(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hXmfK", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return EffectScope; });
$parcel$export(module.exports, "effectScope", function () { return effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return onScopeDispose; });
$parcel$export(module.exports, "ReactiveEffect", function () { return ReactiveEffect; });
$parcel$export(module.exports, "pauseTracking", function () { return pauseTracking; });
$parcel$export(module.exports, "resetTracking", function () { return resetTracking; });
$parcel$export(module.exports, "track", function () { return track; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "toRaw", function () { return toRaw; });
$parcel$export(module.exports, "isShallow", function () { return isShallow; });
$parcel$export(module.exports, "toReactive", function () { return toReactive; });
$parcel$export(module.exports, "shallowReadArray", function () { return shallowReadArray; });
$parcel$export(module.exports, "isProxy", function () { return isProxy; });
$parcel$export(module.exports, "isRef", function () { return isRef; });
$parcel$export(module.exports, "readonly", function () { return readonly; });
$parcel$export(module.exports, "reactive", function () { return reactive; });
$parcel$export(module.exports, "isReadonly", function () { return isReadonly; });
$parcel$export(module.exports, "toReadonly", function () { return toReadonly; });
$parcel$export(module.exports, "shallowReactive", function () { return shallowReactive; });
$parcel$export(module.exports, "isReactive", function () { return isReactive; });
$parcel$export(module.exports, "markRaw", function () { return markRaw; });
$parcel$export(module.exports, "ref", function () { return ref; });
$parcel$export(module.exports, "shallowRef", function () { return shallowRef; });
$parcel$export(module.exports, "unref", function () { return unref; });
$parcel$export(module.exports, "toValue", function () { return toValue; });
$parcel$export(module.exports, "proxyRefs", function () { return proxyRefs; });
$parcel$export(module.exports, "customRef", function () { return customRef; });
$parcel$export(module.exports, "toRefs", function () { return toRefs; });
$parcel$export(module.exports, "toRef", function () { return toRef; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "watch", function () { return watch; });
$parcel$export(module.exports, "traverse", function () { return traverse; });
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $d8jBh = parcelRequire("d8jBh");
function warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $7WNf6._)(args)));
}
var activeEffectScope;
var EffectScope = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $jGAMp._)(this, EffectScope);
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    (0, $byiyg._)(EffectScope, [
        {
            key: "active",
            get: function get() {
                return this._active;
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._active) {
                    this._isPaused = true;
                    var i, l;
                    if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
                }
            }
        },
        {
            /**
   * Resumes the effect scope, including all child scopes and effects.
   */ key: "resume",
            value: function resume() {
                if (this._active) {
                    if (this._isPaused) {
                        this._isPaused = false;
                        var i, l;
                        if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                        for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
                    }
                }
            }
        },
        {
            key: "run",
            value: function run(fn) {
                if (this._active) {
                    var currentEffectScope = activeEffectScope;
                    try {
                        activeEffectScope = this;
                        return fn();
                    } finally{
                        activeEffectScope = currentEffectScope;
                    }
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "on",
            value: function on() {
                if (++this._on === 1) {
                    this.prevScope = activeEffectScope;
                    activeEffectScope = this;
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "off",
            value: function off() {
                if (this._on > 0 && --this._on === 0) {
                    activeEffectScope = this.prevScope;
                    this.prevScope = void 0;
                }
            }
        },
        {
            key: "stop",
            value: function stop(fromParent) {
                if (this._active) {
                    this._active = false;
                    var i, l;
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
                    this.effects.length = 0;
                    for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
                    this.cleanups.length = 0;
                    if (this.scopes) {
                        for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                        this.scopes.length = 0;
                    }
                    if (!this.detached && this.parent && !fromParent) {
                        var last = this.parent.scopes.pop();
                        if (last && last !== this) {
                            this.parent.scopes[this.index] = last;
                            last.index = this.index;
                        }
                    }
                    this.parent = void 0;
                }
            }
        }
    ]);
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
var activeSub;
var EffectFlags = {
    ACTIVE: 1,
    "1": "ACTIVE",
    RUNNING: 2,
    "2": "RUNNING",
    TRACKING: 4,
    "4": "TRACKING",
    NOTIFIED: 8,
    "8": "NOTIFIED",
    DIRTY: 16,
    "16": "DIRTY",
    ALLOW_RECURSE: 32,
    "32": "ALLOW_RECURSE",
    PAUSED: 64,
    "64": "PAUSED",
    EVALUATED: 128,
    "128": "EVALUATED"
};
var pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var ReactiveEffect = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn) {
        (0, $jGAMp._)(this, ReactiveEffect);
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope && activeEffectScope.active) activeEffectScope.effects.push(this);
    }
    (0, $byiyg._)(ReactiveEffect, [
        {
            key: "pause",
            value: function pause() {
                this.flags |= 64;
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.flags & 64) {
                    this.flags &= -65;
                    if (pausedQueueEffects.has(this)) {
                        pausedQueueEffects["delete"](this);
                        this.trigger();
                    }
                }
            }
        },
        {
            /**
   * @internal
   */ key: "notify",
            value: function notify() {
                if (this.flags & 2 && !(this.flags & 32)) return;
                if (!(this.flags & 8)) batch(this);
            }
        },
        {
            key: "run",
            value: function run() {
                if (!(this.flags & 1)) return this.fn();
                this.flags |= 2;
                cleanupEffect(this);
                prepareDeps(this);
                var prevEffect = activeSub;
                var prevShouldTrack = shouldTrack;
                activeSub = this;
                shouldTrack = true;
                try {
                    return this.fn();
                } finally{
                    cleanupDeps(this);
                    activeSub = prevEffect;
                    shouldTrack = prevShouldTrack;
                    this.flags &= -3;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.flags & 1) {
                    for(var link = this.deps; link; link = link.nextDep)removeSub(link);
                    this.deps = this.depsTail = void 0;
                    cleanupEffect(this);
                    this.onStop && this.onStop();
                    this.flags &= -2;
                }
            }
        },
        {
            key: "trigger",
            value: function trigger() {
                if (this.flags & 64) pausedQueueEffects.add(this);
                else if (this.scheduler) this.scheduler();
                else this.runIfDirty();
            }
        },
        {
            /**
   * @internal
   */ key: "runIfDirty",
            value: function runIfDirty() {
                if (isDirty(this)) this.run();
            }
        },
        {
            key: "dirty",
            get: function get() {
                return isDirty(this);
            }
        }
    ]);
    return ReactiveEffect;
}();
var batchDepth = 0;
var batchedSub;
var batchedComputed;
function batch(sub) {
    var isComputed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    sub.flags |= 8;
    if (isComputed) {
        sub.next = batchedComputed;
        batchedComputed = sub;
        return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
}
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    if (batchedComputed) {
        var e = batchedComputed;
        batchedComputed = void 0;
        while(e){
            var next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    var error;
    while(batchedSub){
        var e1 = batchedSub;
        batchedSub = void 0;
        while(e1){
            var next1 = e1.next;
            e1.next = void 0;
            e1.flags &= -9;
            if (e1.flags & 1) try {
                e1.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e1 = next1;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(var link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    var head;
    var tail = sub.depsTail;
    var link = tail;
    while(link){
        var prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(var link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !isDirty(computed))) return;
    computed.flags |= 2;
    var dep = computed.dep;
    var prevSub = activeSub;
    var prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        var value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $d8jBh.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link) {
    var soft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var dep = link.dep, prevSub = link.prevSub, nextSub = link.nextSub;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(var l = dep.computed.deps; l; l = l.nextDep)removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map["delete"](dep.key);
}
function removeDep(link) {
    var prevDep = link.prevDep, nextDep = link.nextDep;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    var e = new ReactiveEffect(fn);
    if (options) (0, $d8jBh.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    var runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    var last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    var cleanup = e.cleanup;
    e.cleanup = void 0;
    if (cleanup) {
        var prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
var globalVersion = 0;
var Link = function Link(sub, dep) {
    "use strict";
    (0, $jGAMp._)(this, Link);
    this.sub = sub;
    this.dep = dep;
    this.version = dep.version;
    this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
};
var Dep = /*#__PURE__*/ function() {
    "use strict";
    function Dep(computed) {
        (0, $jGAMp._)(this, Dep);
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    (0, $byiyg._)(Dep, [
        {
            key: "track",
            value: function track(debugInfo) {
                if (!activeSub || !shouldTrack || activeSub === this.computed) return;
                var link = this.activeLink;
                if (link === void 0 || link.sub !== activeSub) {
                    link = this.activeLink = new Link(activeSub, this);
                    if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
                    else {
                        link.prevDep = activeSub.depsTail;
                        activeSub.depsTail.nextDep = link;
                        activeSub.depsTail = link;
                    }
                    addSub(link);
                } else if (link.version === -1) {
                    link.version = this.version;
                    if (link.nextDep) {
                        var next = link.nextDep;
                        next.prevDep = link.prevDep;
                        if (link.prevDep) link.prevDep.nextDep = next;
                        link.prevDep = activeSub.depsTail;
                        link.nextDep = void 0;
                        activeSub.depsTail.nextDep = link;
                        activeSub.depsTail = link;
                        if (activeSub.deps === link) activeSub.deps = next;
                    }
                }
                return link;
            }
        },
        {
            key: "trigger",
            value: function trigger(debugInfo) {
                this.version++;
                globalVersion++;
                this.notify(debugInfo);
            }
        },
        {
            key: "notify",
            value: function notify(debugInfo) {
                startBatch();
                try {
                    for(var link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
                } finally{
                    endBatch();
                }
            }
        }
    ]);
    return Dep;
}();
function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        var computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(var l = computed.deps; l; l = l.nextDep)addSub(l);
        }
        var currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
var targetMap = /* @__PURE__ */ new WeakMap();
var ITERATE_KEY = Symbol("");
var MAP_KEY_ITERATE_KEY = Symbol("");
var ARRAY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        var depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        var dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    var run = function(dep) {
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        var targetIsArray = (0, $d8jBh.isArray)(target);
        var isArrayIndex = targetIsArray && (0, $d8jBh.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            var newLength = Number(newValue);
            depsMap.forEach(function(dep, key2) {
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, $d8jBh.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, $d8jBh.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, $d8jBh.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, $d8jBh.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    var depMap = targetMap.get(object);
    return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
    var raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
var _obj;
var arrayInstrumentations = (_obj = {
    __proto__: null
}, (0, $cqEAj._)(_obj, Symbol.iterator, function() {
    return iterator(this, Symbol.iterator, toReactive);
}), (0, $cqEAj._)(_obj, "concat", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = reactiveReadArray(this)).concat.apply(_reactiveReadArray, (0, $7WNf6._)(args.map(function(x) {
        return (0, $d8jBh.isArray)(x) ? reactiveReadArray(x) : x;
    })));
}), (0, $cqEAj._)(_obj, "entries", function() {
    return iterator(this, "entries", function(value) {
        value[1] = toReactive(value[1]);
        return value;
    });
}), (0, $cqEAj._)(_obj, "every", function(fn, thisArg) {
    return apply(this, "every", fn, thisArg, void 0, arguments);
}), (0, $cqEAj._)(_obj, "filter", function(fn, thisArg) {
    return apply(this, "filter", fn, thisArg, function(v) {
        return v.map(toReactive);
    }, arguments);
}), (0, $cqEAj._)(_obj, "find", function(fn, thisArg) {
    return apply(this, "find", fn, thisArg, toReactive, arguments);
}), (0, $cqEAj._)(_obj, "findIndex", function(fn, thisArg) {
    return apply(this, "findIndex", fn, thisArg, void 0, arguments);
}), (0, $cqEAj._)(_obj, "findLast", function(fn, thisArg) {
    return apply(this, "findLast", fn, thisArg, toReactive, arguments);
}), (0, $cqEAj._)(_obj, "findLastIndex", function(fn, thisArg) {
    return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
}), // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
(0, $cqEAj._)(_obj, "forEach", function(fn, thisArg) {
    return apply(this, "forEach", fn, thisArg, void 0, arguments);
}), (0, $cqEAj._)(_obj, "includes", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "includes", args);
}), (0, $cqEAj._)(_obj, "indexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "indexOf", args);
}), (0, $cqEAj._)(_obj, "join", function(separator) {
    return reactiveReadArray(this).join(separator);
}), // keys() iterator only reads `length`, no optimisation required
(0, $cqEAj._)(_obj, "lastIndexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "lastIndexOf", args);
}), (0, $cqEAj._)(_obj, "map", function(fn, thisArg) {
    return apply(this, "map", fn, thisArg, void 0, arguments);
}), (0, $cqEAj._)(_obj, "pop", function() {
    return noTracking(this, "pop");
}), (0, $cqEAj._)(_obj, "push", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "push", args);
}), (0, $cqEAj._)(_obj, "reduce", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return reduce(this, "reduce", fn, args);
}), (0, $cqEAj._)(_obj, "reduceRight", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return reduce(this, "reduceRight", fn, args);
}), (0, $cqEAj._)(_obj, "shift", function() {
    return noTracking(this, "shift");
}), // slice could use ARRAY_ITERATE but also seems to beg for range tracking
(0, $cqEAj._)(_obj, "some", function(fn, thisArg) {
    return apply(this, "some", fn, thisArg, void 0, arguments);
}), (0, $cqEAj._)(_obj, "splice", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "splice", args);
}), (0, $cqEAj._)(_obj, "toReversed", function() {
    return reactiveReadArray(this).toReversed();
}), (0, $cqEAj._)(_obj, "toSorted", function(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
}), (0, $cqEAj._)(_obj, "toSpliced", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = reactiveReadArray(this)).toSpliced.apply(_reactiveReadArray, (0, $7WNf6._)(args));
}), (0, $cqEAj._)(_obj, "unshift", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "unshift", args);
}), (0, $cqEAj._)(_obj, "values", function() {
    return iterator(this, "values", toReactive);
}), _obj);
function iterator(self, method, wrapValue) {
    var arr = shallowReadArray(self);
    var iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = function() {
            var result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    var arr = shallowReadArray(self);
    var needsWrap = arr !== self && !isShallow(self);
    var methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        var result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    var wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, toReactive(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    var result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    var _arr;
    var arr = shallowReadArray(self);
    var wrappedFn = fn;
    if (arr !== self) {
        if (!isShallow(self)) wrappedFn = function wrappedFn(acc, item, index) {
            return fn.call(this, acc, toReactive(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function wrappedFn(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return (_arr = arr)[method].apply(_arr, [
        wrappedFn
    ].concat((0, $7WNf6._)(args)));
}
function searchProxy(self, method, args) {
    var _arr;
    var arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    var res = (_arr = arr)[method].apply(_arr, (0, $7WNf6._)(args));
    if ((res === -1 || res === false) && isProxy(args[0])) {
        var _arr1;
        args[0] = toRaw(args[0]);
        return (_arr1 = arr)[method].apply(_arr1, (0, $7WNf6._)(args));
    }
    return res;
}
function noTracking(self, method) {
    var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    pauseTracking();
    startBatch();
    var res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
var isNonTrackableKeys = /* @__PURE__ */ (0, $d8jBh.makeMap)("__proto__,__v_isRef,__isVue");
var builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter(function(key) {
    return key !== "arguments" && key !== "caller";
}).map(function(key) {
    return Symbol[key];
}).filter((0, $d8jBh.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, $d8jBh.isSymbol)(key)) key = String(key);
    var obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var BaseReactiveHandler = /*#__PURE__*/ function() {
    "use strict";
    function BaseReactiveHandler() {
        var _isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, _isShallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $jGAMp._)(this, BaseReactiveHandler);
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    (0, $byiyg._)(BaseReactiveHandler, [
        {
            key: "get",
            value: function get(target, key, receiver) {
                if (key === "__v_skip") return target["__v_skip"];
                var isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
                if (key === "__v_isReactive") return !isReadonly2;
                else if (key === "__v_isReadonly") return isReadonly2;
                else if (key === "__v_isShallow") return isShallow2;
                else if (key === "__v_raw") {
                    if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
                    // this means the receiver is a user proxy of the reactive proxy
                    Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
                    return;
                }
                var targetIsArray = (0, $d8jBh.isArray)(target);
                if (!isReadonly2) {
                    var fn;
                    if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
                    if (key === "hasOwnProperty") return hasOwnProperty;
                }
                var res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
                // as receiver so that we don't have to call `toRaw` on the ref in all
                // its class methods
                isRef(target) ? target : receiver);
                if ((0, $d8jBh.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
                if (!isReadonly2) track(target, "get", key);
                if (isShallow2) return res;
                if (isRef(res)) return targetIsArray && (0, $d8jBh.isIntegerKey)(key) ? res : res.value;
                if ((0, $d8jBh.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
                return res;
            }
        }
    ]);
    return BaseReactiveHandler;
}();
var MutableReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $i3fW3._)(MutableReactiveHandler, BaseReactiveHandler);
    function MutableReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $jGAMp._)(this, MutableReactiveHandler);
        return (0, $kzDuW._)(this, MutableReactiveHandler, [
            false,
            isShallow2
        ]);
    }
    (0, $byiyg._)(MutableReactiveHandler, [
        {
            key: "set",
            value: function set(target, key, value, receiver) {
                var oldValue = target[key];
                if (!this._isShallow) {
                    var isOldValueReadonly = isReadonly(oldValue);
                    if (!isShallow(value) && !isReadonly(value)) {
                        oldValue = toRaw(oldValue);
                        value = toRaw(value);
                    }
                    if (!(0, $d8jBh.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                        if (isOldValueReadonly) return false;
                        else {
                            oldValue.value = value;
                            return true;
                        }
                    }
                }
                var hadKey = (0, $d8jBh.isArray)(target) && (0, $d8jBh.isIntegerKey)(key) ? Number(key) < target.length : (0, $d8jBh.hasOwn)(target, key);
                var result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
                if (target === toRaw(receiver)) {
                    if (!hadKey) trigger(target, "add", key, value);
                    else if ((0, $d8jBh.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
                }
                return result;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                var hadKey = (0, $d8jBh.hasOwn)(target, key);
                var oldValue = target[key];
                var result = Reflect.deleteProperty(target, key);
                if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
                return result;
            }
        },
        {
            key: "has",
            value: function has(target, key) {
                var result = Reflect.has(target, key);
                if (!(0, $d8jBh.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
                return result;
            }
        },
        {
            key: "ownKeys",
            value: function ownKeys(target) {
                track(target, "iterate", (0, $d8jBh.isArray)(target) ? "length" : ITERATE_KEY);
                return Reflect.ownKeys(target);
            }
        }
    ]);
    return MutableReactiveHandler;
}(BaseReactiveHandler);
var ReadonlyReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $i3fW3._)(ReadonlyReactiveHandler, BaseReactiveHandler);
    function ReadonlyReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $jGAMp._)(this, ReadonlyReactiveHandler);
        return (0, $kzDuW._)(this, ReadonlyReactiveHandler, [
            true,
            isShallow2
        ]);
    }
    (0, $byiyg._)(ReadonlyReactiveHandler, [
        {
            key: "set",
            value: function set(target, key) {
                return true;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                return true;
            }
        }
    ]);
    return ReadonlyReactiveHandler;
}(BaseReactiveHandler);
var mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
var readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
var shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
var shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
var toShallow = function(value) {
    return value;
};
var getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = toRaw(target);
        var targetIsMap = (0, $d8jBh.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $7WNf6._)(args));
        var wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return(// iterable protocol
        (0, $cqEAj._)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations(readonly, shallow) {
    var instrumentations = {
        get: function(key) {
            var target = this["__v_raw"];
            var rawTarget = toRaw(target);
            var rawKey = toRaw(key);
            if (!readonly) {
                if ((0, $d8jBh.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
                track(rawTarget, "get", rawKey);
            }
            var has = getProto(rawTarget).has;
            var wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            var target = this["__v_raw"];
            !readonly && track(toRaw(target), "iterate", ITERATE_KEY);
            return Reflect.get(target, "size", target);
        },
        has: function(key) {
            var target = this["__v_raw"];
            var rawTarget = toRaw(target);
            var rawKey = toRaw(key);
            if (!readonly) {
                if ((0, $d8jBh.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
                track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach: function(callback, thisArg) {
            var observed = this;
            var target = observed["__v_raw"];
            var rawTarget = toRaw(target);
            var wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            !readonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach(function(value, key) {
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $d8jBh.extend)(instrumentations, readonly ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        "delete": createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
    } : {
        add: function(value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            var target = toRaw(this);
            var proto = getProto(target);
            var hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                trigger(target, "add", value, value);
            }
            return this;
        },
        set: function(key, value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            var target = toRaw(this);
            var _getProto = getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, $d8jBh.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
            return this;
        },
        "delete": function(key) {
            var target = toRaw(this);
            var _getProto = getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get ? get.call(target, key) : void 0;
            var result = target["delete"](key);
            if (hadKey) trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear: function() {
            var target = toRaw(this);
            var hadItems = target.size !== 0;
            var oldTarget = void 0;
            var result = target.clear();
            if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        instrumentations[method] = createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
    var instrumentations = createInstrumentations(isReadonly2, shallow);
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $d8jBh.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
var shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
var readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
var shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    var rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        var type = (0, $d8jBh.toRawType)(target);
        warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, $d8jBh.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $d8jBh.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    var targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, $d8jBh.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $d8jBh.def)(value, "__v_skip", true);
    return value;
}
var toReactive = function(value) {
    return (0, $d8jBh.isObject)(value) ? reactive(value) : value;
};
var toReadonly = function(value) {
    return (0, $d8jBh.isObject)(value) ? readonly(value) : value;
};
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
var RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, isShallow2) {
        (0, $jGAMp._)(this, RefImpl);
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    (0, $byiyg._)(RefImpl, [
        {
            key: "value",
            get: function get() {
                this.dep.track();
                return this._value;
            },
            set: function set(newValue) {
                var oldValue = this._rawValue;
                var useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
                newValue = useDirectValue ? newValue : toRaw(newValue);
                if ((0, $d8jBh.hasChanged)(newValue, oldValue)) {
                    this._rawValue = newValue;
                    this._value = useDirectValue ? newValue : toReactive(newValue);
                    this.dep.trigger();
                }
            }
        }
    ]);
    return RefImpl;
}();
function triggerRef(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, $d8jBh.isFunction)(source) ? source() : unref(source);
}
var shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
var CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        (0, $jGAMp._)(this, CustomRefImpl);
        this["__v_isRef"] = true;
        this._value = void 0;
        var dep = this.dep = new Dep();
        var _factory = factory(dep.track.bind(dep), dep.trigger.bind(dep)), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $byiyg._)(CustomRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._value = this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    var ret = (0, $d8jBh.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
var ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, _key, _defaultValue) {
        (0, $jGAMp._)(this, ObjectRefImpl);
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    (0, $byiyg._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                var val = this._object[this._key];
                return this._value = val === void 0 ? this._defaultValue : val;
            },
            set: function set(newVal) {
                this._object[this._key] = newVal;
            }
        },
        {
            key: "dep",
            get: function get() {
                return getDepFromReactive(toRaw(this._object), this._key);
            }
        }
    ]);
    return ObjectRefImpl;
}();
var GetterRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function GetterRefImpl(_getter) {
        (0, $jGAMp._)(this, GetterRefImpl);
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    (0, $byiyg._)(GetterRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._value = this._getter();
            }
        }
    ]);
    return GetterRefImpl;
}();
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, $d8jBh.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, $d8jBh.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    var val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
var ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(fn, setter, isSSR) {
        (0, $jGAMp._)(this, ComputedRefImpl);
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    (0, $byiyg._)(ComputedRefImpl, [
        {
            /**
   * @internal
   */ key: "notify",
            value: function notify() {
                this.flags |= 16;
                if (!(this.flags & 8) && // avoid infinite self recursion
                activeSub !== this) {
                    batch(this, true);
                    return true;
                }
            }
        },
        {
            key: "value",
            get: function get() {
                var link = this.dep.track();
                refreshComputed(this);
                if (link) link.version = this.dep.version;
                return this._value;
            },
            set: function set(newValue) {
                if (this.setter) this.setter(newValue);
            }
        }
    ]);
    return ComputedRefImpl;
}();
function computed(getterOrOptions, debugOptions) {
    var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var getter;
    var setter;
    if ((0, $d8jBh.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
var TrackOpTypes = {
    GET: "get",
    HAS: "has",
    ITERATE: "iterate"
};
var TriggerOpTypes = {
    SET: "set",
    ADD: "add",
    DELETE: "delete",
    CLEAR: "clear"
};
var ReactiveFlags = {
    SKIP: "__v_skip",
    IS_REACTIVE: "__v_isReactive",
    IS_READONLY: "__v_isReadonly",
    IS_SHALLOW: "__v_isShallow",
    RAW: "__v_raw",
    IS_REF: "__v_isRef"
};
var WatchErrorCodes = {
    WATCH_GETTER: 2,
    "2": "WATCH_GETTER",
    WATCH_CALLBACK: 3,
    "3": "WATCH_CALLBACK",
    WATCH_CLEANUP: 4,
    "4": "WATCH_CLEANUP"
};
var INITIAL_WATCHER_VALUE = {};
var cleanupMap = /* @__PURE__ */ new WeakMap();
var activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, owner = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : activeWatcher;
    if (owner) {
        var cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $d8jBh.EMPTY_OBJ);
    var immediate = options.immediate, deep = options.deep, once = options.once, scheduler = options.scheduler, augmentJob = options.augmentJob, call = options.call;
    var warnInvalidSource = function(s) {
        (options.onWarn || warn)("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
    };
    var reactiveGetter = function(source2) {
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    var effect;
    var getter;
    var cleanup;
    var boundCleanup;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = function() {
            return reactiveGetter(source);
        };
        forceTrigger = true;
    } else if ((0, $d8jBh.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function(s) {
            return isReactive(s) || isShallow(s);
        });
        getter = function() {
            return source.map(function(s) {
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, $d8jBh.isFunction)(s)) return call ? call(s, 2) : s();
            });
        };
    } else if ((0, $d8jBh.isFunction)(source)) {
        if (cb) getter = call ? function() {
            return call(source, 2);
        } : source;
        else getter = function() {
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            var currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $d8jBh.NOOP);
    if (cb && deep) {
        var baseGetter = getter;
        var depth = deep === true ? Infinity : deep;
        getter = function() {
            return traverse(baseGetter(), depth);
        };
    }
    var scope = getCurrentScope();
    var watchHandle = function() {
        effect.stop();
        if (scope && scope.active) (0, $d8jBh.remove)(scope.effects, effect);
    };
    if (once && cb) {
        var _cb = cb;
        cb = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            _cb.apply(void 0, (0, $7WNf6._)(args));
            watchHandle();
        };
    }
    var oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    var job = function(immediateFirstRun) {
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v, i) {
                return (0, $d8jBh.hasChanged)(v, oldValue[i]);
            }) : (0, $d8jBh.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                var currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    var args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb.apply(void 0, (0, $7WNf6._)(args));
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? function() {
        return scheduler(job, false);
    } : job;
    boundCleanup = function(fn) {
        return onWatcherCleanup(fn, false, effect);
    };
    cleanup = effect.onStop = function() {
        var cleanups = cleanupMap.get(effect);
        if (cleanups) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (call) call(cleanups, 4);
            else try {
                for(var _iterator = cleanups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cleanup2 = _step.value;
                    cleanup2();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            cleanupMap["delete"](effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity, seen = arguments.length > 2 ? arguments[2] : void 0;
    if (depth <= 0 || !(0, $d8jBh.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, $d8jBh.isArray)(value)) for(var i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, $d8jBh.isSet)(value) || (0, $d8jBh.isMap)(value)) value.forEach(function(v) {
        traverse(v, depth, seen);
    });
    else if ((0, $d8jBh.isPlainObject)(value)) {
        for(var key in value)traverse(value[key], depth, seen);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.getOwnPropertySymbols(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key1 = _step.value;
                if (Object.prototype.propertyIsEnumerable.call(value, key1)) traverse(value[key1], depth, seen);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}

});
parcelRegister("kzDuW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efa5b70553d6d74e$export$71511d61b312f219; });

var $hxFDX = parcelRequire("hxFDX");

var $4J9eQ = parcelRequire("4J9eQ");

var $foTGJ = parcelRequire("foTGJ");
function $efa5b70553d6d74e$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $hxFDX._)(derived);
    return (0, $foTGJ._)(_this, (0, $4J9eQ._)() ? Reflect.construct(derived, args || [], (0, $hxFDX._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("hxFDX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc55d2432e23b42d$export$71511d61b312f219; });
function $cc55d2432e23b42d$export$71511d61b312f219(o) {
    $cc55d2432e23b42d$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cc55d2432e23b42d$export$71511d61b312f219(o);
}

});

parcelRegister("4J9eQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $371287f736f95631$export$71511d61b312f219; });
function $371287f736f95631$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($371287f736f95631$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("foTGJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b3644b6ffe489ca4$export$71511d61b312f219; });

var $hMpIh = parcelRequire("hMpIh");

var $3KZcf = parcelRequire("3KZcf");
function $b3644b6ffe489ca4$export$71511d61b312f219(self, call) {
    if (call && ((0, $3KZcf._)(call) === "object" || typeof call === "function")) return call;
    return (0, $hMpIh._)(self);
}

});
parcelRegister("hMpIh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0357249ab7061e71$export$71511d61b312f219; });
function $0357249ab7061e71$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("3KZcf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2bc52351e266baa9$export$71511d61b312f219; });
function $2bc52351e266baa9$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("jGAMp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e54e784522bae5ae$export$71511d61b312f219; });
function $e54e784522bae5ae$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("byiyg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $869142a24bca4d94$export$71511d61b312f219; });
function $869142a24bca4d94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $869142a24bca4d94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $869142a24bca4d94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $869142a24bca4d94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cqEAj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $90c7650330831190$export$71511d61b312f219; });
function $90c7650330831190$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("i3fW3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d244de3743038f60$export$71511d61b312f219; });

var $4zEQz = parcelRequire("4zEQz");
function $d244de3743038f60$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $4zEQz._)(subClass, superClass);
}

});
parcelRegister("4zEQz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $354a1da3b4aaffc0$export$71511d61b312f219; });
function $354a1da3b4aaffc0$export$71511d61b312f219(o, p) {
    $354a1da3b4aaffc0$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $354a1da3b4aaffc0$export$71511d61b312f219(o, p);
}

});


parcelRegister("7WNf6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5c9425c1b8ceb95e$export$71511d61b312f219; });

var $fdFGv = parcelRequire("fdFGv");

var $hpMnK = parcelRequire("hpMnK");

var $kFjpM = parcelRequire("kFjpM");

var $lG3Im = parcelRequire("lG3Im");
function $5c9425c1b8ceb95e$export$71511d61b312f219(arr) {
    return (0, $fdFGv._)(arr) || (0, $hpMnK._)(arr) || (0, $lG3Im._)(arr) || (0, $kFjpM._)();
}

});
parcelRegister("fdFGv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b148679c82108ea9$export$71511d61b312f219; });

var $bssdx = parcelRequire("bssdx");
function $b148679c82108ea9$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $bssdx._)(arr);
}

});
parcelRegister("bssdx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8578329851e9ce62$export$71511d61b312f219; });
function $8578329851e9ce62$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("hpMnK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cada4d22dd4638de$export$71511d61b312f219; });
function $cada4d22dd4638de$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("kFjpM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f0b6b2604b8b1159$export$71511d61b312f219; });
function $f0b6b2604b8b1159$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lG3Im", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fc8066d40eae2e0d$export$71511d61b312f219; });

var $bssdx = parcelRequire("bssdx");
function $fc8066d40eae2e0d$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $bssdx._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $bssdx._)(o, minLen);
}

});


parcelRegister("d8jBh", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $98fb39eb14e7dc25$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $98fb39eb14e7dc25$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $98fb39eb14e7dc25$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $98fb39eb14e7dc25$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $98fb39eb14e7dc25$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $98fb39eb14e7dc25$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $98fb39eb14e7dc25$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $98fb39eb14e7dc25$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $98fb39eb14e7dc25$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $98fb39eb14e7dc25$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $98fb39eb14e7dc25$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $98fb39eb14e7dc25$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $98fb39eb14e7dc25$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $98fb39eb14e7dc25$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $98fb39eb14e7dc25$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $98fb39eb14e7dc25$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $98fb39eb14e7dc25$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $98fb39eb14e7dc25$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $98fb39eb14e7dc25$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $98fb39eb14e7dc25$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $98fb39eb14e7dc25$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $98fb39eb14e7dc25$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $98fb39eb14e7dc25$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $98fb39eb14e7dc25$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $98fb39eb14e7dc25$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $98fb39eb14e7dc25$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $98fb39eb14e7dc25$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $98fb39eb14e7dc25$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $98fb39eb14e7dc25$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $98fb39eb14e7dc25$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $98fb39eb14e7dc25$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $98fb39eb14e7dc25$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $98fb39eb14e7dc25$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $98fb39eb14e7dc25$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $98fb39eb14e7dc25$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $98fb39eb14e7dc25$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $98fb39eb14e7dc25$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $98fb39eb14e7dc25$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $98fb39eb14e7dc25$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $98fb39eb14e7dc25$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $98fb39eb14e7dc25$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $98fb39eb14e7dc25$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $98fb39eb14e7dc25$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $98fb39eb14e7dc25$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $98fb39eb14e7dc25$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $98fb39eb14e7dc25$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $98fb39eb14e7dc25$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $98fb39eb14e7dc25$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $98fb39eb14e7dc25$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $98fb39eb14e7dc25$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $98fb39eb14e7dc25$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $98fb39eb14e7dc25$export$b5b1545233b45293; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $98fb39eb14e7dc25$export$97fe3d6453ee2f5e; });
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__

var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
function $98fb39eb14e7dc25$export$b41394a5437791c8(str) {
    var map = /* @__PURE__ */ Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            map[key] = 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function(val) {
        return val in map;
    };
}
var $98fb39eb14e7dc25$export$cf583d23ab39677c = {};
var $98fb39eb14e7dc25$export$6bd8558f433f1cc1 = [];
var $98fb39eb14e7dc25$export$5702a91a6f42969f = function() {};
var $98fb39eb14e7dc25$export$c01351c0af048e39 = function() {
    return false;
};
var $98fb39eb14e7dc25$export$1a2d97de39ecbb75 = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
};
var $98fb39eb14e7dc25$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $98fb39eb14e7dc25$export$8b58be045bf06082 = Object.assign;
var $98fb39eb14e7dc25$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $98fb39eb14e7dc25$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $98fb39eb14e7dc25$export$b5a638e9b3fff9f3 = function(val, key) {
    return $98fb39eb14e7dc25$var$hasOwnProperty.call(val, key);
};
var $98fb39eb14e7dc25$export$43bee75e5e14138e = Array.isArray;
var $98fb39eb14e7dc25$export$5c90113a285f2241 = function(val) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(val) === "[object Map]";
};
var $98fb39eb14e7dc25$export$6750766a7c7ec627 = function(val) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(val) === "[object Set]";
};
var $98fb39eb14e7dc25$export$871608497c498473 = function(val) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(val) === "[object Date]";
};
var $98fb39eb14e7dc25$export$49841c62b9eff15 = function(val) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $98fb39eb14e7dc25$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $98fb39eb14e7dc25$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $98fb39eb14e7dc25$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $3KZcf._)(val)) === "symbol";
};
var $98fb39eb14e7dc25$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $3KZcf._)(val)) === "object";
};
var $98fb39eb14e7dc25$export$4369c812aac99591 = function(val) {
    return ($98fb39eb14e7dc25$export$a6cdc56e425d0d0a(val) || $98fb39eb14e7dc25$export$f6e2535fb5126e54(val)) && $98fb39eb14e7dc25$export$f6e2535fb5126e54(val.then) && $98fb39eb14e7dc25$export$f6e2535fb5126e54(val["catch"]);
};
var $98fb39eb14e7dc25$export$830c053460e5ddf6 = Object.prototype.toString;
var $98fb39eb14e7dc25$export$1dccc787cc36538b = function(value) {
    return $98fb39eb14e7dc25$export$830c053460e5ddf6.call(value);
};
var $98fb39eb14e7dc25$export$5ad0a3c360b8fbb5 = function(value) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(value).slice(8, -1);
};
var $98fb39eb14e7dc25$export$53b83ca8eaab0383 = function(val) {
    return $98fb39eb14e7dc25$export$1dccc787cc36538b(val) === "[object Object]";
};
var $98fb39eb14e7dc25$export$e2a2b93446ec9fe = function(key) {
    return $98fb39eb14e7dc25$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $98fb39eb14e7dc25$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $98fb39eb14e7dc25$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
var $98fb39eb14e7dc25$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $98fb39eb14e7dc25$var$camelizeRE = /-(\w)/g;
var $98fb39eb14e7dc25$export$161d051f5dd25de7 = $98fb39eb14e7dc25$var$cacheStringFunction(function(str) {
    return str.replace($98fb39eb14e7dc25$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $98fb39eb14e7dc25$var$hyphenateRE = /\B([A-Z])/g;
var $98fb39eb14e7dc25$export$6e6a0a3676c4b8bb = $98fb39eb14e7dc25$var$cacheStringFunction(function(str) {
    return str.replace($98fb39eb14e7dc25$var$hyphenateRE, "-$1").toLowerCase();
});
var $98fb39eb14e7dc25$export$9a00dee1beb8f576 = $98fb39eb14e7dc25$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $98fb39eb14e7dc25$export$8c022799eeaaefcd = $98fb39eb14e7dc25$var$cacheStringFunction(function(str) {
    var s = str ? "on".concat($98fb39eb14e7dc25$export$9a00dee1beb8f576(str)) : "";
    return s;
});
var $98fb39eb14e7dc25$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $98fb39eb14e7dc25$export$39951422d618a9d3 = function(fns) {
    for(var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        arg[_key - 1] = arguments[_key];
    }
    var _fns;
    for(var i = 0; i < fns.length; i++)(_fns = fns)[i].apply(_fns, (0, $7WNf6._)(arg));
};
var $98fb39eb14e7dc25$export$8afb76124cf08683 = function(obj, key, value) {
    var writable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
var $98fb39eb14e7dc25$export$d3be7195bcc2f31b = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
var $98fb39eb14e7dc25$export$a0a81dc3380ce7d3 = function(val) {
    var n = $98fb39eb14e7dc25$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
var $98fb39eb14e7dc25$var$_globalThis;
var $98fb39eb14e7dc25$export$ff5f2eeb11fc7e14 = function() {
    return $98fb39eb14e7dc25$var$_globalThis || ($98fb39eb14e7dc25$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
var $98fb39eb14e7dc25$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $98fb39eb14e7dc25$export$53d5e12f9a1d3cde(name) {
    return $98fb39eb14e7dc25$var$identRE.test(name) ? "__props.".concat(name) : "__props[".concat(JSON.stringify(name), "]");
}
function $98fb39eb14e7dc25$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, function(_, val) {
        return typeof val === "function" ? val.toString() : val;
    });
}
var $98fb39eb14e7dc25$export$4bcc674e2ac54ab0 = {
    TEXT: 1,
    "1": "TEXT",
    CLASS: 2,
    "2": "CLASS",
    STYLE: 4,
    "4": "STYLE",
    PROPS: 8,
    "8": "PROPS",
    FULL_PROPS: 16,
    "16": "FULL_PROPS",
    NEED_HYDRATION: 32,
    "32": "NEED_HYDRATION",
    STABLE_FRAGMENT: 64,
    "64": "STABLE_FRAGMENT",
    KEYED_FRAGMENT: 128,
    "128": "KEYED_FRAGMENT",
    UNKEYED_FRAGMENT: 256,
    "256": "UNKEYED_FRAGMENT",
    NEED_PATCH: 512,
    "512": "NEED_PATCH",
    DYNAMIC_SLOTS: 1024,
    "1024": "DYNAMIC_SLOTS",
    DEV_ROOT_FRAGMENT: 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    CACHED: -1,
    "-1": "CACHED",
    BAIL: -2,
    "-2": "BAIL"
};
var $98fb39eb14e7dc25$var$_obj;
var $98fb39eb14e7dc25$export$def7dc2c2e95a08a = ($98fb39eb14e7dc25$var$_obj = {}, (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 1, "TEXT"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 2, "CLASS"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 4, "STYLE"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 8, "PROPS"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 16, "FULL_PROPS"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 32, "NEED_HYDRATION"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 64, "STABLE_FRAGMENT"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 128, "KEYED_FRAGMENT"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 256, "UNKEYED_FRAGMENT"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 512, "NEED_PATCH"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 1024, "DYNAMIC_SLOTS"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, 2048, "DEV_ROOT_FRAGMENT"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, -1, "CACHED"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj, -2, "BAIL"), $98fb39eb14e7dc25$var$_obj);
var $98fb39eb14e7dc25$export$ff27c1ebf2311072 = {
    ELEMENT: 1,
    "1": "ELEMENT",
    FUNCTIONAL_COMPONENT: 2,
    "2": "FUNCTIONAL_COMPONENT",
    STATEFUL_COMPONENT: 4,
    "4": "STATEFUL_COMPONENT",
    TEXT_CHILDREN: 8,
    "8": "TEXT_CHILDREN",
    ARRAY_CHILDREN: 16,
    "16": "ARRAY_CHILDREN",
    SLOTS_CHILDREN: 32,
    "32": "SLOTS_CHILDREN",
    TELEPORT: 64,
    "64": "TELEPORT",
    SUSPENSE: 128,
    "128": "SUSPENSE",
    COMPONENT_SHOULD_KEEP_ALIVE: 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    COMPONENT_KEPT_ALIVE: 512,
    "512": "COMPONENT_KEPT_ALIVE",
    COMPONENT: 6,
    "6": "COMPONENT"
};
var $98fb39eb14e7dc25$export$b1e6fe37bcdef5be = {
    STABLE: 1,
    "1": "STABLE",
    DYNAMIC: 2,
    "2": "DYNAMIC",
    FORWARDED: 3,
    "3": "FORWARDED"
};
var $98fb39eb14e7dc25$var$_obj1;
var $98fb39eb14e7dc25$export$624972196ed3745f = ($98fb39eb14e7dc25$var$_obj1 = {}, (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj1, 1, "STABLE"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj1, 2, "DYNAMIC"), (0, $cqEAj._)($98fb39eb14e7dc25$var$_obj1, 3, "FORWARDED"), $98fb39eb14e7dc25$var$_obj1);
var $98fb39eb14e7dc25$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
var $98fb39eb14e7dc25$export$f73b8c13b7f97ebf = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$GLOBALS_ALLOWED);
var $98fb39eb14e7dc25$export$d6571a1911e4f27e = $98fb39eb14e7dc25$export$f73b8c13b7f97ebf;
var $98fb39eb14e7dc25$var$range = 2;
function $98fb39eb14e7dc25$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    var lines = source.split(/(\r?\n)/);
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $98fb39eb14e7dc25$var$range; j <= i + $98fb39eb14e7dc25$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $98fb39eb14e7dc25$export$8756898546458274(value) {
    if ($98fb39eb14e7dc25$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $98fb39eb14e7dc25$export$844ec244b1367d54(item) ? $98fb39eb14e7dc25$export$76a205ce979d066a(item) : $98fb39eb14e7dc25$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($98fb39eb14e7dc25$export$844ec244b1367d54(value) || $98fb39eb14e7dc25$export$a6cdc56e425d0d0a(value)) return value;
}
var $98fb39eb14e7dc25$var$listDelimiterRE = /;(?![^(]*\))/g;
var $98fb39eb14e7dc25$var$propertyDelimiterRE = /:([^]+)/;
var $98fb39eb14e7dc25$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $98fb39eb14e7dc25$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.replace($98fb39eb14e7dc25$var$styleCommentRE, "").split($98fb39eb14e7dc25$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($98fb39eb14e7dc25$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $98fb39eb14e7dc25$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($98fb39eb14e7dc25$export$844ec244b1367d54(styles)) return styles;
    var ret = "";
    for(var key in styles){
        var value = styles[key];
        if ($98fb39eb14e7dc25$export$844ec244b1367d54(value) || typeof value === "number") {
            var normalizedKey = key.startsWith("--") ? key : $98fb39eb14e7dc25$export$6e6a0a3676c4b8bb(key);
            ret += "".concat(normalizedKey, ":").concat(value, ";");
        }
    }
    return ret;
}
function $98fb39eb14e7dc25$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($98fb39eb14e7dc25$export$844ec244b1367d54(value)) res = value;
    else if ($98fb39eb14e7dc25$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $98fb39eb14e7dc25$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($98fb39eb14e7dc25$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $98fb39eb14e7dc25$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props["class"], style = props.style;
    if (klass && !$98fb39eb14e7dc25$export$844ec244b1367d54(klass)) props["class"] = $98fb39eb14e7dc25$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $98fb39eb14e7dc25$export$8756898546458274(style);
    return props;
}
var $98fb39eb14e7dc25$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
var $98fb39eb14e7dc25$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $98fb39eb14e7dc25$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
var $98fb39eb14e7dc25$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $98fb39eb14e7dc25$export$1ccf854a0984f890 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$HTML_TAGS);
var $98fb39eb14e7dc25$export$6328ce7565ea1049 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$SVG_TAGS);
var $98fb39eb14e7dc25$export$4a46ca4c5be17b20 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$MATH_TAGS);
var $98fb39eb14e7dc25$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$VOID_TAGS);
var $98fb39eb14e7dc25$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $98fb39eb14e7dc25$export$d186f5eb2e810715 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$specialBooleanAttrs);
var $98fb39eb14e7dc25$export$f763ba3b84e9cd8c = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8($98fb39eb14e7dc25$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
function $98fb39eb14e7dc25$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $98fb39eb14e7dc25$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
var $98fb39eb14e7dc25$var$attrValidationCache = {};
function $98fb39eb14e7dc25$export$d55ef77660f30d12(name) {
    if ($98fb39eb14e7dc25$var$attrValidationCache.hasOwnProperty(name)) return $98fb39eb14e7dc25$var$attrValidationCache[name];
    var isUnsafe = $98fb39eb14e7dc25$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $98fb39eb14e7dc25$var$attrValidationCache[name] = !isUnsafe;
}
var $98fb39eb14e7dc25$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
var $98fb39eb14e7dc25$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
var $98fb39eb14e7dc25$export$80da416f43933831 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
var $98fb39eb14e7dc25$export$fc0748a8e0014066 = /* @__PURE__ */ $98fb39eb14e7dc25$export$b41394a5437791c8("accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns");
function $98fb39eb14e7dc25$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
    return type === "string" || type === "number" || type === "boolean";
}
var $98fb39eb14e7dc25$var$escapeRE = /["'&<>]/;
function $98fb39eb14e7dc25$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $98fb39eb14e7dc25$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
var $98fb39eb14e7dc25$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $98fb39eb14e7dc25$export$7b105034a53bde5f(src) {
    return src.replace($98fb39eb14e7dc25$var$commentStripRE, "");
}
var $98fb39eb14e7dc25$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $98fb39eb14e7dc25$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($98fb39eb14e7dc25$export$9320a7246b331080, function(s) {
        return doubleEscape ? s === '"' ? '\\\\\\"' : "\\\\".concat(s) : "\\".concat(s);
    });
}
function $98fb39eb14e7dc25$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $98fb39eb14e7dc25$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $98fb39eb14e7dc25$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    var aValidType = $98fb39eb14e7dc25$export$871608497c498473(a);
    var bValidType = $98fb39eb14e7dc25$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $98fb39eb14e7dc25$export$a244864fd9645c7f(a);
    bValidType = $98fb39eb14e7dc25$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $98fb39eb14e7dc25$export$43bee75e5e14138e(a);
    bValidType = $98fb39eb14e7dc25$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $98fb39eb14e7dc25$var$looseCompareArrays(a, b) : false;
    aValidType = $98fb39eb14e7dc25$export$a6cdc56e425d0d0a(a);
    bValidType = $98fb39eb14e7dc25$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        var aKeysCount = Object.keys(a).length;
        var bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(var key in a){
            var aHasKey = a.hasOwnProperty(key);
            var bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$98fb39eb14e7dc25$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $98fb39eb14e7dc25$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $98fb39eb14e7dc25$export$ae8015769846262c(item, val);
    });
}
var $98fb39eb14e7dc25$var$isRef = function(val) {
    return !!(val && val["__v_isRef"] === true);
};
var $98fb39eb14e7dc25$export$b5b1545233b45293 = function(val) {
    return $98fb39eb14e7dc25$export$844ec244b1367d54(val) ? val : val == null ? "" : $98fb39eb14e7dc25$export$43bee75e5e14138e(val) || $98fb39eb14e7dc25$export$a6cdc56e425d0d0a(val) && (val.toString === $98fb39eb14e7dc25$export$830c053460e5ddf6 || !$98fb39eb14e7dc25$export$f6e2535fb5126e54(val.toString)) ? $98fb39eb14e7dc25$var$isRef(val) ? $98fb39eb14e7dc25$export$b5b1545233b45293(val.value) : JSON.stringify(val, $98fb39eb14e7dc25$var$replacer, 2) : String(val);
};
var $98fb39eb14e7dc25$var$replacer = function(_key, val) {
    if ($98fb39eb14e7dc25$var$isRef(val)) return $98fb39eb14e7dc25$var$replacer(_key, val.value);
    else if ($98fb39eb14e7dc25$export$5c90113a285f2241(val)) return (0, $cqEAj._)({}, "Map(".concat(val.size, ")"), (0, $7WNf6._)(val.entries()).reduce(function(entries, param, i) {
        var _param = (0, $32TW8._)(param, 2), key = _param[0], val2 = _param[1];
        entries[$98fb39eb14e7dc25$var$stringifySymbol(key, i) + " =>"] = val2;
        return entries;
    }, {}));
    else if ($98fb39eb14e7dc25$export$6750766a7c7ec627(val)) return (0, $cqEAj._)({}, "Set(".concat(val.size, ")"), (0, $7WNf6._)(val.values()).map(function(v) {
        return $98fb39eb14e7dc25$var$stringifySymbol(v);
    }));
    else if ($98fb39eb14e7dc25$export$a244864fd9645c7f(val)) return $98fb39eb14e7dc25$var$stringifySymbol(val);
    else if ($98fb39eb14e7dc25$export$a6cdc56e425d0d0a(val) && !$98fb39eb14e7dc25$export$43bee75e5e14138e(val) && !$98fb39eb14e7dc25$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
var $98fb39eb14e7dc25$var$stringifySymbol = function(v) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $98fb39eb14e7dc25$export$a244864fd9645c7f(v) ? "Symbol(".concat((_a = v.description) != null ? _a : i, ")") : v);
};
function $98fb39eb14e7dc25$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});
parcelRegister("32TW8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $237cf2dadf61cc16$export$71511d61b312f219; });

var $ajVVX = parcelRequire("ajVVX");

var $chDGH = parcelRequire("chDGH");

var $e52Jn = parcelRequire("e52Jn");

var $lG3Im = parcelRequire("lG3Im");
function $237cf2dadf61cc16$export$71511d61b312f219(arr, i) {
    return (0, $ajVVX._)(arr) || (0, $chDGH._)(arr, i) || (0, $lG3Im._)(arr, i) || (0, $e52Jn._)();
}

});
parcelRegister("ajVVX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $78389e31601f6f74$export$71511d61b312f219; });
function $78389e31601f6f74$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("chDGH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8f15dbbe01d29327$export$71511d61b312f219; });
function $8f15dbbe01d29327$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("e52Jn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a403a6a2cc726d82$export$71511d61b312f219; });
function $a403a6a2cc726d82$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("5Op9f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $29749cb926cab32d$export$2e2bcd8739ae039; });

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");

var $boq2B = parcelRequire("boq2B");

parcelRequire("lGUYa");
var $dRnj4 = parcelRequire("dRnj4");
var $dRnj4 = parcelRequire("dRnj4");

var $lUI9E = parcelRequire("lUI9E");

var $5u2PY = parcelRequire("5u2PY");

var $fF3Ps = parcelRequire("fF3Ps");

var $jiXdb = parcelRequire("jiXdb");
var $29749cb926cab32d$var$Graph = null;
var $29749cb926cab32d$var$database = {
    nodes: [],
    links: []
};
var $29749cb926cab32d$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        Splitpanes: (0, $boq2B.Splitpanes),
        Pane: (0, $boq2B.Pane)
    },
    data: function() {
        var _this = this;
        return {
            version: 0,
            activeId: null,
            search: {
                text: "",
                loading: false
            },
            open: {
                description: false
            },
            split: "both",
            orientation: (0, $fF3Ps.getOrientation)(),
            settings: {
                title: false,
                darkMode: true
            },
            article: {
                show: false,
                content: null
            },
            // SPARQL filtering state
            sparqlFilters: {
                active: false,
                data: [],
                originalData: null,
                currentQuery: "",
                loading: false,
                error: null,
                abortController: null
            },
            // SPARQL interface state
            showSparqlInterface: true,
            selectedPresetQuery: null,
            customSparqlQuery: "",
            // Search mode: 'normal' or 'sparql'
            searchMode: "normal",
            // Separate active ID for SPARQL mode to avoid conflicts
            activeSparqlId: null,
            // SPARQL menu options
            sparqlQueries: [
                {
                    name: "All Learning Resources",
                    key: "all",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?format ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title .\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n  OPTIONAL { ?resource dcterms:format ?format }\n  OPTIONAL { ?resource dcterms:subject ?subject }\n} LIMIT 10"
                },
                {
                    name: "Resources with Similarity Links",
                    key: "similar",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\n\nSELECT ?resource ?title ?creator ?similar ?similarTitle WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            sim:similarTo ?similar .\n  ?similar dcterms:title ?similarTitle .\n  OPTIONAL { ?resource dcterms:creator ?creator }\n} LIMIT 10"
                },
                {
                    name: "Database & SQL Resources",
                    key: "databases",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "datenbank") || \n         CONTAINS(LCASE(STR(?subject)), "sql") ||\n         CONTAINS(LCASE(STR(?title)), "datenbank") ||\n         CONTAINS(LCASE(STR(?title)), "sql"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "Programming & Computer Science",
                    key: "programming",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "informatik") || \n         CONTAINS(LCASE(STR(?subject)), "programming") ||\n         CONTAINS(LCASE(STR(?subject)), "programmierung") ||\n         CONTAINS(LCASE(STR(?subject)), "algorithmen") ||\n         CONTAINS(LCASE(STR(?subject)), "python") ||\n         CONTAINS(LCASE(STR(?subject)), "java"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "Mathematics Resources",
                    key: "mathematics",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "mathematik") || \n         CONTAINS(LCASE(STR(?subject)), "mathe") ||\n         CONTAINS(LCASE(STR(?title)), "mathematik") ||\n         CONTAINS(LCASE(STR(?subject)), "algebra") ||\n         CONTAINS(LCASE(STR(?subject)), "funktionen"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "PDF Documents",
                    key: "pdf",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\n\nSELECT ?resource ?title ?creator ?type ?format ?similarCount WHERE {\n  # Get PDF documents first (smaller result set)\n  {\n    SELECT DISTINCT ?resource WHERE {\n      ?resource a edu:LearningResource ;\n                dcterms:format ?format .\n      FILTER(?format = "pdf" || ?format = "application/pdf")\n    }\n    LIMIT 20  # Pre-limit to make similarity counting faster\n  }\n  \n  # Get metadata for these PDFs\n  ?resource dcterms:title ?title ;\n            dcterms:format ?format .\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n  \n  # Count similarities efficiently with COALESCE for zero handling\n  OPTIONAL {\n    SELECT ?resource (COUNT(DISTINCT ?related) as ?count) WHERE {\n      {\n        ?rel a sim:SimilarityRelation ;\n             sim:source ?resource ;\n             sim:target ?related .\n      }\n      UNION\n      {\n        ?rel a sim:SimilarityRelation ;\n             sim:source ?related ;\n             sim:target ?resource .\n      }\n    }\n    GROUP BY ?resource\n  }\n  \n  BIND(COALESCE(?count, 0) as ?similarCount)\n}\nORDER BY DESC(?similarCount) ?title\nLIMIT 10'
                },
                {
                    name: "Physics & Engineering",
                    key: "physics",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "physik") || \n         CONTAINS(LCASE(STR(?subject)), "ingenieur") ||\n         CONTAINS(LCASE(STR(?subject)), "technik") ||\n         CONTAINS(LCASE(STR(?subject)), "elektrotechnik") ||\n         CONTAINS(LCASE(STR(?title)), "physik"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "Office Documents (Word, PowerPoint, Excel)",
                    key: "office",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?format WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:format ?format .\n  FILTER(?format = "docx" || ?format = "pptx" || ?format = "xlsx" ||\n         ?format = "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||\n         ?format = "application/vnd.openxmlformats-officedocument.presentationml.presentation")\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "Resources by Specific Publishers",
                    key: "publishers",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?publisher ?type WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:publisher ?publisher .\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10"
                },
                {
                    name: "TU Dresden Resources",
                    key: "tu_dresden",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?publisher ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:publisher ?publisher .\n  FILTER(CONTAINS(LCASE(STR(?publisher)), "dresden") || \n         CONTAINS(LCASE(STR(?publisher)), "tu_dresden"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:subject ?subject }\n} LIMIT 10'
                },
                {
                    name: "Chemistry & Biology",
                    key: "chemistry",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "chemie") || \n         CONTAINS(LCASE(STR(?subject)), "biologie") ||\n         CONTAINS(LCASE(STR(?subject)), "biochemie") ||\n         CONTAINS(LCASE(STR(?title)), "chemie") ||\n         CONTAINS(LCASE(STR(?subject)), "photosynthese"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n} LIMIT 10'
                },
                {
                    name: "Lecture Materials & Tutorials",
                    key: "lectures",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:type ?type .\n  FILTER(CONTAINS(LCASE(STR(?type)), "vorlesungsfolien") ||\n         CONTAINS(LCASE(STR(?type)), "tutorial") ||\n         CONTAINS(LCASE(STR(?type)), "skript"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:subject ?subject }\n} LIMIT 10'
                },
                {
                    name: "Find Resources Similar to a Given One",
                    key: "similarity_network",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\n\nSELECT ?resource ?title ?similar1 ?title1 ?score1 WHERE {\n  # Simplified: Only show direct similarities, not two-hop\n  ?relation1 a sim:SimilarityRelation ;\n             sim:source ?resource ;\n             sim:target ?similar1 ;\n             sim:score ?score1 .\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title .\n  ?similar1 dcterms:title ?title1 .\n  \n  # Filter for high-quality similarities only\n  FILTER(?score1 > 0.7)\n} \nORDER BY DESC(?score1)\nLIMIT 10"
                },
                {
                    name: "Resources with Rich Descriptions",
                    key: "described",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?description (GROUP_CONCAT(DISTINCT ?subject; separator=", ") as ?subjects) WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:description ?description .\n  FILTER(STRLEN(?description) > 100)\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:subject ?subject }\n}\nGROUP BY ?resource ?title ?creator ?description\nLIMIT 10'
                },
                {
                    name: "Machine Learning & AI Resources",
                    key: "ai_ml",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator ?type ?subject WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:subject ?subject .\n  FILTER(CONTAINS(LCASE(STR(?subject)), "k\xfcnstliche_intelligenz") || \n         CONTAINS(LCASE(STR(?subject)), "machine_learning") ||\n         CONTAINS(LCASE(STR(?subject)), "neuronale_netze") ||\n         CONTAINS(LCASE(STR(?subject)), "ki-") ||\n         CONTAINS(LCASE(STR(?title)), "intelligenz"))\n  OPTIONAL { ?resource dcterms:creator ?creator }\n  OPTIONAL { ?resource dcterms:type ?type }\n}'
                },
                {
                    name: "Find Similar Resources to Specific ID",
                    key: "similar_to_id",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\nPREFIX oer: <http://example.org/oer/>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\n\nSELECT ?resource ?title ?creator ?type ?subject ?score WHERE {\n  {\n    # Find resources where the given ID is the source\n    ?relation a sim:SimilarityRelation ;\n              sim:source oer:YOUR_ID_HERE ;\n              sim:target ?resource ;\n              sim:score ?score .\n    ?resource dcterms:title ?title .\n    OPTIONAL { ?resource dcterms:creator ?creator }\n    OPTIONAL { ?resource dcterms:type ?type }\n    OPTIONAL { ?resource dcterms:subject ?subject }\n  }\n  UNION\n  {\n    # Find resources where the given ID is the target\n    ?relation a sim:SimilarityRelation ;\n              sim:source ?resource ;\n              sim:target oer:YOUR_ID_HERE ;\n              sim:score ?score .\n    ?resource dcterms:title ?title .\n    OPTIONAL { ?resource dcterms:creator ?creator }\n    OPTIONAL { ?resource dcterms:type ?type }\n    OPTIONAL { ?resource dcterms:subject ?subject }\n  }\n  UNION\n  {\n    # Include the original resource itself\n    BIND(oer:YOUR_ID_HERE as ?resource)\n    BIND("1.0"^^xsd:decimal as ?score)\n    ?resource dcterms:title ?title .\n    OPTIONAL { ?resource dcterms:creator ?creator }\n    OPTIONAL { ?resource dcterms:type ?type }\n    OPTIONAL { ?resource dcterms:subject ?subject }\n  }\n}\nORDER BY DESC(?score)\nLIMIT 10'
                },
                {
                    name: "Two-Hop Similarity Network from ID",
                    key: "two_hop_similarity",
                    query: 'PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\nPREFIX oer: <http://example.org/oer/>\n\nSELECT DISTINCT ?resource ?title ?creator ?distance ?score WHERE {\n  # Optimized: Start with direct similarities first (faster)\n  {\n    # Direct similarity (distance 1) - both directions\n    {\n      ?relation a sim:SimilarityRelation ;\n                sim:source oer:YOUR_ID_HERE ;\n                sim:target ?resource ;\n                sim:score ?score .\n    }\n    UNION\n    {\n      ?relation a sim:SimilarityRelation ;\n                sim:source ?resource ;\n                sim:target oer:YOUR_ID_HERE ;\n                sim:score ?score .\n    }\n    ?resource dcterms:title ?title .\n    BIND("1" as ?distance)\n  }\n  UNION\n  {\n    # Two-hop: Only high-score intermediate connections (optimized)\n    ?relation1 a sim:SimilarityRelation ;\n               sim:source oer:YOUR_ID_HERE ;\n               sim:target ?intermediate ;\n               sim:score ?score1 .\n    FILTER(?score1 > 0.8)  # Pre-filter for quality\n    \n    ?relation2 a sim:SimilarityRelation ;\n               sim:source ?intermediate ;\n               sim:target ?resource ;\n               sim:score ?score .\n    FILTER(?score > 0.7)   # Pre-filter for quality\n    \n    ?resource dcterms:title ?title .\n    FILTER(?resource != oer:YOUR_ID_HERE)\n    BIND("2" as ?distance)\n  }\n  \n  OPTIONAL { ?resource dcterms:creator ?creator }\n} \nORDER BY ?distance DESC(?score) \nLIMIT 50'
                },
                {
                    name: "Similarity by Subject Overlap",
                    key: "subject_similarity",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX oer: <http://example.org/oer/>\n\nSELECT ?resource ?title ?creator (COUNT(?sharedSubject) as ?subjectOverlap) WHERE {\n  # Optimized: Direct count without nested GROUP_CONCAT\n  oer:YOUR_ID_HERE dcterms:subject ?sharedSubject .\n  ?resource dcterms:subject ?sharedSubject ;\n            dcterms:title ?title .\n  FILTER(?resource != oer:YOUR_ID_HERE)\n  OPTIONAL { ?resource dcterms:creator ?creator }\n}\nGROUP BY ?resource ?title ?creator\nHAVING(COUNT(?sharedSubject) >= 2)  # Reduced threshold for faster results\nORDER BY DESC(?subjectOverlap) \nLIMIT 30"
                },
                {
                    name: "Resources with Most Similar Connections",
                    key: "similarity_count",
                    query: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\nPREFIX sim: <http://example.org/similarity/>\n\nSELECT ?resource ?title ?creator ?similarCount WHERE {\n  # Pre-filter to learning resources first\n  {\n    SELECT ?resource (COUNT(DISTINCT ?related) as ?similarCount) WHERE {\n      ?resource a edu:LearningResource .\n      \n      # Count similarities efficiently with early limiting\n      {\n        SELECT DISTINCT ?resource ?related WHERE {\n          {\n            ?relation a sim:SimilarityRelation ;\n                      sim:source ?resource ;\n                      sim:target ?related .\n          }\n          UNION\n          {\n            ?relation a sim:SimilarityRelation ;\n                      sim:source ?related ;\n                      sim:target ?resource .\n          }\n        }\n        LIMIT 1000  # Pre-limit similarity relations to check\n      }\n    }\n    GROUP BY ?resource\n    ORDER BY DESC(?similarCount)\n    LIMIT 20  # Pre-select top candidates\n  }\n  \n  # Get metadata for selected resources\n  ?resource dcterms:title ?title .\n  OPTIONAL { ?resource dcterms:creator ?creator }\n}\nORDER BY DESC(?similarCount)\nLIMIT 10"
                }
            ],
            resizeObserver: new ResizeObserver(function() {
                _this.handleResize();
            })
        };
    },
    methods: {
        handleSearch: // Define any methods here if needed
        function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var rawTerm, term, nodeIds, links, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, source, target, sId, tId, nodes;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    this.search.loading = true;
                    this.article.show = false;
                    $29749cb926cab32d$var$Graph.pauseAnimation(); // make sure the loop is idle
                    if (!$29749cb926cab32d$var$database || !$29749cb926cab32d$var$Graph) return [
                        2
                    ];
                    rawTerm = this.search.text.trim(); // keep user casing*
                    // Update URL parameters for search
                    (0, $fF3Ps.updateUrlParams)({
                        mode: "normal",
                        search: rawTerm || null,
                        id: null
                    });
                    term = rawTerm.toLowerCase();
                    // 1️⃣  Show the entire graph **only** when the search term is exactly '*'
                    if (term === "*") {
                        $29749cb926cab32d$var$Graph.graphData($29749cb926cab32d$var$database).d3ReheatSimulation();
                        this.updateCounters($29749cb926cab32d$var$database);
                        $29749cb926cab32d$var$Graph.resumeAnimation();
                        this.search.loading = false;
                        return [
                            2
                        ];
                    }
                    // 2️⃣  Hide the graph completely when the search field is empty
                    if (!term) {
                        $29749cb926cab32d$var$Graph.graphData({
                            nodes: [],
                            links: []
                        });
                        this.updateCounters({
                            nodes: [],
                            links: []
                        });
                        $29749cb926cab32d$var$Graph.resumeAnimation();
                        this.search.loading = false;
                        return [
                            2
                        ];
                    }
                    // 3️⃣  Otherwise, run the regular filtered search
                    nodeIds = new Set($29749cb926cab32d$var$database.nodes.filter(function(n) {
                        return (0, $fF3Ps.includes)("".concat(n.title, " ").concat(n.affiliation || "", " ").concat(n.summary || "", " ").concat(n.authors || "", " ").concat(n.file, " ").concat(n.tag.join(" "), " ").concat(n.license || ""), term);
                    }).map(function(n) {
                        return n.id;
                    }));
                    links = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = $29749cb926cab32d$var$database.links[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = _step.value, source = _step_value.source, target = _step_value.target;
                            // normalise to plain ids just once
                            sId = (typeof source === "undefined" ? "undefined" : (0, $3KZcf._)(source)) === "object" ? source.id : source;
                            tId = (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)) === "object" ? target.id : target;
                            // keep the link only if either endpoint matches
                            if (nodeIds.has(sId) && nodeIds.has(tId)) links.push({
                                source: sId,
                                target: tId
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    nodes = (0, $fF3Ps.resetNodePositions)($29749cb926cab32d$var$database.nodes.filter(function(n) {
                        return nodeIds.has(n.id);
                    }));
                    $29749cb926cab32d$var$Graph.graphData({
                        nodes: nodes,
                        links: links
                    }).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
                    $29749cb926cab32d$var$Graph.resumeAnimation();
                    this.updateCounters({
                        nodes: nodes,
                        links: links
                    });
                    this.search.loading = false;
                    return [
                        2
                    ];
                });
            }).call(this);
        },
        initGraph: function() {
            var _this = this;
            if ($29749cb926cab32d$var$Graph) return;
            fetch("db.json").then(function(response) {
                return response.json();
            }).then(function(json) {
                var self = _this;
                $29749cb926cab32d$var$database = json;
                _this.updateCounters({
                    nodes: [],
                    links: []
                });
                $29749cb926cab32d$var$Graph = new ForceGraph3D(_this.$refs.graph, {
                    extraRenderers: [
                        new (0, $jiXdb.CSS2DRenderer)()
                    ],
                    controlType: "orbit"
                }).graphData({
                    nodes: [],
                    links: []
                }).nodeColor(function(node) {
                    var baseColor = (0, $fF3Ps.stringToColor)(node.tag[0]);
                    // Make the active node glow with a brighter, more saturated color
                    if (node.id === _this.activeId) {
                        // Convert hex to RGB and increase brightness/saturation
                        var hex = baseColor.replace("#", "");
                        var r = Math.min(255, parseInt(hex.substr(0, 2), 16) + 80);
                        var g = Math.min(255, parseInt(hex.substr(2, 2), 16) + 80);
                        var b = Math.min(255, parseInt(hex.substr(4, 2), 16) + 80);
                        return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
                    }
                    return baseColor;
                }).nodeVal(function(n) {
                    return n.value || 4;
                }).onNodeRightClick(function(node) {
                    _this.loadConnections(node);
                }).nodeThreeObject(function(node) {
                    // Create glowing effect for active node
                    if (node.id === _this.activeId && !_this.settings.title) {
                        var geometry = new $dRnj4.SphereGeometry(10);
                        var baseColor = (0, $fF3Ps.stringToColor)(node.tag[0]);
                        // Create a glowing material
                        var material = new $dRnj4.MeshBasicMaterial({
                            color: baseColor,
                            transparent: true,
                            opacity: 0.8
                        });
                        var sphere = new $dRnj4.Mesh(geometry, material);
                        // Add a larger, more transparent outer glow
                        var glowGeometry = new $dRnj4.SphereGeometry(20);
                        var glowMaterial = new $dRnj4.MeshBasicMaterial({
                            color: baseColor,
                            transparent: true,
                            opacity: 0.3,
                            side: $dRnj4.BackSide
                        });
                        var glowSphere = new $dRnj4.Mesh(glowGeometry, glowMaterial);
                        var group = new $dRnj4.Group();
                        group.add(sphere);
                        group.add(glowSphere);
                        return group;
                    }
                    if (_this.settings.title) {
                        var nodeEl = document.createElement("span");
                        nodeEl.textContent = node.title.length <= 25 ? node.title : node.title.slice(0, 25) + "...";
                        nodeEl.style.color = (0, $fF3Ps.stringToColor)(node.tag[0]);
                        nodeEl.className = "node-label";
                        // Add glowing effect to label for active node
                        if (node.id === _this.activeId) {
                            nodeEl.style.textShadow = "0 0 10px ".concat((0, $fF3Ps.stringToColor)(node.tag[0]), ", 0 0 20px ").concat((0, $fF3Ps.stringToColor)(node.tag[0]), ", 0 0 30px ").concat((0, $fF3Ps.stringToColor)(node.tag[0]));
                            nodeEl.style.fontWeight = "bold";
                        }
                        return new (0, $jiXdb.CSS2DObject)(nodeEl);
                    }
                }).nodeThreeObjectExtend(true).onNodeClick(function(node) {
                    return _this.showArticle(node, true);
                }).nodeLabel(function(node) {
                    return "".concat(node.title);
                });
                // Enable WebXR
                var renderer = $29749cb926cab32d$var$Graph.renderer();
                renderer.xr.enabled = true;
                if (navigator.xr && navigator.xr.isSessionSupported) navigator.xr.isSessionSupported("immersive-vr").then(function(supported) {
                    if (supported) _this.$refs.graph.appendChild((0, $5u2PY.VRButton).createButton(renderer));
                });
                $29749cb926cab32d$var$Graph.pauseAnimation();
                //Graph.d3Force("charge").strength(-500);
                // Parse URL parameters to determine initial state
                var urlParams = (0, $fF3Ps.parseUrlParams)();
                // Set initial mode from URL or default to normal
                _this.searchMode = urlParams.mode || "normal";
                // Handle initial view parameter
                if (urlParams.view) _this.split = urlParams.view;
                setTimeout(function() {
                    // Handle title parameter
                    if (urlParams.title) self.toggleTitle();
                    // Handle theme parameter
                    if (urlParams.theme === "light") {
                        self.settings.darkMode = false;
                        self.$vuetify.theme.global.name = "light";
                        var graphElement = self.$refs.graph;
                        if (graphElement) graphElement.style.backgroundColor = "white";
                    }
                    // Handle mode-specific initialization
                    if (urlParams.mode === "sparql") {
                        // SPARQL mode initialization
                        if (urlParams.sparqlQuery) self.customSparqlQuery = urlParams.sparqlQuery;
                        if (urlParams.sparqlPreset) {
                            self.selectedPresetQuery = urlParams.sparqlPreset;
                            // Load the preset query if available
                            var presetQuery = self.sparqlQueries.find(function(q) {
                                return q.key === urlParams.sparqlPreset;
                            });
                            if (presetQuery && !urlParams.sparqlQuery) self.customSparqlQuery = presetQuery.query;
                        }
                        // Execute the SPARQL query if present
                        if (self.customSparqlQuery) self.executeCustomSparqlQuery().then(function() {
                            // Handle ID selection after SPARQL results are loaded
                            if (urlParams.id) setTimeout(function() {
                                // Find node in SPARQL results
                                var sparqlItem = self.sparqlFilters.data.find(function(item) {
                                    var _item_resource_value, _item_resource;
                                    var originalId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                                    return originalId === urlParams.id;
                                });
                                if (sparqlItem) {
                                    var visibleItem = self.visibleNodes.find(function(item) {
                                        return item.originalId === urlParams.id;
                                    });
                                    if (visibleItem) self.showArticle(visibleItem, true);
                                }
                            }, 1000);
                        });
                    } else {
                        // Normal mode initialization
                        if (urlParams.search) {
                            self.search.text = urlParams.search; // pre‑fill the field
                            self.handleSearch(); // execute the search
                            if (urlParams.id) setTimeout(function() {
                                var node = $29749cb926cab32d$var$Graph.graphData().nodes.find(function(n) {
                                    return n.id === urlParams.id;
                                });
                                if (node) self.showArticle(node, true);
                            }, 1000);
                        } else if (urlParams.id) // If only ID is provided, we need to find and highlight the node
                        // This might require loading connections or showing the full graph
                        setTimeout(function() {
                            // Show full graph first to find the node
                            $29749cb926cab32d$var$Graph.graphData($29749cb926cab32d$var$database).d3ReheatSimulation();
                            self.updateCounters($29749cb926cab32d$var$database);
                            var node = $29749cb926cab32d$var$database.nodes.find(function(n) {
                                return n.id === urlParams.id;
                            });
                            if (node) self.showArticle(node, true);
                        }, 1000);
                    }
                }, 1000);
            //this.$refs.graph.appendChild(VRButton.createButton(renderer));
            })["catch"](function(err) {
                return console.warn(err);
            });
            this.resizeObserver.observe(this.$refs.graph);
        },
        updateCounters: function(graph) {
            this.version++;
            this.$refs.nodes.innerText = graph.nodes.length;
            this.$refs.links.innerText = graph.links.length;
        },
        handleResize: function() {
            if (!$29749cb926cab32d$var$Graph) return;
            $29749cb926cab32d$var$Graph.width(this.$refs.graph.clientWidth).height(this.$refs.graph.clientHeight);
        },
        handleSplitChange: function(kind) {
            this.split = kind;
            // Update URL parameters, preserving current state
            (0, $fF3Ps.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                view: kind === "both" ? null : kind
            });
        },
        showArticle: function(node) {
            var _this = this;
            var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var _node_id;
            if (!node) {
                this.activeId = null;
                this.activeSparqlId = null;
                // Update URL to clear ID parameter, but preserve other parameters
                (0, $fF3Ps.updateUrlParams)({
                    mode: this.searchMode,
                    search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                    sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                    sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                    id: null
                });
                // Refresh graph to remove glowing effect
                $29749cb926cab32d$var$Graph.refresh();
                return;
            }
            // Handle clicking on graph nodes in SPARQL mode
            if (this.searchMode === "sparql" && this.sparqlFilters.active) {
                // Find the corresponding SPARQL result item
                var sparqlItem = this.sparqlFilters.data.find(function(item) {
                    var _item_resource_value, _item_resource;
                    var originalId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                    return originalId === node.id;
                });
                if (sparqlItem) {
                    // Find the corresponding item in visibleNodes to get the SPARQL ID
                    var visibleItem = this.visibleNodes.find(function(item) {
                        return item.originalId === node.id;
                    });
                    if (visibleItem) {
                        this.activeSparqlId = visibleItem.id;
                        this.activeId = node.id; // Keep for graph highlighting
                        // Update graph highlighting
                        var config = $29749cb926cab32d$var$Graph.graphData();
                        for(var i = 0; i < config.nodes.length; i++)config.nodes[i].value = config.nodes[i].id === node.id ? 70 : 4;
                        $29749cb926cab32d$var$Graph.graphData(config);
                        $29749cb926cab32d$var$Graph.refresh();
                        this.article.content = visibleItem;
                        this.article.show = true;
                        // Handle scrolling to the card in the list
                        if (this.split !== "graph" && scroll) {
                            var index = this.visibleNodes.findIndex(function(n) {
                                return n.id === visibleItem.id;
                            });
                            if (index >= 0) this.$nextTick(function() {
                                return requestAnimationFrame(function() {
                                    _this.$refs.list.scrollToIndex(index);
                                });
                            });
                        }
                        // Update URL with original ID, preserving SPARQL query and preset
                        (0, $fF3Ps.updateUrlParams)({
                            mode: this.searchMode,
                            sparqlQuery: this.customSparqlQuery || undefined,
                            sparqlPreset: this.selectedPresetQuery || undefined,
                            id: node.id
                        });
                        return;
                    }
                }
            }
            // Handle SPARQL mode card clicks (existing logic)
            if (this.searchMode === "sparql" && ((_node_id = node.id) === null || _node_id === void 0 ? void 0 : _node_id.startsWith("sparql_"))) {
                this.activeSparqlId = node.id;
                this.activeId = null; // Clear normal mode active ID
                // Find the corresponding node in the filtered graph using originalId
                var originalId = node.originalId;
                if (originalId) {
                    var config1 = $29749cb926cab32d$var$Graph.graphData();
                    // Find the node in the current graph data
                    var graphNode = config1.nodes.find(function(n) {
                        return n.id === originalId;
                    });
                    if (graphNode) {
                        // Update graph highlighting
                        for(var i1 = 0; i1 < config1.nodes.length; i1++)config1.nodes[i1].value = config1.nodes[i1].id === originalId ? 70 : 4;
                        $29749cb926cab32d$var$Graph.graphData(config1);
                        $29749cb926cab32d$var$Graph.refresh();
                        // Set activeId for graph synchronization
                        this.activeId = originalId;
                    }
                }
                this.article.content = node;
                this.article.show = true;
                // Handle scrolling in SPARQL mode
                if (this.split !== "graph" && scroll) {
                    var index1 = this.visibleNodes.findIndex(function(n) {
                        return n.id === node.id;
                    });
                    if (index1 >= 0) this.$nextTick(function() {
                        return requestAnimationFrame(function() {
                            _this.$refs.list.scrollToIndex(index1);
                        });
                    });
                }
                // Set URL to the original ID if available, preserving SPARQL query and preset
                var urlId = node.originalId || node.id;
                (0, $fF3Ps.updateUrlParams)({
                    mode: this.searchMode,
                    sparqlQuery: this.customSparqlQuery || undefined,
                    sparqlPreset: this.selectedPresetQuery || undefined,
                    id: urlId
                });
                return;
            }
            // Normal mode handling
            this.activeId = node.id;
            this.activeSparqlId = null; // Clear SPARQL mode active ID
            // Update URL with the selected ID, preserving current mode parameters
            (0, $fF3Ps.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                id: this.activeId
            });
            var config2 = $29749cb926cab32d$var$Graph.graphData();
            var i2 = 0;
            for(i2 = 0; i2 < config2.nodes.length; i2++)config2.nodes[i2].value = config2.nodes[i2].id === node.id ? 70 : 4;
            $29749cb926cab32d$var$Graph.graphData(config2);
            // Refresh the graph to apply glowing effect to the new active node
            $29749cb926cab32d$var$Graph.refresh();
            this.article.content = node;
            this.article.show = true;
            if (this.split !== "list") this.center(node);
            if (this.split !== "graph" && scroll) {
                var index2 = $29749cb926cab32d$var$Graph.graphData().nodes.findIndex(function(n) {
                    return n.id === node.id;
                });
                this.$nextTick(function() {
                    return(// wait for Vue to paint
                    requestAnimationFrame(function() {
                        // wait for VVirtualScroll to measure
                        _this.$refs.list.scrollToIndex(index2);
                    }));
                });
            }
        },
        center: function(node) {
            var distance = 1000;
            var distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z);
            var newPos = node.x || node.y || node.z ? {
                x: node.x * distRatio,
                y: node.y * distRatio,
                z: node.z * distRatio
            } : {
                x: 0,
                y: 0,
                z: distance
            }; // special case if node is in (0,0,0)
            $29749cb926cab32d$var$Graph.cameraPosition(newPos, node, 3000 // ms transition duration
            );
        },
        load: function(id) {
            window.open("https://bildungsportal.sachsen.de/opal/oer/".concat(id), "_blank");
        },
        loadConnections: function(node) {
            var _this = this;
            /* ---------- helpers & cached look‑ups ---------- */ var live = $29749cb926cab32d$var$Graph.graphData(); // current graph
            var dbNode = new Map($29749cb926cab32d$var$database.nodes.map(function(n) {
                return [
                    n.id,
                    n
                ];
            })); // O(1) lookup
            var keepIds = new Set(live.nodes.map(function(n) {
                return n.id;
            })); // nodes we already show
            var newLinks = live.links.map(function(link) {
                return {
                    source: link.source.id,
                    target: link.target.id
                };
            }); // fresh array copy
            var updates = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                /* ---------- scan the full link table once ---------- */ for(var _iterator = $29749cb926cab32d$var$database.links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, source = _step_value.source, target = _step_value.target;
                    var sId = (typeof source === "undefined" ? "undefined" : (0, $3KZcf._)(source)) === "object" ? source.id : source;
                    var tId = (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)) === "object" ? target.id : target;
                    // only links that touch the clicked id *and* whose endpoints both exist
                    if ((sId === node.id || tId === node.id) && dbNode.has(sId) && dbNode.has(tId)) {
                        newLinks.push({
                            source: sId,
                            target: tId
                        });
                        keepIds.add(sId).add(tId); // Set.add is chain‑able
                        updates = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!updates) return;
            /* ---------- build the matching node list ---------- */ var newNodes = (0, $fF3Ps.resetNodePositions)(Array.from(keepIds, function(id) {
                return dbNode.get(id);
            }));
            /* ---------- update the graph ---------- */ for(var i = 0; i < newNodes.length; i++)newNodes[i].value = newNodes[i].id === node.id ? 50 : 4;
            $29749cb926cab32d$var$Graph.graphData({
                nodes: newNodes,
                links: newLinks
            }); //.d3ReheatSimulation(); // optional: settle layout again
            // Refresh the graph to apply glowing effect
            $29749cb926cab32d$var$Graph.refresh();
            this.updateCounters({
                nodes: newNodes,
                links: newLinks
            });
            if (this.split === "both") this.$nextTick(function() {
                return(// wait for Vue to paint
                requestAnimationFrame(function() {
                    var index = $29749cb926cab32d$var$Graph.graphData().nodes.findIndex(function(n) {
                        return n.id === node.id;
                    });
                    // wait for VVirtualScroll to measure
                    _this.$refs.list.scrollToIndex(index);
                }));
            });
        },
        toggleTitle: function() {
            $29749cb926cab32d$var$Graph.pauseAnimation();
            this.settings.title = !this.settings.title;
            // Update URL parameters, preserving current state
            (0, $fF3Ps.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                title: this.settings.title ? "1" : null,
                theme: this.settings.darkMode ? null : "light"
            });
            $29749cb926cab32d$var$Graph.refresh();
            $29749cb926cab32d$var$Graph.resumeAnimation();
            $29749cb926cab32d$var$Graph.d3ReheatSimulation();
        },
        toggleTheme: function() {
            this.settings.darkMode = !this.settings.darkMode;
            this.$vuetify.theme.global.name = this.settings.darkMode ? "dark" : "light";
            // Update graph background color
            var graphElement = this.$refs.graph;
            if (graphElement) graphElement.style.backgroundColor = this.settings.darkMode ? "black" : "white";
            // Update URL parameters
            (0, $fF3Ps.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                title: this.settings.title ? "1" : null,
                theme: this.settings.darkMode ? null : "light"
            });
        },
        executeSparqlQuery: // SPARQL filtering methods
        function(queryConfig) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log("Executing SPARQL query:", queryConfig.name);
                            // Load the preset query into the custom query field
                            this.customSparqlQuery = queryConfig.query;
                            // Set the selected preset by key
                            this.selectedPresetQuery = queryConfig.key;
                            // Update URL parameters
                            (0, $fF3Ps.updateUrlParams)({
                                mode: "sparql",
                                sparqlQuery: queryConfig.query,
                                sparqlPreset: queryConfig.key
                            });
                            // Execute the query
                            return [
                                4,
                                this.executeCustomSparqlQuery()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).call(this);
        },
        clearSparqlFilters: function() {
            console.log("Clearing SPARQL filters");
            // Update URL parameters to remove SPARQL-specific params
            (0, $fF3Ps.updateUrlParams)({
                mode: "sparql",
                sparqlQuery: null,
                sparqlPreset: null,
                id: null
            });
            // Show empty graph instead of all data
            var emptyGraphData = {
                nodes: [],
                links: []
            };
            $29749cb926cab32d$var$Graph.graphData(emptyGraphData);
            this.updateCounters(emptyGraphData);
            // Clear filter state
            this.sparqlFilters.active = false;
            this.sparqlFilters.data = [];
            this.sparqlFilters.currentQuery = "";
            this.sparqlFilters.loading = false;
            this.sparqlFilters.error = null; // Clear errors
            this.sparqlFilters.originalData = null; // Reset original data reference
            this.selectedPresetQuery = null;
            this.customSparqlQuery = "";
            this.activeSparqlId = null;
            $29749cb926cab32d$var$Graph.resumeAnimation();
        },
        // SPARQL Interface Methods
        toggleSparqlInterface: function() {
            this.showSparqlInterface = !this.showSparqlInterface;
        },
        loadPresetQuery: function(index) {
            if (index !== null && this.sparqlQueries[index]) this.customSparqlQuery = this.sparqlQueries[index].query;
        },
        loadPresetQueryByKey: function(key) {
            if (key) {
                var query = this.sparqlQueries.find(function(q) {
                    return q.key === key;
                });
                if (query) this.customSparqlQuery = query.query;
            }
        },
        executeCustomSparqlQuery: function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var _this, results, sparqlNodeIds, filteredNodes, filteredNodeIds, filteredLinks, graphData, matchingPreset, error, errorMessage;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            if (!this.customSparqlQuery.trim()) {
                                console.warn("No SPARQL query provided");
                                return [
                                    2
                                ];
                            }
                            console.log("Executing custom SPARQL query");
                            // Update URL parameters before executing query
                            (0, $fF3Ps.updateUrlParams)({
                                mode: "sparql",
                                sparqlQuery: this.customSparqlQuery,
                                sparqlPreset: this.selectedPresetQuery
                            });
                            // Create new AbortController for this query
                            this.sparqlFilters.abortController = new AbortController();
                            this.sparqlFilters.loading = true;
                            this.sparqlFilters.error = null; // Clear previous errors
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                Promise.race([
                                    (0, $lUI9E.sparqlEngine).executeSelectQuery(this.customSparqlQuery),
                                    new Promise(function(_, reject) {
                                        var _this_sparqlFilters_abortController;
                                        (_this_sparqlFilters_abortController = _this.sparqlFilters.abortController) === null || _this_sparqlFilters_abortController === void 0 ? void 0 : _this_sparqlFilters_abortController.signal.addEventListener("abort", function() {
                                            reject(new Error("Query execution was cancelled by user"));
                                        });
                                    })
                                ])
                            ];
                        case 2:
                            results = _state.sent();
                            console.log("Custom SPARQL results:", results);
                            if (results && results.length > 0) {
                                // Store original data if not already stored
                                if (!this.sparqlFilters.originalData) this.sparqlFilters.originalData = (0, $iT0je._)({}, $29749cb926cab32d$var$database);
                                // Map SPARQL results to existing node format
                                sparqlNodeIds = new Set(results.map(function(item) {
                                    var _item_resource_value, _item_resource;
                                    return ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                                }).filter(function(id) {
                                    return id;
                                }) // Remove empty IDs
                                );
                                // Filter nodes that exist in both SPARQL results and original database
                                filteredNodes = $29749cb926cab32d$var$database.nodes.filter(function(node) {
                                    return sparqlNodeIds.has(node.id);
                                });
                                // Filter links to only include connections between filtered nodes
                                filteredNodeIds = new Set(filteredNodes.map(function(n) {
                                    return n.id;
                                }));
                                filteredLinks = $29749cb926cab32d$var$database.links.filter(function(link) {
                                    var sourceId = (0, $3KZcf._)(link.source) === "object" ? link.source.id : link.source;
                                    var targetId = (0, $3KZcf._)(link.target) === "object" ? link.target.id : link.target;
                                    return filteredNodeIds.has(sourceId) && filteredNodeIds.has(targetId);
                                });
                                // Update graph with filtered data
                                graphData = {
                                    nodes: (0, $fF3Ps.resetNodePositions)(filteredNodes),
                                    links: filteredLinks
                                };
                                $29749cb926cab32d$var$Graph.graphData(graphData).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
                                // Update counters and state
                                this.updateCounters(graphData);
                                this.sparqlFilters.active = true;
                                this.sparqlFilters.data = results;
                                // Determine if this is a preset query or custom
                                matchingPreset = this.sparqlQueries.find(function(q) {
                                    return q.query.trim() === _this.customSparqlQuery.trim();
                                });
                                this.sparqlFilters.currentQuery = matchingPreset ? matchingPreset.key : "custom";
                                $29749cb926cab32d$var$Graph.resumeAnimation();
                                console.log("Applied custom SPARQL filter (".concat(filteredNodes.length, " nodes)"));
                            } else {
                                console.warn("No results found for custom SPARQL query");
                                this.sparqlFilters.error = "No results found for this SPARQL query. Please check your query syntax and try again.";
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error executing custom SPARQL query:", error);
                            // Extract meaningful error message
                            errorMessage = "Unknown error occurred while executing SPARQL query.";
                            if (error instanceof Error) errorMessage = error.message;
                            else if (typeof error === "string") errorMessage = error;
                            else if (error && (typeof error === "undefined" ? "undefined" : (0, $3KZcf._)(error)) === "object" && "message" in error) errorMessage = error.message;
                            // Store the error for display
                            this.sparqlFilters.error = "SPARQL Query Error: ".concat(errorMessage);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            this.sparqlFilters.loading = false;
                            this.sparqlFilters.abortController = null; // Clean up abort controller
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).call(this);
        },
        // Stop the currently running SPARQL query
        stopSparqlQuery: function() {
            if (this.sparqlFilters.abortController) {
                console.log("Stopping SPARQL query execution");
                this.sparqlFilters.abortController.abort();
                this.sparqlFilters.abortController = null;
                this.sparqlFilters.loading = false;
                this.sparqlFilters.error = "Query execution was cancelled by user";
            }
        },
        handleSparqlFilterApplied: function(sparqlData) {
            console.log("SPARQL filter applied:", sparqlData);
            // Store original data if not already stored
            if (!this.sparqlFilters.originalData) this.sparqlFilters.originalData = (0, $iT0je._)({}, $29749cb926cab32d$var$database);
            // Map SPARQL results to existing node IDs
            var sparqlNodeIds = new Set(sparqlData.map(function(item) {
                return item.id;
            }).filter(function(id) {
                return id;
            }) // Remove empty IDs
            );
            // Filter nodes that exist in both SPARQL results and original database
            var filteredNodes = $29749cb926cab32d$var$database.nodes.filter(function(node) {
                return sparqlNodeIds.has(node.id);
            });
            // Filter links to only include connections between filtered nodes
            var filteredNodeIds = new Set(filteredNodes.map(function(n) {
                return n.id;
            }));
            var filteredLinks = $29749cb926cab32d$var$database.links.filter(function(link) {
                var sourceId = (0, $3KZcf._)(link.source) === "object" ? link.source.id : link.source;
                var targetId = (0, $3KZcf._)(link.target) === "object" ? link.target.id : link.target;
                return filteredNodeIds.has(sourceId) && filteredNodeIds.has(targetId);
            });
            // Update graph with filtered data
            var graphData = {
                nodes: (0, $fF3Ps.resetNodePositions)(filteredNodes),
                links: filteredLinks
            };
            $29749cb926cab32d$var$Graph.graphData(graphData).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
            // Update counters and state
            this.updateCounters(graphData);
            this.sparqlFilters.active = true;
            this.sparqlFilters.data = sparqlData;
            $29749cb926cab32d$var$Graph.resumeAnimation();
        },
        handleSparqlItemSelected: function(item) {
            var _item_resource_value, _item_resource;
            console.log("SPARQL item selected:", item);
            // Find the corresponding node in the graph
            var nodeId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
            var node = $29749cb926cab32d$var$Graph.graphData().nodes.find(function(n) {
                return n.id === nodeId;
            });
            if (node) {
                this.showArticle(node, true);
                this.open.sparql = false; // Close modal
            }
        },
        handleSparqlFiltersCleared: function() {
            console.log("SPARQL filters cleared");
            // Restore original data
            if (this.sparqlFilters.originalData) {
                $29749cb926cab32d$var$Graph.graphData(this.sparqlFilters.originalData).d3ReheatSimulation().zoomToFit(600, 40);
                this.updateCounters(this.sparqlFilters.originalData);
            }
            // Clear filter state
            this.sparqlFilters.active = false;
            this.sparqlFilters.data = [];
            $29749cb926cab32d$var$Graph.resumeAnimation();
        },
        copyIdToClipboard: // Copy ID to clipboard method
        function(id, event) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var error, textArea;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (event) event.stopPropagation(); // Prevent card click event
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                navigator.clipboard.writeText(id)
                            ];
                        case 2:
                            _state.sent();
                            console.log("Copied ID to clipboard: ".concat(id));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to copy ID to clipboard:", error);
                            // Fallback for older browsers
                            try {
                                textArea = document.createElement("textarea");
                                textArea.value = id;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand("copy");
                                document.body.removeChild(textArea);
                                console.log("Copied ID to clipboard (fallback): ".concat(id));
                            } catch (fallbackError) {
                                console.error("Fallback copy method also failed:", fallbackError);
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        // Helper methods for generic SPARQL field display
        getAdditionalSparqlFields: function(sparqlData) {
            if (!sparqlData) return {};
            // Define standard fields that are already displayed elsewhere
            var standardFields = new Set([
                "resource",
                "title",
                "creator",
                "type",
                "format",
                "subject",
                "subjects",
                "description",
                "publisher",
                "affiliation",
                "authors",
                "license",
                "tag",
                "summary",
                "file",
                "id",
                "originalId"
            ]);
            var additionalFields = {};
            // Extract additional fields from SPARQL data
            Object.keys(sparqlData).forEach(function(key) {
                var _sparqlData_key;
                if (!standardFields.has(key) && ((_sparqlData_key = sparqlData[key]) === null || _sparqlData_key === void 0 ? void 0 : _sparqlData_key.value) !== undefined) additionalFields[key] = sparqlData[key].value;
            });
            return additionalFields;
        },
        formatFieldName: function(fieldName) {
            // Convert camelCase or snake_case to readable format
            return fieldName.replace(/([A-Z])/g, " $1") // Add space before uppercase
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, function(l) {
                return l.toUpperCase();
            }) // Capitalize first letter of each word
            .trim();
        },
        formatFieldValue: function(value) {
            if (value === null || value === undefined) return "N/A";
            // Handle different value types
            if (typeof value === "number") {
                // Format numbers with appropriate precision
                if (value % 1 === 0) return value.toString();
                return Number(value).toFixed(3);
            }
            if (typeof value === "boolean") return value ? "Yes" : "No";
            // Handle URIs - extract just the local name
            if (typeof value === "string" && value.includes("/")) {
                var parts = value.split("/");
                var lastPart = parts[parts.length - 1];
                if (lastPart && lastPart !== value) return lastPart;
            }
            return String(value);
        }
    },
    computed: {
        visibleNodes: function() {
            /* establish the dependency */ this.version;
            if (!$29749cb926cab32d$var$Graph) return [];
            // Return SPARQL data in the list if filters are active
            if (this.sparqlFilters.active && this.sparqlFilters.data.length > 0) // Convert SPARQL data to display format for the list
            return this.sparqlFilters.data.map(function(item, index) {
                var _item_resource_value, _item_resource, _item_title, _item_type_value, _item_type, _item_format, _item_creator_value, _item_creator, _item_description, _item_subjects, _item_subject_value, _item_subject, _item_creator_value1, _item_creator1, _item_subjects1, _item_subject1, _item_resource_value1, _item_resource1;
                return {
                    id: "sparql_".concat(index, "_").concat(((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id),
                    title: (_item_title = item.title) === null || _item_title === void 0 ? void 0 : _item_title.value,
                    type: (_item_type = item.type) === null || _item_type === void 0 ? void 0 : (_item_type_value = _item_type.value) === null || _item_type_value === void 0 ? void 0 : _item_type_value.split("/").pop(),
                    file: (_item_format = item.format) === null || _item_format === void 0 ? void 0 : _item_format.value,
                    affiliation: ((_item_creator = item.creator) === null || _item_creator === void 0 ? void 0 : (_item_creator_value = _item_creator.value) === null || _item_creator_value === void 0 ? void 0 : _item_creator_value.split("/").pop()) || "",
                    summary: ((_item_description = item.description) === null || _item_description === void 0 ? void 0 : _item_description.value) || ((_item_subjects = item.subjects) === null || _item_subjects === void 0 ? void 0 : _item_subjects.value) || ((_item_subject = item.subject) === null || _item_subject === void 0 ? void 0 : (_item_subject_value = _item_subject.value) === null || _item_subject_value === void 0 ? void 0 : _item_subject_value.split("/").pop()) || "",
                    authors: ((_item_creator1 = item.creator) === null || _item_creator1 === void 0 ? void 0 : (_item_creator_value1 = _item_creator1.value) === null || _item_creator_value1 === void 0 ? void 0 : _item_creator_value1.split("/").pop()) || "",
                    tag: ((_item_subjects1 = item.subjects) === null || _item_subjects1 === void 0 ? void 0 : _item_subjects1.value) ? item.subjects.value.split(", ").map(function(s) {
                        return s.split("/").pop();
                    }).filter(Boolean) : ((_item_subject1 = item.subject) === null || _item_subject1 === void 0 ? void 0 : _item_subject1.value) ? [
                        item.subject.value.split("/").pop()
                    ] : [],
                    sparqlData: item,
                    originalId: ((_item_resource1 = item.resource) === null || _item_resource1 === void 0 ? void 0 : (_item_resource_value1 = _item_resource1.value) === null || _item_resource_value1 === void 0 ? void 0 : _item_resource_value1.split("/").pop()) || item.id
                };
            });
            return $29749cb926cab32d$var$Graph.graphData().nodes;
        }
    },
    watch: {
        searchMode: function(newMode, oldMode) {
            // Update URL when search mode changes
            (0, $fF3Ps.updateUrlParams)({
                mode: newMode,
                search: newMode === "normal" ? this.search.text : null,
                sparqlQuery: newMode === "sparql" ? this.customSparqlQuery : null,
                sparqlPreset: newMode === "sparql" ? this.selectedPresetQuery : null
            });
            // Clear SPARQL filters when switching to normal search mode
            if (newMode === "normal" && oldMode === "sparql" && this.sparqlFilters.active) this.clearSparqlFilters();
            // Clear active selections when switching modes
            if (newMode === "normal") this.activeSparqlId = null;
            else if (newMode === "sparql") // Keep activeId for potential graph highlighting
            // Clear activeSparqlId to start fresh
            this.activeSparqlId = null;
        }
    },
    mounted: function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.$nextTick()
                        ];
                    case 1:
                        _state.sent();
                        this.initGraph();
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    },
    beforeUnmount: function() {
        this.resizeObserver.disconnect();
    }
};

});
parcelRegister("b8tVf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $81b7a708f9d256b7$export$71511d61b312f219; });
function $81b7a708f9d256b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $81b7a708f9d256b7$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $81b7a708f9d256b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $81b7a708f9d256b7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("iT0je", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dbfd9a6fe7da2270$export$71511d61b312f219; });

var $cqEAj = parcelRequire("cqEAj");
function $dbfd9a6fe7da2270$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cqEAj._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("9N5UN", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $720d47411f53d0e9$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $720d47411f53d0e9$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $3KZcf = parcelRequire("3KZcf");
var $720d47411f53d0e9$var$extendStatics = function extendStatics1(d, b) {
    $720d47411f53d0e9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $720d47411f53d0e9$var$extendStatics(d, b);
};
function $720d47411f53d0e9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $720d47411f53d0e9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $720d47411f53d0e9$export$18ce0697a983be9b = function __assign1() {
    $720d47411f53d0e9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $720d47411f53d0e9$export$18ce0697a983be9b.apply(this, arguments);
};
function $720d47411f53d0e9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $720d47411f53d0e9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $3KZcf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $720d47411f53d0e9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $720d47411f53d0e9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $3KZcf._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $720d47411f53d0e9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $720d47411f53d0e9$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $3KZcf._)(x)) === "symbol" ? x : "".concat(x);
}
function $720d47411f53d0e9$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $3KZcf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $720d47411f53d0e9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $3KZcf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $720d47411f53d0e9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $720d47411f53d0e9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $720d47411f53d0e9$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $720d47411f53d0e9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $720d47411f53d0e9$export$45d3717a4c69092e(o, m, p);
}
function $720d47411f53d0e9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $720d47411f53d0e9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $720d47411f53d0e9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($720d47411f53d0e9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $720d47411f53d0e9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $720d47411f53d0e9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $720d47411f53d0e9$export$10c90e4f7922046c(v) {
    return this instanceof $720d47411f53d0e9$export$10c90e4f7922046c ? (this.v = v, this) : new $720d47411f53d0e9$export$10c90e4f7922046c(v);
}
function $720d47411f53d0e9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $720d47411f53d0e9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $720d47411f53d0e9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $720d47411f53d0e9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $720d47411f53d0e9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $720d47411f53d0e9$export$19a8beecd37a4c45 === "function" ? $720d47411f53d0e9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $720d47411f53d0e9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $720d47411f53d0e9$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $720d47411f53d0e9$var$ownKeys = function ownKeys1(o) {
    $720d47411f53d0e9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $720d47411f53d0e9$var$ownKeys(o);
};
function $720d47411f53d0e9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $720d47411f53d0e9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $720d47411f53d0e9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $720d47411f53d0e9$var$__setModuleDefault(result, mod);
    return result;
}
function $720d47411f53d0e9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $720d47411f53d0e9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $720d47411f53d0e9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $720d47411f53d0e9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $3KZcf._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $720d47411f53d0e9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $720d47411f53d0e9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $720d47411f53d0e9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $720d47411f53d0e9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $720d47411f53d0e9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $720d47411f53d0e9$export$2e2bcd8739ae039 = {
    __extends: $720d47411f53d0e9$export$a8ba968b8961cb8a,
    __assign: $720d47411f53d0e9$export$18ce0697a983be9b,
    __rest: $720d47411f53d0e9$export$3c9a16f847548506,
    __decorate: $720d47411f53d0e9$export$29e00dfd3077644b,
    __param: $720d47411f53d0e9$export$d5ad3fd78186038f,
    __esDecorate: $720d47411f53d0e9$export$3a84e1ae4e97e9b0,
    __runInitializers: $720d47411f53d0e9$export$d831c04e792af3d,
    __propKey: $720d47411f53d0e9$export$6a2a36740a146cb8,
    __setFunctionName: $720d47411f53d0e9$export$d1a06452d3489bc7,
    __metadata: $720d47411f53d0e9$export$f1db080c865becb9,
    __awaiter: $720d47411f53d0e9$export$1050f835b63b671e,
    __generator: $720d47411f53d0e9$export$67ebef60e6f28a6,
    __createBinding: $720d47411f53d0e9$export$45d3717a4c69092e,
    __exportStar: $720d47411f53d0e9$export$f33643c0debef087,
    __values: $720d47411f53d0e9$export$19a8beecd37a4c45,
    __read: $720d47411f53d0e9$export$8d051b38c9118094,
    __spread: $720d47411f53d0e9$export$afc72e2116322959,
    __spreadArrays: $720d47411f53d0e9$export$6388937ca91ccae8,
    __spreadArray: $720d47411f53d0e9$export$1216008129fb82ed,
    __await: $720d47411f53d0e9$export$10c90e4f7922046c,
    __asyncGenerator: $720d47411f53d0e9$export$e427f37a30a4de9b,
    __asyncDelegator: $720d47411f53d0e9$export$bbd80228419bb833,
    __asyncValues: $720d47411f53d0e9$export$e3b29a3d6162315f,
    __makeTemplateObject: $720d47411f53d0e9$export$4fb47efe1390b86f,
    __importStar: $720d47411f53d0e9$export$c21735bcef00d192,
    __importDefault: $720d47411f53d0e9$export$da59b14a69baef04,
    __classPrivateFieldGet: $720d47411f53d0e9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $720d47411f53d0e9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $720d47411f53d0e9$export$81fdc39f203e4e04,
    __addDisposableResource: $720d47411f53d0e9$export$88ac25d8e944e405,
    __disposeResources: $720d47411f53d0e9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $720d47411f53d0e9$export$889dfb5d17574b0b
};

});

parcelRegister("boq2B", function(module, exports) {

$parcel$export(module.exports, "Splitpanes", function () { return $84b622c867aa259f$export$51967b84567aeac2; });
$parcel$export(module.exports, "Pane", function () { return $84b622c867aa259f$export$fd2e1a4921eb839b; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $84b622c867aa259f$export$51967b84567aeac2 = {
    __name: "splitpanes",
    props: {
        horizontal: {
            type: Boolean,
            "default": !1
        },
        pushOtherPanes: {
            type: Boolean,
            "default": !0
        },
        maximizePanes: {
            type: Boolean,
            "default": !0
        },
        // Maximize pane on splitter double click/tap.
        rtl: {
            type: Boolean,
            "default": !1
        },
        // Right to left direction.
        firstSplitter: {
            type: Boolean,
            "default": !1
        }
    },
    emits: [
        "ready",
        "resize",
        "resized",
        "pane-click",
        "pane-maximize",
        "pane-add",
        "pane-remove",
        "splitter-click",
        "splitter-dblclick"
    ],
    setup: function(D, param) {
        var h = param.emit;
        var y = h, u = D, E = (0, $bu8yf.useSlots)(), l = (0, $hXmfK.ref)([]), M = (0, $hXmfK.computed)(function() {
            return l.value.reduce(function(e, n) {
                return (e[~~n.id] = n) && e;
            }, {});
        }), m = (0, $hXmfK.computed)(function() {
            return l.value.length;
        }), x = (0, $hXmfK.ref)(null), S = (0, $hXmfK.ref)(!1), c = (0, $hXmfK.ref)({
            mouseDown: !1,
            dragging: !1,
            activeSplitter: null,
            cursorOffset: 0
        }), f = (0, $hXmfK.ref)({
            // Used to detect double click on touch devices.
            splitter: null,
            timeoutId: null
        }), _ = (0, $hXmfK.computed)(function() {
            var _obj;
            return _obj = {}, (0, $cqEAj._)(_obj, "splitpanes splitpanes--".concat(u.horizontal ? "horizontal" : "vertical"), !0), (0, $cqEAj._)(_obj, "splitpanes--dragging", c.value.dragging), _obj;
        }), R = function() {
            document.addEventListener("mousemove", r, {
                passive: !1
            }), document.addEventListener("mouseup", P), "ontouchstart" in window && (document.addEventListener("touchmove", r, {
                passive: !1
            }), document.addEventListener("touchend", P));
        }, O = function() {
            document.removeEventListener("mousemove", r, {
                passive: !1
            }), document.removeEventListener("mouseup", P), "ontouchstart" in window && (document.removeEventListener("touchmove", r, {
                passive: !1
            }), document.removeEventListener("touchend", P));
        }, b = function(e, n) {
            var t = e.target.closest(".splitpanes__splitter");
            if (t) {
                var _t_getBoundingClientRect = t.getBoundingClientRect(), i = _t_getBoundingClientRect.left, a = _t_getBoundingClientRect.top, _ref = "ontouchstart" in window && e.touches ? e.touches[0] : e, s = _ref.clientX, o = _ref.clientY;
                c.value.cursorOffset = u.horizontal ? o - a : s - i;
            }
            R(), c.value.mouseDown = !0, c.value.activeSplitter = n;
        }, r = function(e) {
            c.value.mouseDown && (e.preventDefault(), c.value.dragging = !0, requestAnimationFrame(function() {
                K(I(e)), d("resize", {
                    event: e
                }, !0);
            }));
        }, P = function(e) {
            c.value.dragging && (window.getSelection().removeAllRanges(), d("resized", {
                event: e
            }, !0)), c.value.mouseDown = !1, c.value.activeSplitter = null, setTimeout(function() {
                c.value.dragging = !1, O();
            }, 100);
        }, A = function(e, n) {
            "ontouchstart" in window && (e.preventDefault(), f.value.splitter === n ? (clearTimeout(f.value.timeoutId), f.value.timeoutId = null, U(e, n), f.value.splitter = null) : (f.value.splitter = n, f.value.timeoutId = setTimeout(function() {
                return f.value.splitter = null;
            }, 500))), c.value.dragging || d("splitter-click", {
                event: e,
                index: n
            }, !0);
        }, U = function(e, n) {
            if (d("splitter-dblclick", {
                event: e,
                index: n
            }, !0), u.maximizePanes) {
                var t = 0;
                l.value = l.value.map(function(i, a) {
                    return i.size = a === n ? i.max : i.min, a !== n && (t += i.min), i;
                }), l.value[n].size -= t, d("pane-maximize", {
                    event: e,
                    index: n,
                    pane: l.value[n]
                }), d("resized", {
                    event: e,
                    index: n
                }, !0);
            }
        }, W = function(e, n) {
            d("pane-click", {
                event: e,
                index: M.value[n].index,
                pane: M.value[n]
            });
        }, I = function(e) {
            var n = x.value.getBoundingClientRect(), _ref = "ontouchstart" in window && e.touches ? e.touches[0] : e, t = _ref.clientX, i = _ref.clientY;
            return {
                x: t - (u.horizontal ? 0 : c.value.cursorOffset) - n.left,
                y: i - (u.horizontal ? c.value.cursorOffset : 0) - n.top
            };
        }, J = function(e) {
            e = e[u.horizontal ? "y" : "x"];
            var n = x.value[u.horizontal ? "clientHeight" : "clientWidth"];
            return u.rtl && !u.horizontal && (e = n - e), e * 100 / n;
        }, K = function(e) {
            var n = c.value.activeSplitter;
            var t = {
                prevPanesSize: $(n),
                nextPanesSize: N(n),
                prevReachedMinPanes: 0,
                nextReachedMinPanes: 0
            };
            var i = 0 + (u.pushOtherPanes ? 0 : t.prevPanesSize), a = 100 - (u.pushOtherPanes ? 0 : t.nextPanesSize), s = Math.max(Math.min(J(e), a), i);
            var o = [
                n,
                n + 1
            ], v = l.value[o[0]] || null, p = l.value[o[1]] || null;
            var H = v.max < 100 && s >= v.max + t.prevPanesSize, ue = p.max < 100 && s <= 100 - (p.max + N(n + 1));
            if (H || ue) {
                H ? (v.size = v.max, p.size = Math.max(100 - v.max - t.prevPanesSize - t.nextPanesSize, 0)) : (v.size = Math.max(100 - p.max - t.prevPanesSize - N(n + 1), 0), p.size = p.max);
                return;
            }
            if (u.pushOtherPanes) {
                var j = Q(t, s);
                if (!j) return;
                var ref;
                ref = j, t = ref.sums, o = ref.panesToResize, ref, v = l.value[o[0]] || null, p = l.value[o[1]] || null;
            }
            v !== null && (v.size = Math.min(Math.max(s - t.prevPanesSize - t.prevReachedMinPanes, v.min), v.max)), p !== null && (p.size = Math.min(Math.max(100 - s - t.nextPanesSize - t.nextReachedMinPanes, p.min), p.max));
        }, Q = function(e, n) {
            var t = c.value.activeSplitter, i = [
                t,
                t + 1
            ];
            return n < e.prevPanesSize + l.value[i[0]].min && (i[0] = V(t).index, e.prevReachedMinPanes = 0, i[0] < t && l.value.forEach(function(a, s) {
                s > i[0] && s <= t && (a.size = a.min, e.prevReachedMinPanes += a.min);
            }), e.prevPanesSize = $(i[0]), i[0] === void 0) ? (e.prevReachedMinPanes = 0, l.value[0].size = l.value[0].min, l.value.forEach(function(a, s) {
                s > 0 && s <= t && (a.size = a.min, e.prevReachedMinPanes += a.min);
            }), l.value[i[1]].size = 100 - e.prevReachedMinPanes - l.value[0].min - e.prevPanesSize - e.nextPanesSize, null) : n > 100 - e.nextPanesSize - l.value[i[1]].min && (i[1] = Z(t).index, e.nextReachedMinPanes = 0, i[1] > t + 1 && l.value.forEach(function(a, s) {
                s > t && s < i[1] && (a.size = a.min, e.nextReachedMinPanes += a.min);
            }), e.nextPanesSize = N(i[1] - 1), i[1] === void 0) ? (e.nextReachedMinPanes = 0, l.value.forEach(function(a, s) {
                s < m.value - 1 && s >= t + 1 && (a.size = a.min, e.nextReachedMinPanes += a.min);
            }), l.value[i[0]].size = 100 - e.prevPanesSize - N(i[0] - 1), null) : {
                sums: e,
                panesToResize: i
            };
        }, $ = function(e) {
            return l.value.reduce(function(n, t, i) {
                return n + (i < e ? t.size : 0);
            }, 0);
        }, N = function(e) {
            return l.value.reduce(function(n, t, i) {
                return n + (i > e + 1 ? t.size : 0);
            }, 0);
        }, V = function(e) {
            return (0, $7WNf6._)(l.value).reverse().find(function(t) {
                return t.index < e && t.size > t.min;
            }) || {};
        }, Z = function(e) {
            return l.value.find(function(t) {
                return t.index > e + 1 && t.size > t.min;
            }) || {};
        }, ee = function() {
            var n;
            var e = Array.from(((n = x.value) == null ? void 0 : n.children) || []);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    var i = t.classList.contains("splitpanes__pane"), a = t.classList.contains("splitpanes__splitter");
                    !i && !a && (t.remove(), console.warn("Splitpanes: Only <pane> elements are allowed at the root of <splitpanes>. One of your DOM nodes was removed."));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, F = function(e, n) {
            var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            var i = e - 1, a = document.createElement("div");
            a.classList.add("splitpanes__splitter"), t || (a.onmousedown = function(s) {
                return b(s, i);
            }, (typeof window === "undefined" ? "undefined" : (0, $3KZcf._)(window)) < "u" && "ontouchstart" in window && (a.ontouchstart = function(s) {
                return b(s, i);
            }), a.onclick = function(s) {
                return A(s, i + 1);
            }), a.ondblclick = function(s) {
                return U(s, i + 1);
            }, n.parentNode.insertBefore(a, n);
        }, ne = function(e) {
            e.onmousedown = void 0, e.onclick = void 0, e.ondblclick = void 0, e.remove();
        }, C = function() {
            var t;
            var e = Array.from(((t = x.value) == null ? void 0 : t.children) || []);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    i.className.includes("splitpanes__splitter") && ne(i);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var n = 0;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var i1 = _step1.value;
                    i1.className.includes("splitpanes__pane") && (!n && u.firstSplitter ? F(n, i1, !0) : n && F(n, i1), n++);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }, ie = function(_param) {
            var e = _param.uid, n = (0, $g79Gh._)(_param, [
                "uid"
            ]);
            var t = M.value[e];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], a = _step_value[1];
                    t[i] = a;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, te = function(e) {
            var t;
            var n = -1;
            Array.from(((t = x.value) == null ? void 0 : t.children) || []).some(function(i) {
                return i.className.includes("splitpanes__pane") && n++, i.isSameNode(e.el);
            }), l.value.splice(n, 0, (0, $emQHU._)((0, $iT0je._)({}, e), {
                index: n
            })), l.value.forEach(function(i, a) {
                return i.index = a;
            }), S.value && (0, $bu8yf.nextTick)(function() {
                C(), L({
                    addedPane: l.value[n]
                }), d("pane-add", {
                    pane: l.value[n]
                });
            });
        }, ae = function(e) {
            var n = l.value.findIndex(function(i) {
                return i.id === e;
            });
            l.value[n].el = null;
            var t = l.value.splice(n, 1)[0];
            l.value.forEach(function(i, a) {
                return i.index = a;
            }), (0, $bu8yf.nextTick)(function() {
                C(), d("pane-remove", {
                    pane: t
                }), L({
                    removedPane: (0, $iT0je._)({}, t)
                });
            });
        }, L = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            !e.addedPane && !e.removedPane ? le() : l.value.some(function(n) {
                return n.givenSize !== null || n.min || n.max < 100;
            }) ? oe(e) : se(), S.value && d("resized");
        }, se = function() {
            var e = 100 / m.value;
            var n = 0;
            var t = [], i = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = l.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    a.size = Math.max(Math.min(e, a.max), a.min), n -= a.size, a.size >= a.max && t.push(a.id), a.size <= a.min && i.push(a.id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            n > 0.1 && q(n, t, i);
        }, le = function() {
            var e = 100;
            var n = [], t = [];
            var i = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = l.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var s = _step.value;
                    e -= s.size, s.givenSize !== null && i++, s.size >= s.max && n.push(s.id), s.size <= s.min && t.push(s.id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var a = 100;
            if (e > 0.1) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = l.value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var s1 = _step1.value;
                        s1.givenSize === null && (s1.size = Math.max(Math.min(e / (m.value - i), s1.max), s1.min)), a -= s1.size;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                a > 0.1 && q(a, n, t);
            }
        }, oe = function() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _ref.addedPane, n = _ref.removedPane;
            var t = 100 / m.value, i = 0;
            var a = [], s = [];
            var _ref1;
            ((_ref1 = e == null ? void 0 : e.givenSize) !== null && _ref1 !== void 0 ? _ref1 : null) !== null && (t = (100 - e.givenSize) / (m.value - 1));
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = l.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    i -= o.size, o.size >= o.max && a.push(o.id), o.size <= o.min && s.push(o.id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!(Math.abs(i) < 0.1)) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = l.value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var o1 = _step1.value;
                        (e == null ? void 0 : e.givenSize) !== null && (e == null ? void 0 : e.id) === o1.id || (o1.size = Math.max(Math.min(t, o1.max), o1.min)), i -= o1.size, o1.size >= o1.max && a.push(o1.id), o1.size <= o1.min && s.push(o1.id);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                i > 0.1 && q(i, a, s);
            }
        }, q = function(e, n, t) {
            var i;
            e > 0 ? i = e / (m.value - n.length) : i = e / (m.value - t.length), l.value.forEach(function(a, s) {
                if (e > 0 && !n.includes(a.id)) {
                    var o = Math.max(Math.min(a.size + i, a.max), a.min), v = o - a.size;
                    e -= v, a.size = o;
                } else if (!t.includes(a.id)) {
                    var o1 = Math.max(Math.min(a.size + i, a.max), a.min), v1 = o1 - a.size;
                    e -= v1, a.size = o1;
                }
            }), Math.abs(e) > 0.1 && (0, $bu8yf.nextTick)(function() {
                S.value && console.warn("Splitpanes: Could not resize panes correctly due to their constraints.");
            });
        }, d = function(e, n) {
            var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            var _ref, _ref1;
            var i = (_ref1 = (_ref = n == null ? void 0 : n.index) !== null && _ref !== void 0 ? _ref : c.value.activeSplitter) !== null && _ref1 !== void 0 ? _ref1 : null;
            y(e, (0, $emQHU._)((0, $iT0je._)({}, n, i !== null && {
                index: i
            }, t && i !== null && {
                prevPane: l.value[i - (u.firstSplitter ? 1 : 0)],
                nextPane: l.value[i + (u.firstSplitter ? 0 : 1)]
            }), {
                panes: l.value.map(function(a) {
                    return {
                        min: a.min,
                        max: a.max,
                        size: a.size
                    };
                })
            }));
        };
        (0, $hXmfK.watch)(function() {
            return u.firstSplitter;
        }, function() {
            return C();
        }), (0, $bu8yf.onMounted)(function() {
            ee(), C(), L(), d("ready"), S.value = !0;
        }), (0, $bu8yf.onBeforeUnmount)(function() {
            return S.value = !1;
        });
        var re = function() {
            var e;
            return (0, $bu8yf.h)("div", {
                ref: x,
                "class": _.value
            }, (e = E["default"]) == null ? void 0 : e.call(E));
        };
        return (0, $bu8yf.provide)("panes", l), (0, $bu8yf.provide)("indexedPanes", M), (0, $bu8yf.provide)("horizontal", (0, $hXmfK.computed)(function() {
            return u.horizontal;
        })), (0, $bu8yf.provide)("requestUpdate", ie), (0, $bu8yf.provide)("onPaneAdd", te), (0, $bu8yf.provide)("onPaneRemove", ae), (0, $bu8yf.provide)("onPaneClick", W), function(e, n) {
            return (0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)((0, $bu8yf.resolveDynamicComponent)(re));
        };
    }
}, $84b622c867aa259f$export$fd2e1a4921eb839b = {
    __name: "pane",
    props: {
        size: {
            type: [
                Number,
                String
            ]
        },
        minSize: {
            type: [
                Number,
                String
            ],
            "default": 0
        },
        maxSize: {
            type: [
                Number,
                String
            ],
            "default": 100
        }
    },
    setup: function(D) {
        var b;
        var h = D, y = (0, $bu8yf.inject)("requestUpdate"), u = (0, $bu8yf.inject)("onPaneAdd"), E = (0, $bu8yf.inject)("horizontal"), l = (0, $bu8yf.inject)("onPaneRemove"), M = (0, $bu8yf.inject)("onPaneClick"), m = (b = (0, $bu8yf.getCurrentInstance)()) == null ? void 0 : b.uid, x = (0, $bu8yf.inject)("indexedPanes"), S = (0, $hXmfK.computed)(function() {
            return x.value[m];
        }), c = (0, $hXmfK.ref)(null), f = (0, $hXmfK.computed)(function() {
            var r = isNaN(h.size) || h.size === void 0 ? 0 : parseFloat(h.size);
            return Math.max(Math.min(r, R.value), _.value);
        }), _ = (0, $hXmfK.computed)(function() {
            var r = parseFloat(h.minSize);
            return isNaN(r) ? 0 : r;
        }), R = (0, $hXmfK.computed)(function() {
            var r = parseFloat(h.maxSize);
            return isNaN(r) ? 100 : r;
        }), O = (0, $hXmfK.computed)(function() {
            var r;
            return "".concat(E.value ? "height" : "width", ": ").concat((r = S.value) == null ? void 0 : r.size, "%");
        });
        return (0, $hXmfK.watch)(function() {
            return f.value;
        }, function(r) {
            return y({
                uid: m,
                size: r
            });
        }), (0, $hXmfK.watch)(function() {
            return _.value;
        }, function(r) {
            return y({
                uid: m,
                min: r
            });
        }), (0, $hXmfK.watch)(function() {
            return R.value;
        }, function(r) {
            return y({
                uid: m,
                max: r
            });
        }), (0, $bu8yf.onMounted)(function() {
            u({
                id: m,
                el: c.value,
                min: _.value,
                max: R.value,
                // The given size (useful to know the user intention).
                givenSize: h.size === void 0 ? null : f.value,
                size: f.value
            });
        }), (0, $bu8yf.onBeforeUnmount)(function() {
            return l(m);
        }), function(r, P) {
            return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("div", {
                ref_key: "paneEl",
                ref: c,
                "class": "splitpanes__pane",
                onClick: P[0] || (P[0] = function(A) {
                    return (0, $hXmfK.unref)(M)(A, r._.uid);
                }),
                style: (0, $d8jBh.normalizeStyle)(O.value)
            }, [
                (0, $bu8yf.renderSlot)(r.$slots, "default")
            ], 4);
        };
    }
};

});
parcelRegister("emQHU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a75c0154605dfc5a$export$71511d61b312f219; });
function $a75c0154605dfc5a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a75c0154605dfc5a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a75c0154605dfc5a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("g79Gh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bbb4cf3c938e8df9$export$71511d61b312f219; });

var $aSdJS = parcelRequire("aSdJS");
function $bbb4cf3c938e8df9$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $aSdJS._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("aSdJS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7ea99acb6a72f775$export$71511d61b312f219; });
function $7ea99acb6a72f775$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("4D2TE", function(module, exports) {
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("d8jBh")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("d8jBh")).capitalize; });
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("bu8yf")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("bu8yf")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("bu8yf")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("bu8yf")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("bu8yf")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("bu8yf")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("bu8yf")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("bu8yf")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("bu8yf")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("bu8yf")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("bu8yf")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("bu8yf")).getCurrentInstance; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("bu8yf")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("bu8yf")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("bu8yf")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("bu8yf")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("hXmfK")).isRef; });
$parcel$export(module.exports, "isVNode", function () { return (parcelRequire("bu8yf")).isVNode; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("hXmfK")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("bu8yf")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("bu8yf")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("d8jBh")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("d8jBh")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("bu8yf")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("bu8yf")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("bu8yf")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("bu8yf")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("bu8yf")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("bu8yf")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("bu8yf")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("bu8yf")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("bu8yf")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("bu8yf")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("hXmfK")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("hXmfK")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("bu8yf")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("bu8yf")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("bu8yf")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("bu8yf")).resolveDynamicComponent; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("hXmfK")).shallowRef; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("bu8yf")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("bu8yf")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("hXmfK")).toRaw; });
$parcel$export(module.exports, "useId", function () { return (parcelRequire("bu8yf")).useId; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("bu8yf")).useSlots; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("bu8yf")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("bu8yf")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("bu8yf")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("bu8yf")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("bu8yf")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("kiZwI")).createApp; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("kiZwI")).render; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("kiZwI")).Transition; });
$parcel$export(module.exports, "TransitionGroup", function () { return (parcelRequire("kiZwI")).TransitionGroup; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("kiZwI")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("kiZwI")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("kiZwI")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("kiZwI")).withModifiers; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("d8jBh")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("d8jBh")).toDisplayString; });
/**
* vue v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $bu8yf = parcelRequire("bu8yf");parcelRequire("kiZwI");
var $hXmfK = parcelRequire("hXmfK");parcelRequire("d8jBh");
function $35ed0d22f95dc159$var$initDev() {
    (0, $bu8yf.initCustomFormatter)();
}
var $35ed0d22f95dc159$export$ef7acd7185315e22 = function() {};
$parcel$exportWildcard(module.exports, $hXmfK);

});
parcelRegister("bu8yf", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $85c9212bd0e76cc3$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $85c9212bd0e76cc3$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $85c9212bd0e76cc3$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $85c9212bd0e76cc3$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $85c9212bd0e76cc3$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $85c9212bd0e76cc3$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "withCtx", function () { return $85c9212bd0e76cc3$export$694b237e827a3d23; });
$parcel$export(module.exports, "withDirectives", function () { return $85c9212bd0e76cc3$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "Teleport", function () { return $85c9212bd0e76cc3$export$76d55a0304a371f4; });
$parcel$export(module.exports, "useTransitionState", function () { return $85c9212bd0e76cc3$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $85c9212bd0e76cc3$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $85c9212bd0e76cc3$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $85c9212bd0e76cc3$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $85c9212bd0e76cc3$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $85c9212bd0e76cc3$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $85c9212bd0e76cc3$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $85c9212bd0e76cc3$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $85c9212bd0e76cc3$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "cloneVNode", function () { return $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "defineComponent", function () { return $85c9212bd0e76cc3$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "useId", function () { return $85c9212bd0e76cc3$export$f680877a34711e37; });
$parcel$export(module.exports, "createVNode", function () { return $85c9212bd0e76cc3$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $85c9212bd0e76cc3$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "watch", function () { return $85c9212bd0e76cc3$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "onUpdated", function () { return $85c9212bd0e76cc3$export$5876c47052fb88b1; });
$parcel$export(module.exports, "isVNode", function () { return $85c9212bd0e76cc3$export$3868d13f8734ae81; });
$parcel$export(module.exports, "onActivated", function () { return $85c9212bd0e76cc3$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $85c9212bd0e76cc3$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $85c9212bd0e76cc3$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $85c9212bd0e76cc3$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $85c9212bd0e76cc3$export$ab91988a13872e4c; });
$parcel$export(module.exports, "resolveComponent", function () { return $85c9212bd0e76cc3$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $85c9212bd0e76cc3$export$b44c564a05ca975; });
$parcel$export(module.exports, "renderList", function () { return $85c9212bd0e76cc3$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "renderSlot", function () { return $85c9212bd0e76cc3$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $85c9212bd0e76cc3$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $85c9212bd0e76cc3$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "useSlots", function () { return $85c9212bd0e76cc3$export$9203a8e84125433c; });
$parcel$export(module.exports, "computed", function () { return $85c9212bd0e76cc3$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $85c9212bd0e76cc3$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $85c9212bd0e76cc3$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createRenderer", function () { return $85c9212bd0e76cc3$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $85c9212bd0e76cc3$export$200524cf0d997ff0; });
$parcel$export(module.exports, "watchEffect", function () { return $85c9212bd0e76cc3$export$ede35fc0e5500309; });
$parcel$export(module.exports, "createElementBlock", function () { return $85c9212bd0e76cc3$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $85c9212bd0e76cc3$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $85c9212bd0e76cc3$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $85c9212bd0e76cc3$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createCommentVNode", function () { return $85c9212bd0e76cc3$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $85c9212bd0e76cc3$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $85c9212bd0e76cc3$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $85c9212bd0e76cc3$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $85c9212bd0e76cc3$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("hXmfK")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("hXmfK")).markRaw; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("hXmfK")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("hXmfK")).ref; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("hXmfK")).shallowRef; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("hXmfK")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("d8jBh")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("d8jBh")).capitalize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("d8jBh")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("d8jBh")).normalizeStyle; });
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $hXmfK = parcelRequire("hXmfK");

var $d8jBh = parcelRequire("d8jBh");
var $85c9212bd0e76cc3$var$stack = [];
function $85c9212bd0e76cc3$var$pushWarningContext(vnode) {
    $85c9212bd0e76cc3$var$stack.push(vnode);
}
function $85c9212bd0e76cc3$var$popWarningContext() {
    $85c9212bd0e76cc3$var$stack.pop();
}
var $85c9212bd0e76cc3$var$isWarning = false;
function $85c9212bd0e76cc3$var$warn$1(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if ($85c9212bd0e76cc3$var$isWarning) return;
    $85c9212bd0e76cc3$var$isWarning = true;
    (0, $hXmfK.pauseTracking)();
    var instance = $85c9212bd0e76cc3$var$stack.length ? $85c9212bd0e76cc3$var$stack[$85c9212bd0e76cc3$var$stack.length - 1].component : null;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = $85c9212bd0e76cc3$var$getComponentTrace();
    if (appWarnHandler) $85c9212bd0e76cc3$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map(function(a) {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(function(param) {
            var vnode = param.vnode;
            return "at <".concat($85c9212bd0e76cc3$var$formatComponentName(instance, vnode.type), ">");
        }).join("\n"),
        trace
    ]);
    else {
        var _warnArgs, _console;
        var warnArgs = [
            "[Vue warn]: ".concat(msg)
        ].concat((0, $7WNf6._)(args));
        if (trace.length && // avoid spamming console during tests
        true) (_warnArgs = warnArgs).push.apply(_warnArgs, [
            "\n"
        ].concat((0, $7WNf6._)($85c9212bd0e76cc3$var$formatTrace(trace))));
        (_console = console).warn.apply(_console, (0, $7WNf6._)(warnArgs));
    }
    (0, $hXmfK.resetTracking)();
    $85c9212bd0e76cc3$var$isWarning = false;
}
function $85c9212bd0e76cc3$var$getComponentTrace() {
    var currentVNode = $85c9212bd0e76cc3$var$stack[$85c9212bd0e76cc3$var$stack.length - 1];
    if (!currentVNode) return [];
    var normalizedStack = [];
    while(currentVNode){
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $85c9212bd0e76cc3$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $7WNf6._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $7WNf6._)($85c9212bd0e76cc3$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $85c9212bd0e76cc3$var$formatTraceEntry(param) {
    var vnode = param.vnode, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat($85c9212bd0e76cc3$var$formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? [
        open
    ].concat((0, $7WNf6._)($85c9212bd0e76cc3$var$formatProps(vnode.props)), [
        close
    ]) : [
        open + close
    ];
}
function $85c9212bd0e76cc3$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $7WNf6._)($85c9212bd0e76cc3$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
function $85c9212bd0e76cc3$var$formatProp(key, value, raw) {
    if ((0, $d8jBh.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            "".concat(key, "=").concat(value)
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        "".concat(key, "=").concat(value)
    ];
    else if ((0, $hXmfK.isRef)(value)) {
        value = $85c9212bd0e76cc3$var$formatProp(key, (0, $hXmfK.toRaw)(value.value), true);
        return raw ? value : [
            "".concat(key, "=Ref<"),
            value,
            ">"
        ];
    } else if ((0, $d8jBh.isFunction)(value)) return [
        "".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")
    ];
    else {
        value = (0, $hXmfK.toRaw)(value);
        return raw ? value : [
            "".concat(key, "="),
            value
        ];
    }
}
function $85c9212bd0e76cc3$export$dfbcecb440255e4a(val, type) {
    return;
}
var $85c9212bd0e76cc3$export$10e8e1cf990558d7 = {
    SETUP_FUNCTION: 0,
    "0": "SETUP_FUNCTION",
    RENDER_FUNCTION: 1,
    "1": "RENDER_FUNCTION",
    NATIVE_EVENT_HANDLER: 5,
    "5": "NATIVE_EVENT_HANDLER",
    COMPONENT_EVENT_HANDLER: 6,
    "6": "COMPONENT_EVENT_HANDLER",
    VNODE_HOOK: 7,
    "7": "VNODE_HOOK",
    DIRECTIVE_HOOK: 8,
    "8": "DIRECTIVE_HOOK",
    TRANSITION_HOOK: 9,
    "9": "TRANSITION_HOOK",
    APP_ERROR_HANDLER: 10,
    "10": "APP_ERROR_HANDLER",
    APP_WARN_HANDLER: 11,
    "11": "APP_WARN_HANDLER",
    FUNCTION_REF: 12,
    "12": "FUNCTION_REF",
    ASYNC_COMPONENT_LOADER: 13,
    "13": "ASYNC_COMPONENT_LOADER",
    SCHEDULER: 14,
    "14": "SCHEDULER",
    COMPONENT_UPDATE: 15,
    "15": "COMPONENT_UPDATE",
    APP_UNMOUNT_CLEANUP: 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
var $85c9212bd0e76cc3$var$_obj;
var $85c9212bd0e76cc3$var$ErrorTypeStrings$1 = ($85c9212bd0e76cc3$var$_obj = {}, (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "sp", "serverPrefetch hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "bc", "beforeCreate hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "c", "created hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "bm", "beforeMount hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "m", "mounted hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "bu", "beforeUpdate hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "u", "updated"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "bum", "beforeUnmount hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "um", "unmounted hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "a", "activated hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "da", "deactivated hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "ec", "errorCaptured hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "rtc", "renderTracked hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, "rtg", "renderTriggered hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 0, "setup function"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 1, "render function"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 2, "watcher getter"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 3, "watcher callback"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 4, "watcher cleanup function"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 5, "native event handler"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 6, "component event handler"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 7, "vnode hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 8, "directive hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 9, "transition hook"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 10, "app errorHandler"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 11, "app warnHandler"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 12, "ref function"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 13, "async component loader"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 14, "scheduler flush"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 15, "component update"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj, 16, "app unmount cleanup function"), $85c9212bd0e76cc3$var$_obj);
function $85c9212bd0e76cc3$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn.apply(void 0, (0, $7WNf6._)(args)) : fn();
    } catch (err) {
        $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $85c9212bd0e76cc3$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $d8jBh.isFunction)(fn)) {
        var res = $85c9212bd0e76cc3$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $d8jBh.isPromise)(res)) res["catch"](function(err) {
            $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $d8jBh.isArray)(fn)) {
        var values = [];
        for(var i = 0; i < fn.length; i++)values.push($85c9212bd0e76cc3$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var contextVNode = instance ? instance.vnode : null;
    var _ref = instance && instance.appContext.config || (0, $d8jBh.EMPTY_OBJ), errorHandler = _ref.errorHandler, throwUnhandledErrorInProduction = _ref.throwUnhandledErrorInProduction;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy;
        var errorInfo = "https://vuejs.org/error-reference/#runtime-".concat(type);
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(var i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $hXmfK.pauseTracking)();
            $85c9212bd0e76cc3$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $hXmfK.resetTracking)();
            return;
        }
    }
    $85c9212bd0e76cc3$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $85c9212bd0e76cc3$var$logError(err, type, contextVNode) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, throwInProd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (throwInProd) throw err;
    else console.error(err);
}
var $85c9212bd0e76cc3$var$queue = [];
var $85c9212bd0e76cc3$var$flushIndex = -1;
var $85c9212bd0e76cc3$var$pendingPostFlushCbs = [];
var $85c9212bd0e76cc3$var$activePostFlushCbs = null;
var $85c9212bd0e76cc3$var$postFlushIndex = 0;
var $85c9212bd0e76cc3$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
var $85c9212bd0e76cc3$var$currentFlushPromise = null;
var $85c9212bd0e76cc3$var$RECURSION_LIMIT = 100;
function $85c9212bd0e76cc3$export$bdd553fddd433dcb(fn) {
    var p = $85c9212bd0e76cc3$var$currentFlushPromise || $85c9212bd0e76cc3$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $85c9212bd0e76cc3$var$findInsertionIndex(id) {
    var start = $85c9212bd0e76cc3$var$flushIndex + 1;
    var end = $85c9212bd0e76cc3$var$queue.length;
    while(start < end){
        var middle = start + end >>> 1;
        var middleJob = $85c9212bd0e76cc3$var$queue[middle];
        var middleJobId = $85c9212bd0e76cc3$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $85c9212bd0e76cc3$var$queueJob(job) {
    if (!(job.flags & 1)) {
        var jobId = $85c9212bd0e76cc3$var$getId(job);
        var lastJob = $85c9212bd0e76cc3$var$queue[$85c9212bd0e76cc3$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $85c9212bd0e76cc3$var$getId(lastJob)) $85c9212bd0e76cc3$var$queue.push(job);
        else $85c9212bd0e76cc3$var$queue.splice($85c9212bd0e76cc3$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $85c9212bd0e76cc3$var$queueFlush();
    }
}
function $85c9212bd0e76cc3$var$queueFlush() {
    if (!$85c9212bd0e76cc3$var$currentFlushPromise) $85c9212bd0e76cc3$var$currentFlushPromise = $85c9212bd0e76cc3$var$resolvedPromise.then($85c9212bd0e76cc3$var$flushJobs);
}
function $85c9212bd0e76cc3$export$59536a0199721cab(cb) {
    var _pendingPostFlushCbs;
    if (!(0, $d8jBh.isArray)(cb)) {
        if ($85c9212bd0e76cc3$var$activePostFlushCbs && cb.id === -1) $85c9212bd0e76cc3$var$activePostFlushCbs.splice($85c9212bd0e76cc3$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $85c9212bd0e76cc3$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else (_pendingPostFlushCbs = $85c9212bd0e76cc3$var$pendingPostFlushCbs).push.apply(_pendingPostFlushCbs, (0, $7WNf6._)(cb));
    $85c9212bd0e76cc3$var$queueFlush();
}
function $85c9212bd0e76cc3$var$flushPreFlushCbs(instance, seen) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $85c9212bd0e76cc3$var$flushIndex + 1;
    for(; i < $85c9212bd0e76cc3$var$queue.length; i++){
        var cb = $85c9212bd0e76cc3$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $85c9212bd0e76cc3$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $85c9212bd0e76cc3$var$flushPostFlushCbs(seen) {
    if ($85c9212bd0e76cc3$var$pendingPostFlushCbs.length) {
        var deduped = (0, $7WNf6._)(new Set($85c9212bd0e76cc3$var$pendingPostFlushCbs)).sort(function(a, b) {
            return $85c9212bd0e76cc3$var$getId(a) - $85c9212bd0e76cc3$var$getId(b);
        });
        $85c9212bd0e76cc3$var$pendingPostFlushCbs.length = 0;
        if ($85c9212bd0e76cc3$var$activePostFlushCbs) {
            var _activePostFlushCbs;
            (_activePostFlushCbs = $85c9212bd0e76cc3$var$activePostFlushCbs).push.apply(_activePostFlushCbs, (0, $7WNf6._)(deduped));
            return;
        }
        $85c9212bd0e76cc3$var$activePostFlushCbs = deduped;
        for($85c9212bd0e76cc3$var$postFlushIndex = 0; $85c9212bd0e76cc3$var$postFlushIndex < $85c9212bd0e76cc3$var$activePostFlushCbs.length; $85c9212bd0e76cc3$var$postFlushIndex++){
            var cb = $85c9212bd0e76cc3$var$activePostFlushCbs[$85c9212bd0e76cc3$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $85c9212bd0e76cc3$var$activePostFlushCbs = null;
        $85c9212bd0e76cc3$var$postFlushIndex = 0;
    }
}
var $85c9212bd0e76cc3$var$getId = function(job) {
    return job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
};
function $85c9212bd0e76cc3$var$flushJobs(seen) {
    var check = (0, $d8jBh.NOOP);
    try {
        for($85c9212bd0e76cc3$var$flushIndex = 0; $85c9212bd0e76cc3$var$flushIndex < $85c9212bd0e76cc3$var$queue.length; $85c9212bd0e76cc3$var$flushIndex++){
            var job = $85c9212bd0e76cc3$var$queue[$85c9212bd0e76cc3$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $85c9212bd0e76cc3$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $85c9212bd0e76cc3$var$flushIndex < $85c9212bd0e76cc3$var$queue.length; $85c9212bd0e76cc3$var$flushIndex++){
            var job1 = $85c9212bd0e76cc3$var$queue[$85c9212bd0e76cc3$var$flushIndex];
            if (job1) job1.flags &= -2;
        }
        $85c9212bd0e76cc3$var$flushIndex = -1;
        $85c9212bd0e76cc3$var$queue.length = 0;
        $85c9212bd0e76cc3$var$flushPostFlushCbs(seen);
        $85c9212bd0e76cc3$var$currentFlushPromise = null;
        if ($85c9212bd0e76cc3$var$queue.length || $85c9212bd0e76cc3$var$pendingPostFlushCbs.length) $85c9212bd0e76cc3$var$flushJobs(seen);
    }
}
function $85c9212bd0e76cc3$var$checkRecursiveUpdates(seen, fn) {
    var count = seen.get(fn) || 0;
    if (count > $85c9212bd0e76cc3$var$RECURSION_LIMIT) {
        var instance = fn.i;
        var componentName = instance && $85c9212bd0e76cc3$var$getComponentName(instance.type);
        $85c9212bd0e76cc3$export$d3da1ecaf1206c58("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."), null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
var $85c9212bd0e76cc3$var$isHmrUpdating = false;
var $85c9212bd0e76cc3$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
var $85c9212bd0e76cc3$var$map = /* @__PURE__ */ new Map();
function $85c9212bd0e76cc3$var$registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = $85c9212bd0e76cc3$var$map.get(id);
    if (!record) {
        $85c9212bd0e76cc3$var$createRecord(id, instance.type);
        record = $85c9212bd0e76cc3$var$map.get(id);
    }
    record.instances.add(instance);
}
function $85c9212bd0e76cc3$var$unregisterHMR(instance) {
    $85c9212bd0e76cc3$var$map.get(instance.type.__hmrId).instances["delete"](instance);
}
function $85c9212bd0e76cc3$var$createRecord(id, initialDef) {
    if ($85c9212bd0e76cc3$var$map.has(id)) return false;
    $85c9212bd0e76cc3$var$map.set(id, {
        initialDef: $85c9212bd0e76cc3$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $85c9212bd0e76cc3$var$normalizeClassComponent(component) {
    return $85c9212bd0e76cc3$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $85c9212bd0e76cc3$var$rerender(id, newRender) {
    var record = $85c9212bd0e76cc3$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    (0, $7WNf6._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $85c9212bd0e76cc3$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $85c9212bd0e76cc3$var$isHmrUpdating = true;
        instance.update();
        $85c9212bd0e76cc3$var$isHmrUpdating = false;
    });
}
function $85c9212bd0e76cc3$var$reload(id, newComp) {
    var _loop = function(i) {
        var instance = instances[i];
        var oldComp = $85c9212bd0e76cc3$var$normalizeClassComponent(instance.type);
        var dirtyInstances = $85c9212bd0e76cc3$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $85c9212bd0e76cc3$var$updateComponentDef(oldComp, newComp);
            $85c9212bd0e76cc3$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache["delete"](instance.type);
        instance.appContext.emitsCache["delete"](instance.type);
        instance.appContext.optionsCache["delete"](instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances["delete"](instance);
        } else if (instance.parent) $85c9212bd0e76cc3$var$queueJob(function() {
            $85c9212bd0e76cc3$var$isHmrUpdating = true;
            instance.parent.update();
            $85c9212bd0e76cc3$var$isHmrUpdating = false;
            dirtyInstances["delete"](instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    };
    var record = $85c9212bd0e76cc3$var$map.get(id);
    if (!record) return;
    newComp = $85c9212bd0e76cc3$var$normalizeClassComponent(newComp);
    $85c9212bd0e76cc3$var$updateComponentDef(record.initialDef, newComp);
    var instances = (0, $7WNf6._)(record.instances);
    for(var i = 0; i < instances.length; i++)_loop(i);
    $85c9212bd0e76cc3$export$59536a0199721cab(function() {
        $85c9212bd0e76cc3$var$hmrDirtyComponents.clear();
    });
}
function $85c9212bd0e76cc3$var$updateComponentDef(oldComp, newComp) {
    (0, $d8jBh.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $85c9212bd0e76cc3$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
var $85c9212bd0e76cc3$var$devtools$1;
var $85c9212bd0e76cc3$var$buffer = [];
var $85c9212bd0e76cc3$var$devtoolsNotInstalled = false;
function $85c9212bd0e76cc3$var$emit$1(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools$1;
    if ($85c9212bd0e76cc3$var$devtools$1) (_devtools$1 = $85c9212bd0e76cc3$var$devtools$1).emit.apply(_devtools$1, [
        event
    ].concat((0, $7WNf6._)(args)));
    else if (!$85c9212bd0e76cc3$var$devtoolsNotInstalled) $85c9212bd0e76cc3$var$buffer.push({
        event: event,
        args: args
    });
}
function $85c9212bd0e76cc3$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $85c9212bd0e76cc3$var$devtools$1 = hook;
    if ($85c9212bd0e76cc3$var$devtools$1) {
        var _devtools$1;
        $85c9212bd0e76cc3$var$devtools$1.enabled = true;
        $85c9212bd0e76cc3$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools$1 = $85c9212bd0e76cc3$var$devtools$1).emit.apply(_devtools$1, [
                event
            ].concat((0, $7WNf6._)(args)));
        });
        $85c9212bd0e76cc3$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function(newHook) {
            $85c9212bd0e76cc3$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(function() {
            if (!$85c9212bd0e76cc3$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $85c9212bd0e76cc3$var$devtoolsNotInstalled = true;
                $85c9212bd0e76cc3$var$buffer = [];
            }
        }, 3e3);
    } else {
        $85c9212bd0e76cc3$var$devtoolsNotInstalled = true;
        $85c9212bd0e76cc3$var$buffer = [];
    }
}
function $85c9212bd0e76cc3$var$devtoolsInitApp(app, version) {
    $85c9212bd0e76cc3$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $85c9212bd0e76cc3$export$ffb0004e005737fa,
        Text: $85c9212bd0e76cc3$export$5f1af8db9871e1d6,
        Comment: $85c9212bd0e76cc3$export$4d299b491347818a,
        Static: $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6
    });
}
function $85c9212bd0e76cc3$var$devtoolsUnmountApp(app) {
    $85c9212bd0e76cc3$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
var $85c9212bd0e76cc3$var$devtoolsComponentAdded = /* @__PURE__ */ $85c9212bd0e76cc3$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
var $85c9212bd0e76cc3$var$devtoolsComponentUpdated = /* @__PURE__ */ $85c9212bd0e76cc3$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
var $85c9212bd0e76cc3$var$_devtoolsComponentRemoved = /* @__PURE__ */ $85c9212bd0e76cc3$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
var $85c9212bd0e76cc3$var$devtoolsComponentRemoved = function(component) {
    if ($85c9212bd0e76cc3$var$devtools$1 && typeof $85c9212bd0e76cc3$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$85c9212bd0e76cc3$var$devtools$1.cleanupBuffer(component)) $85c9212bd0e76cc3$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $85c9212bd0e76cc3$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $85c9212bd0e76cc3$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var $85c9212bd0e76cc3$var$devtoolsPerfStart = /* @__PURE__ */ $85c9212bd0e76cc3$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
var $85c9212bd0e76cc3$var$devtoolsPerfEnd = /* @__PURE__ */ $85c9212bd0e76cc3$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $85c9212bd0e76cc3$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $85c9212bd0e76cc3$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $85c9212bd0e76cc3$var$devtoolsComponentEmit(component, event, params) {
    $85c9212bd0e76cc3$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
var $85c9212bd0e76cc3$var$currentRenderingInstance = null;
var $85c9212bd0e76cc3$var$currentScopeId = null;
function $85c9212bd0e76cc3$var$setCurrentRenderingInstance(instance) {
    var prev = $85c9212bd0e76cc3$var$currentRenderingInstance;
    $85c9212bd0e76cc3$var$currentRenderingInstance = instance;
    $85c9212bd0e76cc3$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $85c9212bd0e76cc3$export$ac020265ca2cc4cd(id) {
    $85c9212bd0e76cc3$var$currentScopeId = id;
}
function $85c9212bd0e76cc3$export$f2dc6805dc11834e() {
    $85c9212bd0e76cc3$var$currentScopeId = null;
}
var $85c9212bd0e76cc3$export$15ba313e13f3dd04 = function(_id) {
    return $85c9212bd0e76cc3$export$694b237e827a3d23;
};
function $85c9212bd0e76cc3$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $85c9212bd0e76cc3$var$currentRenderingInstance, isNonScopedSlot = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (renderFnWithContext._d) $85c9212bd0e76cc3$export$c20bee82f26f1e27(-1);
        var prevInstance = $85c9212bd0e76cc3$var$setCurrentRenderingInstance(ctx);
        var res;
        try {
            res = fn.apply(void 0, (0, $7WNf6._)(args));
        } finally{
            $85c9212bd0e76cc3$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $85c9212bd0e76cc3$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $85c9212bd0e76cc3$var$validateDirectiveName(name) {
    if ((0, $d8jBh.isBuiltInDirective)(name)) $85c9212bd0e76cc3$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $85c9212bd0e76cc3$export$49729353e7c1e6c5(vnode, directives) {
    if ($85c9212bd0e76cc3$var$currentRenderingInstance === null) return vnode;
    var instance = $85c9212bd0e76cc3$var$getComponentPublicInstance($85c9212bd0e76cc3$var$currentRenderingInstance);
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $32TW8._)(directives[i], 4), dir = _directives_i[0], value = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $d8jBh.EMPTY_OBJ) : tmp;
        if (dir) {
            if ((0, $d8jBh.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $hXmfK.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            (0, $hXmfK.pauseTracking)();
            $85c9212bd0e76cc3$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $hXmfK.resetTracking)();
        }
    }
}
var $85c9212bd0e76cc3$var$TeleportEndKey = Symbol("_vte");
var $85c9212bd0e76cc3$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $85c9212bd0e76cc3$var$isTeleportDisabled = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $85c9212bd0e76cc3$var$isTeleportDeferred = function(props) {
    return props && (props.defer || props.defer === "");
};
var $85c9212bd0e76cc3$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $85c9212bd0e76cc3$var$isTargetMathML = function(target) {
    return typeof MathMLElement === "function" && target instanceof MathMLElement;
};
var $85c9212bd0e76cc3$var$resolveTarget = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $d8jBh.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
var $85c9212bd0e76cc3$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment;
        var disabled = $85c9212bd0e76cc3$var$isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (n1 == null) {
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var mount = function(container2, anchor2) {
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            var mountToTarget = function() {
                var target = n2.target = $85c9212bd0e76cc3$var$resolveTarget(n2.props, querySelector);
                var targetAnchor = $85c9212bd0e76cc3$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $85c9212bd0e76cc3$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $85c9212bd0e76cc3$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $85c9212bd0e76cc3$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $85c9212bd0e76cc3$var$updateCssVars(n2, true);
            }
            if ($85c9212bd0e76cc3$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($85c9212bd0e76cc3$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                    $85c9212bd0e76cc3$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var target = n2.target = n1.target;
            var targetAnchor = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $85c9212bd0e76cc3$var$isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor;
            if (namespace === "svg" || $85c9212bd0e76cc3$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $85c9212bd0e76cc3$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $85c9212bd0e76cc3$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $85c9212bd0e76cc3$var$moveTeleport(n2, container, mainAnchor1, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = $85c9212bd0e76cc3$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $85c9212bd0e76cc3$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $85c9212bd0e76cc3$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $85c9212bd0e76cc3$var$updateCssVars(n2, disabled);
        }
    },
    remove: function(vnode, parentComponent, parentSuspense, param, doRemove) {
        var unmount = param.um, _param_o = param.o, hostRemove = _param_o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetStart = vnode.targetStart, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            var shouldRemove = doRemove || !$85c9212bd0e76cc3$var$isTeleportDisabled(props);
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $85c9212bd0e76cc3$var$moveTeleport,
    hydrate: $85c9212bd0e76cc3$var$hydrateTeleport
};
function $85c9212bd0e76cc3$var$moveTeleport(vnode, container, parentAnchor, param) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $85c9212bd0e76cc3$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $85c9212bd0e76cc3$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector, insert = _param_o.insert, createText = _param_o.createText;
    var target = vnode.target = $85c9212bd0e76cc3$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        var disabled = $85c9212bd0e76cc3$var$isTeleportDisabled(vnode.props);
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                var targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $85c9212bd0e76cc3$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $85c9212bd0e76cc3$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var $85c9212bd0e76cc3$export$76d55a0304a371f4 = $85c9212bd0e76cc3$var$TeleportImpl;
function $85c9212bd0e76cc3$var$updateCssVars(vnode, isDisabled) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $85c9212bd0e76cc3$var$prepareAnchor(target, vnode, createText, insert) {
    var targetStart = vnode.targetStart = createText("");
    var targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$85c9212bd0e76cc3$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
var $85c9212bd0e76cc3$var$leaveCbKey = Symbol("_leaveCb");
var $85c9212bd0e76cc3$var$enterCbKey = Symbol("_enterCb");
function $85c9212bd0e76cc3$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $85c9212bd0e76cc3$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $85c9212bd0e76cc3$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $85c9212bd0e76cc3$var$TransitionHookValidator = [
    Function,
    Array
];
var $85c9212bd0e76cc3$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onEnter: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onAfterEnter: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onEnterCancelled: $85c9212bd0e76cc3$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onLeave: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onAfterLeave: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onLeaveCancelled: $85c9212bd0e76cc3$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onAppear: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onAfterAppear: $85c9212bd0e76cc3$var$TransitionHookValidator,
    onAppearCancelled: $85c9212bd0e76cc3$var$TransitionHookValidator
};
var $85c9212bd0e76cc3$var$recursiveGetSubtree = function(instance) {
    var subTree = instance.subTree;
    return subTree.component ? $85c9212bd0e76cc3$var$recursiveGetSubtree(subTree.component) : subTree;
};
var $85c9212bd0e76cc3$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: $85c9212bd0e76cc3$export$b876c99684f8cf3b,
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $85c9212bd0e76cc3$export$f13e630aa3915748();
        var state = $85c9212bd0e76cc3$export$d2a0a1bc267c90f6();
        return function() {
            var children = slots["default"] && $85c9212bd0e76cc3$export$a67f9b1229c7c97a(slots["default"](), true);
            if (!children || !children.length) return;
            var child = $85c9212bd0e76cc3$var$findNonCommentChild(children);
            var rawProps = (0, $hXmfK.toRaw)(props);
            var mode = rawProps.mode;
            if (state.isLeaving) return $85c9212bd0e76cc3$var$emptyPlaceholder(child);
            var innerChild = $85c9212bd0e76cc3$var$getInnerChild$1(child);
            if (!innerChild) return $85c9212bd0e76cc3$var$emptyPlaceholder(child);
            var enterHooks = $85c9212bd0e76cc3$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            function(hooks) {
                return enterHooks = hooks;
            });
            if (innerChild.type !== $85c9212bd0e76cc3$export$4d299b491347818a) $85c9212bd0e76cc3$export$7770a22486565649(innerChild, enterHooks);
            var oldInnerChild = instance.subTree && $85c9212bd0e76cc3$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $85c9212bd0e76cc3$export$4d299b491347818a && !$85c9212bd0e76cc3$var$isSameVNodeType(innerChild, oldInnerChild) && $85c9212bd0e76cc3$var$recursiveGetSubtree(instance).type !== $85c9212bd0e76cc3$export$4d299b491347818a) {
                var leavingHooks = $85c9212bd0e76cc3$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $85c9212bd0e76cc3$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $85c9212bd0e76cc3$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = function() {
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $85c9212bd0e76cc3$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $85c9212bd0e76cc3$export$4d299b491347818a) leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
                    var leavingVNodesCache = $85c9212bd0e76cc3$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$85c9212bd0e76cc3$var$leaveCbKey] = function() {
                        earlyRemove();
                        el[$85c9212bd0e76cc3$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = function() {
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $85c9212bd0e76cc3$var$findNonCommentChild(children) {
    var child = children[0];
    if (children.length > 1) {
        var hasFound = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                if (c.type !== $85c9212bd0e76cc3$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return child;
}
var $85c9212bd0e76cc3$export$abd95b5f5e8a8837 = $85c9212bd0e76cc3$var$BaseTransitionImpl;
function $85c9212bd0e76cc3$var$getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $85c9212bd0e76cc3$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = $85c9212bd0e76cc3$var$getLeavingNodesForType(state, vnode);
    var callHook = function(hook, args) {
        hook && $85c9212bd0e76cc3$export$dae85862a8d94378(hook, instance, 9, args);
    };
    var callAsyncHook = function(hook, args) {
        var done = args[1];
        callHook(hook, args);
        if ((0, $d8jBh.isArray)(hook)) {
            if (hook.every(function(hook2) {
                return hook2.length <= 1;
            })) done();
        } else if (hook.length <= 1) done();
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$85c9212bd0e76cc3$var$leaveCbKey]) el[$85c9212bd0e76cc3$var$leaveCbKey](true);
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $85c9212bd0e76cc3$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$85c9212bd0e76cc3$var$leaveCbKey]) leavingVNode.el[$85c9212bd0e76cc3$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            var done = el[$85c9212bd0e76cc3$var$enterCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$85c9212bd0e76cc3$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave: function(el, remove) {
            var key2 = String(vnode.key);
            if (el[$85c9212bd0e76cc3$var$enterCbKey]) el[$85c9212bd0e76cc3$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            var done = el[$85c9212bd0e76cc3$var$leaveCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$85c9212bd0e76cc3$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone: function(vnode2) {
            var hooks2 = $85c9212bd0e76cc3$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $85c9212bd0e76cc3$var$emptyPlaceholder(vnode) {
    if ($85c9212bd0e76cc3$var$isKeepAlive(vnode)) {
        vnode = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $85c9212bd0e76cc3$var$getInnerChild$1(vnode) {
    if (!$85c9212bd0e76cc3$var$isKeepAlive(vnode)) {
        if ($85c9212bd0e76cc3$var$isTeleport(vnode.type) && vnode.children) return $85c9212bd0e76cc3$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $d8jBh.isFunction)(children["default"])) return children["default"]();
    }
}
function $85c9212bd0e76cc3$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $85c9212bd0e76cc3$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $85c9212bd0e76cc3$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, parentKey = arguments.length > 2 ? arguments[2] : void 0;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $85c9212bd0e76cc3$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($85c9212bd0e76cc3$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $85c9212bd0e76cc3$export$4d299b491347818a) ret.push(key != null ? $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $85c9212bd0e76cc3$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $d8jBh.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ function() {
        return (0, $d8jBh.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        });
    }() : options;
}
function $85c9212bd0e76cc3$export$f680877a34711e37() {
    var i = $85c9212bd0e76cc3$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $85c9212bd0e76cc3$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
var $85c9212bd0e76cc3$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $85c9212bd0e76cc3$export$83a5dbc1f35517ca(key) {
    var i = $85c9212bd0e76cc3$export$f13e630aa3915748();
    var r = (0, $hXmfK.shallowRef)(null);
    if (i) {
        var refs = i.refs === (0, $d8jBh.EMPTY_OBJ) ? i.refs = {} : i.refs;
        var desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: function() {
                return r.value;
            },
            set: function(val) {
                return r.value = val;
            }
        });
    }
    var ret = r;
    return ret;
}
function $85c9212bd0e76cc3$var$setRef(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $d8jBh.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $85c9212bd0e76cc3$var$setRef(r, oldRawRef && ((0, $d8jBh.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($85c9212bd0e76cc3$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $85c9212bd0e76cc3$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    var refValue = vnode.shapeFlag & 4 ? $85c9212bd0e76cc3$var$getComponentPublicInstance(vnode.component) : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $d8jBh.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    var rawSetupState = (0, $hXmfK.toRaw)(setupState);
    var canSetSetupRef = setupState === (0, $d8jBh.EMPTY_OBJ) ? function() {
        return false;
    } : function(key) {
        return (0, $d8jBh.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $d8jBh.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $hXmfK.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $d8jBh.isFunction)(ref)) $85c9212bd0e76cc3$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        var _isString = (0, $d8jBh.isString)(ref);
        var _isRef = (0, $hXmfK.isRef)(ref);
        if (_isString || _isRef) {
            var doSet = function() {
                if (rawRef.f) {
                    var existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $d8jBh.isArray)(existing) && (0, $d8jBh.remove)(existing, refValue);
                    else {
                        if (!(0, $d8jBh.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $85c9212bd0e76cc3$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
var $85c9212bd0e76cc3$var$hasLoggedMismatchError = false;
var $85c9212bd0e76cc3$var$logMismatchError = function() {
    if ($85c9212bd0e76cc3$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $85c9212bd0e76cc3$var$hasLoggedMismatchError = true;
};
var $85c9212bd0e76cc3$var$isSVGContainer = function(container) {
    return container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
};
var $85c9212bd0e76cc3$var$isMathMLContainer = function(container) {
    return container.namespaceURI.includes("MathML");
};
var $85c9212bd0e76cc3$var$getContainerType = function(container) {
    if (container.nodeType !== 1) return void 0;
    if ($85c9212bd0e76cc3$var$isSVGContainer(container)) return "svg";
    if ($85c9212bd0e76cc3$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
var $85c9212bd0e76cc3$var$isComment = function(node) {
    return node.nodeType === 8;
};
function $85c9212bd0e76cc3$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, createText = _rendererInternals_o.createText, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $85c9212bd0e76cc3$var$warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            $85c9212bd0e76cc3$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $85c9212bd0e76cc3$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        optimized = optimized || !!vnode.dynamicChildren;
        var isFragmentStart = $85c9212bd0e76cc3$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $d8jBh.def)(node, "__vnode", vnode, true);
            (0, $d8jBh.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch(type){
            case $85c9212bd0e76cc3$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $85c9212bd0e76cc3$var$warn$1("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(vnode.children)));
                        $85c9212bd0e76cc3$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $85c9212bd0e76cc3$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $85c9212bd0e76cc3$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($85c9212bd0e76cc3$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$getContainerType(container), optimized);
                    if ($85c9212bd0e76cc3$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        var subTree;
                        if (isFragmentStart) {
                            subTree = $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $85c9212bd0e76cc3$export$22f9b5ffd89dac9("") : $85c9212bd0e76cc3$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $85c9212bd0e76cc3$var$warn$1("Invalid HostVNode type:", type, "(".concat(typeof type === "undefined" ? "undefined" : (0, $3KZcf._)(type), ")"));
        }
        if (ref != null) $85c9212bd0e76cc3$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs, transition = vnode.transition;
        var forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            var needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $85c9212bd0e76cc3$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                var content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    var cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned = false;
                while(next){
                    if (!$85c9212bd0e76cc3$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $85c9212bd0e76cc3$var$warn$1("Hydration children mismatch on", el, "\nServer rendered element contains more child nodes than client vdom.");
                            hasWarned = true;
                        }
                        $85c9212bd0e76cc3$var$logMismatchError();
                    }
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                var clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$85c9212bd0e76cc3$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $85c9212bd0e76cc3$var$warn$1("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(el.textContent, "\n  - expected on client: ").concat(vnode.children));
                        $85c9212bd0e76cc3$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    var isCustomElement = el.tagName.includes("-");
                    for(var key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some(function(d) {
                            return d.dir.created;
                        })) && $85c9212bd0e76cc3$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $85c9212bd0e76cc3$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $d8jBh.isOn)(key) && !(0, $d8jBh.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $hXmfK.isReactive)(props.style)) for(var key1 in props.style)props.style[key1];
            }
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $85c9212bd0e76cc3$var$queueEffectWithSuspense(function() {
                vnodeHooks && $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $85c9212bd0e76cc3$var$normalizeVNode(children[i]);
            var isText = vnode.type === $85c9212bd0e76cc3$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $85c9212bd0e76cc3$var$normalizeVNode(children[i + 1]).type === $85c9212bd0e76cc3$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$85c9212bd0e76cc3$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $85c9212bd0e76cc3$var$warn$1("Hydration children mismatch on", container, "\nServer rendered element contains fewer child nodes than client vdom.");
                        hasWarned = true;
                    }
                    $85c9212bd0e76cc3$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $85c9212bd0e76cc3$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $85c9212bd0e76cc3$var$logMismatchError();
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        if (!$85c9212bd0e76cc3$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $85c9212bd0e76cc3$var$warn$1("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 ? "(text)" : $85c9212bd0e76cc3$var$isComment(node) && node.data === "[" ? "(start of fragment)" : "", "\n- expected on client:", vnode.type);
            $85c9212bd0e76cc3$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAnchor(node);
            while(true){
                var next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        var next = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $85c9212bd0e76cc3$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    var locateClosingAnchor = function(node) {
        var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[", close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "]";
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $85c9212bd0e76cc3$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    var replaceNode = function(newNode, oldNode, parentComponent) {
        var parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        var parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    var isTemplateNode = function(node) {
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $85c9212bd0e76cc3$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var mismatchType;
    var mismatchKey;
    var actual;
    var expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $d8jBh.normalizeClass)(clientValue);
        if (!$85c9212bd0e76cc3$var$isSetEqual($85c9212bd0e76cc3$var$toClassSet(actual || ""), $85c9212bd0e76cc3$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = "class";
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $d8jBh.isString)(clientValue) ? clientValue : (0, $d8jBh.stringifyStyle)((0, $d8jBh.normalizeStyle)(clientValue));
        var actualMap = $85c9212bd0e76cc3$var$toStyleMap(actual);
        var expectedMap = $85c9212bd0e76cc3$var$toStyleMap(expected);
        if (vnode.dirs) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = vnode.dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, dir = _step_value.dir, value = _step_value.value;
                    if (dir.name === "show" && !value) expectedMap.set("display", "none");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (instance) $85c9212bd0e76cc3$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$85c9212bd0e76cc3$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $d8jBh.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $d8jBh.isBooleanAttr)(key) || (0, $d8jBh.isKnownHtmlAttr)(key))) {
        if ((0, $d8jBh.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $d8jBh.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $d8jBh.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$85c9212bd0e76cc3$var$isMismatchAllowed(el, mismatchType)) {
        var format = function(v1) {
            return v1 === false ? "(not rendered)" : "".concat(mismatchKey, '="').concat(v1, '"');
        };
        var preSegment = "Hydration ".concat($85c9212bd0e76cc3$var$MismatchTypeString[mismatchType], " mismatch on");
        var postSegment = "\n  - rendered on server: ".concat(format(actual), "\n  - expected on client: ").concat(format(expected), "\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch.");
        $85c9212bd0e76cc3$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $85c9212bd0e76cc3$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $85c9212bd0e76cc3$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!b.has(s)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $85c9212bd0e76cc3$var$toStyleMap(str) {
    var styleMap = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item_split = (0, $32TW8._)(item.split(":"), 2), key = _item_split[0], value = _item_split[1];
            key = key.trim();
            value = value && value.trim();
            if (key && value) styleMap.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return styleMap;
}
function $85c9212bd0e76cc3$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== b.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $85c9212bd0e76cc3$var$resolveCssVars(instance, vnode, expectedMap) {
    var root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $85c9212bd0e76cc3$export$ffb0004e005737fa && root.children.includes(vnode))) {
        var cssVars = instance.getCssVars();
        for(var key in cssVars){
            var value = (0, $d8jBh.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set("--".concat((0, $d8jBh.getEscapedCssVarName)(key, false)), value);
        }
    }
    if (vnode === root && instance.parent) $85c9212bd0e76cc3$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
var $85c9212bd0e76cc3$var$allowMismatchAttr = "data-allow-mismatch";
var $85c9212bd0e76cc3$var$_obj1;
var $85c9212bd0e76cc3$var$MismatchTypeString = ($85c9212bd0e76cc3$var$_obj1 = {}, (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj1, 0 /* TEXT */ , "text"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj1, 1 /* CHILDREN */ , "children"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj1, 2 /* CLASS */ , "class"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj1, 3 /* STYLE */ , "style"), (0, $cqEAj._)($85c9212bd0e76cc3$var$_obj1, 4 /* ATTRIBUTE */ , "attribute"), $85c9212bd0e76cc3$var$_obj1);
function $85c9212bd0e76cc3$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($85c9212bd0e76cc3$var$allowMismatchAttr))el = el.parentElement;
    var allowedAttr = el && el.getAttribute($85c9212bd0e76cc3$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        var list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($85c9212bd0e76cc3$var$MismatchTypeString[allowedType]);
    }
}
var $85c9212bd0e76cc3$var$requestIdleCallback = (0, $d8jBh.getGlobalThis)().requestIdleCallback || function(cb) {
    return setTimeout(cb, 1);
};
var $85c9212bd0e76cc3$var$cancelIdleCallback = (0, $d8jBh.getGlobalThis)().cancelIdleCallback || function(id) {
    return clearTimeout(id);
};
var $85c9212bd0e76cc3$export$8bfca283fd254627 = function() {
    var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e4;
    return function(hydrate) {
        var id = $85c9212bd0e76cc3$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return function() {
            return $85c9212bd0e76cc3$var$cancelIdleCallback(id);
        };
    };
};
function $85c9212bd0e76cc3$var$elementIsVisibleInViewport(el) {
    var _el_getBoundingClientRect = el.getBoundingClientRect(), top = _el_getBoundingClientRect.top, left = _el_getBoundingClientRect.left, bottom = _el_getBoundingClientRect.bottom, right = _el_getBoundingClientRect.right;
    var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
var $85c9212bd0e76cc3$export$2b04cd335e660930 = function(opts) {
    return function(hydrate, forEach) {
        var ob = new IntersectionObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    if (!e.isIntersecting) continue;
                    ob.disconnect();
                    hydrate();
                    break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, opts);
        forEach(function(el) {
            if (!(el instanceof Element)) return;
            if ($85c9212bd0e76cc3$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return function() {
            return ob.disconnect();
        };
    };
};
var $85c9212bd0e76cc3$export$804dbb6002787b74 = function(query) {
    return function(hydrate) {
        if (query) {
            var mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return function() {
                    return mql.removeEventListener("change", hydrate);
                };
            }
        }
    };
};
var $85c9212bd0e76cc3$export$288f5a9b4248e114 = function() {
    var interactions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function(hydrate, forEach) {
        if ((0, $d8jBh.isString)(interactions)) interactions = [
            interactions
        ];
        var hasHydrated = false;
        var doHydrate = function(e) {
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        var teardown = function() {
            forEach(function(el) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        el.removeEventListener(i, doHydrate);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        };
        forEach(function(el) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    el.addEventListener(i, doHydrate, {
                        once: true
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        return teardown;
    };
};
function $85c9212bd0e76cc3$var$forEachElement(node, cb) {
    if ($85c9212bd0e76cc3$var$isComment(node) && node.data === "[") {
        var depth = 1;
        var next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                var result = cb(next);
                if (result === false) break;
            } else if ($85c9212bd0e76cc3$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
var $85c9212bd0e76cc3$var$isAsyncWrapper = function(i) {
    return !!i.type.__asyncLoader;
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $85c9212bd0e76cc3$export$d75d499b4c16cf21(source) {
    if ((0, $d8jBh.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _source_delay = source.delay, delay = _source_delay === void 0 ? 200 : _source_delay, hydrateStrategy = source.hydrate, timeout = source.timeout, _source_suspensible = source.// undefined = never times out
    suspensible, suspensible = _source_suspensible === void 0 ? true : _source_suspensible, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader()["catch"](function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp["default"];
            resolvedComp = comp;
            return comp;
        }));
    };
    return $85c9212bd0e76cc3$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate: function(el, instance, hydrate) {
            var patched = false;
            (instance.bu || (instance.bu = [])).push(function() {
                return patched = true;
            });
            var performHydrate = function() {
                if (patched) return;
                hydrate();
            };
            var doHydrate = hydrateStrategy ? function() {
                var teardown = hydrateStrategy(performHydrate, function(cb) {
                    return $85c9212bd0e76cc3$var$forEachElement(el, cb);
                });
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(function() {
                return !instance.isUnmounted && doHydrate();
            });
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup: function() {
            var instance = $85c9212bd0e76cc3$var$currentInstance;
            $85c9212bd0e76cc3$var$markAsyncBoundary(instance);
            if (resolvedComp) return function() {
                return $85c9212bd0e76cc3$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                pendingRequest = null;
                $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $85c9212bd0e76cc3$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $85c9212bd0e76cc3$var$createInnerComp(comp, instance);
                };
            })["catch"](function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $85c9212bd0e76cc3$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var loaded = (0, $hXmfK.ref)(false);
            var error = (0, $hXmfK.ref)();
            var delayed = (0, $hXmfK.ref)(!!delay);
            if (delay) setTimeout(function() {
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(function() {
                if (!loaded.value && !error.value) {
                    var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(function() {
                loaded.value = true;
                if (instance.parent && $85c9212bd0e76cc3$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            })["catch"](function(err) {
                onError(err);
                error.value = err;
            });
            return function() {
                if (loaded.value && resolvedComp) return $85c9212bd0e76cc3$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $85c9212bd0e76cc3$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $85c9212bd0e76cc3$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $85c9212bd0e76cc3$var$createInnerComp(comp, parent) {
    var _parent_vnode = parent.vnode, ref2 = _parent_vnode.ref, props = _parent_vnode.props, children = _parent_vnode.children, ce = _parent_vnode.ce;
    var vnode = $85c9212bd0e76cc3$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
var $85c9212bd0e76cc3$var$isKeepAlive = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $85c9212bd0e76cc3$var$KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $85c9212bd0e76cc3$export$f13e630aa3915748();
        var sharedContext = instance.ctx;
        if (!sharedContext.renderer) return function() {
            var children = slots["default"] && slots["default"]();
            return children && children.length === 1 ? children[0] : children;
        };
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        var parentSuspense = instance.suspense;
        var _sharedContext_renderer = sharedContext.renderer, patch = _sharedContext_renderer.p, move = _sharedContext_renderer.m, _unmount = _sharedContext_renderer.um, createElement = _sharedContext_renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function(vnode, container, anchor, namespace, optimized) {
            var instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                instance2.isDeactivated = false;
                if (instance2.a) (0, $d8jBh.invokeArrayFns)(instance2.a);
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = function(vnode) {
            var instance2 = vnode.component;
            $85c9212bd0e76cc3$var$invalidateMount(instance2.m);
            $85c9212bd0e76cc3$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                if (instance2.da) (0, $d8jBh.invokeArrayFns)(instance2.da);
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $85c9212bd0e76cc3$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $85c9212bd0e76cc3$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (cached && (!current || !$85c9212bd0e76cc3$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $85c9212bd0e76cc3$var$resetShapeFlag(current);
            cache["delete"](key);
            keys["delete"](key);
        }
        $85c9212bd0e76cc3$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $32TW8._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $85c9212bd0e76cc3$var$matches(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$85c9212bd0e76cc3$var$matches(exclude, name);
            });
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            if (pendingCacheKey != null) {
                if ($85c9212bd0e76cc3$var$isSuspense(instance.subTree.type)) $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                    cache.set(pendingCacheKey, $85c9212bd0e76cc3$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $85c9212bd0e76cc3$var$getInnerChild(instance.subTree));
            }
        };
        $85c9212bd0e76cc3$export$6d1641039221b5cb(cacheSubtree);
        $85c9212bd0e76cc3$export$5876c47052fb88b1(cacheSubtree);
        $85c9212bd0e76cc3$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = $85c9212bd0e76cc3$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $85c9212bd0e76cc3$var$resetShapeFlag(vnode);
                    var da = vnode.component.da;
                    da && $85c9212bd0e76cc3$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots["default"]) return current = null;
            var children = slots["default"]();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$85c9212bd0e76cc3$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = $85c9212bd0e76cc3$var$getInnerChild(rawVNode);
            if (vnode.type === $85c9212bd0e76cc3$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            var comp = vnode.type;
            var name = $85c9212bd0e76cc3$var$getComponentName($85c9212bd0e76cc3$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$85c9212bd0e76cc3$var$matches(include, name)) || exclude && name && $85c9212bd0e76cc3$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $85c9212bd0e76cc3$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys["delete"](key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $85c9212bd0e76cc3$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
var $85c9212bd0e76cc3$export$70eb8a58709972df = $85c9212bd0e76cc3$var$KeepAliveImpl;
function $85c9212bd0e76cc3$var$matches(pattern, name) {
    if ((0, $d8jBh.isArray)(pattern)) return pattern.some(function(p) {
        return $85c9212bd0e76cc3$var$matches(p, name);
    });
    else if ((0, $d8jBh.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $d8jBh.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $85c9212bd0e76cc3$export$ba52d824b95a2154(hook, target) {
    $85c9212bd0e76cc3$var$registerKeepAliveHook(hook, "a", target);
}
function $85c9212bd0e76cc3$export$bf1440eeaf5fa709(hook, target) {
    $85c9212bd0e76cc3$var$registerKeepAliveHook(hook, "da", target);
}
function $85c9212bd0e76cc3$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $85c9212bd0e76cc3$var$currentInstance;
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $85c9212bd0e76cc3$var$injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            if ($85c9212bd0e76cc3$var$isKeepAlive(current.parent.vnode)) $85c9212bd0e76cc3$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $85c9212bd0e76cc3$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = $85c9212bd0e76cc3$var$injectHook(type, hook, keepAliveRoot, true);
    $85c9212bd0e76cc3$export$13348a43ccacfe58(function() {
        (0, $d8jBh.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $85c9212bd0e76cc3$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $85c9212bd0e76cc3$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $85c9212bd0e76cc3$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $85c9212bd0e76cc3$var$currentInstance, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $hXmfK.pauseTracking)();
            var reset = $85c9212bd0e76cc3$var$setCurrentInstance(target);
            var res = $85c9212bd0e76cc3$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $hXmfK.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $85c9212bd0e76cc3$var$createHook = function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $85c9212bd0e76cc3$var$currentInstance;
        if (!$85c9212bd0e76cc3$var$isInSSRComponentSetup || lifecycle === "sp") $85c9212bd0e76cc3$var$injectHook(lifecycle, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return hook.apply(void 0, (0, $7WNf6._)(args));
        }, target);
    };
};
var $85c9212bd0e76cc3$export$23b7aeb0d671f804 = $85c9212bd0e76cc3$var$createHook("bm");
var $85c9212bd0e76cc3$export$6d1641039221b5cb = $85c9212bd0e76cc3$var$createHook("m");
var $85c9212bd0e76cc3$export$ab91988a13872e4c = $85c9212bd0e76cc3$var$createHook("bu");
var $85c9212bd0e76cc3$export$5876c47052fb88b1 = $85c9212bd0e76cc3$var$createHook("u");
var $85c9212bd0e76cc3$export$40c420df62d2614 = $85c9212bd0e76cc3$var$createHook("bum");
var $85c9212bd0e76cc3$export$13348a43ccacfe58 = $85c9212bd0e76cc3$var$createHook("um");
var $85c9212bd0e76cc3$export$ebf0c601f267bceb = $85c9212bd0e76cc3$var$createHook("sp");
var $85c9212bd0e76cc3$export$898295a813d662eb = $85c9212bd0e76cc3$var$createHook("rtg");
var $85c9212bd0e76cc3$export$2b41f4235363e921 = $85c9212bd0e76cc3$var$createHook("rtc");
function $85c9212bd0e76cc3$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $85c9212bd0e76cc3$var$currentInstance;
    $85c9212bd0e76cc3$var$injectHook("ec", hook, target);
}
var $85c9212bd0e76cc3$var$COMPONENTS = "components";
var $85c9212bd0e76cc3$var$DIRECTIVES = "directives";
function $85c9212bd0e76cc3$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $85c9212bd0e76cc3$var$resolveAsset($85c9212bd0e76cc3$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
var $85c9212bd0e76cc3$var$NULL_DYNAMIC_COMPONENT = Symbol["for"]("v-ndc");
function $85c9212bd0e76cc3$export$b44c564a05ca975(component) {
    if ((0, $d8jBh.isString)(component)) return $85c9212bd0e76cc3$var$resolveAsset($85c9212bd0e76cc3$var$COMPONENTS, component, false) || component;
    else return component || $85c9212bd0e76cc3$var$NULL_DYNAMIC_COMPONENT;
}
function $85c9212bd0e76cc3$export$a1989e995cd481be(name) {
    return $85c9212bd0e76cc3$var$resolveAsset($85c9212bd0e76cc3$var$DIRECTIVES, name);
}
function $85c9212bd0e76cc3$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $85c9212bd0e76cc3$var$currentRenderingInstance || $85c9212bd0e76cc3$var$currentInstance;
    if (instance) {
        var Component = instance.type;
        if (type === $85c9212bd0e76cc3$var$COMPONENTS) {
            var selfName = $85c9212bd0e76cc3$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $d8jBh.camelize)(name) || selfName === (0, $d8jBh.capitalize)((0, $d8jBh.camelize)(name)))) return Component;
        }
        var res = // local registration
        // check instance[type] first which is resolved for options API
        $85c9212bd0e76cc3$var$resolve(instance[type] || Component[type], name) || // global registration
        $85c9212bd0e76cc3$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $85c9212bd0e76cc3$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $d8jBh.camelize)(name)] || registry[(0, $d8jBh.capitalize)((0, $d8jBh.camelize)(name))]);
}
function $85c9212bd0e76cc3$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    var sourceIsArray = (0, $d8jBh.isArray)(source);
    if (sourceIsArray || (0, $d8jBh.isString)(source)) {
        var sourceIsReactiveArray = sourceIsArray && (0, $hXmfK.isReactive)(source);
        var needsWrap = false;
        var isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $hXmfK.isShallow)(source);
            isReadonlySource = (0, $hXmfK.isReadonly)(source);
            source = (0, $hXmfK.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $hXmfK.toReadonly)((0, $hXmfK.toReactive)(source[i])) : (0, $hXmfK.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, void 0, cached && cached[i1]);
    } else if ((0, $d8jBh.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, void 0, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $85c9212bd0e76cc3$export$85738f8fcd0a5430(slots, dynamicSlots) {
    var _loop = function(i) {
        var slot = dynamicSlots[i];
        if ((0, $d8jBh.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _slot;
            var res = (_slot = slot).fn.apply(_slot, (0, $7WNf6._)(args));
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    };
    for(var i = 0; i < dynamicSlots.length; i++)_loop(i);
    return slots;
}
function $85c9212bd0e76cc3$export$4abee4c34694ada1(slots, name) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, fallback = arguments.length > 3 ? arguments[3] : void 0, noSlotted = arguments.length > 4 ? arguments[4] : void 0;
    if ($85c9212bd0e76cc3$var$currentRenderingInstance.ce || $85c9212bd0e76cc3$var$currentRenderingInstance.parent && $85c9212bd0e76cc3$var$isAsyncWrapper($85c9212bd0e76cc3$var$currentRenderingInstance.parent) && $85c9212bd0e76cc3$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $85c9212bd0e76cc3$export$e7eaa45e502fe5cc(), $85c9212bd0e76cc3$export$9f2dfe8048dfb22b($85c9212bd0e76cc3$export$ffb0004e005737fa, null, [
            $85c9212bd0e76cc3$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    var slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $85c9212bd0e76cc3$export$e7eaa45e502fe5cc();
    var validSlotContent = slot && $85c9212bd0e76cc3$var$ensureValidVNode(slot(props));
    var slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    var rendered = $85c9212bd0e76cc3$export$9f2dfe8048dfb22b($85c9212bd0e76cc3$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $d8jBh.isSymbol)(slotKey) ? slotKey : "_".concat(name)) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $85c9212bd0e76cc3$var$ensureValidVNode(vnodes) {
    return vnodes.some(function(child) {
        if (!$85c9212bd0e76cc3$export$3868d13f8734ae81(child)) return true;
        if (child.type === $85c9212bd0e76cc3$export$4d299b491347818a) return false;
        if (child.type === $85c9212bd0e76cc3$export$ffb0004e005737fa && !$85c9212bd0e76cc3$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $85c9212bd0e76cc3$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    var ret = {};
    for(var key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : (0, $d8jBh.toHandlerKey)(key)] = obj[key];
    return ret;
}
var $85c9212bd0e76cc3$var$getPublicInstance = function(i) {
    if (!i) return null;
    if ($85c9212bd0e76cc3$var$isStatefulComponent(i)) return $85c9212bd0e76cc3$var$getComponentPublicInstance(i);
    return $85c9212bd0e76cc3$var$getPublicInstance(i.parent);
};
var $85c9212bd0e76cc3$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $d8jBh.extend)(/* @__PURE__ */ Object.create(null), {
    $: function(i) {
        return i;
    },
    $el: function(i) {
        return i.vnode.el;
    },
    $data: function(i) {
        return i.data;
    },
    $props: function(i) {
        return 0, i.props;
    },
    $attrs: function(i) {
        return 0, i.attrs;
    },
    $slots: function(i) {
        return 0, i.slots;
    },
    $refs: function(i) {
        return 0, i.refs;
    },
    $parent: function(i) {
        return $85c9212bd0e76cc3$var$getPublicInstance(i.parent);
    },
    $root: function(i) {
        return $85c9212bd0e76cc3$var$getPublicInstance(i.root);
    },
    $host: function(i) {
        return i.ce;
    },
    $emit: function(i) {
        return i.emit;
    },
    $options: function(i) {
        return __VUE_OPTIONS_API__ ? $85c9212bd0e76cc3$var$resolveMergedOptions(i) : i.type;
    },
    $forceUpdate: function(i) {
        return i.f || (i.f = function() {
            $85c9212bd0e76cc3$var$queueJob(i.update);
        });
    },
    $nextTick: function(i) {
        return i.n || (i.n = $85c9212bd0e76cc3$export$bdd553fddd433dcb.bind(i.proxy));
    },
    $watch: function(i) {
        return __VUE_OPTIONS_API__ ? $85c9212bd0e76cc3$var$instanceWatch.bind(i) : (0, $d8jBh.NOOP);
    }
});
var $85c9212bd0e76cc3$var$isReservedPrefix = function(key) {
    return key === "_" || key === "$";
};
var $85c9212bd0e76cc3$var$hasSetupBinding = function(state, key) {
    return state !== (0, $d8jBh.EMPTY_OBJ) && !state.__isScriptSetup && (0, $d8jBh.hasOwn)(state, key);
};
var $85c9212bd0e76cc3$var$PublicInstanceProxyHandlers = {
    get: function(param, key) {
        var instance = param._;
        if (key === "__v_skip") return true;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($85c9212bd0e76cc3$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $d8jBh.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $85c9212bd0e76cc3$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        var publicGetter = $85c9212bd0e76cc3$var$publicPropertiesMap[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $hXmfK.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $d8jBh.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set: function(param, key, value) {
        var instance = param._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if ($85c9212bd0e76cc3$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $d8jBh.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has: function(param, key) {
        var _param__ = param._, data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, propsOptions = _param__.propsOptions;
        var normalizedProps;
        return !!accessCache[key] || data !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasOwn)(data, key) || $85c9212bd0e76cc3$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $d8jBh.hasOwn)(normalizedProps, key) || (0, $d8jBh.hasOwn)(ctx, key) || (0, $d8jBh.hasOwn)($85c9212bd0e76cc3$var$publicPropertiesMap, key) || (0, $d8jBh.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty: function(target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $d8jBh.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $85c9212bd0e76cc3$var$target;
var $85c9212bd0e76cc3$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $d8jBh.extend)({}, $85c9212bd0e76cc3$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        if (key === Symbol.unscopables) return;
        return $85c9212bd0e76cc3$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $d8jBh.isGloballyAllowed)(key);
        return has;
    }
});
function $85c9212bd0e76cc3$var$createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    Object.keys($85c9212bd0e76cc3$var$publicPropertiesMap).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $85c9212bd0e76cc3$var$publicPropertiesMap[key](instance);
            },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $d8jBh.NOOP)
        });
    });
    return target;
}
function $85c9212bd0e76cc3$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $32TW8._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $d8jBh.NOOP)
        });
    });
}
function $85c9212bd0e76cc3$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $hXmfK.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if ($85c9212bd0e76cc3$var$isReservedPrefix(key[0])) {
                $85c9212bd0e76cc3$var$warn$1("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" which are reserved prefixes for Vue internals.'));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $d8jBh.NOOP)
            });
        }
    });
}
var $85c9212bd0e76cc3$var$warnRuntimeUsage = function(method) {
    return $85c9212bd0e76cc3$var$warn$1("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect."));
};
function $85c9212bd0e76cc3$export$80b33eababae110e() {
    return null;
}
function $85c9212bd0e76cc3$export$51ecece22fc17ddc() {
    return null;
}
function $85c9212bd0e76cc3$export$da25b65ca24b518a(exposed) {}
function $85c9212bd0e76cc3$export$77e79129327f3d0d(options) {}
function $85c9212bd0e76cc3$export$1b3acd4bb805b712() {
    return null;
}
function $85c9212bd0e76cc3$export$acd55aa037e791bb() {}
function $85c9212bd0e76cc3$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $85c9212bd0e76cc3$export$9203a8e84125433c() {
    return $85c9212bd0e76cc3$var$getContext("useSlots").slots;
}
function $85c9212bd0e76cc3$export$75e29435042cd2ea() {
    return $85c9212bd0e76cc3$var$getContext("useAttrs").attrs;
}
function $85c9212bd0e76cc3$var$getContext(calledFunctionName) {
    var i = $85c9212bd0e76cc3$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $85c9212bd0e76cc3$var$createSetupContext(i));
}
function $85c9212bd0e76cc3$var$normalizePropsOrEmits(props) {
    return (0, $d8jBh.isArray)(props) ? props.reduce(function(normalized, p) {
        return normalized[p] = null, normalized;
    }, {}) : props;
}
function $85c9212bd0e76cc3$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $85c9212bd0e76cc3$var$normalizePropsOrEmits(raw);
    for(var key in defaults){
        if (key.startsWith("__skip")) continue;
        var opt = props[key];
        if (opt) {
            if ((0, $d8jBh.isArray)(opt) || (0, $d8jBh.isFunction)(opt)) opt = props[key] = {
                type: opt,
                "default": defaults[key]
            };
            else opt["default"] = defaults[key];
        } else if (opt === null) opt = props[key] = {
            "default": defaults[key]
        };
        if (opt && defaults["__skip_".concat(key)]) opt.skipFactory = true;
    }
    return props;
}
function $85c9212bd0e76cc3$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $d8jBh.isArray)(a) && (0, $d8jBh.isArray)(b)) return a.concat(b);
    return (0, $d8jBh.extend)({}, $85c9212bd0e76cc3$var$normalizePropsOrEmits(a), $85c9212bd0e76cc3$var$normalizePropsOrEmits(b));
}
function $85c9212bd0e76cc3$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
function $85c9212bd0e76cc3$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $85c9212bd0e76cc3$export$f13e630aa3915748();
    var awaitable = getAwaitable();
    $85c9212bd0e76cc3$var$unsetCurrentInstance();
    if ((0, $d8jBh.isPromise)(awaitable)) awaitable = awaitable["catch"](function(e) {
        $85c9212bd0e76cc3$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        function() {
            return $85c9212bd0e76cc3$var$setCurrentInstance(ctx);
        }
    ];
}
function $85c9212bd0e76cc3$var$createDuplicateChecker() {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(type, key) {
        if (cache[key]) $85c9212bd0e76cc3$var$warn$1("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $85c9212bd0e76cc3$var$shouldCacheAccess = true;
function $85c9212bd0e76cc3$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $d8jBh.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $d8jBh.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $d8jBh.NOOP);
        var set = !(0, $d8jBh.isFunction)(opt) && (0, $d8jBh.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $d8jBh.NOOP);
        var c = $85c9212bd0e76cc3$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var options = $85c9212bd0e76cc3$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    $85c9212bd0e76cc3$var$shouldCacheAccess = false;
    if (options.beforeCreate) $85c9212bd0e76cc3$var$callHook(options.beforeCreate, instance, "bc");
    var // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    if (injectOptions) $85c9212bd0e76cc3$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $d8jBh.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $d8jBh.isObject)(data)) ;
        else instance.data = (0, $hXmfK.reactive)(data);
    }
    $85c9212bd0e76cc3$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$85c9212bd0e76cc3$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $d8jBh.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $85c9212bd0e76cc3$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $85c9212bd0e76cc3$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $d8jBh.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($85c9212bd0e76cc3$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($85c9212bd0e76cc3$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($85c9212bd0e76cc3$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($85c9212bd0e76cc3$export$5876c47052fb88b1, updated);
    registerLifecycleHook($85c9212bd0e76cc3$export$ba52d824b95a2154, activated);
    registerLifecycleHook($85c9212bd0e76cc3$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($85c9212bd0e76cc3$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($85c9212bd0e76cc3$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($85c9212bd0e76cc3$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($85c9212bd0e76cc3$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($85c9212bd0e76cc3$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($85c9212bd0e76cc3$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $d8jBh.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    },
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $d8jBh.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $85c9212bd0e76cc3$var$markAsyncBoundary(instance);
}
function $85c9212bd0e76cc3$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $d8jBh.isObject)(opt)) {
            if ("default" in opt) injected = $85c9212bd0e76cc3$export$a976684a0efeb93f(opt.from || key, opt["default"], true);
            else injected = $85c9212bd0e76cc3$export$a976684a0efeb93f(opt.from || key);
        } else injected = $85c9212bd0e76cc3$export$a976684a0efeb93f(opt);
        if ((0, $hXmfK.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return injected.value;
            },
            set: function(v1) {
                return injected.value = v1;
            }
        });
        else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $d8jBh.NOOP);
    if ((0, $d8jBh.isArray)(injectOptions)) injectOptions = $85c9212bd0e76cc3$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $85c9212bd0e76cc3$var$callHook(hook, instance, type) {
    $85c9212bd0e76cc3$export$dae85862a8d94378((0, $d8jBh.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $85c9212bd0e76cc3$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $85c9212bd0e76cc3$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $d8jBh.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $d8jBh.isFunction)(handler)) $85c9212bd0e76cc3$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $d8jBh.isFunction)(raw)) $85c9212bd0e76cc3$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $d8jBh.isObject)(raw)) {
        if ((0, $d8jBh.isArray)(raw)) raw.forEach(function(r) {
            return $85c9212bd0e76cc3$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $d8jBh.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $d8jBh.isFunction)(handler1)) $85c9212bd0e76cc3$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
function $85c9212bd0e76cc3$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base["extends"];
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $85c9212bd0e76cc3$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $85c9212bd0e76cc3$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $d8jBh.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $85c9212bd0e76cc3$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from["extends"];
    if (extendsOptions) $85c9212bd0e76cc3$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $85c9212bd0e76cc3$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from){
        if (asMixin && key === "expose") ;
        else {
            var strat = $85c9212bd0e76cc3$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var $85c9212bd0e76cc3$var$internalOptionMergeStrats = {
    data: $85c9212bd0e76cc3$var$mergeDataFn,
    props: $85c9212bd0e76cc3$var$mergeEmitsOrPropsOptions,
    emits: $85c9212bd0e76cc3$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $85c9212bd0e76cc3$var$mergeObjectOptions,
    computed: $85c9212bd0e76cc3$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $85c9212bd0e76cc3$var$mergeAsArray,
    created: $85c9212bd0e76cc3$var$mergeAsArray,
    beforeMount: $85c9212bd0e76cc3$var$mergeAsArray,
    mounted: $85c9212bd0e76cc3$var$mergeAsArray,
    beforeUpdate: $85c9212bd0e76cc3$var$mergeAsArray,
    updated: $85c9212bd0e76cc3$var$mergeAsArray,
    beforeDestroy: $85c9212bd0e76cc3$var$mergeAsArray,
    beforeUnmount: $85c9212bd0e76cc3$var$mergeAsArray,
    destroyed: $85c9212bd0e76cc3$var$mergeAsArray,
    unmounted: $85c9212bd0e76cc3$var$mergeAsArray,
    activated: $85c9212bd0e76cc3$var$mergeAsArray,
    deactivated: $85c9212bd0e76cc3$var$mergeAsArray,
    errorCaptured: $85c9212bd0e76cc3$var$mergeAsArray,
    serverPrefetch: $85c9212bd0e76cc3$var$mergeAsArray,
    // assets
    components: $85c9212bd0e76cc3$var$mergeObjectOptions,
    directives: $85c9212bd0e76cc3$var$mergeObjectOptions,
    // watch
    watch: $85c9212bd0e76cc3$var$mergeWatchOptions,
    // provide / inject
    provide: $85c9212bd0e76cc3$var$mergeDataFn,
    inject: $85c9212bd0e76cc3$var$mergeInject
};
function $85c9212bd0e76cc3$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $d8jBh.extend)((0, $d8jBh.isFunction)(to) ? to.call(this, this) : to, (0, $d8jBh.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $85c9212bd0e76cc3$var$mergeInject(to, from) {
    return $85c9212bd0e76cc3$var$mergeObjectOptions($85c9212bd0e76cc3$var$normalizeInject(to), $85c9212bd0e76cc3$var$normalizeInject(from));
}
function $85c9212bd0e76cc3$var$normalizeInject(raw) {
    if ((0, $d8jBh.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $85c9212bd0e76cc3$var$mergeAsArray(to, from) {
    return to ? (0, $7WNf6._)(new Set([].concat(to, from))) : from;
}
function $85c9212bd0e76cc3$var$mergeObjectOptions(to, from) {
    return to ? (0, $d8jBh.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $85c9212bd0e76cc3$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $d8jBh.isArray)(to) && (0, $d8jBh.isArray)(from)) return (0, $7WNf6._)(/* @__PURE__ */ new Set((0, $7WNf6._)(to).concat((0, $7WNf6._)(from))));
        return (0, $d8jBh.extend)(/* @__PURE__ */ Object.create(null), $85c9212bd0e76cc3$var$normalizePropsOrEmits(to), $85c9212bd0e76cc3$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $85c9212bd0e76cc3$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $d8jBh.extend)(/* @__PURE__ */ Object.create(null), to);
    for(var key in from)merged[key] = $85c9212bd0e76cc3$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $85c9212bd0e76cc3$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $d8jBh.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var $85c9212bd0e76cc3$var$uid$1 = 0;
function $85c9212bd0e76cc3$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(0, $d8jBh.isFunction)(rootComponent)) rootComponent = (0, $d8jBh.extend)({}, rootComponent);
        if (rootProps != null && !(0, $d8jBh.isObject)(rootProps)) rootProps = null;
        var context = $85c9212bd0e76cc3$var$createAppContext();
        var installedPlugins = /* @__PURE__ */ new WeakSet();
        var pluginCleanupFns = [];
        var isMounted = false;
        var app = context.app = {
            _uid: $85c9212bd0e76cc3$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $85c9212bd0e76cc3$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $d8jBh.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $7WNf6._)(options)));
                } else if ((0, $d8jBh.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $7WNf6._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    var vnode = app._ceVNode || $85c9212bd0e76cc3$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $85c9212bd0e76cc3$var$devtoolsInitApp(app, $85c9212bd0e76cc3$export$83d89fbfd8236492);
                    }
                    return $85c9212bd0e76cc3$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount: function(cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount: function() {
                if (isMounted) {
                    $85c9212bd0e76cc3$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $85c9212bd0e76cc3$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext: function(fn) {
                var lastApp = $85c9212bd0e76cc3$var$currentApp;
                $85c9212bd0e76cc3$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $85c9212bd0e76cc3$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
var $85c9212bd0e76cc3$var$currentApp = null;
function $85c9212bd0e76cc3$export$abe1e183e22e10ad(key, value) {
    if (!$85c9212bd0e76cc3$var$currentInstance) ;
    else {
        var provides = $85c9212bd0e76cc3$var$currentInstance.provides;
        var parentProvides = $85c9212bd0e76cc3$var$currentInstance.parent && $85c9212bd0e76cc3$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $85c9212bd0e76cc3$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $85c9212bd0e76cc3$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var instance = $85c9212bd0e76cc3$export$f13e630aa3915748();
    if (instance || $85c9212bd0e76cc3$var$currentApp) {
        var provides = $85c9212bd0e76cc3$var$currentApp ? $85c9212bd0e76cc3$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $d8jBh.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $85c9212bd0e76cc3$export$caf6761f24fc571a() {
    return !!($85c9212bd0e76cc3$export$f13e630aa3915748() || $85c9212bd0e76cc3$var$currentApp);
}
var $85c9212bd0e76cc3$var$internalObjectProto = {};
var $85c9212bd0e76cc3$var$createInternalObject = function() {
    return Object.create($85c9212bd0e76cc3$var$internalObjectProto);
};
var $85c9212bd0e76cc3$var$isInternalObject = function(obj) {
    return Object.getPrototypeOf(obj) === $85c9212bd0e76cc3$var$internalObjectProto;
};
function $85c9212bd0e76cc3$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = {};
    var attrs = $85c9212bd0e76cc3$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $85c9212bd0e76cc3$var$setFullProps(instance, rawProps, props, attrs);
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $hXmfK.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $85c9212bd0e76cc3$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $85c9212bd0e76cc3$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $hXmfK.toRaw)(props);
    var _instance_propsOptions = (0, $32TW8._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                if ($85c9212bd0e76cc3$var$isEmitListener(instance.emitsOptions, key)) continue;
                var value = rawProps[key];
                if (options) {
                    if ((0, $d8jBh.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $d8jBh.camelize)(key);
                        props[camelizedKey] = $85c9212bd0e76cc3$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($85c9212bd0e76cc3$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $d8jBh.hasOwn)(rawProps, key1) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $d8jBh.hyphenate)(key1)) === key1 || !(0, $d8jBh.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key1] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key1] = $85c9212bd0e76cc3$var$resolvePropValue(options, rawCurrentProps, key1, void 0, instance, true);
            } else delete props[key1];
        }
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $d8jBh.hasOwn)(rawProps, key2) && true) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $hXmfK.trigger)(instance.attrs, "set", "");
}
function $85c9212bd0e76cc3$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $32TW8._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        if ((0, $d8jBh.isReservedProp)(key)) continue;
        var value = rawProps[key];
        var camelKey = void 0;
        if (options && (0, $d8jBh.hasOwn)(options, camelKey = (0, $d8jBh.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$85c9212bd0e76cc3$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = (0, $hXmfK.toRaw)(props);
        var castValues = rawCastValues || (0, $d8jBh.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $85c9212bd0e76cc3$var$resolvePropValue(options, rawCurrentProps, key1, castValues[key1], instance, !(0, $d8jBh.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
function $85c9212bd0e76cc3$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $d8jBh.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            var defaultValue = opt["default"];
            if (opt.type !== Function && !opt.skipFactory && (0, $d8jBh.isFunction)(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    var reset = $85c9212bd0e76cc3$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $d8jBh.hyphenate)(key))) value = true;
        }
    }
    return value;
}
var $85c9212bd0e76cc3$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $85c9212bd0e76cc3$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = __VUE_OPTIONS_API__ && asMixin ? $85c9212bd0e76cc3$var$mixinPropsCache : appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $d8jBh.isFunction)(comp)) {
        var extendProps = function(raw2) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $32TW8._)($85c9212bd0e76cc3$var$normalizePropsOptions(raw2, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $d8jBh.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $7WNf6._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp["extends"]) extendProps(comp["extends"]);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $d8jBh.isObject)(comp)) cache.set(comp, (0, $d8jBh.EMPTY_ARR));
        return 0, $d8jBh.EMPTY_ARR;
    }
    if ((0, $d8jBh.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $d8jBh.camelize)(raw[i]);
        if ($85c9212bd0e76cc3$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $d8jBh.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $d8jBh.camelize)(key);
        if ($85c9212bd0e76cc3$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $d8jBh.isArray)(opt) || (0, $d8jBh.isFunction)(opt) ? {
                type: opt
            } : (0, $d8jBh.extend)({}, opt);
            var propType = prop.type;
            var shouldCast = false;
            var shouldCastTrue = true;
            if ((0, $d8jBh.isArray)(propType)) for(var index = 0; index < propType.length; ++index){
                var type = propType[index];
                var typeName = (0, $d8jBh.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $d8jBh.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $d8jBh.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
        }
    }
    var res = [
        normalized,
        needCastKeys
    ];
    if ((0, $d8jBh.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $85c9212bd0e76cc3$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $d8jBh.isReservedProp)(key)) return true;
    return false;
}
function $85c9212bd0e76cc3$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if ((typeof ctor === "undefined" ? "undefined" : (0, $3KZcf._)(ctor)) === "object") {
        var name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $85c9212bd0e76cc3$var$validateProps(rawProps, props, instance) {
    var resolvedValues = (0, $hXmfK.toRaw)(props);
    var options = instance.propsOptions[0];
    var camelizePropsKey = Object.keys(rawProps).map(function(key) {
        return (0, $d8jBh.camelize)(key);
    });
    for(var key in options){
        var opt = options[key];
        if (opt == null) continue;
        $85c9212bd0e76cc3$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $85c9212bd0e76cc3$var$validateProp(name, value, prop, props, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator, skipCheck = prop.skipCheck;
    if (required && isAbsent) {
        $85c9212bd0e76cc3$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = (0, $d8jBh.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $85c9212bd0e76cc3$var$assertType(value, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $85c9212bd0e76cc3$var$warn$1($85c9212bd0e76cc3$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $85c9212bd0e76cc3$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
var $85c9212bd0e76cc3$var$isSimpleType = /* @__PURE__ */ (0, $d8jBh.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $85c9212bd0e76cc3$var$assertType(value, type) {
    var valid;
    var expectedType = $85c9212bd0e76cc3$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($85c9212bd0e76cc3$var$isSimpleType(expectedType)) {
        var t = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $d8jBh.isObject)(value);
    else if (expectedType === "Array") valid = (0, $d8jBh.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $85c9212bd0e76cc3$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return 'Prop type [] for prop "'.concat(name, "\" won't match anything. Did you mean to use type Array instead?");
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '". Expected ').concat(expectedTypes.map((0, $d8jBh.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $d8jBh.toRawType)(value);
    var expectedValue = $85c9212bd0e76cc3$var$styleValue(value, expectedType);
    var receivedValue = $85c9212bd0e76cc3$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $85c9212bd0e76cc3$var$isExplicable(expectedType) && !$85c9212bd0e76cc3$var$isBoolean(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    if ($85c9212bd0e76cc3$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
function $85c9212bd0e76cc3$var$styleValue(value, type) {
    if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
function $85c9212bd0e76cc3$var$isExplicable(type) {
    var explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
function $85c9212bd0e76cc3$var$isBoolean() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
var $85c9212bd0e76cc3$var$isInternalKey = function(key) {
    return key === "_" || key === "__" || key === "_ctx" || key === "$stable";
};
var $85c9212bd0e76cc3$var$normalizeSlotValue = function(value) {
    return (0, $d8jBh.isArray)(value) ? value.map($85c9212bd0e76cc3$var$normalizeVNode) : [
        $85c9212bd0e76cc3$var$normalizeVNode(value)
    ];
};
var $85c9212bd0e76cc3$var$normalizeSlot = function(key, rawSlot, ctx) {
    if (rawSlot._n) return rawSlot;
    var normalized = $85c9212bd0e76cc3$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $85c9212bd0e76cc3$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $7WNf6._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $85c9212bd0e76cc3$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($85c9212bd0e76cc3$var$isInternalKey(key)) return "continue";
        var value = rawSlots[key];
        if ((0, $d8jBh.isFunction)(value)) slots[key] = $85c9212bd0e76cc3$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            var normalized = $85c9212bd0e76cc3$var$normalizeSlotValue(value);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $85c9212bd0e76cc3$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $85c9212bd0e76cc3$var$normalizeSlotValue(children);
    instance.slots["default"] = function() {
        return normalized;
    };
};
var $85c9212bd0e76cc3$var$assignSlots = function(slots, children, optimized) {
    for(var key in children)if (optimized || !$85c9212bd0e76cc3$var$isInternalKey(key)) slots[key] = children[key];
};
var $85c9212bd0e76cc3$var$initSlots = function(instance, children, optimized) {
    var slots = instance.slots = $85c9212bd0e76cc3$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        var cacheIndexes = children.__;
        if (cacheIndexes) (0, $d8jBh.def)(slots, "__", cacheIndexes, true);
        var type = children._;
        if (type) {
            $85c9212bd0e76cc3$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $d8jBh.def)(slots, "_", type, true);
        } else $85c9212bd0e76cc3$var$normalizeObjectSlots(children, slots);
    } else if (children) $85c9212bd0e76cc3$var$normalizeVNodeSlots(instance, children);
};
var $85c9212bd0e76cc3$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $d8jBh.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $85c9212bd0e76cc3$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $85c9212bd0e76cc3$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $85c9212bd0e76cc3$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            "default": 1
        };
    }
    if (needDeletionCheck) {
        for(var key in slots)if (!$85c9212bd0e76cc3$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
var $85c9212bd0e76cc3$var$supported;
var $85c9212bd0e76cc3$var$perf;
function $85c9212bd0e76cc3$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $85c9212bd0e76cc3$var$isSupported()) $85c9212bd0e76cc3$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsPerfStart(instance, type, $85c9212bd0e76cc3$var$isSupported() ? $85c9212bd0e76cc3$var$perf.now() : Date.now());
}
function $85c9212bd0e76cc3$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $85c9212bd0e76cc3$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        $85c9212bd0e76cc3$var$perf.mark(endTag);
        $85c9212bd0e76cc3$var$perf.measure("<".concat($85c9212bd0e76cc3$var$formatComponentName(instance, instance.type), "> ").concat(type), startTag, endTag);
        $85c9212bd0e76cc3$var$perf.clearMarks(startTag);
        $85c9212bd0e76cc3$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsPerfEnd(instance, type, $85c9212bd0e76cc3$var$isSupported() ? $85c9212bd0e76cc3$var$perf.now() : Date.now());
}
function $85c9212bd0e76cc3$var$isSupported() {
    if ($85c9212bd0e76cc3$var$supported !== void 0) return $85c9212bd0e76cc3$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $85c9212bd0e76cc3$var$supported = true;
        $85c9212bd0e76cc3$var$perf = window.performance;
    } else $85c9212bd0e76cc3$var$supported = false;
    return $85c9212bd0e76cc3$var$supported;
}
function $85c9212bd0e76cc3$var$initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $d8jBh.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $d8jBh.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $d8jBh.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
var $85c9212bd0e76cc3$var$queuePostRenderEffect = $85c9212bd0e76cc3$var$queueEffectWithSuspense;
function $85c9212bd0e76cc3$export$53ae2f996c64e9a(options) {
    return $85c9212bd0e76cc3$var$baseCreateRenderer(options);
}
function $85c9212bd0e76cc3$export$200524cf0d997ff0(options) {
    return $85c9212bd0e76cc3$var$baseCreateRenderer(options, $85c9212bd0e76cc3$var$createHydrationFunctions);
}
function $85c9212bd0e76cc3$var$baseCreateRenderer(options, createHydrationFns) {
    $85c9212bd0e76cc3$var$initFeatureFlags();
    var target = (0, $d8jBh.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $d8jBh.NOOP) : tmp, hostInsertStaticContent = options.insertStaticContent;
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, namespace = arguments.length > 6 ? arguments[6] : void 0, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        if (n1 && !$85c9212bd0e76cc3$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $85c9212bd0e76cc3$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $85c9212bd0e76cc3$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $85c9212bd0e76cc3$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $85c9212bd0e76cc3$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $85c9212bd0e76cc3$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, namespace) {
        var ref;
        ref = (0, $32TW8._)(hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    var patchStaticNode = function(n1, n2, container, namespace) {
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            var ref;
            ref = (0, $32TW8._)(hostInsertStaticContent(n2.children, container, anchor, namespace), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(var key in props)if (key !== "value" && !(0, $d8jBh.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $d8jBh.def)(el, "__vnode", vnode, true);
            (0, $d8jBh.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        var needCallTransitionHooks = $85c9212bd0e76cc3$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
            vnodeHook && $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (vnode === subTree || $85c9212bd0e76cc3$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(children[i]) : $85c9212bd0e76cc3$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || (0, $d8jBh.EMPTY_OBJ);
        var newProps = n2.props || (0, $d8jBh.EMPTY_OBJ);
        var vnodeHook;
        parentComponent && $85c9212bd0e76cc3$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $85c9212bd0e76cc3$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $85c9212bd0e76cc3$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps["class"] !== newProps["class"]) hostPatchProp(el, "class", null, newProps["class"], namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
            vnodeHook && $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $85c9212bd0e76cc3$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $85c9212bd0e76cc3$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$85c9212bd0e76cc3$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    var patchProps = function(el, oldProps, newProps, parentComponent, namespace) {
        if (oldProps !== newProps) {
            if (oldProps !== (0, $d8jBh.EMPTY_OBJ)) {
                for(var key in oldProps)if (!(0, $d8jBh.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(var key1 in newProps){
                if ((0, $d8jBh.isReservedProp)(key1)) continue;
                var next = newProps[key1];
                var prev = oldProps[key1];
                if (next !== prev && key1 !== "value") hostPatchProp(el, key1, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $85c9212bd0e76cc3$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) {
        var instance = initialVNode.component = $85c9212bd0e76cc3$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($85c9212bd0e76cc3$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $85c9212bd0e76cc3$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($85c9212bd0e76cc3$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
        var componentUpdateFn = function() {
            if (!instance.isMounted) {
                var vnodeHook;
                var el = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent = instance.parent, root = instance.root, type = instance.type;
                var isAsyncWrapperVNode = $85c9212bd0e76cc3$var$isAsyncWrapper(initialVNode);
                $85c9212bd0e76cc3$var$toggleRecurse(instance, false);
                if (bm) (0, $d8jBh.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $85c9212bd0e76cc3$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    var hydrateSubTree = function() {
                        instance.subTree = $85c9212bd0e76cc3$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && // @ts-expect-error _def is private
                    root.ce._def.shadowRoot !== false) root.ce._injectChildStyle(type);
                    var subTree = instance.subTree = $85c9212bd0e76cc3$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $85c9212bd0e76cc3$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    var scopedInitialVNode = initialVNode;
                    $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                        return $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                    }, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $85c9212bd0e76cc3$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $85c9212bd0e76cc3$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                {
                    var nonHydratedAsyncRoot = $85c9212bd0e76cc3$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(function() {
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                var originNext = next;
                var vnodeHook1;
                $85c9212bd0e76cc3$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $d8jBh.invokeArrayFns)(bu);
                if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                $85c9212bd0e76cc3$var$toggleRecurse(instance, true);
                var nextTree = $85c9212bd0e76cc3$var$renderComponentRoot(instance);
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $85c9212bd0e76cc3$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $85c9212bd0e76cc3$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook1 = next.props && next.props.onVnodeUpdated) $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                    return $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                }, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        var effect = instance.effect = new (0, $hXmfK.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        var update = instance.update = effect.run.bind(effect);
        var job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = function() {
            return $85c9212bd0e76cc3$var$queueJob(job);
        };
        $85c9212bd0e76cc3$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $85c9212bd0e76cc3$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $85c9212bd0e76cc3$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $hXmfK.pauseTracking)();
        $85c9212bd0e76cc3$var$flushPreFlushCbs(instance);
        (0, $hXmfK.resetTracking)();
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        c1 = c1 || (0, $d8jBh.EMPTY_ARR);
        c2 = c2 || (0, $d8jBh.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(c2[i]) : $85c9212bd0e76cc3$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(c2[i]) : $85c9212bd0e76cc3$var$normalizeVNode(c2[i]);
            if ($85c9212bd0e76cc3$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(c2[e2]) : $85c9212bd0e76cc3$var$normalizeVNode(c2[e2]);
            if ($85c9212bd0e76cc3$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(c2[i]) : $85c9212bd0e76cc3$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $85c9212bd0e76cc3$var$cloneIfMounted(c2[i]) : $85c9212bd0e76cc3$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $85c9212bd0e76cc3$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? $85c9212bd0e76cc3$var$getSequence(newIndexToOldIndexMap) : (0, $d8jBh.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchorVNode = c2[nextIndex + 1];
                var anchor1 = nextIndex + 1 < l2 ? // #13559, fallback to el placeholder for unresolved async component
                anchorVNode.el || anchorVNode.placeholder : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2);
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType) {
        var parentSuspense = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $85c9212bd0e76cc3$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        var needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
                    return transition.enter(el);
                }, parentSuspense);
            } else {
                var leave = transition.leave, delayLeave = transition.delayLeave, afterLeave = transition.afterLeave;
                var remove2 = function() {
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                var performLeave = function() {
                    leave(el, function() {
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs, cacheIndex = vnode.cacheIndex;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $hXmfK.pauseTracking)();
            $85c9212bd0e76cc3$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $hXmfK.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !$85c9212bd0e76cc3$var$isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $85c9212bd0e76cc3$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $85c9212bd0e76cc3$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
            vnodeHook && $85c9212bd0e76cc3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $85c9212bd0e76cc3$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $85c9212bd0e76cc3$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function() {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            var leave = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function() {
                return leave(el, performRemove);
            };
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    var removeFragment = function(cur, end) {
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, job = instance.job, subTree = instance.subTree, um = instance.um, m = instance.m, a = instance.a, parent = instance.parent, _instance_slots = instance.slots, slotCacheKeys = _instance_slots.__;
        $85c9212bd0e76cc3$var$invalidateMount(m);
        $85c9212bd0e76cc3$var$invalidateMount(a);
        if (bum) (0, $d8jBh.invokeArrayFns)(bum);
        if (parent && (0, $d8jBh.isArray)(slotCacheKeys)) slotCacheKeys.forEach(function(v1) {
            parent.renderCache[v1] = void 0;
        });
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $85c9212bd0e76cc3$var$queuePostRenderEffect(um, parentSuspense);
        $85c9212bd0e76cc3$var$queuePostRenderEffect(function() {
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        var el = hostNextSibling(vnode.anchor || vnode.el);
        var teleportEnd = el && el[$85c9212bd0e76cc3$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    var isFlushing = false;
    var render = function(vnode, container, namespace) {
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $85c9212bd0e76cc3$var$flushPreFlushCbs();
            $85c9212bd0e76cc3$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $32TW8._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    return {
        render: render,
        hydrate: hydrate,
        createApp: $85c9212bd0e76cc3$var$createAppAPI(render, hydrate)
    };
}
function $85c9212bd0e76cc3$var$resolveChildrenNamespace(param, currentNamespace) {
    var type = param.type, props = param.props;
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $85c9212bd0e76cc3$var$toggleRecurse(param, allowed) {
    var effect = param.effect, job = param.job;
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $85c9212bd0e76cc3$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $85c9212bd0e76cc3$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $d8jBh.isArray)(ch1) && (0, $d8jBh.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $85c9212bd0e76cc3$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $85c9212bd0e76cc3$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $85c9212bd0e76cc3$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $85c9212bd0e76cc3$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $85c9212bd0e76cc3$var$getSequence(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v1, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $85c9212bd0e76cc3$var$locateNonHydratedAsyncRoot(instance) {
    var subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $85c9212bd0e76cc3$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $85c9212bd0e76cc3$var$invalidateMount(hooks) {
    if (hooks) for(var i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
var $85c9212bd0e76cc3$export$f2549a27e18acf2d = Symbol["for"]("v-scx");
var $85c9212bd0e76cc3$export$6b1c54dc4befcda = function() {
    {
        var ctx = $85c9212bd0e76cc3$export$a976684a0efeb93f($85c9212bd0e76cc3$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $85c9212bd0e76cc3$export$ede35fc0e5500309(effect, options) {
    return $85c9212bd0e76cc3$var$doWatch(effect, null, options);
}
function $85c9212bd0e76cc3$export$b7f27ea67102d543(effect, options) {
    return $85c9212bd0e76cc3$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $85c9212bd0e76cc3$export$2035654f31b0e555(effect, options) {
    return $85c9212bd0e76cc3$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $85c9212bd0e76cc3$export$3db5d71bdb2d5499(source, cb, options) {
    return $85c9212bd0e76cc3$var$doWatch(source, cb, options);
}
function $85c9212bd0e76cc3$var$doWatch(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $d8jBh.EMPTY_OBJ);
    var immediate = options.immediate, deep = options.deep, flush = options.flush, once = options.once;
    var baseWatchOptions = (0, $d8jBh.extend)({}, options);
    var runsImmediately = cb && immediate || !cb && flush !== "post";
    var ssrCleanup;
    if ($85c9212bd0e76cc3$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            var ctx = $85c9212bd0e76cc3$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            var watchStopHandle = function() {};
            watchStopHandle.stop = (0, $d8jBh.NOOP);
            watchStopHandle.resume = (0, $d8jBh.NOOP);
            watchStopHandle.pause = (0, $d8jBh.NOOP);
            return watchStopHandle;
        }
    }
    var instance = $85c9212bd0e76cc3$var$currentInstance;
    baseWatchOptions.call = function(fn, type, args) {
        return $85c9212bd0e76cc3$export$dae85862a8d94378(fn, instance, type, args);
    };
    var isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = function(job) {
        $85c9212bd0e76cc3$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = function(job, isFirstRun) {
            if (isFirstRun) job();
            else $85c9212bd0e76cc3$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = function(job) {
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    var watchHandle = (0, $hXmfK.watch)(source, cb, baseWatchOptions);
    if ($85c9212bd0e76cc3$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $85c9212bd0e76cc3$var$instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = (0, $d8jBh.isString)(source) ? source.includes(".") ? $85c9212bd0e76cc3$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $d8jBh.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    var reset = $85c9212bd0e76cc3$var$setCurrentInstance(this);
    var res = $85c9212bd0e76cc3$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $85c9212bd0e76cc3$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $85c9212bd0e76cc3$export$fb78bd113157f1a1(props, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $d8jBh.EMPTY_OBJ);
    var i = $85c9212bd0e76cc3$export$f13e630aa3915748();
    var camelizedName = (0, $d8jBh.camelize)(name);
    var hyphenatedName = (0, $d8jBh.hyphenate)(name);
    var modifiers = $85c9212bd0e76cc3$var$getModelModifiers(props, camelizedName);
    var res = (0, $hXmfK.customRef)(function(track, trigger) {
        var localValue;
        var prevSetValue = (0, $d8jBh.EMPTY_OBJ);
        var prevEmittedValue;
        $85c9212bd0e76cc3$export$2035654f31b0e555(function() {
            var propValue = props[camelizedName];
            if ((0, $d8jBh.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get: function() {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set: function(value) {
                var emittedValue = options.set ? options.set(value) : value;
                if (!(0, $d8jBh.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $d8jBh.EMPTY_OBJ) && (0, $d8jBh.hasChanged)(value, prevSetValue))) return;
                var rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && ("onUpdate:".concat(name) in rawProps || "onUpdate:".concat(camelizedName) in rawProps || "onUpdate:".concat(hyphenatedName) in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit("update:".concat(name), emittedValue);
                if ((0, $d8jBh.hasChanged)(value, emittedValue) && (0, $d8jBh.hasChanged)(value, prevSetValue) && !(0, $d8jBh.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = function() {
        var i2 = 0;
        return {
            next: function() {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $d8jBh.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
var $85c9212bd0e76cc3$var$getModelModifiers = function(props, modelName) {
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props["".concat(modelName, "Modifiers")] || props["".concat((0, $d8jBh.camelize)(modelName), "Modifiers")] || props["".concat((0, $d8jBh.hyphenate)(modelName), "Modifiers")];
};
function $85c9212bd0e76cc3$var$emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    if (instance.isUnmounted) return;
    var props = instance.vnode.props || (0, $d8jBh.EMPTY_OBJ);
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modifiers = isModelListener && $85c9212bd0e76cc3$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map(function(a) {
            return (0, $d8jBh.isString)(a) ? a.trim() : a;
        });
        if (modifiers.number) args = rawArgs.map((0, $d8jBh.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $85c9212bd0e76cc3$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = props[handlerName = (0, $d8jBh.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $d8jBh.toHandlerKey)((0, $d8jBh.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $d8jBh.toHandlerKey)((0, $d8jBh.hyphenate)(event))];
    if (handler) $85c9212bd0e76cc3$export$dae85862a8d94378(handler, instance, 6, args);
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $85c9212bd0e76cc3$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $85c9212bd0e76cc3$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) return cached;
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $d8jBh.isFunction)(comp)) {
        var extendEmits = function(raw2) {
            var normalizedFromExtend = $85c9212bd0e76cc3$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $d8jBh.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp["extends"]) extendEmits(comp["extends"]);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $d8jBh.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $d8jBh.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $d8jBh.extend)(normalized, raw);
    if ((0, $d8jBh.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $85c9212bd0e76cc3$var$isEmitListener(options, key) {
    if (!options || !(0, $d8jBh.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $d8jBh.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $d8jBh.hasOwn)(options, (0, $d8jBh.hyphenate)(key)) || (0, $d8jBh.hasOwn)(options, key);
}
var $85c9212bd0e76cc3$var$accessedAttrs = false;
function $85c9212bd0e76cc3$var$markAttrsAccessed() {
    $85c9212bd0e76cc3$var$accessedAttrs = true;
}
function $85c9212bd0e76cc3$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, _instance_propsOptions = (0, $32TW8._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, props = instance.props, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var prev = $85c9212bd0e76cc3$var$setCurrentRenderingInstance(instance);
    var result;
    var fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            var thisProxy = proxyToUse;
            result = $85c9212bd0e76cc3$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            var render2 = Component;
            result = $85c9212bd0e76cc3$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $85c9212bd0e76cc3$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $85c9212bd0e76cc3$var$blockStack.length = 0;
        $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, 1);
        result = $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$4d299b491347818a);
    }
    var root = result;
    var setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $d8jBh.isModelListener))) fallthroughAttrs = $85c9212bd0e76cc3$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $85c9212bd0e76cc3$export$7770a22486565649(root, vnode.transition);
    result = root;
    $85c9212bd0e76cc3$var$setCurrentRenderingInstance(prev);
    return result;
}
var $85c9212bd0e76cc3$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $85c9212bd0e76cc3$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $7WNf6._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $85c9212bd0e76cc3$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $85c9212bd0e76cc3$var$filterSingleRoot(children) {
    var recurse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($85c9212bd0e76cc3$export$3868d13f8734ae81(child)) {
            if (child.type !== $85c9212bd0e76cc3$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $85c9212bd0e76cc3$var$getFunctionalFallthrough = function(attrs) {
    var res;
    for(var key in attrs)if (key === "class" || key === "style" || (0, $d8jBh.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $85c9212bd0e76cc3$var$filterModelListeners = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $d8jBh.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $85c9212bd0e76cc3$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 || vnode.type === $85c9212bd0e76cc3$export$4d299b491347818a;
};
function $85c9212bd0e76cc3$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $85c9212bd0e76cc3$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$85c9212bd0e76cc3$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $85c9212bd0e76cc3$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $85c9212bd0e76cc3$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$85c9212bd0e76cc3$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $85c9212bd0e76cc3$var$updateHOCHostEl(param, el) {
    var vnode = param.vnode, parent = param.parent;
    while(parent){
        var root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
var $85c9212bd0e76cc3$var$isSuspense = function(type) {
    return type.__isSuspense;
};
var $85c9212bd0e76cc3$var$suspenseId = 0;
var $85c9212bd0e76cc3$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $85c9212bd0e76cc3$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $85c9212bd0e76cc3$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $85c9212bd0e76cc3$var$hydrateSuspense,
    normalize: $85c9212bd0e76cc3$var$normalizeSuspenseChildren
};
var $85c9212bd0e76cc3$export$74bf444e3cd11ea5 = $85c9212bd0e76cc3$var$SuspenseImpl;
function $85c9212bd0e76cc3$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $d8jBh.isFunction)(eventListener)) eventListener();
}
function $85c9212bd0e76cc3$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $85c9212bd0e76cc3$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $85c9212bd0e76cc3$var$triggerEvent(vnode, "onPending");
        $85c9212bd0e76cc3$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $85c9212bd0e76cc3$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $85c9212bd0e76cc3$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($85c9212bd0e76cc3$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $85c9212bd0e76cc3$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $85c9212bd0e76cc3$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $85c9212bd0e76cc3$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $85c9212bd0e76cc3$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $85c9212bd0e76cc3$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $85c9212bd0e76cc3$var$setActiveBranch(suspense, newBranch);
    } else {
        $85c9212bd0e76cc3$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $85c9212bd0e76cc3$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $85c9212bd0e76cc3$var$hasWarned = false;
function $85c9212bd0e76cc3$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _rendererInternals_o = rendererInternals.o, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove;
    var parentSuspenseId;
    var isSuspensible = $85c9212bd0e76cc3$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? (0, $d8jBh.toNumber)(vnode.props.timeout) : void 0;
    var initialAnchor = anchor;
    var suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $85c9212bd0e76cc3$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function() {
            var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, parentComponent2 = suspense.parentComponent, container2 = suspense.container;
            var delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = function() {
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $85c9212bd0e76cc3$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $85c9212bd0e76cc3$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            var parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    var _parent_effects;
                    (_parent_effects = parent.effects).push.apply(_parent_effects, (0, $7WNf6._)(effects));
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $85c9212bd0e76cc3$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $85c9212bd0e76cc3$var$triggerEvent(vnode2, "onResolve");
        },
        fallback: function(fallbackVNode) {
            if (!suspense.pendingBranch) return;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, parentComponent2 = suspense.parentComponent, container2 = suspense.container, namespace2 = suspense.namespace;
            $85c9212bd0e76cc3$var$triggerEvent(vnode2, "onFallback");
            var anchor2 = next(activeBranch);
            var mountFallback = function() {
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $85c9212bd0e76cc3$var$setActiveBranch(suspense, fallbackVNode);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move: function(container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next: function() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function(instance, setupRenderEffect, optimized2) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            var hydratedEl = instance.vnode.el;
            instance.asyncDep["catch"](function(err) {
                $85c9212bd0e76cc3$export$d3da1ecaf1206c58(err, instance, 0);
            }).then(function(asyncSetupResult) {
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                var vnode2 = instance.vnode;
                $85c9212bd0e76cc3$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                var placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $85c9212bd0e76cc3$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount: function(parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $85c9212bd0e76cc3$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = $85c9212bd0e76cc3$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $85c9212bd0e76cc3$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $85c9212bd0e76cc3$var$normalizeSuspenseSlot(isSlotChildren ? children["default"] : children);
    vnode.ssFallback = isSlotChildren ? $85c9212bd0e76cc3$var$normalizeSuspenseSlot(children.fallback) : $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$4d299b491347818a);
}
function $85c9212bd0e76cc3$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $d8jBh.isFunction)(s)) {
        var trackBlock = $85c9212bd0e76cc3$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $85c9212bd0e76cc3$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $85c9212bd0e76cc3$var$currentBlock;
            $85c9212bd0e76cc3$var$closeBlock();
        }
    }
    if ((0, $d8jBh.isArray)(s)) {
        var singleChild = $85c9212bd0e76cc3$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $85c9212bd0e76cc3$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $85c9212bd0e76cc3$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $d8jBh.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $7WNf6._)(fn));
        else suspense.effects.push(fn);
    } else $85c9212bd0e76cc3$export$59536a0199721cab(fn);
}
function $85c9212bd0e76cc3$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $85c9212bd0e76cc3$var$updateHOCHostEl(parentComponent, el);
    }
}
function $85c9212bd0e76cc3$var$isVNodeSuspensible(vnode) {
    var suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
var $85c9212bd0e76cc3$export$ffb0004e005737fa = Symbol["for"]("v-fgt");
var $85c9212bd0e76cc3$export$5f1af8db9871e1d6 = Symbol["for"]("v-txt");
var $85c9212bd0e76cc3$export$4d299b491347818a = Symbol["for"]("v-cmt");
var $85c9212bd0e76cc3$export$c1b9a1d3af45b7b6 = Symbol["for"]("v-stc");
var $85c9212bd0e76cc3$var$blockStack = [];
var $85c9212bd0e76cc3$var$currentBlock = null;
function $85c9212bd0e76cc3$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $85c9212bd0e76cc3$var$blockStack.push($85c9212bd0e76cc3$var$currentBlock = disableTracking ? null : []);
}
function $85c9212bd0e76cc3$var$closeBlock() {
    $85c9212bd0e76cc3$var$blockStack.pop();
    $85c9212bd0e76cc3$var$currentBlock = $85c9212bd0e76cc3$var$blockStack[$85c9212bd0e76cc3$var$blockStack.length - 1] || null;
}
var $85c9212bd0e76cc3$var$isBlockTreeEnabled = 1;
function $85c9212bd0e76cc3$export$c20bee82f26f1e27(value) {
    var inVOnce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $85c9212bd0e76cc3$var$isBlockTreeEnabled += value;
    if (value < 0 && $85c9212bd0e76cc3$var$currentBlock && inVOnce) $85c9212bd0e76cc3$var$currentBlock.hasOnce = true;
}
function $85c9212bd0e76cc3$var$setupBlock(vnode) {
    vnode.dynamicChildren = $85c9212bd0e76cc3$var$isBlockTreeEnabled > 0 ? $85c9212bd0e76cc3$var$currentBlock || (0, $d8jBh.EMPTY_ARR) : null;
    $85c9212bd0e76cc3$var$closeBlock();
    if ($85c9212bd0e76cc3$var$isBlockTreeEnabled > 0 && $85c9212bd0e76cc3$var$currentBlock) $85c9212bd0e76cc3$var$currentBlock.push(vnode);
    return vnode;
}
function $85c9212bd0e76cc3$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $85c9212bd0e76cc3$var$setupBlock($85c9212bd0e76cc3$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $85c9212bd0e76cc3$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $85c9212bd0e76cc3$var$setupBlock($85c9212bd0e76cc3$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $85c9212bd0e76cc3$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $85c9212bd0e76cc3$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $85c9212bd0e76cc3$var$vnodeArgsTransformer;
function $85c9212bd0e76cc3$export$83beccd3afeeb809(transformer) {
    $85c9212bd0e76cc3$var$vnodeArgsTransformer = transformer;
}
var $85c9212bd0e76cc3$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $85c9212bd0e76cc3$var$_createVNode.apply(void 0, (0, $7WNf6._)($85c9212bd0e76cc3$var$vnodeArgsTransformer ? $85c9212bd0e76cc3$var$vnodeArgsTransformer(args, $85c9212bd0e76cc3$var$currentRenderingInstance) : args));
};
var $85c9212bd0e76cc3$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $85c9212bd0e76cc3$var$normalizeRef = function(param) {
    var ref = param.ref, ref_key = param.ref_key, ref_for = param.ref_for;
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $d8jBh.isString)(ref) || (0, $hXmfK.isRef)(ref) || (0, $d8jBh.isFunction)(ref) ? {
        i: $85c9212bd0e76cc3$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $85c9212bd0e76cc3$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : type === $85c9212bd0e76cc3$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $85c9212bd0e76cc3$var$normalizeKey(props),
        ref: props && $85c9212bd0e76cc3$var$normalizeRef(props),
        scopeId: $85c9212bd0e76cc3$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $85c9212bd0e76cc3$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $85c9212bd0e76cc3$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $d8jBh.isString)(children) ? 8 : 16;
    if ($85c9212bd0e76cc3$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $85c9212bd0e76cc3$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $85c9212bd0e76cc3$var$currentBlock.push(vnode);
    return vnode;
}
var $85c9212bd0e76cc3$export$bf5c4cf060303d58 = $85c9212bd0e76cc3$var$_createVNode;
function $85c9212bd0e76cc3$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $85c9212bd0e76cc3$var$NULL_DYNAMIC_COMPONENT) type = $85c9212bd0e76cc3$export$4d299b491347818a;
    if ($85c9212bd0e76cc3$export$3868d13f8734ae81(type)) {
        var cloned = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $85c9212bd0e76cc3$var$normalizeChildren(cloned, children);
        if ($85c9212bd0e76cc3$var$isBlockTreeEnabled > 0 && !isBlockNode && $85c9212bd0e76cc3$var$currentBlock) {
            if (cloned.shapeFlag & 6) $85c9212bd0e76cc3$var$currentBlock[$85c9212bd0e76cc3$var$currentBlock.indexOf(type)] = cloned;
            else $85c9212bd0e76cc3$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($85c9212bd0e76cc3$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $85c9212bd0e76cc3$export$1f1be0e0e384d7d2(props);
        var klass = props["class"], style = props.style;
        if (klass && !(0, $d8jBh.isString)(klass)) props["class"] = (0, $d8jBh.normalizeClass)(klass);
        if ((0, $d8jBh.isObject)(style)) {
            if ((0, $hXmfK.isProxy)(style) && !(0, $d8jBh.isArray)(style)) style = (0, $d8jBh.extend)({}, style);
            props.style = (0, $d8jBh.normalizeStyle)(style);
        }
    }
    var shapeFlag = (0, $d8jBh.isString)(type) ? 1 : $85c9212bd0e76cc3$var$isSuspense(type) ? 128 : $85c9212bd0e76cc3$var$isTeleport(type) ? 64 : (0, $d8jBh.isObject)(type) ? 4 : (0, $d8jBh.isFunction)(type) ? 2 : 0;
    return $85c9212bd0e76cc3$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $85c9212bd0e76cc3$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $hXmfK.isProxy)(props) || $85c9212bd0e76cc3$var$isInternalObject(props) ? (0, $d8jBh.extend)({}, props) : props;
}
function $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cloneTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children, transition = vnode.transition;
    var mergedProps = extraProps ? $85c9212bd0e76cc3$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $85c9212bd0e76cc3$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $d8jBh.isArray)(ref) ? ref.concat($85c9212bd0e76cc3$var$normalizeRef(extraProps)) : [
            ref,
            $85c9212bd0e76cc3$var$normalizeRef(extraProps)
        ] : $85c9212bd0e76cc3$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $85c9212bd0e76cc3$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $85c9212bd0e76cc3$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $85c9212bd0e76cc3$var$deepCloneVNode(vnode) {
    var cloned = $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $d8jBh.isArray)(vnode.children)) cloned.children = vnode.children.map($85c9212bd0e76cc3$var$deepCloneVNode);
    return cloned;
}
function $85c9212bd0e76cc3$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$5f1af8db9871e1d6, null, text, flag);
}
function $85c9212bd0e76cc3$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    var vnode = $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $85c9212bd0e76cc3$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($85c9212bd0e76cc3$export$e7eaa45e502fe5cc(), $85c9212bd0e76cc3$export$9f2dfe8048dfb22b($85c9212bd0e76cc3$export$4d299b491347818a, null, text)) : $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$4d299b491347818a, null, text);
}
function $85c9212bd0e76cc3$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$4d299b491347818a);
    else if ((0, $d8jBh.isArray)(child)) return $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($85c9212bd0e76cc3$export$3868d13f8734ae81(child)) return $85c9212bd0e76cc3$var$cloneIfMounted(child);
    else return $85c9212bd0e76cc3$export$bf5c4cf060303d58($85c9212bd0e76cc3$export$5f1af8db9871e1d6, null, String(child));
}
function $85c9212bd0e76cc3$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $85c9212bd0e76cc3$export$ee4f9e12c0a92a1a(child);
}
function $85c9212bd0e76cc3$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $d8jBh.isArray)(children)) type = 16;
    else if ((typeof children === "undefined" ? "undefined" : (0, $3KZcf._)(children)) === "object") {
        if (shapeFlag & 65) {
            var slot = children["default"];
            if (slot) {
                slot._c && (slot._d = false);
                $85c9212bd0e76cc3$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !$85c9212bd0e76cc3$var$isInternalObject(children)) children._ctx = $85c9212bd0e76cc3$var$currentRenderingInstance;
            else if (slotFlag === 3 && $85c9212bd0e76cc3$var$currentRenderingInstance) {
                if ($85c9212bd0e76cc3$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $d8jBh.isFunction)(children)) {
        children = {
            "default": children,
            _ctx: $85c9212bd0e76cc3$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $85c9212bd0e76cc3$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $85c9212bd0e76cc3$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge){
            if (key === "class") {
                if (ret["class"] !== toMerge["class"]) ret["class"] = (0, $d8jBh.normalizeClass)([
                    ret["class"],
                    toMerge["class"]
                ]);
            } else if (key === "style") ret.style = (0, $d8jBh.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $d8jBh.isOn)(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $d8jBh.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $85c9212bd0e76cc3$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $85c9212bd0e76cc3$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
var $85c9212bd0e76cc3$var$emptyAppContext = $85c9212bd0e76cc3$var$createAppContext();
var $85c9212bd0e76cc3$var$uid = 0;
function $85c9212bd0e76cc3$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || $85c9212bd0e76cc3$var$emptyAppContext;
    var instance = {
        uid: $85c9212bd0e76cc3$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $hXmfK.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $85c9212bd0e76cc3$var$normalizePropsOptions(type, appContext),
        emitsOptions: $85c9212bd0e76cc3$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $d8jBh.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $d8jBh.EMPTY_OBJ),
        data: (0, $d8jBh.EMPTY_OBJ),
        props: (0, $d8jBh.EMPTY_OBJ),
        attrs: (0, $d8jBh.EMPTY_OBJ),
        slots: (0, $d8jBh.EMPTY_OBJ),
        refs: (0, $d8jBh.EMPTY_OBJ),
        setupState: (0, $d8jBh.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $85c9212bd0e76cc3$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
var $85c9212bd0e76cc3$var$currentInstance = null;
var $85c9212bd0e76cc3$export$f13e630aa3915748 = function() {
    return $85c9212bd0e76cc3$var$currentInstance || $85c9212bd0e76cc3$var$currentRenderingInstance;
};
var $85c9212bd0e76cc3$var$internalSetCurrentInstance;
var $85c9212bd0e76cc3$var$setInSSRSetupState;
{
    var $85c9212bd0e76cc3$var$g = (0, $d8jBh.getGlobalThis)();
    var $85c9212bd0e76cc3$var$registerGlobalSetter = function(key, setter) {
        var setters;
        if (!(setters = $85c9212bd0e76cc3$var$g[key])) setters = $85c9212bd0e76cc3$var$g[key] = [];
        setters.push(setter);
        return function(v1) {
            if (setters.length > 1) setters.forEach(function(set) {
                return set(v1);
            });
            else setters[0](v1);
        };
    };
    $85c9212bd0e76cc3$var$internalSetCurrentInstance = $85c9212bd0e76cc3$var$registerGlobalSetter("__VUE_INSTANCE_SETTERS__", function(v1) {
        return $85c9212bd0e76cc3$var$currentInstance = v1;
    });
    $85c9212bd0e76cc3$var$setInSSRSetupState = $85c9212bd0e76cc3$var$registerGlobalSetter("__VUE_SSR_SETTERS__", function(v1) {
        return $85c9212bd0e76cc3$var$isInSSRComponentSetup = v1;
    });
}var $85c9212bd0e76cc3$var$setCurrentInstance = function(instance) {
    var prev = $85c9212bd0e76cc3$var$currentInstance;
    $85c9212bd0e76cc3$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return function() {
        instance.scope.off();
        $85c9212bd0e76cc3$var$internalSetCurrentInstance(prev);
    };
};
var $85c9212bd0e76cc3$var$unsetCurrentInstance = function() {
    $85c9212bd0e76cc3$var$currentInstance && $85c9212bd0e76cc3$var$currentInstance.scope.off();
    $85c9212bd0e76cc3$var$internalSetCurrentInstance(null);
};
var $85c9212bd0e76cc3$var$isBuiltInTag = /* @__PURE__ */ (0, $d8jBh.makeMap)("slot,component");
function $85c9212bd0e76cc3$var$validateComponentName(name, param) {
    var isNativeTag = param.isNativeTag;
    if ($85c9212bd0e76cc3$var$isBuiltInTag(name) || isNativeTag(name)) $85c9212bd0e76cc3$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $85c9212bd0e76cc3$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
var $85c9212bd0e76cc3$var$isInSSRComponentSetup = false;
function $85c9212bd0e76cc3$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, optimized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    isSSR && $85c9212bd0e76cc3$var$setInSSRSetupState(isSSR);
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children;
    var isStateful = $85c9212bd0e76cc3$var$isStatefulComponent(instance);
    $85c9212bd0e76cc3$var$initProps(instance, props, isStateful, isSSR);
    $85c9212bd0e76cc3$var$initSlots(instance, children, optimized || isSSR);
    var setupResult = isStateful ? $85c9212bd0e76cc3$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $85c9212bd0e76cc3$var$setInSSRSetupState(false);
    return setupResult;
}
function $85c9212bd0e76cc3$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    var Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $85c9212bd0e76cc3$var$PublicInstanceProxyHandlers);
    var setup = Component.setup;
    if (setup) {
        (0, $hXmfK.pauseTracking)();
        var setupContext = instance.setupContext = setup.length > 1 ? $85c9212bd0e76cc3$var$createSetupContext(instance) : null;
        var reset = $85c9212bd0e76cc3$var$setCurrentInstance(instance);
        var setupResult = $85c9212bd0e76cc3$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        var isAsyncSetup = (0, $d8jBh.isPromise)(setupResult);
        (0, $hXmfK.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$85c9212bd0e76cc3$var$isAsyncWrapper(instance)) $85c9212bd0e76cc3$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($85c9212bd0e76cc3$var$unsetCurrentInstance, $85c9212bd0e76cc3$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then(function(resolvedResult) {
                $85c9212bd0e76cc3$var$handleSetupResult(instance, resolvedResult, isSSR);
            })["catch"](function(e) {
                $85c9212bd0e76cc3$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $85c9212bd0e76cc3$var$handleSetupResult(instance, setupResult, isSSR);
    } else $85c9212bd0e76cc3$var$finishComponentSetup(instance, isSSR);
}
function $85c9212bd0e76cc3$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $d8jBh.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $d8jBh.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $hXmfK.proxyRefs)(setupResult);
    }
    $85c9212bd0e76cc3$var$finishComponentSetup(instance, isSSR);
}
var $85c9212bd0e76cc3$var$compile;
var $85c9212bd0e76cc3$var$installWithProxy;
function $85c9212bd0e76cc3$export$667bb5a67822b941(_compile) {
    $85c9212bd0e76cc3$var$compile = _compile;
    $85c9212bd0e76cc3$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $85c9212bd0e76cc3$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
var $85c9212bd0e76cc3$export$c93a9c496c5211fa = function() {
    return !$85c9212bd0e76cc3$var$compile;
};
function $85c9212bd0e76cc3$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $85c9212bd0e76cc3$var$compile && !Component.render) {
            var template = Component.template || __VUE_OPTIONS_API__ && $85c9212bd0e76cc3$var$resolveMergedOptions(instance).template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $d8jBh.extend)((0, $d8jBh.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $85c9212bd0e76cc3$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $d8jBh.NOOP);
        if ($85c9212bd0e76cc3$var$installWithProxy) $85c9212bd0e76cc3$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        var reset = $85c9212bd0e76cc3$var$setCurrentInstance(instance);
        (0, $hXmfK.pauseTracking)();
        try {
            $85c9212bd0e76cc3$var$applyOptions(instance);
        } finally{
            (0, $hXmfK.resetTracking)();
            reset();
        }
    }
}
var $85c9212bd0e76cc3$var$attrsProxyHandlers = {
    get: function(target, key) {
        (0, $hXmfK.track)(target, "get", "");
        return target[key];
    }
};
function $85c9212bd0e76cc3$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get: function(target, key) {
            (0, $hXmfK.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $85c9212bd0e76cc3$var$createSetupContext(instance) {
    var expose = function(exposed) {
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $85c9212bd0e76cc3$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $85c9212bd0e76cc3$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $hXmfK.proxyRefs)((0, $hXmfK.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else if (key in $85c9212bd0e76cc3$var$publicPropertiesMap) return $85c9212bd0e76cc3$var$publicPropertiesMap[key](instance);
        },
        has: function(target, key) {
            return key in target || key in $85c9212bd0e76cc3$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
var $85c9212bd0e76cc3$var$classifyRE = /(?:^|[-_])(\w)/g;
var $85c9212bd0e76cc3$var$classify = function(str) {
    return str.replace($85c9212bd0e76cc3$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $85c9212bd0e76cc3$var$getComponentName(Component) {
    var includeInferred = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $d8jBh.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $85c9212bd0e76cc3$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $85c9212bd0e76cc3$var$getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        var inferFromRegistry = function(registry) {
            for(var key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $85c9212bd0e76cc3$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $85c9212bd0e76cc3$var$isClassComponent(value) {
    return (0, $d8jBh.isFunction)(value) && "__vccOpts" in value;
}
var $85c9212bd0e76cc3$export$2983e091f1a1e8e2 = function(getterOrOptions, debugOptions) {
    var c = (0, $hXmfK.computed)(getterOrOptions, debugOptions, $85c9212bd0e76cc3$var$isInSSRComponentSetup);
    return c;
};
function $85c9212bd0e76cc3$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    var l = arguments.length;
    if (l === 2) {
        if ((0, $d8jBh.isObject)(propsOrChildren) && !(0, $d8jBh.isArray)(propsOrChildren)) {
            if ($85c9212bd0e76cc3$export$3868d13f8734ae81(propsOrChildren)) return $85c9212bd0e76cc3$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $85c9212bd0e76cc3$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $85c9212bd0e76cc3$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $85c9212bd0e76cc3$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $85c9212bd0e76cc3$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $85c9212bd0e76cc3$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $hXmfK.toRaw)(instance.props)));
        if (instance.setupState !== (0, $d8jBh.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $d8jBh.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $hXmfK.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $d8jBh.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $7WNf6._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    }
    function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $d8jBh.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $hXmfK.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $d8jBh.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $d8jBh.isArray)(opts) && opts.includes(key) || (0, $d8jBh.isObject)(opts) && key in opts) return true;
        if (Comp["extends"] && isKeyOfType(Comp["extends"], key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
    function genRefFlag(v1) {
        if ((0, $hXmfK.isShallow)(v1)) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    }
}
function $85c9212bd0e76cc3$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $85c9212bd0e76cc3$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $85c9212bd0e76cc3$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++){
        if ((0, $d8jBh.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($85c9212bd0e76cc3$var$isBlockTreeEnabled > 0 && $85c9212bd0e76cc3$var$currentBlock) $85c9212bd0e76cc3$var$currentBlock.push(cached);
    return true;
}
var $85c9212bd0e76cc3$export$83d89fbfd8236492 = "3.5.18";
var $85c9212bd0e76cc3$export$c106dd0671a0fc2d = (0, $d8jBh.NOOP);
var $85c9212bd0e76cc3$export$795e0ad4a0e2ed30 = $85c9212bd0e76cc3$var$ErrorTypeStrings$1;
var $85c9212bd0e76cc3$export$6922d3b3a607469e = $85c9212bd0e76cc3$var$devtools$1;
var $85c9212bd0e76cc3$export$b0c258b32c26c785 = $85c9212bd0e76cc3$var$setDevtoolsHook$1;
var $85c9212bd0e76cc3$var$_ssrUtils = {
    createComponentInstance: $85c9212bd0e76cc3$var$createComponentInstance,
    setupComponent: $85c9212bd0e76cc3$var$setupComponent,
    renderComponentRoot: $85c9212bd0e76cc3$var$renderComponentRoot,
    setCurrentRenderingInstance: $85c9212bd0e76cc3$var$setCurrentRenderingInstance,
    isVNode: $85c9212bd0e76cc3$export$3868d13f8734ae81,
    normalizeVNode: $85c9212bd0e76cc3$var$normalizeVNode,
    getComponentPublicInstance: $85c9212bd0e76cc3$var$getComponentPublicInstance,
    ensureValidVNode: $85c9212bd0e76cc3$var$ensureValidVNode,
    pushWarningContext: $85c9212bd0e76cc3$var$pushWarningContext,
    popWarningContext: $85c9212bd0e76cc3$var$popWarningContext
};
var $85c9212bd0e76cc3$export$a9679033567b336d = $85c9212bd0e76cc3$var$_ssrUtils;
var $85c9212bd0e76cc3$export$83cf26e06ea620e1 = null;
var $85c9212bd0e76cc3$export$dc678eddf276286e = null;
var $85c9212bd0e76cc3$export$22072a82865312f6 = null;

});

parcelRegister("kiZwI", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("bu8yf")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("bu8yf")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("bu8yf")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("d8jBh")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("d8jBh")).capitalize; });
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("bu8yf")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("bu8yf")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("bu8yf")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("bu8yf")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("bu8yf")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("bu8yf")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("bu8yf")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("bu8yf")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("bu8yf")).createRenderer; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("bu8yf")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("bu8yf")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("bu8yf")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("bu8yf")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("bu8yf")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("bu8yf")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("bu8yf")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("bu8yf")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("bu8yf")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("bu8yf")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("hXmfK")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("bu8yf")).isRuntimeOnly; });
$parcel$export(module.exports, "isVNode", function () { return (parcelRequire("bu8yf")).isVNode; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("hXmfK")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("bu8yf")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("bu8yf")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("d8jBh")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("d8jBh")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("bu8yf")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("bu8yf")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("bu8yf")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("bu8yf")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("bu8yf")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("bu8yf")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("bu8yf")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("bu8yf")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("bu8yf")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("bu8yf")).provide; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return (parcelRequire("bu8yf")).queuePostFlushCb; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("hXmfK")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("hXmfK")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("bu8yf")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("bu8yf")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("bu8yf")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("bu8yf")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("bu8yf")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("bu8yf")).setTransitionHooks; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("hXmfK")).shallowRef; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("bu8yf")).Static; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("bu8yf")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("bu8yf")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("hXmfK")).toRaw; });
$parcel$export(module.exports, "useId", function () { return (parcelRequire("bu8yf")).useId; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("bu8yf")).useSlots; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("bu8yf")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("bu8yf")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("bu8yf")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("bu8yf")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("bu8yf")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("bu8yf")).withDirectives; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("d8jBh")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("d8jBh")).toDisplayString; });

$parcel$export(module.exports, "Transition", function () { return $ec8536ffbfd373ec$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $ec8536ffbfd373ec$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "createApp", function () { return $ec8536ffbfd373ec$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "render", function () { return $ec8536ffbfd373ec$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "TransitionGroup", function () { return $ec8536ffbfd373ec$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "vModelText", function () { return $ec8536ffbfd373ec$export$f1f88689f5728478; });
$parcel$export(module.exports, "withModifiers", function () { return $ec8536ffbfd373ec$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $ec8536ffbfd373ec$export$f691a8759658f782; });
/**
* @vue/runtime-dom v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");
var $hXmfK = parcelRequire("hXmfK");parcelRequire("d8jBh");

var $d8jBh = parcelRequire("d8jBh");
var $ec8536ffbfd373ec$var$policy = void 0;
var $ec8536ffbfd373ec$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($ec8536ffbfd373ec$var$tt) try {
    $ec8536ffbfd373ec$var$policy = /* @__PURE__ */ $ec8536ffbfd373ec$var$tt.createPolicy("vue", {
        createHTML: function(val) {
            return val;
        }
    });
} catch (e) {}
var $ec8536ffbfd373ec$var$unsafeToTrustedHTML = $ec8536ffbfd373ec$var$policy ? function(val) {
    return $ec8536ffbfd373ec$var$policy.createHTML(val);
} : function(val) {
    return val;
};
var $ec8536ffbfd373ec$var$svgNS = "http://www.w3.org/2000/svg";
var $ec8536ffbfd373ec$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
var $ec8536ffbfd373ec$var$doc = typeof document !== "undefined" ? document : null;
var $ec8536ffbfd373ec$var$templateContainer = $ec8536ffbfd373ec$var$doc && /* @__PURE__ */ $ec8536ffbfd373ec$var$doc.createElement("template");
var $ec8536ffbfd373ec$var$nodeOps = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, namespace, is, props) {
        var el = namespace === "svg" ? $ec8536ffbfd373ec$var$doc.createElementNS($ec8536ffbfd373ec$var$svgNS, tag) : namespace === "mathml" ? $ec8536ffbfd373ec$var$doc.createElementNS($ec8536ffbfd373ec$var$mathmlNS, tag) : is ? $ec8536ffbfd373ec$var$doc.createElement(tag, {
            is: is
        }) : $ec8536ffbfd373ec$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $ec8536ffbfd373ec$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $ec8536ffbfd373ec$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $ec8536ffbfd373ec$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function(content, parent, anchor, namespace, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $ec8536ffbfd373ec$var$templateContainer.innerHTML = $ec8536ffbfd373ec$var$unsafeToTrustedHTML(namespace === "svg" ? "<svg>".concat(content, "</svg>") : namespace === "mathml" ? "<math>".concat(content, "</math>") : content);
            var template = $ec8536ffbfd373ec$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
var $ec8536ffbfd373ec$var$TRANSITION = "transition";
var $ec8536ffbfd373ec$var$ANIMATION = "animation";
var $ec8536ffbfd373ec$var$vtcKey = Symbol("_vtc");
var $ec8536ffbfd373ec$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        "default": true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $ec8536ffbfd373ec$var$TransitionPropsValidators = /* @__PURE__ */ (0, $d8jBh.extend)({}, (0, $bu8yf.BaseTransitionPropsValidators), $ec8536ffbfd373ec$var$DOMTransitionPropsValidators);
var $ec8536ffbfd373ec$var$decorate$1 = function(t) {
    t.displayName = "Transition";
    t.props = $ec8536ffbfd373ec$var$TransitionPropsValidators;
    return t;
};
var $ec8536ffbfd373ec$export$be58926105124dd4 = /* @__PURE__ */ $ec8536ffbfd373ec$var$decorate$1(function(props, param) {
    var slots = param.slots;
    return (0, $bu8yf.h)((0, $bu8yf.BaseTransition), $ec8536ffbfd373ec$var$resolveTransitionProps(props), slots);
});
var $ec8536ffbfd373ec$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $d8jBh.isArray)(hook)) hook.forEach(function(h2) {
        return h2.apply(void 0, (0, $7WNf6._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $7WNf6._)(args));
};
var $ec8536ffbfd373ec$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $d8jBh.isArray)(hook) ? hook.some(function(h2) {
        return h2.length > 1;
    }) : hook.length > 1 : false;
};
function $ec8536ffbfd373ec$var$resolveTransitionProps(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $ec8536ffbfd373ec$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $ec8536ffbfd373ec$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done, isCancelled) {
        el._enterCancelled = isCancelled;
        $ec8536ffbfd373ec$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $ec8536ffbfd373ec$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        el._isLeaving = false;
        $ec8536ffbfd373ec$var$removeTransitionClass(el, leaveFromClass);
        $ec8536ffbfd373ec$var$removeTransitionClass(el, leaveToClass);
        $ec8536ffbfd373ec$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $ec8536ffbfd373ec$var$callHook(hook, [
                el,
                resolve
            ]);
            $ec8536ffbfd373ec$var$nextFrame(function() {
                $ec8536ffbfd373ec$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $ec8536ffbfd373ec$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$ec8536ffbfd373ec$var$hasExplicitCallback(hook)) $ec8536ffbfd373ec$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $d8jBh.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $ec8536ffbfd373ec$var$callHook(onBeforeEnter, [
                el
            ]);
            $ec8536ffbfd373ec$var$addTransitionClass(el, enterFromClass);
            $ec8536ffbfd373ec$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $ec8536ffbfd373ec$var$callHook(onBeforeAppear, [
                el
            ]);
            $ec8536ffbfd373ec$var$addTransitionClass(el, appearFromClass);
            $ec8536ffbfd373ec$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            el._isLeaving = true;
            var resolve = function() {
                return finishLeave(el, done);
            };
            $ec8536ffbfd373ec$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $ec8536ffbfd373ec$var$forceReflow();
                $ec8536ffbfd373ec$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $ec8536ffbfd373ec$var$addTransitionClass(el, leaveActiveClass);
                $ec8536ffbfd373ec$var$forceReflow();
            }
            $ec8536ffbfd373ec$var$nextFrame(function() {
                if (!el._isLeaving) return;
                $ec8536ffbfd373ec$var$removeTransitionClass(el, leaveFromClass);
                $ec8536ffbfd373ec$var$addTransitionClass(el, leaveToClass);
                if (!$ec8536ffbfd373ec$var$hasExplicitCallback(onLeave)) $ec8536ffbfd373ec$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $ec8536ffbfd373ec$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false, void 0, true);
            $ec8536ffbfd373ec$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true, void 0, true);
            $ec8536ffbfd373ec$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $ec8536ffbfd373ec$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $ec8536ffbfd373ec$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $d8jBh.isObject)(duration)) return [
        $ec8536ffbfd373ec$var$NumberOf(duration.enter),
        $ec8536ffbfd373ec$var$NumberOf(duration.leave)
    ];
    else {
        var n = $ec8536ffbfd373ec$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $ec8536ffbfd373ec$var$NumberOf(val) {
    var res = (0, $d8jBh.toNumber)(val);
    return res;
}
function $ec8536ffbfd373ec$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el[$ec8536ffbfd373ec$var$vtcKey] || (el[$ec8536ffbfd373ec$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $ec8536ffbfd373ec$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el[$ec8536ffbfd373ec$var$vtcKey];
    if (_vtc) {
        _vtc["delete"](cls);
        if (!_vtc.size) el[$ec8536ffbfd373ec$var$vtcKey] = void 0;
    }
}
function $ec8536ffbfd373ec$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $ec8536ffbfd373ec$var$endId = 0;
function $ec8536ffbfd373ec$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$ec8536ffbfd373ec$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $ec8536ffbfd373ec$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $ec8536ffbfd373ec$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties("".concat($ec8536ffbfd373ec$var$TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat($ec8536ffbfd373ec$var$TRANSITION, "Duration"));
    var transitionTimeout = $ec8536ffbfd373ec$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat($ec8536ffbfd373ec$var$ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat($ec8536ffbfd373ec$var$ANIMATION, "Duration"));
    var animationTimeout = $ec8536ffbfd373ec$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === $ec8536ffbfd373ec$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $ec8536ffbfd373ec$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $ec8536ffbfd373ec$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $ec8536ffbfd373ec$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $ec8536ffbfd373ec$var$TRANSITION : $ec8536ffbfd373ec$var$ANIMATION : null;
        propCount = type ? type === $ec8536ffbfd373ec$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $ec8536ffbfd373ec$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties("".concat($ec8536ffbfd373ec$var$TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $ec8536ffbfd373ec$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $7WNf6._)(durations.map(function(d, i) {
        return $ec8536ffbfd373ec$var$toMs(d) + $ec8536ffbfd373ec$var$toMs(delays[i]);
    })));
}
function $ec8536ffbfd373ec$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $ec8536ffbfd373ec$var$forceReflow() {
    return document.body.offsetHeight;
}
function $ec8536ffbfd373ec$var$patchClass(el, value, isSVG) {
    var transitionClasses = el[$ec8536ffbfd373ec$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $7WNf6._)(transitionClasses)) : (0, $7WNf6._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
var $ec8536ffbfd373ec$var$vShowOriginalDisplay = Symbol("_vod");
var $ec8536ffbfd373ec$var$vShowHidden = Symbol("_vsh");
var $ec8536ffbfd373ec$export$5cb4fcdc6937d7e1 = {
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el[$ec8536ffbfd373ec$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $ec8536ffbfd373ec$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $ec8536ffbfd373ec$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $ec8536ffbfd373ec$var$setDisplay(el, false);
            });
        } else $ec8536ffbfd373ec$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $ec8536ffbfd373ec$var$setDisplay(el, value);
    }
};
function $ec8536ffbfd373ec$var$setDisplay(el, value) {
    el.style.display = value ? el[$ec8536ffbfd373ec$var$vShowOriginalDisplay] : "none";
    el[$ec8536ffbfd373ec$var$vShowHidden] = !value;
}
function $ec8536ffbfd373ec$var$initVShowForSSR() {
    $ec8536ffbfd373ec$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
var $ec8536ffbfd373ec$var$CSS_VAR_TEXT = Symbol("");
function $ec8536ffbfd373ec$export$ef28b76f07940108(getter) {
    var instance = (0, $bu8yf.getCurrentInstance)();
    if (!instance) return;
    var updateTeleports = instance.ut = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getter(instance.proxy);
        Array.from(document.querySelectorAll('[data-v-owner="'.concat(instance.uid, '"]'))).forEach(function(node) {
            return $ec8536ffbfd373ec$var$setVarsOnNode(node, vars);
        });
    };
    var setVars = function() {
        var vars = getter(instance.proxy);
        if (instance.ce) $ec8536ffbfd373ec$var$setVarsOnNode(instance.ce, vars);
        else $ec8536ffbfd373ec$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $bu8yf.onBeforeUpdate)(function() {
        (0, $bu8yf.queuePostFlushCb)(setVars);
    });
    (0, $bu8yf.onMounted)(function() {
        (0, $bu8yf.watch)(setVars, (0, $d8jBh.NOOP), {
            flush: "post"
        });
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $bu8yf.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $ec8536ffbfd373ec$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $ec8536ffbfd373ec$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $ec8536ffbfd373ec$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $bu8yf.Fragment)) vnode.children.forEach(function(c) {
        return $ec8536ffbfd373ec$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $bu8yf.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $ec8536ffbfd373ec$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $ec8536ffbfd373ec$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        var cssText = "";
        for(var key in vars){
            var value = (0, $d8jBh.normalizeCssVarValue)(vars[key]);
            style.setProperty("--".concat(key), value);
            cssText += "--".concat(key, ": ").concat(value, ";");
        }
        style[$ec8536ffbfd373ec$var$CSS_VAR_TEXT] = cssText;
    }
}
var $ec8536ffbfd373ec$var$displayRE = /(^|;)\s*display\s*:/;
function $ec8536ffbfd373ec$var$patchStyle(el, prev, next) {
    var style = el.style;
    var isCssString = (0, $d8jBh.isString)(next);
    var hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (!(0, $d8jBh.isString)(prev)) {
                for(var key in prev)if (next[key] == null) $ec8536ffbfd373ec$var$setStyle(style, key, "");
            } else try {
                for(var _iterator = prev.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prevStyle = _step.value;
                    var key1 = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                    if (next[key1] == null) $ec8536ffbfd373ec$var$setStyle(style, key1, "");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        for(var key2 in next){
            if (key2 === "display") hasControlledDisplay = true;
            $ec8536ffbfd373ec$var$setStyle(style, key2, next[key2]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                var cssVarText = style[$ec8536ffbfd373ec$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $ec8536ffbfd373ec$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($ec8536ffbfd373ec$var$vShowOriginalDisplay in el) {
        el[$ec8536ffbfd373ec$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$ec8536ffbfd373ec$var$vShowHidden]) style.display = "none";
    }
}
var $ec8536ffbfd373ec$var$semicolonRE = /[^\\];\s*$/;
var $ec8536ffbfd373ec$var$importantRE = /\s*!important$/;
function $ec8536ffbfd373ec$var$setStyle(style, name, val) {
    if ((0, $d8jBh.isArray)(val)) val.forEach(function(v) {
        return $ec8536ffbfd373ec$var$setStyle(style, name, v);
    });
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            var prefixed = $ec8536ffbfd373ec$var$autoPrefix(style, name);
            if ($ec8536ffbfd373ec$var$importantRE.test(val)) style.setProperty((0, $d8jBh.hyphenate)(prefixed), val.replace($ec8536ffbfd373ec$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
var $ec8536ffbfd373ec$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $ec8536ffbfd373ec$var$prefixCache = {};
function $ec8536ffbfd373ec$var$autoPrefix(style, rawName) {
    var cached = $ec8536ffbfd373ec$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $d8jBh.camelize)(rawName);
    if (name !== "filter" && name in style) return $ec8536ffbfd373ec$var$prefixCache[rawName] = name;
    name = (0, $d8jBh.capitalize)(name);
    for(var i = 0; i < $ec8536ffbfd373ec$var$prefixes.length; i++){
        var prefixed = $ec8536ffbfd373ec$var$prefixes[i] + name;
        if (prefixed in style) return $ec8536ffbfd373ec$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
var $ec8536ffbfd373ec$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $ec8536ffbfd373ec$var$patchAttr(el, key, value, isSVG, instance) {
    var isBoolean = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $d8jBh.isSpecialBooleanAttr)(key);
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($ec8536ffbfd373ec$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($ec8536ffbfd373ec$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $d8jBh.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $d8jBh.isSymbol)(value) ? String(value) : value);
}
function $ec8536ffbfd373ec$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $ec8536ffbfd373ec$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        var oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        var newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $3KZcf._)(el[key]);
        if (type === "boolean") value = (0, $d8jBh.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $ec8536ffbfd373ec$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $ec8536ffbfd373ec$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
var $ec8536ffbfd373ec$var$veiKey = Symbol("_vei");
function $ec8536ffbfd373ec$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var invokers = el[$ec8536ffbfd373ec$var$veiKey] || (el[$ec8536ffbfd373ec$var$veiKey] = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        var _parseName = (0, $32TW8._)($ec8536ffbfd373ec$var$parseName(rawName), 2), name = _parseName[0], options = _parseName[1];
        if (nextValue) {
            var invoker = invokers[rawName] = $ec8536ffbfd373ec$var$createInvoker(nextValue, instance);
            $ec8536ffbfd373ec$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $ec8536ffbfd373ec$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var $ec8536ffbfd373ec$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $ec8536ffbfd373ec$var$parseName(name) {
    var options;
    if ($ec8536ffbfd373ec$var$optionsModifierRE.test(name)) {
        options = {};
        var m;
        while(m = name.match($ec8536ffbfd373ec$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    var event = name[2] === ":" ? name.slice(3) : (0, $d8jBh.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
var $ec8536ffbfd373ec$var$cachedNow = 0;
var $ec8536ffbfd373ec$var$p = /* @__PURE__ */ Promise.resolve();
var $ec8536ffbfd373ec$var$getNow = function() {
    return $ec8536ffbfd373ec$var$cachedNow || ($ec8536ffbfd373ec$var$p.then(function() {
        return $ec8536ffbfd373ec$var$cachedNow = 0;
    }), $ec8536ffbfd373ec$var$cachedNow = Date.now());
};
function $ec8536ffbfd373ec$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $bu8yf.callWithAsyncErrorHandling)($ec8536ffbfd373ec$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $ec8536ffbfd373ec$var$getNow();
    return invoker;
}
function $ec8536ffbfd373ec$var$sanitizeEventValue(value, propName) {
    if ((0, $d8jBh.isFunction)(value) || (0, $d8jBh.isArray)(value)) return value;
    (0, $bu8yf.warn)("Wrong type passed as event handler to ".concat(propName, " - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ").concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value), "."));
    return 0, $d8jBh.NOOP;
}
function $ec8536ffbfd373ec$var$patchStopImmediatePropagation(e, value) {
    if ((0, $d8jBh.isArray)(value)) {
        var originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function() {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(function(fn) {
            return function(e2) {
                return !e2._stopped && fn && fn(e2);
            };
        });
    } else return value;
}
var $ec8536ffbfd373ec$var$isNativeOn = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
};
var $ec8536ffbfd373ec$var$patchProp = function(el, key, prevValue, nextValue, namespace, parentComponent) {
    var isSVG = namespace === "svg";
    if (key === "class") $ec8536ffbfd373ec$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $ec8536ffbfd373ec$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $d8jBh.isOn)(key)) {
        if (!(0, $d8jBh.isModelListener)(key)) $ec8536ffbfd373ec$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $ec8536ffbfd373ec$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $ec8536ffbfd373ec$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $ec8536ffbfd373ec$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $d8jBh.isString)(nextValue))) $ec8536ffbfd373ec$var$patchDOMProp(el, (0, $d8jBh.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $ec8536ffbfd373ec$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $ec8536ffbfd373ec$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $ec8536ffbfd373ec$var$isNativeOn(key) && (0, $d8jBh.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        var tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($ec8536ffbfd373ec$var$isNativeOn(key) && (0, $d8jBh.isString)(value)) return false;
    return key in el;
}
var $ec8536ffbfd373ec$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $ec8536ffbfd373ec$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    var Comp = (0, $bu8yf.defineComponent)(options, extraOptions);
    if ((0, $d8jBh.isPlainObject)(Comp)) (0, $d8jBh.extend)(Comp, extraOptions);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $i3fW3._)(VueCustomElement, VueElement);
        function VueCustomElement(initialProps) {
            (0, $jGAMp._)(this, VueCustomElement);
            return (0, $kzDuW._)(this, VueCustomElement, [
                Comp,
                initialProps,
                _createApp
            ]);
        }
        return VueCustomElement;
    }($ec8536ffbfd373ec$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ var $ec8536ffbfd373ec$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ function(options, extraOptions) {
    return /* @__PURE__ */ $ec8536ffbfd373ec$export$a00e2346eabbdbef(options, extraOptions, $ec8536ffbfd373ec$export$35800275c0037383);
};
var $ec8536ffbfd373ec$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $jGAMp._)(this, _class);
};
var $ec8536ffbfd373ec$export$b337c1a55163dbe3 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $i3fW3._)(VueElement, BaseClass);
    function VueElement(_def) {
        var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _createApp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ec8536ffbfd373ec$export$4e373c34abfa8c68;
        (0, $jGAMp._)(this, VueElement);
        var _this;
        _this = (0, $kzDuW._)(this, VueElement);
        _this._def = _def;
        _this._props = _props;
        _this._createApp = _createApp;
        _this._isVueCE = true;
        /**
     * @internal
     */ _this._instance = null;
        /**
     * @internal
     */ _this._app = null;
        /**
     * @internal
     */ _this._nonce = _this._def.nonce;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        _this._styleChildren = /* @__PURE__ */ new WeakSet();
        _this._ob = null;
        if (_this.shadowRoot && _createApp !== $ec8536ffbfd373ec$export$4e373c34abfa8c68) _this._root = _this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            _this.attachShadow({
                mode: "open"
            });
            _this._root = _this.shadowRoot;
        } else _this._root = _this;
        return _this;
    }
    (0, $byiyg._)(VueElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                if (!this.isConnected) return;
                if (!this.shadowRoot && !this._resolved) this._parseSlots();
                this._connected = true;
                var parent = this;
                while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                    this._parent = parent;
                    break;
                }
                if (!this._instance) {
                    if (this._resolved) this._mount(this._def);
                    else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(function() {
                        _this._pendingResolve = void 0;
                        _this._resolveDef();
                    });
                    else this._resolveDef();
                }
            }
        },
        {
            key: "_setParent",
            value: function _setParent() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent) {
                    this._instance.parent = parent._instance;
                    this._inheritParentContext(parent);
                }
            }
        },
        {
            key: "_inheritParentContext",
            value: function _inheritParentContext() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                (0, $bu8yf.nextTick)(function() {
                    if (!_this._connected) {
                        if (_this._ob) {
                            _this._ob.disconnect();
                            _this._ob = null;
                        }
                        _this._app && _this._app.unmount();
                        if (_this._instance) _this._instance.ce = void 0;
                        _this._app = _this._instance = null;
                    }
                });
            }
        },
        {
            /**
   * resolve inner component definition (handle possible async component)
   */ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                var _this1 = this;
                if (this._pendingResolve) return;
                for(var i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
                this._ob = new MutationObserver(function(mutations) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var m = _step.value;
                            _this._setAttr(m.attributeName);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                this._ob.observe(this, {
                    attributes: true
                });
                var resolve = function(def) {
                    var isAsync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    _this1._resolved = true;
                    _this1._pendingResolve = void 0;
                    var props = def.props, styles = def.styles;
                    var numberProps;
                    if (props && !(0, $d8jBh.isArray)(props)) for(var key in props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            if (key in _this1._props) _this1._props[key] = (0, $d8jBh.toNumber)(_this1._props[key]);
                            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $d8jBh.camelize)(key)] = true;
                        }
                    }
                    _this1._numberProps = numberProps;
                    _this1._resolveProps(def);
                    if (_this1.shadowRoot) _this1._applyStyles(styles);
                    _this1._mount(def);
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) this._pendingResolve = asyncDef().then(function(def) {
                    def.configureApp = _this._def.configureApp;
                    resolve(_this._def = def, true);
                });
                else resolve(this._def);
            }
        },
        {
            key: "_mount",
            value: function _mount(def) {
                var _this, _loop = function(key) {
                    if (!(0, $d8jBh.hasOwn)(_this, key)) Object.defineProperty(_this, key, {
                        // unwrap ref to be consistent with public instance behavior
                        get: function() {
                            return (0, $hXmfK.unref)(exposed[key]);
                        }
                    });
                };
                if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
                this._app = this._createApp(def);
                this._inheritParentContext();
                if (def.configureApp) def.configureApp(this._app);
                this._app._ceVNode = this._createVNode();
                this._app.mount(this._root);
                var exposed = this._instance && this._instance.exposed;
                if (!exposed) return;
                for(var key in exposed)_this = this, _loop(key);
            }
        },
        {
            key: "_resolveProps",
            value: function _resolveProps(def) {
                var props = def.props;
                var declaredPropKeys = (0, $d8jBh.isArray)(props) ? props : Object.keys(props || {});
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _this, _loop = function() {
                        var key = _step1.value;
                        Object.defineProperty(_this, key, {
                            get: function() {
                                return this._getProp(key);
                            },
                            set: function(val) {
                                this._setProp(key, val, true, true);
                            }
                        });
                    };
                    for(var _iterator1 = declaredPropKeys.map((0, $d8jBh.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_this = this, _loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                if (key.startsWith("data-v-")) return;
                var has = this.hasAttribute(key);
                var value = has ? this.getAttribute(key) : $ec8536ffbfd373ec$var$REMOVAL;
                var camelKey = (0, $d8jBh.camelize)(key);
                if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $d8jBh.toNumber)(value);
                this._setProp(camelKey, value, false, true);
            }
        },
        {
            /**
   * @internal
   */ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
   * @internal
   */ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shouldUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                if (val !== this._props[key]) {
                    if (val === $ec8536ffbfd373ec$var$REMOVAL) delete this._props[key];
                    else {
                        this._props[key] = val;
                        if (key === "key" && this._app) this._app._ceVNode.key = val;
                    }
                    if (shouldUpdate && this._instance) this._update();
                    if (shouldReflect) {
                        var ob = this._ob;
                        ob && ob.disconnect();
                        if (val === true) this.setAttribute((0, $d8jBh.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $d8jBh.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $d8jBh.hyphenate)(key));
                        ob && ob.observe(this, {
                            attributes: true
                        });
                    }
                }
            }
        },
        {
            key: "_update",
            value: function _update() {
                var vnode = this._createVNode();
                if (this._app) vnode.appContext = this._app._context;
                $ec8536ffbfd373ec$export$b3890eb0ae9dca99(vnode, this._root);
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var baseProps = {};
                if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
                var vnode = (0, $bu8yf.createVNode)(this._def, (0, $d8jBh.extend)(baseProps, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    _this._instance = instance;
                    instance.ce = _this;
                    instance.isCE = true;
                    var newStyles, s;
                    var dispatch = function(event, args) {
                        _this.dispatchEvent(new CustomEvent(event, (0, $d8jBh.isPlainObject)(args[0]) ? (0, $d8jBh.extend)({
                            detail: args
                        }, args[0]) : {
                            detail: args
                        }));
                    };
                    instance.emit = function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        dispatch(event, args);
                        if ((0, $d8jBh.hyphenate)(event) !== event) dispatch((0, $d8jBh.hyphenate)(event), args);
                    };
                    _this._setParent();
                };
                return vnode;
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles, owner) {
                if (!styles) return;
                if (owner) {
                    if (owner === this._def || this._styleChildren.has(owner)) return;
                    this._styleChildren.add(owner);
                }
                var nonce = this._nonce;
                for(var i = styles.length - 1; i >= 0; i--){
                    var s = document.createElement("style");
                    if (nonce) s.setAttribute("nonce", nonce);
                    s.textContent = styles[i];
                    this.shadowRoot.prepend(s);
                }
            }
        },
        {
            /**
   * Only called when shadowRoot is false
   */ key: "_parseSlots",
            value: function _parseSlots() {
                var slots = this._slots = {};
                var n;
                while(n = this.firstChild){
                    var slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
                    (slots[slotName] || (slots[slotName] = [])).push(n);
                    this.removeChild(n);
                }
            }
        },
        {
            /**
   * Only called when shadowRoot is false
   */ key: "_renderSlots",
            value: function _renderSlots() {
                var outlets = (this._teleportTarget || this).querySelectorAll("slot");
                var scopeId = this._instance.type.__scopeId;
                for(var i = 0; i < outlets.length; i++){
                    var o = outlets[i];
                    var slotName = o.getAttribute("name") || "default";
                    var content = this._slots[slotName];
                    var parent = o.parentNode;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (content) try {
                        for(var _iterator = content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            if (scopeId && n.nodeType === 1) {
                                var id = scopeId + "-s";
                                var walker = document.createTreeWalker(n, 1);
                                n.setAttribute(id, "");
                                var child = void 0;
                                while(child = walker.nextNode())child.setAttribute(id, "");
                            }
                            parent.insertBefore(n, o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else while(o.firstChild)parent.insertBefore(o.firstChild, o);
                    parent.removeChild(o);
                }
            }
        },
        {
            /**
   * @internal
   */ key: "_injectChildStyle",
            value: function _injectChildStyle(comp) {
                this._applyStyles(comp.styles, comp);
            }
        },
        {
            /**
   * @internal
   */ key: "_removeChildStyle",
            value: function _removeChildStyle(comp) {
                var s;
            }
        }
    ]);
    return VueElement;
}($ec8536ffbfd373ec$var$BaseClass);
function $ec8536ffbfd373ec$export$da5acfe93a94e37d(caller) {
    var instance = (0, $bu8yf.getCurrentInstance)();
    var el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $bu8yf.warn)("".concat(caller || "useHost", " called without an active component instance."));
        else (0, $bu8yf.warn)("".concat(caller || "useHost", " can only be used in components defined via defineCustomElement."));
    }
    return null;
}
function $ec8536ffbfd373ec$export$64d45095031fa749() {
    var el = $ec8536ffbfd373ec$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $ec8536ffbfd373ec$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    {
        var instance = (0, $bu8yf.getCurrentInstance)();
        if (!instance) return 0, $d8jBh.EMPTY_OBJ;
        var modules = instance.type.__cssModules;
        if (!modules) return 0, $d8jBh.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $d8jBh.EMPTY_OBJ;
        return mod;
    }
}
var $ec8536ffbfd373ec$var$positionMap = /* @__PURE__ */ new WeakMap();
var $ec8536ffbfd373ec$var$newPositionMap = /* @__PURE__ */ new WeakMap();
var $ec8536ffbfd373ec$var$moveCbKey = Symbol("_moveCb");
var $ec8536ffbfd373ec$var$enterCbKey = Symbol("_enterCb");
var $ec8536ffbfd373ec$var$decorate = function(t) {
    delete t.props.mode;
    return t;
};
var $ec8536ffbfd373ec$var$TransitionGroupImpl = /* @__PURE__ */ $ec8536ffbfd373ec$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $d8jBh.extend)({}, $ec8536ffbfd373ec$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $bu8yf.getCurrentInstance)();
        var state = (0, $bu8yf.useTransitionState)();
        var prevChildren;
        var children;
        (0, $bu8yf.onUpdated)(function() {
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$ec8536ffbfd373ec$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($ec8536ffbfd373ec$var$callPendingCbs);
            prevChildren.forEach($ec8536ffbfd373ec$var$recordPosition);
            var movedChildren = prevChildren.filter($ec8536ffbfd373ec$var$applyTranslation);
            $ec8536ffbfd373ec$var$forceReflow();
            movedChildren.forEach(function(c) {
                var el = c.el;
                var style = el.style;
                $ec8536ffbfd373ec$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el[$ec8536ffbfd373ec$var$moveCbKey] = function(e) {
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$ec8536ffbfd373ec$var$moveCbKey] = null;
                        $ec8536ffbfd373ec$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return function() {
            var rawProps = (0, $hXmfK.toRaw)(props);
            var cssTransitionProps = $ec8536ffbfd373ec$var$resolveTransitionProps(rawProps);
            var tag = rawProps.tag || (0, $bu8yf.Fragment);
            prevChildren = [];
            if (children) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $bu8yf.setTransitionHooks)(child, (0, $bu8yf.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $ec8536ffbfd373ec$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots["default"] ? (0, $bu8yf.getTransitionRawChildren)(slots["default"]()) : [];
            for(var i1 = 0; i1 < children.length; i1++){
                var child1 = children[i1];
                if (child1.key != null) (0, $bu8yf.setTransitionHooks)(child1, (0, $bu8yf.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
            }
            return (0, $bu8yf.createVNode)(tag, null, children);
        };
    }
});
var $ec8536ffbfd373ec$export$19ffa8f511f7bc2e = $ec8536ffbfd373ec$var$TransitionGroupImpl;
function $ec8536ffbfd373ec$var$callPendingCbs(c) {
    var el = c.el;
    if (el[$ec8536ffbfd373ec$var$moveCbKey]) el[$ec8536ffbfd373ec$var$moveCbKey]();
    if (el[$ec8536ffbfd373ec$var$enterCbKey]) el[$ec8536ffbfd373ec$var$enterCbKey]();
}
function $ec8536ffbfd373ec$var$recordPosition(c) {
    $ec8536ffbfd373ec$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $ec8536ffbfd373ec$var$applyTranslation(c) {
    var oldPos = $ec8536ffbfd373ec$var$positionMap.get(c);
    var newPos = $ec8536ffbfd373ec$var$newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function $ec8536ffbfd373ec$var$hasCSSTransform(el, root, moveClass) {
    var clone = el.cloneNode();
    var _vtc = el[$ec8536ffbfd373ec$var$vtcKey];
    if (_vtc) _vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $ec8536ffbfd373ec$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $ec8536ffbfd373ec$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $d8jBh.isArray)(fn) ? function(value) {
        return (0, $d8jBh.invokeArrayFns)(fn, value);
    } : fn;
};
function $ec8536ffbfd373ec$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $ec8536ffbfd373ec$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var $ec8536ffbfd373ec$var$assignKey = Symbol("_assign");
var $ec8536ffbfd373ec$export$f1f88689f5728478 = {
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        $ec8536ffbfd373ec$var$addEventListener(el, lazy ? "change" : "input", function(e) {
            if (e.target.composing) return;
            var domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $d8jBh.looseToNumber)(domValue);
            el[$ec8536ffbfd373ec$var$assignKey](domValue);
        });
        if (trim) $ec8536ffbfd373ec$var$addEventListener(el, "change", function() {
            el.value = el.value.trim();
        });
        if (!lazy) {
            $ec8536ffbfd373ec$var$addEventListener(el, "compositionstart", $ec8536ffbfd373ec$var$onCompositionStart);
            $ec8536ffbfd373ec$var$addEventListener(el, "compositionend", $ec8536ffbfd373ec$var$onCompositionEnd);
            $ec8536ffbfd373ec$var$addEventListener(el, "change", $ec8536ffbfd373ec$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function(el, param) {
        var value = param.value;
        el.value = value == null ? "" : value;
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue, _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        if (el.composing) return;
        var elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $d8jBh.looseToNumber)(el.value) : el.value;
        var newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
var $ec8536ffbfd373ec$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function(el, _, vnode) {
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        $ec8536ffbfd373ec$var$addEventListener(el, "change", function() {
            var modelValue = el._modelValue;
            var elementValue = $ec8536ffbfd373ec$var$getValue(el);
            var checked = el.checked;
            var assign = el[$ec8536ffbfd373ec$var$assignKey];
            if ((0, $d8jBh.isArray)(modelValue)) {
                var index = (0, $d8jBh.looseIndexOf)(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    var filtered = (0, $7WNf6._)(modelValue);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $d8jBh.isSet)(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned["delete"](elementValue);
                assign(cloned);
            } else assign($ec8536ffbfd373ec$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $ec8536ffbfd373ec$var$setChecked,
    beforeUpdate: function(el, binding, vnode) {
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        $ec8536ffbfd373ec$var$setChecked(el, binding, vnode);
    }
};
function $ec8536ffbfd373ec$var$setChecked(el, param, vnode) {
    var value = param.value, oldValue = param.oldValue;
    el._modelValue = value;
    var checked;
    if ((0, $d8jBh.isArray)(value)) checked = (0, $d8jBh.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $d8jBh.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $d8jBh.looseEqual)(value, $ec8536ffbfd373ec$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
var $ec8536ffbfd373ec$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $d8jBh.looseEqual)(value, vnode.props.value);
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        $ec8536ffbfd373ec$var$addEventListener(el, "change", function() {
            el[$ec8536ffbfd373ec$var$assignKey]($ec8536ffbfd373ec$var$getValue(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $d8jBh.looseEqual)(value, vnode.props.value);
    }
};
var $ec8536ffbfd373ec$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        var isSetModel = (0, $d8jBh.isSet)(value);
        $ec8536ffbfd373ec$var$addEventListener(el, "change", function() {
            var selectedVal = Array.prototype.filter.call(el.options, function(o) {
                return o.selected;
            }).map(function(o) {
                return number ? (0, $d8jBh.looseToNumber)($ec8536ffbfd373ec$var$getValue(o)) : $ec8536ffbfd373ec$var$getValue(o);
            });
            el[$ec8536ffbfd373ec$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $bu8yf.nextTick)(function() {
                el._assigning = false;
            });
        });
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function(el, param) {
        var value = param.value;
        $ec8536ffbfd373ec$var$setSelected(el, value);
    },
    beforeUpdate: function(el, _binding, vnode) {
        el[$ec8536ffbfd373ec$var$assignKey] = $ec8536ffbfd373ec$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value;
        if (!el._assigning) $ec8536ffbfd373ec$var$setSelected(el, value);
    }
};
function $ec8536ffbfd373ec$var$setSelected(el, value) {
    var _loop = function(i, l) {
        var option = el.options[i];
        var optionValue = $ec8536ffbfd373ec$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                var optionType = typeof optionValue === "undefined" ? "undefined" : (0, $3KZcf._)(optionValue);
                if (optionType === "string" || optionType === "number") option.selected = value.some(function(v) {
                    return String(v) === String(optionValue);
                });
                else option.selected = (0, $d8jBh.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $d8jBh.looseEqual)($ec8536ffbfd373ec$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return {
                v: void void 0
            };
        }
    };
    var isMultiple = el.multiple;
    var isArrayValue = (0, $d8jBh.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $d8jBh.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var _ret = _loop(i, l);
        if ((0, $3KZcf._)(_ret) === "object") return _ret.v;
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $ec8536ffbfd373ec$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $ec8536ffbfd373ec$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var $ec8536ffbfd373ec$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $ec8536ffbfd373ec$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $ec8536ffbfd373ec$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $ec8536ffbfd373ec$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $ec8536ffbfd373ec$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $ec8536ffbfd373ec$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $ec8536ffbfd373ec$export$87d227567b51ca39;
        case "TEXTAREA":
            return $ec8536ffbfd373ec$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $ec8536ffbfd373ec$export$8847c2e532b35714;
                case "radio":
                    return $ec8536ffbfd373ec$export$b4356c59b38b7aa9;
                default:
                    return $ec8536ffbfd373ec$export$f1f88689f5728478;
            }
    }
}
function $ec8536ffbfd373ec$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse = $ec8536ffbfd373ec$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $ec8536ffbfd373ec$var$initVModelForSSR() {
    $ec8536ffbfd373ec$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $ec8536ffbfd373ec$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $d8jBh.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $ec8536ffbfd373ec$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $d8jBh.isArray)(value)) {
            if (vnode.props && (0, $d8jBh.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $d8jBh.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $ec8536ffbfd373ec$export$5ad5c0e01ff62c5.getSSRProps = function(binding, vnode) {
        if (typeof vnode.type !== "string") return;
        var modelToUse = $ec8536ffbfd373ec$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
var $ec8536ffbfd373ec$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $ec8536ffbfd373ec$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $ec8536ffbfd373ec$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
var $ec8536ffbfd373ec$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    var cache = fn._withMods || (fn._withMods = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $ec8536ffbfd373ec$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $7WNf6._)(args)));
    });
};
var $ec8536ffbfd373ec$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    "delete": "backspace"
};
var $ec8536ffbfd373ec$export$f691a8759658f782 = function(fn, modifiers) {
    var cache = fn._withKeys || (fn._withKeys = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $d8jBh.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $ec8536ffbfd373ec$var$keyNames[k] === eventKey;
        })) return fn(event);
    });
};
var $ec8536ffbfd373ec$var$rendererOptions = /* @__PURE__ */ (0, $d8jBh.extend)({
    patchProp: $ec8536ffbfd373ec$var$patchProp
}, $ec8536ffbfd373ec$var$nodeOps);
var $ec8536ffbfd373ec$var$renderer;
var $ec8536ffbfd373ec$var$enabledHydration = false;
function $ec8536ffbfd373ec$var$ensureRenderer() {
    return $ec8536ffbfd373ec$var$renderer || ($ec8536ffbfd373ec$var$renderer = (0, $bu8yf.createRenderer)($ec8536ffbfd373ec$var$rendererOptions));
}
function $ec8536ffbfd373ec$var$ensureHydrationRenderer() {
    $ec8536ffbfd373ec$var$renderer = $ec8536ffbfd373ec$var$enabledHydration ? $ec8536ffbfd373ec$var$renderer : (0, $bu8yf.createHydrationRenderer)($ec8536ffbfd373ec$var$rendererOptions);
    $ec8536ffbfd373ec$var$enabledHydration = true;
    return $ec8536ffbfd373ec$var$renderer;
}
var $ec8536ffbfd373ec$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $ec8536ffbfd373ec$var$ensureRenderer()).render.apply(_ensureRenderer, (0, $7WNf6._)(args));
};
var $ec8536ffbfd373ec$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $ec8536ffbfd373ec$var$ensureHydrationRenderer()).hydrate.apply(_ensureHydrationRenderer, (0, $7WNf6._)(args));
};
var $ec8536ffbfd373ec$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $ec8536ffbfd373ec$var$ensureRenderer()).createApp.apply(_ensureRenderer, (0, $7WNf6._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $ec8536ffbfd373ec$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $d8jBh.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        var proxy = mount(container, false, $ec8536ffbfd373ec$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $ec8536ffbfd373ec$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    var app = (_ensureHydrationRenderer = $ec8536ffbfd373ec$var$ensureHydrationRenderer()).createApp.apply(_ensureHydrationRenderer, (0, $7WNf6._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $ec8536ffbfd373ec$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $ec8536ffbfd373ec$var$resolveRootNamespace(container));
    };
    return app;
};
function $ec8536ffbfd373ec$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $ec8536ffbfd373ec$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $d8jBh.isHTMLTag)(tag) || (0, $d8jBh.isSVGTag)(tag) || (0, $d8jBh.isMathMLTag)(tag);
        },
        writable: false
    });
}
function $ec8536ffbfd373ec$var$injectCompilerOptionsCheck(app) {
    if ((0, $bu8yf.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $bu8yf.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $bu8yf.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $bu8yf.warn)(msg);
            }
        });
    }
}
function $ec8536ffbfd373ec$var$normalizeContainer(container) {
    if ((0, $d8jBh.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $ec8536ffbfd373ec$var$ssrDirectiveInitialized = false;
var $ec8536ffbfd373ec$export$800b28255aa678d9 = function() {
    if (!$ec8536ffbfd373ec$var$ssrDirectiveInitialized) {
        $ec8536ffbfd373ec$var$ssrDirectiveInitialized = true;
        $ec8536ffbfd373ec$var$initVModelForSSR();
        $ec8536ffbfd373ec$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $hXmfK);

});



parcelRegister("lGUYa", function(module, exports) {

$parcel$export(module.exports, "BackSide", function () { return (parcelRequire("dRnj4")).BackSide; });
$parcel$export(module.exports, "Matrix4", function () { return (parcelRequire("dRnj4")).Matrix4; });
$parcel$export(module.exports, "Mesh", function () { return (parcelRequire("dRnj4")).Mesh; });
$parcel$export(module.exports, "MeshBasicMaterial", function () { return (parcelRequire("dRnj4")).MeshBasicMaterial; });
$parcel$export(module.exports, "Vector2", function () { return (parcelRequire("dRnj4")).Vector2; });
$parcel$export(module.exports, "Vector3", function () { return (parcelRequire("dRnj4")).Vector3; });
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");

var $dRnj4 = parcelRequire("dRnj4");
function $fca9b62618900888$var$WebGLAnimation() {
    var context = null;
    var isAnimating = false;
    var animationLoop = null;
    var requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function start() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function stop() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function setAnimationLoop(callback) {
            animationLoop = callback;
        },
        setContext: function setContext(value) {
            context = value;
        }
    };
}
function $fca9b62618900888$var$WebGLAttributes(gl) {
    var buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        var array = attribute.array;
        var usage = attribute.usage;
        var size = array.byteLength;
        var buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        var type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        var array = attribute.array;
        var updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort(function(a, b) {
                return a.start - b.start;
            });
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            var mergeIndex = 0;
            for(var i = 1; i < updateRanges.length; i++){
                var previousRange = updateRanges[mergeIndex];
                var range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(var i1 = 0, l = updateRanges.length; i1 < l; i1++){
                var range1 = updateRanges[i1];
                gl.bufferSubData(bufferType, range1.start * array.BYTES_PER_ELEMENT, array, range1.start, range1.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        var data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers["delete"](attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            var cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        var data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $fca9b62618900888$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $fca9b62618900888$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $fca9b62618900888$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $fca9b62618900888$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $fca9b62618900888$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $fca9b62618900888$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $fca9b62618900888$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $fca9b62618900888$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $fca9b62618900888$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $fca9b62618900888$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $fca9b62618900888$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $fca9b62618900888$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $fca9b62618900888$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $fca9b62618900888$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $fca9b62618900888$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $fca9b62618900888$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $fca9b62618900888$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $fca9b62618900888$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $fca9b62618900888$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $fca9b62618900888$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $fca9b62618900888$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $fca9b62618900888$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $fca9b62618900888$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $fca9b62618900888$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $fca9b62618900888$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $fca9b62618900888$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $fca9b62618900888$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $fca9b62618900888$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $fca9b62618900888$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $fca9b62618900888$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $fca9b62618900888$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $fca9b62618900888$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $fca9b62618900888$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $fca9b62618900888$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $fca9b62618900888$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $fca9b62618900888$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $fca9b62618900888$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $fca9b62618900888$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $fca9b62618900888$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $fca9b62618900888$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $fca9b62618900888$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $fca9b62618900888$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $fca9b62618900888$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $fca9b62618900888$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $fca9b62618900888$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $fca9b62618900888$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $fca9b62618900888$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $fca9b62618900888$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $fca9b62618900888$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $fca9b62618900888$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $fca9b62618900888$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $fca9b62618900888$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $fca9b62618900888$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $fca9b62618900888$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $fca9b62618900888$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $fca9b62618900888$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $fca9b62618900888$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $fca9b62618900888$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $fca9b62618900888$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $fca9b62618900888$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $fca9b62618900888$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $fca9b62618900888$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $fca9b62618900888$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $fca9b62618900888$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $fca9b62618900888$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $fca9b62618900888$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $fca9b62618900888$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $fca9b62618900888$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $fca9b62618900888$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $fca9b62618900888$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $fca9b62618900888$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $fca9b62618900888$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $fca9b62618900888$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $fca9b62618900888$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $fca9b62618900888$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $fca9b62618900888$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $fca9b62618900888$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $fca9b62618900888$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $fca9b62618900888$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $fca9b62618900888$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $fca9b62618900888$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $fca9b62618900888$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $fca9b62618900888$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $fca9b62618900888$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $fca9b62618900888$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $fca9b62618900888$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $fca9b62618900888$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $fca9b62618900888$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $fca9b62618900888$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $fca9b62618900888$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $fca9b62618900888$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $fca9b62618900888$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $fca9b62618900888$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $fca9b62618900888$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $fca9b62618900888$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $fca9b62618900888$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $fca9b62618900888$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $fca9b62618900888$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $fca9b62618900888$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $fca9b62618900888$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $fca9b62618900888$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $fca9b62618900888$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $fca9b62618900888$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $fca9b62618900888$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $fca9b62618900888$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $fca9b62618900888$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $fca9b62618900888$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var $fca9b62618900888$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var $fca9b62618900888$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $fca9b62618900888$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $fca9b62618900888$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $fca9b62618900888$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $fca9b62618900888$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $fca9b62618900888$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var $fca9b62618900888$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
var $fca9b62618900888$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var $fca9b62618900888$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var $fca9b62618900888$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var $fca9b62618900888$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $fca9b62618900888$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $fca9b62618900888$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var $fca9b62618900888$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var $fca9b62618900888$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
var $fca9b62618900888$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
var $fca9b62618900888$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $fca9b62618900888$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $fca9b62618900888$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
var $fca9b62618900888$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $fca9b62618900888$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
var $fca9b62618900888$export$955f9f2e84c43c8b = {
    alphahash_fragment: $fca9b62618900888$var$alphahash_fragment,
    alphahash_pars_fragment: $fca9b62618900888$var$alphahash_pars_fragment,
    alphamap_fragment: $fca9b62618900888$var$alphamap_fragment,
    alphamap_pars_fragment: $fca9b62618900888$var$alphamap_pars_fragment,
    alphatest_fragment: $fca9b62618900888$var$alphatest_fragment,
    alphatest_pars_fragment: $fca9b62618900888$var$alphatest_pars_fragment,
    aomap_fragment: $fca9b62618900888$var$aomap_fragment,
    aomap_pars_fragment: $fca9b62618900888$var$aomap_pars_fragment,
    batching_pars_vertex: $fca9b62618900888$var$batching_pars_vertex,
    batching_vertex: $fca9b62618900888$var$batching_vertex,
    begin_vertex: $fca9b62618900888$var$begin_vertex,
    beginnormal_vertex: $fca9b62618900888$var$beginnormal_vertex,
    bsdfs: $fca9b62618900888$var$bsdfs,
    iridescence_fragment: $fca9b62618900888$var$iridescence_fragment,
    bumpmap_pars_fragment: $fca9b62618900888$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $fca9b62618900888$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $fca9b62618900888$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $fca9b62618900888$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $fca9b62618900888$var$clipping_planes_vertex,
    color_fragment: $fca9b62618900888$var$color_fragment,
    color_pars_fragment: $fca9b62618900888$var$color_pars_fragment,
    color_pars_vertex: $fca9b62618900888$var$color_pars_vertex,
    color_vertex: $fca9b62618900888$var$color_vertex,
    common: $fca9b62618900888$var$common,
    cube_uv_reflection_fragment: $fca9b62618900888$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $fca9b62618900888$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $fca9b62618900888$var$displacementmap_pars_vertex,
    displacementmap_vertex: $fca9b62618900888$var$displacementmap_vertex,
    emissivemap_fragment: $fca9b62618900888$var$emissivemap_fragment,
    emissivemap_pars_fragment: $fca9b62618900888$var$emissivemap_pars_fragment,
    colorspace_fragment: $fca9b62618900888$var$colorspace_fragment,
    colorspace_pars_fragment: $fca9b62618900888$var$colorspace_pars_fragment,
    envmap_fragment: $fca9b62618900888$var$envmap_fragment,
    envmap_common_pars_fragment: $fca9b62618900888$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $fca9b62618900888$var$envmap_pars_fragment,
    envmap_pars_vertex: $fca9b62618900888$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $fca9b62618900888$var$envmap_physical_pars_fragment,
    envmap_vertex: $fca9b62618900888$var$envmap_vertex,
    fog_vertex: $fca9b62618900888$var$fog_vertex,
    fog_pars_vertex: $fca9b62618900888$var$fog_pars_vertex,
    fog_fragment: $fca9b62618900888$var$fog_fragment,
    fog_pars_fragment: $fca9b62618900888$var$fog_pars_fragment,
    gradientmap_pars_fragment: $fca9b62618900888$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $fca9b62618900888$var$lightmap_pars_fragment,
    lights_lambert_fragment: $fca9b62618900888$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $fca9b62618900888$var$lights_lambert_pars_fragment,
    lights_pars_begin: $fca9b62618900888$var$lights_pars_begin,
    lights_toon_fragment: $fca9b62618900888$var$lights_toon_fragment,
    lights_toon_pars_fragment: $fca9b62618900888$var$lights_toon_pars_fragment,
    lights_phong_fragment: $fca9b62618900888$var$lights_phong_fragment,
    lights_phong_pars_fragment: $fca9b62618900888$var$lights_phong_pars_fragment,
    lights_physical_fragment: $fca9b62618900888$var$lights_physical_fragment,
    lights_physical_pars_fragment: $fca9b62618900888$var$lights_physical_pars_fragment,
    lights_fragment_begin: $fca9b62618900888$var$lights_fragment_begin,
    lights_fragment_maps: $fca9b62618900888$var$lights_fragment_maps,
    lights_fragment_end: $fca9b62618900888$var$lights_fragment_end,
    logdepthbuf_fragment: $fca9b62618900888$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $fca9b62618900888$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $fca9b62618900888$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $fca9b62618900888$var$logdepthbuf_vertex,
    map_fragment: $fca9b62618900888$var$map_fragment,
    map_pars_fragment: $fca9b62618900888$var$map_pars_fragment,
    map_particle_fragment: $fca9b62618900888$var$map_particle_fragment,
    map_particle_pars_fragment: $fca9b62618900888$var$map_particle_pars_fragment,
    metalnessmap_fragment: $fca9b62618900888$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $fca9b62618900888$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $fca9b62618900888$var$morphinstance_vertex,
    morphcolor_vertex: $fca9b62618900888$var$morphcolor_vertex,
    morphnormal_vertex: $fca9b62618900888$var$morphnormal_vertex,
    morphtarget_pars_vertex: $fca9b62618900888$var$morphtarget_pars_vertex,
    morphtarget_vertex: $fca9b62618900888$var$morphtarget_vertex,
    normal_fragment_begin: $fca9b62618900888$var$normal_fragment_begin,
    normal_fragment_maps: $fca9b62618900888$var$normal_fragment_maps,
    normal_pars_fragment: $fca9b62618900888$var$normal_pars_fragment,
    normal_pars_vertex: $fca9b62618900888$var$normal_pars_vertex,
    normal_vertex: $fca9b62618900888$var$normal_vertex,
    normalmap_pars_fragment: $fca9b62618900888$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $fca9b62618900888$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $fca9b62618900888$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $fca9b62618900888$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $fca9b62618900888$var$iridescence_pars_fragment,
    opaque_fragment: $fca9b62618900888$var$opaque_fragment,
    packing: $fca9b62618900888$var$packing,
    premultiplied_alpha_fragment: $fca9b62618900888$var$premultiplied_alpha_fragment,
    project_vertex: $fca9b62618900888$var$project_vertex,
    dithering_fragment: $fca9b62618900888$var$dithering_fragment,
    dithering_pars_fragment: $fca9b62618900888$var$dithering_pars_fragment,
    roughnessmap_fragment: $fca9b62618900888$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $fca9b62618900888$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $fca9b62618900888$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $fca9b62618900888$var$shadowmap_pars_vertex,
    shadowmap_vertex: $fca9b62618900888$var$shadowmap_vertex,
    shadowmask_pars_fragment: $fca9b62618900888$var$shadowmask_pars_fragment,
    skinbase_vertex: $fca9b62618900888$var$skinbase_vertex,
    skinning_pars_vertex: $fca9b62618900888$var$skinning_pars_vertex,
    skinning_vertex: $fca9b62618900888$var$skinning_vertex,
    skinnormal_vertex: $fca9b62618900888$var$skinnormal_vertex,
    specularmap_fragment: $fca9b62618900888$var$specularmap_fragment,
    specularmap_pars_fragment: $fca9b62618900888$var$specularmap_pars_fragment,
    tonemapping_fragment: $fca9b62618900888$var$tonemapping_fragment,
    tonemapping_pars_fragment: $fca9b62618900888$var$tonemapping_pars_fragment,
    transmission_fragment: $fca9b62618900888$var$transmission_fragment,
    transmission_pars_fragment: $fca9b62618900888$var$transmission_pars_fragment,
    uv_pars_fragment: $fca9b62618900888$var$uv_pars_fragment,
    uv_pars_vertex: $fca9b62618900888$var$uv_pars_vertex,
    uv_vertex: $fca9b62618900888$var$uv_vertex,
    worldpos_vertex: $fca9b62618900888$var$worldpos_vertex,
    background_vert: $fca9b62618900888$var$vertex$h,
    background_frag: $fca9b62618900888$var$fragment$h,
    backgroundCube_vert: $fca9b62618900888$var$vertex$g,
    backgroundCube_frag: $fca9b62618900888$var$fragment$g,
    cube_vert: $fca9b62618900888$var$vertex$f,
    cube_frag: $fca9b62618900888$var$fragment$f,
    depth_vert: $fca9b62618900888$var$vertex$e,
    depth_frag: $fca9b62618900888$var$fragment$e,
    distanceRGBA_vert: $fca9b62618900888$var$vertex$d,
    distanceRGBA_frag: $fca9b62618900888$var$fragment$d,
    equirect_vert: $fca9b62618900888$var$vertex$c,
    equirect_frag: $fca9b62618900888$var$fragment$c,
    linedashed_vert: $fca9b62618900888$var$vertex$b,
    linedashed_frag: $fca9b62618900888$var$fragment$b,
    meshbasic_vert: $fca9b62618900888$var$vertex$a,
    meshbasic_frag: $fca9b62618900888$var$fragment$a,
    meshlambert_vert: $fca9b62618900888$var$vertex$9,
    meshlambert_frag: $fca9b62618900888$var$fragment$9,
    meshmatcap_vert: $fca9b62618900888$var$vertex$8,
    meshmatcap_frag: $fca9b62618900888$var$fragment$8,
    meshnormal_vert: $fca9b62618900888$var$vertex$7,
    meshnormal_frag: $fca9b62618900888$var$fragment$7,
    meshphong_vert: $fca9b62618900888$var$vertex$6,
    meshphong_frag: $fca9b62618900888$var$fragment$6,
    meshphysical_vert: $fca9b62618900888$var$vertex$5,
    meshphysical_frag: $fca9b62618900888$var$fragment$5,
    meshtoon_vert: $fca9b62618900888$var$vertex$4,
    meshtoon_frag: $fca9b62618900888$var$fragment$4,
    points_vert: $fca9b62618900888$var$vertex$3,
    points_frag: $fca9b62618900888$var$fragment$3,
    shadow_vert: $fca9b62618900888$var$vertex$2,
    shadow_frag: $fca9b62618900888$var$fragment$2,
    sprite_vert: $fca9b62618900888$var$vertex$1,
    sprite_frag: $fca9b62618900888$var$fragment$1
};
// Uniforms library for shared webgl shaders
var $fca9b62618900888$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dRnj4.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $dRnj4.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $dRnj4.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dRnj4.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $dRnj4.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $dRnj4.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
var $fca9b62618900888$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.specularmap,
            $fca9b62618900888$export$6643083551874bf5.envmap,
            $fca9b62618900888$export$6643083551874bf5.aomap,
            $fca9b62618900888$export$6643083551874bf5.lightmap,
            $fca9b62618900888$export$6643083551874bf5.fog
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.specularmap,
            $fca9b62618900888$export$6643083551874bf5.envmap,
            $fca9b62618900888$export$6643083551874bf5.aomap,
            $fca9b62618900888$export$6643083551874bf5.lightmap,
            $fca9b62618900888$export$6643083551874bf5.emissivemap,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            $fca9b62618900888$export$6643083551874bf5.fog,
            $fca9b62618900888$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.specularmap,
            $fca9b62618900888$export$6643083551874bf5.envmap,
            $fca9b62618900888$export$6643083551874bf5.aomap,
            $fca9b62618900888$export$6643083551874bf5.lightmap,
            $fca9b62618900888$export$6643083551874bf5.emissivemap,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            $fca9b62618900888$export$6643083551874bf5.fog,
            $fca9b62618900888$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.envmap,
            $fca9b62618900888$export$6643083551874bf5.aomap,
            $fca9b62618900888$export$6643083551874bf5.lightmap,
            $fca9b62618900888$export$6643083551874bf5.emissivemap,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            $fca9b62618900888$export$6643083551874bf5.roughnessmap,
            $fca9b62618900888$export$6643083551874bf5.metalnessmap,
            $fca9b62618900888$export$6643083551874bf5.fog,
            $fca9b62618900888$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.aomap,
            $fca9b62618900888$export$6643083551874bf5.lightmap,
            $fca9b62618900888$export$6643083551874bf5.emissivemap,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            $fca9b62618900888$export$6643083551874bf5.gradientmap,
            $fca9b62618900888$export$6643083551874bf5.fog,
            $fca9b62618900888$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            $fca9b62618900888$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.points,
            $fca9b62618900888$export$6643083551874bf5.fog
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.bumpmap,
            $fca9b62618900888$export$6643083551874bf5.normalmap,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.sprite,
            $fca9b62618900888$export$6643083551874bf5.fog
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            }
        },
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.common,
            $fca9b62618900888$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
            $fca9b62618900888$export$6643083551874bf5.lights,
            $fca9b62618900888$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.shadow_frag
    }
};
$fca9b62618900888$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $dRnj4.mergeUniforms)([
        $fca9b62618900888$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $dRnj4.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $dRnj4.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $dRnj4.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $dRnj4.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $dRnj4.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $dRnj4.Matrix3)()
            }
        }
    ]),
    vertexShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $fca9b62618900888$export$955f9f2e84c43c8b.meshphysical_frag
};
var $fca9b62618900888$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
var $fca9b62618900888$var$_e1$1 = /*@__PURE__*/ new (0, $dRnj4.Euler)();
var $fca9b62618900888$var$_m1$1 = /*@__PURE__*/ new (0, $dRnj4.Matrix4)();
function $fca9b62618900888$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    var clearColor = new (0, $dRnj4.Color)(0x000000);
    var clearAlpha = alpha === true ? 0 : 1;
    var planeMesh;
    var boxMesh;
    var currentBackground = null;
    var currentBackgroundVersion = 0;
    var currentTonemapping = null;
    function getBackground(scene) {
        var background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            var usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        var forceClear = false;
        var background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        var environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        var background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $dRnj4.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $dRnj4.Mesh)(new (0, $dRnj4.BoxGeometry)(1, 1, 1), new (0, $dRnj4.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $dRnj4.cloneUniforms)($fca9b62618900888$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $fca9b62618900888$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $fca9b62618900888$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $dRnj4.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function get() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $fca9b62618900888$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $fca9b62618900888$var$_e1$1.x *= -1;
            $fca9b62618900888$var$_e1$1.y *= -1;
            $fca9b62618900888$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $fca9b62618900888$var$_e1$1.y *= -1;
                $fca9b62618900888$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($fca9b62618900888$var$_m1$1.makeRotationFromEuler($fca9b62618900888$var$_e1$1));
            boxMesh.material.toneMapped = (0, $dRnj4.ColorManagement).getTransfer(background.colorSpace) !== (0, $dRnj4.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $dRnj4.Mesh)(new (0, $dRnj4.PlaneGeometry)(2, 2), new (0, $dRnj4.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $dRnj4.cloneUniforms)($fca9b62618900888$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $fca9b62618900888$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $fca9b62618900888$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $dRnj4.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function get() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $dRnj4.ColorManagement).getTransfer(background.colorSpace) !== (0, $dRnj4.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($fca9b62618900888$var$_rgb, (0, $dRnj4.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear($fca9b62618900888$var$_rgb.r, $fca9b62618900888$var$_rgb.g, $fca9b62618900888$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function getClearColor() {
            return clearColor;
        },
        setClearColor: function setClearColor(color) {
            var _$alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            clearColor.set(color);
            clearAlpha = _$alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function getClearAlpha() {
            return clearAlpha;
        },
        setClearAlpha: function setClearAlpha(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $fca9b62618900888$var$WebGLBindingStates(gl, attributes) {
    var maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    var bindingStates = {};
    var defaultState = createBindingState(null);
    var currentState = defaultState;
    var forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        var updateBuffers = false;
        var state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        var wireframe = material.wireframe === true;
        var programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        var stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        var state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        var newAttributes = [];
        var enabledAttributes = [];
        var attributeDivisors = [];
        for(var i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        var cachedAttributes = currentState.attributes;
        var geometryAttributes = geometry.attributes;
        var attributesNum = 0;
        var programAttributes = program.getAttributes();
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var cachedAttribute = cachedAttributes[name];
                var geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        var cache = {};
        var attributes = geometry.attributes;
        var attributesNum = 0;
        var programAttributes = program.getAttributes();
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                var data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        var newAttributes = currentState.newAttributes;
        for(var i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        var attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        for(var i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        var geometryAttributes = geometry.attributes;
        var programAttributes = program.getAttributes();
        var materialDefaultAttributeValues = material.defaultAttributeValues;
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    var normalized = geometryAttribute.normalized;
                    var size = geometryAttribute.itemSize;
                    var attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    var buffer = attribute.buffer;
                    var type = attribute.type;
                    var bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    var integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $dRnj4.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        var data = geometryAttribute.data;
                        var stride = data.stride;
                        var offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(var i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(var i1 = 0; i1 < programAttribute.locationSize; i1++)enableAttribute(programAttribute.location + i1);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(var i2 = 0; i2 < programAttribute.locationSize; i2++)vertexAttribPointer(programAttribute.location + i2, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i2) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(var i3 = 0; i3 < programAttribute.locationSize; i3++)enableAttributeAndDivisor(programAttribute.location + i3, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(var i4 = 0; i4 < programAttribute.locationSize; i4++)enableAttribute(programAttribute.location + i4);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(var i5 = 0; i5 < programAttribute.locationSize; i5++)vertexAttribPointer(programAttribute.location + i5, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i5 * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    var value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            for(var programId in programMap){
                var stateMap = programMap[programId];
                for(var wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        var programMap = bindingStates[geometry.id];
        for(var programId in programMap){
            var stateMap = programMap[programId];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            var stateMap = programMap[program.id];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $fca9b62618900888$var$WebGLBufferRenderer(gl, extensions, info) {
    var mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        var elementCount = 0;
        for(var i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(var i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            var elementCount = 0;
            for(var i1 = 0; i1 < drawCount; i1++)elementCount += counts[i1] * primcount[i1];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $fca9b62618900888$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    var maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            var extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $dRnj4.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        var halfFloatSupportedByExt = textureType === (0, $dRnj4.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $dRnj4.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $dRnj4.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    var maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    var reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    var maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    var maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    var maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    var maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    var maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    var vertexTextures = maxVertexTextures > 0;
    var maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $fca9b62618900888$var$WebGLClipping(properties) {
    var scope = this;
    var globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    var plane = new (0, $dRnj4.Plane)(), viewNormalMatrix = new (0, $dRnj4.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        var enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        var planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        var materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            var nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            var dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(var i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        var nPlanes = planes !== null ? planes.length : 0;
        var dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                var flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(var i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $fca9b62618900888$var$WebGLCubeMaps(renderer) {
    var cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $dRnj4.EquirectangularReflectionMapping)) texture.mapping = (0, $dRnj4.CubeReflectionMapping);
        else if (mapping === (0, $dRnj4.EquirectangularRefractionMapping)) texture.mapping = (0, $dRnj4.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            var mapping = texture.mapping;
            if (mapping === (0, $dRnj4.EquirectangularReflectionMapping) || mapping === (0, $dRnj4.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    var cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    var image = texture.image;
                    if (image && image.height > 0) {
                        var renderTarget = new (0, $dRnj4.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        var cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps["delete"](texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
var $fca9b62618900888$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
var $fca9b62618900888$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
var $fca9b62618900888$var$MAX_SAMPLES = 20;
var $fca9b62618900888$var$_flatCamera = /*@__PURE__*/ new (0, $dRnj4.OrthographicCamera)();
var $fca9b62618900888$var$_clearColor = /*@__PURE__*/ new (0, $dRnj4.Color)();
var $fca9b62618900888$var$_oldTarget = null;
var $fca9b62618900888$var$_oldActiveCubeFace = 0;
var $fca9b62618900888$var$_oldActiveMipmapLevel = 0;
var $fca9b62618900888$var$_oldXrEnabled = false;
// Golden Ratio
var $fca9b62618900888$var$PHI = (1 + Math.sqrt(5)) / 2;
var $fca9b62618900888$var$INV_PHI = 1 / $fca9b62618900888$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
var $fca9b62618900888$var$_axisDirections = [
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(-$fca9b62618900888$var$PHI, $fca9b62618900888$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)($fca9b62618900888$var$PHI, $fca9b62618900888$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(-$fca9b62618900888$var$INV_PHI, 0, $fca9b62618900888$var$PHI),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)($fca9b62618900888$var$INV_PHI, 0, $fca9b62618900888$var$PHI),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(0, $fca9b62618900888$var$PHI, -$fca9b62618900888$var$INV_PHI),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(0, $fca9b62618900888$var$PHI, $fca9b62618900888$var$INV_PHI),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(-1, 1, -1),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(1, 1, -1),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(-1, 1, 1),
    /*@__PURE__*/ new (0, $dRnj4.Vector3)(1, 1, 1)
];
var $fca9b62618900888$var$_origin = /*@__PURE__*/ new (0, $dRnj4.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting:
 * {@link https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view}
*/ var $fca9b62618900888$export$6add42717753e221 = /*#__PURE__*/ function() {
    "use strict";
    function PMREMGenerator(renderer) {
        (0, $jGAMp._)(this, PMREMGenerator);
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    (0, $byiyg._)(PMREMGenerator, [
        {
            /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ key: "fromScene",
            value: function fromScene(scene) {
                var sigma = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var _options_size = options.size, size = _options_size === void 0 ? 256 : _options_size, _options_position = options.position, position = _options_position === void 0 ? $fca9b62618900888$var$_origin : _options_position;
                $fca9b62618900888$var$_oldTarget = this._renderer.getRenderTarget();
                $fca9b62618900888$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
                $fca9b62618900888$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
                $fca9b62618900888$var$_oldXrEnabled = this._renderer.xr.enabled;
                this._renderer.xr.enabled = false;
                this._setSize(size);
                var cubeUVRenderTarget = this._allocateTargets();
                cubeUVRenderTarget.depthBuffer = true;
                this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
                if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ key: "fromEquirectangular",
            value: function fromEquirectangular(equirectangular) {
                var renderTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return this._fromTexture(equirectangular, renderTarget);
            }
        },
        {
            /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ key: "fromCubemap",
            value: function fromCubemap(cubemap) {
                var renderTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return this._fromTexture(cubemap, renderTarget);
            }
        },
        {
            /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileCubemapShader",
            value: function compileCubemapShader() {
                if (this._cubemapMaterial === null) {
                    this._cubemapMaterial = $fca9b62618900888$var$_getCubemapMaterial();
                    this._compileMaterial(this._cubemapMaterial);
                }
            }
        },
        {
            /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileEquirectangularShader",
            value: function compileEquirectangularShader() {
                if (this._equirectMaterial === null) {
                    this._equirectMaterial = $fca9b62618900888$var$_getEquirectMaterial();
                    this._compileMaterial(this._equirectMaterial);
                }
            }
        },
        {
            /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ key: "dispose",
            value: function dispose() {
                this._dispose();
                if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
                if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
            }
        },
        {
            // private interface
            key: "_setSize",
            value: function _setSize(cubeSize) {
                this._lodMax = Math.floor(Math.log2(cubeSize));
                this._cubeSize = Math.pow(2, this._lodMax);
            }
        },
        {
            key: "_dispose",
            value: function _dispose() {
                if (this._blurMaterial !== null) this._blurMaterial.dispose();
                if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
                for(var i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup(outputTarget) {
                this._renderer.setRenderTarget($fca9b62618900888$var$_oldTarget, $fca9b62618900888$var$_oldActiveCubeFace, $fca9b62618900888$var$_oldActiveMipmapLevel);
                this._renderer.xr.enabled = $fca9b62618900888$var$_oldXrEnabled;
                outputTarget.scissorTest = false;
                $fca9b62618900888$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
            }
        },
        {
            key: "_fromTexture",
            value: function _fromTexture(texture, renderTarget) {
                if (texture.mapping === (0, $dRnj4.CubeReflectionMapping) || texture.mapping === (0, $dRnj4.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
                else this._setSize(texture.image.width / 4);
                $fca9b62618900888$var$_oldTarget = this._renderer.getRenderTarget();
                $fca9b62618900888$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
                $fca9b62618900888$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
                $fca9b62618900888$var$_oldXrEnabled = this._renderer.xr.enabled;
                this._renderer.xr.enabled = false;
                var cubeUVRenderTarget = renderTarget || this._allocateTargets();
                this._textureToCubeUV(texture, cubeUVRenderTarget);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_allocateTargets",
            value: function _allocateTargets() {
                var width = 3 * Math.max(this._cubeSize, 112);
                var height = 4 * this._cubeSize;
                var params = {
                    magFilter: (0, $dRnj4.LinearFilter),
                    minFilter: (0, $dRnj4.LinearFilter),
                    generateMipmaps: false,
                    type: (0, $dRnj4.HalfFloatType),
                    format: (0, $dRnj4.RGBAFormat),
                    colorSpace: (0, $dRnj4.LinearSRGBColorSpace),
                    depthBuffer: false
                };
                var cubeUVRenderTarget = $fca9b62618900888$var$_createRenderTarget(width, height, params);
                if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
                    if (this._pingPongRenderTarget !== null) this._dispose();
                    this._pingPongRenderTarget = $fca9b62618900888$var$_createRenderTarget(width, height, params);
                    var _lodMax = this._lodMax;
                    var ref;
                    ref = $fca9b62618900888$var$_createPlanes(_lodMax), this._sizeLods = ref.sizeLods, this._lodPlanes = ref.lodPlanes, this._sigmas = ref.sigmas, ref;
                    this._blurMaterial = $fca9b62618900888$var$_getBlurShader(_lodMax, width, height);
                }
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_compileMaterial",
            value: function _compileMaterial(material) {
                var tmpMesh = new (0, $dRnj4.Mesh)(this._lodPlanes[0], material);
                this._renderer.compile(tmpMesh, $fca9b62618900888$var$_flatCamera);
            }
        },
        {
            key: "_sceneToCubeUV",
            value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
                var fov = 90;
                var aspect = 1;
                var cubeCamera = new (0, $dRnj4.PerspectiveCamera)(fov, aspect, near, far);
                var upSign = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ];
                var forwardSign = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ];
                var renderer = this._renderer;
                var originalAutoClear = renderer.autoClear;
                var toneMapping = renderer.toneMapping;
                renderer.getClearColor($fca9b62618900888$var$_clearColor);
                renderer.toneMapping = (0, $dRnj4.NoToneMapping);
                renderer.autoClear = false;
                var backgroundMaterial = new (0, $dRnj4.MeshBasicMaterial)({
                    name: 'PMREM.Background',
                    side: (0, $dRnj4.BackSide),
                    depthWrite: false,
                    depthTest: false
                });
                var backgroundBox = new (0, $dRnj4.Mesh)(new (0, $dRnj4.BoxGeometry)(), backgroundMaterial);
                var useSolidColor = false;
                var background = scene.background;
                if (background) {
                    if (background.isColor) {
                        backgroundMaterial.color.copy(background);
                        scene.background = null;
                        useSolidColor = true;
                    }
                } else {
                    backgroundMaterial.color.copy($fca9b62618900888$var$_clearColor);
                    useSolidColor = true;
                }
                for(var i = 0; i < 6; i++){
                    var col = i % 3;
                    if (col === 0) {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.position.set(position.x, position.y, position.z);
                        cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
                    } else if (col === 1) {
                        cubeCamera.up.set(0, 0, upSign[i]);
                        cubeCamera.position.set(position.x, position.y, position.z);
                        cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
                    } else {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.position.set(position.x, position.y, position.z);
                        cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
                    }
                    var size = this._cubeSize;
                    $fca9b62618900888$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
                    renderer.setRenderTarget(cubeUVRenderTarget);
                    if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
                    renderer.render(scene, cubeCamera);
                }
                backgroundBox.geometry.dispose();
                backgroundBox.material.dispose();
                renderer.toneMapping = toneMapping;
                renderer.autoClear = originalAutoClear;
                scene.background = background;
            }
        },
        {
            key: "_textureToCubeUV",
            value: function _textureToCubeUV(texture, cubeUVRenderTarget) {
                var renderer = this._renderer;
                var isCubeTexture = texture.mapping === (0, $dRnj4.CubeReflectionMapping) || texture.mapping === (0, $dRnj4.CubeRefractionMapping);
                if (isCubeTexture) {
                    if (this._cubemapMaterial === null) this._cubemapMaterial = $fca9b62618900888$var$_getCubemapMaterial();
                    this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
                } else if (this._equirectMaterial === null) this._equirectMaterial = $fca9b62618900888$var$_getEquirectMaterial();
                var material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
                var mesh = new (0, $dRnj4.Mesh)(this._lodPlanes[0], material);
                var uniforms = material.uniforms;
                uniforms['envMap'].value = texture;
                var size = this._cubeSize;
                $fca9b62618900888$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
                renderer.setRenderTarget(cubeUVRenderTarget);
                renderer.render(mesh, $fca9b62618900888$var$_flatCamera);
            }
        },
        {
            key: "_applyPMREM",
            value: function _applyPMREM(cubeUVRenderTarget) {
                var renderer = this._renderer;
                var autoClear = renderer.autoClear;
                renderer.autoClear = false;
                var n = this._lodPlanes.length;
                for(var i = 1; i < n; i++){
                    var sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
                    var poleAxis = $fca9b62618900888$var$_axisDirections[(n - i - 1) % $fca9b62618900888$var$_axisDirections.length];
                    this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
                }
                renderer.autoClear = autoClear;
            }
        },
        {
            /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ key: "_blur",
            value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
                var pingPongRenderTarget = this._pingPongRenderTarget;
                this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
                this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
            }
        },
        {
            key: "_halfBlur",
            value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
                var renderer = this._renderer;
                var blurMaterial = this._blurMaterial;
                if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
                // Number of standard deviations at which to cut off the discrete approximation.
                var STANDARD_DEVIATIONS = 3;
                var blurMesh = new (0, $dRnj4.Mesh)(this._lodPlanes[lodOut], blurMaterial);
                var blurUniforms = blurMaterial.uniforms;
                var pixels = this._sizeLods[lodIn] - 1;
                var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $fca9b62618900888$var$MAX_SAMPLES - 1);
                var sigmaPixels = sigmaRadians / radiansPerPixel;
                var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $fca9b62618900888$var$MAX_SAMPLES;
                if (samples > $fca9b62618900888$var$MAX_SAMPLES) console.warn("sigmaRadians, ".concat(sigmaRadians, ", is too large and will clip, as it requested ").concat(samples, " samples when the maximum is set to ").concat($fca9b62618900888$var$MAX_SAMPLES));
                var weights = [];
                var sum = 0;
                for(var i = 0; i < $fca9b62618900888$var$MAX_SAMPLES; ++i){
                    var x = i / sigmaPixels;
                    var weight = Math.exp(-x * x / 2);
                    weights.push(weight);
                    if (i === 0) sum += weight;
                    else if (i < samples) sum += 2 * weight;
                }
                for(var i1 = 0; i1 < weights.length; i1++)weights[i1] = weights[i1] / sum;
                blurUniforms['envMap'].value = targetIn.texture;
                blurUniforms['samples'].value = samples;
                blurUniforms['weights'].value = weights;
                blurUniforms['latitudinal'].value = direction === 'latitudinal';
                if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
                var _lodMax = this._lodMax;
                blurUniforms['dTheta'].value = radiansPerPixel;
                blurUniforms['mipInt'].value = _lodMax - lodIn;
                var outputSize = this._sizeLods[lodOut];
                var x1 = 3 * outputSize * (lodOut > _lodMax - $fca9b62618900888$var$LOD_MIN ? lodOut - _lodMax + $fca9b62618900888$var$LOD_MIN : 0);
                var y = 4 * (this._cubeSize - outputSize);
                $fca9b62618900888$var$_setViewport(targetOut, x1, y, 3 * outputSize, 2 * outputSize);
                renderer.setRenderTarget(targetOut);
                renderer.render(blurMesh, $fca9b62618900888$var$_flatCamera);
            }
        }
    ]);
    return PMREMGenerator;
}();
function $fca9b62618900888$var$_createPlanes(lodMax) {
    var lodPlanes = [];
    var sizeLods = [];
    var sigmas = [];
    var lod = lodMax;
    var totalLods = lodMax - $fca9b62618900888$var$LOD_MIN + 1 + $fca9b62618900888$var$EXTRA_LOD_SIGMA.length;
    for(var i = 0; i < totalLods; i++){
        var sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        var sigma = 1.0 / sizeLod;
        if (i > lodMax - $fca9b62618900888$var$LOD_MIN) sigma = $fca9b62618900888$var$EXTRA_LOD_SIGMA[i - lodMax + $fca9b62618900888$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        var texelSize = 1.0 / (sizeLod - 2);
        var min = -texelSize;
        var max = 1 + texelSize;
        var uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        var cubeFaces = 6;
        var vertices = 6;
        var positionSize = 3;
        var uvSize = 2;
        var faceIndexSize = 1;
        var position = new Float32Array(positionSize * vertices * cubeFaces);
        var uv = new Float32Array(uvSize * vertices * cubeFaces);
        var faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(var face = 0; face < cubeFaces; face++){
            var x = face % 3 * 2 / 3 - 1;
            var y = face > 2 ? 0 : -1;
            var coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            var fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        var planes = new (0, $dRnj4.BufferGeometry)();
        planes.setAttribute('position', new (0, $dRnj4.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $dRnj4.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $dRnj4.BufferAttribute)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $fca9b62618900888$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $fca9b62618900888$var$_createRenderTarget(width, height, params) {
    var cubeUVRenderTarget = new (0, $dRnj4.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $dRnj4.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $fca9b62618900888$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $fca9b62618900888$var$_getBlurShader(lodMax, width, height) {
    var weights = new Float32Array($fca9b62618900888$var$MAX_SAMPLES);
    var poleAxis = new (0, $dRnj4.Vector3)(0, 1, 0);
    var shaderMaterial = new (0, $dRnj4.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            n: $fca9b62618900888$var$MAX_SAMPLES,
            CUBEUV_TEXEL_WIDTH: 1.0 / width,
            CUBEUV_TEXEL_HEIGHT: 1.0 / height,
            CUBEUV_MAX_MIP: "".concat(lodMax, ".0")
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: weights
            },
            latitudinal: {
                value: false
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: poleAxis
            }
        },
        vertexShader: $fca9b62618900888$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
        blending: (0, $dRnj4.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $fca9b62618900888$var$_getEquirectMaterial() {
    return new (0, $dRnj4.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $fca9b62618900888$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
        blending: (0, $dRnj4.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $fca9b62618900888$var$_getCubemapMaterial() {
    return new (0, $dRnj4.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $fca9b62618900888$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
        blending: (0, $dRnj4.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $fca9b62618900888$var$_getCommonVertexShader() {
    return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
}
function $fca9b62618900888$var$WebGLCubeUVMaps(renderer) {
    var cubeUVmaps = new WeakMap();
    var pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            var mapping = texture.mapping;
            var isEquirectMap = mapping === (0, $dRnj4.EquirectangularReflectionMapping) || mapping === (0, $dRnj4.EquirectangularRefractionMapping);
            var isCubeMap = mapping === (0, $dRnj4.CubeReflectionMapping) || mapping === (0, $dRnj4.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                var renderTarget = cubeUVmaps.get(texture);
                var currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $fca9b62618900888$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        var image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $fca9b62618900888$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        var count = 0;
        var length = 6;
        for(var i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        var cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps["delete"](texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $fca9b62618900888$var$WebGLExtensions(gl) {
    var extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        var extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function has(name) {
            return getExtension(name) !== null;
        },
        init: function init() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function get(name) {
            var extension = getExtension(name);
            if (extension === null) (0, $dRnj4.warnOnce)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $fca9b62618900888$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    var geometries = {};
    var wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        var geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(var name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        var attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes["delete"](geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        var geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(var name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        var indices = [];
        var geometryIndex = geometry.index;
        var geometryPosition = geometry.attributes.position;
        var version = 0;
        if (geometryIndex !== null) {
            var array = geometryIndex.array;
            version = geometryIndex.version;
            for(var i = 0, l = array.length; i < l; i += 3){
                var a = array[i + 0];
                var b = array[i + 1];
                var c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            var array1 = geometryPosition.array;
            version = geometryPosition.version;
            for(var i1 = 0, l1 = array1.length / 3 - 1; i1 < l1; i1 += 3){
                var a1 = i1 + 0;
                var b1 = i1 + 1;
                var c1 = i1 + 2;
                indices.push(a1, b1, b1, c1, c1, a1);
            }
        } else return;
        var attribute = new ((0, $dRnj4.arrayNeedsUint32)(indices) ? (0, $dRnj4.Uint32BufferAttribute) : (0, $dRnj4.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        var previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        var currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            var geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $fca9b62618900888$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    var mode;
    function setMode(value) {
        mode = value;
    }
    var type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        var elementCount = 0;
        for(var i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(var i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            var elementCount = 0;
            for(var i1 = 0; i1 < drawCount; i1++)elementCount += counts[i1] * primcount[i1];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $fca9b62618900888$var$WebGLInfo(gl) {
    var memory = {
        geometries: 0,
        textures: 0
    };
    var render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $fca9b62618900888$var$WebGLMorphtargets(gl, capabilities, textures) {
    var morphTextures = new WeakMap();
    var morph = new (0, $dRnj4.Vector4)();
    function update(object, geometry, program) {
        var objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        var entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            var hasMorphPosition = geometry.morphAttributes.position !== undefined;
            var hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            var hasMorphColors = geometry.morphAttributes.color !== undefined;
            var morphTargets = geometry.morphAttributes.position || [];
            var morphNormals = geometry.morphAttributes.normal || [];
            var morphColors = geometry.morphAttributes.color || [];
            var vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            var width = geometry.attributes.position.count * vertexDataCount;
            var height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            var buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            var texture = new (0, $dRnj4.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $dRnj4.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            var vertexDataStride = vertexDataCount * 4;
            for(var i = 0; i < morphTargetsCount; i++){
                var morphTarget = morphTargets[i];
                var morphNormal = morphNormals[i];
                var morphColor = morphColors[i];
                var offset = width * height * 4 * i;
                for(var j = 0; j < morphTarget.count; j++){
                    var stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $dRnj4.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures["delete"](geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            var morphInfluencesSum = 0;
            for(var i1 = 0; i1 < objectInfluences.length; i1++)morphInfluencesSum += objectInfluences[i1];
            var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $fca9b62618900888$var$WebGLObjects(gl, geometries, attributes, info) {
    var updateMap = new WeakMap();
    function update(object) {
        var frame = info.render.frame;
        var geometry = object.geometry;
        var buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            var skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        var instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ var $fca9b62618900888$var$emptyTexture = /*@__PURE__*/ new (0, $dRnj4.Texture)();
var $fca9b62618900888$var$emptyShadowTexture = /*@__PURE__*/ new (0, $dRnj4.DepthTexture)(1, 1);
var $fca9b62618900888$var$emptyArrayTexture = /*@__PURE__*/ new (0, $dRnj4.DataArrayTexture)();
var $fca9b62618900888$var$empty3dTexture = /*@__PURE__*/ new (0, $dRnj4.Data3DTexture)();
var $fca9b62618900888$var$emptyCubeTexture = /*@__PURE__*/ new (0, $dRnj4.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
var $fca9b62618900888$var$arrayCacheF32 = [];
var $fca9b62618900888$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
var $fca9b62618900888$var$mat4array = new Float32Array(16);
var $fca9b62618900888$var$mat3array = new Float32Array(9);
var $fca9b62618900888$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $fca9b62618900888$var$flatten(array, nBlocks, blockSize) {
    var firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    var n = nBlocks * blockSize;
    var r = $fca9b62618900888$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $fca9b62618900888$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(var i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $fca9b62618900888$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $fca9b62618900888$var$copyArray(a, b) {
    for(var i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $fca9b62618900888$var$allocTexUnits(textures, n) {
    var r = $fca9b62618900888$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $fca9b62618900888$var$arrayCacheI32[n] = r;
    }
    for(var i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $fca9b62618900888$var$setValueV1f(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $fca9b62618900888$var$setValueV2f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV3f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV4f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $fca9b62618900888$var$setValueM2(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $fca9b62618900888$var$copyArray(cache, v);
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, elements)) return;
        $fca9b62618900888$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $fca9b62618900888$var$mat2array);
        $fca9b62618900888$var$copyArray(cache, elements);
    }
}
function $fca9b62618900888$var$setValueM3(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $fca9b62618900888$var$copyArray(cache, v);
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, elements)) return;
        $fca9b62618900888$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $fca9b62618900888$var$mat3array);
        $fca9b62618900888$var$copyArray(cache, elements);
    }
}
function $fca9b62618900888$var$setValueM4(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $fca9b62618900888$var$copyArray(cache, v);
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, elements)) return;
        $fca9b62618900888$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $fca9b62618900888$var$mat4array);
        $fca9b62618900888$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $fca9b62618900888$var$setValueV1i(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $fca9b62618900888$var$setValueV2i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV3i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV4i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $fca9b62618900888$var$setValueV1ui(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $fca9b62618900888$var$setValueV2ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV3ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
function $fca9b62618900888$var$setValueV4ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($fca9b62618900888$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $fca9b62618900888$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $fca9b62618900888$var$setValueT1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    var emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $fca9b62618900888$var$emptyShadowTexture.compareFunction = (0, $dRnj4.LessEqualCompare); // #28670
        emptyTexture2D = $fca9b62618900888$var$emptyShadowTexture;
    } else emptyTexture2D = $fca9b62618900888$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $fca9b62618900888$var$setValueT3D1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $fca9b62618900888$var$empty3dTexture, unit);
}
function $fca9b62618900888$var$setValueT6(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $fca9b62618900888$var$emptyCubeTexture, unit);
}
function $fca9b62618900888$var$setValueT2DArray1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $fca9b62618900888$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $fca9b62618900888$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $fca9b62618900888$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $fca9b62618900888$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $fca9b62618900888$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $fca9b62618900888$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $fca9b62618900888$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $fca9b62618900888$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $fca9b62618900888$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $fca9b62618900888$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $fca9b62618900888$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $fca9b62618900888$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $fca9b62618900888$var$setValueV4i; // _VEC4
        case 0x1405:
            return $fca9b62618900888$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $fca9b62618900888$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $fca9b62618900888$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $fca9b62618900888$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $fca9b62618900888$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $fca9b62618900888$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $fca9b62618900888$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $fca9b62618900888$var$setValueT2DArray1;
    }
}
// Array of scalars
function $fca9b62618900888$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $fca9b62618900888$var$setValueV2fArray(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $fca9b62618900888$var$setValueV3fArray(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $fca9b62618900888$var$setValueV4fArray(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $fca9b62618900888$var$setValueM2Array(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $fca9b62618900888$var$setValueM3Array(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $fca9b62618900888$var$setValueM4Array(gl, v) {
    var data = $fca9b62618900888$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $fca9b62618900888$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $fca9b62618900888$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $fca9b62618900888$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $fca9b62618900888$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $fca9b62618900888$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $fca9b62618900888$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $fca9b62618900888$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $fca9b62618900888$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $fca9b62618900888$var$setValueT1Array(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $fca9b62618900888$var$allocTexUnits(textures, n);
    if (!$fca9b62618900888$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $fca9b62618900888$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $fca9b62618900888$var$emptyTexture, units[i]);
}
function $fca9b62618900888$var$setValueT3DArray(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $fca9b62618900888$var$allocTexUnits(textures, n);
    if (!$fca9b62618900888$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $fca9b62618900888$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $fca9b62618900888$var$empty3dTexture, units[i]);
}
function $fca9b62618900888$var$setValueT6Array(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $fca9b62618900888$var$allocTexUnits(textures, n);
    if (!$fca9b62618900888$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $fca9b62618900888$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $fca9b62618900888$var$emptyCubeTexture, units[i]);
}
function $fca9b62618900888$var$setValueT2DArrayArray(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $fca9b62618900888$var$allocTexUnits(textures, n);
    if (!$fca9b62618900888$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $fca9b62618900888$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $fca9b62618900888$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $fca9b62618900888$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $fca9b62618900888$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $fca9b62618900888$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $fca9b62618900888$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $fca9b62618900888$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $fca9b62618900888$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $fca9b62618900888$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $fca9b62618900888$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $fca9b62618900888$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $fca9b62618900888$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $fca9b62618900888$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $fca9b62618900888$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $fca9b62618900888$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $fca9b62618900888$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $fca9b62618900888$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $fca9b62618900888$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $fca9b62618900888$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $fca9b62618900888$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $fca9b62618900888$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $fca9b62618900888$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
var $fca9b62618900888$var$SingleUniform = function SingleUniform(id, activeInfo, addr) {
    "use strict";
    (0, $jGAMp._)(this, SingleUniform);
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.setValue = $fca9b62618900888$var$getSingularSetter(activeInfo.type);
};
var $fca9b62618900888$var$PureArrayUniform = function PureArrayUniform(id, activeInfo, addr) {
    "use strict";
    (0, $jGAMp._)(this, PureArrayUniform);
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.size = activeInfo.size;
    this.setValue = $fca9b62618900888$var$getPureArraySetter(activeInfo.type);
};
var $fca9b62618900888$var$StructuredUniform = /*#__PURE__*/ function() {
    "use strict";
    function StructuredUniform(id) {
        (0, $jGAMp._)(this, StructuredUniform);
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    (0, $byiyg._)(StructuredUniform, [
        {
            key: "setValue",
            value: function setValue(gl, value, textures) {
                var seq = this.seq;
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i];
                    u.setValue(gl, value[u.id], textures);
                }
            }
        }
    ]);
    return StructuredUniform;
}();
// --- Top-level ---
// Parser - builds up the property tree from the path strings
var $fca9b62618900888$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $fca9b62618900888$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $fca9b62618900888$var$parseUniform(activeInfo, addr, container) {
    var path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $fca9b62618900888$var$RePathPart.lastIndex = 0;
    while(true){
        var match = $fca9b62618900888$var$RePathPart.exec(path), matchEnd = $fca9b62618900888$var$RePathPart.lastIndex;
        var id = match[1];
        var idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $fca9b62618900888$var$addUniform(container, subscript === undefined ? new $fca9b62618900888$var$SingleUniform(id, activeInfo, addr) : new $fca9b62618900888$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            var map = container.map;
            var next = map[id];
            if (next === undefined) {
                next = new $fca9b62618900888$var$StructuredUniform(id);
                $fca9b62618900888$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
var $fca9b62618900888$var$WebGLUniforms = /*#__PURE__*/ function() {
    "use strict";
    function WebGLUniforms(gl, program) {
        (0, $jGAMp._)(this, WebGLUniforms);
        this.seq = [];
        this.map = {};
        var n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(var i = 0; i < n; ++i){
            var info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $fca9b62618900888$var$parseUniform(info, addr, this);
        }
    }
    (0, $byiyg._)(WebGLUniforms, [
        {
            key: "setValue",
            value: function setValue(gl, name, value, textures) {
                var u = this.map[name];
                if (u !== undefined) u.setValue(gl, value, textures);
            }
        },
        {
            key: "setOptional",
            value: function setOptional(gl, object, name) {
                var v = object[name];
                if (v !== undefined) this.setValue(gl, name, v);
            }
        }
    ], [
        {
            key: "upload",
            value: function upload(gl, seq, values, textures) {
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i], v = values[u.id];
                    if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
                    u.setValue(gl, v.value, textures);
                }
            }
        },
        {
            key: "seqWithValue",
            value: function seqWithValue(seq, values) {
                var r = [];
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i];
                    if (u.id in values) r.push(u);
                }
                return r;
            }
        }
    ]);
    return WebGLUniforms;
}();
function $fca9b62618900888$var$WebGLShader(gl, type, string) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
var $fca9b62618900888$var$COMPLETION_STATUS_KHR = 0x91B1;
var $fca9b62618900888$var$programIdCount = 0;
function $fca9b62618900888$var$handleSource(string, errorLine) {
    var lines = string.split('\n');
    var lines2 = [];
    var from = Math.max(errorLine - 6, 0);
    var to = Math.min(errorLine + 6, lines.length);
    for(var i = from; i < to; i++){
        var line = i + 1;
        lines2.push("".concat(line === errorLine ? '>' : ' ', " ").concat(line, ": ").concat(lines[i]));
    }
    return lines2.join('\n');
}
var $fca9b62618900888$var$_m0 = /*@__PURE__*/ new (0, $dRnj4.Matrix3)();
function $fca9b62618900888$var$getEncodingComponents(colorSpace) {
    (0, $dRnj4.ColorManagement)._getMatrix($fca9b62618900888$var$_m0, (0, $dRnj4.ColorManagement).workingColorSpace, colorSpace);
    var encodingMatrix = "mat3( ".concat($fca9b62618900888$var$_m0.elements.map(function(v) {
        return v.toFixed(4);
    }), " )");
    switch((0, $dRnj4.ColorManagement).getTransfer(colorSpace)){
        case 0, $dRnj4.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $dRnj4.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $fca9b62618900888$var$getShaderErrors(gl, shader, type) {
    var status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    var errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    var errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        var errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $fca9b62618900888$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $fca9b62618900888$var$getTexelEncodingFunction(functionName, colorSpace) {
    var components = $fca9b62618900888$var$getEncodingComponents(colorSpace);
    return [
        "vec4 ".concat(functionName, "( vec4 value ) {"),
        "	return ".concat(components[1], "( vec4( value.rgb * ").concat(components[0], ", value.a ) );"),
        '}'
    ].join('\n');
}
function $fca9b62618900888$var$getToneMappingFunction(functionName, toneMapping) {
    var toneMappingName;
    switch(toneMapping){
        case 0, $dRnj4.LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case 0, $dRnj4.ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case 0, $dRnj4.CineonToneMapping:
            toneMappingName = 'Cineon';
            break;
        case 0, $dRnj4.ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $dRnj4.AgXToneMapping:
            toneMappingName = 'AgX';
            break;
        case 0, $dRnj4.NeutralToneMapping:
            toneMappingName = 'Neutral';
            break;
        case 0, $dRnj4.CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
var $fca9b62618900888$var$_v0 = /*@__PURE__*/ new (0, $dRnj4.Vector3)();
function $fca9b62618900888$var$getLuminanceFunction() {
    (0, $dRnj4.ColorManagement).getLuminanceCoefficients($fca9b62618900888$var$_v0);
    var r = $fca9b62618900888$var$_v0.x.toFixed(4);
    var g = $fca9b62618900888$var$_v0.y.toFixed(4);
    var b = $fca9b62618900888$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        "	const vec3 weights = vec3( ".concat(r, ", ").concat(g, ", ").concat(b, " );"),
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $fca9b62618900888$var$generateVertexExtensions(parameters) {
    var chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($fca9b62618900888$var$filterEmptyLine).join('\n');
}
function $fca9b62618900888$var$generateDefines(defines) {
    var chunks = [];
    for(var name in defines){
        var value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $fca9b62618900888$var$fetchAttributeLocations(gl, program) {
    var attributes = {};
    var n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < n; i++){
        var info = gl.getActiveAttrib(program, i);
        var name = info.name;
        var locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $fca9b62618900888$var$filterEmptyLine(string) {
    return string !== '';
}
function $fca9b62618900888$var$replaceLightNums(string, parameters) {
    var numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $fca9b62618900888$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
var $fca9b62618900888$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $fca9b62618900888$var$resolveIncludes(string) {
    return string.replace($fca9b62618900888$var$includePattern, $fca9b62618900888$var$includeReplacer);
}
var $fca9b62618900888$var$shaderChunkMap = new Map();
function $fca9b62618900888$var$includeReplacer(match, include) {
    var string = $fca9b62618900888$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        var newInclude = $fca9b62618900888$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $fca9b62618900888$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $fca9b62618900888$var$resolveIncludes(string);
}
// Unroll Loops
var $fca9b62618900888$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $fca9b62618900888$var$unrollLoops(string) {
    return string.replace($fca9b62618900888$var$unrollLoopPattern, $fca9b62618900888$var$loopReplacer);
}
function $fca9b62618900888$var$loopReplacer(match, start, end, snippet) {
    var string = '';
    for(var i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $fca9b62618900888$var$generatePrecision(parameters) {
    var precisionstring = "precision ".concat(parameters.precision, " float;\n	precision ").concat(parameters.precision, " int;\n	precision ").concat(parameters.precision, " sampler2D;\n	precision ").concat(parameters.precision, " samplerCube;\n	precision ").concat(parameters.precision, " sampler3D;\n	precision ").concat(parameters.precision, " sampler2DArray;\n	precision ").concat(parameters.precision, " sampler2DShadow;\n	precision ").concat(parameters.precision, " samplerCubeShadow;\n	precision ").concat(parameters.precision, " sampler2DArrayShadow;\n	precision ").concat(parameters.precision, " isampler2D;\n	precision ").concat(parameters.precision, " isampler3D;\n	precision ").concat(parameters.precision, " isamplerCube;\n	precision ").concat(parameters.precision, " isampler2DArray;\n	precision ").concat(parameters.precision, " usampler2D;\n	precision ").concat(parameters.precision, " usampler3D;\n	precision ").concat(parameters.precision, " usamplerCube;\n	precision ").concat(parameters.precision, " usampler2DArray;\n	");
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $fca9b62618900888$var$generateShadowMapTypeDefine(parameters) {
    var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $dRnj4.PCFShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $dRnj4.PCFSoftShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $dRnj4.VSMShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $fca9b62618900888$var$generateEnvMapTypeDefine(parameters) {
    var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $dRnj4.CubeReflectionMapping:
        case 0, $dRnj4.CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $dRnj4.CubeUVReflectionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $fca9b62618900888$var$generateEnvMapModeDefine(parameters) {
    var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $dRnj4.CubeRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $fca9b62618900888$var$generateEnvMapBlendingDefine(parameters) {
    var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $dRnj4.MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $dRnj4.MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $dRnj4.AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $fca9b62618900888$var$generateCubeUVSize(parameters) {
    var imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    var maxMip = Math.log2(imageHeight) - 2;
    var texelHeight = 1.0 / imageHeight;
    var texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $fca9b62618900888$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    var gl = renderer.getContext();
    var defines = parameters.defines;
    var vertexShader = parameters.vertexShader;
    var fragmentShader = parameters.fragmentShader;
    var shadowMapTypeDefine = $fca9b62618900888$var$generateShadowMapTypeDefine(parameters);
    var envMapTypeDefine = $fca9b62618900888$var$generateEnvMapTypeDefine(parameters);
    var envMapModeDefine = $fca9b62618900888$var$generateEnvMapModeDefine(parameters);
    var envMapBlendingDefine = $fca9b62618900888$var$generateEnvMapBlendingDefine(parameters);
    var envMapCubeUVSize = $fca9b62618900888$var$generateCubeUVSize(parameters);
    var customVertexExtensions = $fca9b62618900888$var$generateVertexExtensions(parameters);
    var customDefines = $fca9b62618900888$var$generateDefines(defines);
    var program = gl.createProgram();
    var prefixVertex, prefixFragment;
    var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($fca9b62618900888$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($fca9b62618900888$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $fca9b62618900888$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($fca9b62618900888$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $fca9b62618900888$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $dRnj4.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $dRnj4.NoToneMapping) ? $fca9b62618900888$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $dRnj4.NoToneMapping) ? $fca9b62618900888$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $fca9b62618900888$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $fca9b62618900888$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $fca9b62618900888$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($fca9b62618900888$var$filterEmptyLine).join('\n');
    }
    vertexShader = $fca9b62618900888$var$resolveIncludes(vertexShader);
    vertexShader = $fca9b62618900888$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $fca9b62618900888$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $fca9b62618900888$var$resolveIncludes(fragmentShader);
    fragmentShader = $fca9b62618900888$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $fca9b62618900888$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $fca9b62618900888$var$unrollLoops(vertexShader);
    fragmentShader = $fca9b62618900888$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $dRnj4.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $dRnj4.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    var vertexGlsl = versionString + prefixVertex + vertexShader;
    var fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    var glVertexShader = $fca9b62618900888$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    var glFragmentShader = $fca9b62618900888$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            var programLog = gl.getProgramInfoLog(program).trim();
            var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            var runnable = true;
            var haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    var vertexErrors = $fca9b62618900888$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    var fragmentErrors = $fca9b62618900888$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $fca9b62618900888$var$WebGLUniforms(gl, program);
        cachedAttributes = $fca9b62618900888$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    var cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    var cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    var programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $fca9b62618900888$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $fca9b62618900888$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
var $fca9b62618900888$var$_id = 0;
var $fca9b62618900888$var$WebGLShaderCache = /*#__PURE__*/ function() {
    "use strict";
    function WebGLShaderCache() {
        (0, $jGAMp._)(this, WebGLShaderCache);
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    (0, $byiyg._)(WebGLShaderCache, [
        {
            key: "update",
            value: function update(material) {
                var vertexShader = material.vertexShader;
                var fragmentShader = material.fragmentShader;
                var vertexShaderStage = this._getShaderStage(vertexShader);
                var fragmentShaderStage = this._getShaderStage(fragmentShader);
                var materialShaders = this._getShaderCacheForMaterial(material);
                if (materialShaders.has(vertexShaderStage) === false) {
                    materialShaders.add(vertexShaderStage);
                    vertexShaderStage.usedTimes++;
                }
                if (materialShaders.has(fragmentShaderStage) === false) {
                    materialShaders.add(fragmentShaderStage);
                    fragmentShaderStage.usedTimes++;
                }
                return this;
            }
        },
        {
            key: "remove",
            value: function remove(material) {
                var materialShaders = this.materialCache.get(material);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = materialShaders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var shaderStage = _step.value;
                        shaderStage.usedTimes--;
                        if (shaderStage.usedTimes === 0) this.shaderCache["delete"](shaderStage.code);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.materialCache["delete"](material);
                return this;
            }
        },
        {
            key: "getVertexShaderID",
            value: function getVertexShaderID(material) {
                return this._getShaderStage(material.vertexShader).id;
            }
        },
        {
            key: "getFragmentShaderID",
            value: function getFragmentShaderID(material) {
                return this._getShaderStage(material.fragmentShader).id;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shaderCache.clear();
                this.materialCache.clear();
            }
        },
        {
            key: "_getShaderCacheForMaterial",
            value: function _getShaderCacheForMaterial(material) {
                var cache = this.materialCache;
                var set = cache.get(material);
                if (set === undefined) {
                    set = new Set();
                    cache.set(material, set);
                }
                return set;
            }
        },
        {
            key: "_getShaderStage",
            value: function _getShaderStage(code) {
                var cache = this.shaderCache;
                var stage = cache.get(code);
                if (stage === undefined) {
                    stage = new $fca9b62618900888$var$WebGLShaderStage(code);
                    cache.set(code, stage);
                }
                return stage;
            }
        }
    ]);
    return WebGLShaderCache;
}();
var $fca9b62618900888$var$WebGLShaderStage = function WebGLShaderStage(code) {
    "use strict";
    (0, $jGAMp._)(this, WebGLShaderStage);
    this.id = $fca9b62618900888$var$_id++;
    this.code = code;
    this.usedTimes = 0;
};
function $fca9b62618900888$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    var _programLayers = new (0, $dRnj4.Layers)();
    var _customShaders = new $fca9b62618900888$var$WebGLShaderCache();
    var _activeChannels = new Set();
    var programs = [];
    var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    var SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    var precision = capabilities.precision;
    var shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return "uv".concat(value);
    }
    function getParameters(material, lights, shadows, scene, object) {
        var fog = scene.fog;
        var geometry = object.geometry;
        var environment = material.isMeshStandardMaterial ? scene.environment : null;
        var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        var envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $dRnj4.CubeUVReflectionMapping) ? envMap.image.height : null;
        var shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        var morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        var vertexShader, fragmentShader;
        var customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            var shader = $fca9b62618900888$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        var currentRenderTarget = renderer.getRenderTarget();
        var reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        var IS_INSTANCEDMESH = object.isInstancedMesh === true;
        var IS_BATCHEDMESH = object.isBatchedMesh === true;
        var HAS_MAP = !!material.map;
        var HAS_MATCAP = !!material.matcap;
        var HAS_ENVMAP = !!envMap;
        var HAS_AOMAP = !!material.aoMap;
        var HAS_LIGHTMAP = !!material.lightMap;
        var HAS_BUMPMAP = !!material.bumpMap;
        var HAS_NORMALMAP = !!material.normalMap;
        var HAS_DISPLACEMENTMAP = !!material.displacementMap;
        var HAS_EMISSIVEMAP = !!material.emissiveMap;
        var HAS_METALNESSMAP = !!material.metalnessMap;
        var HAS_ROUGHNESSMAP = !!material.roughnessMap;
        var HAS_ANISOTROPY = material.anisotropy > 0;
        var HAS_CLEARCOAT = material.clearcoat > 0;
        var HAS_DISPERSION = material.dispersion > 0;
        var HAS_IRIDESCENCE = material.iridescence > 0;
        var HAS_SHEEN = material.sheen > 0;
        var HAS_TRANSMISSION = material.transmission > 0;
        var HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        var HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        var HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        var HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        var HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        var HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        var HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        var HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        var HAS_SPECULARMAP = !!material.specularMap;
        var HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        var HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        var HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        var HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        var HAS_GRADIENTMAP = !!material.gradientMap;
        var HAS_ALPHAMAP = !!material.alphaMap;
        var HAS_ALPHATEST = material.alphaTest > 0;
        var HAS_ALPHAHASH = !!material.alphaHash;
        var HAS_EXTENSIONS = !!material.extensions;
        var toneMapping = (0, $dRnj4.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        var parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $dRnj4.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $dRnj4.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $dRnj4.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $dRnj4.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true && material.wireframe === false,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $dRnj4.ColorManagement).getTransfer(material.map.colorSpace) === (0, $dRnj4.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $dRnj4.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, $dRnj4.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $dRnj4.DoubleSide),
            flipSided: material.side === (0, $dRnj4.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        var array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(var name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        if (parameters.gradientMap) _programLayers.enable(22);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        var shaderID = shaderIDs[material.type];
        var uniforms;
        if (shaderID) {
            var shader = $fca9b62618900888$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $dRnj4.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        var program;
        // Check if code has been already compiled
        for(var p = 0, pl = programs.length; p < pl; p++){
            var preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $fca9b62618900888$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            var i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $fca9b62618900888$var$WebGLProperties() {
    var properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        var map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties["delete"](object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $fca9b62618900888$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $fca9b62618900888$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $fca9b62618900888$var$WebGLRenderList() {
    var renderItems = [];
    var renderItemsIndex = 0;
    var opaque = [];
    var transmissive = [];
    var transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        var renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $fca9b62618900888$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $fca9b62618900888$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $fca9b62618900888$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(var i = renderItemsIndex, il = renderItems.length; i < il; i++){
            var renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $fca9b62618900888$var$WebGLRenderLists() {
    var lists = new WeakMap();
    function get(scene, renderCallDepth) {
        var listArray = lists.get(scene);
        var list;
        if (listArray === undefined) {
            list = new $fca9b62618900888$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $fca9b62618900888$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $fca9b62618900888$var$UniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $dRnj4.Vector3)(),
                        color: new (0, $dRnj4.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $dRnj4.Vector3)(),
                        direction: new (0, $dRnj4.Vector3)(),
                        color: new (0, $dRnj4.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $dRnj4.Vector3)(),
                        color: new (0, $dRnj4.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $dRnj4.Vector3)(),
                        skyColor: new (0, $dRnj4.Color)(),
                        groundColor: new (0, $dRnj4.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $dRnj4.Color)(),
                        position: new (0, $dRnj4.Vector3)(),
                        halfWidth: new (0, $dRnj4.Vector3)(),
                        halfHeight: new (0, $dRnj4.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $fca9b62618900888$var$ShadowUniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dRnj4.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dRnj4.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $dRnj4.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
var $fca9b62618900888$var$nextVersion = 0;
function $fca9b62618900888$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $fca9b62618900888$var$WebGLLights(extensions) {
    var cache = new $fca9b62618900888$var$UniformsCache();
    var shadowCache = $fca9b62618900888$var$ShadowUniformsCache();
    var state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(var i = 0; i < 9; i++)state.probe.push(new (0, $dRnj4.Vector3)());
    var vector3 = new (0, $dRnj4.Vector3)();
    var matrix4 = new (0, $dRnj4.Matrix4)();
    var matrix42 = new (0, $dRnj4.Matrix4)();
    function setup(lights) {
        var r = 0, g = 0, b = 0;
        for(var i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var numDirectionalShadows = 0;
        var numPointShadows = 0;
        var numSpotShadows = 0;
        var numSpotMaps = 0;
        var numSpotShadowsWithMaps = 0;
        var numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($fca9b62618900888$var$shadowCastingAndTexturingLightsFirst);
        for(var i1 = 0, l = lights.length; i1 < l; i1++){
            var light = lights[i1];
            var color = light.color;
            var intensity = light.intensity;
            var distance = light.distance;
            var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(var j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                var uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    var shadow = light.shadow;
                    var shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = cache.get(light);
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.color.copy(color).multiplyScalar(intensity);
                uniforms1.distance = distance;
                uniforms1.coneCos = Math.cos(light.angle);
                uniforms1.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms1.decay = light.decay;
                state.spot[spotLength] = uniforms1;
                var shadow1 = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow1.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow1.matrix;
                if (light.castShadow) {
                    var shadowUniforms1 = shadowCache.get(light);
                    shadowUniforms1.shadowIntensity = shadow1.intensity;
                    shadowUniforms1.shadowBias = shadow1.bias;
                    shadowUniforms1.shadowNormalBias = shadow1.normalBias;
                    shadowUniforms1.shadowRadius = shadow1.radius;
                    shadowUniforms1.shadowMapSize = shadow1.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms1;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = cache.get(light);
                uniforms2.color.copy(color).multiplyScalar(intensity);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms2;
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = cache.get(light);
                uniforms3.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms3.distance = light.distance;
                uniforms3.decay = light.decay;
                if (light.castShadow) {
                    var shadow2 = light.shadow;
                    var shadowUniforms2 = shadowCache.get(light);
                    shadowUniforms2.shadowIntensity = shadow2.intensity;
                    shadowUniforms2.shadowBias = shadow2.bias;
                    shadowUniforms2.shadowNormalBias = shadow2.normalBias;
                    shadowUniforms2.shadowRadius = shadow2.radius;
                    shadowUniforms2.shadowMapSize = shadow2.mapSize;
                    shadowUniforms2.shadowCameraNear = shadow2.camera.near;
                    shadowUniforms2.shadowCameraFar = shadow2.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms2;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms3;
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = cache.get(light);
                uniforms4.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms4;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $fca9b62618900888$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $fca9b62618900888$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $fca9b62618900888$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $fca9b62618900888$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        var hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $fca9b62618900888$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var viewMatrix = camera.matrixWorldInverse;
        for(var i = 0, l = lights.length; i < l; i++){
            var light = lights[i];
            if (light.isDirectionalLight) {
                var uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = state.spot[spotLength];
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.position.applyMatrix4(viewMatrix);
                uniforms1.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms1.direction.sub(vector3);
                uniforms1.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = state.rectArea[rectAreaLength];
                uniforms2.position.setFromMatrixPosition(light.matrixWorld);
                uniforms2.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms2.halfWidth.applyMatrix4(matrix42);
                uniforms2.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = state.point[pointLength];
                uniforms3.position.setFromMatrixPosition(light.matrixWorld);
                uniforms3.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = state.hemi[hemiLength];
                uniforms4.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms4.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $fca9b62618900888$var$WebGLRenderState(extensions) {
    var lights = new $fca9b62618900888$var$WebGLLights(extensions);
    var lightsArray = [];
    var shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    var state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $fca9b62618900888$var$WebGLRenderStates(extensions) {
    var renderStates = new WeakMap();
    function get(scene) {
        var renderCallDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var renderStateArray = renderStates.get(scene);
        var renderState;
        if (renderStateArray === undefined) {
            renderState = new $fca9b62618900888$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $fca9b62618900888$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
var $fca9b62618900888$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
var $fca9b62618900888$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $fca9b62618900888$var$WebGLShadowMap(renderer, objects, capabilities) {
    var _frustum = new (0, $dRnj4.Frustum)();
    var _shadowMapSize = new (0, $dRnj4.Vector2)(), _viewportSize = new (0, $dRnj4.Vector2)(), _viewport = new (0, $dRnj4.Vector4)(), _depthMaterial = new (0, $dRnj4.MeshDepthMaterial)({
        depthPacking: (0, $dRnj4.RGBADepthPacking)
    }), _distanceMaterial = new (0, $dRnj4.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    var _obj;
    var shadowSide = (_obj = {}, (0, $cqEAj._)(_obj, (0, $dRnj4.FrontSide), (0, $dRnj4.BackSide)), (0, $cqEAj._)(_obj, (0, $dRnj4.BackSide), (0, $dRnj4.FrontSide)), (0, $cqEAj._)(_obj, (0, $dRnj4.DoubleSide), (0, $dRnj4.DoubleSide)), _obj);
    var shadowMaterialVertical = new (0, $dRnj4.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $dRnj4.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $fca9b62618900888$var$vertex,
        fragmentShader: $fca9b62618900888$var$fragment
    });
    var shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    var fullScreenTri = new (0, $dRnj4.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, $dRnj4.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    var fullScreenMesh = new (0, $dRnj4.Mesh)(fullScreenTri, shadowMaterialVertical);
    var scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $dRnj4.PCFShadowMap);
    var _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        var currentRenderTarget = renderer.getRenderTarget();
        var activeCubeFace = renderer.getActiveCubeFace();
        var activeMipmapLevel = renderer.getActiveMipmapLevel();
        var _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $dRnj4.NoBlending));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        var toVSM = _previousType !== (0, $dRnj4.VSMShadowMap) && this.type === (0, $dRnj4.VSMShadowMap);
        var fromVSM = _previousType === (0, $dRnj4.VSMShadowMap) && this.type !== (0, $dRnj4.VSMShadowMap);
        // render depth map
        for(var i = 0, il = lights.length; i < il; i++){
            var light = lights[i];
            var shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            var shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                var pars = this.type !== (0, $dRnj4.VSMShadowMap) ? {
                    minFilter: (0, $dRnj4.NearestFilter),
                    magFilter: (0, $dRnj4.NearestFilter)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $dRnj4.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            var viewportCount = shadow.getViewportCount();
            for(var vp = 0; vp < viewportCount; vp++){
                var viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $dRnj4.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        var geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $dRnj4.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        var result = null;
        var customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                var keyA = result.uuid, keyB = material.uuid;
                var materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                var cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $dRnj4.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            var materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        var visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $dRnj4.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                var geometry = objects.update(object);
                var material = object.material;
                if (Array.isArray(material)) {
                    var groups = geometry.groups;
                    for(var k = 0, kl = groups.length; k < kl; k++){
                        var group = groups[k];
                        var groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            var depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    var depthMaterial1 = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial1, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial1, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial1, null);
                }
            }
        }
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        var material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(var id in _materialCache){
            var cache = _materialCache[id];
            var uuid = event.target.uuid;
            if (uuid in cache) {
                var shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
var $fca9b62618900888$var$_obj;
var $fca9b62618900888$var$reversedFuncs = ($fca9b62618900888$var$_obj = {}, (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.NeverDepth), (0, $dRnj4.AlwaysDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.LessDepth), (0, $dRnj4.GreaterDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.EqualDepth), (0, $dRnj4.NotEqualDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.LessEqualDepth), (0, $dRnj4.GreaterEqualDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.AlwaysDepth), (0, $dRnj4.NeverDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.GreaterDepth), (0, $dRnj4.LessDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.NotEqualDepth), (0, $dRnj4.EqualDepth)), (0, $cqEAj._)($fca9b62618900888$var$_obj, (0, $dRnj4.GreaterEqualDepth), (0, $dRnj4.LessEqualDepth)), $fca9b62618900888$var$_obj);
function $fca9b62618900888$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        var locked = false;
        var color = new (0, $dRnj4.Vector4)();
        var currentColorMask = null;
        var currentColorClear = new (0, $dRnj4.Vector4)(0, 0, 0, 0);
        return {
            setMask: function setMask(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function reset() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        var locked = false;
        var currentReversed = false;
        var currentDepthMask = null;
        var currentDepthFunc = null;
        var currentDepthClear = null;
        return {
            setReversed: function setReversed(reversed) {
                if (currentReversed !== reversed) {
                    var ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    var oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function getReversed() {
                return currentReversed;
            },
            setTest: function setTest(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function setMask(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function setFunc(depthFunc) {
                if (currentReversed) depthFunc = $fca9b62618900888$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $dRnj4.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $dRnj4.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $dRnj4.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $dRnj4.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $dRnj4.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $dRnj4.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $dRnj4.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $dRnj4.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function reset() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        var locked = false;
        var currentStencilMask = null;
        var currentStencilFunc = null;
        var currentStencilRef = null;
        var currentStencilFuncMask = null;
        var currentStencilFail = null;
        var currentStencilZFail = null;
        var currentStencilZPass = null;
        var currentStencilClear = null;
        return {
            setTest: function setTest(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function setMask(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function reset() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    var colorBuffer = new ColorBuffer();
    var depthBuffer = new DepthBuffer();
    var stencilBuffer = new StencilBuffer();
    var uboBindings = new WeakMap();
    var uboProgramMap = new WeakMap();
    var enabledCapabilities = {};
    var currentBoundFramebuffers = {};
    var currentDrawbuffers = new WeakMap();
    var defaultDrawbuffers = [];
    var currentProgram = null;
    var currentBlendingEnabled = false;
    var currentBlending = null;
    var currentBlendEquation = null;
    var currentBlendSrc = null;
    var currentBlendDst = null;
    var currentBlendEquationAlpha = null;
    var currentBlendSrcAlpha = null;
    var currentBlendDstAlpha = null;
    var currentBlendColor = new (0, $dRnj4.Color)(0, 0, 0);
    var currentBlendAlpha = 0;
    var currentPremultipledAlpha = false;
    var currentFlipSided = null;
    var currentCullFace = null;
    var currentLineWidth = null;
    var currentPolygonOffsetFactor = null;
    var currentPolygonOffsetUnits = null;
    var maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    var lineWidthAvailable = false;
    var version = 0;
    var glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    var currentTextureSlot = null;
    var currentBoundTextures = {};
    var scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    var viewportParam = gl.getParameter(gl.VIEWPORT);
    var currentScissor = new (0, $dRnj4.Vector4)().fromArray(scissorParam);
    var currentViewport = new (0, $dRnj4.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        var texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(var i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    var emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $dRnj4.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, $dRnj4.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, $dRnj4.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        var _$drawBuffers = defaultDrawbuffers;
        var needsUpdate = false;
        if (renderTarget) {
            _$drawBuffers = currentDrawbuffers.get(framebuffer);
            if (_$drawBuffers === undefined) {
                _$drawBuffers = [];
                currentDrawbuffers.set(framebuffer, _$drawBuffers);
            }
            var textures = renderTarget.textures;
            if (_$drawBuffers.length !== textures.length || _$drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(var i = 0, il = textures.length; i < il; i++)_$drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                _$drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (_$drawBuffers[0] !== gl.BACK) {
            _$drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(_$drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    var _obj;
    var equationToGL = (_obj = {}, (0, $cqEAj._)(_obj, (0, $dRnj4.AddEquation), gl.FUNC_ADD), (0, $cqEAj._)(_obj, (0, $dRnj4.SubtractEquation), gl.FUNC_SUBTRACT), (0, $cqEAj._)(_obj, (0, $dRnj4.ReverseSubtractEquation), gl.FUNC_REVERSE_SUBTRACT), _obj);
    equationToGL[0, $dRnj4.MinEquation] = gl.MIN;
    equationToGL[0, $dRnj4.MaxEquation] = gl.MAX;
    var _obj1;
    var factorToGL = (_obj1 = {}, (0, $cqEAj._)(_obj1, (0, $dRnj4.ZeroFactor), gl.ZERO), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneFactor), gl.ONE), (0, $cqEAj._)(_obj1, (0, $dRnj4.SrcColorFactor), gl.SRC_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.SrcAlphaFactor), gl.SRC_ALPHA), (0, $cqEAj._)(_obj1, (0, $dRnj4.SrcAlphaSaturateFactor), gl.SRC_ALPHA_SATURATE), (0, $cqEAj._)(_obj1, (0, $dRnj4.DstColorFactor), gl.DST_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.DstAlphaFactor), gl.DST_ALPHA), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusSrcColorFactor), gl.ONE_MINUS_SRC_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusSrcAlphaFactor), gl.ONE_MINUS_SRC_ALPHA), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusDstColorFactor), gl.ONE_MINUS_DST_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusDstAlphaFactor), gl.ONE_MINUS_DST_ALPHA), (0, $cqEAj._)(_obj1, (0, $dRnj4.ConstantColorFactor), gl.CONSTANT_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusConstantColorFactor), gl.ONE_MINUS_CONSTANT_COLOR), (0, $cqEAj._)(_obj1, (0, $dRnj4.ConstantAlphaFactor), gl.CONSTANT_ALPHA), (0, $cqEAj._)(_obj1, (0, $dRnj4.OneMinusConstantAlphaFactor), gl.ONE_MINUS_CONSTANT_ALPHA), _obj1);
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $dRnj4.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $dRnj4.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $dRnj4.AddEquation) || currentBlendEquationAlpha !== (0, $dRnj4.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $dRnj4.AddEquation);
                    currentBlendEquationAlpha = (0, $dRnj4.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $dRnj4.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $dRnj4.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $dRnj4.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $dRnj4.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $dRnj4.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $dRnj4.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $dRnj4.SubtractiveBlending:
                        console.error('THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $dRnj4.MultiplyBlending:
                        console.error('THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $dRnj4.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        var flipSided = material.side === (0, $dRnj4.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $dRnj4.NormalBlending) && material.transparent === false ? setBlending((0, $dRnj4.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        var stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $dRnj4.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $dRnj4.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $dRnj4.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        var boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        var boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            var _gl;
            (_gl = gl).compressedTexImage2D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            var _gl;
            (_gl = gl).compressedTexImage3D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            var _gl;
            (_gl = gl).texSubImage2D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            var _gl;
            (_gl = gl).texSubImage3D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            var _gl;
            (_gl = gl).compressedTexSubImage2D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            var _gl;
            (_gl = gl).compressedTexSubImage3D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            var _gl;
            (_gl = gl).texStorage2D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            var _gl;
            (_gl = gl).texStorage3D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            var _gl;
            (_gl = gl).texImage2D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            var _gl;
            (_gl = gl).texImage3D.apply(_gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        var mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        var blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        var mapping = uboProgramMap.get(program);
        var blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $dRnj4.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $fca9b62618900888$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    var multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    var supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    var _imageDimensions = new (0, $dRnj4.Vector2)();
    var _videoTextures = new WeakMap();
    var _canvas;
    var _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    var useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $dRnj4.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        var scale = 1;
        var dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                var width = Math.floor(scale * dimensions.width);
                var height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace) {
        var forceLinearTransfer = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        var internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            var transfer = forceLinearTransfer ? (0, $dRnj4.LinearTransfer) : (0, $dRnj4.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $dRnj4.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        var glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $dRnj4.UnsignedIntType) || depthType === (0, $dRnj4.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $dRnj4.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $dRnj4.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $dRnj4.UnsignedIntType) || depthType === (0, $dRnj4.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $dRnj4.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $dRnj4.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $dRnj4.NearestFilter) && texture.minFilter !== (0, $dRnj4.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures["delete"](texture);
    }
    function onRenderTargetDispose(event) {
        var renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        var textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        var source = texture.source;
        var webglTextures = _sources.get(source);
        if (webglTextures) {
            var webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources["delete"](source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        var textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        var source = texture.source;
        var webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(var i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(var level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(var level1 = 0; level1 < renderTargetProperties.__webglFramebuffer.length; level1++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level1]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(var i1 = 0; i1 < renderTargetProperties.__webglColorRenderbuffer.length; i1++)if (renderTargetProperties.__webglColorRenderbuffer[i1]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i1]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        var textures = renderTarget.textures;
        for(var i2 = 0, il = textures.length; i2 < il; i2++){
            var attachmentProperties = properties.get(textures[i2]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i2]);
        }
        properties.remove(renderTarget);
    }
    //
    var textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        var textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        var array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            var image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    var _obj;
    var wrappingToGL = (_obj = {}, (0, $cqEAj._)(_obj, (0, $dRnj4.RepeatWrapping), _gl.REPEAT), (0, $cqEAj._)(_obj, (0, $dRnj4.ClampToEdgeWrapping), _gl.CLAMP_TO_EDGE), (0, $cqEAj._)(_obj, (0, $dRnj4.MirroredRepeatWrapping), _gl.MIRRORED_REPEAT), _obj);
    var _obj1;
    var filterToGL = (_obj1 = {}, (0, $cqEAj._)(_obj1, (0, $dRnj4.NearestFilter), _gl.NEAREST), (0, $cqEAj._)(_obj1, (0, $dRnj4.NearestMipmapNearestFilter), _gl.NEAREST_MIPMAP_NEAREST), (0, $cqEAj._)(_obj1, (0, $dRnj4.NearestMipmapLinearFilter), _gl.NEAREST_MIPMAP_LINEAR), (0, $cqEAj._)(_obj1, (0, $dRnj4.LinearFilter), _gl.LINEAR), (0, $cqEAj._)(_obj1, (0, $dRnj4.LinearMipmapNearestFilter), _gl.LINEAR_MIPMAP_NEAREST), (0, $cqEAj._)(_obj1, (0, $dRnj4.LinearMipmapLinearFilter), _gl.LINEAR_MIPMAP_LINEAR), _obj1);
    var _obj2;
    var compareToGL = (_obj2 = {}, (0, $cqEAj._)(_obj2, (0, $dRnj4.NeverCompare), _gl.NEVER), (0, $cqEAj._)(_obj2, (0, $dRnj4.AlwaysCompare), _gl.ALWAYS), (0, $cqEAj._)(_obj2, (0, $dRnj4.LessCompare), _gl.LESS), (0, $cqEAj._)(_obj2, (0, $dRnj4.LessEqualCompare), _gl.LEQUAL), (0, $cqEAj._)(_obj2, (0, $dRnj4.EqualCompare), _gl.EQUAL), (0, $cqEAj._)(_obj2, (0, $dRnj4.GreaterEqualCompare), _gl.GEQUAL), (0, $cqEAj._)(_obj2, (0, $dRnj4.GreaterCompare), _gl.GREATER), (0, $cqEAj._)(_obj2, (0, $dRnj4.NotEqualCompare), _gl.NOTEQUAL), _obj2);
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $dRnj4.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $dRnj4.LinearFilter) || texture.magFilter === (0, $dRnj4.LinearMipmapNearestFilter) || texture.magFilter === (0, $dRnj4.NearestMipmapLinearFilter) || texture.magFilter === (0, $dRnj4.LinearMipmapLinearFilter) || texture.minFilter === (0, $dRnj4.LinearFilter) || texture.minFilter === (0, $dRnj4.LinearMipmapNearestFilter) || texture.minFilter === (0, $dRnj4.NearestMipmapLinearFilter) || texture.minFilter === (0, $dRnj4.LinearMipmapLinearFilter))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $dRnj4.NearestFilter)) return;
            if (texture.minFilter !== (0, $dRnj4.NearestMipmapLinearFilter) && texture.minFilter !== (0, $dRnj4.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $dRnj4.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                var extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        var forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        var source = texture.source;
        var webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        var textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            var webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        var componentStride = 4; // only RGBA supported
        var updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort(function(a, b) {
                return a.start - b.start;
            });
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            var mergeIndex = 0;
            for(var i = 1; i < updateRanges.length; i++){
                var previousRange = updateRanges[mergeIndex];
                var range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                var previousEnd = previousRange.start + previousRange.count;
                var currentRow = getRow(range.start, image.width, componentStride);
                var previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            var currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            var currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            var currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(var i1 = 0, l = updateRanges.length; i1 < l; i1++){
                var range1 = updateRanges[i1];
                var pixelStart = Math.floor(range1.start / componentStride);
                var pixelCount = Math.ceil(range1.count / componentStride);
                var x = pixelStart % image.width;
                var y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                var width = pixelCount;
                var height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        var textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        var forceUpload = initTexture(textureProperties, texture);
        var source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        var sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            var workingPrimaries = (0, $dRnj4.ColorManagement).getPrimaries((0, $dRnj4.ColorManagement).workingColorSpace);
            var texturePrimaries = texture.colorSpace === (0, $dRnj4.NoColorSpace) ? null : (0, $dRnj4.ColorManagement).getPrimaries(texture.colorSpace);
            var unpackConversion = texture.colorSpace === (0, $dRnj4.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            var image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            var glFormat = utils.convert(texture.format, texture.colorSpace);
            var glType = utils.convert(texture.type);
            var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            var mipmap;
            var mipmaps = texture.mipmaps;
            var useTexStorage = texture.isVideoTexture !== true;
            var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            var dataReady = source.dataReady;
            var levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $dRnj4.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(var i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(var i1 = 0, il1 = mipmaps.length; i1 < il1; i1++){
                        mipmap = mipmaps[i1];
                        if (texture.format !== (0, $dRnj4.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            var layerByteLength = (0, $dRnj4.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = texture.layerUpdates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var layerIndex = _step.value;
                                                    var layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                    state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i1, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i1, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(var i2 = 0, il2 = mipmaps.length; i2 < il2; i2++){
                        mipmap = mipmaps[i2];
                        if (texture.format !== (0, $dRnj4.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            var layerByteLength1 = (0, $dRnj4.getByteLength)(image.width, image.height, texture.format, texture.type);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = texture.layerUpdates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var layerIndex1 = _step1.value;
                                    var layerData1 = image.data.subarray(layerIndex1 * layerByteLength1 / image.data.BYTES_PER_ELEMENT, (layerIndex1 + 1) * layerByteLength1 / image.data.BYTES_PER_ELEMENT);
                                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex1, image.width, image.height, 1, glFormat, glType, layerData1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        var width = image.width, height = image.height;
                        for(var i3 = 0; i3 < levels; i3++){
                            state.texImage2D(_gl.TEXTURE_2D, i3, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        var dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(var i4 = 0, il3 = mipmaps.length; i4 < il3; i4++){
                        mipmap = mipmaps[i4];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i4, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i4, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        var dimensions1 = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions1.width, dimensions1.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        var forceUpload = initTexture(textureProperties, texture);
        var source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        var sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            var workingPrimaries = (0, $dRnj4.ColorManagement).getPrimaries((0, $dRnj4.ColorManagement).workingColorSpace);
            var texturePrimaries = texture.colorSpace === (0, $dRnj4.NoColorSpace) ? null : (0, $dRnj4.ColorManagement).getPrimaries(texture.colorSpace);
            var unpackConversion = texture.colorSpace === (0, $dRnj4.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            var isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            var cubeImage = [];
            for(var i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            var image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            var useTexStorage = texture.isVideoTexture !== true;
            var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            var dataReady = source.dataReady;
            var levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            var mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(var i1 = 0; i1 < 6; i1++){
                    mipmaps = cubeImage[i1].mipmaps;
                    for(var j = 0; j < mipmaps.length; j++){
                        var mipmap = mipmaps[j];
                        if (texture.format !== (0, $dRnj4.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    var dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(var i2 = 0; i2 < 6; i2++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
                    for(var j1 = 0; j1 < mipmaps.length; j1++){
                        var mipmap1 = mipmaps[j1];
                        var mipmapImage = mipmap1.image[i2].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j1 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j1 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
                    for(var j2 = 0; j2 < mipmaps.length; j2++){
                        var mipmap2 = mipmaps[j2];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, 0, 0, glFormat, glType, mipmap2.image[i2]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, glInternalFormat, glFormat, glType, mipmap2.image[i2]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        var glFormat = utils.convert(texture.format, texture.colorSpace);
        var glType = utils.convert(texture.type);
        var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            var width = Math.max(1, renderTarget.width >> level);
            var height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            var depthTexture = renderTarget.depthTexture;
            var depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            var glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            var glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            var samples = getRenderTargetSamples(renderTarget);
            var isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            var textures = renderTarget.textures;
            for(var i = 0; i < textures.length; i++){
                var texture = textures[i];
                var glFormat = utils.convert(texture.format, texture.colorSpace);
                var glType = utils.convert(texture.type);
                var glInternalFormat1 = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                var samples1 = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples1, glInternalFormat1, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples1, glInternalFormat1, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat1, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        var textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        var webglDepthTexture = textureProperties.__webglTexture;
        var samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $dRnj4.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $dRnj4.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            var depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                var disposeEvent = function() {
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            var mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget);
            else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(var i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    var glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    var renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            var mipmaps1 = renderTarget.texture.mipmaps;
            if (mipmaps1 && mipmaps1.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                var glAttachmentType1 = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                var renderbuffer1 = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer1);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType1, _gl.RENDERBUFFER, renderbuffer1);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        var renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        var texture = renderTarget.texture;
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        var textures = renderTarget.textures;
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        var isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(var i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(var level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(var level1 = 0; level1 < texture.mipmaps.length; level1++)renderTargetProperties.__webglFramebuffer[level1] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(var i1 = 0, il = textures.length; i1 < il; i1++){
                var attachmentProperties = properties.get(textures[i1]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(var i2 = 0; i2 < textures.length; i2++){
                    var texture1 = textures[i2];
                    renderTargetProperties.__webglColorRenderbuffer[i2] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                    var glFormat = utils.convert(texture1.format, texture1.colorSpace);
                    var glType = utils.convert(texture1.type);
                    var glInternalFormat = getInternalFormat(texture1.internalFormat, glFormat, glType, texture1.colorSpace, renderTarget.isXRRenderTarget === true);
                    var samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(var i3 = 0; i3 < 6; i3++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(var level2 = 0; level2 < texture.mipmaps.length; level2++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i3][level2], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i3, level2);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i3], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i3, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(var i4 = 0, il1 = textures.length; i4 < il1; i4++){
                var attachment = textures[i4];
                var attachmentProperties1 = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties1.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i4, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            var glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(var level3 = 0; level3 < texture.mipmaps.length; level3++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level3], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level3);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        var textures = renderTarget.textures;
        for(var i = 0, il = textures.length; i < il; i++){
            var texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                var targetType = getTargetType(renderTarget);
                var webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    var invalidationArrayRead = [];
    var invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                var textures = renderTarget.textures;
                var width = renderTarget.width;
                var height = renderTarget.height;
                var mask = _gl.COLOR_BUFFER_BIT;
                var depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                var renderTargetProperties = properties.get(renderTarget);
                var isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(var i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                var mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(var i1 = 0; i1 < textures.length; i1++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i1]);
                        var webglTexture = properties.get(textures[i1]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i1);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(var i2 = 0; i2 < textures.length; i2++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                    var webglTexture1 = properties.get(textures[i2]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, webglTexture1, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                var depthStyle1 = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle1
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        var frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        var colorSpace = texture.colorSpace;
        var format = texture.format;
        var type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $dRnj4.LinearSRGBColorSpace) && colorSpace !== (0, $dRnj4.NoColorSpace)) {
            // sRGB
            if ((0, $dRnj4.ColorManagement).getTransfer(colorSpace) === (0, $dRnj4.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $dRnj4.RGBAFormat) || type !== (0, $dRnj4.UnsignedByteType)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $fca9b62618900888$export$ddaebcad857649a8(gl, extensions) {
    function convert(p) {
        var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $dRnj4.NoColorSpace);
        var extension;
        var transfer = (0, $dRnj4.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $dRnj4.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $dRnj4.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $dRnj4.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $dRnj4.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $dRnj4.ByteType)) return gl.BYTE;
        if (p === (0, $dRnj4.ShortType)) return gl.SHORT;
        if (p === (0, $dRnj4.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $dRnj4.IntType)) return gl.INT;
        if (p === (0, $dRnj4.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $dRnj4.FloatType)) return gl.FLOAT;
        if (p === (0, $dRnj4.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $dRnj4.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $dRnj4.RGBFormat)) return gl.RGB;
        if (p === (0, $dRnj4.RGBAFormat)) return gl.RGBA;
        if (p === (0, $dRnj4.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $dRnj4.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $dRnj4.RedFormat)) return gl.RED;
        if (p === (0, $dRnj4.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $dRnj4.RGFormat)) return gl.RG;
        if (p === (0, $dRnj4.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $dRnj4.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $dRnj4.RGB_S3TC_DXT1_Format) || p === (0, $dRnj4.RGBA_S3TC_DXT1_Format) || p === (0, $dRnj4.RGBA_S3TC_DXT3_Format) || p === (0, $dRnj4.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $dRnj4.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $dRnj4.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $dRnj4.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $dRnj4.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $dRnj4.RGB_PVRTC_4BPPV1_Format) || p === (0, $dRnj4.RGB_PVRTC_2BPPV1_Format) || p === (0, $dRnj4.RGBA_PVRTC_4BPPV1_Format) || p === (0, $dRnj4.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $dRnj4.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $dRnj4.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $dRnj4.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $dRnj4.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $dRnj4.RGB_ETC1_Format) || p === (0, $dRnj4.RGB_ETC2_Format) || p === (0, $dRnj4.RGBA_ETC2_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $dRnj4.RGB_ETC1_Format) || p === (0, $dRnj4.RGB_ETC2_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $dRnj4.RGBA_ETC2_EAC_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $dRnj4.RGBA_ASTC_4x4_Format) || p === (0, $dRnj4.RGBA_ASTC_5x4_Format) || p === (0, $dRnj4.RGBA_ASTC_5x5_Format) || p === (0, $dRnj4.RGBA_ASTC_6x5_Format) || p === (0, $dRnj4.RGBA_ASTC_6x6_Format) || p === (0, $dRnj4.RGBA_ASTC_8x5_Format) || p === (0, $dRnj4.RGBA_ASTC_8x6_Format) || p === (0, $dRnj4.RGBA_ASTC_8x8_Format) || p === (0, $dRnj4.RGBA_ASTC_10x5_Format) || p === (0, $dRnj4.RGBA_ASTC_10x6_Format) || p === (0, $dRnj4.RGBA_ASTC_10x8_Format) || p === (0, $dRnj4.RGBA_ASTC_10x10_Format) || p === (0, $dRnj4.RGBA_ASTC_12x10_Format) || p === (0, $dRnj4.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $dRnj4.RGBA_ASTC_4x4_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_5x4_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_5x5_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_6x5_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_6x6_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_8x5_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_8x6_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_8x8_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_10x5_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_10x6_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_10x8_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_10x10_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_12x10_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $dRnj4.RGBA_ASTC_12x12_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $dRnj4.RGBA_BPTC_Format) || p === (0, $dRnj4.RGB_BPTC_SIGNED_Format) || p === (0, $dRnj4.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $dRnj4.RGBA_BPTC_Format)) return transfer === (0, $dRnj4.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $dRnj4.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $dRnj4.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $dRnj4.RED_RGTC1_Format) || p === (0, $dRnj4.SIGNED_RED_RGTC1_Format) || p === (0, $dRnj4.RED_GREEN_RGTC2_Format) || p === (0, $dRnj4.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $dRnj4.RGBA_BPTC_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $dRnj4.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $dRnj4.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $dRnj4.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $dRnj4.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
var $fca9b62618900888$var$_occlusion_vertex = "\nvoid main() {\n\n	gl_Position = vec4( position, 1.0 );\n\n}";
var $fca9b62618900888$var$_occlusion_fragment = "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n	if ( coord.x >= 1.0 ) {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n	} else {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n	}\n\n}";
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ var $fca9b62618900888$var$WebXRDepthSensing = /*#__PURE__*/ function() {
    "use strict";
    function WebXRDepthSensing() {
        (0, $jGAMp._)(this, WebXRDepthSensing);
        /**
		 * A texture representing the depth of the user's environment.
		 *
		 * @type {?Texture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    (0, $byiyg._)(WebXRDepthSensing, [
        {
            /**
	 * Inits the depth sensing module
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ key: "init",
            value: function init(renderer, depthData, renderState) {
                if (this.texture === null) {
                    var texture = new (0, $dRnj4.Texture)();
                    var texProps = renderer.properties.get(texture);
                    texProps.__webglTexture = depthData.texture;
                    if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                        this.depthNear = depthData.depthNear;
                        this.depthFar = depthData.depthFar;
                    }
                    this.texture = texture;
                }
            }
        },
        {
            /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ key: "getMesh",
            value: function getMesh(cameraXR) {
                if (this.texture !== null) {
                    if (this.mesh === null) {
                        var viewport = cameraXR.cameras[0].viewport;
                        var material = new (0, $dRnj4.ShaderMaterial)({
                            vertexShader: $fca9b62618900888$var$_occlusion_vertex,
                            fragmentShader: $fca9b62618900888$var$_occlusion_fragment,
                            uniforms: {
                                depthColor: {
                                    value: this.texture
                                },
                                depthWidth: {
                                    value: viewport.z
                                },
                                depthHeight: {
                                    value: viewport.w
                                }
                            }
                        });
                        this.mesh = new (0, $dRnj4.Mesh)(new (0, $dRnj4.PlaneGeometry)(20, 20), material);
                    }
                }
                return this.mesh;
            }
        },
        {
            /**
	 * Resets the module
	 */ key: "reset",
            value: function reset() {
                this.texture = null;
                this.mesh = null;
            }
        },
        {
            /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?Texture} The depth texture.
	 */ key: "getDepthTexture",
            value: function getDepthTexture() {
                return this.texture;
            }
        }
    ]);
    return WebXRDepthSensing;
}();
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ var $fca9b62618900888$var$WebXRManager = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(WebXRManager, EventDispatcher);
    function WebXRManager(renderer, gl) {
        (0, $jGAMp._)(this, WebXRManager);
        var _this;
        var onSessionEvent = //
        function onSessionEvent(event) {
            var controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            var controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        };
        var onInputSourcesChange = function onInputSourcesChange(event) {
            // Notify disconnected
            for(var i = 0; i < event.removed.length; i++){
                var inputSource = event.removed[i];
                var index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(var i1 = 0; i1 < event.added.length; i1++){
                var inputSource1 = event.added[i1];
                var controllerIndex = controllerInputSources.indexOf(inputSource1);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(var i2 = 0; i2 < controllers.length; i2++){
                        if (i2 >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource1);
                            controllerIndex = i2;
                            break;
                        } else if (controllerInputSources[i2] === null) {
                            controllerInputSources[i2] = inputSource1;
                            controllerIndex = i2;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                var controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource1);
            }
        };
        var setProjectionFromUnion = /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            var ipd = cameraLPos.distanceTo(cameraRPos);
            var projL = cameraL.projectionMatrix.elements;
            var projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            var near = projL[14] / (projL[10] - 1);
            var far = projL[14] / (projL[10] + 1);
            var topFov = (projL[9] + 1) / projL[5];
            var bottomFov = (projL[9] - 1) / projL[5];
            var leftFov = (projL[8] - 1) / projL[0];
            var rightFov = (projR[8] + 1) / projR[0];
            var left = near * leftFov;
            var right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            var zOffset = ipd / (-leftFov + rightFov);
            var xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                var near2 = near + zOffset;
                var far2 = far + zOffset;
                var left2 = left - xOffset;
                var right2 = right + (ipd - xOffset);
                var top2 = topFov * far / far2 * near2;
                var bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        };
        var updateCamera = function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        };
        var updateUserCamera = function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $dRnj4.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        };
        var onAnimationFrame = function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                var views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                var cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(var i = 0; i < views.length; i++){
                    var view = views[i];
                    var viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    var camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $dRnj4.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $dRnj4.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                var enabledFeatures = session.enabledFeatures;
                var gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && glBinding) {
                    var depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(var i1 = 0; i1 < controllers.length; i1++){
                var inputSource = controllerInputSources[i1];
                var controller = controllers[i1];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        };
        var _this1;
        _this = (0, $kzDuW._)(this, WebXRManager), _this1 = _this;
        var scope = _this1;
        var session = null;
        var framebufferScaleFactor = 1.0;
        var referenceSpace = null;
        var referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        var foveation = 1.0;
        var customReferenceSpace = null;
        var pose = null;
        var glBinding = null;
        var glProjLayer = null;
        var glBaseLayer = null;
        var xrFrame = null;
        var depthSensing = new $fca9b62618900888$var$WebXRDepthSensing();
        var attributes = gl.getContextAttributes();
        var initialRenderTarget = null;
        var newRenderTarget = null;
        var controllers = [];
        var controllerInputSources = [];
        var currentSize = new (0, $dRnj4.Vector2)();
        var currentPixelRatio = null;
        //
        var cameraL = new (0, $dRnj4.PerspectiveCamera)();
        cameraL.viewport = new (0, $dRnj4.Vector4)();
        var cameraR = new (0, $dRnj4.PerspectiveCamera)();
        cameraR.viewport = new (0, $dRnj4.Vector4)();
        var cameras = [
            cameraL,
            cameraR
        ];
        var cameraXR = new (0, $dRnj4.ArrayCamera)();
        var _currentDepthNear = null;
        var _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this1.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this1.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ _this1.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ _this1.getController = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dRnj4.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ _this1.getControllerGrip = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dRnj4.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ _this1.getHand = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $dRnj4.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(var i = 0; i < controllers.length; i++){
                var inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ _this1.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ _this1.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ _this1.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ _this1.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ _this1.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * @return {?XRWebGLBinding} The XR binding.
		 */ _this1.getBinding = function() {
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ _this1.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ _this1.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ _this1.setSession = function(value) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var useLayers, layerInit, depthFormat, depthType, glDepthFormat, projectionlayerInit;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            session = value;
                            if (!(session !== null)) return [
                                3,
                                4
                            ];
                            initialRenderTarget = renderer.getRenderTarget();
                            session.addEventListener('select', onSessionEvent);
                            session.addEventListener('selectstart', onSessionEvent);
                            session.addEventListener('selectend', onSessionEvent);
                            session.addEventListener('squeeze', onSessionEvent);
                            session.addEventListener('squeezestart', onSessionEvent);
                            session.addEventListener('squeezeend', onSessionEvent);
                            session.addEventListener('end', onSessionEnd);
                            session.addEventListener('inputsourceschange', onInputSourcesChange);
                            if (!(attributes.xrCompatible !== true)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                gl.makeXRCompatible()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            currentPixelRatio = renderer.getPixelRatio();
                            renderer.getSize(currentSize);
                            // Check that the browser implements the necessary APIs to use an
                            // XRProjectionLayer rather than an XRWebGLLayer
                            useLayers = typeof XRWebGLBinding !== 'undefined' && 'createProjectionLayer' in XRWebGLBinding.prototype;
                            if (!useLayers) {
                                layerInit = {
                                    antialias: attributes.antialias,
                                    alpha: true,
                                    depth: attributes.depth,
                                    stencil: attributes.stencil,
                                    framebufferScaleFactor: framebufferScaleFactor
                                };
                                glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                                session.updateRenderState({
                                    baseLayer: glBaseLayer
                                });
                                renderer.setPixelRatio(1);
                                renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                                newRenderTarget = new (0, $dRnj4.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                                    format: (0, $dRnj4.RGBAFormat),
                                    type: (0, $dRnj4.UnsignedByteType),
                                    colorSpace: renderer.outputColorSpace,
                                    stencilBuffer: attributes.stencil,
                                    resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                                    resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                                });
                            } else {
                                depthFormat = null;
                                depthType = null;
                                glDepthFormat = null;
                                if (attributes.depth) {
                                    glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                                    depthFormat = attributes.stencil ? (0, $dRnj4.DepthStencilFormat) : (0, $dRnj4.DepthFormat);
                                    depthType = attributes.stencil ? (0, $dRnj4.UnsignedInt248Type) : (0, $dRnj4.UnsignedIntType);
                                }
                                projectionlayerInit = {
                                    colorFormat: gl.RGBA8,
                                    depthFormat: glDepthFormat,
                                    scaleFactor: framebufferScaleFactor
                                };
                                glBinding = new XRWebGLBinding(session, gl);
                                glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                                session.updateRenderState({
                                    layers: [
                                        glProjLayer
                                    ]
                                });
                                renderer.setPixelRatio(1);
                                renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                                newRenderTarget = new (0, $dRnj4.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                                    format: (0, $dRnj4.RGBAFormat),
                                    type: (0, $dRnj4.UnsignedByteType),
                                    depthTexture: new (0, $dRnj4.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                                    stencilBuffer: attributes.stencil,
                                    colorSpace: renderer.outputColorSpace,
                                    samples: attributes.antialias ? 4 : 0,
                                    resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                                    resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                                });
                            }
                            newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                            this.setFoveation(foveation);
                            customReferenceSpace = null;
                            return [
                                4,
                                session.requestReferenceSpace(referenceSpaceType)
                            ];
                        case 3:
                            referenceSpace = _state.sent();
                            animation.setContext(session);
                            animation.start();
                            scope.isPresenting = true;
                            scope.dispatchEvent({
                                type: 'sessionstart'
                            });
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(this);
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ _this1.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * @return {?Texture} The depth texture.
		 */ _this1.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        //
        var cameraLPos = new (0, $dRnj4.Vector3)();
        var cameraRPos = new (0, $dRnj4.Vector3)();
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ _this1.updateCamera = function(camera) {
            if (session === null) return;
            var depthNear = camera.near;
            var depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            var parent = camera.parent;
            var cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(var i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ _this1.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number} The amount of foveation.
		 */ _this1.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ _this1.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ _this1.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ _this1.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        var onAnimationFrameCallback = null;
        var animation = new $fca9b62618900888$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        _this1.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        _this1.dispose = function() {};
        return _this;
    }
    return WebXRManager;
}((0, $dRnj4.EventDispatcher));
var $fca9b62618900888$var$_e1 = /*@__PURE__*/ new (0, $dRnj4.Euler)();
var $fca9b62618900888$var$_m1 = /*@__PURE__*/ new (0, $dRnj4.Matrix4)();
function $fca9b62618900888$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $dRnj4.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $dRnj4.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $dRnj4.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        var materialProperties = properties.get(material);
        var envMap = materialProperties.envMap;
        var envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $fca9b62618900888$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $fca9b62618900888$var$_e1.x *= -1;
            $fca9b62618900888$var$_e1.y *= -1;
            $fca9b62618900888$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $fca9b62618900888$var$_e1.y *= -1;
                $fca9b62618900888$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($fca9b62618900888$var$_m1.makeRotationFromEuler($fca9b62618900888$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $dRnj4.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        var light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $fca9b62618900888$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    var buffers = {};
    var updateList = {};
    var allocatedBindingPoints = [];
    var maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        var webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        var buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        var webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        var frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        var bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        var buffer = gl.createBuffer();
        var size = uniformsGroup.__size;
        var usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(var i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        var buffer = buffers[uniformsGroup.id];
        var uniforms = uniformsGroup.uniforms;
        var cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(var i = 0, il = uniforms.length; i < il; i++){
            var uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(var j = 0, jl = uniformArray.length; j < jl; j++){
                var uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    var offset = uniform.__offset;
                    var values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    var arrayOffset = 0;
                    for(var k = 0; k < values.length; k++){
                        var value = values[k];
                        var info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        var value = uniform.value;
        var indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            var cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        var uniforms = uniformsGroup.uniforms;
        var offset = 0; // global buffer offset in bytes
        var chunkSize = 16; // size of a chunk in bytes
        for(var i = 0, l = uniforms.length; i < l; i++){
            var uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(var j = 0, jl = uniformArray.length; j < jl; j++){
                var uniform = uniformArray[j];
                var values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(var k = 0, kl = values.length; k < kl; k++){
                    var value = values[k];
                    var info = getUniformSize(value);
                    var chunkOffset = offset % chunkSize; // offset in the current chunk
                    var chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    var chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        var chunkOffset1 = offset % chunkSize;
        if (chunkOffset1 > 0) offset += chunkSize - chunkOffset1;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        var info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        var uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        var index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(var id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ var $fca9b62618900888$export$f6cc00ef28d7cf97 = /*#__PURE__*/ function() {
    "use strict";
    function WebGLRenderer() {
        var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $jGAMp._)(this, WebGLRenderer);
        var getTargetPixelRatio = function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        };
        var getContext = function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        };
        var initGLContext = function initGLContext() {
            extensions = new $fca9b62618900888$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $fca9b62618900888$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $fca9b62618900888$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $fca9b62618900888$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $fca9b62618900888$var$WebGLInfo(_gl);
            properties = new $fca9b62618900888$var$WebGLProperties();
            textures = new $fca9b62618900888$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $fca9b62618900888$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $fca9b62618900888$var$WebGLCubeUVMaps(_this);
            attributes = new $fca9b62618900888$var$WebGLAttributes(_gl);
            bindingStates = new $fca9b62618900888$var$WebGLBindingStates(_gl, attributes);
            geometries = new $fca9b62618900888$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $fca9b62618900888$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $fca9b62618900888$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $fca9b62618900888$var$WebGLClipping(properties);
            programCache = new $fca9b62618900888$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $fca9b62618900888$var$WebGLMaterials(_this, properties);
            renderLists = new $fca9b62618900888$var$WebGLRenderLists();
            renderStates = new $fca9b62618900888$var$WebGLRenderStates(extensions);
            background = new $fca9b62618900888$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $fca9b62618900888$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $fca9b62618900888$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $fca9b62618900888$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $fca9b62618900888$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        };
        var onContextLost = // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        };
        var onContextRestore = function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            var infoAutoReset = info.autoReset;
            var shadowMapEnabled = shadowMap.enabled;
            var shadowMapAutoUpdate = shadowMap.autoUpdate;
            var shadowMapNeedsUpdate = shadowMap.needsUpdate;
            var shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        };
        var onContextCreationError = function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        };
        var deallocateMaterial = // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        };
        var releaseMaterialProgramReferences = function releaseMaterialProgramReferences(material) {
            var programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        };
        var prepareMaterial = // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $dRnj4.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $dRnj4.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $dRnj4.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $dRnj4.DoubleSide);
            } else getProgram(material, scene, object);
        };
        var onAnimationFrame = function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        };
        var onXRSessionStart = function onXRSessionStart() {
            animation.stop();
        };
        var onXRSessionEnd = function onXRSessionEnd() {
            animation.start();
        };
        var renderScene = function renderScene(currentRenderList, scene, camera, viewport) {
            var opaqueObjects = currentRenderList.opaque;
            var transmissiveObjects = currentRenderList.transmissive;
            var transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        };
        var renderTransmissionPass = function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $dRnj4.WebGLRenderTarget)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $dRnj4.HalfFloatType) : (0, $dRnj4.UnsignedByteType),
                minFilter: (0, $dRnj4.LinearMipmapLinearFilter),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $dRnj4.ColorManagement).workingColorSpace
            });
            var transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            var activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            var currentRenderTarget = _this.getRenderTarget();
            var currentActiveCubeFace = _this.getActiveCubeFace();
            var currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            var currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $dRnj4.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            var currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                var renderTargetNeedsUpdate = false;
                for(var i = 0, l = transmissiveObjects.length; i < l; i++){
                    var renderItem = transmissiveObjects[i];
                    var object = renderItem.object;
                    var geometry = renderItem.geometry;
                    var material = renderItem.material;
                    var group = renderItem.group;
                    if (material.side === (0, $dRnj4.DoubleSide) && object.layers.test(camera.layers)) {
                        var currentSide = material.side;
                        material.side = (0, $dRnj4.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        };
        var renderObjects = function renderObjects(renderList, scene, camera) {
            var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(var i = 0, l = renderList.length; i < l; i++){
                var renderItem = renderList[i];
                var object = renderItem.object;
                var geometry = renderItem.geometry;
                var group = renderItem.group;
                var material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        };
        var renderObject = function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $dRnj4.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $dRnj4.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $dRnj4.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $dRnj4.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        };
        var getProgram = function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            var materialProperties = properties.get(material);
            var lights = currentRenderState.state.lights;
            var shadowsArray = currentRenderState.state.shadowsArray;
            var lightsStateVersion = lights.state.version;
            var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            var programCacheKey = programCache.getProgramCacheKey(parameters);
            var programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            var program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            var uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        };
        var getUniformList = function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                var progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $fca9b62618900888$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        };
        var updateCommonMaterialProperties = function updateCommonMaterialProperties(material, parameters) {
            var materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        };
        var setProgram = function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            var fog = scene.fog;
            var environment = material.isMeshStandardMaterial ? scene.environment : null;
            var colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $dRnj4.LinearSRGBColorSpace);
            var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            var vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            var vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            var morphTargets = !!geometry.morphAttributes.position;
            var morphNormals = !!geometry.morphAttributes.normal;
            var morphColors = !!geometry.morphAttributes.color;
            var toneMapping = (0, $dRnj4.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            var materialProperties = properties.get(material);
            var lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    var useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            var needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            var program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            var refreshProgram = false;
            var refreshMaterial = false;
            var refreshLights = false;
            var p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                var reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $dRnj4.toNormalizedProjectionMatrix)(_currentProjectionMatrix);
                    (0, $dRnj4.toReversedProjectionMatrix)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                var uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                var skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            var morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $fca9b62618900888$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $fca9b62618900888$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                var groups = material.uniformsGroups;
                for(var i = 0, l = groups.length; i < l; i++){
                    var group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        };
        var markUniformsLightsNeedsUpdate = // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        };
        var materialNeedsLights = function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        };
        var _parameters_canvas = parameters.canvas, canvas = _parameters_canvas === void 0 ? (0, $dRnj4.createCanvasElement)() : _parameters_canvas, _parameters_context = parameters.context, context = _parameters_context === void 0 ? null : _parameters_context, _parameters_depth = parameters.depth, depth = _parameters_depth === void 0 ? true : _parameters_depth, _parameters_stencil = parameters.stencil, stencil = _parameters_stencil === void 0 ? false : _parameters_stencil, _parameters_alpha = parameters.alpha, alpha = _parameters_alpha === void 0 ? false : _parameters_alpha, _parameters_antialias = parameters.antialias, antialias = _parameters_antialias === void 0 ? false : _parameters_antialias, _parameters_premultipliedAlpha = parameters.premultipliedAlpha, premultipliedAlpha = _parameters_premultipliedAlpha === void 0 ? true : _parameters_premultipliedAlpha, _parameters_preserveDrawingBuffer = parameters.preserveDrawingBuffer, preserveDrawingBuffer = _parameters_preserveDrawingBuffer === void 0 ? false : _parameters_preserveDrawingBuffer, _parameters_powerPreference = parameters.powerPreference, powerPreference = _parameters_powerPreference === void 0 ? 'default' : _parameters_powerPreference, _parameters_failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat, failIfMajorPerformanceCaveat = _parameters_failIfMajorPerformanceCaveat === void 0 ? false : _parameters_failIfMajorPerformanceCaveat, _parameters_reverseDepthBuffer = parameters.reverseDepthBuffer, reverseDepthBuffer = _parameters_reverseDepthBuffer === void 0 ? false : _parameters_reverseDepthBuffer;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        var _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        var uintClearColor = new Uint32Array(4);
        var intClearColor = new Int32Array(4);
        var currentRenderList = null;
        var currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        var renderListStack = [];
        var renderStateStack = [];
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {DOMElement}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $dRnj4.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        var _this = this;
        var _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $dRnj4.SRGBColorSpace);
        var _currentActiveCubeFace = 0;
        var _currentActiveMipmapLevel = 0;
        var _currentRenderTarget = null;
        var _currentMaterialId = -1;
        var _currentCamera = null;
        var _currentViewport = new (0, $dRnj4.Vector4)();
        var _currentScissor = new (0, $dRnj4.Vector4)();
        var _currentScissorTest = null;
        var _currentClearColor = new (0, $dRnj4.Color)(0x000000);
        var _currentClearAlpha = 0;
        //
        var _width = canvas.width;
        var _height = canvas.height;
        var _pixelRatio = 1;
        var _opaqueSort = null;
        var _transparentSort = null;
        var _viewport = new (0, $dRnj4.Vector4)(0, 0, _width, _height);
        var _scissor = new (0, $dRnj4.Vector4)(0, 0, _width, _height);
        var _scissorTest = false;
        // frustum
        var _frustum = new (0, $dRnj4.Frustum)();
        // clipping
        var _clippingEnabled = false;
        var _localClippingEnabled = false;
        // camera matrices cache
        var _currentProjectionMatrix = new (0, $dRnj4.Matrix4)();
        var _projScreenMatrix = new (0, $dRnj4.Matrix4)();
        var _vector3 = new (0, $dRnj4.Vector3)();
        var _vector4 = new (0, $dRnj4.Vector4)();
        var _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        var _renderBackground = false;
        // initialize
        var _gl = context;
        try {
            var contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', "three.js r".concat((0, $dRnj4.REVISION)));
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                var contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        var extensions, capabilities, state, info;
        var properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        var programCache, materials, renderLists, renderStates, clipping, shadowMap;
        var background, morphtargets, bufferRenderer, indexedBufferRenderer;
        var utils, bindingStates, uniformsGroups;
        initGLContext();
        // xr
        var xr = new $fca9b62618900888$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            var extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            var extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height) {
            var updateStyle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(_boolean) {
            state.setScissorTest(_scissorTest = _boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            var _background;
            (_background = background).setClearColor.apply(_background, arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            var _background;
            (_background = background).setClearAlpha.apply(_background, arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function() {
            var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, stencil = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                var isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    var targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $dRnj4.RGBAIntegerFormat) || targetFormat === (0, $dRnj4.RGIntegerFormat) || targetFormat === (0, $dRnj4.RedIntegerFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    var targetType = _currentRenderTarget.texture.type;
                    var isUnsignedType = targetType === (0, $dRnj4.UnsignedByteType) || targetType === (0, $dRnj4.UnsignedIntType) || targetType === (0, $dRnj4.UnsignedShortType) || targetType === (0, $dRnj4.UnsignedInt248Type) || targetType === (0, $dRnj4.UnsignedShort4444Type) || targetType === (0, $dRnj4.UnsignedShort5551Type);
                    var clearColor = background.getClearColor();
                    var a = background.getClearAlpha();
                    var r = clearColor.r;
                    var g = clearColor.g;
                    var b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        function onMaterialDispose(event) {
            var material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            var program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            var index = geometry.index;
            var rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            var drawRange = geometry.drawRange;
            var position = geometry.attributes.position;
            var drawStart = drawRange.start * rangeFactor;
            var drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            var drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            var attribute;
            var renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                var lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $dRnj4.warnOnce)('THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    var starts = object._multiDrawStarts;
                    var counts = object._multiDrawCounts;
                    var drawCount1 = object._multiDrawCount;
                    var bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    var uniforms = properties.get(material).currentProgram.getUniforms();
                    for(var i = 0; i < drawCount1; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                var maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                var instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera) {
            var targetScene = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            var materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                var material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(var i = 0; i < material.length; i++){
                        var material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera) {
            var targetScene = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            var materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise(function(resolve) {
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        var materialProperties = properties.get(material);
                        var program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials["delete"](material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        var onAnimationFrameCallback = null;
        var animation = new $fca9b62618900888$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                var depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            var shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            var opaqueObjects = currentRenderList.opaque;
            var transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                var cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(var i = 0, l = cameras.length; i < l; i++){
                    var camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(var i1 = 0, l1 = cameras.length; i1 < l1; i1++){
                    var camera21 = cameras[i1];
                    renderScene(currentRenderList, scene, camera21, camera21.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            var visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        var geometry = objects.update(object);
                        var material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        var geometry1 = objects.update(object);
                        var material1 = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry1.boundingSphere === null) geometry1.computeBoundingSphere();
                                _vector4.copy(geometry1.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material1)) {
                            var groups = geometry1.groups;
                            for(var i = 0, l = groups.length; i < l; i++){
                                var group = groups[i];
                                var groupMaterial = material1[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry1, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material1.visible) currentRenderList.push(object, geometry1, material1, groupOrder, _vector4.z, null);
                    }
                }
            }
            var children = object.children;
            for(var i1 = 0, l1 = children.length; i1 < l1; i1++)projectObject(children[i1], camera, groupOrder, sortObjects);
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            var renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            var renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        var _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget) {
            var activeCubeFace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, activeMipmapLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            var useDefaultFramebuffer = true;
            var framebuffer = null;
            var isCube = false;
            var isRenderTarget3D = false;
            if (renderTarget) {
                var renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    var depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                var texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            var framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                var textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                var textureProperties1 = properties.get(renderTarget.texture);
                var layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties1.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                var textureProperties2 = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties2.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            var textureIndex = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            var framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    var texture = renderTarget.textures[textureIndex];
                    var textureFormat = texture.format;
                    var textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        // when using MRT, select the correct color buffer for the subsequent read command
                        if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    var framebuffer1 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer1);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            var textureIndex = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var framebuffer, texture, textureFormat, textureType, glBuffer, currFramebuffer, sync;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                            framebuffer = properties.get(renderTarget).__webglFramebuffer;
                            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
                            if (!framebuffer) return [
                                3,
                                3
                            ];
                            if (!(x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height)) return [
                                3,
                                2
                            ];
                            // set the active frame buffer to the one we want to read
                            state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                            texture = renderTarget.textures[textureIndex];
                            textureFormat = texture.format;
                            textureType = texture.type;
                            if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                            if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                            glBuffer = _gl.createBuffer();
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                            // when using MRT, select the corect color buffer for the subsequent read command
                            if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                            _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                            // reset the frame buffer to the currently set buffer before waiting
                            currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                            state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                            // check if the commands have finished every 8 ms
                            sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                            _gl.flush();
                            return [
                                4,
                                (0, $dRnj4.probeAsync)(_gl, sync, 4)
                            ];
                        case 1:
                            _state.sent();
                            // read the data and delete the buffer
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                            _gl.deleteBuffer(glBuffer);
                            _gl.deleteSync(sync);
                            return [
                                2,
                                buffer
                            ];
                        case 2:
                            throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture) {
            var position = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            var levelScale = Math.pow(2, -level);
            var width = Math.floor(texture.image.width * levelScale);
            var height = Math.floor(texture.image.height * levelScale);
            var x = position !== null ? position.x : 0;
            var y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        var _srcFramebuffer = _gl.createFramebuffer();
        var _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=null] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture) {
            var srcRegion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, dstPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, srcLevel = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, dstLevel = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $dRnj4.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            var width, height, depth, minX, minY, minZ;
            var dstX, dstY, dstZ;
            var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                var levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            var glFormat = utils.convert(dstTexture.format);
            var glType = utils.convert(dstTexture.type);
            var glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            var currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            var currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            var currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            var currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            var currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            var isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            var isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                var srcTextureProperties = properties.get(srcTexture);
                var dstTextureProperties = properties.get(dstTexture);
                var srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                var dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(var i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                var srcTextureProperties1 = properties.get(srcTexture);
                var dstTextureProperties1 = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(var i1 = 0; i1 < depth; i1++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties1.__webglTexture, srcLevel, minZ + i1);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties1.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties1.__webglTexture, dstLevel, dstZ + i1);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties1.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i1, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture) {
            var srcRegion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, dstPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, level = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
            // @deprecated, r170
            (0, $dRnj4.warnOnce)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    (0, $byiyg._)(WebGLRenderer, [
        {
            key: "coordinateSystem",
            get: /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ function get() {
                return 0, $dRnj4.WebGLCoordinateSystem;
            }
        },
        {
            key: "outputColorSpace",
            get: /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ function get() {
                return this._outputColorSpace;
            },
            set: function set(colorSpace) {
                this._outputColorSpace = colorSpace;
                var gl = this.getContext();
                gl.drawingBufferColorSpace = (0, $dRnj4.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
                gl.unpackColorSpace = (0, $dRnj4.ColorManagement)._getUnpackColorSpace();
            }
        }
    ]);
    return WebGLRenderer;
}();

});
parcelRegister("dRnj4", function(module, exports) {

$parcel$export(module.exports, "REVISION", function () { return $a1724dcfba0d6d9a$export$3545e07a80636437; });
$parcel$export(module.exports, "CullFaceNone", function () { return $a1724dcfba0d6d9a$export$3237e1f2c1ea1f44; });
$parcel$export(module.exports, "CullFaceBack", function () { return $a1724dcfba0d6d9a$export$b9a7b4fc5cb15f9b; });
$parcel$export(module.exports, "CullFaceFront", function () { return $a1724dcfba0d6d9a$export$b8058bcc7037d3f3; });
$parcel$export(module.exports, "PCFShadowMap", function () { return $a1724dcfba0d6d9a$export$5813f879eee7cd88; });
$parcel$export(module.exports, "PCFSoftShadowMap", function () { return $a1724dcfba0d6d9a$export$a47c4b43a1be34f0; });
$parcel$export(module.exports, "VSMShadowMap", function () { return $a1724dcfba0d6d9a$export$896ae1ade6c829c4; });
$parcel$export(module.exports, "FrontSide", function () { return $a1724dcfba0d6d9a$export$2ede184fc2998901; });
$parcel$export(module.exports, "BackSide", function () { return $a1724dcfba0d6d9a$export$d9f0486e75b5ace; });
$parcel$export(module.exports, "DoubleSide", function () { return $a1724dcfba0d6d9a$export$3b296b6f144d5b03; });
$parcel$export(module.exports, "NoBlending", function () { return $a1724dcfba0d6d9a$export$63b8d6b580fc65ba; });
$parcel$export(module.exports, "NormalBlending", function () { return $a1724dcfba0d6d9a$export$5b29a26d96ee6af0; });
$parcel$export(module.exports, "AdditiveBlending", function () { return $a1724dcfba0d6d9a$export$777d8f9551c2216b; });
$parcel$export(module.exports, "SubtractiveBlending", function () { return $a1724dcfba0d6d9a$export$cdfa06f868e2e467; });
$parcel$export(module.exports, "MultiplyBlending", function () { return $a1724dcfba0d6d9a$export$4138e1c684b46a20; });
$parcel$export(module.exports, "CustomBlending", function () { return $a1724dcfba0d6d9a$export$eda4864c68df1fa2; });
$parcel$export(module.exports, "AddEquation", function () { return $a1724dcfba0d6d9a$export$20183a0484ce21a0; });
$parcel$export(module.exports, "SubtractEquation", function () { return $a1724dcfba0d6d9a$export$73e0df5177988548; });
$parcel$export(module.exports, "ReverseSubtractEquation", function () { return $a1724dcfba0d6d9a$export$28e582859cbec660; });
$parcel$export(module.exports, "MinEquation", function () { return $a1724dcfba0d6d9a$export$c8c1508da8d0600c; });
$parcel$export(module.exports, "MaxEquation", function () { return $a1724dcfba0d6d9a$export$99948c02fb51055f; });
$parcel$export(module.exports, "ZeroFactor", function () { return $a1724dcfba0d6d9a$export$2110f05edf778d3d; });
$parcel$export(module.exports, "OneFactor", function () { return $a1724dcfba0d6d9a$export$8805bad65e24940e; });
$parcel$export(module.exports, "SrcColorFactor", function () { return $a1724dcfba0d6d9a$export$7fbe15b28d28cf52; });
$parcel$export(module.exports, "OneMinusSrcColorFactor", function () { return $a1724dcfba0d6d9a$export$947829af9f2c17f6; });
$parcel$export(module.exports, "SrcAlphaFactor", function () { return $a1724dcfba0d6d9a$export$d5773124e86cf28c; });
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", function () { return $a1724dcfba0d6d9a$export$11d468cc7f19e971; });
$parcel$export(module.exports, "DstAlphaFactor", function () { return $a1724dcfba0d6d9a$export$a78aed1ca2a87192; });
$parcel$export(module.exports, "OneMinusDstAlphaFactor", function () { return $a1724dcfba0d6d9a$export$5d0fe17fd8773bac; });
$parcel$export(module.exports, "DstColorFactor", function () { return $a1724dcfba0d6d9a$export$ef5f2dd8ffac5574; });
$parcel$export(module.exports, "OneMinusDstColorFactor", function () { return $a1724dcfba0d6d9a$export$56b85b2686ab16; });
$parcel$export(module.exports, "SrcAlphaSaturateFactor", function () { return $a1724dcfba0d6d9a$export$c05e2a1fc8609506; });
$parcel$export(module.exports, "ConstantColorFactor", function () { return $a1724dcfba0d6d9a$export$7dd8f434fd59075; });
$parcel$export(module.exports, "OneMinusConstantColorFactor", function () { return $a1724dcfba0d6d9a$export$99c8d898a9afbcee; });
$parcel$export(module.exports, "ConstantAlphaFactor", function () { return $a1724dcfba0d6d9a$export$310cd2be38d13b56; });
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", function () { return $a1724dcfba0d6d9a$export$db77b8fbcf45dbf4; });
$parcel$export(module.exports, "NeverDepth", function () { return $a1724dcfba0d6d9a$export$69025ce147cee220; });
$parcel$export(module.exports, "AlwaysDepth", function () { return $a1724dcfba0d6d9a$export$7182eb52ea3b3f04; });
$parcel$export(module.exports, "LessDepth", function () { return $a1724dcfba0d6d9a$export$eedccec66ab7ebe; });
$parcel$export(module.exports, "LessEqualDepth", function () { return $a1724dcfba0d6d9a$export$296f78a0b892f81a; });
$parcel$export(module.exports, "EqualDepth", function () { return $a1724dcfba0d6d9a$export$a60d398fc7b7590e; });
$parcel$export(module.exports, "GreaterEqualDepth", function () { return $a1724dcfba0d6d9a$export$7d7234c1240a1fc4; });
$parcel$export(module.exports, "GreaterDepth", function () { return $a1724dcfba0d6d9a$export$c5e2c52991f30937; });
$parcel$export(module.exports, "NotEqualDepth", function () { return $a1724dcfba0d6d9a$export$2f843afa843d8916; });
$parcel$export(module.exports, "MultiplyOperation", function () { return $a1724dcfba0d6d9a$export$e50ac29801f1774d; });
$parcel$export(module.exports, "MixOperation", function () { return $a1724dcfba0d6d9a$export$9f9d94f963c85479; });
$parcel$export(module.exports, "AddOperation", function () { return $a1724dcfba0d6d9a$export$e641dc52bc3494aa; });
$parcel$export(module.exports, "NoToneMapping", function () { return $a1724dcfba0d6d9a$export$9fcb6b4294603b2; });
$parcel$export(module.exports, "LinearToneMapping", function () { return $a1724dcfba0d6d9a$export$98f52c2a46c598ca; });
$parcel$export(module.exports, "ReinhardToneMapping", function () { return $a1724dcfba0d6d9a$export$74b25e54b3bcd548; });
$parcel$export(module.exports, "CineonToneMapping", function () { return $a1724dcfba0d6d9a$export$932b3dd283d4a366; });
$parcel$export(module.exports, "ACESFilmicToneMapping", function () { return $a1724dcfba0d6d9a$export$a0d98fe6d7e4af64; });
$parcel$export(module.exports, "CustomToneMapping", function () { return $a1724dcfba0d6d9a$export$2c7b09c1e9abfb5e; });
$parcel$export(module.exports, "AgXToneMapping", function () { return $a1724dcfba0d6d9a$export$212d53a513a325b2; });
$parcel$export(module.exports, "NeutralToneMapping", function () { return $a1724dcfba0d6d9a$export$f2863e1668a8e317; });
$parcel$export(module.exports, "CubeReflectionMapping", function () { return $a1724dcfba0d6d9a$export$8759762a6477f2c4; });
$parcel$export(module.exports, "CubeRefractionMapping", function () { return $a1724dcfba0d6d9a$export$dc59f8aed047f61d; });
$parcel$export(module.exports, "EquirectangularReflectionMapping", function () { return $a1724dcfba0d6d9a$export$d64030b316d3b087; });
$parcel$export(module.exports, "EquirectangularRefractionMapping", function () { return $a1724dcfba0d6d9a$export$ee99d97d46898098; });
$parcel$export(module.exports, "CubeUVReflectionMapping", function () { return $a1724dcfba0d6d9a$export$dbf3e70ff37af79; });
$parcel$export(module.exports, "RepeatWrapping", function () { return $a1724dcfba0d6d9a$export$533346c8e8dac0f5; });
$parcel$export(module.exports, "ClampToEdgeWrapping", function () { return $a1724dcfba0d6d9a$export$9d9334239a5a5e06; });
$parcel$export(module.exports, "MirroredRepeatWrapping", function () { return $a1724dcfba0d6d9a$export$c7e7c00b14f51a4f; });
$parcel$export(module.exports, "NearestFilter", function () { return $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0; });
$parcel$export(module.exports, "NearestMipmapNearestFilter", function () { return $a1724dcfba0d6d9a$export$d129e38cf6feaa8c; });
$parcel$export(module.exports, "NearestMipmapLinearFilter", function () { return $a1724dcfba0d6d9a$export$d2327c1afe5bfdf2; });
$parcel$export(module.exports, "LinearFilter", function () { return $a1724dcfba0d6d9a$export$8a72f490b25c56c8; });
$parcel$export(module.exports, "LinearMipmapNearestFilter", function () { return $a1724dcfba0d6d9a$export$19a719f377145a13; });
$parcel$export(module.exports, "LinearMipmapLinearFilter", function () { return $a1724dcfba0d6d9a$export$5d8599b6a933fb1b; });
$parcel$export(module.exports, "UnsignedByteType", function () { return $a1724dcfba0d6d9a$export$2e8ce08d3f6f5e10; });
$parcel$export(module.exports, "ByteType", function () { return $a1724dcfba0d6d9a$export$545fce0311a9796a; });
$parcel$export(module.exports, "ShortType", function () { return $a1724dcfba0d6d9a$export$88572337f312435f; });
$parcel$export(module.exports, "UnsignedShortType", function () { return $a1724dcfba0d6d9a$export$c63dc51868b06a9d; });
$parcel$export(module.exports, "IntType", function () { return $a1724dcfba0d6d9a$export$5c612977753abe2; });
$parcel$export(module.exports, "UnsignedIntType", function () { return $a1724dcfba0d6d9a$export$c3c7fc4518ebba96; });
$parcel$export(module.exports, "FloatType", function () { return $a1724dcfba0d6d9a$export$f6d331659b644596; });
$parcel$export(module.exports, "HalfFloatType", function () { return $a1724dcfba0d6d9a$export$2697304443f382bc; });
$parcel$export(module.exports, "UnsignedShort4444Type", function () { return $a1724dcfba0d6d9a$export$b3969b01faf587f2; });
$parcel$export(module.exports, "UnsignedShort5551Type", function () { return $a1724dcfba0d6d9a$export$18886f8ae33e90de; });
$parcel$export(module.exports, "UnsignedInt248Type", function () { return $a1724dcfba0d6d9a$export$6c8ea339bfab1301; });
$parcel$export(module.exports, "UnsignedInt5999Type", function () { return $a1724dcfba0d6d9a$export$5a4c329b7e2092d3; });
$parcel$export(module.exports, "AlphaFormat", function () { return $a1724dcfba0d6d9a$export$988473390501ed4b; });
$parcel$export(module.exports, "RGBFormat", function () { return $a1724dcfba0d6d9a$export$7c67423a5ee6f5eb; });
$parcel$export(module.exports, "RGBAFormat", function () { return $a1724dcfba0d6d9a$export$3f8bb04b555a363c; });
$parcel$export(module.exports, "DepthFormat", function () { return $a1724dcfba0d6d9a$export$c1b6b5136be58045; });
$parcel$export(module.exports, "DepthStencilFormat", function () { return $a1724dcfba0d6d9a$export$1e113ac2d0905829; });
$parcel$export(module.exports, "RedFormat", function () { return $a1724dcfba0d6d9a$export$4e041a7967d15c4b; });
$parcel$export(module.exports, "RedIntegerFormat", function () { return $a1724dcfba0d6d9a$export$aa92e870a709d190; });
$parcel$export(module.exports, "RGFormat", function () { return $a1724dcfba0d6d9a$export$6cdf0b461c7ce8a0; });
$parcel$export(module.exports, "RGIntegerFormat", function () { return $a1724dcfba0d6d9a$export$1ba1c45f9f77d4d7; });
$parcel$export(module.exports, "RGBAIntegerFormat", function () { return $a1724dcfba0d6d9a$export$c200e7d26f592f21; });
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", function () { return $a1724dcfba0d6d9a$export$21d1799c6d552fc0; });
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", function () { return $a1724dcfba0d6d9a$export$afa304c3e981b668; });
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", function () { return $a1724dcfba0d6d9a$export$d2a1a68024a3e56c; });
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", function () { return $a1724dcfba0d6d9a$export$9a79c424327dacf9; });
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", function () { return $a1724dcfba0d6d9a$export$19ada9bbb1af3573; });
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", function () { return $a1724dcfba0d6d9a$export$d0f0355bb3d948e4; });
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", function () { return $a1724dcfba0d6d9a$export$b82296714358084c; });
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", function () { return $a1724dcfba0d6d9a$export$b71692456c47b6c3; });
$parcel$export(module.exports, "RGB_ETC1_Format", function () { return $a1724dcfba0d6d9a$export$6ab91af2d757aee7; });
$parcel$export(module.exports, "RGB_ETC2_Format", function () { return $a1724dcfba0d6d9a$export$7800993ef8106a6a; });
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", function () { return $a1724dcfba0d6d9a$export$23ed8300a860e7d8; });
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", function () { return $a1724dcfba0d6d9a$export$dc5570b4a2b92d48; });
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", function () { return $a1724dcfba0d6d9a$export$68880cd325f8b2fb; });
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", function () { return $a1724dcfba0d6d9a$export$7d2c0be323373d95; });
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", function () { return $a1724dcfba0d6d9a$export$22b52da301fc3a3e; });
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", function () { return $a1724dcfba0d6d9a$export$c009e2cb4a66485e; });
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", function () { return $a1724dcfba0d6d9a$export$118fff5afa255b63; });
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", function () { return $a1724dcfba0d6d9a$export$120713c829ae0667; });
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", function () { return $a1724dcfba0d6d9a$export$c79eeabbf53313e9; });
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", function () { return $a1724dcfba0d6d9a$export$443cf6567cdd6424; });
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", function () { return $a1724dcfba0d6d9a$export$6573984fc9840780; });
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", function () { return $a1724dcfba0d6d9a$export$e7aee563f30091de; });
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", function () { return $a1724dcfba0d6d9a$export$2eb8634622ddeab7; });
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", function () { return $a1724dcfba0d6d9a$export$202b1ce7b5d25742; });
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", function () { return $a1724dcfba0d6d9a$export$18ab77abd087e467; });
$parcel$export(module.exports, "RGBA_BPTC_Format", function () { return $a1724dcfba0d6d9a$export$ce40b115e188bc81; });
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", function () { return $a1724dcfba0d6d9a$export$d279c5c4bac5121e; });
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", function () { return $a1724dcfba0d6d9a$export$cde52d17225fdbd3; });
$parcel$export(module.exports, "RED_RGTC1_Format", function () { return $a1724dcfba0d6d9a$export$b1688df4c4c21670; });
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", function () { return $a1724dcfba0d6d9a$export$fc15e5d8261eed58; });
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", function () { return $a1724dcfba0d6d9a$export$d220f6ade8463a0f; });
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", function () { return $a1724dcfba0d6d9a$export$768646d09dc1b6ef; });
$parcel$export(module.exports, "RGBADepthPacking", function () { return $a1724dcfba0d6d9a$export$8f910f4c4f73df11; });
$parcel$export(module.exports, "TangentSpaceNormalMap", function () { return $a1724dcfba0d6d9a$export$2852a58ebdac27b8; });
$parcel$export(module.exports, "ObjectSpaceNormalMap", function () { return $a1724dcfba0d6d9a$export$9990ad26f9db5b2c; });
$parcel$export(module.exports, "NoColorSpace", function () { return $a1724dcfba0d6d9a$export$bfcb490c2dd3db51; });
$parcel$export(module.exports, "SRGBColorSpace", function () { return $a1724dcfba0d6d9a$export$561f394b24edfcaa; });
$parcel$export(module.exports, "LinearSRGBColorSpace", function () { return $a1724dcfba0d6d9a$export$42429b3acfb233a4; });
$parcel$export(module.exports, "LinearTransfer", function () { return $a1724dcfba0d6d9a$export$f197347d588c1b4a; });
$parcel$export(module.exports, "SRGBTransfer", function () { return $a1724dcfba0d6d9a$export$8d0a61916cc26abb; });
$parcel$export(module.exports, "NeverCompare", function () { return $a1724dcfba0d6d9a$export$d9e2d19a747baaab; });
$parcel$export(module.exports, "LessCompare", function () { return $a1724dcfba0d6d9a$export$36bcf49c713b3eb7; });
$parcel$export(module.exports, "EqualCompare", function () { return $a1724dcfba0d6d9a$export$66f28d946fc6a0d5; });
$parcel$export(module.exports, "LessEqualCompare", function () { return $a1724dcfba0d6d9a$export$64eea11eb407ddf1; });
$parcel$export(module.exports, "GreaterCompare", function () { return $a1724dcfba0d6d9a$export$155af022118f3a38; });
$parcel$export(module.exports, "NotEqualCompare", function () { return $a1724dcfba0d6d9a$export$67ab95dde6bed156; });
$parcel$export(module.exports, "GreaterEqualCompare", function () { return $a1724dcfba0d6d9a$export$1cdcb70d53d65f61; });
$parcel$export(module.exports, "AlwaysCompare", function () { return $a1724dcfba0d6d9a$export$187b73a3e352c145; });
$parcel$export(module.exports, "GLSL3", function () { return $a1724dcfba0d6d9a$export$f63012db5506e7dd; });
$parcel$export(module.exports, "WebGLCoordinateSystem", function () { return $a1724dcfba0d6d9a$export$5a0e9190d10875d3; });
$parcel$export(module.exports, "EventDispatcher", function () { return $a1724dcfba0d6d9a$export$ec8b666c5fe2c75a; });
$parcel$export(module.exports, "RAD2DEG", function () { return $a1724dcfba0d6d9a$export$914076c8150813e5; });
$parcel$export(module.exports, "Vector2", function () { return $a1724dcfba0d6d9a$export$c977b3e384af9ae1; });
$parcel$export(module.exports, "Vector3", function () { return $a1724dcfba0d6d9a$export$64b5c384219d3699; });
$parcel$export(module.exports, "Matrix3", function () { return $a1724dcfba0d6d9a$export$8ff26dafa08918; });
$parcel$export(module.exports, "arrayNeedsUint32", function () { return $a1724dcfba0d6d9a$export$bc6f937da07eae17; });
$parcel$export(module.exports, "createElementNS", function () { return $a1724dcfba0d6d9a$export$7094a064528c7fee; });
$parcel$export(module.exports, "createCanvasElement", function () { return $a1724dcfba0d6d9a$export$1033a2df66368859; });
$parcel$export(module.exports, "warnOnce", function () { return $a1724dcfba0d6d9a$export$5b28268982f175ba; });
$parcel$export(module.exports, "probeAsync", function () { return $a1724dcfba0d6d9a$export$d43f91ebeafb2c7; });
$parcel$export(module.exports, "toNormalizedProjectionMatrix", function () { return $a1724dcfba0d6d9a$export$5238391f68c729b; });
$parcel$export(module.exports, "toReversedProjectionMatrix", function () { return $a1724dcfba0d6d9a$export$f8cf97d08da9bc86; });
$parcel$export(module.exports, "ColorManagement", function () { return $a1724dcfba0d6d9a$export$5e6fd513f44698c; });
$parcel$export(module.exports, "Texture", function () { return $a1724dcfba0d6d9a$export$5431306cf43de24a; });
$parcel$export(module.exports, "Vector4", function () { return $a1724dcfba0d6d9a$export$fa7daccca11cdbe3; });
$parcel$export(module.exports, "WebGLRenderTarget", function () { return $a1724dcfba0d6d9a$export$3c052beb2e51e23f; });
$parcel$export(module.exports, "DataArrayTexture", function () { return $a1724dcfba0d6d9a$export$dfac6c8e811406a3; });
$parcel$export(module.exports, "Data3DTexture", function () { return $a1724dcfba0d6d9a$export$d7a3086320f856db; });
$parcel$export(module.exports, "Matrix4", function () { return $a1724dcfba0d6d9a$export$2ae72fc923e5eb5; });
$parcel$export(module.exports, "Euler", function () { return $a1724dcfba0d6d9a$export$d93cc409a0768c5f; });
$parcel$export(module.exports, "Layers", function () { return $a1724dcfba0d6d9a$export$89312ce47c0ca777; });
$parcel$export(module.exports, "Object3D", function () { return $a1724dcfba0d6d9a$export$e4dd07dff30cc924; });
$parcel$export(module.exports, "Color", function () { return $a1724dcfba0d6d9a$export$892596cec99bc70e; });
$parcel$export(module.exports, "MeshBasicMaterial", function () { return $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5; });
$parcel$export(module.exports, "BufferAttribute", function () { return $a1724dcfba0d6d9a$export$8dea267bd6bde117; });
$parcel$export(module.exports, "Uint16BufferAttribute", function () { return $a1724dcfba0d6d9a$export$640a853f68025f2e; });
$parcel$export(module.exports, "Uint32BufferAttribute", function () { return $a1724dcfba0d6d9a$export$7eb8c9fa25cd5bd6; });
$parcel$export(module.exports, "BufferGeometry", function () { return $a1724dcfba0d6d9a$export$b7be63a67df8959; });
$parcel$export(module.exports, "Mesh", function () { return $a1724dcfba0d6d9a$export$e176487c05830cc5; });
$parcel$export(module.exports, "BoxGeometry", function () { return $a1724dcfba0d6d9a$export$33e43285f7406bd5; });
$parcel$export(module.exports, "cloneUniforms", function () { return $a1724dcfba0d6d9a$export$acda854380553452; });
$parcel$export(module.exports, "mergeUniforms", function () { return $a1724dcfba0d6d9a$export$8916ce6879271f43; });
$parcel$export(module.exports, "getUnlitUniformColorSpace", function () { return $a1724dcfba0d6d9a$export$a630742c640528c1; });
$parcel$export(module.exports, "UniformsUtils", function () { return $a1724dcfba0d6d9a$export$d8ecdf8615bfea69; });
$parcel$export(module.exports, "ShaderMaterial", function () { return $a1724dcfba0d6d9a$export$83c7d75d550a8b0d; });
$parcel$export(module.exports, "PerspectiveCamera", function () { return $a1724dcfba0d6d9a$export$74e4ae24825f68d7; });
$parcel$export(module.exports, "CubeTexture", function () { return $a1724dcfba0d6d9a$export$ee2e5a18258a4049; });
$parcel$export(module.exports, "WebGLCubeRenderTarget", function () { return $a1724dcfba0d6d9a$export$ac386671d651941e; });
$parcel$export(module.exports, "Group", function () { return $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "WebXRController", function () { return $a1724dcfba0d6d9a$export$cb626c57dcc48b9f; });
$parcel$export(module.exports, "Plane", function () { return $a1724dcfba0d6d9a$export$7ff5ac152ef991b0; });
$parcel$export(module.exports, "Frustum", function () { return $a1724dcfba0d6d9a$export$35efe6f4c85463d2; });
$parcel$export(module.exports, "DepthTexture", function () { return $a1724dcfba0d6d9a$export$fc830aa069cc8c2f; });
$parcel$export(module.exports, "PlaneGeometry", function () { return $a1724dcfba0d6d9a$export$967d831af31f69ce; });
$parcel$export(module.exports, "SphereGeometry", function () { return $a1724dcfba0d6d9a$export$1b417fc3b307a251; });
$parcel$export(module.exports, "MeshDepthMaterial", function () { return $a1724dcfba0d6d9a$export$2698c22ec13825db; });
$parcel$export(module.exports, "MeshDistanceMaterial", function () { return $a1724dcfba0d6d9a$export$33e187ed002f2a19; });
$parcel$export(module.exports, "OrthographicCamera", function () { return $a1724dcfba0d6d9a$export$9ebf355ee4ed261b; });
$parcel$export(module.exports, "ArrayCamera", function () { return $a1724dcfba0d6d9a$export$56b937d9e5581166; });
$parcel$export(module.exports, "getByteLength", function () { return $a1724dcfba0d6d9a$export$cc8c3b705bb8e6e2; });
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $a1724dcfba0d6d9a$export$3545e07a80636437 = '178';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$eda4864c68df1fa2 = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d129e38cf6feaa8c = 1004;
var $a1724dcfba0d6d9a$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d2327c1afe5bfdf2 = 1005;
var $a1724dcfba0d6d9a$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$19a719f377145a13 = 1007;
var $a1724dcfba0d6d9a$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5d8599b6a933fb1b = 1008;
var $a1724dcfba0d6d9a$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5a4c329b7e2092d3 = 35902;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$23ed8300a860e7d8 = 37496;
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$198b11ff4c72bb30 = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f0d8293634f88842 = 2;
/**
 * Basic depth packing.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$deeb383078690b50 = 3200;
/**
 * A depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8f910f4c4f73df11 = 3201;
/**
 * A depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$be2e2ddbc3983173 = 3202;
/**
 * A depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8d0a61916cc26abb = 'srgb';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ var $a1724dcfba0d6d9a$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ var $a1724dcfba0d6d9a$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ var $a1724dcfba0d6d9a$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ var $a1724dcfba0d6d9a$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FLAT_FIRST - Flat interpolation using the first vertex.
 * @property {string} FLAT_EITHER - Flat interpolation using either vertex.
 */ /**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js]{@link https://github.com/mrdoob/eventdispatcher.js/}
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ var $a1724dcfba0d6d9a$export$ec8b666c5fe2c75a = /*#__PURE__*/ function() {
    "use strict";
    function EventDispatcher() {
        (0, $jGAMp._)(this, EventDispatcher);
    }
    (0, $byiyg._)(EventDispatcher, [
        {
            /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ key: "addEventListener",
            value: function addEventListener(type, listener) {
                if (this._listeners === undefined) this._listeners = {};
                var listeners = this._listeners;
                if (listeners[type] === undefined) listeners[type] = [];
                if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
            }
        },
        {
            /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ key: "hasEventListener",
            value: function hasEventListener(type, listener) {
                var listeners = this._listeners;
                if (listeners === undefined) return false;
                return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
            }
        },
        {
            /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ key: "removeEventListener",
            value: function removeEventListener(type, listener) {
                var listeners = this._listeners;
                if (listeners === undefined) return;
                var listenerArray = listeners[type];
                if (listenerArray !== undefined) {
                    var index = listenerArray.indexOf(listener);
                    if (index !== -1) listenerArray.splice(index, 1);
                }
            }
        },
        {
            /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ key: "dispatchEvent",
            value: function dispatchEvent(event) {
                var listeners = this._listeners;
                if (listeners === undefined) return;
                var listenerArray = listeners[event.type];
                if (listenerArray !== undefined) {
                    event.target = this;
                    // Make a copy, in case listeners are removed while iterating.
                    var array = listenerArray.slice(0);
                    for(var i = 0, l = array.length; i < l; i++)array[i].call(this, event);
                    event.target = null;
                }
            }
        }
    ]);
    return EventDispatcher;
}();
var $a1724dcfba0d6d9a$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
var $a1724dcfba0d6d9a$var$_seed = 1234567;
var $a1724dcfba0d6d9a$var$DEG2RAD = Math.PI / 180;
var $a1724dcfba0d6d9a$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $a1724dcfba0d6d9a$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    var uuid = $a1724dcfba0d6d9a$var$_lut[d0 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d0 >> 8 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d0 >> 16 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d0 >> 24 & 0xff] + '-' + $a1724dcfba0d6d9a$var$_lut[d1 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d1 >> 8 & 0xff] + '-' + $a1724dcfba0d6d9a$var$_lut[d1 >> 16 & 0x0f | 0x40] + $a1724dcfba0d6d9a$var$_lut[d1 >> 24 & 0xff] + '-' + $a1724dcfba0d6d9a$var$_lut[d2 & 0x3f | 0x80] + $a1724dcfba0d6d9a$var$_lut[d2 >> 8 & 0xff] + '-' + $a1724dcfba0d6d9a$var$_lut[d2 >> 16 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d2 >> 24 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d3 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d3 >> 8 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d3 >> 16 & 0xff] + $a1724dcfba0d6d9a$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $a1724dcfba0d6d9a$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $a1724dcfba0d6d9a$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $a1724dcfba0d6d9a$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $a1724dcfba0d6d9a$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $a1724dcfba0d6d9a$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $a1724dcfba0d6d9a$var$damp(x, y, lambda, dt) {
    return $a1724dcfba0d6d9a$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $a1724dcfba0d6d9a$var$pingpong(x) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($a1724dcfba0d6d9a$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $a1724dcfba0d6d9a$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $a1724dcfba0d6d9a$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $a1724dcfba0d6d9a$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $a1724dcfba0d6d9a$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $a1724dcfba0d6d9a$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $a1724dcfba0d6d9a$var$seededRandom(s) {
    if (s !== undefined) $a1724dcfba0d6d9a$var$_seed = s;
    // Mulberry32 generator
    var t = $a1724dcfba0d6d9a$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $a1724dcfba0d6d9a$var$degToRad(degrees) {
    return degrees * $a1724dcfba0d6d9a$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $a1724dcfba0d6d9a$var$radToDeg(radians) {
    return radians * $a1724dcfba0d6d9a$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $a1724dcfba0d6d9a$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $a1724dcfba0d6d9a$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $a1724dcfba0d6d9a$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $a1724dcfba0d6d9a$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    var cos = Math.cos;
    var sin = Math.sin;
    var c2 = cos(b / 2);
    var s2 = sin(b / 2);
    var c13 = cos((a + c) / 2);
    var s13 = sin((a + c) / 2);
    var c1_3 = cos((a - c) / 2);
    var s1_3 = sin((a - c) / 2);
    var c3_1 = cos((c - a) / 2);
    var s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $a1724dcfba0d6d9a$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $a1724dcfba0d6d9a$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $a1724dcfba0d6d9a$var$DEG2RAD,
    RAD2DEG: $a1724dcfba0d6d9a$export$914076c8150813e5,
    /**
	 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $a1724dcfba0d6d9a$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $a1724dcfba0d6d9a$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $a1724dcfba0d6d9a$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $a1724dcfba0d6d9a$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $a1724dcfba0d6d9a$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $a1724dcfba0d6d9a$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $a1724dcfba0d6d9a$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $a1724dcfba0d6d9a$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $a1724dcfba0d6d9a$var$smoothstep,
    /**
	 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $a1724dcfba0d6d9a$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $a1724dcfba0d6d9a$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $a1724dcfba0d6d9a$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $a1724dcfba0d6d9a$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $a1724dcfba0d6d9a$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $a1724dcfba0d6d9a$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $a1724dcfba0d6d9a$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $a1724dcfba0d6d9a$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $a1724dcfba0d6d9a$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $a1724dcfba0d6d9a$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $a1724dcfba0d6d9a$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $a1724dcfba0d6d9a$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $a1724dcfba0d6d9a$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ var $a1724dcfba0d6d9a$export$c977b3e384af9ae1 = /*#__PURE__*/ function() {
    "use strict";
    function Vector2() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, Vector2);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector2.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    (0, $byiyg._)(Vector2, [
        {
            key: "width",
            get: /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ function get() {
                return this.x;
            },
            set: function set(value) {
                this.x = value;
            }
        },
        {
            key: "height",
            get: /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ function get() {
                return this.y;
            },
            set: function set(value) {
                this.y = value;
            }
        },
        {
            /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ key: "set",
            value: function set(x, y) {
                this.x = x;
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y);
            }
        },
        {
            /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                return this;
            }
        },
        {
            /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                return this;
            }
        },
        {
            /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                return this;
            }
        },
        {
            /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                return this;
            }
        },
        {
            /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6];
                this.y = e[1] * x + e[4] * y + e[7];
                return this;
            }
        },
        {
            /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                return this;
            }
        },
        {
            /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                return this;
            }
        },
        {
            /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, min.x, max.x);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, min.y, max.y);
                return this;
            }
        },
        {
            /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, minVal, maxVal);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, minVal, maxVal);
                return this;
            }
        },
        {
            /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($a1724dcfba0d6d9a$var$clamp(length, min, max));
            }
        },
        {
            /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                return this;
            }
        },
        {
            /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                return this;
            }
        },
        {
            /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y;
            }
        },
        {
            /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ key: "cross",
            value: function cross(v) {
                return this.x * v.y - this.y * v.x;
            }
        },
        {
            /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
        },
        {
            /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
        },
        {
            /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
        },
        {
            /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ key: "angle",
            value: function angle() {
                var angle = Math.atan2(-this.y, -this.x) + Math.PI;
                return angle;
            }
        },
        {
            /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ key: "angleTo",
            value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator;
                // clamp, to handle numerical problems
                return Math.acos($a1724dcfba0d6d9a$var$clamp(theta, -1, 1));
            }
        },
        {
            /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y;
                return dx * dx + dy * dy;
            }
        },
        {
            /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
            }
        },
        {
            /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y;
            }
        },
        {
            /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                return this;
            }
        },
        {
            /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                return array;
            }
        },
        {
            /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                return this;
            }
        },
        {
            /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ key: "rotateAround",
            value: function rotateAround(center, angle) {
                var c = Math.cos(angle), s = Math.sin(angle);
                var x = this.x - center.x;
                var y = this.y - center.y;
                this.x = x * c - y * s + center.x;
                this.y = x * s + y * c + center.y;
                return this;
            }
        },
        {
            /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector2;
}();
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ var $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3 = /*#__PURE__*/ function() {
    "use strict";
    function Quaternion() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, Quaternion);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    (0, $byiyg._)(Quaternion, [
        {
            key: "x",
            get: /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "w",
            get: /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ function get() {
                return this._w;
            },
            set: function set(value) {
                this._w = value;
                this._onChangeCallback();
            }
        },
        {
            /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "set",
            value: function set(x, y, z, w) {
                this._x = x;
                this._y = y;
                this._z = z;
                this._w = w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
        },
        {
            /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "copy",
            value: function copy(quaternion) {
                this._x = quaternion.x;
                this._y = quaternion.y;
                this._z = quaternion.z;
                this._w = quaternion.w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "setFromEuler",
            value: function setFromEuler(euler) {
                var update = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var x = euler._x, y = euler._y, z = euler._z, order = euler._order;
                // http://www.mathworks.com/matlabcentral/fileexchange/
                // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
                //	content/SpinCalc.m
                var cos = Math.cos;
                var sin = Math.sin;
                var c1 = cos(x / 2);
                var c2 = cos(y / 2);
                var c3 = cos(z / 2);
                var s1 = sin(x / 2);
                var s2 = sin(y / 2);
                var s3 = sin(z / 2);
                switch(order){
                    case 'XYZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'YXZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'ZXY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'ZYX':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'YZX':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'XZY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    default:
                        console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
                }
                if (update === true) this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "setFromAxisAngle",
            value: function setFromAxisAngle(axis, angle) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
                var halfAngle = angle / 2, s = Math.sin(halfAngle);
                this._x = axis.x * s;
                this._y = axis.y * s;
                this._z = axis.z * s;
                this._w = Math.cos(halfAngle);
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
                if (trace > 0) {
                    var s = 0.5 / Math.sqrt(trace + 1.0);
                    this._w = 0.25 / s;
                    this._x = (m32 - m23) * s;
                    this._y = (m13 - m31) * s;
                    this._z = (m21 - m12) * s;
                } else if (m11 > m22 && m11 > m33) {
                    var s1 = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                    this._w = (m32 - m23) / s1;
                    this._x = 0.25 * s1;
                    this._y = (m12 + m21) / s1;
                    this._z = (m13 + m31) / s1;
                } else if (m22 > m33) {
                    var s2 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                    this._w = (m13 - m31) / s2;
                    this._x = (m12 + m21) / s2;
                    this._y = 0.25 * s2;
                    this._z = (m23 + m32) / s2;
                } else {
                    var s3 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                    this._w = (m21 - m12) / s3;
                    this._x = (m13 + m31) / s3;
                    this._y = (m23 + m32) / s3;
                    this._z = 0.25 * s3;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "setFromUnitVectors",
            value: function setFromUnitVectors(vFrom, vTo) {
                // assumes direction vectors vFrom and vTo are normalized
                var r = vFrom.dot(vTo) + 1;
                if (r < 1e-8) {
                    // vFrom and vTo point in opposite directions
                    r = 0;
                    if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                        this._x = -vFrom.y;
                        this._y = vFrom.x;
                        this._z = 0;
                        this._w = r;
                    } else {
                        this._x = 0;
                        this._y = -vFrom.z;
                        this._z = vFrom.y;
                        this._w = r;
                    }
                } else {
                    // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
                    this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
                    this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
                    this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
                    this._w = r;
                }
                return this.normalize();
            }
        },
        {
            /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ key: "angleTo",
            value: function angleTo(q) {
                return 2 * Math.acos(Math.abs($a1724dcfba0d6d9a$var$clamp(this.dot(q), -1, 1)));
            }
        },
        {
            /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "rotateTowards",
            value: function rotateTowards(q, step) {
                var angle = this.angleTo(q);
                if (angle === 0) return this;
                var t = Math.min(1, step / angle);
                this.slerp(q, t);
                return this;
            }
        },
        {
            /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "identity",
            value: function identity() {
                return this.set(0, 0, 0, 1);
            }
        },
        {
            /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "invert",
            value: function invert() {
                return this.conjugate();
            }
        },
        {
            /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "conjugate",
            value: function conjugate() {
                this._x *= -1;
                this._y *= -1;
                this._z *= -1;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ key: "dot",
            value: function dot(v) {
                return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
            }
        },
        {
            /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ key: "lengthSq",
            value: function lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
        },
        {
            /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ key: "length",
            value: function length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
        },
        {
            /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "normalize",
            value: function normalize() {
                var l = this.length();
                if (l === 0) {
                    this._x = 0;
                    this._y = 0;
                    this._z = 0;
                    this._w = 1;
                } else {
                    l = 1 / l;
                    this._x = this._x * l;
                    this._y = this._y * l;
                    this._z = this._z * l;
                    this._w = this._w * l;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "multiply",
            value: function multiply(q) {
                return this.multiplyQuaternions(this, q);
            }
        },
        {
            /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "premultiply",
            value: function premultiply(q) {
                return this.multiplyQuaternions(q, this);
            }
        },
        {
            /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "multiplyQuaternions",
            value: function multiplyQuaternions(a, b) {
                // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
                var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
                var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
                this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
                this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
                this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
                this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "slerp",
            value: function slerp(qb, t) {
                if (t === 0) return this;
                if (t === 1) return this.copy(qb);
                var x = this._x, y = this._y, z = this._z, w = this._w;
                // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
                var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
                if (cosHalfTheta < 0) {
                    this._w = -qb._w;
                    this._x = -qb._x;
                    this._y = -qb._y;
                    this._z = -qb._z;
                    cosHalfTheta = -cosHalfTheta;
                } else this.copy(qb);
                if (cosHalfTheta >= 1.0) {
                    this._w = w;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    return this;
                }
                var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
                if (sqrSinHalfTheta <= Number.EPSILON) {
                    var s = 1 - t;
                    this._w = s * w + t * this._w;
                    this._x = s * x + t * this._x;
                    this._y = s * y + t * this._y;
                    this._z = s * z + t * this._z;
                    this.normalize(); // normalize calls _onChangeCallback()
                    return this;
                }
                var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
                var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
                var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
                this._w = w * ratioA + this._w * ratioB;
                this._x = x * ratioA + this._x * ratioB;
                this._y = y * ratioA + this._y * ratioB;
                this._z = z * ratioA + this._z * ratioB;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "slerpQuaternions",
            value: function slerpQuaternions(qa, qb, t) {
                return this.copy(qa).slerp(qb, t);
            }
        },
        {
            /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "random",
            value: function random() {
                // Ken Shoemake
                // Uniform random rotations
                // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
                var theta1 = 2 * Math.PI * Math.random();
                var theta2 = 2 * Math.PI * Math.random();
                var x0 = Math.random();
                var r1 = Math.sqrt(1 - x0);
                var r2 = Math.sqrt(x0);
                return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
            }
        },
        {
            /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ key: "equals",
            value: function equals(quaternion) {
                return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
            }
        },
        {
            /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this._x = array[offset];
                this._y = array[offset + 1];
                this._z = array[offset + 2];
                this._w = array[offset + 3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._w;
                return array;
            }
        },
        {
            /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this._x = attribute.getX(index);
                this._y = attribute.getY(index);
                this._z = attribute.getZ(index);
                this._w = attribute.getW(index);
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ key: "toJSON",
            value: function toJSON() {
                return this.toArray();
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this._x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this._y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this._z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this._w
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ], [
        {
            key: "slerpFlat",
            value: /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed  in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
                // fuzz-free, array-based Quaternion SLERP operation
                var x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
                if (t === 0) {
                    dst[dstOffset + 0] = x0;
                    dst[dstOffset + 1] = y0;
                    dst[dstOffset + 2] = z0;
                    dst[dstOffset + 3] = w0;
                    return;
                }
                if (t === 1) {
                    dst[dstOffset + 0] = x1;
                    dst[dstOffset + 1] = y1;
                    dst[dstOffset + 2] = z1;
                    dst[dstOffset + 3] = w1;
                    return;
                }
                if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
                    var s = 1 - t;
                    var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
                    // Skip the Slerp for tiny steps to avoid numeric problems:
                    if (sqrSin > Number.EPSILON) {
                        var sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                        s = Math.sin(s * len) / sin;
                        t = Math.sin(t * len) / sin;
                    }
                    var tDir = t * dir;
                    x0 = x0 * s + x1 * tDir;
                    y0 = y0 * s + y1 * tDir;
                    z0 = z0 * s + z1 * tDir;
                    w0 = w0 * s + w1 * tDir;
                    // Normalize in case we just did a lerp:
                    if (s === 1 - t) {
                        var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                        x0 *= f;
                        y0 *= f;
                        z0 *= f;
                        w0 *= f;
                    }
                }
                dst[dstOffset] = x0;
                dst[dstOffset + 1] = y0;
                dst[dstOffset + 2] = z0;
                dst[dstOffset + 3] = w0;
            }
        },
        {
            key: "multiplyQuaternionsFlat",
            value: /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
                var x0 = src0[srcOffset0];
                var y0 = src0[srcOffset0 + 1];
                var z0 = src0[srcOffset0 + 2];
                var w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1];
                var y1 = src1[srcOffset1 + 1];
                var z1 = src1[srcOffset1 + 2];
                var w1 = src1[srcOffset1 + 3];
                dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
                dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
                dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
                dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
                return dst;
            }
        }
    ]);
    return Quaternion;
}();
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ var $a1724dcfba0d6d9a$export$64b5c384219d3699 = /*#__PURE__*/ function() {
    "use strict";
    function Vector3() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $jGAMp._)(this, Vector3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector3.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    (0, $byiyg._)(Vector3, [
        {
            /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ key: "set",
            value: function set(x, y, z) {
                if (z === undefined) z = this.z; // sprite.scale.set(x,y)
                this.x = x;
                this.y = y;
                this.z = z;
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
        },
        {
            /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                return this;
            }
        },
        {
            /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                return this;
            }
        },
        {
            /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "multiplyVectors",
            value: function multiplyVectors(a, b) {
                this.x = a.x * b.x;
                this.y = a.y * b.y;
                this.z = a.z * b.z;
                return this;
            }
        },
        {
            /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyEuler",
            value: function applyEuler(euler) {
                return this.applyQuaternion($a1724dcfba0d6d9a$var$_quaternion$4.setFromEuler(euler));
            }
        },
        {
            /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyAxisAngle",
            value: function applyAxisAngle(axis, angle) {
                return this.applyQuaternion($a1724dcfba0d6d9a$var$_quaternion$4.setFromAxisAngle(axis, angle));
            }
        },
        {
            /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6] * z;
                this.y = e[1] * x + e[4] * y + e[7] * z;
                this.z = e[2] * x + e[5] * y + e[8] * z;
                return this;
            }
        },
        {
            /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                return this.applyMatrix3(m).normalize();
            }
        },
        {
            /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
                this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
                this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
                this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
                return this;
            }
        },
        {
            /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ key: "applyQuaternion",
            value: function applyQuaternion(q) {
                // quaternion q is assumed to have unit length
                var vx = this.x, vy = this.y, vz = this.z;
                var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
                // t = 2 * cross( q.xyz, v );
                var tx = 2 * (qy * vz - qz * vy);
                var ty = 2 * (qz * vx - qx * vz);
                var tz = 2 * (qx * vy - qy * vx);
                // v + q.w * t + cross( q.xyz, t );
                this.x = vx + qw * tx + qy * tz - qz * ty;
                this.y = vy + qw * ty + qz * tx - qx * tz;
                this.z = vz + qw * tz + qx * ty - qy * tx;
                return this;
            }
        },
        {
            /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ key: "project",
            value: function project(camera) {
                return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
            }
        },
        {
            /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ key: "unproject",
            value: function unproject(camera) {
                return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
            }
        },
        {
            /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ key: "transformDirection",
            value: function transformDirection(m) {
                // input: THREE.Matrix4 affine matrix
                // vector interpreted as a direction
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z;
                this.y = e[1] * x + e[5] * y + e[9] * z;
                this.z = e[2] * x + e[6] * y + e[10] * z;
                return this.normalize();
            }
        },
        {
            /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                return this;
            }
        },
        {
            /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, min.x, max.x);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, min.y, max.y);
                this.z = $a1724dcfba0d6d9a$var$clamp(this.z, min.z, max.z);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, minVal, maxVal);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, minVal, maxVal);
                this.z = $a1724dcfba0d6d9a$var$clamp(this.z, minVal, maxVal);
                return this;
            }
        },
        {
            /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($a1724dcfba0d6d9a$var$clamp(length, min, max));
            }
        },
        {
            /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                this.z = Math.trunc(this.z);
                return this;
            }
        },
        {
            /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                return this;
            }
        },
        {
            /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z;
            }
        },
        {
            // TODO lengthSquared?
            /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
        },
        {
            /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
        },
        {
            /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
        },
        {
            /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                return this;
            }
        },
        {
            /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ key: "cross",
            value: function cross(v) {
                return this.crossVectors(this, v);
            }
        },
        {
            /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "crossVectors",
            value: function crossVectors(a, b) {
                var ax = a.x, ay = a.y, az = a.z;
                var bx = b.x, by = b.y, bz = b.z;
                this.x = ay * bz - az * by;
                this.y = az * bx - ax * bz;
                this.z = ax * by - ay * bx;
                return this;
            }
        },
        {
            /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ key: "projectOnVector",
            value: function projectOnVector(v) {
                var denominator = v.lengthSq();
                if (denominator === 0) return this.set(0, 0, 0);
                var scalar = v.dot(this) / denominator;
                return this.copy(v).multiplyScalar(scalar);
            }
        },
        {
            /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ key: "projectOnPlane",
            value: function projectOnPlane(planeNormal) {
                $a1724dcfba0d6d9a$var$_vector$c.copy(this).projectOnVector(planeNormal);
                return this.sub($a1724dcfba0d6d9a$var$_vector$c);
            }
        },
        {
            /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ key: "reflect",
            value: function reflect(normal) {
                return this.sub($a1724dcfba0d6d9a$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
            }
        },
        {
            /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ key: "angleTo",
            value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator;
                // clamp, to handle numerical problems
                return Math.acos($a1724dcfba0d6d9a$var$clamp(theta, -1, 1));
            }
        },
        {
            /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
                return dx * dx + dy * dy + dz * dz;
            }
        },
        {
            /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
            }
        },
        {
            /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromSpherical",
            value: function setFromSpherical(s) {
                return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
            }
        },
        {
            /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromSphericalCoords",
            value: function setFromSphericalCoords(radius, phi, theta) {
                var sinPhiRadius = Math.sin(phi) * radius;
                this.x = sinPhiRadius * Math.sin(theta);
                this.y = Math.cos(phi) * radius;
                this.z = sinPhiRadius * Math.cos(theta);
                return this;
            }
        },
        {
            /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromCylindrical",
            value: function setFromCylindrical(c) {
                return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
            }
        },
        {
            /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromCylindricalCoords",
            value: function setFromCylindricalCoords(radius, theta, y) {
                this.x = radius * Math.sin(theta);
                this.y = y;
                this.z = radius * Math.cos(theta);
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromMatrixPosition",
            value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromMatrixScale",
            value: function setFromMatrixScale(m) {
                var sx = this.setFromMatrixColumn(m, 0).length();
                var sy = this.setFromMatrixColumn(m, 1).length();
                var sz = this.setFromMatrixColumn(m, 2).length();
                this.x = sx;
                this.y = sy;
                this.z = sz;
                return this;
            }
        },
        {
            /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromMatrixColumn",
            value: function setFromMatrixColumn(m, index) {
                return this.fromArray(m.elements, index * 4);
            }
        },
        {
            /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromMatrix3Column",
            value: function setFromMatrix3Column(m, index) {
                return this.fromArray(m.elements, index * 3);
            }
        },
        {
            /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromEuler",
            value: function setFromEuler(e) {
                this.x = e._x;
                this.y = e._y;
                this.z = e._z;
                return this;
            }
        },
        {
            /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ key: "setFromColor",
            value: function setFromColor(c) {
                this.x = c.r;
                this.y = c.g;
                this.z = c.b;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z;
            }
        },
        {
            /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                return this;
            }
        },
        {
            /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                return array;
            }
        },
        {
            /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                return this;
            }
        },
        {
            /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                return this;
            }
        },
        {
            /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ key: "randomDirection",
            value: function randomDirection() {
                // https://mathworld.wolfram.com/SpherePointPicking.html
                var theta = Math.random() * Math.PI * 2;
                var u = Math.random() * 2 - 1;
                var c = Math.sqrt(1 - u * u);
                this.x = c * Math.cos(theta);
                this.y = u;
                this.z = c * Math.sin(theta);
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector3;
}();
var $a1724dcfba0d6d9a$var$_vector$c = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_quaternion$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ var $a1724dcfba0d6d9a$export$8ff26dafa08918 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix3(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        (0, $jGAMp._)(this, Matrix3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix3.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    (0, $byiyg._)(Matrix3, [
        {
            /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "set",
            value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
                var te = this.elements;
                te[0] = n11;
                te[1] = n21;
                te[2] = n31;
                te[3] = n12;
                te[4] = n22;
                te[5] = n32;
                te[6] = n13;
                te[7] = n23;
                te[8] = n33;
                return this;
            }
        },
        {
            /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                return this;
            }
        },
        {
            /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrix3Column(this, 0);
                yAxis.setFromMatrix3Column(this, 1);
                zAxis.setFromMatrix3Column(this, 2);
                return this;
            }
        },
        {
            /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "setFromMatrix4",
            value: function setFromMatrix4(m) {
                var me = m.elements;
                this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
                return this;
            }
        },
        {
            /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "multiply",
            value: function multiply(m) {
                return this.multiplyMatrices(this, m);
            }
        },
        {
            /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[3], a13 = ae[6];
                var a21 = ae[1], a22 = ae[4], a23 = ae[7];
                var a31 = ae[2], a32 = ae[5], a33 = ae[8];
                var b11 = be[0], b12 = be[3], b13 = be[6];
                var b21 = be[1], b22 = be[4], b23 = be[7];
                var b31 = be[2], b32 = be[5], b33 = be[8];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31;
                te[3] = a11 * b12 + a12 * b22 + a13 * b32;
                te[6] = a11 * b13 + a12 * b23 + a13 * b33;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31;
                te[4] = a21 * b12 + a22 * b22 + a23 * b32;
                te[7] = a21 * b13 + a22 * b23 + a23 * b33;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31;
                te[5] = a31 * b12 + a32 * b22 + a33 * b32;
                te[8] = a31 * b13 + a32 * b23 + a33 * b33;
                return this;
            }
        },
        {
            /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[3] *= s;
                te[6] *= s;
                te[1] *= s;
                te[4] *= s;
                te[7] *= s;
                te[2] *= s;
                te[5] *= s;
                te[8] *= s;
                return this;
            }
        },
        {
            /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
                return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
            }
        },
        {
            /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "invert",
            value: function invert() {
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n31 * n23 - n33 * n21) * detInv;
                te[2] = (n32 * n21 - n31 * n22) * detInv;
                te[3] = t12 * detInv;
                te[4] = (n33 * n11 - n31 * n13) * detInv;
                te[5] = (n31 * n12 - n32 * n11) * detInv;
                te[6] = t13 * detInv;
                te[7] = (n21 * n13 - n23 * n11) * detInv;
                te[8] = (n22 * n11 - n21 * n12) * detInv;
                return this;
            }
        },
        {
            /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "transpose",
            value: function transpose() {
                var tmp;
                var m = this.elements;
                tmp = m[1];
                m[1] = m[3];
                m[3] = tmp;
                tmp = m[2];
                m[2] = m[6];
                m[6] = tmp;
                tmp = m[5];
                m[5] = m[7];
                m[7] = tmp;
                return this;
            }
        },
        {
            /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "getNormalMatrix",
            value: function getNormalMatrix(matrix4) {
                return this.setFromMatrix4(matrix4).invert().transpose();
            }
        },
        {
            /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "transposeIntoArray",
            value: function transposeIntoArray(r) {
                var m = this.elements;
                r[0] = m[0];
                r[1] = m[3];
                r[2] = m[6];
                r[3] = m[1];
                r[4] = m[4];
                r[5] = m[7];
                r[6] = m[2];
                r[7] = m[5];
                r[8] = m[8];
                return this;
            }
        },
        {
            /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "setUvTransform",
            value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
                var c = Math.cos(rotation);
                var s = Math.sin(rotation);
                this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "scale",
            value: function scale(sx, sy) {
                this.premultiply($a1724dcfba0d6d9a$var$_m3.makeScale(sx, sy));
                return this;
            }
        },
        {
            /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "rotate",
            value: function rotate(theta) {
                this.premultiply($a1724dcfba0d6d9a$var$_m3.makeRotation(-theta));
                return this;
            }
        },
        {
            /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "translate",
            value: function translate(tx, ty) {
                this.premultiply($a1724dcfba0d6d9a$var$_m3.makeTranslation(tx, ty));
                return this;
            }
        },
        {
            // for 2D Transforms
            /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "makeTranslation",
            value: function makeTranslation(x, y) {
                if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
                else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "makeRotation",
            value: function makeRotation(theta) {
                // counterclockwise
                var c = Math.cos(theta);
                var s = Math.sin(theta);
                this.set(c, -s, 0, s, c, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "makeScale",
            value: function makeScale(x, y) {
                this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 9; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 9; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                return array;
            }
        },
        {
            /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().fromArray(this.elements);
            }
        }
    ]);
    return Matrix3;
}();
var $a1724dcfba0d6d9a$var$_m3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$8ff26dafa08918();
function $a1724dcfba0d6d9a$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(var i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
var $a1724dcfba0d6d9a$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $a1724dcfba0d6d9a$var$getTypedArray(type, buffer) {
    return new $a1724dcfba0d6d9a$var$TYPED_ARRAYS[type](buffer);
}
function $a1724dcfba0d6d9a$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $a1724dcfba0d6d9a$export$1033a2df66368859() {
    var canvas = $a1724dcfba0d6d9a$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
var $a1724dcfba0d6d9a$var$_cache = {};
function $a1724dcfba0d6d9a$export$5b28268982f175ba(message) {
    if (message in $a1724dcfba0d6d9a$var$_cache) return;
    $a1724dcfba0d6d9a$var$_cache[message] = true;
    console.warn(message);
}
function $a1724dcfba0d6d9a$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $a1724dcfba0d6d9a$export$5238391f68c729b(projectionMatrix) {
    var m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $a1724dcfba0d6d9a$export$f8cf97d08da9bc86(projectionMatrix) {
    var m = projectionMatrix.elements;
    var isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
var $a1724dcfba0d6d9a$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
var $a1724dcfba0d6d9a$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $a1724dcfba0d6d9a$var$createColorManagement() {
    var ColorManagement = {
        enabled: true,
        workingColorSpace: $a1724dcfba0d6d9a$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function convert(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $a1724dcfba0d6d9a$export$8d0a61916cc26abb) {
                color.r = $a1724dcfba0d6d9a$var$SRGBToLinear(color.r);
                color.g = $a1724dcfba0d6d9a$var$SRGBToLinear(color.g);
                color.b = $a1724dcfba0d6d9a$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $a1724dcfba0d6d9a$export$8d0a61916cc26abb) {
                color.r = $a1724dcfba0d6d9a$var$LinearToSRGB(color.r);
                color.g = $a1724dcfba0d6d9a$var$LinearToSRGB(color.g);
                color.b = $a1724dcfba0d6d9a$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function workingToColorSpace(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function colorSpaceToWorking(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function getPrimaries(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function getTransfer(colorSpace) {
            if (colorSpace === $a1724dcfba0d6d9a$export$bfcb490c2dd3db51) return $a1724dcfba0d6d9a$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function getLuminanceCoefficients(target) {
            var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.workingColorSpace;
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function define(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function _getMatrix(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function _getDrawingBufferColorSpace(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function _getUnpackColorSpace() {
            var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.workingColorSpace;
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {
            $a1724dcfba0d6d9a$export$5b28268982f175ba('THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {
            $a1724dcfba0d6d9a$export$5b28268982f175ba('THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ var REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    var REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    var D65 = [
        0.3127,
        0.3290
    ];
    var _obj;
    ColorManagement.define((_obj = {}, (0, $cqEAj._)(_obj, $a1724dcfba0d6d9a$export$42429b3acfb233a4, {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: $a1724dcfba0d6d9a$export$f197347d588c1b4a,
        toXYZ: $a1724dcfba0d6d9a$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $a1724dcfba0d6d9a$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        workingColorSpaceConfig: {
            unpackColorSpace: $a1724dcfba0d6d9a$export$561f394b24edfcaa
        },
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $a1724dcfba0d6d9a$export$561f394b24edfcaa
        }
    }), (0, $cqEAj._)(_obj, $a1724dcfba0d6d9a$export$561f394b24edfcaa, {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: $a1724dcfba0d6d9a$export$8d0a61916cc26abb,
        toXYZ: $a1724dcfba0d6d9a$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $a1724dcfba0d6d9a$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $a1724dcfba0d6d9a$export$561f394b24edfcaa
        }
    }), _obj));
    return ColorManagement;
}
var $a1724dcfba0d6d9a$export$5e6fd513f44698c = /*@__PURE__*/ $a1724dcfba0d6d9a$var$createColorManagement();
function $a1724dcfba0d6d9a$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $a1724dcfba0d6d9a$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
var $a1724dcfba0d6d9a$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$698882cf06df44aa = /*#__PURE__*/ function() {
    "use strict";
    function ImageUtils() {
        (0, $jGAMp._)(this, ImageUtils);
    }
    (0, $byiyg._)(ImageUtils, null, [
        {
            key: "getDataURL",
            value: /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ function getDataURL(image) {
                var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'image/png';
                if (/^data:/i.test(image.src)) return image.src;
                if (typeof HTMLCanvasElement === 'undefined') return image.src;
                var canvas;
                if (image instanceof HTMLCanvasElement) canvas = image;
                else {
                    if ($a1724dcfba0d6d9a$var$_canvas === undefined) $a1724dcfba0d6d9a$var$_canvas = $a1724dcfba0d6d9a$export$7094a064528c7fee('canvas');
                    $a1724dcfba0d6d9a$var$_canvas.width = image.width;
                    $a1724dcfba0d6d9a$var$_canvas.height = image.height;
                    var context = $a1724dcfba0d6d9a$var$_canvas.getContext('2d');
                    if (image instanceof ImageData) context.putImageData(image, 0, 0);
                    else context.drawImage(image, 0, 0, image.width, image.height);
                    canvas = $a1724dcfba0d6d9a$var$_canvas;
                }
                return canvas.toDataURL(type);
            }
        },
        {
            key: "sRGBToLinear",
            value: /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ function sRGBToLinear(image) {
                if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                    var canvas = $a1724dcfba0d6d9a$export$7094a064528c7fee('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var imageData = context.getImageData(0, 0, image.width, image.height);
                    var data = imageData.data;
                    for(var i = 0; i < data.length; i++)data[i] = $a1724dcfba0d6d9a$var$SRGBToLinear(data[i] / 255) * 255;
                    context.putImageData(imageData, 0, 0);
                    return canvas;
                } else if (image.data) {
                    var data1 = image.data.slice(0);
                    for(var i1 = 0; i1 < data1.length; i1++)if (data1 instanceof Uint8Array || data1 instanceof Uint8ClampedArray) data1[i1] = Math.floor($a1724dcfba0d6d9a$var$SRGBToLinear(data1[i1] / 255) * 255);
                    else // assuming float
                    data1[i1] = $a1724dcfba0d6d9a$var$SRGBToLinear(data1[i1]);
                    return {
                        data: data1,
                        width: image.width,
                        height: image.height
                    };
                } else {
                    console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
                    return image;
                }
            }
        }
    ]);
    return ImageUtils;
}();
var $a1724dcfba0d6d9a$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ var $a1724dcfba0d6d9a$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    "use strict";
    function Source() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $jGAMp._)(this, Source);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $a1724dcfba0d6d9a$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    (0, $byiyg._)(Source, [
        {
            key: "getSize",
            value: function getSize(target) {
                var data = this.data;
                if (data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight);
                else if (data !== null) target.set(data.width, data.height, data.depth || 0);
                else target.set(0, 0, 0);
                return target;
            }
        },
        {
            key: "needsUpdate",
            set: /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
                var output = {
                    uuid: this.uuid,
                    url: ''
                };
                var data = this.data;
                if (data !== null) {
                    var url;
                    if (Array.isArray(data)) {
                        // cube texture
                        url = [];
                        for(var i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($a1724dcfba0d6d9a$var$serializeImage(data[i].image));
                        else url.push($a1724dcfba0d6d9a$var$serializeImage(data[i]));
                    } else // texture
                    url = $a1724dcfba0d6d9a$var$serializeImage(data);
                    output.url = url;
                }
                if (!isRootObject) meta.images[this.uuid] = output;
                return output;
            }
        }
    ]);
    return Source;
}();
function $a1724dcfba0d6d9a$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $a1724dcfba0d6d9a$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
var $a1724dcfba0d6d9a$var$_textureId = 0;
var $a1724dcfba0d6d9a$var$_tempVec3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$5431306cf43de24a = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(Texture, EventDispatcher);
    function Texture() {
        var image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Texture.DEFAULT_IMAGE, mapping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Texture.DEFAULT_MAPPING, wrapS = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $a1724dcfba0d6d9a$export$9d9334239a5a5e06, wrapT = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $a1724dcfba0d6d9a$export$9d9334239a5a5e06, magFilter = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $a1724dcfba0d6d9a$export$8a72f490b25c56c8, minFilter = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $a1724dcfba0d6d9a$export$5d8599b6a933fb1b, format = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $a1724dcfba0d6d9a$export$3f8bb04b555a363c, type = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : $a1724dcfba0d6d9a$export$2e8ce08d3f6f5e10, anisotropy = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : Texture.DEFAULT_ANISOTROPY, colorSpace = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $a1724dcfba0d6d9a$export$bfcb490c2dd3db51;
        (0, $jGAMp._)(this, Texture);
        var _this;
        _this = (0, $kzDuW._)(this, Texture);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(_this, 'id', {
            value: $a1724dcfba0d6d9a$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ _this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ _this.source = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ _this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ _this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ _this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ _this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ _this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ _this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ _this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ _this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ _this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ _this.offset = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.repeat = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ _this.center = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ _this.matrix = new $a1724dcfba0d6d9a$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ _this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ _this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ _this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ _this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ _this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ _this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ _this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ _this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ _this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ _this.pmremVersion = 0;
        return _this;
    }
    (0, $byiyg._)(Texture, [
        {
            key: "width",
            get: /**
	 * The width of the texture in pixels.
	 */ function get() {
                return this.source.getSize($a1724dcfba0d6d9a$var$_tempVec3).x;
            }
        },
        {
            key: "height",
            get: /**
	 * The height of the texture in pixels.
	 */ function get() {
                return this.source.getSize($a1724dcfba0d6d9a$var$_tempVec3).y;
            }
        },
        {
            key: "depth",
            get: /**
	 * The depth of the texture in pixels.
	 */ function get() {
                return this.source.getSize($a1724dcfba0d6d9a$var$_tempVec3).z;
            }
        },
        {
            key: "image",
            get: /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ function get() {
                return this.source.data;
            },
            set: function set() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this.source.data = value;
            }
        },
        {
            /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
        },
        {
            /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ key: "addUpdateRange",
            value: function addUpdateRange(start, count) {
                this.updateRanges.push({
                    start: start,
                    count: count
                });
            }
        },
        {
            /**
	 * Clears the update ranges.
	 */ key: "clearUpdateRanges",
            value: function clearUpdateRanges() {
                this.updateRanges.length = 0;
            }
        },
        {
            /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.source = source.source;
                this.mipmaps = source.mipmaps.slice(0);
                this.mapping = source.mapping;
                this.channel = source.channel;
                this.wrapS = source.wrapS;
                this.wrapT = source.wrapT;
                this.magFilter = source.magFilter;
                this.minFilter = source.minFilter;
                this.anisotropy = source.anisotropy;
                this.format = source.format;
                this.internalFormat = source.internalFormat;
                this.type = source.type;
                this.offset.copy(source.offset);
                this.repeat.copy(source.repeat);
                this.center.copy(source.center);
                this.rotation = source.rotation;
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrix.copy(source.matrix);
                this.generateMipmaps = source.generateMipmaps;
                this.premultiplyAlpha = source.premultiplyAlpha;
                this.flipY = source.flipY;
                this.unpackAlignment = source.unpackAlignment;
                this.colorSpace = source.colorSpace;
                this.renderTarget = source.renderTarget;
                this.isRenderTargetTexture = source.isRenderTargetTexture;
                this.isArrayTexture = source.isArrayTexture;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                this.needsUpdate = true;
                return this;
            }
        },
        {
            /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ key: "setValues",
            value: function setValues(values) {
                for(var key in values){
                    var newValue = values[key];
                    if (newValue === undefined) {
                        console.warn("THREE.Texture.setValues(): parameter '".concat(key, "' has value of undefined."));
                        continue;
                    }
                    var currentValue = this[key];
                    if (currentValue === undefined) {
                        console.warn("THREE.Texture.setValues(): property '".concat(key, "' does not exist."));
                        continue;
                    }
                    if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
                    else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
                    else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
                    else this[key] = newValue;
                }
            }
        },
        {
            /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
                var output = {
                    metadata: {
                        version: 4.7,
                        type: 'Texture',
                        generator: 'Texture.toJSON'
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(meta).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                if (Object.keys(this.userData).length > 0) output.userData = this.userData;
                if (!isRootObject) meta.textures[this.uuid] = output;
                return output;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ key: "dispose",
            value: function dispose() {
                /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ key: "transformUv",
            value: function transformUv(uv) {
                if (this.mapping !== $a1724dcfba0d6d9a$export$1beec6768cbb3d2d) return uv;
                uv.applyMatrix3(this.matrix);
                if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
                    case $a1724dcfba0d6d9a$export$533346c8e8dac0f5:
                        uv.x = uv.x - Math.floor(uv.x);
                        break;
                    case $a1724dcfba0d6d9a$export$9d9334239a5a5e06:
                        uv.x = uv.x < 0 ? 0 : 1;
                        break;
                    case $a1724dcfba0d6d9a$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                        else uv.x = uv.x - Math.floor(uv.x);
                        break;
                }
                if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
                    case $a1724dcfba0d6d9a$export$533346c8e8dac0f5:
                        uv.y = uv.y - Math.floor(uv.y);
                        break;
                    case $a1724dcfba0d6d9a$export$9d9334239a5a5e06:
                        uv.y = uv.y < 0 ? 0 : 1;
                        break;
                    case $a1724dcfba0d6d9a$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                        else uv.y = uv.y - Math.floor(uv.y);
                        break;
                }
                if (this.flipY) uv.y = 1 - uv.y;
                return uv;
            }
        },
        {
            key: "needsUpdate",
            set: /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) {
                    this.version++;
                    this.source.needsUpdate = true;
                }
            }
        },
        {
            key: "needsPMREMUpdate",
            set: /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.pmremVersion++;
            }
        }
    ]);
    return Texture;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $a1724dcfba0d6d9a$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $a1724dcfba0d6d9a$export$5431306cf43de24a.DEFAULT_MAPPING = $a1724dcfba0d6d9a$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $a1724dcfba0d6d9a$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ var $a1724dcfba0d6d9a$export$fa7daccca11cdbe3 = /*#__PURE__*/ function() {
    "use strict";
    function Vector4() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, Vector4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector4.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    (0, $byiyg._)(Vector4, [
        {
            key: "width",
            get: /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ function get() {
                return this.z;
            },
            set: function set(value) {
                this.z = value;
            }
        },
        {
            key: "height",
            get: /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ function get() {
                return this.w;
            },
            set: function set(value) {
                this.w = value;
            }
        },
        {
            /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ key: "set",
            value: function set(x, y, z, w) {
                this.x = x;
                this.y = y;
                this.z = z;
                this.w = w;
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                this.w = scalar;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setW",
            value: function setW(w) {
                this.w = w;
                return this;
            }
        },
        {
            /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    case 3:
                        this.w = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
        },
        {
            /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                this.w = v.w !== undefined ? v.w : 1;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                this.w += v.w;
                return this;
            }
        },
        {
            /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                this.w += s;
                return this;
            }
        },
        {
            /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                this.w = a.w + b.w;
                return this;
            }
        },
        {
            /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                this.w += v.w * s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                this.w -= v.w;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                this.w -= s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                this.w = a.w - b.w;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                this.w *= v.w;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                this.w *= scalar;
                return this;
            }
        },
        {
            /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z, w = this.w;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
                this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
                this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
                this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
                return this;
            }
        },
        {
            /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                this.w /= v.w;
                return this;
            }
        },
        {
            /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setAxisAngleFromQuaternion",
            value: function setAxisAngleFromQuaternion(q) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
                // q is assumed to be normalized
                this.w = 2 * Math.acos(q.w);
                var s = Math.sqrt(1 - q.w * q.w);
                if (s < 0.0001) {
                    this.x = 1;
                    this.y = 0;
                    this.z = 0;
                } else {
                    this.x = q.x / s;
                    this.y = q.y / s;
                    this.z = q.z / s;
                }
                return this;
            }
        },
        {
            /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setAxisAngleFromRotationMatrix",
            value: function setAxisAngleFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var angle, x, y, z; // variables for result
                var epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
                if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
                    // singularity found
                    // first check for identity matrix which must have +1 for all terms
                    // in leading diagonal and zero in other terms
                    if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                        // this singularity is identity matrix so angle = 0
                        this.set(1, 0, 0, 0);
                        return this; // zero angle, arbitrary axis
                    }
                    // otherwise this singularity is angle = 180
                    angle = Math.PI;
                    var xx = (m11 + 1) / 2;
                    var yy = (m22 + 1) / 2;
                    var zz = (m33 + 1) / 2;
                    var xy = (m12 + m21) / 4;
                    var xz = (m13 + m31) / 4;
                    var yz = (m23 + m32) / 4;
                    if (xx > yy && xx > zz) {
                        // m11 is the largest diagonal term
                        if (xx < epsilon) {
                            x = 0;
                            y = 0.707106781;
                            z = 0.707106781;
                        } else {
                            x = Math.sqrt(xx);
                            y = xy / x;
                            z = xz / x;
                        }
                    } else if (yy > zz) {
                        // m22 is the largest diagonal term
                        if (yy < epsilon) {
                            x = 0.707106781;
                            y = 0;
                            z = 0.707106781;
                        } else {
                            y = Math.sqrt(yy);
                            x = xy / y;
                            z = yz / y;
                        }
                    } else // m33 is the largest diagonal term so base result on this
                    if (zz < epsilon) {
                        x = 0.707106781;
                        y = 0.707106781;
                        z = 0;
                    } else {
                        z = Math.sqrt(zz);
                        x = xz / z;
                        y = yz / z;
                    }
                    this.set(x, y, z, angle);
                    return this; // return 180 deg rotation
                }
                // as we have reached here there are no singularities so we can handle normally
                var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
                if (Math.abs(s) < 0.001) s = 1;
                // prevent divide by zero, should not happen if matrix is orthogonal and should be
                // caught by singularity test above, but I've left it in just in case
                this.x = (m32 - m23) / s;
                this.y = (m13 - m31) / s;
                this.z = (m21 - m12) / s;
                this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
                return this;
            }
        },
        {
            /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setFromMatrixPosition",
            value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                this.w = e[15];
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                this.w = Math.min(this.w, v.w);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                this.w = Math.max(this.w, v.w);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, min.x, max.x);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, min.y, max.y);
                this.z = $a1724dcfba0d6d9a$var$clamp(this.z, min.z, max.z);
                this.w = $a1724dcfba0d6d9a$var$clamp(this.w, min.w, max.w);
                return this;
            }
        },
        {
            /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $a1724dcfba0d6d9a$var$clamp(this.x, minVal, maxVal);
                this.y = $a1724dcfba0d6d9a$var$clamp(this.y, minVal, maxVal);
                this.z = $a1724dcfba0d6d9a$var$clamp(this.z, minVal, maxVal);
                this.w = $a1724dcfba0d6d9a$var$clamp(this.w, minVal, maxVal);
                return this;
            }
        },
        {
            /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($a1724dcfba0d6d9a$var$clamp(length, min, max));
            }
        },
        {
            /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                this.w = Math.floor(this.w);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                this.w = Math.ceil(this.w);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                this.w = Math.round(this.w);
                return this;
            }
        },
        {
            /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                this.z = Math.trunc(this.z);
                this.w = Math.trunc(this.w);
                return this;
            }
        },
        {
            /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                this.w = -this.w;
                return this;
            }
        },
        {
            /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
            }
        },
        {
            /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
        },
        {
            /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
        },
        {
            /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
        },
        {
            /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                this.w += (v.w - this.w) * alpha;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                this.w = v1.w + (v2.w - v1.w) * alpha;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
            }
        },
        {
            /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                this.w = array[offset + 3];
                return this;
            }
        },
        {
            /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                array[offset + 3] = this.w;
                return array;
            }
        },
        {
            /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                this.w = attribute.getW(index);
                return this;
            }
        },
        {
            /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                this.w = Math.random();
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this.w
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector4;
}();
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$efcb1f8bf367cbfb = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(RenderTarget, EventDispatcher);
    function RenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $jGAMp._)(this, RenderTarget);
        var _this;
        _this = (0, $kzDuW._)(this, RenderTarget);
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $a1724dcfba0d6d9a$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ _this.scissor = new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ _this.viewport = new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(0, 0, width, height);
        var image = {
            width: width,
            height: height,
            depth: options.depth
        };
        var texture = new $a1724dcfba0d6d9a$export$5431306cf43de24a(image);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ _this.textures = [];
        var count = options.count;
        for(var i = 0; i < count; i++){
            _this.textures[i] = texture.clone();
            _this.textures[i].isRenderTargetTexture = true;
            _this.textures[i].renderTarget = _this;
        }
        _this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.resolveStencilBuffer = options.resolveStencilBuffer;
        _this._depthTexture = null;
        _this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.multiview = options.multiview;
        return _this;
    }
    (0, $byiyg._)(RenderTarget, [
        {
            key: "_setTextureOptions",
            value: function _setTextureOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var values = {
                    minFilter: $a1724dcfba0d6d9a$export$8a72f490b25c56c8,
                    generateMipmaps: false,
                    flipY: false,
                    internalFormat: null
                };
                if (options.mapping !== undefined) values.mapping = options.mapping;
                if (options.wrapS !== undefined) values.wrapS = options.wrapS;
                if (options.wrapT !== undefined) values.wrapT = options.wrapT;
                if (options.wrapR !== undefined) values.wrapR = options.wrapR;
                if (options.magFilter !== undefined) values.magFilter = options.magFilter;
                if (options.minFilter !== undefined) values.minFilter = options.minFilter;
                if (options.format !== undefined) values.format = options.format;
                if (options.type !== undefined) values.type = options.type;
                if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
                if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
                if (options.flipY !== undefined) values.flipY = options.flipY;
                if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
                if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
                for(var i = 0; i < this.textures.length; i++){
                    var texture = this.textures[i];
                    texture.setValues(values);
                }
            }
        },
        {
            key: "texture",
            get: /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ function get() {
                return this.textures[0];
            },
            set: function set(value) {
                this.textures[0] = value;
            }
        },
        {
            key: "depthTexture",
            get: /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ function get() {
                return this._depthTexture;
            },
            set: function set(current) {
                if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
                if (current !== null) current.renderTarget = this;
                this._depthTexture = current;
            }
        },
        {
            /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ key: "setSize",
            value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                    this.width = width;
                    this.height = height;
                    this.depth = depth;
                    for(var i = 0, il = this.textures.length; i < il; i++){
                        this.textures[i].image.width = width;
                        this.textures[i].image.height = height;
                        this.textures[i].image.depth = depth;
                        this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
                    }
                    this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
            }
        },
        {
            /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.scissor.copy(source.scissor);
                this.scissorTest = source.scissorTest;
                this.viewport.copy(source.viewport);
                this.textures.length = 0;
                for(var i = 0, il = source.textures.length; i < il; i++){
                    this.textures[i] = source.textures[i].clone();
                    this.textures[i].isRenderTargetTexture = true;
                    this.textures[i].renderTarget = this;
                    // ensure image object is not shared, see #20328
                    var image = Object.assign({}, source.textures[i].image);
                    this.textures[i].source = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(image);
                }
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                this.resolveDepthBuffer = source.resolveDepthBuffer;
                this.resolveStencilBuffer = source.resolveStencilBuffer;
                if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
                this.samples = source.samples;
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return RenderTarget;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ var $a1724dcfba0d6d9a$export$3c052beb2e51e23f = /*#__PURE__*/ function(RenderTarget) {
    "use strict";
    (0, $i3fW3._)(WebGLRenderTarget, RenderTarget);
    function WebGLRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $jGAMp._)(this, WebGLRenderTarget);
        var _this;
        _this = (0, $kzDuW._)(this, WebGLRenderTarget, [
            width,
            height,
            options
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isWebGLRenderTarget = true;
        return _this;
    }
    return WebGLRenderTarget;
}($a1724dcfba0d6d9a$export$efcb1f8bf367cbfb);
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$dfac6c8e811406a3 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(DataArrayTexture, Texture);
    function DataArrayTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, DataArrayTexture);
        var _this;
        _this = (0, $kzDuW._)(this, DataArrayTexture, [
            null
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.magFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.minFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ _this.wrapR = $a1724dcfba0d6d9a$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ _this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ _this.layerUpdates = new Set();
        return _this;
    }
    (0, $byiyg._)(DataArrayTexture, [
        {
            /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ key: "addLayerUpdate",
            value: function addLayerUpdate(layerIndex) {
                this.layerUpdates.add(layerIndex);
            }
        },
        {
            /**
	 * Resets the layer updates registry.
	 */ key: "clearLayerUpdates",
            value: function clearLayerUpdates() {
                this.layerUpdates.clear();
            }
        }
    ]);
    return DataArrayTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ var $a1724dcfba0d6d9a$export$c77a02c11ed180c7 = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $i3fW3._)(WebGLArrayRenderTarget, WebGLRenderTarget);
    function WebGLArrayRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $jGAMp._)(this, WebGLArrayRenderTarget);
        var _this;
        _this = (0, $kzDuW._)(this, WebGLArrayRenderTarget, [
            width,
            height,
            options
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isWebGLArrayRenderTarget = true;
        _this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ _this.texture = new $a1724dcfba0d6d9a$export$dfac6c8e811406a3(null, width, height, depth);
        _this._setTextureOptions(options);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return WebGLArrayRenderTarget;
}($a1724dcfba0d6d9a$export$3c052beb2e51e23f);
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$d7a3086320f856db = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(Data3DTexture, Texture);
    function Data3DTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, Data3DTexture);
        var _this;
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        _this = (0, $kzDuW._)(this, Data3DTexture, [
            null
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.magFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.minFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ _this.wrapR = $a1724dcfba0d6d9a$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ _this.unpackAlignment = 1;
        return _this;
    }
    return Data3DTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ var $a1724dcfba0d6d9a$export$7ee06591009639df = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $i3fW3._)(WebGL3DRenderTarget, WebGLRenderTarget);
    function WebGL3DRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $jGAMp._)(this, WebGL3DRenderTarget);
        var _this;
        _this = (0, $kzDuW._)(this, WebGL3DRenderTarget, [
            width,
            height,
            options
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isWebGL3DRenderTarget = true;
        _this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ _this.texture = new $a1724dcfba0d6d9a$export$d7a3086320f856db(null, width, height, depth);
        _this._setTextureOptions(options);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return WebGL3DRenderTarget;
}($a1724dcfba0d6d9a$export$3c052beb2e51e23f);
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ var $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3 = /*#__PURE__*/ function() {
    "use strict";
    function Box3() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity);
        (0, $jGAMp._)(this, Box3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    (0, $byiyg._)(Box3, [
        {
            /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "setFromArray",
            value: function setFromArray(array) {
                this.makeEmpty();
                for(var i = 0, il = array.length; i < il; i += 3)this.expandByPoint($a1724dcfba0d6d9a$var$_vector$b.fromArray(array, i));
                return this;
            }
        },
        {
            /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "setFromBufferAttribute",
            value: function setFromBufferAttribute(attribute) {
                this.makeEmpty();
                for(var i = 0, il = attribute.count; i < il; i++)this.expandByPoint($a1724dcfba0d6d9a$var$_vector$b.fromBufferAttribute(attribute, i));
                return this;
            }
        },
        {
            /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $a1724dcfba0d6d9a$var$_vector$b.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "setFromObject",
            value: function setFromObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.makeEmpty();
                return this.expandByObject(object, precise);
            }
        },
        {
            /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = this.min.z = Infinity;
                this.max.x = this.max.y = this.max.z = -Infinity;
                return this;
            }
        },
        {
            /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
        },
        {
            /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "expandByObject",
            value: function expandByObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // Computes the world-axis-aligned bounding box of an object (including its children),
                // accounting for both the object's, and children's, world transforms
                object.updateWorldMatrix(false, false);
                var geometry = object.geometry;
                if (geometry !== undefined) {
                    var positionAttribute = geometry.getAttribute('position');
                    // precise AABB computation based on vertex data requires at least a position attribute.
                    // instancing isn't supported so far and uses the normal (conservative) code path.
                    if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(var i = 0, l = positionAttribute.count; i < l; i++){
                        if (object.isMesh === true) object.getVertexPosition(i, $a1724dcfba0d6d9a$var$_vector$b);
                        else $a1724dcfba0d6d9a$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                        $a1724dcfba0d6d9a$var$_vector$b.applyMatrix4(object.matrixWorld);
                        this.expandByPoint($a1724dcfba0d6d9a$var$_vector$b);
                    }
                    else {
                        if (object.boundingBox !== undefined) {
                            // object-level bounding box
                            if (object.boundingBox === null) object.computeBoundingBox();
                            $a1724dcfba0d6d9a$var$_box$4.copy(object.boundingBox);
                        } else {
                            // geometry-level bounding box
                            if (geometry.boundingBox === null) geometry.computeBoundingBox();
                            $a1724dcfba0d6d9a$var$_box$4.copy(geometry.boundingBox);
                        }
                        $a1724dcfba0d6d9a$var$_box$4.applyMatrix4(object.matrixWorld);
                        this.union($a1724dcfba0d6d9a$var$_box$4);
                    }
                }
                var children = object.children;
                for(var i1 = 0, l1 = children.length; i1 < l1; i1++)this.expandByObject(children[i1], precise);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ key: "containsPoint",
            value: function containsPoint(point) {
                return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
            }
        },
        {
            /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
            }
        },
        {
            /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
            }
        },
        {
            /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 6 splitting planes to rule out intersections.
                return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
            }
        },
        {
            /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                // Find the point on the AABB closest to the sphere center.
                this.clampPoint(sphere.center, $a1724dcfba0d6d9a$var$_vector$b);
                // If that point is inside the sphere, the AABB and sphere intersect.
                return $a1724dcfba0d6d9a$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // We compute the minimum and maximum dot product values. If those values
                // are on the same side (back or front) of the plane, then there is no intersection.
                var min, max;
                if (plane.normal.x > 0) {
                    min = plane.normal.x * this.min.x;
                    max = plane.normal.x * this.max.x;
                } else {
                    min = plane.normal.x * this.max.x;
                    max = plane.normal.x * this.min.x;
                }
                if (plane.normal.y > 0) {
                    min += plane.normal.y * this.min.y;
                    max += plane.normal.y * this.max.y;
                } else {
                    min += plane.normal.y * this.max.y;
                    max += plane.normal.y * this.min.y;
                }
                if (plane.normal.z > 0) {
                    min += plane.normal.z * this.min.z;
                    max += plane.normal.z * this.max.z;
                } else {
                    min += plane.normal.z * this.max.z;
                    max += plane.normal.z * this.min.z;
                }
                return min <= -plane.constant && max >= -plane.constant;
            }
        },
        {
            /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ key: "intersectsTriangle",
            value: function intersectsTriangle(triangle) {
                if (this.isEmpty()) return false;
                // compute box center and extents
                this.getCenter($a1724dcfba0d6d9a$var$_center);
                $a1724dcfba0d6d9a$var$_extents.subVectors(this.max, $a1724dcfba0d6d9a$var$_center);
                // translate triangle to aabb origin
                $a1724dcfba0d6d9a$var$_v0$2.subVectors(triangle.a, $a1724dcfba0d6d9a$var$_center);
                $a1724dcfba0d6d9a$var$_v1$7.subVectors(triangle.b, $a1724dcfba0d6d9a$var$_center);
                $a1724dcfba0d6d9a$var$_v2$4.subVectors(triangle.c, $a1724dcfba0d6d9a$var$_center);
                // compute edge vectors for triangle
                $a1724dcfba0d6d9a$var$_f0.subVectors($a1724dcfba0d6d9a$var$_v1$7, $a1724dcfba0d6d9a$var$_v0$2);
                $a1724dcfba0d6d9a$var$_f1.subVectors($a1724dcfba0d6d9a$var$_v2$4, $a1724dcfba0d6d9a$var$_v1$7);
                $a1724dcfba0d6d9a$var$_f2.subVectors($a1724dcfba0d6d9a$var$_v0$2, $a1724dcfba0d6d9a$var$_v2$4);
                // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
                // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
                // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
                var axes = [
                    0,
                    -$a1724dcfba0d6d9a$var$_f0.z,
                    $a1724dcfba0d6d9a$var$_f0.y,
                    0,
                    -$a1724dcfba0d6d9a$var$_f1.z,
                    $a1724dcfba0d6d9a$var$_f1.y,
                    0,
                    -$a1724dcfba0d6d9a$var$_f2.z,
                    $a1724dcfba0d6d9a$var$_f2.y,
                    $a1724dcfba0d6d9a$var$_f0.z,
                    0,
                    -$a1724dcfba0d6d9a$var$_f0.x,
                    $a1724dcfba0d6d9a$var$_f1.z,
                    0,
                    -$a1724dcfba0d6d9a$var$_f1.x,
                    $a1724dcfba0d6d9a$var$_f2.z,
                    0,
                    -$a1724dcfba0d6d9a$var$_f2.x,
                    -$a1724dcfba0d6d9a$var$_f0.y,
                    $a1724dcfba0d6d9a$var$_f0.x,
                    0,
                    -$a1724dcfba0d6d9a$var$_f1.y,
                    $a1724dcfba0d6d9a$var$_f1.x,
                    0,
                    -$a1724dcfba0d6d9a$var$_f2.y,
                    $a1724dcfba0d6d9a$var$_f2.x,
                    0
                ];
                if (!$a1724dcfba0d6d9a$var$satForAxes(axes, $a1724dcfba0d6d9a$var$_v0$2, $a1724dcfba0d6d9a$var$_v1$7, $a1724dcfba0d6d9a$var$_v2$4, $a1724dcfba0d6d9a$var$_extents)) return false;
                // test 3 face normals from the aabb
                axes = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ];
                if (!$a1724dcfba0d6d9a$var$satForAxes(axes, $a1724dcfba0d6d9a$var$_v0$2, $a1724dcfba0d6d9a$var$_v1$7, $a1724dcfba0d6d9a$var$_v2$4, $a1724dcfba0d6d9a$var$_extents)) return false;
                // finally testing the face normal of the triangle
                // use already existing triangle edge vectors here
                $a1724dcfba0d6d9a$var$_triangleNormal.crossVectors($a1724dcfba0d6d9a$var$_f0, $a1724dcfba0d6d9a$var$_f1);
                axes = [
                    $a1724dcfba0d6d9a$var$_triangleNormal.x,
                    $a1724dcfba0d6d9a$var$_triangleNormal.y,
                    $a1724dcfba0d6d9a$var$_triangleNormal.z
                ];
                return $a1724dcfba0d6d9a$var$satForAxes(axes, $a1724dcfba0d6d9a$var$_v0$2, $a1724dcfba0d6d9a$var$_v1$7, $a1724dcfba0d6d9a$var$_v2$4, $a1724dcfba0d6d9a$var$_extents);
            }
        },
        {
            /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.clampPoint(point, $a1724dcfba0d6d9a$var$_vector$b).distanceTo(point);
            }
        },
        {
            /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ key: "getBoundingSphere",
            value: function getBoundingSphere(target) {
                if (this.isEmpty()) target.makeEmpty();
                else {
                    this.getCenter(target.center);
                    target.radius = this.getSize($a1724dcfba0d6d9a$var$_vector$b).length() * 0.5;
                }
                return target;
            }
        },
        {
            /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
                if (this.isEmpty()) this.makeEmpty();
                return this;
            }
        },
        {
            /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                // transform of empty box is an empty box.
                if (this.isEmpty()) return this;
                // NOTE: I am using a binary pattern to specify all 2^3 combinations below
                $a1724dcfba0d6d9a$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
                $a1724dcfba0d6d9a$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
                $a1724dcfba0d6d9a$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
                $a1724dcfba0d6d9a$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
                $a1724dcfba0d6d9a$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
                $a1724dcfba0d6d9a$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
                $a1724dcfba0d6d9a$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
                $a1724dcfba0d6d9a$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
                this.setFromPoints($a1724dcfba0d6d9a$var$_points);
                return this;
            }
        },
        {
            /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        },
        {
            /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ key: "toJSON",
            value: function toJSON() {
                return {
                    min: this.min.toArray(),
                    max: this.max.toArray()
                };
            }
        },
        {
            /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ key: "fromJSON",
            value: function fromJSON(json) {
                this.min.fromArray(json.min);
                this.max.fromArray(json.max);
                return this;
            }
        }
    ]);
    return Box3;
}();
var $a1724dcfba0d6d9a$var$_points = [
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699()
];
var $a1724dcfba0d6d9a$var$_vector$b = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_box$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
// triangle centered vertices
var $a1724dcfba0d6d9a$var$_v0$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v1$7 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v2$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
// triangle edge vectors
var $a1724dcfba0d6d9a$var$_f0 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_f1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_f2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_center = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_extents = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_triangleNormal = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_testAxis = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
function $a1724dcfba0d6d9a$var$satForAxes(axes, v0, v1, v2, extents) {
    for(var i = 0, j = axes.length - 3; i <= j; i += 3){
        $a1724dcfba0d6d9a$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        var r = extents.x * Math.abs($a1724dcfba0d6d9a$var$_testAxis.x) + extents.y * Math.abs($a1724dcfba0d6d9a$var$_testAxis.y) + extents.z * Math.abs($a1724dcfba0d6d9a$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        var p0 = v0.dot($a1724dcfba0d6d9a$var$_testAxis);
        var p1 = v1.dot($a1724dcfba0d6d9a$var$_testAxis);
        var p2 = v2.dot($a1724dcfba0d6d9a$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
var $a1724dcfba0d6d9a$var$_box$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
var $a1724dcfba0d6d9a$var$_v1$6 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v2$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ var $a1724dcfba0d6d9a$export$805e8b72413ccaba = /*#__PURE__*/ function() {
    "use strict";
    function Sphere() {
        var center = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), radius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
        (0, $jGAMp._)(this, Sphere);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    (0, $byiyg._)(Sphere, [
        {
            /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "set",
            value: function set(center, radius) {
                this.center.copy(center);
                this.radius = radius;
                return this;
            }
        },
        {
            /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "setFromPoints",
            value: function setFromPoints(points, optionalCenter) {
                var center = this.center;
                if (optionalCenter !== undefined) center.copy(optionalCenter);
                else $a1724dcfba0d6d9a$var$_box$3.setFromPoints(points).getCenter(center);
                var maxRadiusSq = 0;
                for(var i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
                this.radius = Math.sqrt(maxRadiusSq);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "copy",
            value: function copy(sphere) {
                this.center.copy(sphere.center);
                this.radius = sphere.radius;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ key: "isEmpty",
            value: function isEmpty() {
                return this.radius < 0;
            }
        },
        {
            /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ key: "makeEmpty",
            value: function makeEmpty() {
                this.center.set(0, 0, 0);
                this.radius = -1;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ key: "containsPoint",
            value: function containsPoint(point) {
                return point.distanceToSquared(this.center) <= this.radius * this.radius;
            }
        },
        {
            /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return point.distanceTo(this.center) - this.radius;
            }
        },
        {
            /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var radiusSum = this.radius + sphere.radius;
                return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
            }
        },
        {
            /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsSphere(this);
            }
        },
        {
            /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
            }
        },
        {
            /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ key: "clampPoint",
            value: function clampPoint(point, target) {
                var deltaLengthSq = this.center.distanceToSquared(point);
                target.copy(point);
                if (deltaLengthSq > this.radius * this.radius) {
                    target.sub(this.center).normalize();
                    target.multiplyScalar(this.radius).add(this.center);
                }
                return target;
            }
        },
        {
            /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ key: "getBoundingBox",
            value: function getBoundingBox(target) {
                if (this.isEmpty()) {
                    // Empty sphere produces empty bounding box
                    target.makeEmpty();
                    return target;
                }
                target.set(this.center, this.center);
                target.expandByScalar(this.radius);
                return target;
            }
        },
        {
            /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.center.applyMatrix4(matrix);
                this.radius = this.radius * matrix.getMaxScaleOnAxis();
                return this;
            }
        },
        {
            /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "translate",
            value: function translate(offset) {
                this.center.add(offset);
                return this;
            }
        },
        {
            /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "expandByPoint",
            value: function expandByPoint(point) {
                if (this.isEmpty()) {
                    this.center.copy(point);
                    this.radius = 0;
                    return this;
                }
                $a1724dcfba0d6d9a$var$_v1$6.subVectors(point, this.center);
                var lengthSq = $a1724dcfba0d6d9a$var$_v1$6.lengthSq();
                if (lengthSq > this.radius * this.radius) {
                    // calculate the minimal sphere
                    var length = Math.sqrt(lengthSq);
                    var delta = (length - this.radius) * 0.5;
                    this.center.addScaledVector($a1724dcfba0d6d9a$var$_v1$6, delta / length);
                    this.radius += delta;
                }
                return this;
            }
        },
        {
            /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ key: "union",
            value: function union(sphere) {
                if (sphere.isEmpty()) return this;
                if (this.isEmpty()) {
                    this.copy(sphere);
                    return this;
                }
                if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
                else {
                    $a1724dcfba0d6d9a$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
                    this.expandByPoint($a1724dcfba0d6d9a$var$_v1$6.copy(sphere.center).add($a1724dcfba0d6d9a$var$_v2$3));
                    this.expandByPoint($a1724dcfba0d6d9a$var$_v1$6.copy(sphere.center).sub($a1724dcfba0d6d9a$var$_v2$3));
                }
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ key: "equals",
            value: function equals(sphere) {
                return sphere.center.equals(this.center) && sphere.radius === this.radius;
            }
        },
        {
            /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ key: "toJSON",
            value: function toJSON() {
                return {
                    radius: this.radius,
                    center: this.center.toArray()
                };
            }
        },
        {
            /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Box3} A reference to this bounding sphere.
	 */ key: "fromJSON",
            value: function fromJSON(json) {
                this.radius = json.radius;
                this.center.fromArray(json.center);
                return this;
            }
        }
    ]);
    return Sphere;
}();
var $a1724dcfba0d6d9a$var$_vector$a = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_segCenter = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_segDir = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_diff = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_edge1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_edge2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_normal$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ var $a1724dcfba0d6d9a$export$a186db52eed6d40e = /*#__PURE__*/ function() {
    "use strict";
    function Ray() {
        var origin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, -1);
        (0, $jGAMp._)(this, Ray);
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    (0, $byiyg._)(Ray, [
        {
            /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ key: "set",
            value: function set(origin, direction) {
                this.origin.copy(origin);
                this.direction.copy(direction);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ key: "copy",
            value: function copy(ray) {
                this.origin.copy(ray.origin);
                this.direction.copy(ray.direction);
                return this;
            }
        },
        {
            /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ key: "at",
            value: function at(t, target) {
                return target.copy(this.origin).addScaledVector(this.direction, t);
            }
        },
        {
            /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ key: "lookAt",
            value: function lookAt(v) {
                this.direction.copy(v).sub(this.origin).normalize();
                return this;
            }
        },
        {
            /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ key: "recast",
            value: function recast(t) {
                this.origin.copy(this.at(t, $a1724dcfba0d6d9a$var$_vector$a));
                return this;
            }
        },
        {
            /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ key: "closestPointToPoint",
            value: function closestPointToPoint(point, target) {
                target.subVectors(point, this.origin);
                var directionDistance = target.dot(this.direction);
                if (directionDistance < 0) return target.copy(this.origin);
                return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
            }
        },
        {
            /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return Math.sqrt(this.distanceSqToPoint(point));
            }
        },
        {
            /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ key: "distanceSqToPoint",
            value: function distanceSqToPoint(point) {
                var directionDistance = $a1724dcfba0d6d9a$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
                // point behind the ray
                if (directionDistance < 0) return this.origin.distanceToSquared(point);
                $a1724dcfba0d6d9a$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
                return $a1724dcfba0d6d9a$var$_vector$a.distanceToSquared(point);
            }
        },
        {
            /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ key: "distanceSqToSegment",
            value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
                // It returns the min distance between the ray and the segment
                // defined by v0 and v1
                // It can also set two optional targets :
                // - The closest point on the ray
                // - The closest point on the segment
                $a1724dcfba0d6d9a$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
                $a1724dcfba0d6d9a$var$_segDir.copy(v1).sub(v0).normalize();
                $a1724dcfba0d6d9a$var$_diff.copy(this.origin).sub($a1724dcfba0d6d9a$var$_segCenter);
                var segExtent = v0.distanceTo(v1) * 0.5;
                var a01 = -this.direction.dot($a1724dcfba0d6d9a$var$_segDir);
                var b0 = $a1724dcfba0d6d9a$var$_diff.dot(this.direction);
                var b1 = -$a1724dcfba0d6d9a$var$_diff.dot($a1724dcfba0d6d9a$var$_segDir);
                var c = $a1724dcfba0d6d9a$var$_diff.lengthSq();
                var det = Math.abs(1 - a01 * a01);
                var s0, s1, sqrDist, extDet;
                if (det > 0) {
                    // The ray and segment are not parallel.
                    s0 = a01 * b1 - b0;
                    s1 = a01 * b0 - b1;
                    extDet = segExtent * det;
                    if (s0 >= 0) {
                        if (s1 >= -extDet) {
                            if (s1 <= extDet) {
                                // region 0
                                // Minimum at interior points of ray and segment.
                                var invDet = 1 / det;
                                s0 *= invDet;
                                s1 *= invDet;
                                sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                            } else {
                                // region 1
                                s1 = segExtent;
                                s0 = Math.max(0, -(a01 * s1 + b0));
                                sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                            }
                        } else {
                            // region 5
                            s1 = -segExtent;
                            s0 = Math.max(0, -(a01 * s1 + b0));
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    } else {
                        if (s1 <= -extDet) {
                            // region 4
                            s0 = Math.max(0, -(-a01 * segExtent + b0));
                            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        } else if (s1 <= extDet) {
                            // region 3
                            s0 = 0;
                            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = s1 * (s1 + 2 * b1) + c;
                        } else {
                            // region 2
                            s0 = Math.max(0, -(a01 * segExtent + b0));
                            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    }
                } else {
                    // Ray and segment are parallel.
                    s1 = a01 > 0 ? -segExtent : segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
                if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
                if (optionalPointOnSegment) optionalPointOnSegment.copy($a1724dcfba0d6d9a$var$_segCenter).addScaledVector($a1724dcfba0d6d9a$var$_segDir, s1);
                return sqrDist;
            }
        },
        {
            /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ key: "intersectSphere",
            value: function intersectSphere(sphere, target) {
                $a1724dcfba0d6d9a$var$_vector$a.subVectors(sphere.center, this.origin);
                var tca = $a1724dcfba0d6d9a$var$_vector$a.dot(this.direction);
                var d2 = $a1724dcfba0d6d9a$var$_vector$a.dot($a1724dcfba0d6d9a$var$_vector$a) - tca * tca;
                var radius2 = sphere.radius * sphere.radius;
                if (d2 > radius2) return null;
                var thc = Math.sqrt(radius2 - d2);
                // t0 = first intersect point - entrance on front of sphere
                var t0 = tca - thc;
                // t1 = second intersect point - exit point on back of sphere
                var t1 = tca + thc;
                // test to see if t1 is behind the ray - if so, return null
                if (t1 < 0) return null;
                // test to see if t0 is behind the ray:
                // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
                // in order to always return an intersect point that is in front of the ray.
                if (t0 < 0) return this.at(t1, target);
                // else t0 is in front of the ray, so return the first collision point scaled by t0
                return this.at(t0, target);
            }
        },
        {
            /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                if (sphere.radius < 0) return false; // handle empty spheres, see #31187
                return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ key: "distanceToPlane",
            value: function distanceToPlane(plane) {
                var denominator = plane.normal.dot(this.direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (plane.distanceToPoint(this.origin) === 0) return 0;
                    // Null is preferable to undefined since undefined means.... it is undefined
                    return null;
                }
                var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
                // Return if the ray never intersects the plane
                return t >= 0 ? t : null;
            }
        },
        {
            /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ key: "intersectPlane",
            value: function intersectPlane(plane, target) {
                var t = this.distanceToPlane(plane);
                if (t === null) return null;
                return this.at(t, target);
            }
        },
        {
            /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // check if the ray lies on the plane first
                var distToPoint = plane.distanceToPoint(this.origin);
                if (distToPoint === 0) return true;
                var denominator = plane.normal.dot(this.direction);
                if (denominator * distToPoint < 0) return true;
                // ray origin is behind the plane (and is pointing behind it)
                return false;
            }
        },
        {
            /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ key: "intersectBox",
            value: function intersectBox(box, target) {
                var tmin, tmax, tymin, tymax, tzmin, tzmax;
                var invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
                var origin = this.origin;
                if (invdirx >= 0) {
                    tmin = (box.min.x - origin.x) * invdirx;
                    tmax = (box.max.x - origin.x) * invdirx;
                } else {
                    tmin = (box.max.x - origin.x) * invdirx;
                    tmax = (box.min.x - origin.x) * invdirx;
                }
                if (invdiry >= 0) {
                    tymin = (box.min.y - origin.y) * invdiry;
                    tymax = (box.max.y - origin.y) * invdiry;
                } else {
                    tymin = (box.max.y - origin.y) * invdiry;
                    tymax = (box.min.y - origin.y) * invdiry;
                }
                if (tmin > tymax || tymin > tmax) return null;
                if (tymin > tmin || isNaN(tmin)) tmin = tymin;
                if (tymax < tmax || isNaN(tmax)) tmax = tymax;
                if (invdirz >= 0) {
                    tzmin = (box.min.z - origin.z) * invdirz;
                    tzmax = (box.max.z - origin.z) * invdirz;
                } else {
                    tzmin = (box.max.z - origin.z) * invdirz;
                    tzmax = (box.min.z - origin.z) * invdirz;
                }
                if (tmin > tzmax || tzmin > tmax) return null;
                if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
                if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
                //return point closest to the ray (positive side)
                if (tmax < 0) return null;
                return this.at(tmin >= 0 ? tmin : tmax, target);
            }
        },
        {
            /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                return this.intersectBox(box, $a1724dcfba0d6d9a$var$_vector$a) !== null;
            }
        },
        {
            /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ key: "intersectTriangle",
            value: function intersectTriangle(a, b, c, backfaceCulling, target) {
                // Compute the offset origin, edges, and normal.
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
                $a1724dcfba0d6d9a$var$_edge1.subVectors(b, a);
                $a1724dcfba0d6d9a$var$_edge2.subVectors(c, a);
                $a1724dcfba0d6d9a$var$_normal$1.crossVectors($a1724dcfba0d6d9a$var$_edge1, $a1724dcfba0d6d9a$var$_edge2);
                // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
                // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
                //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
                //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
                //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
                var DdN = this.direction.dot($a1724dcfba0d6d9a$var$_normal$1);
                var sign;
                if (DdN > 0) {
                    if (backfaceCulling) return null;
                    sign = 1;
                } else if (DdN < 0) {
                    sign = -1;
                    DdN = -DdN;
                } else return null;
                $a1724dcfba0d6d9a$var$_diff.subVectors(this.origin, a);
                var DdQxE2 = sign * this.direction.dot($a1724dcfba0d6d9a$var$_edge2.crossVectors($a1724dcfba0d6d9a$var$_diff, $a1724dcfba0d6d9a$var$_edge2));
                // b1 < 0, no intersection
                if (DdQxE2 < 0) return null;
                var DdE1xQ = sign * this.direction.dot($a1724dcfba0d6d9a$var$_edge1.cross($a1724dcfba0d6d9a$var$_diff));
                // b2 < 0, no intersection
                if (DdE1xQ < 0) return null;
                // b1+b2 > 1, no intersection
                if (DdQxE2 + DdE1xQ > DdN) return null;
                // Line intersects triangle, check if ray does.
                var QdN = -sign * $a1724dcfba0d6d9a$var$_diff.dot($a1724dcfba0d6d9a$var$_normal$1);
                // t < 0, no intersection
                if (QdN < 0) return null;
                // Ray intersects triangle.
                return this.at(QdN / DdN, target);
            }
        },
        {
            /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix4) {
                this.origin.applyMatrix4(matrix4);
                this.direction.transformDirection(matrix4);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ key: "equals",
            value: function equals(ray) {
                return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
            }
        },
        {
            /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Ray;
}();
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial]{@link https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices}
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ var $a1724dcfba0d6d9a$export$2ae72fc923e5eb5 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix4(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        (0, $jGAMp._)(this, Matrix4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix4.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    (0, $byiyg._)(Matrix4, [
        {
            /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "set",
            value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
                var te = this.elements;
                te[0] = n11;
                te[4] = n12;
                te[8] = n13;
                te[12] = n14;
                te[1] = n21;
                te[5] = n22;
                te[9] = n23;
                te[13] = n24;
                te[2] = n31;
                te[6] = n32;
                te[10] = n33;
                te[14] = n34;
                te[3] = n41;
                te[7] = n42;
                te[11] = n43;
                te[15] = n44;
                return this;
            }
        },
        {
            /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new Matrix4().fromArray(this.elements);
            }
        },
        {
            /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                te[9] = me[9];
                te[10] = me[10];
                te[11] = me[11];
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                te[15] = me[15];
                return this;
            }
        },
        {
            /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "copyPosition",
            value: function copyPosition(m) {
                var te = this.elements, me = m.elements;
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                return this;
            }
        },
        {
            /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "setFromMatrix3",
            value: function setFromMatrix3(m) {
                var me = m.elements;
                this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrixColumn(this, 0);
                yAxis.setFromMatrixColumn(this, 1);
                zAxis.setFromMatrixColumn(this, 2);
                return this;
            }
        },
        {
            /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeBasis",
            value: function makeBasis(xAxis, yAxis, zAxis) {
                this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "extractRotation",
            value: function extractRotation(m) {
                var te = this.elements;
                var me = m.elements;
                var scaleX = 1 / $a1724dcfba0d6d9a$var$_v1$5.setFromMatrixColumn(m, 0).length();
                var scaleY = 1 / $a1724dcfba0d6d9a$var$_v1$5.setFromMatrixColumn(m, 1).length();
                var scaleZ = 1 / $a1724dcfba0d6d9a$var$_v1$5.setFromMatrixColumn(m, 2).length();
                te[0] = me[0] * scaleX;
                te[1] = me[1] * scaleX;
                te[2] = me[2] * scaleX;
                te[3] = 0;
                te[4] = me[4] * scaleY;
                te[5] = me[5] * scaleY;
                te[6] = me[6] * scaleY;
                te[7] = 0;
                te[8] = me[8] * scaleZ;
                te[9] = me[9] * scaleZ;
                te[10] = me[10] * scaleZ;
                te[11] = 0;
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationFromEuler",
            value: function makeRotationFromEuler(euler) {
                var te = this.elements;
                var x = euler.x, y = euler.y, z = euler.z;
                var a = Math.cos(x), b = Math.sin(x);
                var c = Math.cos(y), d = Math.sin(y);
                var e = Math.cos(z), f = Math.sin(z);
                if (euler.order === 'XYZ') {
                    var ae = a * e, af = a * f, be = b * e, bf = b * f;
                    te[0] = c * e;
                    te[4] = -c * f;
                    te[8] = d;
                    te[1] = af + be * d;
                    te[5] = ae - bf * d;
                    te[9] = -b * c;
                    te[2] = bf - ae * d;
                    te[6] = be + af * d;
                    te[10] = a * c;
                } else if (euler.order === 'YXZ') {
                    var ce = c * e, cf = c * f, de = d * e, df = d * f;
                    te[0] = ce + df * b;
                    te[4] = de * b - cf;
                    te[8] = a * d;
                    te[1] = a * f;
                    te[5] = a * e;
                    te[9] = -b;
                    te[2] = cf * b - de;
                    te[6] = df + ce * b;
                    te[10] = a * c;
                } else if (euler.order === 'ZXY') {
                    var ce1 = c * e, cf1 = c * f, de1 = d * e, df1 = d * f;
                    te[0] = ce1 - df1 * b;
                    te[4] = -a * f;
                    te[8] = de1 + cf1 * b;
                    te[1] = cf1 + de1 * b;
                    te[5] = a * e;
                    te[9] = df1 - ce1 * b;
                    te[2] = -a * d;
                    te[6] = b;
                    te[10] = a * c;
                } else if (euler.order === 'ZYX') {
                    var ae1 = a * e, af1 = a * f, be1 = b * e, bf1 = b * f;
                    te[0] = c * e;
                    te[4] = be1 * d - af1;
                    te[8] = ae1 * d + bf1;
                    te[1] = c * f;
                    te[5] = bf1 * d + ae1;
                    te[9] = af1 * d - be1;
                    te[2] = -d;
                    te[6] = b * c;
                    te[10] = a * c;
                } else if (euler.order === 'YZX') {
                    var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
                    te[0] = c * e;
                    te[4] = bd - ac * f;
                    te[8] = bc * f + ad;
                    te[1] = f;
                    te[5] = a * e;
                    te[9] = -b * e;
                    te[2] = -d * e;
                    te[6] = ad * f + bc;
                    te[10] = ac - bd * f;
                } else if (euler.order === 'XZY') {
                    var ac1 = a * c, ad1 = a * d, bc1 = b * c, bd1 = b * d;
                    te[0] = c * e;
                    te[4] = -f;
                    te[8] = d * e;
                    te[1] = ac1 * f + bd1;
                    te[5] = a * e;
                    te[9] = ad1 * f - bc1;
                    te[2] = bc1 * f - ad1;
                    te[6] = b * e;
                    te[10] = bd1 * f + ac1;
                }
                // bottom row
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                // last column
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationFromQuaternion",
            value: function makeRotationFromQuaternion(q) {
                return this.compose($a1724dcfba0d6d9a$var$_zero, q, $a1724dcfba0d6d9a$var$_one);
            }
        },
        {
            /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "lookAt",
            value: function lookAt(eye, target, up) {
                var te = this.elements;
                $a1724dcfba0d6d9a$var$_z.subVectors(eye, target);
                if ($a1724dcfba0d6d9a$var$_z.lengthSq() === 0) // eye and target are in the same position
                $a1724dcfba0d6d9a$var$_z.z = 1;
                $a1724dcfba0d6d9a$var$_z.normalize();
                $a1724dcfba0d6d9a$var$_x.crossVectors(up, $a1724dcfba0d6d9a$var$_z);
                if ($a1724dcfba0d6d9a$var$_x.lengthSq() === 0) {
                    // up and z are parallel
                    if (Math.abs(up.z) === 1) $a1724dcfba0d6d9a$var$_z.x += 0.0001;
                    else $a1724dcfba0d6d9a$var$_z.z += 0.0001;
                    $a1724dcfba0d6d9a$var$_z.normalize();
                    $a1724dcfba0d6d9a$var$_x.crossVectors(up, $a1724dcfba0d6d9a$var$_z);
                }
                $a1724dcfba0d6d9a$var$_x.normalize();
                $a1724dcfba0d6d9a$var$_y.crossVectors($a1724dcfba0d6d9a$var$_z, $a1724dcfba0d6d9a$var$_x);
                te[0] = $a1724dcfba0d6d9a$var$_x.x;
                te[4] = $a1724dcfba0d6d9a$var$_y.x;
                te[8] = $a1724dcfba0d6d9a$var$_z.x;
                te[1] = $a1724dcfba0d6d9a$var$_x.y;
                te[5] = $a1724dcfba0d6d9a$var$_y.y;
                te[9] = $a1724dcfba0d6d9a$var$_z.y;
                te[2] = $a1724dcfba0d6d9a$var$_x.z;
                te[6] = $a1724dcfba0d6d9a$var$_y.z;
                te[10] = $a1724dcfba0d6d9a$var$_z.z;
                return this;
            }
        },
        {
            /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "multiply",
            value: function multiply(m) {
                return this.multiplyMatrices(this, m);
            }
        },
        {
            /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
                var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
                var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
                var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
                var b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
                var b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
                var b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
                var b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                return this;
            }
        },
        {
            /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[4] *= s;
                te[8] *= s;
                te[12] *= s;
                te[1] *= s;
                te[5] *= s;
                te[9] *= s;
                te[13] *= s;
                te[2] *= s;
                te[6] *= s;
                te[10] *= s;
                te[14] *= s;
                te[3] *= s;
                te[7] *= s;
                te[11] *= s;
                te[15] *= s;
                return this;
            }
        },
        {
            /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
	 *
	 * @return {number} The determinant.
	 */ key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
                var n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
                var n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
                var n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
                //TODO: make this more efficient
                return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
            }
        },
        {
            /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "transpose",
            value: function transpose() {
                var te = this.elements;
                var tmp;
                tmp = te[1];
                te[1] = te[4];
                te[4] = tmp;
                tmp = te[2];
                te[2] = te[8];
                te[8] = tmp;
                tmp = te[6];
                te[6] = te[9];
                te[9] = tmp;
                tmp = te[3];
                te[3] = te[12];
                te[12] = tmp;
                tmp = te[7];
                te[7] = te[13];
                te[13] = tmp;
                tmp = te[11];
                te[11] = te[14];
                te[14] = tmp;
                return this;
            }
        },
        {
            /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "setPosition",
            value: function setPosition(x, y, z) {
                var te = this.elements;
                if (x.isVector3) {
                    te[12] = x.x;
                    te[13] = x.y;
                    te[14] = x.z;
                } else {
                    te[12] = x;
                    te[13] = y;
                    te[14] = z;
                }
                return this;
            }
        },
        {
            /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "invert",
            value: function invert() {
                // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
                var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
                te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
                te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
                te[4] = t12 * detInv;
                te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
                te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
                te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
                te[8] = t13 * detInv;
                te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
                te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
                te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
                te[12] = t14 * detInv;
                te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
                te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
                te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
                return this;
            }
        },
        {
            /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "scale",
            value: function scale(v) {
                var te = this.elements;
                var x = v.x, y = v.y, z = v.z;
                te[0] *= x;
                te[4] *= y;
                te[8] *= z;
                te[1] *= x;
                te[5] *= y;
                te[9] *= z;
                te[2] *= x;
                te[6] *= y;
                te[10] *= z;
                te[3] *= x;
                te[7] *= y;
                te[11] *= z;
                return this;
            }
        },
        {
            /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ key: "getMaxScaleOnAxis",
            value: function getMaxScaleOnAxis() {
                var te = this.elements;
                var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
                var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
                var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
                return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
            }
        },
        {
            /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeTranslation",
            value: function makeTranslation(x, y, z) {
                if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
                else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationX",
            value: function makeRotationX(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationY",
            value: function makeRotationY(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationZ",
            value: function makeRotationZ(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeRotationAxis",
            value: function makeRotationAxis(axis, angle) {
                // Based on http://www.gamedev.net/reference/articles/article1199.asp
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var t = 1 - c;
                var x = axis.x, y = axis.y, z = axis.z;
                var tx = t * x, ty = t * y;
                this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeScale",
            value: function makeScale(x, y, z) {
                this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeShear",
            value: function makeShear(xy, xz, yx, yz, zx, zy) {
                this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "compose",
            value: function compose(position, quaternion, scale) {
                var te = this.elements;
                var x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
                var x2 = x + x, y2 = y + y, z2 = z + z;
                var xx = x * x2, xy = x * y2, xz = x * z2;
                var yy = y * y2, yz = y * z2, zz = z * z2;
                var wx = w * x2, wy = w * y2, wz = w * z2;
                var sx = scale.x, sy = scale.y, sz = scale.z;
                te[0] = (1 - (yy + zz)) * sx;
                te[1] = (xy + wz) * sx;
                te[2] = (xz - wy) * sx;
                te[3] = 0;
                te[4] = (xy - wz) * sy;
                te[5] = (1 - (xx + zz)) * sy;
                te[6] = (yz + wx) * sy;
                te[7] = 0;
                te[8] = (xz + wy) * sz;
                te[9] = (yz - wx) * sz;
                te[10] = (1 - (xx + yy)) * sz;
                te[11] = 0;
                te[12] = position.x;
                te[13] = position.y;
                te[14] = position.z;
                te[15] = 1;
                return this;
            }
        },
        {
            /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "decompose",
            value: function decompose(position, quaternion, scale) {
                var te = this.elements;
                var sx = $a1724dcfba0d6d9a$var$_v1$5.set(te[0], te[1], te[2]).length();
                var sy = $a1724dcfba0d6d9a$var$_v1$5.set(te[4], te[5], te[6]).length();
                var sz = $a1724dcfba0d6d9a$var$_v1$5.set(te[8], te[9], te[10]).length();
                // if determine is negative, we need to invert one scale
                var det = this.determinant();
                if (det < 0) sx = -sx;
                position.x = te[12];
                position.y = te[13];
                position.z = te[14];
                // scale the rotation part
                $a1724dcfba0d6d9a$var$_m1$2.copy(this);
                var invSX = 1 / sx;
                var invSY = 1 / sy;
                var invSZ = 1 / sz;
                $a1724dcfba0d6d9a$var$_m1$2.elements[0] *= invSX;
                $a1724dcfba0d6d9a$var$_m1$2.elements[1] *= invSX;
                $a1724dcfba0d6d9a$var$_m1$2.elements[2] *= invSX;
                $a1724dcfba0d6d9a$var$_m1$2.elements[4] *= invSY;
                $a1724dcfba0d6d9a$var$_m1$2.elements[5] *= invSY;
                $a1724dcfba0d6d9a$var$_m1$2.elements[6] *= invSY;
                $a1724dcfba0d6d9a$var$_m1$2.elements[8] *= invSZ;
                $a1724dcfba0d6d9a$var$_m1$2.elements[9] *= invSZ;
                $a1724dcfba0d6d9a$var$_m1$2.elements[10] *= invSZ;
                quaternion.setFromRotationMatrix($a1724dcfba0d6d9a$var$_m1$2);
                scale.x = sx;
                scale.y = sy;
                scale.z = sz;
                return this;
            }
        },
        {
            /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makePerspective",
            value: function makePerspective(left, right, top, bottom, near, far) {
                var coordinateSystem = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $a1724dcfba0d6d9a$export$5a0e9190d10875d3;
                var te = this.elements;
                var x = 2 * near / (right - left);
                var y = 2 * near / (top - bottom);
                var a = (right + left) / (right - left);
                var b = (top + bottom) / (top - bottom);
                var c, d;
                if (coordinateSystem === $a1724dcfba0d6d9a$export$5a0e9190d10875d3) {
                    c = -(far + near) / (far - near);
                    d = -2 * far * near / (far - near);
                } else if (coordinateSystem === $a1724dcfba0d6d9a$export$cc83beedcb9be9ac) {
                    c = -far / (far - near);
                    d = -far * near / (far - near);
                } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
                te[0] = x;
                te[4] = 0;
                te[8] = a;
                te[12] = 0;
                te[1] = 0;
                te[5] = y;
                te[9] = b;
                te[13] = 0;
                te[2] = 0;
                te[6] = 0;
                te[10] = c;
                te[14] = d;
                te[3] = 0;
                te[7] = 0;
                te[11] = -1;
                te[15] = 0;
                return this;
            }
        },
        {
            /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "makeOrthographic",
            value: function makeOrthographic(left, right, top, bottom, near, far) {
                var coordinateSystem = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $a1724dcfba0d6d9a$export$5a0e9190d10875d3;
                var te = this.elements;
                var w = 1.0 / (right - left);
                var h = 1.0 / (top - bottom);
                var p = 1.0 / (far - near);
                var x = (right + left) * w;
                var y = (top + bottom) * h;
                var z, zInv;
                if (coordinateSystem === $a1724dcfba0d6d9a$export$5a0e9190d10875d3) {
                    z = (far + near) * p;
                    zInv = -2 * p;
                } else if (coordinateSystem === $a1724dcfba0d6d9a$export$cc83beedcb9be9ac) {
                    z = near * p;
                    zInv = -1 * p;
                } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
                te[0] = 2 * w;
                te[4] = 0;
                te[8] = 0;
                te[12] = -x;
                te[1] = 0;
                te[5] = 2 * h;
                te[9] = 0;
                te[13] = -y;
                te[2] = 0;
                te[6] = 0;
                te[10] = zInv;
                te[14] = -z;
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 16; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 16; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                array[offset + 9] = te[9];
                array[offset + 10] = te[10];
                array[offset + 11] = te[11];
                array[offset + 12] = te[12];
                array[offset + 13] = te[13];
                array[offset + 14] = te[14];
                array[offset + 15] = te[15];
                return array;
            }
        }
    ]);
    return Matrix4;
}();
var $a1724dcfba0d6d9a$var$_v1$5 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_m1$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_zero = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 0);
var $a1724dcfba0d6d9a$var$_one = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 1, 1);
var $a1724dcfba0d6d9a$var$_x = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_y = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_z = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_matrix$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_quaternion$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ var $a1724dcfba0d6d9a$export$d93cc409a0768c5f = /*#__PURE__*/ function() {
    "use strict";
    function Euler() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Euler.DEFAULT_ORDER;
        (0, $jGAMp._)(this, Euler);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    (0, $byiyg._)(Euler, [
        {
            key: "x",
            get: /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "order",
            get: /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ function get() {
                return this._order;
            },
            set: function set(value) {
                this._order = value;
                this._onChangeCallback();
            }
        },
        {
            /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "set",
            value: function set(x, y, z) {
                var order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this._order;
                this._x = x;
                this._y = y;
                this._z = z;
                this._order = order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
        },
        {
            /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "copy",
            value: function copy(euler) {
                this._x = euler._x;
                this._y = euler._y;
                this._z = euler._z;
                this._order = euler._order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order, update = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var te = m.elements;
                var m11 = te[0], m12 = te[4], m13 = te[8];
                var m21 = te[1], m22 = te[5], m23 = te[9];
                var m31 = te[2], m32 = te[6], m33 = te[10];
                switch(order){
                    case 'XYZ':
                        this._y = Math.asin($a1724dcfba0d6d9a$var$clamp(m13, -1, 1));
                        if (Math.abs(m13) < 0.9999999) {
                            this._x = Math.atan2(-m23, m33);
                            this._z = Math.atan2(-m12, m11);
                        } else {
                            this._x = Math.atan2(m32, m22);
                            this._z = 0;
                        }
                        break;
                    case 'YXZ':
                        this._x = Math.asin(-$a1724dcfba0d6d9a$var$clamp(m23, -1, 1));
                        if (Math.abs(m23) < 0.9999999) {
                            this._y = Math.atan2(m13, m33);
                            this._z = Math.atan2(m21, m22);
                        } else {
                            this._y = Math.atan2(-m31, m11);
                            this._z = 0;
                        }
                        break;
                    case 'ZXY':
                        this._x = Math.asin($a1724dcfba0d6d9a$var$clamp(m32, -1, 1));
                        if (Math.abs(m32) < 0.9999999) {
                            this._y = Math.atan2(-m31, m33);
                            this._z = Math.atan2(-m12, m22);
                        } else {
                            this._y = 0;
                            this._z = Math.atan2(m21, m11);
                        }
                        break;
                    case 'ZYX':
                        this._y = Math.asin(-$a1724dcfba0d6d9a$var$clamp(m31, -1, 1));
                        if (Math.abs(m31) < 0.9999999) {
                            this._x = Math.atan2(m32, m33);
                            this._z = Math.atan2(m21, m11);
                        } else {
                            this._x = 0;
                            this._z = Math.atan2(-m12, m22);
                        }
                        break;
                    case 'YZX':
                        this._z = Math.asin($a1724dcfba0d6d9a$var$clamp(m21, -1, 1));
                        if (Math.abs(m21) < 0.9999999) {
                            this._x = Math.atan2(-m23, m22);
                            this._y = Math.atan2(-m31, m11);
                        } else {
                            this._x = 0;
                            this._y = Math.atan2(m13, m33);
                        }
                        break;
                    case 'XZY':
                        this._z = Math.asin(-$a1724dcfba0d6d9a$var$clamp(m12, -1, 1));
                        if (Math.abs(m12) < 0.9999999) {
                            this._x = Math.atan2(m32, m22);
                            this._y = Math.atan2(m13, m11);
                        } else {
                            this._x = Math.atan2(-m23, m33);
                            this._y = 0;
                        }
                        break;
                    default:
                        console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
                }
                this._order = order;
                if (update === true) this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "setFromQuaternion",
            value: function setFromQuaternion(q, order, update) {
                $a1724dcfba0d6d9a$var$_matrix$2.makeRotationFromQuaternion(q);
                return this.setFromRotationMatrix($a1724dcfba0d6d9a$var$_matrix$2, order, update);
            }
        },
        {
            /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "setFromVector3",
            value: function setFromVector3(v) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order;
                return this.set(v.x, v.y, v.z, order);
            }
        },
        {
            /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "reorder",
            value: function reorder(newOrder) {
                $a1724dcfba0d6d9a$var$_quaternion$3.setFromEuler(this);
                return this.setFromQuaternion($a1724dcfba0d6d9a$var$_quaternion$3, newOrder);
            }
        },
        {
            /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ key: "equals",
            value: function equals(euler) {
                return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
            }
        },
        {
            /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ key: "fromArray",
            value: function fromArray(array) {
                this._x = array[0];
                this._y = array[1];
                this._z = array[2];
                if (array[3] !== undefined) this._order = array[3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._order;
                return array;
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this._x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this._y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this._z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this._order
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Euler;
}();
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $a1724dcfba0d6d9a$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ var $a1724dcfba0d6d9a$export$89312ce47c0ca777 = /*#__PURE__*/ function() {
    "use strict";
    function Layers() {
        (0, $jGAMp._)(this, Layers);
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    (0, $byiyg._)(Layers, [
        {
            /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ key: "set",
            value: function set(layer) {
                this.mask = (1 << layer | 0) >>> 0;
            }
        },
        {
            /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ key: "enable",
            value: function enable(layer) {
                this.mask |= 1 << layer | 0;
            }
        },
        {
            /**
	 * Adds membership to all layers.
	 */ key: "enableAll",
            value: function enableAll() {
                this.mask = -1;
            }
        },
        {
            /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ key: "toggle",
            value: function toggle(layer) {
                this.mask ^= 1 << layer | 0;
            }
        },
        {
            /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ key: "disable",
            value: function disable(layer) {
                this.mask &= ~(1 << layer | 0);
            }
        },
        {
            /**
	 * Removes the membership from all layers.
	 */ key: "disableAll",
            value: function disableAll() {
                this.mask = 0;
            }
        },
        {
            /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ key: "test",
            value: function test(layers) {
                return (this.mask & layers.mask) !== 0;
            }
        },
        {
            /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ key: "isEnabled",
            value: function isEnabled(layer) {
                return (this.mask & (1 << layer | 0)) !== 0;
            }
        }
    ]);
    return Layers;
}();
var $a1724dcfba0d6d9a$var$_object3DId = 0;
var $a1724dcfba0d6d9a$var$_v1$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_q1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
var $a1724dcfba0d6d9a$var$_m1$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_target = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_position$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_scale$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_quaternion$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
var $a1724dcfba0d6d9a$var$_xAxis = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 0, 0);
var $a1724dcfba0d6d9a$var$_yAxis = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0);
var $a1724dcfba0d6d9a$var$_zAxis = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ var $a1724dcfba0d6d9a$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ var $a1724dcfba0d6d9a$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ var $a1724dcfba0d6d9a$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ var $a1724dcfba0d6d9a$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$e4dd07dff30cc924 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(Object3D, EventDispatcher);
    function Object3D() {
        (0, $jGAMp._)(this, Object3D);
        var _this;
        var onRotationChange = function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        };
        var onQuaternionChange = function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        };
        _this = (0, $kzDuW._)(this, Object3D);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(_this, 'id', {
            value: $a1724dcfba0d6d9a$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ _this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ _this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ _this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ _this.up = Object3D.DEFAULT_UP.clone();
        var position = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var rotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        var quaternion = new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
        var scale = new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 1, 1);
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(_this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $a1724dcfba0d6d9a$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ _this.matrix = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ _this.matrixWorld = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ _this.layers = new $a1724dcfba0d6d9a$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ _this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ _this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ _this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ _this.userData = {};
        return _this;
    }
    (0, $byiyg._)(Object3D, [
        {
            /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ key: "onBeforeShadow",
            value: function onBeforeShadow() {}
        },
        {
            /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ key: "onAfterShadow",
            value: function onAfterShadow() {}
        },
        {
            /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ key: "onBeforeRender",
            value: function onBeforeRender() {}
        },
        {
            /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ key: "onAfterRender",
            value: function onAfterRender() {}
        },
        {
            /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                this.matrix.premultiply(matrix);
                this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
        },
        {
            /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ key: "applyQuaternion",
            value: function applyQuaternion(q) {
                this.quaternion.premultiply(q);
                return this;
            }
        },
        {
            /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ key: "setRotationFromAxisAngle",
            value: function setRotationFromAxisAngle(axis, angle) {
                // assumes axis is normalized
                this.quaternion.setFromAxisAngle(axis, angle);
            }
        },
        {
            /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ key: "setRotationFromEuler",
            value: function setRotationFromEuler(euler) {
                this.quaternion.setFromEuler(euler, true);
            }
        },
        {
            /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ key: "setRotationFromMatrix",
            value: function setRotationFromMatrix(m) {
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                this.quaternion.setFromRotationMatrix(m);
            }
        },
        {
            /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ key: "setRotationFromQuaternion",
            value: function setRotationFromQuaternion(q) {
                // assumes q is normalized
                this.quaternion.copy(q);
            }
        },
        {
            /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ key: "rotateOnAxis",
            value: function rotateOnAxis(axis, angle) {
                // rotate object on axis in object space
                // axis is assumed to be normalized
                $a1724dcfba0d6d9a$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.multiply($a1724dcfba0d6d9a$var$_q1);
                return this;
            }
        },
        {
            /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ key: "rotateOnWorldAxis",
            value: function rotateOnWorldAxis(axis, angle) {
                // rotate object on axis in world space
                // axis is assumed to be normalized
                // method assumes no rotated parent
                $a1724dcfba0d6d9a$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.premultiply($a1724dcfba0d6d9a$var$_q1);
                return this;
            }
        },
        {
            /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ key: "rotateX",
            value: function rotateX(angle) {
                return this.rotateOnAxis($a1724dcfba0d6d9a$var$_xAxis, angle);
            }
        },
        {
            /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ key: "rotateY",
            value: function rotateY(angle) {
                return this.rotateOnAxis($a1724dcfba0d6d9a$var$_yAxis, angle);
            }
        },
        {
            /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ key: "rotateZ",
            value: function rotateZ(angle) {
                return this.rotateOnAxis($a1724dcfba0d6d9a$var$_zAxis, angle);
            }
        },
        {
            /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ key: "translateOnAxis",
            value: function translateOnAxis(axis, distance) {
                // translate object by distance along axis in object space
                // axis is assumed to be normalized
                $a1724dcfba0d6d9a$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
                this.position.add($a1724dcfba0d6d9a$var$_v1$4.multiplyScalar(distance));
                return this;
            }
        },
        {
            /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ key: "translateX",
            value: function translateX(distance) {
                return this.translateOnAxis($a1724dcfba0d6d9a$var$_xAxis, distance);
            }
        },
        {
            /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ key: "translateY",
            value: function translateY(distance) {
                return this.translateOnAxis($a1724dcfba0d6d9a$var$_yAxis, distance);
            }
        },
        {
            /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ key: "translateZ",
            value: function translateZ(distance) {
                return this.translateOnAxis($a1724dcfba0d6d9a$var$_zAxis, distance);
            }
        },
        {
            /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ key: "localToWorld",
            value: function localToWorld(vector) {
                this.updateWorldMatrix(true, false);
                return vector.applyMatrix4(this.matrixWorld);
            }
        },
        {
            /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ key: "worldToLocal",
            value: function worldToLocal(vector) {
                this.updateWorldMatrix(true, false);
                return vector.applyMatrix4($a1724dcfba0d6d9a$var$_m1$1.copy(this.matrixWorld).invert());
            }
        },
        {
            /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ key: "lookAt",
            value: function lookAt(x, y, z) {
                // This method does not support objects having non-uniformly-scaled parent(s)
                if (x.isVector3) $a1724dcfba0d6d9a$var$_target.copy(x);
                else $a1724dcfba0d6d9a$var$_target.set(x, y, z);
                var parent = this.parent;
                this.updateWorldMatrix(true, false);
                $a1724dcfba0d6d9a$var$_position$3.setFromMatrixPosition(this.matrixWorld);
                if (this.isCamera || this.isLight) $a1724dcfba0d6d9a$var$_m1$1.lookAt($a1724dcfba0d6d9a$var$_position$3, $a1724dcfba0d6d9a$var$_target, this.up);
                else $a1724dcfba0d6d9a$var$_m1$1.lookAt($a1724dcfba0d6d9a$var$_target, $a1724dcfba0d6d9a$var$_position$3, this.up);
                this.quaternion.setFromRotationMatrix($a1724dcfba0d6d9a$var$_m1$1);
                if (parent) {
                    $a1724dcfba0d6d9a$var$_m1$1.extractRotation(parent.matrixWorld);
                    $a1724dcfba0d6d9a$var$_q1.setFromRotationMatrix($a1724dcfba0d6d9a$var$_m1$1);
                    this.quaternion.premultiply($a1724dcfba0d6d9a$var$_q1.invert());
                }
            }
        },
        {
            /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ key: "add",
            value: function add(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
                    return this;
                }
                if (object === this) {
                    console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
                    return this;
                }
                if (object && object.isObject3D) {
                    object.removeFromParent();
                    object.parent = this;
                    this.children.push(object);
                    object.dispatchEvent($a1724dcfba0d6d9a$var$_addedEvent);
                    $a1724dcfba0d6d9a$var$_childaddedEvent.child = object;
                    this.dispatchEvent($a1724dcfba0d6d9a$var$_childaddedEvent);
                    $a1724dcfba0d6d9a$var$_childaddedEvent.child = null;
                } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
                return this;
            }
        },
        {
            /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ key: "remove",
            value: function remove(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.remove(arguments[i]);
                    return this;
                }
                var index = this.children.indexOf(object);
                if (index !== -1) {
                    object.parent = null;
                    this.children.splice(index, 1);
                    object.dispatchEvent($a1724dcfba0d6d9a$var$_removedEvent);
                    $a1724dcfba0d6d9a$var$_childremovedEvent.child = object;
                    this.dispatchEvent($a1724dcfba0d6d9a$var$_childremovedEvent);
                    $a1724dcfba0d6d9a$var$_childremovedEvent.child = null;
                }
                return this;
            }
        },
        {
            /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ key: "removeFromParent",
            value: function removeFromParent() {
                var parent = this.parent;
                if (parent !== null) parent.remove(this);
                return this;
            }
        },
        {
            /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ key: "clear",
            value: function clear() {
                return this.remove.apply(this, (0, $7WNf6._)(this.children));
            }
        },
        {
            /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ key: "attach",
            value: function attach(object) {
                // adds object as a child of this, while maintaining the object's world transform
                // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
                this.updateWorldMatrix(true, false);
                $a1724dcfba0d6d9a$var$_m1$1.copy(this.matrixWorld).invert();
                if (object.parent !== null) {
                    object.parent.updateWorldMatrix(true, false);
                    $a1724dcfba0d6d9a$var$_m1$1.multiply(object.parent.matrixWorld);
                }
                object.applyMatrix4($a1724dcfba0d6d9a$var$_m1$1);
                object.removeFromParent();
                object.parent = this;
                this.children.push(object);
                object.updateWorldMatrix(false, true);
                object.dispatchEvent($a1724dcfba0d6d9a$var$_addedEvent);
                $a1724dcfba0d6d9a$var$_childaddedEvent.child = object;
                this.dispatchEvent($a1724dcfba0d6d9a$var$_childaddedEvent);
                $a1724dcfba0d6d9a$var$_childaddedEvent.child = null;
                return this;
            }
        },
        {
            /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ key: "getObjectById",
            value: function getObjectById(id) {
                return this.getObjectByProperty('id', id);
            }
        },
        {
            /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ key: "getObjectByName",
            value: function getObjectByName(name) {
                return this.getObjectByProperty('name', name);
            }
        },
        {
            /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ key: "getObjectByProperty",
            value: function getObjectByProperty(name, value) {
                if (this[name] === value) return this;
                for(var i = 0, l = this.children.length; i < l; i++){
                    var child = this.children[i];
                    var object = child.getObjectByProperty(name, value);
                    if (object !== undefined) return object;
                }
                return undefined;
            }
        },
        {
            /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ key: "getObjectsByProperty",
            value: function getObjectsByProperty(name, value) {
                var result = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                if (this[name] === value) result.push(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
                return result;
            }
        },
        {
            /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ key: "getWorldPosition",
            value: function getWorldPosition(target) {
                this.updateWorldMatrix(true, false);
                return target.setFromMatrixPosition(this.matrixWorld);
            }
        },
        {
            /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ key: "getWorldQuaternion",
            value: function getWorldQuaternion(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($a1724dcfba0d6d9a$var$_position$3, target, $a1724dcfba0d6d9a$var$_scale$2);
                return target;
            }
        },
        {
            /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ key: "getWorldScale",
            value: function getWorldScale(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($a1724dcfba0d6d9a$var$_position$3, $a1724dcfba0d6d9a$var$_quaternion$2, target);
                return target;
            }
        },
        {
            /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ key: "getWorldDirection",
            value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(e[8], e[9], e[10]).normalize();
            }
        },
        {
            /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ key: "raycast",
            value: function raycast() {}
        },
        {
            /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ key: "traverse",
            value: function traverse(callback) {
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
            }
        },
        {
            /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ key: "traverseVisible",
            value: function traverseVisible(callback) {
                if (this.visible === false) return;
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
            }
        },
        {
            /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ key: "traverseAncestors",
            value: function traverseAncestors(callback) {
                var parent = this.parent;
                if (parent !== null) {
                    callback(parent);
                    parent.traverseAncestors(callback);
                }
            }
        },
        {
            /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale);
                this.matrixWorldNeedsUpdate = true;
            }
        },
        {
            /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldNeedsUpdate || force) {
                    if (this.matrixWorldAutoUpdate === true) {
                        if (this.parent === null) this.matrixWorld.copy(this.matrix);
                        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                    }
                    this.matrixWorldNeedsUpdate = false;
                    force = true;
                }
                // make sure descendants are updated if required
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++){
                    var child = children[i];
                    child.updateMatrixWorld(force);
                }
            }
        },
        {
            /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                var parent = this.parent;
                if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldAutoUpdate === true) {
                    if (this.parent === null) this.matrixWorld.copy(this.matrix);
                    else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                }
                // make sure descendants are updated
                if (updateChildren === true) {
                    var children = this.children;
                    for(var i = 0, l = children.length; i < l; i++){
                        var child = children[i];
                        child.updateWorldMatrix(false, true);
                    }
                }
            }
        },
        {
            /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON(meta) {
                // meta is a string when called from JSON.stringify
                var isRootObject = meta === undefined || typeof meta === 'string';
                var output = {};
                // meta is a hash used to collect geometries, materials.
                // not providing it implies that this is the root object
                // being serialized.
                if (isRootObject) {
                    // initialize meta obj
                    meta = {
                        geometries: {},
                        materials: {},
                        textures: {},
                        images: {},
                        shapes: {},
                        skeletons: {},
                        animations: {},
                        nodes: {}
                    };
                    output.metadata = {
                        version: 4.7,
                        type: 'Object',
                        generator: 'Object3D.toJSON'
                    };
                }
                // standard Object3D serialization
                var object = {};
                object.uuid = this.uuid;
                object.type = this.type;
                if (this.name !== '') object.name = this.name;
                if (this.castShadow === true) object.castShadow = true;
                if (this.receiveShadow === true) object.receiveShadow = true;
                if (this.visible === false) object.visible = false;
                if (this.frustumCulled === false) object.frustumCulled = false;
                if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
                if (Object.keys(this.userData).length > 0) object.userData = this.userData;
                object.layers = this.layers.mask;
                object.matrix = this.matrix.toArray();
                object.up = this.up.toArray();
                if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
                // object specific properties
                if (this.isInstancedMesh) {
                    object.type = 'InstancedMesh';
                    object.count = this.count;
                    object.instanceMatrix = this.instanceMatrix.toJSON();
                    if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
                }
                if (this.isBatchedMesh) {
                    object.type = 'BatchedMesh';
                    object.perObjectFrustumCulled = this.perObjectFrustumCulled;
                    object.sortObjects = this.sortObjects;
                    object.drawRanges = this._drawRanges;
                    object.reservedRanges = this._reservedRanges;
                    object.geometryInfo = this._geometryInfo.map(function(info) {
                        return (0, $emQHU._)((0, $iT0je._)({}, info), {
                            boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                            boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                        });
                    });
                    object.instanceInfo = this._instanceInfo.map(function(info) {
                        return (0, $iT0je._)({}, info);
                    });
                    object.availableInstanceIds = this._availableInstanceIds.slice();
                    object.availableGeometryIds = this._availableGeometryIds.slice();
                    object.nextIndexStart = this._nextIndexStart;
                    object.nextVertexStart = this._nextVertexStart;
                    object.geometryCount = this._geometryCount;
                    object.maxInstanceCount = this._maxInstanceCount;
                    object.maxVertexCount = this._maxVertexCount;
                    object.maxIndexCount = this._maxIndexCount;
                    object.geometryInitialized = this._geometryInitialized;
                    object.matricesTexture = this._matricesTexture.toJSON(meta);
                    object.indirectTexture = this._indirectTexture.toJSON(meta);
                    if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
                    if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
                    if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
                }
                //
                function serialize(library, element) {
                    if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
                    return element.uuid;
                }
                if (this.isScene) {
                    if (this.background) {
                        if (this.background.isColor) object.background = this.background.toJSON();
                        else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
                    }
                    if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
                } else if (this.isMesh || this.isLine || this.isPoints) {
                    object.geometry = serialize(meta.geometries, this.geometry);
                    var parameters = this.geometry.parameters;
                    if (parameters !== undefined && parameters.shapes !== undefined) {
                        var shapes = parameters.shapes;
                        if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
                            var shape = shapes[i];
                            serialize(meta.shapes, shape);
                        }
                        else serialize(meta.shapes, shapes);
                    }
                }
                if (this.isSkinnedMesh) {
                    object.bindMode = this.bindMode;
                    object.bindMatrix = this.bindMatrix.toArray();
                    if (this.skeleton !== undefined) {
                        serialize(meta.skeletons, this.skeleton);
                        object.skeleton = this.skeleton.uuid;
                    }
                }
                if (this.material !== undefined) {
                    if (Array.isArray(this.material)) {
                        var uuids = [];
                        for(var i1 = 0, l1 = this.material.length; i1 < l1; i1++)uuids.push(serialize(meta.materials, this.material[i1]));
                        object.material = uuids;
                    } else object.material = serialize(meta.materials, this.material);
                }
                //
                if (this.children.length > 0) {
                    object.children = [];
                    for(var i2 = 0; i2 < this.children.length; i2++)object.children.push(this.children[i2].toJSON(meta).object);
                }
                //
                if (this.animations.length > 0) {
                    object.animations = [];
                    for(var i3 = 0; i3 < this.animations.length; i3++){
                        var animation = this.animations[i3];
                        object.animations.push(serialize(meta.animations, animation));
                    }
                }
                if (isRootObject) {
                    var geometries = extractFromCache(meta.geometries);
                    var materials = extractFromCache(meta.materials);
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    var shapes1 = extractFromCache(meta.shapes);
                    var skeletons = extractFromCache(meta.skeletons);
                    var animations = extractFromCache(meta.animations);
                    var nodes = extractFromCache(meta.nodes);
                    if (geometries.length > 0) output.geometries = geometries;
                    if (materials.length > 0) output.materials = materials;
                    if (textures.length > 0) output.textures = textures;
                    if (images.length > 0) output.images = images;
                    if (shapes1.length > 0) output.shapes = shapes1;
                    if (skeletons.length > 0) output.skeletons = skeletons;
                    if (animations.length > 0) output.animations = animations;
                    if (nodes.length > 0) output.nodes = nodes;
                }
                output.object = object;
                return output;
                // extract data from the cache hash
                // remove metadata on each item
                // and return as array
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
            }
        },
        {
            /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ key: "clone",
            value: function clone(recursive) {
                return new this.constructor().copy(this, recursive);
            }
        },
        {
            /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.name = source.name;
                this.up.copy(source.up);
                this.position.copy(source.position);
                this.rotation.order = source.rotation.order;
                this.quaternion.copy(source.quaternion);
                this.scale.copy(source.scale);
                this.matrix.copy(source.matrix);
                this.matrixWorld.copy(source.matrixWorld);
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
                this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
                this.layers.mask = source.layers.mask;
                this.visible = source.visible;
                this.castShadow = source.castShadow;
                this.receiveShadow = source.receiveShadow;
                this.frustumCulled = source.frustumCulled;
                this.renderOrder = source.renderOrder;
                this.animations = source.animations.slice();
                this.userData = JSON.parse(JSON.stringify(source.userData));
                if (recursive === true) for(var i = 0; i < source.children.length; i++){
                    var child = source.children[i];
                    this.add(child.clone());
                }
                return this;
            }
        }
    ]);
    return Object3D;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
var $a1724dcfba0d6d9a$var$_v0$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v1$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v2$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v3$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vab = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vac = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vbc = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vap = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vbp = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vcp = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v40 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
var $a1724dcfba0d6d9a$var$_v41 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
var $a1724dcfba0d6d9a$var$_v42 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ var $a1724dcfba0d6d9a$export$5a465592bfe74b48 = /*#__PURE__*/ function() {
    "use strict";
    function Triangle() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        (0, $jGAMp._)(this, Triangle);
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    (0, $byiyg._)(Triangle, [
        {
            /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ key: "set",
            value: function set(a, b, c) {
                this.a.copy(a);
                this.b.copy(b);
                this.c.copy(c);
                return this;
            }
        },
        {
            /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ key: "setFromPointsAndIndices",
            value: function setFromPointsAndIndices(points, i0, i1, i2) {
                this.a.copy(points[i0]);
                this.b.copy(points[i1]);
                this.c.copy(points[i2]);
                return this;
            }
        },
        {
            /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ key: "setFromAttributeAndIndices",
            value: function setFromAttributeAndIndices(attribute, i0, i1, i2) {
                this.a.fromBufferAttribute(attribute, i0);
                this.b.fromBufferAttribute(attribute, i1);
                this.c.fromBufferAttribute(attribute, i2);
                return this;
            }
        },
        {
            /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ key: "copy",
            value: function copy(triangle) {
                this.a.copy(triangle.a);
                this.b.copy(triangle.b);
                this.c.copy(triangle.c);
                return this;
            }
        },
        {
            /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ key: "getArea",
            value: function getArea() {
                $a1724dcfba0d6d9a$var$_v0$1.subVectors(this.c, this.b);
                $a1724dcfba0d6d9a$var$_v1$3.subVectors(this.a, this.b);
                return $a1724dcfba0d6d9a$var$_v0$1.cross($a1724dcfba0d6d9a$var$_v1$3).length() * 0.5;
            }
        },
        {
            /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ key: "getMidpoint",
            value: function getMidpoint(target) {
                return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
        },
        {
            /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ key: "getNormal",
            value: function getNormal(target) {
                return Triangle.getNormal(this.a, this.b, this.c, target);
            }
        },
        {
            /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ key: "getPlane",
            value: function getPlane(target) {
                return target.setFromCoplanarPoints(this.a, this.b, this.c);
            }
        },
        {
            /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ key: "getBarycoord",
            value: function getBarycoord(point, target) {
                return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
            }
        },
        {
            /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ key: "getInterpolation",
            value: function getInterpolation(point, v1, v2, v3, target) {
                return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
            }
        },
        {
            /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ key: "containsPoint",
            value: function containsPoint(point) {
                return Triangle.containsPoint(point, this.a, this.b, this.c);
            }
        },
        {
            /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ key: "isFrontFacing",
            value: function isFrontFacing(direction) {
                return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
            }
        },
        {
            /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsTriangle(this);
            }
        },
        {
            /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ key: "closestPointToPoint",
            value: function closestPointToPoint(p, target) {
                var a = this.a, b = this.b, c = this.c;
                var v, w;
                // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
                // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
                // under the accompanying license; see chapter 5.1.5 for detailed explanation.
                // basically, we're distinguishing which of the voronoi regions of the triangle
                // the point lies in with the minimum amount of redundant computation.
                $a1724dcfba0d6d9a$var$_vab.subVectors(b, a);
                $a1724dcfba0d6d9a$var$_vac.subVectors(c, a);
                $a1724dcfba0d6d9a$var$_vap.subVectors(p, a);
                var d1 = $a1724dcfba0d6d9a$var$_vab.dot($a1724dcfba0d6d9a$var$_vap);
                var d2 = $a1724dcfba0d6d9a$var$_vac.dot($a1724dcfba0d6d9a$var$_vap);
                if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
                return target.copy(a);
                $a1724dcfba0d6d9a$var$_vbp.subVectors(p, b);
                var d3 = $a1724dcfba0d6d9a$var$_vab.dot($a1724dcfba0d6d9a$var$_vbp);
                var d4 = $a1724dcfba0d6d9a$var$_vac.dot($a1724dcfba0d6d9a$var$_vbp);
                if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
                return target.copy(b);
                var vc = d1 * d4 - d3 * d2;
                if (vc <= 0 && d1 >= 0 && d3 <= 0) {
                    v = d1 / (d1 - d3);
                    // edge region of AB; barycentric coords (1-v, v, 0)
                    return target.copy(a).addScaledVector($a1724dcfba0d6d9a$var$_vab, v);
                }
                $a1724dcfba0d6d9a$var$_vcp.subVectors(p, c);
                var d5 = $a1724dcfba0d6d9a$var$_vab.dot($a1724dcfba0d6d9a$var$_vcp);
                var d6 = $a1724dcfba0d6d9a$var$_vac.dot($a1724dcfba0d6d9a$var$_vcp);
                if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
                return target.copy(c);
                var vb = d5 * d2 - d1 * d6;
                if (vb <= 0 && d2 >= 0 && d6 <= 0) {
                    w = d2 / (d2 - d6);
                    // edge region of AC; barycentric coords (1-w, 0, w)
                    return target.copy(a).addScaledVector($a1724dcfba0d6d9a$var$_vac, w);
                }
                var va = d3 * d6 - d5 * d4;
                if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
                    $a1724dcfba0d6d9a$var$_vbc.subVectors(c, b);
                    w = (d4 - d3) / (d4 - d3 + (d5 - d6));
                    // edge region of BC; barycentric coords (0, 1-w, w)
                    return target.copy(b).addScaledVector($a1724dcfba0d6d9a$var$_vbc, w); // edge region of BC
                }
                // face region
                var denom = 1 / (va + vb + vc);
                // u = va * denom
                v = vb * denom;
                w = vc * denom;
                return target.copy(a).addScaledVector($a1724dcfba0d6d9a$var$_vab, v).addScaledVector($a1724dcfba0d6d9a$var$_vac, w);
            }
        },
        {
            /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ key: "equals",
            value: function equals(triangle) {
                return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
            }
        }
    ], [
        {
            key: "getNormal",
            value: /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ function getNormal(a, b, c, target) {
                target.subVectors(c, b);
                $a1724dcfba0d6d9a$var$_v0$1.subVectors(a, b);
                target.cross($a1724dcfba0d6d9a$var$_v0$1);
                var targetLengthSq = target.lengthSq();
                if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
                return target.set(0, 0, 0);
            }
        },
        {
            key: "getBarycoord",
            value: /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ function getBarycoord(point, a, b, c, target) {
                // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
                $a1724dcfba0d6d9a$var$_v0$1.subVectors(c, a);
                $a1724dcfba0d6d9a$var$_v1$3.subVectors(b, a);
                $a1724dcfba0d6d9a$var$_v2$2.subVectors(point, a);
                var dot00 = $a1724dcfba0d6d9a$var$_v0$1.dot($a1724dcfba0d6d9a$var$_v0$1);
                var dot01 = $a1724dcfba0d6d9a$var$_v0$1.dot($a1724dcfba0d6d9a$var$_v1$3);
                var dot02 = $a1724dcfba0d6d9a$var$_v0$1.dot($a1724dcfba0d6d9a$var$_v2$2);
                var dot11 = $a1724dcfba0d6d9a$var$_v1$3.dot($a1724dcfba0d6d9a$var$_v1$3);
                var dot12 = $a1724dcfba0d6d9a$var$_v1$3.dot($a1724dcfba0d6d9a$var$_v2$2);
                var denom = dot00 * dot11 - dot01 * dot01;
                // collinear or singular triangle
                if (denom === 0) {
                    target.set(0, 0, 0);
                    return null;
                }
                var invDenom = 1 / denom;
                var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
                var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
                // barycentric coordinates must always sum to 1
                return target.set(1 - u - v, v, u);
            }
        },
        {
            key: "containsPoint",
            value: /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ function containsPoint(point, a, b, c) {
                // if the triangle is degenerate then we can't contain a point
                if (this.getBarycoord(point, a, b, c, $a1724dcfba0d6d9a$var$_v3$2) === null) return false;
                return $a1724dcfba0d6d9a$var$_v3$2.x >= 0 && $a1724dcfba0d6d9a$var$_v3$2.y >= 0 && $a1724dcfba0d6d9a$var$_v3$2.x + $a1724dcfba0d6d9a$var$_v3$2.y <= 1;
            }
        },
        {
            key: "getInterpolation",
            value: /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ function getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
                if (this.getBarycoord(point, p1, p2, p3, $a1724dcfba0d6d9a$var$_v3$2) === null) {
                    target.x = 0;
                    target.y = 0;
                    if ('z' in target) target.z = 0;
                    if ('w' in target) target.w = 0;
                    return null;
                }
                target.setScalar(0);
                target.addScaledVector(v1, $a1724dcfba0d6d9a$var$_v3$2.x);
                target.addScaledVector(v2, $a1724dcfba0d6d9a$var$_v3$2.y);
                target.addScaledVector(v3, $a1724dcfba0d6d9a$var$_v3$2.z);
                return target;
            }
        },
        {
            key: "getInterpolatedAttribute",
            value: /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ function getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
                $a1724dcfba0d6d9a$var$_v40.setScalar(0);
                $a1724dcfba0d6d9a$var$_v41.setScalar(0);
                $a1724dcfba0d6d9a$var$_v42.setScalar(0);
                $a1724dcfba0d6d9a$var$_v40.fromBufferAttribute(attr, i1);
                $a1724dcfba0d6d9a$var$_v41.fromBufferAttribute(attr, i2);
                $a1724dcfba0d6d9a$var$_v42.fromBufferAttribute(attr, i3);
                target.setScalar(0);
                target.addScaledVector($a1724dcfba0d6d9a$var$_v40, barycoord.x);
                target.addScaledVector($a1724dcfba0d6d9a$var$_v41, barycoord.y);
                target.addScaledVector($a1724dcfba0d6d9a$var$_v42, barycoord.z);
                return target;
            }
        },
        {
            key: "isFrontFacing",
            value: /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ function isFrontFacing(a, b, c, direction) {
                $a1724dcfba0d6d9a$var$_v0$1.subVectors(c, b);
                $a1724dcfba0d6d9a$var$_v1$3.subVectors(a, b);
                // strictly front facing
                return $a1724dcfba0d6d9a$var$_v0$1.cross($a1724dcfba0d6d9a$var$_v1$3).dot(direction) < 0 ? true : false;
            }
        }
    ]);
    return Triangle;
}();
var $a1724dcfba0d6d9a$var$_colorKeywords = {
    aliceblue: 0xF0F8FF,
    antiquewhite: 0xFAEBD7,
    aqua: 0x00FFFF,
    aquamarine: 0x7FFFD4,
    azure: 0xF0FFFF,
    beige: 0xF5F5DC,
    bisque: 0xFFE4C4,
    black: 0x000000,
    blanchedalmond: 0xFFEBCD,
    blue: 0x0000FF,
    blueviolet: 0x8A2BE2,
    brown: 0xA52A2A,
    burlywood: 0xDEB887,
    cadetblue: 0x5F9EA0,
    chartreuse: 0x7FFF00,
    chocolate: 0xD2691E,
    coral: 0xFF7F50,
    cornflowerblue: 0x6495ED,
    cornsilk: 0xFFF8DC,
    crimson: 0xDC143C,
    cyan: 0x00FFFF,
    darkblue: 0x00008B,
    darkcyan: 0x008B8B,
    darkgoldenrod: 0xB8860B,
    darkgray: 0xA9A9A9,
    darkgreen: 0x006400,
    darkgrey: 0xA9A9A9,
    darkkhaki: 0xBDB76B,
    darkmagenta: 0x8B008B,
    darkolivegreen: 0x556B2F,
    darkorange: 0xFF8C00,
    darkorchid: 0x9932CC,
    darkred: 0x8B0000,
    darksalmon: 0xE9967A,
    darkseagreen: 0x8FBC8F,
    darkslateblue: 0x483D8B,
    darkslategray: 0x2F4F4F,
    darkslategrey: 0x2F4F4F,
    darkturquoise: 0x00CED1,
    darkviolet: 0x9400D3,
    deeppink: 0xFF1493,
    deepskyblue: 0x00BFFF,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1E90FF,
    firebrick: 0xB22222,
    floralwhite: 0xFFFAF0,
    forestgreen: 0x228B22,
    fuchsia: 0xFF00FF,
    gainsboro: 0xDCDCDC,
    ghostwhite: 0xF8F8FF,
    gold: 0xFFD700,
    goldenrod: 0xDAA520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xADFF2F,
    grey: 0x808080,
    honeydew: 0xF0FFF0,
    hotpink: 0xFF69B4,
    indianred: 0xCD5C5C,
    indigo: 0x4B0082,
    ivory: 0xFFFFF0,
    khaki: 0xF0E68C,
    lavender: 0xE6E6FA,
    lavenderblush: 0xFFF0F5,
    lawngreen: 0x7CFC00,
    lemonchiffon: 0xFFFACD,
    lightblue: 0xADD8E6,
    lightcoral: 0xF08080,
    lightcyan: 0xE0FFFF,
    lightgoldenrodyellow: 0xFAFAD2,
    lightgray: 0xD3D3D3,
    lightgreen: 0x90EE90,
    lightgrey: 0xD3D3D3,
    lightpink: 0xFFB6C1,
    lightsalmon: 0xFFA07A,
    lightseagreen: 0x20B2AA,
    lightskyblue: 0x87CEFA,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xB0C4DE,
    lightyellow: 0xFFFFE0,
    lime: 0x00FF00,
    limegreen: 0x32CD32,
    linen: 0xFAF0E6,
    magenta: 0xFF00FF,
    maroon: 0x800000,
    mediumaquamarine: 0x66CDAA,
    mediumblue: 0x0000CD,
    mediumorchid: 0xBA55D3,
    mediumpurple: 0x9370DB,
    mediumseagreen: 0x3CB371,
    mediumslateblue: 0x7B68EE,
    mediumspringgreen: 0x00FA9A,
    mediumturquoise: 0x48D1CC,
    mediumvioletred: 0xC71585,
    midnightblue: 0x191970,
    mintcream: 0xF5FFFA,
    mistyrose: 0xFFE4E1,
    moccasin: 0xFFE4B5,
    navajowhite: 0xFFDEAD,
    navy: 0x000080,
    oldlace: 0xFDF5E6,
    olive: 0x808000,
    olivedrab: 0x6B8E23,
    orange: 0xFFA500,
    orangered: 0xFF4500,
    orchid: 0xDA70D6,
    palegoldenrod: 0xEEE8AA,
    palegreen: 0x98FB98,
    paleturquoise: 0xAFEEEE,
    palevioletred: 0xDB7093,
    papayawhip: 0xFFEFD5,
    peachpuff: 0xFFDAB9,
    peru: 0xCD853F,
    pink: 0xFFC0CB,
    plum: 0xDDA0DD,
    powderblue: 0xB0E0E6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xFF0000,
    rosybrown: 0xBC8F8F,
    royalblue: 0x4169E1,
    saddlebrown: 0x8B4513,
    salmon: 0xFA8072,
    sandybrown: 0xF4A460,
    seagreen: 0x2E8B57,
    seashell: 0xFFF5EE,
    sienna: 0xA0522D,
    silver: 0xC0C0C0,
    skyblue: 0x87CEEB,
    slateblue: 0x6A5ACD,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xFFFAFA,
    springgreen: 0x00FF7F,
    steelblue: 0x4682B4,
    tan: 0xD2B48C,
    teal: 0x008080,
    thistle: 0xD8BFD8,
    tomato: 0xFF6347,
    turquoise: 0x40E0D0,
    violet: 0xEE82EE,
    wheat: 0xF5DEB3,
    white: 0xFFFFFF,
    whitesmoke: 0xF5F5F5,
    yellow: 0xFFFF00,
    yellowgreen: 0x9ACD32
};
var $a1724dcfba0d6d9a$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
var $a1724dcfba0d6d9a$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $a1724dcfba0d6d9a$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ var $a1724dcfba0d6d9a$export$892596cec99bc70e = /*#__PURE__*/ function() {
    "use strict";
    function Color(r, g, b) {
        (0, $jGAMp._)(this, Color);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    (0, $byiyg._)(Color, [
        {
            /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ key: "set",
            value: function set(r, g, b) {
                if (g === undefined && b === undefined) {
                    // r is THREE.Color, hex or string
                    var value = r;
                    if (value && value.isColor) this.copy(value);
                    else if (typeof value === 'number') this.setHex(value);
                    else if (typeof value === 'string') this.setStyle(value);
                } else this.setRGB(r, g, b);
                return this;
            }
        },
        {
            /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ key: "setScalar",
            value: function setScalar(scalar) {
                this.r = scalar;
                this.g = scalar;
                this.b = scalar;
                return this;
            }
        },
        {
            /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ key: "setHex",
            value: function setHex(hex) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                hex = Math.floor(hex);
                this.r = (hex >> 16 & 255) / 255;
                this.g = (hex >> 8 & 255) / 255;
                this.b = (hex & 255) / 255;
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
                return this;
            }
        },
        {
            /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ key: "setRGB",
            value: function setRGB(r, g, b) {
                var colorSpace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
                this.r = r;
                this.g = g;
                this.b = b;
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
                return this;
            }
        },
        {
            /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ key: "setHSL",
            value: function setHSL(h, s, l) {
                var colorSpace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                h = $a1724dcfba0d6d9a$var$euclideanModulo(h, 1);
                s = $a1724dcfba0d6d9a$var$clamp(s, 0, 1);
                l = $a1724dcfba0d6d9a$var$clamp(l, 0, 1);
                if (s === 0) this.r = this.g = this.b = l;
                else {
                    var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
                    var q = 2 * l - p;
                    this.r = $a1724dcfba0d6d9a$var$hue2rgb(q, p, h + 1 / 3);
                    this.g = $a1724dcfba0d6d9a$var$hue2rgb(q, p, h);
                    this.b = $a1724dcfba0d6d9a$var$hue2rgb(q, p, h - 1 / 3);
                }
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
                return this;
            }
        },
        {
            /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ key: "setStyle",
            value: function setStyle(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                function handleAlpha(string) {
                    if (string === undefined) return;
                    if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
                }
                var m;
                if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
                    // rgb / hsl
                    var color;
                    var name = m[1];
                    var components = m[2];
                    switch(name){
                        case 'rgb':
                        case 'rgba':
                            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(255,0,0) rgba(255,0,0,0.5)
                                handleAlpha(color[4]);
                                return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                            }
                            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                                handleAlpha(color[4]);
                                return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                            }
                            break;
                        case 'hsl':
                        case 'hsla':
                            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                                handleAlpha(color[4]);
                                return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                            }
                            break;
                        default:
                            console.warn('THREE.Color: Unknown color model ' + style);
                    }
                } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
                    // hex color
                    var hex = m[1];
                    var size = hex.length;
                    if (size === 3) // #ff0
                    return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
                    else if (size === 6) // #ff0000
                    return this.setHex(parseInt(hex, 16), colorSpace);
                    else console.warn('THREE.Color: Invalid hex color ' + style);
                } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
                return this;
            }
        },
        {
            /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ key: "setColorName",
            value: function setColorName(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                // color keywords
                var hex = $a1724dcfba0d6d9a$var$_colorKeywords[style.toLowerCase()];
                if (hex !== undefined) // red
                this.setHex(hex, colorSpace);
                else // unknown color
                console.warn('THREE.Color: Unknown color ' + style);
                return this;
            }
        },
        {
            /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
        },
        {
            /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ key: "copy",
            value: function copy(color) {
                this.r = color.r;
                this.g = color.g;
                this.b = color.b;
                return this;
            }
        },
        {
            /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ key: "copySRGBToLinear",
            value: function copySRGBToLinear(color) {
                this.r = $a1724dcfba0d6d9a$var$SRGBToLinear(color.r);
                this.g = $a1724dcfba0d6d9a$var$SRGBToLinear(color.g);
                this.b = $a1724dcfba0d6d9a$var$SRGBToLinear(color.b);
                return this;
            }
        },
        {
            /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ key: "copyLinearToSRGB",
            value: function copyLinearToSRGB(color) {
                this.r = $a1724dcfba0d6d9a$var$LinearToSRGB(color.r);
                this.g = $a1724dcfba0d6d9a$var$LinearToSRGB(color.g);
                this.b = $a1724dcfba0d6d9a$var$LinearToSRGB(color.b);
                return this;
            }
        },
        {
            /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ key: "convertSRGBToLinear",
            value: function convertSRGBToLinear() {
                this.copySRGBToLinear(this);
                return this;
            }
        },
        {
            /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ key: "convertLinearToSRGB",
            value: function convertLinearToSRGB() {
                this.copyLinearToSRGB(this);
                return this;
            }
        },
        {
            /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ key: "getHex",
            value: function getHex() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingToColorSpace($a1724dcfba0d6d9a$var$_color.copy(this), colorSpace);
                return Math.round($a1724dcfba0d6d9a$var$clamp($a1724dcfba0d6d9a$var$_color.r * 255, 0, 255)) * 65536 + Math.round($a1724dcfba0d6d9a$var$clamp($a1724dcfba0d6d9a$var$_color.g * 255, 0, 255)) * 256 + Math.round($a1724dcfba0d6d9a$var$clamp($a1724dcfba0d6d9a$var$_color.b * 255, 0, 255));
            }
        },
        {
            /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ key: "getHexString",
            value: function getHexString() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
            }
        },
        {
            /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ key: "getHSL",
            value: function getHSL(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingToColorSpace($a1724dcfba0d6d9a$var$_color.copy(this), colorSpace);
                var r = $a1724dcfba0d6d9a$var$_color.r, g = $a1724dcfba0d6d9a$var$_color.g, b = $a1724dcfba0d6d9a$var$_color.b;
                var max = Math.max(r, g, b);
                var min = Math.min(r, g, b);
                var hue, saturation;
                var lightness = (min + max) / 2.0;
                if (min === max) {
                    hue = 0;
                    saturation = 0;
                } else {
                    var delta = max - min;
                    saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
                    switch(max){
                        case r:
                            hue = (g - b) / delta + (g < b ? 6 : 0);
                            break;
                        case g:
                            hue = (b - r) / delta + 2;
                            break;
                        case b:
                            hue = (r - g) / delta + 4;
                            break;
                    }
                    hue /= 6;
                }
                target.h = hue;
                target.s = saturation;
                target.l = lightness;
                return target;
            }
        },
        {
            /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ key: "getRGB",
            value: function getRGB(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingToColorSpace($a1724dcfba0d6d9a$var$_color.copy(this), colorSpace);
                target.r = $a1724dcfba0d6d9a$var$_color.r;
                target.g = $a1724dcfba0d6d9a$var$_color.g;
                target.b = $a1724dcfba0d6d9a$var$_color.b;
                return target;
            }
        },
        {
            /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ key: "getStyle",
            value: function getStyle() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingToColorSpace($a1724dcfba0d6d9a$var$_color.copy(this), colorSpace);
                var r = $a1724dcfba0d6d9a$var$_color.r, g = $a1724dcfba0d6d9a$var$_color.g, b = $a1724dcfba0d6d9a$var$_color.b;
                if (colorSpace !== $a1724dcfba0d6d9a$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
                return "color(".concat(colorSpace, " ").concat(r.toFixed(3), " ").concat(g.toFixed(3), " ").concat(b.toFixed(3), ")");
                return "rgb(".concat(Math.round(r * 255), ",").concat(Math.round(g * 255), ",").concat(Math.round(b * 255), ")");
            }
        },
        {
            /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ key: "offsetHSL",
            value: function offsetHSL(h, s, l) {
                this.getHSL($a1724dcfba0d6d9a$var$_hslA);
                return this.setHSL($a1724dcfba0d6d9a$var$_hslA.h + h, $a1724dcfba0d6d9a$var$_hslA.s + s, $a1724dcfba0d6d9a$var$_hslA.l + l);
            }
        },
        {
            /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ key: "add",
            value: function add(color) {
                this.r += color.r;
                this.g += color.g;
                this.b += color.b;
                return this;
            }
        },
        {
            /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ key: "addColors",
            value: function addColors(color1, color2) {
                this.r = color1.r + color2.r;
                this.g = color1.g + color2.g;
                this.b = color1.b + color2.b;
                return this;
            }
        },
        {
            /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ key: "addScalar",
            value: function addScalar(s) {
                this.r += s;
                this.g += s;
                this.b += s;
                return this;
            }
        },
        {
            /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ key: "sub",
            value: function sub(color) {
                this.r = Math.max(0, this.r - color.r);
                this.g = Math.max(0, this.g - color.g);
                this.b = Math.max(0, this.b - color.b);
                return this;
            }
        },
        {
            /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ key: "multiply",
            value: function multiply(color) {
                this.r *= color.r;
                this.g *= color.g;
                this.b *= color.b;
                return this;
            }
        },
        {
            /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ key: "multiplyScalar",
            value: function multiplyScalar(s) {
                this.r *= s;
                this.g *= s;
                this.b *= s;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ key: "lerp",
            value: function lerp(color, alpha) {
                this.r += (color.r - this.r) * alpha;
                this.g += (color.g - this.g) * alpha;
                this.b += (color.b - this.b) * alpha;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ key: "lerpColors",
            value: function lerpColors(color1, color2, alpha) {
                this.r = color1.r + (color2.r - color1.r) * alpha;
                this.g = color1.g + (color2.g - color1.g) * alpha;
                this.b = color1.b + (color2.b - color1.b) * alpha;
                return this;
            }
        },
        {
            /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ key: "lerpHSL",
            value: function lerpHSL(color, alpha) {
                this.getHSL($a1724dcfba0d6d9a$var$_hslA);
                color.getHSL($a1724dcfba0d6d9a$var$_hslB);
                var h = $a1724dcfba0d6d9a$var$lerp($a1724dcfba0d6d9a$var$_hslA.h, $a1724dcfba0d6d9a$var$_hslB.h, alpha);
                var s = $a1724dcfba0d6d9a$var$lerp($a1724dcfba0d6d9a$var$_hslA.s, $a1724dcfba0d6d9a$var$_hslB.s, alpha);
                var l = $a1724dcfba0d6d9a$var$lerp($a1724dcfba0d6d9a$var$_hslA.l, $a1724dcfba0d6d9a$var$_hslB.l, alpha);
                this.setHSL(h, s, l);
                return this;
            }
        },
        {
            /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ key: "setFromVector3",
            value: function setFromVector3(v) {
                this.r = v.x;
                this.g = v.y;
                this.b = v.z;
                return this;
            }
        },
        {
            /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var r = this.r, g = this.g, b = this.b;
                var e = m.elements;
                this.r = e[0] * r + e[3] * g + e[6] * b;
                this.g = e[1] * r + e[4] * g + e[7] * b;
                this.b = e[2] * r + e[5] * g + e[8] * b;
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ key: "equals",
            value: function equals(c) {
                return c.r === this.r && c.g === this.g && c.b === this.b;
            }
        },
        {
            /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.r = array[offset];
                this.g = array[offset + 1];
                this.b = array[offset + 2];
                return this;
            }
        },
        {
            /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.r;
                array[offset + 1] = this.g;
                array[offset + 2] = this.b;
                return array;
            }
        },
        {
            /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.r = attribute.getX(index);
                this.g = attribute.getY(index);
                this.b = attribute.getZ(index);
                return this;
            }
        },
        {
            /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ key: "toJSON",
            value: function toJSON() {
                return this.getHex();
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.r
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.g
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.b
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Color;
}();
var $a1724dcfba0d6d9a$var$_color = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $a1724dcfba0d6d9a$export$892596cec99bc70e.NAMES = $a1724dcfba0d6d9a$var$_colorKeywords;
var $a1724dcfba0d6d9a$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$a2d8b23205c25948 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(Material, EventDispatcher);
    function Material() {
        (0, $jGAMp._)(this, Material);
        var _this;
        _this = (0, $kzDuW._)(this, Material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(_this, 'id', {
            value: $a1724dcfba0d6d9a$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ _this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ _this.blending = $a1724dcfba0d6d9a$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ _this.side = $a1724dcfba0d6d9a$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ _this.blendSrc = $a1724dcfba0d6d9a$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ _this.blendDst = $a1724dcfba0d6d9a$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ _this.blendEquation = $a1724dcfba0d6d9a$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ _this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ _this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ _this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.blendColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ _this.depthFunc = $a1724dcfba0d6d9a$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ _this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ _this.stencilFunc = $a1724dcfba0d6d9a$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ _this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ _this.stencilFail = $a1724dcfba0d6d9a$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ _this.stencilZFail = $a1724dcfba0d6d9a$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ _this.stencilZPass = $a1724dcfba0d6d9a$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ _this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ _this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ _this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ _this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ _this.version = 0;
        _this._alphaTest = 0;
        return _this;
    }
    (0, $byiyg._)(Material, [
        {
            key: "alphaTest",
            get: /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ function get() {
                return this._alphaTest;
            },
            set: function set(value) {
                if (this._alphaTest > 0 !== value > 0) this.version++;
                this._alphaTest = value;
            }
        },
        {
            /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ key: "onBeforeRender",
            value: function onBeforeRender() {}
        },
        {
            /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ key: "onBeforeCompile",
            value: function onBeforeCompile() {}
        },
        {
            /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ key: "customProgramCacheKey",
            value: function customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
        },
        {
            /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ key: "setValues",
            value: function setValues(values) {
                if (values === undefined) return;
                for(var key in values){
                    var newValue = values[key];
                    if (newValue === undefined) {
                        console.warn("THREE.Material: parameter '".concat(key, "' has value of undefined."));
                        continue;
                    }
                    var currentValue = this[key];
                    if (currentValue === undefined) {
                        console.warn("THREE.Material: '".concat(key, "' is not a property of THREE.").concat(this.type, "."));
                        continue;
                    }
                    if (currentValue && currentValue.isColor) currentValue.set(newValue);
                    else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
                    else this[key] = newValue;
                }
            }
        },
        {
            /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (isRootObject) meta = {
                    textures: {},
                    images: {}
                };
                var data = {
                    metadata: {
                        version: 4.7,
                        type: 'Material',
                        generator: 'Material.toJSON'
                    }
                };
                // standard Material serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (this.color && this.color.isColor) data.color = this.color.getHex();
                if (this.roughness !== undefined) data.roughness = this.roughness;
                if (this.metalness !== undefined) data.metalness = this.metalness;
                if (this.sheen !== undefined) data.sheen = this.sheen;
                if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
                if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
                if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
                if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
                if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
                if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
                if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
                if (this.shininess !== undefined) data.shininess = this.shininess;
                if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
                if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
                if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
                if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
                if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
                    data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
                    data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
                }
                if (this.dispersion !== undefined) data.dispersion = this.dispersion;
                if (this.iridescence !== undefined) data.iridescence = this.iridescence;
                if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
                if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
                if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
                if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
                if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
                if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
                if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
                if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
                if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
                if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
                if (this.lightMap && this.lightMap.isTexture) {
                    data.lightMap = this.lightMap.toJSON(meta).uuid;
                    data.lightMapIntensity = this.lightMapIntensity;
                }
                if (this.aoMap && this.aoMap.isTexture) {
                    data.aoMap = this.aoMap.toJSON(meta).uuid;
                    data.aoMapIntensity = this.aoMapIntensity;
                }
                if (this.bumpMap && this.bumpMap.isTexture) {
                    data.bumpMap = this.bumpMap.toJSON(meta).uuid;
                    data.bumpScale = this.bumpScale;
                }
                if (this.normalMap && this.normalMap.isTexture) {
                    data.normalMap = this.normalMap.toJSON(meta).uuid;
                    data.normalMapType = this.normalMapType;
                    data.normalScale = this.normalScale.toArray();
                }
                if (this.displacementMap && this.displacementMap.isTexture) {
                    data.displacementMap = this.displacementMap.toJSON(meta).uuid;
                    data.displacementScale = this.displacementScale;
                    data.displacementBias = this.displacementBias;
                }
                if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
                if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
                if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
                if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
                if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
                if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
                if (this.envMap && this.envMap.isTexture) {
                    data.envMap = this.envMap.toJSON(meta).uuid;
                    if (this.combine !== undefined) data.combine = this.combine;
                }
                if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
                if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
                if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
                if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
                if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
                if (this.transmission !== undefined) data.transmission = this.transmission;
                if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
                if (this.thickness !== undefined) data.thickness = this.thickness;
                if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
                if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
                if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
                if (this.size !== undefined) data.size = this.size;
                if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
                if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
                if (this.blending !== $a1724dcfba0d6d9a$export$5b29a26d96ee6af0) data.blending = this.blending;
                if (this.side !== $a1724dcfba0d6d9a$export$2ede184fc2998901) data.side = this.side;
                if (this.vertexColors === true) data.vertexColors = true;
                if (this.opacity < 1) data.opacity = this.opacity;
                if (this.transparent === true) data.transparent = true;
                if (this.blendSrc !== $a1724dcfba0d6d9a$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
                if (this.blendDst !== $a1724dcfba0d6d9a$export$11d468cc7f19e971) data.blendDst = this.blendDst;
                if (this.blendEquation !== $a1724dcfba0d6d9a$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
                if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
                if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
                if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
                if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
                if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
                if (this.depthFunc !== $a1724dcfba0d6d9a$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
                if (this.depthTest === false) data.depthTest = this.depthTest;
                if (this.depthWrite === false) data.depthWrite = this.depthWrite;
                if (this.colorWrite === false) data.colorWrite = this.colorWrite;
                if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
                if (this.stencilFunc !== $a1724dcfba0d6d9a$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
                if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
                if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
                if (this.stencilFail !== $a1724dcfba0d6d9a$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
                if (this.stencilZFail !== $a1724dcfba0d6d9a$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
                if (this.stencilZPass !== $a1724dcfba0d6d9a$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
                if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
                // rotation (SpriteMaterial)
                if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
                if (this.polygonOffset === true) data.polygonOffset = true;
                if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
                if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
                if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
                if (this.dashSize !== undefined) data.dashSize = this.dashSize;
                if (this.gapSize !== undefined) data.gapSize = this.gapSize;
                if (this.scale !== undefined) data.scale = this.scale;
                if (this.dithering === true) data.dithering = true;
                if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
                if (this.alphaHash === true) data.alphaHash = true;
                if (this.alphaToCoverage === true) data.alphaToCoverage = true;
                if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
                if (this.forceSinglePass === true) data.forceSinglePass = true;
                if (this.wireframe === true) data.wireframe = true;
                if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
                if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
                if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
                if (this.flatShading === true) data.flatShading = true;
                if (this.visible === false) data.visible = false;
                if (this.toneMapped === false) data.toneMapped = false;
                if (this.fog === false) data.fog = false;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                // TODO: Copied from Object3D.toJSON
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
                if (isRootObject) {
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    if (textures.length > 0) data.textures = textures;
                    if (images.length > 0) data.images = images;
                }
                return data;
            }
        },
        {
            /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.blending = source.blending;
                this.side = source.side;
                this.vertexColors = source.vertexColors;
                this.opacity = source.opacity;
                this.transparent = source.transparent;
                this.blendSrc = source.blendSrc;
                this.blendDst = source.blendDst;
                this.blendEquation = source.blendEquation;
                this.blendSrcAlpha = source.blendSrcAlpha;
                this.blendDstAlpha = source.blendDstAlpha;
                this.blendEquationAlpha = source.blendEquationAlpha;
                this.blendColor.copy(source.blendColor);
                this.blendAlpha = source.blendAlpha;
                this.depthFunc = source.depthFunc;
                this.depthTest = source.depthTest;
                this.depthWrite = source.depthWrite;
                this.stencilWriteMask = source.stencilWriteMask;
                this.stencilFunc = source.stencilFunc;
                this.stencilRef = source.stencilRef;
                this.stencilFuncMask = source.stencilFuncMask;
                this.stencilFail = source.stencilFail;
                this.stencilZFail = source.stencilZFail;
                this.stencilZPass = source.stencilZPass;
                this.stencilWrite = source.stencilWrite;
                var srcPlanes = source.clippingPlanes;
                var dstPlanes = null;
                if (srcPlanes !== null) {
                    var n = srcPlanes.length;
                    dstPlanes = new Array(n);
                    for(var i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
                }
                this.clippingPlanes = dstPlanes;
                this.clipIntersection = source.clipIntersection;
                this.clipShadows = source.clipShadows;
                this.shadowSide = source.shadowSide;
                this.colorWrite = source.colorWrite;
                this.precision = source.precision;
                this.polygonOffset = source.polygonOffset;
                this.polygonOffsetFactor = source.polygonOffsetFactor;
                this.polygonOffsetUnits = source.polygonOffsetUnits;
                this.dithering = source.dithering;
                this.alphaTest = source.alphaTest;
                this.alphaHash = source.alphaHash;
                this.alphaToCoverage = source.alphaToCoverage;
                this.premultipliedAlpha = source.premultipliedAlpha;
                this.forceSinglePass = source.forceSinglePass;
                this.visible = source.visible;
                this.toneMapped = source.toneMapped;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ key: "dispose",
            value: function dispose() {
                /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            key: "needsUpdate",
            set: /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.version++;
            }
        }
    ]);
    return Material;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshBasicMaterial, Material);
    function MeshBasicMaterial(parameters) {
        (0, $jGAMp._)(this, MeshBasicMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshBasicMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshBasicMaterial = true;
        _this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff); // emissive
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.envMapRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ _this.combine = $a1724dcfba0d6d9a$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ _this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ _this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshBasicMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
var $a1724dcfba0d6d9a$var$_tables = /*@__PURE__*/ $a1724dcfba0d6d9a$var$_generateTables();
function $a1724dcfba0d6d9a$var$_generateTables() {
    // float32 to float16 helpers
    var buffer = new ArrayBuffer(4);
    var floatView = new Float32Array(buffer);
    var uint32View = new Uint32Array(buffer);
    var baseTable = new Uint32Array(512);
    var shiftTable = new Uint32Array(512);
    for(var i = 0; i < 256; ++i){
        var e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    var mantissaTable = new Uint32Array(2048);
    var exponentTable = new Uint32Array(64);
    var offsetTable = new Uint32Array(64);
    for(var i1 = 1; i1 < 1024; ++i1){
        var m = i1 << 13; // zero pad mantissa bits
        var e1 = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e1 -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e1 += 0x38800000; // adjust bias
        mantissaTable[i1] = m | e1;
    }
    for(var i2 = 1024; i2 < 2048; ++i2)mantissaTable[i2] = 0x38000000 + (i2 - 1024 << 13);
    for(var i3 = 1; i3 < 31; ++i3)exponentTable[i3] = i3 << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(var i4 = 33; i4 < 63; ++i4)exponentTable[i4] = 0x80000000 + (i4 - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(var i5 = 1; i5 < 64; ++i5)if (i5 !== 32) offsetTable[i5] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $a1724dcfba0d6d9a$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $a1724dcfba0d6d9a$var$clamp(val, -65504, 65504);
    $a1724dcfba0d6d9a$var$_tables.floatView[0] = val;
    var f = $a1724dcfba0d6d9a$var$_tables.uint32View[0];
    var e = f >> 23 & 0x1ff;
    return $a1724dcfba0d6d9a$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $a1724dcfba0d6d9a$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $a1724dcfba0d6d9a$var$fromHalfFloat(val) {
    var m = val >> 10;
    $a1724dcfba0d6d9a$var$_tables.uint32View[0] = $a1724dcfba0d6d9a$var$_tables.mantissaTable[$a1724dcfba0d6d9a$var$_tables.offsetTable[m] + (val & 0x3ff)] + $a1724dcfba0d6d9a$var$_tables.exponentTable[m];
    return $a1724dcfba0d6d9a$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$11ce8b759162cc80 = /*#__PURE__*/ function() {
    "use strict";
    function DataUtils() {
        (0, $jGAMp._)(this, DataUtils);
    }
    (0, $byiyg._)(DataUtils, null, [
        {
            key: "toHalfFloat",
            value: /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ function toHalfFloat1(val) {
                return $a1724dcfba0d6d9a$var$toHalfFloat(val);
            }
        },
        {
            key: "fromHalfFloat",
            value: /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ function fromHalfFloat1(val) {
                return $a1724dcfba0d6d9a$var$fromHalfFloat(val);
            }
        }
    ]);
    return DataUtils;
}();
var $a1724dcfba0d6d9a$var$_vector$9 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vector2$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ var $a1724dcfba0d6d9a$export$8dea267bd6bde117 = /*#__PURE__*/ function() {
    "use strict";
    function BufferAttribute(array, itemSize) {
        var normalized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $jGAMp._)(this, BufferAttribute);
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $a1724dcfba0d6d9a$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $a1724dcfba0d6d9a$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $a1724dcfba0d6d9a$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    (0, $byiyg._)(BufferAttribute, [
        {
            /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ key: "addUpdateRange",
            value: function addUpdateRange(start, count) {
                this.updateRanges.push({
                    start: start,
                    count: count
                });
            }
        },
        {
            /**
	 * Clears the update ranges.
	 */ key: "clearUpdateRanges",
            value: function clearUpdateRanges() {
                this.updateRanges.length = 0;
            }
        },
        {
            /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.array = new source.array.constructor(source.array);
                this.itemSize = source.itemSize;
                this.count = source.count;
                this.normalized = source.normalized;
                this.usage = source.usage;
                this.gpuType = source.gpuType;
                return this;
            }
        },
        {
            /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "copyAt",
            value: function copyAt(index1, attribute, index2) {
                index1 *= this.itemSize;
                index2 *= attribute.itemSize;
                for(var i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
                return this;
            }
        },
        {
            /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "copyArray",
            value: function copyArray(array) {
                this.array.set(array);
                return this;
            }
        },
        {
            /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "applyMatrix3",
            value: function applyMatrix3(m) {
                if (this.itemSize === 2) for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector2$1.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector2$1.applyMatrix3(m);
                    this.setXY(i, $a1724dcfba0d6d9a$var$_vector2$1.x, $a1724dcfba0d6d9a$var$_vector2$1.y);
                }
                else if (this.itemSize === 3) for(var i1 = 0, l1 = this.count; i1 < l1; i1++){
                    $a1724dcfba0d6d9a$var$_vector$9.fromBufferAttribute(this, i1);
                    $a1724dcfba0d6d9a$var$_vector$9.applyMatrix3(m);
                    this.setXYZ(i1, $a1724dcfba0d6d9a$var$_vector$9.x, $a1724dcfba0d6d9a$var$_vector$9.y, $a1724dcfba0d6d9a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$9.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$9.applyMatrix4(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$9.x, $a1724dcfba0d6d9a$var$_vector$9.y, $a1724dcfba0d6d9a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$9.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$9.applyNormalMatrix(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$9.x, $a1724dcfba0d6d9a$var$_vector$9.y, $a1724dcfba0d6d9a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$9.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$9.transformDirection(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$9.x, $a1724dcfba0d6d9a$var$_vector$9.y, $a1724dcfba0d6d9a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                // Matching BufferAttribute constructor, do not normalize the array.
                this.array.set(value, offset);
                return this;
            }
        },
        {
            /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ key: "getComponent",
            value: function getComponent(index, component) {
                var value = this.array[index * this.itemSize + component];
                if (this.normalized) value = $a1724dcfba0d6d9a$var$denormalize(value, this.array);
                return value;
            }
        },
        {
            /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setComponent",
            value: function setComponent(index, component, value) {
                if (this.normalized) value = $a1724dcfba0d6d9a$var$normalize(value, this.array);
                this.array[index * this.itemSize + component] = value;
                return this;
            }
        },
        {
            /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ key: "getX",
            value: function getX(index) {
                var x = this.array[index * this.itemSize];
                if (this.normalized) x = $a1724dcfba0d6d9a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                this.array[index * this.itemSize] = x;
                return this;
            }
        },
        {
            /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ key: "getY",
            value: function getY(index) {
                var y = this.array[index * this.itemSize + 1];
                if (this.normalized) y = $a1724dcfba0d6d9a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                this.array[index * this.itemSize + 1] = y;
                return this;
            }
        },
        {
            /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ key: "getZ",
            value: function getZ(index) {
                var z = this.array[index * this.itemSize + 2];
                if (this.normalized) z = $a1724dcfba0d6d9a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                this.array[index * this.itemSize + 2] = z;
                return this;
            }
        },
        {
            /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ key: "getW",
            value: function getW(index) {
                var w = this.array[index * this.itemSize + 3];
                if (this.normalized) w = $a1724dcfba0d6d9a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                this.array[index * this.itemSize + 3] = w;
                return this;
            }
        },
        {
            /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setXY",
            value: function setXY(index, x, y) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                return this;
            }
        },
        {
            /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                return this;
            }
        },
        {
            /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                    w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                this.array[index + 3] = w;
                return this;
            }
        },
        {
            /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
        },
        {
            /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ key: "toJSON",
            value: function toJSON() {
                var data = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                if (this.name !== '') data.name = this.name;
                if (this.usage !== $a1724dcfba0d6d9a$export$763e8360f4d7f77d) data.usage = this.usage;
                return data;
            }
        }
    ]);
    return BufferAttribute;
}();
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$f9ff2d6a20248cbf = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Int8BufferAttribute, BufferAttribute);
    function Int8BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Int8BufferAttribute);
        return (0, $kzDuW._)(this, Int8BufferAttribute, [
            new Int8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int8BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$cacc90cf35d11cdd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Uint8BufferAttribute, BufferAttribute);
    function Uint8BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Uint8BufferAttribute);
        return (0, $kzDuW._)(this, Uint8BufferAttribute, [
            new Uint8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$baaa85a1a812c157 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Uint8ClampedBufferAttribute, BufferAttribute);
    function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Uint8ClampedBufferAttribute);
        return (0, $kzDuW._)(this, Uint8ClampedBufferAttribute, [
            new Uint8ClampedArray(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8ClampedBufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$2b755a102ccdcefe = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Int16BufferAttribute, BufferAttribute);
    function Int16BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Int16BufferAttribute);
        return (0, $kzDuW._)(this, Int16BufferAttribute, [
            new Int16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int16BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$640a853f68025f2e = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Uint16BufferAttribute, BufferAttribute);
    function Uint16BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Uint16BufferAttribute);
        return (0, $kzDuW._)(this, Uint16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint16BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$46b369aed2968a0a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Int32BufferAttribute, BufferAttribute);
    function Int32BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Int32BufferAttribute);
        return (0, $kzDuW._)(this, Int32BufferAttribute, [
            new Int32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int32BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$7eb8c9fa25cd5bd6 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Uint32BufferAttribute, BufferAttribute);
    function Uint32BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Uint32BufferAttribute);
        return (0, $kzDuW._)(this, Uint32BufferAttribute, [
            new Uint32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint32BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$dbd3698c64958d69 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Float16BufferAttribute, BufferAttribute);
    function Float16BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Float16BufferAttribute);
        var _this;
        _this = (0, $kzDuW._)(this, Float16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
        _this.isFloat16BufferAttribute = true;
        return _this;
    }
    (0, $byiyg._)(Float16BufferAttribute, [
        {
            key: "getX",
            value: function getX(index) {
                var x = $a1724dcfba0d6d9a$var$fromHalfFloat(this.array[index * this.itemSize]);
                if (this.normalized) x = $a1724dcfba0d6d9a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                this.array[index * this.itemSize] = $a1724dcfba0d6d9a$var$toHalfFloat(x);
                return this;
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                var y = $a1724dcfba0d6d9a$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
                if (this.normalized) y = $a1724dcfba0d6d9a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                this.array[index * this.itemSize + 1] = $a1724dcfba0d6d9a$var$toHalfFloat(y);
                return this;
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                var z = $a1724dcfba0d6d9a$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
                if (this.normalized) z = $a1724dcfba0d6d9a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                this.array[index * this.itemSize + 2] = $a1724dcfba0d6d9a$var$toHalfFloat(z);
                return this;
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                var w = $a1724dcfba0d6d9a$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
                if (this.normalized) w = $a1724dcfba0d6d9a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                this.array[index * this.itemSize + 3] = $a1724dcfba0d6d9a$var$toHalfFloat(w);
                return this;
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                }
                this.array[index + 0] = $a1724dcfba0d6d9a$var$toHalfFloat(x);
                this.array[index + 1] = $a1724dcfba0d6d9a$var$toHalfFloat(y);
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                }
                this.array[index + 0] = $a1724dcfba0d6d9a$var$toHalfFloat(x);
                this.array[index + 1] = $a1724dcfba0d6d9a$var$toHalfFloat(y);
                this.array[index + 2] = $a1724dcfba0d6d9a$var$toHalfFloat(z);
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                    w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                }
                this.array[index + 0] = $a1724dcfba0d6d9a$var$toHalfFloat(x);
                this.array[index + 1] = $a1724dcfba0d6d9a$var$toHalfFloat(y);
                this.array[index + 2] = $a1724dcfba0d6d9a$var$toHalfFloat(z);
                this.array[index + 3] = $a1724dcfba0d6d9a$var$toHalfFloat(w);
                return this;
            }
        }
    ]);
    return Float16BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$cbe7a62641830ebd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(Float32BufferAttribute, BufferAttribute);
    function Float32BufferAttribute(array, itemSize, normalized) {
        (0, $jGAMp._)(this, Float32BufferAttribute);
        return (0, $kzDuW._)(this, Float32BufferAttribute, [
            new Float32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Float32BufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
var $a1724dcfba0d6d9a$var$_id$1 = 0;
var $a1724dcfba0d6d9a$var$_m1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_obj = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$e4dd07dff30cc924();
var $a1724dcfba0d6d9a$var$_offset = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_box$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
var $a1724dcfba0d6d9a$var$_boxMorphTargets = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
var $a1724dcfba0d6d9a$var$_vector$8 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$b7be63a67df8959 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(BufferGeometry, EventDispatcher);
    function BufferGeometry() {
        (0, $jGAMp._)(this, BufferGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, BufferGeometry);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(_this, 'id', {
            value: $a1724dcfba0d6d9a$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ _this.name = '';
        _this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ _this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ _this.indirect = null;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ _this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()?, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ _this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ _this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {Box3}
		 * @default null
		 */ _this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {Sphere}
		 * @default null
		 */ _this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ _this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ _this.userData = {};
        return _this;
    }
    (0, $byiyg._)(BufferGeometry, [
        {
            /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "setIndex",
            value: function setIndex(index) {
                if (Array.isArray(index)) this.index = new ($a1724dcfba0d6d9a$export$bc6f937da07eae17(index) ? $a1724dcfba0d6d9a$export$7eb8c9fa25cd5bd6 : $a1724dcfba0d6d9a$export$640a853f68025f2e)(index, 1);
                else this.index = index;
                return this;
            }
        },
        {
            /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "setIndirect",
            value: function setIndirect(indirect) {
                this.indirect = indirect;
                return this;
            }
        },
        {
            /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ key: "getIndirect",
            value: function getIndirect() {
                return this.indirect;
            }
        },
        {
            /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ key: "getAttribute",
            value: function getAttribute(name) {
                return this.attributes[name];
            }
        },
        {
            /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "setAttribute",
            value: function setAttribute(name, attribute) {
                this.attributes[name] = attribute;
                return this;
            }
        },
        {
            /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "deleteAttribute",
            value: function deleteAttribute(name) {
                delete this.attributes[name];
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ key: "hasAttribute",
            value: function hasAttribute(name) {
                return this.attributes[name] !== undefined;
            }
        },
        {
            /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ key: "addGroup",
            value: function addGroup(start, count) {
                var materialIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                this.groups.push({
                    start: start,
                    count: count,
                    materialIndex: materialIndex
                });
            }
        },
        {
            /**
	 * Clears all groups.
	 */ key: "clearGroups",
            value: function clearGroups() {
                this.groups = [];
            }
        },
        {
            /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ key: "setDrawRange",
            value: function setDrawRange(start, count) {
                this.drawRange.start = start;
                this.drawRange.count = count;
            }
        },
        {
            /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                var position = this.attributes.position;
                if (position !== undefined) {
                    position.applyMatrix4(matrix);
                    position.needsUpdate = true;
                }
                var normal = this.attributes.normal;
                if (normal !== undefined) {
                    var normalMatrix = new $a1724dcfba0d6d9a$export$8ff26dafa08918().getNormalMatrix(matrix);
                    normal.applyNormalMatrix(normalMatrix);
                    normal.needsUpdate = true;
                }
                var tangent = this.attributes.tangent;
                if (tangent !== undefined) {
                    tangent.transformDirection(matrix);
                    tangent.needsUpdate = true;
                }
                if (this.boundingBox !== null) this.computeBoundingBox();
                if (this.boundingSphere !== null) this.computeBoundingSphere();
                return this;
            }
        },
        {
            /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "applyQuaternion",
            value: function applyQuaternion(q) {
                $a1724dcfba0d6d9a$var$_m1.makeRotationFromQuaternion(q);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "rotateX",
            value: function rotateX(angle) {
                // rotate geometry around world x-axis
                $a1724dcfba0d6d9a$var$_m1.makeRotationX(angle);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "rotateY",
            value: function rotateY(angle) {
                // rotate geometry around world y-axis
                $a1724dcfba0d6d9a$var$_m1.makeRotationY(angle);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "rotateZ",
            value: function rotateZ(angle) {
                // rotate geometry around world z-axis
                $a1724dcfba0d6d9a$var$_m1.makeRotationZ(angle);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "translate",
            value: function translate(x, y, z) {
                // translate geometry
                $a1724dcfba0d6d9a$var$_m1.makeTranslation(x, y, z);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "scale",
            value: function scale(x, y, z) {
                // scale geometry
                $a1724dcfba0d6d9a$var$_m1.makeScale(x, y, z);
                this.applyMatrix4($a1724dcfba0d6d9a$var$_m1);
                return this;
            }
        },
        {
            /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "lookAt",
            value: function lookAt(vector) {
                $a1724dcfba0d6d9a$var$_obj.lookAt(vector);
                $a1724dcfba0d6d9a$var$_obj.updateMatrix();
                this.applyMatrix4($a1724dcfba0d6d9a$var$_obj.matrix);
                return this;
            }
        },
        {
            /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "center",
            value: function center() {
                this.computeBoundingBox();
                this.boundingBox.getCenter($a1724dcfba0d6d9a$var$_offset).negate();
                this.translate($a1724dcfba0d6d9a$var$_offset.x, $a1724dcfba0d6d9a$var$_offset.y, $a1724dcfba0d6d9a$var$_offset.z);
                return this;
            }
        },
        {
            /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "setFromPoints",
            value: function setFromPoints(points) {
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute === undefined) {
                    var position = [];
                    for(var i = 0, l = points.length; i < l; i++){
                        var point = points[i];
                        position.push(point.x, point.y, point.z || 0);
                    }
                    this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(position, 3));
                } else {
                    var l1 = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
                    for(var i1 = 0; i1 < l1; i1++){
                        var point1 = points[i1];
                        positionAttribute.setXYZ(i1, point1.x, point1.y, point1.z || 0);
                    }
                    if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
                    positionAttribute.needsUpdate = true;
                }
                return this;
            }
        },
        {
            /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ key: "computeBoundingBox",
            value: function computeBoundingBox() {
                if (this.boundingBox === null) this.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
                    this.boundingBox.set(new $a1724dcfba0d6d9a$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $a1724dcfba0d6d9a$export$64b5c384219d3699(Infinity, Infinity, Infinity));
                    return;
                }
                if (position !== undefined) {
                    this.boundingBox.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $a1724dcfba0d6d9a$var$_box$2.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $a1724dcfba0d6d9a$var$_vector$8.addVectors(this.boundingBox.min, $a1724dcfba0d6d9a$var$_box$2.min);
                            this.boundingBox.expandByPoint($a1724dcfba0d6d9a$var$_vector$8);
                            $a1724dcfba0d6d9a$var$_vector$8.addVectors(this.boundingBox.max, $a1724dcfba0d6d9a$var$_box$2.max);
                            this.boundingBox.expandByPoint($a1724dcfba0d6d9a$var$_vector$8);
                        } else {
                            this.boundingBox.expandByPoint($a1724dcfba0d6d9a$var$_box$2.min);
                            this.boundingBox.expandByPoint($a1724dcfba0d6d9a$var$_box$2.max);
                        }
                    }
                } else this.boundingBox.makeEmpty();
                if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
        },
        {
            /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                if (this.boundingSphere === null) this.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
                    this.boundingSphere.set(new $a1724dcfba0d6d9a$export$64b5c384219d3699(), Infinity);
                    return;
                }
                if (position) {
                    // first, find the center of the bounding sphere
                    var center = this.boundingSphere.center;
                    $a1724dcfba0d6d9a$var$_box$2.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $a1724dcfba0d6d9a$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $a1724dcfba0d6d9a$var$_vector$8.addVectors($a1724dcfba0d6d9a$var$_box$2.min, $a1724dcfba0d6d9a$var$_boxMorphTargets.min);
                            $a1724dcfba0d6d9a$var$_box$2.expandByPoint($a1724dcfba0d6d9a$var$_vector$8);
                            $a1724dcfba0d6d9a$var$_vector$8.addVectors($a1724dcfba0d6d9a$var$_box$2.max, $a1724dcfba0d6d9a$var$_boxMorphTargets.max);
                            $a1724dcfba0d6d9a$var$_box$2.expandByPoint($a1724dcfba0d6d9a$var$_vector$8);
                        } else {
                            $a1724dcfba0d6d9a$var$_box$2.expandByPoint($a1724dcfba0d6d9a$var$_boxMorphTargets.min);
                            $a1724dcfba0d6d9a$var$_box$2.expandByPoint($a1724dcfba0d6d9a$var$_boxMorphTargets.max);
                        }
                    }
                    $a1724dcfba0d6d9a$var$_box$2.getCenter(center);
                    // second, try to find a boundingSphere with a radius smaller than the
                    // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
                    var maxRadiusSq = 0;
                    for(var i1 = 0, il1 = position.count; i1 < il1; i1++){
                        $a1724dcfba0d6d9a$var$_vector$8.fromBufferAttribute(position, i1);
                        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($a1724dcfba0d6d9a$var$_vector$8));
                    }
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i2 = 0, il2 = morphAttributesPosition.length; i2 < il2; i2++){
                        var morphAttribute1 = morphAttributesPosition[i2];
                        var morphTargetsRelative = this.morphTargetsRelative;
                        for(var j = 0, jl = morphAttribute1.count; j < jl; j++){
                            $a1724dcfba0d6d9a$var$_vector$8.fromBufferAttribute(morphAttribute1, j);
                            if (morphTargetsRelative) {
                                $a1724dcfba0d6d9a$var$_offset.fromBufferAttribute(position, j);
                                $a1724dcfba0d6d9a$var$_vector$8.add($a1724dcfba0d6d9a$var$_offset);
                            }
                            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($a1724dcfba0d6d9a$var$_vector$8));
                        }
                    }
                    this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
                    if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
        },
        {
            /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ key: "computeTangents",
            value: function computeTangents() {
                var index = this.index;
                var attributes = this.attributes;
                // based on http://www.terathon.com/code/tangent.html
                // (per vertex tangents)
                if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
                    console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
                    return;
                }
                var positionAttribute = attributes.position;
                var normalAttribute = attributes.normal;
                var uvAttribute = attributes.uv;
                if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $a1724dcfba0d6d9a$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
                var tangentAttribute = this.getAttribute('tangent');
                var tan1 = [], tan2 = [];
                for(var i = 0; i < positionAttribute.count; i++){
                    tan1[i] = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    tan2[i] = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                }
                var vA = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), vB = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), vC = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), uvA = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), uvB = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), uvC = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), sdir = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), tdir = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                function handleTriangle(a, b, c) {
                    vA.fromBufferAttribute(positionAttribute, a);
                    vB.fromBufferAttribute(positionAttribute, b);
                    vC.fromBufferAttribute(positionAttribute, c);
                    uvA.fromBufferAttribute(uvAttribute, a);
                    uvB.fromBufferAttribute(uvAttribute, b);
                    uvC.fromBufferAttribute(uvAttribute, c);
                    vB.sub(vA);
                    vC.sub(vA);
                    uvB.sub(uvA);
                    uvC.sub(uvA);
                    var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
                    // silently ignore degenerate uv triangles having coincident or colinear vertices
                    if (!isFinite(r)) return;
                    sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
                    tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
                    tan1[a].add(sdir);
                    tan1[b].add(sdir);
                    tan1[c].add(sdir);
                    tan2[a].add(tdir);
                    tan2[b].add(tdir);
                    tan2[c].add(tdir);
                }
                var groups = this.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: index.count
                    }
                ];
                for(var i1 = 0, il = groups.length; i1 < il; ++i1){
                    var group = groups[i1];
                    var start = group.start;
                    var count = group.count;
                    for(var j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
                }
                var tmp = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), tmp2 = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var n = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), n2 = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                function handleVertex(v) {
                    n.fromBufferAttribute(normalAttribute, v);
                    n2.copy(n);
                    var t = tan1[v];
                    // Gram-Schmidt orthogonalize
                    tmp.copy(t);
                    tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
                    // Calculate handedness
                    tmp2.crossVectors(n2, t);
                    var test = tmp2.dot(tan2[v]);
                    var w = test < 0.0 ? -1 : 1.0;
                    tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
                }
                for(var i2 = 0, il1 = groups.length; i2 < il1; ++i2){
                    var group1 = groups[i2];
                    var start1 = group1.start;
                    var count1 = group1.count;
                    for(var j1 = start1, jl1 = start1 + count1; j1 < jl1; j1 += 3){
                        handleVertex(index.getX(j1 + 0));
                        handleVertex(index.getX(j1 + 1));
                        handleVertex(index.getX(j1 + 2));
                    }
                }
            }
        },
        {
            /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ key: "computeVertexNormals",
            value: function computeVertexNormals() {
                var index = this.index;
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute !== undefined) {
                    var normalAttribute = this.getAttribute('normal');
                    if (normalAttribute === undefined) {
                        normalAttribute = new $a1724dcfba0d6d9a$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                        this.setAttribute('normal', normalAttribute);
                    } else // reset existing normals to zero
                    for(var i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
                    var pA = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), pB = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), pC = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    var nA = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), nB = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), nC = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    var cb = new $a1724dcfba0d6d9a$export$64b5c384219d3699(), ab = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    // indexed elements
                    if (index) for(var i1 = 0, il1 = index.count; i1 < il1; i1 += 3){
                        var vA = index.getX(i1 + 0);
                        var vB = index.getX(i1 + 1);
                        var vC = index.getX(i1 + 2);
                        pA.fromBufferAttribute(positionAttribute, vA);
                        pB.fromBufferAttribute(positionAttribute, vB);
                        pC.fromBufferAttribute(positionAttribute, vC);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        nA.fromBufferAttribute(normalAttribute, vA);
                        nB.fromBufferAttribute(normalAttribute, vB);
                        nC.fromBufferAttribute(normalAttribute, vC);
                        nA.add(cb);
                        nB.add(cb);
                        nC.add(cb);
                        normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                        normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                        normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
                    }
                    else // non-indexed elements (unconnected triangle soup)
                    for(var i2 = 0, il2 = positionAttribute.count; i2 < il2; i2 += 3){
                        pA.fromBufferAttribute(positionAttribute, i2 + 0);
                        pB.fromBufferAttribute(positionAttribute, i2 + 1);
                        pC.fromBufferAttribute(positionAttribute, i2 + 2);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
                    }
                    this.normalizeNormals();
                    normalAttribute.needsUpdate = true;
                }
            }
        },
        {
            /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ key: "normalizeNormals",
            value: function normalizeNormals() {
                var normals = this.attributes.normal;
                for(var i = 0, il = normals.count; i < il; i++){
                    $a1724dcfba0d6d9a$var$_vector$8.fromBufferAttribute(normals, i);
                    $a1724dcfba0d6d9a$var$_vector$8.normalize();
                    normals.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$8.x, $a1724dcfba0d6d9a$var$_vector$8.y, $a1724dcfba0d6d9a$var$_vector$8.z);
                }
            }
        },
        {
            /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ key: "toNonIndexed",
            value: function toNonIndexed() {
                function convertBufferAttribute(attribute, indices) {
                    var array = attribute.array;
                    var itemSize = attribute.itemSize;
                    var normalized = attribute.normalized;
                    var array2 = new array.constructor(indices.length * itemSize);
                    var index = 0, index2 = 0;
                    for(var i = 0, l = indices.length; i < l; i++){
                        if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                        else index = indices[i] * itemSize;
                        for(var j = 0; j < itemSize; j++)array2[index2++] = array[index++];
                    }
                    return new $a1724dcfba0d6d9a$export$8dea267bd6bde117(array2, itemSize, normalized);
                }
                //
                if (this.index === null) {
                    console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
                    return this;
                }
                var geometry2 = new BufferGeometry();
                var indices = this.index.array;
                var attributes = this.attributes;
                // attributes
                for(var name in attributes){
                    var attribute = attributes[name];
                    var newAttribute = convertBufferAttribute(attribute, indices);
                    geometry2.setAttribute(name, newAttribute);
                }
                // morph attributes
                var morphAttributes = this.morphAttributes;
                for(var name1 in morphAttributes){
                    var morphArray = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, il = morphAttribute.length; i < il; i++){
                        var attribute1 = morphAttribute[i];
                        var newAttribute1 = convertBufferAttribute(attribute1, indices);
                        morphArray.push(newAttribute1);
                    }
                    geometry2.morphAttributes[name1] = morphArray;
                }
                geometry2.morphTargetsRelative = this.morphTargetsRelative;
                // groups
                var groups = this.groups;
                for(var i1 = 0, l = groups.length; i1 < l; i1++){
                    var group = groups[i1];
                    geometry2.addGroup(group.start, group.count, group.materialIndex);
                }
                return geometry2;
            }
        },
        {
            /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.7,
                        type: 'BufferGeometry',
                        generator: 'BufferGeometry.toJSON'
                    }
                };
                // standard BufferGeometry serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                if (this.parameters !== undefined) {
                    var parameters = this.parameters;
                    for(var key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
                    return data;
                }
                // for simplicity the code assumes attributes are not shared across geometries, see #15811
                data.data = {
                    attributes: {}
                };
                var index = this.index;
                if (index !== null) data.data.index = {
                    type: index.array.constructor.name,
                    array: Array.prototype.slice.call(index.array)
                };
                var attributes = this.attributes;
                for(var key1 in attributes){
                    var attribute = attributes[key1];
                    data.data.attributes[key1] = attribute.toJSON(data.data);
                }
                var morphAttributes = {};
                var hasMorphAttributes = false;
                for(var key2 in this.morphAttributes){
                    var attributeArray = this.morphAttributes[key2];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        array.push(attribute1.toJSON(data.data));
                    }
                    if (array.length > 0) {
                        morphAttributes[key2] = array;
                        hasMorphAttributes = true;
                    }
                }
                if (hasMorphAttributes) {
                    data.data.morphAttributes = morphAttributes;
                    data.data.morphTargetsRelative = this.morphTargetsRelative;
                }
                var groups = this.groups;
                if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
                var boundingSphere = this.boundingSphere;
                if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
                return data;
            }
        },
        {
            /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                // reset
                this.index = null;
                this.attributes = {};
                this.morphAttributes = {};
                this.groups = [];
                this.boundingBox = null;
                this.boundingSphere = null;
                // used for storing cloned, shared data
                var data = {};
                // name
                this.name = source.name;
                // index
                var index = source.index;
                if (index !== null) this.setIndex(index.clone());
                // attributes
                var attributes = source.attributes;
                for(var name in attributes){
                    var attribute = attributes[name];
                    this.setAttribute(name, attribute.clone(data));
                }
                // morph attributes
                var morphAttributes = source.morphAttributes;
                for(var name1 in morphAttributes){
                    var array = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
                    this.morphAttributes[name1] = array;
                }
                this.morphTargetsRelative = source.morphTargetsRelative;
                // groups
                var groups = source.groups;
                for(var i1 = 0, l1 = groups.length; i1 < l1; i1++){
                    var group = groups[i1];
                    this.addGroup(group.start, group.count, group.materialIndex);
                }
                // bounding box
                var boundingBox = source.boundingBox;
                if (boundingBox !== null) this.boundingBox = boundingBox.clone();
                // bounding sphere
                var boundingSphere = source.boundingSphere;
                if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
                // draw range
                this.drawRange.start = source.drawRange.start;
                this.drawRange.count = source.drawRange.count;
                // user data
                this.userData = source.userData;
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return BufferGeometry;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
var $a1724dcfba0d6d9a$var$_inverseMatrix$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_ray$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$a186db52eed6d40e();
var $a1724dcfba0d6d9a$var$_sphere$6 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_sphereHitAt = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vA$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vB$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vC$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_tempA = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_morphA = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_intersectionPoint = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_intersectionPointWorld = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$e176487c05830cc5 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Mesh, Object3D);
    function Mesh() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5();
        (0, $jGAMp._)(this, Mesh);
        var _this;
        _this = (0, $kzDuW._)(this, Mesh);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMesh = true;
        _this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ _this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ _this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ _this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ _this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.count = 1;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $byiyg._)(Mesh, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Mesh.prototype), "copy", this).call(this, source, recursive);
                if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
                if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        },
        {
            /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ key: "getVertexPosition",
            value: function getVertexPosition(index, target) {
                var geometry = this.geometry;
                var position = geometry.attributes.position;
                var morphPosition = geometry.morphAttributes.position;
                var morphTargetsRelative = geometry.morphTargetsRelative;
                target.fromBufferAttribute(position, index);
                var morphInfluences = this.morphTargetInfluences;
                if (morphPosition && morphInfluences) {
                    $a1724dcfba0d6d9a$var$_morphA.set(0, 0, 0);
                    for(var i = 0, il = morphPosition.length; i < il; i++){
                        var influence = morphInfluences[i];
                        var morphAttribute = morphPosition[i];
                        if (influence === 0) continue;
                        $a1724dcfba0d6d9a$var$_tempA.fromBufferAttribute(morphAttribute, index);
                        if (morphTargetsRelative) $a1724dcfba0d6d9a$var$_morphA.addScaledVector($a1724dcfba0d6d9a$var$_tempA, influence);
                        else $a1724dcfba0d6d9a$var$_morphA.addScaledVector($a1724dcfba0d6d9a$var$_tempA.sub(target), influence);
                    }
                    target.add($a1724dcfba0d6d9a$var$_morphA);
                }
                return target;
            }
        },
        {
            /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return;
                // test with bounding sphere in world space
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $a1724dcfba0d6d9a$var$_sphere$6.copy(geometry.boundingSphere);
                $a1724dcfba0d6d9a$var$_sphere$6.applyMatrix4(matrixWorld);
                // check distance from ray origin to bounding sphere
                $a1724dcfba0d6d9a$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
                if ($a1724dcfba0d6d9a$var$_sphere$6.containsPoint($a1724dcfba0d6d9a$var$_ray$3.origin) === false) {
                    if ($a1724dcfba0d6d9a$var$_ray$3.intersectSphere($a1724dcfba0d6d9a$var$_sphere$6, $a1724dcfba0d6d9a$var$_sphereHitAt) === null) return;
                    if ($a1724dcfba0d6d9a$var$_ray$3.origin.distanceToSquared($a1724dcfba0d6d9a$var$_sphereHitAt) > Math.pow(raycaster.far - raycaster.near, 2)) return;
                }
                // convert ray to local space of mesh
                $a1724dcfba0d6d9a$var$_inverseMatrix$3.copy(matrixWorld).invert();
                $a1724dcfba0d6d9a$var$_ray$3.copy(raycaster.ray).applyMatrix4($a1724dcfba0d6d9a$var$_inverseMatrix$3);
                // test with bounding box in local space
                if (geometry.boundingBox !== null) {
                    if ($a1724dcfba0d6d9a$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
                }
                // test for intersections with geometry
                this._computeIntersections(raycaster, intersects, $a1724dcfba0d6d9a$var$_ray$3);
            }
        },
        {
            key: "_computeIntersections",
            value: function _computeIntersections(raycaster, intersects, rayLocalSpace) {
                var intersection;
                var geometry = this.geometry;
                var material = this.material;
                var index = geometry.index;
                var position = geometry.attributes.position;
                var uv = geometry.attributes.uv;
                var uv1 = geometry.attributes.uv1;
                var normal = geometry.attributes.normal;
                var groups = geometry.groups;
                var drawRange = geometry.drawRange;
                if (index !== null) {
                    // indexed buffer geometry
                    if (Array.isArray(material)) for(var i = 0, il = groups.length; i < il; i++){
                        var group = groups[i];
                        var groupMaterial = material[group.materialIndex];
                        var start = Math.max(group.start, drawRange.start);
                        var end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                        for(var j = start, jl = end; j < jl; j += 3){
                            var a = index.getX(j);
                            var b = index.getX(j + 1);
                            var c = index.getX(j + 2);
                            intersection = $a1724dcfba0d6d9a$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                                intersection.face.materialIndex = group.materialIndex;
                                intersects.push(intersection);
                            }
                        }
                    }
                    else {
                        var start1 = Math.max(0, drawRange.start);
                        var end1 = Math.min(index.count, drawRange.start + drawRange.count);
                        for(var i1 = start1, il1 = end1; i1 < il1; i1 += 3){
                            var a1 = index.getX(i1);
                            var b1 = index.getX(i1 + 1);
                            var c1 = index.getX(i1 + 2);
                            intersection = $a1724dcfba0d6d9a$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a1, b1, c1);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(i1 / 3); // triangle number in indexed buffer semantics
                                intersects.push(intersection);
                            }
                        }
                    }
                } else if (position !== undefined) {
                    // non-indexed buffer geometry
                    if (Array.isArray(material)) for(var i2 = 0, il2 = groups.length; i2 < il2; i2++){
                        var group1 = groups[i2];
                        var groupMaterial1 = material[group1.materialIndex];
                        var start2 = Math.max(group1.start, drawRange.start);
                        var end2 = Math.min(position.count, Math.min(group1.start + group1.count, drawRange.start + drawRange.count));
                        for(var j1 = start2, jl1 = end2; j1 < jl1; j1 += 3){
                            var a2 = j1;
                            var b2 = j1 + 1;
                            var c2 = j1 + 2;
                            intersection = $a1724dcfba0d6d9a$var$checkGeometryIntersection(this, groupMaterial1, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(j1 / 3); // triangle number in non-indexed buffer semantics
                                intersection.face.materialIndex = group1.materialIndex;
                                intersects.push(intersection);
                            }
                        }
                    }
                    else {
                        var start3 = Math.max(0, drawRange.start);
                        var end3 = Math.min(position.count, drawRange.start + drawRange.count);
                        for(var i3 = start3, il3 = end3; i3 < il3; i3 += 3){
                            var a3 = i3;
                            var b3 = i3 + 1;
                            var c3 = i3 + 2;
                            intersection = $a1724dcfba0d6d9a$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a3, b3, c3);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(i3 / 3); // triangle number in non-indexed buffer semantics
                                intersects.push(intersection);
                            }
                        }
                    }
                }
            }
        }
    ]);
    return Mesh;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
function $a1724dcfba0d6d9a$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    var intersect;
    if (material.side === $a1724dcfba0d6d9a$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $a1724dcfba0d6d9a$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $a1724dcfba0d6d9a$var$_intersectionPointWorld.copy(point);
    $a1724dcfba0d6d9a$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    var distance = raycaster.ray.origin.distanceTo($a1724dcfba0d6d9a$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $a1724dcfba0d6d9a$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $a1724dcfba0d6d9a$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $a1724dcfba0d6d9a$var$_vA$1);
    object.getVertexPosition(b, $a1724dcfba0d6d9a$var$_vB$1);
    object.getVertexPosition(c, $a1724dcfba0d6d9a$var$_vC$1);
    var intersection = $a1724dcfba0d6d9a$var$checkIntersection$1(object, material, raycaster, ray, $a1724dcfba0d6d9a$var$_vA$1, $a1724dcfba0d6d9a$var$_vB$1, $a1724dcfba0d6d9a$var$_vC$1, $a1724dcfba0d6d9a$var$_intersectionPoint);
    if (intersection) {
        var barycoord = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        $a1724dcfba0d6d9a$export$5a465592bfe74b48.getBarycoord($a1724dcfba0d6d9a$var$_intersectionPoint, $a1724dcfba0d6d9a$var$_vA$1, $a1724dcfba0d6d9a$var$_vB$1, $a1724dcfba0d6d9a$var$_vC$1, barycoord);
        if (uv) intersection.uv = $a1724dcfba0d6d9a$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $a1724dcfba0d6d9a$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $a1724dcfba0d6d9a$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $a1724dcfba0d6d9a$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $a1724dcfba0d6d9a$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $a1724dcfba0d6d9a$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        var face = {
            a: a,
            b: b,
            c: c,
            normal: new $a1724dcfba0d6d9a$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $a1724dcfba0d6d9a$export$5a465592bfe74b48.getNormal($a1724dcfba0d6d9a$var$_vA$1, $a1724dcfba0d6d9a$var$_vB$1, $a1724dcfba0d6d9a$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$33e43285f7406bd5 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(BoxGeometry, BufferGeometry);
    function BoxGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, widthSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, depthSegments = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
        (0, $jGAMp._)(this, BoxGeometry);
        var _this;
        var buildPlane = function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            var segmentWidth = width / gridX;
            var segmentHeight = height / gridY;
            var widthHalf = width / 2;
            var heightHalf = height / 2;
            var depthHalf = depth / 2;
            var gridX1 = gridX + 1;
            var gridY1 = gridY + 1;
            var vertexCounter = 0;
            var groupCount = 0;
            var vector = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(var iy = 0; iy < gridY1; iy++){
                var y = iy * segmentHeight - heightHalf;
                for(var ix = 0; ix < gridX1; ix++){
                    var x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
                var a = numberOfVertices + ix1 + gridX1 * iy1;
                var b = numberOfVertices + ix1 + gridX1 * (iy1 + 1);
                var c = numberOfVertices + (ix1 + 1) + gridX1 * (iy1 + 1);
                var d = numberOfVertices + (ix1 + 1) + gridX1 * iy1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        };
        _this = (0, $kzDuW._)(this, BoxGeometry);
        _this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        var scope = _this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var numberOfVertices = 0;
        var groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(BoxGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(BoxGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ function fromJSON(data) {
                return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
            }
        }
    ]);
    return BoxGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
// Uniform Utilities
function $a1724dcfba0d6d9a$export$acda854380553452(src) {
    var dst = {};
    for(var u in src){
        dst[u] = {};
        for(var p in src[u]){
            var property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $a1724dcfba0d6d9a$export$8916ce6879271f43(uniforms) {
    var merged = {};
    for(var u = 0; u < uniforms.length; u++){
        var tmp = $a1724dcfba0d6d9a$export$acda854380553452(uniforms[u]);
        for(var p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $a1724dcfba0d6d9a$var$cloneUniformsGroups(src) {
    var dst = [];
    for(var u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $a1724dcfba0d6d9a$export$a630742c640528c1(renderer) {
    var currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
var $a1724dcfba0d6d9a$export$d8ecdf8615bfea69 = {
    clone: $a1724dcfba0d6d9a$export$acda854380553452,
    merge: $a1724dcfba0d6d9a$export$8916ce6879271f43
};
var $a1724dcfba0d6d9a$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $a1724dcfba0d6d9a$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized]{@link https://en.wikipedia.org/wiki/Normalized_loop}.
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$83c7d75d550a8b0d = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(ShaderMaterial, Material);
    function ShaderMaterial(parameters) {
        (0, $jGAMp._)(this, ShaderMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, ShaderMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isShaderMaterial = true;
        _this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ _this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ _this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ _this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ _this.vertexShader = $a1724dcfba0d6d9a$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ _this.fragmentShader = $a1724dcfba0d6d9a$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Define whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ _this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ _this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation}
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ _this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ _this.glslVersion = null;
        if (parameters !== undefined) _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(ShaderMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(ShaderMaterial.prototype), "copy", this).call(this, source);
                this.fragmentShader = source.fragmentShader;
                this.vertexShader = source.vertexShader;
                this.uniforms = $a1724dcfba0d6d9a$export$acda854380553452(source.uniforms);
                this.uniformsGroups = $a1724dcfba0d6d9a$var$cloneUniformsGroups(source.uniformsGroups);
                this.defines = Object.assign({}, source.defines);
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.fog = source.fog;
                this.lights = source.lights;
                this.clipping = source.clipping;
                this.extensions = Object.assign({}, source.extensions);
                this.glslVersion = source.glslVersion;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(ShaderMaterial.prototype), "toJSON", this).call(this, meta);
                data.glslVersion = this.glslVersion;
                data.uniforms = {};
                for(var name in this.uniforms){
                    var uniform = this.uniforms[name];
                    var value = uniform.value;
                    if (value && value.isTexture) data.uniforms[name] = {
                        type: 't',
                        value: value.toJSON(meta).uuid
                    };
                    else if (value && value.isColor) data.uniforms[name] = {
                        type: 'c',
                        value: value.getHex()
                    };
                    else if (value && value.isVector2) data.uniforms[name] = {
                        type: 'v2',
                        value: value.toArray()
                    };
                    else if (value && value.isVector3) data.uniforms[name] = {
                        type: 'v3',
                        value: value.toArray()
                    };
                    else if (value && value.isVector4) data.uniforms[name] = {
                        type: 'v4',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix3) data.uniforms[name] = {
                        type: 'm3',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix4) data.uniforms[name] = {
                        type: 'm4',
                        value: value.toArray()
                    };
                    else data.uniforms[name] = {
                        value: value
                    };
                }
                if (Object.keys(this.defines).length > 0) data.defines = this.defines;
                data.vertexShader = this.vertexShader;
                data.fragmentShader = this.fragmentShader;
                data.lights = this.lights;
                data.clipping = this.clipping;
                var extensions = {};
                for(var key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
                if (Object.keys(extensions).length > 0) data.extensions = extensions;
                return data;
            }
        }
    ]);
    return ShaderMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$79f141de891a5fed = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Camera, Object3D);
    function Camera() {
        (0, $jGAMp._)(this, Camera);
        var _this;
        _this = (0, $kzDuW._)(this, Camera);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCamera = true;
        _this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ _this.matrixWorldInverse = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ _this.projectionMatrix = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ _this.projectionMatrixInverse = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ _this.coordinateSystem = $a1724dcfba0d6d9a$export$5a0e9190d10875d3;
        return _this;
    }
    (0, $byiyg._)(Camera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Camera.prototype), "copy", this).call(this, source, recursive);
                this.matrixWorldInverse.copy(source.matrixWorldInverse);
                this.projectionMatrix.copy(source.projectionMatrix);
                this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
                this.coordinateSystem = source.coordinateSystem;
                return this;
            }
        },
        {
            /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ key: "getWorldDirection",
            value: function getWorldDirection(target) {
                return (0, $fXhL4._)((0, $hxFDX._)(Camera.prototype), "getWorldDirection", this).call(this, target).negate();
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $fXhL4._)((0, $hxFDX._)(Camera.prototype), "updateMatrixWorld", this).call(this, force);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                (0, $fXhL4._)((0, $hxFDX._)(Camera.prototype), "updateWorldMatrix", this).call(this, updateParents, updateChildren);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Camera;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_v3$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_minTarget = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_maxTarget = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection]{@link https://en.wikipedia.org/wiki/Perspective_(graphical)}.
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ var $a1724dcfba0d6d9a$export$74e4ae24825f68d7 = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $i3fW3._)(PerspectiveCamera, Camera);
    function PerspectiveCamera() {
        var fov = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50, aspect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2000;
        (0, $jGAMp._)(this, PerspectiveCamera);
        var _this;
        _this = (0, $kzDuW._)(this, PerspectiveCamera);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isPerspectiveCamera = true;
        _this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ _this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ _this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ _this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ _this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ _this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ _this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.filmOffset = 0;
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $byiyg._)(PerspectiveCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(PerspectiveCamera.prototype), "copy", this).call(this, source, recursive);
                this.fov = source.fov;
                this.zoom = source.zoom;
                this.near = source.near;
                this.far = source.far;
                this.focus = source.focus;
                this.aspect = source.aspect;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                this.filmGauge = source.filmGauge;
                this.filmOffset = source.filmOffset;
                return this;
            }
        },
        {
            /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ key: "setFocalLength",
            value: function setFocalLength(focalLength) {
                /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
                this.fov = $a1724dcfba0d6d9a$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ key: "getFocalLength",
            value: function getFocalLength() {
                var vExtentSlope = Math.tan($a1724dcfba0d6d9a$var$DEG2RAD * 0.5 * this.fov);
                return 0.5 * this.getFilmHeight() / vExtentSlope;
            }
        },
        {
            /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ key: "getEffectiveFOV",
            value: function getEffectiveFOV() {
                return $a1724dcfba0d6d9a$export$914076c8150813e5 * 2 * Math.atan(Math.tan($a1724dcfba0d6d9a$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
            }
        },
        {
            /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ key: "getFilmWidth",
            value: function getFilmWidth() {
                // film not completely covered in portrait format (aspect < 1)
                return this.filmGauge * Math.min(this.aspect, 1);
            }
        },
        {
            /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ key: "getFilmHeight",
            value: function getFilmHeight() {
                // film not completely covered in landscape format (aspect > 1)
                return this.filmGauge / Math.max(this.aspect, 1);
            }
        },
        {
            /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ key: "getViewBounds",
            value: function getViewBounds(distance, minTarget, maxTarget) {
                $a1724dcfba0d6d9a$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
                minTarget.set($a1724dcfba0d6d9a$var$_v3$1.x, $a1724dcfba0d6d9a$var$_v3$1.y).multiplyScalar(-distance / $a1724dcfba0d6d9a$var$_v3$1.z);
                $a1724dcfba0d6d9a$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
                maxTarget.set($a1724dcfba0d6d9a$var$_v3$1.x, $a1724dcfba0d6d9a$var$_v3$1.y).multiplyScalar(-distance / $a1724dcfba0d6d9a$var$_v3$1.z);
            }
        },
        {
            /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ key: "getViewSize",
            value: function getViewSize(distance, target) {
                this.getViewBounds(distance, $a1724dcfba0d6d9a$var$_minTarget, $a1724dcfba0d6d9a$var$_maxTarget);
                return target.subVectors($a1724dcfba0d6d9a$var$_maxTarget, $a1724dcfba0d6d9a$var$_minTarget);
            }
        },
        {
            /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                this.aspect = fullWidth / fullHeight;
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Removes the view offset from the projection matrix.
	 */ key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var near = this.near;
                var top = near * Math.tan($a1724dcfba0d6d9a$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
                var height = 2 * top;
                var width = this.aspect * height;
                var left = -0.5 * width;
                var view = this.view;
                if (this.view !== null && this.view.enabled) {
                    var fullWidth = view.fullWidth, fullHeight = view.fullHeight;
                    left += view.offsetX * width / fullWidth;
                    top -= view.offsetY * height / fullHeight;
                    width *= view.width / fullWidth;
                    height *= view.height / fullHeight;
                }
                var skew = this.filmOffset;
                if (skew !== 0) left += near * skew / this.getFilmWidth();
                this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(PerspectiveCamera.prototype), "toJSON", this).call(this, meta);
                data.object.fov = this.fov;
                data.object.zoom = this.zoom;
                data.object.near = this.near;
                data.object.far = this.far;
                data.object.focus = this.focus;
                data.object.aspect = this.aspect;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                data.object.filmGauge = this.filmGauge;
                data.object.filmOffset = this.filmOffset;
                return data;
            }
        }
    ]);
    return PerspectiveCamera;
}($a1724dcfba0d6d9a$export$79f141de891a5fed);
var $a1724dcfba0d6d9a$var$fov = -90; // negative fov is not an error
var $a1724dcfba0d6d9a$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$d0cdd0bd804995de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(CubeCamera, Object3D);
    function CubeCamera(near, far, renderTarget) {
        (0, $jGAMp._)(this, CubeCamera);
        var _this;
        _this = (0, $kzDuW._)(this, CubeCamera);
        _this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ _this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ _this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ _this.activeMipmapLevel = 0;
        var cameraPX = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraPX.layers = _this.layers;
        _this.add(cameraPX);
        var cameraNX = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraNX.layers = _this.layers;
        _this.add(cameraNX);
        var cameraPY = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraPY.layers = _this.layers;
        _this.add(cameraPY);
        var cameraNY = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraNY.layers = _this.layers;
        _this.add(cameraNY);
        var cameraPZ = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraPZ.layers = _this.layers;
        _this.add(cameraPZ);
        var cameraNZ = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7($a1724dcfba0d6d9a$var$fov, $a1724dcfba0d6d9a$var$aspect, near, far);
        cameraNZ.layers = _this.layers;
        _this.add(cameraNZ);
        return _this;
    }
    (0, $byiyg._)(CubeCamera, [
        {
            /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ key: "updateCoordinateSystem",
            value: function updateCoordinateSystem() {
                var coordinateSystem = this.coordinateSystem;
                var cameras = this.children.concat();
                var _cameras = (0, $32TW8._)(cameras, 6), cameraPX = _cameras[0], cameraNX = _cameras[1], cameraPY = _cameras[2], cameraNY = _cameras[3], cameraPZ = _cameras[4], cameraNZ = _cameras[5];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = cameras[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var camera = _step.value;
                        this.remove(camera);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (coordinateSystem === $a1724dcfba0d6d9a$export$5a0e9190d10875d3) {
                    cameraPX.up.set(0, 1, 0);
                    cameraPX.lookAt(1, 0, 0);
                    cameraNX.up.set(0, 1, 0);
                    cameraNX.lookAt(-1, 0, 0);
                    cameraPY.up.set(0, 0, -1);
                    cameraPY.lookAt(0, 1, 0);
                    cameraNY.up.set(0, 0, 1);
                    cameraNY.lookAt(0, -1, 0);
                    cameraPZ.up.set(0, 1, 0);
                    cameraPZ.lookAt(0, 0, 1);
                    cameraNZ.up.set(0, 1, 0);
                    cameraNZ.lookAt(0, 0, -1);
                } else if (coordinateSystem === $a1724dcfba0d6d9a$export$cc83beedcb9be9ac) {
                    cameraPX.up.set(0, -1, 0);
                    cameraPX.lookAt(-1, 0, 0);
                    cameraNX.up.set(0, -1, 0);
                    cameraNX.lookAt(1, 0, 0);
                    cameraPY.up.set(0, 0, 1);
                    cameraPY.lookAt(0, 1, 0);
                    cameraNY.up.set(0, 0, -1);
                    cameraNY.lookAt(0, -1, 0);
                    cameraPZ.up.set(0, -1, 0);
                    cameraPZ.lookAt(0, 0, 1);
                    cameraNZ.up.set(0, -1, 0);
                    cameraNZ.lookAt(0, 0, -1);
                } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = cameras[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var camera1 = _step1.value;
                        this.add(camera1);
                        camera1.updateMatrixWorld();
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ key: "update",
            value: function update(renderer, scene) {
                if (this.parent === null) this.updateMatrixWorld();
                var _this = this, renderTarget = _this.renderTarget, activeMipmapLevel = _this.activeMipmapLevel;
                if (this.coordinateSystem !== renderer.coordinateSystem) {
                    this.coordinateSystem = renderer.coordinateSystem;
                    this.updateCoordinateSystem();
                }
                var _this_children = (0, $32TW8._)(this.children, 6), cameraPX = _this_children[0], cameraNX = _this_children[1], cameraPY = _this_children[2], cameraNY = _this_children[3], cameraPZ = _this_children[4], cameraNZ = _this_children[5];
                var currentRenderTarget = renderer.getRenderTarget();
                var currentActiveCubeFace = renderer.getActiveCubeFace();
                var currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
                var currentXrEnabled = renderer.xr.enabled;
                renderer.xr.enabled = false;
                var generateMipmaps = renderTarget.texture.generateMipmaps;
                renderTarget.texture.generateMipmaps = false;
                renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
                renderer.render(scene, cameraPX);
                renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
                renderer.render(scene, cameraNX);
                renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
                renderer.render(scene, cameraPY);
                renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
                renderer.render(scene, cameraNY);
                renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
                renderer.render(scene, cameraPZ);
                // mipmaps are generated during the last call of render()
                // at this point, all sides of the cube render target are defined
                renderTarget.texture.generateMipmaps = generateMipmaps;
                renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
                renderer.render(scene, cameraNZ);
                renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
                renderer.xr.enabled = currentXrEnabled;
                renderTarget.texture.needsPMREMUpdate = true;
            }
        }
    ]);
    return CubeCamera;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$ee2e5a18258a4049 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(CubeTexture, Texture);
    function CubeTexture() {
        var images = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], mapping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$8759762a6477f2c4, wrapS = arguments.length > 2 ? arguments[2] : void 0, wrapT = arguments.length > 3 ? arguments[3] : void 0, magFilter = arguments.length > 4 ? arguments[4] : void 0, minFilter = arguments.length > 5 ? arguments[5] : void 0, format = arguments.length > 6 ? arguments[6] : void 0, type = arguments.length > 7 ? arguments[7] : void 0, anisotropy = arguments.length > 8 ? arguments[8] : void 0, colorSpace = arguments.length > 9 ? arguments[9] : void 0;
        (0, $jGAMp._)(this, CubeTexture);
        var _this;
        _this = (0, $kzDuW._)(this, CubeTexture, [
            images,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flipY = false;
        return _this;
    }
    (0, $byiyg._)(CubeTexture, [
        {
            key: "images",
            get: /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ function get() {
                return this.image;
            },
            set: function set(value) {
                this.image = value;
            }
        }
    ]);
    return CubeTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ var $a1724dcfba0d6d9a$export$ac386671d651941e = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $i3fW3._)(WebGLCubeRenderTarget, WebGLRenderTarget);
    function WebGLCubeRenderTarget() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, WebGLCubeRenderTarget);
        var _this;
        _this = (0, $kzDuW._)(this, WebGLCubeRenderTarget, [
            size,
            size,
            options
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isWebGLCubeRenderTarget = true;
        var image = {
            width: size,
            height: size,
            depth: 1
        };
        var images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ _this.texture = new $a1724dcfba0d6d9a$export$ee2e5a18258a4049(images);
        _this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    (0, $byiyg._)(WebGLCubeRenderTarget, [
        {
            /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ key: "fromEquirectangularTexture",
            value: function fromEquirectangularTexture(renderer, texture) {
                this.texture.type = texture.type;
                this.texture.colorSpace = texture.colorSpace;
                this.texture.generateMipmaps = texture.generateMipmaps;
                this.texture.minFilter = texture.minFilter;
                this.texture.magFilter = texture.magFilter;
                var shader = {
                    uniforms: {
                        tEquirect: {
                            value: null
                        }
                    },
                    vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
                    fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
                };
                var geometry = new $a1724dcfba0d6d9a$export$33e43285f7406bd5(5, 5, 5);
                var material = new $a1724dcfba0d6d9a$export$83c7d75d550a8b0d({
                    name: 'CubemapFromEquirect',
                    uniforms: $a1724dcfba0d6d9a$export$acda854380553452(shader.uniforms),
                    vertexShader: shader.vertexShader,
                    fragmentShader: shader.fragmentShader,
                    side: $a1724dcfba0d6d9a$export$d9f0486e75b5ace,
                    blending: $a1724dcfba0d6d9a$export$63b8d6b580fc65ba
                });
                material.uniforms.tEquirect.value = texture;
                var mesh = new $a1724dcfba0d6d9a$export$e176487c05830cc5(geometry, material);
                var currentMinFilter = texture.minFilter;
                // Avoid blurred poles
                if (texture.minFilter === $a1724dcfba0d6d9a$export$5d8599b6a933fb1b) texture.minFilter = $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                var camera = new $a1724dcfba0d6d9a$export$d0cdd0bd804995de(1, 10, this);
                camera.update(renderer, mesh);
                texture.minFilter = currentMinFilter;
                mesh.geometry.dispose();
                mesh.material.dispose();
                return this;
            }
        },
        {
            /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ key: "clear",
            value: function clear(renderer) {
                var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, stencil = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                var currentRenderTarget = renderer.getRenderTarget();
                for(var i = 0; i < 6; i++){
                    renderer.setRenderTarget(this, i);
                    renderer.clear(color, depth, stencil);
                }
                renderer.setRenderTarget(currentRenderTarget);
            }
        }
    ]);
    return WebGLCubeRenderTarget;
}($a1724dcfba0d6d9a$export$3c052beb2e51e23f);
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Group, Object3D);
    function Group() {
        (0, $jGAMp._)(this, Group);
        var _this;
        _this = (0, $kzDuW._)(this, Group);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isGroup = true;
        _this.type = 'Group';
        return _this;
    }
    return Group;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ var $a1724dcfba0d6d9a$export$cb626c57dcc48b9f = /*#__PURE__*/ function() {
    "use strict";
    function WebXRController() {
        (0, $jGAMp._)(this, WebXRController);
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    (0, $byiyg._)(WebXRController, [
        {
            /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ key: "getHandSpace",
            value: function getHandSpace() {
                if (this._hand === null) {
                    this._hand = new $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4();
                    this._hand.matrixAutoUpdate = false;
                    this._hand.visible = false;
                    this._hand.joints = {};
                    this._hand.inputState = {
                        pinching: false
                    };
                }
                return this._hand;
            }
        },
        {
            /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ key: "getTargetRaySpace",
            value: function getTargetRaySpace() {
                if (this._targetRay === null) {
                    this._targetRay = new $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4();
                    this._targetRay.matrixAutoUpdate = false;
                    this._targetRay.visible = false;
                    this._targetRay.hasLinearVelocity = false;
                    this._targetRay.linearVelocity = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    this._targetRay.hasAngularVelocity = false;
                    this._targetRay.angularVelocity = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                }
                return this._targetRay;
            }
        },
        {
            /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ key: "getGripSpace",
            value: function getGripSpace() {
                if (this._grip === null) {
                    this._grip = new $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4();
                    this._grip.matrixAutoUpdate = false;
                    this._grip.visible = false;
                    this._grip.hasLinearVelocity = false;
                    this._grip.linearVelocity = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                    this._grip.hasAngularVelocity = false;
                    this._grip.angularVelocity = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                }
                return this._grip;
            }
        },
        {
            /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ key: "dispatchEvent",
            value: function dispatchEvent(event) {
                if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
                if (this._grip !== null) this._grip.dispatchEvent(event);
                if (this._hand !== null) this._hand.dispatchEvent(event);
                return this;
            }
        },
        {
            /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ key: "connect",
            value: function connect(inputSource) {
                if (inputSource && inputSource.hand) {
                    var hand = this._hand;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (hand) try {
                        for(var _iterator = inputSource.hand.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var inputjoint = _step.value;
                            // Initialize hand with joints when connected
                            this._getHandJoint(hand, inputjoint);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                this.dispatchEvent({
                    type: 'connected',
                    data: inputSource
                });
                return this;
            }
        },
        {
            /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ key: "disconnect",
            value: function disconnect(inputSource) {
                this.dispatchEvent({
                    type: 'disconnected',
                    data: inputSource
                });
                if (this._targetRay !== null) this._targetRay.visible = false;
                if (this._grip !== null) this._grip.visible = false;
                if (this._hand !== null) this._hand.visible = false;
                return this;
            }
        },
        {
            /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ key: "update",
            value: function update(inputSource, frame, referenceSpace) {
                var inputPose = null;
                var gripPose = null;
                var handPose = null;
                var targetRay = this._targetRay;
                var grip = this._grip;
                var hand = this._hand;
                if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
                    if (hand && inputSource.hand) {
                        handPose = true;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = inputSource.hand.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var inputjoint = _step.value;
                                // Update the joints groups with the XRJoint poses
                                var jointPose = frame.getJointPose(inputjoint, referenceSpace);
                                // The transform of this joint will be updated with the joint pose on each frame
                                var joint = this._getHandJoint(hand, inputjoint);
                                if (jointPose !== null) {
                                    joint.matrix.fromArray(jointPose.transform.matrix);
                                    joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                                    joint.matrixWorldNeedsUpdate = true;
                                    joint.jointRadius = jointPose.radius;
                                }
                                joint.visible = jointPose !== null;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Custom events
                        // Check pinchz
                        var indexTip = hand.joints['index-finger-tip'];
                        var thumbTip = hand.joints['thumb-tip'];
                        var distance = indexTip.position.distanceTo(thumbTip.position);
                        var distanceToPinch = 0.02;
                        var threshold = 0.005;
                        if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                            hand.inputState.pinching = false;
                            this.dispatchEvent({
                                type: 'pinchend',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                            hand.inputState.pinching = true;
                            this.dispatchEvent({
                                type: 'pinchstart',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        }
                    } else if (grip !== null && inputSource.gripSpace) {
                        gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                        if (gripPose !== null) {
                            grip.matrix.fromArray(gripPose.transform.matrix);
                            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                            grip.matrixWorldNeedsUpdate = true;
                            if (gripPose.linearVelocity) {
                                grip.hasLinearVelocity = true;
                                grip.linearVelocity.copy(gripPose.linearVelocity);
                            } else grip.hasLinearVelocity = false;
                            if (gripPose.angularVelocity) {
                                grip.hasAngularVelocity = true;
                                grip.angularVelocity.copy(gripPose.angularVelocity);
                            } else grip.hasAngularVelocity = false;
                        }
                    }
                    if (targetRay !== null) {
                        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                        // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                        if (inputPose === null && gripPose !== null) inputPose = gripPose;
                        if (inputPose !== null) {
                            targetRay.matrix.fromArray(inputPose.transform.matrix);
                            targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                            targetRay.matrixWorldNeedsUpdate = true;
                            if (inputPose.linearVelocity) {
                                targetRay.hasLinearVelocity = true;
                                targetRay.linearVelocity.copy(inputPose.linearVelocity);
                            } else targetRay.hasLinearVelocity = false;
                            if (inputPose.angularVelocity) {
                                targetRay.hasAngularVelocity = true;
                                targetRay.angularVelocity.copy(inputPose.angularVelocity);
                            } else targetRay.hasAngularVelocity = false;
                            this.dispatchEvent($a1724dcfba0d6d9a$var$_moveEvent);
                        }
                    }
                }
                if (targetRay !== null) targetRay.visible = inputPose !== null;
                if (grip !== null) grip.visible = gripPose !== null;
                if (hand !== null) hand.visible = handPose !== null;
                return this;
            }
        },
        {
            /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ key: "_getHandJoint",
            value: function _getHandJoint(hand, inputjoint) {
                if (hand.joints[inputjoint.jointName] === undefined) {
                    var joint = new $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4();
                    joint.matrixAutoUpdate = false;
                    joint.visible = false;
                    hand.joints[inputjoint.jointName] = joint;
                    hand.add(joint);
                }
                return hand.joints[inputjoint.jointName];
            }
        }
    ]);
    return WebXRController;
}();
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ var $a1724dcfba0d6d9a$export$6f1519f023b8d0f6 = /*#__PURE__*/ function() {
    "use strict";
    function FogExp2(color) {
        var density = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.00025;
        (0, $jGAMp._)(this, FogExp2);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    (0, $byiyg._)(FogExp2, [
        {
            /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new FogExp2(this.color, this.density);
            }
        },
        {
            /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'FogExp2',
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
    ]);
    return FogExp2;
}();
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ var $a1724dcfba0d6d9a$export$3c890837b09508d4 = /*#__PURE__*/ function() {
    "use strict";
    function Fog(color) {
        var near = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, far = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
        (0, $jGAMp._)(this, Fog);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    (0, $byiyg._)(Fog, [
        {
            /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new Fog(this.color, this.near, this.far);
            }
        },
        {
            /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'Fog',
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
    ]);
    return Fog;
}();
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$38af1803e3442a7f = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Scene, Object3D);
    function Scene() {
        (0, $jGAMp._)(this, Scene);
        var _this;
        _this = (0, $kzDuW._)(this, Scene);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isScene = true;
        _this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ _this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ _this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.backgroundRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.environmentRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ _this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: _this
        }));
        return _this;
    }
    (0, $byiyg._)(Scene, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Scene.prototype), "copy", this).call(this, source, recursive);
                if (source.background !== null) this.background = source.background.clone();
                if (source.environment !== null) this.environment = source.environment.clone();
                if (source.fog !== null) this.fog = source.fog.clone();
                this.backgroundBlurriness = source.backgroundBlurriness;
                this.backgroundIntensity = source.backgroundIntensity;
                this.backgroundRotation.copy(source.backgroundRotation);
                this.environmentIntensity = source.environmentIntensity;
                this.environmentRotation.copy(source.environmentRotation);
                if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(Scene.prototype), "toJSON", this).call(this, meta);
                if (this.fog !== null) data.object.fog = this.fog.toJSON();
                if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
                if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
                data.object.backgroundRotation = this.backgroundRotation.toArray();
                if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
                data.object.environmentRotation = this.environmentRotation.toArray();
                return data;
            }
        }
    ]);
    return Scene;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics]{@link https://blog.tojicode.com/2011/05/interleaved-array-basics.html}
 */ var $a1724dcfba0d6d9a$export$3d5cd879f108f53f = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBuffer(array, stride) {
        (0, $jGAMp._)(this, InterleavedBuffer);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $a1724dcfba0d6d9a$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
    }
    (0, $byiyg._)(InterleavedBuffer, [
        {
            /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ key: "addUpdateRange",
            value: function addUpdateRange(start, count) {
                this.updateRanges.push({
                    start: start,
                    count: count
                });
            }
        },
        {
            /**
	 * Clears the update ranges.
	 */ key: "clearUpdateRanges",
            value: function clearUpdateRanges() {
                this.updateRanges.length = 0;
            }
        },
        {
            /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ key: "copy",
            value: function copy(source) {
                this.array = new source.array.constructor(source.array);
                this.count = source.count;
                this.stride = source.stride;
                this.usage = source.usage;
                return this;
            }
        },
        {
            /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ key: "copyAt",
            value: function copyAt(index1, interleavedBuffer, index2) {
                index1 *= this.stride;
                index2 *= interleavedBuffer.stride;
                for(var i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
                return this;
            }
        },
        {
            /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.array.set(value, offset);
                return this;
            }
        },
        {
            /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ key: "clone",
            value: function clone(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $a1724dcfba0d6d9a$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
                var array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
                var ib = new this.constructor(array, this.stride);
                ib.setUsage(this.usage);
                return ib;
            }
        },
        {
            /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ key: "toJSON",
            value: function toJSON(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                // generate UUID for array buffer if necessary
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $a1724dcfba0d6d9a$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
                //
                return {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
    ]);
    return InterleavedBuffer;
}();
var $a1724dcfba0d6d9a$var$_vector$7 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ var $a1724dcfba0d6d9a$export$920b6d07334599c7 = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset) {
        var normalized = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        (0, $jGAMp._)(this, InterleavedBufferAttribute);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    (0, $byiyg._)(InterleavedBufferAttribute, [
        {
            key: "count",
            get: /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ function get() {
                return this.data.count;
            }
        },
        {
            key: "array",
            get: /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ function get() {
                return this.data.array;
            }
        },
        {
            key: "needsUpdate",
            set: /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                this.data.needsUpdate = value;
            }
        },
        {
            /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.data.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$7.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$7.applyMatrix4(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$7.x, $a1724dcfba0d6d9a$var$_vector$7.y, $a1724dcfba0d6d9a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$7.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$7.applyNormalMatrix(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$7.x, $a1724dcfba0d6d9a$var$_vector$7.y, $a1724dcfba0d6d9a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $a1724dcfba0d6d9a$var$_vector$7.fromBufferAttribute(this, i);
                    $a1724dcfba0d6d9a$var$_vector$7.transformDirection(m);
                    this.setXYZ(i, $a1724dcfba0d6d9a$var$_vector$7.x, $a1724dcfba0d6d9a$var$_vector$7.y, $a1724dcfba0d6d9a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ key: "getComponent",
            value: function getComponent(index, component) {
                var value = this.array[index * this.data.stride + this.offset + component];
                if (this.normalized) value = $a1724dcfba0d6d9a$var$denormalize(value, this.array);
                return value;
            }
        },
        {
            /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setComponent",
            value: function setComponent(index, component, value) {
                if (this.normalized) value = $a1724dcfba0d6d9a$var$normalize(value, this.array);
                this.data.array[index * this.data.stride + this.offset + component] = value;
                return this;
            }
        },
        {
            /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                this.data.array[index * this.data.stride + this.offset] = x;
                return this;
            }
        },
        {
            /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                this.data.array[index * this.data.stride + this.offset + 1] = y;
                return this;
            }
        },
        {
            /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                this.data.array[index * this.data.stride + this.offset + 2] = z;
                return this;
            }
        },
        {
            /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                this.data.array[index * this.data.stride + this.offset + 3] = w;
                return this;
            }
        },
        {
            /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ key: "getX",
            value: function getX(index) {
                var x = this.data.array[index * this.data.stride + this.offset];
                if (this.normalized) x = $a1724dcfba0d6d9a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ key: "getY",
            value: function getY(index) {
                var y = this.data.array[index * this.data.stride + this.offset + 1];
                if (this.normalized) y = $a1724dcfba0d6d9a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ key: "getZ",
            value: function getZ(index) {
                var z = this.data.array[index * this.data.stride + this.offset + 2];
                if (this.normalized) z = $a1724dcfba0d6d9a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ key: "getW",
            value: function getW(index) {
                var w = this.data.array[index * this.data.stride + this.offset + 3];
                if (this.normalized) w = $a1724dcfba0d6d9a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setXY",
            value: function setXY(index, x, y) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                return this;
            }
        },
        {
            /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                return this;
            }
        },
        {
            /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $a1724dcfba0d6d9a$var$normalize(x, this.array);
                    y = $a1724dcfba0d6d9a$var$normalize(y, this.array);
                    z = $a1724dcfba0d6d9a$var$normalize(z, this.array);
                    w = $a1724dcfba0d6d9a$var$normalize(w, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                this.data.array[index + 3] = w;
                return this;
            }
        },
        {
            /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ key: "clone",
            value: function clone(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    return new $a1724dcfba0d6d9a$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
                } else {
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
                    return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
                }
            }
        },
        {
            /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ key: "toJSON",
            value: function toJSON(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    // de-interleave data and save it as an ordinary buffer attribute for now
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: array,
                        normalized: this.normalized
                    };
                } else {
                    // save as true interleaved attribute
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
                    return {
                        isInterleavedBufferAttribute: true,
                        itemSize: this.itemSize,
                        data: this.data.uuid,
                        offset: this.offset,
                        normalized: this.normalized
                    };
                }
            }
        }
    ]);
    return InterleavedBufferAttribute;
}();
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$5ec7dd1c6994bf8e = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(SpriteMaterial, Material);
    function SpriteMaterial(parameters) {
        (0, $jGAMp._)(this, SpriteMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, SpriteMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSpriteMaterial = true;
        _this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(SpriteMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(SpriteMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.rotation = source.rotation;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return SpriteMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
var $a1724dcfba0d6d9a$var$_geometry;
var $a1724dcfba0d6d9a$var$_intersectPoint = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_worldScale = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_mvPosition = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_alignedPosition = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_rotatedPosition = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_viewWorldMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_vA = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vB = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vC = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_uvA = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_uvB = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
var $a1724dcfba0d6d9a$var$_uvC = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$3075603db8e6204c = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Sprite, Object3D);
    function Sprite() {
        var material = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$5ec7dd1c6994bf8e();
        (0, $jGAMp._)(this, Sprite);
        var _this;
        _this = (0, $kzDuW._)(this, Sprite);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSprite = true;
        _this.type = 'Sprite';
        if ($a1724dcfba0d6d9a$var$_geometry === undefined) {
            $a1724dcfba0d6d9a$var$_geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
            var float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            var interleavedBuffer = new $a1724dcfba0d6d9a$export$3d5cd879f108f53f(float32Array, 5);
            $a1724dcfba0d6d9a$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $a1724dcfba0d6d9a$var$_geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $a1724dcfba0d6d9a$var$_geometry.setAttribute('uv', new $a1724dcfba0d6d9a$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ _this.geometry = $a1724dcfba0d6d9a$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {SpriteMaterial}
		 */ _this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ _this.center = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.count = 1;
        return _this;
    }
    (0, $byiyg._)(Sprite, [
        {
            /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
                $a1724dcfba0d6d9a$var$_worldScale.setFromMatrixScale(this.matrixWorld);
                $a1724dcfba0d6d9a$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
                this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
                $a1724dcfba0d6d9a$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
                if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $a1724dcfba0d6d9a$var$_worldScale.multiplyScalar(-$a1724dcfba0d6d9a$var$_mvPosition.z);
                var rotation = this.material.rotation;
                var sin, cos;
                if (rotation !== 0) {
                    cos = Math.cos(rotation);
                    sin = Math.sin(rotation);
                }
                var center = this.center;
                $a1724dcfba0d6d9a$var$transformVertex($a1724dcfba0d6d9a$var$_vA.set(-0.5, -0.5, 0), $a1724dcfba0d6d9a$var$_mvPosition, center, $a1724dcfba0d6d9a$var$_worldScale, sin, cos);
                $a1724dcfba0d6d9a$var$transformVertex($a1724dcfba0d6d9a$var$_vB.set(0.5, -0.5, 0), $a1724dcfba0d6d9a$var$_mvPosition, center, $a1724dcfba0d6d9a$var$_worldScale, sin, cos);
                $a1724dcfba0d6d9a$var$transformVertex($a1724dcfba0d6d9a$var$_vC.set(0.5, 0.5, 0), $a1724dcfba0d6d9a$var$_mvPosition, center, $a1724dcfba0d6d9a$var$_worldScale, sin, cos);
                $a1724dcfba0d6d9a$var$_uvA.set(0, 0);
                $a1724dcfba0d6d9a$var$_uvB.set(1, 0);
                $a1724dcfba0d6d9a$var$_uvC.set(1, 1);
                // check first triangle
                var intersect = raycaster.ray.intersectTriangle($a1724dcfba0d6d9a$var$_vA, $a1724dcfba0d6d9a$var$_vB, $a1724dcfba0d6d9a$var$_vC, false, $a1724dcfba0d6d9a$var$_intersectPoint);
                if (intersect === null) {
                    // check second triangle
                    $a1724dcfba0d6d9a$var$transformVertex($a1724dcfba0d6d9a$var$_vB.set(-0.5, 0.5, 0), $a1724dcfba0d6d9a$var$_mvPosition, center, $a1724dcfba0d6d9a$var$_worldScale, sin, cos);
                    $a1724dcfba0d6d9a$var$_uvB.set(0, 1);
                    intersect = raycaster.ray.intersectTriangle($a1724dcfba0d6d9a$var$_vA, $a1724dcfba0d6d9a$var$_vC, $a1724dcfba0d6d9a$var$_vB, false, $a1724dcfba0d6d9a$var$_intersectPoint);
                    if (intersect === null) return;
                }
                var distance = raycaster.ray.origin.distanceTo($a1724dcfba0d6d9a$var$_intersectPoint);
                if (distance < raycaster.near || distance > raycaster.far) return;
                intersects.push({
                    distance: distance,
                    point: $a1724dcfba0d6d9a$var$_intersectPoint.clone(),
                    uv: $a1724dcfba0d6d9a$export$5a465592bfe74b48.getInterpolation($a1724dcfba0d6d9a$var$_intersectPoint, $a1724dcfba0d6d9a$var$_vA, $a1724dcfba0d6d9a$var$_vB, $a1724dcfba0d6d9a$var$_vC, $a1724dcfba0d6d9a$var$_uvA, $a1724dcfba0d6d9a$var$_uvB, $a1724dcfba0d6d9a$var$_uvC, new $a1724dcfba0d6d9a$export$c977b3e384af9ae1()),
                    face: null,
                    object: this
                });
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Sprite.prototype), "copy", this).call(this, source, recursive);
                if (source.center !== undefined) this.center.copy(source.center);
                this.material = source.material;
                return this;
            }
        }
    ]);
    return Sprite;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
function $a1724dcfba0d6d9a$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $a1724dcfba0d6d9a$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $a1724dcfba0d6d9a$var$_rotatedPosition.x = cos * $a1724dcfba0d6d9a$var$_alignedPosition.x - sin * $a1724dcfba0d6d9a$var$_alignedPosition.y;
        $a1724dcfba0d6d9a$var$_rotatedPosition.y = sin * $a1724dcfba0d6d9a$var$_alignedPosition.x + cos * $a1724dcfba0d6d9a$var$_alignedPosition.y;
    } else $a1724dcfba0d6d9a$var$_rotatedPosition.copy($a1724dcfba0d6d9a$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $a1724dcfba0d6d9a$var$_rotatedPosition.x;
    vertexPosition.y += $a1724dcfba0d6d9a$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($a1724dcfba0d6d9a$var$_viewWorldMatrix);
}
var $a1724dcfba0d6d9a$var$_v1$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v2$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$112e7237be0c5f30 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(LOD, Object3D);
    function LOD() {
        (0, $jGAMp._)(this, LOD);
        var _this;
        _this = (0, $kzDuW._)(this, LOD);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ _this._currentLevel = 0;
        _this.type = 'LOD';
        Object.defineProperties(_this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.autoUpdate = true;
        return _this;
    }
    (0, $byiyg._)(LOD, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LOD.prototype), "copy", this).call(this, source, false);
                var levels = source.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    this.addLevel(level.object.clone(), level.distance, level.hysteresis);
                }
                this.autoUpdate = source.autoUpdate;
                return this;
            }
        },
        {
            /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ key: "addLevel",
            value: function addLevel(object) {
                var distance = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, hysteresis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                distance = Math.abs(distance);
                var levels = this.levels;
                var l;
                for(l = 0; l < levels.length; l++){
                    if (distance < levels[l].distance) break;
                }
                levels.splice(l, 0, {
                    distance: distance,
                    hysteresis: hysteresis,
                    object: object
                });
                this.add(object);
                return this;
            }
        },
        {
            /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ key: "removeLevel",
            value: function removeLevel(distance) {
                var levels = this.levels;
                for(var i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
                    var removedElements = levels.splice(i, 1);
                    this.remove(removedElements[0].object);
                    return true;
                }
                return false;
            }
        },
        {
            /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ key: "getCurrentLevel",
            value: function getCurrentLevel() {
                return this._currentLevel;
            }
        },
        {
            /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {Object3D|null} The found 3D object. `null` if no 3D object has been found.
	 */ key: "getObjectForDistance",
            value: function getObjectForDistance(distance) {
                var levels = this.levels;
                if (levels.length > 0) {
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        var levelDistance = levels[i].distance;
                        if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                        if (distance < levelDistance) break;
                    }
                    return levels[i - 1].object;
                }
                return null;
            }
        },
        {
            /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                var levels = this.levels;
                if (levels.length > 0) {
                    $a1724dcfba0d6d9a$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
                    var distance = raycaster.ray.origin.distanceTo($a1724dcfba0d6d9a$var$_v1$2);
                    this.getObjectForDistance(distance).raycast(raycaster, intersects);
                }
            }
        },
        {
            /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ key: "update",
            value: function update(camera) {
                var levels = this.levels;
                if (levels.length > 1) {
                    $a1724dcfba0d6d9a$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
                    $a1724dcfba0d6d9a$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
                    var distance = $a1724dcfba0d6d9a$var$_v1$2.distanceTo($a1724dcfba0d6d9a$var$_v2$1) / camera.zoom;
                    levels[0].object.visible = true;
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        var levelDistance = levels[i].distance;
                        if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                        if (distance >= levelDistance) {
                            levels[i - 1].object.visible = false;
                            levels[i].object.visible = true;
                        } else break;
                    }
                    this._currentLevel = i - 1;
                    for(; i < l; i++)levels[i].object.visible = false;
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(LOD.prototype), "toJSON", this).call(this, meta);
                if (this.autoUpdate === false) data.object.autoUpdate = false;
                data.object.levels = [];
                var levels = this.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    data.object.levels.push({
                        object: level.object.uuid,
                        distance: level.distance,
                        hysteresis: level.hysteresis
                    });
                }
                return data;
            }
        }
    ]);
    return LOD;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_basePosition = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_skinIndex = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
var $a1724dcfba0d6d9a$var$_skinWeight = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
var $a1724dcfba0d6d9a$var$_vector3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_matrix4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_vertex = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_sphere$5 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_inverseMatrix$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_ray$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 */ var $a1724dcfba0d6d9a$export$b303577035157ecf = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $i3fW3._)(SkinnedMesh, Mesh);
    function SkinnedMesh(geometry, material) {
        (0, $jGAMp._)(this, SkinnedMesh);
        var _this;
        _this = (0, $kzDuW._)(this, SkinnedMesh, [
            geometry,
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSkinnedMesh = true;
        _this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ _this.bindMode = $a1724dcfba0d6d9a$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ _this.bindMatrix = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ _this.bindMatrixInverse = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ _this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ _this.boundingSphere = null;
        return _this;
    }
    (0, $byiyg._)(SkinnedMesh, [
        {
            /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ key: "computeBoundingBox",
            value: function computeBoundingBox() {
                var geometry = this.geometry;
                if (this.boundingBox === null) this.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                this.boundingBox.makeEmpty();
                var positionAttribute = geometry.getAttribute('position');
                for(var i = 0; i < positionAttribute.count; i++){
                    this.getVertexPosition(i, $a1724dcfba0d6d9a$var$_vertex);
                    this.boundingBox.expandByPoint($a1724dcfba0d6d9a$var$_vertex);
                }
            }
        },
        {
            /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                var geometry = this.geometry;
                if (this.boundingSphere === null) this.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                this.boundingSphere.makeEmpty();
                var positionAttribute = geometry.getAttribute('position');
                for(var i = 0; i < positionAttribute.count; i++){
                    this.getVertexPosition(i, $a1724dcfba0d6d9a$var$_vertex);
                    this.boundingSphere.expandByPoint($a1724dcfba0d6d9a$var$_vertex);
                }
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(SkinnedMesh.prototype), "copy", this).call(this, source, recursive);
                this.bindMode = source.bindMode;
                this.bindMatrix.copy(source.bindMatrix);
                this.bindMatrixInverse.copy(source.bindMatrixInverse);
                this.skeleton = source.skeleton;
                if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
                if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return;
                // test with bounding sphere in world space
                if (this.boundingSphere === null) this.computeBoundingSphere();
                $a1724dcfba0d6d9a$var$_sphere$5.copy(this.boundingSphere);
                $a1724dcfba0d6d9a$var$_sphere$5.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$5) === false) return;
                // convert ray to local space of skinned mesh
                $a1724dcfba0d6d9a$var$_inverseMatrix$2.copy(matrixWorld).invert();
                $a1724dcfba0d6d9a$var$_ray$2.copy(raycaster.ray).applyMatrix4($a1724dcfba0d6d9a$var$_inverseMatrix$2);
                // test with bounding box in local space
                if (this.boundingBox !== null) {
                    if ($a1724dcfba0d6d9a$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
                }
                // test for intersections with geometry
                this._computeIntersections(raycaster, intersects, $a1724dcfba0d6d9a$var$_ray$2);
            }
        },
        {
            key: "getVertexPosition",
            value: function getVertexPosition(index, target) {
                (0, $fXhL4._)((0, $hxFDX._)(SkinnedMesh.prototype), "getVertexPosition", this).call(this, index, target);
                this.applyBoneTransform(index, target);
                return target;
            }
        },
        {
            /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ key: "bind",
            value: function bind(skeleton, bindMatrix) {
                this.skeleton = skeleton;
                if (bindMatrix === undefined) {
                    this.updateMatrixWorld(true);
                    this.skeleton.calculateInverses();
                    bindMatrix = this.matrixWorld;
                }
                this.bindMatrix.copy(bindMatrix);
                this.bindMatrixInverse.copy(bindMatrix).invert();
            }
        },
        {
            /**
	 * This method sets the skinned mesh in the rest pose).
	 */ key: "pose",
            value: function pose() {
                this.skeleton.pose();
            }
        },
        {
            /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ key: "normalizeSkinWeights",
            value: function normalizeSkinWeights() {
                var vector = new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3();
                var skinWeight = this.geometry.attributes.skinWeight;
                for(var i = 0, l = skinWeight.count; i < l; i++){
                    vector.fromBufferAttribute(skinWeight, i);
                    var scale = 1.0 / vector.manhattanLength();
                    if (scale !== Infinity) vector.multiplyScalar(scale);
                    else vector.set(1, 0, 0, 0); // do something reasonable
                    skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
                }
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $fXhL4._)((0, $hxFDX._)(SkinnedMesh.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.bindMode === $a1724dcfba0d6d9a$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
                else if (this.bindMode === $a1724dcfba0d6d9a$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
                else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
            }
        },
        {
            /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ key: "applyBoneTransform",
            value: function applyBoneTransform(index, target) {
                var skeleton = this.skeleton;
                var geometry = this.geometry;
                $a1724dcfba0d6d9a$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
                $a1724dcfba0d6d9a$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
                $a1724dcfba0d6d9a$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
                target.set(0, 0, 0);
                for(var i = 0; i < 4; i++){
                    var weight = $a1724dcfba0d6d9a$var$_skinWeight.getComponent(i);
                    if (weight !== 0) {
                        var boneIndex = $a1724dcfba0d6d9a$var$_skinIndex.getComponent(i);
                        $a1724dcfba0d6d9a$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                        target.addScaledVector($a1724dcfba0d6d9a$var$_vector3.copy($a1724dcfba0d6d9a$var$_basePosition).applyMatrix4($a1724dcfba0d6d9a$var$_matrix4), weight);
                    }
                }
                return target.applyMatrix4(this.bindMatrixInverse);
            }
        }
    ]);
    return SkinnedMesh;
}($a1724dcfba0d6d9a$export$e176487c05830cc5);
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$b127726e56765aa4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Bone, Object3D);
    function Bone() {
        (0, $jGAMp._)(this, Bone);
        var _this;
        _this = (0, $kzDuW._)(this, Bone);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isBone = true;
        _this.type = 'Bone';
        return _this;
    }
    return Bone;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$b691f601014eabe1 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(DataTexture, Texture);
    function DataTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, format = arguments.length > 3 ? arguments[3] : void 0, type = arguments.length > 4 ? arguments[4] : void 0, mapping = arguments.length > 5 ? arguments[5] : void 0, wrapS = arguments.length > 6 ? arguments[6] : void 0, wrapT = arguments.length > 7 ? arguments[7] : void 0, magFilter = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0, minFilter = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0, anisotropy = arguments.length > 10 ? arguments[10] : void 0, colorSpace = arguments.length > 11 ? arguments[11] : void 0;
        (0, $jGAMp._)(this, DataTexture);
        var _this;
        _this = (0, $kzDuW._)(this, DataTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ _this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ _this.unpackAlignment = 1;
        return _this;
    }
    return DataTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
var $a1724dcfba0d6d9a$var$_offsetMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_identityMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ var $a1724dcfba0d6d9a$export$8f31e4c4a37b8e9c = /*#__PURE__*/ function() {
    "use strict";
    function Skeleton() {
        var bones = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], boneInverses = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        (0, $jGAMp._)(this, Skeleton);
        this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    (0, $byiyg._)(Skeleton, [
        {
            /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ key: "init",
            value: function init() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                this.boneMatrices = new Float32Array(bones.length * 16);
                // calculate inverse bone matrices if necessary
                if (boneInverses.length === 0) this.calculateInverses();
                else // handle special case
                if (bones.length !== boneInverses.length) {
                    console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
                    this.boneInverses = [];
                    for(var i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5());
                }
            }
        },
        {
            /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ key: "calculateInverses",
            value: function calculateInverses() {
                this.boneInverses.length = 0;
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var inverse = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
                    if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
                    this.boneInverses.push(inverse);
                }
            }
        },
        {
            /**
	 * Resets the skeleton to the base pose.
	 */ key: "pose",
            value: function pose() {
                // recover the bind-time world matrices
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
                }
                // compute the local matrices, positions, rotations and scales
                for(var i1 = 0, il1 = this.bones.length; i1 < il1; i1++){
                    var bone1 = this.bones[i1];
                    if (bone1) {
                        if (bone1.parent && bone1.parent.isBone) {
                            bone1.matrix.copy(bone1.parent.matrixWorld).invert();
                            bone1.matrix.multiply(bone1.matrixWorld);
                        } else bone1.matrix.copy(bone1.matrixWorld);
                        bone1.matrix.decompose(bone1.position, bone1.quaternion, bone1.scale);
                    }
                }
            }
        },
        {
            /**
	 * Resets the skeleton to the base pose.
	 */ key: "update",
            value: function update() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                var boneMatrices = this.boneMatrices;
                var boneTexture = this.boneTexture;
                // flatten bone matrices to array
                for(var i = 0, il = bones.length; i < il; i++){
                    // compute the offset between the current and the original transform
                    var matrix = bones[i] ? bones[i].matrixWorld : $a1724dcfba0d6d9a$var$_identityMatrix;
                    $a1724dcfba0d6d9a$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
                    $a1724dcfba0d6d9a$var$_offsetMatrix.toArray(boneMatrices, i * 16);
                }
                if (boneTexture !== null) boneTexture.needsUpdate = true;
            }
        },
        {
            /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new Skeleton(this.bones, this.boneInverses);
            }
        },
        {
            /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ key: "computeBoneTexture",
            value: function computeBoneTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                var size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
                size = Math.ceil(size / 4) * 4;
                size = Math.max(size, 4);
                var boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                boneMatrices.set(this.boneMatrices); // copy current values
                var boneTexture = new $a1724dcfba0d6d9a$export$b691f601014eabe1(boneMatrices, size, size, $a1724dcfba0d6d9a$export$3f8bb04b555a363c, $a1724dcfba0d6d9a$export$f6d331659b644596);
                boneTexture.needsUpdate = true;
                this.boneMatrices = boneMatrices;
                this.boneTexture = boneTexture;
                return this;
            }
        },
        {
            /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ key: "getBoneByName",
            value: function getBoneByName(name) {
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone.name === name) return bone;
                }
                return undefined;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                if (this.boneTexture !== null) {
                    this.boneTexture.dispose();
                    this.boneTexture = null;
                }
            }
        },
        {
            /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ key: "fromJSON",
            value: function fromJSON(json, bones) {
                this.uuid = json.uuid;
                for(var i = 0, l = json.bones.length; i < l; i++){
                    var uuid = json.bones[i];
                    var bone = bones[uuid];
                    if (bone === undefined) {
                        console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                        bone = new $a1724dcfba0d6d9a$export$b127726e56765aa4();
                    }
                    this.bones.push(bone);
                    this.boneInverses.push(new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
                }
                this.init();
                return this;
            }
        },
        {
            /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.7,
                        type: 'Skeleton',
                        generator: 'Skeleton.toJSON'
                    },
                    bones: [],
                    boneInverses: []
                };
                data.uuid = this.uuid;
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                for(var i = 0, l = bones.length; i < l; i++){
                    var bone = bones[i];
                    data.bones.push(bone.uuid);
                    var boneInverse = boneInverses[i];
                    data.boneInverses.push(boneInverse.toArray());
                }
                return data;
            }
        }
    ]);
    return Skeleton;
}();
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ var $a1724dcfba0d6d9a$export$32ea87a8b54d744a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $i3fW3._)(InstancedBufferAttribute, BufferAttribute);
    function InstancedBufferAttribute(array, itemSize, normalized) {
        var meshPerAttribute = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, InstancedBufferAttribute);
        var _this;
        _this = (0, $kzDuW._)(this, InstancedBufferAttribute, [
            array,
            itemSize,
            normalized
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $byiyg._)(InstancedBufferAttribute, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(InstancedBufferAttribute.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(InstancedBufferAttribute.prototype), "toJSON", this).call(this);
                data.meshPerAttribute = this.meshPerAttribute;
                data.isInstancedBufferAttribute = true;
                return data;
            }
        }
    ]);
    return InstancedBufferAttribute;
}($a1724dcfba0d6d9a$export$8dea267bd6bde117);
var $a1724dcfba0d6d9a$var$_instanceLocalMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_instanceWorldMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_instanceIntersects = [];
var $a1724dcfba0d6d9a$var$_box3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
var $a1724dcfba0d6d9a$var$_identity = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_mesh$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$e176487c05830cc5();
var $a1724dcfba0d6d9a$var$_sphere$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ var $a1724dcfba0d6d9a$export$f3c979c331175ad7 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $i3fW3._)(InstancedMesh, Mesh);
    function InstancedMesh(geometry, material, count) {
        (0, $jGAMp._)(this, InstancedMesh);
        var _this;
        _this = (0, $kzDuW._)(this, InstancedMesh, [
            geometry,
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ _this.instanceMatrix = new $a1724dcfba0d6d9a$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ _this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ _this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ _this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ _this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ _this.boundingSphere = null;
        for(var i = 0; i < count; i++)_this.setMatrixAt(i, $a1724dcfba0d6d9a$var$_identity);
        return _this;
    }
    (0, $byiyg._)(InstancedMesh, [
        {
            /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ key: "computeBoundingBox",
            value: function computeBoundingBox() {
                var geometry = this.geometry;
                var count = this.count;
                if (this.boundingBox === null) this.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                this.boundingBox.makeEmpty();
                for(var i = 0; i < count; i++){
                    this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    $a1724dcfba0d6d9a$var$_box3.copy(geometry.boundingBox).applyMatrix4($a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    this.boundingBox.union($a1724dcfba0d6d9a$var$_box3);
                }
            }
        },
        {
            /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                var geometry = this.geometry;
                var count = this.count;
                if (this.boundingSphere === null) this.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                this.boundingSphere.makeEmpty();
                for(var i = 0; i < count; i++){
                    this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    $a1724dcfba0d6d9a$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    this.boundingSphere.union($a1724dcfba0d6d9a$var$_sphere$4);
                }
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(InstancedMesh.prototype), "copy", this).call(this, source, recursive);
                this.instanceMatrix.copy(source.instanceMatrix);
                if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
                if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
                this.count = source.count;
                if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
                if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
                return this;
            }
        },
        {
            /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ key: "getColorAt",
            value: function getColorAt(index, color) {
                color.fromArray(this.instanceColor.array, index * 3);
            }
        },
        {
            /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ key: "getMatrixAt",
            value: function getMatrixAt(index, matrix) {
                matrix.fromArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ key: "getMorphAt",
            value: function getMorphAt(index, object) {
                var objectInfluences = object.morphTargetInfluences;
                var array = this.morphTexture.source.data.data;
                var len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
                var dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
                for(var i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var matrixWorld = this.matrixWorld;
                var raycastTimes = this.count;
                $a1724dcfba0d6d9a$var$_mesh$1.geometry = this.geometry;
                $a1724dcfba0d6d9a$var$_mesh$1.material = this.material;
                if ($a1724dcfba0d6d9a$var$_mesh$1.material === undefined) return;
                // test with bounding sphere first
                if (this.boundingSphere === null) this.computeBoundingSphere();
                $a1724dcfba0d6d9a$var$_sphere$4.copy(this.boundingSphere);
                $a1724dcfba0d6d9a$var$_sphere$4.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$4) === false) return;
                // now test each instance
                for(var instanceId = 0; instanceId < raycastTimes; instanceId++){
                    // calculate the world matrix for each instance
                    this.getMatrixAt(instanceId, $a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    $a1724dcfba0d6d9a$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $a1724dcfba0d6d9a$var$_instanceLocalMatrix);
                    // the mesh represents this single instance
                    $a1724dcfba0d6d9a$var$_mesh$1.matrixWorld = $a1724dcfba0d6d9a$var$_instanceWorldMatrix;
                    $a1724dcfba0d6d9a$var$_mesh$1.raycast(raycaster, $a1724dcfba0d6d9a$var$_instanceIntersects);
                    // process the result of raycast
                    for(var i = 0, l = $a1724dcfba0d6d9a$var$_instanceIntersects.length; i < l; i++){
                        var intersect = $a1724dcfba0d6d9a$var$_instanceIntersects[i];
                        intersect.instanceId = instanceId;
                        intersect.object = this;
                        intersects.push(intersect);
                    }
                    $a1724dcfba0d6d9a$var$_instanceIntersects.length = 0;
                }
            }
        },
        {
            /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ key: "setColorAt",
            value: function setColorAt(index, color) {
                if (this.instanceColor === null) this.instanceColor = new $a1724dcfba0d6d9a$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
                color.toArray(this.instanceColor.array, index * 3);
            }
        },
        {
            /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ key: "setMatrixAt",
            value: function setMatrixAt(index, matrix) {
                matrix.toArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ key: "setMorphAt",
            value: function setMorphAt(index, object) {
                var objectInfluences = object.morphTargetInfluences;
                var len = objectInfluences.length + 1; // morphBaseInfluence + all influences
                if (this.morphTexture === null) this.morphTexture = new $a1724dcfba0d6d9a$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $a1724dcfba0d6d9a$export$4e041a7967d15c4b, $a1724dcfba0d6d9a$export$f6d331659b644596);
                var array = this.morphTexture.source.data.data;
                var morphInfluencesSum = 0;
                for(var i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
                var morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
                var dataIndex = len * index;
                array[dataIndex] = morphBaseInfluence;
                array.set(objectInfluences, dataIndex + 1);
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {}
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
                if (this.morphTexture !== null) {
                    this.morphTexture.dispose();
                    this.morphTexture = null;
                }
            }
        }
    ]);
    return InstancedMesh;
}($a1724dcfba0d6d9a$export$e176487c05830cc5);
var $a1724dcfba0d6d9a$var$_vector1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vector2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_normalMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form]{@link http://mathworld.wolfram.com/HessianNormalForm.html}
 * by a unit length normal vector and a constant.
 */ var $a1724dcfba0d6d9a$export$7ff5ac152ef991b0 = /*#__PURE__*/ function() {
    "use strict";
    function Plane() {
        var normal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 0, 0), constant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, Plane);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    (0, $byiyg._)(Plane, [
        {
            /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ key: "set",
            value: function set(normal, constant) {
                this.normal.copy(normal);
                this.constant = constant;
                return this;
            }
        },
        {
            /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ key: "setComponents",
            value: function setComponents(x, y, z, w) {
                this.normal.set(x, y, z);
                this.constant = w;
                return this;
            }
        },
        {
            /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ key: "setFromNormalAndCoplanarPoint",
            value: function setFromNormalAndCoplanarPoint(normal, point) {
                this.normal.copy(normal);
                this.constant = -point.dot(this.normal);
                return this;
            }
        },
        {
            /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ key: "setFromCoplanarPoints",
            value: function setFromCoplanarPoints(a, b, c) {
                var normal = $a1724dcfba0d6d9a$var$_vector1.subVectors(c, b).cross($a1724dcfba0d6d9a$var$_vector2.subVectors(a, b)).normalize();
                // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
                this.setFromNormalAndCoplanarPoint(normal, a);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ key: "copy",
            value: function copy(plane) {
                this.normal.copy(plane.normal);
                this.constant = plane.constant;
                return this;
            }
        },
        {
            /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ key: "normalize",
            value: function normalize() {
                // Note: will lead to a divide by zero if the plane is invalid.
                var inverseNormalLength = 1.0 / this.normal.length();
                this.normal.multiplyScalar(inverseNormalLength);
                this.constant *= inverseNormalLength;
                return this;
            }
        },
        {
            /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ key: "negate",
            value: function negate() {
                this.constant *= -1;
                this.normal.negate();
                return this;
            }
        },
        {
            /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.normal.dot(point) + this.constant;
            }
        },
        {
            /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ key: "distanceToSphere",
            value: function distanceToSphere(sphere) {
                return this.distanceToPoint(sphere.center) - sphere.radius;
            }
        },
        {
            /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ key: "projectPoint",
            value: function projectPoint(point, target) {
                return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
            }
        },
        {
            /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ key: "intersectLine",
            value: function intersectLine(line, target) {
                var direction = line.delta($a1724dcfba0d6d9a$var$_vector1);
                var denominator = this.normal.dot(direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
                    // Unsure if this is the correct method to handle this case.
                    return null;
                }
                var t = -(line.start.dot(this.normal) + this.constant) / denominator;
                if (t < 0 || t > 1) return null;
                return target.copy(line.start).addScaledVector(direction, t);
            }
        },
        {
            /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ key: "intersectsLine",
            value: function intersectsLine(line) {
                // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
                var startSign = this.distanceToPoint(line.start);
                var endSign = this.distanceToPoint(line.end);
                return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
            }
        },
        {
            /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsPlane(this);
            }
        },
        {
            /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                return sphere.intersectsPlane(this);
            }
        },
        {
            /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ key: "coplanarPoint",
            value: function coplanarPoint(target) {
                return target.copy(this.normal).multiplyScalar(-this.constant);
            }
        },
        {
            /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix, optionalNormalMatrix) {
                var normalMatrix = optionalNormalMatrix || $a1724dcfba0d6d9a$var$_normalMatrix.getNormalMatrix(matrix);
                var referencePoint = this.coplanarPoint($a1724dcfba0d6d9a$var$_vector1).applyMatrix4(matrix);
                var normal = this.normal.applyMatrix3(normalMatrix).normalize();
                this.constant = -referencePoint.dot(normal);
                return this;
            }
        },
        {
            /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ key: "translate",
            value: function translate(offset) {
                this.constant -= offset.dot(this.normal);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ key: "equals",
            value: function equals(plane) {
                return plane.normal.equals(this.normal) && plane.constant === this.constant;
            }
        },
        {
            /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Plane;
}();
var $a1724dcfba0d6d9a$var$_sphere$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_defaultSpriteCenter = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, 0.5);
var $a1724dcfba0d6d9a$var$_vector$6 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ var $a1724dcfba0d6d9a$export$35efe6f4c85463d2 = /*#__PURE__*/ function() {
    "use strict";
    function Frustum() {
        var p0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0(), p1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0(), p2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0(), p3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0(), p4 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0(), p5 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : new $a1724dcfba0d6d9a$export$7ff5ac152ef991b0();
        (0, $jGAMp._)(this, Frustum);
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    (0, $byiyg._)(Frustum, [
        {
            /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ key: "set",
            value: function set(p0, p1, p2, p3, p4, p5) {
                var planes = this.planes;
                planes[0].copy(p0);
                planes[1].copy(p1);
                planes[2].copy(p2);
                planes[3].copy(p3);
                planes[4].copy(p4);
                planes[5].copy(p5);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ key: "copy",
            value: function copy(frustum) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
                return this;
            }
        },
        {
            /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @return {Frustum} A reference to this frustum.
	 */ key: "setFromProjectionMatrix",
            value: function setFromProjectionMatrix(m) {
                var coordinateSystem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a1724dcfba0d6d9a$export$5a0e9190d10875d3;
                var planes = this.planes;
                var me = m.elements;
                var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
                var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
                var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
                var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
                planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
                planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
                planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
                planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
                planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
                if (coordinateSystem === $a1724dcfba0d6d9a$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
                else if (coordinateSystem === $a1724dcfba0d6d9a$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
                else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ key: "intersectsObject",
            value: function intersectsObject(object) {
                if (object.boundingSphere !== undefined) {
                    if (object.boundingSphere === null) object.computeBoundingSphere();
                    $a1724dcfba0d6d9a$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
                } else {
                    var geometry = object.geometry;
                    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                    $a1724dcfba0d6d9a$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
                }
                return this.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$3);
            }
        },
        {
            /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ key: "intersectsSprite",
            value: function intersectsSprite(sprite) {
                $a1724dcfba0d6d9a$var$_sphere$3.center.set(0, 0, 0);
                var offset = $a1724dcfba0d6d9a$var$_defaultSpriteCenter.distanceTo(sprite.center);
                $a1724dcfba0d6d9a$var$_sphere$3.radius = 0.7071067811865476 + offset;
                $a1724dcfba0d6d9a$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
                return this.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$3);
            }
        },
        {
            /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var planes = this.planes;
                var center = sphere.center;
                var negRadius = -sphere.radius;
                for(var i = 0; i < 6; i++){
                    var distance = planes[i].distanceToPoint(center);
                    if (distance < negRadius) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    var plane = planes[i];
                    // corner at max distance
                    $a1724dcfba0d6d9a$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
                    $a1724dcfba0d6d9a$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
                    $a1724dcfba0d6d9a$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
                    if (plane.distanceToPoint($a1724dcfba0d6d9a$var$_vector$6) < 0) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ key: "containsPoint",
            value: function containsPoint(point) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    if (planes[i].distanceToPoint(point) < 0) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Frustum;
}();
var $a1724dcfba0d6d9a$var$_projScreenMatrix$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_frustum$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ var $a1724dcfba0d6d9a$export$2d7d04327620499c = /*#__PURE__*/ function() {
    "use strict";
    function FrustumArray() {
        (0, $jGAMp._)(this, FrustumArray);
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $a1724dcfba0d6d9a$export$5a0e9190d10875d3;
    }
    (0, $byiyg._)(FrustumArray, [
        {
            /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ key: "intersectsObject",
            value: function intersectsObject(object, cameraArray) {
                if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
                for(var i = 0; i < cameraArray.cameras.length; i++){
                    var camera = cameraArray.cameras[i];
                    $a1724dcfba0d6d9a$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    $a1724dcfba0d6d9a$var$_frustum$1.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$2, this.coordinateSystem);
                    if ($a1724dcfba0d6d9a$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
                }
                return false; // Not visible in any camera
            }
        },
        {
            /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ key: "intersectsSprite",
            value: function intersectsSprite(sprite, cameraArray) {
                if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
                for(var i = 0; i < cameraArray.cameras.length; i++){
                    var camera = cameraArray.cameras[i];
                    $a1724dcfba0d6d9a$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    $a1724dcfba0d6d9a$var$_frustum$1.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$2, this.coordinateSystem);
                    if ($a1724dcfba0d6d9a$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
                }
                return false; // Not visible in any camera
            }
        },
        {
            /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ key: "intersectsSphere",
            value: function intersectsSphere(sphere, cameraArray) {
                if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
                for(var i = 0; i < cameraArray.cameras.length; i++){
                    var camera = cameraArray.cameras[i];
                    $a1724dcfba0d6d9a$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    $a1724dcfba0d6d9a$var$_frustum$1.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$2, this.coordinateSystem);
                    if ($a1724dcfba0d6d9a$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
                }
                return false; // Not visible in any camera
            }
        },
        {
            /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ key: "intersectsBox",
            value: function intersectsBox(box, cameraArray) {
                if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
                for(var i = 0; i < cameraArray.cameras.length; i++){
                    var camera = cameraArray.cameras[i];
                    $a1724dcfba0d6d9a$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    $a1724dcfba0d6d9a$var$_frustum$1.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$2, this.coordinateSystem);
                    if ($a1724dcfba0d6d9a$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
                }
                return false; // Not visible in any camera
            }
        },
        {
            /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ key: "containsPoint",
            value: function containsPoint(point, cameraArray) {
                if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
                for(var i = 0; i < cameraArray.cameras.length; i++){
                    var camera = cameraArray.cameras[i];
                    $a1724dcfba0d6d9a$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    $a1724dcfba0d6d9a$var$_frustum$1.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$2, this.coordinateSystem);
                    if ($a1724dcfba0d6d9a$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
                }
                return false; // Not visible in any camera
            }
        },
        {
            /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new FrustumArray();
            }
        }
    ]);
    return FrustumArray;
}();
function $a1724dcfba0d6d9a$var$ascIdSort(a, b) {
    return a - b;
}
function $a1724dcfba0d6d9a$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $a1724dcfba0d6d9a$var$sortTransparent(a, b) {
    return b.z - a.z;
}
var $a1724dcfba0d6d9a$var$MultiDrawRenderList = /*#__PURE__*/ function() {
    "use strict";
    function MultiDrawRenderList() {
        (0, $jGAMp._)(this, MultiDrawRenderList);
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    (0, $byiyg._)(MultiDrawRenderList, [
        {
            key: "push",
            value: function push(start, count, z, index) {
                var pool = this.pool;
                var list = this.list;
                if (this.index >= pool.length) pool.push({
                    start: -1,
                    count: -1,
                    z: -1,
                    index: -1
                });
                var item = pool[this.index];
                list.push(item);
                this.index++;
                item.start = start;
                item.count = count;
                item.z = z;
                item.index = index;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.list.length = 0;
                this.index = 0;
            }
        }
    ]);
    return MultiDrawRenderList;
}();
var $a1724dcfba0d6d9a$var$_matrix$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_whiteColor = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$892596cec99bc70e(1, 1, 1);
var $a1724dcfba0d6d9a$var$_frustum = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$35efe6f4c85463d2();
var $a1724dcfba0d6d9a$var$_frustumArray = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2d7d04327620499c();
var $a1724dcfba0d6d9a$var$_box$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
var $a1724dcfba0d6d9a$var$_sphere$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_vector$5 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_forward$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_temp = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_renderList = /*@__PURE__*/ new $a1724dcfba0d6d9a$var$MultiDrawRenderList();
var $a1724dcfba0d6d9a$var$_mesh = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$e176487c05830cc5();
var $a1724dcfba0d6d9a$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $a1724dcfba0d6d9a$var$copyAttributeData(src, target) {
    var targetOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        var vertexCount = src.count;
        for(var i = 0; i < vertexCount; i++)for(var c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $a1724dcfba0d6d9a$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        var len = Math.min(src.length, target.length);
        for(var i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        var len1 = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len1));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ var $a1724dcfba0d6d9a$export$6e01c5ee52ed8f7b = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $i3fW3._)(BatchedMesh, Mesh);
    function BatchedMesh(maxInstanceCount, maxVertexCount) {
        var maxIndexCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : maxVertexCount * 2, material = arguments.length > 3 ? arguments[3] : void 0;
        (0, $jGAMp._)(this, BatchedMesh);
        var _this;
        _this = (0, $kzDuW._)(this, BatchedMesh, [
            new $a1724dcfba0d6d9a$export$b7be63a67df8959(),
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ _this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ _this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ _this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        _this._instanceInfo = [];
        _this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        _this._availableInstanceIds = [];
        _this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        _this._nextIndexStart = 0;
        _this._nextVertexStart = 0;
        _this._geometryCount = 0;
        // flags
        _this._visibilityChanged = true;
        _this._geometryInitialized = false;
        // cached user options
        _this._maxInstanceCount = maxInstanceCount;
        _this._maxVertexCount = maxVertexCount;
        _this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        _this._multiDrawCounts = new Int32Array(maxInstanceCount);
        _this._multiDrawStarts = new Int32Array(maxInstanceCount);
        _this._multiDrawCount = 0;
        _this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        _this._matricesTexture = null;
        _this._indirectTexture = null;
        _this._colorsTexture = null;
        _this._initMatricesTexture();
        _this._initIndirectTexture();
        return _this;
    }
    (0, $byiyg._)(BatchedMesh, [
        {
            key: "maxInstanceCount",
            get: /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ function get() {
                return this._maxInstanceCount;
            }
        },
        {
            key: "instanceCount",
            get: /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ function get() {
                return this._instanceInfo.length - this._availableInstanceIds.length;
            }
        },
        {
            key: "unusedVertexCount",
            get: /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ function get() {
                return this._maxVertexCount - this._nextVertexStart;
            }
        },
        {
            key: "unusedIndexCount",
            get: /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ function get() {
                return this._maxIndexCount - this._nextIndexStart;
            }
        },
        {
            key: "_initMatricesTexture",
            value: function _initMatricesTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
                var size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
                size = Math.ceil(size / 4) * 4;
                size = Math.max(size, 4);
                var matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                var matricesTexture = new $a1724dcfba0d6d9a$export$b691f601014eabe1(matricesArray, size, size, $a1724dcfba0d6d9a$export$3f8bb04b555a363c, $a1724dcfba0d6d9a$export$f6d331659b644596);
                this._matricesTexture = matricesTexture;
            }
        },
        {
            key: "_initIndirectTexture",
            value: function _initIndirectTexture() {
                var size = Math.sqrt(this._maxInstanceCount);
                size = Math.ceil(size);
                var indirectArray = new Uint32Array(size * size);
                var indirectTexture = new $a1724dcfba0d6d9a$export$b691f601014eabe1(indirectArray, size, size, $a1724dcfba0d6d9a$export$aa92e870a709d190, $a1724dcfba0d6d9a$export$c3c7fc4518ebba96);
                this._indirectTexture = indirectTexture;
            }
        },
        {
            key: "_initColorsTexture",
            value: function _initColorsTexture() {
                var size = Math.sqrt(this._maxInstanceCount);
                size = Math.ceil(size);
                // 4 floats per RGBA pixel initialized to white
                var colorsArray = new Float32Array(size * size * 4).fill(1);
                var colorsTexture = new $a1724dcfba0d6d9a$export$b691f601014eabe1(colorsArray, size, size, $a1724dcfba0d6d9a$export$3f8bb04b555a363c, $a1724dcfba0d6d9a$export$f6d331659b644596);
                colorsTexture.colorSpace = $a1724dcfba0d6d9a$export$5e6fd513f44698c.workingColorSpace;
                this._colorsTexture = colorsTexture;
            }
        },
        {
            key: "_initializeGeometry",
            value: function _initializeGeometry(reference) {
                var geometry = this.geometry;
                var maxVertexCount = this._maxVertexCount;
                var maxIndexCount = this._maxIndexCount;
                if (this._geometryInitialized === false) {
                    for(var attributeName in reference.attributes){
                        var srcAttribute = reference.getAttribute(attributeName);
                        var array = srcAttribute.array, itemSize = srcAttribute.itemSize, normalized = srcAttribute.normalized;
                        var dstArray = new array.constructor(maxVertexCount * itemSize);
                        var dstAttribute = new $a1724dcfba0d6d9a$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                        geometry.setAttribute(attributeName, dstAttribute);
                    }
                    if (reference.getIndex() !== null) {
                        // Reserve last u16 index for primitive restart.
                        var indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                        geometry.setIndex(new $a1724dcfba0d6d9a$export$8dea267bd6bde117(indexArray, 1));
                    }
                    this._geometryInitialized = true;
                }
            }
        },
        {
            // Make sure the geometry is compatible with the existing combined geometry attributes
            key: "_validateGeometry",
            value: function _validateGeometry(geometry) {
                // check to ensure the geometries are using consistent attributes and indices
                var batchGeometry = this.geometry;
                if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
                for(var attributeName in batchGeometry.attributes){
                    if (!geometry.hasAttribute(attributeName)) throw new Error('THREE.BatchedMesh: Added geometry missing "'.concat(attributeName, '". All geometries must have consistent attributes.'));
                    var srcAttribute = geometry.getAttribute(attributeName);
                    var dstAttribute = batchGeometry.getAttribute(attributeName);
                    if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
                }
            }
        },
        {
            /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ key: "validateInstanceId",
            value: function validateInstanceId(instanceId) {
                var instanceInfo = this._instanceInfo;
                if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error("THREE.BatchedMesh: Invalid instanceId ".concat(instanceId, ". Instance is either out of range or has been deleted."));
            }
        },
        {
            /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ key: "validateGeometryId",
            value: function validateGeometryId(geometryId) {
                var geometryInfoList = this._geometryInfo;
                if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error("THREE.BatchedMesh: Invalid geometryId ".concat(geometryId, ". Geometry is either out of range or has been deleted."));
            }
        },
        {
            /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "setCustomSort",
            value: function setCustomSort(func) {
                this.customSort = func;
                return this;
            }
        },
        {
            /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ key: "computeBoundingBox",
            value: function computeBoundingBox() {
                if (this.boundingBox === null) this.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                var boundingBox = this.boundingBox;
                var instanceInfo = this._instanceInfo;
                boundingBox.makeEmpty();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (instanceInfo[i].active === false) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_matrix$1);
                    this.getBoundingBoxAt(geometryId, $a1724dcfba0d6d9a$var$_box$1).applyMatrix4($a1724dcfba0d6d9a$var$_matrix$1);
                    boundingBox.union($a1724dcfba0d6d9a$var$_box$1);
                }
            }
        },
        {
            /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                if (this.boundingSphere === null) this.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                var boundingSphere = this.boundingSphere;
                var instanceInfo = this._instanceInfo;
                boundingSphere.makeEmpty();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (instanceInfo[i].active === false) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $a1724dcfba0d6d9a$var$_sphere$2).applyMatrix4($a1724dcfba0d6d9a$var$_matrix$1);
                    boundingSphere.union($a1724dcfba0d6d9a$var$_sphere$2);
                }
            }
        },
        {
            /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ key: "addInstance",
            value: function addInstance(geometryId) {
                var atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
                // ensure we're not over geometry
                if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
                var instanceInfo = {
                    visible: true,
                    active: true,
                    geometryIndex: geometryId
                };
                var drawId = null;
                // Prioritize using previously freed instance ids
                if (this._availableInstanceIds.length > 0) {
                    this._availableInstanceIds.sort($a1724dcfba0d6d9a$var$ascIdSort);
                    drawId = this._availableInstanceIds.shift();
                    this._instanceInfo[drawId] = instanceInfo;
                } else {
                    drawId = this._instanceInfo.length;
                    this._instanceInfo.push(instanceInfo);
                }
                var matricesTexture = this._matricesTexture;
                $a1724dcfba0d6d9a$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
                matricesTexture.needsUpdate = true;
                var colorsTexture = this._colorsTexture;
                if (colorsTexture) {
                    $a1724dcfba0d6d9a$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
                    colorsTexture.needsUpdate = true;
                }
                this._visibilityChanged = true;
                return drawId;
            }
        },
        {
            /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ key: "addGeometry",
            value: function addGeometry(geometry) {
                var reservedVertexCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, reservedIndexCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
                this._initializeGeometry(geometry);
                this._validateGeometry(geometry);
                var geometryInfo = {
                    // geometry information
                    vertexStart: -1,
                    vertexCount: -1,
                    reservedVertexCount: -1,
                    indexStart: -1,
                    indexCount: -1,
                    reservedIndexCount: -1,
                    // draw range information
                    start: -1,
                    count: -1,
                    // state
                    boundingBox: null,
                    boundingSphere: null,
                    active: true
                };
                var geometryInfoList = this._geometryInfo;
                geometryInfo.vertexStart = this._nextVertexStart;
                geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
                var index = geometry.getIndex();
                var hasIndex = index !== null;
                if (hasIndex) {
                    geometryInfo.indexStart = this._nextIndexStart;
                    geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
                }
                if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
                // update id
                var geometryId;
                if (this._availableGeometryIds.length > 0) {
                    this._availableGeometryIds.sort($a1724dcfba0d6d9a$var$ascIdSort);
                    geometryId = this._availableGeometryIds.shift();
                    geometryInfoList[geometryId] = geometryInfo;
                } else {
                    geometryId = this._geometryCount;
                    this._geometryCount++;
                    geometryInfoList.push(geometryInfo);
                }
                // update the geometry
                this.setGeometryAt(geometryId, geometry);
                // increment the next geometry position
                this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
                this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
                return geometryId;
            }
        },
        {
            /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ key: "setGeometryAt",
            value: function setGeometryAt(geometryId, geometry) {
                if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
                this._validateGeometry(geometry);
                var batchGeometry = this.geometry;
                var hasIndex = batchGeometry.getIndex() !== null;
                var dstIndex = batchGeometry.getIndex();
                var srcIndex = geometry.getIndex();
                var geometryInfo = this._geometryInfo[geometryId];
                if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
                // copy geometry buffer data over
                var vertexStart = geometryInfo.vertexStart;
                var reservedVertexCount = geometryInfo.reservedVertexCount;
                geometryInfo.vertexCount = geometry.getAttribute('position').count;
                for(var attributeName in batchGeometry.attributes){
                    // copy attribute data
                    var srcAttribute = geometry.getAttribute(attributeName);
                    var dstAttribute = batchGeometry.getAttribute(attributeName);
                    $a1724dcfba0d6d9a$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
                    // fill the rest in with zeroes
                    var itemSize = srcAttribute.itemSize;
                    for(var i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                        var index = vertexStart + i;
                        for(var c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
                    }
                    dstAttribute.needsUpdate = true;
                    dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
                }
                // copy index
                if (hasIndex) {
                    var indexStart = geometryInfo.indexStart;
                    var reservedIndexCount = geometryInfo.reservedIndexCount;
                    geometryInfo.indexCount = geometry.getIndex().count;
                    // copy index data over
                    for(var i1 = 0; i1 < srcIndex.count; i1++)dstIndex.setX(indexStart + i1, vertexStart + srcIndex.getX(i1));
                    // fill the rest in with zeroes
                    for(var i2 = srcIndex.count, l1 = reservedIndexCount; i2 < l1; i2++)dstIndex.setX(indexStart + i2, vertexStart);
                    dstIndex.needsUpdate = true;
                    dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
                }
                // update the draw range
                geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
                geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
                // store the bounding boxes
                geometryInfo.boundingBox = null;
                if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
                geometryInfo.boundingSphere = null;
                if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
                this._visibilityChanged = true;
                return geometryId;
            }
        },
        {
            /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "deleteGeometry",
            value: function deleteGeometry(geometryId) {
                var geometryInfoList = this._geometryInfo;
                if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
                // delete any instances associated with this geometry
                var instanceInfo = this._instanceInfo;
                for(var i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
                geometryInfoList[geometryId].active = false;
                this._availableGeometryIds.push(geometryId);
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "deleteInstance",
            value: function deleteInstance(instanceId) {
                this.validateInstanceId(instanceId);
                this._instanceInfo[instanceId].active = false;
                this._availableInstanceIds.push(instanceId);
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            /**
	 * Repacks the sub geometries in [name] to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "optimize",
            value: function optimize() {
                // track the next indices to copy data to
                var nextVertexStart = 0;
                var nextIndexStart = 0;
                // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
                // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
                var geometryInfoList = this._geometryInfo;
                var indices = geometryInfoList.map(function(e, i) {
                    return i;
                }).sort(function(a, b) {
                    return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
                });
                var geometry = this.geometry;
                for(var i = 0, l = geometryInfoList.length; i < l; i++){
                    // if a geometry range is inactive then don't copy anything
                    var index = indices[i];
                    var geometryInfo = geometryInfoList[index];
                    if (geometryInfo.active === false) continue;
                    // if a geometry contains an index buffer then shift it, as well
                    if (geometry.index !== null) {
                        if (geometryInfo.indexStart !== nextIndexStart) {
                            var indexStart = geometryInfo.indexStart, vertexStart = geometryInfo.vertexStart, reservedIndexCount = geometryInfo.reservedIndexCount;
                            var index1 = geometry.index;
                            var array = index1.array;
                            // shift the index pointers based on how the vertex data will shift
                            // adjusting the index must happen first so the original vertex start value is available
                            var elementDelta = nextVertexStart - vertexStart;
                            for(var j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                            index1.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                            index1.addUpdateRange(nextIndexStart, reservedIndexCount);
                            geometryInfo.indexStart = nextIndexStart;
                        }
                        nextIndexStart += geometryInfo.reservedIndexCount;
                    }
                    // if a geometry needs to be moved then copy attribute data to overwrite unused space
                    if (geometryInfo.vertexStart !== nextVertexStart) {
                        var vertexStart1 = geometryInfo.vertexStart, reservedVertexCount = geometryInfo.reservedVertexCount;
                        var attributes = geometry.attributes;
                        for(var key in attributes){
                            var attribute = attributes[key];
                            var array1 = attribute.array, itemSize = attribute.itemSize;
                            array1.copyWithin(nextVertexStart * itemSize, vertexStart1 * itemSize, (vertexStart1 + reservedVertexCount) * itemSize);
                            attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                        }
                        geometryInfo.vertexStart = nextVertexStart;
                    }
                    nextVertexStart += geometryInfo.reservedVertexCount;
                    geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
                    // step the next geometry points to the shifted position
                    this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
                    this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
                }
                return this;
            }
        },
        {
            /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {Box3|null} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ key: "getBoundingBoxAt",
            value: function getBoundingBoxAt(geometryId, target) {
                if (geometryId >= this._geometryCount) return null;
                // compute bounding box
                var geometry = this.geometry;
                var geometryInfo = this._geometryInfo[geometryId];
                if (geometryInfo.boundingBox === null) {
                    var box = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                    var index = geometry.index;
                    var position = geometry.attributes.position;
                    for(var i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                        var iv = i;
                        if (index) iv = index.getX(iv);
                        box.expandByPoint($a1724dcfba0d6d9a$var$_vector$5.fromBufferAttribute(position, iv));
                    }
                    geometryInfo.boundingBox = box;
                }
                target.copy(geometryInfo.boundingBox);
                return target;
            }
        },
        {
            /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {Sphere|null} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ key: "getBoundingSphereAt",
            value: function getBoundingSphereAt(geometryId, target) {
                if (geometryId >= this._geometryCount) return null;
                // compute bounding sphere
                var geometry = this.geometry;
                var geometryInfo = this._geometryInfo[geometryId];
                if (geometryInfo.boundingSphere === null) {
                    var sphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                    this.getBoundingBoxAt(geometryId, $a1724dcfba0d6d9a$var$_box$1);
                    $a1724dcfba0d6d9a$var$_box$1.getCenter(sphere.center);
                    var index = geometry.index;
                    var position = geometry.attributes.position;
                    var maxRadiusSq = 0;
                    for(var i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                        var iv = i;
                        if (index) iv = index.getX(iv);
                        $a1724dcfba0d6d9a$var$_vector$5.fromBufferAttribute(position, iv);
                        maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($a1724dcfba0d6d9a$var$_vector$5));
                    }
                    sphere.radius = Math.sqrt(maxRadiusSq);
                    geometryInfo.boundingSphere = sphere;
                }
                target.copy(geometryInfo.boundingSphere);
                return target;
            }
        },
        {
            /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "setMatrixAt",
            value: function setMatrixAt(instanceId, matrix) {
                this.validateInstanceId(instanceId);
                var matricesTexture = this._matricesTexture;
                var matricesArray = this._matricesTexture.image.data;
                matrix.toArray(matricesArray, instanceId * 16);
                matricesTexture.needsUpdate = true;
                return this;
            }
        },
        {
            /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ key: "getMatrixAt",
            value: function getMatrixAt(instanceId, matrix) {
                this.validateInstanceId(instanceId);
                return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
            }
        },
        {
            /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "setColorAt",
            value: function setColorAt(instanceId, color) {
                this.validateInstanceId(instanceId);
                if (this._colorsTexture === null) this._initColorsTexture();
                color.toArray(this._colorsTexture.image.data, instanceId * 4);
                this._colorsTexture.needsUpdate = true;
                return this;
            }
        },
        {
            /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ key: "getColorAt",
            value: function getColorAt(instanceId, color) {
                this.validateInstanceId(instanceId);
                return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
            }
        },
        {
            /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "setVisibleAt",
            value: function setVisibleAt(instanceId, visible) {
                this.validateInstanceId(instanceId);
                if (this._instanceInfo[instanceId].visible === visible) return this;
                this._instanceInfo[instanceId].visible = visible;
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ key: "getVisibleAt",
            value: function getVisibleAt(instanceId) {
                this.validateInstanceId(instanceId);
                return this._instanceInfo[instanceId].visible;
            }
        },
        {
            /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ key: "setGeometryIdAt",
            value: function setGeometryIdAt(instanceId, geometryId) {
                this.validateInstanceId(instanceId);
                this.validateGeometryId(geometryId);
                this._instanceInfo[instanceId].geometryIndex = geometryId;
                return this;
            }
        },
        {
            /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ key: "getGeometryIdAt",
            value: function getGeometryIdAt(instanceId) {
                this.validateInstanceId(instanceId);
                return this._instanceInfo[instanceId].geometryIndex;
            }
        },
        {
            /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ key: "getGeometryRangeAt",
            value: function getGeometryRangeAt(geometryId) {
                var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.validateGeometryId(geometryId);
                var geometryInfo = this._geometryInfo[geometryId];
                target.vertexStart = geometryInfo.vertexStart;
                target.vertexCount = geometryInfo.vertexCount;
                target.reservedVertexCount = geometryInfo.reservedVertexCount;
                target.indexStart = geometryInfo.indexStart;
                target.indexCount = geometryInfo.indexCount;
                target.reservedIndexCount = geometryInfo.reservedIndexCount;
                target.start = geometryInfo.start;
                target.count = geometryInfo.count;
                return target;
            }
        },
        {
            /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ key: "setInstanceCount",
            value: function setInstanceCount(maxInstanceCount) {
                // shrink the available instances as much as possible
                var availableInstanceIds = this._availableInstanceIds;
                var instanceInfo = this._instanceInfo;
                availableInstanceIds.sort($a1724dcfba0d6d9a$var$ascIdSort);
                while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
                    instanceInfo.pop();
                    availableInstanceIds.pop();
                }
                // throw an error if it can't be shrunk to the desired size
                if (maxInstanceCount < instanceInfo.length) throw new Error("BatchedMesh: Instance ids outside the range ".concat(maxInstanceCount, " are being used. Cannot shrink instance count."));
                // copy the multi draw counts
                var multiDrawCounts = new Int32Array(maxInstanceCount);
                var multiDrawStarts = new Int32Array(maxInstanceCount);
                $a1724dcfba0d6d9a$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
                $a1724dcfba0d6d9a$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
                this._multiDrawCounts = multiDrawCounts;
                this._multiDrawStarts = multiDrawStarts;
                this._maxInstanceCount = maxInstanceCount;
                // update texture data for instance sampling
                var indirectTexture = this._indirectTexture;
                var matricesTexture = this._matricesTexture;
                var colorsTexture = this._colorsTexture;
                indirectTexture.dispose();
                this._initIndirectTexture();
                $a1724dcfba0d6d9a$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
                matricesTexture.dispose();
                this._initMatricesTexture();
                $a1724dcfba0d6d9a$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
                if (colorsTexture) {
                    colorsTexture.dispose();
                    this._initColorsTexture();
                    $a1724dcfba0d6d9a$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
                }
            }
        },
        {
            /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ key: "setGeometrySize",
            value: function setGeometrySize(maxVertexCount, maxIndexCount) {
                var _Math;
                // Check if we can shrink to the requested vertex attribute size
                var validRanges = (0, $7WNf6._)(this._geometryInfo).filter(function(info) {
                    return info.active;
                });
                var requiredVertexLength = (_Math = Math).max.apply(_Math, (0, $7WNf6._)(validRanges.map(function(range) {
                    return range.vertexStart + range.reservedVertexCount;
                })));
                if (requiredVertexLength > maxVertexCount) throw new Error("BatchedMesh: Geometry vertex values are being used outside the range ".concat(maxIndexCount, ". Cannot shrink further."));
                // Check if we can shrink to the requested index attribute size
                if (this.geometry.index) {
                    var _Math1;
                    var requiredIndexLength = (_Math1 = Math).max.apply(_Math1, (0, $7WNf6._)(validRanges.map(function(range) {
                        return range.indexStart + range.reservedIndexCount;
                    })));
                    if (requiredIndexLength > maxIndexCount) throw new Error("BatchedMesh: Geometry index values are being used outside the range ".concat(maxIndexCount, ". Cannot shrink further."));
                }
                //
                // dispose of the previous geometry
                var oldGeometry = this.geometry;
                oldGeometry.dispose();
                // recreate the geometry needed based on the previous variant
                this._maxVertexCount = maxVertexCount;
                this._maxIndexCount = maxIndexCount;
                if (this._geometryInitialized) {
                    this._geometryInitialized = false;
                    this.geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
                    this._initializeGeometry(oldGeometry);
                }
                // copy data from the previous geometry
                var geometry = this.geometry;
                if (oldGeometry.index) $a1724dcfba0d6d9a$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
                for(var key in oldGeometry.attributes)$a1724dcfba0d6d9a$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var instanceInfo = this._instanceInfo;
                var geometryInfoList = this._geometryInfo;
                var matrixWorld = this.matrixWorld;
                var batchGeometry = this.geometry;
                // iterate over each geometry
                $a1724dcfba0d6d9a$var$_mesh.material = this.material;
                $a1724dcfba0d6d9a$var$_mesh.geometry.index = batchGeometry.index;
                $a1724dcfba0d6d9a$var$_mesh.geometry.attributes = batchGeometry.attributes;
                if ($a1724dcfba0d6d9a$var$_mesh.geometry.boundingBox === null) $a1724dcfba0d6d9a$var$_mesh.geometry.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
                if ($a1724dcfba0d6d9a$var$_mesh.geometry.boundingSphere === null) $a1724dcfba0d6d9a$var$_mesh.geometry.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    var geometryInfo = geometryInfoList[geometryId];
                    $a1724dcfba0d6d9a$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
                    // get the intersects
                    this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_mesh.matrixWorld).premultiply(matrixWorld);
                    this.getBoundingBoxAt(geometryId, $a1724dcfba0d6d9a$var$_mesh.geometry.boundingBox);
                    this.getBoundingSphereAt(geometryId, $a1724dcfba0d6d9a$var$_mesh.geometry.boundingSphere);
                    $a1724dcfba0d6d9a$var$_mesh.raycast(raycaster, $a1724dcfba0d6d9a$var$_batchIntersects);
                    // add batch id to the intersects
                    for(var j = 0, l1 = $a1724dcfba0d6d9a$var$_batchIntersects.length; j < l1; j++){
                        var intersect = $a1724dcfba0d6d9a$var$_batchIntersects[j];
                        intersect.object = this;
                        intersect.batchId = i;
                        intersects.push(intersect);
                    }
                    $a1724dcfba0d6d9a$var$_batchIntersects.length = 0;
                }
                $a1724dcfba0d6d9a$var$_mesh.material = null;
                $a1724dcfba0d6d9a$var$_mesh.geometry.index = null;
                $a1724dcfba0d6d9a$var$_mesh.geometry.attributes = {};
                $a1724dcfba0d6d9a$var$_mesh.geometry.setDrawRange(0, Infinity);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(BatchedMesh.prototype), "copy", this).call(this, source);
                this.geometry = source.geometry.clone();
                this.perObjectFrustumCulled = source.perObjectFrustumCulled;
                this.sortObjects = source.sortObjects;
                this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
                this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
                this._geometryInfo = source._geometryInfo.map(function(info) {
                    return (0, $emQHU._)((0, $iT0je._)({}, info), {
                        boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                        boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
                    });
                });
                this._instanceInfo = source._instanceInfo.map(function(info) {
                    return (0, $iT0je._)({}, info);
                });
                this._availableInstanceIds = source._availableInstanceIds.slice();
                this._availableGeometryIds = source._availableGeometryIds.slice();
                this._nextIndexStart = source._nextIndexStart;
                this._nextVertexStart = source._nextVertexStart;
                this._geometryCount = source._geometryCount;
                this._maxInstanceCount = source._maxInstanceCount;
                this._maxVertexCount = source._maxVertexCount;
                this._maxIndexCount = source._maxIndexCount;
                this._geometryInitialized = source._geometryInitialized;
                this._multiDrawCounts = source._multiDrawCounts.slice();
                this._multiDrawStarts = source._multiDrawStarts.slice();
                this._indirectTexture = source._indirectTexture.clone();
                this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
                this._matricesTexture = source._matricesTexture.clone();
                this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
                if (this._colorsTexture !== null) {
                    this._colorsTexture = source._colorsTexture.clone();
                    this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
                }
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                // Assuming the geometry is not shared with other meshes
                this.geometry.dispose();
                this._matricesTexture.dispose();
                this._matricesTexture = null;
                this._indirectTexture.dispose();
                this._indirectTexture = null;
                if (this._colorsTexture !== null) {
                    this._colorsTexture.dispose();
                    this._colorsTexture = null;
                }
            }
        },
        {
            key: "onBeforeRender",
            value: function onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
                // if visibility has not changed and frustum culling and object sorting is not required
                // then skip iterating over all items
                if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
                // the indexed version of the multi draw function requires specifying the start
                // offset in bytes.
                var index = geometry.getIndex();
                var bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
                var instanceInfo = this._instanceInfo;
                var multiDrawStarts = this._multiDrawStarts;
                var multiDrawCounts = this._multiDrawCounts;
                var geometryInfoList = this._geometryInfo;
                var perObjectFrustumCulled = this.perObjectFrustumCulled;
                var indirectTexture = this._indirectTexture;
                var indirectArray = indirectTexture.image.data;
                var frustum = camera.isArrayCamera ? $a1724dcfba0d6d9a$var$_frustumArray : $a1724dcfba0d6d9a$var$_frustum;
                // prepare the frustum in the local frame
                if (perObjectFrustumCulled && !camera.isArrayCamera) {
                    $a1724dcfba0d6d9a$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
                    $a1724dcfba0d6d9a$var$_frustum.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_matrix$1, renderer.coordinateSystem);
                }
                var multiDrawCount = 0;
                if (this.sortObjects) {
                    // get the camera position in the local frame
                    $a1724dcfba0d6d9a$var$_matrix$1.copy(this.matrixWorld).invert();
                    $a1724dcfba0d6d9a$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($a1724dcfba0d6d9a$var$_matrix$1);
                    $a1724dcfba0d6d9a$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($a1724dcfba0d6d9a$var$_matrix$1);
                    for(var i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                        var geometryId = instanceInfo[i].geometryIndex;
                        // get the bounds in world space
                        this.getMatrixAt(i, $a1724dcfba0d6d9a$var$_matrix$1);
                        this.getBoundingSphereAt(geometryId, $a1724dcfba0d6d9a$var$_sphere$2).applyMatrix4($a1724dcfba0d6d9a$var$_matrix$1);
                        // determine whether the batched geometry is within the frustum
                        var culled = false;
                        if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$2, camera);
                        if (!culled) {
                            // get the distance from camera used for sorting
                            var geometryInfo = geometryInfoList[geometryId];
                            var z = $a1724dcfba0d6d9a$var$_temp.subVectors($a1724dcfba0d6d9a$var$_sphere$2.center, $a1724dcfba0d6d9a$var$_vector$5).dot($a1724dcfba0d6d9a$var$_forward$1);
                            $a1724dcfba0d6d9a$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                        }
                    }
                    // Sort the draw ranges and prep for rendering
                    var list = $a1724dcfba0d6d9a$var$_renderList.list;
                    var customSort = this.customSort;
                    if (customSort === null) list.sort(material.transparent ? $a1724dcfba0d6d9a$var$sortTransparent : $a1724dcfba0d6d9a$var$sortOpaque);
                    else customSort.call(this, list, camera);
                    for(var i1 = 0, l1 = list.length; i1 < l1; i1++){
                        var item = list[i1];
                        multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                        multiDrawCounts[multiDrawCount] = item.count;
                        indirectArray[multiDrawCount] = item.index;
                        multiDrawCount++;
                    }
                    $a1724dcfba0d6d9a$var$_renderList.reset();
                } else {
                    for(var i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++)if (instanceInfo[i2].visible && instanceInfo[i2].active) {
                        var geometryId1 = instanceInfo[i2].geometryIndex;
                        // determine whether the batched geometry is within the frustum
                        var culled1 = false;
                        if (perObjectFrustumCulled) {
                            // get the bounds in world space
                            this.getMatrixAt(i2, $a1724dcfba0d6d9a$var$_matrix$1);
                            this.getBoundingSphereAt(geometryId1, $a1724dcfba0d6d9a$var$_sphere$2).applyMatrix4($a1724dcfba0d6d9a$var$_matrix$1);
                            culled1 = !frustum.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$2, camera);
                        }
                        if (!culled1) {
                            var geometryInfo1 = geometryInfoList[geometryId1];
                            multiDrawStarts[multiDrawCount] = geometryInfo1.start * bytesPerElement;
                            multiDrawCounts[multiDrawCount] = geometryInfo1.count;
                            indirectArray[multiDrawCount] = i2;
                            multiDrawCount++;
                        }
                    }
                }
                indirectTexture.needsUpdate = true;
                this._multiDrawCount = multiDrawCount;
                this._visibilityChanged = false;
            }
        },
        {
            key: "onBeforeShadow",
            value: function onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
                this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
            }
        }
    ]);
    return BatchedMesh;
}($a1724dcfba0d6d9a$export$e176487c05830cc5);
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$fbaaa33907730a0c = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(LineBasicMaterial, Material);
    function LineBasicMaterial(parameters) {
        (0, $jGAMp._)(this, LineBasicMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, LineBasicMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineBasicMaterial = true;
        _this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ _this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(LineBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LineBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.linewidth = source.linewidth;
                this.linecap = source.linecap;
                this.linejoin = source.linejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return LineBasicMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
var $a1724dcfba0d6d9a$var$_vStart = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_vEnd = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_inverseMatrix$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_ray$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$a186db52eed6d40e();
var $a1724dcfba0d6d9a$var$_sphere$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_intersectPointOnRay = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_intersectPointOnSegment = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$17d680238e50603e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Line, Object3D);
    function Line() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$fbaaa33907730a0c();
        (0, $jGAMp._)(this, Line);
        var _this;
        _this = (0, $kzDuW._)(this, Line);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLine = true;
        _this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ _this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ _this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ _this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ _this.morphTargetInfluences = undefined;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $byiyg._)(Line, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Line.prototype), "copy", this).call(this, source, recursive);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                // we assume non-indexed geometry
                if (geometry.index === null) {
                    var positionAttribute = geometry.attributes.position;
                    var lineDistances = [
                        0
                    ];
                    for(var i = 1, l = positionAttribute.count; i < l; i++){
                        $a1724dcfba0d6d9a$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                        $a1724dcfba0d6d9a$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                        lineDistances[i] = lineDistances[i - 1];
                        lineDistances[i] += $a1724dcfba0d6d9a$var$_vStart.distanceTo($a1724dcfba0d6d9a$var$_vEnd);
                    }
                    geometry.setAttribute('lineDistance', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(lineDistances, 1));
                } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                return this;
            }
        },
        {
            /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Line.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $a1724dcfba0d6d9a$var$_sphere$1.copy(geometry.boundingSphere);
                $a1724dcfba0d6d9a$var$_sphere$1.applyMatrix4(matrixWorld);
                $a1724dcfba0d6d9a$var$_sphere$1.radius += threshold;
                if (raycaster.ray.intersectsSphere($a1724dcfba0d6d9a$var$_sphere$1) === false) return;
                //
                $a1724dcfba0d6d9a$var$_inverseMatrix$1.copy(matrixWorld).invert();
                $a1724dcfba0d6d9a$var$_ray$1.copy(raycaster.ray).applyMatrix4($a1724dcfba0d6d9a$var$_inverseMatrix$1);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var step = this.isLineSegments ? 2 : 1;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                    var start = Math.max(0, drawRange.start);
                    var end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(var i = start, l = end - 1; i < l; i += step){
                        var a = index.getX(i);
                        var b = index.getX(i + 1);
                        var intersect = $a1724dcfba0d6d9a$var$checkIntersection(this, raycaster, $a1724dcfba0d6d9a$var$_ray$1, localThresholdSq, a, b, i);
                        if (intersect) intersects.push(intersect);
                    }
                    if (this.isLineLoop) {
                        var a1 = index.getX(end - 1);
                        var b1 = index.getX(start);
                        var intersect1 = $a1724dcfba0d6d9a$var$checkIntersection(this, raycaster, $a1724dcfba0d6d9a$var$_ray$1, localThresholdSq, a1, b1, end - 1);
                        if (intersect1) intersects.push(intersect1);
                    }
                } else {
                    var start1 = Math.max(0, drawRange.start);
                    var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                    for(var i1 = start1, l1 = end1 - 1; i1 < l1; i1 += step){
                        var intersect2 = $a1724dcfba0d6d9a$var$checkIntersection(this, raycaster, $a1724dcfba0d6d9a$var$_ray$1, localThresholdSq, i1, i1 + 1, i1);
                        if (intersect2) intersects.push(intersect2);
                    }
                    if (this.isLineLoop) {
                        var intersect3 = $a1724dcfba0d6d9a$var$checkIntersection(this, raycaster, $a1724dcfba0d6d9a$var$_ray$1, localThresholdSq, end1 - 1, start1, end1 - 1);
                        if (intersect3) intersects.push(intersect3);
                    }
                }
            }
        },
        {
            /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        }
    ]);
    return Line;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
function $a1724dcfba0d6d9a$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    var positionAttribute = object.geometry.attributes.position;
    $a1724dcfba0d6d9a$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $a1724dcfba0d6d9a$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    var distSq = ray.distanceSqToSegment($a1724dcfba0d6d9a$var$_vStart, $a1724dcfba0d6d9a$var$_vEnd, $a1724dcfba0d6d9a$var$_intersectPointOnRay, $a1724dcfba0d6d9a$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $a1724dcfba0d6d9a$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    var distance = raycaster.ray.origin.distanceTo($a1724dcfba0d6d9a$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $a1724dcfba0d6d9a$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
var $a1724dcfba0d6d9a$var$_start = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_end = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ var $a1724dcfba0d6d9a$export$ff1ed10fedfdd604 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $i3fW3._)(LineSegments, Line);
    function LineSegments(geometry, material) {
        (0, $jGAMp._)(this, LineSegments);
        var _this;
        _this = (0, $kzDuW._)(this, LineSegments, [
            geometry,
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineSegments = true;
        _this.type = 'LineSegments';
        return _this;
    }
    (0, $byiyg._)(LineSegments, [
        {
            key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                // we assume non-indexed geometry
                if (geometry.index === null) {
                    var positionAttribute = geometry.attributes.position;
                    var lineDistances = [];
                    for(var i = 0, l = positionAttribute.count; i < l; i += 2){
                        $a1724dcfba0d6d9a$var$_start.fromBufferAttribute(positionAttribute, i);
                        $a1724dcfba0d6d9a$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                        lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                        lineDistances[i + 1] = lineDistances[i] + $a1724dcfba0d6d9a$var$_start.distanceTo($a1724dcfba0d6d9a$var$_end);
                    }
                    geometry.setAttribute('lineDistance', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(lineDistances, 1));
                } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                return this;
            }
        }
    ]);
    return LineSegments;
}($a1724dcfba0d6d9a$export$17d680238e50603e);
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ var $a1724dcfba0d6d9a$export$f85a24d745e4f17d = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $i3fW3._)(LineLoop, Line);
    function LineLoop(geometry, material) {
        (0, $jGAMp._)(this, LineLoop);
        var _this;
        _this = (0, $kzDuW._)(this, LineLoop, [
            geometry,
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineLoop = true;
        _this.type = 'LineLoop';
        return _this;
    }
    return LineLoop;
}($a1724dcfba0d6d9a$export$17d680238e50603e);
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$a178c45366ce5d6b = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(PointsMaterial, Material);
    function PointsMaterial(parameters) {
        (0, $jGAMp._)(this, PointsMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, PointsMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isPointsMaterial = true;
        _this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(PointsMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(PointsMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.size = source.size;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return PointsMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
var $a1724dcfba0d6d9a$var$_inverseMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_ray = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$a186db52eed6d40e();
var $a1724dcfba0d6d9a$var$_sphere = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$805e8b72413ccaba();
var $a1724dcfba0d6d9a$var$_position$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$1c787534cb11aa3e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Points, Object3D);
    function Points() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$a178c45366ce5d6b();
        (0, $jGAMp._)(this, Points);
        var _this;
        _this = (0, $kzDuW._)(this, Points);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isPoints = true;
        _this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ _this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ _this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ _this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ _this.morphTargetInfluences = undefined;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $byiyg._)(Points, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Points.prototype), "copy", this).call(this, source, recursive);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Points.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $a1724dcfba0d6d9a$var$_sphere.copy(geometry.boundingSphere);
                $a1724dcfba0d6d9a$var$_sphere.applyMatrix4(matrixWorld);
                $a1724dcfba0d6d9a$var$_sphere.radius += threshold;
                if (raycaster.ray.intersectsSphere($a1724dcfba0d6d9a$var$_sphere) === false) return;
                //
                $a1724dcfba0d6d9a$var$_inverseMatrix.copy(matrixWorld).invert();
                $a1724dcfba0d6d9a$var$_ray.copy(raycaster.ray).applyMatrix4($a1724dcfba0d6d9a$var$_inverseMatrix);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                    var start = Math.max(0, drawRange.start);
                    var end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(var i = start, il = end; i < il; i++){
                        var a = index.getX(i);
                        $a1724dcfba0d6d9a$var$_position$2.fromBufferAttribute(positionAttribute, a);
                        $a1724dcfba0d6d9a$var$testPoint($a1724dcfba0d6d9a$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                    }
                } else {
                    var start1 = Math.max(0, drawRange.start);
                    var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                    for(var i1 = start1, l = end1; i1 < l; i1++){
                        $a1724dcfba0d6d9a$var$_position$2.fromBufferAttribute(positionAttribute, i1);
                        $a1724dcfba0d6d9a$var$testPoint($a1724dcfba0d6d9a$var$_position$2, i1, localThresholdSq, matrixWorld, raycaster, intersects, this);
                    }
                }
            }
        },
        {
            /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        }
    ]);
    return Points;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
function $a1724dcfba0d6d9a$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    var rayPointDistanceSq = $a1724dcfba0d6d9a$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        var intersectPoint = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        $a1724dcfba0d6d9a$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        var distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$6e09d1edf8d5a25c = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(VideoTexture, Texture);
    function VideoTexture(video, mapping, wrapS, wrapT) {
        var magFilter = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $a1724dcfba0d6d9a$export$8a72f490b25c56c8, minFilter = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $a1724dcfba0d6d9a$export$8a72f490b25c56c8, format = arguments.length > 6 ? arguments[6] : void 0, type = arguments.length > 7 ? arguments[7] : void 0, anisotropy = arguments.length > 8 ? arguments[8] : void 0;
        (0, $jGAMp._)(this, VideoTexture);
        var _this;
        _this = (0, $kzDuW._)(this, VideoTexture, [
            video,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        var scope = _this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
        return _this;
    }
    (0, $byiyg._)(VideoTexture, [
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.image).copy(this);
            }
        },
        {
            /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ key: "update",
            value: function update() {
                var video = this.image;
                var hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
                if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
            }
        }
    ]);
    return VideoTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ var $a1724dcfba0d6d9a$export$68498d200b825382 = /*#__PURE__*/ function(VideoTexture) {
    "use strict";
    (0, $i3fW3._)(VideoFrameTexture, VideoTexture);
    function VideoFrameTexture(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $jGAMp._)(this, VideoFrameTexture);
        var _this;
        _this = (0, $kzDuW._)(this, VideoFrameTexture, [
            {},
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isVideoFrameTexture = true;
        return _this;
    }
    (0, $byiyg._)(VideoFrameTexture, [
        {
            /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ key: "update",
            value: function update() {}
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this); // restoring Texture.clone()
            }
        },
        {
            /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ key: "setFrame",
            value: function setFrame(frame) {
                this.image = frame;
                this.needsUpdate = true;
            }
        }
    ]);
    return VideoFrameTexture;
}($a1724dcfba0d6d9a$export$6e09d1edf8d5a25c);
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$9270d786f73ce6fe = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(FramebufferTexture, Texture);
    function FramebufferTexture(width, height) {
        (0, $jGAMp._)(this, FramebufferTexture);
        var _this;
        _this = (0, $kzDuW._)(this, FramebufferTexture, [
            {
                width: width,
                height: height
            }
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.magFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ _this.minFilter = $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        _this.needsUpdate = true;
        return _this;
    }
    return FramebufferTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$3466bac9141a5cc4 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(CompressedTexture, Texture);
    function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace) {
        (0, $jGAMp._)(this, CompressedTexture);
        var _this;
        _this = (0, $kzDuW._)(this, CompressedTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ _this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ _this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ _this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ _this.generateMipmaps = false;
        return _this;
    }
    return CompressedTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ var $a1724dcfba0d6d9a$export$5fe6b8e34b274fcb = /*#__PURE__*/ function(CompressedTexture) {
    "use strict";
    (0, $i3fW3._)(CompressedArrayTexture, CompressedTexture);
    function CompressedArrayTexture(mipmaps, width, height, depth, format, type) {
        (0, $jGAMp._)(this, CompressedArrayTexture);
        var _this;
        _this = (0, $kzDuW._)(this, CompressedArrayTexture, [
            mipmaps,
            width,
            height,
            format,
            type
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ _this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ _this.wrapR = $a1724dcfba0d6d9a$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ _this.layerUpdates = new Set();
        return _this;
    }
    (0, $byiyg._)(CompressedArrayTexture, [
        {
            /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ key: "addLayerUpdate",
            value: function addLayerUpdate(layerIndex) {
                this.layerUpdates.add(layerIndex);
            }
        },
        {
            /**
	 * Resets the layer updates registry.
	 */ key: "clearLayerUpdates",
            value: function clearLayerUpdates() {
                this.layerUpdates.clear();
            }
        }
    ]);
    return CompressedArrayTexture;
}($a1724dcfba0d6d9a$export$3466bac9141a5cc4);
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ var $a1724dcfba0d6d9a$export$d80173634de65bff = /*#__PURE__*/ function(CompressedTexture) {
    "use strict";
    (0, $i3fW3._)(CompressedCubeTexture, CompressedTexture);
    function CompressedCubeTexture(images, format, type) {
        (0, $jGAMp._)(this, CompressedCubeTexture);
        var _this;
        _this = (0, $kzDuW._)(this, CompressedCubeTexture, [
            undefined,
            images[0].width,
            images[0].height,
            format,
            type,
            $a1724dcfba0d6d9a$export$8759762a6477f2c4
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCubeTexture = true;
        _this.image = images;
        return _this;
    }
    return CompressedCubeTexture;
}($a1724dcfba0d6d9a$export$3466bac9141a5cc4);
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$f7189e49152d1c13 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(CanvasTexture, Texture);
    function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $jGAMp._)(this, CanvasTexture);
        var _this;
        _this = (0, $kzDuW._)(this, CanvasTexture, [
            canvas,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCanvasTexture = true;
        _this.needsUpdate = true;
        return _this;
    }
    return CanvasTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ var $a1724dcfba0d6d9a$export$fc830aa069cc8c2f = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $i3fW3._)(DepthTexture, Texture);
    function DepthTexture(width, height) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $a1724dcfba0d6d9a$export$c3c7fc4518ebba96, mapping = arguments.length > 3 ? arguments[3] : void 0, wrapS = arguments.length > 4 ? arguments[4] : void 0, wrapT = arguments.length > 5 ? arguments[5] : void 0, magFilter = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0, minFilter = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0, anisotropy = arguments.length > 8 ? arguments[8] : void 0, format = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $a1724dcfba0d6d9a$export$c1b6b5136be58045, depth = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 1;
        (0, $jGAMp._)(this, DepthTexture);
        var _this;
        if (format !== $a1724dcfba0d6d9a$export$c1b6b5136be58045 && format !== $a1724dcfba0d6d9a$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        var image = {
            width: width,
            height: height,
            depth: depth
        };
        _this = (0, $kzDuW._)(this, DepthTexture, [
            image,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ _this.compareFunction = null;
        return _this;
    }
    (0, $byiyg._)(DepthTexture, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(DepthTexture.prototype), "copy", this).call(this, source);
                this.source = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
                this.compareFunction = source.compareFunction;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(DepthTexture.prototype), "toJSON", this).call(this, meta);
                if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
                return data;
            }
        }
    ]);
    return DepthTexture;
}($a1724dcfba0d6d9a$export$5431306cf43de24a);
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$41680e8551036033 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(CapsuleGeometry, BufferGeometry);
    function CapsuleGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, capSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
        (0, $jGAMp._)(this, CapsuleGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, CapsuleGeometry);
        _this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var halfHeight = height / 2;
        var capArcLength = Math.PI / 2 * radius;
        var cylinderPartLength = height;
        var totalArcLength = 2 * capArcLength + cylinderPartLength;
        var numVerticalSegments = capSegments * 2 + heightSegments;
        var verticesPerRow = radialSegments + 1;
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(var iy = 0; iy <= numVerticalSegments; iy++){
            var currentArcLength = 0;
            var profileY = 0;
            var profileRadius = 0;
            var normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                var segmentProgress = iy / capSegments;
                var angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                var segmentProgress1 = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress1 * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress1 * cylinderPartLength;
            } else {
                // top cap
                var segmentProgress2 = (iy - capSegments - heightSegments) / capSegments;
                var angle1 = segmentProgress2 * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle1);
                profileRadius = radius * Math.cos(angle1);
                normalYComponent = radius * Math.sin(angle1);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress2 * capArcLength;
            }
            var v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            var uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(var ix = 0; ix <= radialSegments; ix++){
                var u = ix / radialSegments;
                var theta = u * Math.PI * 2;
                var sinTheta = Math.sin(theta);
                var cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                var prevIndexRow = (iy - 1) * verticesPerRow;
                for(var ix1 = 0; ix1 < radialSegments; ix1++){
                    var i1 = prevIndexRow + ix1;
                    var i2 = prevIndexRow + ix1 + 1;
                    var i3 = iy * verticesPerRow + ix1;
                    var i4 = iy * verticesPerRow + ix1 + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(CapsuleGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CapsuleGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ function fromJSON(data) {
                return new CapsuleGeometry(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
            }
        }
    ]);
    return CapsuleGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$d5c0e8d607467193 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(CircleGeometry, BufferGeometry);
    function CircleGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, thetaStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, thetaLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $jGAMp._)(this, CircleGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, CircleGeometry);
        _this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var uv = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(var s = 0, i = 3; s <= segments; s++, i += 3){
            var segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(var i1 = 1; i1 <= segments; i1++)indices.push(i1, i1 + 1, 0);
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(CircleGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CircleGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ function fromJSON(data) {
                return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CircleGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$68f745719dbe5198 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(CylinderGeometry, BufferGeometry);
    function CylinderGeometry() {
        var radiusTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, radiusBottom = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 32, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, openEnded = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, thetaStart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, thetaLength = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : Math.PI * 2;
        (0, $jGAMp._)(this, CylinderGeometry);
        var _this;
        var generateTorso = function generateTorso() {
            var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var groupCount = 0;
            // this will be used to calculate the normal
            var slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(var y = 0; y <= heightSegments; y++){
                var indexRow = [];
                var v = y / heightSegments;
                // calculate the radius of the current row
                var radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(var x = 0; x <= radialSegments; x++){
                    var u = x / radialSegments;
                    var theta = u * thetaLength + thetaStart;
                    var sinTheta = Math.sin(theta);
                    var cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(var x1 = 0; x1 < radialSegments; x1++)for(var y1 = 0; y1 < heightSegments; y1++){
                // we use the index array to access the correct indices
                var a = indexArray[y1][x1];
                var b = indexArray[y1 + 1][x1];
                var c = indexArray[y1 + 1][x1 + 1];
                var d = indexArray[y1][x1 + 1];
                // faces
                if (radiusTop > 0 || y1 !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y1 !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        };
        var generateCap = function generateCap(top) {
            // save the index of the first center vertex
            var centerIndexStart = index;
            var uv = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
            var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var groupCount = 0;
            var radius = top === true ? radiusTop : radiusBottom;
            var sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(var x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            var centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(var x1 = 0; x1 <= radialSegments; x1++){
                var u = x1 / radialSegments;
                var theta = u * thetaLength + thetaStart;
                var cosTheta = Math.cos(theta);
                var sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(var x2 = 0; x2 < radialSegments; x2++){
                var c = centerIndexStart + x2;
                var i = centerIndexEnd + x2;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        };
        _this = (0, $kzDuW._)(this, CylinderGeometry);
        _this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        var scope = _this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var index = 0;
        var indexArray = [];
        var halfHeight = height / 2;
        var groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(CylinderGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CylinderGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ function fromJSON(data) {
                return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CylinderGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 */ var $a1724dcfba0d6d9a$export$a7a48974f285c9b3 = /*#__PURE__*/ function(CylinderGeometry) {
    "use strict";
    (0, $i3fW3._)(ConeGeometry, CylinderGeometry);
    function ConeGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 32, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, openEnded = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI * 2;
        (0, $jGAMp._)(this, ConeGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, ConeGeometry, [
            0,
            radius,
            height,
            radialSegments,
            heightSegments,
            openEnded,
            thetaStart,
            thetaLength
        ]);
        _this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        return _this;
    }
    (0, $byiyg._)(ConeGeometry, null, [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ function fromJSON(data) {
                return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return ConeGeometry;
}($a1724dcfba0d6d9a$export$68f745719dbe5198);
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$60e57a7d3f20ff65 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(PolyhedronGeometry, BufferGeometry);
    function PolyhedronGeometry() {
        var vertices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], indices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, detail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, $jGAMp._)(this, PolyhedronGeometry);
        var _this;
        var subdivide = // helper functions
        function subdivide(detail) {
            var a = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var b = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var c = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(var i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        };
        var subdivideFace = function subdivideFace(a, b, c, detail) {
            var cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            var v = [];
            // construct all of the vertices for this subdivision
            for(var i = 0; i <= cols; i++){
                v[i] = [];
                var aj = a.clone().lerp(c, i / cols);
                var bj = b.clone().lerp(c, i / cols);
                var rows = cols - i;
                for(var j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(var i1 = 0; i1 < cols; i1++)for(var j1 = 0; j1 < 2 * (cols - i1) - 1; j1++){
                var k = Math.floor(j1 / 2);
                if (j1 % 2 === 0) {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                    pushVertex(v[i1][k]);
                } else {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                }
            }
        };
        var applyRadius = function applyRadius(radius) {
            var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        };
        var generateUVs = function generateUVs() {
            var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                var u = azimuth(vertex) / 2 / Math.PI + 0.5;
                var v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        };
        var correctSeam = function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(var i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                var x0 = uvBuffer[i + 0];
                var x1 = uvBuffer[i + 2];
                var x2 = uvBuffer[i + 4];
                var max = Math.max(x0, x1, x2);
                var min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        };
        var pushVertex = function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        };
        var getVertexByIndex = function getVertexByIndex(index, vertex) {
            var stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        };
        var correctUVs = function correctUVs() {
            var a = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var b = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var c = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var centroid = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var uvA = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
            var uvB = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
            var uvC = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
            for(var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                var azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        };
        var correctUV = function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        };
        var azimuth = // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        };
        var inclination = // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        };
        _this = (0, $kzDuW._)(this, PolyhedronGeometry);
        _this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        var vertexBuffer = [];
        var uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertexBuffer, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) _this.computeVertexNormals(); // flat normals
        else _this.normalizeNormals(); // smooth normals
        return _this;
    }
    (0, $byiyg._)(PolyhedronGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(PolyhedronGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ function fromJSON(data) {
                return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
            }
        }
    ]);
    return PolyhedronGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ var $a1724dcfba0d6d9a$export$c0babfeb8708fc9c = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $i3fW3._)(DodecahedronGeometry, PolyhedronGeometry);
    function DodecahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, DodecahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var r = 1 / t;
        var vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        var indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        _this = (0, $kzDuW._)(this, DodecahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $byiyg._)(DodecahedronGeometry, null, [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ function fromJSON(data) {
                return new DodecahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return DodecahedronGeometry;
}($a1724dcfba0d6d9a$export$60e57a7d3f20ff65);
var $a1724dcfba0d6d9a$var$_v0 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v1$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_normal = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_triangle = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$4730b1542707547f = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(EdgesGeometry, BufferGeometry);
    function EdgesGeometry() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, thresholdAngle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $jGAMp._)(this, EdgesGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, EdgesGeometry);
        _this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            var precisionPoints = 4;
            var precision = Math.pow(10, precisionPoints);
            var thresholdDot = Math.cos($a1724dcfba0d6d9a$var$DEG2RAD * thresholdAngle);
            var indexAttr = geometry.getIndex();
            var positionAttr = geometry.getAttribute('position');
            var indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            var indexArr = [
                0,
                0,
                0
            ];
            var vertKeys = [
                'a',
                'b',
                'c'
            ];
            var hashes = new Array(3);
            var edgeData = {};
            var vertices = [];
            for(var i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                var a = $a1724dcfba0d6d9a$var$_triangle.a, b = $a1724dcfba0d6d9a$var$_triangle.b, c = $a1724dcfba0d6d9a$var$_triangle.c;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $a1724dcfba0d6d9a$var$_triangle.getNormal($a1724dcfba0d6d9a$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = "".concat(Math.round(a.x * precision), ",").concat(Math.round(a.y * precision), ",").concat(Math.round(a.z * precision));
                hashes[1] = "".concat(Math.round(b.x * precision), ",").concat(Math.round(b.y * precision), ",").concat(Math.round(b.z * precision));
                hashes[2] = "".concat(Math.round(c.x * precision), ",").concat(Math.round(c.y * precision), ",").concat(Math.round(c.z * precision));
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(var j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    var jNext = (j + 1) % 3;
                    var vecHash0 = hashes[j];
                    var vecHash1 = hashes[jNext];
                    var v0 = $a1724dcfba0d6d9a$var$_triangle[vertKeys[j]];
                    var v1 = $a1724dcfba0d6d9a$var$_triangle[vertKeys[jNext]];
                    var hash = "".concat(vecHash0, "_").concat(vecHash1);
                    var reverseHash = "".concat(vecHash1, "_").concat(vecHash0);
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($a1724dcfba0d6d9a$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $a1724dcfba0d6d9a$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(var key in edgeData)if (edgeData[key]) {
                var _edgeData_key = edgeData[key], index0 = _edgeData_key.index0, index1 = _edgeData_key.index1;
                $a1724dcfba0d6d9a$var$_v0.fromBufferAttribute(positionAttr, index0);
                $a1724dcfba0d6d9a$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($a1724dcfba0d6d9a$var$_v0.x, $a1724dcfba0d6d9a$var$_v0.y, $a1724dcfba0d6d9a$var$_v0.z);
                vertices.push($a1724dcfba0d6d9a$var$_v1$1.x, $a1724dcfba0d6d9a$var$_v1$1.y, $a1724dcfba0d6d9a$var$_v1$1.z);
            }
            _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        }
        return _this;
    }
    (0, $byiyg._)(EdgesGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(EdgesGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ]);
    return EdgesGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ var $a1724dcfba0d6d9a$export$b0e83c3ef8d2db1 = /*#__PURE__*/ function() {
    "use strict";
    function Curve() {
        (0, $jGAMp._)(this, Curve);
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    (0, $byiyg._)(Curve, [
        {
            /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ key: "getPoint",
            value: function getPoint() {
                console.warn('THREE.Curve: .getPoint() not implemented.');
            }
        },
        {
            /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getPoint(t, optionalTarget);
            }
        },
        {
            /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
                return points;
            }
        },
        {
            // Get sequence of points using getPointAt( u )
            /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
                return points;
            }
        },
        {
            /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ key: "getLength",
            value: function getLength() {
                var lengths = this.getLengths();
                return lengths[lengths.length - 1];
            }
        },
        {
            /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ key: "getLengths",
            value: function getLengths() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = false;
                var cache = [];
                var current, last = this.getPoint(0);
                var sum = 0;
                cache.push(0);
                for(var p = 1; p <= divisions; p++){
                    current = this.getPoint(p / divisions);
                    sum += current.distanceTo(last);
                    cache.push(sum);
                    last = current;
                }
                this.cacheArcLengths = cache;
                return cache; // { sums: cache, sum: sum }; Sum is in the last element.
            }
        },
        {
            /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ key: "updateArcLengths",
            value: function updateArcLengths() {
                this.needsUpdate = true;
                this.getLengths();
            }
        },
        {
            /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ key: "getUtoTmapping",
            value: function getUtoTmapping(u) {
                var distance = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var arcLengths = this.getLengths();
                var i = 0;
                var il = arcLengths.length;
                var targetArcLength; // The targeted u distance value to get
                if (distance) targetArcLength = distance;
                else targetArcLength = u * arcLengths[il - 1];
                // binary search for the index with largest value smaller than target u distance
                var low = 0, high = il - 1, comparison;
                while(low <= high){
                    i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                    comparison = arcLengths[i] - targetArcLength;
                    if (comparison < 0) low = i + 1;
                    else if (comparison > 0) high = i - 1;
                    else {
                        high = i;
                        break;
                    // DONE
                    }
                }
                i = high;
                if (arcLengths[i] === targetArcLength) return i / (il - 1);
                // we could get finer grain at lengths, or use simple interpolation between two points
                var lengthBefore = arcLengths[i];
                var lengthAfter = arcLengths[i + 1];
                var segmentLength = lengthAfter - lengthBefore;
                // determine where we are between the 'before' and 'after' points
                var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                // add that fractional amount to t
                var t = (i + segmentFraction) / (il - 1);
                return t;
            }
        },
        {
            /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ key: "getTangent",
            value: function getTangent(t, optionalTarget) {
                var delta = 0.0001;
                var t1 = t - delta;
                var t2 = t + delta;
                // Capping in case of danger
                if (t1 < 0) t1 = 0;
                if (t2 > 1) t2 = 1;
                var pt1 = this.getPoint(t1);
                var pt2 = this.getPoint(t2);
                var tangent = optionalTarget || (pt1.isVector2 ? new $a1724dcfba0d6d9a$export$c977b3e384af9ae1() : new $a1724dcfba0d6d9a$export$64b5c384219d3699());
                tangent.copy(pt2).sub(pt1).normalize();
                return tangent;
            }
        },
        {
            /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getTangent(t, optionalTarget);
            }
        },
        {
            /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ key: "computeFrenetFrames",
            value: function computeFrenetFrames(segments) {
                var closed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
                var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var tangents = [];
                var normals = [];
                var binormals = [];
                var vec = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var mat = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
                // compute the tangent vectors for each segment on the curve
                for(var i = 0; i <= segments; i++){
                    var u = i / segments;
                    tangents[i] = this.getTangentAt(u, new $a1724dcfba0d6d9a$export$64b5c384219d3699());
                }
                // select an initial normal vector perpendicular to the first tangent vector,
                // and in the direction of the minimum tangent xyz component
                normals[0] = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                binormals[0] = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var min = Number.MAX_VALUE;
                var tx = Math.abs(tangents[0].x);
                var ty = Math.abs(tangents[0].y);
                var tz = Math.abs(tangents[0].z);
                if (tx <= min) {
                    min = tx;
                    normal.set(1, 0, 0);
                }
                if (ty <= min) {
                    min = ty;
                    normal.set(0, 1, 0);
                }
                if (tz <= min) normal.set(0, 0, 1);
                vec.crossVectors(tangents[0], normal).normalize();
                normals[0].crossVectors(tangents[0], vec);
                binormals[0].crossVectors(tangents[0], normals[0]);
                // compute the slowly-varying normal and binormal vectors for each segment on the curve
                for(var i1 = 1; i1 <= segments; i1++){
                    normals[i1] = normals[i1 - 1].clone();
                    binormals[i1] = binormals[i1 - 1].clone();
                    vec.crossVectors(tangents[i1 - 1], tangents[i1]);
                    if (vec.length() > Number.EPSILON) {
                        vec.normalize();
                        var theta = Math.acos($a1724dcfba0d6d9a$var$clamp(tangents[i1 - 1].dot(tangents[i1]), -1, 1)); // clamp for floating pt errors
                        normals[i1].applyMatrix4(mat.makeRotationAxis(vec, theta));
                    }
                    binormals[i1].crossVectors(tangents[i1], normals[i1]);
                }
                // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
                if (closed === true) {
                    var theta1 = Math.acos($a1724dcfba0d6d9a$var$clamp(normals[0].dot(normals[segments]), -1, 1));
                    theta1 /= segments;
                    if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta1 = -theta1;
                    for(var i2 = 1; i2 <= segments; i2++){
                        // twist a little...
                        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta1 * i2));
                        binormals[i2].crossVectors(tangents[i2], normals[i2]);
                    }
                }
                return {
                    tangents: tangents,
                    normals: normals,
                    binormals: binormals
                };
            }
        },
        {
            /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ key: "copy",
            value: function copy(source) {
                this.arcLengthDivisions = source.arcLengthDivisions;
                return this;
            }
        },
        {
            /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.7,
                        type: 'Curve',
                        generator: 'Curve.toJSON'
                    }
                };
                data.arcLengthDivisions = this.arcLengthDivisions;
                data.type = this.type;
                return data;
            }
        },
        {
            /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ key: "fromJSON",
            value: function fromJSON(json) {
                this.arcLengthDivisions = json.arcLengthDivisions;
                return this;
            }
        }
    ]);
    return Curve;
}();
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$3f87a931616cde04 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(EllipseCurve, Curve);
    function EllipseCurve() {
        var aX = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, aY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, xRadius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, yRadius = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, aStartAngle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, aEndAngle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2, aClockwise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, aRotation = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
        (0, $jGAMp._)(this, EllipseCurve);
        var _this;
        _this = (0, $kzDuW._)(this, EllipseCurve);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isEllipseCurve = true;
        _this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ _this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.aRotation = aRotation;
        return _this;
    }
    (0, $byiyg._)(EllipseCurve, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var twoPi = Math.PI * 2;
                var deltaAngle = this.aEndAngle - this.aStartAngle;
                var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                // ensures that deltaAngle is 0 .. 2 PI
                while(deltaAngle < 0)deltaAngle += twoPi;
                while(deltaAngle > twoPi)deltaAngle -= twoPi;
                if (deltaAngle < Number.EPSILON) {
                    if (samePoints) deltaAngle = 0;
                    else deltaAngle = twoPi;
                }
                if (this.aClockwise === true && !samePoints) {
                    if (deltaAngle === twoPi) deltaAngle = -twoPi;
                    else deltaAngle = deltaAngle - twoPi;
                }
                var angle = this.aStartAngle + t * deltaAngle;
                var x = this.aX + this.xRadius * Math.cos(angle);
                var y = this.aY + this.yRadius * Math.sin(angle);
                if (this.aRotation !== 0) {
                    var cos = Math.cos(this.aRotation);
                    var sin = Math.sin(this.aRotation);
                    var tx = x - this.aX;
                    var ty = y - this.aY;
                    // Rotate the point about the center of the ellipse.
                    x = tx * cos - ty * sin + this.aX;
                    y = tx * sin + ty * cos + this.aY;
                }
                return point.set(x, y);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(EllipseCurve.prototype), "copy", this).call(this, source);
                this.aX = source.aX;
                this.aY = source.aY;
                this.xRadius = source.xRadius;
                this.yRadius = source.yRadius;
                this.aStartAngle = source.aStartAngle;
                this.aEndAngle = source.aEndAngle;
                this.aClockwise = source.aClockwise;
                this.aRotation = source.aRotation;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(EllipseCurve.prototype), "toJSON", this).call(this);
                data.aX = this.aX;
                data.aY = this.aY;
                data.xRadius = this.xRadius;
                data.yRadius = this.yRadius;
                data.aStartAngle = this.aStartAngle;
                data.aEndAngle = this.aEndAngle;
                data.aClockwise = this.aClockwise;
                data.aRotation = this.aRotation;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(EllipseCurve.prototype), "fromJSON", this).call(this, json);
                this.aX = json.aX;
                this.aY = json.aY;
                this.xRadius = json.xRadius;
                this.yRadius = json.yRadius;
                this.aStartAngle = json.aStartAngle;
                this.aEndAngle = json.aEndAngle;
                this.aClockwise = json.aClockwise;
                this.aRotation = json.aRotation;
                return this;
            }
        }
    ]);
    return EllipseCurve;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ var $a1724dcfba0d6d9a$export$b1eedc9aab6300e8 = /*#__PURE__*/ function(EllipseCurve) {
    "use strict";
    (0, $i3fW3._)(ArcCurve, EllipseCurve);
    function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        (0, $jGAMp._)(this, ArcCurve);
        var _this;
        _this = (0, $kzDuW._)(this, ArcCurve, [
            aX,
            aY,
            aRadius,
            aRadius,
            aStartAngle,
            aEndAngle,
            aClockwise
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isArcCurve = true;
        _this.type = 'ArcCurve';
        return _this;
    }
    return ArcCurve;
}($a1724dcfba0d6d9a$export$3f87a931616cde04);
function $a1724dcfba0d6d9a$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function calc(t) {
            var t2 = t * t;
            var t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
var $a1724dcfba0d6d9a$var$tmp = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$px = /*@__PURE__*/ new $a1724dcfba0d6d9a$var$CubicPoly();
var $a1724dcfba0d6d9a$var$py = /*@__PURE__*/ new $a1724dcfba0d6d9a$var$CubicPoly();
var $a1724dcfba0d6d9a$var$pz = /*@__PURE__*/ new $a1724dcfba0d6d9a$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$b9146b27c24b744c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(CatmullRomCurve3, Curve);
    function CatmullRomCurve3() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], closed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, curveType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'centripetal', tension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
        (0, $jGAMp._)(this, CatmullRomCurve3);
        var _this;
        _this = (0, $kzDuW._)(this, CatmullRomCurve3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCatmullRomCurve3 = true;
        _this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ _this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ _this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ _this.tension = tension;
        return _this;
    }
    (0, $byiyg._)(CatmullRomCurve3, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var point = optionalTarget;
                var points = this.points;
                var l = points.length;
                var p = (l - (this.closed ? 0 : 1)) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
                else if (weight === 0 && intPoint === l - 1) {
                    intPoint = l - 2;
                    weight = 1;
                }
                var p0, p3; // 4 points (p1 & p2 defined below)
                if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
                else {
                    // extrapolate first point
                    $a1724dcfba0d6d9a$var$tmp.subVectors(points[0], points[1]).add(points[0]);
                    p0 = $a1724dcfba0d6d9a$var$tmp;
                }
                var p1 = points[intPoint % l];
                var p2 = points[(intPoint + 1) % l];
                if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
                else {
                    // extrapolate last point
                    $a1724dcfba0d6d9a$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
                    p3 = $a1724dcfba0d6d9a$var$tmp;
                }
                if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
                    // init Centripetal / Chordal Catmull-Rom
                    var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
                    var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
                    var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
                    var dt2 = Math.pow(p2.distanceToSquared(p3), pow);
                    // safety check for repeated points
                    if (dt1 < 1e-4) dt1 = 1.0;
                    if (dt0 < 1e-4) dt0 = dt1;
                    if (dt2 < 1e-4) dt2 = dt1;
                    $a1724dcfba0d6d9a$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
                    $a1724dcfba0d6d9a$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
                    $a1724dcfba0d6d9a$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
                } else if (this.curveType === 'catmullrom') {
                    $a1724dcfba0d6d9a$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
                    $a1724dcfba0d6d9a$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
                    $a1724dcfba0d6d9a$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
                }
                point.set($a1724dcfba0d6d9a$var$px.calc(weight), $a1724dcfba0d6d9a$var$py.calc(weight), $a1724dcfba0d6d9a$var$pz.calc(weight));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CatmullRomCurve3.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                this.closed = source.closed;
                this.curveType = source.curveType;
                this.tension = source.tension;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(CatmullRomCurve3.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                data.closed = this.closed;
                data.curveType = this.curveType;
                data.tension = this.tension;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(CatmullRomCurve3.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $a1724dcfba0d6d9a$export$64b5c384219d3699().fromArray(point));
                }
                this.closed = json.closed;
                this.curveType = json.curveType;
                this.tension = json.tension;
                return this;
            }
        }
    ]);
    return CatmullRomCurve3;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
// Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
/**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $a1724dcfba0d6d9a$var$CatmullRom(t, p0, p1, p2, p3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    var t2 = t * t;
    var t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $a1724dcfba0d6d9a$var$QuadraticBezierP0(t, p) {
    var k = 1 - t;
    return k * k * p;
}
function $a1724dcfba0d6d9a$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $a1724dcfba0d6d9a$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $a1724dcfba0d6d9a$var$QuadraticBezier(t, p0, p1, p2) {
    return $a1724dcfba0d6d9a$var$QuadraticBezierP0(t, p0) + $a1724dcfba0d6d9a$var$QuadraticBezierP1(t, p1) + $a1724dcfba0d6d9a$var$QuadraticBezierP2(t, p2);
}
//
function $a1724dcfba0d6d9a$var$CubicBezierP0(t, p) {
    var k = 1 - t;
    return k * k * k * p;
}
function $a1724dcfba0d6d9a$var$CubicBezierP1(t, p) {
    var k = 1 - t;
    return 3 * k * k * t * p;
}
function $a1724dcfba0d6d9a$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $a1724dcfba0d6d9a$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $a1724dcfba0d6d9a$var$CubicBezier(t, p0, p1, p2, p3) {
    return $a1724dcfba0d6d9a$var$CubicBezierP0(t, p0) + $a1724dcfba0d6d9a$var$CubicBezierP1(t, p1) + $a1724dcfba0d6d9a$var$CubicBezierP2(t, p2) + $a1724dcfba0d6d9a$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$e36650d36468bb39 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(CubicBezierCurve, Curve);
    function CubicBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        (0, $jGAMp._)(this, CubicBezierCurve);
        var _this;
        _this = (0, $kzDuW._)(this, CubicBezierCurve);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCubicBezierCurve = true;
        _this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ _this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ _this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ _this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ _this.v3 = v3;
        return _this;
    }
    (0, $byiyg._)(CubicBezierCurve, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($a1724dcfba0d6d9a$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $a1724dcfba0d6d9a$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$13d5f1c9525f246c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(CubicBezierCurve3, Curve);
    function CubicBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        (0, $jGAMp._)(this, CubicBezierCurve3);
        var _this;
        _this = (0, $kzDuW._)(this, CubicBezierCurve3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCubicBezierCurve3 = true;
        _this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ _this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ _this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ _this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ _this.v3 = v3;
        return _this;
    }
    (0, $byiyg._)(CubicBezierCurve3, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($a1724dcfba0d6d9a$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $a1724dcfba0d6d9a$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $a1724dcfba0d6d9a$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(CubicBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve3;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$ab2e07e76531a47e = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(LineCurve, Curve);
    function LineCurve() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        (0, $jGAMp._)(this, LineCurve);
        var _this;
        _this = (0, $kzDuW._)(this, LineCurve);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineCurve = true;
        _this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ _this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ _this.v2 = v2;
        return _this;
    }
    (0, $byiyg._)(LineCurve, [
        {
            /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "getTangent",
            value: function getTangent(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                return optionalTarget.subVectors(this.v2, this.v1).normalize();
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                return this.getTangent(u, optionalTarget);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LineCurve.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(LineCurve.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(LineCurve.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$1fdfd9d9cf487600 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(LineCurve3, Curve);
    function LineCurve3() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        (0, $jGAMp._)(this, LineCurve3);
        var _this;
        _this = (0, $kzDuW._)(this, LineCurve3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineCurve3 = true;
        _this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ _this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ _this.v2 = v2;
        return _this;
    }
    (0, $byiyg._)(LineCurve3, [
        {
            /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "getTangent",
            value: function getTangent(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                return optionalTarget.subVectors(this.v2, this.v1).normalize();
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                return this.getTangent(u, optionalTarget);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LineCurve3.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(LineCurve3.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(LineCurve3.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve3;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$5938c4ee491a43ad = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(QuadraticBezierCurve, Curve);
    function QuadraticBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        (0, $jGAMp._)(this, QuadraticBezierCurve);
        var _this;
        _this = (0, $kzDuW._)(this, QuadraticBezierCurve);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isQuadraticBezierCurve = true;
        _this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ _this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ _this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ _this.v2 = v2;
        return _this;
    }
    (0, $byiyg._)(QuadraticBezierCurve, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($a1724dcfba0d6d9a$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $a1724dcfba0d6d9a$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$bf3f4c7e459f90fc = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(QuadraticBezierCurve3, Curve);
    function QuadraticBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        (0, $jGAMp._)(this, QuadraticBezierCurve3);
        var _this;
        _this = (0, $kzDuW._)(this, QuadraticBezierCurve3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isQuadraticBezierCurve3 = true;
        _this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ _this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ _this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ _this.v2 = v2;
        return _this;
    }
    (0, $byiyg._)(QuadraticBezierCurve3, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($a1724dcfba0d6d9a$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $a1724dcfba0d6d9a$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $a1724dcfba0d6d9a$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(QuadraticBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve3;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$d3bdd77da77afc1b = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(SplineCurve, Curve);
    function SplineCurve() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $jGAMp._)(this, SplineCurve);
        var _this;
        _this = (0, $kzDuW._)(this, SplineCurve);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSplineCurve = true;
        _this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ _this.points = points;
        return _this;
    }
    (0, $byiyg._)(SplineCurve, [
        {
            /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var points = this.points;
                var p = (points.length - 1) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                var p1 = points[intPoint];
                var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                point.set($a1724dcfba0d6d9a$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $a1724dcfba0d6d9a$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(SplineCurve.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(SplineCurve.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(SplineCurve.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $a1724dcfba0d6d9a$export$c977b3e384af9ae1().fromArray(point));
                }
                return this;
            }
        }
    ]);
    return SplineCurve;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
var $a1724dcfba0d6d9a$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $a1724dcfba0d6d9a$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $a1724dcfba0d6d9a$export$b9146b27c24b744c,
    CubicBezierCurve: $a1724dcfba0d6d9a$export$e36650d36468bb39,
    CubicBezierCurve3: $a1724dcfba0d6d9a$export$13d5f1c9525f246c,
    EllipseCurve: $a1724dcfba0d6d9a$export$3f87a931616cde04,
    LineCurve: $a1724dcfba0d6d9a$export$ab2e07e76531a47e,
    LineCurve3: $a1724dcfba0d6d9a$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $a1724dcfba0d6d9a$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $a1724dcfba0d6d9a$export$bf3f4c7e459f90fc,
    SplineCurve: $a1724dcfba0d6d9a$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ var $a1724dcfba0d6d9a$export$4aaf9b66af1bbf2c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $i3fW3._)(CurvePath, Curve);
    function CurvePath() {
        (0, $jGAMp._)(this, CurvePath);
        var _this;
        _this = (0, $kzDuW._)(this, CurvePath);
        _this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ _this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.autoClose = false;
        return _this;
    }
    (0, $byiyg._)(CurvePath, [
        {
            /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ key: "add",
            value: function add(curve) {
                this.curves.push(curve);
            }
        },
        {
            /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ key: "closePath",
            value: function closePath() {
                // Add a line curve if start and end of lines are not connected
                var startPoint = this.curves[0].getPoint(0);
                var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                if (!startPoint.equals(endPoint)) {
                    var lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
                    this.curves.push(new $a1724dcfba0d6d9a$var$Curves[lineType](endPoint, startPoint));
                }
                return this;
            }
        },
        {
            /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ key: "getPoint",
            value: function getPoint(t, optionalTarget) {
                // To get accurate point with reference to
                // entire path distance at time t,
                // following has to be done:
                // 1. Length of each sub path have to be known
                // 2. Locate and identify type of curve
                // 3. Get t for the curve
                // 4. Return curve.getPointAt(t')
                var d = t * this.getLength();
                var curveLengths = this.getCurveLengths();
                var i = 0;
                // To think about boundaries points.
                while(i < curveLengths.length){
                    if (curveLengths[i] >= d) {
                        var diff = curveLengths[i] - d;
                        var curve = this.curves[i];
                        var segmentLength = curve.getLength();
                        var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                        return curve.getPointAt(u, optionalTarget);
                    }
                    i++;
                }
                return null;
            // loop where sum != 0, sum > d , sum+1 <d
            }
        },
        {
            key: "getLength",
            value: function getLength() {
                // We cannot use the default THREE.Curve getPoint() with getLength() because in
                // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
                // getPoint() depends on getLength
                var lens = this.getCurveLengths();
                return lens[lens.length - 1];
            }
        },
        {
            key: "updateArcLengths",
            value: function updateArcLengths() {
                // cacheLengths must be recalculated.
                this.needsUpdate = true;
                this.cacheLengths = null;
                this.getCurveLengths();
            }
        },
        {
            /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ key: "getCurveLengths",
            value: function getCurveLengths() {
                // Compute lengths and cache them
                // We cannot overwrite getLengths() because UtoT mapping uses it.
                // We use cache values if curves and cache array are same length
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                // Get length of sub-curve
                // Push sums into cached array
                var lengths = [];
                var sums = 0;
                for(var i = 0, l = this.curves.length; i < l; i++){
                    sums += this.curves[i].getLength();
                    lengths.push(sums);
                }
                this.cacheLengths = lengths;
                return lengths;
            }
        },
        {
            key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 40;
                var points = [];
                for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                if (this.autoClose) points.push(points[0]);
                return points;
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 12;
                var points = [];
                var last;
                for(var i = 0, curves = this.curves; i < curves.length; i++){
                    var curve = curves[i];
                    var resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
                    var pts = curve.getPoints(resolution);
                    for(var j = 0; j < pts.length; j++){
                        var point = pts[j];
                        if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                        points.push(point);
                        last = point;
                    }
                }
                if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                return points;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(CurvePath.prototype), "copy", this).call(this, source);
                this.curves = [];
                for(var i = 0, l = source.curves.length; i < l; i++){
                    var curve = source.curves[i];
                    this.curves.push(curve.clone());
                }
                this.autoClose = source.autoClose;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(CurvePath.prototype), "toJSON", this).call(this);
                data.autoClose = this.autoClose;
                data.curves = [];
                for(var i = 0, l = this.curves.length; i < l; i++){
                    var curve = this.curves[i];
                    data.curves.push(curve.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(CurvePath.prototype), "fromJSON", this).call(this, json);
                this.autoClose = json.autoClose;
                this.curves = [];
                for(var i = 0, l = json.curves.length; i < l; i++){
                    var curve = json.curves[i];
                    this.curves.push(new $a1724dcfba0d6d9a$var$Curves[curve.type]().fromJSON(curve));
                }
                return this;
            }
        }
    ]);
    return CurvePath;
}($a1724dcfba0d6d9a$export$b0e83c3ef8d2db1);
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ var $a1724dcfba0d6d9a$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(CurvePath) {
    "use strict";
    (0, $i3fW3._)(Path, CurvePath);
    function Path(points) {
        (0, $jGAMp._)(this, Path);
        var _this;
        _this = (0, $kzDuW._)(this, Path);
        _this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ _this.currentPoint = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        if (points) _this.setFromPoints(points);
        return _this;
    }
    (0, $byiyg._)(Path, [
        {
            /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ key: "setFromPoints",
            value: function setFromPoints(points) {
                this.moveTo(points[0].x, points[0].y);
                for(var i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
                return this;
            }
        },
        {
            /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ key: "lineTo",
            value: function lineTo(x, y) {
                var curve = new $a1724dcfba0d6d9a$export$ab2e07e76531a47e(this.currentPoint.clone(), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(x, y));
                this.curves.push(curve);
                this.currentPoint.set(x, y);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                var curve = new $a1724dcfba0d6d9a$export$5938c4ee491a43ad(this.currentPoint.clone(), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(aCPx, aCPy), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                var curve = new $a1724dcfba0d6d9a$export$e36650d36468bb39(this.currentPoint.clone(), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(aCP1x, aCP1y), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(aCP2x, aCP2y), new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ key: "splineThru",
            value: function splineThru(pts) {
                var npts = [
                    this.currentPoint.clone()
                ].concat(pts);
                var curve = new $a1724dcfba0d6d9a$export$d3bdd77da77afc1b(npts);
                this.curves.push(curve);
                this.currentPoint.copy(pts[pts.length - 1]);
                return this;
            }
        },
        {
            /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ key: "arc",
            value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ key: "absarc",
            value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ key: "ellipse",
            value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                return this;
            }
        },
        {
            /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ key: "absellipse",
            value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var curve = new $a1724dcfba0d6d9a$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                if (this.curves.length > 0) {
                    // if a previous curve is present, attempt to join
                    var firstPoint = curve.getPoint(0);
                    if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
                }
                this.curves.push(curve);
                var lastPoint = curve.getPoint(1);
                this.currentPoint.copy(lastPoint);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(Path.prototype), "copy", this).call(this, source);
                this.currentPoint.copy(source.currentPoint);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(Path.prototype), "toJSON", this).call(this);
                data.currentPoint = this.currentPoint.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(Path.prototype), "fromJSON", this).call(this, json);
                this.currentPoint.fromArray(json.currentPoint);
                return this;
            }
        }
    ]);
    return Path;
}($a1724dcfba0d6d9a$export$4aaf9b66af1bbf2c);
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ var $a1724dcfba0d6d9a$export$6428a7f2611ef1fa = /*#__PURE__*/ function(Path1) {
    "use strict";
    (0, $i3fW3._)(Shape, Path1);
    function Shape(points) {
        (0, $jGAMp._)(this, Shape);
        var _this;
        _this = (0, $kzDuW._)(this, Shape, [
            points
        ]);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ _this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        _this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ _this.holes = [];
        return _this;
    }
    (0, $byiyg._)(Shape, [
        {
            /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ key: "getPointsHoles",
            value: function getPointsHoles(divisions) {
                var holesPts = [];
                for(var i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
                return holesPts;
            }
        },
        {
            // get points of shape and holes (keypoints based on segments parameter)
            /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ key: "extractPoints",
            value: function extractPoints(divisions) {
                return {
                    shape: this.getPoints(divisions),
                    holes: this.getPointsHoles(divisions)
                };
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(Shape.prototype), "copy", this).call(this, source);
                this.holes = [];
                for(var i = 0, l = source.holes.length; i < l; i++){
                    var hole = source.holes[i];
                    this.holes.push(hole.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(Shape.prototype), "toJSON", this).call(this);
                data.uuid = this.uuid;
                data.holes = [];
                for(var i = 0, l = this.holes.length; i < l; i++){
                    var hole = this.holes[i];
                    data.holes.push(hole.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $fXhL4._)((0, $hxFDX._)(Shape.prototype), "fromJSON", this).call(this, json);
                this.uuid = json.uuid;
                this.holes = [];
                for(var i = 0, l = json.holes.length; i < l; i++){
                    var hole = json.holes[i];
                    this.holes.push(new $a1724dcfba0d6d9a$export$4b2950bdac9b6ee9().fromJSON(hole));
                }
                return this;
            }
        }
    ]);
    return Shape;
}($a1724dcfba0d6d9a$export$4b2950bdac9b6ee9);
/* eslint-disable */ // copy of mapbox/earcut version 3.0.1
// https://github.com/mapbox/earcut/tree/v3.0.1
function $a1724dcfba0d6d9a$var$earcut(data, holeIndices) {
    var dim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var outerNode = $a1724dcfba0d6d9a$var$linkedList(data, 0, outerLen, dim, true);
    var triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, invSize;
    if (hasHoles) outerNode = $a1724dcfba0d6d9a$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        for(var i = dim; i < outerLen; i += dim){
            var x = data[i];
            var y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $a1724dcfba0d6d9a$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $a1724dcfba0d6d9a$var$linkedList(data, start, end, dim, clockwise) {
    var last;
    if (clockwise === $a1724dcfba0d6d9a$var$signedArea(data, start, end, dim) > 0) for(var i = start; i < end; i += dim)last = $a1724dcfba0d6d9a$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(var i1 = end - dim; i1 >= start; i1 -= dim)last = $a1724dcfba0d6d9a$var$insertNode(i1 / dim | 0, data[i1], data[i1 + 1], last);
    if (last && $a1724dcfba0d6d9a$var$equals(last, last.next)) {
        $a1724dcfba0d6d9a$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $a1724dcfba0d6d9a$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($a1724dcfba0d6d9a$var$equals(p, p.next) || $a1724dcfba0d6d9a$var$area(p.prev, p, p.next) === 0)) {
            $a1724dcfba0d6d9a$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $a1724dcfba0d6d9a$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $a1724dcfba0d6d9a$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        var prev = ear.prev;
        var next = ear.next;
        if (invSize ? $a1724dcfba0d6d9a$var$isEarHashed(ear, minX, minY, invSize) : $a1724dcfba0d6d9a$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $a1724dcfba0d6d9a$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $a1724dcfba0d6d9a$var$earcutLinked($a1724dcfba0d6d9a$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $a1724dcfba0d6d9a$var$cureLocalIntersections($a1724dcfba0d6d9a$var$filterPoints(ear), triangles);
                $a1724dcfba0d6d9a$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $a1724dcfba0d6d9a$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $a1724dcfba0d6d9a$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($a1724dcfba0d6d9a$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    var x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $a1724dcfba0d6d9a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $a1724dcfba0d6d9a$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($a1724dcfba0d6d9a$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    var x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    var minZ = $a1724dcfba0d6d9a$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $a1724dcfba0d6d9a$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $a1724dcfba0d6d9a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $a1724dcfba0d6d9a$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $a1724dcfba0d6d9a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $a1724dcfba0d6d9a$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $a1724dcfba0d6d9a$var$cureLocalIntersections(start, triangles) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$a1724dcfba0d6d9a$var$equals(a, b) && $a1724dcfba0d6d9a$var$intersects(a, p, p.next, b) && $a1724dcfba0d6d9a$var$locallyInside(a, b) && $a1724dcfba0d6d9a$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $a1724dcfba0d6d9a$var$removeNode(p);
            $a1724dcfba0d6d9a$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $a1724dcfba0d6d9a$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $a1724dcfba0d6d9a$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $a1724dcfba0d6d9a$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $a1724dcfba0d6d9a$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $a1724dcfba0d6d9a$var$filterPoints(a, a.next);
                c = $a1724dcfba0d6d9a$var$filterPoints(c, c.next);
                // run earcut on each half
                $a1724dcfba0d6d9a$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $a1724dcfba0d6d9a$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $a1724dcfba0d6d9a$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [];
    for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        var list = $a1724dcfba0d6d9a$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($a1724dcfba0d6d9a$var$getLeftmost(list));
    }
    queue.sort($a1724dcfba0d6d9a$var$compareXYSlope);
    // process holes from left to right
    for(var i1 = 0; i1 < queue.length; i1++)outerNode = $a1724dcfba0d6d9a$var$eliminateHole(queue[i1], outerNode);
    return outerNode;
}
function $a1724dcfba0d6d9a$var$compareXYSlope(a, b) {
    var result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            var aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            var bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $a1724dcfba0d6d9a$var$eliminateHole(hole, outerNode) {
    var bridge = $a1724dcfba0d6d9a$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $a1724dcfba0d6d9a$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $a1724dcfba0d6d9a$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $a1724dcfba0d6d9a$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $a1724dcfba0d6d9a$var$findHoleBridge(hole, outerNode) {
    var p = outerNode;
    var hx = hole.x;
    var hy = hole.y;
    var qx = -Infinity;
    var m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($a1724dcfba0d6d9a$var$equals(hole, p)) return p;
    do {
        if ($a1724dcfba0d6d9a$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m;
    var mx = m.x;
    var my = m.y;
    var tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $a1724dcfba0d6d9a$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            var tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($a1724dcfba0d6d9a$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $a1724dcfba0d6d9a$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $a1724dcfba0d6d9a$var$sectorContainsSector(m, p) {
    return $a1724dcfba0d6d9a$var$area(m.prev, m, p.prev) < 0 && $a1724dcfba0d6d9a$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $a1724dcfba0d6d9a$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $a1724dcfba0d6d9a$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $a1724dcfba0d6d9a$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $a1724dcfba0d6d9a$var$sortLinked(list) {
    var numMerges;
    var inSize = 1;
    do {
        var p = list;
        var e = void 0;
        list = null;
        var tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            var q = p;
            var pSize = 0;
            for(var i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            var qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $a1724dcfba0d6d9a$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $a1724dcfba0d6d9a$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $a1724dcfba0d6d9a$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $a1724dcfba0d6d9a$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $a1724dcfba0d6d9a$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $a1724dcfba0d6d9a$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$a1724dcfba0d6d9a$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($a1724dcfba0d6d9a$var$locallyInside(a, b) && $a1724dcfba0d6d9a$var$locallyInside(b, a) && $a1724dcfba0d6d9a$var$middleInside(a, b) && // locally visible
    ($a1724dcfba0d6d9a$var$area(a.prev, a, b.prev) || $a1724dcfba0d6d9a$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $a1724dcfba0d6d9a$var$equals(a, b) && $a1724dcfba0d6d9a$var$area(a.prev, a, a.next) > 0 && $a1724dcfba0d6d9a$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $a1724dcfba0d6d9a$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $a1724dcfba0d6d9a$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $a1724dcfba0d6d9a$var$intersects(p1, q1, p2, q2) {
    var o1 = $a1724dcfba0d6d9a$var$sign($a1724dcfba0d6d9a$var$area(p1, q1, p2));
    var o2 = $a1724dcfba0d6d9a$var$sign($a1724dcfba0d6d9a$var$area(p1, q1, q2));
    var o3 = $a1724dcfba0d6d9a$var$sign($a1724dcfba0d6d9a$var$area(p2, q2, p1));
    var o4 = $a1724dcfba0d6d9a$var$sign($a1724dcfba0d6d9a$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $a1724dcfba0d6d9a$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $a1724dcfba0d6d9a$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $a1724dcfba0d6d9a$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $a1724dcfba0d6d9a$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $a1724dcfba0d6d9a$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $a1724dcfba0d6d9a$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $a1724dcfba0d6d9a$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $a1724dcfba0d6d9a$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $a1724dcfba0d6d9a$var$locallyInside(a, b) {
    return $a1724dcfba0d6d9a$var$area(a.prev, a, a.next) < 0 ? $a1724dcfba0d6d9a$var$area(a, b, a.next) >= 0 && $a1724dcfba0d6d9a$var$area(a, a.prev, b) >= 0 : $a1724dcfba0d6d9a$var$area(a, b, a.prev) < 0 || $a1724dcfba0d6d9a$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $a1724dcfba0d6d9a$var$middleInside(a, b) {
    var p = a;
    var inside = false;
    var px = (a.x + b.x) / 2;
    var py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $a1724dcfba0d6d9a$var$splitPolygon(a, b) {
    var a2 = $a1724dcfba0d6d9a$var$createNode(a.i, a.x, a.y), b2 = $a1724dcfba0d6d9a$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $a1724dcfba0d6d9a$var$insertNode(i, x, y, last) {
    var p = $a1724dcfba0d6d9a$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $a1724dcfba0d6d9a$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $a1724dcfba0d6d9a$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $a1724dcfba0d6d9a$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
var $a1724dcfba0d6d9a$var$Earcut = /*#__PURE__*/ function() {
    "use strict";
    function Earcut() {
        (0, $jGAMp._)(this, Earcut);
    }
    (0, $byiyg._)(Earcut, null, [
        {
            key: "triangulate",
            value: /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ function triangulate(data, holeIndices) {
                var dim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
                return $a1724dcfba0d6d9a$var$earcut(data, holeIndices, dim);
            }
        }
    ]);
    return Earcut;
}();
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8 = /*#__PURE__*/ function() {
    "use strict";
    function ShapeUtils() {
        (0, $jGAMp._)(this, ShapeUtils);
    }
    (0, $byiyg._)(ShapeUtils, null, [
        {
            key: "area",
            value: /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ function area(contour) {
                var n = contour.length;
                var a = 0.0;
                for(var p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
                return a * 0.5;
            }
        },
        {
            key: "isClockWise",
            value: /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ function isClockWise(pts) {
                return ShapeUtils.area(pts) < 0;
            }
        },
        {
            key: "triangulateShape",
            value: /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ function triangulateShape(contour, holes) {
                var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
                var holeIndices = []; // array of hole indices
                var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
                $a1724dcfba0d6d9a$var$removeDupEndPts(contour);
                $a1724dcfba0d6d9a$var$addContour(vertices, contour);
                //
                var holeIndex = contour.length;
                holes.forEach($a1724dcfba0d6d9a$var$removeDupEndPts);
                for(var i = 0; i < holes.length; i++){
                    holeIndices.push(holeIndex);
                    holeIndex += holes[i].length;
                    $a1724dcfba0d6d9a$var$addContour(vertices, holes[i]);
                }
                //
                var triangles = $a1724dcfba0d6d9a$var$Earcut.triangulate(vertices, holeIndices);
                //
                for(var i1 = 0; i1 < triangles.length; i1 += 3)faces.push(triangles.slice(i1, i1 + 3));
                return faces;
            }
        }
    ]);
    return ShapeUtils;
}();
function $a1724dcfba0d6d9a$var$removeDupEndPts(points) {
    var l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $a1724dcfba0d6d9a$var$addContour(vertices, contour) {
    for(var i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$598697a1efa63ca7 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(ExtrudeGeometry, BufferGeometry);
    function ExtrudeGeometry() {
        var shapes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa([
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, 0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(-0.5, 0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(-0.5, -0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, -0.5)
        ]), options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, ExtrudeGeometry);
        var _this;
        var addShape = // functions
        function addShape(shape) {
            var placeholder = [];
            // options
            var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            var steps = options.steps !== undefined ? options.steps : 1;
            var depth = options.depth !== undefined ? options.depth : 1;
            var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            var extrudePath = options.extrudePath;
            var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $a1724dcfba0d6d9a$var$WorldUVGenerator;
            //
            var extrudePts, extrudeByPath = false;
            var splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
                position2 = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            var shapePoints = shape.extractPoints(curveSegments);
            var vertices = shapePoints.shape;
            var holes = shapePoints.holes;
            var reverse = !$a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    if ($a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                var THRESHOLD = 1e-10;
                var THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                var prevPos = points[0];
                for(var i = 1; i <= points.length; i++){
                    var currentIndex = i % points.length;
                    var currentPos = points[currentIndex];
                    var dx = currentPos.x - prevPos.x;
                    var dy = currentPos.y - prevPos.y;
                    var distSq = dx * dx + dy * dy;
                    var scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    var thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            var numHoles = holes.length;
            /* Vertices */ var contour = vertices; // vertices has all points but contour has only points of circumference
            for(var h1 = 0; h1 < numHoles; h1++){
                var ahole1 = holes[h1];
                vertices = vertices.concat(ahole1);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            var vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    var v_prev_len = Math.sqrt(v_prev_lensq);
                    var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    var ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    var ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    var direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            var contourMovements = [];
            for(var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            var holesMovements = [];
            var oneHoleMovements, verticesMovements = contourMovements.concat();
            for(var h2 = 0, hl1 = numHoles; h2 < hl1; h2++){
                var ahole2 = holes[h2];
                oneHoleMovements = [];
                for(var i1 = 0, il1 = ahole2.length, j1 = il1 - 1, k1 = i1 + 1; i1 < il1; i1++, j1++, k1++){
                    if (j1 === il1) j1 = 0;
                    if (k1 === il1) k1 = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i1] = getBevelVec(ahole2[i1], ahole2[j1], ahole2[k1]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            var faces;
            if (bevelSegments === 0) faces = $a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                var contractedContourVertices = [];
                var expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(var b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    var t = b / bevelSegments;
                    var z = bevelThickness * Math.cos(t * Math.PI / 2);
                    var bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(var i2 = 0, il2 = contour.length; i2 < il2; i2++){
                        var vert = scalePt2(contour[i2], contourMovements[i2], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(var h3 = 0, hl2 = numHoles; h3 < hl2; h3++){
                        var ahole3 = holes[h3];
                        oneHoleMovements = holesMovements[h3];
                        var oneHoleVertices = [];
                        for(var i3 = 0, il3 = ahole3.length; i3 < il3; i3++){
                            var vert1 = scalePt2(ahole3[i3], oneHoleMovements[i3], bs);
                            v(vert1.x, vert1.y, -z);
                            if (t === 0) oneHoleVertices.push(vert1);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            var flen = faces.length;
            var bs1 = bevelSize + bevelOffset;
            // Back facing vertices
            for(var i4 = 0; i4 < vlen; i4++){
                var vert2 = bevelEnabled ? scalePt2(vertices[i4], verticesMovements[i4], bs1) : vertices[i4];
                if (!extrudeByPath) v(vert2.x, vert2.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert2.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert2.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(var s = 1; s <= steps; s++)for(var i5 = 0; i5 < vlen; i5++){
                var vert3 = bevelEnabled ? scalePt2(vertices[i5], verticesMovements[i5], bs1) : vertices[i5];
                if (!extrudeByPath) v(vert3.x, vert3.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert3.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert3.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(var b1 = bevelSegments - 1; b1 >= 0; b1--){
                var t1 = b1 / bevelSegments;
                var z1 = bevelThickness * Math.cos(t1 * Math.PI / 2);
                var bs2 = bevelSize * Math.sin(t1 * Math.PI / 2) + bevelOffset;
                // contract shape
                for(var i6 = 0, il4 = contour.length; i6 < il4; i6++){
                    var vert4 = scalePt2(contour[i6], contourMovements[i6], bs2);
                    v(vert4.x, vert4.y, depth + z1);
                }
                // expand holes
                for(var h4 = 0, hl3 = holes.length; h4 < hl3; h4++){
                    var ahole4 = holes[h4];
                    oneHoleMovements = holesMovements[h4];
                    for(var i7 = 0, il5 = ahole4.length; i7 < il5; i7++){
                        var vert5 = scalePt2(ahole4[i7], oneHoleMovements[i7], bs2);
                        if (!extrudeByPath) v(vert5.x, vert5.y, depth + z1);
                        else v(vert5.x, vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z1);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                var start = verticesArray.length / 3;
                if (bevelEnabled) {
                    var layer = 0; // steps + 1
                    var offset = vlen * layer;
                    // Bottom faces
                    for(var i = 0; i < flen; i++){
                        var face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(var i1 = 0; i1 < flen; i1++){
                        var face1 = faces[i1];
                        f3(face1[0] + offset, face1[1] + offset, face1[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(var i2 = 0; i2 < flen; i2++){
                        var face2 = faces[i2];
                        f3(face2[2], face2[1], face2[0]);
                    }
                    // Top faces
                    for(var i3 = 0; i3 < flen; i3++){
                        var face3 = faces[i3];
                        f3(face3[0] + vlen * steps, face3[1] + vlen * steps, face3[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                var start = verticesArray.length / 3;
                var layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                var i = contour.length;
                while(--i >= 0){
                    var j = i;
                    var k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(var s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        var slen1 = vlen * s;
                        var slen2 = vlen * (s + 1);
                        var a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        };
        _this = (0, $kzDuW._)(this, ExtrudeGeometry);
        _this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        var scope = _this;
        var verticesArray = [];
        var uvArray = [];
        for(var i = 0, l = shapes.length; i < l; i++){
            var shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(verticesArray, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvArray, 2));
        _this.computeVertexNormals();
        return _this;
    }
    (0, $byiyg._)(ExtrudeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(ExtrudeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(ExtrudeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                var options = this.parameters.options;
                return $a1724dcfba0d6d9a$var$toJSON$1(shapes, options, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                var extrudePath = data.options.extrudePath;
                if (extrudePath !== undefined) data.options.extrudePath = new $a1724dcfba0d6d9a$var$Curves[extrudePath.type]().fromJSON(extrudePath);
                return new ExtrudeGeometry(geometryShapes, data.options);
            }
        }
    ]);
    return ExtrudeGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
var $a1724dcfba0d6d9a$var$WorldUVGenerator = {
    generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        return [
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(a_x, a_y),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(b_x, b_y),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var a_z = vertices[indexA * 3 + 2];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var b_z = vertices[indexB * 3 + 2];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        var c_z = vertices[indexC * 3 + 2];
        var d_x = vertices[indexD * 3];
        var d_y = vertices[indexD * 3 + 1];
        var d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $a1724dcfba0d6d9a$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ var $a1724dcfba0d6d9a$export$9567cc828c9535da = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $i3fW3._)(IcosahedronGeometry, PolyhedronGeometry);
    function IcosahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, IcosahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        var indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        _this = (0, $kzDuW._)(this, IcosahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $byiyg._)(IcosahedronGeometry, null, [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ function fromJSON(data) {
                return new IcosahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return IcosahedronGeometry;
}($a1724dcfba0d6d9a$export$60e57a7d3f20ff65);
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$6d839803fcd1882c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(LatheGeometry, BufferGeometry);
    function LatheGeometry() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0, -0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, 0),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0, 0.5)
        ], segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, phiStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, phiLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $jGAMp._)(this, LatheGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, LatheGeometry);
        _this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $a1724dcfba0d6d9a$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        var indices = [];
        var vertices = [];
        var uvs = [];
        var initNormals = [];
        var normals = [];
        // helper variables
        var inverseSegments = 1.0 / segments;
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var uv = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var curNormal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var prevNormal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var dx = 0;
        var dy = 0;
        // pre-compute normals for initial "meridian"
        for(var j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(var i = 0; i <= segments; i++){
            var phi = phiStart + i * inverseSegments * phiLength;
            var sin = Math.sin(phi);
            var cos = Math.cos(phi);
            for(var j1 = 0; j1 <= points.length - 1; j1++){
                // vertex
                vertex.x = points[j1].x * sin;
                vertex.y = points[j1].y;
                vertex.z = points[j1].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j1 / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                var x = initNormals[3 * j1 + 0] * sin;
                var y = initNormals[3 * j1 + 1];
                var z = initNormals[3 * j1 + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(var i1 = 0; i1 < segments; i1++)for(var j2 = 0; j2 < points.length - 1; j2++){
            var base = j2 + i1 * points.length;
            var a = base;
            var b = base + points.length;
            var c = base + points.length + 1;
            var d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        return _this;
    }
    (0, $byiyg._)(LatheGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LatheGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ function fromJSON(data) {
                return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
            }
        }
    ]);
    return LatheGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ var $a1724dcfba0d6d9a$export$1954e2b809fe361e = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $i3fW3._)(OctahedronGeometry, PolyhedronGeometry);
    function OctahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, OctahedronGeometry);
        var _this;
        var vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        var indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        _this = (0, $kzDuW._)(this, OctahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $byiyg._)(OctahedronGeometry, null, [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ function fromJSON(data) {
                return new OctahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return OctahedronGeometry;
}($a1724dcfba0d6d9a$export$60e57a7d3f20ff65);
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$967d831af31f69ce = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(PlaneGeometry, BufferGeometry);
    function PlaneGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, widthSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $jGAMp._)(this, PlaneGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, PlaneGeometry);
        _this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        var width_half = width / 2;
        var height_half = height / 2;
        var gridX = Math.floor(widthSegments);
        var gridY = Math.floor(heightSegments);
        var gridX1 = gridX + 1;
        var gridY1 = gridY + 1;
        var segment_width = width / gridX;
        var segment_height = height / gridY;
        //
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        for(var iy = 0; iy < gridY1; iy++){
            var y = iy * segment_height - height_half;
            for(var ix = 0; ix < gridX1; ix++){
                var x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
            var a = ix1 + gridX1 * iy1;
            var b = ix1 + gridX1 * (iy1 + 1);
            var c = ix1 + 1 + gridX1 * (iy1 + 1);
            var d = ix1 + 1 + gridX1 * iy1;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(PlaneGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(PlaneGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ function fromJSON(data) {
                return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
            }
        }
    ]);
    return PlaneGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$68cb731f50f614af = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(RingGeometry, BufferGeometry);
    function RingGeometry() {
        var innerRadius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5, outerRadius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, thetaSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 32, phiSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, thetaStart = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, thetaLength = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2;
        (0, $jGAMp._)(this, RingGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, RingGeometry);
        _this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // some helper variables
        var radius = innerRadius;
        var radiusStep = (outerRadius - innerRadius) / phiSegments;
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var uv = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(var j = 0; j <= phiSegments; j++){
            for(var i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                var segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(var j1 = 0; j1 < phiSegments; j1++){
            var thetaSegmentLevel = j1 * (thetaSegments + 1);
            for(var i1 = 0; i1 < thetaSegments; i1++){
                var segment1 = i1 + thetaSegmentLevel;
                var a = segment1;
                var b = segment1 + thetaSegments + 1;
                var c = segment1 + thetaSegments + 2;
                var d = segment1 + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(RingGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(RingGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ function fromJSON(data) {
                return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return RingGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$57a29a1c803e9065 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(ShapeGeometry, BufferGeometry);
    function ShapeGeometry() {
        var shapes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa([
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0, 0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(-0.5, -0.5),
            new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(0.5, -0.5)
        ]), curveSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
        (0, $jGAMp._)(this, ShapeGeometry);
        var _this;
        var addShape = // helper functions
        function addShape(shape) {
            var indexOffset = vertices.length / 3;
            var points = shape.extractPoints(curveSegments);
            var shapeVertices = points.shape;
            var shapeHoles = points.holes;
            // check direction of vertices
            if ($a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(var i = 0, l = shapeHoles.length; i < l; i++){
                var shapeHole = shapeHoles[i];
                if ($a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            var faces = $a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(var i1 = 0, l1 = shapeHoles.length; i1 < l1; i1++){
                var shapeHole1 = shapeHoles[i1];
                shapeVertices = shapeVertices.concat(shapeHole1);
            }
            // vertices, normals, uvs
            for(var i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++){
                var vertex = shapeVertices[i2];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(var i3 = 0, l3 = faces.length; i3 < l3; i3++){
                var face = faces[i3];
                var a = face[0] + indexOffset;
                var b = face[1] + indexOffset;
                var c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        };
        _this = (0, $kzDuW._)(this, ShapeGeometry);
        _this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var groupStart = 0;
        var groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(var i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            _this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(ShapeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(ShapeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON1() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(ShapeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                return $a1724dcfba0d6d9a$var$toJSON(shapes, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                return new ShapeGeometry(geometryShapes, data.curveSegments);
            }
        }
    ]);
    return ShapeGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
function $a1724dcfba0d6d9a$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$1b417fc3b307a251 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(SphereGeometry, BufferGeometry);
    function SphereGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, widthSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, heightSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 16, phiStart = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, phiLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI;
        (0, $jGAMp._)(this, SphereGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, SphereGeometry);
        _this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        var index = 0;
        var grid = [];
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // generate vertices, normals and uvs
        for(var iy = 0; iy <= heightSegments; iy++){
            var verticesRow = [];
            var v = iy / heightSegments;
            // special case for the poles
            var uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(var ix = 0; ix <= widthSegments; ix++){
                var u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(var iy1 = 0; iy1 < heightSegments; iy1++)for(var ix1 = 0; ix1 < widthSegments; ix1++){
            var a = grid[iy1][ix1 + 1];
            var b = grid[iy1][ix1];
            var c = grid[iy1 + 1][ix1];
            var d = grid[iy1 + 1][ix1 + 1];
            if (iy1 !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy1 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(SphereGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(SphereGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ function fromJSON(data) {
                return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return SphereGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ var $a1724dcfba0d6d9a$export$fb3f7adc68bd6e02 = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $i3fW3._)(TetrahedronGeometry, PolyhedronGeometry);
    function TetrahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $jGAMp._)(this, TetrahedronGeometry);
        var _this;
        var vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        var indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        _this = (0, $kzDuW._)(this, TetrahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $byiyg._)(TetrahedronGeometry, null, [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ function fromJSON(data) {
                return new TetrahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return TetrahedronGeometry;
}($a1724dcfba0d6d9a$export$60e57a7d3f20ff65);
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$a2312a2a1fa56495 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(TorusGeometry, BufferGeometry);
    function TorusGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 12, tubularSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 48, arc = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2;
        (0, $jGAMp._)(this, TorusGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, TorusGeometry);
        _this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var center = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var j = 0; j <= radialSegments; j++)for(var i = 0; i <= tubularSegments; i++){
            var u = i / tubularSegments * arc;
            var v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(var j1 = 1; j1 <= radialSegments; j1++)for(var i1 = 1; i1 <= tubularSegments; i1++){
            // indices
            var a = (tubularSegments + 1) * j1 + i1 - 1;
            var b = (tubularSegments + 1) * (j1 - 1) + i1 - 1;
            var c = (tubularSegments + 1) * (j1 - 1) + i1;
            var d = (tubularSegments + 1) * j1 + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(TorusGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(TorusGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ function fromJSON(data) {
                return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
            }
        }
    ]);
    return TorusGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$77e9bfadfb9ab8c8 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(TorusKnotGeometry, BufferGeometry);
    function TorusKnotGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, tubularSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 64, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2, q = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 3;
        (0, $jGAMp._)(this, TorusKnotGeometry);
        var _this;
        var calculatePositionOnCurve = // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            var cu = Math.cos(u);
            var su = Math.sin(u);
            var quOverP = q / p * u;
            var cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        };
        _this = (0, $kzDuW._)(this, TorusKnotGeometry);
        _this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var P1 = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var P2 = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var B = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var T = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var N = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            var u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(var j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                var v = j / radialSegments * Math.PI * 2;
                var cx = -tube * Math.cos(v);
                var cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(var j1 = 1; j1 <= tubularSegments; j1++)for(var i1 = 1; i1 <= radialSegments; i1++){
            // indices
            var a = (radialSegments + 1) * (j1 - 1) + (i1 - 1);
            var b = (radialSegments + 1) * j1 + (i1 - 1);
            var c = (radialSegments + 1) * j1 + i1;
            var d = (radialSegments + 1) * (j1 - 1) + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(TorusKnotGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(TorusKnotGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ function fromJSON(data) {
                return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
            }
        }
    ]);
    return TorusKnotGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$7897d9d48904490c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(TubeGeometry, BufferGeometry);
    function TubeGeometry() {
        var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$bf3f4c7e459f90fc(new $a1724dcfba0d6d9a$export$64b5c384219d3699(-1, -1, 0), new $a1724dcfba0d6d9a$export$64b5c384219d3699(-1, 1, 0), new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 1, 0)), tubularSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, closed = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $jGAMp._)(this, TubeGeometry);
        var _this;
        var generateBufferData = // functions
        function generateBufferData() {
            for(var i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        };
        var generateSegment = function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            var N = frames.normals[i];
            var B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(var j = 0; j <= radialSegments; j++){
                var v = j / radialSegments * Math.PI * 2;
                var sin = Math.sin(v);
                var cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        };
        var generateIndices = function generateIndices() {
            for(var j = 1; j <= tubularSegments; j++)for(var i = 1; i <= radialSegments; i++){
                var a = (radialSegments + 1) * (j - 1) + (i - 1);
                var b = (radialSegments + 1) * j + (i - 1);
                var c = (radialSegments + 1) * j + i;
                var d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        };
        var generateUVs = function generateUVs() {
            for(var i = 0; i <= tubularSegments; i++)for(var j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        };
        _this = (0, $kzDuW._)(this, TubeGeometry);
        _this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        var frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        _this.tangents = frames.tangents;
        _this.normals = frames.normals;
        _this.binormals = frames.binormals;
        // helper variables
        var vertex = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var normal = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        var uv = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
        var P = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        // buffer
        var vertices = [];
        var normals = [];
        var uvs = [];
        var indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $byiyg._)(TubeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(TubeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(TubeGeometry.prototype), "toJSON", this).call(this);
                data.path = this.parameters.path.toJSON();
                return data;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ function fromJSON(data) {
                // This only works for built-in curves (e.g. CatmullRomCurve3).
                // User defined curves or instances of CurvePath will not be deserialized.
                return new TubeGeometry(new $a1724dcfba0d6d9a$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
            }
        }
    ]);
    return TubeGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ var $a1724dcfba0d6d9a$export$4b739da06d24892b = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(WireframeGeometry, BufferGeometry);
    function WireframeGeometry() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $jGAMp._)(this, WireframeGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, WireframeGeometry);
        _this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ _this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            var vertices = [];
            var edges = new Set();
            // helper variables
            var start = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            var end = new $a1724dcfba0d6d9a$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                var position = geometry.attributes.position;
                var indices = geometry.index;
                var groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(var o = 0, ol = groups.length; o < ol; ++o){
                    var group = groups[o];
                    var groupStart = group.start;
                    var groupCount = group.count;
                    for(var i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(var j = 0; j < 3; j++){
                        var index1 = indices.getX(i + j);
                        var index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($a1724dcfba0d6d9a$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                var position1 = geometry.attributes.position;
                for(var i1 = 0, l1 = position1.count / 3; i1 < l1; i1++)for(var j1 = 0; j1 < 3; j1++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    var index11 = 3 * i1 + j1;
                    var index21 = 3 * i1 + (j1 + 1) % 3;
                    start.fromBufferAttribute(position1, index11);
                    end.fromBufferAttribute(position1, index21);
                    if ($a1724dcfba0d6d9a$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            _this.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        }
        return _this;
    }
    (0, $byiyg._)(WireframeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(WireframeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ]);
    return WireframeGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
function $a1724dcfba0d6d9a$var$isUniqueEdge(start, end, edges) {
    var hash1 = "".concat(start.x, ",").concat(start.y, ",").concat(start.z, "-").concat(end.x, ",").concat(end.y, ",").concat(end.z);
    var hash2 = "".concat(end.x, ",").concat(end.y, ",").concat(end.z, "-").concat(start.x, ",").concat(start.y, ",").concat(start.z); // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $a1724dcfba0d6d9a$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $a1724dcfba0d6d9a$export$33e43285f7406bd5,
    CapsuleGeometry: $a1724dcfba0d6d9a$export$41680e8551036033,
    CircleGeometry: $a1724dcfba0d6d9a$export$d5c0e8d607467193,
    ConeGeometry: $a1724dcfba0d6d9a$export$a7a48974f285c9b3,
    CylinderGeometry: $a1724dcfba0d6d9a$export$68f745719dbe5198,
    DodecahedronGeometry: $a1724dcfba0d6d9a$export$c0babfeb8708fc9c,
    EdgesGeometry: $a1724dcfba0d6d9a$export$4730b1542707547f,
    ExtrudeGeometry: $a1724dcfba0d6d9a$export$598697a1efa63ca7,
    IcosahedronGeometry: $a1724dcfba0d6d9a$export$9567cc828c9535da,
    LatheGeometry: $a1724dcfba0d6d9a$export$6d839803fcd1882c,
    OctahedronGeometry: $a1724dcfba0d6d9a$export$1954e2b809fe361e,
    PlaneGeometry: $a1724dcfba0d6d9a$export$967d831af31f69ce,
    PolyhedronGeometry: $a1724dcfba0d6d9a$export$60e57a7d3f20ff65,
    RingGeometry: $a1724dcfba0d6d9a$export$68cb731f50f614af,
    ShapeGeometry: $a1724dcfba0d6d9a$export$57a29a1c803e9065,
    SphereGeometry: $a1724dcfba0d6d9a$export$1b417fc3b307a251,
    TetrahedronGeometry: $a1724dcfba0d6d9a$export$fb3f7adc68bd6e02,
    TorusGeometry: $a1724dcfba0d6d9a$export$a2312a2a1fa56495,
    TorusKnotGeometry: $a1724dcfba0d6d9a$export$77e9bfadfb9ab8c8,
    TubeGeometry: $a1724dcfba0d6d9a$export$7897d9d48904490c,
    WireframeGeometry: $a1724dcfba0d6d9a$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$e8564da406055a3 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(ShadowMaterial, Material);
    function ShadowMaterial(parameters) {
        (0, $jGAMp._)(this, ShadowMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, ShadowMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isShadowMaterial = true;
        _this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(ShadowMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(ShadowMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return ShadowMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ var $a1724dcfba0d6d9a$export$21c421a2e1df9d22 = /*#__PURE__*/ function(ShaderMaterial) {
    "use strict";
    (0, $i3fW3._)(RawShaderMaterial, ShaderMaterial);
    function RawShaderMaterial(parameters) {
        (0, $jGAMp._)(this, RawShaderMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, RawShaderMaterial, [
            parameters
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isRawShaderMaterial = true;
        _this.type = 'RawShaderMaterial';
        return _this;
    }
    return RawShaderMaterial;
}($a1724dcfba0d6d9a$export$83c7d75d550a8b0d);
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity]{@link https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/},
 * [Unreal]{@link https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/} and
 * [3D Studio Max]{@link http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017}.
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset]{@link https://www.marmoset.co}:
 *
 * - [Basic Theory of Physically Based Rendering]{@link https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/}
 * - [Physically Based Rendering and You Can Too]{@link https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/}
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney]{@link https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf}
 * (pdf), by Brent Burley.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$f2980790215acccd = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshStandardMaterial, Material);
    function MeshStandardMaterial(parameters) {
        (0, $jGAMp._)(this, MeshStandardMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshStandardMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshStandardMaterial = true;
        _this.type = 'MeshStandardMaterial';
        _this.defines = {
            STANDARD: ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.emissive = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.envMapRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshStandardMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshStandardMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    STANDARD: ''
                };
                this.color.copy(source.color);
                this.roughness = source.roughness;
                this.metalness = source.metalness;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.roughnessMap = source.roughnessMap;
                this.metalnessMap = source.metalnessMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.envMapIntensity = source.envMapIntensity;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshStandardMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 */ var $a1724dcfba0d6d9a$export$28d04986c4269c9f = /*#__PURE__*/ function(MeshStandardMaterial) {
    "use strict";
    (0, $i3fW3._)(MeshPhysicalMaterial, MeshStandardMaterial);
    function MeshPhysicalMaterial(parameters) {
        (0, $jGAMp._)(this, MeshPhysicalMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshPhysicalMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshPhysicalMaterial = true;
        _this.defines = {
            STANDARD: '',
            PHYSICAL: ''
        };
        _this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.clearcoatNormalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ _this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(_this, 'reflectivity', {
            get: function get() {
                return $a1724dcfba0d6d9a$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function set(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ _this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ _this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.sheenColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ _this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.attenuationColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.specularColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.specularColorMap = null;
        _this._anisotropy = 0;
        _this._clearcoat = 0;
        _this._dispersion = 0;
        _this._iridescence = 0;
        _this._sheen = 0.0;
        _this._transmission = 0;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshPhysicalMaterial, [
        {
            key: "anisotropy",
            get: /**
	 * The anisotropy strength.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._anisotropy;
            },
            set: function set(value) {
                if (this._anisotropy > 0 !== value > 0) this.version++;
                this._anisotropy = value;
            }
        },
        {
            key: "clearcoat",
            get: /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._clearcoat;
            },
            set: function set(value) {
                if (this._clearcoat > 0 !== value > 0) this.version++;
                this._clearcoat = value;
            }
        },
        {
            key: "iridescence",
            get: /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._iridescence;
            },
            set: function set(value) {
                if (this._iridescence > 0 !== value > 0) this.version++;
                this._iridescence = value;
            }
        },
        {
            key: "dispersion",
            get: /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._dispersion;
            },
            set: function set(value) {
                if (this._dispersion > 0 !== value > 0) this.version++;
                this._dispersion = value;
            }
        },
        {
            key: "sheen",
            get: /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._sheen;
            },
            set: function set(value) {
                if (this._sheen > 0 !== value > 0) this.version++;
                this._sheen = value;
            }
        },
        {
            key: "transmission",
            get: /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ function get() {
                return this._transmission;
            },
            set: function set(value) {
                if (this._transmission > 0 !== value > 0) this.version++;
                this._transmission = value;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshPhysicalMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    STANDARD: '',
                    PHYSICAL: ''
                };
                this.anisotropy = source.anisotropy;
                this.anisotropyRotation = source.anisotropyRotation;
                this.anisotropyMap = source.anisotropyMap;
                this.clearcoat = source.clearcoat;
                this.clearcoatMap = source.clearcoatMap;
                this.clearcoatRoughness = source.clearcoatRoughness;
                this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
                this.clearcoatNormalMap = source.clearcoatNormalMap;
                this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
                this.dispersion = source.dispersion;
                this.ior = source.ior;
                this.iridescence = source.iridescence;
                this.iridescenceMap = source.iridescenceMap;
                this.iridescenceIOR = source.iridescenceIOR;
                this.iridescenceThicknessRange = (0, $7WNf6._)(source.iridescenceThicknessRange);
                this.iridescenceThicknessMap = source.iridescenceThicknessMap;
                this.sheen = source.sheen;
                this.sheenColor.copy(source.sheenColor);
                this.sheenColorMap = source.sheenColorMap;
                this.sheenRoughness = source.sheenRoughness;
                this.sheenRoughnessMap = source.sheenRoughnessMap;
                this.transmission = source.transmission;
                this.transmissionMap = source.transmissionMap;
                this.thickness = source.thickness;
                this.thicknessMap = source.thicknessMap;
                this.attenuationDistance = source.attenuationDistance;
                this.attenuationColor.copy(source.attenuationColor);
                this.specularIntensity = source.specularIntensity;
                this.specularIntensityMap = source.specularIntensityMap;
                this.specularColor.copy(source.specularColor);
                this.specularColorMap = source.specularColorMap;
                return this;
            }
        }
    ]);
    return MeshPhysicalMaterial;
}($a1724dcfba0d6d9a$export$f2980790215acccd);
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong]{@link https://en.wikipedia.org/wiki/Blinn-Phong_shading_model}
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$24c72f71cbaf0678 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshPhongMaterial, Material);
    function MeshPhongMaterial(parameters) {
        (0, $jGAMp._)(this, MeshPhongMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshPhongMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshPhongMaterial = true;
        _this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ _this.specular = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ _this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.emissive = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.envMapRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ _this.combine = $a1724dcfba0d6d9a$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ _this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ _this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshPhongMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshPhongMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.specular.copy(source.specular);
                this.shininess = source.shininess;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshPhongMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material implementing toon shading.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$df893cf97e765622 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshToonMaterial, Material);
    function MeshToonMaterial(parameters) {
        (0, $jGAMp._)(this, MeshToonMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshToonMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshToonMaterial = true;
        _this.defines = {
            TOON: ''
        };
        _this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.emissive = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshToonMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshToonMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.gradientMap = source.gradientMap;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshToonMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$bfe8c0a091f41ae7 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshNormalMaterial, Material);
    function MeshNormalMaterial(parameters) {
        (0, $jGAMp._)(this, MeshNormalMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshNormalMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshNormalMaterial = true;
        _this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flatShading = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshNormalMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshNormalMaterial.prototype), "copy", this).call(this, source);
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.flatShading = source.flatShading;
                return this;
            }
        }
    ]);
    return MeshNormalMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian]{@link https://en.wikipedia.org/wiki/Lambertian_reflectance}
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$5023a9a8114806b8 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshLambertMaterial, Material);
    function MeshLambertMaterial(parameters) {
        (0, $jGAMp._)(this, MeshLambertMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshLambertMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshLambertMaterial = true;
        _this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ _this.emissive = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ _this.envMapRotation = new $a1724dcfba0d6d9a$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ _this.combine = $a1724dcfba0d6d9a$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ _this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ _this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ _this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshLambertMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshLambertMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshLambertMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$2698c22ec13825db = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshDepthMaterial, Material);
    function MeshDepthMaterial(parameters) {
        (0, $jGAMp._)(this, MeshDepthMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshDepthMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshDepthMaterial = true;
        _this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ _this.depthPacking = $a1724dcfba0d6d9a$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.wireframeLinewidth = 1;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshDepthMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshDepthMaterial.prototype), "copy", this).call(this, source);
                this.depthPacking = source.depthPacking;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                return this;
            }
        }
    ]);
    return MeshDepthMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do no cast shadows.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$33e187ed002f2a19 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshDistanceMaterial, Material);
    function MeshDistanceMaterial(parameters) {
        (0, $jGAMp._)(this, MeshDistanceMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshDistanceMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshDistanceMaterial = true;
        _this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshDistanceMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshDistanceMaterial.prototype), "copy", this).call(this, source);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                return this;
            }
        }
    ]);
    return MeshDistanceMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 */ var $a1724dcfba0d6d9a$export$6f5fef6235ec12ee = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $i3fW3._)(MeshMatcapMaterial, Material);
    function MeshMatcapMaterial(parameters) {
        (0, $jGAMp._)(this, MeshMatcapMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, MeshMatcapMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isMeshMatcapMaterial = true;
        _this.defines = {
            MATCAP: ''
        };
        _this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ _this.normalMapType = $a1724dcfba0d6d9a$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ _this.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.alphaMap = null;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(MeshMatcapMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(MeshMatcapMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    MATCAP: ''
                };
                this.color.copy(source.color);
                this.matcap = source.matcap;
                this.map = source.map;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshMatcapMaterial;
}($a1724dcfba0d6d9a$export$a2d8b23205c25948);
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ var $a1724dcfba0d6d9a$export$327886a3efaeaebe = /*#__PURE__*/ function(LineBasicMaterial) {
    "use strict";
    (0, $i3fW3._)(LineDashedMaterial, LineBasicMaterial);
    function LineDashedMaterial(parameters) {
        (0, $jGAMp._)(this, LineDashedMaterial);
        var _this;
        _this = (0, $kzDuW._)(this, LineDashedMaterial);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLineDashedMaterial = true;
        _this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ _this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.gapSize = 1;
        _this.setValues(parameters);
        return _this;
    }
    (0, $byiyg._)(LineDashedMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LineDashedMaterial.prototype), "copy", this).call(this, source);
                this.scale = source.scale;
                this.dashSize = source.dashSize;
                this.gapSize = source.gapSize;
                return this;
            }
        }
    ]);
    return LineDashedMaterial;
}($a1724dcfba0d6d9a$export$fbaaa33907730a0c);
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $a1724dcfba0d6d9a$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} object - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $a1724dcfba0d6d9a$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $a1724dcfba0d6d9a$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    var n = times.length;
    var result = new Array(n);
    for(var i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $a1724dcfba0d6d9a$var$sortedArray(values, stride, order) {
    var nValues = values.length;
    var result = new values.constructor(nValues);
    for(var i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        var srcOffset = order[i] * stride;
        for(var j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $a1724dcfba0d6d9a$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    var i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    var value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            var _values;
            times.push(key.time);
            (_values = values).push.apply(_values, (0, $7WNf6._)(value)); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $a1724dcfba0d6d9a$var$subclip(sourceClip, name, startFrame, endFrame) {
    var fps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 30;
    var clip = sourceClip.clone();
    clip.name = name;
    var tracks = [];
    for(var i = 0; i < clip.tracks.length; ++i){
        var track = clip.tracks[i];
        var valueSize = track.getValueSize();
        var times = [];
        var values = [];
        for(var j = 0; j < track.times.length; ++j){
            var frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(var k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $a1724dcfba0d6d9a$var$convertArray(times, track.times.constructor);
        track.values = $a1724dcfba0d6d9a$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    var minStartTime = Infinity;
    for(var i1 = 0; i1 < clip.tracks.length; ++i1)if (minStartTime > clip.tracks[i1].times[0]) minStartTime = clip.tracks[i1].times[0];
    // shift all tracks such that clip begins at t=0
    for(var i2 = 0; i2 < clip.tracks.length; ++i2)clip.tracks[i2].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $a1724dcfba0d6d9a$var$makeClipAdditive(targetClip) {
    var _loop = function(i) {
        var referenceTrack = referenceClip.tracks[i];
        var referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') return "continue";
        // Find the track in the target clip whose name and type matches the reference track
        var targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) return "continue";
        var referenceOffset = 0;
        var referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        var targetOffset = 0;
        var targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        var lastIndex = referenceTrack.times.length - 1;
        var referenceValue = void 0;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            var startIndex = referenceOffset;
            var endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            var startIndex1 = lastIndex * referenceValueSize + referenceOffset;
            var endIndex1 = startIndex1 + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex1, endIndex1);
        } else {
            // Interpolate to the reference value
            var interpolant = referenceTrack.createInterpolant();
            var startIndex2 = referenceOffset;
            var endIndex2 = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex2, endIndex2);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            var referenceQuat = new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        var numTimes = targetTrack.times.length;
        for(var j = 0; j < numTimes; ++j){
            var valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                var valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(var k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    };
    var referenceFrame = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, referenceClip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : targetClip, fps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30;
    if (fps <= 0) fps = 30;
    var numTracks = referenceClip.tracks.length;
    var referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(var i = 0; i < numTracks; ++i)_loop(i);
    targetClip.blendMode = $a1724dcfba0d6d9a$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$7ee8caa573e71ad1 = /*#__PURE__*/ function() {
    "use strict";
    function AnimationUtils() {
        (0, $jGAMp._)(this, AnimationUtils);
    }
    (0, $byiyg._)(AnimationUtils, null, [
        {
            key: "convertArray",
            value: /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ function convertArray1(array, type) {
                return $a1724dcfba0d6d9a$var$convertArray(array, type);
            }
        },
        {
            key: "isTypedArray",
            value: /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ function isTypedArray1(object) {
                return $a1724dcfba0d6d9a$var$isTypedArray(object);
            }
        },
        {
            key: "getKeyframeOrder",
            value: /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ function getKeyframeOrder1(times) {
                return $a1724dcfba0d6d9a$var$getKeyframeOrder(times);
            }
        },
        {
            key: "sortedArray",
            value: /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ function sortedArray1(values, stride, order) {
                return $a1724dcfba0d6d9a$var$sortedArray(values, stride, order);
            }
        },
        {
            key: "flattenJSON",
            value: /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ function flattenJSON1(jsonKeys, times, values, valuePropertyName) {
                $a1724dcfba0d6d9a$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
            }
        },
        {
            key: "subclip",
            value: /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ function subclip1(sourceClip, name, startFrame, endFrame) {
                var fps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 30;
                return $a1724dcfba0d6d9a$var$subclip(sourceClip, name, startFrame, endFrame, fps);
            }
        },
        {
            key: "makeClipAdditive",
            value: /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ function makeClipAdditive1(targetClip) {
                var referenceFrame = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, referenceClip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : targetClip, fps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30;
                return $a1724dcfba0d6d9a$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
            }
        }
    ]);
    return AnimationUtils;
}();
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ var $a1724dcfba0d6d9a$export$b558baee9c0f72d3 = /*#__PURE__*/ function() {
    "use strict";
    function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $jGAMp._)(this, Interpolant);
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    (0, $byiyg._)(Interpolant, [
        {
            /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ key: "evaluate",
            value: function evaluate(t) {
                var pp = this.parameterPositions;
                var i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
                validate_interval: {
                    seek: {
                        var right;
                        linear_scan: {
                            //- See http://jsperf.com/comparison-to-undefined/3
                            //- slower code:
                            //-
                            //- 				if ( t >= t1 || t1 === undefined ) {
                            forward_scan: if (!(t < t1)) {
                                for(var giveUpAt = i1 + 2;;){
                                    if (t1 === undefined) {
                                        if (t < t0) break forward_scan;
                                        // after end
                                        i1 = pp.length;
                                        this._cachedIndex = i1;
                                        return this.copySampleValue_(i1 - 1);
                                    }
                                    if (i1 === giveUpAt) break; // this loop
                                    t0 = t1;
                                    t1 = pp[++i1];
                                    if (t < t1) break seek;
                                }
                                // prepare binary search on the right side of the index
                                right = pp.length;
                                break linear_scan;
                            }
                            //- slower code:
                            //-					if ( t < t0 || t0 === undefined ) {
                            if (!(t >= t0)) {
                                // looping?
                                var t1global = pp[1];
                                if (t < t1global) {
                                    i1 = 2; // + 1, using the scan for the details
                                    t0 = t1global;
                                }
                                // linear reverse scan
                                for(var giveUpAt1 = i1 - 2;;){
                                    if (t0 === undefined) {
                                        // before start
                                        this._cachedIndex = 0;
                                        return this.copySampleValue_(0);
                                    }
                                    if (i1 === giveUpAt1) break; // this loop
                                    t1 = t0;
                                    t0 = pp[--i1 - 1];
                                    if (t >= t0) break seek;
                                }
                                // prepare binary search on the left side of the index
                                right = i1;
                                i1 = 0;
                                break linear_scan;
                            }
                            break validate_interval;
                        } // linear scan
                        // binary search
                        while(i1 < right){
                            var mid = i1 + right >>> 1;
                            if (t < pp[mid]) right = mid;
                            else i1 = mid + 1;
                        }
                        t1 = pp[i1];
                        t0 = pp[i1 - 1];
                        // check boundary cases, again
                        if (t0 === undefined) {
                            this._cachedIndex = 0;
                            return this.copySampleValue_(0);
                        }
                        if (t1 === undefined) {
                            i1 = pp.length;
                            this._cachedIndex = i1;
                            return this.copySampleValue_(i1 - 1);
                        }
                    } // seek
                    this._cachedIndex = i1;
                    this.intervalChanged_(i1, t0, t1);
                } // validate_interval
                return this.interpolate_(i1, t0, t, t1);
            }
        },
        {
            /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ key: "getSettings_",
            value: function getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
        },
        {
            /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ key: "copySampleValue_",
            value: function copySampleValue_(index) {
                // copies a sample value to the result buffer
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset + i];
                return result;
            }
        },
        {
            /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ key: "interpolate_",
            value: function interpolate_() {
                throw new Error('call to abstract method');
            // implementations shall return this.resultBuffer
            }
        },
        {
            /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ key: "intervalChanged_",
            value: function intervalChanged_() {
            // empty
            }
        }
    ]);
    return Interpolant;
}();
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ var $a1724dcfba0d6d9a$export$3646682e7a3959 = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $i3fW3._)(CubicInterpolant, Interpolant);
    function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $jGAMp._)(this, CubicInterpolant);
        var _this;
        _this = (0, $kzDuW._)(this, CubicInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
        _this._weightPrev = -0;
        _this._offsetPrev = -0;
        _this._weightNext = -0;
        _this._offsetNext = -0;
        _this.DefaultSettings_ = {
            endingStart: $a1724dcfba0d6d9a$export$7f795934b84ab523,
            endingEnd: $a1724dcfba0d6d9a$export$7f795934b84ab523
        };
        return _this;
    }
    (0, $byiyg._)(CubicInterpolant, [
        {
            key: "intervalChanged_",
            value: function intervalChanged_(i1, t0, t1) {
                var pp = this.parameterPositions;
                var iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
                if (tPrev === undefined) switch(this.getSettings_().endingStart){
                    case $a1724dcfba0d6d9a$export$24a4ccb5099273b5:
                        // f'(t0) = 0
                        iPrev = i1;
                        tPrev = 2 * t0 - t1;
                        break;
                    case $a1724dcfba0d6d9a$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iPrev = pp.length - 2;
                        tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                        break;
                    default:
                        // f''(t0) = 0 a.k.a. Natural Spline
                        iPrev = i1;
                        tPrev = t1;
                }
                if (tNext === undefined) switch(this.getSettings_().endingEnd){
                    case $a1724dcfba0d6d9a$export$24a4ccb5099273b5:
                        // f'(tN) = 0
                        iNext = i1;
                        tNext = 2 * t1 - t0;
                        break;
                    case $a1724dcfba0d6d9a$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iNext = 1;
                        tNext = t1 + pp[1] - pp[0];
                        break;
                    default:
                        // f''(tN) = 0, a.k.a. Natural Spline
                        iNext = i1 - 1;
                        tNext = t0;
                }
                var halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
                this._weightPrev = halfDt / (t0 - tPrev);
                this._weightNext = halfDt / (tNext - t1);
                this._offsetPrev = iPrev * stride;
                this._offsetNext = iNext * stride;
            }
        },
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
                // evaluate polynomials
                var sP = -wP * ppp + 2 * wP * pp - wP * p;
                var s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
                var s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
                var sN = wN * ppp - wN * pp;
                // combine data linearly
                for(var i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
                return result;
            }
        }
    ]);
    return CubicInterpolant;
}($a1724dcfba0d6d9a$export$b558baee9c0f72d3);
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ var $a1724dcfba0d6d9a$export$a8e6009059f51e1a = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $i3fW3._)(LinearInterpolant, Interpolant);
    function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $jGAMp._)(this, LinearInterpolant);
        return (0, $kzDuW._)(this, LinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $byiyg._)(LinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
                return result;
            }
        }
    ]);
    return LinearInterpolant;
}($a1724dcfba0d6d9a$export$b558baee9c0f72d3);
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ var $a1724dcfba0d6d9a$export$fb9758ef7ef8d5cc = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $i3fW3._)(DiscreteInterpolant, Interpolant);
    function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $jGAMp._)(this, DiscreteInterpolant);
        return (0, $kzDuW._)(this, DiscreteInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $byiyg._)(DiscreteInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1 /*, t0, t, t1 */ ) {
                return this.copySampleValue_(i1 - 1);
            }
        }
    ]);
    return DiscreteInterpolant;
}($a1724dcfba0d6d9a$export$b558baee9c0f72d3);
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ var $a1724dcfba0d6d9a$export$b0e479f45b7006d6 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeTrack(name, times, values, interpolation) {
        (0, $jGAMp._)(this, KeyframeTrack);
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $a1724dcfba0d6d9a$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $a1724dcfba0d6d9a$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    (0, $byiyg._)(KeyframeTrack, [
        {
            /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ key: "InterpolantFactoryMethodDiscrete",
            value: function InterpolantFactoryMethodDiscrete(result) {
                return new $a1724dcfba0d6d9a$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $a1724dcfba0d6d9a$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ key: "InterpolantFactoryMethodSmooth",
            value: function InterpolantFactoryMethodSmooth(result) {
                return new $a1724dcfba0d6d9a$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ key: "setInterpolation",
            value: function setInterpolation(interpolation) {
                var factoryMethod;
                switch(interpolation){
                    case $a1724dcfba0d6d9a$export$995b32462a65e855:
                        factoryMethod = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case $a1724dcfba0d6d9a$export$30fac1aace31cf4d:
                        factoryMethod = this.InterpolantFactoryMethodLinear;
                        break;
                    case $a1724dcfba0d6d9a$export$198b11ff4c72bb30:
                        factoryMethod = this.InterpolantFactoryMethodSmooth;
                        break;
                }
                if (factoryMethod === undefined) {
                    var message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
                    if (this.createInterpolant === undefined) {
                        // fall back to default, unless the default itself is messed up
                        if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                        else throw new Error(message); // fatal, in this case
                    }
                    console.warn('THREE.KeyframeTrack:', message);
                    return this;
                }
                this.createInterpolant = factoryMethod;
                return this;
            }
        },
        {
            /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ key: "getInterpolation",
            value: function getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return $a1724dcfba0d6d9a$export$995b32462a65e855;
                    case this.InterpolantFactoryMethodLinear:
                        return $a1724dcfba0d6d9a$export$30fac1aace31cf4d;
                    case this.InterpolantFactoryMethodSmooth:
                        return $a1724dcfba0d6d9a$export$198b11ff4c72bb30;
                }
            }
        },
        {
            /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ key: "getValueSize",
            value: function getValueSize() {
                return this.values.length / this.times.length;
            }
        },
        {
            /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ key: "shift",
            value: function shift(timeOffset) {
                if (timeOffset !== 0.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
                }
                return this;
            }
        },
        {
            /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ key: "scale",
            value: function scale(timeScale) {
                if (timeScale !== 1.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
                }
                return this;
            }
        },
        {
            /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ key: "trim",
            value: function trim(startTime, endTime) {
                var times = this.times, nKeys = times.length;
                var from = 0, to = nKeys - 1;
                while(from !== nKeys && times[from] < startTime)++from;
                while(to !== -1 && times[to] > endTime)--to;
                ++to; // inclusive -> exclusive bound
                if (from !== 0 || to !== nKeys) {
                    // empty tracks are forbidden, so keep at least one keyframe
                    if (from >= to) {
                        to = Math.max(to, 1);
                        from = to - 1;
                    }
                    var stride = this.getValueSize();
                    this.times = times.slice(from, to);
                    this.values = this.values.slice(from * stride, to * stride);
                }
                return this;
            }
        },
        {
            /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ key: "validate",
            value: function validate() {
                var valid = true;
                var valueSize = this.getValueSize();
                if (valueSize - Math.floor(valueSize) !== 0) {
                    console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
                    valid = false;
                }
                var times = this.times, values = this.values, nKeys = times.length;
                if (nKeys === 0) {
                    console.error('THREE.KeyframeTrack: Track is empty.', this);
                    valid = false;
                }
                var prevTime = null;
                for(var i = 0; i !== nKeys; i++){
                    var currTime = times[i];
                    if (typeof currTime === 'number' && isNaN(currTime)) {
                        console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                        valid = false;
                        break;
                    }
                    if (prevTime !== null && prevTime > currTime) {
                        console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                        valid = false;
                        break;
                    }
                    prevTime = currTime;
                }
                if (values !== undefined) {
                    if ($a1724dcfba0d6d9a$var$isTypedArray(values)) for(var i1 = 0, n = values.length; i1 !== n; ++i1){
                        var value = values[i1];
                        if (isNaN(value)) {
                            console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i1, value);
                            valid = false;
                            break;
                        }
                    }
                }
                return valid;
            }
        },
        {
            /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ key: "optimize",
            value: function optimize() {
                // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
                // times or values may be shared with other tracks, so overwriting is unsafe
                var times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $a1724dcfba0d6d9a$export$198b11ff4c72bb30, lastIndex = times.length - 1;
                var writeIndex = 1;
                for(var i = 1; i < lastIndex; ++i){
                    var keep = false;
                    var time = times[i];
                    var timeNext = times[i + 1];
                    // remove adjacent keyframes scheduled at the same time
                    if (time !== timeNext && (i !== 1 || time !== times[0])) {
                        if (!smoothInterpolation) {
                            // remove unnecessary keyframes same as their neighbors
                            var offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                            for(var j = 0; j !== stride; ++j){
                                var value = values[offset + j];
                                if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                                    keep = true;
                                    break;
                                }
                            }
                        } else keep = true;
                    }
                    // in-place compaction
                    if (keep) {
                        if (i !== writeIndex) {
                            times[writeIndex] = times[i];
                            var readOffset = i * stride, writeOffset = writeIndex * stride;
                            for(var j1 = 0; j1 !== stride; ++j1)values[writeOffset + j1] = values[readOffset + j1];
                        }
                        ++writeIndex;
                    }
                }
                // flush last keyframe (compaction looks ahead)
                if (lastIndex > 0) {
                    times[writeIndex] = times[lastIndex];
                    for(var readOffset1 = lastIndex * stride, writeOffset1 = writeIndex * stride, j2 = 0; j2 !== stride; ++j2)values[writeOffset1 + j2] = values[readOffset1 + j2];
                    ++writeIndex;
                }
                if (writeIndex !== times.length) {
                    this.times = times.slice(0, writeIndex);
                    this.values = values.slice(0, writeIndex * stride);
                } else {
                    this.times = times;
                    this.values = values;
                }
                return this;
            }
        },
        {
            /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                var times = this.times.slice();
                var values = this.values.slice();
                var TypedKeyframeTrack = this.constructor;
                var track = new TypedKeyframeTrack(this.name, times, values);
                // Interpolant argument to constructor is not saved, so copy the factory method directly.
                track.createInterpolant = this.createInterpolant;
                return track;
            }
        }
    ], [
        {
            key: "toJSON",
            value: /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ function toJSON(track) {
                var trackType = track.constructor;
                var json;
                // derived classes can define a static toJSON method
                if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
                else {
                    // by default, we assume the data can be serialized as-is
                    json = {
                        name: track.name,
                        times: $a1724dcfba0d6d9a$var$convertArray(track.times, Array),
                        values: $a1724dcfba0d6d9a$var$convertArray(track.values, Array)
                    };
                    var interpolation = track.getInterpolation();
                    if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
                }
                json.type = track.ValueTypeName; // mandatory
                return json;
            }
        }
    ]);
    return KeyframeTrack;
}();
/**
 * The value type name.
 *
 * @type {String}
 * @default ''
 */ $a1724dcfba0d6d9a$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $a1724dcfba0d6d9a$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $a1724dcfba0d6d9a$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ $a1724dcfba0d6d9a$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $a1724dcfba0d6d9a$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$d3a344b98cf0b775 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(BooleanKeyframeTrack, KeyframeTrack);
    function BooleanKeyframeTrack(name, times, values) {
        (0, $jGAMp._)(this, BooleanKeyframeTrack);
        return (0, $kzDuW._)(this, BooleanKeyframeTrack, [
            name,
            times,
            values
        ]);
    }
    return BooleanKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'bool'
 */ $a1724dcfba0d6d9a$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $a1724dcfba0d6d9a$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $a1724dcfba0d6d9a$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $a1724dcfba0d6d9a$export$995b32462a65e855;
$a1724dcfba0d6d9a$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$a1724dcfba0d6d9a$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$83444c5d885347d8 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(ColorKeyframeTrack, KeyframeTrack);
    function ColorKeyframeTrack(name, times, values, interpolation) {
        (0, $jGAMp._)(this, ColorKeyframeTrack);
        return (0, $kzDuW._)(this, ColorKeyframeTrack, [
            name,
            times,
            values,
            interpolation
        ]);
    }
    return ColorKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'color'
 */ $a1724dcfba0d6d9a$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$d45f0d1a4d9a9314 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(NumberKeyframeTrack, KeyframeTrack);
    function NumberKeyframeTrack(name, times, values, interpolation) {
        (0, $jGAMp._)(this, NumberKeyframeTrack);
        return (0, $kzDuW._)(this, NumberKeyframeTrack, [
            name,
            times,
            values,
            interpolation
        ]);
    }
    return NumberKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'number'
 */ $a1724dcfba0d6d9a$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ var $a1724dcfba0d6d9a$export$2db1cfb7923d931e = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $i3fW3._)(QuaternionLinearInterpolant, Interpolant);
    function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $jGAMp._)(this, QuaternionLinearInterpolant);
        return (0, $kzDuW._)(this, QuaternionLinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $byiyg._)(QuaternionLinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
                var offset = i1 * stride;
                for(var end = offset + stride; offset !== end; offset += 4)$a1724dcfba0d6d9a$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
                return result;
            }
        }
    ]);
    return QuaternionLinearInterpolant;
}($a1724dcfba0d6d9a$export$b558baee9c0f72d3);
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$b8043f12b5aafbd7 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(QuaternionKeyframeTrack, KeyframeTrack);
    function QuaternionKeyframeTrack(name, times, values, interpolation) {
        (0, $jGAMp._)(this, QuaternionKeyframeTrack);
        return (0, $kzDuW._)(this, QuaternionKeyframeTrack, [
            name,
            times,
            values,
            interpolation
        ]);
    }
    (0, $byiyg._)(QuaternionKeyframeTrack, [
        {
            /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $a1724dcfba0d6d9a$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
            }
        }
    ]);
    return QuaternionKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'quaternion'
 */ $a1724dcfba0d6d9a$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$a1724dcfba0d6d9a$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(StringKeyframeTrack, KeyframeTrack);
    function StringKeyframeTrack(name, times, values) {
        (0, $jGAMp._)(this, StringKeyframeTrack);
        return (0, $kzDuW._)(this, StringKeyframeTrack, [
            name,
            times,
            values
        ]);
    }
    return StringKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'string'
 */ $a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $a1724dcfba0d6d9a$export$995b32462a65e855;
$a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ var $a1724dcfba0d6d9a$export$5ce2dcb4cc9f2bff = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $i3fW3._)(VectorKeyframeTrack, KeyframeTrack);
    function VectorKeyframeTrack(name, times, values, interpolation) {
        (0, $jGAMp._)(this, VectorKeyframeTrack);
        return (0, $kzDuW._)(this, VectorKeyframeTrack, [
            name,
            times,
            values,
            interpolation
        ]);
    }
    return VectorKeyframeTrack;
}($a1724dcfba0d6d9a$export$b0e479f45b7006d6);
/**
 * The value type name.
 *
 * @type {String}
 * @default 'vector'
 */ $a1724dcfba0d6d9a$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ var $a1724dcfba0d6d9a$export$d942c706bf23829c = /*#__PURE__*/ function() {
    "use strict";
    function AnimationClip() {
        var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, tracks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $a1724dcfba0d6d9a$export$bcfbbdcf8de7f8cd;
        (0, $jGAMp._)(this, AnimationClip);
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    (0, $byiyg._)(AnimationClip, [
        {
            /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ key: "resetDuration",
            value: function resetDuration() {
                var tracks = this.tracks;
                var duration = 0;
                for(var i = 0, n = tracks.length; i !== n; ++i){
                    var track = this.tracks[i];
                    duration = Math.max(duration, track.times[track.times.length - 1]);
                }
                this.duration = duration;
                return this;
            }
        },
        {
            /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ key: "trim",
            value: function trim() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
                return this;
            }
        },
        {
            /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ key: "validate",
            value: function validate() {
                var valid = true;
                for(var i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
                return valid;
            }
        },
        {
            /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ key: "optimize",
            value: function optimize() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
                return this;
            }
        },
        {
            /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                var tracks = [];
                for(var i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
                return new this.constructor(this.name, this.duration, tracks, this.blendMode);
            }
        },
        {
            /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ key: "toJSON",
            value: function toJSON() {
                return this.constructor.toJSON(this);
            }
        }
    ], [
        {
            key: "parse",
            value: /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ function parse(json) {
                var tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
                for(var i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($a1724dcfba0d6d9a$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
                var clip = new this(json.name, json.duration, tracks, json.blendMode);
                clip.uuid = json.uuid;
                return clip;
            }
        },
        {
            key: "toJSON",
            value: /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ function toJSON(clip) {
                var tracks = [], clipTracks = clip.tracks;
                var json = {
                    name: clip.name,
                    duration: clip.duration,
                    tracks: tracks,
                    uuid: clip.uuid,
                    blendMode: clip.blendMode
                };
                for(var i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($a1724dcfba0d6d9a$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
                return json;
            }
        },
        {
            key: "CreateFromMorphTargetSequence",
            value: /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ function CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
                var numMorphTargets = morphTargetSequence.length;
                var tracks = [];
                for(var i = 0; i < numMorphTargets; i++){
                    var times = [];
                    var values = [];
                    times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
                    values.push(0, 1, 0);
                    var order = $a1724dcfba0d6d9a$var$getKeyframeOrder(times);
                    times = $a1724dcfba0d6d9a$var$sortedArray(times, 1, order);
                    values = $a1724dcfba0d6d9a$var$sortedArray(values, 1, order);
                    // if there is a key at the first frame, duplicate it as the
                    // last frame as well for perfect loop.
                    if (!noLoop && times[0] === 0) {
                        times.push(numMorphTargets);
                        values.push(values[0]);
                    }
                    tracks.push(new $a1724dcfba0d6d9a$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
                }
                return new this(name, -1, tracks);
            }
        },
        {
            key: "findByName",
            value: /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ function findByName(objectOrClipArray, name) {
                var clipArray = objectOrClipArray;
                if (!Array.isArray(objectOrClipArray)) {
                    var o = objectOrClipArray;
                    clipArray = o.geometry && o.geometry.animations || o.animations;
                }
                for(var i = 0; i < clipArray.length; i++){
                    if (clipArray[i].name === name) return clipArray[i];
                }
                return null;
            }
        },
        {
            key: "CreateClipsFromMorphTargetSequences",
            value: /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ function CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
                var animationToMorphTargets = {};
                // tested with https://regex101.com/ on trick sequences
                // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
                var pattern = /^([\w-]*?)([\d]+)$/;
                // sort morph target names into animation groups based
                // patterns like Walk_001, Walk_002, Run_001, Run_002
                for(var i = 0, il = morphTargets.length; i < il; i++){
                    var morphTarget = morphTargets[i];
                    var parts = morphTarget.name.match(pattern);
                    if (parts && parts.length > 1) {
                        var name = parts[1];
                        var animationMorphTargets = animationToMorphTargets[name];
                        if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                        animationMorphTargets.push(morphTarget);
                    }
                }
                var clips = [];
                for(var name1 in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name1, animationToMorphTargets[name1], fps, noLoop));
                return clips;
            }
        },
        {
            key: "parseAnimation",
            value: /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ function parseAnimation(animation, bones) {
                console.warn('THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185');
                if (!animation) {
                    console.error('THREE.AnimationClip: No animation in JSONLoader data.');
                    return null;
                }
                var addNonemptyTrack = function addNonemptyTrack(trackType, trackName, animationKeys, propertyName, destTracks) {
                    // only return track if there are actually keys.
                    if (animationKeys.length !== 0) {
                        var times = [];
                        var values = [];
                        $a1724dcfba0d6d9a$var$flattenJSON(animationKeys, times, values, propertyName);
                        // empty keys are filtered out, so check again
                        if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
                    }
                };
                var tracks = [];
                var clipName = animation.name || 'default';
                var fps = animation.fps || 30;
                var blendMode = animation.blendMode;
                // automatic length determination in AnimationClip.
                var duration = animation.length || -1;
                var hierarchyTracks = animation.hierarchy || [];
                for(var h = 0; h < hierarchyTracks.length; h++){
                    var animationKeys = hierarchyTracks[h].keys;
                    // skip empty tracks
                    if (!animationKeys || animationKeys.length === 0) continue;
                    // process morph targets
                    if (animationKeys[0].morphTargets) {
                        // figure out all morph targets used in this track
                        var morphTargetNames = {};
                        var k = void 0;
                        for(k = 0; k < animationKeys.length; k++){
                            if (animationKeys[k].morphTargets) for(var m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                        }
                        // create a track for each morph target with all zero
                        // morphTargetInfluences except for the keys in which
                        // the morphTarget is named.
                        for(var morphTargetName in morphTargetNames){
                            var times = [];
                            var values = [];
                            for(var m1 = 0; m1 !== animationKeys[k].morphTargets.length; ++m1){
                                var animationKey = animationKeys[k];
                                times.push(animationKey.time);
                                values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                            }
                            tracks.push(new $a1724dcfba0d6d9a$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                        }
                        duration = morphTargetNames.length * fps;
                    } else {
                        // ...assume skeletal animation
                        var boneName = '.bones[' + bones[h].name + ']';
                        addNonemptyTrack($a1724dcfba0d6d9a$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                        addNonemptyTrack($a1724dcfba0d6d9a$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                        addNonemptyTrack($a1724dcfba0d6d9a$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
                    }
                }
                if (tracks.length === 0) return null;
                var clip = new this(clipName, duration, tracks, blendMode);
                return clip;
            }
        }
    ]);
    return AnimationClip;
}();
function $a1724dcfba0d6d9a$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $a1724dcfba0d6d9a$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $a1724dcfba0d6d9a$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $a1724dcfba0d6d9a$export$83444c5d885347d8;
        case 'quaternion':
            return $a1724dcfba0d6d9a$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $a1724dcfba0d6d9a$export$d3a344b98cf0b775;
        case 'string':
            return $a1724dcfba0d6d9a$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $a1724dcfba0d6d9a$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    var trackType = $a1724dcfba0d6d9a$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        var times = [], values = [];
        $a1724dcfba0d6d9a$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function add(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function get(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function remove(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function clear() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ var $a1724dcfba0d6d9a$export$99cc795e99919eed = function LoadingManager(onLoad, onProgress, onError) {
    "use strict";
    (0, $jGAMp._)(this, LoadingManager);
    var scope = this;
    var isLoading = false;
    var itemsLoaded = 0;
    var itemsTotal = 0;
    var urlModifier = undefined;
    var handlers = [];
    // Refer to #5689 for the reason why we don't set .onStart
    // in the constructor
    /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
    /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
    /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
    /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
    /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
            if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
        }
        isLoading = true;
    };
    /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
        if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== undefined) scope.onLoad();
        }
    };
    /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
        if (scope.onError !== undefined) scope.onError(url);
    };
    /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
        if (urlModifier) return urlModifier(url);
        return url;
    };
    /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
    };
    /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
    };
    /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
        var index = handlers.indexOf(regex);
        if (index !== -1) handlers.splice(index, 2);
        return this;
    };
    /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
        for(var i = 0, l = handlers.length; i < l; i += 2){
            var regex = handlers[i];
            var loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0; // see #17920
            if (regex.test(file)) return loader;
        }
        return null;
    };
};
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ var $a1724dcfba0d6d9a$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ var $a1724dcfba0d6d9a$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader(manager) {
        (0, $jGAMp._)(this, Loader);
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $a1724dcfba0d6d9a$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
    (0, $byiyg._)(Loader, [
        {
            /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ key: "load",
            value: function load() {}
        },
        {
            /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ key: "loadAsync",
            value: function loadAsync(url, onProgress) {
                var scope = this;
                return new Promise(function(resolve, reject) {
                    scope.load(url, resolve, onProgress, reject);
                });
            }
        },
        {
            /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @param {any} data - The data to parse.
	 */ key: "parse",
            value: function parse() {}
        },
        {
            /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ key: "setCrossOrigin",
            value: function setCrossOrigin(crossOrigin) {
                this.crossOrigin = crossOrigin;
                return this;
            }
        },
        {
            /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ key: "setWithCredentials",
            value: function setWithCredentials(value) {
                this.withCredentials = value;
                return this;
            }
        },
        {
            /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ key: "setPath",
            value: function setPath(path) {
                this.path = path;
                return this;
            }
        },
        {
            /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ key: "setResourcePath",
            value: function setResourcePath(resourcePath) {
                this.resourcePath = resourcePath;
                return this;
            }
        },
        {
            /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ key: "setRequestHeader",
            value: function setRequestHeader(requestHeader) {
                this.requestHeader = requestHeader;
                return this;
            }
        }
    ]);
    return Loader;
}();
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $a1724dcfba0d6d9a$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
var $a1724dcfba0d6d9a$var$loading = {};
var $a1724dcfba0d6d9a$var$HttpError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $i3fW3._)(HttpError, Error1);
    function HttpError(message, response) {
        (0, $jGAMp._)(this, HttpError);
        var _this;
        _this = (0, $kzDuW._)(this, HttpError, [
            message
        ]);
        _this.response = response;
        return _this;
    }
    return HttpError;
}((0, $8AW3P._)(Error));
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$98435a25b5cf7b2b = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(FileLoader, Loader);
    function FileLoader(manager) {
        (0, $jGAMp._)(this, FileLoader);
        var _this;
        _this = (0, $kzDuW._)(this, FileLoader, [
            manager
        ]);
        /**
		 * The expected mime type.
		 *
		 * @type {string}
		 */ _this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ _this.responseType = '';
        return _this;
    }
    (0, $byiyg._)(FileLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var _this = this;
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var cached = $a1724dcfba0d6d9a$export$94affb487e701bf2.get("file:".concat(url));
                if (cached !== undefined) {
                    this.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        _this.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                // Check if request is duplicate
                if ($a1724dcfba0d6d9a$var$loading[url] !== undefined) {
                    $a1724dcfba0d6d9a$var$loading[url].push({
                        onLoad: onLoad,
                        onProgress: onProgress,
                        onError: onError
                    });
                    return;
                }
                // Initialise array for duplicate requests
                $a1724dcfba0d6d9a$var$loading[url] = [];
                $a1724dcfba0d6d9a$var$loading[url].push({
                    onLoad: onLoad,
                    onProgress: onProgress,
                    onError: onError
                });
                // create request
                var req = new Request(url, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? 'include' : 'same-origin'
                });
                // record states ( avoid data race )
                var mimeType = this.mimeType;
                var responseType = this.responseType;
                // start the fetch
                fetch(req).then(function(response) {
                    if (response.status === 200 || response.status === 0) {
                        // Some browsers return HTTP Status 0 when using non-http protocol
                        // e.g. 'file://' or 'data://'. Handle as success.
                        if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                        // Workaround: Checking if response.body === undefined for Alipay browser #23548
                        if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                        var callbacks = $a1724dcfba0d6d9a$var$loading[url];
                        var reader = response.body.getReader();
                        // Nginx needs X-File-Size check
                        // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                        var contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                        var total = contentLength ? parseInt(contentLength) : 0;
                        var lengthComputable = total !== 0;
                        var loaded = 0;
                        // periodically read data into the new stream tracking while download progress
                        var stream = new ReadableStream({
                            start: function(controller) {
                                readData();
                                function readData() {
                                    reader.read().then(function(param) {
                                        var done = param.done, value = param.value;
                                        if (done) controller.close();
                                        else {
                                            loaded += value.byteLength;
                                            var event = new ProgressEvent('progress', {
                                                lengthComputable: lengthComputable,
                                                loaded: loaded,
                                                total: total
                                            });
                                            for(var i = 0, il = callbacks.length; i < il; i++){
                                                var callback = callbacks[i];
                                                if (callback.onProgress) callback.onProgress(event);
                                            }
                                            controller.enqueue(value);
                                            readData();
                                        }
                                    }, function(e) {
                                        controller.error(e);
                                    });
                                }
                            }
                        });
                        return new Response(stream);
                    } else throw new $a1724dcfba0d6d9a$var$HttpError('fetch for "'.concat(response.url, '" responded with ').concat(response.status, ": ").concat(response.statusText), response);
                }).then(function(response) {
                    switch(responseType){
                        case 'arraybuffer':
                            return response.arrayBuffer();
                        case 'blob':
                            return response.blob();
                        case 'document':
                            return response.text().then(function(text) {
                                var parser = new DOMParser();
                                return parser.parseFromString(text, mimeType);
                            });
                        case 'json':
                            return response.json();
                        default:
                            if (mimeType === '') return response.text();
                            else {
                                // sniff encoding
                                var re = /charset="?([^;"\s]*)"?/i;
                                var exec = re.exec(mimeType);
                                var label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                                var decoder = new TextDecoder(label);
                                return response.arrayBuffer().then(function(ab) {
                                    return decoder.decode(ab);
                                });
                            }
                    }
                }).then(function(data) {
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    $a1724dcfba0d6d9a$export$94affb487e701bf2.add("file:".concat(url), data);
                    var callbacks = $a1724dcfba0d6d9a$var$loading[url];
                    delete $a1724dcfba0d6d9a$var$loading[url];
                    for(var i = 0, il = callbacks.length; i < il; i++){
                        var callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(data);
                    }
                })["catch"](function(err) {
                    // Abort errors and other errors are handled the same
                    var callbacks = $a1724dcfba0d6d9a$var$loading[url];
                    if (callbacks === undefined) {
                        // When onLoad was called and url was deleted in `loading`
                        _this.manager.itemError(url);
                        throw err;
                    }
                    delete $a1724dcfba0d6d9a$var$loading[url];
                    for(var i = 0, il = callbacks.length; i < il; i++){
                        var callback = callbacks[i];
                        if (callback.onError) callback.onError(err);
                    }
                    _this.manager.itemError(url);
                })["finally"](function() {
                    _this.manager.itemEnd(url);
                });
                this.manager.itemStart(url);
            }
        },
        {
            /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ key: "setResponseType",
            value: function setResponseType(value) {
                this.responseType = value;
                return this;
            }
        },
        {
            /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ key: "setMimeType",
            value: function setMimeType(value) {
                this.mimeType = value;
                return this;
            }
        }
    ]);
    return FileLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$29711c7e14f61db = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(AnimationLoader, Loader);
    function AnimationLoader(manager) {
        (0, $jGAMp._)(this, AnimationLoader);
        return (0, $kzDuW._)(this, AnimationLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(AnimationLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ key: "parse",
            value: function parse(json) {
                var animations = [];
                for(var i = 0; i < json.length; i++){
                    var clip = $a1724dcfba0d6d9a$export$d942c706bf23829c.parse(json[i]);
                    animations.push(clip);
                }
                return animations;
            }
        }
    ]);
    return AnimationLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$bd73ce947a280350 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(CompressedTextureLoader, Loader);
    function CompressedTextureLoader(manager) {
        (0, $jGAMp._)(this, CompressedTextureLoader);
        return (0, $kzDuW._)(this, CompressedTextureLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(CompressedTextureLoader, [
        {
            /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var images = [];
                var texture = new $a1724dcfba0d6d9a$export$3466bac9141a5cc4();
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(url[i], function(buffer) {
                        var texDatas = scope.parse(buffer, true);
                        images[i] = {
                            width: texDatas.width,
                            height: texDatas.height,
                            format: texDatas.format,
                            mipmaps: texDatas.mipmaps
                        };
                        loaded += 1;
                        if (loaded === 6) {
                            if (texDatas.mipmapCount === 1) texture.minFilter = $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                            texture.image = images;
                            texture.format = texDatas.format;
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, onProgress, onError);
                }
                if (Array.isArray(url)) for(var i = 0, il = url.length; i < il; ++i)loadTexture(i);
                else // compressed cubemap texture stored in a single DDS file
                loader.load(url, function(buffer) {
                    var texDatas = scope.parse(buffer, true);
                    if (texDatas.isCubemap) {
                        var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                        for(var f = 0; f < faces; f++){
                            images[f] = {
                                mipmaps: []
                            };
                            for(var i = 0; i < texDatas.mipmapCount; i++){
                                images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                                images[f].format = texDatas.format;
                                images[f].width = texDatas.width;
                                images[f].height = texDatas.height;
                            }
                        }
                        texture.image = images;
                    } else {
                        texture.image.width = texDatas.width;
                        texture.image.height = texDatas.height;
                        texture.mipmaps = texDatas.mipmaps;
                    }
                    if (texDatas.mipmapCount === 1) texture.minFilter = $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return CompressedTextureLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
var $a1724dcfba0d6d9a$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639}.
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$8905ce1c7a2464a1 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(ImageLoader, Loader);
    function ImageLoader(manager) {
        (0, $jGAMp._)(this, ImageLoader);
        return (0, $kzDuW._)(this, ImageLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(ImageLoader, [
        {
            /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $a1724dcfba0d6d9a$export$94affb487e701bf2.get("image:".concat(url));
                if (cached !== undefined) {
                    if (cached.complete === true) {
                        scope.manager.itemStart(url);
                        setTimeout(function() {
                            if (onLoad) onLoad(cached);
                            scope.manager.itemEnd(url);
                        }, 0);
                    } else {
                        var arr = $a1724dcfba0d6d9a$var$_loading.get(cached);
                        if (arr === undefined) {
                            arr = [];
                            $a1724dcfba0d6d9a$var$_loading.set(cached, arr);
                        }
                        arr.push({
                            onLoad: onLoad,
                            onError: onError
                        });
                    }
                    return cached;
                }
                var image = $a1724dcfba0d6d9a$export$7094a064528c7fee('img');
                function onImageLoad() {
                    removeEventListeners();
                    if (onLoad) onLoad(this);
                    //
                    var callbacks = $a1724dcfba0d6d9a$var$_loading.get(this) || [];
                    for(var i = 0; i < callbacks.length; i++){
                        var callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(this);
                    }
                    $a1724dcfba0d6d9a$var$_loading["delete"](this);
                    scope.manager.itemEnd(url);
                }
                function onImageError(event) {
                    removeEventListeners();
                    if (onError) onError(event);
                    $a1724dcfba0d6d9a$export$94affb487e701bf2.remove("image:".concat(url));
                    //
                    var callbacks = $a1724dcfba0d6d9a$var$_loading.get(this) || [];
                    for(var i = 0; i < callbacks.length; i++){
                        var callback = callbacks[i];
                        if (callback.onError) callback.onError(event);
                    }
                    $a1724dcfba0d6d9a$var$_loading["delete"](this);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
                function removeEventListeners() {
                    image.removeEventListener('load', onImageLoad, false);
                    image.removeEventListener('error', onImageError, false);
                }
                image.addEventListener('load', onImageLoad, false);
                image.addEventListener('error', onImageError, false);
                if (url.slice(0, 5) !== 'data:') {
                    if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
                }
                $a1724dcfba0d6d9a$export$94affb487e701bf2.add("image:".concat(url), image);
                scope.manager.itemStart(url);
                image.src = url;
                return image;
            }
        }
    ]);
    return ImageLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$2ec114afc2cf6308 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(CubeTextureLoader, Loader);
    function CubeTextureLoader(manager) {
        (0, $jGAMp._)(this, CubeTextureLoader);
        return (0, $kzDuW._)(this, CubeTextureLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(CubeTextureLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ key: "load",
            value: function load(urls, onLoad, onProgress, onError) {
                var texture = new $a1724dcfba0d6d9a$export$ee2e5a18258a4049();
                texture.colorSpace = $a1724dcfba0d6d9a$export$561f394b24edfcaa;
                var loader = new $a1724dcfba0d6d9a$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(urls[i], function(image) {
                        texture.images[i] = image;
                        loaded++;
                        if (loaded === 6) {
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, undefined, onError);
                }
                for(var i = 0; i < urls.length; ++i)loadTexture(i);
                return texture;
            }
        }
    ]);
    return CubeTextureLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$792d8a18f2c55855 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(DataTextureLoader, Loader);
    function DataTextureLoader(manager) {
        (0, $jGAMp._)(this, DataTextureLoader);
        return (0, $kzDuW._)(this, DataTextureLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(DataTextureLoader, [
        {
            /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var texture = new $a1724dcfba0d6d9a$export$b691f601014eabe1();
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setPath(this.path);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(buffer) {
                    var texData;
                    try {
                        texData = scope.parse(buffer);
                    } catch (error) {
                        if (onError !== undefined) onError(error);
                        else {
                            console.error(error);
                            return;
                        }
                    }
                    if (texData.image !== undefined) texture.image = texData.image;
                    else if (texData.data !== undefined) {
                        texture.image.width = texData.width;
                        texture.image.height = texData.height;
                        texture.image.data = texData.data;
                    }
                    texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $a1724dcfba0d6d9a$export$9d9334239a5a5e06;
                    texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $a1724dcfba0d6d9a$export$9d9334239a5a5e06;
                    texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                    texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                    texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
                    if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
                    if (texData.flipY !== undefined) texture.flipY = texData.flipY;
                    if (texData.format !== undefined) texture.format = texData.format;
                    if (texData.type !== undefined) texture.type = texData.type;
                    if (texData.mipmaps !== undefined) {
                        texture.mipmaps = texData.mipmaps;
                        texture.minFilter = $a1724dcfba0d6d9a$export$5d8599b6a933fb1b; // presumably...
                    }
                    if (texData.mipmapCount === 1) texture.minFilter = $a1724dcfba0d6d9a$export$8a72f490b25c56c8;
                    if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture, texData);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return DataTextureLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145}.
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$fd1bfc71f64c538c = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(TextureLoader, Loader);
    function TextureLoader(manager) {
        (0, $jGAMp._)(this, TextureLoader);
        return (0, $kzDuW._)(this, TextureLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(TextureLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var texture = new $a1724dcfba0d6d9a$export$5431306cf43de24a();
                var loader = new $a1724dcfba0d6d9a$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                loader.load(url, function(image) {
                    texture.image = image;
                    texture.needsUpdate = true;
                    if (onLoad !== undefined) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return TextureLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$6ecadb6ed240d696 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Light, Object3D);
    function Light(color) {
        var intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $jGAMp._)(this, Light);
        var _this;
        _this = (0, $kzDuW._)(this, Light);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLight = true;
        _this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ _this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.intensity = intensity;
        return _this;
    }
    (0, $byiyg._)(Light, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
            // Empty here in base class; some subclasses override.
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Light.prototype), "copy", this).call(this, source, recursive);
                this.color.copy(source.color);
                this.intensity = source.intensity;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(Light.prototype), "toJSON", this).call(this, meta);
                data.object.color = this.color.getHex();
                data.object.intensity = this.intensity;
                if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
                if (this.distance !== undefined) data.object.distance = this.distance;
                if (this.angle !== undefined) data.object.angle = this.angle;
                if (this.decay !== undefined) data.object.decay = this.decay;
                if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
                if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
                if (this.target !== undefined) data.object.target = this.target.uuid;
                return data;
            }
        }
    ]);
    return Light;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$8d474f55edbb9624 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(HemisphereLight, Light);
    function HemisphereLight(skyColor, groundColor, intensity) {
        (0, $jGAMp._)(this, HemisphereLight);
        var _this;
        _this = (0, $kzDuW._)(this, HemisphereLight, [
            skyColor,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isHemisphereLight = true;
        _this.type = 'HemisphereLight';
        _this.position.copy($a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ _this.groundColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e(groundColor);
        return _this;
    }
    (0, $byiyg._)(HemisphereLight, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(HemisphereLight.prototype), "copy", this).call(this, source, recursive);
                this.groundColor.copy(source.groundColor);
                return this;
            }
        }
    ]);
    return HemisphereLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
var $a1724dcfba0d6d9a$var$_projScreenMatrix$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_lightPositionWorld$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_lookTarget$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ var $a1724dcfba0d6d9a$var$LightShadow = /*#__PURE__*/ function() {
    "use strict";
    function LightShadow(camera) {
        (0, $jGAMp._)(this, LightShadow);
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `PCFSoftShadowMap` and
		 * and it is recommended to increase softness by decreasing the shadow map size instead.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $a1724dcfba0d6d9a$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $a1724dcfba0d6d9a$export$35efe6f4c85463d2();
        this._frameExtents = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    (0, $byiyg._)(LightShadow, [
        {
            /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ key: "getViewportCount",
            value: function getViewportCount() {
                return this._viewportCount;
            }
        },
        {
            /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ key: "getFrustum",
            value: function getFrustum() {
                return this._frustum;
            }
        },
        {
            /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ key: "updateMatrices",
            value: function updateMatrices(light) {
                var shadowCamera = this.camera;
                var shadowMatrix = this.matrix;
                $a1724dcfba0d6d9a$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
                shadowCamera.position.copy($a1724dcfba0d6d9a$var$_lightPositionWorld$1);
                $a1724dcfba0d6d9a$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
                shadowCamera.lookAt($a1724dcfba0d6d9a$var$_lookTarget$1);
                shadowCamera.updateMatrixWorld();
                $a1724dcfba0d6d9a$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix$1);
                shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
                shadowMatrix.multiply($a1724dcfba0d6d9a$var$_projScreenMatrix$1);
            }
        },
        {
            /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ key: "getViewport",
            value: function getViewport(viewportIndex) {
                return this._viewports[viewportIndex];
            }
        },
        {
            /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ key: "getFrameExtents",
            value: function getFrameExtents() {
                return this._frameExtents;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                if (this.map) this.map.dispose();
                if (this.mapPass) this.mapPass.dispose();
            }
        },
        {
            /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ key: "copy",
            value: function copy(source) {
                this.camera = source.camera.clone();
                this.intensity = source.intensity;
                this.bias = source.bias;
                this.radius = source.radius;
                this.autoUpdate = source.autoUpdate;
                this.needsUpdate = source.needsUpdate;
                this.normalBias = source.normalBias;
                this.blurSamples = source.blurSamples;
                this.mapSize.copy(source.mapSize);
                return this;
            }
        },
        {
            /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ key: "toJSON",
            value: function toJSON() {
                var object = {};
                if (this.intensity !== 1) object.intensity = this.intensity;
                if (this.bias !== 0) object.bias = this.bias;
                if (this.normalBias !== 0) object.normalBias = this.normalBias;
                if (this.radius !== 1) object.radius = this.radius;
                if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
                object.camera = this.camera.toJSON(false).object;
                delete object.camera.matrix;
                return object;
            }
        }
    ]);
    return LightShadow;
}();
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ var $a1724dcfba0d6d9a$var$SpotLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $i3fW3._)(SpotLightShadow, LightShadow);
    function SpotLightShadow() {
        (0, $jGAMp._)(this, SpotLightShadow);
        var _this;
        _this = (0, $kzDuW._)(this, SpotLightShadow, [
            new $a1724dcfba0d6d9a$export$74e4ae24825f68d7(50, 1, 0.5, 500)
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.aspect = 1;
        return _this;
    }
    (0, $byiyg._)(SpotLightShadow, [
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var camera = this.camera;
                var fov = $a1724dcfba0d6d9a$export$914076c8150813e5 * 2 * light.angle * this.focus;
                var aspect = this.mapSize.width / this.mapSize.height * this.aspect;
                var far = light.distance || camera.far;
                if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
                    camera.fov = fov;
                    camera.aspect = aspect;
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                (0, $fXhL4._)((0, $hxFDX._)(SpotLightShadow.prototype), "updateMatrices", this).call(this, light);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(SpotLightShadow.prototype), "copy", this).call(this, source);
                this.focus = source.focus;
                return this;
            }
        }
    ]);
    return SpotLightShadow;
}($a1724dcfba0d6d9a$var$LightShadow);
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$81495cbb73897362 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(SpotLight, Light);
    function SpotLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, angle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI / 3, penumbra = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, decay = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2;
        (0, $jGAMp._)(this, SpotLight);
        var _this;
        _this = (0, $kzDuW._)(this, SpotLight, [
            color,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSpotLight = true;
        _this.type = 'SpotLight';
        _this.position.copy($a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ _this.target = new $a1724dcfba0d6d9a$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ _this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ _this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ _this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ _this.shadow = new $a1724dcfba0d6d9a$var$SpotLightShadow();
        return _this;
    }
    (0, $byiyg._)(SpotLight, [
        {
            key: "power",
            get: /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
                return this.intensity * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / Math.PI;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(SpotLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.angle = source.angle;
                this.penumbra = source.penumbra;
                this.decay = source.decay;
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return SpotLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
var $a1724dcfba0d6d9a$var$_projScreenMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_lightPositionWorld = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_lookTarget = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ var $a1724dcfba0d6d9a$var$PointLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $i3fW3._)(PointLightShadow, LightShadow);
    function PointLightShadow() {
        (0, $jGAMp._)(this, PointLightShadow);
        var _this;
        _this = (0, $kzDuW._)(this, PointLightShadow, [
            new $a1724dcfba0d6d9a$export$74e4ae24825f68d7(90, 1, 0.5, 500)
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isPointLightShadow = true;
        _this._frameExtents = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(4, 2);
        _this._viewportCount = 6;
        _this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        _this._cubeDirections = [
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(1, 0, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(-1, 0, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 1),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, -1),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, -1, 0)
        ];
        _this._cubeUps = [
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 1, 0),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 1),
            new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, -1)
        ];
        return _this;
    }
    (0, $byiyg._)(PointLightShadow, [
        {
            /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 * @param {number} [viewportIndex=0] - The viewport index.
	 */ key: "updateMatrices",
            value: function updateMatrices(light) {
                var viewportIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var camera = this.camera;
                var shadowMatrix = this.matrix;
                var far = light.distance || camera.far;
                if (far !== camera.far) {
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                $a1724dcfba0d6d9a$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                camera.position.copy($a1724dcfba0d6d9a$var$_lightPositionWorld);
                $a1724dcfba0d6d9a$var$_lookTarget.copy(camera.position);
                $a1724dcfba0d6d9a$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
                camera.up.copy(this._cubeUps[viewportIndex]);
                camera.lookAt($a1724dcfba0d6d9a$var$_lookTarget);
                camera.updateMatrixWorld();
                shadowMatrix.makeTranslation(-$a1724dcfba0d6d9a$var$_lightPositionWorld.x, -$a1724dcfba0d6d9a$var$_lightPositionWorld.y, -$a1724dcfba0d6d9a$var$_lightPositionWorld.z);
                $a1724dcfba0d6d9a$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($a1724dcfba0d6d9a$var$_projScreenMatrix);
            }
        }
    ]);
    return PointLightShadow;
}($a1724dcfba0d6d9a$var$LightShadow);
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$4c9c1cb3f0b6f455 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(PointLight, Light);
    function PointLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, decay = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
        (0, $jGAMp._)(this, PointLight);
        var _this;
        _this = (0, $kzDuW._)(this, PointLight, [
            color,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isPointLight = true;
        _this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ _this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ _this.shadow = new $a1724dcfba0d6d9a$var$PointLightShadow();
        return _this;
    }
    (0, $byiyg._)(PointLight, [
        {
            key: "power",
            get: /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
                return this.intensity * 4 * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / (4 * Math.PI);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(PointLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.decay = source.decay;
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return PointLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
/**
 * Camera that uses [orthographic projection]{@link https://en.wikipedia.org/wiki/Orthographic_projection}.
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ var $a1724dcfba0d6d9a$export$9ebf355ee4ed261b = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $i3fW3._)(OrthographicCamera, Camera);
    function OrthographicCamera() {
        var left = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, right = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, top = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, bottom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, near = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.1, far = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2000;
        (0, $jGAMp._)(this, OrthographicCamera);
        var _this;
        _this = (0, $kzDuW._)(this, OrthographicCamera);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isOrthographicCamera = true;
        _this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ _this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ _this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ _this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ _this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ _this.far = far;
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $byiyg._)(OrthographicCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(OrthographicCamera.prototype), "copy", this).call(this, source, recursive);
                this.left = source.left;
                this.right = source.right;
                this.top = source.top;
                this.bottom = source.bottom;
                this.near = source.near;
                this.far = source.far;
                this.zoom = source.zoom;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                return this;
            }
        },
        {
            /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Removes the view offset from the projection matrix.
	 */ key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var dx = (this.right - this.left) / (2 * this.zoom);
                var dy = (this.top - this.bottom) / (2 * this.zoom);
                var cx = (this.right + this.left) / 2;
                var cy = (this.top + this.bottom) / 2;
                var left = cx - dx;
                var right = cx + dx;
                var top = cy + dy;
                var bottom = cy - dy;
                if (this.view !== null && this.view.enabled) {
                    var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
                    var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    left += scaleW * this.view.offsetX;
                    right = left + scaleW * this.view.width;
                    top -= scaleH * this.view.offsetY;
                    bottom = top - scaleH * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(OrthographicCamera.prototype), "toJSON", this).call(this, meta);
                data.object.zoom = this.zoom;
                data.object.left = this.left;
                data.object.right = this.right;
                data.object.top = this.top;
                data.object.bottom = this.bottom;
                data.object.near = this.near;
                data.object.far = this.far;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                return data;
            }
        }
    ]);
    return OrthographicCamera;
}($a1724dcfba0d6d9a$export$79f141de891a5fed);
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ var $a1724dcfba0d6d9a$var$DirectionalLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $i3fW3._)(DirectionalLightShadow, LightShadow);
    function DirectionalLightShadow() {
        (0, $jGAMp._)(this, DirectionalLightShadow);
        var _this;
        _this = (0, $kzDuW._)(this, DirectionalLightShadow, [
            new $a1724dcfba0d6d9a$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500)
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isDirectionalLightShadow = true;
        return _this;
    }
    return DirectionalLightShadow;
}($a1724dcfba0d6d9a$var$LightShadow);
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$3fea33cc9972c868 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(DirectionalLight, Light);
    function DirectionalLight(color, intensity) {
        (0, $jGAMp._)(this, DirectionalLight);
        var _this;
        _this = (0, $kzDuW._)(this, DirectionalLight, [
            color,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isDirectionalLight = true;
        _this.type = 'DirectionalLight';
        _this.position.copy($a1724dcfba0d6d9a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ _this.target = new $a1724dcfba0d6d9a$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ _this.shadow = new $a1724dcfba0d6d9a$var$DirectionalLightShadow();
        return _this;
    }
    (0, $byiyg._)(DirectionalLight, [
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(DirectionalLight.prototype), "copy", this).call(this, source);
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return DirectionalLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$af279bfef9ec2c96 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(AmbientLight, Light);
    function AmbientLight(color, intensity) {
        (0, $jGAMp._)(this, AmbientLight);
        var _this;
        _this = (0, $kzDuW._)(this, AmbientLight, [
            color,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isAmbientLight = true;
        _this.type = 'AmbientLight';
        return _this;
    }
    return AmbientLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$61db2d908bbd2429 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(RectAreaLight, Light);
    function RectAreaLight(color, intensity) {
        var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 10;
        (0, $jGAMp._)(this, RectAreaLight);
        var _this;
        _this = (0, $kzDuW._)(this, RectAreaLight, [
            color,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isRectAreaLight = true;
        _this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ _this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ _this.height = height;
        return _this;
    }
    (0, $byiyg._)(RectAreaLight, [
        {
            key: "power",
            get: /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ function get() {
                // compute the light's luminous power (in lumens) from its intensity (in nits)
                return this.intensity * this.width * this.height * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in nits) from the desired luminous power (in lumens)
                this.intensity = power / (this.width * this.height * Math.PI);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(RectAreaLight.prototype), "copy", this).call(this, source);
                this.width = source.width;
                this.height = source.height;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(RectAreaLight.prototype), "toJSON", this).call(this, meta);
                data.object.width = this.width;
                data.object.height = this.height;
                return data;
            }
        }
    ]);
    return RectAreaLight;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ var $a1724dcfba0d6d9a$export$ba61ce607e1f405a = /*#__PURE__*/ function() {
    "use strict";
    function SphericalHarmonics3() {
        (0, $jGAMp._)(this, SphericalHarmonics3);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(var i = 0; i < 9; i++)this.coefficients.push(new $a1724dcfba0d6d9a$export$64b5c384219d3699());
    }
    (0, $byiyg._)(SphericalHarmonics3, [
        {
            /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "set",
            value: function set(coefficients) {
                for(var i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
                return this;
            }
        },
        {
            /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "zero",
            value: function zero() {
                for(var i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
                return this;
            }
        },
        {
            /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ key: "getAt",
            value: function getAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.282095);
                // band 1
                target.addScaledVector(coeff[1], 0.488603 * y);
                target.addScaledVector(coeff[2], 0.488603 * z);
                target.addScaledVector(coeff[3], 0.488603 * x);
                // band 2
                target.addScaledVector(coeff[4], 1.092548 * (x * y));
                target.addScaledVector(coeff[5], 1.092548 * (y * z));
                target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
                target.addScaledVector(coeff[7], 1.092548 * (x * z));
                target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
                return target;
            }
        },
        {
            /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ key: "getIrradianceAt",
            value: function getIrradianceAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
                // band 1
                target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
                target.addScaledVector(coeff[2], 1.023328 * z);
                target.addScaledVector(coeff[3], 1.023328 * x);
                // band 2
                target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
                target.addScaledVector(coeff[5], 0.858086 * y * z);
                target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
                target.addScaledVector(coeff[7], 0.858086 * x * z);
                target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
                return target;
            }
        },
        {
            /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "add",
            value: function add(sh) {
                for(var i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
                return this;
            }
        },
        {
            /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "addScaledSH",
            value: function addScaledSH(sh, s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
                return this;
            }
        },
        {
            /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "scale",
            value: function scale(s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
                return this;
            }
        },
        {
            /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "lerp",
            value: function lerp(sh, alpha) {
                for(var i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ key: "equals",
            value: function equals(sh) {
                for(var i = 0; i < 9; i++){
                    if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
                }
                return true;
            }
        },
        {
            /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ key: "copy",
            value: function copy(sh) {
                return this.set(sh.coefficients);
            }
        },
        {
            /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
                return this;
            }
        },
        {
            /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
                return array;
            }
        }
    ], [
        {
            key: "getBasisAt",
            value: /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ function getBasisAt(normal, shBasis) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                // band 0
                shBasis[0] = 0.282095;
                // band 1
                shBasis[1] = 0.488603 * y;
                shBasis[2] = 0.488603 * z;
                shBasis[3] = 0.488603 * x;
                // band 2
                shBasis[4] = 1.092548 * x * y;
                shBasis[5] = 1.092548 * y * z;
                shBasis[6] = 0.315392 * (3 * z * z - 1);
                shBasis[7] = 1.092548 * x * z;
                shBasis[8] = 0.546274 * (x * x - y * y);
            }
        }
    ]);
    return SphericalHarmonics3;
}();
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ var $a1724dcfba0d6d9a$export$e7ef036e309b38d2 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $i3fW3._)(LightProbe, Light);
    function LightProbe() {
        var sh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$ba61ce607e1f405a(), intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $jGAMp._)(this, LightProbe);
        var _this;
        _this = (0, $kzDuW._)(this, LightProbe, [
            undefined,
            intensity
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ _this.sh = sh;
        return _this;
    }
    (0, $byiyg._)(LightProbe, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(LightProbe.prototype), "copy", this).call(this, source);
                this.sh.copy(source.sh);
                return this;
            }
        },
        {
            /**
	 * Deserializes the light prove from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized light probe.
	 * @return {LightProbe} A reference to this light probe.
	 */ key: "fromJSON",
            value: function fromJSON(json) {
                this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
                this.sh.fromArray(json.sh);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $fXhL4._)((0, $hxFDX._)(LightProbe.prototype), "toJSON", this).call(this, meta);
                data.object.sh = this.sh.toArray();
                return data;
            }
        }
    ]);
    return LightProbe;
}($a1724dcfba0d6d9a$export$6ecadb6ed240d696);
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$3bd6d323353dcf96 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(MaterialLoader, Loader);
    function MaterialLoader(manager) {
        (0, $jGAMp._)(this, MaterialLoader);
        var _this;
        _this = (0, $kzDuW._)(this, MaterialLoader, [
            manager
        ]);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ _this.textures = {};
        return _this;
    }
    (0, $byiyg._)(MaterialLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ key: "parse",
            value: function parse(json) {
                var textures = this.textures;
                function getTexture(name) {
                    if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
                    return textures[name];
                }
                var material = this.createMaterialFromType(json.type);
                if (json.uuid !== undefined) material.uuid = json.uuid;
                if (json.name !== undefined) material.name = json.name;
                if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
                if (json.roughness !== undefined) material.roughness = json.roughness;
                if (json.metalness !== undefined) material.metalness = json.metalness;
                if (json.sheen !== undefined) material.sheen = json.sheen;
                if (json.sheenColor !== undefined) material.sheenColor = new $a1724dcfba0d6d9a$export$892596cec99bc70e().setHex(json.sheenColor);
                if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
                if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
                if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
                if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
                if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
                if (json.shininess !== undefined) material.shininess = json.shininess;
                if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
                if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
                if (json.dispersion !== undefined) material.dispersion = json.dispersion;
                if (json.iridescence !== undefined) material.iridescence = json.iridescence;
                if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
                if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
                if (json.transmission !== undefined) material.transmission = json.transmission;
                if (json.thickness !== undefined) material.thickness = json.thickness;
                if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
                if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
                if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
                if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
                if (json.fog !== undefined) material.fog = json.fog;
                if (json.flatShading !== undefined) material.flatShading = json.flatShading;
                if (json.blending !== undefined) material.blending = json.blending;
                if (json.combine !== undefined) material.combine = json.combine;
                if (json.side !== undefined) material.side = json.side;
                if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
                if (json.opacity !== undefined) material.opacity = json.opacity;
                if (json.transparent !== undefined) material.transparent = json.transparent;
                if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
                if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
                if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
                if (json.depthTest !== undefined) material.depthTest = json.depthTest;
                if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
                if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
                if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
                if (json.blendDst !== undefined) material.blendDst = json.blendDst;
                if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
                if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
                if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
                if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
                if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
                if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
                if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
                if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
                if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
                if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
                if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
                if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
                if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
                if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
                if (json.wireframe !== undefined) material.wireframe = json.wireframe;
                if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
                if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
                if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
                if (json.rotation !== undefined) material.rotation = json.rotation;
                if (json.linewidth !== undefined) material.linewidth = json.linewidth;
                if (json.dashSize !== undefined) material.dashSize = json.dashSize;
                if (json.gapSize !== undefined) material.gapSize = json.gapSize;
                if (json.scale !== undefined) material.scale = json.scale;
                if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
                if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
                if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
                if (json.dithering !== undefined) material.dithering = json.dithering;
                if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
                if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
                if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
                if (json.visible !== undefined) material.visible = json.visible;
                if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
                if (json.userData !== undefined) material.userData = json.userData;
                if (json.vertexColors !== undefined) {
                    if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
                    else material.vertexColors = json.vertexColors;
                }
                // Shader Material
                if (json.uniforms !== undefined) for(var name in json.uniforms){
                    var uniform = json.uniforms[name];
                    material.uniforms[name] = {};
                    switch(uniform.type){
                        case 't':
                            material.uniforms[name].value = getTexture(uniform.value);
                            break;
                        case 'c':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$892596cec99bc70e().setHex(uniform.value);
                            break;
                        case 'v2':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1().fromArray(uniform.value);
                            break;
                        case 'v3':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$64b5c384219d3699().fromArray(uniform.value);
                            break;
                        case 'v4':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$fa7daccca11cdbe3().fromArray(uniform.value);
                            break;
                        case 'm3':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$8ff26dafa08918().fromArray(uniform.value);
                            break;
                        case 'm4':
                            material.uniforms[name].value = new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5().fromArray(uniform.value);
                            break;
                        default:
                            material.uniforms[name].value = uniform.value;
                    }
                }
                if (json.defines !== undefined) material.defines = json.defines;
                if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
                if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
                if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
                if (json.extensions !== undefined) for(var key in json.extensions)material.extensions[key] = json.extensions[key];
                if (json.lights !== undefined) material.lights = json.lights;
                if (json.clipping !== undefined) material.clipping = json.clipping;
                // for PointsMaterial
                if (json.size !== undefined) material.size = json.size;
                if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
                // maps
                if (json.map !== undefined) material.map = getTexture(json.map);
                if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
                if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
                if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
                if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
                if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
                if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
                if (json.normalScale !== undefined) {
                    var normalScale = json.normalScale;
                    if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
                    normalScale = [
                        normalScale,
                        normalScale
                    ];
                    material.normalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1().fromArray(normalScale);
                }
                if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
                if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
                if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
                if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
                if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
                if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
                if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
                if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
                if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
                if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
                if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
                if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
                if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
                if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
                if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
                if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
                if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
                if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
                if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
                if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
                if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
                if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
                if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
                if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $a1724dcfba0d6d9a$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
                if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
                if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
                if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
                if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
                if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
                if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
                if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
                return material;
            }
        },
        {
            /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ key: "setTextures",
            value: function setTextures(value) {
                this.textures = value;
                return this;
            }
        },
        {
            /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ key: "createMaterialFromType",
            value: function createMaterialFromType(type) {
                return MaterialLoader.createMaterialFromType(type);
            }
        }
    ], [
        {
            key: "createMaterialFromType",
            value: /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ function createMaterialFromType(type) {
                var materialLib = {
                    ShadowMaterial: $a1724dcfba0d6d9a$export$e8564da406055a3,
                    SpriteMaterial: $a1724dcfba0d6d9a$export$5ec7dd1c6994bf8e,
                    RawShaderMaterial: $a1724dcfba0d6d9a$export$21c421a2e1df9d22,
                    ShaderMaterial: $a1724dcfba0d6d9a$export$83c7d75d550a8b0d,
                    PointsMaterial: $a1724dcfba0d6d9a$export$a178c45366ce5d6b,
                    MeshPhysicalMaterial: $a1724dcfba0d6d9a$export$28d04986c4269c9f,
                    MeshStandardMaterial: $a1724dcfba0d6d9a$export$f2980790215acccd,
                    MeshPhongMaterial: $a1724dcfba0d6d9a$export$24c72f71cbaf0678,
                    MeshToonMaterial: $a1724dcfba0d6d9a$export$df893cf97e765622,
                    MeshNormalMaterial: $a1724dcfba0d6d9a$export$bfe8c0a091f41ae7,
                    MeshLambertMaterial: $a1724dcfba0d6d9a$export$5023a9a8114806b8,
                    MeshDepthMaterial: $a1724dcfba0d6d9a$export$2698c22ec13825db,
                    MeshDistanceMaterial: $a1724dcfba0d6d9a$export$33e187ed002f2a19,
                    MeshBasicMaterial: $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5,
                    MeshMatcapMaterial: $a1724dcfba0d6d9a$export$6f5fef6235ec12ee,
                    LineDashedMaterial: $a1724dcfba0d6d9a$export$327886a3efaeaebe,
                    LineBasicMaterial: $a1724dcfba0d6d9a$export$fbaaa33907730a0c,
                    Material: $a1724dcfba0d6d9a$export$a2d8b23205c25948
                };
                return new materialLib[type]();
            }
        }
    ]);
    return MaterialLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * A class with loader utility functions.
 */ var $a1724dcfba0d6d9a$export$b5d2dc08d867e41a = /*#__PURE__*/ function() {
    "use strict";
    function LoaderUtils() {
        (0, $jGAMp._)(this, LoaderUtils);
    }
    (0, $byiyg._)(LoaderUtils, null, [
        {
            key: "extractUrlBase",
            value: /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ function extractUrlBase(url) {
                var index = url.lastIndexOf('/');
                if (index === -1) return './';
                return url.slice(0, index + 1);
            }
        },
        {
            key: "resolveURL",
            value: /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ function resolveURL(url, path) {
                // Invalid URL
                if (typeof url !== 'string' || url === '') return '';
                // Host Relative URL
                if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
                // Absolute URL http://,https://,//
                if (/^(https?:)?\/\//i.test(url)) return url;
                // Data URI
                if (/^data:.*,.*$/i.test(url)) return url;
                // Blob URL
                if (/^blob:.*$/i.test(url)) return url;
                // Relative URL
                return path + url;
            }
        }
    ]);
    return LoaderUtils;
}();
/**
 * An instanced version of a geometry.
 */ var $a1724dcfba0d6d9a$export$231f009cbe414146 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $i3fW3._)(InstancedBufferGeometry, BufferGeometry);
    function InstancedBufferGeometry() {
        (0, $jGAMp._)(this, InstancedBufferGeometry);
        var _this;
        _this = (0, $kzDuW._)(this, InstancedBufferGeometry);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isInstancedBufferGeometry = true;
        _this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ _this.instanceCount = Infinity;
        return _this;
    }
    (0, $byiyg._)(InstancedBufferGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(InstancedBufferGeometry.prototype), "copy", this).call(this, source);
                this.instanceCount = source.instanceCount;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $fXhL4._)((0, $hxFDX._)(InstancedBufferGeometry.prototype), "toJSON", this).call(this);
                data.instanceCount = this.instanceCount;
                data.isInstancedBufferGeometry = true;
                return data;
            }
        }
    ]);
    return InstancedBufferGeometry;
}($a1724dcfba0d6d9a$export$b7be63a67df8959);
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$dc275bb96327833a = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(BufferGeometryLoader, Loader);
    function BufferGeometryLoader(manager) {
        (0, $jGAMp._)(this, BufferGeometryLoader);
        return (0, $kzDuW._)(this, BufferGeometryLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(BufferGeometryLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ key: "parse",
            value: function parse(json) {
                var interleavedBufferMap = {};
                var arrayBufferMap = {};
                function getInterleavedBuffer(json, uuid) {
                    if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
                    var interleavedBuffers = json.interleavedBuffers;
                    var interleavedBuffer = interleavedBuffers[uuid];
                    var buffer = getArrayBuffer(json, interleavedBuffer.buffer);
                    var array = $a1724dcfba0d6d9a$var$getTypedArray(interleavedBuffer.type, buffer);
                    var ib = new $a1724dcfba0d6d9a$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
                    ib.uuid = interleavedBuffer.uuid;
                    interleavedBufferMap[uuid] = ib;
                    return ib;
                }
                function getArrayBuffer(json, uuid) {
                    if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
                    var arrayBuffers = json.arrayBuffers;
                    var arrayBuffer = arrayBuffers[uuid];
                    var ab = new Uint32Array(arrayBuffer).buffer;
                    arrayBufferMap[uuid] = ab;
                    return ab;
                }
                var geometry = json.isInstancedBufferGeometry ? new $a1724dcfba0d6d9a$export$231f009cbe414146() : new $a1724dcfba0d6d9a$export$b7be63a67df8959();
                var index = json.data.index;
                if (index !== undefined) {
                    var typedArray = $a1724dcfba0d6d9a$var$getTypedArray(index.type, index.array);
                    geometry.setIndex(new $a1724dcfba0d6d9a$export$8dea267bd6bde117(typedArray, 1));
                }
                var attributes = json.data.attributes;
                for(var key in attributes){
                    var attribute = attributes[key];
                    var bufferAttribute = void 0;
                    if (attribute.isInterleavedBufferAttribute) {
                        var interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                        bufferAttribute = new $a1724dcfba0d6d9a$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                    } else {
                        var typedArray1 = $a1724dcfba0d6d9a$var$getTypedArray(attribute.type, attribute.array);
                        var bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $a1724dcfba0d6d9a$export$32ea87a8b54d744a : $a1724dcfba0d6d9a$export$8dea267bd6bde117;
                        bufferAttribute = new bufferAttributeConstr(typedArray1, attribute.itemSize, attribute.normalized);
                    }
                    if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                    if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
                    geometry.setAttribute(key, bufferAttribute);
                }
                var morphAttributes = json.data.morphAttributes;
                if (morphAttributes) for(var key1 in morphAttributes){
                    var attributeArray = morphAttributes[key1];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        var bufferAttribute1 = void 0;
                        if (attribute1.isInterleavedBufferAttribute) {
                            var interleavedBuffer1 = getInterleavedBuffer(json.data, attribute1.data);
                            bufferAttribute1 = new $a1724dcfba0d6d9a$export$920b6d07334599c7(interleavedBuffer1, attribute1.itemSize, attribute1.offset, attribute1.normalized);
                        } else {
                            var typedArray2 = $a1724dcfba0d6d9a$var$getTypedArray(attribute1.type, attribute1.array);
                            bufferAttribute1 = new $a1724dcfba0d6d9a$export$8dea267bd6bde117(typedArray2, attribute1.itemSize, attribute1.normalized);
                        }
                        if (attribute1.name !== undefined) bufferAttribute1.name = attribute1.name;
                        array.push(bufferAttribute1);
                    }
                    geometry.morphAttributes[key1] = array;
                }
                var morphTargetsRelative = json.data.morphTargetsRelative;
                if (morphTargetsRelative) geometry.morphTargetsRelative = true;
                var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
                if (groups !== undefined) for(var i1 = 0, n = groups.length; i1 !== n; ++i1){
                    var group = groups[i1];
                    geometry.addGroup(group.start, group.count, group.materialIndex);
                }
                var boundingSphere = json.data.boundingSphere;
                if (boundingSphere !== undefined) geometry.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba().fromJSON(boundingSphere);
                if (json.name) geometry.name = json.name;
                if (json.userData) geometry.userData = json.userData;
                return geometry;
            }
        }
    ]);
    return BufferGeometryLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format]{@link https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4}.
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$40110c8505c5ad19 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(ObjectLoader, Loader);
    function ObjectLoader(manager) {
        (0, $jGAMp._)(this, ObjectLoader);
        return (0, $kzDuW._)(this, ObjectLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(ObjectLoader, [
        {
            /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? $a1724dcfba0d6d9a$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
                this.resourcePath = this.resourcePath || path;
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    var json = null;
                    try {
                        json = JSON.parse(text);
                    } catch (error) {
                        if (onError !== undefined) onError(error);
                        console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                        return;
                    }
                    var metadata = json.metadata;
                    if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                        if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                        console.error('THREE.ObjectLoader: Can\'t load ' + url);
                        return;
                    }
                    scope.parse(json, onLoad);
                }, onProgress, onError);
            }
        },
        {
            key: "loadAsync",
            value: /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ function loadAsync(url, onProgress) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var scope, path, loader, text, json, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = this;
                                path = this.path === '' ? $a1724dcfba0d6d9a$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
                                this.resourcePath = this.resourcePath || path;
                                loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                                loader.setPath(this.path);
                                loader.setRequestHeader(this.requestHeader);
                                loader.setWithCredentials(this.withCredentials);
                                return [
                                    4,
                                    loader.loadAsync(url, onProgress)
                                ];
                            case 1:
                                text = _state.sent();
                                json = JSON.parse(text);
                                metadata = json.metadata;
                                if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
                                return [
                                    4,
                                    scope.parseAsync(json)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ key: "parse",
            value: function parse(json, onLoad) {
                var animations = this.parseAnimations(json.animations);
                var shapes = this.parseShapes(json.shapes);
                var geometries = this.parseGeometries(json.geometries, shapes);
                var images = this.parseImages(json.images, function() {
                    if (onLoad !== undefined) onLoad(object);
                });
                var textures = this.parseTextures(json.textures, images);
                var materials = this.parseMaterials(json.materials, textures);
                var object = this.parseObject(json.object, geometries, materials, textures, animations);
                var skeletons = this.parseSkeletons(json.skeletons, object);
                this.bindSkeletons(object, skeletons);
                this.bindLightTargets(object);
                //
                if (onLoad !== undefined) {
                    var hasImages = false;
                    for(var uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                        hasImages = true;
                        break;
                    }
                    if (hasImages === false) onLoad(object);
                }
                return object;
            }
        },
        {
            key: "parseAsync",
            value: /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ function parseAsync(json) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var animations, shapes, geometries, images, textures, materials, object, skeletons;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                animations = this.parseAnimations(json.animations);
                                shapes = this.parseShapes(json.shapes);
                                geometries = this.parseGeometries(json.geometries, shapes);
                                return [
                                    4,
                                    this.parseImagesAsync(json.images)
                                ];
                            case 1:
                                images = _state.sent();
                                textures = this.parseTextures(json.textures, images);
                                materials = this.parseMaterials(json.materials, textures);
                                object = this.parseObject(json.object, geometries, materials, textures, animations);
                                skeletons = this.parseSkeletons(json.skeletons, object);
                                this.bindSkeletons(object, skeletons);
                                this.bindLightTargets(object);
                                return [
                                    2,
                                    object
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // internals
            key: "parseShapes",
            value: function parseShapes(json) {
                var shapes = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var shape = new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa().fromJSON(json[i]);
                    shapes[shape.uuid] = shape;
                }
                return shapes;
            }
        },
        {
            key: "parseSkeletons",
            value: function parseSkeletons(json, object) {
                var skeletons = {};
                var bones = {};
                // generate bone lookup table
                object.traverse(function(child) {
                    if (child.isBone) bones[child.uuid] = child;
                });
                // create skeletons
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var skeleton = new $a1724dcfba0d6d9a$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
                    skeletons[skeleton.uuid] = skeleton;
                }
                return skeletons;
            }
        },
        {
            key: "parseGeometries",
            value: function parseGeometries(json, shapes) {
                var geometries = {};
                if (json !== undefined) {
                    var bufferGeometryLoader = new $a1724dcfba0d6d9a$export$dc275bb96327833a();
                    for(var i = 0, l = json.length; i < l; i++){
                        var geometry = void 0;
                        var data = json[i];
                        switch(data.type){
                            case 'BufferGeometry':
                            case 'InstancedBufferGeometry':
                                geometry = bufferGeometryLoader.parse(data);
                                break;
                            default:
                                if (data.type in $a1724dcfba0d6d9a$var$Geometries) geometry = $a1724dcfba0d6d9a$var$Geometries[data.type].fromJSON(data, shapes);
                                else console.warn('THREE.ObjectLoader: Unsupported geometry type "'.concat(data.type, '"'));
                        }
                        geometry.uuid = data.uuid;
                        if (data.name !== undefined) geometry.name = data.name;
                        if (data.userData !== undefined) geometry.userData = data.userData;
                        geometries[data.uuid] = geometry;
                    }
                }
                return geometries;
            }
        },
        {
            key: "parseMaterials",
            value: function parseMaterials(json, textures) {
                var cache = {}; // MultiMaterial
                var materials = {};
                if (json !== undefined) {
                    var loader = new $a1724dcfba0d6d9a$export$3bd6d323353dcf96();
                    loader.setTextures(textures);
                    for(var i = 0, l = json.length; i < l; i++){
                        var data = json[i];
                        if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                        materials[data.uuid] = cache[data.uuid];
                    }
                }
                return materials;
            }
        },
        {
            key: "parseAnimations",
            value: function parseAnimations(json) {
                var animations = {};
                if (json !== undefined) for(var i = 0; i < json.length; i++){
                    var data = json[i];
                    var clip = $a1724dcfba0d6d9a$export$d942c706bf23829c.parse(data);
                    animations[clip.uuid] = clip;
                }
                return animations;
            }
        },
        {
            key: "parseImages",
            value: function parseImages(json, onLoad) {
                var scope = this;
                var images = {};
                var loader;
                function loadImage(url) {
                    scope.manager.itemStart(url);
                    return loader.load(url, function() {
                        scope.manager.itemEnd(url);
                    }, undefined, function() {
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    });
                }
                function deserializeImage(image) {
                    if (typeof image === 'string') {
                        var url = image;
                        var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                        return loadImage(path);
                    } else {
                        if (image.data) return {
                            data: $a1724dcfba0d6d9a$var$getTypedArray(image.type, image.data),
                            width: image.width,
                            height: image.height
                        };
                        else return null;
                    }
                }
                if (json !== undefined && json.length > 0) {
                    var manager = new $a1724dcfba0d6d9a$export$99cc795e99919eed(onLoad);
                    loader = new $a1724dcfba0d6d9a$export$8905ce1c7a2464a1(manager);
                    loader.setCrossOrigin(this.crossOrigin);
                    for(var i = 0, il = json.length; i < il; i++){
                        var image = json[i];
                        var url = image.url;
                        if (Array.isArray(url)) {
                            // load array of images e.g CubeTexture
                            var imageArray = [];
                            for(var j = 0, jl = url.length; j < jl; j++){
                                var currentUrl = url[j];
                                var deserializedImage = deserializeImage(currentUrl);
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    imageArray.push(new $a1724dcfba0d6d9a$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                            }
                            images[image.uuid] = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(imageArray);
                        } else {
                            // load single image
                            var deserializedImage1 = deserializeImage(image.url);
                            images[image.uuid] = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(deserializedImage1);
                        }
                    }
                }
                return images;
            }
        },
        {
            key: "parseImagesAsync",
            value: function parseImagesAsync(json) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var scope, images, loader, i, il, image, url, imageArray, j, jl, currentUrl, deserializedImage, deserializedImage1;
                    function deserializeImage(image) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var url, path;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(typeof image === 'string')) return [
                                            3,
                                            2
                                        ];
                                        url = image;
                                        path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                                        return [
                                            4,
                                            loader.loadAsync(path)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        if (image.data) return [
                                            2,
                                            {
                                                data: $a1724dcfba0d6d9a$var$getTypedArray(image.type, image.data),
                                                width: image.width,
                                                height: image.height
                                            }
                                        ];
                                        else return [
                                            2,
                                            null
                                        ];
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = this;
                                images = {};
                                if (!(json !== undefined && json.length > 0)) return [
                                    3,
                                    9
                                ];
                                loader = new $a1724dcfba0d6d9a$export$8905ce1c7a2464a1(this.manager);
                                loader.setCrossOrigin(this.crossOrigin);
                                i = 0, il = json.length;
                                _state.label = 1;
                            case 1:
                                if (!(i < il)) return [
                                    3,
                                    9
                                ];
                                image = json[i];
                                url = image.url;
                                if (!Array.isArray(url)) return [
                                    3,
                                    6
                                ];
                                // load array of images e.g CubeTexture
                                imageArray = [];
                                j = 0, jl = url.length;
                                _state.label = 2;
                            case 2:
                                if (!(j < jl)) return [
                                    3,
                                    5
                                ];
                                currentUrl = url[j];
                                return [
                                    4,
                                    deserializeImage(currentUrl)
                                ];
                            case 3:
                                deserializedImage = _state.sent();
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    imageArray.push(new $a1724dcfba0d6d9a$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                                _state.label = 4;
                            case 4:
                                j++;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                images[image.uuid] = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(imageArray);
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                return [
                                    4,
                                    deserializeImage(image.url)
                                ];
                            case 7:
                                deserializedImage1 = _state.sent();
                                images[image.uuid] = new $a1724dcfba0d6d9a$export$1d2df86270c81ecb(deserializedImage1);
                                _state.label = 8;
                            case 8:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 9:
                                return [
                                    2,
                                    images
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parseTextures",
            value: function parseTextures(json, images) {
                function parseConstant(value, type) {
                    if (typeof value === 'number') return value;
                    console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
                    return type[value];
                }
                var textures = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var data = json[i];
                    if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
                    if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
                    var source = images[data.image];
                    var image = source.data;
                    var texture = void 0;
                    if (Array.isArray(image)) {
                        texture = new $a1724dcfba0d6d9a$export$ee2e5a18258a4049();
                        if (image.length === 6) texture.needsUpdate = true;
                    } else {
                        if (image && image.data) texture = new $a1724dcfba0d6d9a$export$b691f601014eabe1();
                        else texture = new $a1724dcfba0d6d9a$export$5431306cf43de24a();
                        if (image) texture.needsUpdate = true; // textures can have undefined image data
                    }
                    texture.source = source;
                    texture.uuid = data.uuid;
                    if (data.name !== undefined) texture.name = data.name;
                    if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $a1724dcfba0d6d9a$var$TEXTURE_MAPPING);
                    if (data.channel !== undefined) texture.channel = data.channel;
                    if (data.offset !== undefined) texture.offset.fromArray(data.offset);
                    if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
                    if (data.center !== undefined) texture.center.fromArray(data.center);
                    if (data.rotation !== undefined) texture.rotation = data.rotation;
                    if (data.wrap !== undefined) {
                        texture.wrapS = parseConstant(data.wrap[0], $a1724dcfba0d6d9a$var$TEXTURE_WRAPPING);
                        texture.wrapT = parseConstant(data.wrap[1], $a1724dcfba0d6d9a$var$TEXTURE_WRAPPING);
                    }
                    if (data.format !== undefined) texture.format = data.format;
                    if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
                    if (data.type !== undefined) texture.type = data.type;
                    if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
                    if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $a1724dcfba0d6d9a$var$TEXTURE_FILTER);
                    if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $a1724dcfba0d6d9a$var$TEXTURE_FILTER);
                    if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
                    if (data.flipY !== undefined) texture.flipY = data.flipY;
                    if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
                    if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
                    if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
                    if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
                    if (data.userData !== undefined) texture.userData = data.userData;
                    textures[data.uuid] = texture;
                }
                return textures;
            }
        },
        {
            key: "parseObject",
            value: function parseObject(data, geometries, materials, textures, animations) {
                var object;
                function getGeometry(name) {
                    if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
                    return geometries[name];
                }
                function getMaterial(name) {
                    if (name === undefined) return undefined;
                    if (Array.isArray(name)) {
                        var array = [];
                        for(var i = 0, l = name.length; i < l; i++){
                            var uuid = name[i];
                            if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                            array.push(materials[uuid]);
                        }
                        return array;
                    }
                    if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
                    return materials[name];
                }
                function getTexture(uuid) {
                    if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
                    return textures[uuid];
                }
                var geometry, material;
                switch(data.type){
                    case 'Scene':
                        object = new $a1724dcfba0d6d9a$export$38af1803e3442a7f();
                        if (data.background !== undefined) {
                            if (Number.isInteger(data.background)) object.background = new $a1724dcfba0d6d9a$export$892596cec99bc70e(data.background);
                            else object.background = getTexture(data.background);
                        }
                        if (data.environment !== undefined) object.environment = getTexture(data.environment);
                        if (data.fog !== undefined) {
                            if (data.fog.type === 'Fog') object.fog = new $a1724dcfba0d6d9a$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                            else if (data.fog.type === 'FogExp2') object.fog = new $a1724dcfba0d6d9a$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                            if (data.fog.name !== '') object.fog.name = data.fog.name;
                        }
                        if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                        if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                        if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                        if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                        if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                        break;
                    case 'PerspectiveCamera':
                        object = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                        if (data.focus !== undefined) object.focus = data.focus;
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                        if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'OrthographicCamera':
                        object = new $a1724dcfba0d6d9a$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'AmbientLight':
                        object = new $a1724dcfba0d6d9a$export$af279bfef9ec2c96(data.color, data.intensity);
                        break;
                    case 'DirectionalLight':
                        object = new $a1724dcfba0d6d9a$export$3fea33cc9972c868(data.color, data.intensity);
                        object.target = data.target || '';
                        break;
                    case 'PointLight':
                        object = new $a1724dcfba0d6d9a$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                        break;
                    case 'RectAreaLight':
                        object = new $a1724dcfba0d6d9a$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                        break;
                    case 'SpotLight':
                        object = new $a1724dcfba0d6d9a$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                        object.target = data.target || '';
                        break;
                    case 'HemisphereLight':
                        object = new $a1724dcfba0d6d9a$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                        break;
                    case 'LightProbe':
                        object = new $a1724dcfba0d6d9a$export$e7ef036e309b38d2().fromJSON(data);
                        break;
                    case 'SkinnedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $a1724dcfba0d6d9a$export$b303577035157ecf(geometry, material);
                        if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                        if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                        if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                        break;
                    case 'Mesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $a1724dcfba0d6d9a$export$e176487c05830cc5(geometry, material);
                        break;
                    case 'InstancedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        var count = data.count;
                        var instanceMatrix = data.instanceMatrix;
                        var instanceColor = data.instanceColor;
                        object = new $a1724dcfba0d6d9a$export$f3c979c331175ad7(geometry, material, count);
                        object.instanceMatrix = new $a1724dcfba0d6d9a$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                        if (instanceColor !== undefined) object.instanceColor = new $a1724dcfba0d6d9a$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                        break;
                    case 'BatchedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $a1724dcfba0d6d9a$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                        object.geometry = geometry;
                        object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                        object.sortObjects = data.sortObjects;
                        object._drawRanges = data.drawRanges;
                        object._reservedRanges = data.reservedRanges;
                        object._geometryInfo = data.geometryInfo.map(function(info) {
                            var box = null;
                            var sphere = null;
                            if (info.boundingBox !== undefined) box = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                            if (info.boundingSphere !== undefined) sphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                            return (0, $emQHU._)((0, $iT0je._)({}, info), {
                                boundingBox: box,
                                boundingSphere: sphere
                            });
                        });
                        object._instanceInfo = data.instanceInfo;
                        object._availableInstanceIds = data._availableInstanceIds;
                        object._availableGeometryIds = data._availableGeometryIds;
                        object._nextIndexStart = data.nextIndexStart;
                        object._nextVertexStart = data.nextVertexStart;
                        object._geometryCount = data.geometryCount;
                        object._maxInstanceCount = data.maxInstanceCount;
                        object._maxVertexCount = data.maxVertexCount;
                        object._maxIndexCount = data.maxIndexCount;
                        object._geometryInitialized = data.geometryInitialized;
                        object._matricesTexture = getTexture(data.matricesTexture.uuid);
                        object._indirectTexture = getTexture(data.indirectTexture.uuid);
                        if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                        if (data.boundingSphere !== undefined) object.boundingSphere = new $a1724dcfba0d6d9a$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                        if (data.boundingBox !== undefined) object.boundingBox = new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                        break;
                    case 'LOD':
                        object = new $a1724dcfba0d6d9a$export$112e7237be0c5f30();
                        break;
                    case 'Line':
                        object = new $a1724dcfba0d6d9a$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineLoop':
                        object = new $a1724dcfba0d6d9a$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineSegments':
                        object = new $a1724dcfba0d6d9a$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'PointCloud':
                    case 'Points':
                        object = new $a1724dcfba0d6d9a$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'Sprite':
                        object = new $a1724dcfba0d6d9a$export$3075603db8e6204c(getMaterial(data.material));
                        break;
                    case 'Group':
                        object = new $a1724dcfba0d6d9a$export$eb2fcfdbd7ba97d4();
                        break;
                    case 'Bone':
                        object = new $a1724dcfba0d6d9a$export$b127726e56765aa4();
                        break;
                    default:
                        object = new $a1724dcfba0d6d9a$export$e4dd07dff30cc924();
                }
                object.uuid = data.uuid;
                if (data.name !== undefined) object.name = data.name;
                if (data.matrix !== undefined) {
                    object.matrix.fromArray(data.matrix);
                    if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
                    if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
                } else {
                    if (data.position !== undefined) object.position.fromArray(data.position);
                    if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
                    if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
                    if (data.scale !== undefined) object.scale.fromArray(data.scale);
                }
                if (data.up !== undefined) object.up.fromArray(data.up);
                if (data.castShadow !== undefined) object.castShadow = data.castShadow;
                if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
                if (data.shadow) {
                    if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
                    if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
                    if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
                    if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
                    if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
                    if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
                }
                if (data.visible !== undefined) object.visible = data.visible;
                if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
                if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
                if (data.userData !== undefined) object.userData = data.userData;
                if (data.layers !== undefined) object.layers.mask = data.layers;
                if (data.children !== undefined) {
                    var children = data.children;
                    for(var i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
                }
                if (data.animations !== undefined) {
                    var objectAnimations = data.animations;
                    for(var i1 = 0; i1 < objectAnimations.length; i1++){
                        var uuid = objectAnimations[i1];
                        object.animations.push(animations[uuid]);
                    }
                }
                if (data.type === 'LOD') {
                    if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
                    var levels = data.levels;
                    for(var l = 0; l < levels.length; l++){
                        var level = levels[l];
                        var child = object.getObjectByProperty('uuid', level.object);
                        if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
                    }
                }
                return object;
            }
        },
        {
            key: "bindSkeletons",
            value: function bindSkeletons(object, skeletons) {
                if (Object.keys(skeletons).length === 0) return;
                object.traverse(function(child) {
                    if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                        var skeleton = skeletons[child.skeleton];
                        if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                        else child.bind(skeleton, child.bindMatrix);
                    }
                });
            }
        },
        {
            key: "bindLightTargets",
            value: function bindLightTargets(object) {
                object.traverse(function(child) {
                    if (child.isDirectionalLight || child.isSpotLight) {
                        var uuid = child.target;
                        var target = object.getObjectByProperty('uuid', uuid);
                        if (target !== undefined) child.target = target;
                        else child.target = new $a1724dcfba0d6d9a$export$e4dd07dff30cc924();
                    }
                });
            }
        }
    ]);
    return ObjectLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
var $a1724dcfba0d6d9a$var$TEXTURE_MAPPING = {
    UVMapping: $a1724dcfba0d6d9a$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $a1724dcfba0d6d9a$export$8759762a6477f2c4,
    CubeRefractionMapping: $a1724dcfba0d6d9a$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $a1724dcfba0d6d9a$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $a1724dcfba0d6d9a$export$ee99d97d46898098,
    CubeUVReflectionMapping: $a1724dcfba0d6d9a$export$dbf3e70ff37af79
};
var $a1724dcfba0d6d9a$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $a1724dcfba0d6d9a$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $a1724dcfba0d6d9a$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $a1724dcfba0d6d9a$export$c7e7c00b14f51a4f
};
var $a1724dcfba0d6d9a$var$TEXTURE_FILTER = {
    NearestFilter: $a1724dcfba0d6d9a$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $a1724dcfba0d6d9a$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $a1724dcfba0d6d9a$export$d2327c1afe5bfdf2,
    LinearFilter: $a1724dcfba0d6d9a$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $a1724dcfba0d6d9a$export$19a719f377145a13,
    LinearMipmapLinearFilter: $a1724dcfba0d6d9a$export$5d8599b6a933fb1b
};
var $a1724dcfba0d6d9a$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap}.
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader avoids multiple concurrent requests to the same URL only if `Cache` is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$52286b55c4a9b51f = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(ImageBitmapLoader, Loader);
    function ImageBitmapLoader(manager) {
        (0, $jGAMp._)(this, ImageBitmapLoader);
        var _this;
        _this = (0, $kzDuW._)(this, ImageBitmapLoader, [
            manager
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ _this.options = {
            premultiplyAlpha: 'none'
        };
        return _this;
    }
    (0, $byiyg._)(ImageBitmapLoader, [
        {
            /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap}.
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                return this;
            }
        },
        {
            /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $a1724dcfba0d6d9a$export$94affb487e701bf2.get("image-bitmap:".concat(url));
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    // If cached is a promise, wait for it to resolve
                    if (cached.then) {
                        cached.then(function(imageBitmap) {
                            // check if there is an error for the cached promise
                            if ($a1724dcfba0d6d9a$var$_errorMap.has(cached) === true) {
                                if (onError) onError($a1724dcfba0d6d9a$var$_errorMap.get(cached));
                                scope.manager.itemError(url);
                                scope.manager.itemEnd(url);
                            } else {
                                if (onLoad) onLoad(imageBitmap);
                                scope.manager.itemEnd(url);
                                return imageBitmap;
                            }
                        });
                        return;
                    }
                    // If cached is not a promise (i.e., it's already an imageBitmap)
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                var fetchOptions = {};
                fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
                fetchOptions.headers = this.requestHeader;
                var promise = fetch(url, fetchOptions).then(function(res) {
                    return res.blob();
                }).then(function(blob) {
                    return createImageBitmap(blob, Object.assign(scope.options, {
                        colorSpaceConversion: 'none'
                    }));
                }).then(function(imageBitmap) {
                    $a1724dcfba0d6d9a$export$94affb487e701bf2.add("image-bitmap:".concat(url), imageBitmap);
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                    return imageBitmap;
                })["catch"](function(e) {
                    if (onError) onError(e);
                    $a1724dcfba0d6d9a$var$_errorMap.set(promise, e);
                    $a1724dcfba0d6d9a$export$94affb487e701bf2.remove("image-bitmap:".concat(url));
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                });
                $a1724dcfba0d6d9a$export$94affb487e701bf2.add("image-bitmap:".concat(url), promise);
                scope.manager.itemStart(url);
            }
        }
    ]);
    return ImageBitmapLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
var $a1724dcfba0d6d9a$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$fcbc63750ec2a81f = /*#__PURE__*/ function() {
    "use strict";
    function AudioContext() {
        (0, $jGAMp._)(this, AudioContext);
    }
    (0, $byiyg._)(AudioContext, null, [
        {
            key: "getContext",
            value: /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ function getContext() {
                if ($a1724dcfba0d6d9a$var$_context === undefined) $a1724dcfba0d6d9a$var$_context = new (window.AudioContext || window.webkitAudioContext)();
                return $a1724dcfba0d6d9a$var$_context;
            }
        },
        {
            key: "setContext",
            value: /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ function setContext(value) {
                $a1724dcfba0d6d9a$var$_context = value;
            }
        }
    ]);
    return AudioContext;
}();
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ var $a1724dcfba0d6d9a$export$d8d5fccfbf47714e = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $i3fW3._)(AudioLoader, Loader);
    function AudioLoader(manager) {
        (0, $jGAMp._)(this, AudioLoader);
        return (0, $kzDuW._)(this, AudioLoader, [
            manager
        ]);
    }
    (0, $byiyg._)(AudioLoader, [
        {
            /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $a1724dcfba0d6d9a$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(buffer) {
                    try {
                        // Create a copy of the buffer. The `decodeAudioData` method
                        // detaches the buffer when complete, preventing reuse.
                        var bufferCopy = buffer.slice(0);
                        var context = $a1724dcfba0d6d9a$export$fcbc63750ec2a81f.getContext();
                        context.decodeAudioData(bufferCopy, function(audioBuffer) {
                            onLoad(audioBuffer);
                        })["catch"](handleError);
                    } catch (e) {
                        handleError(e);
                    }
                }, onProgress, onError);
                function handleError(e) {
                    if (onError) onError(e);
                    else console.error(e);
                    scope.manager.itemError(url);
                }
            }
        }
    ]);
    return AudioLoader;
}($a1724dcfba0d6d9a$export$3b0d6d7590275603);
var $a1724dcfba0d6d9a$var$_eyeRight = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_eyeLeft = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_projectionMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph]{@link https://en.wikipedia.org/wiki/Anaglyph_3D} or
 * [Parallax Barrier]{@link https://en.wikipedia.org/wiki/parallax_barrier}.
 */ var $a1724dcfba0d6d9a$export$bc7f73a1065bee0c = /*#__PURE__*/ function() {
    "use strict";
    function StereoCamera() {
        (0, $jGAMp._)(this, StereoCamera);
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $a1724dcfba0d6d9a$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    (0, $byiyg._)(StereoCamera, [
        {
            /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ key: "update",
            value: function update(camera) {
                var cache = this._cache;
                var needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
                if (needsUpdate) {
                    cache.focus = camera.focus;
                    cache.fov = camera.fov;
                    cache.aspect = camera.aspect * this.aspect;
                    cache.near = camera.near;
                    cache.far = camera.far;
                    cache.zoom = camera.zoom;
                    cache.eyeSep = this.eyeSep;
                    // Off-axis stereoscopic effect based on
                    // http://paulbourke.net/stereographics/stereorender/
                    $a1724dcfba0d6d9a$var$_projectionMatrix.copy(camera.projectionMatrix);
                    var eyeSepHalf = cache.eyeSep / 2;
                    var eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
                    var ymax = cache.near * Math.tan($a1724dcfba0d6d9a$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
                    var xmin, xmax;
                    // translate xOffset
                    $a1724dcfba0d6d9a$var$_eyeLeft.elements[12] = -eyeSepHalf;
                    $a1724dcfba0d6d9a$var$_eyeRight.elements[12] = eyeSepHalf;
                    // for left eye
                    xmin = -ymax * cache.aspect + eyeSepOnProjection;
                    xmax = ymax * cache.aspect + eyeSepOnProjection;
                    $a1724dcfba0d6d9a$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    $a1724dcfba0d6d9a$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraL.projectionMatrix.copy($a1724dcfba0d6d9a$var$_projectionMatrix);
                    // for right eye
                    xmin = -ymax * cache.aspect - eyeSepOnProjection;
                    xmax = ymax * cache.aspect - eyeSepOnProjection;
                    $a1724dcfba0d6d9a$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    $a1724dcfba0d6d9a$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraR.projectionMatrix.copy($a1724dcfba0d6d9a$var$_projectionMatrix);
                }
                this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($a1724dcfba0d6d9a$var$_eyeLeft);
                this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($a1724dcfba0d6d9a$var$_eyeRight);
            }
        }
    ]);
    return StereoCamera;
}();
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ var $a1724dcfba0d6d9a$export$56b937d9e5581166 = /*#__PURE__*/ function(PerspectiveCamera) {
    "use strict";
    (0, $i3fW3._)(ArrayCamera, PerspectiveCamera);
    function ArrayCamera() {
        var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $jGAMp._)(this, ArrayCamera);
        var _this;
        _this = (0, $kzDuW._)(this, ArrayCamera);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ _this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ _this.cameras = array;
        return _this;
    }
    return ArrayCamera;
}($a1724dcfba0d6d9a$export$74e4ae24825f68d7);
/**
 * Class for keeping track of time.
 */ var $a1724dcfba0d6d9a$export$9735c82c4bae3302 = /*#__PURE__*/ function() {
    "use strict";
    function Clock() {
        var autoStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        (0, $jGAMp._)(this, Clock);
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
    (0, $byiyg._)(Clock, [
        {
            /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ key: "start",
            value: function start() {
                this.startTime = performance.now();
                this.oldTime = this.startTime;
                this.elapsedTime = 0;
                this.running = true;
            }
        },
        {
            /**
	 * Stops the clock.
	 */ key: "stop",
            value: function stop() {
                this.getElapsedTime();
                this.running = false;
                this.autoStart = false;
            }
        },
        {
            /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ key: "getElapsedTime",
            value: function getElapsedTime() {
                this.getDelta();
                return this.elapsedTime;
            }
        },
        {
            /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ key: "getDelta",
            value: function getDelta() {
                var diff = 0;
                if (this.autoStart && !this.running) {
                    this.start();
                    return 0;
                }
                if (this.running) {
                    var newTime = performance.now();
                    diff = (newTime - this.oldTime) / 1000;
                    this.oldTime = newTime;
                    this.elapsedTime += diff;
                }
                return diff;
            }
        }
    ]);
    return Clock;
}();
var $a1724dcfba0d6d9a$var$_position$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_quaternion$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
var $a1724dcfba0d6d9a$var$_scale$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_forward = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_up = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$8a1b810c6fde8951 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(AudioListener, Object3D);
    function AudioListener() {
        (0, $jGAMp._)(this, AudioListener);
        var _this;
        _this = (0, $kzDuW._)(this, AudioListener);
        _this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ _this.context = $a1724dcfba0d6d9a$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ _this.gain = _this.context.createGain();
        _this.gain.connect(_this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ _this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ _this.timeDelta = 0;
        // private
        _this._clock = new $a1724dcfba0d6d9a$export$9735c82c4bae3302();
        return _this;
    }
    (0, $byiyg._)(AudioListener, [
        {
            /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ key: "getInput",
            value: function getInput() {
                return this.gain;
            }
        },
        {
            /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ key: "removeFilter",
            value: function removeFilter() {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                    this.gain.connect(this.context.destination);
                    this.filter = null;
                }
                return this;
            }
        },
        {
            /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ key: "getFilter",
            value: function getFilter() {
                return this.filter;
            }
        },
        {
            /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ key: "setFilter",
            value: function setFilter(value) {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                } else this.gain.disconnect(this.context.destination);
                this.filter = value;
                this.gain.connect(this.filter);
                this.filter.connect(this.context.destination);
                return this;
            }
        },
        {
            /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ key: "getMasterVolume",
            value: function getMasterVolume() {
                return this.gain.gain.value;
            }
        },
        {
            /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ key: "setMasterVolume",
            value: function setMasterVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $fXhL4._)((0, $hxFDX._)(AudioListener.prototype), "updateMatrixWorld", this).call(this, force);
                var listener = this.context.listener;
                this.timeDelta = this._clock.getDelta();
                this.matrixWorld.decompose($a1724dcfba0d6d9a$var$_position$1, $a1724dcfba0d6d9a$var$_quaternion$1, $a1724dcfba0d6d9a$var$_scale$1);
                // the initial forward and up directions must be orthogonal
                $a1724dcfba0d6d9a$var$_forward.set(0, 0, -1).applyQuaternion($a1724dcfba0d6d9a$var$_quaternion$1);
                $a1724dcfba0d6d9a$var$_up.set(0, 1, 0).applyQuaternion($a1724dcfba0d6d9a$var$_quaternion$1);
                if (listener.positionX) {
                    // code path for Chrome (see #14393)
                    var endTime = this.context.currentTime + this.timeDelta;
                    listener.positionX.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position$1.x, endTime);
                    listener.positionY.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position$1.y, endTime);
                    listener.positionZ.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position$1.z, endTime);
                    listener.forwardX.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_forward.x, endTime);
                    listener.forwardY.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_forward.y, endTime);
                    listener.forwardZ.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_forward.z, endTime);
                    listener.upX.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_up.x, endTime);
                    listener.upY.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_up.y, endTime);
                    listener.upZ.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_up.z, endTime);
                } else {
                    listener.setPosition($a1724dcfba0d6d9a$var$_position$1.x, $a1724dcfba0d6d9a$var$_position$1.y, $a1724dcfba0d6d9a$var$_position$1.z);
                    listener.setOrientation($a1724dcfba0d6d9a$var$_forward.x, $a1724dcfba0d6d9a$var$_forward.y, $a1724dcfba0d6d9a$var$_forward.z, $a1724dcfba0d6d9a$var$_up.x, $a1724dcfba0d6d9a$var$_up.y, $a1724dcfba0d6d9a$var$_up.z);
                }
            }
        }
    ]);
    return AudioListener;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API]{@link https://www.w3.org/TR/webaudio-1.1/}.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$153755f98d9861de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(Audio, Object3D);
    function Audio(listener) {
        (0, $jGAMp._)(this, Audio);
        var _this;
        _this = (0, $kzDuW._)(this, Audio);
        _this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ _this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ _this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ _this.gain = _this.context.createGain();
        _this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ _this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ _this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ _this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ _this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ _this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ _this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ _this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ _this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ _this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ _this.sourceType = 'empty';
        _this._startedAt = 0;
        _this._progress = 0;
        _this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ _this.filters = [];
        return _this;
    }
    (0, $byiyg._)(Audio, [
        {
            /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ key: "getOutput",
            value: function getOutput() {
                return this.gain;
            }
        },
        {
            /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ key: "setNodeSource",
            value: function setNodeSource(audioNode) {
                this.hasPlaybackControl = false;
                this.sourceType = 'audioNode';
                this.source = audioNode;
                this.connect();
                return this;
            }
        },
        {
            /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ key: "setMediaElementSource",
            value: function setMediaElementSource(mediaElement) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaNode';
                this.source = this.context.createMediaElementSource(mediaElement);
                this.connect();
                return this;
            }
        },
        {
            /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ key: "setMediaStreamSource",
            value: function setMediaStreamSource(mediaStream) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaStreamNode';
                this.source = this.context.createMediaStreamSource(mediaStream);
                this.connect();
                return this;
            }
        },
        {
            /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ key: "setBuffer",
            value: function setBuffer(audioBuffer) {
                this.buffer = audioBuffer;
                this.sourceType = 'buffer';
                if (this.autoplay) this.play();
                return this;
            }
        },
        {
            /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "play",
            value: function play() {
                var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.isPlaying === true) {
                    console.warn('THREE.Audio: Audio is already playing.');
                    return;
                }
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._startedAt = this.context.currentTime + delay;
                var source = this.context.createBufferSource();
                source.buffer = this.buffer;
                source.loop = this.loop;
                source.loopStart = this.loopStart;
                source.loopEnd = this.loopEnd;
                source.onended = this.onEnded.bind(this);
                source.start(this._startedAt, this._progress + this.offset, this.duration);
                this.isPlaying = true;
                this.source = source;
                this.setDetune(this.detune);
                this.setPlaybackRate(this.playbackRate);
                return this.connect();
            }
        },
        {
            /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "pause",
            value: function pause() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                if (this.isPlaying === true) {
                    // update current progress
                    this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
                    if (this.loop === true) // ensure _progress does not exceed duration with looped audios
                    this._progress = this._progress % (this.duration || this.buffer.duration);
                    this.source.stop();
                    this.source.onended = null;
                    this.isPlaying = false;
                }
                return this;
            }
        },
        {
            /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "stop",
            value: function stop() {
                var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._progress = 0;
                if (this.source !== null) {
                    this.source.stop(this.context.currentTime + delay);
                    this.source.onended = null;
                }
                this.isPlaying = false;
                return this;
            }
        },
        {
            /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ key: "connect",
            value: function connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                this._connected = true;
                return this;
            }
        },
        {
            /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "disconnect",
            value: function disconnect() {
                if (this._connected === false) return;
                if (this.filters.length > 0) {
                    this.source.disconnect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
                    this.filters[this.filters.length - 1].disconnect(this.getOutput());
                } else this.source.disconnect(this.getOutput());
                this._connected = false;
                return this;
            }
        },
        {
            /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ key: "getFilters",
            value: function getFilters() {
                return this.filters;
            }
        },
        {
            /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ key: "setFilters",
            value: function setFilters(value) {
                if (!value) value = [];
                if (this._connected === true) {
                    this.disconnect();
                    this.filters = value.slice();
                    this.connect();
                } else this.filters = value.slice();
                return this;
            }
        },
        {
            /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ key: "setDetune",
            value: function setDetune(value) {
                this.detune = value;
                if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ key: "getDetune",
            value: function getDetune() {
                return this.detune;
            }
        },
        {
            /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ key: "getFilter",
            value: function getFilter() {
                return this.getFilters()[0];
            }
        },
        {
            /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ key: "setFilter",
            value: function setFilter(filter) {
                return this.setFilters(filter ? [
                    filter
                ] : []);
            }
        },
        {
            /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "setPlaybackRate",
            value: function setPlaybackRate(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.playbackRate = value;
                if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.playbackRate;
            }
        },
        {
            /**
	 * Automatically called when playback finished.
	 */ key: "onEnded",
            value: function onEnded() {
                this.isPlaying = false;
                this._progress = 0;
            }
        },
        {
            /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ key: "getLoop",
            value: function getLoop() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return false;
                }
                return this.loop;
            }
        },
        {
            /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ key: "setLoop",
            value: function setLoop(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.loop = value;
                if (this.isPlaying === true) this.source.loop = this.loop;
                return this;
            }
        },
        {
            /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ key: "setLoopStart",
            value: function setLoopStart(value) {
                this.loopStart = value;
                return this;
            }
        },
        {
            /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ key: "setLoopEnd",
            value: function setLoopEnd(value) {
                this.loopEnd = value;
                return this;
            }
        },
        {
            /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ key: "getVolume",
            value: function getVolume() {
                return this.gain.gain.value;
            }
        },
        {
            /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ key: "setVolume",
            value: function setVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(Audio.prototype), "copy", this).call(this, source, recursive);
                if (source.sourceType !== 'buffer') {
                    console.warn('THREE.Audio: Audio source type cannot be copied.');
                    return this;
                }
                this.autoplay = source.autoplay;
                this.buffer = source.buffer;
                this.detune = source.detune;
                this.loop = source.loop;
                this.loopStart = source.loopStart;
                this.loopEnd = source.loopEnd;
                this.offset = source.offset;
                this.duration = source.duration;
                this.playbackRate = source.playbackRate;
                this.hasPlaybackControl = source.hasPlaybackControl;
                this.sourceType = source.sourceType;
                this.filters = source.filters.slice();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(recursive) {
                return new this.constructor(this.listener).copy(this, recursive);
            }
        }
    ]);
    return Audio;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_position = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_quaternion = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3();
var $a1724dcfba0d6d9a$var$_scale = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_orientation = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ var $a1724dcfba0d6d9a$export$4b3e397ef1832507 = /*#__PURE__*/ function(Audio) {
    "use strict";
    (0, $i3fW3._)(PositionalAudio, Audio);
    function PositionalAudio(listener) {
        (0, $jGAMp._)(this, PositionalAudio);
        var _this;
        _this = (0, $kzDuW._)(this, PositionalAudio, [
            listener
        ]);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ _this.panner = _this.context.createPanner();
        _this.panner.panningModel = 'HRTF';
        _this.panner.connect(_this.gain);
        return _this;
    }
    (0, $byiyg._)(PositionalAudio, [
        {
            key: "connect",
            value: function connect() {
                (0, $fXhL4._)((0, $hxFDX._)(PositionalAudio.prototype), "connect", this).call(this);
                this.panner.connect(this.gain);
                return this;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                (0, $fXhL4._)((0, $hxFDX._)(PositionalAudio.prototype), "disconnect", this).call(this);
                this.panner.disconnect(this.gain);
                return this;
            }
        },
        {
            key: "getOutput",
            value: function getOutput() {
                return this.panner;
            }
        },
        {
            /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ key: "getRefDistance",
            value: function getRefDistance() {
                return this.panner.refDistance;
            }
        },
        {
            /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ key: "setRefDistance",
            value: function setRefDistance(value) {
                this.panner.refDistance = value;
                return this;
            }
        },
        {
            /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ key: "getRolloffFactor",
            value: function getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
        },
        {
            /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ key: "setRolloffFactor",
            value: function setRolloffFactor(value) {
                this.panner.rolloffFactor = value;
                return this;
            }
        },
        {
            /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ key: "getDistanceModel",
            value: function getDistanceModel() {
                return this.panner.distanceModel;
            }
        },
        {
            /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec]{@link https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype}
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ key: "setDistanceModel",
            value: function setDistanceModel(value) {
                this.panner.distanceModel = value;
                return this;
            }
        },
        {
            /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ key: "getMaxDistance",
            value: function getMaxDistance() {
                return this.panner.maxDistance;
            }
        },
        {
            /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ key: "setMaxDistance",
            value: function setMaxDistance(value) {
                this.panner.maxDistance = value;
                return this;
            }
        },
        {
            /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ key: "setDirectionalCone",
            value: function setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
                this.panner.coneInnerAngle = coneInnerAngle;
                this.panner.coneOuterAngle = coneOuterAngle;
                this.panner.coneOuterGain = coneOuterGain;
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $fXhL4._)((0, $hxFDX._)(PositionalAudio.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.hasPlaybackControl === true && this.isPlaying === false) return;
                this.matrixWorld.decompose($a1724dcfba0d6d9a$var$_position, $a1724dcfba0d6d9a$var$_quaternion, $a1724dcfba0d6d9a$var$_scale);
                $a1724dcfba0d6d9a$var$_orientation.set(0, 0, 1).applyQuaternion($a1724dcfba0d6d9a$var$_quaternion);
                var panner = this.panner;
                if (panner.positionX) {
                    // code path for Chrome and Firefox (see #14393)
                    var endTime = this.context.currentTime + this.listener.timeDelta;
                    panner.positionX.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position.x, endTime);
                    panner.positionY.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position.y, endTime);
                    panner.positionZ.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_position.z, endTime);
                    panner.orientationX.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_orientation.x, endTime);
                    panner.orientationY.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_orientation.y, endTime);
                    panner.orientationZ.linearRampToValueAtTime($a1724dcfba0d6d9a$var$_orientation.z, endTime);
                } else {
                    panner.setPosition($a1724dcfba0d6d9a$var$_position.x, $a1724dcfba0d6d9a$var$_position.y, $a1724dcfba0d6d9a$var$_position.z);
                    panner.setOrientation($a1724dcfba0d6d9a$var$_orientation.x, $a1724dcfba0d6d9a$var$_orientation.y, $a1724dcfba0d6d9a$var$_orientation.z);
                }
            }
        }
    ]);
    return PositionalAudio;
}((0, $8AW3P._)($a1724dcfba0d6d9a$export$153755f98d9861de));
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ var $a1724dcfba0d6d9a$export$d47da1ef3d382827 = /*#__PURE__*/ function() {
    "use strict";
    function AudioAnalyser(audio) {
        var fftSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2048;
        (0, $jGAMp._)(this, AudioAnalyser);
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    (0, $byiyg._)(AudioAnalyser, [
        {
            /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ key: "getFrequencyData",
            value: function getFrequencyData() {
                this.analyser.getByteFrequencyData(this.data);
                return this.data;
            }
        },
        {
            /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ key: "getAverageFrequency",
            value: function getAverageFrequency() {
                var value = 0;
                var data = this.getFrequencyData();
                for(var i = 0; i < data.length; i++)value += data[i];
                return value / data.length;
            }
        }
    ]);
    return AudioAnalyser;
}();
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ var $a1724dcfba0d6d9a$export$dfe0af1ca1acb78a = /*#__PURE__*/ function() {
    "use strict";
    function PropertyMixer(binding, typeName, valueSize) {
        (0, $jGAMp._)(this, PropertyMixer);
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        var mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    (0, $byiyg._)(PropertyMixer, [
        {
            /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ key: "accumulate",
            value: function accumulate(accuIndex, weight) {
                // note: happily accumulating nothing when weight = 0, the caller knows
                // the weight and shouldn't have made the call in the first place
                var buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
                var currentWeight = this.cumulativeWeight;
                if (currentWeight === 0) {
                    // accuN := incoming * weight
                    for(var i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
                    currentWeight = weight;
                } else {
                    // accuN := accuN + incoming * weight
                    currentWeight += weight;
                    var mix = weight / currentWeight;
                    this._mixBufferRegion(buffer, offset, 0, mix, stride);
                }
                this.cumulativeWeight = currentWeight;
            }
        },
        {
            /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ key: "accumulateAdditive",
            value: function accumulateAdditive(weight) {
                var buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
                if (this.cumulativeWeightAdditive === 0) // add = identity
                this._setIdentity();
                // add := add + incoming * weight
                this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
                this.cumulativeWeightAdditive += weight;
            }
        },
        {
            /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ key: "apply",
            value: function apply(accuIndex) {
                var stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
                if (weight < 1) {
                    // accuN := accuN + original * ( 1 - cumulativeWeight )
                    var originalValueOffset = stride * this._origIndex;
                    this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
                }
                if (weightAdditive > 0) // accuN := accuN + additive accuN
                this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
                for(var i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
                    // value has changed -> update scene graph
                    binding.setValue(buffer, offset);
                    break;
                }
            }
        },
        {
            /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ key: "saveOriginalState",
            value: function saveOriginalState() {
                var binding = this.binding;
                var buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
                binding.getValue(buffer, originalValueOffset);
                // accu[0..1] := orig -- initially detect changes against the original
                for(var i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
                // Add to identity for additive
                this._setIdentity();
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
            }
        },
        {
            /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ key: "restoreOriginalState",
            value: function restoreOriginalState() {
                var originalValueOffset = this.valueSize * 3;
                this.binding.setValue(this.buffer, originalValueOffset);
            }
        },
        {
            // internals
            key: "_setAdditiveIdentityNumeric",
            value: function _setAdditiveIdentityNumeric() {
                var startIndex = this._addIndex * this.valueSize;
                var endIndex = startIndex + this.valueSize;
                for(var i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
            }
        },
        {
            key: "_setAdditiveIdentityQuaternion",
            value: function _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric();
                this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
        },
        {
            key: "_setAdditiveIdentityOther",
            value: function _setAdditiveIdentityOther() {
                var startIndex = this._origIndex * this.valueSize;
                var targetIndex = this._addIndex * this.valueSize;
                for(var i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
            }
        },
        {
            // mix functions
            key: "_select",
            value: function _select(buffer, dstOffset, srcOffset, t, stride) {
                if (t >= 0.5) for(var i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
            }
        },
        {
            key: "_slerp",
            value: function _slerp(buffer, dstOffset, srcOffset, t) {
                $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
            }
        },
        {
            key: "_slerpAdditive",
            value: function _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                var workOffset = this._workIndex * stride;
                // Store result in intermediate buffer offset
                $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
                // Slerp to the intermediate result
                $a1724dcfba0d6d9a$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
            }
        },
        {
            key: "_lerp",
            value: function _lerp(buffer, dstOffset, srcOffset, t, stride) {
                var s = 1 - t;
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
                }
            }
        },
        {
            key: "_lerpAdditive",
            value: function _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
                }
            }
        }
    ]);
    return PropertyMixer;
}();
// Characters [].:/ are reserved for track binding syntax.
var $a1724dcfba0d6d9a$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
var $a1724dcfba0d6d9a$var$_reservedRe = new RegExp('[' + $a1724dcfba0d6d9a$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
var $a1724dcfba0d6d9a$var$_wordChar = '[^' + $a1724dcfba0d6d9a$var$_RESERVED_CHARS_RE + ']';
var $a1724dcfba0d6d9a$var$_wordCharOrDot = '[^' + $a1724dcfba0d6d9a$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
var $a1724dcfba0d6d9a$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $a1724dcfba0d6d9a$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
var $a1724dcfba0d6d9a$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $a1724dcfba0d6d9a$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
var $a1724dcfba0d6d9a$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $a1724dcfba0d6d9a$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
var $a1724dcfba0d6d9a$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $a1724dcfba0d6d9a$var$_wordChar);
var $a1724dcfba0d6d9a$var$_trackRe = new RegExp("^" + $a1724dcfba0d6d9a$var$_directoryRe + $a1724dcfba0d6d9a$var$_nodeRe + $a1724dcfba0d6d9a$var$_objectRe + $a1724dcfba0d6d9a$var$_propertyRe + '$');
var $a1724dcfba0d6d9a$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
var $a1724dcfba0d6d9a$var$Composite = /*#__PURE__*/ function() {
    "use strict";
    function Composite(targetGroup, path, optionalParsedPath) {
        (0, $jGAMp._)(this, Composite);
        var parsedPath = optionalParsedPath || $a1724dcfba0d6d9a$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    (0, $byiyg._)(Composite, [
        {
            key: "getValue",
            value: function getValue(array, offset) {
                this.bind(); // bind all binding
                var firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
                // and only call .getValue on the first
                if (binding !== undefined) binding.getValue(array, offset);
            }
        },
        {
            key: "setValue",
            value: function setValue(array, offset) {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
            }
        },
        {
            key: "bind",
            value: function bind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
            }
        }
    ]);
    return Composite;
}();
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ var $a1724dcfba0d6d9a$export$7bf70fcf9f891893 = /*#__PURE__*/ function() {
    "use strict";
    function PropertyBinding(rootNode, path, parsedPath) {
        (0, $jGAMp._)(this, PropertyBinding);
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    (0, $byiyg._)(PropertyBinding, [
        {
            // these are used to "bind" a nonexistent property
            key: "_getValue_unavailable",
            value: function _getValue_unavailable() {}
        },
        {
            key: "_setValue_unavailable",
            value: function _setValue_unavailable() {}
        },
        {
            // Getters
            key: "_getValue_direct",
            value: function _getValue_direct(buffer, offset) {
                buffer[offset] = this.targetObject[this.propertyName];
            }
        },
        {
            key: "_getValue_array",
            value: function _getValue_array(buffer, offset) {
                var source = this.resolvedProperty;
                for(var i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
            }
        },
        {
            key: "_getValue_arrayElement",
            value: function _getValue_arrayElement(buffer, offset) {
                buffer[offset] = this.resolvedProperty[this.propertyIndex];
            }
        },
        {
            key: "_getValue_toArray",
            value: function _getValue_toArray(buffer, offset) {
                this.resolvedProperty.toArray(buffer, offset);
            }
        },
        {
            // Direct
            key: "_setValue_direct",
            value: function _setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
            }
        },
        {
            key: "_setValue_direct_setNeedsUpdate",
            value: function _setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_direct_setMatrixWorldNeedsUpdate",
            value: function _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // EntireArray
            key: "_setValue_array",
            value: function _setValue_array(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
            }
        },
        {
            key: "_setValue_array_setNeedsUpdate",
            value: function _setValue_array_setNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_array_setMatrixWorldNeedsUpdate",
            value: function _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // ArrayElement
            key: "_setValue_arrayElement",
            value: function _setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
            }
        },
        {
            key: "_setValue_arrayElement_setNeedsUpdate",
            value: function _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
            value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // HasToFromArray
            key: "_setValue_fromArray",
            value: function _setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
            }
        },
        {
            key: "_setValue_fromArray_setNeedsUpdate",
            value: function _setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
            value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            key: "_getValue_unbound",
            value: function _getValue_unbound(targetArray, offset) {
                this.bind();
                this.getValue(targetArray, offset);
            }
        },
        {
            key: "_setValue_unbound",
            value: function _setValue_unbound(sourceArray, offset) {
                this.bind();
                this.setValue(sourceArray, offset);
            }
        },
        {
            /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ key: "bind",
            value: function bind() {
                var targetObject = this.node;
                var parsedPath = this.parsedPath;
                var objectName = parsedPath.objectName;
                var propertyName = parsedPath.propertyName;
                var propertyIndex = parsedPath.propertyIndex;
                if (!targetObject) {
                    targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
                    this.node = targetObject;
                }
                // set fail state so we can just 'return' on error
                this.getValue = this._getValue_unavailable;
                this.setValue = this._setValue_unavailable;
                // ensure there is a value node
                if (!targetObject) {
                    console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
                    return;
                }
                if (objectName) {
                    var objectIndex = parsedPath.objectIndex;
                    // special cases were we need to reach deeper into the hierarchy to get the face materials....
                    switch(objectName){
                        case 'materials':
                            if (!targetObject.material) {
                                console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                                return;
                            }
                            if (!targetObject.material.materials) {
                                console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                                return;
                            }
                            targetObject = targetObject.material.materials;
                            break;
                        case 'bones':
                            if (!targetObject.skeleton) {
                                console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                                return;
                            }
                            // potential future optimization: skip this if propertyIndex is already an integer
                            // and convert the integer string to a true integer.
                            targetObject = targetObject.skeleton.bones;
                            // support resolving morphTarget names into indices.
                            for(var i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                                objectIndex = i;
                                break;
                            }
                            break;
                        case 'map':
                            if ('map' in targetObject) {
                                targetObject = targetObject.map;
                                break;
                            }
                            if (!targetObject.material) {
                                console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                                return;
                            }
                            if (!targetObject.material.map) {
                                console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                                return;
                            }
                            targetObject = targetObject.material.map;
                            break;
                        default:
                            if (targetObject[objectName] === undefined) {
                                console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                                return;
                            }
                            targetObject = targetObject[objectName];
                    }
                    if (objectIndex !== undefined) {
                        if (targetObject[objectIndex] === undefined) {
                            console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                            return;
                        }
                        targetObject = targetObject[objectIndex];
                    }
                }
                // resolve property
                var nodeProperty = targetObject[propertyName];
                if (nodeProperty === undefined) {
                    var nodeName = parsedPath.nodeName;
                    console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
                    return;
                }
                // determine versioning scheme
                var versioning = this.Versioning.None;
                this.targetObject = targetObject;
                if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
                else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
                // determine how the property gets bound
                var bindingType = this.BindingType.Direct;
                if (propertyIndex !== undefined) {
                    // access a sub element of the property array (only primitives are supported right now)
                    if (propertyName === 'morphTargetInfluences') {
                        // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                        // support resolving morphTarget names into indices.
                        if (!targetObject.geometry) {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                            return;
                        }
                        if (!targetObject.geometry.morphAttributes) {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                            return;
                        }
                        if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                    }
                    bindingType = this.BindingType.ArrayElement;
                    this.resolvedProperty = nodeProperty;
                    this.propertyIndex = propertyIndex;
                } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
                    // must use copy for Object3D.Euler/Quaternion
                    bindingType = this.BindingType.HasFromToArray;
                    this.resolvedProperty = nodeProperty;
                } else if (Array.isArray(nodeProperty)) {
                    bindingType = this.BindingType.EntireArray;
                    this.resolvedProperty = nodeProperty;
                } else this.propertyName = propertyName;
                // select getter / setter
                this.getValue = this.GetterByBindingType[bindingType];
                this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
            }
        },
        {
            /**
	 * Unbinds the property.
	 */ key: "unbind",
            value: function unbind() {
                this.node = null;
                // back to the prototype version of getValue / setValue
                // note: avoiding to mutate the shape of 'this' via 'delete'
                this.getValue = this._getValue_unbound;
                this.setValue = this._setValue_unbound;
            }
        }
    ], [
        {
            key: "create",
            value: /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ function create(root, path, parsedPath) {
                if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
                else return new PropertyBinding.Composite(root, path, parsedPath);
            }
        },
        {
            key: "sanitizeNodeName",
            value: /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ function sanitizeNodeName(name) {
                return name.replace(/\s/g, '_').replace($a1724dcfba0d6d9a$var$_reservedRe, '');
            }
        },
        {
            key: "parseTrackName",
            value: /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ function parseTrackName(trackName) {
                var matches = $a1724dcfba0d6d9a$var$_trackRe.exec(trackName);
                if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
                var results = {
                    // directoryName: matches[ 1 ], // (tschw) currently unused
                    nodeName: matches[2],
                    objectName: matches[3],
                    objectIndex: matches[4],
                    propertyName: matches[5],
                    propertyIndex: matches[6]
                };
                var lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
                if (lastDot !== undefined && lastDot !== -1) {
                    var objectName = results.nodeName.substring(lastDot + 1);
                    // Object names must be checked against an allowlist. Otherwise, there
                    // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
                    // 'bar' could be the objectName, or part of a nodeName (which can
                    // include '.' characters).
                    if ($a1724dcfba0d6d9a$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                        results.nodeName = results.nodeName.substring(0, lastDot);
                        results.objectName = objectName;
                    }
                }
                if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
                return results;
            }
        },
        {
            key: "findNode",
            value: /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ function findNode(root, nodeName) {
                if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
                // search into skeleton bones.
                if (root.skeleton) {
                    var bone = root.skeleton.getBoneByName(nodeName);
                    if (bone !== undefined) return bone;
                }
                // search into node subtree.
                if (root.children) {
                    var searchNodeSubtree = function searchNodeSubtree1(children) {
                        for(var i = 0; i < children.length; i++){
                            var childNode = children[i];
                            if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                            var result = searchNodeSubtree(childNode.children);
                            if (result) return result;
                        }
                        return null;
                    };
                    var subTreeNode = searchNodeSubtree(root.children);
                    if (subTreeNode) return subTreeNode;
                }
                return null;
            }
        }
    ]);
    return PropertyBinding;
}();
$a1724dcfba0d6d9a$export$7bf70fcf9f891893.Composite = $a1724dcfba0d6d9a$var$Composite;
$a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._getValue_direct,
    $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._getValue_array,
    $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_direct,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_array,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $a1724dcfba0d6d9a$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ var $a1724dcfba0d6d9a$export$30619c2afd3f34db = /*#__PURE__*/ function() {
    "use strict";
    function AnimationObjectGroup() {
        (0, $jGAMp._)(this, AnimationObjectGroup);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $a1724dcfba0d6d9a$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        var indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(var i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        var scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    (0, $byiyg._)(AnimationObjectGroup, [
        {
            /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ key: "add",
            value: function add() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
                var knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid;
                    var index = indicesByUUID[uuid];
                    if (index === undefined) {
                        // unknown object -> add it to the ACTIVE region
                        index = nObjects++;
                        indicesByUUID[uuid] = index;
                        objects.push(object);
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $a1724dcfba0d6d9a$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
                    } else if (index < nCachedObjects) {
                        knownObject = objects[index];
                        // move existing object to the ACTIVE region
                        var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                        indicesByUUID[lastCachedObject.uuid] = index;
                        objects[index] = lastCachedObject;
                        indicesByUUID[uuid] = firstActiveIndex;
                        objects[firstActiveIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                            var bindingsForPath = bindings[j1], lastCached = bindingsForPath[firstActiveIndex];
                            var binding = bindingsForPath[index];
                            bindingsForPath[index] = lastCached;
                            if (binding === undefined) // since we do not bother to create new bindings
                            // for objects that are cached, the binding may
                            // or may not exist
                            binding = new $a1724dcfba0d6d9a$export$7bf70fcf9f891893(object, paths[j1], parsedPaths[j1]);
                            bindingsForPath[firstActiveIndex] = binding;
                        }
                    } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                     // else the object is already where we want it to be
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ key: "remove",
            value: function remove() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined && index >= nCachedObjects) {
                        // move existing object into the CACHED region
                        var lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                        indicesByUUID[firstActiveObject.uuid] = index;
                        objects[index] = firstActiveObject;
                        indicesByUUID[uuid] = lastCachedIndex;
                        objects[lastCachedIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j){
                            var bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                            bindingsForPath[index] = firstActive;
                            bindingsForPath[lastCachedIndex] = binding;
                        }
                    }
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ key: "uncache",
            value: function uncache() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined) {
                        delete indicesByUUID[uuid];
                        if (index < nCachedObjects) {
                            // object is cached, shrink the CACHED region
                            var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                            // last cached object takes this object's place
                            indicesByUUID[lastCachedObject.uuid] = index;
                            objects[index] = lastCachedObject;
                            // last object goes to the activated slot and pop
                            indicesByUUID[lastObject.uuid] = firstActiveIndex;
                            objects[firstActiveIndex] = lastObject;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j = 0, m = nBindings; j !== m; ++j){
                                var bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                                bindingsForPath[index] = lastCached;
                                bindingsForPath[firstActiveIndex] = last;
                                bindingsForPath.pop();
                            }
                        } else {
                            // object is active, just swap with the last and pop
                            var lastIndex1 = --nObjects, lastObject1 = objects[lastIndex1];
                            if (lastIndex1 > 0) indicesByUUID[lastObject1.uuid] = index;
                            objects[index] = lastObject1;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                                var bindingsForPath1 = bindings[j1];
                                bindingsForPath1[index] = bindingsForPath1[lastIndex1];
                                bindingsForPath1.pop();
                            }
                        } // cached or active
                    } // if object is known
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            // Internal interface used by befriended PropertyBinding.Composite:
            key: "subscribe_",
            value: function subscribe_(path, parsedPath) {
                // returns an array of bindings for the given path that is changed
                // according to the contained objects in the group
                var indicesByPath = this._bindingsIndicesByPath;
                var index = indicesByPath[path];
                var bindings = this._bindings;
                if (index !== undefined) return bindings[index];
                var paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
                index = bindings.length;
                indicesByPath[path] = index;
                paths.push(path);
                parsedPaths.push(parsedPath);
                bindings.push(bindingsForPath);
                for(var i = nCachedObjects, n = objects.length; i !== n; ++i){
                    var object = objects[i];
                    bindingsForPath[i] = new $a1724dcfba0d6d9a$export$7bf70fcf9f891893(object, path, parsedPath);
                }
                return bindingsForPath;
            }
        },
        {
            key: "unsubscribe_",
            value: function unsubscribe_(path) {
                // tells the group to forget about a property path and no longer
                // update the array previously obtained with 'subscribe_'
                var indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
                if (index !== undefined) {
                    var paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
                    indicesByPath[lastBindingsPath] = index;
                    bindings[index] = lastBindings;
                    bindings.pop();
                    parsedPaths[index] = parsedPaths[lastBindingsIndex];
                    parsedPaths.pop();
                    paths[index] = paths[lastBindingsIndex];
                    paths.pop();
                }
            }
        }
    ]);
    return AnimationObjectGroup;
}();
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ var $a1724dcfba0d6d9a$export$6946940a69e799e = /*#__PURE__*/ function() {
    "use strict";
    function AnimationAction(mixer, clip) {
        var localRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : clip.blendMode;
        (0, $jGAMp._)(this, AnimationAction);
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        var tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        var interpolantSettings = {
            endingStart: $a1724dcfba0d6d9a$export$7f795934b84ab523,
            endingEnd: $a1724dcfba0d6d9a$export$7f795934b84ab523
        };
        for(var i = 0; i !== nTracks; ++i){
            var interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $a1724dcfba0d6d9a$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    (0, $byiyg._)(AnimationAction, [
        {
            /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "play",
            value: function play() {
                this._mixer._activateAction(this);
                return this;
            }
        },
        {
            /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "stop",
            value: function stop() {
                this._mixer._deactivateAction(this);
                return this.reset();
            }
        },
        {
            /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "reset",
            value: function reset() {
                this.paused = false;
                this.enabled = true;
                this.time = 0; // restart clip
                this._loopCount = -1; // forget previous loops
                this._startTime = null; // forget scheduling
                return this.stopFading().stopWarping();
            }
        },
        {
            /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ key: "isRunning",
            value: function isRunning() {
                return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
            }
        },
        {
            /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ key: "isScheduled",
            value: function isScheduled() {
                return this._mixer._isActiveAction(this);
            }
        },
        {
            /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "startAt",
            value: function startAt(time) {
                this._startTime = time;
                return this;
            }
        },
        {
            /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "setLoop",
            value: function setLoop(mode, repetitions) {
                this.loop = mode;
                this.repetitions = repetitions;
                return this;
            }
        },
        {
            /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "setEffectiveWeight",
            value: function setEffectiveWeight(weight) {
                this.weight = weight;
                // note: same logic as when updated at runtime
                this._effectiveWeight = this.enabled ? weight : 0;
                return this.stopFading();
            }
        },
        {
            /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ key: "getEffectiveWeight",
            value: function getEffectiveWeight() {
                return this._effectiveWeight;
            }
        },
        {
            /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "fadeIn",
            value: function fadeIn(duration) {
                return this._scheduleFading(duration, 0, 1);
            }
        },
        {
            /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "fadeOut",
            value: function fadeOut(duration) {
                return this._scheduleFading(duration, 1, 0);
            }
        },
        {
            /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "crossFadeFrom",
            value: function crossFadeFrom(fadeOutAction, duration) {
                var warp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                fadeOutAction.fadeOut(duration);
                this.fadeIn(duration);
                if (warp === true) {
                    var fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
                    fadeOutAction.warp(1.0, startEndRatio, duration);
                    this.warp(endStartRatio, 1.0, duration);
                }
                return this;
            }
        },
        {
            /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "crossFadeTo",
            value: function crossFadeTo(fadeInAction, duration) {
                var warp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return fadeInAction.crossFadeFrom(this, duration, warp);
            }
        },
        {
            /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "stopFading",
            value: function stopFading() {
                var weightInterpolant = this._weightInterpolant;
                if (weightInterpolant !== null) {
                    this._weightInterpolant = null;
                    this._mixer._takeBackControlInterpolant(weightInterpolant);
                }
                return this;
            }
        },
        {
            /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "setEffectiveTimeScale",
            value: function setEffectiveTimeScale(timeScale) {
                this.timeScale = timeScale;
                this._effectiveTimeScale = this.paused ? 0 : timeScale;
                return this.stopWarping();
            }
        },
        {
            /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ key: "getEffectiveTimeScale",
            value: function getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
        },
        {
            /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "setDuration",
            value: function setDuration(duration) {
                this.timeScale = this._clip.duration / duration;
                return this.stopWarping();
            }
        },
        {
            /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "syncWith",
            value: function syncWith(action) {
                this.time = action.time;
                this.timeScale = action.timeScale;
                return this.stopWarping();
            }
        },
        {
            /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "halt",
            value: function halt(duration) {
                return this.warp(this._effectiveTimeScale, 0, duration);
            }
        },
        {
            /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "warp",
            value: function warp(startTimeScale, endTimeScale, duration) {
                var mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
                var interpolant = this._timeScaleInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._timeScaleInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                times[1] = now + duration;
                values[0] = startTimeScale / timeScale;
                values[1] = endTimeScale / timeScale;
                return this;
            }
        },
        {
            /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ key: "stopWarping",
            value: function stopWarping() {
                var timeScaleInterpolant = this._timeScaleInterpolant;
                if (timeScaleInterpolant !== null) {
                    this._timeScaleInterpolant = null;
                    this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
                }
                return this;
            }
        },
        {
            /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ key: "getMixer",
            value: function getMixer() {
                return this._mixer;
            }
        },
        {
            /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ key: "getClip",
            value: function getClip() {
                return this._clip;
            }
        },
        {
            /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ key: "getRoot",
            value: function getRoot() {
                return this._localRoot || this._mixer._root;
            }
        },
        {
            // Interna
            key: "_update",
            value: function _update(time, deltaTime, timeDirection, accuIndex) {
                // called by the mixer
                if (!this.enabled) {
                    // call ._updateWeight() to update ._effectiveWeight
                    this._updateWeight(time);
                    return;
                }
                var startTime = this._startTime;
                if (startTime !== null) {
                    // check for scheduled start of action
                    var timeRunning = (time - startTime) * timeDirection;
                    if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
                    else {
                        this._startTime = null; // unschedule
                        deltaTime = timeDirection * timeRunning;
                    }
                }
                // apply time scale and advance time
                deltaTime *= this._updateTimeScale(time);
                var clipTime = this._updateTime(deltaTime);
                // note: _updateTime may disable the action resulting in
                // an effective weight of 0
                var weight = this._updateWeight(time);
                if (weight > 0) {
                    var interpolants = this._interpolants;
                    var propertyMixers = this._propertyBindings;
                    switch(this.blendMode){
                        case $a1724dcfba0d6d9a$export$d875e029ef558d3:
                            for(var j = 0, m = interpolants.length; j !== m; ++j){
                                interpolants[j].evaluate(clipTime);
                                propertyMixers[j].accumulateAdditive(weight);
                            }
                            break;
                        case $a1724dcfba0d6d9a$export$bcfbbdcf8de7f8cd:
                        default:
                            for(var j1 = 0, m1 = interpolants.length; j1 !== m1; ++j1){
                                interpolants[j1].evaluate(clipTime);
                                propertyMixers[j1].accumulate(accuIndex, weight);
                            }
                    }
                }
            }
        },
        {
            key: "_updateWeight",
            value: function _updateWeight(time) {
                var weight = 0;
                if (this.enabled) {
                    weight = this.weight;
                    var interpolant = this._weightInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        weight *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopFading();
                            if (interpolantValue === 0) // faded out, disable
                            this.enabled = false;
                        }
                    }
                }
                this._effectiveWeight = weight;
                return weight;
            }
        },
        {
            key: "_updateTimeScale",
            value: function _updateTimeScale(time) {
                var timeScale = 0;
                if (!this.paused) {
                    timeScale = this.timeScale;
                    var interpolant = this._timeScaleInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        timeScale *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopWarping();
                            if (timeScale === 0) // motion has halted, pause
                            this.paused = true;
                            else // warp done - apply final time scale
                            this.timeScale = timeScale;
                        }
                    }
                }
                this._effectiveTimeScale = timeScale;
                return timeScale;
            }
        },
        {
            key: "_updateTime",
            value: function _updateTime(deltaTime) {
                var duration = this._clip.duration;
                var loop = this.loop;
                var time = this.time + deltaTime;
                var loopCount = this._loopCount;
                var pingPong = loop === $a1724dcfba0d6d9a$export$f8f6f2041b78e210;
                if (deltaTime === 0) {
                    if (loopCount === -1) return time;
                    return pingPong && (loopCount & 1) === 1 ? duration - time : time;
                }
                if (loop === $a1724dcfba0d6d9a$export$d62fdc9d1b1cccad) {
                    if (loopCount === -1) {
                        // just started
                        this._loopCount = 0;
                        this._setEndings(true, true, false);
                    }
                    handle_stop: {
                        if (time >= duration) time = duration;
                        else if (time < 0) time = 0;
                        else {
                            this.time = time;
                            break handle_stop;
                        }
                        if (this.clampWhenFinished) this.paused = true;
                        else this.enabled = false;
                        this.time = time;
                        this._mixer.dispatchEvent({
                            type: 'finished',
                            action: this,
                            direction: deltaTime < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (loopCount === -1) {
                        // just started
                        if (deltaTime >= 0) {
                            loopCount = 0;
                            this._setEndings(true, this.repetitions === 0, pingPong);
                        } else // when looping in reverse direction, the initial
                        // transition through zero counts as a repetition,
                        // so leave loopCount at -1
                        this._setEndings(this.repetitions === 0, true, pingPong);
                    }
                    if (time >= duration || time < 0) {
                        // wrap around
                        var loopDelta = Math.floor(time / duration); // signed
                        time -= duration * loopDelta;
                        loopCount += Math.abs(loopDelta);
                        var pending = this.repetitions - loopCount;
                        if (pending <= 0) {
                            // have to stop (switch state, clamp time, fire event)
                            if (this.clampWhenFinished) this.paused = true;
                            else this.enabled = false;
                            time = deltaTime > 0 ? duration : 0;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'finished',
                                action: this,
                                direction: deltaTime > 0 ? 1 : -1
                            });
                        } else {
                            // keep running
                            if (pending === 1) {
                                // entering the last round
                                var atStart = deltaTime < 0;
                                this._setEndings(atStart, !atStart, pingPong);
                            } else this._setEndings(false, false, pingPong);
                            this._loopCount = loopCount;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'loop',
                                action: this,
                                loopDelta: loopDelta
                            });
                        }
                    } else this.time = time;
                    if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
                    return duration - time;
                }
                return time;
            }
        },
        {
            key: "_setEndings",
            value: function _setEndings(atStart, atEnd, pingPong) {
                var settings = this._interpolantSettings;
                if (pingPong) {
                    settings.endingStart = $a1724dcfba0d6d9a$export$24a4ccb5099273b5;
                    settings.endingEnd = $a1724dcfba0d6d9a$export$24a4ccb5099273b5;
                } else {
                    // assuming for LoopOnce atStart == atEnd == true
                    if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $a1724dcfba0d6d9a$export$24a4ccb5099273b5 : $a1724dcfba0d6d9a$export$7f795934b84ab523;
                    else settings.endingStart = $a1724dcfba0d6d9a$export$8e8c3ecdcd8e1fee;
                    if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $a1724dcfba0d6d9a$export$24a4ccb5099273b5 : $a1724dcfba0d6d9a$export$7f795934b84ab523;
                    else settings.endingEnd = $a1724dcfba0d6d9a$export$8e8c3ecdcd8e1fee;
                }
            }
        },
        {
            key: "_scheduleFading",
            value: function _scheduleFading(duration, weightNow, weightThen) {
                var mixer = this._mixer, now = mixer.time;
                var interpolant = this._weightInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._weightInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                values[0] = weightNow;
                times[1] = now + duration;
                values[1] = weightThen;
                return this;
            }
        }
    ]);
    return AnimationAction;
}();
var $a1724dcfba0d6d9a$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ var $a1724dcfba0d6d9a$export$fbd77e5aefaa0102 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(AnimationMixer, EventDispatcher);
    function AnimationMixer(root) {
        (0, $jGAMp._)(this, AnimationMixer);
        var _this;
        _this = (0, $kzDuW._)(this, AnimationMixer);
        _this._root = root;
        _this._initMemoryManager();
        _this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ _this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.timeScale = 1.0;
        return _this;
    }
    (0, $byiyg._)(AnimationMixer, [
        {
            key: "_bindAction",
            value: function _bindAction(action, prototypeAction) {
                var root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
                var bindingsByName = bindingsByRoot[rootUuid];
                if (bindingsByName === undefined) {
                    bindingsByName = {};
                    bindingsByRoot[rootUuid] = bindingsByName;
                }
                for(var i = 0; i !== nTracks; ++i){
                    var track = tracks[i], trackName = track.name;
                    var binding = bindingsByName[trackName];
                    if (binding !== undefined) {
                        ++binding.referenceCount;
                        bindings[i] = binding;
                    } else {
                        binding = bindings[i];
                        if (binding !== undefined) {
                            // existing binding, make sure the cache knows
                            if (binding._cacheIndex === null) {
                                ++binding.referenceCount;
                                this._addInactiveBinding(binding, rootUuid, trackName);
                            }
                            continue;
                        }
                        var path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                        binding = new $a1724dcfba0d6d9a$export$dfe0af1ca1acb78a($a1724dcfba0d6d9a$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                        bindings[i] = binding;
                    }
                    interpolants[i].resultBuffer = binding.buffer;
                }
            }
        },
        {
            key: "_activateAction",
            value: function _activateAction(action) {
                if (!this._isActiveAction(action)) {
                    if (action._cacheIndex === null) {
                        // this action has been forgotten by the cache, but the user
                        // appears to be still using it -> rebind
                        var rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                        this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                        this._addInactiveAction(action, clipUuid, rootUuid);
                    }
                    var bindings = action._propertyBindings;
                    // increment reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (binding.useCount++ === 0) {
                            this._lendBinding(binding);
                            binding.saveOriginalState();
                        }
                    }
                    this._lendAction(action);
                }
            }
        },
        {
            key: "_deactivateAction",
            value: function _deactivateAction(action) {
                if (this._isActiveAction(action)) {
                    var bindings = action._propertyBindings;
                    // decrement reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (--binding.useCount === 0) {
                            binding.restoreOriginalState();
                            this._takeBackBinding(binding);
                        }
                    }
                    this._takeBackAction(action);
                }
            }
        },
        {
            // Memory manager
            key: "_initMemoryManager",
            value: function _initMemoryManager() {
                this._actions = []; // 'nActiveActions' followed by inactive ones
                this._nActiveActions = 0;
                this._actionsByClip = {};
                // inside:
                // {
                // 	knownActions: Array< AnimationAction > - used as prototypes
                // 	actionByRoot: AnimationAction - lookup
                // }
                this._bindings = []; // 'nActiveBindings' followed by inactive ones
                this._nActiveBindings = 0;
                this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
                this._controlInterpolants = []; // same game as above
                this._nActiveControlInterpolants = 0;
                var scope = this;
                this.stats = {
                    actions: {
                        get total () {
                            return scope._actions.length;
                        },
                        get inUse () {
                            return scope._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return scope._bindings.length;
                        },
                        get inUse () {
                            return scope._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return scope._controlInterpolants.length;
                        },
                        get inUse () {
                            return scope._nActiveControlInterpolants;
                        }
                    }
                };
            }
        },
        {
            // Memory management for AnimationAction objects
            key: "_isActiveAction",
            value: function _isActiveAction(action) {
                var index = action._cacheIndex;
                return index !== null && index < this._nActiveActions;
            }
        },
        {
            key: "_addInactiveAction",
            value: function _addInactiveAction(action, clipUuid, rootUuid) {
                var actions = this._actions, actionsByClip = this._actionsByClip;
                var actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip === undefined) {
                    actionsForClip = {
                        knownActions: [
                            action
                        ],
                        actionByRoot: {}
                    };
                    action._byClipCacheIndex = 0;
                    actionsByClip[clipUuid] = actionsForClip;
                } else {
                    var knownActions = actionsForClip.knownActions;
                    action._byClipCacheIndex = knownActions.length;
                    knownActions.push(action);
                }
                action._cacheIndex = actions.length;
                actions.push(action);
                actionsForClip.actionByRoot[rootUuid] = action;
            }
        },
        {
            key: "_removeInactiveAction",
            value: function _removeInactiveAction(action) {
                var actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                action._cacheIndex = null;
                var clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
                lastKnownAction._byClipCacheIndex = byClipCacheIndex;
                knownActionsForClip[byClipCacheIndex] = lastKnownAction;
                knownActionsForClip.pop();
                action._byClipCacheIndex = null;
                var actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
                delete actionByRoot[rootUuid];
                if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
                this._removeInactiveBindingsForAction(action);
            }
        },
        {
            key: "_removeInactiveBindingsForAction",
            value: function _removeInactiveBindingsForAction(action) {
                var bindings = action._propertyBindings;
                for(var i = 0, n = bindings.length; i !== n; ++i){
                    var binding = bindings[i];
                    if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
                }
            }
        },
        {
            key: "_lendAction",
            value: function _lendAction(action) {
                // [ active actions |  inactive actions  ]
                // [  active actions >| inactive actions ]
                //                 s        a
                //                  <-swap->
                //                 a        s
                var actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
                action._cacheIndex = lastActiveIndex;
                actions[lastActiveIndex] = action;
                firstInactiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = firstInactiveAction;
            }
        },
        {
            key: "_takeBackAction",
            value: function _takeBackAction(action) {
                // [  active actions  | inactive actions ]
                // [ active actions |< inactive actions  ]
                //        a        s
                //         <-swap->
                //        s        a
                var actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
                action._cacheIndex = firstInactiveIndex;
                actions[firstInactiveIndex] = action;
                lastActiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = lastActiveAction;
            }
        },
        {
            // Memory management for PropertyMixer objects
            key: "_addInactiveBinding",
            value: function _addInactiveBinding(binding, rootUuid, trackName) {
                var bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
                var bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName === undefined) {
                    bindingByName = {};
                    bindingsByRoot[rootUuid] = bindingByName;
                }
                bindingByName[trackName] = binding;
                binding._cacheIndex = bindings.length;
                bindings.push(binding);
            }
        },
        {
            key: "_removeInactiveBinding",
            value: function _removeInactiveBinding(binding) {
                var bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
                lastInactiveBinding._cacheIndex = cacheIndex;
                bindings[cacheIndex] = lastInactiveBinding;
                bindings.pop();
                delete bindingByName[trackName];
                if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
            }
        },
        {
            key: "_lendBinding",
            value: function _lendBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
                binding._cacheIndex = lastActiveIndex;
                bindings[lastActiveIndex] = binding;
                firstInactiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = firstInactiveBinding;
            }
        },
        {
            key: "_takeBackBinding",
            value: function _takeBackBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
                binding._cacheIndex = firstInactiveIndex;
                bindings[firstInactiveIndex] = binding;
                lastActiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = lastActiveBinding;
            }
        },
        {
            // Memory management of Interpolants for weight and time scale
            key: "_lendControlInterpolant",
            value: function _lendControlInterpolant() {
                var interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
                var interpolant = interpolants[lastActiveIndex];
                if (interpolant === undefined) {
                    interpolant = new $a1724dcfba0d6d9a$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $a1724dcfba0d6d9a$var$_controlInterpolantsResultBuffer);
                    interpolant.__cacheIndex = lastActiveIndex;
                    interpolants[lastActiveIndex] = interpolant;
                }
                return interpolant;
            }
        },
        {
            key: "_takeBackControlInterpolant",
            value: function _takeBackControlInterpolant(interpolant) {
                var interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
                interpolant.__cacheIndex = firstInactiveIndex;
                interpolants[firstInactiveIndex] = interpolant;
                lastActiveInterpolant.__cacheIndex = prevIndex;
                interpolants[prevIndex] = lastActiveInterpolant;
            }
        },
        {
            /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ key: "clipAction",
            value: function clipAction(clip, optionalRoot, blendMode) {
                var root = optionalRoot || this._root, rootUuid = root.uuid;
                var clipObject = typeof clip === 'string' ? $a1724dcfba0d6d9a$export$d942c706bf23829c.findByName(root, clip) : clip;
                var clipUuid = clipObject !== null ? clipObject.uuid : clip;
                var actionsForClip = this._actionsByClip[clipUuid];
                var prototypeAction = null;
                if (blendMode === undefined) {
                    if (clipObject !== null) blendMode = clipObject.blendMode;
                    else blendMode = $a1724dcfba0d6d9a$export$bcfbbdcf8de7f8cd;
                }
                if (actionsForClip !== undefined) {
                    var existingAction = actionsForClip.actionByRoot[rootUuid];
                    if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
                    // we know the clip, so we don't have to parse all
                    // the bindings again but can just copy
                    prototypeAction = actionsForClip.knownActions[0];
                    // also, take the clip from the prototype action
                    if (clipObject === null) clipObject = prototypeAction._clip;
                }
                // clip must be known when specified via string
                if (clipObject === null) return null;
                // allocate all resources required to run it
                var newAction = new $a1724dcfba0d6d9a$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
                this._bindAction(newAction, prototypeAction);
                // and make the action known to the memory manager
                this._addInactiveAction(newAction, clipUuid, rootUuid);
                return newAction;
            }
        },
        {
            /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ key: "existingAction",
            value: function existingAction(clip, optionalRoot) {
                var root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $a1724dcfba0d6d9a$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
                if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
                return null;
            }
        },
        {
            /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ key: "stopAllAction",
            value: function stopAllAction() {
                var actions = this._actions, nActions = this._nActiveActions;
                for(var i = nActions - 1; i >= 0; --i)actions[i].stop();
                return this;
            }
        },
        {
            /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ key: "update",
            value: function update(deltaTime) {
                deltaTime *= this.timeScale;
                var actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
                // run active actions
                for(var i = 0; i !== nActions; ++i){
                    var action = actions[i];
                    action._update(time, deltaTime, timeDirection, accuIndex);
                }
                // update scene graph
                var bindings = this._bindings, nBindings = this._nActiveBindings;
                for(var i1 = 0; i1 !== nBindings; ++i1)bindings[i1].apply(accuIndex);
                return this;
            }
        },
        {
            /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ key: "setTime",
            value: function setTime(time) {
                this.time = 0; // Zero out time attribute for AnimationMixer object;
                for(var i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
                return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
            }
        },
        {
            /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ key: "getRoot",
            value: function getRoot() {
                return this._root;
            }
        },
        {
            /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ key: "uncacheClip",
            value: function uncacheClip(clip) {
                var actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip !== undefined) {
                    // note: just calling _removeInactiveAction would mess up the
                    // iteration state and also require updating the state we can
                    // just throw away
                    var actionsToRemove = actionsForClip.knownActions;
                    for(var i = 0, n = actionsToRemove.length; i !== n; ++i){
                        var action = actionsToRemove[i];
                        this._deactivateAction(action);
                        var cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                        action._cacheIndex = null;
                        action._byClipCacheIndex = null;
                        lastInactiveAction._cacheIndex = cacheIndex;
                        actions[cacheIndex] = lastInactiveAction;
                        actions.pop();
                        this._removeInactiveBindingsForAction(action);
                    }
                    delete actionsByClip[clipUuid];
                }
            }
        },
        {
            /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ key: "uncacheRoot",
            value: function uncacheRoot(root) {
                var rootUuid = root.uuid, actionsByClip = this._actionsByClip;
                for(var clipUuid in actionsByClip){
                    var actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
                    if (action !== undefined) {
                        this._deactivateAction(action);
                        this._removeInactiveAction(action);
                    }
                }
                var bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName !== undefined) for(var trackName in bindingByName){
                    var binding = bindingByName[trackName];
                    binding.restoreOriginalState();
                    this._removeInactiveBinding(binding);
                }
            }
        },
        {
            /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ key: "uncacheAction",
            value: function uncacheAction(clip, optionalRoot) {
                var action = this.existingAction(clip, optionalRoot);
                if (action !== null) {
                    this._deactivateAction(action);
                    this._removeInactiveAction(action);
                }
            }
        }
    ]);
    return AnimationMixer;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ var $a1724dcfba0d6d9a$export$6b116d2fdfef087c = /*#__PURE__*/ function(RenderTarget) {
    "use strict";
    (0, $i3fW3._)(RenderTarget3D, RenderTarget);
    function RenderTarget3D() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $jGAMp._)(this, RenderTarget3D);
        var _this;
        _this = (0, $kzDuW._)(this, RenderTarget3D, [
            width,
            height,
            options
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isRenderTarget3D = true;
        _this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ _this.texture = new $a1724dcfba0d6d9a$export$d7a3086320f856db(null, width, height, depth);
        _this._setTextureOptions(options);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return RenderTarget3D;
}($a1724dcfba0d6d9a$export$efcb1f8bf367cbfb);
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ var $a1724dcfba0d6d9a$export$2947cebfe91c02f8 = /*#__PURE__*/ function() {
    "use strict";
    function Uniform(value) {
        (0, $jGAMp._)(this, Uniform);
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    (0, $byiyg._)(Uniform, [
        {
            /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
            }
        }
    ]);
    return Uniform;
}();
var $a1724dcfba0d6d9a$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$c412d5ffe1f79209 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(UniformsGroup, EventDispatcher);
    function UniformsGroup() {
        (0, $jGAMp._)(this, UniformsGroup);
        var _this;
        _this = (0, $kzDuW._)(this, UniformsGroup);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(_this, 'id', {
            value: $a1724dcfba0d6d9a$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ _this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ _this.usage = $a1724dcfba0d6d9a$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ _this.uniforms = [];
        return _this;
    }
    (0, $byiyg._)(UniformsGroup, [
        {
            /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ key: "add",
            value: function add(uniform) {
                this.uniforms.push(uniform);
                return this;
            }
        },
        {
            /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ key: "remove",
            value: function remove(uniform) {
                var index = this.uniforms.indexOf(uniform);
                if (index !== -1) this.uniforms.splice(index, 1);
                return this;
            }
        },
        {
            /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ key: "setName",
            value: function setName(name) {
                this.name = name;
                return this;
            }
        },
        {
            /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.usage = source.usage;
                var uniformsSource = source.uniforms;
                this.uniforms.length = 0;
                for(var i = 0, l = uniformsSource.length; i < l; i++){
                    var uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                        uniformsSource[i]
                    ];
                    for(var j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
                }
                return this;
            }
        },
        {
            /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return UniformsGroup;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ var $a1724dcfba0d6d9a$export$25ec0e1af1389358 = /*#__PURE__*/ function(InterleavedBuffer) {
    "use strict";
    (0, $i3fW3._)(InstancedInterleavedBuffer, InterleavedBuffer);
    function InstancedInterleavedBuffer(array, stride) {
        var meshPerAttribute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        (0, $jGAMp._)(this, InstancedInterleavedBuffer);
        var _this;
        _this = (0, $kzDuW._)(this, InstancedInterleavedBuffer, [
            array,
            stride
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $byiyg._)(InstancedInterleavedBuffer, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(InstancedInterleavedBuffer.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                var ib = (0, $fXhL4._)((0, $hxFDX._)(InstancedInterleavedBuffer.prototype), "clone", this).call(this, data);
                ib.meshPerAttribute = this.meshPerAttribute;
                return ib;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                var json = (0, $fXhL4._)((0, $hxFDX._)(InstancedInterleavedBuffer.prototype), "toJSON", this).call(this, data);
                json.isInstancedInterleavedBuffer = true;
                json.meshPerAttribute = this.meshPerAttribute;
                return json;
            }
        }
    ]);
    return InstancedInterleavedBuffer;
}($a1724dcfba0d6d9a$export$3d5cd879f108f53f);
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ var $a1724dcfba0d6d9a$export$6b7339ae8dbddf73 = /*#__PURE__*/ function() {
    "use strict";
    function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
        var normalized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $jGAMp._)(this, GLBufferAttribute);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    (0, $byiyg._)(GLBufferAttribute, [
        {
            key: "needsUpdate",
            set: /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setBuffer",
            value: function setBuffer(buffer) {
                this.buffer = buffer;
                return this;
            }
        },
        {
            /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setType",
            value: function setType(type, elementSize) {
                this.type = type;
                this.elementSize = elementSize;
                return this;
            }
        },
        {
            /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setItemSize",
            value: function setItemSize(itemSize) {
                this.itemSize = itemSize;
                return this;
            }
        },
        {
            /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ key: "setCount",
            value: function setCount(count) {
                this.count = count;
                return this;
            }
        }
    ]);
    return GLBufferAttribute;
}();
var $a1724dcfba0d6d9a$var$_matrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ var $a1724dcfba0d6d9a$export$8b7aaceff00bd2f = /*#__PURE__*/ function() {
    "use strict";
    function Raycaster(origin, direction) {
        var near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
        (0, $jGAMp._)(this, Raycaster);
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $a1724dcfba0d6d9a$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $a1724dcfba0d6d9a$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    (0, $byiyg._)(Raycaster, [
        {
            /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ key: "set",
            value: function set(origin, direction) {
                // direction is assumed to be normalized (for accurate distance calculations)
                this.ray.set(origin, direction);
            }
        },
        {
            /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ key: "setFromCamera",
            value: function setFromCamera(coords, camera) {
                if (camera.isPerspectiveCamera) {
                    this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
                    this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
                    this.camera = camera;
                } else if (camera.isOrthographicCamera) {
                    this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
                    this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
                    this.camera = camera;
                } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
            }
        },
        {
            /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ key: "setFromXRController",
            value: function setFromXRController(controller) {
                $a1724dcfba0d6d9a$var$_matrix.identity().extractRotation(controller.matrixWorld);
                this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
                this.ray.direction.set(0, 0, -1).applyMatrix4($a1724dcfba0d6d9a$var$_matrix);
                return this;
            }
        },
        {
            /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ key: "intersectObject",
            value: function intersectObject(object) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                $a1724dcfba0d6d9a$var$intersect(object, this, intersects, recursive);
                intersects.sort($a1724dcfba0d6d9a$var$ascSort);
                return intersects;
            }
        },
        {
            /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ key: "intersectObjects",
            value: function intersectObjects(objects) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                for(var i = 0, l = objects.length; i < l; i++)$a1724dcfba0d6d9a$var$intersect(objects[i], this, intersects, recursive);
                intersects.sort($a1724dcfba0d6d9a$var$ascSort);
                return intersects;
            }
        }
    ]);
    return Raycaster;
}();
function $a1724dcfba0d6d9a$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $a1724dcfba0d6d9a$var$intersect(object, raycaster, intersects, recursive) {
    var propagate = true;
    if (object.layers.test(raycaster.layers)) {
        var result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)$a1724dcfba0d6d9a$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates]{@link https://en.wikipedia.org/wiki/Spherical_coordinate_system}.
 */ var $a1724dcfba0d6d9a$export$d712cd887b4a00f7 = /*#__PURE__*/ function() {
    "use strict";
    function Spherical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, phi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, theta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $jGAMp._)(this, Spherical);
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    (0, $byiyg._)(Spherical, [
        {
            /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ key: "set",
            value: function set(radius, phi, theta) {
                this.radius = radius;
                this.phi = phi;
                this.theta = theta;
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.phi = other.phi;
                this.theta = other.theta;
                return this;
            }
        },
        {
            /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ key: "makeSafe",
            value: function makeSafe() {
                var EPS = 0.000001;
                this.phi = $a1724dcfba0d6d9a$var$clamp(this.phi, EPS, Math.PI - EPS);
                return this;
            }
        },
        {
            /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Spherical} A reference to this spherical.
	 */ key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + y * y + z * z);
                if (this.radius === 0) {
                    this.theta = 0;
                    this.phi = 0;
                } else {
                    this.theta = Math.atan2(x, z);
                    this.phi = Math.acos($a1724dcfba0d6d9a$var$clamp(y / this.radius, -1, 1));
                }
                return this;
            }
        },
        {
            /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Spherical;
}();
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates]{@link https://en.wikipedia.org/wiki/Cylindrical_coordinate_system}.
 */ var $a1724dcfba0d6d9a$export$287165bb2177f4fd = /*#__PURE__*/ function() {
    "use strict";
    function Cylindrical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, theta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $jGAMp._)(this, Cylindrical);
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    (0, $byiyg._)(Cylindrical, [
        {
            /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ key: "set",
            value: function set(radius, theta, y) {
                this.radius = radius;
                this.theta = theta;
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.theta = other.theta;
                this.y = other.y;
                return this;
            }
        },
        {
            /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + z * z);
                this.theta = Math.atan2(x, z);
                this.y = y;
                return this;
            }
        },
        {
            /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Cylindrical;
}();
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ var $a1724dcfba0d6d9a$export$cbcc6560bf79fb38 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix2(n11, n12, n21, n22) {
        (0, $jGAMp._)(this, Matrix2);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix2.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    (0, $byiyg._)(Matrix2, [
        {
            /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 1);
                return this;
            }
        },
        {
            /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 4; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ key: "set",
            value: function set(n11, n12, n21, n22) {
                var te = this.elements;
                te[0] = n11;
                te[2] = n12;
                te[1] = n21;
                te[3] = n22;
                return this;
            }
        }
    ]);
    return Matrix2;
}();
var $a1724dcfba0d6d9a$var$_vector$4 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ var $a1724dcfba0d6d9a$export$60f553fa130f08b0 = /*#__PURE__*/ function() {
    "use strict";
    function Box2() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$c977b3e384af9ae1(-Infinity, -Infinity);
        (0, $jGAMp._)(this, Box2);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    (0, $byiyg._)(Box2, [
        {
            /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $a1724dcfba0d6d9a$var$_vector$4.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = Infinity;
                this.max.x = this.max.y = -Infinity;
                return this;
            }
        },
        {
            /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
        },
        {
            /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ key: "containsPoint",
            value: function containsPoint(point) {
                return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
            }
        },
        {
            /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
            }
        },
        {
            /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
            }
        },
        {
            /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 4 splitting planes to rule out intersections
                return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
            }
        },
        {
            /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.clampPoint(point, $a1724dcfba0d6d9a$var$_vector$4).distanceTo(point);
            }
        },
        {
            /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                if (this.isEmpty()) this.makeEmpty();
                return this;
            }
        },
        {
            /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        }
    ]);
    return Box2;
}();
var $a1724dcfba0d6d9a$var$_startP = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_startEnd = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ var $a1724dcfba0d6d9a$export$e0ba6359f1954fd3 = /*#__PURE__*/ function() {
    "use strict";
    function Line3() {
        var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(), end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699();
        (0, $jGAMp._)(this, Line3);
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    (0, $byiyg._)(Line3, [
        {
            /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ key: "set",
            value: function set(start, end) {
                this.start.copy(start);
                this.end.copy(end);
                return this;
            }
        },
        {
            /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ key: "copy",
            value: function copy(line) {
                this.start.copy(line.start);
                this.end.copy(line.end);
                return this;
            }
        },
        {
            /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ key: "getCenter",
            value: function getCenter(target) {
                return target.addVectors(this.start, this.end).multiplyScalar(0.5);
            }
        },
        {
            /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ key: "delta",
            value: function delta(target) {
                return target.subVectors(this.end, this.start);
            }
        },
        {
            /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ key: "distanceSq",
            value: function distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
        },
        {
            /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ key: "distance",
            value: function distance() {
                return this.start.distanceTo(this.end);
            }
        },
        {
            /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ key: "at",
            value: function at(t, target) {
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ key: "closestPointToPointParameter",
            value: function closestPointToPointParameter(point, clampToLine) {
                $a1724dcfba0d6d9a$var$_startP.subVectors(point, this.start);
                $a1724dcfba0d6d9a$var$_startEnd.subVectors(this.end, this.start);
                var startEnd2 = $a1724dcfba0d6d9a$var$_startEnd.dot($a1724dcfba0d6d9a$var$_startEnd);
                var startEnd_startP = $a1724dcfba0d6d9a$var$_startEnd.dot($a1724dcfba0d6d9a$var$_startP);
                var t = startEnd_startP / startEnd2;
                if (clampToLine) t = $a1724dcfba0d6d9a$var$clamp(t, 0, 1);
                return t;
            }
        },
        {
            /**
	 * Returns the closets point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target -  The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ key: "closestPointToPoint",
            value: function closestPointToPoint(point, clampToLine, target) {
                var t = this.closestPointToPointParameter(point, clampToLine);
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.start.applyMatrix4(matrix);
                this.end.applyMatrix4(matrix);
                return this;
            }
        },
        {
            /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ key: "equals",
            value: function equals(line) {
                return line.start.equals(this.start) && line.end.equals(this.end);
            }
        },
        {
            /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Line3;
}();
var $a1724dcfba0d6d9a$var$_vector$3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$4b14638ffdd81e68 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(SpotLightHelper, Object3D);
    function SpotLightHelper(light, color) {
        (0, $jGAMp._)(this, SpotLightHelper);
        var _this;
        _this = (0, $kzDuW._)(this, SpotLightHelper);
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ _this.light = light;
        _this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ _this.color = color;
        _this.type = 'SpotLightHelper';
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        var positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(var i = 0, j = 1, l = 32; i < l; i++, j++){
            var p1 = i / l * Math.PI * 2;
            var p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(positions, 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        _this.cone = new $a1724dcfba0d6d9a$export$ff1ed10fedfdd604(geometry, material);
        _this.add(_this.cone);
        _this.update();
        return _this;
    }
    (0, $byiyg._)(SpotLightHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.cone.geometry.dispose();
                this.cone.material.dispose();
            }
        },
        {
            /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                // update the local matrix based on the parent and light target transforms
                if (this.parent) {
                    this.parent.updateWorldMatrix(true);
                    this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
                } else this.matrix.copy(this.light.matrixWorld);
                this.matrixWorld.copy(this.light.matrixWorld);
                var coneLength = this.light.distance ? this.light.distance : 1000;
                var coneWidth = coneLength * Math.tan(this.light.angle);
                this.cone.scale.set(coneWidth, coneWidth, coneLength);
                $a1724dcfba0d6d9a$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
                this.cone.lookAt($a1724dcfba0d6d9a$var$_vector$3);
                if (this.color !== undefined) this.cone.material.color.set(this.color);
                else this.cone.material.color.copy(this.light.color);
            }
        }
    ]);
    return SpotLightHelper;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_vector$2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_boneMatrix = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
var $a1724dcfba0d6d9a$var$_matrixWorldInv = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$5277df3c9e732259 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(SkeletonHelper, LineSegments);
    function SkeletonHelper(object) {
        (0, $jGAMp._)(this, SkeletonHelper);
        var _this;
        var bones = $a1724dcfba0d6d9a$var$getBoneList(object);
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        var vertices = [];
        var colors = [];
        var color1 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0, 0, 1);
        var color2 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0, 1, 0);
        for(var i = 0; i < bones.length; i++){
            var bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(colors, 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        _this = (0, $kzDuW._)(this, SkeletonHelper, [
            geometry,
            material
        ]);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isSkeletonHelper = true;
        _this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ _this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ _this.bones = bones;
        _this.matrix = object.matrixWorld;
        _this.matrixAutoUpdate = false;
        return _this;
    }
    (0, $byiyg._)(SkeletonHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var bones = this.bones;
                var geometry = this.geometry;
                var position = geometry.getAttribute('position');
                $a1724dcfba0d6d9a$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
                for(var i = 0, j = 0; i < bones.length; i++){
                    var bone = bones[i];
                    if (bone.parent && bone.parent.isBone) {
                        $a1724dcfba0d6d9a$var$_boneMatrix.multiplyMatrices($a1724dcfba0d6d9a$var$_matrixWorldInv, bone.matrixWorld);
                        $a1724dcfba0d6d9a$var$_vector$2.setFromMatrixPosition($a1724dcfba0d6d9a$var$_boneMatrix);
                        position.setXYZ(j, $a1724dcfba0d6d9a$var$_vector$2.x, $a1724dcfba0d6d9a$var$_vector$2.y, $a1724dcfba0d6d9a$var$_vector$2.z);
                        $a1724dcfba0d6d9a$var$_boneMatrix.multiplyMatrices($a1724dcfba0d6d9a$var$_matrixWorldInv, bone.parent.matrixWorld);
                        $a1724dcfba0d6d9a$var$_vector$2.setFromMatrixPosition($a1724dcfba0d6d9a$var$_boneMatrix);
                        position.setXYZ(j + 1, $a1724dcfba0d6d9a$var$_vector$2.x, $a1724dcfba0d6d9a$var$_vector$2.y, $a1724dcfba0d6d9a$var$_vector$2.z);
                        j += 2;
                    }
                }
                geometry.getAttribute('position').needsUpdate = true;
                (0, $fXhL4._)((0, $hxFDX._)(SkeletonHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return SkeletonHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
function $a1724dcfba0d6d9a$var$getBoneList(object) {
    var _boneList;
    var boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(var i = 0; i < object.children.length; i++)(_boneList = boneList).push.apply(_boneList, (0, $7WNf6._)($a1724dcfba0d6d9a$var$getBoneList(object.children[i])));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ var $a1724dcfba0d6d9a$export$9a9291685b9e4023 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $i3fW3._)(PointLightHelper, Mesh);
    function PointLightHelper(light, sphereSize, color) {
        (0, $jGAMp._)(this, PointLightHelper);
        var _this;
        var geometry = new $a1724dcfba0d6d9a$export$1b417fc3b307a251(sphereSize, 4, 2);
        var material = new $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        _this = (0, $kzDuW._)(this, PointLightHelper, [
            geometry,
            material
        ]);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ _this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ _this.color = color;
        _this.type = 'PointLightHelper';
        _this.matrix = _this.light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $byiyg._)(PointLightHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        },
        {
            /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                if (this.color !== undefined) this.material.color.set(this.color);
                else this.material.color.copy(this.light.color);
            /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
        }
    ]);
    return PointLightHelper;
}($a1724dcfba0d6d9a$export$e176487c05830cc5);
var $a1724dcfba0d6d9a$var$_vector$1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_color1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$892596cec99bc70e();
var $a1724dcfba0d6d9a$var$_color2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$8dca15f13f4f8172 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(HemisphereLightHelper, Object3D);
    function HemisphereLightHelper(light, size, color) {
        (0, $jGAMp._)(this, HemisphereLightHelper);
        var _this;
        _this = (0, $kzDuW._)(this, HemisphereLightHelper);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ _this.light = light;
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ _this.color = color;
        _this.type = 'HemisphereLightHelper';
        var geometry = new $a1724dcfba0d6d9a$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        _this.material = new $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (_this.color === undefined) _this.material.vertexColors = true;
        var position = geometry.getAttribute('position');
        var colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$8dea267bd6bde117(colors, 3));
        _this.add(new $a1724dcfba0d6d9a$export$e176487c05830cc5(geometry, _this.material));
        _this.update();
        return _this;
    }
    (0, $byiyg._)(HemisphereLightHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
            }
        },
        {
            /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ key: "update",
            value: function update() {
                var mesh = this.children[0];
                if (this.color !== undefined) this.material.color.set(this.color);
                else {
                    var colors = mesh.geometry.getAttribute('color');
                    $a1724dcfba0d6d9a$var$_color1.copy(this.light.color);
                    $a1724dcfba0d6d9a$var$_color2.copy(this.light.groundColor);
                    for(var i = 0, l = colors.count; i < l; i++){
                        var color = i < l / 2 ? $a1724dcfba0d6d9a$var$_color1 : $a1724dcfba0d6d9a$var$_color2;
                        colors.setXYZ(i, color.r, color.g, color.b);
                    }
                    colors.needsUpdate = true;
                }
                this.light.updateWorldMatrix(true, false);
                mesh.lookAt($a1724dcfba0d6d9a$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
    ]);
    return HemisphereLightHelper;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$3875d39926561055 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(GridHelper, LineSegments);
    function GridHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, divisions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, color1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0x444444, color2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0x888888;
        (0, $jGAMp._)(this, GridHelper);
        var _this;
        color1 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color1);
        color2 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color2);
        var center = divisions / 2;
        var step = size / divisions;
        var halfSize = size / 2;
        var vertices = [], colors = [];
        for(var i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            var color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(colors, 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $kzDuW._)(this, GridHelper, [
            geometry,
            material
        ]);
        _this.type = 'GridHelper';
        return _this;
    }
    (0, $byiyg._)(GridHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return GridHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$361430a10f533cd3 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(PolarGridHelper, LineSegments);
    function PolarGridHelper() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, sectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16, rings = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, divisions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 64, color1 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0x444444, color2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0x888888;
        (0, $jGAMp._)(this, PolarGridHelper);
        var _this;
        color1 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color1);
        color2 = new $a1724dcfba0d6d9a$export$892596cec99bc70e(color2);
        var vertices = [];
        var colors = [];
        // create the sectors
        if (sectors > 1) for(var i = 0; i < sectors; i++){
            var v = i / sectors * (Math.PI * 2);
            var x = Math.sin(v) * radius;
            var z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            var color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(var i1 = 0; i1 < rings; i1++){
            var color3 = i1 & 1 ? color1 : color2;
            var r = radius - radius / rings * i1;
            for(var j = 0; j < divisions; j++){
                // first vertex
                var v1 = j / divisions * (Math.PI * 2);
                var x1 = Math.sin(v1) * r;
                var z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
                // second vertex
                v1 = (j + 1) / divisions * (Math.PI * 2);
                x1 = Math.sin(v1) * r;
                z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
            }
        }
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(colors, 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $kzDuW._)(this, PolarGridHelper, [
            geometry,
            material
        ]);
        _this.type = 'PolarGridHelper';
        return _this;
    }
    (0, $byiyg._)(PolarGridHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return PolarGridHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
var $a1724dcfba0d6d9a$var$_v1 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v2 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_v3 = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$f8e434dc14203e7d = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(DirectionalLightHelper, Object3D);
    function DirectionalLightHelper(light, size, color) {
        (0, $jGAMp._)(this, DirectionalLightHelper);
        var _this;
        _this = (0, $kzDuW._)(this, DirectionalLightHelper);
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ _this.light = light;
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ _this.color = color;
        _this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ _this.lightPlane = new $a1724dcfba0d6d9a$export$17d680238e50603e(geometry, material);
        _this.add(_this.lightPlane);
        geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ _this.targetLine = new $a1724dcfba0d6d9a$export$17d680238e50603e(geometry, material);
        _this.add(_this.targetLine);
        _this.update();
        return _this;
    }
    (0, $byiyg._)(DirectionalLightHelper, [
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.lightPlane.geometry.dispose();
                this.lightPlane.material.dispose();
                this.targetLine.geometry.dispose();
                this.targetLine.material.dispose();
            }
        },
        {
            /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                $a1724dcfba0d6d9a$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
                $a1724dcfba0d6d9a$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
                $a1724dcfba0d6d9a$var$_v3.subVectors($a1724dcfba0d6d9a$var$_v2, $a1724dcfba0d6d9a$var$_v1);
                this.lightPlane.lookAt($a1724dcfba0d6d9a$var$_v2);
                if (this.color !== undefined) {
                    this.lightPlane.material.color.set(this.color);
                    this.targetLine.material.color.set(this.color);
                } else {
                    this.lightPlane.material.color.copy(this.light.color);
                    this.targetLine.material.color.copy(this.light.color);
                }
                this.targetLine.lookAt($a1724dcfba0d6d9a$var$_v2);
                this.targetLine.scale.z = $a1724dcfba0d6d9a$var$_v3.length();
            }
        }
    ]);
    return DirectionalLightHelper;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
var $a1724dcfba0d6d9a$var$_vector = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_camera = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example]{@link https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html}.
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$ed8e93f853cd795 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(CameraHelper, LineSegments);
    function CameraHelper(camera) {
        (0, $jGAMp._)(this, CameraHelper);
        var _this;
        var addLine = function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        };
        var addPoint = function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        };
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        var vertices = [];
        var colors = [];
        var pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(colors, 3));
        _this = (0, $kzDuW._)(this, CameraHelper, [
            geometry,
            material
        ]);
        _this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ _this.camera = camera;
        if (_this.camera.updateProjectionMatrix) _this.camera.updateProjectionMatrix();
        _this.matrix = camera.matrixWorld;
        _this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ _this.pointMap = pointMap;
        _this.update();
        // colors
        var colorFrustum = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffaa00);
        var colorCone = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xff0000);
        var colorUp = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x00aaff);
        var colorTarget = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0xffffff);
        var colorCross = new $a1724dcfba0d6d9a$export$892596cec99bc70e(0x333333);
        _this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
        return _this;
    }
    (0, $byiyg._)(CameraHelper, [
        {
            /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 */ key: "setColors",
            value: function setColors(frustum, cone, up, target, cross) {
                var geometry = this.geometry;
                var colorAttribute = geometry.getAttribute('color');
                // near
                colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
                colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
                colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
                colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
                // far
                colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
                colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
                colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
                colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
                // sides
                colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
                colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
                colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
                colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
                // cone
                colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
                colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
                colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
                colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
                // up
                colorAttribute.setXYZ(32, up.r, up.g, up.b);
                colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
                colorAttribute.setXYZ(34, up.r, up.g, up.b);
                colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
                colorAttribute.setXYZ(36, up.r, up.g, up.b);
                colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
                // target
                colorAttribute.setXYZ(38, target.r, target.g, target.b);
                colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
                colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
                // cross
                colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
                colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
                colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
                colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
                colorAttribute.needsUpdate = true;
            }
        },
        {
            /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ key: "update",
            value: function update() {
                var geometry = this.geometry;
                var pointMap = this.pointMap;
                var w = 1, h = 1;
                // we need just camera projection matrix inverse
                // world matrix must be identity
                $a1724dcfba0d6d9a$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
                // Adjust z values based on coordinate system
                var nearZ = this.camera.coordinateSystem === $a1724dcfba0d6d9a$export$5a0e9190d10875d3 ? -1 : 0;
                // center / target
                $a1724dcfba0d6d9a$var$setPoint('c', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, 0, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('t', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, 0, 1);
                // near
                $a1724dcfba0d6d9a$var$setPoint('n1', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, -h, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('n2', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, -h, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('n3', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, h, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('n4', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, h, nearZ);
                // far
                $a1724dcfba0d6d9a$var$setPoint('f1', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, -h, 1);
                $a1724dcfba0d6d9a$var$setPoint('f2', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, -h, 1);
                $a1724dcfba0d6d9a$var$setPoint('f3', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, h, 1);
                $a1724dcfba0d6d9a$var$setPoint('f4', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, h, 1);
                // up
                $a1724dcfba0d6d9a$var$setPoint('u1', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w * 0.7, h * 1.1, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('u2', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w * 0.7, h * 1.1, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('u3', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, h * 2, nearZ);
                // cross
                $a1724dcfba0d6d9a$var$setPoint('cf1', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, 0, 1);
                $a1724dcfba0d6d9a$var$setPoint('cf2', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, 0, 1);
                $a1724dcfba0d6d9a$var$setPoint('cf3', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, -h, 1);
                $a1724dcfba0d6d9a$var$setPoint('cf4', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, h, 1);
                $a1724dcfba0d6d9a$var$setPoint('cn1', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, -w, 0, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('cn2', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, w, 0, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('cn3', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, -h, nearZ);
                $a1724dcfba0d6d9a$var$setPoint('cn4', pointMap, geometry, $a1724dcfba0d6d9a$var$_camera, 0, h, nearZ);
                geometry.getAttribute('position').needsUpdate = true;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return CameraHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
function $a1724dcfba0d6d9a$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $a1724dcfba0d6d9a$var$_vector.set(x, y, z).unproject(camera);
    var points = pointMap[point];
    if (points !== undefined) {
        var position = geometry.getAttribute('position');
        for(var i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $a1724dcfba0d6d9a$var$_vector.x, $a1724dcfba0d6d9a$var$_vector.y, $a1724dcfba0d6d9a$var$_vector.z);
    }
}
var $a1724dcfba0d6d9a$var$_box = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$38a664cc862a6a9d = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(BoxHelper, LineSegments);
    function BoxHelper(object) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $jGAMp._)(this, BoxHelper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = new Float32Array(24);
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setIndex(new $a1724dcfba0d6d9a$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$8dea267bd6bde117(positions, 3));
        _this = (0, $kzDuW._)(this, BoxHelper, [
            geometry,
            new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ _this.object = object;
        _this.type = 'BoxHelper';
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $byiyg._)(BoxHelper, [
        {
            /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ key: "update",
            value: function update() {
                if (this.object !== undefined) $a1724dcfba0d6d9a$var$_box.setFromObject(this.object);
                if ($a1724dcfba0d6d9a$var$_box.isEmpty()) return;
                var min = $a1724dcfba0d6d9a$var$_box.min;
                var max = $a1724dcfba0d6d9a$var$_box.max;
                /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ var position = this.geometry.attributes.position;
                var array = position.array;
                array[0] = max.x;
                array[1] = max.y;
                array[2] = max.z;
                array[3] = min.x;
                array[4] = max.y;
                array[5] = max.z;
                array[6] = min.x;
                array[7] = min.y;
                array[8] = max.z;
                array[9] = max.x;
                array[10] = min.y;
                array[11] = max.z;
                array[12] = max.x;
                array[13] = max.y;
                array[14] = min.z;
                array[15] = min.x;
                array[16] = max.y;
                array[17] = min.z;
                array[18] = min.x;
                array[19] = min.y;
                array[20] = min.z;
                array[21] = max.x;
                array[22] = min.y;
                array[23] = min.z;
                position.needsUpdate = true;
                this.geometry.computeBoundingSphere();
            }
        },
        {
            /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ key: "setFromObject",
            value: function setFromObject(object) {
                this.object = object;
                this.update();
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(BoxHelper.prototype), "copy", this).call(this, source, recursive);
                this.object = source.object;
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return BoxHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$ce39f4bb96c9a290 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(Box3Helper, LineSegments);
    function Box3Helper(box) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $jGAMp._)(this, Box3Helper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setIndex(new $a1724dcfba0d6d9a$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(positions, 3));
        _this = (0, $kzDuW._)(this, Box3Helper, [
            geometry,
            new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ _this.box = box;
        _this.type = 'Box3Helper';
        _this.geometry.computeBoundingSphere();
        return _this;
    }
    (0, $byiyg._)(Box3Helper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var box = this.box;
                if (box.isEmpty()) return;
                box.getCenter(this.position);
                box.getSize(this.scale);
                this.scale.multiplyScalar(0.5);
                (0, $fXhL4._)((0, $hxFDX._)(Box3Helper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return Box3Helper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ var $a1724dcfba0d6d9a$export$a34fe8156c66e5d7 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $i3fW3._)(PlaneHelper, Line);
    function PlaneHelper(plane) {
        var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, hex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0xffff00;
        (0, $jGAMp._)(this, PlaneHelper);
        var _this;
        var color = hex;
        var positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        _this = (0, $kzDuW._)(this, PlaneHelper, [
            geometry,
            new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ _this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ _this.size = size;
        var positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        var geometry2 = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        _this.add(new $a1724dcfba0d6d9a$export$e176487c05830cc5(geometry2, new $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
        return _this;
    }
    (0, $byiyg._)(PlaneHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                this.position.set(0, 0, 0);
                this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
                this.lookAt(this.plane.normal);
                this.translateZ(-this.plane.constant);
                (0, $fXhL4._)((0, $hxFDX._)(PlaneHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
            }
        }
    ]);
    return PlaneHelper;
}($a1724dcfba0d6d9a$export$17d680238e50603e);
var $a1724dcfba0d6d9a$var$_axis = /*@__PURE__*/ new $a1724dcfba0d6d9a$export$64b5c384219d3699();
var $a1724dcfba0d6d9a$var$_lineGeometry, $a1724dcfba0d6d9a$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ var $a1724dcfba0d6d9a$export$a3008e7bd8d2cbe7 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(ArrowHelper, Object3D);
    function ArrowHelper() {
        var dir = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 1), origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a1724dcfba0d6d9a$export$64b5c384219d3699(0, 0, 0), length = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, color = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0xffff00, headLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : length * 0.2, headWidth = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : headLength * 0.2;
        (0, $jGAMp._)(this, ArrowHelper);
        var _this;
        _this = (0, $kzDuW._)(this, ArrowHelper);
        _this.type = 'ArrowHelper';
        if ($a1724dcfba0d6d9a$var$_lineGeometry === undefined) {
            $a1724dcfba0d6d9a$var$_lineGeometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
            $a1724dcfba0d6d9a$var$_lineGeometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $a1724dcfba0d6d9a$var$_coneGeometry = new $a1724dcfba0d6d9a$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $a1724dcfba0d6d9a$var$_coneGeometry.translate(0, -0.5, 0);
        }
        _this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ _this.line = new $a1724dcfba0d6d9a$export$17d680238e50603e($a1724dcfba0d6d9a$var$_lineGeometry, new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        _this.line.matrixAutoUpdate = false;
        _this.add(_this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ _this.cone = new $a1724dcfba0d6d9a$export$e176487c05830cc5($a1724dcfba0d6d9a$var$_coneGeometry, new $a1724dcfba0d6d9a$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        _this.cone.matrixAutoUpdate = false;
        _this.add(_this.cone);
        _this.setDirection(dir);
        _this.setLength(length, headLength, headWidth);
        return _this;
    }
    (0, $byiyg._)(ArrowHelper, [
        {
            /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ key: "setDirection",
            value: function setDirection(dir) {
                // dir is assumed to be normalized
                if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
                else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    $a1724dcfba0d6d9a$var$_axis.set(dir.z, 0, -dir.x).normalize();
                    var radians = Math.acos(dir.y);
                    this.quaternion.setFromAxisAngle($a1724dcfba0d6d9a$var$_axis, radians);
                }
            }
        },
        {
            /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ key: "setLength",
            value: function setLength(length) {
                var headLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : length * 0.2, headWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : headLength * 0.2;
                this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
                this.line.updateMatrix();
                this.cone.scale.set(headWidth, headLength, headWidth);
                this.cone.position.y = length;
                this.cone.updateMatrix();
            }
        },
        {
            /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ key: "setColor",
            value: function setColor(color) {
                this.line.material.color.set(color);
                this.cone.material.color.set(color);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $fXhL4._)((0, $hxFDX._)(ArrowHelper.prototype), "copy", this).call(this, source, false);
                this.line.copy(source.line);
                this.cone.copy(source.cone);
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.line.geometry.dispose();
                this.line.material.dispose();
                this.cone.geometry.dispose();
                this.cone.material.dispose();
            }
        }
    ]);
    return ArrowHelper;
}($a1724dcfba0d6d9a$export$e4dd07dff30cc924);
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ var $a1724dcfba0d6d9a$export$6c8303f35b8578fd = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $i3fW3._)(AxesHelper, LineSegments);
    function AxesHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        (0, $jGAMp._)(this, AxesHelper);
        var _this;
        var vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        var colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        var geometry = new $a1724dcfba0d6d9a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $a1724dcfba0d6d9a$export$cbe7a62641830ebd(colors, 3));
        var material = new $a1724dcfba0d6d9a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $kzDuW._)(this, AxesHelper, [
            geometry,
            material
        ]);
        _this.type = 'AxesHelper';
        return _this;
    }
    (0, $byiyg._)(AxesHelper, [
        {
            /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ key: "setColors",
            value: function setColors(xAxisColor, yAxisColor, zAxisColor) {
                var color = new $a1724dcfba0d6d9a$export$892596cec99bc70e();
                var array = this.geometry.attributes.color.array;
                color.set(xAxisColor);
                color.toArray(array, 0);
                color.toArray(array, 3);
                color.set(yAxisColor);
                color.toArray(array, 6);
                color.toArray(array, 9);
                color.set(zAxisColor);
                color.toArray(array, 12);
                color.toArray(array, 15);
                this.geometry.attributes.color.needsUpdate = true;
                return this;
            }
        },
        {
            /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return AxesHelper;
}($a1724dcfba0d6d9a$export$ff1ed10fedfdd604);
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ var $a1724dcfba0d6d9a$export$148534a3c727230b = /*#__PURE__*/ function() {
    "use strict";
    function ShapePath() {
        (0, $jGAMp._)(this, ShapePath);
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $a1724dcfba0d6d9a$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    (0, $byiyg._)(ShapePath, [
        {
            /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPath = new $a1724dcfba0d6d9a$export$4b2950bdac9b6ee9();
                this.subPaths.push(this.currentPath);
                this.currentPath.moveTo(x, y);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ key: "lineTo",
            value: function lineTo(x, y) {
                this.currentPath.lineTo(x, y);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
                return this;
            }
        },
        {
            /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ key: "splineThru",
            value: function splineThru(pts) {
                this.currentPath.splineThru(pts);
                return this;
            }
        },
        {
            /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ key: "toShapes",
            value: function toShapes(isCCW) {
                function toShapesNoHoles(inSubpaths) {
                    var shapes = [];
                    for(var i = 0, l = inSubpaths.length; i < l; i++){
                        var tmpPath = inSubpaths[i];
                        var tmpShape = new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa();
                        tmpShape.curves = tmpPath.curves;
                        shapes.push(tmpShape);
                    }
                    return shapes;
                }
                function isPointInsidePolygon(inPt, inPolygon) {
                    var polyLen = inPolygon.length;
                    // inPt on polygon contour => immediate success    or
                    // toggling of inside/outside at every single! intersection point of an edge
                    //  with the horizontal line through inPt, left of inPt
                    //  not counting lowerY endpoints of edges and whole edges on that line
                    var inside = false;
                    for(var p = polyLen - 1, q = 0; q < polyLen; p = q++){
                        var edgeLowPt = inPolygon[p];
                        var edgeHighPt = inPolygon[q];
                        var edgeDx = edgeHighPt.x - edgeLowPt.x;
                        var edgeDy = edgeHighPt.y - edgeLowPt.y;
                        if (Math.abs(edgeDy) > Number.EPSILON) {
                            // not parallel
                            if (edgeDy < 0) {
                                edgeLowPt = inPolygon[q];
                                edgeDx = -edgeDx;
                                edgeHighPt = inPolygon[p];
                                edgeDy = -edgeDy;
                            }
                            if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                            if (inPt.y === edgeLowPt.y) {
                                if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                            // continue;				// no intersection or edgeLowPt => doesn't count !!!
                            } else {
                                var perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                                if (perpEdge === 0) return true; // inPt is on contour ?
                                if (perpEdge < 0) continue;
                                inside = !inside; // true intersection left of inPt
                            }
                        } else {
                            // parallel or collinear
                            if (inPt.y !== edgeLowPt.y) continue; // parallel
                            // edge lies on the same horizontal line as inPt
                            if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                        // continue;
                        }
                    }
                    return inside;
                }
                var isClockWise = $a1724dcfba0d6d9a$export$96bdf6d9c66d7ba8.isClockWise;
                var subPaths = this.subPaths;
                if (subPaths.length === 0) return [];
                var solid, tmpPath, tmpShape;
                var shapes = [];
                if (subPaths.length === 1) {
                    tmpPath = subPaths[0];
                    tmpShape = new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa();
                    tmpShape.curves = tmpPath.curves;
                    shapes.push(tmpShape);
                    return shapes;
                }
                var holesFirst = !isClockWise(subPaths[0].getPoints());
                holesFirst = isCCW ? !holesFirst : holesFirst;
                // console.log("Holes first", holesFirst);
                var betterShapeHoles = [];
                var newShapes = [];
                var newShapeHoles = [];
                var mainIdx = 0;
                var tmpPoints;
                newShapes[mainIdx] = undefined;
                newShapeHoles[mainIdx] = [];
                for(var i = 0, l = subPaths.length; i < l; i++){
                    tmpPath = subPaths[i];
                    tmpPoints = tmpPath.getPoints();
                    solid = isClockWise(tmpPoints);
                    solid = isCCW ? !solid : solid;
                    if (solid) {
                        if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                        newShapes[mainIdx] = {
                            s: new $a1724dcfba0d6d9a$export$6428a7f2611ef1fa(),
                            p: tmpPoints
                        };
                        newShapes[mainIdx].s.curves = tmpPath.curves;
                        if (holesFirst) mainIdx++;
                        newShapeHoles[mainIdx] = [];
                    //console.log('cw', i);
                    } else newShapeHoles[mainIdx].push({
                        h: tmpPath,
                        p: tmpPoints[0]
                    });
                }
                // only Holes? -> probably all Shapes with wrong orientation
                if (!newShapes[0]) return toShapesNoHoles(subPaths);
                if (newShapes.length > 1) {
                    var ambiguous = false;
                    var toChange = 0;
                    for(var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
                    for(var sIdx1 = 0, sLen1 = newShapes.length; sIdx1 < sLen1; sIdx1++){
                        var sho = newShapeHoles[sIdx1];
                        for(var hIdx = 0; hIdx < sho.length; hIdx++){
                            var ho = sho[hIdx];
                            var hole_unassigned = true;
                            for(var s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                                if (sIdx1 !== s2Idx) toChange++;
                                if (hole_unassigned) {
                                    hole_unassigned = false;
                                    betterShapeHoles[s2Idx].push(ho);
                                } else ambiguous = true;
                            }
                            if (hole_unassigned) betterShapeHoles[sIdx1].push(ho);
                        }
                    }
                    if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
                }
                var tmpHoles;
                for(var i1 = 0, il = newShapes.length; i1 < il; i1++){
                    tmpShape = newShapes[i1].s;
                    shapes.push(tmpShape);
                    tmpHoles = newShapeHoles[i1];
                    for(var j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
                }
                //console.log("shape", shapes);
                return shapes;
            }
        }
    ]);
    return ShapePath;
}();
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ var $a1724dcfba0d6d9a$export$c7c44baae9d9f25f = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $i3fW3._)(Controls, EventDispatcher);
    function Controls(object) {
        var domElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $jGAMp._)(this, Controls);
        var _this;
        _this = (0, $kzDuW._)(this, Controls);
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ _this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLDOMElement}
		 * @default null
		 */ _this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ _this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ _this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ _this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ _this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ _this.touches = {
            ONE: null,
            TWO: null
        };
        return _this;
    }
    (0, $byiyg._)(Controls, [
        {
            /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLDOMElement} element - The DOM element to connect to.
	 */ key: "connect",
            value: function connect(element) {
                if (element === undefined) {
                    console.warn('THREE.Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
                    return;
                }
                if (this.domElement !== null) this.disconnect();
                this.domElement = element;
            }
        },
        {
            /**
	 * Disconnects the controls from the DOM.
	 */ key: "disconnect",
            value: function disconnect() {}
        },
        {
            /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ key: "dispose",
            value: function dispose() {}
        },
        {
            /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ key: "update",
            value: function update() {}
        }
    ]);
    return Controls;
}($a1724dcfba0d6d9a$export$ec8b666c5fe2c75a);
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $a1724dcfba0d6d9a$var$contain(texture, aspect) {
    var imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $a1724dcfba0d6d9a$var$cover(texture, aspect) {
    var imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $a1724dcfba0d6d9a$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $a1724dcfba0d6d9a$export$cc8c3b705bb8e6e2(width, height, format, type) {
    var typeByteLength = $a1724dcfba0d6d9a$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $a1724dcfba0d6d9a$export$988473390501ed4b:
            return width * height;
        case $a1724dcfba0d6d9a$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $a1724dcfba0d6d9a$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $a1724dcfba0d6d9a$export$21d1799c6d552fc0:
        case $a1724dcfba0d6d9a$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $a1724dcfba0d6d9a$export$d2a1a68024a3e56c:
        case $a1724dcfba0d6d9a$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $a1724dcfba0d6d9a$export$d0f0355bb3d948e4:
        case $a1724dcfba0d6d9a$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $a1724dcfba0d6d9a$export$19ada9bbb1af3573:
        case $a1724dcfba0d6d9a$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $a1724dcfba0d6d9a$export$6ab91af2d757aee7:
        case $a1724dcfba0d6d9a$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $a1724dcfba0d6d9a$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $a1724dcfba0d6d9a$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $a1724dcfba0d6d9a$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $a1724dcfba0d6d9a$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $a1724dcfba0d6d9a$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $a1724dcfba0d6d9a$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $a1724dcfba0d6d9a$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $a1724dcfba0d6d9a$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $a1724dcfba0d6d9a$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $a1724dcfba0d6d9a$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $a1724dcfba0d6d9a$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $a1724dcfba0d6d9a$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $a1724dcfba0d6d9a$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $a1724dcfba0d6d9a$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $a1724dcfba0d6d9a$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $a1724dcfba0d6d9a$export$ce40b115e188bc81:
        case $a1724dcfba0d6d9a$export$d279c5c4bac5121e:
        case $a1724dcfba0d6d9a$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $a1724dcfba0d6d9a$export$b1688df4c4c21670:
        case $a1724dcfba0d6d9a$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $a1724dcfba0d6d9a$export$d220f6ade8463a0f:
        case $a1724dcfba0d6d9a$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error("Unable to determine texture byte length for ".concat(format, " format."));
}
function $a1724dcfba0d6d9a$var$getTextureTypeByteLength(type) {
    switch(type){
        case $a1724dcfba0d6d9a$export$2e8ce08d3f6f5e10:
        case $a1724dcfba0d6d9a$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $a1724dcfba0d6d9a$export$c63dc51868b06a9d:
        case $a1724dcfba0d6d9a$export$88572337f312435f:
        case $a1724dcfba0d6d9a$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $a1724dcfba0d6d9a$export$b3969b01faf587f2:
        case $a1724dcfba0d6d9a$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $a1724dcfba0d6d9a$export$c3c7fc4518ebba96:
        case $a1724dcfba0d6d9a$export$5c612977753abe2:
        case $a1724dcfba0d6d9a$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $a1724dcfba0d6d9a$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error("Unknown texture type ".concat(type, "."));
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ var $a1724dcfba0d6d9a$export$ec276d39f33d4b7 = /*#__PURE__*/ function() {
    "use strict";
    function TextureUtils() {
        (0, $jGAMp._)(this, TextureUtils);
    }
    (0, $byiyg._)(TextureUtils, null, [
        {
            key: "contain",
            value: /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ function contain1(texture, aspect) {
                return $a1724dcfba0d6d9a$var$contain(texture, aspect);
            }
        },
        {
            key: "cover",
            value: /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ function cover1(texture, aspect) {
                return $a1724dcfba0d6d9a$var$cover(texture, aspect);
            }
        },
        {
            key: "fill",
            value: /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ function fill1(texture) {
                return $a1724dcfba0d6d9a$var$fill(texture);
            }
        },
        {
            key: "getByteLength",
            value: /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ function getByteLength1(width, height, format, type) {
                return $a1724dcfba0d6d9a$export$cc8c3b705bb8e6e2(width, height, format, type);
            }
        }
    ]);
    return TextureUtils;
}();
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $a1724dcfba0d6d9a$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $a1724dcfba0d6d9a$export$3545e07a80636437;
}

});
parcelRegister("fXhL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b9da24198e43ac0f$export$71511d61b312f219; });

var $jBOXB = parcelRequire("jBOXB");
function $b9da24198e43ac0f$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $b9da24198e43ac0f$export$71511d61b312f219 = Reflect.get;
    else $b9da24198e43ac0f$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $jBOXB._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $b9da24198e43ac0f$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("jBOXB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e46900ad2e34f55d$export$71511d61b312f219; });

var $hxFDX = parcelRequire("hxFDX");
function $e46900ad2e34f55d$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $hxFDX._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("8AW3P", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $641eb92e8e8050e5$export$71511d61b312f219; });

var $dBg4t = parcelRequire("dBg4t");

var $hxFDX = parcelRequire("hxFDX");

var $ltaUh = parcelRequire("ltaUh");

var $4zEQz = parcelRequire("4zEQz");
function $641eb92e8e8050e5$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $641eb92e8e8050e5$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $ltaUh._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $dBg4t._)(Class, arguments, (0, $hxFDX._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $4zEQz._)(Wrapper, Class);
    };
    return $641eb92e8e8050e5$export$71511d61b312f219(Class);
}

});
parcelRegister("dBg4t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9e6b3275da7502d1$export$71511d61b312f219; });

var $4J9eQ = parcelRequire("4J9eQ");

var $4zEQz = parcelRequire("4zEQz");
function $9e6b3275da7502d1$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $4J9eQ._)()) $9e6b3275da7502d1$export$71511d61b312f219 = Reflect.construct;
    else $9e6b3275da7502d1$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $4zEQz._)(instance, Class.prototype);
        return instance;
    };
    return $9e6b3275da7502d1$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("ltaUh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa14c4414b26301e$export$71511d61b312f219; });
function $fa14c4414b26301e$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});




parcelRegister("lUI9E", function(module, exports) {

$parcel$export(module.exports, "sparqlEngine", function () { return $b4a6363429f32ddf$export$5668bdd4cce435cd; });

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");

var $er6Qn = parcelRequire("er6Qn");
var $b4a6363429f32ddf$export$79f0350e4e0bf879 = /*#__PURE__*/ function() {
    "use strict";
    function SparqlEngine() {
        (0, $jGAMp._)(this, SparqlEngine);
        this.engine = new (0, $er6Qn.QueryEngine)();
    }
    (0, $byiyg._)(SparqlEngine, [
        {
            key: "getTTLUrl",
            value: /**
   * Get the correct TTL file URL for the current environment
   */ function getTTLUrl() {
                // Try different possible paths for the TTL file
                var possiblePaths = [
                    // Direct file from static folder
                    new URL('/oer_dataset.ttl', window.location.origin).href,
                    // Static folder path
                    new URL('/static/oer_dataset.ttl', window.location.origin).href,
                    // Current URL base
                    new URL('./oer_dataset.ttl', window.location.href).href,
                    // Relative to current page
                    new URL('../oer_dataset.ttl', window.location.href).href
                ];
                // For development, use the most likely path
                return possiblePaths[0];
            }
        },
        {
            key: "testTTLAccess",
            value: /**
   * Test if a TTL file URL is accessible
   */ function testTTLAccess(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var response, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    fetch(url, {
                                        method: 'HEAD'
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.ok
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findAccessibleTTLUrl",
            value: /**
   * Find accessible TTL file URL
   */ function findAccessibleTTLUrl() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var possiblePaths, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, path, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                possiblePaths = [
                                    new URL('/oer_dataset.ttl', window.location.origin).href,
                                    new URL('/static/oer_dataset.ttl', window.location.origin).href,
                                    new URL('./oer_dataset.ttl', window.location.href).href,
                                    new URL('../oer_dataset.ttl', window.location.href).href,
                                    // Also try without leading slash
                                    new URL('oer_dataset.ttl', window.location.origin).href
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = possiblePaths[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                path = _step.value;
                                console.log("Testing TTL path: ".concat(path));
                                return [
                                    4,
                                    this.testTTLAccess(path)
                                ];
                            case 3:
                                if (_state.sent()) {
                                    console.log("\u2713 Found accessible TTL file at: ".concat(path));
                                    return [
                                        2,
                                        path
                                    ];
                                }
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                throw new Error("TTL file not found at any of these paths: ".concat(possiblePaths.join(', ')));
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "executeSelectQuery",
            value: /**
   * Execute a SPARQL SELECT query against the OER dataset
   * @param query SPARQL query string
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @returns Promise resolving to an array of bindings
   */ function executeSelectQuery(query, ttlUrl) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var sourceUrl, _tmp, bindingsStream, bindings, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                _tmp = ttlUrl;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.findAccessibleTTLUrl()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                sourceUrl = _tmp;
                                console.log("Executing SPARQL query against: ".concat(sourceUrl));
                                return [
                                    4,
                                    this.engine.queryBindings(query, {
                                        sources: [
                                            sourceUrl
                                        ]
                                    })
                                ];
                            case 3:
                                bindingsStream = _state.sent();
                                return [
                                    4,
                                    bindingsStream.toArray()
                                ];
                            case 4:
                                bindings = _state.sent();
                                // Convert RDF/JS bindings to plain objects
                                return [
                                    2,
                                    bindings.map(function(binding) {
                                        var _term_datatype;
                                        var result = {};
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = binding[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _step_value = (0, $32TW8._)(_step.value, 2), variable = _step_value[0], term = _step_value[1];
                                                result[variable.value] = {
                                                    value: term.value,
                                                    type: term.termType,
                                                    datatype: (_term_datatype = term.datatype) === null || _term_datatype === void 0 ? void 0 : _term_datatype.value,
                                                    language: term.language
                                                };
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return result;
                                    })
                                ];
                            case 5:
                                error = _state.sent();
                                console.error("SPARQL query execution failed:", error);
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "executeConstructQuery",
            value: /**
   * Execute a SPARQL CONSTRUCT query to get RDF triples
   * @param query SPARQL CONSTRUCT query string
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @returns Promise resolving to an array of quads
   */ function executeConstructQuery(query, ttlUrl) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var sourceUrl, _tmp, quadStream, quads, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                _tmp = ttlUrl;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.findAccessibleTTLUrl()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                sourceUrl = _tmp;
                                return [
                                    4,
                                    this.engine.queryQuads(query, {
                                        sources: [
                                            sourceUrl
                                        ]
                                    })
                                ];
                            case 3:
                                quadStream = _state.sent();
                                return [
                                    4,
                                    quadStream.toArray()
                                ];
                            case 4:
                                quads = _state.sent();
                                return [
                                    2,
                                    quads.map(function(quad) {
                                        return {
                                            subject: quad.subject.value,
                                            predicate: quad.predicate.value,
                                            object: quad.object.value,
                                            graph: quad.graph.value
                                        };
                                    })
                                ];
                            case 5:
                                error = _state.sent();
                                console.error("SPARQL CONSTRUCT query execution failed:", error);
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getLearningResources",
            value: /**
   * Get all learning resources with their basic information
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param limit Optional limit for results
   */ function getLearningResources(ttlUrl) {
                var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        query = "\n      PREFIX dcterms: <http://purl.org/dc/terms/>\n      PREFIX edu: <http://example.org/education/>\n      PREFIX oer: <http://example.org/oer/>\n\n      SELECT ?resource ?title ?creator ?type ?format ?subject WHERE {\n        ?resource a edu:LearningResource ;\n                  dcterms:title ?title ;\n                  dcterms:creator ?creator ;\n                  dcterms:type ?type ;\n                  dcterms:format ?format .\n        OPTIONAL { ?resource dcterms:subject ?subject }\n      } LIMIT ".concat(limit, "\n    ");
                        return [
                            2,
                            this.executeSelectQuery(query, ttlUrl)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "searchBySubject",
            value: /**
   * Search learning resources by subject/concept
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param concept The concept to search for (e.g., "Datenbanken")
   */ function searchBySubject(ttlUrl, concept) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        query = '\n      PREFIX dcterms: <http://purl.org/dc/terms/>\n      PREFIX edu: <http://example.org/education/>\n      PREFIX oer: <http://example.org/oer/>\n\n      SELECT ?resource ?title ?creator ?type ?subject WHERE {\n        ?resource a edu:LearningResource ;\n                  dcterms:title ?title ;\n                  dcterms:creator ?creator ;\n                  dcterms:type ?type ;\n                  dcterms:subject ?subject .\n        FILTER(CONTAINS(LCASE(STR(?subject)), LCASE("'.concat(concept, '")))\n      }\n    ');
                        return [
                            2,
                            this.executeSelectQuery(query, ttlUrl)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getResourcesByCreator",
            value: /**
   * Get resources by creator/author
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param creator The creator name to search for
   */ function getResourcesByCreator(ttlUrl, creator) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        query = '\n      PREFIX dcterms: <http://purl.org/dc/terms/>\n      PREFIX edu: <http://example.org/education/>\n      PREFIX oer: <http://example.org/oer/>\n\n      SELECT ?resource ?title ?type ?format ?subject WHERE {\n        ?resource a edu:LearningResource ;\n                  dcterms:title ?title ;\n                  dcterms:creator ?creator ;\n                  dcterms:type ?type ;\n                  dcterms:format ?format .\n        OPTIONAL { ?resource dcterms:subject ?subject }\n        FILTER(CONTAINS(LCASE(STR(?creator)), LCASE("'.concat(creator, '")))\n      }\n    ');
                        return [
                            2,
                            this.executeSelectQuery(query, ttlUrl)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getAllSubjects",
            value: /**
   * Get all unique subjects/concepts in the dataset
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   */ function getAllSubjects(ttlUrl) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        query = "\n      PREFIX dcterms: <http://purl.org/dc/terms/>\n      PREFIX edu: <http://example.org/education/>\n\n      SELECT DISTINCT ?subject WHERE {\n        ?resource a edu:LearningResource ;\n                  dcterms:subject ?subject .\n      }\n      ORDER BY ?subject\n    ";
                        return [
                            2,
                            this.executeSelectQuery(query, ttlUrl)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getDatasetStats",
            value: /**
   * Get statistics about the dataset
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   */ function getDatasetStats(ttlUrl) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        query = "\n      PREFIX dcterms: <http://purl.org/dc/terms/>\n      PREFIX edu: <http://example.org/education/>\n\n      SELECT \n        (COUNT(DISTINCT ?resource) as ?totalResources)\n        (COUNT(DISTINCT ?creator) as ?totalCreators)\n        (COUNT(DISTINCT ?type) as ?totalTypes)\n        (COUNT(DISTINCT ?subject) as ?totalSubjects)\n      WHERE {\n        ?resource a edu:LearningResource .\n        OPTIONAL { ?resource dcterms:creator ?creator }\n        OPTIONAL { ?resource dcterms:type ?type }\n        OPTIONAL { ?resource dcterms:subject ?subject }\n      }\n    ";
                        return [
                            2,
                            this.executeSelectQuery(query, ttlUrl)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "testTTLFileAccess",
            value: /**
   * Test TTL file accessibility and log debug information
   */ function testTTLFileAccess() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var possiblePaths, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, path, response, accessible, error, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                possiblePaths = [
                                    new URL('/oer_dataset.ttl', window.location.origin).href,
                                    new URL('/static/oer_dataset.ttl', window.location.origin).href,
                                    new URL('./oer_dataset.ttl', window.location.href).href,
                                    new URL('../oer_dataset.ttl', window.location.href).href,
                                    new URL('oer_dataset.ttl', window.location.origin).href
                                ];
                                console.log('Current location:', window.location.href);
                                console.log('Testing TTL file accessibility...');
                                results = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = possiblePaths[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                path = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    fetch(path, {
                                        method: 'HEAD'
                                    })
                                ];
                            case 4:
                                response = _state.sent();
                                accessible = response.ok;
                                console.log("".concat(accessible ? "\u2713" : "\u2717", " ").concat(path, " - ").concat(response.status, " ").concat(response.statusText));
                                results.push({
                                    path: path,
                                    accessible: accessible,
                                    status: response.status,
                                    statusText: response.statusText
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                console.log("\u2717 ".concat(path, " - Error: ").concat(error));
                                results.push({
                                    path: path,
                                    accessible: false,
                                    error: error === null || error === void 0 ? void 0 : error.toString()
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2,
                                    results
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SparqlEngine;
}();
var $b4a6363429f32ddf$export$5668bdd4cce435cd = new $b4a6363429f32ddf$export$79f0350e4e0bf879();

});
parcelRegister("er6Qn", function(module, exports) {
"use strict";
var $a828e55c19ce505a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a828e55c19ce505a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a828e55c19ce505a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a828e55c19ce505a$var$__exportStar((parcelRequire("68qZP")), module.exports);

});
parcelRegister("68qZP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngine = void 0;

var $6nvMd = parcelRequire("6nvMd");

var $fy2AY = parcelRequire("fy2AY");
/**
 * A Comunica SPARQL query engine.
 */ var $47786e4f5f9fa0dd$var$QueryEngine = /*#__PURE__*/ function(_actor_init_query_1_QueryEngineBase) {
    (0, $i3fW3._)(QueryEngine, _actor_init_query_1_QueryEngineBase);
    function QueryEngine() {
        var engine = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $fy2AY();
        (0, $jGAMp._)(this, QueryEngine);
        return (0, $kzDuW._)(this, QueryEngine, [
            engine
        ]);
    }
    return QueryEngine;
}($6nvMd.QueryEngineBase);
module.exports.QueryEngine = $47786e4f5f9fa0dd$var$QueryEngine;

});
parcelRegister("6nvMd", function(module, exports) {
"use strict";
var $4a4d8a42102d452d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a4d8a42102d452d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4a4d8a42102d452d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngineBase = void 0;

$4a4d8a42102d452d$var$__exportStar((parcelRequire("dXd9V")), module.exports);

$4a4d8a42102d452d$var$__exportStar((parcelRequire("7Vzoe")), module.exports);

var $3buLn = parcelRequire("3buLn");
Object.defineProperty(module.exports, "QueryEngineBase", {
    enumerable: true,
    get: function get() {
        return $3buLn.QueryEngineBase;
    }
});

});
parcelRegister("dXd9V", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInitQueryBase = void 0;

var $jxtX7 = parcelRequire("jxtX7");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A browser-safe comunica Query Init Actor.
 */ var $a28afe26f4c5d1da$var$ActorInitQueryBase = /*#__PURE__*/ function(_bus_init_1_ActorInit) {
    (0, $i3fW3._)(ActorInitQueryBase, _bus_init_1_ActorInit);
    function ActorInitQueryBase() {
        (0, $jGAMp._)(this, ActorInitQueryBase);
        return (0, $kzDuW._)(this, ActorInitQueryBase, arguments);
    }
    (0, $byiyg._)(ActorInitQueryBase, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error('ActorInitSparql#run is not supported in the browser.');
                    });
                })();
            }
        }
    ]);
    return ActorInitQueryBase;
}($jxtX7.ActorInit);
module.exports.ActorInitQueryBase = $a28afe26f4c5d1da$var$ActorInitQueryBase;

});
parcelRegister("jxtX7", function(module, exports) {
"use strict";
var $e39855508786205a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e39855508786205a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e39855508786205a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e39855508786205a$var$__exportStar((parcelRequire("bxQqr")), module.exports);

});
parcelRegister("bxQqr", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInit = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A base actor for listening to init events.
 *
 * Actor types:
 * * Input:  IActionInit:      Contains process information
 *                             such as the list of arguments,
 *                             environment variables and input stream.
 * * Test:   <none>
 * * Output: IActorOutputInit: Contains process output streams.
 *
 * @see IActionInit
 */ var $867b71626a8806c0$var$ActorInit = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorInit, _core_1_Actor);
    function ActorInit(args) {
        (0, $jGAMp._)(this, ActorInit);
        return (0, $kzDuW._)(this, ActorInit, [
            args
        ]);
    }
    return ActorInit;
}($kNNoa.Actor);
module.exports.ActorInit = $867b71626a8806c0$var$ActorInit;

});
parcelRegister("kNNoa", function(module, exports) {
"use strict";
var $f24eb1db78e9335c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f24eb1db78e9335c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f24eb1db78e9335c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f24eb1db78e9335c$var$__exportStar((parcelRequire("9uOmH")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("iJYWm")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("jX5mJ")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("5Zi9f")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("a4ChO")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("9m1yZ")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("grzE8")), module.exports);

$f24eb1db78e9335c$var$__exportStar((parcelRequire("1agTw")), module.exports);

});
parcelRegister("9uOmH", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionContextKey = module.exports.ActionContext = void 0;

var $ejkDQ = parcelRequire("ejkDQ");
/**
 * Implementation of {@link IActionContext} using Immutable.js.
 */ var $6e9dfbe008be0b75$var$ActionContext = /*#__PURE__*/ function() {
    function ActionContext() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $jGAMp._)(this, ActionContext);
        this.map = (0, $ejkDQ.Map)(data);
    }
    (0, $byiyg._)(ActionContext, [
        {
            /**
     * Will only set the value if the key is not already set.
     */ key: "setDefault",
            value: function setDefault(key, value) {
                return this.has(key) ? this : this.set(key, value);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                return this.setRaw(key.name, value);
            }
        },
        {
            key: "setRaw",
            value: function setRaw(key, value) {
                return new ActionContext(this.map.set(key, value));
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return new ActionContext(this.map["delete"](key.name));
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.getRaw(key.name);
            }
        },
        {
            key: "getRaw",
            value: function getRaw(key) {
                return this.map.get(key);
            }
        },
        {
            key: "getSafe",
            value: function getSafe(key) {
                if (!this.has(key)) throw new Error("Context entry ".concat(key.name, " is required but not available"));
                return this.get(key);
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.hasRaw(key.name);
            }
        },
        {
            key: "hasRaw",
            value: function hasRaw(key) {
                return this.map.has(key);
            }
        },
        {
            key: "merge",
            value: function merge() {
                for(var _len = arguments.length, contexts = new Array(_len), _key = 0; _key < _len; _key++){
                    contexts[_key] = arguments[_key];
                }
                // eslint-disable-next-line ts/no-this-alias
                var context = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = contexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var source = _step.value;
                        try {
                            for(var _iterator1 = source.keys()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var key = _step1.value;
                                context = context.set(key, source.get(key));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return context;
            }
        },
        {
            key: "keys",
            value: function keys() {
                return (0, $7WNf6._)(this.map.keys()).map(function(keyName) {
                    return new $6e9dfbe008be0b75$var$ActionContextKey(keyName);
                });
            }
        },
        {
            key: "toJS",
            value: function toJS() {
                return this.map.toJS();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "ActionContext(".concat(JSON.stringify(this.map.toJS()), ")");
            }
        },
        {
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value() {
                return "ActionContext(".concat(JSON.stringify(this.map.toJS(), null, '  '), ")");
            }
        }
    ], [
        {
            key: "ensureActionContext",
            value: /**
     * Convert the given object to an action context object if it is not an action context object yet.
     * If it already is an action context object, return the object as-is.
     * @param maybeActionContext An action context or record.
     * @return {ActionContext} An action context object.
     */ function ensureActionContext(maybeActionContext) {
                return maybeActionContext instanceof ActionContext ? maybeActionContext : new ActionContext((0, $ejkDQ.Map)(maybeActionContext !== null && maybeActionContext !== void 0 ? maybeActionContext : {}));
            }
        }
    ]);
    return ActionContext;
}();
module.exports.ActionContext = $6e9dfbe008be0b75$var$ActionContext;
/**
 * Simple implementation of {@link IActionContextKey}.
 */ var $6e9dfbe008be0b75$var$ActionContextKey = function ActionContextKey(name) {
    (0, $jGAMp._)(this, ActionContextKey);
    this.name = name;
};
module.exports.ActionContextKey = $6e9dfbe008be0b75$var$ActionContextKey;

});
parcelRegister("ejkDQ", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return Map; });
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
var $3KZcf = parcelRequire("3KZcf");
var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
function isCollection(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}
var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}
var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
function isSeq(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}
var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
function isRecord(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === 'string') return true;
    return value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
function isMap(maybeMap) {
    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
function isValueObject(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === 'function' && typeof maybeValue.hashCode === 'function');
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    if (o == null) return hashNullish(o);
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
    var v = valueOf(o);
    if (v == null) return hashNullish(v);
    switch(typeof v === "undefined" ? "undefined" : (0, $3KZcf._)(v)){
        case 'boolean':
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case 'number':
            return hashNumber(v);
        case 'string':
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case 'object':
        case 'function':
            return hashJSObj(v);
        case 'symbol':
            return hashSymbol(v);
        default:
            if (typeof v.toString === 'function') return hashString(v.toString());
            throw new Error('Value type ' + (typeof v === "undefined" ? "undefined" : (0, $3KZcf._)(v)) + ' cannot be hashed.');
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var _$hash = n | 0;
    if (_$hash !== n) _$hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        _$hash ^= n;
    }
    return smi(_$hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function' ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' || toString.call(value) !== '[object Object]') return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn$1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + keyPath.slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn$1(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn$1(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn$1(collection, [
        key
    ], notSetValue, updater);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn(keyPath, notSetValue, updater) {
    return updateIn$1(this, keyPath, notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== 'function') throw new TypeError('Invalid merger function: ' + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function mergeIntoCollection(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return typeof merger === 'function' && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function mergeItem(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
function isList(maybeList) {
    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var _$has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!_$has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (_$has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
function isStack(maybeStack) {
    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
function isSet(maybeSet) {
    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function mixin(ctor, methods) {
    var keyCopier = function keyCopier(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object') return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === 'string') set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var _$set = Object.create(SetPrototype);
    _$set.size = map ? map.size : 0;
    _$set._map = map;
    _$set.__ownerID = ownerID;
    return _$set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var _$set = Object.create(OrderedSetPrototype);
    _$set.size = map ? map.size : 0;
    _$set._map = map;
    _$set.__ownerID = ownerID;
    return _$set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error('Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.');
    if (isImmutable(defaultValues)) throw new Error('Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.');
    if (defaultValues === null || (typeof defaultValues === "undefined" ? "undefined" : (0, $3KZcf._)(defaultValues)) !== 'object') throw new Error('Can not call `Record` with a non-object as default values. Use a plain javascript object instead.');
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ (typeof console === "undefined" ? "undefined" : (0, $3KZcf._)(console)) === 'object' && console.warn && console.warn('Cannot define ' + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function get() {
                return this.get(name);
            },
            set: function set(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== 'string' && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "4.3.7";
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    PairSorting: PairSorting,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    isPlainObject: isPlainObject,
    isSeq: isSeq,
    isList: isList,
    isMap: isMap,
    isOrderedMap: isOrderedMap,
    isStack: isStack,
    isSet: isSet,
    isOrderedSet: isOrderedSet,
    isRecord: isRecord,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn$1
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $a6b2da06f7d70012$export$2e2bcd8739ae039 = Immutable;

});


parcelRegister("iJYWm", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bus = void 0;
/**
 * A publish-subscribe bus for sending actions to actors
 * to test whether or not they can run an action.
 *
 * This bus does not run the action itself,
 * for that a {@link Mediator} can be used.
 *
 * @see Actor
 * @see Mediator
 *
 * @template A The actor type that can subscribe to the sub.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ var $da4bb370aa7549e1$var$Bus = /*#__PURE__*/ function() {
    function Bus(args) {
        (0, $jGAMp._)(this, Bus);
        this.actors = [];
        this.observers = [];
        // Mapping from dependency (after) to dependents (before)
        this.dependencyLinks = new Map();
        Object.assign(this, args);
        this.failMessage = "All actors over bus ".concat(this.name, " failed to handle an action");
    }
    (0, $byiyg._)(Bus, [
        {
            /**
     * Subscribe the given actor to the bus.
     * After this, the given actor can be unsubscribed from the bus by calling {@link Bus#unsubscribe}.
     *
     * An actor that is subscribed multiple times will exist that amount of times in the bus.
     *
     * @param {A} actor The actor to subscribe.
     */ key: "subscribe",
            value: function subscribe(actor) {
                this.actors.push(actor);
                this.reorderForDependencies();
            }
        },
        {
            /**
     * Subscribe the given observer to the bus.
     * After this, the given observer can be unsubscribed from the bus by calling {@link Bus#unsubscribeObserver}.
     *
     * An observer that is subscribed multiple times will exist that amount of times in the bus.
     *
     * @param {ActionObserver<I, O>} observer The observer to subscribe.
     */ key: "subscribeObserver",
            value: function subscribeObserver(observer) {
                this.observers.push(observer);
            }
        },
        {
            /**
     * Unsubscribe the given actor from the bus.
     *
     * An actor that is subscribed multiple times will be unsubscribed only once.
     *
     * @param {A} actor The actor to unsubscribe
     * @return {boolean} If the given actor was successfully unsubscribed,
     *         otherwise it was not subscribed before.
     */ key: "unsubscribe",
            value: function unsubscribe(actor) {
                var index = this.actors.indexOf(actor);
                if (index >= 0) {
                    this.actors.splice(index, 1);
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Unsubscribe the given observer from the bus.
     *
     * An observer that is subscribed multiple times will be unsubscribed only once.
     *
     * @param {ActionObserver<I, O>} observer The observer to unsubscribe.
     * @return {boolean} If the given observer was successfully unsubscribed,
     *         otherwise it was not subscribed before.
     */ key: "unsubscribeObserver",
            value: function unsubscribeObserver(observer) {
                var index = this.observers.indexOf(observer);
                if (index >= 0) {
                    this.observers.splice(index, 1);
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Publish an action to all actors in the bus to test if they can run the action.
     *
     * @param {I} action An action to publish
     * @return {IActorReply<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest,
     *         O extends IActorOutput>[]}
     *         An array of reply objects. Each object contains a reference to the actor,
     *         and a promise to its {@link Actor#test} result.
     */ key: "publish",
            value: function publish(action) {
                return this.actors.map(function(actor) {
                    return {
                        actor: actor,
                        reply: actor.test(action)
                    };
                });
            }
        },
        {
            /**
     * Invoked when an action was run by an actor.
     *
     * @param actor               The action on which the {@link Actor#run} method was invoked.
     * @param {I}          action The original action input.
     * @param {Promise<O>} output A promise resolving to the final action output.
     */ key: "onRun",
            value: function onRun(actor, action, output) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.observers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var observer = _step.value;
                        observer.onRun(actor, action, output);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Indicate that the given actor has the given actor dependencies.
     *
     * This will ensure that the given actor will be present in the bus *before* the given dependencies.
     *
     * @param {A} dependent A dependent actor that will be placed before the given actors.
     * @param {A[]} dependencies Actor dependencies that will be placed after the given actor.
     */ key: "addDependencies",
            value: function addDependencies(dependent, dependencies) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = dependencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dependency = _step.value;
                        var existingDependencies = this.dependencyLinks.get(dependency);
                        if (!existingDependencies) {
                            existingDependencies = [];
                            this.dependencyLinks.set(dependency, existingDependencies);
                        }
                        existingDependencies.push(dependent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.reorderForDependencies();
            }
        },
        {
            /**
     * Reorder the bus based on all present dependencies.
     */ key: "reorderForDependencies",
            value: function reorderForDependencies() {
                if (this.dependencyLinks.size > 0) {
                    var actorsAfter = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Temporarily remove all actors that have dependencies
                        for(var _iterator = this.dependencyLinks.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var actorAfter = _step.value;
                            var dependentPos = this.actors.indexOf(actorAfter);
                            if (dependentPos >= 0) {
                                this.actors.splice(dependentPos, 1);
                                actorsAfter.push(actorAfter);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Iteratively append actors based on the first dependency link
                    // that has all of its dependencies available in the array
                    while(actorsAfter.length > 0){
                        // Find the first actor that has all of its dependencies available.
                        var activeActorAfterId = -1;
                        for(var i = 0; i < actorsAfter.length; i++){
                            var validLink = true;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = this.dependencyLinks.get(actorsAfter[i])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var dependency = _step1.value;
                                    if (!this.actors.includes(dependency) && actorsAfter.includes(dependency)) {
                                        validLink = false;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            if (validLink) {
                                activeActorAfterId = i;
                                break;
                            }
                        }
                        // If none of the pending links are possible, there must be a cyclic dependency
                        if (activeActorAfterId < 0) throw new Error("Cyclic dependency links detected in bus ".concat(this.name));
                        // The dependent may not be available (yet), so we don't add it to the array (yet).
                        var activeActorAfter = actorsAfter.splice(activeActorAfterId, 1)[0];
                        this.actors.push(activeActorAfter);
                    }
                }
            }
        }
    ]);
    return Bus;
}();
module.exports.Bus = $da4bb370aa7549e1$var$Bus;

});

parcelRegister("jX5mJ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusIndexed = void 0;

var $iJYWm = parcelRequire("iJYWm");
/**
 * A bus that indexes identified actors,
 * so that actions with a corresponding identifier can be published more efficiently.
 *
 * Multiple actors with the same identifier can be subscribed.
 *
 * If actors or actions do not have a valid identifier,
 * then this will fallback to the normal bus behaviour.
 *
 * @see Bus
 *
 * @template A The actor type that can subscribe to the sub.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 */ var $e867b0857a345e0b$var$BusIndexed = /*#__PURE__*/ function(_Bus_1_Bus) {
    (0, $i3fW3._)(BusIndexed, _Bus_1_Bus);
    function BusIndexed(args) {
        (0, $jGAMp._)(this, BusIndexed);
        var _this;
        _this = (0, $kzDuW._)(this, BusIndexed, [
            args
        ]);
        _this.actorsIndex = {};
        return _this;
    }
    (0, $byiyg._)(BusIndexed, [
        {
            key: "subscribe",
            value: function subscribe(actor) {
                var _this_getActorIdentifiers;
                var actorIds = (_this_getActorIdentifiers = this.getActorIdentifiers(actor)) !== null && _this_getActorIdentifiers !== void 0 ? _this_getActorIdentifiers : [
                    '_undefined_'
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = actorIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var actorId = _step.value;
                        var actors = this.actorsIndex[actorId];
                        if (!actors) actors = this.actorsIndex[actorId] = [];
                        actors.push(actor);
                        (0, $fXhL4._)((0, $hxFDX._)(BusIndexed.prototype), "subscribe", this).call(this, actor);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(actor) {
                var _this_getActorIdentifiers;
                var actorIds = (_this_getActorIdentifiers = this.getActorIdentifiers(actor)) !== null && _this_getActorIdentifiers !== void 0 ? _this_getActorIdentifiers : [
                    '_undefined_'
                ];
                var unsubscribed = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = actorIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var actorId = _step.value;
                        var actors = this.actorsIndex[actorId];
                        if (actors) {
                            var i = actors.indexOf(actor);
                            if (i >= 0) actors.splice(i, 1);
                            if (actors.length === 0) delete this.actorsIndex[actorId];
                        }
                        unsubscribed = unsubscribed || (0, $fXhL4._)((0, $hxFDX._)(BusIndexed.prototype), "unsubscribe", this).call(this, actor);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return unsubscribed;
            }
        },
        {
            key: "publish",
            value: function publish(action) {
                var actionId = this.getActionIdentifier(action);
                if (actionId) {
                    var actors = (0, $7WNf6._)(this.actorsIndex[actionId] || []).concat((0, $7WNf6._)(this.actorsIndex._undefined_ || []));
                    return actors.map(function(actor) {
                        return {
                            actor: actor,
                            reply: actor.test(action)
                        };
                    });
                }
                return (0, $fXhL4._)((0, $hxFDX._)(BusIndexed.prototype), "publish", this).call(this, action);
            }
        },
        {
            key: "getActorIdentifiers",
            value: function getActorIdentifiers(actor) {
                var identifierValue = this.actorIdentifierFields.reduce(function(object, field) {
                    return object[field];
                }, actor);
                if (!identifierValue) return;
                return Array.isArray(identifierValue) ? identifierValue : [
                    identifierValue
                ];
            }
        },
        {
            key: "getActionIdentifier",
            value: function getActionIdentifier(action) {
                return this.actionIdentifierFields.reduce(function(object, field) {
                    return object[field];
                }, action);
            }
        }
    ]);
    return BusIndexed;
}($iJYWm.Bus);
module.exports.BusIndexed = $e867b0857a345e0b$var$BusIndexed;

});

parcelRegister("5Zi9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CONTEXT_KEY_LOGGER = void 0;

var $9uOmH = parcelRequire("9uOmH");
module.exports.CONTEXT_KEY_LOGGER = new $9uOmH.ActionContextKey('@comunica/core:log');

});

parcelRegister("a4ChO", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserver = void 0;
/**
 * An ActionObserver can passively listen to {@link Actor#run} inputs and outputs for all actors on a certain bus.
 *
 * ActionObserver should not edit inputs and outputs,
 * they should be considered immutable.
 *
 * @see Actor
 * @see Bus
 *
 * @template I The input type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ var $7557f9fbf3bfa995$var$ActionObserver = function ActionObserver(args) {
    (0, $jGAMp._)(this, ActionObserver);
    Object.assign(this, args);
};
module.exports.ActionObserver = $7557f9fbf3bfa995$var$ActionObserver;

});

parcelRegister("9m1yZ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Actor = void 0;

var $5Zi9f = parcelRequire("5Zi9f");
/**
 * An actor can act on messages of certain types and provide output of a certain type.
 *
 * The flow of an actor is as follows:
 * 1. Send a message to {@link Actor#test} to test if an actor can run that action.
 * 2. If the actor can reply to the message, let the actor run the action using {@link Actor#run}.
 *
 * An actor is typically subscribed to a bus,
 * using which the applicability to an action can be tested.
 *
 * @see Bus
 *
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ var $6cf7619624364494$var$Actor = /*#__PURE__*/ function() {
    function Actor(args) {
        (0, $jGAMp._)(this, Actor);
        this.beforeActors = [];
        Object.assign(this, args);
        this.bus.subscribe(this);
        if (this.beforeActors.length > 0) this.bus.addDependencies(this, this.beforeActors);
        if (args.busFailMessage) this.bus.failMessage = args.busFailMessage;
    }
    (0, $byiyg._)(Actor, [
        {
            /**
     * Run the given action on this actor
     * AND invokes the {@link Bus#onRun} method.
     *
     * @param {I} action The action to run.
     * @return {Promise<T>} A promise that resolves to the run result.
     */ key: "runObservable",
            value: function runObservable(action, sideData) {
                var output = this.run(action, sideData);
                this.bus.onRun(this, action, output);
                return output;
            }
        },
        {
            /* Proxy methods for the (optional) logger that is defined in the context */ key: "getDefaultLogData",
            value: function getDefaultLogData(context, data) {
                var dataActual = data ? data() : {};
                dataActual.actor = this.name;
                return dataActual;
            }
        },
        {
            key: "logTrace",
            value: function logTrace(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.trace(message, this.getDefaultLogData(context, data));
            }
        },
        {
            key: "logDebug",
            value: function logDebug(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.debug(message, this.getDefaultLogData(context, data));
            }
        },
        {
            key: "logInfo",
            value: function logInfo(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.info(message, this.getDefaultLogData(context, data));
            }
        },
        {
            key: "logWarn",
            value: function logWarn(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.warn(message, this.getDefaultLogData(context, data));
            }
        },
        {
            key: "logError",
            value: function logError(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.error(message, this.getDefaultLogData(context, data));
            }
        },
        {
            key: "logFatal",
            value: function logFatal(context, message, data) {
                var logger = Actor.getContextLogger(context);
                if (logger) logger.fatal(message, this.getDefaultLogData(context, data));
            }
        }
    ], [
        {
            key: "getContextLogger",
            value: /**
     * Get the logger from the given context.
     * @param {ActionContext} context An optional context.
     * @return {Logger} The logger or undefined.
     */ function getContextLogger(context) {
                return context.get($5Zi9f.CONTEXT_KEY_LOGGER);
            }
        }
    ]);
    return Actor;
}();
module.exports.Actor = $6cf7619624364494$var$Actor;

});

parcelRegister("grzE8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mediator = void 0;
/**
 * A mediator can mediate an action over a bus of actors.
 *
 * It does the following:
 * 1. Accepts an action in {@link Mediator#mediate}.
 * 2. Sends the action to the bus to test its applicability on all actors.
 * 3. It _mediates_ over these test results.
 * 4. It selects the _best_ actor.
 * 5. The action is run by the _best_ actor, and the result if returned.
 *
 * The _mediates_ and _best_ parts are filled in by subclasses of this abstract Mediator class.
 *
 * @template A The type of actor to mediator over.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 */ var $bf8ad197c6835bb6$var$Mediator = /*#__PURE__*/ function() {
    function Mediator(args) {
        (0, $jGAMp._)(this, Mediator);
        Object.assign(this, args);
    }
    (0, $byiyg._)(Mediator, [
        {
            /**
     * Publish the given action in the bus.
     *
     * This will send the test action on all actors in the bus.
     * All actor replies will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {IActorReply<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest, O extends IActorOutput>[]}
     * The list of actor replies.
     */ key: "publish",
            value: function publish(action) {
                // Test all actors in the bus
                var actors = this.bus.publish(action);
                if (actors.length === 0) throw new Error("No actors are able to reply to a message in the bus ".concat(this.bus.name));
                return actors;
            }
        },
        {
            key: "mediateActor",
            value: /**
     * Mediate for the given action to get an actor.
     *
     * This will send the test action on all actors in the bus.
     * The actor that tests _best_ will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the _best_ actor.
     */ function mediateActor(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediateWith(action, this.publish(action))
                                ];
                            case 1:
                                // Mediate to one actor and run that actor.
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "mediateTestable",
            value: /**
     * Mediate for the given action.
     *
     * This will send the test action on all actors in the bus.
     * The action will be run on the actor that tests _best_,
     * of which the result will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the mediation result.
     */ function mediateTestable(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var actorResult;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediateActor(action)
                                ];
                            case 1:
                                actorResult = _state.sent();
                                return [
                                    2,
                                    actorResult.mapAsync(function(actor, sideData) {
                                        return actor.runObservable(action, sideData);
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "mediate",
            value: /**
     * Mediate for the given action.
     *
     * This will send the test action on all actors in the bus.
     * The action will be run on the actor that tests _best_,
     * of which the result will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the mediation result.
     */ function mediate(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var testable;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediateTestable(action)
                                ];
                            case 1:
                                testable = _state.sent();
                                return [
                                    2,
                                    testable.getOrThrow()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Construct a human-friendly failure message that accumulates the given actors's failure messages.
     * @param action The action that was executed.
     * @param actorFailures The failure messages that were collected from actor tests based on the given executed action.
     * @protected
     */ key: "constructFailureMessage",
            value: function constructFailureMessage(action, actorFailures) {
                var prefix = "\n        ";
                var failMessage = this.bus.failMessage.replaceAll(RegExp("\\$\\{(.*?)\\}", "gu"), function(match, key) {
                    return Mediator.getObjectValue({
                        action: action
                    }, key.split('.')) || match;
                });
                return "".concat(failMessage, "\n    Error messages of failing actors:").concat(prefix).concat(actorFailures.join(prefix));
            }
        }
    ], [
        {
            key: "getObjectValue",
            value: function getObjectValue(obj, path) {
                if (path.length === 0) return obj;
                if (obj) return Mediator.getObjectValue(obj[path[0]], path.slice(1));
                return undefined;
            }
        }
    ]);
    return Mediator;
}();
module.exports.Mediator = $bf8ad197c6835bb6$var$Mediator;

});

parcelRegister("1agTw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestResultFailed = module.exports.TestResultPassed = module.exports.failTest = module.exports.passTestVoidWithSideData = module.exports.passTestWithSideData = module.exports.passTestVoid = module.exports.passTest = void 0;
/**
 * Create a new test result that represents a passed value.
 * @param value The value the test passed with.
 */ function $0d93d4811d2c20b0$var$passTest(value) {
    return new $0d93d4811d2c20b0$var$TestResultPassed(value, undefined);
}
module.exports.passTest = $0d93d4811d2c20b0$var$passTest;
/**
 * Create a new test result that represents a passed void value.
 */ function $0d93d4811d2c20b0$var$passTestVoid() {
    return new $0d93d4811d2c20b0$var$TestResultPassed(true, undefined);
}
module.exports.passTestVoid = $0d93d4811d2c20b0$var$passTestVoid;
/**
 * Create a new test result that represents a passed value with side data.
 * @param value The value the test passed with.
 * @param sideData Additional data to pass to the run phase.
 */ function $0d93d4811d2c20b0$var$passTestWithSideData(value, sideData) {
    return new $0d93d4811d2c20b0$var$TestResultPassed(value, sideData);
}
module.exports.passTestWithSideData = $0d93d4811d2c20b0$var$passTestWithSideData;
/**
 * Create a new test result that represents a passed void value with side data.
 * @param sideData Additional data to pass to the run phase.
 */ function $0d93d4811d2c20b0$var$passTestVoidWithSideData(sideData) {
    return new $0d93d4811d2c20b0$var$TestResultPassed(true, sideData);
}
module.exports.passTestVoidWithSideData = $0d93d4811d2c20b0$var$passTestVoidWithSideData;
/**
 * Create a new test result that represents a test failure.
 * @param message The error message that describes the failure.
 */ function $0d93d4811d2c20b0$var$failTest(message) {
    return new $0d93d4811d2c20b0$var$TestResultFailed(message);
}
module.exports.failTest = $0d93d4811d2c20b0$var$failTest;
/**
 * A passed test result.
 * This should not be constructed manually.
 * Instead, `testPass` should be used.
 */ var $0d93d4811d2c20b0$var$TestResultPassed = /*#__PURE__*/ function() {
    function TestResultPassed(passValue, sideData) {
        (0, $jGAMp._)(this, TestResultPassed);
        this.value = passValue;
        this.sideData = sideData;
    }
    (0, $byiyg._)(TestResultPassed, [
        {
            /**
     * Check if the test has passed.
     * If true, it will contain a value.
     */ key: "isPassed",
            value: function isPassed() {
                return true;
            }
        },
        {
            /**
     * Check if the test has failed.
     * If true, it will contain a failure message.
     */ key: "isFailed",
            value: function isFailed() {
                return false;
            }
        },
        {
            /**
     * Get the value of the passed test, or undefined if the test failed.
     */ key: "get",
            value: function get() {
                return this.value;
            }
        },
        {
            /**
     * Get the value of the passed test, or throw an error if the test failed.
     */ key: "getOrThrow",
            value: function getOrThrow() {
                return this.value;
            }
        },
        {
            /**
     * The side data that will be passed to run.
     */ key: "getSideData",
            value: function getSideData() {
                return this.sideData;
            }
        },
        {
            /**
     * Get the failure message callback of the failed test, or undefined if the test passed.
     */ key: "getFailMessage",
            value: function getFailMessage() {
                return undefined;
            }
        },
        {
            /**
     * For passed tests, map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     *
     * @param mapper A function that will transform the passed value.
     */ key: "map",
            value: function map(mapper) {
                return new TestResultPassed(mapper(this.value, this.sideData), this.sideData);
            }
        },
        {
            key: "mapAsync",
            value: /**
     * For passed tests, asynchronously map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     *
     * @param mapper A function that will transform the passed value.
     */ function mapAsync(mapper) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = TestResultPassed.bind;
                                return [
                                    4,
                                    mapper(this.value, this.sideData)
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_.apply(TestResultPassed, [
                                        void 0,
                                        _state.sent(),
                                        this.sideData
                                    ]))
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return TestResultPassed;
}();
module.exports.TestResultPassed = $0d93d4811d2c20b0$var$TestResultPassed;
/**
 * A failed test result.
 * This should not be constructed manually.
 * Instead, `testFail` should be used.
 */ var $0d93d4811d2c20b0$var$TestResultFailed = /*#__PURE__*/ function() {
    function TestResultFailed(failMessage) {
        (0, $jGAMp._)(this, TestResultFailed);
        this.failMessage = failMessage;
    }
    (0, $byiyg._)(TestResultFailed, [
        {
            /**
     * Check if the test has passed.
     * If true, it will contain a value.
     */ key: "isPassed",
            value: function isPassed() {
                return false;
            }
        },
        {
            /**
     * Check if the test has failed.
     * If true, it will contain a failure message.
     */ key: "isFailed",
            value: function isFailed() {
                return true;
            }
        },
        {
            /**
     * Get the value of the passed test, or undefined if the test failed.
     */ key: "get",
            value: function get() {
                return undefined;
            }
        },
        {
            /**
     * Get the value of the passed test, or throw an error if the test failed.
     */ key: "getOrThrow",
            value: function getOrThrow() {
                throw new Error(this.getFailMessage());
            }
        },
        {
            /**
     * The side data that will be passed to run.
     */ key: "getSideData",
            value: function getSideData() {
                throw new Error(this.getFailMessage());
            }
        },
        {
            /**
     * Get the failure message callback of the failed test, or undefined if the test passed.
     */ key: "getFailMessage",
            value: function getFailMessage() {
                return this.failMessage;
            }
        },
        {
            /**
     * For passed tests, map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     */ key: "map",
            value: function map() {
                return this;
            }
        },
        {
            key: "mapAsync",
            value: /**
     * For passed tests, asynchronously map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     */ function mapAsync() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return TestResultFailed;
}();
module.exports.TestResultFailed = $0d93d4811d2c20b0$var$TestResultFailed;

});





parcelRegister("7Vzoe", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInitQuery = void 0;

var $dXd9V = parcelRequire("dXd9V");

// Polyfills process.nextTick for readable-stream
globalThis.process = (parcelRequire("2Qkr5"));
var $5c594ef10e46d807$var$ActorInitQuery = /*#__PURE__*/ function(_ActorInitQueryBase_1_ActorInitQueryBase) {
    (0, $i3fW3._)(ActorInitQuery, _ActorInitQueryBase_1_ActorInitQueryBase);
    function ActorInitQuery() {
        (0, $jGAMp._)(this, ActorInitQuery);
        return (0, $kzDuW._)(this, ActorInitQuery, arguments);
    }
    return ActorInitQuery;
}($dXd9V.ActorInitQueryBase);
module.exports.ActorInitQuery = $5c594ef10e46d807$var$ActorInitQuery;

});
parcelRegister("2Qkr5", function(module, exports) {
// shim for using process in browser
var $21204a37c14e08e1$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $21204a37c14e08e1$var$cachedSetTimeout;
var $21204a37c14e08e1$var$cachedClearTimeout;
function $21204a37c14e08e1$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $21204a37c14e08e1$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $21204a37c14e08e1$var$cachedSetTimeout = setTimeout;
        else $21204a37c14e08e1$var$cachedSetTimeout = $21204a37c14e08e1$var$defaultSetTimout;
    } catch (e) {
        $21204a37c14e08e1$var$cachedSetTimeout = $21204a37c14e08e1$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $21204a37c14e08e1$var$cachedClearTimeout = clearTimeout;
        else $21204a37c14e08e1$var$cachedClearTimeout = $21204a37c14e08e1$var$defaultClearTimeout;
    } catch (e) {
        $21204a37c14e08e1$var$cachedClearTimeout = $21204a37c14e08e1$var$defaultClearTimeout;
    }
})();
function $21204a37c14e08e1$var$runTimeout(fun) {
    if ($21204a37c14e08e1$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($21204a37c14e08e1$var$cachedSetTimeout === $21204a37c14e08e1$var$defaultSetTimout || !$21204a37c14e08e1$var$cachedSetTimeout) && setTimeout) {
        $21204a37c14e08e1$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $21204a37c14e08e1$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $21204a37c14e08e1$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $21204a37c14e08e1$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $21204a37c14e08e1$var$runClearTimeout(marker) {
    if ($21204a37c14e08e1$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($21204a37c14e08e1$var$cachedClearTimeout === $21204a37c14e08e1$var$defaultClearTimeout || !$21204a37c14e08e1$var$cachedClearTimeout) && clearTimeout) {
        $21204a37c14e08e1$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $21204a37c14e08e1$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $21204a37c14e08e1$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $21204a37c14e08e1$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $21204a37c14e08e1$var$queue = [];
var $21204a37c14e08e1$var$draining = false;
var $21204a37c14e08e1$var$currentQueue;
var $21204a37c14e08e1$var$queueIndex = -1;
function $21204a37c14e08e1$var$cleanUpNextTick() {
    if (!$21204a37c14e08e1$var$draining || !$21204a37c14e08e1$var$currentQueue) return;
    $21204a37c14e08e1$var$draining = false;
    if ($21204a37c14e08e1$var$currentQueue.length) $21204a37c14e08e1$var$queue = $21204a37c14e08e1$var$currentQueue.concat($21204a37c14e08e1$var$queue);
    else $21204a37c14e08e1$var$queueIndex = -1;
    if ($21204a37c14e08e1$var$queue.length) $21204a37c14e08e1$var$drainQueue();
}
function $21204a37c14e08e1$var$drainQueue() {
    if ($21204a37c14e08e1$var$draining) return;
    var timeout = $21204a37c14e08e1$var$runTimeout($21204a37c14e08e1$var$cleanUpNextTick);
    $21204a37c14e08e1$var$draining = true;
    var len = $21204a37c14e08e1$var$queue.length;
    while(len){
        $21204a37c14e08e1$var$currentQueue = $21204a37c14e08e1$var$queue;
        $21204a37c14e08e1$var$queue = [];
        while(++$21204a37c14e08e1$var$queueIndex < len)if ($21204a37c14e08e1$var$currentQueue) $21204a37c14e08e1$var$currentQueue[$21204a37c14e08e1$var$queueIndex].run();
        $21204a37c14e08e1$var$queueIndex = -1;
        len = $21204a37c14e08e1$var$queue.length;
    }
    $21204a37c14e08e1$var$currentQueue = null;
    $21204a37c14e08e1$var$draining = false;
    $21204a37c14e08e1$var$runClearTimeout(timeout);
}
$21204a37c14e08e1$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $21204a37c14e08e1$var$queue.push(new $21204a37c14e08e1$var$Item(fun, args));
    if ($21204a37c14e08e1$var$queue.length === 1 && !$21204a37c14e08e1$var$draining) $21204a37c14e08e1$var$runTimeout($21204a37c14e08e1$var$drainQueue);
};
// v8 likes predictible objects
function $21204a37c14e08e1$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$21204a37c14e08e1$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$21204a37c14e08e1$var$process.title = 'browser';
$21204a37c14e08e1$var$process.browser = true;
$21204a37c14e08e1$var$process.env = {};
$21204a37c14e08e1$var$process.argv = [];
$21204a37c14e08e1$var$process.version = ''; // empty string to avoid regexp issues
$21204a37c14e08e1$var$process.versions = {};
function $21204a37c14e08e1$var$noop() {}
$21204a37c14e08e1$var$process.on = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.addListener = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.once = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.off = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.removeListener = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.removeAllListeners = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.emit = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.prependListener = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.prependOnceListener = $21204a37c14e08e1$var$noop;
$21204a37c14e08e1$var$process.listeners = function(name) {
    return [];
};
$21204a37c14e08e1$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$21204a37c14e08e1$var$process.cwd = function() {
    return '/';
};
$21204a37c14e08e1$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$21204a37c14e08e1$var$process.umask = function() {
    return 0;
};

});


parcelRegister("3buLn", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngineBase = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * Base implementation of a Comunica query engine.
 */ var $251a431e8e465795$var$QueryEngineBase = /*#__PURE__*/ function() {
    function QueryEngineBase(actorInitQuery) {
        (0, $jGAMp._)(this, QueryEngineBase);
        this.actorInitQuery = actorInitQuery;
    }
    (0, $byiyg._)(QueryEngineBase, [
        {
            key: "queryBindings",
            value: function queryBindings(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.queryOfType(query, context, 'bindings')
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.queryOfType(query, context, 'quads')
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.queryOfType(query, context, 'boolean')
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.queryOfType(query, context, 'void')
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryOfType",
            value: function queryOfType(query, context, expectedType) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var result;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.query(query, context)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(result.resultType === expectedType)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    result.execute()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                throw new Error("Query result type '".concat(expectedType, "' was expected, while '").concat(result.resultType, "' was found."));
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "query",
            value: /**
     * Evaluate the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @return {Promise<QueryType>} A promise that resolves to the query output.
     */ function query(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.queryOrExplain(query, context)
                                ];
                            case 1:
                                output = _state.sent();
                                if ('explain' in output) throw new Error("Tried to explain a query when in query-only mode");
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "explain",
            value: /**
     * Explain the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @param explainMode The explain mode.
     * @return {Promise<QueryType | IQueryExplained>} A promise that resolves to
     *                                                               the query output or explanation.
     */ function explain(query, context, explainMode) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context.explain = explainMode;
                                return [
                                    4,
                                    this.queryOrExplain(query, context)
                                ];
                            case 1:
                                output = _state.sent();
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "queryOrExplain",
            value: /**
     * Evaluate or explain the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @return {Promise<QueryType | IQueryExplained>} A promise that resolves to
     *                                                               the query output or explanation.
     */ function queryOrExplain(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var actionContext, result;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                actionContext = $kNNoa.ActionContext.ensureActionContext(context);
                                if (!actionContext.get($9nBhR.KeysInitQuery.invalidateCache)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.invalidateHttpCache()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    this.actorInitQuery.mediatorQueryProcess.mediate({
                                        query: query,
                                        context: actionContext
                                    })
                                ];
                            case 3:
                                result = _state.sent().result;
                                if ('explain' in result) return [
                                    2,
                                    result
                                ];
                                return [
                                    2,
                                    QueryEngineBase.internalToFinalResult(result)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getResultMediaTypes",
            value: /**
     * @param context An optional context.
     * @return {Promise<{[p: string]: number}>} All available SPARQL (weighted) result media types.
     */ function getResultMediaTypes(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = $kNNoa.ActionContext.ensureActionContext(context);
                                return [
                                    4,
                                    this.actorInitQuery.mediatorQueryResultSerializeMediaTypeCombiner.mediate({
                                        context: context,
                                        mediaTypes: true
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().mediaTypes
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getResultMediaTypeFormats",
            value: /**
     * @param context An optional context.
     * @return {Promise<{[p: string]: number}>} All available SPARQL result media type formats.
     */ function getResultMediaTypeFormats(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = $kNNoa.ActionContext.ensureActionContext(context);
                                return [
                                    4,
                                    this.actorInitQuery.mediatorQueryResultSerializeMediaTypeFormatCombiner.mediate({
                                        context: context,
                                        mediaTypeFormats: true
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().mediaTypeFormats
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resultToString",
            value: /**
     * Convert a query result to a string stream based on a certain media type.
     * @param {IQueryOperationResult} queryResult A query result.
     * @param {string} mediaType A media type.
     * @param {ActionContext} context An optional context.
     * @return {Promise<IActorQueryResultSerializeOutput>} A text stream.
     */ function resultToString(queryResult, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var handle, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = $kNNoa.ActionContext.ensureActionContext(context);
                                if (!mediaType) switch(queryResult.resultType){
                                    case 'bindings':
                                        mediaType = 'application/json';
                                        break;
                                    case 'quads':
                                        mediaType = 'application/trig';
                                        break;
                                    default:
                                        mediaType = 'simple';
                                        break;
                                }
                                _tmp = [
                                    {}
                                ];
                                return [
                                    4,
                                    QueryEngineBase.finalToInternalResult(queryResult)
                                ];
                            case 1:
                                handle = (0, $emQHU._).apply(void 0, [
                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                        _state.sent()
                                    ])),
                                    {
                                        context: context
                                    }
                                ]);
                                return [
                                    4,
                                    this.actorInitQuery.mediatorQueryResultSerialize.mediate({
                                        context: context,
                                        handle: handle,
                                        handleMediaType: mediaType
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().handle
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Invalidate all internal caches related to the given page URL.
     * If no page URL is given, then all pages will be invalidated.
     * @param {string} url The page URL to invalidate.
     * @param context An optional ActionContext to pass to the actors.
     * @return {Promise<any>} A promise resolving when the caches have been invalidated.
     */ key: "invalidateHttpCache",
            value: function invalidateHttpCache(url, context) {
                context = $kNNoa.ActionContext.ensureActionContext(context);
                return this.actorInitQuery.mediatorHttpInvalidate.mediate({
                    url: url,
                    context: context
                });
            }
        }
    ], [
        {
            key: "internalToFinalResult",
            value: /**
     * Convert an internal query result to a final one.
     * @param internalResult An intermediary query result.
     */ function internalToFinalResult(internalResult) {
                switch(internalResult.type){
                    case 'bindings':
                        return {
                            resultType: 'bindings',
                            execute: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            internalResult.bindingsStream
                                        ];
                                    });
                                })();
                            },
                            metadata: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    var meta;
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    internalResult.metadata()
                                                ];
                                            case 1:
                                                meta = _state.sent();
                                                meta.variables = meta.variables.map(function(variable) {
                                                    return variable.variable;
                                                });
                                                return [
                                                    2,
                                                    meta
                                                ];
                                        }
                                    });
                                })();
                            },
                            context: internalResult.context
                        };
                    case 'quads':
                        return {
                            resultType: 'quads',
                            execute: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            internalResult.quadStream
                                        ];
                                    });
                                })();
                            },
                            metadata: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    internalResult.metadata()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })();
                            },
                            context: internalResult.context
                        };
                    case 'boolean':
                        return {
                            resultType: 'boolean',
                            execute: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            internalResult.execute()
                                        ];
                                    });
                                })();
                            },
                            context: internalResult.context
                        };
                    case 'void':
                        return {
                            resultType: 'void',
                            execute: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            internalResult.execute()
                                        ];
                                    });
                                })();
                            },
                            context: internalResult.context
                        };
                }
            }
        },
        {
            key: "finalToInternalResult",
            value: /**
     * Convert a final query result to an internal one.
     * @param finalResult A final query result.
     */ function finalToInternalResult(finalResult) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _, _tmp, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = finalResult.resultType;
                                switch(_){
                                    case 'bindings':
                                        return [
                                            3,
                                            1
                                        ];
                                    case 'quads':
                                        return [
                                            3,
                                            3
                                        ];
                                    case 'boolean':
                                        return [
                                            3,
                                            5
                                        ];
                                    case 'void':
                                        return [
                                            3,
                                            6
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                _tmp = {
                                    type: 'bindings'
                                };
                                return [
                                    4,
                                    finalResult.execute()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_tmp.bindingsStream = _state.sent(), _tmp.metadata = function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var meta;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            finalResult.metadata()
                                                        ];
                                                    case 1:
                                                        meta = _state.sent();
                                                        meta.variables = meta.variables.map(function(variable) {
                                                            return {
                                                                variable: variable,
                                                                canBeUndef: false
                                                            };
                                                        });
                                                        return [
                                                            2,
                                                            meta
                                                        ];
                                                }
                                            });
                                        })();
                                    }, _tmp)
                                ];
                            case 3:
                                _tmp1 = {
                                    type: 'quads'
                                };
                                return [
                                    4,
                                    finalResult.execute()
                                ];
                            case 4:
                                return [
                                    2,
                                    (_tmp1.quadStream = _state.sent(), _tmp1.metadata = function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            finalResult.metadata()
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        })();
                                    }, _tmp1)
                                ];
                            case 5:
                                return [
                                    2,
                                    {
                                        type: 'boolean',
                                        execute: function() {
                                            return finalResult.execute();
                                        }
                                    }
                                ];
                            case 6:
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: function() {
                                            return finalResult.execute();
                                        }
                                    }
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return QueryEngineBase;
}();
module.exports.QueryEngineBase = $251a431e8e465795$var$QueryEngineBase;

});
parcelRegister("9nBhR", function(module, exports) {
"use strict";
var $6d432f7f40829b5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d432f7f40829b5f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d432f7f40829b5f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6d432f7f40829b5f$var$__exportStar((parcelRequire("kMAHP")), module.exports);

});
parcelRegister("kMAHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeysStatistics = module.exports.KeysRdfJoin = module.exports.KeysMergeBindingsContext = module.exports.KeysRdfUpdateQuads = module.exports.KeysQuerySourceIdentify = module.exports.KeysRdfParseHtmlScript = module.exports.KeysRdfParseJsonLd = module.exports.KeysQueryOperation = module.exports.KeysExpressionEvaluator = module.exports.KeysInitQuery = module.exports.KeysHttpProxy = module.exports.KeysHttpMemento = module.exports.KeysHttpWayback = module.exports.KeysHttp = module.exports.KeysCore = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * When adding entries to this file, also add a shortcut for them in the contextKeyShortcuts TSDoc comment in
 * ActorInitQueryBase in @comunica/actor-init-query if it makes sense to use this entry externally.
 * Also, add this shortcut to IQueryContextCommon in @comunica/types.
 */ module.exports.KeysCore = {
    // We create the core context keys in @comunica/core to avoid a cyclic dependency
    /**
     * A logger instance.
     */ log: $kNNoa.CONTEXT_KEY_LOGGER
};
module.exports.KeysHttp = {
    /**
     * Include credentials flags.
     */ includeCredentials: new $kNNoa.ActionContextKey('@comunica/bus-http:include-credentials'),
    /**
     * Authentication for a source as a "username:password"-pair.
     */ auth: new $kNNoa.ActionContextKey('@comunica/bus-http:auth'),
    /**
     * Fetch function implementation.
     */ fetch: new $kNNoa.ActionContextKey('@comunica/bus-http:fetch'),
    /**
     * HTTP request timeout in milliseconds.
     */ httpTimeout: new $kNNoa.ActionContextKey('@comunica/bus-http:http-timeout'),
    /**
     * Makes the HTTP timeout not only apply until the response starts streaming in
     * but until the response is fully consumed.
     */ httpBodyTimeout: new $kNNoa.ActionContextKey('@comunica/bus-http:http-body-timeout'),
    /**
     * Number of retries to make on failed network calls. This only takes effect
     * on errors thrown during the initial fetch() call and not while streaming the body.
     */ httpRetryCount: new $kNNoa.ActionContextKey('@comunica/bus-http:http-retry-count'),
    /**
     * The fallback retry delay in milliseconds. This value is used when a server does not
     * send a delay value in the Retry-After header or if the header value is incorrectly formatted.
     */ httpRetryDelayFallback: new $kNNoa.ActionContextKey('@comunica/bus-http:http-retry-delay-fallback'),
    /**
     * The upper limit for the retry delay in milliseconds. When a server requests a delay larger than this,
     * the engine will consider it unavailable until the specified timestamp is close enough.
     */ httpRetryDelayLimit: new $kNNoa.ActionContextKey('@comunica/bus-http:http-retry-delay-limit'),
    /**
     * HTTP status codes that should always trigger a retry, regardless of the default behaviour.
     * This can be used to, for example, force retries on server-side errors in the 500 range.
     */ httpRetryStatusCodes: new $kNNoa.ActionContextKey('@comunica/bus-http:http-retry-status-codes')
};
module.exports.KeysHttpWayback = {
    /**
     * Use the WayBack machine to get the most recent representation of a file if a link is broken.
     * @default false
     */ recoverBrokenLinks: new $kNNoa.ActionContextKey('@comunica/bus-http:recover-broken-links')
};
module.exports.KeysHttpMemento = {
    /**
     * The desired datetime for Memento datetime-negotiation.
     */ datetime: new $kNNoa.ActionContextKey('@comunica/actor-http-memento:datetime')
};
module.exports.KeysHttpProxy = {
    /**
     * Interface.
     */ httpProxyHandler: new $kNNoa.ActionContextKey('@comunica/actor-http-proxy:httpProxyHandler')
};
module.exports.KeysInitQuery = {
    /**
     * The unidentified sources to query over.
     */ querySourcesUnidentified: new $kNNoa.ActionContextKey('@comunica/actor-init-query:querySourcesUnidentified'),
    /**
     * Variables that have to be pre-bound to values in the query.
     */ initialBindings: new $kNNoa.ActionContextKey('@comunica/actor-init-query:initialBindings'),
    /**
     * The provided query's format.
     * Defaults to { language: 'sparql', version: '1.1' }
     */ queryFormat: new $kNNoa.ActionContextKey('@comunica/actor-init-query:queryFormat'),
    /**
     * Which GraphQL bindings should be singularized.
     */ graphqlSingularizeVariables: new $kNNoa.ActionContextKey('@comunica/actor-init-query:singularizeVariables'),
    /**
     * If HTTP and parsing failures are ignored.
     */ lenient: new $kNNoa.ActionContextKey('@comunica/actor-init-query:lenient'),
    /**
     * The original query string.
     */ queryString: new $kNNoa.ActionContextKey('@comunica/actor-init-query:queryString'),
    /**
     * The original parsed query.
     */ query: new $kNNoa.ActionContextKey('@comunica/actor-init-query:query'),
    /**
     * The query's base IRI.
     */ baseIRI: new $kNNoa.ActionContextKey('@comunica/actor-init-query:baseIRI'),
    /**
     * Object to cache function argument overload resolutions.
     * Defaults to an object that is reused across query executions.
     */ functionArgumentsCache: new $kNNoa.ActionContextKey('@comunica/actor-init-query:functionArgumentsCache'),
    /**
     * A timestamp representing the current time.
     * This is required for certain SPARQL operations such as NOW().
     */ queryTimestamp: new $kNNoa.ActionContextKey('@comunica/actor-init-query:queryTimestamp'),
    /**
     * A high resolution timestamp representing the time elapsed since Performance.timeOrigin`.
     * It can be used to precisely measure durations from the start of query execution.
     */ queryTimestampHighResolution: new $kNNoa.ActionContextKey('@comunica/actor-init-query:queryTimestampHighResolution'),
    /**
     * @range {functionNamedNode: RDF.NamedNode) => ((args: RDF.Term[]) => Promise<RDF.Term>) | undefined}
     * Extension function creator for a given function IRI.
     * Returned value should be an async function implementation.
     * Undefined may be returned if no implementation exists for the given function IRI.
     *
     * The dictionary-based extensionFunctions context entry may be used instead, but not simultaneously.
     */ extensionFunctionCreator: new $kNNoa.ActionContextKey('@comunica/actor-init-query:extensionFunctionCreator'),
    /**
     * Dictionary of extension functions.
     * Key is the IRI of the function, and value is the async function implementation.
     *
     * The callback-based extensionFunctionCreator context entry may be used instead, but not simultaneously.
     */ extensionFunctions: new $kNNoa.ActionContextKey('@comunica/actor-init-query:extensionFunctions'),
    /**
     * Enables manipulation of the CLI arguments and their processing.
     */ cliArgsHandlers: new $kNNoa.ActionContextKey('@comunica/actor-init-query:cliArgsHandlers'),
    /**
     * Explain mode of the query. Can be 'parsed', 'logical', 'physical', or 'physical-json'.
     */ explain: new $kNNoa.ActionContextKey('@comunica/actor-init-query:explain'),
    /**
     * Logs the used physical operators
     */ physicalQueryPlanLogger: new $kNNoa.ActionContextKey('@comunica/actor-init-query:physicalQueryPlanLogger'),
    /**
     * The current physical operator within the query plan.
     *              This is used to pass parent-child relationships for invoking the query plan logger.
     */ physicalQueryPlanNode: new $kNNoa.ActionContextKey('@comunica/actor-init-query:physicalQueryPlanNode'),
    /**
     * A JSON-LD context
     */ jsonLdContext: new $kNNoa.ActionContextKey('@context'),
    /**
     * A boolean value denoting whether caching is disabled or not.
     */ invalidateCache: new $kNNoa.ActionContextKey('@comunica/actor-init-query:invalidateCache'),
    /**
     * The data factory for creating terms and quads.
     */ dataFactory: new $kNNoa.ActionContextKey('@comunica/actor-init-query:dataFactory'),
    /**
     * A boolean value denoting whether results should be deduplicated or not.
     */ distinctConstruct: new $kNNoa.ActionContextKey('@comunica/actor-init-query:distinctConstruct')
};
module.exports.KeysExpressionEvaluator = {
    extensionFunctionCreator: new $kNNoa.ActionContextKey('@comunica/utils-expression-evaluator:extensionFunctionCreator'),
    superTypeProvider: new $kNNoa.ActionContextKey('@comunica/utils-expression-evaluator:superTypeProvider'),
    defaultTimeZone: new $kNNoa.ActionContextKey('@comunica/utils-expression-evaluator:defaultTimeZone'),
    actionContext: new $kNNoa.ActionContextKey('@comunica/utils-expression-evaluator:actionContext')
};
module.exports.KeysQueryOperation = {
    /**
     * Context entry for the current query operation.
     */ operation: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:operation'),
    /**
     * @type {any} The metadata from the left streams within a join operation.
     */ joinLeftMetadata: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:joinLeftMetadata'),
    /**
     * An array of metadata from the right streams within a join operation.
     */ joinRightMetadatas: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:joinRightMetadatas'),
    /**
     * Indicates the bindings that were used to bind the operation.
     */ joinBindings: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:joinBindings'),
    /**
     * Flag for indicating that only read operations are allowed, defaults to false.
     */ readOnly: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:readOnly'),
    /**
     * An internal context entry to mark that a property path with arbitrary length and a distinct key is being processed.
     */ isPathArbitraryLengthDistinctKey: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:isPathArbitraryLengthDistinct'),
    /**
     * An indicator that the stream will be limited to the given number of elements afterwards.
     */ limitIndicator: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:limitIndicator'),
    /**
     * If the default graph should also contain the union of all named graphs.
     */ unionDefaultGraph: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:unionDefaultGraph'),
    /**
     * The sources to query over.
     */ querySources: new $kNNoa.ActionContextKey('@comunica/bus-query-operation:querySources')
};
module.exports.KeysRdfParseJsonLd = {
    /**
     * @range {IDocumentLoader}
     */ documentLoader: new $kNNoa.ActionContextKey('@comunica/actor-rdf-parse-jsonld:documentLoader'),
    /**
     * @range {boolean}
     */ strictValues: new $kNNoa.ActionContextKey('@comunica/actor-rdf-parse-jsonld:strictValues'),
    /**
     * @range {Record<string, any>}
     */ parserOptions: new $kNNoa.ActionContextKey('@comunica/actor-rdf-parse-jsonld:parserOptions')
};
module.exports.KeysRdfParseHtmlScript = {
    /**
     * An internal context flag to determine if the engine is already processing an HTML script tag.
     */ processingHtmlScript: new $kNNoa.ActionContextKey('@comunica/actor-rdf-parse-html-script:processingHtmlScript'),
    /**
     * If all HTML script tags must be considered.
     */ extractAllScripts: new $kNNoa.ActionContextKey('extractAllScripts')
};
module.exports.KeysQuerySourceIdentify = {
    /**
     * A map containing unique IDs for each source
     */ sourceIds: new $kNNoa.ActionContextKey('@comunica/bus-query-source-identify:sourceIds'),
    /**
     * Hypermedia sources mapping to their aggregated store.
     */ hypermediaSourcesAggregatedStores: new $kNNoa.ActionContextKey('@comunica/bus-query-source-identify:hypermediaSourcesAggregatedStores'),
    /**
     * If links may be traversed from this source.
     * This means that sources annotated with this flag are considered incomplete until all links have been traversed.
     */ traverse: new $kNNoa.ActionContextKey('@comunica/bus-query-source-identify:traverse')
};
module.exports.KeysRdfUpdateQuads = {
    /**
     * A data destination.
     */ destination: new $kNNoa.ActionContextKey('@comunica/bus-rdf-update-quads:destination')
};
module.exports.KeysMergeBindingsContext = {
    /**
     * The data sources required to produce the binding
     */ sourcesBinding: new $kNNoa.ActionContextKey('@comunica/bus-merge-bindings-context:sourcesBinding')
};
module.exports.KeysRdfJoin = {
    /**
     * The last physical join actor that was executed.
     */ lastPhysicalJoin: new $kNNoa.ActionContextKey('@comunica/bus-rdf-join:lastPhysicalJoin')
};
module.exports.KeysStatistics = {
    /**
     * All discovered links during query execution. Not all of them will necessarily be dereferenced.
     */ discoveredLinks: new $kNNoa.ActionContextKey('@comunica/statistic:discoveredLinks'),
    /**
     * Information about what links are dereferenced and when
     */ dereferencedLinks: new $kNNoa.ActionContextKey('@comunica/statistic:dereferencedLinks'),
    /**
     * Intermediate results produced during query execution
     */ intermediateResults: new $kNNoa.ActionContextKey('@comunica/statistic:intermediateResults')
};

});




parcelRegister("fy2AY", function(module, exports) {

























































































































































































































































































































module.exports = function(variables) {
    function getVariableValue(name) {
        if (!variables || !(name in variables)) throw new Error('Undefined variable: ' + name);
        return variables[name];
    }
    var df_719_1 = new (parcelRequire("2auqX")).LoggerVoid();
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-init/^4.0.0/components/ActorInit.jsonld#ActorInit_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-context-preprocess/^4.0.0/components/ActorContextPreprocess.jsonld#ActorContextPreprocess_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-hash-bindings/^4.0.0/components/ActorHashBindings.jsonld#ActorHashBindings_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_quads__4_0_0_components_ActorHashQuads_jsonld_ActorHashQuads_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-hash-quads/^4.0.0/components/ActorHashQuads.jsonld#ActorHashQuads_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-optimize-query-operation/^4.0.0/components/ActorOptimizeQueryOperation.jsonld#ActorOptimizeQueryOperation_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-parse/^4.0.0/components/ActorQueryParse.jsonld#ActorQueryParse_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-result-serialize/^4.0.0/components/ActorQueryResultSerialize.jsonld#ActorQueryResultSerialize_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-source-identify-hypermedia/^4.0.0/components/ActorQuerySourceIdentifyHypermedia.jsonld#ActorQuerySourceIdentifyHypermedia_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-dereference/^4.0.0/components/ActorDereference.jsonld#ActorDereference_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-dereference-rdf/^4.0.0/components/ActorDereferenceRdf.jsonld#ActorDereferenceRdf_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join-entries-sort/^4.0.0/components/ActorRdfJoinEntriesSort.jsonld#ActorRdfJoinEntriesSort_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join-selectivity/^4.0.0/components/ActorRdfJoinSelectivity.jsonld#ActorRdfJoinSelectivity_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata/^4.0.0/components/ActorRdfMetadata.jsonld#ActorRdfMetadata_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata-accumulate/^4.0.0/components/ActorRdfMetadataAccumulate.jsonld#ActorRdfMetadataAccumulate_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata-extract/^4.0.0/components/ActorRdfMetadataExtract.jsonld#ActorRdfMetadataExtract_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse/^4.0.0/components/ActorRdfParse.jsonld#ActorRdfParse_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse-html/^4.0.0/components/ActorRdfParseHtml.jsonld#ActorRdfParseHtml_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-resolve-hypermedia-links/^4.0.0/components/ActorRdfResolveHypermediaLinks.jsonld#ActorRdfResolveHypermediaLinks_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-resolve-hypermedia-links-queue/^4.0.0/components/ActorRdfResolveHypermediaLinksQueue.jsonld#ActorRdfResolveHypermediaLinksQueue_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-serialize/^4.0.0/components/ActorRdfSerialize.jsonld#ActorRdfSerialize_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-update-hypermedia/^4.0.0/components/ActorRdfUpdateHypermedia.jsonld#ActorRdfUpdateHypermedia_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-update-quads/^4.0.0/components/ActorRdfUpdateQuads.jsonld#ActorRdfUpdateQuads_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-bindings-aggregator-factory/^4.0.0/components/ActorBindingsAggregatorFactory.jsonld#ActorBindingsAggregatorFactory_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-expression-evaluator-factory/^4.0.0/components/ActorExpressionEvaluatorFactory.jsonld#ActorExpressionEvaluatorFactory_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus = new (parcelRequire("1W2eA")).BusFunctionFactory({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-function-factory/^4.0.0/components/ActorFunctionFactory.jsonld#ActorFunctionFactory_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_fallback_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus = new (parcelRequire("dng5S")).BusQueryOperation({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-operation/^4.0.0/components/ActorQueryOperation.jsonld#ActorQueryOperation_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-process/^4.0.0/components/ActorQueryProcess.jsonld#ActorQueryProcess_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-source-identify/^4.0.0/components/ActorQuerySourceIdentify.jsonld#ActorQuerySourceIdentify_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join/^4.0.0/components/ActorRdfJoin.jsonld#ActorRdfJoin_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-term-comparator-factory/^4.0.0/components/ActorTermComparatorFactory.jsonld#ActorTermComparatorFactory_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http-invalidate/^4.0.0/components/ActorHttpInvalidate.jsonld#ActorHttpInvalidate_default_bus'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_merge_bindings_context__4_0_0_components_ActorMergeBindingsContext_jsonld_ActorMergeBindingsContext_default_bus = new (parcelRequire("kNNoa")).Bus({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-merge-bindings-context/^4.0.0/components/ActorMergeBindingsContext.jsonld#ActorMergeBindingsContext_default_bus'
    });
    var urn_comunica_default_context_preprocess_actors_convert_shortcuts = new (parcelRequire("fwfaU")).ActorContextPreprocessConvertShortcuts({
        contextKeyShortcuts: {
            baseIRI: "@comunica/actor-init-query:baseIRI",
            dataFactory: "@comunica/actor-init-query:dataFactory",
            datetime: "@comunica/actor-http-memento:datetime",
            destination: "@comunica/bus-rdf-update-quads:destination",
            distinctConstruct: "@comunica/actor-init-query:distinctConstruct",
            explain: "@comunica/actor-init-query:explain",
            extensionFunctionCreator: "@comunica/actor-init-query:extensionFunctionCreator",
            extensionFunctions: "@comunica/actor-init-query:extensionFunctions",
            fetch: "@comunica/bus-http:fetch",
            functionArgumentsCache: "@comunica/actor-init-query:functionArgumentsCache",
            httpAuth: "@comunica/bus-http:auth",
            httpBodyTimeout: "@comunica/bus-http:http-body-timeout",
            httpIncludeCredentials: "@comunica/bus-http:include-credentials",
            httpProxyHandler: "@comunica/actor-http-proxy:httpProxyHandler",
            httpRetryCount: "@comunica/bus-http:http-retry-count",
            httpRetryDelayFallback: "@comunica/bus-http:http-retry-delay-fallback",
            httpRetryDelayLimit: "@comunica/bus-http:http-retry-delay-limit",
            httpTimeout: "@comunica/bus-http:http-timeout",
            initialBindings: "@comunica/actor-init-query:initialBindings",
            invalidateCache: "@comunica/actor-init-query:invalidateCache",
            lenient: "@comunica/actor-init-query:lenient",
            log: "@comunica/core:log",
            queryFormat: "@comunica/actor-init-query:queryFormat",
            queryTimestamp: "@comunica/actor-init-query:queryTimestamp",
            queryTimestampHighResolution: "@comunica/actor-init-query:queryTimestampHighResolution",
            readOnly: "@comunica/bus-query-operation:readOnly",
            recoverBrokenLinks: "@comunica/bus-http-wayback:recover-broken-links",
            sources: "@comunica/actor-init-query:querySourcesUnidentified",
            traverse: "@comunica/bus-query-source-identify:traverse",
            unionDefaultGraph: "@comunica/bus-query-operation:unionDefaultGraph"
        },
        name: 'urn:comunica:default:context-preprocess/actors#convert-shortcuts',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        busFailMessage: 'Context preprocessing failed'
    });
    var urn_comunica_default_context_preprocess_actors_set_defaults = new (parcelRequire("6L2ur")).ActorContextPreprocessSetDefaults({
        logger: df_719_1,
        name: 'urn:comunica:default:context-preprocess/actors#set-defaults',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        busFailMessage: 'Context preprocessing failed'
    });
    var urn_comunica_default_context_preprocess_actors_source_to_destination = new (parcelRequire("7KrwB")).ActorContextPreprocessSourceToDestination({
        name: 'urn:comunica:default:context-preprocess/actors#source-to-destination',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        busFailMessage: 'Context preprocessing failed'
    });
    var urn_comunica_default_context_preprocess_actors_query_source_skolemize = new (parcelRequire("8rRId")).ActorContextPreprocessQuerySourceSkolemize({
        name: 'urn:comunica:default:context-preprocess/actors#query-source-skolemize',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        busFailMessage: 'Context preprocessing failed'
    });
    var urn_comunica_default_context_preprocess_mediators_main = new (parcelRequire("9CrIH")).MediatorCombinePipeline({
        name: 'urn:comunica:default:context-preprocess/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus
    });
    var urn_comunica_default_hash_bindings_actors_murmur = new (parcelRequire("lS8bs")).ActorHashBindingsMurmur({
        name: 'urn:comunica:default:hash-bindings/actors#murmur',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus,
        busFailMessage: 'Failed to obtaining hash functions for bindings'
    });
    var urn_comunica_default_hash_bindings_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:hash-bindings/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus
    });
    var urn_comunica_default_hash_quads_actors_murmur = new (parcelRequire("CX5dO")).ActorHashQuadsMurmur({
        name: 'urn:comunica:default:hash-quads/actors#murmur',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_quads__4_0_0_components_ActorHashQuads_jsonld_ActorHashQuads_default_bus,
        busFailMessage: 'Failed to obtaining hash functions for quads'
    });
    var urn_comunica_default_optimize_query_operation_actors_rewrite_copy = new (parcelRequire("TNyGX")).ActorOptimizeQueryOperationRewriteCopy({
        name: 'urn:comunica:default:optimize-query-operation/actors#rewrite-copy',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize'
    });
    var urn_comunica_default_optimize_query_operation_actors_rewrite_move = new (parcelRequire("kpzeU")).ActorOptimizeQueryOperationRewriteMove({
        name: 'urn:comunica:default:optimize-query-operation/actors#rewrite-move',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize'
    });
    var urn_comunica_default_optimize_query_operation_actors_rewrite_add = new (parcelRequire("f0pjo")).ActorOptimizeQueryOperationRewriteAdd({
        name: 'urn:comunica:default:optimize-query-operation/actors#rewrite-add',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize'
    });
    var urn_comunica_default_optimize_query_operation_actors_group_sources = new (parcelRequire("bW2V3")).ActorOptimizeQueryOperationGroupSources({
        name: 'urn:comunica:default:optimize-query-operation/actors#group-sources',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize'
    });
    var urn_comunica_default_optimize_query_operation_actors_construct_distinct = new (parcelRequire("jxoZy")).ActorOptimizeQueryOperationConstructDistinct({
        name: 'urn:comunica:default:optimize-query-operation/actors#construct-distinct',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize'
    });
    var urn_comunica_default_optimize_query_operation_mediators_main = new (parcelRequire("9CrIH")).MediatorCombinePipeline({
        filterFailures: true,
        name: 'urn:comunica:default:optimize-query-operation/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus
    });
    var urn_comunica_default_query_parse_actors_sparql = new (parcelRequire("iWUon")).ActorQueryParseSparql({
        prefixes: {
            dbpedia: "http://dbpedia.org/resource/",
            "dbpedia-owl": "http://dbpedia.org/ontology/",
            dbpprop: "http://dbpedia.org/property/",
            dc: "http://purl.org/dc/terms/",
            dc11: "http://purl.org/dc/elements/1.1/",
            dcterms: "http://purl.org/dc/terms/",
            foaf: "http://xmlns.com/foaf/0.1/",
            geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
            owl: "http://www.w3.org/2002/07/owl#",
            rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
            rdfs: "http://www.w3.org/2000/01/rdf-schema#",
            schema: "http://schema.org/",
            skos: "http://www.w3.org/2008/05/skos#",
            xsd: "http://www.w3.org/2001/XMLSchema#"
        },
        name: 'urn:comunica:default:query-parse/actors#sparql',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus,
        busFailMessage: 'Query parsing failed: none of the configured parsers were able to the query "${action.query}"'
    });
    var urn_comunica_default_query_parse_actors_graphql = new (parcelRequire("5d2MZ")).ActorQueryParseGraphql({
        name: 'urn:comunica:default:query-parse/actors#graphql',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus,
        busFailMessage: 'Query parsing failed: none of the configured parsers were able to the query "${action.query}"'
    });
    var urn_comunica_default_query_parse_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:query-parse/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus
    });
    var urn_comunica_default_query_result_serialize_actors_json = new (parcelRequire("jEzKP")).ActorQueryResultSerializeJson({
        mediaTypePriorities: {
            "application/json": 1
        },
        mediaTypeFormats: {
            "application/json": "https://comunica.linkeddatafragments.org/#results_JSON"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#json',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_simple = new (parcelRequire("bPDNl")).ActorQueryResultSerializeSimple({
        mediaTypePriorities: {
            simple: 0.9
        },
        mediaTypeFormats: {
            simple: "https://comunica.linkeddatafragments.org/#results_simple"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#simple',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_csv = new (parcelRequire("8YZmf")).ActorQueryResultSerializeSparqlCsv({
        mediaTypePriorities: {
            "text/csv": 0.75
        },
        mediaTypeFormats: {
            "text/csv": "http://www.w3.org/ns/formats/SPARQL_Results_CSV"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#csv',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_sparql_tsv = new (parcelRequire("49sET")).ActorQueryResultSerializeSparqlTsv({
        mediaTypePriorities: {
            "text/tab-separated-values": 0.75
        },
        mediaTypeFormats: {
            "text/tab-separated-values": "http://www.w3.org/ns/formats/SPARQL_Results_TSV"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#sparql-tsv',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_sparql_xml = new (parcelRequire("bhJ18")).ActorQueryResultSerializeSparqlXml({
        mediaTypePriorities: {
            "application/sparql-results+xml": 0.8
        },
        mediaTypeFormats: {
            "application/sparql-results+xml": "http://www.w3.org/ns/formats/SPARQL_Results_XML"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#sparql-xml',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_table = new (parcelRequire("3RGGg")).ActorQueryResultSerializeTable({
        columnWidth: 50,
        mediaTypePriorities: {
            table: 0.6
        },
        mediaTypeFormats: {
            table: "https://comunica.linkeddatafragments.org/#results_table"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#table',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_tree = new (parcelRequire("mFOgG")).ActorQueryResultSerializeTree({
        mediaTypePriorities: {
            tree: 0.5
        },
        mediaTypeFormats: {
            tree: "https://comunica.linkeddatafragments.org/#results_tree"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#tree',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_mediators_serialize = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:query-result-serialize/mediators#serialize',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    var urn_comunica_default_query_result_serialize_mediators_mediaType = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mediaTypes',
        name: 'urn:comunica:default:query-result-serialize/mediators#mediaType',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    var urn_comunica_default_query_result_serialize_mediators_mediaTypeFormat = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mediaTypeFormats',
        name: 'urn:comunica:default:query-result-serialize/mediators#mediaTypeFormat',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    var urn_comunica_default_query_source_identify_hypermedia_mediators_main = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'filterFactor',
        type: 'max',
        ignoreFailures: true,
        name: 'urn:comunica:default:query-source-identify-hypermedia/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus
    });
    var urn_comunica_default_dereference_actors_fallback = new (parcelRequire("l1kfs")).ActorDereferenceFallback({
        name: 'urn:comunica:default:dereference/actors#fallback',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus,
        busFailMessage: 'Dereferencing failed: none of the configured actors were able to handle ${action.url}'
    });
    var urn_comunica_default_dereference_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:dereference/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus
    });
    var urn_comunica_default_dereference_rdf_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:dereference-rdf/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus
    });
    var urn_comunica_default_rdf_join_entries_sort_actors_cardinality = new (parcelRequire("kxo2X")).ActorRdfJoinEntriesSortCardinality({
        name: 'urn:comunica:default:rdf-join-entries-sort/actors#cardinality',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus,
        busFailMessage: 'Sorting join entries failed: none of the configured actors were able to sort'
    });
    var urn_comunica_default_rdf_join_entries_sort_mediators_main = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'accuracy',
        type: 'max',
        ignoreFailures: true,
        name: 'urn:comunica:default:rdf-join-entries-sort/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus
    });
    var urn_comunica_default_rdf_join_selectivity_actors_variable_counting = new (parcelRequire("lJFm0")).ActorRdfJoinSelectivityVariableCounting({
        name: 'urn:comunica:default:rdf-join-selectivity/actors#variable-counting',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus,
        busFailMessage: 'Determining join selectivity failed: none of the configured actors were able to calculate selectivities'
    });
    var urn_comunica_default_rdf_join_selectivity_mediators_main = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'accuracy',
        type: 'max',
        ignoreFailures: true,
        name: 'urn:comunica:default:rdf-join-selectivity/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus
    });
    var urn_comunica_default_rdf_metadata_actors_primary_topic = new (parcelRequire("2lLvY")).ActorRdfMetadataPrimaryTopic({
        metadataToData: false,
        dataToMetadataOnInvalidMetadataGraph: true,
        name: 'urn:comunica:default:rdf-metadata/actors#primary-topic',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus,
        busFailMessage: 'Metadata splicing failed: none of the configured actors were able to splice metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_actors_all = new (parcelRequire("4CCr8")).ActorRdfMetadataAll({
        name: 'urn:comunica:default:rdf-metadata/actors#all',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus,
        busFailMessage: 'Metadata splicing failed: none of the configured actors were able to splice metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-metadata/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus
    });
    var urn_comunica_default_rdf_metadata_accumulate_actors_cardinality = new (parcelRequire("l0iVg")).ActorRdfMetadataAccumulateCardinality({
        name: 'urn:comunica:default:rdf-metadata-accumulate/actors#cardinality',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        busFailMessage: 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    var urn_comunica_default_rdf_metadata_accumulate_actors_pagesize = new (parcelRequire("kF6rE")).ActorRdfMetadataAccumulatePageSize({
        name: 'urn:comunica:default:rdf-metadata-accumulate/actors#pagesize',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        busFailMessage: 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    var urn_comunica_default_rdf_metadata_accumulate_actors_requesttime = new (parcelRequire("jslhI")).ActorRdfMetadataAccumulateRequestTime({
        name: 'urn:comunica:default:rdf-metadata-accumulate/actors#requesttime',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        busFailMessage: 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    var urn_comunica_default_rdf_metadata_accumulate_mediators_main = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'metadata',
        name: 'urn:comunica:default:rdf-metadata-accumulate/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus
    });
    var urn_comunica_default_rdf_metadata_extract_actors_hydra_controls = new (parcelRequire("45Y83")).ActorRdfMetadataExtractHydraControls({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#hydra-controls',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_hydra_count = new (parcelRequire("dvyct")).ActorRdfMetadataExtractHydraCount({
        predicates: [
            'http://www.w3.org/ns/hydra/core#totalItems',
            'http://rdfs.org/ns/void#triples'
        ],
        name: 'urn:comunica:default:rdf-metadata-extract/actors#hydra-count',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_hydra_pagesize = new (parcelRequire("2yLVw")).ActorRdfMetadataExtractHydraPagesize({
        predicates: [
            'http://www.w3.org/ns/hydra/core#itemsPerPage'
        ],
        name: 'urn:comunica:default:rdf-metadata-extract/actors#hydra-pagesize',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_request_time = new (parcelRequire("4F2wW")).ActorRdfMetadataExtractRequestTime({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#request-time',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_allow_http_methods = new (parcelRequire("4FR6v")).ActorRdfMetadataExtractAllowHttpMethods({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#allow-http-methods',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_put_accepted = new (parcelRequire("3yj2a")).ActorRdfMetadataExtractPutAccepted({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#put-accepted',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_patch_sparql_update = new (parcelRequire("kG9HC")).ActorRdfMetadataExtractPatchSparqlUpdate({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#patch-sparql-update',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_sparql_service = new (parcelRequire("h1Oj6")).ActorRdfMetadataExtractSparqlService({
        inferHttpsEndpoint: true,
        name: 'urn:comunica:default:rdf-metadata-extract/actors#sparql-service',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_actors_void = new (parcelRequire("hqvPN")).ActorRdfMetadataExtractVoid({
        name: 'urn:comunica:default:rdf-metadata-extract/actors#void',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        busFailMessage: 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    var urn_comunica_default_rdf_metadata_extract_mediators_main = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        filterFailures: true,
        field: 'metadata',
        name: 'urn:comunica:default:rdf-metadata-extract/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus
    });
    var urn_comunica_default_rdf_parse_actors_n3 = new (parcelRequire("lrPxK")).ActorRdfParseN3({
        mediaTypePriorities: {
            "application/n-quads": 1,
            "application/n-triples": 0.8,
            "application/trig": 0.95,
            "text/n3": 0.35,
            "text/turtle": 0.6
        },
        mediaTypeFormats: {
            "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
            "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
            "application/trig": "http://www.w3.org/ns/formats/TriG",
            "text/n3": "http://www.w3.org/ns/formats/N3",
            "text/turtle": "http://www.w3.org/ns/formats/Turtle"
        },
        priorityScale: 1,
        name: 'urn:comunica:default:rdf-parse/actors#n3',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_actors_rdfxml = new (parcelRequire("gUxwi")).ActorRdfParseRdfXml({
        mediaTypePriorities: {
            "application/rdf+xml": 1
        },
        mediaTypeFormats: {
            "application/rdf+xml": "http://www.w3.org/ns/formats/RDF_XML"
        },
        priorityScale: 0.5,
        name: 'urn:comunica:default:rdf-parse/actors#rdfxml',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_actors_xmlrdfa = new (parcelRequire("7BGO6")).ActorRdfParseXmlRdfa({
        mediaTypePriorities: {
            "application/xml": 1,
            "image/svg+xml": 1,
            "text/xml": 1
        },
        mediaTypeFormats: {
            "application/xml": "http://www.w3.org/ns/formats/RDFa",
            "image/svg+xml": "http://www.w3.org/ns/formats/RDFa",
            "text/xml": "http://www.w3.org/ns/formats/RDFa"
        },
        priorityScale: 0.3,
        name: 'urn:comunica:default:rdf-parse/actors#xmlrdfa',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_actors_shaclc = new (parcelRequire("1slhB")).ActorRdfParseShaclc({
        mediaTypePriorities: {
            "text/shaclc": 1,
            "text/shaclc-ext": 0.5
        },
        mediaTypeFormats: {
            "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
            "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
        },
        priorityScale: 0.1,
        name: 'urn:comunica:default:rdf-parse/actors#shaclc',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_mediators_parse = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-parse/mediators#parse',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus
    });
    var urn_comunica_default_rdf_parse_mediators_mediaType = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mediaTypes',
        name: 'urn:comunica:default:rdf-parse/mediators#mediaType',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus
    });
    var urn_comunica_default_rdf_parse_actors_html = new (parcelRequire("en4lX")).ActorRdfParseHtml({
        busRdfParseHtml: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        mediaTypePriorities: {
            "application/xhtml+xml": 0.9,
            "text/html": 1
        },
        mediaTypeFormats: {
            "application/xhtml+xml": "http://www.w3.org/ns/formats/HTML",
            "text/html": "http://www.w3.org/ns/formats/HTML"
        },
        priorityScale: 0.2,
        name: 'urn:comunica:default:rdf-parse/actors#html',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_html_actors_microdata = new (parcelRequire("2DXpo")).ActorRdfParseHtmlMicrodata({
        name: 'urn:comunica:default:rdf-parse-html/actors#microdata',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        busFailMessage: 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    var urn_comunica_default_rdf_parse_html_actors_rdfa = new (parcelRequire("djEjK")).ActorRdfParseHtmlRdfa({
        name: 'urn:comunica:default:rdf-parse-html/actors#rdfa',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        busFailMessage: 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    var urn_comunica_default_rdf_resolve_hypermedia_links_actors_next = new (parcelRequire("hB6KM")).ActorRdfResolveHypermediaLinksNext({
        name: 'urn:comunica:default:rdf-resolve-hypermedia-links/actors#next',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus,
        busFailMessage: 'Hypermedia link resolution failed: none of the configured actors were able to resolve links from metadata'
    });
    var urn_comunica_default_rdf_resolve_hypermedia_links_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-resolve-hypermedia-links/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus
    });
    var urn_comunica_default_rdf_resolve_hypermedia_links_queue_actors_fifo = new (parcelRequire("cGWfA")).ActorRdfResolveHypermediaLinksQueueFifo({
        name: 'urn:comunica:default:rdf-resolve-hypermedia-links-queue/actors#fifo',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus,
        busFailMessage: 'Link queue creation failed: none of the configured actors were able to create a link queue starting from ${action.firstUrl}'
    });
    var urn_comunica_default_rdf_resolve_hypermedia_links_queue_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-resolve-hypermedia-links-queue/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus
    });
    var urn_comunica_default_rdf_serialize_actors_n3 = new (parcelRequire("blqeN")).ActorRdfSerializeN3({
        mediaTypePriorities: {
            "application/n-quads": 1,
            "application/n-triples": 0.8,
            "application/trig": 0.95,
            "text/n3": 0.35,
            "text/turtle": 0.6
        },
        mediaTypeFormats: {
            "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
            "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
            "application/trig": "http://www.w3.org/ns/formats/TriG",
            "text/n3": "http://www.w3.org/ns/formats/N3",
            "text/turtle": "http://www.w3.org/ns/formats/Turtle"
        },
        name: 'urn:comunica:default:rdf-serialize/actors#n3',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        busFailMessage: 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    var urn_comunica_default_rdf_serialize_actors_jsonld = new (parcelRequire("7Vy2O")).ActorRdfSerializeJsonLd({
        jsonStringifyIndentSpaces: 2,
        mediaTypePriorities: {
            "application/ld+json": 1
        },
        mediaTypeFormats: {
            "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD"
        },
        priorityScale: 0.9,
        name: 'urn:comunica:default:rdf-serialize/actors#jsonld',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        busFailMessage: 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    var urn_comunica_default_rdf_serialize_actors_shaclc = new (parcelRequire("3HhXO")).ActorRdfSerializeShaclc({
        mediaTypePriorities: {
            "text/shaclc": 1,
            "text/shaclc-ext": 0.5
        },
        mediaTypeFormats: {
            "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
            "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
        },
        priorityScale: 0.1,
        name: 'urn:comunica:default:rdf-serialize/actors#shaclc',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        busFailMessage: 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    var urn_comunica_default_rdf_serialize_mediators_serialize = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-serialize/mediators#serialize',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    var urn_comunica_default_rdf_serialize_mediators_mediaType = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mediaTypes',
        name: 'urn:comunica:default:rdf-serialize/mediators#mediaType',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    var urn_comunica_default_rdf_serialize_mediators_mediaTypeFormat = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mediaTypeFormats',
        name: 'urn:comunica:default:rdf-serialize/mediators#mediaTypeFormat',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    var urn_comunica_default_rdf_update_hypermedia_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-update-hypermedia/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus
    });
    var urn_comunica_default_rdf_update_quads_actors_rdfjs_store = new (parcelRequire("5qvrA")).ActorRdfUpdateQuadsRdfJsStore({
        name: 'urn:comunica:default:rdf-update-quads/actors#rdfjs-store',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus,
        busFailMessage: 'RDF updating failed: none of the configured actors were able to handle an update'
    });
    var urn_comunica_default_rdf_update_quads_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:rdf-update-quads/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus
    });
    var urn_comunica_default_bindings_aggregator_factory_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:bindings-aggregator-factory/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus
    });
    var urn_comunica_default_expression_evaluator_factory_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:expression-evaluator-factory/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus
    });
    var urn_comunica_default_function_factory_actors_expression_function_bnode = new (parcelRequire("fTJn2")).ActorFunctionFactoryExpressionBnode({
        name: 'urn:comunica:default:function-factory/actors#expression-function-bnode',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_bound = new (parcelRequire("kcyoh")).ActorFunctionFactoryExpressionBound({
        name: 'urn:comunica:default:function-factory/actors#expression-function-bound',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_coalesce = new (parcelRequire("g1xTT")).ActorFunctionFactoryExpressionCoalesce({
        name: 'urn:comunica:default:function-factory/actors#expression-function-coalesce',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_concat = new (parcelRequire("fEb1l")).ActorFunctionFactoryExpressionConcat({
        name: 'urn:comunica:default:function-factory/actors#expression-function-concat',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_extensions = new (parcelRequire("fzdBt")).ActorFunctionFactoryExpressionExtensions({
        name: 'urn:comunica:default:function-factory/actors#expression-function-extensions',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_if = new (parcelRequire("9Sd9e")).ActorFunctionFactoryExpressionIf({
        name: 'urn:comunica:default:function-factory/actors#expression-function-if',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_logical_and = new (parcelRequire("lXYT0")).ActorFunctionFactoryExpressionLogicalAnd({
        name: 'urn:comunica:default:function-factory/actors#expression-function-logical-and',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_logical_or = new (parcelRequire("g12h3")).ActorFunctionFactoryExpressionLogicalOr({
        name: 'urn:comunica:default:function-factory/actors#expression-function-logical-or',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_same_term = new (parcelRequire("eIuJ6")).ActorFunctionFactoryExpressionSameTerm({
        name: 'urn:comunica:default:function-factory/actors#expression-function-same-term',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_abs = new (parcelRequire("gpQB3")).ActorFunctionFactoryTermAbs({
        name: 'urn:comunica:default:function-factory/actors#term-function-abs',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_addition = new (parcelRequire("hGtWh")).ActorFunctionFactoryTermAddition({
        name: 'urn:comunica:default:function-factory/actors#term-function-addition',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_ceil = new (parcelRequire("kKFFN")).ActorFunctionFactoryTermCeil({
        name: 'urn:comunica:default:function-factory/actors#term-function-ceil',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_contains = new (parcelRequire("gePIu")).ActorFunctionFactoryTermContains({
        name: 'urn:comunica:default:function-factory/actors#term-function-contains',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_datatype = new (parcelRequire("2bGm8")).ActorFunctionFactoryTermDatatype({
        name: 'urn:comunica:default:function-factory/actors#term-function-datatype',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_day = new (parcelRequire("esdDo")).ActorFunctionFactoryTermDay({
        name: 'urn:comunica:default:function-factory/actors#term-function-day',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_division = new (parcelRequire("dOomI")).ActorFunctionFactoryTermDivision({
        name: 'urn:comunica:default:function-factory/actors#term-function-division',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_encode_for_uri = new (parcelRequire("jD9Kl")).ActorFunctionFactoryTermEncodeForUri({
        name: 'urn:comunica:default:function-factory/actors#term-function-encode-for-uri',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_equality = new (parcelRequire("1lRUZ")).ActorFunctionFactoryTermEquality({
        name: 'urn:comunica:default:function-factory/actors#term-function-equality',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_floor = new (parcelRequire("kG6VY")).ActorFunctionFactoryTermFloor({
        name: 'urn:comunica:default:function-factory/actors#term-function-floor',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_hours = new (parcelRequire("hUUIQ")).ActorFunctionFactoryTermHours({
        name: 'urn:comunica:default:function-factory/actors#term-function-hours',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_iri = new (parcelRequire("lOdya")).ActorFunctionFactoryTermIri({
        name: 'urn:comunica:default:function-factory/actors#term-function-iri',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_is_blank = new (parcelRequire("iiju5")).ActorFunctionFactoryTermIsBlank({
        name: 'urn:comunica:default:function-factory/actors#term-function-is-blank',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_is_iri = new (parcelRequire("4q8EB")).ActorFunctionFactoryTermIsIri({
        name: 'urn:comunica:default:function-factory/actors#term-function-is-iri',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_is_literal = new (parcelRequire("bxCon")).ActorFunctionFactoryTermIsLiteral({
        name: 'urn:comunica:default:function-factory/actors#term-function-is-literal',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_is_numeric = new (parcelRequire("bNFsp")).ActorFunctionFactoryTermIsNumeric({
        name: 'urn:comunica:default:function-factory/actors#term-function-is-numeric',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_is_triple = new (parcelRequire("1Fvoy")).ActorFunctionFactoryTermIsTriple({
        name: 'urn:comunica:default:function-factory/actors#term-function-is-triple',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_lang = new (parcelRequire("hF0s3")).ActorFunctionFactoryTermLang({
        name: 'urn:comunica:default:function-factory/actors#term-function-lang',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_langmatches = new (parcelRequire("hnfyg")).ActorFunctionFactoryTermLangmatches({
        name: 'urn:comunica:default:function-factory/actors#term-function-langmatches',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_lcase = new (parcelRequire("6QSwS")).ActorFunctionFactoryTermLcase({
        name: 'urn:comunica:default:function-factory/actors#term-function-lcase',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_md5 = new (parcelRequire("8X8wJ")).ActorFunctionFactoryTermMd5({
        name: 'urn:comunica:default:function-factory/actors#term-function-md5',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_minutes = new (parcelRequire("ktqm3")).ActorFunctionFactoryTermMinutes({
        name: 'urn:comunica:default:function-factory/actors#term-function-minutes',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_month = new (parcelRequire("kJHq1")).ActorFunctionFactoryTermMonth({
        name: 'urn:comunica:default:function-factory/actors#term-function-month',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_multiplication = new (parcelRequire("1F228")).ActorFunctionFactoryTermMultiplication({
        name: 'urn:comunica:default:function-factory/actors#term-function-multiplication',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_not = new (parcelRequire("fEqC4")).ActorFunctionFactoryTermNot({
        name: 'urn:comunica:default:function-factory/actors#term-function-not',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_now = new (parcelRequire("2g5Io")).ActorFunctionFactoryTermNow({
        name: 'urn:comunica:default:function-factory/actors#term-function-now',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_object = new (parcelRequire("2gkFS")).ActorFunctionFactoryTermObject({
        name: 'urn:comunica:default:function-factory/actors#term-function-object',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_predicate = new (parcelRequire("bgUrQ")).ActorFunctionFactoryTermPredicate({
        name: 'urn:comunica:default:function-factory/actors#term-function-predicate',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_rand = new (parcelRequire("luK5n")).ActorFunctionFactoryTermRand({
        name: 'urn:comunica:default:function-factory/actors#term-function-rand',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_regex = new (parcelRequire("hWbTr")).ActorFunctionFactoryTermRegex({
        name: 'urn:comunica:default:function-factory/actors#term-function-regex',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_replace = new (parcelRequire("9gzVJ")).ActorFunctionFactoryTermReplace({
        name: 'urn:comunica:default:function-factory/actors#term-function-replace',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_round = new (parcelRequire("hECp6")).ActorFunctionFactoryTermRound({
        name: 'urn:comunica:default:function-factory/actors#term-function-round',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_seconds = new (parcelRequire("evz6F")).ActorFunctionFactoryTermSeconds({
        name: 'urn:comunica:default:function-factory/actors#term-function-seconds',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_sha1 = new (parcelRequire("iwuut")).ActorFunctionFactoryTermSha1({
        name: 'urn:comunica:default:function-factory/actors#term-function-sha1',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_sha256 = new (parcelRequire("lKx3X")).ActorFunctionFactoryTermSha256({
        name: 'urn:comunica:default:function-factory/actors#term-function-sha256',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_sha384 = new (parcelRequire("i8gx1")).ActorFunctionFactoryTermSha384({
        name: 'urn:comunica:default:function-factory/actors#term-function-sha384',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_sha512 = new (parcelRequire("3kz0A")).ActorFunctionFactoryTermSha512({
        name: 'urn:comunica:default:function-factory/actors#term-function-sha512',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_after = new (parcelRequire("bfIpY")).ActorFunctionFactoryTermStrAfter({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-after',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_before = new (parcelRequire("fpz1G")).ActorFunctionFactoryTermStrBefore({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-before',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_dt = new (parcelRequire("bO2Yg")).ActorFunctionFactoryTermStrDt({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-dt',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_ends = new (parcelRequire("04ryT")).ActorFunctionFactoryTermStrEnds({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-ends',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_lang = new (parcelRequire("7lURB")).ActorFunctionFactoryTermStrLang({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-lang',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_len = new (parcelRequire("98mTy")).ActorFunctionFactoryTermStrLen({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-len',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_starts = new (parcelRequire("l0rRO")).ActorFunctionFactoryTermStrStarts({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-starts',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str_uuid = new (parcelRequire("5NCvw")).ActorFunctionFactoryTermStrUuid({
        name: 'urn:comunica:default:function-factory/actors#term-function-str-uuid',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_str = new (parcelRequire("9WRq4")).ActorFunctionFactoryTermStr({
        name: 'urn:comunica:default:function-factory/actors#term-function-str',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_sub_str = new (parcelRequire("6phxZ")).ActorFunctionFactoryTermSubStr({
        name: 'urn:comunica:default:function-factory/actors#term-function-sub-str',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_subject = new (parcelRequire("1PbTR")).ActorFunctionFactoryTermSubject({
        name: 'urn:comunica:default:function-factory/actors#term-function-subject',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_subtraction = new (parcelRequire("jK0VQ")).ActorFunctionFactoryTermSubtraction({
        name: 'urn:comunica:default:function-factory/actors#term-function-subtraction',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_timezone = new (parcelRequire("5RCgw")).ActorFunctionFactoryTermTimezone({
        name: 'urn:comunica:default:function-factory/actors#term-function-timezone',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_triple = new (parcelRequire("446W0")).ActorFunctionFactoryTermTriple({
        name: 'urn:comunica:default:function-factory/actors#term-function-triple',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_tz = new (parcelRequire("8ayCt")).ActorFunctionFactoryTermTz({
        name: 'urn:comunica:default:function-factory/actors#term-function-tz',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_ucase = new (parcelRequire("9ojU7")).ActorFunctionFactoryTermUcase({
        name: 'urn:comunica:default:function-factory/actors#term-function-ucase',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_unary_minus = new (parcelRequire("bUWt8")).ActorFunctionFactoryTermUnaryMinus({
        name: 'urn:comunica:default:function-factory/actors#term-function-unary-minus',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_unary_plus = new (parcelRequire("8xIuJ")).ActorFunctionFactoryTermUnaryPlus({
        name: 'urn:comunica:default:function-factory/actors#term-function-unary-plus',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_uuid = new (parcelRequire("8BVL0")).ActorFunctionFactoryTermUuid({
        name: 'urn:comunica:default:function-factory/actors#term-function-uuid',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_boolean = new (parcelRequire("jVMit")).ActorFunctionFactoryTermXsdToBoolean({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-boolean',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_date = new (parcelRequire("e8Qpy")).ActorFunctionFactoryTermXsdToDate({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-date',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_datetime = new (parcelRequire("eywyp")).ActorFunctionFactoryTermXsdToDatetime({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-datetime',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_day_time_duration = new (parcelRequire("eV8N9")).ActorFunctionFactoryTermXsdToDayTimeDuration({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-day-time-duration',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_decimal = new (parcelRequire("9vlPs")).ActorFunctionFactoryTermXsdToDecimal({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-decimal',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_double = new (parcelRequire("eE7o6")).ActorFunctionFactoryTermXsdToDouble({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-double',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_duration = new (parcelRequire("kWp2j")).ActorFunctionFactoryTermXsdToDuration({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-duration',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_float = new (parcelRequire("aOUuf")).ActorFunctionFactoryTermXsdToFloat({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-float',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_integer = new (parcelRequire("hN8E0")).ActorFunctionFactoryTermXsdToInteger({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-integer',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_string = new (parcelRequire("bcjoZ")).ActorFunctionFactoryTermXsdToString({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-string',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_time = new (parcelRequire("iseW2")).ActorFunctionFactoryTermXsdToTime({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-time',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_xsd_to_year_month_duration = new (parcelRequire("cL8W5")).ActorFunctionFactoryTermXsdToYearMonthDuration({
        name: 'urn:comunica:default:function-factory/actors#term-function-xsd-to-year-month-duration',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_year = new (parcelRequire("1TYtu")).ActorFunctionFactoryTermYear({
        name: 'urn:comunica:default:function-factory/actors#term-function-year',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:function-factory/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus
    });
    var urn_comunica_default_http_actors_fetch = new (parcelRequire("3Yylx")).ActorHttpFetch({
        agentOptions: {
            keepAlive: true,
            maxSockets: 5
        },
        name: 'urn:comunica:default:http/actors#fetch',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        busFailMessage: 'HTTP request failed: none of the configured actors were able to handle ${action.input}'
    });
    var urn_comunica_default_http_mediators_no_fallback = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'time',
        type: 'min',
        ignoreFailures: true,
        name: 'urn:comunica:default:http/mediators#no-fallback',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    var urn_comunica_default_http_mediators_main = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'time',
        type: 'min',
        ignoreFailures: true,
        name: 'urn:comunica:default:http/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus
    });
    var urn_comunica_default_query_operation_actors_source = new (parcelRequire("g7ZYB")).ActorQueryOperationSource({
        name: 'urn:comunica:default:query-operation/actors#source',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_mediators_main = new (parcelRequire("ci2mP")).MediatorNumber({
        field: 'httpRequests',
        type: 'min',
        ignoreFailures: true,
        name: 'urn:comunica:default:query-operation/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus
    });
    var urn_comunica_default_query_process_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:query-process/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus
    });
    var urn_comunica_default_query_source_identify_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:query-source-identify/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus
    });
    var urn_comunica_default_rdf_join_mediators_main = new (parcelRequire("9S8Do")).MediatorJoinCoefficientsFixed({
        cpuWeight: 10,
        memoryWeight: 1,
        timeWeight: 2,
        ioWeight: 10,
        name: 'urn:comunica:default:rdf-join/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus
    });
    var urn_comunica_default_term_comparator_factory_mediators_main = new (parcelRequire("IQBqE")).MediatorRace({
        name: 'urn:comunica:default:term-comparator-factory/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_context_preprocess_query_source_identify__4_0_0_components_ActorContextPreprocessQuerySourceIdentify_jsonld_IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-context-preprocess-query-source-identify/^4.0.0/components/ActorContextPreprocessQuerySourceIdentify.jsonld#IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var urn_comunica_default_http_invalidate_mediators_main = new (parcelRequire("dKlTA")).MediatorAll({
        name: 'urn:comunica:default:http-invalidate/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_rdf_update_quads_hypermedia__4_0_0_components_ActorRdfUpdateQuadsHypermedia_jsonld_IActorRdfUpdateQuadsHypermediaArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-rdf-update-quads-hypermedia/^4.0.0/components/ActorRdfUpdateQuadsHypermedia.jsonld#IActorRdfUpdateQuadsHypermediaArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_retry__4_0_0_components_ActorHttpRetry_jsonld_IActorHttpQueueArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-http-retry/^4.0.0/components/ActorHttpRetry.jsonld#IActorHttpQueueArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_limit_rate__4_0_0_components_ActorHttpLimitRate_jsonld_IActorHttpLimitRateArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-http-limit-rate/^4.0.0/components/ActorHttpLimitRate.jsonld#IActorHttpLimitRateArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-sparql-json/^4.0.0/components/ActionObserverHttp.jsonld#IActionObserverHttpArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator = new (parcelRequire("cGCel")).ActorHttpInvalidateListenable({
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-stats/^4.0.0/components/ActionObserverHttp.jsonld#IActionObserverHttpArgs_default_invalidator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        busFailMessage: 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    var urn_comunica_default_merge_bindings_context_mediators_main = new (parcelRequire("ggXMo")).MediatorCombineUnion({
        field: 'mergeHandlers',
        name: 'urn:comunica:default:merge-bindings-context/mediators#main',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_merge_bindings_context__4_0_0_components_ActorMergeBindingsContext_jsonld_ActorMergeBindingsContext_default_bus
    });
    var urn_comunica_default_rdf_join_entries_sort_actors_selectivity = new (parcelRequire("8KRAp")).ActorRdfJoinEntriesSortSelectivity({
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join-entries-sort/actors#selectivity',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus,
        busFailMessage: 'Sorting join entries failed: none of the configured actors were able to sort'
    });
    var urn_comunica_default_rdf_join_actors_inner_single = new (parcelRequire("lmIWK")).ActorRdfJoinSingle({
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-single',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_multi_empty = new (parcelRequire("jPiTb")).ActorRdfJoinMultiEmpty({
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-multi-empty',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_hash_def = new (parcelRequire("g7Uez")).ActorRdfJoinHash({
        mediatorHashBindings: urn_comunica_default_hash_bindings_mediators_main,
        canHandleUndefs: false,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-hash-def',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_hash_undef = new (parcelRequire("g7Uez")).ActorRdfJoinHash({
        mediatorHashBindings: urn_comunica_default_hash_bindings_mediators_main,
        canHandleUndefs: true,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-hash-undef',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_symmetric_hash = new (parcelRequire("3hhVx")).ActorRdfJoinSymmetricHash({
        mediatorHashBindings: urn_comunica_default_hash_bindings_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-symmetric-hash',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_nested_loop = new (parcelRequire("dr8ya")).ActorRdfJoinNestedLoop({
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-nested-loop',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_hash_def_nonblocking = new (parcelRequire("9stAK")).ActorRdfJoinOptionalHash({
        canHandleUndefs: false,
        blocking: false,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-hash-def-nonblocking',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_hash_def_blocking = new (parcelRequire("9stAK")).ActorRdfJoinOptionalHash({
        canHandleUndefs: false,
        blocking: true,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-hash-def-blocking',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_hash_undef_nonblocking = new (parcelRequire("9stAK")).ActorRdfJoinOptionalHash({
        canHandleUndefs: true,
        blocking: false,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-hash-undef-nonblocking',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_hash_undef_blocking = new (parcelRequire("9stAK")).ActorRdfJoinOptionalHash({
        canHandleUndefs: true,
        blocking: true,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-hash-undef-blocking',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_nested_loop = new (parcelRequire("iMV5m")).ActorRdfJoinOptionalNestedLoop({
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-nested-loop',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_minus_hash_def = new (parcelRequire("l8BQG")).ActorRdfJoinMinusHash({
        canHandleUndefs: false,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#minus-hash-def',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_minus_hash_undef = new (parcelRequire("l8BQG")).ActorRdfJoinMinusHash({
        canHandleUndefs: true,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#minus-hash-undef',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_dereference_rdf_actors_parse = new (parcelRequire("6SuO1")).ActorDereferenceRdfParse({
        mediatorDereference: urn_comunica_default_dereference_mediators_main,
        mediatorParse: urn_comunica_default_rdf_parse_mediators_parse,
        mediatorParseMediatypes: urn_comunica_default_rdf_parse_mediators_mediaType,
        mediaMappings: {
            htm: "text/html",
            html: "text/html",
            json: "application/json",
            jsonld: "application/ld+json",
            n3: "text/n3",
            nq: "application/n-quads",
            nquads: "application/n-quads",
            nt: "application/n-triples",
            ntriples: "application/n-triples",
            owl: "application/rdf+xml",
            rdf: "application/rdf+xml",
            rdfxml: "application/rdf+xml",
            shaclc: "text/shaclc",
            shaclce: "text/shaclc-ext",
            shc: "text/shaclc",
            shce: "text/shaclc-ext",
            svg: "image/svg+xml",
            svgz: "image/svg+xml",
            trig: "application/trig",
            ttl: "text/turtle",
            turtle: "text/turtle",
            xht: "application/xhtml+xml",
            xhtml: "application/xhtml+xml",
            xml: "application/xml"
        },
        name: 'urn:comunica:default:dereference-rdf/actors#parse',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus,
        busFailMessage: 'RDF dereferencing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_parse_html_actors_script = new (parcelRequire("bptQC")).ActorRdfParseHtmlScript({
        mediatorRdfParseMediatypes: urn_comunica_default_rdf_parse_mediators_mediaType,
        mediatorRdfParseHandle: urn_comunica_default_rdf_parse_mediators_parse,
        name: 'urn:comunica:default:rdf-parse-html/actors#script',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        busFailMessage: 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    var urn_comunica_default_query_result_serialize_actors_rdf = new (parcelRequire("lpMNw")).ActorQueryResultSerializeRdf({
        mediatorRdfSerialize: urn_comunica_default_rdf_serialize_mediators_serialize,
        mediatorMediaTypeCombiner: urn_comunica_default_rdf_serialize_mediators_mediaType,
        mediatorMediaTypeFormatCombiner: urn_comunica_default_rdf_serialize_mediators_mediaTypeFormat,
        name: 'urn:comunica:default:query-result-serialize/actors#rdf',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_group_concat = new (parcelRequire("2MTlf")).ActorBindingsAggregatorFactoryGroupConcat({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#group-concat',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_count = new (parcelRequire("6HdhD")).ActorBindingsAggregatorFactoryCount({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#count',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_sample = new (parcelRequire("6hH92")).ActorBindingsAggregatorFactorySample({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#sample',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_wildcard_count = new (parcelRequire("cVuER")).ActorBindingsAggregatorFactoryWildcardCount({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#wildcard-count',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_average = new (parcelRequire("56jOZ")).ActorBindingsAggregatorFactoryAverage({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#average',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_sum = new (parcelRequire("3j5jH")).ActorBindingsAggregatorFactorySum({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#sum',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_in = new (parcelRequire("cPsBY")).ActorFunctionFactoryExpressionIn({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#expression-function-in',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_expression_function_not_in = new (parcelRequire("1wTtT")).ActorFunctionFactoryExpressionNotIn({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#expression-function-not-in',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_greater_than_equal = new (parcelRequire("apIh3")).ActorFunctionFactoryTermGreaterThanEqual({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#term-function-greater-than-equal',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_greater_than = new (parcelRequire("gAfo6")).ActorFunctionFactoryTermGreaterThan({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#term-function-greater-than',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_inequality = new (parcelRequire("3QKdb")).ActorFunctionFactoryTermInequality({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#term-function-inequality',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_lesser_than_equal = new (parcelRequire("pPlxK")).ActorFunctionFactoryTermLesserThanEqual({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#term-function-lesser-than-equal',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_function_factory_actors_term_function_lesser_than = new (parcelRequire("37h0Z")).ActorFunctionFactoryTermLesserThan({
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        name: 'urn:comunica:default:function-factory/actors#term-function-lesser-than',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        busFailMessage: 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    var urn_comunica_default_http_actors_wayback = new (parcelRequire("aGPm7")).ActorHttpWayback({
        mediatorHttp: urn_comunica_default_http_mediators_no_fallback,
        name: 'urn:comunica:default:http/actors#wayback',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus,
        busFailMessage: 'HTTP request failed: none of the configured actors were able to handle ${action.input}'
    });
    var urn_comunica_default_rdf_parse_actors_jsonld = new (parcelRequire("jLMV2")).ActorRdfParseJsonLd({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        mediaTypePriorities: {
            "application/json": 0.15,
            "application/ld+json": 1
        },
        mediaTypeFormats: {
            "application/json": "http://www.w3.org/ns/formats/JSON-LD",
            "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD"
        },
        priorityScale: 0.9,
        name: 'urn:comunica:default:rdf-parse/actors#jsonld',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        busFailMessage: 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    var urn_comunica_default_rdf_update_hypermedia_actors_patch_sparql_update = new (parcelRequire("8Mtih")).ActorRdfUpdateHypermediaPatchSparqlUpdate({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        name: 'urn:comunica:default:rdf-update-hypermedia/actors#patch-sparql-update',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        busFailMessage: 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    var urn_comunica_default_rdf_update_hypermedia_actors_put_ldp = new (parcelRequire("4ecIx")).ActorRdfUpdateHypermediaPutLdp({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        mediatorRdfSerializeMediatypes: urn_comunica_default_rdf_serialize_mediators_mediaType,
        mediatorRdfSerialize: urn_comunica_default_rdf_serialize_mediators_serialize,
        name: 'urn:comunica:default:rdf-update-hypermedia/actors#put-ldp',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        busFailMessage: 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    var urn_comunica_default_rdf_update_hypermedia_actors_sparql = new (parcelRequire("3eiUy")).ActorRdfUpdateHypermediaSparql({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        checkUrlSuffixSparql: true,
        checkUrlSuffixUpdate: true,
        name: 'urn:comunica:default:rdf-update-hypermedia/actors#sparql',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        busFailMessage: 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    var urn_comunica_default_query_operation_actors_ask = new (parcelRequire("kmuTt")).ActorQueryOperationAsk({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#ask',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_bgp = new (parcelRequire("k2U1r")).ActorQueryOperationBgpJoin({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#bgp',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_construct = new (parcelRequire("9i17A")).ActorQueryOperationConstruct({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#construct',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_distinct = new (parcelRequire("byR0v")).ActorQueryOperationDistinctIdentity({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#distinct',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_extend = new (parcelRequire("83WaN")).ActorQueryOperationExtend({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#extend',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_filter = new (parcelRequire("8s53N")).ActorQueryOperationFilter({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#filter',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_from = new (parcelRequire("7fBtz")).ActorQueryOperationFromQuad({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#from',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_project = new (parcelRequire("bmdx4")).ActorQueryOperationProject({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#project',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_reduced = new (parcelRequire("4Gx0x")).ActorQueryOperationReducedHash({
        mediatorHashBindings: urn_comunica_default_hash_bindings_mediators_main,
        cacheSize: 100,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#reduced',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_slice = new (parcelRequire("7IPXV")).ActorQueryOperationSlice({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#slice',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_union = new (parcelRequire("b0tz5")).ActorQueryOperationUnion({
        mediatorRdfMetadataAccumulate: urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#union',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_alt = new (parcelRequire("lnTNW")).ActorQueryOperationPathAlt({
        mediatorRdfMetadataAccumulate: urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-alt',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_inv = new (parcelRequire("1sViH")).ActorQueryOperationPathInv({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-inv',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_link = new (parcelRequire("f0mIM")).ActorQueryOperationPathLink({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-link',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_nps = new (parcelRequire("fGvp1")).ActorQueryOperationPathNps({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-nps',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_clear = new (parcelRequire("ll55X")).ActorQueryOperationClear({
        mediatorUpdateQuads: urn_comunica_default_rdf_update_quads_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-clear',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_composite = new (parcelRequire("i2UmV")).ActorQueryOperationUpdateCompositeUpdate({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-composite',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_create = new (parcelRequire("98dBy")).ActorQueryOperationCreate({
        mediatorUpdateQuads: urn_comunica_default_rdf_update_quads_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-create',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_drop = new (parcelRequire("f9vSY")).ActorQueryOperationDrop({
        mediatorUpdateQuads: urn_comunica_default_rdf_update_quads_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-drop',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_load = new (parcelRequire("guyUf")).ActorQueryOperationLoad({
        mediatorUpdateQuads: urn_comunica_default_rdf_update_quads_mediators_main,
        mediatorQuerySourceIdentify: urn_comunica_default_query_source_identify_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-load',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_join = new (parcelRequire("fD2Tn")).ActorQueryOperationJoin({
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#join',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_leftjoin = new (parcelRequire("hXK5w")).ActorQueryOperationLeftJoin({
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#leftjoin',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_minus = new (parcelRequire("7HHhd")).ActorQueryOperationMinus({
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#minus',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_seq = new (parcelRequire("ka5nq")).ActorQueryOperationPathSeq({
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-seq',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_rdf_join_actors_inner_multi_smallest = new (parcelRequire("9Z4Pv")).ActorRdfJoinMultiSmallest({
        mediatorJoinEntriesSort: urn_comunica_default_rdf_join_entries_sort_mediators_main,
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-multi-smallest',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_max = new (parcelRequire("cBRQZ")).ActorBindingsAggregatorFactoryMax({
        mediatorTermComparatorFactory: urn_comunica_default_term_comparator_factory_mediators_main,
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#max',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_bindings_aggregator_factory_actors_min = new (parcelRequire("cFis2")).ActorBindingsAggregatorFactoryMin({
        mediatorTermComparatorFactory: urn_comunica_default_term_comparator_factory_mediators_main,
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        name: 'urn:comunica:default:bindings-aggregator-factory/actors#min',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        busFailMessage: 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    var urn_comunica_default_query_operation_actors_orderby = new (parcelRequire("4EKee")).ActorQueryOperationOrderBy({
        mediatorExpressionEvaluatorFactory: urn_comunica_default_expression_evaluator_factory_mediators_main,
        mediatorTermComparatorFactory: urn_comunica_default_term_comparator_factory_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#orderby',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_optimize_query_operation_actors_filter_pushdown = new (parcelRequire("j3xeS")).ActorOptimizeQueryOperationFilterPushdown({
        aggressivePushdown: false,
        maxIterations: 10,
        splitConjunctive: true,
        mergeConjunctive: true,
        pushIntoLeftJoins: true,
        pushEqualityIntoPatterns: true,
        name: 'urn:comunica:default:optimize-query-operation/actors#filter-pushdown',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_group_sources
        ]
    });
    var urn_comunica_default_dereference_actors_http = new (parcelRequire("62lD4")).ActorDereferenceHttp({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        maxAcceptHeaderLength: 1024,
        maxAcceptHeaderLengthBrowser: 128,
        name: 'urn:comunica:default:dereference/actors#http',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus,
        busFailMessage: 'Dereferencing failed: none of the configured actors were able to handle ${action.url}',
        beforeActors: [
            urn_comunica_default_dereference_actors_fallback
        ]
    });
    var urn_comunica_default_http_actors_proxy = new (parcelRequire("5Y3qE")).ActorHttpProxy({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        name: 'urn:comunica:default:http/actors#proxy',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        busFailMessage: 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        beforeActors: [
            urn_comunica_default_http_actors_fetch
        ]
    });
    var urn_comunica_default_context_preprocess_actors_query_source_identify = new (parcelRequire("hk1Et")).ActorContextPreprocessQuerySourceIdentify({
        cacheSize: 100,
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_context_preprocess_query_source_identify__4_0_0_components_ActorContextPreprocessQuerySourceIdentify_jsonld_IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator,
        mediatorQuerySourceIdentify: urn_comunica_default_query_source_identify_mediators_main,
        mediatorContextPreprocess: urn_comunica_default_context_preprocess_mediators_main,
        name: 'urn:comunica:default:context-preprocess/actors#query-source-identify',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        busFailMessage: 'Context preprocessing failed',
        beforeActors: [
            urn_comunica_default_context_preprocess_actors_query_source_skolemize
        ]
    });
    var urn_comunica_default_init_actors_query = new (parcelRequire("6nvMd")).ActorInitQuery({
        mediatorQueryProcess: urn_comunica_default_query_process_mediators_main,
        mediatorQueryResultSerialize: urn_comunica_default_query_result_serialize_mediators_serialize,
        mediatorQueryResultSerializeMediaTypeCombiner: urn_comunica_default_query_result_serialize_mediators_mediaType,
        mediatorQueryResultSerializeMediaTypeFormatCombiner: urn_comunica_default_query_result_serialize_mediators_mediaTypeFormat,
        mediatorHttpInvalidate: urn_comunica_default_http_invalidate_mediators_main,
        defaultQueryInputFormat: 'sparql',
        allowNoSources: false,
        name: 'urn:comunica:default:init/actors#query',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus,
        busFailMessage: 'Initialization failed: none of the configured actors were to initialize'
    });
    var urn_comunica_default_rdf_update_quads_actors_hypermedia = new (parcelRequire("6Y0p7")).ActorRdfUpdateQuadsHypermedia({
        cacheSize: 100,
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_rdf_update_quads_hypermedia__4_0_0_components_ActorRdfUpdateQuadsHypermedia_jsonld_IActorRdfUpdateQuadsHypermediaArgs_default_invalidator,
        mediatorDereferenceRdf: urn_comunica_default_dereference_rdf_mediators_main,
        mediatorMetadata: urn_comunica_default_rdf_metadata_mediators_main,
        mediatorMetadataExtract: urn_comunica_default_rdf_metadata_extract_mediators_main,
        mediatorRdfUpdateHypermedia: urn_comunica_default_rdf_update_hypermedia_mediators_main,
        name: 'urn:comunica:default:rdf-update-quads/actors#hypermedia',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus,
        busFailMessage: 'RDF updating failed: none of the configured actors were able to handle an update'
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActorQueryResultSerializeSparqlJson_jsonld_ActorQueryResultSerializeSparqlJson_default_observer = new (parcelRequire("caezk")).ActionObserverHttp({
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator,
        observedActors: [
            'urn:comunica:default:http/actors#fetch'
        ],
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-sparql-json/^4.0.0/components/ActorQueryResultSerializeSparqlJson.jsonld#ActorQueryResultSerializeSparqlJson_default_observer',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    var https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActorQueryResultSerializeStats_jsonld_ActorQueryResultSerializeStats_default_observer = new (parcelRequire("9CR5Y")).ActionObserverHttp({
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator,
        observedActors: [
            'urn:comunica:default:http/actors#fetch'
        ],
        name: 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-stats/^4.0.0/components/ActorQueryResultSerializeStats.jsonld#ActorQueryResultSerializeStats_default_observer',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    var urn_comunica_default_query_source_identify_hypermedia_actors_qpf = new (parcelRequire("uCkRL")).ActorQuerySourceIdentifyHypermediaQpf({
        mediatorMetadata: urn_comunica_default_rdf_metadata_mediators_main,
        mediatorMetadataExtract: urn_comunica_default_rdf_metadata_extract_mediators_main,
        mediatorDereferenceRdf: urn_comunica_default_dereference_rdf_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        subjectUri: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#subject',
        predicateUri: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate',
        objectUri: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#object',
        graphUri: 'http://www.w3.org/ns/sparql-service-description#graph',
        name: 'urn:comunica:default:query-source-identify-hypermedia/actors#qpf',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        busFailMessage: 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    var urn_comunica_default_query_source_identify_hypermedia_actors_sparql = new (parcelRequire("lFMRA")).ActorQuerySourceIdentifyHypermediaSparql({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        checkUrlSuffix: true,
        forceHttpGet: false,
        cacheSize: 1024,
        forceSourceType: false,
        bindMethod: 'values',
        countTimeout: 3000,
        cardinalityCountQueries: true,
        cardinalityEstimateConstruction: false,
        name: 'urn:comunica:default:query-source-identify-hypermedia/actors#sparql',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        busFailMessage: 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    var urn_comunica_default_query_source_identify_hypermedia_actors_none = new (parcelRequire("drZeA")).ActorQuerySourceIdentifyHypermediaNone({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:query-source-identify-hypermedia/actors#none',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        busFailMessage: 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    var urn_comunica_default_expression_evaluator_factory_actors_default = new (parcelRequire("7YkOv")).ActorExpressionEvaluatorFactoryDefault({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:expression-evaluator-factory/actors#default',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus,
        busFailMessage: 'Creation of Expression Evaluator failed'
    });
    var urn_comunica_default_query_operation_actors_group = new (parcelRequire("fGm4T")).ActorQueryOperationGroup({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorBindingsAggregatorFactory: urn_comunica_default_bindings_aggregator_factory_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#group',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_nop = new (parcelRequire("dlhfj")).ActorQueryOperationNop({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#nop',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_service = new (parcelRequire("3Ixgm")).ActorQueryOperationService({
        forceSparqlEndpoint: false,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQuerySourceIdentify: urn_comunica_default_query_source_identify_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#service',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_values = new (parcelRequire("4bQXf")).ActorQueryOperationValues({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#values',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_one_or_more = new (parcelRequire("8EvRI")).ActorQueryOperationPathOneOrMore({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-one-or-more',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_zero_or_more = new (parcelRequire("9tmiu")).ActorQueryOperationPathZeroOrMore({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-zero-or-more',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_path_zero_or_one = new (parcelRequire("hYELP")).ActorQueryOperationPathZeroOrOne({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#path-zero-or-one',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_operation_actors_update_delete_insert = new (parcelRequire("chNTI")).ActorQueryOperationUpdateDeleteInsert({
        mediatorUpdateQuads: urn_comunica_default_rdf_update_quads_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        name: 'urn:comunica:default:query-operation/actors#update-delete-insert',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        busFailMessage: 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    var urn_comunica_default_query_process_actors_sequential = new (parcelRequire("kCebH")).ActorQueryProcessSequential({
        mediatorContextPreprocess: urn_comunica_default_context_preprocess_mediators_main,
        mediatorQueryParse: urn_comunica_default_query_parse_mediators_main,
        mediatorOptimizeQueryOperation: urn_comunica_default_optimize_query_operation_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:query-process/actors#sequential',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        busFailMessage: 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    var urn_comunica_default_query_source_identify_actors_hypermedia = new (parcelRequire("1RsAr")).ActorQuerySourceIdentifyHypermedia({
        cacheSize: 100,
        maxIterators: 64,
        aggregateTraversalStore: true,
        mediatorDereferenceRdf: urn_comunica_default_dereference_rdf_mediators_main,
        mediatorMetadata: urn_comunica_default_rdf_metadata_mediators_main,
        mediatorMetadataExtract: urn_comunica_default_rdf_metadata_extract_mediators_main,
        mediatorMetadataAccumulate: urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        mediatorQuerySourceIdentifyHypermedia: urn_comunica_default_query_source_identify_hypermedia_mediators_main,
        mediatorRdfResolveHypermediaLinks: urn_comunica_default_rdf_resolve_hypermedia_links_mediators_main,
        mediatorRdfResolveHypermediaLinksQueue: urn_comunica_default_rdf_resolve_hypermedia_links_queue_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:query-source-identify/actors#hypermedia',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        busFailMessage: 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}'
    });
    var urn_comunica_default_rdf_join_actors_inner_none = new (parcelRequire("9VryK")).ActorRdfJoinNone({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-none',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_rdf_join_actors_optional_bind = new (parcelRequire("b7XJQ")).ActorRdfJoinOptionalBind({
        bindOrder: 'depth-first',
        selectivityModifier: 0.000001,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#optional-bind',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    var urn_comunica_default_term_comparator_factory_actors_expression_evaluator = new (parcelRequire("7l09z")).ActorTermComparatorFactoryExpressionEvaluator({
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        mediatorFunctionFactory: urn_comunica_default_function_factory_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:term-comparator-factory/actors#expression-evaluator',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus,
        busFailMessage: 'Creation of term comparator failed'
    });
    var urn_comunica_default_rdf_join_actors_inner_multi_bind = new (parcelRequire("hka6L")).ActorRdfJoinMultiBind({
        bindOrder: 'depth-first',
        selectivityModifier: 0.0001,
        minMaxCardinalityRatio: 60,
        mediatorJoinEntriesSort: urn_comunica_default_rdf_join_entries_sort_mediators_main,
        mediatorQueryOperation: urn_comunica_default_query_operation_mediators_main,
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-multi-bind',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        beforeActors: [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    var urn_comunica_default_rdf_join_actors_inner_multi_smallest_filter_bindings = new (parcelRequire("cCj0z")).ActorRdfJoinMultiSmallestFilterBindings({
        selectivityModifier: 0.0001,
        blockSize: 64,
        mediatorJoinEntriesSort: urn_comunica_default_rdf_join_entries_sort_mediators_main,
        mediatorJoin: urn_comunica_default_rdf_join_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-multi-smallest-filter-bindings',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        beforeActors: [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    var urn_comunica_default_query_result_serialize_actors_sparql_json = new (parcelRequire("caezk")).ActorQueryResultSerializeSparqlJson({
        emitMetadata: true,
        httpObserver: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActorQueryResultSerializeSparqlJson_jsonld_ActorQueryResultSerializeSparqlJson_default_observer,
        mediaTypePriorities: {
            "application/sparql-results+json": 0.8
        },
        mediaTypeFormats: {
            "application/sparql-results+json": "http://www.w3.org/ns/formats/SPARQL_Results_JSON"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#sparql-json',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_result_serialize_actors_stats = new (parcelRequire("9CR5Y")).ActorQueryResultSerializeStats({
        httpObserver: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActorQueryResultSerializeStats_jsonld_ActorQueryResultSerializeStats_default_observer,
        mediaTypePriorities: {
            stats: 0.5
        },
        mediaTypeFormats: {
            stats: "https://comunica.linkeddatafragments.org/#results_stats"
        },
        name: 'urn:comunica:default:query-result-serialize/actors#stats',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        busFailMessage: 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    var urn_comunica_default_query_process_actors_explain_logical = new (parcelRequire("1FmL4")).ActorQueryProcessExplainLogical({
        queryProcessor: urn_comunica_default_query_process_actors_sequential,
        name: 'urn:comunica:default:query-process/actors#explain-logical',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        busFailMessage: 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    var urn_comunica_default_query_process_actors_explain_parsed = new (parcelRequire("lrzg1")).ActorQueryProcessExplainParsed({
        queryProcessor: urn_comunica_default_query_process_actors_sequential,
        name: 'urn:comunica:default:query-process/actors#explain-parsed',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        busFailMessage: 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    var urn_comunica_default_query_process_actors_explain_physical = new (parcelRequire("kF7FR")).ActorQueryProcessExplainPhysical({
        queryProcessor: urn_comunica_default_query_process_actors_sequential,
        name: 'urn:comunica:default:query-process/actors#explain-physical',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        busFailMessage: 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    var urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations = new (parcelRequire("7cuef")).ActorOptimizeQueryOperationPruneEmptySourceOperations({
        useAskIfSupported: false,
        name: 'urn:comunica:default:optimize-query-operation/actors#prune-empty-source-operations',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_filter_pushdown
        ]
    });
    var urn_comunica_default_http_actors_retry = new (parcelRequire("kcGj8")).ActorHttpRetry({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_retry__4_0_0_components_ActorHttpRetry_jsonld_IActorHttpQueueArgs_default_invalidator,
        name: 'urn:comunica:default:http/actors#retry',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        busFailMessage: 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        beforeActors: [
            urn_comunica_default_http_actors_proxy
        ]
    });
    var urn_comunica_default_http_actors_limit_rate = new (parcelRequire("49KPC")).ActorHttpLimitRate({
        mediatorHttp: urn_comunica_default_http_mediators_main,
        httpInvalidator: https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_limit_rate__4_0_0_components_ActorHttpLimitRate_jsonld_IActorHttpLimitRateArgs_default_invalidator,
        correctionMultiplier: 0.1,
        failureMultiplier: 10,
        limitByDefault: false,
        allowOverlap: false,
        name: 'urn:comunica:default:http/actors#limit-rate',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        busFailMessage: 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        beforeActors: [
            urn_comunica_default_http_actors_proxy
        ]
    });
    var urn_comunica_default_query_source_identify_actors_rdfjs = new (parcelRequire("hbGDL")).ActorQuerySourceIdentifyRdfJs({
        mediatorMergeBindingsContext: urn_comunica_default_merge_bindings_context_mediators_main,
        name: 'urn:comunica:default:query-source-identify/actors#rdfjs',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        busFailMessage: 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}',
        beforeActors: [
            urn_comunica_default_query_source_identify_actors_hypermedia
        ]
    });
    var urn_comunica_default_query_source_identify_actors_serialized = new (parcelRequire("bg8LU")).ActorQuerySourceIdentifySerialized({
        mediatorRdfParse: urn_comunica_default_rdf_parse_mediators_parse,
        mediatorQuerySourceIdentify: urn_comunica_default_query_source_identify_mediators_main,
        name: 'urn:comunica:default:query-source-identify/actors#serialized',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        busFailMessage: 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}',
        beforeActors: [
            urn_comunica_default_query_source_identify_actors_hypermedia
        ]
    });
    var urn_comunica_default_rdf_join_actors_inner_multi_bind_source = new (parcelRequire("k91fE")).ActorRdfJoinMultiBindSource({
        selectivityModifier: 0.0001,
        blockSize: 16,
        mediatorJoinEntriesSort: urn_comunica_default_rdf_join_entries_sort_mediators_main,
        mediatorJoinSelectivity: urn_comunica_default_rdf_join_selectivity_mediators_main,
        name: 'urn:comunica:default:rdf-join/actors#inner-multi-bind-source',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        busFailMessage: 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        beforeActors: [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_multi_bind,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    var urn_comunica_default_optimize_query_operation_actors_join_connected = new (parcelRequire("ifXoQ")).ActorOptimizeQueryOperationJoinConnected({
        name: 'urn:comunica:default:optimize-query-operation/actors#join-connected',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations
        ]
    });
    var urn_comunica_default_optimize_query_operation_actors_bgp_to_join = new (parcelRequire("b79U3")).ActorOptimizeQueryOperationBgpToJoin({
        name: 'urn:comunica:default:optimize-query-operation/actors#bgp-to-join',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_join_connected
        ]
    });
    var urn_comunica_default_optimize_query_operation_actors_join_bgp = new (parcelRequire("2FQJB")).ActorOptimizeQueryOperationJoinBgp({
        name: 'urn:comunica:default:optimize-query-operation/actors#join-bgp',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_bgp_to_join
        ]
    });
    var urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive = new (parcelRequire("gBbJY")).ActorOptimizeQueryOperationAssignSourcesExhaustive({
        name: 'urn:comunica:default:optimize-query-operation/actors#assign-sources-exhaustive',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_join_bgp
        ]
    });
    var urn_comunica_default_optimize_query_operation_actors_describe_to_constructs_subject = new (parcelRequire("aA2cu")).ActorOptimizeQueryOperationDescribeToConstructsSubject({
        name: 'urn:comunica:default:optimize-query-operation/actors#describe-to-constructs-subject',
        bus: https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        busFailMessage: 'Query optimization failed: none of the configured actors were able to optimize',
        beforeActors: [
            urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive
        ]
    });
    var urn_comunica_default_Runner = (https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus, [
        urn_comunica_default_context_preprocess_actors_convert_shortcuts,
        urn_comunica_default_context_preprocess_actors_set_defaults,
        urn_comunica_default_context_preprocess_actors_source_to_destination,
        urn_comunica_default_context_preprocess_actors_query_source_identify,
        urn_comunica_default_context_preprocess_actors_query_source_skolemize,
        urn_comunica_default_hash_bindings_actors_murmur,
        urn_comunica_default_hash_quads_actors_murmur,
        urn_comunica_default_init_actors_query,
        urn_comunica_default_optimize_query_operation_actors_rewrite_copy,
        urn_comunica_default_optimize_query_operation_actors_rewrite_move,
        urn_comunica_default_optimize_query_operation_actors_rewrite_add,
        urn_comunica_default_optimize_query_operation_actors_describe_to_constructs_subject,
        urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive,
        urn_comunica_default_optimize_query_operation_actors_join_bgp,
        urn_comunica_default_optimize_query_operation_actors_bgp_to_join,
        urn_comunica_default_optimize_query_operation_actors_join_connected,
        urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations,
        urn_comunica_default_optimize_query_operation_actors_filter_pushdown,
        urn_comunica_default_optimize_query_operation_actors_group_sources,
        urn_comunica_default_optimize_query_operation_actors_construct_distinct,
        urn_comunica_default_query_parse_actors_sparql,
        urn_comunica_default_query_parse_actors_graphql,
        urn_comunica_default_query_result_serialize_actors_json,
        urn_comunica_default_query_result_serialize_actors_rdf,
        urn_comunica_default_query_result_serialize_actors_simple,
        urn_comunica_default_query_result_serialize_actors_csv,
        urn_comunica_default_query_result_serialize_actors_sparql_json,
        urn_comunica_default_query_result_serialize_actors_sparql_tsv,
        urn_comunica_default_query_result_serialize_actors_sparql_xml,
        urn_comunica_default_query_result_serialize_actors_stats,
        urn_comunica_default_query_result_serialize_actors_table,
        urn_comunica_default_query_result_serialize_actors_tree,
        urn_comunica_default_query_source_identify_hypermedia_actors_qpf,
        urn_comunica_default_query_source_identify_hypermedia_actors_sparql,
        urn_comunica_default_query_source_identify_hypermedia_actors_none,
        urn_comunica_default_dereference_actors_http,
        urn_comunica_default_dereference_actors_fallback,
        urn_comunica_default_dereference_rdf_actors_parse,
        urn_comunica_default_rdf_join_entries_sort_actors_cardinality,
        urn_comunica_default_rdf_join_entries_sort_actors_selectivity,
        urn_comunica_default_rdf_join_selectivity_actors_variable_counting,
        urn_comunica_default_rdf_metadata_actors_primary_topic,
        urn_comunica_default_rdf_metadata_actors_all,
        urn_comunica_default_rdf_metadata_accumulate_actors_cardinality,
        urn_comunica_default_rdf_metadata_accumulate_actors_pagesize,
        urn_comunica_default_rdf_metadata_accumulate_actors_requesttime,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_controls,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_count,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_pagesize,
        urn_comunica_default_rdf_metadata_extract_actors_request_time,
        urn_comunica_default_rdf_metadata_extract_actors_allow_http_methods,
        urn_comunica_default_rdf_metadata_extract_actors_put_accepted,
        urn_comunica_default_rdf_metadata_extract_actors_patch_sparql_update,
        urn_comunica_default_rdf_metadata_extract_actors_sparql_service,
        urn_comunica_default_rdf_metadata_extract_actors_void,
        urn_comunica_default_rdf_parse_actors_n3,
        urn_comunica_default_rdf_parse_actors_jsonld,
        urn_comunica_default_rdf_parse_actors_rdfxml,
        urn_comunica_default_rdf_parse_actors_xmlrdfa,
        urn_comunica_default_rdf_parse_actors_html,
        urn_comunica_default_rdf_parse_actors_shaclc,
        urn_comunica_default_rdf_parse_html_actors_microdata,
        urn_comunica_default_rdf_parse_html_actors_rdfa,
        urn_comunica_default_rdf_parse_html_actors_script,
        urn_comunica_default_rdf_resolve_hypermedia_links_actors_next,
        urn_comunica_default_rdf_resolve_hypermedia_links_queue_actors_fifo,
        urn_comunica_default_rdf_serialize_actors_n3,
        urn_comunica_default_rdf_serialize_actors_jsonld,
        urn_comunica_default_rdf_serialize_actors_shaclc,
        urn_comunica_default_rdf_update_hypermedia_actors_patch_sparql_update,
        urn_comunica_default_rdf_update_hypermedia_actors_put_ldp,
        urn_comunica_default_rdf_update_hypermedia_actors_sparql,
        urn_comunica_default_rdf_update_quads_actors_hypermedia,
        urn_comunica_default_rdf_update_quads_actors_rdfjs_store,
        urn_comunica_default_bindings_aggregator_factory_actors_average,
        urn_comunica_default_bindings_aggregator_factory_actors_group_concat,
        urn_comunica_default_bindings_aggregator_factory_actors_count,
        urn_comunica_default_bindings_aggregator_factory_actors_max,
        urn_comunica_default_bindings_aggregator_factory_actors_min,
        urn_comunica_default_bindings_aggregator_factory_actors_sample,
        urn_comunica_default_bindings_aggregator_factory_actors_sum,
        urn_comunica_default_bindings_aggregator_factory_actors_wildcard_count,
        urn_comunica_default_expression_evaluator_factory_actors_default,
        urn_comunica_default_function_factory_actors_expression_function_bnode,
        urn_comunica_default_function_factory_actors_expression_function_bound,
        urn_comunica_default_function_factory_actors_expression_function_coalesce,
        urn_comunica_default_function_factory_actors_expression_function_concat,
        urn_comunica_default_function_factory_actors_expression_function_extensions,
        urn_comunica_default_function_factory_actors_expression_function_if,
        urn_comunica_default_function_factory_actors_expression_function_in,
        urn_comunica_default_function_factory_actors_expression_function_logical_and,
        urn_comunica_default_function_factory_actors_expression_function_logical_or,
        urn_comunica_default_function_factory_actors_expression_function_not_in,
        urn_comunica_default_function_factory_actors_expression_function_same_term,
        urn_comunica_default_function_factory_actors_term_function_abs,
        urn_comunica_default_function_factory_actors_term_function_addition,
        urn_comunica_default_function_factory_actors_term_function_ceil,
        urn_comunica_default_function_factory_actors_term_function_contains,
        urn_comunica_default_function_factory_actors_term_function_datatype,
        urn_comunica_default_function_factory_actors_term_function_day,
        urn_comunica_default_function_factory_actors_term_function_division,
        urn_comunica_default_function_factory_actors_term_function_encode_for_uri,
        urn_comunica_default_function_factory_actors_term_function_equality,
        urn_comunica_default_function_factory_actors_term_function_floor,
        urn_comunica_default_function_factory_actors_term_function_greater_than_equal,
        urn_comunica_default_function_factory_actors_term_function_greater_than,
        urn_comunica_default_function_factory_actors_term_function_hours,
        urn_comunica_default_function_factory_actors_term_function_inequality,
        urn_comunica_default_function_factory_actors_term_function_iri,
        urn_comunica_default_function_factory_actors_term_function_is_blank,
        urn_comunica_default_function_factory_actors_term_function_is_iri,
        urn_comunica_default_function_factory_actors_term_function_is_literal,
        urn_comunica_default_function_factory_actors_term_function_is_numeric,
        urn_comunica_default_function_factory_actors_term_function_is_triple,
        urn_comunica_default_function_factory_actors_term_function_lang,
        urn_comunica_default_function_factory_actors_term_function_langmatches,
        urn_comunica_default_function_factory_actors_term_function_lcase,
        urn_comunica_default_function_factory_actors_term_function_lesser_than_equal,
        urn_comunica_default_function_factory_actors_term_function_lesser_than,
        urn_comunica_default_function_factory_actors_term_function_md5,
        urn_comunica_default_function_factory_actors_term_function_minutes,
        urn_comunica_default_function_factory_actors_term_function_month,
        urn_comunica_default_function_factory_actors_term_function_multiplication,
        urn_comunica_default_function_factory_actors_term_function_not,
        urn_comunica_default_function_factory_actors_term_function_now,
        urn_comunica_default_function_factory_actors_term_function_object,
        urn_comunica_default_function_factory_actors_term_function_predicate,
        urn_comunica_default_function_factory_actors_term_function_rand,
        urn_comunica_default_function_factory_actors_term_function_regex,
        urn_comunica_default_function_factory_actors_term_function_replace,
        urn_comunica_default_function_factory_actors_term_function_round,
        urn_comunica_default_function_factory_actors_term_function_seconds,
        urn_comunica_default_function_factory_actors_term_function_sha1,
        urn_comunica_default_function_factory_actors_term_function_sha256,
        urn_comunica_default_function_factory_actors_term_function_sha384,
        urn_comunica_default_function_factory_actors_term_function_sha512,
        urn_comunica_default_function_factory_actors_term_function_str_after,
        urn_comunica_default_function_factory_actors_term_function_str_before,
        urn_comunica_default_function_factory_actors_term_function_str_dt,
        urn_comunica_default_function_factory_actors_term_function_str_ends,
        urn_comunica_default_function_factory_actors_term_function_str_lang,
        urn_comunica_default_function_factory_actors_term_function_str_len,
        urn_comunica_default_function_factory_actors_term_function_str_starts,
        urn_comunica_default_function_factory_actors_term_function_str_uuid,
        urn_comunica_default_function_factory_actors_term_function_str,
        urn_comunica_default_function_factory_actors_term_function_sub_str,
        urn_comunica_default_function_factory_actors_term_function_subject,
        urn_comunica_default_function_factory_actors_term_function_subtraction,
        urn_comunica_default_function_factory_actors_term_function_timezone,
        urn_comunica_default_function_factory_actors_term_function_triple,
        urn_comunica_default_function_factory_actors_term_function_tz,
        urn_comunica_default_function_factory_actors_term_function_ucase,
        urn_comunica_default_function_factory_actors_term_function_unary_minus,
        urn_comunica_default_function_factory_actors_term_function_unary_plus,
        urn_comunica_default_function_factory_actors_term_function_uuid,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_boolean,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_date,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_datetime,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_day_time_duration,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_decimal,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_double,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_duration,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_float,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_integer,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_string,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_time,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_year_month_duration,
        urn_comunica_default_function_factory_actors_term_function_year,
        urn_comunica_default_http_actors_retry,
        urn_comunica_default_http_actors_proxy,
        urn_comunica_default_http_actors_fetch,
        urn_comunica_default_http_actors_limit_rate,
        urn_comunica_default_http_actors_wayback,
        urn_comunica_default_query_operation_actors_ask,
        urn_comunica_default_query_operation_actors_bgp,
        urn_comunica_default_query_operation_actors_construct,
        urn_comunica_default_query_operation_actors_distinct,
        urn_comunica_default_query_operation_actors_extend,
        urn_comunica_default_query_operation_actors_filter,
        urn_comunica_default_query_operation_actors_from,
        urn_comunica_default_query_operation_actors_group,
        urn_comunica_default_query_operation_actors_join,
        urn_comunica_default_query_operation_actors_leftjoin,
        urn_comunica_default_query_operation_actors_minus,
        urn_comunica_default_query_operation_actors_nop,
        urn_comunica_default_query_operation_actors_orderby,
        urn_comunica_default_query_operation_actors_project,
        urn_comunica_default_query_operation_actors_reduced,
        urn_comunica_default_query_operation_actors_service,
        urn_comunica_default_query_operation_actors_slice,
        urn_comunica_default_query_operation_actors_source,
        urn_comunica_default_query_operation_actors_union,
        urn_comunica_default_query_operation_actors_values,
        urn_comunica_default_query_operation_actors_path_alt,
        urn_comunica_default_query_operation_actors_path_inv,
        urn_comunica_default_query_operation_actors_path_link,
        urn_comunica_default_query_operation_actors_path_nps,
        urn_comunica_default_query_operation_actors_path_one_or_more,
        urn_comunica_default_query_operation_actors_path_seq,
        urn_comunica_default_query_operation_actors_path_zero_or_more,
        urn_comunica_default_query_operation_actors_path_zero_or_one,
        urn_comunica_default_query_operation_actors_update_clear,
        urn_comunica_default_query_operation_actors_update_composite,
        urn_comunica_default_query_operation_actors_update_create,
        urn_comunica_default_query_operation_actors_update_delete_insert,
        urn_comunica_default_query_operation_actors_update_drop,
        urn_comunica_default_query_operation_actors_update_load,
        urn_comunica_default_query_process_actors_sequential,
        urn_comunica_default_query_process_actors_explain_logical,
        urn_comunica_default_query_process_actors_explain_parsed,
        urn_comunica_default_query_process_actors_explain_physical,
        urn_comunica_default_query_source_identify_actors_hypermedia,
        urn_comunica_default_query_source_identify_actors_rdfjs,
        urn_comunica_default_query_source_identify_actors_serialized,
        urn_comunica_default_rdf_join_actors_inner_none,
        urn_comunica_default_rdf_join_actors_inner_single,
        urn_comunica_default_rdf_join_actors_inner_multi_empty,
        urn_comunica_default_rdf_join_actors_inner_multi_bind_source,
        urn_comunica_default_rdf_join_actors_inner_multi_bind,
        urn_comunica_default_rdf_join_actors_inner_hash_def,
        urn_comunica_default_rdf_join_actors_inner_hash_undef,
        urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
        urn_comunica_default_rdf_join_actors_inner_nested_loop,
        urn_comunica_default_rdf_join_actors_inner_multi_smallest,
        urn_comunica_default_rdf_join_actors_inner_multi_smallest_filter_bindings,
        urn_comunica_default_rdf_join_actors_optional_bind,
        urn_comunica_default_rdf_join_actors_optional_hash_def_nonblocking,
        urn_comunica_default_rdf_join_actors_optional_hash_def_blocking,
        urn_comunica_default_rdf_join_actors_optional_hash_undef_nonblocking,
        urn_comunica_default_rdf_join_actors_optional_hash_undef_blocking,
        urn_comunica_default_rdf_join_actors_optional_nested_loop,
        urn_comunica_default_rdf_join_actors_minus_hash_def,
        urn_comunica_default_rdf_join_actors_minus_hash_undef,
        urn_comunica_default_term_comparator_factory_actors_expression_evaluator
    ]);
    return urn_comunica_default_init_actors_query;
};

});
parcelRegister("2auqX", function(module, exports) {
"use strict";
var $19441f7433c9e21e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $19441f7433c9e21e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $19441f7433c9e21e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$19441f7433c9e21e$var$__exportStar((parcelRequire("7Quo9")), module.exports);

});
parcelRegister("7Quo9", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggerVoid = void 0;

var $gIvya = parcelRequire("gIvya");
/**
 * A logger that voids everything.
 */ var $5b64f648d993e2f3$var$LoggerVoid = /*#__PURE__*/ function(_types_1_Logger) {
    (0, $i3fW3._)(LoggerVoid, _types_1_Logger);
    function LoggerVoid() {
        (0, $jGAMp._)(this, LoggerVoid);
        return (0, $kzDuW._)(this, LoggerVoid, arguments);
    }
    (0, $byiyg._)(LoggerVoid, [
        {
            key: "debug",
            value: function debug() {
            // Void
            }
        },
        {
            key: "error",
            value: function error() {
            // Void
            }
        },
        {
            key: "fatal",
            value: function fatal() {
            // Void
            }
        },
        {
            key: "info",
            value: function info() {
            // Void
            }
        },
        {
            key: "trace",
            value: function trace() {
            // Void
            }
        },
        {
            key: "warn",
            value: function warn() {
            // Void
            }
        }
    ]);
    return LoggerVoid;
}($gIvya.Logger);
module.exports.LoggerVoid = $5b64f648d993e2f3$var$LoggerVoid;

});
parcelRegister("gIvya", function(module, exports) {
"use strict";
var $c2b93a9a18a18e55$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c2b93a9a18a18e55$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c2b93a9a18a18e55$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("8qk7t")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("c37Ni")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("8vzFL")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("2L9H5")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("5GxmT")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("4dapj")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("59tbO")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("66r6a")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("jx6T3")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("hpTpH")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("ejMTp")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("barmX")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("2qPSK")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("l3Zw3")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("7qdWY")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("gtbX9")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("22OMc")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("fPKlB")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("kONCO")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("kYqLJ")), module.exports);

$c2b93a9a18a18e55$var$__exportStar((parcelRequire("9Lh9D")), module.exports);

});
parcelRegister("8qk7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("c37Ni", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8vzFL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2L9H5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5GxmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4dapj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("59tbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("66r6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jx6T3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hpTpH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ejMTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("barmX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2qPSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l3Zw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7qdWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
}); // ----- Examples of FragmentSelectorShapes -----
 // const AF = new Factory();
 // const DF = new DataFactory();
 // const shapeTpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //   ],
 // };
 //
 // const shapeQpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o'), DF.variable('g')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //     DF.variable('g'),
 //   ],
 // };
 //
 // const shapeBrTpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //   ],
 //   addBindings: true,
 // };
 //
 // const shapeSparqlEp: FragmentSelectorShape = { // Same as SaGe
 //   type: 'disjunction',
 //   children: [
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.PROJECT },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.CONSTRUCT },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.DESCRIBE },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.ASK },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.COMPOSITE_UPDATE },
 //     },
 //   ],
 // };
 //
 // // Example of request:
 // //   Find ?s matching "?s dbo:country dbr:norway. ?s dbo:award ?o2. ?s dbo:birthDate ?o3."
 // const shapeSpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { type: Algebra.types.BGP },
 //   scopedVariables: [
 //     DF.variable('s'),
 //   ],
 //   children: [
 //     {
 //       type: 'arity',
 //       min: 1,
 //       max: Number.POSITIVE_INFINITY,
 //       child: {
 //         type: 'operation',
 //         operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //         variablesOptional: [
 //           DF.variable('p'),
 //           DF.variable('o'),
 //         ],
 //       },
 //     },
 //   ],
 //   addBindings: true,
 // };
 //
 // // Example of requests:
 // //   - brTPF
 // //   - Find all ?s and ?o matching "?s db:country ?o"
 // const shapeSmartKg: FragmentSelectorShape = {
 //   type: 'disjunction',
 //   children: [
 //     {
 //       type: 'operation',
 //       operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //       variablesOptional: [
 //         DF.variable('s'),
 //         DF.variable('p'),
 //         DF.variable('o'),
 //       ],
 //       addBindings: true,
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.BGP },
 //       children: [
 //         {
 //           type: 'arity',
 //           min: 1,
 //           max: Number.POSITIVE_INFINITY,
 //           child: {
 //             type: 'operation',
 //             operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //             variablesRequired: [
 //               DF.variable('p'),
 //             ],
 //           },
 //         },
 //       ],
 //     },
 //   ],
 // };

});

parcelRegister("gtbX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("22OMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fPKlB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kONCO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kYqLJ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;
/**
 * A logger accepts messages from different levels
 * and emits them in a certain way.
 */ var $f44e2cf8ae964e6f$var$Logger = /*#__PURE__*/ function() {
    function Logger() {
        (0, $jGAMp._)(this, Logger);
    }
    (0, $byiyg._)(Logger, null, [
        {
            key: "getLevelOrdinal",
            value: /**
     * Convert a string-based logging level to a numerical logging level.
     * @param level A string-based logging level
     * @return The numerical logging level, or undefined.
     */ function getLevelOrdinal(level) {
                return Logger.LEVELS[level];
            }
        }
    ]);
    return Logger;
}();
module.exports.Logger = $f44e2cf8ae964e6f$var$Logger;
/**
 * All available logging levels.
 * @type {{trace: number; debug: number; info: number; warn: number; error: number; fatal: number}}
 */ $f44e2cf8ae964e6f$var$Logger.LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5
};

});

parcelRegister("9Lh9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionType = void 0;
var $71b5cf576533c2b5$var$ExpressionType;
(function(ExpressionType) {
    ExpressionType["Aggregate"] = "aggregate";
    ExpressionType["Existence"] = "existence";
    ExpressionType["Operator"] = "operator";
    ExpressionType["Term"] = "term";
    ExpressionType["Variable"] = "variable";
})($71b5cf576533c2b5$var$ExpressionType || (module.exports.ExpressionType = $71b5cf576533c2b5$var$ExpressionType = {}));

});




parcelRegister("1W2eA", function(module, exports) {
"use strict";
var $168cf0ecb2bef17e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $168cf0ecb2bef17e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $168cf0ecb2bef17e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$168cf0ecb2bef17e$var$__exportStar((parcelRequire("9D6za")), module.exports);

$168cf0ecb2bef17e$var$__exportStar((parcelRequire("fTX4j")), module.exports);

$168cf0ecb2bef17e$var$__exportStar((parcelRequire("3g6Xo")), module.exports);

$168cf0ecb2bef17e$var$__exportStar((parcelRequire("3Novs")), module.exports);

});
parcelRegister("9D6za", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorFunctionFactory = module.exports.ActorFunctionFactory = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for function factory events.
 *
 * Actor types:
 * * Input:  IActionFunctions: A request to receive a function implementation for a given function name
 * and potentially the function arguments.
 * * Test:   <none>
 * * Output: IActorFunctionsOutput: A function implementation.
 *
 * @see IActionFunctionFactory
 * @see IActorFunctionFactoryOutput
 */ var $702cd97d119a7e22$var$ActorFunctionFactory = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorFunctionFactory, _core_1_Actor);
    function ActorFunctionFactory(args) {
        (0, $jGAMp._)(this, ActorFunctionFactory);
        return (0, $kzDuW._)(this, ActorFunctionFactory, [
            args
        ]);
    }
    return ActorFunctionFactory;
}($kNNoa.Actor);
module.exports.ActorFunctionFactory = $702cd97d119a7e22$var$ActorFunctionFactory;
var $702cd97d119a7e22$var$MediatorFunctionFactory = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorFunctionFactory, _core_1_Mediator);
    function MediatorFunctionFactory() {
        (0, $jGAMp._)(this, MediatorFunctionFactory);
        return (0, $kzDuW._)(this, MediatorFunctionFactory, arguments);
    }
    return MediatorFunctionFactory;
}($kNNoa.Mediator);
module.exports.MediatorFunctionFactory = $702cd97d119a7e22$var$MediatorFunctionFactory;

});

parcelRegister("fTX4j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryDedicated = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $9D6za = parcelRequire("9D6za");
/**
 * A base implementation for function factory actors for a dedicated operator.
 */ var $b939cfd43a254013$var$ActorFunctionFactoryDedicated = /*#__PURE__*/ function(_ActorFunctionFactory_1_ActorFunctionFactory) {
    (0, $i3fW3._)(ActorFunctionFactoryDedicated, _ActorFunctionFactory_1_ActorFunctionFactory);
    function ActorFunctionFactoryDedicated(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryDedicated);
        return (0, $kzDuW._)(this, ActorFunctionFactoryDedicated, [
            args
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryDedicated, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Name must match, if this is a term function, all is fine, if not, look whether term-function is not requested.
                        if (this.functionNames.includes(action.functionName) && (this.termFunction || !action.requireTermExpression)) return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                        return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, ' can not provide implementation for "').concat(action.functionName, '", only for ').concat(this.termFunction ? '' : 'non-termExpression ').concat(this.functionNames.join(' and '), "."))
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryDedicated;
}($9D6za.ActorFunctionFactory);
module.exports.ActorFunctionFactoryDedicated = $b939cfd43a254013$var$ActorFunctionFactoryDedicated;

});

parcelRegister("3g6Xo", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusFunctionFactory = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * Bus inspired by BusIndexed but specific for function factory.
 *
 * The implementation differs. In BusIndexed, each actor is indexed only once.
 * Here, a single actor can be indexed multiple times (max 2).
 */ var $25f843379ce077dc$var$BusFunctionFactory = /*#__PURE__*/ function(_core_1_BusIndexed) {
    (0, $i3fW3._)(BusFunctionFactory, _core_1_BusIndexed);
    function BusFunctionFactory(args) {
        (0, $jGAMp._)(this, BusFunctionFactory);
        return (0, $kzDuW._)(this, BusFunctionFactory, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                actorIdentifierFields: [
                    'functionNames'
                ],
                actionIdentifierFields: [
                    'functionName'
                ]
            })
        ]);
    }
    return BusFunctionFactory;
}($kNNoa.BusIndexed);
module.exports.BusFunctionFactory = $25f843379ce077dc$var$BusFunctionFactory;

});

parcelRegister("3Novs", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionBase = module.exports.ExpressionFunctionBase = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
var $2c38f5294ff534f6$var$ExpressionFunctionBase = /*#__PURE__*/ function() {
    function ExpressionFunctionBase(param) {
        var arity = param.arity, operator = param.operator, apply = param.apply;
        (0, $jGAMp._)(this, ExpressionFunctionBase);
        this.arity = arity;
        this.operator = operator;
        this.apply = apply;
    }
    (0, $byiyg._)(ExpressionFunctionBase, [
        {
            key: "checkArity",
            value: function checkArity(args) {
                if (Array.isArray(this.arity)) return this.arity.includes(args.length);
                if (this.arity === Number.POSITIVE_INFINITY) // Infinity is used to represent var-args, so it's always correct.
                return true;
                return args.length === this.arity;
            }
        }
    ]);
    return ExpressionFunctionBase;
}();
module.exports.ExpressionFunctionBase = $2c38f5294ff534f6$var$ExpressionFunctionBase;
/**
 * Varying kinds of functions take arguments of different types on which the
 * specific behaviour is dependant. Although their behaviour is often varying,
 * it is always relatively simple, and better suited for synced behaviour.
 * The types of their arguments are always terms, but might differ in
 * their term-type (eg: iri, literal),
 * their specific literal type (eg: string, integer),
 * their arity (see BNODE),
 * or even their specific numeric type (eg: integer, float).
 *
 * Examples include:
 *  - Arithmetic operations such as: *, -, /, +
 *  - Bool operators such as: =, !=, <=, <, ...
 *  - Functions such as: str, IRI
 *
 * See also: https://www.w3.org/TR/definitionTypesparql11-query/#func-rdfTerms
 * and https://www.w3.org/TR/sparql11-query/#OperatorMapping
 */ var $2c38f5294ff534f6$var$TermFunctionBase = /*#__PURE__*/ function(ExpressionFunctionBase) {
    (0, $i3fW3._)(TermFunctionBase, ExpressionFunctionBase);
    function TermFunctionBase(param) {
        var arity = param.arity, operator = param.operator, overloads = param.overloads;
        (0, $jGAMp._)(this, TermFunctionBase);
        var _this;
        var _this1;
        _this = (0, $kzDuW._)(this, TermFunctionBase, [
            {
                arity: arity,
                operator: operator,
                apply: function(param) {
                    var args = param.args, exprEval = param.exprEval, mapping = param.mapping;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var _;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _ = _this1.applyOnTerms;
                                    return [
                                        4,
                                        Promise.all(args.map(function(arg) {
                                            return exprEval.evaluatorExpressionEvaluation(arg, mapping);
                                        }))
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _.apply(_this1, [
                                            _state.sent(),
                                            exprEval
                                        ])
                                    ];
                            }
                        });
                    })();
                }
            }
        ]), _this1 = _this;
        _this1.supportsTermExpressions = true;
        _this1.overloads = overloads;
        return _this;
    }
    (0, $byiyg._)(TermFunctionBase, [
        {
            key: "applyOnTerms",
            value: function applyOnTerms(args, exprEval) {
                var _this_overloads_search;
                var concreteFunction = (_this_overloads_search = this.overloads.search(args, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider), exprEval.context.getSafe($9nBhR.KeysInitQuery.functionArgumentsCache))) !== null && _this_overloads_search !== void 0 ? _this_overloads_search : this.handleInvalidTypes(args);
                return concreteFunction(exprEval)(args);
            }
        },
        {
            key: "handleInvalidTypes",
            value: function handleInvalidTypes(args) {
                throw new $aduX6.InvalidArgumentTypes(args, this.operator);
            }
        }
    ]);
    return TermFunctionBase;
}($2c38f5294ff534f6$var$ExpressionFunctionBase);
module.exports.TermFunctionBase = $2c38f5294ff534f6$var$TermFunctionBase;

});
parcelRegister("aduX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LangStringLiteral = module.exports.TimeLiteral = module.exports.DurationLiteral = module.exports.DateLiteral = module.exports.DayTimeDurationLiteral = module.exports.DateTimeLiteral = module.exports.yearMonthDurationsToMonths = module.exports.toUTCDate = module.exports.toDateTimeRepresentation = module.exports.negateDuration = module.exports.extractRawTimeZone = module.exports.defaultedYearMonthDurationRepresentation = module.exports.defaultedDurationRepresentation = module.exports.defaultedDayTimeDurationRepresentation = module.exports.defaultedDateTimeRepresentation = module.exports.dayTimeDurationsToSeconds = module.exports.isSubTypeOf = module.exports.SparqlOperator = module.exports.TypeAlias = module.exports.TypeURL = module.exports.typedLiteral = module.exports.InvalidArity = module.exports.InvalidLexicalForm = module.exports.ExtensionFunctionError = module.exports.CastError = module.exports.UnboundVariableError = module.exports.NoAggregator = module.exports.InError = module.exports.CoalesceError = module.exports.InvalidArgumentTypes = module.exports.InvalidTimezoneCall = module.exports.IncompatibleLanguageOperation = module.exports.RDFEqualTypeError = module.exports.EmptyAggregateError = module.exports.isExpressionError = module.exports.ExpressionError = module.exports.Builder = module.exports.expressionToVar = module.exports["float"] = module.exports.decimal = module.exports.langString = module.exports.dateTime = module.exports.integer = module.exports["double"] = module.exports.string = module.exports.bool = module.exports.declare = module.exports.prepareEvaluatorActionContext = module.exports.OverloadTree = module.exports.TermTransformer = void 0;
module.exports.trimToDayTimeDuration = module.exports.trimToYearMonthDuration = module.exports.parseDate = module.exports.parseXSDFloat = module.exports.parseXSDDecimal = module.exports.parseYearMonthDuration = module.exports.parseTime = module.exports.parseDuration = module.exports.parseDayTimeDuration = module.exports.parseDateTime = module.exports.elapsedDuration = module.exports.addDurationToDateTime = module.exports.isNonLexicalLiteral = module.exports.StringLiteral = module.exports.NonLexicalLiteral = module.exports.FloatLiteral = module.exports.IntegerLiteral = module.exports.Literal = module.exports.Existence = module.exports.Aggregate = module.exports.DoubleLiteral = module.exports.DefaultGraph = module.exports.DecimalLiteral = module.exports.BlankNode = module.exports.BooleanLiteral = module.exports.NumericLiteral = module.exports.Variable = module.exports.NamedNode = module.exports.Operator = module.exports.Quad = module.exports.YearMonthDurationLiteral = module.exports.Term = void 0;

var $2WVZ8 = parcelRequire("2WVZ8");
Object.defineProperty(module.exports, "TermTransformer", {
    enumerable: true,
    get: function get() {
        return $2WVZ8.TermTransformer;
    }
});

var $eckXw = parcelRequire("eckXw");
Object.defineProperty(module.exports, "OverloadTree", {
    enumerable: true,
    get: function get() {
        return $eckXw.OverloadTree;
    }
});

var $1dicK = parcelRequire("1dicK");
Object.defineProperty(module.exports, "prepareEvaluatorActionContext", {
    enumerable: true,
    get: function get() {
        return $1dicK.prepareEvaluatorActionContext;
    }
});

var $tVMut = parcelRequire("tVMut");
Object.defineProperty(module.exports, "declare", {
    enumerable: true,
    get: function get() {
        return $tVMut.declare;
    }
});
Object.defineProperty(module.exports, "bool", {
    enumerable: true,
    get: function get() {
        return $tVMut.bool;
    }
});
Object.defineProperty(module.exports, "string", {
    enumerable: true,
    get: function get() {
        return $tVMut.string;
    }
});
Object.defineProperty(module.exports, "double", {
    enumerable: true,
    get: function get() {
        return $tVMut.double;
    }
});
Object.defineProperty(module.exports, "integer", {
    enumerable: true,
    get: function get() {
        return $tVMut.integer;
    }
});
Object.defineProperty(module.exports, "dateTime", {
    enumerable: true,
    get: function get() {
        return $tVMut.dateTime;
    }
});
Object.defineProperty(module.exports, "langString", {
    enumerable: true,
    get: function get() {
        return $tVMut.langString;
    }
});
Object.defineProperty(module.exports, "decimal", {
    enumerable: true,
    get: function get() {
        return $tVMut.decimal;
    }
});
Object.defineProperty(module.exports, "float", {
    enumerable: true,
    get: function get() {
        return $tVMut.float;
    }
});
Object.defineProperty(module.exports, "expressionToVar", {
    enumerable: true,
    get: function get() {
        return $tVMut.expressionToVar;
    }
});
Object.defineProperty(module.exports, "Builder", {
    enumerable: true,
    get: function get() {
        return $tVMut.Builder;
    }
});

var $gwvZQ = parcelRequire("gwvZQ");
Object.defineProperty(module.exports, "ExpressionError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.ExpressionError;
    }
});
Object.defineProperty(module.exports, "isExpressionError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.isExpressionError;
    }
});
Object.defineProperty(module.exports, "EmptyAggregateError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.EmptyAggregateError;
    }
});
Object.defineProperty(module.exports, "RDFEqualTypeError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.RDFEqualTypeError;
    }
});
Object.defineProperty(module.exports, "IncompatibleLanguageOperation", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.IncompatibleLanguageOperation;
    }
});
Object.defineProperty(module.exports, "InvalidTimezoneCall", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.InvalidTimezoneCall;
    }
});
Object.defineProperty(module.exports, "InvalidArgumentTypes", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.InvalidArgumentTypes;
    }
});
Object.defineProperty(module.exports, "CoalesceError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.CoalesceError;
    }
});
Object.defineProperty(module.exports, "InError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.InError;
    }
});
Object.defineProperty(module.exports, "NoAggregator", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.NoAggregator;
    }
});
Object.defineProperty(module.exports, "UnboundVariableError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.UnboundVariableError;
    }
});
Object.defineProperty(module.exports, "CastError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.CastError;
    }
});
Object.defineProperty(module.exports, "ExtensionFunctionError", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.ExtensionFunctionError;
    }
});
Object.defineProperty(module.exports, "InvalidLexicalForm", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.InvalidLexicalForm;
    }
});
Object.defineProperty(module.exports, "InvalidArity", {
    enumerable: true,
    get: function get() {
        return $gwvZQ.InvalidArity;
    }
});

var $lb1HF = parcelRequire("lb1HF");
Object.defineProperty(module.exports, "typedLiteral", {
    enumerable: true,
    get: function get() {
        return $lb1HF.typedLiteral;
    }
});
Object.defineProperty(module.exports, "TypeURL", {
    enumerable: true,
    get: function get() {
        return $lb1HF.TypeURL;
    }
});
Object.defineProperty(module.exports, "TypeAlias", {
    enumerable: true,
    get: function get() {
        return $lb1HF.TypeAlias;
    }
});
Object.defineProperty(module.exports, "SparqlOperator", {
    enumerable: true,
    get: function get() {
        return $lb1HF.SparqlOperator;
    }
});

var $DRItq = parcelRequire("DRItq");
Object.defineProperty(module.exports, "isSubTypeOf", {
    enumerable: true,
    get: function get() {
        return $DRItq.isSubTypeOf;
    }
});

var $50jbC = parcelRequire("50jbC");
Object.defineProperty(module.exports, "dayTimeDurationsToSeconds", {
    enumerable: true,
    get: function get() {
        return $50jbC.dayTimeDurationsToSeconds;
    }
});
Object.defineProperty(module.exports, "defaultedDateTimeRepresentation", {
    enumerable: true,
    get: function get() {
        return $50jbC.defaultedDateTimeRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedDayTimeDurationRepresentation", {
    enumerable: true,
    get: function get() {
        return $50jbC.defaultedDayTimeDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedDurationRepresentation", {
    enumerable: true,
    get: function get() {
        return $50jbC.defaultedDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedYearMonthDurationRepresentation", {
    enumerable: true,
    get: function get() {
        return $50jbC.defaultedYearMonthDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "extractRawTimeZone", {
    enumerable: true,
    get: function get() {
        return $50jbC.extractRawTimeZone;
    }
});
Object.defineProperty(module.exports, "negateDuration", {
    enumerable: true,
    get: function get() {
        return $50jbC.negateDuration;
    }
});
Object.defineProperty(module.exports, "toDateTimeRepresentation", {
    enumerable: true,
    get: function get() {
        return $50jbC.toDateTimeRepresentation;
    }
});
Object.defineProperty(module.exports, "toUTCDate", {
    enumerable: true,
    get: function get() {
        return $50jbC.toUTCDate;
    }
});
Object.defineProperty(module.exports, "yearMonthDurationsToMonths", {
    enumerable: true,
    get: function get() {
        return $50jbC.yearMonthDurationsToMonths;
    }
});

var $jk80y = parcelRequire("jk80y");
Object.defineProperty(module.exports, "DateTimeLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DateTimeLiteral;
    }
});
Object.defineProperty(module.exports, "DayTimeDurationLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DayTimeDurationLiteral;
    }
});
Object.defineProperty(module.exports, "DateLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DateLiteral;
    }
});
Object.defineProperty(module.exports, "DurationLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DurationLiteral;
    }
});
Object.defineProperty(module.exports, "TimeLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.TimeLiteral;
    }
});
Object.defineProperty(module.exports, "LangStringLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.LangStringLiteral;
    }
});
Object.defineProperty(module.exports, "Term", {
    enumerable: true,
    get: function get() {
        return $jk80y.Term;
    }
});
Object.defineProperty(module.exports, "YearMonthDurationLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.YearMonthDurationLiteral;
    }
});
Object.defineProperty(module.exports, "Quad", {
    enumerable: true,
    get: function get() {
        return $jk80y.Quad;
    }
});
Object.defineProperty(module.exports, "Operator", {
    enumerable: true,
    get: function get() {
        return $jk80y.Operator;
    }
});
Object.defineProperty(module.exports, "NamedNode", {
    enumerable: true,
    get: function get() {
        return $jk80y.NamedNode;
    }
});
Object.defineProperty(module.exports, "Variable", {
    enumerable: true,
    get: function get() {
        return $jk80y.Variable;
    }
});
Object.defineProperty(module.exports, "NumericLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.NumericLiteral;
    }
});
Object.defineProperty(module.exports, "BooleanLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.BooleanLiteral;
    }
});
Object.defineProperty(module.exports, "BlankNode", {
    enumerable: true,
    get: function get() {
        return $jk80y.BlankNode;
    }
});
Object.defineProperty(module.exports, "DecimalLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DecimalLiteral;
    }
});
Object.defineProperty(module.exports, "DefaultGraph", {
    enumerable: true,
    get: function get() {
        return $jk80y.DefaultGraph;
    }
});
Object.defineProperty(module.exports, "DoubleLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.DoubleLiteral;
    }
});
Object.defineProperty(module.exports, "Aggregate", {
    enumerable: true,
    get: function get() {
        return $jk80y.Aggregate;
    }
});
Object.defineProperty(module.exports, "Existence", {
    enumerable: true,
    get: function get() {
        return $jk80y.Existence;
    }
});
Object.defineProperty(module.exports, "Literal", {
    enumerable: true,
    get: function get() {
        return $jk80y.Literal;
    }
});
Object.defineProperty(module.exports, "IntegerLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.IntegerLiteral;
    }
});
Object.defineProperty(module.exports, "FloatLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.FloatLiteral;
    }
});
Object.defineProperty(module.exports, "NonLexicalLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.NonLexicalLiteral;
    }
});
Object.defineProperty(module.exports, "StringLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.StringLiteral;
    }
});
Object.defineProperty(module.exports, "isNonLexicalLiteral", {
    enumerable: true,
    get: function get() {
        return $jk80y.isNonLexicalLiteral;
    }
});

var $62SQo = parcelRequire("62SQo");
Object.defineProperty(module.exports, "addDurationToDateTime", {
    enumerable: true,
    get: function get() {
        return $62SQo.addDurationToDateTime;
    }
});
Object.defineProperty(module.exports, "elapsedDuration", {
    enumerable: true,
    get: function get() {
        return $62SQo.elapsedDuration;
    }
});

var $k3Tq9 = parcelRequire("k3Tq9");
Object.defineProperty(module.exports, "parseDateTime", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseDateTime;
    }
});
Object.defineProperty(module.exports, "parseDayTimeDuration", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseDayTimeDuration;
    }
});
Object.defineProperty(module.exports, "parseDuration", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseDuration;
    }
});
Object.defineProperty(module.exports, "parseTime", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseTime;
    }
});
Object.defineProperty(module.exports, "parseYearMonthDuration", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseYearMonthDuration;
    }
});
Object.defineProperty(module.exports, "parseXSDDecimal", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseXSDDecimal;
    }
});
Object.defineProperty(module.exports, "parseXSDFloat", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseXSDFloat;
    }
});
Object.defineProperty(module.exports, "parseDate", {
    enumerable: true,
    get: function get() {
        return $k3Tq9.parseDate;
    }
});

var $50jbC = parcelRequire("50jbC");
Object.defineProperty(module.exports, "trimToYearMonthDuration", {
    enumerable: true,
    get: function get() {
        return $50jbC.trimToYearMonthDuration;
    }
});
Object.defineProperty(module.exports, "trimToDayTimeDuration", {
    enumerable: true,
    get: function get() {
        return $50jbC.trimToDayTimeDuration;
    }
});

});
parcelRegister("2WVZ8", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermTransformer = void 0;

var $gQYIc = parcelRequire("gQYIc");

var $hSHd8 = parcelRequire("hSHd8");

var $jk80y = parcelRequire("jk80y");

var $lb1HF = parcelRequire("lb1HF");

var $gwvZQ = parcelRequire("gwvZQ");

var $gwvZQ = parcelRequire("gwvZQ");

var $k3Tq9 = parcelRequire("k3Tq9");

var $k3Tq9 = parcelRequire("k3Tq9");

var $DRItq = parcelRequire("DRItq");
var $225dfa2b26bd9745$var$TermTransformer = /*#__PURE__*/ function() {
    function TermTransformer(superTypeProvider) {
        (0, $jGAMp._)(this, TermTransformer);
        this.superTypeProvider = superTypeProvider;
    }
    (0, $byiyg._)(TermTransformer, [
        {
            /**
     * Transforms an RDF term to the internal representation of a term,
     * assuming it is not a variable, which would be an expression (internally).
     *
     * @param term RDF term to transform into internal representation of a term
     */ key: "transformRDFTermUnsafe",
            value: function transformRDFTermUnsafe(term) {
                return this.transformTerm({
                    term: term,
                    type: $hSHd8.Algebra.types.EXPRESSION,
                    expressionType: $hSHd8.Algebra.expressionTypes.TERM
                });
            }
        },
        {
            key: "transformTerm",
            value: function transformTerm(term) {
                if (!term.term) throw new $gwvZQ.InvalidExpression(term);
                switch(term.term.termType){
                    case 'Variable':
                        return new $jk80y.Variable($gQYIc.termToString(term.term));
                    case 'Literal':
                        return this.transformLiteral(term.term);
                    case 'NamedNode':
                        return new $jk80y.NamedNode(term.term.value);
                    case 'BlankNode':
                        return new $jk80y.BlankNode(term.term.value);
                    case 'Quad':
                        return new $jk80y.Quad(this.transformRDFTermUnsafe(term.term.subject), this.transformRDFTermUnsafe(term.term.predicate), this.transformRDFTermUnsafe(term.term.object), this.transformRDFTermUnsafe(term.term.graph));
                    case 'DefaultGraph':
                        return new $jk80y.DefaultGraph();
                }
            }
        },
        {
            /**
     * @param lit the rdf literal we want to transform to an internal Literal expression.
     */ key: "transformLiteral",
            value: function transformLiteral(lit) {
                // Both here and within the switch we transform to LangStringLiteral or StringLiteral.
                // We do this when we detect a simple literal being used.
                // Original issue regarding this behaviour: https://github.com/w3c/sparql-12/issues/112
                if (!lit.datatype || [
                    null,
                    undefined,
                    ''
                ].includes(lit.datatype.value)) return lit.language ? new $jk80y.LangStringLiteral(lit.value, lit.language) : new $jk80y.StringLiteral(lit.value);
                var dataType = lit.datatype.value;
                var superTypeDict = (0, $DRItq.getSuperTypeDict)(dataType, this.superTypeProvider);
                // The order of checking matters! Check most specific types first!
                try {
                    if ($lb1HF.TypeURL.XSD_STRING in superTypeDict) return new $jk80y.StringLiteral(lit.value, dataType);
                    if ($lb1HF.TypeURL.RDF_LANG_STRING in superTypeDict) return new $jk80y.LangStringLiteral(lit.value, lit.language);
                    if ($lb1HF.TypeURL.XSD_YEAR_MONTH_DURATION in superTypeDict) return new $jk80y.YearMonthDurationLiteral((0, $k3Tq9.parseYearMonthDuration)(lit.value), lit.value, dataType);
                    if ($lb1HF.TypeURL.XSD_DAY_TIME_DURATION in superTypeDict) return new $jk80y.DayTimeDurationLiteral((0, $k3Tq9.parseDayTimeDuration)(lit.value), lit.value, dataType);
                    if ($lb1HF.TypeURL.XSD_DURATION in superTypeDict) return new $jk80y.DurationLiteral((0, $k3Tq9.parseDuration)(lit.value), lit.value, dataType);
                    if ($lb1HF.TypeURL.XSD_DATE_TIME in superTypeDict) {
                        var dateVal = new Date(lit.value);
                        if (Number.isNaN(dateVal.getTime())) return new $jk80y.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                        return new $jk80y.DateTimeLiteral((0, $k3Tq9.parseDateTime)(lit.value), lit.value, dataType);
                    }
                    if ($lb1HF.TypeURL.XSD_DATE in superTypeDict) return new $jk80y.DateLiteral((0, $k3Tq9.parseDate)(lit.value), lit.value, dataType);
                    if ($lb1HF.TypeURL.XSD_TIME in superTypeDict) return new $jk80y.TimeLiteral((0, $k3Tq9.parseTime)(lit.value), lit.value, dataType);
                    if ($lb1HF.TypeURL.XSD_BOOLEAN in superTypeDict) {
                        if (lit.value !== 'true' && lit.value !== 'false' && lit.value !== '1' && lit.value !== '0') return new $jk80y.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                        return new $jk80y.BooleanLiteral(lit.value === 'true' || lit.value === '1', lit.value);
                    }
                    if ($lb1HF.TypeURL.XSD_DECIMAL in superTypeDict) {
                        var intVal = $k3Tq9.parseXSDDecimal(lit.value);
                        if (intVal === undefined) return new $jk80y.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                        if ($lb1HF.TypeURL.XSD_INTEGER in superTypeDict) return new $jk80y.IntegerLiteral(intVal, dataType, lit.value);
                        // If type is not an integer it's just a decimal.
                        return new $jk80y.DecimalLiteral(intVal, dataType, lit.value);
                    }
                    var isFloat = $lb1HF.TypeURL.XSD_FLOAT in superTypeDict;
                    var isDouble = $lb1HF.TypeURL.XSD_DOUBLE in superTypeDict;
                    if (isFloat || isDouble) {
                        var doubleVal = $k3Tq9.parseXSDFloat(lit.value);
                        if (doubleVal === undefined) return new $jk80y.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                        if (isFloat) return new $jk80y.FloatLiteral(doubleVal, dataType, lit.value);
                        return new $jk80y.DoubleLiteral(doubleVal, dataType, lit.value);
                    }
                    return new $jk80y.Literal(lit.value, dataType, lit.value);
                } catch (error) {
                    if ((0, $gwvZQ.isExpressionError)(error)) return new $jk80y.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                    throw error;
                }
            }
        }
    ]);
    return TermTransformer;
}();
module.exports.TermTransformer = $225dfa2b26bd9745$var$TermTransformer;

});
parcelRegister("gQYIc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralLanguage = void 0;

var $GxhZ5 = parcelRequire("GxhZ5");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function get() {
        return $GxhZ5.termToString;
    }
});

});
parcelRegister("GxhZ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.stringToTerm = module.exports.getLiteralLanguage = module.exports.getLiteralType = module.exports.getLiteralValue = module.exports.termToString = void 0;

var $2ej16 = parcelRequire("2ej16");
var $07fdbedfb278bb43$var$FACTORY = new $2ej16.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $07fdbedfb278bb43$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            var literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '');
        case 'Quad':
            return "<<".concat($07fdbedfb278bb43$var$termToString(term.subject), " ").concat($07fdbedfb278bb43$var$termToString(term.predicate), " ").concat($07fdbedfb278bb43$var$termToString(term.object)).concat(term.graph.termType === 'DefaultGraph' ? '' : ' ' + $07fdbedfb278bb43$var$termToString(term.graph), ">>");
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
module.exports.termToString = $07fdbedfb278bb43$var$termToString;
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $07fdbedfb278bb43$var$getLiteralValue(literalValue) {
    var match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
module.exports.getLiteralValue = $07fdbedfb278bb43$var$getLiteralValue;
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $07fdbedfb278bb43$var$getLiteralType(literalValue) {
    var match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
module.exports.getLiteralType = $07fdbedfb278bb43$var$getLiteralType;
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $07fdbedfb278bb43$var$getLiteralLanguage(literalValue) {
    var match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] ? match[1].toLowerCase() : '';
}
module.exports.getLiteralLanguage = $07fdbedfb278bb43$var$getLiteralLanguage;
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $07fdbedfb278bb43$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $07fdbedfb278bb43$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error("Missing 'variable()' method on the given DataFactory");
            return dataFactory.variable(value.substr(1));
        case '"':
            var language = $07fdbedfb278bb43$var$getLiteralLanguage(value);
            var type = dataFactory.namedNode($07fdbedfb278bb43$var$getLiteralType(value));
            return dataFactory.literal($07fdbedfb278bb43$var$getLiteralValue(value), language || type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                var terms = value.slice(2, -2).trim();
                var stringTerms = [];
                var ignoreTags = 0;
                var lastIndex = 0;
                var inQuote = false;
                for(var i = 0; i < terms.length; i++){
                    var _char = terms[i];
                    if (_char === '<') ignoreTags++;
                    if (_char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (_char === '"') {
                        var escaped = false;
                        var j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (_char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map(function(term) {
                    return term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term;
                });
                return dataFactory.quad($07fdbedfb278bb43$var$stringToTerm(stringTerms[0]), $07fdbedfb278bb43$var$stringToTerm(stringTerms[1]), $07fdbedfb278bb43$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $07fdbedfb278bb43$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
module.exports.stringToTerm = $07fdbedfb278bb43$var$stringToTerm;
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $07fdbedfb278bb43$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $07fdbedfb278bb43$var$termToString(q.subject),
        predicate: $07fdbedfb278bb43$var$termToString(q.predicate),
        object: $07fdbedfb278bb43$var$termToString(q.object),
        graph: $07fdbedfb278bb43$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
module.exports.quadToStringQuad = $07fdbedfb278bb43$var$quadToStringQuad;
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $07fdbedfb278bb43$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $07fdbedfb278bb43$var$FACTORY;
    return dataFactory.quad($07fdbedfb278bb43$var$stringToTerm(stringQuad.subject, dataFactory), $07fdbedfb278bb43$var$stringToTerm(stringQuad.predicate, dataFactory), $07fdbedfb278bb43$var$stringToTerm(stringQuad.object, dataFactory), $07fdbedfb278bb43$var$stringToTerm(stringQuad.graph, dataFactory));
}
module.exports.stringQuadToQuad = $07fdbedfb278bb43$var$stringQuadToQuad;

});
parcelRegister("2ej16", function(module, exports) {
"use strict";
var $19fba3efd255ee31$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $19fba3efd255ee31$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $19fba3efd255ee31$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$19fba3efd255ee31$var$__exportStar((parcelRequire("lWD7N")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("dsYXT")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("91V7Q")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("huJPC")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("3nU8T")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("hFuPj")), module.exports);

$19fba3efd255ee31$var$__exportStar((parcelRequire("bAiRT")), module.exports);

});
parcelRegister("lWD7N", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ var $ff9d5d1c6e51f03e$var$BlankNode = /*#__PURE__*/ function() {
    function BlankNode(value) {
        (0, $jGAMp._)(this, BlankNode);
        this.termType = 'BlankNode';
        this.value = value;
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNode;
}();
module.exports.BlankNode = $ff9d5d1c6e51f03e$var$BlankNode;

});

parcelRegister("dsYXT", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $lWD7N = parcelRequire("lWD7N");

var $91V7Q = parcelRequire("91V7Q");

var $huJPC = parcelRequire("huJPC");

var $3nU8T = parcelRequire("3nU8T");

var $hFuPj = parcelRequire("hFuPj");

var $bAiRT = parcelRequire("bAiRT");
var $9cdd2e410df6e58f$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ var $9cdd2e410df6e58f$var$DataFactory = /*#__PURE__*/ function() {
    function DataFactory(options) {
        (0, $jGAMp._)(this, DataFactory);
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || "df_".concat($9cdd2e410df6e58f$var$dataFactoryCounter++, "_");
    }
    (0, $byiyg._)(DataFactory, [
        {
            /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ key: "namedNode",
            value: function namedNode(value) {
                return new $3nU8T.NamedNode(value);
            }
        },
        {
            /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ key: "blankNode",
            value: function blankNode(value) {
                return new $lWD7N.BlankNode(value || "".concat(this.blankNodePrefix).concat(this.blankNodeCounter++));
            }
        },
        {
            /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language or datatype.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           Otherwise `languageOrDatatype` is used for the value
     *                           of `NamedNode.language`.
     * @return A new instance of Literal.
     * @see Literal
     */ key: "literal",
            value: function literal(value, languageOrDatatype) {
                return new $huJPC.Literal(value, languageOrDatatype);
            }
        },
        {
            /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ key: "variable",
            value: function variable(value) {
                return new $bAiRT.Variable(value);
            }
        },
        {
            /**
     * @return An instance of DefaultGraph.
     */ key: "defaultGraph",
            value: function defaultGraph() {
                return $91V7Q.DefaultGraph.INSTANCE;
            }
        },
        {
            /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ key: "quad",
            value: function quad(subject, predicate, object, graph) {
                return new $hFuPj.Quad(subject, predicate, object, graph || this.defaultGraph());
            }
        },
        {
            /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ key: "fromTerm",
            value: function fromTerm(original) {
                // TODO: remove nasty any casts when this TS bug has been fixed:
                //  https://github.com/microsoft/TypeScript/issues/26933
                switch(original.termType){
                    case 'NamedNode':
                        return this.namedNode(original.value);
                    case 'BlankNode':
                        return this.blankNode(original.value);
                    case 'Literal':
                        if (original.language) return this.literal(original.value, original.language);
                        if (!original.datatype.equals($huJPC.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                        return this.literal(original.value);
                    case 'Variable':
                        return this.variable(original.value);
                    case 'DefaultGraph':
                        return this.defaultGraph();
                    case 'Quad':
                        return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
                }
            }
        },
        {
            /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ key: "fromQuad",
            value: function fromQuad(original) {
                return this.fromTerm(original);
            }
        },
        {
            /**
     * Reset the internal blank node counter.
     */ key: "resetBlankNodeCounter",
            value: function resetBlankNodeCounter() {
                this.blankNodeCounter = 0;
            }
        }
    ]);
    return DataFactory;
}();
module.exports.DataFactory = $9cdd2e410df6e58f$var$DataFactory;

});
parcelRegister("91V7Q", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $01b254b9b833c35e$var$DefaultGraph = /*#__PURE__*/ function() {
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        this.termType = 'DefaultGraph';
        this.value = '';
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'DefaultGraph';
            }
        }
    ]);
    return DefaultGraph;
}();
module.exports.DefaultGraph = $01b254b9b833c35e$var$DefaultGraph;
$01b254b9b833c35e$var$DefaultGraph.INSTANCE = new $01b254b9b833c35e$var$DefaultGraph();

});

parcelRegister("huJPC", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $3nU8T = parcelRequire("3nU8T");
/**
 * A term that represents an RDF literal, containing a string with an optional language tag or datatype.
 */ var $cbc8ca2de1852be1$var$Literal = /*#__PURE__*/ function() {
    function Literal(value, languageOrDatatype) {
        (0, $jGAMp._)(this, Literal);
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = Literal.RDF_LANGUAGE_STRING;
        } else if (languageOrDatatype) {
            this.language = '';
            this.datatype = languageOrDatatype;
        } else {
            this.language = '';
            this.datatype = Literal.XSD_STRING;
        }
    }
    (0, $byiyg._)(Literal, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && this.datatype.equals(other.datatype);
            }
        }
    ]);
    return Literal;
}();
module.exports.Literal = $cbc8ca2de1852be1$var$Literal;
$cbc8ca2de1852be1$var$Literal.RDF_LANGUAGE_STRING = new $3nU8T.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$cbc8ca2de1852be1$var$Literal.XSD_STRING = new $3nU8T.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("3nU8T", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ var $276f11cdc711b6b0$var$NamedNode = /*#__PURE__*/ function() {
    function NamedNode(value) {
        (0, $jGAMp._)(this, NamedNode);
        this.termType = 'NamedNode';
        this.value = value;
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'NamedNode' && other.value === this.value;
            }
        }
    ]);
    return NamedNode;
}();
module.exports.NamedNode = $276f11cdc711b6b0$var$NamedNode;

});


parcelRegister("hFuPj", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $cdce2d80ad71c49e$var$Quad = /*#__PURE__*/ function() {
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "equals",
            value: function equals(other) {
                // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
                return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
            }
        }
    ]);
    return Quad;
}();
module.exports.Quad = $cdce2d80ad71c49e$var$Quad;

});

parcelRegister("bAiRT", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ var $86f1b157be103232$var$Variable = /*#__PURE__*/ function() {
    function Variable(value) {
        (0, $jGAMp._)(this, Variable);
        this.termType = 'Variable';
        this.value = value;
    }
    (0, $byiyg._)(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Variable' && other.value === this.value;
            }
        }
    ]);
    return Variable;
}();
module.exports.Variable = $86f1b157be103232$var$Variable;

});





parcelRegister("hSHd8", function(module, exports) {
"use strict";
var $d048ff9bc2aa0129$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d048ff9bc2aa0129$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d048ff9bc2aa0129$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d048ff9bc2aa0129$var$__createBinding(result, mod, k);
    }
    $d048ff9bc2aa0129$var$__setModuleDefault(result, mod);
    return result;
};
var $d048ff9bc2aa0129$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = module.exports.toSparqlJs = module.exports.toSparql = module.exports.Factory = module.exports.Algebra = module.exports.translate = void 0;

var $d048ff9bc2aa0129$var$sparqlAlgebra_1 = $d048ff9bc2aa0129$var$__importDefault((parcelRequire("gIyqO")));
module.exports.translate = $d048ff9bc2aa0129$var$sparqlAlgebra_1["default"];

var $d048ff9bc2aa0129$var$Algebra = $d048ff9bc2aa0129$var$__importStar((parcelRequire("2utmd")));
module.exports.Algebra = $d048ff9bc2aa0129$var$Algebra;

var $d048ff9bc2aa0129$var$factory_1 = $d048ff9bc2aa0129$var$__importDefault((parcelRequire("3btxo")));
module.exports.Factory = $d048ff9bc2aa0129$var$factory_1["default"];

var $zButK = parcelRequire("zButK");
Object.defineProperty(module.exports, "toSparql", {
    enumerable: true,
    get: function get() {
        return $zButK.toSparql;
    }
});
Object.defineProperty(module.exports, "toSparqlJs", {
    enumerable: true,
    get: function get() {
        return $zButK.toSparqlJs;
    }
});

var $d048ff9bc2aa0129$var$util_1 = $d048ff9bc2aa0129$var$__importDefault((parcelRequire("7qBOV")));
module.exports.Util = $d048ff9bc2aa0129$var$util_1["default"];

});
parcelRegister("gIyqO", function(module, exports) {

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
var $c2bb76c32d721f2c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c2bb76c32d721f2c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c2bb76c32d721f2c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c2bb76c32d721f2c$var$__createBinding(result, mod, k);
    }
    $c2bb76c32d721f2c$var$__setModuleDefault(result, mod);
    return result;
};
var $c2bb76c32d721f2c$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cfoeU = parcelRequire("cfoeU");

var $gQYIc = parcelRequire("gQYIc");

var $c2bb76c32d721f2c$var$Algebra = $c2bb76c32d721f2c$var$__importStar((parcelRequire("2utmd")));

var $c2bb76c32d721f2c$var$factory_1 = $c2bb76c32d721f2c$var$__importDefault((parcelRequire("3btxo")));

var $c2bb76c32d721f2c$var$util_1 = $c2bb76c32d721f2c$var$__importDefault((parcelRequire("7qBOV")));

var $2h2ox = parcelRequire("2h2ox");
var $c2bb76c32d721f2c$require$Parser = $2h2ox.Parser;
var $c2bb76c32d721f2c$var$types = $c2bb76c32d721f2c$var$Algebra.types;
var $c2bb76c32d721f2c$var$variables = new Set();
var $c2bb76c32d721f2c$var$varCount = 0;
var $c2bb76c32d721f2c$var$useQuads = false;
var $c2bb76c32d721f2c$var$factory;
/**
 * Translates the given SPARQL query to SPARQL Algebra.
 * @param sparql - Either a SPARQL string or an object generated by sparql.js
 * @param options - Optional options object. Current options:
 *                    * dataFactory: The Datafactory used to generate terms. Default @rdfjs/data-model.
 *                    * quads: Boolean indicating whether triples should be converted to Quads (consumes GRAPH statements). Default false.
 *                    * prefixes: Pre-defined prefixes for the given query. Default empty.
 *                    * baseIRI: Base IRI that should be used for the query. Default undefined (throws error if required).
 * @returns {Operation}
 */ function $c2bb76c32d721f2c$var$translate(sparql, options) {
    options = options || {};
    $c2bb76c32d721f2c$var$factory = new $c2bb76c32d721f2c$var$factory_1["default"](options.dataFactory);
    var query;
    if ($c2bb76c32d721f2c$var$isString(sparql)) {
        var parser = new $c2bb76c32d721f2c$require$Parser(options);
        // resets the identifier counter used for blank nodes
        // provides nicer and more consistent output if there are multiple calls
        parser._resetBlanks();
        query = parser.parse(sparql);
    } else query = sparql;
    return $c2bb76c32d721f2c$var$translateQuery(query, options.quads, options.blankToVariable);
}
module.exports["default"] = $c2bb76c32d721f2c$var$translate;
function $c2bb76c32d721f2c$var$translateQuery(sparql, quads, blankToVariable) {
    // this set is filled in during the inScopeVariables call
    $c2bb76c32d721f2c$var$variables = new Set();
    $c2bb76c32d721f2c$var$varCount = 0;
    $c2bb76c32d721f2c$var$useQuads = Boolean(quads);
    // Assume this is an empty query
    if (!sparql.type) return $c2bb76c32d721f2c$var$factory.createNop();
    if (sparql.type !== 'query' && sparql.type !== 'update') throw new Error('Translate only works on complete query or update objects.');
    var res;
    // find ALL variables here to fill `variables` array
    $c2bb76c32d721f2c$var$findAllVariables(sparql);
    if (sparql.type === 'query') {
        // group and where are identical, having only 1 makes parsing easier, can be undefined in DESCRIBE
        var group = {
            type: 'group',
            patterns: sparql.where || []
        };
        res = $c2bb76c32d721f2c$var$translateGraphPattern(group);
        res = $c2bb76c32d721f2c$var$translateAggregates(sparql, res);
    } else if (sparql.type === 'update') res = $c2bb76c32d721f2c$var$translateUpdate(sparql);
    if (blankToVariable) res = $c2bb76c32d721f2c$var$translateBlankNodesToVariables(res);
    return res;
}
function $c2bb76c32d721f2c$var$isString(str) {
    return typeof str === 'string';
}
function $c2bb76c32d721f2c$var$isTerm(term) {
    return Boolean(term === null || term === void 0 ? void 0 : term.termType);
}
// This is not completely correct but this way we also catch SPARQL.js triples
function $c2bb76c32d721f2c$var$isTriple(triple) {
    return triple.subject && triple.predicate && triple.object;
}
function $c2bb76c32d721f2c$var$isVariable(term) {
    return (term === null || term === void 0 ? void 0 : term.termType) === 'Variable';
}
// Will be used to make sure new variables don't overlap
function $c2bb76c32d721f2c$var$findAllVariables(thingy) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    if ($c2bb76c32d721f2c$var$isTerm(thingy)) {
        if ($c2bb76c32d721f2c$var$isVariable(thingy)) // Variables don't store the `?`
        $c2bb76c32d721f2c$var$variables.add("?".concat(thingy.value));
    } else if (Array.isArray(thingy)) try {
        for(var _iterator = thingy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            $c2bb76c32d721f2c$var$findAllVariables(entry);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (thingy && (typeof thingy === "undefined" ? "undefined" : (0, $3KZcf._)(thingy)) === 'object') try {
        for(var _iterator1 = Object.keys(thingy)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key = _step1.value;
            // Some variables are hidden in keys (specifically for VALUES)
            if (key.startsWith('?')) $c2bb76c32d721f2c$var$variables.add(key);
            else if (key.startsWith('$')) $c2bb76c32d721f2c$var$variables.add("?".concat(key.slice(1)));
            $c2bb76c32d721f2c$var$findAllVariables(thingy[key]);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
// 18.2.1
function $c2bb76c32d721f2c$var$inScopeVariables(thingy) {
    var // A path predicate should not have variables but just iterating so we could theoretically support this
    _Object, _Object1;
    var inScope = {};
    if ($c2bb76c32d721f2c$var$isTriple(thingy)) {
        var _Object2;
        // Note that this could both be an actual Quad or a SPARQL.js triple (without graph)
        var result = [
            $c2bb76c32d721f2c$var$inScopeVariables(thingy.subject),
            $c2bb76c32d721f2c$var$inScopeVariables(thingy.predicate),
            $c2bb76c32d721f2c$var$inScopeVariables(thingy.object),
            thingy.graph ? $c2bb76c32d721f2c$var$inScopeVariables(thingy.graph) : {}
        ];
        (_Object2 = Object).assign.apply(_Object2, [
            inScope
        ].concat((0, $7WNf6._)(result)));
    } else if ($c2bb76c32d721f2c$var$isTerm(thingy)) {
        if ($c2bb76c32d721f2c$var$isVariable(thingy)) inScope[thingy.value] = thingy;
    } else if (thingy.type === 'bgp') {
        var _Object3;
        // Slightly cheating but this is a subset of what we support so is fine
        var quads = thingy.triples;
        (_Object3 = Object).assign.apply(_Object3, [
            inScope
        ].concat((0, $7WNf6._)(quads.map($c2bb76c32d721f2c$var$inScopeVariables))));
    } else if (thingy.type === 'path') (_Object = Object).assign.apply(_Object, [
        inScope
    ].concat((0, $7WNf6._)(thingy.items.map($c2bb76c32d721f2c$var$inScopeVariables))));
    else if (thingy.type === 'group' || thingy.type === 'union' || thingy.type === 'optional') (_Object1 = Object).assign.apply(_Object1, [
        inScope
    ].concat((0, $7WNf6._)(thingy.patterns.map($c2bb76c32d721f2c$var$inScopeVariables))));
    else if (thingy.type === 'service' || thingy.type === 'graph') {
        var _Object4;
        Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(thingy.name));
        (_Object4 = Object).assign.apply(_Object4, [
            inScope
        ].concat((0, $7WNf6._)(thingy.patterns.map($c2bb76c32d721f2c$var$inScopeVariables))));
    } else if (thingy.type === 'bind') Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(thingy.variable));
    else if (thingy.type === 'values') {
        if (thingy.values.length > 0) {
            var _Object5;
            var vars = Object.keys(thingy.values[0]).map(function(v) {
                return $c2bb76c32d721f2c$var$factory.createTerm(v);
            });
            (_Object5 = Object).assign.apply(_Object5, [
                inScope
            ].concat((0, $7WNf6._)(vars.map($c2bb76c32d721f2c$var$inScopeVariables))));
        }
    } else if (thingy.type === 'query') {
        if (thingy.queryType === 'SELECT' || thingy.queryType === 'DESCRIBE') {
            var _Object6;
            if (thingy.where && thingy.variables.some($c2bb76c32d721f2c$var$util_1["default"].isWildcard)) (_Object6 = Object).assign.apply(_Object6, [
                inScope
            ].concat((0, $7WNf6._)(thingy.where.map($c2bb76c32d721f2c$var$inScopeVariables))));
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = thingy.variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var v = _step.value;
                    if ($c2bb76c32d721f2c$var$isVariable(v)) Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(v));
                    else if (v.variable) Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(v.variable));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (thingy.queryType === 'SELECT') {
                if (thingy.group) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // Grouping can be a VariableExpression, typings are wrong
                        for(var _iterator1 = thingy.group[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var g = _step1.value;
                            if (g.variable) Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(g.variable));
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                if (thingy.values) {
                    var values = {
                        type: 'values',
                        values: thingy.values
                    };
                    Object.assign(inScope, $c2bb76c32d721f2c$var$inScopeVariables(values));
                }
            }
        }
    }
    return inScope;
}
function $c2bb76c32d721f2c$var$translateGraphPattern(thingy) {
    // 18.2.2.1
    // already done by sparql parser
    // 18.2.2.3
    // 18.2.2.4
    // 18.2.2.5
    // In Sparql.js, a group with a single BGP in it is a single object.
    if (thingy.type === 'bgp') return $c2bb76c32d721f2c$var$translateBgp(thingy);
    // 18.2.2.6 - GroupOrUnionGraphPattern
    if (thingy.type === 'union') return $c2bb76c32d721f2c$var$factory.createUnion(thingy.patterns.map(function(p) {
        // sparqljs doesn't always indicate the children are groups
        if (p.type !== 'group') p = {
            type: 'group',
            patterns: [
                p
            ]
        };
        return $c2bb76c32d721f2c$var$translateGraphPattern(p);
    }));
    // 18.2.2.6 - GraphGraphPattern
    if (thingy.type === 'graph') {
        // Sparql.js combines the group graph pattern and the graph itself in the same object.
        // We split here so the group graph pattern can be interpreted correctly.
        var group = {
            type: 'group',
            patterns: thingy.patterns
        };
        var result = $c2bb76c32d721f2c$var$translateGraphPattern(group);
        // Output depends on if we use quads or not
        if ($c2bb76c32d721f2c$var$useQuads) result = $c2bb76c32d721f2c$var$recurseGraph(result, thingy.name);
        else result = $c2bb76c32d721f2c$var$factory.createGraph(result, thingy.name);
        return result;
    }
    // 18.2.2.6 - InlineData
    if (thingy.type === 'values') return $c2bb76c32d721f2c$var$translateInlineData(thingy);
    // 18.2.2.6 - SubSelect
    if (thingy.type === 'query') return $c2bb76c32d721f2c$var$translateQuery(thingy, $c2bb76c32d721f2c$var$useQuads, false);
    if (thingy.type === 'group') {
        // 18.2.2.2
        var filters = [];
        var nonfilters = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = thingy.patterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var pattern = _step.value;
                (pattern.type === 'filter' ? filters : nonfilters).push(pattern);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // 18.2.2.6 - GroupGraphPattern
        var result1 = nonfilters.reduce($c2bb76c32d721f2c$var$accumulateGroupGraphPattern, $c2bb76c32d721f2c$var$factory.createBgp([]));
        // 18.2.2.7
        var expressions = filters.map(function(filter) {
            return $c2bb76c32d721f2c$var$translateExpression(filter.expression);
        });
        if (expressions.length > 0) result1 = $c2bb76c32d721f2c$var$factory.createFilter(result1, expressions.reduce(function(acc, exp) {
            return $c2bb76c32d721f2c$var$factory.createOperatorExpression('&&', [
                acc,
                exp
            ]);
        }));
        return result1;
    }
    throw new Error("Unexpected type: ".concat(thingy.type));
}
function $c2bb76c32d721f2c$var$translateExpression(exp) {
    if ($c2bb76c32d721f2c$var$util_1["default"].isSimpleTerm(exp)) return $c2bb76c32d721f2c$var$factory.createTermExpression(exp);
    if ($c2bb76c32d721f2c$var$util_1["default"].isQuad(exp)) {
        if ($c2bb76c32d721f2c$var$util_1["default"].hasQuadVariables(exp)) return $c2bb76c32d721f2c$var$factory.createOperatorExpression('triple', [
            $c2bb76c32d721f2c$var$translateExpression(exp.subject),
            $c2bb76c32d721f2c$var$translateExpression(exp.predicate),
            $c2bb76c32d721f2c$var$translateExpression(exp.object)
        ]);
        else return $c2bb76c32d721f2c$var$factory.createTermExpression(exp);
    }
    if ($c2bb76c32d721f2c$var$util_1["default"].isWildcard(exp)) return $c2bb76c32d721f2c$var$factory.createWildcardExpression();
    if ('aggregation' in exp) return $c2bb76c32d721f2c$var$factory.createAggregateExpression(exp.aggregation, $c2bb76c32d721f2c$var$translateExpression(exp.expression), Boolean(exp.distinct), exp.separator);
    if ('function' in exp) // Outdated typings
    return $c2bb76c32d721f2c$var$factory.createNamedExpression(exp["function"], exp.args.map($c2bb76c32d721f2c$var$translateExpression));
    if ('operator' in exp) {
        if (exp.operator === 'exists' || exp.operator === 'notexists') return $c2bb76c32d721f2c$var$factory.createExistenceExpression(exp.operator === 'notexists', $c2bb76c32d721f2c$var$translateGraphPattern(exp.args[0]));
        if (exp.operator === 'in' || exp.operator === 'notin') exp.args = [
            exp.args[0]
        ].concat(exp.args[1]); // sparql.js uses 2 arguments with the second one being a list
        return $c2bb76c32d721f2c$var$factory.createOperatorExpression(exp.operator, exp.args.map($c2bb76c32d721f2c$var$translateExpression));
    }
    throw new Error("Unknown expression: ".concat(JSON.stringify(exp)));
}
function $c2bb76c32d721f2c$var$translateBgp(thingy) {
    var patterns = [];
    var joins = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = thingy.triples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if ('pathType' in t.predicate) {
                // translatePath returns a mix of Quads and Paths
                var path = $c2bb76c32d721f2c$var$translatePath(t);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = path[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var p = _step1.value;
                        if (p.type === $c2bb76c32d721f2c$var$types.PATH) {
                            if (patterns.length > 0) joins.push($c2bb76c32d721f2c$var$factory.createBgp(patterns));
                            patterns = [];
                            joins.push(p);
                        } else patterns.push(p);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            } else patterns.push($c2bb76c32d721f2c$var$translateQuad(t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (patterns.length > 0) joins.push($c2bb76c32d721f2c$var$factory.createBgp(patterns));
    if (joins.length === 1) return joins[0];
    return $c2bb76c32d721f2c$var$factory.createJoin(joins);
}
function $c2bb76c32d721f2c$var$translatePath(triple) {
    var sub = triple.subject;
    var pred = $c2bb76c32d721f2c$var$translatePathPredicate(triple.predicate);
    var obj = triple.object;
    return $c2bb76c32d721f2c$var$simplifyPath(sub, pred, obj);
}
function $c2bb76c32d721f2c$var$translatePathPredicate(predicate) {
    if ($c2bb76c32d721f2c$var$util_1["default"].isSimpleTerm(predicate)) {
        if (predicate.termType === 'NamedNode') return $c2bb76c32d721f2c$var$factory.createLink(predicate);
        else throw new Error("Path predicate should be a NamedNode, got ".concat(JSON.stringify(predicate)));
    }
    if (predicate.pathType === '^') return $c2bb76c32d721f2c$var$factory.createInv($c2bb76c32d721f2c$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '!') {
        // negation is either over a single predicate or a list of disjuncted properties
        var normals = [];
        var inverted = [];
        var items;
        if ('pathType' in predicate.items[0] && predicate.items[0].pathType === '|') items = predicate.items[0].items; // the | element
        else items = predicate.items;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if ($c2bb76c32d721f2c$var$util_1["default"].isSimpleTerm(item)) normals.push(item);
                else if (item.pathType === '^') inverted.push(item.items[0]);
                else throw new Error("Unexpected item: ".concat(JSON.stringify(item)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // NPS elements do not have the LINK function
        var normalElement = $c2bb76c32d721f2c$var$factory.createNps(normals);
        var invertedElement = $c2bb76c32d721f2c$var$factory.createInv($c2bb76c32d721f2c$var$factory.createNps(inverted));
        if (inverted.length === 0) return normalElement;
        if (normals.length === 0) return invertedElement;
        return $c2bb76c32d721f2c$var$factory.createAlt([
            normalElement,
            invertedElement
        ]);
    }
    if (predicate.pathType === '/') return $c2bb76c32d721f2c$var$factory.createSeq(predicate.items.map($c2bb76c32d721f2c$var$translatePathPredicate));
    if (predicate.pathType === '|') return $c2bb76c32d721f2c$var$factory.createAlt(predicate.items.map($c2bb76c32d721f2c$var$translatePathPredicate));
    if (predicate.pathType === '*') return $c2bb76c32d721f2c$var$factory.createZeroOrMorePath($c2bb76c32d721f2c$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '+') return $c2bb76c32d721f2c$var$factory.createOneOrMorePath($c2bb76c32d721f2c$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '?') return $c2bb76c32d721f2c$var$factory.createZeroOrOnePath($c2bb76c32d721f2c$var$translatePathPredicate(predicate.items[0]));
    throw new Error("Unable to translate path expression ".concat(JSON.stringify(predicate)));
}
function $c2bb76c32d721f2c$var$simplifyPath(subject, predicate, object) {
    if (predicate.type === $c2bb76c32d721f2c$var$types.LINK) return [
        $c2bb76c32d721f2c$var$factory.createPattern(subject, predicate.iri, object)
    ];
    if (predicate.type === $c2bb76c32d721f2c$var$types.INV) return $c2bb76c32d721f2c$var$simplifyPath(object, predicate.path, subject);
    if (predicate.type === $c2bb76c32d721f2c$var$types.SEQ) {
        var joiner = subject;
        return $c2bb76c32d721f2c$var$util_1["default"].flatten(predicate.input.map(function(subOp, i) {
            var nextJoiner = i === predicate.input.length - 1 ? object : $c2bb76c32d721f2c$var$generateFreshVar();
            var simplifiedPath = $c2bb76c32d721f2c$var$simplifyPath(joiner, subOp, nextJoiner);
            if (nextJoiner.termType === 'Variable') joiner = nextJoiner;
            return simplifiedPath;
        }));
    }
    return [
        $c2bb76c32d721f2c$var$factory.createPath(subject, predicate, object)
    ];
}
function $c2bb76c32d721f2c$var$generateFreshVar() {
    var v = "?var".concat($c2bb76c32d721f2c$var$varCount++);
    if ($c2bb76c32d721f2c$var$variables.has(v)) return $c2bb76c32d721f2c$var$generateFreshVar();
    $c2bb76c32d721f2c$var$variables.add(v);
    return $c2bb76c32d721f2c$var$factory.createTerm(v);
}
function $c2bb76c32d721f2c$var$translateQuad(quad) {
    if ('pathType' in quad.predicate) throw new Error('Trying to translate property path to quad.');
    // Graphs are needed here
    // TODO: investigate if typings are wrong or if we internally add graphs to these
    return $c2bb76c32d721f2c$var$factory.createPattern(quad.subject, quad.predicate, quad.object, quad.graph);
}
var $c2bb76c32d721f2c$var$typeVals = Object.values($c2bb76c32d721f2c$var$types);
function $c2bb76c32d721f2c$var$recurseGraph(thingy, graph, replacement) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (thingy.type === $c2bb76c32d721f2c$var$types.GRAPH) {
        if (replacement) // At this point we would lose track of the replacement which would result in incorrect results
        // This would indicate the library is not being used as intended though
        throw new Error('Recursing through nested GRAPH statements with a replacement is impossible.');
        // In case there were nested GRAPH statements that were not recursed yet for some reason
        thingy = $c2bb76c32d721f2c$var$recurseGraph(thingy.input, thingy.name);
    } else if (thingy.type === $c2bb76c32d721f2c$var$types.SERVICE) ;
    else if (thingy.type === $c2bb76c32d721f2c$var$types.BGP) thingy.patterns = thingy.patterns.map(function(quad) {
        if (replacement) {
            if (quad.subject.equals(graph)) quad.subject = replacement;
            if (quad.predicate.equals(graph)) quad.predicate = replacement;
            if (quad.object.equals(graph)) quad.object = replacement;
        }
        if (quad.graph.termType === 'DefaultGraph') quad.graph = graph;
        return quad;
    });
    else if (thingy.type === $c2bb76c32d721f2c$var$types.PATH) {
        if (replacement) {
            if (thingy.subject.equals(graph)) thingy.subject = replacement;
            if (thingy.object.equals(graph)) thingy.object = replacement;
        }
        if (thingy.graph.termType === 'DefaultGraph') thingy.graph = graph;
    } else if (thingy.type === $c2bb76c32d721f2c$var$types.PROJECT && !replacement) {
        if (!thingy.variables.some(function(v) {
            return v.equals(graph);
        })) replacement = $c2bb76c32d721f2c$var$generateFreshVar();
        thingy.input = $c2bb76c32d721f2c$var$recurseGraph(thingy.input, graph, replacement);
    } else if (thingy.type === $c2bb76c32d721f2c$var$types.EXTEND && !replacement) {
        if (thingy.variable.equals(graph)) replacement = $c2bb76c32d721f2c$var$generateFreshVar();
        thingy.input = $c2bb76c32d721f2c$var$recurseGraph(thingy.input, graph, replacement);
    } else try {
        for(var _iterator = Object.keys(thingy)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (Array.isArray(thingy[key])) thingy[key] = thingy[key].map(function(x) {
                return $c2bb76c32d721f2c$var$recurseGraph(x, graph, replacement);
            });
            else if ($c2bb76c32d721f2c$var$typeVals.indexOf(thingy[key].type) >= 0) thingy[key] = $c2bb76c32d721f2c$var$recurseGraph(thingy[key], graph, replacement);
            else if (replacement && $c2bb76c32d721f2c$var$isVariable(thingy[key]) && thingy[key].equals(graph)) thingy[key] = replacement;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return thingy;
}
function $c2bb76c32d721f2c$var$accumulateGroupGraphPattern(G, E) {
    if (E.type === 'optional') {
        // optional input needs to be interpreted as a group
        var A = $c2bb76c32d721f2c$var$translateGraphPattern({
            type: 'group',
            patterns: E.patterns
        });
        if (A.type === $c2bb76c32d721f2c$var$types.FILTER) G = $c2bb76c32d721f2c$var$factory.createLeftJoin(G, A.input, A.expression);
        else G = $c2bb76c32d721f2c$var$factory.createLeftJoin(G, A);
    } else if (E.type === 'minus') {
        // minus input needs to be interpreted as a group
        var A1 = $c2bb76c32d721f2c$var$translateGraphPattern({
            type: 'group',
            patterns: E.patterns
        });
        G = $c2bb76c32d721f2c$var$factory.createMinus(G, A1);
    } else if (E.type === 'bind') G = $c2bb76c32d721f2c$var$factory.createExtend(G, E.variable, $c2bb76c32d721f2c$var$translateExpression(E.expression));
    else if (E.type === 'service') {
        // transform to group so childnodes get parsed correctly
        var group = {
            type: 'group',
            patterns: E.patterns
        };
        var A2 = $c2bb76c32d721f2c$var$factory.createService($c2bb76c32d721f2c$var$translateGraphPattern(group), E.name, E.silent);
        G = $c2bb76c32d721f2c$var$simplifiedJoin(G, A2);
    } else {
        var A3 = $c2bb76c32d721f2c$var$translateGraphPattern(E);
        G = $c2bb76c32d721f2c$var$simplifiedJoin(G, A3);
    }
    return G;
}
function $c2bb76c32d721f2c$var$simplifiedJoin(G, A) {
    // Note: this is more simplification than requested in 18.2.2.8, but no reason not to do it.
    if (G.type === $c2bb76c32d721f2c$var$types.BGP && A.type === $c2bb76c32d721f2c$var$types.BGP) G = $c2bb76c32d721f2c$var$factory.createBgp((0, $7WNf6._)(G.patterns).concat((0, $7WNf6._)(A.patterns)));
    else if (G.type === $c2bb76c32d721f2c$var$types.BGP && G.patterns.length === 0) G = A;
    else if (A.type === $c2bb76c32d721f2c$var$types.BGP && A.patterns.length === 0) ; // do nothing
    else G = $c2bb76c32d721f2c$var$factory.createJoin([
        G,
        A
    ]);
    return G;
}
function $c2bb76c32d721f2c$var$translateInlineData(values) {
    var variables = (values.values.length === 0 ? [] : Object.keys(values.values[0])).map($c2bb76c32d721f2c$var$factory.createTerm.bind($c2bb76c32d721f2c$var$factory));
    var bindings = values.values.map(function(binding) {
        var keys = Object.keys(binding);
        keys = keys.filter(function(k) {
            return binding[k] !== undefined;
        });
        var map = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                map[key] = binding[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return map;
    });
    return $c2bb76c32d721f2c$var$factory.createValues(variables, bindings);
}
// --------------------------------------- AGGREGATES
function $c2bb76c32d721f2c$var$translateAggregates(query, res) {
    // Typings for ConstructQuery are wrong and missing several fields so we will cast quite often to SelectQuery to have partial typings
    var select = query;
    // 18.2.4.1
    var E = [];
    var A = {};
    select.variables = select.variables && select.variables.map(function(val) {
        return $c2bb76c32d721f2c$var$mapAggregate(val, A);
    });
    select.having = select.having && select.having.map(function(val) {
        return $c2bb76c32d721f2c$var$mapAggregate(val, A);
    });
    select.order = select.order && select.order.map(function(val) {
        return $c2bb76c32d721f2c$var$mapAggregate(val, A);
    });
    // if there are any aggregates or if we have a groupBy (both result in a GROUP)
    if (select.group || Object.keys(A).length > 0) {
        var aggregates = Object.keys(A).map(function(v) {
            return $c2bb76c32d721f2c$var$translateBoundAggregate(A[v], $c2bb76c32d721f2c$var$factory.createTerm(v));
        });
        var vars = [];
        if (select.group) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = select.group[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    if ($c2bb76c32d721f2c$var$util_1["default"].isSimpleTerm(e.expression)) vars.push(e.expression); // this will always be a var, otherwise sparql would be invalid
                    else {
                        // Incorrect typings, e can have a variable, see for example group-variable test in sparql.js
                        var v = 'variable' in e ? e.variable : $c2bb76c32d721f2c$var$generateFreshVar();
                        res = $c2bb76c32d721f2c$var$factory.createExtend(res, v, $c2bb76c32d721f2c$var$translateExpression(e.expression));
                        vars.push(v);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        res = $c2bb76c32d721f2c$var$factory.createGroup(res, vars, aggregates);
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    // 18.2.4.2
    if (select.having) try {
        for(var _iterator1 = select.having[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var filter = _step1.value;
            res = $c2bb76c32d721f2c$var$factory.createFilter(res, $c2bb76c32d721f2c$var$translateExpression(filter));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // 18.2.4.3
    if (query.values) res = $c2bb76c32d721f2c$var$factory.createJoin([
        res,
        $c2bb76c32d721f2c$var$translateInlineData(query)
    ]);
    // 18.2.4.4
    var PV = [];
    if (query.queryType === 'SELECT' || query.queryType === 'DESCRIBE') {
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        // Sort variables for consistent output
        if (query.variables.some(function(e) {
            return e && $c2bb76c32d721f2c$var$util_1["default"].isWildcard(e);
        })) PV = Object.values($c2bb76c32d721f2c$var$inScopeVariables(query)).sort(function(left, right) {
            return left.value.localeCompare(right.value);
        });
        else try {
            // Wildcard has been filtered out above
            for(var _iterator2 = query.variables[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var v1 = _step2.value;
                // can have non-variables with DESCRIBE
                if ($c2bb76c32d721f2c$var$isVariable(v1) || !('variable' in v1)) PV.push(v1);
                else if (v1.variable) {
                    PV.push(v1.variable);
                    E.push(v1);
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        // TODO: Jena simplifies by having a list of extends
        for(var _iterator3 = E[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var v2 = _step3.value;
            res = $c2bb76c32d721f2c$var$factory.createExtend(res, v2.variable, $c2bb76c32d721f2c$var$translateExpression(v2.expression));
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    // 18.2.5
    // not using toList and toMultiset
    // 18.2.5.1
    if (select.order) res = $c2bb76c32d721f2c$var$factory.createOrderBy(res, select.order.map(function(exp) {
        var result = $c2bb76c32d721f2c$var$translateExpression(exp.expression);
        if (exp.descending) result = $c2bb76c32d721f2c$var$factory.createOperatorExpression('desc', [
            result
        ]);
        return result;
    }));
    // 18.2.5.2
    // construct does not need a project (select, ask and describe do)
    if (query.queryType === 'SELECT') // Named nodes are only possible in a DESCRIBE so this cast is safe
    res = $c2bb76c32d721f2c$var$factory.createProject(res, PV);
    // 18.2.5.3
    if (select.distinct) res = $c2bb76c32d721f2c$var$factory.createDistinct(res);
    // 18.2.5.4
    if (select.reduced) res = $c2bb76c32d721f2c$var$factory.createReduced(res);
    // NEW: support for ask/construct/describe queries
    if (query.queryType === 'CONSTRUCT') res = $c2bb76c32d721f2c$var$factory.createConstruct(res, (query.template || []).map($c2bb76c32d721f2c$var$translateQuad));
    else if (query.queryType === 'ASK') res = $c2bb76c32d721f2c$var$factory.createAsk(res);
    else if (query.queryType === 'DESCRIBE') res = $c2bb76c32d721f2c$var$factory.createDescribe(res, PV);
    // Slicing needs to happen after construct/describe
    // 18.2.5.5
    if (select.offset || select.limit) res = $c2bb76c32d721f2c$var$factory.createSlice(res, select.offset || 0, select.limit);
    if (select.from) res = $c2bb76c32d721f2c$var$factory.createFrom(res, select.from["default"], select.from.named);
    return res;
}
// rewrites some of the input sparql object to make use of aggregate variables
function $c2bb76c32d721f2c$var$mapAggregate(thingy, aggregates) {
    if ('type' in thingy && thingy.type === 'aggregate') {
        var found = false;
        var v;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(aggregates)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if ($cfoeU(aggregates[key], thingy)) {
                    v = $c2bb76c32d721f2c$var$factory.createTerm(key);
                    found = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!found) {
            v = $c2bb76c32d721f2c$var$generateFreshVar();
            aggregates[(0, $gQYIc.termToString)(v)] = thingy;
        }
        return v;
    }
    // non-aggregate expression
    if ('expression' in thingy && thingy.expression) return (0, $emQHU._)((0, $iT0je._)({}, thingy), {
        expression: $c2bb76c32d721f2c$var$mapAggregate(thingy.expression, aggregates)
    });
    if ('args' in thingy && thingy.args) return (0, $emQHU._)((0, $iT0je._)({}, thingy), {
        args: thingy.args.map(function(subthingy) {
            return $c2bb76c32d721f2c$var$mapAggregate(subthingy, aggregates);
        })
    });
    // Normal variable/wildcard
    return thingy;
}
function $c2bb76c32d721f2c$var$translateBoundAggregate(thingy, v) {
    if (thingy.type !== 'aggregate' || !thingy.aggregation) throw new Error("Unexpected input: ".concat(JSON.stringify(thingy)));
    var A = $c2bb76c32d721f2c$var$translateExpression(thingy);
    A.variable = v;
    return A;
}
function $c2bb76c32d721f2c$var$translateUpdate(thingy) {
    if (thingy.updates.length === 1) return $c2bb76c32d721f2c$var$translateSingleUpdate(thingy.updates[0]);
    return $c2bb76c32d721f2c$var$factory.createCompositeUpdate(thingy.updates.map($c2bb76c32d721f2c$var$translateSingleUpdate));
}
function $c2bb76c32d721f2c$var$translateSingleUpdate(thingy) {
    if ('type' in thingy) {
        if (thingy.type === 'load') return $c2bb76c32d721f2c$var$translateUpdateGraphLoad(thingy);
        if (thingy.type === 'clear' || thingy.type === 'create' || thingy.type === 'drop') return $c2bb76c32d721f2c$var$translateUpdateGraph(thingy);
        if (thingy.type === 'add' || thingy.type === 'copy' || thingy.type === 'move') return $c2bb76c32d721f2c$var$translateUpdateGraphShortcut(thingy);
    } else if (thingy.updateType === 'insertdelete' || thingy.updateType === 'deletewhere' || thingy.updateType === 'delete' || thingy.updateType === 'insert') return $c2bb76c32d721f2c$var$translateInsertDelete(thingy);
    throw new Error("Unknown update type ".concat(JSON.stringify(thingy)));
}
function $c2bb76c32d721f2c$var$translateInsertDelete(thingy) {
    if (!$c2bb76c32d721f2c$var$useQuads) throw new Error('INSERT/DELETE operations are only supported with quads option enabled');
    var deleteTriples = [];
    var insertTriples = [];
    var where;
    if (thingy["delete"]) deleteTriples = $c2bb76c32d721f2c$var$util_1["default"].flatten(thingy["delete"].map(function(input) {
        return $c2bb76c32d721f2c$var$translateUpdateTriplesBlock(input, thingy.graph);
    }));
    if (thingy.insert) insertTriples = $c2bb76c32d721f2c$var$util_1["default"].flatten(thingy.insert.map(function(input) {
        return $c2bb76c32d721f2c$var$translateUpdateTriplesBlock(input, thingy.graph);
    }));
    if (thingy.where && thingy.where.length > 0) {
        where = $c2bb76c32d721f2c$var$translateGraphPattern({
            type: 'group',
            patterns: thingy.where
        });
        // Wrong typings, see test "using" in Sparql.js
        var use = thingy.using;
        if (use) where = $c2bb76c32d721f2c$var$factory.createFrom(where, use["default"], use.named);
        else if (thingy.graph) // This is equivalent
        where = $c2bb76c32d721f2c$var$recurseGraph(where, thingy.graph);
    } else if (thingy.updateType === 'deletewhere' && deleteTriples.length > 0) where = $c2bb76c32d721f2c$var$factory.createBgp(deleteTriples);
    return $c2bb76c32d721f2c$var$factory.createDeleteInsert(deleteTriples.length > 0 ? deleteTriples : undefined, insertTriples.length > 0 ? insertTriples : undefined, where);
}
// UPDATE parsing will always return quads and have no GRAPH elements
function $c2bb76c32d721f2c$var$translateUpdateTriplesBlock(thingy, graph) {
    var currentGraph = graph;
    if (thingy.type === 'graph') currentGraph = thingy.name;
    var currentTriples = thingy.triples;
    if (currentGraph) currentTriples = currentTriples.map(function(triple) {
        return Object.assign(triple, {
            graph: currentGraph
        });
    });
    return currentTriples.map($c2bb76c32d721f2c$var$translateQuad);
}
function $c2bb76c32d721f2c$var$translateUpdateGraph(thingy) {
    var source;
    if ($c2bb76c32d721f2c$var$util_1["default"].isSimpleTerm(thingy.graph)) source = thingy.graph;
    else if (thingy.graph.all) source = 'ALL';
    else if (thingy.graph["default"]) source = 'DEFAULT';
    else if (thingy.graph.named) source = 'NAMED';
    else source = thingy.graph.name;
    switch(thingy.type){
        case 'clear':
            return $c2bb76c32d721f2c$var$factory.createClear(source, thingy.silent);
        case 'create':
            return $c2bb76c32d721f2c$var$factory.createCreate(source, thingy.silent);
        case 'drop':
            return $c2bb76c32d721f2c$var$factory.createDrop(source, thingy.silent);
    }
}
function $c2bb76c32d721f2c$var$translateUpdateGraphLoad(thingy) {
    return $c2bb76c32d721f2c$var$factory.createLoad(thingy.source, thingy.destination, thingy.silent);
}
function $c2bb76c32d721f2c$var$translateUpdateGraphShortcut(thingy) {
    var source = thingy.source["default"] ? 'DEFAULT' : thingy.source.name;
    var destination = thingy.destination["default"] ? 'DEFAULT' : thingy.destination.name;
    switch(thingy.type){
        case 'copy':
            return $c2bb76c32d721f2c$var$factory.createCopy(source, destination, thingy.silent);
        case 'move':
            return $c2bb76c32d721f2c$var$factory.createMove(source, destination, thingy.silent);
        case 'add':
            return $c2bb76c32d721f2c$var$factory.createAdd(source, destination, thingy.silent);
    }
}
function $c2bb76c32d721f2c$var$translateBlankNodesToVariables(res) {
    var blankToVariableMapping = {};
    var variablesRaw = Array.from($c2bb76c32d721f2c$var$variables).reduce(function(acc, variable) {
        acc[variable] = true;
        return acc;
    }, {});
    var _obj;
    return $c2bb76c32d721f2c$var$util_1["default"].mapOperation(res, (_obj = {}, (0, $cqEAj._)(_obj, $c2bb76c32d721f2c$var$Algebra.types.DELETE_INSERT, function(op) {
        // Make sure blank nodes remain in the INSERT block, but do update the WHERE block
        return {
            result: $c2bb76c32d721f2c$var$factory.createDeleteInsert(op["delete"], op.insert, op.where && $c2bb76c32d721f2c$var$translateBlankNodesToVariables(op.where)),
            recurse: false
        };
    }), (0, $cqEAj._)(_obj, $c2bb76c32d721f2c$var$Algebra.types.PATH, function(op, factory) {
        return {
            result: factory.createPath(blankToVariable(op.subject), op.predicate, blankToVariable(op.object), blankToVariable(op.graph)),
            recurse: false
        };
    }), (0, $cqEAj._)(_obj, $c2bb76c32d721f2c$var$Algebra.types.PATTERN, function(op, factory) {
        return {
            result: factory.createPattern(blankToVariable(op.subject), blankToVariable(op.predicate), blankToVariable(op.object), blankToVariable(op.graph)),
            recurse: false
        };
    }), (0, $cqEAj._)(_obj, $c2bb76c32d721f2c$var$Algebra.types.CONSTRUCT, function(op) {
        // Blank nodes in CONSTRUCT templates must be maintained
        return {
            result: $c2bb76c32d721f2c$var$factory.createConstruct($c2bb76c32d721f2c$var$translateBlankNodesToVariables(op.input), op.template),
            recurse: false
        };
    }), _obj));
    function blankToVariable(term) {
        if (term.termType === 'BlankNode') {
            var variable = blankToVariableMapping[term.value];
            if (!variable) {
                variable = $c2bb76c32d721f2c$var$util_1["default"].createUniqueVariable(term.value, variablesRaw, $c2bb76c32d721f2c$var$factory.dataFactory);
                variablesRaw[variable.value] = true;
                blankToVariableMapping[term.value] = variable;
            }
            return variable;
        }
        return term;
    }
}

});
parcelRegister("cfoeU", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';
// do not edit .js files directly - edit src/index.jst
var $8ea9b03393fb290a$var$envHasBigInt64Array = typeof BigInt64Array !== 'undefined';
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $3KZcf._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $3KZcf._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    i = _step.value;
                    if (!b.has(i[0])) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = a.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    i = _step1.value;
                    if (!equal(i[1], b.get(i[0]))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = a.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    i = _step2.value;
                    if (!b.has(i[0])) return false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                        _iterator2["return"]();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("2utmd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expressionTypes = module.exports.types = void 0;
var $1d0527d88b8944ed$var$types;
(function(types) {
    types["ALT"] = "alt";
    types["ASK"] = "ask";
    types["BGP"] = "bgp";
    types["CONSTRUCT"] = "construct";
    types["DESCRIBE"] = "describe";
    types["DISTINCT"] = "distinct";
    types["EXPRESSION"] = "expression";
    types["EXTEND"] = "extend";
    types["FILTER"] = "filter";
    types["FROM"] = "from";
    types["GRAPH"] = "graph";
    types["GROUP"] = "group";
    types["INV"] = "inv";
    types["JOIN"] = "join";
    types["LEFT_JOIN"] = "leftjoin";
    types["LINK"] = "link";
    types["MINUS"] = "minus";
    types["NOP"] = "nop";
    types["NPS"] = "nps";
    types["ONE_OR_MORE_PATH"] = "OneOrMorePath";
    types["ORDER_BY"] = "orderby";
    types["PATH"] = "path";
    types["PATTERN"] = "pattern";
    types["PROJECT"] = "project";
    types["REDUCED"] = "reduced";
    types["SEQ"] = "seq";
    types["SERVICE"] = "service";
    types["SLICE"] = "slice";
    types["UNION"] = "union";
    types["VALUES"] = "values";
    types["ZERO_OR_MORE_PATH"] = "ZeroOrMorePath";
    types["ZERO_OR_ONE_PATH"] = "ZeroOrOnePath";
    types["COMPOSITE_UPDATE"] = "compositeupdate";
    types["DELETE_INSERT"] = "deleteinsert";
    types["LOAD"] = "load";
    types["CLEAR"] = "clear";
    types["CREATE"] = "create";
    types["DROP"] = "drop";
    types["ADD"] = "add";
    types["MOVE"] = "move";
    types["COPY"] = "copy";
})($1d0527d88b8944ed$var$types = module.exports.types || (module.exports.types = {}));
var $1d0527d88b8944ed$var$expressionTypes;
(function(expressionTypes) {
    expressionTypes["AGGREGATE"] = "aggregate";
    expressionTypes["EXISTENCE"] = "existence";
    expressionTypes["NAMED"] = "named";
    expressionTypes["OPERATOR"] = "operator";
    expressionTypes["TERM"] = "term";
    expressionTypes["WILDCARD"] = "wildcard";
})($1d0527d88b8944ed$var$expressionTypes = module.exports.expressionTypes || (module.exports.expressionTypes = {}));

});

parcelRegister("3btxo", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
var $25194fb5206c1664$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $25194fb5206c1664$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $25194fb5206c1664$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $25194fb5206c1664$var$__createBinding(result, mod, k);
    }
    $25194fb5206c1664$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $25194fb5206c1664$var$A = $25194fb5206c1664$var$__importStar((parcelRequire("2utmd")));

var $2ej16 = parcelRequire("2ej16");

var $gQYIc = parcelRequire("gQYIc");

var $2h2ox = parcelRequire("2h2ox");
var $25194fb5206c1664$var$Factory = /*#__PURE__*/ function() {
    function Factory(dataFactory) {
        (0, $jGAMp._)(this, Factory);
        this.dataFactory = dataFactory || new $2ej16.DataFactory();
        this.stringType = this.createTerm('http://www.w3.org/2001/XMLSchema#string');
    }
    (0, $byiyg._)(Factory, [
        {
            key: "createAlt",
            value: function createAlt(input) {
                var flatten = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.flattenMulti({
                    type: $25194fb5206c1664$var$A.types.ALT,
                    input: input
                }, flatten);
            }
        },
        {
            key: "createAsk",
            value: function createAsk(input) {
                return {
                    type: $25194fb5206c1664$var$A.types.ASK,
                    input: input
                };
            }
        },
        {
            key: "createBoundAggregate",
            value: function createBoundAggregate(variable, aggregate, expression, distinct, separator) {
                var result = this.createAggregateExpression(aggregate, expression, distinct, separator);
                result.variable = variable;
                return result;
            }
        },
        {
            key: "createBgp",
            value: function createBgp(patterns) {
                return {
                    type: $25194fb5206c1664$var$A.types.BGP,
                    patterns: patterns
                };
            }
        },
        {
            key: "createConstruct",
            value: function createConstruct(input, template) {
                return {
                    type: $25194fb5206c1664$var$A.types.CONSTRUCT,
                    input: input,
                    template: template
                };
            }
        },
        {
            key: "createDescribe",
            value: function createDescribe(input, terms) {
                return {
                    type: $25194fb5206c1664$var$A.types.DESCRIBE,
                    input: input,
                    terms: terms
                };
            }
        },
        {
            key: "createDistinct",
            value: function createDistinct(input) {
                return {
                    type: $25194fb5206c1664$var$A.types.DISTINCT,
                    input: input
                };
            }
        },
        {
            key: "createExtend",
            value: function createExtend(input, variable, expression) {
                return {
                    type: $25194fb5206c1664$var$A.types.EXTEND,
                    input: input,
                    variable: variable,
                    expression: expression
                };
            }
        },
        {
            key: "createFrom",
            value: function createFrom(input, def, named) {
                return {
                    type: $25194fb5206c1664$var$A.types.FROM,
                    input: input,
                    "default": def,
                    named: named
                };
            }
        },
        {
            key: "createFilter",
            value: function createFilter(input, expression) {
                return {
                    type: $25194fb5206c1664$var$A.types.FILTER,
                    input: input,
                    expression: expression
                };
            }
        },
        {
            key: "createGraph",
            value: function createGraph(input, name) {
                return {
                    type: $25194fb5206c1664$var$A.types.GRAPH,
                    input: input,
                    name: name
                };
            }
        },
        {
            key: "createGroup",
            value: function createGroup(input, variables, aggregates) {
                return {
                    type: $25194fb5206c1664$var$A.types.GROUP,
                    input: input,
                    variables: variables,
                    aggregates: aggregates
                };
            }
        },
        {
            key: "createInv",
            value: function createInv(path) {
                return {
                    type: $25194fb5206c1664$var$A.types.INV,
                    path: path
                };
            }
        },
        {
            key: "createJoin",
            value: function createJoin(input) {
                var flatten = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.flattenMulti({
                    type: $25194fb5206c1664$var$A.types.JOIN,
                    input: input
                }, flatten);
            }
        },
        {
            key: "createLeftJoin",
            value: function createLeftJoin(left, right, expression) {
                if (expression) return {
                    type: $25194fb5206c1664$var$A.types.LEFT_JOIN,
                    input: [
                        left,
                        right
                    ],
                    expression: expression
                };
                return {
                    type: $25194fb5206c1664$var$A.types.LEFT_JOIN,
                    input: [
                        left,
                        right
                    ]
                };
            }
        },
        {
            key: "createLink",
            value: function createLink(iri) {
                return {
                    type: $25194fb5206c1664$var$A.types.LINK,
                    iri: iri
                };
            }
        },
        {
            key: "createMinus",
            value: function createMinus(left, right) {
                return {
                    type: $25194fb5206c1664$var$A.types.MINUS,
                    input: [
                        left,
                        right
                    ]
                };
            }
        },
        {
            key: "createNop",
            value: function createNop() {
                return {
                    type: $25194fb5206c1664$var$A.types.NOP
                };
            }
        },
        {
            key: "createNps",
            value: function createNps(iris) {
                return {
                    type: $25194fb5206c1664$var$A.types.NPS,
                    iris: iris
                };
            }
        },
        {
            key: "createOneOrMorePath",
            value: function createOneOrMorePath(path) {
                return {
                    type: $25194fb5206c1664$var$A.types.ONE_OR_MORE_PATH,
                    path: path
                };
            }
        },
        {
            key: "createOrderBy",
            value: function createOrderBy(input, expressions) {
                return {
                    type: $25194fb5206c1664$var$A.types.ORDER_BY,
                    input: input,
                    expressions: expressions
                };
            }
        },
        {
            key: "createPath",
            value: function createPath(subject, predicate, object, graph) {
                if (graph) return {
                    type: $25194fb5206c1664$var$A.types.PATH,
                    subject: subject,
                    predicate: predicate,
                    object: object,
                    graph: graph
                };
                return {
                    type: $25194fb5206c1664$var$A.types.PATH,
                    subject: subject,
                    predicate: predicate,
                    object: object,
                    graph: this.dataFactory.defaultGraph()
                };
            }
        },
        {
            key: "createPattern",
            value: function createPattern(subject, predicate, object, graph) {
                var pattern = this.dataFactory.quad(subject, predicate, object, graph);
                pattern.type = $25194fb5206c1664$var$A.types.PATTERN;
                return pattern;
            }
        },
        {
            key: "createProject",
            value: function createProject(input, variables) {
                return {
                    type: $25194fb5206c1664$var$A.types.PROJECT,
                    input: input,
                    variables: variables
                };
            }
        },
        {
            key: "createReduced",
            value: function createReduced(input) {
                return {
                    type: $25194fb5206c1664$var$A.types.REDUCED,
                    input: input
                };
            }
        },
        {
            key: "createSeq",
            value: function createSeq(input) {
                var flatten = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.flattenMulti({
                    type: $25194fb5206c1664$var$A.types.SEQ,
                    input: input
                }, flatten);
            }
        },
        {
            key: "createService",
            value: function createService(input, name, silent) {
                return {
                    type: $25194fb5206c1664$var$A.types.SERVICE,
                    input: input,
                    name: name,
                    silent: Boolean(silent)
                };
            }
        },
        {
            key: "createSlice",
            value: function createSlice(input, start, length) {
                start = start || 0;
                if (length !== undefined) return {
                    type: $25194fb5206c1664$var$A.types.SLICE,
                    input: input,
                    start: start,
                    length: length
                };
                return {
                    type: $25194fb5206c1664$var$A.types.SLICE,
                    input: input,
                    start: start
                };
            }
        },
        {
            key: "createUnion",
            value: function createUnion(input) {
                var flatten = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.flattenMulti({
                    type: $25194fb5206c1664$var$A.types.UNION,
                    input: input
                }, flatten);
            }
        },
        {
            key: "createValues",
            value: function createValues(variables, bindings) {
                return {
                    type: $25194fb5206c1664$var$A.types.VALUES,
                    variables: variables,
                    bindings: bindings
                };
            }
        },
        {
            key: "createZeroOrMorePath",
            value: function createZeroOrMorePath(path) {
                return {
                    type: $25194fb5206c1664$var$A.types.ZERO_OR_MORE_PATH,
                    path: path
                };
            }
        },
        {
            key: "createZeroOrOnePath",
            value: function createZeroOrOnePath(path) {
                return {
                    type: $25194fb5206c1664$var$A.types.ZERO_OR_ONE_PATH,
                    path: path
                };
            }
        },
        {
            key: "createAggregateExpression",
            value: function createAggregateExpression(aggregator, expression, distinct, separator) {
                if (separator) return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.AGGREGATE,
                    aggregator: aggregator,
                    expression: expression,
                    separator: separator,
                    distinct: distinct
                };
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.AGGREGATE,
                    aggregator: aggregator,
                    expression: expression,
                    distinct: distinct
                };
            }
        },
        {
            key: "createExistenceExpression",
            value: function createExistenceExpression(not, input) {
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.EXISTENCE,
                    not: not,
                    input: input
                };
            }
        },
        {
            key: "createNamedExpression",
            value: function createNamedExpression(name, args) {
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.NAMED,
                    name: name,
                    args: args
                };
            }
        },
        {
            key: "createOperatorExpression",
            value: function createOperatorExpression(operator, args) {
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.OPERATOR,
                    operator: operator,
                    args: args
                };
            }
        },
        {
            key: "createTermExpression",
            value: function createTermExpression(term) {
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.TERM,
                    term: term
                };
            }
        },
        {
            key: "createWildcardExpression",
            value: function createWildcardExpression() {
                return {
                    type: $25194fb5206c1664$var$A.types.EXPRESSION,
                    expressionType: $25194fb5206c1664$var$A.expressionTypes.WILDCARD,
                    wildcard: new $2h2ox.Wildcard()
                };
            }
        },
        {
            key: "createTerm",
            value: function createTerm(str) {
                if (str[0] === '$') str = str.replace('$', '?');
                return (0, $gQYIc.stringToTerm)(str, this.dataFactory);
            }
        },
        {
            // Update functions
            key: "createCompositeUpdate",
            value: function createCompositeUpdate(updates) {
                return {
                    type: $25194fb5206c1664$var$A.types.COMPOSITE_UPDATE,
                    updates: updates
                };
            }
        },
        {
            key: "createDeleteInsert",
            value: function createDeleteInsert(deleteQuads, insertQuads, where) {
                var result = {
                    type: $25194fb5206c1664$var$A.types.DELETE_INSERT
                };
                if (deleteQuads) result["delete"] = deleteQuads;
                if (insertQuads) result.insert = insertQuads;
                if (where) result.where = where;
                return result;
            }
        },
        {
            key: "createLoad",
            value: function createLoad(source, destination, silent) {
                var result = {
                    type: $25194fb5206c1664$var$A.types.LOAD,
                    source: source
                };
                if (destination) result.destination = destination;
                return this.addSilent(result, Boolean(silent));
            }
        },
        {
            key: "createClear",
            value: function createClear(source, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.CLEAR,
                    source: source
                }, Boolean(silent));
            }
        },
        {
            key: "createCreate",
            value: function createCreate(source, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.CREATE,
                    source: source
                }, Boolean(silent));
            }
        },
        {
            key: "createDrop",
            value: function createDrop(source, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.DROP,
                    source: source
                }, Boolean(silent));
            }
        },
        {
            key: "createAdd",
            value: function createAdd(source, destination, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.ADD,
                    source: source,
                    destination: destination
                }, Boolean(silent));
            }
        },
        {
            key: "createMove",
            value: function createMove(source, destination, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.MOVE,
                    source: source,
                    destination: destination
                }, Boolean(silent));
            }
        },
        {
            key: "createCopy",
            value: function createCopy(source, destination, silent) {
                return this.addSilent({
                    type: $25194fb5206c1664$var$A.types.COPY,
                    source: source,
                    destination: destination
                }, Boolean(silent));
            }
        },
        {
            key: "addSilent",
            value: function addSilent(input, silent) {
                if (silent) input.silent = silent;
                return input;
            }
        },
        {
            key: "flattenMulti",
            value: function flattenMulti(input, flatten) {
                var _newChildren;
                if (!flatten) return input;
                var type = input.type;
                var children = input.input;
                var newChildren = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        if (child.type === type) (_newChildren = newChildren).push.apply(_newChildren, (0, $7WNf6._)(child.input));
                        else newChildren.push(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                input.input = newChildren;
                return input;
            }
        }
    ]);
    return Factory;
}();
module.exports["default"] = $25194fb5206c1664$var$Factory;

});
parcelRegister("2h2ox", function(module, exports) {

var $7kxeZ = parcelRequire("7kxeZ");
var $1a7f06e1802a80bc$require$Parser = $7kxeZ.Parser;

var $XAnrW = parcelRequire("XAnrW");
var $1a7f06e1802a80bc$require$Generator = $XAnrW.Generator;

var $4E6EG = parcelRequire("4E6EG");
var $1a7f06e1802a80bc$require$Wildcard = $4E6EG.Wildcard;

var $2ej16 = parcelRequire("2ej16");
var $1a7f06e1802a80bc$require$DataFactory = $2ej16.DataFactory;
/**
 * Creates a SPARQL parser with the given pre-defined prefixes and base IRI
 * @param options {
 *   prefixes?: { [prefix: string]: string },
 *   baseIRI?: string,
 *   factory?: import('rdf-js').DataFactory,
 *   sparqlStar?: boolean,
 *   skipValidation?: boolean,
 *   skipUngroupedVariableCheck?: boolean
 * }
 */ function $1a7f06e1802a80bc$var$_Parser() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, prefixes = _ref.prefixes, baseIRI = _ref.baseIRI, factory = _ref.factory, pathOnly = _ref.pathOnly, sparqlStar = _ref.sparqlStar, skipValidation = _ref.skipValidation, skipUngroupedVariableCheck = _ref.skipUngroupedVariableCheck;
    // Create a copy of the prefixes
    var prefixesCopy = {};
    for(var prefix in prefixes !== null && prefixes !== void 0 ? prefixes : {})prefixesCopy[prefix] = prefixes[prefix];
    // Create a new parser with the given prefixes
    // (Workaround for https://github.com/zaach/jison/issues/241)
    var parser = new $1a7f06e1802a80bc$require$Parser();
    parser.parse = function() {
        $1a7f06e1802a80bc$require$Parser.base = baseIRI || '';
        $1a7f06e1802a80bc$require$Parser.prefixes = Object.create(prefixesCopy);
        $1a7f06e1802a80bc$require$Parser.factory = factory || new $1a7f06e1802a80bc$require$DataFactory();
        $1a7f06e1802a80bc$require$Parser.sparqlStar = Boolean(sparqlStar);
        $1a7f06e1802a80bc$require$Parser.pathOnly = Boolean(pathOnly);
        // We keep skipUngroupedVariableCheck for compatibility reasons.
        $1a7f06e1802a80bc$require$Parser.skipValidation = Boolean(skipValidation) || Boolean(skipUngroupedVariableCheck);
        return $1a7f06e1802a80bc$require$Parser.prototype.parse.apply(parser, arguments);
    };
    parser._resetBlanks = $1a7f06e1802a80bc$require$Parser._resetBlanks;
    return parser;
}
module.exports = {
    Parser: $1a7f06e1802a80bc$var$_Parser,
    Generator: $1a7f06e1802a80bc$require$Generator,
    Wildcard: $1a7f06e1802a80bc$require$Wildcard
};

});
parcelRegister("7kxeZ", function(module, exports) {
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ 
var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $55642f91fd8759e1$var$SparqlParser = function() {
    var o = function o(k, v, _o, l) {
        for(_o = _o || {}, l = k.length; l--; _o[k[l]] = v);
        return _o;
    }, $V0 = [
        6,
        12,
        13,
        15,
        16,
        24,
        32,
        36,
        41,
        45,
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        197,
        224,
        229,
        308,
        329,
        330,
        331,
        332,
        333
    ], $V1 = [
        2,
        247
    ], $V2 = [
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        329,
        330,
        331,
        332,
        333
    ], $V3 = [
        2,
        409
    ], $V4 = [
        1,
        18
    ], $V5 = [
        1,
        27
    ], $V6 = [
        13,
        16,
        45,
        197,
        224,
        229,
        308
    ], $V7 = [
        28,
        29,
        53
    ], $V8 = [
        28,
        53
    ], $V9 = [
        1,
        42
    ], $Va = [
        1,
        45
    ], $Vb = [
        1,
        41
    ], $Vc = [
        1,
        44
    ], $Vd = [
        123,
        126
    ], $Ve = [
        1,
        67
    ], $Vf = [
        39,
        45,
        87
    ], $Vg = [
        13,
        16,
        45,
        197,
        224,
        308
    ], $Vh = [
        1,
        87
    ], $Vi = [
        2,
        281
    ], $Vj = [
        1,
        86
    ], $Vk = [
        13,
        16,
        45,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vl = [
        6,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm = [
        6,
        13,
        16,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85,
        87,
        308
    ], $Vn = [
        6,
        13,
        16,
        28,
        29,
        45,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        197,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314
    ], $Vo = [
        6,
        13,
        16,
        28,
        29,
        31,
        39,
        45,
        47,
        48,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        109,
        112,
        121,
        123,
        126,
        128,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        337,
        338,
        340,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vp = [
        13,
        16,
        308
    ], $Vq = [
        112,
        132,
        327,
        334
    ], $Vr = [
        13,
        16,
        112,
        132,
        308
    ], $Vs = [
        1,
        111
    ], $Vt = [
        1,
        117
    ], $Vu = [
        112,
        132,
        327,
        328,
        334
    ], $Vv = [
        13,
        16,
        112,
        132,
        308,
        328
    ], $Vw = [
        28,
        29,
        45,
        53,
        87
    ], $Vx = [
        1,
        138
    ], $Vy = [
        1,
        151
    ], $Vz = [
        1,
        128
    ], $VA = [
        1,
        127
    ], $VB = [
        1,
        129
    ], $VC = [
        1,
        140
    ], $VD = [
        1,
        141
    ], $VE = [
        1,
        142
    ], $VF = [
        1,
        143
    ], $VG = [
        1,
        144
    ], $VH = [
        1,
        145
    ], $VI = [
        1,
        147
    ], $VJ = [
        1,
        148
    ], $VK = [
        2,
        457
    ], $VL = [
        1,
        158
    ], $VM = [
        1,
        159
    ], $VN = [
        1,
        160
    ], $VO = [
        1,
        152
    ], $VP = [
        1,
        153
    ], $VQ = [
        1,
        156
    ], $VR = [
        1,
        171
    ], $VS = [
        1,
        172
    ], $VT = [
        1,
        173
    ], $VU = [
        1,
        174
    ], $VV = [
        1,
        175
    ], $VW = [
        1,
        176
    ], $VX = [
        1,
        167
    ], $VY = [
        1,
        168
    ], $VZ = [
        1,
        169
    ], $V_ = [
        1,
        170
    ], $V$ = [
        1,
        157
    ], $V01 = [
        1,
        166
    ], $V11 = [
        1,
        161
    ], $V21 = [
        1,
        162
    ], $V31 = [
        1,
        163
    ], $V41 = [
        1,
        164
    ], $V51 = [
        1,
        165
    ], $V61 = [
        6,
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $V71 = [
        1,
        195
    ], $V81 = [
        6,
        31,
        73,
        81,
        83,
        85
    ], $V91 = [
        2,
        285
    ], $Va1 = [
        1,
        199
    ], $Vb1 = [
        1,
        201
    ], $Vc1 = [
        6,
        31,
        70,
        73,
        81,
        83,
        85
    ], $Vd1 = [
        2,
        283
    ], $Ve1 = [
        1,
        207
    ], $Vf1 = [
        1,
        218
    ], $Vg1 = [
        1,
        223
    ], $Vh1 = [
        1,
        219
    ], $Vi1 = [
        1,
        225
    ], $Vj1 = [
        1,
        226
    ], $Vk1 = [
        1,
        224
    ], $Vl1 = [
        6,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm1 = [
        1,
        236
    ], $Vn1 = [
        2,
        334
    ], $Vo1 = [
        1,
        243
    ], $Vp1 = [
        1,
        241
    ], $Vq1 = [
        6,
        193
    ], $Vr1 = [
        2,
        349
    ], $Vs1 = [
        2,
        339
    ], $Vt1 = [
        28,
        128
    ], $Vu1 = [
        47,
        48,
        193,
        272
    ], $Vv1 = [
        47,
        48,
        193,
        242,
        272
    ], $Vw1 = [
        47,
        48,
        193,
        242,
        246,
        272
    ], $Vx1 = [
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vy1 = [
        39,
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vz1 = [
        1,
        271
    ], $VA1 = [
        1,
        270
    ], $VB1 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VC1 = [
        1,
        281
    ], $VD1 = [
        1,
        280
    ], $VE1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VF1 = [
        45,
        89
    ], $VG1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VH1 = [
        13,
        16,
        31,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $VI1 = [
        31,
        89
    ], $VJ1 = [
        48,
        87
    ], $VK1 = [
        6,
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338
    ], $VL1 = [
        6,
        13,
        16,
        39,
        45,
        48,
        82,
        87,
        89,
        231,
        263,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338,
        340
    ], $VM1 = [
        1,
        313
    ], $VN1 = [
        6,
        85
    ], $VO1 = [
        6,
        31,
        81,
        83,
        85
    ], $VP1 = [
        2,
        361
    ], $VQ1 = [
        2,
        353
    ], $VR1 = [
        1,
        343
    ], $VS1 = [
        31,
        112,
        335
    ], $VT1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $VU1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335
    ], $VV1 = [
        6,
        109,
        193
    ], $VW1 = [
        31,
        112
    ], $VX1 = [
        13,
        16,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VY1 = [
        1,
        390
    ], $VZ1 = [
        1,
        391
    ], $V_1 = [
        13,
        16,
        87,
        197,
        308,
        314
    ], $V$1 = [
        13,
        16,
        39,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V02 = [
        1,
        417
    ], $V12 = [
        1,
        418
    ], $V22 = [
        13,
        16,
        48,
        197,
        229,
        308
    ], $V32 = [
        6,
        31,
        85
    ], $V42 = [
        6,
        13,
        16,
        31,
        45,
        73,
        81,
        83,
        85,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V52 = [
        6,
        13,
        16,
        29,
        31,
        45,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V62 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164
    ], $V72 = [
        1,
        443
    ], $V82 = [
        1,
        444
    ], $V92 = [
        1,
        449
    ], $Va2 = [
        31,
        112,
        193,
        232,
        318,
        335
    ], $Vb2 = [
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vc2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vd2 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Ve2 = [
        13,
        16,
        31,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vf2 = [
        31,
        45
    ], $Vg2 = [
        1,
        507
    ], $Vh2 = [
        1,
        508
    ], $Vi2 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        63,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        336,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vj2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        335
    ], $Vk2 = [
        6,
        13,
        16,
        31,
        45,
        70,
        73,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vl2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        197,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vm2 = [
        2,
        352
    ], $Vn2 = [
        13,
        16,
        197,
        308,
        314
    ], $Vo2 = [
        1,
        565
    ], $Vp2 = [
        6,
        13,
        16,
        31,
        45,
        76,
        78,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vq2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vr2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $Vs2 = [
        13,
        16,
        87,
        308
    ], $Vt2 = [
        2,
        364
    ], $Vu2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        318,
        335
    ], $Vv2 = [
        31,
        112,
        193,
        232,
        272,
        318,
        335
    ], $Vw2 = [
        2,
        359
    ], $Vx2 = [
        13,
        16,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vy2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        272,
        318,
        335
    ], $Vz2 = [
        13,
        16,
        31,
        45,
        82,
        87,
        89,
        112,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $VA2 = [
        2,
        347
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            error: 2,
            QueryOrUpdate: 3,
            Prologue: 4,
            QueryOrUpdate_group0: 5,
            EOF: 6,
            Query: 7,
            Qry: 8,
            Query_option0: 9,
            Prologue_repetition0: 10,
            BaseDecl: 11,
            BASE: 12,
            IRIREF: 13,
            PrefixDecl: 14,
            PREFIX: 15,
            PNAME_NS: 16,
            SelectClauseWildcard: 17,
            Qry_repetition0: 18,
            WhereClause: 19,
            SolutionModifierNoGroup: 20,
            SelectClauseVars: 21,
            Qry_repetition1: 22,
            SolutionModifier: 23,
            CONSTRUCT: 24,
            ConstructTemplate: 25,
            Qry_repetition2: 26,
            Qry_repetition3: 27,
            WHERE: 28,
            "{": 29,
            Qry_option0: 30,
            "}": 31,
            DESCRIBE: 32,
            Qry_group0: 33,
            Qry_repetition4: 34,
            Qry_option1: 35,
            ASK: 36,
            Qry_repetition5: 37,
            SelectClauseBase: 38,
            "*": 39,
            SelectClauseVars_repetition_plus0: 40,
            SELECT: 41,
            SelectClauseBase_option0: 42,
            SelectClauseItem: 43,
            Var: 44,
            "(": 45,
            Expression: 46,
            AS: 47,
            ")": 48,
            SubSelect: 49,
            SubSelect_option0: 50,
            SubSelect_option1: 51,
            DatasetClause: 52,
            FROM: 53,
            DatasetClause_option0: 54,
            iri: 55,
            WhereClause_option0: 56,
            GroupGraphPattern: 57,
            SolutionModifier_option0: 58,
            SolutionModifierNoGroup_option0: 59,
            SolutionModifierNoGroup_option1: 60,
            SolutionModifierNoGroup_option2: 61,
            GroupClause: 62,
            GROUP: 63,
            BY: 64,
            GroupClause_repetition_plus0: 65,
            GroupCondition: 66,
            BuiltInCall: 67,
            FunctionCall: 68,
            HavingClause: 69,
            HAVING: 70,
            HavingClause_repetition_plus0: 71,
            OrderClause: 72,
            ORDER: 73,
            OrderClause_repetition_plus0: 74,
            OrderCondition: 75,
            ASC: 76,
            BrackettedExpression: 77,
            DESC: 78,
            Constraint: 79,
            LimitOffsetClauses: 80,
            LIMIT: 81,
            INTEGER: 82,
            OFFSET: 83,
            ValuesClause: 84,
            VALUES: 85,
            InlineData: 86,
            VAR: 87,
            InlineData_repetition0: 88,
            NIL: 89,
            InlineData_repetition1: 90,
            InlineData_repetition_plus2: 91,
            InlineData_repetition3: 92,
            DataBlock: 93,
            DataBlockValueList: 94,
            DataBlockValueList_repetition_plus0: 95,
            Update: 96,
            Update_repetition0: 97,
            Update1: 98,
            Update_option0: 99,
            LOAD: 100,
            Update1_option0: 101,
            Update1_option1: 102,
            Update1_group0: 103,
            Update1_option2: 104,
            GraphRefAll: 105,
            Update1_group1: 106,
            Update1_option3: 107,
            GraphOrDefault: 108,
            TO: 109,
            CREATE: 110,
            Update1_option4: 111,
            GRAPH: 112,
            INSERTDATA: 113,
            QuadPattern: 114,
            DELETEDATA: 115,
            DELETEWHERE: 116,
            Update1_option5: 117,
            InsertDeleteClause: 118,
            Update1_repetition0: 119,
            IntoGraphClause: 120,
            INTO: 121,
            GraphRef: 122,
            DELETE: 123,
            InsertDeleteClause_option0: 124,
            InsertClause: 125,
            INSERT: 126,
            UsingClause: 127,
            USING: 128,
            UsingClause_option0: 129,
            WithClause: 130,
            WITH: 131,
            DEFAULT: 132,
            GraphOrDefault_option0: 133,
            GraphRefAll_group0: 134,
            Quads: 135,
            Quads_option0: 136,
            Quads_repetition0: 137,
            QuadsNotTriples: 138,
            VarOrIri: 139,
            QuadsNotTriples_option0: 140,
            QuadsNotTriples_option1: 141,
            QuadsNotTriples_option2: 142,
            TriplesTemplate: 143,
            TriplesTemplate_repetition0: 144,
            TriplesSameSubject: 145,
            TriplesTemplate_option0: 146,
            GroupGraphPatternSub: 147,
            GroupGraphPatternSub_option0: 148,
            GroupGraphPatternSub_repetition0: 149,
            GroupGraphPatternSubTail: 150,
            GraphPatternNotTriples: 151,
            GroupGraphPatternSubTail_option0: 152,
            GroupGraphPatternSubTail_option1: 153,
            TriplesBlock: 154,
            TriplesBlock_repetition0: 155,
            TriplesSameSubjectPath: 156,
            TriplesBlock_option0: 157,
            GroupOrUnionGraphPattern: 158,
            OPTIONAL: 159,
            MINUS: 160,
            SERVICE: 161,
            GraphPatternNotTriples_option0: 162,
            FILTER: 163,
            BIND: 164,
            InlineDataOneVar: 165,
            InlineDataFull: 166,
            InlineDataOneVar_repetition0: 167,
            InlineDataFull_repetition0: 168,
            InlineDataFull_repetition_plus1: 169,
            InlineDataFull_repetition2: 170,
            DataBlockValue: 171,
            Literal: 172,
            QuotedTriple: 173,
            UNDEF: 174,
            GroupOrUnionGraphPattern_repetition0: 175,
            ArgList: 176,
            ArgList_option0: 177,
            ArgList_repetition0: 178,
            ExpressionList: 179,
            ExpressionList_repetition0: 180,
            ConstructTemplate_option0: 181,
            ConstructTriples: 182,
            ConstructTriples_repetition0: 183,
            ConstructTriples_option0: 184,
            VarOrTermOrQuotedTP: 185,
            PropertyListNotEmpty: 186,
            TriplesNode: 187,
            PropertyList: 188,
            PropertyList_option0: 189,
            VerbObjectList: 190,
            PropertyListNotEmpty_repetition0: 191,
            SemiOptionalVerbObjectList: 192,
            ";": 193,
            SemiOptionalVerbObjectList_option0: 194,
            Verb: 195,
            ObjectList: 196,
            a: 197,
            ObjectList_repetition0: 198,
            Object: 199,
            GraphNode: 200,
            Object_option0: 201,
            PropertyListPathNotEmpty: 202,
            TriplesNodePath: 203,
            TriplesSameSubjectPath_option0: 204,
            O: 205,
            PropertyListPathNotEmpty_repetition0: 206,
            PropertyListPathNotEmptyTail: 207,
            O_group0: 208,
            ObjectListPath: 209,
            ObjectListPath_repetition0: 210,
            ObjectPath: 211,
            GraphNodePath: 212,
            ObjectPath_option0: 213,
            Path: 214,
            Path_repetition0: 215,
            PathSequence: 216,
            PathSequence_repetition0: 217,
            PathEltOrInverse: 218,
            PathElt: 219,
            PathPrimary: 220,
            PathElt_option0: 221,
            PathEltOrInverse_option0: 222,
            IriOrA: 223,
            "!": 224,
            PathNegatedPropertySet: 225,
            PathOneInPropertySet: 226,
            PathNegatedPropertySet_repetition0: 227,
            PathNegatedPropertySet_option0: 228,
            "^": 229,
            TriplesNode_repetition_plus0: 230,
            "[": 231,
            "]": 232,
            TriplesNodePath_repetition_plus0: 233,
            VarOrTermOrQuotedTPExpr: 234,
            VarOrTerm: 235,
            GraphTerm: 236,
            BlankNode: 237,
            ConditionalOrExpression: 238,
            ConditionalAndExpression: 239,
            ConditionalOrExpression_repetition0: 240,
            ConditionalOrExpressionTail: 241,
            "||": 242,
            RelationalExpression: 243,
            ConditionalAndExpression_repetition0: 244,
            ConditionalAndExpressionTail: 245,
            "&&": 246,
            NumericExpression: 247,
            RelationalExpression_group0: 248,
            RelationalExpression_option0: 249,
            IN: 250,
            MultiplicativeExpression: 251,
            NumericExpression_repetition0: 252,
            AdditiveExpressionTail: 253,
            AdditiveExpressionTail_group0: 254,
            NumericLiteralPositive: 255,
            AdditiveExpressionTail_repetition0: 256,
            NumericLiteralNegative: 257,
            AdditiveExpressionTail_repetition1: 258,
            UnaryExpression: 259,
            MultiplicativeExpression_repetition0: 260,
            MultiplicativeExpressionTail: 261,
            MultiplicativeExpressionTail_group0: 262,
            "+": 263,
            PrimaryExpression: 264,
            "-": 265,
            ExprQuotedTP: 266,
            Aggregate: 267,
            FUNC_ARITY0: 268,
            FUNC_ARITY1: 269,
            FUNC_ARITY1_SPARQL_STAR: 270,
            FUNC_ARITY2: 271,
            ",": 272,
            FUNC_ARITY3: 273,
            FUNC_ARITY3_SPARQL_STAR: 274,
            BuiltInCall_group0: 275,
            BOUND: 276,
            BNODE: 277,
            BuiltInCall_option0: 278,
            EXISTS: 279,
            COUNT: 280,
            Aggregate_option0: 281,
            Aggregate_group0: 282,
            FUNC_AGGREGATE: 283,
            Aggregate_option1: 284,
            GROUP_CONCAT: 285,
            Aggregate_option2: 286,
            Aggregate_option3: 287,
            GroupConcatSeparator: 288,
            SEPARATOR: 289,
            "=": 290,
            String: 291,
            LANGTAG: 292,
            "^^": 293,
            DECIMAL: 294,
            DOUBLE: 295,
            BOOLEAN: 296,
            INTEGER_POSITIVE: 297,
            DECIMAL_POSITIVE: 298,
            DOUBLE_POSITIVE: 299,
            INTEGER_NEGATIVE: 300,
            DECIMAL_NEGATIVE: 301,
            DOUBLE_NEGATIVE: 302,
            STRING_LITERAL1: 303,
            STRING_LITERAL2: 304,
            STRING_LITERAL_LONG1: 305,
            STRING_LITERAL_LONG2: 306,
            PrefixedName: 307,
            PNAME_LN: 308,
            BLANK_NODE_LABEL: 309,
            ANON: 310,
            QuotedTP: 311,
            "<<": 312,
            qtSubjectOrObject: 313,
            ">>": 314,
            DataValueTerm: 315,
            AnnotationPattern: 316,
            "{|": 317,
            "|}": 318,
            AnnotationPatternPath: 319,
            ExprVarOrTerm: 320,
            QueryOrUpdate_group0_option0: 321,
            Prologue_repetition0_group0: 322,
            Qry_group0_repetition_plus0: 323,
            SelectClauseBase_option0_group0: 324,
            DISTINCT: 325,
            REDUCED: 326,
            NAMED: 327,
            SILENT: 328,
            CLEAR: 329,
            DROP: 330,
            ADD: 331,
            MOVE: 332,
            COPY: 333,
            ALL: 334,
            ".": 335,
            UNION: 336,
            "|": 337,
            "/": 338,
            PathElt_option0_group0: 339,
            "?": 340,
            "!=": 341,
            "<": 342,
            ">": 343,
            "<=": 344,
            ">=": 345,
            NOT: 346,
            CONCAT: 347,
            COALESCE: 348,
            SUBSTR: 349,
            REGEX: 350,
            REPLACE: 351,
            $accept: 0,
            $end: 1
        },
        terminals_: {
            2: "error",
            6: "EOF",
            12: "BASE",
            13: "IRIREF",
            15: "PREFIX",
            16: "PNAME_NS",
            24: "CONSTRUCT",
            28: "WHERE",
            29: "{",
            31: "}",
            32: "DESCRIBE",
            36: "ASK",
            39: "*",
            41: "SELECT",
            45: "(",
            47: "AS",
            48: ")",
            53: "FROM",
            63: "GROUP",
            64: "BY",
            70: "HAVING",
            73: "ORDER",
            76: "ASC",
            78: "DESC",
            81: "LIMIT",
            82: "INTEGER",
            83: "OFFSET",
            85: "VALUES",
            87: "VAR",
            89: "NIL",
            100: "LOAD",
            109: "TO",
            110: "CREATE",
            112: "GRAPH",
            113: "INSERTDATA",
            115: "DELETEDATA",
            116: "DELETEWHERE",
            121: "INTO",
            123: "DELETE",
            126: "INSERT",
            128: "USING",
            131: "WITH",
            132: "DEFAULT",
            159: "OPTIONAL",
            160: "MINUS",
            161: "SERVICE",
            163: "FILTER",
            164: "BIND",
            174: "UNDEF",
            193: ";",
            197: "a",
            224: "!",
            229: "^",
            231: "[",
            232: "]",
            242: "||",
            246: "&&",
            250: "IN",
            263: "+",
            265: "-",
            268: "FUNC_ARITY0",
            269: "FUNC_ARITY1",
            270: "FUNC_ARITY1_SPARQL_STAR",
            271: "FUNC_ARITY2",
            272: ",",
            273: "FUNC_ARITY3",
            274: "FUNC_ARITY3_SPARQL_STAR",
            276: "BOUND",
            277: "BNODE",
            279: "EXISTS",
            280: "COUNT",
            283: "FUNC_AGGREGATE",
            285: "GROUP_CONCAT",
            289: "SEPARATOR",
            290: "=",
            292: "LANGTAG",
            293: "^^",
            294: "DECIMAL",
            295: "DOUBLE",
            296: "BOOLEAN",
            297: "INTEGER_POSITIVE",
            298: "DECIMAL_POSITIVE",
            299: "DOUBLE_POSITIVE",
            300: "INTEGER_NEGATIVE",
            301: "DECIMAL_NEGATIVE",
            302: "DOUBLE_NEGATIVE",
            303: "STRING_LITERAL1",
            304: "STRING_LITERAL2",
            305: "STRING_LITERAL_LONG1",
            306: "STRING_LITERAL_LONG2",
            308: "PNAME_LN",
            309: "BLANK_NODE_LABEL",
            310: "ANON",
            312: "<<",
            314: ">>",
            317: "{|",
            318: "|}",
            325: "DISTINCT",
            326: "REDUCED",
            327: "NAMED",
            328: "SILENT",
            329: "CLEAR",
            330: "DROP",
            331: "ADD",
            332: "MOVE",
            333: "COPY",
            334: "ALL",
            335: ".",
            336: "UNION",
            337: "|",
            338: "/",
            340: "?",
            341: "!=",
            342: "<",
            343: ">",
            344: "<=",
            345: ">=",
            346: "NOT",
            347: "CONCAT",
            348: "COALESCE",
            349: "SUBSTR",
            350: "REGEX",
            351: "REPLACE"
        },
        productions_: [
            0,
            [
                3,
                3
            ],
            [
                7,
                2
            ],
            [
                4,
                1
            ],
            [
                11,
                2
            ],
            [
                14,
                3
            ],
            [
                8,
                4
            ],
            [
                8,
                4
            ],
            [
                8,
                5
            ],
            [
                8,
                7
            ],
            [
                8,
                5
            ],
            [
                8,
                4
            ],
            [
                17,
                2
            ],
            [
                21,
                2
            ],
            [
                38,
                2
            ],
            [
                43,
                1
            ],
            [
                43,
                5
            ],
            [
                49,
                4
            ],
            [
                49,
                4
            ],
            [
                52,
                3
            ],
            [
                19,
                2
            ],
            [
                23,
                2
            ],
            [
                20,
                3
            ],
            [
                62,
                3
            ],
            [
                66,
                1
            ],
            [
                66,
                1
            ],
            [
                66,
                3
            ],
            [
                66,
                5
            ],
            [
                66,
                1
            ],
            [
                69,
                2
            ],
            [
                72,
                3
            ],
            [
                75,
                2
            ],
            [
                75,
                2
            ],
            [
                75,
                1
            ],
            [
                75,
                1
            ],
            [
                80,
                2
            ],
            [
                80,
                2
            ],
            [
                80,
                4
            ],
            [
                80,
                4
            ],
            [
                84,
                2
            ],
            [
                86,
                4
            ],
            [
                86,
                4
            ],
            [
                86,
                6
            ],
            [
                86,
                2
            ],
            [
                94,
                3
            ],
            [
                96,
                3
            ],
            [
                98,
                4
            ],
            [
                98,
                3
            ],
            [
                98,
                5
            ],
            [
                98,
                4
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                5
            ],
            [
                120,
                2
            ],
            [
                118,
                3
            ],
            [
                118,
                1
            ],
            [
                125,
                2
            ],
            [
                127,
                3
            ],
            [
                130,
                2
            ],
            [
                108,
                1
            ],
            [
                108,
                2
            ],
            [
                122,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                1
            ],
            [
                114,
                3
            ],
            [
                135,
                2
            ],
            [
                138,
                7
            ],
            [
                143,
                3
            ],
            [
                57,
                3
            ],
            [
                57,
                3
            ],
            [
                147,
                2
            ],
            [
                150,
                3
            ],
            [
                154,
                3
            ],
            [
                151,
                1
            ],
            [
                151,
                2
            ],
            [
                151,
                2
            ],
            [
                151,
                3
            ],
            [
                151,
                4
            ],
            [
                151,
                2
            ],
            [
                151,
                6
            ],
            [
                151,
                1
            ],
            [
                93,
                1
            ],
            [
                93,
                1
            ],
            [
                165,
                4
            ],
            [
                166,
                4
            ],
            [
                166,
                6
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                158,
                2
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                68,
                2
            ],
            [
                176,
                1
            ],
            [
                176,
                5
            ],
            [
                179,
                1
            ],
            [
                179,
                4
            ],
            [
                25,
                3
            ],
            [
                182,
                3
            ],
            [
                145,
                2
            ],
            [
                145,
                2
            ],
            [
                188,
                1
            ],
            [
                186,
                2
            ],
            [
                192,
                2
            ],
            [
                190,
                2
            ],
            [
                195,
                1
            ],
            [
                195,
                1
            ],
            [
                196,
                2
            ],
            [
                199,
                2
            ],
            [
                156,
                2
            ],
            [
                156,
                2
            ],
            [
                202,
                2
            ],
            [
                207,
                1
            ],
            [
                207,
                2
            ],
            [
                205,
                2
            ],
            [
                209,
                2
            ],
            [
                211,
                2
            ],
            [
                214,
                2
            ],
            [
                216,
                2
            ],
            [
                219,
                2
            ],
            [
                218,
                2
            ],
            [
                220,
                1
            ],
            [
                220,
                2
            ],
            [
                220,
                3
            ],
            [
                225,
                1
            ],
            [
                225,
                1
            ],
            [
                225,
                4
            ],
            [
                226,
                1
            ],
            [
                226,
                2
            ],
            [
                187,
                3
            ],
            [
                187,
                3
            ],
            [
                203,
                3
            ],
            [
                203,
                3
            ],
            [
                200,
                1
            ],
            [
                200,
                1
            ],
            [
                212,
                1
            ],
            [
                212,
                1
            ],
            [
                234,
                1
            ],
            [
                235,
                1
            ],
            [
                235,
                1
            ],
            [
                139,
                1
            ],
            [
                139,
                1
            ],
            [
                44,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                46,
                1
            ],
            [
                238,
                2
            ],
            [
                241,
                2
            ],
            [
                239,
                2
            ],
            [
                245,
                2
            ],
            [
                243,
                1
            ],
            [
                243,
                3
            ],
            [
                243,
                4
            ],
            [
                247,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                251,
                2
            ],
            [
                261,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                77,
                3
            ],
            [
                67,
                1
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                4
            ],
            [
                67,
                6
            ],
            [
                67,
                8
            ],
            [
                67,
                8
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                3
            ],
            [
                267,
                5
            ],
            [
                267,
                5
            ],
            [
                267,
                6
            ],
            [
                288,
                4
            ],
            [
                172,
                1
            ],
            [
                172,
                2
            ],
            [
                172,
                3
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                55,
                1
            ],
            [
                55,
                1
            ],
            [
                307,
                1
            ],
            [
                307,
                1
            ],
            [
                237,
                1
            ],
            [
                237,
                1
            ],
            [
                311,
                5
            ],
            [
                173,
                5
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                316,
                3
            ],
            [
                319,
                3
            ],
            [
                266,
                5
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                223,
                1
            ],
            [
                223,
                1
            ],
            [
                321,
                0
            ],
            [
                321,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                9,
                0
            ],
            [
                9,
                1
            ],
            [
                322,
                1
            ],
            [
                322,
                1
            ],
            [
                10,
                0
            ],
            [
                10,
                2
            ],
            [
                18,
                0
            ],
            [
                18,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                2
            ],
            [
                26,
                0
            ],
            [
                26,
                2
            ],
            [
                27,
                0
            ],
            [
                27,
                2
            ],
            [
                30,
                0
            ],
            [
                30,
                1
            ],
            [
                323,
                1
            ],
            [
                323,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                35,
                0
            ],
            [
                35,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                2
            ],
            [
                40,
                1
            ],
            [
                40,
                2
            ],
            [
                324,
                1
            ],
            [
                324,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                51,
                0
            ],
            [
                51,
                1
            ],
            [
                54,
                0
            ],
            [
                54,
                1
            ],
            [
                56,
                0
            ],
            [
                56,
                1
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                59,
                0
            ],
            [
                59,
                1
            ],
            [
                60,
                0
            ],
            [
                60,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                1
            ],
            [
                65,
                1
            ],
            [
                65,
                2
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                2
            ],
            [
                88,
                0
            ],
            [
                88,
                2
            ],
            [
                90,
                0
            ],
            [
                90,
                2
            ],
            [
                91,
                1
            ],
            [
                91,
                2
            ],
            [
                92,
                0
            ],
            [
                92,
                2
            ],
            [
                95,
                1
            ],
            [
                95,
                2
            ],
            [
                97,
                0
            ],
            [
                97,
                4
            ],
            [
                99,
                0
            ],
            [
                99,
                2
            ],
            [
                101,
                0
            ],
            [
                101,
                1
            ],
            [
                102,
                0
            ],
            [
                102,
                1
            ],
            [
                103,
                1
            ],
            [
                103,
                1
            ],
            [
                104,
                0
            ],
            [
                104,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                107,
                0
            ],
            [
                107,
                1
            ],
            [
                111,
                0
            ],
            [
                111,
                1
            ],
            [
                117,
                0
            ],
            [
                117,
                1
            ],
            [
                119,
                0
            ],
            [
                119,
                2
            ],
            [
                124,
                0
            ],
            [
                124,
                1
            ],
            [
                129,
                0
            ],
            [
                129,
                1
            ],
            [
                133,
                0
            ],
            [
                133,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                136,
                0
            ],
            [
                136,
                1
            ],
            [
                137,
                0
            ],
            [
                137,
                2
            ],
            [
                140,
                0
            ],
            [
                140,
                1
            ],
            [
                141,
                0
            ],
            [
                141,
                1
            ],
            [
                142,
                0
            ],
            [
                142,
                1
            ],
            [
                144,
                0
            ],
            [
                144,
                3
            ],
            [
                146,
                0
            ],
            [
                146,
                1
            ],
            [
                148,
                0
            ],
            [
                148,
                1
            ],
            [
                149,
                0
            ],
            [
                149,
                2
            ],
            [
                152,
                0
            ],
            [
                152,
                1
            ],
            [
                153,
                0
            ],
            [
                153,
                1
            ],
            [
                155,
                0
            ],
            [
                155,
                3
            ],
            [
                157,
                0
            ],
            [
                157,
                1
            ],
            [
                162,
                0
            ],
            [
                162,
                1
            ],
            [
                167,
                0
            ],
            [
                167,
                2
            ],
            [
                168,
                0
            ],
            [
                168,
                2
            ],
            [
                169,
                1
            ],
            [
                169,
                2
            ],
            [
                170,
                0
            ],
            [
                170,
                2
            ],
            [
                175,
                0
            ],
            [
                175,
                3
            ],
            [
                177,
                0
            ],
            [
                177,
                1
            ],
            [
                178,
                0
            ],
            [
                178,
                3
            ],
            [
                180,
                0
            ],
            [
                180,
                3
            ],
            [
                181,
                0
            ],
            [
                181,
                1
            ],
            [
                183,
                0
            ],
            [
                183,
                3
            ],
            [
                184,
                0
            ],
            [
                184,
                1
            ],
            [
                189,
                0
            ],
            [
                189,
                1
            ],
            [
                191,
                0
            ],
            [
                191,
                2
            ],
            [
                194,
                0
            ],
            [
                194,
                1
            ],
            [
                198,
                0
            ],
            [
                198,
                3
            ],
            [
                201,
                0
            ],
            [
                201,
                1
            ],
            [
                204,
                0
            ],
            [
                204,
                1
            ],
            [
                206,
                0
            ],
            [
                206,
                2
            ],
            [
                208,
                1
            ],
            [
                208,
                1
            ],
            [
                210,
                0
            ],
            [
                210,
                3
            ],
            [
                213,
                0
            ],
            [
                213,
                1
            ],
            [
                215,
                0
            ],
            [
                215,
                3
            ],
            [
                217,
                0
            ],
            [
                217,
                3
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                221,
                0
            ],
            [
                221,
                1
            ],
            [
                222,
                0
            ],
            [
                222,
                1
            ],
            [
                227,
                0
            ],
            [
                227,
                3
            ],
            [
                228,
                0
            ],
            [
                228,
                1
            ],
            [
                230,
                1
            ],
            [
                230,
                2
            ],
            [
                233,
                1
            ],
            [
                233,
                2
            ],
            [
                240,
                0
            ],
            [
                240,
                2
            ],
            [
                244,
                0
            ],
            [
                244,
                2
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                249,
                0
            ],
            [
                249,
                1
            ],
            [
                252,
                0
            ],
            [
                252,
                2
            ],
            [
                254,
                1
            ],
            [
                254,
                1
            ],
            [
                256,
                0
            ],
            [
                256,
                2
            ],
            [
                258,
                0
            ],
            [
                258,
                2
            ],
            [
                260,
                0
            ],
            [
                260,
                2
            ],
            [
                262,
                1
            ],
            [
                262,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                278,
                0
            ],
            [
                278,
                1
            ],
            [
                281,
                0
            ],
            [
                281,
                1
            ],
            [
                282,
                1
            ],
            [
                282,
                1
            ],
            [
                284,
                0
            ],
            [
                284,
                1
            ],
            [
                286,
                0
            ],
            [
                286,
                1
            ],
            [
                287,
                0
            ],
            [
                287,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    // Set parser options
                    $$[$0 - 1] = $$[$0 - 1] || {};
                    if (Parser.base) $$[$0 - 1].base = Parser.base;
                    Parser.base = '';
                    $$[$0 - 1].prefixes = Parser.prefixes;
                    Parser.prefixes = null;
                    if (Parser.pathOnly) {
                        if ($$[$0 - 1].type === 'path' || 'termType' in $$[$0 - 1]) return $$[$0 - 1];
                        throw new Error('Received full SPARQL query in path only mode');
                    } else if ($$[$0 - 1].type === 'path' || 'termType' in $$[$0 - 1]) throw new Error('Received only path in full SPARQL mode');
                    // Ensure that blank nodes are not used across INSERT DATA clauses
                    if ($$[$0 - 1].type === 'update') {
                        var insertBnodesAll = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = $$[$0 - 1].updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var update = _step.value;
                                if (update.updateType === 'insert') {
                                    // Collect bnodes for current insert clause
                                    var insertBnodes = {};
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = update.insert[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$operation = _step1.value;
                                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                            if (_$operation.type === 'bgp' || _$operation.type === 'graph') try {
                                                for(var _iterator2 = _$operation.triples[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                    var triple1 = _step2.value;
                                                    if (triple1.subject.termType === 'BlankNode') insertBnodes[triple1.subject.value] = true;
                                                    if (triple1.predicate.termType === 'BlankNode') insertBnodes[triple1.predicate.value] = true;
                                                    if (triple1.object.termType === 'BlankNode') insertBnodes[triple1.object.value] = true;
                                                }
                                            } catch (err) {
                                                _didIteratorError2 = true;
                                                _iteratorError2 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                        _iterator2["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError2) {
                                                        throw _iteratorError2;
                                                    }
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                                _iterator1["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        // Check if the inserting bnodes don't clash with bnodes from a previous insert clause
                                        for(var _iterator3 = Object.keys(insertBnodes)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var bnode = _step3.value;
                                            if (insertBnodesAll[bnode]) throw new Error('Detected reuse blank node across different INSERT DATA clauses');
                                            insertBnodesAll[bnode] = true;
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                                _iterator3["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    return $$[$0 - 1];
                case 2:
                    this.$ = (0, $emQHU._)((0, $iT0je._)({}, $$[$0 - 1], $$[$0]), {
                        type: 'query'
                    });
                    break;
                case 4:
                    Parser.base = resolveIRI($$[$0]);
                    break;
                case 5:
                    if (!Parser.prefixes) Parser.prefixes = {};
                    $$[$0 - 1] = $$[$0 - 1].substr(0, $$[$0 - 1].length - 1);
                    $$[$0] = resolveIRI($$[$0]);
                    Parser.prefixes[$$[$0 - 1]] = $$[$0];
                    break;
                case 6:
                    this.$ = (0, $iT0je._)({}, $$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 7:
                    // Check for projection of ungrouped variable
                    if (!Parser.skipValidation) {
                        var counts = flatten($$[$0 - 3].variables.map(function(vars) {
                            return getAggregatesOfExpression(vars.expression);
                        })).some(function(agg) {
                            return agg.aggregation === "count" && !(agg.expression instanceof Wildcard);
                        });
                        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        if (counts || $$[$0].group) try {
                            for(var _iterator4 = $$[$0 - 3].variables[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                var selectVar = _step4.value;
                                if (selectVar.termType === "Variable") {
                                    if (!$$[$0].group || !$$[$0].group.map(function(groupVar) {
                                        return getExpressionId(groupVar);
                                    }).includes(getExpressionId(selectVar))) throw Error("Projection of ungrouped variable (?" + getExpressionId(selectVar) + ")");
                                } else if (getAggregatesOfExpression(selectVar.expression).length === 0) {
                                    var usedVars = getVariablesFromExpression(selectVar.expression);
                                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                    try {
                                        for(var _iterator5 = usedVars[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                            var usedVar = _step5.value;
                                            if (!$$[$0].group || !$$[$0].group.map || !$$[$0].group.map(function(groupVar) {
                                                return getExpressionId(groupVar);
                                            }).includes(getExpressionId(usedVar))) throw Error("Use of ungrouped variable in projection of operation (?" + getExpressionId(usedVar) + ")");
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                                _iterator5["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                    _iterator4["return"]();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                    // Check if id of each AS-selected column is not yet bound by subquery
                    var subqueries = $$[$0 - 1].where.filter(function(w) {
                        return w.type === "query";
                    });
                    if (subqueries.length > 0) {
                        var selectedVarIds = $$[$0 - 3].variables.filter(function(v) {
                            return v.variable && v.variable.value;
                        }).map(function(v) {
                            return v.variable.value;
                        });
                        var subqueryIds = flatten(subqueries.map(function(sub) {
                            return sub.variables;
                        })).map(function(v) {
                            return v.value || v.variable.value;
                        });
                        var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                        try {
                            for(var _iterator6 = selectedVarIds[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                var selectedVarId = _step6.value;
                                if (subqueryIds.indexOf(selectedVarId) >= 0) throw Error("Target id of 'AS' (?" + selectedVarId + ") already used in subquery");
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                                    _iterator6["return"]();
                                }
                            } finally{
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    }
                    this.$ = extend($$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 8:
                    this.$ = extend({
                        queryType: 'CONSTRUCT',
                        template: $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 9:
                    this.$ = extend({
                        queryType: 'CONSTRUCT',
                        template: $$[$0 - 2] = $$[$0 - 2] ? $$[$0 - 2].triples : []
                    }, groupDatasets($$[$0 - 5]), {
                        where: [
                            {
                                type: 'bgp',
                                triples: appendAllTo([], $$[$0 - 2])
                            }
                        ]
                    }, $$[$0]);
                    break;
                case 10:
                    this.$ = extend({
                        queryType: 'DESCRIBE',
                        variables: $$[$0 - 3] === '*' ? [
                            new Wildcard()
                        ] : $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 11:
                    this.$ = extend({
                        queryType: 'ASK'
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 12:
                    this.$ = extend($$[$0 - 1], {
                        variables: [
                            new Wildcard()
                        ]
                    });
                    break;
                case 13:
                    // Check if id of each selected column is different
                    var selectedVarIds1 = $$[$0].map(function(v) {
                        return v.value || v.variable.value;
                    });
                    var duplicates = getDuplicatesInArray(selectedVarIds1);
                    if (duplicates.length > 0) throw Error("Two or more of the resulting columns have the same name (?" + duplicates[0] + ")");
                    this.$ = extend($$[$0 - 1], {
                        variables: $$[$0]
                    });
                    break;
                case 14:
                    this.$ = extend({
                        queryType: 'SELECT'
                    }, $$[$0] && ($$[$0 - 1] = lowercase($$[$0]), $$[$0] = {}, $$[$0][$$[$0 - 1]] = true, $$[$0]));
                    break;
                case 16:
                case 27:
                    this.$ = expression($$[$0 - 3], {
                        variable: $$[$0 - 1]
                    });
                    break;
                case 17:
                case 18:
                    this.$ = extend($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], {
                        type: 'query'
                    });
                    break;
                case 19:
                case 58:
                    this.$ = {
                        iri: $$[$0],
                        named: !!$$[$0 - 1]
                    };
                    break;
                case 20:
                    this.$ = {
                        where: $$[$0].patterns
                    };
                    break;
                case 21:
                    this.$ = extend($$[$0 - 1], $$[$0]);
                    break;
                case 22:
                    this.$ = extend($$[$0 - 2], $$[$0 - 1], $$[$0]);
                    break;
                case 23:
                    this.$ = {
                        group: $$[$0]
                    };
                    break;
                case 24:
                case 25:
                case 28:
                case 31:
                case 33:
                case 34:
                    this.$ = expression($$[$0]);
                    break;
                case 26:
                    this.$ = expression($$[$0 - 1]);
                    break;
                case 29:
                    this.$ = {
                        having: $$[$0]
                    };
                    break;
                case 30:
                    this.$ = {
                        order: $$[$0]
                    };
                    break;
                case 32:
                    this.$ = expression($$[$0], {
                        descending: true
                    });
                    break;
                case 35:
                    this.$ = {
                        limit: toInt($$[$0])
                    };
                    break;
                case 36:
                    this.$ = {
                        offset: toInt($$[$0])
                    };
                    break;
                case 37:
                    this.$ = {
                        limit: toInt($$[$0 - 2]),
                        offset: toInt($$[$0])
                    };
                    break;
                case 38:
                    this.$ = {
                        limit: toInt($$[$0]),
                        offset: toInt($$[$0 - 2])
                    };
                    break;
                case 39:
                case 43:
                    this.$ = {
                        type: 'values',
                        values: $$[$0]
                    };
                    break;
                case 40:
                case 84:
                    this.$ = $$[$0 - 1].map(function(v) {
                        return (0, $cqEAj._)({}, $$[$0 - 3], v);
                    });
                    break;
                case 41:
                case 85:
                    this.$ = $$[$0 - 1].map(function() {
                        return {};
                    });
                    break;
                case 42:
                case 86:
                    var length = $$[$0 - 4].length;
                    $$[$0 - 4] = $$[$0 - 4].map(toVar);
                    this.$ = $$[$0 - 1].map(function(values) {
                        if (values.length !== length) throw Error('Inconsistent VALUES length');
                        var valuesObject = {};
                        for(var i = 0; i < length; i++)valuesObject['?' + $$[$0 - 4][i].value] = values[i];
                        return valuesObject;
                    });
                    break;
                case 44:
                case 65:
                case 100:
                case 126:
                case 175:
                    this.$ = $$[$0 - 1];
                    break;
                case 45:
                    this.$ = {
                        type: 'update',
                        updates: appendTo($$[$0 - 2], $$[$0 - 1])
                    };
                    break;
                case 46:
                    this.$ = extend({
                        type: 'load',
                        silent: !!$$[$0 - 2],
                        source: $$[$0 - 1]
                    }, $$[$0] && {
                        destination: $$[$0]
                    });
                    break;
                case 47:
                    this.$ = {
                        type: lowercase($$[$0 - 2]),
                        silent: !!$$[$0 - 1],
                        graph: $$[$0]
                    };
                    break;
                case 48:
                    this.$ = {
                        type: lowercase($$[$0 - 4]),
                        silent: !!$$[$0 - 3],
                        source: $$[$0 - 2],
                        destination: $$[$0]
                    };
                    break;
                case 49:
                    this.$ = {
                        type: 'create',
                        silent: !!$$[$0 - 2],
                        graph: {
                            type: 'graph',
                            name: $$[$0]
                        }
                    };
                    break;
                case 50:
                    this.$ = {
                        updateType: 'insert',
                        insert: ensureNoVariables($$[$0])
                    };
                    break;
                case 51:
                    this.$ = {
                        updateType: 'delete',
                        "delete": ensureNoBnodes(ensureNoVariables($$[$0]))
                    };
                    break;
                case 52:
                    this.$ = {
                        updateType: 'deletewhere',
                        "delete": ensureNoBnodes($$[$0])
                    };
                    break;
                case 53:
                    this.$ = (0, $emQHU._)((0, $iT0je._)({
                        updateType: 'insertdelete'
                    }, $$[$0 - 4], $$[$0 - 3], groupDatasets($$[$0 - 2], 'using')), {
                        where: $$[$0].patterns
                    });
                    break;
                case 54:
                case 57:
                case 62:
                case 167:
                case 191:
                case 236:
                    this.$ = $$[$0];
                    break;
                case 55:
                    this.$ = {
                        "delete": ensureNoBnodes($$[$0 - 1]),
                        insert: $$[$0] || []
                    };
                    break;
                case 56:
                    this.$ = {
                        "delete": [],
                        insert: $$[$0]
                    };
                    break;
                case 59:
                    this.$ = {
                        graph: $$[$0]
                    };
                    break;
                case 60:
                    this.$ = {
                        type: 'graph',
                        "default": true
                    };
                    break;
                case 61:
                case 63:
                    this.$ = {
                        type: 'graph',
                        name: $$[$0]
                    };
                    break;
                case 64:
                    this.$ = (0, $cqEAj._)({}, lowercase($$[$0]), true);
                    break;
                case 66:
                    this.$ = $$[$0 - 1] ? unionAll($$[$0], [
                        $$[$0 - 1]
                    ]) : unionAll($$[$0]);
                    break;
                case 67:
                    var graph = extend($$[$0 - 3] || {
                        triples: []
                    }, {
                        type: 'graph',
                        name: $$[$0 - 5]
                    });
                    this.$ = $$[$0] ? [
                        graph,
                        $$[$0]
                    ] : [
                        graph
                    ];
                    break;
                case 68:
                case 73:
                    this.$ = {
                        type: 'bgp',
                        triples: unionAll($$[$0 - 2], [
                            $$[$0 - 1]
                        ])
                    };
                    break;
                case 69:
                    this.$ = {
                        type: 'group',
                        patterns: [
                            $$[$0 - 1]
                        ]
                    };
                    break;
                case 70:
                    var _iteratorNormalCompletion7 = true, _didIteratorError7 = false, _iteratorError7 = undefined;
                    try {
                        var _loop = function() {
                            var binding = _step7.value;
                            var index = $$[$0 - 1].indexOf(binding);
                            var boundVars = new Set();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                //Collect all bounded variables before the binding
                                for(var _iterator = $$[$0 - 1].slice(0, index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var el = _step.value;
                                    if (el.type === "group" || el.type === "bgp") getBoundVarsFromGroupGraphPattern(el).forEach(function(boundVar) {
                                        return boundVars.add(boundVar);
                                    });
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            // If binding with a non-free variable, throw error
                            if (boundVars.has(binding.variable.value)) throw Error("Variable used to bind is already bound (?" + binding.variable.value + ")");
                        };
                        // For every binding
                        for(var _iterator7 = $$[$0 - 1].filter(function(el) {
                            return el.type === "bind";
                        })[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true)_loop();
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                                _iterator7["return"]();
                            }
                        } finally{
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                    this.$ = {
                        type: 'group',
                        patterns: $$[$0 - 1]
                    };
                    break;
                case 71:
                    this.$ = $$[$0 - 1] ? unionAll([
                        $$[$0 - 1]
                    ], $$[$0]) : unionAll($$[$0]);
                    break;
                case 72:
                    this.$ = $$[$0] ? [
                        $$[$0 - 2],
                        $$[$0]
                    ] : $$[$0 - 2];
                    break;
                case 75:
                    this.$ = extend($$[$0], {
                        type: 'optional'
                    });
                    break;
                case 76:
                    this.$ = extend($$[$0], {
                        type: 'minus'
                    });
                    break;
                case 77:
                    this.$ = extend($$[$0], {
                        type: 'graph',
                        name: $$[$0 - 1]
                    });
                    break;
                case 78:
                    this.$ = extend($$[$0], {
                        type: 'service',
                        name: $$[$0 - 1],
                        silent: !!$$[$0 - 2]
                    });
                    break;
                case 79:
                    this.$ = {
                        type: 'filter',
                        expression: $$[$0]
                    };
                    break;
                case 80:
                    this.$ = {
                        type: 'bind',
                        variable: $$[$0 - 1],
                        expression: $$[$0 - 3]
                    };
                    break;
                case 89:
                    this.$ = ensureSparqlStar($$[$0]);
                    break;
                case 90:
                    this.$ = undefined;
                    break;
                case 91:
                    this.$ = $$[$0 - 1].length ? {
                        type: 'union',
                        patterns: unionAll($$[$0 - 1].map(degroupSingle), [
                            degroupSingle($$[$0])
                        ])
                    } : $$[$0];
                    break;
                case 95:
                    this.$ = (0, $emQHU._)((0, $iT0je._)({}, $$[$0]), {
                        "function": $$[$0 - 1]
                    });
                    break;
                case 96:
                    this.$ = {
                        type: 'functionCall',
                        args: []
                    };
                    break;
                case 97:
                    this.$ = {
                        type: 'functionCall',
                        args: appendTo($$[$0 - 2], $$[$0 - 1]),
                        distinct: !!$$[$0 - 3]
                    };
                    break;
                case 98:
                case 115:
                case 128:
                case 247:
                case 249:
                case 251:
                case 253:
                case 255:
                case 263:
                case 267:
                case 297:
                case 299:
                case 303:
                case 307:
                case 328:
                case 341:
                case 349:
                case 355:
                case 361:
                case 367:
                case 369:
                case 373:
                case 375:
                case 379:
                case 381:
                case 385:
                case 391:
                case 395:
                case 401:
                case 405:
                case 409:
                case 411:
                case 420:
                case 428:
                case 430:
                case 440:
                case 444:
                case 446:
                case 448:
                    this.$ = [];
                    break;
                case 99:
                    this.$ = appendTo($$[$0 - 2], $$[$0 - 1]);
                    break;
                case 101:
                    this.$ = unionAll($$[$0 - 2], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 102:
                case 112:
                    this.$ = applyAnnotations($$[$0].map(function(t) {
                        return extend(triple($$[$0 - 1]), t);
                    }));
                    break;
                case 103:
                    this.$ = applyAnnotations(appendAllTo($$[$0].map(function(t) {
                        return extend(triple($$[$0 - 1].entity), t);
                    }), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 105:
                    this.$ = unionAll([
                        $$[$0 - 1]
                    ], $$[$0]);
                    break;
                case 106:
                    this.$ = unionAll($$[$0]);
                    break;
                case 107:
                    this.$ = objectListToTriples($$[$0 - 1], $$[$0]);
                    break;
                case 109:
                case 237:
                    this.$ = Parser.factory.namedNode(RDF_TYPE);
                    break;
                case 110:
                case 118:
                    this.$ = appendTo($$[$0 - 1], $$[$0]);
                    break;
                case 111:
                    this.$ = $$[$0] ? {
                        annotation: $$[$0],
                        object: $$[$0 - 1]
                    } : $$[$0 - 1];
                    break;
                case 113:
                    this.$ = !$$[$0] ? $$[$0 - 1].triples : applyAnnotations(appendAllTo($$[$0].map(function(t) {
                        return extend(triple($$[$0 - 1].entity), t);
                    }), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 114:
                    this.$ = objectListToTriples.apply(void 0, (0, $7WNf6._)($$[$0 - 1]).concat([
                        $$[$0]
                    ]));
                    break;
                case 116:
                    this.$ = objectListToTriples.apply(void 0, (0, $7WNf6._)($$[$0]));
                    break;
                case 117:
                case 159:
                case 163:
                    this.$ = [
                        $$[$0 - 1],
                        $$[$0]
                    ];
                    break;
                case 119:
                    this.$ = $$[$0] ? {
                        object: $$[$0 - 1],
                        annotation: $$[$0]
                    } : $$[$0 - 1];
                    break;
                case 120:
                    this.$ = $$[$0 - 1].length ? path('|', appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 121:
                    this.$ = $$[$0 - 1].length ? path('/', appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 122:
                    this.$ = $$[$0] ? path($$[$0], [
                        $$[$0 - 1]
                    ]) : $$[$0 - 1];
                    break;
                case 123:
                    this.$ = $$[$0 - 1] ? path($$[$0 - 1], [
                        $$[$0]
                    ]) : $$[$0];
                    break;
                case 125:
                case 131:
                    this.$ = path($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 129:
                    this.$ = path('|', appendTo($$[$0 - 2], $$[$0 - 1]));
                    break;
                case 132:
                case 134:
                    this.$ = createList($$[$0 - 1]);
                    break;
                case 133:
                case 135:
                    this.$ = createAnonymousObject($$[$0 - 1]);
                    break;
                case 140:
                    this.$ = {
                        entity: $$[$0],
                        triples: []
                    };
                    break;
                case 145:
                    this.$ = toVar($$[$0]);
                    break;
                case 149:
                    this.$ = Parser.factory.namedNode(RDF_NIL);
                    break;
                case 151:
                case 153:
                case 158:
                case 162:
                    this.$ = createOperationTree($$[$0 - 1], $$[$0]);
                    break;
                case 152:
                    this.$ = [
                        '||',
                        $$[$0]
                    ];
                    break;
                case 154:
                    this.$ = [
                        '&&',
                        $$[$0]
                    ];
                    break;
                case 156:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0 - 2],
                        $$[$0]
                    ]);
                    break;
                case 157:
                    this.$ = operation($$[$0 - 2] ? 'notin' : 'in', [
                        $$[$0 - 3],
                        $$[$0]
                    ]);
                    break;
                case 160:
                    this.$ = [
                        '+',
                        createOperationTree($$[$0 - 1], $$[$0])
                    ];
                    break;
                case 161:
                    var negatedLiteral = createTypedLiteral($$[$0 - 1].value.replace('-', ''), $$[$0 - 1].datatype);
                    this.$ = [
                        '-',
                        createOperationTree(negatedLiteral, $$[$0])
                    ];
                    break;
                case 164:
                    this.$ = operation('UPLUS', [
                        $$[$0]
                    ]);
                    break;
                case 165:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 166:
                    this.$ = operation('UMINUS', [
                        $$[$0]
                    ]);
                    break;
                case 177:
                    this.$ = operation(lowercase($$[$0 - 1]));
                    break;
                case 178:
                    this.$ = operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]);
                    break;
                case 179:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]));
                    break;
                case 180:
                    this.$ = operation(lowercase($$[$0 - 5]), [
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 181:
                    this.$ = operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 182:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]));
                    break;
                case 183:
                    this.$ = operation(lowercase($$[$0 - 1]), $$[$0]);
                    break;
                case 184:
                    this.$ = operation('bound', [
                        toVar($$[$0 - 1])
                    ]);
                    break;
                case 185:
                    this.$ = operation($$[$0 - 1], []);
                    break;
                case 186:
                    this.$ = operation($$[$0 - 3], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 187:
                    this.$ = operation($$[$0 - 2] ? 'notexists' : 'exists', [
                        degroupSingle($$[$0])
                    ]);
                    break;
                case 188:
                case 189:
                    this.$ = expression($$[$0 - 1], {
                        type: 'aggregate',
                        aggregation: lowercase($$[$0 - 4]),
                        distinct: !!$$[$0 - 2]
                    });
                    break;
                case 190:
                    this.$ = expression($$[$0 - 2], {
                        type: 'aggregate',
                        aggregation: lowercase($$[$0 - 5]),
                        distinct: !!$$[$0 - 3],
                        separator: typeof $$[$0 - 1] === 'string' ? $$[$0 - 1] : ' '
                    });
                    break;
                case 192:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 193:
                    this.$ = createLangLiteral($$[$0 - 1], lowercase($$[$0].substr(1)));
                    break;
                case 194:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 195:
                case 204:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 196:
                case 205:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 197:
                case 206:
                    this.$ = createTypedLiteral(lowercase($$[$0]), XSD_DOUBLE);
                    break;
                case 200:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 201:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_INTEGER);
                    break;
                case 202:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_DECIMAL);
                    break;
                case 203:
                    this.$ = createTypedLiteral($$[$0].substr(1).toLowerCase(), XSD_DOUBLE);
                    break;
                case 207:
                case 208:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 209:
                case 210:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 211:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 213:
                    var namePos = $$[$0].indexOf(':'), prefix = $$[$0].substr(0, namePos), expansion = Parser.prefixes[prefix];
                    if (!expansion) throw new Error('Unknown prefix: ' + prefix);
                    var uriString = resolveIRI(expansion + $$[$0].substr(namePos + 1));
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 214:
                    $$[$0] = $$[$0].substr(0, $$[$0].length - 1);
                    if (!($$[$0] in Parser.prefixes)) throw new Error('Unknown prefix: ' + $$[$0]);
                    var uriString = resolveIRI(Parser.prefixes[$$[$0]]);
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 215:
                    this.$ = blank($$[$0].replace(/^(_:)/, ''));
                    break;
                case 216:
                    this.$ = blank();
                    break;
                case 217:
                case 218:
                case 232:
                    this.$ = ensureSparqlStar(nestedTriple($$[$0 - 3], $$[$0 - 2], $$[$0 - 1]));
                    break;
                case 230:
                case 231:
                    this.$ = ensureSparqlStar($$[$0 - 1]);
                    break;
                case 248:
                case 250:
                case 252:
                case 254:
                case 256:
                case 260:
                case 264:
                case 268:
                case 270:
                case 292:
                case 294:
                case 296:
                case 298:
                case 300:
                case 302:
                case 304:
                case 306:
                case 329:
                case 342:
                case 356:
                case 368:
                case 370:
                case 372:
                case 374:
                case 392:
                case 402:
                case 425:
                case 427:
                case 429:
                case 431:
                case 441:
                case 445:
                case 447:
                case 449:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 259:
                case 269:
                case 291:
                case 293:
                case 295:
                case 301:
                case 305:
                case 371:
                case 424:
                case 426:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 308:
                    $$[$0 - 3].push($$[$0 - 2]);
                    break;
                case 350:
                case 362:
                case 376:
                case 380:
                case 382:
                case 386:
                case 396:
                case 406:
                case 410:
                case 412:
                case 421:
                    $$[$0 - 2].push($$[$0 - 1]);
                    break;
            }
        },
        table: [
            o($V0, $V1, {
                3: 1,
                4: 2,
                10: 3
            }),
            {
                1: [
                    3
                ]
            },
            o($V2, [
                2,
                307
            ], {
                5: 4,
                7: 5,
                321: 6,
                214: 7,
                8: 8,
                96: 9,
                215: 10,
                17: 11,
                21: 12,
                97: 16,
                38: 17,
                6: [
                    2,
                    238
                ],
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                24: [
                    1,
                    13
                ],
                32: [
                    1,
                    14
                ],
                36: [
                    1,
                    15
                ],
                41: $V4
            }),
            o([
                6,
                13,
                16,
                24,
                32,
                36,
                41,
                45,
                100,
                110,
                113,
                115,
                116,
                123,
                126,
                131,
                197,
                224,
                229,
                308,
                329,
                330,
                331,
                332,
                333
            ], [
                2,
                3
            ], {
                322: 19,
                11: 20,
                14: 21,
                12: [
                    1,
                    22
                ],
                15: [
                    1,
                    23
                ]
            }),
            {
                6: [
                    1,
                    24
                ]
            },
            {
                6: [
                    2,
                    240
                ]
            },
            {
                6: [
                    2,
                    241
                ]
            },
            {
                6: [
                    2,
                    242
                ]
            },
            {
                6: [
                    2,
                    243
                ],
                9: 25,
                84: 26,
                85: $V5
            },
            {
                6: [
                    2,
                    239
                ]
            },
            o($V6, [
                2,
                411
            ], {
                216: 28,
                217: 29
            }),
            o($V7, [
                2,
                249
            ], {
                18: 30
            }),
            o($V7, [
                2,
                251
            ], {
                22: 31
            }),
            o($V8, [
                2,
                255
            ], {
                25: 32,
                27: 33,
                29: [
                    1,
                    34
                ]
            }),
            {
                13: $V9,
                16: $Va,
                33: 35,
                39: [
                    1,
                    37
                ],
                44: 39,
                55: 40,
                87: $Vb,
                139: 38,
                307: 43,
                308: $Vc,
                323: 36
            },
            o($V7, [
                2,
                267
            ], {
                37: 46
            }),
            o($Vd, [
                2,
                326
            ], {
                98: 47,
                103: 49,
                106: 50,
                117: 55,
                130: 61,
                100: [
                    1,
                    48
                ],
                110: [
                    1,
                    51
                ],
                113: [
                    1,
                    52
                ],
                115: [
                    1,
                    53
                ],
                116: [
                    1,
                    54
                ],
                131: [
                    1,
                    62
                ],
                329: [
                    1,
                    56
                ],
                330: [
                    1,
                    57
                ],
                331: [
                    1,
                    58
                ],
                332: [
                    1,
                    59
                ],
                333: [
                    1,
                    60
                ]
            }),
            {
                39: [
                    1,
                    63
                ],
                40: 64,
                43: 65,
                44: 66,
                45: $Ve,
                87: $Vb
            },
            o($Vf, [
                2,
                273
            ], {
                42: 68,
                324: 69,
                325: [
                    1,
                    70
                ],
                326: [
                    1,
                    71
                ]
            }),
            o($V0, [
                2,
                248
            ]),
            o($V0, [
                2,
                245
            ]),
            o($V0, [
                2,
                246
            ]),
            {
                13: [
                    1,
                    72
                ]
            },
            {
                16: [
                    1,
                    73
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                6: [
                    2,
                    2
                ]
            },
            {
                6: [
                    2,
                    244
                ]
            },
            {
                45: [
                    1,
                    77
                ],
                85: [
                    1,
                    78
                ],
                86: 74,
                87: [
                    1,
                    75
                ],
                89: [
                    1,
                    76
                ]
            },
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312
            ], [
                2,
                120
            ], {
                337: [
                    1,
                    79
                ]
            }),
            o($Vg, [
                2,
                418
            ], {
                218: 80,
                222: 81,
                229: [
                    1,
                    82
                ]
            }),
            {
                19: 83,
                28: $Vh,
                29: $Vi,
                52: 84,
                53: $Vj,
                56: 85
            },
            {
                19: 88,
                28: $Vh,
                29: $Vi,
                52: 89,
                53: $Vj,
                56: 85
            },
            o($V7, [
                2,
                253
            ], {
                26: 90
            }),
            {
                28: [
                    1,
                    91
                ],
                52: 92,
                53: $Vj
            },
            o($Vk, [
                2,
                385
            ], {
                181: 93,
                182: 94,
                183: 95,
                31: [
                    2,
                    383
                ]
            }),
            o($Vl, [
                2,
                263
            ], {
                34: 96
            }),
            o($Vl, [
                2,
                261
            ], {
                44: 39,
                55: 40,
                307: 43,
                139: 97,
                13: $V9,
                16: $Va,
                87: $Vb,
                308: $Vc
            }),
            o($Vl, [
                2,
                262
            ]),
            o($Vm, [
                2,
                259
            ]),
            o($Vn, [
                2,
                143
            ]),
            o($Vn, [
                2,
                144
            ]),
            o([
                6,
                13,
                16,
                28,
                29,
                31,
                39,
                45,
                47,
                48,
                53,
                63,
                70,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                197,
                224,
                229,
                231,
                232,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                314,
                317,
                318,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                145
            ]),
            o($Vo, [
                2,
                211
            ]),
            o($Vo, [
                2,
                212
            ]),
            o($Vo, [
                2,
                213
            ]),
            o($Vo, [
                2,
                214
            ]),
            {
                19: 98,
                28: $Vh,
                29: $Vi,
                52: 99,
                53: $Vj,
                56: 85
            },
            {
                6: [
                    2,
                    309
                ],
                99: 100,
                193: [
                    1,
                    101
                ]
            },
            o($Vp, [
                2,
                311
            ], {
                101: 102,
                328: [
                    1,
                    103
                ]
            }),
            o($Vq, [
                2,
                317
            ], {
                104: 104,
                328: [
                    1,
                    105
                ]
            }),
            o($Vr, [
                2,
                322
            ], {
                107: 106,
                328: [
                    1,
                    107
                ]
            }),
            {
                111: 108,
                112: [
                    2,
                    324
                ],
                328: [
                    1,
                    109
                ]
            },
            {
                29: $Vs,
                114: 110
            },
            {
                29: $Vs,
                114: 112
            },
            {
                29: $Vs,
                114: 113
            },
            {
                118: 114,
                123: [
                    1,
                    115
                ],
                125: 116,
                126: $Vt
            },
            o($Vu, [
                2,
                315
            ]),
            o($Vu, [
                2,
                316
            ]),
            o($Vv, [
                2,
                319
            ]),
            o($Vv, [
                2,
                320
            ]),
            o($Vv, [
                2,
                321
            ]),
            o($Vd, [
                2,
                327
            ]),
            {
                13: $V9,
                16: $Va,
                55: 118,
                307: 43,
                308: $Vc
            },
            o($V7, [
                2,
                12
            ]),
            o($V7, [
                2,
                13
            ], {
                44: 66,
                43: 119,
                45: $Ve,
                87: $Vb
            }),
            o($Vw, [
                2,
                269
            ]),
            o($Vw, [
                2,
                15
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 120,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vf, [
                2,
                14
            ]),
            o($Vf, [
                2,
                274
            ]),
            o($Vf, [
                2,
                271
            ]),
            o($Vf, [
                2,
                272
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    177
                ]
            },
            o($V61, [
                2,
                39
            ]),
            {
                29: [
                    1,
                    178
                ]
            },
            {
                29: [
                    1,
                    179
                ]
            },
            {
                87: [
                    1,
                    181
                ],
                91: 180
            },
            {
                45: [
                    1,
                    187
                ],
                87: [
                    1,
                    185
                ],
                89: [
                    1,
                    186
                ],
                93: 182,
                165: 183,
                166: 184
            },
            o($V6, [
                2,
                410
            ]),
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                337
            ], [
                2,
                121
            ], {
                338: [
                    1,
                    188
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    193
                ],
                55: 194,
                197: $V71,
                219: 189,
                220: 190,
                223: 191,
                224: [
                    1,
                    192
                ],
                307: 43,
                308: $Vc
            },
            o($Vg, [
                2,
                419
            ]),
            o($V81, $V91, {
                20: 196,
                59: 197,
                69: 198,
                70: $Va1
            }),
            o($V7, [
                2,
                250
            ]),
            {
                29: $Vb1,
                57: 200
            },
            o($Vp, [
                2,
                279
            ], {
                54: 202,
                327: [
                    1,
                    203
                ]
            }),
            {
                29: [
                    2,
                    282
                ]
            },
            o($Vc1, $Vd1, {
                23: 204,
                58: 205,
                62: 206,
                63: $Ve1
            }),
            o($V7, [
                2,
                252
            ]),
            {
                19: 208,
                28: $Vh,
                29: $Vi,
                52: 209,
                53: $Vj,
                56: 85
            },
            {
                29: [
                    1,
                    210
                ]
            },
            o($V8, [
                2,
                256
            ]),
            {
                31: [
                    1,
                    211
                ]
            },
            {
                31: [
                    2,
                    384
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 212,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl1, [
                2,
                265
            ], {
                56: 85,
                35: 227,
                52: 228,
                19: 229,
                28: $Vh,
                29: $Vi,
                53: $Vj
            }),
            o($Vm, [
                2,
                260
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 230,
                63: $Ve1
            }),
            o($V7, [
                2,
                268
            ]),
            {
                6: [
                    2,
                    45
                ]
            },
            o($V0, $V1, {
                10: 3,
                4: 231
            }),
            {
                13: $V9,
                16: $Va,
                55: 232,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                312
            ]),
            {
                105: 233,
                112: $Vm1,
                122: 234,
                132: [
                    1,
                    237
                ],
                134: 235,
                327: [
                    1,
                    238
                ],
                334: [
                    1,
                    239
                ]
            },
            o($Vq, [
                2,
                318
            ]),
            o($Vp, $Vn1, {
                108: 240,
                133: 242,
                112: $Vo1,
                132: $Vp1
            }),
            o($Vr, [
                2,
                323
            ]),
            {
                112: [
                    1,
                    244
                ]
            },
            {
                112: [
                    2,
                    325
                ]
            },
            o($Vq1, [
                2,
                50
            ]),
            o($Vk, $Vr1, {
                135: 245,
                136: 246,
                143: 247,
                144: 248,
                31: $Vs1,
                112: $Vs1
            }),
            o($Vq1, [
                2,
                51
            ]),
            o($Vq1, [
                2,
                52
            ]),
            o($Vt1, [
                2,
                328
            ], {
                119: 249
            }),
            {
                29: $Vs,
                114: 250
            },
            o($Vt1, [
                2,
                56
            ]),
            {
                29: $Vs,
                114: 251
            },
            o($Vd, [
                2,
                59
            ]),
            o($Vw, [
                2,
                270
            ]),
            {
                47: [
                    1,
                    252
                ]
            },
            o($Vu1, [
                2,
                150
            ]),
            o($Vv1, [
                2,
                428
            ], {
                240: 253
            }),
            o($Vw1, [
                2,
                430
            ], {
                244: 254
            }),
            o($Vw1, [
                2,
                155
            ], {
                248: 255,
                249: 256,
                250: [
                    2,
                    438
                ],
                290: [
                    1,
                    257
                ],
                341: [
                    1,
                    258
                ],
                342: [
                    1,
                    259
                ],
                343: [
                    1,
                    260
                ],
                344: [
                    1,
                    261
                ],
                345: [
                    1,
                    262
                ],
                346: [
                    1,
                    263
                ]
            }),
            o($Vx1, [
                2,
                440
            ], {
                252: 264
            }),
            o($Vy1, [
                2,
                448
            ], {
                260: 265
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 266,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 267,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 268,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                167
            ]),
            o($Vy1, [
                2,
                168
            ]),
            o($Vy1, [
                2,
                169
            ]),
            o($Vy1, [
                2,
                170
            ], {
                176: 269,
                45: $Vz1,
                89: $VA1
            }),
            o($Vy1, [
                2,
                171
            ]),
            o($Vy1, [
                2,
                172
            ]),
            o($Vy1, [
                2,
                173
            ]),
            o($Vy1, [
                2,
                174
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 272,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                176
            ]),
            {
                89: [
                    1,
                    273
                ]
            },
            {
                45: [
                    1,
                    274
                ]
            },
            {
                45: [
                    1,
                    275
                ]
            },
            {
                45: [
                    1,
                    276
                ]
            },
            {
                45: [
                    1,
                    277
                ]
            },
            {
                45: [
                    1,
                    278
                ]
            },
            {
                45: $VC1,
                89: $VD1,
                179: 279
            },
            {
                45: [
                    1,
                    282
                ]
            },
            {
                45: [
                    1,
                    284
                ],
                89: [
                    1,
                    283
                ]
            },
            {
                279: [
                    1,
                    285
                ]
            },
            o($VE1, [
                2,
                192
            ], {
                292: [
                    1,
                    286
                ],
                293: [
                    1,
                    287
                ]
            }),
            o($VE1, [
                2,
                195
            ]),
            o($VE1, [
                2,
                196
            ]),
            o($VE1, [
                2,
                197
            ]),
            o($VE1, [
                2,
                198
            ]),
            o($VE1, [
                2,
                199
            ]),
            o($VE1, [
                2,
                200
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 288
            },
            {
                45: [
                    1,
                    292
                ]
            },
            {
                45: [
                    1,
                    293
                ]
            },
            {
                45: [
                    1,
                    294
                ]
            },
            o($VF1, [
                2,
                452
            ]),
            o($VF1, [
                2,
                453
            ]),
            o($VF1, [
                2,
                454
            ]),
            o($VF1, [
                2,
                455
            ]),
            o($VF1, [
                2,
                456
            ]),
            {
                279: [
                    2,
                    458
                ]
            },
            o($VG1, [
                2,
                207
            ]),
            o($VG1, [
                2,
                208
            ]),
            o($VG1, [
                2,
                209
            ]),
            o($VG1, [
                2,
                210
            ]),
            o($VE1, [
                2,
                201
            ]),
            o($VE1, [
                2,
                202
            ]),
            o($VE1, [
                2,
                203
            ]),
            o($VE1, [
                2,
                204
            ]),
            o($VE1, [
                2,
                205
            ]),
            o($VE1, [
                2,
                206
            ]),
            o($V0, [
                2,
                5
            ]),
            o($VH1, [
                2,
                297
            ], {
                88: 295
            }),
            o($VI1, [
                2,
                299
            ], {
                90: 296
            }),
            {
                48: [
                    1,
                    297
                ],
                87: [
                    1,
                    298
                ]
            },
            o($VJ1, [
                2,
                301
            ]),
            o($V61, [
                2,
                43
            ]),
            o($V61, [
                2,
                82
            ]),
            o($V61, [
                2,
                83
            ]),
            {
                29: [
                    1,
                    299
                ]
            },
            {
                29: [
                    1,
                    300
                ]
            },
            {
                87: [
                    1,
                    302
                ],
                169: 301
            },
            o($V6, [
                2,
                412
            ]),
            o($VK1, [
                2,
                123
            ]),
            o($VK1, [
                2,
                416
            ], {
                221: 303,
                339: 304,
                39: [
                    1,
                    306
                ],
                263: [
                    1,
                    307
                ],
                340: [
                    1,
                    305
                ]
            }),
            o($VL1, [
                2,
                124
            ]),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    311
                ],
                55: 194,
                89: [
                    1,
                    310
                ],
                197: $V71,
                223: 312,
                225: 308,
                226: 309,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($V6, $V3, {
                215: 10,
                214: 314
            }),
            o($VL1, [
                2,
                236
            ]),
            o($VL1, [
                2,
                237
            ]),
            o($VN1, [
                2,
                6
            ]),
            o($VO1, [
                2,
                287
            ], {
                60: 315,
                72: 316,
                73: [
                    1,
                    317
                ]
            }),
            o($V81, [
                2,
                286
            ]),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                71: 318,
                77: 320,
                79: 319,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o([
                6,
                31,
                63,
                70,
                73,
                81,
                83,
                85
            ], [
                2,
                20
            ]),
            o($Vk, $VP1, {
                38: 17,
                49: 324,
                147: 325,
                17: 326,
                21: 327,
                148: 328,
                154: 329,
                155: 330,
                29: $VQ1,
                31: $VQ1,
                85: $VQ1,
                112: $VQ1,
                159: $VQ1,
                160: $VQ1,
                161: $VQ1,
                163: $VQ1,
                164: $VQ1,
                41: $V4
            }),
            {
                13: $V9,
                16: $Va,
                55: 331,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                280
            ]),
            o($VN1, [
                2,
                7
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 332,
                70: $Va1
            }),
            o($Vc1, [
                2,
                284
            ]),
            {
                64: [
                    1,
                    333
                ]
            },
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 334,
                63: $Ve1
            }),
            o($V7, [
                2,
                254
            ]),
            o($Vk, $Vr1, {
                144: 248,
                30: 335,
                143: 336,
                31: [
                    2,
                    257
                ]
            }),
            o($V7, [
                2,
                100
            ]),
            {
                31: [
                    2,
                    387
                ],
                184: 337,
                335: [
                    1,
                    338
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 339,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VS1, [
                2,
                389
            ], {
                44: 39,
                55: 40,
                307: 43,
                190: 340,
                195: 341,
                139: 342,
                188: 344,
                189: 345,
                186: 346,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($VT1, [
                2,
                227
            ]),
            o($VT1, [
                2,
                228
            ]),
            o($VT1, [
                2,
                229
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 348,
                230: 347,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 352,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VT1, [
                2,
                146
            ]),
            o($VT1, [
                2,
                147
            ]),
            o($VT1, [
                2,
                148
            ]),
            o($VT1, [
                2,
                149
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 353
            },
            o($VU1, [
                2,
                215
            ]),
            o($VU1, [
                2,
                216
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 359,
                63: $Ve1
            }),
            o($Vl, [
                2,
                264
            ]),
            o($Vl1, [
                2,
                266
            ]),
            o($VN1, [
                2,
                11
            ]),
            o($V2, [
                2,
                308
            ], {
                6: [
                    2,
                    310
                ]
            }),
            o($Vq1, [
                2,
                313
            ], {
                102: 360,
                120: 361,
                121: [
                    1,
                    362
                ]
            }),
            o($Vq1, [
                2,
                47
            ]),
            o($Vq1, [
                2,
                63
            ]),
            o($Vq1, [
                2,
                64
            ]),
            {
                13: $V9,
                16: $Va,
                55: 363,
                307: 43,
                308: $Vc
            },
            o($Vq1, [
                2,
                336
            ]),
            o($Vq1, [
                2,
                337
            ]),
            o($Vq1, [
                2,
                338
            ]),
            {
                109: [
                    1,
                    364
                ]
            },
            o($VV1, [
                2,
                60
            ]),
            {
                13: $V9,
                16: $Va,
                55: 365,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                335
            ]),
            {
                13: $V9,
                16: $Va,
                55: 366,
                307: 43,
                308: $Vc
            },
            {
                31: [
                    1,
                    367
                ]
            },
            o($VW1, [
                2,
                341
            ], {
                137: 368
            }),
            o($VW1, [
                2,
                340
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 369,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                28: [
                    1,
                    370
                ],
                127: 371,
                128: [
                    1,
                    372
                ]
            },
            o($Vt1, [
                2,
                330
            ], {
                124: 373,
                125: 374,
                126: $Vt
            }),
            o($Vt1, [
                2,
                57
            ]),
            {
                44: 375,
                87: $Vb
            },
            o($Vu1, [
                2,
                151
            ], {
                241: 376,
                242: [
                    1,
                    377
                ]
            }),
            o($Vv1, [
                2,
                153
            ], {
                245: 378,
                246: [
                    1,
                    379
                ]
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                247: 380,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                250: [
                    1,
                    381
                ]
            },
            o($VX1, [
                2,
                432
            ]),
            o($VX1, [
                2,
                433
            ]),
            o($VX1, [
                2,
                434
            ]),
            o($VX1, [
                2,
                435
            ]),
            o($VX1, [
                2,
                436
            ]),
            o($VX1, [
                2,
                437
            ]),
            {
                250: [
                    2,
                    439
                ]
            },
            o([
                47,
                48,
                193,
                242,
                246,
                250,
                272,
                290,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                158
            ], {
                253: 382,
                254: 383,
                255: 384,
                257: 385,
                263: [
                    1,
                    386
                ],
                265: [
                    1,
                    387
                ],
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW
            }),
            o($Vx1, [
                2,
                162
            ], {
                261: 388,
                262: 389,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                164
            ]),
            o($Vy1, [
                2,
                165
            ]),
            o($Vy1, [
                2,
                166
            ]),
            o($VB1, [
                2,
                95
            ]),
            o($VB1, [
                2,
                96
            ]),
            o($VX1, [
                2,
                377
            ], {
                177: 392,
                325: [
                    1,
                    393
                ]
            }),
            {
                48: [
                    1,
                    394
                ]
            },
            o($VB1, [
                2,
                177
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 395,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 396,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 397,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 398,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 399,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                183
            ]),
            o($VB1, [
                2,
                98
            ]),
            o($VX1, [
                2,
                381
            ], {
                180: 400
            }),
            {
                87: [
                    1,
                    401
                ]
            },
            o($VB1, [
                2,
                185
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 402,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                29: $Vb1,
                57: 403
            },
            o($VE1, [
                2,
                193
            ]),
            {
                13: $V9,
                16: $Va,
                55: 404,
                307: 43,
                308: $Vc
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 405,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                233
            ]),
            o($V_1, [
                2,
                234
            ]),
            o($V_1, [
                2,
                235
            ]),
            o($V$1, [
                2,
                459
            ], {
                281: 406,
                325: [
                    1,
                    407
                ]
            }),
            o($VX1, [
                2,
                463
            ], {
                284: 408,
                325: [
                    1,
                    409
                ]
            }),
            o($VX1, [
                2,
                465
            ], {
                286: 410,
                325: [
                    1,
                    411
                ]
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    412
                ],
                55: 414,
                82: $Vy,
                171: 413,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    419
                ],
                89: [
                    1,
                    420
                ]
            },
            {
                29: [
                    1,
                    421
                ]
            },
            o($VJ1, [
                2,
                302
            ]),
            o($VH1, [
                2,
                367
            ], {
                167: 422
            }),
            o($VI1, [
                2,
                369
            ], {
                168: 423
            }),
            {
                48: [
                    1,
                    424
                ],
                87: [
                    1,
                    425
                ]
            },
            o($VJ1, [
                2,
                371
            ]),
            o($VK1, [
                2,
                122
            ]),
            o($VK1, [
                2,
                417
            ]),
            o($VK1, [
                2,
                413
            ]),
            o($VK1, [
                2,
                414
            ]),
            o($VK1, [
                2,
                415
            ]),
            o($VL1, [
                2,
                125
            ]),
            o($VL1, [
                2,
                127
            ]),
            o($VL1, [
                2,
                128
            ]),
            o($V22, [
                2,
                420
            ], {
                227: 426
            }),
            o($VL1, [
                2,
                130
            ]),
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 427,
                307: 43,
                308: $Vc
            },
            {
                48: [
                    1,
                    428
                ]
            },
            o($V32, [
                2,
                289
            ], {
                61: 429,
                80: 430,
                81: [
                    1,
                    431
                ],
                83: [
                    1,
                    432
                ]
            }),
            o($VO1, [
                2,
                288
            ]),
            {
                64: [
                    1,
                    433
                ]
            },
            o($V81, [
                2,
                29
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 434,
                13: $V9,
                16: $Va,
                45: $Vx,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($V42, [
                2,
                293
            ]),
            o($V52, [
                2,
                92
            ]),
            o($V52, [
                2,
                93
            ]),
            o($V52, [
                2,
                94
            ]),
            {
                45: $Vz1,
                89: $VA1,
                176: 269
            },
            {
                31: [
                    1,
                    435
                ]
            },
            {
                31: [
                    1,
                    436
                ]
            },
            {
                19: 437,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            {
                19: 438,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            o($V62, [
                2,
                355
            ], {
                149: 439
            }),
            o($V62, [
                2,
                354
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                156: 440,
                172: 221,
                185: 441,
                203: 442,
                231: $V82,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl, [
                2,
                19
            ]),
            o($V32, [
                2,
                21
            ]),
            {
                13: $V9,
                16: $Va,
                44: 450,
                45: $V92,
                55: 323,
                65: 445,
                66: 446,
                67: 447,
                68: 448,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VN1, [
                2,
                8
            ]),
            {
                31: [
                    1,
                    451
                ]
            },
            {
                31: [
                    2,
                    258
                ]
            },
            {
                31: [
                    2,
                    101
                ]
            },
            o($Vk, [
                2,
                386
            ], {
                31: [
                    2,
                    388
                ]
            }),
            o($VS1, [
                2,
                102
            ]),
            o($Va2, [
                2,
                391
            ], {
                191: 452
            }),
            o($Vk, [
                2,
                395
            ], {
                196: 453,
                198: 454
            }),
            o($Vk, [
                2,
                108
            ]),
            o($Vk, [
                2,
                109
            ]),
            o($VS1, [
                2,
                103
            ]),
            o($VS1, [
                2,
                104
            ]),
            o($VS1, [
                2,
                390
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                48: [
                    1,
                    455
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 456,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                424
            ]),
            o($Vc2, [
                2,
                136
            ]),
            o($Vc2, [
                2,
                137
            ]),
            o($Vd2, [
                2,
                140
            ]),
            {
                232: [
                    1,
                    457
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 458,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                219
            ]),
            o($V_1, [
                2,
                220
            ]),
            o($V_1, [
                2,
                221
            ]),
            o($V_1, [
                2,
                222
            ]),
            o($V_1, [
                2,
                223
            ]),
            o($VN1, [
                2,
                10
            ]),
            o($Vq1, [
                2,
                46
            ]),
            o($Vq1, [
                2,
                314
            ]),
            {
                112: $Vm1,
                122: 459
            },
            o($Vq1, [
                2,
                62
            ]),
            o($Vp, $Vn1, {
                133: 242,
                108: 460,
                112: $Vo1,
                132: $Vp1
            }),
            o($VV1, [
                2,
                61
            ]),
            o($Vq1, [
                2,
                49
            ]),
            o([
                6,
                28,
                126,
                128,
                193
            ], [
                2,
                65
            ]),
            {
                31: [
                    2,
                    66
                ],
                112: [
                    1,
                    462
                ],
                138: 461
            },
            o($VW1, [
                2,
                351
            ], {
                146: 463,
                335: [
                    1,
                    464
                ]
            }),
            {
                29: $Vb1,
                57: 465
            },
            o($Vt1, [
                2,
                329
            ]),
            o($Vp, [
                2,
                332
            ], {
                129: 466,
                327: [
                    1,
                    467
                ]
            }),
            o($Vt1, [
                2,
                55
            ]),
            o($Vt1, [
                2,
                331
            ]),
            {
                48: [
                    1,
                    468
                ]
            },
            o($Vv1, [
                2,
                429
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                239: 469,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                431
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                243: 470,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                156
            ]),
            {
                45: $VC1,
                89: $VD1,
                179: 471
            },
            o($Vx1, [
                2,
                441
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                251: 472,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                444
            ], {
                256: 473
            }),
            o($Vy1, [
                2,
                446
            ], {
                258: 474
            }),
            o($VX1, [
                2,
                442
            ]),
            o($VX1, [
                2,
                443
            ]),
            o($Vy1, [
                2,
                449
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                255: 154,
                257: 155,
                259: 475,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                450
            ]),
            o($VX1, [
                2,
                451
            ]),
            o($VX1, [
                2,
                379
            ], {
                178: 476
            }),
            o($VX1, [
                2,
                378
            ]),
            o([
                6,
                13,
                16,
                29,
                31,
                39,
                45,
                47,
                48,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                231,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                175
            ]),
            {
                48: [
                    1,
                    477
                ]
            },
            {
                48: [
                    1,
                    478
                ]
            },
            {
                272: [
                    1,
                    479
                ]
            },
            {
                272: [
                    1,
                    480
                ]
            },
            {
                272: [
                    1,
                    481
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 482,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    483
                ]
            },
            {
                48: [
                    1,
                    484
                ]
            },
            o($VB1, [
                2,
                187
            ]),
            o($VE1, [
                2,
                194
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 485
            },
            {
                13: $V9,
                16: $Va,
                39: [
                    1,
                    487
                ],
                44: 136,
                45: $Vx,
                46: 488,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                282: 486,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V$1, [
                2,
                460
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 489,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                464
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 490,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                466
            ]),
            o($V61, [
                2,
                40
            ]),
            o($VH1, [
                2,
                298
            ]),
            o($Ve2, [
                2,
                87
            ]),
            o($Ve2, [
                2,
                88
            ]),
            o($Ve2, [
                2,
                89
            ]),
            o($Ve2, [
                2,
                90
            ]),
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 491
            },
            o($V61, [
                2,
                41
            ]),
            o($VI1, [
                2,
                300
            ]),
            o($Vf2, [
                2,
                303
            ], {
                92: 495
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    496
                ],
                55: 414,
                82: $Vy,
                171: 497,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    498
                ],
                89: [
                    1,
                    499
                ]
            },
            {
                29: [
                    1,
                    500
                ]
            },
            o($VJ1, [
                2,
                372
            ]),
            {
                13: $V9,
                16: $Va,
                48: [
                    2,
                    422
                ],
                55: 194,
                197: $V71,
                223: 312,
                226: 502,
                228: 501,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($VL1, [
                2,
                131
            ]),
            o($VL1, [
                2,
                126
            ]),
            o($V32, [
                2,
                22
            ]),
            o($V32, [
                2,
                290
            ]),
            {
                82: [
                    1,
                    503
                ]
            },
            {
                82: [
                    1,
                    504
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 510,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                74: 505,
                75: 506,
                76: $Vg2,
                77: 320,
                78: $Vh2,
                79: 509,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V42, [
                2,
                294
            ]),
            o($Vi2, [
                2,
                69
            ]),
            o($Vi2, [
                2,
                70
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 511,
                70: $Va1
            }),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 512,
                63: $Ve1
            }),
            {
                29: [
                    2,
                    375
                ],
                31: [
                    2,
                    71
                ],
                84: 522,
                85: $V5,
                112: [
                    1,
                    518
                ],
                150: 513,
                151: 514,
                158: 515,
                159: [
                    1,
                    516
                ],
                160: [
                    1,
                    517
                ],
                161: [
                    1,
                    519
                ],
                163: [
                    1,
                    520
                ],
                164: [
                    1,
                    521
                ],
                175: 523
            },
            o($V62, [
                2,
                363
            ], {
                157: 524,
                335: [
                    1,
                    525
                ]
            }),
            o($V6, $V3, {
                215: 10,
                202: 526,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                87: $Vb
            }),
            o($Vj2, [
                2,
                399
            ], {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                204: 531,
                202: 532,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 534,
                231: $V82,
                233: 533,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 537,
                87: $Vb
            }),
            o($Vc1, [
                2,
                23
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                55: 323,
                67: 447,
                68: 448,
                44: 450,
                66: 538,
                13: $V9,
                16: $Va,
                45: $V92,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vk2, [
                2,
                291
            ]),
            o($Vk2, [
                2,
                24
            ]),
            o($Vk2, [
                2,
                25
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 539,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vk2, [
                2,
                28
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 540,
                63: $Ve1
            }),
            o([
                31,
                112,
                232,
                318,
                335
            ], [
                2,
                105
            ], {
                192: 541,
                193: [
                    1,
                    542
                ]
            }),
            o($Va2, [
                2,
                107
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                199: 543,
                200: 544,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl2, [
                2,
                132
            ]),
            o($Vb2, [
                2,
                425
            ]),
            o($Vl2, [
                2,
                133
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 545
            },
            o($Vq1, [
                2,
                54
            ]),
            o($Vq1, [
                2,
                48
            ]),
            o($VW1, [
                2,
                342
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 546,
                307: 43,
                308: $Vc
            },
            o($VW1, [
                2,
                68
            ]),
            o($Vk, [
                2,
                350
            ], {
                31: $Vm2,
                112: $Vm2
            }),
            o($Vq1, [
                2,
                53
            ]),
            {
                13: $V9,
                16: $Va,
                55: 547,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                333
            ]),
            o($Vw, [
                2,
                16
            ]),
            o($Vv1, [
                2,
                152
            ]),
            o($Vw1, [
                2,
                154
            ]),
            o($Vw1, [
                2,
                157
            ]),
            o($Vx1, [
                2,
                159
            ]),
            o($Vx1, [
                2,
                160
            ], {
                262: 389,
                261: 548,
                39: $VY1,
                338: $VZ1
            }),
            o($Vx1, [
                2,
                161
            ], {
                262: 389,
                261: 549,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                163
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 550,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                178
            ]),
            o($VB1, [
                2,
                179
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 551,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 552,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 553,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    554
                ],
                272: [
                    1,
                    555
                ]
            },
            o($VB1, [
                2,
                184
            ]),
            o($VB1, [
                2,
                186
            ]),
            {
                314: [
                    1,
                    556
                ]
            },
            {
                48: [
                    1,
                    557
                ]
            },
            {
                48: [
                    2,
                    461
                ]
            },
            {
                48: [
                    2,
                    462
                ]
            },
            {
                48: [
                    1,
                    558
                ]
            },
            {
                48: [
                    2,
                    467
                ],
                193: [
                    1,
                    561
                ],
                287: 559,
                288: 560
            },
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 562,
                307: 43,
                308: $Vc
            },
            o($Vn2, [
                2,
                224
            ]),
            o($Vn2, [
                2,
                225
            ]),
            o($Vn2, [
                2,
                226
            ]),
            {
                31: [
                    1,
                    563
                ],
                45: $Vo2,
                94: 564
            },
            o($V61, [
                2,
                84
            ]),
            o($VH1, [
                2,
                368
            ]),
            o($V61, [
                2,
                85
            ]),
            o($VI1, [
                2,
                370
            ]),
            o($Vf2, [
                2,
                373
            ], {
                170: 566
            }),
            {
                48: [
                    1,
                    567
                ]
            },
            {
                48: [
                    2,
                    423
                ],
                337: [
                    1,
                    568
                ]
            },
            o($V32, [
                2,
                35
            ], {
                83: [
                    1,
                    569
                ]
            }),
            o($V32, [
                2,
                36
            ], {
                81: [
                    1,
                    570
                ]
            }),
            o($VO1, [
                2,
                30
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 509,
                44: 510,
                75: 571,
                13: $V9,
                16: $Va,
                45: $Vx,
                76: $Vg2,
                78: $Vh2,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vp2, [
                2,
                295
            ]),
            {
                45: $Vx,
                77: 572
            },
            {
                45: $Vx,
                77: 573
            },
            o($Vp2, [
                2,
                33
            ]),
            o($Vp2, [
                2,
                34
            ]),
            {
                31: [
                    2,
                    275
                ],
                50: 574,
                84: 575,
                85: $V5
            },
            {
                31: [
                    2,
                    277
                ],
                51: 576,
                84: 577,
                85: $V5
            },
            o($V62, [
                2,
                356
            ]),
            o($Vq2, [
                2,
                357
            ], {
                152: 578,
                335: [
                    1,
                    579
                ]
            }),
            o($Vr2, [
                2,
                74
            ]),
            {
                29: $Vb1,
                57: 580
            },
            {
                29: $Vb1,
                57: 581
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 582,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                365
            ], {
                162: 583,
                328: [
                    1,
                    584
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                77: 320,
                79: 585,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                45: [
                    1,
                    586
                ]
            },
            o($Vr2, [
                2,
                81
            ]),
            {
                29: $Vb1,
                57: 587
            },
            o($V62, [
                2,
                73
            ]),
            o($Vk, [
                2,
                362
            ], {
                29: $Vt2,
                31: $Vt2,
                85: $Vt2,
                112: $Vt2,
                159: $Vt2,
                160: $Vt2,
                161: $Vt2,
                163: $Vt2,
                164: $Vt2
            }),
            o($Vj2, [
                2,
                112
            ]),
            o($Vu2, [
                2,
                401
            ], {
                206: 588
            }),
            o($Vk, [
                2,
                405
            ], {
                209: 589,
                210: 590
            }),
            o($Vk, [
                2,
                403
            ]),
            o($Vk, [
                2,
                404
            ]),
            o($Vj2, [
                2,
                113
            ]),
            o($Vj2, [
                2,
                400
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                48: [
                    1,
                    591
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 592,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                426
            ]),
            o($Vd2, [
                2,
                138
            ]),
            o($Vd2, [
                2,
                139
            ]),
            {
                232: [
                    1,
                    593
                ]
            },
            o($Vk2, [
                2,
                292
            ]),
            {
                47: [
                    1,
                    595
                ],
                48: [
                    1,
                    594
                ]
            },
            o($VN1, [
                2,
                9
            ]),
            o($Va2, [
                2,
                392
            ]),
            o($Va2, [
                2,
                393
            ], {
                44: 39,
                55: 40,
                307: 43,
                195: 341,
                139: 342,
                194: 596,
                190: 597,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($Va2, [
                2,
                110
            ], {
                272: [
                    1,
                    598
                ]
            }),
            o($Vv2, [
                2,
                397
            ], {
                201: 599,
                316: 600,
                317: [
                    1,
                    601
                ]
            }),
            {
                314: [
                    1,
                    602
                ]
            },
            {
                29: [
                    1,
                    603
                ]
            },
            o($Vt1, [
                2,
                58
            ]),
            o($Vy1, [
                2,
                445
            ]),
            o($Vy1, [
                2,
                447
            ]),
            {
                48: [
                    1,
                    604
                ],
                272: [
                    1,
                    605
                ]
            },
            {
                48: [
                    1,
                    606
                ]
            },
            {
                272: [
                    1,
                    607
                ]
            },
            {
                272: [
                    1,
                    608
                ]
            },
            o($VB1, [
                2,
                99
            ]),
            o($VX1, [
                2,
                382
            ]),
            o([
                13,
                16,
                39,
                47,
                48,
                87,
                193,
                197,
                242,
                246,
                250,
                263,
                265,
                272,
                290,
                297,
                298,
                299,
                300,
                301,
                302,
                308,
                314,
                338,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                232
            ]),
            o($VB1, [
                2,
                188
            ]),
            o($VB1, [
                2,
                189
            ]),
            {
                48: [
                    1,
                    609
                ]
            },
            {
                48: [
                    2,
                    468
                ]
            },
            {
                289: [
                    1,
                    610
                ]
            },
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 611
            },
            o($V61, [
                2,
                42
            ]),
            o($Vf2, [
                2,
                304
            ]),
            {
                13: $V9,
                16: $Va,
                55: 414,
                82: $Vy,
                95: 612,
                171: 613,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    614
                ],
                45: $Vo2,
                94: 615
            },
            o($VL1, [
                2,
                129
            ]),
            o($V22, [
                2,
                421
            ]),
            {
                82: [
                    1,
                    616
                ]
            },
            {
                82: [
                    1,
                    617
                ]
            },
            o($Vp2, [
                2,
                296
            ]),
            o($Vp2, [
                2,
                31
            ]),
            o($Vp2, [
                2,
                32
            ]),
            {
                31: [
                    2,
                    17
                ]
            },
            {
                31: [
                    2,
                    276
                ]
            },
            {
                31: [
                    2,
                    18
                ]
            },
            {
                31: [
                    2,
                    278
                ]
            },
            o($Vk, $VP1, {
                155: 330,
                153: 618,
                154: 619,
                29: $Vw2,
                31: $Vw2,
                85: $Vw2,
                112: $Vw2,
                159: $Vw2,
                160: $Vw2,
                161: $Vw2,
                163: $Vw2,
                164: $Vw2
            }),
            o($Vq2, [
                2,
                358
            ]),
            o($Vr2, [
                2,
                75
            ]),
            o($Vr2, [
                2,
                76
            ]),
            {
                29: $Vb1,
                57: 620
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 621,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                366
            ]),
            o($Vr2, [
                2,
                79
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 622,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vr2, [
                2,
                91
            ], {
                336: [
                    1,
                    623
                ]
            }),
            o([
                29,
                31,
                85,
                112,
                159,
                160,
                161,
                163,
                164,
                232,
                318,
                335
            ], [
                2,
                114
            ], {
                207: 624,
                193: [
                    1,
                    625
                ]
            }),
            o($Vu2, [
                2,
                117
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                211: 626,
                212: 627,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($VT1, [
                2,
                134
            ]),
            o($Vb2, [
                2,
                427
            ]),
            o($VT1, [
                2,
                135
            ]),
            o($Vk2, [
                2,
                26
            ]),
            {
                44: 628,
                87: $Vb
            },
            o($Va2, [
                2,
                106
            ]),
            o($Va2, [
                2,
                394
            ]),
            o($Vk, [
                2,
                396
            ]),
            o($Vv2, [
                2,
                111
            ]),
            o($Vv2, [
                2,
                398
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 629,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VU1, [
                2,
                217
            ]),
            o($Vk, $Vr1, {
                144: 248,
                140: 630,
                143: 631,
                31: [
                    2,
                    343
                ]
            }),
            o($VB1, [
                2,
                97
            ]),
            o($VX1, [
                2,
                380
            ]),
            o($VB1, [
                2,
                180
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 632,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 633,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                190
            ]),
            {
                290: [
                    1,
                    634
                ]
            },
            {
                314: [
                    1,
                    635
                ]
            },
            {
                13: $V9,
                16: $Va,
                48: [
                    1,
                    636
                ],
                55: 414,
                82: $Vy,
                171: 637,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            o($Vx2, [
                2,
                305
            ]),
            o($V61, [
                2,
                86
            ]),
            o($Vf2, [
                2,
                374
            ]),
            o($V32, [
                2,
                37
            ]),
            o($V32, [
                2,
                38
            ]),
            o($V62, [
                2,
                72
            ]),
            o($V62, [
                2,
                360
            ]),
            o($Vr2, [
                2,
                77
            ]),
            {
                29: $Vb1,
                57: 638
            },
            {
                47: [
                    1,
                    639
                ]
            },
            {
                29: [
                    2,
                    376
                ]
            },
            o($Vu2, [
                2,
                402
            ]),
            o($Vu2, [
                2,
                115
            ], {
                215: 10,
                208: 528,
                214: 529,
                44: 530,
                205: 640,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            o($Vu2, [
                2,
                118
            ], {
                272: [
                    1,
                    641
                ]
            }),
            o($Vy2, [
                2,
                407
            ], {
                213: 642,
                319: 643,
                317: [
                    1,
                    644
                ]
            }),
            {
                48: [
                    1,
                    645
                ]
            },
            {
                318: [
                    1,
                    646
                ]
            },
            {
                31: [
                    1,
                    647
                ]
            },
            {
                31: [
                    2,
                    344
                ]
            },
            {
                48: [
                    1,
                    648
                ]
            },
            {
                48: [
                    1,
                    649
                ]
            },
            {
                291: 650,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_
            },
            o($Ve2, [
                2,
                218
            ]),
            o($Vf2, [
                2,
                44
            ]),
            o($Vx2, [
                2,
                306
            ]),
            o($Vr2, [
                2,
                78
            ]),
            {
                44: 651,
                87: $Vb
            },
            o($Vu2, [
                2,
                116
            ]),
            o($Vk, [
                2,
                406
            ]),
            o($Vy2, [
                2,
                119
            ]),
            o($Vy2, [
                2,
                408
            ]),
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 652,
                87: $Vb
            }),
            o($Vk2, [
                2,
                27
            ]),
            o($Vv2, [
                2,
                230
            ]),
            o($Vz2, [
                2,
                345
            ], {
                141: 653,
                335: [
                    1,
                    654
                ]
            }),
            o($VB1, [
                2,
                181
            ]),
            o($VB1, [
                2,
                182
            ]),
            {
                48: [
                    2,
                    191
                ]
            },
            {
                48: [
                    1,
                    655
                ]
            },
            {
                318: [
                    1,
                    656
                ]
            },
            o($Vk, $Vr1, {
                144: 248,
                142: 657,
                143: 658,
                31: $VA2,
                112: $VA2
            }),
            o($Vz2, [
                2,
                346
            ]),
            o($Vr2, [
                2,
                80
            ]),
            o($Vy2, [
                2,
                231
            ]),
            o($VW1, [
                2,
                67
            ]),
            o($VW1, [
                2,
                348
            ])
        ],
        defaultActions: {
            5: [
                2,
                240
            ],
            6: [
                2,
                241
            ],
            7: [
                2,
                242
            ],
            9: [
                2,
                239
            ],
            24: [
                2,
                1
            ],
            25: [
                2,
                2
            ],
            26: [
                2,
                244
            ],
            87: [
                2,
                282
            ],
            94: [
                2,
                384
            ],
            100: [
                2,
                45
            ],
            109: [
                2,
                325
            ],
            166: [
                2,
                458
            ],
            263: [
                2,
                439
            ],
            336: [
                2,
                258
            ],
            337: [
                2,
                101
            ],
            487: [
                2,
                461
            ],
            488: [
                2,
                462
            ],
            560: [
                2,
                468
            ],
            574: [
                2,
                17
            ],
            575: [
                2,
                276
            ],
            576: [
                2,
                18
            ],
            577: [
                2,
                278
            ],
            623: [
                2,
                376
            ],
            631: [
                2,
                344
            ],
            650: [
                2,
                191
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function lex() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == 'undefined') symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push('\'' + this.terminals_[p] + '\'');
                    if (lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                    else errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== 'undefined') return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    SPARQL parser in the Jison parser generator format.
  */ var Wildcard = (parcelRequire("4E6EG")).Wildcard;
    // Common namespaces and entities
    var RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', RDF_TYPE = RDF + 'type', RDF_FIRST = RDF + 'first', RDF_REST = RDF + 'rest', RDF_NIL = RDF + 'nil', XSD = 'http://www.w3.org/2001/XMLSchema#', XSD_INTEGER = XSD + 'integer', XSD_DECIMAL = XSD + 'decimal', XSD_DOUBLE = XSD + 'double', XSD_BOOLEAN = XSD + 'boolean';
    var base = '', basePath = '', baseRoot = '';
    // Returns a lowercase version of the given string
    function lowercase(string) {
        return string.toLowerCase();
    }
    // Appends the item to the array and returns the array
    function appendTo(array, item) {
        return array.push(item), array;
    }
    // Appends the items to the array and returns the array
    function appendAllTo(array, items) {
        return array.push.apply(array, items), array;
    }
    // Extends a base object with properties of other objects
    function extend(base) {
        if (!base) base = {};
        for(var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++)for(var name in arg)base[name] = arg[name];
        return base;
    }
    // Creates an array that contains all items of the given arrays
    function unionAll() {
        var union = [];
        for(var i = 0, l = arguments.length; i < l; i++)union = union.concat.apply(union, arguments[i]);
        return union;
    }
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets
        if (iri[0] === '<') iri = iri.substring(1, iri.length - 1);
        // Return absolute IRIs unmodified
        if (/^[a-z][a-z0-9.+-]*:/i.test(iri)) return iri;
        if (!Parser.base) throw new Error('Cannot resolve relative IRI ' + iri + ' because no base IRI was set.');
        if (base !== Parser.base) {
            base = Parser.base;
            basePath = base.replace(/[^\/:]*$/, '');
            baseRoot = base.match(/^(?:[a-z]+:\/*)?[^\/]*/)[0];
        }
        switch(iri[0]){
            // An empty relative IRI indicates the base IRI
            case undefined:
                return base;
            // Resolve relative fragment IRIs against the base IRI
            case '#':
                return base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case '?':
                return base.replace(/(?:\?.*)?$/, iri);
            // Resolve root relative IRIs at the root of the base IRI
            case '/':
                return baseRoot + iri;
            // Resolve all other IRIs at the base IRI's path
            default:
                return basePath + iri;
        }
    }
    // If the item is a variable, ensures it starts with a question mark
    function toVar(variable) {
        if (variable) {
            var first = variable[0];
            if (first === '?' || first === '$') return Parser.factory.variable(variable.substr(1));
        }
        return variable;
    }
    // Creates an operation with the given name and arguments
    function operation(operatorName, args) {
        return {
            type: 'operation',
            operator: operatorName,
            args: args || []
        };
    }
    // Creates an expression with the given type and attributes
    function expression(expr, attr) {
        var expression = {
            expression: expr === '*' ? new Wildcard() : expr
        };
        if (attr) for(var a in attr)expression[a] = attr[a];
        return expression;
    }
    // Creates a path with the given type and items
    function path(type, items) {
        return {
            type: 'path',
            pathType: type,
            items: items
        };
    }
    // Transforms a list of operations types and arguments into a tree of operations
    function createOperationTree(initialExpression, operationList) {
        for(var i = 0, l = operationList.length, item; i < l && (item = operationList[i]); i++)initialExpression = operation(item[0], [
            initialExpression,
            item[1]
        ]);
        return initialExpression;
    }
    // Group datasets by default and named
    function groupDatasets(fromClauses, groupName) {
        var defaults = [], named = [], l = fromClauses.length, fromClause, group = {};
        if (!l) return null;
        for(var i = 0; i < l && (fromClause = fromClauses[i]); i++)(fromClause.named ? named : defaults).push(fromClause.iri);
        group[groupName || 'from'] = {
            "default": defaults,
            named: named
        };
        return group;
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Transforms a possibly single group into its patterns
    function degroupSingle(group) {
        return group.type === 'group' && group.patterns.length === 1 ? group.patterns[0] : group;
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== 'NamedNode') type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    function nestedTriple(subject, predicate, object) {
        // TODO: Remove this when it is caught by the grammar
        if (!('termType' in predicate)) throw new Error('Nested triples cannot contain paths');
        return Parser.factory.quad(subject, predicate, object);
    }
    // Creates a triple with the given subject, predicate, and object
    function triple(subject, predicate, object, annotations) {
        var triple = {};
        if (subject != null) triple.subject = subject;
        if (predicate != null) triple.predicate = predicate;
        if (object != null) triple.object = object;
        if (annotations != null) triple.annotations = annotations;
        return triple;
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === 'string') {
            if (name.startsWith('e_')) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode('e_' + name);
        }
        return Parser.factory.blankNode('g_' + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        '\\': '\\',
        "'": "'",
        '"': '"',
        t: '\t',
        b: '\b',
        n: '\n',
        r: '\r',
        f: '\f'
    }, partialSurrogatesWithoutEndpoint = /[\uD800-\uDBFF]([^\uDC00-\uDFFF]|$)/, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        string = string.substring(trimLength, string.length - trimLength);
        try {
            string = string.replace(escapeSequence, function(sequence, unicode4, unicode8, escapedChar) {
                var charCode;
                if (unicode4) {
                    charCode = parseInt(unicode4, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    return fromCharCode(charCode);
                } else if (unicode8) {
                    charCode = parseInt(unicode8, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    if (charCode < 0xFFFF) return fromCharCode(charCode);
                    return fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
                } else {
                    var replacement = escapeReplacements[escapedChar];
                    if (!replacement) throw new Error();
                    return replacement;
                }
            });
        } catch (error) {
            return '';
        }
        // Test for invalid unicode surrogate pairs
        if (partialSurrogatesWithoutEndpoint.exec(string)) throw new Error('Invalid unicode codepoint of surrogate pair without corresponding codepoint in ' + string);
        return string;
    }
    // Creates a list, collecting its (possibly blank) items and triples associated with those items
    function createList(objects) {
        var list = blank(), head = list, listItems = [], listTriples, triples = [];
        objects.forEach(function(o) {
            listItems.push(o.entity);
            appendAllTo(triples, o.triples);
        });
        // Build an RDF list out of the items
        for(var i = 0, j = 0, l = listItems.length, listTriples = Array(l * 2); i < l;)listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_FIRST), listItems[i]), listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        // Return the list's identifier, its triples, and the triples associated with its items
        return {
            entity: list,
            triples: appendAllTo(listTriples, triples)
        };
    }
    // Creates a blank node identifier, collecting triples with that blank node as subject
    function createAnonymousObject(propertyList) {
        var entity = blank();
        return {
            entity: entity,
            triples: propertyList.map(function(t) {
                return extend(triple(entity), t);
            })
        };
    }
    // Collects all (possibly blank) objects, and triples that have them as subject
    function objectListToTriples(predicate, objectList, otherTriples) {
        var objects = [], triples = [];
        objectList.forEach(function(l) {
            var annotation = null;
            if (l.annotation) {
                annotation = l.annotation;
                l = l.object;
            }
            objects.push(triple(null, predicate, l.entity, annotation));
            appendAllTo(triples, l.triples);
        });
        return unionAll(objects, otherTriples || [], triples);
    }
    // Simplifies groups by merging adjacent BGPs
    function mergeAdjacentBGPs(groups) {
        var merged = [], currentBgp;
        for(var i = 0, group; group = groups[i]; i++)switch(group.type){
            // Add a BGP's triples to the current BGP
            case 'bgp':
                if (group.triples.length) {
                    if (!currentBgp) appendTo(merged, currentBgp = group);
                    else appendAllTo(currentBgp.triples, group.triples);
                }
                break;
            // All other groups break up a BGP
            default:
                // Only add the group if its pattern is non-empty
                if (!group.patterns || group.patterns.length > 0) {
                    appendTo(merged, group);
                    currentBgp = null;
                }
        }
        return merged;
    }
    // Return the id of an expression
    function getExpressionId(expression) {
        return expression.variable ? expression.variable.value : expression.value || expression.expression.value;
    }
    // Get all "aggregate"'s from an expression
    function getAggregatesOfExpression(expression) {
        if (!expression) return [];
        if (expression.type === 'aggregate') return [
            expression
        ];
        else if (expression.type === "operation") {
            var _aggregates;
            var aggregates = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = expression.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var arg = _step.value;
                    (_aggregates = aggregates).push.apply(_aggregates, (0, $7WNf6._)(getAggregatesOfExpression(arg)));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return aggregates;
        }
        return [];
    }
    // Get all variables used in an expression
    function getVariablesFromExpression(expression) {
        var variables = new Set();
        var visitExpression = function visitExpression1(expr) {
            if (!expr) return;
            if (expr.termType === "Variable") variables.add(expr);
            else if (expr.type === "operation") expr.args.forEach(visitExpression);
        };
        visitExpression(expression);
        return variables;
    }
    // Helper function to flatten arrays
    function flatten(input) {
        var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, stack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (depth > 0 && item instanceof Array) flatten(item, depth - 1, stack);
                else stack.push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return stack;
    }
    function isVariable(term) {
        return term.termType === 'Variable';
    }
    function getBoundVarsFromGroupGraphPattern(pattern) {
        if (pattern.triples) {
            var boundVars = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = pattern.triples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var triple = _step.value;
                    if (isVariable(triple.subject)) boundVars.push(triple.subject.value);
                    if (isVariable(triple.predicate)) boundVars.push(triple.predicate.value);
                    if (isVariable(triple.object)) boundVars.push(triple.object.value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return boundVars;
        } else if (pattern.patterns) {
            var _boundVars;
            var boundVars1 = [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = pattern.patterns[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var pat = _step1.value;
                    (_boundVars = boundVars1).push.apply(_boundVars, (0, $7WNf6._)(getBoundVarsFromGroupGraphPattern(pat)));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return boundVars1;
        }
        return [];
    }
    // Helper function to find duplicates in array
    function getDuplicatesInArray(array) {
        var sortedArray = array.slice().sort();
        var duplicates = [];
        for(var i = 0; i < sortedArray.length - 1; i++)if (sortedArray[i + 1] == sortedArray[i]) duplicates.push(sortedArray[i]);
        return duplicates;
    }
    function ensureSparqlStar(value) {
        if (!Parser.sparqlStar) throw new Error('SPARQL-star support is not enabled');
        return value;
    }
    function _applyAnnotations(subject, annotations, arr) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = annotations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var annotation = _step.value;
                var t = triple(// If the annotation already has a subject then just push the
                // annotation to the upper scope as it is a blank node introduced
                // from a pattern like :s :p :o {| :p1 [ :p2 :o2; :p3 :o3 ] |}
                'subject' in annotation ? annotation.subject : subject, annotation.predicate, annotation.object);
                arr.push(t);
                if (annotation.annotations) _applyAnnotations(nestedTriple(subject, annotation.predicate, annotation.object), annotation.annotations, arr);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function applyAnnotations(triples) {
        if (Parser.sparqlStar) {
            var newTriples = [];
            triples.forEach(function(t) {
                var s = triple(t.subject, t.predicate, t.object);
                newTriples.push(s);
                if (t.annotations) _applyAnnotations(nestedTriple(t.subject, t.predicate, t.object), t.annotations, newTriples);
            });
            return newTriples;
        }
        return triples;
    }
    function ensureSparqlStarNestedQuads(value) {
        if (!Parser.sparqlStarNestedQuads) throw new Error('Lenient SPARQL-star support with nested quads is not enabled');
        return value;
    }
    function ensureNoVariables(operations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var operation = _step.value;
                if (operation.type === 'graph' && operation.name.termType === 'Variable') throw new Error('Detected illegal variable in GRAPH');
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (operation.type === 'bgp' || operation.type === 'graph') try {
                    for(var _iterator1 = operation.triples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var triple = _step1.value;
                        if (triple.subject.termType === 'Variable' || triple.predicate.termType === 'Variable' || triple.object.termType === 'Variable') throw new Error('Detected illegal variable in BGP');
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return operations;
    }
    function ensureNoBnodes(operations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var operation = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (operation.type === 'bgp') try {
                    for(var _iterator1 = operation.triples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var triple = _step1.value;
                        if (triple.subject.termType === 'BlankNode' || triple.predicate.termType === 'BlankNode' || triple.object.termType === 'BlankNode') throw new Error('Detected illegal blank node in BGP');
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return operations;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function setInput(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function more() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function test_match(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function next() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                flex: true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 15;
                    case 3:
                        return 41;
                    case 4:
                        return 325;
                    case 5:
                        return 326;
                    case 6:
                        return 45;
                    case 7:
                        return 47;
                    case 8:
                        return 48;
                    case 9:
                        return 39;
                    case 10:
                        return 24;
                    case 11:
                        return 28;
                    case 12:
                        return 29;
                    case 13:
                        return 31;
                    case 14:
                        return 32;
                    case 15:
                        return 36;
                    case 16:
                        return 53;
                    case 17:
                        return 327;
                    case 18:
                        return 63;
                    case 19:
                        return 64;
                    case 20:
                        return 70;
                    case 21:
                        return 73;
                    case 22:
                        return 76;
                    case 23:
                        return 78;
                    case 24:
                        return 81;
                    case 25:
                        return 83;
                    case 26:
                        return 85;
                    case 27:
                        return 193;
                    case 28:
                        return 100;
                    case 29:
                        return 328;
                    case 30:
                        return 121;
                    case 31:
                        return 329;
                    case 32:
                        return 330;
                    case 33:
                        return 110;
                    case 34:
                        return 331;
                    case 35:
                        return 109;
                    case 36:
                        return 332;
                    case 37:
                        return 333;
                    case 38:
                        return 113;
                    case 39:
                        return 115;
                    case 40:
                        return 116;
                    case 41:
                        return 131;
                    case 42:
                        return 123;
                    case 43:
                        return 126;
                    case 44:
                        return 128;
                    case 45:
                        return 132;
                    case 46:
                        return 112;
                    case 47:
                        return 334;
                    case 48:
                        return 335;
                    case 49:
                        return 159;
                    case 50:
                        return 161;
                    case 51:
                        return 164;
                    case 52:
                        return 174;
                    case 53:
                        return 160;
                    case 54:
                        return 336;
                    case 55:
                        return 163;
                    case 56:
                        return 312;
                    case 57:
                        return 314;
                    case 58:
                        return 317;
                    case 59:
                        return 318;
                    case 60:
                        return 272;
                    case 61:
                        return 197;
                    case 62:
                        return 337;
                    case 63:
                        return 338;
                    case 64:
                        return 229;
                    case 65:
                        return 340;
                    case 66:
                        return 263;
                    case 67:
                        return 224;
                    case 68:
                        return 231;
                    case 69:
                        return 232;
                    case 70:
                        return 242;
                    case 71:
                        return 246;
                    case 72:
                        return 290;
                    case 73:
                        return 341;
                    case 74:
                        return 342;
                    case 75:
                        return 343;
                    case 76:
                        return 344;
                    case 77:
                        return 345;
                    case 78:
                        return 250;
                    case 79:
                        return 346;
                    case 80:
                        return 265;
                    case 81:
                        return 276;
                    case 82:
                        return 277;
                    case 83:
                        return 268;
                    case 84:
                        return 269;
                    case 85:
                        return 270;
                    case 86:
                        return 271;
                    case 87:
                        return 347;
                    case 88:
                        return 348;
                    case 89:
                        return 273;
                    case 90:
                        return 274;
                    case 91:
                        return 350;
                    case 92:
                        return 349;
                    case 93:
                        return 351;
                    case 94:
                        return 279;
                    case 95:
                        return 280;
                    case 96:
                        return 283;
                    case 97:
                        return 285;
                    case 98:
                        return 289;
                    case 99:
                        return 293;
                    case 100:
                        return 296;
                    case 101:
                        return 13;
                    case 102:
                        return 16;
                    case 103:
                        return 308;
                    case 104:
                        return 309;
                    case 105:
                        return 87;
                    case 106:
                        return 292;
                    case 107:
                        return 82;
                    case 108:
                        return 294;
                    case 109:
                        return 295;
                    case 110:
                        return 297;
                    case 111:
                        return 298;
                    case 112:
                        return 299;
                    case 113:
                        return 300;
                    case 114:
                        return 301;
                    case 115:
                        return 302;
                    case 116:
                        return 'EXPONENT';
                    case 117:
                        return 303;
                    case 118:
                        return 304;
                    case 119:
                        return 305;
                    case 120:
                        return 306;
                    case 121:
                        return 89;
                    case 122:
                        return 310;
                    case 123:
                        return 6;
                    case 124:
                        return 'INVALID';
                    case 125:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|(#[^\n\r]*))/i,
                /^(?:BASE)/i,
                /^(?:PREFIX)/i,
                /^(?:SELECT)/i,
                /^(?:DISTINCT)/i,
                /^(?:REDUCED)/i,
                /^(?:\()/i,
                /^(?:AS)/i,
                /^(?:\))/i,
                /^(?:\*)/i,
                /^(?:CONSTRUCT)/i,
                /^(?:WHERE)/i,
                /^(?:\{)/i,
                /^(?:\})/i,
                /^(?:DESCRIBE)/i,
                /^(?:ASK)/i,
                /^(?:FROM)/i,
                /^(?:NAMED)/i,
                /^(?:GROUP)/i,
                /^(?:BY)/i,
                /^(?:HAVING)/i,
                /^(?:ORDER)/i,
                /^(?:ASC)/i,
                /^(?:DESC)/i,
                /^(?:LIMIT)/i,
                /^(?:OFFSET)/i,
                /^(?:VALUES)/i,
                /^(?:;)/i,
                /^(?:LOAD)/i,
                /^(?:SILENT)/i,
                /^(?:INTO)/i,
                /^(?:CLEAR)/i,
                /^(?:DROP)/i,
                /^(?:CREATE)/i,
                /^(?:ADD)/i,
                /^(?:TO)/i,
                /^(?:MOVE)/i,
                /^(?:COPY)/i,
                /^(?:INSERT((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)WHERE)/i,
                /^(?:WITH)/i,
                /^(?:DELETE)/i,
                /^(?:INSERT)/i,
                /^(?:USING)/i,
                /^(?:DEFAULT)/i,
                /^(?:GRAPH)/i,
                /^(?:ALL)/i,
                /^(?:\.)/i,
                /^(?:OPTIONAL)/i,
                /^(?:SERVICE)/i,
                /^(?:BIND)/i,
                /^(?:UNDEF)/i,
                /^(?:MINUS)/i,
                /^(?:UNION)/i,
                /^(?:FILTER)/i,
                /^(?:<<)/i,
                /^(?:>>)/i,
                /^(?:\{\|)/i,
                /^(?:\|\})/i,
                /^(?:,)/i,
                /^(?:a)/i,
                /^(?:\|)/i,
                /^(?:\/)/i,
                /^(?:\^)/i,
                /^(?:\?)/i,
                /^(?:\+)/i,
                /^(?:!)/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\|\|)/i,
                /^(?:&&)/i,
                /^(?:=)/i,
                /^(?:!=)/i,
                /^(?:<)/i,
                /^(?:>)/i,
                /^(?:<=)/i,
                /^(?:>=)/i,
                /^(?:IN)/i,
                /^(?:NOT)/i,
                /^(?:-)/i,
                /^(?:BOUND)/i,
                /^(?:BNODE)/i,
                /^(?:(RAND|NOW|UUID|STRUUID))/i,
                /^(?:(LANG|DATATYPE|IRI|URI|ABS|CEIL|FLOOR|ROUND|STRLEN|STR|UCASE|LCASE|ENCODE_FOR_URI|YEAR|MONTH|DAY|HOURS|MINUTES|SECONDS|TIMEZONE|TZ|MD5|SHA1|SHA256|SHA384|SHA512|isIRI|isURI|isBLANK|isLITERAL|isNUMERIC))/i,
                /^(?:(SUBJECT|PREDICATE|OBJECT|isTRIPLE))/i,
                /^(?:(LANGMATCHES|CONTAINS|STRSTARTS|STRENDS|STRBEFORE|STRAFTER|STRLANG|STRDT|sameTerm))/i,
                /^(?:CONCAT)/i,
                /^(?:COALESCE)/i,
                /^(?:IF)/i,
                /^(?:TRIPLE)/i,
                /^(?:REGEX)/i,
                /^(?:SUBSTR)/i,
                /^(?:REPLACE)/i,
                /^(?:EXISTS)/i,
                /^(?:COUNT)/i,
                /^(?:SUM|MIN|MAX|AVG|SAMPLE)/i,
                /^(?:GROUP_CONCAT)/i,
                /^(?:SEPARATOR)/i,
                /^(?:\^\^)/i,
                /^(?:true|false)/i,
                /^(?:(<(?:[^<>\"\{\}\|\^`\\\u0000-\u0020])*>))/i,
                /^(?:((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:)((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|:|[0-9]|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(_:(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?))/i,
                /^(?:([\?\$]((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])*)))/i,
                /^(?:(@[a-zA-Z]+(?:-[a-zA-Z0-9]+)*))/i,
                /^(?:([0-9]+))/i,
                /^(?:([0-9]*\.[0-9]+))/i,
                /^(?:([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+)))/i,
                /^(?:(\+([0-9]+)))/i,
                /^(?:(\+([0-9]*\.[0-9]+)))/i,
                /^(?:(\+([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:(-([0-9]+)))/i,
                /^(?:(-([0-9]*\.[0-9]+)))/i,
                /^(?:(-([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*"""))/i,
                /^(?:(\((\u0020|\u0009|\u000D|\u000A)*\)))/i,
                /^(?:(\[(\u0020|\u0009|\u000D|\u000A)*\]))/i,
                /^(?:$)/i,
                /^(?:.)/i,
                /^(?:.)/i
            ],
            conditions: {
                INITIAL: {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        59,
                        60,
                        61,
                        62,
                        63,
                        64,
                        65,
                        66,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        75,
                        76,
                        77,
                        78,
                        79,
                        80,
                        81,
                        82,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        91,
                        92,
                        93,
                        94,
                        95,
                        96,
                        97,
                        98,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        107,
                        108,
                        109,
                        110,
                        111,
                        112,
                        113,
                        114,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        123,
                        124,
                        125
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
module.exports = $55642f91fd8759e1$var$SparqlParser;

});
parcelRegister("4E6EG", function(module, exports) {

$parcel$export(module.exports, "Wildcard", function () { return $36200f6d505448da$export$10fd9b2de72cfe8c; }, function (v) { return $36200f6d505448da$export$10fd9b2de72cfe8c = v; });
// Wildcard constructor

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
var $36200f6d505448da$export$10fd9b2de72cfe8c;
var $36200f6d505448da$var$Wildcard = /*#__PURE__*/ function() {
    "use strict";
    function Wildcard() {
        (0, $jGAMp._)(this, Wildcard);
        return $36200f6d505448da$var$WILDCARD || this;
    }
    (0, $byiyg._)(Wildcard, [
        {
            key: "equals",
            value: function equals(other) {
                return other && this.termType === other.termType;
            }
        }
    ]);
    return Wildcard;
}();
Object.defineProperty($36200f6d505448da$var$Wildcard.prototype, 'value', {
    enumerable: true,
    value: '*'
});
Object.defineProperty($36200f6d505448da$var$Wildcard.prototype, 'termType', {
    enumerable: true,
    value: 'Wildcard'
});
// Wildcard singleton
var $36200f6d505448da$var$WILDCARD = new $36200f6d505448da$var$Wildcard();
$36200f6d505448da$export$10fd9b2de72cfe8c = $36200f6d505448da$var$Wildcard;

});


parcelRegister("XAnrW", function(module, exports) {
var $0b31ba8fac66f9c6$var$XSD_INTEGER = 'http://www.w3.org/2001/XMLSchema#integer';
var $0b31ba8fac66f9c6$var$XSD_STRING = 'http://www.w3.org/2001/XMLSchema#string';
function $0b31ba8fac66f9c6$var$Generator(options) {
    this._options = options = options || {};
    var prefixes = options.prefixes || {};
    this._prefixByIri = {};
    var prefixIris = [];
    for(var prefix in prefixes){
        var iri = prefixes[prefix];
        if ($0b31ba8fac66f9c6$var$isString(iri)) {
            this._prefixByIri[iri] = prefix;
            prefixIris.push(iri);
        }
    }
    var iriList = prefixIris.join('|').replace(/[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
    this._prefixRegex = new RegExp('^(' + iriList + ')([a-zA-Z][\\-_a-zA-Z0-9]*)$');
    this._usedPrefixes = {};
    this._sparqlStar = options.sparqlStar;
    this._indent = $0b31ba8fac66f9c6$var$isString(options.indent) ? options.indent : '  ';
    this._newline = $0b31ba8fac66f9c6$var$isString(options.newline) ? options.newline : '\n';
    this._explicitDatatype = Boolean(options.explicitDatatype);
}
// Converts the parsed query object into a SPARQL query
$0b31ba8fac66f9c6$var$Generator.prototype.toQuery = function(q) {
    var query = '';
    if (q.queryType) query += q.queryType.toUpperCase() + ' ';
    if (q.reduced) query += 'REDUCED ';
    if (q.distinct) query += 'DISTINCT ';
    if (q.variables) query += $0b31ba8fac66f9c6$var$mapJoin(q.variables, undefined, function(variable) {
        // String variable
        if (/^[?$]/.test(variable)) return variable;
        else if ($0b31ba8fac66f9c6$var$isTerm(variable)) return this.toEntity(variable);
        else return '(' + this.toExpression(variable.expression) + ' AS ' + $0b31ba8fac66f9c6$var$variableToString(variable.variable) + ')';
    }, this) + ' ';
    else if (q.template) query += this.group(q.template, true) + this._newline;
    if (q.from) query += this.graphs('FROM ', q.from["default"]) + this.graphs('FROM NAMED ', q.from.named);
    if (q.where) query += 'WHERE ' + this.group(q.where, true) + this._newline;
    if (q.updates) query += $0b31ba8fac66f9c6$var$mapJoin(q.updates, ';' + this._newline, this.toUpdate, this);
    if (q.group) query += 'GROUP BY ' + $0b31ba8fac66f9c6$var$mapJoin(q.group, undefined, function(it) {
        var result = $0b31ba8fac66f9c6$var$isTerm(it.expression) ? this.toEntity(it.expression) : '(' + this.toExpression(it.expression) + ')';
        return it.variable ? '(' + result + ' AS ' + $0b31ba8fac66f9c6$var$variableToString(it.variable) + ')' : result;
    }, this) + this._newline;
    if (q.having) query += 'HAVING (' + $0b31ba8fac66f9c6$var$mapJoin(q.having, undefined, this.toExpression, this) + ')' + this._newline;
    if (q.order) query += 'ORDER BY ' + $0b31ba8fac66f9c6$var$mapJoin(q.order, undefined, function(it) {
        var expr = '(' + this.toExpression(it.expression) + ')';
        return !it.descending ? expr : 'DESC ' + expr;
    }, this) + this._newline;
    if (q.offset) query += 'OFFSET ' + q.offset + this._newline;
    if (q.limit) query += 'LIMIT ' + q.limit + this._newline;
    if (q.values) query += this.values(q);
    // stringify prefixes at the end to mark used ones
    query = this.baseAndPrefixes(q) + query;
    return query.trim();
};
$0b31ba8fac66f9c6$var$Generator.prototype.baseAndPrefixes = function(q) {
    var base = q.base ? 'BASE <' + q.base + '>' + this._newline : '';
    var prefixes = '';
    for(var key in q.prefixes)if (this._options.allPrefixes || this._usedPrefixes[key]) prefixes += 'PREFIX ' + key + ': <' + q.prefixes[key] + '>' + this._newline;
    return base + prefixes;
};
// Converts the parsed SPARQL pattern into a SPARQL pattern
$0b31ba8fac66f9c6$var$Generator.prototype.toPattern = function(pattern) {
    var type = pattern.type || pattern instanceof Array && 'array' || (pattern.subject && pattern.predicate && pattern.object ? 'triple' : '');
    if (!(type in this)) throw new Error('Unknown entry type: ' + type);
    return this[type](pattern);
};
$0b31ba8fac66f9c6$var$Generator.prototype.triple = function(t) {
    return this.toEntity(t.subject) + ' ' + this.toEntity(t.predicate) + ' ' + this.toEntity(t.object) + '.';
};
$0b31ba8fac66f9c6$var$Generator.prototype.array = function(items) {
    return $0b31ba8fac66f9c6$var$mapJoin(items, this._newline, this.toPattern, this);
};
$0b31ba8fac66f9c6$var$Generator.prototype.bgp = function(bgp) {
    return this.encodeTriples(bgp.triples);
};
$0b31ba8fac66f9c6$var$Generator.prototype.encodeTriples = function(triples) {
    if (!triples.length) return '';
    var parts = [], subject = undefined, predicate = undefined;
    for(var i = 0; i < triples.length; i++){
        var triple = triples[i];
        // Triple with different subject
        if (!$0b31ba8fac66f9c6$var$equalTerms(triple.subject, subject)) {
            // Terminate previous triple
            if (subject) parts.push('.' + this._newline);
            subject = triple.subject;
            predicate = triple.predicate;
            parts.push(this.toEntity(subject), ' ', this.toEntity(predicate));
        } else if (!$0b31ba8fac66f9c6$var$equalTerms(triple.predicate, predicate)) {
            predicate = triple.predicate;
            parts.push(';' + this._newline, this._indent, this.toEntity(predicate));
        } else parts.push(',');
        parts.push(' ', this.toEntity(triple.object));
    }
    parts.push('.');
    return parts.join('');
};
$0b31ba8fac66f9c6$var$Generator.prototype.graph = function(graph) {
    return 'GRAPH ' + this.toEntity(graph.name) + ' ' + this.group(graph);
};
$0b31ba8fac66f9c6$var$Generator.prototype.graphs = function(keyword, graphs) {
    return !graphs || graphs.length === 0 ? '' : $0b31ba8fac66f9c6$var$mapJoin(graphs, '', function(g) {
        return keyword + this.toEntity(g) + this._newline;
    }, this);
};
$0b31ba8fac66f9c6$var$Generator.prototype.group = function(group, inline) {
    group = inline !== true ? this.array(group.patterns || group.triples) : this.toPattern(group.type !== 'group' ? group : group.patterns);
    return group.indexOf(this._newline) === -1 ? '{ ' + group + ' }' : '{' + this._newline + this.indent(group) + this._newline + '}';
};
$0b31ba8fac66f9c6$var$Generator.prototype.query = function(query) {
    return this.toQuery(query);
};
$0b31ba8fac66f9c6$var$Generator.prototype.filter = function(filter) {
    return 'FILTER(' + this.toExpression(filter.expression) + ')';
};
$0b31ba8fac66f9c6$var$Generator.prototype.bind = function(bind) {
    return 'BIND(' + this.toExpression(bind.expression) + ' AS ' + $0b31ba8fac66f9c6$var$variableToString(bind.variable) + ')';
};
$0b31ba8fac66f9c6$var$Generator.prototype.optional = function(optional) {
    return 'OPTIONAL ' + this.group(optional);
};
$0b31ba8fac66f9c6$var$Generator.prototype.union = function(union) {
    return $0b31ba8fac66f9c6$var$mapJoin(union.patterns, this._newline + 'UNION' + this._newline, function(p) {
        return this.group(p, true);
    }, this);
};
$0b31ba8fac66f9c6$var$Generator.prototype.minus = function(minus) {
    return 'MINUS ' + this.group(minus);
};
$0b31ba8fac66f9c6$var$Generator.prototype.values = function(valuesList) {
    // Gather unique keys
    var keys = Object.keys(valuesList.values.reduce(function(keyHash, values) {
        for(var key in values)keyHash[key] = true;
        return keyHash;
    }, {}));
    // Check whether simple syntax can be used
    var lparen, rparen;
    if (keys.length === 1) lparen = rparen = '';
    else {
        lparen = '(';
        rparen = ')';
    }
    // Create value rows
    return 'VALUES ' + lparen + keys.join(' ') + rparen + ' {' + this._newline + $0b31ba8fac66f9c6$var$mapJoin(valuesList.values, this._newline, function(values) {
        return '  ' + lparen + $0b31ba8fac66f9c6$var$mapJoin(keys, undefined, function(key) {
            return values[key] ? this.toEntity(values[key]) : 'UNDEF';
        }, this) + rparen;
    }, this) + this._newline + '}';
};
$0b31ba8fac66f9c6$var$Generator.prototype.service = function(service) {
    return 'SERVICE ' + (service.silent ? 'SILENT ' : '') + this.toEntity(service.name) + ' ' + this.group(service);
};
// Converts the parsed expression object into a SPARQL expression
$0b31ba8fac66f9c6$var$Generator.prototype.toExpression = function(expr) {
    if ($0b31ba8fac66f9c6$var$isTerm(expr)) return this.toEntity(expr);
    switch(expr.type.toLowerCase()){
        case 'aggregate':
            return expr.aggregation.toUpperCase() + '(' + (expr.distinct ? 'DISTINCT ' : '') + this.toExpression(expr.expression) + (typeof expr.separator === 'string' ? '; SEPARATOR = "' + expr.separator.replace($0b31ba8fac66f9c6$var$escape, $0b31ba8fac66f9c6$var$escapeReplacer) + '"' : '') + ')';
        case 'functioncall':
            return this.toEntity(expr["function"]) + '(' + $0b31ba8fac66f9c6$var$mapJoin(expr.args, ', ', this.toExpression, this) + ')';
        case 'operation':
            var operator = expr.operator.toUpperCase(), args = expr.args || [];
            switch(expr.operator.toLowerCase()){
                // Infix operators
                case '<':
                case '>':
                case '>=':
                case '<=':
                case '&&':
                case '||':
                case '=':
                case '!=':
                case '+':
                case '-':
                case '*':
                case '/':
                    return ($0b31ba8fac66f9c6$var$isTerm(args[0]) ? this.toEntity(args[0]) : '(' + this.toExpression(args[0]) + ')') + ' ' + operator + ' ' + ($0b31ba8fac66f9c6$var$isTerm(args[1]) ? this.toEntity(args[1]) : '(' + this.toExpression(args[1]) + ')');
                // Unary operators
                case '!':
                    return '!(' + this.toExpression(args[0]) + ')';
                case 'uplus':
                    return '+(' + this.toExpression(args[0]) + ')';
                case 'uminus':
                    return '-(' + this.toExpression(args[0]) + ')';
                // IN and NOT IN
                case 'notin':
                    operator = 'NOT IN';
                case 'in':
                    return this.toExpression(args[0]) + ' ' + operator + '(' + ($0b31ba8fac66f9c6$var$isString(args[1]) ? args[1] : $0b31ba8fac66f9c6$var$mapJoin(args[1], ', ', this.toExpression, this)) + ')';
                // EXISTS and NOT EXISTS
                case 'notexists':
                    operator = 'NOT EXISTS';
                case 'exists':
                    return operator + ' ' + this.group(args[0], true);
                // Other expressions
                default:
                    return operator + '(' + $0b31ba8fac66f9c6$var$mapJoin(args, ', ', this.toExpression, this) + ')';
            }
        default:
            throw new Error('Unknown expression type: ' + expr.type);
    }
};
// Converts the parsed entity (or property path) into a SPARQL entity
$0b31ba8fac66f9c6$var$Generator.prototype.toEntity = function(value) {
    if ($0b31ba8fac66f9c6$var$isTerm(value)) switch(value.termType){
        // variable, * selector, or blank node
        case 'Wildcard':
            return '*';
        case 'Variable':
            return $0b31ba8fac66f9c6$var$variableToString(value);
        case 'BlankNode':
            return '_:' + value.value;
        // literal
        case 'Literal':
            var lexical = value.value || '', language = value.language || '', datatype = value.datatype;
            value = '"' + lexical.replace($0b31ba8fac66f9c6$var$escape, $0b31ba8fac66f9c6$var$escapeReplacer) + '"';
            if (language) value += '@' + language;
            else if (datatype) {
                // Abbreviate literals when possible
                if (!this._explicitDatatype) switch(datatype.value){
                    case $0b31ba8fac66f9c6$var$XSD_STRING:
                        return value;
                    case $0b31ba8fac66f9c6$var$XSD_INTEGER:
                        if (/^\d+$/.test(lexical)) // Add space to avoid confusion with decimals in broken parsers
                        return lexical + ' ';
                }
                value += '^^' + this.encodeIRI(datatype.value);
            }
            return value;
        case 'Quad':
            if (!this._sparqlStar) throw new Error('SPARQL* support is not enabled');
            if (value.graph && value.graph.termType !== "DefaultGraph") return '<< GRAPH ' + this.toEntity(value.graph) + ' { ' + this.toEntity(value.subject) + ' ' + this.toEntity(value.predicate) + ' ' + this.toEntity(value.object) + ' } ' + ' >>';
            else return '<< ' + this.toEntity(value.subject) + ' ' + this.toEntity(value.predicate) + ' ' + this.toEntity(value.object) + ' >>';
        // IRI
        default:
            return this.encodeIRI(value.value);
    }
    else {
        var items = value.items.map(this.toEntity, this), path = value.pathType;
        switch(path){
            // prefix operator
            case '^':
            case '!':
                return path + items[0];
            // postfix operator
            case '*':
            case '+':
            case '?':
                return '(' + items[0] + path + ')';
            // infix operator
            default:
                return '(' + items.join(path) + ')';
        }
    }
};
var $0b31ba8fac66f9c6$var$escape = /["\\\t\n\r\b\f]/g, $0b31ba8fac66f9c6$var$escapeReplacer = function escapeReplacer(c) {
    return $0b31ba8fac66f9c6$var$escapeReplacements[c];
}, $0b31ba8fac66f9c6$var$escapeReplacements = {
    '\\': '\\\\',
    '"': '\\"',
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '\b': '\\b',
    '\f': '\\f'
};
// Represent the IRI, as a prefixed name when possible
$0b31ba8fac66f9c6$var$Generator.prototype.encodeIRI = function(iri) {
    var prefixMatch = this._prefixRegex.exec(iri);
    if (prefixMatch) {
        var prefix = this._prefixByIri[prefixMatch[1]];
        this._usedPrefixes[prefix] = true;
        return prefix + ':' + prefixMatch[2];
    }
    return '<' + iri + '>';
};
// Converts the parsed update object into a SPARQL update clause
$0b31ba8fac66f9c6$var$Generator.prototype.toUpdate = function(update) {
    switch(update.type || update.updateType){
        case 'load':
            return 'LOAD' + (update.source ? ' ' + this.toEntity(update.source) : '') + (update.destination ? ' INTO GRAPH ' + this.toEntity(update.destination) : '');
        case 'insert':
            return 'INSERT DATA ' + this.group(update.insert, true);
        case 'delete':
            return 'DELETE DATA ' + this.group(update["delete"], true);
        case 'deletewhere':
            return 'DELETE WHERE ' + this.group(update["delete"], true);
        case 'insertdelete':
            return (update.graph ? 'WITH ' + this.toEntity(update.graph) + this._newline : '') + (update["delete"].length ? 'DELETE ' + this.group(update["delete"], true) + this._newline : '') + (update.insert.length ? 'INSERT ' + this.group(update.insert, true) + this._newline : '') + (update.using ? this.graphs('USING ', update.using["default"]) : '') + (update.using ? this.graphs('USING NAMED ', update.using.named) : '') + 'WHERE ' + this.group(update.where, true);
        case 'add':
        case 'copy':
        case 'move':
            return update.type.toUpperCase() + ' ' + (update.silent ? 'SILENT ' : '') + (update.source["default"] ? 'DEFAULT' : this.toEntity(update.source.name)) + ' TO ' + this.toEntity(update.destination.name);
        case 'create':
        case 'clear':
        case 'drop':
            return update.type.toUpperCase() + (update.silent ? ' SILENT ' : ' ') + (update.graph["default"] ? 'DEFAULT' : update.graph.named ? 'NAMED' : update.graph.all ? 'ALL' : 'GRAPH ' + this.toEntity(update.graph.name));
        default:
            throw new Error('Unknown update query type: ' + update.type);
    }
};
// Indents each line of the string
$0b31ba8fac66f9c6$var$Generator.prototype.indent = function(text) {
    return text.replace(/^/gm, this._indent);
};
function $0b31ba8fac66f9c6$var$variableToString(variable) {
    return '?' + variable.value;
}
// Checks whether the object is a string
function $0b31ba8fac66f9c6$var$isString(object) {
    return typeof object === 'string';
}
// Checks whether the object is a Term
function $0b31ba8fac66f9c6$var$isTerm(object) {
    return typeof object.termType === 'string';
}
// Checks whether term1 and term2 are equivalent without `.equals()` prototype method
function $0b31ba8fac66f9c6$var$equalTerms(term1, term2) {
    if (!term1 || !$0b31ba8fac66f9c6$var$isTerm(term1)) return false;
    if (!term2 || !$0b31ba8fac66f9c6$var$isTerm(term2)) return false;
    if (term1.termType !== term2.termType) return false;
    switch(term1.termType){
        case 'Literal':
            return term1.value === term2.value && term1.language === term2.language && $0b31ba8fac66f9c6$var$equalTerms(term1.datatype, term2.datatype);
        case 'Quad':
            return $0b31ba8fac66f9c6$var$equalTerms(term1.subject, term2.subject) && $0b31ba8fac66f9c6$var$equalTerms(term1.predicate, term2.predicate) && $0b31ba8fac66f9c6$var$equalTerms(term1.object, term2.object) && $0b31ba8fac66f9c6$var$equalTerms(term1.graph, term2.graph);
        default:
            return term1.value === term2.value;
    }
}
// Maps the array with the given function, and joins the results using the separator
function $0b31ba8fac66f9c6$var$mapJoin(array, sep, func, self) {
    return array.map(func, self).join($0b31ba8fac66f9c6$var$isString(sep) ? sep : ' ');
}
/**
 * @param options {
 *   allPrefixes: boolean,
 *   indentation: string,
 *   newline: string
 * }
 */ function $0b31ba8fac66f9c6$var$_Generator() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        stringify: function stringify(query) {
            var currentOptions = Object.create(options);
            currentOptions.prefixes = query.prefixes;
            return new $0b31ba8fac66f9c6$var$Generator(currentOptions).toQuery(query);
        },
        createGenerator: function createGenerator() {
            return new $0b31ba8fac66f9c6$var$Generator(options);
        }
    };
}
module.exports = {
    Generator: $0b31ba8fac66f9c6$var$_Generator
};

});



parcelRegister("7qBOV", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
var $56884c6cb5d6b3c9$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2utmd = parcelRequire("2utmd");

var $56884c6cb5d6b3c9$var$factory_1 = $56884c6cb5d6b3c9$var$__importDefault((parcelRequire("3btxo")));

var $ilNtL = parcelRequire("ilNtL");
var $56884c6cb5d6b3c9$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "flatten",
            value: /**
     * Flattens an array of arrays to an array.
     * @param arr - Array of arrays
     */ function flatten(arr) {
                var _Array_prototype;
                return (_Array_prototype = Array.prototype).concat.apply(_Array_prototype, (0, $7WNf6._)(arr)).filter(function(x) {
                    return x;
                });
            }
        },
        {
            key: "objectify",
            value: /**
     * Outputs a JSON object corresponding to the input algebra-like.
     */ function objectify(algebra) {
                if (algebra.termType) {
                    if (algebra.termType === 'Quad') return {
                        type: 'pattern',
                        termType: 'Quad',
                        subject: Util.objectify(algebra.subject),
                        predicate: Util.objectify(algebra.predicate),
                        object: Util.objectify(algebra.object),
                        graph: Util.objectify(algebra.graph)
                    };
                    else {
                        var result = {
                            termType: algebra.termType,
                            value: algebra.value
                        };
                        if (algebra.language) result.language = algebra.language;
                        if (algebra.datatype) result.datatype = Util.objectify(algebra.datatype);
                        return result;
                    }
                }
                if (Array.isArray(algebra)) return algebra.map(function(e) {
                    return Util.objectify(e);
                });
                if (algebra === Object(algebra)) {
                    var result1 = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(algebra)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            result1[key] = Util.objectify(algebra[key]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return result1;
                }
                return algebra;
            }
        },
        {
            key: "inScopeVariables",
            value: /**
     * Detects all in-scope variables.
     * In practice this means iterating through the entire algebra tree, finding all variables,
     * and stopping when a project function is found.
     * @param {Operation} op - Input algebra tree.
     * @returns {Variable[]} - List of unique in-scope variables.
     */ function inScopeVariables(op) {
                var variables = [];
                function addVariable(v) {
                    if (!variables.find(function(v2) {
                        return v.value === v2.value;
                    })) variables.push(v);
                }
                function recurseTerm(quad) {
                    if (quad.subject.termType === 'Variable') addVariable(quad.subject);
                    if (quad.predicate.termType === 'Variable') addVariable(quad.predicate);
                    if (quad.object.termType === 'Variable') addVariable(quad.object);
                    if (quad.graph.termType === 'Variable') addVariable(quad.graph);
                    if (quad.subject.termType === 'Quad') recurseTerm(quad.subject);
                    if (quad.predicate.termType === 'Quad') recurseTerm(quad.predicate);
                    if (quad.object.termType === 'Quad') recurseTerm(quad.object);
                    if (quad.graph.termType === 'Quad') recurseTerm(quad.graph);
                }
                var _obj;
                // https://www.w3.org/TR/sparql11-query/#variableScope
                Util.recurseOperation(op, (_obj = {}, (0, $cqEAj._)(_obj, $2utmd.types.EXPRESSION, function(op) {
                    if (op.expressionType === $2utmd.expressionTypes.AGGREGATE && op.variable) addVariable(op.variable);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.EXTEND, function(op) {
                    addVariable(op.variable);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.GRAPH, function(op) {
                    if (op.name.termType === 'Variable') addVariable(op.name);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.GROUP, function(op) {
                    op.variables.forEach(addVariable);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.PATH, function(op) {
                    if (op.subject.termType === 'Variable') addVariable(op.subject);
                    if (op.object.termType === 'Variable') addVariable(op.object);
                    if (op.graph.termType === 'Variable') addVariable(op.graph);
                    if (op.subject.termType === 'Quad') recurseTerm(op.subject);
                    if (op.object.termType === 'Quad') recurseTerm(op.object);
                    if (op.graph.termType === 'Quad') recurseTerm(op.graph);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.PATTERN, function(op) {
                    recurseTerm(op);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.PROJECT, function(op) {
                    op.variables.forEach(addVariable);
                    return false;
                }), (0, $cqEAj._)(_obj, $2utmd.types.SERVICE, function(op) {
                    if (op.name.termType === 'Variable') addVariable(op.name);
                    return true;
                }), (0, $cqEAj._)(_obj, $2utmd.types.VALUES, function(op) {
                    op.variables.forEach(addVariable);
                    return true;
                }), _obj));
                return variables;
            }
        },
        {
            key: "recurseOperation",
            value: /**
     * Recurses through the given algebra tree
     * A map of callback functions can be provided for individual Operation types to gather data.
     * The return value of those callbacks should indicate whether recursion should be applied or not.
     * Making modifications will change the original input object.
     * @param {Operation} op - The Operation to recurse on.
     * @param { [type: string]: (op: Operation) => boolean } callbacks - A map of required callback Operations.
     */ function recurseOperation(op, callbacks) {
                var result = op;
                var doRecursion = true;
                var callback = callbacks[op.type];
                if (callback) // Not sure how to get typing correct for op here
                doRecursion = callback(op);
                if (!doRecursion) return;
                var recurseOp = function(op) {
                    return Util.recurseOperation(op, callbacks);
                };
                switch(result.type){
                    case $2utmd.types.ALT:
                        result.input.map(recurseOp);
                        break;
                    case $2utmd.types.ASK:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.BGP:
                        result.patterns.forEach(recurseOp);
                        break;
                    case $2utmd.types.CONSTRUCT:
                        recurseOp(result.input);
                        result.template.map(recurseOp);
                        break;
                    case $2utmd.types.DESCRIBE:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.DISTINCT:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.EXPRESSION:
                        if (result.expressionType === $2utmd.expressionTypes.EXISTENCE) recurseOp(result.input);
                        break;
                    case $2utmd.types.EXTEND:
                        recurseOp(result.input);
                        recurseOp(result.expression);
                        break;
                    case $2utmd.types.FILTER:
                        recurseOp(result.input);
                        recurseOp(result.expression);
                        break;
                    case $2utmd.types.FROM:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.GRAPH:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.GROUP:
                        recurseOp(result.input);
                        result.aggregates.forEach(recurseOp);
                        break;
                    case $2utmd.types.INV:
                        recurseOp(result.path);
                        break;
                    case $2utmd.types.JOIN:
                        result.input.map(recurseOp);
                        break;
                    case $2utmd.types.LEFT_JOIN:
                        result.input.map(recurseOp);
                        if (result.expression) recurseOp(result.expression);
                        break;
                    case $2utmd.types.LINK:
                        break;
                    case $2utmd.types.MINUS:
                        result.input.map(recurseOp);
                        break;
                    case $2utmd.types.NOP:
                        break;
                    case $2utmd.types.NPS:
                        break;
                    case $2utmd.types.ONE_OR_MORE_PATH:
                        recurseOp(result.path);
                        break;
                    case $2utmd.types.ORDER_BY:
                        recurseOp(result.input);
                        result.expressions.forEach(recurseOp);
                        break;
                    case $2utmd.types.PATH:
                        recurseOp(result.predicate);
                        break;
                    case $2utmd.types.PATTERN:
                        break;
                    case $2utmd.types.PROJECT:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.REDUCED:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.SEQ:
                        result.input.map(recurseOp);
                        break;
                    case $2utmd.types.SERVICE:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.SLICE:
                        recurseOp(result.input);
                        break;
                    case $2utmd.types.UNION:
                        result.input.map(recurseOp);
                        break;
                    case $2utmd.types.VALUES:
                        break;
                    case $2utmd.types.ZERO_OR_MORE_PATH:
                        recurseOp(result.path);
                        break;
                    case $2utmd.types.ZERO_OR_ONE_PATH:
                        recurseOp(result.path);
                        break;
                    // UPDATE operations
                    case $2utmd.types.COMPOSITE_UPDATE:
                        result.updates.forEach(function(update) {
                            return recurseOp(update);
                        });
                        break;
                    case $2utmd.types.DELETE_INSERT:
                        if (result["delete"]) result["delete"].forEach(function(pattern) {
                            return recurseOp(pattern);
                        });
                        if (result.insert) result.insert.forEach(function(pattern) {
                            return recurseOp(pattern);
                        });
                        if (result.where) recurseOp(result.where);
                        break;
                    // all of these only have graph IDs as values
                    case $2utmd.types.LOAD:
                        break;
                    case $2utmd.types.CLEAR:
                        break;
                    case $2utmd.types.CREATE:
                        break;
                    case $2utmd.types.DROP:
                        break;
                    case $2utmd.types.ADD:
                        break;
                    case $2utmd.types.MOVE:
                        break;
                    case $2utmd.types.COPY:
                        break;
                    default:
                        throw new Error("Unknown Operation type ".concat(result.type));
                }
            }
        },
        {
            key: "mapOperation",
            value: /**
     * Creates a deep copy of the given Operation.
     * Creates shallow copies of the non-Operation values.
     * A map of callback functions can be provided for individual Operation types
     * to specifically modify the given objects before triggering recursion.
     * The return value of those callbacks should indicate whether recursion should be applied to this returned object or not.
     * @param {Operation} op - The Operation to recurse on.
     * @param callbacks - A map of required callback Operations.
     * @param {Factory} factory - Factory used to create new Operations. Will use default factory if none is provided.
     * @returns {Operation} - The copied result.
     */ function mapOperation(op, callbacks, factory) {
                var result = op;
                var doRecursion = true;
                var copyMetadata = true;
                factory = factory || new $56884c6cb5d6b3c9$var$factory_1["default"]();
                var callback = callbacks[op.type];
                if (callback) {
                    // Not sure how to get typing correct for op here
                    var recurseResult = callback(op, factory);
                    result = recurseResult.result;
                    doRecursion = recurseResult.recurse;
                    copyMetadata = recurseResult.copyMetadata !== false;
                }
                var toCopyMetadata;
                if (copyMetadata && (result.metadata || op.metadata)) toCopyMetadata = (0, $iT0je._)({}, result.metadata, op.metadata);
                if (!doRecursion) {
                    // Inherit metadata
                    if (toCopyMetadata) result.metadata = toCopyMetadata;
                    return result;
                }
                var mapOp = function(op) {
                    return Util.mapOperation(op, callbacks, factory);
                };
                // Several casts here might be wrong though depending on the callbacks output
                switch(result.type){
                    case $2utmd.types.ALT:
                        result = factory.createAlt(result.input.map(mapOp));
                        break;
                    case $2utmd.types.ASK:
                        result = factory.createAsk(mapOp(result.input));
                        break;
                    case $2utmd.types.BGP:
                        result = factory.createBgp(result.patterns.map(mapOp));
                        break;
                    case $2utmd.types.CONSTRUCT:
                        result = factory.createConstruct(mapOp(result.input), result.template.map(mapOp));
                        break;
                    case $2utmd.types.DESCRIBE:
                        result = factory.createDescribe(mapOp(result.input), result.terms);
                        break;
                    case $2utmd.types.DISTINCT:
                        result = factory.createDistinct(mapOp(result.input));
                        break;
                    case $2utmd.types.EXPRESSION:
                        result = Util.mapExpression(result, callbacks, factory);
                        break;
                    case $2utmd.types.EXTEND:
                        result = factory.createExtend(mapOp(result.input), result.variable, mapOp(result.expression));
                        break;
                    case $2utmd.types.FILTER:
                        result = factory.createFilter(mapOp(result.input), mapOp(result.expression));
                        break;
                    case $2utmd.types.FROM:
                        result = factory.createFrom(mapOp(result.input), (0, $7WNf6._)(result["default"]), (0, $7WNf6._)(result.named));
                        break;
                    case $2utmd.types.GRAPH:
                        result = factory.createGraph(mapOp(result.input), result.name);
                        break;
                    case $2utmd.types.GROUP:
                        result = factory.createGroup(mapOp(result.input), [].concat(result.variables), result.aggregates.map(mapOp));
                        break;
                    case $2utmd.types.INV:
                        result = factory.createInv(mapOp(result.path));
                        break;
                    case $2utmd.types.JOIN:
                        result = factory.createJoin(result.input.map(mapOp));
                        break;
                    case $2utmd.types.LEFT_JOIN:
                        result = factory.createLeftJoin(mapOp(result.input[0]), mapOp(result.input[1]), result.expression ? mapOp(result.expression) : undefined);
                        break;
                    case $2utmd.types.LINK:
                        result = factory.createLink(result.iri);
                        break;
                    case $2utmd.types.MINUS:
                        result = factory.createMinus(mapOp(result.input[0]), mapOp(result.input[1]));
                        break;
                    case $2utmd.types.NOP:
                        result = factory.createNop();
                        break;
                    case $2utmd.types.NPS:
                        result = factory.createNps([].concat(result.iris));
                        break;
                    case $2utmd.types.ONE_OR_MORE_PATH:
                        result = factory.createOneOrMorePath(mapOp(result.path));
                        break;
                    case $2utmd.types.ORDER_BY:
                        result = factory.createOrderBy(mapOp(result.input), result.expressions.map(mapOp));
                        break;
                    case $2utmd.types.PATH:
                        result = factory.createPath(result.subject, mapOp(result.predicate), result.object, result.graph);
                        break;
                    case $2utmd.types.PATTERN:
                        result = factory.createPattern(result.subject, result.predicate, result.object, result.graph);
                        break;
                    case $2utmd.types.PROJECT:
                        result = factory.createProject(mapOp(result.input), (0, $7WNf6._)(result.variables));
                        break;
                    case $2utmd.types.REDUCED:
                        result = factory.createReduced(mapOp(result.input));
                        break;
                    case $2utmd.types.SEQ:
                        result = factory.createSeq(result.input.map(mapOp));
                        break;
                    case $2utmd.types.SERVICE:
                        result = factory.createService(mapOp(result.input), result.name, result.silent);
                        break;
                    case $2utmd.types.SLICE:
                        result = factory.createSlice(mapOp(result.input), result.start, result.length);
                        break;
                    case $2utmd.types.UNION:
                        result = factory.createUnion(result.input.map(mapOp));
                        break;
                    case $2utmd.types.VALUES:
                        result = factory.createValues([].concat(result.variables), result.bindings.map(function(b) {
                            return Object.assign({}, b);
                        }));
                        break;
                    case $2utmd.types.ZERO_OR_MORE_PATH:
                        result = factory.createZeroOrMorePath(mapOp(result.path));
                        break;
                    case $2utmd.types.ZERO_OR_ONE_PATH:
                        result = factory.createZeroOrOnePath(mapOp(result.path));
                        break;
                    // UPDATE operations
                    case $2utmd.types.COMPOSITE_UPDATE:
                        result = factory.createCompositeUpdate(result.updates.map(mapOp));
                        break;
                    case $2utmd.types.DELETE_INSERT:
                        result = factory.createDeleteInsert(result["delete"] ? result["delete"].map(mapOp) : undefined, result.insert ? result.insert.map(mapOp) : undefined, result.where ? mapOp(result.where) : undefined);
                        break;
                    case $2utmd.types.LOAD:
                        result = factory.createLoad(result.source, result.destination, result.silent);
                        break;
                    case $2utmd.types.CLEAR:
                        result = factory.createClear(result.source, result.silent);
                        break;
                    case $2utmd.types.CREATE:
                        result = factory.createCreate(result.source, result.silent);
                        break;
                    case $2utmd.types.DROP:
                        result = factory.createDrop(result.source, result.silent);
                        break;
                    case $2utmd.types.ADD:
                        result = factory.createAdd(result.source, result.destination);
                        break;
                    case $2utmd.types.MOVE:
                        result = factory.createMove(result.source, result.destination);
                        break;
                    case $2utmd.types.COPY:
                        result = factory.createCopy(result.source, result.destination);
                        break;
                    default:
                        throw new Error("Unknown Operation type ".concat(result.type));
                }
                // Inherit metadata
                if (toCopyMetadata) result.metadata = toCopyMetadata;
                return result;
            }
        },
        {
            key: "mapExpression",
            value: /**
     * Similar to the {@link mapOperation} function but specifically for expressions.
     * Both functions call each other while copying.
     * Should not be called directly since it does not execute the callbacks, these happen in {@link mapOperation}.
     * @param {Expression} expr - The Operation to recurse on.
     * @param callbacks - A map of required callback Operations.
     * @param {Factory} factory - Factory used to create new Operations. Will use default factory if none is provided.
     * @returns {Operation} - The copied result.
     */ function mapExpression(expr, callbacks, factory) {
                var result = expr;
                var doRecursion = true;
                factory = factory || new $56884c6cb5d6b3c9$var$factory_1["default"]();
                var callback = callbacks[expr.expressionType];
                var ref;
                if (callback) ref = callback(expr, factory), result = ref.result, doRecursion = ref.recurse, ref;
                if (!doRecursion) return result;
                var mapOp = function(op) {
                    return Util.mapOperation(op, callbacks, factory);
                };
                switch(expr.expressionType){
                    case $2utmd.expressionTypes.AGGREGATE:
                        if (expr.variable) return factory.createBoundAggregate(expr.variable, expr.aggregator, mapOp(expr.expression), expr.distinct, expr.separator);
                        return factory.createAggregateExpression(expr.aggregator, mapOp(expr.expression), expr.distinct, expr.separator);
                    case $2utmd.expressionTypes.EXISTENCE:
                        return factory.createExistenceExpression(expr.not, mapOp(expr.input));
                    case $2utmd.expressionTypes.NAMED:
                        return factory.createNamedExpression(expr.name, expr.args.map(mapOp));
                    case $2utmd.expressionTypes.OPERATOR:
                        return factory.createOperatorExpression(expr.operator, expr.args.map(mapOp));
                    case $2utmd.expressionTypes.TERM:
                        return factory.createTermExpression(expr.term);
                    case $2utmd.expressionTypes.WILDCARD:
                        return factory.createWildcardExpression();
                    default:
                        throw new Error("Unknown Expression type ".concat(expr.expressionType));
                }
            }
        },
        {
            key: "cloneOperation",
            value: /**
     * Creates a deep clone of the operation.
     * This is syntactic sugar for calling {@link mapOperation} without callbacks.
     * @param {Operation} op - The operation to copy.
     * @returns {Operation} - The deep copy.
     */ function cloneOperation(op) {
                return Util.mapOperation(op, {});
            }
        },
        {
            key: "cloneExpression",
            value: /**
     * Creates a deep clone of the expression.
     * This is syntactic sugar for calling {@link mapExpression} without callbacks.
     * @param {Expression} expr - The operation to copy.
     * @returns {Expression} - The deep copy.
     */ function cloneExpression(expr) {
                return Util.mapExpression(expr, {});
            }
        },
        {
            key: "createUniqueVariable",
            value: function createUniqueVariable(label, variables, dataFactory) {
                var counter = 0;
                var labelLoop = label;
                while(variables[labelLoop])labelLoop = "".concat(label).concat(counter++);
                return dataFactory.variable(labelLoop);
            }
        },
        {
            key: "isSimpleTerm",
            value: // separate terms from wildcard since we handle them differently
            function isSimpleTerm(term) {
                return term.termType !== undefined && term.termType !== 'Quad' && term.termType !== 'Wildcard';
            }
        },
        {
            key: "isQuad",
            value: function isQuad(term) {
                return term.termType === 'Quad';
            }
        },
        {
            key: "hasQuadVariables",
            value: function hasQuadVariables(quad) {
                return (0, $ilNtL.someTermsNested)(quad, function(term) {
                    return term.termType === 'Variable';
                });
            }
        },
        {
            key: "isWildcard",
            value: function isWildcard(term) {
                return term.termType === 'Wildcard';
            }
        }
    ]);
    return Util;
}();
module.exports["default"] = $56884c6cb5d6b3c9$var$Util;

});
parcelRegister("ilNtL", function(module, exports) {
"use strict";
var $d5c091aef060a623$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5c091aef060a623$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d5c091aef060a623$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d5c091aef060a623$var$__exportStar((parcelRequire("6NEcM")), module.exports);

$d5c091aef060a623$var$__exportStar((parcelRequire("5zfzP")), module.exports);

});
parcelRegister("6NEcM", function(module, exports) {

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matchPatternMappings = module.exports.matchPatternComplete = module.exports.matchPattern = module.exports.matchTerm = module.exports.getValueNestedPath = module.exports.someTermsNested = module.exports.someTerms = module.exports.everyTermsNested = module.exports.everyTerms = module.exports.reduceTermsNested = module.exports.reduceTerms = module.exports.mapTermsNested = module.exports.mapTerms = module.exports.filterQuadTermNamesNested = module.exports.filterQuadTermNames = module.exports.filterTermsNested = module.exports.filterTerms = module.exports.forEachTermsNested = module.exports.forEachTerms = module.exports.collectNamedTerms = module.exports.getNamedTerms = module.exports.getTermsNested = module.exports.getTerms = module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;

var $2ej16 = parcelRequire("2ej16");
var $4f36819576ae6d05$var$DF = new $2ej16.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $4f36819576ae6d05$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
module.exports.getTerms = $4f36819576ae6d05$var$getTerms;
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $4f36819576ae6d05$var$getTermsNested(quad, ignoreDefaultGraph) {
    var terms = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $4f36819576ae6d05$var$getTerms(quad, ignoreDefaultGraph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var term = _step.value;
            if (term.termType === 'Quad') $4f36819576ae6d05$var$getTermsNested(term, ignoreDefaultGraph).forEach(function(subTerm) {
                return terms.push(subTerm);
            });
            else terms.push(term);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return terms;
}
module.exports.getTermsNested = $4f36819576ae6d05$var$getTermsNested;
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $4f36819576ae6d05$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
module.exports.getNamedTerms = $4f36819576ae6d05$var$getNamedTerms;
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $4f36819576ae6d05$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    var elements = {};
    namedTerms.forEach(function(namedTerm) {
        return elements[namedTerm.key] = namedTerm.value;
    });
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $4f36819576ae6d05$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
module.exports.collectNamedTerms = $4f36819576ae6d05$var$collectNamedTerms;
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $4f36819576ae6d05$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
module.exports.forEachTerms = $4f36819576ae6d05$var$forEachTerms;
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $4f36819576ae6d05$var$forEachTermsNested(quad, cb) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (quad.subject.termType === 'Quad') $4f36819576ae6d05$var$forEachTermsNested(quad.subject, cb, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else cb(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') $4f36819576ae6d05$var$forEachTermsNested(quad.predicate, cb, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else cb(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') $4f36819576ae6d05$var$forEachTermsNested(quad.object, cb, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else cb(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') $4f36819576ae6d05$var$forEachTermsNested(quad.graph, cb, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else cb(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
}
module.exports.forEachTermsNested = $4f36819576ae6d05$var$forEachTermsNested;
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $4f36819576ae6d05$var$filterTerms(quad, filter) {
    var terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
module.exports.filterTerms = $4f36819576ae6d05$var$filterTerms;
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $4f36819576ae6d05$var$filterTermsNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var terms = [];
    if (quad.subject.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterTermsNested(quad.subject, filter, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))));
    else if (filter(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterTermsNested(quad.predicate, filter, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))));
    else if (filter(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterTermsNested(quad.object, filter, (0, $7WNf6._)(keys).concat([
        'object'
    ]))));
    else if (filter(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterTermsNested(quad.graph, filter, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))));
    else if (filter(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))) terms.push(quad.graph);
    return terms;
}
module.exports.filterTermsNested = $4f36819576ae6d05$var$filterTermsNested;
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $4f36819576ae6d05$var$filterQuadTermNames(quad, filter) {
    var names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
module.exports.filterQuadTermNames = $4f36819576ae6d05$var$filterQuadTermNames;
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $4f36819576ae6d05$var$filterQuadTermNamesNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var names = [];
    var keysS = (0, $7WNf6._)(keys).concat([
        'subject'
    ]);
    if (quad.subject.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterQuadTermNamesNested(quad.subject, filter, keysS)));
    else if (filter(quad.subject, keysS)) names.push(keysS);
    var keysP = (0, $7WNf6._)(keys).concat([
        'predicate'
    ]);
    if (quad.predicate.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)));
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    var keysO = (0, $7WNf6._)(keys).concat([
        'object'
    ]);
    if (quad.object.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterQuadTermNamesNested(quad.object, filter, keysO)));
    else if (filter(quad.object, keysO)) names.push(keysO);
    var keysG = (0, $7WNf6._)(keys).concat([
        'graph'
    ]);
    if (quad.graph.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($4f36819576ae6d05$var$filterQuadTermNamesNested(quad.graph, filter, keysG)));
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
module.exports.filterQuadTermNamesNested = $4f36819576ae6d05$var$filterQuadTermNamesNested;
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $4f36819576ae6d05$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $4f36819576ae6d05$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
module.exports.mapTerms = $4f36819576ae6d05$var$mapTerms;
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $4f36819576ae6d05$var$mapTermsNested(quad, mapper, dataFactory) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return (dataFactory || $4f36819576ae6d05$var$DF).quad(quad.subject.termType === 'Quad' ? $4f36819576ae6d05$var$mapTermsNested(quad.subject, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : mapper(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ])), quad.predicate.termType === 'Quad' ? $4f36819576ae6d05$var$mapTermsNested(quad.predicate, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : mapper(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])), quad.object.termType === 'Quad' ? $4f36819576ae6d05$var$mapTermsNested(quad.object, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : mapper(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ])), quad.graph.termType === 'Quad' ? $4f36819576ae6d05$var$mapTermsNested(quad.graph, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : mapper(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
module.exports.mapTermsNested = $4f36819576ae6d05$var$mapTermsNested;
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $4f36819576ae6d05$var$reduceTerms(quad, reducer, initialValue) {
    var value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
module.exports.reduceTerms = $4f36819576ae6d05$var$reduceTerms;
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $4f36819576ae6d05$var$reduceTermsNested(quad, reducer, initialValue) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var value = initialValue;
    if (quad.subject.termType === 'Quad') value = $4f36819576ae6d05$var$reduceTermsNested(quad.subject, reducer, value, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else value = reducer(value, quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') value = $4f36819576ae6d05$var$reduceTermsNested(quad.predicate, reducer, value, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else value = reducer(value, quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') value = $4f36819576ae6d05$var$reduceTermsNested(quad.object, reducer, value, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else value = reducer(value, quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') value = $4f36819576ae6d05$var$reduceTermsNested(quad.graph, reducer, value, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else value = reducer(value, quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    return value;
}
module.exports.reduceTermsNested = $4f36819576ae6d05$var$reduceTermsNested;
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $4f36819576ae6d05$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
module.exports.everyTerms = $4f36819576ae6d05$var$everyTerms;
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $4f36819576ae6d05$var$everyTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $4f36819576ae6d05$var$everyTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) && (quad.predicate.termType === 'Quad' ? $4f36819576ae6d05$var$everyTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) && (quad.object.termType === 'Quad' ? $4f36819576ae6d05$var$everyTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) && (quad.graph.termType === 'Quad' ? $4f36819576ae6d05$var$everyTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
module.exports.everyTermsNested = $4f36819576ae6d05$var$everyTermsNested;
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $4f36819576ae6d05$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
module.exports.someTerms = $4f36819576ae6d05$var$someTerms;
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $4f36819576ae6d05$var$someTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $4f36819576ae6d05$var$someTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) || (quad.predicate.termType === 'Quad' ? $4f36819576ae6d05$var$someTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) || (quad.object.termType === 'Quad' ? $4f36819576ae6d05$var$someTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) || (quad.graph.termType === 'Quad' ? $4f36819576ae6d05$var$someTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
module.exports.someTermsNested = $4f36819576ae6d05$var$someTermsNested;
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $4f36819576ae6d05$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $4f36819576ae6d05$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error("Tried to get ".concat(keys[0], " from term of type ").concat(term.termType));
}
module.exports.getValueNestedPath = $4f36819576ae6d05$var$getValueNestedPath;
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $4f36819576ae6d05$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $4f36819576ae6d05$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
module.exports.matchTerm = $4f36819576ae6d05$var$matchTerm;
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $4f36819576ae6d05$var$matchPattern(quad, subject, predicate, object, graph) {
    return $4f36819576ae6d05$var$matchTerm(quad.subject, subject) && $4f36819576ae6d05$var$matchTerm(quad.predicate, predicate) && $4f36819576ae6d05$var$matchTerm(quad.object, object) && $4f36819576ae6d05$var$matchTerm(quad.graph, graph);
}
module.exports.matchPattern = $4f36819576ae6d05$var$matchPattern;
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $4f36819576ae6d05$var$matchPatternComplete(quad, pattern) {
    return $4f36819576ae6d05$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
module.exports.matchPatternComplete = $4f36819576ae6d05$var$matchPatternComplete;
function $4f36819576ae6d05$var$matchPatternMappings(quad, pattern) {
    var opt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var map = {};
    function match(_pattern, _quad) {
        return $4f36819576ae6d05$var$everyTerms(_pattern, function(t1, key) {
            var _a, _b;
            var t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}
module.exports.matchPatternMappings = $4f36819576ae6d05$var$matchPatternMappings;

});

parcelRegister("5zfzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getQuads = module.exports.getDefaultGraphs = module.exports.getVariables = module.exports.getLiterals = module.exports.getBlankNodes = module.exports.getNamedNodes = module.exports.getTermsOfType = module.exports.uniqTerms = module.exports.TERM_TYPES = void 0;

var $gQYIc = parcelRequire("gQYIc");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $40dc4de2a0cf40ac$var$uniqTerms(terms) {
    var hash = {};
    return terms.filter(function(term) {
        var termString = (0, $gQYIc.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
module.exports.uniqTerms = $40dc4de2a0cf40ac$var$uniqTerms;
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $40dc4de2a0cf40ac$var$getTermsOfType(terms, termType) {
    return terms.filter(function(term) {
        return term.termType === termType;
    });
}
module.exports.getTermsOfType = $40dc4de2a0cf40ac$var$getTermsOfType;
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $40dc4de2a0cf40ac$var$getNamedNodes(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'NamedNode');
}
module.exports.getNamedNodes = $40dc4de2a0cf40ac$var$getNamedNodes;
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $40dc4de2a0cf40ac$var$getBlankNodes(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'BlankNode');
}
module.exports.getBlankNodes = $40dc4de2a0cf40ac$var$getBlankNodes;
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $40dc4de2a0cf40ac$var$getLiterals(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'Literal');
}
module.exports.getLiterals = $40dc4de2a0cf40ac$var$getLiterals;
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $40dc4de2a0cf40ac$var$getVariables(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'Variable');
}
module.exports.getVariables = $40dc4de2a0cf40ac$var$getVariables;
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $40dc4de2a0cf40ac$var$getDefaultGraphs(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'DefaultGraph');
}
module.exports.getDefaultGraphs = $40dc4de2a0cf40ac$var$getDefaultGraphs;
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $40dc4de2a0cf40ac$var$getQuads(terms) {
    return $40dc4de2a0cf40ac$var$getTermsOfType(terms, 'Quad');
}
module.exports.getQuads = $40dc4de2a0cf40ac$var$getQuads;

});




parcelRegister("zButK", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
var $06b059d98c862dc3$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06b059d98c862dc3$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $06b059d98c862dc3$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $06b059d98c862dc3$var$__createBinding(result, mod, k);
    }
    $06b059d98c862dc3$var$__setModuleDefault(result, mod);
    return result;
};
var $06b059d98c862dc3$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toSparqlJs = module.exports.toSparql = void 0;

var $gevlR = parcelRequire("gevlR");

var $gQYIc = parcelRequire("gQYIc");

var $2h2ox = parcelRequire("2h2ox");

var $06b059d98c862dc3$var$Algebra = $06b059d98c862dc3$var$__importStar((parcelRequire("2utmd")));

var $06b059d98c862dc3$var$factory_1 = $06b059d98c862dc3$var$__importDefault((parcelRequire("3btxo")));

var $06b059d98c862dc3$var$util_1 = $06b059d98c862dc3$var$__importDefault((parcelRequire("7qBOV")));
var $06b059d98c862dc3$var$types = $06b059d98c862dc3$var$Algebra.types;
var $06b059d98c862dc3$var$eTypes = $06b059d98c862dc3$var$Algebra.expressionTypes;
var $06b059d98c862dc3$var$context;
var $06b059d98c862dc3$var$factory = new $06b059d98c862dc3$var$factory_1["default"]();
function $06b059d98c862dc3$var$toSparql(op) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var generator = new $2h2ox.Generator(options);
    return generator.stringify($06b059d98c862dc3$var$toSparqlJs(op));
}
module.exports.toSparql = $06b059d98c862dc3$var$toSparql;
function $06b059d98c862dc3$var$toSparqlJs(op) {
    $06b059d98c862dc3$var$resetContext();
    op = $06b059d98c862dc3$var$removeQuads(op);
    var result = $06b059d98c862dc3$var$translateOperation(op);
    if (result.type === 'group') return result.patterns[0];
    return result;
}
module.exports.toSparqlJs = $06b059d98c862dc3$var$toSparqlJs;
function $06b059d98c862dc3$var$resetContext() {
    $06b059d98c862dc3$var$context = {
        project: false,
        extend: [],
        group: [],
        aggregates: [],
        order: []
    };
}
function $06b059d98c862dc3$var$translateOperation(op) {
    // this allows us to differentiate between BIND and SELECT when translating EXTEND
    // GRAPH was added because the way graphs get added back here is not the same as how they get added in the future
    // ^ seems fine but might have to be changed if problems get detected in the future
    if (op.type !== $06b059d98c862dc3$var$types.EXTEND && op.type !== $06b059d98c862dc3$var$types.ORDER_BY && op.type !== $06b059d98c862dc3$var$types.GRAPH) $06b059d98c862dc3$var$context.project = false;
    switch(op.type){
        case $06b059d98c862dc3$var$types.EXPRESSION:
            return $06b059d98c862dc3$var$translateExpression(op);
        case $06b059d98c862dc3$var$types.ASK:
            return $06b059d98c862dc3$var$translateProject(op, $06b059d98c862dc3$var$types.ASK);
        case $06b059d98c862dc3$var$types.BGP:
            return $06b059d98c862dc3$var$translateBgp(op);
        case $06b059d98c862dc3$var$types.CONSTRUCT:
            return $06b059d98c862dc3$var$translateConstruct(op);
        case $06b059d98c862dc3$var$types.DESCRIBE:
            return $06b059d98c862dc3$var$translateProject(op, $06b059d98c862dc3$var$types.DESCRIBE);
        case $06b059d98c862dc3$var$types.DISTINCT:
            return $06b059d98c862dc3$var$translateDistinct(op);
        case $06b059d98c862dc3$var$types.EXTEND:
            return $06b059d98c862dc3$var$translateExtend(op);
        case $06b059d98c862dc3$var$types.FROM:
            return $06b059d98c862dc3$var$translateFrom(op);
        case $06b059d98c862dc3$var$types.FILTER:
            return $06b059d98c862dc3$var$translateFilter(op);
        case $06b059d98c862dc3$var$types.GRAPH:
            return $06b059d98c862dc3$var$translateGraph(op);
        case $06b059d98c862dc3$var$types.GROUP:
            return $06b059d98c862dc3$var$translateGroup(op);
        case $06b059d98c862dc3$var$types.JOIN:
            return $06b059d98c862dc3$var$translateJoin(op);
        case $06b059d98c862dc3$var$types.LEFT_JOIN:
            return $06b059d98c862dc3$var$translateLeftJoin(op);
        case $06b059d98c862dc3$var$types.MINUS:
            return $06b059d98c862dc3$var$translateMinus(op);
        case $06b059d98c862dc3$var$types.NOP:
            return {};
        case $06b059d98c862dc3$var$types.ORDER_BY:
            return $06b059d98c862dc3$var$translateOrderBy(op);
        case $06b059d98c862dc3$var$types.PATH:
            return $06b059d98c862dc3$var$translatePath(op);
        case $06b059d98c862dc3$var$types.PATTERN:
            return $06b059d98c862dc3$var$translatePattern(op);
        case $06b059d98c862dc3$var$types.PROJECT:
            return $06b059d98c862dc3$var$translateProject(op, $06b059d98c862dc3$var$types.PROJECT);
        case $06b059d98c862dc3$var$types.REDUCED:
            return $06b059d98c862dc3$var$translateReduced(op);
        case $06b059d98c862dc3$var$types.SERVICE:
            return $06b059d98c862dc3$var$translateService(op);
        case $06b059d98c862dc3$var$types.SLICE:
            return $06b059d98c862dc3$var$translateSlice(op);
        case $06b059d98c862dc3$var$types.UNION:
            return $06b059d98c862dc3$var$translateUnion(op);
        case $06b059d98c862dc3$var$types.VALUES:
            return $06b059d98c862dc3$var$translateValues(op);
        // UPDATE operations
        case $06b059d98c862dc3$var$types.COMPOSITE_UPDATE:
            return $06b059d98c862dc3$var$translateCompositeUpdate(op);
        case $06b059d98c862dc3$var$types.DELETE_INSERT:
            return $06b059d98c862dc3$var$translateDeleteInsert(op);
        case $06b059d98c862dc3$var$types.LOAD:
            return $06b059d98c862dc3$var$translateLoad(op);
        case $06b059d98c862dc3$var$types.CLEAR:
            return $06b059d98c862dc3$var$translateClear(op);
        case $06b059d98c862dc3$var$types.CREATE:
            return $06b059d98c862dc3$var$translateCreate(op);
        case $06b059d98c862dc3$var$types.DROP:
            return $06b059d98c862dc3$var$translateDrop(op);
        case $06b059d98c862dc3$var$types.ADD:
            return $06b059d98c862dc3$var$translateAdd(op);
        case $06b059d98c862dc3$var$types.MOVE:
            return $06b059d98c862dc3$var$translateMove(op);
        case $06b059d98c862dc3$var$types.COPY:
            return $06b059d98c862dc3$var$translateCopy(op);
    }
    throw new Error("Unknown Operation type ".concat(op.type));
}
function $06b059d98c862dc3$var$translateExpression(expr) {
    switch(expr.expressionType){
        case $06b059d98c862dc3$var$eTypes.AGGREGATE:
            return $06b059d98c862dc3$var$translateAggregateExpression(expr);
        case $06b059d98c862dc3$var$eTypes.EXISTENCE:
            return $06b059d98c862dc3$var$translateExistenceExpression(expr);
        case $06b059d98c862dc3$var$eTypes.NAMED:
            return $06b059d98c862dc3$var$translateNamedExpression(expr);
        case $06b059d98c862dc3$var$eTypes.OPERATOR:
            return $06b059d98c862dc3$var$translateOperatorExpression(expr);
        case $06b059d98c862dc3$var$eTypes.TERM:
            return $06b059d98c862dc3$var$translateTermExpression(expr);
        case $06b059d98c862dc3$var$eTypes.WILDCARD:
            return $06b059d98c862dc3$var$translateWildcardExpression(expr);
    }
    throw new Error("Unknown Expression Operation type ".concat(expr.expressionType));
}
function $06b059d98c862dc3$var$translatePathComponent(path) {
    switch(path.type){
        case $06b059d98c862dc3$var$types.ALT:
            return $06b059d98c862dc3$var$translateAlt(path);
        case $06b059d98c862dc3$var$types.INV:
            return $06b059d98c862dc3$var$translateInv(path);
        case $06b059d98c862dc3$var$types.LINK:
            return $06b059d98c862dc3$var$translateLink(path);
        case $06b059d98c862dc3$var$types.NPS:
            return $06b059d98c862dc3$var$translateNps(path);
        case $06b059d98c862dc3$var$types.ONE_OR_MORE_PATH:
            return $06b059d98c862dc3$var$translateOneOrMorePath(path);
        case $06b059d98c862dc3$var$types.SEQ:
            return $06b059d98c862dc3$var$translateSeq(path);
        case $06b059d98c862dc3$var$types.ZERO_OR_MORE_PATH:
            return $06b059d98c862dc3$var$translateZeroOrMorePath(path);
        case $06b059d98c862dc3$var$types.ZERO_OR_ONE_PATH:
            return $06b059d98c862dc3$var$translateZeroOrOnePath(path);
    }
    throw new Error("Unknown Path type ".concat(path.type));
}
function $06b059d98c862dc3$var$translateTerm(term) {
    return (0, $gQYIc.termToString)(term);
}
// ------------------------- EXPRESSIONS -------------------------
function $06b059d98c862dc3$var$translateAggregateExpression(expr) {
    var result = {
        expression: $06b059d98c862dc3$var$translateExpression(expr.expression),
        type: 'aggregate',
        aggregation: expr.aggregator,
        distinct: expr.distinct
    };
    if (expr.separator) result.separator = expr.separator;
    return result;
}
function $06b059d98c862dc3$var$translateExistenceExpression(expr) {
    return {
        type: 'operation',
        operator: expr.not ? 'notexists' : 'exists',
        args: [
            {
                type: 'group',
                patterns: $06b059d98c862dc3$var$util_1["default"].flatten([
                    $06b059d98c862dc3$var$translateOperation(expr.input)
                ])
            }
        ]
    };
}
function $06b059d98c862dc3$var$translateNamedExpression(expr) {
    return {
        type: 'functionCall',
        // Wrong typings
        "function": expr.name,
        args: expr.args.map($06b059d98c862dc3$var$translateExpression)
    };
}
function $06b059d98c862dc3$var$translateOperatorExpression(expr) {
    if (expr.operator === 'desc') {
        var result = {
            expression: $06b059d98c862dc3$var$translateExpression(expr.args[0])
        };
        result.descending = true;
        return result;
    }
    var result1 = {
        type: 'operation',
        operator: expr.operator,
        args: expr.args.map($06b059d98c862dc3$var$translateExpression)
    };
    if (result1.operator === 'in' || result1.operator === 'notin') result1.args = [
        result1.args[0]
    ].concat([
        result1.args.slice(1)
    ]);
    return result1;
}
function $06b059d98c862dc3$var$translateTermExpression(expr) {
    return expr.term;
}
function $06b059d98c862dc3$var$translateWildcardExpression(expr) {
    return expr.wildcard;
}
function $06b059d98c862dc3$var$arrayToPattern(input) {
    if (!Array.isArray(input)) return input;
    if (input.length === 1) return input[0];
    return {
        type: 'group',
        patterns: input
    };
}
// ------------------------- OPERATIONS -------------------------
// these get translated in the project function
function $06b059d98c862dc3$var$translateBoundAggregate(op) {
    return op;
}
function $06b059d98c862dc3$var$translateBgp(op) {
    var patterns = op.patterns.map($06b059d98c862dc3$var$translatePattern);
    if (patterns.length === 0) return null;
    return {
        type: 'bgp',
        triples: patterns
    };
}
function $06b059d98c862dc3$var$translateConstruct(op) {
    return {
        type: 'query',
        prefixes: {},
        queryType: 'CONSTRUCT',
        template: op.template.map($06b059d98c862dc3$var$translatePattern),
        where: $06b059d98c862dc3$var$util_1["default"].flatten([
            $06b059d98c862dc3$var$translateOperation(op.input)
        ])
    };
}
function $06b059d98c862dc3$var$translateDistinct(op) {
    var result = $06b059d98c862dc3$var$translateOperation(op.input);
    // project is nested in group object
    result.patterns[0].distinct = true;
    return result;
}
function $06b059d98c862dc3$var$translateExtend(op) {
    if ($06b059d98c862dc3$var$context.project) {
        $06b059d98c862dc3$var$context.extend.push(op);
        return $06b059d98c862dc3$var$translateOperation(op.input);
    }
    return $06b059d98c862dc3$var$util_1["default"].flatten([
        $06b059d98c862dc3$var$translateOperation(op.input),
        {
            type: 'bind',
            variable: op.variable,
            expression: $06b059d98c862dc3$var$translateExpression(op.expression)
        }
    ]);
}
function $06b059d98c862dc3$var$translateFrom(op) {
    var result = $06b059d98c862dc3$var$translateOperation(op.input);
    // Can't type as CONSTRUCT queries do not have `from` field in their type
    var obj = result;
    // project is nested in group object
    if (result.type === 'group') obj = result.patterns[0];
    obj.from = {
        "default": op["default"],
        named: op.named
    };
    return result;
}
function $06b059d98c862dc3$var$translateFilter(op) {
    return {
        type: 'group',
        patterns: $06b059d98c862dc3$var$util_1["default"].flatten([
            $06b059d98c862dc3$var$translateOperation(op.input),
            {
                type: 'filter',
                expression: $06b059d98c862dc3$var$translateExpression(op.expression)
            }
        ])
    };
}
function $06b059d98c862dc3$var$translateGraph(op) {
    return {
        type: 'graph',
        patterns: $06b059d98c862dc3$var$util_1["default"].flatten([
            $06b059d98c862dc3$var$translateOperation(op.input)
        ]),
        name: op.name
    };
}
function $06b059d98c862dc3$var$translateGroup(op) {
    var _context_aggregates, // TODO: apply possible extends
    _context_group;
    var input = $06b059d98c862dc3$var$translateOperation(op.input);
    var aggs = op.aggregates.map($06b059d98c862dc3$var$translateBoundAggregate);
    (_context_aggregates = $06b059d98c862dc3$var$context.aggregates).push.apply(_context_aggregates, (0, $7WNf6._)(aggs));
    (_context_group = $06b059d98c862dc3$var$context.group).push.apply(_context_group, (0, $7WNf6._)(op.variables));
    return input;
}
function $06b059d98c862dc3$var$translateJoin(op) {
    var arr = $06b059d98c862dc3$var$util_1["default"].flatten(op.input.map($06b059d98c862dc3$var$translateOperation));
    // Merge bgps
    // This is possible if one side was a path and the other a bgp for example
    return arr.reduce(function(result, val) {
        var _result__triples;
        if (val.type !== 'bgp' || result.length == 0 || result[result.length - 1].type !== 'bgp') result.push(val);
        else (_result__triples = result[result.length - 1].triples).push.apply(_result__triples, (0, $7WNf6._)(val.triples));
        return result;
    }, []);
}
function $06b059d98c862dc3$var$translateLeftJoin(op) {
    var leftjoin = {
        type: 'optional',
        patterns: [
            $06b059d98c862dc3$var$translateOperation(op.input[1])
        ]
    };
    if (op.expression) leftjoin.patterns.push({
        type: 'filter',
        expression: $06b059d98c862dc3$var$translateExpression(op.expression)
    });
    leftjoin.patterns = $06b059d98c862dc3$var$util_1["default"].flatten(leftjoin.patterns);
    return $06b059d98c862dc3$var$util_1["default"].flatten([
        $06b059d98c862dc3$var$translateOperation(op.input[0]),
        leftjoin
    ]);
}
function $06b059d98c862dc3$var$translateMinus(op) {
    var patterns = $06b059d98c862dc3$var$translateOperation(op.input[1]);
    if (patterns.type === 'group') patterns = patterns.patterns;
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    return $06b059d98c862dc3$var$util_1["default"].flatten([
        $06b059d98c862dc3$var$translateOperation(op.input[0]),
        {
            type: 'minus',
            patterns: patterns
        }
    ]);
}
function $06b059d98c862dc3$var$translateOrderBy(op) {
    var _context_order;
    (_context_order = $06b059d98c862dc3$var$context.order).push.apply(_context_order, (0, $7WNf6._)(op.expressions));
    return $06b059d98c862dc3$var$translateOperation(op.input);
}
function $06b059d98c862dc3$var$translatePath(op) {
    return {
        type: 'bgp',
        triples: [
            {
                subject: op.subject,
                predicate: $06b059d98c862dc3$var$translatePathComponent(op.predicate),
                object: op.object
            }
        ]
    };
}
function $06b059d98c862dc3$var$translatePattern(op) {
    return {
        subject: op.subject,
        predicate: op.predicate,
        object: op.object
    };
}
function $06b059d98c862dc3$var$replaceAggregatorVariables(s, map) {
    var st = $06b059d98c862dc3$var$util_1["default"].isSimpleTerm(s) ? $06b059d98c862dc3$var$translateTerm(s) : s;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (typeof st === 'string') {
        if (map[st]) return map[st];
    } else if (Array.isArray(s)) s = s.map(function(e) {
        return $06b059d98c862dc3$var$replaceAggregatorVariables(e, map);
    });
    else try {
        for(var _iterator = Object.keys(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            s[key] = $06b059d98c862dc3$var$replaceAggregatorVariables(s[key], map);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return s;
}
function $06b059d98c862dc3$var$translateProject(op, type) {
    var result = {
        type: 'query',
        prefixes: {}
    };
    // Makes typing easier in some places
    var select = result;
    var variables;
    if (type === $06b059d98c862dc3$var$types.PROJECT) {
        result.queryType = 'SELECT';
        variables = op.variables;
    } else if (type === $06b059d98c862dc3$var$types.ASK) result.queryType = 'ASK';
    else if (type === $06b059d98c862dc3$var$types.DESCRIBE) {
        result.queryType = 'DESCRIBE';
        variables = op.terms;
    }
    // backup values in case of nested queries
    // everything in extend, group, etc. is irrelevant for this project call
    var extend = $06b059d98c862dc3$var$context.extend;
    var group = $06b059d98c862dc3$var$context.group;
    var aggregates = $06b059d98c862dc3$var$context.aggregates;
    var order = $06b059d98c862dc3$var$context.order;
    $06b059d98c862dc3$var$resetContext();
    $06b059d98c862dc3$var$context.project = true;
    var input = $06b059d98c862dc3$var$util_1["default"].flatten([
        $06b059d98c862dc3$var$translateOperation(op.input)
    ]);
    if (input.length === 1 && input[0].type === 'group') input = input[0].patterns;
    result.where = input;
    var aggregators = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // these can not reference each other
        for(var _iterator = $06b059d98c862dc3$var$context.aggregates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var agg = _step.value;
            aggregators[$06b059d98c862dc3$var$translateTerm(agg.variable)] = $06b059d98c862dc3$var$translateExpression(agg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // do these in reverse order since variables in one extend might apply to an expression in an other extend
    var extensions = {};
    for(var i = $06b059d98c862dc3$var$context.extend.length - 1; i >= 0; --i){
        var e = $06b059d98c862dc3$var$context.extend[i];
        extensions[$06b059d98c862dc3$var$translateTerm(e.variable)] = $06b059d98c862dc3$var$replaceAggregatorVariables($06b059d98c862dc3$var$translateExpression(e.expression), aggregators);
    }
    if ($06b059d98c862dc3$var$context.group.length > 0) select.group = $06b059d98c862dc3$var$context.group.map(function(variable) {
        var v = $06b059d98c862dc3$var$translateTerm(variable);
        if (extensions[v]) {
            var result = extensions[v];
            delete extensions[v]; // make sure there is only 1 'AS' statement
            return {
                variable: variable,
                expression: result
            };
        }
        return {
            expression: variable
        };
    });
    // descending expressions will already be in the correct format due to the structure of those
    if ($06b059d98c862dc3$var$context.order.length > 0) select.order = $06b059d98c862dc3$var$context.order.map($06b059d98c862dc3$var$translateOperation).map(function(o) {
        return o.descending ? o : {
            expression: o
        };
    });
    // this needs to happen after the group because it might depend on variables generated there
    if (variables) {
        select.variables = variables.map(function(term) {
            var v = $06b059d98c862dc3$var$translateTerm(term);
            if (extensions[v]) {
                var result = extensions[v];
                delete extensions[v]; // remove used extensions so only unused ones remain
                return {
                    variable: term,
                    expression: result
                };
            }
            return term;
        });
        // if the * didn't match any variables this would be empty
        if (select.variables.length === 0) select.variables = [
            new $2h2ox.Wildcard()
        ];
    }
    // It is possible that at this point some extensions have not yet been resolved.
    // These would be bind operations that are not used in a GROUP BY or SELECT body.
    // We still need to add them though, as they could be relevant to the other extensions.
    var extensionEntries = Object.entries(extensions);
    if (extensionEntries.length > 0) {
        select.where = select.where || [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = extensionEntries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $32TW8._)(_step1.value, 2), key = _step_value[0], value = _step_value[1];
                select.where.push({
                    type: 'bind',
                    variable: (0, $gQYIc.stringToTerm)(key),
                    expression: value
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    // convert filter to 'having' if it contains an aggregator variable
    // could always convert, but is nicer to use filter when possible
    if (result.where.length > 0 && result.where[result.where.length - 1].type === 'filter') {
        var filter = result.where[result.where.length - 1];
        if ($06b059d98c862dc3$var$objectContainsValues(filter, Object.keys(aggregators))) {
            select.having = $06b059d98c862dc3$var$util_1["default"].flatten([
                $06b059d98c862dc3$var$replaceAggregatorVariables(filter.expression, aggregators)
            ]);
            result.where.splice(-1);
        }
    }
    $06b059d98c862dc3$var$context.extend = extend;
    $06b059d98c862dc3$var$context.group = group;
    $06b059d98c862dc3$var$context.aggregates = aggregates;
    $06b059d98c862dc3$var$context.order = order;
    // subqueries need to be in a group, this will be removed again later for the root query
    return {
        type: 'group',
        patterns: [
            select
        ]
    };
}
function $06b059d98c862dc3$var$objectContainsValues(o, vals) {
    if ($06b059d98c862dc3$var$util_1["default"].isSimpleTerm(o)) return vals.indexOf($06b059d98c862dc3$var$translateTerm(o)) >= 0;
    if (Array.isArray(o)) return o.some(function(e) {
        return $06b059d98c862dc3$var$objectContainsValues(e, vals);
    });
    if (o === Object(o)) return Object.keys(o).some(function(key) {
        return $06b059d98c862dc3$var$objectContainsValues(o[key], vals);
    });
    return vals.indexOf(o) >= 0;
}
function $06b059d98c862dc3$var$translateReduced(op) {
    var result = $06b059d98c862dc3$var$translateOperation(op.input);
    // project is nested in group object
    result.patterns[0].reduced = true;
    return result;
}
function $06b059d98c862dc3$var$translateService(op) {
    var patterns = $06b059d98c862dc3$var$translateOperation(op.input);
    if (patterns.type === 'group') patterns = patterns.patterns;
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    return {
        type: 'service',
        // Typings are wrong, name can also be a variable
        name: op.name,
        silent: op.silent,
        patterns: patterns
    };
}
function $06b059d98c862dc3$var$translateSlice(op) {
    var result = $06b059d98c862dc3$var$translateOperation(op.input);
    // results can be nested in a group object
    var obj = result;
    if (result.type && result.type === 'group') obj = result.patterns[0];
    if (op.start !== 0) obj.offset = op.start;
    if (op.length !== undefined) obj.limit = op.length;
    return result;
}
function $06b059d98c862dc3$var$translateUnion(op) {
    return {
        type: 'union',
        patterns: op.input.map($06b059d98c862dc3$var$translateOperation).map($06b059d98c862dc3$var$arrayToPattern)
    };
}
function $06b059d98c862dc3$var$translateValues(op) {
    // TODO: check if handled correctly when outside of select block
    return {
        type: 'values',
        values: op.bindings.map(function(binding) {
            var result = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = op.variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var v = _step.value;
                    var s = "?".concat(v.value);
                    if (binding[s]) result[s] = binding[s];
                    else result[s] = undefined;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return result;
        })
    };
}
// PATH COMPONENTS
function $06b059d98c862dc3$var$translateAlt(path) {
    var mapped = path.input.map($06b059d98c862dc3$var$translatePathComponent);
    if (mapped.every(function(entry) {
        return 'pathType' in entry && entry.pathType === '!';
    })) return {
        type: 'path',
        pathType: '!',
        items: [
            {
                type: 'path',
                pathType: '|',
                items: $06b059d98c862dc3$var$util_1["default"].flatten(mapped.map(function(entry) {
                    return entry.items;
                }))
            }
        ]
    };
    return {
        type: 'path',
        pathType: '|',
        items: mapped
    };
}
function $06b059d98c862dc3$var$translateInv(path) {
    if (path.path.type === $06b059d98c862dc3$var$types.NPS) {
        var inv = path.path.iris.map(function(iri) {
            return {
                type: 'path',
                pathType: '^',
                items: [
                    iri
                ]
            };
        });
        if (inv.length <= 1) return {
            type: 'path',
            pathType: '!',
            items: inv
        };
        return {
            type: 'path',
            pathType: '!',
            items: [
                {
                    type: 'path',
                    pathType: '|',
                    items: inv
                }
            ]
        };
    }
    return {
        type: 'path',
        pathType: '^',
        items: [
            $06b059d98c862dc3$var$translatePathComponent(path.path)
        ]
    };
}
function $06b059d98c862dc3$var$translateLink(path) {
    return path.iri;
}
function $06b059d98c862dc3$var$translateNps(path) {
    if (path.iris.length <= 1) return {
        type: 'path',
        pathType: '!',
        items: path.iris
    };
    return {
        type: 'path',
        pathType: '!',
        items: [
            {
                type: 'path',
                pathType: '|',
                items: path.iris
            }
        ]
    };
}
function $06b059d98c862dc3$var$translateOneOrMorePath(path) {
    return {
        type: 'path',
        pathType: '+',
        items: [
            $06b059d98c862dc3$var$translatePathComponent(path.path)
        ]
    };
}
function $06b059d98c862dc3$var$translateSeq(path) {
    return {
        type: 'path',
        pathType: '/',
        items: path.input.map($06b059d98c862dc3$var$translatePathComponent)
    };
}
function $06b059d98c862dc3$var$translateZeroOrMorePath(path) {
    return {
        type: 'path',
        pathType: '*',
        items: [
            $06b059d98c862dc3$var$translatePathComponent(path.path)
        ]
    };
}
function $06b059d98c862dc3$var$translateZeroOrOnePath(path) {
    // Typings are missing '?' operator
    return {
        type: 'path',
        // Typings are missing this path
        pathType: '?',
        items: [
            $06b059d98c862dc3$var$translatePathComponent(path.path)
        ]
    };
}
// UPDATE OPERATIONS
function $06b059d98c862dc3$var$translateCompositeUpdate(op) {
    var updates = op.updates.map(function(update) {
        var result = $06b059d98c862dc3$var$translateOperation(update);
        return result.updates[0];
    });
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $06b059d98c862dc3$var$translateDeleteInsert(op) {
    var _a;
    var where = op.where;
    var use = undefined;
    if (where && where.type === $06b059d98c862dc3$var$types.FROM) {
        var from = where;
        where = from.input;
        use = {
            "default": from["default"],
            named: from.named
        };
    }
    var updates = [
        {
            updateType: 'insertdelete',
            "delete": $06b059d98c862dc3$var$convertUpdatePatterns(op["delete"] || []),
            insert: $06b059d98c862dc3$var$convertUpdatePatterns(op.insert || [])
        }
    ];
    // Typings don't support 'using' yet
    if (use) updates[0].using = use;
    // corresponds to empty array in SPARQL.js
    if (!where || where.type === $06b059d98c862dc3$var$types.BGP && where.patterns.length === 0) updates[0].where = [];
    else {
        var graphs = [];
        var result = $06b059d98c862dc3$var$translateOperation($06b059d98c862dc3$var$removeQuadsRecursive(where, graphs));
        if (result.type === 'group') updates[0].where = result.patterns;
        else updates[0].where = [
            result
        ];
        // graph might not be applied yet since there was no project
        // this can only happen if there was a single graph
        if (graphs.length > 0) {
            if (graphs.length !== 1) throw new Error('This is unexpected and might indicate an error in graph handling for updates.');
            // ignore if default graph
            if (((_a = graphs[0]) === null || _a === void 0 ? void 0 : _a.value) !== '') updates[0].where = [
                {
                    type: 'graph',
                    patterns: updates[0].where,
                    name: graphs[0]
                }
            ];
        }
    }
    // not really necessary but can give cleaner looking queries
    if (!op["delete"] && !op.where) {
        updates[0].updateType = 'insert';
        delete updates[0]["delete"];
        delete updates[0].where;
    } else if (!op.insert && !op.where) {
        delete updates[0].insert;
        delete updates[0].where;
        if (op["delete"].some(function(pattern) {
            return pattern.subject.termType === 'Variable' || pattern.predicate.termType === 'Variable' || pattern.object.termType === 'Variable';
        })) updates[0].updateType = 'deletewhere';
        else updates[0].updateType = 'delete';
    } else if (!op.insert && op.where && op.where.type === 'bgp') {
        if ((0, $gevlR.isomorphic)(op["delete"], op.where.patterns)) {
            delete updates[0].where;
            updates[0].updateType = 'deletewhere';
        }
    }
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $06b059d98c862dc3$var$translateLoad(op) {
    // Typings are wrong, destiniation is optional
    var updates = [
        {
            type: 'load',
            silent: Boolean(op.silent),
            source: op.source
        }
    ];
    if (op.destination) updates[0].destination = op.destination;
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $06b059d98c862dc3$var$translateClear(op) {
    return $06b059d98c862dc3$var$translateClearCreateDrop(op, 'clear');
}
function $06b059d98c862dc3$var$translateCreate(op) {
    return $06b059d98c862dc3$var$translateClearCreateDrop(op, 'create');
}
function $06b059d98c862dc3$var$translateDrop(op) {
    return $06b059d98c862dc3$var$translateClearCreateDrop(op, 'drop');
}
function $06b059d98c862dc3$var$translateClearCreateDrop(op, type) {
    var updates = [
        {
            type: type,
            silent: Boolean(op.silent)
        }
    ];
    // Typings are wrong, type is not required, see for example "clear-drop" test
    if (op.source === 'DEFAULT') updates[0].graph = {
        "default": true
    };
    else if (op.source === 'NAMED') updates[0].graph = {
        named: true
    };
    else if (op.source === 'ALL') updates[0].graph = {
        all: true
    };
    else updates[0].graph = {
        type: 'graph',
        name: op.source
    };
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $06b059d98c862dc3$var$translateAdd(op) {
    return $06b059d98c862dc3$var$translateUpdateGraphShortcut(op, 'add');
}
function $06b059d98c862dc3$var$translateMove(op) {
    return $06b059d98c862dc3$var$translateUpdateGraphShortcut(op, 'move');
}
function $06b059d98c862dc3$var$translateCopy(op) {
    return $06b059d98c862dc3$var$translateUpdateGraphShortcut(op, 'copy');
}
function $06b059d98c862dc3$var$translateUpdateGraphShortcut(op, type) {
    var updates = [
        {
            type: type,
            silent: Boolean(op.silent)
        }
    ];
    updates[0].source = op.source === 'DEFAULT' ? {
        type: 'graph',
        "default": true
    } : {
        type: 'graph',
        name: op.source
    };
    updates[0].destination = op.destination === 'DEFAULT' ? {
        type: 'graph',
        "default": true
    } : {
        type: 'graph',
        name: op.destination
    };
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
// similar to removeQuads but more simplified for UPDATEs
function $06b059d98c862dc3$var$convertUpdatePatterns(patterns) {
    if (!patterns) return [];
    var graphs = {};
    patterns.forEach(function(pattern) {
        var graph = pattern.graph.value;
        if (!graphs[graph]) graphs[graph] = [];
        graphs[graph].push(pattern);
    });
    return Object.keys(graphs).map(function(graph) {
        if (graph === '') return {
            type: 'bgp',
            triples: graphs[graph].map($06b059d98c862dc3$var$translatePattern)
        };
        return {
            type: 'graph',
            triples: graphs[graph].map($06b059d98c862dc3$var$translatePattern),
            name: graphs[graph][0].graph
        };
    });
}
function $06b059d98c862dc3$var$removeQuads(op) {
    return $06b059d98c862dc3$var$removeQuadsRecursive(op, []);
}
// remove quads
function $06b059d98c862dc3$var$removeQuadsRecursive(op, graphs) {
    if (Array.isArray(op)) return op.map(function(sub) {
        return $06b059d98c862dc3$var$removeQuadsRecursive(sub, graphs);
    });
    if (!op.type) return op;
    // UPDATE operations with Patterns handle graphs a bit differently
    if (op.type === $06b059d98c862dc3$var$types.DELETE_INSERT) return op;
    if ((op.type === $06b059d98c862dc3$var$types.PATTERN || op.type === $06b059d98c862dc3$var$types.PATH) && op.graph) {
        graphs.push(op.graph);
        // Remove non-default graphs
        if (op.graph.name !== '') return op.type === $06b059d98c862dc3$var$types.PATTERN ? $06b059d98c862dc3$var$factory.createPattern(op.subject, op.predicate, op.object) : $06b059d98c862dc3$var$factory.createPath(op.subject, op.predicate, op.object);
        return op;
    }
    var result = {};
    var keyGraphs = {}; // unique graph per key
    var globalNames = {}; // track all the unique graph names for the entire Operation
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(op)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var newGraphs = [];
            result[key] = $06b059d98c862dc3$var$removeQuadsRecursive(op[key], newGraphs);
            if (newGraphs.length > 0) {
                keyGraphs[key] = newGraphs;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = newGraphs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var graph = _step1.value;
                        globalNames[graph.value] = graph;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var graphNameSet = Object.keys(globalNames);
    if (graphNameSet.length > 0) {
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        // We also need to create graph statement if we are at the edge of certain operations
        if (graphNameSet.length === 1 && ![
            $06b059d98c862dc3$var$types.PROJECT,
            $06b059d98c862dc3$var$types.SERVICE
        ].includes(op.type)) graphs.push(globalNames[graphNameSet[0]]);
        else if (op.type === $06b059d98c862dc3$var$types.BGP) // This is the specific case that got changed because of using quads.
        return $06b059d98c862dc3$var$splitBgpToGraphs(op, keyGraphs.patterns);
        else try {
            var _loop = function() {
                var key = _step2.value;
                var value = result[key];
                if (Array.isArray(value)) result[key] = value.map(function(child, idx) {
                    return keyGraphs[key][0].value === '' ? child : $06b059d98c862dc3$var$factory.createGraph(child, keyGraphs[key][idx]);
                });
                else if (keyGraphs[key][0].value !== '') result[key] = $06b059d98c862dc3$var$factory.createGraph(value, keyGraphs[key][0]);
            };
            // multiple graphs (or project), need to create graph objects for them
            for(var _iterator2 = Object.keys(keyGraphs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)_loop();
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    return result;
}
// `graphs` should be an array of length identical to `op.patterns`, containing the corresponding graph for each triple.
function $06b059d98c862dc3$var$splitBgpToGraphs(op, graphs) {
    var _a;
    // Split patterns per graph
    var graphPatterns = {};
    for(var i = 0; i < op.patterns.length; ++i){
        var pattern = op.patterns[i];
        var graphName = graphs[i].value;
        graphPatterns[graphName] = (_a = graphPatterns[graphName]) !== null && _a !== void 0 ? _a : {
            patterns: [],
            graph: graphs[i]
        };
        graphPatterns[graphName].patterns.push(pattern);
    }
    // Create graph objects for every cluster
    var children = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(graphPatterns)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $32TW8._)(_step.value, 2), graphName1 = _step_value[0], _step_value_ = _step_value[1], patterns = _step_value_.patterns, graph = _step_value_.graph;
            var bgp = $06b059d98c862dc3$var$factory.createBgp(patterns);
            children.push(graphName1 === '' ? bgp : $06b059d98c862dc3$var$factory.createGraph(bgp, graph));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Join the graph objects
    var join = children[0];
    for(var i1 = 1; i1 < children.length; ++i1)join = $06b059d98c862dc3$var$factory.createJoin([
        join,
        children[i1]
    ]);
    return join;
}

});
parcelRegister("gevlR", function(module, exports) {
"use strict";
var $bd1645eb5dcccbd6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd1645eb5dcccbd6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bd1645eb5dcccbd6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bd1645eb5dcccbd6$var$__exportStar((parcelRequire("6n3Hp")), module.exports);

});
parcelRegister("6n3Hp", function(module, exports) {

var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTermGrounded = module.exports.termToSignature = module.exports.quadToSignature = module.exports.sha1hex = module.exports.hashTerm = module.exports.hashTerms = module.exports.getGraphBlankNodes = module.exports.uniqGraph = module.exports.deindexGraph = module.exports.indexGraph = module.exports.getQuadsWithoutBlankNodes = module.exports.getQuadsWithBlankNodes = module.exports.hasValue = module.exports.hashValues = module.exports.getBijectionInner = module.exports.getBijection = module.exports.isomorphic = void 0;

var $168PV = parcelRequire("168PV");

var $gQYIc = parcelRequire("gQYIc");

var $ilNtL = parcelRequire("ilNtL");
/**
 * Determines if the two given graphs are isomorphic.
 *
 * @param {Quad[]} graphA An array of quads, order is not important.
 * @param {Quad[]} graphB An array of quads, order is not important.
 * @return {boolean} If the two given graphs are isomorphic.
 */ function $4a37c29f90efc6a0$var$isomorphic(graphA, graphB) {
    return !!$4a37c29f90efc6a0$var$getBijection(graphA, graphB);
}
module.exports.isomorphic = $4a37c29f90efc6a0$var$isomorphic;
/**
 * Calculate a hash of graphA blank nodes to graphB blank nodes.
 * This represents a bijection from graphA's blank nodes to graphB's blank nodes.
 *
 * @param {Quad[]} graphA An array of quads, order is not important.
 * @param {Quad[]} graphB An array of quads, order is not important.
 * @return {IBijection} A hash representing a bijection, or null if none could be found.
 */ function $4a37c29f90efc6a0$var$getBijection(graphA, graphB) {
    // Check if all (non-blanknode-containing) quads in the two graphs are equal.
    // We do this by creating a hash-based index for both graphs.
    var nonBlankIndexA = $4a37c29f90efc6a0$var$indexGraph($4a37c29f90efc6a0$var$getQuadsWithoutBlankNodes(graphA));
    var nonBlankIndexB = $4a37c29f90efc6a0$var$indexGraph($4a37c29f90efc6a0$var$getQuadsWithoutBlankNodes(graphB));
    if (Object.keys(nonBlankIndexA).length !== Object.keys(nonBlankIndexB).length) return null;
    for(var key in nonBlankIndexA){
        if (nonBlankIndexA[key] !== nonBlankIndexB[key]) return null;
    }
    // Pre-process data that needs to be present in each iteration of getBijectionInner.
    var blankQuadsA = $4a37c29f90efc6a0$var$uniqGraph($4a37c29f90efc6a0$var$getQuadsWithBlankNodes(graphA));
    var blankQuadsB = $4a37c29f90efc6a0$var$uniqGraph($4a37c29f90efc6a0$var$getQuadsWithBlankNodes(graphB));
    var blankNodesA = $4a37c29f90efc6a0$var$getGraphBlankNodes(graphA);
    var blankNodesB = $4a37c29f90efc6a0$var$getGraphBlankNodes(graphB);
    return $4a37c29f90efc6a0$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB);
}
module.exports.getBijection = $4a37c29f90efc6a0$var$getBijection;
function $4a37c29f90efc6a0$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB, groundedHashesA, groundedHashesB) {
    if (!groundedHashesA) groundedHashesA = {};
    if (!groundedHashesB) groundedHashesB = {};
    // Hash every term based on the signature of the quads if appears in.
    var _hashTerms = (0, $32TW8._)($4a37c29f90efc6a0$var$hashTerms(blankQuadsA, blankNodesA, groundedHashesA), 2), hashesA = _hashTerms[0], ungroundedHashesA = _hashTerms[1];
    var _hashTerms1 = (0, $32TW8._)($4a37c29f90efc6a0$var$hashTerms(blankQuadsB, blankNodesB, groundedHashesB), 2), hashesB = _hashTerms1[0], ungroundedHashesB = _hashTerms1[1];
    // Break quickly if a graph contains a grounded node that is not contained in the other graph.
    if (Object.keys(hashesA).length !== Object.keys(hashesB).length) return null;
    for(var hashKeyA in hashesA){
        if (!$4a37c29f90efc6a0$var$hasValue(hashesB, hashesA[hashKeyA])) return null;
    }
    // Map the blank nodes from graph A to the blank nodes of graph B using the created hashes.
    // Grounded hashes will also be equal, but not needed here, we will need them in the next recursion
    // (as we only recurse on grounded nodes).
    var bijection = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = blankNodesA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var blankNodeA = _step.value;
            var blankNodeAString = $gQYIc.termToString(blankNodeA);
            var blankNodeAHash = ungroundedHashesA[blankNodeAString];
            for(var blankNodeBString in ungroundedHashesB)if (ungroundedHashesB[blankNodeBString] === blankNodeAHash) {
                bijection[blankNodeAString] = blankNodeBString;
                delete ungroundedHashesB[blankNodeBString];
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check if all nodes from graph A and B are present in the bijection,
    // if not, speculatively mark pairs with matching ungrounded hashes as bijected, and recurse.
    if (!$4a37c29f90efc6a0$var$arraysEqual(Object.keys(bijection).sort(), blankNodesA.map($gQYIc.termToString).sort()) || !$4a37c29f90efc6a0$var$arraysEqual($4a37c29f90efc6a0$var$hashValues(bijection).sort(), blankNodesB.map($gQYIc.termToString).sort())) {
        // I have not yet been able to find any pathological cases where this code is reached.
        // This may be removable, but let's wait until someone proves that.
        bijection = null;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = blankNodesA[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var blankNodeA1 = _step1.value;
                // Only replace ungrounded node hashes
                var blankNodeAString1 = $gQYIc.termToString(blankNodeA1);
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                if (!hashesA[blankNodeAString1]) try {
                    for(var _iterator2 = blankNodesB[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var blankNodeB = _step2.value;
                        // Only replace ungrounded node hashes
                        var blankNodeBString1 = $gQYIc.termToString(blankNodeB);
                        if (!hashesB[blankNodeBString1]) {
                            if (ungroundedHashesA[blankNodeAString1] === ungroundedHashesB[blankNodeBString1]) {
                                var hash = $4a37c29f90efc6a0$var$sha1hex(blankNodeAString1);
                                bijection = $4a37c29f90efc6a0$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB, Object.assign(Object.assign({}, hashesA), (0, $cqEAj._)({}, blankNodeAString1, hash)), Object.assign(Object.assign({}, hashesB), (0, $cqEAj._)({}, blankNodeBString1, hash)));
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return bijection;
}
module.exports.getBijectionInner = $4a37c29f90efc6a0$var$getBijectionInner;
function $4a37c29f90efc6a0$var$arraysEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    for(var i = array1.length; i--;){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
/**
 * Get all values from the given hash
 * @param hash A hash.
 * @return {any[]} The array of values.
 */ function $4a37c29f90efc6a0$var$hashValues(hash) {
    var arr = [];
    for(var e in hash)arr.push(hash[e]);
    return arr;
}
module.exports.hashValues = $4a37c29f90efc6a0$var$hashValues;
/**
 * Check if the given hash contains the given value.
 * @param hash A hash.
 * @param {string} value A value.
 * @return {boolean} If it contains the value.
 */ function $4a37c29f90efc6a0$var$hasValue(hash, value) {
    for(var hashValue in hash){
        if (hash[hashValue] === value) return true;
    }
    return false;
}
module.exports.hasValue = $4a37c29f90efc6a0$var$hasValue;
/**
 * Get all quads with blank nodes.
 * @param {Quad[]} graph An array of quads.
 * @return {Quad[]} An array of quads with blank nodes
 */ function $4a37c29f90efc6a0$var$getQuadsWithBlankNodes(graph) {
    return graph.filter(function(quad) {
        return $ilNtL.someTerms(quad, function(value) {
            return value.termType === 'BlankNode' || value.termType === 'Quad' && $ilNtL.getTermsNested(value).some(function(term) {
                return term.termType === 'BlankNode';
            });
        });
    });
}
module.exports.getQuadsWithBlankNodes = $4a37c29f90efc6a0$var$getQuadsWithBlankNodes;
/**
 * Get all quads without blank nodes.
 * @param {Quad[]} graph An array of quads.
 * @return {Quad[]} An array of quads without blank nodes
 */ function $4a37c29f90efc6a0$var$getQuadsWithoutBlankNodes(graph) {
    return graph.filter(function(quad) {
        return $ilNtL.everyTerms(quad, function(value) {
            return value.termType !== 'BlankNode' && !(value.termType === 'Quad' && $ilNtL.getTermsNested(value).some(function(term) {
                return term.termType === 'BlankNode';
            }));
        });
    });
}
module.exports.getQuadsWithoutBlankNodes = $4a37c29f90efc6a0$var$getQuadsWithoutBlankNodes;
/**
 * Create a hash-based index of the given graph.
 * @param {Quad[]} graph An array of quads, the order does not matter.
 * @return {{[p: string]: boolean}} A hash-based datastructure representing the graph.
 */ function $4a37c29f90efc6a0$var$indexGraph(graph) {
    var index = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = graph[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var quad = _step.value;
            index[JSON.stringify($gQYIc.quadToStringQuad(quad))] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return index;
}
module.exports.indexGraph = $4a37c29f90efc6a0$var$indexGraph;
/**
 * Create a graph from the given hash-based index.
 * @param {{[p: string]: boolean}} indexedGraph A hash-based datastructure representing the graph.
 * @return {Quad[]} An array of quads, the order does not matter.
 */ function $4a37c29f90efc6a0$var$deindexGraph(indexedGraph) {
    return Object.keys(indexedGraph).map(function(str) {
        return $gQYIc.stringQuadToQuad(JSON.parse(str));
    });
}
module.exports.deindexGraph = $4a37c29f90efc6a0$var$deindexGraph;
/**
 * Unique-ify the given RDF graph based on strict equality.
 * The output graph will consist of new quad and term instances.
 * @param {Quad[]} graph An input graph.
 * @return {Quad[]} The input graph without duplicates.
 */ function $4a37c29f90efc6a0$var$uniqGraph(graph) {
    return $4a37c29f90efc6a0$var$deindexGraph($4a37c29f90efc6a0$var$indexGraph(graph));
}
module.exports.uniqGraph = $4a37c29f90efc6a0$var$uniqGraph;
/**
 * Find all blank nodes in the given graph.
 * @param {Quad[]} graph An array of quads.
 * @return {BlankNode[]} A list of (unique) blank nodes.
 */ function $4a37c29f90efc6a0$var$getGraphBlankNodes(graph) {
    return $ilNtL.uniqTerms(graph.map(function(quad) {
        return $ilNtL.getBlankNodes($ilNtL.getTermsNested(quad));
    }).reduce(function(acc, val) {
        return acc.concat(val);
    }, []));
}
module.exports.getGraphBlankNodes = $4a37c29f90efc6a0$var$getGraphBlankNodes;
/**
 * Create term hashes for the given set of quads and blank node terms.
 *
 * @param {Quad[]} quads A set of quads.
 * @param {Term[]} terms Blank node terms.
 * @param {ITermHash} groundedHashes Grounded term hashes that are used to create more specific signatures
 *                                   of other terms, because they are based on non-blank nodes and grounded blank nodes.
 * @return {[ITermHash]} A tuple of grounded and ungrounded hashes.
 */ function $4a37c29f90efc6a0$var$hashTerms(quads, terms, groundedHashes) {
    var hashes = Object.assign({}, groundedHashes);
    var ungroundedHashes = {};
    var hashNeeded = true;
    // Iteratively mark nodes as grounded.
    // If a node is marked as grounded, then the next iteration can lead to new grounded states
    while(hashNeeded){
        var initialGroundedNodesCount = Object.keys(hashes).length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = terms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var term = _step.value;
                var termString = $gQYIc.termToString(term);
                if (!hashes[termString]) {
                    var _hashTerm = (0, $32TW8._)($4a37c29f90efc6a0$var$hashTerm(term, quads, hashes), 2), grounded = _hashTerm[0], hash = _hashTerm[1];
                    if (grounded) hashes[termString] = hash;
                    ungroundedHashes[termString] = hash;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // All terms that have a unique hash at this point can be marked as grounded
        var uniques = {};
        for(var termKey in ungroundedHashes){
            var hash1 = ungroundedHashes[termKey];
            if (uniques[hash1] === undefined) uniques[hash1] = termKey;
            else uniques[hash1] = false;
        }
        for(var hash2 in uniques){
            var value = uniques[hash2];
            if (value) hashes[value] = hash2;
        }
        // Check if the loop needs to terminate
        hashNeeded = initialGroundedNodesCount !== Object.keys(hashes).length;
    }
    return [
        hashes,
        ungroundedHashes
    ];
}
module.exports.hashTerms = $4a37c29f90efc6a0$var$hashTerms;
/**
 * Generate a hash for the given term based on the signature of the quads it appears in.
 *
 * Signatures are made up of grounded terms in quads that are associated with a term,
 * i.e., everything except for ungrounded blank nodes.
 * The hash is created by hashing a sorted list of each quad's signature,
 * where each quad signature is a concatenation of the signature of all grounded terms.
 *
 * Terms are considered grounded if they are a member in the given hash AND if they are not the given term.
 *
 * @param {Term} term The term to get the hash around.
 * @param {Quad[]} quads The quads to include in the hashing.
 * @param {ITermHash} hashes A grounded term hash object.
 * @return {[boolean , string]} A tuple indicating if the given term is grounded in all the given quads, and the hash.
 */ function $4a37c29f90efc6a0$var$hashTerm(term, quads, hashes) {
    var quadSignatures = [];
    var grounded = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = quads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var quad = _step.value;
            var terms = $ilNtL.getTermsNested(quad);
            if (terms.some(function(quadTerm) {
                return quadTerm.equals(term);
            })) {
                quadSignatures.push($4a37c29f90efc6a0$var$quadToSignature(quad, hashes, term));
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = terms[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var quadTerm = _step1.value;
                        if (!$4a37c29f90efc6a0$var$isTermGrounded(quadTerm, hashes) && !quadTerm.equals(term)) grounded = false;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var hash = $4a37c29f90efc6a0$var$sha1hex(quadSignatures.sort().join(''));
    return [
        grounded,
        hash
    ];
}
module.exports.hashTerm = $4a37c29f90efc6a0$var$hashTerm;
/**
 * Create a hash using sha1 as a hex digest.
 * @param {string | Buffer | NodeJS.TypedArray | DataView} data Something to hash.
 * @return {string} A hash string.
 */ function $4a37c29f90efc6a0$var$sha1hex(data) {
    return $168PV.sha1().update(data).digest('hex');
}
module.exports.sha1hex = $4a37c29f90efc6a0$var$sha1hex;
/**
 * Convert the given quad to a string signature so that it can be used in the hash structure.
 * @param {Quad} quad A quad.
 * @param {ITermHash} hashes A grounded term hash object.
 * @param {Term} term A target term to compare with.
 * @return {string} A string signature.
 */ function $4a37c29f90efc6a0$var$quadToSignature(quad, hashes, term) {
    return $ilNtL.getTerms(quad).map(function(quadTerm) {
        return $4a37c29f90efc6a0$var$termToSignature(quadTerm, hashes, term);
    }).join('|');
}
module.exports.quadToSignature = $4a37c29f90efc6a0$var$quadToSignature;
/**
 * Convert the given term to a string signature so that it can be used in the hash structure.
 * @param {Term} term A term.
 * @param {ITermHash} hashes A grounded term hash object.
 * @param {Term} target A target term to compare with.
 * @return {string} A string signature.
 */ function $4a37c29f90efc6a0$var$termToSignature(term, hashes, target) {
    if (term.equals(target)) return '@self';
    else if (term.termType === 'BlankNode') return hashes[$gQYIc.termToString(term)] || '@blank';
    else if (term.termType === 'Quad') return "<".concat($4a37c29f90efc6a0$var$quadToSignature(term, hashes, target), ">");
    else return $gQYIc.termToString(term);
}
module.exports.termToSignature = $4a37c29f90efc6a0$var$termToSignature;
/**
 * Check if a term is grounded.
 *
 * A term is grounded if it is not a blank node
 * or if it included in the given hash of grounded nodes.
 *
 * @param {Term} term A term.
 * @param {ITermHash} hashes A grounded term hash object.
 * @return {boolean} If the given term is grounded.
 */ function $4a37c29f90efc6a0$var$isTermGrounded(term, hashes) {
    return term.termType !== 'BlankNode' && !(term.termType === 'Quad' && $ilNtL.getTermsNested(term).some(function(subTerm) {
        return !$4a37c29f90efc6a0$var$isTermGrounded(subTerm, hashes);
    })) || !!hashes[$gQYIc.termToString(term)];
}
module.exports.isTermGrounded = $4a37c29f90efc6a0$var$isTermGrounded;

});
parcelRegister("168PV", function(module, exports) {
var $0ccd34b4bed80532$var$hash = module.exports;

$0ccd34b4bed80532$var$hash.utils = (parcelRequire("lWITE"));

$0ccd34b4bed80532$var$hash.common = (parcelRequire("kF0CT"));

$0ccd34b4bed80532$var$hash.sha = (parcelRequire("bN4Ay"));

$0ccd34b4bed80532$var$hash.ripemd = (parcelRequire("fBt6e"));

$0ccd34b4bed80532$var$hash.hmac = (parcelRequire("grq85"));
// Proxy hash functions to the main object
$0ccd34b4bed80532$var$hash.sha1 = $0ccd34b4bed80532$var$hash.sha.sha1;
$0ccd34b4bed80532$var$hash.sha256 = $0ccd34b4bed80532$var$hash.sha.sha256;
$0ccd34b4bed80532$var$hash.sha224 = $0ccd34b4bed80532$var$hash.sha.sha224;
$0ccd34b4bed80532$var$hash.sha384 = $0ccd34b4bed80532$var$hash.sha.sha384;
$0ccd34b4bed80532$var$hash.sha512 = $0ccd34b4bed80532$var$hash.sha.sha512;
$0ccd34b4bed80532$var$hash.ripemd160 = $0ccd34b4bed80532$var$hash.ripemd.ripemd160;

});
parcelRegister("lWITE", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $ffa1d74c11378782$export$69f1b2dcda23c5f8; }, function (v) { return $ffa1d74c11378782$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $ffa1d74c11378782$export$45b10814cc054894; }, function (v) { return $ffa1d74c11378782$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $ffa1d74c11378782$export$7ea66e3774a60b67; }, function (v) { return $ffa1d74c11378782$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $ffa1d74c11378782$export$34a52f00f601f6f1; }, function (v) { return $ffa1d74c11378782$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $ffa1d74c11378782$export$812b0cbd5e8a72ab; }, function (v) { return $ffa1d74c11378782$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $ffa1d74c11378782$export$f24f9e11d63bb314; }, function (v) { return $ffa1d74c11378782$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $ffa1d74c11378782$export$b71357c7e07ca1f1; }, function (v) { return $ffa1d74c11378782$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $ffa1d74c11378782$export$2e58a4b541fdcbe8; }, function (v) { return $ffa1d74c11378782$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $ffa1d74c11378782$export$183b950bde9faab8; }, function (v) { return $ffa1d74c11378782$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $ffa1d74c11378782$export$4785c77169fea59e; }, function (v) { return $ffa1d74c11378782$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $ffa1d74c11378782$export$242a185dfcffac5b; }, function (v) { return $ffa1d74c11378782$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $ffa1d74c11378782$export$58c04ae0ae31877d; }, function (v) { return $ffa1d74c11378782$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $ffa1d74c11378782$export$d058ca695f8c6f11; }, function (v) { return $ffa1d74c11378782$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $ffa1d74c11378782$export$a1efd7fc3e986367; }, function (v) { return $ffa1d74c11378782$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $ffa1d74c11378782$export$bbfea4a2b5abaab4; }, function (v) { return $ffa1d74c11378782$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $ffa1d74c11378782$export$97ad4afc7de86152; }, function (v) { return $ffa1d74c11378782$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $ffa1d74c11378782$export$ce4673d9a79f6a4b; }, function (v) { return $ffa1d74c11378782$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $ffa1d74c11378782$export$786cc99fc6eedc0b; }, function (v) { return $ffa1d74c11378782$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $ffa1d74c11378782$export$45c59b9a1848dd0; }, function (v) { return $ffa1d74c11378782$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $ffa1d74c11378782$export$50d8f613e76d3034; }, function (v) { return $ffa1d74c11378782$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $ffa1d74c11378782$export$b8e83683c60ee162; }, function (v) { return $ffa1d74c11378782$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $ffa1d74c11378782$export$aeeb51790d1bcc4a; }, function (v) { return $ffa1d74c11378782$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $ffa1d74c11378782$export$bb7c616f719ad9c; }, function (v) { return $ffa1d74c11378782$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $ffa1d74c11378782$export$4d63290824f9d7df; }, function (v) { return $ffa1d74c11378782$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $ffa1d74c11378782$export$2f64ceb90ef28ea1; }, function (v) { return $ffa1d74c11378782$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $ffa1d74c11378782$export$8d2089d465f6d10d; }, function (v) { return $ffa1d74c11378782$export$8d2089d465f6d10d = v; });
var $ffa1d74c11378782$export$69f1b2dcda23c5f8;
var $ffa1d74c11378782$export$45b10814cc054894;
var $ffa1d74c11378782$export$7ea66e3774a60b67;
var $ffa1d74c11378782$export$34a52f00f601f6f1;
var $ffa1d74c11378782$export$812b0cbd5e8a72ab;
var $ffa1d74c11378782$export$f24f9e11d63bb314;
var $ffa1d74c11378782$export$b71357c7e07ca1f1;
var $ffa1d74c11378782$export$2e58a4b541fdcbe8;
var $ffa1d74c11378782$export$183b950bde9faab8;
var $ffa1d74c11378782$export$4785c77169fea59e;
var $ffa1d74c11378782$export$242a185dfcffac5b;
var $ffa1d74c11378782$export$58c04ae0ae31877d;
var $ffa1d74c11378782$export$d058ca695f8c6f11;
var $ffa1d74c11378782$export$a1efd7fc3e986367;
var $ffa1d74c11378782$export$bbfea4a2b5abaab4;
var $ffa1d74c11378782$export$97ad4afc7de86152;
var $ffa1d74c11378782$export$ce4673d9a79f6a4b;
var $ffa1d74c11378782$export$786cc99fc6eedc0b;
var $ffa1d74c11378782$export$45c59b9a1848dd0;
var $ffa1d74c11378782$export$50d8f613e76d3034;
var $ffa1d74c11378782$export$b8e83683c60ee162;
var $ffa1d74c11378782$export$aeeb51790d1bcc4a;
var $ffa1d74c11378782$export$bb7c616f719ad9c;
var $ffa1d74c11378782$export$4d63290824f9d7df;
var $ffa1d74c11378782$export$2f64ceb90ef28ea1;
var $ffa1d74c11378782$export$8d2089d465f6d10d;
'use strict';

var $fXUQh = parcelRequire("fXUQh");

var $a7SRP = parcelRequire("a7SRP");
$ffa1d74c11378782$export$69f1b2dcda23c5f8 = $a7SRP;
function $ffa1d74c11378782$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $ffa1d74c11378782$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($ffa1d74c11378782$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$ffa1d74c11378782$export$45b10814cc054894 = $ffa1d74c11378782$var$toArray;
function $ffa1d74c11378782$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $ffa1d74c11378782$var$zero2(msg[i].toString(16));
    return res;
}
$ffa1d74c11378782$export$7ea66e3774a60b67 = $ffa1d74c11378782$var$toHex;
function $ffa1d74c11378782$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$ffa1d74c11378782$export$34a52f00f601f6f1 = $ffa1d74c11378782$var$htonl;
function $ffa1d74c11378782$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $ffa1d74c11378782$var$htonl(w);
        res += $ffa1d74c11378782$var$zero8(w.toString(16));
    }
    return res;
}
$ffa1d74c11378782$export$812b0cbd5e8a72ab = $ffa1d74c11378782$var$toHex32;
function $ffa1d74c11378782$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$ffa1d74c11378782$export$f24f9e11d63bb314 = $ffa1d74c11378782$var$zero2;
function $ffa1d74c11378782$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$ffa1d74c11378782$export$b71357c7e07ca1f1 = $ffa1d74c11378782$var$zero8;
function $ffa1d74c11378782$var$join32(msg, start, end, endian) {
    var len = end - start;
    $fXUQh(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$ffa1d74c11378782$export$2e58a4b541fdcbe8 = $ffa1d74c11378782$var$join32;
function $ffa1d74c11378782$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$ffa1d74c11378782$export$183b950bde9faab8 = $ffa1d74c11378782$var$split32;
function $ffa1d74c11378782$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$ffa1d74c11378782$export$4785c77169fea59e = $ffa1d74c11378782$var$rotr32;
function $ffa1d74c11378782$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$ffa1d74c11378782$export$242a185dfcffac5b = $ffa1d74c11378782$var$rotl32;
function $ffa1d74c11378782$var$sum32(a, b) {
    return a + b >>> 0;
}
$ffa1d74c11378782$export$58c04ae0ae31877d = $ffa1d74c11378782$var$sum32;
function $ffa1d74c11378782$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$ffa1d74c11378782$export$d058ca695f8c6f11 = $ffa1d74c11378782$var$sum32_3;
function $ffa1d74c11378782$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$ffa1d74c11378782$export$a1efd7fc3e986367 = $ffa1d74c11378782$var$sum32_4;
function $ffa1d74c11378782$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$ffa1d74c11378782$export$bbfea4a2b5abaab4 = $ffa1d74c11378782$var$sum32_5;
function $ffa1d74c11378782$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$ffa1d74c11378782$export$97ad4afc7de86152 = $ffa1d74c11378782$var$sum64;
function $ffa1d74c11378782$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$ffa1d74c11378782$export$ce4673d9a79f6a4b = $ffa1d74c11378782$var$sum64_hi;
function $ffa1d74c11378782$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$ffa1d74c11378782$export$786cc99fc6eedc0b = $ffa1d74c11378782$var$sum64_lo;
function $ffa1d74c11378782$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$ffa1d74c11378782$export$45c59b9a1848dd0 = $ffa1d74c11378782$var$sum64_4_hi;
function $ffa1d74c11378782$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$ffa1d74c11378782$export$50d8f613e76d3034 = $ffa1d74c11378782$var$sum64_4_lo;
function $ffa1d74c11378782$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$ffa1d74c11378782$export$b8e83683c60ee162 = $ffa1d74c11378782$var$sum64_5_hi;
function $ffa1d74c11378782$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$ffa1d74c11378782$export$aeeb51790d1bcc4a = $ffa1d74c11378782$var$sum64_5_lo;
function $ffa1d74c11378782$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$ffa1d74c11378782$export$bb7c616f719ad9c = $ffa1d74c11378782$var$rotr64_hi;
function $ffa1d74c11378782$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$ffa1d74c11378782$export$4d63290824f9d7df = $ffa1d74c11378782$var$rotr64_lo;
function $ffa1d74c11378782$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$ffa1d74c11378782$export$2f64ceb90ef28ea1 = $ffa1d74c11378782$var$shr64_hi;
function $ffa1d74c11378782$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$ffa1d74c11378782$export$8d2089d465f6d10d = $ffa1d74c11378782$var$shr64_lo;

});
parcelRegister("fXUQh", function(module, exports) {
module.exports = $b9f87563b19d73eb$var$assert;
function $b9f87563b19d73eb$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$b9f87563b19d73eb$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("a7SRP", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("kF0CT", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $f0a81f58c7f547e1$export$8687658379b577e6; }, function (v) { return $f0a81f58c7f547e1$export$8687658379b577e6 = v; });
var $f0a81f58c7f547e1$export$8687658379b577e6;
'use strict';

var $lWITE = parcelRequire("lWITE");

var $fXUQh = parcelRequire("fXUQh");
function $f0a81f58c7f547e1$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$f0a81f58c7f547e1$export$8687658379b577e6 = $f0a81f58c7f547e1$var$BlockHash;
$f0a81f58c7f547e1$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $lWITE.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $lWITE.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$f0a81f58c7f547e1$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $fXUQh(this.pending === null);
    return this._digest(enc);
};
$f0a81f58c7f547e1$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("bN4Ay", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $8957d481bd54044e$export$5091bdda49ba90f5; }, function (v) { return $8957d481bd54044e$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $8957d481bd54044e$export$97b70509d4e397ea; }, function (v) { return $8957d481bd54044e$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $8957d481bd54044e$export$bced8d2aada2d1c9; }, function (v) { return $8957d481bd54044e$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $8957d481bd54044e$export$612d47d55dedde45; }, function (v) { return $8957d481bd54044e$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $8957d481bd54044e$export$a888d2532e6dc7bb; }, function (v) { return $8957d481bd54044e$export$a888d2532e6dc7bb = v; });
var $8957d481bd54044e$export$5091bdda49ba90f5;
var $8957d481bd54044e$export$97b70509d4e397ea;
var $8957d481bd54044e$export$bced8d2aada2d1c9;
var $8957d481bd54044e$export$612d47d55dedde45;
var $8957d481bd54044e$export$a888d2532e6dc7bb;
'use strict';

$8957d481bd54044e$export$5091bdda49ba90f5 = (parcelRequire("l2eZJ"));

$8957d481bd54044e$export$97b70509d4e397ea = (parcelRequire("bDdYm"));

$8957d481bd54044e$export$bced8d2aada2d1c9 = (parcelRequire("7GYdm"));

$8957d481bd54044e$export$612d47d55dedde45 = (parcelRequire("9Xslv"));

$8957d481bd54044e$export$a888d2532e6dc7bb = (parcelRequire("k4Du4"));

});
parcelRegister("l2eZJ", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $kF0CT = parcelRequire("kF0CT");

var $i1Q3x = parcelRequire("i1Q3x");
var $f5056a7cb8e5086c$var$rotl32 = $lWITE.rotl32;
var $f5056a7cb8e5086c$var$sum32 = $lWITE.sum32;
var $f5056a7cb8e5086c$var$sum32_5 = $lWITE.sum32_5;
var $f5056a7cb8e5086c$var$ft_1 = $i1Q3x.ft_1;
var $f5056a7cb8e5086c$var$BlockHash = $kF0CT.BlockHash;
var $f5056a7cb8e5086c$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $f5056a7cb8e5086c$var$SHA1() {
    if (!(this instanceof $f5056a7cb8e5086c$var$SHA1)) return new $f5056a7cb8e5086c$var$SHA1();
    $f5056a7cb8e5086c$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$lWITE.inherits($f5056a7cb8e5086c$var$SHA1, $f5056a7cb8e5086c$var$BlockHash);
module.exports = $f5056a7cb8e5086c$var$SHA1;
$f5056a7cb8e5086c$var$SHA1.blockSize = 512;
$f5056a7cb8e5086c$var$SHA1.outSize = 160;
$f5056a7cb8e5086c$var$SHA1.hmacStrength = 80;
$f5056a7cb8e5086c$var$SHA1.padLength = 64;
$f5056a7cb8e5086c$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $f5056a7cb8e5086c$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $f5056a7cb8e5086c$var$sum32_5($f5056a7cb8e5086c$var$rotl32(a, 5), $f5056a7cb8e5086c$var$ft_1(s, b, c, d), e, W[i], $f5056a7cb8e5086c$var$sha1_K[s]);
        e = d;
        d = c;
        c = $f5056a7cb8e5086c$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $f5056a7cb8e5086c$var$sum32(this.h[0], a);
    this.h[1] = $f5056a7cb8e5086c$var$sum32(this.h[1], b);
    this.h[2] = $f5056a7cb8e5086c$var$sum32(this.h[2], c);
    this.h[3] = $f5056a7cb8e5086c$var$sum32(this.h[3], d);
    this.h[4] = $f5056a7cb8e5086c$var$sum32(this.h[4], e);
};
$f5056a7cb8e5086c$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lWITE.toHex32(this.h, 'big');
    else return $lWITE.split32(this.h, 'big');
};

});
parcelRegister("i1Q3x", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $d200b338b17d3002$export$5a92649d7ddb9f63; }, function (v) { return $d200b338b17d3002$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $d200b338b17d3002$export$c6d0d020c3a6269; }, function (v) { return $d200b338b17d3002$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $d200b338b17d3002$export$eb90c27fca05f956; }, function (v) { return $d200b338b17d3002$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $d200b338b17d3002$export$14a4a98e063b1999; }, function (v) { return $d200b338b17d3002$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $d200b338b17d3002$export$d20cecfa1564c686; }, function (v) { return $d200b338b17d3002$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $d200b338b17d3002$export$44fd472a12fc6db; }, function (v) { return $d200b338b17d3002$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $d200b338b17d3002$export$1ed238bb6ea1dd47; }, function (v) { return $d200b338b17d3002$export$1ed238bb6ea1dd47 = v; });
var $d200b338b17d3002$export$5a92649d7ddb9f63;
var $d200b338b17d3002$export$c6d0d020c3a6269;
var $d200b338b17d3002$export$eb90c27fca05f956;
var $d200b338b17d3002$export$cc992891a14496a1;
var $d200b338b17d3002$export$14a4a98e063b1999;
var $d200b338b17d3002$export$d20cecfa1564c686;
var $d200b338b17d3002$export$44fd472a12fc6db;
var $d200b338b17d3002$export$1ed238bb6ea1dd47;
'use strict';

var $lWITE = parcelRequire("lWITE");
var $d200b338b17d3002$var$rotr32 = $lWITE.rotr32;
function $d200b338b17d3002$var$ft_1(s, x, y, z) {
    if (s === 0) return $d200b338b17d3002$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $d200b338b17d3002$var$p32(x, y, z);
    if (s === 2) return $d200b338b17d3002$var$maj32(x, y, z);
}
$d200b338b17d3002$export$5a92649d7ddb9f63 = $d200b338b17d3002$var$ft_1;
function $d200b338b17d3002$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$d200b338b17d3002$export$c6d0d020c3a6269 = $d200b338b17d3002$var$ch32;
function $d200b338b17d3002$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$d200b338b17d3002$export$eb90c27fca05f956 = $d200b338b17d3002$var$maj32;
function $d200b338b17d3002$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$d200b338b17d3002$export$cc992891a14496a1 = $d200b338b17d3002$var$p32;
function $d200b338b17d3002$var$s0_256(x) {
    return $d200b338b17d3002$var$rotr32(x, 2) ^ $d200b338b17d3002$var$rotr32(x, 13) ^ $d200b338b17d3002$var$rotr32(x, 22);
}
$d200b338b17d3002$export$14a4a98e063b1999 = $d200b338b17d3002$var$s0_256;
function $d200b338b17d3002$var$s1_256(x) {
    return $d200b338b17d3002$var$rotr32(x, 6) ^ $d200b338b17d3002$var$rotr32(x, 11) ^ $d200b338b17d3002$var$rotr32(x, 25);
}
$d200b338b17d3002$export$d20cecfa1564c686 = $d200b338b17d3002$var$s1_256;
function $d200b338b17d3002$var$g0_256(x) {
    return $d200b338b17d3002$var$rotr32(x, 7) ^ $d200b338b17d3002$var$rotr32(x, 18) ^ x >>> 3;
}
$d200b338b17d3002$export$44fd472a12fc6db = $d200b338b17d3002$var$g0_256;
function $d200b338b17d3002$var$g1_256(x) {
    return $d200b338b17d3002$var$rotr32(x, 17) ^ $d200b338b17d3002$var$rotr32(x, 19) ^ x >>> 10;
}
$d200b338b17d3002$export$1ed238bb6ea1dd47 = $d200b338b17d3002$var$g1_256;

});


parcelRegister("bDdYm", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $7GYdm = parcelRequire("7GYdm");
function $877e2cdf1e08aeb7$var$SHA224() {
    if (!(this instanceof $877e2cdf1e08aeb7$var$SHA224)) return new $877e2cdf1e08aeb7$var$SHA224();
    $7GYdm.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$lWITE.inherits($877e2cdf1e08aeb7$var$SHA224, $7GYdm);
module.exports = $877e2cdf1e08aeb7$var$SHA224;
$877e2cdf1e08aeb7$var$SHA224.blockSize = 512;
$877e2cdf1e08aeb7$var$SHA224.outSize = 224;
$877e2cdf1e08aeb7$var$SHA224.hmacStrength = 192;
$877e2cdf1e08aeb7$var$SHA224.padLength = 64;
$877e2cdf1e08aeb7$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $lWITE.toHex32(this.h.slice(0, 7), 'big');
    else return $lWITE.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("7GYdm", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $kF0CT = parcelRequire("kF0CT");

var $i1Q3x = parcelRequire("i1Q3x");

var $fXUQh = parcelRequire("fXUQh");
var $599b2a00d8547e14$var$sum32 = $lWITE.sum32;
var $599b2a00d8547e14$var$sum32_4 = $lWITE.sum32_4;
var $599b2a00d8547e14$var$sum32_5 = $lWITE.sum32_5;
var $599b2a00d8547e14$var$ch32 = $i1Q3x.ch32;
var $599b2a00d8547e14$var$maj32 = $i1Q3x.maj32;
var $599b2a00d8547e14$var$s0_256 = $i1Q3x.s0_256;
var $599b2a00d8547e14$var$s1_256 = $i1Q3x.s1_256;
var $599b2a00d8547e14$var$g0_256 = $i1Q3x.g0_256;
var $599b2a00d8547e14$var$g1_256 = $i1Q3x.g1_256;
var $599b2a00d8547e14$var$BlockHash = $kF0CT.BlockHash;
var $599b2a00d8547e14$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $599b2a00d8547e14$var$SHA256() {
    if (!(this instanceof $599b2a00d8547e14$var$SHA256)) return new $599b2a00d8547e14$var$SHA256();
    $599b2a00d8547e14$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $599b2a00d8547e14$var$sha256_K;
    this.W = new Array(64);
}
$lWITE.inherits($599b2a00d8547e14$var$SHA256, $599b2a00d8547e14$var$BlockHash);
module.exports = $599b2a00d8547e14$var$SHA256;
$599b2a00d8547e14$var$SHA256.blockSize = 512;
$599b2a00d8547e14$var$SHA256.outSize = 256;
$599b2a00d8547e14$var$SHA256.hmacStrength = 192;
$599b2a00d8547e14$var$SHA256.padLength = 64;
$599b2a00d8547e14$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $599b2a00d8547e14$var$sum32_4($599b2a00d8547e14$var$g1_256(W[i - 2]), W[i - 7], $599b2a00d8547e14$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $fXUQh(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $599b2a00d8547e14$var$sum32_5(h, $599b2a00d8547e14$var$s1_256(e), $599b2a00d8547e14$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $599b2a00d8547e14$var$sum32($599b2a00d8547e14$var$s0_256(a), $599b2a00d8547e14$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $599b2a00d8547e14$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $599b2a00d8547e14$var$sum32(T1, T2);
    }
    this.h[0] = $599b2a00d8547e14$var$sum32(this.h[0], a);
    this.h[1] = $599b2a00d8547e14$var$sum32(this.h[1], b);
    this.h[2] = $599b2a00d8547e14$var$sum32(this.h[2], c);
    this.h[3] = $599b2a00d8547e14$var$sum32(this.h[3], d);
    this.h[4] = $599b2a00d8547e14$var$sum32(this.h[4], e);
    this.h[5] = $599b2a00d8547e14$var$sum32(this.h[5], f);
    this.h[6] = $599b2a00d8547e14$var$sum32(this.h[6], g);
    this.h[7] = $599b2a00d8547e14$var$sum32(this.h[7], h);
};
$599b2a00d8547e14$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lWITE.toHex32(this.h, 'big');
    else return $lWITE.split32(this.h, 'big');
};

});


parcelRegister("9Xslv", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $k4Du4 = parcelRequire("k4Du4");
function $73ff9ca4b2c57f6f$var$SHA384() {
    if (!(this instanceof $73ff9ca4b2c57f6f$var$SHA384)) return new $73ff9ca4b2c57f6f$var$SHA384();
    $k4Du4.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$lWITE.inherits($73ff9ca4b2c57f6f$var$SHA384, $k4Du4);
module.exports = $73ff9ca4b2c57f6f$var$SHA384;
$73ff9ca4b2c57f6f$var$SHA384.blockSize = 1024;
$73ff9ca4b2c57f6f$var$SHA384.outSize = 384;
$73ff9ca4b2c57f6f$var$SHA384.hmacStrength = 192;
$73ff9ca4b2c57f6f$var$SHA384.padLength = 128;
$73ff9ca4b2c57f6f$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lWITE.toHex32(this.h.slice(0, 12), 'big');
    else return $lWITE.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("k4Du4", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $kF0CT = parcelRequire("kF0CT");

var $fXUQh = parcelRequire("fXUQh");
var $e9d2cf159edc02c7$var$rotr64_hi = $lWITE.rotr64_hi;
var $e9d2cf159edc02c7$var$rotr64_lo = $lWITE.rotr64_lo;
var $e9d2cf159edc02c7$var$shr64_hi = $lWITE.shr64_hi;
var $e9d2cf159edc02c7$var$shr64_lo = $lWITE.shr64_lo;
var $e9d2cf159edc02c7$var$sum64 = $lWITE.sum64;
var $e9d2cf159edc02c7$var$sum64_hi = $lWITE.sum64_hi;
var $e9d2cf159edc02c7$var$sum64_lo = $lWITE.sum64_lo;
var $e9d2cf159edc02c7$var$sum64_4_hi = $lWITE.sum64_4_hi;
var $e9d2cf159edc02c7$var$sum64_4_lo = $lWITE.sum64_4_lo;
var $e9d2cf159edc02c7$var$sum64_5_hi = $lWITE.sum64_5_hi;
var $e9d2cf159edc02c7$var$sum64_5_lo = $lWITE.sum64_5_lo;
var $e9d2cf159edc02c7$var$BlockHash = $kF0CT.BlockHash;
var $e9d2cf159edc02c7$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $e9d2cf159edc02c7$var$SHA512() {
    if (!(this instanceof $e9d2cf159edc02c7$var$SHA512)) return new $e9d2cf159edc02c7$var$SHA512();
    $e9d2cf159edc02c7$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $e9d2cf159edc02c7$var$sha512_K;
    this.W = new Array(160);
}
$lWITE.inherits($e9d2cf159edc02c7$var$SHA512, $e9d2cf159edc02c7$var$BlockHash);
module.exports = $e9d2cf159edc02c7$var$SHA512;
$e9d2cf159edc02c7$var$SHA512.blockSize = 1024;
$e9d2cf159edc02c7$var$SHA512.outSize = 512;
$e9d2cf159edc02c7$var$SHA512.hmacStrength = 192;
$e9d2cf159edc02c7$var$SHA512.padLength = 128;
$e9d2cf159edc02c7$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $e9d2cf159edc02c7$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $e9d2cf159edc02c7$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $e9d2cf159edc02c7$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $e9d2cf159edc02c7$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $e9d2cf159edc02c7$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $e9d2cf159edc02c7$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$e9d2cf159edc02c7$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $fXUQh(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $e9d2cf159edc02c7$var$s1_512_hi(eh, el);
        var c1_lo = $e9d2cf159edc02c7$var$s1_512_lo(eh, el);
        var c2_hi = $e9d2cf159edc02c7$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $e9d2cf159edc02c7$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $e9d2cf159edc02c7$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $e9d2cf159edc02c7$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $e9d2cf159edc02c7$var$s0_512_hi(ah, al);
        c0_lo = $e9d2cf159edc02c7$var$s0_512_lo(ah, al);
        c1_hi = $e9d2cf159edc02c7$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $e9d2cf159edc02c7$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $e9d2cf159edc02c7$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $e9d2cf159edc02c7$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $e9d2cf159edc02c7$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $e9d2cf159edc02c7$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $e9d2cf159edc02c7$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $e9d2cf159edc02c7$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $e9d2cf159edc02c7$var$sum64(this.h, 0, ah, al);
    $e9d2cf159edc02c7$var$sum64(this.h, 2, bh, bl);
    $e9d2cf159edc02c7$var$sum64(this.h, 4, ch, cl);
    $e9d2cf159edc02c7$var$sum64(this.h, 6, dh, dl);
    $e9d2cf159edc02c7$var$sum64(this.h, 8, eh, el);
    $e9d2cf159edc02c7$var$sum64(this.h, 10, fh, fl);
    $e9d2cf159edc02c7$var$sum64(this.h, 12, gh, gl);
    $e9d2cf159edc02c7$var$sum64(this.h, 14, hh, hl);
};
$e9d2cf159edc02c7$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lWITE.toHex32(this.h, 'big');
    else return $lWITE.split32(this.h, 'big');
};
function $e9d2cf159edc02c7$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$s0_512_hi(xh, xl) {
    var c0_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $e9d2cf159edc02c7$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $e9d2cf159edc02c7$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$s0_512_lo(xh, xl) {
    var c0_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $e9d2cf159edc02c7$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $e9d2cf159edc02c7$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$s1_512_hi(xh, xl) {
    var c0_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $e9d2cf159edc02c7$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$s1_512_lo(xh, xl) {
    var c0_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $e9d2cf159edc02c7$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$g0_512_hi(xh, xl) {
    var c0_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $e9d2cf159edc02c7$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$g0_512_lo(xh, xl) {
    var c0_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $e9d2cf159edc02c7$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$g1_512_hi(xh, xl) {
    var c0_hi = $e9d2cf159edc02c7$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $e9d2cf159edc02c7$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $e9d2cf159edc02c7$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e9d2cf159edc02c7$var$g1_512_lo(xh, xl) {
    var c0_lo = $e9d2cf159edc02c7$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $e9d2cf159edc02c7$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $e9d2cf159edc02c7$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("fBt6e", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $b5c0e24729f88cd1$export$d1cea0ee4e3f0d3e; }, function (v) { return $b5c0e24729f88cd1$export$d1cea0ee4e3f0d3e = v; });
var $b5c0e24729f88cd1$export$d1cea0ee4e3f0d3e;
'use strict';

var $lWITE = parcelRequire("lWITE");

var $kF0CT = parcelRequire("kF0CT");
var $b5c0e24729f88cd1$var$rotl32 = $lWITE.rotl32;
var $b5c0e24729f88cd1$var$sum32 = $lWITE.sum32;
var $b5c0e24729f88cd1$var$sum32_3 = $lWITE.sum32_3;
var $b5c0e24729f88cd1$var$sum32_4 = $lWITE.sum32_4;
var $b5c0e24729f88cd1$var$BlockHash = $kF0CT.BlockHash;
function $b5c0e24729f88cd1$var$RIPEMD160() {
    if (!(this instanceof $b5c0e24729f88cd1$var$RIPEMD160)) return new $b5c0e24729f88cd1$var$RIPEMD160();
    $b5c0e24729f88cd1$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$lWITE.inherits($b5c0e24729f88cd1$var$RIPEMD160, $b5c0e24729f88cd1$var$BlockHash);
$b5c0e24729f88cd1$export$d1cea0ee4e3f0d3e = $b5c0e24729f88cd1$var$RIPEMD160;
$b5c0e24729f88cd1$var$RIPEMD160.blockSize = 512;
$b5c0e24729f88cd1$var$RIPEMD160.outSize = 160;
$b5c0e24729f88cd1$var$RIPEMD160.hmacStrength = 192;
$b5c0e24729f88cd1$var$RIPEMD160.padLength = 64;
$b5c0e24729f88cd1$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $b5c0e24729f88cd1$var$sum32($b5c0e24729f88cd1$var$rotl32($b5c0e24729f88cd1$var$sum32_4(A, $b5c0e24729f88cd1$var$f(j, B, C, D), msg[$b5c0e24729f88cd1$var$r[j] + start], $b5c0e24729f88cd1$var$K(j)), $b5c0e24729f88cd1$var$s[j]), E);
        A = E;
        E = D;
        D = $b5c0e24729f88cd1$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $b5c0e24729f88cd1$var$sum32($b5c0e24729f88cd1$var$rotl32($b5c0e24729f88cd1$var$sum32_4(Ah, $b5c0e24729f88cd1$var$f(79 - j, Bh, Ch, Dh), msg[$b5c0e24729f88cd1$var$rh[j] + start], $b5c0e24729f88cd1$var$Kh(j)), $b5c0e24729f88cd1$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $b5c0e24729f88cd1$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $b5c0e24729f88cd1$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $b5c0e24729f88cd1$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $b5c0e24729f88cd1$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $b5c0e24729f88cd1$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $b5c0e24729f88cd1$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$b5c0e24729f88cd1$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lWITE.toHex32(this.h, 'little');
    else return $lWITE.split32(this.h, 'little');
};
function $b5c0e24729f88cd1$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $b5c0e24729f88cd1$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $b5c0e24729f88cd1$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $b5c0e24729f88cd1$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $b5c0e24729f88cd1$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $b5c0e24729f88cd1$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $b5c0e24729f88cd1$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("grq85", function(module, exports) {
'use strict';

var $lWITE = parcelRequire("lWITE");

var $fXUQh = parcelRequire("fXUQh");
function $bf836fb5b9959298$var$Hmac(hash, key, enc) {
    if (!(this instanceof $bf836fb5b9959298$var$Hmac)) return new $bf836fb5b9959298$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($lWITE.toArray(key, enc));
}
module.exports = $bf836fb5b9959298$var$Hmac;
$bf836fb5b9959298$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $fXUQh(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$bf836fb5b9959298$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$bf836fb5b9959298$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});






parcelRegister("jk80y", function(module, exports) {
"use strict";
var $e11618c469693481$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e11618c469693481$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e11618c469693481$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e11618c469693481$var$__exportStar((parcelRequire("4xmfD")), module.exports);

$e11618c469693481$var$__exportStar((parcelRequire("7T1be")), module.exports);

$e11618c469693481$var$__exportStar((parcelRequire("dDGWp")), module.exports);

$e11618c469693481$var$__exportStar((parcelRequire("30jqh")), module.exports);

$e11618c469693481$var$__exportStar((parcelRequire("1dA1d")), module.exports);

$e11618c469693481$var$__exportStar((parcelRequire("8p3eX")), module.exports);

});
parcelRegister("4xmfD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asTermType = void 0;
function $34db811f0c621df6$var$asTermType(type) {
    if (type === 'namedNode' || type === 'literal' || type === 'blankNode' || type === 'quad') return type;
    return undefined;
}
module.exports.asTermType = $34db811f0c621df6$var$asTermType;

});

parcelRegister("7T1be", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;

var $gIvya = parcelRequire("gIvya");
var $5bde95d410a66a37$var$Variable = function Variable(name) {
    (0, $jGAMp._)(this, Variable);
    this.expressionType = $gIvya.ExpressionType.Variable;
    this.name = name;
};
module.exports.Variable = $5bde95d410a66a37$var$Variable;

});

parcelRegister("dDGWp", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNonLexicalLiteral = module.exports.NonLexicalLiteral = module.exports.YearMonthDurationLiteral = module.exports.DayTimeDurationLiteral = module.exports.DurationLiteral = module.exports.DateLiteral = module.exports.TimeLiteral = module.exports.DateTimeLiteral = module.exports.StringLiteral = module.exports.LangStringLiteral = module.exports.BooleanLiteral = module.exports.DoubleLiteral = module.exports.FloatLiteral = module.exports.DecimalLiteral = module.exports.IntegerLiteral = module.exports.NumericLiteral = module.exports.Literal = module.exports.isLiteralTermExpression = module.exports.DefaultGraph = module.exports.Quad = module.exports.BlankNode = module.exports.NamedNode = module.exports.Term = void 0;

var $gIvya = parcelRequire("gIvya");

var $lb1HF = parcelRequire("lb1HF");

var $lb1HF = parcelRequire("lb1HF");

var $gwvZQ = parcelRequire("gwvZQ");

var $fXAAl = parcelRequire("fXAAl");

var $DRItq = parcelRequire("DRItq");
var $9ee03a15001e7d31$var$Term = /*#__PURE__*/ function() {
    function Term() {
        (0, $jGAMp._)(this, Term);
        this.expressionType = $gIvya.ExpressionType.Term;
    }
    (0, $byiyg._)(Term, [
        {
            key: "str",
            value: function str() {
                throw new $gwvZQ.InvalidArgumentTypes([
                    this
                ], $lb1HF.SparqlOperator.STR);
            }
        },
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                throw new $gwvZQ.EBVCoercionError(this);
            }
        }
    ]);
    return Term;
}();
module.exports.Term = $9ee03a15001e7d31$var$Term;
// NamedNodes -----------------------------------------------------------------
var $9ee03a15001e7d31$var$NamedNode = /*#__PURE__*/ function(Term) {
    (0, $i3fW3._)(NamedNode, Term);
    function NamedNode(value) {
        (0, $jGAMp._)(this, NamedNode);
        var _this;
        _this = (0, $kzDuW._)(this, NamedNode);
        _this.value = value;
        _this.termType = 'namedNode';
        return _this;
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                return dataFactory.namedNode(this.value);
            }
        },
        {
            key: "str",
            value: function str() {
                return this.value;
            }
        }
    ]);
    return NamedNode;
}($9ee03a15001e7d31$var$Term);
module.exports.NamedNode = $9ee03a15001e7d31$var$NamedNode;
// BlankNodes -----------------------------------------------------------------
var $9ee03a15001e7d31$var$BlankNode = /*#__PURE__*/ function(Term) {
    (0, $i3fW3._)(BlankNode, Term);
    function BlankNode(value) {
        (0, $jGAMp._)(this, BlankNode);
        var _this;
        _this = (0, $kzDuW._)(this, BlankNode);
        _this.termType = 'blankNode';
        _this.value = value;
        return _this;
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                return typeof this.value === 'string' ? dataFactory.blankNode(this.value) : this.value;
            }
        }
    ]);
    return BlankNode;
}($9ee03a15001e7d31$var$Term);
module.exports.BlankNode = $9ee03a15001e7d31$var$BlankNode;
// Quads -----------------------------------------------------------------
var $9ee03a15001e7d31$var$Quad = /*#__PURE__*/ function(Term) {
    (0, $i3fW3._)(Quad, Term);
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        var _this;
        _this = (0, $kzDuW._)(this, Quad);
        _this.subject = subject;
        _this.predicate = predicate;
        _this.object = object;
        _this.graph = graph;
        _this.termType = 'quad';
        return _this;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                return dataFactory.quad(this.subject.toRDF(dataFactory), this.predicate.toRDF(dataFactory), this.object.toRDF(dataFactory), this.graph.toRDF(dataFactory));
            }
        },
        {
            key: "str",
            value: function str() {
                return "Quad: [".concat(this.subject.str(), ", ").concat(this.predicate.str(), ", ").concat(this.object.str(), ", ").concat(this.graph.str(), "]");
            }
        }
    ]);
    return Quad;
}($9ee03a15001e7d31$var$Term);
module.exports.Quad = $9ee03a15001e7d31$var$Quad;
var $9ee03a15001e7d31$var$DefaultGraph = /*#__PURE__*/ function(Term) {
    (0, $i3fW3._)(DefaultGraph, Term);
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        var _this;
        _this = (0, $kzDuW._)(this, DefaultGraph);
        _this.termType = 'defaultGraph';
        return _this;
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                return dataFactory.defaultGraph();
            }
        },
        {
            key: "str",
            value: function str() {
                return 'DefaultGraph';
            }
        }
    ]);
    return DefaultGraph;
}($9ee03a15001e7d31$var$Term);
module.exports.DefaultGraph = $9ee03a15001e7d31$var$DefaultGraph;
// Literals-- -----------------------------------------------------------------
function $9ee03a15001e7d31$var$isLiteralTermExpression(expr) {
    if (expr.termType === 'literal') return expr;
    return undefined;
}
module.exports.isLiteralTermExpression = $9ee03a15001e7d31$var$isLiteralTermExpression;
var $9ee03a15001e7d31$var$Literal = /*#__PURE__*/ function(Term) {
    (0, $i3fW3._)(Literal, Term);
    function Literal(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, Literal);
        var _this;
        _this = (0, $kzDuW._)(this, Literal);
        _this.typedValue = typedValue;
        _this.dataType = dataType;
        _this.strValue = strValue;
        _this.language = language;
        _this.termType = 'literal';
        return _this;
    }
    (0, $byiyg._)(Literal, [
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                var _this_strValue, _this_language;
                return dataFactory.literal((_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.str(), (_this_language = this.language) !== null && _this_language !== void 0 ? _this_language : dataFactory.namedNode(this.dataType));
            }
        },
        {
            key: "str",
            value: function str() {
                var _this_strValue;
                return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.typedValue.toString();
            }
        }
    ]);
    return Literal;
}($9ee03a15001e7d31$var$Term);
module.exports.Literal = $9ee03a15001e7d31$var$Literal;
var $9ee03a15001e7d31$var$NumericLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(NumericLiteral, Literal);
    function NumericLiteral(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, NumericLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, NumericLiteral, [
            typedValue,
            dataType,
            strValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(NumericLiteral, [
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                return Boolean(this.typedValue);
            }
        },
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                var term = (0, $fXhL4._)((0, $hxFDX._)(NumericLiteral.prototype), "toRDF", this).call(this, dataFactory);
                if (!Number.isFinite(this.typedValue)) term.value = term.value.replace('Infinity', 'INF');
                return term;
            }
        },
        {
            key: "str",
            value: function str() {
                var _this_strValue;
                return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.specificFormatter(this.typedValue);
            }
        }
    ]);
    return NumericLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.NumericLiteral = $9ee03a15001e7d31$var$NumericLiteral;
var $9ee03a15001e7d31$var$IntegerLiteral = /*#__PURE__*/ function(NumericLiteral) {
    (0, $i3fW3._)(IntegerLiteral, NumericLiteral);
    function IntegerLiteral(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, IntegerLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, IntegerLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_INTEGER,
            strValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(IntegerLiteral, [
        {
            key: "specificFormatter",
            value: function specificFormatter(val) {
                return val.toFixed(0);
            }
        }
    ]);
    return IntegerLiteral;
}($9ee03a15001e7d31$var$NumericLiteral);
module.exports.IntegerLiteral = $9ee03a15001e7d31$var$IntegerLiteral;
var $9ee03a15001e7d31$var$DecimalLiteral = /*#__PURE__*/ function(NumericLiteral) {
    (0, $i3fW3._)(DecimalLiteral, NumericLiteral);
    function DecimalLiteral(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, DecimalLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DecimalLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DECIMAL,
            strValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(DecimalLiteral, [
        {
            key: "specificFormatter",
            value: function specificFormatter(val) {
                return val.toString();
            }
        }
    ]);
    return DecimalLiteral;
}($9ee03a15001e7d31$var$NumericLiteral);
module.exports.DecimalLiteral = $9ee03a15001e7d31$var$DecimalLiteral;
var $9ee03a15001e7d31$var$FloatLiteral = /*#__PURE__*/ function(NumericLiteral) {
    (0, $i3fW3._)(FloatLiteral, NumericLiteral);
    function FloatLiteral(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, FloatLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, FloatLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_FLOAT,
            strValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(FloatLiteral, [
        {
            key: "specificFormatter",
            value: function specificFormatter(val) {
                return val.toString();
            }
        }
    ]);
    return FloatLiteral;
}($9ee03a15001e7d31$var$NumericLiteral);
module.exports.FloatLiteral = $9ee03a15001e7d31$var$FloatLiteral;
var $9ee03a15001e7d31$var$DoubleLiteral = /*#__PURE__*/ function(NumericLiteral) {
    (0, $i3fW3._)(DoubleLiteral, NumericLiteral);
    function DoubleLiteral(typedValue, dataType, strValue, language) {
        (0, $jGAMp._)(this, DoubleLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DoubleLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DOUBLE,
            strValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(DoubleLiteral, [
        {
            key: "specificFormatter",
            value: function specificFormatter(val) {
                if (!Number.isFinite(val)) {
                    if (val > 0) return 'INF';
                    if (val < 0) return '-INF';
                    return 'NaN';
                }
                var jsExponential = val.toExponential();
                var _jsExponential_split = (0, $32TW8._)(jsExponential.split('e'), 2), jsMantisse = _jsExponential_split[0], jsExponent = _jsExponential_split[1];
                // Leading + must be removed for integer
                // https://www.w3.org/TR/xmlschema-2/#integer
                var exponent = jsExponent.replace(RegExp("\\+", "u"), '');
                // SPARQL test suite prefers trailing zero's
                var mantisse = jsMantisse.includes('.') ? jsMantisse : "".concat(jsMantisse, ".0");
                return "".concat(mantisse, "E").concat(exponent);
            }
        }
    ]);
    return DoubleLiteral;
}($9ee03a15001e7d31$var$NumericLiteral);
module.exports.DoubleLiteral = $9ee03a15001e7d31$var$DoubleLiteral;
var $9ee03a15001e7d31$var$BooleanLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(BooleanLiteral, Literal);
    function BooleanLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, BooleanLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, BooleanLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_BOOLEAN,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(BooleanLiteral, [
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                return this.typedValue;
            }
        }
    ]);
    return BooleanLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.BooleanLiteral = $9ee03a15001e7d31$var$BooleanLiteral;
var $9ee03a15001e7d31$var$LangStringLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(LangStringLiteral, Literal);
    function LangStringLiteral(typedValue, language, dataType) {
        (0, $jGAMp._)(this, LangStringLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, LangStringLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.RDF_LANG_STRING,
            typedValue,
            language
        ]);
        _this.typedValue = typedValue;
        _this.language = language;
        return _this;
    }
    (0, $byiyg._)(LangStringLiteral, [
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                return this.str().length > 0;
            }
        }
    ]);
    return LangStringLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.LangStringLiteral = $9ee03a15001e7d31$var$LangStringLiteral;
// https://www.w3.org/TR/2004/REC-rdf-concepts-20040210/#dfn-plain-literal
// https://www.w3.org/TR/sparql11-query/#defn_SimpleLiteral
// https://www.w3.org/TR/sparql11-query/#func-strings
// This does not include language tagged literals
var $9ee03a15001e7d31$var$StringLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(StringLiteral, Literal);
    function StringLiteral(typedValue, dataType) {
        (0, $jGAMp._)(this, StringLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, StringLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_STRING,
            typedValue
        ]);
        _this.typedValue = typedValue;
        return _this;
    }
    (0, $byiyg._)(StringLiteral, [
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                return this.str().length > 0;
            }
        }
    ]);
    return StringLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.StringLiteral = $9ee03a15001e7d31$var$StringLiteral;
var $9ee03a15001e7d31$var$DateTimeLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(DateTimeLiteral, Literal);
    function DateTimeLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, DateTimeLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DateTimeLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DATE_TIME,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(DateTimeLiteral, [
        {
            key: "str",
            value: function str() {
                return (0, $fXAAl.serializeDateTime)(this.typedValue);
            }
        }
    ]);
    return DateTimeLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.DateTimeLiteral = $9ee03a15001e7d31$var$DateTimeLiteral;
var $9ee03a15001e7d31$var$TimeLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(TimeLiteral, Literal);
    function TimeLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, TimeLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, TimeLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_TIME,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(TimeLiteral, [
        {
            key: "str",
            value: function str() {
                return (0, $fXAAl.serializeTime)(this.typedValue);
            }
        }
    ]);
    return TimeLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.TimeLiteral = $9ee03a15001e7d31$var$TimeLiteral;
var $9ee03a15001e7d31$var$DateLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(DateLiteral, Literal);
    function DateLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, DateLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DateLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DATE,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(DateLiteral, [
        {
            key: "str",
            value: function str() {
                return (0, $fXAAl.serializeDate)(this.typedValue);
            }
        }
    ]);
    return DateLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.DateLiteral = $9ee03a15001e7d31$var$DateLiteral;
var $9ee03a15001e7d31$var$DurationLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(DurationLiteral, Literal);
    function DurationLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, DurationLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DurationLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DURATION,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(DurationLiteral, [
        {
            key: "str",
            value: function str() {
                return (0, $fXAAl.serializeDuration)(this.typedValue);
            }
        }
    ]);
    return DurationLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.DurationLiteral = $9ee03a15001e7d31$var$DurationLiteral;
var $9ee03a15001e7d31$var$DayTimeDurationLiteral = /*#__PURE__*/ function(DurationLiteral) {
    (0, $i3fW3._)(DayTimeDurationLiteral, DurationLiteral);
    function DayTimeDurationLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, DayTimeDurationLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, DayTimeDurationLiteral, [
            typedValue,
            strValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_DAY_TIME_DURATION
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    return DayTimeDurationLiteral;
}($9ee03a15001e7d31$var$DurationLiteral);
module.exports.DayTimeDurationLiteral = $9ee03a15001e7d31$var$DayTimeDurationLiteral;
var $9ee03a15001e7d31$var$YearMonthDurationLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(YearMonthDurationLiteral, Literal);
    function YearMonthDurationLiteral(typedValue, strValue, dataType) {
        (0, $jGAMp._)(this, YearMonthDurationLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, YearMonthDurationLiteral, [
            typedValue,
            dataType !== null && dataType !== void 0 ? dataType : $lb1HF.TypeURL.XSD_YEAR_MONTH_DURATION,
            strValue
        ]);
        _this.typedValue = typedValue;
        _this.strValue = strValue;
        return _this;
    }
    (0, $byiyg._)(YearMonthDurationLiteral, [
        {
            key: "str",
            value: function str() {
                return (0, $fXAAl.serializeDuration)(this.typedValue, 'P0M');
            }
        }
    ]);
    return YearMonthDurationLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.YearMonthDurationLiteral = $9ee03a15001e7d31$var$YearMonthDurationLiteral;
/**
 * This class is used when a literal is parsed, and it's value is
 * an invalid lexical form for it's datatype. The spec defines value with
 * invalid lexical form are still valid terms, and as such we can not error
 * immediately. This class makes sure that the typedValue will remain undefined,
 * and the category 'nonlexical'. This way, only when operators apply to the
 * 'nonlexical' category, they will keep working, otherwise they will throw a
 * type error.
 * This seems to match the spec, except maybe for functions that accept
 * non-lexical values for their datatype.
 *
 * See:
 *  - https://www.w3.org/TR/xquery/#dt-type-error
 *  - https://www.w3.org/TR/rdf-concepts/#section-Literal-Value
 *  - https://www.w3.org/TR/xquery/#dt-ebv
 *  - ... some other more precise thing i can't find...
 */ var $9ee03a15001e7d31$var$NonLexicalLiteral = /*#__PURE__*/ function(Literal) {
    (0, $i3fW3._)(NonLexicalLiteral, Literal);
    function NonLexicalLiteral(typedValue, dataType, openWorldType, strValue, language) {
        (0, $jGAMp._)(this, NonLexicalLiteral);
        var _this;
        _this = (0, $kzDuW._)(this, NonLexicalLiteral, [
            {
                toString: function() {
                    return 'undefined';
                }
            },
            dataType,
            strValue,
            language
        ]);
        _this.openWorldType = openWorldType;
        return _this;
    }
    (0, $byiyg._)(NonLexicalLiteral, [
        {
            key: "coerceEBV",
            value: function coerceEBV() {
                var isNumericOrBool = (0, $DRItq.isSubTypeOf)(this.dataType, $lb1HF.TypeURL.XSD_BOOLEAN, this.openWorldType) || (0, $DRItq.isSubTypeOf)(this.dataType, $lb1HF.TypeAlias.SPARQL_NUMERIC, this.openWorldType);
                if (isNumericOrBool) return false;
                throw new $gwvZQ.EBVCoercionError(this);
            }
        },
        {
            key: "toRDF",
            value: function toRDF(dataFactory) {
                var _this_language;
                return dataFactory.literal(this.str(), (_this_language = this.language) !== null && _this_language !== void 0 ? _this_language : dataFactory.namedNode(this.dataType));
            }
        },
        {
            key: "str",
            value: function str() {
                var _this_strValue;
                return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : '';
            }
        }
    ]);
    return NonLexicalLiteral;
}($9ee03a15001e7d31$var$Literal);
module.exports.NonLexicalLiteral = $9ee03a15001e7d31$var$NonLexicalLiteral;
function $9ee03a15001e7d31$var$isNonLexicalLiteral(lit) {
    if (lit instanceof $9ee03a15001e7d31$var$NonLexicalLiteral) return lit;
    return undefined;
}
module.exports.isNonLexicalLiteral = $9ee03a15001e7d31$var$isNonLexicalLiteral;

});
parcelRegister("lb1HF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlOperator = module.exports.TypeURL = module.exports.typedLiteral = module.exports.TypeAlias = void 0;

var $2ej16 = parcelRequire("2ej16");
var $f6abf24875e7a115$var$TypeAlias;
(function(TypeAlias) {
    // Numeric is everything defined in https://www.w3.org/TR/sparql11-query/#operandDataTypes
    TypeAlias["SPARQL_NUMERIC"] = "SPARQL_NUMERIC";
    /**
     * Stringly is everything defined in https://www.w3.org/TR/sparql11-query/#func-strings
     * In other words it is a simple literal, a plain literal with language tag, or a literal with datatype xsd:string
     * In other words, since utils-expression-evaluator transforms a simple literal to xsd_string.
     * It is RDF_LANG_STRING or XSD_STRING.
     * Reasons for this are mentioned here: w3c/sparql-12#112
     */ TypeAlias["SPARQL_STRINGLY"] = "SPARQL_STRINGLY";
})($f6abf24875e7a115$var$TypeAlias || (module.exports.TypeAlias = $f6abf24875e7a115$var$TypeAlias = {}));
var $f6abf24875e7a115$var$DF = new $2ej16.DataFactory();
function $f6abf24875e7a115$var$typedLiteral(value, type) {
    return $f6abf24875e7a115$var$DF.literal(value, $f6abf24875e7a115$var$DF.namedNode(type));
}
module.exports.typedLiteral = $f6abf24875e7a115$var$typedLiteral;
var $f6abf24875e7a115$var$TypeURL;
(function(TypeURL) {
    TypeURL["XSD_ANY_URI"] = "http://www.w3.org/2001/XMLSchema#anyURI";
    TypeURL["XSD_STRING"] = "http://www.w3.org/2001/XMLSchema#string";
    TypeURL["RDF_LANG_STRING"] = "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString";
    TypeURL["XSD_BOOLEAN"] = "http://www.w3.org/2001/XMLSchema#boolean";
    TypeURL["XSD_DATE_TIME"] = "http://www.w3.org/2001/XMLSchema#dateTime";
    TypeURL["XSD_DATE_TIME_STAMP"] = "http://www.w3.org/2001/XMLSchema#dateTimeStamp";
    TypeURL["XSD_DATE"] = "http://www.w3.org/2001/XMLSchema#date";
    TypeURL["XSD_G_MONTH"] = "http://www.w3.org/2001/XMLSchema#gMonth";
    TypeURL["XSD_G_MONTHDAY"] = "http://www.w3.org/2001/XMLSchema#gMonthDay";
    TypeURL["XSD_G_YEAR"] = "http://www.w3.org/2001/XMLSchema#gYear";
    TypeURL["XSD_G_YEAR_MONTH"] = "http://www.w3.org/2001/XMLSchema#gYearMonth";
    TypeURL["XSD_TIME"] = "http://www.w3.org/2001/XMLSchema#time";
    TypeURL["XSD_G_DAY"] = "http://www.w3.org/2001/XMLSchema#gDay";
    // Numeric types
    TypeURL["XSD_DECIMAL"] = "http://www.w3.org/2001/XMLSchema#decimal";
    TypeURL["XSD_FLOAT"] = "http://www.w3.org/2001/XMLSchema#float";
    TypeURL["XSD_DOUBLE"] = "http://www.w3.org/2001/XMLSchema#double";
    // Derived numeric types
    TypeURL["XSD_INTEGER"] = "http://www.w3.org/2001/XMLSchema#integer";
    TypeURL["XSD_NON_POSITIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#nonPositiveInteger";
    TypeURL["XSD_NEGATIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#negativeInteger";
    TypeURL["XSD_LONG"] = "http://www.w3.org/2001/XMLSchema#long";
    TypeURL["XSD_INT"] = "http://www.w3.org/2001/XMLSchema#int";
    TypeURL["XSD_SHORT"] = "http://www.w3.org/2001/XMLSchema#short";
    TypeURL["XSD_BYTE"] = "http://www.w3.org/2001/XMLSchema#byte";
    TypeURL["XSD_NON_NEGATIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#nonNegativeInteger";
    TypeURL["XSD_POSITIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#positiveInteger";
    TypeURL["XSD_UNSIGNED_LONG"] = "http://www.w3.org/2001/XMLSchema#unsignedLong";
    TypeURL["XSD_UNSIGNED_INT"] = "http://www.w3.org/2001/XMLSchema#unsignedInt";
    TypeURL["XSD_UNSIGNED_SHORT"] = "http://www.w3.org/2001/XMLSchema#unsignedShort";
    TypeURL["XSD_UNSIGNED_BYTE"] = "http://www.w3.org/2001/XMLSchema#unsignedByte";
    // Derived String Type
    TypeURL["XSD_NORMALIZED_STRING"] = "http://www.w3.org/2001/XMLSchema#normalizedString";
    TypeURL["XSD_TOKEN"] = "http://www.w3.org/2001/XMLSchema#token";
    TypeURL["XSD_LANGUAGE"] = "http://www.w3.org/2001/XMLSchema#language";
    TypeURL["XSD_NM_TOKEN"] = "http://www.w3.org/2001/XMLSchema#NMTOKEN";
    TypeURL["XSD_NAME"] = "http://www.w3.org/2001/XMLSchema#name";
    TypeURL["XSD_NC_NAME"] = "http://www.w3.org/2001/XMLSchema#NCName";
    TypeURL["XSD_ENTITY"] = "http://www.w3.org/2001/XMLSchema#ENTITY";
    TypeURL["XSD_ID"] = "http://www.w3.org/2001/XMLSchema#ID";
    TypeURL["XSD_ID_REF"] = "http://www.w3.org/2001/XMLSchema#IDREF";
    // Other types
    TypeURL["XSD_DURATION"] = "http://www.w3.org/2001/XMLSchema#duration";
    TypeURL["XSD_YEAR_MONTH_DURATION"] = "http://www.w3.org/2001/XMLSchema#yearMonthDuration";
    TypeURL["XSD_DAY_TIME_DURATION"] = "http://www.w3.org/2001/XMLSchema#dayTimeDuration";
})($f6abf24875e7a115$var$TypeURL || (module.exports.TypeURL = $f6abf24875e7a115$var$TypeURL = {}));
// TODO: Remove unneeded double typing
var $f6abf24875e7a115$var$SparqlOperator;
(function(SparqlOperator) {
    // Operator mapping
    // https://www.w3.org/TR/sparql11-query/#OperatorMapping
    SparqlOperator["NOT"] = "!";
    SparqlOperator["UMINUS"] = "uminus";
    SparqlOperator["UPLUS"] = "uplus";
    SparqlOperator["LOGICAL_OR"] = "||";
    SparqlOperator["LOGICAL_AND"] = "&&";
    SparqlOperator["EQUAL"] = "=";
    SparqlOperator["NOT_EQUAL"] = "!=";
    SparqlOperator["LT"] = "<";
    SparqlOperator["GT"] = ">";
    SparqlOperator["LTE"] = "<=";
    SparqlOperator["GTE"] = ">=";
    SparqlOperator["SAME_TERM"] = "sameterm";
    SparqlOperator["IN"] = "in";
    SparqlOperator["NOT_IN"] = "notin";
    SparqlOperator["MULTIPLICATION"] = "*";
    SparqlOperator["DIVISION"] = "/";
    SparqlOperator["ADDITION"] = "+";
    SparqlOperator["SUBTRACTION"] = "-";
    // Functional Forms
    // https://www.w3.org/TR/sparql11-query/#func-forms
    // See SpecialOperators
    // Functions on RDF Terms
    // https://www.w3.org/TR/sparql11-query/#func-rdfTerms
    SparqlOperator["IS_IRI"] = "isiri";
    SparqlOperator["IS_URI"] = "isuri";
    SparqlOperator["IS_BLANK"] = "isblank";
    SparqlOperator["IS_LITERAL"] = "isliteral";
    SparqlOperator["IS_NUMERIC"] = "isnumeric";
    SparqlOperator["STR"] = "str";
    SparqlOperator["LANG"] = "lang";
    SparqlOperator["DATATYPE"] = "datatype";
    SparqlOperator["IRI"] = "iri";
    SparqlOperator["URI"] = "uri";
    SparqlOperator["BNODE"] = "bnode";
    SparqlOperator["STRDT"] = "strdt";
    SparqlOperator["STRLANG"] = "strlang";
    SparqlOperator["UUID"] = "uuid";
    SparqlOperator["STRUUID"] = "struuid";
    // Functions on strings
    // https://www.w3.org/TR/sparql11-query/#func-strings
    SparqlOperator["STRLEN"] = "strlen";
    SparqlOperator["SUBSTR"] = "substr";
    SparqlOperator["UCASE"] = "ucase";
    SparqlOperator["LCASE"] = "lcase";
    SparqlOperator["STRSTARTS"] = "strstarts";
    SparqlOperator["STRENDS"] = "strends";
    SparqlOperator["CONTAINS"] = "contains";
    SparqlOperator["STRBEFORE"] = "strbefore";
    SparqlOperator["STRAFTER"] = "strafter";
    SparqlOperator["ENCODE_FOR_URI"] = "encode_for_uri";
    SparqlOperator["CONCAT"] = "concat";
    SparqlOperator["LANG_MATCHES"] = "langmatches";
    SparqlOperator["REGEX"] = "regex";
    SparqlOperator["REPLACE"] = "replace";
    // Functions on numerics
    // https://www.w3.org/TR/sparql11-query/#func-numerics
    SparqlOperator["ABS"] = "abs";
    SparqlOperator["ROUND"] = "round";
    SparqlOperator["CEIL"] = "ceil";
    SparqlOperator["FLOOR"] = "floor";
    SparqlOperator["RAND"] = "rand";
    // Functions on Dates and Times
    // https://www.w3.org/TR/sparql11-query/#func-date-time
    SparqlOperator["NOW"] = "now";
    SparqlOperator["YEAR"] = "year";
    SparqlOperator["MONTH"] = "month";
    SparqlOperator["DAY"] = "day";
    SparqlOperator["HOURS"] = "hours";
    SparqlOperator["MINUTES"] = "minutes";
    SparqlOperator["SECONDS"] = "seconds";
    SparqlOperator["TIMEZONE"] = "timezone";
    SparqlOperator["TZ"] = "tz";
    // Hash functions
    // https://www.w3.org/TR/sparql11-query/#func-hash
    SparqlOperator["MD5"] = "md5";
    SparqlOperator["SHA1"] = "sha1";
    SparqlOperator["SHA256"] = "sha256";
    SparqlOperator["SHA384"] = "sha384";
    SparqlOperator["SHA512"] = "sha512";
    // XPath Constructor functions
    // https://www.w3.org/TR/sparql11-query/#FunctionMapping
    // See Named Operators
    // Functions for quoted triples
    // https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#triple-function
    SparqlOperator["TRIPLE"] = "triple";
    SparqlOperator["SUBJECT"] = "subject";
    SparqlOperator["PREDICATE"] = "predicate";
    SparqlOperator["OBJECT"] = "object";
    SparqlOperator["IS_TRIPLE"] = "istriple";
    // Functional Forms
    // https://www.w3.org/TR/sparql11-query/#func-forms
    SparqlOperator["BOUND"] = "bound";
    SparqlOperator["IF"] = "if";
    SparqlOperator["COALESCE"] = "coalesce";
})($f6abf24875e7a115$var$SparqlOperator || (module.exports.SparqlOperator = $f6abf24875e7a115$var$SparqlOperator = {}));

});

parcelRegister("gwvZQ", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoAggregator = module.exports.ExtensionFunctionError = module.exports.InvalidExpression = module.exports.InvalidArity = module.exports.UnexpectedError = module.exports.ParseError = module.exports.EmptyAggregateError = module.exports.IncompatibleLanguageOperation = module.exports.InvalidTimezoneCall = module.exports.CastError = module.exports.InvalidArgumentTypes = module.exports.InError = module.exports.CoalesceError = module.exports.RDFEqualTypeError = module.exports.EBVCoercionError = module.exports.UnboundVariableError = module.exports.InvalidLexicalForm = module.exports.isExpressionError = module.exports.ExpressionError = void 0;
/**
 * This class of error will be thrown when an expression errors.
 * Various reasons this could happen are:
 *   - invalid types for the given operator
 *   - unbound variables
 *   - invalid lexical forms
 *   - ...
 *
 * The distinction is made so that one can catch this specific type
 * and handle it accordingly to the SPARQL spec (relevant for e.g. FILTER, EXTEND),
 * while others (programming errors) can be re-thrown.
 *
 * @see isExpressionError
 */ var $c07874548d8c502d$var$ExpressionError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ExpressionError, Error1);
    function ExpressionError() {
        (0, $jGAMp._)(this, ExpressionError);
        return (0, $kzDuW._)(this, ExpressionError, arguments);
    }
    return ExpressionError;
}((0, $8AW3P._)(Error));
module.exports.ExpressionError = $c07874548d8c502d$var$ExpressionError;
/**
 * Checks whether a given error is an {@link ExpressionError}.
 * Also useful for mocking in tests for covering all branches.
 *
 * @see ExpressionError
 */ function $c07874548d8c502d$var$isExpressionError(error) {
    return error instanceof $c07874548d8c502d$var$ExpressionError;
}
module.exports.isExpressionError = $c07874548d8c502d$var$isExpressionError;
/**
 * A literal has an invalid lexical form for the datatype it is accompanied by.
 * This error is only thrown when the term is as function argument that requires
 * a valid lexical form.
 */ var $c07874548d8c502d$var$InvalidLexicalForm = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(InvalidLexicalForm, ExpressionError);
    function InvalidLexicalForm(arg) {
        (0, $jGAMp._)(this, InvalidLexicalForm);
        var _this;
        _this = (0, $kzDuW._)(this, InvalidLexicalForm, [
            "Invalid lexical form '".concat($c07874548d8c502d$var$pp(arg), "'")
        ]);
        _this.arg = arg;
        return _this;
    }
    return InvalidLexicalForm;
}($c07874548d8c502d$var$ExpressionError);
module.exports.InvalidLexicalForm = $c07874548d8c502d$var$InvalidLexicalForm;
/**
 * A variable in the expression was not bound.
 */ var $c07874548d8c502d$var$UnboundVariableError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(UnboundVariableError, ExpressionError);
    function UnboundVariableError(variable, bindings) {
        (0, $jGAMp._)(this, UnboundVariableError);
        var _this;
        _this = (0, $kzDuW._)(this, UnboundVariableError, [
            "Unbound variable '".concat($c07874548d8c502d$var$pp(variable), "'")
        ]);
        _this.variable = variable;
        _this.bindings = bindings;
        return _this;
    }
    return UnboundVariableError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.UnboundVariableError = $c07874548d8c502d$var$UnboundVariableError;
/**
 * An invalid term was being coerced to an Effective Boolean Value.
 *
 * See the {@link https://www.w3.org/TR/sparql11-query/#ebv | SPARQL docs}
 * on EBVs.
 */ var $c07874548d8c502d$var$EBVCoercionError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(EBVCoercionError, ExpressionError);
    function EBVCoercionError(arg) {
        (0, $jGAMp._)(this, EBVCoercionError);
        var _this;
        _this = (0, $kzDuW._)(this, EBVCoercionError, [
            "Cannot coerce term to EBV '".concat($c07874548d8c502d$var$pp(arg), "'")
        ]);
        _this.arg = arg;
        return _this;
    }
    return EBVCoercionError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.EBVCoercionError = $c07874548d8c502d$var$EBVCoercionError;
/**
 * An equality test was done on literals with unsupported datatypes.
 *
 * See {@link https://www.w3.org/TR/sparql11-query/#func-RDFterm-equal | term equality spec}.
 */ var $c07874548d8c502d$var$RDFEqualTypeError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(RDFEqualTypeError, ExpressionError);
    function RDFEqualTypeError(args) {
        (0, $jGAMp._)(this, RDFEqualTypeError);
        var _this;
        _this = (0, $kzDuW._)(this, RDFEqualTypeError, [
            'Equality test for literals with unsupported datatypes'
        ]);
        _this.args = args;
        return _this;
    }
    return RDFEqualTypeError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.RDFEqualTypeError = $c07874548d8c502d$var$RDFEqualTypeError;
/**
 * All the expressions in a COALESCE call threw errors.
 */ var $c07874548d8c502d$var$CoalesceError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(CoalesceError, ExpressionError);
    function CoalesceError(errors) {
        (0, $jGAMp._)(this, CoalesceError);
        var _this;
        _this = (0, $kzDuW._)(this, CoalesceError, [
            'All COALESCE arguments threw errors'
        ]);
        _this.errors = errors;
        return _this;
    }
    return CoalesceError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.CoalesceError = $c07874548d8c502d$var$CoalesceError;
/**
 * No arguments to an IN call where equal, and at least one threw an error.
 */ var $c07874548d8c502d$var$InError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(InError, ExpressionError);
    function InError(errors) {
        (0, $jGAMp._)(this, InError);
        var _this;
        _this = (0, $kzDuW._)(this, InError, [
            "Some argument to IN errorred and none where equal. ".concat(errors.map(function(err) {
                return "(".concat(err.toString(), ") ");
            }).join('and '))
        ]);
        _this.errors = errors;
        return _this;
    }
    return InError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.InError = $c07874548d8c502d$var$InError;
/**
 * Literals were passed to an operator that doesn't support their datatypes.
 */ var $c07874548d8c502d$var$InvalidArgumentTypes = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(InvalidArgumentTypes, ExpressionError);
    function InvalidArgumentTypes(args, op) {
        (0, $jGAMp._)(this, InvalidArgumentTypes);
        var _this;
        _this = (0, $kzDuW._)(this, InvalidArgumentTypes, [
            "Argument types not valid for operator: '".concat($c07874548d8c502d$var$pp(op), "' with '").concat($c07874548d8c502d$var$pp(args))
        ]);
        _this.args = args;
        _this.op = op;
        return _this;
    }
    return InvalidArgumentTypes;
}($c07874548d8c502d$var$ExpressionError);
module.exports.InvalidArgumentTypes = $c07874548d8c502d$var$InvalidArgumentTypes;
/**
 * An invalid typecast happened.
 */ var $c07874548d8c502d$var$CastError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(CastError, ExpressionError);
    function CastError(arg, cast) {
        (0, $jGAMp._)(this, CastError);
        var _this;
        _this = (0, $kzDuW._)(this, CastError, [
            "Invalid cast: '".concat($c07874548d8c502d$var$pp(arg), "' to '").concat($c07874548d8c502d$var$pp(cast), "'")
        ]);
        _this.arg = arg;
        return _this;
    }
    return CastError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.CastError = $c07874548d8c502d$var$CastError;
var $c07874548d8c502d$var$InvalidTimezoneCall = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(InvalidTimezoneCall, ExpressionError);
    function InvalidTimezoneCall(dateString) {
        (0, $jGAMp._)(this, InvalidTimezoneCall);
        var _this;
        _this = (0, $kzDuW._)(this, InvalidTimezoneCall, [
            "TIMEZONE call on ".concat(dateString, " which has no timezone")
        ]);
        _this.dateString = dateString;
        return _this;
    }
    return InvalidTimezoneCall;
}($c07874548d8c502d$var$ExpressionError);
module.exports.InvalidTimezoneCall = $c07874548d8c502d$var$InvalidTimezoneCall;
var $c07874548d8c502d$var$IncompatibleLanguageOperation = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(IncompatibleLanguageOperation, ExpressionError);
    function IncompatibleLanguageOperation(arg1, arg2) {
        (0, $jGAMp._)(this, IncompatibleLanguageOperation);
        var _this;
        _this = (0, $kzDuW._)(this, IncompatibleLanguageOperation, [
            "Operation on incompatible language literals '".concat($c07874548d8c502d$var$pp(arg1), "' and '").concat($c07874548d8c502d$var$pp(arg2), "'")
        ]);
        _this.arg1 = arg1;
        _this.arg2 = arg2;
        return _this;
    }
    return IncompatibleLanguageOperation;
}($c07874548d8c502d$var$ExpressionError);
module.exports.IncompatibleLanguageOperation = $c07874548d8c502d$var$IncompatibleLanguageOperation;
var $c07874548d8c502d$var$EmptyAggregateError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(EmptyAggregateError, ExpressionError);
    function EmptyAggregateError() {
        (0, $jGAMp._)(this, EmptyAggregateError);
        return (0, $kzDuW._)(this, EmptyAggregateError, [
            'Empty aggregate expression'
        ]);
    }
    return EmptyAggregateError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.EmptyAggregateError = $c07874548d8c502d$var$EmptyAggregateError;
var $c07874548d8c502d$var$ParseError = /*#__PURE__*/ function(ExpressionError) {
    (0, $i3fW3._)(ParseError, ExpressionError);
    function ParseError(str, type) {
        (0, $jGAMp._)(this, ParseError);
        return (0, $kzDuW._)(this, ParseError, [
            'Failed to parse "'.concat(str, '" as ').concat(type, ".")
        ]);
    }
    return ParseError;
}($c07874548d8c502d$var$ExpressionError);
module.exports.ParseError = $c07874548d8c502d$var$ParseError;
// Non Expression Errors ------------------------------------------------------
/**
 * An error that arises when we detect a 'should-be-impossible' state.
 * Given that this error is thrown, it clearly wasn't impossible, and some
 * mistake has been made.
 */ var $c07874548d8c502d$var$UnexpectedError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(UnexpectedError, Error1);
    function UnexpectedError(message, payload) {
        (0, $jGAMp._)(this, UnexpectedError);
        var _this;
        _this = (0, $kzDuW._)(this, UnexpectedError, [
            "Programmer Error '".concat(message, "'")
        ]);
        _this.payload = payload;
        return _this;
    }
    return UnexpectedError;
}((0, $8AW3P._)(Error));
module.exports.UnexpectedError = $c07874548d8c502d$var$UnexpectedError;
var $c07874548d8c502d$var$InvalidArity = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(InvalidArity, Error1);
    function InvalidArity(args, op) {
        (0, $jGAMp._)(this, InvalidArity);
        var _this;
        _this = (0, $kzDuW._)(this, InvalidArity, [
            "The number of args does not match the arity of the operator '".concat($c07874548d8c502d$var$pp(op), "'.")
        ]);
        _this.args = args;
        _this.op = op;
        return _this;
    }
    return InvalidArity;
}((0, $8AW3P._)(Error));
module.exports.InvalidArity = $c07874548d8c502d$var$InvalidArity;
var $c07874548d8c502d$var$InvalidExpression = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(InvalidExpression, Error1);
    function InvalidExpression(expr) {
        (0, $jGAMp._)(this, InvalidExpression);
        return (0, $kzDuW._)(this, InvalidExpression, [
            "Invalid SPARQL Expression '".concat($c07874548d8c502d$var$pp(expr), "'")
        ]);
    }
    return InvalidExpression;
}((0, $8AW3P._)(Error));
module.exports.InvalidExpression = $c07874548d8c502d$var$InvalidExpression;
var $c07874548d8c502d$var$ExtensionFunctionError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ExtensionFunctionError, Error1);
    function ExtensionFunctionError(name, functionError) {
        (0, $jGAMp._)(this, ExtensionFunctionError);
        var _this;
        if (functionError instanceof Error) _this = (0, $kzDuW._)(this, ExtensionFunctionError, [
            "Error thrown in ".concat(name, ": ").concat(functionError.message).concat(functionError.stack ? "\n".concat(functionError.stack) : '')
        ]);
        else _this = (0, $kzDuW._)(this, ExtensionFunctionError, [
            "Error thrown in ".concat(name)
        ]);
        return (0, $hMpIh._)(_this);
    }
    return ExtensionFunctionError;
}((0, $8AW3P._)(Error));
module.exports.ExtensionFunctionError = $c07874548d8c502d$var$ExtensionFunctionError;
var $c07874548d8c502d$var$NoAggregator = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(NoAggregator, Error1);
    function NoAggregator(name) {
        (0, $jGAMp._)(this, NoAggregator);
        return (0, $kzDuW._)(this, NoAggregator, [
            "Aggregate expression ".concat($c07874548d8c502d$var$pp(name), " found, but no aggregate hook provided.")
        ]);
    }
    return NoAggregator;
}((0, $8AW3P._)(Error));
module.exports.NoAggregator = $c07874548d8c502d$var$NoAggregator;
function $c07874548d8c502d$var$pp(object) {
    return JSON.stringify(object);
}

});

parcelRegister("fXAAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeDuration = module.exports.serializeTime = module.exports.serializeDate = module.exports.serializeDateTime = void 0;
function $b9e8bec0d02869a1$var$numSerializer(num) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return num.toLocaleString(undefined, {
        minimumIntegerDigits: min,
        useGrouping: false
    });
}
function $b9e8bec0d02869a1$var$serializeDateTime(date) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime
    // Extraction is needed because the date serializer can not add timezone y
    return "".concat($b9e8bec0d02869a1$var$serializeDate({
        year: date.year,
        month: date.month,
        day: date.day
    }), "T").concat($b9e8bec0d02869a1$var$serializeTime(date));
}
module.exports.serializeDateTime = $b9e8bec0d02869a1$var$serializeDateTime;
function $b9e8bec0d02869a1$var$serializeTimeZone(tz) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime-timezones
    if (tz.zoneHours === undefined || tz.zoneMinutes === undefined) return '';
    if (tz.zoneHours === 0 && tz.zoneMinutes === 0) return 'Z';
    // SerializeTimeZone({ zoneHours: 5, zoneMinutes: 4 }) returns +05:04
    return "".concat(tz.zoneHours >= 0 ? "+".concat($b9e8bec0d02869a1$var$numSerializer(tz.zoneHours)) : $b9e8bec0d02869a1$var$numSerializer(tz.zoneHours), ":").concat($b9e8bec0d02869a1$var$numSerializer(Math.abs(tz.zoneMinutes)));
}
function $b9e8bec0d02869a1$var$serializeDate(date) {
    // https://www.w3.org/TR/xmlschema-2/#date-lexical-representation
    return "".concat($b9e8bec0d02869a1$var$numSerializer(date.year, 4), "-").concat($b9e8bec0d02869a1$var$numSerializer(date.month), "-").concat($b9e8bec0d02869a1$var$numSerializer(date.day)).concat($b9e8bec0d02869a1$var$serializeTimeZone(date));
}
module.exports.serializeDate = $b9e8bec0d02869a1$var$serializeDate;
function $b9e8bec0d02869a1$var$serializeTime(time) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    return "".concat($b9e8bec0d02869a1$var$numSerializer(time.hours), ":").concat($b9e8bec0d02869a1$var$numSerializer(time.minutes), ":").concat($b9e8bec0d02869a1$var$numSerializer(time.seconds)).concat($b9e8bec0d02869a1$var$serializeTimeZone(time));
}
module.exports.serializeTime = $b9e8bec0d02869a1$var$serializeTime;
function $b9e8bec0d02869a1$var$serializeDuration(dur) {
    var zeroString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'PT0S';
    // https://www.w3.org/TR/xmlschema-2/#duration-lexical-repr
    if (!Object.values(dur).some(function(val) {
        return (val || 0) !== 0;
    })) return zeroString;
    var sign = Object.values(dur).some(function(val) {
        return (val || 0) < 0;
    }) ? '-' : '';
    var year = dur.year ? "".concat(Math.abs(dur.year), "Y") : '';
    var month = dur.month ? "".concat(Math.abs(dur.month), "M") : '';
    var day = dur.day ? "".concat(Math.abs(dur.day), "D") : '';
    var dayNotation = "".concat(sign, "P").concat(year).concat(month).concat(day);
    // eslint-disable-next-line ts/prefer-nullish-coalescing
    if (!(dur.hours || dur.minutes || dur.seconds)) return dayNotation;
    var hour = dur.hours ? "".concat(Math.abs(dur.hours), "H") : '';
    var minute = dur.minutes ? "".concat(Math.abs(dur.minutes), "M") : '';
    var second = dur.seconds ? "".concat(Math.abs(dur.seconds), "S") : '';
    return "".concat(dayNotation, "T").concat(hour).concat(minute).concat(second);
}
module.exports.serializeDuration = $b9e8bec0d02869a1$var$serializeDuration;

});

parcelRegister("DRItq", function(module, exports) {

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typePromotion = module.exports.isSubTypeOf = module.exports.getSuperTypeDict = module.exports.isInternalSubType = module.exports.asGeneralType = module.exports.asOverrideType = module.exports.asKnownLiteralType = module.exports.asTypeAlias = module.exports.typeAliasCheck = module.exports.extensionTableInit = module.exports.getSuperTypes = module.exports.superTypeDictTable = module.exports.extensionTableInput = void 0;

var $jk80y = parcelRequire("jk80y");

var $tVMut = parcelRequire("tVMut");

var $lb1HF = parcelRequire("lb1HF");
var $077d4f93292d42d5$var$_obj;
/**
 * Types that are not mentioned just map to 'term'.
 * When editing this, make sure type promotion and substitution don't start interfering.
 * e.g. when saying something like string -> stringly -> anyUri -> term.
 * This would make substitution on types that promote to each other possible. We and the specs don't want that!
 * A DAG will be created based on this. Make sure it doesn't have any cycles!
 */ module.exports.extensionTableInput = ($077d4f93292d42d5$var$_obj = {}, // Datetime types
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DATE_TIME_STAMP, $lb1HF.TypeURL.XSD_DATE_TIME), // Duration types
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DAY_TIME_DURATION, $lb1HF.TypeURL.XSD_DURATION), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_YEAR_MONTH_DURATION, $lb1HF.TypeURL.XSD_DURATION), // Stringly types
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.RDF_LANG_STRING, $lb1HF.TypeAlias.SPARQL_STRINGLY), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_STRING, $lb1HF.TypeAlias.SPARQL_STRINGLY), // String types
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NORMALIZED_STRING, $lb1HF.TypeURL.XSD_STRING), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_TOKEN, $lb1HF.TypeURL.XSD_NORMALIZED_STRING), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_LANGUAGE, $lb1HF.TypeURL.XSD_TOKEN), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NM_TOKEN, $lb1HF.TypeURL.XSD_TOKEN), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NAME, $lb1HF.TypeURL.XSD_TOKEN), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NC_NAME, $lb1HF.TypeURL.XSD_NAME), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_ENTITY, $lb1HF.TypeURL.XSD_NC_NAME), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_ID, $lb1HF.TypeURL.XSD_NC_NAME), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_ID_REF, $lb1HF.TypeURL.XSD_NC_NAME), // Numeric types
// https://www.w3.org/TR/sparql11-query/#operandDataTypes
// > numeric denotes typed literals with datatypes xsd:integer, xsd:decimal, xsd:float, and xsd:double
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DOUBLE, $lb1HF.TypeAlias.SPARQL_NUMERIC), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_FLOAT, $lb1HF.TypeAlias.SPARQL_NUMERIC), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DECIMAL, $lb1HF.TypeAlias.SPARQL_NUMERIC), // Decimal types
(0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_INTEGER, $lb1HF.TypeURL.XSD_DECIMAL), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NON_POSITIVE_INTEGER, $lb1HF.TypeURL.XSD_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NEGATIVE_INTEGER, $lb1HF.TypeURL.XSD_NON_POSITIVE_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_LONG, $lb1HF.TypeURL.XSD_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_INT, $lb1HF.TypeURL.XSD_LONG), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_SHORT, $lb1HF.TypeURL.XSD_INT), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_BYTE, $lb1HF.TypeURL.XSD_SHORT), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_NON_NEGATIVE_INTEGER, $lb1HF.TypeURL.XSD_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_POSITIVE_INTEGER, $lb1HF.TypeURL.XSD_NON_NEGATIVE_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_UNSIGNED_LONG, $lb1HF.TypeURL.XSD_NON_NEGATIVE_INTEGER), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_UNSIGNED_INT, $lb1HF.TypeURL.XSD_UNSIGNED_LONG), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_UNSIGNED_SHORT, $lb1HF.TypeURL.XSD_UNSIGNED_INT), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_UNSIGNED_BYTE, $lb1HF.TypeURL.XSD_UNSIGNED_SHORT), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DATE_TIME, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_BOOLEAN, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DATE, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_G_MONTH, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_G_MONTHDAY, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_G_YEAR, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_G_YEAR_MONTH, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_TIME, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_G_DAY, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_DURATION, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeAlias.SPARQL_NUMERIC, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeAlias.SPARQL_STRINGLY, 'term'), (0, $cqEAj._)($077d4f93292d42d5$var$_obj, $lb1HF.TypeURL.XSD_ANY_URI, 'term'), $077d4f93292d42d5$var$_obj);
module.exports.superTypeDictTable = Object.create(null);
/**
 * This will return the super types of a type and cache them.
 * @param type IRI we will decide the super types of.
 * @param openWorldType the enabler that provides a way to find super types.
 */ function $077d4f93292d42d5$var$getSuperTypes(type, openWorldType) {
    var cached = openWorldType.cache.get(type);
    if (cached) return cached;
    var value = openWorldType.discoverer(type);
    if (value === 'term') {
        var res = Object.create(null);
        res.__depth = 0;
        res[type] = 0;
        openWorldType.cache.set(type, res);
        return res;
    }
    var subExtension;
    var knownValue = $077d4f93292d42d5$var$asKnownLiteralType(value);
    if (knownValue) subExtension = (0, $iT0je._)({}, module.exports.superTypeDictTable[knownValue]);
    else subExtension = (0, $iT0je._)({}, $077d4f93292d42d5$var$getSuperTypes(value, openWorldType));
    subExtension.__depth++;
    subExtension[type] = subExtension.__depth;
    openWorldType.cache.set(type, subExtension);
    return subExtension;
}
module.exports.getSuperTypes = $077d4f93292d42d5$var$getSuperTypes;
// No circular structure allowed! & No other keys allowed!
function $077d4f93292d42d5$var$extensionTableInit() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(module.exports.extensionTableInput)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $32TW8._)(_step.value, 2), _key = _step_value[0], value = _step_value[1];
            var key = _key;
            if (module.exports.superTypeDictTable[key]) continue;
            $077d4f93292d42d5$var$extensionTableBuilderInitKey(key, value, module.exports.superTypeDictTable);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
module.exports.extensionTableInit = $077d4f93292d42d5$var$extensionTableInit;
$077d4f93292d42d5$var$extensionTableInit();
function $077d4f93292d42d5$var$extensionTableBuilderInitKey(key, value, res) {
    if (value === 'term' || value === undefined) {
        var baseRes = Object.create(null);
        baseRes.__depth = 0;
        baseRes[key] = 0;
        res[key] = baseRes;
        return;
    }
    if (!res[value]) $077d4f93292d42d5$var$extensionTableBuilderInitKey(value, module.exports.extensionTableInput[value], res);
    var _obj;
    res[key] = (0, $emQHU._)((0, $iT0je._)({}, res[value]), (_obj = {}, (0, $cqEAj._)(_obj, key, res[value].__depth + 1), (0, $cqEAj._)(_obj, "__depth", res[value].__depth + 1), _obj));
}
module.exports.typeAliasCheck = Object.create(null);
function $077d4f93292d42d5$var$initTypeAliasCheck() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values($lb1HF.TypeAlias)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var val = _step.value;
            module.exports.typeAliasCheck[val] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
$077d4f93292d42d5$var$initTypeAliasCheck();
function $077d4f93292d42d5$var$asTypeAlias(type) {
    if (type in module.exports.typeAliasCheck) return type;
    return undefined;
}
module.exports.asTypeAlias = $077d4f93292d42d5$var$asTypeAlias;
function $077d4f93292d42d5$var$asKnownLiteralType(type) {
    if (type in module.exports.superTypeDictTable) return type;
    return undefined;
}
module.exports.asKnownLiteralType = $077d4f93292d42d5$var$asKnownLiteralType;
function $077d4f93292d42d5$var$asOverrideType(type) {
    var _asKnownLiteralType;
    if ((_asKnownLiteralType = $077d4f93292d42d5$var$asKnownLiteralType(type)) !== null && _asKnownLiteralType !== void 0 ? _asKnownLiteralType : type === 'term') return type;
    return undefined;
}
module.exports.asOverrideType = $077d4f93292d42d5$var$asOverrideType;
function $077d4f93292d42d5$var$asGeneralType(type) {
    if (type === 'term' || (0, $jk80y.asTermType)(type)) return type;
    return undefined;
}
module.exports.asGeneralType = $077d4f93292d42d5$var$asGeneralType;
/**
 * Internal type of @see isSubTypeOf This only takes knownTypes but doesn't need an enabler
 */ function $077d4f93292d42d5$var$isInternalSubType(baseType, argumentType) {
    return baseType !== 'term' && module.exports.superTypeDictTable[baseType] && module.exports.superTypeDictTable[baseType][argumentType] !== undefined;
}
module.exports.isInternalSubType = $077d4f93292d42d5$var$isInternalSubType;
/**
 * This function can be used to check the base type is a restriction on a type in the dict.
 * If we want to check if type x is a restriction on string we do this by calling:
 * 'http://www.w3.org/2001/XMLSchema#string' in getSuperTypeDict(X, superTypeProvider)
 * @param baseType
 * @param superTypeProvider
 */ function $077d4f93292d42d5$var$getSuperTypeDict(baseType, superTypeProvider) {
    var concreteType = $077d4f93292d42d5$var$asKnownLiteralType(baseType);
    if (concreteType) // Concrete dataType is known by utils-expression-evaluator.
    return module.exports.superTypeDictTable[concreteType];
    // Datatype is a custom datatype
    return $077d4f93292d42d5$var$getSuperTypes(baseType, superTypeProvider);
}
module.exports.getSuperTypeDict = $077d4f93292d42d5$var$getSuperTypeDict;
/**
 * This function needs to be O(1)! The execution time of this function is vital!
 * We define typeA isSubtypeOf typeA as true.
 * If you find yourself using this function a lot (e.g. in a case) please use getSuperTypeDict instead.
 * @param baseType type you want to provide.
 * @param argumentType type you want to provide @param baseType to.
 * @param superTypeProvider the enabler to discover super types of unknown types.
 */ function $077d4f93292d42d5$var$isSubTypeOf(baseType, argumentType, superTypeProvider) {
    if (baseType === 'term') return false;
    return $077d4f93292d42d5$var$getSuperTypeDict(baseType, superTypeProvider)[argumentType] !== undefined;
}
module.exports.isSubTypeOf = $077d4f93292d42d5$var$isSubTypeOf;
var $077d4f93292d42d5$var$_obj1;
// Defined by https://www.w3.org/TR/xpath-31/#promotion .
// e.g. When a function takes a string, it can also accept a XSD_ANY_URI if it's cast first.
module.exports.typePromotion = ($077d4f93292d42d5$var$_obj1 = {}, (0, $cqEAj._)($077d4f93292d42d5$var$_obj1, $lb1HF.TypeURL.XSD_STRING, [
    {
        typeToPromote: $lb1HF.TypeURL.XSD_ANY_URI,
        conversionFunction: function(arg) {
            return (0, $tVMut.string)(arg.str());
        }
    }
]), (0, $cqEAj._)($077d4f93292d42d5$var$_obj1, $lb1HF.TypeURL.XSD_DOUBLE, [
    {
        typeToPromote: $lb1HF.TypeURL.XSD_FLOAT,
        conversionFunction: function(arg) {
            return (0, $tVMut.double)(arg.typedValue);
        }
    },
    // TODO: in case of decimal a round needs to happen.
    {
        typeToPromote: $lb1HF.TypeURL.XSD_DECIMAL,
        conversionFunction: function(arg) {
            return (0, $tVMut.double)(arg.typedValue);
        }
    }
]), (0, $cqEAj._)($077d4f93292d42d5$var$_obj1, $lb1HF.TypeURL.XSD_FLOAT, [
    // TODO: in case of decimal a round needs to happen.
    {
        typeToPromote: $lb1HF.TypeURL.XSD_DECIMAL,
        conversionFunction: function(arg) {
            return (0, $tVMut.float)(arg.typedValue);
        }
    }
]), $077d4f93292d42d5$var$_obj1);

});
parcelRegister("tVMut", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expressionToVar = module.exports.dateTime = module.exports.langString = module.exports.string = module.exports["double"] = module.exports["float"] = module.exports.decimal = module.exports.integer = module.exports.bool = module.exports.Builder = module.exports.declare = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $jk80y = parcelRequire("jk80y");

var $jk80y = parcelRequire("jk80y");

var $lb1HF = parcelRequire("lb1HF");

var $lb1HF = parcelRequire("lb1HF");

var $gwvZQ = parcelRequire("gwvZQ");

var $eckXw = parcelRequire("eckXw");
function $059f87abfe60c305$var$declare(identifier) {
    return new $059f87abfe60c305$var$Builder(identifier);
}
module.exports.declare = $059f87abfe60c305$var$declare;
var $059f87abfe60c305$var$Builder = /*#__PURE__*/ function() {
    function Builder(identifier) {
        (0, $jGAMp._)(this, Builder);
        this.overloadTree = new $eckXw.OverloadTree(identifier);
        this.collected = false;
    }
    (0, $byiyg._)(Builder, [
        {
            key: "collect",
            value: function collect() {
                if (this.collected) // Only 1 time allowed because we can't copy a tree. (And we don't need this).
                throw new Error('Builders can only be collected once!');
                this.collected = true;
                return this.overloadTree;
            }
        },
        {
            key: "set",
            value: function set(argTypes, func) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                this.overloadTree.addOverload(argTypes, addInvalidHandling ? Builder.wrapInvalidLexicalProtected(func) : func);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(param) {
                var from = param.from, to = param.to;
                var impl = this.overloadTree.getImplementationExact(from);
                if (!impl) throw new $gwvZQ.UnexpectedError('Tried to copy implementation, but types not found', {
                    from: from,
                    to: to
                });
                return this.set(to, impl);
            }
        },
        {
            key: "onUnary",
            value: function onUnary(type, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set([
                    type
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), val = _param[0];
                        return op(expressionEvaluator)(val);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onUnaryTyped",
            value: function onUnaryTyped(type, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set([
                    type
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), val = _param[0];
                        return op(expressionEvaluator)(val.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onBinary",
            value: function onBinary(types, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set(types, function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        return op(expressionEvaluator)(left, right);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onBinaryTyped",
            value: function onBinaryTyped(types, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set(types, function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        return op(expressionEvaluator)(left.typedValue, right.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onTernaryTyped",
            value: function onTernaryTyped(types, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set(types, function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 3), a1 = _param[0], a2 = _param[1], a3 = _param[2];
                        return op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onTernary",
            value: function onTernary(types, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set(types, function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 3), a1 = _param[0], a2 = _param[1], a3 = _param[2];
                        return op(expressionEvaluator)(a1, a2, a3);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onQuaternaryTyped",
            value: function onQuaternaryTyped(types, op) {
                var addInvalidHandling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return this.set(types, function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 4), a1 = _param[0], a2 = _param[1], a3 = _param[2], a4 = _param[3];
                        return op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue, a4.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onTerm1",
            value: function onTerm1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return this.set([
                    'term'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), term = _param[0];
                        return op(expressionEvaluator)(term);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onTerm3",
            value: function onTerm3(op) {
                return this.set([
                    'term',
                    'term',
                    'term'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 3), t1 = _param[0], t2 = _param[1], t3 = _param[2];
                        return op(expressionEvaluator)(t1, t2, t3);
                    };
                });
            }
        },
        {
            key: "onQuad1",
            value: function onQuad1(op) {
                return this.set([
                    'quad'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), term = _param[0];
                        return op(expressionEvaluator)(term);
                    };
                });
            }
        },
        {
            key: "onLiteral1",
            value: function onLiteral1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    'literal'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), term = _param[0];
                        return op(expressionEvaluator)(term);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onBoolean1",
            value: function onBoolean1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_BOOLEAN
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onBoolean1Typed",
            value: function onBoolean1Typed(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_BOOLEAN
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onString1",
            value: function onString1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_STRING
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onString1Typed",
            value: function onString1Typed(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_STRING
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onLangString1",
            value: function onLangString1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.RDF_LANG_STRING
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onStringly1",
            value: function onStringly1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeAlias.SPARQL_STRINGLY
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onStringly1Typed",
            value: function onStringly1Typed(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeAlias.SPARQL_STRINGLY
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), lit = _param[0];
                        return op(expressionEvaluator)(lit.typedValue);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onNumeric1",
            value: function onNumeric1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeAlias.SPARQL_NUMERIC
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), val = _param[0];
                        return op(expressionEvaluator)(val);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "onDateTime1",
            value: function onDateTime1(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_DATE_TIME
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), val = _param[0];
                        return op(expressionEvaluator)(val);
                    };
                }, addInvalidHandling);
            }
        },
        {
            /**
     * We return the base types and not the provided types because we don't want to create invalid terms.
     * Providing negative number to a function unary - for example should not
     * return a term of type negative number having a positive value.
     * @param op the numeric operator performed
     * @param addInvalidHandling whether to add invalid handling,
     *   whether to add @param op in @see wrapInvalidLexicalProtected
     */ key: "numericConverter",
            value: function numericConverter(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var evalHelper = function(expressionEvaluator) {
                    return function(arg) {
                        return op(expressionEvaluator)(arg.typedValue);
                    };
                };
                return this.onUnary($lb1HF.TypeURL.XSD_INTEGER, function(expressionEvaluator) {
                    return function(arg) {
                        return $059f87abfe60c305$var$integer(evalHelper(expressionEvaluator)(arg));
                    };
                }, addInvalidHandling).onUnary($lb1HF.TypeURL.XSD_DECIMAL, function(expressionEvaluator) {
                    return function(arg) {
                        return $059f87abfe60c305$var$decimal(evalHelper(expressionEvaluator)(arg));
                    };
                }, addInvalidHandling).onUnary($lb1HF.TypeURL.XSD_FLOAT, function(expressionEvaluator) {
                    return function(arg) {
                        return $059f87abfe60c305$var$_float(evalHelper(expressionEvaluator)(arg));
                    };
                }, addInvalidHandling).onUnary($lb1HF.TypeURL.XSD_DOUBLE, function(expressionEvaluator) {
                    return function(arg) {
                        return $059f87abfe60c305$var$_double(evalHelper(expressionEvaluator)(arg));
                    };
                }, addInvalidHandling);
            }
        },
        {
            /**
     * !!! Be aware when using this function, it will create different overloads with different return types !!!
     * Arithmetic operators take 2 numeric arguments, and return a single numerical
     * value. The type of the return value is heavily dependent on the types of the
     * input arguments. In JS everything is a double, but in SPARQL it is not.
     *
     * The different arguments are handled by type promotion and subtype substitution.
     * The way numeric function arguments work is described here:
     * https://www.w3.org/TR/xpath20/#mapping
     * Above url is referenced in the sparql spec: https://www.w3.org/TR/sparql11-query/#OperatorMapping
     */ key: "arithmetic",
            value: function arithmetic(op) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var evalHelper = function(expressionEvaluator) {
                    return function(left, right) {
                        return op(expressionEvaluator)(left.typedValue, right.typedValue);
                    };
                };
                return this.onBinary([
                    $lb1HF.TypeURL.XSD_INTEGER,
                    $lb1HF.TypeURL.XSD_INTEGER
                ], function(expressionEvaluator) {
                    return function(left, right) {
                        return $059f87abfe60c305$var$integer(evalHelper(expressionEvaluator)(left, right));
                    };
                }, addInvalidHandling).onBinary([
                    $lb1HF.TypeURL.XSD_DECIMAL,
                    $lb1HF.TypeURL.XSD_DECIMAL
                ], function(expressionEvaluator) {
                    return function(left, right) {
                        return $059f87abfe60c305$var$decimal(evalHelper(expressionEvaluator)(left, right));
                    };
                }, addInvalidHandling).onBinary([
                    $lb1HF.TypeURL.XSD_FLOAT,
                    $lb1HF.TypeURL.XSD_FLOAT
                ], function(expressionEvaluator) {
                    return function(left, right) {
                        return $059f87abfe60c305$var$_float(evalHelper(expressionEvaluator)(left, right));
                    };
                }, addInvalidHandling).onBinary([
                    $lb1HF.TypeURL.XSD_DOUBLE,
                    $lb1HF.TypeURL.XSD_DOUBLE
                ], function(expressionEvaluator) {
                    return function(left, right) {
                        return $059f87abfe60c305$var$_double(evalHelper(expressionEvaluator)(left, right));
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "numberTest",
            value: function numberTest(test) {
                return this.numeric(function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        var result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                        return $059f87abfe60c305$var$bool(result);
                    };
                });
            }
        },
        {
            key: "stringTest",
            value: function stringTest(test) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_STRING,
                    $lb1HF.TypeURL.XSD_STRING
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        var result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                        return $059f87abfe60c305$var$bool(result);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "booleanTest",
            value: function booleanTest(test) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_BOOLEAN,
                    $lb1HF.TypeURL.XSD_BOOLEAN
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        var result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                        return $059f87abfe60c305$var$bool(result);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "dateTimeTest",
            value: function dateTimeTest(test) {
                var addInvalidHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return this.set([
                    $lb1HF.TypeURL.XSD_DATE_TIME,
                    $lb1HF.TypeURL.XSD_DATE_TIME
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        var result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                        return $059f87abfe60c305$var$bool(result);
                    };
                }, addInvalidHandling);
            }
        },
        {
            key: "numeric",
            value: function numeric(op) {
                return this.set([
                    $lb1HF.TypeAlias.SPARQL_NUMERIC,
                    $lb1HF.TypeAlias.SPARQL_NUMERIC
                ], op);
            }
        }
    ], [
        {
            key: "wrapInvalidLexicalProtected",
            value: function wrapInvalidLexicalProtected(func) {
                return function(expressionEvaluator) {
                    return function(args) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = args.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $32TW8._)(_step.value, 2), index = _step_value[0], arg = _step_value[1];
                                if (arg instanceof $jk80y.NonLexicalLiteral) throw new $gwvZQ.InvalidLexicalForm(args[index].toRDF(expressionEvaluator.context.getSafe($9nBhR.KeysInitQuery.dataFactory)));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return func(expressionEvaluator)(args);
                    };
                };
            }
        }
    ]);
    return Builder;
}();
module.exports.Builder = $059f87abfe60c305$var$Builder;
// ----------------------------------------------------------------------------
// Literal Construction helpers
// ----------------------------------------------------------------------------
function $059f87abfe60c305$var$bool(val) {
    return new $jk80y.BooleanLiteral(val);
}
module.exports.bool = $059f87abfe60c305$var$bool;
function $059f87abfe60c305$var$integer(num) {
    return new $jk80y.IntegerLiteral(num);
}
module.exports.integer = $059f87abfe60c305$var$integer;
function $059f87abfe60c305$var$decimal(num) {
    return new $jk80y.DecimalLiteral(num);
}
module.exports.decimal = $059f87abfe60c305$var$decimal;
function $059f87abfe60c305$var$_float(num) {
    return new $jk80y.FloatLiteral(num);
}
module.exports["float"] = $059f87abfe60c305$var$_float;
function $059f87abfe60c305$var$_double(num) {
    return new $jk80y.DoubleLiteral(num);
}
module.exports["double"] = $059f87abfe60c305$var$_double;
function $059f87abfe60c305$var$string(str) {
    return new $jk80y.StringLiteral(str);
}
module.exports.string = $059f87abfe60c305$var$string;
function $059f87abfe60c305$var$langString(str, lang) {
    return new $jk80y.LangStringLiteral(str, lang);
}
module.exports.langString = $059f87abfe60c305$var$langString;
function $059f87abfe60c305$var$dateTime(date, str) {
    return new $jk80y.DateTimeLiteral(date, str);
}
module.exports.dateTime = $059f87abfe60c305$var$dateTime;
function $059f87abfe60c305$var$expressionToVar(dataFactory, variableExpression) {
    return dataFactory.variable(variableExpression.name.slice(1));
}
module.exports.expressionToVar = $059f87abfe60c305$var$expressionToVar;

});
parcelRegister("eckXw", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $1UYmo = parcelRequire("1UYmo");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OverloadTree = void 0;

var $jk80y = parcelRequire("jk80y");

var $DRItq = parcelRequire("DRItq");
/**
 * Maps argument types on their specific implementation in a tree like structure.
 * When adding any functionality to this class, make sure you add it to SpecialFunctions as well.
 */ var $a56271aeb48cfc77$var$OverloadTree = /*#__PURE__*/ function() {
    function OverloadTree(identifier, depth) {
        (0, $jGAMp._)(this, OverloadTree);
        this.identifier = identifier;
        this.implementation = undefined;
        this.generalOverloads = Object.create(null);
        this.literalOverLoads = [];
        this.depth = depth !== null && depth !== void 0 ? depth : 0;
        this.promotionCount = undefined;
    }
    (0, $byiyg._)(OverloadTree, [
        {
            key: "getSubtree",
            value: function getSubtree(overrideType) {
                var generalType = (0, $DRItq.asGeneralType)(overrideType);
                if (generalType) return this.generalOverloads[generalType];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.literalOverLoads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), type = _step_value[0], overloadTree = _step_value[1];
                        if (overrideType === type) return overloadTree;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        },
        {
            /**
     * Get the implementation for the types that exactly match @param args .
     */ key: "getImplementationExact",
            value: function getImplementationExact(args) {
                // eslint-disable-next-line ts/no-this-alias
                var node = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var expression = _step.value;
                        node = node.getSubtree(expression);
                        if (!node) return undefined;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return node.implementation;
            }
        },
        {
            /**
     * Searches in a depth first way for the best matching overload. considering this a the tree's root.
     * @param args the arguments to the function.
     * @param superTypeProvider
     * @param functionArgumentsCache
     */ key: "search",
            value: function search(args, superTypeProvider, functionArgumentsCache) {
                var _this, _loop = function() {
                    var _searchStack;
                    var _searchStack_pop = searchStack.pop(), index = _searchStack_pop.index, node = _searchStack_pop.node;
                    // We check the implementation because it would be possible a path is created but not implemented.
                    // ex: f(double, double, double) and f(term, term). and calling f(double, double).
                    if (index === args.length && node.implementation) {
                        _this.addToCache(functionArgumentsCache, args, node.implementation);
                        return {
                            v: node.implementation
                        };
                    }
                    (_searchStack = searchStack).push.apply(_searchStack, (0, $7WNf6._)(node.getSubTreeWithArg(args[index], superTypeProvider).map(function(item) {
                        return {
                            node: item,
                            index: index + 1
                        };
                    })));
                };
                var // GetSubTreeWithArg return a SearchStack containing the node's that should be contacted next.
                // We also log the index since there is no other way to remember this index.
                // the provided stack should be pushed on top of our search stack since it also has it's order.
                _searchStack;
                var cacheIter = functionArgumentsCache[this.identifier];
                var searchIndex = 0;
                while(searchIndex < args.length && (cacheIter === null || cacheIter === void 0 ? void 0 : cacheIter.cache)){
                    var term = args[searchIndex];
                    var literalExpression = (0, $jk80y.isLiteralTermExpression)(term);
                    cacheIter = cacheIter.cache[literalExpression ? literalExpression.dataType : term.termType];
                    searchIndex++;
                }
                if (searchIndex === args.length && (cacheIter === null || cacheIter === void 0 ? void 0 : cacheIter.func)) return cacheIter.func;
                // SearchStack is a stack of all node's that need to be checked for implementation.
                // It provides an easy way to keep order in our search.
                var searchStack = [];
                var startIndex = 0;
                if (args.length === 0) return this.implementation;
                (_searchStack = searchStack).push.apply(_searchStack, (0, $7WNf6._)(this.getSubTreeWithArg(args[startIndex], superTypeProvider).map(function(node) {
                    return {
                        node: node,
                        index: startIndex + 1
                    };
                })));
                while(searchStack.length > 0){
                    var _ret = (_this = this, _loop());
                    if ((0, $3KZcf._)(_ret) === "object") return _ret.v;
                }
                // Calling a function with one argument but finding no implementation should return no implementation.
                // Not even the one with no arguments.
                return undefined;
            }
        },
        {
            key: "addToCache",
            value: function addToCache(functionArgumentsCache, args, func) {
                function getDefault(lruCache, key) {
                    if (!(key in lruCache)) lruCache[key] = {};
                    return lruCache[key];
                }
                var cache = getDefault(functionArgumentsCache, this.identifier);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var term = _step.value;
                        var literalExpression = (0, $jk80y.isLiteralTermExpression)(term);
                        var key = literalExpression ? literalExpression.dataType : term.termType;
                        var _cache_cache;
                        cache.cache = (_cache_cache = cache.cache) !== null && _cache_cache !== void 0 ? _cache_cache : {};
                        cache = getDefault(cache.cache, key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                cache.func = func;
            }
        },
        {
            /**
     * Adds an overload to the tree structure considering this as the tree's root.
     * @param argumentTypes a list of argumentTypes that would need to be provided in
     * the same order to get the implementation.
     * @param func the implementation for this overload.
     */ key: "addOverload",
            value: function addOverload(argumentTypes, func) {
                this._addOverload((0, $7WNf6._)(argumentTypes), func, 0);
            }
        },
        {
            key: "_addOverload",
            value: function _addOverload(argumentTypes, func, promotionCount) {
                var _argumentTypes = (0, $1UYmo._)(argumentTypes), argumentType = _argumentTypes[0], _argumentTypes1 = _argumentTypes.slice(1);
                if (!argumentType) {
                    if (this.promotionCount === undefined || promotionCount <= this.promotionCount) {
                        this.promotionCount = promotionCount;
                        this.implementation = func;
                    }
                    return;
                }
                var nextTree = this.getSubtree(argumentType);
                if (!nextTree) {
                    var newNode = new OverloadTree(this.identifier, this.depth + 1);
                    var generalType = (0, $DRItq.asGeneralType)(argumentType);
                    if (generalType) this.generalOverloads[generalType] = newNode;
                    var overrideType = (0, $DRItq.asOverrideType)(argumentType);
                    if (overrideType) this.literalOverLoads.push([
                        overrideType,
                        newNode
                    ]);
                    nextTree = newNode;
                }
                nextTree._addOverload(_argumentTypes1, func, promotionCount);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ($DRItq.typePromotion[argumentType]) try {
                    for(var _iterator = $DRItq.typePromotion[argumentType][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ret = _step.value;
                        this.addPromotedOverload(ret.typeToPromote, func, ret.conversionFunction, _argumentTypes1, promotionCount);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "addPromotedOverload",
            value: function addPromotedOverload(typeToPromote, func, conversionFunction, argumentTypes, promotionCount) {
                var _this = this;
                var nextTree = this.getSubtree(typeToPromote);
                if (!nextTree) {
                    var newNode = new OverloadTree(this.identifier, this.depth + 1);
                    this.literalOverLoads.push([
                        typeToPromote,
                        newNode
                    ]);
                    nextTree = newNode;
                }
                nextTree._addOverload(argumentTypes, function(funcConf) {
                    return function(args) {
                        return func(funcConf)((0, $7WNf6._)(args.slice(0, _this.depth)).concat([
                            conversionFunction(args[_this.depth])
                        ], (0, $7WNf6._)(args.slice(_this.depth + 1, args.length))));
                    };
                }, promotionCount + 1);
            }
        },
        {
            /**
     * @param arg term to try and match to possible overloads of this node.
     * @param openWorldType interface allowing to discover relations between types.
     * @returns SearchStack a stack with top element the next node that should be asked for implementation or overload.
     */ key: "getSubTreeWithArg",
            value: function getSubTreeWithArg(arg, openWorldType) {
                var res = [];
                var literalExpression = (0, $jk80y.isLiteralTermExpression)(arg);
                // These types refer to Type exported by lib/util/Consts.ts
                if (this.generalOverloads.term) res.push(this.generalOverloads.term);
                // TermTypes are defined in E.TermType.
                if (this.generalOverloads[arg.termType]) res.push(this.generalOverloads[arg.termType]);
                if (literalExpression) {
                    var _res;
                    // Defending implementation. Mainly the scary sort.
                    // This function has cost O(n) + O(m * log(m)) with n = amount of overloads and m = amount of matched overloads
                    // We map over each of the overloads, filter only the once that can be used (this is normally 1 or 2).
                    // The sort function on an array with 1 or 2 arguments will be negligible.
                    var concreteType = (0, $DRItq.asKnownLiteralType)(literalExpression.dataType);
                    var subExtensionTable;
                    if (concreteType) // Concrete dataType is known by utils-expression-evaluator.
                    subExtensionTable = $DRItq.superTypeDictTable[concreteType];
                    else // Datatype is a custom datatype
                    subExtensionTable = (0, $DRItq.getSuperTypes)(literalExpression.dataType, openWorldType);
                    var matches = this.literalOverLoads.filter(function(param) {
                        var _param = (0, $32TW8._)(param, 2), matchType = _param[0], _ = _param[1];
                        return matchType in subExtensionTable;
                    }).map(function(param) {
                        var _param = (0, $32TW8._)(param, 2), matchType = _param[0], tree = _param[1];
                        return [
                            subExtensionTable[matchType],
                            tree
                        ];
                    });
                    // eslint-disable-next-line unused-imports/no-unused-vars
                    matches.sort(function(param, param1) {
                        var _param = (0, $32TW8._)(param, 2), prioA = _param[0], matchTypeA = _param[1], _param1 = (0, $32TW8._)(param1, 2), prioB = _param1[0], matchTypeB = _param1[1];
                        return prioA - prioB;
                    });
                    (_res = res).push.apply(_res, (0, $7WNf6._)(matches.map(function(param) {
                        var _param = (0, $32TW8._)(param, 2), _ = _param[0], sortedType = _param[1];
                        return sortedType;
                    })));
                }
                return res;
            }
        }
    ]);
    return OverloadTree;
}();
module.exports.OverloadTree = $a56271aeb48cfc77$var$OverloadTree;

});
parcelRegister("1UYmo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1659d7b4780f82fe$export$71511d61b312f219; });

var $ajVVX = parcelRequire("ajVVX");

var $hpMnK = parcelRequire("hpMnK");

var $e52Jn = parcelRequire("e52Jn");

var $lG3Im = parcelRequire("lG3Im");
function $1659d7b4780f82fe$export$71511d61b312f219(arr) {
    return (0, $ajVVX._)(arr) || (0, $hpMnK._)(arr) || (0, $lG3Im._)(arr) || (0, $e52Jn._)();
}

});





parcelRegister("30jqh", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Operator = void 0;

var $gIvya = parcelRequire("gIvya");
var $230070240da9679f$var$Operator = function Operator(name, args, apply) {
    (0, $jGAMp._)(this, Operator);
    this.name = name;
    this.args = args;
    this.apply = apply;
    this.expressionType = $gIvya.ExpressionType.Operator;
};
module.exports.Operator = $230070240da9679f$var$Operator;

});

parcelRegister("1dA1d", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Aggregate = void 0;

var $gIvya = parcelRequire("gIvya");
var $0e32f1e65aeb1bee$var$Aggregate = function Aggregate(name, expression) {
    (0, $jGAMp._)(this, Aggregate);
    this.name = name;
    this.expression = expression;
    this.expressionType = $gIvya.ExpressionType.Aggregate;
};
module.exports.Aggregate = $0e32f1e65aeb1bee$var$Aggregate;

});

parcelRegister("8p3eX", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Existence = void 0;

var $gIvya = parcelRequire("gIvya");
var $61e32bf3ecfa9f0e$var$Existence = function Existence(expression) {
    (0, $jGAMp._)(this, Existence);
    this.expression = expression;
    this.expressionType = $gIvya.ExpressionType.Existence;
};
module.exports.Existence = $61e32bf3ecfa9f0e$var$Existence;

});


parcelRegister("k3Tq9", function(module, exports) {

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
// TODO: Find a library for this, because this is basically an xsd datatypes parser
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDayTimeDuration = module.exports.parseYearMonthDuration = module.exports.parseDuration = module.exports.parseTime = module.exports.parseDate = module.exports.parseDateTime = module.exports.parseXSDDecimal = module.exports.parseXSDFloat = void 0;

var $50jbC = parcelRequire("50jbC");

var $gwvZQ = parcelRequire("gwvZQ");

var $62SQo = parcelRequire("62SQo");
/**
 * TODO: Fix decently
 * Parses float datatypes (double, float).
 *
 * All invalid lexical values return undefined.
 *
 * @param value the string to interpret as a number
 */ function $e9af13e0464b3877$var$parseXSDFloat(value) {
    var numb = Number(value);
    if (Number.isNaN(numb)) {
        if (value === 'NaN') return Number.NaN;
        if (value === 'INF' || value === '+INF') return Number.POSITIVE_INFINITY;
        if (value === '-INF') return Number.NEGATIVE_INFINITY;
        return undefined;
    }
    return numb;
}
module.exports.parseXSDFloat = $e9af13e0464b3877$var$parseXSDFloat;
/**
 * Parses decimal datatypes (decimal, int, byte, nonPositiveInteger, etc...).
 *
 * All other values, including NaN, INF, and floating point numbers all
 * return undefined;
 *
 * @param value the string to interpret as a number
 */ function $e9af13e0464b3877$var$parseXSDDecimal(value) {
    var numb = Number(value);
    return Number.isNaN(numb) ? undefined : numb;
}
module.exports.parseXSDDecimal = $e9af13e0464b3877$var$parseXSDDecimal;
function $e9af13e0464b3877$var$parseDateTime(dateTimeStr) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime
    var _dateTimeStr_split = (0, $32TW8._)(dateTimeStr.split('T'), 2), date = _dateTimeStr_split[0], time = _dateTimeStr_split[1];
    if (time === undefined) throw new $gwvZQ.ParseError(dateTimeStr, 'dateTime');
    return (0, $iT0je._)({}, $e9af13e0464b3877$var$parseDate(date), $e9af13e0464b3877$var$__parseTime(time));
}
module.exports.parseDateTime = $e9af13e0464b3877$var$parseDateTime;
function $e9af13e0464b3877$var$parseTimeZone(timeZoneStr) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime-timezones
    if (timeZoneStr === '') return {
        zoneHours: undefined,
        zoneMinutes: undefined
    };
    if (timeZoneStr === 'Z') return {
        zoneHours: 0,
        zoneMinutes: 0
    };
    var timeZoneStrings = timeZoneStr.replaceAll(RegExp("^([+|-])(\\d\\d):(\\d\\d)$", "gu"), '$11!$2!$3').split('!');
    var timeZone = timeZoneStrings.map(Number);
    return {
        zoneHours: timeZone[0] * timeZone[1],
        zoneMinutes: timeZone[0] * timeZone[2]
    };
}
function $e9af13e0464b3877$var$parseDate(dateStr) {
    // https://www.w3.org/TR/xmlschema-2/#date-lexical-representation
    var formatted = dateStr.replaceAll(RegExp("^(-)?([123456789]*\\d{4})-(\\d\\d)-(\\d\\d)(Z|([+-]\\d\\d:\\d\\d))?$", "gu"), '$11!$2!$3!$4!$5');
    if (formatted === dateStr) throw new $gwvZQ.ParseError(dateStr, 'date');
    var dateStrings = formatted.split('!');
    var date = dateStrings.slice(0, -1).map(Number);
    var res = (0, $iT0je._)({
        year: date[0] * date[1],
        month: date[2],
        day: date[3]
    }, $e9af13e0464b3877$var$parseTimeZone(dateStrings[4]));
    if (!(res.month >= 1 && res.month <= 12) || !(res.day >= 1 && res.day <= (0, $62SQo.maximumDayInMonthFor)(res.year, res.month))) throw new $gwvZQ.ParseError(dateStr, 'date');
    return res;
}
module.exports.parseDate = $e9af13e0464b3877$var$parseDate;
function $e9af13e0464b3877$var$__parseTime(timeStr) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    var formatted = timeStr.replaceAll(RegExp("^(\\d\\d):(\\d\\d):(\\d\\d(\\.\\d+)?)(Z|([+-]\\d\\d:\\d\\d))?$", "gu"), '$1!$2!$3!$5');
    if (formatted === timeStr) throw new $gwvZQ.ParseError(timeStr, 'time');
    var timeStrings = formatted.split('!');
    var time = timeStrings.slice(0, -1).map(Number);
    var res = (0, $iT0je._)({
        hours: time[0],
        minutes: time[1],
        seconds: time[2]
    }, $e9af13e0464b3877$var$parseTimeZone(timeStrings[3]));
    if (res.seconds >= 60 || res.minutes >= 60 || res.hours > 24 || res.hours === 24 && (res.minutes !== 0 || res.seconds !== 0)) throw new $gwvZQ.ParseError(timeStr, 'time');
    return res;
}
// We make a separation in internal and external since dateTime will have hour-date rollover,
// but time just does modulo the time.
function $e9af13e0464b3877$var$parseTime(timeStr) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    var res = $e9af13e0464b3877$var$__parseTime(timeStr);
    res.hours %= 24;
    return res;
}
module.exports.parseTime = $e9af13e0464b3877$var$parseTime;
function $e9af13e0464b3877$var$parseDuration(durationStr) {
    // https://www.w3.org/TR/xmlschema-2/#duration-lexical-repr
    var _durationStr_split = (0, $32TW8._)(durationStr.split('T'), 2), dayNotation = _durationStr_split[0], timeNotation = _durationStr_split[1];
    // Handle date part
    var formattedDayDur = dayNotation.replaceAll(RegExp("^(-)?P(\\d+Y)?(\\d+M)?(\\d+D)?$", "gu"), '$11S!$2!$3!$4');
    if (formattedDayDur === dayNotation) throw new $gwvZQ.ParseError(durationStr, 'duration');
    var durationStrings = formattedDayDur.split('!');
    if (timeNotation !== undefined) {
        var _durationStrings;
        var formattedTimeDur = timeNotation.replaceAll(RegExp("^(\\d+H)?(\\d+M)?(\\d+(\\.\\d+)?S)?$", "gu"), '$1!$2!$3');
        if (timeNotation === '' || timeNotation === formattedTimeDur) throw new $gwvZQ.ParseError(durationStr, 'duration');
        (_durationStrings = durationStrings).push.apply(_durationStrings, (0, $7WNf6._)(formattedTimeDur.split('!')));
    }
    var duration = durationStrings.map(function(str) {
        return str.slice(0, -1);
    });
    if (!duration.slice(1).some(Boolean)) throw new $gwvZQ.ParseError(durationStr, 'duration');
    var sign = Number(duration[0]);
    return (0, $50jbC.simplifyDurationRepresentation)({
        year: duration[1] ? sign * Number(duration[1]) : undefined,
        month: duration[2] ? sign * Number(duration[2]) : undefined,
        day: duration[3] ? sign * Number(duration[3]) : undefined,
        hours: duration[4] ? sign * Number(duration[4]) : undefined,
        minutes: duration[5] ? sign * Number(duration[5]) : undefined,
        seconds: duration[6] ? sign * Number(duration[6]) : undefined
    });
}
module.exports.parseDuration = $e9af13e0464b3877$var$parseDuration;
function $e9af13e0464b3877$var$parseYearMonthDuration(durationStr) {
    var res = $e9af13e0464b3877$var$parseDuration(durationStr);
    if ([
        'hours',
        'minutes',
        'seconds',
        'day'
    ].some(function(key) {
        return Boolean(res[key]);
    })) throw new $gwvZQ.ParseError(durationStr, 'yearMonthDuration');
    return res;
}
module.exports.parseYearMonthDuration = $e9af13e0464b3877$var$parseYearMonthDuration;
function $e9af13e0464b3877$var$parseDayTimeDuration(durationStr) {
    var res = $e9af13e0464b3877$var$parseDuration(durationStr);
    if ([
        'year',
        'month'
    ].some(function(key) {
        return Boolean(res[key]);
    })) throw new $gwvZQ.ParseError(durationStr, 'dayTimeDuration');
    return res;
}
module.exports.parseDayTimeDuration = $e9af13e0464b3877$var$parseDayTimeDuration;

});
parcelRegister("50jbC", function(module, exports) {

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractTimeZone = module.exports.extractRawTimeZone = module.exports.dayTimeDurationsToSeconds = module.exports.yearMonthDurationsToMonths = module.exports.trimToDayTimeDuration = module.exports.trimToYearMonthDuration = module.exports.toUTCDate = module.exports.toJSDate = module.exports.negateDuration = module.exports.toDateTimeRepresentation = module.exports.defaultedDateTimeRepresentation = module.exports.simplifyDurationRepresentation = module.exports.defaultedDurationRepresentation = module.exports.defaultedYearMonthDurationRepresentation = module.exports.defaultedDayTimeDurationRepresentation = void 0;
// Important is to notice JS and XSD datatypes have different defaulted values
// | Field | Default in JS | Default in XSD_DayTime | Default in XSD_Duration |
// | Month | 0             | 1                      | 0                       |
// | Day   | 1             | 1                      | 0                       |
function $3a4bd5d9b16c562e$var$defaultedDayTimeDurationRepresentation(rep) {
    var _rep_day, _rep_hours, _rep_minutes, _rep_seconds;
    return {
        day: (_rep_day = rep.day) !== null && _rep_day !== void 0 ? _rep_day : 0,
        hours: (_rep_hours = rep.hours) !== null && _rep_hours !== void 0 ? _rep_hours : 0,
        minutes: (_rep_minutes = rep.minutes) !== null && _rep_minutes !== void 0 ? _rep_minutes : 0,
        seconds: (_rep_seconds = rep.seconds) !== null && _rep_seconds !== void 0 ? _rep_seconds : 0
    };
}
module.exports.defaultedDayTimeDurationRepresentation = $3a4bd5d9b16c562e$var$defaultedDayTimeDurationRepresentation;
function $3a4bd5d9b16c562e$var$defaultedYearMonthDurationRepresentation(rep) {
    var _rep_year, _rep_month;
    return {
        year: (_rep_year = rep.year) !== null && _rep_year !== void 0 ? _rep_year : 0,
        month: (_rep_month = rep.month) !== null && _rep_month !== void 0 ? _rep_month : 0
    };
}
module.exports.defaultedYearMonthDurationRepresentation = $3a4bd5d9b16c562e$var$defaultedYearMonthDurationRepresentation;
function $3a4bd5d9b16c562e$var$defaultedDurationRepresentation(rep) {
    return (0, $iT0je._)({}, $3a4bd5d9b16c562e$var$defaultedDayTimeDurationRepresentation(rep), $3a4bd5d9b16c562e$var$defaultedYearMonthDurationRepresentation(rep));
}
module.exports.defaultedDurationRepresentation = $3a4bd5d9b16c562e$var$defaultedDurationRepresentation;
function $3a4bd5d9b16c562e$var$simplifyDurationRepresentation(rep) {
    var temp = $3a4bd5d9b16c562e$var$defaultedDurationRepresentation(rep);
    var res = {};
    // Simplify year part
    var years = temp.year + Math.trunc(temp.month / 12);
    if (years) {
        res.year = years;
        temp.month %= 12;
    }
    if (temp.month) res.month = temp.month;
    // Simplify day part
    var days = temp.day + Math.trunc(temp.hours / 24) + Math.trunc(temp.minutes / 1440) + Math.trunc(temp.seconds / 86400);
    if (days) {
        res.day = days;
        temp.hours %= 24;
        temp.minutes %= 1440;
        temp.seconds %= 86400;
    }
    var hours = temp.hours + Math.trunc(temp.minutes / 60) + Math.trunc(temp.seconds / 3600);
    if (hours) {
        res.hours = hours;
        temp.minutes %= 60;
        temp.seconds %= 3600;
    }
    var minutes = temp.minutes + Math.trunc(temp.seconds / 60);
    if (minutes) {
        res.minutes = minutes;
        temp.seconds %= 60;
    }
    if (temp.seconds) res.seconds = temp.seconds;
    return res;
}
module.exports.simplifyDurationRepresentation = $3a4bd5d9b16c562e$var$simplifyDurationRepresentation;
function $3a4bd5d9b16c562e$var$defaultedDateTimeRepresentation(rep) {
    var _rep_day, _rep_hours, _rep_month, _rep_year, _rep_seconds, _rep_minutes;
    return (0, $emQHU._)((0, $iT0je._)({}, rep), {
        day: (_rep_day = rep.day) !== null && _rep_day !== void 0 ? _rep_day : 1,
        hours: (_rep_hours = rep.hours) !== null && _rep_hours !== void 0 ? _rep_hours : 0,
        month: (_rep_month = rep.month) !== null && _rep_month !== void 0 ? _rep_month : 1,
        year: (_rep_year = rep.year) !== null && _rep_year !== void 0 ? _rep_year : 0,
        seconds: (_rep_seconds = rep.seconds) !== null && _rep_seconds !== void 0 ? _rep_seconds : 0,
        minutes: (_rep_minutes = rep.minutes) !== null && _rep_minutes !== void 0 ? _rep_minutes : 0
    });
}
module.exports.defaultedDateTimeRepresentation = $3a4bd5d9b16c562e$var$defaultedDateTimeRepresentation;
function $3a4bd5d9b16c562e$var$toDateTimeRepresentation(param) {
    var date = param.date, timeZone = param.timeZone;
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
        zoneHours: timeZone.zoneHours,
        zoneMinutes: timeZone.zoneMinutes
    };
}
module.exports.toDateTimeRepresentation = $3a4bd5d9b16c562e$var$toDateTimeRepresentation;
function $3a4bd5d9b16c562e$var$negateDuration(dur) {
    return {
        year: dur.year === undefined ? undefined : -1 * dur.year,
        month: dur.month === undefined ? undefined : -1 * dur.month,
        day: dur.day === undefined ? undefined : -1 * dur.day,
        hours: dur.hours === undefined ? undefined : -1 * dur.hours,
        minutes: dur.minutes === undefined ? undefined : -1 * dur.minutes,
        seconds: dur.seconds === undefined ? undefined : -1 * dur.seconds
    };
}
module.exports.negateDuration = $3a4bd5d9b16c562e$var$negateDuration;
function $3a4bd5d9b16c562e$var$toJSDate(date) {
    // The given hours will be assumed to be local time.
    var res = new Date(date.year, date.month - 1, date.day, date.hours, date.minutes, Math.trunc(date.seconds), date.seconds % 1 * 1000);
    if (date.year >= 0 && date.year < 100) {
        // Special rule of date has gone int action:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#individual_date_and_time_component_values
        var jumpDeltaOfDate = 1900;
        res.setFullYear(res.getFullYear() - jumpDeltaOfDate);
    }
    return res;
}
module.exports.toJSDate = $3a4bd5d9b16c562e$var$toJSDate;
function $3a4bd5d9b16c562e$var$toUTCDate(date, defaultTimezone) {
    var localTime = $3a4bd5d9b16c562e$var$toJSDate($3a4bd5d9b16c562e$var$defaultedDateTimeRepresentation(date));
    // This date has been constructed in machine local time, now we alter it to become UTC and convert to correct timezone
    // Correction needed from local machine timezone to UTC
    var minutesCorrectionLocal = localTime.getTimezoneOffset();
    var _date_zoneHours;
    // Correction needed from UTC to provided timeZone
    var hourCorrectionUTC = (_date_zoneHours = date.zoneHours) !== null && _date_zoneHours !== void 0 ? _date_zoneHours : defaultTimezone.zoneHours;
    var _date_zoneMinutes;
    var minutesCorrectionUTC = (_date_zoneMinutes = date.zoneMinutes) !== null && _date_zoneMinutes !== void 0 ? _date_zoneMinutes : defaultTimezone.zoneMinutes;
    return new Date(localTime.getTime() - (minutesCorrectionLocal + hourCorrectionUTC * 60 + minutesCorrectionUTC) * 60000);
}
module.exports.toUTCDate = $3a4bd5d9b16c562e$var$toUTCDate;
function $3a4bd5d9b16c562e$var$trimToYearMonthDuration(dur) {
    return {
        year: dur.year,
        month: dur.month
    };
}
module.exports.trimToYearMonthDuration = $3a4bd5d9b16c562e$var$trimToYearMonthDuration;
function $3a4bd5d9b16c562e$var$trimToDayTimeDuration(dur) {
    return {
        day: dur.day,
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds
    };
}
module.exports.trimToDayTimeDuration = $3a4bd5d9b16c562e$var$trimToDayTimeDuration;
function $3a4bd5d9b16c562e$var$yearMonthDurationsToMonths(dur) {
    return dur.year * 12 + dur.month;
}
module.exports.yearMonthDurationsToMonths = $3a4bd5d9b16c562e$var$yearMonthDurationsToMonths;
function $3a4bd5d9b16c562e$var$dayTimeDurationsToSeconds(dur) {
    return ((dur.day * 24 + dur.hours) * 60 + dur.minutes) * 60 + dur.seconds;
}
module.exports.dayTimeDurationsToSeconds = $3a4bd5d9b16c562e$var$dayTimeDurationsToSeconds;
function $3a4bd5d9b16c562e$var$extractRawTimeZone(zoneContained) {
    var extraction = RegExp("(Z|([+-]\\d\\d:\\d\\d))?$", "u").exec(zoneContained);
    // It is safe to cast here because the empty string can always match.
    return extraction[0];
}
module.exports.extractRawTimeZone = $3a4bd5d9b16c562e$var$extractRawTimeZone;
function $3a4bd5d9b16c562e$var$extractTimeZone(date) {
    return {
        zoneHours: date.getTimezoneOffset() / 60,
        zoneMinutes: date.getTimezoneOffset() % 60
    };
}
module.exports.extractTimeZone = $3a4bd5d9b16c562e$var$extractTimeZone;

});

parcelRegister("62SQo", function(module, exports) {

var $iT0je = parcelRequire("iT0je");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.elapsedDuration = module.exports.addDurationToDateTime = module.exports.maximumDayInMonthFor = void 0;

var $50jbC = parcelRequire("50jbC");
function $466d78e22026292f$var$fDiv(arg, high) {
    var low = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    // Adds the 4 spec functions into one since they are highly related,
    // and fQuotient and modulo are almost always called in pairs.
    var first = arg - low;
    var second = high - low;
    var intDiv = Math.floor(first / second);
    return {
        intDiv: intDiv,
        remainder: arg - intDiv * second
    };
}
function $466d78e22026292f$var$maximumDayInMonthFor(yearValue, monthValue) {
    var _fDiv = $466d78e22026292f$var$fDiv(monthValue, 13, 1), additionalYears = _fDiv.intDiv, month = _fDiv.remainder;
    var year = yearValue + additionalYears;
    if ([
        1,
        3,
        5,
        7,
        8,
        10,
        12
    ].includes(month)) return 31;
    if ([
        4,
        6,
        9,
        11
    ].includes(month)) return 30;
    if (month === 2 && ($466d78e22026292f$var$fDiv(year, 400).remainder === 0 || $466d78e22026292f$var$fDiv(year, 100).remainder !== 0 && $466d78e22026292f$var$fDiv(year, 4).remainder === 0)) return 29;
    return 28;
}
module.exports.maximumDayInMonthFor = $466d78e22026292f$var$maximumDayInMonthFor;
// https://www.w3.org/TR/xmlschema-2/#adding-durations-to-dateTimes
function $466d78e22026292f$var$addDurationToDateTime(date, duration) {
    // Used to cary over optional fields like timezone
    var newDate = (0, $iT0je._)({}, date);
    // Month
    var tempDiv = $466d78e22026292f$var$fDiv(date.month + duration.month, 13, 1);
    newDate.month = tempDiv.remainder;
    // Year
    newDate.year = date.year + duration.year + tempDiv.intDiv;
    // Seconds
    tempDiv = $466d78e22026292f$var$fDiv(date.seconds + duration.seconds, 60);
    newDate.seconds = tempDiv.remainder;
    // Minutes
    tempDiv = $466d78e22026292f$var$fDiv(date.minutes + duration.minutes + tempDiv.intDiv, 60);
    newDate.minutes = tempDiv.remainder;
    // Hours
    tempDiv = $466d78e22026292f$var$fDiv(date.hours + duration.hours + tempDiv.intDiv, 24);
    newDate.hours = tempDiv.remainder;
    // We skip a part of the spec code since: Defined spec code can not happen since it would be an invalid literal
    newDate.day = date.day + duration.day + tempDiv.intDiv;
    while(true){
        var carry = void 0;
        if (newDate.day < 1) {
            newDate.day += $466d78e22026292f$var$maximumDayInMonthFor(newDate.year, newDate.month - 1);
            carry = -1;
        } else if (newDate.day > $466d78e22026292f$var$maximumDayInMonthFor(newDate.year, newDate.month)) {
            newDate.day -= $466d78e22026292f$var$maximumDayInMonthFor(newDate.year, newDate.month);
            carry = 1;
        } else break;
        tempDiv = $466d78e22026292f$var$fDiv(newDate.month + carry, 13, 1);
        newDate.month = tempDiv.remainder;
        newDate.year += tempDiv.intDiv;
    }
    return newDate;
}
module.exports.addDurationToDateTime = $466d78e22026292f$var$addDurationToDateTime;
function $466d78e22026292f$var$elapsedDuration(first, second, defaultTimeZone) {
    var d1 = (0, $50jbC.toUTCDate)(first, defaultTimeZone);
    var d2 = (0, $50jbC.toUTCDate)(second, defaultTimeZone);
    var diff = d1.getTime() - d2.getTime();
    return {
        day: Math.floor(diff / 86400000),
        hours: Math.floor(diff % 86400000 / 3600000),
        minutes: Math.floor(diff % 3600000 / 60000),
        seconds: diff % 60000
    };
}
module.exports.elapsedDuration = $466d78e22026292f$var$elapsedDuration;

});



parcelRegister("1dicK", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareEvaluatorActionContext = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $j9GhE = parcelRequire("j9GhE");

var $50jbC = parcelRequire("50jbC");
function $0e25206c46b99331$var$prepareEvaluatorActionContext(orgContext) {
    var context = orgContext;
    // Handle two variants of providing extension functions
    if (context.has($9nBhR.KeysInitQuery.extensionFunctionCreator) && context.has($9nBhR.KeysInitQuery.extensionFunctions)) throw new Error('Illegal simultaneous usage of extensionFunctionCreator and extensionFunctions in context');
    if (context.has($9nBhR.KeysInitQuery.extensionFunctionCreator)) context = context.set($9nBhR.KeysExpressionEvaluator.extensionFunctionCreator, context.get($9nBhR.KeysInitQuery.extensionFunctionCreator));
    else if (context.has($9nBhR.KeysInitQuery.extensionFunctions)) {
        var extensionFunctions = context.getSafe($9nBhR.KeysInitQuery.extensionFunctions);
        context = context.set($9nBhR.KeysExpressionEvaluator.extensionFunctionCreator, function(functionNamedNode) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    return [
                        2,
                        extensionFunctions[functionNamedNode.value]
                    ];
                });
            })();
        });
    } else // eslint-disable-next-line unicorn/no-useless-undefined
    context = context.setDefault($9nBhR.KeysExpressionEvaluator.extensionFunctionCreator, function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                return [
                    2,
                    undefined
                ];
            });
        })();
    });
    context = context.setDefault($9nBhR.KeysExpressionEvaluator.defaultTimeZone, (0, $50jbC.extractTimeZone)(context.getSafe($9nBhR.KeysInitQuery.queryTimestamp)));
    context = context.setDefault($9nBhR.KeysExpressionEvaluator.superTypeProvider, {
        cache: new $j9GhE.LRUCache({
            max: 1000
        }),
        discoverer: function() {
            return 'term';
        }
    });
    return context;
}
module.exports.prepareEvaluatorActionContext = $0e25206c46b99331$var$prepareEvaluatorActionContext;

});
parcelRegister("j9GhE", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $df1fa83db2ed51ff$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $df1fa83db2ed51ff$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $df1fa83db2ed51ff$var$warned = new Set();
/* c8 ignore start */ var $df1fa83db2ed51ff$var$PROCESS = {};
/* c8 ignore start */ var $df1fa83db2ed51ff$var$emitWarning = function(msg, type, code, fn) {
    typeof $df1fa83db2ed51ff$var$PROCESS.emitWarning === 'function' ? $df1fa83db2ed51ff$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $df1fa83db2ed51ff$var$AC = globalThis.AbortController;
var $df1fa83db2ed51ff$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $df1fa83db2ed51ff$var$AC === 'undefined') {
    var $df1fa83db2ed51ff$var$_PROCESS_env;
    //@ts-ignore
    $df1fa83db2ed51ff$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $df1fa83db2ed51ff$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $df1fa83db2ed51ff$var$AS());
            $df1fa83db2ed51ff$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $df1fa83db2ed51ff$var$printACPolyfillWarning = (($df1fa83db2ed51ff$var$_PROCESS_env = $df1fa83db2ed51ff$var$PROCESS.env) === null || $df1fa83db2ed51ff$var$_PROCESS_env === void 0 ? void 0 : $df1fa83db2ed51ff$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $df1fa83db2ed51ff$var$warnACPolyfill = function() {
        if (!$df1fa83db2ed51ff$var$printACPolyfillWarning) return;
        $df1fa83db2ed51ff$var$printACPolyfillWarning = false;
        $df1fa83db2ed51ff$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $df1fa83db2ed51ff$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $df1fa83db2ed51ff$var$shouldWarn = function(code) {
    return !$df1fa83db2ed51ff$var$warned.has(code);
};
var $df1fa83db2ed51ff$var$TYPE = Symbol('type');
var $df1fa83db2ed51ff$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $df1fa83db2ed51ff$var$getUintArray = function(max) {
    return !$df1fa83db2ed51ff$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $df1fa83db2ed51ff$var$ZeroArray : null;
};
/* c8 ignore stop */ var $df1fa83db2ed51ff$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $df1fa83db2ed51ff$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $df1fa83db2ed51ff$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $df1fa83db2ed51ff$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $df1fa83db2ed51ff$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $df1fa83db2ed51ff$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $df1fa83db2ed51ff$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$df1fa83db2ed51ff$var$_max = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_maxSize = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_dispose = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$df1fa83db2ed51ff$var$_size = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_keyMap = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_keyList = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_valList = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_next = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_prev = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_head = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_tail = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_free = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_disposed = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_sizes = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_starts = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_ttls = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$df1fa83db2ed51ff$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $df1fa83db2ed51ff$var$_isStale = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_requireSize = /*#__PURE__*/ new WeakMap(), $df1fa83db2ed51ff$var$_indexes = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_rindexes = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_evict = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_connect = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_delete = /*#__PURE__*/ new WeakSet(), $df1fa83db2ed51ff$var$_clear = /*#__PURE__*/ new WeakSet();
var $df1fa83db2ed51ff$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_indexes);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_rindexes);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_isValidIndex);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_evict);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_backgroundFetch);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_connect);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_moveToTail);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_delete);
        (0, $bA8rW._)(this, $df1fa83db2ed51ff$var$_clear);
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $df1fa83db2ed51ff$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$df1fa83db2ed51ff$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $df1fa83db2ed51ff$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_max, max);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, 0);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, 0);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_free, $df1fa83db2ed51ff$var$Stack.create(max));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_size, 0);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_hasDispose, !!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_dispose));
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize) !== 0) {
                if (!$df1fa83db2ed51ff$var$isPosInt((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$df1fa83db2ed51ff$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_initializeSizeTracking, $df1fa83db2ed51ff$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $df1fa83db2ed51ff$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$df1fa83db2ed51ff$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_initializeTTLTracking, $df1fa83db2ed51ff$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max) && !(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($df1fa83db2ed51ff$var$shouldWarn(code)) {
                $df1fa83db2ed51ff$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $df1fa83db2ed51ff$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i],
                                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i],
                                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($df1fa83db2ed51ff$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes)) entry.size = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $df1fa83db2ed51ff$var$perf.now() - (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes)) entry.size = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $df1fa83db2ed51ff$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) === 0 ? (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail) : (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).length !== 0 ? (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).pop() : (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max) ? (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_evict, $df1fa83db2ed51ff$var$evict).call(this, false) : (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size);
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail)] = index;
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[index] = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail);
                    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, index);
                    (0, $3cNKp._)(this, $df1fa83db2ed51ff$var$_size).value++;
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_moveToTail, $df1fa83db2ed51ff$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $df1fa83db2ed51ff$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $df1fa83db2ed51ff$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls)) (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_initializeTTLTracking, $df1fa83db2ed51ff$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $df1fa83db2ed51ff$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size)){
                        var val = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head)];
                        (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_evict, $df1fa83db2ed51ff$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $df1fa83db2ed51ff$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_backgroundFetch, $df1fa83db2ed51ff$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_moveToTail, $df1fa83db2ed51ff$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_backgroundFetch, $df1fa83db2ed51ff$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_moveToTail, $df1fa83db2ed51ff$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_clear, $df1fa83db2ed51ff$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_starts),
                    ttls: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_ttls),
                    sizes: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_keyList),
                    valList: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_valList),
                    next: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_next),
                    prev: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $df1fa83db2ed51ff$var$_backgroundFetch, $df1fa83db2ed51ff$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $df1fa83db2ed51ff$var$_moveToTail, $df1fa83db2ed51ff$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $df1fa83db2ed51ff$var$_indexes, $df1fa83db2ed51ff$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $df1fa83db2ed51ff$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $df1fa83db2ed51ff$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $df1fa83db2ed51ff$var$ZeroArray((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max));
    var starts = new $df1fa83db2ed51ff$var$ZeroArray((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max));
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_ttls, ttls);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_starts, starts);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $df1fa83db2ed51ff$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $df1fa83db2ed51ff$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(_this1, (0, $el4bI._)(_this1, $df1fa83db2ed51ff$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $df1fa83db2ed51ff$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $df1fa83db2ed51ff$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $df1fa83db2ed51ff$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $df1fa83db2ed51ff$var$ZeroArray((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_max));
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_sizes, sizes);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $df1fa83db2ed51ff$var$_calculatedSize, (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$df1fa83db2ed51ff$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$df1fa83db2ed51ff$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $df1fa83db2ed51ff$var$_evict, $df1fa83db2ed51ff$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $df1fa83db2ed51ff$var$_calculatedSize, (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_calculatedSize);
        }
    });
}
function $df1fa83db2ed51ff$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isValidIndex, $df1fa83db2ed51ff$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $df1fa83db2ed51ff$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isValidIndex, $df1fa83db2ed51ff$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $df1fa83db2ed51ff$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[index]) === index;
}
function $df1fa83db2ed51ff$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head);
    var k = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[head];
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose) || (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $df1fa83db2ed51ff$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) === 1) {
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, 0));
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[head]);
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $df1fa83db2ed51ff$var$_size).value--;
    return head;
}
function $df1fa83db2ed51ff$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $df1fa83db2ed51ff$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $df1fa83db2ed51ff$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $df1fa83db2ed51ff$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $df1fa83db2ed51ff$var$_delete, $df1fa83db2ed51ff$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $df1fa83db2ed51ff$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $df1fa83db2ed51ff$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index] = bf;
    return bf;
}
function $df1fa83db2ed51ff$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $df1fa83db2ed51ff$var$AC;
}
function $df1fa83db2ed51ff$var$connect(p, n) {
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[n] = p;
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[p] = n;
}
function $df1fa83db2ed51ff$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail)) {
        if (index === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head)) (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[index]);
        else (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_connect, $df1fa83db2ed51ff$var$connect).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[index], (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[index]);
        (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_connect, $df1fa83db2ed51ff$var$connect).call(this, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail), index);
        (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, index);
    }
}
function $df1fa83db2ed51ff$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_size) === 1) (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_clear, $df1fa83db2ed51ff$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose) || (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $df1fa83db2ed51ff$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_tail)) (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_head)) (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[index];
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[pi] = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_next)[index];
                    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[ni] = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $df1fa83db2ed51ff$var$_size).value--;
                (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $df1fa83db2ed51ff$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $df1fa83db2ed51ff$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_rindexes, $df1fa83db2ed51ff$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $df1fa83db2ed51ff$var$_isBackgroundFetch, $df1fa83db2ed51ff$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList)[index];
                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $df1fa83db2ed51ff$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyMap).clear();
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts)) {
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_ttls).fill(0);
        (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes)) (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_head, 0);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_tail, 0);
    (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_free).length = 0;
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $df1fa83db2ed51ff$var$_size, 0);
    if ((0, $el4bI._)(this, $df1fa83db2ed51ff$var$_hasDisposeAfter) && (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $df1fa83db2ed51ff$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $df1fa83db2ed51ff$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});
parcelRegister("el4bI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a706467e6a1b3d81$export$71511d61b312f219; });

var $20mU2 = parcelRequire("20mU2");

var $g58nw = parcelRequire("g58nw");
function $a706467e6a1b3d81$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $g58nw._)(receiver, privateMap, "get");
    return (0, $20mU2._)(receiver, descriptor);
}

});
parcelRegister("20mU2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $175d58e296c5a336$export$71511d61b312f219; });
function $175d58e296c5a336$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("g58nw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bb539cc49ee4dce3$export$71511d61b312f219; });
function $bb539cc49ee4dce3$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("hsOXY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cb6c960472503351$export$71511d61b312f219; });

var $23fGG = parcelRequire("23fGG");
function $cb6c960472503351$export$71511d61b312f219(obj, privateMap, value) {
    (0, $23fGG._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("23fGG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17e807c8e194bf76$export$71511d61b312f219; });
function $17e807c8e194bf76$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("FPkD9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $07dba5dda8510a5e$export$71511d61b312f219; });

var $7wJY7 = parcelRequire("7wJY7");

var $g58nw = parcelRequire("g58nw");
function $07dba5dda8510a5e$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $g58nw._)(receiver, privateMap, "set");
    (0, $7wJY7._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("7wJY7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $57af2df64efbb188$export$71511d61b312f219; });
function $57af2df64efbb188$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("3cNKp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $255914ee8687bf95$export$71511d61b312f219; });

var $2OEmG = parcelRequire("2OEmG");

var $g58nw = parcelRequire("g58nw");
function $255914ee8687bf95$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $g58nw._)(receiver, privateMap, "update");
    return (0, $2OEmG._)(receiver, descriptor);
}

});
parcelRegister("2OEmG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20cf8fed27d74941$export$71511d61b312f219; });
function $20cf8fed27d74941$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

});


parcelRegister("dZ0wD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a2e1612ed4d37a9f$export$71511d61b312f219; });
function $a2e1612ed4d37a9f$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("bA8rW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $86e99c6ab9f1b451$export$71511d61b312f219; });

var $23fGG = parcelRequire("23fGG");
function $86e99c6ab9f1b451$export$71511d61b312f219(obj, privateSet) {
    (0, $23fGG._)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("iRvUI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dbb5ee9e880b32a2$export$71511d61b312f219; });

var $20mU2 = parcelRequire("20mU2");

var $5C2pv = parcelRequire("5C2pv");

var $b5tmp = parcelRequire("b5tmp");
function $dbb5ee9e880b32a2$export$71511d61b312f219(receiver, classConstructor, descriptor) {
    (0, $5C2pv._)(receiver, classConstructor);
    (0, $b5tmp._)(descriptor, "get");
    return (0, $20mU2._)(receiver, descriptor);
}

});
parcelRegister("5C2pv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $41625f0972ae48c9$export$71511d61b312f219; });
function $41625f0972ae48c9$export$71511d61b312f219(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}

});

parcelRegister("b5tmp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8126efb72a43c4b7$export$71511d61b312f219; });
function $8126efb72a43c4b7$export$71511d61b312f219(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}

});


parcelRegister("dqGf9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9c6e78bb2d66ade9$export$71511d61b312f219; });

var $7wJY7 = parcelRequire("7wJY7");

var $5C2pv = parcelRequire("5C2pv");

var $b5tmp = parcelRequire("b5tmp");
function $9c6e78bb2d66ade9$export$71511d61b312f219(receiver, classConstructor, descriptor, value) {
    (0, $5C2pv._)(receiver, classConstructor);
    (0, $b5tmp._)(descriptor, "set");
    (0, $7wJY7._)(receiver, descriptor, value);
    return value;
}

});






parcelRegister("dng5S", function(module, exports) {
"use strict";
var $9bc9e83e2e4a2d34$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9bc9e83e2e4a2d34$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9bc9e83e2e4a2d34$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9bc9e83e2e4a2d34$var$__exportStar((parcelRequire("eAKbV")), module.exports);

$9bc9e83e2e4a2d34$var$__exportStar((parcelRequire("bhMFI")), module.exports);

$9bc9e83e2e4a2d34$var$__exportStar((parcelRequire("8pqNh")), module.exports);

$9bc9e83e2e4a2d34$var$__exportStar((parcelRequire("9qx2i")), module.exports);

});
parcelRegister("eAKbV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperation = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for query-operation events.
 *
 * Actor types:
 * * Input:  IActionQueryOperation:      A SPARQL Algebra operation.
 * * Test:   <none>
 * * Output: IActorQueryOperationOutput: A bindings stream.
 *
 * @see IActionQueryOperation
 * @see IQueryOperationResult
 */ var $a9f84223eb7db78a$var$ActorQueryOperation = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorQueryOperation, _core_1_Actor);
    function ActorQueryOperation(args) {
        (0, $jGAMp._)(this, ActorQueryOperation);
        return (0, $kzDuW._)(this, ActorQueryOperation, [
            args
        ]);
    }
    return ActorQueryOperation;
}($kNNoa.Actor);
module.exports.ActorQueryOperation = $a9f84223eb7db78a$var$ActorQueryOperation;

});

parcelRegister("bhMFI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationTyped = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $eAKbV = parcelRequire("eAKbV");
/**
 * A base implementation for query operation actors for a specific operation type.
 */ var $837709743f3f70b8$var$ActorQueryOperationTyped = /*#__PURE__*/ function(_ActorQueryOperation_1_ActorQueryOperation) {
    (0, $i3fW3._)(ActorQueryOperationTyped, _ActorQueryOperation_1_ActorQueryOperation);
    function ActorQueryOperationTyped(args, operationName) {
        (0, $jGAMp._)(this, ActorQueryOperationTyped);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationTyped, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                operationName: operationName
            })
        ]);
        if (!_this.operationName) throw new Error('A valid "operationName" argument must be provided.');
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationTyped, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.operation) return [
                            2,
                            (0, $kNNoa.failTest)('Missing field \'operation\' in a query operation action.')
                        ];
                        if (action.operation.type !== this.operationName) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " only supports ").concat(this.operationName, " operations, but got ").concat(action.operation.type))
                        ];
                        operation = action.operation;
                        return [
                            2,
                            this.testOperation(operation, action.context)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var physicalQueryPlanLogger, operation, subContext, output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Log to physical plan
                                physicalQueryPlanLogger = action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanLogger);
                                if (physicalQueryPlanLogger) {
                                    physicalQueryPlanLogger.logOperation(action.operation.type, undefined, action.operation, action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanNode), this.name, {});
                                    action.context = action.context.set($9nBhR.KeysInitQuery.physicalQueryPlanNode, action.operation);
                                }
                                operation = action.operation;
                                subContext = action.context.set($9nBhR.KeysQueryOperation.operation, operation);
                                return [
                                    4,
                                    this.runOperation(operation, subContext, sideData)
                                ];
                            case 1:
                                output = _state.sent();
                                if ('metadata' in output) output.metadata = (0, $jZbVy.cachifyMetadata)(output.metadata);
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationTyped;
}($eAKbV.ActorQueryOperation);
module.exports.ActorQueryOperationTyped = $837709743f3f70b8$var$ActorQueryOperationTyped;

});
parcelRegister("jZbVy", function(module, exports) {
"use strict";
var $e8ccf7533d37cce5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e8ccf7533d37cce5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e8ccf7533d37cce5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e8ccf7533d37cce5$var$__exportStar((parcelRequire("7JX3J")), module.exports);

$e8ccf7533d37cce5$var$__exportStar((parcelRequire("5ezRP")), module.exports);

});
parcelRegister("7JX3J", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataValidationState = void 0;
/**
 * Reusable implementation for metadata validation states.
 */ var $5a2a8c48be0e8969$var$MetadataValidationState = /*#__PURE__*/ function() {
    function MetadataValidationState() {
        (0, $jGAMp._)(this, MetadataValidationState);
        this.invalidateListeners = [];
        this.valid = true;
    }
    (0, $byiyg._)(MetadataValidationState, [
        {
            key: "addInvalidateListener",
            value: function addInvalidateListener(listener) {
                this.invalidateListeners.push(listener);
            }
        },
        {
            key: "invalidate",
            value: function invalidate() {
                if (this.valid) {
                    this.valid = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.invalidateListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var invalidateListener = _step.value;
                            invalidateListener();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        }
    ]);
    return MetadataValidationState;
}();
module.exports.MetadataValidationState = $5a2a8c48be0e8969$var$MetadataValidationState;

});

parcelRegister("5ezRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cachifyMetadata = module.exports.validateMetadataBindings = module.exports.validateMetadataQuads = module.exports.getMetadataBindings = module.exports.getMetadataQuads = void 0;
/**
 * Return a cached callback to the metadata from the given quad stream as a promise.
 * @param data A quad stream.
 */ function $3cfa150d43d736cb$var$getMetadataQuads(data) {
    return $3cfa150d43d736cb$var$cachifyMetadata(function() {
        return new Promise(function(resolve, reject) {
            data.getProperty('metadata', function(metadata) {
                return resolve(metadata);
            });
            data.on('error', reject);
        }).then(function(metadataRaw) {
            return $3cfa150d43d736cb$var$validateMetadataQuads(metadataRaw);
        });
    });
}
module.exports.getMetadataQuads = $3cfa150d43d736cb$var$getMetadataQuads;
/**
 * Return a cached callback to the metadata from the given bindings stream as a promise.
 * @param data A bindings stream.
 */ function $3cfa150d43d736cb$var$getMetadataBindings(data) {
    return $3cfa150d43d736cb$var$cachifyMetadata(function() {
        return new Promise(function(resolve, reject) {
            data.getProperty('metadata', function(metadata) {
                return resolve(metadata);
            });
            data.on('error', reject);
        }).then(function(metadataRaw) {
            return $3cfa150d43d736cb$var$validateMetadataBindings(metadataRaw);
        });
    });
}
module.exports.getMetadataBindings = $3cfa150d43d736cb$var$getMetadataBindings;
/**
 * Ensure that the given raw metadata object contains all required metadata entries.
 * @param metadataRaw A raw metadata object.
 */ function $3cfa150d43d736cb$var$validateMetadataQuads(metadataRaw) {
    for(var _i = 0, _iter = [
        'cardinality'
    ]; _i < _iter.length; _i++){
        var key = _iter[_i];
        if (!(key in metadataRaw)) throw new Error("Invalid metadata: missing ".concat(key, " in ").concat(JSON.stringify(metadataRaw)));
    }
    return metadataRaw;
}
module.exports.validateMetadataQuads = $3cfa150d43d736cb$var$validateMetadataQuads;
/**
 * Ensure that the given raw metadata object contains all required metadata entries.
 * @param metadataRaw A raw metadata object.
 */ function $3cfa150d43d736cb$var$validateMetadataBindings(metadataRaw) {
    for(var _i = 0, _iter = [
        'cardinality',
        'variables'
    ]; _i < _iter.length; _i++){
        var key = _iter[_i];
        if (!(key in metadataRaw)) throw new Error("Invalid metadata: missing ".concat(key, " in ").concat(JSON.stringify(metadataRaw)));
    }
    return metadataRaw;
}
module.exports.validateMetadataBindings = $3cfa150d43d736cb$var$validateMetadataBindings;
/**
 * Convert a metadata callback to a lazy callback where the response value is cached.
 * @param {() => Promise<IMetadata>} metadata A metadata callback
 * @return {() => Promise<{[p: string]: any}>} The callback where the response will be cached.
 */ function $3cfa150d43d736cb$var$cachifyMetadata(metadata) {
    var lastReturn;
    return function() {
        if (!lastReturn) {
            lastReturn = metadata();
            lastReturn.then(function(lastReturnValue) {
                return lastReturnValue.state.addInvalidateListener(function() {
                    lastReturn = undefined;
                });
            })["catch"](function() {
            // Ignore error
            });
        }
        return lastReturn;
    };
}
module.exports.cachifyMetadata = $3cfa150d43d736cb$var$cachifyMetadata;

});



parcelRegister("8pqNh", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationTypedMediated = void 0;

var $bhMFI = parcelRequire("bhMFI");
/**
 * A base implementation for query operation actors for a specific operation type that have a query operation mediator.
 */ var $61f57135bcd4da75$var$ActorQueryOperationTypedMediated = /*#__PURE__*/ function(_ActorQueryOperationTyped_1_ActorQueryOperationTyped) {
    (0, $i3fW3._)(ActorQueryOperationTypedMediated, _ActorQueryOperationTyped_1_ActorQueryOperationTyped);
    function ActorQueryOperationTypedMediated(args, operationName) {
        (0, $jGAMp._)(this, ActorQueryOperationTypedMediated);
        return (0, $kzDuW._)(this, ActorQueryOperationTypedMediated, [
            args,
            operationName
        ]);
    }
    return ActorQueryOperationTypedMediated;
}($bhMFI.ActorQueryOperationTyped);
module.exports.ActorQueryOperationTypedMediated = $61f57135bcd4da75$var$ActorQueryOperationTypedMediated;

});

parcelRegister("9qx2i", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusQueryOperation = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * Indexed bus for query operations.
 */ var $6dd02b0d76e884ad$var$BusQueryOperation = /*#__PURE__*/ function(_core_1_BusIndexed) {
    (0, $i3fW3._)(BusQueryOperation, _core_1_BusIndexed);
    function BusQueryOperation(args) {
        (0, $jGAMp._)(this, BusQueryOperation);
        return (0, $kzDuW._)(this, BusQueryOperation, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                actorIdentifierFields: [
                    'operationName'
                ],
                actionIdentifierFields: [
                    'operation',
                    'type'
                ]
            })
        ]);
    }
    return BusQueryOperation;
}($kNNoa.BusIndexed);
module.exports.BusQueryOperation = $6dd02b0d76e884ad$var$BusQueryOperation;

});


parcelRegister("fwfaU", function(module, exports) {
"use strict";
var $b4c59d9642fec7b1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b4c59d9642fec7b1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b4c59d9642fec7b1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b4c59d9642fec7b1$var$__exportStar((parcelRequire("4yjGQ")), module.exports);

});
parcelRegister("4yjGQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessConvertShortcuts = void 0;

var $9sIz8 = parcelRequire("9sIz8");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Convert Shortcuts Context Preprocess Actor.
 */ var $35099c74e0ee433b$var$ActorContextPreprocessConvertShortcuts = /*#__PURE__*/ function(_bus_context_preprocess_1_ActorContextPreprocess) {
    (0, $i3fW3._)(ActorContextPreprocessConvertShortcuts, _bus_context_preprocess_1_ActorContextPreprocess);
    function ActorContextPreprocessConvertShortcuts(args) {
        (0, $jGAMp._)(this, ActorContextPreprocessConvertShortcuts);
        return (0, $kzDuW._)(this, ActorContextPreprocessConvertShortcuts, [
            args
        ]);
    }
    (0, $byiyg._)(ActorContextPreprocessConvertShortcuts, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                context: ActorContextPreprocessConvertShortcuts.expandShortcuts(action.context, this.contextKeyShortcuts)
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "expandShortcuts",
            value: function expandShortcuts(context, contextKeyShortcuts) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (contextKeyShortcuts[key.name]) context = context.set(new $kNNoa.ActionContextKey(contextKeyShortcuts[key.name]), context.get(key))["delete"](key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return context;
            }
        }
    ]);
    return ActorContextPreprocessConvertShortcuts;
}($9sIz8.ActorContextPreprocess);
module.exports.ActorContextPreprocessConvertShortcuts = $35099c74e0ee433b$var$ActorContextPreprocessConvertShortcuts;

});
parcelRegister("9sIz8", function(module, exports) {
"use strict";
var $6e394c6c5a9ab323$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e394c6c5a9ab323$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e394c6c5a9ab323$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e394c6c5a9ab323$var$__exportStar((parcelRequire("9c8PK")), module.exports);

});
parcelRegister("9c8PK", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocess = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for context-preprocess events.
 *
 * Actor types:
 * * Input:  IAction:      A context that will be processed.
 * * Test:   <none>
 * * Output: IActorContextPreprocessOutput: The resulting context.
 *
 * @see IActionContextPreprocess
 * @see IActorContextPreprocessOutput
 */ var $6b1c163e2fb9b5e4$var$ActorContextPreprocess = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorContextPreprocess, _core_1_Actor);
    function ActorContextPreprocess(args) {
        (0, $jGAMp._)(this, ActorContextPreprocess);
        return (0, $kzDuW._)(this, ActorContextPreprocess, [
            args
        ]);
    }
    return ActorContextPreprocess;
}($kNNoa.Actor);
module.exports.ActorContextPreprocess = $6b1c163e2fb9b5e4$var$ActorContextPreprocess;

});




parcelRegister("6L2ur", function(module, exports) {
"use strict";
var $4eb9104c9068c33b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4eb9104c9068c33b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4eb9104c9068c33b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4eb9104c9068c33b$var$__exportStar((parcelRequire("jzfd8")), module.exports);

});
parcelRegister("jzfd8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessSetDefaults = void 0;

var $9sIz8 = parcelRequire("9sIz8");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2ej16 = parcelRequire("2ej16");
/**
 * A comunica Set Defaults Context Preprocess Actor.
 */ var $e3ed15be3e472642$var$ActorContextPreprocessSetDefaults = /*#__PURE__*/ function(_bus_context_preprocess_1_ActorContextPreprocess) {
    (0, $i3fW3._)(ActorContextPreprocessSetDefaults, _bus_context_preprocess_1_ActorContextPreprocess);
    function ActorContextPreprocessSetDefaults(args) {
        (0, $jGAMp._)(this, ActorContextPreprocessSetDefaults);
        var _this;
        _this = (0, $kzDuW._)(this, ActorContextPreprocessSetDefaults, [
            args
        ]);
        _this.defaultFunctionArgumentsCache = {};
        return _this;
    }
    (0, $byiyg._)(ActorContextPreprocessSetDefaults, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var context, queryFormat;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        context = action.context;
                        if (action.initialize) {
                            // Set default values
                            context = context.setDefault($9nBhR.KeysInitQuery.queryTimestamp, new Date()).setDefault($9nBhR.KeysInitQuery.queryTimestampHighResolution, performance.now()).setDefault($9nBhR.KeysQuerySourceIdentify.sourceIds, new Map()).setDefault($9nBhR.KeysCore.log, this.logger).setDefault($9nBhR.KeysInitQuery.functionArgumentsCache, this.defaultFunctionArgumentsCache).setDefault($9nBhR.KeysQuerySourceIdentify.hypermediaSourcesAggregatedStores, new Map()).setDefault($9nBhR.KeysInitQuery.dataFactory, new $2ej16.DataFactory());
                            // Handle default query format
                            queryFormat = {
                                language: 'sparql',
                                version: '1.1'
                            };
                            if (context.has($9nBhR.KeysInitQuery.queryFormat)) {
                                queryFormat = context.get($9nBhR.KeysInitQuery.queryFormat);
                                if (queryFormat.language === 'graphql') context = context.setDefault($9nBhR.KeysInitQuery.graphqlSingularizeVariables, {});
                            } else context = context.set($9nBhR.KeysInitQuery.queryFormat, queryFormat);
                        }
                        return [
                            2,
                            {
                                context: context
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorContextPreprocessSetDefaults;
}($9sIz8.ActorContextPreprocess);
module.exports.ActorContextPreprocessSetDefaults = $e3ed15be3e472642$var$ActorContextPreprocessSetDefaults;

});


parcelRegister("7KrwB", function(module, exports) {
"use strict";
var $5a422e29c51873d4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5a422e29c51873d4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5a422e29c51873d4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5a422e29c51873d4$var$__exportStar((parcelRequire("6bYJf")), module.exports);

});
parcelRegister("6bYJf", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessSourceToDestination = void 0;

var $9sIz8 = parcelRequire("9sIz8");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Source To Destination Context Preprocess Actor.
 */ var $4822e09fbd13685e$var$ActorContextPreprocessSourceToDestination = /*#__PURE__*/ function(_bus_context_preprocess_1_ActorContextPreprocess) {
    (0, $i3fW3._)(ActorContextPreprocessSourceToDestination, _bus_context_preprocess_1_ActorContextPreprocess);
    function ActorContextPreprocessSourceToDestination(args) {
        (0, $jGAMp._)(this, ActorContextPreprocessSourceToDestination);
        return (0, $kzDuW._)(this, ActorContextPreprocessSourceToDestination, [
            args
        ]);
    }
    (0, $byiyg._)(ActorContextPreprocessSourceToDestination, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var sources;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.context.get($9nBhR.KeysInitQuery.querySourcesUnidentified) && !action.context.get($9nBhR.KeysRdfUpdateQuads.destination)) {
                            sources = action.context.get($9nBhR.KeysInitQuery.querySourcesUnidentified);
                            if (sources.length === 1) return [
                                2,
                                {
                                    context: action.context.set($9nBhR.KeysRdfUpdateQuads.destination, sources[0])
                                }
                            ];
                        }
                        return [
                            2,
                            action
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorContextPreprocessSourceToDestination;
}($9sIz8.ActorContextPreprocess);
module.exports.ActorContextPreprocessSourceToDestination = $4822e09fbd13685e$var$ActorContextPreprocessSourceToDestination;

});


parcelRegister("8rRId", function(module, exports) {
"use strict";
var $626a82751498d6f1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $626a82751498d6f1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $626a82751498d6f1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$626a82751498d6f1$var$__exportStar((parcelRequire("iczcE")), module.exports);

$626a82751498d6f1$var$__exportStar((parcelRequire("dyCOO")), module.exports);

$626a82751498d6f1$var$__exportStar((parcelRequire("kFCZr")), module.exports);

});
parcelRegister("iczcE", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessQuerySourceSkolemize = void 0;

var $9sIz8 = parcelRequire("9sIz8");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $dyCOO = parcelRequire("dyCOO");

var $kFCZr = parcelRequire("kFCZr");
/**
 * A comunica Query Source Skolemize Context Preprocess Actor.
 */ var $d404a78da21105b7$var$ActorContextPreprocessQuerySourceSkolemize = /*#__PURE__*/ function(_bus_context_preprocess_1_ActorContextPreprocess) {
    (0, $i3fW3._)(ActorContextPreprocessQuerySourceSkolemize, _bus_context_preprocess_1_ActorContextPreprocess);
    function ActorContextPreprocessQuerySourceSkolemize(args) {
        (0, $jGAMp._)(this, ActorContextPreprocessQuerySourceSkolemize);
        return (0, $kzDuW._)(this, ActorContextPreprocessQuerySourceSkolemize, [
            args
        ]);
    }
    (0, $byiyg._)(ActorContextPreprocessQuerySourceSkolemize, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var context, sourceIds, sources;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        context = action.context;
                        // Wrap sources in skolemized sources
                        if (context.has($9nBhR.KeysQueryOperation.querySources)) {
                            // Determine map of source id's
                            if (!context.has($9nBhR.KeysQuerySourceIdentify.sourceIds)) context = context.set($9nBhR.KeysQuerySourceIdentify.sourceIds, new Map());
                            sourceIds = context.getSafe($9nBhR.KeysQuerySourceIdentify.sourceIds);
                            sources = context.getSafe($9nBhR.KeysQueryOperation.querySources);
                            sources = sources.map(function(sourceWrapper) {
                                return {
                                    source: new $dyCOO.QuerySourceSkolemized(sourceWrapper.source, (0, $kFCZr.getSourceId)(sourceIds, sourceWrapper.source)),
                                    context: sourceWrapper.context
                                };
                            });
                            context = context.set($9nBhR.KeysQueryOperation.querySources, sources);
                        }
                        return [
                            2,
                            {
                                context: context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorContextPreprocessQuerySourceSkolemize;
}($9sIz8.ActorContextPreprocess);
module.exports.ActorContextPreprocessQuerySourceSkolemize = $d404a78da21105b7$var$ActorContextPreprocessQuerySourceSkolemize;

});
parcelRegister("dyCOO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceSkolemized = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");

var $kFCZr = parcelRequire("kFCZr");
/**
 * A IQuerySource wrapper that skolemizes outgoing quads and bindings.
 */ var $9dec8fe4dda6974a$var$QuerySourceSkolemized = /*#__PURE__*/ function() {
    function QuerySourceSkolemized(innerSource, sourceId) {
        (0, $jGAMp._)(this, QuerySourceSkolemized);
        this.innerSource = innerSource;
        this.sourceId = sourceId;
    }
    (0, $byiyg._)(QuerySourceSkolemized, [
        {
            key: "getSelectorShape",
            value: function getSelectorShape(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.innerSource.getSelectorShape(context)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryBindings",
            value: function queryBindings(operation, context, options) {
                var dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                var operationMapped = (0, $kFCZr.deskolemizeOperation)(dataFactory, operation, this.sourceId);
                if (!operationMapped) {
                    var it = new $aafx9.ArrayIterator([], {
                        autoStart: false
                    });
                    it.setProperty('metadata', {
                        state: new $jZbVy.MetadataValidationState(),
                        cardinality: {
                            type: 'exact',
                            value: 0
                        },
                        variables: []
                    });
                    return it;
                }
                return (0, $kFCZr.skolemizeBindingsStream)(dataFactory, this.innerSource.queryBindings(operationMapped, context, options), this.sourceId);
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(operation, context) {
                return this.innerSource.queryBoolean(operation, context);
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(operation, context) {
                var dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                var operationMapped = (0, $kFCZr.deskolemizeOperation)(dataFactory, operation, this.sourceId);
                if (!operationMapped) {
                    var it = new $aafx9.ArrayIterator([], {
                        autoStart: false
                    });
                    it.setProperty('metadata', {
                        state: new $jZbVy.MetadataValidationState(),
                        cardinality: {
                            type: 'exact',
                            value: 0
                        }
                    });
                    return it;
                }
                return (0, $kFCZr.skolemizeQuadStream)(dataFactory, this.innerSource.queryQuads(operationMapped, context), this.sourceId);
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(operation, context) {
                return this.innerSource.queryVoid(operation, context);
            }
        },
        {
            key: "referenceValue",
            get: function get() {
                return this.innerSource.referenceValue;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.innerSource.toString(), "(SkolemID:").concat(this.sourceId, ")");
            }
        }
    ]);
    return QuerySourceSkolemized;
}();
module.exports.QuerySourceSkolemized = $9dec8fe4dda6974a$var$QuerySourceSkolemized;

});
parcelRegister("aafx9", function(module, exports) {

$parcel$export(module.exports, "scheduleTask", function () { return $25e8dc8e65a43d49$export$4c4b0fa62907e900; });
$parcel$export(module.exports, "AsyncIterator", function () { return $25e8dc8e65a43d49$export$a22e41f064157de0; });
$parcel$export(module.exports, "SimpleTransformIterator", function () { return $25e8dc8e65a43d49$export$97134afd6ea6a7bc; });
$parcel$export(module.exports, "EmptyIterator", function () { return $25e8dc8e65a43d49$export$80fed2b3fb5591aa; });
$parcel$export(module.exports, "SingletonIterator", function () { return $25e8dc8e65a43d49$export$429f276659ec1f; });
$parcel$export(module.exports, "ArrayIterator", function () { return $25e8dc8e65a43d49$export$9174e9fcc7d3059; });
$parcel$export(module.exports, "DESTINATION", function () { return $25e8dc8e65a43d49$export$b74110983b07cd2e; });
$parcel$export(module.exports, "BufferedIterator", function () { return $25e8dc8e65a43d49$export$654d6042b7ea281f; });
$parcel$export(module.exports, "TransformIterator", function () { return $25e8dc8e65a43d49$export$524b9ce0a1396fb8; });
$parcel$export(module.exports, "MultiTransformIterator", function () { return $25e8dc8e65a43d49$export$4866f110077c3a09; });
$parcel$export(module.exports, "UnionIterator", function () { return $25e8dc8e65a43d49$export$a9dbacdfc5e6386c; });
$parcel$export(module.exports, "wrap", function () { return $25e8dc8e65a43d49$export$4997ffc0176396a6; });
$parcel$export(module.exports, "WrappingIterator", function () { return $25e8dc8e65a43d49$export$21fecf94eb104400; });
/**
 * An asynchronous iterator library for advanced object pipelines
 * @module asynciterator
 */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $bBoAO = parcelRequire("bBoAO");

var $iIrt4 = parcelRequire("iIrt4");

var $alcuh = parcelRequire("alcuh");
var $25e8dc8e65a43d49$var$taskScheduler = (0, $alcuh.createTaskScheduler)();
function $25e8dc8e65a43d49$export$4c4b0fa62907e900(task) {
    $25e8dc8e65a43d49$var$taskScheduler(task);
}
function $25e8dc8e65a43d49$export$4c6be4bab151e3be() {
    return $25e8dc8e65a43d49$var$taskScheduler;
}
function $25e8dc8e65a43d49$export$30184523a1e9dfc5(scheduler) {
    $25e8dc8e65a43d49$var$taskScheduler = scheduler;
}
var $25e8dc8e65a43d49$export$d788bc089976c004 = 1;
var $25e8dc8e65a43d49$export$bb29a81b503a982c = 2;
var $25e8dc8e65a43d49$export$a44e3b3c4a99043 = 4;
var $25e8dc8e65a43d49$export$19c4f83398a8dbce = 8;
var $25e8dc8e65a43d49$export$9d38167254403955 = 16;
var $25e8dc8e65a43d49$export$74e6752c3968d283 = 32;
var $25e8dc8e65a43d49$export$a22e41f064157de0 = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $i3fW3._)(AsyncIterator, EventEmitter);
    function AsyncIterator() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $25e8dc8e65a43d49$export$bb29a81b503a982c;
        (0, $jGAMp._)(this, AsyncIterator);
        var _this;
        _this = (0, $kzDuW._)(this, AsyncIterator);
        _this._readable = false;
        _this._state = initialState;
        _this.on('newListener', $25e8dc8e65a43d49$var$waitForDataListener);
        return _this;
    }
    (0, $byiyg._)(AsyncIterator, [
        {
            /**
      Changes the iterator to the given state if possible and necessary,
      possibly emitting events to signal that change.
      @protected
      @param {integer} newState The ID of the new state
      @param {boolean} [eventAsync=false] Whether resulting events should be emitted asynchronously
      @returns {boolean} Whether the state was changed
      @emits module:asynciterator.AsyncIterator.end
    */ key: "_changeState",
            value: function _changeState(newState) {
                var _this = this;
                var eventAsync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // Validate the state change
                var valid = newState > this._state && this._state < $25e8dc8e65a43d49$export$9d38167254403955;
                if (valid) {
                    this._state = newState;
                    // Emit the `end` event when changing to ENDED
                    if (newState === $25e8dc8e65a43d49$export$9d38167254403955) {
                        if (!eventAsync) this.emit('end');
                        else $25e8dc8e65a43d49$var$taskScheduler(function() {
                            return _this.emit('end');
                        });
                    }
                }
                return valid;
            }
        },
        {
            /**
      Tries to read the next item from the iterator.
      This is the main method for reading the iterator in _on-demand mode_,
      where new items are only created when needed by consumers.
      If no items are currently available, this methods returns `null`.
      The {@link module:asynciterator.event:readable} event
      will then signal when new items might be ready.
      To read all items from the iterator,
      switch to _flow mode_ by subscribing
      to the {@link module:asynciterator.event:data} event.
      When in flow mode, do not use the `read` method.
      @returns {object?} The next item, or `null` if none is available
    */ key: "read",
            value: function read() {
                return null;
            }
        },
        {
            /**
      The iterator emits a `readable` event when it might have new items available
      after having had no items available right before this event.
      If the iterator is not in flow mode, items can be retrieved
      by calling {@link module:asynciterator.AsyncIterator#read}.
      @event module:asynciterator.readable
    */ /**
      The iterator emits a `data` event with a new item as soon as it becomes available.
      When one or more listeners are attached to the `data` event,
      the iterator switches to _flow mode_,
      generating and emitting new items as fast as possible.
      This drains the source and might create backpressure on the consumers,
      so only subscribe to this event if this behavior is intended.
      In flow mode, don't use {@link module:asynciterator.AsyncIterator#read}.
      To switch back to _on-demand mode_, remove all listeners from the `data` event.
      You can then obtain items through `read` again.
      @event module:asynciterator.data
      @param {object} item The new item
    */ /**
      Invokes the callback for each remaining item in the iterator.
      Switches the iterator to flow mode.
      @param {Function} callback A function that will be called with each item
      @param {object?} self The `this` pointer for the callback
    */ key: "forEach",
            value: function forEach(callback, self) {
                this.on('data', $25e8dc8e65a43d49$var$bind(callback, self));
            }
        },
        {
            /**
      Stops the iterator from generating new items.
      Already generated items or terminating items can still be emitted.
      After this, the iterator will end asynchronously.
      @emits module:asynciterator.AsyncIterator.end
    */ key: "close",
            value: function close() {
                if (this._changeState($25e8dc8e65a43d49$export$19c4f83398a8dbce)) this._endAsync();
            }
        },
        {
            /**
      Destroy the iterator and stop it from generating new items.
      This will not do anything if the iterator was already ended or destroyed.
      All internal resources will be released an no new items will be emitted,
      even not already generated items.
      Implementors should not override this method,
      but instead implement {@link module:asynciterator.AsyncIterator#_destroy}.
      @param {Error} [cause] An optional error to emit.
      @emits module:asynciterator.AsyncIterator.end
      @emits module:asynciterator.AsyncIterator.error Only if an error is passed.
    */ key: "destroy",
            value: function destroy(cause) {
                var _this = this;
                if (!this.done) this._destroy(cause, function(error) {
                    cause = cause || error;
                    if (cause) _this.emit('error', cause);
                    _this._end(true);
                });
            }
        },
        {
            /**
      Called by {@link module:asynciterator.AsyncIterator#destroy}.
      Implementers can override this, but this should not be called directly.
      @param {?Error} cause The reason why the iterator is destroyed.
      @param {Function} callback A callback function with an optional error argument.
    */ key: "_destroy",
            value: function _destroy(cause, callback) {
                callback();
            }
        },
        {
            /**
      Ends the iterator and cleans up.
      Should never be called before {@link module:asynciterator.AsyncIterator#close};
      typically, `close` is responsible for calling `_end`.
      @param {boolean} [destroy] If the iterator should be forcefully destroyed.
      @protected
      @emits module:asynciterator.AsyncIterator.end
    */ key: "_end",
            value: function _end() {
                var destroy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this._changeState(destroy ? $25e8dc8e65a43d49$export$74e6752c3968d283 : $25e8dc8e65a43d49$export$9d38167254403955)) {
                    this._readable = false;
                    this.removeAllListeners('readable');
                    this.removeAllListeners('data');
                    this.removeAllListeners('end');
                }
            }
        },
        {
            /**
      Asynchronously calls `_end`.
      @protected
    */ key: "_endAsync",
            value: function _endAsync() {
                var _this = this;
                $25e8dc8e65a43d49$var$taskScheduler(function() {
                    return _this._end();
                });
            }
        },
        {
            key: "readable",
            get: /**
      The `end` event is emitted after the last item of the iterator has been read.
      @event module:asynciterator.end
    */ /**
      Gets or sets whether this iterator might have items available for read.
      A value of `false` means there are _definitely_ no items available;
      a value of `true` means items _might_ be available.
      @type boolean
      @emits module:asynciterator.AsyncIterator.readable
    */ function get() {
                return this._readable;
            },
            set: function set(readable) {
                var _this = this;
                readable = Boolean(readable) && !this.done;
                // Set the readable value only if it has changed
                if (this._readable !== readable) {
                    this._readable = readable;
                    // If the iterator became readable, emit the `readable` event
                    if (readable) $25e8dc8e65a43d49$var$taskScheduler(function() {
                        return _this.emit('readable');
                    });
                }
            }
        },
        {
            key: "closed",
            get: /**
      Gets whether the iterator has stopped generating new items.
      @type boolean
      @readonly
    */ function get() {
                return this._state >= $25e8dc8e65a43d49$export$a44e3b3c4a99043;
            }
        },
        {
            key: "ended",
            get: /**
      Gets whether the iterator has finished emitting items.
      @type boolean
      @readonly
    */ function get() {
                return this._state === $25e8dc8e65a43d49$export$9d38167254403955;
            }
        },
        {
            key: "destroyed",
            get: /**
      Gets whether the iterator has been destroyed.
      @type boolean
      @readonly
    */ function get() {
                return this._state === $25e8dc8e65a43d49$export$74e6752c3968d283;
            }
        },
        {
            key: "done",
            get: /**
      Gets whether the iterator will not emit anymore items,
      either due to being closed or due to being destroyed.
      @type boolean
      @readonly
    */ function get() {
                return this._state >= $25e8dc8e65a43d49$export$9d38167254403955;
            }
        },
        {
            /* Generates a textual representation of the iterator. */ key: "toString",
            value: function toString() {
                var details = this._toStringDetails();
                return "[".concat(this.constructor.name).concat(details ? " ".concat(details) : '', "]");
            }
        },
        {
            /**
      Generates details for a textual representation of the iterator.
      @protected
    */ key: "_toStringDetails",
            value: function _toStringDetails() {
                return '';
            }
        },
        {
            /**
      Consume all remaining items of the iterator into an array that will be returned asynchronously.
      @param {object} [options] Settings for array creation
      @param {integer} [options.limit] The maximum number of items to place in the array.
     */ key: "toArray",
            value: function toArray(options) {
                var _this = this;
                var items = [];
                var limit = typeof (options === null || options === void 0 ? void 0 : options.limit) === 'number' ? options.limit : Infinity;
                return this.ended || limit <= 0 ? Promise.resolve(items) : new Promise(function(resolve, reject) {
                    // Collect and return all items up to the limit
                    var resolveItems = function() {
                        return resolve(items);
                    };
                    var pushItem = function(item) {
                        items.push(item);
                        if (items.length >= limit) {
                            _this.removeListener('error', reject);
                            _this.removeListener('data', pushItem);
                            _this.removeListener('end', resolveItems);
                            resolve(items);
                        }
                    };
                    // Start item collection
                    _this.on('error', reject);
                    _this.on('data', pushItem);
                    _this.on('end', resolveItems);
                });
            }
        },
        {
            /**
      Retrieves the property with the given name from the iterator.
      If no callback is passed, it returns the value of the property
      or `undefined` if the property is not set.
      If a callback is passed, it returns `undefined`
      and calls the callback with the property the moment it is set.
      @param {string} propertyName The name of the property to retrieve
      @param {Function?} [callback] A one-argument callback to receive the property value
      @returns {object?} The value of the property (if set and no callback is given)
    */ key: "getProperty",
            value: function getProperty(propertyName, callback) {
                var properties = this._properties;
                // If no callback was passed, return the property value
                if (!callback) return properties && properties[propertyName];
                // If the value has been set, send it through the callback
                if (properties && propertyName in properties) $25e8dc8e65a43d49$var$taskScheduler(function() {
                    return callback(properties[propertyName]);
                });
                else {
                    var propertyCallbacks;
                    if (!(propertyCallbacks = this._propertyCallbacks)) this._propertyCallbacks = propertyCallbacks = Object.create(null);
                    if (propertyName in propertyCallbacks) propertyCallbacks[propertyName].push(callback);
                    else propertyCallbacks[propertyName] = [
                        callback
                    ];
                }
                return undefined;
            }
        },
        {
            /**
      Sets the property with the given name to the value.
      @param {string} propertyName The name of the property to set
      @param {object?} value The new value of the property
    */ key: "setProperty",
            value: function setProperty(propertyName, value) {
                var properties = this._properties || (this._properties = Object.create(null));
                properties[propertyName] = value;
                // Execute getter callbacks that were waiting for this property to be set
                var propertyCallbacks = this._propertyCallbacks || {};
                var callbacks = propertyCallbacks[propertyName];
                if (callbacks) {
                    delete propertyCallbacks[propertyName];
                    $25e8dc8e65a43d49$var$taskScheduler(function() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var callback = _step.value;
                                callback(value);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    });
                    // Remove _propertyCallbacks if no pending callbacks are left
                    for(propertyName in propertyCallbacks)return;
                    delete this._propertyCallbacks;
                }
            }
        },
        {
            /**
      Retrieves all properties of the iterator.
      @returns {object} An object with property names as keys.
    */ key: "getProperties",
            value: function getProperties() {
                var properties = this._properties;
                var copy = {};
                for(var name in properties)copy[name] = properties[name];
                return copy;
            }
        },
        {
            /**
      Sets all of the given properties.
      @param {object} properties Key/value pairs of properties to set
    */ key: "setProperties",
            value: function setProperties(properties) {
                for(var propertyName in properties)this.setProperty(propertyName, properties[propertyName]);
            }
        },
        {
            /**
      Copies the given properties from the source iterator.
      @param {module:asynciterator.AsyncIterator} source The iterator to copy from
      @param {Array} propertyNames List of property names to copy
    */ key: "copyProperties",
            value: function copyProperties(source, propertyNames) {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var propertyName = _step.value;
                        source.getProperty(propertyName, function(value) {
                            return _this.setProperty(propertyName, value);
                        });
                    };
                    for(var _iterator = propertyNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
      Transforms items from this iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {object|Function} [options] Settings of the iterator, or the transformation function
      @param {integer} [options.maxbufferSize=4] The maximum number of items to keep in the buffer
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
      @param {integer} [options.offset] The number of items to skip
      @param {integer} [options.limit] The maximum number of items
      @param {Function} [options.filter] A function to synchronously filter items from the source
      @param {Function} [options.map] A function to synchronously transform items from the source
      @param {Function} [options.transform] A function to asynchronously transform items from the source
      @param {boolean} [options.optional=false] If transforming is optional, the original item is pushed when its mapping yields `null` or its transformation yields no items
      @param {Array|module:asynciterator.AsyncIterator} [options.prepend] Items to insert before the source items
      @param {Array|module:asynciterator.AsyncIterator} [options.append]  Items to insert after the source items
      @returns {module:asynciterator.AsyncIterator} A new iterator that maps the items from this iterator
    */ key: "transform",
            value: function transform(options) {
                return new $25e8dc8e65a43d49$export$97134afd6ea6a7bc(this, options);
            }
        },
        {
            /**
      Maps items from this iterator using the given function.
      After this operation, only read the returned iterator instead of the current one.
      @param {Function} map A mapping function to call on this iterator's (remaining) items
      @param {object?} self The `this` pointer for the mapping function
      @returns {module:asynciterator.AsyncIterator} A new iterator that maps the items from this iterator
    */ key: "map",
            value: function map(_map, self) {
                return new $25e8dc8e65a43d49$export$a5143b4f5a44b8b4(this, $25e8dc8e65a43d49$var$bind(_map, self));
            }
        },
        {
            key: "filter",
            value: function filter(filter, self) {
                return this.map(function(item) {
                    return filter.call(self || this, item) ? item : null;
                });
            }
        },
        {
            /**
     * Returns a new iterator containing all of the unique items in the original iterator.
     * @param by - The derived value by which to determine uniqueness (e.g., stringification).
                   Defaults to the identity function.
     * @returns An iterator with duplicates filtered out.
     */ key: "uniq",
            value: function uniq() {
                var by = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $25e8dc8e65a43d49$export$f0954fd7d5368655;
                var uniques = new Set();
                return this.filter(function(item) {
                    var hashed = by.call(this, item);
                    if (!uniques.has(hashed)) {
                        uniques.add(hashed);
                        return true;
                    }
                    return false;
                });
            }
        },
        {
            /**
      Prepends the items after those of the current iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} items Items to insert before this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that prepends items to this iterator
    */ key: "prepend",
            value: function prepend(items) {
                return this.transform({
                    prepend: items
                });
            }
        },
        {
            /**
      Appends the items after those of the current iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} items Items to insert after this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that appends items to this iterator
    */ key: "append",
            value: function append(items) {
                return this.transform({
                    append: items
                });
            }
        },
        {
            /**
      Surrounds items of the current iterator with the given items.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} prepend Items to insert before this iterator's (remaining) items
      @param {Array|module:asynciterator.AsyncIterator} append Items to insert after this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that appends and prepends items to this iterator
    */ key: "surround",
            value: function surround(prepend, append) {
                return this.transform({
                    prepend: prepend,
                    append: append
                });
            }
        },
        {
            /**
      Skips the given number of items from the current iterator.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} offset The number of items to skip
      @returns {module:asynciterator.AsyncIterator} A new iterator that skips the given number of items
    */ key: "skip",
            value: function skip(offset) {
                return this.map(function(item) {
                    return offset-- > 0 ? null : item;
                });
            }
        },
        {
            /**
      Limits the current iterator to the given number of items.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} limit The maximum number of items
      @returns {module:asynciterator.AsyncIterator} A new iterator with at most the given number of items
    */ key: "take",
            value: function take(limit) {
                return this.transform({
                    limit: limit
                });
            }
        },
        {
            /**
      Limits the current iterator to the given range.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} start Index of the first item to return
      @param {integer} end Index of the last item to return
      @returns {module:asynciterator.AsyncIterator} A new iterator with items in the given range
    */ key: "range",
            value: function range(start, end) {
                return this.transform({
                    offset: start,
                    limit: Math.max(end - start + 1, 0)
                });
            }
        },
        {
            /**
      Creates a copy of the current iterator,
      containing all items emitted from this point onward.
      Further copies can be created; they will all start from this same point.
      After this operation, only read the returned copies instead of the original iterator.
      @returns {module:asynciterator.AsyncIterator} A new iterator that contains all future items of this iterator
    */ key: "clone",
            value: function clone() {
                return new $25e8dc8e65a43d49$export$dbe2e03f1d64d8a2(this);
            }
        },
        {
            /**
     * An AsyncIterator is async iterable.
     * This allows iterators to be used via the for-await syntax.
     *
     * In cases where the returned EcmaScript AsyncIterator will not be fully consumed,
     * it is recommended to manually listen for error events on the main AsyncIterator
     * to avoid uncaught error messages.
     *
     * @returns {ESAsyncIterator<T>} An EcmaScript AsyncIterator
     */ key: Symbol.asyncIterator,
            value: function value() {
                var it = this;
                var currentResolve = null;
                var currentReject = null;
                var pendingError = null;
                it.addListener('readable', tryResolve);
                it.addListener('end', tryResolve);
                it.addListener('error', tryReject);
                // Tries to emit an item or signal the end of the iterator
                function tryResolve() {
                    if (currentResolve !== null) {
                        if (pendingError !== null) tryReject(pendingError);
                        else if (it.done) {
                            currentResolve({
                                done: true,
                                value: undefined
                            });
                            currentResolve = currentReject = null;
                            removeListeners();
                        } else {
                            var value = it.read();
                            if (value !== null) {
                                currentResolve({
                                    done: false,
                                    value: value
                                });
                                currentResolve = currentReject = null;
                            }
                        }
                    }
                }
                // Tries to emit an error
                function tryReject(error) {
                    if (currentReject !== null) {
                        currentReject(error);
                        currentResolve = currentReject = pendingError = null;
                        removeListeners();
                    } else if (pendingError === null) pendingError = error;
                }
                // Cleans up all attached listeners
                function removeListeners() {
                    it.removeListener('readable', tryResolve);
                    it.removeListener('end', tryResolve);
                    it.removeListener('error', tryReject);
                }
                // An EcmaScript AsyncIterator exposes the next() function that can be invoked repeatedly
                return {
                    next: function() {
                        return new Promise(function(resolve, reject) {
                            currentResolve = resolve;
                            currentReject = reject;
                            tryResolve();
                        });
                    }
                };
            }
        }
    ]);
    return AsyncIterator;
}((0, $bBoAO.EventEmitter));
// Starts emitting `data` events when `data` listeners are added
function $25e8dc8e65a43d49$var$waitForDataListener(eventName) {
    var _this = this;
    if (eventName === 'data') {
        this.removeListener('newListener', $25e8dc8e65a43d49$var$waitForDataListener);
        $25e8dc8e65a43d49$var$addSingleListener(this, 'readable', $25e8dc8e65a43d49$var$emitData);
        if (this.readable) $25e8dc8e65a43d49$var$taskScheduler(function() {
            return $25e8dc8e65a43d49$var$emitData.call(_this);
        });
    }
}
// Emits new items though `data` events as long as there are `data` listeners
function $25e8dc8e65a43d49$var$emitData() {
    // While there are `data` listeners and items, emit them
    var item;
    while(this.listenerCount('data') !== 0 && (item = this.read()) !== null)this.emit('data', item);
    // Stop draining the source if there are no more `data` listeners
    if (this.listenerCount('data') === 0 && !this.done) {
        this.removeListener('readable', $25e8dc8e65a43d49$var$emitData);
        $25e8dc8e65a43d49$var$addSingleListener(this, 'newListener', $25e8dc8e65a43d49$var$waitForDataListener);
    }
}
// Adds the listener to the event, if it has not been added previously.
function $25e8dc8e65a43d49$var$addSingleListener(source, eventName, listener) {
    if (!source.listeners(eventName).includes(listener)) source.on(eventName, listener);
}
var $25e8dc8e65a43d49$export$80fed2b3fb5591aa = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(EmptyIterator, AsyncIterator);
    function EmptyIterator() {
        (0, $jGAMp._)(this, EmptyIterator);
        var _this;
        _this = (0, $kzDuW._)(this, EmptyIterator);
        _this._changeState($25e8dc8e65a43d49$export$9d38167254403955, true);
        return _this;
    }
    return EmptyIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
var $25e8dc8e65a43d49$export$429f276659ec1f = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(SingletonIterator, AsyncIterator);
    function SingletonIterator(item) {
        (0, $jGAMp._)(this, SingletonIterator);
        var _this;
        _this = (0, $kzDuW._)(this, SingletonIterator);
        _this._item = item;
        if (item === null) _this.close();
        else _this.readable = true;
        return _this;
    }
    (0, $byiyg._)(SingletonIterator, [
        {
            /* Reads the item from the iterator. */ key: "read",
            value: function read() {
                var item = this._item;
                this._item = null;
                this.close();
                return item;
            }
        },
        {
            /* Generates details for a textual representation of the iterator. */ key: "_toStringDetails",
            value: function _toStringDetails() {
                return this._item === null ? '' : "(".concat(this._item, ")");
            }
        }
    ]);
    return SingletonIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
var $25e8dc8e65a43d49$export$9174e9fcc7d3059 = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(ArrayIterator, AsyncIterator);
    function ArrayIterator() {
        var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_autoStart = _ref.autoStart, autoStart = _ref_autoStart === void 0 ? true : _ref_autoStart, _ref_preserve = _ref.preserve, preserve = _ref_preserve === void 0 ? true : _ref_preserve;
        (0, $jGAMp._)(this, ArrayIterator);
        var _this;
        _this = (0, $kzDuW._)(this, ArrayIterator);
        var buffer = preserve || !Array.isArray(items) ? (0, $7WNf6._)(items) : items;
        _this._index = 0;
        _this._sourceStarted = autoStart !== false;
        _this._truncateThreshold = preserve ? -1 : 64;
        if (_this._sourceStarted && buffer.length === 0) _this.close();
        else _this._buffer = buffer;
        _this.readable = true;
        return _this;
    }
    (0, $byiyg._)(ArrayIterator, [
        {
            /* Reads an item from the iterator. */ key: "read",
            value: function read() {
                if (!this._sourceStarted) this._sourceStarted = true;
                var item = null;
                if (this._buffer) {
                    // Emit the current item
                    if (this._index < this._buffer.length) item = this._buffer[this._index++];
                    // Close when all elements have been returned
                    if (this._index === this._buffer.length) {
                        delete this._buffer;
                        this.close();
                    } else if (this._index === this._truncateThreshold) {
                        this._buffer.splice(0, this._truncateThreshold);
                        this._index = 0;
                    }
                }
                return item;
            }
        },
        {
            /* Generates details for a textual representation of the iterator. */ key: "_toStringDetails",
            value: function _toStringDetails() {
                return "(".concat(this._buffer ? this._buffer.length - this._index : 0, ")");
            }
        },
        {
            /* Called by {@link module:asynciterator.AsyncIterator#destroy} */ key: "_destroy",
            value: function _destroy(cause, callback) {
                delete this._buffer;
                callback();
            }
        },
        {
            /**
     Consume all remaining items of the iterator into an array that will be returned asynchronously.
     @param {object} [options] Settings for array creation
     @param {integer} [options.limit] The maximum number of items to place in the array.
     */ key: "toArray",
            value: function toArray() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (!this._buffer) return Promise.resolve([]);
                // Determine start and end index
                var length = this._buffer.length;
                var start = this._index;
                var end = typeof options.limit !== 'number' ? length : start + options.limit;
                // Slice the items off the buffer
                var items = this._buffer.slice(start, end);
                this._index = end;
                // Close this iterator when we're past the end
                if (end >= length) this.close();
                return Promise.resolve(items);
            }
        }
    ]);
    return ArrayIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
var $25e8dc8e65a43d49$export$ebc81b2f9859754a = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(IntegerIterator, AsyncIterator);
    function IntegerIterator() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_start = _ref.start, start = _ref_start === void 0 ? 0 : _ref_start, _ref_step = _ref.step, step = _ref_step === void 0 ? 1 : _ref_step, end = _ref.end;
        (0, $jGAMp._)(this, IntegerIterator);
        var _this;
        _this = (0, $kzDuW._)(this, IntegerIterator);
        // Determine the first number
        if (Number.isFinite(start)) start = Math.trunc(start);
        _this._next = start;
        // Determine step size
        if (Number.isFinite(step)) step = Math.trunc(step);
        _this._step = step;
        // Determine the last number
        var ascending = step >= 0;
        var direction = ascending ? Infinity : -Infinity;
        if (Number.isFinite(end)) end = Math.trunc(end);
        else if (end !== -direction) end = direction;
        _this._last = end;
        // Start iteration if there is at least one item; close otherwise
        if (!Number.isFinite(start) || (ascending ? start > end : start < end)) _this.close();
        else _this.readable = true;
        return _this;
    }
    (0, $byiyg._)(IntegerIterator, [
        {
            /* Reads an item from the iterator. */ key: "read",
            value: function read() {
                if (this.closed) return null;
                var current = this._next, step = this._step, last = this._last, next = this._next += step;
                if (step >= 0 ? next > last : next < last) this.close();
                return current;
            }
        },
        {
            /* Generates details for a textual representation of the iterator. */ key: "_toStringDetails",
            value: function _toStringDetails() {
                return "(".concat(this._next, "...").concat(this._last, ")");
            }
        }
    ]);
    return IntegerIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
function $25e8dc8e65a43d49$export$f0954fd7d5368655(item) {
    return item;
}
var $25e8dc8e65a43d49$export$b74110983b07cd2e = Symbol('destination');
var $25e8dc8e65a43d49$export$a5143b4f5a44b8b4 = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(MappingIterator, AsyncIterator);
    function MappingIterator(source) {
        var map = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $25e8dc8e65a43d49$export$f0954fd7d5368655, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $jGAMp._)(this, MappingIterator);
        var _this;
        _this = (0, $kzDuW._)(this, MappingIterator);
        _this._map = map;
        _this._source = $25e8dc8e65a43d49$var$ensureSourceAvailable(source);
        _this._destroySource = options.destroySource !== false;
        // Close if the source is already empty
        if (source.done) _this.close();
        else {
            _this._source[$25e8dc8e65a43d49$export$b74110983b07cd2e] = _this;
            _this._source.on('end', $25e8dc8e65a43d49$var$destinationClose);
            _this._source.on('error', $25e8dc8e65a43d49$var$destinationEmitError);
            _this._source.on('readable', $25e8dc8e65a43d49$var$destinationSetReadable);
            _this.readable = _this._source.readable;
        }
        return _this;
    }
    (0, $byiyg._)(MappingIterator, [
        {
            /* Tries to read the next item from the iterator. */ key: "read",
            value: function read() {
                if (!this.done) {
                    // Try to read an item that maps to a non-null value
                    if (this._source.readable) {
                        var item, mapped;
                        while((item = this._source.read()) !== null){
                            if ((mapped = this._map(item)) !== null) return mapped;
                        }
                    }
                    this.readable = false;
                    // Close this iterator if the source is empty
                    if (this._source.done) this.close();
                }
                return null;
            }
        },
        {
            /* Cleans up the source iterator and ends. */ key: "_end",
            value: function _end(destroy) {
                this._source.removeListener('end', $25e8dc8e65a43d49$var$destinationClose);
                this._source.removeListener('error', $25e8dc8e65a43d49$var$destinationEmitError);
                this._source.removeListener('readable', $25e8dc8e65a43d49$var$destinationSetReadable);
                delete this._source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                if (this._destroySource) this._source.destroy();
                (0, $fXhL4._)((0, $hxFDX._)(MappingIterator.prototype), "_end", this).call(this, destroy);
            }
        }
    ]);
    return MappingIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
// Validates an AsyncIterator for use as a source within another AsyncIterator
function $25e8dc8e65a43d49$var$ensureSourceAvailable(source) {
    var allowDestination = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!source || !$25e8dc8e65a43d49$export$f6e2535fb5126e54(source.read) || !$25e8dc8e65a43d49$export$f6e2535fb5126e54(source.on)) throw new TypeError("Invalid source: ".concat(source));
    if (!allowDestination && source[$25e8dc8e65a43d49$export$b74110983b07cd2e]) throw new Error('The source already has a destination');
    return source;
}
var $25e8dc8e65a43d49$export$654d6042b7ea281f = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(BufferedIterator, AsyncIterator);
    function BufferedIterator() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_maxBufferSize = _ref.maxBufferSize, maxBufferSize = _ref_maxBufferSize === void 0 ? 4 : _ref_maxBufferSize, _ref_autoStart = _ref.autoStart, autoStart = _ref_autoStart === void 0 ? true : _ref_autoStart;
        (0, $jGAMp._)(this, BufferedIterator);
        var _this;
        _this = (0, $kzDuW._)(this, BufferedIterator, [
            $25e8dc8e65a43d49$export$d788bc089976c004
        ]);
        _this._buffer = new (0, $iIrt4.LinkedList)();
        _this._maxBufferSize = 4;
        _this._reading = true;
        _this._pushedCount = 0;
        _this.maxBufferSize = maxBufferSize;
        $25e8dc8e65a43d49$var$taskScheduler(function() {
            return _this._init(autoStart);
        });
        _this._sourceStarted = autoStart !== false;
        return _this;
    }
    (0, $byiyg._)(BufferedIterator, [
        {
            key: "maxBufferSize",
            get: /**
      The maximum number of items to preload in the internal buffer.
      A `BufferedIterator` tries to fill its buffer as far as possible.
      Set to `Infinity` to fully drain the source.
      @type number
    */ function get() {
                return this._maxBufferSize;
            },
            set: function set(maxBufferSize) {
                // Allow only positive integers and infinity
                if (maxBufferSize !== Infinity) maxBufferSize = !Number.isFinite(maxBufferSize) ? 4 : Math.max(Math.trunc(maxBufferSize), 1);
                // Only set the maximum buffer size if it changes
                if (this._maxBufferSize !== maxBufferSize) {
                    this._maxBufferSize = maxBufferSize;
                    // Ensure sufficient elements are buffered
                    if (this._state === $25e8dc8e65a43d49$export$bb29a81b503a982c) this._fillBuffer();
                }
            }
        },
        {
            /**
      Initializing the iterator by calling {@link BufferedIterator#_begin}
      and changing state from INIT to OPEN.
      @protected
      @param {boolean} autoStart Whether reading of items should immediately start after OPEN.
    */ key: "_init",
            value: function _init(autoStart) {
                var _this = this;
                // Perform initialization tasks
                var doneCalled = false;
                this._reading = true;
                this._begin(function() {
                    if (doneCalled) throw new Error('done callback called multiple times');
                    doneCalled = true;
                    // Open the iterator and start buffering
                    _this._reading = false;
                    _this._changeState($25e8dc8e65a43d49$export$bb29a81b503a982c);
                    if (autoStart) _this._fillBufferAsync();
                    else _this.readable = true;
                });
            }
        },
        {
            /**
      Writes beginning items and opens iterator resources.
      Should never be called before {@link BufferedIterator#_init};
      typically, `_init` is responsible for calling `_begin`.
      @protected
      @param {function} done To be called when initialization is complete
    */ key: "_begin",
            value: function _begin(done) {
                done();
            }
        },
        {
            /**
      Tries to read the next item from the iterator.
      If the buffer is empty,
      this method calls {@link BufferedIterator#_read} to fetch items.
      @returns {object?} The next item, or `null` if none is available
    */ key: "read",
            value: function read() {
                if (this.done) return null;
                // An explicit read kickstarts the source
                if (!this._sourceStarted) this._sourceStarted = true;
                // Try to retrieve an item from the buffer
                var buffer = this._buffer;
                var item;
                if (buffer.empty) {
                    item = null;
                    this.readable = false;
                } else item = buffer.shift();
                // If the buffer is becoming empty, either fill it or end the iterator
                if (!this._reading && buffer.length < this._maxBufferSize) {
                    // If the iterator is not closed and thus may still generate new items, fill the buffer
                    if (!this.closed) this._fillBufferAsync();
                    else if (buffer.empty) this._endAsync();
                }
                return item;
            }
        },
        {
            /**
      Tries to generate the given number of items.
      Implementers should add `count` items through {@link BufferedIterator#_push}.
      @protected
      @param {integer} count The number of items to generate
      @param {function} done To be called when reading is complete
    */ key: "_read",
            value: function _read(count, done) {
                done();
            }
        },
        {
            /**
      Adds an item to the internal buffer.
      @protected
      @param {object} item The item to add
      @emits module:asynciterator.AsyncIterator.readable
    */ key: "_push",
            value: function _push(item) {
                if (!this.done) {
                    this._pushedCount++;
                    this._buffer.push(item);
                    this.readable = true;
                }
            }
        },
        {
            /**
      Fills the internal buffer until `this._maxBufferSize` items are present.
      This method calls {@link BufferedIterator#_read} to fetch items.
      @protected
      @emits module:asynciterator.AsyncIterator.readable
    */ key: "_fillBuffer",
            value: function _fillBuffer() {
                var _this = this;
                var neededItems;
                // Avoid recursive reads
                if (this._reading) ;
                else if (this.closed) this._completeClose();
                else if ((neededItems = Math.min(this._maxBufferSize - this._buffer.length, 128)) > 0) {
                    // Acquire reading lock and start reading, counting pushed items
                    this._pushedCount = 0;
                    this._reading = true;
                    this._read(neededItems, function() {
                        // Verify the callback is only called once
                        if (!neededItems) throw new Error('done callback called multiple times');
                        neededItems = 0;
                        // Release reading lock
                        _this._reading = false;
                        // If the iterator was closed while reading, complete closing
                        if (_this.closed) _this._completeClose();
                        else if (_this._pushedCount) {
                            _this.readable = true;
                            // If the buffer is insufficiently full, continue filling
                            if (_this._buffer.length < _this._maxBufferSize / 2) _this._fillBufferAsync();
                        }
                    });
                }
            }
        },
        {
            /**
      Schedules `_fillBuffer` asynchronously.
    */ key: "_fillBufferAsync",
            value: function _fillBufferAsync() {
                var _this = this;
                // Acquire reading lock to avoid recursive reads
                if (!this._reading) {
                    this._reading = true;
                    $25e8dc8e65a43d49$var$taskScheduler(function() {
                        // Release reading lock so _fillBuffer` can take it
                        _this._reading = false;
                        _this._fillBuffer();
                    });
                }
            }
        },
        {
            /**
      Stops the iterator from generating new items
      after a possible pending read operation has finished.
      Already generated, pending, or terminating items can still be emitted.
      After this, the iterator will end asynchronously.
      @emits module:asynciterator.AsyncIterator.end
    */ key: "close",
            value: function close() {
                // If the iterator is not currently reading, we can close immediately
                if (!this._reading) this._completeClose();
                else this._changeState($25e8dc8e65a43d49$export$a44e3b3c4a99043);
            }
        },
        {
            /**
      Stops the iterator from generating new items,
      switching from `CLOSING` state into `CLOSED` state.
      @protected
      @emits module:asynciterator.AsyncIterator.end
    */ key: "_completeClose",
            value: function _completeClose() {
                var _this = this;
                if (this._changeState($25e8dc8e65a43d49$export$19c4f83398a8dbce)) {
                    // Write possible terminating items
                    this._reading = true;
                    this._flush(function() {
                        if (!_this._reading) throw new Error('done callback called multiple times');
                        _this._reading = false;
                        // If no items are left, end the iterator
                        // Otherwise, `read` becomes responsible for ending the iterator
                        if (_this._buffer.empty) _this._endAsync();
                    });
                }
            }
        },
        {
            /* Called by {@link module:asynciterator.AsyncIterator#destroy} */ key: "_destroy",
            value: function _destroy(cause, callback) {
                this._buffer.clear();
                callback();
            }
        },
        {
            /**
      Writes terminating items and closes iterator resources.
      Should never be called before {@link BufferedIterator#close};
      typically, `close` is responsible for calling `_flush`.
      @protected
      @param {function} done To be called when termination is complete
    */ key: "_flush",
            value: function _flush(done) {
                done();
            }
        },
        {
            /**
      Generates details for a textual representation of the iterator.
      @protected
     */ key: "_toStringDetails",
            value: function _toStringDetails() {
                var buffer = this._buffer;
                return "{".concat(buffer.empty ? '' : "next: ".concat(buffer.first, ", "), "buffer: ").concat(buffer.length, "}");
            }
        }
    ]);
    return BufferedIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
var $25e8dc8e65a43d49$export$524b9ce0a1396fb8 = /*#__PURE__*/ function(BufferedIterator) {
    "use strict";
    (0, $i3fW3._)(TransformIterator, BufferedIterator);
    function TransformIterator(source) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : source || {};
        (0, $jGAMp._)(this, TransformIterator);
        var _this;
        _this = (0, $kzDuW._)(this, TransformIterator, [
            options
        ]);
        _this._boundPush = function(item) {
            return _this._push(item);
        };
        // Shift parameters if needed
        if (!$25e8dc8e65a43d49$export$7d4a29d60ae655ec(source)) source = options.source;
        // The passed source is an AsyncIterator or readable stream
        if ($25e8dc8e65a43d49$export$ad59ba2f4c892638(source)) _this.source = source;
        else if (source) {
            _this._createSource = $25e8dc8e65a43d49$export$4369c812aac99591(source) ? function() {
                return source;
            } : source;
            if (_this._sourceStarted) _this._loadSourceAsync();
        }
        // Set other options
        _this._optional = Boolean(options.optional);
        _this._destroySource = options.destroySource !== false;
        return _this;
    }
    (0, $byiyg._)(TransformIterator, [
        {
            key: "source",
            get: /**
      The source this iterator generates items from.
      @type module:asynciterator.AsyncIterator
    */ function get() {
                if ($25e8dc8e65a43d49$export$f6e2535fb5126e54(this._createSource)) this._loadSourceAsync();
                return this._source;
            },
            set: function set(value) {
                // Validate and set source
                var source = this._source = this._validateSource(value);
                source[$25e8dc8e65a43d49$export$b74110983b07cd2e] = this;
                // Do not read the source if this iterator already ended
                if (this.done) {
                    if (this._destroySource) source.destroy();
                } else if (source.done) this.close();
                else {
                    source.on('end', $25e8dc8e65a43d49$var$destinationCloseWhenDone);
                    source.on('readable', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    source.on('error', $25e8dc8e65a43d49$var$destinationEmitError);
                }
            }
        },
        {
            /**
      Initializes a source that was set through a promise
      @protected
    */ key: "_loadSourceAsync",
            value: function _loadSourceAsync() {
                var _this = this;
                if ($25e8dc8e65a43d49$export$f6e2535fb5126e54(this._createSource)) {
                    // Assign the source after resolving
                    Promise.resolve(this._createSource()).then(function(source) {
                        delete _this._createSource;
                        _this.source = source;
                        _this._fillBuffer();
                    }, function(error) {
                        return _this.emit('error', error);
                    });
                    // Signal that source creation is pending
                    this._createSource = null;
                }
            }
        },
        {
            /**
      Validates whether the given iterator can be used as a source.
      @protected
      @param {object} source The source to validate
      @param {boolean} allowDestination Whether the source can already have a destination
    */ key: "_validateSource",
            value: function _validateSource(source) {
                var allowDestination = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (this._source || typeof this._createSource !== 'undefined') throw new Error('The source cannot be changed after it has been set');
                return $25e8dc8e65a43d49$var$ensureSourceAvailable(source, allowDestination);
            }
        },
        {
            /**
      Tries to read transformed items.
    */ key: "_read",
            value: function _read(count, done) {
                var _this = this;
                var next = function() {
                    // Continue transforming until at least `count` items have been pushed
                    if (_this._pushedCount < count && !_this.closed) $25e8dc8e65a43d49$var$taskScheduler(function() {
                        return _this._readAndTransform(next, done);
                    });
                    else done();
                };
                this._readAndTransform(next, done);
            }
        },
        {
            /**
      Reads a transforms an item
    */ key: "_readAndTransform",
            value: function _readAndTransform(next, done) {
                // If the source exists and still can read items,
                // try to read and transform the next item.
                var item;
                var source = this.source;
                if (!source || source.done || (item = source.read()) === null) done();
                else if (!this._optional) this._transform(item, next, this._boundPush);
                else this._optionalTransform(item, next);
            }
        },
        {
            /**
      Tries to transform the item;
      if the transformation yields no items, pushes the original item.
    */ key: "_optionalTransform",
            value: function _optionalTransform(item, done) {
                var _this = this;
                var pushedCount = this._pushedCount;
                this._transform(item, function() {
                    if (pushedCount === _this._pushedCount) _this._push(item);
                    done();
                }, this._boundPush);
            }
        },
        {
            /**
      Generates items based on the item from the source.
      Implementers should add items through {@link BufferedIterator#_push}.
      The default implementation pushes the source item as-is.
      @protected
      @param {object} item The last read item from the source
      @param {function} done To be called when reading is complete
      @param {function} push A callback to push zero or more transformation results.
    */ key: "_transform",
            value: function _transform(item, done, push) {
                push(item);
                done();
            }
        },
        {
            /**
      Closes the iterator when pending items are transformed.
      @protected
    */ key: "_closeWhenDone",
            value: function _closeWhenDone() {
                this.close();
            }
        },
        {
            /* Cleans up the source iterator and ends. */ key: "_end",
            value: function _end(destroy) {
                var source = this._source;
                if (source) {
                    source.removeListener('end', $25e8dc8e65a43d49$var$destinationCloseWhenDone);
                    source.removeListener('error', $25e8dc8e65a43d49$var$destinationEmitError);
                    source.removeListener('readable', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    delete source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                    if (this._destroySource) source.destroy();
                }
                (0, $fXhL4._)((0, $hxFDX._)(TransformIterator.prototype), "_end", this).call(this, destroy);
            }
        }
    ]);
    return TransformIterator;
}($25e8dc8e65a43d49$export$654d6042b7ea281f);
function $25e8dc8e65a43d49$var$destinationSetReadable() {
    this[$25e8dc8e65a43d49$export$b74110983b07cd2e].readable = true;
}
function $25e8dc8e65a43d49$var$destinationEmitError(error) {
    this[$25e8dc8e65a43d49$export$b74110983b07cd2e].emit('error', error);
}
function $25e8dc8e65a43d49$var$destinationClose() {
    this[$25e8dc8e65a43d49$export$b74110983b07cd2e].close();
}
function $25e8dc8e65a43d49$var$destinationCloseWhenDone() {
    this[$25e8dc8e65a43d49$export$b74110983b07cd2e]._closeWhenDone();
}
function $25e8dc8e65a43d49$var$destinationFillBuffer() {
    if (this[$25e8dc8e65a43d49$export$b74110983b07cd2e]._sourceStarted !== false) this[$25e8dc8e65a43d49$export$b74110983b07cd2e]._fillBuffer();
}
var $25e8dc8e65a43d49$export$97134afd6ea6a7bc = /*#__PURE__*/ function(TransformIterator) {
    "use strict";
    (0, $i3fW3._)(SimpleTransformIterator, TransformIterator);
    function SimpleTransformIterator(source, options) {
        (0, $jGAMp._)(this, SimpleTransformIterator);
        var _this;
        _this = (0, $kzDuW._)(this, SimpleTransformIterator, [
            source,
            options
        ]);
        _this._offset = 0;
        _this._limit = Infinity;
        _this._filter = function(item) {
            return true;
        };
        // Set transformation steps from the options
        options = options || (!$25e8dc8e65a43d49$export$7d4a29d60ae655ec(source) ? source : null);
        if (options) {
            var transform = $25e8dc8e65a43d49$export$f6e2535fb5126e54(options) ? options : options.transform;
            var limit = options.limit, offset = options.offset, filter = options.filter, map = options.map, prepend = options.prepend, append = options.append;
            // Don't emit any items when bounds are unreachable
            if (offset === Infinity || limit === -Infinity) _this._limit = 0;
            else {
                if (Number.isFinite(offset)) _this._offset = Math.max(Math.trunc(offset), 0);
                if (Number.isFinite(limit)) _this._limit = Math.max(Math.trunc(limit), 0);
                if ($25e8dc8e65a43d49$export$f6e2535fb5126e54(filter)) _this._filter = filter;
                if ($25e8dc8e65a43d49$export$f6e2535fb5126e54(map)) _this._map = map;
                _this._transform = $25e8dc8e65a43d49$export$f6e2535fb5126e54(transform) ? transform : null;
            }
            if (prepend) _this._prepender = $25e8dc8e65a43d49$export$ad59ba2f4c892638(prepend) ? prepend : $25e8dc8e65a43d49$export$571d59b505e6bb4e(prepend);
            if (append) _this._appender = $25e8dc8e65a43d49$export$ad59ba2f4c892638(append) ? append : $25e8dc8e65a43d49$export$571d59b505e6bb4e(append);
        }
        return _this;
    }
    (0, $byiyg._)(SimpleTransformIterator, [
        {
            /* Tries to read and transform items */ key: "_read",
            value: function _read(count, done) {
                var _this = this;
                var next = function() {
                    return _this._readAndTransformSimple(count, nextAsync, done);
                };
                this._readAndTransformSimple(count, nextAsync, done);
                function nextAsync() {
                    $25e8dc8e65a43d49$var$taskScheduler(next);
                }
            }
        },
        {
            /* Reads and transform items */ key: "_readAndTransformSimple",
            value: function _readAndTransformSimple(count, next, done) {
                // Verify we have a readable source
                var item;
                var source = this.source;
                if (!source || source.done) {
                    done();
                    return;
                }
                // Verify we are still below the limit
                if (this._limit === 0) this.close();
                // Try to read the next item until at least `count` items have been pushed
                while(!this.closed && this._pushedCount < count && (item = source.read()) !== null){
                    // Verify the item passes the filter and we've reached the offset
                    if (!this._filter(item) || this._offset !== 0 && this._offset--) continue;
                    // Synchronously map the item
                    var mappedItem = typeof this._map === 'undefined' ? item : this._map(item);
                    // Skip `null` items, pushing the original item if the mapping was optional
                    if (mappedItem === null) {
                        if (this._optional) this._push(item);
                    } else if (!$25e8dc8e65a43d49$export$f6e2535fb5126e54(this._transform)) this._push(mappedItem);
                    else {
                        if (!this._optional) this._transform(mappedItem, next, this._boundPush);
                        else this._optionalTransform(mappedItem, next);
                        return;
                    }
                    // Stop when we've reached the limit
                    if (--this._limit === 0) this.close();
                }
                done();
            }
        },
        {
            // Prepends items to the iterator
            key: "_begin",
            value: function _begin(done) {
                this._insert(this._prepender, done);
                delete this._prepender;
            }
        },
        {
            // Appends items to the iterator
            key: "_flush",
            value: function _flush(done) {
                this._insert(this._appender, done);
                delete this._appender;
            }
        },
        {
            // Inserts items in the iterator
            key: "_insert",
            value: function _insert(inserter, done) {
                var _this = this;
                var push = function(item) {
                    return _this._push(item);
                };
                if (!inserter || inserter.done) done();
                else {
                    inserter.on('data', push);
                    inserter.on('end', end);
                }
                function end() {
                    inserter.removeListener('data', push);
                    inserter.removeListener('end', end);
                    done();
                }
            }
        }
    ]);
    return SimpleTransformIterator;
}($25e8dc8e65a43d49$export$524b9ce0a1396fb8);
var $25e8dc8e65a43d49$export$4866f110077c3a09 = /*#__PURE__*/ function(TransformIterator) {
    "use strict";
    (0, $i3fW3._)(MultiTransformIterator, TransformIterator);
    function MultiTransformIterator(source, options) {
        (0, $jGAMp._)(this, MultiTransformIterator);
        var _this;
        _this = (0, $kzDuW._)(this, MultiTransformIterator, [
            source,
            options
        ]);
        _this._transformerQueue = [];
        // Set transformation steps from the options
        if (options) {
            var multiTransform = $25e8dc8e65a43d49$export$f6e2535fb5126e54(options) ? options : options.multiTransform;
            if (multiTransform) _this._createTransformer = multiTransform;
        }
        return _this;
    }
    (0, $byiyg._)(MultiTransformIterator, [
        {
            /* Tries to read and transform items */ key: "_read",
            value: function _read(count, done) {
                // Remove transformers that have ended
                var transformerQueue = this._transformerQueue, optional = this._optional;
                var head, item;
                while((head = transformerQueue[0]) && head.transformer.done){
                    // If transforming is optional, push the original item if none was pushed
                    if (optional && head.item !== null) {
                        count--;
                        this._push(head.item);
                    }
                    // Remove listeners from the transformer
                    transformerQueue.shift();
                    var transformer = head.transformer;
                    transformer.removeListener('end', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    transformer.removeListener('readable', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    transformer.removeListener('error', $25e8dc8e65a43d49$var$destinationEmitError);
                }
                // Create new transformers if there are less than the maximum buffer size
                var source = this.source;
                while(source && !source.done && transformerQueue.length < this.maxBufferSize){
                    // Read an item to create the next transformer
                    item = source.read();
                    if (item === null) break;
                    // Create the transformer and listen to its events
                    var transformer1 = this._createTransformer(item) || new $25e8dc8e65a43d49$export$80fed2b3fb5591aa();
                    transformer1[$25e8dc8e65a43d49$export$b74110983b07cd2e] = this;
                    transformer1.on('end', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    transformer1.on('readable', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    transformer1.on('error', $25e8dc8e65a43d49$var$destinationEmitError);
                    transformerQueue.push({
                        transformer: transformer1,
                        item: item
                    });
                }
                // Try to read `count` items from the transformer
                head = transformerQueue[0];
                if (head) {
                    var transformer2 = head.transformer;
                    while(count-- > 0 && (item = transformer2.read()) !== null){
                        this._push(item);
                        // If a transformed item was pushed, no need to push the original anymore
                        if (optional) head.item = null;
                    }
                } else if (source && source.done) this.close();
                done();
            }
        },
        {
            /**
      Creates a transformer for the given item.
      @param {object} item The last read item from the source
      @returns {module:asynciterator.AsyncIterator} An iterator that transforms the given item
    */ key: "_createTransformer",
            value: function _createTransformer(item) {
                return new $25e8dc8e65a43d49$export$429f276659ec1f(item);
            }
        },
        {
            /* Closes the iterator when pending items are transformed. */ key: "_closeWhenDone",
            value: function _closeWhenDone() {
                // Only close if all transformers are read
                if (!this._transformerQueue.length) this.close();
            }
        },
        {
            key: "_end",
            value: function _end(destroy) {
                (0, $fXhL4._)((0, $hxFDX._)(MultiTransformIterator.prototype), "_end", this).call(this, destroy);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // Also destroy the open transformers left in the queue
                if (this._destroySource) try {
                    for(var _iterator = this._transformerQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        item.transformer.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return MultiTransformIterator;
}($25e8dc8e65a43d49$export$524b9ce0a1396fb8);
var $25e8dc8e65a43d49$export$a9dbacdfc5e6386c = /*#__PURE__*/ function(BufferedIterator) {
    "use strict";
    (0, $i3fW3._)(UnionIterator, BufferedIterator);
    function UnionIterator(sources) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, UnionIterator);
        var _this;
        _this = (0, $kzDuW._)(this, UnionIterator, [
            options
        ]);
        _this._sources = [];
        _this._currentSource = -1;
        var autoStart = options.autoStart !== false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // Sources have been passed as an iterator
        if ($25e8dc8e65a43d49$export$ad59ba2f4c892638(sources)) {
            sources.on('error', function(error) {
                return _this.emit('error', error);
            });
            _this._pending = {
                loading: false,
                sources: sources
            };
            if (autoStart) _this._loadSources();
        } else if (Array.isArray(sources) && sources.length > 0) try {
            for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var source = _step.value;
                _this._addSource(source);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else if (autoStart) _this.close();
        // Set other options
        _this._destroySources = options.destroySources !== false;
        return _this;
    }
    (0, $byiyg._)(UnionIterator, [
        {
            // Loads pending sources into the sources list
            key: "_loadSources",
            value: function _loadSources() {
                var _this = this;
                // Obtain sources iterator
                var sources = this._pending.sources;
                this._pending.loading = true;
                // Close immediately if done
                if (sources.done) {
                    delete this._pending;
                    this.close();
                } else {
                    sources.on('data', function(source) {
                        _this._addSource(source);
                        _this._fillBufferAsync();
                    });
                    sources.on('end', function() {
                        delete _this._pending;
                        _this._fillBuffer();
                    });
                }
            }
        },
        {
            // Adds the given source to the internal sources array
            key: "_addSource",
            value: function _addSource(source) {
                if ($25e8dc8e65a43d49$export$4369c812aac99591(source)) source = $25e8dc8e65a43d49$export$4997ffc0176396a6(source);
                if (!source.done) {
                    this._sources.push(source);
                    source[$25e8dc8e65a43d49$export$b74110983b07cd2e] = this;
                    source.on('error', $25e8dc8e65a43d49$var$destinationEmitError);
                    source.on('readable', $25e8dc8e65a43d49$var$destinationFillBuffer);
                    source.on('end', $25e8dc8e65a43d49$var$destinationRemoveEmptySources);
                }
            }
        },
        {
            // Removes sources that will no longer emit items
            key: "_removeEmptySources",
            value: function _removeEmptySources() {
                var _this = this;
                this._sources = this._sources.filter(function(source, index) {
                    // Adjust the index of the current source if needed
                    if (source.done && index <= _this._currentSource) _this._currentSource--;
                    return !source.done;
                });
                this._fillBuffer();
            }
        },
        {
            // Reads items from the next sources
            key: "_read",
            value: function _read(count, done) {
                var _a;
                // Start source loading if needed
                if (((_a = this._pending) === null || _a === void 0 ? void 0 : _a.loading) === false) this._loadSources();
                // Try to read `count` items
                var lastCount = 0, item;
                while(lastCount !== (lastCount = count))// Try every source at least once
                for(var i = 0; i < this._sources.length && count > 0; i++){
                    // Pick the next source
                    this._currentSource = (this._currentSource + 1) % this._sources.length;
                    var source = this._sources[this._currentSource];
                    // Attempt to read an item from that source
                    if ((item = source.read()) !== null) {
                        count--;
                        this._push(item);
                    }
                }
                // Close this iterator if all of its sources have been read
                if (!this._pending && this._sources.length === 0) this.close();
                done();
            }
        },
        {
            key: "_end",
            value: function _end() {
                var destroy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                (0, $fXhL4._)((0, $hxFDX._)(UnionIterator.prototype), "_end", this).call(this, destroy);
                // Destroy all sources that are still readable
                if (this._destroySources) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var source = _step.value;
                            source.destroy();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Also close the sources stream if applicable
                    if (this._pending) {
                        this._pending.sources.destroy();
                        delete this._pending;
                    }
                }
            }
        }
    ]);
    return UnionIterator;
}($25e8dc8e65a43d49$export$654d6042b7ea281f);
function $25e8dc8e65a43d49$var$destinationRemoveEmptySources() {
    this[$25e8dc8e65a43d49$export$b74110983b07cd2e]._removeEmptySources();
}
var $25e8dc8e65a43d49$export$dbe2e03f1d64d8a2 = /*#__PURE__*/ function(TransformIterator) {
    "use strict";
    (0, $i3fW3._)(ClonedIterator, TransformIterator);
    function ClonedIterator(source) {
        (0, $jGAMp._)(this, ClonedIterator);
        var _this;
        _this = (0, $kzDuW._)(this, ClonedIterator, [
            source,
            {
                autoStart: false
            }
        ]);
        _this._readPosition = 0;
        _this._reading = false;
        // As cloned iterators are not auto-started, they must always be marked as readable.
        if (source) _this.readable = true;
        return _this;
    }
    (0, $byiyg._)(ClonedIterator, [
        {
            key: "_init",
            value: function _init() {
            // skip buffered iterator initialization, since we read from history
            }
        },
        {
            key: "close",
            value: function close() {
                // skip buffered iterator cleanup
                $25e8dc8e65a43d49$export$a22e41f064157de0.prototype.close.call(this);
            }
        },
        {
            key: "source",
            get: // The source this iterator copies items from
            function get() {
                return (0, $fXhL4._)((0, $hxFDX._)(ClonedIterator.prototype), "source", this);
            },
            set: function set(value) {
                // Validate and set the source
                var source = this._source = this._validateSource(value);
                // Create a history reader for the source if none already existed
                var history = source && source[$25e8dc8e65a43d49$export$b74110983b07cd2e] || (source[$25e8dc8e65a43d49$export$b74110983b07cd2e] = new $25e8dc8e65a43d49$var$HistoryReader(source));
                // Do not read the source if this iterator already ended
                if (this.done) {
                    if (this._destroySource) source.destroy();
                } else if (history.endsAt(0)) this.close();
                else {
                    // Subscribe to history events
                    history.register(this);
                    // If there are already items in history, this clone is readable
                    // If the source has a lazy start, always mark this iterator as readable without eagerly triggering a read.
                    if (source._sourceStarted === false || history.readAt(0) !== null) this.readable = true;
                }
                // Hook pending property callbacks to the source
                var propertyCallbacks = this._propertyCallbacks;
                for(var propertyName in propertyCallbacks){
                    var callbacks = propertyCallbacks[propertyName];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            this._getSourceProperty(propertyName, callback);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
      Validates whether the given iterator can be used as a source.
      @protected
      @param {object} source The source to validate
      @param {boolean} allowDestination Whether the source can already have a destination
    */ key: "_validateSource",
            value: function _validateSource(source) {
                var allowDestination = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var history = source && source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                return (0, $fXhL4._)((0, $hxFDX._)(ClonedIterator.prototype), "_validateSource", this).call(this, source, !history || history instanceof $25e8dc8e65a43d49$var$HistoryReader);
            }
        },
        {
            // Retrieves the property with the given name from the clone or its source.
            key: "getProperty",
            value: function getProperty(propertyName, callback) {
                var source = this.source, properties = this._properties, hasProperty = properties && propertyName in properties;
                // If no callback was passed, return the property value
                if (!callback) return hasProperty ? properties && properties[propertyName] : source && source.getProperty(propertyName);
                // Try to look up the property in this clone
                (0, $fXhL4._)((0, $hxFDX._)(ClonedIterator.prototype), "getProperty", this).call(this, propertyName, callback);
                // If the property is not set on this clone, it might become set on the source first
                if (source && !hasProperty) this._getSourceProperty(propertyName, callback);
                return undefined;
            }
        },
        {
            // Retrieves the property with the given name from the source
            key: "_getSourceProperty",
            value: function _getSourceProperty(propertyName, callback) {
                var _this = this;
                this.source.getProperty(propertyName, function(value) {
                    // Only send the source's property if it was not set on the clone in the meantime
                    if (!_this._properties || !(propertyName in _this._properties)) callback(value);
                });
            }
        },
        {
            // Retrieves all properties of the iterator and its source.
            key: "getProperties",
            value: function getProperties() {
                var base = this.source ? this.source.getProperties() : {}, properties = this._properties;
                for(var name in properties)base[name] = properties[name];
                return base;
            }
        },
        {
            /* Generates details for a textual representation of the iterator. */ key: "_toStringDetails",
            value: function _toStringDetails() {
                return "{source: ".concat(this.source ? this.source.toString() : 'none', "}");
            }
        },
        {
            /* Tries to read an item */ key: "read",
            value: function read() {
                // An explicit read kickstarts the source
                if (!this._sourceStarted) this._sourceStarted = true;
                var source = this.source;
                var item = null;
                if (!this.done && source) {
                    // Try to read an item at the current point in history
                    var history = source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                    if ((item = history.readAt(this._readPosition)) !== null) this._readPosition++;
                    else this.readable = false;
                    // Close the iterator if we are at the end of the source
                    if (history.endsAt(this._readPosition)) this.close();
                }
                return item;
            }
        },
        {
            /* End the iterator and cleans up. */ key: "_end",
            value: function _end(destroy) {
                // Unregister from a possible history reader
                var source = this.source;
                var history = source === null || source === void 0 ? void 0 : source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                if (history) history.unregister(this);
                // Don't call TransformIterator#_end,
                // as it would make the source inaccessible for other clones
                $25e8dc8e65a43d49$export$654d6042b7ea281f.prototype._end.call(this, destroy);
            }
        }
    ]);
    return ClonedIterator;
}($25e8dc8e65a43d49$export$524b9ce0a1396fb8);
// Stores the history of a source, so it can be cloned
var $25e8dc8e65a43d49$var$HistoryReader = /*#__PURE__*/ function() {
    "use strict";
    function HistoryReader(source) {
        var _this = this;
        (0, $jGAMp._)(this, HistoryReader);
        this._history = [];
        this._trackers = new Set();
        this._source = source;
        // If the source is still live, set up clone tracking;
        // otherwise, the clones just read from the finished history
        if (!source.done) {
            // When the source becomes readable, makes all clones readable
            var setReadable = function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this._trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tracker = _step.value;
                        tracker.readable = true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            // When the source errors, re-emits the error
            var emitError = function(error) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this._trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tracker = _step.value;
                        tracker.emit('error', error);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            // When the source ends, closes all clones that are fully read
            var end = function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Close the clone if all items had been emitted
                    for(var _iterator = _this._trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tracker = _step.value;
                        if (tracker._sourceStarted !== false && tracker._readPosition === _this._history.length) tracker.close();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                _this._trackers.clear();
                // Remove source listeners, since no further events will be emitted
                source.removeListener('end', end);
                source.removeListener('error', emitError);
                source.removeListener('readable', setReadable);
            };
            // Listen to source events to trigger events in subscribed clones
            source.on('end', end);
            source.on('error', emitError);
            source.on('readable', setReadable);
        }
    }
    (0, $byiyg._)(HistoryReader, [
        {
            // Registers a clone for history updates
            key: "register",
            value: function register(clone) {
                // Tracking is only needed if the source is still live
                if (!this._source.done) this._trackers.add(clone);
            }
        },
        {
            // Unregisters a clone for history updates
            key: "unregister",
            value: function unregister(clone) {
                this._trackers["delete"](clone);
            }
        },
        {
            // Tries to read the item at the given history position
            key: "readAt",
            value: function readAt(pos) {
                var item = null;
                // Retrieve an item from history when available
                if (pos < this._history.length) item = this._history[pos];
                else if (!this._source.done && (item = this._source.read()) !== null) this._history[pos] = item;
                return item;
            }
        },
        {
            // Determines whether the given position is the end of the source
            key: "endsAt",
            value: function endsAt(pos) {
                return this._source.done && this._history.length === pos;
            }
        }
    ]);
    return HistoryReader;
}();
var $25e8dc8e65a43d49$export$21fecf94eb104400 = /*#__PURE__*/ function(AsyncIterator1) {
    "use strict";
    (0, $i3fW3._)(WrappingIterator, AsyncIterator1);
    function WrappingIterator(source, opts) {
        (0, $jGAMp._)(this, WrappingIterator);
        var _this;
        _this = (0, $kzDuW._)(this, WrappingIterator);
        _this._source = null;
        _this._destroySource = (opts === null || opts === void 0 ? void 0 : opts.destroySource) !== false;
        // If promise, set up a temporary source and replace when ready
        if ($25e8dc8e65a43d49$export$4369c812aac99591(source)) {
            _this._source = new $25e8dc8e65a43d49$export$a22e41f064157de0();
            source.then(function(value) {
                _this._source = null;
                _this.source = value;
            })["catch"](function(error) {
                return _this.emit('error', error);
            });
        } else if (source) _this.source = source;
        return _this;
    }
    (0, $byiyg._)(WrappingIterator, [
        {
            key: "source",
            set: function set(value) {
                var _this = this;
                var source = value;
                if (this._source !== null) throw new Error('The source cannot be changed after it has been set');
                // Process an iterable source
                if ($25e8dc8e65a43d49$export$9652023d9040757(source)) source = source[Symbol.iterator]();
                // Process an iterator source
                if ($25e8dc8e65a43d49$export$50db6e277db66ea0(source)) {
                    var iterator = source;
                    source = new (0, $bBoAO.EventEmitter)();
                    source.read = function() {
                        if (iterator !== null) {
                            // Skip any null values inside of the iterator
                            var next;
                            while(!(next = iterator.next()).done){
                                if (next.value !== null) return next.value;
                            }
                            // No remaining values, so stop iterating
                            iterator = null;
                            _this.close();
                        }
                        return null;
                    };
                } else source = $25e8dc8e65a43d49$var$ensureSourceAvailable(source);
                // Do not change sources if the iterator is already done
                if (this.done) {
                    if (this._destroySource && $25e8dc8e65a43d49$export$f6e2535fb5126e54(source.destroy)) source.destroy();
                    return;
                }
                // Set up event handling
                source[$25e8dc8e65a43d49$export$b74110983b07cd2e] = this;
                source.on('end', $25e8dc8e65a43d49$var$destinationClose);
                source.on('error', $25e8dc8e65a43d49$var$destinationEmitError);
                source.on('readable', $25e8dc8e65a43d49$var$destinationSetReadable);
                // Enable reading from source
                this._source = source;
                this.readable = source.readable !== false;
            }
        },
        {
            key: "read",
            value: function read() {
                if (this._source !== null && this._source.readable !== false) {
                    var item = this._source.read();
                    if (item !== null) return item;
                    this.readable = false;
                }
                return null;
            }
        },
        {
            key: "_end",
            value: function _end() {
                var destroy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this._source !== null) {
                    this._source.removeListener('end', $25e8dc8e65a43d49$var$destinationClose);
                    this._source.removeListener('error', $25e8dc8e65a43d49$var$destinationEmitError);
                    this._source.removeListener('readable', $25e8dc8e65a43d49$var$destinationSetReadable);
                    delete this._source[$25e8dc8e65a43d49$export$b74110983b07cd2e];
                    if (this._destroySource && $25e8dc8e65a43d49$export$f6e2535fb5126e54(this._source.destroy)) this._source.destroy();
                    this._source = null;
                }
                (0, $fXhL4._)((0, $hxFDX._)(WrappingIterator.prototype), "_end", this).call(this, destroy);
            }
        }
    ]);
    return WrappingIterator;
}($25e8dc8e65a43d49$export$a22e41f064157de0);
function $25e8dc8e65a43d49$export$4997ffc0176396a6(source, options) {
    // For backward compatibility, always use TransformIterator when options are specified
    if (options && ('autoStart' in options || 'optional' in options || 'source' in options || 'maxBufferSize' in options)) {
        if (source && !$25e8dc8e65a43d49$export$ad59ba2f4c892638(source)) source = new $25e8dc8e65a43d49$export$21fecf94eb104400(source);
        return new $25e8dc8e65a43d49$export$524b9ce0a1396fb8(source, options);
    }
    // Empty iterator if no source specified
    if (!source) return $25e8dc8e65a43d49$export$6e22c362a0406a2c();
    // Unwrap promised sources
    if ($25e8dc8e65a43d49$export$4369c812aac99591(source)) return new $25e8dc8e65a43d49$export$21fecf94eb104400(source, options);
    // Directly return any AsyncIterator
    if (source instanceof $25e8dc8e65a43d49$export$a22e41f064157de0) return source;
    // Other iterable objects
    if (Array.isArray(source)) return $25e8dc8e65a43d49$export$571d59b505e6bb4e(source);
    if ($25e8dc8e65a43d49$export$9652023d9040757(source) || $25e8dc8e65a43d49$export$50db6e277db66ea0(source) || $25e8dc8e65a43d49$export$ad59ba2f4c892638(source)) return new $25e8dc8e65a43d49$export$21fecf94eb104400(source, options);
    // Other types are unsupported
    throw new TypeError("Invalid source: ".concat(source));
}
function $25e8dc8e65a43d49$export$6e22c362a0406a2c() {
    return new $25e8dc8e65a43d49$export$80fed2b3fb5591aa();
}
function $25e8dc8e65a43d49$export$863d7ca51b416cee(item) {
    return new $25e8dc8e65a43d49$export$429f276659ec1f(item);
}
function $25e8dc8e65a43d49$export$571d59b505e6bb4e(items) {
    return new $25e8dc8e65a43d49$export$9174e9fcc7d3059(items);
}
function $25e8dc8e65a43d49$export$fcdaf0685da028e1(source) {
    return new $25e8dc8e65a43d49$export$21fecf94eb104400(source);
}
function $25e8dc8e65a43d49$export$dcccc29c315dd646(source) {
    return new $25e8dc8e65a43d49$export$21fecf94eb104400(source);
}
function $25e8dc8e65a43d49$export$971dd5b0dfd021b6(sources) {
    return new $25e8dc8e65a43d49$export$a9dbacdfc5e6386c(sources);
}
function $25e8dc8e65a43d49$export$d02631cccf789723(start, end, step) {
    return new $25e8dc8e65a43d49$export$ebc81b2f9859754a({
        start: start,
        end: end,
        step: step
    });
}
// Returns a function that calls `fn` with `self` as `this` pointer. */
function $25e8dc8e65a43d49$var$bind(fn, self) {
    return self ? fn.bind(self) : fn;
}
function $25e8dc8e65a43d49$export$f6e2535fb5126e54(object) {
    return typeof object === 'function';
}
function $25e8dc8e65a43d49$export$ad59ba2f4c892638(object) {
    return $25e8dc8e65a43d49$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.on);
}
function $25e8dc8e65a43d49$export$4369c812aac99591(object) {
    return $25e8dc8e65a43d49$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.then);
}
function $25e8dc8e65a43d49$export$7d4a29d60ae655ec(object) {
    return object && ($25e8dc8e65a43d49$export$ad59ba2f4c892638(object) || $25e8dc8e65a43d49$export$4369c812aac99591(object) || $25e8dc8e65a43d49$export$f6e2535fb5126e54(object));
}
function $25e8dc8e65a43d49$export$9652023d9040757(object) {
    return object && Symbol.iterator in object;
}
function $25e8dc8e65a43d49$export$50db6e277db66ea0(object) {
    return $25e8dc8e65a43d49$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.next);
}

});
parcelRegister("bBoAO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3KZcf = parcelRequire("3KZcf");
'use strict';
var $872639ffced919b4$var$R = (typeof Reflect === "undefined" ? "undefined" : (0, $3KZcf._)(Reflect)) === 'object' ? Reflect : null;
var $872639ffced919b4$var$ReflectApply = $872639ffced919b4$var$R && typeof $872639ffced919b4$var$R.apply === 'function' ? $872639ffced919b4$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $872639ffced919b4$var$ReflectOwnKeys;
if ($872639ffced919b4$var$R && typeof $872639ffced919b4$var$R.ownKeys === 'function') $872639ffced919b4$var$ReflectOwnKeys = $872639ffced919b4$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $872639ffced919b4$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $872639ffced919b4$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $872639ffced919b4$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $872639ffced919b4$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $872639ffced919b4$var$EventEmitter() {
    $872639ffced919b4$var$EventEmitter.init.call(this);
}
module.exports = $872639ffced919b4$var$EventEmitter;
module.exports.once = $872639ffced919b4$var$once;
// Backwards-compat with node 0.10.x
$872639ffced919b4$var$EventEmitter.EventEmitter = $872639ffced919b4$var$EventEmitter;
$872639ffced919b4$var$EventEmitter.prototype._events = undefined;
$872639ffced919b4$var$EventEmitter.prototype._eventsCount = 0;
$872639ffced919b4$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $872639ffced919b4$var$defaultMaxListeners = 10;
function $872639ffced919b4$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $3KZcf._)(listener)));
}
Object.defineProperty($872639ffced919b4$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function get() {
        return $872639ffced919b4$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== 'number' || arg < 0 || $872639ffced919b4$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $872639ffced919b4$var$defaultMaxListeners = arg;
    }
});
$872639ffced919b4$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$872639ffced919b4$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $872639ffced919b4$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $872639ffced919b4$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $872639ffced919b4$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$872639ffced919b4$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $872639ffced919b4$var$_getMaxListeners(this);
};
$872639ffced919b4$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $872639ffced919b4$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $872639ffced919b4$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$872639ffced919b4$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $872639ffced919b4$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $872639ffced919b4$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $872639ffced919b4$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $872639ffced919b4$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$872639ffced919b4$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $872639ffced919b4$var$_addListener(this, type, listener, false);
};
$872639ffced919b4$var$EventEmitter.prototype.on = $872639ffced919b4$var$EventEmitter.prototype.addListener;
$872639ffced919b4$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $872639ffced919b4$var$_addListener(this, type, listener, true);
};
function $872639ffced919b4$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $872639ffced919b4$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $872639ffced919b4$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$872639ffced919b4$var$EventEmitter.prototype.once = function once(type, listener) {
    $872639ffced919b4$var$checkListener(listener);
    this.on(type, $872639ffced919b4$var$_onceWrap(this, type, listener));
    return this;
};
$872639ffced919b4$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $872639ffced919b4$var$checkListener(listener);
    this.prependListener(type, $872639ffced919b4$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$872639ffced919b4$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $872639ffced919b4$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $872639ffced919b4$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$872639ffced919b4$var$EventEmitter.prototype.off = $872639ffced919b4$var$EventEmitter.prototype.removeListener;
$872639ffced919b4$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $872639ffced919b4$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $872639ffced919b4$var$unwrapListeners(evlistener) : $872639ffced919b4$var$arrayClone(evlistener, evlistener.length);
}
$872639ffced919b4$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $872639ffced919b4$var$_listeners(this, type, true);
};
$872639ffced919b4$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $872639ffced919b4$var$_listeners(this, type, false);
};
$872639ffced919b4$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $872639ffced919b4$var$listenerCount.call(emitter, type);
};
$872639ffced919b4$var$EventEmitter.prototype.listenerCount = $872639ffced919b4$var$listenerCount;
function $872639ffced919b4$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$872639ffced919b4$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $872639ffced919b4$var$ReflectOwnKeys(this._events) : [];
};
function $872639ffced919b4$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $872639ffced919b4$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $872639ffced919b4$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $872639ffced919b4$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $872639ffced919b4$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $872639ffced919b4$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $872639ffced919b4$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $872639ffced919b4$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $872639ffced919b4$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $3KZcf._)(emitter)));
}

});

parcelRegister("iIrt4", function(module, exports) {

$parcel$export(module.exports, "LinkedList", function () { return $5090703231cb7c11$export$f0ef28713f767754; });
/**
 * A list with O(1) push and shift operations.
 */ 
var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
var $5090703231cb7c11$export$f0ef28713f767754 = /*#__PURE__*/ function() {
    "use strict";
    function LinkedList() {
        (0, $jGAMp._)(this, LinkedList);
        this._length = 0;
        this._head = null;
        this._tail = null;
    }
    (0, $byiyg._)(LinkedList, [
        {
            key: "length",
            get: function get() {
                return this._length;
            }
        },
        {
            key: "first",
            get: function get() {
                var _a;
                return (_a = this._head) === null || _a === void 0 ? void 0 : _a.value;
            }
        },
        {
            key: "last",
            get: function get() {
                var _a;
                return (_a = this._tail) === null || _a === void 0 ? void 0 : _a.value;
            }
        },
        {
            key: "empty",
            get: function get() {
                return this._head === null;
            }
        },
        {
            key: "push",
            value: function push(value) {
                var node = {
                    value: value,
                    next: null
                };
                if (this._tail === null) this._head = this._tail = node;
                else this._tail.next = this._tail = node;
                this._length++;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this._head === null) return undefined;
                var _this__head = this._head, value = _this__head.value, next = _this__head.next;
                this._head = next;
                if (next === null) this._tail = null;
                this._length--;
                return value;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._length = 0;
                this._head = this._tail = null;
            }
        }
    ]);
    return LinkedList;
}();

});

parcelRegister("alcuh", function(module, exports) {

$parcel$export(module.exports, "createTaskScheduler", function () { return $2d7a3cac1faeef6f$export$b8e809f247dcf830; });
var $2d7a3cac1faeef6f$var$resolved = Promise.resolve(undefined);
function $2d7a3cac1faeef6f$export$b8e809f247dcf830() {
    // Use or create a microtask scheduler
    var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : function(task) {
        return $2d7a3cac1faeef6f$var$resolved.then(task);
    };
    // Use or create a macrotask scheduler
    var scheduleMacrotask = typeof setImmediate === 'function' ? setImmediate : function(task) {
        return setTimeout(task, 0);
    };
    // Interrupt with a macrotask every once in a while to avoid freezing
    var i = 0;
    var queue = null;
    return function(task) {
        // Tasks are currently being queued to avoid freezing
        if (queue !== null) queue.push(task);
        else if (++i < 100) scheduleMicrotask(task);
        else {
            // Hold all tasks in a queue, and reschedule them after a macrotask
            queue = [
                task
            ];
            scheduleMacrotask(function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Work through the queue
                    for(var _iterator = queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var queued = _step.value;
                        scheduleMicrotask(queued);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                queue = null;
                // Reset the interruption schedule
                i = 0;
            });
        }
    };
}

});


parcelRegister("kFCZr", function(module, exports) {

var $cqEAj = parcelRequire("cqEAj");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deskolemizeOperation = module.exports.deskolemizeQuad = module.exports.deskolemizeTermNestedThrowing = module.exports.deskolemizeTerm = module.exports.skolemizeBindingsStream = module.exports.skolemizeQuadStream = module.exports.skolemizeBindings = module.exports.skolemizeQuad = module.exports.skolemizeTerm = module.exports.getSourceId = module.exports.SKOLEM_PREFIX = void 0;

var $ck9FR = parcelRequire("ck9FR");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");
module.exports.SKOLEM_PREFIX = 'urn:comunica_skolem:source_';
/**
 * Get the unique, deterministic id for the given source.
 * @param sourceIds ID's of datasources, see KeysRdfResolveQuadPattern.sourceIds.
 * @param source A data source.
 * @return The id of the given source.
 */ function $f0c5e19797264da6$var$getSourceId(sourceIds, source) {
    var sourceId = sourceIds.get(source.referenceValue);
    if (sourceId === undefined) {
        sourceId = "".concat(sourceIds.size);
        sourceIds.set(source.referenceValue, sourceId);
    }
    return sourceId;
}
module.exports.getSourceId = $f0c5e19797264da6$var$getSourceId;
/**
 * If the given term is a blank node, return a deterministic named node for it
 * based on the source id and the blank node value.
 * @param dataFactory The data factory.
 * @param term Any RDF term.
 * @param sourceId A source identifier.
 * @return If the given term was a blank node, this will return a skolemized named node, otherwise the original term.
 */ function $f0c5e19797264da6$var$skolemizeTerm(dataFactory, term, sourceId) {
    if (term.termType === 'BlankNode') return new $ck9FR.BlankNodeScoped("bc_".concat(sourceId, "_").concat(term.value), dataFactory.namedNode("".concat(module.exports.SKOLEM_PREFIX).concat(sourceId, ":").concat(term.value)));
    return term;
}
module.exports.skolemizeTerm = $f0c5e19797264da6$var$skolemizeTerm;
/**
 * Skolemize all terms in the given quad.
 * @param dataFactory The data factory.
 * @param quad An RDF quad.
 * @param sourceId A source identifier.
 * @return The skolemized quad.
 */ function $f0c5e19797264da6$var$skolemizeQuad(dataFactory, quad, sourceId) {
    return (0, $ilNtL.mapTermsNested)(quad, function(term) {
        return $f0c5e19797264da6$var$skolemizeTerm(dataFactory, term, sourceId);
    });
}
module.exports.skolemizeQuad = $f0c5e19797264da6$var$skolemizeQuad;
/**
 * Skolemize all terms in the given bindings.
 * @param dataFactory The data factory.
 * @param bindings An RDF bindings object.
 * @param sourceId A source identifier.
 * @return The skolemized bindings.
 */ function $f0c5e19797264da6$var$skolemizeBindings(dataFactory, bindings, sourceId) {
    return bindings.map(function(term) {
        if (term.termType === 'Quad') return $f0c5e19797264da6$var$skolemizeQuad(dataFactory, term, sourceId);
        return $f0c5e19797264da6$var$skolemizeTerm(dataFactory, term, sourceId);
    });
}
module.exports.skolemizeBindings = $f0c5e19797264da6$var$skolemizeBindings;
/**
 * Skolemize all terms in the given quad stream.
 * @param dataFactory The data factory.
 * @param iterator An RDF quad stream.
 * @param sourceId A source identifier.
 * @return The skolemized quad stream.
 */ function $f0c5e19797264da6$var$skolemizeQuadStream(dataFactory, iterator, sourceId) {
    var ret = iterator.map(function(quad) {
        return $f0c5e19797264da6$var$skolemizeQuad(dataFactory, quad, sourceId);
    });
    function inheritMetadata() {
        iterator.getProperty('metadata', function(metadata) {
            ret.setProperty('metadata', metadata);
            metadata.state.addInvalidateListener(inheritMetadata);
        });
    }
    inheritMetadata();
    return ret;
}
module.exports.skolemizeQuadStream = $f0c5e19797264da6$var$skolemizeQuadStream;
/**
 * Skolemize all terms in the given bindings stream.
 * @param dataFactory The data factory.
 * @param iterator An RDF bindings stream.
 * @param sourceId A source identifier.
 * @return The skolemized bindings stream.
 */ function $f0c5e19797264da6$var$skolemizeBindingsStream(dataFactory, iterator, sourceId) {
    var ret = iterator.map(function(bindings) {
        return $f0c5e19797264da6$var$skolemizeBindings(dataFactory, bindings, sourceId);
    });
    function inheritMetadata() {
        iterator.getProperty('metadata', function(metadata) {
            ret.setProperty('metadata', metadata);
            metadata.state.addInvalidateListener(inheritMetadata);
        });
    }
    inheritMetadata();
    return ret;
}
module.exports.skolemizeBindingsStream = $f0c5e19797264da6$var$skolemizeBindingsStream;
/**
 * If a given term was a skolemized named node for the given source id,
 * deskolemize it again to a blank node.
 * If the given term was a skolemized named node for another source, return false.
 * If the given term was not a skolemized named node, return the original term.
 * @param dataFactory The data factory.
 * @param term Any RDF term.
 * @param sourceId A source identifier.
 */ function $f0c5e19797264da6$var$deskolemizeTerm(dataFactory, term, sourceId) {
    if (term.termType === 'BlankNode' && 'skolemized' in term) term = term.skolemized;
    if (term.termType === 'NamedNode' && term.value.startsWith(module.exports.SKOLEM_PREFIX)) {
        var colonSeparator = term.value.indexOf(':', module.exports.SKOLEM_PREFIX.length);
        var termSourceId = term.value.slice(module.exports.SKOLEM_PREFIX.length, colonSeparator);
        // We had a skolemized term
        if (termSourceId === sourceId) {
            // It came from the correct source
            var termLabel = term.value.slice(colonSeparator + 1, term.value.length);
            return dataFactory.blankNode(termLabel);
        }
        // It came from a different source
        return null;
    }
    return term;
}
module.exports.deskolemizeTerm = $f0c5e19797264da6$var$deskolemizeTerm;
function $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, term, sourceId) {
    if (term.termType === 'Quad') return (0, $ilNtL.mapTermsNested)(term, function(subTerm) {
        var deskolemized = $f0c5e19797264da6$var$deskolemizeTerm(dataFactory, subTerm, sourceId);
        if (!deskolemized) throw new Error("Skolemized term is not in scope for this source");
        return deskolemized;
    });
    var ret = $f0c5e19797264da6$var$deskolemizeTerm(dataFactory, term, sourceId);
    if (ret === null) throw new Error("Skolemized term is not in scope for this source");
    return ret;
}
module.exports.deskolemizeTermNestedThrowing = $f0c5e19797264da6$var$deskolemizeTermNestedThrowing;
/**
 * Deskolemize all terms in the given quad.
 * @param dataFactory The data factory.
 * @param quad An RDF quad.
 * @param sourceId A source identifier.
 * @return The deskolemized quad.
 */ function $f0c5e19797264da6$var$deskolemizeQuad(dataFactory, quad, sourceId) {
    return (0, $ilNtL.mapTermsNested)(quad, function(term) {
        var newTerm = $f0c5e19797264da6$var$deskolemizeTerm(dataFactory, term, sourceId);
        // If the term was skolemized in a different source then don't deskolemize it
        return newTerm !== null && newTerm !== void 0 ? newTerm : term;
    });
}
module.exports.deskolemizeQuad = $f0c5e19797264da6$var$deskolemizeQuad;
/**
 * Deskolemize all terms in the given quad.
 * Will return undefined if there is at least one blank node not in scope for this sourceId.
 * @param dataFactory The data factory.
 * @param operation An algebra operation.
 * @param sourceId A source identifier.
 */ function $f0c5e19797264da6$var$deskolemizeOperation(dataFactory, operation, sourceId) {
    var algebraFactory = new $hSHd8.Factory();
    try {
        var _obj;
        return $hSHd8.Util.mapOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATTERN, function(op, factory) {
            return {
                result: Object.assign(factory.createPattern($f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.subject, sourceId), $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.predicate, sourceId), $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.object, sourceId), $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.graph, sourceId)), {
                    metadata: op.metadata
                }),
                recurse: false
            };
        }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATH, function(op, factory) {
            return {
                result: Object.assign(factory.createPath($f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.subject, sourceId), op.predicate, $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.object, sourceId), $f0c5e19797264da6$var$deskolemizeTermNestedThrowing(dataFactory, op.graph, sourceId)), {
                    metadata: op.metadata
                }),
                recurse: false
            };
        }), _obj), algebraFactory);
    } catch (e) {
    // Return undefined for skolemized terms not in scope for this source
    }
}
module.exports.deskolemizeOperation = $f0c5e19797264da6$var$deskolemizeOperation;

});
parcelRegister("ck9FR", function(module, exports) {
"use strict";
var $8f8edb5dae75531d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8f8edb5dae75531d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8f8edb5dae75531d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8f8edb5dae75531d$var$__exportStar((parcelRequire("2PMHh")), module.exports);

$8f8edb5dae75531d$var$__exportStar((parcelRequire("eUjVy")), module.exports);

});
parcelRegister("2PMHh", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNodeScoped = void 0;
/**
 * A blank node that is scoped to a certain source.
 */ var $21061e6d811c7fca$var$BlankNodeScoped = /*#__PURE__*/ function() {
    function BlankNodeScoped(value, skolemized) {
        (0, $jGAMp._)(this, BlankNodeScoped);
        this.termType = 'BlankNode';
        this.value = value;
        this.skolemized = skolemized;
    }
    (0, $byiyg._)(BlankNodeScoped, [
        {
            key: "equals",
            value: function equals(other) {
                // eslint-disable-next-line no-implicit-coercion
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNodeScoped;
}();
module.exports.BlankNodeScoped = $21061e6d811c7fca$var$BlankNodeScoped;

});

parcelRegister("eUjVy", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNodeBindingsScoped = void 0;
/**
 * A blank node that is scoped to a set of bindings.
 */ var $ada5c0c745d5ad84$var$BlankNodeBindingsScoped = /*#__PURE__*/ function() {
    function BlankNodeBindingsScoped(value) {
        (0, $jGAMp._)(this, BlankNodeBindingsScoped);
        this.termType = 'BlankNode';
        this.singleBindingsScope = true;
        this.value = value;
    }
    (0, $byiyg._)(BlankNodeBindingsScoped, [
        {
            key: "equals",
            value: function equals(other) {
                // eslint-disable-next-line no-implicit-coercion
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNodeBindingsScoped;
}();
module.exports.BlankNodeBindingsScoped = $ada5c0c745d5ad84$var$BlankNodeBindingsScoped;

});






parcelRegister("9CrIH", function(module, exports) {
"use strict";
var $700d2a4173aeb889$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $700d2a4173aeb889$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $700d2a4173aeb889$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$700d2a4173aeb889$var$__exportStar((parcelRequire("1QHmv")), module.exports);

});
parcelRegister("1QHmv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorCombinePipeline = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica mediator that goes over all actors in sequence and forwards I/O.
 * This required the action input and the actor output to be of the same type.
 */ var $158c488ff542cbe2$var$MediatorCombinePipeline = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorCombinePipeline, _core_1_Mediator);
    function MediatorCombinePipeline(args) {
        (0, $jGAMp._)(this, MediatorCombinePipeline);
        return (0, $kzDuW._)(this, MediatorCombinePipeline, [
            args
        ]);
    }
    (0, $byiyg._)(MediatorCombinePipeline, [
        {
            key: "mediate",
            value: function mediate(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, testResults, _testResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, reply, err, sideDatas, getOrder, handle, i, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, actor, _tmp, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                try {
                                    testResults = this.publish(action);
                                } catch (e) {
                                    // If no actors are available, just return the input as output
                                    return [
                                        2,
                                        action
                                    ];
                                }
                                if (!this.filterFailures) return [
                                    3,
                                    9
                                ];
                                _testResults = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = testResults[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                result = _step.value;
                                return [
                                    4,
                                    result.reply
                                ];
                            case 3:
                                reply = _state.sent();
                                if (reply.isPassed()) _testResults.push(result);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                testResults = _testResults;
                                _state.label = 9;
                            case 9:
                                // Delegate test errors.
                                sideDatas = [];
                                return [
                                    4,
                                    Promise.all(testResults.map(function(param, i) {
                                        var actor = param.actor, reply = param.reply;
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var awaitedReply, value, error;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]);
                                                        return [
                                                            4,
                                                            reply
                                                        ];
                                                    case 1:
                                                        awaitedReply = _state.sent();
                                                        value = awaitedReply.getOrThrow();
                                                        sideDatas[i] = awaitedReply.getSideData();
                                                        return [
                                                            2,
                                                            {
                                                                actor: actor,
                                                                reply: value
                                                            }
                                                        ];
                                                    case 2:
                                                        error = _state.sent();
                                                        throw new Error(this.constructFailureMessage(action, [
                                                            error.message
                                                        ]));
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 10:
                                testResults = _state.sent();
                                // Order the test results if ordering is enabled
                                if (this.order) {
                                    // A function used to extract an ordering value from a test result
                                    getOrder = function(elem) {
                                        // If there is a field key use it, otherwise use the input
                                        // element for ordering
                                        var value = _this.field ? elem[_this.field] : elem;
                                        // Check the ordering value is a number
                                        if (typeof value !== 'number') throw new TypeError('Cannot order elements that are not numbers.');
                                        return value;
                                    };
                                    testResults = testResults.sort(function(actor1, actor2) {
                                        return (_this.order === 'increasing' ? 1 : -1) * (getOrder(actor1.reply) - getOrder(actor2.reply));
                                    });
                                }
                                // Pass action to first actor,
                                // and each actor output as input to the following actor.
                                handle = action;
                                i = 0;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 11;
                            case 11:
                                _state.trys.push([
                                    11,
                                    16,
                                    17,
                                    18
                                ]);
                                _iterator1 = testResults[Symbol.iterator]();
                                _state.label = 12;
                            case 12:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    15
                                ];
                                actor = _step1.value.actor;
                                _tmp = [
                                    {},
                                    handle
                                ];
                                return [
                                    4,
                                    actor.runObservable(handle, sideDatas[i++])
                                ];
                            case 13:
                                handle = (0, $iT0je._).apply(void 0, _tmp.concat([
                                    _state.sent()
                                ]));
                                _state.label = 14;
                            case 14:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    12
                                ];
                            case 15:
                                return [
                                    3,
                                    18
                                ];
                            case 16:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 18:
                                // Return the final actor output
                                return [
                                    2,
                                    handle
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "mediateWith",
            value: function mediateWith() {
                throw new Error('Method not supported.');
            }
        }
    ]);
    return MediatorCombinePipeline;
}($kNNoa.Mediator);
module.exports.MediatorCombinePipeline = $158c488ff542cbe2$var$MediatorCombinePipeline;

});


parcelRegister("lS8bs", function(module, exports) {
"use strict";
var $fec4fd464111e646$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fec4fd464111e646$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fec4fd464111e646$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fec4fd464111e646$var$__exportStar((parcelRequire("7lVII")), module.exports);

});
parcelRegister("7lVII", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashBindingsMurmur = void 0;

var $5gFj1 = parcelRequire("5gFj1");

var $kNNoa = parcelRequire("kNNoa");

var $5EZjY = parcelRequire("5EZjY");
/**
 * A comunica Murmur Hash Bindings Actor.
 */ var $55a74495c5712a25$var$ActorHashBindingsMurmur = /*#__PURE__*/ function(_bus_hash_bindings_1_ActorHashBindings) {
    (0, $i3fW3._)(ActorHashBindingsMurmur, _bus_hash_bindings_1_ActorHashBindings);
    function ActorHashBindingsMurmur() {
        (0, $jGAMp._)(this, ActorHashBindingsMurmur);
        return (0, $kzDuW._)(this, ActorHashBindingsMurmur, arguments);
    }
    (0, $byiyg._)(ActorHashBindingsMurmur, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                hashFunction: function(bindings, variables) {
                                    var _bindings_get;
                                    var hash = $5EZjY();
                                    var _bindings_get_value;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var variable = _step.value;
                                            hash = hash.hash((_bindings_get_value = (_bindings_get = bindings.get(variable)) === null || _bindings_get === void 0 ? void 0 : _bindings_get.value) !== null && _bindings_get_value !== void 0 ? _bindings_get_value : 'UNDEF');
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return hash.result();
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorHashBindingsMurmur;
}($5gFj1.ActorHashBindings);
module.exports.ActorHashBindingsMurmur = $55a74495c5712a25$var$ActorHashBindingsMurmur;

});
parcelRegister("5gFj1", function(module, exports) {
"use strict";
var $3d5e7cdac71ed111$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d5e7cdac71ed111$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3d5e7cdac71ed111$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3d5e7cdac71ed111$var$__exportStar((parcelRequire("76lSH")), module.exports);

});
parcelRegister("76lSH", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashBindings = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for hash-bindings events.
 *
 * Actor types:
 * * Input:  IActionHashBindings:      Metadata for selecting a hash function.
 * * Test:   IActorTest:
 * * Output: IActorHashBindingsOutput: The resulting hash function.
 *
 * @see IActionHashBindings
 * @see IActorHashBindingsTest
 * @see IActorHashBindingsOutput
 */ var $52ba111aa081ff74$var$ActorHashBindings = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorHashBindings, _core_1_Actor);
    function ActorHashBindings(args) {
        (0, $jGAMp._)(this, ActorHashBindings);
        return (0, $kzDuW._)(this, ActorHashBindings, [
            args
        ]);
    }
    return ActorHashBindings;
}($kNNoa.Actor);
module.exports.ActorHashBindings = $52ba111aa081ff74$var$ActorHashBindings;

});


parcelRegister("5EZjY", function(module, exports) {
/**
 * @preserve
 * JS Implementation of incremental MurmurHash3 (r150) (as of May 10, 2013)
 *
 * @author <a href="mailto:jensyt@gmail.com">Jens Taylor</a>
 * @see http://github.com/homebrewing/brauhaus-diff
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 */ (function() {
    var cache;
    // Call this function without `new` to use the cached object (good for
    // single-threaded environments), or with `new` to create a new object.
    //
    // @param {string} key A UTF-16 or ASCII string
    // @param {number} seed An optional positive integer
    // @return {object} A MurmurHash3 object for incremental hashing
    function MurmurHash3(key, seed) {
        var m = this instanceof MurmurHash3 ? this : cache;
        m.reset(seed);
        if (typeof key === 'string' && key.length > 0) m.hash(key);
        if (m !== this) return m;
    }
    // Incrementally add a string to this hash
    //
    // @param {string} key A UTF-16 or ASCII string
    // @return {object} this
    MurmurHash3.prototype.hash = function(key) {
        var h1, k1, i, top, len;
        len = key.length;
        this.len += len;
        k1 = this.k1;
        i = 0;
        switch(this.rem){
            case 0:
                k1 ^= len > i ? key.charCodeAt(i++) & 0xffff : 0;
            case 1:
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xffff) << 8 : 0;
            case 2:
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xffff) << 16 : 0;
            case 3:
                k1 ^= len > i ? (key.charCodeAt(i) & 0xff) << 24 : 0;
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xff00) >> 8 : 0;
        }
        this.rem = len + this.rem & 3; // & 3 is same as % 4
        len -= this.rem;
        if (len > 0) {
            h1 = this.h1;
            while(true){
                k1 = k1 * 0x2d51 + (k1 & 0xffff) * 0xcc9e0000 & 0xffffffff;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * 0x3593 + (k1 & 0xffff) * 0x1b870000 & 0xffffffff;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1 = h1 * 5 + 0xe6546b64 & 0xffffffff;
                if (i >= len) break;
                k1 = key.charCodeAt(i++) & 0xffff ^ (key.charCodeAt(i++) & 0xffff) << 8 ^ (key.charCodeAt(i++) & 0xffff) << 16;
                top = key.charCodeAt(i++);
                k1 ^= (top & 0xff) << 24 ^ (top & 0xff00) >> 8;
            }
            k1 = 0;
            switch(this.rem){
                case 3:
                    k1 ^= (key.charCodeAt(i + 2) & 0xffff) << 16;
                case 2:
                    k1 ^= (key.charCodeAt(i + 1) & 0xffff) << 8;
                case 1:
                    k1 ^= key.charCodeAt(i) & 0xffff;
            }
            this.h1 = h1;
        }
        this.k1 = k1;
        return this;
    };
    // Get the result of this hash
    //
    // @return {number} The 32-bit hash
    MurmurHash3.prototype.result = function() {
        var k1, h1;
        k1 = this.k1;
        h1 = this.h1;
        if (k1 > 0) {
            k1 = k1 * 0x2d51 + (k1 & 0xffff) * 0xcc9e0000 & 0xffffffff;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * 0x3593 + (k1 & 0xffff) * 0x1b870000 & 0xffffffff;
            h1 ^= k1;
        }
        h1 ^= this.len;
        h1 ^= h1 >>> 16;
        h1 = h1 * 0xca6b + (h1 & 0xffff) * 0x85eb0000 & 0xffffffff;
        h1 ^= h1 >>> 13;
        h1 = h1 * 0xae35 + (h1 & 0xffff) * 0xc2b20000 & 0xffffffff;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
    };
    // Reset the hash object for reuse
    //
    // @param {number} seed An optional positive integer
    MurmurHash3.prototype.reset = function(seed) {
        this.h1 = typeof seed === 'number' ? seed : 0;
        this.rem = this.k1 = this.len = 0;
        return this;
    };
    // A cached object to use. This can be safely used if you're in a single-
    // threaded environment, otherwise you need to create new hashes to use.
    cache = new MurmurHash3();
    if (typeof module != 'undefined') module.exports = MurmurHash3;
    else this.MurmurHash3 = MurmurHash3;
})();

});



parcelRegister("IQBqE", function(module, exports) {
"use strict";
var $086ce9f94ed4c1ce$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $086ce9f94ed4c1ce$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $086ce9f94ed4c1ce$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$086ce9f94ed4c1ce$var$__exportStar((parcelRequire("hRGQJ")), module.exports);

});
parcelRegister("hRGQJ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorRace = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A mediator that picks the first actor that resolves its test.
 */ var $d0189fe7bf1862d0$var$MediatorRace = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorRace, _core_1_Mediator);
    function MediatorRace(args) {
        (0, $jGAMp._)(this, MediatorRace);
        return (0, $kzDuW._)(this, MediatorRace, [
            args
        ]);
    }
    (0, $byiyg._)(MediatorRace, [
        {
            key: "mediateWith",
            value: function mediateWith(action, testResults) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    var errors = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var testResult = _step.value;
                            testResult.reply.then(function(reply) {
                                if (reply.isPassed()) resolve((0, $kNNoa.passTestWithSideData)(testResult.actor, reply.getSideData()));
                                else {
                                    errors.push(reply.getFailMessage());
                                    if (errors.length === testResults.length) resolve((0, $kNNoa.failTest)(_this.constructFailureMessage(action, errors)));
                                }
                            })["catch"](function(error) {
                                reject(error);
                            });
                        };
                        for(var _iterator = testResults[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        }
    ]);
    return MediatorRace;
}($kNNoa.Mediator);
module.exports.MediatorRace = $d0189fe7bf1862d0$var$MediatorRace;

});


parcelRegister("CX5dO", function(module, exports) {
"use strict";
var $0751616bf0bbf95e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0751616bf0bbf95e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0751616bf0bbf95e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0751616bf0bbf95e$var$__exportStar((parcelRequire("9FA96")), module.exports);

});
parcelRegister("9FA96", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashQuadsMurmur = void 0;

var $g71m9 = parcelRequire("g71m9");

var $kNNoa = parcelRequire("kNNoa");

var $5EZjY = parcelRequire("5EZjY");
/**
 * A comunica Murmur Hash Quads Actor.
 */ var $70a3fb37b5fb9da6$var$ActorHashQuadsMurmur = /*#__PURE__*/ function(_bus_hash_quads_1_ActorHashQuads) {
    (0, $i3fW3._)(ActorHashQuadsMurmur, _bus_hash_quads_1_ActorHashQuads);
    function ActorHashQuadsMurmur() {
        (0, $jGAMp._)(this, ActorHashQuadsMurmur);
        return (0, $kzDuW._)(this, ActorHashQuadsMurmur, arguments);
    }
    (0, $byiyg._)(ActorHashQuadsMurmur, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                hashFunction: function(quad) {
                                    var hash = $5EZjY(quad.subject.value);
                                    hash.hash(quad.predicate.value);
                                    hash.hash(quad.object.value);
                                    hash.hash(quad.graph.value);
                                    return hash.result();
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorHashQuadsMurmur;
}($g71m9.ActorHashQuads);
module.exports.ActorHashQuadsMurmur = $70a3fb37b5fb9da6$var$ActorHashQuadsMurmur;

});
parcelRegister("g71m9", function(module, exports) {
"use strict";
var $bbae5a22e7fc5174$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbae5a22e7fc5174$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbae5a22e7fc5174$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bbae5a22e7fc5174$var$__exportStar((parcelRequire("ioLd8")), module.exports);

});
parcelRegister("ioLd8", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashQuads = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for hash-quads events.
 *
 * Actor types:
 * * Input:  IActionHashQuads:      Metadata for selecting a hash function.
 * * Test:   <none>
 * * Output: IActorHashQuadsOutput: The resulting hash function.
 *
 * @see IActionHashQuads
 * @see IActorHashQuadsOutput
 */ var $d64f16fb4076ec66$var$ActorHashQuads = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorHashQuads, _core_1_Actor);
    function ActorHashQuads(args) {
        (0, $jGAMp._)(this, ActorHashQuads);
        return (0, $kzDuW._)(this, ActorHashQuads, [
            args
        ]);
    }
    return ActorHashQuads;
}($kNNoa.Actor);
module.exports.ActorHashQuads = $d64f16fb4076ec66$var$ActorHashQuads;

});




parcelRegister("TNyGX", function(module, exports) {
"use strict";
var $0a7b9476b26ae51e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a7b9476b26ae51e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a7b9476b26ae51e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a7b9476b26ae51e$var$__exportStar((parcelRequire("hQ5DS")), module.exports);

});
parcelRegister("hQ5DS", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteCopy = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Rewrite Copy Optimize Query Operation Actor.
 */ var $cfcbab6de39f01a3$var$ActorOptimizeQueryOperationRewriteCopy = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationRewriteCopy, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationRewriteCopy(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationRewriteCopy);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationRewriteCopy, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationRewriteCopy, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, (0, $cqEAj._)({}, $hSHd8.Algebra.types.COPY, function(operationOriginal, factory) {
                            // No-op if source === destination
                            var result;
                            if (typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' && operationOriginal.destination === operationOriginal.source || typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' && operationOriginal.destination.equals(operationOriginal.source)) result = factory.createCompositeUpdate([]);
                            else // COPY is equivalent to drop destination, and add
                            result = factory.createCompositeUpdate([
                                factory.createDrop(operationOriginal.destination, true),
                                factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent)
                            ]);
                            return {
                                result: result,
                                recurse: false
                            };
                        }), algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationRewriteCopy;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationRewriteCopy = $cfcbab6de39f01a3$var$ActorOptimizeQueryOperationRewriteCopy;

});
parcelRegister("1GbiV", function(module, exports) {
"use strict";
var $13927b8080d6e76c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13927b8080d6e76c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $13927b8080d6e76c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$13927b8080d6e76c$var$__exportStar((parcelRequire("fxls6")), module.exports);

});
parcelRegister("fxls6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperation = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for optimize-query-operation events.
 *
 * Actor types:
 * * Input:  IActionOptimizeQueryOperation:      An incoming SPARQL operation.
 * * Test:   <none>
 * * Output: IActorOptimizeQueryOperationOutput: A (possibly optimized) outgoing SPARQL operation.
 *
 * @see IActionOptimizeQueryOperation
 * @see IActorOptimizeQueryOperationOutput
 */ var $b4fa940ef727bf3c$var$ActorOptimizeQueryOperation = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorOptimizeQueryOperation, _core_1_Actor);
    function ActorOptimizeQueryOperation(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperation);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperation, [
            args
        ]);
    }
    return ActorOptimizeQueryOperation;
}($kNNoa.Actor);
module.exports.ActorOptimizeQueryOperation = $b4fa940ef727bf3c$var$ActorOptimizeQueryOperation;

});




parcelRegister("kpzeU", function(module, exports) {
"use strict";
var $edc17a451dbed989$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $edc17a451dbed989$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $edc17a451dbed989$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$edc17a451dbed989$var$__exportStar((parcelRequire("itBuw")), module.exports);

});
parcelRegister("itBuw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteMove = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Rewrite Move Optimize Query Operation Actor.
 */ var $d738046b4e4bc417$var$ActorOptimizeQueryOperationRewriteMove = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationRewriteMove, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationRewriteMove(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationRewriteMove);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationRewriteMove, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationRewriteMove, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, (0, $cqEAj._)({}, $hSHd8.Algebra.types.MOVE, function(operationOriginal, factory) {
                            // No-op if source === destination
                            var result;
                            if (typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' && operationOriginal.destination === operationOriginal.source || typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' && operationOriginal.destination.equals(operationOriginal.source)) result = factory.createCompositeUpdate([]);
                            else {
                                // MOVE is equivalent to drop destination, add, and drop source
                                var updates = [
                                    factory.createDrop(operationOriginal.destination, true),
                                    factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent),
                                    factory.createDrop(operationOriginal.source)
                                ];
                                result = factory.createCompositeUpdate(updates);
                            }
                            return {
                                result: result,
                                recurse: false
                            };
                        }), algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationRewriteMove;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationRewriteMove = $d738046b4e4bc417$var$ActorOptimizeQueryOperationRewriteMove;

});


parcelRegister("f0pjo", function(module, exports) {
"use strict";
var $aeca7d7b58643e5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aeca7d7b58643e5b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aeca7d7b58643e5b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aeca7d7b58643e5b$var$__exportStar((parcelRequire("attBq")), module.exports);

});
parcelRegister("attBq", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteAdd = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2ej16 = parcelRequire("2ej16");

var $hSHd8 = parcelRequire("hSHd8");
var $7a03934ab3746666$var$DF = new $2ej16.DataFactory();
/**
 * A comunica Rewrite Add Optimize Query Operation Actor.
 */ var $7a03934ab3746666$var$ActorOptimizeQueryOperationRewriteAdd = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationRewriteAdd, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationRewriteAdd(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationRewriteAdd);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationRewriteAdd, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationRewriteAdd, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, (0, $cqEAj._)({}, $hSHd8.Algebra.types.ADD, function(operationOriginal, factory) {
                            // CONSTRUCT all quads from the source, and INSERT them into the destination
                            var destination = operationOriginal.destination === 'DEFAULT' ? $7a03934ab3746666$var$DF.defaultGraph() : operationOriginal.destination;
                            var source = operationOriginal.source === 'DEFAULT' ? $7a03934ab3746666$var$DF.defaultGraph() : operationOriginal.source;
                            var result = factory.createDeleteInsert(undefined, [
                                factory.createPattern($7a03934ab3746666$var$DF.variable('s'), $7a03934ab3746666$var$DF.variable('p'), $7a03934ab3746666$var$DF.variable('o'), destination)
                            ], factory.createPattern($7a03934ab3746666$var$DF.variable('s'), $7a03934ab3746666$var$DF.variable('p'), $7a03934ab3746666$var$DF.variable('o'), source));
                            return {
                                result: result,
                                recurse: false
                            };
                        }), algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationRewriteAdd;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationRewriteAdd = $7a03934ab3746666$var$ActorOptimizeQueryOperationRewriteAdd;

});


parcelRegister("bW2V3", function(module, exports) {
"use strict";
var $8b076033afd5c1ff$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8b076033afd5c1ff$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8b076033afd5c1ff$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8b076033afd5c1ff$var$__exportStar((parcelRequire("6duM4")), module.exports);

});
parcelRegister("6duM4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationGroupSources = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Group Sources Optimize Query Operation Actor.
 */ var $486bd41a7fe063a1$var$ActorOptimizeQueryOperationGroupSources = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationGroupSources, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationGroupSources(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationGroupSources);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationGroupSources, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationGroupSources, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if ((0, $2n9RU.getOperationSource)(action.operation)) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " does not work with top-level operation sources."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    this.groupOperation(action.operation, action.context)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.operation = _state.sent(), _tmp.context = action.context, _tmp)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "groupOperation",
            value: /**
     * Group operations belonging to the same source together, only if that source accepts the grouped operations.
     * This grouping will be done recursively for the whole operation tree.
     * Operations annotated with sources are considered leaves in the tree.
     * @param operation An operation to group.
     * @param context The action context.
     */ function groupOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, _ref, _groupedInput_metadata, groupedInput, source, _, inputs, clusters, newInputs, source1, _tmp, multiFactoryMethod;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                // Return operation as-is if the operation already has a single source, or if the operation has no children.
                                if ((_ref = (0, $2n9RU.getOperationSource)(operation)) !== null && _ref !== void 0 ? _ref : !('input' in operation)) return [
                                    2,
                                    operation
                                ];
                                if (!!Array.isArray(operation.input)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.groupOperation(operation.input, context)
                                ];
                            case 1:
                                groupedInput = _state.sent();
                                if (!((_groupedInput_metadata = groupedInput.metadata) === null || _groupedInput_metadata === void 0 ? void 0 : _groupedInput_metadata.scopedSource)) return [
                                    3,
                                    3
                                ];
                                source = (0, $2n9RU.getOperationSource)(groupedInput);
                                _ = (0, $2n9RU.doesShapeAcceptOperation);
                                return [
                                    4,
                                    source.source.getSelectorShape(context)
                                ];
                            case 2:
                                if (_.apply(void 0, [
                                    _state.sent(),
                                    operation
                                ])) {
                                    this.logDebug(context, "Hoist 1 source-specific operation into a single ".concat(operation.type, " operation for ").concat(source.source.toString()));
                                    (0, $2n9RU.removeOperationSource)(groupedInput);
                                    operation = (0, $2n9RU.assignOperationSource)(operation, source);
                                }
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    (0, $emQHU._)((0, $iT0je._)({}, operation), {
                                        input: groupedInput
                                    })
                                ];
                            case 4:
                                return [
                                    4,
                                    Promise.all(operation.input.map(function(subInput) {
                                        return _this.groupOperation(subInput, context);
                                    }))
                                ];
                            case 5:
                                inputs = _state.sent();
                                clusters = this.clusterOperationsWithEqualSources(inputs);
                                if (!(clusters.length === 1)) return [
                                    3,
                                    7
                                ];
                                newInputs = clusters[0];
                                source1 = (0, $2n9RU.getOperationSource)(clusters[0][0]);
                                _tmp = [
                                    {}
                                ];
                                return [
                                    4,
                                    this.moveSourceAnnotationUpwardsIfPossible(operation, newInputs, source1, context)
                                ];
                            case 6:
                                return [
                                    2,
                                    (0, $emQHU._).apply(void 0, [
                                        (0, $iT0je._).apply(void 0, _tmp.concat([
                                            _state.sent()
                                        ])),
                                        {
                                            input: newInputs
                                        }
                                    ])
                                ];
                            case 7:
                                // If the number of clusters is equal to the number of original inputs, do nothing.
                                if (clusters.length === inputs.length) return [
                                    2,
                                    (0, $emQHU._)((0, $iT0je._)({}, operation), {
                                        input: inputs
                                    })
                                ];
                                switch(operation.type){
                                    case $hSHd8.Algebra.types.JOIN:
                                        multiFactoryMethod = algebraFactory.createJoin.bind(algebraFactory);
                                        break;
                                    case $hSHd8.Algebra.types.UNION:
                                        multiFactoryMethod = algebraFactory.createUnion.bind(algebraFactory);
                                        break;
                                    case $hSHd8.Algebra.types.ALT:
                                        multiFactoryMethod = algebraFactory.createAlt.bind(algebraFactory);
                                        break;
                                    case $hSHd8.Algebra.types.SEQ:
                                        multiFactoryMethod = algebraFactory.createSeq.bind(algebraFactory);
                                        break;
                                    default:
                                        // While LeftJoin and Minus are also multi-operations,
                                        // these can never occur because they only have 2 inputs,
                                        // so these cases will always be captured by one of the 2 if-cases above
                                        // (clusters.length === 1 or clusters.length === input.length)
                                        // In all other cases, error
                                        throw new Error("Unsupported operation '".concat(operation.type, "' detected while grouping sources"));
                                }
                                return [
                                    4,
                                    this.groupOperationMulti(clusters, multiFactoryMethod, context)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "groupOperationMulti",
            value: function groupOperationMulti(clusters, factoryMethod, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, flatten, nestedMerges;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                flatten = true;
                                return [
                                    4,
                                    Promise.all(clusters.map(function(cluster) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var source, merged;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        source = (0, $2n9RU.getOperationSource)(cluster[0]);
                                                        return [
                                                            4,
                                                            this.moveSourceAnnotationUpwardsIfPossible(factoryMethod(cluster, true), cluster, source, context)
                                                        ];
                                                    case 1:
                                                        merged = _state.sent();
                                                        if ((0, $2n9RU.getOperationSource)(merged)) flatten = false;
                                                        return [
                                                            2,
                                                            merged
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 1:
                                nestedMerges = _state.sent();
                                return [
                                    2,
                                    factoryMethod(nestedMerges, flatten)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Cluster the given operations by equal source annotations.
     * @param operationsIn An array of operations to cluster.
     */ key: "clusterOperationsWithEqualSources",
            value: function clusterOperationsWithEqualSources(operationsIn) {
                // Operations can have a source, or no source at all
                var sourceOperations = new Map();
                var sourcelessOperations = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Cluster by source
                    for(var _iterator = operationsIn[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var operation = _step.value;
                        var source = (0, $2n9RU.getOperationSource)(operation);
                        if (source) {
                            if (!sourceOperations.has(source)) sourceOperations.set(source, []);
                            sourceOperations.get(source).push(operation);
                        } else sourcelessOperations.push(operation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Return clusters
                var clusters = [];
                if (sourcelessOperations.length > 0) clusters.push(sourcelessOperations);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _loop = function() {
                        var _step_value = (0, $32TW8._)(_step1.value, 2), source = _step_value[0], operations = _step_value[1];
                        clusters.push(operations.map(function(operation) {
                            return (0, $2n9RU.assignOperationSource)(operation, source);
                        }));
                    };
                    for(var _iterator1 = sourceOperations.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return clusters;
            }
        },
        {
            key: "moveSourceAnnotationUpwardsIfPossible",
            value: /**
     * If the given source accepts the grouped operation, annotate the grouped operation with the source,
     * and remove the source annotation from the seperate input operations.
     * Otherwise, return the grouped operation unchanged.
     * @param operation A grouped operation consisting of all given input operations.
     * @param inputs An array of operations that share the same source annotation.
     * @param source The common source.
     * @param context The action context.
     */ function moveSourceAnnotationUpwardsIfPossible(operation, inputs, source, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _tmp, _, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = source;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                _ = (0, $2n9RU.doesShapeAcceptOperation);
                                return [
                                    4,
                                    source.source.getSelectorShape(context)
                                ];
                            case 1:
                                _tmp = _.apply(void 0, [
                                    _state.sent(),
                                    operation
                                ]);
                                _state.label = 2;
                            case 2:
                                if (_tmp) {
                                    this.logDebug(context, "Hoist ".concat(inputs.length, " source-specific operations into a single ").concat(operation.type, " operation for ").concat(source.source.toString()));
                                    operation = (0, $2n9RU.assignOperationSource)(operation, source);
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = inputs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            input = _step.value;
                                            (0, $2n9RU.removeOperationSource)(input);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return [
                                    2,
                                    operation
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorOptimizeQueryOperationGroupSources;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationGroupSources = $486bd41a7fe063a1$var$ActorOptimizeQueryOperationGroupSources;

});
parcelRegister("2n9RU", function(module, exports) {
"use strict";
var $1ba5626854c64a37$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ba5626854c64a37$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1ba5626854c64a37$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1ba5626854c64a37$var$__exportStar((parcelRequire("ciVWs")), module.exports);

$1ba5626854c64a37$var$__exportStar((parcelRequire("e8bF8")), module.exports);

$1ba5626854c64a37$var$__exportStar((parcelRequire("f99ML")), module.exports);

$1ba5626854c64a37$var$__exportStar((parcelRequire("cZ2ZT")), module.exports);

});
parcelRegister("ciVWs", function(module, exports) {

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.estimateNpsCardinality = module.exports.estimateJoinCardinality = module.exports.estimateUnionCardinality = module.exports.estimateSliceCardinality = module.exports.estimateMinusCardinality = module.exports.estimateCardinality = void 0;

var $2ej16 = parcelRequire("2ej16");

var $hSHd8 = parcelRequire("hSHd8");
// These are only used internally for estimates
var $8f541c88b6ade238$var$DF = new $2ej16.DataFactory();
var $8f541c88b6ade238$var$AF = new $hSHd8.Factory($8f541c88b6ade238$var$DF);
/**
 * Estimate the cardinality of the provided operation using the specified dataset metadata.
 * This is the primary function that should be called to perform cardinality estimation.
 */ function $8f541c88b6ade238$var$estimateCardinality(operation, dataset) {
    var estimate = dataset.getCardinality(operation);
    if (estimate) return estimate;
    switch(operation.type){
        case $hSHd8.Algebra.types.ASK:
            return {
                type: 'exact',
                value: 1,
                dataset: dataset.uri
            };
        case $hSHd8.Algebra.types.LOAD:
        case $hSHd8.Algebra.types.DELETE_INSERT:
        case $hSHd8.Algebra.types.ADD:
        case $hSHd8.Algebra.types.COMPOSITE_UPDATE:
        case $hSHd8.Algebra.types.CLEAR:
        case $hSHd8.Algebra.types.NOP:
        case $hSHd8.Algebra.types.DROP:
        case $hSHd8.Algebra.types.CREATE:
        case $hSHd8.Algebra.types.MOVE:
        case $hSHd8.Algebra.types.COPY:
            return {
                type: 'exact',
                value: 0,
                dataset: dataset.uri
            };
        case $hSHd8.Algebra.types.PROJECT:
        case $hSHd8.Algebra.types.FILTER:
        case $hSHd8.Algebra.types.ORDER_BY:
        case $hSHd8.Algebra.types.GROUP:
        case $hSHd8.Algebra.types.CONSTRUCT:
        case $hSHd8.Algebra.types.DISTINCT:
        case $hSHd8.Algebra.types.REDUCED:
        case $hSHd8.Algebra.types.EXTEND:
        case $hSHd8.Algebra.types.FROM:
        case $hSHd8.Algebra.types.GRAPH:
            return $8f541c88b6ade238$var$estimateCardinality(operation.input, dataset);
        case $hSHd8.Algebra.types.ZERO_OR_ONE_PATH:
        case $hSHd8.Algebra.types.ZERO_OR_MORE_PATH:
        case $hSHd8.Algebra.types.ONE_OR_MORE_PATH:
        case $hSHd8.Algebra.types.INV:
            return $8f541c88b6ade238$var$estimateCardinality(operation.path, dataset);
        case $hSHd8.Algebra.types.PATH:
            return $8f541c88b6ade238$var$estimateCardinality(operation.predicate, dataset);
        case $hSHd8.Algebra.types.NPS:
            return $8f541c88b6ade238$var$estimateNpsCardinality(operation, dataset);
        case $hSHd8.Algebra.types.LINK:
            return $8f541c88b6ade238$var$estimateCardinality($8f541c88b6ade238$var$AF.createPattern($8f541c88b6ade238$var$DF.variable('s'), operation.iri, $8f541c88b6ade238$var$DF.variable('o')), dataset);
        case $hSHd8.Algebra.types.UNION:
        case $hSHd8.Algebra.types.SEQ:
        case $hSHd8.Algebra.types.ALT:
            return $8f541c88b6ade238$var$estimateUnionCardinality(operation.input, dataset);
        case $hSHd8.Algebra.types.BGP:
            return $8f541c88b6ade238$var$estimateJoinCardinality(operation.patterns, dataset);
        case $hSHd8.Algebra.types.JOIN:
        case $hSHd8.Algebra.types.LEFT_JOIN:
            return $8f541c88b6ade238$var$estimateJoinCardinality(operation.input, dataset);
        case $hSHd8.Algebra.types.SLICE:
            return $8f541c88b6ade238$var$estimateSliceCardinality(operation, dataset);
        case $hSHd8.Algebra.types.MINUS:
            return $8f541c88b6ade238$var$estimateMinusCardinality(operation, dataset);
        case $hSHd8.Algebra.types.VALUES:
            return {
                type: 'exact',
                value: operation.bindings.length,
                dataset: dataset.uri
            };
        case $hSHd8.Algebra.types.SERVICE:
        case $hSHd8.Algebra.types.DESCRIBE:
        case $hSHd8.Algebra.types.EXPRESSION:
        case $hSHd8.Algebra.types.PATTERN:
            return {
                type: 'estimate',
                value: Number.POSITIVE_INFINITY,
                dataset: dataset.uri
            };
    }
}
module.exports.estimateCardinality = $8f541c88b6ade238$var$estimateCardinality;
/**
 * Estimate the cardinality of a minus, by taking into account the input cardinalities.
 */ function $8f541c88b6ade238$var$estimateMinusCardinality(minus, dataset) {
    var estimateFirst = $8f541c88b6ade238$var$estimateCardinality(minus.input[0], dataset);
    var estimateSecond = $8f541c88b6ade238$var$estimateCardinality(minus.input[1], dataset);
    return {
        type: 'estimate',
        value: Math.max(estimateFirst.value - estimateSecond.value, 0),
        dataset: dataset.uri
    };
}
module.exports.estimateMinusCardinality = $8f541c88b6ade238$var$estimateMinusCardinality;
/**
 * Estimate the cardinality of a slice operation, taking into account the input cardinality and the slice range.
 */ function $8f541c88b6ade238$var$estimateSliceCardinality(slice, dataset) {
    var estimate = $8f541c88b6ade238$var$estimateCardinality(slice.input, dataset);
    if (estimate.value > 0) {
        estimate.value = Math.max(estimate.value - slice.start, 0);
        if (slice.length !== undefined) estimate.value = Math.min(estimate.value, slice.length);
    }
    return estimate;
}
module.exports.estimateSliceCardinality = $8f541c88b6ade238$var$estimateSliceCardinality;
/**
 * Estimate the cardinality of a union, using a sum of the individual input cardinalities.
 */ function $8f541c88b6ade238$var$estimateUnionCardinality(input, dataset) {
    var estimate = {
        type: 'exact',
        value: 0,
        dataset: dataset.uri
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var operation = _step.value;
            var cardinality = $8f541c88b6ade238$var$estimateCardinality(operation, dataset);
            if (cardinality.type === 'estimate' && estimate.type === 'exact') estimate.type = cardinality.type;
            if (cardinality.value > 0) estimate.value += cardinality.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return estimate;
}
module.exports.estimateUnionCardinality = $8f541c88b6ade238$var$estimateUnionCardinality;
/**
 * Estimate the cardinality of a join. This estimation is done by:
 *  1. Grouping operations together based on variables.
 *  2. Selecting the minimum op cardinality in each group as the cardinality of that group.
 *  3. Multiplying cardinalities of these (detached) groups.
 *
 * This should provide a good balance between selective groups of operations,
 * as well as cartesian joins between groups that do not overlap.
 */ function $8f541c88b6ade238$var$estimateJoinCardinality(operations, dataset) {
    var _Math;
    var operationGroups = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var operation = _step.value;
            var vars = $hSHd8.Util.inScopeVariables(operation).map(function(v) {
                return v.value;
            });
            var group = operationGroups.find(function(g) {
                return vars.some(function(v) {
                    return g.vars.has(v);
                });
            });
            if (group) {
                group.ops.push(operation);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = vars[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var v = _step1.value;
                        group.vars.add(v);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else operationGroups.push({
                ops: [
                    operation
                ],
                vars: new Set(vars)
            });
        };
        for(var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var cardinality = {
        type: 'estimate',
        value: operationGroups.map(function(g) {
            return (_Math = Math).min.apply(_Math, (0, $7WNf6._)(g.ops.map(function(o) {
                return $8f541c88b6ade238$var$estimateCardinality(o, dataset).value;
            })));
        }).reduce(function(acc, cur) {
            return acc * cur;
        }, 1),
        dataset: dataset.uri
    };
    return cardinality;
}
module.exports.estimateJoinCardinality = $8f541c88b6ade238$var$estimateJoinCardinality;
/**
 * Estimate the cardinality of a negated property set, by subtracting the non-inversed
 * estimate from the total number of triples.
 */ function $8f541c88b6ade238$var$estimateNpsCardinality(nps, dataset) {
    var seq = $8f541c88b6ade238$var$AF.createSeq((0, $7WNf6._)(nps.iris).reverse().map(function(iri) {
        return $8f541c88b6ade238$var$AF.createLink(iri);
    }));
    var seqCardinality = $8f541c88b6ade238$var$estimateCardinality(seq, dataset);
    var pattern = $8f541c88b6ade238$var$AF.createPattern($8f541c88b6ade238$var$DF.variable('s'), $8f541c88b6ade238$var$DF.variable('p'), $8f541c88b6ade238$var$DF.variable('o'));
    var patternCardinality = $8f541c88b6ade238$var$estimateCardinality(pattern, dataset);
    return {
        type: 'estimate',
        value: Math.max(0, patternCardinality.value - seqCardinality.value),
        dataset: dataset.uri
    };
}
module.exports.estimateNpsCardinality = $8f541c88b6ade238$var$estimateNpsCardinality;

});

parcelRegister("e8bF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesShapeAcceptOperation = void 0;
/**
 * Check if the given shape accepts the given query operation.
 * @param shape A shape to test the query operation against.
 * @param operation A query operation to test.
 * @param options Additional options to consider.
 * @param options.joinBindings If additional bindings will be pushed down to the source for joining.
 * @param options.filterBindings If additional bindings will be pushed down to the source for filtering.
 */ function $02a7a8b592cf976a$var$doesShapeAcceptOperation(shape, operation, options) {
    return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shape, shape, operation, options);
}
module.exports.doesShapeAcceptOperation = $02a7a8b592cf976a$var$doesShapeAcceptOperation;
function $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeActive, operation, options) {
    // Recurse into the shape
    if (shapeActive.type === 'conjunction') return shapeActive.children.every(function(child) {
        return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, child, operation, options);
    });
    if (shapeActive.type === 'disjunction') return shapeActive.children.some(function(child) {
        return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, child, operation, options);
    });
    if (shapeActive.type === 'arity') return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeActive.child, operation, options);
    var _ref;
    // Validate options
    if ((_ref = (options === null || options === void 0 ? void 0 : options.joinBindings) && !shapeActive.joinBindings) !== null && _ref !== void 0 ? _ref : (options === null || options === void 0 ? void 0 : options.filterBindings) && !shapeActive.filterBindings) return false;
    // Check if the shape's operation matches with the given operation
    var shapeOperation = shapeActive.operation;
    switch(shapeOperation.operationType){
        case 'type':
            if (!$02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options)) return false;
            return shapeOperation.type === operation.type;
        case 'pattern':
            if (!$02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options)) return false;
            return shapeOperation.pattern.type === operation.type;
        case 'wildcard':
            return true;
    }
}
function $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options) {
    // Recurse into the operation, and restart from the top-level shape
    if (operation.input) {
        var inputs = Array.isArray(operation.input) ? operation.input : [
            operation.input
        ];
        if (!inputs.every(function(input) {
            return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeTop, input, options);
        })) return false;
    }
    if (operation.patterns && !operation.patterns.every(function(input) {
        return $02a7a8b592cf976a$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeTop, input, options);
    })) return false;
    return true;
}

});

parcelRegister("f99ML", function(module, exports) {

var $iT0je = parcelRequire("iT0je");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeOperationSource = module.exports.assignOperationSource = module.exports.getOperationSource = module.exports.testReadOnly = module.exports.validateQueryOutput = module.exports.getSafeVoid = module.exports.getSafeBoolean = module.exports.getSafeQuads = module.exports.getSafeBindings = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * Safely cast a query operation output to a bindings output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultBindings} A bindings query operation output.
 */ function $b06f497c4c9cd3b6$var$getSafeBindings(output) {
    $b06f497c4c9cd3b6$var$validateQueryOutput(output, 'bindings');
    return output;
}
module.exports.getSafeBindings = $b06f497c4c9cd3b6$var$getSafeBindings;
/**
 * Safely cast a query operation output to a quads output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultQuads} A quads query operation output.
 */ function $b06f497c4c9cd3b6$var$getSafeQuads(output) {
    $b06f497c4c9cd3b6$var$validateQueryOutput(output, 'quads');
    return output;
}
module.exports.getSafeQuads = $b06f497c4c9cd3b6$var$getSafeQuads;
/**
 * Safely cast a query operation output to a boolean output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultBoolean} A boolean query operation output.
 */ function $b06f497c4c9cd3b6$var$getSafeBoolean(output) {
    $b06f497c4c9cd3b6$var$validateQueryOutput(output, 'boolean');
    return output;
}
module.exports.getSafeBoolean = $b06f497c4c9cd3b6$var$getSafeBoolean;
/**
 * Safely cast a query operation output to a void output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultVoid} A void query operation output.
 */ function $b06f497c4c9cd3b6$var$getSafeVoid(output) {
    $b06f497c4c9cd3b6$var$validateQueryOutput(output, 'void');
    return output;
}
module.exports.getSafeVoid = $b06f497c4c9cd3b6$var$getSafeVoid;
/**
 * Throw an error if the output type does not match the expected type.
 * @param {IQueryOperationResult} output A query operation output.
 * @param {string} expectedType The expected output type.
 */ function $b06f497c4c9cd3b6$var$validateQueryOutput(output, expectedType) {
    if (output.type !== expectedType) throw new Error("Invalid query output type: Expected '".concat(expectedType, "' but got '").concat(output.type, "'"));
}
module.exports.validateQueryOutput = $b06f497c4c9cd3b6$var$validateQueryOutput;
/**
 * Test if the context contains the readOnly flag.
 * @param context An action context.
 */ function $b06f497c4c9cd3b6$var$testReadOnly(context) {
    if (context.get($9nBhR.KeysQueryOperation.readOnly)) return (0, $kNNoa.failTest)("Attempted a write operation in read-only mode");
    return (0, $kNNoa.passTestVoid)();
}
module.exports.testReadOnly = $b06f497c4c9cd3b6$var$testReadOnly;
/**
 * Obtain the query source attached to the given operation.
 * @param operation An algebra operation.
 */ function $b06f497c4c9cd3b6$var$getOperationSource(operation) {
    var _operation_metadata;
    return (_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? void 0 : _operation_metadata.scopedSource;
}
module.exports.getOperationSource = $b06f497c4c9cd3b6$var$getOperationSource;
/**
 * Assign a source wrapper to the given operation.
 * The operation is copied and returned.
 * @param operation An operation.
 * @param source A source wrapper.
 */ function $b06f497c4c9cd3b6$var$assignOperationSource(operation, source) {
    operation = (0, $iT0je._)({}, operation);
    operation.metadata = operation.metadata ? (0, $iT0je._)({}, operation.metadata) : {};
    operation.metadata.scopedSource = source;
    return operation;
}
module.exports.assignOperationSource = $b06f497c4c9cd3b6$var$assignOperationSource;
/**
 * Remove the source wrapper from the given operation.
 * The operation is mutated.
 * @param operation An operation.
 */ function $b06f497c4c9cd3b6$var$removeOperationSource(operation) {
    var _operation_metadata;
    (_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? true : delete _operation_metadata.scopedSource;
    if (operation.metadata && Object.keys(operation.metadata).length === 0) delete operation.metadata;
}
module.exports.removeOperationSource = $b06f497c4c9cd3b6$var$removeOperationSource;

});

parcelRegister("cZ2ZT", function(module, exports) {

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.materializeOperation = module.exports.materializeTerm = void 0;

var $gQYIc = parcelRequire("gQYIc");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * Materialize a term with the given binding.
 *
 * If the given term is a variable,
 * and that variable exist in the given bindings object,
 * the value of that binding is returned.
 * In all other cases, the term itself is returned.
 *
 * @param {RDF.Term} term A term.
 * @param {Bindings} bindings A bindings object.
 * @return {RDF.Term} The materialized term.
 */ function $973d81b7c666a2f7$var$materializeTerm(term, bindings) {
    if (term.termType === 'Variable') {
        var value = bindings.get(term);
        if (value) return value;
    }
    if (term.termType === 'Quad' && (0, $ilNtL.someTermsNested)(term, function(value) {
        return value.termType === 'Variable';
    })) return (0, $ilNtL.mapTermsNested)(term, function(subTerm) {
        return $973d81b7c666a2f7$var$materializeTerm(subTerm, bindings);
    });
    return term;
}
module.exports.materializeTerm = $973d81b7c666a2f7$var$materializeTerm;
/**
 * Materialize the given operation (recursively) with the given bindings.
 * Essentially, the variables in the given operation
 * which don't appear in the projection operation will be replaced
 * by the terms bound to the variables in the given bindings.
 * @param {Algebra.Operation} operation SPARQL algebra operation.
 * And the variables that appear in the projection operation
 * will be added to a new values operation.
 * @param {Bindings} bindings A bindings object.
 * @param algebraFactory The algebra factory.
 * @param bindingsFactory The bindings factory.
 * @param options Options for materializations.
 * @param options.strictTargetVariables If target variable bindings (such as on SELECT or BIND) should not be allowed.
 * @param options.bindFilter If filter expressions should be materialized.
 * @param options.originalBindings The bindings object as it was at the top level call of materializeOperation.
 * @return Algebra.Operation A new operation materialized with the given bindings.
 */ function $973d81b7c666a2f7$var$materializeOperation(operation, bindings, algebraFactory, bindingsFactory) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    options = {
        strictTargetVariables: 'strictTargetVariables' in options ? options.strictTargetVariables : false,
        bindFilter: 'bindFilter' in options ? options.bindFilter : true,
        originalBindings: 'originalBindings' in options ? options.originalBindings : bindings
    };
    return $hSHd8.Util.mapOperation(operation, {
        path: function(op, factory) {
            // Materialize variables in a path expression.
            // The predicate expression will be recursed.
            return {
                recurse: false,
                result: Object.assign(factory.createPath($973d81b7c666a2f7$var$materializeTerm(op.subject, bindings), op.predicate, $973d81b7c666a2f7$var$materializeTerm(op.object, bindings), $973d81b7c666a2f7$var$materializeTerm(op.graph, bindings)), {
                    metadata: op.metadata
                })
            };
        },
        pattern: function(op, factory) {
            // Materialize variables in the quad pattern.
            return {
                recurse: false,
                result: Object.assign(factory.createPattern($973d81b7c666a2f7$var$materializeTerm(op.subject, bindings), $973d81b7c666a2f7$var$materializeTerm(op.predicate, bindings), $973d81b7c666a2f7$var$materializeTerm(op.object, bindings), $973d81b7c666a2f7$var$materializeTerm(op.graph, bindings)), {
                    metadata: op.metadata
                })
            };
        },
        join: function(op, factory) {
            // Materialize join operation, and ensure metadata is taken into account.
            // Join entries with metadata should not be flattened.
            return {
                recurse: false,
                result: factory.createJoin(op.input.map(function(input) {
                    return $973d81b7c666a2f7$var$materializeOperation(input, bindings, algebraFactory, bindingsFactory, options);
                }), op.input.every(function(input) {
                    return !input.metadata;
                }))
            };
        },
        extend: function(op) {
            // Materialize an extend operation.
            // If strictTargetVariables is true, we throw if the extension target variable is attempted to be bound.
            // Otherwise, we remove the extend operation.
            if (bindings.has(op.variable)) {
                if (options.strictTargetVariables) throw new Error("Tried to bind variable ".concat((0, $gQYIc.termToString)(op.variable), " in a BIND operator."));
                else return {
                    recurse: true,
                    result: $973d81b7c666a2f7$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options)
                };
            }
            return {
                recurse: true,
                result: op
            };
        },
        group: function(op, factory) {
            // Materialize a group operation.
            // If strictTargetVariables is true, we throw if the group target variable is attempted to be bound.
            // Otherwise, we just filter out the bound variables.
            if (options.strictTargetVariables) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = op.variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var variable = _step.value;
                        if (bindings.has(variable)) throw new Error("Tried to bind variable ".concat((0, $gQYIc.termToString)(variable), " in a GROUP BY operator."));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    recurse: true,
                    result: op
                };
            }
            var variables = op.variables.filter(function(variable) {
                return !bindings.has(variable);
            });
            return {
                recurse: true,
                result: factory.createGroup(op.input, variables, op.aggregates)
            };
        },
        filter: function(op, factory) {
            var originalBindings = options.originalBindings;
            if (op.expression.expressionType !== 'operator' || originalBindings.size === 0) return {
                recurse: false,
                result: op
            };
            // Make a values clause using all the variables from originalBindings.
            var values = $973d81b7c666a2f7$var$createValuesFromBindings(factory, originalBindings);
            // Recursively materialize the filter expression
            var recursionResultExpression = $973d81b7c666a2f7$var$materializeOperation(op.expression, bindings, algebraFactory, bindingsFactory, options);
            // Recursively materialize the filter input
            var recursionResultInput = $973d81b7c666a2f7$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options);
            if (values.length > 0) recursionResultInput = factory.createJoin((0, $7WNf6._)(values).concat([
                recursionResultInput
            ]));
            return {
                // Recursion already taken care of above.
                recurse: false,
                result: factory.createFilter(recursionResultInput, recursionResultExpression)
            };
        },
        project: function(op, factory) {
            // Materialize a project operation.
            // Find projected variables which are present in the originalBindings.
            // This will result in projected variables being handled via a values clause.
            var values = $973d81b7c666a2f7$var$createValuesFromBindings(factory, options.originalBindings, op.variables);
            var recursionResult = $973d81b7c666a2f7$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options);
            if (values.length > 0) recursionResult = factory.createJoin((0, $7WNf6._)(values).concat([
                recursionResult
            ]));
            return {
                recurse: false,
                result: factory.createProject(recursionResult, op.variables)
            };
        },
        values: function(op, factory) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            // Materialize a values operation.
            // If strictTargetVariables is true, we throw if the values target variable is attempted to be bound.
            // Otherwise, we just filter out the bound variables and their bindings.
            if (options.strictTargetVariables) try {
                for(var _iterator = op.variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var variable = _step.value;
                    if (bindings.has(variable)) throw new Error("Tried to bind variable ".concat((0, $gQYIc.termToString)(variable), " in a VALUES operator."));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else {
                var variables = op.variables.filter(function(variable) {
                    return !bindings.has(variable);
                });
                var valueBindings = op.bindings.map(function(binding) {
                    var newBinding = (0, $iT0je._)({}, binding);
                    var valid = true;
                    // eslint-disable-next-line unicorn/no-array-for-each
                    bindings.forEach(function(value, key) {
                        var keyString = (0, $gQYIc.termToString)(key);
                        if (keyString in newBinding) {
                            if (!value.equals(newBinding[keyString])) // If the value of the binding is not equal, remove this binding completely from the VALUES clause
                            valid = false;
                            delete newBinding[keyString];
                        }
                    });
                    return valid ? newBinding : undefined;
                }).filter(Boolean);
                return {
                    recurse: true,
                    result: factory.createValues(variables, valueBindings)
                };
            }
            return {
                recurse: false,
                result: op
            };
        },
        expression: function(op, factory) {
            if (!options.bindFilter) return {
                recurse: false,
                result: op
            };
            if (op.expressionType === 'term') // Materialize a term expression
            return {
                recurse: false,
                result: factory.createTermExpression($973d81b7c666a2f7$var$materializeTerm(op.term, bindings))
            };
            if (op.expressionType === 'operator') {
                if (op.operator === 'bound' && op.args.length === 1 && op.args[0].expressionType === 'term' && (0, $7WNf6._)(bindings.keys()).some(function(variable) {
                    return op.args[0].term.equals(variable);
                })) return {
                    recurse: false,
                    result: factory.createTermExpression(factory.dataFactory.literal('true', factory.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')))
                };
                return {
                    recurse: true,
                    result: op
                };
            }
            if (op.expressionType === 'aggregate' && 'variable' in op && bindings.has(op.variable)) {
                // Materialize a bound aggregate operation.
                // If strictTargetVariables is true, we throw if the expression target variable is attempted to be bound.
                // Otherwise, we ignore this operation.
                if (options.strictTargetVariables) throw new Error("Tried to bind ".concat((0, $gQYIc.termToString)(op.variable), " in a ").concat(op.aggregator, " aggregate."));
                else return {
                    recurse: true,
                    result: op
                };
            }
            return {
                recurse: true,
                result: op
            };
        }
    }, algebraFactory);
}
module.exports.materializeOperation = $973d81b7c666a2f7$var$materializeOperation;
/**
 * Make a values operation containing the values that are present in `bindings` for variables present in `variables`.
 * If no `variables` argument is given, this method returns a values operation
 * containing every binding from `bindings`.
 * @param {Factory} factory The Factory used to create the values operation.
 * @param {Bindings} bindings A bindings object.
 * @param {Variable[]} variables A list of variables.
 * @returns Algebra.Values A new values operation the given bindings.
 */ function $973d81b7c666a2f7$var$createValuesFromBindings(factory, bindings, variables) {
    var values = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $32TW8._)(_step.value, 2), variable = _step_value[0], binding = _step_value[1];
            if (!variables || variables.some(function(v) {
                return v.equals(variable);
            })) {
                var newBinding = (0, $cqEAj._)({}, (0, $gQYIc.termToString)(variable), binding);
                values.push(factory.createValues([
                    variable
                ], [
                    newBinding
                ]));
            }
        };
        for(var _iterator = bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
}

});




parcelRegister("jxoZy", function(module, exports) {
"use strict";
var $e3947c3f634a9a1e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3947c3f634a9a1e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3947c3f634a9a1e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3947c3f634a9a1e$var$__exportStar((parcelRequire("gpqiX")), module.exports);

});
parcelRegister("gpqiX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationConstructDistinct = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $kMAHP = parcelRequire("kMAHP");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Construct Distinct Optimize Query Operation Actor.
 */ var $bf2362b1df773660$var$ActorOptimizeQueryOperationConstructDistinct = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationConstructDistinct, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationConstructDistinct(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationConstructDistinct);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationConstructDistinct, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationConstructDistinct, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.context.has($kMAHP.KeysInitQuery.distinctConstruct)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " was not enabled by the query."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        operation = $hSHd8.Util.mapOperation(action.operation, {
                            construct: function(op, factory) {
                                return {
                                    recurse: false,
                                    result: factory.createDistinct(factory.createConstruct(op.input, op.template))
                                };
                            }
                        });
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context["delete"]($kMAHP.KeysInitQuery.distinctConstruct)
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationConstructDistinct;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationConstructDistinct = $bf2362b1df773660$var$ActorOptimizeQueryOperationConstructDistinct;

});


parcelRegister("iWUon", function(module, exports) {
"use strict";
var $dcb96319f3201b76$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcb96319f3201b76$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dcb96319f3201b76$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dcb96319f3201b76$var$__exportStar((parcelRequire("1U8jA")), module.exports);

});
parcelRegister("1U8jA", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParseSparql = void 0;

var $lSPbm = parcelRequire("lSPbm");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");

var $2h2ox = parcelRequire("2h2ox");
/**
 * A comunica Algebra SPARQL Parse Actor.
 */ var $16317899b7857993$var$ActorQueryParseSparql = /*#__PURE__*/ function(_bus_query_parse_1_ActorQueryParse) {
    (0, $i3fW3._)(ActorQueryParseSparql, _bus_query_parse_1_ActorQueryParse);
    function ActorQueryParseSparql(args) {
        (0, $jGAMp._)(this, ActorQueryParseSparql);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryParseSparql, [
            args
        ]);
        _this.prefixes = Object.freeze(_this.prefixes);
        return _this;
    }
    (0, $byiyg._)(ActorQueryParseSparql, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.queryFormat && action.queryFormat.language !== 'sparql') return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only parse SPARQL queries')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, parser, parsedSyntax, baseIRI;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        parser = new $2h2ox.Parser({
                            prefixes: this.prefixes,
                            baseIRI: action.baseIRI,
                            sparqlStar: true,
                            factory: dataFactory
                        });
                        parsedSyntax = parser.parse(action.query);
                        baseIRI = parsedSyntax.type === 'query' ? parsedSyntax.base : undefined;
                        return [
                            2,
                            {
                                baseIRI: baseIRI,
                                operation: (0, $hSHd8.translate)(parsedSyntax, {
                                    quads: true,
                                    prefixes: this.prefixes,
                                    blankToVariable: true,
                                    baseIRI: action.baseIRI,
                                    dataFactory: dataFactory
                                })
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryParseSparql;
}($lSPbm.ActorQueryParse);
module.exports.ActorQueryParseSparql = $16317899b7857993$var$ActorQueryParseSparql;

});
parcelRegister("lSPbm", function(module, exports) {
"use strict";
var $fee657d91c6f56d0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fee657d91c6f56d0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fee657d91c6f56d0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fee657d91c6f56d0$var$__exportStar((parcelRequire("9VXsN")), module.exports);

});
parcelRegister("9VXsN", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParse = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for query-parse events.
 *
 * Actor types:
 * * Input:  IActionSparqlParse:      A SPARQL query string.
 * * Test:   <none>
 * * Output: IActorSparqlParseOutput: A parsed query in SPARQL query algebra.
 *
 * @see IActionQueryParse
 * @see IActorQueryParseOutput
 */ var $73b79020c40a0cd7$var$ActorQueryParse = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorQueryParse, _core_1_Actor);
    function ActorQueryParse(args) {
        (0, $jGAMp._)(this, ActorQueryParse);
        return (0, $kzDuW._)(this, ActorQueryParse, [
            args
        ]);
    }
    return ActorQueryParse;
}($kNNoa.Actor);
module.exports.ActorQueryParse = $73b79020c40a0cd7$var$ActorQueryParse;

});




parcelRegister("5d2MZ", function(module, exports) {
"use strict";
var $3cb0547f259399af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3cb0547f259399af$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3cb0547f259399af$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3cb0547f259399af$var$__exportStar((parcelRequire("9gowO")), module.exports);

});
parcelRegister("9gowO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParseGraphql = void 0;

var $lSPbm = parcelRequire("lSPbm");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $d9suX = parcelRequire("d9suX");
/**
 * A comunica GraphQL SPARQL Parse Actor.
 */ var $6be8a27a3d03b6a5$var$ActorQueryParseGraphql = /*#__PURE__*/ function(_bus_query_parse_1_ActorQueryParse) {
    (0, $i3fW3._)(ActorQueryParseGraphql, _bus_query_parse_1_ActorQueryParse);
    function ActorQueryParseGraphql(args) {
        (0, $jGAMp._)(this, ActorQueryParseGraphql);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryParseGraphql, [
            args
        ]);
        _this.graphqlToSparql = new $d9suX.Converter({
            requireContext: true
        });
        return _this;
    }
    (0, $byiyg._)(ActorQueryParseGraphql, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_queryFormat;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (((_action_queryFormat = action.queryFormat) === null || _action_queryFormat === void 0 ? void 0 : _action_queryFormat.language) !== 'graphql') return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only parse GraphQL queries')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var context, options, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = action.context.get($9nBhR.KeysInitQuery.jsonLdContext) || {};
                                options = {
                                    // eslint-disable-next-line ts/no-unnecessary-type-assertion
                                    singularizeVariables: action.context.get($9nBhR.KeysInitQuery.graphqlSingularizeVariables)
                                };
                                _tmp = {};
                                return [
                                    4,
                                    this.graphqlToSparql.graphqlToSparqlAlgebra(action.query, context, options)
                                ];
                            case 1:
                                // TODO: pass data factory
                                return [
                                    2,
                                    (_tmp.operation = _state.sent(), _tmp)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryParseGraphql;
}($lSPbm.ActorQueryParse);
module.exports.ActorQueryParseGraphql = $6be8a27a3d03b6a5$var$ActorQueryParseGraphql;

});
parcelRegister("d9suX", function(module, exports) {
"use strict";
var $02788d4da458481e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $02788d4da458481e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $02788d4da458481e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$02788d4da458481e$var$__exportStar((parcelRequire("jIPpf")), module.exports);

$02788d4da458481e$var$__exportStar((parcelRequire("kPBE2")), module.exports);

$02788d4da458481e$var$__exportStar((parcelRequire("49Vd9")), module.exports);

$02788d4da458481e$var$__exportStar((parcelRequire("cFhok")), module.exports);

$02788d4da458481e$var$__exportStar((parcelRequire("7oPrC")), module.exports);

});
parcelRegister("jIPpf", function(module, exports) {
"use strict";
var $e5ba0097209f8268$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5ba0097209f8268$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5ba0097209f8268$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5ba0097209f8268$var$__exportStar((parcelRequire("85LSR")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("acUgZ")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("2xD54")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("4V2Bk")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("6uT5a")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("kVFKE")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("Ht2sP")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("3iiJQ")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("3bWYD")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("gLr1c")), module.exports);

$e5ba0097209f8268$var$__exportStar((parcelRequire("ejkbA")), module.exports);

});
parcelRegister("85LSR", function(module, exports) {
"use strict";
var $5e43ef1aa742cdd4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e43ef1aa742cdd4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5e43ef1aa742cdd4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("iUNHO")), module.exports);

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("a9vYg")), module.exports);

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("rfry7")), module.exports);

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("1XOH2")), module.exports);

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("1RzoB")), module.exports);

$5e43ef1aa742cdd4$var$__exportStar((parcelRequire("4ap3Q")), module.exports);

});
parcelRegister("iUNHO", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerAdapter = void 0;
/**
 * An abstract handler for GraphQL directives.
 */ var $038dbdfdc83f9399$var$DirectiveNodeHandlerAdapter = /*#__PURE__*/ function() {
    function DirectiveNodeHandlerAdapter(targetKind, util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerAdapter);
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
    (0, $byiyg._)(DirectiveNodeHandlerAdapter, [
        {
            /**
     * Get the value of the 'if' argument in a directive.
     * @param {DirectiveNode} directive A directive.
     * @param {IConvertContext} convertContext A convert context.
     * @return {Term} The term.
     */ key: "getDirectiveConditionalValue",
            value: function getDirectiveConditionalValue(directive, convertContext) {
                var arg = this.util.getArgument(directive["arguments"], 'if');
                if (!arg) throw new Error("The directive ".concat(directive.name.value, " is missing an if-argument."));
                var subValue = this.util.handleNodeValue(arg.value, arg.name.value, convertContext);
                if (subValue.terms.length !== 1) throw new Error("Can not apply the directive ".concat(directive.name.value, " with a list."));
                return subValue.terms[0];
            }
        },
        {
            /**
     * If a `scope: all` directive param is present.
     * @param {DirectiveNode} directive A directive.
     * @return {boolean} If `scope: all` is present.
     */ key: "isDirectiveScopeAll",
            value: function isDirectiveScopeAll(directive) {
                var scopeArg = this.util.getArgument(directive["arguments"], 'scope');
                return scopeArg && scopeArg.value.kind === 'EnumValue' && scopeArg.value.value === 'all';
            }
        }
    ]);
    return DirectiveNodeHandlerAdapter;
}();
module.exports.DirectiveNodeHandlerAdapter = $038dbdfdc83f9399$var$DirectiveNodeHandlerAdapter;

});

parcelRegister("a9vYg", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerInclude = void 0;

var $iUNHO = parcelRequire("iUNHO");
/**
 * A handler for include directives.
 */ var $76438b6c77e7145a$var$DirectiveNodeHandlerInclude = /*#__PURE__*/ function(_DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter) {
    (0, $i3fW3._)(DirectiveNodeHandlerInclude, _DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter);
    function DirectiveNodeHandlerInclude(util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerInclude);
        return (0, $kzDuW._)(this, DirectiveNodeHandlerInclude, [
            'include',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(DirectiveNodeHandlerInclude, [
        {
            key: "handle",
            value: function handle(directiveContext, convertContext) {
                var val = this.getDirectiveConditionalValue(directiveContext.directive, convertContext);
                if (val.termType === 'Literal' && val.value === 'false') return {
                    ignore: true
                };
                return {};
            }
        }
    ]);
    return DirectiveNodeHandlerInclude;
}($iUNHO.DirectiveNodeHandlerAdapter);
module.exports.DirectiveNodeHandlerInclude = $76438b6c77e7145a$var$DirectiveNodeHandlerInclude;

});

parcelRegister("rfry7", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerOptional = void 0;

var $iUNHO = parcelRequire("iUNHO");
/**
 * A handler for optional directives.
 */ var $051e807509fea58f$var$DirectiveNodeHandlerOptional = /*#__PURE__*/ function(_DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter) {
    (0, $i3fW3._)(DirectiveNodeHandlerOptional, _DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter);
    function DirectiveNodeHandlerOptional(util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerOptional);
        return (0, $kzDuW._)(this, DirectiveNodeHandlerOptional, [
            'optional',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(DirectiveNodeHandlerOptional, [
        {
            key: "handle",
            value: function handle(directiveContext, convertContext) {
                var _this = this;
                return {
                    operationOverrider: function(operation) {
                        return _this.util.operationFactory.createLeftJoin(_this.util.operationFactory.createBgp([]), operation);
                    }
                };
            }
        }
    ]);
    return DirectiveNodeHandlerOptional;
}($iUNHO.DirectiveNodeHandlerAdapter);
module.exports.DirectiveNodeHandlerOptional = $051e807509fea58f$var$DirectiveNodeHandlerOptional;

});

parcelRegister("1XOH2", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerPlural = void 0;

var $49Vd9 = parcelRequire("49Vd9");

var $iUNHO = parcelRequire("iUNHO");
/**
 * A handler for plural directives.
 */ var $16e29fbf7f093b60$var$DirectiveNodeHandlerPlural = /*#__PURE__*/ function(_DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter) {
    (0, $i3fW3._)(DirectiveNodeHandlerPlural, _DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter);
    function DirectiveNodeHandlerPlural(util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerPlural);
        return (0, $kzDuW._)(this, DirectiveNodeHandlerPlural, [
            'plural',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(DirectiveNodeHandlerPlural, [
        {
            key: "handle",
            value: function handle(directiveContext, convertContext) {
                if (this.isDirectiveScopeAll(directiveContext.directive)) convertContext.singularizeState = $49Vd9.SingularizeState.PLURAL;
                // Delete the existing entry, as this may have already been set before if we were in a single scope.
                delete convertContext.singularizeVariables[this.util.nameToVariable(directiveContext.fieldLabel, convertContext).value];
                return {};
            }
        }
    ]);
    return DirectiveNodeHandlerPlural;
}($iUNHO.DirectiveNodeHandlerAdapter);
module.exports.DirectiveNodeHandlerPlural = $16e29fbf7f093b60$var$DirectiveNodeHandlerPlural;

});
parcelRegister("49Vd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingularizeState = void 0;
/**
 * A singularization state for variable values.
 */ var $307461a47128e534$var$SingularizeState;
(function(SingularizeState) {
    /**
     * If only a first matching value should be picked.
     */ SingularizeState[SingularizeState["SINGLE"] = 0] = "SINGLE";
    /**
     * If all matching values should be picked.
     */ SingularizeState[SingularizeState["PLURAL"] = 1] = "PLURAL";
})($307461a47128e534$var$SingularizeState = module.exports.SingularizeState || (module.exports.SingularizeState = {}));

});


parcelRegister("1RzoB", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerSingle = void 0;

var $49Vd9 = parcelRequire("49Vd9");

var $iUNHO = parcelRequire("iUNHO");
/**
 * A handler for single directives.
 */ var $15b6328f8d53fba3$var$DirectiveNodeHandlerSingle = /*#__PURE__*/ function(_DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter) {
    (0, $i3fW3._)(DirectiveNodeHandlerSingle, _DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter);
    function DirectiveNodeHandlerSingle(util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerSingle);
        return (0, $kzDuW._)(this, DirectiveNodeHandlerSingle, [
            'single',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(DirectiveNodeHandlerSingle, [
        {
            key: "handle",
            value: function handle(directiveContext, convertContext) {
                if (this.isDirectiveScopeAll(directiveContext.directive)) convertContext.singularizeState = $49Vd9.SingularizeState.SINGLE;
                convertContext.singularizeVariables[this.util.nameToVariable(directiveContext.fieldLabel, convertContext).value] = true;
                return {};
            }
        }
    ]);
    return DirectiveNodeHandlerSingle;
}($iUNHO.DirectiveNodeHandlerAdapter);
module.exports.DirectiveNodeHandlerSingle = $15b6328f8d53fba3$var$DirectiveNodeHandlerSingle;

});

parcelRegister("4ap3Q", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerSkip = void 0;

var $iUNHO = parcelRequire("iUNHO");
/**
 * A handler for skip directives.
 */ var $308b89368f9ce5c8$var$DirectiveNodeHandlerSkip = /*#__PURE__*/ function(_DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter) {
    (0, $i3fW3._)(DirectiveNodeHandlerSkip, _DirectiveNodeHandlerAdapter_1_DirectiveNodeHandlerAdapter);
    function DirectiveNodeHandlerSkip(util, settings) {
        (0, $jGAMp._)(this, DirectiveNodeHandlerSkip);
        return (0, $kzDuW._)(this, DirectiveNodeHandlerSkip, [
            'skip',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(DirectiveNodeHandlerSkip, [
        {
            key: "handle",
            value: function handle(directiveContext, convertContext) {
                var val = this.getDirectiveConditionalValue(directiveContext.directive, convertContext);
                if (val.termType === 'Literal' && val.value === 'true') return {
                    ignore: true
                };
                return {};
            }
        }
    ]);
    return DirectiveNodeHandlerSkip;
}($iUNHO.DirectiveNodeHandlerAdapter);
module.exports.DirectiveNodeHandlerSkip = $308b89368f9ce5c8$var$DirectiveNodeHandlerSkip;

});


parcelRegister("acUgZ", function(module, exports) {
"use strict";
var $76e6ad02ee1ba301$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $76e6ad02ee1ba301$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $76e6ad02ee1ba301$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("6yU2K")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("4YPjv")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("6BtIY")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("4qHeM")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("fl8UE")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("03o5r")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("9QW1I")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("j0peG")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("jyMqd")), module.exports);

$76e6ad02ee1ba301$var$__exportStar((parcelRequire("cxnPp")), module.exports);

});
parcelRegister("6yU2K", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerAdapter = void 0;
/**
 * A handler for converting GraphQL value nodes to terms and patterns.
 */ var $4c7164171fc9c410$var$NodeValueHandlerAdapter = function NodeValueHandlerAdapter(targetKind, util, settings) {
    (0, $jGAMp._)(this, NodeValueHandlerAdapter);
    this.targetKind = targetKind;
    this.util = util;
    this.settings = settings;
};
module.exports.NodeValueHandlerAdapter = $4c7164171fc9c410$var$NodeValueHandlerAdapter;

});

parcelRegister("4YPjv", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerBoolean = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL booleans to RDF boolean terms.
 */ var $3a0491d39897c7f2$var$NodeValueHandlerBoolean = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerBoolean, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerBoolean(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerBoolean);
        var _this;
        _this = (0, $kzDuW._)(this, NodeValueHandlerBoolean, [
            'BooleanValue',
            util,
            settings
        ]);
        _this.datatype = _this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#boolean');
        return _this;
    }
    (0, $byiyg._)(NodeValueHandlerBoolean, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                return {
                    terms: [
                        this.util.dataFactory.literal(valueNode.value ? 'true' : 'false', this.datatype)
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerBoolean;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerBoolean = $3a0491d39897c7f2$var$NodeValueHandlerBoolean;

});

parcelRegister("6BtIY", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerEnum = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL enums to RDF named nodes.
 */ var $4ced4165f895df34$var$NodeValueHandlerEnum = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerEnum, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerEnum(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerEnum);
        return (0, $kzDuW._)(this, NodeValueHandlerEnum, [
            'EnumValue',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeValueHandlerEnum, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                return {
                    terms: [
                        this.util.valueToNamedNode(valueNode.value, convertContext.context)
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerEnum;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerEnum = $4ced4165f895df34$var$NodeValueHandlerEnum;

});

parcelRegister("4qHeM", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerFloat = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL floats to RDF float terms.
 */ var $339b2130316b9143$var$NodeValueHandlerFloat = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerFloat, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerFloat(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerFloat);
        var _this;
        _this = (0, $kzDuW._)(this, NodeValueHandlerFloat, [
            'FloatValue',
            util,
            settings
        ]);
        _this.datatype = _this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#float');
        return _this;
    }
    (0, $byiyg._)(NodeValueHandlerFloat, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                return {
                    terms: [
                        this.util.dataFactory.literal(valueNode.value, this.datatype)
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerFloat;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerFloat = $339b2130316b9143$var$NodeValueHandlerFloat;

});

parcelRegister("fl8UE", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerInt = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL ints to RDF integer terms.
 */ var $b2afbb0bb89a88b7$var$NodeValueHandlerInt = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerInt, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerInt(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerInt);
        var _this;
        _this = (0, $kzDuW._)(this, NodeValueHandlerInt, [
            'IntValue',
            util,
            settings
        ]);
        _this.datatype = _this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#integer');
        return _this;
    }
    (0, $byiyg._)(NodeValueHandlerInt, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                return {
                    terms: [
                        this.util.dataFactory.literal(valueNode.value, this.datatype)
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerInt;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerInt = $b2afbb0bb89a88b7$var$NodeValueHandlerInt;

});

parcelRegister("03o5r", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerList = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL lists to RDF lists if settings.arraysToRdfLists is true, otherwise it converts to multiple values.
 */ var $00a2f70c224b6a7f$var$NodeValueHandlerList = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerList, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerList(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerList);
        var _this;
        _this = (0, $kzDuW._)(this, NodeValueHandlerList, [
            'ListValue',
            util,
            settings
        ]);
        _this.nodeFirst = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first');
        _this.nodeRest = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest');
        _this.nodeNil = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
        return _this;
    }
    (0, $byiyg._)(NodeValueHandlerList, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                var listTerms = [];
                var auxiliaryPatterns = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create terms for list values
                    for(var _iterator = valueNode.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var v = _step.value;
                        var subValue = this.util.handleNodeValue(v, fieldName, convertContext);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = subValue.terms[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var term = _step1.value;
                                listTerms.push(term);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (subValue.auxiliaryPatterns) auxiliaryPatterns = auxiliaryPatterns.concat(subValue.auxiliaryPatterns);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.settings.arraysToRdfLists) {
                    // Convert array to RDF list
                    // Create chained list structure
                    var firstListNode = this.util.dataFactory.blankNode();
                    var listNode = firstListNode;
                    var remaining = listTerms.length;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = listTerms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var term1 = _step2.value;
                            auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeFirst, term1, convertContext.graph));
                            var nextListNode = --remaining === 0 ? this.nodeNil : this.util.dataFactory.blankNode();
                            auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeRest, nextListNode, convertContext.graph));
                            listNode = nextListNode;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                _iterator2["return"]();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    return {
                        terms: [
                            firstListNode
                        ],
                        auxiliaryPatterns: auxiliaryPatterns
                    };
                } else // Convert array to multiple terms that will be linked via the same predicate.
                return {
                    terms: listTerms,
                    auxiliaryPatterns: auxiliaryPatterns
                };
            }
        }
    ]);
    return NodeValueHandlerList;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerList = $00a2f70c224b6a7f$var$NodeValueHandlerList;

});

parcelRegister("9QW1I", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerNull = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL nulls to RDF nil terms.
 */ var $72c5fb429ddb46ae$var$NodeValueHandlerNull = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerNull, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerNull(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerNull);
        var _this;
        _this = (0, $kzDuW._)(this, NodeValueHandlerNull, [
            'NullValue',
            util,
            settings
        ]);
        _this.nil = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
        return _this;
    }
    (0, $byiyg._)(NodeValueHandlerNull, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                return {
                    terms: [
                        this.nil
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerNull;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerNull = $72c5fb429ddb46ae$var$NodeValueHandlerNull;

});

parcelRegister("j0peG", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerObject = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL objects to triple patterns by converting keys to predicates and values to objects.
 */ var $dd6197b97bee2962$var$NodeValueHandlerObject = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerObject, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerObject(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerObject);
        return (0, $kzDuW._)(this, NodeValueHandlerObject, [
            'ObjectValue',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeValueHandlerObject, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                // Convert object keys to predicates and values to objects, and link them both with a new blank node.
                var subject = this.util.dataFactory.blankNode();
                var auxiliaryObjectPatterns = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = valueNode.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var field = _step.value;
                        var subValue = this.util.handleNodeValue(field.value, fieldName, convertContext);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = subValue.terms[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var term = _step1.value;
                                auxiliaryObjectPatterns.push(this.util.createQuadPattern(subject, field.name, term, convertContext.graph, convertContext.context));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (subValue.auxiliaryPatterns) auxiliaryObjectPatterns = auxiliaryObjectPatterns.concat(subValue.auxiliaryPatterns);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    terms: [
                        subject
                    ],
                    auxiliaryPatterns: auxiliaryObjectPatterns
                };
            }
        }
    ]);
    return NodeValueHandlerObject;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerObject = $dd6197b97bee2962$var$NodeValueHandlerObject;

});

parcelRegister("jyMqd", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerString = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL strings to RDF string terms, which can have a custom language or datatype.
 */ var $e3d6c0d6d4a02a93$var$NodeValueHandlerString = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerString, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerString(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerString);
        return (0, $kzDuW._)(this, NodeValueHandlerString, [
            'StringValue',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeValueHandlerString, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                var contextEntry = convertContext.context.getContextRaw()[fieldName];
                var language;
                var datatype;
                if (contextEntry && typeof contextEntry !== 'string') {
                    if (contextEntry['@language']) language = contextEntry['@language'];
                    else if (contextEntry['@type']) datatype = this.util.dataFactory.namedNode(contextEntry['@type']);
                }
                return {
                    terms: [
                        this.util.dataFactory.literal(valueNode.value, language || datatype)
                    ]
                };
            }
        }
    ]);
    return NodeValueHandlerString;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerString = $e3d6c0d6d4a02a93$var$NodeValueHandlerString;

});

parcelRegister("cxnPp", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerVariable = void 0;

var $6yU2K = parcelRequire("6yU2K");
/**
 * Converts GraphQL variables to terms based on the contents of the variablesDict.
 */ var $920b0cdf08aca9f3$var$NodeValueHandlerVariable = /*#__PURE__*/ function(_NodeValueHandlerAdapter_1_NodeValueHandlerAdapter) {
    (0, $i3fW3._)(NodeValueHandlerVariable, _NodeValueHandlerAdapter_1_NodeValueHandlerAdapter);
    function NodeValueHandlerVariable(util, settings) {
        (0, $jGAMp._)(this, NodeValueHandlerVariable);
        return (0, $kzDuW._)(this, NodeValueHandlerVariable, [
            'Variable',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeValueHandlerVariable, [
        {
            key: "handle",
            value: function handle(valueNode, fieldName, convertContext) {
                var id = valueNode.name.value;
                var value = convertContext.variablesDict[id];
                var meta = convertContext.variablesMetaDict[id];
                // Handle missing values
                if (!value) {
                    if (!convertContext.ignoreUnknownVariables && (!meta || meta.mandatory)) throw new Error("Undefined variable: ".concat(id));
                    else {
                        var variable = this.util.dataFactory.variable(id);
                        if (convertContext.terminalVariables.map(function(v) {
                            return v.value;
                        }).indexOf(id) < 0) convertContext.terminalVariables.push(variable);
                        return {
                            terms: [
                                variable
                            ]
                        };
                    }
                }
                // Don't allow variables that refer to other variables
                if (value.kind === 'Variable') throw new Error("Variable refers to another variable: ".concat(id));
                if (meta) {
                    // Check the type
                    if (meta.list) {
                        // If we expect a list, check if we got a list.
                        if (value.kind !== 'ListValue') throw new Error("Expected a list, but got ".concat(value.kind, " for ").concat(id));
                        // Check the type in the list
                        if (meta.type) {
                            var listValue = value;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = listValue.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var v = _step.value;
                                    if (v.kind !== meta.type) throw new Error("Expected ".concat(meta.type, ", but got ").concat(v.kind, " for ").concat(id));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } else meta.type;
                }
                return this.util.handleNodeValue(value, fieldName, convertContext);
            }
        }
    ]);
    return NodeValueHandlerVariable;
}($6yU2K.NodeValueHandlerAdapter);
module.exports.NodeValueHandlerVariable = $920b0cdf08aca9f3$var$NodeValueHandlerVariable;

});


parcelRegister("2xD54", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerAdapter = void 0;
/**
 * A handler for converting GraphQL nodes to operations.
 */ var $1d9cfa78ddc21e05$var$NodeHandlerAdapter = /*#__PURE__*/ function() {
    function NodeHandlerAdapter(targetKind, util, settings) {
        (0, $jGAMp._)(this, NodeHandlerAdapter);
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
    (0, $byiyg._)(NodeHandlerAdapter, [
        {
            /* ----- Node quad context ----- */ /**
     * Get the quad context of a selection set node that should be used for the whole definition node.
     *
     * This is a pre-processing step of selection sets.
     * Its only purpose is to determine the subject within a selection set,
     * because this subject is needed to link with its parent.
     * In a later phase, the selection set will be processed using the discovered subject,
     * and the field identifying the subject will be ignored.
     *
     * @param {SelectionSetNode} selectionSet A selection set node.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject, graph and auxiliary patterns.
     */ key: "getNodeQuadContextSelectionSet",
            value: function getNodeQuadContextSelectionSet(selectionSet, fieldLabel, convertContext) {
                var nodeQuadContext = {};
                if (selectionSet) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = selectionSet.selections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var selectionNode = _step.value;
                            if (selectionNode.kind === 'Field') {
                                var fieldNode = selectionNode;
                                this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'id', 'subject');
                                this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'graph', 'graph');
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return nodeQuadContext;
            }
        },
        {
            /**
     * Handles a single field for determining the node quad context.
     * @param {FieldNode} fieldNode A field node.
     * @param {IConvertContext} convertContext A convert context.
     * @param {INodeQuadContext} nodeQuadContext The node quad context to populate.
     * @param {string} fieldName The field name to check for.
     * @param {'subject' | 'graph'} nodeQuadContextKey The key to fill into the node quad context.
     */ key: "handleNodeQuadContextField",
            value: function handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, fieldName, nodeQuadContextKey) {
                if (!nodeQuadContext[nodeQuadContextKey] && fieldNode.name.value === fieldName) {
                    // Get (or set) the nodeQuadContextKey for fieldName fields
                    if (!nodeQuadContext[nodeQuadContextKey]) {
                        var argument = this.util.getArgument(fieldNode["arguments"], '_');
                        if (argument) {
                            var valueOutput = this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
                            if (valueOutput.terms.length !== 1) throw new Error("Only single values can be set as ".concat(fieldName, ", but got ").concat(valueOutput.terms.length, " at ").concat(fieldNode.name.value));
                            nodeQuadContext[nodeQuadContextKey] = valueOutput.terms[0];
                            if (valueOutput.auxiliaryPatterns) {
                                if (!nodeQuadContext.auxiliaryPatterns) nodeQuadContext.auxiliaryPatterns = [];
                                nodeQuadContext.auxiliaryPatterns.concat(valueOutput.auxiliaryPatterns);
                            }
                        }
                    }
                    if (!nodeQuadContext[nodeQuadContextKey]) {
                        var term = this.util.nameToVariable(this.util.getFieldLabel(fieldNode), convertContext);
                        convertContext.terminalVariables.push(term);
                        nodeQuadContext[nodeQuadContextKey] = term;
                    }
                }
            }
        },
        {
            /* ----- Directives ----- */ /**
     * Get an operation override defined by one of the directives.
     *
     * This should be called before a sub-operation is handled.
     *
     * @param {ReadonlyArray<DirectiveNode>} directives An option directives array.
     * @param {string} fieldLabel The current field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {IDirectiveNodeHandlerOutput[]} The directive node handler outputs, or null if it should be ignored.
     */ key: "getDirectiveOutputs",
            value: function getDirectiveOutputs(directives, fieldLabel, convertContext) {
                var outputs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (directives) try {
                    for(var _iterator = directives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var directive = _step.value;
                        var output = this.util.handleDirectiveNode({
                            directive: directive,
                            fieldLabel: fieldLabel
                        }, convertContext);
                        if (output) {
                            if (output.ignore) return null;
                            outputs.push(output);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return outputs;
            }
        },
        {
            /**
     * Handle the directive outputs with respect to an operation.
     *
     * This should be called after a sub-operation was handled.
     *
     * @param {IDirectiveNodeHandlerOutput[]} directiveOutputs
     * @param {Operation} operation
     * @return {Operation}
     */ key: "handleDirectiveOutputs",
            value: function handleDirectiveOutputs(directiveOutputs, operation) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = directiveOutputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var directiveOutput = _step.value;
                        if (directiveOutput.ignore) return this.util.operationFactory.createBgp([]);
                        if (directiveOutput.operationOverrider) operation = directiveOutput.operationOverrider(operation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return operation;
            }
        }
    ]);
    return NodeHandlerAdapter;
}();
module.exports.NodeHandlerAdapter = $1d9cfa78ddc21e05$var$NodeHandlerAdapter;

});

parcelRegister("4V2Bk", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionAdapter = void 0;

var $2xD54 = parcelRequire("2xD54");
/**
 * A handler for converting GraphQL definition nodes to operations.
 */ var $394e80cd4495bddf$var$NodeHandlerDefinitionAdapter = /*#__PURE__*/ function(_NodeHandlerAdapter_1_NodeHandlerAdapter) {
    (0, $i3fW3._)(NodeHandlerDefinitionAdapter, _NodeHandlerAdapter_1_NodeHandlerAdapter);
    function NodeHandlerDefinitionAdapter(targetKind, util, settings) {
        (0, $jGAMp._)(this, NodeHandlerDefinitionAdapter);
        return (0, $kzDuW._)(this, NodeHandlerDefinitionAdapter, [
            targetKind,
            util,
            settings
        ]);
    }
    return NodeHandlerDefinitionAdapter;
}($2xD54.NodeHandlerAdapter);
module.exports.NodeHandlerDefinitionAdapter = $394e80cd4495bddf$var$NodeHandlerDefinitionAdapter;

});

parcelRegister("6uT5a", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionFragment = void 0;

var $4V2Bk = parcelRequire("4V2Bk");
/**
 * Errors if fragment definitions are found,
 * as these should have been processed away earlier.
 */ var $4bb045a58cd871db$var$NodeHandlerDefinitionFragment = /*#__PURE__*/ function(_NodeHandlerDefinitionAdapter_1_NodeHandlerDefinitionAdapter) {
    (0, $i3fW3._)(NodeHandlerDefinitionFragment, _NodeHandlerDefinitionAdapter_1_NodeHandlerDefinitionAdapter);
    function NodeHandlerDefinitionFragment(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerDefinitionFragment);
        return (0, $kzDuW._)(this, NodeHandlerDefinitionFragment, [
            'FragmentDefinition',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerDefinitionFragment, [
        {
            key: "handle",
            value: function handle(operationDefinition, convertContext) {
                throw new Error('Illegal state: fragment definitions must be indexed and removed before processing');
            }
        }
    ]);
    return NodeHandlerDefinitionFragment;
}($4V2Bk.NodeHandlerDefinitionAdapter);
module.exports.NodeHandlerDefinitionFragment = $4bb045a58cd871db$var$NodeHandlerDefinitionFragment;

});

parcelRegister("kVFKE", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionOperation = void 0;

var $4V2Bk = parcelRequire("4V2Bk");
/**
 * Converts GraphQL definitions to joined operations for all its selections.
 */ var $f3c9847aa887586c$var$NodeHandlerDefinitionOperation = /*#__PURE__*/ function(_NodeHandlerDefinitionAdapter_1_NodeHandlerDefinitionAdapter) {
    (0, $i3fW3._)(NodeHandlerDefinitionOperation, _NodeHandlerDefinitionAdapter_1_NodeHandlerDefinitionAdapter);
    function NodeHandlerDefinitionOperation(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerDefinitionOperation);
        return (0, $kzDuW._)(this, NodeHandlerDefinitionOperation, [
            'OperationDefinition',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerDefinitionOperation, [
        {
            key: "handle",
            value: function handle(operationDefinition, convertContext) {
                var _this = this;
                if (operationDefinition.operation !== 'query') throw new Error('Unsupported definition operation: ' + operationDefinition.operation);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // We ignore the query name, as SPARQL doesn't support naming queries.
                // Variables
                if (operationDefinition.variableDefinitions) try {
                    for(var _iterator = operationDefinition.variableDefinitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var variableDefinition = _step.value;
                        var name = variableDefinition.variable.name.value;
                        // Put the default value in the context if it hasn't been defined yet.
                        if (variableDefinition.defaultValue) {
                            if (!convertContext.variablesDict[name]) convertContext.variablesDict[name] = variableDefinition.defaultValue;
                        }
                        // Handle type
                        var typeNode = variableDefinition.type;
                        var mandatory = typeNode.kind === 'NonNullType';
                        if (mandatory) typeNode = typeNode.type;
                        var list = typeNode.kind === 'ListType';
                        if (list) typeNode = typeNode.type;
                        var type = typeNode.name.value;
                        convertContext.variablesMetaDict[name] = {
                            mandatory: mandatory,
                            list: list,
                            type: type
                        };
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Directives
                var directiveOutputs = this.getDirectiveOutputs(operationDefinition.directives, operationDefinition.name ? operationDefinition.name.value : '', convertContext);
                if (!directiveOutputs) return this.util.operationFactory.createBgp([]);
                // Handle the operation
                var operation = this.util.joinOperations(operationDefinition.selectionSet.selections.map(function(selectionNode) {
                    return _this.util.handleNode(selectionNode, convertContext);
                }));
                // Override operation if needed
                return this.handleDirectiveOutputs(directiveOutputs, operation);
            }
        }
    ]);
    return NodeHandlerDefinitionOperation;
}($4V2Bk.NodeHandlerDefinitionAdapter);
module.exports.NodeHandlerDefinitionOperation = $f3c9847aa887586c$var$NodeHandlerDefinitionOperation;

});

parcelRegister("Ht2sP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDocument = void 0;

var $hSHd8 = parcelRequire("hSHd8");

var $2xD54 = parcelRequire("2xD54");
/**
 * Converts GraphQL documents to joined operations for all its definitions.
 */ var $082a8ac19276edda$var$NodeHandlerDocument = /*#__PURE__*/ function(_NodeHandlerAdapter_1_NodeHandlerAdapter) {
    (0, $i3fW3._)(NodeHandlerDocument, _NodeHandlerAdapter_1_NodeHandlerAdapter);
    function NodeHandlerDocument(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerDocument);
        return (0, $kzDuW._)(this, NodeHandlerDocument, [
            'Document',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerDocument, [
        {
            key: "handle",
            value: function handle(document, convertContext) {
                var _this = this;
                var definitionOperations = document.definitions.map(function(definition) {
                    var subjectOutput = _this.getNodeQuadContextDefinitionNode(definition, Object.assign(Object.assign({}, convertContext), {
                        ignoreUnknownVariables: true
                    }));
                    var queryParseContext = Object.assign(Object.assign({}, convertContext), {
                        graph: subjectOutput.graph || convertContext.graph,
                        subject: subjectOutput.subject || _this.util.dataFactory.blankNode()
                    });
                    var definitionOperation = _this.util.handleNode(definition, queryParseContext);
                    if (subjectOutput && subjectOutput.auxiliaryPatterns) definitionOperation = _this.util.joinOperations([
                        definitionOperation,
                        _this.util.operationFactory.createBgp(subjectOutput.auxiliaryPatterns)
                    ]);
                    return definitionOperation;
                });
                var operation = this.util.operationFactory.createProject(definitionOperations.length === 1 ? definitionOperations[0] : this.util.operationFactory.createUnion(definitionOperations), convertContext.terminalVariables);
                // Convert blank nodes to variables
                return this.translateBlankNodesToVariables(operation);
            }
        },
        {
            /**
     * Get the quad context of a definition node that should be used for the whole definition node.
     * @param {DefinitionNode} definition A definition node.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject and optional auxiliary patterns.
     */ key: "getNodeQuadContextDefinitionNode",
            value: function getNodeQuadContextDefinitionNode(definition, convertContext) {
                if (definition.kind === 'OperationDefinition') return this.getNodeQuadContextSelectionSet(definition.selectionSet, definition.name ? definition.name.value : '', convertContext);
                throw new Error("Unsupported definition: ".concat(definition.kind));
            }
        },
        {
            /**
     * Translates blank nodes inside the query to variables.
     * @param {Project} operation The operation to translate.
     * @return {Operation} The transformed operation.
     */ key: "translateBlankNodesToVariables",
            value: function translateBlankNodesToVariables(operation) {
                var self = this;
                var blankToVariableMapping = {};
                var variablesRaw = Array.from(operation.variables).reduce(function(acc, variable) {
                    acc[variable.value] = true;
                    return acc;
                }, {});
                return $hSHd8.Util.mapOperation(operation, {
                    path: function(op, factory) {
                        return {
                            recurse: false,
                            result: factory.createPath(blankToVariable(op.subject), op.predicate, blankToVariable(op.object), blankToVariable(op.graph))
                        };
                    },
                    pattern: function(op, factory) {
                        return {
                            recurse: false,
                            result: factory.createPattern(blankToVariable(op.subject), blankToVariable(op.predicate), blankToVariable(op.object), blankToVariable(op.graph))
                        };
                    }
                });
                function blankToVariable(term) {
                    if (term.termType === 'BlankNode') {
                        var variable = blankToVariableMapping[term.value];
                        if (!variable) {
                            variable = $hSHd8.Util.createUniqueVariable(term.value, variablesRaw, self.util.dataFactory);
                            variablesRaw[variable.value] = true;
                            blankToVariableMapping[term.value] = variable;
                        }
                        return variable;
                    }
                    return term;
                }
            }
        }
    ]);
    return NodeHandlerDocument;
}($2xD54.NodeHandlerAdapter);
module.exports.NodeHandlerDocument = $082a8ac19276edda$var$NodeHandlerDocument;

});

parcelRegister("3iiJQ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionAdapter = void 0;

var $hSHd8 = parcelRequire("hSHd8");

var $49Vd9 = parcelRequire("49Vd9");

var $2xD54 = parcelRequire("2xD54");
/**
 * A handler for converting GraphQL selection nodes to operations.
 */ var $266196999095ecde$var$NodeHandlerSelectionAdapter = /*#__PURE__*/ function(_NodeHandlerAdapter_1_NodeHandlerAdapter) {
    (0, $i3fW3._)(NodeHandlerSelectionAdapter, _NodeHandlerAdapter_1_NodeHandlerAdapter);
    function NodeHandlerSelectionAdapter(targetKind, util, settings) {
        (0, $jGAMp._)(this, NodeHandlerSelectionAdapter);
        return (0, $kzDuW._)(this, NodeHandlerSelectionAdapter, [
            targetKind,
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerSelectionAdapter, [
        {
            /**
     * Get the quad context of a field node that should be used for the whole definition node.
     * @param {FieldNode} field A field node.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject and optional auxiliary patterns.
     */ key: "getNodeQuadContextFieldNode",
            value: function getNodeQuadContextFieldNode(field, fieldLabel, convertContext) {
                return this.getNodeQuadContextSelectionSet(field.selectionSet, fieldLabel, Object.assign(Object.assign({}, convertContext), {
                    path: this.util.appendFieldToPath(convertContext.path, fieldLabel)
                }));
            }
        },
        {
            /**
     * Convert a field node to an operation.
     * @param {IConvertContext} convertContext A convert context.
     * @param {FieldNode} fieldNode The field node to convert.
     * @param {boolean} pushTerminalVariables If terminal variables should be created.
     * @param {Pattern[]} auxiliaryPatterns Optional patterns that should be part of the BGP.
     * @return {Operation} The reslting operation.
     */ key: "fieldToOperation",
            value: function fieldToOperation(convertContext, fieldNode, pushTerminalVariables, auxiliaryPatterns) {
                var _this = this;
                // If a deeper node is being selected, and if the current object should become the next subject
                var nesting = pushTerminalVariables;
                // Offset and limit can be changed using the magic arguments 'first' and 'offset'.
                var offset = 0;
                var limit;
                // Ignore 'id' and 'graph' fields, because we have processed them earlier in getNodeQuadContextSelectionSet.
                if (fieldNode.name.value === 'id' || fieldNode.name.value === 'graph') {
                    pushTerminalVariables = false;
                    // Validate all _-arguments, because even though they were handled before,
                    // the validity of variables could not be checked,
                    // as variablesMetaDict wasn't populated at that time yet.
                    if (fieldNode["arguments"]) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = fieldNode["arguments"][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var argument = _step.value;
                                if (argument.name.value === '_') this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
                // Determine the field label for variable naming, taking into account aliases
                var fieldLabel = this.util.getFieldLabel(fieldNode);
                // Handle the singular/plural scope
                if (convertContext.singularizeState === $49Vd9.SingularizeState.SINGLE) convertContext.singularizeVariables[this.util.nameToVariable(fieldLabel, convertContext).value] = true;
                // Handle meta fields
                if (pushTerminalVariables) {
                    var operationOverride = this.handleMetaField(convertContext, fieldLabel, auxiliaryPatterns);
                    if (operationOverride) return operationOverride;
                }
                var operations = auxiliaryPatterns ? [
                    this.util.operationFactory.createBgp(auxiliaryPatterns)
                ] : [];
                // Define subject and object
                var subjectOutput = this.getNodeQuadContextFieldNode(fieldNode, fieldLabel, convertContext);
                var object = subjectOutput.subject || this.util.nameToVariable(fieldLabel, convertContext);
                var graph = subjectOutput.graph || convertContext.graph;
                if (subjectOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(subjectOutput.auxiliaryPatterns));
                // Check if there is a '_' argument
                // We do this before handling all other arguments so that the order of final triple patterns is sane.
                var createQuadPattern = true;
                var overrideObjectTerms = null;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (pushTerminalVariables && fieldNode["arguments"] && fieldNode["arguments"].length) try {
                    for(var _iterator1 = fieldNode["arguments"][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var argument1 = _step1.value;
                        if (argument1.name.value === '_') {
                            // '_'-arguments do not create an additional predicate link, but set the value directly.
                            var valueOutput = this.util.handleNodeValue(argument1.value, fieldNode.name.value, convertContext);
                            overrideObjectTerms = valueOutput.terms;
                            operations.push(this.util.operationFactory.createBgp(valueOutput.terms.map(function(term) {
                                return _this.util.createQuadPattern(convertContext.subject, fieldNode.name, term, convertContext.graph, convertContext.context);
                            })));
                            if (valueOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(valueOutput.auxiliaryPatterns));
                            pushTerminalVariables = false;
                            break;
                        } else if (argument1.name.value === 'graph') {
                            // 'graph'-arguments do not create an additional predicate link, but set the graph.
                            var valueOutput1 = this.util.handleNodeValue(argument1.value, fieldNode.name.value, convertContext);
                            if (valueOutput1.terms.length !== 1) throw new Error("Only single values can be set as graph, but got ".concat(valueOutput1.terms.length, " at ").concat(fieldNode.name.value));
                            graph = valueOutput1.terms[0];
                            convertContext = Object.assign(Object.assign({}, convertContext), {
                                graph: graph
                            });
                            if (valueOutput1.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(valueOutput1.auxiliaryPatterns));
                            break;
                        } else if (argument1.name.value === 'alt') {
                            // 'alt'-arguments do not create an additional predicate link, but create alt-property paths.
                            var pathValue = argument1.value;
                            if (pathValue.kind !== 'ListValue') pathValue = {
                                kind: 'ListValue',
                                values: [
                                    pathValue
                                ]
                            };
                            operations.push(this.util.createQuadPath(convertContext.subject, fieldNode.name, pathValue, object, convertContext.graph, convertContext.context));
                            createQuadPattern = false;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                // Create at least a pattern for the parent node and the current path.
                if (pushTerminalVariables && createQuadPattern) operations.push(this.util.operationFactory.createBgp([
                    this.util.createQuadPattern(convertContext.subject, fieldNode.name, object, convertContext.graph, convertContext.context)
                ]));
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                // Create patterns for the node's arguments
                if (fieldNode["arguments"] && fieldNode["arguments"].length) try {
                    var _this1, _loop = function() {
                        var argument = _step2.value;
                        if (argument.name.value === '_' || argument.name.value === 'graph' || argument.name.value === 'alt') ;
                        else if (argument.name.value === 'first') {
                            if (argument.value.kind !== 'IntValue') throw new Error('Invalid value type for \'first\' argument: ' + argument.value.kind);
                            limit = parseInt(argument.value.value, 10);
                        } else if (argument.name.value === 'offset') {
                            if (argument.value.kind !== 'IntValue') throw new Error('Invalid value type for \'offset\' argument: ' + argument.value.kind);
                            offset = parseInt(argument.value.value, 10);
                        } else {
                            var valueOutput = _this1.util.handleNodeValue(argument.value, argument.name.value, convertContext);
                            operations.push(_this1.util.operationFactory.createBgp(valueOutput.terms.map(function(term) {
                                return _this.util.createQuadPattern(object, argument.name, term, convertContext.graph, convertContext.context);
                            })));
                            if (valueOutput.auxiliaryPatterns) operations.push(_this1.util.operationFactory.createBgp(valueOutput.auxiliaryPatterns));
                        }
                    };
                    for(var _iterator2 = fieldNode["arguments"][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                // Directives
                var directiveOutputs = this.getDirectiveOutputs(fieldNode.directives, fieldLabel, convertContext);
                if (!directiveOutputs) return this.util.operationFactory.createBgp([]);
                // Recursive call for nested selection sets
                var operation = this.util.joinOperations(operations);
                if (fieldNode.selectionSet && fieldNode.selectionSet.selections.length) {
                    // Override the object if needed
                    if (overrideObjectTerms) {
                        if (overrideObjectTerms.length !== 1) throw new Error("Only single values can be set as id, but got ".concat(overrideObjectTerms.length, " at ").concat(fieldNode.name.value));
                        object = overrideObjectTerms[0];
                    }
                    // Change path value when there was an alias on this node.
                    var subConvertContext = Object.assign(Object.assign(Object.assign({}, convertContext), nesting ? {
                        path: this.util.appendFieldToPath(convertContext.path, fieldLabel)
                    } : {}), {
                        graph: graph,
                        subject: nesting ? object : convertContext.subject
                    });
                    // If the magic keyword 'totalCount' is present, include a count aggregator.
                    var totalCount = false;
                    var selections = fieldNode.selectionSet.selections.filter(function(selection) {
                        if (selection.kind === 'Field' && selection.name.value === 'totalCount') {
                            totalCount = true;
                            return false;
                        }
                        return true;
                    });
                    var joinedOperation = this.util.joinOperations(operations.concat(selections.map(function(selectionNode) {
                        return _this.util.handleNode(selectionNode, subConvertContext);
                    })));
                    // Modify the operation if there was a count selection
                    if (totalCount) {
                        // Create to a count aggregation
                        var expressionVariable = this.util.dataFactory.variable('var' + this.settings.expressionVariableCounter++);
                        var countOverVariable = this.util.dataFactory.variable(object.value + this.settings.variableDelimiter + 'totalCount');
                        var aggregator = this.util.operationFactory.createBoundAggregate(expressionVariable, 'count', this.util.operationFactory.createTermExpression(object), false);
                        var countProject = this.util.operationFactory.createProject(this.util.operationFactory.createExtend(this.util.operationFactory.createGroup(operation, [], [
                            aggregator
                        ]), countOverVariable, this.util.operationFactory.createTermExpression(expressionVariable)), [
                            countOverVariable
                        ]);
                        convertContext.terminalVariables.push(countOverVariable);
                        // If no other selections exist (next to totalCount),
                        // then we just return the count operations as-is,
                        // otherwise, we join the count operation with all other selections
                        if (!selections.length) joinedOperation = countProject;
                        else joinedOperation = this.util.operationFactory.createJoin([
                            this.util.operationFactory.createProject(joinedOperation, []),
                            countProject
                        ]);
                    }
                    operation = joinedOperation;
                } else if (pushTerminalVariables && object.termType === 'Variable') // If no nested selection sets exist,
                // consider the object variable as a terminal variable that should be selected.
                convertContext.terminalVariables.push(object);
                // Wrap the operation in a slice if a 'first' or 'offset' argument was provided.
                if (offset || limit) operation = this.util.operationFactory.createSlice(this.util.operationFactory.createProject(operation, $hSHd8.Util.inScopeVariables(operation)), offset, limit);
                // Override operation if needed
                return this.handleDirectiveOutputs(directiveOutputs, operation);
            }
        },
        {
            /**
     * Check if the given node is a meta field, for things like introspection.
     * If so, return a new operation for this, otherwise, null is returned.
     * @param {IConvertContext} convertContext A convert context.
     * @param {Term} subject The subject.
     * @param {string} fieldLabel The field label to convert.
     * @param {Pattern[]} auxiliaryPatterns Optional patterns that should be part of the BGP.
     * @return {Operation} An operation or undefined.
     */ key: "handleMetaField",
            value: function handleMetaField(convertContext, fieldLabel, auxiliaryPatterns) {
                // TODO: in the future, we should add support for GraphQL wide range of introspection features:
                // http://graphql.org/learn/introspection/
                if (fieldLabel === '__typename') {
                    var object = this.util.nameToVariable(fieldLabel, convertContext);
                    convertContext.terminalVariables.push(object);
                    return this.util.operationFactory.createBgp([
                        this.util.operationFactory.createPattern(convertContext.subject, this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), this.util.nameToVariable(fieldLabel, convertContext), convertContext.graph)
                    ].concat(auxiliaryPatterns || []));
                }
            }
        }
    ]);
    return NodeHandlerSelectionAdapter;
}($2xD54.NodeHandlerAdapter);
module.exports.NodeHandlerSelectionAdapter = $266196999095ecde$var$NodeHandlerSelectionAdapter;

});

parcelRegister("3bWYD", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionField = void 0;

var $3iiJQ = parcelRequire("3iiJQ");
/**
 * Converts GraphQL fields to one or more quad patterns.
 */ var $253025c2482ab23a$var$NodeHandlerSelectionField = /*#__PURE__*/ function(_NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter) {
    (0, $i3fW3._)(NodeHandlerSelectionField, _NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter);
    function NodeHandlerSelectionField(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerSelectionField);
        return (0, $kzDuW._)(this, NodeHandlerSelectionField, [
            'Field',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerSelectionField, [
        {
            key: "handle",
            value: function handle(fieldNode, convertContext) {
                return this.fieldToOperation(convertContext, fieldNode, true);
            }
        }
    ]);
    return NodeHandlerSelectionField;
}($3iiJQ.NodeHandlerSelectionAdapter);
module.exports.NodeHandlerSelectionField = $253025c2482ab23a$var$NodeHandlerSelectionField;

});

parcelRegister("gLr1c", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionFragmentSpread = void 0;

var $3iiJQ = parcelRequire("3iiJQ");
/**
 * Converts GraphQL fragment spread to one or more quad patterns with a given type within an optional.
 */ var $c345fe6a10d74108$var$NodeHandlerSelectionFragmentSpread = /*#__PURE__*/ function(_NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter) {
    (0, $i3fW3._)(NodeHandlerSelectionFragmentSpread, _NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter);
    function NodeHandlerSelectionFragmentSpread(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerSelectionFragmentSpread);
        return (0, $kzDuW._)(this, NodeHandlerSelectionFragmentSpread, [
            'FragmentSpread',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerSelectionFragmentSpread, [
        {
            key: "handle",
            value: function handle(fragmentSpreadNode, convertContext) {
                var fragmentDefinitionNode = convertContext.fragmentDefinitions[fragmentSpreadNode.name.value];
                if (!fragmentDefinitionNode) throw new Error('Undefined fragment definition: ' + fragmentSpreadNode.name.value);
                // Wrap in an OPTIONAL, as this pattern should only apply if the type applies
                var fieldNode = {
                    alias: undefined,
                    arguments: undefined,
                    directives: fragmentDefinitionNode.directives,
                    kind: 'Field',
                    name: fragmentSpreadNode.name,
                    selectionSet: fragmentDefinitionNode.selectionSet
                };
                var auxiliaryPatterns = [
                    this.util.newTypePattern(convertContext.subject, fragmentDefinitionNode.typeCondition, convertContext)
                ];
                return this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), this.fieldToOperation(convertContext, fieldNode, false, auxiliaryPatterns));
            }
        }
    ]);
    return NodeHandlerSelectionFragmentSpread;
}($3iiJQ.NodeHandlerSelectionAdapter);
module.exports.NodeHandlerSelectionFragmentSpread = $c345fe6a10d74108$var$NodeHandlerSelectionFragmentSpread;

});

parcelRegister("ejkbA", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionInlineFragment = void 0;

var $3iiJQ = parcelRequire("3iiJQ");
/**
 * Converts GraphQL inline fragment to one or more quad patterns with a given type within an optional.
 */ var $a6b27f87898ca202$var$NodeHandlerSelectionInlineFragment = /*#__PURE__*/ function(_NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter) {
    (0, $i3fW3._)(NodeHandlerSelectionInlineFragment, _NodeHandlerSelectionAdapter_1_NodeHandlerSelectionAdapter);
    function NodeHandlerSelectionInlineFragment(util, settings) {
        (0, $jGAMp._)(this, NodeHandlerSelectionInlineFragment);
        return (0, $kzDuW._)(this, NodeHandlerSelectionInlineFragment, [
            'InlineFragment',
            util,
            settings
        ]);
    }
    (0, $byiyg._)(NodeHandlerSelectionInlineFragment, [
        {
            key: "handle",
            value: function handle(inlineFragmentNode, convertContext) {
                // Wrap in an OPTIONAL, as this pattern should only apply if the type applies
                var fieldNode = {
                    alias: undefined,
                    arguments: undefined,
                    directives: inlineFragmentNode.directives,
                    kind: 'Field',
                    name: {
                        kind: 'Name',
                        value: convertContext.subject.value
                    },
                    selectionSet: inlineFragmentNode.selectionSet
                };
                var auxiliaryPatterns = inlineFragmentNode.typeCondition ? [
                    this.util.newTypePattern(convertContext.subject, inlineFragmentNode.typeCondition, convertContext)
                ] : [];
                return this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), this.fieldToOperation(convertContext, fieldNode, false, auxiliaryPatterns));
            }
        }
    ]);
    return NodeHandlerSelectionInlineFragment;
}($3iiJQ.NodeHandlerSelectionAdapter);
module.exports.NodeHandlerSelectionInlineFragment = $a6b27f87898ca202$var$NodeHandlerSelectionInlineFragment;

});


parcelRegister("kPBE2", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $f2a5c58f367a9291$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Converter = void 0;

var $7Fnp0 = parcelRequire("7Fnp0");

var $jIPpf = parcelRequire("jIPpf");

var $85LSR = parcelRequire("85LSR");

var $49Vd9 = parcelRequire("49Vd9");

var $7oPrC = parcelRequire("7oPrC");
/**
 * Translate GraphQL queries into SPARQL algebra.
 */ var $f2a5c58f367a9291$var$Converter = /*#__PURE__*/ function() {
    function Converter(settings) {
        (0, $jGAMp._)(this, Converter);
        settings = settings || {};
        settings.variableDelimiter = settings.variableDelimiter || '_';
        settings.expressionVariableCounter = settings.expressionVariableCounter || 0;
        this.util = new $7oPrC.Util(settings);
        this.initializeNodeHandlers(settings);
    }
    (0, $byiyg._)(Converter, [
        {
            /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Promise<Operation>} A promise resolving to an operation.
     */ key: "graphqlToSparqlAlgebra",
            value: function graphqlToSparqlAlgebra(graphqlQuery, context, options) {
                return $f2a5c58f367a9291$var$__awaiter(this, void 0, void 0, function() {
                    var _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = this).graphqlToSparqlAlgebraRawContext;
                                _tmp = [
                                    graphqlQuery
                                ];
                                return [
                                    4,
                                    this.util.contextParser.parse(context)
                                ];
                            case 1:
                                return [
                                    2,
                                    _1.apply(_, _tmp.concat([
                                        _state.sent(),
                                        options
                                    ]))
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Operation} An operation.
     */ key: "graphqlToSparqlAlgebraRawContext",
            value: function graphqlToSparqlAlgebraRawContext(graphqlQuery, context, options) {
                options = options || {};
                var document = typeof graphqlQuery === 'string' ? (0, $7Fnp0.parse)(graphqlQuery) : graphqlQuery;
                var fragmentDefinitions = this.indexFragments(document);
                var convertContext = {
                    context: context,
                    fragmentDefinitions: fragmentDefinitions,
                    graph: this.util.dataFactory.defaultGraph(),
                    path: [],
                    singularizeState: $49Vd9.SingularizeState.PLURAL,
                    singularizeVariables: options.singularizeVariables || {},
                    subject: null,
                    terminalVariables: [],
                    variablesDict: options.variablesDict || {},
                    variablesMetaDict: {}
                };
                return this.util.handleNode(document, convertContext);
            }
        },
        {
            /**
     * Create an index of all fragment definitions in the given document.
     *
     * This will assign a new array of definition nodes without fragment definition.
     *
     * @param {DocumentNode} document A document node.
     * @return {{[p: string]: FragmentDefinitionNode}} An index of fragment definition nodes.
     */ key: "indexFragments",
            value: function indexFragments(document) {
                var fragmentDefinitions = {};
                var newDefinitions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = document.definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var definition = _step.value;
                        if (definition.kind === 'FragmentDefinition') fragmentDefinitions[definition.name.value] = definition;
                        else newDefinitions.push(definition);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                document.definitions = newDefinitions;
                return fragmentDefinitions;
            }
        },
        {
            key: "initializeNodeHandlers",
            value: function initializeNodeHandlers(settings) {
                Converter.registerNodeHandlers(this.util, settings);
                Converter.registerNodeValueHandlers(this.util, settings);
                Converter.registerDirectiveNodeHandlers(this.util, settings);
            }
        }
    ], [
        {
            key: "registerNodeHandlers",
            value: function registerNodeHandlers(util, settings) {
                util.registerNodeHandler(new $jIPpf.NodeHandlerDocument(util, settings));
                util.registerNodeHandler(new $jIPpf.NodeHandlerDefinitionOperation(util, settings));
                util.registerNodeHandler(new $jIPpf.NodeHandlerDefinitionFragment(util, settings));
                util.registerNodeHandler(new $jIPpf.NodeHandlerSelectionFragmentSpread(util, settings));
                util.registerNodeHandler(new $jIPpf.NodeHandlerSelectionInlineFragment(util, settings));
                util.registerNodeHandler(new $jIPpf.NodeHandlerSelectionField(util, settings));
            }
        },
        {
            key: "registerNodeValueHandlers",
            value: function registerNodeValueHandlers(util, settings) {
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerVariable(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerInt(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerFloat(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerString(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerBoolean(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerNull(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerEnum(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerList(util, settings));
                util.registerNodeValueHandler(new $jIPpf.NodeValueHandlerObject(util, settings));
            }
        },
        {
            key: "registerDirectiveNodeHandlers",
            value: function registerDirectiveNodeHandlers(util, settings) {
                util.registerDirectiveNodeHandler(new $85LSR.DirectiveNodeHandlerInclude(util, settings));
                util.registerDirectiveNodeHandler(new $85LSR.DirectiveNodeHandlerOptional(util, settings));
                util.registerDirectiveNodeHandler(new $85LSR.DirectiveNodeHandlerPlural(util, settings));
                util.registerDirectiveNodeHandler(new $85LSR.DirectiveNodeHandlerSingle(util, settings));
                util.registerDirectiveNodeHandler(new $85LSR.DirectiveNodeHandlerSkip(util, settings));
            }
        }
    ]);
    return Converter;
}();
module.exports.Converter = $f2a5c58f367a9291$var$Converter;

});
parcelRegister("7Fnp0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Source", {
    enumerable: true,
    get: function get() {
        return $3Xljf.Source;
    }
});
Object.defineProperty(module.exports, "getLocation", {
    enumerable: true,
    get: function get() {
        return $f1Lrn.getLocation;
    }
});
Object.defineProperty(module.exports, "printLocation", {
    enumerable: true,
    get: function get() {
        return $9jJrH.printLocation;
    }
});
Object.defineProperty(module.exports, "printSourceLocation", {
    enumerable: true,
    get: function get() {
        return $9jJrH.printSourceLocation;
    }
});
Object.defineProperty(module.exports, "Kind", {
    enumerable: true,
    get: function get() {
        return $eWXut.Kind;
    }
});
Object.defineProperty(module.exports, "TokenKind", {
    enumerable: true,
    get: function get() {
        return $iB3Qg.TokenKind;
    }
});
Object.defineProperty(module.exports, "Lexer", {
    enumerable: true,
    get: function get() {
        return $75iIV.Lexer;
    }
});
Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function get() {
        return $pAxKA.parse;
    }
});
Object.defineProperty(module.exports, "parseValue", {
    enumerable: true,
    get: function get() {
        return $pAxKA.parseValue;
    }
});
Object.defineProperty(module.exports, "parseType", {
    enumerable: true,
    get: function get() {
        return $pAxKA.parseType;
    }
});
Object.defineProperty(module.exports, "print", {
    enumerable: true,
    get: function get() {
        return $aGu3k.print;
    }
});
Object.defineProperty(module.exports, "visit", {
    enumerable: true,
    get: function get() {
        return $6p2DZ.visit;
    }
});
Object.defineProperty(module.exports, "visitInParallel", {
    enumerable: true,
    get: function get() {
        return $6p2DZ.visitInParallel;
    }
});
Object.defineProperty(module.exports, "getVisitFn", {
    enumerable: true,
    get: function get() {
        return $6p2DZ.getVisitFn;
    }
});
Object.defineProperty(module.exports, "BREAK", {
    enumerable: true,
    get: function get() {
        return $6p2DZ.BREAK;
    }
});
Object.defineProperty(module.exports, "Location", {
    enumerable: true,
    get: function get() {
        return $3ilOD.Location;
    }
});
Object.defineProperty(module.exports, "Token", {
    enumerable: true,
    get: function get() {
        return $3ilOD.Token;
    }
});
Object.defineProperty(module.exports, "isDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isExecutableDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isExecutableDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isSelectionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isSelectionNode;
    }
});
Object.defineProperty(module.exports, "isValueNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isValueNode;
    }
});
Object.defineProperty(module.exports, "isTypeNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isTypeNode;
    }
});
Object.defineProperty(module.exports, "isTypeSystemDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isTypeSystemDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isTypeDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isTypeDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isTypeSystemExtensionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isTypeSystemExtensionNode;
    }
});
Object.defineProperty(module.exports, "isTypeExtensionNode", {
    enumerable: true,
    get: function get() {
        return $kMO9U.isTypeExtensionNode;
    }
});
Object.defineProperty(module.exports, "DirectiveLocation", {
    enumerable: true,
    get: function get() {
        return $6fb3a.DirectiveLocation;
    }
});

var $3Xljf = parcelRequire("3Xljf");

var $f1Lrn = parcelRequire("f1Lrn");

var $9jJrH = parcelRequire("9jJrH");

var $eWXut = parcelRequire("eWXut");

var $iB3Qg = parcelRequire("iB3Qg");

var $75iIV = parcelRequire("75iIV");

var $pAxKA = parcelRequire("pAxKA");

var $aGu3k = parcelRequire("aGu3k");

var $6p2DZ = parcelRequire("6p2DZ");

var $3ilOD = parcelRequire("3ilOD");

var $kMO9U = parcelRequire("kMO9U");

var $6fb3a = parcelRequire("6fb3a");

});
parcelRegister("3Xljf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSource = $2e17696be2977aaf$var$isSource;
module.exports.Source = void 0;

var $2QEVV = parcelRequire("2QEVV");

var $2e17696be2977aaf$var$_inspect = $2e17696be2977aaf$var$_interopRequireDefault((parcelRequire("eJPX0")));

var $2e17696be2977aaf$var$_devAssert = $2e17696be2977aaf$var$_interopRequireDefault((parcelRequire("5OeBE")));

var $2e17696be2977aaf$var$_instanceOf = $2e17696be2977aaf$var$_interopRequireDefault((parcelRequire("gfaAQ")));
function $2e17696be2977aaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2e17696be2977aaf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2e17696be2977aaf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2e17696be2977aaf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2e17696be2977aaf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */ var $2e17696be2977aaf$var$Source = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $2e17696be2977aaf$var$_devAssert["default"])(0, "Body must be a string. Received: ".concat((0, $2e17696be2977aaf$var$_inspect["default"])(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $2e17696be2977aaf$var$_devAssert["default"])(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $2e17696be2977aaf$var$_devAssert["default"])(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $2e17696be2977aaf$var$_createClass(Source, [
        {
            key: $2QEVV.SYMBOL_TO_STRING_TAG,
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ module.exports.Source = $2e17696be2977aaf$var$Source;
// eslint-disable-next-line no-redeclare
function $2e17696be2977aaf$var$isSource(source) {
    return (0, $2e17696be2977aaf$var$_instanceOf["default"])(source, $2e17696be2977aaf$var$Source);
}

});
parcelRegister("2QEVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SYMBOL_TO_STRING_TAG = module.exports.SYMBOL_ASYNC_ITERATOR = module.exports.SYMBOL_ITERATOR = void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $21303095604435c6$var$SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
module.exports.SYMBOL_ITERATOR = $21303095604435c6$var$SYMBOL_ITERATOR;
var $21303095604435c6$var$SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
module.exports.SYMBOL_ASYNC_ITERATOR = $21303095604435c6$var$SYMBOL_ASYNC_ITERATOR;
var $21303095604435c6$var$SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
module.exports.SYMBOL_TO_STRING_TAG = $21303095604435c6$var$SYMBOL_TO_STRING_TAG;

});

parcelRegister("eJPX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $abad90fe89d81c2f$var$inspect;

var $abad90fe89d81c2f$var$_nodejsCustomInspectSymbol = $abad90fe89d81c2f$var$_interopRequireDefault((parcelRequire("5uOxP")));
function $abad90fe89d81c2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $abad90fe89d81c2f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $abad90fe89d81c2f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $abad90fe89d81c2f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $abad90fe89d81c2f$var$_typeof(obj);
}
var $abad90fe89d81c2f$var$MAX_ARRAY_LENGTH = 10;
var $abad90fe89d81c2f$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $abad90fe89d81c2f$var$inspect(value) {
    return $abad90fe89d81c2f$var$formatValue(value, []);
}
function $abad90fe89d81c2f$var$formatValue(value, seenValues) {
    switch($abad90fe89d81c2f$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $abad90fe89d81c2f$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $abad90fe89d81c2f$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $abad90fe89d81c2f$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $abad90fe89d81c2f$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $abad90fe89d81c2f$var$formatArray(value, seenValues);
    return $abad90fe89d81c2f$var$formatObject(value, seenValues);
}
function $abad90fe89d81c2f$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $abad90fe89d81c2f$var$MAX_RECURSIVE_DEPTH) return '[' + $abad90fe89d81c2f$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $abad90fe89d81c2f$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $abad90fe89d81c2f$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $abad90fe89d81c2f$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($abad90fe89d81c2f$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($abad90fe89d81c2f$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $abad90fe89d81c2f$var$getCustomFn(object) {
    var customInspectFn = object[String($abad90fe89d81c2f$var$_nodejsCustomInspectSymbol["default"])];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $abad90fe89d81c2f$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("5uOxP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4006f6370a289384$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol["for"] === 'function' ? Symbol["for"]('nodejs.util.inspect.custom') : undefined;
var $4006f6370a289384$var$_default = $4006f6370a289384$var$nodejsCustomInspectSymbol;
module.exports["default"] = $4006f6370a289384$var$_default;

});


parcelRegister("5OeBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $43acf3c1e5926d67$var$devAssert;
function $43acf3c1e5926d67$var$devAssert(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("gfaAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bd3643ae70671789$var$_inspect = $bd3643ae70671789$var$_interopRequireDefault((parcelRequire("eJPX0")));
function $bd3643ae70671789$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bd3643ae70671789$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bd3643ae70671789$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bd3643ae70671789$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bd3643ae70671789$var$_typeof(obj);
}
// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var $bd3643ae70671789$var$_default = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};
module.exports["default"] = $bd3643ae70671789$var$_default;

});


parcelRegister("f1Lrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocation = $af0bbfb91ba468c3$var$getLocation;
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $af0bbfb91ba468c3$var$getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("9jJrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printLocation = $6c89240042978e3b$var$printLocation;
module.exports.printSourceLocation = $6c89240042978e3b$var$printSourceLocation;

var $f1Lrn = parcelRequire("f1Lrn");
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ function $6c89240042978e3b$var$printLocation(location) {
    return $6c89240042978e3b$var$printSourceLocation(location.source, (0, $f1Lrn.getLocation)(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ function $6c89240042978e3b$var$printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $6c89240042978e3b$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $6c89240042978e3b$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $6c89240042978e3b$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $6c89240042978e3b$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $6c89240042978e3b$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $6c89240042978e3b$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $6c89240042978e3b$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $6c89240042978e3b$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $6c89240042978e3b$var$leftPad(len, str) {
    return $6c89240042978e3b$var$whitespace(len - str.length) + str;
}

});

parcelRegister("eWXut", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $ae24a10f56cdd069$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $ae24a10f56cdd069$var$Kind;

});

parcelRegister("iB3Qg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenKind = void 0;
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $d89ea9a38937e2ce$var$TokenKind = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */ module.exports.TokenKind = $d89ea9a38937e2ce$var$TokenKind;

});

parcelRegister("75iIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPunctuatorTokenKind = $5287862879589c53$var$isPunctuatorTokenKind;
module.exports.Lexer = void 0;

var $4TL3u = parcelRequire("4TL3u");

var $3ilOD = parcelRequire("3ilOD");

var $iB3Qg = parcelRequire("iB3Qg");

var $jyi0s = parcelRequire("jyi0s");
/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ var $5287862879589c53$var$Lexer = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new $3ilOD.Token($iB3Qg.TokenKind.SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== $iB3Qg.TokenKind.EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $5287862879589c53$var$readToken(this, token);
        }while (token.kind === $iB3Qg.TokenKind.COMMENT);
        return token;
    };
    return Lexer;
}();
/**
 * @internal
 */ module.exports.Lexer = $5287862879589c53$var$Lexer;
function $5287862879589c53$var$isPunctuatorTokenKind(kind) {
    return kind === $iB3Qg.TokenKind.BANG || kind === $iB3Qg.TokenKind.DOLLAR || kind === $iB3Qg.TokenKind.AMP || kind === $iB3Qg.TokenKind.PAREN_L || kind === $iB3Qg.TokenKind.PAREN_R || kind === $iB3Qg.TokenKind.SPREAD || kind === $iB3Qg.TokenKind.COLON || kind === $iB3Qg.TokenKind.EQUALS || kind === $iB3Qg.TokenKind.AT || kind === $iB3Qg.TokenKind.BRACKET_L || kind === $iB3Qg.TokenKind.BRACKET_R || kind === $iB3Qg.TokenKind.BRACE_L || kind === $iB3Qg.TokenKind.PIPE || kind === $iB3Qg.TokenKind.BRACE_R;
}
function $5287862879589c53$var$printCharCode(code) {
    return isNaN(code) ? $iB3Qg.TokenKind.EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $5287862879589c53$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new $3ilOD.Token($iB3Qg.TokenKind.BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $5287862879589c53$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new $3ilOD.Token($iB3Qg.TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new $3ilOD.Token($iB3Qg.TokenKind.AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new $3ilOD.Token($iB3Qg.TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new $3ilOD.Token($iB3Qg.TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new $3ilOD.Token($iB3Qg.TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new $3ilOD.Token($iB3Qg.TokenKind.COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new $3ilOD.Token($iB3Qg.TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new $3ilOD.Token($iB3Qg.TokenKind.AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new $3ilOD.Token($iB3Qg.TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new $3ilOD.Token($iB3Qg.TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new $3ilOD.Token($iB3Qg.TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new $3ilOD.Token($iB3Qg.TokenKind.PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new $3ilOD.Token($iB3Qg.TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $5287862879589c53$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $5287862879589c53$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $5287862879589c53$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $5287862879589c53$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $4TL3u.syntaxError)(source, pos, $5287862879589c53$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new $3ilOD.Token($iB3Qg.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $5287862879589c53$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($5287862879589c53$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($5287862879589c53$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $5287862879589c53$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new $3ilOD.Token($iB3Qg.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $5287862879589c53$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $4TL3u.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($5287862879589c53$var$printCharCode(code), "."));
    } else {
        position = $5287862879589c53$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $5287862879589c53$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $5287862879589c53$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $5287862879589c53$var$isNameStart(code)) throw (0, $4TL3u.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($5287862879589c53$var$printCharCode(code), "."));
    return new $3ilOD.Token(isFloat ? $iB3Qg.TokenKind.FLOAT : $iB3Qg.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $5287862879589c53$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $4TL3u.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($5287862879589c53$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $5287862879589c53$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new $3ilOD.Token($iB3Qg.TokenKind.STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $4TL3u.syntaxError)(source, position, "Invalid character within String: ".concat($5287862879589c53$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $5287862879589c53$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $4TL3u.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $4TL3u.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $4TL3u.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $5287862879589c53$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new $3ilOD.Token($iB3Qg.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, $jyi0s.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $4TL3u.syntaxError)(source, position, "Invalid character within String: ".concat($5287862879589c53$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $4TL3u.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $5287862879589c53$var$uniCharCode(a, b, c, d) {
    return $5287862879589c53$var$char2hex(a) << 12 | $5287862879589c53$var$char2hex(b) << 8 | $5287862879589c53$var$char2hex(c) << 4 | $5287862879589c53$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $5287862879589c53$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $5287862879589c53$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $3ilOD.Token($iB3Qg.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $5287862879589c53$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("4TL3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syntaxError = $3910ccb2117323c9$var$syntaxError;

var $6fnp1 = parcelRequire("6fnp1");
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ function $3910ccb2117323c9$var$syntaxError(source, position, description) {
    return new $6fnp1.GraphQLError("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("6fnp1", function(module, exports) {
"use strict";
function $48c64c09447dcbba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $48c64c09447dcbba$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $48c64c09447dcbba$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $48c64c09447dcbba$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printError = $48c64c09447dcbba$var$printError;
module.exports.formatError = $48c64c09447dcbba$var$formatError;
module.exports.GraphQLError = void 0;

var $48c64c09447dcbba$var$_devAssert = $48c64c09447dcbba$var$_interopRequireDefault((parcelRequire("5OeBE")));

var $48c64c09447dcbba$var$_isObjectLike = $48c64c09447dcbba$var$_interopRequireDefault((parcelRequire("7qgLy")));

var $2QEVV = parcelRequire("2QEVV");

var $f1Lrn = parcelRequire("f1Lrn");

var $9jJrH = parcelRequire("9jJrH");
function $48c64c09447dcbba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $48c64c09447dcbba$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48c64c09447dcbba$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $48c64c09447dcbba$var$ownKeys(Object(source), true).forEach(function(key) {
            $48c64c09447dcbba$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $48c64c09447dcbba$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $48c64c09447dcbba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $48c64c09447dcbba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $48c64c09447dcbba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $48c64c09447dcbba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $48c64c09447dcbba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $48c64c09447dcbba$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $48c64c09447dcbba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $48c64c09447dcbba$var$_setPrototypeOf(subClass, superClass);
}
function $48c64c09447dcbba$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $48c64c09447dcbba$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $48c64c09447dcbba$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $48c64c09447dcbba$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $48c64c09447dcbba$var$_possibleConstructorReturn(this, result);
    };
}
function $48c64c09447dcbba$var$_possibleConstructorReturn(self, call) {
    if (call && ($48c64c09447dcbba$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $48c64c09447dcbba$var$_assertThisInitialized(self);
}
function $48c64c09447dcbba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $48c64c09447dcbba$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $48c64c09447dcbba$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$48c64c09447dcbba$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $48c64c09447dcbba$var$_construct(Class, arguments, $48c64c09447dcbba$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $48c64c09447dcbba$var$_setPrototypeOf(Wrapper, Class);
    };
    return $48c64c09447dcbba$var$_wrapNativeSuper(Class);
}
function $48c64c09447dcbba$var$_construct(Parent, args, Class) {
    if ($48c64c09447dcbba$var$_isNativeReflectConstruct()) $48c64c09447dcbba$var$_construct = Reflect.construct;
    else $48c64c09447dcbba$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $48c64c09447dcbba$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $48c64c09447dcbba$var$_construct.apply(null, arguments);
}
function $48c64c09447dcbba$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $48c64c09447dcbba$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $48c64c09447dcbba$var$_setPrototypeOf(o, p) {
    $48c64c09447dcbba$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48c64c09447dcbba$var$_setPrototypeOf(o, p);
}
function $48c64c09447dcbba$var$_getPrototypeOf(o) {
    $48c64c09447dcbba$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $48c64c09447dcbba$var$_getPrototypeOf(o);
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */ var $48c64c09447dcbba$var$GraphQLError = /*#__PURE__*/ function(_Error) {
    $48c64c09447dcbba$var$_inherits(GraphQLError, _Error);
    var _super = $48c64c09447dcbba$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $48c64c09447dcbba$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $48c64c09447dcbba$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $48c64c09447dcbba$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $f1Lrn.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $f1Lrn.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $48c64c09447dcbba$var$_isObjectLike["default"])(originalExtensions)) _this.extensions = $48c64c09447dcbba$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($48c64c09447dcbba$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($48c64c09447dcbba$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $48c64c09447dcbba$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($48c64c09447dcbba$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($48c64c09447dcbba$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $48c64c09447dcbba$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $48c64c09447dcbba$var$printError(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $48c64c09447dcbba$var$formatError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: $2QEVV.SYMBOL_TO_STRING_TAG,
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $48c64c09447dcbba$var$_wrapNativeSuper(Error));
module.exports.GraphQLError = $48c64c09447dcbba$var$GraphQLError;
function $48c64c09447dcbba$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ function $48c64c09447dcbba$var$printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $9jJrH.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $9jJrH.printSourceLocation)(error.source, location);
    }
    return output;
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ function $48c64c09447dcbba$var$formatError(error) {
    var _error$message;
    error || (0, $48c64c09447dcbba$var$_devAssert["default"])(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("7qgLy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5677f77b26ee3794$var$isObjectLike;
function $5677f77b26ee3794$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5677f77b26ee3794$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5677f77b26ee3794$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5677f77b26ee3794$var$_typeof(obj);
}
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $5677f77b26ee3794$var$isObjectLike(value) {
    return $5677f77b26ee3794$var$_typeof(value) == 'object' && value !== null;
}

});



parcelRegister("3ilOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $2663f9a9a241cd40$var$isNode;
module.exports.Token = module.exports.Location = void 0;

var $2663f9a9a241cd40$var$_defineInspect = $2663f9a9a241cd40$var$_interopRequireDefault((parcelRequire("ikXqC")));
function $2663f9a9a241cd40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $2663f9a9a241cd40$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Location = $2663f9a9a241cd40$var$Location;
(0, $2663f9a9a241cd40$var$_defineInspect["default"])($2663f9a9a241cd40$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $2663f9a9a241cd40$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Token = $2663f9a9a241cd40$var$Token;
(0, $2663f9a9a241cd40$var$_defineInspect["default"])($2663f9a9a241cd40$var$Token);
/**
 * @internal
 */ function $2663f9a9a241cd40$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("ikXqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d598317bc2f2bd83$var$defineInspect;

var $d598317bc2f2bd83$var$_invariant = $d598317bc2f2bd83$var$_interopRequireDefault((parcelRequire("hJvG6")));

var $d598317bc2f2bd83$var$_nodejsCustomInspectSymbol = $d598317bc2f2bd83$var$_interopRequireDefault((parcelRequire("5uOxP")));
function $d598317bc2f2bd83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $d598317bc2f2bd83$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $d598317bc2f2bd83$var$_invariant["default"])(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($d598317bc2f2bd83$var$_nodejsCustomInspectSymbol["default"]) classObject.prototype[$d598317bc2f2bd83$var$_nodejsCustomInspectSymbol["default"]] = fn;
}

});
parcelRegister("hJvG6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ce8f36392b2ba842$var$invariant;
function $ce8f36392b2ba842$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});



parcelRegister("jyi0s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringValue = $e3bf2901893a8044$var$dedentBlockStringValue;
module.exports.getBlockStringIndentation = $e3bf2901893a8044$var$getBlockStringIndentation;
module.exports.printBlockString = $e3bf2901893a8044$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $e3bf2901893a8044$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $e3bf2901893a8044$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $e3bf2901893a8044$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $e3bf2901893a8044$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $e3bf2901893a8044$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $e3bf2901893a8044$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $e3bf2901893a8044$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("pAxKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $04ceaeaa35d65175$var$parse;
module.exports.parseValue = $04ceaeaa35d65175$var$parseValue;
module.exports.parseType = $04ceaeaa35d65175$var$parseType;
module.exports.Parser = void 0;

var $4TL3u = parcelRequire("4TL3u");

var $eWXut = parcelRequire("eWXut");

var $3ilOD = parcelRequire("3ilOD");

var $iB3Qg = parcelRequire("iB3Qg");

var $3Xljf = parcelRequire("3Xljf");

var $6fb3a = parcelRequire("6fb3a");

var $75iIV = parcelRequire("75iIV");
/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ function $04ceaeaa35d65175$var$parse(source, options) {
    var parser = new $04ceaeaa35d65175$var$Parser(source, options);
    return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ function $04ceaeaa35d65175$var$parseValue(source, options) {
    var parser = new $04ceaeaa35d65175$var$Parser(source, options);
    parser.expectToken($iB3Qg.TokenKind.SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken($iB3Qg.TokenKind.EOF);
    return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ function $04ceaeaa35d65175$var$parseType(source, options) {
    var parser = new $04ceaeaa35d65175$var$Parser(source, options);
    parser.expectToken($iB3Qg.TokenKind.SOF);
    var type = parser.parseTypeReference();
    parser.expectToken($iB3Qg.TokenKind.EOF);
    return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */ var $04ceaeaa35d65175$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $3Xljf.isSource)(source) ? source : new $3Xljf.Source(source);
        this._lexer = new $75iIV.Lexer(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken($iB3Qg.TokenKind.NAME);
        return {
            kind: $eWXut.Kind.NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: $eWXut.Kind.DOCUMENT,
            definitions: this.many($iB3Qg.TokenKind.SOF, this.parseDefinition, $iB3Qg.TokenKind.EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek($iB3Qg.TokenKind.NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek($iB3Qg.TokenKind.BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek($iB3Qg.TokenKind.BRACE_L)) return {
            kind: $eWXut.Kind.OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek($iB3Qg.TokenKind.NAME)) name = this.parseName();
        return {
            kind: $eWXut.Kind.OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken($iB3Qg.TokenKind.NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany($iB3Qg.TokenKind.PAREN_L, this.parseVariableDefinition, $iB3Qg.TokenKind.PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: $eWXut.Kind.VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken($iB3Qg.TokenKind.COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken($iB3Qg.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken($iB3Qg.TokenKind.DOLLAR);
        return {
            kind: $eWXut.Kind.VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: $eWXut.Kind.SELECTION_SET,
            selections: this.many($iB3Qg.TokenKind.BRACE_L, this.parseSelection, $iB3Qg.TokenKind.BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek($iB3Qg.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken($iB3Qg.TokenKind.COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: $eWXut.Kind.FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek($iB3Qg.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany($iB3Qg.TokenKind.PAREN_L, item, $iB3Qg.TokenKind.PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken($iB3Qg.TokenKind.COLON);
        return {
            kind: $eWXut.Kind.ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: $eWXut.Kind.ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken($iB3Qg.TokenKind.COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken($iB3Qg.TokenKind.SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek($iB3Qg.TokenKind.NAME)) return {
            kind: $eWXut.Kind.FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: $eWXut.Kind.INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: $eWXut.Kind.FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: $eWXut.Kind.FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case $iB3Qg.TokenKind.BRACKET_L:
                return this.parseList(isConst);
            case $iB3Qg.TokenKind.BRACE_L:
                return this.parseObject(isConst);
            case $iB3Qg.TokenKind.INT:
                this._lexer.advance();
                return {
                    kind: $eWXut.Kind.INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case $iB3Qg.TokenKind.FLOAT:
                this._lexer.advance();
                return {
                    kind: $eWXut.Kind.FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case $iB3Qg.TokenKind.STRING:
            case $iB3Qg.TokenKind.BLOCK_STRING:
                return this.parseStringLiteral();
            case $iB3Qg.TokenKind.NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: $eWXut.Kind.BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: $eWXut.Kind.BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: $eWXut.Kind.NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: $eWXut.Kind.ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case $iB3Qg.TokenKind.DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: $eWXut.Kind.STRING,
            value: token.value,
            block: token.kind === $iB3Qg.TokenKind.BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: $eWXut.Kind.LIST,
            values: this.any($iB3Qg.TokenKind.BRACKET_L, item, $iB3Qg.TokenKind.BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: $eWXut.Kind.OBJECT,
            fields: this.any($iB3Qg.TokenKind.BRACE_L, item, $iB3Qg.TokenKind.BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken($iB3Qg.TokenKind.COLON);
        return {
            kind: $eWXut.Kind.OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek($iB3Qg.TokenKind.AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken($iB3Qg.TokenKind.AT);
        return {
            kind: $eWXut.Kind.DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken($iB3Qg.TokenKind.BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken($iB3Qg.TokenKind.BRACKET_R);
            type = {
                kind: $eWXut.Kind.LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken($iB3Qg.TokenKind.BANG)) return {
            kind: $eWXut.Kind.NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: $eWXut.Kind.NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === $iB3Qg.TokenKind.NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek($iB3Qg.TokenKind.STRING) || this.peek($iB3Qg.TokenKind.BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many($iB3Qg.TokenKind.BRACE_L, this.parseOperationTypeDefinition, $iB3Qg.TokenKind.BRACE_R);
        return {
            kind: $eWXut.Kind.SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken($iB3Qg.TokenKind.COLON);
        var type = this.parseNamedType();
        return {
            kind: $eWXut.Kind.OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: $eWXut.Kind.SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: $eWXut.Kind.OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken($iB3Qg.TokenKind.AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken($iB3Qg.TokenKind.AMP) || this.peek($iB3Qg.TokenKind.NAME));
            return types;
        }
        return this.delimitedMany($iB3Qg.TokenKind.AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek($iB3Qg.TokenKind.BRACE_L) && this._lexer.lookahead().kind === $iB3Qg.TokenKind.BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany($iB3Qg.TokenKind.BRACE_L, this.parseFieldDefinition, $iB3Qg.TokenKind.BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken($iB3Qg.TokenKind.COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: $eWXut.Kind.FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany($iB3Qg.TokenKind.PAREN_L, this.parseInputValueDef, $iB3Qg.TokenKind.PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken($iB3Qg.TokenKind.COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken($iB3Qg.TokenKind.EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: $eWXut.Kind.INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: $eWXut.Kind.INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: $eWXut.Kind.UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken($iB3Qg.TokenKind.EQUALS) ? this.delimitedMany($iB3Qg.TokenKind.PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: $eWXut.Kind.ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany($iB3Qg.TokenKind.BRACE_L, this.parseEnumValueDefinition, $iB3Qg.TokenKind.BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: $eWXut.Kind.ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: $eWXut.Kind.INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany($iB3Qg.TokenKind.BRACE_L, this.parseInputValueDef, $iB3Qg.TokenKind.BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === $iB3Qg.TokenKind.NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany($iB3Qg.TokenKind.BRACE_L, this.parseOperationTypeDefinition, $iB3Qg.TokenKind.BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $eWXut.Kind.INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken($iB3Qg.TokenKind.AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: $eWXut.Kind.DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany($iB3Qg.TokenKind.PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ($6fb3a.DirectiveLocation[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new $3ilOD.Location(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $4TL3u.syntaxError)(this._lexer.source, token.start, "Expected ".concat($04ceaeaa35d65175$var$getTokenKindDesc(kind), ", found ").concat($04ceaeaa35d65175$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === $iB3Qg.TokenKind.NAME && token.value === value) this._lexer.advance();
        else throw (0, $4TL3u.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($04ceaeaa35d65175$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === $iB3Qg.TokenKind.NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $4TL3u.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($04ceaeaa35d65175$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ module.exports.Parser = $04ceaeaa35d65175$var$Parser;
function $04ceaeaa35d65175$var$getTokenDesc(token) {
    var value = token.value;
    return $04ceaeaa35d65175$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $04ceaeaa35d65175$var$getTokenKindDesc(kind) {
    return (0, $75iIV.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("6fb3a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveLocation = void 0;
/**
 * The set of allowed directive location values.
 */ var $48bcb71eabd72833$var$DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */ module.exports.DirectiveLocation = $48bcb71eabd72833$var$DirectiveLocation;

});


parcelRegister("aGu3k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $7c75237cd7407eec$var$print;

var $6p2DZ = parcelRequire("6p2DZ");

var $jyi0s = parcelRequire("jyi0s");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $7c75237cd7407eec$var$print(ast) {
    return (0, $6p2DZ.visit)(ast, {
        leave: $7c75237cd7407eec$var$printDocASTReducer
    });
}
var $7c75237cd7407eec$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $7c75237cd7407eec$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $7c75237cd7407eec$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(node.variableDefinitions, ', '), ')');
        var directives = $7c75237cd7407eec$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $7c75237cd7407eec$var$join([
            op,
            $7c75237cd7407eec$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $7c75237cd7407eec$var$wrap(' = ', defaultValue) + $7c75237cd7407eec$var$wrap(' ', $7c75237cd7407eec$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $7c75237cd7407eec$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3["arguments"], directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $7c75237cd7407eec$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(args, ', '), ')');
        if (argsLine.length > $7c75237cd7407eec$var$MAX_LINE_LENGTH) argsLine = prefix + $7c75237cd7407eec$var$wrap('(\n', $7c75237cd7407eec$var$indent($7c75237cd7407eec$var$join(args, '\n')), '\n)');
        return $7c75237cd7407eec$var$join([
            argsLine,
            $7c75237cd7407eec$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $7c75237cd7407eec$var$wrap(' ', $7c75237cd7407eec$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $7c75237cd7407eec$var$join([
            '...',
            $7c75237cd7407eec$var$wrap('on ', typeCondition),
            $7c75237cd7407eec$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($7c75237cd7407eec$var$wrap('', $7c75237cd7407eec$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $jyi0s.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $7c75237cd7407eec$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $7c75237cd7407eec$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16["arguments"];
        return '@' + name + $7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $7c75237cd7407eec$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $7c75237cd7407eec$var$join([
            'schema',
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $7c75237cd7407eec$var$join([
            'scalar',
            name,
            $7c75237cd7407eec$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $7c75237cd7407eec$var$join([
            'type',
            name,
            $7c75237cd7407eec$var$wrap('implements ', $7c75237cd7407eec$var$join(interfaces, ' & ')),
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $7c75237cd7407eec$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24["arguments"], type = _ref24.type, directives = _ref24.directives;
        return name + ($7c75237cd7407eec$var$hasMultilineItems(args) ? $7c75237cd7407eec$var$wrap('(\n', $7c75237cd7407eec$var$indent($7c75237cd7407eec$var$join(args, '\n')), '\n)') : $7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(args, ', '), ')')) + ': ' + type + $7c75237cd7407eec$var$wrap(' ', $7c75237cd7407eec$var$join(directives, ' '));
    }),
    InputValueDefinition: $7c75237cd7407eec$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $7c75237cd7407eec$var$join([
            name + ': ' + type,
            $7c75237cd7407eec$var$wrap('= ', defaultValue),
            $7c75237cd7407eec$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $7c75237cd7407eec$var$join([
            'interface',
            name,
            $7c75237cd7407eec$var$wrap('implements ', $7c75237cd7407eec$var$join(interfaces, ' & ')),
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $7c75237cd7407eec$var$join([
            'union',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $7c75237cd7407eec$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $7c75237cd7407eec$var$join([
            'enum',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $7c75237cd7407eec$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $7c75237cd7407eec$var$join([
            name,
            $7c75237cd7407eec$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $7c75237cd7407eec$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $7c75237cd7407eec$var$join([
            'input',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $7c75237cd7407eec$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31["arguments"], repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($7c75237cd7407eec$var$hasMultilineItems(args) ? $7c75237cd7407eec$var$wrap('(\n', $7c75237cd7407eec$var$indent($7c75237cd7407eec$var$join(args, '\n')), '\n)') : $7c75237cd7407eec$var$wrap('(', $7c75237cd7407eec$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $7c75237cd7407eec$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $7c75237cd7407eec$var$join([
            'extend schema',
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $7c75237cd7407eec$var$join([
            'extend scalar',
            name,
            $7c75237cd7407eec$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $7c75237cd7407eec$var$join([
            'extend type',
            name,
            $7c75237cd7407eec$var$wrap('implements ', $7c75237cd7407eec$var$join(interfaces, ' & ')),
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $7c75237cd7407eec$var$join([
            'extend interface',
            name,
            $7c75237cd7407eec$var$wrap('implements ', $7c75237cd7407eec$var$join(interfaces, ' & ')),
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $7c75237cd7407eec$var$join([
            'extend union',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $7c75237cd7407eec$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $7c75237cd7407eec$var$join([
            'extend enum',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $7c75237cd7407eec$var$join([
            'extend input',
            name,
            $7c75237cd7407eec$var$join(directives, ' '),
            $7c75237cd7407eec$var$block(fields)
        ], ' ');
    }
};
function $7c75237cd7407eec$var$addDescription(cb) {
    return function(node) {
        return $7c75237cd7407eec$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $7c75237cd7407eec$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $7c75237cd7407eec$var$block(array) {
    return $7c75237cd7407eec$var$wrap('{\n', $7c75237cd7407eec$var$indent($7c75237cd7407eec$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $7c75237cd7407eec$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $7c75237cd7407eec$var$indent(str) {
    return $7c75237cd7407eec$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $7c75237cd7407eec$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $7c75237cd7407eec$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($7c75237cd7407eec$var$isMultiline);
}

});
parcelRegister("6p2DZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $4a9720e65b530a05$var$visit;
module.exports.visitInParallel = $4a9720e65b530a05$var$visitInParallel;
module.exports.getVisitFn = $4a9720e65b530a05$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $4a9720e65b530a05$var$_inspect = $4a9720e65b530a05$var$_interopRequireDefault((parcelRequire("eJPX0")));

var $3ilOD = parcelRequire("3ilOD");
function $4a9720e65b530a05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4a9720e65b530a05$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $4a9720e65b530a05$var$QueryDocumentKeys;
var $4a9720e65b530a05$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $4a9720e65b530a05$var$BREAK;
function $4a9720e65b530a05$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $4a9720e65b530a05$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $3ilOD.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $4a9720e65b530a05$var$_inspect["default"])(node), "."));
            var visitFn = $4a9720e65b530a05$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $4a9720e65b530a05$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $3ilOD.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $4a9720e65b530a05$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $4a9720e65b530a05$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $4a9720e65b530a05$var$BREAK) skipping[i] = $4a9720e65b530a05$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $4a9720e65b530a05$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $4a9720e65b530a05$var$BREAK) skipping[i] = $4a9720e65b530a05$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $4a9720e65b530a05$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRegister("kMO9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefinitionNode = $f21f32d2d175afdc$var$isDefinitionNode;
module.exports.isExecutableDefinitionNode = $f21f32d2d175afdc$var$isExecutableDefinitionNode;
module.exports.isSelectionNode = $f21f32d2d175afdc$var$isSelectionNode;
module.exports.isValueNode = $f21f32d2d175afdc$var$isValueNode;
module.exports.isTypeNode = $f21f32d2d175afdc$var$isTypeNode;
module.exports.isTypeSystemDefinitionNode = $f21f32d2d175afdc$var$isTypeSystemDefinitionNode;
module.exports.isTypeDefinitionNode = $f21f32d2d175afdc$var$isTypeDefinitionNode;
module.exports.isTypeSystemExtensionNode = $f21f32d2d175afdc$var$isTypeSystemExtensionNode;
module.exports.isTypeExtensionNode = $f21f32d2d175afdc$var$isTypeExtensionNode;

var $eWXut = parcelRequire("eWXut");
function $f21f32d2d175afdc$var$isDefinitionNode(node) {
    return $f21f32d2d175afdc$var$isExecutableDefinitionNode(node) || $f21f32d2d175afdc$var$isTypeSystemDefinitionNode(node) || $f21f32d2d175afdc$var$isTypeSystemExtensionNode(node);
}
function $f21f32d2d175afdc$var$isExecutableDefinitionNode(node) {
    return node.kind === $eWXut.Kind.OPERATION_DEFINITION || node.kind === $eWXut.Kind.FRAGMENT_DEFINITION;
}
function $f21f32d2d175afdc$var$isSelectionNode(node) {
    return node.kind === $eWXut.Kind.FIELD || node.kind === $eWXut.Kind.FRAGMENT_SPREAD || node.kind === $eWXut.Kind.INLINE_FRAGMENT;
}
function $f21f32d2d175afdc$var$isValueNode(node) {
    return node.kind === $eWXut.Kind.VARIABLE || node.kind === $eWXut.Kind.INT || node.kind === $eWXut.Kind.FLOAT || node.kind === $eWXut.Kind.STRING || node.kind === $eWXut.Kind.BOOLEAN || node.kind === $eWXut.Kind.NULL || node.kind === $eWXut.Kind.ENUM || node.kind === $eWXut.Kind.LIST || node.kind === $eWXut.Kind.OBJECT;
}
function $f21f32d2d175afdc$var$isTypeNode(node) {
    return node.kind === $eWXut.Kind.NAMED_TYPE || node.kind === $eWXut.Kind.LIST_TYPE || node.kind === $eWXut.Kind.NON_NULL_TYPE;
}
function $f21f32d2d175afdc$var$isTypeSystemDefinitionNode(node) {
    return node.kind === $eWXut.Kind.SCHEMA_DEFINITION || $f21f32d2d175afdc$var$isTypeDefinitionNode(node) || node.kind === $eWXut.Kind.DIRECTIVE_DEFINITION;
}
function $f21f32d2d175afdc$var$isTypeDefinitionNode(node) {
    return node.kind === $eWXut.Kind.SCALAR_TYPE_DEFINITION || node.kind === $eWXut.Kind.OBJECT_TYPE_DEFINITION || node.kind === $eWXut.Kind.INTERFACE_TYPE_DEFINITION || node.kind === $eWXut.Kind.UNION_TYPE_DEFINITION || node.kind === $eWXut.Kind.ENUM_TYPE_DEFINITION || node.kind === $eWXut.Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function $f21f32d2d175afdc$var$isTypeSystemExtensionNode(node) {
    return node.kind === $eWXut.Kind.SCHEMA_EXTENSION || $f21f32d2d175afdc$var$isTypeExtensionNode(node);
}
function $f21f32d2d175afdc$var$isTypeExtensionNode(node) {
    return node.kind === $eWXut.Kind.SCALAR_TYPE_EXTENSION || node.kind === $eWXut.Kind.OBJECT_TYPE_EXTENSION || node.kind === $eWXut.Kind.INTERFACE_TYPE_EXTENSION || node.kind === $eWXut.Kind.UNION_TYPE_EXTENSION || node.kind === $eWXut.Kind.ENUM_TYPE_EXTENSION || node.kind === $eWXut.Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("7oPrC", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $2ej16 = parcelRequire("2ej16");

var $iWwCt = parcelRequire("iWwCt");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * Utilities for conversion.
 */ var $5632ae174d935683$var$Util = /*#__PURE__*/ function() {
    function Util(settings) {
        (0, $jGAMp._)(this, Util);
        this.nodeHandlers = {};
        this.nodeValueHandlers = {};
        this.directiveNodeHandlers = {};
        this.settings = settings;
        this.dataFactory = settings.dataFactory || new $2ej16.DataFactory();
        this.operationFactory = new $hSHd8.Factory(this.dataFactory);
        this.contextParser = new $iWwCt.ContextParser();
    }
    (0, $byiyg._)(Util, [
        {
            /**
     * Register a new {@link NodeHandlerAdapter}.
     * @param {NodeHandlerAdapter<any>} nodeHandler A handler for converting GraphQL nodes to operations.
     */ key: "registerNodeHandler",
            value: function registerNodeHandler(nodeHandler) {
                this.nodeHandlers[nodeHandler.targetKind] = nodeHandler;
            }
        },
        {
            /**
     * Register a new {@link NodeValueHandlerAdapter}
     * @param {NodeValueHandlerAdapter<any>} nodeValueHandler A handler for converting GraphQL value nodes
     *                                                        to terms and patterns.
     */ key: "registerNodeValueHandler",
            value: function registerNodeValueHandler(nodeValueHandler) {
                this.nodeValueHandlers[nodeValueHandler.targetKind] = nodeValueHandler;
            }
        },
        {
            /**
     * Register a new {@link DirectiveNodeHandlerAdapter}
     * @param {DirectiveNodeHandlerAdapter} directiveNodeHandler A handler for handling GraphQL directives.
     */ key: "registerDirectiveNodeHandler",
            value: function registerDirectiveNodeHandler(directiveNodeHandler) {
                this.directiveNodeHandlers[directiveNodeHandler.targetKind] = directiveNodeHandler;
            }
        },
        {
            /**
     * Get the operation for the given GraphQL node.
     * @param {T} node A GraphQL node.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {Operation} A SPARQL algebra operation.
     */ key: "handleNode",
            value: function handleNode(node, convertContext) {
                var nodeHandler = this.nodeHandlers[node.kind];
                if (!nodeHandler) throw new Error("Unsupported GraphQL node '".concat(node.kind, "'"));
                return nodeHandler.handle(node, convertContext);
            }
        },
        {
            /**
     * Get the terms and patterns for the given value node.
     * @param {T} node A GraphQL node.
     * @param {string} fieldName The name of the field or argument in which the value was encapsulated.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IValueNodeHandlerOutput} The RDF terms and patterns.
     */ key: "handleNodeValue",
            value: function handleNodeValue(node, fieldName, convertContext) {
                var nodeValueHandler = this.nodeValueHandlers[node.kind];
                if (!nodeValueHandler) throw new Error("Unsupported GraphQL value node '".concat(node.kind, "'"));
                return nodeValueHandler.handle(node, fieldName, convertContext);
            }
        },
        {
            /**
     * Get the handler output for the given directive.
     * @param {IDirectiveContext} directiveContext The current directive context.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IDirectiveNodeHandlerOutput} The directive node handler output or null.
     */ key: "handleDirectiveNode",
            value: function handleDirectiveNode(directiveContext, convertContext) {
                var directiveNodeHandler = this.directiveNodeHandlers[directiveContext.directive.name.value];
                if (!directiveNodeHandler) return null;
                return directiveNodeHandler.handle(directiveContext, convertContext);
            }
        },
        {
            /**
     * Join the given array of operations.
     * If all operations are BGPs, then a single big BGP with all patterns from the given BGPs will be created.
     * @param {Operation[]} operations An array of operations.
     * @return {Operation} A single joined operation.
     */ key: "joinOperations",
            value: function joinOperations(operations) {
                if (operations.length === 1) return operations[0];
                // Check if which operations are BGPs
                var bgps = [];
                var nonBgps = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var operation = _step.value;
                        if (operation.type === 'bgp') bgps.push(operation);
                        else nonBgps.push(operation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (bgps.length === operations.length) // Create a big BGP from all BGPs
                return this.joinOperationsAsBgp(bgps);
                else if (bgps.length === operations.length - 1 && nonBgps[0].type === 'leftjoin' && nonBgps[0].input[0].type === 'bgp') {
                    // Check if we have one left-join (with a BGP on the left), and the rest are BGPs.
                    // If so, merge the BGPS within the left-hand-side of the left-join.
                    var originalLeftJoin = nonBgps[0];
                    bgps.push(originalLeftJoin.input[0]);
                    return this.operationFactory.createLeftJoin(this.joinOperationsAsBgp(bgps), originalLeftJoin.input[1]);
                } else if (nonBgps.length === operations.length) // Create nested joins
                return this.joinOperationsAsNestedJoin(nonBgps);
                else // Join as much BGPs together as possible, and join with the other operations
                return this.joinOperationsAsNestedJoin([
                    this.joinOperationsAsBgp(bgps),
                    this.joinOperationsAsNestedJoin(nonBgps)
                ]);
            }
        },
        {
            key: "joinOperationsAsBgp",
            value: function joinOperationsAsBgp(operations) {
                return this.operationFactory.createBgp([].concat.apply([], operations.map(function(op) {
                    return op.patterns;
                })));
            }
        },
        {
            key: "joinOperationsAsNestedJoin",
            value: function joinOperationsAsNestedJoin(operations) {
                return this.operationFactory.createJoin(operations);
            }
        },
        {
            /**
     * Append a field's label to a path.
     * @param {string[]} path A path.
     * @param {string} fieldLabel A field label.
     * @return {string[]} A new path array.
     */ key: "appendFieldToPath",
            value: function appendFieldToPath(path, fieldLabel) {
                return path.concat([
                    fieldLabel
                ]);
            }
        },
        {
            /**
     * Get the label of a field by taking into account the alias.
     * @param {FieldNode} field A field node.
     * @return {string} The field name or alias.
     */ key: "getFieldLabel",
            value: function getFieldLabel(field) {
                return (field.alias ? field.alias : field.name).value;
            }
        },
        {
            /**
     * Convert a field node to a variable built from the node name and the current path inside the context.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @param {string} variableDelimiter A variable delimiter.
     * @return {Variable} A variable.
     */ key: "nameToVariable",
            value: function nameToVariable(fieldLabel, convertContext) {
                return this.dataFactory.variable((convertContext.path.length ? convertContext.path.join(this.settings.variableDelimiter) + this.settings.variableDelimiter : '') + fieldLabel);
            }
        },
        {
            /**
     * Convert a GraphQL term into a URI using the given context.
     * @param {string} value A GraphQL term.
     * @param {IContext} context A JSON-LD context.
     * @return {NamedNode} A named node.
     */ key: "valueToNamedNode",
            value: function valueToNamedNode(value, context) {
                var contextValue = context.expandTerm(value, true);
                if (this.settings.requireContext && !contextValue) throw new Error('No context entry was found for ' + value);
                return this.dataFactory.namedNode(contextValue || value);
            }
        },
        {
            /**
     * Get an argument by name.
     * This will return null if the argument could not be found.
     * @param {ReadonlyArray<ArgumentNode>} args Arguments or null.
     * @param {string} name The name of an argument.
     * @return {ArgumentNode} The named argument.
     */ key: "getArgument",
            value: function getArgument(args, name) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (args) try {
                    for(var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var argument = _step.value;
                        if (argument.name.value === name) return argument;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Create a pattern with an rdf:type predicate.
     * @param {Term} subject The subject.
     * @param {NamedTypeNode} typeCondition The object name.
     * @param {IConvertContext} convertContext A convert context.
     * @return {Pattern} A pattern.
     */ key: "newTypePattern",
            value: function newTypePattern(subject, typeCondition, convertContext) {
                return this.operationFactory.createPattern(subject, this.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), this.valueToNamedNode(typeCondition.name.value, convertContext.context), convertContext.graph);
            }
        },
        {
            /**
     * Create a quad pattern when the predicate is a name node that needs to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Pattern} A quad pattern.
     */ key: "createQuadPattern",
            value: function createQuadPattern(subject, predicateName, object, graph, context) {
                var predicate = this.valueToNamedNode(predicateName.value, context);
                if (context && context.getContextRaw()[predicateName.value] && context.getContextRaw()[predicateName.value]['@reverse']) return this.operationFactory.createPattern(object, predicate, subject, graph);
                return this.operationFactory.createPattern(subject, predicate, object, graph);
            }
        },
        {
            /**
     * Create a quad path when the predicate is a list node with field alternatives
     * that need to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Path} A quad property path.
     */ key: "createQuadPath",
            value: function createQuadPath(subject, predicateName, predicateAlternatives, object, graph, context) {
                var predicateInitial = this.valueToNamedNode(predicateName.value, context);
                var pathSymbol = this.operationFactory.createLink(predicateInitial);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Add all fields in the list as predicate alternatives
                    for(var _iterator = predicateAlternatives.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var predicateAlternative = _step.value;
                        if (predicateAlternative.kind !== 'EnumValue') throw new Error('Invalid value type for \'alt\' argument, must be EnumValue, but got ' + predicateAlternative.kind);
                        pathSymbol = this.operationFactory.createAlt([
                            pathSymbol,
                            this.operationFactory.createLink(this.valueToNamedNode(predicateAlternative.value, context))
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Reverse the path based on the initial predicate
                if (context && context.getContextRaw()[predicateName.value] && context.getContextRaw()[predicateName.value]['@reverse']) return this.operationFactory.createPath(object, pathSymbol, subject, graph);
                return this.operationFactory.createPath(subject, pathSymbol, object, graph);
            }
        }
    ]);
    return Util;
}();
module.exports.Util = $5632ae174d935683$var$Util;

});
parcelRegister("iWwCt", function(module, exports) {
"use strict";
var $dca6f25863797c32$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dca6f25863797c32$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dca6f25863797c32$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dca6f25863797c32$var$__exportStar((parcelRequire("l83za")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("fTLSW")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("bozcm")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("dX1cl")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("kisoS")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("dSZo5")), module.exports);

$dca6f25863797c32$var$__exportStar((parcelRequire("a9M6x")), module.exports);

});
parcelRegister("l83za", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $fTLSW = parcelRequire("fTLSW");

var $bozcm = parcelRequire("bozcm");

var $dSZo5 = parcelRequire("dSZo5");

var $a9M6x = parcelRequire("a9M6x");
/**
 * Parses JSON-LD contexts.
 */ var $f61d1c7d96baf77b$var$ContextParser = /*#__PURE__*/ function() {
    function ContextParser(options) {
        (0, $jGAMp._)(this, ContextParser);
        options = options || {};
        this.documentLoader = options.documentLoader || new $bozcm.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
    (0, $byiyg._)(ContextParser, [
        {
            /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ key: "idifyReverseTerms",
            value: function idifyReverseTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (value['@reverse'] && !value['@id']) {
                                if (typeof value['@reverse'] !== 'string' || $a9M6x.Util.isValidKeyword(value['@reverse'])) throw new $fTLSW.ErrorCoded("Invalid @reverse value, must be absolute IRI or blank node: '".concat(value['@reverse'], "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                value = context[key] = Object.assign(Object.assign({}, value), {
                                    '@id': value['@reverse']
                                });
                                value['@id'] = value['@reverse'];
                                if ($a9M6x.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                                else value['@reverse'] = true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return context;
            }
        },
        {
            /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ key: "expandPrefixedTerms",
            value: function expandPrefixedTerms(context, expandContentTypeToBase, keys) {
                var contextRaw = context.getContextRaw();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys || Object.keys(contextRaw))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Only expand allowed keys
                        if ($a9M6x.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$a9M6x.Util.isReservedInternalKeyword(key)) {
                            // Error if we try to alias a keyword to something else.
                            var keyValue = contextRaw[key];
                            if ($a9M6x.Util.isPotentialKeyword(key) && $a9M6x.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                                if (key !== '@type' || (0, $3KZcf._)(contextRaw[key]) === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $fTLSW.ErrorCoded("Keywords can not be aliased to something else.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $fTLSW.ERROR_CODES.KEYWORD_REDEFINITION);
                            }
                            // Error if we try to alias to an illegal keyword
                            if ($a9M6x.Util.ALIAS_RANGE_BLACKLIST.indexOf($a9M6x.Util.getContextValueId(keyValue)) >= 0) throw new $fTLSW.ErrorCoded("Aliasing to certain keywords is not allowed.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $fTLSW.ERROR_CODES.INVALID_KEYWORD_ALIAS);
                            // Error if this term was marked as prefix as well
                            if (keyValue && $a9M6x.Util.isPotentialKeyword($a9M6x.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $fTLSW.ErrorCoded("Tried to use keyword aliases as prefix: '".concat(key, "': '").concat(JSON.stringify(keyValue), "'"), $fTLSW.ERROR_CODES.INVALID_TERM_DEFINITION);
                            // Loop because prefixes might be nested
                            while($a9M6x.Util.isPrefixValue(contextRaw[key])){
                                var value = contextRaw[key];
                                var changed = false;
                                if (typeof value === 'string') {
                                    contextRaw[key] = context.expandTerm(value, true);
                                    changed = changed || value !== contextRaw[key];
                                } else {
                                    var id = value['@id'];
                                    var type = value['@type'];
                                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                                    var canAddIdEntry = !('@prefix' in value) || $a9M6x.Util.isValidIri(key);
                                    if ('@id' in value) // Use @id value for expansion
                                    {
                                        if (id !== undefined && id !== null && typeof id === 'string') {
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': context.expandTerm(id, true)
                                            });
                                            changed = changed || id !== contextRaw[key]['@id'];
                                        }
                                    } else if (!$a9M6x.Util.isPotentialKeyword(key) && canAddIdEntry) {
                                        // Add an explicit @id value based on the expanded key value
                                        var newId = context.expandTerm(key, true);
                                        if (newId !== key) {
                                            // Don't set @id if expansion failed
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': newId
                                            });
                                            changed = true;
                                        }
                                    }
                                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                                        // First check @vocab, then fallback to @base
                                        var expandedType = context.expandTerm(type, true);
                                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                                        if (expandedType !== type) {
                                            changed = true;
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@type': expandedType
                                            });
                                        }
                                    }
                                }
                                if (!changed) break;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ key: "normalize",
            value: function normalize(context, param) {
                var processingMode = param.processingMode, normalizeLanguageTags = param.normalizeLanguageTags;
                // Lowercase language keys in 1.0
                if (normalizeLanguageTags || processingMode === 1.0) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
                            else {
                                var value = context[key];
                                if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                    if (typeof value['@language'] === 'string') {
                                        var lowercase = value['@language'].toLowerCase();
                                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                                            '@language': lowercase
                                        });
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ key: "containersToHash",
            value: function containersToHash(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                                '@container': (0, $cqEAj._)({}, value['@container'], true)
                            });
                            else if (Array.isArray(value['@container'])) {
                                var newValue = {};
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = value['@container'][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var containerValue = _step1.value;
                                        newValue[containerValue] = true;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                context[key] = Object.assign(Object.assign({}, value), {
                                    '@container': newValue
                                });
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ key: "applyScopedProtected",
            value: function applyScopedProtected(context, param, expandOptions) {
                var processingMode = param.processingMode;
                if (processingMode && processingMode >= 1.1) {
                    if (context['@protected']) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var key = _step.value;
                                if ($a9M6x.Util.isReservedInternalKeyword(key)) continue;
                                if (!$a9M6x.Util.isPotentialKeyword(key) && !$a9M6x.Util.isTermProtected(context, key)) {
                                    var value = context[key];
                                    if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                        if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                                        context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@protected': true
                                        });
                                    } else {
                                        // Convert string-based term values to object-based values with @protected: true
                                        context[key] = {
                                            '@id': value,
                                            '@protected': true
                                        };
                                        if ($a9M6x.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@prefix': true
                                        });
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        delete context['@protected'];
                    }
                }
            }
        },
        {
            /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ key: "validateKeywordRedefinitions",
            value: function validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if ($a9M6x.Util.isTermProtected(contextBefore, key)) {
                            // The entry in the context before will always be in object-mode
                            // If the new entry is in string-mode, convert it to object-mode
                            // before checking if it is identical.
                            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                                '@id': contextAfter[key],
                                '@protected': true
                            };
                            else // We modify this deliberately,
                            // as we need it for the value comparison (they must be identical modulo '@protected')),
                            // and for the fact that this new value will override the first one.
                            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                                '@protected': true
                            });
                            // Error if they are not identical
                            if (!$a9M6x.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $fTLSW.ErrorCoded("Attempted to override the protected keyword ".concat(key, " from ").concat(JSON.stringify($a9M6x.Util.getContextValueId(contextBefore[key])), " to ").concat(JSON.stringify($a9M6x.Util.getContextValueId(contextAfter[key]))), $fTLSW.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ key: "validate",
            value: function validate(context, param) {
                var processingMode = param.processingMode;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Ignore reserved internal keywords.
                        if ($a9M6x.Util.isReservedInternalKeyword(key)) continue;
                        // Do not allow empty term
                        if (key === '') throw new $fTLSW.ErrorCoded("The empty term is not allowed, got: '".concat(key, "': '").concat(JSON.stringify(context[key]), "'"), $fTLSW.ERROR_CODES.INVALID_TERM_DEFINITION);
                        var value = context[key];
                        var valueType = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
                        // First check if the key is a keyword
                        if ($a9M6x.Util.isPotentialKeyword(key)) {
                            switch(key.substr(1)){
                                case 'vocab':
                                    if (value !== null && valueType !== 'string') throw new $fTLSW.ErrorCoded("Found an invalid @vocab IRI: ".concat(value), $fTLSW.ERROR_CODES.INVALID_VOCAB_MAPPING);
                                    break;
                                case 'base':
                                    if (value !== null && valueType !== 'string') throw new $fTLSW.ErrorCoded("Found an invalid @base IRI: ".concat(context[key]), $fTLSW.ERROR_CODES.INVALID_BASE_IRI);
                                    break;
                                case 'language':
                                    if (value !== null) ContextParser.validateLanguage(value, true, $fTLSW.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                                    break;
                                case 'version':
                                    if (value !== null && valueType !== 'number') throw new $fTLSW.ErrorCoded("Found an invalid @version number: ".concat(value), $fTLSW.ERROR_CODES.INVALID_VERSION_VALUE);
                                    break;
                                case 'direction':
                                    if (value !== null) ContextParser.validateDirection(value, true);
                                    break;
                                case 'propagate':
                                    if (processingMode === 1.0) throw new $fTLSW.ErrorCoded("Found an illegal @propagate keyword: ".concat(value), $fTLSW.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                    if (value !== null && valueType !== 'boolean') throw new $fTLSW.ErrorCoded("Found an invalid @propagate value: ".concat(value), $fTLSW.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                                    break;
                            }
                            // Don't allow keywords to be overridden
                            if ($a9M6x.Util.isValidKeyword(key) && $a9M6x.Util.isValidKeyword($a9M6x.Util.getContextValueId(value))) throw new $fTLSW.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat($a9M6x.Util.getContextValueId(value), "'"), $fTLSW.ERROR_CODES.KEYWORD_REDEFINITION);
                            continue;
                        }
                        // Otherwise, consider the key a term
                        if (value !== null) switch(valueType){
                            case 'string':
                                if ($a9M6x.Util.getPrefix(value, context) === key) throw new $fTLSW.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                if ($a9M6x.Util.isValidIriWeak(key)) {
                                    if (value === '@type') throw new $fTLSW.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(value, "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($a9M6x.Util.isValidIri(value) && value !== new $dSZo5.JsonLdContextNormalized(context).expandTerm(key)) throw new $fTLSW.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(value, "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                break;
                            case 'object':
                                if (!$a9M6x.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $fTLSW.ErrorCoded("Missing @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Object.keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var objectKey = _step1.value;
                                        var objectValue = value[objectKey];
                                        if (!objectValue) continue;
                                        switch(objectKey){
                                            case '@id':
                                                if ($a9M6x.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $fTLSW.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($a9M6x.Util.isValidIriWeak(key)) {
                                                    if (objectValue === '@type') throw new $fTLSW.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                                    else if ($a9M6x.Util.isValidIri(objectValue) && objectValue !== new $dSZo5.JsonLdContextNormalized(context).expandTerm(key)) throw new $fTLSW.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                                }
                                                if (typeof objectValue !== 'string') throw new $fTLSW.ErrorCoded("Detected non-string @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($a9M6x.Util.getPrefix(objectValue, context) === key) throw new $fTLSW.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                                break;
                                            case '@type':
                                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $fTLSW.ErrorCoded("@container: @type only allows @type: @id or @vocab, but got: '".concat(key, "': '").concat(objectValue, "'"), $fTLSW.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (typeof objectValue !== 'string') throw new $fTLSW.ErrorCoded("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"), $fTLSW.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$a9M6x.Util.isValidIri(objectValue))) throw new $fTLSW.ErrorCoded("A context @type must be an absolute IRI, found: '".concat(key, "': '").concat(objectValue, "'"), $fTLSW.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                break;
                                            case '@reverse':
                                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $fTLSW.ErrorCoded("Found non-matching @id and @reverse term values in '".concat(key, "':'").concat(objectValue, "' and '").concat(value['@id'], "'"), $fTLSW.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                if ('@nest' in value) throw new $fTLSW.ErrorCoded("@nest is not allowed in the reverse property '".concat(key, "'"), $fTLSW.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                break;
                                            case '@container':
                                                if (processingMode === 1.0) {
                                                    if (Object.keys(objectValue).length > 1 || $a9M6x.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $fTLSW.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(Object.keys(objectValue), "') in 1.0, must be only one of ").concat($a9M6x.Util.CONTAINERS_1_0.join(', ')), $fTLSW.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                }
                                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(var _iterator2 = Object.keys(objectValue)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        var containerValue = _step2.value;
                                                        if (containerValue === '@list' && value['@reverse']) throw new $fTLSW.ErrorCoded("Term value can not be @container: @list and @reverse at the same time on '".concat(key, "'"), $fTLSW.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                        if ($a9M6x.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $fTLSW.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(containerValue, "'), must be one of ").concat($a9M6x.Util.CONTAINERS.join(', ')), $fTLSW.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                            _iterator2["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                                break;
                                            case '@language':
                                                ContextParser.validateLanguage(objectValue, true, $fTLSW.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                                break;
                                            case '@direction':
                                                ContextParser.validateDirection(objectValue, true);
                                                break;
                                            case '@prefix':
                                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $fTLSW.ErrorCoded("Found an invalid term @prefix boolean in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_PREFIX_VALUE);
                                                if (!('@id' in value) && !$a9M6x.Util.isValidIri(key)) throw new $fTLSW.ErrorCoded("Invalid @prefix definition for '".concat(key, "' ('").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@index':
                                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $fTLSW.ErrorCoded("Attempt to add illegal key to value object: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@nest':
                                                if ($a9M6x.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $fTLSW.ErrorCoded("Found an invalid term @nest value in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_NEST_VALUE);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new $fTLSW.ErrorCoded("Found an invalid term value: '".concat(key, "': '").concat(value, "'"), $fTLSW.ERROR_CODES.INVALID_TERM_DEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ key: "applyBaseEntry",
            value: function applyBaseEntry(context, options, inheritFromParent) {
                // In some special cases, this can be a string, so ignore those.
                if (typeof context === 'string') return context;
                // Give priority to @base in the parent context
                if (inheritFromParent && !('@base' in context) && options.parentContext && (0, $3KZcf._)(options.parentContext) === 'object' && '@base' in options.parentContext) {
                    context['@base'] = options.parentContext['@base'];
                    if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
                }
                // Override the base IRI if provided.
                if (options.baseIRI && !options.external) {
                    if (!('@base' in context)) {
                        // The context base is the document base
                        context['@base'] = options.baseIRI;
                        context['@__baseDocument'] = true;
                    } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$a9M6x.Util.isValidIri(context['@base'])) // The context base is relative to the document base
                    context['@base'] = (0, $hDpjF.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
                }
                return context;
            }
        },
        {
            /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ key: "normalizeContextIri",
            value: function normalizeContextIri(contextIri, baseIRI) {
                if (!$a9M6x.Util.isValidIri(contextIri)) try {
                    contextIri = (0, $hDpjF.resolve)(contextIri, baseIRI);
                } catch (_a) {
                    throw new Error("Invalid context IRI: ".concat(contextIri));
                }
                // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
                if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
                return contextIri;
            }
        },
        {
            key: "parseInnerContexts",
            value: /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ function parseInnerContexts(context, options, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, value, parentContext, e, _, _tmp, _tmp1, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    11,
                                    12
                                ]);
                                _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(context))[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    9
                                ];
                                key = _step.value;
                                value = context[key];
                                if (!(value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object')) return [
                                    3,
                                    8
                                ];
                                if (!('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts)) return [
                                    3,
                                    8
                                ];
                                if (!this.validateContext) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                parentContext = Object.assign(Object.assign({}, context), (0, $cqEAj._)({}, key, Object.assign({}, context[key])));
                                delete parentContext[key]['@context'];
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        parentContext: parentContext,
                                        ignoreProtection: true,
                                        ignoreRemoteScopedContexts: true,
                                        ignoreScopedContexts: true
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                throw new $fTLSW.ErrorCoded(e.message, $fTLSW.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                            case 6:
                                _ = Object.assign;
                                _tmp = [
                                    Object.assign({}, value)
                                ];
                                _tmp1 = {};
                                _1 = '@context';
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        minimalProcessing: true,
                                        ignoreRemoteScopedContexts: true,
                                        parentContext: context
                                    }))
                                ];
                            case 7:
                                context[key] = _.apply(Object, _tmp.concat([
                                    (_tmp1[_1] = _state.sent().getContextRaw(), _tmp1)
                                ]));
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    context
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parse",
            value: function parse(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(context) {
                    var _this, options, // These options are only for internal use on recursive calls and should not be used by
                    // libraries consuming this function
                    internalOptions, baseIRI, parentContext, external, _options_processingMode, processingMode, normalizeLanguageTags, ignoreProtection, minimalProcessing, remoteContexts, contextIri, overriddenLoad, parsedStringContext, _, _1, contextIris, contexts, reducedContexts, importContext, newContext, keys, overlappingKeys, key, newContextWrapped;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, internalOptions = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                                baseIRI = options.baseIRI, parentContext = options.parentContext, external = options.external, _options_processingMode = options.processingMode, processingMode = _options_processingMode === void 0 ? ContextParser.DEFAULT_PROCESSING_MODE : _options_processingMode, normalizeLanguageTags = options.normalizeLanguageTags, ignoreProtection = options.ignoreProtection, minimalProcessing = options.minimalProcessing;
                                remoteContexts = options.remoteContexts || {};
                                // Avoid remote context overflows
                                if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $fTLSW.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $fTLSW.ERROR_CODES.CONTEXT_OVERFLOW);
                                if (!(context === null || context === undefined)) return [
                                    3,
                                    1
                                ];
                                // Don't allow context nullification and there are protected terms
                                if (!ignoreProtection && parentContext && $a9M6x.Util.hasProtectedTerms(parentContext)) throw new $fTLSW.ErrorCoded('Illegal context nullification when terms are protected', $fTLSW.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
                                // Context that are explicitly set to null are empty.
                                return [
                                    2,
                                    new $dSZo5.JsonLdContextNormalized(this.applyBaseEntry({}, options, false))
                                ];
                            case 1:
                                if (!(typeof context === 'string')) return [
                                    3,
                                    4
                                ];
                                contextIri = this.normalizeContextIri(context, baseIRI);
                                overriddenLoad = this.getOverriddenLoad(contextIri, options);
                                if (overriddenLoad) return [
                                    2,
                                    new $dSZo5.JsonLdContextNormalized(overriddenLoad)
                                ];
                                _1 = (_ = this).parse;
                                return [
                                    4,
                                    this.load(contextIri)
                                ];
                            case 2:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent(),
                                        Object.assign(Object.assign({}, options), {
                                            baseIRI: contextIri,
                                            external: true,
                                            remoteContexts: Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIri, true))
                                        })
                                    ])
                                ];
                            case 3:
                                parsedStringContext = _state.sent();
                                this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
                                return [
                                    2,
                                    parsedStringContext
                                ];
                            case 4:
                                if (!Array.isArray(context)) return [
                                    3,
                                    7
                                ];
                                // As a performance consideration, first load all external contexts in parallel.
                                contextIris = [];
                                return [
                                    4,
                                    Promise.all(context.map(function(subContext, i) {
                                        if (typeof subContext === 'string') {
                                            var contextIri = _this.normalizeContextIri(subContext, baseIRI);
                                            contextIris[i] = contextIri;
                                            var overriddenLoad = _this.getOverriddenLoad(contextIri, options);
                                            if (overriddenLoad) return overriddenLoad;
                                            return _this.load(contextIri);
                                        } else return subContext;
                                    }))
                                ];
                            case 5:
                                contexts = _state.sent();
                                // Don't apply inheritance logic on minimal processing
                                if (minimalProcessing) return [
                                    2,
                                    new $dSZo5.JsonLdContextNormalized(contexts)
                                ];
                                return [
                                    4,
                                    contexts.reduce(function(accContextPromise, contextEntry, i) {
                                        return accContextPromise.then(function(accContext) {
                                            return _this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                                                baseIRI: contextIris[i] || options.baseIRI,
                                                external: !!contextIris[i] || options.external,
                                                parentContext: accContext.getContextRaw(),
                                                remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIris[i], true)) : remoteContexts
                                            }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                                            {
                                                skipValidation: i < contexts.length - 1
                                            });
                                        });
                                    }, Promise.resolve(new $dSZo5.JsonLdContextNormalized(parentContext || {})))
                                ];
                            case 6:
                                reducedContexts = _state.sent();
                                // Override the base IRI if provided.
                                this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
                                return [
                                    2,
                                    reducedContexts
                                ];
                            case 7:
                                if (!((typeof context === "undefined" ? "undefined" : (0, $3KZcf._)(context)) === 'object')) return [
                                    3,
                                    14
                                ];
                                if (!('@context' in context)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.parse(context['@context'], options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                // Make a deep clone of the given context, to avoid modifying it.
                                context = Object.assign({}, context);
                                // According to the JSON-LD spec, @base must be ignored from external contexts.
                                if (external) delete context['@base'];
                                // Override the base IRI if provided.
                                this.applyBaseEntry(context, options, true);
                                // Hashify container entries
                                // Do this before protected term validation as that influences term format
                                this.containersToHash(context);
                                // Don't perform any other modifications if only minimal processing is needed.
                                if (minimalProcessing) return [
                                    2,
                                    new $dSZo5.JsonLdContextNormalized(context)
                                ];
                                // In JSON-LD 1.1, load @import'ed context prior to processing.
                                importContext = {};
                                if (!('@import' in context)) return [
                                    3,
                                    12
                                ];
                                if (!(processingMode >= 1.1)) return [
                                    3,
                                    11
                                ];
                                // Only accept string values
                                if (typeof context['@import'] !== 'string') throw new $fTLSW.ErrorCoded('An @import value must be a string, but got ' + (0, $3KZcf._)(context['@import']), $fTLSW.ERROR_CODES.INVALID_IMPORT_VALUE);
                                return [
                                    4,
                                    this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI))
                                ];
                            case 10:
                                // Load context
                                importContext = _state.sent();
                                delete context['@import'];
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                throw new $fTLSW.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $fTLSW.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                            case 12:
                                this.applyScopedProtected(importContext, {
                                    processingMode: processingMode
                                }, $dSZo5.defaultExpandOptions);
                                newContext = Object.assign(importContext, context);
                                // Handle terms (before protection checks)
                                this.idifyReverseTerms(newContext);
                                this.normalize(newContext, {
                                    processingMode: processingMode,
                                    normalizeLanguageTags: normalizeLanguageTags
                                });
                                this.applyScopedProtected(newContext, {
                                    processingMode: processingMode
                                }, $dSZo5.defaultExpandOptions);
                                keys = Object.keys(newContext);
                                overlappingKeys = [];
                                if ((typeof parentContext === "undefined" ? "undefined" : (0, $3KZcf._)(parentContext)) === 'object') {
                                    // Merge different parts of the final context in order
                                    for(var key in parentContext)if (key in newContext) overlappingKeys.push(key);
                                    else newContext[key] = parentContext[key];
                                }
                                // Parse inner contexts with minimal processing
                                return [
                                    4,
                                    this.parseInnerContexts(newContext, options, keys)
                                ];
                            case 13:
                                _state.sent();
                                newContextWrapped = new $dSZo5.JsonLdContextNormalized(newContext);
                                // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
                                if ((newContext && newContext['@version'] || ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                                    if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                                    else if ($a9M6x.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                                    newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
                                }
                                this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
                                // In JSON-LD 1.1, check if we are not redefining any protected keywords
                                if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $dSZo5.defaultExpandOptions, overlappingKeys);
                                if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                                    processingMode: processingMode
                                });
                                return [
                                    2,
                                    newContextWrapped
                                ];
                            case 14:
                                throw new $fTLSW.ErrorCoded("Tried parsing a context that is not a string, array or object, but got ".concat(context), $fTLSW.ERROR_CODES.INVALID_LOCAL_CONTEXT);
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "load",
            value: /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cached, document, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // First try to retrieve the context from cache
                                cached = this.documentCache[url];
                                if (cached) return [
                                    2,
                                    cached
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.documentLoader.load(url)
                                ];
                            case 2:
                                document = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                throw new $fTLSW.ErrorCoded("Failed to load remote context ".concat(url, ": ").concat(e.message), $fTLSW.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
                            case 4:
                                // Validate the context
                                if (!('@context' in document)) throw new $fTLSW.ErrorCoded("Missing @context in remote context at ".concat(url), $fTLSW.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                return [
                                    2,
                                    this.documentCache[url] = document['@context']
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ key: "getOverriddenLoad",
            value: function getOverriddenLoad(url, options) {
                if (url in (options.remoteContexts || {})) {
                    if (options.ignoreRemoteScopedContexts) return url;
                    else throw new $fTLSW.ErrorCoded('Detected a cyclic context inclusion of ' + url, $fTLSW.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
                }
                return null;
            }
        },
        {
            key: "loadImportContext",
            value: /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ function loadImportContext(importContextIri) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var importContext;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.load(importContextIri)
                                ];
                            case 1:
                                importContext = _state.sent();
                                // Require the context to be a non-array object
                                if ((typeof importContext === "undefined" ? "undefined" : (0, $3KZcf._)(importContext)) !== 'object' || Array.isArray(importContext)) throw new $fTLSW.ErrorCoded('An imported context must be a single object: ' + importContextIri, $fTLSW.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                // Error if the context contains another @import
                                if ('@import' in importContext) throw new $fTLSW.ErrorCoded('An imported context can not import another context: ' + importContextIri, $fTLSW.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                importContext = Object.assign({}, importContext);
                                // Containers have to be converted into hash values the same way as for the importing context
                                // Otherwise context validation will fail for container values
                                this.containersToHash(importContext);
                                return [
                                    2,
                                    importContext
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "validateLanguage",
            value: /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateLanguage(value, strictRange, errorCode) {
                if (typeof value !== 'string') throw new $fTLSW.ErrorCoded("The value of an '@language' must be a string, got '".concat(JSON.stringify(value), "'"), errorCode);
                if (!$a9M6x.Util.REGEX_LANGUAGE_TAG.test(value)) {
                    if (strictRange) throw new $fTLSW.ErrorCoded("The value of an '@language' must be a valid language tag, got '".concat(JSON.stringify(value), "'"), errorCode);
                    else return false;
                }
                return true;
            }
        },
        {
            key: "validateDirection",
            value: /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateDirection(value, strictValues) {
                if (typeof value !== 'string') throw new $fTLSW.ErrorCoded("The value of an '@direction' must be a string, got '".concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_BASE_DIRECTION);
                if (!$a9M6x.Util.REGEX_DIRECTION_TAG.test(value)) {
                    if (strictValues) throw new $fTLSW.ErrorCoded("The value of an '@direction' must be 'ltr' or 'rtl', got '".concat(JSON.stringify(value), "'"), $fTLSW.ERROR_CODES.INVALID_BASE_DIRECTION);
                    else return false;
                }
                return true;
            }
        }
    ]);
    return ContextParser;
}();
$f61d1c7d96baf77b$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $f61d1c7d96baf77b$var$ContextParser;

});
parcelRegister("hDpjF", function(module, exports) {
"use strict";
var $cd69b77476fb7500$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd69b77476fb7500$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd69b77476fb7500$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd69b77476fb7500$var$__exportStar((parcelRequire("32wB6")), module.exports);

});
parcelRegister("32wB6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeDotSegmentsOfPath = module.exports.removeDotSegments = module.exports.resolve = void 0;
/**
 * Convert the given relative IRI to an absolute IRI
 * by taking into account the given optional baseIRI.
 *
 * @param {string} relativeIRI The relative IRI to convert to an absolute IRI.
 * @param {string} baseIRI The optional base IRI.
 * @return {string} an absolute IRI.
 */ function $236ad8315bad7f92$var$resolve(relativeIRI, baseIRI) {
    baseIRI = baseIRI || '';
    var baseFragmentPos = baseIRI.indexOf('#');
    // Ignore any fragments in the base IRI
    if (baseFragmentPos > 0) baseIRI = baseIRI.substr(0, baseFragmentPos);
    // Convert empty value directly to base IRI
    if (!relativeIRI.length) {
        // At this point, the baseIRI MUST be absolute, otherwise we error
        if (baseIRI.indexOf(':') < 0) throw new Error("Found invalid baseIRI '".concat(baseIRI, "' for value '").concat(relativeIRI, "'"));
        return baseIRI;
    }
    // If the value starts with a query character, concat directly (but strip the existing query)
    if (relativeIRI.startsWith('?')) {
        var baseQueryPos = baseIRI.indexOf('?');
        if (baseQueryPos > 0) baseIRI = baseIRI.substr(0, baseQueryPos);
        return baseIRI + relativeIRI;
    }
    // If the value starts with a fragment character, concat directly
    if (relativeIRI.startsWith('#')) return baseIRI + relativeIRI;
    // Ignore baseIRI if it is empty
    if (!baseIRI.length) {
        var relativeColonPos = relativeIRI.indexOf(':');
        if (relativeColonPos < 0) throw new Error("Found invalid relative IRI '".concat(relativeIRI, "' for a missing baseIRI"));
        return $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, relativeColonPos);
    }
    // Ignore baseIRI if the value is absolute
    var valueColonPos = relativeIRI.indexOf(':');
    if (valueColonPos >= 0) return $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    // At this point, the baseIRI MUST be absolute, otherwise we error
    var baseColonPos = baseIRI.indexOf(':');
    if (baseColonPos < 0) throw new Error("Found invalid baseIRI '".concat(baseIRI, "' for value '").concat(relativeIRI, "'"));
    var baseIRIScheme = baseIRI.substr(0, baseColonPos + 1);
    // Inherit the baseIRI scheme if the value starts with '//'
    if (relativeIRI.indexOf('//') === 0) return baseIRIScheme + $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    // Check cases where '://' occurs in the baseIRI, and where there is no '/' after a ':' anymore.
    var baseSlashAfterColonPos;
    if (baseIRI.indexOf('//', baseColonPos) === baseColonPos + 1) {
        // If there is no additional '/' after the '//'.
        baseSlashAfterColonPos = baseIRI.indexOf('/', baseColonPos + 3);
        if (baseSlashAfterColonPos < 0) {
            // If something other than a '/' follows the '://', append the value after a '/',
            // otherwise, prefix the value with only the baseIRI scheme.
            if (baseIRI.length > baseColonPos + 3) return baseIRI + '/' + $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
            else return baseIRIScheme + $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
        }
    } else {
        // If there is not even a single '/' after the ':'
        baseSlashAfterColonPos = baseIRI.indexOf('/', baseColonPos + 1);
        if (baseSlashAfterColonPos < 0) // If we don't have a '/' after the ':',
        // prefix the value with only the baseIRI scheme.
        return baseIRIScheme + $236ad8315bad7f92$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    }
    // If the value starts with a '/', then prefix it with everything before the first effective slash of the base IRI.
    if (relativeIRI.indexOf('/') === 0) return baseIRI.substr(0, baseSlashAfterColonPos) + $236ad8315bad7f92$var$removeDotSegments(relativeIRI);
    var baseIRIPath = baseIRI.substr(baseSlashAfterColonPos);
    var baseIRILastSlashPos = baseIRIPath.lastIndexOf('/');
    // Ignore everything after the last '/' in the baseIRI path
    if (baseIRILastSlashPos >= 0 && baseIRILastSlashPos < baseIRIPath.length - 1) {
        baseIRIPath = baseIRIPath.substr(0, baseIRILastSlashPos + 1);
        // Also remove the first character of the relative path if it starts with '.' (and not '..' or './')
        // This change is only allowed if there is something else following the path
        if (relativeIRI[0] === '.' && relativeIRI[1] !== '.' && relativeIRI[1] !== '/' && relativeIRI[2]) relativeIRI = relativeIRI.substr(1);
    }
    // Prefix the value with the baseIRI path where
    relativeIRI = baseIRIPath + relativeIRI;
    // Remove dot segment from the IRI
    relativeIRI = $236ad8315bad7f92$var$removeDotSegments(relativeIRI);
    // Prefix our transformed value with the part of the baseIRI until the first '/' after the first ':'.
    return baseIRI.substr(0, baseSlashAfterColonPos) + relativeIRI;
}
module.exports.resolve = $236ad8315bad7f92$var$resolve;
/**
 * Remove dot segments from the given path,
 * as described in https://www.ietf.org/rfc/rfc3986.txt (page 32).
 * @param {string} path An IRI path.
 * @return {string} A path, will always start with a '/'.
 */ function $236ad8315bad7f92$var$removeDotSegments(path) {
    // Prepare a buffer with segments between each '/.
    // Each segment represents an array of characters.
    var segmentBuffers = [];
    var i = 0;
    while(i < path.length)// Remove '/.' or '/..'
    switch(path[i]){
        case '/':
            if (path[i + 1] === '.') {
                if (path[i + 2] === '.') {
                    // Start a new segment if we find an invalid character after the '.'
                    if (!$236ad8315bad7f92$var$isCharacterAllowedAfterRelativePathSegment(path[i + 3])) {
                        segmentBuffers.push([]);
                        i++;
                        break;
                    }
                    // Go to parent directory,
                    // so we remove a parent segment
                    segmentBuffers.pop();
                    // Ensure that we end with a slash if there is a trailing '/..'
                    if (!path[i + 3]) segmentBuffers.push([]);
                    i += 3;
                } else {
                    // Start a new segment if we find an invalid character after the '.'
                    if (!$236ad8315bad7f92$var$isCharacterAllowedAfterRelativePathSegment(path[i + 2])) {
                        segmentBuffers.push([]);
                        i++;
                        break;
                    }
                    // Ensure that we end with a slash if there is a trailing '/.'
                    if (!path[i + 2]) segmentBuffers.push([]);
                    // Go to the current directory,
                    // so we do nothing
                    i += 2;
                }
            } else {
                // Start a new segment
                segmentBuffers.push([]);
                i++;
            }
            break;
        case '#':
        case '?':
            // Query and fragment string should be appended unchanged
            if (!segmentBuffers.length) segmentBuffers.push([]);
            segmentBuffers[segmentBuffers.length - 1].push(path.substr(i));
            // Break the while loop
            i = path.length;
            break;
        default:
            // Not a special character, just append it to our buffer
            if (!segmentBuffers.length) segmentBuffers.push([]);
            segmentBuffers[segmentBuffers.length - 1].push(path[i]);
            i++;
            break;
    }
    return '/' + segmentBuffers.map(function(buffer) {
        return buffer.join('');
    }).join('/');
}
module.exports.removeDotSegments = $236ad8315bad7f92$var$removeDotSegments;
/**
 * Removes dot segments of the given IRI.
 * @param {string} iri An IRI (or part of IRI).
 * @param {number} colonPosition The position of the first ':' in the IRI.
 * @return {string} The IRI where dot segments were removed.
 */ function $236ad8315bad7f92$var$removeDotSegmentsOfPath(iri, colonPosition) {
    // Determine where we should start looking for the first '/' that indicates the start of the path
    var searchOffset = colonPosition + 1;
    if (colonPosition >= 0) {
        if (iri[colonPosition + 1] === '/' && iri[colonPosition + 2] === '/') searchOffset = colonPosition + 3;
    } else if (iri[0] === '/' && iri[1] === '/') searchOffset = 2;
    // Determine the path
    var pathSeparator = iri.indexOf('/', searchOffset);
    if (pathSeparator < 0) return iri;
    var base = iri.substr(0, pathSeparator);
    var path = iri.substr(pathSeparator);
    // Remove dot segments from the path
    return base + $236ad8315bad7f92$var$removeDotSegments(path);
}
module.exports.removeDotSegmentsOfPath = $236ad8315bad7f92$var$removeDotSegmentsOfPath;
function $236ad8315bad7f92$var$isCharacterAllowedAfterRelativePathSegment(character) {
    return !character || character === '#' || character === '?' || character === '/';
}

});


parcelRegister("fTLSW", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ var $b93123140c5b9dcb$var$ErrorCoded = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ErrorCoded, Error1);
    function ErrorCoded(message, code) {
        (0, $jGAMp._)(this, ErrorCoded);
        var _this;
        _this = (0, $kzDuW._)(this, ErrorCoded, [
            message
        ]);
        _this.code = code;
        return _this;
    }
    return ErrorCoded;
}((0, $8AW3P._)(Error));
module.exports.ErrorCoded = $b93123140c5b9dcb$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $b93123140c5b9dcb$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($b93123140c5b9dcb$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("bozcm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $fTLSW = parcelRequire("fTLSW");

var $fdIar = parcelRequire("fdIar");

var $hDpjF = parcelRequire("hDpjF");
/**
 * Loads documents via the fetch API.
 */ var $84bd3d482e851963$var$FetchDocumentLoader = /*#__PURE__*/ function() {
    function FetchDocumentLoader(fetcher) {
        (0, $jGAMp._)(this, FetchDocumentLoader);
        this.fetcher = fetcher;
    }
    (0, $byiyg._)(FetchDocumentLoader, [
        {
            key: "load",
            value: function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var response, mediaType, colonPos, alternateUrl;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (this.fetcher || fetch)(url, {
                                        headers: new Headers({
                                            accept: 'application/ld+json'
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!(response.ok && response.headers)) return [
                                    3,
                                    5
                                ];
                                mediaType = response.headers.get('Content-Type');
                                if (mediaType) {
                                    colonPos = mediaType.indexOf(';');
                                    if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
                                }
                                if (!(mediaType === 'application/ld+json')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                // Return JSON-LD if proper content type was returned
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                // Check for alternate link for a non-JSON-LD response
                                if (response.headers.has('Link')) {
                                    ;
                                    response.headers.forEach(function(value, key) {
                                        if (key === 'link') {
                                            var linkHeader = (0, $fdIar.parse)(value);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = linkHeader.get('type', 'application/ld+json')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var link = _step.value;
                                                    if (link.rel === 'alternate') {
                                                        if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                                        alternateUrl = (0, $hDpjF.resolve)(link.uri, url);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                    if (alternateUrl) return [
                                        2,
                                        this.load(alternateUrl)
                                    ];
                                }
                                throw new $fTLSW.ErrorCoded("Unsupported JSON-LD media type ".concat(mediaType), $fTLSW.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error(response.statusText || "Status code: ".concat(response.status));
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return FetchDocumentLoader;
}();
module.exports.FetchDocumentLoader = $84bd3d482e851963$var$FetchDocumentLoader;

});
parcelRegister("fdIar", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");

var $jbNCJ = parcelRequire("jbNCJ");
var $b14a54a6f41b8128$require$Buffer = $jbNCJ.Buffer;
'use strict';
var $b14a54a6f41b8128$var$COMPATIBLE_ENCODING_PATTERN = /^utf-?8|ascii|utf-?16-?le|ucs-?2|base-?64|latin-?1$/i;
var $b14a54a6f41b8128$var$WS_TRIM_PATTERN = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
var $b14a54a6f41b8128$var$WS_CHAR_PATTERN = /\s|\uFEFF|\xA0/;
var $b14a54a6f41b8128$var$WS_FOLD_PATTERN = /\r?\n[\x20\x09]+/g;
var $b14a54a6f41b8128$var$DELIMITER_PATTERN = /[;,"]/;
var $b14a54a6f41b8128$var$WS_DELIMITER_PATTERN = /[;,"]|\s/;
/**
 * Token character pattern
 * @type {RegExp}
 * @see https://tools.ietf.org/html/rfc7230#section-3.2.6
 */ var $b14a54a6f41b8128$var$TOKEN_PATTERN = /^[!#$%&'*+\-\.^_`|~\da-zA-Z]+$/;
var $b14a54a6f41b8128$var$STATE = {
    IDLE: 1,
    URI: 2,
    ATTR: 4
};
function $b14a54a6f41b8128$var$trim(value) {
    return value.replace($b14a54a6f41b8128$var$WS_TRIM_PATTERN, '');
}
function $b14a54a6f41b8128$var$hasWhitespace(value) {
    return $b14a54a6f41b8128$var$WS_CHAR_PATTERN.test(value);
}
function $b14a54a6f41b8128$var$skipWhitespace(value, offset) {
    while($b14a54a6f41b8128$var$hasWhitespace(value[offset]))offset++;
    return offset;
}
function $b14a54a6f41b8128$var$needsQuotes(value) {
    return $b14a54a6f41b8128$var$WS_DELIMITER_PATTERN.test(value) || !$b14a54a6f41b8128$var$TOKEN_PATTERN.test(value);
}
/**
 * Shallow compares two objects to check if their properties match.
 * @param {object} object1 First object to compare.
 * @param {object} object2 Second object to compare.
 * @returns {boolean} Do the objects have matching properties.
 */ function $b14a54a6f41b8128$var$shallowCompareObjects(object1, object2) {
    return Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every(function(key) {
        return key in object2 && object1[key] === object2[key];
    });
}
var $b14a54a6f41b8128$var$Link = /*#__PURE__*/ function() {
    "use strict";
    function Link(value) {
        (0, $jGAMp._)(this, Link);
        /** @type {Array} URI references */ this.refs = [];
        if (value) this.parse(value);
    }
    (0, $byiyg._)(Link, [
        {
            /**
   * Get refs with given relation type
   * @param {String} value
   * @returns {Array<Object>}
   */ key: "rel",
            value: function rel(value) {
                var links = [];
                var type = value.toLowerCase();
                for(var i = 0; i < this.refs.length; i++)if (typeof this.refs[i].rel === 'string' && this.refs[i].rel.toLowerCase() === type) links.push(this.refs[i]);
                return links;
            }
        },
        {
            /**
   * Get refs where given attribute has a given value
   * @param {String} attr
   * @param {String} value
   * @returns {Array<Object>}
   */ key: "get",
            value: function get(attr, value) {
                attr = attr.toLowerCase();
                value = value.toLowerCase();
                var links = [];
                for(var i = 0; i < this.refs.length; i++)if (typeof this.refs[i][attr] === 'string' && this.refs[i][attr].toLowerCase() === value) links.push(this.refs[i]);
                return links;
            }
        },
        {
            /** Sets a reference. */ key: "set",
            value: function set(link) {
                this.refs.push(link);
                return this;
            }
        },
        {
            /**
   * Sets a reference if a reference with similar properties isn’t already set.
   */ key: "setUnique",
            value: function setUnique(link) {
                if (!this.refs.some(function(ref) {
                    return $b14a54a6f41b8128$var$shallowCompareObjects(ref, link);
                })) this.refs.push(link);
                return this;
            }
        },
        {
            key: "has",
            value: function has(attr, value) {
                attr = attr.toLowerCase();
                value = value.toLowerCase();
                for(var i = 0; i < this.refs.length; i++){
                    if (typeof this.refs[i][attr] === 'string' && this.refs[i][attr].toLowerCase() === value) return true;
                }
                return false;
            }
        },
        {
            key: "parse",
            value: function parse(value, offset) {
                var _this_refs;
                offset = offset || 0;
                value = offset ? value.slice(offset) : value;
                // Trim & unfold folded lines
                value = $b14a54a6f41b8128$var$trim(value).replace($b14a54a6f41b8128$var$WS_FOLD_PATTERN, '');
                var state = $b14a54a6f41b8128$var$STATE.IDLE;
                var length = value.length;
                var offset = 0;
                var ref = null;
                while(offset < length){
                    if (state === $b14a54a6f41b8128$var$STATE.IDLE) {
                        if ($b14a54a6f41b8128$var$hasWhitespace(value[offset])) {
                            offset++;
                            continue;
                        } else if (value[offset] === '<') {
                            var _this_refs1;
                            if (ref != null) ref.rel != null ? (_this_refs1 = this.refs).push.apply(_this_refs1, (0, $7WNf6._)(Link.expandRelations(ref))) : this.refs.push(ref);
                            var end = value.indexOf('>', offset);
                            if (end === -1) throw new Error('Expected end of URI delimiter at offset ' + offset);
                            ref = {
                                uri: value.slice(offset + 1, end)
                            };
                            // this.refs.push( ref )
                            offset = end;
                            state = $b14a54a6f41b8128$var$STATE.URI;
                        } else throw new Error('Unexpected character "' + value[offset] + '" at offset ' + offset);
                        offset++;
                    } else if (state === $b14a54a6f41b8128$var$STATE.URI) {
                        if ($b14a54a6f41b8128$var$hasWhitespace(value[offset])) {
                            offset++;
                            continue;
                        } else if (value[offset] === ';') {
                            state = $b14a54a6f41b8128$var$STATE.ATTR;
                            offset++;
                        } else if (value[offset] === ',') {
                            state = $b14a54a6f41b8128$var$STATE.IDLE;
                            offset++;
                        } else throw new Error('Unexpected character "' + value[offset] + '" at offset ' + offset);
                    } else if (state === $b14a54a6f41b8128$var$STATE.ATTR) {
                        if (value[offset] === ';' || $b14a54a6f41b8128$var$hasWhitespace(value[offset])) {
                            offset++;
                            continue;
                        }
                        var end = value.indexOf('=', offset);
                        if (end === -1) end = value.indexOf(';', offset);
                        if (end === -1) end = value.length;
                        var attr = $b14a54a6f41b8128$var$trim(value.slice(offset, end)).toLowerCase();
                        var attrValue = '';
                        offset = end + 1;
                        offset = $b14a54a6f41b8128$var$skipWhitespace(value, offset);
                        if (value[offset] === '"') {
                            offset++;
                            while(offset < length){
                                if (value[offset] === '"') {
                                    offset++;
                                    break;
                                }
                                if (value[offset] === '\\') offset++;
                                attrValue += value[offset];
                                offset++;
                            }
                        } else {
                            var end = offset + 1;
                            while(!$b14a54a6f41b8128$var$DELIMITER_PATTERN.test(value[end]) && end < length)end++;
                            attrValue = value.slice(offset, end);
                            offset = end;
                        }
                        if (ref[attr] && Link.isSingleOccurenceAttr(attr)) ;
                        else if (attr[attr.length - 1] === '*') ref[attr] = Link.parseExtendedValue(attrValue);
                        else {
                            attrValue = attr === 'type' ? attrValue.toLowerCase() : attrValue;
                            if (ref[attr] != null) {
                                if (Array.isArray(ref[attr])) ref[attr].push(attrValue);
                                else ref[attr] = [
                                    ref[attr],
                                    attrValue
                                ];
                            } else ref[attr] = attrValue;
                        }
                        switch(value[offset]){
                            case ',':
                                state = $b14a54a6f41b8128$var$STATE.IDLE;
                                break;
                            case ';':
                                state = $b14a54a6f41b8128$var$STATE.ATTR;
                                break;
                        }
                        offset++;
                    } else throw new Error('Unknown parser state "' + state + '"');
                }
                if (ref != null) ref.rel != null ? (_this_refs = this.refs).push.apply(_this_refs, (0, $7WNf6._)(Link.expandRelations(ref))) : this.refs.push(ref);
                ref = null;
                return this;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var refs = [];
                var link = '';
                var ref = null;
                for(var i = 0; i < this.refs.length; i++){
                    ref = this.refs[i];
                    link = Object.keys(this.refs[i]).reduce(function(link, attr) {
                        if (attr === 'uri') return link;
                        return link + '; ' + Link.formatAttribute(attr, ref[attr]);
                    }, '<' + ref.uri + '>');
                    refs.push(link);
                }
                return refs.join(', ');
            }
        }
    ]);
    return Link;
}();
/**
 * Determines whether an encoding can be
 * natively handled with a `Buffer`
 * @param {String} value
 * @returns {Boolean}
 */ $b14a54a6f41b8128$var$Link.isCompatibleEncoding = function(value) {
    return $b14a54a6f41b8128$var$COMPATIBLE_ENCODING_PATTERN.test(value);
};
$b14a54a6f41b8128$var$Link.parse = function(value, offset) {
    return new $b14a54a6f41b8128$var$Link().parse(value, offset);
};
$b14a54a6f41b8128$var$Link.isSingleOccurenceAttr = function(attr) {
    return attr === 'rel' || attr === 'type' || attr === 'media' || attr === 'title' || attr === 'title*';
};
$b14a54a6f41b8128$var$Link.isTokenAttr = function(attr) {
    return attr === 'rel' || attr === 'type' || attr === 'anchor';
};
$b14a54a6f41b8128$var$Link.escapeQuotes = function(value) {
    return value.replace(/"/g, '\\"');
};
$b14a54a6f41b8128$var$Link.expandRelations = function(ref) {
    var rels = ref.rel.split(' ');
    return rels.map(function(rel) {
        var value = Object.assign({}, ref);
        value.rel = rel;
        return value;
    });
};
/**
 * Parses an extended value and attempts to decode it
 * @internal
 * @param {String} value
 * @return {Object}
 */ $b14a54a6f41b8128$var$Link.parseExtendedValue = function(value) {
    var parts = /([^']+)?(?:'([^']*)')?(.+)/.exec(value);
    return {
        language: parts[2].toLowerCase(),
        encoding: $b14a54a6f41b8128$var$Link.isCompatibleEncoding(parts[1]) ? null : parts[1].toLowerCase(),
        value: $b14a54a6f41b8128$var$Link.isCompatibleEncoding(parts[1]) ? decodeURIComponent(parts[3]) : parts[3]
    };
};
/**
 * Format a given extended attribute and it's value
 * @param {String} attr
 * @param {Object} data
 * @return {String}
 */ $b14a54a6f41b8128$var$Link.formatExtendedAttribute = function(attr, data) {
    var encoding = (data.encoding || 'utf-8').toUpperCase();
    var language = data.language || 'en';
    var encodedValue = '';
    if ($b14a54a6f41b8128$require$Buffer.isBuffer(data.value) && $b14a54a6f41b8128$var$Link.isCompatibleEncoding(encoding)) encodedValue = data.value.toString(encoding);
    else if ($b14a54a6f41b8128$require$Buffer.isBuffer(data.value)) encodedValue = data.value.toString('hex').replace(/[0-9a-f]{2}/gi, '%$1');
    else encodedValue = encodeURIComponent(data.value);
    return attr + '=' + encoding + '\'' + language + '\'' + encodedValue;
};
/**
 * Format a given attribute and it's value
 * @param {String} attr
 * @param {String|Object} value
 * @return {String}
 */ $b14a54a6f41b8128$var$Link.formatAttribute = function(attr, value) {
    if (Array.isArray(value)) return value.map(function(item) {
        return $b14a54a6f41b8128$var$Link.formatAttribute(attr, item);
    }).join('; ');
    if (attr[attr.length - 1] === '*' || typeof value !== 'string') return $b14a54a6f41b8128$var$Link.formatExtendedAttribute(attr, value);
    if ($b14a54a6f41b8128$var$Link.isTokenAttr(attr)) value = $b14a54a6f41b8128$var$needsQuotes(value) ? '"' + $b14a54a6f41b8128$var$Link.escapeQuotes(value) + '"' : $b14a54a6f41b8128$var$Link.escapeQuotes(value);
    else if ($b14a54a6f41b8128$var$needsQuotes(value)) {
        value = encodeURIComponent(value);
        // We don't need to escape <SP> <,> <;> within quotes
        value = value.replace(/%20/g, ' ').replace(/%2C/g, ',').replace(/%3B/g, ';');
        value = '"' + value + '"';
    }
    return attr + '=' + value;
};
module.exports = $b14a54a6f41b8128$var$Link;

});
parcelRegister("jbNCJ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $df8589a663a53332$export$a143d493d941bafc; }, function (v) { return $df8589a663a53332$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $df8589a663a53332$export$e4cf37d7f6fb9e0a; }, function (v) { return $df8589a663a53332$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $df8589a663a53332$export$f99ded8fe4b79145; }, function (v) { return $df8589a663a53332$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $df8589a663a53332$export$599f31c3813fae4d; }, function (v) { return $df8589a663a53332$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $3KZcf = parcelRequire("3KZcf");
var $df8589a663a53332$export$a143d493d941bafc;
var $df8589a663a53332$export$e4cf37d7f6fb9e0a;
var $df8589a663a53332$export$f99ded8fe4b79145;
var $df8589a663a53332$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $df8589a663a53332$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$df8589a663a53332$export$a143d493d941bafc = $df8589a663a53332$var$Buffer;
$df8589a663a53332$export$e4cf37d7f6fb9e0a = $df8589a663a53332$var$SlowBuffer;
$df8589a663a53332$export$f99ded8fe4b79145 = 50;
var $df8589a663a53332$var$K_MAX_LENGTH = 0x7fffffff;
$df8589a663a53332$export$599f31c3813fae4d = $df8589a663a53332$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $df8589a663a53332$var$Buffer.TYPED_ARRAY_SUPPORT = $df8589a663a53332$var$typedArraySupport();
if (!$df8589a663a53332$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $df8589a663a53332$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($df8589a663a53332$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$df8589a663a53332$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($df8589a663a53332$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$df8589a663a53332$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $df8589a663a53332$var$createBuffer(length) {
    if (length > $df8589a663a53332$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $df8589a663a53332$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $df8589a663a53332$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $df8589a663a53332$var$allocUnsafe(arg);
    }
    return $df8589a663a53332$var$from(arg, encodingOrOffset, length);
}
$df8589a663a53332$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $df8589a663a53332$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $df8589a663a53332$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $df8589a663a53332$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($df8589a663a53332$var$isInstance(value, ArrayBuffer) || value && $df8589a663a53332$var$isInstance(value.buffer, ArrayBuffer)) return $df8589a663a53332$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($df8589a663a53332$var$isInstance(value, SharedArrayBuffer) || value && $df8589a663a53332$var$isInstance(value.buffer, SharedArrayBuffer))) return $df8589a663a53332$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $df8589a663a53332$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $df8589a663a53332$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $df8589a663a53332$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $df8589a663a53332$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $df8589a663a53332$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($df8589a663a53332$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($df8589a663a53332$var$Buffer, Uint8Array);
function $df8589a663a53332$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $df8589a663a53332$var$alloc(size, fill, encoding) {
    $df8589a663a53332$var$assertSize(size);
    if (size <= 0) return $df8589a663a53332$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $df8589a663a53332$var$createBuffer(size).fill(fill, encoding) : $df8589a663a53332$var$createBuffer(size).fill(fill);
    return $df8589a663a53332$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $df8589a663a53332$var$Buffer.alloc = function(size, fill, encoding) {
    return $df8589a663a53332$var$alloc(size, fill, encoding);
};
function $df8589a663a53332$var$allocUnsafe(size) {
    $df8589a663a53332$var$assertSize(size);
    return $df8589a663a53332$var$createBuffer(size < 0 ? 0 : $df8589a663a53332$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $df8589a663a53332$var$Buffer.allocUnsafe = function(size) {
    return $df8589a663a53332$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $df8589a663a53332$var$Buffer.allocUnsafeSlow = function(size) {
    return $df8589a663a53332$var$allocUnsafe(size);
};
function $df8589a663a53332$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$df8589a663a53332$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $df8589a663a53332$var$byteLength(string, encoding) | 0;
    var buf = $df8589a663a53332$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $df8589a663a53332$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $df8589a663a53332$var$checked(array.length) | 0;
    var buf = $df8589a663a53332$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $df8589a663a53332$var$fromArrayView(arrayView) {
    if ($df8589a663a53332$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $df8589a663a53332$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $df8589a663a53332$var$fromArrayLike(arrayView);
}
function $df8589a663a53332$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $df8589a663a53332$var$Buffer.prototype);
    return buf;
}
function $df8589a663a53332$var$fromObject(obj) {
    if ($df8589a663a53332$var$Buffer.isBuffer(obj)) {
        var len = $df8589a663a53332$var$checked(obj.length) | 0;
        var buf = $df8589a663a53332$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $df8589a663a53332$var$numberIsNaN(obj.length)) return $df8589a663a53332$var$createBuffer(0);
        return $df8589a663a53332$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $df8589a663a53332$var$fromArrayLike(obj.data);
}
function $df8589a663a53332$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $df8589a663a53332$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $df8589a663a53332$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $df8589a663a53332$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $df8589a663a53332$var$Buffer.alloc(+length);
}
$df8589a663a53332$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $df8589a663a53332$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$df8589a663a53332$var$Buffer.compare = function compare(a, b) {
    if ($df8589a663a53332$var$isInstance(a, Uint8Array)) a = $df8589a663a53332$var$Buffer.from(a, a.offset, a.byteLength);
    if ($df8589a663a53332$var$isInstance(b, Uint8Array)) b = $df8589a663a53332$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$df8589a663a53332$var$Buffer.isBuffer(a) || !$df8589a663a53332$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$df8589a663a53332$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$df8589a663a53332$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $df8589a663a53332$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $df8589a663a53332$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($df8589a663a53332$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $df8589a663a53332$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$df8589a663a53332$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $df8589a663a53332$var$byteLength(string, encoding) {
    if ($df8589a663a53332$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $df8589a663a53332$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $df8589a663a53332$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $df8589a663a53332$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $df8589a663a53332$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$df8589a663a53332$var$Buffer.byteLength = $df8589a663a53332$var$byteLength;
function $df8589a663a53332$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $df8589a663a53332$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $df8589a663a53332$var$utf8Slice(this, start, end);
        case 'ascii':
            return $df8589a663a53332$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $df8589a663a53332$var$latin1Slice(this, start, end);
        case 'base64':
            return $df8589a663a53332$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $df8589a663a53332$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$df8589a663a53332$var$Buffer.prototype._isBuffer = true;
function $df8589a663a53332$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$df8589a663a53332$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$df8589a663a53332$var$swap(this, i, i + 1);
    return this;
};
$df8589a663a53332$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $df8589a663a53332$var$swap(this, i, i + 3);
        $df8589a663a53332$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$df8589a663a53332$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $df8589a663a53332$var$swap(this, i, i + 7);
        $df8589a663a53332$var$swap(this, i + 1, i + 6);
        $df8589a663a53332$var$swap(this, i + 2, i + 5);
        $df8589a663a53332$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$df8589a663a53332$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $df8589a663a53332$var$utf8Slice(this, 0, length);
    return $df8589a663a53332$var$slowToString.apply(this, arguments);
};
$df8589a663a53332$var$Buffer.prototype.toLocaleString = $df8589a663a53332$var$Buffer.prototype.toString;
$df8589a663a53332$var$Buffer.prototype.equals = function equals(b) {
    if (!$df8589a663a53332$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $df8589a663a53332$var$Buffer.compare(this, b) === 0;
};
$df8589a663a53332$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $df8589a663a53332$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($df8589a663a53332$var$customInspectSymbol) $df8589a663a53332$var$Buffer.prototype[$df8589a663a53332$var$customInspectSymbol] = $df8589a663a53332$var$Buffer.prototype.inspect;
$df8589a663a53332$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($df8589a663a53332$var$isInstance(target, Uint8Array)) target = $df8589a663a53332$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$df8589a663a53332$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $df8589a663a53332$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($df8589a663a53332$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $df8589a663a53332$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($df8589a663a53332$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $df8589a663a53332$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $df8589a663a53332$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $df8589a663a53332$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$df8589a663a53332$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$df8589a663a53332$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $df8589a663a53332$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$df8589a663a53332$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $df8589a663a53332$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $df8589a663a53332$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($df8589a663a53332$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $df8589a663a53332$var$utf8Write(buf, string, offset, length) {
    return $df8589a663a53332$var$blitBuffer($df8589a663a53332$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $df8589a663a53332$var$asciiWrite(buf, string, offset, length) {
    return $df8589a663a53332$var$blitBuffer($df8589a663a53332$var$asciiToBytes(string), buf, offset, length);
}
function $df8589a663a53332$var$base64Write(buf, string, offset, length) {
    return $df8589a663a53332$var$blitBuffer($df8589a663a53332$var$base64ToBytes(string), buf, offset, length);
}
function $df8589a663a53332$var$ucs2Write(buf, string, offset, length) {
    return $df8589a663a53332$var$blitBuffer($df8589a663a53332$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$df8589a663a53332$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $df8589a663a53332$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $df8589a663a53332$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $df8589a663a53332$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $df8589a663a53332$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $df8589a663a53332$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$df8589a663a53332$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $df8589a663a53332$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $df8589a663a53332$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $df8589a663a53332$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $df8589a663a53332$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $df8589a663a53332$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $df8589a663a53332$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $df8589a663a53332$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $df8589a663a53332$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $df8589a663a53332$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $df8589a663a53332$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $df8589a663a53332$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $df8589a663a53332$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$df8589a663a53332$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $df8589a663a53332$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $df8589a663a53332$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$df8589a663a53332$var$Buffer.prototype.readUintLE = $df8589a663a53332$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$df8589a663a53332$var$Buffer.prototype.readUintBE = $df8589a663a53332$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$df8589a663a53332$var$Buffer.prototype.readUint8 = $df8589a663a53332$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$df8589a663a53332$var$Buffer.prototype.readUint16LE = $df8589a663a53332$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$df8589a663a53332$var$Buffer.prototype.readUint16BE = $df8589a663a53332$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$df8589a663a53332$var$Buffer.prototype.readUint32LE = $df8589a663a53332$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$df8589a663a53332$var$Buffer.prototype.readUint32BE = $df8589a663a53332$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$df8589a663a53332$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$df8589a663a53332$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$df8589a663a53332$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$df8589a663a53332$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$df8589a663a53332$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$df8589a663a53332$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$df8589a663a53332$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$df8589a663a53332$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$df8589a663a53332$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$df8589a663a53332$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$df8589a663a53332$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $df8589a663a53332$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$df8589a663a53332$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$df8589a663a53332$var$Buffer.prototype.writeUintLE = $df8589a663a53332$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $df8589a663a53332$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$df8589a663a53332$var$Buffer.prototype.writeUintBE = $df8589a663a53332$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $df8589a663a53332$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$df8589a663a53332$var$Buffer.prototype.writeUint8 = $df8589a663a53332$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$df8589a663a53332$var$Buffer.prototype.writeUint16LE = $df8589a663a53332$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$df8589a663a53332$var$Buffer.prototype.writeUint16BE = $df8589a663a53332$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$df8589a663a53332$var$Buffer.prototype.writeUint32LE = $df8589a663a53332$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$df8589a663a53332$var$Buffer.prototype.writeUint32BE = $df8589a663a53332$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$df8589a663a53332$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $df8589a663a53332$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$df8589a663a53332$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $df8589a663a53332$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$df8589a663a53332$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$df8589a663a53332$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$df8589a663a53332$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$df8589a663a53332$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$df8589a663a53332$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $df8589a663a53332$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $df8589a663a53332$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$df8589a663a53332$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $df8589a663a53332$var$writeFloat(this, value, offset, true, noAssert);
};
$df8589a663a53332$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $df8589a663a53332$var$writeFloat(this, value, offset, false, noAssert);
};
function $df8589a663a53332$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $df8589a663a53332$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$df8589a663a53332$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $df8589a663a53332$var$writeDouble(this, value, offset, true, noAssert);
};
$df8589a663a53332$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $df8589a663a53332$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$df8589a663a53332$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$df8589a663a53332$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$df8589a663a53332$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$df8589a663a53332$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $df8589a663a53332$var$Buffer.isBuffer(val) ? val : $df8589a663a53332$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $df8589a663a53332$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $df8589a663a53332$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($df8589a663a53332$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $df8589a663a53332$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $df8589a663a53332$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $df8589a663a53332$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $df8589a663a53332$var$base64ToBytes(str) {
    return $abUaD.toByteArray($df8589a663a53332$var$base64clean(str));
}
function $df8589a663a53332$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $df8589a663a53332$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $df8589a663a53332$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $df8589a663a53332$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("abUaD", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $76b680c35826c2f7$export$d622b2ad8d90c771; }, function (v) { return $76b680c35826c2f7$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $76b680c35826c2f7$export$6100ba28696e12de; }, function (v) { return $76b680c35826c2f7$export$6100ba28696e12de = v; });
var $76b680c35826c2f7$export$a48f0734ac7c2329;
var $76b680c35826c2f7$export$d622b2ad8d90c771;
var $76b680c35826c2f7$export$6100ba28696e12de;
'use strict';
$76b680c35826c2f7$export$a48f0734ac7c2329 = $76b680c35826c2f7$var$byteLength;
$76b680c35826c2f7$export$d622b2ad8d90c771 = $76b680c35826c2f7$var$toByteArray;
$76b680c35826c2f7$export$6100ba28696e12de = $76b680c35826c2f7$var$fromByteArray;
var $76b680c35826c2f7$var$lookup = [];
var $76b680c35826c2f7$var$revLookup = [];
var $76b680c35826c2f7$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $76b680c35826c2f7$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $76b680c35826c2f7$var$i = 0, $76b680c35826c2f7$var$len = $76b680c35826c2f7$var$code.length; $76b680c35826c2f7$var$i < $76b680c35826c2f7$var$len; ++$76b680c35826c2f7$var$i){
    $76b680c35826c2f7$var$lookup[$76b680c35826c2f7$var$i] = $76b680c35826c2f7$var$code[$76b680c35826c2f7$var$i];
    $76b680c35826c2f7$var$revLookup[$76b680c35826c2f7$var$code.charCodeAt($76b680c35826c2f7$var$i)] = $76b680c35826c2f7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$76b680c35826c2f7$var$revLookup['-'.charCodeAt(0)] = 62;
$76b680c35826c2f7$var$revLookup['_'.charCodeAt(0)] = 63;
function $76b680c35826c2f7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $76b680c35826c2f7$var$byteLength(b64) {
    var lens = $76b680c35826c2f7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $76b680c35826c2f7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $76b680c35826c2f7$var$toByteArray(b64) {
    var tmp;
    var lens = $76b680c35826c2f7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $76b680c35826c2f7$var$Arr($76b680c35826c2f7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i)] << 18 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i)] << 2 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i)] << 10 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $76b680c35826c2f7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $76b680c35826c2f7$var$tripletToBase64(num) {
    return $76b680c35826c2f7$var$lookup[num >> 18 & 0x3F] + $76b680c35826c2f7$var$lookup[num >> 12 & 0x3F] + $76b680c35826c2f7$var$lookup[num >> 6 & 0x3F] + $76b680c35826c2f7$var$lookup[num & 0x3F];
}
function $76b680c35826c2f7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($76b680c35826c2f7$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $76b680c35826c2f7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($76b680c35826c2f7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($76b680c35826c2f7$var$lookup[tmp >> 2] + $76b680c35826c2f7$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($76b680c35826c2f7$var$lookup[tmp >> 10] + $76b680c35826c2f7$var$lookup[tmp >> 4 & 0x3F] + $76b680c35826c2f7$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("6cq2P", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $483810fdf804e270$export$aafa59e2e03f2942; }, function (v) { return $483810fdf804e270$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $483810fdf804e270$export$68d8715fc104d294; }, function (v) { return $483810fdf804e270$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $483810fdf804e270$export$aafa59e2e03f2942;
var $483810fdf804e270$export$68d8715fc104d294;
$483810fdf804e270$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$483810fdf804e270$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("dSZo5", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $fTLSW = parcelRequire("fTLSW");

var $a9M6x = parcelRequire("a9M6x");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ var $a1bfefcbe1d13fb1$var$JsonLdContextNormalized = /*#__PURE__*/ function() {
    function JsonLdContextNormalized(contextRaw) {
        (0, $jGAMp._)(this, JsonLdContextNormalized);
        this.contextRaw = contextRaw;
    }
    (0, $byiyg._)(JsonLdContextNormalized, [
        {
            /**
     * @return The raw inner context.
     */ key: "getContextRaw",
            value: function getContextRaw() {
                return this.contextRaw;
            }
        },
        {
            /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ key: "expandTerm",
            value: function expandTerm(term, expandVocab) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultExpandOptions;
                var contextValue = this.contextRaw[term];
                // Immediately return if the term was disabled in the context
                if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
                // Check the @id
                var validIriMapping = true;
                if (contextValue && expandVocab) {
                    var value = $a9M6x.Util.getContextValueId(contextValue);
                    if (value && value !== term) {
                        if (typeof value !== 'string' || !$a9M6x.Util.isValidIri(value) && !$a9M6x.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                        {
                            if (!$a9M6x.Util.isPotentialKeyword(value)) validIriMapping = false;
                        } else return value;
                    }
                }
                // Check if the term is prefixed
                var prefix = $a9M6x.Util.getPrefix(term, this.contextRaw);
                var vocab = this.contextRaw['@vocab'];
                var vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
                var base = this.contextRaw['@base'];
                var potentialKeyword = $a9M6x.Util.isPotentialKeyword(term);
                if (prefix) {
                    var contextPrefixValue = this.contextRaw[prefix];
                    var value1 = $a9M6x.Util.getContextValueId(contextPrefixValue);
                    if (value1) {
                        if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                            // If we have a simple term definition,
                            // check the last character of the prefix to determine whether or not it is a prefix.
                            // Validate that prefix ends with gen-delim character, unless @prefix is true
                            if (!$a9M6x.Util.isSimpleTermDefinitionPrefix(value1, options)) // Treat the term as an absolute IRI
                            return term;
                        } else {
                            // If we have an expanded term definition, default to @prefix: false
                            if (value1[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                            return term;
                        }
                        return value1 + term.substr(prefix.length + 1);
                    }
                } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$a9M6x.Util.isCompactIri(term)) {
                    if (vocabRelative) {
                        if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $hDpjF.resolve)(vocab, base) : '') + term;
                        else throw new $fTLSW.ErrorCoded("Relative vocab expansion for term '".concat(term, "' with vocab '").concat(vocab, "' is not allowed."), $fTLSW.ERROR_CODES.INVALID_VOCAB_MAPPING);
                    } else return vocab + term;
                } else if (!expandVocab && base && !potentialKeyword && !$a9M6x.Util.isCompactIri(term)) return (0, $hDpjF.resolve)(term, base);
                // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
                if (validIriMapping) return term;
                else throw new $fTLSW.ErrorCoded("Invalid IRI mapping found for context entry '".concat(term, "': '").concat(JSON.stringify(contextValue), "'"), $fTLSW.ERROR_CODES.INVALID_IRI_MAPPING);
            }
        },
        {
            /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ key: "compactIri",
            value: function compactIri(iri, vocab) {
                // Try @vocab compacting
                if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
                // Try @base compacting
                if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
                // Loop over all terms in the context
                // This will try to prefix as short as possible.
                // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
                var shortestPrefixing = {
                    prefix: '',
                    suffix: iri
                };
                for(var key in this.contextRaw){
                    var value = this.contextRaw[key];
                    if (value && !$a9M6x.Util.isPotentialKeyword(key)) {
                        var contextIri = $a9M6x.Util.getContextValueId(value);
                        if (iri.startsWith(contextIri)) {
                            var suffix = iri.substr(contextIri.length);
                            if (!suffix) {
                                if (vocab) // Immediately return on compacted alias
                                return key;
                            } else if (suffix.length < shortestPrefixing.suffix.length) {
                                // Overwrite the shortest prefix
                                shortestPrefixing.prefix = key;
                                shortestPrefixing.suffix = suffix;
                            }
                        }
                    }
                }
                // Return the shortest prefix
                if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
                return iri;
            }
        }
    ]);
    return JsonLdContextNormalized;
}();
module.exports.JsonLdContextNormalized = $a1bfefcbe1d13fb1$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("a9M6x", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
var $76500f2f837a7179$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "isCompactIri",
            value: /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ function isCompactIri(term) {
                return term.indexOf(':') > 0 && !(term && term[0] === '#');
            }
        },
        {
            key: "getPrefix",
            value: /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ function getPrefix(term, context) {
                // Do not consider relative IRIs starting with a hash as compact IRIs
                if (term && term[0] === '#') return null;
                var separatorPos = term.indexOf(':');
                if (separatorPos >= 0) {
                    // Suffix can not begin with two slashes
                    if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
                    var prefix = term.substr(0, separatorPos);
                    // Prefix can not be an underscore (this is a blank node)
                    if (prefix === '_') return null;
                    // Prefix must match a term in the active context
                    if (context[prefix]) return prefix;
                }
                return null;
            }
        },
        {
            key: "getContextValueId",
            value: /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ function getContextValueId(contextValue) {
                if (contextValue === null || typeof contextValue === 'string') return contextValue;
                var id = contextValue['@id'];
                return id ? id : null;
            }
        },
        {
            key: "isSimpleTermDefinitionPrefix",
            value: /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ function isSimpleTermDefinitionPrefix(value, options) {
                return !Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || Util.isPrefixIriEndingWithGenDelim(value)));
            }
        },
        {
            key: "isPotentialKeyword",
            value: /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ function isPotentialKeyword(keyword) {
                return typeof keyword === 'string' && Util.KEYWORD_REGEX.test(keyword);
            }
        },
        {
            key: "isPrefixIriEndingWithGenDelim",
            value: /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ function isPrefixIriEndingWithGenDelim(prefixIri) {
                return Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
            }
        },
        {
            key: "isPrefixValue",
            value: /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ function isPrefixValue(value) {
                return value && (typeof value === 'string' || value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object');
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Boolean(iri && Util.IRI_REGEX.test(iri));
            }
        },
        {
            key: "isValidIriWeak",
            value: /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIriWeak(iri) {
                return !!iri && iri[0] !== ':' && Util.IRI_REGEX_WEAK.test(iri);
            }
        },
        {
            key: "isValidKeyword",
            value: /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ function isValidKeyword(keyword) {
                return Util.VALID_KEYWORDS[keyword];
            }
        },
        {
            key: "isTermProtected",
            value: /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ function isTermProtected(context, key) {
                var value = context[key];
                return !(typeof value === 'string') && value && value['@protected'];
            }
        },
        {
            key: "hasProtectedTerms",
            value: /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ function hasProtectedTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (Util.isTermProtected(context, key)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isReservedInternalKeyword",
            value: /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ function isReservedInternalKeyword(key) {
                return key.startsWith('@__');
            }
        },
        {
            key: "deepEqual",
            value: /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ function deepEqual(object1, object2) {
                var _this = this;
                var objKeys1 = Object.keys(object1);
                var objKeys2 = Object.keys(object2);
                if (objKeys1.length !== objKeys2.length) return false;
                return objKeys1.every(function(key) {
                    var value1 = object1[key];
                    var value2 = object2[key];
                    return value1 === value2 || value1 !== null && value2 !== null && (typeof value1 === "undefined" ? "undefined" : (0, $3KZcf._)(value1)) === "object" && (typeof value2 === "undefined" ? "undefined" : (0, $3KZcf._)(value2)) === "object" && _this.deepEqual(value1, value2);
                });
            }
        }
    ]);
    return Util;
}();
// Regex for valid IRIs
$76500f2f837a7179$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$76500f2f837a7179$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$76500f2f837a7179$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$76500f2f837a7179$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$76500f2f837a7179$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$76500f2f837a7179$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$76500f2f837a7179$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$76500f2f837a7179$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$76500f2f837a7179$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$76500f2f837a7179$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$76500f2f837a7179$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$76500f2f837a7179$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $76500f2f837a7179$var$Util;

});



parcelRegister("dX1cl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kisoS", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("cFhok", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("jEzKP", function(module, exports) {
"use strict";
var $e4ed7cca7e4b410a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4ed7cca7e4b410a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e4ed7cca7e4b410a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e4ed7cca7e4b410a$var$__exportStar((parcelRequire("bBKPJ")), module.exports);

});
parcelRegister("bBKPJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeJson = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");

var $6rBT9 = parcelRequire("6rBT9");
/**
 * A comunica JSON Query Result Serialize Actor.
 */ var $87377a8b3a6ffdbd$var$ActorQueryResultSerializeJson = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeJson, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeJson(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeJson);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeJson, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeJson, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'quads',
                            'boolean'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings or quad streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data, stream, empty, _, _1, _2, _3, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = new $6rBT9.Readable();
                                data._read = function() {
                                // Do nothing
                                };
                                if (!(action.type === 'bindings' || action.type === 'quads')) return [
                                    3,
                                    1
                                ];
                                stream = action.type === 'bindings' ? (0, $aafx9.wrap)(action.bindingsStream).map(function(element) {
                                    return JSON.stringify(Object.fromEntries((0, $7WNf6._)(element).map(function(param) {
                                        var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                        return [
                                            key.value,
                                            $gQYIc.termToString(value)
                                        ];
                                    })));
                                }) : (0, $aafx9.wrap)(action.quadStream).map(function(element) {
                                    return JSON.stringify($gQYIc.quadToStringQuad(element));
                                });
                                empty = true;
                                stream = stream.map(function(element) {
                                    var ret = "".concat(empty ? '' : ',', "\n").concat(element);
                                    empty = false;
                                    return ret;
                                }).prepend([
                                    '['
                                ]).append([
                                    '\n]\n'
                                ]);
                                data.wrap(stream);
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _ = data.push;
                                _2 = (_1 = "").concat;
                                _3 = JSON.stringify;
                                return [
                                    4,
                                    action.execute()
                                ];
                            case 2:
                                _.apply(data, [
                                    _2.apply(_1, [
                                        _3.apply(JSON, [
                                            _state.sent()
                                        ]),
                                        "\n"
                                    ])
                                ]);
                                data.push(null);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                setTimeout(function() {
                                    return data.emit('error', error);
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ActorQueryResultSerializeJson;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeJson = $87377a8b3a6ffdbd$var$ActorQueryResultSerializeJson;

});
parcelRegister("cqzMF", function(module, exports) {
"use strict";
var $90c3abb5972d4ab1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90c3abb5972d4ab1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $90c3abb5972d4ab1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$90c3abb5972d4ab1$var$__exportStar((parcelRequire("kF3Ij")), module.exports);

$90c3abb5972d4ab1$var$__exportStar((parcelRequire("kV1cO")), module.exports);

});
parcelRegister("kF3Ij", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerialize = void 0;

var $2T5vf = parcelRequire("2T5vf");
/**
 * A comunica actor for query-result-serialize events.
 *
 * Actor types:
 * * Input:  IActionSparqlSerialize:      SPARQL bindings or a quad stream.
 * * Test:   <none>
 * * Output: IActorQueryResultSerializeOutput: A text stream.
 *
 * @see IActionSparqlSerialize
 * @see IActorQueryResultSerializeOutput
 */ var $f0aa8474004f77e6$var$ActorQueryResultSerialize = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTyped) {
    (0, $i3fW3._)(ActorQueryResultSerialize, _actor_abstract_mediatyped_1_ActorAbstractMediaTyped);
    function ActorQueryResultSerialize(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerialize);
        return (0, $kzDuW._)(this, ActorQueryResultSerialize, [
            args
        ]);
    }
    return ActorQueryResultSerialize;
}($2T5vf.ActorAbstractMediaTyped);
module.exports.ActorQueryResultSerialize = $f0aa8474004f77e6$var$ActorQueryResultSerialize;

});
parcelRegister("2T5vf", function(module, exports) {
"use strict";
var $21a4fca002b2f773$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21a4fca002b2f773$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21a4fca002b2f773$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$21a4fca002b2f773$var$__exportStar((parcelRequire("8dNK3")), module.exports);

$21a4fca002b2f773$var$__exportStar((parcelRequire("76IIP")), module.exports);

});
parcelRegister("8dNK3", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractMediaTyped = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * An abstract actor that handles media-typed actions.
 *
 * It splits up a action between a 'handle' and a 'mediaTypes' action.
 * A 'mediaTypes' action is used to retrieve the available media types from this actor.
 * A 'handle' action is abstract, and can be implemented to do anything,
 * such as parsing, serializing, etc.
 * @see IActionAbstractMediaTyped
 *
 * @see ActorAbstractMediaTypedFixed
 */ var $5fc61f4b31d4dee9$var$ActorAbstractMediaTyped = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorAbstractMediaTyped, _core_1_Actor);
    function ActorAbstractMediaTyped(args) {
        (0, $jGAMp._)(this, ActorAbstractMediaTyped);
        return (0, $kzDuW._)(this, ActorAbstractMediaTyped, [
            args
        ]);
    }
    (0, $byiyg._)(ActorAbstractMediaTyped, [
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var typedAction, _tmp, _tmp1, _tmp2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!('handle' in action)) return [
                                    3,
                                    2
                                ];
                                typedAction = action;
                                _tmp = {};
                                return [
                                    4,
                                    this.runHandle(typedAction.handle, typedAction.handleMediaType, action.context)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.handle = _state.sent(), _tmp)
                                ];
                            case 2:
                                if (!('mediaTypes' in action)) return [
                                    3,
                                    4
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    this.getMediaTypes(action.context)
                                ];
                            case 3:
                                return [
                                    2,
                                    (_tmp1.mediaTypes = _state.sent(), _tmp1)
                                ];
                            case 4:
                                if (!('mediaTypeFormats' in action)) return [
                                    3,
                                    6
                                ];
                                _tmp2 = {};
                                return [
                                    4,
                                    this.getMediaTypeFormats(action.context)
                                ];
                            case 5:
                                return [
                                    2,
                                    (_tmp2.mediaTypeFormats = _state.sent(), _tmp2)
                                ];
                            case 6:
                                throw new Error('Either a handle, mediaTypes or mediaTypeFormats action needs to be provided');
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var typedAction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!('handle' in action)) return [
                                    3,
                                    2
                                ];
                                typedAction = action;
                                return [
                                    4,
                                    this.testHandle(typedAction.handle, typedAction.handleMediaType, action.context)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().map(function(handle) {
                                        return {
                                            handle: handle
                                        };
                                    })
                                ];
                            case 2:
                                if (!('mediaTypes' in action)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.testMediaType(action.context)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent().map(function(mediaTypes) {
                                        return {
                                            mediaTypes: mediaTypes
                                        };
                                    })
                                ];
                            case 4:
                                if (!('mediaTypeFormats' in action)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.testMediaTypeFormats(action.context)
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent().map(function(mediaTypeFormats) {
                                        return {
                                            mediaTypeFormats: mediaTypeFormats
                                        };
                                    })
                                ];
                            case 6:
                                return [
                                    2,
                                    (0, $kNNoa.failTest)('Either a handle, mediaTypes or mediaTypeFormats action needs to be provided')
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorAbstractMediaTyped;
}($kNNoa.Actor);
module.exports.ActorAbstractMediaTyped = $5fc61f4b31d4dee9$var$ActorAbstractMediaTyped;

});

parcelRegister("76IIP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractMediaTypedFixed = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $8dNK3 = parcelRequire("8dNK3");
var $52cbc8c9753f861f$var$ActorAbstractMediaTypedFixed = /*#__PURE__*/ function(_ActorAbstractMediaTyped_1_ActorAbstractMediaTyped) {
    (0, $i3fW3._)(ActorAbstractMediaTypedFixed, _ActorAbstractMediaTyped_1_ActorAbstractMediaTyped);
    function ActorAbstractMediaTypedFixed(args) {
        (0, $jGAMp._)(this, ActorAbstractMediaTypedFixed);
        var _this;
        _this = (0, $kzDuW._)(this, ActorAbstractMediaTypedFixed, [
            args
        ]);
        var scale = _this.priorityScale || _this.priorityScale === 0 ? _this.priorityScale : 1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (_this.mediaTypePriorities) try {
            for(var _iterator = Object.entries(_this.mediaTypePriorities).entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $32TW8._)(_step.value, 2), _index = _step_value[0], _step_value_ = (0, $32TW8._)(_step_value[1], 2), key = _step_value_[0], value = _step_value_[1];
                _this.mediaTypePriorities[key] = scale * value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this.mediaTypePriorities = Object.freeze(_this.mediaTypePriorities);
        _this.mediaTypeFormats = Object.freeze(_this.mediaTypeFormats);
        return _this;
    }
    (0, $byiyg._)(ActorAbstractMediaTypedFixed, [
        {
            key: "testHandle",
            value: function testHandle(action, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!mediaType || !(mediaType in this.mediaTypePriorities)) return [
                                    2,
                                    (0, $kNNoa.failTest)("Unrecognized media type: ".concat(mediaType))
                                ];
                                return [
                                    4,
                                    this.testHandleChecked(action, context)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "testMediaType",
            value: function testMediaType(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "getMediaTypes",
            value: function getMediaTypes(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.mediaTypePriorities
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "testMediaTypeFormats",
            value: function testMediaTypeFormats(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "getMediaTypeFormats",
            value: function getMediaTypeFormats(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.mediaTypeFormats
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorAbstractMediaTypedFixed;
}($8dNK3.ActorAbstractMediaTyped);
module.exports.ActorAbstractMediaTypedFixed = $52cbc8c9753f861f$var$ActorAbstractMediaTypedFixed;

});



parcelRegister("kV1cO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeFixedMediaTypes = void 0;

var $2T5vf = parcelRequire("2T5vf");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A base actor for listening to SPARQL serialize events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionSparqlSerializeOrMediaType:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorQueryResultSerializeOutputOrMediaType: The serialized quads.
 *
 * @see IActionInit
 */ var $f3aa10eb104c9c90$var$ActorQueryResultSerializeFixedMediaTypes = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed) {
    (0, $i3fW3._)(ActorQueryResultSerializeFixedMediaTypes, _actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed);
    function ActorQueryResultSerializeFixedMediaTypes(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeFixedMediaTypes);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeFixedMediaTypes, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeFixedMediaTypes, [
        {
            key: "testHandleChecked",
            value: /* eslint-enable max-len */ function testHandleChecked(_action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorQueryResultSerializeFixedMediaTypes;
}($2T5vf.ActorAbstractMediaTypedFixed);
module.exports.ActorQueryResultSerializeFixedMediaTypes = $f3aa10eb104c9c90$var$ActorQueryResultSerializeFixedMediaTypes;

});


parcelRegister("6rBT9", function(module, exports) {
'use strict';

var $78oVG = parcelRequire("78oVG");

var $e2rzw = parcelRequire("e2rzw");
var $4b12a78b6bc15ddc$var$originalDestroy = $78oVG.Readable.destroy;
module.exports = $78oVG.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $78oVG._uint8ArrayToBuffer;
module.exports._isUint8Array = $78oVG._isUint8Array;
module.exports.isDisturbed = $78oVG.isDisturbed;
module.exports.isErrored = $78oVG.isErrored;
module.exports.isReadable = $78oVG.isReadable;
module.exports.Readable = $78oVG.Readable;
module.exports.Writable = $78oVG.Writable;
module.exports.Duplex = $78oVG.Duplex;
module.exports.Transform = $78oVG.Transform;
module.exports.PassThrough = $78oVG.PassThrough;
module.exports.addAbortSignal = $78oVG.addAbortSignal;
module.exports.finished = $78oVG.finished;
module.exports.destroy = $78oVG.destroy;
module.exports.destroy = $4b12a78b6bc15ddc$var$originalDestroy;
module.exports.pipeline = $78oVG.pipeline;
module.exports.compose = $78oVG.compose;
Object.defineProperty($78oVG, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $e2rzw;
    }
});
module.exports.Stream = $78oVG.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("78oVG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $4Ltnq = parcelRequire("4Ltnq");
var $531c9e3ba23d4db0$require$Buffer = $4Ltnq.Buffer;

var $kl2GN = parcelRequire("kl2GN");
/* replacement end */ var $531c9e3ba23d4db0$var$ObjectDefineProperty = $kl2GN.ObjectDefineProperty, $531c9e3ba23d4db0$var$ObjectKeys = $kl2GN.ObjectKeys, $531c9e3ba23d4db0$var$ReflectApply = $kl2GN.ReflectApply;

var $aKXXL = parcelRequire("aKXXL");
var $531c9e3ba23d4db0$var$_require_promisify = $aKXXL.promisify, $531c9e3ba23d4db0$var$customPromisify = $531c9e3ba23d4db0$var$_require_promisify.custom;

var $9Tz0r = parcelRequire("9Tz0r");
var $531c9e3ba23d4db0$var$streamReturningOperators = $9Tz0r.streamReturningOperators, $531c9e3ba23d4db0$var$promiseReturningOperators = $9Tz0r.promiseReturningOperators;

var $aL8gC = parcelRequire("aL8gC");
var $531c9e3ba23d4db0$var$ERR_ILLEGAL_CONSTRUCTOR = $aL8gC.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $4t3s0 = parcelRequire("4t3s0");

var $jZuHC = parcelRequire("jZuHC");
var $531c9e3ba23d4db0$var$setDefaultHighWaterMark = $jZuHC.setDefaultHighWaterMark, $531c9e3ba23d4db0$var$getDefaultHighWaterMark = $jZuHC.getDefaultHighWaterMark;

var $1mjtZ = parcelRequire("1mjtZ");
var $531c9e3ba23d4db0$require$pipeline = $1mjtZ.pipeline;

var $5hUD5 = parcelRequire("5hUD5");
var $531c9e3ba23d4db0$require$destroyer = $5hUD5.destroyer;

var $77kNw = parcelRequire("77kNw");
var $531c9e3ba23d4db0$var$internalBuffer = {};

var $e2rzw = parcelRequire("e2rzw");

var $bqRki = parcelRequire("bqRki");

var $531c9e3ba23d4db0$var$Stream = module.exports = (parcelRequire("5wiDi")).Stream;
$531c9e3ba23d4db0$var$Stream.isDestroyed = $bqRki.isDestroyed;
$531c9e3ba23d4db0$var$Stream.isDisturbed = $bqRki.isDisturbed;
$531c9e3ba23d4db0$var$Stream.isErrored = $bqRki.isErrored;
$531c9e3ba23d4db0$var$Stream.isReadable = $bqRki.isReadable;
$531c9e3ba23d4db0$var$Stream.isWritable = $bqRki.isWritable;

$531c9e3ba23d4db0$var$Stream.Readable = (parcelRequire("cKbyd"));
var $531c9e3ba23d4db0$var$_iteratorNormalCompletion = true, $531c9e3ba23d4db0$var$_didIteratorError = false, $531c9e3ba23d4db0$var$_iteratorError = undefined;
try {
    for(var $531c9e3ba23d4db0$var$_iterator = $531c9e3ba23d4db0$var$ObjectKeys($531c9e3ba23d4db0$var$streamReturningOperators)[Symbol.iterator](), $531c9e3ba23d4db0$var$_step; !($531c9e3ba23d4db0$var$_iteratorNormalCompletion = ($531c9e3ba23d4db0$var$_step = $531c9e3ba23d4db0$var$_iterator.next()).done); $531c9e3ba23d4db0$var$_iteratorNormalCompletion = true){
        var $531c9e3ba23d4db0$var$key = $531c9e3ba23d4db0$var$_step.value;
        var $531c9e3ba23d4db0$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $531c9e3ba23d4db0$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $531c9e3ba23d4db0$var$Stream.Readable.from($531c9e3ba23d4db0$var$ReflectApply($531c9e3ba23d4db0$var$op, this, args));
        };
        var $531c9e3ba23d4db0$var$op = $531c9e3ba23d4db0$var$streamReturningOperators[$531c9e3ba23d4db0$var$key];
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$fn, 'name', {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$op.name
        });
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$fn, 'length', {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$op.length
        });
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$Stream.Readable.prototype, $531c9e3ba23d4db0$var$key, {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $531c9e3ba23d4db0$var$_didIteratorError = true;
    $531c9e3ba23d4db0$var$_iteratorError = err;
} finally{
    try {
        if (!$531c9e3ba23d4db0$var$_iteratorNormalCompletion && $531c9e3ba23d4db0$var$_iterator["return"] != null) {
            $531c9e3ba23d4db0$var$_iterator["return"]();
        }
    } finally{
        if ($531c9e3ba23d4db0$var$_didIteratorError) {
            throw $531c9e3ba23d4db0$var$_iteratorError;
        }
    }
}
var $531c9e3ba23d4db0$var$_iteratorNormalCompletion1 = true, $531c9e3ba23d4db0$var$_didIteratorError1 = false, $531c9e3ba23d4db0$var$_iteratorError1 = undefined;
try {
    for(var $531c9e3ba23d4db0$var$_iterator1 = $531c9e3ba23d4db0$var$ObjectKeys($531c9e3ba23d4db0$var$promiseReturningOperators)[Symbol.iterator](), $531c9e3ba23d4db0$var$_step1; !($531c9e3ba23d4db0$var$_iteratorNormalCompletion1 = ($531c9e3ba23d4db0$var$_step1 = $531c9e3ba23d4db0$var$_iterator1.next()).done); $531c9e3ba23d4db0$var$_iteratorNormalCompletion1 = true){
        var $531c9e3ba23d4db0$var$key1 = $531c9e3ba23d4db0$var$_step1.value;
        var $531c9e3ba23d4db0$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $531c9e3ba23d4db0$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $531c9e3ba23d4db0$var$ReflectApply($531c9e3ba23d4db0$var$op1, this, args);
        };
        var $531c9e3ba23d4db0$var$op1 = $531c9e3ba23d4db0$var$promiseReturningOperators[$531c9e3ba23d4db0$var$key1];
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$fn1, 'name', {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$op1.name
        });
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$fn1, 'length', {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$op1.length
        });
        $531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$Stream.Readable.prototype, $531c9e3ba23d4db0$var$key1, {
            __proto__: null,
            value: $531c9e3ba23d4db0$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $531c9e3ba23d4db0$var$_didIteratorError1 = true;
    $531c9e3ba23d4db0$var$_iteratorError1 = err;
} finally{
    try {
        if (!$531c9e3ba23d4db0$var$_iteratorNormalCompletion1 && $531c9e3ba23d4db0$var$_iterator1["return"] != null) {
            $531c9e3ba23d4db0$var$_iterator1["return"]();
        }
    } finally{
        if ($531c9e3ba23d4db0$var$_didIteratorError1) {
            throw $531c9e3ba23d4db0$var$_iteratorError1;
        }
    }
}

$531c9e3ba23d4db0$var$Stream.Writable = (parcelRequire("fPP2r"));

$531c9e3ba23d4db0$var$Stream.Duplex = (parcelRequire("kn0t3"));

$531c9e3ba23d4db0$var$Stream.Transform = (parcelRequire("jASIF"));

$531c9e3ba23d4db0$var$Stream.PassThrough = (parcelRequire("lVYXD"));
$531c9e3ba23d4db0$var$Stream.pipeline = $531c9e3ba23d4db0$require$pipeline;

var $amsso = parcelRequire("amsso");
var $531c9e3ba23d4db0$require$addAbortSignal = $amsso.addAbortSignal;
$531c9e3ba23d4db0$var$Stream.addAbortSignal = $531c9e3ba23d4db0$require$addAbortSignal;
$531c9e3ba23d4db0$var$Stream.finished = $77kNw;
$531c9e3ba23d4db0$var$Stream.destroy = $531c9e3ba23d4db0$require$destroyer;
$531c9e3ba23d4db0$var$Stream.compose = $4t3s0;
$531c9e3ba23d4db0$var$Stream.setDefaultHighWaterMark = $531c9e3ba23d4db0$var$setDefaultHighWaterMark;
$531c9e3ba23d4db0$var$Stream.getDefaultHighWaterMark = $531c9e3ba23d4db0$var$getDefaultHighWaterMark;
$531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $e2rzw;
    }
});
$531c9e3ba23d4db0$var$ObjectDefineProperty($531c9e3ba23d4db0$require$pipeline, $531c9e3ba23d4db0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $e2rzw.pipeline;
    }
});
$531c9e3ba23d4db0$var$ObjectDefineProperty($77kNw, $531c9e3ba23d4db0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $e2rzw.finished;
    }
});
// Backwards-compat with node 0.4.x
$531c9e3ba23d4db0$var$Stream.Stream = $531c9e3ba23d4db0$var$Stream;
$531c9e3ba23d4db0$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$531c9e3ba23d4db0$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $531c9e3ba23d4db0$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("4Ltnq", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $378256d6056e8f40$export$a143d493d941bafc; }, function (v) { return $378256d6056e8f40$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $378256d6056e8f40$export$f99ded8fe4b79145; }, function (v) { return $378256d6056e8f40$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $378256d6056e8f40$export$a143d493d941bafc;
var $378256d6056e8f40$export$e4cf37d7f6fb9e0a;
var $378256d6056e8f40$export$f99ded8fe4b79145;
var $378256d6056e8f40$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $378256d6056e8f40$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$378256d6056e8f40$export$a143d493d941bafc = $378256d6056e8f40$var$Buffer;
$378256d6056e8f40$export$e4cf37d7f6fb9e0a = $378256d6056e8f40$var$SlowBuffer;
$378256d6056e8f40$export$f99ded8fe4b79145 = 50;
var $378256d6056e8f40$var$K_MAX_LENGTH = 0x7fffffff;
$378256d6056e8f40$export$599f31c3813fae4d = $378256d6056e8f40$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $378256d6056e8f40$var$Buffer.TYPED_ARRAY_SUPPORT = $378256d6056e8f40$var$typedArraySupport();
if (!$378256d6056e8f40$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $378256d6056e8f40$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($378256d6056e8f40$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$378256d6056e8f40$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($378256d6056e8f40$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$378256d6056e8f40$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $378256d6056e8f40$var$createBuffer(length) {
    if (length > $378256d6056e8f40$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $378256d6056e8f40$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $378256d6056e8f40$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $378256d6056e8f40$var$allocUnsafe(arg);
    }
    return $378256d6056e8f40$var$from(arg, encodingOrOffset, length);
}
$378256d6056e8f40$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $378256d6056e8f40$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $378256d6056e8f40$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $378256d6056e8f40$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($378256d6056e8f40$var$isInstance(value, ArrayBuffer) || value && $378256d6056e8f40$var$isInstance(value.buffer, ArrayBuffer)) return $378256d6056e8f40$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($378256d6056e8f40$var$isInstance(value, SharedArrayBuffer) || value && $378256d6056e8f40$var$isInstance(value.buffer, SharedArrayBuffer))) return $378256d6056e8f40$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $378256d6056e8f40$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $378256d6056e8f40$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $378256d6056e8f40$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $378256d6056e8f40$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $378256d6056e8f40$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($378256d6056e8f40$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($378256d6056e8f40$var$Buffer, Uint8Array);
function $378256d6056e8f40$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $378256d6056e8f40$var$alloc(size, fill, encoding) {
    $378256d6056e8f40$var$assertSize(size);
    if (size <= 0) return $378256d6056e8f40$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $378256d6056e8f40$var$createBuffer(size).fill(fill, encoding) : $378256d6056e8f40$var$createBuffer(size).fill(fill);
    return $378256d6056e8f40$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $378256d6056e8f40$var$Buffer.alloc = function(size, fill, encoding) {
    return $378256d6056e8f40$var$alloc(size, fill, encoding);
};
function $378256d6056e8f40$var$allocUnsafe(size) {
    $378256d6056e8f40$var$assertSize(size);
    return $378256d6056e8f40$var$createBuffer(size < 0 ? 0 : $378256d6056e8f40$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $378256d6056e8f40$var$Buffer.allocUnsafe = function(size) {
    return $378256d6056e8f40$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $378256d6056e8f40$var$Buffer.allocUnsafeSlow = function(size) {
    return $378256d6056e8f40$var$allocUnsafe(size);
};
function $378256d6056e8f40$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$378256d6056e8f40$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $378256d6056e8f40$var$byteLength(string, encoding) | 0;
    var buf = $378256d6056e8f40$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $378256d6056e8f40$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $378256d6056e8f40$var$checked(array.length) | 0;
    var buf = $378256d6056e8f40$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $378256d6056e8f40$var$fromArrayView(arrayView) {
    if ($378256d6056e8f40$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $378256d6056e8f40$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $378256d6056e8f40$var$fromArrayLike(arrayView);
}
function $378256d6056e8f40$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $378256d6056e8f40$var$Buffer.prototype);
    return buf;
}
function $378256d6056e8f40$var$fromObject(obj) {
    if ($378256d6056e8f40$var$Buffer.isBuffer(obj)) {
        var len = $378256d6056e8f40$var$checked(obj.length) | 0;
        var buf = $378256d6056e8f40$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $378256d6056e8f40$var$numberIsNaN(obj.length)) return $378256d6056e8f40$var$createBuffer(0);
        return $378256d6056e8f40$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $378256d6056e8f40$var$fromArrayLike(obj.data);
}
function $378256d6056e8f40$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $378256d6056e8f40$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $378256d6056e8f40$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $378256d6056e8f40$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $378256d6056e8f40$var$Buffer.alloc(+length);
}
$378256d6056e8f40$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $378256d6056e8f40$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$378256d6056e8f40$var$Buffer.compare = function compare(a, b) {
    if ($378256d6056e8f40$var$isInstance(a, Uint8Array)) a = $378256d6056e8f40$var$Buffer.from(a, a.offset, a.byteLength);
    if ($378256d6056e8f40$var$isInstance(b, Uint8Array)) b = $378256d6056e8f40$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$378256d6056e8f40$var$Buffer.isBuffer(a) || !$378256d6056e8f40$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$378256d6056e8f40$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$378256d6056e8f40$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $378256d6056e8f40$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $378256d6056e8f40$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($378256d6056e8f40$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$378256d6056e8f40$var$Buffer.isBuffer(buf)) buf = $378256d6056e8f40$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$378256d6056e8f40$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $378256d6056e8f40$var$byteLength(string, encoding) {
    if ($378256d6056e8f40$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $378256d6056e8f40$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $378256d6056e8f40$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $378256d6056e8f40$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $378256d6056e8f40$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$378256d6056e8f40$var$Buffer.byteLength = $378256d6056e8f40$var$byteLength;
function $378256d6056e8f40$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $378256d6056e8f40$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $378256d6056e8f40$var$utf8Slice(this, start, end);
        case 'ascii':
            return $378256d6056e8f40$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $378256d6056e8f40$var$latin1Slice(this, start, end);
        case 'base64':
            return $378256d6056e8f40$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $378256d6056e8f40$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$378256d6056e8f40$var$Buffer.prototype._isBuffer = true;
function $378256d6056e8f40$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$378256d6056e8f40$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$378256d6056e8f40$var$swap(this, i, i + 1);
    return this;
};
$378256d6056e8f40$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $378256d6056e8f40$var$swap(this, i, i + 3);
        $378256d6056e8f40$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$378256d6056e8f40$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $378256d6056e8f40$var$swap(this, i, i + 7);
        $378256d6056e8f40$var$swap(this, i + 1, i + 6);
        $378256d6056e8f40$var$swap(this, i + 2, i + 5);
        $378256d6056e8f40$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$378256d6056e8f40$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $378256d6056e8f40$var$utf8Slice(this, 0, length);
    return $378256d6056e8f40$var$slowToString.apply(this, arguments);
};
$378256d6056e8f40$var$Buffer.prototype.toLocaleString = $378256d6056e8f40$var$Buffer.prototype.toString;
$378256d6056e8f40$var$Buffer.prototype.equals = function equals(b) {
    if (!$378256d6056e8f40$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $378256d6056e8f40$var$Buffer.compare(this, b) === 0;
};
$378256d6056e8f40$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $378256d6056e8f40$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($378256d6056e8f40$var$customInspectSymbol) $378256d6056e8f40$var$Buffer.prototype[$378256d6056e8f40$var$customInspectSymbol] = $378256d6056e8f40$var$Buffer.prototype.inspect;
$378256d6056e8f40$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($378256d6056e8f40$var$isInstance(target, Uint8Array)) target = $378256d6056e8f40$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$378256d6056e8f40$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $378256d6056e8f40$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($378256d6056e8f40$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $378256d6056e8f40$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($378256d6056e8f40$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $378256d6056e8f40$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $378256d6056e8f40$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $378256d6056e8f40$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$378256d6056e8f40$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$378256d6056e8f40$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $378256d6056e8f40$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$378256d6056e8f40$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $378256d6056e8f40$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $378256d6056e8f40$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($378256d6056e8f40$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $378256d6056e8f40$var$utf8Write(buf, string, offset, length) {
    return $378256d6056e8f40$var$blitBuffer($378256d6056e8f40$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $378256d6056e8f40$var$asciiWrite(buf, string, offset, length) {
    return $378256d6056e8f40$var$blitBuffer($378256d6056e8f40$var$asciiToBytes(string), buf, offset, length);
}
function $378256d6056e8f40$var$base64Write(buf, string, offset, length) {
    return $378256d6056e8f40$var$blitBuffer($378256d6056e8f40$var$base64ToBytes(string), buf, offset, length);
}
function $378256d6056e8f40$var$ucs2Write(buf, string, offset, length) {
    return $378256d6056e8f40$var$blitBuffer($378256d6056e8f40$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$378256d6056e8f40$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $378256d6056e8f40$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $378256d6056e8f40$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $378256d6056e8f40$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $378256d6056e8f40$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $378256d6056e8f40$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$378256d6056e8f40$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $378256d6056e8f40$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $378256d6056e8f40$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $378256d6056e8f40$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $378256d6056e8f40$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $378256d6056e8f40$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $378256d6056e8f40$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $378256d6056e8f40$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $378256d6056e8f40$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $378256d6056e8f40$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $378256d6056e8f40$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $378256d6056e8f40$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $378256d6056e8f40$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$378256d6056e8f40$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $378256d6056e8f40$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $378256d6056e8f40$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$378256d6056e8f40$var$Buffer.prototype.readUintLE = $378256d6056e8f40$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$378256d6056e8f40$var$Buffer.prototype.readUintBE = $378256d6056e8f40$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$378256d6056e8f40$var$Buffer.prototype.readUint8 = $378256d6056e8f40$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$378256d6056e8f40$var$Buffer.prototype.readUint16LE = $378256d6056e8f40$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$378256d6056e8f40$var$Buffer.prototype.readUint16BE = $378256d6056e8f40$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$378256d6056e8f40$var$Buffer.prototype.readUint32LE = $378256d6056e8f40$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$378256d6056e8f40$var$Buffer.prototype.readUint32BE = $378256d6056e8f40$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$378256d6056e8f40$var$Buffer.prototype.readBigUInt64LE = $378256d6056e8f40$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $378256d6056e8f40$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $378256d6056e8f40$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$378256d6056e8f40$var$Buffer.prototype.readBigUInt64BE = $378256d6056e8f40$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $378256d6056e8f40$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $378256d6056e8f40$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$378256d6056e8f40$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$378256d6056e8f40$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$378256d6056e8f40$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$378256d6056e8f40$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$378256d6056e8f40$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$378256d6056e8f40$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$378256d6056e8f40$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$378256d6056e8f40$var$Buffer.prototype.readBigInt64LE = $378256d6056e8f40$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $378256d6056e8f40$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $378256d6056e8f40$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$378256d6056e8f40$var$Buffer.prototype.readBigInt64BE = $378256d6056e8f40$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $378256d6056e8f40$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $378256d6056e8f40$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$378256d6056e8f40$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$378256d6056e8f40$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$378256d6056e8f40$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$378256d6056e8f40$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $378256d6056e8f40$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$378256d6056e8f40$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$378256d6056e8f40$var$Buffer.prototype.writeUintLE = $378256d6056e8f40$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $378256d6056e8f40$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$378256d6056e8f40$var$Buffer.prototype.writeUintBE = $378256d6056e8f40$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $378256d6056e8f40$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$378256d6056e8f40$var$Buffer.prototype.writeUint8 = $378256d6056e8f40$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$378256d6056e8f40$var$Buffer.prototype.writeUint16LE = $378256d6056e8f40$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$378256d6056e8f40$var$Buffer.prototype.writeUint16BE = $378256d6056e8f40$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$378256d6056e8f40$var$Buffer.prototype.writeUint32LE = $378256d6056e8f40$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$378256d6056e8f40$var$Buffer.prototype.writeUint32BE = $378256d6056e8f40$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $378256d6056e8f40$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $378256d6056e8f40$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $378256d6056e8f40$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $378256d6056e8f40$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$378256d6056e8f40$var$Buffer.prototype.writeBigUInt64LE = $378256d6056e8f40$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $378256d6056e8f40$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$378256d6056e8f40$var$Buffer.prototype.writeBigUInt64BE = $378256d6056e8f40$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $378256d6056e8f40$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$378256d6056e8f40$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $378256d6056e8f40$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$378256d6056e8f40$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $378256d6056e8f40$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$378256d6056e8f40$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$378256d6056e8f40$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$378256d6056e8f40$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$378256d6056e8f40$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$378256d6056e8f40$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$378256d6056e8f40$var$Buffer.prototype.writeBigInt64LE = $378256d6056e8f40$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $378256d6056e8f40$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$378256d6056e8f40$var$Buffer.prototype.writeBigInt64BE = $378256d6056e8f40$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $378256d6056e8f40$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $378256d6056e8f40$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $378256d6056e8f40$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$378256d6056e8f40$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $378256d6056e8f40$var$writeFloat(this, value, offset, true, noAssert);
};
$378256d6056e8f40$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $378256d6056e8f40$var$writeFloat(this, value, offset, false, noAssert);
};
function $378256d6056e8f40$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $378256d6056e8f40$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$378256d6056e8f40$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $378256d6056e8f40$var$writeDouble(this, value, offset, true, noAssert);
};
$378256d6056e8f40$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $378256d6056e8f40$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$378256d6056e8f40$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$378256d6056e8f40$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$378256d6056e8f40$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$378256d6056e8f40$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $378256d6056e8f40$var$Buffer.isBuffer(val) ? val : $378256d6056e8f40$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $378256d6056e8f40$var$errors = {};
function $378256d6056e8f40$var$E(sym, getMessage, Base) {
    $378256d6056e8f40$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$378256d6056e8f40$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$378256d6056e8f40$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$378256d6056e8f40$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $378256d6056e8f40$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $378256d6056e8f40$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $378256d6056e8f40$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $378256d6056e8f40$var$checkBounds(buf, offset, byteLength) {
    $378256d6056e8f40$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $378256d6056e8f40$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $378256d6056e8f40$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $378256d6056e8f40$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $378256d6056e8f40$var$checkBounds(buf, offset, byteLength);
}
function $378256d6056e8f40$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $378256d6056e8f40$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $378256d6056e8f40$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $378256d6056e8f40$var$validateNumber(value, type);
        throw new $378256d6056e8f40$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $378256d6056e8f40$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $378256d6056e8f40$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $378256d6056e8f40$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $378256d6056e8f40$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($378256d6056e8f40$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $378256d6056e8f40$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $378256d6056e8f40$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $378256d6056e8f40$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $378256d6056e8f40$var$base64ToBytes(str) {
    return $abUaD.toByteArray($378256d6056e8f40$var$base64clean(str));
}
function $378256d6056e8f40$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $378256d6056e8f40$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $378256d6056e8f40$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $378256d6056e8f40$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $378256d6056e8f40$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $378256d6056e8f40$var$BufferBigIntNotDefined : fn;
}
function $378256d6056e8f40$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("kl2GN", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $ece7dad4d8120e44$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $ece7dad4d8120e44$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("aKXXL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $4Ltnq = parcelRequire("4Ltnq");

var $epZJv = parcelRequire("epZJv");
var $7d4cb6aae7d7d8d3$var$format = $epZJv.format, $7d4cb6aae7d7d8d3$var$inspect = $epZJv.inspect;

var $aL8gC = parcelRequire("aL8gC");
var $7d4cb6aae7d7d8d3$var$ERR_INVALID_ARG_TYPE = $aL8gC.codes.ERR_INVALID_ARG_TYPE;

var $kl2GN = parcelRequire("kl2GN");
var $7d4cb6aae7d7d8d3$var$kResistStopPropagation = $kl2GN.kResistStopPropagation, $7d4cb6aae7d7d8d3$var$AggregateError = $kl2GN.AggregateError, $7d4cb6aae7d7d8d3$var$SymbolDispose = $kl2GN.SymbolDispose;

var $7d4cb6aae7d7d8d3$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $7d4cb6aae7d7d8d3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $7d4cb6aae7d7d8d3$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $7d4cb6aae7d7d8d3$var$Blob = globalThis.Blob || $4Ltnq.Blob;
/* eslint-disable indent */ var $7d4cb6aae7d7d8d3$var$isBlob = typeof $7d4cb6aae7d7d8d3$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $7d4cb6aae7d7d8d3$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $7d4cb6aae7d7d8d3$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $7d4cb6aae7d7d8d3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $7d4cb6aae7d7d8d3$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $7d4cb6aae7d7d8d3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $7d4cb6aae7d7d8d3$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $7d4cb6aae7d7d8d3$var$format,
    inspect: $7d4cb6aae7d7d8d3$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $7d4cb6aae7d7d8d3$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $7d4cb6aae7d7d8d3$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $7d4cb6aae7d7d8d3$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $7d4cb6aae7d7d8d3$var$validateAbortSignal(signal, 'signal');
        $7d4cb6aae7d7d8d3$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $7d4cb6aae7d7d8d3$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $7d4cb6aae7d7d8d3$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $7d4cb6aae7d7d8d3$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $7d4cb6aae7d7d8d3$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $7d4cb6aae7d7d8d3$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("epZJv", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("aL8gC", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $epZJv = parcelRequire("epZJv");
var $7d54b4d73ac2e378$var$format = $epZJv.format, $7d54b4d73ac2e378$var$inspect = $epZJv.inspect;

var $kl2GN = parcelRequire("kl2GN");
var $7d54b4d73ac2e378$var$CustomAggregateError = $kl2GN.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $7d54b4d73ac2e378$var$AggregateError = globalThis.AggregateError || $7d54b4d73ac2e378$var$CustomAggregateError;
var $7d54b4d73ac2e378$var$kIsNodeError = Symbol('kIsNodeError');
var $7d54b4d73ac2e378$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $7d54b4d73ac2e378$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $7d54b4d73ac2e378$var$nodeInternalPrefix = '__node_internal_';
var $7d54b4d73ac2e378$var$codes = {};
function $7d54b4d73ac2e378$var$assert(value, message) {
    if (!value) throw new $7d54b4d73ac2e378$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $7d54b4d73ac2e378$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $7d54b4d73ac2e378$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $7d54b4d73ac2e378$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $7d54b4d73ac2e378$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $7d54b4d73ac2e378$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $7d54b4d73ac2e378$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $7d54b4d73ac2e378$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$7d54b4d73ac2e378$var$kIsNodeError] = true;
    $7d54b4d73ac2e378$var$codes[code] = NodeError;
}
function $7d54b4d73ac2e378$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $7d54b4d73ac2e378$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $7d54b4d73ac2e378$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $7d54b4d73ac2e378$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $7d54b4d73ac2e378$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $7d54b4d73ac2e378$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$7d54b4d73ac2e378$var$E('ERR_ASSERTION', '%s', Error);
$7d54b4d73ac2e378$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $7d54b4d73ac2e378$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $7d54b4d73ac2e378$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($7d54b4d73ac2e378$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($7d54b4d73ac2e378$var$classRegExp.test(value)) instances.push(value);
            else {
                $7d54b4d73ac2e378$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $7d54b4d73ac2e378$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $7d54b4d73ac2e378$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$7d54b4d73ac2e378$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $7d54b4d73ac2e378$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$7d54b4d73ac2e378$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$7d54b4d73ac2e378$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $7d54b4d73ac2e378$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7d54b4d73ac2e378$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $7d54b4d73ac2e378$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $7d54b4d73ac2e378$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $7d54b4d73ac2e378$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $7d54b4d73ac2e378$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$7d54b4d73ac2e378$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$7d54b4d73ac2e378$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7d54b4d73ac2e378$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$7d54b4d73ac2e378$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$7d54b4d73ac2e378$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $7d54b4d73ac2e378$var$AbortError,
    aggregateTwoErrors: $7d54b4d73ac2e378$var$hideStackFrames($7d54b4d73ac2e378$var$aggregateTwoErrors),
    hideStackFrames: $7d54b4d73ac2e378$var$hideStackFrames,
    codes: $7d54b4d73ac2e378$var$codes
};

});

parcelRegister("6an3P", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ var $47d590a84c5876f2$var$_ref = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined, $47d590a84c5876f2$var$AbortController = $47d590a84c5876f2$var$_ref.AbortController, $47d590a84c5876f2$var$AbortSignal = $47d590a84c5876f2$var$_ref.AbortSignal;
/*eslint-enable @mysticatea/prettier */ module.exports = $47d590a84c5876f2$var$AbortController;
module.exports.AbortSignal = $47d590a84c5876f2$var$AbortSignal;
module.exports["default"] = $47d590a84c5876f2$var$AbortController;

});


parcelRegister("9Tz0r", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $734467922cda5570$export$42af8c323be37587; }, function (v) { return $734467922cda5570$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $734467922cda5570$export$f405f72c701dad87; }, function (v) { return $734467922cda5570$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $734467922cda5570$export$42af8c323be37587;
var $734467922cda5570$export$f405f72c701dad87;
'use strict';

var $734467922cda5570$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $aL8gC = parcelRequire("aL8gC");
var $734467922cda5570$var$_require_codes = $aL8gC.codes, $734467922cda5570$var$ERR_INVALID_ARG_VALUE = $734467922cda5570$var$_require_codes.ERR_INVALID_ARG_VALUE, $734467922cda5570$var$ERR_INVALID_ARG_TYPE = $734467922cda5570$var$_require_codes.ERR_INVALID_ARG_TYPE, $734467922cda5570$var$ERR_MISSING_ARGS = $734467922cda5570$var$_require_codes.ERR_MISSING_ARGS, $734467922cda5570$var$ERR_OUT_OF_RANGE = $734467922cda5570$var$_require_codes.ERR_OUT_OF_RANGE, $734467922cda5570$var$AbortError = $aL8gC.AbortError;

var $2V9xu = parcelRequire("2V9xu");
var $734467922cda5570$var$validateAbortSignal = $2V9xu.validateAbortSignal, $734467922cda5570$var$validateInteger = $2V9xu.validateInteger, $734467922cda5570$var$validateObject = $2V9xu.validateObject;

var $734467922cda5570$var$kWeakHandler = (parcelRequire("kl2GN")).Symbol('kWeak');

var $734467922cda5570$var$kResistStopPropagation = (parcelRequire("kl2GN")).Symbol('kResistStopPropagation');

var $77kNw = parcelRequire("77kNw");
var $734467922cda5570$require$finished = $77kNw.finished;

var $4t3s0 = parcelRequire("4t3s0");

var $amsso = parcelRequire("amsso");
var $734467922cda5570$require$addAbortSignalNoValidate = $amsso.addAbortSignalNoValidate;

var $bqRki = parcelRequire("bqRki");
var $734467922cda5570$var$isWritable = $bqRki.isWritable, $734467922cda5570$var$isNodeStream = $bqRki.isNodeStream;

var $734467922cda5570$require$deprecate = (parcelRequire("aKXXL")).deprecate;

var $734467922cda5570$var$ArrayPrototypePush = (parcelRequire("kl2GN")).ArrayPrototypePush, $734467922cda5570$var$Boolean = (parcelRequire("kl2GN")).Boolean, $734467922cda5570$var$MathFloor = (parcelRequire("kl2GN")).MathFloor, $734467922cda5570$var$Number = (parcelRequire("kl2GN")).Number, $734467922cda5570$var$NumberIsNaN = (parcelRequire("kl2GN")).NumberIsNaN, $734467922cda5570$var$Promise = (parcelRequire("kl2GN")).Promise, $734467922cda5570$var$PromiseReject = (parcelRequire("kl2GN")).PromiseReject, $734467922cda5570$var$PromiseResolve = (parcelRequire("kl2GN")).PromiseResolve, $734467922cda5570$var$PromisePrototypeThen = (parcelRequire("kl2GN")).PromisePrototypeThen, $734467922cda5570$var$Symbol = (parcelRequire("kl2GN")).Symbol;
var $734467922cda5570$var$kEmpty = $734467922cda5570$var$Symbol('kEmpty');
var $734467922cda5570$var$kEof = $734467922cda5570$var$Symbol('kEof');
function $734467922cda5570$var$compose(stream, options) {
    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
    if ($734467922cda5570$var$isNodeStream(stream) && !$734467922cda5570$var$isWritable(stream)) throw new $734467922cda5570$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $4t3s0(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $734467922cda5570$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $734467922cda5570$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $734467922cda5570$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $734467922cda5570$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $734467922cda5570$var$MathFloor(options.highWaterMark);
    $734467922cda5570$var$validateInteger(concurrency, 'options.concurrency', 1);
    $734467922cda5570$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $734467922cda5570$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $734467922cda5570$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $734467922cda5570$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $734467922cda5570$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $734467922cda5570$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $734467922cda5570$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($734467922cda5570$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $734467922cda5570$var$PromiseReject(err1);
                                $734467922cda5570$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("aKXXL")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($734467922cda5570$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $734467922cda5570$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $734467922cda5570$var$AbortError();
                        if (!(val !== $734467922cda5570$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $734467922cda5570$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $734467922cda5570$var$asIndexedPairs(options) {
    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $734467922cda5570$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $734467922cda5570$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($734467922cda5570$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $734467922cda5570$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $734467922cda5570$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $734467922cda5570$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $734467922cda5570$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($734467922cda5570$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $734467922cda5570$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $734467922cda5570$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $734467922cda5570$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($734467922cda5570$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $734467922cda5570$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $734467922cda5570$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $734467922cda5570$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $734467922cda5570$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $734467922cda5570$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($734467922cda5570$var$ERR_MISSING_ARGS);
function $734467922cda5570$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $734467922cda5570$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $734467922cda5570$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $734467922cda5570$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $734467922cda5570$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $734467922cda5570$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $734467922cda5570$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $734467922cda5570$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $734467922cda5570$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $734467922cda5570$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $734467922cda5570$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $734467922cda5570$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $734467922cda5570$var$flatMap(fn, options) {
    var values = $734467922cda5570$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $734467922cda5570$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $734467922cda5570$var$Number(number);
    if ($734467922cda5570$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $734467922cda5570$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $734467922cda5570$var$drop(number, options) {
    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
    number = $734467922cda5570$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $734467922cda5570$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $734467922cda5570$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $734467922cda5570$var$take(number, options) {
    if (options != null) $734467922cda5570$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $734467922cda5570$var$validateAbortSignal(options.signal, 'options.signal');
    number = $734467922cda5570$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $734467922cda5570$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $734467922cda5570$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$734467922cda5570$export$42af8c323be37587 = {
    asIndexedPairs: $734467922cda5570$require$deprecate($734467922cda5570$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $734467922cda5570$var$drop,
    filter: $734467922cda5570$var$filter,
    flatMap: $734467922cda5570$var$flatMap,
    map: $734467922cda5570$var$map,
    take: $734467922cda5570$var$take,
    compose: $734467922cda5570$var$compose
};
$734467922cda5570$export$f405f72c701dad87 = {
    every: $734467922cda5570$var$every,
    forEach: $734467922cda5570$var$forEach,
    reduce: $734467922cda5570$var$reduce,
    toArray: $734467922cda5570$var$toArray,
    some: $734467922cda5570$var$some,
    find: $734467922cda5570$var$find
};

});
parcelRegister("d5YHV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $988ad53e61c0b853$export$71511d61b312f219; });

var $2smnd = parcelRequire("2smnd");
function $988ad53e61c0b853$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $2smnd._)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}

});
parcelRegister("2smnd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c9f8d2db8f4f5ae$export$71511d61b312f219; });
function $1c9f8d2db8f4f5ae$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

});


parcelRegister("bq7J2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $85081d8823aed4da$export$71511d61b312f219; });
function $85081d8823aed4da$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $85081d8823aed4da$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $85081d8823aed4da$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $85081d8823aed4da$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $85081d8823aed4da$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $85081d8823aed4da$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("iw20L", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d7acc6899506fc3c$export$71511d61b312f219; });

var $2smnd = parcelRequire("2smnd");
function $d7acc6899506fc3c$export$71511d61b312f219(value) {
    return new (0, $2smnd._)(value, /* kind: await */ 0);
}

});

parcelRegister("75utm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5290a34476c19212$export$71511d61b312f219; });

var $bMcQZ = parcelRequire("bMcQZ");
function $5290a34476c19212$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $bMcQZ._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("bMcQZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $892e25dc935ad701$export$71511d61b312f219; });

var $2smnd = parcelRequire("2smnd");
function $892e25dc935ad701$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $2smnd._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$892e25dc935ad701$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$892e25dc935ad701$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$892e25dc935ad701$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$892e25dc935ad701$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("2V9xu", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $22084ded65d9507a$var$ArrayIsArray = $kl2GN.ArrayIsArray, $22084ded65d9507a$var$ArrayPrototypeIncludes = $kl2GN.ArrayPrototypeIncludes, $22084ded65d9507a$var$ArrayPrototypeJoin = $kl2GN.ArrayPrototypeJoin, $22084ded65d9507a$var$ArrayPrototypeMap = $kl2GN.ArrayPrototypeMap, $22084ded65d9507a$var$NumberIsInteger = $kl2GN.NumberIsInteger, $22084ded65d9507a$var$NumberIsNaN = $kl2GN.NumberIsNaN, $22084ded65d9507a$var$NumberMAX_SAFE_INTEGER = $kl2GN.NumberMAX_SAFE_INTEGER, $22084ded65d9507a$var$NumberMIN_SAFE_INTEGER = $kl2GN.NumberMIN_SAFE_INTEGER, $22084ded65d9507a$var$NumberParseInt = $kl2GN.NumberParseInt, $22084ded65d9507a$var$ObjectPrototypeHasOwnProperty = $kl2GN.ObjectPrototypeHasOwnProperty, $22084ded65d9507a$var$RegExpPrototypeExec = $kl2GN.RegExpPrototypeExec, $22084ded65d9507a$var$String = $kl2GN.String, $22084ded65d9507a$var$StringPrototypeToUpperCase = $kl2GN.StringPrototypeToUpperCase, $22084ded65d9507a$var$StringPrototypeTrim = $kl2GN.StringPrototypeTrim;

var $aL8gC = parcelRequire("aL8gC");
var $22084ded65d9507a$var$hideStackFrames = $aL8gC.hideStackFrames, $22084ded65d9507a$var$_require_codes = $aL8gC.codes, $22084ded65d9507a$var$ERR_SOCKET_BAD_PORT = $22084ded65d9507a$var$_require_codes.ERR_SOCKET_BAD_PORT, $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE = $22084ded65d9507a$var$_require_codes.ERR_INVALID_ARG_TYPE, $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE = $22084ded65d9507a$var$_require_codes.ERR_INVALID_ARG_VALUE, $22084ded65d9507a$var$ERR_OUT_OF_RANGE = $22084ded65d9507a$var$_require_codes.ERR_OUT_OF_RANGE, $22084ded65d9507a$var$ERR_UNKNOWN_SIGNAL = $22084ded65d9507a$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $aKXXL = parcelRequire("aKXXL");
var $22084ded65d9507a$require$normalizeEncoding = $aKXXL.normalizeEncoding;

var $aKXXL = parcelRequire("aKXXL");
var $22084ded65d9507a$require$_require_types = $aKXXL.types;
var $22084ded65d9507a$var$isAsyncFunction = $22084ded65d9507a$require$_require_types.isAsyncFunction, $22084ded65d9507a$var$isArrayBufferView = $22084ded65d9507a$require$_require_types.isArrayBufferView;
var $22084ded65d9507a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $22084ded65d9507a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $22084ded65d9507a$var$isUint32(value) {
    return value === value >>> 0;
}
var $22084ded65d9507a$var$octalReg = /^[0-7]+$/;
var $22084ded65d9507a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $22084ded65d9507a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($22084ded65d9507a$var$RegExpPrototypeExec($22084ded65d9507a$var$octalReg, value) === null) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE(name, value, $22084ded65d9507a$var$modeDesc);
        value = $22084ded65d9507a$var$NumberParseInt(value, 8);
    }
    $22084ded65d9507a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $22084ded65d9507a$var$validateInteger = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $22084ded65d9507a$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $22084ded65d9507a$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$22084ded65d9507a$var$NumberIsInteger(value)) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $22084ded65d9507a$var$validateInt32 = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$22084ded65d9507a$var$NumberIsInteger(value)) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $22084ded65d9507a$var$validateUint32 = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$22084ded65d9507a$var$NumberIsInteger(value)) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $22084ded65d9507a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $22084ded65d9507a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $22084ded65d9507a$var$NumberIsNaN(value)) throw new $22084ded65d9507a$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $22084ded65d9507a$var$validateOneOf = $22084ded65d9507a$var$hideStackFrames(function(value, name, oneOf) {
    if (!$22084ded65d9507a$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $22084ded65d9507a$var$ArrayPrototypeJoin($22084ded65d9507a$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $22084ded65d9507a$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $22084ded65d9507a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $22084ded65d9507a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$22084ded65d9507a$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $22084ded65d9507a$var$validateObject = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $22084ded65d9507a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $22084ded65d9507a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $22084ded65d9507a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $22084ded65d9507a$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $22084ded65d9507a$var$validateDictionary = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $22084ded65d9507a$var$validateArray = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$22084ded65d9507a$var$ArrayIsArray(value)) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $22084ded65d9507a$var$validateStringArray(value, name) {
    $22084ded65d9507a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$22084ded65d9507a$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $22084ded65d9507a$var$validateBooleanArray(value, name) {
    $22084ded65d9507a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$22084ded65d9507a$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $22084ded65d9507a$var$validateAbortSignalArray(value, name) {
    $22084ded65d9507a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $22084ded65d9507a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $22084ded65d9507a$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $22084ded65d9507a$var$validateString(signal, name);
    if ($22084ded65d9507a$var$signals[signal] === undefined) {
        if ($22084ded65d9507a$var$signals[$22084ded65d9507a$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $22084ded65d9507a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $22084ded65d9507a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $22084ded65d9507a$var$validateBuffer = $22084ded65d9507a$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$22084ded65d9507a$var$isArrayBufferView(buffer)) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $22084ded65d9507a$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $22084ded65d9507a$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $22084ded65d9507a$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $22084ded65d9507a$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $22084ded65d9507a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $22084ded65d9507a$var$validateAbortSignal = $22084ded65d9507a$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $22084ded65d9507a$var$validateFunction = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $22084ded65d9507a$var$validatePlainFunction = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $22084ded65d9507a$var$isAsyncFunction(value)) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $22084ded65d9507a$var$validateUndefined = $22084ded65d9507a$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $22084ded65d9507a$var$validateUnion(value, name, union) {
    if (!$22084ded65d9507a$var$ArrayPrototypeIncludes(union, value)) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_TYPE(name, "('".concat($22084ded65d9507a$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $22084ded65d9507a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $22084ded65d9507a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$22084ded65d9507a$var$RegExpPrototypeExec($22084ded65d9507a$var$linkValueRegExp, value)) throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $22084ded65d9507a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $22084ded65d9507a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($22084ded65d9507a$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $22084ded65d9507a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $22084ded65d9507a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $22084ded65d9507a$var$isInt32,
    isUint32: $22084ded65d9507a$var$isUint32,
    parseFileMode: $22084ded65d9507a$var$parseFileMode,
    validateArray: $22084ded65d9507a$var$validateArray,
    validateStringArray: $22084ded65d9507a$var$validateStringArray,
    validateBooleanArray: $22084ded65d9507a$var$validateBooleanArray,
    validateAbortSignalArray: $22084ded65d9507a$var$validateAbortSignalArray,
    validateBoolean: $22084ded65d9507a$var$validateBoolean,
    validateBuffer: $22084ded65d9507a$var$validateBuffer,
    validateDictionary: $22084ded65d9507a$var$validateDictionary,
    validateEncoding: $22084ded65d9507a$var$validateEncoding,
    validateFunction: $22084ded65d9507a$var$validateFunction,
    validateInt32: $22084ded65d9507a$var$validateInt32,
    validateInteger: $22084ded65d9507a$var$validateInteger,
    validateNumber: $22084ded65d9507a$var$validateNumber,
    validateObject: $22084ded65d9507a$var$validateObject,
    validateOneOf: $22084ded65d9507a$var$validateOneOf,
    validatePlainFunction: $22084ded65d9507a$var$validatePlainFunction,
    validatePort: $22084ded65d9507a$var$validatePort,
    validateSignalName: $22084ded65d9507a$var$validateSignalName,
    validateString: $22084ded65d9507a$var$validateString,
    validateUint32: $22084ded65d9507a$var$validateUint32,
    validateUndefined: $22084ded65d9507a$var$validateUndefined,
    validateUnion: $22084ded65d9507a$var$validateUnion,
    validateAbortSignal: $22084ded65d9507a$var$validateAbortSignal,
    validateLinkHeaderValue: $22084ded65d9507a$var$validateLinkHeaderValue
};

});

parcelRegister("77kNw", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $aL8gC = parcelRequire("aL8gC");
/* replacement end */ var $52e951d68c4cf581$var$AbortError = $aL8gC.AbortError, $52e951d68c4cf581$var$codes = $aL8gC.codes;
var $52e951d68c4cf581$var$ERR_INVALID_ARG_TYPE = $52e951d68c4cf581$var$codes.ERR_INVALID_ARG_TYPE, $52e951d68c4cf581$var$ERR_STREAM_PREMATURE_CLOSE = $52e951d68c4cf581$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $52e951d68c4cf581$var$kEmptyObject = (parcelRequire("aKXXL")).kEmptyObject, $52e951d68c4cf581$var$once = (parcelRequire("aKXXL")).once;

var $2V9xu = parcelRequire("2V9xu");
var $52e951d68c4cf581$var$validateAbortSignal = $2V9xu.validateAbortSignal, $52e951d68c4cf581$var$validateFunction = $2V9xu.validateFunction, $52e951d68c4cf581$var$validateObject = $2V9xu.validateObject, $52e951d68c4cf581$var$validateBoolean = $2V9xu.validateBoolean;

var $kl2GN = parcelRequire("kl2GN");
var $52e951d68c4cf581$var$Promise = $kl2GN.Promise, $52e951d68c4cf581$var$PromisePrototypeThen = $kl2GN.PromisePrototypeThen, $52e951d68c4cf581$var$SymbolDispose = $kl2GN.SymbolDispose;

var $bqRki = parcelRequire("bqRki");
var $52e951d68c4cf581$var$isClosed = $bqRki.isClosed, $52e951d68c4cf581$var$isReadable = $bqRki.isReadable, $52e951d68c4cf581$var$isReadableNodeStream = $bqRki.isReadableNodeStream, $52e951d68c4cf581$var$isReadableStream = $bqRki.isReadableStream, $52e951d68c4cf581$var$isReadableFinished = $bqRki.isReadableFinished, $52e951d68c4cf581$var$isReadableErrored = $bqRki.isReadableErrored, $52e951d68c4cf581$var$isWritable = $bqRki.isWritable, $52e951d68c4cf581$var$isWritableNodeStream = $bqRki.isWritableNodeStream, $52e951d68c4cf581$var$isWritableStream = $bqRki.isWritableStream, $52e951d68c4cf581$var$isWritableFinished = $bqRki.isWritableFinished, $52e951d68c4cf581$var$isWritableErrored = $bqRki.isWritableErrored, $52e951d68c4cf581$var$isNodeStream = $bqRki.isNodeStream, $52e951d68c4cf581$var$_willEmitClose = $bqRki.willEmitClose, $52e951d68c4cf581$var$kIsClosedPromise = $bqRki.kIsClosedPromise;
var $52e951d68c4cf581$var$addAbortListener;
function $52e951d68c4cf581$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $52e951d68c4cf581$var$nop = function() {};

function $52e951d68c4cf581$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $52e951d68c4cf581$var$kEmptyObject;
    } else if (options == null) options = $52e951d68c4cf581$var$kEmptyObject;
    else $52e951d68c4cf581$var$validateObject(options, 'options');
    $52e951d68c4cf581$var$validateFunction(callback, 'callback');
    $52e951d68c4cf581$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $52e951d68c4cf581$var$once(callback);
    if ($52e951d68c4cf581$var$isReadableStream(stream) || $52e951d68c4cf581$var$isWritableStream(stream)) return $52e951d68c4cf581$var$eosWeb(stream, options, callback);
    if (!$52e951d68c4cf581$var$isNodeStream(stream)) throw new $52e951d68c4cf581$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $52e951d68c4cf581$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $52e951d68c4cf581$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $52e951d68c4cf581$var$_willEmitClose(stream) && $52e951d68c4cf581$var$isReadableNodeStream(stream) === readable && $52e951d68c4cf581$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $52e951d68c4cf581$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $52e951d68c4cf581$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $52e951d68c4cf581$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $52e951d68c4cf581$var$isWritableErrored(stream) || $52e951d68c4cf581$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $52e951d68c4cf581$var$isReadableNodeStream(stream, true)) {
            if (!$52e951d68c4cf581$var$isReadableFinished(stream, false)) return callback.call(stream, new $52e951d68c4cf581$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$52e951d68c4cf581$var$isWritableFinished(stream, false)) return callback.call(stream, new $52e951d68c4cf581$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $52e951d68c4cf581$var$isWritableErrored(stream) || $52e951d68c4cf581$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($52e951d68c4cf581$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $52e951d68c4cf581$var$isReadable(stream)) && (writableFinished || $52e951d68c4cf581$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $52e951d68c4cf581$var$isWritable(stream)) && (readableFinished || $52e951d68c4cf581$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $52e951d68c4cf581$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $52e951d68c4cf581$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $52e951d68c4cf581$var$addAbortListener = $52e951d68c4cf581$var$addAbortListener || (parcelRequire("aKXXL")).addAbortListener;
            var disposable = $52e951d68c4cf581$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $52e951d68c4cf581$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$52e951d68c4cf581$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $52e951d68c4cf581$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $52e951d68c4cf581$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $52e951d68c4cf581$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $52e951d68c4cf581$var$addAbortListener = $52e951d68c4cf581$var$addAbortListener || (parcelRequire("aKXXL")).addAbortListener;
            var disposable = $52e951d68c4cf581$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $52e951d68c4cf581$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$52e951d68c4cf581$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $52e951d68c4cf581$var$PromisePrototypeThen(stream[$52e951d68c4cf581$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $52e951d68c4cf581$var$nop;
}
function $52e951d68c4cf581$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $52e951d68c4cf581$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $52e951d68c4cf581$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $52e951d68c4cf581$var$Promise(function(resolve, reject) {
        var cleanup = $52e951d68c4cf581$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $52e951d68c4cf581$var$eos;
module.exports.finished = $52e951d68c4cf581$var$finished;

});
parcelRegister("bqRki", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $852b7ce63a3bac41$var$SymbolAsyncIterator = $kl2GN.SymbolAsyncIterator, $852b7ce63a3bac41$var$SymbolIterator = $kl2GN.SymbolIterator, $852b7ce63a3bac41$var$SymbolFor = $kl2GN.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $852b7ce63a3bac41$var$kIsDestroyed = $852b7ce63a3bac41$var$SymbolFor('nodejs.stream.destroyed');
var $852b7ce63a3bac41$var$kIsErrored = $852b7ce63a3bac41$var$SymbolFor('nodejs.stream.errored');
var $852b7ce63a3bac41$var$kIsReadable = $852b7ce63a3bac41$var$SymbolFor('nodejs.stream.readable');
var $852b7ce63a3bac41$var$kIsWritable = $852b7ce63a3bac41$var$SymbolFor('nodejs.stream.writable');
var $852b7ce63a3bac41$var$kIsDisturbed = $852b7ce63a3bac41$var$SymbolFor('nodejs.stream.disturbed');
var $852b7ce63a3bac41$var$kIsClosedPromise = $852b7ce63a3bac41$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $852b7ce63a3bac41$var$kControllerErrorFunction = $852b7ce63a3bac41$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $852b7ce63a3bac41$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $852b7ce63a3bac41$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $852b7ce63a3bac41$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $852b7ce63a3bac41$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $852b7ce63a3bac41$var$isReadableStream(obj) {
    return !!(obj && !$852b7ce63a3bac41$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $852b7ce63a3bac41$var$isWritableStream(obj) {
    return !!(obj && !$852b7ce63a3bac41$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $852b7ce63a3bac41$var$isTransformStream(obj) {
    return !!(obj && !$852b7ce63a3bac41$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $852b7ce63a3bac41$var$isWebStream(obj) {
    return $852b7ce63a3bac41$var$isReadableStream(obj) || $852b7ce63a3bac41$var$isWritableStream(obj) || $852b7ce63a3bac41$var$isTransformStream(obj);
}
function $852b7ce63a3bac41$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$852b7ce63a3bac41$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$852b7ce63a3bac41$var$SymbolIterator] === 'function';
    return typeof obj[$852b7ce63a3bac41$var$SymbolAsyncIterator] === 'function' || typeof obj[$852b7ce63a3bac41$var$SymbolIterator] === 'function';
}
function $852b7ce63a3bac41$var$isDestroyed(stream) {
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$852b7ce63a3bac41$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $852b7ce63a3bac41$var$isWritableEnded(stream) {
    if (!$852b7ce63a3bac41$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $852b7ce63a3bac41$var$isWritableFinished(stream, strict) {
    if (!$852b7ce63a3bac41$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $852b7ce63a3bac41$var$isReadableEnded(stream) {
    if (!$852b7ce63a3bac41$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $852b7ce63a3bac41$var$isReadableFinished(stream, strict) {
    if (!$852b7ce63a3bac41$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $852b7ce63a3bac41$var$isReadable(stream) {
    if (stream && stream[$852b7ce63a3bac41$var$kIsReadable] != null) return stream[$852b7ce63a3bac41$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($852b7ce63a3bac41$var$isDestroyed(stream)) return false;
    return $852b7ce63a3bac41$var$isReadableNodeStream(stream) && stream.readable && !$852b7ce63a3bac41$var$isReadableFinished(stream);
}
function $852b7ce63a3bac41$var$isWritable(stream) {
    if (stream && stream[$852b7ce63a3bac41$var$kIsWritable] != null) return stream[$852b7ce63a3bac41$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($852b7ce63a3bac41$var$isDestroyed(stream)) return false;
    return $852b7ce63a3bac41$var$isWritableNodeStream(stream) && stream.writable && !$852b7ce63a3bac41$var$isWritableEnded(stream);
}
function $852b7ce63a3bac41$var$isFinished(stream, opts) {
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    if ($852b7ce63a3bac41$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $852b7ce63a3bac41$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $852b7ce63a3bac41$var$isWritable(stream)) return false;
    return true;
}
function $852b7ce63a3bac41$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $852b7ce63a3bac41$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $852b7ce63a3bac41$var$isClosed(stream) {
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $852b7ce63a3bac41$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $852b7ce63a3bac41$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $852b7ce63a3bac41$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $852b7ce63a3bac41$var$isOutgoingMessage(stream);
}
function $852b7ce63a3bac41$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $852b7ce63a3bac41$var$willEmitClose(stream) {
    if (!$852b7ce63a3bac41$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $852b7ce63a3bac41$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $852b7ce63a3bac41$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$852b7ce63a3bac41$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $852b7ce63a3bac41$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$852b7ce63a3bac41$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $852b7ce63a3bac41$var$isDestroyed,
    kIsDestroyed: $852b7ce63a3bac41$var$kIsDestroyed,
    isDisturbed: $852b7ce63a3bac41$var$isDisturbed,
    kIsDisturbed: $852b7ce63a3bac41$var$kIsDisturbed,
    isErrored: $852b7ce63a3bac41$var$isErrored,
    kIsErrored: $852b7ce63a3bac41$var$kIsErrored,
    isReadable: $852b7ce63a3bac41$var$isReadable,
    kIsReadable: $852b7ce63a3bac41$var$kIsReadable,
    kIsClosedPromise: $852b7ce63a3bac41$var$kIsClosedPromise,
    kControllerErrorFunction: $852b7ce63a3bac41$var$kControllerErrorFunction,
    kIsWritable: $852b7ce63a3bac41$var$kIsWritable,
    isClosed: $852b7ce63a3bac41$var$isClosed,
    isDuplexNodeStream: $852b7ce63a3bac41$var$isDuplexNodeStream,
    isFinished: $852b7ce63a3bac41$var$isFinished,
    isIterable: $852b7ce63a3bac41$var$isIterable,
    isReadableNodeStream: $852b7ce63a3bac41$var$isReadableNodeStream,
    isReadableStream: $852b7ce63a3bac41$var$isReadableStream,
    isReadableEnded: $852b7ce63a3bac41$var$isReadableEnded,
    isReadableFinished: $852b7ce63a3bac41$var$isReadableFinished,
    isReadableErrored: $852b7ce63a3bac41$var$isReadableErrored,
    isNodeStream: $852b7ce63a3bac41$var$isNodeStream,
    isWebStream: $852b7ce63a3bac41$var$isWebStream,
    isWritable: $852b7ce63a3bac41$var$isWritable,
    isWritableNodeStream: $852b7ce63a3bac41$var$isWritableNodeStream,
    isWritableStream: $852b7ce63a3bac41$var$isWritableStream,
    isWritableEnded: $852b7ce63a3bac41$var$isWritableEnded,
    isWritableFinished: $852b7ce63a3bac41$var$isWritableFinished,
    isWritableErrored: $852b7ce63a3bac41$var$isWritableErrored,
    isServerRequest: $852b7ce63a3bac41$var$isServerRequest,
    isServerResponse: $852b7ce63a3bac41$var$isServerResponse,
    willEmitClose: $852b7ce63a3bac41$var$willEmitClose,
    isTransformStream: $852b7ce63a3bac41$var$isTransformStream
};

});


parcelRegister("4t3s0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $1mjtZ = parcelRequire("1mjtZ");
var $340c8c127ce95ed0$require$pipeline = $1mjtZ.pipeline;

var $kn0t3 = parcelRequire("kn0t3");

var $5hUD5 = parcelRequire("5hUD5");
var $340c8c127ce95ed0$require$destroyer = $5hUD5.destroyer;

var $bqRki = parcelRequire("bqRki");
var $340c8c127ce95ed0$var$isNodeStream = $bqRki.isNodeStream, $340c8c127ce95ed0$var$isReadable = $bqRki.isReadable, $340c8c127ce95ed0$var$isWritable = $bqRki.isWritable, $340c8c127ce95ed0$var$isWebStream = $bqRki.isWebStream, $340c8c127ce95ed0$var$isTransformStream = $bqRki.isTransformStream, $340c8c127ce95ed0$var$isWritableStream = $bqRki.isWritableStream, $340c8c127ce95ed0$var$isReadableStream = $bqRki.isReadableStream;

var $aL8gC = parcelRequire("aL8gC");
var $340c8c127ce95ed0$var$AbortError = $aL8gC.AbortError, $340c8c127ce95ed0$var$_require_codes = $aL8gC.codes, $340c8c127ce95ed0$var$ERR_INVALID_ARG_VALUE = $340c8c127ce95ed0$var$_require_codes.ERR_INVALID_ARG_VALUE, $340c8c127ce95ed0$var$ERR_MISSING_ARGS = $340c8c127ce95ed0$var$_require_codes.ERR_MISSING_ARGS;

var $77kNw = parcelRequire("77kNw");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $340c8c127ce95ed0$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $kn0t3.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $kn0t3.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $kn0t3.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$340c8c127ce95ed0$var$isNodeStream(streams[n]) && !$340c8c127ce95ed0$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($340c8c127ce95ed0$var$isReadable(streams[n]) || $340c8c127ce95ed0$var$isReadableStream(streams[n]) || $340c8c127ce95ed0$var$isTransformStream(streams[n]))) throw new $340c8c127ce95ed0$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($340c8c127ce95ed0$var$isWritable(streams[n]) || $340c8c127ce95ed0$var$isWritableStream(streams[n]) || $340c8c127ce95ed0$var$isTransformStream(streams[n]))) throw new $340c8c127ce95ed0$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $340c8c127ce95ed0$require$pipeline(streams, onfinished);
    var writable = !!($340c8c127ce95ed0$var$isWritable(head) || $340c8c127ce95ed0$var$isWritableStream(head) || $340c8c127ce95ed0$var$isTransformStream(head));
    var readable = !!($340c8c127ce95ed0$var$isReadable(tail) || $340c8c127ce95ed0$var$isReadableStream(tail) || $340c8c127ce95ed0$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $kn0t3({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($340c8c127ce95ed0$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($340c8c127ce95ed0$var$isWebStream(head)) {
            var writable1 = $340c8c127ce95ed0$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $340c8c127ce95ed0$var$isTransformStream(tail) ? tail.readable : tail;
        $77kNw(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($340c8c127ce95ed0$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($340c8c127ce95ed0$var$isWebStream(tail)) {
            var readable1 = $340c8c127ce95ed0$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $340c8c127ce95ed0$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($340c8c127ce95ed0$var$isNodeStream(tail)) $340c8c127ce95ed0$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("1mjtZ", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $0fd6f565c861b034$var$ArrayIsArray = $kl2GN.ArrayIsArray, $0fd6f565c861b034$var$Promise = $kl2GN.Promise, $0fd6f565c861b034$var$SymbolAsyncIterator = $kl2GN.SymbolAsyncIterator, $0fd6f565c861b034$var$SymbolDispose = $kl2GN.SymbolDispose;

var $77kNw = parcelRequire("77kNw");

var $0fd6f565c861b034$require$once = (parcelRequire("aKXXL")).once;

var $5hUD5 = parcelRequire("5hUD5");

var $kn0t3 = parcelRequire("kn0t3");

var $aL8gC = parcelRequire("aL8gC");
var $0fd6f565c861b034$var$aggregateTwoErrors = $aL8gC.aggregateTwoErrors, $0fd6f565c861b034$var$_require_codes = $aL8gC.codes, $0fd6f565c861b034$var$ERR_INVALID_ARG_TYPE = $0fd6f565c861b034$var$_require_codes.ERR_INVALID_ARG_TYPE, $0fd6f565c861b034$var$ERR_INVALID_RETURN_VALUE = $0fd6f565c861b034$var$_require_codes.ERR_INVALID_RETURN_VALUE, $0fd6f565c861b034$var$ERR_MISSING_ARGS = $0fd6f565c861b034$var$_require_codes.ERR_MISSING_ARGS, $0fd6f565c861b034$var$ERR_STREAM_DESTROYED = $0fd6f565c861b034$var$_require_codes.ERR_STREAM_DESTROYED, $0fd6f565c861b034$var$ERR_STREAM_PREMATURE_CLOSE = $0fd6f565c861b034$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $0fd6f565c861b034$var$AbortError = $aL8gC.AbortError;

var $2V9xu = parcelRequire("2V9xu");
var $0fd6f565c861b034$var$validateFunction = $2V9xu.validateFunction, $0fd6f565c861b034$var$validateAbortSignal = $2V9xu.validateAbortSignal;

var $bqRki = parcelRequire("bqRki");
var $0fd6f565c861b034$var$isIterable = $bqRki.isIterable, $0fd6f565c861b034$var$isReadable = $bqRki.isReadable, $0fd6f565c861b034$var$isReadableNodeStream = $bqRki.isReadableNodeStream, $0fd6f565c861b034$var$isNodeStream = $bqRki.isNodeStream, $0fd6f565c861b034$var$isTransformStream = $bqRki.isTransformStream, $0fd6f565c861b034$var$isWebStream = $bqRki.isWebStream, $0fd6f565c861b034$var$isReadableStream = $bqRki.isReadableStream, $0fd6f565c861b034$var$isReadableFinished = $bqRki.isReadableFinished;

var $0fd6f565c861b034$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $0fd6f565c861b034$var$PassThrough;
var $0fd6f565c861b034$var$Readable;
var $0fd6f565c861b034$var$addAbortListener;
function $0fd6f565c861b034$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $77kNw(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $5hUD5.destroyer(stream, err || new $0fd6f565c861b034$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $0fd6f565c861b034$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $0fd6f565c861b034$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $0fd6f565c861b034$var$makeAsyncIterable(val) {
    if ($0fd6f565c861b034$var$isIterable(val)) return val;
    else if ($0fd6f565c861b034$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $0fd6f565c861b034$var$fromReadable(val);
    throw new $0fd6f565c861b034$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $0fd6f565c861b034$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$0fd6f565c861b034$var$Readable) $0fd6f565c861b034$var$Readable = (parcelRequire("cKbyd"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($0fd6f565c861b034$var$Readable.prototype[$0fd6f565c861b034$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0fd6f565c861b034$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $0fd6f565c861b034$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $77kNw(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $0fd6f565c861b034$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0fd6f565c861b034$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($0fd6f565c861b034$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0fd6f565c861b034$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $0fd6f565c861b034$var$pipelineImpl(streams, $0fd6f565c861b034$require$once($0fd6f565c861b034$var$popCallback(streams)));
}


function $0fd6f565c861b034$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($0fd6f565c861b034$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $0fd6f565c861b034$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($0fd6f565c861b034$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($0fd6f565c861b034$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$0fd6f565c861b034$var$isIterable(ret)) throw new $0fd6f565c861b034$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($0fd6f565c861b034$var$isIterable(stream) || $0fd6f565c861b034$var$isReadableNodeStream(stream) || $0fd6f565c861b034$var$isTransformStream(stream)) ret = stream;
            else ret = $kn0t3.from(stream);
        } else if (typeof stream === 'function') {
            if ($0fd6f565c861b034$var$isTransformStream(ret)) {
                var _ret;
                ret = $0fd6f565c861b034$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $0fd6f565c861b034$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$0fd6f565c861b034$var$isIterable(ret, true)) throw new $0fd6f565c861b034$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$0fd6f565c861b034$var$PassThrough) $0fd6f565c861b034$var$PassThrough = (parcelRequire("lVYXD"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $0fd6f565c861b034$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($0fd6f565c861b034$var$isIterable(ret, true)) {
                    finishCount++;
                    $0fd6f565c861b034$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($0fd6f565c861b034$var$isReadableStream(ret) || $0fd6f565c861b034$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $0fd6f565c861b034$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $0fd6f565c861b034$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $0fd6f565c861b034$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($0fd6f565c861b034$var$isNodeStream(stream)) {
            if ($0fd6f565c861b034$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $0fd6f565c861b034$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($0fd6f565c861b034$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($0fd6f565c861b034$var$isTransformStream(ret) || $0fd6f565c861b034$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $0fd6f565c861b034$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($0fd6f565c861b034$var$isIterable(ret)) {
                finishCount++;
                $0fd6f565c861b034$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $0fd6f565c861b034$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($0fd6f565c861b034$var$isWebStream(stream)) {
            if ($0fd6f565c861b034$var$isReadableNodeStream(ret)) {
                finishCount++;
                $0fd6f565c861b034$var$pumpToWeb($0fd6f565c861b034$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($0fd6f565c861b034$var$isReadableStream(ret) || $0fd6f565c861b034$var$isIterable(ret)) {
                finishCount++;
                $0fd6f565c861b034$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($0fd6f565c861b034$var$isTransformStream(ret)) {
                finishCount++;
                $0fd6f565c861b034$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $0fd6f565c861b034$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $kn0t3.from(stream);
    };
    if (streams.length === 1 && $0fd6f565c861b034$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $0fd6f565c861b034$var$ERR_MISSING_ARGS('streams');
    var ac = new $0fd6f565c861b034$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $0fd6f565c861b034$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $0fd6f565c861b034$var$AbortError());
    }
    $0fd6f565c861b034$var$addAbortListener = $0fd6f565c861b034$var$addAbortListener || (parcelRequire("aKXXL")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $0fd6f565c861b034$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$0fd6f565c861b034$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $0fd6f565c861b034$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $0fd6f565c861b034$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($0fd6f565c861b034$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $77kNw(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $77kNw(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $0fd6f565c861b034$var$pipelineImpl,
    pipeline: $0fd6f565c861b034$var$pipeline
};

});
parcelRegister("5hUD5", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $aL8gC = parcelRequire("aL8gC");
/* replacement end */ var $3d9a77b043b655b3$var$aggregateTwoErrors = $aL8gC.aggregateTwoErrors, $3d9a77b043b655b3$var$ERR_MULTIPLE_CALLBACK = $aL8gC.codes.ERR_MULTIPLE_CALLBACK, $3d9a77b043b655b3$var$AbortError = $aL8gC.AbortError;

var $kl2GN = parcelRequire("kl2GN");
var $3d9a77b043b655b3$require$Symbol = $kl2GN.Symbol;

var $bqRki = parcelRequire("bqRki");
var $3d9a77b043b655b3$var$kIsDestroyed = $bqRki.kIsDestroyed, $3d9a77b043b655b3$var$isDestroyed = $bqRki.isDestroyed, $3d9a77b043b655b3$var$isFinished = $bqRki.isFinished, $3d9a77b043b655b3$var$isServerRequest = $bqRki.isServerRequest;
var $3d9a77b043b655b3$var$kDestroy = $3d9a77b043b655b3$require$Symbol('kDestroy');
var $3d9a77b043b655b3$var$kConstruct = $3d9a77b043b655b3$require$Symbol('kConstruct');
function $3d9a77b043b655b3$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $3d9a77b043b655b3$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $3d9a77b043b655b3$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($3d9a77b043b655b3$var$kDestroy, function(er) {
        $3d9a77b043b655b3$var$_destroy(this, $3d9a77b043b655b3$var$aggregateTwoErrors(er, err), cb);
    });
    else $3d9a77b043b655b3$var$_destroy(this, err, cb);
    return this;
}
function $3d9a77b043b655b3$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $3d9a77b043b655b3$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($3d9a77b043b655b3$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($3d9a77b043b655b3$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $3d9a77b043b655b3$var$emitErrorCloseNT(self, err) {
    $3d9a77b043b655b3$var$emitErrorNT(self, err);
    $3d9a77b043b655b3$var$emitCloseNT(self);
}
function $3d9a77b043b655b3$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $3d9a77b043b655b3$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $3d9a77b043b655b3$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $3d9a77b043b655b3$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($3d9a77b043b655b3$var$emitErrorNT, stream, err);
        else $3d9a77b043b655b3$var$emitErrorNT(stream, err);
    }
}
function $3d9a77b043b655b3$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($3d9a77b043b655b3$var$kConstruct, cb);
    if (stream.listenerCount($3d9a77b043b655b3$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($3d9a77b043b655b3$var$constructNT, stream);
}
function $3d9a77b043b655b3$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $3d9a77b043b655b3$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $3d9a77b043b655b3$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($3d9a77b043b655b3$var$kDestroy, err);
        else if (err) $3d9a77b043b655b3$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($3d9a77b043b655b3$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $3d9a77b043b655b3$var$emitConstructNT(stream) {
    stream.emit($3d9a77b043b655b3$var$kConstruct);
}
function $3d9a77b043b655b3$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $3d9a77b043b655b3$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $3d9a77b043b655b3$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($3d9a77b043b655b3$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $3d9a77b043b655b3$var$destroyer(stream, err) {
    if (!stream || $3d9a77b043b655b3$var$isDestroyed(stream)) return;
    if (!err && !$3d9a77b043b655b3$var$isFinished(stream)) err = new $3d9a77b043b655b3$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($3d9a77b043b655b3$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($3d9a77b043b655b3$var$isRequest(stream)) stream.abort();
    else if ($3d9a77b043b655b3$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($3d9a77b043b655b3$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($3d9a77b043b655b3$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$3d9a77b043b655b3$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $3d9a77b043b655b3$var$construct,
    destroyer: $3d9a77b043b655b3$var$destroyer,
    destroy: $3d9a77b043b655b3$var$destroy,
    undestroy: $3d9a77b043b655b3$var$undestroy,
    errorOrDestroy: $3d9a77b043b655b3$var$errorOrDestroy
};

});

parcelRegister("kn0t3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $ed465176c9f82c1b$var$ObjectDefineProperties = $kl2GN.ObjectDefineProperties, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor = $kl2GN.ObjectGetOwnPropertyDescriptor, $ed465176c9f82c1b$var$ObjectKeys = $kl2GN.ObjectKeys, $ed465176c9f82c1b$var$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf;
module.exports = $ed465176c9f82c1b$var$Duplex;

var $cKbyd = parcelRequire("cKbyd");

var $fPP2r = parcelRequire("fPP2r");
$ed465176c9f82c1b$var$ObjectSetPrototypeOf($ed465176c9f82c1b$var$Duplex.prototype, $cKbyd.prototype);
$ed465176c9f82c1b$var$ObjectSetPrototypeOf($ed465176c9f82c1b$var$Duplex, $cKbyd);
{
    var $ed465176c9f82c1b$var$keys = $ed465176c9f82c1b$var$ObjectKeys($fPP2r.prototype);
    // Allow the keys array to be GC'ed.
    for(var $ed465176c9f82c1b$var$i = 0; $ed465176c9f82c1b$var$i < $ed465176c9f82c1b$var$keys.length; $ed465176c9f82c1b$var$i++){
        var $ed465176c9f82c1b$var$method = $ed465176c9f82c1b$var$keys[$ed465176c9f82c1b$var$i];
        if (!$ed465176c9f82c1b$var$Duplex.prototype[$ed465176c9f82c1b$var$method]) $ed465176c9f82c1b$var$Duplex.prototype[$ed465176c9f82c1b$var$method] = $fPP2r.prototype[$ed465176c9f82c1b$var$method];
    }
}function $ed465176c9f82c1b$var$Duplex(options) {
    if (!(this instanceof $ed465176c9f82c1b$var$Duplex)) return new $ed465176c9f82c1b$var$Duplex(options);
    $cKbyd.call(this, options);
    $fPP2r.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$ed465176c9f82c1b$var$ObjectDefineProperties($ed465176c9f82c1b$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $ed465176c9f82c1b$var$ObjectGetOwnPropertyDescriptor($fPP2r.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $ed465176c9f82c1b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ed465176c9f82c1b$var$lazyWebStreams() {
    if ($ed465176c9f82c1b$var$webStreamsAdapters === undefined) $ed465176c9f82c1b$var$webStreamsAdapters = {};
    return $ed465176c9f82c1b$var$webStreamsAdapters;
}
$ed465176c9f82c1b$var$Duplex.fromWeb = function(pair, options) {
    return $ed465176c9f82c1b$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$ed465176c9f82c1b$var$Duplex.toWeb = function(duplex) {
    return $ed465176c9f82c1b$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $ed465176c9f82c1b$var$duplexify;

$ed465176c9f82c1b$var$Duplex.from = function(body) {
    if (!$ed465176c9f82c1b$var$duplexify) $ed465176c9f82c1b$var$duplexify = (parcelRequire("aeAk3"));
    return $ed465176c9f82c1b$var$duplexify(body, 'body');
};

});
parcelRegister("cKbyd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kl2GN = parcelRequire("kl2GN");
/* replacement end */ var $9472bdacecd55175$var$ArrayPrototypeIndexOf = $kl2GN.ArrayPrototypeIndexOf, $9472bdacecd55175$var$NumberIsInteger = $kl2GN.NumberIsInteger, $9472bdacecd55175$var$NumberIsNaN = $kl2GN.NumberIsNaN, $9472bdacecd55175$var$NumberParseInt = $kl2GN.NumberParseInt, $9472bdacecd55175$var$ObjectDefineProperties = $kl2GN.ObjectDefineProperties, $9472bdacecd55175$var$ObjectKeys = $kl2GN.ObjectKeys, $9472bdacecd55175$var$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf, $9472bdacecd55175$var$Promise = $kl2GN.Promise, $9472bdacecd55175$var$SafeSet = $kl2GN.SafeSet, $9472bdacecd55175$var$SymbolAsyncDispose = $kl2GN.SymbolAsyncDispose, $9472bdacecd55175$var$SymbolAsyncIterator = $kl2GN.SymbolAsyncIterator, $9472bdacecd55175$var$Symbol = $kl2GN.Symbol;
module.exports = $9472bdacecd55175$var$Readable;
$9472bdacecd55175$var$Readable.ReadableState = $9472bdacecd55175$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $9472bdacecd55175$var$EE = $bBoAO.EventEmitter;

var $5wiDi = parcelRequire("5wiDi");
var $9472bdacecd55175$var$Stream = $5wiDi.Stream, $9472bdacecd55175$var$prependListener = $5wiDi.prependListener;

var $4Ltnq = parcelRequire("4Ltnq");
var $9472bdacecd55175$require$Buffer = $4Ltnq.Buffer;

var $amsso = parcelRequire("amsso");
var $9472bdacecd55175$require$addAbortSignal = $amsso.addAbortSignal;

var $77kNw = parcelRequire("77kNw");

var $9472bdacecd55175$var$debug = (parcelRequire("aKXXL")).debuglog('stream', function(fn) {
    $9472bdacecd55175$var$debug = fn;
});

var $lcvU7 = parcelRequire("lcvU7");

var $5hUD5 = parcelRequire("5hUD5");

var $jZuHC = parcelRequire("jZuHC");
var $9472bdacecd55175$var$getHighWaterMark = $jZuHC.getHighWaterMark, $9472bdacecd55175$var$getDefaultHighWaterMark = $jZuHC.getDefaultHighWaterMark;

var $aL8gC = parcelRequire("aL8gC");
var $9472bdacecd55175$var$aggregateTwoErrors = $aL8gC.aggregateTwoErrors, $9472bdacecd55175$var$_require_codes = $aL8gC.codes, $9472bdacecd55175$var$ERR_INVALID_ARG_TYPE = $9472bdacecd55175$var$_require_codes.ERR_INVALID_ARG_TYPE, $9472bdacecd55175$var$ERR_METHOD_NOT_IMPLEMENTED = $9472bdacecd55175$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $9472bdacecd55175$var$ERR_OUT_OF_RANGE = $9472bdacecd55175$var$_require_codes.ERR_OUT_OF_RANGE, $9472bdacecd55175$var$ERR_STREAM_PUSH_AFTER_EOF = $9472bdacecd55175$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $9472bdacecd55175$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9472bdacecd55175$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $9472bdacecd55175$var$AbortError = $aL8gC.AbortError;

var $2V9xu = parcelRequire("2V9xu");
var $9472bdacecd55175$require$validateObject = $2V9xu.validateObject;
var $9472bdacecd55175$var$kPaused = $9472bdacecd55175$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $9472bdacecd55175$require$StringDecoder = $3Jf7C.StringDecoder;

var $7yLaJ = parcelRequire("7yLaJ");
$9472bdacecd55175$var$ObjectSetPrototypeOf($9472bdacecd55175$var$Readable.prototype, $9472bdacecd55175$var$Stream.prototype);
$9472bdacecd55175$var$ObjectSetPrototypeOf($9472bdacecd55175$var$Readable, $9472bdacecd55175$var$Stream);
var $9472bdacecd55175$var$nop = function() {};
var $9472bdacecd55175$var$errorOrDestroy = $5hUD5.errorOrDestroy;
var $9472bdacecd55175$var$kObjectMode = 1;
var $9472bdacecd55175$var$kEnded = 2;
var $9472bdacecd55175$var$kEndEmitted = 4;
var $9472bdacecd55175$var$kReading = 8;
var $9472bdacecd55175$var$kConstructed = 16;
var $9472bdacecd55175$var$kSync = 32;
var $9472bdacecd55175$var$kNeedReadable = 64;
var $9472bdacecd55175$var$kEmittedReadable = 128;
var $9472bdacecd55175$var$kReadableListening = 256;
var $9472bdacecd55175$var$kResumeScheduled = 512;
var $9472bdacecd55175$var$kErrorEmitted = 1024;
var $9472bdacecd55175$var$kEmitClose = 2048;
var $9472bdacecd55175$var$kAutoDestroy = 4096;
var $9472bdacecd55175$var$kDestroyed = 8192;
var $9472bdacecd55175$var$kClosed = 16384;
var $9472bdacecd55175$var$kCloseEmitted = 32768;
var $9472bdacecd55175$var$kMultiAwaitDrain = 65536;
var $9472bdacecd55175$var$kReadingMore = 131072;
var $9472bdacecd55175$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $9472bdacecd55175$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$9472bdacecd55175$var$ObjectDefineProperties($9472bdacecd55175$var$ReadableState.prototype, {
    objectMode: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kObjectMode),
    ended: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kEnded),
    endEmitted: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kEndEmitted),
    reading: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kNeedReadable),
    emittedReadable: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kEmittedReadable),
    readableListening: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kReadableListening),
    resumeScheduled: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kErrorEmitted),
    emitClose: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kEmitClose),
    autoDestroy: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kCloseEmitted),
    multiAwaitDrain: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kReadingMore),
    dataEmitted: $9472bdacecd55175$var$makeBitMapDescriptor($9472bdacecd55175$var$kDataEmitted)
});

function $9472bdacecd55175$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kn0t3"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $9472bdacecd55175$var$kEmitClose | $9472bdacecd55175$var$kAutoDestroy | $9472bdacecd55175$var$kConstructed | $9472bdacecd55175$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $9472bdacecd55175$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $9472bdacecd55175$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $9472bdacecd55175$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $9472bdacecd55175$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $lcvU7();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$9472bdacecd55175$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$9472bdacecd55175$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$9472bdacecd55175$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $9472bdacecd55175$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9472bdacecd55175$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $9472bdacecd55175$var$Readable)) return new $9472bdacecd55175$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("kn0t3"));
    this._readableState = new $9472bdacecd55175$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $9472bdacecd55175$require$addAbortSignal(options.signal, this);
    }
    $9472bdacecd55175$var$Stream.call(this, options);
    $5hUD5.construct(this, function() {
        if (_this._readableState.needReadable) $9472bdacecd55175$var$maybeReadMore(_this, _this._readableState);
    });
}
$9472bdacecd55175$var$Readable.prototype.destroy = $5hUD5.destroy;
$9472bdacecd55175$var$Readable.prototype._undestroy = $5hUD5.undestroy;
$9472bdacecd55175$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$9472bdacecd55175$var$Readable.prototype[$9472bdacecd55175$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$9472bdacecd55175$var$Readable.prototype[$9472bdacecd55175$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $9472bdacecd55175$var$AbortError();
        this.destroy(error);
    }
    return new $9472bdacecd55175$var$Promise(function(resolve, reject) {
        return $77kNw(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9472bdacecd55175$var$Readable.prototype.push = function(chunk, encoding) {
    return $9472bdacecd55175$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$9472bdacecd55175$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $9472bdacecd55175$var$readableAddChunk(this, chunk, encoding, true);
};
function $9472bdacecd55175$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $9472bdacecd55175$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $9472bdacecd55175$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $9472bdacecd55175$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $9472bdacecd55175$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $9472bdacecd55175$require$Buffer) encoding = '';
        else if ($9472bdacecd55175$var$Stream._isUint8Array(chunk)) {
            chunk = $9472bdacecd55175$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $9472bdacecd55175$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $9472bdacecd55175$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$9472bdacecd55175$var$kReading;
        $9472bdacecd55175$var$onEofChunk(stream, state);
    } else if ((state.state & $9472bdacecd55175$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $9472bdacecd55175$var$kEndEmitted) !== 0) $9472bdacecd55175$var$errorOrDestroy(stream, new $9472bdacecd55175$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $9472bdacecd55175$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $9472bdacecd55175$var$errorOrDestroy(stream, new $9472bdacecd55175$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$9472bdacecd55175$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $9472bdacecd55175$var$addChunk(stream, state, chunk, false);
                else $9472bdacecd55175$var$maybeReadMore(stream, state);
            } else $9472bdacecd55175$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$9472bdacecd55175$var$kReading;
        $9472bdacecd55175$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9472bdacecd55175$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $9472bdacecd55175$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $9472bdacecd55175$var$kNeedReadable) !== 0) $9472bdacecd55175$var$emitReadable(stream);
    }
    $9472bdacecd55175$var$maybeReadMore(stream, state);
}
$9472bdacecd55175$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$9472bdacecd55175$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$9472bdacecd55175$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $9472bdacecd55175$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$9472bdacecd55175$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $9472bdacecd55175$var$MAX_HWM = 0x40000000;
function $9472bdacecd55175$var$computeNewHighWaterMark(n) {
    if (n > $9472bdacecd55175$var$MAX_HWM) throw new $9472bdacecd55175$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9472bdacecd55175$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $9472bdacecd55175$var$kObjectMode) !== 0) return 1;
    if ($9472bdacecd55175$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$9472bdacecd55175$var$Readable.prototype.read = function(n) {
    $9472bdacecd55175$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$9472bdacecd55175$var$NumberIsInteger(n)) n = $9472bdacecd55175$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9472bdacecd55175$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$9472bdacecd55175$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9472bdacecd55175$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9472bdacecd55175$var$endReadable(this);
        else $9472bdacecd55175$var$emitReadable(this);
        return null;
    }
    n = $9472bdacecd55175$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9472bdacecd55175$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $9472bdacecd55175$var$kNeedReadable) !== 0;
    $9472bdacecd55175$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9472bdacecd55175$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $9472bdacecd55175$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $9472bdacecd55175$var$debug('do read');
        state.state |= $9472bdacecd55175$var$kReading | $9472bdacecd55175$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $9472bdacecd55175$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $9472bdacecd55175$var$errorOrDestroy(this, err);
        }
        state.state &= ~$9472bdacecd55175$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9472bdacecd55175$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9472bdacecd55175$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9472bdacecd55175$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $9472bdacecd55175$var$onEofChunk(stream, state) {
    $9472bdacecd55175$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $9472bdacecd55175$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $9472bdacecd55175$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9472bdacecd55175$var$emitReadable(stream) {
    var state = stream._readableState;
    $9472bdacecd55175$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9472bdacecd55175$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($9472bdacecd55175$var$emitReadable_, stream);
    }
}
function $9472bdacecd55175$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9472bdacecd55175$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9472bdacecd55175$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9472bdacecd55175$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($9472bdacecd55175$var$maybeReadMore_, stream, state);
    }
}
function $9472bdacecd55175$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9472bdacecd55175$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9472bdacecd55175$var$Readable.prototype._read = function(n) {
    throw new $9472bdacecd55175$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$9472bdacecd55175$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $9472bdacecd55175$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $9472bdacecd55175$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9472bdacecd55175$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9472bdacecd55175$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $9472bdacecd55175$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $9472bdacecd55175$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $9472bdacecd55175$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $9472bdacecd55175$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $9472bdacecd55175$var$debug('ondata');
        var ret = dest.write(chunk);
        $9472bdacecd55175$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9472bdacecd55175$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $9472bdacecd55175$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $9472bdacecd55175$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9472bdacecd55175$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9472bdacecd55175$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $9472bdacecd55175$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9472bdacecd55175$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $9472bdacecd55175$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $9472bdacecd55175$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$9472bdacecd55175$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $9472bdacecd55175$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$9472bdacecd55175$var$Readable.prototype.on = function(ev, fn) {
    var res = $9472bdacecd55175$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9472bdacecd55175$var$debug('on readable', state.length, state.reading);
            if (state.length) $9472bdacecd55175$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($9472bdacecd55175$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9472bdacecd55175$var$Readable.prototype.addListener = $9472bdacecd55175$var$Readable.prototype.on;
$9472bdacecd55175$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $9472bdacecd55175$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($9472bdacecd55175$var$updateReadableListening, this);
    return res;
};
$9472bdacecd55175$var$Readable.prototype.off = $9472bdacecd55175$var$Readable.prototype.removeListener;
$9472bdacecd55175$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $9472bdacecd55175$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($9472bdacecd55175$var$updateReadableListening, this);
    return res;
};
function $9472bdacecd55175$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$9472bdacecd55175$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $9472bdacecd55175$var$nReadingNextTick(self) {
    $9472bdacecd55175$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9472bdacecd55175$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9472bdacecd55175$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $9472bdacecd55175$var$resume(this, state);
    }
    state[$9472bdacecd55175$var$kPaused] = false;
    return this;
};
function $9472bdacecd55175$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($9472bdacecd55175$var$resume_, stream, state);
    }
}
function $9472bdacecd55175$var$resume_(stream, state) {
    $9472bdacecd55175$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $9472bdacecd55175$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9472bdacecd55175$var$Readable.prototype.pause = function() {
    $9472bdacecd55175$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9472bdacecd55175$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$9472bdacecd55175$var$kPaused] = true;
    return this;
};
function $9472bdacecd55175$var$flow(stream) {
    var state = stream._readableState;
    $9472bdacecd55175$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9472bdacecd55175$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $9472bdacecd55175$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $9472bdacecd55175$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$9472bdacecd55175$var$Readable.prototype[$9472bdacecd55175$var$SymbolAsyncIterator] = function() {
    return $9472bdacecd55175$var$streamToAsyncIterator(this);
};
$9472bdacecd55175$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $9472bdacecd55175$require$validateObject(options, 'options');
    return $9472bdacecd55175$var$streamToAsyncIterator(this, options);
};
function $9472bdacecd55175$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $9472bdacecd55175$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $9472bdacecd55175$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $9472bdacecd55175$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $9472bdacecd55175$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $9472bdacecd55175$var$nop;
                    stream.on('readable', next);
                    cleanup = $77kNw(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $9472bdacecd55175$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $9472bdacecd55175$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $9472bdacecd55175$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $9472bdacecd55175$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $5hUD5.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$9472bdacecd55175$var$ObjectDefineProperties($9472bdacecd55175$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$9472bdacecd55175$var$ObjectDefineProperties($9472bdacecd55175$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$9472bdacecd55175$var$kPaused] !== false;
        },
        set: function(value) {
            this[$9472bdacecd55175$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$9472bdacecd55175$var$Readable._fromList = $9472bdacecd55175$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9472bdacecd55175$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9472bdacecd55175$var$endReadable(stream) {
    var state = stream._readableState;
    $9472bdacecd55175$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($9472bdacecd55175$var$endReadableNT, state, stream);
    }
}
function $9472bdacecd55175$var$endReadableNT(state, stream) {
    $9472bdacecd55175$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($9472bdacecd55175$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $9472bdacecd55175$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$9472bdacecd55175$var$Readable.from = function(iterable, opts) {
    return $7yLaJ($9472bdacecd55175$var$Readable, iterable, opts);
};
var $9472bdacecd55175$var$webStreamsAdapters;
// Lazy to avoid circular references
function $9472bdacecd55175$var$lazyWebStreams() {
    if ($9472bdacecd55175$var$webStreamsAdapters === undefined) $9472bdacecd55175$var$webStreamsAdapters = {};
    return $9472bdacecd55175$var$webStreamsAdapters;
}
$9472bdacecd55175$var$Readable.fromWeb = function(readableStream, options) {
    return $9472bdacecd55175$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$9472bdacecd55175$var$Readable.toWeb = function(streamReadable, options) {
    return $9472bdacecd55175$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$9472bdacecd55175$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $9472bdacecd55175$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $5hUD5.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("5wiDi", function(module, exports) {
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $404e64fb1c2b5c99$var$ArrayIsArray = $kl2GN.ArrayIsArray, $404e64fb1c2b5c99$var$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $404e64fb1c2b5c99$var$EE = $bBoAO.EventEmitter;
function $404e64fb1c2b5c99$var$Stream(opts) {
    $404e64fb1c2b5c99$var$EE.call(this, opts);
}
$404e64fb1c2b5c99$var$ObjectSetPrototypeOf($404e64fb1c2b5c99$var$Stream.prototype, $404e64fb1c2b5c99$var$EE.prototype);
$404e64fb1c2b5c99$var$ObjectSetPrototypeOf($404e64fb1c2b5c99$var$Stream, $404e64fb1c2b5c99$var$EE);
$404e64fb1c2b5c99$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($404e64fb1c2b5c99$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $404e64fb1c2b5c99$var$prependListener(source, 'error', onerror);
    $404e64fb1c2b5c99$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $404e64fb1c2b5c99$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($404e64fb1c2b5c99$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $404e64fb1c2b5c99$var$Stream,
    prependListener: $404e64fb1c2b5c99$var$prependListener
};

});

parcelRegister("amsso", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $78b208677323be07$export$e2db56ee53255a0; }, function (v) { return $78b208677323be07$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $78b208677323be07$export$11956e9313f43de0; }, function (v) { return $78b208677323be07$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $78b208677323be07$export$e2db56ee53255a0;
var $78b208677323be07$export$11956e9313f43de0;
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $78b208677323be07$require$SymbolDispose = $kl2GN.SymbolDispose;

var $aL8gC = parcelRequire("aL8gC");
var $78b208677323be07$var$AbortError = $aL8gC.AbortError, $78b208677323be07$var$codes = $aL8gC.codes;

var $bqRki = parcelRequire("bqRki");
var $78b208677323be07$var$isNodeStream = $bqRki.isNodeStream, $78b208677323be07$var$isWebStream = $bqRki.isWebStream, $78b208677323be07$var$kControllerErrorFunction = $bqRki.kControllerErrorFunction;

var $77kNw = parcelRequire("77kNw");
var $78b208677323be07$var$ERR_INVALID_ARG_TYPE = $78b208677323be07$var$codes.ERR_INVALID_ARG_TYPE;
var $78b208677323be07$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $78b208677323be07$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $78b208677323be07$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$78b208677323be07$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $78b208677323be07$var$validateAbortSignal(signal, 'signal');
    if (!$78b208677323be07$var$isNodeStream(stream) && !$78b208677323be07$var$isWebStream(stream)) throw new $78b208677323be07$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $78b208677323be07$export$11956e9313f43de0(signal, stream);
};

$78b208677323be07$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $78b208677323be07$var$isNodeStream(stream) ? function() {
        stream.destroy(new $78b208677323be07$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$78b208677323be07$var$kControllerErrorFunction](new $78b208677323be07$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $78b208677323be07$var$addAbortListener = $78b208677323be07$var$addAbortListener || (parcelRequire("aKXXL")).addAbortListener;
        var disposable = $78b208677323be07$var$addAbortListener(signal, onAbort);
        $77kNw(stream, disposable[$78b208677323be07$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("lcvU7", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $f6f37771ce0057fe$var$StringPrototypeSlice = $kl2GN.StringPrototypeSlice, $f6f37771ce0057fe$var$SymbolIterator = $kl2GN.SymbolIterator, $f6f37771ce0057fe$var$TypedArrayPrototypeSet = $kl2GN.TypedArrayPrototypeSet, $f6f37771ce0057fe$var$Uint8Array = $kl2GN.Uint8Array;

var $4Ltnq = parcelRequire("4Ltnq");
var $f6f37771ce0057fe$require$Buffer = $4Ltnq.Buffer;

var $aKXXL = parcelRequire("aKXXL");
var $f6f37771ce0057fe$require$inspect = $aKXXL.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f6f37771ce0057fe$require$Buffer.alloc(0);
                var ret = $f6f37771ce0057fe$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f6f37771ce0057fe$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $f6f37771ce0057fe$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $f6f37771ce0057fe$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $f6f37771ce0057fe$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f6f37771ce0057fe$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $f6f37771ce0057fe$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $f6f37771ce0057fe$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $f6f37771ce0057fe$var$TypedArrayPrototypeSet(ret, new $f6f37771ce0057fe$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $f6f37771ce0057fe$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("jZuHC", function(module, exports) {
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $e8db87b57c5856f1$var$MathFloor = $kl2GN.MathFloor, $e8db87b57c5856f1$var$NumberIsInteger = $kl2GN.NumberIsInteger;

var $2V9xu = parcelRequire("2V9xu");
var $e8db87b57c5856f1$require$validateInteger = $2V9xu.validateInteger;

var $e8db87b57c5856f1$var$ERR_INVALID_ARG_VALUE = (parcelRequire("aL8gC")).codes.ERR_INVALID_ARG_VALUE;
var $e8db87b57c5856f1$var$defaultHighWaterMarkBytes = 16384;
var $e8db87b57c5856f1$var$defaultHighWaterMarkObjectMode = 16;
function $e8db87b57c5856f1$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $e8db87b57c5856f1$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $e8db87b57c5856f1$var$defaultHighWaterMarkObjectMode : $e8db87b57c5856f1$var$defaultHighWaterMarkBytes;
}
function $e8db87b57c5856f1$var$setDefaultHighWaterMark(objectMode, value) {
    $e8db87b57c5856f1$require$validateInteger(value, 'value', 0);
    if (objectMode) $e8db87b57c5856f1$var$defaultHighWaterMarkObjectMode = value;
    else $e8db87b57c5856f1$var$defaultHighWaterMarkBytes = value;
}
function $e8db87b57c5856f1$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $e8db87b57c5856f1$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$e8db87b57c5856f1$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $e8db87b57c5856f1$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $e8db87b57c5856f1$var$MathFloor(hwm);
    }
    // Default value
    return $e8db87b57c5856f1$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $e8db87b57c5856f1$var$getHighWaterMark,
    getDefaultHighWaterMark: $e8db87b57c5856f1$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $e8db87b57c5856f1$var$setDefaultHighWaterMark
};

});

parcelRegister("3Jf7C", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $2b714df29c27a821$export$63a7aa211a91ed69; }, function (v) { return $2b714df29c27a821$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $2b714df29c27a821$export$63a7aa211a91ed69;
'use strict';

var $lMHt3 = parcelRequire("lMHt3");
var $2b714df29c27a821$require$Buffer = $lMHt3.Buffer;
/*</replacement>*/ var $2b714df29c27a821$var$isEncoding = $2b714df29c27a821$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $2b714df29c27a821$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $2b714df29c27a821$var$normalizeEncoding(enc) {
    var nenc = $2b714df29c27a821$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($2b714df29c27a821$require$Buffer.isEncoding === $2b714df29c27a821$var$isEncoding || !$2b714df29c27a821$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$2b714df29c27a821$export$63a7aa211a91ed69 = $2b714df29c27a821$var$StringDecoder;
function $2b714df29c27a821$var$StringDecoder(encoding) {
    this.encoding = $2b714df29c27a821$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $2b714df29c27a821$var$utf16Text;
            this.end = $2b714df29c27a821$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $2b714df29c27a821$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $2b714df29c27a821$var$base64Text;
            this.end = $2b714df29c27a821$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $2b714df29c27a821$var$simpleWrite;
            this.end = $2b714df29c27a821$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $2b714df29c27a821$require$Buffer.allocUnsafe(nb);
}
$2b714df29c27a821$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$2b714df29c27a821$var$StringDecoder.prototype.end = $2b714df29c27a821$var$utf8End;
// Returns only complete characters in a Buffer
$2b714df29c27a821$var$StringDecoder.prototype.text = $2b714df29c27a821$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$2b714df29c27a821$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $2b714df29c27a821$var$utf8CheckByte(_byte) {
    if (_byte <= 0x7F) return 0;
    else if (_byte >> 5 === 0x06) return 2;
    else if (_byte >> 4 === 0x0E) return 3;
    else if (_byte >> 3 === 0x1E) return 4;
    return _byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $2b714df29c27a821$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $2b714df29c27a821$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2b714df29c27a821$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2b714df29c27a821$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $2b714df29c27a821$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $2b714df29c27a821$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $2b714df29c27a821$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $2b714df29c27a821$var$utf8Text(buf, i) {
    var total = $2b714df29c27a821$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $2b714df29c27a821$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $2b714df29c27a821$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $2b714df29c27a821$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $2b714df29c27a821$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $2b714df29c27a821$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $2b714df29c27a821$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $2b714df29c27a821$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("lMHt3", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $jbNCJ = parcelRequire("jbNCJ");
var $fdbfcc70393e3ae1$var$Buffer = $jbNCJ.Buffer;
// alternative to using Object.keys for old browsers
function $fdbfcc70393e3ae1$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($fdbfcc70393e3ae1$var$Buffer.from && $fdbfcc70393e3ae1$var$Buffer.alloc && $fdbfcc70393e3ae1$var$Buffer.allocUnsafe && $fdbfcc70393e3ae1$var$Buffer.allocUnsafeSlow) module.exports = $jbNCJ;
else {
    // Copy properties from require('buffer')
    $fdbfcc70393e3ae1$var$copyProps($jbNCJ, module.exports);
    module.exports.Buffer = $fdbfcc70393e3ae1$var$SafeBuffer;
}
function $fdbfcc70393e3ae1$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $fdbfcc70393e3ae1$var$Buffer(arg, encodingOrOffset, length);
}
$fdbfcc70393e3ae1$var$SafeBuffer.prototype = Object.create($fdbfcc70393e3ae1$var$Buffer.prototype);
// Copy static methods from Buffer
$fdbfcc70393e3ae1$var$copyProps($fdbfcc70393e3ae1$var$Buffer, $fdbfcc70393e3ae1$var$SafeBuffer);
$fdbfcc70393e3ae1$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $fdbfcc70393e3ae1$var$Buffer(arg, encodingOrOffset, length);
};
$fdbfcc70393e3ae1$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $fdbfcc70393e3ae1$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$fdbfcc70393e3ae1$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $fdbfcc70393e3ae1$var$Buffer(size);
};
$fdbfcc70393e3ae1$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $jbNCJ.SlowBuffer(size);
};

});


parcelRegister("7yLaJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kl2GN = parcelRequire("kl2GN");
/* replacement end */ var $58104cc312100990$var$PromisePrototypeThen = $kl2GN.PromisePrototypeThen, $58104cc312100990$var$SymbolAsyncIterator = $kl2GN.SymbolAsyncIterator, $58104cc312100990$var$SymbolIterator = $kl2GN.SymbolIterator;

var $4Ltnq = parcelRequire("4Ltnq");
var $58104cc312100990$require$Buffer = $4Ltnq.Buffer;

var $aL8gC = parcelRequire("aL8gC");
var $58104cc312100990$require$_require_codes = $aL8gC.codes;
var $58104cc312100990$var$ERR_INVALID_ARG_TYPE = $58104cc312100990$require$_require_codes.ERR_INVALID_ARG_TYPE, $58104cc312100990$var$ERR_STREAM_NULL_VALUES = $58104cc312100990$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $58104cc312100990$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $58104cc312100990$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$58104cc312100990$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$58104cc312100990$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$58104cc312100990$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$58104cc312100990$var$SymbolIterator]();
    } else throw new $58104cc312100990$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $58104cc312100990$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $58104cc312100990$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $58104cc312100990$var$from;

});


parcelRegister("fPP2r", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kl2GN = parcelRequire("kl2GN");
/* replacement end */ var $b873359a6c1014e0$var$ArrayPrototypeSlice = $kl2GN.ArrayPrototypeSlice, $b873359a6c1014e0$var$Error = $kl2GN.Error, $b873359a6c1014e0$var$FunctionPrototypeSymbolHasInstance = $kl2GN.FunctionPrototypeSymbolHasInstance, $b873359a6c1014e0$var$ObjectDefineProperty = $kl2GN.ObjectDefineProperty, $b873359a6c1014e0$var$ObjectDefineProperties = $kl2GN.ObjectDefineProperties, $b873359a6c1014e0$var$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf, $b873359a6c1014e0$var$StringPrototypeToLowerCase = $kl2GN.StringPrototypeToLowerCase, $b873359a6c1014e0$var$Symbol = $kl2GN.Symbol, $b873359a6c1014e0$var$SymbolHasInstance = $kl2GN.SymbolHasInstance;
module.exports = $b873359a6c1014e0$var$Writable;
$b873359a6c1014e0$var$Writable.WritableState = $b873359a6c1014e0$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $b873359a6c1014e0$var$EE = $bBoAO.EventEmitter;

var $5wiDi = parcelRequire("5wiDi");
var $b873359a6c1014e0$require$Stream = $5wiDi.Stream;

var $4Ltnq = parcelRequire("4Ltnq");
var $b873359a6c1014e0$require$Buffer = $4Ltnq.Buffer;

var $5hUD5 = parcelRequire("5hUD5");

var $amsso = parcelRequire("amsso");
var $b873359a6c1014e0$require$addAbortSignal = $amsso.addAbortSignal;

var $jZuHC = parcelRequire("jZuHC");
var $b873359a6c1014e0$var$getHighWaterMark = $jZuHC.getHighWaterMark, $b873359a6c1014e0$var$getDefaultHighWaterMark = $jZuHC.getDefaultHighWaterMark;

var $aL8gC = parcelRequire("aL8gC");
var $b873359a6c1014e0$require$_require_codes = $aL8gC.codes;
var $b873359a6c1014e0$var$ERR_INVALID_ARG_TYPE = $b873359a6c1014e0$require$_require_codes.ERR_INVALID_ARG_TYPE, $b873359a6c1014e0$var$ERR_METHOD_NOT_IMPLEMENTED = $b873359a6c1014e0$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $b873359a6c1014e0$var$ERR_MULTIPLE_CALLBACK = $b873359a6c1014e0$require$_require_codes.ERR_MULTIPLE_CALLBACK, $b873359a6c1014e0$var$ERR_STREAM_CANNOT_PIPE = $b873359a6c1014e0$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $b873359a6c1014e0$var$ERR_STREAM_DESTROYED = $b873359a6c1014e0$require$_require_codes.ERR_STREAM_DESTROYED, $b873359a6c1014e0$var$ERR_STREAM_ALREADY_FINISHED = $b873359a6c1014e0$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $b873359a6c1014e0$var$ERR_STREAM_NULL_VALUES = $b873359a6c1014e0$require$_require_codes.ERR_STREAM_NULL_VALUES, $b873359a6c1014e0$var$ERR_STREAM_WRITE_AFTER_END = $b873359a6c1014e0$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $b873359a6c1014e0$var$ERR_UNKNOWN_ENCODING = $b873359a6c1014e0$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $b873359a6c1014e0$var$errorOrDestroy = $5hUD5.errorOrDestroy;
$b873359a6c1014e0$var$ObjectSetPrototypeOf($b873359a6c1014e0$var$Writable.prototype, $b873359a6c1014e0$require$Stream.prototype);
$b873359a6c1014e0$var$ObjectSetPrototypeOf($b873359a6c1014e0$var$Writable, $b873359a6c1014e0$require$Stream);
function $b873359a6c1014e0$var$nop() {}
var $b873359a6c1014e0$var$kOnFinished = $b873359a6c1014e0$var$Symbol('kOnFinished');

function $b873359a6c1014e0$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kn0t3"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $b873359a6c1014e0$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $b873359a6c1014e0$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $b873359a6c1014e0$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $b873359a6c1014e0$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$b873359a6c1014e0$var$kOnFinished] = [];
}
function $b873359a6c1014e0$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$b873359a6c1014e0$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $b873359a6c1014e0$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$b873359a6c1014e0$var$ObjectDefineProperty($b873359a6c1014e0$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $b873359a6c1014e0$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("kn0t3"));
    if (!isDuplex && !$b873359a6c1014e0$var$FunctionPrototypeSymbolHasInstance($b873359a6c1014e0$var$Writable, this)) return new $b873359a6c1014e0$var$Writable(options);
    this._writableState = new $b873359a6c1014e0$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $b873359a6c1014e0$require$addAbortSignal(options.signal, this);
    }
    $b873359a6c1014e0$require$Stream.call(this, options);
    $5hUD5.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $b873359a6c1014e0$var$clearBuffer(_this, state);
        $b873359a6c1014e0$var$finishMaybe(_this, state);
    });
}
$b873359a6c1014e0$var$ObjectDefineProperty($b873359a6c1014e0$var$Writable, $b873359a6c1014e0$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($b873359a6c1014e0$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $b873359a6c1014e0$var$Writable) return false;
        return object && object._writableState instanceof $b873359a6c1014e0$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$b873359a6c1014e0$var$Writable.prototype.pipe = function() {
    $b873359a6c1014e0$var$errorOrDestroy(this, new $b873359a6c1014e0$var$ERR_STREAM_CANNOT_PIPE());
};
function $b873359a6c1014e0$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$b873359a6c1014e0$require$Buffer.isEncoding(encoding)) throw new $b873359a6c1014e0$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $b873359a6c1014e0$var$nop;
    }
    if (chunk === null) throw new $b873359a6c1014e0$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $b873359a6c1014e0$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $b873359a6c1014e0$require$Buffer) encoding = 'buffer';
        else if ($b873359a6c1014e0$require$Stream._isUint8Array(chunk)) {
            chunk = $b873359a6c1014e0$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $b873359a6c1014e0$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $b873359a6c1014e0$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $b873359a6c1014e0$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $b873359a6c1014e0$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $b873359a6c1014e0$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$b873359a6c1014e0$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $b873359a6c1014e0$var$_write(this, chunk, encoding, cb) === true;
};
$b873359a6c1014e0$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b873359a6c1014e0$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $b873359a6c1014e0$var$clearBuffer(this, state);
    }
};
$b873359a6c1014e0$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $b873359a6c1014e0$var$StringPrototypeToLowerCase(encoding);
    if (!$b873359a6c1014e0$require$Buffer.isEncoding(encoding)) throw new $b873359a6c1014e0$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b873359a6c1014e0$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $b873359a6c1014e0$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $b873359a6c1014e0$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b873359a6c1014e0$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b873359a6c1014e0$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $b873359a6c1014e0$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $b873359a6c1014e0$var$errorOrDestroy(stream, er);
}
function $b873359a6c1014e0$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $b873359a6c1014e0$var$errorOrDestroy(stream, new $b873359a6c1014e0$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($b873359a6c1014e0$var$onwriteError, stream, state, er, cb);
        else $b873359a6c1014e0$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $b873359a6c1014e0$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($b873359a6c1014e0$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $b873359a6c1014e0$var$afterWrite(stream, state, 1, cb);
    }
}
function $b873359a6c1014e0$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $b873359a6c1014e0$var$afterWrite(stream, state, count, cb);
}
function $b873359a6c1014e0$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $b873359a6c1014e0$var$errorBuffer(state);
    $b873359a6c1014e0$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $b873359a6c1014e0$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $b873359a6c1014e0$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$b873359a6c1014e0$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $b873359a6c1014e0$var$ERR_STREAM_DESTROYED('end'));
    }
    $b873359a6c1014e0$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $b873359a6c1014e0$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $b873359a6c1014e0$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $b873359a6c1014e0$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $b873359a6c1014e0$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $b873359a6c1014e0$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $b873359a6c1014e0$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $b873359a6c1014e0$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$b873359a6c1014e0$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $b873359a6c1014e0$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$b873359a6c1014e0$var$Writable.prototype._writev = null;
$b873359a6c1014e0$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $b873359a6c1014e0$var$_write(this, chunk, encoding);
        if (ret instanceof $b873359a6c1014e0$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $b873359a6c1014e0$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $b873359a6c1014e0$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $b873359a6c1014e0$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$b873359a6c1014e0$var$kOnFinished].push(cb);
    }
    return this;
};
function $b873359a6c1014e0$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $b873359a6c1014e0$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $b873359a6c1014e0$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $b873359a6c1014e0$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$b873359a6c1014e0$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $b873359a6c1014e0$var$errorOrDestroy(stream, err, state.sync);
        } else if ($b873359a6c1014e0$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($b873359a6c1014e0$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $b873359a6c1014e0$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $b873359a6c1014e0$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b873359a6c1014e0$var$finishMaybe(stream, state, sync) {
    if ($b873359a6c1014e0$var$needFinish(state)) {
        $b873359a6c1014e0$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($b873359a6c1014e0$var$needFinish(state)) $b873359a6c1014e0$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($b873359a6c1014e0$var$needFinish(state)) {
                state.pendingcb++;
                $b873359a6c1014e0$var$finish(stream, state);
            }
        }
    }
}
function $b873359a6c1014e0$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$b873359a6c1014e0$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$b873359a6c1014e0$var$ObjectDefineProperties($b873359a6c1014e0$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $b873359a6c1014e0$var$destroy = $5hUD5.destroy;
$b873359a6c1014e0$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$b873359a6c1014e0$var$kOnFinished].length)) $2Qkr5.nextTick($b873359a6c1014e0$var$errorBuffer, state);
    $b873359a6c1014e0$var$destroy.call(this, err, cb);
    return this;
};
$b873359a6c1014e0$var$Writable.prototype._undestroy = $5hUD5.undestroy;
$b873359a6c1014e0$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$b873359a6c1014e0$var$Writable.prototype[$b873359a6c1014e0$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $b873359a6c1014e0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b873359a6c1014e0$var$lazyWebStreams() {
    if ($b873359a6c1014e0$var$webStreamsAdapters === undefined) $b873359a6c1014e0$var$webStreamsAdapters = {};
    return $b873359a6c1014e0$var$webStreamsAdapters;
}
$b873359a6c1014e0$var$Writable.fromWeb = function(writableStream, options) {
    return $b873359a6c1014e0$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$b873359a6c1014e0$var$Writable.toWeb = function(streamWritable) {
    return $b873359a6c1014e0$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("aeAk3", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $4Ltnq = parcelRequire("4Ltnq");

var $bqRki = parcelRequire("bqRki");
var $7737630c584de7ee$var$isReadable = $bqRki.isReadable, $7737630c584de7ee$var$isWritable = $bqRki.isWritable, $7737630c584de7ee$var$isIterable = $bqRki.isIterable, $7737630c584de7ee$var$isNodeStream = $bqRki.isNodeStream, $7737630c584de7ee$var$isReadableNodeStream = $bqRki.isReadableNodeStream, $7737630c584de7ee$var$isWritableNodeStream = $bqRki.isWritableNodeStream, $7737630c584de7ee$var$isDuplexNodeStream = $bqRki.isDuplexNodeStream, $7737630c584de7ee$var$isReadableStream = $bqRki.isReadableStream, $7737630c584de7ee$var$isWritableStream = $bqRki.isWritableStream;

var $77kNw = parcelRequire("77kNw");

var $aL8gC = parcelRequire("aL8gC");
var $7737630c584de7ee$var$AbortError = $aL8gC.AbortError, $7737630c584de7ee$var$_require_codes = $aL8gC.codes, $7737630c584de7ee$var$ERR_INVALID_ARG_TYPE = $7737630c584de7ee$var$_require_codes.ERR_INVALID_ARG_TYPE, $7737630c584de7ee$var$ERR_INVALID_RETURN_VALUE = $7737630c584de7ee$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $5hUD5 = parcelRequire("5hUD5");
var $7737630c584de7ee$require$destroyer = $5hUD5.destroyer;

var $kn0t3 = parcelRequire("kn0t3");

var $cKbyd = parcelRequire("cKbyd");

var $fPP2r = parcelRequire("fPP2r");

var $aKXXL = parcelRequire("aKXXL");
var $7737630c584de7ee$require$createDeferredPromise = $aKXXL.createDeferredPromise;

var $7yLaJ = parcelRequire("7yLaJ");
var $7737630c584de7ee$var$Blob = globalThis.Blob || $4Ltnq.Blob;
var $7737630c584de7ee$var$isBlob = typeof $7737630c584de7ee$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $7737630c584de7ee$var$Blob;
} : function isBlob(b) {
    return false;
};

var $7737630c584de7ee$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $kl2GN = parcelRequire("kl2GN");
var $7737630c584de7ee$require$FunctionPrototypeCall = $kl2GN.FunctionPrototypeCall;
// This is needed for pre node 17.
var $7737630c584de7ee$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($kn0t3);
module.exports = function duplexify(body, name) {
    if ($7737630c584de7ee$var$isDuplexNodeStream(body)) return body;
    if ($7737630c584de7ee$var$isReadableNodeStream(body)) return $7737630c584de7ee$var$_duplexify({
        readable: body
    });
    if ($7737630c584de7ee$var$isWritableNodeStream(body)) return $7737630c584de7ee$var$_duplexify({
        writable: body
    });
    if ($7737630c584de7ee$var$isNodeStream(body)) return $7737630c584de7ee$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($7737630c584de7ee$var$isReadableStream(body)) return $7737630c584de7ee$var$_duplexify({
        readable: $cKbyd.fromWeb(body)
    });
    if ($7737630c584de7ee$var$isWritableStream(body)) return $7737630c584de7ee$var$_duplexify({
        writable: $fPP2r.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $7737630c584de7ee$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($7737630c584de7ee$var$isIterable(value)) return $7yLaJ($7737630c584de7ee$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $7737630c584de7ee$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $7737630c584de7ee$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $7737630c584de7ee$require$destroyer(d, err);
            });
            return d = new $7737630c584de7ee$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $7737630c584de7ee$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($7737630c584de7ee$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($7737630c584de7ee$var$isIterable(body)) return $7yLaJ($7737630c584de7ee$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($7737630c584de7ee$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $7737630c584de7ee$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $7737630c584de7ee$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $7737630c584de7ee$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $7737630c584de7ee$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $7737630c584de7ee$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $7737630c584de7ee$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $7737630c584de7ee$require$destroyer(d1, err);
        });
        return d1 = new $7737630c584de7ee$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $7737630c584de7ee$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $7737630c584de7ee$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $7737630c584de7ee$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $7737630c584de7ee$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $7737630c584de7ee$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $7737630c584de7ee$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $7737630c584de7ee$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $cKbyd.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$7737630c584de7ee$var$isReadable(r);
    var writable = !!$7737630c584de7ee$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $7737630c584de7ee$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $77kNw(w, function(err) {
            writable = false;
            if (err) $7737630c584de7ee$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $77kNw(r, function(err) {
            readable = false;
            if (err) $7737630c584de7ee$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $7737630c584de7ee$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $7737630c584de7ee$require$destroyer(w, err);
            $7737630c584de7ee$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("lVYXD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $ff7e3565815f10ce$require$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf;
module.exports = $ff7e3565815f10ce$var$PassThrough;

var $jASIF = parcelRequire("jASIF");
$ff7e3565815f10ce$require$ObjectSetPrototypeOf($ff7e3565815f10ce$var$PassThrough.prototype, $jASIF.prototype);
$ff7e3565815f10ce$require$ObjectSetPrototypeOf($ff7e3565815f10ce$var$PassThrough, $jASIF);
function $ff7e3565815f10ce$var$PassThrough(options) {
    if (!(this instanceof $ff7e3565815f10ce$var$PassThrough)) return new $ff7e3565815f10ce$var$PassThrough(options);
    $jASIF.call(this, options);
}
$ff7e3565815f10ce$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("jASIF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $e43bd343b6ba7ae3$var$ObjectSetPrototypeOf = $kl2GN.ObjectSetPrototypeOf, $e43bd343b6ba7ae3$var$Symbol = $kl2GN.Symbol;
module.exports = $e43bd343b6ba7ae3$var$Transform;

var $e43bd343b6ba7ae3$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("aL8gC")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $kn0t3 = parcelRequire("kn0t3");

var $jZuHC = parcelRequire("jZuHC");
var $e43bd343b6ba7ae3$require$getHighWaterMark = $jZuHC.getHighWaterMark;
$e43bd343b6ba7ae3$var$ObjectSetPrototypeOf($e43bd343b6ba7ae3$var$Transform.prototype, $kn0t3.prototype);
$e43bd343b6ba7ae3$var$ObjectSetPrototypeOf($e43bd343b6ba7ae3$var$Transform, $kn0t3);
var $e43bd343b6ba7ae3$var$kCallback = $e43bd343b6ba7ae3$var$Symbol('kCallback');
function $e43bd343b6ba7ae3$var$Transform(options) {
    if (!(this instanceof $e43bd343b6ba7ae3$var$Transform)) return new $e43bd343b6ba7ae3$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $e43bd343b6ba7ae3$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $kn0t3.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$e43bd343b6ba7ae3$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $e43bd343b6ba7ae3$var$prefinish);
}
function $e43bd343b6ba7ae3$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $e43bd343b6ba7ae3$var$prefinish() {
    if (this._final !== $e43bd343b6ba7ae3$var$_final) $e43bd343b6ba7ae3$var$_final.call(this);
}
$e43bd343b6ba7ae3$var$Transform.prototype._final = $e43bd343b6ba7ae3$var$_final;
$e43bd343b6ba7ae3$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $e43bd343b6ba7ae3$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$e43bd343b6ba7ae3$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$e43bd343b6ba7ae3$var$kCallback] = callback;
    });
};
$e43bd343b6ba7ae3$var$Transform.prototype._read = function() {
    if (this[$e43bd343b6ba7ae3$var$kCallback]) {
        var callback = this[$e43bd343b6ba7ae3$var$kCallback];
        this[$e43bd343b6ba7ae3$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("e2rzw", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kl2GN = parcelRequire("kl2GN");
var $a386a3cb673d64e0$var$ArrayPrototypePop = $kl2GN.ArrayPrototypePop, $a386a3cb673d64e0$var$Promise = $kl2GN.Promise;

var $bqRki = parcelRequire("bqRki");
var $a386a3cb673d64e0$var$isIterable = $bqRki.isIterable, $a386a3cb673d64e0$var$isNodeStream = $bqRki.isNodeStream, $a386a3cb673d64e0$var$isWebStream = $bqRki.isWebStream;

var $1mjtZ = parcelRequire("1mjtZ");
var $a386a3cb673d64e0$var$pl = $1mjtZ.pipelineImpl;

var $77kNw = parcelRequire("77kNw");
var $a386a3cb673d64e0$require$finished = $77kNw.finished;
parcelRequire("78oVG");
function $a386a3cb673d64e0$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $a386a3cb673d64e0$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$a386a3cb673d64e0$var$isNodeStream(lastArg) && !$a386a3cb673d64e0$var$isIterable(lastArg) && !$a386a3cb673d64e0$var$isWebStream(lastArg)) {
            var options = $a386a3cb673d64e0$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $a386a3cb673d64e0$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $a386a3cb673d64e0$require$finished,
    pipeline: $a386a3cb673d64e0$var$pipeline
};

});





parcelRegister("bPDNl", function(module, exports) {
"use strict";
var $89d3538a171dd460$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89d3538a171dd460$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $89d3538a171dd460$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$89d3538a171dd460$var$__exportStar((parcelRequire("sceJc")), module.exports);

});
parcelRegister("sceJc", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSimple = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");

var $4f6bq = parcelRequire("4f6bq");
/**
 * A comunica Simple Sparql Serialize Actor.
 */ var $054c1b9030d4f10b$var$ActorQueryResultSerializeSimple = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeSimple, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeSimple(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeSimple);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeSimple, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeSimple, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'quads',
                            'boolean',
                            'void'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams, quad streams, booleans, or updates.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        data = new $4f6bq.Readable();
                        if (action.type === 'bindings') data.wrap(action.bindingsStream.map(function(bindings) {
                            return "".concat((0, $7WNf6._)(bindings).map(function(param) {
                                var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                return "?".concat(key.value, ": ").concat(ActorQueryResultSerializeSimple.termToString(value));
                            }).join('\n'), "\n\n");
                        }));
                        else if (action.type === 'quads') data.wrap(action.quadStream.map(function(quad) {
                            return "subject: ".concat(ActorQueryResultSerializeSimple.termToString(quad.subject), "\n") + "predicate: ".concat(ActorQueryResultSerializeSimple.termToString(quad.predicate), "\n") + "object: ".concat(ActorQueryResultSerializeSimple.termToString(quad.object), "\n") + "graph: ".concat(ActorQueryResultSerializeSimple.termToString(quad.graph), "\n\n");
                        }));
                        else data.wrap((0, $aafx9.wrap)(action.type === 'boolean' ? action.execute().then(function(value) {
                            return [
                                "".concat(value, "\n")
                            ];
                        }) : action.execute().then(function() {
                            return [
                                'ok\n'
                            ];
                        })));
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "termToString",
            value: function termToString(term) {
                return term.termType === 'Quad' ? (0, $gQYIc.termToString)(term) : term.value;
            }
        }
    ]);
    return ActorQueryResultSerializeSimple;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeSimple = $054c1b9030d4f10b$var$ActorQueryResultSerializeSimple;

});
parcelRegister("4f6bq", function(module, exports) {
'use strict';

var $a5eKe = parcelRequire("a5eKe");

var $kmzCv = parcelRequire("kmzCv");
var $316d5c0625b6dcbf$var$originalDestroy = $a5eKe.Readable.destroy;
module.exports = $a5eKe.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $a5eKe._uint8ArrayToBuffer;
module.exports._isUint8Array = $a5eKe._isUint8Array;
module.exports.isDisturbed = $a5eKe.isDisturbed;
module.exports.isErrored = $a5eKe.isErrored;
module.exports.isReadable = $a5eKe.isReadable;
module.exports.Readable = $a5eKe.Readable;
module.exports.Writable = $a5eKe.Writable;
module.exports.Duplex = $a5eKe.Duplex;
module.exports.Transform = $a5eKe.Transform;
module.exports.PassThrough = $a5eKe.PassThrough;
module.exports.addAbortSignal = $a5eKe.addAbortSignal;
module.exports.finished = $a5eKe.finished;
module.exports.destroy = $a5eKe.destroy;
module.exports.destroy = $316d5c0625b6dcbf$var$originalDestroy;
module.exports.pipeline = $a5eKe.pipeline;
module.exports.compose = $a5eKe.compose;
Object.defineProperty($a5eKe, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $kmzCv;
    }
});
module.exports.Stream = $a5eKe.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("a5eKe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $57t8y = parcelRequire("57t8y");
var $7575cf01128e9ada$require$Buffer = $57t8y.Buffer;

var $fEo31 = parcelRequire("fEo31");
/* replacement end */ var $7575cf01128e9ada$var$ObjectDefineProperty = $fEo31.ObjectDefineProperty, $7575cf01128e9ada$var$ObjectKeys = $fEo31.ObjectKeys, $7575cf01128e9ada$var$ReflectApply = $fEo31.ReflectApply;

var $3HJCn = parcelRequire("3HJCn");
var $7575cf01128e9ada$var$_require_promisify = $3HJCn.promisify, $7575cf01128e9ada$var$customPromisify = $7575cf01128e9ada$var$_require_promisify.custom;

var $3hwCP = parcelRequire("3hwCP");
var $7575cf01128e9ada$var$streamReturningOperators = $3hwCP.streamReturningOperators, $7575cf01128e9ada$var$promiseReturningOperators = $3hwCP.promiseReturningOperators;

var $7idPE = parcelRequire("7idPE");
var $7575cf01128e9ada$var$ERR_ILLEGAL_CONSTRUCTOR = $7idPE.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $guJik = parcelRequire("guJik");

var $b6kaZ = parcelRequire("b6kaZ");
var $7575cf01128e9ada$var$setDefaultHighWaterMark = $b6kaZ.setDefaultHighWaterMark, $7575cf01128e9ada$var$getDefaultHighWaterMark = $b6kaZ.getDefaultHighWaterMark;

var $azeRi = parcelRequire("azeRi");
var $7575cf01128e9ada$require$pipeline = $azeRi.pipeline;

var $1Gyoe = parcelRequire("1Gyoe");
var $7575cf01128e9ada$require$destroyer = $1Gyoe.destroyer;

var $l7UFF = parcelRequire("l7UFF");
var $7575cf01128e9ada$var$internalBuffer = {};

var $kmzCv = parcelRequire("kmzCv");

var $eCt0N = parcelRequire("eCt0N");

var $7575cf01128e9ada$var$Stream = module.exports = (parcelRequire("2qnO2")).Stream;
$7575cf01128e9ada$var$Stream.isDestroyed = $eCt0N.isDestroyed;
$7575cf01128e9ada$var$Stream.isDisturbed = $eCt0N.isDisturbed;
$7575cf01128e9ada$var$Stream.isErrored = $eCt0N.isErrored;
$7575cf01128e9ada$var$Stream.isReadable = $eCt0N.isReadable;
$7575cf01128e9ada$var$Stream.isWritable = $eCt0N.isWritable;

$7575cf01128e9ada$var$Stream.Readable = (parcelRequire("3WXi7"));
var $7575cf01128e9ada$var$_iteratorNormalCompletion = true, $7575cf01128e9ada$var$_didIteratorError = false, $7575cf01128e9ada$var$_iteratorError = undefined;
try {
    for(var $7575cf01128e9ada$var$_iterator = $7575cf01128e9ada$var$ObjectKeys($7575cf01128e9ada$var$streamReturningOperators)[Symbol.iterator](), $7575cf01128e9ada$var$_step; !($7575cf01128e9ada$var$_iteratorNormalCompletion = ($7575cf01128e9ada$var$_step = $7575cf01128e9ada$var$_iterator.next()).done); $7575cf01128e9ada$var$_iteratorNormalCompletion = true){
        var $7575cf01128e9ada$var$key = $7575cf01128e9ada$var$_step.value;
        var $7575cf01128e9ada$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $7575cf01128e9ada$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7575cf01128e9ada$var$Stream.Readable.from($7575cf01128e9ada$var$ReflectApply($7575cf01128e9ada$var$op, this, args));
        };
        var $7575cf01128e9ada$var$op = $7575cf01128e9ada$var$streamReturningOperators[$7575cf01128e9ada$var$key];
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$fn, 'name', {
            __proto__: null,
            value: $7575cf01128e9ada$var$op.name
        });
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$fn, 'length', {
            __proto__: null,
            value: $7575cf01128e9ada$var$op.length
        });
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$Stream.Readable.prototype, $7575cf01128e9ada$var$key, {
            __proto__: null,
            value: $7575cf01128e9ada$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7575cf01128e9ada$var$_didIteratorError = true;
    $7575cf01128e9ada$var$_iteratorError = err;
} finally{
    try {
        if (!$7575cf01128e9ada$var$_iteratorNormalCompletion && $7575cf01128e9ada$var$_iterator["return"] != null) {
            $7575cf01128e9ada$var$_iterator["return"]();
        }
    } finally{
        if ($7575cf01128e9ada$var$_didIteratorError) {
            throw $7575cf01128e9ada$var$_iteratorError;
        }
    }
}
var $7575cf01128e9ada$var$_iteratorNormalCompletion1 = true, $7575cf01128e9ada$var$_didIteratorError1 = false, $7575cf01128e9ada$var$_iteratorError1 = undefined;
try {
    for(var $7575cf01128e9ada$var$_iterator1 = $7575cf01128e9ada$var$ObjectKeys($7575cf01128e9ada$var$promiseReturningOperators)[Symbol.iterator](), $7575cf01128e9ada$var$_step1; !($7575cf01128e9ada$var$_iteratorNormalCompletion1 = ($7575cf01128e9ada$var$_step1 = $7575cf01128e9ada$var$_iterator1.next()).done); $7575cf01128e9ada$var$_iteratorNormalCompletion1 = true){
        var $7575cf01128e9ada$var$key1 = $7575cf01128e9ada$var$_step1.value;
        var $7575cf01128e9ada$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $7575cf01128e9ada$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7575cf01128e9ada$var$ReflectApply($7575cf01128e9ada$var$op1, this, args);
        };
        var $7575cf01128e9ada$var$op1 = $7575cf01128e9ada$var$promiseReturningOperators[$7575cf01128e9ada$var$key1];
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$fn1, 'name', {
            __proto__: null,
            value: $7575cf01128e9ada$var$op1.name
        });
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$fn1, 'length', {
            __proto__: null,
            value: $7575cf01128e9ada$var$op1.length
        });
        $7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$Stream.Readable.prototype, $7575cf01128e9ada$var$key1, {
            __proto__: null,
            value: $7575cf01128e9ada$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7575cf01128e9ada$var$_didIteratorError1 = true;
    $7575cf01128e9ada$var$_iteratorError1 = err;
} finally{
    try {
        if (!$7575cf01128e9ada$var$_iteratorNormalCompletion1 && $7575cf01128e9ada$var$_iterator1["return"] != null) {
            $7575cf01128e9ada$var$_iterator1["return"]();
        }
    } finally{
        if ($7575cf01128e9ada$var$_didIteratorError1) {
            throw $7575cf01128e9ada$var$_iteratorError1;
        }
    }
}

$7575cf01128e9ada$var$Stream.Writable = (parcelRequire("23Jcj"));

$7575cf01128e9ada$var$Stream.Duplex = (parcelRequire("9hmsc"));

$7575cf01128e9ada$var$Stream.Transform = (parcelRequire("blkYa"));

$7575cf01128e9ada$var$Stream.PassThrough = (parcelRequire("9bpTR"));
$7575cf01128e9ada$var$Stream.pipeline = $7575cf01128e9ada$require$pipeline;

var $iOHZz = parcelRequire("iOHZz");
var $7575cf01128e9ada$require$addAbortSignal = $iOHZz.addAbortSignal;
$7575cf01128e9ada$var$Stream.addAbortSignal = $7575cf01128e9ada$require$addAbortSignal;
$7575cf01128e9ada$var$Stream.finished = $l7UFF;
$7575cf01128e9ada$var$Stream.destroy = $7575cf01128e9ada$require$destroyer;
$7575cf01128e9ada$var$Stream.compose = $guJik;
$7575cf01128e9ada$var$Stream.setDefaultHighWaterMark = $7575cf01128e9ada$var$setDefaultHighWaterMark;
$7575cf01128e9ada$var$Stream.getDefaultHighWaterMark = $7575cf01128e9ada$var$getDefaultHighWaterMark;
$7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $kmzCv;
    }
});
$7575cf01128e9ada$var$ObjectDefineProperty($7575cf01128e9ada$require$pipeline, $7575cf01128e9ada$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $kmzCv.pipeline;
    }
});
$7575cf01128e9ada$var$ObjectDefineProperty($l7UFF, $7575cf01128e9ada$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $kmzCv.finished;
    }
});
// Backwards-compat with node 0.4.x
$7575cf01128e9ada$var$Stream.Stream = $7575cf01128e9ada$var$Stream;
$7575cf01128e9ada$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$7575cf01128e9ada$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $7575cf01128e9ada$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("57t8y", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3ba4352bd5db731c$export$a143d493d941bafc; }, function (v) { return $3ba4352bd5db731c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3ba4352bd5db731c$export$f99ded8fe4b79145; }, function (v) { return $3ba4352bd5db731c$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $3ba4352bd5db731c$export$a143d493d941bafc;
var $3ba4352bd5db731c$export$e4cf37d7f6fb9e0a;
var $3ba4352bd5db731c$export$f99ded8fe4b79145;
var $3ba4352bd5db731c$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $3ba4352bd5db731c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3ba4352bd5db731c$export$a143d493d941bafc = $3ba4352bd5db731c$var$Buffer;
$3ba4352bd5db731c$export$e4cf37d7f6fb9e0a = $3ba4352bd5db731c$var$SlowBuffer;
$3ba4352bd5db731c$export$f99ded8fe4b79145 = 50;
var $3ba4352bd5db731c$var$K_MAX_LENGTH = 0x7fffffff;
$3ba4352bd5db731c$export$599f31c3813fae4d = $3ba4352bd5db731c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3ba4352bd5db731c$var$Buffer.TYPED_ARRAY_SUPPORT = $3ba4352bd5db731c$var$typedArraySupport();
if (!$3ba4352bd5db731c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3ba4352bd5db731c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3ba4352bd5db731c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$3ba4352bd5db731c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3ba4352bd5db731c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$3ba4352bd5db731c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3ba4352bd5db731c$var$createBuffer(length) {
    if (length > $3ba4352bd5db731c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3ba4352bd5db731c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3ba4352bd5db731c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3ba4352bd5db731c$var$allocUnsafe(arg);
    }
    return $3ba4352bd5db731c$var$from(arg, encodingOrOffset, length);
}
$3ba4352bd5db731c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3ba4352bd5db731c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3ba4352bd5db731c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3ba4352bd5db731c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($3ba4352bd5db731c$var$isInstance(value, ArrayBuffer) || value && $3ba4352bd5db731c$var$isInstance(value.buffer, ArrayBuffer)) return $3ba4352bd5db731c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3ba4352bd5db731c$var$isInstance(value, SharedArrayBuffer) || value && $3ba4352bd5db731c$var$isInstance(value.buffer, SharedArrayBuffer))) return $3ba4352bd5db731c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3ba4352bd5db731c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $3ba4352bd5db731c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3ba4352bd5db731c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3ba4352bd5db731c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3ba4352bd5db731c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3ba4352bd5db731c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3ba4352bd5db731c$var$Buffer, Uint8Array);
function $3ba4352bd5db731c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3ba4352bd5db731c$var$alloc(size, fill, encoding) {
    $3ba4352bd5db731c$var$assertSize(size);
    if (size <= 0) return $3ba4352bd5db731c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3ba4352bd5db731c$var$createBuffer(size).fill(fill, encoding) : $3ba4352bd5db731c$var$createBuffer(size).fill(fill);
    return $3ba4352bd5db731c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3ba4352bd5db731c$var$Buffer.alloc = function(size, fill, encoding) {
    return $3ba4352bd5db731c$var$alloc(size, fill, encoding);
};
function $3ba4352bd5db731c$var$allocUnsafe(size) {
    $3ba4352bd5db731c$var$assertSize(size);
    return $3ba4352bd5db731c$var$createBuffer(size < 0 ? 0 : $3ba4352bd5db731c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3ba4352bd5db731c$var$Buffer.allocUnsafe = function(size) {
    return $3ba4352bd5db731c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3ba4352bd5db731c$var$Buffer.allocUnsafeSlow = function(size) {
    return $3ba4352bd5db731c$var$allocUnsafe(size);
};
function $3ba4352bd5db731c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3ba4352bd5db731c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $3ba4352bd5db731c$var$byteLength(string, encoding) | 0;
    var buf = $3ba4352bd5db731c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3ba4352bd5db731c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $3ba4352bd5db731c$var$checked(array.length) | 0;
    var buf = $3ba4352bd5db731c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3ba4352bd5db731c$var$fromArrayView(arrayView) {
    if ($3ba4352bd5db731c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $3ba4352bd5db731c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3ba4352bd5db731c$var$fromArrayLike(arrayView);
}
function $3ba4352bd5db731c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3ba4352bd5db731c$var$Buffer.prototype);
    return buf;
}
function $3ba4352bd5db731c$var$fromObject(obj) {
    if ($3ba4352bd5db731c$var$Buffer.isBuffer(obj)) {
        var len = $3ba4352bd5db731c$var$checked(obj.length) | 0;
        var buf = $3ba4352bd5db731c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3ba4352bd5db731c$var$numberIsNaN(obj.length)) return $3ba4352bd5db731c$var$createBuffer(0);
        return $3ba4352bd5db731c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3ba4352bd5db731c$var$fromArrayLike(obj.data);
}
function $3ba4352bd5db731c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3ba4352bd5db731c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3ba4352bd5db731c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3ba4352bd5db731c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3ba4352bd5db731c$var$Buffer.alloc(+length);
}
$3ba4352bd5db731c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3ba4352bd5db731c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3ba4352bd5db731c$var$Buffer.compare = function compare(a, b) {
    if ($3ba4352bd5db731c$var$isInstance(a, Uint8Array)) a = $3ba4352bd5db731c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3ba4352bd5db731c$var$isInstance(b, Uint8Array)) b = $3ba4352bd5db731c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3ba4352bd5db731c$var$Buffer.isBuffer(a) || !$3ba4352bd5db731c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3ba4352bd5db731c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3ba4352bd5db731c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3ba4352bd5db731c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $3ba4352bd5db731c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($3ba4352bd5db731c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3ba4352bd5db731c$var$Buffer.isBuffer(buf)) buf = $3ba4352bd5db731c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3ba4352bd5db731c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3ba4352bd5db731c$var$byteLength(string, encoding) {
    if ($3ba4352bd5db731c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3ba4352bd5db731c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3ba4352bd5db731c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3ba4352bd5db731c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3ba4352bd5db731c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3ba4352bd5db731c$var$Buffer.byteLength = $3ba4352bd5db731c$var$byteLength;
function $3ba4352bd5db731c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3ba4352bd5db731c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3ba4352bd5db731c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3ba4352bd5db731c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3ba4352bd5db731c$var$latin1Slice(this, start, end);
        case 'base64':
            return $3ba4352bd5db731c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3ba4352bd5db731c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3ba4352bd5db731c$var$Buffer.prototype._isBuffer = true;
function $3ba4352bd5db731c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3ba4352bd5db731c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$3ba4352bd5db731c$var$swap(this, i, i + 1);
    return this;
};
$3ba4352bd5db731c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $3ba4352bd5db731c$var$swap(this, i, i + 3);
        $3ba4352bd5db731c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3ba4352bd5db731c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $3ba4352bd5db731c$var$swap(this, i, i + 7);
        $3ba4352bd5db731c$var$swap(this, i + 1, i + 6);
        $3ba4352bd5db731c$var$swap(this, i + 2, i + 5);
        $3ba4352bd5db731c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3ba4352bd5db731c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3ba4352bd5db731c$var$utf8Slice(this, 0, length);
    return $3ba4352bd5db731c$var$slowToString.apply(this, arguments);
};
$3ba4352bd5db731c$var$Buffer.prototype.toLocaleString = $3ba4352bd5db731c$var$Buffer.prototype.toString;
$3ba4352bd5db731c$var$Buffer.prototype.equals = function equals(b) {
    if (!$3ba4352bd5db731c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3ba4352bd5db731c$var$Buffer.compare(this, b) === 0;
};
$3ba4352bd5db731c$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $3ba4352bd5db731c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3ba4352bd5db731c$var$customInspectSymbol) $3ba4352bd5db731c$var$Buffer.prototype[$3ba4352bd5db731c$var$customInspectSymbol] = $3ba4352bd5db731c$var$Buffer.prototype.inspect;
$3ba4352bd5db731c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3ba4352bd5db731c$var$isInstance(target, Uint8Array)) target = $3ba4352bd5db731c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3ba4352bd5db731c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3ba4352bd5db731c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3ba4352bd5db731c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3ba4352bd5db731c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3ba4352bd5db731c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3ba4352bd5db731c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3ba4352bd5db731c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3ba4352bd5db731c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3ba4352bd5db731c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3ba4352bd5db731c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3ba4352bd5db731c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3ba4352bd5db731c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3ba4352bd5db731c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3ba4352bd5db731c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3ba4352bd5db731c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3ba4352bd5db731c$var$utf8Write(buf, string, offset, length) {
    return $3ba4352bd5db731c$var$blitBuffer($3ba4352bd5db731c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3ba4352bd5db731c$var$asciiWrite(buf, string, offset, length) {
    return $3ba4352bd5db731c$var$blitBuffer($3ba4352bd5db731c$var$asciiToBytes(string), buf, offset, length);
}
function $3ba4352bd5db731c$var$base64Write(buf, string, offset, length) {
    return $3ba4352bd5db731c$var$blitBuffer($3ba4352bd5db731c$var$base64ToBytes(string), buf, offset, length);
}
function $3ba4352bd5db731c$var$ucs2Write(buf, string, offset, length) {
    return $3ba4352bd5db731c$var$blitBuffer($3ba4352bd5db731c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3ba4352bd5db731c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3ba4352bd5db731c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3ba4352bd5db731c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3ba4352bd5db731c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3ba4352bd5db731c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3ba4352bd5db731c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3ba4352bd5db731c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3ba4352bd5db731c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $3ba4352bd5db731c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3ba4352bd5db731c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $3ba4352bd5db731c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3ba4352bd5db731c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $3ba4352bd5db731c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3ba4352bd5db731c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3ba4352bd5db731c$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3ba4352bd5db731c$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3ba4352bd5db731c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $3ba4352bd5db731c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3ba4352bd5db731c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3ba4352bd5db731c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3ba4352bd5db731c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3ba4352bd5db731c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3ba4352bd5db731c$var$Buffer.prototype.readUintLE = $3ba4352bd5db731c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readUintBE = $3ba4352bd5db731c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readUint8 = $3ba4352bd5db731c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3ba4352bd5db731c$var$Buffer.prototype.readUint16LE = $3ba4352bd5db731c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3ba4352bd5db731c$var$Buffer.prototype.readUint16BE = $3ba4352bd5db731c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3ba4352bd5db731c$var$Buffer.prototype.readUint32LE = $3ba4352bd5db731c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3ba4352bd5db731c$var$Buffer.prototype.readUint32BE = $3ba4352bd5db731c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3ba4352bd5db731c$var$Buffer.prototype.readBigUInt64LE = $3ba4352bd5db731c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3ba4352bd5db731c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $3ba4352bd5db731c$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3ba4352bd5db731c$var$Buffer.prototype.readBigUInt64BE = $3ba4352bd5db731c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3ba4352bd5db731c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $3ba4352bd5db731c$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3ba4352bd5db731c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3ba4352bd5db731c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3ba4352bd5db731c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3ba4352bd5db731c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3ba4352bd5db731c$var$Buffer.prototype.readBigInt64LE = $3ba4352bd5db731c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3ba4352bd5db731c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $3ba4352bd5db731c$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$3ba4352bd5db731c$var$Buffer.prototype.readBigInt64BE = $3ba4352bd5db731c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3ba4352bd5db731c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $3ba4352bd5db731c$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$3ba4352bd5db731c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$3ba4352bd5db731c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$3ba4352bd5db731c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$3ba4352bd5db731c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $3ba4352bd5db731c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3ba4352bd5db731c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3ba4352bd5db731c$var$Buffer.prototype.writeUintLE = $3ba4352bd5db731c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3ba4352bd5db731c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUintBE = $3ba4352bd5db731c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3ba4352bd5db731c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUint8 = $3ba4352bd5db731c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUint16LE = $3ba4352bd5db731c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUint16BE = $3ba4352bd5db731c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUint32LE = $3ba4352bd5db731c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeUint32BE = $3ba4352bd5db731c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3ba4352bd5db731c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3ba4352bd5db731c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3ba4352bd5db731c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3ba4352bd5db731c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3ba4352bd5db731c$var$Buffer.prototype.writeBigUInt64LE = $3ba4352bd5db731c$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $3ba4352bd5db731c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3ba4352bd5db731c$var$Buffer.prototype.writeBigUInt64BE = $3ba4352bd5db731c$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $3ba4352bd5db731c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3ba4352bd5db731c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3ba4352bd5db731c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3ba4352bd5db731c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3ba4352bd5db731c$var$Buffer.prototype.writeBigInt64LE = $3ba4352bd5db731c$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $3ba4352bd5db731c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3ba4352bd5db731c$var$Buffer.prototype.writeBigInt64BE = $3ba4352bd5db731c$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $3ba4352bd5db731c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3ba4352bd5db731c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3ba4352bd5db731c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3ba4352bd5db731c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3ba4352bd5db731c$var$writeFloat(this, value, offset, true, noAssert);
};
$3ba4352bd5db731c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3ba4352bd5db731c$var$writeFloat(this, value, offset, false, noAssert);
};
function $3ba4352bd5db731c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ba4352bd5db731c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3ba4352bd5db731c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3ba4352bd5db731c$var$writeDouble(this, value, offset, true, noAssert);
};
$3ba4352bd5db731c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3ba4352bd5db731c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3ba4352bd5db731c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3ba4352bd5db731c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3ba4352bd5db731c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3ba4352bd5db731c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $3ba4352bd5db731c$var$Buffer.isBuffer(val) ? val : $3ba4352bd5db731c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $3ba4352bd5db731c$var$errors = {};
function $3ba4352bd5db731c$var$E(sym, getMessage, Base) {
    $3ba4352bd5db731c$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$3ba4352bd5db731c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3ba4352bd5db731c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$3ba4352bd5db731c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $3ba4352bd5db731c$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $3ba4352bd5db731c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $3ba4352bd5db731c$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $3ba4352bd5db731c$var$checkBounds(buf, offset, byteLength) {
    $3ba4352bd5db731c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3ba4352bd5db731c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3ba4352bd5db731c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $3ba4352bd5db731c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3ba4352bd5db731c$var$checkBounds(buf, offset, byteLength);
}
function $3ba4352bd5db731c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3ba4352bd5db731c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3ba4352bd5db731c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3ba4352bd5db731c$var$validateNumber(value, type);
        throw new $3ba4352bd5db731c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3ba4352bd5db731c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3ba4352bd5db731c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $3ba4352bd5db731c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3ba4352bd5db731c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3ba4352bd5db731c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3ba4352bd5db731c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3ba4352bd5db731c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3ba4352bd5db731c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3ba4352bd5db731c$var$base64ToBytes(str) {
    return $abUaD.toByteArray($3ba4352bd5db731c$var$base64clean(str));
}
function $3ba4352bd5db731c$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3ba4352bd5db731c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3ba4352bd5db731c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $3ba4352bd5db731c$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3ba4352bd5db731c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3ba4352bd5db731c$var$BufferBigIntNotDefined : fn;
}
function $3ba4352bd5db731c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("fEo31", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $b64d3ecd9689a760$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $b64d3ecd9689a760$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("3HJCn", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $57t8y = parcelRequire("57t8y");

var $3XHPb = parcelRequire("3XHPb");
var $2b28c60b2004ae44$var$format = $3XHPb.format, $2b28c60b2004ae44$var$inspect = $3XHPb.inspect;

var $7idPE = parcelRequire("7idPE");
var $2b28c60b2004ae44$var$ERR_INVALID_ARG_TYPE = $7idPE.codes.ERR_INVALID_ARG_TYPE;

var $fEo31 = parcelRequire("fEo31");
var $2b28c60b2004ae44$var$kResistStopPropagation = $fEo31.kResistStopPropagation, $2b28c60b2004ae44$var$AggregateError = $fEo31.AggregateError, $2b28c60b2004ae44$var$SymbolDispose = $fEo31.SymbolDispose;

var $2b28c60b2004ae44$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $2b28c60b2004ae44$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $2b28c60b2004ae44$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $2b28c60b2004ae44$var$Blob = globalThis.Blob || $57t8y.Blob;
/* eslint-disable indent */ var $2b28c60b2004ae44$var$isBlob = typeof $2b28c60b2004ae44$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $2b28c60b2004ae44$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $2b28c60b2004ae44$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $2b28c60b2004ae44$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $2b28c60b2004ae44$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $2b28c60b2004ae44$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $2b28c60b2004ae44$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $2b28c60b2004ae44$var$format,
    inspect: $2b28c60b2004ae44$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $2b28c60b2004ae44$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $2b28c60b2004ae44$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $2b28c60b2004ae44$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $2b28c60b2004ae44$var$validateAbortSignal(signal, 'signal');
        $2b28c60b2004ae44$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $2b28c60b2004ae44$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $2b28c60b2004ae44$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $2b28c60b2004ae44$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $2b28c60b2004ae44$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $2b28c60b2004ae44$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("3XHPb", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("7idPE", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $3XHPb = parcelRequire("3XHPb");
var $54f4f19b1f8a324a$var$format = $3XHPb.format, $54f4f19b1f8a324a$var$inspect = $3XHPb.inspect;

var $fEo31 = parcelRequire("fEo31");
var $54f4f19b1f8a324a$var$CustomAggregateError = $fEo31.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $54f4f19b1f8a324a$var$AggregateError = globalThis.AggregateError || $54f4f19b1f8a324a$var$CustomAggregateError;
var $54f4f19b1f8a324a$var$kIsNodeError = Symbol('kIsNodeError');
var $54f4f19b1f8a324a$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $54f4f19b1f8a324a$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $54f4f19b1f8a324a$var$nodeInternalPrefix = '__node_internal_';
var $54f4f19b1f8a324a$var$codes = {};
function $54f4f19b1f8a324a$var$assert(value, message) {
    if (!value) throw new $54f4f19b1f8a324a$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $54f4f19b1f8a324a$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $54f4f19b1f8a324a$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $54f4f19b1f8a324a$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $54f4f19b1f8a324a$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $54f4f19b1f8a324a$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $54f4f19b1f8a324a$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $54f4f19b1f8a324a$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$54f4f19b1f8a324a$var$kIsNodeError] = true;
    $54f4f19b1f8a324a$var$codes[code] = NodeError;
}
function $54f4f19b1f8a324a$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $54f4f19b1f8a324a$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $54f4f19b1f8a324a$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $54f4f19b1f8a324a$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $54f4f19b1f8a324a$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $54f4f19b1f8a324a$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$54f4f19b1f8a324a$var$E('ERR_ASSERTION', '%s', Error);
$54f4f19b1f8a324a$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $54f4f19b1f8a324a$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $54f4f19b1f8a324a$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($54f4f19b1f8a324a$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($54f4f19b1f8a324a$var$classRegExp.test(value)) instances.push(value);
            else {
                $54f4f19b1f8a324a$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $54f4f19b1f8a324a$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $54f4f19b1f8a324a$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$54f4f19b1f8a324a$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $54f4f19b1f8a324a$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$54f4f19b1f8a324a$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$54f4f19b1f8a324a$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $54f4f19b1f8a324a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$54f4f19b1f8a324a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $54f4f19b1f8a324a$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $54f4f19b1f8a324a$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $54f4f19b1f8a324a$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $54f4f19b1f8a324a$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$54f4f19b1f8a324a$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$54f4f19b1f8a324a$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$54f4f19b1f8a324a$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$54f4f19b1f8a324a$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$54f4f19b1f8a324a$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $54f4f19b1f8a324a$var$AbortError,
    aggregateTwoErrors: $54f4f19b1f8a324a$var$hideStackFrames($54f4f19b1f8a324a$var$aggregateTwoErrors),
    hideStackFrames: $54f4f19b1f8a324a$var$hideStackFrames,
    codes: $54f4f19b1f8a324a$var$codes
};

});


parcelRegister("3hwCP", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $263c444d4f98673b$export$42af8c323be37587; }, function (v) { return $263c444d4f98673b$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $263c444d4f98673b$export$f405f72c701dad87; }, function (v) { return $263c444d4f98673b$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $263c444d4f98673b$export$42af8c323be37587;
var $263c444d4f98673b$export$f405f72c701dad87;
'use strict';

var $263c444d4f98673b$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $7idPE = parcelRequire("7idPE");
var $263c444d4f98673b$var$_require_codes = $7idPE.codes, $263c444d4f98673b$var$ERR_INVALID_ARG_VALUE = $263c444d4f98673b$var$_require_codes.ERR_INVALID_ARG_VALUE, $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE = $263c444d4f98673b$var$_require_codes.ERR_INVALID_ARG_TYPE, $263c444d4f98673b$var$ERR_MISSING_ARGS = $263c444d4f98673b$var$_require_codes.ERR_MISSING_ARGS, $263c444d4f98673b$var$ERR_OUT_OF_RANGE = $263c444d4f98673b$var$_require_codes.ERR_OUT_OF_RANGE, $263c444d4f98673b$var$AbortError = $7idPE.AbortError;

var $3OsBa = parcelRequire("3OsBa");
var $263c444d4f98673b$var$validateAbortSignal = $3OsBa.validateAbortSignal, $263c444d4f98673b$var$validateInteger = $3OsBa.validateInteger, $263c444d4f98673b$var$validateObject = $3OsBa.validateObject;

var $263c444d4f98673b$var$kWeakHandler = (parcelRequire("fEo31")).Symbol('kWeak');

var $263c444d4f98673b$var$kResistStopPropagation = (parcelRequire("fEo31")).Symbol('kResistStopPropagation');

var $l7UFF = parcelRequire("l7UFF");
var $263c444d4f98673b$require$finished = $l7UFF.finished;

var $guJik = parcelRequire("guJik");

var $iOHZz = parcelRequire("iOHZz");
var $263c444d4f98673b$require$addAbortSignalNoValidate = $iOHZz.addAbortSignalNoValidate;

var $eCt0N = parcelRequire("eCt0N");
var $263c444d4f98673b$var$isWritable = $eCt0N.isWritable, $263c444d4f98673b$var$isNodeStream = $eCt0N.isNodeStream;

var $263c444d4f98673b$require$deprecate = (parcelRequire("3HJCn")).deprecate;

var $263c444d4f98673b$var$ArrayPrototypePush = (parcelRequire("fEo31")).ArrayPrototypePush, $263c444d4f98673b$var$Boolean = (parcelRequire("fEo31")).Boolean, $263c444d4f98673b$var$MathFloor = (parcelRequire("fEo31")).MathFloor, $263c444d4f98673b$var$Number = (parcelRequire("fEo31")).Number, $263c444d4f98673b$var$NumberIsNaN = (parcelRequire("fEo31")).NumberIsNaN, $263c444d4f98673b$var$Promise = (parcelRequire("fEo31")).Promise, $263c444d4f98673b$var$PromiseReject = (parcelRequire("fEo31")).PromiseReject, $263c444d4f98673b$var$PromiseResolve = (parcelRequire("fEo31")).PromiseResolve, $263c444d4f98673b$var$PromisePrototypeThen = (parcelRequire("fEo31")).PromisePrototypeThen, $263c444d4f98673b$var$Symbol = (parcelRequire("fEo31")).Symbol;
var $263c444d4f98673b$var$kEmpty = $263c444d4f98673b$var$Symbol('kEmpty');
var $263c444d4f98673b$var$kEof = $263c444d4f98673b$var$Symbol('kEof');
function $263c444d4f98673b$var$compose(stream, options) {
    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
    if ($263c444d4f98673b$var$isNodeStream(stream) && !$263c444d4f98673b$var$isWritable(stream)) throw new $263c444d4f98673b$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $guJik(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $263c444d4f98673b$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $263c444d4f98673b$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $263c444d4f98673b$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $263c444d4f98673b$var$MathFloor(options.highWaterMark);
    $263c444d4f98673b$var$validateInteger(concurrency, 'options.concurrency', 1);
    $263c444d4f98673b$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $263c444d4f98673b$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $263c444d4f98673b$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $263c444d4f98673b$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $263c444d4f98673b$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $263c444d4f98673b$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $263c444d4f98673b$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($263c444d4f98673b$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $263c444d4f98673b$var$PromiseReject(err1);
                                $263c444d4f98673b$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("3HJCn")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($263c444d4f98673b$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $263c444d4f98673b$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $263c444d4f98673b$var$AbortError();
                        if (!(val !== $263c444d4f98673b$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $263c444d4f98673b$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $263c444d4f98673b$var$asIndexedPairs(options) {
    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $263c444d4f98673b$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $263c444d4f98673b$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($263c444d4f98673b$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $263c444d4f98673b$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $263c444d4f98673b$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $263c444d4f98673b$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($263c444d4f98673b$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $263c444d4f98673b$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $263c444d4f98673b$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($263c444d4f98673b$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $263c444d4f98673b$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $263c444d4f98673b$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $263c444d4f98673b$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $263c444d4f98673b$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($263c444d4f98673b$var$ERR_MISSING_ARGS);
function $263c444d4f98673b$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $263c444d4f98673b$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $263c444d4f98673b$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $263c444d4f98673b$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $263c444d4f98673b$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $263c444d4f98673b$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $263c444d4f98673b$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $263c444d4f98673b$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $263c444d4f98673b$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $263c444d4f98673b$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $263c444d4f98673b$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $263c444d4f98673b$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $263c444d4f98673b$var$flatMap(fn, options) {
    var values = $263c444d4f98673b$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $263c444d4f98673b$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $263c444d4f98673b$var$Number(number);
    if ($263c444d4f98673b$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $263c444d4f98673b$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $263c444d4f98673b$var$drop(number, options) {
    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
    number = $263c444d4f98673b$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $263c444d4f98673b$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $263c444d4f98673b$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $263c444d4f98673b$var$take(number, options) {
    if (options != null) $263c444d4f98673b$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $263c444d4f98673b$var$validateAbortSignal(options.signal, 'options.signal');
    number = $263c444d4f98673b$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $263c444d4f98673b$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $263c444d4f98673b$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$263c444d4f98673b$export$42af8c323be37587 = {
    asIndexedPairs: $263c444d4f98673b$require$deprecate($263c444d4f98673b$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $263c444d4f98673b$var$drop,
    filter: $263c444d4f98673b$var$filter,
    flatMap: $263c444d4f98673b$var$flatMap,
    map: $263c444d4f98673b$var$map,
    take: $263c444d4f98673b$var$take,
    compose: $263c444d4f98673b$var$compose
};
$263c444d4f98673b$export$f405f72c701dad87 = {
    every: $263c444d4f98673b$var$every,
    forEach: $263c444d4f98673b$var$forEach,
    reduce: $263c444d4f98673b$var$reduce,
    toArray: $263c444d4f98673b$var$toArray,
    some: $263c444d4f98673b$var$some,
    find: $263c444d4f98673b$var$find
};

});
parcelRegister("3OsBa", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $2c6c39b15c69b63a$var$ArrayIsArray = $fEo31.ArrayIsArray, $2c6c39b15c69b63a$var$ArrayPrototypeIncludes = $fEo31.ArrayPrototypeIncludes, $2c6c39b15c69b63a$var$ArrayPrototypeJoin = $fEo31.ArrayPrototypeJoin, $2c6c39b15c69b63a$var$ArrayPrototypeMap = $fEo31.ArrayPrototypeMap, $2c6c39b15c69b63a$var$NumberIsInteger = $fEo31.NumberIsInteger, $2c6c39b15c69b63a$var$NumberIsNaN = $fEo31.NumberIsNaN, $2c6c39b15c69b63a$var$NumberMAX_SAFE_INTEGER = $fEo31.NumberMAX_SAFE_INTEGER, $2c6c39b15c69b63a$var$NumberMIN_SAFE_INTEGER = $fEo31.NumberMIN_SAFE_INTEGER, $2c6c39b15c69b63a$var$NumberParseInt = $fEo31.NumberParseInt, $2c6c39b15c69b63a$var$ObjectPrototypeHasOwnProperty = $fEo31.ObjectPrototypeHasOwnProperty, $2c6c39b15c69b63a$var$RegExpPrototypeExec = $fEo31.RegExpPrototypeExec, $2c6c39b15c69b63a$var$String = $fEo31.String, $2c6c39b15c69b63a$var$StringPrototypeToUpperCase = $fEo31.StringPrototypeToUpperCase, $2c6c39b15c69b63a$var$StringPrototypeTrim = $fEo31.StringPrototypeTrim;

var $7idPE = parcelRequire("7idPE");
var $2c6c39b15c69b63a$var$hideStackFrames = $7idPE.hideStackFrames, $2c6c39b15c69b63a$var$_require_codes = $7idPE.codes, $2c6c39b15c69b63a$var$ERR_SOCKET_BAD_PORT = $2c6c39b15c69b63a$var$_require_codes.ERR_SOCKET_BAD_PORT, $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE = $2c6c39b15c69b63a$var$_require_codes.ERR_INVALID_ARG_TYPE, $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE = $2c6c39b15c69b63a$var$_require_codes.ERR_INVALID_ARG_VALUE, $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE = $2c6c39b15c69b63a$var$_require_codes.ERR_OUT_OF_RANGE, $2c6c39b15c69b63a$var$ERR_UNKNOWN_SIGNAL = $2c6c39b15c69b63a$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $3HJCn = parcelRequire("3HJCn");
var $2c6c39b15c69b63a$require$normalizeEncoding = $3HJCn.normalizeEncoding;

var $3HJCn = parcelRequire("3HJCn");
var $2c6c39b15c69b63a$require$_require_types = $3HJCn.types;
var $2c6c39b15c69b63a$var$isAsyncFunction = $2c6c39b15c69b63a$require$_require_types.isAsyncFunction, $2c6c39b15c69b63a$var$isArrayBufferView = $2c6c39b15c69b63a$require$_require_types.isArrayBufferView;
var $2c6c39b15c69b63a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2c6c39b15c69b63a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2c6c39b15c69b63a$var$isUint32(value) {
    return value === value >>> 0;
}
var $2c6c39b15c69b63a$var$octalReg = /^[0-7]+$/;
var $2c6c39b15c69b63a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $2c6c39b15c69b63a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($2c6c39b15c69b63a$var$RegExpPrototypeExec($2c6c39b15c69b63a$var$octalReg, value) === null) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE(name, value, $2c6c39b15c69b63a$var$modeDesc);
        value = $2c6c39b15c69b63a$var$NumberParseInt(value, 8);
    }
    $2c6c39b15c69b63a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $2c6c39b15c69b63a$var$validateInteger = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2c6c39b15c69b63a$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $2c6c39b15c69b63a$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2c6c39b15c69b63a$var$NumberIsInteger(value)) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $2c6c39b15c69b63a$var$validateInt32 = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2c6c39b15c69b63a$var$NumberIsInteger(value)) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $2c6c39b15c69b63a$var$validateUint32 = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2c6c39b15c69b63a$var$NumberIsInteger(value)) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $2c6c39b15c69b63a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $2c6c39b15c69b63a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $2c6c39b15c69b63a$var$NumberIsNaN(value)) throw new $2c6c39b15c69b63a$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $2c6c39b15c69b63a$var$validateOneOf = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name, oneOf) {
    if (!$2c6c39b15c69b63a$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $2c6c39b15c69b63a$var$ArrayPrototypeJoin($2c6c39b15c69b63a$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $2c6c39b15c69b63a$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $2c6c39b15c69b63a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $2c6c39b15c69b63a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$2c6c39b15c69b63a$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $2c6c39b15c69b63a$var$validateObject = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $2c6c39b15c69b63a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $2c6c39b15c69b63a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $2c6c39b15c69b63a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $2c6c39b15c69b63a$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $2c6c39b15c69b63a$var$validateDictionary = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $2c6c39b15c69b63a$var$validateArray = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$2c6c39b15c69b63a$var$ArrayIsArray(value)) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $2c6c39b15c69b63a$var$validateStringArray(value, name) {
    $2c6c39b15c69b63a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2c6c39b15c69b63a$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $2c6c39b15c69b63a$var$validateBooleanArray(value, name) {
    $2c6c39b15c69b63a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2c6c39b15c69b63a$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $2c6c39b15c69b63a$var$validateAbortSignalArray(value, name) {
    $2c6c39b15c69b63a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $2c6c39b15c69b63a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $2c6c39b15c69b63a$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $2c6c39b15c69b63a$var$validateString(signal, name);
    if ($2c6c39b15c69b63a$var$signals[signal] === undefined) {
        if ($2c6c39b15c69b63a$var$signals[$2c6c39b15c69b63a$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $2c6c39b15c69b63a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $2c6c39b15c69b63a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $2c6c39b15c69b63a$var$validateBuffer = $2c6c39b15c69b63a$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$2c6c39b15c69b63a$var$isArrayBufferView(buffer)) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $2c6c39b15c69b63a$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $2c6c39b15c69b63a$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $2c6c39b15c69b63a$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $2c6c39b15c69b63a$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $2c6c39b15c69b63a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $2c6c39b15c69b63a$var$validateAbortSignal = $2c6c39b15c69b63a$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $2c6c39b15c69b63a$var$validateFunction = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $2c6c39b15c69b63a$var$validatePlainFunction = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $2c6c39b15c69b63a$var$isAsyncFunction(value)) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $2c6c39b15c69b63a$var$validateUndefined = $2c6c39b15c69b63a$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $2c6c39b15c69b63a$var$validateUnion(value, name, union) {
    if (!$2c6c39b15c69b63a$var$ArrayPrototypeIncludes(union, value)) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_TYPE(name, "('".concat($2c6c39b15c69b63a$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $2c6c39b15c69b63a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $2c6c39b15c69b63a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$2c6c39b15c69b63a$var$RegExpPrototypeExec($2c6c39b15c69b63a$var$linkValueRegExp, value)) throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $2c6c39b15c69b63a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $2c6c39b15c69b63a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($2c6c39b15c69b63a$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $2c6c39b15c69b63a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $2c6c39b15c69b63a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $2c6c39b15c69b63a$var$isInt32,
    isUint32: $2c6c39b15c69b63a$var$isUint32,
    parseFileMode: $2c6c39b15c69b63a$var$parseFileMode,
    validateArray: $2c6c39b15c69b63a$var$validateArray,
    validateStringArray: $2c6c39b15c69b63a$var$validateStringArray,
    validateBooleanArray: $2c6c39b15c69b63a$var$validateBooleanArray,
    validateAbortSignalArray: $2c6c39b15c69b63a$var$validateAbortSignalArray,
    validateBoolean: $2c6c39b15c69b63a$var$validateBoolean,
    validateBuffer: $2c6c39b15c69b63a$var$validateBuffer,
    validateDictionary: $2c6c39b15c69b63a$var$validateDictionary,
    validateEncoding: $2c6c39b15c69b63a$var$validateEncoding,
    validateFunction: $2c6c39b15c69b63a$var$validateFunction,
    validateInt32: $2c6c39b15c69b63a$var$validateInt32,
    validateInteger: $2c6c39b15c69b63a$var$validateInteger,
    validateNumber: $2c6c39b15c69b63a$var$validateNumber,
    validateObject: $2c6c39b15c69b63a$var$validateObject,
    validateOneOf: $2c6c39b15c69b63a$var$validateOneOf,
    validatePlainFunction: $2c6c39b15c69b63a$var$validatePlainFunction,
    validatePort: $2c6c39b15c69b63a$var$validatePort,
    validateSignalName: $2c6c39b15c69b63a$var$validateSignalName,
    validateString: $2c6c39b15c69b63a$var$validateString,
    validateUint32: $2c6c39b15c69b63a$var$validateUint32,
    validateUndefined: $2c6c39b15c69b63a$var$validateUndefined,
    validateUnion: $2c6c39b15c69b63a$var$validateUnion,
    validateAbortSignal: $2c6c39b15c69b63a$var$validateAbortSignal,
    validateLinkHeaderValue: $2c6c39b15c69b63a$var$validateLinkHeaderValue
};

});

parcelRegister("l7UFF", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $7idPE = parcelRequire("7idPE");
/* replacement end */ var $f616361fb0b160e5$var$AbortError = $7idPE.AbortError, $f616361fb0b160e5$var$codes = $7idPE.codes;
var $f616361fb0b160e5$var$ERR_INVALID_ARG_TYPE = $f616361fb0b160e5$var$codes.ERR_INVALID_ARG_TYPE, $f616361fb0b160e5$var$ERR_STREAM_PREMATURE_CLOSE = $f616361fb0b160e5$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $f616361fb0b160e5$var$kEmptyObject = (parcelRequire("3HJCn")).kEmptyObject, $f616361fb0b160e5$var$once = (parcelRequire("3HJCn")).once;

var $3OsBa = parcelRequire("3OsBa");
var $f616361fb0b160e5$var$validateAbortSignal = $3OsBa.validateAbortSignal, $f616361fb0b160e5$var$validateFunction = $3OsBa.validateFunction, $f616361fb0b160e5$var$validateObject = $3OsBa.validateObject, $f616361fb0b160e5$var$validateBoolean = $3OsBa.validateBoolean;

var $fEo31 = parcelRequire("fEo31");
var $f616361fb0b160e5$var$Promise = $fEo31.Promise, $f616361fb0b160e5$var$PromisePrototypeThen = $fEo31.PromisePrototypeThen, $f616361fb0b160e5$var$SymbolDispose = $fEo31.SymbolDispose;

var $eCt0N = parcelRequire("eCt0N");
var $f616361fb0b160e5$var$isClosed = $eCt0N.isClosed, $f616361fb0b160e5$var$isReadable = $eCt0N.isReadable, $f616361fb0b160e5$var$isReadableNodeStream = $eCt0N.isReadableNodeStream, $f616361fb0b160e5$var$isReadableStream = $eCt0N.isReadableStream, $f616361fb0b160e5$var$isReadableFinished = $eCt0N.isReadableFinished, $f616361fb0b160e5$var$isReadableErrored = $eCt0N.isReadableErrored, $f616361fb0b160e5$var$isWritable = $eCt0N.isWritable, $f616361fb0b160e5$var$isWritableNodeStream = $eCt0N.isWritableNodeStream, $f616361fb0b160e5$var$isWritableStream = $eCt0N.isWritableStream, $f616361fb0b160e5$var$isWritableFinished = $eCt0N.isWritableFinished, $f616361fb0b160e5$var$isWritableErrored = $eCt0N.isWritableErrored, $f616361fb0b160e5$var$isNodeStream = $eCt0N.isNodeStream, $f616361fb0b160e5$var$_willEmitClose = $eCt0N.willEmitClose, $f616361fb0b160e5$var$kIsClosedPromise = $eCt0N.kIsClosedPromise;
var $f616361fb0b160e5$var$addAbortListener;
function $f616361fb0b160e5$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $f616361fb0b160e5$var$nop = function() {};

function $f616361fb0b160e5$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $f616361fb0b160e5$var$kEmptyObject;
    } else if (options == null) options = $f616361fb0b160e5$var$kEmptyObject;
    else $f616361fb0b160e5$var$validateObject(options, 'options');
    $f616361fb0b160e5$var$validateFunction(callback, 'callback');
    $f616361fb0b160e5$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $f616361fb0b160e5$var$once(callback);
    if ($f616361fb0b160e5$var$isReadableStream(stream) || $f616361fb0b160e5$var$isWritableStream(stream)) return $f616361fb0b160e5$var$eosWeb(stream, options, callback);
    if (!$f616361fb0b160e5$var$isNodeStream(stream)) throw new $f616361fb0b160e5$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $f616361fb0b160e5$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $f616361fb0b160e5$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $f616361fb0b160e5$var$_willEmitClose(stream) && $f616361fb0b160e5$var$isReadableNodeStream(stream) === readable && $f616361fb0b160e5$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $f616361fb0b160e5$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $f616361fb0b160e5$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $f616361fb0b160e5$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $f616361fb0b160e5$var$isWritableErrored(stream) || $f616361fb0b160e5$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $f616361fb0b160e5$var$isReadableNodeStream(stream, true)) {
            if (!$f616361fb0b160e5$var$isReadableFinished(stream, false)) return callback.call(stream, new $f616361fb0b160e5$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$f616361fb0b160e5$var$isWritableFinished(stream, false)) return callback.call(stream, new $f616361fb0b160e5$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $f616361fb0b160e5$var$isWritableErrored(stream) || $f616361fb0b160e5$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($f616361fb0b160e5$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $f616361fb0b160e5$var$isReadable(stream)) && (writableFinished || $f616361fb0b160e5$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $f616361fb0b160e5$var$isWritable(stream)) && (readableFinished || $f616361fb0b160e5$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $f616361fb0b160e5$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $f616361fb0b160e5$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $f616361fb0b160e5$var$addAbortListener = $f616361fb0b160e5$var$addAbortListener || (parcelRequire("3HJCn")).addAbortListener;
            var disposable = $f616361fb0b160e5$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $f616361fb0b160e5$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$f616361fb0b160e5$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $f616361fb0b160e5$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $f616361fb0b160e5$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $f616361fb0b160e5$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $f616361fb0b160e5$var$addAbortListener = $f616361fb0b160e5$var$addAbortListener || (parcelRequire("3HJCn")).addAbortListener;
            var disposable = $f616361fb0b160e5$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $f616361fb0b160e5$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$f616361fb0b160e5$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $f616361fb0b160e5$var$PromisePrototypeThen(stream[$f616361fb0b160e5$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $f616361fb0b160e5$var$nop;
}
function $f616361fb0b160e5$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $f616361fb0b160e5$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $f616361fb0b160e5$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $f616361fb0b160e5$var$Promise(function(resolve, reject) {
        var cleanup = $f616361fb0b160e5$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $f616361fb0b160e5$var$eos;
module.exports.finished = $f616361fb0b160e5$var$finished;

});
parcelRegister("eCt0N", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $aa4b1e6d5a3504dc$var$SymbolAsyncIterator = $fEo31.SymbolAsyncIterator, $aa4b1e6d5a3504dc$var$SymbolIterator = $fEo31.SymbolIterator, $aa4b1e6d5a3504dc$var$SymbolFor = $fEo31.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $aa4b1e6d5a3504dc$var$kIsDestroyed = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.stream.destroyed');
var $aa4b1e6d5a3504dc$var$kIsErrored = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.stream.errored');
var $aa4b1e6d5a3504dc$var$kIsReadable = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.stream.readable');
var $aa4b1e6d5a3504dc$var$kIsWritable = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.stream.writable');
var $aa4b1e6d5a3504dc$var$kIsDisturbed = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.stream.disturbed');
var $aa4b1e6d5a3504dc$var$kIsClosedPromise = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $aa4b1e6d5a3504dc$var$kControllerErrorFunction = $aa4b1e6d5a3504dc$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $aa4b1e6d5a3504dc$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $aa4b1e6d5a3504dc$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $aa4b1e6d5a3504dc$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $aa4b1e6d5a3504dc$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $aa4b1e6d5a3504dc$var$isReadableStream(obj) {
    return !!(obj && !$aa4b1e6d5a3504dc$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $aa4b1e6d5a3504dc$var$isWritableStream(obj) {
    return !!(obj && !$aa4b1e6d5a3504dc$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $aa4b1e6d5a3504dc$var$isTransformStream(obj) {
    return !!(obj && !$aa4b1e6d5a3504dc$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $aa4b1e6d5a3504dc$var$isWebStream(obj) {
    return $aa4b1e6d5a3504dc$var$isReadableStream(obj) || $aa4b1e6d5a3504dc$var$isWritableStream(obj) || $aa4b1e6d5a3504dc$var$isTransformStream(obj);
}
function $aa4b1e6d5a3504dc$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$aa4b1e6d5a3504dc$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$aa4b1e6d5a3504dc$var$SymbolIterator] === 'function';
    return typeof obj[$aa4b1e6d5a3504dc$var$SymbolAsyncIterator] === 'function' || typeof obj[$aa4b1e6d5a3504dc$var$SymbolIterator] === 'function';
}
function $aa4b1e6d5a3504dc$var$isDestroyed(stream) {
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$aa4b1e6d5a3504dc$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $aa4b1e6d5a3504dc$var$isWritableEnded(stream) {
    if (!$aa4b1e6d5a3504dc$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $aa4b1e6d5a3504dc$var$isWritableFinished(stream, strict) {
    if (!$aa4b1e6d5a3504dc$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $aa4b1e6d5a3504dc$var$isReadableEnded(stream) {
    if (!$aa4b1e6d5a3504dc$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $aa4b1e6d5a3504dc$var$isReadableFinished(stream, strict) {
    if (!$aa4b1e6d5a3504dc$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $aa4b1e6d5a3504dc$var$isReadable(stream) {
    if (stream && stream[$aa4b1e6d5a3504dc$var$kIsReadable] != null) return stream[$aa4b1e6d5a3504dc$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($aa4b1e6d5a3504dc$var$isDestroyed(stream)) return false;
    return $aa4b1e6d5a3504dc$var$isReadableNodeStream(stream) && stream.readable && !$aa4b1e6d5a3504dc$var$isReadableFinished(stream);
}
function $aa4b1e6d5a3504dc$var$isWritable(stream) {
    if (stream && stream[$aa4b1e6d5a3504dc$var$kIsWritable] != null) return stream[$aa4b1e6d5a3504dc$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($aa4b1e6d5a3504dc$var$isDestroyed(stream)) return false;
    return $aa4b1e6d5a3504dc$var$isWritableNodeStream(stream) && stream.writable && !$aa4b1e6d5a3504dc$var$isWritableEnded(stream);
}
function $aa4b1e6d5a3504dc$var$isFinished(stream, opts) {
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    if ($aa4b1e6d5a3504dc$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $aa4b1e6d5a3504dc$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $aa4b1e6d5a3504dc$var$isWritable(stream)) return false;
    return true;
}
function $aa4b1e6d5a3504dc$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $aa4b1e6d5a3504dc$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $aa4b1e6d5a3504dc$var$isClosed(stream) {
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $aa4b1e6d5a3504dc$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $aa4b1e6d5a3504dc$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $aa4b1e6d5a3504dc$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $aa4b1e6d5a3504dc$var$isOutgoingMessage(stream);
}
function $aa4b1e6d5a3504dc$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $aa4b1e6d5a3504dc$var$willEmitClose(stream) {
    if (!$aa4b1e6d5a3504dc$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $aa4b1e6d5a3504dc$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $aa4b1e6d5a3504dc$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$aa4b1e6d5a3504dc$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $aa4b1e6d5a3504dc$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$aa4b1e6d5a3504dc$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $aa4b1e6d5a3504dc$var$isDestroyed,
    kIsDestroyed: $aa4b1e6d5a3504dc$var$kIsDestroyed,
    isDisturbed: $aa4b1e6d5a3504dc$var$isDisturbed,
    kIsDisturbed: $aa4b1e6d5a3504dc$var$kIsDisturbed,
    isErrored: $aa4b1e6d5a3504dc$var$isErrored,
    kIsErrored: $aa4b1e6d5a3504dc$var$kIsErrored,
    isReadable: $aa4b1e6d5a3504dc$var$isReadable,
    kIsReadable: $aa4b1e6d5a3504dc$var$kIsReadable,
    kIsClosedPromise: $aa4b1e6d5a3504dc$var$kIsClosedPromise,
    kControllerErrorFunction: $aa4b1e6d5a3504dc$var$kControllerErrorFunction,
    kIsWritable: $aa4b1e6d5a3504dc$var$kIsWritable,
    isClosed: $aa4b1e6d5a3504dc$var$isClosed,
    isDuplexNodeStream: $aa4b1e6d5a3504dc$var$isDuplexNodeStream,
    isFinished: $aa4b1e6d5a3504dc$var$isFinished,
    isIterable: $aa4b1e6d5a3504dc$var$isIterable,
    isReadableNodeStream: $aa4b1e6d5a3504dc$var$isReadableNodeStream,
    isReadableStream: $aa4b1e6d5a3504dc$var$isReadableStream,
    isReadableEnded: $aa4b1e6d5a3504dc$var$isReadableEnded,
    isReadableFinished: $aa4b1e6d5a3504dc$var$isReadableFinished,
    isReadableErrored: $aa4b1e6d5a3504dc$var$isReadableErrored,
    isNodeStream: $aa4b1e6d5a3504dc$var$isNodeStream,
    isWebStream: $aa4b1e6d5a3504dc$var$isWebStream,
    isWritable: $aa4b1e6d5a3504dc$var$isWritable,
    isWritableNodeStream: $aa4b1e6d5a3504dc$var$isWritableNodeStream,
    isWritableStream: $aa4b1e6d5a3504dc$var$isWritableStream,
    isWritableEnded: $aa4b1e6d5a3504dc$var$isWritableEnded,
    isWritableFinished: $aa4b1e6d5a3504dc$var$isWritableFinished,
    isWritableErrored: $aa4b1e6d5a3504dc$var$isWritableErrored,
    isServerRequest: $aa4b1e6d5a3504dc$var$isServerRequest,
    isServerResponse: $aa4b1e6d5a3504dc$var$isServerResponse,
    willEmitClose: $aa4b1e6d5a3504dc$var$willEmitClose,
    isTransformStream: $aa4b1e6d5a3504dc$var$isTransformStream
};

});


parcelRegister("guJik", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $azeRi = parcelRequire("azeRi");
var $c022953ed7760eff$require$pipeline = $azeRi.pipeline;

var $9hmsc = parcelRequire("9hmsc");

var $1Gyoe = parcelRequire("1Gyoe");
var $c022953ed7760eff$require$destroyer = $1Gyoe.destroyer;

var $eCt0N = parcelRequire("eCt0N");
var $c022953ed7760eff$var$isNodeStream = $eCt0N.isNodeStream, $c022953ed7760eff$var$isReadable = $eCt0N.isReadable, $c022953ed7760eff$var$isWritable = $eCt0N.isWritable, $c022953ed7760eff$var$isWebStream = $eCt0N.isWebStream, $c022953ed7760eff$var$isTransformStream = $eCt0N.isTransformStream, $c022953ed7760eff$var$isWritableStream = $eCt0N.isWritableStream, $c022953ed7760eff$var$isReadableStream = $eCt0N.isReadableStream;

var $7idPE = parcelRequire("7idPE");
var $c022953ed7760eff$var$AbortError = $7idPE.AbortError, $c022953ed7760eff$var$_require_codes = $7idPE.codes, $c022953ed7760eff$var$ERR_INVALID_ARG_VALUE = $c022953ed7760eff$var$_require_codes.ERR_INVALID_ARG_VALUE, $c022953ed7760eff$var$ERR_MISSING_ARGS = $c022953ed7760eff$var$_require_codes.ERR_MISSING_ARGS;

var $l7UFF = parcelRequire("l7UFF");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $c022953ed7760eff$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $9hmsc.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $9hmsc.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $9hmsc.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$c022953ed7760eff$var$isNodeStream(streams[n]) && !$c022953ed7760eff$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($c022953ed7760eff$var$isReadable(streams[n]) || $c022953ed7760eff$var$isReadableStream(streams[n]) || $c022953ed7760eff$var$isTransformStream(streams[n]))) throw new $c022953ed7760eff$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($c022953ed7760eff$var$isWritable(streams[n]) || $c022953ed7760eff$var$isWritableStream(streams[n]) || $c022953ed7760eff$var$isTransformStream(streams[n]))) throw new $c022953ed7760eff$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $c022953ed7760eff$require$pipeline(streams, onfinished);
    var writable = !!($c022953ed7760eff$var$isWritable(head) || $c022953ed7760eff$var$isWritableStream(head) || $c022953ed7760eff$var$isTransformStream(head));
    var readable = !!($c022953ed7760eff$var$isReadable(tail) || $c022953ed7760eff$var$isReadableStream(tail) || $c022953ed7760eff$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9hmsc({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($c022953ed7760eff$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($c022953ed7760eff$var$isWebStream(head)) {
            var writable1 = $c022953ed7760eff$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $c022953ed7760eff$var$isTransformStream(tail) ? tail.readable : tail;
        $l7UFF(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($c022953ed7760eff$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($c022953ed7760eff$var$isWebStream(tail)) {
            var readable1 = $c022953ed7760eff$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $c022953ed7760eff$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($c022953ed7760eff$var$isNodeStream(tail)) $c022953ed7760eff$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("azeRi", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $7b18b2e06671e16e$var$ArrayIsArray = $fEo31.ArrayIsArray, $7b18b2e06671e16e$var$Promise = $fEo31.Promise, $7b18b2e06671e16e$var$SymbolAsyncIterator = $fEo31.SymbolAsyncIterator, $7b18b2e06671e16e$var$SymbolDispose = $fEo31.SymbolDispose;

var $l7UFF = parcelRequire("l7UFF");

var $7b18b2e06671e16e$require$once = (parcelRequire("3HJCn")).once;

var $1Gyoe = parcelRequire("1Gyoe");

var $9hmsc = parcelRequire("9hmsc");

var $7idPE = parcelRequire("7idPE");
var $7b18b2e06671e16e$var$aggregateTwoErrors = $7idPE.aggregateTwoErrors, $7b18b2e06671e16e$var$_require_codes = $7idPE.codes, $7b18b2e06671e16e$var$ERR_INVALID_ARG_TYPE = $7b18b2e06671e16e$var$_require_codes.ERR_INVALID_ARG_TYPE, $7b18b2e06671e16e$var$ERR_INVALID_RETURN_VALUE = $7b18b2e06671e16e$var$_require_codes.ERR_INVALID_RETURN_VALUE, $7b18b2e06671e16e$var$ERR_MISSING_ARGS = $7b18b2e06671e16e$var$_require_codes.ERR_MISSING_ARGS, $7b18b2e06671e16e$var$ERR_STREAM_DESTROYED = $7b18b2e06671e16e$var$_require_codes.ERR_STREAM_DESTROYED, $7b18b2e06671e16e$var$ERR_STREAM_PREMATURE_CLOSE = $7b18b2e06671e16e$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $7b18b2e06671e16e$var$AbortError = $7idPE.AbortError;

var $3OsBa = parcelRequire("3OsBa");
var $7b18b2e06671e16e$var$validateFunction = $3OsBa.validateFunction, $7b18b2e06671e16e$var$validateAbortSignal = $3OsBa.validateAbortSignal;

var $eCt0N = parcelRequire("eCt0N");
var $7b18b2e06671e16e$var$isIterable = $eCt0N.isIterable, $7b18b2e06671e16e$var$isReadable = $eCt0N.isReadable, $7b18b2e06671e16e$var$isReadableNodeStream = $eCt0N.isReadableNodeStream, $7b18b2e06671e16e$var$isNodeStream = $eCt0N.isNodeStream, $7b18b2e06671e16e$var$isTransformStream = $eCt0N.isTransformStream, $7b18b2e06671e16e$var$isWebStream = $eCt0N.isWebStream, $7b18b2e06671e16e$var$isReadableStream = $eCt0N.isReadableStream, $7b18b2e06671e16e$var$isReadableFinished = $eCt0N.isReadableFinished;

var $7b18b2e06671e16e$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $7b18b2e06671e16e$var$PassThrough;
var $7b18b2e06671e16e$var$Readable;
var $7b18b2e06671e16e$var$addAbortListener;
function $7b18b2e06671e16e$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $l7UFF(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $1Gyoe.destroyer(stream, err || new $7b18b2e06671e16e$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $7b18b2e06671e16e$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $7b18b2e06671e16e$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $7b18b2e06671e16e$var$makeAsyncIterable(val) {
    if ($7b18b2e06671e16e$var$isIterable(val)) return val;
    else if ($7b18b2e06671e16e$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $7b18b2e06671e16e$var$fromReadable(val);
    throw new $7b18b2e06671e16e$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $7b18b2e06671e16e$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7b18b2e06671e16e$var$Readable) $7b18b2e06671e16e$var$Readable = (parcelRequire("3WXi7"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($7b18b2e06671e16e$var$Readable.prototype[$7b18b2e06671e16e$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7b18b2e06671e16e$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $7b18b2e06671e16e$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $l7UFF(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $7b18b2e06671e16e$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7b18b2e06671e16e$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($7b18b2e06671e16e$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7b18b2e06671e16e$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $7b18b2e06671e16e$var$pipelineImpl(streams, $7b18b2e06671e16e$require$once($7b18b2e06671e16e$var$popCallback(streams)));
}


function $7b18b2e06671e16e$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($7b18b2e06671e16e$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $7b18b2e06671e16e$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($7b18b2e06671e16e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($7b18b2e06671e16e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$7b18b2e06671e16e$var$isIterable(ret)) throw new $7b18b2e06671e16e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($7b18b2e06671e16e$var$isIterable(stream) || $7b18b2e06671e16e$var$isReadableNodeStream(stream) || $7b18b2e06671e16e$var$isTransformStream(stream)) ret = stream;
            else ret = $9hmsc.from(stream);
        } else if (typeof stream === 'function') {
            if ($7b18b2e06671e16e$var$isTransformStream(ret)) {
                var _ret;
                ret = $7b18b2e06671e16e$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $7b18b2e06671e16e$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$7b18b2e06671e16e$var$isIterable(ret, true)) throw new $7b18b2e06671e16e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$7b18b2e06671e16e$var$PassThrough) $7b18b2e06671e16e$var$PassThrough = (parcelRequire("9bpTR"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $7b18b2e06671e16e$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($7b18b2e06671e16e$var$isIterable(ret, true)) {
                    finishCount++;
                    $7b18b2e06671e16e$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($7b18b2e06671e16e$var$isReadableStream(ret) || $7b18b2e06671e16e$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $7b18b2e06671e16e$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $7b18b2e06671e16e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $7b18b2e06671e16e$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($7b18b2e06671e16e$var$isNodeStream(stream)) {
            if ($7b18b2e06671e16e$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $7b18b2e06671e16e$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($7b18b2e06671e16e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($7b18b2e06671e16e$var$isTransformStream(ret) || $7b18b2e06671e16e$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $7b18b2e06671e16e$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($7b18b2e06671e16e$var$isIterable(ret)) {
                finishCount++;
                $7b18b2e06671e16e$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $7b18b2e06671e16e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($7b18b2e06671e16e$var$isWebStream(stream)) {
            if ($7b18b2e06671e16e$var$isReadableNodeStream(ret)) {
                finishCount++;
                $7b18b2e06671e16e$var$pumpToWeb($7b18b2e06671e16e$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($7b18b2e06671e16e$var$isReadableStream(ret) || $7b18b2e06671e16e$var$isIterable(ret)) {
                finishCount++;
                $7b18b2e06671e16e$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($7b18b2e06671e16e$var$isTransformStream(ret)) {
                finishCount++;
                $7b18b2e06671e16e$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $7b18b2e06671e16e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $9hmsc.from(stream);
    };
    if (streams.length === 1 && $7b18b2e06671e16e$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7b18b2e06671e16e$var$ERR_MISSING_ARGS('streams');
    var ac = new $7b18b2e06671e16e$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $7b18b2e06671e16e$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $7b18b2e06671e16e$var$AbortError());
    }
    $7b18b2e06671e16e$var$addAbortListener = $7b18b2e06671e16e$var$addAbortListener || (parcelRequire("3HJCn")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $7b18b2e06671e16e$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$7b18b2e06671e16e$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $7b18b2e06671e16e$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $7b18b2e06671e16e$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($7b18b2e06671e16e$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $l7UFF(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $l7UFF(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $7b18b2e06671e16e$var$pipelineImpl,
    pipeline: $7b18b2e06671e16e$var$pipeline
};

});
parcelRegister("1Gyoe", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $7idPE = parcelRequire("7idPE");
/* replacement end */ var $13a463cad84fa645$var$aggregateTwoErrors = $7idPE.aggregateTwoErrors, $13a463cad84fa645$var$ERR_MULTIPLE_CALLBACK = $7idPE.codes.ERR_MULTIPLE_CALLBACK, $13a463cad84fa645$var$AbortError = $7idPE.AbortError;

var $fEo31 = parcelRequire("fEo31");
var $13a463cad84fa645$require$Symbol = $fEo31.Symbol;

var $eCt0N = parcelRequire("eCt0N");
var $13a463cad84fa645$var$kIsDestroyed = $eCt0N.kIsDestroyed, $13a463cad84fa645$var$isDestroyed = $eCt0N.isDestroyed, $13a463cad84fa645$var$isFinished = $eCt0N.isFinished, $13a463cad84fa645$var$isServerRequest = $eCt0N.isServerRequest;
var $13a463cad84fa645$var$kDestroy = $13a463cad84fa645$require$Symbol('kDestroy');
var $13a463cad84fa645$var$kConstruct = $13a463cad84fa645$require$Symbol('kConstruct');
function $13a463cad84fa645$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $13a463cad84fa645$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $13a463cad84fa645$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($13a463cad84fa645$var$kDestroy, function(er) {
        $13a463cad84fa645$var$_destroy(this, $13a463cad84fa645$var$aggregateTwoErrors(er, err), cb);
    });
    else $13a463cad84fa645$var$_destroy(this, err, cb);
    return this;
}
function $13a463cad84fa645$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $13a463cad84fa645$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($13a463cad84fa645$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($13a463cad84fa645$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $13a463cad84fa645$var$emitErrorCloseNT(self, err) {
    $13a463cad84fa645$var$emitErrorNT(self, err);
    $13a463cad84fa645$var$emitCloseNT(self);
}
function $13a463cad84fa645$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $13a463cad84fa645$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $13a463cad84fa645$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $13a463cad84fa645$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($13a463cad84fa645$var$emitErrorNT, stream, err);
        else $13a463cad84fa645$var$emitErrorNT(stream, err);
    }
}
function $13a463cad84fa645$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($13a463cad84fa645$var$kConstruct, cb);
    if (stream.listenerCount($13a463cad84fa645$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($13a463cad84fa645$var$constructNT, stream);
}
function $13a463cad84fa645$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $13a463cad84fa645$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $13a463cad84fa645$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($13a463cad84fa645$var$kDestroy, err);
        else if (err) $13a463cad84fa645$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($13a463cad84fa645$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $13a463cad84fa645$var$emitConstructNT(stream) {
    stream.emit($13a463cad84fa645$var$kConstruct);
}
function $13a463cad84fa645$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $13a463cad84fa645$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $13a463cad84fa645$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($13a463cad84fa645$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $13a463cad84fa645$var$destroyer(stream, err) {
    if (!stream || $13a463cad84fa645$var$isDestroyed(stream)) return;
    if (!err && !$13a463cad84fa645$var$isFinished(stream)) err = new $13a463cad84fa645$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($13a463cad84fa645$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($13a463cad84fa645$var$isRequest(stream)) stream.abort();
    else if ($13a463cad84fa645$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($13a463cad84fa645$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($13a463cad84fa645$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$13a463cad84fa645$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $13a463cad84fa645$var$construct,
    destroyer: $13a463cad84fa645$var$destroyer,
    destroy: $13a463cad84fa645$var$destroy,
    undestroy: $13a463cad84fa645$var$undestroy,
    errorOrDestroy: $13a463cad84fa645$var$errorOrDestroy
};

});

parcelRegister("9hmsc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $6c171e7388fa8f67$var$ObjectDefineProperties = $fEo31.ObjectDefineProperties, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor = $fEo31.ObjectGetOwnPropertyDescriptor, $6c171e7388fa8f67$var$ObjectKeys = $fEo31.ObjectKeys, $6c171e7388fa8f67$var$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf;
module.exports = $6c171e7388fa8f67$var$Duplex;

var $3WXi7 = parcelRequire("3WXi7");

var $23Jcj = parcelRequire("23Jcj");
$6c171e7388fa8f67$var$ObjectSetPrototypeOf($6c171e7388fa8f67$var$Duplex.prototype, $3WXi7.prototype);
$6c171e7388fa8f67$var$ObjectSetPrototypeOf($6c171e7388fa8f67$var$Duplex, $3WXi7);
{
    var $6c171e7388fa8f67$var$keys = $6c171e7388fa8f67$var$ObjectKeys($23Jcj.prototype);
    // Allow the keys array to be GC'ed.
    for(var $6c171e7388fa8f67$var$i = 0; $6c171e7388fa8f67$var$i < $6c171e7388fa8f67$var$keys.length; $6c171e7388fa8f67$var$i++){
        var $6c171e7388fa8f67$var$method = $6c171e7388fa8f67$var$keys[$6c171e7388fa8f67$var$i];
        if (!$6c171e7388fa8f67$var$Duplex.prototype[$6c171e7388fa8f67$var$method]) $6c171e7388fa8f67$var$Duplex.prototype[$6c171e7388fa8f67$var$method] = $23Jcj.prototype[$6c171e7388fa8f67$var$method];
    }
}function $6c171e7388fa8f67$var$Duplex(options) {
    if (!(this instanceof $6c171e7388fa8f67$var$Duplex)) return new $6c171e7388fa8f67$var$Duplex(options);
    $3WXi7.call(this, options);
    $23Jcj.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$6c171e7388fa8f67$var$ObjectDefineProperties($6c171e7388fa8f67$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $6c171e7388fa8f67$var$ObjectGetOwnPropertyDescriptor($23Jcj.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $6c171e7388fa8f67$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6c171e7388fa8f67$var$lazyWebStreams() {
    if ($6c171e7388fa8f67$var$webStreamsAdapters === undefined) $6c171e7388fa8f67$var$webStreamsAdapters = {};
    return $6c171e7388fa8f67$var$webStreamsAdapters;
}
$6c171e7388fa8f67$var$Duplex.fromWeb = function(pair, options) {
    return $6c171e7388fa8f67$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$6c171e7388fa8f67$var$Duplex.toWeb = function(duplex) {
    return $6c171e7388fa8f67$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $6c171e7388fa8f67$var$duplexify;

$6c171e7388fa8f67$var$Duplex.from = function(body) {
    if (!$6c171e7388fa8f67$var$duplexify) $6c171e7388fa8f67$var$duplexify = (parcelRequire("hKHJd"));
    return $6c171e7388fa8f67$var$duplexify(body, 'body');
};

});
parcelRegister("3WXi7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fEo31 = parcelRequire("fEo31");
/* replacement end */ var $2e04c7dcdabc1396$var$ArrayPrototypeIndexOf = $fEo31.ArrayPrototypeIndexOf, $2e04c7dcdabc1396$var$NumberIsInteger = $fEo31.NumberIsInteger, $2e04c7dcdabc1396$var$NumberIsNaN = $fEo31.NumberIsNaN, $2e04c7dcdabc1396$var$NumberParseInt = $fEo31.NumberParseInt, $2e04c7dcdabc1396$var$ObjectDefineProperties = $fEo31.ObjectDefineProperties, $2e04c7dcdabc1396$var$ObjectKeys = $fEo31.ObjectKeys, $2e04c7dcdabc1396$var$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf, $2e04c7dcdabc1396$var$Promise = $fEo31.Promise, $2e04c7dcdabc1396$var$SafeSet = $fEo31.SafeSet, $2e04c7dcdabc1396$var$SymbolAsyncDispose = $fEo31.SymbolAsyncDispose, $2e04c7dcdabc1396$var$SymbolAsyncIterator = $fEo31.SymbolAsyncIterator, $2e04c7dcdabc1396$var$Symbol = $fEo31.Symbol;
module.exports = $2e04c7dcdabc1396$var$Readable;
$2e04c7dcdabc1396$var$Readable.ReadableState = $2e04c7dcdabc1396$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $2e04c7dcdabc1396$var$EE = $bBoAO.EventEmitter;

var $2qnO2 = parcelRequire("2qnO2");
var $2e04c7dcdabc1396$var$Stream = $2qnO2.Stream, $2e04c7dcdabc1396$var$prependListener = $2qnO2.prependListener;

var $57t8y = parcelRequire("57t8y");
var $2e04c7dcdabc1396$require$Buffer = $57t8y.Buffer;

var $iOHZz = parcelRequire("iOHZz");
var $2e04c7dcdabc1396$require$addAbortSignal = $iOHZz.addAbortSignal;

var $l7UFF = parcelRequire("l7UFF");

var $2e04c7dcdabc1396$var$debug = (parcelRequire("3HJCn")).debuglog('stream', function(fn) {
    $2e04c7dcdabc1396$var$debug = fn;
});

var $9MSXb = parcelRequire("9MSXb");

var $1Gyoe = parcelRequire("1Gyoe");

var $b6kaZ = parcelRequire("b6kaZ");
var $2e04c7dcdabc1396$var$getHighWaterMark = $b6kaZ.getHighWaterMark, $2e04c7dcdabc1396$var$getDefaultHighWaterMark = $b6kaZ.getDefaultHighWaterMark;

var $7idPE = parcelRequire("7idPE");
var $2e04c7dcdabc1396$var$aggregateTwoErrors = $7idPE.aggregateTwoErrors, $2e04c7dcdabc1396$var$_require_codes = $7idPE.codes, $2e04c7dcdabc1396$var$ERR_INVALID_ARG_TYPE = $2e04c7dcdabc1396$var$_require_codes.ERR_INVALID_ARG_TYPE, $2e04c7dcdabc1396$var$ERR_METHOD_NOT_IMPLEMENTED = $2e04c7dcdabc1396$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $2e04c7dcdabc1396$var$ERR_OUT_OF_RANGE = $2e04c7dcdabc1396$var$_require_codes.ERR_OUT_OF_RANGE, $2e04c7dcdabc1396$var$ERR_STREAM_PUSH_AFTER_EOF = $2e04c7dcdabc1396$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $2e04c7dcdabc1396$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $2e04c7dcdabc1396$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $2e04c7dcdabc1396$var$AbortError = $7idPE.AbortError;

var $3OsBa = parcelRequire("3OsBa");
var $2e04c7dcdabc1396$require$validateObject = $3OsBa.validateObject;
var $2e04c7dcdabc1396$var$kPaused = $2e04c7dcdabc1396$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $2e04c7dcdabc1396$require$StringDecoder = $3Jf7C.StringDecoder;

var $hlLIv = parcelRequire("hlLIv");
$2e04c7dcdabc1396$var$ObjectSetPrototypeOf($2e04c7dcdabc1396$var$Readable.prototype, $2e04c7dcdabc1396$var$Stream.prototype);
$2e04c7dcdabc1396$var$ObjectSetPrototypeOf($2e04c7dcdabc1396$var$Readable, $2e04c7dcdabc1396$var$Stream);
var $2e04c7dcdabc1396$var$nop = function() {};
var $2e04c7dcdabc1396$var$errorOrDestroy = $1Gyoe.errorOrDestroy;
var $2e04c7dcdabc1396$var$kObjectMode = 1;
var $2e04c7dcdabc1396$var$kEnded = 2;
var $2e04c7dcdabc1396$var$kEndEmitted = 4;
var $2e04c7dcdabc1396$var$kReading = 8;
var $2e04c7dcdabc1396$var$kConstructed = 16;
var $2e04c7dcdabc1396$var$kSync = 32;
var $2e04c7dcdabc1396$var$kNeedReadable = 64;
var $2e04c7dcdabc1396$var$kEmittedReadable = 128;
var $2e04c7dcdabc1396$var$kReadableListening = 256;
var $2e04c7dcdabc1396$var$kResumeScheduled = 512;
var $2e04c7dcdabc1396$var$kErrorEmitted = 1024;
var $2e04c7dcdabc1396$var$kEmitClose = 2048;
var $2e04c7dcdabc1396$var$kAutoDestroy = 4096;
var $2e04c7dcdabc1396$var$kDestroyed = 8192;
var $2e04c7dcdabc1396$var$kClosed = 16384;
var $2e04c7dcdabc1396$var$kCloseEmitted = 32768;
var $2e04c7dcdabc1396$var$kMultiAwaitDrain = 65536;
var $2e04c7dcdabc1396$var$kReadingMore = 131072;
var $2e04c7dcdabc1396$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $2e04c7dcdabc1396$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$2e04c7dcdabc1396$var$ObjectDefineProperties($2e04c7dcdabc1396$var$ReadableState.prototype, {
    objectMode: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kObjectMode),
    ended: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kEnded),
    endEmitted: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kEndEmitted),
    reading: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kNeedReadable),
    emittedReadable: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kEmittedReadable),
    readableListening: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kReadableListening),
    resumeScheduled: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kErrorEmitted),
    emitClose: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kEmitClose),
    autoDestroy: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kCloseEmitted),
    multiAwaitDrain: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kReadingMore),
    dataEmitted: $2e04c7dcdabc1396$var$makeBitMapDescriptor($2e04c7dcdabc1396$var$kDataEmitted)
});

function $2e04c7dcdabc1396$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("9hmsc"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $2e04c7dcdabc1396$var$kEmitClose | $2e04c7dcdabc1396$var$kAutoDestroy | $2e04c7dcdabc1396$var$kConstructed | $2e04c7dcdabc1396$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $2e04c7dcdabc1396$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $2e04c7dcdabc1396$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $2e04c7dcdabc1396$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $2e04c7dcdabc1396$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9MSXb();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$2e04c7dcdabc1396$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$2e04c7dcdabc1396$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$2e04c7dcdabc1396$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $2e04c7dcdabc1396$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $2e04c7dcdabc1396$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $2e04c7dcdabc1396$var$Readable)) return new $2e04c7dcdabc1396$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("9hmsc"));
    this._readableState = new $2e04c7dcdabc1396$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $2e04c7dcdabc1396$require$addAbortSignal(options.signal, this);
    }
    $2e04c7dcdabc1396$var$Stream.call(this, options);
    $1Gyoe.construct(this, function() {
        if (_this._readableState.needReadable) $2e04c7dcdabc1396$var$maybeReadMore(_this, _this._readableState);
    });
}
$2e04c7dcdabc1396$var$Readable.prototype.destroy = $1Gyoe.destroy;
$2e04c7dcdabc1396$var$Readable.prototype._undestroy = $1Gyoe.undestroy;
$2e04c7dcdabc1396$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$2e04c7dcdabc1396$var$Readable.prototype[$2e04c7dcdabc1396$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$2e04c7dcdabc1396$var$Readable.prototype[$2e04c7dcdabc1396$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $2e04c7dcdabc1396$var$AbortError();
        this.destroy(error);
    }
    return new $2e04c7dcdabc1396$var$Promise(function(resolve, reject) {
        return $l7UFF(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$2e04c7dcdabc1396$var$Readable.prototype.push = function(chunk, encoding) {
    return $2e04c7dcdabc1396$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$2e04c7dcdabc1396$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $2e04c7dcdabc1396$var$readableAddChunk(this, chunk, encoding, true);
};
function $2e04c7dcdabc1396$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $2e04c7dcdabc1396$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $2e04c7dcdabc1396$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $2e04c7dcdabc1396$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $2e04c7dcdabc1396$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $2e04c7dcdabc1396$require$Buffer) encoding = '';
        else if ($2e04c7dcdabc1396$var$Stream._isUint8Array(chunk)) {
            chunk = $2e04c7dcdabc1396$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $2e04c7dcdabc1396$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $2e04c7dcdabc1396$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$2e04c7dcdabc1396$var$kReading;
        $2e04c7dcdabc1396$var$onEofChunk(stream, state);
    } else if ((state.state & $2e04c7dcdabc1396$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $2e04c7dcdabc1396$var$kEndEmitted) !== 0) $2e04c7dcdabc1396$var$errorOrDestroy(stream, new $2e04c7dcdabc1396$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $2e04c7dcdabc1396$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $2e04c7dcdabc1396$var$errorOrDestroy(stream, new $2e04c7dcdabc1396$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$2e04c7dcdabc1396$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $2e04c7dcdabc1396$var$addChunk(stream, state, chunk, false);
                else $2e04c7dcdabc1396$var$maybeReadMore(stream, state);
            } else $2e04c7dcdabc1396$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$2e04c7dcdabc1396$var$kReading;
        $2e04c7dcdabc1396$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $2e04c7dcdabc1396$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $2e04c7dcdabc1396$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $2e04c7dcdabc1396$var$kNeedReadable) !== 0) $2e04c7dcdabc1396$var$emitReadable(stream);
    }
    $2e04c7dcdabc1396$var$maybeReadMore(stream, state);
}
$2e04c7dcdabc1396$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$2e04c7dcdabc1396$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$2e04c7dcdabc1396$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $2e04c7dcdabc1396$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$2e04c7dcdabc1396$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $2e04c7dcdabc1396$var$MAX_HWM = 0x40000000;
function $2e04c7dcdabc1396$var$computeNewHighWaterMark(n) {
    if (n > $2e04c7dcdabc1396$var$MAX_HWM) throw new $2e04c7dcdabc1396$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2e04c7dcdabc1396$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $2e04c7dcdabc1396$var$kObjectMode) !== 0) return 1;
    if ($2e04c7dcdabc1396$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$2e04c7dcdabc1396$var$Readable.prototype.read = function(n) {
    $2e04c7dcdabc1396$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$2e04c7dcdabc1396$var$NumberIsInteger(n)) n = $2e04c7dcdabc1396$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $2e04c7dcdabc1396$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$2e04c7dcdabc1396$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $2e04c7dcdabc1396$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $2e04c7dcdabc1396$var$endReadable(this);
        else $2e04c7dcdabc1396$var$emitReadable(this);
        return null;
    }
    n = $2e04c7dcdabc1396$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $2e04c7dcdabc1396$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $2e04c7dcdabc1396$var$kNeedReadable) !== 0;
    $2e04c7dcdabc1396$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $2e04c7dcdabc1396$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $2e04c7dcdabc1396$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $2e04c7dcdabc1396$var$debug('do read');
        state.state |= $2e04c7dcdabc1396$var$kReading | $2e04c7dcdabc1396$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $2e04c7dcdabc1396$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $2e04c7dcdabc1396$var$errorOrDestroy(this, err);
        }
        state.state &= ~$2e04c7dcdabc1396$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $2e04c7dcdabc1396$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $2e04c7dcdabc1396$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $2e04c7dcdabc1396$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $2e04c7dcdabc1396$var$onEofChunk(stream, state) {
    $2e04c7dcdabc1396$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $2e04c7dcdabc1396$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $2e04c7dcdabc1396$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $2e04c7dcdabc1396$var$emitReadable(stream) {
    var state = stream._readableState;
    $2e04c7dcdabc1396$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $2e04c7dcdabc1396$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($2e04c7dcdabc1396$var$emitReadable_, stream);
    }
}
function $2e04c7dcdabc1396$var$emitReadable_(stream) {
    var state = stream._readableState;
    $2e04c7dcdabc1396$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $2e04c7dcdabc1396$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $2e04c7dcdabc1396$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($2e04c7dcdabc1396$var$maybeReadMore_, stream, state);
    }
}
function $2e04c7dcdabc1396$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $2e04c7dcdabc1396$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$2e04c7dcdabc1396$var$Readable.prototype._read = function(n) {
    throw new $2e04c7dcdabc1396$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$2e04c7dcdabc1396$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $2e04c7dcdabc1396$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $2e04c7dcdabc1396$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $2e04c7dcdabc1396$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $2e04c7dcdabc1396$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $2e04c7dcdabc1396$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $2e04c7dcdabc1396$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $2e04c7dcdabc1396$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $2e04c7dcdabc1396$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $2e04c7dcdabc1396$var$debug('ondata');
        var ret = dest.write(chunk);
        $2e04c7dcdabc1396$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $2e04c7dcdabc1396$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $2e04c7dcdabc1396$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $2e04c7dcdabc1396$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $2e04c7dcdabc1396$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $2e04c7dcdabc1396$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $2e04c7dcdabc1396$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $2e04c7dcdabc1396$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $2e04c7dcdabc1396$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $2e04c7dcdabc1396$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$2e04c7dcdabc1396$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $2e04c7dcdabc1396$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$2e04c7dcdabc1396$var$Readable.prototype.on = function(ev, fn) {
    var res = $2e04c7dcdabc1396$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $2e04c7dcdabc1396$var$debug('on readable', state.length, state.reading);
            if (state.length) $2e04c7dcdabc1396$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($2e04c7dcdabc1396$var$nReadingNextTick, this);
        }
    }
    return res;
};
$2e04c7dcdabc1396$var$Readable.prototype.addListener = $2e04c7dcdabc1396$var$Readable.prototype.on;
$2e04c7dcdabc1396$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $2e04c7dcdabc1396$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($2e04c7dcdabc1396$var$updateReadableListening, this);
    return res;
};
$2e04c7dcdabc1396$var$Readable.prototype.off = $2e04c7dcdabc1396$var$Readable.prototype.removeListener;
$2e04c7dcdabc1396$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $2e04c7dcdabc1396$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($2e04c7dcdabc1396$var$updateReadableListening, this);
    return res;
};
function $2e04c7dcdabc1396$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$2e04c7dcdabc1396$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $2e04c7dcdabc1396$var$nReadingNextTick(self) {
    $2e04c7dcdabc1396$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$2e04c7dcdabc1396$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $2e04c7dcdabc1396$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $2e04c7dcdabc1396$var$resume(this, state);
    }
    state[$2e04c7dcdabc1396$var$kPaused] = false;
    return this;
};
function $2e04c7dcdabc1396$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($2e04c7dcdabc1396$var$resume_, stream, state);
    }
}
function $2e04c7dcdabc1396$var$resume_(stream, state) {
    $2e04c7dcdabc1396$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $2e04c7dcdabc1396$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$2e04c7dcdabc1396$var$Readable.prototype.pause = function() {
    $2e04c7dcdabc1396$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $2e04c7dcdabc1396$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$2e04c7dcdabc1396$var$kPaused] = true;
    return this;
};
function $2e04c7dcdabc1396$var$flow(stream) {
    var state = stream._readableState;
    $2e04c7dcdabc1396$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$2e04c7dcdabc1396$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $2e04c7dcdabc1396$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $2e04c7dcdabc1396$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$2e04c7dcdabc1396$var$Readable.prototype[$2e04c7dcdabc1396$var$SymbolAsyncIterator] = function() {
    return $2e04c7dcdabc1396$var$streamToAsyncIterator(this);
};
$2e04c7dcdabc1396$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $2e04c7dcdabc1396$require$validateObject(options, 'options');
    return $2e04c7dcdabc1396$var$streamToAsyncIterator(this, options);
};
function $2e04c7dcdabc1396$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $2e04c7dcdabc1396$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $2e04c7dcdabc1396$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $2e04c7dcdabc1396$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $2e04c7dcdabc1396$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $2e04c7dcdabc1396$var$nop;
                    stream.on('readable', next);
                    cleanup = $l7UFF(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $2e04c7dcdabc1396$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $2e04c7dcdabc1396$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $2e04c7dcdabc1396$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $2e04c7dcdabc1396$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $1Gyoe.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$2e04c7dcdabc1396$var$ObjectDefineProperties($2e04c7dcdabc1396$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$2e04c7dcdabc1396$var$ObjectDefineProperties($2e04c7dcdabc1396$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$2e04c7dcdabc1396$var$kPaused] !== false;
        },
        set: function(value) {
            this[$2e04c7dcdabc1396$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$2e04c7dcdabc1396$var$Readable._fromList = $2e04c7dcdabc1396$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2e04c7dcdabc1396$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $2e04c7dcdabc1396$var$endReadable(stream) {
    var state = stream._readableState;
    $2e04c7dcdabc1396$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($2e04c7dcdabc1396$var$endReadableNT, state, stream);
    }
}
function $2e04c7dcdabc1396$var$endReadableNT(state, stream) {
    $2e04c7dcdabc1396$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($2e04c7dcdabc1396$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $2e04c7dcdabc1396$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$2e04c7dcdabc1396$var$Readable.from = function(iterable, opts) {
    return $hlLIv($2e04c7dcdabc1396$var$Readable, iterable, opts);
};
var $2e04c7dcdabc1396$var$webStreamsAdapters;
// Lazy to avoid circular references
function $2e04c7dcdabc1396$var$lazyWebStreams() {
    if ($2e04c7dcdabc1396$var$webStreamsAdapters === undefined) $2e04c7dcdabc1396$var$webStreamsAdapters = {};
    return $2e04c7dcdabc1396$var$webStreamsAdapters;
}
$2e04c7dcdabc1396$var$Readable.fromWeb = function(readableStream, options) {
    return $2e04c7dcdabc1396$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$2e04c7dcdabc1396$var$Readable.toWeb = function(streamReadable, options) {
    return $2e04c7dcdabc1396$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$2e04c7dcdabc1396$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $2e04c7dcdabc1396$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $1Gyoe.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("2qnO2", function(module, exports) {
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $1c4079dae1251ece$var$ArrayIsArray = $fEo31.ArrayIsArray, $1c4079dae1251ece$var$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $1c4079dae1251ece$var$EE = $bBoAO.EventEmitter;
function $1c4079dae1251ece$var$Stream(opts) {
    $1c4079dae1251ece$var$EE.call(this, opts);
}
$1c4079dae1251ece$var$ObjectSetPrototypeOf($1c4079dae1251ece$var$Stream.prototype, $1c4079dae1251ece$var$EE.prototype);
$1c4079dae1251ece$var$ObjectSetPrototypeOf($1c4079dae1251ece$var$Stream, $1c4079dae1251ece$var$EE);
$1c4079dae1251ece$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1c4079dae1251ece$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $1c4079dae1251ece$var$prependListener(source, 'error', onerror);
    $1c4079dae1251ece$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $1c4079dae1251ece$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($1c4079dae1251ece$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $1c4079dae1251ece$var$Stream,
    prependListener: $1c4079dae1251ece$var$prependListener
};

});

parcelRegister("iOHZz", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $db2f056800e65381$export$e2db56ee53255a0; }, function (v) { return $db2f056800e65381$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $db2f056800e65381$export$11956e9313f43de0; }, function (v) { return $db2f056800e65381$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $db2f056800e65381$export$e2db56ee53255a0;
var $db2f056800e65381$export$11956e9313f43de0;
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $db2f056800e65381$require$SymbolDispose = $fEo31.SymbolDispose;

var $7idPE = parcelRequire("7idPE");
var $db2f056800e65381$var$AbortError = $7idPE.AbortError, $db2f056800e65381$var$codes = $7idPE.codes;

var $eCt0N = parcelRequire("eCt0N");
var $db2f056800e65381$var$isNodeStream = $eCt0N.isNodeStream, $db2f056800e65381$var$isWebStream = $eCt0N.isWebStream, $db2f056800e65381$var$kControllerErrorFunction = $eCt0N.kControllerErrorFunction;

var $l7UFF = parcelRequire("l7UFF");
var $db2f056800e65381$var$ERR_INVALID_ARG_TYPE = $db2f056800e65381$var$codes.ERR_INVALID_ARG_TYPE;
var $db2f056800e65381$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $db2f056800e65381$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $db2f056800e65381$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$db2f056800e65381$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $db2f056800e65381$var$validateAbortSignal(signal, 'signal');
    if (!$db2f056800e65381$var$isNodeStream(stream) && !$db2f056800e65381$var$isWebStream(stream)) throw new $db2f056800e65381$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $db2f056800e65381$export$11956e9313f43de0(signal, stream);
};

$db2f056800e65381$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $db2f056800e65381$var$isNodeStream(stream) ? function() {
        stream.destroy(new $db2f056800e65381$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$db2f056800e65381$var$kControllerErrorFunction](new $db2f056800e65381$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $db2f056800e65381$var$addAbortListener = $db2f056800e65381$var$addAbortListener || (parcelRequire("3HJCn")).addAbortListener;
        var disposable = $db2f056800e65381$var$addAbortListener(signal, onAbort);
        $l7UFF(stream, disposable[$db2f056800e65381$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9MSXb", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $7203396117fb03df$var$StringPrototypeSlice = $fEo31.StringPrototypeSlice, $7203396117fb03df$var$SymbolIterator = $fEo31.SymbolIterator, $7203396117fb03df$var$TypedArrayPrototypeSet = $fEo31.TypedArrayPrototypeSet, $7203396117fb03df$var$Uint8Array = $fEo31.Uint8Array;

var $57t8y = parcelRequire("57t8y");
var $7203396117fb03df$require$Buffer = $57t8y.Buffer;

var $3HJCn = parcelRequire("3HJCn");
var $7203396117fb03df$require$inspect = $3HJCn.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7203396117fb03df$require$Buffer.alloc(0);
                var ret = $7203396117fb03df$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7203396117fb03df$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $7203396117fb03df$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $7203396117fb03df$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $7203396117fb03df$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7203396117fb03df$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $7203396117fb03df$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $7203396117fb03df$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $7203396117fb03df$var$TypedArrayPrototypeSet(ret, new $7203396117fb03df$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $7203396117fb03df$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("b6kaZ", function(module, exports) {
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $814fe7d76c1417c6$var$MathFloor = $fEo31.MathFloor, $814fe7d76c1417c6$var$NumberIsInteger = $fEo31.NumberIsInteger;

var $3OsBa = parcelRequire("3OsBa");
var $814fe7d76c1417c6$require$validateInteger = $3OsBa.validateInteger;

var $814fe7d76c1417c6$var$ERR_INVALID_ARG_VALUE = (parcelRequire("7idPE")).codes.ERR_INVALID_ARG_VALUE;
var $814fe7d76c1417c6$var$defaultHighWaterMarkBytes = 16384;
var $814fe7d76c1417c6$var$defaultHighWaterMarkObjectMode = 16;
function $814fe7d76c1417c6$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $814fe7d76c1417c6$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $814fe7d76c1417c6$var$defaultHighWaterMarkObjectMode : $814fe7d76c1417c6$var$defaultHighWaterMarkBytes;
}
function $814fe7d76c1417c6$var$setDefaultHighWaterMark(objectMode, value) {
    $814fe7d76c1417c6$require$validateInteger(value, 'value', 0);
    if (objectMode) $814fe7d76c1417c6$var$defaultHighWaterMarkObjectMode = value;
    else $814fe7d76c1417c6$var$defaultHighWaterMarkBytes = value;
}
function $814fe7d76c1417c6$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $814fe7d76c1417c6$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$814fe7d76c1417c6$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $814fe7d76c1417c6$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $814fe7d76c1417c6$var$MathFloor(hwm);
    }
    // Default value
    return $814fe7d76c1417c6$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $814fe7d76c1417c6$var$getHighWaterMark,
    getDefaultHighWaterMark: $814fe7d76c1417c6$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $814fe7d76c1417c6$var$setDefaultHighWaterMark
};

});

parcelRegister("hlLIv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fEo31 = parcelRequire("fEo31");
/* replacement end */ var $ca19696afea28876$var$PromisePrototypeThen = $fEo31.PromisePrototypeThen, $ca19696afea28876$var$SymbolAsyncIterator = $fEo31.SymbolAsyncIterator, $ca19696afea28876$var$SymbolIterator = $fEo31.SymbolIterator;

var $57t8y = parcelRequire("57t8y");
var $ca19696afea28876$require$Buffer = $57t8y.Buffer;

var $7idPE = parcelRequire("7idPE");
var $ca19696afea28876$require$_require_codes = $7idPE.codes;
var $ca19696afea28876$var$ERR_INVALID_ARG_TYPE = $ca19696afea28876$require$_require_codes.ERR_INVALID_ARG_TYPE, $ca19696afea28876$var$ERR_STREAM_NULL_VALUES = $ca19696afea28876$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $ca19696afea28876$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $ca19696afea28876$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$ca19696afea28876$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$ca19696afea28876$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$ca19696afea28876$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$ca19696afea28876$var$SymbolIterator]();
    } else throw new $ca19696afea28876$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $ca19696afea28876$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $ca19696afea28876$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $ca19696afea28876$var$from;

});


parcelRegister("23Jcj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fEo31 = parcelRequire("fEo31");
/* replacement end */ var $17feebe57b9f627f$var$ArrayPrototypeSlice = $fEo31.ArrayPrototypeSlice, $17feebe57b9f627f$var$Error = $fEo31.Error, $17feebe57b9f627f$var$FunctionPrototypeSymbolHasInstance = $fEo31.FunctionPrototypeSymbolHasInstance, $17feebe57b9f627f$var$ObjectDefineProperty = $fEo31.ObjectDefineProperty, $17feebe57b9f627f$var$ObjectDefineProperties = $fEo31.ObjectDefineProperties, $17feebe57b9f627f$var$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf, $17feebe57b9f627f$var$StringPrototypeToLowerCase = $fEo31.StringPrototypeToLowerCase, $17feebe57b9f627f$var$Symbol = $fEo31.Symbol, $17feebe57b9f627f$var$SymbolHasInstance = $fEo31.SymbolHasInstance;
module.exports = $17feebe57b9f627f$var$Writable;
$17feebe57b9f627f$var$Writable.WritableState = $17feebe57b9f627f$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $17feebe57b9f627f$var$EE = $bBoAO.EventEmitter;

var $2qnO2 = parcelRequire("2qnO2");
var $17feebe57b9f627f$require$Stream = $2qnO2.Stream;

var $57t8y = parcelRequire("57t8y");
var $17feebe57b9f627f$require$Buffer = $57t8y.Buffer;

var $1Gyoe = parcelRequire("1Gyoe");

var $iOHZz = parcelRequire("iOHZz");
var $17feebe57b9f627f$require$addAbortSignal = $iOHZz.addAbortSignal;

var $b6kaZ = parcelRequire("b6kaZ");
var $17feebe57b9f627f$var$getHighWaterMark = $b6kaZ.getHighWaterMark, $17feebe57b9f627f$var$getDefaultHighWaterMark = $b6kaZ.getDefaultHighWaterMark;

var $7idPE = parcelRequire("7idPE");
var $17feebe57b9f627f$require$_require_codes = $7idPE.codes;
var $17feebe57b9f627f$var$ERR_INVALID_ARG_TYPE = $17feebe57b9f627f$require$_require_codes.ERR_INVALID_ARG_TYPE, $17feebe57b9f627f$var$ERR_METHOD_NOT_IMPLEMENTED = $17feebe57b9f627f$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $17feebe57b9f627f$var$ERR_MULTIPLE_CALLBACK = $17feebe57b9f627f$require$_require_codes.ERR_MULTIPLE_CALLBACK, $17feebe57b9f627f$var$ERR_STREAM_CANNOT_PIPE = $17feebe57b9f627f$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $17feebe57b9f627f$var$ERR_STREAM_DESTROYED = $17feebe57b9f627f$require$_require_codes.ERR_STREAM_DESTROYED, $17feebe57b9f627f$var$ERR_STREAM_ALREADY_FINISHED = $17feebe57b9f627f$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $17feebe57b9f627f$var$ERR_STREAM_NULL_VALUES = $17feebe57b9f627f$require$_require_codes.ERR_STREAM_NULL_VALUES, $17feebe57b9f627f$var$ERR_STREAM_WRITE_AFTER_END = $17feebe57b9f627f$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $17feebe57b9f627f$var$ERR_UNKNOWN_ENCODING = $17feebe57b9f627f$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $17feebe57b9f627f$var$errorOrDestroy = $1Gyoe.errorOrDestroy;
$17feebe57b9f627f$var$ObjectSetPrototypeOf($17feebe57b9f627f$var$Writable.prototype, $17feebe57b9f627f$require$Stream.prototype);
$17feebe57b9f627f$var$ObjectSetPrototypeOf($17feebe57b9f627f$var$Writable, $17feebe57b9f627f$require$Stream);
function $17feebe57b9f627f$var$nop() {}
var $17feebe57b9f627f$var$kOnFinished = $17feebe57b9f627f$var$Symbol('kOnFinished');

function $17feebe57b9f627f$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("9hmsc"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $17feebe57b9f627f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $17feebe57b9f627f$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $17feebe57b9f627f$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $17feebe57b9f627f$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$17feebe57b9f627f$var$kOnFinished] = [];
}
function $17feebe57b9f627f$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$17feebe57b9f627f$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $17feebe57b9f627f$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$17feebe57b9f627f$var$ObjectDefineProperty($17feebe57b9f627f$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $17feebe57b9f627f$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("9hmsc"));
    if (!isDuplex && !$17feebe57b9f627f$var$FunctionPrototypeSymbolHasInstance($17feebe57b9f627f$var$Writable, this)) return new $17feebe57b9f627f$var$Writable(options);
    this._writableState = new $17feebe57b9f627f$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $17feebe57b9f627f$require$addAbortSignal(options.signal, this);
    }
    $17feebe57b9f627f$require$Stream.call(this, options);
    $1Gyoe.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $17feebe57b9f627f$var$clearBuffer(_this, state);
        $17feebe57b9f627f$var$finishMaybe(_this, state);
    });
}
$17feebe57b9f627f$var$ObjectDefineProperty($17feebe57b9f627f$var$Writable, $17feebe57b9f627f$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($17feebe57b9f627f$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $17feebe57b9f627f$var$Writable) return false;
        return object && object._writableState instanceof $17feebe57b9f627f$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$17feebe57b9f627f$var$Writable.prototype.pipe = function() {
    $17feebe57b9f627f$var$errorOrDestroy(this, new $17feebe57b9f627f$var$ERR_STREAM_CANNOT_PIPE());
};
function $17feebe57b9f627f$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$17feebe57b9f627f$require$Buffer.isEncoding(encoding)) throw new $17feebe57b9f627f$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $17feebe57b9f627f$var$nop;
    }
    if (chunk === null) throw new $17feebe57b9f627f$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $17feebe57b9f627f$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $17feebe57b9f627f$require$Buffer) encoding = 'buffer';
        else if ($17feebe57b9f627f$require$Stream._isUint8Array(chunk)) {
            chunk = $17feebe57b9f627f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $17feebe57b9f627f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $17feebe57b9f627f$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $17feebe57b9f627f$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $17feebe57b9f627f$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $17feebe57b9f627f$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$17feebe57b9f627f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $17feebe57b9f627f$var$_write(this, chunk, encoding, cb) === true;
};
$17feebe57b9f627f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$17feebe57b9f627f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $17feebe57b9f627f$var$clearBuffer(this, state);
    }
};
$17feebe57b9f627f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $17feebe57b9f627f$var$StringPrototypeToLowerCase(encoding);
    if (!$17feebe57b9f627f$require$Buffer.isEncoding(encoding)) throw new $17feebe57b9f627f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $17feebe57b9f627f$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $17feebe57b9f627f$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $17feebe57b9f627f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $17feebe57b9f627f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $17feebe57b9f627f$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $17feebe57b9f627f$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $17feebe57b9f627f$var$errorOrDestroy(stream, er);
}
function $17feebe57b9f627f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $17feebe57b9f627f$var$errorOrDestroy(stream, new $17feebe57b9f627f$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($17feebe57b9f627f$var$onwriteError, stream, state, er, cb);
        else $17feebe57b9f627f$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $17feebe57b9f627f$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($17feebe57b9f627f$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $17feebe57b9f627f$var$afterWrite(stream, state, 1, cb);
    }
}
function $17feebe57b9f627f$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $17feebe57b9f627f$var$afterWrite(stream, state, count, cb);
}
function $17feebe57b9f627f$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $17feebe57b9f627f$var$errorBuffer(state);
    $17feebe57b9f627f$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $17feebe57b9f627f$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $17feebe57b9f627f$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$17feebe57b9f627f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $17feebe57b9f627f$var$ERR_STREAM_DESTROYED('end'));
    }
    $17feebe57b9f627f$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $17feebe57b9f627f$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $17feebe57b9f627f$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $17feebe57b9f627f$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $17feebe57b9f627f$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $17feebe57b9f627f$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $17feebe57b9f627f$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $17feebe57b9f627f$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$17feebe57b9f627f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $17feebe57b9f627f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$17feebe57b9f627f$var$Writable.prototype._writev = null;
$17feebe57b9f627f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $17feebe57b9f627f$var$_write(this, chunk, encoding);
        if (ret instanceof $17feebe57b9f627f$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $17feebe57b9f627f$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $17feebe57b9f627f$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $17feebe57b9f627f$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$17feebe57b9f627f$var$kOnFinished].push(cb);
    }
    return this;
};
function $17feebe57b9f627f$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $17feebe57b9f627f$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $17feebe57b9f627f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $17feebe57b9f627f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$17feebe57b9f627f$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $17feebe57b9f627f$var$errorOrDestroy(stream, err, state.sync);
        } else if ($17feebe57b9f627f$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($17feebe57b9f627f$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $17feebe57b9f627f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $17feebe57b9f627f$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $17feebe57b9f627f$var$finishMaybe(stream, state, sync) {
    if ($17feebe57b9f627f$var$needFinish(state)) {
        $17feebe57b9f627f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($17feebe57b9f627f$var$needFinish(state)) $17feebe57b9f627f$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($17feebe57b9f627f$var$needFinish(state)) {
                state.pendingcb++;
                $17feebe57b9f627f$var$finish(stream, state);
            }
        }
    }
}
function $17feebe57b9f627f$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$17feebe57b9f627f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$17feebe57b9f627f$var$ObjectDefineProperties($17feebe57b9f627f$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $17feebe57b9f627f$var$destroy = $1Gyoe.destroy;
$17feebe57b9f627f$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$17feebe57b9f627f$var$kOnFinished].length)) $2Qkr5.nextTick($17feebe57b9f627f$var$errorBuffer, state);
    $17feebe57b9f627f$var$destroy.call(this, err, cb);
    return this;
};
$17feebe57b9f627f$var$Writable.prototype._undestroy = $1Gyoe.undestroy;
$17feebe57b9f627f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$17feebe57b9f627f$var$Writable.prototype[$17feebe57b9f627f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $17feebe57b9f627f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $17feebe57b9f627f$var$lazyWebStreams() {
    if ($17feebe57b9f627f$var$webStreamsAdapters === undefined) $17feebe57b9f627f$var$webStreamsAdapters = {};
    return $17feebe57b9f627f$var$webStreamsAdapters;
}
$17feebe57b9f627f$var$Writable.fromWeb = function(writableStream, options) {
    return $17feebe57b9f627f$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$17feebe57b9f627f$var$Writable.toWeb = function(streamWritable) {
    return $17feebe57b9f627f$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hKHJd", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $57t8y = parcelRequire("57t8y");

var $eCt0N = parcelRequire("eCt0N");
var $cec8a71350b10715$var$isReadable = $eCt0N.isReadable, $cec8a71350b10715$var$isWritable = $eCt0N.isWritable, $cec8a71350b10715$var$isIterable = $eCt0N.isIterable, $cec8a71350b10715$var$isNodeStream = $eCt0N.isNodeStream, $cec8a71350b10715$var$isReadableNodeStream = $eCt0N.isReadableNodeStream, $cec8a71350b10715$var$isWritableNodeStream = $eCt0N.isWritableNodeStream, $cec8a71350b10715$var$isDuplexNodeStream = $eCt0N.isDuplexNodeStream, $cec8a71350b10715$var$isReadableStream = $eCt0N.isReadableStream, $cec8a71350b10715$var$isWritableStream = $eCt0N.isWritableStream;

var $l7UFF = parcelRequire("l7UFF");

var $7idPE = parcelRequire("7idPE");
var $cec8a71350b10715$var$AbortError = $7idPE.AbortError, $cec8a71350b10715$var$_require_codes = $7idPE.codes, $cec8a71350b10715$var$ERR_INVALID_ARG_TYPE = $cec8a71350b10715$var$_require_codes.ERR_INVALID_ARG_TYPE, $cec8a71350b10715$var$ERR_INVALID_RETURN_VALUE = $cec8a71350b10715$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $1Gyoe = parcelRequire("1Gyoe");
var $cec8a71350b10715$require$destroyer = $1Gyoe.destroyer;

var $9hmsc = parcelRequire("9hmsc");

var $3WXi7 = parcelRequire("3WXi7");

var $23Jcj = parcelRequire("23Jcj");

var $3HJCn = parcelRequire("3HJCn");
var $cec8a71350b10715$require$createDeferredPromise = $3HJCn.createDeferredPromise;

var $hlLIv = parcelRequire("hlLIv");
var $cec8a71350b10715$var$Blob = globalThis.Blob || $57t8y.Blob;
var $cec8a71350b10715$var$isBlob = typeof $cec8a71350b10715$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $cec8a71350b10715$var$Blob;
} : function isBlob(b) {
    return false;
};

var $cec8a71350b10715$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $fEo31 = parcelRequire("fEo31");
var $cec8a71350b10715$require$FunctionPrototypeCall = $fEo31.FunctionPrototypeCall;
// This is needed for pre node 17.
var $cec8a71350b10715$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($9hmsc);
module.exports = function duplexify(body, name) {
    if ($cec8a71350b10715$var$isDuplexNodeStream(body)) return body;
    if ($cec8a71350b10715$var$isReadableNodeStream(body)) return $cec8a71350b10715$var$_duplexify({
        readable: body
    });
    if ($cec8a71350b10715$var$isWritableNodeStream(body)) return $cec8a71350b10715$var$_duplexify({
        writable: body
    });
    if ($cec8a71350b10715$var$isNodeStream(body)) return $cec8a71350b10715$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($cec8a71350b10715$var$isReadableStream(body)) return $cec8a71350b10715$var$_duplexify({
        readable: $3WXi7.fromWeb(body)
    });
    if ($cec8a71350b10715$var$isWritableStream(body)) return $cec8a71350b10715$var$_duplexify({
        writable: $23Jcj.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $cec8a71350b10715$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($cec8a71350b10715$var$isIterable(value)) return $hlLIv($cec8a71350b10715$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $cec8a71350b10715$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $cec8a71350b10715$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $cec8a71350b10715$require$destroyer(d, err);
            });
            return d = new $cec8a71350b10715$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $cec8a71350b10715$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($cec8a71350b10715$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($cec8a71350b10715$var$isIterable(body)) return $hlLIv($cec8a71350b10715$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($cec8a71350b10715$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $cec8a71350b10715$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $cec8a71350b10715$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $cec8a71350b10715$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $cec8a71350b10715$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $cec8a71350b10715$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $cec8a71350b10715$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $cec8a71350b10715$require$destroyer(d1, err);
        });
        return d1 = new $cec8a71350b10715$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $cec8a71350b10715$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $cec8a71350b10715$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $cec8a71350b10715$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $cec8a71350b10715$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $cec8a71350b10715$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $cec8a71350b10715$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $cec8a71350b10715$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $3WXi7.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$cec8a71350b10715$var$isReadable(r);
    var writable = !!$cec8a71350b10715$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $cec8a71350b10715$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $l7UFF(w, function(err) {
            writable = false;
            if (err) $cec8a71350b10715$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $l7UFF(r, function(err) {
            readable = false;
            if (err) $cec8a71350b10715$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $cec8a71350b10715$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $cec8a71350b10715$require$destroyer(w, err);
            $cec8a71350b10715$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("9bpTR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $6af93b57f83c892e$require$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf;
module.exports = $6af93b57f83c892e$var$PassThrough;

var $blkYa = parcelRequire("blkYa");
$6af93b57f83c892e$require$ObjectSetPrototypeOf($6af93b57f83c892e$var$PassThrough.prototype, $blkYa.prototype);
$6af93b57f83c892e$require$ObjectSetPrototypeOf($6af93b57f83c892e$var$PassThrough, $blkYa);
function $6af93b57f83c892e$var$PassThrough(options) {
    if (!(this instanceof $6af93b57f83c892e$var$PassThrough)) return new $6af93b57f83c892e$var$PassThrough(options);
    $blkYa.call(this, options);
}
$6af93b57f83c892e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("blkYa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $8421ebf3f5b22d28$var$ObjectSetPrototypeOf = $fEo31.ObjectSetPrototypeOf, $8421ebf3f5b22d28$var$Symbol = $fEo31.Symbol;
module.exports = $8421ebf3f5b22d28$var$Transform;

var $8421ebf3f5b22d28$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("7idPE")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $9hmsc = parcelRequire("9hmsc");

var $b6kaZ = parcelRequire("b6kaZ");
var $8421ebf3f5b22d28$require$getHighWaterMark = $b6kaZ.getHighWaterMark;
$8421ebf3f5b22d28$var$ObjectSetPrototypeOf($8421ebf3f5b22d28$var$Transform.prototype, $9hmsc.prototype);
$8421ebf3f5b22d28$var$ObjectSetPrototypeOf($8421ebf3f5b22d28$var$Transform, $9hmsc);
var $8421ebf3f5b22d28$var$kCallback = $8421ebf3f5b22d28$var$Symbol('kCallback');
function $8421ebf3f5b22d28$var$Transform(options) {
    if (!(this instanceof $8421ebf3f5b22d28$var$Transform)) return new $8421ebf3f5b22d28$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $8421ebf3f5b22d28$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $9hmsc.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8421ebf3f5b22d28$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8421ebf3f5b22d28$var$prefinish);
}
function $8421ebf3f5b22d28$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8421ebf3f5b22d28$var$prefinish() {
    if (this._final !== $8421ebf3f5b22d28$var$_final) $8421ebf3f5b22d28$var$_final.call(this);
}
$8421ebf3f5b22d28$var$Transform.prototype._final = $8421ebf3f5b22d28$var$_final;
$8421ebf3f5b22d28$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8421ebf3f5b22d28$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8421ebf3f5b22d28$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$8421ebf3f5b22d28$var$kCallback] = callback;
    });
};
$8421ebf3f5b22d28$var$Transform.prototype._read = function() {
    if (this[$8421ebf3f5b22d28$var$kCallback]) {
        var callback = this[$8421ebf3f5b22d28$var$kCallback];
        this[$8421ebf3f5b22d28$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("kmzCv", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fEo31 = parcelRequire("fEo31");
var $ed317e1a8b3d28dc$var$ArrayPrototypePop = $fEo31.ArrayPrototypePop, $ed317e1a8b3d28dc$var$Promise = $fEo31.Promise;

var $eCt0N = parcelRequire("eCt0N");
var $ed317e1a8b3d28dc$var$isIterable = $eCt0N.isIterable, $ed317e1a8b3d28dc$var$isNodeStream = $eCt0N.isNodeStream, $ed317e1a8b3d28dc$var$isWebStream = $eCt0N.isWebStream;

var $azeRi = parcelRequire("azeRi");
var $ed317e1a8b3d28dc$var$pl = $azeRi.pipelineImpl;

var $l7UFF = parcelRequire("l7UFF");
var $ed317e1a8b3d28dc$require$finished = $l7UFF.finished;
parcelRequire("a5eKe");
function $ed317e1a8b3d28dc$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $ed317e1a8b3d28dc$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$ed317e1a8b3d28dc$var$isNodeStream(lastArg) && !$ed317e1a8b3d28dc$var$isIterable(lastArg) && !$ed317e1a8b3d28dc$var$isWebStream(lastArg)) {
            var options = $ed317e1a8b3d28dc$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $ed317e1a8b3d28dc$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $ed317e1a8b3d28dc$require$finished,
    pipeline: $ed317e1a8b3d28dc$var$pipeline
};

});





parcelRegister("8YZmf", function(module, exports) {
"use strict";
var $68a385b5317936ef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $68a385b5317936ef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $68a385b5317936ef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$68a385b5317936ef$var$__exportStar((parcelRequire("g1hpK")), module.exports);

});
parcelRegister("g1hpK", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlCsv = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $8DEjG = parcelRequire("8DEjG");
/**
 * A comunica SPARQL CSV Query Result Serialize Actor.
 */ var $ba9a3f6e338876c6$var$ActorQueryResultSerializeSparqlCsv = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeSparqlCsv, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeSparqlCsv(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeSparqlCsv);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeSparqlCsv, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeSparqlCsv, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.type !== 'bindings') return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var bindingsAction, data, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                bindingsAction = action;
                                data = new $8DEjG.Readable();
                                return [
                                    4,
                                    bindingsAction.metadata()
                                ];
                            case 1:
                                metadata = _state.sent();
                                // Write head
                                data.push("".concat(metadata.variables.map(function(variable) {
                                    return variable.variable.value;
                                }).join(','), "\r\n"));
                                // Write body
                                data.wrap(bindingsAction.bindingsStream.map(function(bindings) {
                                    return "".concat(metadata.variables.map(function(key) {
                                        return ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(bindings.get(key.variable));
                                    }).join(','), "\r\n");
                                }));
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "bindingToCsvBindings",
            value: /**
     * Converts an RDF term to its CSV representation.
     * @param {RDF.Term} value An RDF term.
     * @return {string} A string representation of the given value.
     */ function bindingToCsvBindings(value) {
                if (!value) return '';
                var stringValue = value.value;
                if (value.termType === 'Literal') // This is a lossy representation, since language and datatype are not encoded in here.
                stringValue = "".concat(stringValue);
                else if (value.termType === 'BlankNode') stringValue = "_:".concat(stringValue);
                else if (value.termType === 'Quad') {
                    var object = ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.object);
                    if (value.object.termType === 'Literal') // If object is a literal, it must be put in quotes, and internal quotes must be escaped
                    object = '"'.concat(object.replaceAll('"', '""'), '"');
                    stringValue = "<< ".concat(ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.subject), " ").concat(ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.predicate), " ").concat(object, " >>");
                } else stringValue = "<".concat(stringValue, ">");
                // If a value contains certain characters, put it between double quotes
                if (RegExp('[",\\n\\r]', "u").test(stringValue)) // Within quote strings, " is written using a pair of quotation marks "".
                stringValue = '"'.concat(stringValue.replaceAll('"', '""'), '"');
                return stringValue;
            }
        }
    ]);
    return ActorQueryResultSerializeSparqlCsv;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeSparqlCsv = $ba9a3f6e338876c6$var$ActorQueryResultSerializeSparqlCsv;

});
parcelRegister("8DEjG", function(module, exports) {
'use strict';

var $AXlQY = parcelRequire("AXlQY");

var $hmVGK = parcelRequire("hmVGK");
var $64a13d43b00033f2$var$originalDestroy = $AXlQY.Readable.destroy;
module.exports = $AXlQY.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $AXlQY._uint8ArrayToBuffer;
module.exports._isUint8Array = $AXlQY._isUint8Array;
module.exports.isDisturbed = $AXlQY.isDisturbed;
module.exports.isErrored = $AXlQY.isErrored;
module.exports.isReadable = $AXlQY.isReadable;
module.exports.Readable = $AXlQY.Readable;
module.exports.Writable = $AXlQY.Writable;
module.exports.Duplex = $AXlQY.Duplex;
module.exports.Transform = $AXlQY.Transform;
module.exports.PassThrough = $AXlQY.PassThrough;
module.exports.addAbortSignal = $AXlQY.addAbortSignal;
module.exports.finished = $AXlQY.finished;
module.exports.destroy = $AXlQY.destroy;
module.exports.destroy = $64a13d43b00033f2$var$originalDestroy;
module.exports.pipeline = $AXlQY.pipeline;
module.exports.compose = $AXlQY.compose;
Object.defineProperty($AXlQY, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $hmVGK;
    }
});
module.exports.Stream = $AXlQY.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("AXlQY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $gywOi = parcelRequire("gywOi");
var $06f166dfca949c4d$require$Buffer = $gywOi.Buffer;

var $01kWT = parcelRequire("01kWT");
/* replacement end */ var $06f166dfca949c4d$var$ObjectDefineProperty = $01kWT.ObjectDefineProperty, $06f166dfca949c4d$var$ObjectKeys = $01kWT.ObjectKeys, $06f166dfca949c4d$var$ReflectApply = $01kWT.ReflectApply;

var $f6h6y = parcelRequire("f6h6y");
var $06f166dfca949c4d$var$_require_promisify = $f6h6y.promisify, $06f166dfca949c4d$var$customPromisify = $06f166dfca949c4d$var$_require_promisify.custom;

var $xIQnH = parcelRequire("xIQnH");
var $06f166dfca949c4d$var$streamReturningOperators = $xIQnH.streamReturningOperators, $06f166dfca949c4d$var$promiseReturningOperators = $xIQnH.promiseReturningOperators;

var $bsbC4 = parcelRequire("bsbC4");
var $06f166dfca949c4d$var$ERR_ILLEGAL_CONSTRUCTOR = $bsbC4.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $b9Axa = parcelRequire("b9Axa");

var $4dlVb = parcelRequire("4dlVb");
var $06f166dfca949c4d$var$setDefaultHighWaterMark = $4dlVb.setDefaultHighWaterMark, $06f166dfca949c4d$var$getDefaultHighWaterMark = $4dlVb.getDefaultHighWaterMark;

var $eMv1z = parcelRequire("eMv1z");
var $06f166dfca949c4d$require$pipeline = $eMv1z.pipeline;

var $329Hf = parcelRequire("329Hf");
var $06f166dfca949c4d$require$destroyer = $329Hf.destroyer;

var $2KEat = parcelRequire("2KEat");
var $06f166dfca949c4d$var$internalBuffer = {};

var $hmVGK = parcelRequire("hmVGK");

var $2VP5Y = parcelRequire("2VP5Y");

var $06f166dfca949c4d$var$Stream = module.exports = (parcelRequire("7eOXa")).Stream;
$06f166dfca949c4d$var$Stream.isDestroyed = $2VP5Y.isDestroyed;
$06f166dfca949c4d$var$Stream.isDisturbed = $2VP5Y.isDisturbed;
$06f166dfca949c4d$var$Stream.isErrored = $2VP5Y.isErrored;
$06f166dfca949c4d$var$Stream.isReadable = $2VP5Y.isReadable;
$06f166dfca949c4d$var$Stream.isWritable = $2VP5Y.isWritable;

$06f166dfca949c4d$var$Stream.Readable = (parcelRequire("9Dgc3"));
var $06f166dfca949c4d$var$_iteratorNormalCompletion = true, $06f166dfca949c4d$var$_didIteratorError = false, $06f166dfca949c4d$var$_iteratorError = undefined;
try {
    for(var $06f166dfca949c4d$var$_iterator = $06f166dfca949c4d$var$ObjectKeys($06f166dfca949c4d$var$streamReturningOperators)[Symbol.iterator](), $06f166dfca949c4d$var$_step; !($06f166dfca949c4d$var$_iteratorNormalCompletion = ($06f166dfca949c4d$var$_step = $06f166dfca949c4d$var$_iterator.next()).done); $06f166dfca949c4d$var$_iteratorNormalCompletion = true){
        var $06f166dfca949c4d$var$key = $06f166dfca949c4d$var$_step.value;
        var $06f166dfca949c4d$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $06f166dfca949c4d$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $06f166dfca949c4d$var$Stream.Readable.from($06f166dfca949c4d$var$ReflectApply($06f166dfca949c4d$var$op, this, args));
        };
        var $06f166dfca949c4d$var$op = $06f166dfca949c4d$var$streamReturningOperators[$06f166dfca949c4d$var$key];
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$fn, 'name', {
            __proto__: null,
            value: $06f166dfca949c4d$var$op.name
        });
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$fn, 'length', {
            __proto__: null,
            value: $06f166dfca949c4d$var$op.length
        });
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$Stream.Readable.prototype, $06f166dfca949c4d$var$key, {
            __proto__: null,
            value: $06f166dfca949c4d$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $06f166dfca949c4d$var$_didIteratorError = true;
    $06f166dfca949c4d$var$_iteratorError = err;
} finally{
    try {
        if (!$06f166dfca949c4d$var$_iteratorNormalCompletion && $06f166dfca949c4d$var$_iterator["return"] != null) {
            $06f166dfca949c4d$var$_iterator["return"]();
        }
    } finally{
        if ($06f166dfca949c4d$var$_didIteratorError) {
            throw $06f166dfca949c4d$var$_iteratorError;
        }
    }
}
var $06f166dfca949c4d$var$_iteratorNormalCompletion1 = true, $06f166dfca949c4d$var$_didIteratorError1 = false, $06f166dfca949c4d$var$_iteratorError1 = undefined;
try {
    for(var $06f166dfca949c4d$var$_iterator1 = $06f166dfca949c4d$var$ObjectKeys($06f166dfca949c4d$var$promiseReturningOperators)[Symbol.iterator](), $06f166dfca949c4d$var$_step1; !($06f166dfca949c4d$var$_iteratorNormalCompletion1 = ($06f166dfca949c4d$var$_step1 = $06f166dfca949c4d$var$_iterator1.next()).done); $06f166dfca949c4d$var$_iteratorNormalCompletion1 = true){
        var $06f166dfca949c4d$var$key1 = $06f166dfca949c4d$var$_step1.value;
        var $06f166dfca949c4d$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $06f166dfca949c4d$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $06f166dfca949c4d$var$ReflectApply($06f166dfca949c4d$var$op1, this, args);
        };
        var $06f166dfca949c4d$var$op1 = $06f166dfca949c4d$var$promiseReturningOperators[$06f166dfca949c4d$var$key1];
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$fn1, 'name', {
            __proto__: null,
            value: $06f166dfca949c4d$var$op1.name
        });
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$fn1, 'length', {
            __proto__: null,
            value: $06f166dfca949c4d$var$op1.length
        });
        $06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$Stream.Readable.prototype, $06f166dfca949c4d$var$key1, {
            __proto__: null,
            value: $06f166dfca949c4d$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $06f166dfca949c4d$var$_didIteratorError1 = true;
    $06f166dfca949c4d$var$_iteratorError1 = err;
} finally{
    try {
        if (!$06f166dfca949c4d$var$_iteratorNormalCompletion1 && $06f166dfca949c4d$var$_iterator1["return"] != null) {
            $06f166dfca949c4d$var$_iterator1["return"]();
        }
    } finally{
        if ($06f166dfca949c4d$var$_didIteratorError1) {
            throw $06f166dfca949c4d$var$_iteratorError1;
        }
    }
}

$06f166dfca949c4d$var$Stream.Writable = (parcelRequire("3x7Uf"));

$06f166dfca949c4d$var$Stream.Duplex = (parcelRequire("itmui"));

$06f166dfca949c4d$var$Stream.Transform = (parcelRequire("fJjUG"));

$06f166dfca949c4d$var$Stream.PassThrough = (parcelRequire("iNbiQ"));
$06f166dfca949c4d$var$Stream.pipeline = $06f166dfca949c4d$require$pipeline;

var $glIk8 = parcelRequire("glIk8");
var $06f166dfca949c4d$require$addAbortSignal = $glIk8.addAbortSignal;
$06f166dfca949c4d$var$Stream.addAbortSignal = $06f166dfca949c4d$require$addAbortSignal;
$06f166dfca949c4d$var$Stream.finished = $2KEat;
$06f166dfca949c4d$var$Stream.destroy = $06f166dfca949c4d$require$destroyer;
$06f166dfca949c4d$var$Stream.compose = $b9Axa;
$06f166dfca949c4d$var$Stream.setDefaultHighWaterMark = $06f166dfca949c4d$var$setDefaultHighWaterMark;
$06f166dfca949c4d$var$Stream.getDefaultHighWaterMark = $06f166dfca949c4d$var$getDefaultHighWaterMark;
$06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $hmVGK;
    }
});
$06f166dfca949c4d$var$ObjectDefineProperty($06f166dfca949c4d$require$pipeline, $06f166dfca949c4d$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $hmVGK.pipeline;
    }
});
$06f166dfca949c4d$var$ObjectDefineProperty($2KEat, $06f166dfca949c4d$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $hmVGK.finished;
    }
});
// Backwards-compat with node 0.4.x
$06f166dfca949c4d$var$Stream.Stream = $06f166dfca949c4d$var$Stream;
$06f166dfca949c4d$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$06f166dfca949c4d$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $06f166dfca949c4d$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("gywOi", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c0d945c4c0be1eca$export$a143d493d941bafc; }, function (v) { return $c0d945c4c0be1eca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c0d945c4c0be1eca$export$f99ded8fe4b79145; }, function (v) { return $c0d945c4c0be1eca$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $c0d945c4c0be1eca$export$a143d493d941bafc;
var $c0d945c4c0be1eca$export$e4cf37d7f6fb9e0a;
var $c0d945c4c0be1eca$export$f99ded8fe4b79145;
var $c0d945c4c0be1eca$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $c0d945c4c0be1eca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c0d945c4c0be1eca$export$a143d493d941bafc = $c0d945c4c0be1eca$var$Buffer;
$c0d945c4c0be1eca$export$e4cf37d7f6fb9e0a = $c0d945c4c0be1eca$var$SlowBuffer;
$c0d945c4c0be1eca$export$f99ded8fe4b79145 = 50;
var $c0d945c4c0be1eca$var$K_MAX_LENGTH = 0x7fffffff;
$c0d945c4c0be1eca$export$599f31c3813fae4d = $c0d945c4c0be1eca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c0d945c4c0be1eca$var$Buffer.TYPED_ARRAY_SUPPORT = $c0d945c4c0be1eca$var$typedArraySupport();
if (!$c0d945c4c0be1eca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c0d945c4c0be1eca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c0d945c4c0be1eca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c0d945c4c0be1eca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c0d945c4c0be1eca$var$createBuffer(length) {
    if (length > $c0d945c4c0be1eca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c0d945c4c0be1eca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c0d945c4c0be1eca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c0d945c4c0be1eca$var$allocUnsafe(arg);
    }
    return $c0d945c4c0be1eca$var$from(arg, encodingOrOffset, length);
}
$c0d945c4c0be1eca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c0d945c4c0be1eca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c0d945c4c0be1eca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c0d945c4c0be1eca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($c0d945c4c0be1eca$var$isInstance(value, ArrayBuffer) || value && $c0d945c4c0be1eca$var$isInstance(value.buffer, ArrayBuffer)) return $c0d945c4c0be1eca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c0d945c4c0be1eca$var$isInstance(value, SharedArrayBuffer) || value && $c0d945c4c0be1eca$var$isInstance(value.buffer, SharedArrayBuffer))) return $c0d945c4c0be1eca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c0d945c4c0be1eca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c0d945c4c0be1eca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c0d945c4c0be1eca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c0d945c4c0be1eca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c0d945c4c0be1eca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c0d945c4c0be1eca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c0d945c4c0be1eca$var$Buffer, Uint8Array);
function $c0d945c4c0be1eca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c0d945c4c0be1eca$var$alloc(size, fill, encoding) {
    $c0d945c4c0be1eca$var$assertSize(size);
    if (size <= 0) return $c0d945c4c0be1eca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c0d945c4c0be1eca$var$createBuffer(size).fill(fill, encoding) : $c0d945c4c0be1eca$var$createBuffer(size).fill(fill);
    return $c0d945c4c0be1eca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c0d945c4c0be1eca$var$Buffer.alloc = function(size, fill, encoding) {
    return $c0d945c4c0be1eca$var$alloc(size, fill, encoding);
};
function $c0d945c4c0be1eca$var$allocUnsafe(size) {
    $c0d945c4c0be1eca$var$assertSize(size);
    return $c0d945c4c0be1eca$var$createBuffer(size < 0 ? 0 : $c0d945c4c0be1eca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c0d945c4c0be1eca$var$Buffer.allocUnsafe = function(size) {
    return $c0d945c4c0be1eca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c0d945c4c0be1eca$var$Buffer.allocUnsafeSlow = function(size) {
    return $c0d945c4c0be1eca$var$allocUnsafe(size);
};
function $c0d945c4c0be1eca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c0d945c4c0be1eca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $c0d945c4c0be1eca$var$byteLength(string, encoding) | 0;
    var buf = $c0d945c4c0be1eca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c0d945c4c0be1eca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c0d945c4c0be1eca$var$checked(array.length) | 0;
    var buf = $c0d945c4c0be1eca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c0d945c4c0be1eca$var$fromArrayView(arrayView) {
    if ($c0d945c4c0be1eca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c0d945c4c0be1eca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c0d945c4c0be1eca$var$fromArrayLike(arrayView);
}
function $c0d945c4c0be1eca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c0d945c4c0be1eca$var$Buffer.prototype);
    return buf;
}
function $c0d945c4c0be1eca$var$fromObject(obj) {
    if ($c0d945c4c0be1eca$var$Buffer.isBuffer(obj)) {
        var len = $c0d945c4c0be1eca$var$checked(obj.length) | 0;
        var buf = $c0d945c4c0be1eca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c0d945c4c0be1eca$var$numberIsNaN(obj.length)) return $c0d945c4c0be1eca$var$createBuffer(0);
        return $c0d945c4c0be1eca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c0d945c4c0be1eca$var$fromArrayLike(obj.data);
}
function $c0d945c4c0be1eca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c0d945c4c0be1eca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c0d945c4c0be1eca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c0d945c4c0be1eca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c0d945c4c0be1eca$var$Buffer.alloc(+length);
}
$c0d945c4c0be1eca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c0d945c4c0be1eca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c0d945c4c0be1eca$var$Buffer.compare = function compare(a, b) {
    if ($c0d945c4c0be1eca$var$isInstance(a, Uint8Array)) a = $c0d945c4c0be1eca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c0d945c4c0be1eca$var$isInstance(b, Uint8Array)) b = $c0d945c4c0be1eca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(a) || !$c0d945c4c0be1eca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c0d945c4c0be1eca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c0d945c4c0be1eca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c0d945c4c0be1eca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c0d945c4c0be1eca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c0d945c4c0be1eca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(buf)) buf = $c0d945c4c0be1eca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c0d945c4c0be1eca$var$byteLength(string, encoding) {
    if ($c0d945c4c0be1eca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c0d945c4c0be1eca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c0d945c4c0be1eca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c0d945c4c0be1eca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c0d945c4c0be1eca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c0d945c4c0be1eca$var$Buffer.byteLength = $c0d945c4c0be1eca$var$byteLength;
function $c0d945c4c0be1eca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c0d945c4c0be1eca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c0d945c4c0be1eca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c0d945c4c0be1eca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c0d945c4c0be1eca$var$latin1Slice(this, start, end);
        case 'base64':
            return $c0d945c4c0be1eca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c0d945c4c0be1eca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c0d945c4c0be1eca$var$Buffer.prototype._isBuffer = true;
function $c0d945c4c0be1eca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c0d945c4c0be1eca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$c0d945c4c0be1eca$var$swap(this, i, i + 1);
    return this;
};
$c0d945c4c0be1eca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $c0d945c4c0be1eca$var$swap(this, i, i + 3);
        $c0d945c4c0be1eca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c0d945c4c0be1eca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $c0d945c4c0be1eca$var$swap(this, i, i + 7);
        $c0d945c4c0be1eca$var$swap(this, i + 1, i + 6);
        $c0d945c4c0be1eca$var$swap(this, i + 2, i + 5);
        $c0d945c4c0be1eca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c0d945c4c0be1eca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c0d945c4c0be1eca$var$utf8Slice(this, 0, length);
    return $c0d945c4c0be1eca$var$slowToString.apply(this, arguments);
};
$c0d945c4c0be1eca$var$Buffer.prototype.toLocaleString = $c0d945c4c0be1eca$var$Buffer.prototype.toString;
$c0d945c4c0be1eca$var$Buffer.prototype.equals = function equals(b) {
    if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c0d945c4c0be1eca$var$Buffer.compare(this, b) === 0;
};
$c0d945c4c0be1eca$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $c0d945c4c0be1eca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c0d945c4c0be1eca$var$customInspectSymbol) $c0d945c4c0be1eca$var$Buffer.prototype[$c0d945c4c0be1eca$var$customInspectSymbol] = $c0d945c4c0be1eca$var$Buffer.prototype.inspect;
$c0d945c4c0be1eca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c0d945c4c0be1eca$var$isInstance(target, Uint8Array)) target = $c0d945c4c0be1eca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c0d945c4c0be1eca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c0d945c4c0be1eca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c0d945c4c0be1eca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c0d945c4c0be1eca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c0d945c4c0be1eca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c0d945c4c0be1eca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c0d945c4c0be1eca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c0d945c4c0be1eca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c0d945c4c0be1eca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c0d945c4c0be1eca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c0d945c4c0be1eca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c0d945c4c0be1eca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c0d945c4c0be1eca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c0d945c4c0be1eca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c0d945c4c0be1eca$var$utf8Write(buf, string, offset, length) {
    return $c0d945c4c0be1eca$var$blitBuffer($c0d945c4c0be1eca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c0d945c4c0be1eca$var$asciiWrite(buf, string, offset, length) {
    return $c0d945c4c0be1eca$var$blitBuffer($c0d945c4c0be1eca$var$asciiToBytes(string), buf, offset, length);
}
function $c0d945c4c0be1eca$var$base64Write(buf, string, offset, length) {
    return $c0d945c4c0be1eca$var$blitBuffer($c0d945c4c0be1eca$var$base64ToBytes(string), buf, offset, length);
}
function $c0d945c4c0be1eca$var$ucs2Write(buf, string, offset, length) {
    return $c0d945c4c0be1eca$var$blitBuffer($c0d945c4c0be1eca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c0d945c4c0be1eca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c0d945c4c0be1eca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c0d945c4c0be1eca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c0d945c4c0be1eca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c0d945c4c0be1eca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c0d945c4c0be1eca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c0d945c4c0be1eca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c0d945c4c0be1eca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $c0d945c4c0be1eca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c0d945c4c0be1eca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c0d945c4c0be1eca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c0d945c4c0be1eca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c0d945c4c0be1eca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c0d945c4c0be1eca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c0d945c4c0be1eca$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c0d945c4c0be1eca$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c0d945c4c0be1eca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $c0d945c4c0be1eca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c0d945c4c0be1eca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c0d945c4c0be1eca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c0d945c4c0be1eca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c0d945c4c0be1eca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c0d945c4c0be1eca$var$Buffer.prototype.readUintLE = $c0d945c4c0be1eca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUintBE = $c0d945c4c0be1eca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUint8 = $c0d945c4c0be1eca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUint16LE = $c0d945c4c0be1eca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUint16BE = $c0d945c4c0be1eca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUint32LE = $c0d945c4c0be1eca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readUint32BE = $c0d945c4c0be1eca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c0d945c4c0be1eca$var$Buffer.prototype.readBigUInt64LE = $c0d945c4c0be1eca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c0d945c4c0be1eca$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d945c4c0be1eca$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c0d945c4c0be1eca$var$Buffer.prototype.readBigUInt64BE = $c0d945c4c0be1eca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c0d945c4c0be1eca$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d945c4c0be1eca$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c0d945c4c0be1eca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c0d945c4c0be1eca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c0d945c4c0be1eca$var$Buffer.prototype.readBigInt64LE = $c0d945c4c0be1eca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c0d945c4c0be1eca$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d945c4c0be1eca$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$c0d945c4c0be1eca$var$Buffer.prototype.readBigInt64BE = $c0d945c4c0be1eca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c0d945c4c0be1eca$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d945c4c0be1eca$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$c0d945c4c0be1eca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$c0d945c4c0be1eca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$c0d945c4c0be1eca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$c0d945c4c0be1eca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $c0d945c4c0be1eca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c0d945c4c0be1eca$var$Buffer.prototype.writeUintLE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0d945c4c0be1eca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUintBE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0d945c4c0be1eca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUint8 = $c0d945c4c0be1eca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUint16LE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUint16BE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUint32LE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeUint32BE = $c0d945c4c0be1eca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c0d945c4c0be1eca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c0d945c4c0be1eca$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c0d945c4c0be1eca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c0d945c4c0be1eca$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c0d945c4c0be1eca$var$Buffer.prototype.writeBigUInt64LE = $c0d945c4c0be1eca$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c0d945c4c0be1eca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c0d945c4c0be1eca$var$Buffer.prototype.writeBigUInt64BE = $c0d945c4c0be1eca$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c0d945c4c0be1eca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c0d945c4c0be1eca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c0d945c4c0be1eca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c0d945c4c0be1eca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeBigInt64LE = $c0d945c4c0be1eca$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c0d945c4c0be1eca$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c0d945c4c0be1eca$var$Buffer.prototype.writeBigInt64BE = $c0d945c4c0be1eca$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c0d945c4c0be1eca$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c0d945c4c0be1eca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c0d945c4c0be1eca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c0d945c4c0be1eca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c0d945c4c0be1eca$var$writeFloat(this, value, offset, true, noAssert);
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c0d945c4c0be1eca$var$writeFloat(this, value, offset, false, noAssert);
};
function $c0d945c4c0be1eca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d945c4c0be1eca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c0d945c4c0be1eca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c0d945c4c0be1eca$var$writeDouble(this, value, offset, true, noAssert);
};
$c0d945c4c0be1eca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c0d945c4c0be1eca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c0d945c4c0be1eca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c0d945c4c0be1eca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c0d945c4c0be1eca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c0d945c4c0be1eca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c0d945c4c0be1eca$var$Buffer.isBuffer(val) ? val : $c0d945c4c0be1eca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $c0d945c4c0be1eca$var$errors = {};
function $c0d945c4c0be1eca$var$E(sym, getMessage, Base) {
    $c0d945c4c0be1eca$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$c0d945c4c0be1eca$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c0d945c4c0be1eca$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$c0d945c4c0be1eca$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $c0d945c4c0be1eca$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $c0d945c4c0be1eca$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $c0d945c4c0be1eca$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $c0d945c4c0be1eca$var$checkBounds(buf, offset, byteLength) {
    $c0d945c4c0be1eca$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c0d945c4c0be1eca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c0d945c4c0be1eca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $c0d945c4c0be1eca$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c0d945c4c0be1eca$var$checkBounds(buf, offset, byteLength);
}
function $c0d945c4c0be1eca$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c0d945c4c0be1eca$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c0d945c4c0be1eca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c0d945c4c0be1eca$var$validateNumber(value, type);
        throw new $c0d945c4c0be1eca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c0d945c4c0be1eca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c0d945c4c0be1eca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $c0d945c4c0be1eca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c0d945c4c0be1eca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c0d945c4c0be1eca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c0d945c4c0be1eca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c0d945c4c0be1eca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c0d945c4c0be1eca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c0d945c4c0be1eca$var$base64ToBytes(str) {
    return $abUaD.toByteArray($c0d945c4c0be1eca$var$base64clean(str));
}
function $c0d945c4c0be1eca$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c0d945c4c0be1eca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c0d945c4c0be1eca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c0d945c4c0be1eca$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c0d945c4c0be1eca$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c0d945c4c0be1eca$var$BufferBigIntNotDefined : fn;
}
function $c0d945c4c0be1eca$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("01kWT", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $00405822ae43a83d$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $00405822ae43a83d$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("f6h6y", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $gywOi = parcelRequire("gywOi");

var $7w4Rm = parcelRequire("7w4Rm");
var $afe4af2ff61c2340$var$format = $7w4Rm.format, $afe4af2ff61c2340$var$inspect = $7w4Rm.inspect;

var $bsbC4 = parcelRequire("bsbC4");
var $afe4af2ff61c2340$var$ERR_INVALID_ARG_TYPE = $bsbC4.codes.ERR_INVALID_ARG_TYPE;

var $01kWT = parcelRequire("01kWT");
var $afe4af2ff61c2340$var$kResistStopPropagation = $01kWT.kResistStopPropagation, $afe4af2ff61c2340$var$AggregateError = $01kWT.AggregateError, $afe4af2ff61c2340$var$SymbolDispose = $01kWT.SymbolDispose;

var $afe4af2ff61c2340$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $afe4af2ff61c2340$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $afe4af2ff61c2340$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $afe4af2ff61c2340$var$Blob = globalThis.Blob || $gywOi.Blob;
/* eslint-disable indent */ var $afe4af2ff61c2340$var$isBlob = typeof $afe4af2ff61c2340$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $afe4af2ff61c2340$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $afe4af2ff61c2340$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $afe4af2ff61c2340$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $afe4af2ff61c2340$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $afe4af2ff61c2340$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $afe4af2ff61c2340$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $afe4af2ff61c2340$var$format,
    inspect: $afe4af2ff61c2340$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $afe4af2ff61c2340$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $afe4af2ff61c2340$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $afe4af2ff61c2340$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $afe4af2ff61c2340$var$validateAbortSignal(signal, 'signal');
        $afe4af2ff61c2340$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $afe4af2ff61c2340$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $afe4af2ff61c2340$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $afe4af2ff61c2340$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $afe4af2ff61c2340$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $afe4af2ff61c2340$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("7w4Rm", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("bsbC4", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $7w4Rm = parcelRequire("7w4Rm");
var $856b5150fa05045e$var$format = $7w4Rm.format, $856b5150fa05045e$var$inspect = $7w4Rm.inspect;

var $01kWT = parcelRequire("01kWT");
var $856b5150fa05045e$var$CustomAggregateError = $01kWT.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $856b5150fa05045e$var$AggregateError = globalThis.AggregateError || $856b5150fa05045e$var$CustomAggregateError;
var $856b5150fa05045e$var$kIsNodeError = Symbol('kIsNodeError');
var $856b5150fa05045e$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $856b5150fa05045e$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $856b5150fa05045e$var$nodeInternalPrefix = '__node_internal_';
var $856b5150fa05045e$var$codes = {};
function $856b5150fa05045e$var$assert(value, message) {
    if (!value) throw new $856b5150fa05045e$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $856b5150fa05045e$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $856b5150fa05045e$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $856b5150fa05045e$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $856b5150fa05045e$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $856b5150fa05045e$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $856b5150fa05045e$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $856b5150fa05045e$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$856b5150fa05045e$var$kIsNodeError] = true;
    $856b5150fa05045e$var$codes[code] = NodeError;
}
function $856b5150fa05045e$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $856b5150fa05045e$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $856b5150fa05045e$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $856b5150fa05045e$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $856b5150fa05045e$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $856b5150fa05045e$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$856b5150fa05045e$var$E('ERR_ASSERTION', '%s', Error);
$856b5150fa05045e$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $856b5150fa05045e$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $856b5150fa05045e$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($856b5150fa05045e$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($856b5150fa05045e$var$classRegExp.test(value)) instances.push(value);
            else {
                $856b5150fa05045e$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $856b5150fa05045e$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $856b5150fa05045e$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$856b5150fa05045e$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $856b5150fa05045e$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$856b5150fa05045e$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$856b5150fa05045e$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $856b5150fa05045e$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$856b5150fa05045e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $856b5150fa05045e$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $856b5150fa05045e$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $856b5150fa05045e$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $856b5150fa05045e$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$856b5150fa05045e$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$856b5150fa05045e$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$856b5150fa05045e$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$856b5150fa05045e$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$856b5150fa05045e$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$856b5150fa05045e$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$856b5150fa05045e$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$856b5150fa05045e$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$856b5150fa05045e$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$856b5150fa05045e$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$856b5150fa05045e$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $856b5150fa05045e$var$AbortError,
    aggregateTwoErrors: $856b5150fa05045e$var$hideStackFrames($856b5150fa05045e$var$aggregateTwoErrors),
    hideStackFrames: $856b5150fa05045e$var$hideStackFrames,
    codes: $856b5150fa05045e$var$codes
};

});


parcelRegister("xIQnH", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $0655de3cf1999fb0$export$42af8c323be37587; }, function (v) { return $0655de3cf1999fb0$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $0655de3cf1999fb0$export$f405f72c701dad87; }, function (v) { return $0655de3cf1999fb0$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $0655de3cf1999fb0$export$42af8c323be37587;
var $0655de3cf1999fb0$export$f405f72c701dad87;
'use strict';

var $0655de3cf1999fb0$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $bsbC4 = parcelRequire("bsbC4");
var $0655de3cf1999fb0$var$_require_codes = $bsbC4.codes, $0655de3cf1999fb0$var$ERR_INVALID_ARG_VALUE = $0655de3cf1999fb0$var$_require_codes.ERR_INVALID_ARG_VALUE, $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE = $0655de3cf1999fb0$var$_require_codes.ERR_INVALID_ARG_TYPE, $0655de3cf1999fb0$var$ERR_MISSING_ARGS = $0655de3cf1999fb0$var$_require_codes.ERR_MISSING_ARGS, $0655de3cf1999fb0$var$ERR_OUT_OF_RANGE = $0655de3cf1999fb0$var$_require_codes.ERR_OUT_OF_RANGE, $0655de3cf1999fb0$var$AbortError = $bsbC4.AbortError;

var $4Lq9R = parcelRequire("4Lq9R");
var $0655de3cf1999fb0$var$validateAbortSignal = $4Lq9R.validateAbortSignal, $0655de3cf1999fb0$var$validateInteger = $4Lq9R.validateInteger, $0655de3cf1999fb0$var$validateObject = $4Lq9R.validateObject;

var $0655de3cf1999fb0$var$kWeakHandler = (parcelRequire("01kWT")).Symbol('kWeak');

var $0655de3cf1999fb0$var$kResistStopPropagation = (parcelRequire("01kWT")).Symbol('kResistStopPropagation');

var $2KEat = parcelRequire("2KEat");
var $0655de3cf1999fb0$require$finished = $2KEat.finished;

var $b9Axa = parcelRequire("b9Axa");

var $glIk8 = parcelRequire("glIk8");
var $0655de3cf1999fb0$require$addAbortSignalNoValidate = $glIk8.addAbortSignalNoValidate;

var $2VP5Y = parcelRequire("2VP5Y");
var $0655de3cf1999fb0$var$isWritable = $2VP5Y.isWritable, $0655de3cf1999fb0$var$isNodeStream = $2VP5Y.isNodeStream;

var $0655de3cf1999fb0$require$deprecate = (parcelRequire("f6h6y")).deprecate;

var $0655de3cf1999fb0$var$ArrayPrototypePush = (parcelRequire("01kWT")).ArrayPrototypePush, $0655de3cf1999fb0$var$Boolean = (parcelRequire("01kWT")).Boolean, $0655de3cf1999fb0$var$MathFloor = (parcelRequire("01kWT")).MathFloor, $0655de3cf1999fb0$var$Number = (parcelRequire("01kWT")).Number, $0655de3cf1999fb0$var$NumberIsNaN = (parcelRequire("01kWT")).NumberIsNaN, $0655de3cf1999fb0$var$Promise = (parcelRequire("01kWT")).Promise, $0655de3cf1999fb0$var$PromiseReject = (parcelRequire("01kWT")).PromiseReject, $0655de3cf1999fb0$var$PromiseResolve = (parcelRequire("01kWT")).PromiseResolve, $0655de3cf1999fb0$var$PromisePrototypeThen = (parcelRequire("01kWT")).PromisePrototypeThen, $0655de3cf1999fb0$var$Symbol = (parcelRequire("01kWT")).Symbol;
var $0655de3cf1999fb0$var$kEmpty = $0655de3cf1999fb0$var$Symbol('kEmpty');
var $0655de3cf1999fb0$var$kEof = $0655de3cf1999fb0$var$Symbol('kEof');
function $0655de3cf1999fb0$var$compose(stream, options) {
    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
    if ($0655de3cf1999fb0$var$isNodeStream(stream) && !$0655de3cf1999fb0$var$isWritable(stream)) throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $b9Axa(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $0655de3cf1999fb0$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $0655de3cf1999fb0$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $0655de3cf1999fb0$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $0655de3cf1999fb0$var$MathFloor(options.highWaterMark);
    $0655de3cf1999fb0$var$validateInteger(concurrency, 'options.concurrency', 1);
    $0655de3cf1999fb0$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $0655de3cf1999fb0$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $0655de3cf1999fb0$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $0655de3cf1999fb0$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $0655de3cf1999fb0$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $0655de3cf1999fb0$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($0655de3cf1999fb0$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $0655de3cf1999fb0$var$PromiseReject(err1);
                                $0655de3cf1999fb0$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("f6h6y")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($0655de3cf1999fb0$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $0655de3cf1999fb0$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                        if (!(val !== $0655de3cf1999fb0$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $0655de3cf1999fb0$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0655de3cf1999fb0$var$asIndexedPairs(options) {
    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $0655de3cf1999fb0$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0655de3cf1999fb0$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0655de3cf1999fb0$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $0655de3cf1999fb0$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $0655de3cf1999fb0$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $0655de3cf1999fb0$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0655de3cf1999fb0$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $0655de3cf1999fb0$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $0655de3cf1999fb0$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0655de3cf1999fb0$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $0655de3cf1999fb0$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $0655de3cf1999fb0$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $0655de3cf1999fb0$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $0655de3cf1999fb0$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($0655de3cf1999fb0$var$ERR_MISSING_ARGS);
function $0655de3cf1999fb0$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $0655de3cf1999fb0$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $0655de3cf1999fb0$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $0655de3cf1999fb0$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $0655de3cf1999fb0$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $0655de3cf1999fb0$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $0655de3cf1999fb0$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $0655de3cf1999fb0$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0655de3cf1999fb0$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $0655de3cf1999fb0$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $0655de3cf1999fb0$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $0655de3cf1999fb0$var$flatMap(fn, options) {
    var values = $0655de3cf1999fb0$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $0655de3cf1999fb0$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $0655de3cf1999fb0$var$Number(number);
    if ($0655de3cf1999fb0$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $0655de3cf1999fb0$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $0655de3cf1999fb0$var$drop(number, options) {
    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
    number = $0655de3cf1999fb0$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0655de3cf1999fb0$var$take(number, options) {
    if (options != null) $0655de3cf1999fb0$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0655de3cf1999fb0$var$validateAbortSignal(options.signal, 'options.signal');
    number = $0655de3cf1999fb0$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $0655de3cf1999fb0$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$0655de3cf1999fb0$export$42af8c323be37587 = {
    asIndexedPairs: $0655de3cf1999fb0$require$deprecate($0655de3cf1999fb0$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $0655de3cf1999fb0$var$drop,
    filter: $0655de3cf1999fb0$var$filter,
    flatMap: $0655de3cf1999fb0$var$flatMap,
    map: $0655de3cf1999fb0$var$map,
    take: $0655de3cf1999fb0$var$take,
    compose: $0655de3cf1999fb0$var$compose
};
$0655de3cf1999fb0$export$f405f72c701dad87 = {
    every: $0655de3cf1999fb0$var$every,
    forEach: $0655de3cf1999fb0$var$forEach,
    reduce: $0655de3cf1999fb0$var$reduce,
    toArray: $0655de3cf1999fb0$var$toArray,
    some: $0655de3cf1999fb0$var$some,
    find: $0655de3cf1999fb0$var$find
};

});
parcelRegister("4Lq9R", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $377fd7a4219129a5$var$ArrayIsArray = $01kWT.ArrayIsArray, $377fd7a4219129a5$var$ArrayPrototypeIncludes = $01kWT.ArrayPrototypeIncludes, $377fd7a4219129a5$var$ArrayPrototypeJoin = $01kWT.ArrayPrototypeJoin, $377fd7a4219129a5$var$ArrayPrototypeMap = $01kWT.ArrayPrototypeMap, $377fd7a4219129a5$var$NumberIsInteger = $01kWT.NumberIsInteger, $377fd7a4219129a5$var$NumberIsNaN = $01kWT.NumberIsNaN, $377fd7a4219129a5$var$NumberMAX_SAFE_INTEGER = $01kWT.NumberMAX_SAFE_INTEGER, $377fd7a4219129a5$var$NumberMIN_SAFE_INTEGER = $01kWT.NumberMIN_SAFE_INTEGER, $377fd7a4219129a5$var$NumberParseInt = $01kWT.NumberParseInt, $377fd7a4219129a5$var$ObjectPrototypeHasOwnProperty = $01kWT.ObjectPrototypeHasOwnProperty, $377fd7a4219129a5$var$RegExpPrototypeExec = $01kWT.RegExpPrototypeExec, $377fd7a4219129a5$var$String = $01kWT.String, $377fd7a4219129a5$var$StringPrototypeToUpperCase = $01kWT.StringPrototypeToUpperCase, $377fd7a4219129a5$var$StringPrototypeTrim = $01kWT.StringPrototypeTrim;

var $bsbC4 = parcelRequire("bsbC4");
var $377fd7a4219129a5$var$hideStackFrames = $bsbC4.hideStackFrames, $377fd7a4219129a5$var$_require_codes = $bsbC4.codes, $377fd7a4219129a5$var$ERR_SOCKET_BAD_PORT = $377fd7a4219129a5$var$_require_codes.ERR_SOCKET_BAD_PORT, $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE = $377fd7a4219129a5$var$_require_codes.ERR_INVALID_ARG_TYPE, $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE = $377fd7a4219129a5$var$_require_codes.ERR_INVALID_ARG_VALUE, $377fd7a4219129a5$var$ERR_OUT_OF_RANGE = $377fd7a4219129a5$var$_require_codes.ERR_OUT_OF_RANGE, $377fd7a4219129a5$var$ERR_UNKNOWN_SIGNAL = $377fd7a4219129a5$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $f6h6y = parcelRequire("f6h6y");
var $377fd7a4219129a5$require$normalizeEncoding = $f6h6y.normalizeEncoding;

var $f6h6y = parcelRequire("f6h6y");
var $377fd7a4219129a5$require$_require_types = $f6h6y.types;
var $377fd7a4219129a5$var$isAsyncFunction = $377fd7a4219129a5$require$_require_types.isAsyncFunction, $377fd7a4219129a5$var$isArrayBufferView = $377fd7a4219129a5$require$_require_types.isArrayBufferView;
var $377fd7a4219129a5$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $377fd7a4219129a5$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $377fd7a4219129a5$var$isUint32(value) {
    return value === value >>> 0;
}
var $377fd7a4219129a5$var$octalReg = /^[0-7]+$/;
var $377fd7a4219129a5$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $377fd7a4219129a5$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($377fd7a4219129a5$var$RegExpPrototypeExec($377fd7a4219129a5$var$octalReg, value) === null) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE(name, value, $377fd7a4219129a5$var$modeDesc);
        value = $377fd7a4219129a5$var$NumberParseInt(value, 8);
    }
    $377fd7a4219129a5$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $377fd7a4219129a5$var$validateInteger = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $377fd7a4219129a5$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $377fd7a4219129a5$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$377fd7a4219129a5$var$NumberIsInteger(value)) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $377fd7a4219129a5$var$validateInt32 = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$377fd7a4219129a5$var$NumberIsInteger(value)) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $377fd7a4219129a5$var$validateUint32 = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$377fd7a4219129a5$var$NumberIsInteger(value)) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $377fd7a4219129a5$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $377fd7a4219129a5$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $377fd7a4219129a5$var$NumberIsNaN(value)) throw new $377fd7a4219129a5$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $377fd7a4219129a5$var$validateOneOf = $377fd7a4219129a5$var$hideStackFrames(function(value, name, oneOf) {
    if (!$377fd7a4219129a5$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $377fd7a4219129a5$var$ArrayPrototypeJoin($377fd7a4219129a5$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $377fd7a4219129a5$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $377fd7a4219129a5$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $377fd7a4219129a5$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$377fd7a4219129a5$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $377fd7a4219129a5$var$validateObject = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $377fd7a4219129a5$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $377fd7a4219129a5$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $377fd7a4219129a5$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $377fd7a4219129a5$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $377fd7a4219129a5$var$validateDictionary = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $377fd7a4219129a5$var$validateArray = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$377fd7a4219129a5$var$ArrayIsArray(value)) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $377fd7a4219129a5$var$validateStringArray(value, name) {
    $377fd7a4219129a5$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$377fd7a4219129a5$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $377fd7a4219129a5$var$validateBooleanArray(value, name) {
    $377fd7a4219129a5$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$377fd7a4219129a5$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $377fd7a4219129a5$var$validateAbortSignalArray(value, name) {
    $377fd7a4219129a5$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $377fd7a4219129a5$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $377fd7a4219129a5$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $377fd7a4219129a5$var$validateString(signal, name);
    if ($377fd7a4219129a5$var$signals[signal] === undefined) {
        if ($377fd7a4219129a5$var$signals[$377fd7a4219129a5$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $377fd7a4219129a5$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $377fd7a4219129a5$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $377fd7a4219129a5$var$validateBuffer = $377fd7a4219129a5$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$377fd7a4219129a5$var$isArrayBufferView(buffer)) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $377fd7a4219129a5$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $377fd7a4219129a5$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $377fd7a4219129a5$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $377fd7a4219129a5$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $377fd7a4219129a5$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $377fd7a4219129a5$var$validateAbortSignal = $377fd7a4219129a5$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $377fd7a4219129a5$var$validateFunction = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $377fd7a4219129a5$var$validatePlainFunction = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $377fd7a4219129a5$var$isAsyncFunction(value)) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $377fd7a4219129a5$var$validateUndefined = $377fd7a4219129a5$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $377fd7a4219129a5$var$validateUnion(value, name, union) {
    if (!$377fd7a4219129a5$var$ArrayPrototypeIncludes(union, value)) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_TYPE(name, "('".concat($377fd7a4219129a5$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $377fd7a4219129a5$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $377fd7a4219129a5$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$377fd7a4219129a5$var$RegExpPrototypeExec($377fd7a4219129a5$var$linkValueRegExp, value)) throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $377fd7a4219129a5$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $377fd7a4219129a5$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($377fd7a4219129a5$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $377fd7a4219129a5$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $377fd7a4219129a5$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $377fd7a4219129a5$var$isInt32,
    isUint32: $377fd7a4219129a5$var$isUint32,
    parseFileMode: $377fd7a4219129a5$var$parseFileMode,
    validateArray: $377fd7a4219129a5$var$validateArray,
    validateStringArray: $377fd7a4219129a5$var$validateStringArray,
    validateBooleanArray: $377fd7a4219129a5$var$validateBooleanArray,
    validateAbortSignalArray: $377fd7a4219129a5$var$validateAbortSignalArray,
    validateBoolean: $377fd7a4219129a5$var$validateBoolean,
    validateBuffer: $377fd7a4219129a5$var$validateBuffer,
    validateDictionary: $377fd7a4219129a5$var$validateDictionary,
    validateEncoding: $377fd7a4219129a5$var$validateEncoding,
    validateFunction: $377fd7a4219129a5$var$validateFunction,
    validateInt32: $377fd7a4219129a5$var$validateInt32,
    validateInteger: $377fd7a4219129a5$var$validateInteger,
    validateNumber: $377fd7a4219129a5$var$validateNumber,
    validateObject: $377fd7a4219129a5$var$validateObject,
    validateOneOf: $377fd7a4219129a5$var$validateOneOf,
    validatePlainFunction: $377fd7a4219129a5$var$validatePlainFunction,
    validatePort: $377fd7a4219129a5$var$validatePort,
    validateSignalName: $377fd7a4219129a5$var$validateSignalName,
    validateString: $377fd7a4219129a5$var$validateString,
    validateUint32: $377fd7a4219129a5$var$validateUint32,
    validateUndefined: $377fd7a4219129a5$var$validateUndefined,
    validateUnion: $377fd7a4219129a5$var$validateUnion,
    validateAbortSignal: $377fd7a4219129a5$var$validateAbortSignal,
    validateLinkHeaderValue: $377fd7a4219129a5$var$validateLinkHeaderValue
};

});

parcelRegister("2KEat", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bsbC4 = parcelRequire("bsbC4");
/* replacement end */ var $200f092661392c28$var$AbortError = $bsbC4.AbortError, $200f092661392c28$var$codes = $bsbC4.codes;
var $200f092661392c28$var$ERR_INVALID_ARG_TYPE = $200f092661392c28$var$codes.ERR_INVALID_ARG_TYPE, $200f092661392c28$var$ERR_STREAM_PREMATURE_CLOSE = $200f092661392c28$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $200f092661392c28$var$kEmptyObject = (parcelRequire("f6h6y")).kEmptyObject, $200f092661392c28$var$once = (parcelRequire("f6h6y")).once;

var $4Lq9R = parcelRequire("4Lq9R");
var $200f092661392c28$var$validateAbortSignal = $4Lq9R.validateAbortSignal, $200f092661392c28$var$validateFunction = $4Lq9R.validateFunction, $200f092661392c28$var$validateObject = $4Lq9R.validateObject, $200f092661392c28$var$validateBoolean = $4Lq9R.validateBoolean;

var $01kWT = parcelRequire("01kWT");
var $200f092661392c28$var$Promise = $01kWT.Promise, $200f092661392c28$var$PromisePrototypeThen = $01kWT.PromisePrototypeThen, $200f092661392c28$var$SymbolDispose = $01kWT.SymbolDispose;

var $2VP5Y = parcelRequire("2VP5Y");
var $200f092661392c28$var$isClosed = $2VP5Y.isClosed, $200f092661392c28$var$isReadable = $2VP5Y.isReadable, $200f092661392c28$var$isReadableNodeStream = $2VP5Y.isReadableNodeStream, $200f092661392c28$var$isReadableStream = $2VP5Y.isReadableStream, $200f092661392c28$var$isReadableFinished = $2VP5Y.isReadableFinished, $200f092661392c28$var$isReadableErrored = $2VP5Y.isReadableErrored, $200f092661392c28$var$isWritable = $2VP5Y.isWritable, $200f092661392c28$var$isWritableNodeStream = $2VP5Y.isWritableNodeStream, $200f092661392c28$var$isWritableStream = $2VP5Y.isWritableStream, $200f092661392c28$var$isWritableFinished = $2VP5Y.isWritableFinished, $200f092661392c28$var$isWritableErrored = $2VP5Y.isWritableErrored, $200f092661392c28$var$isNodeStream = $2VP5Y.isNodeStream, $200f092661392c28$var$_willEmitClose = $2VP5Y.willEmitClose, $200f092661392c28$var$kIsClosedPromise = $2VP5Y.kIsClosedPromise;
var $200f092661392c28$var$addAbortListener;
function $200f092661392c28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $200f092661392c28$var$nop = function() {};

function $200f092661392c28$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $200f092661392c28$var$kEmptyObject;
    } else if (options == null) options = $200f092661392c28$var$kEmptyObject;
    else $200f092661392c28$var$validateObject(options, 'options');
    $200f092661392c28$var$validateFunction(callback, 'callback');
    $200f092661392c28$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $200f092661392c28$var$once(callback);
    if ($200f092661392c28$var$isReadableStream(stream) || $200f092661392c28$var$isWritableStream(stream)) return $200f092661392c28$var$eosWeb(stream, options, callback);
    if (!$200f092661392c28$var$isNodeStream(stream)) throw new $200f092661392c28$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $200f092661392c28$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $200f092661392c28$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $200f092661392c28$var$_willEmitClose(stream) && $200f092661392c28$var$isReadableNodeStream(stream) === readable && $200f092661392c28$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $200f092661392c28$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $200f092661392c28$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $200f092661392c28$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $200f092661392c28$var$isWritableErrored(stream) || $200f092661392c28$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $200f092661392c28$var$isReadableNodeStream(stream, true)) {
            if (!$200f092661392c28$var$isReadableFinished(stream, false)) return callback.call(stream, new $200f092661392c28$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$200f092661392c28$var$isWritableFinished(stream, false)) return callback.call(stream, new $200f092661392c28$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $200f092661392c28$var$isWritableErrored(stream) || $200f092661392c28$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($200f092661392c28$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $200f092661392c28$var$isReadable(stream)) && (writableFinished || $200f092661392c28$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $200f092661392c28$var$isWritable(stream)) && (readableFinished || $200f092661392c28$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $200f092661392c28$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $200f092661392c28$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $200f092661392c28$var$addAbortListener = $200f092661392c28$var$addAbortListener || (parcelRequire("f6h6y")).addAbortListener;
            var disposable = $200f092661392c28$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $200f092661392c28$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$200f092661392c28$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $200f092661392c28$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $200f092661392c28$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $200f092661392c28$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $200f092661392c28$var$addAbortListener = $200f092661392c28$var$addAbortListener || (parcelRequire("f6h6y")).addAbortListener;
            var disposable = $200f092661392c28$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $200f092661392c28$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$200f092661392c28$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $200f092661392c28$var$PromisePrototypeThen(stream[$200f092661392c28$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $200f092661392c28$var$nop;
}
function $200f092661392c28$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $200f092661392c28$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $200f092661392c28$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $200f092661392c28$var$Promise(function(resolve, reject) {
        var cleanup = $200f092661392c28$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $200f092661392c28$var$eos;
module.exports.finished = $200f092661392c28$var$finished;

});
parcelRegister("2VP5Y", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $22288a224615bd16$var$SymbolAsyncIterator = $01kWT.SymbolAsyncIterator, $22288a224615bd16$var$SymbolIterator = $01kWT.SymbolIterator, $22288a224615bd16$var$SymbolFor = $01kWT.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $22288a224615bd16$var$kIsDestroyed = $22288a224615bd16$var$SymbolFor('nodejs.stream.destroyed');
var $22288a224615bd16$var$kIsErrored = $22288a224615bd16$var$SymbolFor('nodejs.stream.errored');
var $22288a224615bd16$var$kIsReadable = $22288a224615bd16$var$SymbolFor('nodejs.stream.readable');
var $22288a224615bd16$var$kIsWritable = $22288a224615bd16$var$SymbolFor('nodejs.stream.writable');
var $22288a224615bd16$var$kIsDisturbed = $22288a224615bd16$var$SymbolFor('nodejs.stream.disturbed');
var $22288a224615bd16$var$kIsClosedPromise = $22288a224615bd16$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $22288a224615bd16$var$kControllerErrorFunction = $22288a224615bd16$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $22288a224615bd16$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $22288a224615bd16$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $22288a224615bd16$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $22288a224615bd16$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $22288a224615bd16$var$isReadableStream(obj) {
    return !!(obj && !$22288a224615bd16$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $22288a224615bd16$var$isWritableStream(obj) {
    return !!(obj && !$22288a224615bd16$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $22288a224615bd16$var$isTransformStream(obj) {
    return !!(obj && !$22288a224615bd16$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $22288a224615bd16$var$isWebStream(obj) {
    return $22288a224615bd16$var$isReadableStream(obj) || $22288a224615bd16$var$isWritableStream(obj) || $22288a224615bd16$var$isTransformStream(obj);
}
function $22288a224615bd16$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$22288a224615bd16$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$22288a224615bd16$var$SymbolIterator] === 'function';
    return typeof obj[$22288a224615bd16$var$SymbolAsyncIterator] === 'function' || typeof obj[$22288a224615bd16$var$SymbolIterator] === 'function';
}
function $22288a224615bd16$var$isDestroyed(stream) {
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$22288a224615bd16$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $22288a224615bd16$var$isWritableEnded(stream) {
    if (!$22288a224615bd16$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $22288a224615bd16$var$isWritableFinished(stream, strict) {
    if (!$22288a224615bd16$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $22288a224615bd16$var$isReadableEnded(stream) {
    if (!$22288a224615bd16$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $22288a224615bd16$var$isReadableFinished(stream, strict) {
    if (!$22288a224615bd16$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $22288a224615bd16$var$isReadable(stream) {
    if (stream && stream[$22288a224615bd16$var$kIsReadable] != null) return stream[$22288a224615bd16$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($22288a224615bd16$var$isDestroyed(stream)) return false;
    return $22288a224615bd16$var$isReadableNodeStream(stream) && stream.readable && !$22288a224615bd16$var$isReadableFinished(stream);
}
function $22288a224615bd16$var$isWritable(stream) {
    if (stream && stream[$22288a224615bd16$var$kIsWritable] != null) return stream[$22288a224615bd16$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($22288a224615bd16$var$isDestroyed(stream)) return false;
    return $22288a224615bd16$var$isWritableNodeStream(stream) && stream.writable && !$22288a224615bd16$var$isWritableEnded(stream);
}
function $22288a224615bd16$var$isFinished(stream, opts) {
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    if ($22288a224615bd16$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $22288a224615bd16$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $22288a224615bd16$var$isWritable(stream)) return false;
    return true;
}
function $22288a224615bd16$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $22288a224615bd16$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $22288a224615bd16$var$isClosed(stream) {
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $22288a224615bd16$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $22288a224615bd16$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $22288a224615bd16$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $22288a224615bd16$var$isOutgoingMessage(stream);
}
function $22288a224615bd16$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $22288a224615bd16$var$willEmitClose(stream) {
    if (!$22288a224615bd16$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $22288a224615bd16$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $22288a224615bd16$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$22288a224615bd16$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $22288a224615bd16$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$22288a224615bd16$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $22288a224615bd16$var$isDestroyed,
    kIsDestroyed: $22288a224615bd16$var$kIsDestroyed,
    isDisturbed: $22288a224615bd16$var$isDisturbed,
    kIsDisturbed: $22288a224615bd16$var$kIsDisturbed,
    isErrored: $22288a224615bd16$var$isErrored,
    kIsErrored: $22288a224615bd16$var$kIsErrored,
    isReadable: $22288a224615bd16$var$isReadable,
    kIsReadable: $22288a224615bd16$var$kIsReadable,
    kIsClosedPromise: $22288a224615bd16$var$kIsClosedPromise,
    kControllerErrorFunction: $22288a224615bd16$var$kControllerErrorFunction,
    kIsWritable: $22288a224615bd16$var$kIsWritable,
    isClosed: $22288a224615bd16$var$isClosed,
    isDuplexNodeStream: $22288a224615bd16$var$isDuplexNodeStream,
    isFinished: $22288a224615bd16$var$isFinished,
    isIterable: $22288a224615bd16$var$isIterable,
    isReadableNodeStream: $22288a224615bd16$var$isReadableNodeStream,
    isReadableStream: $22288a224615bd16$var$isReadableStream,
    isReadableEnded: $22288a224615bd16$var$isReadableEnded,
    isReadableFinished: $22288a224615bd16$var$isReadableFinished,
    isReadableErrored: $22288a224615bd16$var$isReadableErrored,
    isNodeStream: $22288a224615bd16$var$isNodeStream,
    isWebStream: $22288a224615bd16$var$isWebStream,
    isWritable: $22288a224615bd16$var$isWritable,
    isWritableNodeStream: $22288a224615bd16$var$isWritableNodeStream,
    isWritableStream: $22288a224615bd16$var$isWritableStream,
    isWritableEnded: $22288a224615bd16$var$isWritableEnded,
    isWritableFinished: $22288a224615bd16$var$isWritableFinished,
    isWritableErrored: $22288a224615bd16$var$isWritableErrored,
    isServerRequest: $22288a224615bd16$var$isServerRequest,
    isServerResponse: $22288a224615bd16$var$isServerResponse,
    willEmitClose: $22288a224615bd16$var$willEmitClose,
    isTransformStream: $22288a224615bd16$var$isTransformStream
};

});


parcelRegister("b9Axa", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eMv1z = parcelRequire("eMv1z");
var $81ecdfda9a18aefe$require$pipeline = $eMv1z.pipeline;

var $itmui = parcelRequire("itmui");

var $329Hf = parcelRequire("329Hf");
var $81ecdfda9a18aefe$require$destroyer = $329Hf.destroyer;

var $2VP5Y = parcelRequire("2VP5Y");
var $81ecdfda9a18aefe$var$isNodeStream = $2VP5Y.isNodeStream, $81ecdfda9a18aefe$var$isReadable = $2VP5Y.isReadable, $81ecdfda9a18aefe$var$isWritable = $2VP5Y.isWritable, $81ecdfda9a18aefe$var$isWebStream = $2VP5Y.isWebStream, $81ecdfda9a18aefe$var$isTransformStream = $2VP5Y.isTransformStream, $81ecdfda9a18aefe$var$isWritableStream = $2VP5Y.isWritableStream, $81ecdfda9a18aefe$var$isReadableStream = $2VP5Y.isReadableStream;

var $bsbC4 = parcelRequire("bsbC4");
var $81ecdfda9a18aefe$var$AbortError = $bsbC4.AbortError, $81ecdfda9a18aefe$var$_require_codes = $bsbC4.codes, $81ecdfda9a18aefe$var$ERR_INVALID_ARG_VALUE = $81ecdfda9a18aefe$var$_require_codes.ERR_INVALID_ARG_VALUE, $81ecdfda9a18aefe$var$ERR_MISSING_ARGS = $81ecdfda9a18aefe$var$_require_codes.ERR_MISSING_ARGS;

var $2KEat = parcelRequire("2KEat");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $81ecdfda9a18aefe$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $itmui.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $itmui.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $itmui.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$81ecdfda9a18aefe$var$isNodeStream(streams[n]) && !$81ecdfda9a18aefe$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($81ecdfda9a18aefe$var$isReadable(streams[n]) || $81ecdfda9a18aefe$var$isReadableStream(streams[n]) || $81ecdfda9a18aefe$var$isTransformStream(streams[n]))) throw new $81ecdfda9a18aefe$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($81ecdfda9a18aefe$var$isWritable(streams[n]) || $81ecdfda9a18aefe$var$isWritableStream(streams[n]) || $81ecdfda9a18aefe$var$isTransformStream(streams[n]))) throw new $81ecdfda9a18aefe$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $81ecdfda9a18aefe$require$pipeline(streams, onfinished);
    var writable = !!($81ecdfda9a18aefe$var$isWritable(head) || $81ecdfda9a18aefe$var$isWritableStream(head) || $81ecdfda9a18aefe$var$isTransformStream(head));
    var readable = !!($81ecdfda9a18aefe$var$isReadable(tail) || $81ecdfda9a18aefe$var$isReadableStream(tail) || $81ecdfda9a18aefe$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $itmui({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($81ecdfda9a18aefe$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($81ecdfda9a18aefe$var$isWebStream(head)) {
            var writable1 = $81ecdfda9a18aefe$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $81ecdfda9a18aefe$var$isTransformStream(tail) ? tail.readable : tail;
        $2KEat(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($81ecdfda9a18aefe$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($81ecdfda9a18aefe$var$isWebStream(tail)) {
            var readable1 = $81ecdfda9a18aefe$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $81ecdfda9a18aefe$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($81ecdfda9a18aefe$var$isNodeStream(tail)) $81ecdfda9a18aefe$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("eMv1z", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $ac2d9d29d83a5651$var$ArrayIsArray = $01kWT.ArrayIsArray, $ac2d9d29d83a5651$var$Promise = $01kWT.Promise, $ac2d9d29d83a5651$var$SymbolAsyncIterator = $01kWT.SymbolAsyncIterator, $ac2d9d29d83a5651$var$SymbolDispose = $01kWT.SymbolDispose;

var $2KEat = parcelRequire("2KEat");

var $ac2d9d29d83a5651$require$once = (parcelRequire("f6h6y")).once;

var $329Hf = parcelRequire("329Hf");

var $itmui = parcelRequire("itmui");

var $bsbC4 = parcelRequire("bsbC4");
var $ac2d9d29d83a5651$var$aggregateTwoErrors = $bsbC4.aggregateTwoErrors, $ac2d9d29d83a5651$var$_require_codes = $bsbC4.codes, $ac2d9d29d83a5651$var$ERR_INVALID_ARG_TYPE = $ac2d9d29d83a5651$var$_require_codes.ERR_INVALID_ARG_TYPE, $ac2d9d29d83a5651$var$ERR_INVALID_RETURN_VALUE = $ac2d9d29d83a5651$var$_require_codes.ERR_INVALID_RETURN_VALUE, $ac2d9d29d83a5651$var$ERR_MISSING_ARGS = $ac2d9d29d83a5651$var$_require_codes.ERR_MISSING_ARGS, $ac2d9d29d83a5651$var$ERR_STREAM_DESTROYED = $ac2d9d29d83a5651$var$_require_codes.ERR_STREAM_DESTROYED, $ac2d9d29d83a5651$var$ERR_STREAM_PREMATURE_CLOSE = $ac2d9d29d83a5651$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $ac2d9d29d83a5651$var$AbortError = $bsbC4.AbortError;

var $4Lq9R = parcelRequire("4Lq9R");
var $ac2d9d29d83a5651$var$validateFunction = $4Lq9R.validateFunction, $ac2d9d29d83a5651$var$validateAbortSignal = $4Lq9R.validateAbortSignal;

var $2VP5Y = parcelRequire("2VP5Y");
var $ac2d9d29d83a5651$var$isIterable = $2VP5Y.isIterable, $ac2d9d29d83a5651$var$isReadable = $2VP5Y.isReadable, $ac2d9d29d83a5651$var$isReadableNodeStream = $2VP5Y.isReadableNodeStream, $ac2d9d29d83a5651$var$isNodeStream = $2VP5Y.isNodeStream, $ac2d9d29d83a5651$var$isTransformStream = $2VP5Y.isTransformStream, $ac2d9d29d83a5651$var$isWebStream = $2VP5Y.isWebStream, $ac2d9d29d83a5651$var$isReadableStream = $2VP5Y.isReadableStream, $ac2d9d29d83a5651$var$isReadableFinished = $2VP5Y.isReadableFinished;

var $ac2d9d29d83a5651$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $ac2d9d29d83a5651$var$PassThrough;
var $ac2d9d29d83a5651$var$Readable;
var $ac2d9d29d83a5651$var$addAbortListener;
function $ac2d9d29d83a5651$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $2KEat(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $329Hf.destroyer(stream, err || new $ac2d9d29d83a5651$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $ac2d9d29d83a5651$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $ac2d9d29d83a5651$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $ac2d9d29d83a5651$var$makeAsyncIterable(val) {
    if ($ac2d9d29d83a5651$var$isIterable(val)) return val;
    else if ($ac2d9d29d83a5651$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $ac2d9d29d83a5651$var$fromReadable(val);
    throw new $ac2d9d29d83a5651$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $ac2d9d29d83a5651$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$ac2d9d29d83a5651$var$Readable) $ac2d9d29d83a5651$var$Readable = (parcelRequire("9Dgc3"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($ac2d9d29d83a5651$var$Readable.prototype[$ac2d9d29d83a5651$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $ac2d9d29d83a5651$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $ac2d9d29d83a5651$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $2KEat(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $ac2d9d29d83a5651$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ac2d9d29d83a5651$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($ac2d9d29d83a5651$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ac2d9d29d83a5651$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $ac2d9d29d83a5651$var$pipelineImpl(streams, $ac2d9d29d83a5651$require$once($ac2d9d29d83a5651$var$popCallback(streams)));
}


function $ac2d9d29d83a5651$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($ac2d9d29d83a5651$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $ac2d9d29d83a5651$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($ac2d9d29d83a5651$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($ac2d9d29d83a5651$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$ac2d9d29d83a5651$var$isIterable(ret)) throw new $ac2d9d29d83a5651$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($ac2d9d29d83a5651$var$isIterable(stream) || $ac2d9d29d83a5651$var$isReadableNodeStream(stream) || $ac2d9d29d83a5651$var$isTransformStream(stream)) ret = stream;
            else ret = $itmui.from(stream);
        } else if (typeof stream === 'function') {
            if ($ac2d9d29d83a5651$var$isTransformStream(ret)) {
                var _ret;
                ret = $ac2d9d29d83a5651$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $ac2d9d29d83a5651$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$ac2d9d29d83a5651$var$isIterable(ret, true)) throw new $ac2d9d29d83a5651$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$ac2d9d29d83a5651$var$PassThrough) $ac2d9d29d83a5651$var$PassThrough = (parcelRequire("iNbiQ"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $ac2d9d29d83a5651$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($ac2d9d29d83a5651$var$isIterable(ret, true)) {
                    finishCount++;
                    $ac2d9d29d83a5651$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($ac2d9d29d83a5651$var$isReadableStream(ret) || $ac2d9d29d83a5651$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $ac2d9d29d83a5651$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $ac2d9d29d83a5651$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $ac2d9d29d83a5651$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($ac2d9d29d83a5651$var$isNodeStream(stream)) {
            if ($ac2d9d29d83a5651$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $ac2d9d29d83a5651$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($ac2d9d29d83a5651$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($ac2d9d29d83a5651$var$isTransformStream(ret) || $ac2d9d29d83a5651$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $ac2d9d29d83a5651$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($ac2d9d29d83a5651$var$isIterable(ret)) {
                finishCount++;
                $ac2d9d29d83a5651$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $ac2d9d29d83a5651$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($ac2d9d29d83a5651$var$isWebStream(stream)) {
            if ($ac2d9d29d83a5651$var$isReadableNodeStream(ret)) {
                finishCount++;
                $ac2d9d29d83a5651$var$pumpToWeb($ac2d9d29d83a5651$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($ac2d9d29d83a5651$var$isReadableStream(ret) || $ac2d9d29d83a5651$var$isIterable(ret)) {
                finishCount++;
                $ac2d9d29d83a5651$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($ac2d9d29d83a5651$var$isTransformStream(ret)) {
                finishCount++;
                $ac2d9d29d83a5651$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $ac2d9d29d83a5651$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $itmui.from(stream);
    };
    if (streams.length === 1 && $ac2d9d29d83a5651$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ac2d9d29d83a5651$var$ERR_MISSING_ARGS('streams');
    var ac = new $ac2d9d29d83a5651$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $ac2d9d29d83a5651$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $ac2d9d29d83a5651$var$AbortError());
    }
    $ac2d9d29d83a5651$var$addAbortListener = $ac2d9d29d83a5651$var$addAbortListener || (parcelRequire("f6h6y")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $ac2d9d29d83a5651$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$ac2d9d29d83a5651$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $ac2d9d29d83a5651$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $ac2d9d29d83a5651$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($ac2d9d29d83a5651$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2KEat(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2KEat(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $ac2d9d29d83a5651$var$pipelineImpl,
    pipeline: $ac2d9d29d83a5651$var$pipeline
};

});
parcelRegister("329Hf", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bsbC4 = parcelRequire("bsbC4");
/* replacement end */ var $235914878f273d4a$var$aggregateTwoErrors = $bsbC4.aggregateTwoErrors, $235914878f273d4a$var$ERR_MULTIPLE_CALLBACK = $bsbC4.codes.ERR_MULTIPLE_CALLBACK, $235914878f273d4a$var$AbortError = $bsbC4.AbortError;

var $01kWT = parcelRequire("01kWT");
var $235914878f273d4a$require$Symbol = $01kWT.Symbol;

var $2VP5Y = parcelRequire("2VP5Y");
var $235914878f273d4a$var$kIsDestroyed = $2VP5Y.kIsDestroyed, $235914878f273d4a$var$isDestroyed = $2VP5Y.isDestroyed, $235914878f273d4a$var$isFinished = $2VP5Y.isFinished, $235914878f273d4a$var$isServerRequest = $2VP5Y.isServerRequest;
var $235914878f273d4a$var$kDestroy = $235914878f273d4a$require$Symbol('kDestroy');
var $235914878f273d4a$var$kConstruct = $235914878f273d4a$require$Symbol('kConstruct');
function $235914878f273d4a$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $235914878f273d4a$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $235914878f273d4a$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($235914878f273d4a$var$kDestroy, function(er) {
        $235914878f273d4a$var$_destroy(this, $235914878f273d4a$var$aggregateTwoErrors(er, err), cb);
    });
    else $235914878f273d4a$var$_destroy(this, err, cb);
    return this;
}
function $235914878f273d4a$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $235914878f273d4a$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($235914878f273d4a$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($235914878f273d4a$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $235914878f273d4a$var$emitErrorCloseNT(self, err) {
    $235914878f273d4a$var$emitErrorNT(self, err);
    $235914878f273d4a$var$emitCloseNT(self);
}
function $235914878f273d4a$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $235914878f273d4a$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $235914878f273d4a$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $235914878f273d4a$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($235914878f273d4a$var$emitErrorNT, stream, err);
        else $235914878f273d4a$var$emitErrorNT(stream, err);
    }
}
function $235914878f273d4a$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($235914878f273d4a$var$kConstruct, cb);
    if (stream.listenerCount($235914878f273d4a$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($235914878f273d4a$var$constructNT, stream);
}
function $235914878f273d4a$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $235914878f273d4a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $235914878f273d4a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($235914878f273d4a$var$kDestroy, err);
        else if (err) $235914878f273d4a$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($235914878f273d4a$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $235914878f273d4a$var$emitConstructNT(stream) {
    stream.emit($235914878f273d4a$var$kConstruct);
}
function $235914878f273d4a$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $235914878f273d4a$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $235914878f273d4a$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($235914878f273d4a$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $235914878f273d4a$var$destroyer(stream, err) {
    if (!stream || $235914878f273d4a$var$isDestroyed(stream)) return;
    if (!err && !$235914878f273d4a$var$isFinished(stream)) err = new $235914878f273d4a$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($235914878f273d4a$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($235914878f273d4a$var$isRequest(stream)) stream.abort();
    else if ($235914878f273d4a$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($235914878f273d4a$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($235914878f273d4a$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$235914878f273d4a$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $235914878f273d4a$var$construct,
    destroyer: $235914878f273d4a$var$destroyer,
    destroy: $235914878f273d4a$var$destroy,
    undestroy: $235914878f273d4a$var$undestroy,
    errorOrDestroy: $235914878f273d4a$var$errorOrDestroy
};

});

parcelRegister("itmui", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $d72c60fbb4336de2$var$ObjectDefineProperties = $01kWT.ObjectDefineProperties, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor = $01kWT.ObjectGetOwnPropertyDescriptor, $d72c60fbb4336de2$var$ObjectKeys = $01kWT.ObjectKeys, $d72c60fbb4336de2$var$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf;
module.exports = $d72c60fbb4336de2$var$Duplex;

var $9Dgc3 = parcelRequire("9Dgc3");

var $3x7Uf = parcelRequire("3x7Uf");
$d72c60fbb4336de2$var$ObjectSetPrototypeOf($d72c60fbb4336de2$var$Duplex.prototype, $9Dgc3.prototype);
$d72c60fbb4336de2$var$ObjectSetPrototypeOf($d72c60fbb4336de2$var$Duplex, $9Dgc3);
{
    var $d72c60fbb4336de2$var$keys = $d72c60fbb4336de2$var$ObjectKeys($3x7Uf.prototype);
    // Allow the keys array to be GC'ed.
    for(var $d72c60fbb4336de2$var$i = 0; $d72c60fbb4336de2$var$i < $d72c60fbb4336de2$var$keys.length; $d72c60fbb4336de2$var$i++){
        var $d72c60fbb4336de2$var$method = $d72c60fbb4336de2$var$keys[$d72c60fbb4336de2$var$i];
        if (!$d72c60fbb4336de2$var$Duplex.prototype[$d72c60fbb4336de2$var$method]) $d72c60fbb4336de2$var$Duplex.prototype[$d72c60fbb4336de2$var$method] = $3x7Uf.prototype[$d72c60fbb4336de2$var$method];
    }
}function $d72c60fbb4336de2$var$Duplex(options) {
    if (!(this instanceof $d72c60fbb4336de2$var$Duplex)) return new $d72c60fbb4336de2$var$Duplex(options);
    $9Dgc3.call(this, options);
    $3x7Uf.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$d72c60fbb4336de2$var$ObjectDefineProperties($d72c60fbb4336de2$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $d72c60fbb4336de2$var$ObjectGetOwnPropertyDescriptor($3x7Uf.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $d72c60fbb4336de2$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d72c60fbb4336de2$var$lazyWebStreams() {
    if ($d72c60fbb4336de2$var$webStreamsAdapters === undefined) $d72c60fbb4336de2$var$webStreamsAdapters = {};
    return $d72c60fbb4336de2$var$webStreamsAdapters;
}
$d72c60fbb4336de2$var$Duplex.fromWeb = function(pair, options) {
    return $d72c60fbb4336de2$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$d72c60fbb4336de2$var$Duplex.toWeb = function(duplex) {
    return $d72c60fbb4336de2$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $d72c60fbb4336de2$var$duplexify;

$d72c60fbb4336de2$var$Duplex.from = function(body) {
    if (!$d72c60fbb4336de2$var$duplexify) $d72c60fbb4336de2$var$duplexify = (parcelRequire("axpQw"));
    return $d72c60fbb4336de2$var$duplexify(body, 'body');
};

});
parcelRegister("9Dgc3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $01kWT = parcelRequire("01kWT");
/* replacement end */ var $7034513a4267861d$var$ArrayPrototypeIndexOf = $01kWT.ArrayPrototypeIndexOf, $7034513a4267861d$var$NumberIsInteger = $01kWT.NumberIsInteger, $7034513a4267861d$var$NumberIsNaN = $01kWT.NumberIsNaN, $7034513a4267861d$var$NumberParseInt = $01kWT.NumberParseInt, $7034513a4267861d$var$ObjectDefineProperties = $01kWT.ObjectDefineProperties, $7034513a4267861d$var$ObjectKeys = $01kWT.ObjectKeys, $7034513a4267861d$var$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf, $7034513a4267861d$var$Promise = $01kWT.Promise, $7034513a4267861d$var$SafeSet = $01kWT.SafeSet, $7034513a4267861d$var$SymbolAsyncDispose = $01kWT.SymbolAsyncDispose, $7034513a4267861d$var$SymbolAsyncIterator = $01kWT.SymbolAsyncIterator, $7034513a4267861d$var$Symbol = $01kWT.Symbol;
module.exports = $7034513a4267861d$var$Readable;
$7034513a4267861d$var$Readable.ReadableState = $7034513a4267861d$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $7034513a4267861d$var$EE = $bBoAO.EventEmitter;

var $7eOXa = parcelRequire("7eOXa");
var $7034513a4267861d$var$Stream = $7eOXa.Stream, $7034513a4267861d$var$prependListener = $7eOXa.prependListener;

var $gywOi = parcelRequire("gywOi");
var $7034513a4267861d$require$Buffer = $gywOi.Buffer;

var $glIk8 = parcelRequire("glIk8");
var $7034513a4267861d$require$addAbortSignal = $glIk8.addAbortSignal;

var $2KEat = parcelRequire("2KEat");

var $7034513a4267861d$var$debug = (parcelRequire("f6h6y")).debuglog('stream', function(fn) {
    $7034513a4267861d$var$debug = fn;
});

var $9zo3z = parcelRequire("9zo3z");

var $329Hf = parcelRequire("329Hf");

var $4dlVb = parcelRequire("4dlVb");
var $7034513a4267861d$var$getHighWaterMark = $4dlVb.getHighWaterMark, $7034513a4267861d$var$getDefaultHighWaterMark = $4dlVb.getDefaultHighWaterMark;

var $bsbC4 = parcelRequire("bsbC4");
var $7034513a4267861d$var$aggregateTwoErrors = $bsbC4.aggregateTwoErrors, $7034513a4267861d$var$_require_codes = $bsbC4.codes, $7034513a4267861d$var$ERR_INVALID_ARG_TYPE = $7034513a4267861d$var$_require_codes.ERR_INVALID_ARG_TYPE, $7034513a4267861d$var$ERR_METHOD_NOT_IMPLEMENTED = $7034513a4267861d$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $7034513a4267861d$var$ERR_OUT_OF_RANGE = $7034513a4267861d$var$_require_codes.ERR_OUT_OF_RANGE, $7034513a4267861d$var$ERR_STREAM_PUSH_AFTER_EOF = $7034513a4267861d$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $7034513a4267861d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7034513a4267861d$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $7034513a4267861d$var$AbortError = $bsbC4.AbortError;

var $4Lq9R = parcelRequire("4Lq9R");
var $7034513a4267861d$require$validateObject = $4Lq9R.validateObject;
var $7034513a4267861d$var$kPaused = $7034513a4267861d$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $7034513a4267861d$require$StringDecoder = $3Jf7C.StringDecoder;

var $hs5Ep = parcelRequire("hs5Ep");
$7034513a4267861d$var$ObjectSetPrototypeOf($7034513a4267861d$var$Readable.prototype, $7034513a4267861d$var$Stream.prototype);
$7034513a4267861d$var$ObjectSetPrototypeOf($7034513a4267861d$var$Readable, $7034513a4267861d$var$Stream);
var $7034513a4267861d$var$nop = function() {};
var $7034513a4267861d$var$errorOrDestroy = $329Hf.errorOrDestroy;
var $7034513a4267861d$var$kObjectMode = 1;
var $7034513a4267861d$var$kEnded = 2;
var $7034513a4267861d$var$kEndEmitted = 4;
var $7034513a4267861d$var$kReading = 8;
var $7034513a4267861d$var$kConstructed = 16;
var $7034513a4267861d$var$kSync = 32;
var $7034513a4267861d$var$kNeedReadable = 64;
var $7034513a4267861d$var$kEmittedReadable = 128;
var $7034513a4267861d$var$kReadableListening = 256;
var $7034513a4267861d$var$kResumeScheduled = 512;
var $7034513a4267861d$var$kErrorEmitted = 1024;
var $7034513a4267861d$var$kEmitClose = 2048;
var $7034513a4267861d$var$kAutoDestroy = 4096;
var $7034513a4267861d$var$kDestroyed = 8192;
var $7034513a4267861d$var$kClosed = 16384;
var $7034513a4267861d$var$kCloseEmitted = 32768;
var $7034513a4267861d$var$kMultiAwaitDrain = 65536;
var $7034513a4267861d$var$kReadingMore = 131072;
var $7034513a4267861d$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $7034513a4267861d$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$7034513a4267861d$var$ObjectDefineProperties($7034513a4267861d$var$ReadableState.prototype, {
    objectMode: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kObjectMode),
    ended: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kEnded),
    endEmitted: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kEndEmitted),
    reading: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kNeedReadable),
    emittedReadable: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kEmittedReadable),
    readableListening: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kReadableListening),
    resumeScheduled: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kErrorEmitted),
    emitClose: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kEmitClose),
    autoDestroy: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kCloseEmitted),
    multiAwaitDrain: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kReadingMore),
    dataEmitted: $7034513a4267861d$var$makeBitMapDescriptor($7034513a4267861d$var$kDataEmitted)
});

function $7034513a4267861d$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("itmui"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $7034513a4267861d$var$kEmitClose | $7034513a4267861d$var$kAutoDestroy | $7034513a4267861d$var$kConstructed | $7034513a4267861d$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $7034513a4267861d$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $7034513a4267861d$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $7034513a4267861d$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $7034513a4267861d$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9zo3z();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$7034513a4267861d$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$7034513a4267861d$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$7034513a4267861d$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $7034513a4267861d$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7034513a4267861d$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $7034513a4267861d$var$Readable)) return new $7034513a4267861d$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("itmui"));
    this._readableState = new $7034513a4267861d$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $7034513a4267861d$require$addAbortSignal(options.signal, this);
    }
    $7034513a4267861d$var$Stream.call(this, options);
    $329Hf.construct(this, function() {
        if (_this._readableState.needReadable) $7034513a4267861d$var$maybeReadMore(_this, _this._readableState);
    });
}
$7034513a4267861d$var$Readable.prototype.destroy = $329Hf.destroy;
$7034513a4267861d$var$Readable.prototype._undestroy = $329Hf.undestroy;
$7034513a4267861d$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$7034513a4267861d$var$Readable.prototype[$7034513a4267861d$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$7034513a4267861d$var$Readable.prototype[$7034513a4267861d$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $7034513a4267861d$var$AbortError();
        this.destroy(error);
    }
    return new $7034513a4267861d$var$Promise(function(resolve, reject) {
        return $2KEat(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7034513a4267861d$var$Readable.prototype.push = function(chunk, encoding) {
    return $7034513a4267861d$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$7034513a4267861d$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $7034513a4267861d$var$readableAddChunk(this, chunk, encoding, true);
};
function $7034513a4267861d$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $7034513a4267861d$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $7034513a4267861d$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $7034513a4267861d$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $7034513a4267861d$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $7034513a4267861d$require$Buffer) encoding = '';
        else if ($7034513a4267861d$var$Stream._isUint8Array(chunk)) {
            chunk = $7034513a4267861d$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $7034513a4267861d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $7034513a4267861d$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$7034513a4267861d$var$kReading;
        $7034513a4267861d$var$onEofChunk(stream, state);
    } else if ((state.state & $7034513a4267861d$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $7034513a4267861d$var$kEndEmitted) !== 0) $7034513a4267861d$var$errorOrDestroy(stream, new $7034513a4267861d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $7034513a4267861d$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $7034513a4267861d$var$errorOrDestroy(stream, new $7034513a4267861d$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$7034513a4267861d$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $7034513a4267861d$var$addChunk(stream, state, chunk, false);
                else $7034513a4267861d$var$maybeReadMore(stream, state);
            } else $7034513a4267861d$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$7034513a4267861d$var$kReading;
        $7034513a4267861d$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7034513a4267861d$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $7034513a4267861d$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $7034513a4267861d$var$kNeedReadable) !== 0) $7034513a4267861d$var$emitReadable(stream);
    }
    $7034513a4267861d$var$maybeReadMore(stream, state);
}
$7034513a4267861d$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$7034513a4267861d$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$7034513a4267861d$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $7034513a4267861d$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$7034513a4267861d$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $7034513a4267861d$var$MAX_HWM = 0x40000000;
function $7034513a4267861d$var$computeNewHighWaterMark(n) {
    if (n > $7034513a4267861d$var$MAX_HWM) throw new $7034513a4267861d$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7034513a4267861d$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $7034513a4267861d$var$kObjectMode) !== 0) return 1;
    if ($7034513a4267861d$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$7034513a4267861d$var$Readable.prototype.read = function(n) {
    $7034513a4267861d$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$7034513a4267861d$var$NumberIsInteger(n)) n = $7034513a4267861d$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7034513a4267861d$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$7034513a4267861d$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7034513a4267861d$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7034513a4267861d$var$endReadable(this);
        else $7034513a4267861d$var$emitReadable(this);
        return null;
    }
    n = $7034513a4267861d$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7034513a4267861d$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $7034513a4267861d$var$kNeedReadable) !== 0;
    $7034513a4267861d$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7034513a4267861d$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $7034513a4267861d$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $7034513a4267861d$var$debug('do read');
        state.state |= $7034513a4267861d$var$kReading | $7034513a4267861d$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $7034513a4267861d$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $7034513a4267861d$var$errorOrDestroy(this, err);
        }
        state.state &= ~$7034513a4267861d$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7034513a4267861d$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7034513a4267861d$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7034513a4267861d$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $7034513a4267861d$var$onEofChunk(stream, state) {
    $7034513a4267861d$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $7034513a4267861d$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $7034513a4267861d$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7034513a4267861d$var$emitReadable(stream) {
    var state = stream._readableState;
    $7034513a4267861d$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7034513a4267861d$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($7034513a4267861d$var$emitReadable_, stream);
    }
}
function $7034513a4267861d$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7034513a4267861d$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7034513a4267861d$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7034513a4267861d$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($7034513a4267861d$var$maybeReadMore_, stream, state);
    }
}
function $7034513a4267861d$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7034513a4267861d$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7034513a4267861d$var$Readable.prototype._read = function(n) {
    throw new $7034513a4267861d$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$7034513a4267861d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $7034513a4267861d$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $7034513a4267861d$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7034513a4267861d$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7034513a4267861d$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $7034513a4267861d$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $7034513a4267861d$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $7034513a4267861d$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $7034513a4267861d$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7034513a4267861d$var$debug('ondata');
        var ret = dest.write(chunk);
        $7034513a4267861d$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7034513a4267861d$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $7034513a4267861d$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $7034513a4267861d$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7034513a4267861d$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7034513a4267861d$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $7034513a4267861d$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7034513a4267861d$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $7034513a4267861d$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $7034513a4267861d$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$7034513a4267861d$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $7034513a4267861d$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$7034513a4267861d$var$Readable.prototype.on = function(ev, fn) {
    var res = $7034513a4267861d$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7034513a4267861d$var$debug('on readable', state.length, state.reading);
            if (state.length) $7034513a4267861d$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($7034513a4267861d$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7034513a4267861d$var$Readable.prototype.addListener = $7034513a4267861d$var$Readable.prototype.on;
$7034513a4267861d$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7034513a4267861d$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($7034513a4267861d$var$updateReadableListening, this);
    return res;
};
$7034513a4267861d$var$Readable.prototype.off = $7034513a4267861d$var$Readable.prototype.removeListener;
$7034513a4267861d$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7034513a4267861d$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($7034513a4267861d$var$updateReadableListening, this);
    return res;
};
function $7034513a4267861d$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$7034513a4267861d$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $7034513a4267861d$var$nReadingNextTick(self) {
    $7034513a4267861d$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7034513a4267861d$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7034513a4267861d$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $7034513a4267861d$var$resume(this, state);
    }
    state[$7034513a4267861d$var$kPaused] = false;
    return this;
};
function $7034513a4267861d$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($7034513a4267861d$var$resume_, stream, state);
    }
}
function $7034513a4267861d$var$resume_(stream, state) {
    $7034513a4267861d$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7034513a4267861d$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7034513a4267861d$var$Readable.prototype.pause = function() {
    $7034513a4267861d$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7034513a4267861d$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$7034513a4267861d$var$kPaused] = true;
    return this;
};
function $7034513a4267861d$var$flow(stream) {
    var state = stream._readableState;
    $7034513a4267861d$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7034513a4267861d$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $7034513a4267861d$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $7034513a4267861d$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$7034513a4267861d$var$Readable.prototype[$7034513a4267861d$var$SymbolAsyncIterator] = function() {
    return $7034513a4267861d$var$streamToAsyncIterator(this);
};
$7034513a4267861d$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $7034513a4267861d$require$validateObject(options, 'options');
    return $7034513a4267861d$var$streamToAsyncIterator(this, options);
};
function $7034513a4267861d$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $7034513a4267861d$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $7034513a4267861d$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $7034513a4267861d$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $7034513a4267861d$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $7034513a4267861d$var$nop;
                    stream.on('readable', next);
                    cleanup = $2KEat(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $7034513a4267861d$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $7034513a4267861d$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $7034513a4267861d$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $7034513a4267861d$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $329Hf.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$7034513a4267861d$var$ObjectDefineProperties($7034513a4267861d$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$7034513a4267861d$var$ObjectDefineProperties($7034513a4267861d$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$7034513a4267861d$var$kPaused] !== false;
        },
        set: function(value) {
            this[$7034513a4267861d$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$7034513a4267861d$var$Readable._fromList = $7034513a4267861d$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7034513a4267861d$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7034513a4267861d$var$endReadable(stream) {
    var state = stream._readableState;
    $7034513a4267861d$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($7034513a4267861d$var$endReadableNT, state, stream);
    }
}
function $7034513a4267861d$var$endReadableNT(state, stream) {
    $7034513a4267861d$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($7034513a4267861d$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $7034513a4267861d$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$7034513a4267861d$var$Readable.from = function(iterable, opts) {
    return $hs5Ep($7034513a4267861d$var$Readable, iterable, opts);
};
var $7034513a4267861d$var$webStreamsAdapters;
// Lazy to avoid circular references
function $7034513a4267861d$var$lazyWebStreams() {
    if ($7034513a4267861d$var$webStreamsAdapters === undefined) $7034513a4267861d$var$webStreamsAdapters = {};
    return $7034513a4267861d$var$webStreamsAdapters;
}
$7034513a4267861d$var$Readable.fromWeb = function(readableStream, options) {
    return $7034513a4267861d$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$7034513a4267861d$var$Readable.toWeb = function(streamReadable, options) {
    return $7034513a4267861d$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$7034513a4267861d$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $7034513a4267861d$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $329Hf.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("7eOXa", function(module, exports) {
'use strict';

var $01kWT = parcelRequire("01kWT");
var $54515d78a6e21a4e$var$ArrayIsArray = $01kWT.ArrayIsArray, $54515d78a6e21a4e$var$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $54515d78a6e21a4e$var$EE = $bBoAO.EventEmitter;
function $54515d78a6e21a4e$var$Stream(opts) {
    $54515d78a6e21a4e$var$EE.call(this, opts);
}
$54515d78a6e21a4e$var$ObjectSetPrototypeOf($54515d78a6e21a4e$var$Stream.prototype, $54515d78a6e21a4e$var$EE.prototype);
$54515d78a6e21a4e$var$ObjectSetPrototypeOf($54515d78a6e21a4e$var$Stream, $54515d78a6e21a4e$var$EE);
$54515d78a6e21a4e$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($54515d78a6e21a4e$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $54515d78a6e21a4e$var$prependListener(source, 'error', onerror);
    $54515d78a6e21a4e$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $54515d78a6e21a4e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($54515d78a6e21a4e$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $54515d78a6e21a4e$var$Stream,
    prependListener: $54515d78a6e21a4e$var$prependListener
};

});

parcelRegister("glIk8", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $be70fd44111d2b0e$export$e2db56ee53255a0; }, function (v) { return $be70fd44111d2b0e$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $be70fd44111d2b0e$export$11956e9313f43de0; }, function (v) { return $be70fd44111d2b0e$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $be70fd44111d2b0e$export$e2db56ee53255a0;
var $be70fd44111d2b0e$export$11956e9313f43de0;
'use strict';

var $01kWT = parcelRequire("01kWT");
var $be70fd44111d2b0e$require$SymbolDispose = $01kWT.SymbolDispose;

var $bsbC4 = parcelRequire("bsbC4");
var $be70fd44111d2b0e$var$AbortError = $bsbC4.AbortError, $be70fd44111d2b0e$var$codes = $bsbC4.codes;

var $2VP5Y = parcelRequire("2VP5Y");
var $be70fd44111d2b0e$var$isNodeStream = $2VP5Y.isNodeStream, $be70fd44111d2b0e$var$isWebStream = $2VP5Y.isWebStream, $be70fd44111d2b0e$var$kControllerErrorFunction = $2VP5Y.kControllerErrorFunction;

var $2KEat = parcelRequire("2KEat");
var $be70fd44111d2b0e$var$ERR_INVALID_ARG_TYPE = $be70fd44111d2b0e$var$codes.ERR_INVALID_ARG_TYPE;
var $be70fd44111d2b0e$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $be70fd44111d2b0e$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $be70fd44111d2b0e$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$be70fd44111d2b0e$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $be70fd44111d2b0e$var$validateAbortSignal(signal, 'signal');
    if (!$be70fd44111d2b0e$var$isNodeStream(stream) && !$be70fd44111d2b0e$var$isWebStream(stream)) throw new $be70fd44111d2b0e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $be70fd44111d2b0e$export$11956e9313f43de0(signal, stream);
};

$be70fd44111d2b0e$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $be70fd44111d2b0e$var$isNodeStream(stream) ? function() {
        stream.destroy(new $be70fd44111d2b0e$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$be70fd44111d2b0e$var$kControllerErrorFunction](new $be70fd44111d2b0e$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $be70fd44111d2b0e$var$addAbortListener = $be70fd44111d2b0e$var$addAbortListener || (parcelRequire("f6h6y")).addAbortListener;
        var disposable = $be70fd44111d2b0e$var$addAbortListener(signal, onAbort);
        $2KEat(stream, disposable[$be70fd44111d2b0e$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9zo3z", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $6f7a0b19059ddf2f$var$StringPrototypeSlice = $01kWT.StringPrototypeSlice, $6f7a0b19059ddf2f$var$SymbolIterator = $01kWT.SymbolIterator, $6f7a0b19059ddf2f$var$TypedArrayPrototypeSet = $01kWT.TypedArrayPrototypeSet, $6f7a0b19059ddf2f$var$Uint8Array = $01kWT.Uint8Array;

var $gywOi = parcelRequire("gywOi");
var $6f7a0b19059ddf2f$require$Buffer = $gywOi.Buffer;

var $f6h6y = parcelRequire("f6h6y");
var $6f7a0b19059ddf2f$require$inspect = $f6h6y.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $6f7a0b19059ddf2f$require$Buffer.alloc(0);
                var ret = $6f7a0b19059ddf2f$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $6f7a0b19059ddf2f$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $6f7a0b19059ddf2f$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $6f7a0b19059ddf2f$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $6f7a0b19059ddf2f$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $6f7a0b19059ddf2f$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $6f7a0b19059ddf2f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $6f7a0b19059ddf2f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $6f7a0b19059ddf2f$var$TypedArrayPrototypeSet(ret, new $6f7a0b19059ddf2f$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $6f7a0b19059ddf2f$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("4dlVb", function(module, exports) {
'use strict';

var $01kWT = parcelRequire("01kWT");
var $3119616d21a44bbb$var$MathFloor = $01kWT.MathFloor, $3119616d21a44bbb$var$NumberIsInteger = $01kWT.NumberIsInteger;

var $4Lq9R = parcelRequire("4Lq9R");
var $3119616d21a44bbb$require$validateInteger = $4Lq9R.validateInteger;

var $3119616d21a44bbb$var$ERR_INVALID_ARG_VALUE = (parcelRequire("bsbC4")).codes.ERR_INVALID_ARG_VALUE;
var $3119616d21a44bbb$var$defaultHighWaterMarkBytes = 16384;
var $3119616d21a44bbb$var$defaultHighWaterMarkObjectMode = 16;
function $3119616d21a44bbb$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3119616d21a44bbb$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $3119616d21a44bbb$var$defaultHighWaterMarkObjectMode : $3119616d21a44bbb$var$defaultHighWaterMarkBytes;
}
function $3119616d21a44bbb$var$setDefaultHighWaterMark(objectMode, value) {
    $3119616d21a44bbb$require$validateInteger(value, 'value', 0);
    if (objectMode) $3119616d21a44bbb$var$defaultHighWaterMarkObjectMode = value;
    else $3119616d21a44bbb$var$defaultHighWaterMarkBytes = value;
}
function $3119616d21a44bbb$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $3119616d21a44bbb$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$3119616d21a44bbb$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $3119616d21a44bbb$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $3119616d21a44bbb$var$MathFloor(hwm);
    }
    // Default value
    return $3119616d21a44bbb$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $3119616d21a44bbb$var$getHighWaterMark,
    getDefaultHighWaterMark: $3119616d21a44bbb$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $3119616d21a44bbb$var$setDefaultHighWaterMark
};

});

parcelRegister("hs5Ep", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $01kWT = parcelRequire("01kWT");
/* replacement end */ var $cb496f53a74cad12$var$PromisePrototypeThen = $01kWT.PromisePrototypeThen, $cb496f53a74cad12$var$SymbolAsyncIterator = $01kWT.SymbolAsyncIterator, $cb496f53a74cad12$var$SymbolIterator = $01kWT.SymbolIterator;

var $gywOi = parcelRequire("gywOi");
var $cb496f53a74cad12$require$Buffer = $gywOi.Buffer;

var $bsbC4 = parcelRequire("bsbC4");
var $cb496f53a74cad12$require$_require_codes = $bsbC4.codes;
var $cb496f53a74cad12$var$ERR_INVALID_ARG_TYPE = $cb496f53a74cad12$require$_require_codes.ERR_INVALID_ARG_TYPE, $cb496f53a74cad12$var$ERR_STREAM_NULL_VALUES = $cb496f53a74cad12$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $cb496f53a74cad12$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $cb496f53a74cad12$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$cb496f53a74cad12$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$cb496f53a74cad12$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$cb496f53a74cad12$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$cb496f53a74cad12$var$SymbolIterator]();
    } else throw new $cb496f53a74cad12$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $cb496f53a74cad12$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $cb496f53a74cad12$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $cb496f53a74cad12$var$from;

});


parcelRegister("3x7Uf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $01kWT = parcelRequire("01kWT");
/* replacement end */ var $292a962fc57b3ed0$var$ArrayPrototypeSlice = $01kWT.ArrayPrototypeSlice, $292a962fc57b3ed0$var$Error = $01kWT.Error, $292a962fc57b3ed0$var$FunctionPrototypeSymbolHasInstance = $01kWT.FunctionPrototypeSymbolHasInstance, $292a962fc57b3ed0$var$ObjectDefineProperty = $01kWT.ObjectDefineProperty, $292a962fc57b3ed0$var$ObjectDefineProperties = $01kWT.ObjectDefineProperties, $292a962fc57b3ed0$var$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf, $292a962fc57b3ed0$var$StringPrototypeToLowerCase = $01kWT.StringPrototypeToLowerCase, $292a962fc57b3ed0$var$Symbol = $01kWT.Symbol, $292a962fc57b3ed0$var$SymbolHasInstance = $01kWT.SymbolHasInstance;
module.exports = $292a962fc57b3ed0$var$Writable;
$292a962fc57b3ed0$var$Writable.WritableState = $292a962fc57b3ed0$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $292a962fc57b3ed0$var$EE = $bBoAO.EventEmitter;

var $7eOXa = parcelRequire("7eOXa");
var $292a962fc57b3ed0$require$Stream = $7eOXa.Stream;

var $gywOi = parcelRequire("gywOi");
var $292a962fc57b3ed0$require$Buffer = $gywOi.Buffer;

var $329Hf = parcelRequire("329Hf");

var $glIk8 = parcelRequire("glIk8");
var $292a962fc57b3ed0$require$addAbortSignal = $glIk8.addAbortSignal;

var $4dlVb = parcelRequire("4dlVb");
var $292a962fc57b3ed0$var$getHighWaterMark = $4dlVb.getHighWaterMark, $292a962fc57b3ed0$var$getDefaultHighWaterMark = $4dlVb.getDefaultHighWaterMark;

var $bsbC4 = parcelRequire("bsbC4");
var $292a962fc57b3ed0$require$_require_codes = $bsbC4.codes;
var $292a962fc57b3ed0$var$ERR_INVALID_ARG_TYPE = $292a962fc57b3ed0$require$_require_codes.ERR_INVALID_ARG_TYPE, $292a962fc57b3ed0$var$ERR_METHOD_NOT_IMPLEMENTED = $292a962fc57b3ed0$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $292a962fc57b3ed0$var$ERR_MULTIPLE_CALLBACK = $292a962fc57b3ed0$require$_require_codes.ERR_MULTIPLE_CALLBACK, $292a962fc57b3ed0$var$ERR_STREAM_CANNOT_PIPE = $292a962fc57b3ed0$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED = $292a962fc57b3ed0$require$_require_codes.ERR_STREAM_DESTROYED, $292a962fc57b3ed0$var$ERR_STREAM_ALREADY_FINISHED = $292a962fc57b3ed0$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $292a962fc57b3ed0$var$ERR_STREAM_NULL_VALUES = $292a962fc57b3ed0$require$_require_codes.ERR_STREAM_NULL_VALUES, $292a962fc57b3ed0$var$ERR_STREAM_WRITE_AFTER_END = $292a962fc57b3ed0$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $292a962fc57b3ed0$var$ERR_UNKNOWN_ENCODING = $292a962fc57b3ed0$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $292a962fc57b3ed0$var$errorOrDestroy = $329Hf.errorOrDestroy;
$292a962fc57b3ed0$var$ObjectSetPrototypeOf($292a962fc57b3ed0$var$Writable.prototype, $292a962fc57b3ed0$require$Stream.prototype);
$292a962fc57b3ed0$var$ObjectSetPrototypeOf($292a962fc57b3ed0$var$Writable, $292a962fc57b3ed0$require$Stream);
function $292a962fc57b3ed0$var$nop() {}
var $292a962fc57b3ed0$var$kOnFinished = $292a962fc57b3ed0$var$Symbol('kOnFinished');

function $292a962fc57b3ed0$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("itmui"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $292a962fc57b3ed0$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $292a962fc57b3ed0$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $292a962fc57b3ed0$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $292a962fc57b3ed0$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$292a962fc57b3ed0$var$kOnFinished] = [];
}
function $292a962fc57b3ed0$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$292a962fc57b3ed0$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $292a962fc57b3ed0$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$292a962fc57b3ed0$var$ObjectDefineProperty($292a962fc57b3ed0$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $292a962fc57b3ed0$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("itmui"));
    if (!isDuplex && !$292a962fc57b3ed0$var$FunctionPrototypeSymbolHasInstance($292a962fc57b3ed0$var$Writable, this)) return new $292a962fc57b3ed0$var$Writable(options);
    this._writableState = new $292a962fc57b3ed0$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $292a962fc57b3ed0$require$addAbortSignal(options.signal, this);
    }
    $292a962fc57b3ed0$require$Stream.call(this, options);
    $329Hf.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $292a962fc57b3ed0$var$clearBuffer(_this, state);
        $292a962fc57b3ed0$var$finishMaybe(_this, state);
    });
}
$292a962fc57b3ed0$var$ObjectDefineProperty($292a962fc57b3ed0$var$Writable, $292a962fc57b3ed0$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($292a962fc57b3ed0$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $292a962fc57b3ed0$var$Writable) return false;
        return object && object._writableState instanceof $292a962fc57b3ed0$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$292a962fc57b3ed0$var$Writable.prototype.pipe = function() {
    $292a962fc57b3ed0$var$errorOrDestroy(this, new $292a962fc57b3ed0$var$ERR_STREAM_CANNOT_PIPE());
};
function $292a962fc57b3ed0$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$292a962fc57b3ed0$require$Buffer.isEncoding(encoding)) throw new $292a962fc57b3ed0$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $292a962fc57b3ed0$var$nop;
    }
    if (chunk === null) throw new $292a962fc57b3ed0$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $292a962fc57b3ed0$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $292a962fc57b3ed0$require$Buffer) encoding = 'buffer';
        else if ($292a962fc57b3ed0$require$Stream._isUint8Array(chunk)) {
            chunk = $292a962fc57b3ed0$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $292a962fc57b3ed0$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $292a962fc57b3ed0$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $292a962fc57b3ed0$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $292a962fc57b3ed0$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$292a962fc57b3ed0$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $292a962fc57b3ed0$var$_write(this, chunk, encoding, cb) === true;
};
$292a962fc57b3ed0$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$292a962fc57b3ed0$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $292a962fc57b3ed0$var$clearBuffer(this, state);
    }
};
$292a962fc57b3ed0$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $292a962fc57b3ed0$var$StringPrototypeToLowerCase(encoding);
    if (!$292a962fc57b3ed0$require$Buffer.isEncoding(encoding)) throw new $292a962fc57b3ed0$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $292a962fc57b3ed0$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $292a962fc57b3ed0$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $292a962fc57b3ed0$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $292a962fc57b3ed0$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $292a962fc57b3ed0$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $292a962fc57b3ed0$var$errorOrDestroy(stream, er);
}
function $292a962fc57b3ed0$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $292a962fc57b3ed0$var$errorOrDestroy(stream, new $292a962fc57b3ed0$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($292a962fc57b3ed0$var$onwriteError, stream, state, er, cb);
        else $292a962fc57b3ed0$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $292a962fc57b3ed0$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($292a962fc57b3ed0$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $292a962fc57b3ed0$var$afterWrite(stream, state, 1, cb);
    }
}
function $292a962fc57b3ed0$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $292a962fc57b3ed0$var$afterWrite(stream, state, count, cb);
}
function $292a962fc57b3ed0$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $292a962fc57b3ed0$var$errorBuffer(state);
    $292a962fc57b3ed0$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $292a962fc57b3ed0$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$292a962fc57b3ed0$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED('end'));
    }
    $292a962fc57b3ed0$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $292a962fc57b3ed0$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $292a962fc57b3ed0$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $292a962fc57b3ed0$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $292a962fc57b3ed0$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $292a962fc57b3ed0$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $292a962fc57b3ed0$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $292a962fc57b3ed0$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$292a962fc57b3ed0$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $292a962fc57b3ed0$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$292a962fc57b3ed0$var$Writable.prototype._writev = null;
$292a962fc57b3ed0$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $292a962fc57b3ed0$var$_write(this, chunk, encoding);
        if (ret instanceof $292a962fc57b3ed0$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $292a962fc57b3ed0$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $292a962fc57b3ed0$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $292a962fc57b3ed0$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$292a962fc57b3ed0$var$kOnFinished].push(cb);
    }
    return this;
};
function $292a962fc57b3ed0$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $292a962fc57b3ed0$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $292a962fc57b3ed0$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $292a962fc57b3ed0$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$292a962fc57b3ed0$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $292a962fc57b3ed0$var$errorOrDestroy(stream, err, state.sync);
        } else if ($292a962fc57b3ed0$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($292a962fc57b3ed0$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $292a962fc57b3ed0$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $292a962fc57b3ed0$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $292a962fc57b3ed0$var$finishMaybe(stream, state, sync) {
    if ($292a962fc57b3ed0$var$needFinish(state)) {
        $292a962fc57b3ed0$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($292a962fc57b3ed0$var$needFinish(state)) $292a962fc57b3ed0$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($292a962fc57b3ed0$var$needFinish(state)) {
                state.pendingcb++;
                $292a962fc57b3ed0$var$finish(stream, state);
            }
        }
    }
}
function $292a962fc57b3ed0$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$292a962fc57b3ed0$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$292a962fc57b3ed0$var$ObjectDefineProperties($292a962fc57b3ed0$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $292a962fc57b3ed0$var$destroy = $329Hf.destroy;
$292a962fc57b3ed0$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$292a962fc57b3ed0$var$kOnFinished].length)) $2Qkr5.nextTick($292a962fc57b3ed0$var$errorBuffer, state);
    $292a962fc57b3ed0$var$destroy.call(this, err, cb);
    return this;
};
$292a962fc57b3ed0$var$Writable.prototype._undestroy = $329Hf.undestroy;
$292a962fc57b3ed0$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$292a962fc57b3ed0$var$Writable.prototype[$292a962fc57b3ed0$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $292a962fc57b3ed0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $292a962fc57b3ed0$var$lazyWebStreams() {
    if ($292a962fc57b3ed0$var$webStreamsAdapters === undefined) $292a962fc57b3ed0$var$webStreamsAdapters = {};
    return $292a962fc57b3ed0$var$webStreamsAdapters;
}
$292a962fc57b3ed0$var$Writable.fromWeb = function(writableStream, options) {
    return $292a962fc57b3ed0$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$292a962fc57b3ed0$var$Writable.toWeb = function(streamWritable) {
    return $292a962fc57b3ed0$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("axpQw", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $gywOi = parcelRequire("gywOi");

var $2VP5Y = parcelRequire("2VP5Y");
var $7ac108eea3eea6b4$var$isReadable = $2VP5Y.isReadable, $7ac108eea3eea6b4$var$isWritable = $2VP5Y.isWritable, $7ac108eea3eea6b4$var$isIterable = $2VP5Y.isIterable, $7ac108eea3eea6b4$var$isNodeStream = $2VP5Y.isNodeStream, $7ac108eea3eea6b4$var$isReadableNodeStream = $2VP5Y.isReadableNodeStream, $7ac108eea3eea6b4$var$isWritableNodeStream = $2VP5Y.isWritableNodeStream, $7ac108eea3eea6b4$var$isDuplexNodeStream = $2VP5Y.isDuplexNodeStream, $7ac108eea3eea6b4$var$isReadableStream = $2VP5Y.isReadableStream, $7ac108eea3eea6b4$var$isWritableStream = $2VP5Y.isWritableStream;

var $2KEat = parcelRequire("2KEat");

var $bsbC4 = parcelRequire("bsbC4");
var $7ac108eea3eea6b4$var$AbortError = $bsbC4.AbortError, $7ac108eea3eea6b4$var$_require_codes = $bsbC4.codes, $7ac108eea3eea6b4$var$ERR_INVALID_ARG_TYPE = $7ac108eea3eea6b4$var$_require_codes.ERR_INVALID_ARG_TYPE, $7ac108eea3eea6b4$var$ERR_INVALID_RETURN_VALUE = $7ac108eea3eea6b4$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $329Hf = parcelRequire("329Hf");
var $7ac108eea3eea6b4$require$destroyer = $329Hf.destroyer;

var $itmui = parcelRequire("itmui");

var $9Dgc3 = parcelRequire("9Dgc3");

var $3x7Uf = parcelRequire("3x7Uf");

var $f6h6y = parcelRequire("f6h6y");
var $7ac108eea3eea6b4$require$createDeferredPromise = $f6h6y.createDeferredPromise;

var $hs5Ep = parcelRequire("hs5Ep");
var $7ac108eea3eea6b4$var$Blob = globalThis.Blob || $gywOi.Blob;
var $7ac108eea3eea6b4$var$isBlob = typeof $7ac108eea3eea6b4$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $7ac108eea3eea6b4$var$Blob;
} : function isBlob(b) {
    return false;
};

var $7ac108eea3eea6b4$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $01kWT = parcelRequire("01kWT");
var $7ac108eea3eea6b4$require$FunctionPrototypeCall = $01kWT.FunctionPrototypeCall;
// This is needed for pre node 17.
var $7ac108eea3eea6b4$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($itmui);
module.exports = function duplexify(body, name) {
    if ($7ac108eea3eea6b4$var$isDuplexNodeStream(body)) return body;
    if ($7ac108eea3eea6b4$var$isReadableNodeStream(body)) return $7ac108eea3eea6b4$var$_duplexify({
        readable: body
    });
    if ($7ac108eea3eea6b4$var$isWritableNodeStream(body)) return $7ac108eea3eea6b4$var$_duplexify({
        writable: body
    });
    if ($7ac108eea3eea6b4$var$isNodeStream(body)) return $7ac108eea3eea6b4$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($7ac108eea3eea6b4$var$isReadableStream(body)) return $7ac108eea3eea6b4$var$_duplexify({
        readable: $9Dgc3.fromWeb(body)
    });
    if ($7ac108eea3eea6b4$var$isWritableStream(body)) return $7ac108eea3eea6b4$var$_duplexify({
        writable: $3x7Uf.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $7ac108eea3eea6b4$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($7ac108eea3eea6b4$var$isIterable(value)) return $hs5Ep($7ac108eea3eea6b4$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $7ac108eea3eea6b4$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $7ac108eea3eea6b4$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $7ac108eea3eea6b4$require$destroyer(d, err);
            });
            return d = new $7ac108eea3eea6b4$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $7ac108eea3eea6b4$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($7ac108eea3eea6b4$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($7ac108eea3eea6b4$var$isIterable(body)) return $hs5Ep($7ac108eea3eea6b4$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($7ac108eea3eea6b4$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $7ac108eea3eea6b4$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $7ac108eea3eea6b4$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $7ac108eea3eea6b4$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $7ac108eea3eea6b4$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $7ac108eea3eea6b4$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $7ac108eea3eea6b4$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $7ac108eea3eea6b4$require$destroyer(d1, err);
        });
        return d1 = new $7ac108eea3eea6b4$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $7ac108eea3eea6b4$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $7ac108eea3eea6b4$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $7ac108eea3eea6b4$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $7ac108eea3eea6b4$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $7ac108eea3eea6b4$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $7ac108eea3eea6b4$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $7ac108eea3eea6b4$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $9Dgc3.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$7ac108eea3eea6b4$var$isReadable(r);
    var writable = !!$7ac108eea3eea6b4$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $7ac108eea3eea6b4$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2KEat(w, function(err) {
            writable = false;
            if (err) $7ac108eea3eea6b4$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2KEat(r, function(err) {
            readable = false;
            if (err) $7ac108eea3eea6b4$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $7ac108eea3eea6b4$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $7ac108eea3eea6b4$require$destroyer(w, err);
            $7ac108eea3eea6b4$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("iNbiQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $01kWT = parcelRequire("01kWT");
var $dae59226544fe554$require$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf;
module.exports = $dae59226544fe554$var$PassThrough;

var $fJjUG = parcelRequire("fJjUG");
$dae59226544fe554$require$ObjectSetPrototypeOf($dae59226544fe554$var$PassThrough.prototype, $fJjUG.prototype);
$dae59226544fe554$require$ObjectSetPrototypeOf($dae59226544fe554$var$PassThrough, $fJjUG);
function $dae59226544fe554$var$PassThrough(options) {
    if (!(this instanceof $dae59226544fe554$var$PassThrough)) return new $dae59226544fe554$var$PassThrough(options);
    $fJjUG.call(this, options);
}
$dae59226544fe554$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("fJjUG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $b73a8153f4826496$var$ObjectSetPrototypeOf = $01kWT.ObjectSetPrototypeOf, $b73a8153f4826496$var$Symbol = $01kWT.Symbol;
module.exports = $b73a8153f4826496$var$Transform;

var $b73a8153f4826496$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("bsbC4")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $itmui = parcelRequire("itmui");

var $4dlVb = parcelRequire("4dlVb");
var $b73a8153f4826496$require$getHighWaterMark = $4dlVb.getHighWaterMark;
$b73a8153f4826496$var$ObjectSetPrototypeOf($b73a8153f4826496$var$Transform.prototype, $itmui.prototype);
$b73a8153f4826496$var$ObjectSetPrototypeOf($b73a8153f4826496$var$Transform, $itmui);
var $b73a8153f4826496$var$kCallback = $b73a8153f4826496$var$Symbol('kCallback');
function $b73a8153f4826496$var$Transform(options) {
    if (!(this instanceof $b73a8153f4826496$var$Transform)) return new $b73a8153f4826496$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $b73a8153f4826496$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $itmui.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$b73a8153f4826496$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $b73a8153f4826496$var$prefinish);
}
function $b73a8153f4826496$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $b73a8153f4826496$var$prefinish() {
    if (this._final !== $b73a8153f4826496$var$_final) $b73a8153f4826496$var$_final.call(this);
}
$b73a8153f4826496$var$Transform.prototype._final = $b73a8153f4826496$var$_final;
$b73a8153f4826496$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $b73a8153f4826496$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$b73a8153f4826496$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$b73a8153f4826496$var$kCallback] = callback;
    });
};
$b73a8153f4826496$var$Transform.prototype._read = function() {
    if (this[$b73a8153f4826496$var$kCallback]) {
        var callback = this[$b73a8153f4826496$var$kCallback];
        this[$b73a8153f4826496$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("hmVGK", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $01kWT = parcelRequire("01kWT");
var $ca513d7dc9235135$var$ArrayPrototypePop = $01kWT.ArrayPrototypePop, $ca513d7dc9235135$var$Promise = $01kWT.Promise;

var $2VP5Y = parcelRequire("2VP5Y");
var $ca513d7dc9235135$var$isIterable = $2VP5Y.isIterable, $ca513d7dc9235135$var$isNodeStream = $2VP5Y.isNodeStream, $ca513d7dc9235135$var$isWebStream = $2VP5Y.isWebStream;

var $eMv1z = parcelRequire("eMv1z");
var $ca513d7dc9235135$var$pl = $eMv1z.pipelineImpl;

var $2KEat = parcelRequire("2KEat");
var $ca513d7dc9235135$require$finished = $2KEat.finished;
parcelRequire("AXlQY");
function $ca513d7dc9235135$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $ca513d7dc9235135$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$ca513d7dc9235135$var$isNodeStream(lastArg) && !$ca513d7dc9235135$var$isIterable(lastArg) && !$ca513d7dc9235135$var$isWebStream(lastArg)) {
            var options = $ca513d7dc9235135$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $ca513d7dc9235135$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $ca513d7dc9235135$require$finished,
    pipeline: $ca513d7dc9235135$var$pipeline
};

});





parcelRegister("49sET", function(module, exports) {
"use strict";
var $305e3ba9f7b497d3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $305e3ba9f7b497d3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $305e3ba9f7b497d3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$305e3ba9f7b497d3$var$__exportStar((parcelRequire("fQikt")), module.exports);

});
parcelRegister("fQikt", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlTsv = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $3veIK = parcelRequire("3veIK");

var $zfuFE = parcelRequire("zfuFE");
/**
 * A comunica SPARQL TSV Query Result Serialize Actor.
 */ var $b889ee1f787d77bf$var$ActorQueryResultSerializeSparqlTsv = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeSparqlTsv, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeSparqlTsv(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeSparqlTsv);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeSparqlTsv, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeSparqlTsv, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.type !== 'bindings') return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var bindingsAction, data, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                bindingsAction = action;
                                data = new $zfuFE.Readable();
                                return [
                                    4,
                                    bindingsAction.metadata()
                                ];
                            case 1:
                                metadata = _state.sent();
                                data.push("".concat(metadata.variables.map(function(variable) {
                                    return variable.variable.value;
                                }).join('\t'), "\n"));
                                // Write Bindings
                                data.wrap(bindingsAction.bindingsStream.map(function(bindings) {
                                    return "".concat(metadata.variables.map(function(key) {
                                        return ActorQueryResultSerializeSparqlTsv.bindingToTsvBindings(bindings.get(key.variable));
                                    }).join('\t'), "\n");
                                }));
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "bindingToTsvBindings",
            value: /**
     * Converts an RDF term to its TSV representation.
     * @param {RDF.Term} value An RDF term.
     * @return {string} A string representation of the given value.
     */ function bindingToTsvBindings(value) {
                if (!value) return '';
                // Escape tab, newline and carriage return characters
                return (0, $3veIK.termToString)(value).replaceAll('\t', '\\t').replaceAll('\n', '\\n').replaceAll('\r', '\\r');
            }
        }
    ]);
    return ActorQueryResultSerializeSparqlTsv;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeSparqlTsv = $b889ee1f787d77bf$var$ActorQueryResultSerializeSparqlTsv;

});
parcelRegister("3veIK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralLanguage = void 0;

var $dj6jQ = parcelRequire("dj6jQ");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function get() {
        return $dj6jQ.termToString;
    }
});

});
parcelRegister("dj6jQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.stringToTerm = module.exports.getLiteralLanguage = module.exports.getLiteralType = module.exports.getLiteralValue = module.exports.termToString = void 0;

var $2ej16 = parcelRequire("2ej16");
var $9b01f388968a1da3$var$FACTORY = new $2ej16.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables: '_myVariable'
 * * Literals: '"myString"', '"myLanguageString"@en-us', '"<p>e</p>"^^<http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML>'
 * * URIs: '<http://example.org>'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $9b01f388968a1da3$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return "<".concat($9b01f388968a1da3$var$escapeIRI(term.value), ">");
        case 'BlankNode':
            return "_:".concat(term.value);
        case 'Literal':
            {
                var literalValue = term;
                return '"'.concat($9b01f388968a1da3$var$escapeStringRDF(literalValue.value), '"').concat(literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' ? "^^<".concat(literalValue.datatype.value, ">") : '').concat(literalValue.language ? "@".concat(literalValue.language) : '');
            }
        case 'Quad':
            return "<<".concat($9b01f388968a1da3$var$termToString(term.subject), " ").concat($9b01f388968a1da3$var$termToString(term.predicate), " ").concat($9b01f388968a1da3$var$termToString(term.object)).concat(term.graph.termType === 'DefaultGraph' ? '' : " ".concat($9b01f388968a1da3$var$termToString(term.graph)), ">>");
        case 'Variable':
            return "?".concat(term.value);
        case 'DefaultGraph':
            return term.value;
    }
}
module.exports.termToString = $9b01f388968a1da3$var$termToString;
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $9b01f388968a1da3$var$getLiteralValue(literalValue) {
    var match = RegExp('^"([^]*)"((\\^\\^.*)|(@.*))?$', "u").exec(literalValue);
    if (!match) throw new Error("".concat(literalValue, " is not a literal"));
    return match[1].replace(RegExp('\\\\"', "ug"), '"');
}
module.exports.getLiteralValue = $9b01f388968a1da3$var$getLiteralValue;
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $9b01f388968a1da3$var$getLiteralType(literalValue) {
    var match = RegExp('^"[^]*"(?:\\^\\^<([^"]+)>|(@)[^@"]+)?$', "u").exec(literalValue);
    if (!match) throw new Error("".concat(literalValue, " is not a literal"));
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
module.exports.getLiteralType = $9b01f388968a1da3$var$getLiteralType;
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $9b01f388968a1da3$var$getLiteralLanguage(literalValue) {
    var match = RegExp('^"[^]*"(?:@([^@"]+)|\\^\\^[^"]+)?$', "u").exec(literalValue);
    if (!match) throw new Error("".concat(literalValue, " is not a literal"));
    return match[1] ? match[1].toLowerCase() : '';
}
module.exports.getLiteralLanguage = $9b01f388968a1da3$var$getLiteralLanguage;
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $9b01f388968a1da3$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $9b01f388968a1da3$var$FACTORY;
    if (!value || value.length === 0) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.slice(2));
        case '?':
            if (!dataFactory.variable) throw new Error("Missing 'variable()' method on the given DataFactory");
            return dataFactory.variable(value.slice(1));
        case '"':
            {
                var language = $9b01f388968a1da3$var$getLiteralLanguage(value);
                var type = dataFactory.namedNode($9b01f388968a1da3$var$getLiteralType(value));
                return dataFactory.literal($9b01f388968a1da3$var$getLiteralValue(value), language || type);
            }
        case '<':
        default:
            if (value.startsWith('<<') && value.endsWith('>>')) {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                var terms = value.slice(2, -2);
                var stringTerms = [];
                var ignoreTags = 0;
                var lastIndex = 0;
                for(var i = 0; i < terms.length; i++){
                    var _char = terms[i];
                    if (_char === '<') ignoreTags++;
                    if (_char === '>') {
                        if (ignoreTags === 0) throw new Error("Found closing tag without opening tag in ".concat(value));
                        else ignoreTags--;
                    }
                    if (_char === ' ' && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error("Found opening tag without closing tag in ".concat(value));
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error("Nested quad syntax error ".concat(value));
                return dataFactory.quad($9b01f388968a1da3$var$stringToTerm(stringTerms[0]), $9b01f388968a1da3$var$stringToTerm(stringTerms[1]), $9b01f388968a1da3$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $9b01f388968a1da3$var$stringToTerm(stringTerms[3]) : undefined);
            }
            if (!value.startsWith('<') || !value.endsWith('>')) throw new Error("Detected invalid iri for named node (must be wrapped in <>): ".concat(value));
            return dataFactory.namedNode(value.slice(1, -1));
    }
}
module.exports.stringToTerm = $9b01f388968a1da3$var$stringToTerm;
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $9b01f388968a1da3$var$quadToStringQuad(quad) {
    return {
        subject: $9b01f388968a1da3$var$termToString(quad.subject),
        predicate: $9b01f388968a1da3$var$termToString(quad.predicate),
        object: $9b01f388968a1da3$var$termToString(quad.object),
        graph: $9b01f388968a1da3$var$termToString(quad.graph)
    };
}
module.exports.quadToStringQuad = $9b01f388968a1da3$var$quadToStringQuad;
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $9b01f388968a1da3$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $9b01f388968a1da3$var$FACTORY;
    return dataFactory.quad($9b01f388968a1da3$var$stringToTerm(stringQuad.subject, dataFactory), $9b01f388968a1da3$var$stringToTerm(stringQuad.predicate, dataFactory), $9b01f388968a1da3$var$stringToTerm(stringQuad.object, dataFactory), $9b01f388968a1da3$var$stringToTerm(stringQuad.graph, dataFactory));
}
module.exports.stringQuadToQuad = $9b01f388968a1da3$var$stringQuadToQuad;
function $9b01f388968a1da3$var$escapeIRI(iriValue) {
    return iriValue.replace($9b01f388968a1da3$var$escapePattern, $9b01f388968a1da3$var$replaceEscapedCharacter);
}
function $9b01f388968a1da3$var$escapeStringRDF(stringValue) {
    if ($9b01f388968a1da3$var$escapePattern.test(stringValue)) stringValue = stringValue.replace($9b01f388968a1da3$var$escapePattern, $9b01f388968a1da3$var$replaceEscapedCharacter);
    return stringValue;
}
// Characters in literals and IRIs that require escaping
// Also containing potential surrogate pairs
/* eslint-disable require-unicode-regexp */ /* eslint-disable unicorn/better-regex */ var $9b01f388968a1da3$var$escapePattern = /["\\\t\n\r\b\f\u0000-\u0019]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
/* eslint-enable require-unicode-regexp */ /* eslint-enable unicorn/better-regex */ var $9b01f388968a1da3$var$escapes = new Map([
    [
        '\\',
        '\\\\'
    ],
    [
        '"',
        '\\"'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\b',
        '\\b'
    ],
    [
        '\f',
        '\\f'
    ]
]);
function $9b01f388968a1da3$var$replaceEscapedCharacter(character) {
    // Try simplest case first, get replacement for character
    var result = $9b01f388968a1da3$var$escapes.get(character);
    if (!result) {
        if (character.length === 1) {
            // Single unicode charachters, i.e. not a surrogate pair
            var code = character.charCodeAt(0).toString(16);
            return "".concat('\\u0000'.slice(0, -code.length)).concat(code);
        }
        // Surrogate pairs
        var code1 = ((character.charCodeAt(0) - 55296) * 1024 + character.charCodeAt(1) + 9216).toString(16);
        return "".concat('\\U00000000'.slice(0, -code1.length)).concat(code1);
    }
    return result;
}

});


parcelRegister("zfuFE", function(module, exports) {
'use strict';

var $cRgOS = parcelRequire("cRgOS");

var $9GjPh = parcelRequire("9GjPh");
var $069f49b92d710387$var$originalDestroy = $cRgOS.Readable.destroy;
module.exports = $cRgOS.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $cRgOS._uint8ArrayToBuffer;
module.exports._isUint8Array = $cRgOS._isUint8Array;
module.exports.isDisturbed = $cRgOS.isDisturbed;
module.exports.isErrored = $cRgOS.isErrored;
module.exports.isReadable = $cRgOS.isReadable;
module.exports.Readable = $cRgOS.Readable;
module.exports.Writable = $cRgOS.Writable;
module.exports.Duplex = $cRgOS.Duplex;
module.exports.Transform = $cRgOS.Transform;
module.exports.PassThrough = $cRgOS.PassThrough;
module.exports.addAbortSignal = $cRgOS.addAbortSignal;
module.exports.finished = $cRgOS.finished;
module.exports.destroy = $cRgOS.destroy;
module.exports.destroy = $069f49b92d710387$var$originalDestroy;
module.exports.pipeline = $cRgOS.pipeline;
module.exports.compose = $cRgOS.compose;
Object.defineProperty($cRgOS, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $9GjPh;
    }
});
module.exports.Stream = $cRgOS.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("cRgOS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $bMIbb = parcelRequire("bMIbb");
var $95c77b4beaa6d8d1$require$Buffer = $bMIbb.Buffer;

var $hu6tI = parcelRequire("hu6tI");
/* replacement end */ var $95c77b4beaa6d8d1$var$ObjectDefineProperty = $hu6tI.ObjectDefineProperty, $95c77b4beaa6d8d1$var$ObjectKeys = $hu6tI.ObjectKeys, $95c77b4beaa6d8d1$var$ReflectApply = $hu6tI.ReflectApply;

var $fktRN = parcelRequire("fktRN");
var $95c77b4beaa6d8d1$var$_require_promisify = $fktRN.promisify, $95c77b4beaa6d8d1$var$customPromisify = $95c77b4beaa6d8d1$var$_require_promisify.custom;

var $dPqw8 = parcelRequire("dPqw8");
var $95c77b4beaa6d8d1$var$streamReturningOperators = $dPqw8.streamReturningOperators, $95c77b4beaa6d8d1$var$promiseReturningOperators = $dPqw8.promiseReturningOperators;

var $kwaL9 = parcelRequire("kwaL9");
var $95c77b4beaa6d8d1$var$ERR_ILLEGAL_CONSTRUCTOR = $kwaL9.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $hEIbf = parcelRequire("hEIbf");

var $8NU40 = parcelRequire("8NU40");
var $95c77b4beaa6d8d1$var$setDefaultHighWaterMark = $8NU40.setDefaultHighWaterMark, $95c77b4beaa6d8d1$var$getDefaultHighWaterMark = $8NU40.getDefaultHighWaterMark;

var $dNzXS = parcelRequire("dNzXS");
var $95c77b4beaa6d8d1$require$pipeline = $dNzXS.pipeline;

var $8oqOv = parcelRequire("8oqOv");
var $95c77b4beaa6d8d1$require$destroyer = $8oqOv.destroyer;

var $3lOnL = parcelRequire("3lOnL");
var $95c77b4beaa6d8d1$var$internalBuffer = {};

var $9GjPh = parcelRequire("9GjPh");

var $ekKVz = parcelRequire("ekKVz");

var $95c77b4beaa6d8d1$var$Stream = module.exports = (parcelRequire("i4Yg4")).Stream;
$95c77b4beaa6d8d1$var$Stream.isDestroyed = $ekKVz.isDestroyed;
$95c77b4beaa6d8d1$var$Stream.isDisturbed = $ekKVz.isDisturbed;
$95c77b4beaa6d8d1$var$Stream.isErrored = $ekKVz.isErrored;
$95c77b4beaa6d8d1$var$Stream.isReadable = $ekKVz.isReadable;
$95c77b4beaa6d8d1$var$Stream.isWritable = $ekKVz.isWritable;

$95c77b4beaa6d8d1$var$Stream.Readable = (parcelRequire("TYLM0"));
var $95c77b4beaa6d8d1$var$_iteratorNormalCompletion = true, $95c77b4beaa6d8d1$var$_didIteratorError = false, $95c77b4beaa6d8d1$var$_iteratorError = undefined;
try {
    for(var $95c77b4beaa6d8d1$var$_iterator = $95c77b4beaa6d8d1$var$ObjectKeys($95c77b4beaa6d8d1$var$streamReturningOperators)[Symbol.iterator](), $95c77b4beaa6d8d1$var$_step; !($95c77b4beaa6d8d1$var$_iteratorNormalCompletion = ($95c77b4beaa6d8d1$var$_step = $95c77b4beaa6d8d1$var$_iterator.next()).done); $95c77b4beaa6d8d1$var$_iteratorNormalCompletion = true){
        var $95c77b4beaa6d8d1$var$key = $95c77b4beaa6d8d1$var$_step.value;
        var $95c77b4beaa6d8d1$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $95c77b4beaa6d8d1$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $95c77b4beaa6d8d1$var$Stream.Readable.from($95c77b4beaa6d8d1$var$ReflectApply($95c77b4beaa6d8d1$var$op, this, args));
        };
        var $95c77b4beaa6d8d1$var$op = $95c77b4beaa6d8d1$var$streamReturningOperators[$95c77b4beaa6d8d1$var$key];
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$fn, 'name', {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$op.name
        });
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$fn, 'length', {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$op.length
        });
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$Stream.Readable.prototype, $95c77b4beaa6d8d1$var$key, {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $95c77b4beaa6d8d1$var$_didIteratorError = true;
    $95c77b4beaa6d8d1$var$_iteratorError = err;
} finally{
    try {
        if (!$95c77b4beaa6d8d1$var$_iteratorNormalCompletion && $95c77b4beaa6d8d1$var$_iterator["return"] != null) {
            $95c77b4beaa6d8d1$var$_iterator["return"]();
        }
    } finally{
        if ($95c77b4beaa6d8d1$var$_didIteratorError) {
            throw $95c77b4beaa6d8d1$var$_iteratorError;
        }
    }
}
var $95c77b4beaa6d8d1$var$_iteratorNormalCompletion1 = true, $95c77b4beaa6d8d1$var$_didIteratorError1 = false, $95c77b4beaa6d8d1$var$_iteratorError1 = undefined;
try {
    for(var $95c77b4beaa6d8d1$var$_iterator1 = $95c77b4beaa6d8d1$var$ObjectKeys($95c77b4beaa6d8d1$var$promiseReturningOperators)[Symbol.iterator](), $95c77b4beaa6d8d1$var$_step1; !($95c77b4beaa6d8d1$var$_iteratorNormalCompletion1 = ($95c77b4beaa6d8d1$var$_step1 = $95c77b4beaa6d8d1$var$_iterator1.next()).done); $95c77b4beaa6d8d1$var$_iteratorNormalCompletion1 = true){
        var $95c77b4beaa6d8d1$var$key1 = $95c77b4beaa6d8d1$var$_step1.value;
        var $95c77b4beaa6d8d1$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $95c77b4beaa6d8d1$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $95c77b4beaa6d8d1$var$ReflectApply($95c77b4beaa6d8d1$var$op1, this, args);
        };
        var $95c77b4beaa6d8d1$var$op1 = $95c77b4beaa6d8d1$var$promiseReturningOperators[$95c77b4beaa6d8d1$var$key1];
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$fn1, 'name', {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$op1.name
        });
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$fn1, 'length', {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$op1.length
        });
        $95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$Stream.Readable.prototype, $95c77b4beaa6d8d1$var$key1, {
            __proto__: null,
            value: $95c77b4beaa6d8d1$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $95c77b4beaa6d8d1$var$_didIteratorError1 = true;
    $95c77b4beaa6d8d1$var$_iteratorError1 = err;
} finally{
    try {
        if (!$95c77b4beaa6d8d1$var$_iteratorNormalCompletion1 && $95c77b4beaa6d8d1$var$_iterator1["return"] != null) {
            $95c77b4beaa6d8d1$var$_iterator1["return"]();
        }
    } finally{
        if ($95c77b4beaa6d8d1$var$_didIteratorError1) {
            throw $95c77b4beaa6d8d1$var$_iteratorError1;
        }
    }
}

$95c77b4beaa6d8d1$var$Stream.Writable = (parcelRequire("lm9mM"));

$95c77b4beaa6d8d1$var$Stream.Duplex = (parcelRequire("eCbWS"));

$95c77b4beaa6d8d1$var$Stream.Transform = (parcelRequire("1LsLb"));

$95c77b4beaa6d8d1$var$Stream.PassThrough = (parcelRequire("2HHoM"));
$95c77b4beaa6d8d1$var$Stream.pipeline = $95c77b4beaa6d8d1$require$pipeline;

var $aEL2R = parcelRequire("aEL2R");
var $95c77b4beaa6d8d1$require$addAbortSignal = $aEL2R.addAbortSignal;
$95c77b4beaa6d8d1$var$Stream.addAbortSignal = $95c77b4beaa6d8d1$require$addAbortSignal;
$95c77b4beaa6d8d1$var$Stream.finished = $3lOnL;
$95c77b4beaa6d8d1$var$Stream.destroy = $95c77b4beaa6d8d1$require$destroyer;
$95c77b4beaa6d8d1$var$Stream.compose = $hEIbf;
$95c77b4beaa6d8d1$var$Stream.setDefaultHighWaterMark = $95c77b4beaa6d8d1$var$setDefaultHighWaterMark;
$95c77b4beaa6d8d1$var$Stream.getDefaultHighWaterMark = $95c77b4beaa6d8d1$var$getDefaultHighWaterMark;
$95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $9GjPh;
    }
});
$95c77b4beaa6d8d1$var$ObjectDefineProperty($95c77b4beaa6d8d1$require$pipeline, $95c77b4beaa6d8d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9GjPh.pipeline;
    }
});
$95c77b4beaa6d8d1$var$ObjectDefineProperty($3lOnL, $95c77b4beaa6d8d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9GjPh.finished;
    }
});
// Backwards-compat with node 0.4.x
$95c77b4beaa6d8d1$var$Stream.Stream = $95c77b4beaa6d8d1$var$Stream;
$95c77b4beaa6d8d1$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$95c77b4beaa6d8d1$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $95c77b4beaa6d8d1$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("bMIbb", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $89467281ce384a5e$export$a143d493d941bafc; }, function (v) { return $89467281ce384a5e$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $89467281ce384a5e$export$f99ded8fe4b79145; }, function (v) { return $89467281ce384a5e$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $89467281ce384a5e$export$a143d493d941bafc;
var $89467281ce384a5e$export$e4cf37d7f6fb9e0a;
var $89467281ce384a5e$export$f99ded8fe4b79145;
var $89467281ce384a5e$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $89467281ce384a5e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$89467281ce384a5e$export$a143d493d941bafc = $89467281ce384a5e$var$Buffer;
$89467281ce384a5e$export$e4cf37d7f6fb9e0a = $89467281ce384a5e$var$SlowBuffer;
$89467281ce384a5e$export$f99ded8fe4b79145 = 50;
var $89467281ce384a5e$var$K_MAX_LENGTH = 0x7fffffff;
$89467281ce384a5e$export$599f31c3813fae4d = $89467281ce384a5e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $89467281ce384a5e$var$Buffer.TYPED_ARRAY_SUPPORT = $89467281ce384a5e$var$typedArraySupport();
if (!$89467281ce384a5e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $89467281ce384a5e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($89467281ce384a5e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$89467281ce384a5e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($89467281ce384a5e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$89467281ce384a5e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $89467281ce384a5e$var$createBuffer(length) {
    if (length > $89467281ce384a5e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $89467281ce384a5e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $89467281ce384a5e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $89467281ce384a5e$var$allocUnsafe(arg);
    }
    return $89467281ce384a5e$var$from(arg, encodingOrOffset, length);
}
$89467281ce384a5e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $89467281ce384a5e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $89467281ce384a5e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $89467281ce384a5e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($89467281ce384a5e$var$isInstance(value, ArrayBuffer) || value && $89467281ce384a5e$var$isInstance(value.buffer, ArrayBuffer)) return $89467281ce384a5e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($89467281ce384a5e$var$isInstance(value, SharedArrayBuffer) || value && $89467281ce384a5e$var$isInstance(value.buffer, SharedArrayBuffer))) return $89467281ce384a5e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $89467281ce384a5e$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $89467281ce384a5e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $89467281ce384a5e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $89467281ce384a5e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $89467281ce384a5e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($89467281ce384a5e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($89467281ce384a5e$var$Buffer, Uint8Array);
function $89467281ce384a5e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $89467281ce384a5e$var$alloc(size, fill, encoding) {
    $89467281ce384a5e$var$assertSize(size);
    if (size <= 0) return $89467281ce384a5e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $89467281ce384a5e$var$createBuffer(size).fill(fill, encoding) : $89467281ce384a5e$var$createBuffer(size).fill(fill);
    return $89467281ce384a5e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $89467281ce384a5e$var$Buffer.alloc = function(size, fill, encoding) {
    return $89467281ce384a5e$var$alloc(size, fill, encoding);
};
function $89467281ce384a5e$var$allocUnsafe(size) {
    $89467281ce384a5e$var$assertSize(size);
    return $89467281ce384a5e$var$createBuffer(size < 0 ? 0 : $89467281ce384a5e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $89467281ce384a5e$var$Buffer.allocUnsafe = function(size) {
    return $89467281ce384a5e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $89467281ce384a5e$var$Buffer.allocUnsafeSlow = function(size) {
    return $89467281ce384a5e$var$allocUnsafe(size);
};
function $89467281ce384a5e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$89467281ce384a5e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $89467281ce384a5e$var$byteLength(string, encoding) | 0;
    var buf = $89467281ce384a5e$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $89467281ce384a5e$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $89467281ce384a5e$var$checked(array.length) | 0;
    var buf = $89467281ce384a5e$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $89467281ce384a5e$var$fromArrayView(arrayView) {
    if ($89467281ce384a5e$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $89467281ce384a5e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $89467281ce384a5e$var$fromArrayLike(arrayView);
}
function $89467281ce384a5e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $89467281ce384a5e$var$Buffer.prototype);
    return buf;
}
function $89467281ce384a5e$var$fromObject(obj) {
    if ($89467281ce384a5e$var$Buffer.isBuffer(obj)) {
        var len = $89467281ce384a5e$var$checked(obj.length) | 0;
        var buf = $89467281ce384a5e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $89467281ce384a5e$var$numberIsNaN(obj.length)) return $89467281ce384a5e$var$createBuffer(0);
        return $89467281ce384a5e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $89467281ce384a5e$var$fromArrayLike(obj.data);
}
function $89467281ce384a5e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $89467281ce384a5e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $89467281ce384a5e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $89467281ce384a5e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $89467281ce384a5e$var$Buffer.alloc(+length);
}
$89467281ce384a5e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $89467281ce384a5e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$89467281ce384a5e$var$Buffer.compare = function compare(a, b) {
    if ($89467281ce384a5e$var$isInstance(a, Uint8Array)) a = $89467281ce384a5e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($89467281ce384a5e$var$isInstance(b, Uint8Array)) b = $89467281ce384a5e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$89467281ce384a5e$var$Buffer.isBuffer(a) || !$89467281ce384a5e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$89467281ce384a5e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$89467281ce384a5e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $89467281ce384a5e$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $89467281ce384a5e$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($89467281ce384a5e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$89467281ce384a5e$var$Buffer.isBuffer(buf)) buf = $89467281ce384a5e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$89467281ce384a5e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $89467281ce384a5e$var$byteLength(string, encoding) {
    if ($89467281ce384a5e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $89467281ce384a5e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $89467281ce384a5e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $89467281ce384a5e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $89467281ce384a5e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$89467281ce384a5e$var$Buffer.byteLength = $89467281ce384a5e$var$byteLength;
function $89467281ce384a5e$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $89467281ce384a5e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $89467281ce384a5e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $89467281ce384a5e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $89467281ce384a5e$var$latin1Slice(this, start, end);
        case 'base64':
            return $89467281ce384a5e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $89467281ce384a5e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$89467281ce384a5e$var$Buffer.prototype._isBuffer = true;
function $89467281ce384a5e$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$89467281ce384a5e$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$89467281ce384a5e$var$swap(this, i, i + 1);
    return this;
};
$89467281ce384a5e$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $89467281ce384a5e$var$swap(this, i, i + 3);
        $89467281ce384a5e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$89467281ce384a5e$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $89467281ce384a5e$var$swap(this, i, i + 7);
        $89467281ce384a5e$var$swap(this, i + 1, i + 6);
        $89467281ce384a5e$var$swap(this, i + 2, i + 5);
        $89467281ce384a5e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$89467281ce384a5e$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $89467281ce384a5e$var$utf8Slice(this, 0, length);
    return $89467281ce384a5e$var$slowToString.apply(this, arguments);
};
$89467281ce384a5e$var$Buffer.prototype.toLocaleString = $89467281ce384a5e$var$Buffer.prototype.toString;
$89467281ce384a5e$var$Buffer.prototype.equals = function equals(b) {
    if (!$89467281ce384a5e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $89467281ce384a5e$var$Buffer.compare(this, b) === 0;
};
$89467281ce384a5e$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $89467281ce384a5e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($89467281ce384a5e$var$customInspectSymbol) $89467281ce384a5e$var$Buffer.prototype[$89467281ce384a5e$var$customInspectSymbol] = $89467281ce384a5e$var$Buffer.prototype.inspect;
$89467281ce384a5e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($89467281ce384a5e$var$isInstance(target, Uint8Array)) target = $89467281ce384a5e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$89467281ce384a5e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $89467281ce384a5e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($89467281ce384a5e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $89467281ce384a5e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($89467281ce384a5e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $89467281ce384a5e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $89467281ce384a5e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $89467281ce384a5e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$89467281ce384a5e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$89467281ce384a5e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $89467281ce384a5e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$89467281ce384a5e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $89467281ce384a5e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $89467281ce384a5e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($89467281ce384a5e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $89467281ce384a5e$var$utf8Write(buf, string, offset, length) {
    return $89467281ce384a5e$var$blitBuffer($89467281ce384a5e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $89467281ce384a5e$var$asciiWrite(buf, string, offset, length) {
    return $89467281ce384a5e$var$blitBuffer($89467281ce384a5e$var$asciiToBytes(string), buf, offset, length);
}
function $89467281ce384a5e$var$base64Write(buf, string, offset, length) {
    return $89467281ce384a5e$var$blitBuffer($89467281ce384a5e$var$base64ToBytes(string), buf, offset, length);
}
function $89467281ce384a5e$var$ucs2Write(buf, string, offset, length) {
    return $89467281ce384a5e$var$blitBuffer($89467281ce384a5e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$89467281ce384a5e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $89467281ce384a5e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $89467281ce384a5e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $89467281ce384a5e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $89467281ce384a5e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $89467281ce384a5e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$89467281ce384a5e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $89467281ce384a5e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $89467281ce384a5e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $89467281ce384a5e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $89467281ce384a5e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $89467281ce384a5e$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $89467281ce384a5e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $89467281ce384a5e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $89467281ce384a5e$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $89467281ce384a5e$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $89467281ce384a5e$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $89467281ce384a5e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $89467281ce384a5e$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$89467281ce384a5e$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $89467281ce384a5e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $89467281ce384a5e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$89467281ce384a5e$var$Buffer.prototype.readUintLE = $89467281ce384a5e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$89467281ce384a5e$var$Buffer.prototype.readUintBE = $89467281ce384a5e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$89467281ce384a5e$var$Buffer.prototype.readUint8 = $89467281ce384a5e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$89467281ce384a5e$var$Buffer.prototype.readUint16LE = $89467281ce384a5e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$89467281ce384a5e$var$Buffer.prototype.readUint16BE = $89467281ce384a5e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$89467281ce384a5e$var$Buffer.prototype.readUint32LE = $89467281ce384a5e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$89467281ce384a5e$var$Buffer.prototype.readUint32BE = $89467281ce384a5e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$89467281ce384a5e$var$Buffer.prototype.readBigUInt64LE = $89467281ce384a5e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $89467281ce384a5e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $89467281ce384a5e$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$89467281ce384a5e$var$Buffer.prototype.readBigUInt64BE = $89467281ce384a5e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $89467281ce384a5e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $89467281ce384a5e$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$89467281ce384a5e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$89467281ce384a5e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$89467281ce384a5e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$89467281ce384a5e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$89467281ce384a5e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$89467281ce384a5e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$89467281ce384a5e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$89467281ce384a5e$var$Buffer.prototype.readBigInt64LE = $89467281ce384a5e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $89467281ce384a5e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $89467281ce384a5e$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$89467281ce384a5e$var$Buffer.prototype.readBigInt64BE = $89467281ce384a5e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $89467281ce384a5e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $89467281ce384a5e$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$89467281ce384a5e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$89467281ce384a5e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$89467281ce384a5e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$89467281ce384a5e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $89467281ce384a5e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$89467281ce384a5e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$89467281ce384a5e$var$Buffer.prototype.writeUintLE = $89467281ce384a5e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $89467281ce384a5e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$89467281ce384a5e$var$Buffer.prototype.writeUintBE = $89467281ce384a5e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $89467281ce384a5e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$89467281ce384a5e$var$Buffer.prototype.writeUint8 = $89467281ce384a5e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$89467281ce384a5e$var$Buffer.prototype.writeUint16LE = $89467281ce384a5e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$89467281ce384a5e$var$Buffer.prototype.writeUint16BE = $89467281ce384a5e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$89467281ce384a5e$var$Buffer.prototype.writeUint32LE = $89467281ce384a5e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$89467281ce384a5e$var$Buffer.prototype.writeUint32BE = $89467281ce384a5e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $89467281ce384a5e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $89467281ce384a5e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $89467281ce384a5e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $89467281ce384a5e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$89467281ce384a5e$var$Buffer.prototype.writeBigUInt64LE = $89467281ce384a5e$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $89467281ce384a5e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$89467281ce384a5e$var$Buffer.prototype.writeBigUInt64BE = $89467281ce384a5e$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $89467281ce384a5e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$89467281ce384a5e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $89467281ce384a5e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$89467281ce384a5e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $89467281ce384a5e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$89467281ce384a5e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$89467281ce384a5e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$89467281ce384a5e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$89467281ce384a5e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$89467281ce384a5e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$89467281ce384a5e$var$Buffer.prototype.writeBigInt64LE = $89467281ce384a5e$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $89467281ce384a5e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$89467281ce384a5e$var$Buffer.prototype.writeBigInt64BE = $89467281ce384a5e$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $89467281ce384a5e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $89467281ce384a5e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $89467281ce384a5e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$89467281ce384a5e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $89467281ce384a5e$var$writeFloat(this, value, offset, true, noAssert);
};
$89467281ce384a5e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $89467281ce384a5e$var$writeFloat(this, value, offset, false, noAssert);
};
function $89467281ce384a5e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $89467281ce384a5e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$89467281ce384a5e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $89467281ce384a5e$var$writeDouble(this, value, offset, true, noAssert);
};
$89467281ce384a5e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $89467281ce384a5e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$89467281ce384a5e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$89467281ce384a5e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$89467281ce384a5e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$89467281ce384a5e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $89467281ce384a5e$var$Buffer.isBuffer(val) ? val : $89467281ce384a5e$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $89467281ce384a5e$var$errors = {};
function $89467281ce384a5e$var$E(sym, getMessage, Base) {
    $89467281ce384a5e$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$89467281ce384a5e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$89467281ce384a5e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$89467281ce384a5e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $89467281ce384a5e$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $89467281ce384a5e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $89467281ce384a5e$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $89467281ce384a5e$var$checkBounds(buf, offset, byteLength) {
    $89467281ce384a5e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $89467281ce384a5e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $89467281ce384a5e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $89467281ce384a5e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $89467281ce384a5e$var$checkBounds(buf, offset, byteLength);
}
function $89467281ce384a5e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $89467281ce384a5e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $89467281ce384a5e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $89467281ce384a5e$var$validateNumber(value, type);
        throw new $89467281ce384a5e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $89467281ce384a5e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $89467281ce384a5e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $89467281ce384a5e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $89467281ce384a5e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($89467281ce384a5e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $89467281ce384a5e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $89467281ce384a5e$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $89467281ce384a5e$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $89467281ce384a5e$var$base64ToBytes(str) {
    return $abUaD.toByteArray($89467281ce384a5e$var$base64clean(str));
}
function $89467281ce384a5e$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $89467281ce384a5e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $89467281ce384a5e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $89467281ce384a5e$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $89467281ce384a5e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $89467281ce384a5e$var$BufferBigIntNotDefined : fn;
}
function $89467281ce384a5e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("hu6tI", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $cbaa436ffc2d75bb$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $cbaa436ffc2d75bb$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("fktRN", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $bMIbb = parcelRequire("bMIbb");

var $1KsT2 = parcelRequire("1KsT2");
var $b28fe42dd99e1782$var$format = $1KsT2.format, $b28fe42dd99e1782$var$inspect = $1KsT2.inspect;

var $kwaL9 = parcelRequire("kwaL9");
var $b28fe42dd99e1782$var$ERR_INVALID_ARG_TYPE = $kwaL9.codes.ERR_INVALID_ARG_TYPE;

var $hu6tI = parcelRequire("hu6tI");
var $b28fe42dd99e1782$var$kResistStopPropagation = $hu6tI.kResistStopPropagation, $b28fe42dd99e1782$var$AggregateError = $hu6tI.AggregateError, $b28fe42dd99e1782$var$SymbolDispose = $hu6tI.SymbolDispose;

var $b28fe42dd99e1782$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $b28fe42dd99e1782$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $b28fe42dd99e1782$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $b28fe42dd99e1782$var$Blob = globalThis.Blob || $bMIbb.Blob;
/* eslint-disable indent */ var $b28fe42dd99e1782$var$isBlob = typeof $b28fe42dd99e1782$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $b28fe42dd99e1782$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $b28fe42dd99e1782$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $b28fe42dd99e1782$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $b28fe42dd99e1782$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $b28fe42dd99e1782$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $b28fe42dd99e1782$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $b28fe42dd99e1782$var$format,
    inspect: $b28fe42dd99e1782$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $b28fe42dd99e1782$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $b28fe42dd99e1782$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $b28fe42dd99e1782$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $b28fe42dd99e1782$var$validateAbortSignal(signal, 'signal');
        $b28fe42dd99e1782$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $b28fe42dd99e1782$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $b28fe42dd99e1782$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $b28fe42dd99e1782$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $b28fe42dd99e1782$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $b28fe42dd99e1782$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("1KsT2", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("kwaL9", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $1KsT2 = parcelRequire("1KsT2");
var $eeff246dedf12465$var$format = $1KsT2.format, $eeff246dedf12465$var$inspect = $1KsT2.inspect;

var $hu6tI = parcelRequire("hu6tI");
var $eeff246dedf12465$var$CustomAggregateError = $hu6tI.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $eeff246dedf12465$var$AggregateError = globalThis.AggregateError || $eeff246dedf12465$var$CustomAggregateError;
var $eeff246dedf12465$var$kIsNodeError = Symbol('kIsNodeError');
var $eeff246dedf12465$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $eeff246dedf12465$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $eeff246dedf12465$var$nodeInternalPrefix = '__node_internal_';
var $eeff246dedf12465$var$codes = {};
function $eeff246dedf12465$var$assert(value, message) {
    if (!value) throw new $eeff246dedf12465$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $eeff246dedf12465$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $eeff246dedf12465$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $eeff246dedf12465$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $eeff246dedf12465$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $eeff246dedf12465$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $eeff246dedf12465$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $eeff246dedf12465$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$eeff246dedf12465$var$kIsNodeError] = true;
    $eeff246dedf12465$var$codes[code] = NodeError;
}
function $eeff246dedf12465$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $eeff246dedf12465$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $eeff246dedf12465$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $eeff246dedf12465$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $eeff246dedf12465$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $eeff246dedf12465$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$eeff246dedf12465$var$E('ERR_ASSERTION', '%s', Error);
$eeff246dedf12465$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $eeff246dedf12465$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $eeff246dedf12465$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($eeff246dedf12465$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($eeff246dedf12465$var$classRegExp.test(value)) instances.push(value);
            else {
                $eeff246dedf12465$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $eeff246dedf12465$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $eeff246dedf12465$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$eeff246dedf12465$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $eeff246dedf12465$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$eeff246dedf12465$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$eeff246dedf12465$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $eeff246dedf12465$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$eeff246dedf12465$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $eeff246dedf12465$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $eeff246dedf12465$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $eeff246dedf12465$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $eeff246dedf12465$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$eeff246dedf12465$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$eeff246dedf12465$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$eeff246dedf12465$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$eeff246dedf12465$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$eeff246dedf12465$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$eeff246dedf12465$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$eeff246dedf12465$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$eeff246dedf12465$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$eeff246dedf12465$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$eeff246dedf12465$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$eeff246dedf12465$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $eeff246dedf12465$var$AbortError,
    aggregateTwoErrors: $eeff246dedf12465$var$hideStackFrames($eeff246dedf12465$var$aggregateTwoErrors),
    hideStackFrames: $eeff246dedf12465$var$hideStackFrames,
    codes: $eeff246dedf12465$var$codes
};

});


parcelRegister("dPqw8", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $a1149b8ad9e97ff8$export$42af8c323be37587; }, function (v) { return $a1149b8ad9e97ff8$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $a1149b8ad9e97ff8$export$f405f72c701dad87; }, function (v) { return $a1149b8ad9e97ff8$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $a1149b8ad9e97ff8$export$42af8c323be37587;
var $a1149b8ad9e97ff8$export$f405f72c701dad87;
'use strict';

var $a1149b8ad9e97ff8$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $kwaL9 = parcelRequire("kwaL9");
var $a1149b8ad9e97ff8$var$_require_codes = $kwaL9.codes, $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_VALUE = $a1149b8ad9e97ff8$var$_require_codes.ERR_INVALID_ARG_VALUE, $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE = $a1149b8ad9e97ff8$var$_require_codes.ERR_INVALID_ARG_TYPE, $a1149b8ad9e97ff8$var$ERR_MISSING_ARGS = $a1149b8ad9e97ff8$var$_require_codes.ERR_MISSING_ARGS, $a1149b8ad9e97ff8$var$ERR_OUT_OF_RANGE = $a1149b8ad9e97ff8$var$_require_codes.ERR_OUT_OF_RANGE, $a1149b8ad9e97ff8$var$AbortError = $kwaL9.AbortError;

var $ipLmc = parcelRequire("ipLmc");
var $a1149b8ad9e97ff8$var$validateAbortSignal = $ipLmc.validateAbortSignal, $a1149b8ad9e97ff8$var$validateInteger = $ipLmc.validateInteger, $a1149b8ad9e97ff8$var$validateObject = $ipLmc.validateObject;

var $a1149b8ad9e97ff8$var$kWeakHandler = (parcelRequire("hu6tI")).Symbol('kWeak');

var $a1149b8ad9e97ff8$var$kResistStopPropagation = (parcelRequire("hu6tI")).Symbol('kResistStopPropagation');

var $3lOnL = parcelRequire("3lOnL");
var $a1149b8ad9e97ff8$require$finished = $3lOnL.finished;

var $hEIbf = parcelRequire("hEIbf");

var $aEL2R = parcelRequire("aEL2R");
var $a1149b8ad9e97ff8$require$addAbortSignalNoValidate = $aEL2R.addAbortSignalNoValidate;

var $ekKVz = parcelRequire("ekKVz");
var $a1149b8ad9e97ff8$var$isWritable = $ekKVz.isWritable, $a1149b8ad9e97ff8$var$isNodeStream = $ekKVz.isNodeStream;

var $a1149b8ad9e97ff8$require$deprecate = (parcelRequire("fktRN")).deprecate;

var $a1149b8ad9e97ff8$var$ArrayPrototypePush = (parcelRequire("hu6tI")).ArrayPrototypePush, $a1149b8ad9e97ff8$var$Boolean = (parcelRequire("hu6tI")).Boolean, $a1149b8ad9e97ff8$var$MathFloor = (parcelRequire("hu6tI")).MathFloor, $a1149b8ad9e97ff8$var$Number = (parcelRequire("hu6tI")).Number, $a1149b8ad9e97ff8$var$NumberIsNaN = (parcelRequire("hu6tI")).NumberIsNaN, $a1149b8ad9e97ff8$var$Promise = (parcelRequire("hu6tI")).Promise, $a1149b8ad9e97ff8$var$PromiseReject = (parcelRequire("hu6tI")).PromiseReject, $a1149b8ad9e97ff8$var$PromiseResolve = (parcelRequire("hu6tI")).PromiseResolve, $a1149b8ad9e97ff8$var$PromisePrototypeThen = (parcelRequire("hu6tI")).PromisePrototypeThen, $a1149b8ad9e97ff8$var$Symbol = (parcelRequire("hu6tI")).Symbol;
var $a1149b8ad9e97ff8$var$kEmpty = $a1149b8ad9e97ff8$var$Symbol('kEmpty');
var $a1149b8ad9e97ff8$var$kEof = $a1149b8ad9e97ff8$var$Symbol('kEof');
function $a1149b8ad9e97ff8$var$compose(stream, options) {
    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
    if ($a1149b8ad9e97ff8$var$isNodeStream(stream) && !$a1149b8ad9e97ff8$var$isWritable(stream)) throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $hEIbf(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $a1149b8ad9e97ff8$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $a1149b8ad9e97ff8$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $a1149b8ad9e97ff8$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $a1149b8ad9e97ff8$var$MathFloor(options.highWaterMark);
    $a1149b8ad9e97ff8$var$validateInteger(concurrency, 'options.concurrency', 1);
    $a1149b8ad9e97ff8$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $a1149b8ad9e97ff8$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $a1149b8ad9e97ff8$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $a1149b8ad9e97ff8$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $a1149b8ad9e97ff8$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $a1149b8ad9e97ff8$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($a1149b8ad9e97ff8$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $a1149b8ad9e97ff8$var$PromiseReject(err1);
                                $a1149b8ad9e97ff8$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("fktRN")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($a1149b8ad9e97ff8$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $a1149b8ad9e97ff8$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                        if (!(val !== $a1149b8ad9e97ff8$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $a1149b8ad9e97ff8$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a1149b8ad9e97ff8$var$asIndexedPairs(options) {
    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $a1149b8ad9e97ff8$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a1149b8ad9e97ff8$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a1149b8ad9e97ff8$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $a1149b8ad9e97ff8$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $a1149b8ad9e97ff8$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $a1149b8ad9e97ff8$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a1149b8ad9e97ff8$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $a1149b8ad9e97ff8$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $a1149b8ad9e97ff8$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a1149b8ad9e97ff8$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $a1149b8ad9e97ff8$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $a1149b8ad9e97ff8$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $a1149b8ad9e97ff8$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $a1149b8ad9e97ff8$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($a1149b8ad9e97ff8$var$ERR_MISSING_ARGS);
function $a1149b8ad9e97ff8$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $a1149b8ad9e97ff8$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $a1149b8ad9e97ff8$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $a1149b8ad9e97ff8$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $a1149b8ad9e97ff8$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $a1149b8ad9e97ff8$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $a1149b8ad9e97ff8$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $a1149b8ad9e97ff8$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $a1149b8ad9e97ff8$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $a1149b8ad9e97ff8$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $a1149b8ad9e97ff8$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $a1149b8ad9e97ff8$var$flatMap(fn, options) {
    var values = $a1149b8ad9e97ff8$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $a1149b8ad9e97ff8$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $a1149b8ad9e97ff8$var$Number(number);
    if ($a1149b8ad9e97ff8$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $a1149b8ad9e97ff8$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $a1149b8ad9e97ff8$var$drop(number, options) {
    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
    number = $a1149b8ad9e97ff8$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a1149b8ad9e97ff8$var$take(number, options) {
    if (options != null) $a1149b8ad9e97ff8$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a1149b8ad9e97ff8$var$validateAbortSignal(options.signal, 'options.signal');
    number = $a1149b8ad9e97ff8$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $a1149b8ad9e97ff8$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$a1149b8ad9e97ff8$export$42af8c323be37587 = {
    asIndexedPairs: $a1149b8ad9e97ff8$require$deprecate($a1149b8ad9e97ff8$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $a1149b8ad9e97ff8$var$drop,
    filter: $a1149b8ad9e97ff8$var$filter,
    flatMap: $a1149b8ad9e97ff8$var$flatMap,
    map: $a1149b8ad9e97ff8$var$map,
    take: $a1149b8ad9e97ff8$var$take,
    compose: $a1149b8ad9e97ff8$var$compose
};
$a1149b8ad9e97ff8$export$f405f72c701dad87 = {
    every: $a1149b8ad9e97ff8$var$every,
    forEach: $a1149b8ad9e97ff8$var$forEach,
    reduce: $a1149b8ad9e97ff8$var$reduce,
    toArray: $a1149b8ad9e97ff8$var$toArray,
    some: $a1149b8ad9e97ff8$var$some,
    find: $a1149b8ad9e97ff8$var$find
};

});
parcelRegister("ipLmc", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $d67f4befe49d267b$var$ArrayIsArray = $hu6tI.ArrayIsArray, $d67f4befe49d267b$var$ArrayPrototypeIncludes = $hu6tI.ArrayPrototypeIncludes, $d67f4befe49d267b$var$ArrayPrototypeJoin = $hu6tI.ArrayPrototypeJoin, $d67f4befe49d267b$var$ArrayPrototypeMap = $hu6tI.ArrayPrototypeMap, $d67f4befe49d267b$var$NumberIsInteger = $hu6tI.NumberIsInteger, $d67f4befe49d267b$var$NumberIsNaN = $hu6tI.NumberIsNaN, $d67f4befe49d267b$var$NumberMAX_SAFE_INTEGER = $hu6tI.NumberMAX_SAFE_INTEGER, $d67f4befe49d267b$var$NumberMIN_SAFE_INTEGER = $hu6tI.NumberMIN_SAFE_INTEGER, $d67f4befe49d267b$var$NumberParseInt = $hu6tI.NumberParseInt, $d67f4befe49d267b$var$ObjectPrototypeHasOwnProperty = $hu6tI.ObjectPrototypeHasOwnProperty, $d67f4befe49d267b$var$RegExpPrototypeExec = $hu6tI.RegExpPrototypeExec, $d67f4befe49d267b$var$String = $hu6tI.String, $d67f4befe49d267b$var$StringPrototypeToUpperCase = $hu6tI.StringPrototypeToUpperCase, $d67f4befe49d267b$var$StringPrototypeTrim = $hu6tI.StringPrototypeTrim;

var $kwaL9 = parcelRequire("kwaL9");
var $d67f4befe49d267b$var$hideStackFrames = $kwaL9.hideStackFrames, $d67f4befe49d267b$var$_require_codes = $kwaL9.codes, $d67f4befe49d267b$var$ERR_SOCKET_BAD_PORT = $d67f4befe49d267b$var$_require_codes.ERR_SOCKET_BAD_PORT, $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE = $d67f4befe49d267b$var$_require_codes.ERR_INVALID_ARG_TYPE, $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE = $d67f4befe49d267b$var$_require_codes.ERR_INVALID_ARG_VALUE, $d67f4befe49d267b$var$ERR_OUT_OF_RANGE = $d67f4befe49d267b$var$_require_codes.ERR_OUT_OF_RANGE, $d67f4befe49d267b$var$ERR_UNKNOWN_SIGNAL = $d67f4befe49d267b$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $fktRN = parcelRequire("fktRN");
var $d67f4befe49d267b$require$normalizeEncoding = $fktRN.normalizeEncoding;

var $fktRN = parcelRequire("fktRN");
var $d67f4befe49d267b$require$_require_types = $fktRN.types;
var $d67f4befe49d267b$var$isAsyncFunction = $d67f4befe49d267b$require$_require_types.isAsyncFunction, $d67f4befe49d267b$var$isArrayBufferView = $d67f4befe49d267b$require$_require_types.isArrayBufferView;
var $d67f4befe49d267b$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d67f4befe49d267b$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d67f4befe49d267b$var$isUint32(value) {
    return value === value >>> 0;
}
var $d67f4befe49d267b$var$octalReg = /^[0-7]+$/;
var $d67f4befe49d267b$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $d67f4befe49d267b$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($d67f4befe49d267b$var$RegExpPrototypeExec($d67f4befe49d267b$var$octalReg, value) === null) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE(name, value, $d67f4befe49d267b$var$modeDesc);
        value = $d67f4befe49d267b$var$NumberParseInt(value, 8);
    }
    $d67f4befe49d267b$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $d67f4befe49d267b$var$validateInteger = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $d67f4befe49d267b$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $d67f4befe49d267b$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d67f4befe49d267b$var$NumberIsInteger(value)) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $d67f4befe49d267b$var$validateInt32 = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d67f4befe49d267b$var$NumberIsInteger(value)) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $d67f4befe49d267b$var$validateUint32 = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d67f4befe49d267b$var$NumberIsInteger(value)) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $d67f4befe49d267b$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $d67f4befe49d267b$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $d67f4befe49d267b$var$NumberIsNaN(value)) throw new $d67f4befe49d267b$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $d67f4befe49d267b$var$validateOneOf = $d67f4befe49d267b$var$hideStackFrames(function(value, name, oneOf) {
    if (!$d67f4befe49d267b$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $d67f4befe49d267b$var$ArrayPrototypeJoin($d67f4befe49d267b$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $d67f4befe49d267b$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $d67f4befe49d267b$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $d67f4befe49d267b$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$d67f4befe49d267b$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $d67f4befe49d267b$var$validateObject = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $d67f4befe49d267b$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $d67f4befe49d267b$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $d67f4befe49d267b$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $d67f4befe49d267b$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $d67f4befe49d267b$var$validateDictionary = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $d67f4befe49d267b$var$validateArray = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$d67f4befe49d267b$var$ArrayIsArray(value)) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $d67f4befe49d267b$var$validateStringArray(value, name) {
    $d67f4befe49d267b$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$d67f4befe49d267b$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $d67f4befe49d267b$var$validateBooleanArray(value, name) {
    $d67f4befe49d267b$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$d67f4befe49d267b$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $d67f4befe49d267b$var$validateAbortSignalArray(value, name) {
    $d67f4befe49d267b$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $d67f4befe49d267b$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $d67f4befe49d267b$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $d67f4befe49d267b$var$validateString(signal, name);
    if ($d67f4befe49d267b$var$signals[signal] === undefined) {
        if ($d67f4befe49d267b$var$signals[$d67f4befe49d267b$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $d67f4befe49d267b$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $d67f4befe49d267b$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $d67f4befe49d267b$var$validateBuffer = $d67f4befe49d267b$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$d67f4befe49d267b$var$isArrayBufferView(buffer)) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $d67f4befe49d267b$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $d67f4befe49d267b$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $d67f4befe49d267b$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $d67f4befe49d267b$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $d67f4befe49d267b$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $d67f4befe49d267b$var$validateAbortSignal = $d67f4befe49d267b$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $d67f4befe49d267b$var$validateFunction = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $d67f4befe49d267b$var$validatePlainFunction = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $d67f4befe49d267b$var$isAsyncFunction(value)) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $d67f4befe49d267b$var$validateUndefined = $d67f4befe49d267b$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $d67f4befe49d267b$var$validateUnion(value, name, union) {
    if (!$d67f4befe49d267b$var$ArrayPrototypeIncludes(union, value)) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_TYPE(name, "('".concat($d67f4befe49d267b$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $d67f4befe49d267b$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $d67f4befe49d267b$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$d67f4befe49d267b$var$RegExpPrototypeExec($d67f4befe49d267b$var$linkValueRegExp, value)) throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $d67f4befe49d267b$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $d67f4befe49d267b$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($d67f4befe49d267b$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $d67f4befe49d267b$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $d67f4befe49d267b$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $d67f4befe49d267b$var$isInt32,
    isUint32: $d67f4befe49d267b$var$isUint32,
    parseFileMode: $d67f4befe49d267b$var$parseFileMode,
    validateArray: $d67f4befe49d267b$var$validateArray,
    validateStringArray: $d67f4befe49d267b$var$validateStringArray,
    validateBooleanArray: $d67f4befe49d267b$var$validateBooleanArray,
    validateAbortSignalArray: $d67f4befe49d267b$var$validateAbortSignalArray,
    validateBoolean: $d67f4befe49d267b$var$validateBoolean,
    validateBuffer: $d67f4befe49d267b$var$validateBuffer,
    validateDictionary: $d67f4befe49d267b$var$validateDictionary,
    validateEncoding: $d67f4befe49d267b$var$validateEncoding,
    validateFunction: $d67f4befe49d267b$var$validateFunction,
    validateInt32: $d67f4befe49d267b$var$validateInt32,
    validateInteger: $d67f4befe49d267b$var$validateInteger,
    validateNumber: $d67f4befe49d267b$var$validateNumber,
    validateObject: $d67f4befe49d267b$var$validateObject,
    validateOneOf: $d67f4befe49d267b$var$validateOneOf,
    validatePlainFunction: $d67f4befe49d267b$var$validatePlainFunction,
    validatePort: $d67f4befe49d267b$var$validatePort,
    validateSignalName: $d67f4befe49d267b$var$validateSignalName,
    validateString: $d67f4befe49d267b$var$validateString,
    validateUint32: $d67f4befe49d267b$var$validateUint32,
    validateUndefined: $d67f4befe49d267b$var$validateUndefined,
    validateUnion: $d67f4befe49d267b$var$validateUnion,
    validateAbortSignal: $d67f4befe49d267b$var$validateAbortSignal,
    validateLinkHeaderValue: $d67f4befe49d267b$var$validateLinkHeaderValue
};

});

parcelRegister("3lOnL", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kwaL9 = parcelRequire("kwaL9");
/* replacement end */ var $270a6a21bc6952be$var$AbortError = $kwaL9.AbortError, $270a6a21bc6952be$var$codes = $kwaL9.codes;
var $270a6a21bc6952be$var$ERR_INVALID_ARG_TYPE = $270a6a21bc6952be$var$codes.ERR_INVALID_ARG_TYPE, $270a6a21bc6952be$var$ERR_STREAM_PREMATURE_CLOSE = $270a6a21bc6952be$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $270a6a21bc6952be$var$kEmptyObject = (parcelRequire("fktRN")).kEmptyObject, $270a6a21bc6952be$var$once = (parcelRequire("fktRN")).once;

var $ipLmc = parcelRequire("ipLmc");
var $270a6a21bc6952be$var$validateAbortSignal = $ipLmc.validateAbortSignal, $270a6a21bc6952be$var$validateFunction = $ipLmc.validateFunction, $270a6a21bc6952be$var$validateObject = $ipLmc.validateObject, $270a6a21bc6952be$var$validateBoolean = $ipLmc.validateBoolean;

var $hu6tI = parcelRequire("hu6tI");
var $270a6a21bc6952be$var$Promise = $hu6tI.Promise, $270a6a21bc6952be$var$PromisePrototypeThen = $hu6tI.PromisePrototypeThen, $270a6a21bc6952be$var$SymbolDispose = $hu6tI.SymbolDispose;

var $ekKVz = parcelRequire("ekKVz");
var $270a6a21bc6952be$var$isClosed = $ekKVz.isClosed, $270a6a21bc6952be$var$isReadable = $ekKVz.isReadable, $270a6a21bc6952be$var$isReadableNodeStream = $ekKVz.isReadableNodeStream, $270a6a21bc6952be$var$isReadableStream = $ekKVz.isReadableStream, $270a6a21bc6952be$var$isReadableFinished = $ekKVz.isReadableFinished, $270a6a21bc6952be$var$isReadableErrored = $ekKVz.isReadableErrored, $270a6a21bc6952be$var$isWritable = $ekKVz.isWritable, $270a6a21bc6952be$var$isWritableNodeStream = $ekKVz.isWritableNodeStream, $270a6a21bc6952be$var$isWritableStream = $ekKVz.isWritableStream, $270a6a21bc6952be$var$isWritableFinished = $ekKVz.isWritableFinished, $270a6a21bc6952be$var$isWritableErrored = $ekKVz.isWritableErrored, $270a6a21bc6952be$var$isNodeStream = $ekKVz.isNodeStream, $270a6a21bc6952be$var$_willEmitClose = $ekKVz.willEmitClose, $270a6a21bc6952be$var$kIsClosedPromise = $ekKVz.kIsClosedPromise;
var $270a6a21bc6952be$var$addAbortListener;
function $270a6a21bc6952be$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $270a6a21bc6952be$var$nop = function() {};

function $270a6a21bc6952be$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $270a6a21bc6952be$var$kEmptyObject;
    } else if (options == null) options = $270a6a21bc6952be$var$kEmptyObject;
    else $270a6a21bc6952be$var$validateObject(options, 'options');
    $270a6a21bc6952be$var$validateFunction(callback, 'callback');
    $270a6a21bc6952be$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $270a6a21bc6952be$var$once(callback);
    if ($270a6a21bc6952be$var$isReadableStream(stream) || $270a6a21bc6952be$var$isWritableStream(stream)) return $270a6a21bc6952be$var$eosWeb(stream, options, callback);
    if (!$270a6a21bc6952be$var$isNodeStream(stream)) throw new $270a6a21bc6952be$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $270a6a21bc6952be$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $270a6a21bc6952be$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $270a6a21bc6952be$var$_willEmitClose(stream) && $270a6a21bc6952be$var$isReadableNodeStream(stream) === readable && $270a6a21bc6952be$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $270a6a21bc6952be$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $270a6a21bc6952be$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $270a6a21bc6952be$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $270a6a21bc6952be$var$isWritableErrored(stream) || $270a6a21bc6952be$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $270a6a21bc6952be$var$isReadableNodeStream(stream, true)) {
            if (!$270a6a21bc6952be$var$isReadableFinished(stream, false)) return callback.call(stream, new $270a6a21bc6952be$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$270a6a21bc6952be$var$isWritableFinished(stream, false)) return callback.call(stream, new $270a6a21bc6952be$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $270a6a21bc6952be$var$isWritableErrored(stream) || $270a6a21bc6952be$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($270a6a21bc6952be$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $270a6a21bc6952be$var$isReadable(stream)) && (writableFinished || $270a6a21bc6952be$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $270a6a21bc6952be$var$isWritable(stream)) && (readableFinished || $270a6a21bc6952be$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $270a6a21bc6952be$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $270a6a21bc6952be$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $270a6a21bc6952be$var$addAbortListener = $270a6a21bc6952be$var$addAbortListener || (parcelRequire("fktRN")).addAbortListener;
            var disposable = $270a6a21bc6952be$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $270a6a21bc6952be$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$270a6a21bc6952be$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $270a6a21bc6952be$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $270a6a21bc6952be$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $270a6a21bc6952be$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $270a6a21bc6952be$var$addAbortListener = $270a6a21bc6952be$var$addAbortListener || (parcelRequire("fktRN")).addAbortListener;
            var disposable = $270a6a21bc6952be$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $270a6a21bc6952be$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$270a6a21bc6952be$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $270a6a21bc6952be$var$PromisePrototypeThen(stream[$270a6a21bc6952be$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $270a6a21bc6952be$var$nop;
}
function $270a6a21bc6952be$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $270a6a21bc6952be$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $270a6a21bc6952be$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $270a6a21bc6952be$var$Promise(function(resolve, reject) {
        var cleanup = $270a6a21bc6952be$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $270a6a21bc6952be$var$eos;
module.exports.finished = $270a6a21bc6952be$var$finished;

});
parcelRegister("ekKVz", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $a6f755c4846d47a8$var$SymbolAsyncIterator = $hu6tI.SymbolAsyncIterator, $a6f755c4846d47a8$var$SymbolIterator = $hu6tI.SymbolIterator, $a6f755c4846d47a8$var$SymbolFor = $hu6tI.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $a6f755c4846d47a8$var$kIsDestroyed = $a6f755c4846d47a8$var$SymbolFor('nodejs.stream.destroyed');
var $a6f755c4846d47a8$var$kIsErrored = $a6f755c4846d47a8$var$SymbolFor('nodejs.stream.errored');
var $a6f755c4846d47a8$var$kIsReadable = $a6f755c4846d47a8$var$SymbolFor('nodejs.stream.readable');
var $a6f755c4846d47a8$var$kIsWritable = $a6f755c4846d47a8$var$SymbolFor('nodejs.stream.writable');
var $a6f755c4846d47a8$var$kIsDisturbed = $a6f755c4846d47a8$var$SymbolFor('nodejs.stream.disturbed');
var $a6f755c4846d47a8$var$kIsClosedPromise = $a6f755c4846d47a8$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $a6f755c4846d47a8$var$kControllerErrorFunction = $a6f755c4846d47a8$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $a6f755c4846d47a8$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $a6f755c4846d47a8$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $a6f755c4846d47a8$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $a6f755c4846d47a8$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $a6f755c4846d47a8$var$isReadableStream(obj) {
    return !!(obj && !$a6f755c4846d47a8$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $a6f755c4846d47a8$var$isWritableStream(obj) {
    return !!(obj && !$a6f755c4846d47a8$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $a6f755c4846d47a8$var$isTransformStream(obj) {
    return !!(obj && !$a6f755c4846d47a8$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $a6f755c4846d47a8$var$isWebStream(obj) {
    return $a6f755c4846d47a8$var$isReadableStream(obj) || $a6f755c4846d47a8$var$isWritableStream(obj) || $a6f755c4846d47a8$var$isTransformStream(obj);
}
function $a6f755c4846d47a8$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$a6f755c4846d47a8$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$a6f755c4846d47a8$var$SymbolIterator] === 'function';
    return typeof obj[$a6f755c4846d47a8$var$SymbolAsyncIterator] === 'function' || typeof obj[$a6f755c4846d47a8$var$SymbolIterator] === 'function';
}
function $a6f755c4846d47a8$var$isDestroyed(stream) {
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$a6f755c4846d47a8$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $a6f755c4846d47a8$var$isWritableEnded(stream) {
    if (!$a6f755c4846d47a8$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $a6f755c4846d47a8$var$isWritableFinished(stream, strict) {
    if (!$a6f755c4846d47a8$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $a6f755c4846d47a8$var$isReadableEnded(stream) {
    if (!$a6f755c4846d47a8$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $a6f755c4846d47a8$var$isReadableFinished(stream, strict) {
    if (!$a6f755c4846d47a8$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $a6f755c4846d47a8$var$isReadable(stream) {
    if (stream && stream[$a6f755c4846d47a8$var$kIsReadable] != null) return stream[$a6f755c4846d47a8$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($a6f755c4846d47a8$var$isDestroyed(stream)) return false;
    return $a6f755c4846d47a8$var$isReadableNodeStream(stream) && stream.readable && !$a6f755c4846d47a8$var$isReadableFinished(stream);
}
function $a6f755c4846d47a8$var$isWritable(stream) {
    if (stream && stream[$a6f755c4846d47a8$var$kIsWritable] != null) return stream[$a6f755c4846d47a8$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($a6f755c4846d47a8$var$isDestroyed(stream)) return false;
    return $a6f755c4846d47a8$var$isWritableNodeStream(stream) && stream.writable && !$a6f755c4846d47a8$var$isWritableEnded(stream);
}
function $a6f755c4846d47a8$var$isFinished(stream, opts) {
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    if ($a6f755c4846d47a8$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $a6f755c4846d47a8$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $a6f755c4846d47a8$var$isWritable(stream)) return false;
    return true;
}
function $a6f755c4846d47a8$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $a6f755c4846d47a8$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $a6f755c4846d47a8$var$isClosed(stream) {
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $a6f755c4846d47a8$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $a6f755c4846d47a8$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $a6f755c4846d47a8$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $a6f755c4846d47a8$var$isOutgoingMessage(stream);
}
function $a6f755c4846d47a8$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $a6f755c4846d47a8$var$willEmitClose(stream) {
    if (!$a6f755c4846d47a8$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $a6f755c4846d47a8$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $a6f755c4846d47a8$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$a6f755c4846d47a8$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $a6f755c4846d47a8$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$a6f755c4846d47a8$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $a6f755c4846d47a8$var$isDestroyed,
    kIsDestroyed: $a6f755c4846d47a8$var$kIsDestroyed,
    isDisturbed: $a6f755c4846d47a8$var$isDisturbed,
    kIsDisturbed: $a6f755c4846d47a8$var$kIsDisturbed,
    isErrored: $a6f755c4846d47a8$var$isErrored,
    kIsErrored: $a6f755c4846d47a8$var$kIsErrored,
    isReadable: $a6f755c4846d47a8$var$isReadable,
    kIsReadable: $a6f755c4846d47a8$var$kIsReadable,
    kIsClosedPromise: $a6f755c4846d47a8$var$kIsClosedPromise,
    kControllerErrorFunction: $a6f755c4846d47a8$var$kControllerErrorFunction,
    kIsWritable: $a6f755c4846d47a8$var$kIsWritable,
    isClosed: $a6f755c4846d47a8$var$isClosed,
    isDuplexNodeStream: $a6f755c4846d47a8$var$isDuplexNodeStream,
    isFinished: $a6f755c4846d47a8$var$isFinished,
    isIterable: $a6f755c4846d47a8$var$isIterable,
    isReadableNodeStream: $a6f755c4846d47a8$var$isReadableNodeStream,
    isReadableStream: $a6f755c4846d47a8$var$isReadableStream,
    isReadableEnded: $a6f755c4846d47a8$var$isReadableEnded,
    isReadableFinished: $a6f755c4846d47a8$var$isReadableFinished,
    isReadableErrored: $a6f755c4846d47a8$var$isReadableErrored,
    isNodeStream: $a6f755c4846d47a8$var$isNodeStream,
    isWebStream: $a6f755c4846d47a8$var$isWebStream,
    isWritable: $a6f755c4846d47a8$var$isWritable,
    isWritableNodeStream: $a6f755c4846d47a8$var$isWritableNodeStream,
    isWritableStream: $a6f755c4846d47a8$var$isWritableStream,
    isWritableEnded: $a6f755c4846d47a8$var$isWritableEnded,
    isWritableFinished: $a6f755c4846d47a8$var$isWritableFinished,
    isWritableErrored: $a6f755c4846d47a8$var$isWritableErrored,
    isServerRequest: $a6f755c4846d47a8$var$isServerRequest,
    isServerResponse: $a6f755c4846d47a8$var$isServerResponse,
    willEmitClose: $a6f755c4846d47a8$var$willEmitClose,
    isTransformStream: $a6f755c4846d47a8$var$isTransformStream
};

});


parcelRegister("hEIbf", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $dNzXS = parcelRequire("dNzXS");
var $cda8716a889772d2$require$pipeline = $dNzXS.pipeline;

var $eCbWS = parcelRequire("eCbWS");

var $8oqOv = parcelRequire("8oqOv");
var $cda8716a889772d2$require$destroyer = $8oqOv.destroyer;

var $ekKVz = parcelRequire("ekKVz");
var $cda8716a889772d2$var$isNodeStream = $ekKVz.isNodeStream, $cda8716a889772d2$var$isReadable = $ekKVz.isReadable, $cda8716a889772d2$var$isWritable = $ekKVz.isWritable, $cda8716a889772d2$var$isWebStream = $ekKVz.isWebStream, $cda8716a889772d2$var$isTransformStream = $ekKVz.isTransformStream, $cda8716a889772d2$var$isWritableStream = $ekKVz.isWritableStream, $cda8716a889772d2$var$isReadableStream = $ekKVz.isReadableStream;

var $kwaL9 = parcelRequire("kwaL9");
var $cda8716a889772d2$var$AbortError = $kwaL9.AbortError, $cda8716a889772d2$var$_require_codes = $kwaL9.codes, $cda8716a889772d2$var$ERR_INVALID_ARG_VALUE = $cda8716a889772d2$var$_require_codes.ERR_INVALID_ARG_VALUE, $cda8716a889772d2$var$ERR_MISSING_ARGS = $cda8716a889772d2$var$_require_codes.ERR_MISSING_ARGS;

var $3lOnL = parcelRequire("3lOnL");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $cda8716a889772d2$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $eCbWS.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $eCbWS.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $eCbWS.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$cda8716a889772d2$var$isNodeStream(streams[n]) && !$cda8716a889772d2$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($cda8716a889772d2$var$isReadable(streams[n]) || $cda8716a889772d2$var$isReadableStream(streams[n]) || $cda8716a889772d2$var$isTransformStream(streams[n]))) throw new $cda8716a889772d2$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($cda8716a889772d2$var$isWritable(streams[n]) || $cda8716a889772d2$var$isWritableStream(streams[n]) || $cda8716a889772d2$var$isTransformStream(streams[n]))) throw new $cda8716a889772d2$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $cda8716a889772d2$require$pipeline(streams, onfinished);
    var writable = !!($cda8716a889772d2$var$isWritable(head) || $cda8716a889772d2$var$isWritableStream(head) || $cda8716a889772d2$var$isTransformStream(head));
    var readable = !!($cda8716a889772d2$var$isReadable(tail) || $cda8716a889772d2$var$isReadableStream(tail) || $cda8716a889772d2$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $eCbWS({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($cda8716a889772d2$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($cda8716a889772d2$var$isWebStream(head)) {
            var writable1 = $cda8716a889772d2$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $cda8716a889772d2$var$isTransformStream(tail) ? tail.readable : tail;
        $3lOnL(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($cda8716a889772d2$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($cda8716a889772d2$var$isWebStream(tail)) {
            var readable1 = $cda8716a889772d2$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $cda8716a889772d2$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($cda8716a889772d2$var$isNodeStream(tail)) $cda8716a889772d2$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("dNzXS", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $a0bbbfd7a0415405$var$ArrayIsArray = $hu6tI.ArrayIsArray, $a0bbbfd7a0415405$var$Promise = $hu6tI.Promise, $a0bbbfd7a0415405$var$SymbolAsyncIterator = $hu6tI.SymbolAsyncIterator, $a0bbbfd7a0415405$var$SymbolDispose = $hu6tI.SymbolDispose;

var $3lOnL = parcelRequire("3lOnL");

var $a0bbbfd7a0415405$require$once = (parcelRequire("fktRN")).once;

var $8oqOv = parcelRequire("8oqOv");

var $eCbWS = parcelRequire("eCbWS");

var $kwaL9 = parcelRequire("kwaL9");
var $a0bbbfd7a0415405$var$aggregateTwoErrors = $kwaL9.aggregateTwoErrors, $a0bbbfd7a0415405$var$_require_codes = $kwaL9.codes, $a0bbbfd7a0415405$var$ERR_INVALID_ARG_TYPE = $a0bbbfd7a0415405$var$_require_codes.ERR_INVALID_ARG_TYPE, $a0bbbfd7a0415405$var$ERR_INVALID_RETURN_VALUE = $a0bbbfd7a0415405$var$_require_codes.ERR_INVALID_RETURN_VALUE, $a0bbbfd7a0415405$var$ERR_MISSING_ARGS = $a0bbbfd7a0415405$var$_require_codes.ERR_MISSING_ARGS, $a0bbbfd7a0415405$var$ERR_STREAM_DESTROYED = $a0bbbfd7a0415405$var$_require_codes.ERR_STREAM_DESTROYED, $a0bbbfd7a0415405$var$ERR_STREAM_PREMATURE_CLOSE = $a0bbbfd7a0415405$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $a0bbbfd7a0415405$var$AbortError = $kwaL9.AbortError;

var $ipLmc = parcelRequire("ipLmc");
var $a0bbbfd7a0415405$var$validateFunction = $ipLmc.validateFunction, $a0bbbfd7a0415405$var$validateAbortSignal = $ipLmc.validateAbortSignal;

var $ekKVz = parcelRequire("ekKVz");
var $a0bbbfd7a0415405$var$isIterable = $ekKVz.isIterable, $a0bbbfd7a0415405$var$isReadable = $ekKVz.isReadable, $a0bbbfd7a0415405$var$isReadableNodeStream = $ekKVz.isReadableNodeStream, $a0bbbfd7a0415405$var$isNodeStream = $ekKVz.isNodeStream, $a0bbbfd7a0415405$var$isTransformStream = $ekKVz.isTransformStream, $a0bbbfd7a0415405$var$isWebStream = $ekKVz.isWebStream, $a0bbbfd7a0415405$var$isReadableStream = $ekKVz.isReadableStream, $a0bbbfd7a0415405$var$isReadableFinished = $ekKVz.isReadableFinished;

var $a0bbbfd7a0415405$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $a0bbbfd7a0415405$var$PassThrough;
var $a0bbbfd7a0415405$var$Readable;
var $a0bbbfd7a0415405$var$addAbortListener;
function $a0bbbfd7a0415405$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $3lOnL(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $8oqOv.destroyer(stream, err || new $a0bbbfd7a0415405$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $a0bbbfd7a0415405$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $a0bbbfd7a0415405$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $a0bbbfd7a0415405$var$makeAsyncIterable(val) {
    if ($a0bbbfd7a0415405$var$isIterable(val)) return val;
    else if ($a0bbbfd7a0415405$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $a0bbbfd7a0415405$var$fromReadable(val);
    throw new $a0bbbfd7a0415405$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $a0bbbfd7a0415405$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$a0bbbfd7a0415405$var$Readable) $a0bbbfd7a0415405$var$Readable = (parcelRequire("TYLM0"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($a0bbbfd7a0415405$var$Readable.prototype[$a0bbbfd7a0415405$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $a0bbbfd7a0415405$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $a0bbbfd7a0415405$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $3lOnL(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $a0bbbfd7a0415405$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $a0bbbfd7a0415405$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($a0bbbfd7a0415405$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $a0bbbfd7a0415405$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $a0bbbfd7a0415405$var$pipelineImpl(streams, $a0bbbfd7a0415405$require$once($a0bbbfd7a0415405$var$popCallback(streams)));
}


function $a0bbbfd7a0415405$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($a0bbbfd7a0415405$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $a0bbbfd7a0415405$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($a0bbbfd7a0415405$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($a0bbbfd7a0415405$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$a0bbbfd7a0415405$var$isIterable(ret)) throw new $a0bbbfd7a0415405$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($a0bbbfd7a0415405$var$isIterable(stream) || $a0bbbfd7a0415405$var$isReadableNodeStream(stream) || $a0bbbfd7a0415405$var$isTransformStream(stream)) ret = stream;
            else ret = $eCbWS.from(stream);
        } else if (typeof stream === 'function') {
            if ($a0bbbfd7a0415405$var$isTransformStream(ret)) {
                var _ret;
                ret = $a0bbbfd7a0415405$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $a0bbbfd7a0415405$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$a0bbbfd7a0415405$var$isIterable(ret, true)) throw new $a0bbbfd7a0415405$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$a0bbbfd7a0415405$var$PassThrough) $a0bbbfd7a0415405$var$PassThrough = (parcelRequire("2HHoM"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $a0bbbfd7a0415405$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($a0bbbfd7a0415405$var$isIterable(ret, true)) {
                    finishCount++;
                    $a0bbbfd7a0415405$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($a0bbbfd7a0415405$var$isReadableStream(ret) || $a0bbbfd7a0415405$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $a0bbbfd7a0415405$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $a0bbbfd7a0415405$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $a0bbbfd7a0415405$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($a0bbbfd7a0415405$var$isNodeStream(stream)) {
            if ($a0bbbfd7a0415405$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $a0bbbfd7a0415405$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($a0bbbfd7a0415405$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($a0bbbfd7a0415405$var$isTransformStream(ret) || $a0bbbfd7a0415405$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $a0bbbfd7a0415405$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($a0bbbfd7a0415405$var$isIterable(ret)) {
                finishCount++;
                $a0bbbfd7a0415405$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $a0bbbfd7a0415405$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($a0bbbfd7a0415405$var$isWebStream(stream)) {
            if ($a0bbbfd7a0415405$var$isReadableNodeStream(ret)) {
                finishCount++;
                $a0bbbfd7a0415405$var$pumpToWeb($a0bbbfd7a0415405$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($a0bbbfd7a0415405$var$isReadableStream(ret) || $a0bbbfd7a0415405$var$isIterable(ret)) {
                finishCount++;
                $a0bbbfd7a0415405$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($a0bbbfd7a0415405$var$isTransformStream(ret)) {
                finishCount++;
                $a0bbbfd7a0415405$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $a0bbbfd7a0415405$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $eCbWS.from(stream);
    };
    if (streams.length === 1 && $a0bbbfd7a0415405$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a0bbbfd7a0415405$var$ERR_MISSING_ARGS('streams');
    var ac = new $a0bbbfd7a0415405$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $a0bbbfd7a0415405$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $a0bbbfd7a0415405$var$AbortError());
    }
    $a0bbbfd7a0415405$var$addAbortListener = $a0bbbfd7a0415405$var$addAbortListener || (parcelRequire("fktRN")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $a0bbbfd7a0415405$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$a0bbbfd7a0415405$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $a0bbbfd7a0415405$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $a0bbbfd7a0415405$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($a0bbbfd7a0415405$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $3lOnL(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $3lOnL(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $a0bbbfd7a0415405$var$pipelineImpl,
    pipeline: $a0bbbfd7a0415405$var$pipeline
};

});
parcelRegister("8oqOv", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kwaL9 = parcelRequire("kwaL9");
/* replacement end */ var $61c55d3989a7c11a$var$aggregateTwoErrors = $kwaL9.aggregateTwoErrors, $61c55d3989a7c11a$var$ERR_MULTIPLE_CALLBACK = $kwaL9.codes.ERR_MULTIPLE_CALLBACK, $61c55d3989a7c11a$var$AbortError = $kwaL9.AbortError;

var $hu6tI = parcelRequire("hu6tI");
var $61c55d3989a7c11a$require$Symbol = $hu6tI.Symbol;

var $ekKVz = parcelRequire("ekKVz");
var $61c55d3989a7c11a$var$kIsDestroyed = $ekKVz.kIsDestroyed, $61c55d3989a7c11a$var$isDestroyed = $ekKVz.isDestroyed, $61c55d3989a7c11a$var$isFinished = $ekKVz.isFinished, $61c55d3989a7c11a$var$isServerRequest = $ekKVz.isServerRequest;
var $61c55d3989a7c11a$var$kDestroy = $61c55d3989a7c11a$require$Symbol('kDestroy');
var $61c55d3989a7c11a$var$kConstruct = $61c55d3989a7c11a$require$Symbol('kConstruct');
function $61c55d3989a7c11a$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $61c55d3989a7c11a$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $61c55d3989a7c11a$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($61c55d3989a7c11a$var$kDestroy, function(er) {
        $61c55d3989a7c11a$var$_destroy(this, $61c55d3989a7c11a$var$aggregateTwoErrors(er, err), cb);
    });
    else $61c55d3989a7c11a$var$_destroy(this, err, cb);
    return this;
}
function $61c55d3989a7c11a$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $61c55d3989a7c11a$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($61c55d3989a7c11a$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($61c55d3989a7c11a$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $61c55d3989a7c11a$var$emitErrorCloseNT(self, err) {
    $61c55d3989a7c11a$var$emitErrorNT(self, err);
    $61c55d3989a7c11a$var$emitCloseNT(self);
}
function $61c55d3989a7c11a$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $61c55d3989a7c11a$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $61c55d3989a7c11a$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $61c55d3989a7c11a$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($61c55d3989a7c11a$var$emitErrorNT, stream, err);
        else $61c55d3989a7c11a$var$emitErrorNT(stream, err);
    }
}
function $61c55d3989a7c11a$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($61c55d3989a7c11a$var$kConstruct, cb);
    if (stream.listenerCount($61c55d3989a7c11a$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($61c55d3989a7c11a$var$constructNT, stream);
}
function $61c55d3989a7c11a$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $61c55d3989a7c11a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $61c55d3989a7c11a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($61c55d3989a7c11a$var$kDestroy, err);
        else if (err) $61c55d3989a7c11a$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($61c55d3989a7c11a$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $61c55d3989a7c11a$var$emitConstructNT(stream) {
    stream.emit($61c55d3989a7c11a$var$kConstruct);
}
function $61c55d3989a7c11a$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $61c55d3989a7c11a$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $61c55d3989a7c11a$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($61c55d3989a7c11a$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $61c55d3989a7c11a$var$destroyer(stream, err) {
    if (!stream || $61c55d3989a7c11a$var$isDestroyed(stream)) return;
    if (!err && !$61c55d3989a7c11a$var$isFinished(stream)) err = new $61c55d3989a7c11a$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($61c55d3989a7c11a$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($61c55d3989a7c11a$var$isRequest(stream)) stream.abort();
    else if ($61c55d3989a7c11a$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($61c55d3989a7c11a$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($61c55d3989a7c11a$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$61c55d3989a7c11a$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $61c55d3989a7c11a$var$construct,
    destroyer: $61c55d3989a7c11a$var$destroyer,
    destroy: $61c55d3989a7c11a$var$destroy,
    undestroy: $61c55d3989a7c11a$var$undestroy,
    errorOrDestroy: $61c55d3989a7c11a$var$errorOrDestroy
};

});

parcelRegister("eCbWS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $aa3de20ae22c581e$var$ObjectDefineProperties = $hu6tI.ObjectDefineProperties, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor = $hu6tI.ObjectGetOwnPropertyDescriptor, $aa3de20ae22c581e$var$ObjectKeys = $hu6tI.ObjectKeys, $aa3de20ae22c581e$var$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf;
module.exports = $aa3de20ae22c581e$var$Duplex;

var $TYLM0 = parcelRequire("TYLM0");

var $lm9mM = parcelRequire("lm9mM");
$aa3de20ae22c581e$var$ObjectSetPrototypeOf($aa3de20ae22c581e$var$Duplex.prototype, $TYLM0.prototype);
$aa3de20ae22c581e$var$ObjectSetPrototypeOf($aa3de20ae22c581e$var$Duplex, $TYLM0);
{
    var $aa3de20ae22c581e$var$keys = $aa3de20ae22c581e$var$ObjectKeys($lm9mM.prototype);
    // Allow the keys array to be GC'ed.
    for(var $aa3de20ae22c581e$var$i = 0; $aa3de20ae22c581e$var$i < $aa3de20ae22c581e$var$keys.length; $aa3de20ae22c581e$var$i++){
        var $aa3de20ae22c581e$var$method = $aa3de20ae22c581e$var$keys[$aa3de20ae22c581e$var$i];
        if (!$aa3de20ae22c581e$var$Duplex.prototype[$aa3de20ae22c581e$var$method]) $aa3de20ae22c581e$var$Duplex.prototype[$aa3de20ae22c581e$var$method] = $lm9mM.prototype[$aa3de20ae22c581e$var$method];
    }
}function $aa3de20ae22c581e$var$Duplex(options) {
    if (!(this instanceof $aa3de20ae22c581e$var$Duplex)) return new $aa3de20ae22c581e$var$Duplex(options);
    $TYLM0.call(this, options);
    $lm9mM.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$aa3de20ae22c581e$var$ObjectDefineProperties($aa3de20ae22c581e$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $aa3de20ae22c581e$var$ObjectGetOwnPropertyDescriptor($lm9mM.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $aa3de20ae22c581e$var$webStreamsAdapters;
// Lazy to avoid circular references
function $aa3de20ae22c581e$var$lazyWebStreams() {
    if ($aa3de20ae22c581e$var$webStreamsAdapters === undefined) $aa3de20ae22c581e$var$webStreamsAdapters = {};
    return $aa3de20ae22c581e$var$webStreamsAdapters;
}
$aa3de20ae22c581e$var$Duplex.fromWeb = function(pair, options) {
    return $aa3de20ae22c581e$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$aa3de20ae22c581e$var$Duplex.toWeb = function(duplex) {
    return $aa3de20ae22c581e$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $aa3de20ae22c581e$var$duplexify;

$aa3de20ae22c581e$var$Duplex.from = function(body) {
    if (!$aa3de20ae22c581e$var$duplexify) $aa3de20ae22c581e$var$duplexify = (parcelRequire("8OYgH"));
    return $aa3de20ae22c581e$var$duplexify(body, 'body');
};

});
parcelRegister("TYLM0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hu6tI = parcelRequire("hu6tI");
/* replacement end */ var $0a8446bbbb1ec236$var$ArrayPrototypeIndexOf = $hu6tI.ArrayPrototypeIndexOf, $0a8446bbbb1ec236$var$NumberIsInteger = $hu6tI.NumberIsInteger, $0a8446bbbb1ec236$var$NumberIsNaN = $hu6tI.NumberIsNaN, $0a8446bbbb1ec236$var$NumberParseInt = $hu6tI.NumberParseInt, $0a8446bbbb1ec236$var$ObjectDefineProperties = $hu6tI.ObjectDefineProperties, $0a8446bbbb1ec236$var$ObjectKeys = $hu6tI.ObjectKeys, $0a8446bbbb1ec236$var$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf, $0a8446bbbb1ec236$var$Promise = $hu6tI.Promise, $0a8446bbbb1ec236$var$SafeSet = $hu6tI.SafeSet, $0a8446bbbb1ec236$var$SymbolAsyncDispose = $hu6tI.SymbolAsyncDispose, $0a8446bbbb1ec236$var$SymbolAsyncIterator = $hu6tI.SymbolAsyncIterator, $0a8446bbbb1ec236$var$Symbol = $hu6tI.Symbol;
module.exports = $0a8446bbbb1ec236$var$Readable;
$0a8446bbbb1ec236$var$Readable.ReadableState = $0a8446bbbb1ec236$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $0a8446bbbb1ec236$var$EE = $bBoAO.EventEmitter;

var $i4Yg4 = parcelRequire("i4Yg4");
var $0a8446bbbb1ec236$var$Stream = $i4Yg4.Stream, $0a8446bbbb1ec236$var$prependListener = $i4Yg4.prependListener;

var $bMIbb = parcelRequire("bMIbb");
var $0a8446bbbb1ec236$require$Buffer = $bMIbb.Buffer;

var $aEL2R = parcelRequire("aEL2R");
var $0a8446bbbb1ec236$require$addAbortSignal = $aEL2R.addAbortSignal;

var $3lOnL = parcelRequire("3lOnL");

var $0a8446bbbb1ec236$var$debug = (parcelRequire("fktRN")).debuglog('stream', function(fn) {
    $0a8446bbbb1ec236$var$debug = fn;
});

var $j6Po1 = parcelRequire("j6Po1");

var $8oqOv = parcelRequire("8oqOv");

var $8NU40 = parcelRequire("8NU40");
var $0a8446bbbb1ec236$var$getHighWaterMark = $8NU40.getHighWaterMark, $0a8446bbbb1ec236$var$getDefaultHighWaterMark = $8NU40.getDefaultHighWaterMark;

var $kwaL9 = parcelRequire("kwaL9");
var $0a8446bbbb1ec236$var$aggregateTwoErrors = $kwaL9.aggregateTwoErrors, $0a8446bbbb1ec236$var$_require_codes = $kwaL9.codes, $0a8446bbbb1ec236$var$ERR_INVALID_ARG_TYPE = $0a8446bbbb1ec236$var$_require_codes.ERR_INVALID_ARG_TYPE, $0a8446bbbb1ec236$var$ERR_METHOD_NOT_IMPLEMENTED = $0a8446bbbb1ec236$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $0a8446bbbb1ec236$var$ERR_OUT_OF_RANGE = $0a8446bbbb1ec236$var$_require_codes.ERR_OUT_OF_RANGE, $0a8446bbbb1ec236$var$ERR_STREAM_PUSH_AFTER_EOF = $0a8446bbbb1ec236$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $0a8446bbbb1ec236$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $0a8446bbbb1ec236$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $0a8446bbbb1ec236$var$AbortError = $kwaL9.AbortError;

var $ipLmc = parcelRequire("ipLmc");
var $0a8446bbbb1ec236$require$validateObject = $ipLmc.validateObject;
var $0a8446bbbb1ec236$var$kPaused = $0a8446bbbb1ec236$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $0a8446bbbb1ec236$require$StringDecoder = $3Jf7C.StringDecoder;

var $91wIh = parcelRequire("91wIh");
$0a8446bbbb1ec236$var$ObjectSetPrototypeOf($0a8446bbbb1ec236$var$Readable.prototype, $0a8446bbbb1ec236$var$Stream.prototype);
$0a8446bbbb1ec236$var$ObjectSetPrototypeOf($0a8446bbbb1ec236$var$Readable, $0a8446bbbb1ec236$var$Stream);
var $0a8446bbbb1ec236$var$nop = function() {};
var $0a8446bbbb1ec236$var$errorOrDestroy = $8oqOv.errorOrDestroy;
var $0a8446bbbb1ec236$var$kObjectMode = 1;
var $0a8446bbbb1ec236$var$kEnded = 2;
var $0a8446bbbb1ec236$var$kEndEmitted = 4;
var $0a8446bbbb1ec236$var$kReading = 8;
var $0a8446bbbb1ec236$var$kConstructed = 16;
var $0a8446bbbb1ec236$var$kSync = 32;
var $0a8446bbbb1ec236$var$kNeedReadable = 64;
var $0a8446bbbb1ec236$var$kEmittedReadable = 128;
var $0a8446bbbb1ec236$var$kReadableListening = 256;
var $0a8446bbbb1ec236$var$kResumeScheduled = 512;
var $0a8446bbbb1ec236$var$kErrorEmitted = 1024;
var $0a8446bbbb1ec236$var$kEmitClose = 2048;
var $0a8446bbbb1ec236$var$kAutoDestroy = 4096;
var $0a8446bbbb1ec236$var$kDestroyed = 8192;
var $0a8446bbbb1ec236$var$kClosed = 16384;
var $0a8446bbbb1ec236$var$kCloseEmitted = 32768;
var $0a8446bbbb1ec236$var$kMultiAwaitDrain = 65536;
var $0a8446bbbb1ec236$var$kReadingMore = 131072;
var $0a8446bbbb1ec236$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $0a8446bbbb1ec236$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$0a8446bbbb1ec236$var$ObjectDefineProperties($0a8446bbbb1ec236$var$ReadableState.prototype, {
    objectMode: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kObjectMode),
    ended: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kEnded),
    endEmitted: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kEndEmitted),
    reading: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kNeedReadable),
    emittedReadable: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kEmittedReadable),
    readableListening: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kReadableListening),
    resumeScheduled: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kErrorEmitted),
    emitClose: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kEmitClose),
    autoDestroy: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kCloseEmitted),
    multiAwaitDrain: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kReadingMore),
    dataEmitted: $0a8446bbbb1ec236$var$makeBitMapDescriptor($0a8446bbbb1ec236$var$kDataEmitted)
});

function $0a8446bbbb1ec236$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("eCbWS"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $0a8446bbbb1ec236$var$kEmitClose | $0a8446bbbb1ec236$var$kAutoDestroy | $0a8446bbbb1ec236$var$kConstructed | $0a8446bbbb1ec236$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $0a8446bbbb1ec236$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $0a8446bbbb1ec236$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $0a8446bbbb1ec236$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $0a8446bbbb1ec236$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $j6Po1();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$0a8446bbbb1ec236$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$0a8446bbbb1ec236$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$0a8446bbbb1ec236$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $0a8446bbbb1ec236$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $0a8446bbbb1ec236$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $0a8446bbbb1ec236$var$Readable)) return new $0a8446bbbb1ec236$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("eCbWS"));
    this._readableState = new $0a8446bbbb1ec236$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $0a8446bbbb1ec236$require$addAbortSignal(options.signal, this);
    }
    $0a8446bbbb1ec236$var$Stream.call(this, options);
    $8oqOv.construct(this, function() {
        if (_this._readableState.needReadable) $0a8446bbbb1ec236$var$maybeReadMore(_this, _this._readableState);
    });
}
$0a8446bbbb1ec236$var$Readable.prototype.destroy = $8oqOv.destroy;
$0a8446bbbb1ec236$var$Readable.prototype._undestroy = $8oqOv.undestroy;
$0a8446bbbb1ec236$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$0a8446bbbb1ec236$var$Readable.prototype[$0a8446bbbb1ec236$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$0a8446bbbb1ec236$var$Readable.prototype[$0a8446bbbb1ec236$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $0a8446bbbb1ec236$var$AbortError();
        this.destroy(error);
    }
    return new $0a8446bbbb1ec236$var$Promise(function(resolve, reject) {
        return $3lOnL(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$0a8446bbbb1ec236$var$Readable.prototype.push = function(chunk, encoding) {
    return $0a8446bbbb1ec236$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$0a8446bbbb1ec236$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $0a8446bbbb1ec236$var$readableAddChunk(this, chunk, encoding, true);
};
function $0a8446bbbb1ec236$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $0a8446bbbb1ec236$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $0a8446bbbb1ec236$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $0a8446bbbb1ec236$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $0a8446bbbb1ec236$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $0a8446bbbb1ec236$require$Buffer) encoding = '';
        else if ($0a8446bbbb1ec236$var$Stream._isUint8Array(chunk)) {
            chunk = $0a8446bbbb1ec236$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $0a8446bbbb1ec236$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $0a8446bbbb1ec236$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$0a8446bbbb1ec236$var$kReading;
        $0a8446bbbb1ec236$var$onEofChunk(stream, state);
    } else if ((state.state & $0a8446bbbb1ec236$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $0a8446bbbb1ec236$var$kEndEmitted) !== 0) $0a8446bbbb1ec236$var$errorOrDestroy(stream, new $0a8446bbbb1ec236$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $0a8446bbbb1ec236$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $0a8446bbbb1ec236$var$errorOrDestroy(stream, new $0a8446bbbb1ec236$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$0a8446bbbb1ec236$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $0a8446bbbb1ec236$var$addChunk(stream, state, chunk, false);
                else $0a8446bbbb1ec236$var$maybeReadMore(stream, state);
            } else $0a8446bbbb1ec236$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$0a8446bbbb1ec236$var$kReading;
        $0a8446bbbb1ec236$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $0a8446bbbb1ec236$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $0a8446bbbb1ec236$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $0a8446bbbb1ec236$var$kNeedReadable) !== 0) $0a8446bbbb1ec236$var$emitReadable(stream);
    }
    $0a8446bbbb1ec236$var$maybeReadMore(stream, state);
}
$0a8446bbbb1ec236$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$0a8446bbbb1ec236$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$0a8446bbbb1ec236$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $0a8446bbbb1ec236$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$0a8446bbbb1ec236$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $0a8446bbbb1ec236$var$MAX_HWM = 0x40000000;
function $0a8446bbbb1ec236$var$computeNewHighWaterMark(n) {
    if (n > $0a8446bbbb1ec236$var$MAX_HWM) throw new $0a8446bbbb1ec236$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0a8446bbbb1ec236$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $0a8446bbbb1ec236$var$kObjectMode) !== 0) return 1;
    if ($0a8446bbbb1ec236$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$0a8446bbbb1ec236$var$Readable.prototype.read = function(n) {
    $0a8446bbbb1ec236$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$0a8446bbbb1ec236$var$NumberIsInteger(n)) n = $0a8446bbbb1ec236$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $0a8446bbbb1ec236$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$0a8446bbbb1ec236$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $0a8446bbbb1ec236$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $0a8446bbbb1ec236$var$endReadable(this);
        else $0a8446bbbb1ec236$var$emitReadable(this);
        return null;
    }
    n = $0a8446bbbb1ec236$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $0a8446bbbb1ec236$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $0a8446bbbb1ec236$var$kNeedReadable) !== 0;
    $0a8446bbbb1ec236$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $0a8446bbbb1ec236$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $0a8446bbbb1ec236$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $0a8446bbbb1ec236$var$debug('do read');
        state.state |= $0a8446bbbb1ec236$var$kReading | $0a8446bbbb1ec236$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $0a8446bbbb1ec236$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $0a8446bbbb1ec236$var$errorOrDestroy(this, err);
        }
        state.state &= ~$0a8446bbbb1ec236$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $0a8446bbbb1ec236$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $0a8446bbbb1ec236$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $0a8446bbbb1ec236$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $0a8446bbbb1ec236$var$onEofChunk(stream, state) {
    $0a8446bbbb1ec236$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $0a8446bbbb1ec236$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $0a8446bbbb1ec236$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $0a8446bbbb1ec236$var$emitReadable(stream) {
    var state = stream._readableState;
    $0a8446bbbb1ec236$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $0a8446bbbb1ec236$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($0a8446bbbb1ec236$var$emitReadable_, stream);
    }
}
function $0a8446bbbb1ec236$var$emitReadable_(stream) {
    var state = stream._readableState;
    $0a8446bbbb1ec236$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $0a8446bbbb1ec236$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $0a8446bbbb1ec236$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($0a8446bbbb1ec236$var$maybeReadMore_, stream, state);
    }
}
function $0a8446bbbb1ec236$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $0a8446bbbb1ec236$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$0a8446bbbb1ec236$var$Readable.prototype._read = function(n) {
    throw new $0a8446bbbb1ec236$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$0a8446bbbb1ec236$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $0a8446bbbb1ec236$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $0a8446bbbb1ec236$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $0a8446bbbb1ec236$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $0a8446bbbb1ec236$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $0a8446bbbb1ec236$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $0a8446bbbb1ec236$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $0a8446bbbb1ec236$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $0a8446bbbb1ec236$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $0a8446bbbb1ec236$var$debug('ondata');
        var ret = dest.write(chunk);
        $0a8446bbbb1ec236$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $0a8446bbbb1ec236$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $0a8446bbbb1ec236$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $0a8446bbbb1ec236$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $0a8446bbbb1ec236$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $0a8446bbbb1ec236$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $0a8446bbbb1ec236$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $0a8446bbbb1ec236$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $0a8446bbbb1ec236$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $0a8446bbbb1ec236$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$0a8446bbbb1ec236$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $0a8446bbbb1ec236$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$0a8446bbbb1ec236$var$Readable.prototype.on = function(ev, fn) {
    var res = $0a8446bbbb1ec236$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $0a8446bbbb1ec236$var$debug('on readable', state.length, state.reading);
            if (state.length) $0a8446bbbb1ec236$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($0a8446bbbb1ec236$var$nReadingNextTick, this);
        }
    }
    return res;
};
$0a8446bbbb1ec236$var$Readable.prototype.addListener = $0a8446bbbb1ec236$var$Readable.prototype.on;
$0a8446bbbb1ec236$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $0a8446bbbb1ec236$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($0a8446bbbb1ec236$var$updateReadableListening, this);
    return res;
};
$0a8446bbbb1ec236$var$Readable.prototype.off = $0a8446bbbb1ec236$var$Readable.prototype.removeListener;
$0a8446bbbb1ec236$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $0a8446bbbb1ec236$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($0a8446bbbb1ec236$var$updateReadableListening, this);
    return res;
};
function $0a8446bbbb1ec236$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$0a8446bbbb1ec236$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $0a8446bbbb1ec236$var$nReadingNextTick(self) {
    $0a8446bbbb1ec236$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$0a8446bbbb1ec236$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $0a8446bbbb1ec236$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $0a8446bbbb1ec236$var$resume(this, state);
    }
    state[$0a8446bbbb1ec236$var$kPaused] = false;
    return this;
};
function $0a8446bbbb1ec236$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($0a8446bbbb1ec236$var$resume_, stream, state);
    }
}
function $0a8446bbbb1ec236$var$resume_(stream, state) {
    $0a8446bbbb1ec236$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $0a8446bbbb1ec236$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$0a8446bbbb1ec236$var$Readable.prototype.pause = function() {
    $0a8446bbbb1ec236$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $0a8446bbbb1ec236$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$0a8446bbbb1ec236$var$kPaused] = true;
    return this;
};
function $0a8446bbbb1ec236$var$flow(stream) {
    var state = stream._readableState;
    $0a8446bbbb1ec236$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$0a8446bbbb1ec236$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $0a8446bbbb1ec236$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $0a8446bbbb1ec236$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$0a8446bbbb1ec236$var$Readable.prototype[$0a8446bbbb1ec236$var$SymbolAsyncIterator] = function() {
    return $0a8446bbbb1ec236$var$streamToAsyncIterator(this);
};
$0a8446bbbb1ec236$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $0a8446bbbb1ec236$require$validateObject(options, 'options');
    return $0a8446bbbb1ec236$var$streamToAsyncIterator(this, options);
};
function $0a8446bbbb1ec236$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $0a8446bbbb1ec236$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $0a8446bbbb1ec236$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $0a8446bbbb1ec236$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $0a8446bbbb1ec236$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $0a8446bbbb1ec236$var$nop;
                    stream.on('readable', next);
                    cleanup = $3lOnL(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $0a8446bbbb1ec236$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $0a8446bbbb1ec236$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $0a8446bbbb1ec236$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $0a8446bbbb1ec236$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $8oqOv.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$0a8446bbbb1ec236$var$ObjectDefineProperties($0a8446bbbb1ec236$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$0a8446bbbb1ec236$var$ObjectDefineProperties($0a8446bbbb1ec236$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$0a8446bbbb1ec236$var$kPaused] !== false;
        },
        set: function(value) {
            this[$0a8446bbbb1ec236$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$0a8446bbbb1ec236$var$Readable._fromList = $0a8446bbbb1ec236$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0a8446bbbb1ec236$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $0a8446bbbb1ec236$var$endReadable(stream) {
    var state = stream._readableState;
    $0a8446bbbb1ec236$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($0a8446bbbb1ec236$var$endReadableNT, state, stream);
    }
}
function $0a8446bbbb1ec236$var$endReadableNT(state, stream) {
    $0a8446bbbb1ec236$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($0a8446bbbb1ec236$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $0a8446bbbb1ec236$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$0a8446bbbb1ec236$var$Readable.from = function(iterable, opts) {
    return $91wIh($0a8446bbbb1ec236$var$Readable, iterable, opts);
};
var $0a8446bbbb1ec236$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0a8446bbbb1ec236$var$lazyWebStreams() {
    if ($0a8446bbbb1ec236$var$webStreamsAdapters === undefined) $0a8446bbbb1ec236$var$webStreamsAdapters = {};
    return $0a8446bbbb1ec236$var$webStreamsAdapters;
}
$0a8446bbbb1ec236$var$Readable.fromWeb = function(readableStream, options) {
    return $0a8446bbbb1ec236$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$0a8446bbbb1ec236$var$Readable.toWeb = function(streamReadable, options) {
    return $0a8446bbbb1ec236$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$0a8446bbbb1ec236$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $0a8446bbbb1ec236$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $8oqOv.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("i4Yg4", function(module, exports) {
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $d29757bcf879de70$var$ArrayIsArray = $hu6tI.ArrayIsArray, $d29757bcf879de70$var$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $d29757bcf879de70$var$EE = $bBoAO.EventEmitter;
function $d29757bcf879de70$var$Stream(opts) {
    $d29757bcf879de70$var$EE.call(this, opts);
}
$d29757bcf879de70$var$ObjectSetPrototypeOf($d29757bcf879de70$var$Stream.prototype, $d29757bcf879de70$var$EE.prototype);
$d29757bcf879de70$var$ObjectSetPrototypeOf($d29757bcf879de70$var$Stream, $d29757bcf879de70$var$EE);
$d29757bcf879de70$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d29757bcf879de70$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $d29757bcf879de70$var$prependListener(source, 'error', onerror);
    $d29757bcf879de70$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $d29757bcf879de70$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($d29757bcf879de70$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $d29757bcf879de70$var$Stream,
    prependListener: $d29757bcf879de70$var$prependListener
};

});

parcelRegister("aEL2R", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $7c222205095e1251$export$e2db56ee53255a0; }, function (v) { return $7c222205095e1251$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $7c222205095e1251$export$11956e9313f43de0; }, function (v) { return $7c222205095e1251$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $7c222205095e1251$export$e2db56ee53255a0;
var $7c222205095e1251$export$11956e9313f43de0;
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $7c222205095e1251$require$SymbolDispose = $hu6tI.SymbolDispose;

var $kwaL9 = parcelRequire("kwaL9");
var $7c222205095e1251$var$AbortError = $kwaL9.AbortError, $7c222205095e1251$var$codes = $kwaL9.codes;

var $ekKVz = parcelRequire("ekKVz");
var $7c222205095e1251$var$isNodeStream = $ekKVz.isNodeStream, $7c222205095e1251$var$isWebStream = $ekKVz.isWebStream, $7c222205095e1251$var$kControllerErrorFunction = $ekKVz.kControllerErrorFunction;

var $3lOnL = parcelRequire("3lOnL");
var $7c222205095e1251$var$ERR_INVALID_ARG_TYPE = $7c222205095e1251$var$codes.ERR_INVALID_ARG_TYPE;
var $7c222205095e1251$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $7c222205095e1251$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $7c222205095e1251$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$7c222205095e1251$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $7c222205095e1251$var$validateAbortSignal(signal, 'signal');
    if (!$7c222205095e1251$var$isNodeStream(stream) && !$7c222205095e1251$var$isWebStream(stream)) throw new $7c222205095e1251$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $7c222205095e1251$export$11956e9313f43de0(signal, stream);
};

$7c222205095e1251$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $7c222205095e1251$var$isNodeStream(stream) ? function() {
        stream.destroy(new $7c222205095e1251$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$7c222205095e1251$var$kControllerErrorFunction](new $7c222205095e1251$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $7c222205095e1251$var$addAbortListener = $7c222205095e1251$var$addAbortListener || (parcelRequire("fktRN")).addAbortListener;
        var disposable = $7c222205095e1251$var$addAbortListener(signal, onAbort);
        $3lOnL(stream, disposable[$7c222205095e1251$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("j6Po1", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $de96701e604beab9$var$StringPrototypeSlice = $hu6tI.StringPrototypeSlice, $de96701e604beab9$var$SymbolIterator = $hu6tI.SymbolIterator, $de96701e604beab9$var$TypedArrayPrototypeSet = $hu6tI.TypedArrayPrototypeSet, $de96701e604beab9$var$Uint8Array = $hu6tI.Uint8Array;

var $bMIbb = parcelRequire("bMIbb");
var $de96701e604beab9$require$Buffer = $bMIbb.Buffer;

var $fktRN = parcelRequire("fktRN");
var $de96701e604beab9$require$inspect = $fktRN.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $de96701e604beab9$require$Buffer.alloc(0);
                var ret = $de96701e604beab9$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $de96701e604beab9$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $de96701e604beab9$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $de96701e604beab9$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $de96701e604beab9$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $de96701e604beab9$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $de96701e604beab9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $de96701e604beab9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $de96701e604beab9$var$TypedArrayPrototypeSet(ret, new $de96701e604beab9$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $de96701e604beab9$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("8NU40", function(module, exports) {
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $668e63605ae89945$var$MathFloor = $hu6tI.MathFloor, $668e63605ae89945$var$NumberIsInteger = $hu6tI.NumberIsInteger;

var $ipLmc = parcelRequire("ipLmc");
var $668e63605ae89945$require$validateInteger = $ipLmc.validateInteger;

var $668e63605ae89945$var$ERR_INVALID_ARG_VALUE = (parcelRequire("kwaL9")).codes.ERR_INVALID_ARG_VALUE;
var $668e63605ae89945$var$defaultHighWaterMarkBytes = 16384;
var $668e63605ae89945$var$defaultHighWaterMarkObjectMode = 16;
function $668e63605ae89945$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $668e63605ae89945$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $668e63605ae89945$var$defaultHighWaterMarkObjectMode : $668e63605ae89945$var$defaultHighWaterMarkBytes;
}
function $668e63605ae89945$var$setDefaultHighWaterMark(objectMode, value) {
    $668e63605ae89945$require$validateInteger(value, 'value', 0);
    if (objectMode) $668e63605ae89945$var$defaultHighWaterMarkObjectMode = value;
    else $668e63605ae89945$var$defaultHighWaterMarkBytes = value;
}
function $668e63605ae89945$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $668e63605ae89945$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$668e63605ae89945$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $668e63605ae89945$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $668e63605ae89945$var$MathFloor(hwm);
    }
    // Default value
    return $668e63605ae89945$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $668e63605ae89945$var$getHighWaterMark,
    getDefaultHighWaterMark: $668e63605ae89945$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $668e63605ae89945$var$setDefaultHighWaterMark
};

});

parcelRegister("91wIh", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hu6tI = parcelRequire("hu6tI");
/* replacement end */ var $691d9530bd57ba99$var$PromisePrototypeThen = $hu6tI.PromisePrototypeThen, $691d9530bd57ba99$var$SymbolAsyncIterator = $hu6tI.SymbolAsyncIterator, $691d9530bd57ba99$var$SymbolIterator = $hu6tI.SymbolIterator;

var $bMIbb = parcelRequire("bMIbb");
var $691d9530bd57ba99$require$Buffer = $bMIbb.Buffer;

var $kwaL9 = parcelRequire("kwaL9");
var $691d9530bd57ba99$require$_require_codes = $kwaL9.codes;
var $691d9530bd57ba99$var$ERR_INVALID_ARG_TYPE = $691d9530bd57ba99$require$_require_codes.ERR_INVALID_ARG_TYPE, $691d9530bd57ba99$var$ERR_STREAM_NULL_VALUES = $691d9530bd57ba99$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $691d9530bd57ba99$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $691d9530bd57ba99$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$691d9530bd57ba99$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$691d9530bd57ba99$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$691d9530bd57ba99$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$691d9530bd57ba99$var$SymbolIterator]();
    } else throw new $691d9530bd57ba99$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $691d9530bd57ba99$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $691d9530bd57ba99$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $691d9530bd57ba99$var$from;

});


parcelRegister("lm9mM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hu6tI = parcelRequire("hu6tI");
/* replacement end */ var $f8c2eb07828144fa$var$ArrayPrototypeSlice = $hu6tI.ArrayPrototypeSlice, $f8c2eb07828144fa$var$Error = $hu6tI.Error, $f8c2eb07828144fa$var$FunctionPrototypeSymbolHasInstance = $hu6tI.FunctionPrototypeSymbolHasInstance, $f8c2eb07828144fa$var$ObjectDefineProperty = $hu6tI.ObjectDefineProperty, $f8c2eb07828144fa$var$ObjectDefineProperties = $hu6tI.ObjectDefineProperties, $f8c2eb07828144fa$var$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf, $f8c2eb07828144fa$var$StringPrototypeToLowerCase = $hu6tI.StringPrototypeToLowerCase, $f8c2eb07828144fa$var$Symbol = $hu6tI.Symbol, $f8c2eb07828144fa$var$SymbolHasInstance = $hu6tI.SymbolHasInstance;
module.exports = $f8c2eb07828144fa$var$Writable;
$f8c2eb07828144fa$var$Writable.WritableState = $f8c2eb07828144fa$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $f8c2eb07828144fa$var$EE = $bBoAO.EventEmitter;

var $i4Yg4 = parcelRequire("i4Yg4");
var $f8c2eb07828144fa$require$Stream = $i4Yg4.Stream;

var $bMIbb = parcelRequire("bMIbb");
var $f8c2eb07828144fa$require$Buffer = $bMIbb.Buffer;

var $8oqOv = parcelRequire("8oqOv");

var $aEL2R = parcelRequire("aEL2R");
var $f8c2eb07828144fa$require$addAbortSignal = $aEL2R.addAbortSignal;

var $8NU40 = parcelRequire("8NU40");
var $f8c2eb07828144fa$var$getHighWaterMark = $8NU40.getHighWaterMark, $f8c2eb07828144fa$var$getDefaultHighWaterMark = $8NU40.getDefaultHighWaterMark;

var $kwaL9 = parcelRequire("kwaL9");
var $f8c2eb07828144fa$require$_require_codes = $kwaL9.codes;
var $f8c2eb07828144fa$var$ERR_INVALID_ARG_TYPE = $f8c2eb07828144fa$require$_require_codes.ERR_INVALID_ARG_TYPE, $f8c2eb07828144fa$var$ERR_METHOD_NOT_IMPLEMENTED = $f8c2eb07828144fa$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $f8c2eb07828144fa$var$ERR_MULTIPLE_CALLBACK = $f8c2eb07828144fa$require$_require_codes.ERR_MULTIPLE_CALLBACK, $f8c2eb07828144fa$var$ERR_STREAM_CANNOT_PIPE = $f8c2eb07828144fa$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED = $f8c2eb07828144fa$require$_require_codes.ERR_STREAM_DESTROYED, $f8c2eb07828144fa$var$ERR_STREAM_ALREADY_FINISHED = $f8c2eb07828144fa$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $f8c2eb07828144fa$var$ERR_STREAM_NULL_VALUES = $f8c2eb07828144fa$require$_require_codes.ERR_STREAM_NULL_VALUES, $f8c2eb07828144fa$var$ERR_STREAM_WRITE_AFTER_END = $f8c2eb07828144fa$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $f8c2eb07828144fa$var$ERR_UNKNOWN_ENCODING = $f8c2eb07828144fa$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $f8c2eb07828144fa$var$errorOrDestroy = $8oqOv.errorOrDestroy;
$f8c2eb07828144fa$var$ObjectSetPrototypeOf($f8c2eb07828144fa$var$Writable.prototype, $f8c2eb07828144fa$require$Stream.prototype);
$f8c2eb07828144fa$var$ObjectSetPrototypeOf($f8c2eb07828144fa$var$Writable, $f8c2eb07828144fa$require$Stream);
function $f8c2eb07828144fa$var$nop() {}
var $f8c2eb07828144fa$var$kOnFinished = $f8c2eb07828144fa$var$Symbol('kOnFinished');

function $f8c2eb07828144fa$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("eCbWS"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $f8c2eb07828144fa$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $f8c2eb07828144fa$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $f8c2eb07828144fa$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $f8c2eb07828144fa$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$f8c2eb07828144fa$var$kOnFinished] = [];
}
function $f8c2eb07828144fa$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$f8c2eb07828144fa$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $f8c2eb07828144fa$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$f8c2eb07828144fa$var$ObjectDefineProperty($f8c2eb07828144fa$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $f8c2eb07828144fa$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("eCbWS"));
    if (!isDuplex && !$f8c2eb07828144fa$var$FunctionPrototypeSymbolHasInstance($f8c2eb07828144fa$var$Writable, this)) return new $f8c2eb07828144fa$var$Writable(options);
    this._writableState = new $f8c2eb07828144fa$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $f8c2eb07828144fa$require$addAbortSignal(options.signal, this);
    }
    $f8c2eb07828144fa$require$Stream.call(this, options);
    $8oqOv.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $f8c2eb07828144fa$var$clearBuffer(_this, state);
        $f8c2eb07828144fa$var$finishMaybe(_this, state);
    });
}
$f8c2eb07828144fa$var$ObjectDefineProperty($f8c2eb07828144fa$var$Writable, $f8c2eb07828144fa$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($f8c2eb07828144fa$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $f8c2eb07828144fa$var$Writable) return false;
        return object && object._writableState instanceof $f8c2eb07828144fa$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$f8c2eb07828144fa$var$Writable.prototype.pipe = function() {
    $f8c2eb07828144fa$var$errorOrDestroy(this, new $f8c2eb07828144fa$var$ERR_STREAM_CANNOT_PIPE());
};
function $f8c2eb07828144fa$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$f8c2eb07828144fa$require$Buffer.isEncoding(encoding)) throw new $f8c2eb07828144fa$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $f8c2eb07828144fa$var$nop;
    }
    if (chunk === null) throw new $f8c2eb07828144fa$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $f8c2eb07828144fa$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $f8c2eb07828144fa$require$Buffer) encoding = 'buffer';
        else if ($f8c2eb07828144fa$require$Stream._isUint8Array(chunk)) {
            chunk = $f8c2eb07828144fa$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $f8c2eb07828144fa$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $f8c2eb07828144fa$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $f8c2eb07828144fa$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $f8c2eb07828144fa$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$f8c2eb07828144fa$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $f8c2eb07828144fa$var$_write(this, chunk, encoding, cb) === true;
};
$f8c2eb07828144fa$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f8c2eb07828144fa$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $f8c2eb07828144fa$var$clearBuffer(this, state);
    }
};
$f8c2eb07828144fa$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $f8c2eb07828144fa$var$StringPrototypeToLowerCase(encoding);
    if (!$f8c2eb07828144fa$require$Buffer.isEncoding(encoding)) throw new $f8c2eb07828144fa$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f8c2eb07828144fa$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $f8c2eb07828144fa$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $f8c2eb07828144fa$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f8c2eb07828144fa$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $f8c2eb07828144fa$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $f8c2eb07828144fa$var$errorOrDestroy(stream, er);
}
function $f8c2eb07828144fa$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $f8c2eb07828144fa$var$errorOrDestroy(stream, new $f8c2eb07828144fa$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($f8c2eb07828144fa$var$onwriteError, stream, state, er, cb);
        else $f8c2eb07828144fa$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $f8c2eb07828144fa$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($f8c2eb07828144fa$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $f8c2eb07828144fa$var$afterWrite(stream, state, 1, cb);
    }
}
function $f8c2eb07828144fa$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $f8c2eb07828144fa$var$afterWrite(stream, state, count, cb);
}
function $f8c2eb07828144fa$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $f8c2eb07828144fa$var$errorBuffer(state);
    $f8c2eb07828144fa$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $f8c2eb07828144fa$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$f8c2eb07828144fa$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED('end'));
    }
    $f8c2eb07828144fa$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $f8c2eb07828144fa$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $f8c2eb07828144fa$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $f8c2eb07828144fa$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $f8c2eb07828144fa$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $f8c2eb07828144fa$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $f8c2eb07828144fa$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $f8c2eb07828144fa$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$f8c2eb07828144fa$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $f8c2eb07828144fa$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$f8c2eb07828144fa$var$Writable.prototype._writev = null;
$f8c2eb07828144fa$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $f8c2eb07828144fa$var$_write(this, chunk, encoding);
        if (ret instanceof $f8c2eb07828144fa$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $f8c2eb07828144fa$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $f8c2eb07828144fa$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $f8c2eb07828144fa$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$f8c2eb07828144fa$var$kOnFinished].push(cb);
    }
    return this;
};
function $f8c2eb07828144fa$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $f8c2eb07828144fa$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $f8c2eb07828144fa$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $f8c2eb07828144fa$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$f8c2eb07828144fa$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $f8c2eb07828144fa$var$errorOrDestroy(stream, err, state.sync);
        } else if ($f8c2eb07828144fa$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($f8c2eb07828144fa$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $f8c2eb07828144fa$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $f8c2eb07828144fa$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f8c2eb07828144fa$var$finishMaybe(stream, state, sync) {
    if ($f8c2eb07828144fa$var$needFinish(state)) {
        $f8c2eb07828144fa$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($f8c2eb07828144fa$var$needFinish(state)) $f8c2eb07828144fa$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($f8c2eb07828144fa$var$needFinish(state)) {
                state.pendingcb++;
                $f8c2eb07828144fa$var$finish(stream, state);
            }
        }
    }
}
function $f8c2eb07828144fa$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$f8c2eb07828144fa$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$f8c2eb07828144fa$var$ObjectDefineProperties($f8c2eb07828144fa$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $f8c2eb07828144fa$var$destroy = $8oqOv.destroy;
$f8c2eb07828144fa$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$f8c2eb07828144fa$var$kOnFinished].length)) $2Qkr5.nextTick($f8c2eb07828144fa$var$errorBuffer, state);
    $f8c2eb07828144fa$var$destroy.call(this, err, cb);
    return this;
};
$f8c2eb07828144fa$var$Writable.prototype._undestroy = $8oqOv.undestroy;
$f8c2eb07828144fa$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$f8c2eb07828144fa$var$Writable.prototype[$f8c2eb07828144fa$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $f8c2eb07828144fa$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f8c2eb07828144fa$var$lazyWebStreams() {
    if ($f8c2eb07828144fa$var$webStreamsAdapters === undefined) $f8c2eb07828144fa$var$webStreamsAdapters = {};
    return $f8c2eb07828144fa$var$webStreamsAdapters;
}
$f8c2eb07828144fa$var$Writable.fromWeb = function(writableStream, options) {
    return $f8c2eb07828144fa$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$f8c2eb07828144fa$var$Writable.toWeb = function(streamWritable) {
    return $f8c2eb07828144fa$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("8OYgH", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $bMIbb = parcelRequire("bMIbb");

var $ekKVz = parcelRequire("ekKVz");
var $66c1be4748958a4c$var$isReadable = $ekKVz.isReadable, $66c1be4748958a4c$var$isWritable = $ekKVz.isWritable, $66c1be4748958a4c$var$isIterable = $ekKVz.isIterable, $66c1be4748958a4c$var$isNodeStream = $ekKVz.isNodeStream, $66c1be4748958a4c$var$isReadableNodeStream = $ekKVz.isReadableNodeStream, $66c1be4748958a4c$var$isWritableNodeStream = $ekKVz.isWritableNodeStream, $66c1be4748958a4c$var$isDuplexNodeStream = $ekKVz.isDuplexNodeStream, $66c1be4748958a4c$var$isReadableStream = $ekKVz.isReadableStream, $66c1be4748958a4c$var$isWritableStream = $ekKVz.isWritableStream;

var $3lOnL = parcelRequire("3lOnL");

var $kwaL9 = parcelRequire("kwaL9");
var $66c1be4748958a4c$var$AbortError = $kwaL9.AbortError, $66c1be4748958a4c$var$_require_codes = $kwaL9.codes, $66c1be4748958a4c$var$ERR_INVALID_ARG_TYPE = $66c1be4748958a4c$var$_require_codes.ERR_INVALID_ARG_TYPE, $66c1be4748958a4c$var$ERR_INVALID_RETURN_VALUE = $66c1be4748958a4c$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $8oqOv = parcelRequire("8oqOv");
var $66c1be4748958a4c$require$destroyer = $8oqOv.destroyer;

var $eCbWS = parcelRequire("eCbWS");

var $TYLM0 = parcelRequire("TYLM0");

var $lm9mM = parcelRequire("lm9mM");

var $fktRN = parcelRequire("fktRN");
var $66c1be4748958a4c$require$createDeferredPromise = $fktRN.createDeferredPromise;

var $91wIh = parcelRequire("91wIh");
var $66c1be4748958a4c$var$Blob = globalThis.Blob || $bMIbb.Blob;
var $66c1be4748958a4c$var$isBlob = typeof $66c1be4748958a4c$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $66c1be4748958a4c$var$Blob;
} : function isBlob(b) {
    return false;
};

var $66c1be4748958a4c$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $hu6tI = parcelRequire("hu6tI");
var $66c1be4748958a4c$require$FunctionPrototypeCall = $hu6tI.FunctionPrototypeCall;
// This is needed for pre node 17.
var $66c1be4748958a4c$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($eCbWS);
module.exports = function duplexify(body, name) {
    if ($66c1be4748958a4c$var$isDuplexNodeStream(body)) return body;
    if ($66c1be4748958a4c$var$isReadableNodeStream(body)) return $66c1be4748958a4c$var$_duplexify({
        readable: body
    });
    if ($66c1be4748958a4c$var$isWritableNodeStream(body)) return $66c1be4748958a4c$var$_duplexify({
        writable: body
    });
    if ($66c1be4748958a4c$var$isNodeStream(body)) return $66c1be4748958a4c$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($66c1be4748958a4c$var$isReadableStream(body)) return $66c1be4748958a4c$var$_duplexify({
        readable: $TYLM0.fromWeb(body)
    });
    if ($66c1be4748958a4c$var$isWritableStream(body)) return $66c1be4748958a4c$var$_duplexify({
        writable: $lm9mM.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $66c1be4748958a4c$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($66c1be4748958a4c$var$isIterable(value)) return $91wIh($66c1be4748958a4c$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $66c1be4748958a4c$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $66c1be4748958a4c$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $66c1be4748958a4c$require$destroyer(d, err);
            });
            return d = new $66c1be4748958a4c$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $66c1be4748958a4c$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($66c1be4748958a4c$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($66c1be4748958a4c$var$isIterable(body)) return $91wIh($66c1be4748958a4c$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($66c1be4748958a4c$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $66c1be4748958a4c$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $66c1be4748958a4c$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $66c1be4748958a4c$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $66c1be4748958a4c$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $66c1be4748958a4c$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $66c1be4748958a4c$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $66c1be4748958a4c$require$destroyer(d1, err);
        });
        return d1 = new $66c1be4748958a4c$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $66c1be4748958a4c$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $66c1be4748958a4c$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $66c1be4748958a4c$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $66c1be4748958a4c$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $66c1be4748958a4c$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $66c1be4748958a4c$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $66c1be4748958a4c$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $TYLM0.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$66c1be4748958a4c$var$isReadable(r);
    var writable = !!$66c1be4748958a4c$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $66c1be4748958a4c$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $3lOnL(w, function(err) {
            writable = false;
            if (err) $66c1be4748958a4c$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $3lOnL(r, function(err) {
            readable = false;
            if (err) $66c1be4748958a4c$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $66c1be4748958a4c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $66c1be4748958a4c$require$destroyer(w, err);
            $66c1be4748958a4c$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2HHoM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $1f81430332b19b5b$require$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf;
module.exports = $1f81430332b19b5b$var$PassThrough;

var $1LsLb = parcelRequire("1LsLb");
$1f81430332b19b5b$require$ObjectSetPrototypeOf($1f81430332b19b5b$var$PassThrough.prototype, $1LsLb.prototype);
$1f81430332b19b5b$require$ObjectSetPrototypeOf($1f81430332b19b5b$var$PassThrough, $1LsLb);
function $1f81430332b19b5b$var$PassThrough(options) {
    if (!(this instanceof $1f81430332b19b5b$var$PassThrough)) return new $1f81430332b19b5b$var$PassThrough(options);
    $1LsLb.call(this, options);
}
$1f81430332b19b5b$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("1LsLb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $14907d58ebbb0f33$var$ObjectSetPrototypeOf = $hu6tI.ObjectSetPrototypeOf, $14907d58ebbb0f33$var$Symbol = $hu6tI.Symbol;
module.exports = $14907d58ebbb0f33$var$Transform;

var $14907d58ebbb0f33$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("kwaL9")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $eCbWS = parcelRequire("eCbWS");

var $8NU40 = parcelRequire("8NU40");
var $14907d58ebbb0f33$require$getHighWaterMark = $8NU40.getHighWaterMark;
$14907d58ebbb0f33$var$ObjectSetPrototypeOf($14907d58ebbb0f33$var$Transform.prototype, $eCbWS.prototype);
$14907d58ebbb0f33$var$ObjectSetPrototypeOf($14907d58ebbb0f33$var$Transform, $eCbWS);
var $14907d58ebbb0f33$var$kCallback = $14907d58ebbb0f33$var$Symbol('kCallback');
function $14907d58ebbb0f33$var$Transform(options) {
    if (!(this instanceof $14907d58ebbb0f33$var$Transform)) return new $14907d58ebbb0f33$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $14907d58ebbb0f33$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $eCbWS.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$14907d58ebbb0f33$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $14907d58ebbb0f33$var$prefinish);
}
function $14907d58ebbb0f33$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $14907d58ebbb0f33$var$prefinish() {
    if (this._final !== $14907d58ebbb0f33$var$_final) $14907d58ebbb0f33$var$_final.call(this);
}
$14907d58ebbb0f33$var$Transform.prototype._final = $14907d58ebbb0f33$var$_final;
$14907d58ebbb0f33$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $14907d58ebbb0f33$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$14907d58ebbb0f33$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$14907d58ebbb0f33$var$kCallback] = callback;
    });
};
$14907d58ebbb0f33$var$Transform.prototype._read = function() {
    if (this[$14907d58ebbb0f33$var$kCallback]) {
        var callback = this[$14907d58ebbb0f33$var$kCallback];
        this[$14907d58ebbb0f33$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("9GjPh", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hu6tI = parcelRequire("hu6tI");
var $70c76a5edd80a89c$var$ArrayPrototypePop = $hu6tI.ArrayPrototypePop, $70c76a5edd80a89c$var$Promise = $hu6tI.Promise;

var $ekKVz = parcelRequire("ekKVz");
var $70c76a5edd80a89c$var$isIterable = $ekKVz.isIterable, $70c76a5edd80a89c$var$isNodeStream = $ekKVz.isNodeStream, $70c76a5edd80a89c$var$isWebStream = $ekKVz.isWebStream;

var $dNzXS = parcelRequire("dNzXS");
var $70c76a5edd80a89c$var$pl = $dNzXS.pipelineImpl;

var $3lOnL = parcelRequire("3lOnL");
var $70c76a5edd80a89c$require$finished = $3lOnL.finished;
parcelRequire("cRgOS");
function $70c76a5edd80a89c$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $70c76a5edd80a89c$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$70c76a5edd80a89c$var$isNodeStream(lastArg) && !$70c76a5edd80a89c$var$isIterable(lastArg) && !$70c76a5edd80a89c$var$isWebStream(lastArg)) {
            var options = $70c76a5edd80a89c$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $70c76a5edd80a89c$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $70c76a5edd80a89c$require$finished,
    pipeline: $70c76a5edd80a89c$var$pipeline
};

});





parcelRegister("bhJ18", function(module, exports) {
"use strict";
var $837433c268fff143$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $837433c268fff143$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $837433c268fff143$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$837433c268fff143$var$__exportStar((parcelRequire("kOBYc")), module.exports);

});
parcelRegister("kOBYc", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlXml = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $aafx9 = parcelRequire("aafx9");

var $cmYRg = parcelRequire("cmYRg");

var $iZ0Xk = parcelRequire("iZ0Xk");
/**
 * A comunica sparql-results+xml Serialize Actor.
 */ var $f275ee378ef1ebc9$var$ActorQueryResultSerializeSparqlXml = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeSparqlXml, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeSparqlXml(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeSparqlXml);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeSparqlXml, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeSparqlXml, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'boolean'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams or booleans.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data, serializer, metadata, end, stream, result, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = new $cmYRg.Readable();
                                data._read = function() {
                                // Do nothing
                                };
                                serializer = new $iZ0Xk.XmlSerializer();
                                return [
                                    4,
                                    action.metadata()
                                ];
                            case 1:
                                metadata = _state.sent();
                                data.push($iZ0Xk.XmlSerializer.header);
                                data.push(serializer.open('sparql', {
                                    xmlns: 'http://www.w3.org/2005/sparql-results#'
                                }));
                                data.push(serializer.serializeNode({
                                    name: 'head',
                                    children: metadata.variables.map(function(variable) {
                                        return {
                                            name: 'variable',
                                            attributes: {
                                                name: variable.variable.value
                                            }
                                        };
                                    })
                                }));
                                if (!(action.type === 'bindings')) return [
                                    3,
                                    2
                                ];
                                end = function end() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    serializer.close()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    serializer.close()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                data.push(serializer.open('results'));
                                stream = (0, $aafx9.wrap)(action.bindingsStream).map(function(bindings) {
                                    return serializer.serializeNode({
                                        name: 'result',
                                        children: (0, $7WNf6._)(bindings).map(function(param) {
                                            var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                            return ActorQueryResultSerializeSparqlXml.bindingToXmlBindings(value, key);
                                        })
                                    });
                                }).append((0, $aafx9.wrap)(end()));
                                data.wrap(stream);
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    action.execute()
                                ];
                            case 3:
                                result = _state.sent();
                                data.push(serializer.serializeNode({
                                    name: 'boolean',
                                    children: result.toString()
                                }));
                                data.push(serializer.close());
                                setTimeout(function() {
                                    return data.push(null);
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                setTimeout(function() {
                                    return data.emit('error', error);
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "bindingToXmlBindings",
            value: /**
     * Converts an RDF term to its object-based XML representation.
     * @param {RDF.Term} value An RDF term.
     * @param {string} key A variable name, '?' must be included as a prefix.
     * @return {IXmlNode} An object-based XML tag.
     */ function bindingToXmlBindings(value, key) {
                return {
                    name: 'binding',
                    attributes: {
                        name: key.value
                    },
                    children: [
                        this.valueToXmlValue(value)
                    ]
                };
            }
        },
        {
            key: "valueToXmlValue",
            value: function valueToXmlValue(value) {
                var attributes;
                switch(value.termType){
                    case 'Literal':
                        if (value.language) attributes = {
                            'xml:lang': value.language
                        };
                        else if (value.datatype && value.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string') attributes = {
                            datatype: value.datatype.value
                        };
                        else attributes = {};
                        return {
                            name: 'literal',
                            attributes: attributes,
                            children: value.value
                        };
                    case 'BlankNode':
                        return {
                            name: 'bnode',
                            children: value.value
                        };
                    case 'Quad':
                        return {
                            name: 'triple',
                            children: [
                                {
                                    name: 'subject',
                                    children: [
                                        this.valueToXmlValue(value.subject)
                                    ]
                                },
                                {
                                    name: 'predicate',
                                    children: [
                                        this.valueToXmlValue(value.predicate)
                                    ]
                                },
                                {
                                    name: 'object',
                                    children: [
                                        this.valueToXmlValue(value.object)
                                    ]
                                }
                            ]
                        };
                    default:
                        return {
                            name: 'uri',
                            children: value.value
                        };
                }
            }
        }
    ]);
    return ActorQueryResultSerializeSparqlXml;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeSparqlXml = $f275ee378ef1ebc9$var$ActorQueryResultSerializeSparqlXml;

});
parcelRegister("cmYRg", function(module, exports) {
'use strict';

var $4ecLu = parcelRequire("4ecLu");

var $9fX8p = parcelRequire("9fX8p");
var $9016bf420ac66cb9$var$originalDestroy = $4ecLu.Readable.destroy;
module.exports = $4ecLu.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $4ecLu._uint8ArrayToBuffer;
module.exports._isUint8Array = $4ecLu._isUint8Array;
module.exports.isDisturbed = $4ecLu.isDisturbed;
module.exports.isErrored = $4ecLu.isErrored;
module.exports.isReadable = $4ecLu.isReadable;
module.exports.Readable = $4ecLu.Readable;
module.exports.Writable = $4ecLu.Writable;
module.exports.Duplex = $4ecLu.Duplex;
module.exports.Transform = $4ecLu.Transform;
module.exports.PassThrough = $4ecLu.PassThrough;
module.exports.addAbortSignal = $4ecLu.addAbortSignal;
module.exports.finished = $4ecLu.finished;
module.exports.destroy = $4ecLu.destroy;
module.exports.destroy = $9016bf420ac66cb9$var$originalDestroy;
module.exports.pipeline = $4ecLu.pipeline;
module.exports.compose = $4ecLu.compose;
Object.defineProperty($4ecLu, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $9fX8p;
    }
});
module.exports.Stream = $4ecLu.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("4ecLu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $9cHQz = parcelRequire("9cHQz");
var $31425f12cfb118bf$require$Buffer = $9cHQz.Buffer;

var $kdkK0 = parcelRequire("kdkK0");
/* replacement end */ var $31425f12cfb118bf$var$ObjectDefineProperty = $kdkK0.ObjectDefineProperty, $31425f12cfb118bf$var$ObjectKeys = $kdkK0.ObjectKeys, $31425f12cfb118bf$var$ReflectApply = $kdkK0.ReflectApply;

var $amFNO = parcelRequire("amFNO");
var $31425f12cfb118bf$var$_require_promisify = $amFNO.promisify, $31425f12cfb118bf$var$customPromisify = $31425f12cfb118bf$var$_require_promisify.custom;

var $hMXir = parcelRequire("hMXir");
var $31425f12cfb118bf$var$streamReturningOperators = $hMXir.streamReturningOperators, $31425f12cfb118bf$var$promiseReturningOperators = $hMXir.promiseReturningOperators;

var $lhKpv = parcelRequire("lhKpv");
var $31425f12cfb118bf$var$ERR_ILLEGAL_CONSTRUCTOR = $lhKpv.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $c1lsK = parcelRequire("c1lsK");

var $gs6oV = parcelRequire("gs6oV");
var $31425f12cfb118bf$var$setDefaultHighWaterMark = $gs6oV.setDefaultHighWaterMark, $31425f12cfb118bf$var$getDefaultHighWaterMark = $gs6oV.getDefaultHighWaterMark;

var $aT7Lf = parcelRequire("aT7Lf");
var $31425f12cfb118bf$require$pipeline = $aT7Lf.pipeline;

var $3mhwQ = parcelRequire("3mhwQ");
var $31425f12cfb118bf$require$destroyer = $3mhwQ.destroyer;

var $5P5kd = parcelRequire("5P5kd");
var $31425f12cfb118bf$var$internalBuffer = {};

var $9fX8p = parcelRequire("9fX8p");

var $fbUlO = parcelRequire("fbUlO");

var $31425f12cfb118bf$var$Stream = module.exports = (parcelRequire("h144z")).Stream;
$31425f12cfb118bf$var$Stream.isDestroyed = $fbUlO.isDestroyed;
$31425f12cfb118bf$var$Stream.isDisturbed = $fbUlO.isDisturbed;
$31425f12cfb118bf$var$Stream.isErrored = $fbUlO.isErrored;
$31425f12cfb118bf$var$Stream.isReadable = $fbUlO.isReadable;
$31425f12cfb118bf$var$Stream.isWritable = $fbUlO.isWritable;

$31425f12cfb118bf$var$Stream.Readable = (parcelRequire("5qi49"));
var $31425f12cfb118bf$var$_iteratorNormalCompletion = true, $31425f12cfb118bf$var$_didIteratorError = false, $31425f12cfb118bf$var$_iteratorError = undefined;
try {
    for(var $31425f12cfb118bf$var$_iterator = $31425f12cfb118bf$var$ObjectKeys($31425f12cfb118bf$var$streamReturningOperators)[Symbol.iterator](), $31425f12cfb118bf$var$_step; !($31425f12cfb118bf$var$_iteratorNormalCompletion = ($31425f12cfb118bf$var$_step = $31425f12cfb118bf$var$_iterator.next()).done); $31425f12cfb118bf$var$_iteratorNormalCompletion = true){
        var $31425f12cfb118bf$var$key = $31425f12cfb118bf$var$_step.value;
        var $31425f12cfb118bf$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $31425f12cfb118bf$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $31425f12cfb118bf$var$Stream.Readable.from($31425f12cfb118bf$var$ReflectApply($31425f12cfb118bf$var$op, this, args));
        };
        var $31425f12cfb118bf$var$op = $31425f12cfb118bf$var$streamReturningOperators[$31425f12cfb118bf$var$key];
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$fn, 'name', {
            __proto__: null,
            value: $31425f12cfb118bf$var$op.name
        });
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$fn, 'length', {
            __proto__: null,
            value: $31425f12cfb118bf$var$op.length
        });
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$Stream.Readable.prototype, $31425f12cfb118bf$var$key, {
            __proto__: null,
            value: $31425f12cfb118bf$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $31425f12cfb118bf$var$_didIteratorError = true;
    $31425f12cfb118bf$var$_iteratorError = err;
} finally{
    try {
        if (!$31425f12cfb118bf$var$_iteratorNormalCompletion && $31425f12cfb118bf$var$_iterator["return"] != null) {
            $31425f12cfb118bf$var$_iterator["return"]();
        }
    } finally{
        if ($31425f12cfb118bf$var$_didIteratorError) {
            throw $31425f12cfb118bf$var$_iteratorError;
        }
    }
}
var $31425f12cfb118bf$var$_iteratorNormalCompletion1 = true, $31425f12cfb118bf$var$_didIteratorError1 = false, $31425f12cfb118bf$var$_iteratorError1 = undefined;
try {
    for(var $31425f12cfb118bf$var$_iterator1 = $31425f12cfb118bf$var$ObjectKeys($31425f12cfb118bf$var$promiseReturningOperators)[Symbol.iterator](), $31425f12cfb118bf$var$_step1; !($31425f12cfb118bf$var$_iteratorNormalCompletion1 = ($31425f12cfb118bf$var$_step1 = $31425f12cfb118bf$var$_iterator1.next()).done); $31425f12cfb118bf$var$_iteratorNormalCompletion1 = true){
        var $31425f12cfb118bf$var$key1 = $31425f12cfb118bf$var$_step1.value;
        var $31425f12cfb118bf$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $31425f12cfb118bf$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $31425f12cfb118bf$var$ReflectApply($31425f12cfb118bf$var$op1, this, args);
        };
        var $31425f12cfb118bf$var$op1 = $31425f12cfb118bf$var$promiseReturningOperators[$31425f12cfb118bf$var$key1];
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$fn1, 'name', {
            __proto__: null,
            value: $31425f12cfb118bf$var$op1.name
        });
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$fn1, 'length', {
            __proto__: null,
            value: $31425f12cfb118bf$var$op1.length
        });
        $31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$Stream.Readable.prototype, $31425f12cfb118bf$var$key1, {
            __proto__: null,
            value: $31425f12cfb118bf$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $31425f12cfb118bf$var$_didIteratorError1 = true;
    $31425f12cfb118bf$var$_iteratorError1 = err;
} finally{
    try {
        if (!$31425f12cfb118bf$var$_iteratorNormalCompletion1 && $31425f12cfb118bf$var$_iterator1["return"] != null) {
            $31425f12cfb118bf$var$_iterator1["return"]();
        }
    } finally{
        if ($31425f12cfb118bf$var$_didIteratorError1) {
            throw $31425f12cfb118bf$var$_iteratorError1;
        }
    }
}

$31425f12cfb118bf$var$Stream.Writable = (parcelRequire("euisa"));

$31425f12cfb118bf$var$Stream.Duplex = (parcelRequire("fNq7V"));

$31425f12cfb118bf$var$Stream.Transform = (parcelRequire("hZ8Xt"));

$31425f12cfb118bf$var$Stream.PassThrough = (parcelRequire("j7DUE"));
$31425f12cfb118bf$var$Stream.pipeline = $31425f12cfb118bf$require$pipeline;

var $8wW07 = parcelRequire("8wW07");
var $31425f12cfb118bf$require$addAbortSignal = $8wW07.addAbortSignal;
$31425f12cfb118bf$var$Stream.addAbortSignal = $31425f12cfb118bf$require$addAbortSignal;
$31425f12cfb118bf$var$Stream.finished = $5P5kd;
$31425f12cfb118bf$var$Stream.destroy = $31425f12cfb118bf$require$destroyer;
$31425f12cfb118bf$var$Stream.compose = $c1lsK;
$31425f12cfb118bf$var$Stream.setDefaultHighWaterMark = $31425f12cfb118bf$var$setDefaultHighWaterMark;
$31425f12cfb118bf$var$Stream.getDefaultHighWaterMark = $31425f12cfb118bf$var$getDefaultHighWaterMark;
$31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $9fX8p;
    }
});
$31425f12cfb118bf$var$ObjectDefineProperty($31425f12cfb118bf$require$pipeline, $31425f12cfb118bf$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9fX8p.pipeline;
    }
});
$31425f12cfb118bf$var$ObjectDefineProperty($5P5kd, $31425f12cfb118bf$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9fX8p.finished;
    }
});
// Backwards-compat with node 0.4.x
$31425f12cfb118bf$var$Stream.Stream = $31425f12cfb118bf$var$Stream;
$31425f12cfb118bf$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$31425f12cfb118bf$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $31425f12cfb118bf$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("9cHQz", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6b373f24e3958fb2$export$a143d493d941bafc; }, function (v) { return $6b373f24e3958fb2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6b373f24e3958fb2$export$f99ded8fe4b79145; }, function (v) { return $6b373f24e3958fb2$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $6b373f24e3958fb2$export$a143d493d941bafc;
var $6b373f24e3958fb2$export$e4cf37d7f6fb9e0a;
var $6b373f24e3958fb2$export$f99ded8fe4b79145;
var $6b373f24e3958fb2$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $6b373f24e3958fb2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6b373f24e3958fb2$export$a143d493d941bafc = $6b373f24e3958fb2$var$Buffer;
$6b373f24e3958fb2$export$e4cf37d7f6fb9e0a = $6b373f24e3958fb2$var$SlowBuffer;
$6b373f24e3958fb2$export$f99ded8fe4b79145 = 50;
var $6b373f24e3958fb2$var$K_MAX_LENGTH = 0x7fffffff;
$6b373f24e3958fb2$export$599f31c3813fae4d = $6b373f24e3958fb2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6b373f24e3958fb2$var$Buffer.TYPED_ARRAY_SUPPORT = $6b373f24e3958fb2$var$typedArraySupport();
if (!$6b373f24e3958fb2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6b373f24e3958fb2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6b373f24e3958fb2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$6b373f24e3958fb2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6b373f24e3958fb2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$6b373f24e3958fb2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6b373f24e3958fb2$var$createBuffer(length) {
    if (length > $6b373f24e3958fb2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6b373f24e3958fb2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6b373f24e3958fb2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6b373f24e3958fb2$var$allocUnsafe(arg);
    }
    return $6b373f24e3958fb2$var$from(arg, encodingOrOffset, length);
}
$6b373f24e3958fb2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6b373f24e3958fb2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6b373f24e3958fb2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6b373f24e3958fb2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($6b373f24e3958fb2$var$isInstance(value, ArrayBuffer) || value && $6b373f24e3958fb2$var$isInstance(value.buffer, ArrayBuffer)) return $6b373f24e3958fb2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6b373f24e3958fb2$var$isInstance(value, SharedArrayBuffer) || value && $6b373f24e3958fb2$var$isInstance(value.buffer, SharedArrayBuffer))) return $6b373f24e3958fb2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6b373f24e3958fb2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6b373f24e3958fb2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6b373f24e3958fb2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6b373f24e3958fb2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6b373f24e3958fb2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6b373f24e3958fb2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6b373f24e3958fb2$var$Buffer, Uint8Array);
function $6b373f24e3958fb2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6b373f24e3958fb2$var$alloc(size, fill, encoding) {
    $6b373f24e3958fb2$var$assertSize(size);
    if (size <= 0) return $6b373f24e3958fb2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6b373f24e3958fb2$var$createBuffer(size).fill(fill, encoding) : $6b373f24e3958fb2$var$createBuffer(size).fill(fill);
    return $6b373f24e3958fb2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6b373f24e3958fb2$var$Buffer.alloc = function(size, fill, encoding) {
    return $6b373f24e3958fb2$var$alloc(size, fill, encoding);
};
function $6b373f24e3958fb2$var$allocUnsafe(size) {
    $6b373f24e3958fb2$var$assertSize(size);
    return $6b373f24e3958fb2$var$createBuffer(size < 0 ? 0 : $6b373f24e3958fb2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6b373f24e3958fb2$var$Buffer.allocUnsafe = function(size) {
    return $6b373f24e3958fb2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6b373f24e3958fb2$var$Buffer.allocUnsafeSlow = function(size) {
    return $6b373f24e3958fb2$var$allocUnsafe(size);
};
function $6b373f24e3958fb2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6b373f24e3958fb2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6b373f24e3958fb2$var$byteLength(string, encoding) | 0;
    var buf = $6b373f24e3958fb2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6b373f24e3958fb2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6b373f24e3958fb2$var$checked(array.length) | 0;
    var buf = $6b373f24e3958fb2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6b373f24e3958fb2$var$fromArrayView(arrayView) {
    if ($6b373f24e3958fb2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6b373f24e3958fb2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6b373f24e3958fb2$var$fromArrayLike(arrayView);
}
function $6b373f24e3958fb2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6b373f24e3958fb2$var$Buffer.prototype);
    return buf;
}
function $6b373f24e3958fb2$var$fromObject(obj) {
    if ($6b373f24e3958fb2$var$Buffer.isBuffer(obj)) {
        var len = $6b373f24e3958fb2$var$checked(obj.length) | 0;
        var buf = $6b373f24e3958fb2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6b373f24e3958fb2$var$numberIsNaN(obj.length)) return $6b373f24e3958fb2$var$createBuffer(0);
        return $6b373f24e3958fb2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6b373f24e3958fb2$var$fromArrayLike(obj.data);
}
function $6b373f24e3958fb2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6b373f24e3958fb2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6b373f24e3958fb2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6b373f24e3958fb2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6b373f24e3958fb2$var$Buffer.alloc(+length);
}
$6b373f24e3958fb2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6b373f24e3958fb2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6b373f24e3958fb2$var$Buffer.compare = function compare(a, b) {
    if ($6b373f24e3958fb2$var$isInstance(a, Uint8Array)) a = $6b373f24e3958fb2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6b373f24e3958fb2$var$isInstance(b, Uint8Array)) b = $6b373f24e3958fb2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6b373f24e3958fb2$var$Buffer.isBuffer(a) || !$6b373f24e3958fb2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6b373f24e3958fb2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6b373f24e3958fb2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6b373f24e3958fb2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6b373f24e3958fb2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6b373f24e3958fb2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6b373f24e3958fb2$var$Buffer.isBuffer(buf)) buf = $6b373f24e3958fb2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6b373f24e3958fb2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6b373f24e3958fb2$var$byteLength(string, encoding) {
    if ($6b373f24e3958fb2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6b373f24e3958fb2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6b373f24e3958fb2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6b373f24e3958fb2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6b373f24e3958fb2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6b373f24e3958fb2$var$Buffer.byteLength = $6b373f24e3958fb2$var$byteLength;
function $6b373f24e3958fb2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6b373f24e3958fb2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6b373f24e3958fb2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6b373f24e3958fb2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6b373f24e3958fb2$var$latin1Slice(this, start, end);
        case 'base64':
            return $6b373f24e3958fb2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6b373f24e3958fb2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6b373f24e3958fb2$var$Buffer.prototype._isBuffer = true;
function $6b373f24e3958fb2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6b373f24e3958fb2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6b373f24e3958fb2$var$swap(this, i, i + 1);
    return this;
};
$6b373f24e3958fb2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6b373f24e3958fb2$var$swap(this, i, i + 3);
        $6b373f24e3958fb2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6b373f24e3958fb2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6b373f24e3958fb2$var$swap(this, i, i + 7);
        $6b373f24e3958fb2$var$swap(this, i + 1, i + 6);
        $6b373f24e3958fb2$var$swap(this, i + 2, i + 5);
        $6b373f24e3958fb2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6b373f24e3958fb2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6b373f24e3958fb2$var$utf8Slice(this, 0, length);
    return $6b373f24e3958fb2$var$slowToString.apply(this, arguments);
};
$6b373f24e3958fb2$var$Buffer.prototype.toLocaleString = $6b373f24e3958fb2$var$Buffer.prototype.toString;
$6b373f24e3958fb2$var$Buffer.prototype.equals = function equals(b) {
    if (!$6b373f24e3958fb2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6b373f24e3958fb2$var$Buffer.compare(this, b) === 0;
};
$6b373f24e3958fb2$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6b373f24e3958fb2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6b373f24e3958fb2$var$customInspectSymbol) $6b373f24e3958fb2$var$Buffer.prototype[$6b373f24e3958fb2$var$customInspectSymbol] = $6b373f24e3958fb2$var$Buffer.prototype.inspect;
$6b373f24e3958fb2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6b373f24e3958fb2$var$isInstance(target, Uint8Array)) target = $6b373f24e3958fb2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6b373f24e3958fb2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6b373f24e3958fb2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6b373f24e3958fb2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6b373f24e3958fb2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6b373f24e3958fb2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6b373f24e3958fb2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6b373f24e3958fb2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6b373f24e3958fb2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6b373f24e3958fb2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6b373f24e3958fb2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6b373f24e3958fb2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6b373f24e3958fb2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6b373f24e3958fb2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6b373f24e3958fb2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6b373f24e3958fb2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6b373f24e3958fb2$var$utf8Write(buf, string, offset, length) {
    return $6b373f24e3958fb2$var$blitBuffer($6b373f24e3958fb2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6b373f24e3958fb2$var$asciiWrite(buf, string, offset, length) {
    return $6b373f24e3958fb2$var$blitBuffer($6b373f24e3958fb2$var$asciiToBytes(string), buf, offset, length);
}
function $6b373f24e3958fb2$var$base64Write(buf, string, offset, length) {
    return $6b373f24e3958fb2$var$blitBuffer($6b373f24e3958fb2$var$base64ToBytes(string), buf, offset, length);
}
function $6b373f24e3958fb2$var$ucs2Write(buf, string, offset, length) {
    return $6b373f24e3958fb2$var$blitBuffer($6b373f24e3958fb2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6b373f24e3958fb2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6b373f24e3958fb2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6b373f24e3958fb2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6b373f24e3958fb2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6b373f24e3958fb2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6b373f24e3958fb2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6b373f24e3958fb2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6b373f24e3958fb2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $6b373f24e3958fb2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6b373f24e3958fb2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6b373f24e3958fb2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6b373f24e3958fb2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6b373f24e3958fb2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6b373f24e3958fb2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6b373f24e3958fb2$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6b373f24e3958fb2$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6b373f24e3958fb2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6b373f24e3958fb2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6b373f24e3958fb2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6b373f24e3958fb2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6b373f24e3958fb2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6b373f24e3958fb2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6b373f24e3958fb2$var$Buffer.prototype.readUintLE = $6b373f24e3958fb2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readUintBE = $6b373f24e3958fb2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readUint8 = $6b373f24e3958fb2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6b373f24e3958fb2$var$Buffer.prototype.readUint16LE = $6b373f24e3958fb2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6b373f24e3958fb2$var$Buffer.prototype.readUint16BE = $6b373f24e3958fb2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6b373f24e3958fb2$var$Buffer.prototype.readUint32LE = $6b373f24e3958fb2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6b373f24e3958fb2$var$Buffer.prototype.readUint32BE = $6b373f24e3958fb2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6b373f24e3958fb2$var$Buffer.prototype.readBigUInt64LE = $6b373f24e3958fb2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6b373f24e3958fb2$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6b373f24e3958fb2$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6b373f24e3958fb2$var$Buffer.prototype.readBigUInt64BE = $6b373f24e3958fb2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6b373f24e3958fb2$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6b373f24e3958fb2$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6b373f24e3958fb2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6b373f24e3958fb2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6b373f24e3958fb2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6b373f24e3958fb2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6b373f24e3958fb2$var$Buffer.prototype.readBigInt64LE = $6b373f24e3958fb2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6b373f24e3958fb2$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6b373f24e3958fb2$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6b373f24e3958fb2$var$Buffer.prototype.readBigInt64BE = $6b373f24e3958fb2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6b373f24e3958fb2$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6b373f24e3958fb2$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6b373f24e3958fb2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$6b373f24e3958fb2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$6b373f24e3958fb2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$6b373f24e3958fb2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $6b373f24e3958fb2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6b373f24e3958fb2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6b373f24e3958fb2$var$Buffer.prototype.writeUintLE = $6b373f24e3958fb2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6b373f24e3958fb2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUintBE = $6b373f24e3958fb2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6b373f24e3958fb2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUint8 = $6b373f24e3958fb2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUint16LE = $6b373f24e3958fb2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUint16BE = $6b373f24e3958fb2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUint32LE = $6b373f24e3958fb2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeUint32BE = $6b373f24e3958fb2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6b373f24e3958fb2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6b373f24e3958fb2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6b373f24e3958fb2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6b373f24e3958fb2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6b373f24e3958fb2$var$Buffer.prototype.writeBigUInt64LE = $6b373f24e3958fb2$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6b373f24e3958fb2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6b373f24e3958fb2$var$Buffer.prototype.writeBigUInt64BE = $6b373f24e3958fb2$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6b373f24e3958fb2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6b373f24e3958fb2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6b373f24e3958fb2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6b373f24e3958fb2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6b373f24e3958fb2$var$Buffer.prototype.writeBigInt64LE = $6b373f24e3958fb2$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6b373f24e3958fb2$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6b373f24e3958fb2$var$Buffer.prototype.writeBigInt64BE = $6b373f24e3958fb2$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6b373f24e3958fb2$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6b373f24e3958fb2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6b373f24e3958fb2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6b373f24e3958fb2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6b373f24e3958fb2$var$writeFloat(this, value, offset, true, noAssert);
};
$6b373f24e3958fb2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6b373f24e3958fb2$var$writeFloat(this, value, offset, false, noAssert);
};
function $6b373f24e3958fb2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6b373f24e3958fb2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6b373f24e3958fb2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6b373f24e3958fb2$var$writeDouble(this, value, offset, true, noAssert);
};
$6b373f24e3958fb2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6b373f24e3958fb2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6b373f24e3958fb2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6b373f24e3958fb2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6b373f24e3958fb2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6b373f24e3958fb2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6b373f24e3958fb2$var$Buffer.isBuffer(val) ? val : $6b373f24e3958fb2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6b373f24e3958fb2$var$errors = {};
function $6b373f24e3958fb2$var$E(sym, getMessage, Base) {
    $6b373f24e3958fb2$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6b373f24e3958fb2$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6b373f24e3958fb2$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$6b373f24e3958fb2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6b373f24e3958fb2$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6b373f24e3958fb2$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6b373f24e3958fb2$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6b373f24e3958fb2$var$checkBounds(buf, offset, byteLength) {
    $6b373f24e3958fb2$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6b373f24e3958fb2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6b373f24e3958fb2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6b373f24e3958fb2$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6b373f24e3958fb2$var$checkBounds(buf, offset, byteLength);
}
function $6b373f24e3958fb2$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6b373f24e3958fb2$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6b373f24e3958fb2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6b373f24e3958fb2$var$validateNumber(value, type);
        throw new $6b373f24e3958fb2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6b373f24e3958fb2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6b373f24e3958fb2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6b373f24e3958fb2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6b373f24e3958fb2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6b373f24e3958fb2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6b373f24e3958fb2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6b373f24e3958fb2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6b373f24e3958fb2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6b373f24e3958fb2$var$base64ToBytes(str) {
    return $abUaD.toByteArray($6b373f24e3958fb2$var$base64clean(str));
}
function $6b373f24e3958fb2$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6b373f24e3958fb2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6b373f24e3958fb2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6b373f24e3958fb2$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6b373f24e3958fb2$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6b373f24e3958fb2$var$BufferBigIntNotDefined : fn;
}
function $6b373f24e3958fb2$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("kdkK0", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $eb751c48ba4db6c3$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $eb751c48ba4db6c3$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("amFNO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $9cHQz = parcelRequire("9cHQz");

var $h8sz7 = parcelRequire("h8sz7");
var $78bc6286acf41e19$var$format = $h8sz7.format, $78bc6286acf41e19$var$inspect = $h8sz7.inspect;

var $lhKpv = parcelRequire("lhKpv");
var $78bc6286acf41e19$var$ERR_INVALID_ARG_TYPE = $lhKpv.codes.ERR_INVALID_ARG_TYPE;

var $kdkK0 = parcelRequire("kdkK0");
var $78bc6286acf41e19$var$kResistStopPropagation = $kdkK0.kResistStopPropagation, $78bc6286acf41e19$var$AggregateError = $kdkK0.AggregateError, $78bc6286acf41e19$var$SymbolDispose = $kdkK0.SymbolDispose;

var $78bc6286acf41e19$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $78bc6286acf41e19$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $78bc6286acf41e19$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $78bc6286acf41e19$var$Blob = globalThis.Blob || $9cHQz.Blob;
/* eslint-disable indent */ var $78bc6286acf41e19$var$isBlob = typeof $78bc6286acf41e19$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $78bc6286acf41e19$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $78bc6286acf41e19$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $78bc6286acf41e19$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $78bc6286acf41e19$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $78bc6286acf41e19$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $78bc6286acf41e19$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $78bc6286acf41e19$var$format,
    inspect: $78bc6286acf41e19$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $78bc6286acf41e19$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $78bc6286acf41e19$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $78bc6286acf41e19$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $78bc6286acf41e19$var$validateAbortSignal(signal, 'signal');
        $78bc6286acf41e19$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $78bc6286acf41e19$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $78bc6286acf41e19$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $78bc6286acf41e19$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $78bc6286acf41e19$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $78bc6286acf41e19$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("h8sz7", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("lhKpv", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $h8sz7 = parcelRequire("h8sz7");
var $f7ef2fa5c3de914b$var$format = $h8sz7.format, $f7ef2fa5c3de914b$var$inspect = $h8sz7.inspect;

var $kdkK0 = parcelRequire("kdkK0");
var $f7ef2fa5c3de914b$var$CustomAggregateError = $kdkK0.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $f7ef2fa5c3de914b$var$AggregateError = globalThis.AggregateError || $f7ef2fa5c3de914b$var$CustomAggregateError;
var $f7ef2fa5c3de914b$var$kIsNodeError = Symbol('kIsNodeError');
var $f7ef2fa5c3de914b$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $f7ef2fa5c3de914b$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $f7ef2fa5c3de914b$var$nodeInternalPrefix = '__node_internal_';
var $f7ef2fa5c3de914b$var$codes = {};
function $f7ef2fa5c3de914b$var$assert(value, message) {
    if (!value) throw new $f7ef2fa5c3de914b$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $f7ef2fa5c3de914b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $f7ef2fa5c3de914b$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $f7ef2fa5c3de914b$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $f7ef2fa5c3de914b$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $f7ef2fa5c3de914b$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $f7ef2fa5c3de914b$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $f7ef2fa5c3de914b$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$f7ef2fa5c3de914b$var$kIsNodeError] = true;
    $f7ef2fa5c3de914b$var$codes[code] = NodeError;
}
function $f7ef2fa5c3de914b$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $f7ef2fa5c3de914b$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $f7ef2fa5c3de914b$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $f7ef2fa5c3de914b$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $f7ef2fa5c3de914b$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $f7ef2fa5c3de914b$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$f7ef2fa5c3de914b$var$E('ERR_ASSERTION', '%s', Error);
$f7ef2fa5c3de914b$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $f7ef2fa5c3de914b$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $f7ef2fa5c3de914b$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($f7ef2fa5c3de914b$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($f7ef2fa5c3de914b$var$classRegExp.test(value)) instances.push(value);
            else {
                $f7ef2fa5c3de914b$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $f7ef2fa5c3de914b$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $f7ef2fa5c3de914b$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$f7ef2fa5c3de914b$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $f7ef2fa5c3de914b$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$f7ef2fa5c3de914b$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$f7ef2fa5c3de914b$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $f7ef2fa5c3de914b$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$f7ef2fa5c3de914b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $f7ef2fa5c3de914b$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $f7ef2fa5c3de914b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $f7ef2fa5c3de914b$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $f7ef2fa5c3de914b$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$f7ef2fa5c3de914b$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$f7ef2fa5c3de914b$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$f7ef2fa5c3de914b$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$f7ef2fa5c3de914b$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $f7ef2fa5c3de914b$var$AbortError,
    aggregateTwoErrors: $f7ef2fa5c3de914b$var$hideStackFrames($f7ef2fa5c3de914b$var$aggregateTwoErrors),
    hideStackFrames: $f7ef2fa5c3de914b$var$hideStackFrames,
    codes: $f7ef2fa5c3de914b$var$codes
};

});


parcelRegister("hMXir", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $cf34ea66bb962e18$export$42af8c323be37587; }, function (v) { return $cf34ea66bb962e18$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $cf34ea66bb962e18$export$f405f72c701dad87; }, function (v) { return $cf34ea66bb962e18$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $cf34ea66bb962e18$export$42af8c323be37587;
var $cf34ea66bb962e18$export$f405f72c701dad87;
'use strict';

var $cf34ea66bb962e18$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $lhKpv = parcelRequire("lhKpv");
var $cf34ea66bb962e18$var$_require_codes = $lhKpv.codes, $cf34ea66bb962e18$var$ERR_INVALID_ARG_VALUE = $cf34ea66bb962e18$var$_require_codes.ERR_INVALID_ARG_VALUE, $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE = $cf34ea66bb962e18$var$_require_codes.ERR_INVALID_ARG_TYPE, $cf34ea66bb962e18$var$ERR_MISSING_ARGS = $cf34ea66bb962e18$var$_require_codes.ERR_MISSING_ARGS, $cf34ea66bb962e18$var$ERR_OUT_OF_RANGE = $cf34ea66bb962e18$var$_require_codes.ERR_OUT_OF_RANGE, $cf34ea66bb962e18$var$AbortError = $lhKpv.AbortError;

var $jwkTK = parcelRequire("jwkTK");
var $cf34ea66bb962e18$var$validateAbortSignal = $jwkTK.validateAbortSignal, $cf34ea66bb962e18$var$validateInteger = $jwkTK.validateInteger, $cf34ea66bb962e18$var$validateObject = $jwkTK.validateObject;

var $cf34ea66bb962e18$var$kWeakHandler = (parcelRequire("kdkK0")).Symbol('kWeak');

var $cf34ea66bb962e18$var$kResistStopPropagation = (parcelRequire("kdkK0")).Symbol('kResistStopPropagation');

var $5P5kd = parcelRequire("5P5kd");
var $cf34ea66bb962e18$require$finished = $5P5kd.finished;

var $c1lsK = parcelRequire("c1lsK");

var $8wW07 = parcelRequire("8wW07");
var $cf34ea66bb962e18$require$addAbortSignalNoValidate = $8wW07.addAbortSignalNoValidate;

var $fbUlO = parcelRequire("fbUlO");
var $cf34ea66bb962e18$var$isWritable = $fbUlO.isWritable, $cf34ea66bb962e18$var$isNodeStream = $fbUlO.isNodeStream;

var $cf34ea66bb962e18$require$deprecate = (parcelRequire("amFNO")).deprecate;

var $cf34ea66bb962e18$var$ArrayPrototypePush = (parcelRequire("kdkK0")).ArrayPrototypePush, $cf34ea66bb962e18$var$Boolean = (parcelRequire("kdkK0")).Boolean, $cf34ea66bb962e18$var$MathFloor = (parcelRequire("kdkK0")).MathFloor, $cf34ea66bb962e18$var$Number = (parcelRequire("kdkK0")).Number, $cf34ea66bb962e18$var$NumberIsNaN = (parcelRequire("kdkK0")).NumberIsNaN, $cf34ea66bb962e18$var$Promise = (parcelRequire("kdkK0")).Promise, $cf34ea66bb962e18$var$PromiseReject = (parcelRequire("kdkK0")).PromiseReject, $cf34ea66bb962e18$var$PromiseResolve = (parcelRequire("kdkK0")).PromiseResolve, $cf34ea66bb962e18$var$PromisePrototypeThen = (parcelRequire("kdkK0")).PromisePrototypeThen, $cf34ea66bb962e18$var$Symbol = (parcelRequire("kdkK0")).Symbol;
var $cf34ea66bb962e18$var$kEmpty = $cf34ea66bb962e18$var$Symbol('kEmpty');
var $cf34ea66bb962e18$var$kEof = $cf34ea66bb962e18$var$Symbol('kEof');
function $cf34ea66bb962e18$var$compose(stream, options) {
    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
    if ($cf34ea66bb962e18$var$isNodeStream(stream) && !$cf34ea66bb962e18$var$isWritable(stream)) throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $c1lsK(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $cf34ea66bb962e18$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $cf34ea66bb962e18$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $cf34ea66bb962e18$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $cf34ea66bb962e18$var$MathFloor(options.highWaterMark);
    $cf34ea66bb962e18$var$validateInteger(concurrency, 'options.concurrency', 1);
    $cf34ea66bb962e18$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $cf34ea66bb962e18$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $cf34ea66bb962e18$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $cf34ea66bb962e18$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $cf34ea66bb962e18$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $cf34ea66bb962e18$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($cf34ea66bb962e18$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $cf34ea66bb962e18$var$PromiseReject(err1);
                                $cf34ea66bb962e18$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("amFNO")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($cf34ea66bb962e18$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $cf34ea66bb962e18$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                        if (!(val !== $cf34ea66bb962e18$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $cf34ea66bb962e18$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $cf34ea66bb962e18$var$asIndexedPairs(options) {
    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $cf34ea66bb962e18$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $cf34ea66bb962e18$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($cf34ea66bb962e18$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $cf34ea66bb962e18$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $cf34ea66bb962e18$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $cf34ea66bb962e18$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($cf34ea66bb962e18$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $cf34ea66bb962e18$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $cf34ea66bb962e18$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($cf34ea66bb962e18$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $cf34ea66bb962e18$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $cf34ea66bb962e18$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $cf34ea66bb962e18$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $cf34ea66bb962e18$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($cf34ea66bb962e18$var$ERR_MISSING_ARGS);
function $cf34ea66bb962e18$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $cf34ea66bb962e18$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $cf34ea66bb962e18$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $cf34ea66bb962e18$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $cf34ea66bb962e18$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $cf34ea66bb962e18$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $cf34ea66bb962e18$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $cf34ea66bb962e18$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $cf34ea66bb962e18$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $cf34ea66bb962e18$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $cf34ea66bb962e18$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $cf34ea66bb962e18$var$flatMap(fn, options) {
    var values = $cf34ea66bb962e18$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $cf34ea66bb962e18$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $cf34ea66bb962e18$var$Number(number);
    if ($cf34ea66bb962e18$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $cf34ea66bb962e18$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $cf34ea66bb962e18$var$drop(number, options) {
    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
    number = $cf34ea66bb962e18$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $cf34ea66bb962e18$var$take(number, options) {
    if (options != null) $cf34ea66bb962e18$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $cf34ea66bb962e18$var$validateAbortSignal(options.signal, 'options.signal');
    number = $cf34ea66bb962e18$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $cf34ea66bb962e18$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$cf34ea66bb962e18$export$42af8c323be37587 = {
    asIndexedPairs: $cf34ea66bb962e18$require$deprecate($cf34ea66bb962e18$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $cf34ea66bb962e18$var$drop,
    filter: $cf34ea66bb962e18$var$filter,
    flatMap: $cf34ea66bb962e18$var$flatMap,
    map: $cf34ea66bb962e18$var$map,
    take: $cf34ea66bb962e18$var$take,
    compose: $cf34ea66bb962e18$var$compose
};
$cf34ea66bb962e18$export$f405f72c701dad87 = {
    every: $cf34ea66bb962e18$var$every,
    forEach: $cf34ea66bb962e18$var$forEach,
    reduce: $cf34ea66bb962e18$var$reduce,
    toArray: $cf34ea66bb962e18$var$toArray,
    some: $cf34ea66bb962e18$var$some,
    find: $cf34ea66bb962e18$var$find
};

});
parcelRegister("jwkTK", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $e361376718b852d9$var$ArrayIsArray = $kdkK0.ArrayIsArray, $e361376718b852d9$var$ArrayPrototypeIncludes = $kdkK0.ArrayPrototypeIncludes, $e361376718b852d9$var$ArrayPrototypeJoin = $kdkK0.ArrayPrototypeJoin, $e361376718b852d9$var$ArrayPrototypeMap = $kdkK0.ArrayPrototypeMap, $e361376718b852d9$var$NumberIsInteger = $kdkK0.NumberIsInteger, $e361376718b852d9$var$NumberIsNaN = $kdkK0.NumberIsNaN, $e361376718b852d9$var$NumberMAX_SAFE_INTEGER = $kdkK0.NumberMAX_SAFE_INTEGER, $e361376718b852d9$var$NumberMIN_SAFE_INTEGER = $kdkK0.NumberMIN_SAFE_INTEGER, $e361376718b852d9$var$NumberParseInt = $kdkK0.NumberParseInt, $e361376718b852d9$var$ObjectPrototypeHasOwnProperty = $kdkK0.ObjectPrototypeHasOwnProperty, $e361376718b852d9$var$RegExpPrototypeExec = $kdkK0.RegExpPrototypeExec, $e361376718b852d9$var$String = $kdkK0.String, $e361376718b852d9$var$StringPrototypeToUpperCase = $kdkK0.StringPrototypeToUpperCase, $e361376718b852d9$var$StringPrototypeTrim = $kdkK0.StringPrototypeTrim;

var $lhKpv = parcelRequire("lhKpv");
var $e361376718b852d9$var$hideStackFrames = $lhKpv.hideStackFrames, $e361376718b852d9$var$_require_codes = $lhKpv.codes, $e361376718b852d9$var$ERR_SOCKET_BAD_PORT = $e361376718b852d9$var$_require_codes.ERR_SOCKET_BAD_PORT, $e361376718b852d9$var$ERR_INVALID_ARG_TYPE = $e361376718b852d9$var$_require_codes.ERR_INVALID_ARG_TYPE, $e361376718b852d9$var$ERR_INVALID_ARG_VALUE = $e361376718b852d9$var$_require_codes.ERR_INVALID_ARG_VALUE, $e361376718b852d9$var$ERR_OUT_OF_RANGE = $e361376718b852d9$var$_require_codes.ERR_OUT_OF_RANGE, $e361376718b852d9$var$ERR_UNKNOWN_SIGNAL = $e361376718b852d9$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $amFNO = parcelRequire("amFNO");
var $e361376718b852d9$require$normalizeEncoding = $amFNO.normalizeEncoding;

var $amFNO = parcelRequire("amFNO");
var $e361376718b852d9$require$_require_types = $amFNO.types;
var $e361376718b852d9$var$isAsyncFunction = $e361376718b852d9$require$_require_types.isAsyncFunction, $e361376718b852d9$var$isArrayBufferView = $e361376718b852d9$require$_require_types.isArrayBufferView;
var $e361376718b852d9$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e361376718b852d9$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e361376718b852d9$var$isUint32(value) {
    return value === value >>> 0;
}
var $e361376718b852d9$var$octalReg = /^[0-7]+$/;
var $e361376718b852d9$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e361376718b852d9$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e361376718b852d9$var$RegExpPrototypeExec($e361376718b852d9$var$octalReg, value) === null) throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE(name, value, $e361376718b852d9$var$modeDesc);
        value = $e361376718b852d9$var$NumberParseInt(value, 8);
    }
    $e361376718b852d9$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $e361376718b852d9$var$validateInteger = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e361376718b852d9$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $e361376718b852d9$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e361376718b852d9$var$NumberIsInteger(value)) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $e361376718b852d9$var$validateInt32 = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e361376718b852d9$var$NumberIsInteger(value)) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $e361376718b852d9$var$validateUint32 = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e361376718b852d9$var$NumberIsInteger(value)) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e361376718b852d9$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e361376718b852d9$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e361376718b852d9$var$NumberIsNaN(value)) throw new $e361376718b852d9$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $e361376718b852d9$var$validateOneOf = $e361376718b852d9$var$hideStackFrames(function(value, name, oneOf) {
    if (!$e361376718b852d9$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $e361376718b852d9$var$ArrayPrototypeJoin($e361376718b852d9$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $e361376718b852d9$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e361376718b852d9$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e361376718b852d9$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e361376718b852d9$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $e361376718b852d9$var$validateObject = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $e361376718b852d9$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $e361376718b852d9$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $e361376718b852d9$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e361376718b852d9$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $e361376718b852d9$var$validateDictionary = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $e361376718b852d9$var$validateArray = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$e361376718b852d9$var$ArrayIsArray(value)) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e361376718b852d9$var$validateStringArray(value, name) {
    $e361376718b852d9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e361376718b852d9$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e361376718b852d9$var$validateBooleanArray(value, name) {
    $e361376718b852d9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e361376718b852d9$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e361376718b852d9$var$validateAbortSignalArray(value, name) {
    $e361376718b852d9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e361376718b852d9$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e361376718b852d9$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $e361376718b852d9$var$validateString(signal, name);
    if ($e361376718b852d9$var$signals[signal] === undefined) {
        if ($e361376718b852d9$var$signals[$e361376718b852d9$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e361376718b852d9$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e361376718b852d9$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $e361376718b852d9$var$validateBuffer = $e361376718b852d9$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$e361376718b852d9$var$isArrayBufferView(buffer)) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e361376718b852d9$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $e361376718b852d9$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e361376718b852d9$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e361376718b852d9$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e361376718b852d9$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $e361376718b852d9$var$validateAbortSignal = $e361376718b852d9$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $e361376718b852d9$var$validateFunction = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $e361376718b852d9$var$validatePlainFunction = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $e361376718b852d9$var$isAsyncFunction(value)) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $e361376718b852d9$var$validateUndefined = $e361376718b852d9$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e361376718b852d9$var$validateUnion(value, name, union) {
    if (!$e361376718b852d9$var$ArrayPrototypeIncludes(union, value)) throw new $e361376718b852d9$var$ERR_INVALID_ARG_TYPE(name, "('".concat($e361376718b852d9$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $e361376718b852d9$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e361376718b852d9$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e361376718b852d9$var$RegExpPrototypeExec($e361376718b852d9$var$linkValueRegExp, value)) throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e361376718b852d9$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e361376718b852d9$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e361376718b852d9$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $e361376718b852d9$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e361376718b852d9$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e361376718b852d9$var$isInt32,
    isUint32: $e361376718b852d9$var$isUint32,
    parseFileMode: $e361376718b852d9$var$parseFileMode,
    validateArray: $e361376718b852d9$var$validateArray,
    validateStringArray: $e361376718b852d9$var$validateStringArray,
    validateBooleanArray: $e361376718b852d9$var$validateBooleanArray,
    validateAbortSignalArray: $e361376718b852d9$var$validateAbortSignalArray,
    validateBoolean: $e361376718b852d9$var$validateBoolean,
    validateBuffer: $e361376718b852d9$var$validateBuffer,
    validateDictionary: $e361376718b852d9$var$validateDictionary,
    validateEncoding: $e361376718b852d9$var$validateEncoding,
    validateFunction: $e361376718b852d9$var$validateFunction,
    validateInt32: $e361376718b852d9$var$validateInt32,
    validateInteger: $e361376718b852d9$var$validateInteger,
    validateNumber: $e361376718b852d9$var$validateNumber,
    validateObject: $e361376718b852d9$var$validateObject,
    validateOneOf: $e361376718b852d9$var$validateOneOf,
    validatePlainFunction: $e361376718b852d9$var$validatePlainFunction,
    validatePort: $e361376718b852d9$var$validatePort,
    validateSignalName: $e361376718b852d9$var$validateSignalName,
    validateString: $e361376718b852d9$var$validateString,
    validateUint32: $e361376718b852d9$var$validateUint32,
    validateUndefined: $e361376718b852d9$var$validateUndefined,
    validateUnion: $e361376718b852d9$var$validateUnion,
    validateAbortSignal: $e361376718b852d9$var$validateAbortSignal,
    validateLinkHeaderValue: $e361376718b852d9$var$validateLinkHeaderValue
};

});

parcelRegister("5P5kd", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lhKpv = parcelRequire("lhKpv");
/* replacement end */ var $43d5d899606f1af6$var$AbortError = $lhKpv.AbortError, $43d5d899606f1af6$var$codes = $lhKpv.codes;
var $43d5d899606f1af6$var$ERR_INVALID_ARG_TYPE = $43d5d899606f1af6$var$codes.ERR_INVALID_ARG_TYPE, $43d5d899606f1af6$var$ERR_STREAM_PREMATURE_CLOSE = $43d5d899606f1af6$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $43d5d899606f1af6$var$kEmptyObject = (parcelRequire("amFNO")).kEmptyObject, $43d5d899606f1af6$var$once = (parcelRequire("amFNO")).once;

var $jwkTK = parcelRequire("jwkTK");
var $43d5d899606f1af6$var$validateAbortSignal = $jwkTK.validateAbortSignal, $43d5d899606f1af6$var$validateFunction = $jwkTK.validateFunction, $43d5d899606f1af6$var$validateObject = $jwkTK.validateObject, $43d5d899606f1af6$var$validateBoolean = $jwkTK.validateBoolean;

var $kdkK0 = parcelRequire("kdkK0");
var $43d5d899606f1af6$var$Promise = $kdkK0.Promise, $43d5d899606f1af6$var$PromisePrototypeThen = $kdkK0.PromisePrototypeThen, $43d5d899606f1af6$var$SymbolDispose = $kdkK0.SymbolDispose;

var $fbUlO = parcelRequire("fbUlO");
var $43d5d899606f1af6$var$isClosed = $fbUlO.isClosed, $43d5d899606f1af6$var$isReadable = $fbUlO.isReadable, $43d5d899606f1af6$var$isReadableNodeStream = $fbUlO.isReadableNodeStream, $43d5d899606f1af6$var$isReadableStream = $fbUlO.isReadableStream, $43d5d899606f1af6$var$isReadableFinished = $fbUlO.isReadableFinished, $43d5d899606f1af6$var$isReadableErrored = $fbUlO.isReadableErrored, $43d5d899606f1af6$var$isWritable = $fbUlO.isWritable, $43d5d899606f1af6$var$isWritableNodeStream = $fbUlO.isWritableNodeStream, $43d5d899606f1af6$var$isWritableStream = $fbUlO.isWritableStream, $43d5d899606f1af6$var$isWritableFinished = $fbUlO.isWritableFinished, $43d5d899606f1af6$var$isWritableErrored = $fbUlO.isWritableErrored, $43d5d899606f1af6$var$isNodeStream = $fbUlO.isNodeStream, $43d5d899606f1af6$var$_willEmitClose = $fbUlO.willEmitClose, $43d5d899606f1af6$var$kIsClosedPromise = $fbUlO.kIsClosedPromise;
var $43d5d899606f1af6$var$addAbortListener;
function $43d5d899606f1af6$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $43d5d899606f1af6$var$nop = function() {};

function $43d5d899606f1af6$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $43d5d899606f1af6$var$kEmptyObject;
    } else if (options == null) options = $43d5d899606f1af6$var$kEmptyObject;
    else $43d5d899606f1af6$var$validateObject(options, 'options');
    $43d5d899606f1af6$var$validateFunction(callback, 'callback');
    $43d5d899606f1af6$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $43d5d899606f1af6$var$once(callback);
    if ($43d5d899606f1af6$var$isReadableStream(stream) || $43d5d899606f1af6$var$isWritableStream(stream)) return $43d5d899606f1af6$var$eosWeb(stream, options, callback);
    if (!$43d5d899606f1af6$var$isNodeStream(stream)) throw new $43d5d899606f1af6$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $43d5d899606f1af6$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $43d5d899606f1af6$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $43d5d899606f1af6$var$_willEmitClose(stream) && $43d5d899606f1af6$var$isReadableNodeStream(stream) === readable && $43d5d899606f1af6$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $43d5d899606f1af6$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $43d5d899606f1af6$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $43d5d899606f1af6$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $43d5d899606f1af6$var$isWritableErrored(stream) || $43d5d899606f1af6$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $43d5d899606f1af6$var$isReadableNodeStream(stream, true)) {
            if (!$43d5d899606f1af6$var$isReadableFinished(stream, false)) return callback.call(stream, new $43d5d899606f1af6$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$43d5d899606f1af6$var$isWritableFinished(stream, false)) return callback.call(stream, new $43d5d899606f1af6$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $43d5d899606f1af6$var$isWritableErrored(stream) || $43d5d899606f1af6$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($43d5d899606f1af6$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $43d5d899606f1af6$var$isReadable(stream)) && (writableFinished || $43d5d899606f1af6$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $43d5d899606f1af6$var$isWritable(stream)) && (readableFinished || $43d5d899606f1af6$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $43d5d899606f1af6$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $43d5d899606f1af6$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $43d5d899606f1af6$var$addAbortListener = $43d5d899606f1af6$var$addAbortListener || (parcelRequire("amFNO")).addAbortListener;
            var disposable = $43d5d899606f1af6$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $43d5d899606f1af6$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$43d5d899606f1af6$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $43d5d899606f1af6$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $43d5d899606f1af6$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $43d5d899606f1af6$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $43d5d899606f1af6$var$addAbortListener = $43d5d899606f1af6$var$addAbortListener || (parcelRequire("amFNO")).addAbortListener;
            var disposable = $43d5d899606f1af6$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $43d5d899606f1af6$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$43d5d899606f1af6$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $43d5d899606f1af6$var$PromisePrototypeThen(stream[$43d5d899606f1af6$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $43d5d899606f1af6$var$nop;
}
function $43d5d899606f1af6$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $43d5d899606f1af6$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $43d5d899606f1af6$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $43d5d899606f1af6$var$Promise(function(resolve, reject) {
        var cleanup = $43d5d899606f1af6$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $43d5d899606f1af6$var$eos;
module.exports.finished = $43d5d899606f1af6$var$finished;

});
parcelRegister("fbUlO", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $b0f398371dd01c11$var$SymbolAsyncIterator = $kdkK0.SymbolAsyncIterator, $b0f398371dd01c11$var$SymbolIterator = $kdkK0.SymbolIterator, $b0f398371dd01c11$var$SymbolFor = $kdkK0.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $b0f398371dd01c11$var$kIsDestroyed = $b0f398371dd01c11$var$SymbolFor('nodejs.stream.destroyed');
var $b0f398371dd01c11$var$kIsErrored = $b0f398371dd01c11$var$SymbolFor('nodejs.stream.errored');
var $b0f398371dd01c11$var$kIsReadable = $b0f398371dd01c11$var$SymbolFor('nodejs.stream.readable');
var $b0f398371dd01c11$var$kIsWritable = $b0f398371dd01c11$var$SymbolFor('nodejs.stream.writable');
var $b0f398371dd01c11$var$kIsDisturbed = $b0f398371dd01c11$var$SymbolFor('nodejs.stream.disturbed');
var $b0f398371dd01c11$var$kIsClosedPromise = $b0f398371dd01c11$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $b0f398371dd01c11$var$kControllerErrorFunction = $b0f398371dd01c11$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $b0f398371dd01c11$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $b0f398371dd01c11$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $b0f398371dd01c11$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $b0f398371dd01c11$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $b0f398371dd01c11$var$isReadableStream(obj) {
    return !!(obj && !$b0f398371dd01c11$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $b0f398371dd01c11$var$isWritableStream(obj) {
    return !!(obj && !$b0f398371dd01c11$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $b0f398371dd01c11$var$isTransformStream(obj) {
    return !!(obj && !$b0f398371dd01c11$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $b0f398371dd01c11$var$isWebStream(obj) {
    return $b0f398371dd01c11$var$isReadableStream(obj) || $b0f398371dd01c11$var$isWritableStream(obj) || $b0f398371dd01c11$var$isTransformStream(obj);
}
function $b0f398371dd01c11$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$b0f398371dd01c11$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$b0f398371dd01c11$var$SymbolIterator] === 'function';
    return typeof obj[$b0f398371dd01c11$var$SymbolAsyncIterator] === 'function' || typeof obj[$b0f398371dd01c11$var$SymbolIterator] === 'function';
}
function $b0f398371dd01c11$var$isDestroyed(stream) {
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$b0f398371dd01c11$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $b0f398371dd01c11$var$isWritableEnded(stream) {
    if (!$b0f398371dd01c11$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $b0f398371dd01c11$var$isWritableFinished(stream, strict) {
    if (!$b0f398371dd01c11$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $b0f398371dd01c11$var$isReadableEnded(stream) {
    if (!$b0f398371dd01c11$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $b0f398371dd01c11$var$isReadableFinished(stream, strict) {
    if (!$b0f398371dd01c11$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $b0f398371dd01c11$var$isReadable(stream) {
    if (stream && stream[$b0f398371dd01c11$var$kIsReadable] != null) return stream[$b0f398371dd01c11$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($b0f398371dd01c11$var$isDestroyed(stream)) return false;
    return $b0f398371dd01c11$var$isReadableNodeStream(stream) && stream.readable && !$b0f398371dd01c11$var$isReadableFinished(stream);
}
function $b0f398371dd01c11$var$isWritable(stream) {
    if (stream && stream[$b0f398371dd01c11$var$kIsWritable] != null) return stream[$b0f398371dd01c11$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($b0f398371dd01c11$var$isDestroyed(stream)) return false;
    return $b0f398371dd01c11$var$isWritableNodeStream(stream) && stream.writable && !$b0f398371dd01c11$var$isWritableEnded(stream);
}
function $b0f398371dd01c11$var$isFinished(stream, opts) {
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    if ($b0f398371dd01c11$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $b0f398371dd01c11$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $b0f398371dd01c11$var$isWritable(stream)) return false;
    return true;
}
function $b0f398371dd01c11$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $b0f398371dd01c11$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $b0f398371dd01c11$var$isClosed(stream) {
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $b0f398371dd01c11$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $b0f398371dd01c11$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $b0f398371dd01c11$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $b0f398371dd01c11$var$isOutgoingMessage(stream);
}
function $b0f398371dd01c11$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $b0f398371dd01c11$var$willEmitClose(stream) {
    if (!$b0f398371dd01c11$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $b0f398371dd01c11$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $b0f398371dd01c11$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$b0f398371dd01c11$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $b0f398371dd01c11$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$b0f398371dd01c11$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $b0f398371dd01c11$var$isDestroyed,
    kIsDestroyed: $b0f398371dd01c11$var$kIsDestroyed,
    isDisturbed: $b0f398371dd01c11$var$isDisturbed,
    kIsDisturbed: $b0f398371dd01c11$var$kIsDisturbed,
    isErrored: $b0f398371dd01c11$var$isErrored,
    kIsErrored: $b0f398371dd01c11$var$kIsErrored,
    isReadable: $b0f398371dd01c11$var$isReadable,
    kIsReadable: $b0f398371dd01c11$var$kIsReadable,
    kIsClosedPromise: $b0f398371dd01c11$var$kIsClosedPromise,
    kControllerErrorFunction: $b0f398371dd01c11$var$kControllerErrorFunction,
    kIsWritable: $b0f398371dd01c11$var$kIsWritable,
    isClosed: $b0f398371dd01c11$var$isClosed,
    isDuplexNodeStream: $b0f398371dd01c11$var$isDuplexNodeStream,
    isFinished: $b0f398371dd01c11$var$isFinished,
    isIterable: $b0f398371dd01c11$var$isIterable,
    isReadableNodeStream: $b0f398371dd01c11$var$isReadableNodeStream,
    isReadableStream: $b0f398371dd01c11$var$isReadableStream,
    isReadableEnded: $b0f398371dd01c11$var$isReadableEnded,
    isReadableFinished: $b0f398371dd01c11$var$isReadableFinished,
    isReadableErrored: $b0f398371dd01c11$var$isReadableErrored,
    isNodeStream: $b0f398371dd01c11$var$isNodeStream,
    isWebStream: $b0f398371dd01c11$var$isWebStream,
    isWritable: $b0f398371dd01c11$var$isWritable,
    isWritableNodeStream: $b0f398371dd01c11$var$isWritableNodeStream,
    isWritableStream: $b0f398371dd01c11$var$isWritableStream,
    isWritableEnded: $b0f398371dd01c11$var$isWritableEnded,
    isWritableFinished: $b0f398371dd01c11$var$isWritableFinished,
    isWritableErrored: $b0f398371dd01c11$var$isWritableErrored,
    isServerRequest: $b0f398371dd01c11$var$isServerRequest,
    isServerResponse: $b0f398371dd01c11$var$isServerResponse,
    willEmitClose: $b0f398371dd01c11$var$willEmitClose,
    isTransformStream: $b0f398371dd01c11$var$isTransformStream
};

});


parcelRegister("c1lsK", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $aT7Lf = parcelRequire("aT7Lf");
var $8c063a17dd940f9c$require$pipeline = $aT7Lf.pipeline;

var $fNq7V = parcelRequire("fNq7V");

var $3mhwQ = parcelRequire("3mhwQ");
var $8c063a17dd940f9c$require$destroyer = $3mhwQ.destroyer;

var $fbUlO = parcelRequire("fbUlO");
var $8c063a17dd940f9c$var$isNodeStream = $fbUlO.isNodeStream, $8c063a17dd940f9c$var$isReadable = $fbUlO.isReadable, $8c063a17dd940f9c$var$isWritable = $fbUlO.isWritable, $8c063a17dd940f9c$var$isWebStream = $fbUlO.isWebStream, $8c063a17dd940f9c$var$isTransformStream = $fbUlO.isTransformStream, $8c063a17dd940f9c$var$isWritableStream = $fbUlO.isWritableStream, $8c063a17dd940f9c$var$isReadableStream = $fbUlO.isReadableStream;

var $lhKpv = parcelRequire("lhKpv");
var $8c063a17dd940f9c$var$AbortError = $lhKpv.AbortError, $8c063a17dd940f9c$var$_require_codes = $lhKpv.codes, $8c063a17dd940f9c$var$ERR_INVALID_ARG_VALUE = $8c063a17dd940f9c$var$_require_codes.ERR_INVALID_ARG_VALUE, $8c063a17dd940f9c$var$ERR_MISSING_ARGS = $8c063a17dd940f9c$var$_require_codes.ERR_MISSING_ARGS;

var $5P5kd = parcelRequire("5P5kd");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $8c063a17dd940f9c$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $fNq7V.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $fNq7V.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $fNq7V.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$8c063a17dd940f9c$var$isNodeStream(streams[n]) && !$8c063a17dd940f9c$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($8c063a17dd940f9c$var$isReadable(streams[n]) || $8c063a17dd940f9c$var$isReadableStream(streams[n]) || $8c063a17dd940f9c$var$isTransformStream(streams[n]))) throw new $8c063a17dd940f9c$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($8c063a17dd940f9c$var$isWritable(streams[n]) || $8c063a17dd940f9c$var$isWritableStream(streams[n]) || $8c063a17dd940f9c$var$isTransformStream(streams[n]))) throw new $8c063a17dd940f9c$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $8c063a17dd940f9c$require$pipeline(streams, onfinished);
    var writable = !!($8c063a17dd940f9c$var$isWritable(head) || $8c063a17dd940f9c$var$isWritableStream(head) || $8c063a17dd940f9c$var$isTransformStream(head));
    var readable = !!($8c063a17dd940f9c$var$isReadable(tail) || $8c063a17dd940f9c$var$isReadableStream(tail) || $8c063a17dd940f9c$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $fNq7V({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($8c063a17dd940f9c$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($8c063a17dd940f9c$var$isWebStream(head)) {
            var writable1 = $8c063a17dd940f9c$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $8c063a17dd940f9c$var$isTransformStream(tail) ? tail.readable : tail;
        $5P5kd(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($8c063a17dd940f9c$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($8c063a17dd940f9c$var$isWebStream(tail)) {
            var readable1 = $8c063a17dd940f9c$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $8c063a17dd940f9c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($8c063a17dd940f9c$var$isNodeStream(tail)) $8c063a17dd940f9c$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("aT7Lf", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $7ed50f99e108d4b7$var$ArrayIsArray = $kdkK0.ArrayIsArray, $7ed50f99e108d4b7$var$Promise = $kdkK0.Promise, $7ed50f99e108d4b7$var$SymbolAsyncIterator = $kdkK0.SymbolAsyncIterator, $7ed50f99e108d4b7$var$SymbolDispose = $kdkK0.SymbolDispose;

var $5P5kd = parcelRequire("5P5kd");

var $7ed50f99e108d4b7$require$once = (parcelRequire("amFNO")).once;

var $3mhwQ = parcelRequire("3mhwQ");

var $fNq7V = parcelRequire("fNq7V");

var $lhKpv = parcelRequire("lhKpv");
var $7ed50f99e108d4b7$var$aggregateTwoErrors = $lhKpv.aggregateTwoErrors, $7ed50f99e108d4b7$var$_require_codes = $lhKpv.codes, $7ed50f99e108d4b7$var$ERR_INVALID_ARG_TYPE = $7ed50f99e108d4b7$var$_require_codes.ERR_INVALID_ARG_TYPE, $7ed50f99e108d4b7$var$ERR_INVALID_RETURN_VALUE = $7ed50f99e108d4b7$var$_require_codes.ERR_INVALID_RETURN_VALUE, $7ed50f99e108d4b7$var$ERR_MISSING_ARGS = $7ed50f99e108d4b7$var$_require_codes.ERR_MISSING_ARGS, $7ed50f99e108d4b7$var$ERR_STREAM_DESTROYED = $7ed50f99e108d4b7$var$_require_codes.ERR_STREAM_DESTROYED, $7ed50f99e108d4b7$var$ERR_STREAM_PREMATURE_CLOSE = $7ed50f99e108d4b7$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $7ed50f99e108d4b7$var$AbortError = $lhKpv.AbortError;

var $jwkTK = parcelRequire("jwkTK");
var $7ed50f99e108d4b7$var$validateFunction = $jwkTK.validateFunction, $7ed50f99e108d4b7$var$validateAbortSignal = $jwkTK.validateAbortSignal;

var $fbUlO = parcelRequire("fbUlO");
var $7ed50f99e108d4b7$var$isIterable = $fbUlO.isIterable, $7ed50f99e108d4b7$var$isReadable = $fbUlO.isReadable, $7ed50f99e108d4b7$var$isReadableNodeStream = $fbUlO.isReadableNodeStream, $7ed50f99e108d4b7$var$isNodeStream = $fbUlO.isNodeStream, $7ed50f99e108d4b7$var$isTransformStream = $fbUlO.isTransformStream, $7ed50f99e108d4b7$var$isWebStream = $fbUlO.isWebStream, $7ed50f99e108d4b7$var$isReadableStream = $fbUlO.isReadableStream, $7ed50f99e108d4b7$var$isReadableFinished = $fbUlO.isReadableFinished;

var $7ed50f99e108d4b7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $7ed50f99e108d4b7$var$PassThrough;
var $7ed50f99e108d4b7$var$Readable;
var $7ed50f99e108d4b7$var$addAbortListener;
function $7ed50f99e108d4b7$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $5P5kd(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $3mhwQ.destroyer(stream, err || new $7ed50f99e108d4b7$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $7ed50f99e108d4b7$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $7ed50f99e108d4b7$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $7ed50f99e108d4b7$var$makeAsyncIterable(val) {
    if ($7ed50f99e108d4b7$var$isIterable(val)) return val;
    else if ($7ed50f99e108d4b7$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $7ed50f99e108d4b7$var$fromReadable(val);
    throw new $7ed50f99e108d4b7$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $7ed50f99e108d4b7$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7ed50f99e108d4b7$var$Readable) $7ed50f99e108d4b7$var$Readable = (parcelRequire("5qi49"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($7ed50f99e108d4b7$var$Readable.prototype[$7ed50f99e108d4b7$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7ed50f99e108d4b7$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $7ed50f99e108d4b7$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $5P5kd(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $7ed50f99e108d4b7$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7ed50f99e108d4b7$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($7ed50f99e108d4b7$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7ed50f99e108d4b7$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $7ed50f99e108d4b7$var$pipelineImpl(streams, $7ed50f99e108d4b7$require$once($7ed50f99e108d4b7$var$popCallback(streams)));
}


function $7ed50f99e108d4b7$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($7ed50f99e108d4b7$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $7ed50f99e108d4b7$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($7ed50f99e108d4b7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($7ed50f99e108d4b7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$7ed50f99e108d4b7$var$isIterable(ret)) throw new $7ed50f99e108d4b7$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($7ed50f99e108d4b7$var$isIterable(stream) || $7ed50f99e108d4b7$var$isReadableNodeStream(stream) || $7ed50f99e108d4b7$var$isTransformStream(stream)) ret = stream;
            else ret = $fNq7V.from(stream);
        } else if (typeof stream === 'function') {
            if ($7ed50f99e108d4b7$var$isTransformStream(ret)) {
                var _ret;
                ret = $7ed50f99e108d4b7$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $7ed50f99e108d4b7$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$7ed50f99e108d4b7$var$isIterable(ret, true)) throw new $7ed50f99e108d4b7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$7ed50f99e108d4b7$var$PassThrough) $7ed50f99e108d4b7$var$PassThrough = (parcelRequire("j7DUE"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $7ed50f99e108d4b7$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($7ed50f99e108d4b7$var$isIterable(ret, true)) {
                    finishCount++;
                    $7ed50f99e108d4b7$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($7ed50f99e108d4b7$var$isReadableStream(ret) || $7ed50f99e108d4b7$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $7ed50f99e108d4b7$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $7ed50f99e108d4b7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $7ed50f99e108d4b7$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($7ed50f99e108d4b7$var$isNodeStream(stream)) {
            if ($7ed50f99e108d4b7$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $7ed50f99e108d4b7$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($7ed50f99e108d4b7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($7ed50f99e108d4b7$var$isTransformStream(ret) || $7ed50f99e108d4b7$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $7ed50f99e108d4b7$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($7ed50f99e108d4b7$var$isIterable(ret)) {
                finishCount++;
                $7ed50f99e108d4b7$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $7ed50f99e108d4b7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($7ed50f99e108d4b7$var$isWebStream(stream)) {
            if ($7ed50f99e108d4b7$var$isReadableNodeStream(ret)) {
                finishCount++;
                $7ed50f99e108d4b7$var$pumpToWeb($7ed50f99e108d4b7$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($7ed50f99e108d4b7$var$isReadableStream(ret) || $7ed50f99e108d4b7$var$isIterable(ret)) {
                finishCount++;
                $7ed50f99e108d4b7$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($7ed50f99e108d4b7$var$isTransformStream(ret)) {
                finishCount++;
                $7ed50f99e108d4b7$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $7ed50f99e108d4b7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $fNq7V.from(stream);
    };
    if (streams.length === 1 && $7ed50f99e108d4b7$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7ed50f99e108d4b7$var$ERR_MISSING_ARGS('streams');
    var ac = new $7ed50f99e108d4b7$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $7ed50f99e108d4b7$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $7ed50f99e108d4b7$var$AbortError());
    }
    $7ed50f99e108d4b7$var$addAbortListener = $7ed50f99e108d4b7$var$addAbortListener || (parcelRequire("amFNO")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $7ed50f99e108d4b7$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$7ed50f99e108d4b7$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $7ed50f99e108d4b7$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $7ed50f99e108d4b7$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($7ed50f99e108d4b7$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $5P5kd(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $5P5kd(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $7ed50f99e108d4b7$var$pipelineImpl,
    pipeline: $7ed50f99e108d4b7$var$pipeline
};

});
parcelRegister("3mhwQ", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lhKpv = parcelRequire("lhKpv");
/* replacement end */ var $27210609ca1c41af$var$aggregateTwoErrors = $lhKpv.aggregateTwoErrors, $27210609ca1c41af$var$ERR_MULTIPLE_CALLBACK = $lhKpv.codes.ERR_MULTIPLE_CALLBACK, $27210609ca1c41af$var$AbortError = $lhKpv.AbortError;

var $kdkK0 = parcelRequire("kdkK0");
var $27210609ca1c41af$require$Symbol = $kdkK0.Symbol;

var $fbUlO = parcelRequire("fbUlO");
var $27210609ca1c41af$var$kIsDestroyed = $fbUlO.kIsDestroyed, $27210609ca1c41af$var$isDestroyed = $fbUlO.isDestroyed, $27210609ca1c41af$var$isFinished = $fbUlO.isFinished, $27210609ca1c41af$var$isServerRequest = $fbUlO.isServerRequest;
var $27210609ca1c41af$var$kDestroy = $27210609ca1c41af$require$Symbol('kDestroy');
var $27210609ca1c41af$var$kConstruct = $27210609ca1c41af$require$Symbol('kConstruct');
function $27210609ca1c41af$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $27210609ca1c41af$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $27210609ca1c41af$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($27210609ca1c41af$var$kDestroy, function(er) {
        $27210609ca1c41af$var$_destroy(this, $27210609ca1c41af$var$aggregateTwoErrors(er, err), cb);
    });
    else $27210609ca1c41af$var$_destroy(this, err, cb);
    return this;
}
function $27210609ca1c41af$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $27210609ca1c41af$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($27210609ca1c41af$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($27210609ca1c41af$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $27210609ca1c41af$var$emitErrorCloseNT(self, err) {
    $27210609ca1c41af$var$emitErrorNT(self, err);
    $27210609ca1c41af$var$emitCloseNT(self);
}
function $27210609ca1c41af$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $27210609ca1c41af$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $27210609ca1c41af$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $27210609ca1c41af$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($27210609ca1c41af$var$emitErrorNT, stream, err);
        else $27210609ca1c41af$var$emitErrorNT(stream, err);
    }
}
function $27210609ca1c41af$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($27210609ca1c41af$var$kConstruct, cb);
    if (stream.listenerCount($27210609ca1c41af$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($27210609ca1c41af$var$constructNT, stream);
}
function $27210609ca1c41af$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $27210609ca1c41af$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $27210609ca1c41af$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($27210609ca1c41af$var$kDestroy, err);
        else if (err) $27210609ca1c41af$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($27210609ca1c41af$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $27210609ca1c41af$var$emitConstructNT(stream) {
    stream.emit($27210609ca1c41af$var$kConstruct);
}
function $27210609ca1c41af$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $27210609ca1c41af$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $27210609ca1c41af$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($27210609ca1c41af$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $27210609ca1c41af$var$destroyer(stream, err) {
    if (!stream || $27210609ca1c41af$var$isDestroyed(stream)) return;
    if (!err && !$27210609ca1c41af$var$isFinished(stream)) err = new $27210609ca1c41af$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($27210609ca1c41af$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($27210609ca1c41af$var$isRequest(stream)) stream.abort();
    else if ($27210609ca1c41af$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($27210609ca1c41af$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($27210609ca1c41af$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$27210609ca1c41af$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $27210609ca1c41af$var$construct,
    destroyer: $27210609ca1c41af$var$destroyer,
    destroy: $27210609ca1c41af$var$destroy,
    undestroy: $27210609ca1c41af$var$undestroy,
    errorOrDestroy: $27210609ca1c41af$var$errorOrDestroy
};

});

parcelRegister("fNq7V", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $b7ffb2d6cb63b674$var$ObjectDefineProperties = $kdkK0.ObjectDefineProperties, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor = $kdkK0.ObjectGetOwnPropertyDescriptor, $b7ffb2d6cb63b674$var$ObjectKeys = $kdkK0.ObjectKeys, $b7ffb2d6cb63b674$var$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf;
module.exports = $b7ffb2d6cb63b674$var$Duplex;

var $5qi49 = parcelRequire("5qi49");

var $euisa = parcelRequire("euisa");
$b7ffb2d6cb63b674$var$ObjectSetPrototypeOf($b7ffb2d6cb63b674$var$Duplex.prototype, $5qi49.prototype);
$b7ffb2d6cb63b674$var$ObjectSetPrototypeOf($b7ffb2d6cb63b674$var$Duplex, $5qi49);
{
    var $b7ffb2d6cb63b674$var$keys = $b7ffb2d6cb63b674$var$ObjectKeys($euisa.prototype);
    // Allow the keys array to be GC'ed.
    for(var $b7ffb2d6cb63b674$var$i = 0; $b7ffb2d6cb63b674$var$i < $b7ffb2d6cb63b674$var$keys.length; $b7ffb2d6cb63b674$var$i++){
        var $b7ffb2d6cb63b674$var$method = $b7ffb2d6cb63b674$var$keys[$b7ffb2d6cb63b674$var$i];
        if (!$b7ffb2d6cb63b674$var$Duplex.prototype[$b7ffb2d6cb63b674$var$method]) $b7ffb2d6cb63b674$var$Duplex.prototype[$b7ffb2d6cb63b674$var$method] = $euisa.prototype[$b7ffb2d6cb63b674$var$method];
    }
}function $b7ffb2d6cb63b674$var$Duplex(options) {
    if (!(this instanceof $b7ffb2d6cb63b674$var$Duplex)) return new $b7ffb2d6cb63b674$var$Duplex(options);
    $5qi49.call(this, options);
    $euisa.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$b7ffb2d6cb63b674$var$ObjectDefineProperties($b7ffb2d6cb63b674$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $b7ffb2d6cb63b674$var$ObjectGetOwnPropertyDescriptor($euisa.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $b7ffb2d6cb63b674$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b7ffb2d6cb63b674$var$lazyWebStreams() {
    if ($b7ffb2d6cb63b674$var$webStreamsAdapters === undefined) $b7ffb2d6cb63b674$var$webStreamsAdapters = {};
    return $b7ffb2d6cb63b674$var$webStreamsAdapters;
}
$b7ffb2d6cb63b674$var$Duplex.fromWeb = function(pair, options) {
    return $b7ffb2d6cb63b674$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$b7ffb2d6cb63b674$var$Duplex.toWeb = function(duplex) {
    return $b7ffb2d6cb63b674$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $b7ffb2d6cb63b674$var$duplexify;

$b7ffb2d6cb63b674$var$Duplex.from = function(body) {
    if (!$b7ffb2d6cb63b674$var$duplexify) $b7ffb2d6cb63b674$var$duplexify = (parcelRequire("en2Dd"));
    return $b7ffb2d6cb63b674$var$duplexify(body, 'body');
};

});
parcelRegister("5qi49", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kdkK0 = parcelRequire("kdkK0");
/* replacement end */ var $3f2d64f6ef915f56$var$ArrayPrototypeIndexOf = $kdkK0.ArrayPrototypeIndexOf, $3f2d64f6ef915f56$var$NumberIsInteger = $kdkK0.NumberIsInteger, $3f2d64f6ef915f56$var$NumberIsNaN = $kdkK0.NumberIsNaN, $3f2d64f6ef915f56$var$NumberParseInt = $kdkK0.NumberParseInt, $3f2d64f6ef915f56$var$ObjectDefineProperties = $kdkK0.ObjectDefineProperties, $3f2d64f6ef915f56$var$ObjectKeys = $kdkK0.ObjectKeys, $3f2d64f6ef915f56$var$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf, $3f2d64f6ef915f56$var$Promise = $kdkK0.Promise, $3f2d64f6ef915f56$var$SafeSet = $kdkK0.SafeSet, $3f2d64f6ef915f56$var$SymbolAsyncDispose = $kdkK0.SymbolAsyncDispose, $3f2d64f6ef915f56$var$SymbolAsyncIterator = $kdkK0.SymbolAsyncIterator, $3f2d64f6ef915f56$var$Symbol = $kdkK0.Symbol;
module.exports = $3f2d64f6ef915f56$var$Readable;
$3f2d64f6ef915f56$var$Readable.ReadableState = $3f2d64f6ef915f56$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $3f2d64f6ef915f56$var$EE = $bBoAO.EventEmitter;

var $h144z = parcelRequire("h144z");
var $3f2d64f6ef915f56$var$Stream = $h144z.Stream, $3f2d64f6ef915f56$var$prependListener = $h144z.prependListener;

var $9cHQz = parcelRequire("9cHQz");
var $3f2d64f6ef915f56$require$Buffer = $9cHQz.Buffer;

var $8wW07 = parcelRequire("8wW07");
var $3f2d64f6ef915f56$require$addAbortSignal = $8wW07.addAbortSignal;

var $5P5kd = parcelRequire("5P5kd");

var $3f2d64f6ef915f56$var$debug = (parcelRequire("amFNO")).debuglog('stream', function(fn) {
    $3f2d64f6ef915f56$var$debug = fn;
});

var $4R55I = parcelRequire("4R55I");

var $3mhwQ = parcelRequire("3mhwQ");

var $gs6oV = parcelRequire("gs6oV");
var $3f2d64f6ef915f56$var$getHighWaterMark = $gs6oV.getHighWaterMark, $3f2d64f6ef915f56$var$getDefaultHighWaterMark = $gs6oV.getDefaultHighWaterMark;

var $lhKpv = parcelRequire("lhKpv");
var $3f2d64f6ef915f56$var$aggregateTwoErrors = $lhKpv.aggregateTwoErrors, $3f2d64f6ef915f56$var$_require_codes = $lhKpv.codes, $3f2d64f6ef915f56$var$ERR_INVALID_ARG_TYPE = $3f2d64f6ef915f56$var$_require_codes.ERR_INVALID_ARG_TYPE, $3f2d64f6ef915f56$var$ERR_METHOD_NOT_IMPLEMENTED = $3f2d64f6ef915f56$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $3f2d64f6ef915f56$var$ERR_OUT_OF_RANGE = $3f2d64f6ef915f56$var$_require_codes.ERR_OUT_OF_RANGE, $3f2d64f6ef915f56$var$ERR_STREAM_PUSH_AFTER_EOF = $3f2d64f6ef915f56$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $3f2d64f6ef915f56$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $3f2d64f6ef915f56$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $3f2d64f6ef915f56$var$AbortError = $lhKpv.AbortError;

var $jwkTK = parcelRequire("jwkTK");
var $3f2d64f6ef915f56$require$validateObject = $jwkTK.validateObject;
var $3f2d64f6ef915f56$var$kPaused = $3f2d64f6ef915f56$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $3f2d64f6ef915f56$require$StringDecoder = $3Jf7C.StringDecoder;

var $2N9PA = parcelRequire("2N9PA");
$3f2d64f6ef915f56$var$ObjectSetPrototypeOf($3f2d64f6ef915f56$var$Readable.prototype, $3f2d64f6ef915f56$var$Stream.prototype);
$3f2d64f6ef915f56$var$ObjectSetPrototypeOf($3f2d64f6ef915f56$var$Readable, $3f2d64f6ef915f56$var$Stream);
var $3f2d64f6ef915f56$var$nop = function() {};
var $3f2d64f6ef915f56$var$errorOrDestroy = $3mhwQ.errorOrDestroy;
var $3f2d64f6ef915f56$var$kObjectMode = 1;
var $3f2d64f6ef915f56$var$kEnded = 2;
var $3f2d64f6ef915f56$var$kEndEmitted = 4;
var $3f2d64f6ef915f56$var$kReading = 8;
var $3f2d64f6ef915f56$var$kConstructed = 16;
var $3f2d64f6ef915f56$var$kSync = 32;
var $3f2d64f6ef915f56$var$kNeedReadable = 64;
var $3f2d64f6ef915f56$var$kEmittedReadable = 128;
var $3f2d64f6ef915f56$var$kReadableListening = 256;
var $3f2d64f6ef915f56$var$kResumeScheduled = 512;
var $3f2d64f6ef915f56$var$kErrorEmitted = 1024;
var $3f2d64f6ef915f56$var$kEmitClose = 2048;
var $3f2d64f6ef915f56$var$kAutoDestroy = 4096;
var $3f2d64f6ef915f56$var$kDestroyed = 8192;
var $3f2d64f6ef915f56$var$kClosed = 16384;
var $3f2d64f6ef915f56$var$kCloseEmitted = 32768;
var $3f2d64f6ef915f56$var$kMultiAwaitDrain = 65536;
var $3f2d64f6ef915f56$var$kReadingMore = 131072;
var $3f2d64f6ef915f56$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $3f2d64f6ef915f56$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$3f2d64f6ef915f56$var$ObjectDefineProperties($3f2d64f6ef915f56$var$ReadableState.prototype, {
    objectMode: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kObjectMode),
    ended: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kEnded),
    endEmitted: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kEndEmitted),
    reading: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kNeedReadable),
    emittedReadable: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kEmittedReadable),
    readableListening: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kReadableListening),
    resumeScheduled: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kErrorEmitted),
    emitClose: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kEmitClose),
    autoDestroy: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kCloseEmitted),
    multiAwaitDrain: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kReadingMore),
    dataEmitted: $3f2d64f6ef915f56$var$makeBitMapDescriptor($3f2d64f6ef915f56$var$kDataEmitted)
});

function $3f2d64f6ef915f56$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("fNq7V"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $3f2d64f6ef915f56$var$kEmitClose | $3f2d64f6ef915f56$var$kAutoDestroy | $3f2d64f6ef915f56$var$kConstructed | $3f2d64f6ef915f56$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $3f2d64f6ef915f56$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $3f2d64f6ef915f56$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $3f2d64f6ef915f56$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $3f2d64f6ef915f56$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4R55I();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$3f2d64f6ef915f56$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$3f2d64f6ef915f56$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$3f2d64f6ef915f56$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $3f2d64f6ef915f56$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3f2d64f6ef915f56$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $3f2d64f6ef915f56$var$Readable)) return new $3f2d64f6ef915f56$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("fNq7V"));
    this._readableState = new $3f2d64f6ef915f56$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $3f2d64f6ef915f56$require$addAbortSignal(options.signal, this);
    }
    $3f2d64f6ef915f56$var$Stream.call(this, options);
    $3mhwQ.construct(this, function() {
        if (_this._readableState.needReadable) $3f2d64f6ef915f56$var$maybeReadMore(_this, _this._readableState);
    });
}
$3f2d64f6ef915f56$var$Readable.prototype.destroy = $3mhwQ.destroy;
$3f2d64f6ef915f56$var$Readable.prototype._undestroy = $3mhwQ.undestroy;
$3f2d64f6ef915f56$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3f2d64f6ef915f56$var$Readable.prototype[$3f2d64f6ef915f56$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$3f2d64f6ef915f56$var$Readable.prototype[$3f2d64f6ef915f56$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $3f2d64f6ef915f56$var$AbortError();
        this.destroy(error);
    }
    return new $3f2d64f6ef915f56$var$Promise(function(resolve, reject) {
        return $5P5kd(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3f2d64f6ef915f56$var$Readable.prototype.push = function(chunk, encoding) {
    return $3f2d64f6ef915f56$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$3f2d64f6ef915f56$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $3f2d64f6ef915f56$var$readableAddChunk(this, chunk, encoding, true);
};
function $3f2d64f6ef915f56$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $3f2d64f6ef915f56$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $3f2d64f6ef915f56$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $3f2d64f6ef915f56$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $3f2d64f6ef915f56$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $3f2d64f6ef915f56$require$Buffer) encoding = '';
        else if ($3f2d64f6ef915f56$var$Stream._isUint8Array(chunk)) {
            chunk = $3f2d64f6ef915f56$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $3f2d64f6ef915f56$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $3f2d64f6ef915f56$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$3f2d64f6ef915f56$var$kReading;
        $3f2d64f6ef915f56$var$onEofChunk(stream, state);
    } else if ((state.state & $3f2d64f6ef915f56$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $3f2d64f6ef915f56$var$kEndEmitted) !== 0) $3f2d64f6ef915f56$var$errorOrDestroy(stream, new $3f2d64f6ef915f56$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $3f2d64f6ef915f56$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $3f2d64f6ef915f56$var$errorOrDestroy(stream, new $3f2d64f6ef915f56$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$3f2d64f6ef915f56$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $3f2d64f6ef915f56$var$addChunk(stream, state, chunk, false);
                else $3f2d64f6ef915f56$var$maybeReadMore(stream, state);
            } else $3f2d64f6ef915f56$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$3f2d64f6ef915f56$var$kReading;
        $3f2d64f6ef915f56$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3f2d64f6ef915f56$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $3f2d64f6ef915f56$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $3f2d64f6ef915f56$var$kNeedReadable) !== 0) $3f2d64f6ef915f56$var$emitReadable(stream);
    }
    $3f2d64f6ef915f56$var$maybeReadMore(stream, state);
}
$3f2d64f6ef915f56$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$3f2d64f6ef915f56$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$3f2d64f6ef915f56$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $3f2d64f6ef915f56$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$3f2d64f6ef915f56$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $3f2d64f6ef915f56$var$MAX_HWM = 0x40000000;
function $3f2d64f6ef915f56$var$computeNewHighWaterMark(n) {
    if (n > $3f2d64f6ef915f56$var$MAX_HWM) throw new $3f2d64f6ef915f56$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3f2d64f6ef915f56$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $3f2d64f6ef915f56$var$kObjectMode) !== 0) return 1;
    if ($3f2d64f6ef915f56$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$3f2d64f6ef915f56$var$Readable.prototype.read = function(n) {
    $3f2d64f6ef915f56$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$3f2d64f6ef915f56$var$NumberIsInteger(n)) n = $3f2d64f6ef915f56$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3f2d64f6ef915f56$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$3f2d64f6ef915f56$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3f2d64f6ef915f56$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3f2d64f6ef915f56$var$endReadable(this);
        else $3f2d64f6ef915f56$var$emitReadable(this);
        return null;
    }
    n = $3f2d64f6ef915f56$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3f2d64f6ef915f56$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $3f2d64f6ef915f56$var$kNeedReadable) !== 0;
    $3f2d64f6ef915f56$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3f2d64f6ef915f56$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $3f2d64f6ef915f56$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $3f2d64f6ef915f56$var$debug('do read');
        state.state |= $3f2d64f6ef915f56$var$kReading | $3f2d64f6ef915f56$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $3f2d64f6ef915f56$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $3f2d64f6ef915f56$var$errorOrDestroy(this, err);
        }
        state.state &= ~$3f2d64f6ef915f56$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3f2d64f6ef915f56$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3f2d64f6ef915f56$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3f2d64f6ef915f56$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $3f2d64f6ef915f56$var$onEofChunk(stream, state) {
    $3f2d64f6ef915f56$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $3f2d64f6ef915f56$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $3f2d64f6ef915f56$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3f2d64f6ef915f56$var$emitReadable(stream) {
    var state = stream._readableState;
    $3f2d64f6ef915f56$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3f2d64f6ef915f56$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($3f2d64f6ef915f56$var$emitReadable_, stream);
    }
}
function $3f2d64f6ef915f56$var$emitReadable_(stream) {
    var state = stream._readableState;
    $3f2d64f6ef915f56$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3f2d64f6ef915f56$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3f2d64f6ef915f56$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($3f2d64f6ef915f56$var$maybeReadMore_, stream, state);
    }
}
function $3f2d64f6ef915f56$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $3f2d64f6ef915f56$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3f2d64f6ef915f56$var$Readable.prototype._read = function(n) {
    throw new $3f2d64f6ef915f56$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$3f2d64f6ef915f56$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $3f2d64f6ef915f56$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $3f2d64f6ef915f56$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3f2d64f6ef915f56$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3f2d64f6ef915f56$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $3f2d64f6ef915f56$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $3f2d64f6ef915f56$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $3f2d64f6ef915f56$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $3f2d64f6ef915f56$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3f2d64f6ef915f56$var$debug('ondata');
        var ret = dest.write(chunk);
        $3f2d64f6ef915f56$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3f2d64f6ef915f56$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $3f2d64f6ef915f56$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $3f2d64f6ef915f56$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3f2d64f6ef915f56$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3f2d64f6ef915f56$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $3f2d64f6ef915f56$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3f2d64f6ef915f56$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $3f2d64f6ef915f56$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $3f2d64f6ef915f56$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$3f2d64f6ef915f56$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $3f2d64f6ef915f56$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$3f2d64f6ef915f56$var$Readable.prototype.on = function(ev, fn) {
    var res = $3f2d64f6ef915f56$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3f2d64f6ef915f56$var$debug('on readable', state.length, state.reading);
            if (state.length) $3f2d64f6ef915f56$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($3f2d64f6ef915f56$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3f2d64f6ef915f56$var$Readable.prototype.addListener = $3f2d64f6ef915f56$var$Readable.prototype.on;
$3f2d64f6ef915f56$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $3f2d64f6ef915f56$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($3f2d64f6ef915f56$var$updateReadableListening, this);
    return res;
};
$3f2d64f6ef915f56$var$Readable.prototype.off = $3f2d64f6ef915f56$var$Readable.prototype.removeListener;
$3f2d64f6ef915f56$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $3f2d64f6ef915f56$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($3f2d64f6ef915f56$var$updateReadableListening, this);
    return res;
};
function $3f2d64f6ef915f56$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$3f2d64f6ef915f56$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $3f2d64f6ef915f56$var$nReadingNextTick(self) {
    $3f2d64f6ef915f56$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3f2d64f6ef915f56$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3f2d64f6ef915f56$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $3f2d64f6ef915f56$var$resume(this, state);
    }
    state[$3f2d64f6ef915f56$var$kPaused] = false;
    return this;
};
function $3f2d64f6ef915f56$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($3f2d64f6ef915f56$var$resume_, stream, state);
    }
}
function $3f2d64f6ef915f56$var$resume_(stream, state) {
    $3f2d64f6ef915f56$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3f2d64f6ef915f56$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3f2d64f6ef915f56$var$Readable.prototype.pause = function() {
    $3f2d64f6ef915f56$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3f2d64f6ef915f56$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$3f2d64f6ef915f56$var$kPaused] = true;
    return this;
};
function $3f2d64f6ef915f56$var$flow(stream) {
    var state = stream._readableState;
    $3f2d64f6ef915f56$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3f2d64f6ef915f56$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $3f2d64f6ef915f56$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $3f2d64f6ef915f56$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$3f2d64f6ef915f56$var$Readable.prototype[$3f2d64f6ef915f56$var$SymbolAsyncIterator] = function() {
    return $3f2d64f6ef915f56$var$streamToAsyncIterator(this);
};
$3f2d64f6ef915f56$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $3f2d64f6ef915f56$require$validateObject(options, 'options');
    return $3f2d64f6ef915f56$var$streamToAsyncIterator(this, options);
};
function $3f2d64f6ef915f56$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $3f2d64f6ef915f56$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $3f2d64f6ef915f56$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $3f2d64f6ef915f56$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $3f2d64f6ef915f56$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $3f2d64f6ef915f56$var$nop;
                    stream.on('readable', next);
                    cleanup = $5P5kd(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $3f2d64f6ef915f56$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $3f2d64f6ef915f56$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $3f2d64f6ef915f56$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $3f2d64f6ef915f56$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $3mhwQ.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$3f2d64f6ef915f56$var$ObjectDefineProperties($3f2d64f6ef915f56$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$3f2d64f6ef915f56$var$ObjectDefineProperties($3f2d64f6ef915f56$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$3f2d64f6ef915f56$var$kPaused] !== false;
        },
        set: function(value) {
            this[$3f2d64f6ef915f56$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$3f2d64f6ef915f56$var$Readable._fromList = $3f2d64f6ef915f56$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3f2d64f6ef915f56$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3f2d64f6ef915f56$var$endReadable(stream) {
    var state = stream._readableState;
    $3f2d64f6ef915f56$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($3f2d64f6ef915f56$var$endReadableNT, state, stream);
    }
}
function $3f2d64f6ef915f56$var$endReadableNT(state, stream) {
    $3f2d64f6ef915f56$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($3f2d64f6ef915f56$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $3f2d64f6ef915f56$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$3f2d64f6ef915f56$var$Readable.from = function(iterable, opts) {
    return $2N9PA($3f2d64f6ef915f56$var$Readable, iterable, opts);
};
var $3f2d64f6ef915f56$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3f2d64f6ef915f56$var$lazyWebStreams() {
    if ($3f2d64f6ef915f56$var$webStreamsAdapters === undefined) $3f2d64f6ef915f56$var$webStreamsAdapters = {};
    return $3f2d64f6ef915f56$var$webStreamsAdapters;
}
$3f2d64f6ef915f56$var$Readable.fromWeb = function(readableStream, options) {
    return $3f2d64f6ef915f56$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$3f2d64f6ef915f56$var$Readable.toWeb = function(streamReadable, options) {
    return $3f2d64f6ef915f56$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$3f2d64f6ef915f56$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $3f2d64f6ef915f56$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $3mhwQ.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("h144z", function(module, exports) {
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $c635b06cc715ecc6$var$ArrayIsArray = $kdkK0.ArrayIsArray, $c635b06cc715ecc6$var$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $c635b06cc715ecc6$var$EE = $bBoAO.EventEmitter;
function $c635b06cc715ecc6$var$Stream(opts) {
    $c635b06cc715ecc6$var$EE.call(this, opts);
}
$c635b06cc715ecc6$var$ObjectSetPrototypeOf($c635b06cc715ecc6$var$Stream.prototype, $c635b06cc715ecc6$var$EE.prototype);
$c635b06cc715ecc6$var$ObjectSetPrototypeOf($c635b06cc715ecc6$var$Stream, $c635b06cc715ecc6$var$EE);
$c635b06cc715ecc6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($c635b06cc715ecc6$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $c635b06cc715ecc6$var$prependListener(source, 'error', onerror);
    $c635b06cc715ecc6$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $c635b06cc715ecc6$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($c635b06cc715ecc6$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $c635b06cc715ecc6$var$Stream,
    prependListener: $c635b06cc715ecc6$var$prependListener
};

});

parcelRegister("8wW07", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $635e4dabf6f35b9d$export$e2db56ee53255a0; }, function (v) { return $635e4dabf6f35b9d$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $635e4dabf6f35b9d$export$11956e9313f43de0; }, function (v) { return $635e4dabf6f35b9d$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $635e4dabf6f35b9d$export$e2db56ee53255a0;
var $635e4dabf6f35b9d$export$11956e9313f43de0;
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $635e4dabf6f35b9d$require$SymbolDispose = $kdkK0.SymbolDispose;

var $lhKpv = parcelRequire("lhKpv");
var $635e4dabf6f35b9d$var$AbortError = $lhKpv.AbortError, $635e4dabf6f35b9d$var$codes = $lhKpv.codes;

var $fbUlO = parcelRequire("fbUlO");
var $635e4dabf6f35b9d$var$isNodeStream = $fbUlO.isNodeStream, $635e4dabf6f35b9d$var$isWebStream = $fbUlO.isWebStream, $635e4dabf6f35b9d$var$kControllerErrorFunction = $fbUlO.kControllerErrorFunction;

var $5P5kd = parcelRequire("5P5kd");
var $635e4dabf6f35b9d$var$ERR_INVALID_ARG_TYPE = $635e4dabf6f35b9d$var$codes.ERR_INVALID_ARG_TYPE;
var $635e4dabf6f35b9d$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $635e4dabf6f35b9d$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $635e4dabf6f35b9d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$635e4dabf6f35b9d$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $635e4dabf6f35b9d$var$validateAbortSignal(signal, 'signal');
    if (!$635e4dabf6f35b9d$var$isNodeStream(stream) && !$635e4dabf6f35b9d$var$isWebStream(stream)) throw new $635e4dabf6f35b9d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $635e4dabf6f35b9d$export$11956e9313f43de0(signal, stream);
};

$635e4dabf6f35b9d$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $635e4dabf6f35b9d$var$isNodeStream(stream) ? function() {
        stream.destroy(new $635e4dabf6f35b9d$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$635e4dabf6f35b9d$var$kControllerErrorFunction](new $635e4dabf6f35b9d$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $635e4dabf6f35b9d$var$addAbortListener = $635e4dabf6f35b9d$var$addAbortListener || (parcelRequire("amFNO")).addAbortListener;
        var disposable = $635e4dabf6f35b9d$var$addAbortListener(signal, onAbort);
        $5P5kd(stream, disposable[$635e4dabf6f35b9d$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4R55I", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $38900fa785c36450$var$StringPrototypeSlice = $kdkK0.StringPrototypeSlice, $38900fa785c36450$var$SymbolIterator = $kdkK0.SymbolIterator, $38900fa785c36450$var$TypedArrayPrototypeSet = $kdkK0.TypedArrayPrototypeSet, $38900fa785c36450$var$Uint8Array = $kdkK0.Uint8Array;

var $9cHQz = parcelRequire("9cHQz");
var $38900fa785c36450$require$Buffer = $9cHQz.Buffer;

var $amFNO = parcelRequire("amFNO");
var $38900fa785c36450$require$inspect = $amFNO.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $38900fa785c36450$require$Buffer.alloc(0);
                var ret = $38900fa785c36450$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $38900fa785c36450$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $38900fa785c36450$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $38900fa785c36450$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $38900fa785c36450$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $38900fa785c36450$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $38900fa785c36450$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $38900fa785c36450$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $38900fa785c36450$var$TypedArrayPrototypeSet(ret, new $38900fa785c36450$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $38900fa785c36450$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("gs6oV", function(module, exports) {
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $bfa439f61666b651$var$MathFloor = $kdkK0.MathFloor, $bfa439f61666b651$var$NumberIsInteger = $kdkK0.NumberIsInteger;

var $jwkTK = parcelRequire("jwkTK");
var $bfa439f61666b651$require$validateInteger = $jwkTK.validateInteger;

var $bfa439f61666b651$var$ERR_INVALID_ARG_VALUE = (parcelRequire("lhKpv")).codes.ERR_INVALID_ARG_VALUE;
var $bfa439f61666b651$var$defaultHighWaterMarkBytes = 16384;
var $bfa439f61666b651$var$defaultHighWaterMarkObjectMode = 16;
function $bfa439f61666b651$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $bfa439f61666b651$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $bfa439f61666b651$var$defaultHighWaterMarkObjectMode : $bfa439f61666b651$var$defaultHighWaterMarkBytes;
}
function $bfa439f61666b651$var$setDefaultHighWaterMark(objectMode, value) {
    $bfa439f61666b651$require$validateInteger(value, 'value', 0);
    if (objectMode) $bfa439f61666b651$var$defaultHighWaterMarkObjectMode = value;
    else $bfa439f61666b651$var$defaultHighWaterMarkBytes = value;
}
function $bfa439f61666b651$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $bfa439f61666b651$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$bfa439f61666b651$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $bfa439f61666b651$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $bfa439f61666b651$var$MathFloor(hwm);
    }
    // Default value
    return $bfa439f61666b651$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $bfa439f61666b651$var$getHighWaterMark,
    getDefaultHighWaterMark: $bfa439f61666b651$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $bfa439f61666b651$var$setDefaultHighWaterMark
};

});

parcelRegister("2N9PA", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kdkK0 = parcelRequire("kdkK0");
/* replacement end */ var $2087c896bb0e0bb1$var$PromisePrototypeThen = $kdkK0.PromisePrototypeThen, $2087c896bb0e0bb1$var$SymbolAsyncIterator = $kdkK0.SymbolAsyncIterator, $2087c896bb0e0bb1$var$SymbolIterator = $kdkK0.SymbolIterator;

var $9cHQz = parcelRequire("9cHQz");
var $2087c896bb0e0bb1$require$Buffer = $9cHQz.Buffer;

var $lhKpv = parcelRequire("lhKpv");
var $2087c896bb0e0bb1$require$_require_codes = $lhKpv.codes;
var $2087c896bb0e0bb1$var$ERR_INVALID_ARG_TYPE = $2087c896bb0e0bb1$require$_require_codes.ERR_INVALID_ARG_TYPE, $2087c896bb0e0bb1$var$ERR_STREAM_NULL_VALUES = $2087c896bb0e0bb1$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $2087c896bb0e0bb1$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $2087c896bb0e0bb1$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$2087c896bb0e0bb1$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$2087c896bb0e0bb1$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$2087c896bb0e0bb1$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$2087c896bb0e0bb1$var$SymbolIterator]();
    } else throw new $2087c896bb0e0bb1$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $2087c896bb0e0bb1$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $2087c896bb0e0bb1$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $2087c896bb0e0bb1$var$from;

});


parcelRegister("euisa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kdkK0 = parcelRequire("kdkK0");
/* replacement end */ var $a8c22e7f1b94c28d$var$ArrayPrototypeSlice = $kdkK0.ArrayPrototypeSlice, $a8c22e7f1b94c28d$var$Error = $kdkK0.Error, $a8c22e7f1b94c28d$var$FunctionPrototypeSymbolHasInstance = $kdkK0.FunctionPrototypeSymbolHasInstance, $a8c22e7f1b94c28d$var$ObjectDefineProperty = $kdkK0.ObjectDefineProperty, $a8c22e7f1b94c28d$var$ObjectDefineProperties = $kdkK0.ObjectDefineProperties, $a8c22e7f1b94c28d$var$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf, $a8c22e7f1b94c28d$var$StringPrototypeToLowerCase = $kdkK0.StringPrototypeToLowerCase, $a8c22e7f1b94c28d$var$Symbol = $kdkK0.Symbol, $a8c22e7f1b94c28d$var$SymbolHasInstance = $kdkK0.SymbolHasInstance;
module.exports = $a8c22e7f1b94c28d$var$Writable;
$a8c22e7f1b94c28d$var$Writable.WritableState = $a8c22e7f1b94c28d$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a8c22e7f1b94c28d$var$EE = $bBoAO.EventEmitter;

var $h144z = parcelRequire("h144z");
var $a8c22e7f1b94c28d$require$Stream = $h144z.Stream;

var $9cHQz = parcelRequire("9cHQz");
var $a8c22e7f1b94c28d$require$Buffer = $9cHQz.Buffer;

var $3mhwQ = parcelRequire("3mhwQ");

var $8wW07 = parcelRequire("8wW07");
var $a8c22e7f1b94c28d$require$addAbortSignal = $8wW07.addAbortSignal;

var $gs6oV = parcelRequire("gs6oV");
var $a8c22e7f1b94c28d$var$getHighWaterMark = $gs6oV.getHighWaterMark, $a8c22e7f1b94c28d$var$getDefaultHighWaterMark = $gs6oV.getDefaultHighWaterMark;

var $lhKpv = parcelRequire("lhKpv");
var $a8c22e7f1b94c28d$require$_require_codes = $lhKpv.codes;
var $a8c22e7f1b94c28d$var$ERR_INVALID_ARG_TYPE = $a8c22e7f1b94c28d$require$_require_codes.ERR_INVALID_ARG_TYPE, $a8c22e7f1b94c28d$var$ERR_METHOD_NOT_IMPLEMENTED = $a8c22e7f1b94c28d$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a8c22e7f1b94c28d$var$ERR_MULTIPLE_CALLBACK = $a8c22e7f1b94c28d$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a8c22e7f1b94c28d$var$ERR_STREAM_CANNOT_PIPE = $a8c22e7f1b94c28d$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED = $a8c22e7f1b94c28d$require$_require_codes.ERR_STREAM_DESTROYED, $a8c22e7f1b94c28d$var$ERR_STREAM_ALREADY_FINISHED = $a8c22e7f1b94c28d$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a8c22e7f1b94c28d$var$ERR_STREAM_NULL_VALUES = $a8c22e7f1b94c28d$require$_require_codes.ERR_STREAM_NULL_VALUES, $a8c22e7f1b94c28d$var$ERR_STREAM_WRITE_AFTER_END = $a8c22e7f1b94c28d$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a8c22e7f1b94c28d$var$ERR_UNKNOWN_ENCODING = $a8c22e7f1b94c28d$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a8c22e7f1b94c28d$var$errorOrDestroy = $3mhwQ.errorOrDestroy;
$a8c22e7f1b94c28d$var$ObjectSetPrototypeOf($a8c22e7f1b94c28d$var$Writable.prototype, $a8c22e7f1b94c28d$require$Stream.prototype);
$a8c22e7f1b94c28d$var$ObjectSetPrototypeOf($a8c22e7f1b94c28d$var$Writable, $a8c22e7f1b94c28d$require$Stream);
function $a8c22e7f1b94c28d$var$nop() {}
var $a8c22e7f1b94c28d$var$kOnFinished = $a8c22e7f1b94c28d$var$Symbol('kOnFinished');

function $a8c22e7f1b94c28d$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("fNq7V"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a8c22e7f1b94c28d$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a8c22e7f1b94c28d$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a8c22e7f1b94c28d$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a8c22e7f1b94c28d$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a8c22e7f1b94c28d$var$kOnFinished] = [];
}
function $a8c22e7f1b94c28d$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a8c22e7f1b94c28d$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a8c22e7f1b94c28d$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a8c22e7f1b94c28d$var$ObjectDefineProperty($a8c22e7f1b94c28d$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a8c22e7f1b94c28d$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("fNq7V"));
    if (!isDuplex && !$a8c22e7f1b94c28d$var$FunctionPrototypeSymbolHasInstance($a8c22e7f1b94c28d$var$Writable, this)) return new $a8c22e7f1b94c28d$var$Writable(options);
    this._writableState = new $a8c22e7f1b94c28d$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a8c22e7f1b94c28d$require$addAbortSignal(options.signal, this);
    }
    $a8c22e7f1b94c28d$require$Stream.call(this, options);
    $3mhwQ.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a8c22e7f1b94c28d$var$clearBuffer(_this, state);
        $a8c22e7f1b94c28d$var$finishMaybe(_this, state);
    });
}
$a8c22e7f1b94c28d$var$ObjectDefineProperty($a8c22e7f1b94c28d$var$Writable, $a8c22e7f1b94c28d$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a8c22e7f1b94c28d$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a8c22e7f1b94c28d$var$Writable) return false;
        return object && object._writableState instanceof $a8c22e7f1b94c28d$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a8c22e7f1b94c28d$var$Writable.prototype.pipe = function() {
    $a8c22e7f1b94c28d$var$errorOrDestroy(this, new $a8c22e7f1b94c28d$var$ERR_STREAM_CANNOT_PIPE());
};
function $a8c22e7f1b94c28d$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a8c22e7f1b94c28d$require$Buffer.isEncoding(encoding)) throw new $a8c22e7f1b94c28d$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a8c22e7f1b94c28d$var$nop;
    }
    if (chunk === null) throw new $a8c22e7f1b94c28d$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a8c22e7f1b94c28d$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a8c22e7f1b94c28d$require$Buffer) encoding = 'buffer';
        else if ($a8c22e7f1b94c28d$require$Stream._isUint8Array(chunk)) {
            chunk = $a8c22e7f1b94c28d$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a8c22e7f1b94c28d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a8c22e7f1b94c28d$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a8c22e7f1b94c28d$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a8c22e7f1b94c28d$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a8c22e7f1b94c28d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a8c22e7f1b94c28d$var$_write(this, chunk, encoding, cb) === true;
};
$a8c22e7f1b94c28d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a8c22e7f1b94c28d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a8c22e7f1b94c28d$var$clearBuffer(this, state);
    }
};
$a8c22e7f1b94c28d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a8c22e7f1b94c28d$var$StringPrototypeToLowerCase(encoding);
    if (!$a8c22e7f1b94c28d$require$Buffer.isEncoding(encoding)) throw new $a8c22e7f1b94c28d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a8c22e7f1b94c28d$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a8c22e7f1b94c28d$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a8c22e7f1b94c28d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a8c22e7f1b94c28d$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a8c22e7f1b94c28d$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a8c22e7f1b94c28d$var$errorOrDestroy(stream, er);
}
function $a8c22e7f1b94c28d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a8c22e7f1b94c28d$var$errorOrDestroy(stream, new $a8c22e7f1b94c28d$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a8c22e7f1b94c28d$var$onwriteError, stream, state, er, cb);
        else $a8c22e7f1b94c28d$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a8c22e7f1b94c28d$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a8c22e7f1b94c28d$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a8c22e7f1b94c28d$var$afterWrite(stream, state, 1, cb);
    }
}
function $a8c22e7f1b94c28d$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a8c22e7f1b94c28d$var$afterWrite(stream, state, count, cb);
}
function $a8c22e7f1b94c28d$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a8c22e7f1b94c28d$var$errorBuffer(state);
    $a8c22e7f1b94c28d$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a8c22e7f1b94c28d$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a8c22e7f1b94c28d$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED('end'));
    }
    $a8c22e7f1b94c28d$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a8c22e7f1b94c28d$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a8c22e7f1b94c28d$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a8c22e7f1b94c28d$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a8c22e7f1b94c28d$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a8c22e7f1b94c28d$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a8c22e7f1b94c28d$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a8c22e7f1b94c28d$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a8c22e7f1b94c28d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a8c22e7f1b94c28d$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a8c22e7f1b94c28d$var$Writable.prototype._writev = null;
$a8c22e7f1b94c28d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a8c22e7f1b94c28d$var$_write(this, chunk, encoding);
        if (ret instanceof $a8c22e7f1b94c28d$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a8c22e7f1b94c28d$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a8c22e7f1b94c28d$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a8c22e7f1b94c28d$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a8c22e7f1b94c28d$var$kOnFinished].push(cb);
    }
    return this;
};
function $a8c22e7f1b94c28d$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a8c22e7f1b94c28d$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a8c22e7f1b94c28d$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a8c22e7f1b94c28d$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a8c22e7f1b94c28d$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a8c22e7f1b94c28d$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a8c22e7f1b94c28d$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a8c22e7f1b94c28d$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a8c22e7f1b94c28d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a8c22e7f1b94c28d$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a8c22e7f1b94c28d$var$finishMaybe(stream, state, sync) {
    if ($a8c22e7f1b94c28d$var$needFinish(state)) {
        $a8c22e7f1b94c28d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a8c22e7f1b94c28d$var$needFinish(state)) $a8c22e7f1b94c28d$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a8c22e7f1b94c28d$var$needFinish(state)) {
                state.pendingcb++;
                $a8c22e7f1b94c28d$var$finish(stream, state);
            }
        }
    }
}
function $a8c22e7f1b94c28d$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a8c22e7f1b94c28d$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a8c22e7f1b94c28d$var$ObjectDefineProperties($a8c22e7f1b94c28d$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a8c22e7f1b94c28d$var$destroy = $3mhwQ.destroy;
$a8c22e7f1b94c28d$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a8c22e7f1b94c28d$var$kOnFinished].length)) $2Qkr5.nextTick($a8c22e7f1b94c28d$var$errorBuffer, state);
    $a8c22e7f1b94c28d$var$destroy.call(this, err, cb);
    return this;
};
$a8c22e7f1b94c28d$var$Writable.prototype._undestroy = $3mhwQ.undestroy;
$a8c22e7f1b94c28d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a8c22e7f1b94c28d$var$Writable.prototype[$a8c22e7f1b94c28d$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a8c22e7f1b94c28d$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a8c22e7f1b94c28d$var$lazyWebStreams() {
    if ($a8c22e7f1b94c28d$var$webStreamsAdapters === undefined) $a8c22e7f1b94c28d$var$webStreamsAdapters = {};
    return $a8c22e7f1b94c28d$var$webStreamsAdapters;
}
$a8c22e7f1b94c28d$var$Writable.fromWeb = function(writableStream, options) {
    return $a8c22e7f1b94c28d$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a8c22e7f1b94c28d$var$Writable.toWeb = function(streamWritable) {
    return $a8c22e7f1b94c28d$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("en2Dd", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $9cHQz = parcelRequire("9cHQz");

var $fbUlO = parcelRequire("fbUlO");
var $a765413b8267edcc$var$isReadable = $fbUlO.isReadable, $a765413b8267edcc$var$isWritable = $fbUlO.isWritable, $a765413b8267edcc$var$isIterable = $fbUlO.isIterable, $a765413b8267edcc$var$isNodeStream = $fbUlO.isNodeStream, $a765413b8267edcc$var$isReadableNodeStream = $fbUlO.isReadableNodeStream, $a765413b8267edcc$var$isWritableNodeStream = $fbUlO.isWritableNodeStream, $a765413b8267edcc$var$isDuplexNodeStream = $fbUlO.isDuplexNodeStream, $a765413b8267edcc$var$isReadableStream = $fbUlO.isReadableStream, $a765413b8267edcc$var$isWritableStream = $fbUlO.isWritableStream;

var $5P5kd = parcelRequire("5P5kd");

var $lhKpv = parcelRequire("lhKpv");
var $a765413b8267edcc$var$AbortError = $lhKpv.AbortError, $a765413b8267edcc$var$_require_codes = $lhKpv.codes, $a765413b8267edcc$var$ERR_INVALID_ARG_TYPE = $a765413b8267edcc$var$_require_codes.ERR_INVALID_ARG_TYPE, $a765413b8267edcc$var$ERR_INVALID_RETURN_VALUE = $a765413b8267edcc$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $3mhwQ = parcelRequire("3mhwQ");
var $a765413b8267edcc$require$destroyer = $3mhwQ.destroyer;

var $fNq7V = parcelRequire("fNq7V");

var $5qi49 = parcelRequire("5qi49");

var $euisa = parcelRequire("euisa");

var $amFNO = parcelRequire("amFNO");
var $a765413b8267edcc$require$createDeferredPromise = $amFNO.createDeferredPromise;

var $2N9PA = parcelRequire("2N9PA");
var $a765413b8267edcc$var$Blob = globalThis.Blob || $9cHQz.Blob;
var $a765413b8267edcc$var$isBlob = typeof $a765413b8267edcc$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $a765413b8267edcc$var$Blob;
} : function isBlob(b) {
    return false;
};

var $a765413b8267edcc$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $kdkK0 = parcelRequire("kdkK0");
var $a765413b8267edcc$require$FunctionPrototypeCall = $kdkK0.FunctionPrototypeCall;
// This is needed for pre node 17.
var $a765413b8267edcc$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($fNq7V);
module.exports = function duplexify(body, name) {
    if ($a765413b8267edcc$var$isDuplexNodeStream(body)) return body;
    if ($a765413b8267edcc$var$isReadableNodeStream(body)) return $a765413b8267edcc$var$_duplexify({
        readable: body
    });
    if ($a765413b8267edcc$var$isWritableNodeStream(body)) return $a765413b8267edcc$var$_duplexify({
        writable: body
    });
    if ($a765413b8267edcc$var$isNodeStream(body)) return $a765413b8267edcc$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($a765413b8267edcc$var$isReadableStream(body)) return $a765413b8267edcc$var$_duplexify({
        readable: $5qi49.fromWeb(body)
    });
    if ($a765413b8267edcc$var$isWritableStream(body)) return $a765413b8267edcc$var$_duplexify({
        writable: $euisa.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $a765413b8267edcc$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($a765413b8267edcc$var$isIterable(value)) return $2N9PA($a765413b8267edcc$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $a765413b8267edcc$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $a765413b8267edcc$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $a765413b8267edcc$require$destroyer(d, err);
            });
            return d = new $a765413b8267edcc$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $a765413b8267edcc$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($a765413b8267edcc$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($a765413b8267edcc$var$isIterable(body)) return $2N9PA($a765413b8267edcc$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($a765413b8267edcc$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $a765413b8267edcc$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $a765413b8267edcc$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $a765413b8267edcc$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $a765413b8267edcc$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $a765413b8267edcc$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $a765413b8267edcc$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $a765413b8267edcc$require$destroyer(d1, err);
        });
        return d1 = new $a765413b8267edcc$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $a765413b8267edcc$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $a765413b8267edcc$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $a765413b8267edcc$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $a765413b8267edcc$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $a765413b8267edcc$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $a765413b8267edcc$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $a765413b8267edcc$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $5qi49.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$a765413b8267edcc$var$isReadable(r);
    var writable = !!$a765413b8267edcc$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $a765413b8267edcc$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $5P5kd(w, function(err) {
            writable = false;
            if (err) $a765413b8267edcc$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $5P5kd(r, function(err) {
            readable = false;
            if (err) $a765413b8267edcc$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $a765413b8267edcc$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $a765413b8267edcc$require$destroyer(w, err);
            $a765413b8267edcc$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("j7DUE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $debda19f06eda9d8$require$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf;
module.exports = $debda19f06eda9d8$var$PassThrough;

var $hZ8Xt = parcelRequire("hZ8Xt");
$debda19f06eda9d8$require$ObjectSetPrototypeOf($debda19f06eda9d8$var$PassThrough.prototype, $hZ8Xt.prototype);
$debda19f06eda9d8$require$ObjectSetPrototypeOf($debda19f06eda9d8$var$PassThrough, $hZ8Xt);
function $debda19f06eda9d8$var$PassThrough(options) {
    if (!(this instanceof $debda19f06eda9d8$var$PassThrough)) return new $debda19f06eda9d8$var$PassThrough(options);
    $hZ8Xt.call(this, options);
}
$debda19f06eda9d8$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("hZ8Xt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $d17f15126e1bd006$var$ObjectSetPrototypeOf = $kdkK0.ObjectSetPrototypeOf, $d17f15126e1bd006$var$Symbol = $kdkK0.Symbol;
module.exports = $d17f15126e1bd006$var$Transform;

var $d17f15126e1bd006$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("lhKpv")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $fNq7V = parcelRequire("fNq7V");

var $gs6oV = parcelRequire("gs6oV");
var $d17f15126e1bd006$require$getHighWaterMark = $gs6oV.getHighWaterMark;
$d17f15126e1bd006$var$ObjectSetPrototypeOf($d17f15126e1bd006$var$Transform.prototype, $fNq7V.prototype);
$d17f15126e1bd006$var$ObjectSetPrototypeOf($d17f15126e1bd006$var$Transform, $fNq7V);
var $d17f15126e1bd006$var$kCallback = $d17f15126e1bd006$var$Symbol('kCallback');
function $d17f15126e1bd006$var$Transform(options) {
    if (!(this instanceof $d17f15126e1bd006$var$Transform)) return new $d17f15126e1bd006$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $d17f15126e1bd006$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $fNq7V.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$d17f15126e1bd006$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $d17f15126e1bd006$var$prefinish);
}
function $d17f15126e1bd006$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $d17f15126e1bd006$var$prefinish() {
    if (this._final !== $d17f15126e1bd006$var$_final) $d17f15126e1bd006$var$_final.call(this);
}
$d17f15126e1bd006$var$Transform.prototype._final = $d17f15126e1bd006$var$_final;
$d17f15126e1bd006$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $d17f15126e1bd006$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$d17f15126e1bd006$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$d17f15126e1bd006$var$kCallback] = callback;
    });
};
$d17f15126e1bd006$var$Transform.prototype._read = function() {
    if (this[$d17f15126e1bd006$var$kCallback]) {
        var callback = this[$d17f15126e1bd006$var$kCallback];
        this[$d17f15126e1bd006$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("9fX8p", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $kdkK0 = parcelRequire("kdkK0");
var $6bd362b032062b90$var$ArrayPrototypePop = $kdkK0.ArrayPrototypePop, $6bd362b032062b90$var$Promise = $kdkK0.Promise;

var $fbUlO = parcelRequire("fbUlO");
var $6bd362b032062b90$var$isIterable = $fbUlO.isIterable, $6bd362b032062b90$var$isNodeStream = $fbUlO.isNodeStream, $6bd362b032062b90$var$isWebStream = $fbUlO.isWebStream;

var $aT7Lf = parcelRequire("aT7Lf");
var $6bd362b032062b90$var$pl = $aT7Lf.pipelineImpl;

var $5P5kd = parcelRequire("5P5kd");
var $6bd362b032062b90$require$finished = $5P5kd.finished;
parcelRequire("4ecLu");
function $6bd362b032062b90$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $6bd362b032062b90$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$6bd362b032062b90$var$isNodeStream(lastArg) && !$6bd362b032062b90$var$isIterable(lastArg) && !$6bd362b032062b90$var$isWebStream(lastArg)) {
            var options = $6bd362b032062b90$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $6bd362b032062b90$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $6bd362b032062b90$require$finished,
    pipeline: $6bd362b032062b90$var$pipeline
};

});



parcelRegister("iZ0Xk", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XmlSerializer = void 0;
/**
 * A very simple XML serializer
 */ var $dd1eaa4e24d9ea64$var$XmlSerializer = /*#__PURE__*/ function() {
    function XmlSerializer() {
        (0, $jGAMp._)(this, XmlSerializer);
        this.stack = [];
    }
    (0, $byiyg._)(XmlSerializer, [
        {
            /**
     *
     * @param name should be a valid XML tag name
     * @param attributes keys should be valid attribute names
     */ key: "open",
            value: function open(name, attributes) {
                var res = "".concat(this.identation() + this.formatTag(name, attributes, 'open'), "\n");
                this.stack.push(name);
                return res;
            }
        },
        {
            key: "close",
            value: function close() {
                var name = this.stack.pop();
                if (name === undefined) throw new Error('There is no tag left to close');
                return "".concat(this.identation() + this.formatTag(name, {}, 'close'), "\n");
            }
        },
        {
            key: "serializeNode",
            value: function serializeNode(node) {
                if (node.children === undefined) return "".concat(this.identation() + this.formatTag(node.name, node.attributes, 'self-closing'), "\n");
                if (typeof node.children === 'string') return "".concat(this.identation() + this.formatTag(node.name, node.attributes, 'open') + this.escape(node.children) + this.formatTag(node.name, {}, 'close'), "\n");
                var parts = [];
                parts.push("".concat(this.identation() + this.formatTag(node.name, node.attributes, 'open'), "\n"));
                this.stack.push(node.name);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        parts.push(this.serializeNode(child));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.stack.pop();
                parts.push("".concat(this.identation() + this.formatTag(node.name, {}, 'close'), "\n"));
                return parts.join('');
            }
        },
        {
            key: "identation",
            value: function identation() {
                return this.stack.map(function(_) {
                    return '  ';
                }).join('');
            }
        },
        {
            key: "formatTag",
            value: function formatTag(name, attributes, state) {
                var _this = this;
                // eslint-disable-next-line ts/restrict-template-expressions
                return "<".concat(state === 'close' ? '/' : '').concat(name).concat(Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}).map(function(attr) {
                    return " ".concat(attr[0], '="').concat(_this.escape(attr[1]), '"');
                })).concat(state === 'self-closing' ? '/' : '', ">");
            }
        },
        {
            key: "escape",
            value: function escape(text) {
                return text.replaceAll(RegExp("[\"&'<>]", "gu"), function(_char) {
                    switch(_char){
                        case '<':
                            return '&lt;';
                        case '>':
                            return '&gt;';
                        case '&':
                            return '&amp;';
                        case '\'':
                            return '&apos;';
                        case '"':
                            return '&quot;';
                    }
                });
            }
        }
    ]);
    return XmlSerializer;
}();
module.exports.XmlSerializer = $dd1eaa4e24d9ea64$var$XmlSerializer;
$dd1eaa4e24d9ea64$var$XmlSerializer.header = '<?xml version="1.0" encoding="UTF-8"?>\n';

});



parcelRegister("3RGGg", function(module, exports) {
"use strict";
var $2d076dcff3d84d24$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d076dcff3d84d24$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2d076dcff3d84d24$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2d076dcff3d84d24$var$__exportStar((parcelRequire("40wqu")), module.exports);

});
parcelRegister("40wqu", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeTable = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $gQYIc = parcelRequire("gQYIc");

var $ilNtL = parcelRequire("ilNtL");

var $efwrj = parcelRequire("efwrj");
/**
 * A comunica Table Sparql Serialize Actor.
 */ var $2eb050ae17ce0b5c$var$ActorQueryResultSerializeTable = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeTable, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeTable(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeTable);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryResultSerializeTable, [
            args
        ]);
        _this.padding = ActorQueryResultSerializeTable.repeat(' ', _this.columnWidth);
        return _this;
    }
    (0, $byiyg._)(ActorQueryResultSerializeTable, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'quads'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings or quad streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "termToString",
            value: function termToString(term) {
                return term.termType === 'Quad' ? (0, $gQYIc.termToString)(term) : term.value;
            }
        },
        {
            key: "pad",
            value: function pad(str) {
                if (str.length <= this.columnWidth) return str + this.padding.slice(str.length);
                return "".concat(str.slice(0, this.columnWidth - 1), "\u2026");
            }
        },
        {
            key: "pushHeader",
            value: function pushHeader(data, labels) {
                var _this = this;
                var header = labels.map(function(label) {
                    return _this.pad(label.value);
                }).join(' ');
                data.push("".concat(header, "\n").concat(ActorQueryResultSerializeTable.repeat('-', header.length), "\n"));
            }
        },
        {
            key: "createRow",
            value: function createRow(labels, bindings) {
                var _this = this;
                return "".concat(labels.map(function(label) {
                    return bindings.has(label) ? _this.termToString(bindings.get(label)) : '';
                }).map(function(label) {
                    return _this.pad(label);
                }).join(' '), "\n");
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, data, resultStream, labels, dataFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                data = new $efwrj.Readable();
                                if (!(action.type === 'bindings')) return [
                                    3,
                                    2
                                ];
                                resultStream = action.bindingsStream.map(function(bindings) {
                                    return _this.createRow(labels, bindings);
                                });
                                return [
                                    4,
                                    action.metadata()
                                ];
                            case 1:
                                labels = _state.sent().variables.map(function(v) {
                                    return v.variable;
                                });
                                this.pushHeader(data, labels);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                resultStream = action.quadStream.map(function(quad) {
                                    return "".concat((0, $ilNtL.getTerms)(quad).map(function(term) {
                                        return _this.pad(_this.termToString(term));
                                    }).join(' '), "\n");
                                });
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                this.pushHeader(data, $ilNtL.QUAD_TERM_NAMES.map(function(name) {
                                    return dataFactory.variable(name);
                                }));
                                _state.label = 3;
                            case 3:
                                data.wrap(resultStream);
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "repeat",
            value: function repeat(str, count) {
                return str.repeat(count);
            }
        }
    ]);
    return ActorQueryResultSerializeTable;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeTable = $2eb050ae17ce0b5c$var$ActorQueryResultSerializeTable;

});
parcelRegister("efwrj", function(module, exports) {
'use strict';

var $aPJcD = parcelRequire("aPJcD");

var $bRjgs = parcelRequire("bRjgs");
var $a5fba13831c8166c$var$originalDestroy = $aPJcD.Readable.destroy;
module.exports = $aPJcD.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $aPJcD._uint8ArrayToBuffer;
module.exports._isUint8Array = $aPJcD._isUint8Array;
module.exports.isDisturbed = $aPJcD.isDisturbed;
module.exports.isErrored = $aPJcD.isErrored;
module.exports.isReadable = $aPJcD.isReadable;
module.exports.Readable = $aPJcD.Readable;
module.exports.Writable = $aPJcD.Writable;
module.exports.Duplex = $aPJcD.Duplex;
module.exports.Transform = $aPJcD.Transform;
module.exports.PassThrough = $aPJcD.PassThrough;
module.exports.addAbortSignal = $aPJcD.addAbortSignal;
module.exports.finished = $aPJcD.finished;
module.exports.destroy = $aPJcD.destroy;
module.exports.destroy = $a5fba13831c8166c$var$originalDestroy;
module.exports.pipeline = $aPJcD.pipeline;
module.exports.compose = $aPJcD.compose;
Object.defineProperty($aPJcD, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $bRjgs;
    }
});
module.exports.Stream = $aPJcD.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("aPJcD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $5EQ4X = parcelRequire("5EQ4X");
var $7e31bb26b7bbe73b$require$Buffer = $5EQ4X.Buffer;

var $4K8OX = parcelRequire("4K8OX");
/* replacement end */ var $7e31bb26b7bbe73b$var$ObjectDefineProperty = $4K8OX.ObjectDefineProperty, $7e31bb26b7bbe73b$var$ObjectKeys = $4K8OX.ObjectKeys, $7e31bb26b7bbe73b$var$ReflectApply = $4K8OX.ReflectApply;

var $1FR2B = parcelRequire("1FR2B");
var $7e31bb26b7bbe73b$var$_require_promisify = $1FR2B.promisify, $7e31bb26b7bbe73b$var$customPromisify = $7e31bb26b7bbe73b$var$_require_promisify.custom;

var $8ISEW = parcelRequire("8ISEW");
var $7e31bb26b7bbe73b$var$streamReturningOperators = $8ISEW.streamReturningOperators, $7e31bb26b7bbe73b$var$promiseReturningOperators = $8ISEW.promiseReturningOperators;

var $d092A = parcelRequire("d092A");
var $7e31bb26b7bbe73b$var$ERR_ILLEGAL_CONSTRUCTOR = $d092A.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $5fFxF = parcelRequire("5fFxF");

var $4Gyqa = parcelRequire("4Gyqa");
var $7e31bb26b7bbe73b$var$setDefaultHighWaterMark = $4Gyqa.setDefaultHighWaterMark, $7e31bb26b7bbe73b$var$getDefaultHighWaterMark = $4Gyqa.getDefaultHighWaterMark;

var $aXKB2 = parcelRequire("aXKB2");
var $7e31bb26b7bbe73b$require$pipeline = $aXKB2.pipeline;

var $jnNYa = parcelRequire("jnNYa");
var $7e31bb26b7bbe73b$require$destroyer = $jnNYa.destroyer;

var $leSYr = parcelRequire("leSYr");
var $7e31bb26b7bbe73b$var$internalBuffer = {};

var $bRjgs = parcelRequire("bRjgs");

var $eLqbm = parcelRequire("eLqbm");

var $7e31bb26b7bbe73b$var$Stream = module.exports = (parcelRequire("8N5gC")).Stream;
$7e31bb26b7bbe73b$var$Stream.isDestroyed = $eLqbm.isDestroyed;
$7e31bb26b7bbe73b$var$Stream.isDisturbed = $eLqbm.isDisturbed;
$7e31bb26b7bbe73b$var$Stream.isErrored = $eLqbm.isErrored;
$7e31bb26b7bbe73b$var$Stream.isReadable = $eLqbm.isReadable;
$7e31bb26b7bbe73b$var$Stream.isWritable = $eLqbm.isWritable;

$7e31bb26b7bbe73b$var$Stream.Readable = (parcelRequire("84Uuw"));
var $7e31bb26b7bbe73b$var$_iteratorNormalCompletion = true, $7e31bb26b7bbe73b$var$_didIteratorError = false, $7e31bb26b7bbe73b$var$_iteratorError = undefined;
try {
    for(var $7e31bb26b7bbe73b$var$_iterator = $7e31bb26b7bbe73b$var$ObjectKeys($7e31bb26b7bbe73b$var$streamReturningOperators)[Symbol.iterator](), $7e31bb26b7bbe73b$var$_step; !($7e31bb26b7bbe73b$var$_iteratorNormalCompletion = ($7e31bb26b7bbe73b$var$_step = $7e31bb26b7bbe73b$var$_iterator.next()).done); $7e31bb26b7bbe73b$var$_iteratorNormalCompletion = true){
        var $7e31bb26b7bbe73b$var$key = $7e31bb26b7bbe73b$var$_step.value;
        var $7e31bb26b7bbe73b$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $7e31bb26b7bbe73b$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7e31bb26b7bbe73b$var$Stream.Readable.from($7e31bb26b7bbe73b$var$ReflectApply($7e31bb26b7bbe73b$var$op, this, args));
        };
        var $7e31bb26b7bbe73b$var$op = $7e31bb26b7bbe73b$var$streamReturningOperators[$7e31bb26b7bbe73b$var$key];
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$fn, 'name', {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$op.name
        });
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$fn, 'length', {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$op.length
        });
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$Stream.Readable.prototype, $7e31bb26b7bbe73b$var$key, {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7e31bb26b7bbe73b$var$_didIteratorError = true;
    $7e31bb26b7bbe73b$var$_iteratorError = err;
} finally{
    try {
        if (!$7e31bb26b7bbe73b$var$_iteratorNormalCompletion && $7e31bb26b7bbe73b$var$_iterator["return"] != null) {
            $7e31bb26b7bbe73b$var$_iterator["return"]();
        }
    } finally{
        if ($7e31bb26b7bbe73b$var$_didIteratorError) {
            throw $7e31bb26b7bbe73b$var$_iteratorError;
        }
    }
}
var $7e31bb26b7bbe73b$var$_iteratorNormalCompletion1 = true, $7e31bb26b7bbe73b$var$_didIteratorError1 = false, $7e31bb26b7bbe73b$var$_iteratorError1 = undefined;
try {
    for(var $7e31bb26b7bbe73b$var$_iterator1 = $7e31bb26b7bbe73b$var$ObjectKeys($7e31bb26b7bbe73b$var$promiseReturningOperators)[Symbol.iterator](), $7e31bb26b7bbe73b$var$_step1; !($7e31bb26b7bbe73b$var$_iteratorNormalCompletion1 = ($7e31bb26b7bbe73b$var$_step1 = $7e31bb26b7bbe73b$var$_iterator1.next()).done); $7e31bb26b7bbe73b$var$_iteratorNormalCompletion1 = true){
        var $7e31bb26b7bbe73b$var$key1 = $7e31bb26b7bbe73b$var$_step1.value;
        var $7e31bb26b7bbe73b$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $7e31bb26b7bbe73b$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7e31bb26b7bbe73b$var$ReflectApply($7e31bb26b7bbe73b$var$op1, this, args);
        };
        var $7e31bb26b7bbe73b$var$op1 = $7e31bb26b7bbe73b$var$promiseReturningOperators[$7e31bb26b7bbe73b$var$key1];
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$fn1, 'name', {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$op1.name
        });
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$fn1, 'length', {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$op1.length
        });
        $7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$Stream.Readable.prototype, $7e31bb26b7bbe73b$var$key1, {
            __proto__: null,
            value: $7e31bb26b7bbe73b$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7e31bb26b7bbe73b$var$_didIteratorError1 = true;
    $7e31bb26b7bbe73b$var$_iteratorError1 = err;
} finally{
    try {
        if (!$7e31bb26b7bbe73b$var$_iteratorNormalCompletion1 && $7e31bb26b7bbe73b$var$_iterator1["return"] != null) {
            $7e31bb26b7bbe73b$var$_iterator1["return"]();
        }
    } finally{
        if ($7e31bb26b7bbe73b$var$_didIteratorError1) {
            throw $7e31bb26b7bbe73b$var$_iteratorError1;
        }
    }
}

$7e31bb26b7bbe73b$var$Stream.Writable = (parcelRequire("b2yGi"));

$7e31bb26b7bbe73b$var$Stream.Duplex = (parcelRequire("29VwN"));

$7e31bb26b7bbe73b$var$Stream.Transform = (parcelRequire("e5oCo"));

$7e31bb26b7bbe73b$var$Stream.PassThrough = (parcelRequire("iVKMH"));
$7e31bb26b7bbe73b$var$Stream.pipeline = $7e31bb26b7bbe73b$require$pipeline;

var $aeA37 = parcelRequire("aeA37");
var $7e31bb26b7bbe73b$require$addAbortSignal = $aeA37.addAbortSignal;
$7e31bb26b7bbe73b$var$Stream.addAbortSignal = $7e31bb26b7bbe73b$require$addAbortSignal;
$7e31bb26b7bbe73b$var$Stream.finished = $leSYr;
$7e31bb26b7bbe73b$var$Stream.destroy = $7e31bb26b7bbe73b$require$destroyer;
$7e31bb26b7bbe73b$var$Stream.compose = $5fFxF;
$7e31bb26b7bbe73b$var$Stream.setDefaultHighWaterMark = $7e31bb26b7bbe73b$var$setDefaultHighWaterMark;
$7e31bb26b7bbe73b$var$Stream.getDefaultHighWaterMark = $7e31bb26b7bbe73b$var$getDefaultHighWaterMark;
$7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $bRjgs;
    }
});
$7e31bb26b7bbe73b$var$ObjectDefineProperty($7e31bb26b7bbe73b$require$pipeline, $7e31bb26b7bbe73b$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $bRjgs.pipeline;
    }
});
$7e31bb26b7bbe73b$var$ObjectDefineProperty($leSYr, $7e31bb26b7bbe73b$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $bRjgs.finished;
    }
});
// Backwards-compat with node 0.4.x
$7e31bb26b7bbe73b$var$Stream.Stream = $7e31bb26b7bbe73b$var$Stream;
$7e31bb26b7bbe73b$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$7e31bb26b7bbe73b$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $7e31bb26b7bbe73b$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("5EQ4X", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $41e915feb8c23e56$export$a143d493d941bafc; }, function (v) { return $41e915feb8c23e56$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $41e915feb8c23e56$export$f99ded8fe4b79145; }, function (v) { return $41e915feb8c23e56$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $41e915feb8c23e56$export$a143d493d941bafc;
var $41e915feb8c23e56$export$e4cf37d7f6fb9e0a;
var $41e915feb8c23e56$export$f99ded8fe4b79145;
var $41e915feb8c23e56$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $41e915feb8c23e56$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$41e915feb8c23e56$export$a143d493d941bafc = $41e915feb8c23e56$var$Buffer;
$41e915feb8c23e56$export$e4cf37d7f6fb9e0a = $41e915feb8c23e56$var$SlowBuffer;
$41e915feb8c23e56$export$f99ded8fe4b79145 = 50;
var $41e915feb8c23e56$var$K_MAX_LENGTH = 0x7fffffff;
$41e915feb8c23e56$export$599f31c3813fae4d = $41e915feb8c23e56$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $41e915feb8c23e56$var$Buffer.TYPED_ARRAY_SUPPORT = $41e915feb8c23e56$var$typedArraySupport();
if (!$41e915feb8c23e56$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $41e915feb8c23e56$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($41e915feb8c23e56$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$41e915feb8c23e56$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($41e915feb8c23e56$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$41e915feb8c23e56$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $41e915feb8c23e56$var$createBuffer(length) {
    if (length > $41e915feb8c23e56$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $41e915feb8c23e56$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $41e915feb8c23e56$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $41e915feb8c23e56$var$allocUnsafe(arg);
    }
    return $41e915feb8c23e56$var$from(arg, encodingOrOffset, length);
}
$41e915feb8c23e56$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $41e915feb8c23e56$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $41e915feb8c23e56$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $41e915feb8c23e56$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($41e915feb8c23e56$var$isInstance(value, ArrayBuffer) || value && $41e915feb8c23e56$var$isInstance(value.buffer, ArrayBuffer)) return $41e915feb8c23e56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($41e915feb8c23e56$var$isInstance(value, SharedArrayBuffer) || value && $41e915feb8c23e56$var$isInstance(value.buffer, SharedArrayBuffer))) return $41e915feb8c23e56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $41e915feb8c23e56$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $41e915feb8c23e56$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $41e915feb8c23e56$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $41e915feb8c23e56$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $41e915feb8c23e56$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($41e915feb8c23e56$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($41e915feb8c23e56$var$Buffer, Uint8Array);
function $41e915feb8c23e56$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $41e915feb8c23e56$var$alloc(size, fill, encoding) {
    $41e915feb8c23e56$var$assertSize(size);
    if (size <= 0) return $41e915feb8c23e56$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $41e915feb8c23e56$var$createBuffer(size).fill(fill, encoding) : $41e915feb8c23e56$var$createBuffer(size).fill(fill);
    return $41e915feb8c23e56$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $41e915feb8c23e56$var$Buffer.alloc = function(size, fill, encoding) {
    return $41e915feb8c23e56$var$alloc(size, fill, encoding);
};
function $41e915feb8c23e56$var$allocUnsafe(size) {
    $41e915feb8c23e56$var$assertSize(size);
    return $41e915feb8c23e56$var$createBuffer(size < 0 ? 0 : $41e915feb8c23e56$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $41e915feb8c23e56$var$Buffer.allocUnsafe = function(size) {
    return $41e915feb8c23e56$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $41e915feb8c23e56$var$Buffer.allocUnsafeSlow = function(size) {
    return $41e915feb8c23e56$var$allocUnsafe(size);
};
function $41e915feb8c23e56$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$41e915feb8c23e56$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $41e915feb8c23e56$var$byteLength(string, encoding) | 0;
    var buf = $41e915feb8c23e56$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $41e915feb8c23e56$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $41e915feb8c23e56$var$checked(array.length) | 0;
    var buf = $41e915feb8c23e56$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $41e915feb8c23e56$var$fromArrayView(arrayView) {
    if ($41e915feb8c23e56$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $41e915feb8c23e56$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $41e915feb8c23e56$var$fromArrayLike(arrayView);
}
function $41e915feb8c23e56$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $41e915feb8c23e56$var$Buffer.prototype);
    return buf;
}
function $41e915feb8c23e56$var$fromObject(obj) {
    if ($41e915feb8c23e56$var$Buffer.isBuffer(obj)) {
        var len = $41e915feb8c23e56$var$checked(obj.length) | 0;
        var buf = $41e915feb8c23e56$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $41e915feb8c23e56$var$numberIsNaN(obj.length)) return $41e915feb8c23e56$var$createBuffer(0);
        return $41e915feb8c23e56$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $41e915feb8c23e56$var$fromArrayLike(obj.data);
}
function $41e915feb8c23e56$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $41e915feb8c23e56$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $41e915feb8c23e56$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $41e915feb8c23e56$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $41e915feb8c23e56$var$Buffer.alloc(+length);
}
$41e915feb8c23e56$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $41e915feb8c23e56$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$41e915feb8c23e56$var$Buffer.compare = function compare(a, b) {
    if ($41e915feb8c23e56$var$isInstance(a, Uint8Array)) a = $41e915feb8c23e56$var$Buffer.from(a, a.offset, a.byteLength);
    if ($41e915feb8c23e56$var$isInstance(b, Uint8Array)) b = $41e915feb8c23e56$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$41e915feb8c23e56$var$Buffer.isBuffer(a) || !$41e915feb8c23e56$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$41e915feb8c23e56$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$41e915feb8c23e56$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $41e915feb8c23e56$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $41e915feb8c23e56$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($41e915feb8c23e56$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$41e915feb8c23e56$var$Buffer.isBuffer(buf)) buf = $41e915feb8c23e56$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$41e915feb8c23e56$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $41e915feb8c23e56$var$byteLength(string, encoding) {
    if ($41e915feb8c23e56$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $41e915feb8c23e56$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $41e915feb8c23e56$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $41e915feb8c23e56$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $41e915feb8c23e56$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$41e915feb8c23e56$var$Buffer.byteLength = $41e915feb8c23e56$var$byteLength;
function $41e915feb8c23e56$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $41e915feb8c23e56$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $41e915feb8c23e56$var$utf8Slice(this, start, end);
        case 'ascii':
            return $41e915feb8c23e56$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $41e915feb8c23e56$var$latin1Slice(this, start, end);
        case 'base64':
            return $41e915feb8c23e56$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41e915feb8c23e56$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$41e915feb8c23e56$var$Buffer.prototype._isBuffer = true;
function $41e915feb8c23e56$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$41e915feb8c23e56$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$41e915feb8c23e56$var$swap(this, i, i + 1);
    return this;
};
$41e915feb8c23e56$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $41e915feb8c23e56$var$swap(this, i, i + 3);
        $41e915feb8c23e56$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$41e915feb8c23e56$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $41e915feb8c23e56$var$swap(this, i, i + 7);
        $41e915feb8c23e56$var$swap(this, i + 1, i + 6);
        $41e915feb8c23e56$var$swap(this, i + 2, i + 5);
        $41e915feb8c23e56$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$41e915feb8c23e56$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $41e915feb8c23e56$var$utf8Slice(this, 0, length);
    return $41e915feb8c23e56$var$slowToString.apply(this, arguments);
};
$41e915feb8c23e56$var$Buffer.prototype.toLocaleString = $41e915feb8c23e56$var$Buffer.prototype.toString;
$41e915feb8c23e56$var$Buffer.prototype.equals = function equals(b) {
    if (!$41e915feb8c23e56$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $41e915feb8c23e56$var$Buffer.compare(this, b) === 0;
};
$41e915feb8c23e56$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $41e915feb8c23e56$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($41e915feb8c23e56$var$customInspectSymbol) $41e915feb8c23e56$var$Buffer.prototype[$41e915feb8c23e56$var$customInspectSymbol] = $41e915feb8c23e56$var$Buffer.prototype.inspect;
$41e915feb8c23e56$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($41e915feb8c23e56$var$isInstance(target, Uint8Array)) target = $41e915feb8c23e56$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$41e915feb8c23e56$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $41e915feb8c23e56$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($41e915feb8c23e56$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $41e915feb8c23e56$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($41e915feb8c23e56$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $41e915feb8c23e56$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $41e915feb8c23e56$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $41e915feb8c23e56$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$41e915feb8c23e56$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$41e915feb8c23e56$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $41e915feb8c23e56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$41e915feb8c23e56$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $41e915feb8c23e56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $41e915feb8c23e56$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($41e915feb8c23e56$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $41e915feb8c23e56$var$utf8Write(buf, string, offset, length) {
    return $41e915feb8c23e56$var$blitBuffer($41e915feb8c23e56$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $41e915feb8c23e56$var$asciiWrite(buf, string, offset, length) {
    return $41e915feb8c23e56$var$blitBuffer($41e915feb8c23e56$var$asciiToBytes(string), buf, offset, length);
}
function $41e915feb8c23e56$var$base64Write(buf, string, offset, length) {
    return $41e915feb8c23e56$var$blitBuffer($41e915feb8c23e56$var$base64ToBytes(string), buf, offset, length);
}
function $41e915feb8c23e56$var$ucs2Write(buf, string, offset, length) {
    return $41e915feb8c23e56$var$blitBuffer($41e915feb8c23e56$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$41e915feb8c23e56$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $41e915feb8c23e56$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $41e915feb8c23e56$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $41e915feb8c23e56$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $41e915feb8c23e56$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41e915feb8c23e56$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$41e915feb8c23e56$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $41e915feb8c23e56$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $41e915feb8c23e56$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $41e915feb8c23e56$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $41e915feb8c23e56$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $41e915feb8c23e56$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $41e915feb8c23e56$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $41e915feb8c23e56$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $41e915feb8c23e56$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $41e915feb8c23e56$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $41e915feb8c23e56$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $41e915feb8c23e56$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $41e915feb8c23e56$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$41e915feb8c23e56$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $41e915feb8c23e56$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $41e915feb8c23e56$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$41e915feb8c23e56$var$Buffer.prototype.readUintLE = $41e915feb8c23e56$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$41e915feb8c23e56$var$Buffer.prototype.readUintBE = $41e915feb8c23e56$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$41e915feb8c23e56$var$Buffer.prototype.readUint8 = $41e915feb8c23e56$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$41e915feb8c23e56$var$Buffer.prototype.readUint16LE = $41e915feb8c23e56$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$41e915feb8c23e56$var$Buffer.prototype.readUint16BE = $41e915feb8c23e56$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$41e915feb8c23e56$var$Buffer.prototype.readUint32LE = $41e915feb8c23e56$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$41e915feb8c23e56$var$Buffer.prototype.readUint32BE = $41e915feb8c23e56$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$41e915feb8c23e56$var$Buffer.prototype.readBigUInt64LE = $41e915feb8c23e56$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $41e915feb8c23e56$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $41e915feb8c23e56$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$41e915feb8c23e56$var$Buffer.prototype.readBigUInt64BE = $41e915feb8c23e56$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $41e915feb8c23e56$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $41e915feb8c23e56$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$41e915feb8c23e56$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41e915feb8c23e56$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41e915feb8c23e56$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$41e915feb8c23e56$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41e915feb8c23e56$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41e915feb8c23e56$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$41e915feb8c23e56$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$41e915feb8c23e56$var$Buffer.prototype.readBigInt64LE = $41e915feb8c23e56$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $41e915feb8c23e56$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $41e915feb8c23e56$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$41e915feb8c23e56$var$Buffer.prototype.readBigInt64BE = $41e915feb8c23e56$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $41e915feb8c23e56$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $41e915feb8c23e56$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$41e915feb8c23e56$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$41e915feb8c23e56$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$41e915feb8c23e56$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$41e915feb8c23e56$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $41e915feb8c23e56$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$41e915feb8c23e56$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$41e915feb8c23e56$var$Buffer.prototype.writeUintLE = $41e915feb8c23e56$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41e915feb8c23e56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUintBE = $41e915feb8c23e56$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41e915feb8c23e56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUint8 = $41e915feb8c23e56$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUint16LE = $41e915feb8c23e56$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUint16BE = $41e915feb8c23e56$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUint32LE = $41e915feb8c23e56$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$41e915feb8c23e56$var$Buffer.prototype.writeUint32BE = $41e915feb8c23e56$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $41e915feb8c23e56$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $41e915feb8c23e56$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $41e915feb8c23e56$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $41e915feb8c23e56$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$41e915feb8c23e56$var$Buffer.prototype.writeBigUInt64LE = $41e915feb8c23e56$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $41e915feb8c23e56$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41e915feb8c23e56$var$Buffer.prototype.writeBigUInt64BE = $41e915feb8c23e56$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $41e915feb8c23e56$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41e915feb8c23e56$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $41e915feb8c23e56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41e915feb8c23e56$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $41e915feb8c23e56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41e915feb8c23e56$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$41e915feb8c23e56$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41e915feb8c23e56$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41e915feb8c23e56$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$41e915feb8c23e56$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$41e915feb8c23e56$var$Buffer.prototype.writeBigInt64LE = $41e915feb8c23e56$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $41e915feb8c23e56$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$41e915feb8c23e56$var$Buffer.prototype.writeBigInt64BE = $41e915feb8c23e56$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $41e915feb8c23e56$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $41e915feb8c23e56$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $41e915feb8c23e56$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$41e915feb8c23e56$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $41e915feb8c23e56$var$writeFloat(this, value, offset, true, noAssert);
};
$41e915feb8c23e56$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $41e915feb8c23e56$var$writeFloat(this, value, offset, false, noAssert);
};
function $41e915feb8c23e56$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41e915feb8c23e56$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$41e915feb8c23e56$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $41e915feb8c23e56$var$writeDouble(this, value, offset, true, noAssert);
};
$41e915feb8c23e56$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $41e915feb8c23e56$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$41e915feb8c23e56$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$41e915feb8c23e56$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$41e915feb8c23e56$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$41e915feb8c23e56$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $41e915feb8c23e56$var$Buffer.isBuffer(val) ? val : $41e915feb8c23e56$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $41e915feb8c23e56$var$errors = {};
function $41e915feb8c23e56$var$E(sym, getMessage, Base) {
    $41e915feb8c23e56$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$41e915feb8c23e56$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$41e915feb8c23e56$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$41e915feb8c23e56$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $41e915feb8c23e56$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $41e915feb8c23e56$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $41e915feb8c23e56$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $41e915feb8c23e56$var$checkBounds(buf, offset, byteLength) {
    $41e915feb8c23e56$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $41e915feb8c23e56$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $41e915feb8c23e56$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $41e915feb8c23e56$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $41e915feb8c23e56$var$checkBounds(buf, offset, byteLength);
}
function $41e915feb8c23e56$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $41e915feb8c23e56$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $41e915feb8c23e56$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $41e915feb8c23e56$var$validateNumber(value, type);
        throw new $41e915feb8c23e56$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $41e915feb8c23e56$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $41e915feb8c23e56$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $41e915feb8c23e56$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $41e915feb8c23e56$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($41e915feb8c23e56$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $41e915feb8c23e56$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $41e915feb8c23e56$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $41e915feb8c23e56$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $41e915feb8c23e56$var$base64ToBytes(str) {
    return $abUaD.toByteArray($41e915feb8c23e56$var$base64clean(str));
}
function $41e915feb8c23e56$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $41e915feb8c23e56$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $41e915feb8c23e56$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $41e915feb8c23e56$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $41e915feb8c23e56$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $41e915feb8c23e56$var$BufferBigIntNotDefined : fn;
}
function $41e915feb8c23e56$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("4K8OX", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $37424cf08b80688d$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $37424cf08b80688d$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("1FR2B", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $5EQ4X = parcelRequire("5EQ4X");

var $WpdUJ = parcelRequire("WpdUJ");
var $1382c3974533a94a$var$format = $WpdUJ.format, $1382c3974533a94a$var$inspect = $WpdUJ.inspect;

var $d092A = parcelRequire("d092A");
var $1382c3974533a94a$var$ERR_INVALID_ARG_TYPE = $d092A.codes.ERR_INVALID_ARG_TYPE;

var $4K8OX = parcelRequire("4K8OX");
var $1382c3974533a94a$var$kResistStopPropagation = $4K8OX.kResistStopPropagation, $1382c3974533a94a$var$AggregateError = $4K8OX.AggregateError, $1382c3974533a94a$var$SymbolDispose = $4K8OX.SymbolDispose;

var $1382c3974533a94a$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $1382c3974533a94a$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $1382c3974533a94a$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $1382c3974533a94a$var$Blob = globalThis.Blob || $5EQ4X.Blob;
/* eslint-disable indent */ var $1382c3974533a94a$var$isBlob = typeof $1382c3974533a94a$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $1382c3974533a94a$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $1382c3974533a94a$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $1382c3974533a94a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $1382c3974533a94a$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $1382c3974533a94a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $1382c3974533a94a$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $1382c3974533a94a$var$format,
    inspect: $1382c3974533a94a$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $1382c3974533a94a$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $1382c3974533a94a$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $1382c3974533a94a$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $1382c3974533a94a$var$validateAbortSignal(signal, 'signal');
        $1382c3974533a94a$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $1382c3974533a94a$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $1382c3974533a94a$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $1382c3974533a94a$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $1382c3974533a94a$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $1382c3974533a94a$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("WpdUJ", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("d092A", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $WpdUJ = parcelRequire("WpdUJ");
var $977249be4ce82672$var$format = $WpdUJ.format, $977249be4ce82672$var$inspect = $WpdUJ.inspect;

var $4K8OX = parcelRequire("4K8OX");
var $977249be4ce82672$var$CustomAggregateError = $4K8OX.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $977249be4ce82672$var$AggregateError = globalThis.AggregateError || $977249be4ce82672$var$CustomAggregateError;
var $977249be4ce82672$var$kIsNodeError = Symbol('kIsNodeError');
var $977249be4ce82672$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $977249be4ce82672$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $977249be4ce82672$var$nodeInternalPrefix = '__node_internal_';
var $977249be4ce82672$var$codes = {};
function $977249be4ce82672$var$assert(value, message) {
    if (!value) throw new $977249be4ce82672$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $977249be4ce82672$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $977249be4ce82672$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $977249be4ce82672$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $977249be4ce82672$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $977249be4ce82672$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $977249be4ce82672$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $977249be4ce82672$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$977249be4ce82672$var$kIsNodeError] = true;
    $977249be4ce82672$var$codes[code] = NodeError;
}
function $977249be4ce82672$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $977249be4ce82672$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $977249be4ce82672$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $977249be4ce82672$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $977249be4ce82672$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $977249be4ce82672$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$977249be4ce82672$var$E('ERR_ASSERTION', '%s', Error);
$977249be4ce82672$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $977249be4ce82672$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $977249be4ce82672$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($977249be4ce82672$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($977249be4ce82672$var$classRegExp.test(value)) instances.push(value);
            else {
                $977249be4ce82672$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $977249be4ce82672$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $977249be4ce82672$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$977249be4ce82672$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $977249be4ce82672$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$977249be4ce82672$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$977249be4ce82672$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $977249be4ce82672$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$977249be4ce82672$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $977249be4ce82672$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $977249be4ce82672$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $977249be4ce82672$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $977249be4ce82672$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$977249be4ce82672$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$977249be4ce82672$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$977249be4ce82672$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$977249be4ce82672$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$977249be4ce82672$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$977249be4ce82672$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$977249be4ce82672$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$977249be4ce82672$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$977249be4ce82672$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$977249be4ce82672$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$977249be4ce82672$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $977249be4ce82672$var$AbortError,
    aggregateTwoErrors: $977249be4ce82672$var$hideStackFrames($977249be4ce82672$var$aggregateTwoErrors),
    hideStackFrames: $977249be4ce82672$var$hideStackFrames,
    codes: $977249be4ce82672$var$codes
};

});


parcelRegister("8ISEW", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $659cd5008367dae9$export$42af8c323be37587; }, function (v) { return $659cd5008367dae9$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $659cd5008367dae9$export$f405f72c701dad87; }, function (v) { return $659cd5008367dae9$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $659cd5008367dae9$export$42af8c323be37587;
var $659cd5008367dae9$export$f405f72c701dad87;
'use strict';

var $659cd5008367dae9$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $d092A = parcelRequire("d092A");
var $659cd5008367dae9$var$_require_codes = $d092A.codes, $659cd5008367dae9$var$ERR_INVALID_ARG_VALUE = $659cd5008367dae9$var$_require_codes.ERR_INVALID_ARG_VALUE, $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE = $659cd5008367dae9$var$_require_codes.ERR_INVALID_ARG_TYPE, $659cd5008367dae9$var$ERR_MISSING_ARGS = $659cd5008367dae9$var$_require_codes.ERR_MISSING_ARGS, $659cd5008367dae9$var$ERR_OUT_OF_RANGE = $659cd5008367dae9$var$_require_codes.ERR_OUT_OF_RANGE, $659cd5008367dae9$var$AbortError = $d092A.AbortError;

var $jYkoQ = parcelRequire("jYkoQ");
var $659cd5008367dae9$var$validateAbortSignal = $jYkoQ.validateAbortSignal, $659cd5008367dae9$var$validateInteger = $jYkoQ.validateInteger, $659cd5008367dae9$var$validateObject = $jYkoQ.validateObject;

var $659cd5008367dae9$var$kWeakHandler = (parcelRequire("4K8OX")).Symbol('kWeak');

var $659cd5008367dae9$var$kResistStopPropagation = (parcelRequire("4K8OX")).Symbol('kResistStopPropagation');

var $leSYr = parcelRequire("leSYr");
var $659cd5008367dae9$require$finished = $leSYr.finished;

var $5fFxF = parcelRequire("5fFxF");

var $aeA37 = parcelRequire("aeA37");
var $659cd5008367dae9$require$addAbortSignalNoValidate = $aeA37.addAbortSignalNoValidate;

var $eLqbm = parcelRequire("eLqbm");
var $659cd5008367dae9$var$isWritable = $eLqbm.isWritable, $659cd5008367dae9$var$isNodeStream = $eLqbm.isNodeStream;

var $659cd5008367dae9$require$deprecate = (parcelRequire("1FR2B")).deprecate;

var $659cd5008367dae9$var$ArrayPrototypePush = (parcelRequire("4K8OX")).ArrayPrototypePush, $659cd5008367dae9$var$Boolean = (parcelRequire("4K8OX")).Boolean, $659cd5008367dae9$var$MathFloor = (parcelRequire("4K8OX")).MathFloor, $659cd5008367dae9$var$Number = (parcelRequire("4K8OX")).Number, $659cd5008367dae9$var$NumberIsNaN = (parcelRequire("4K8OX")).NumberIsNaN, $659cd5008367dae9$var$Promise = (parcelRequire("4K8OX")).Promise, $659cd5008367dae9$var$PromiseReject = (parcelRequire("4K8OX")).PromiseReject, $659cd5008367dae9$var$PromiseResolve = (parcelRequire("4K8OX")).PromiseResolve, $659cd5008367dae9$var$PromisePrototypeThen = (parcelRequire("4K8OX")).PromisePrototypeThen, $659cd5008367dae9$var$Symbol = (parcelRequire("4K8OX")).Symbol;
var $659cd5008367dae9$var$kEmpty = $659cd5008367dae9$var$Symbol('kEmpty');
var $659cd5008367dae9$var$kEof = $659cd5008367dae9$var$Symbol('kEof');
function $659cd5008367dae9$var$compose(stream, options) {
    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
    if ($659cd5008367dae9$var$isNodeStream(stream) && !$659cd5008367dae9$var$isWritable(stream)) throw new $659cd5008367dae9$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $5fFxF(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $659cd5008367dae9$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $659cd5008367dae9$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $659cd5008367dae9$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $659cd5008367dae9$var$MathFloor(options.highWaterMark);
    $659cd5008367dae9$var$validateInteger(concurrency, 'options.concurrency', 1);
    $659cd5008367dae9$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $659cd5008367dae9$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $659cd5008367dae9$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $659cd5008367dae9$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $659cd5008367dae9$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $659cd5008367dae9$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $659cd5008367dae9$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($659cd5008367dae9$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $659cd5008367dae9$var$PromiseReject(err1);
                                $659cd5008367dae9$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("1FR2B")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($659cd5008367dae9$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $659cd5008367dae9$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $659cd5008367dae9$var$AbortError();
                        if (!(val !== $659cd5008367dae9$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $659cd5008367dae9$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $659cd5008367dae9$var$asIndexedPairs(options) {
    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $659cd5008367dae9$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $659cd5008367dae9$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($659cd5008367dae9$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $659cd5008367dae9$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $659cd5008367dae9$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $659cd5008367dae9$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($659cd5008367dae9$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $659cd5008367dae9$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $659cd5008367dae9$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($659cd5008367dae9$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $659cd5008367dae9$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $659cd5008367dae9$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $659cd5008367dae9$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $659cd5008367dae9$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($659cd5008367dae9$var$ERR_MISSING_ARGS);
function $659cd5008367dae9$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $659cd5008367dae9$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $659cd5008367dae9$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $659cd5008367dae9$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $659cd5008367dae9$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $659cd5008367dae9$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $659cd5008367dae9$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $659cd5008367dae9$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $659cd5008367dae9$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $659cd5008367dae9$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $659cd5008367dae9$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $659cd5008367dae9$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $659cd5008367dae9$var$flatMap(fn, options) {
    var values = $659cd5008367dae9$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $659cd5008367dae9$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $659cd5008367dae9$var$Number(number);
    if ($659cd5008367dae9$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $659cd5008367dae9$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $659cd5008367dae9$var$drop(number, options) {
    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
    number = $659cd5008367dae9$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $659cd5008367dae9$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $659cd5008367dae9$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $659cd5008367dae9$var$take(number, options) {
    if (options != null) $659cd5008367dae9$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $659cd5008367dae9$var$validateAbortSignal(options.signal, 'options.signal');
    number = $659cd5008367dae9$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $659cd5008367dae9$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $659cd5008367dae9$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$659cd5008367dae9$export$42af8c323be37587 = {
    asIndexedPairs: $659cd5008367dae9$require$deprecate($659cd5008367dae9$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $659cd5008367dae9$var$drop,
    filter: $659cd5008367dae9$var$filter,
    flatMap: $659cd5008367dae9$var$flatMap,
    map: $659cd5008367dae9$var$map,
    take: $659cd5008367dae9$var$take,
    compose: $659cd5008367dae9$var$compose
};
$659cd5008367dae9$export$f405f72c701dad87 = {
    every: $659cd5008367dae9$var$every,
    forEach: $659cd5008367dae9$var$forEach,
    reduce: $659cd5008367dae9$var$reduce,
    toArray: $659cd5008367dae9$var$toArray,
    some: $659cd5008367dae9$var$some,
    find: $659cd5008367dae9$var$find
};

});
parcelRegister("jYkoQ", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $e8a371db6c33e551$var$ArrayIsArray = $4K8OX.ArrayIsArray, $e8a371db6c33e551$var$ArrayPrototypeIncludes = $4K8OX.ArrayPrototypeIncludes, $e8a371db6c33e551$var$ArrayPrototypeJoin = $4K8OX.ArrayPrototypeJoin, $e8a371db6c33e551$var$ArrayPrototypeMap = $4K8OX.ArrayPrototypeMap, $e8a371db6c33e551$var$NumberIsInteger = $4K8OX.NumberIsInteger, $e8a371db6c33e551$var$NumberIsNaN = $4K8OX.NumberIsNaN, $e8a371db6c33e551$var$NumberMAX_SAFE_INTEGER = $4K8OX.NumberMAX_SAFE_INTEGER, $e8a371db6c33e551$var$NumberMIN_SAFE_INTEGER = $4K8OX.NumberMIN_SAFE_INTEGER, $e8a371db6c33e551$var$NumberParseInt = $4K8OX.NumberParseInt, $e8a371db6c33e551$var$ObjectPrototypeHasOwnProperty = $4K8OX.ObjectPrototypeHasOwnProperty, $e8a371db6c33e551$var$RegExpPrototypeExec = $4K8OX.RegExpPrototypeExec, $e8a371db6c33e551$var$String = $4K8OX.String, $e8a371db6c33e551$var$StringPrototypeToUpperCase = $4K8OX.StringPrototypeToUpperCase, $e8a371db6c33e551$var$StringPrototypeTrim = $4K8OX.StringPrototypeTrim;

var $d092A = parcelRequire("d092A");
var $e8a371db6c33e551$var$hideStackFrames = $d092A.hideStackFrames, $e8a371db6c33e551$var$_require_codes = $d092A.codes, $e8a371db6c33e551$var$ERR_SOCKET_BAD_PORT = $e8a371db6c33e551$var$_require_codes.ERR_SOCKET_BAD_PORT, $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE = $e8a371db6c33e551$var$_require_codes.ERR_INVALID_ARG_TYPE, $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE = $e8a371db6c33e551$var$_require_codes.ERR_INVALID_ARG_VALUE, $e8a371db6c33e551$var$ERR_OUT_OF_RANGE = $e8a371db6c33e551$var$_require_codes.ERR_OUT_OF_RANGE, $e8a371db6c33e551$var$ERR_UNKNOWN_SIGNAL = $e8a371db6c33e551$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $1FR2B = parcelRequire("1FR2B");
var $e8a371db6c33e551$require$normalizeEncoding = $1FR2B.normalizeEncoding;

var $1FR2B = parcelRequire("1FR2B");
var $e8a371db6c33e551$require$_require_types = $1FR2B.types;
var $e8a371db6c33e551$var$isAsyncFunction = $e8a371db6c33e551$require$_require_types.isAsyncFunction, $e8a371db6c33e551$var$isArrayBufferView = $e8a371db6c33e551$require$_require_types.isArrayBufferView;
var $e8a371db6c33e551$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e8a371db6c33e551$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e8a371db6c33e551$var$isUint32(value) {
    return value === value >>> 0;
}
var $e8a371db6c33e551$var$octalReg = /^[0-7]+$/;
var $e8a371db6c33e551$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e8a371db6c33e551$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e8a371db6c33e551$var$RegExpPrototypeExec($e8a371db6c33e551$var$octalReg, value) === null) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE(name, value, $e8a371db6c33e551$var$modeDesc);
        value = $e8a371db6c33e551$var$NumberParseInt(value, 8);
    }
    $e8a371db6c33e551$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $e8a371db6c33e551$var$validateInteger = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e8a371db6c33e551$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $e8a371db6c33e551$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e8a371db6c33e551$var$NumberIsInteger(value)) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $e8a371db6c33e551$var$validateInt32 = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e8a371db6c33e551$var$NumberIsInteger(value)) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $e8a371db6c33e551$var$validateUint32 = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e8a371db6c33e551$var$NumberIsInteger(value)) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e8a371db6c33e551$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e8a371db6c33e551$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e8a371db6c33e551$var$NumberIsNaN(value)) throw new $e8a371db6c33e551$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $e8a371db6c33e551$var$validateOneOf = $e8a371db6c33e551$var$hideStackFrames(function(value, name, oneOf) {
    if (!$e8a371db6c33e551$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $e8a371db6c33e551$var$ArrayPrototypeJoin($e8a371db6c33e551$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $e8a371db6c33e551$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e8a371db6c33e551$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e8a371db6c33e551$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e8a371db6c33e551$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $e8a371db6c33e551$var$validateObject = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $e8a371db6c33e551$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $e8a371db6c33e551$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $e8a371db6c33e551$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e8a371db6c33e551$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $e8a371db6c33e551$var$validateDictionary = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $e8a371db6c33e551$var$validateArray = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$e8a371db6c33e551$var$ArrayIsArray(value)) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e8a371db6c33e551$var$validateStringArray(value, name) {
    $e8a371db6c33e551$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e8a371db6c33e551$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e8a371db6c33e551$var$validateBooleanArray(value, name) {
    $e8a371db6c33e551$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e8a371db6c33e551$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e8a371db6c33e551$var$validateAbortSignalArray(value, name) {
    $e8a371db6c33e551$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e8a371db6c33e551$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e8a371db6c33e551$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $e8a371db6c33e551$var$validateString(signal, name);
    if ($e8a371db6c33e551$var$signals[signal] === undefined) {
        if ($e8a371db6c33e551$var$signals[$e8a371db6c33e551$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e8a371db6c33e551$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e8a371db6c33e551$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $e8a371db6c33e551$var$validateBuffer = $e8a371db6c33e551$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$e8a371db6c33e551$var$isArrayBufferView(buffer)) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e8a371db6c33e551$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $e8a371db6c33e551$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e8a371db6c33e551$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e8a371db6c33e551$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e8a371db6c33e551$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $e8a371db6c33e551$var$validateAbortSignal = $e8a371db6c33e551$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $e8a371db6c33e551$var$validateFunction = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $e8a371db6c33e551$var$validatePlainFunction = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $e8a371db6c33e551$var$isAsyncFunction(value)) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $e8a371db6c33e551$var$validateUndefined = $e8a371db6c33e551$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e8a371db6c33e551$var$validateUnion(value, name, union) {
    if (!$e8a371db6c33e551$var$ArrayPrototypeIncludes(union, value)) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_TYPE(name, "('".concat($e8a371db6c33e551$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $e8a371db6c33e551$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e8a371db6c33e551$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e8a371db6c33e551$var$RegExpPrototypeExec($e8a371db6c33e551$var$linkValueRegExp, value)) throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e8a371db6c33e551$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e8a371db6c33e551$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e8a371db6c33e551$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $e8a371db6c33e551$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e8a371db6c33e551$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e8a371db6c33e551$var$isInt32,
    isUint32: $e8a371db6c33e551$var$isUint32,
    parseFileMode: $e8a371db6c33e551$var$parseFileMode,
    validateArray: $e8a371db6c33e551$var$validateArray,
    validateStringArray: $e8a371db6c33e551$var$validateStringArray,
    validateBooleanArray: $e8a371db6c33e551$var$validateBooleanArray,
    validateAbortSignalArray: $e8a371db6c33e551$var$validateAbortSignalArray,
    validateBoolean: $e8a371db6c33e551$var$validateBoolean,
    validateBuffer: $e8a371db6c33e551$var$validateBuffer,
    validateDictionary: $e8a371db6c33e551$var$validateDictionary,
    validateEncoding: $e8a371db6c33e551$var$validateEncoding,
    validateFunction: $e8a371db6c33e551$var$validateFunction,
    validateInt32: $e8a371db6c33e551$var$validateInt32,
    validateInteger: $e8a371db6c33e551$var$validateInteger,
    validateNumber: $e8a371db6c33e551$var$validateNumber,
    validateObject: $e8a371db6c33e551$var$validateObject,
    validateOneOf: $e8a371db6c33e551$var$validateOneOf,
    validatePlainFunction: $e8a371db6c33e551$var$validatePlainFunction,
    validatePort: $e8a371db6c33e551$var$validatePort,
    validateSignalName: $e8a371db6c33e551$var$validateSignalName,
    validateString: $e8a371db6c33e551$var$validateString,
    validateUint32: $e8a371db6c33e551$var$validateUint32,
    validateUndefined: $e8a371db6c33e551$var$validateUndefined,
    validateUnion: $e8a371db6c33e551$var$validateUnion,
    validateAbortSignal: $e8a371db6c33e551$var$validateAbortSignal,
    validateLinkHeaderValue: $e8a371db6c33e551$var$validateLinkHeaderValue
};

});

parcelRegister("leSYr", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $d092A = parcelRequire("d092A");
/* replacement end */ var $f7658c772126610d$var$AbortError = $d092A.AbortError, $f7658c772126610d$var$codes = $d092A.codes;
var $f7658c772126610d$var$ERR_INVALID_ARG_TYPE = $f7658c772126610d$var$codes.ERR_INVALID_ARG_TYPE, $f7658c772126610d$var$ERR_STREAM_PREMATURE_CLOSE = $f7658c772126610d$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $f7658c772126610d$var$kEmptyObject = (parcelRequire("1FR2B")).kEmptyObject, $f7658c772126610d$var$once = (parcelRequire("1FR2B")).once;

var $jYkoQ = parcelRequire("jYkoQ");
var $f7658c772126610d$var$validateAbortSignal = $jYkoQ.validateAbortSignal, $f7658c772126610d$var$validateFunction = $jYkoQ.validateFunction, $f7658c772126610d$var$validateObject = $jYkoQ.validateObject, $f7658c772126610d$var$validateBoolean = $jYkoQ.validateBoolean;

var $4K8OX = parcelRequire("4K8OX");
var $f7658c772126610d$var$Promise = $4K8OX.Promise, $f7658c772126610d$var$PromisePrototypeThen = $4K8OX.PromisePrototypeThen, $f7658c772126610d$var$SymbolDispose = $4K8OX.SymbolDispose;

var $eLqbm = parcelRequire("eLqbm");
var $f7658c772126610d$var$isClosed = $eLqbm.isClosed, $f7658c772126610d$var$isReadable = $eLqbm.isReadable, $f7658c772126610d$var$isReadableNodeStream = $eLqbm.isReadableNodeStream, $f7658c772126610d$var$isReadableStream = $eLqbm.isReadableStream, $f7658c772126610d$var$isReadableFinished = $eLqbm.isReadableFinished, $f7658c772126610d$var$isReadableErrored = $eLqbm.isReadableErrored, $f7658c772126610d$var$isWritable = $eLqbm.isWritable, $f7658c772126610d$var$isWritableNodeStream = $eLqbm.isWritableNodeStream, $f7658c772126610d$var$isWritableStream = $eLqbm.isWritableStream, $f7658c772126610d$var$isWritableFinished = $eLqbm.isWritableFinished, $f7658c772126610d$var$isWritableErrored = $eLqbm.isWritableErrored, $f7658c772126610d$var$isNodeStream = $eLqbm.isNodeStream, $f7658c772126610d$var$_willEmitClose = $eLqbm.willEmitClose, $f7658c772126610d$var$kIsClosedPromise = $eLqbm.kIsClosedPromise;
var $f7658c772126610d$var$addAbortListener;
function $f7658c772126610d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $f7658c772126610d$var$nop = function() {};

function $f7658c772126610d$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $f7658c772126610d$var$kEmptyObject;
    } else if (options == null) options = $f7658c772126610d$var$kEmptyObject;
    else $f7658c772126610d$var$validateObject(options, 'options');
    $f7658c772126610d$var$validateFunction(callback, 'callback');
    $f7658c772126610d$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $f7658c772126610d$var$once(callback);
    if ($f7658c772126610d$var$isReadableStream(stream) || $f7658c772126610d$var$isWritableStream(stream)) return $f7658c772126610d$var$eosWeb(stream, options, callback);
    if (!$f7658c772126610d$var$isNodeStream(stream)) throw new $f7658c772126610d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $f7658c772126610d$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $f7658c772126610d$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $f7658c772126610d$var$_willEmitClose(stream) && $f7658c772126610d$var$isReadableNodeStream(stream) === readable && $f7658c772126610d$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $f7658c772126610d$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $f7658c772126610d$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $f7658c772126610d$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $f7658c772126610d$var$isWritableErrored(stream) || $f7658c772126610d$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $f7658c772126610d$var$isReadableNodeStream(stream, true)) {
            if (!$f7658c772126610d$var$isReadableFinished(stream, false)) return callback.call(stream, new $f7658c772126610d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$f7658c772126610d$var$isWritableFinished(stream, false)) return callback.call(stream, new $f7658c772126610d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $f7658c772126610d$var$isWritableErrored(stream) || $f7658c772126610d$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($f7658c772126610d$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $f7658c772126610d$var$isReadable(stream)) && (writableFinished || $f7658c772126610d$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $f7658c772126610d$var$isWritable(stream)) && (readableFinished || $f7658c772126610d$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $f7658c772126610d$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $f7658c772126610d$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $f7658c772126610d$var$addAbortListener = $f7658c772126610d$var$addAbortListener || (parcelRequire("1FR2B")).addAbortListener;
            var disposable = $f7658c772126610d$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $f7658c772126610d$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$f7658c772126610d$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $f7658c772126610d$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $f7658c772126610d$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $f7658c772126610d$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $f7658c772126610d$var$addAbortListener = $f7658c772126610d$var$addAbortListener || (parcelRequire("1FR2B")).addAbortListener;
            var disposable = $f7658c772126610d$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $f7658c772126610d$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$f7658c772126610d$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $f7658c772126610d$var$PromisePrototypeThen(stream[$f7658c772126610d$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $f7658c772126610d$var$nop;
}
function $f7658c772126610d$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $f7658c772126610d$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $f7658c772126610d$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $f7658c772126610d$var$Promise(function(resolve, reject) {
        var cleanup = $f7658c772126610d$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $f7658c772126610d$var$eos;
module.exports.finished = $f7658c772126610d$var$finished;

});
parcelRegister("eLqbm", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $abf9c3be98a1a231$var$SymbolAsyncIterator = $4K8OX.SymbolAsyncIterator, $abf9c3be98a1a231$var$SymbolIterator = $4K8OX.SymbolIterator, $abf9c3be98a1a231$var$SymbolFor = $4K8OX.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $abf9c3be98a1a231$var$kIsDestroyed = $abf9c3be98a1a231$var$SymbolFor('nodejs.stream.destroyed');
var $abf9c3be98a1a231$var$kIsErrored = $abf9c3be98a1a231$var$SymbolFor('nodejs.stream.errored');
var $abf9c3be98a1a231$var$kIsReadable = $abf9c3be98a1a231$var$SymbolFor('nodejs.stream.readable');
var $abf9c3be98a1a231$var$kIsWritable = $abf9c3be98a1a231$var$SymbolFor('nodejs.stream.writable');
var $abf9c3be98a1a231$var$kIsDisturbed = $abf9c3be98a1a231$var$SymbolFor('nodejs.stream.disturbed');
var $abf9c3be98a1a231$var$kIsClosedPromise = $abf9c3be98a1a231$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $abf9c3be98a1a231$var$kControllerErrorFunction = $abf9c3be98a1a231$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $abf9c3be98a1a231$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $abf9c3be98a1a231$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $abf9c3be98a1a231$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $abf9c3be98a1a231$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $abf9c3be98a1a231$var$isReadableStream(obj) {
    return !!(obj && !$abf9c3be98a1a231$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $abf9c3be98a1a231$var$isWritableStream(obj) {
    return !!(obj && !$abf9c3be98a1a231$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $abf9c3be98a1a231$var$isTransformStream(obj) {
    return !!(obj && !$abf9c3be98a1a231$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $abf9c3be98a1a231$var$isWebStream(obj) {
    return $abf9c3be98a1a231$var$isReadableStream(obj) || $abf9c3be98a1a231$var$isWritableStream(obj) || $abf9c3be98a1a231$var$isTransformStream(obj);
}
function $abf9c3be98a1a231$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$abf9c3be98a1a231$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$abf9c3be98a1a231$var$SymbolIterator] === 'function';
    return typeof obj[$abf9c3be98a1a231$var$SymbolAsyncIterator] === 'function' || typeof obj[$abf9c3be98a1a231$var$SymbolIterator] === 'function';
}
function $abf9c3be98a1a231$var$isDestroyed(stream) {
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$abf9c3be98a1a231$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $abf9c3be98a1a231$var$isWritableEnded(stream) {
    if (!$abf9c3be98a1a231$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $abf9c3be98a1a231$var$isWritableFinished(stream, strict) {
    if (!$abf9c3be98a1a231$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $abf9c3be98a1a231$var$isReadableEnded(stream) {
    if (!$abf9c3be98a1a231$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $abf9c3be98a1a231$var$isReadableFinished(stream, strict) {
    if (!$abf9c3be98a1a231$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $abf9c3be98a1a231$var$isReadable(stream) {
    if (stream && stream[$abf9c3be98a1a231$var$kIsReadable] != null) return stream[$abf9c3be98a1a231$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($abf9c3be98a1a231$var$isDestroyed(stream)) return false;
    return $abf9c3be98a1a231$var$isReadableNodeStream(stream) && stream.readable && !$abf9c3be98a1a231$var$isReadableFinished(stream);
}
function $abf9c3be98a1a231$var$isWritable(stream) {
    if (stream && stream[$abf9c3be98a1a231$var$kIsWritable] != null) return stream[$abf9c3be98a1a231$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($abf9c3be98a1a231$var$isDestroyed(stream)) return false;
    return $abf9c3be98a1a231$var$isWritableNodeStream(stream) && stream.writable && !$abf9c3be98a1a231$var$isWritableEnded(stream);
}
function $abf9c3be98a1a231$var$isFinished(stream, opts) {
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    if ($abf9c3be98a1a231$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $abf9c3be98a1a231$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $abf9c3be98a1a231$var$isWritable(stream)) return false;
    return true;
}
function $abf9c3be98a1a231$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $abf9c3be98a1a231$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $abf9c3be98a1a231$var$isClosed(stream) {
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $abf9c3be98a1a231$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $abf9c3be98a1a231$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $abf9c3be98a1a231$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $abf9c3be98a1a231$var$isOutgoingMessage(stream);
}
function $abf9c3be98a1a231$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $abf9c3be98a1a231$var$willEmitClose(stream) {
    if (!$abf9c3be98a1a231$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $abf9c3be98a1a231$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $abf9c3be98a1a231$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$abf9c3be98a1a231$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $abf9c3be98a1a231$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$abf9c3be98a1a231$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $abf9c3be98a1a231$var$isDestroyed,
    kIsDestroyed: $abf9c3be98a1a231$var$kIsDestroyed,
    isDisturbed: $abf9c3be98a1a231$var$isDisturbed,
    kIsDisturbed: $abf9c3be98a1a231$var$kIsDisturbed,
    isErrored: $abf9c3be98a1a231$var$isErrored,
    kIsErrored: $abf9c3be98a1a231$var$kIsErrored,
    isReadable: $abf9c3be98a1a231$var$isReadable,
    kIsReadable: $abf9c3be98a1a231$var$kIsReadable,
    kIsClosedPromise: $abf9c3be98a1a231$var$kIsClosedPromise,
    kControllerErrorFunction: $abf9c3be98a1a231$var$kControllerErrorFunction,
    kIsWritable: $abf9c3be98a1a231$var$kIsWritable,
    isClosed: $abf9c3be98a1a231$var$isClosed,
    isDuplexNodeStream: $abf9c3be98a1a231$var$isDuplexNodeStream,
    isFinished: $abf9c3be98a1a231$var$isFinished,
    isIterable: $abf9c3be98a1a231$var$isIterable,
    isReadableNodeStream: $abf9c3be98a1a231$var$isReadableNodeStream,
    isReadableStream: $abf9c3be98a1a231$var$isReadableStream,
    isReadableEnded: $abf9c3be98a1a231$var$isReadableEnded,
    isReadableFinished: $abf9c3be98a1a231$var$isReadableFinished,
    isReadableErrored: $abf9c3be98a1a231$var$isReadableErrored,
    isNodeStream: $abf9c3be98a1a231$var$isNodeStream,
    isWebStream: $abf9c3be98a1a231$var$isWebStream,
    isWritable: $abf9c3be98a1a231$var$isWritable,
    isWritableNodeStream: $abf9c3be98a1a231$var$isWritableNodeStream,
    isWritableStream: $abf9c3be98a1a231$var$isWritableStream,
    isWritableEnded: $abf9c3be98a1a231$var$isWritableEnded,
    isWritableFinished: $abf9c3be98a1a231$var$isWritableFinished,
    isWritableErrored: $abf9c3be98a1a231$var$isWritableErrored,
    isServerRequest: $abf9c3be98a1a231$var$isServerRequest,
    isServerResponse: $abf9c3be98a1a231$var$isServerResponse,
    willEmitClose: $abf9c3be98a1a231$var$willEmitClose,
    isTransformStream: $abf9c3be98a1a231$var$isTransformStream
};

});


parcelRegister("5fFxF", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $aXKB2 = parcelRequire("aXKB2");
var $3d2e93d2e76812e6$require$pipeline = $aXKB2.pipeline;

var $29VwN = parcelRequire("29VwN");

var $jnNYa = parcelRequire("jnNYa");
var $3d2e93d2e76812e6$require$destroyer = $jnNYa.destroyer;

var $eLqbm = parcelRequire("eLqbm");
var $3d2e93d2e76812e6$var$isNodeStream = $eLqbm.isNodeStream, $3d2e93d2e76812e6$var$isReadable = $eLqbm.isReadable, $3d2e93d2e76812e6$var$isWritable = $eLqbm.isWritable, $3d2e93d2e76812e6$var$isWebStream = $eLqbm.isWebStream, $3d2e93d2e76812e6$var$isTransformStream = $eLqbm.isTransformStream, $3d2e93d2e76812e6$var$isWritableStream = $eLqbm.isWritableStream, $3d2e93d2e76812e6$var$isReadableStream = $eLqbm.isReadableStream;

var $d092A = parcelRequire("d092A");
var $3d2e93d2e76812e6$var$AbortError = $d092A.AbortError, $3d2e93d2e76812e6$var$_require_codes = $d092A.codes, $3d2e93d2e76812e6$var$ERR_INVALID_ARG_VALUE = $3d2e93d2e76812e6$var$_require_codes.ERR_INVALID_ARG_VALUE, $3d2e93d2e76812e6$var$ERR_MISSING_ARGS = $3d2e93d2e76812e6$var$_require_codes.ERR_MISSING_ARGS;

var $leSYr = parcelRequire("leSYr");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $3d2e93d2e76812e6$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $29VwN.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $29VwN.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $29VwN.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$3d2e93d2e76812e6$var$isNodeStream(streams[n]) && !$3d2e93d2e76812e6$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($3d2e93d2e76812e6$var$isReadable(streams[n]) || $3d2e93d2e76812e6$var$isReadableStream(streams[n]) || $3d2e93d2e76812e6$var$isTransformStream(streams[n]))) throw new $3d2e93d2e76812e6$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($3d2e93d2e76812e6$var$isWritable(streams[n]) || $3d2e93d2e76812e6$var$isWritableStream(streams[n]) || $3d2e93d2e76812e6$var$isTransformStream(streams[n]))) throw new $3d2e93d2e76812e6$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $3d2e93d2e76812e6$require$pipeline(streams, onfinished);
    var writable = !!($3d2e93d2e76812e6$var$isWritable(head) || $3d2e93d2e76812e6$var$isWritableStream(head) || $3d2e93d2e76812e6$var$isTransformStream(head));
    var readable = !!($3d2e93d2e76812e6$var$isReadable(tail) || $3d2e93d2e76812e6$var$isReadableStream(tail) || $3d2e93d2e76812e6$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $29VwN({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($3d2e93d2e76812e6$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($3d2e93d2e76812e6$var$isWebStream(head)) {
            var writable1 = $3d2e93d2e76812e6$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $3d2e93d2e76812e6$var$isTransformStream(tail) ? tail.readable : tail;
        $leSYr(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($3d2e93d2e76812e6$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($3d2e93d2e76812e6$var$isWebStream(tail)) {
            var readable1 = $3d2e93d2e76812e6$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $3d2e93d2e76812e6$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($3d2e93d2e76812e6$var$isNodeStream(tail)) $3d2e93d2e76812e6$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("aXKB2", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $7fb38f2a7bd0c744$var$ArrayIsArray = $4K8OX.ArrayIsArray, $7fb38f2a7bd0c744$var$Promise = $4K8OX.Promise, $7fb38f2a7bd0c744$var$SymbolAsyncIterator = $4K8OX.SymbolAsyncIterator, $7fb38f2a7bd0c744$var$SymbolDispose = $4K8OX.SymbolDispose;

var $leSYr = parcelRequire("leSYr");

var $7fb38f2a7bd0c744$require$once = (parcelRequire("1FR2B")).once;

var $jnNYa = parcelRequire("jnNYa");

var $29VwN = parcelRequire("29VwN");

var $d092A = parcelRequire("d092A");
var $7fb38f2a7bd0c744$var$aggregateTwoErrors = $d092A.aggregateTwoErrors, $7fb38f2a7bd0c744$var$_require_codes = $d092A.codes, $7fb38f2a7bd0c744$var$ERR_INVALID_ARG_TYPE = $7fb38f2a7bd0c744$var$_require_codes.ERR_INVALID_ARG_TYPE, $7fb38f2a7bd0c744$var$ERR_INVALID_RETURN_VALUE = $7fb38f2a7bd0c744$var$_require_codes.ERR_INVALID_RETURN_VALUE, $7fb38f2a7bd0c744$var$ERR_MISSING_ARGS = $7fb38f2a7bd0c744$var$_require_codes.ERR_MISSING_ARGS, $7fb38f2a7bd0c744$var$ERR_STREAM_DESTROYED = $7fb38f2a7bd0c744$var$_require_codes.ERR_STREAM_DESTROYED, $7fb38f2a7bd0c744$var$ERR_STREAM_PREMATURE_CLOSE = $7fb38f2a7bd0c744$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $7fb38f2a7bd0c744$var$AbortError = $d092A.AbortError;

var $jYkoQ = parcelRequire("jYkoQ");
var $7fb38f2a7bd0c744$var$validateFunction = $jYkoQ.validateFunction, $7fb38f2a7bd0c744$var$validateAbortSignal = $jYkoQ.validateAbortSignal;

var $eLqbm = parcelRequire("eLqbm");
var $7fb38f2a7bd0c744$var$isIterable = $eLqbm.isIterable, $7fb38f2a7bd0c744$var$isReadable = $eLqbm.isReadable, $7fb38f2a7bd0c744$var$isReadableNodeStream = $eLqbm.isReadableNodeStream, $7fb38f2a7bd0c744$var$isNodeStream = $eLqbm.isNodeStream, $7fb38f2a7bd0c744$var$isTransformStream = $eLqbm.isTransformStream, $7fb38f2a7bd0c744$var$isWebStream = $eLqbm.isWebStream, $7fb38f2a7bd0c744$var$isReadableStream = $eLqbm.isReadableStream, $7fb38f2a7bd0c744$var$isReadableFinished = $eLqbm.isReadableFinished;

var $7fb38f2a7bd0c744$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $7fb38f2a7bd0c744$var$PassThrough;
var $7fb38f2a7bd0c744$var$Readable;
var $7fb38f2a7bd0c744$var$addAbortListener;
function $7fb38f2a7bd0c744$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $leSYr(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $jnNYa.destroyer(stream, err || new $7fb38f2a7bd0c744$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $7fb38f2a7bd0c744$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $7fb38f2a7bd0c744$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $7fb38f2a7bd0c744$var$makeAsyncIterable(val) {
    if ($7fb38f2a7bd0c744$var$isIterable(val)) return val;
    else if ($7fb38f2a7bd0c744$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $7fb38f2a7bd0c744$var$fromReadable(val);
    throw new $7fb38f2a7bd0c744$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $7fb38f2a7bd0c744$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7fb38f2a7bd0c744$var$Readable) $7fb38f2a7bd0c744$var$Readable = (parcelRequire("84Uuw"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($7fb38f2a7bd0c744$var$Readable.prototype[$7fb38f2a7bd0c744$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7fb38f2a7bd0c744$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $7fb38f2a7bd0c744$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $leSYr(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $7fb38f2a7bd0c744$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7fb38f2a7bd0c744$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($7fb38f2a7bd0c744$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7fb38f2a7bd0c744$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $7fb38f2a7bd0c744$var$pipelineImpl(streams, $7fb38f2a7bd0c744$require$once($7fb38f2a7bd0c744$var$popCallback(streams)));
}


function $7fb38f2a7bd0c744$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($7fb38f2a7bd0c744$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $7fb38f2a7bd0c744$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($7fb38f2a7bd0c744$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($7fb38f2a7bd0c744$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$7fb38f2a7bd0c744$var$isIterable(ret)) throw new $7fb38f2a7bd0c744$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($7fb38f2a7bd0c744$var$isIterable(stream) || $7fb38f2a7bd0c744$var$isReadableNodeStream(stream) || $7fb38f2a7bd0c744$var$isTransformStream(stream)) ret = stream;
            else ret = $29VwN.from(stream);
        } else if (typeof stream === 'function') {
            if ($7fb38f2a7bd0c744$var$isTransformStream(ret)) {
                var _ret;
                ret = $7fb38f2a7bd0c744$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $7fb38f2a7bd0c744$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$7fb38f2a7bd0c744$var$isIterable(ret, true)) throw new $7fb38f2a7bd0c744$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$7fb38f2a7bd0c744$var$PassThrough) $7fb38f2a7bd0c744$var$PassThrough = (parcelRequire("iVKMH"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $7fb38f2a7bd0c744$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($7fb38f2a7bd0c744$var$isIterable(ret, true)) {
                    finishCount++;
                    $7fb38f2a7bd0c744$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($7fb38f2a7bd0c744$var$isReadableStream(ret) || $7fb38f2a7bd0c744$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $7fb38f2a7bd0c744$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $7fb38f2a7bd0c744$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $7fb38f2a7bd0c744$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($7fb38f2a7bd0c744$var$isNodeStream(stream)) {
            if ($7fb38f2a7bd0c744$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $7fb38f2a7bd0c744$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($7fb38f2a7bd0c744$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($7fb38f2a7bd0c744$var$isTransformStream(ret) || $7fb38f2a7bd0c744$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $7fb38f2a7bd0c744$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($7fb38f2a7bd0c744$var$isIterable(ret)) {
                finishCount++;
                $7fb38f2a7bd0c744$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $7fb38f2a7bd0c744$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($7fb38f2a7bd0c744$var$isWebStream(stream)) {
            if ($7fb38f2a7bd0c744$var$isReadableNodeStream(ret)) {
                finishCount++;
                $7fb38f2a7bd0c744$var$pumpToWeb($7fb38f2a7bd0c744$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($7fb38f2a7bd0c744$var$isReadableStream(ret) || $7fb38f2a7bd0c744$var$isIterable(ret)) {
                finishCount++;
                $7fb38f2a7bd0c744$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($7fb38f2a7bd0c744$var$isTransformStream(ret)) {
                finishCount++;
                $7fb38f2a7bd0c744$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $7fb38f2a7bd0c744$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $29VwN.from(stream);
    };
    if (streams.length === 1 && $7fb38f2a7bd0c744$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7fb38f2a7bd0c744$var$ERR_MISSING_ARGS('streams');
    var ac = new $7fb38f2a7bd0c744$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $7fb38f2a7bd0c744$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $7fb38f2a7bd0c744$var$AbortError());
    }
    $7fb38f2a7bd0c744$var$addAbortListener = $7fb38f2a7bd0c744$var$addAbortListener || (parcelRequire("1FR2B")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $7fb38f2a7bd0c744$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$7fb38f2a7bd0c744$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $7fb38f2a7bd0c744$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $7fb38f2a7bd0c744$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($7fb38f2a7bd0c744$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $leSYr(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $leSYr(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $7fb38f2a7bd0c744$var$pipelineImpl,
    pipeline: $7fb38f2a7bd0c744$var$pipeline
};

});
parcelRegister("jnNYa", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $d092A = parcelRequire("d092A");
/* replacement end */ var $e1c6ed31d9bc8361$var$aggregateTwoErrors = $d092A.aggregateTwoErrors, $e1c6ed31d9bc8361$var$ERR_MULTIPLE_CALLBACK = $d092A.codes.ERR_MULTIPLE_CALLBACK, $e1c6ed31d9bc8361$var$AbortError = $d092A.AbortError;

var $4K8OX = parcelRequire("4K8OX");
var $e1c6ed31d9bc8361$require$Symbol = $4K8OX.Symbol;

var $eLqbm = parcelRequire("eLqbm");
var $e1c6ed31d9bc8361$var$kIsDestroyed = $eLqbm.kIsDestroyed, $e1c6ed31d9bc8361$var$isDestroyed = $eLqbm.isDestroyed, $e1c6ed31d9bc8361$var$isFinished = $eLqbm.isFinished, $e1c6ed31d9bc8361$var$isServerRequest = $eLqbm.isServerRequest;
var $e1c6ed31d9bc8361$var$kDestroy = $e1c6ed31d9bc8361$require$Symbol('kDestroy');
var $e1c6ed31d9bc8361$var$kConstruct = $e1c6ed31d9bc8361$require$Symbol('kConstruct');
function $e1c6ed31d9bc8361$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $e1c6ed31d9bc8361$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $e1c6ed31d9bc8361$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($e1c6ed31d9bc8361$var$kDestroy, function(er) {
        $e1c6ed31d9bc8361$var$_destroy(this, $e1c6ed31d9bc8361$var$aggregateTwoErrors(er, err), cb);
    });
    else $e1c6ed31d9bc8361$var$_destroy(this, err, cb);
    return this;
}
function $e1c6ed31d9bc8361$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $e1c6ed31d9bc8361$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $e1c6ed31d9bc8361$var$emitErrorCloseNT(self, err) {
    $e1c6ed31d9bc8361$var$emitErrorNT(self, err);
    $e1c6ed31d9bc8361$var$emitCloseNT(self);
}
function $e1c6ed31d9bc8361$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $e1c6ed31d9bc8361$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $e1c6ed31d9bc8361$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $e1c6ed31d9bc8361$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitErrorNT, stream, err);
        else $e1c6ed31d9bc8361$var$emitErrorNT(stream, err);
    }
}
function $e1c6ed31d9bc8361$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($e1c6ed31d9bc8361$var$kConstruct, cb);
    if (stream.listenerCount($e1c6ed31d9bc8361$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($e1c6ed31d9bc8361$var$constructNT, stream);
}
function $e1c6ed31d9bc8361$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $e1c6ed31d9bc8361$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $e1c6ed31d9bc8361$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($e1c6ed31d9bc8361$var$kDestroy, err);
        else if (err) $e1c6ed31d9bc8361$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $e1c6ed31d9bc8361$var$emitConstructNT(stream) {
    stream.emit($e1c6ed31d9bc8361$var$kConstruct);
}
function $e1c6ed31d9bc8361$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $e1c6ed31d9bc8361$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $e1c6ed31d9bc8361$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $e1c6ed31d9bc8361$var$destroyer(stream, err) {
    if (!stream || $e1c6ed31d9bc8361$var$isDestroyed(stream)) return;
    if (!err && !$e1c6ed31d9bc8361$var$isFinished(stream)) err = new $e1c6ed31d9bc8361$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($e1c6ed31d9bc8361$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($e1c6ed31d9bc8361$var$isRequest(stream)) stream.abort();
    else if ($e1c6ed31d9bc8361$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($e1c6ed31d9bc8361$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$e1c6ed31d9bc8361$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $e1c6ed31d9bc8361$var$construct,
    destroyer: $e1c6ed31d9bc8361$var$destroyer,
    destroy: $e1c6ed31d9bc8361$var$destroy,
    undestroy: $e1c6ed31d9bc8361$var$undestroy,
    errorOrDestroy: $e1c6ed31d9bc8361$var$errorOrDestroy
};

});

parcelRegister("29VwN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $19290be3b633c728$var$ObjectDefineProperties = $4K8OX.ObjectDefineProperties, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor = $4K8OX.ObjectGetOwnPropertyDescriptor, $19290be3b633c728$var$ObjectKeys = $4K8OX.ObjectKeys, $19290be3b633c728$var$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf;
module.exports = $19290be3b633c728$var$Duplex;

var $84Uuw = parcelRequire("84Uuw");

var $b2yGi = parcelRequire("b2yGi");
$19290be3b633c728$var$ObjectSetPrototypeOf($19290be3b633c728$var$Duplex.prototype, $84Uuw.prototype);
$19290be3b633c728$var$ObjectSetPrototypeOf($19290be3b633c728$var$Duplex, $84Uuw);
{
    var $19290be3b633c728$var$keys = $19290be3b633c728$var$ObjectKeys($b2yGi.prototype);
    // Allow the keys array to be GC'ed.
    for(var $19290be3b633c728$var$i = 0; $19290be3b633c728$var$i < $19290be3b633c728$var$keys.length; $19290be3b633c728$var$i++){
        var $19290be3b633c728$var$method = $19290be3b633c728$var$keys[$19290be3b633c728$var$i];
        if (!$19290be3b633c728$var$Duplex.prototype[$19290be3b633c728$var$method]) $19290be3b633c728$var$Duplex.prototype[$19290be3b633c728$var$method] = $b2yGi.prototype[$19290be3b633c728$var$method];
    }
}function $19290be3b633c728$var$Duplex(options) {
    if (!(this instanceof $19290be3b633c728$var$Duplex)) return new $19290be3b633c728$var$Duplex(options);
    $84Uuw.call(this, options);
    $b2yGi.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$19290be3b633c728$var$ObjectDefineProperties($19290be3b633c728$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $19290be3b633c728$var$ObjectGetOwnPropertyDescriptor($b2yGi.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $19290be3b633c728$var$webStreamsAdapters;
// Lazy to avoid circular references
function $19290be3b633c728$var$lazyWebStreams() {
    if ($19290be3b633c728$var$webStreamsAdapters === undefined) $19290be3b633c728$var$webStreamsAdapters = {};
    return $19290be3b633c728$var$webStreamsAdapters;
}
$19290be3b633c728$var$Duplex.fromWeb = function(pair, options) {
    return $19290be3b633c728$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$19290be3b633c728$var$Duplex.toWeb = function(duplex) {
    return $19290be3b633c728$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $19290be3b633c728$var$duplexify;

$19290be3b633c728$var$Duplex.from = function(body) {
    if (!$19290be3b633c728$var$duplexify) $19290be3b633c728$var$duplexify = (parcelRequire("kJljR"));
    return $19290be3b633c728$var$duplexify(body, 'body');
};

});
parcelRegister("84Uuw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4K8OX = parcelRequire("4K8OX");
/* replacement end */ var $01848e8604ba482b$var$ArrayPrototypeIndexOf = $4K8OX.ArrayPrototypeIndexOf, $01848e8604ba482b$var$NumberIsInteger = $4K8OX.NumberIsInteger, $01848e8604ba482b$var$NumberIsNaN = $4K8OX.NumberIsNaN, $01848e8604ba482b$var$NumberParseInt = $4K8OX.NumberParseInt, $01848e8604ba482b$var$ObjectDefineProperties = $4K8OX.ObjectDefineProperties, $01848e8604ba482b$var$ObjectKeys = $4K8OX.ObjectKeys, $01848e8604ba482b$var$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf, $01848e8604ba482b$var$Promise = $4K8OX.Promise, $01848e8604ba482b$var$SafeSet = $4K8OX.SafeSet, $01848e8604ba482b$var$SymbolAsyncDispose = $4K8OX.SymbolAsyncDispose, $01848e8604ba482b$var$SymbolAsyncIterator = $4K8OX.SymbolAsyncIterator, $01848e8604ba482b$var$Symbol = $4K8OX.Symbol;
module.exports = $01848e8604ba482b$var$Readable;
$01848e8604ba482b$var$Readable.ReadableState = $01848e8604ba482b$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $01848e8604ba482b$var$EE = $bBoAO.EventEmitter;

var $8N5gC = parcelRequire("8N5gC");
var $01848e8604ba482b$var$Stream = $8N5gC.Stream, $01848e8604ba482b$var$prependListener = $8N5gC.prependListener;

var $5EQ4X = parcelRequire("5EQ4X");
var $01848e8604ba482b$require$Buffer = $5EQ4X.Buffer;

var $aeA37 = parcelRequire("aeA37");
var $01848e8604ba482b$require$addAbortSignal = $aeA37.addAbortSignal;

var $leSYr = parcelRequire("leSYr");

var $01848e8604ba482b$var$debug = (parcelRequire("1FR2B")).debuglog('stream', function(fn) {
    $01848e8604ba482b$var$debug = fn;
});

var $4igrv = parcelRequire("4igrv");

var $jnNYa = parcelRequire("jnNYa");

var $4Gyqa = parcelRequire("4Gyqa");
var $01848e8604ba482b$var$getHighWaterMark = $4Gyqa.getHighWaterMark, $01848e8604ba482b$var$getDefaultHighWaterMark = $4Gyqa.getDefaultHighWaterMark;

var $d092A = parcelRequire("d092A");
var $01848e8604ba482b$var$aggregateTwoErrors = $d092A.aggregateTwoErrors, $01848e8604ba482b$var$_require_codes = $d092A.codes, $01848e8604ba482b$var$ERR_INVALID_ARG_TYPE = $01848e8604ba482b$var$_require_codes.ERR_INVALID_ARG_TYPE, $01848e8604ba482b$var$ERR_METHOD_NOT_IMPLEMENTED = $01848e8604ba482b$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $01848e8604ba482b$var$ERR_OUT_OF_RANGE = $01848e8604ba482b$var$_require_codes.ERR_OUT_OF_RANGE, $01848e8604ba482b$var$ERR_STREAM_PUSH_AFTER_EOF = $01848e8604ba482b$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $01848e8604ba482b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $01848e8604ba482b$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $01848e8604ba482b$var$AbortError = $d092A.AbortError;

var $jYkoQ = parcelRequire("jYkoQ");
var $01848e8604ba482b$require$validateObject = $jYkoQ.validateObject;
var $01848e8604ba482b$var$kPaused = $01848e8604ba482b$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $01848e8604ba482b$require$StringDecoder = $3Jf7C.StringDecoder;

var $eS7aQ = parcelRequire("eS7aQ");
$01848e8604ba482b$var$ObjectSetPrototypeOf($01848e8604ba482b$var$Readable.prototype, $01848e8604ba482b$var$Stream.prototype);
$01848e8604ba482b$var$ObjectSetPrototypeOf($01848e8604ba482b$var$Readable, $01848e8604ba482b$var$Stream);
var $01848e8604ba482b$var$nop = function() {};
var $01848e8604ba482b$var$errorOrDestroy = $jnNYa.errorOrDestroy;
var $01848e8604ba482b$var$kObjectMode = 1;
var $01848e8604ba482b$var$kEnded = 2;
var $01848e8604ba482b$var$kEndEmitted = 4;
var $01848e8604ba482b$var$kReading = 8;
var $01848e8604ba482b$var$kConstructed = 16;
var $01848e8604ba482b$var$kSync = 32;
var $01848e8604ba482b$var$kNeedReadable = 64;
var $01848e8604ba482b$var$kEmittedReadable = 128;
var $01848e8604ba482b$var$kReadableListening = 256;
var $01848e8604ba482b$var$kResumeScheduled = 512;
var $01848e8604ba482b$var$kErrorEmitted = 1024;
var $01848e8604ba482b$var$kEmitClose = 2048;
var $01848e8604ba482b$var$kAutoDestroy = 4096;
var $01848e8604ba482b$var$kDestroyed = 8192;
var $01848e8604ba482b$var$kClosed = 16384;
var $01848e8604ba482b$var$kCloseEmitted = 32768;
var $01848e8604ba482b$var$kMultiAwaitDrain = 65536;
var $01848e8604ba482b$var$kReadingMore = 131072;
var $01848e8604ba482b$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $01848e8604ba482b$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$01848e8604ba482b$var$ObjectDefineProperties($01848e8604ba482b$var$ReadableState.prototype, {
    objectMode: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kObjectMode),
    ended: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kEnded),
    endEmitted: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kEndEmitted),
    reading: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kNeedReadable),
    emittedReadable: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kEmittedReadable),
    readableListening: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kReadableListening),
    resumeScheduled: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kErrorEmitted),
    emitClose: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kEmitClose),
    autoDestroy: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kCloseEmitted),
    multiAwaitDrain: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kReadingMore),
    dataEmitted: $01848e8604ba482b$var$makeBitMapDescriptor($01848e8604ba482b$var$kDataEmitted)
});

function $01848e8604ba482b$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("29VwN"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $01848e8604ba482b$var$kEmitClose | $01848e8604ba482b$var$kAutoDestroy | $01848e8604ba482b$var$kConstructed | $01848e8604ba482b$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $01848e8604ba482b$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $01848e8604ba482b$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $01848e8604ba482b$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $01848e8604ba482b$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4igrv();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$01848e8604ba482b$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$01848e8604ba482b$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$01848e8604ba482b$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $01848e8604ba482b$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $01848e8604ba482b$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $01848e8604ba482b$var$Readable)) return new $01848e8604ba482b$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("29VwN"));
    this._readableState = new $01848e8604ba482b$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $01848e8604ba482b$require$addAbortSignal(options.signal, this);
    }
    $01848e8604ba482b$var$Stream.call(this, options);
    $jnNYa.construct(this, function() {
        if (_this._readableState.needReadable) $01848e8604ba482b$var$maybeReadMore(_this, _this._readableState);
    });
}
$01848e8604ba482b$var$Readable.prototype.destroy = $jnNYa.destroy;
$01848e8604ba482b$var$Readable.prototype._undestroy = $jnNYa.undestroy;
$01848e8604ba482b$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$01848e8604ba482b$var$Readable.prototype[$01848e8604ba482b$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$01848e8604ba482b$var$Readable.prototype[$01848e8604ba482b$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $01848e8604ba482b$var$AbortError();
        this.destroy(error);
    }
    return new $01848e8604ba482b$var$Promise(function(resolve, reject) {
        return $leSYr(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$01848e8604ba482b$var$Readable.prototype.push = function(chunk, encoding) {
    return $01848e8604ba482b$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$01848e8604ba482b$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $01848e8604ba482b$var$readableAddChunk(this, chunk, encoding, true);
};
function $01848e8604ba482b$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $01848e8604ba482b$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $01848e8604ba482b$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $01848e8604ba482b$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $01848e8604ba482b$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $01848e8604ba482b$require$Buffer) encoding = '';
        else if ($01848e8604ba482b$var$Stream._isUint8Array(chunk)) {
            chunk = $01848e8604ba482b$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $01848e8604ba482b$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $01848e8604ba482b$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$01848e8604ba482b$var$kReading;
        $01848e8604ba482b$var$onEofChunk(stream, state);
    } else if ((state.state & $01848e8604ba482b$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $01848e8604ba482b$var$kEndEmitted) !== 0) $01848e8604ba482b$var$errorOrDestroy(stream, new $01848e8604ba482b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $01848e8604ba482b$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $01848e8604ba482b$var$errorOrDestroy(stream, new $01848e8604ba482b$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$01848e8604ba482b$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $01848e8604ba482b$var$addChunk(stream, state, chunk, false);
                else $01848e8604ba482b$var$maybeReadMore(stream, state);
            } else $01848e8604ba482b$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$01848e8604ba482b$var$kReading;
        $01848e8604ba482b$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $01848e8604ba482b$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $01848e8604ba482b$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $01848e8604ba482b$var$kNeedReadable) !== 0) $01848e8604ba482b$var$emitReadable(stream);
    }
    $01848e8604ba482b$var$maybeReadMore(stream, state);
}
$01848e8604ba482b$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$01848e8604ba482b$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$01848e8604ba482b$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $01848e8604ba482b$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$01848e8604ba482b$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $01848e8604ba482b$var$MAX_HWM = 0x40000000;
function $01848e8604ba482b$var$computeNewHighWaterMark(n) {
    if (n > $01848e8604ba482b$var$MAX_HWM) throw new $01848e8604ba482b$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $01848e8604ba482b$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $01848e8604ba482b$var$kObjectMode) !== 0) return 1;
    if ($01848e8604ba482b$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$01848e8604ba482b$var$Readable.prototype.read = function(n) {
    $01848e8604ba482b$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$01848e8604ba482b$var$NumberIsInteger(n)) n = $01848e8604ba482b$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $01848e8604ba482b$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$01848e8604ba482b$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $01848e8604ba482b$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $01848e8604ba482b$var$endReadable(this);
        else $01848e8604ba482b$var$emitReadable(this);
        return null;
    }
    n = $01848e8604ba482b$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $01848e8604ba482b$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $01848e8604ba482b$var$kNeedReadable) !== 0;
    $01848e8604ba482b$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $01848e8604ba482b$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $01848e8604ba482b$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $01848e8604ba482b$var$debug('do read');
        state.state |= $01848e8604ba482b$var$kReading | $01848e8604ba482b$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $01848e8604ba482b$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $01848e8604ba482b$var$errorOrDestroy(this, err);
        }
        state.state &= ~$01848e8604ba482b$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $01848e8604ba482b$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $01848e8604ba482b$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $01848e8604ba482b$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $01848e8604ba482b$var$onEofChunk(stream, state) {
    $01848e8604ba482b$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $01848e8604ba482b$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $01848e8604ba482b$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $01848e8604ba482b$var$emitReadable(stream) {
    var state = stream._readableState;
    $01848e8604ba482b$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $01848e8604ba482b$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($01848e8604ba482b$var$emitReadable_, stream);
    }
}
function $01848e8604ba482b$var$emitReadable_(stream) {
    var state = stream._readableState;
    $01848e8604ba482b$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $01848e8604ba482b$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $01848e8604ba482b$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($01848e8604ba482b$var$maybeReadMore_, stream, state);
    }
}
function $01848e8604ba482b$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $01848e8604ba482b$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$01848e8604ba482b$var$Readable.prototype._read = function(n) {
    throw new $01848e8604ba482b$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$01848e8604ba482b$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $01848e8604ba482b$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $01848e8604ba482b$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $01848e8604ba482b$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $01848e8604ba482b$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $01848e8604ba482b$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $01848e8604ba482b$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $01848e8604ba482b$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $01848e8604ba482b$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $01848e8604ba482b$var$debug('ondata');
        var ret = dest.write(chunk);
        $01848e8604ba482b$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $01848e8604ba482b$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $01848e8604ba482b$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $01848e8604ba482b$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $01848e8604ba482b$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $01848e8604ba482b$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $01848e8604ba482b$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $01848e8604ba482b$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $01848e8604ba482b$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $01848e8604ba482b$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$01848e8604ba482b$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $01848e8604ba482b$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$01848e8604ba482b$var$Readable.prototype.on = function(ev, fn) {
    var res = $01848e8604ba482b$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $01848e8604ba482b$var$debug('on readable', state.length, state.reading);
            if (state.length) $01848e8604ba482b$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($01848e8604ba482b$var$nReadingNextTick, this);
        }
    }
    return res;
};
$01848e8604ba482b$var$Readable.prototype.addListener = $01848e8604ba482b$var$Readable.prototype.on;
$01848e8604ba482b$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $01848e8604ba482b$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($01848e8604ba482b$var$updateReadableListening, this);
    return res;
};
$01848e8604ba482b$var$Readable.prototype.off = $01848e8604ba482b$var$Readable.prototype.removeListener;
$01848e8604ba482b$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $01848e8604ba482b$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($01848e8604ba482b$var$updateReadableListening, this);
    return res;
};
function $01848e8604ba482b$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$01848e8604ba482b$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $01848e8604ba482b$var$nReadingNextTick(self) {
    $01848e8604ba482b$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$01848e8604ba482b$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $01848e8604ba482b$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $01848e8604ba482b$var$resume(this, state);
    }
    state[$01848e8604ba482b$var$kPaused] = false;
    return this;
};
function $01848e8604ba482b$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($01848e8604ba482b$var$resume_, stream, state);
    }
}
function $01848e8604ba482b$var$resume_(stream, state) {
    $01848e8604ba482b$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $01848e8604ba482b$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$01848e8604ba482b$var$Readable.prototype.pause = function() {
    $01848e8604ba482b$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $01848e8604ba482b$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$01848e8604ba482b$var$kPaused] = true;
    return this;
};
function $01848e8604ba482b$var$flow(stream) {
    var state = stream._readableState;
    $01848e8604ba482b$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$01848e8604ba482b$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $01848e8604ba482b$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $01848e8604ba482b$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$01848e8604ba482b$var$Readable.prototype[$01848e8604ba482b$var$SymbolAsyncIterator] = function() {
    return $01848e8604ba482b$var$streamToAsyncIterator(this);
};
$01848e8604ba482b$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $01848e8604ba482b$require$validateObject(options, 'options');
    return $01848e8604ba482b$var$streamToAsyncIterator(this, options);
};
function $01848e8604ba482b$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $01848e8604ba482b$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $01848e8604ba482b$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $01848e8604ba482b$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $01848e8604ba482b$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $01848e8604ba482b$var$nop;
                    stream.on('readable', next);
                    cleanup = $leSYr(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $01848e8604ba482b$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $01848e8604ba482b$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $01848e8604ba482b$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $01848e8604ba482b$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $jnNYa.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$01848e8604ba482b$var$ObjectDefineProperties($01848e8604ba482b$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$01848e8604ba482b$var$ObjectDefineProperties($01848e8604ba482b$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$01848e8604ba482b$var$kPaused] !== false;
        },
        set: function(value) {
            this[$01848e8604ba482b$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$01848e8604ba482b$var$Readable._fromList = $01848e8604ba482b$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $01848e8604ba482b$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $01848e8604ba482b$var$endReadable(stream) {
    var state = stream._readableState;
    $01848e8604ba482b$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($01848e8604ba482b$var$endReadableNT, state, stream);
    }
}
function $01848e8604ba482b$var$endReadableNT(state, stream) {
    $01848e8604ba482b$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($01848e8604ba482b$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $01848e8604ba482b$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$01848e8604ba482b$var$Readable.from = function(iterable, opts) {
    return $eS7aQ($01848e8604ba482b$var$Readable, iterable, opts);
};
var $01848e8604ba482b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $01848e8604ba482b$var$lazyWebStreams() {
    if ($01848e8604ba482b$var$webStreamsAdapters === undefined) $01848e8604ba482b$var$webStreamsAdapters = {};
    return $01848e8604ba482b$var$webStreamsAdapters;
}
$01848e8604ba482b$var$Readable.fromWeb = function(readableStream, options) {
    return $01848e8604ba482b$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$01848e8604ba482b$var$Readable.toWeb = function(streamReadable, options) {
    return $01848e8604ba482b$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$01848e8604ba482b$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $01848e8604ba482b$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $jnNYa.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("8N5gC", function(module, exports) {
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $6666fc3cd100522b$var$ArrayIsArray = $4K8OX.ArrayIsArray, $6666fc3cd100522b$var$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $6666fc3cd100522b$var$EE = $bBoAO.EventEmitter;
function $6666fc3cd100522b$var$Stream(opts) {
    $6666fc3cd100522b$var$EE.call(this, opts);
}
$6666fc3cd100522b$var$ObjectSetPrototypeOf($6666fc3cd100522b$var$Stream.prototype, $6666fc3cd100522b$var$EE.prototype);
$6666fc3cd100522b$var$ObjectSetPrototypeOf($6666fc3cd100522b$var$Stream, $6666fc3cd100522b$var$EE);
$6666fc3cd100522b$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($6666fc3cd100522b$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $6666fc3cd100522b$var$prependListener(source, 'error', onerror);
    $6666fc3cd100522b$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $6666fc3cd100522b$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($6666fc3cd100522b$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $6666fc3cd100522b$var$Stream,
    prependListener: $6666fc3cd100522b$var$prependListener
};

});

parcelRegister("aeA37", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $77372ccdf4777da9$export$e2db56ee53255a0; }, function (v) { return $77372ccdf4777da9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $77372ccdf4777da9$export$11956e9313f43de0; }, function (v) { return $77372ccdf4777da9$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $77372ccdf4777da9$export$e2db56ee53255a0;
var $77372ccdf4777da9$export$11956e9313f43de0;
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $77372ccdf4777da9$require$SymbolDispose = $4K8OX.SymbolDispose;

var $d092A = parcelRequire("d092A");
var $77372ccdf4777da9$var$AbortError = $d092A.AbortError, $77372ccdf4777da9$var$codes = $d092A.codes;

var $eLqbm = parcelRequire("eLqbm");
var $77372ccdf4777da9$var$isNodeStream = $eLqbm.isNodeStream, $77372ccdf4777da9$var$isWebStream = $eLqbm.isWebStream, $77372ccdf4777da9$var$kControllerErrorFunction = $eLqbm.kControllerErrorFunction;

var $leSYr = parcelRequire("leSYr");
var $77372ccdf4777da9$var$ERR_INVALID_ARG_TYPE = $77372ccdf4777da9$var$codes.ERR_INVALID_ARG_TYPE;
var $77372ccdf4777da9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $77372ccdf4777da9$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $77372ccdf4777da9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$77372ccdf4777da9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $77372ccdf4777da9$var$validateAbortSignal(signal, 'signal');
    if (!$77372ccdf4777da9$var$isNodeStream(stream) && !$77372ccdf4777da9$var$isWebStream(stream)) throw new $77372ccdf4777da9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $77372ccdf4777da9$export$11956e9313f43de0(signal, stream);
};

$77372ccdf4777da9$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $77372ccdf4777da9$var$isNodeStream(stream) ? function() {
        stream.destroy(new $77372ccdf4777da9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$77372ccdf4777da9$var$kControllerErrorFunction](new $77372ccdf4777da9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $77372ccdf4777da9$var$addAbortListener = $77372ccdf4777da9$var$addAbortListener || (parcelRequire("1FR2B")).addAbortListener;
        var disposable = $77372ccdf4777da9$var$addAbortListener(signal, onAbort);
        $leSYr(stream, disposable[$77372ccdf4777da9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4igrv", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $3205990563194a33$var$StringPrototypeSlice = $4K8OX.StringPrototypeSlice, $3205990563194a33$var$SymbolIterator = $4K8OX.SymbolIterator, $3205990563194a33$var$TypedArrayPrototypeSet = $4K8OX.TypedArrayPrototypeSet, $3205990563194a33$var$Uint8Array = $4K8OX.Uint8Array;

var $5EQ4X = parcelRequire("5EQ4X");
var $3205990563194a33$require$Buffer = $5EQ4X.Buffer;

var $1FR2B = parcelRequire("1FR2B");
var $3205990563194a33$require$inspect = $1FR2B.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $3205990563194a33$require$Buffer.alloc(0);
                var ret = $3205990563194a33$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $3205990563194a33$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $3205990563194a33$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $3205990563194a33$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $3205990563194a33$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $3205990563194a33$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $3205990563194a33$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $3205990563194a33$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $3205990563194a33$var$TypedArrayPrototypeSet(ret, new $3205990563194a33$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $3205990563194a33$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("4Gyqa", function(module, exports) {
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $3695c8f6e8a7f188$var$MathFloor = $4K8OX.MathFloor, $3695c8f6e8a7f188$var$NumberIsInteger = $4K8OX.NumberIsInteger;

var $jYkoQ = parcelRequire("jYkoQ");
var $3695c8f6e8a7f188$require$validateInteger = $jYkoQ.validateInteger;

var $3695c8f6e8a7f188$var$ERR_INVALID_ARG_VALUE = (parcelRequire("d092A")).codes.ERR_INVALID_ARG_VALUE;
var $3695c8f6e8a7f188$var$defaultHighWaterMarkBytes = 16384;
var $3695c8f6e8a7f188$var$defaultHighWaterMarkObjectMode = 16;
function $3695c8f6e8a7f188$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3695c8f6e8a7f188$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $3695c8f6e8a7f188$var$defaultHighWaterMarkObjectMode : $3695c8f6e8a7f188$var$defaultHighWaterMarkBytes;
}
function $3695c8f6e8a7f188$var$setDefaultHighWaterMark(objectMode, value) {
    $3695c8f6e8a7f188$require$validateInteger(value, 'value', 0);
    if (objectMode) $3695c8f6e8a7f188$var$defaultHighWaterMarkObjectMode = value;
    else $3695c8f6e8a7f188$var$defaultHighWaterMarkBytes = value;
}
function $3695c8f6e8a7f188$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $3695c8f6e8a7f188$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$3695c8f6e8a7f188$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $3695c8f6e8a7f188$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $3695c8f6e8a7f188$var$MathFloor(hwm);
    }
    // Default value
    return $3695c8f6e8a7f188$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $3695c8f6e8a7f188$var$getHighWaterMark,
    getDefaultHighWaterMark: $3695c8f6e8a7f188$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $3695c8f6e8a7f188$var$setDefaultHighWaterMark
};

});

parcelRegister("eS7aQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4K8OX = parcelRequire("4K8OX");
/* replacement end */ var $ad3bac67706b6813$var$PromisePrototypeThen = $4K8OX.PromisePrototypeThen, $ad3bac67706b6813$var$SymbolAsyncIterator = $4K8OX.SymbolAsyncIterator, $ad3bac67706b6813$var$SymbolIterator = $4K8OX.SymbolIterator;

var $5EQ4X = parcelRequire("5EQ4X");
var $ad3bac67706b6813$require$Buffer = $5EQ4X.Buffer;

var $d092A = parcelRequire("d092A");
var $ad3bac67706b6813$require$_require_codes = $d092A.codes;
var $ad3bac67706b6813$var$ERR_INVALID_ARG_TYPE = $ad3bac67706b6813$require$_require_codes.ERR_INVALID_ARG_TYPE, $ad3bac67706b6813$var$ERR_STREAM_NULL_VALUES = $ad3bac67706b6813$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $ad3bac67706b6813$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $ad3bac67706b6813$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$ad3bac67706b6813$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$ad3bac67706b6813$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$ad3bac67706b6813$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$ad3bac67706b6813$var$SymbolIterator]();
    } else throw new $ad3bac67706b6813$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $ad3bac67706b6813$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $ad3bac67706b6813$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $ad3bac67706b6813$var$from;

});


parcelRegister("b2yGi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4K8OX = parcelRequire("4K8OX");
/* replacement end */ var $809ac891f682729f$var$ArrayPrototypeSlice = $4K8OX.ArrayPrototypeSlice, $809ac891f682729f$var$Error = $4K8OX.Error, $809ac891f682729f$var$FunctionPrototypeSymbolHasInstance = $4K8OX.FunctionPrototypeSymbolHasInstance, $809ac891f682729f$var$ObjectDefineProperty = $4K8OX.ObjectDefineProperty, $809ac891f682729f$var$ObjectDefineProperties = $4K8OX.ObjectDefineProperties, $809ac891f682729f$var$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf, $809ac891f682729f$var$StringPrototypeToLowerCase = $4K8OX.StringPrototypeToLowerCase, $809ac891f682729f$var$Symbol = $4K8OX.Symbol, $809ac891f682729f$var$SymbolHasInstance = $4K8OX.SymbolHasInstance;
module.exports = $809ac891f682729f$var$Writable;
$809ac891f682729f$var$Writable.WritableState = $809ac891f682729f$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $809ac891f682729f$var$EE = $bBoAO.EventEmitter;

var $8N5gC = parcelRequire("8N5gC");
var $809ac891f682729f$require$Stream = $8N5gC.Stream;

var $5EQ4X = parcelRequire("5EQ4X");
var $809ac891f682729f$require$Buffer = $5EQ4X.Buffer;

var $jnNYa = parcelRequire("jnNYa");

var $aeA37 = parcelRequire("aeA37");
var $809ac891f682729f$require$addAbortSignal = $aeA37.addAbortSignal;

var $4Gyqa = parcelRequire("4Gyqa");
var $809ac891f682729f$var$getHighWaterMark = $4Gyqa.getHighWaterMark, $809ac891f682729f$var$getDefaultHighWaterMark = $4Gyqa.getDefaultHighWaterMark;

var $d092A = parcelRequire("d092A");
var $809ac891f682729f$require$_require_codes = $d092A.codes;
var $809ac891f682729f$var$ERR_INVALID_ARG_TYPE = $809ac891f682729f$require$_require_codes.ERR_INVALID_ARG_TYPE, $809ac891f682729f$var$ERR_METHOD_NOT_IMPLEMENTED = $809ac891f682729f$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $809ac891f682729f$var$ERR_MULTIPLE_CALLBACK = $809ac891f682729f$require$_require_codes.ERR_MULTIPLE_CALLBACK, $809ac891f682729f$var$ERR_STREAM_CANNOT_PIPE = $809ac891f682729f$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $809ac891f682729f$var$ERR_STREAM_DESTROYED = $809ac891f682729f$require$_require_codes.ERR_STREAM_DESTROYED, $809ac891f682729f$var$ERR_STREAM_ALREADY_FINISHED = $809ac891f682729f$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $809ac891f682729f$var$ERR_STREAM_NULL_VALUES = $809ac891f682729f$require$_require_codes.ERR_STREAM_NULL_VALUES, $809ac891f682729f$var$ERR_STREAM_WRITE_AFTER_END = $809ac891f682729f$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $809ac891f682729f$var$ERR_UNKNOWN_ENCODING = $809ac891f682729f$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $809ac891f682729f$var$errorOrDestroy = $jnNYa.errorOrDestroy;
$809ac891f682729f$var$ObjectSetPrototypeOf($809ac891f682729f$var$Writable.prototype, $809ac891f682729f$require$Stream.prototype);
$809ac891f682729f$var$ObjectSetPrototypeOf($809ac891f682729f$var$Writable, $809ac891f682729f$require$Stream);
function $809ac891f682729f$var$nop() {}
var $809ac891f682729f$var$kOnFinished = $809ac891f682729f$var$Symbol('kOnFinished');

function $809ac891f682729f$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("29VwN"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $809ac891f682729f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $809ac891f682729f$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $809ac891f682729f$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $809ac891f682729f$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$809ac891f682729f$var$kOnFinished] = [];
}
function $809ac891f682729f$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$809ac891f682729f$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $809ac891f682729f$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$809ac891f682729f$var$ObjectDefineProperty($809ac891f682729f$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $809ac891f682729f$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("29VwN"));
    if (!isDuplex && !$809ac891f682729f$var$FunctionPrototypeSymbolHasInstance($809ac891f682729f$var$Writable, this)) return new $809ac891f682729f$var$Writable(options);
    this._writableState = new $809ac891f682729f$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $809ac891f682729f$require$addAbortSignal(options.signal, this);
    }
    $809ac891f682729f$require$Stream.call(this, options);
    $jnNYa.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $809ac891f682729f$var$clearBuffer(_this, state);
        $809ac891f682729f$var$finishMaybe(_this, state);
    });
}
$809ac891f682729f$var$ObjectDefineProperty($809ac891f682729f$var$Writable, $809ac891f682729f$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($809ac891f682729f$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $809ac891f682729f$var$Writable) return false;
        return object && object._writableState instanceof $809ac891f682729f$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$809ac891f682729f$var$Writable.prototype.pipe = function() {
    $809ac891f682729f$var$errorOrDestroy(this, new $809ac891f682729f$var$ERR_STREAM_CANNOT_PIPE());
};
function $809ac891f682729f$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$809ac891f682729f$require$Buffer.isEncoding(encoding)) throw new $809ac891f682729f$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $809ac891f682729f$var$nop;
    }
    if (chunk === null) throw new $809ac891f682729f$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $809ac891f682729f$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $809ac891f682729f$require$Buffer) encoding = 'buffer';
        else if ($809ac891f682729f$require$Stream._isUint8Array(chunk)) {
            chunk = $809ac891f682729f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $809ac891f682729f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $809ac891f682729f$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $809ac891f682729f$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $809ac891f682729f$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $809ac891f682729f$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$809ac891f682729f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $809ac891f682729f$var$_write(this, chunk, encoding, cb) === true;
};
$809ac891f682729f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$809ac891f682729f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $809ac891f682729f$var$clearBuffer(this, state);
    }
};
$809ac891f682729f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $809ac891f682729f$var$StringPrototypeToLowerCase(encoding);
    if (!$809ac891f682729f$require$Buffer.isEncoding(encoding)) throw new $809ac891f682729f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $809ac891f682729f$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $809ac891f682729f$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $809ac891f682729f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $809ac891f682729f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $809ac891f682729f$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $809ac891f682729f$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $809ac891f682729f$var$errorOrDestroy(stream, er);
}
function $809ac891f682729f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $809ac891f682729f$var$errorOrDestroy(stream, new $809ac891f682729f$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($809ac891f682729f$var$onwriteError, stream, state, er, cb);
        else $809ac891f682729f$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $809ac891f682729f$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($809ac891f682729f$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $809ac891f682729f$var$afterWrite(stream, state, 1, cb);
    }
}
function $809ac891f682729f$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $809ac891f682729f$var$afterWrite(stream, state, count, cb);
}
function $809ac891f682729f$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $809ac891f682729f$var$errorBuffer(state);
    $809ac891f682729f$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $809ac891f682729f$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $809ac891f682729f$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$809ac891f682729f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $809ac891f682729f$var$ERR_STREAM_DESTROYED('end'));
    }
    $809ac891f682729f$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $809ac891f682729f$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $809ac891f682729f$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $809ac891f682729f$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $809ac891f682729f$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $809ac891f682729f$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $809ac891f682729f$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $809ac891f682729f$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$809ac891f682729f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $809ac891f682729f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$809ac891f682729f$var$Writable.prototype._writev = null;
$809ac891f682729f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $809ac891f682729f$var$_write(this, chunk, encoding);
        if (ret instanceof $809ac891f682729f$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $809ac891f682729f$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $809ac891f682729f$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $809ac891f682729f$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$809ac891f682729f$var$kOnFinished].push(cb);
    }
    return this;
};
function $809ac891f682729f$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $809ac891f682729f$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $809ac891f682729f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $809ac891f682729f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$809ac891f682729f$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $809ac891f682729f$var$errorOrDestroy(stream, err, state.sync);
        } else if ($809ac891f682729f$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($809ac891f682729f$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $809ac891f682729f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $809ac891f682729f$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $809ac891f682729f$var$finishMaybe(stream, state, sync) {
    if ($809ac891f682729f$var$needFinish(state)) {
        $809ac891f682729f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($809ac891f682729f$var$needFinish(state)) $809ac891f682729f$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($809ac891f682729f$var$needFinish(state)) {
                state.pendingcb++;
                $809ac891f682729f$var$finish(stream, state);
            }
        }
    }
}
function $809ac891f682729f$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$809ac891f682729f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$809ac891f682729f$var$ObjectDefineProperties($809ac891f682729f$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $809ac891f682729f$var$destroy = $jnNYa.destroy;
$809ac891f682729f$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$809ac891f682729f$var$kOnFinished].length)) $2Qkr5.nextTick($809ac891f682729f$var$errorBuffer, state);
    $809ac891f682729f$var$destroy.call(this, err, cb);
    return this;
};
$809ac891f682729f$var$Writable.prototype._undestroy = $jnNYa.undestroy;
$809ac891f682729f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$809ac891f682729f$var$Writable.prototype[$809ac891f682729f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $809ac891f682729f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $809ac891f682729f$var$lazyWebStreams() {
    if ($809ac891f682729f$var$webStreamsAdapters === undefined) $809ac891f682729f$var$webStreamsAdapters = {};
    return $809ac891f682729f$var$webStreamsAdapters;
}
$809ac891f682729f$var$Writable.fromWeb = function(writableStream, options) {
    return $809ac891f682729f$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$809ac891f682729f$var$Writable.toWeb = function(streamWritable) {
    return $809ac891f682729f$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("kJljR", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $5EQ4X = parcelRequire("5EQ4X");

var $eLqbm = parcelRequire("eLqbm");
var $f1788c340cca6793$var$isReadable = $eLqbm.isReadable, $f1788c340cca6793$var$isWritable = $eLqbm.isWritable, $f1788c340cca6793$var$isIterable = $eLqbm.isIterable, $f1788c340cca6793$var$isNodeStream = $eLqbm.isNodeStream, $f1788c340cca6793$var$isReadableNodeStream = $eLqbm.isReadableNodeStream, $f1788c340cca6793$var$isWritableNodeStream = $eLqbm.isWritableNodeStream, $f1788c340cca6793$var$isDuplexNodeStream = $eLqbm.isDuplexNodeStream, $f1788c340cca6793$var$isReadableStream = $eLqbm.isReadableStream, $f1788c340cca6793$var$isWritableStream = $eLqbm.isWritableStream;

var $leSYr = parcelRequire("leSYr");

var $d092A = parcelRequire("d092A");
var $f1788c340cca6793$var$AbortError = $d092A.AbortError, $f1788c340cca6793$var$_require_codes = $d092A.codes, $f1788c340cca6793$var$ERR_INVALID_ARG_TYPE = $f1788c340cca6793$var$_require_codes.ERR_INVALID_ARG_TYPE, $f1788c340cca6793$var$ERR_INVALID_RETURN_VALUE = $f1788c340cca6793$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $jnNYa = parcelRequire("jnNYa");
var $f1788c340cca6793$require$destroyer = $jnNYa.destroyer;

var $29VwN = parcelRequire("29VwN");

var $84Uuw = parcelRequire("84Uuw");

var $b2yGi = parcelRequire("b2yGi");

var $1FR2B = parcelRequire("1FR2B");
var $f1788c340cca6793$require$createDeferredPromise = $1FR2B.createDeferredPromise;

var $eS7aQ = parcelRequire("eS7aQ");
var $f1788c340cca6793$var$Blob = globalThis.Blob || $5EQ4X.Blob;
var $f1788c340cca6793$var$isBlob = typeof $f1788c340cca6793$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $f1788c340cca6793$var$Blob;
} : function isBlob(b) {
    return false;
};

var $f1788c340cca6793$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $4K8OX = parcelRequire("4K8OX");
var $f1788c340cca6793$require$FunctionPrototypeCall = $4K8OX.FunctionPrototypeCall;
// This is needed for pre node 17.
var $f1788c340cca6793$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($29VwN);
module.exports = function duplexify(body, name) {
    if ($f1788c340cca6793$var$isDuplexNodeStream(body)) return body;
    if ($f1788c340cca6793$var$isReadableNodeStream(body)) return $f1788c340cca6793$var$_duplexify({
        readable: body
    });
    if ($f1788c340cca6793$var$isWritableNodeStream(body)) return $f1788c340cca6793$var$_duplexify({
        writable: body
    });
    if ($f1788c340cca6793$var$isNodeStream(body)) return $f1788c340cca6793$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($f1788c340cca6793$var$isReadableStream(body)) return $f1788c340cca6793$var$_duplexify({
        readable: $84Uuw.fromWeb(body)
    });
    if ($f1788c340cca6793$var$isWritableStream(body)) return $f1788c340cca6793$var$_duplexify({
        writable: $b2yGi.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $f1788c340cca6793$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($f1788c340cca6793$var$isIterable(value)) return $eS7aQ($f1788c340cca6793$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $f1788c340cca6793$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $f1788c340cca6793$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $f1788c340cca6793$require$destroyer(d, err);
            });
            return d = new $f1788c340cca6793$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $f1788c340cca6793$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($f1788c340cca6793$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($f1788c340cca6793$var$isIterable(body)) return $eS7aQ($f1788c340cca6793$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($f1788c340cca6793$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $f1788c340cca6793$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $f1788c340cca6793$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $f1788c340cca6793$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $f1788c340cca6793$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $f1788c340cca6793$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $f1788c340cca6793$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $f1788c340cca6793$require$destroyer(d1, err);
        });
        return d1 = new $f1788c340cca6793$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $f1788c340cca6793$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $f1788c340cca6793$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $f1788c340cca6793$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $f1788c340cca6793$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $f1788c340cca6793$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $f1788c340cca6793$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $f1788c340cca6793$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $84Uuw.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$f1788c340cca6793$var$isReadable(r);
    var writable = !!$f1788c340cca6793$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $f1788c340cca6793$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $leSYr(w, function(err) {
            writable = false;
            if (err) $f1788c340cca6793$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $leSYr(r, function(err) {
            readable = false;
            if (err) $f1788c340cca6793$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $f1788c340cca6793$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $f1788c340cca6793$require$destroyer(w, err);
            $f1788c340cca6793$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("iVKMH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $dc81d7499da0e056$require$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf;
module.exports = $dc81d7499da0e056$var$PassThrough;

var $e5oCo = parcelRequire("e5oCo");
$dc81d7499da0e056$require$ObjectSetPrototypeOf($dc81d7499da0e056$var$PassThrough.prototype, $e5oCo.prototype);
$dc81d7499da0e056$require$ObjectSetPrototypeOf($dc81d7499da0e056$var$PassThrough, $e5oCo);
function $dc81d7499da0e056$var$PassThrough(options) {
    if (!(this instanceof $dc81d7499da0e056$var$PassThrough)) return new $dc81d7499da0e056$var$PassThrough(options);
    $e5oCo.call(this, options);
}
$dc81d7499da0e056$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("e5oCo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $a414a0f69bebf79b$var$ObjectSetPrototypeOf = $4K8OX.ObjectSetPrototypeOf, $a414a0f69bebf79b$var$Symbol = $4K8OX.Symbol;
module.exports = $a414a0f69bebf79b$var$Transform;

var $a414a0f69bebf79b$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("d092A")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $29VwN = parcelRequire("29VwN");

var $4Gyqa = parcelRequire("4Gyqa");
var $a414a0f69bebf79b$require$getHighWaterMark = $4Gyqa.getHighWaterMark;
$a414a0f69bebf79b$var$ObjectSetPrototypeOf($a414a0f69bebf79b$var$Transform.prototype, $29VwN.prototype);
$a414a0f69bebf79b$var$ObjectSetPrototypeOf($a414a0f69bebf79b$var$Transform, $29VwN);
var $a414a0f69bebf79b$var$kCallback = $a414a0f69bebf79b$var$Symbol('kCallback');
function $a414a0f69bebf79b$var$Transform(options) {
    if (!(this instanceof $a414a0f69bebf79b$var$Transform)) return new $a414a0f69bebf79b$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $a414a0f69bebf79b$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $29VwN.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$a414a0f69bebf79b$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $a414a0f69bebf79b$var$prefinish);
}
function $a414a0f69bebf79b$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $a414a0f69bebf79b$var$prefinish() {
    if (this._final !== $a414a0f69bebf79b$var$_final) $a414a0f69bebf79b$var$_final.call(this);
}
$a414a0f69bebf79b$var$Transform.prototype._final = $a414a0f69bebf79b$var$_final;
$a414a0f69bebf79b$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $a414a0f69bebf79b$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$a414a0f69bebf79b$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$a414a0f69bebf79b$var$kCallback] = callback;
    });
};
$a414a0f69bebf79b$var$Transform.prototype._read = function() {
    if (this[$a414a0f69bebf79b$var$kCallback]) {
        var callback = this[$a414a0f69bebf79b$var$kCallback];
        this[$a414a0f69bebf79b$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("bRjgs", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4K8OX = parcelRequire("4K8OX");
var $8a2396764159dbc1$var$ArrayPrototypePop = $4K8OX.ArrayPrototypePop, $8a2396764159dbc1$var$Promise = $4K8OX.Promise;

var $eLqbm = parcelRequire("eLqbm");
var $8a2396764159dbc1$var$isIterable = $eLqbm.isIterable, $8a2396764159dbc1$var$isNodeStream = $eLqbm.isNodeStream, $8a2396764159dbc1$var$isWebStream = $eLqbm.isWebStream;

var $aXKB2 = parcelRequire("aXKB2");
var $8a2396764159dbc1$var$pl = $aXKB2.pipelineImpl;

var $leSYr = parcelRequire("leSYr");
var $8a2396764159dbc1$require$finished = $leSYr.finished;
parcelRequire("aPJcD");
function $8a2396764159dbc1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $8a2396764159dbc1$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$8a2396764159dbc1$var$isNodeStream(lastArg) && !$8a2396764159dbc1$var$isIterable(lastArg) && !$8a2396764159dbc1$var$isWebStream(lastArg)) {
            var options = $8a2396764159dbc1$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $8a2396764159dbc1$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $8a2396764159dbc1$require$finished,
    pipeline: $8a2396764159dbc1$var$pipeline
};

});





parcelRegister("mFOgG", function(module, exports) {
"use strict";
var $04427cbd4acf1c7f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04427cbd4acf1c7f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $04427cbd4acf1c7f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindingsStreamToGraphQl = void 0;

var $04427cbd4acf1c7f$var$bindingsStreamToGraphQl = (parcelRequire("1nZl8")).ActorQueryResultSerializeTree.bindingsStreamToGraphQl;
module.exports.bindingsStreamToGraphQl = $04427cbd4acf1c7f$var$bindingsStreamToGraphQl;

$04427cbd4acf1c7f$var$__exportStar((parcelRequire("1nZl8")), module.exports);

});
parcelRegister("1nZl8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeTree = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $lBZ2m = parcelRequire("lBZ2m");

var $8GYyi = parcelRequire("8GYyi");
/**
 * A comunica Tree Query Result Serialize Actor.
 */ var $10278540d6ebb02a$var$ActorQueryResultSerializeTree = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeTree, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeTree(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeTree);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeTree, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeTree, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.type !== 'bindings') return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        data = new $lBZ2m.Readable();
                        data._read = function() {
                            data._read = function() {};
                            ActorQueryResultSerializeTree.bindingsStreamToGraphQl(action.bindingsStream, action.context, {
                                materializeRdfJsTerms: true
                            }).then(function(result) {
                                data.push(JSON.stringify(result, null, '  '));
                                data.push(null);
                            })["catch"](function(error) {
                                return data.emit('error', error);
                            });
                        };
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "bindingsStreamToGraphQl",
            value: /**
     *
     * @param {BindingsStream} bindingsStream
     * @param context
     * @param {IConverterSettings} converterSettings
     * @return {Promise<string>}
     */ function bindingsStreamToGraphQl(bindingsStream, context, converterSettings) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var actionContext, converter, _actionContext_get, schema, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                actionContext = $kNNoa.ActionContext.ensureActionContext(context);
                                converter = new $8GYyi.Converter(converterSettings);
                                schema = {
                                    singularizeVariables: (_actionContext_get = actionContext.get($9nBhR.KeysInitQuery.graphqlSingularizeVariables)) !== null && _actionContext_get !== void 0 ? _actionContext_get : {}
                                };
                                _ = converter.bindingsToTree;
                                return [
                                    4,
                                    bindingsStream.map(function(bindings) {
                                        return Object.fromEntries((0, $7WNf6._)(bindings).map(function(param) {
                                            var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                            return [
                                                key.value,
                                                value
                                            ];
                                        }));
                                    }).toArray()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(converter, [
                                        _state.sent(),
                                        schema
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ActorQueryResultSerializeTree;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeTree = $10278540d6ebb02a$var$ActorQueryResultSerializeTree;

});
parcelRegister("lBZ2m", function(module, exports) {
'use strict';

var $cRPwj = parcelRequire("cRPwj");

var $1c4Vy = parcelRequire("1c4Vy");
var $fbbc6661bdbc08c8$var$originalDestroy = $cRPwj.Readable.destroy;
module.exports = $cRPwj.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $cRPwj._uint8ArrayToBuffer;
module.exports._isUint8Array = $cRPwj._isUint8Array;
module.exports.isDisturbed = $cRPwj.isDisturbed;
module.exports.isErrored = $cRPwj.isErrored;
module.exports.isReadable = $cRPwj.isReadable;
module.exports.Readable = $cRPwj.Readable;
module.exports.Writable = $cRPwj.Writable;
module.exports.Duplex = $cRPwj.Duplex;
module.exports.Transform = $cRPwj.Transform;
module.exports.PassThrough = $cRPwj.PassThrough;
module.exports.addAbortSignal = $cRPwj.addAbortSignal;
module.exports.finished = $cRPwj.finished;
module.exports.destroy = $cRPwj.destroy;
module.exports.destroy = $fbbc6661bdbc08c8$var$originalDestroy;
module.exports.pipeline = $cRPwj.pipeline;
module.exports.compose = $cRPwj.compose;
Object.defineProperty($cRPwj, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $1c4Vy;
    }
});
module.exports.Stream = $cRPwj.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("cRPwj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $lqHhy = parcelRequire("lqHhy");
var $95e2661b39095e9b$require$Buffer = $lqHhy.Buffer;

var $h2bKv = parcelRequire("h2bKv");
/* replacement end */ var $95e2661b39095e9b$var$ObjectDefineProperty = $h2bKv.ObjectDefineProperty, $95e2661b39095e9b$var$ObjectKeys = $h2bKv.ObjectKeys, $95e2661b39095e9b$var$ReflectApply = $h2bKv.ReflectApply;

var $eqibB = parcelRequire("eqibB");
var $95e2661b39095e9b$var$_require_promisify = $eqibB.promisify, $95e2661b39095e9b$var$customPromisify = $95e2661b39095e9b$var$_require_promisify.custom;

var $7Tbrj = parcelRequire("7Tbrj");
var $95e2661b39095e9b$var$streamReturningOperators = $7Tbrj.streamReturningOperators, $95e2661b39095e9b$var$promiseReturningOperators = $7Tbrj.promiseReturningOperators;

var $dOAm6 = parcelRequire("dOAm6");
var $95e2661b39095e9b$var$ERR_ILLEGAL_CONSTRUCTOR = $dOAm6.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $cv0BA = parcelRequire("cv0BA");

var $5poJJ = parcelRequire("5poJJ");
var $95e2661b39095e9b$var$setDefaultHighWaterMark = $5poJJ.setDefaultHighWaterMark, $95e2661b39095e9b$var$getDefaultHighWaterMark = $5poJJ.getDefaultHighWaterMark;

var $clB1p = parcelRequire("clB1p");
var $95e2661b39095e9b$require$pipeline = $clB1p.pipeline;

var $hS2RW = parcelRequire("hS2RW");
var $95e2661b39095e9b$require$destroyer = $hS2RW.destroyer;

var $dsQMn = parcelRequire("dsQMn");
var $95e2661b39095e9b$var$internalBuffer = {};

var $1c4Vy = parcelRequire("1c4Vy");

var $coKti = parcelRequire("coKti");

var $95e2661b39095e9b$var$Stream = module.exports = (parcelRequire("8IJMa")).Stream;
$95e2661b39095e9b$var$Stream.isDestroyed = $coKti.isDestroyed;
$95e2661b39095e9b$var$Stream.isDisturbed = $coKti.isDisturbed;
$95e2661b39095e9b$var$Stream.isErrored = $coKti.isErrored;
$95e2661b39095e9b$var$Stream.isReadable = $coKti.isReadable;
$95e2661b39095e9b$var$Stream.isWritable = $coKti.isWritable;

$95e2661b39095e9b$var$Stream.Readable = (parcelRequire("aUr4N"));
var $95e2661b39095e9b$var$_iteratorNormalCompletion = true, $95e2661b39095e9b$var$_didIteratorError = false, $95e2661b39095e9b$var$_iteratorError = undefined;
try {
    for(var $95e2661b39095e9b$var$_iterator = $95e2661b39095e9b$var$ObjectKeys($95e2661b39095e9b$var$streamReturningOperators)[Symbol.iterator](), $95e2661b39095e9b$var$_step; !($95e2661b39095e9b$var$_iteratorNormalCompletion = ($95e2661b39095e9b$var$_step = $95e2661b39095e9b$var$_iterator.next()).done); $95e2661b39095e9b$var$_iteratorNormalCompletion = true){
        var $95e2661b39095e9b$var$key = $95e2661b39095e9b$var$_step.value;
        var $95e2661b39095e9b$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $95e2661b39095e9b$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $95e2661b39095e9b$var$Stream.Readable.from($95e2661b39095e9b$var$ReflectApply($95e2661b39095e9b$var$op, this, args));
        };
        var $95e2661b39095e9b$var$op = $95e2661b39095e9b$var$streamReturningOperators[$95e2661b39095e9b$var$key];
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$fn, 'name', {
            __proto__: null,
            value: $95e2661b39095e9b$var$op.name
        });
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$fn, 'length', {
            __proto__: null,
            value: $95e2661b39095e9b$var$op.length
        });
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$Stream.Readable.prototype, $95e2661b39095e9b$var$key, {
            __proto__: null,
            value: $95e2661b39095e9b$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $95e2661b39095e9b$var$_didIteratorError = true;
    $95e2661b39095e9b$var$_iteratorError = err;
} finally{
    try {
        if (!$95e2661b39095e9b$var$_iteratorNormalCompletion && $95e2661b39095e9b$var$_iterator["return"] != null) {
            $95e2661b39095e9b$var$_iterator["return"]();
        }
    } finally{
        if ($95e2661b39095e9b$var$_didIteratorError) {
            throw $95e2661b39095e9b$var$_iteratorError;
        }
    }
}
var $95e2661b39095e9b$var$_iteratorNormalCompletion1 = true, $95e2661b39095e9b$var$_didIteratorError1 = false, $95e2661b39095e9b$var$_iteratorError1 = undefined;
try {
    for(var $95e2661b39095e9b$var$_iterator1 = $95e2661b39095e9b$var$ObjectKeys($95e2661b39095e9b$var$promiseReturningOperators)[Symbol.iterator](), $95e2661b39095e9b$var$_step1; !($95e2661b39095e9b$var$_iteratorNormalCompletion1 = ($95e2661b39095e9b$var$_step1 = $95e2661b39095e9b$var$_iterator1.next()).done); $95e2661b39095e9b$var$_iteratorNormalCompletion1 = true){
        var $95e2661b39095e9b$var$key1 = $95e2661b39095e9b$var$_step1.value;
        var $95e2661b39095e9b$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $95e2661b39095e9b$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $95e2661b39095e9b$var$ReflectApply($95e2661b39095e9b$var$op1, this, args);
        };
        var $95e2661b39095e9b$var$op1 = $95e2661b39095e9b$var$promiseReturningOperators[$95e2661b39095e9b$var$key1];
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$fn1, 'name', {
            __proto__: null,
            value: $95e2661b39095e9b$var$op1.name
        });
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$fn1, 'length', {
            __proto__: null,
            value: $95e2661b39095e9b$var$op1.length
        });
        $95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$Stream.Readable.prototype, $95e2661b39095e9b$var$key1, {
            __proto__: null,
            value: $95e2661b39095e9b$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $95e2661b39095e9b$var$_didIteratorError1 = true;
    $95e2661b39095e9b$var$_iteratorError1 = err;
} finally{
    try {
        if (!$95e2661b39095e9b$var$_iteratorNormalCompletion1 && $95e2661b39095e9b$var$_iterator1["return"] != null) {
            $95e2661b39095e9b$var$_iterator1["return"]();
        }
    } finally{
        if ($95e2661b39095e9b$var$_didIteratorError1) {
            throw $95e2661b39095e9b$var$_iteratorError1;
        }
    }
}

$95e2661b39095e9b$var$Stream.Writable = (parcelRequire("hM0g8"));

$95e2661b39095e9b$var$Stream.Duplex = (parcelRequire("5jQJn"));

$95e2661b39095e9b$var$Stream.Transform = (parcelRequire("b0RrJ"));

$95e2661b39095e9b$var$Stream.PassThrough = (parcelRequire("jCm3a"));
$95e2661b39095e9b$var$Stream.pipeline = $95e2661b39095e9b$require$pipeline;

var $fdpM7 = parcelRequire("fdpM7");
var $95e2661b39095e9b$require$addAbortSignal = $fdpM7.addAbortSignal;
$95e2661b39095e9b$var$Stream.addAbortSignal = $95e2661b39095e9b$require$addAbortSignal;
$95e2661b39095e9b$var$Stream.finished = $dsQMn;
$95e2661b39095e9b$var$Stream.destroy = $95e2661b39095e9b$require$destroyer;
$95e2661b39095e9b$var$Stream.compose = $cv0BA;
$95e2661b39095e9b$var$Stream.setDefaultHighWaterMark = $95e2661b39095e9b$var$setDefaultHighWaterMark;
$95e2661b39095e9b$var$Stream.getDefaultHighWaterMark = $95e2661b39095e9b$var$getDefaultHighWaterMark;
$95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $1c4Vy;
    }
});
$95e2661b39095e9b$var$ObjectDefineProperty($95e2661b39095e9b$require$pipeline, $95e2661b39095e9b$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $1c4Vy.pipeline;
    }
});
$95e2661b39095e9b$var$ObjectDefineProperty($dsQMn, $95e2661b39095e9b$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $1c4Vy.finished;
    }
});
// Backwards-compat with node 0.4.x
$95e2661b39095e9b$var$Stream.Stream = $95e2661b39095e9b$var$Stream;
$95e2661b39095e9b$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$95e2661b39095e9b$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $95e2661b39095e9b$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("lqHhy", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f99d999901e0ff6c$export$a143d493d941bafc; }, function (v) { return $f99d999901e0ff6c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f99d999901e0ff6c$export$f99ded8fe4b79145; }, function (v) { return $f99d999901e0ff6c$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $f99d999901e0ff6c$export$a143d493d941bafc;
var $f99d999901e0ff6c$export$e4cf37d7f6fb9e0a;
var $f99d999901e0ff6c$export$f99ded8fe4b79145;
var $f99d999901e0ff6c$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $f99d999901e0ff6c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f99d999901e0ff6c$export$a143d493d941bafc = $f99d999901e0ff6c$var$Buffer;
$f99d999901e0ff6c$export$e4cf37d7f6fb9e0a = $f99d999901e0ff6c$var$SlowBuffer;
$f99d999901e0ff6c$export$f99ded8fe4b79145 = 50;
var $f99d999901e0ff6c$var$K_MAX_LENGTH = 0x7fffffff;
$f99d999901e0ff6c$export$599f31c3813fae4d = $f99d999901e0ff6c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f99d999901e0ff6c$var$Buffer.TYPED_ARRAY_SUPPORT = $f99d999901e0ff6c$var$typedArraySupport();
if (!$f99d999901e0ff6c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f99d999901e0ff6c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f99d999901e0ff6c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$f99d999901e0ff6c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f99d999901e0ff6c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$f99d999901e0ff6c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f99d999901e0ff6c$var$createBuffer(length) {
    if (length > $f99d999901e0ff6c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f99d999901e0ff6c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f99d999901e0ff6c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f99d999901e0ff6c$var$allocUnsafe(arg);
    }
    return $f99d999901e0ff6c$var$from(arg, encodingOrOffset, length);
}
$f99d999901e0ff6c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f99d999901e0ff6c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f99d999901e0ff6c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f99d999901e0ff6c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($f99d999901e0ff6c$var$isInstance(value, ArrayBuffer) || value && $f99d999901e0ff6c$var$isInstance(value.buffer, ArrayBuffer)) return $f99d999901e0ff6c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f99d999901e0ff6c$var$isInstance(value, SharedArrayBuffer) || value && $f99d999901e0ff6c$var$isInstance(value.buffer, SharedArrayBuffer))) return $f99d999901e0ff6c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f99d999901e0ff6c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f99d999901e0ff6c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f99d999901e0ff6c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f99d999901e0ff6c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f99d999901e0ff6c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f99d999901e0ff6c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f99d999901e0ff6c$var$Buffer, Uint8Array);
function $f99d999901e0ff6c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f99d999901e0ff6c$var$alloc(size, fill, encoding) {
    $f99d999901e0ff6c$var$assertSize(size);
    if (size <= 0) return $f99d999901e0ff6c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f99d999901e0ff6c$var$createBuffer(size).fill(fill, encoding) : $f99d999901e0ff6c$var$createBuffer(size).fill(fill);
    return $f99d999901e0ff6c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f99d999901e0ff6c$var$Buffer.alloc = function(size, fill, encoding) {
    return $f99d999901e0ff6c$var$alloc(size, fill, encoding);
};
function $f99d999901e0ff6c$var$allocUnsafe(size) {
    $f99d999901e0ff6c$var$assertSize(size);
    return $f99d999901e0ff6c$var$createBuffer(size < 0 ? 0 : $f99d999901e0ff6c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f99d999901e0ff6c$var$Buffer.allocUnsafe = function(size) {
    return $f99d999901e0ff6c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f99d999901e0ff6c$var$Buffer.allocUnsafeSlow = function(size) {
    return $f99d999901e0ff6c$var$allocUnsafe(size);
};
function $f99d999901e0ff6c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f99d999901e0ff6c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f99d999901e0ff6c$var$byteLength(string, encoding) | 0;
    var buf = $f99d999901e0ff6c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f99d999901e0ff6c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f99d999901e0ff6c$var$checked(array.length) | 0;
    var buf = $f99d999901e0ff6c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f99d999901e0ff6c$var$fromArrayView(arrayView) {
    if ($f99d999901e0ff6c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f99d999901e0ff6c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f99d999901e0ff6c$var$fromArrayLike(arrayView);
}
function $f99d999901e0ff6c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f99d999901e0ff6c$var$Buffer.prototype);
    return buf;
}
function $f99d999901e0ff6c$var$fromObject(obj) {
    if ($f99d999901e0ff6c$var$Buffer.isBuffer(obj)) {
        var len = $f99d999901e0ff6c$var$checked(obj.length) | 0;
        var buf = $f99d999901e0ff6c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f99d999901e0ff6c$var$numberIsNaN(obj.length)) return $f99d999901e0ff6c$var$createBuffer(0);
        return $f99d999901e0ff6c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f99d999901e0ff6c$var$fromArrayLike(obj.data);
}
function $f99d999901e0ff6c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f99d999901e0ff6c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f99d999901e0ff6c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f99d999901e0ff6c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f99d999901e0ff6c$var$Buffer.alloc(+length);
}
$f99d999901e0ff6c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f99d999901e0ff6c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f99d999901e0ff6c$var$Buffer.compare = function compare(a, b) {
    if ($f99d999901e0ff6c$var$isInstance(a, Uint8Array)) a = $f99d999901e0ff6c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f99d999901e0ff6c$var$isInstance(b, Uint8Array)) b = $f99d999901e0ff6c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f99d999901e0ff6c$var$Buffer.isBuffer(a) || !$f99d999901e0ff6c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f99d999901e0ff6c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f99d999901e0ff6c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f99d999901e0ff6c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f99d999901e0ff6c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f99d999901e0ff6c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f99d999901e0ff6c$var$Buffer.isBuffer(buf)) buf = $f99d999901e0ff6c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f99d999901e0ff6c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f99d999901e0ff6c$var$byteLength(string, encoding) {
    if ($f99d999901e0ff6c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f99d999901e0ff6c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f99d999901e0ff6c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f99d999901e0ff6c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f99d999901e0ff6c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f99d999901e0ff6c$var$Buffer.byteLength = $f99d999901e0ff6c$var$byteLength;
function $f99d999901e0ff6c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f99d999901e0ff6c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f99d999901e0ff6c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f99d999901e0ff6c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f99d999901e0ff6c$var$latin1Slice(this, start, end);
        case 'base64':
            return $f99d999901e0ff6c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f99d999901e0ff6c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f99d999901e0ff6c$var$Buffer.prototype._isBuffer = true;
function $f99d999901e0ff6c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f99d999901e0ff6c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f99d999901e0ff6c$var$swap(this, i, i + 1);
    return this;
};
$f99d999901e0ff6c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f99d999901e0ff6c$var$swap(this, i, i + 3);
        $f99d999901e0ff6c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f99d999901e0ff6c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f99d999901e0ff6c$var$swap(this, i, i + 7);
        $f99d999901e0ff6c$var$swap(this, i + 1, i + 6);
        $f99d999901e0ff6c$var$swap(this, i + 2, i + 5);
        $f99d999901e0ff6c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f99d999901e0ff6c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f99d999901e0ff6c$var$utf8Slice(this, 0, length);
    return $f99d999901e0ff6c$var$slowToString.apply(this, arguments);
};
$f99d999901e0ff6c$var$Buffer.prototype.toLocaleString = $f99d999901e0ff6c$var$Buffer.prototype.toString;
$f99d999901e0ff6c$var$Buffer.prototype.equals = function equals(b) {
    if (!$f99d999901e0ff6c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f99d999901e0ff6c$var$Buffer.compare(this, b) === 0;
};
$f99d999901e0ff6c$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f99d999901e0ff6c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f99d999901e0ff6c$var$customInspectSymbol) $f99d999901e0ff6c$var$Buffer.prototype[$f99d999901e0ff6c$var$customInspectSymbol] = $f99d999901e0ff6c$var$Buffer.prototype.inspect;
$f99d999901e0ff6c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f99d999901e0ff6c$var$isInstance(target, Uint8Array)) target = $f99d999901e0ff6c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f99d999901e0ff6c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f99d999901e0ff6c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f99d999901e0ff6c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f99d999901e0ff6c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f99d999901e0ff6c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f99d999901e0ff6c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f99d999901e0ff6c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f99d999901e0ff6c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f99d999901e0ff6c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f99d999901e0ff6c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f99d999901e0ff6c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f99d999901e0ff6c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f99d999901e0ff6c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f99d999901e0ff6c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f99d999901e0ff6c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f99d999901e0ff6c$var$utf8Write(buf, string, offset, length) {
    return $f99d999901e0ff6c$var$blitBuffer($f99d999901e0ff6c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f99d999901e0ff6c$var$asciiWrite(buf, string, offset, length) {
    return $f99d999901e0ff6c$var$blitBuffer($f99d999901e0ff6c$var$asciiToBytes(string), buf, offset, length);
}
function $f99d999901e0ff6c$var$base64Write(buf, string, offset, length) {
    return $f99d999901e0ff6c$var$blitBuffer($f99d999901e0ff6c$var$base64ToBytes(string), buf, offset, length);
}
function $f99d999901e0ff6c$var$ucs2Write(buf, string, offset, length) {
    return $f99d999901e0ff6c$var$blitBuffer($f99d999901e0ff6c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f99d999901e0ff6c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f99d999901e0ff6c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f99d999901e0ff6c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f99d999901e0ff6c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f99d999901e0ff6c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f99d999901e0ff6c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f99d999901e0ff6c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f99d999901e0ff6c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $f99d999901e0ff6c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f99d999901e0ff6c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f99d999901e0ff6c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f99d999901e0ff6c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f99d999901e0ff6c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f99d999901e0ff6c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f99d999901e0ff6c$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f99d999901e0ff6c$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f99d999901e0ff6c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f99d999901e0ff6c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f99d999901e0ff6c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f99d999901e0ff6c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f99d999901e0ff6c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f99d999901e0ff6c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f99d999901e0ff6c$var$Buffer.prototype.readUintLE = $f99d999901e0ff6c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readUintBE = $f99d999901e0ff6c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readUint8 = $f99d999901e0ff6c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f99d999901e0ff6c$var$Buffer.prototype.readUint16LE = $f99d999901e0ff6c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f99d999901e0ff6c$var$Buffer.prototype.readUint16BE = $f99d999901e0ff6c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f99d999901e0ff6c$var$Buffer.prototype.readUint32LE = $f99d999901e0ff6c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f99d999901e0ff6c$var$Buffer.prototype.readUint32BE = $f99d999901e0ff6c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f99d999901e0ff6c$var$Buffer.prototype.readBigUInt64LE = $f99d999901e0ff6c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f99d999901e0ff6c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f99d999901e0ff6c$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f99d999901e0ff6c$var$Buffer.prototype.readBigUInt64BE = $f99d999901e0ff6c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f99d999901e0ff6c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f99d999901e0ff6c$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f99d999901e0ff6c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f99d999901e0ff6c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f99d999901e0ff6c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f99d999901e0ff6c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f99d999901e0ff6c$var$Buffer.prototype.readBigInt64LE = $f99d999901e0ff6c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f99d999901e0ff6c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f99d999901e0ff6c$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$f99d999901e0ff6c$var$Buffer.prototype.readBigInt64BE = $f99d999901e0ff6c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f99d999901e0ff6c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f99d999901e0ff6c$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$f99d999901e0ff6c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$f99d999901e0ff6c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$f99d999901e0ff6c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$f99d999901e0ff6c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $f99d999901e0ff6c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f99d999901e0ff6c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f99d999901e0ff6c$var$Buffer.prototype.writeUintLE = $f99d999901e0ff6c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f99d999901e0ff6c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUintBE = $f99d999901e0ff6c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f99d999901e0ff6c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUint8 = $f99d999901e0ff6c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUint16LE = $f99d999901e0ff6c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUint16BE = $f99d999901e0ff6c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUint32LE = $f99d999901e0ff6c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeUint32BE = $f99d999901e0ff6c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f99d999901e0ff6c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f99d999901e0ff6c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f99d999901e0ff6c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f99d999901e0ff6c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f99d999901e0ff6c$var$Buffer.prototype.writeBigUInt64LE = $f99d999901e0ff6c$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f99d999901e0ff6c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f99d999901e0ff6c$var$Buffer.prototype.writeBigUInt64BE = $f99d999901e0ff6c$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f99d999901e0ff6c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f99d999901e0ff6c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f99d999901e0ff6c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f99d999901e0ff6c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f99d999901e0ff6c$var$Buffer.prototype.writeBigInt64LE = $f99d999901e0ff6c$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f99d999901e0ff6c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f99d999901e0ff6c$var$Buffer.prototype.writeBigInt64BE = $f99d999901e0ff6c$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f99d999901e0ff6c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f99d999901e0ff6c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f99d999901e0ff6c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f99d999901e0ff6c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f99d999901e0ff6c$var$writeFloat(this, value, offset, true, noAssert);
};
$f99d999901e0ff6c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f99d999901e0ff6c$var$writeFloat(this, value, offset, false, noAssert);
};
function $f99d999901e0ff6c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f99d999901e0ff6c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f99d999901e0ff6c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f99d999901e0ff6c$var$writeDouble(this, value, offset, true, noAssert);
};
$f99d999901e0ff6c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f99d999901e0ff6c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f99d999901e0ff6c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f99d999901e0ff6c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f99d999901e0ff6c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f99d999901e0ff6c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f99d999901e0ff6c$var$Buffer.isBuffer(val) ? val : $f99d999901e0ff6c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $f99d999901e0ff6c$var$errors = {};
function $f99d999901e0ff6c$var$E(sym, getMessage, Base) {
    $f99d999901e0ff6c$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$f99d999901e0ff6c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f99d999901e0ff6c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$f99d999901e0ff6c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $f99d999901e0ff6c$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $f99d999901e0ff6c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $f99d999901e0ff6c$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $f99d999901e0ff6c$var$checkBounds(buf, offset, byteLength) {
    $f99d999901e0ff6c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f99d999901e0ff6c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f99d999901e0ff6c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $f99d999901e0ff6c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f99d999901e0ff6c$var$checkBounds(buf, offset, byteLength);
}
function $f99d999901e0ff6c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f99d999901e0ff6c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f99d999901e0ff6c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f99d999901e0ff6c$var$validateNumber(value, type);
        throw new $f99d999901e0ff6c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f99d999901e0ff6c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f99d999901e0ff6c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $f99d999901e0ff6c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f99d999901e0ff6c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f99d999901e0ff6c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f99d999901e0ff6c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f99d999901e0ff6c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f99d999901e0ff6c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f99d999901e0ff6c$var$base64ToBytes(str) {
    return $abUaD.toByteArray($f99d999901e0ff6c$var$base64clean(str));
}
function $f99d999901e0ff6c$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f99d999901e0ff6c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f99d999901e0ff6c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f99d999901e0ff6c$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f99d999901e0ff6c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f99d999901e0ff6c$var$BufferBigIntNotDefined : fn;
}
function $f99d999901e0ff6c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("h2bKv", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $c66bbcb38f9d88a5$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $c66bbcb38f9d88a5$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("eqibB", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $lqHhy = parcelRequire("lqHhy");

var $10XCS = parcelRequire("10XCS");
var $a80199c6c72dc83c$var$format = $10XCS.format, $a80199c6c72dc83c$var$inspect = $10XCS.inspect;

var $dOAm6 = parcelRequire("dOAm6");
var $a80199c6c72dc83c$var$ERR_INVALID_ARG_TYPE = $dOAm6.codes.ERR_INVALID_ARG_TYPE;

var $h2bKv = parcelRequire("h2bKv");
var $a80199c6c72dc83c$var$kResistStopPropagation = $h2bKv.kResistStopPropagation, $a80199c6c72dc83c$var$AggregateError = $h2bKv.AggregateError, $a80199c6c72dc83c$var$SymbolDispose = $h2bKv.SymbolDispose;

var $a80199c6c72dc83c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $a80199c6c72dc83c$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $a80199c6c72dc83c$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $a80199c6c72dc83c$var$Blob = globalThis.Blob || $lqHhy.Blob;
/* eslint-disable indent */ var $a80199c6c72dc83c$var$isBlob = typeof $a80199c6c72dc83c$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $a80199c6c72dc83c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $a80199c6c72dc83c$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $a80199c6c72dc83c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $a80199c6c72dc83c$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $a80199c6c72dc83c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $a80199c6c72dc83c$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $a80199c6c72dc83c$var$format,
    inspect: $a80199c6c72dc83c$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $a80199c6c72dc83c$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $a80199c6c72dc83c$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $a80199c6c72dc83c$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $a80199c6c72dc83c$var$validateAbortSignal(signal, 'signal');
        $a80199c6c72dc83c$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $a80199c6c72dc83c$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $a80199c6c72dc83c$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $a80199c6c72dc83c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $a80199c6c72dc83c$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $a80199c6c72dc83c$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("10XCS", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("dOAm6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $10XCS = parcelRequire("10XCS");
var $a0ec25541077a085$var$format = $10XCS.format, $a0ec25541077a085$var$inspect = $10XCS.inspect;

var $h2bKv = parcelRequire("h2bKv");
var $a0ec25541077a085$var$CustomAggregateError = $h2bKv.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $a0ec25541077a085$var$AggregateError = globalThis.AggregateError || $a0ec25541077a085$var$CustomAggregateError;
var $a0ec25541077a085$var$kIsNodeError = Symbol('kIsNodeError');
var $a0ec25541077a085$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $a0ec25541077a085$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $a0ec25541077a085$var$nodeInternalPrefix = '__node_internal_';
var $a0ec25541077a085$var$codes = {};
function $a0ec25541077a085$var$assert(value, message) {
    if (!value) throw new $a0ec25541077a085$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $a0ec25541077a085$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $a0ec25541077a085$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $a0ec25541077a085$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $a0ec25541077a085$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $a0ec25541077a085$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $a0ec25541077a085$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $a0ec25541077a085$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$a0ec25541077a085$var$kIsNodeError] = true;
    $a0ec25541077a085$var$codes[code] = NodeError;
}
function $a0ec25541077a085$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $a0ec25541077a085$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $a0ec25541077a085$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $a0ec25541077a085$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $a0ec25541077a085$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $a0ec25541077a085$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$a0ec25541077a085$var$E('ERR_ASSERTION', '%s', Error);
$a0ec25541077a085$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $a0ec25541077a085$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $a0ec25541077a085$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($a0ec25541077a085$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($a0ec25541077a085$var$classRegExp.test(value)) instances.push(value);
            else {
                $a0ec25541077a085$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $a0ec25541077a085$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $a0ec25541077a085$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$a0ec25541077a085$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $a0ec25541077a085$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$a0ec25541077a085$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$a0ec25541077a085$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $a0ec25541077a085$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$a0ec25541077a085$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $a0ec25541077a085$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $a0ec25541077a085$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $a0ec25541077a085$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $a0ec25541077a085$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$a0ec25541077a085$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$a0ec25541077a085$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$a0ec25541077a085$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$a0ec25541077a085$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$a0ec25541077a085$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$a0ec25541077a085$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$a0ec25541077a085$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$a0ec25541077a085$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$a0ec25541077a085$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$a0ec25541077a085$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$a0ec25541077a085$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $a0ec25541077a085$var$AbortError,
    aggregateTwoErrors: $a0ec25541077a085$var$hideStackFrames($a0ec25541077a085$var$aggregateTwoErrors),
    hideStackFrames: $a0ec25541077a085$var$hideStackFrames,
    codes: $a0ec25541077a085$var$codes
};

});


parcelRegister("7Tbrj", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $5be68b1ce5f06a32$export$42af8c323be37587; }, function (v) { return $5be68b1ce5f06a32$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $5be68b1ce5f06a32$export$f405f72c701dad87; }, function (v) { return $5be68b1ce5f06a32$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $5be68b1ce5f06a32$export$42af8c323be37587;
var $5be68b1ce5f06a32$export$f405f72c701dad87;
'use strict';

var $5be68b1ce5f06a32$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $dOAm6 = parcelRequire("dOAm6");
var $5be68b1ce5f06a32$var$_require_codes = $dOAm6.codes, $5be68b1ce5f06a32$var$ERR_INVALID_ARG_VALUE = $5be68b1ce5f06a32$var$_require_codes.ERR_INVALID_ARG_VALUE, $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE = $5be68b1ce5f06a32$var$_require_codes.ERR_INVALID_ARG_TYPE, $5be68b1ce5f06a32$var$ERR_MISSING_ARGS = $5be68b1ce5f06a32$var$_require_codes.ERR_MISSING_ARGS, $5be68b1ce5f06a32$var$ERR_OUT_OF_RANGE = $5be68b1ce5f06a32$var$_require_codes.ERR_OUT_OF_RANGE, $5be68b1ce5f06a32$var$AbortError = $dOAm6.AbortError;

var $2ih1i = parcelRequire("2ih1i");
var $5be68b1ce5f06a32$var$validateAbortSignal = $2ih1i.validateAbortSignal, $5be68b1ce5f06a32$var$validateInteger = $2ih1i.validateInteger, $5be68b1ce5f06a32$var$validateObject = $2ih1i.validateObject;

var $5be68b1ce5f06a32$var$kWeakHandler = (parcelRequire("h2bKv")).Symbol('kWeak');

var $5be68b1ce5f06a32$var$kResistStopPropagation = (parcelRequire("h2bKv")).Symbol('kResistStopPropagation');

var $dsQMn = parcelRequire("dsQMn");
var $5be68b1ce5f06a32$require$finished = $dsQMn.finished;

var $cv0BA = parcelRequire("cv0BA");

var $fdpM7 = parcelRequire("fdpM7");
var $5be68b1ce5f06a32$require$addAbortSignalNoValidate = $fdpM7.addAbortSignalNoValidate;

var $coKti = parcelRequire("coKti");
var $5be68b1ce5f06a32$var$isWritable = $coKti.isWritable, $5be68b1ce5f06a32$var$isNodeStream = $coKti.isNodeStream;

var $5be68b1ce5f06a32$require$deprecate = (parcelRequire("eqibB")).deprecate;

var $5be68b1ce5f06a32$var$ArrayPrototypePush = (parcelRequire("h2bKv")).ArrayPrototypePush, $5be68b1ce5f06a32$var$Boolean = (parcelRequire("h2bKv")).Boolean, $5be68b1ce5f06a32$var$MathFloor = (parcelRequire("h2bKv")).MathFloor, $5be68b1ce5f06a32$var$Number = (parcelRequire("h2bKv")).Number, $5be68b1ce5f06a32$var$NumberIsNaN = (parcelRequire("h2bKv")).NumberIsNaN, $5be68b1ce5f06a32$var$Promise = (parcelRequire("h2bKv")).Promise, $5be68b1ce5f06a32$var$PromiseReject = (parcelRequire("h2bKv")).PromiseReject, $5be68b1ce5f06a32$var$PromiseResolve = (parcelRequire("h2bKv")).PromiseResolve, $5be68b1ce5f06a32$var$PromisePrototypeThen = (parcelRequire("h2bKv")).PromisePrototypeThen, $5be68b1ce5f06a32$var$Symbol = (parcelRequire("h2bKv")).Symbol;
var $5be68b1ce5f06a32$var$kEmpty = $5be68b1ce5f06a32$var$Symbol('kEmpty');
var $5be68b1ce5f06a32$var$kEof = $5be68b1ce5f06a32$var$Symbol('kEof');
function $5be68b1ce5f06a32$var$compose(stream, options) {
    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
    if ($5be68b1ce5f06a32$var$isNodeStream(stream) && !$5be68b1ce5f06a32$var$isWritable(stream)) throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $cv0BA(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $5be68b1ce5f06a32$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $5be68b1ce5f06a32$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $5be68b1ce5f06a32$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $5be68b1ce5f06a32$var$MathFloor(options.highWaterMark);
    $5be68b1ce5f06a32$var$validateInteger(concurrency, 'options.concurrency', 1);
    $5be68b1ce5f06a32$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $5be68b1ce5f06a32$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $5be68b1ce5f06a32$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $5be68b1ce5f06a32$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $5be68b1ce5f06a32$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $5be68b1ce5f06a32$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($5be68b1ce5f06a32$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $5be68b1ce5f06a32$var$PromiseReject(err1);
                                $5be68b1ce5f06a32$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("eqibB")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($5be68b1ce5f06a32$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $5be68b1ce5f06a32$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                        if (!(val !== $5be68b1ce5f06a32$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $5be68b1ce5f06a32$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $5be68b1ce5f06a32$var$asIndexedPairs(options) {
    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $5be68b1ce5f06a32$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $5be68b1ce5f06a32$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($5be68b1ce5f06a32$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $5be68b1ce5f06a32$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $5be68b1ce5f06a32$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $5be68b1ce5f06a32$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($5be68b1ce5f06a32$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $5be68b1ce5f06a32$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $5be68b1ce5f06a32$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($5be68b1ce5f06a32$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $5be68b1ce5f06a32$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $5be68b1ce5f06a32$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $5be68b1ce5f06a32$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $5be68b1ce5f06a32$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($5be68b1ce5f06a32$var$ERR_MISSING_ARGS);
function $5be68b1ce5f06a32$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $5be68b1ce5f06a32$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $5be68b1ce5f06a32$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $5be68b1ce5f06a32$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $5be68b1ce5f06a32$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $5be68b1ce5f06a32$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $5be68b1ce5f06a32$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $5be68b1ce5f06a32$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $5be68b1ce5f06a32$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $5be68b1ce5f06a32$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $5be68b1ce5f06a32$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $5be68b1ce5f06a32$var$flatMap(fn, options) {
    var values = $5be68b1ce5f06a32$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $5be68b1ce5f06a32$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $5be68b1ce5f06a32$var$Number(number);
    if ($5be68b1ce5f06a32$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $5be68b1ce5f06a32$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $5be68b1ce5f06a32$var$drop(number, options) {
    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
    number = $5be68b1ce5f06a32$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $5be68b1ce5f06a32$var$take(number, options) {
    if (options != null) $5be68b1ce5f06a32$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $5be68b1ce5f06a32$var$validateAbortSignal(options.signal, 'options.signal');
    number = $5be68b1ce5f06a32$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $5be68b1ce5f06a32$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$5be68b1ce5f06a32$export$42af8c323be37587 = {
    asIndexedPairs: $5be68b1ce5f06a32$require$deprecate($5be68b1ce5f06a32$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $5be68b1ce5f06a32$var$drop,
    filter: $5be68b1ce5f06a32$var$filter,
    flatMap: $5be68b1ce5f06a32$var$flatMap,
    map: $5be68b1ce5f06a32$var$map,
    take: $5be68b1ce5f06a32$var$take,
    compose: $5be68b1ce5f06a32$var$compose
};
$5be68b1ce5f06a32$export$f405f72c701dad87 = {
    every: $5be68b1ce5f06a32$var$every,
    forEach: $5be68b1ce5f06a32$var$forEach,
    reduce: $5be68b1ce5f06a32$var$reduce,
    toArray: $5be68b1ce5f06a32$var$toArray,
    some: $5be68b1ce5f06a32$var$some,
    find: $5be68b1ce5f06a32$var$find
};

});
parcelRegister("2ih1i", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $1aba76fc0b58daa0$var$ArrayIsArray = $h2bKv.ArrayIsArray, $1aba76fc0b58daa0$var$ArrayPrototypeIncludes = $h2bKv.ArrayPrototypeIncludes, $1aba76fc0b58daa0$var$ArrayPrototypeJoin = $h2bKv.ArrayPrototypeJoin, $1aba76fc0b58daa0$var$ArrayPrototypeMap = $h2bKv.ArrayPrototypeMap, $1aba76fc0b58daa0$var$NumberIsInteger = $h2bKv.NumberIsInteger, $1aba76fc0b58daa0$var$NumberIsNaN = $h2bKv.NumberIsNaN, $1aba76fc0b58daa0$var$NumberMAX_SAFE_INTEGER = $h2bKv.NumberMAX_SAFE_INTEGER, $1aba76fc0b58daa0$var$NumberMIN_SAFE_INTEGER = $h2bKv.NumberMIN_SAFE_INTEGER, $1aba76fc0b58daa0$var$NumberParseInt = $h2bKv.NumberParseInt, $1aba76fc0b58daa0$var$ObjectPrototypeHasOwnProperty = $h2bKv.ObjectPrototypeHasOwnProperty, $1aba76fc0b58daa0$var$RegExpPrototypeExec = $h2bKv.RegExpPrototypeExec, $1aba76fc0b58daa0$var$String = $h2bKv.String, $1aba76fc0b58daa0$var$StringPrototypeToUpperCase = $h2bKv.StringPrototypeToUpperCase, $1aba76fc0b58daa0$var$StringPrototypeTrim = $h2bKv.StringPrototypeTrim;

var $dOAm6 = parcelRequire("dOAm6");
var $1aba76fc0b58daa0$var$hideStackFrames = $dOAm6.hideStackFrames, $1aba76fc0b58daa0$var$_require_codes = $dOAm6.codes, $1aba76fc0b58daa0$var$ERR_SOCKET_BAD_PORT = $1aba76fc0b58daa0$var$_require_codes.ERR_SOCKET_BAD_PORT, $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE = $1aba76fc0b58daa0$var$_require_codes.ERR_INVALID_ARG_TYPE, $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE = $1aba76fc0b58daa0$var$_require_codes.ERR_INVALID_ARG_VALUE, $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE = $1aba76fc0b58daa0$var$_require_codes.ERR_OUT_OF_RANGE, $1aba76fc0b58daa0$var$ERR_UNKNOWN_SIGNAL = $1aba76fc0b58daa0$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $eqibB = parcelRequire("eqibB");
var $1aba76fc0b58daa0$require$normalizeEncoding = $eqibB.normalizeEncoding;

var $eqibB = parcelRequire("eqibB");
var $1aba76fc0b58daa0$require$_require_types = $eqibB.types;
var $1aba76fc0b58daa0$var$isAsyncFunction = $1aba76fc0b58daa0$require$_require_types.isAsyncFunction, $1aba76fc0b58daa0$var$isArrayBufferView = $1aba76fc0b58daa0$require$_require_types.isArrayBufferView;
var $1aba76fc0b58daa0$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $1aba76fc0b58daa0$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $1aba76fc0b58daa0$var$isUint32(value) {
    return value === value >>> 0;
}
var $1aba76fc0b58daa0$var$octalReg = /^[0-7]+$/;
var $1aba76fc0b58daa0$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $1aba76fc0b58daa0$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($1aba76fc0b58daa0$var$RegExpPrototypeExec($1aba76fc0b58daa0$var$octalReg, value) === null) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE(name, value, $1aba76fc0b58daa0$var$modeDesc);
        value = $1aba76fc0b58daa0$var$NumberParseInt(value, 8);
    }
    $1aba76fc0b58daa0$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $1aba76fc0b58daa0$var$validateInteger = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $1aba76fc0b58daa0$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1aba76fc0b58daa0$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$1aba76fc0b58daa0$var$NumberIsInteger(value)) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $1aba76fc0b58daa0$var$validateInt32 = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$1aba76fc0b58daa0$var$NumberIsInteger(value)) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $1aba76fc0b58daa0$var$validateUint32 = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$1aba76fc0b58daa0$var$NumberIsInteger(value)) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $1aba76fc0b58daa0$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $1aba76fc0b58daa0$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $1aba76fc0b58daa0$var$NumberIsNaN(value)) throw new $1aba76fc0b58daa0$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $1aba76fc0b58daa0$var$validateOneOf = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name, oneOf) {
    if (!$1aba76fc0b58daa0$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $1aba76fc0b58daa0$var$ArrayPrototypeJoin($1aba76fc0b58daa0$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $1aba76fc0b58daa0$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $1aba76fc0b58daa0$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $1aba76fc0b58daa0$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$1aba76fc0b58daa0$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $1aba76fc0b58daa0$var$validateObject = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $1aba76fc0b58daa0$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $1aba76fc0b58daa0$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $1aba76fc0b58daa0$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $1aba76fc0b58daa0$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $1aba76fc0b58daa0$var$validateDictionary = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $1aba76fc0b58daa0$var$validateArray = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$1aba76fc0b58daa0$var$ArrayIsArray(value)) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $1aba76fc0b58daa0$var$validateStringArray(value, name) {
    $1aba76fc0b58daa0$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$1aba76fc0b58daa0$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $1aba76fc0b58daa0$var$validateBooleanArray(value, name) {
    $1aba76fc0b58daa0$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$1aba76fc0b58daa0$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $1aba76fc0b58daa0$var$validateAbortSignalArray(value, name) {
    $1aba76fc0b58daa0$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $1aba76fc0b58daa0$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $1aba76fc0b58daa0$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $1aba76fc0b58daa0$var$validateString(signal, name);
    if ($1aba76fc0b58daa0$var$signals[signal] === undefined) {
        if ($1aba76fc0b58daa0$var$signals[$1aba76fc0b58daa0$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $1aba76fc0b58daa0$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $1aba76fc0b58daa0$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $1aba76fc0b58daa0$var$validateBuffer = $1aba76fc0b58daa0$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$1aba76fc0b58daa0$var$isArrayBufferView(buffer)) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $1aba76fc0b58daa0$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $1aba76fc0b58daa0$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $1aba76fc0b58daa0$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $1aba76fc0b58daa0$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $1aba76fc0b58daa0$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $1aba76fc0b58daa0$var$validateAbortSignal = $1aba76fc0b58daa0$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $1aba76fc0b58daa0$var$validateFunction = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $1aba76fc0b58daa0$var$validatePlainFunction = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $1aba76fc0b58daa0$var$isAsyncFunction(value)) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $1aba76fc0b58daa0$var$validateUndefined = $1aba76fc0b58daa0$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $1aba76fc0b58daa0$var$validateUnion(value, name, union) {
    if (!$1aba76fc0b58daa0$var$ArrayPrototypeIncludes(union, value)) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_TYPE(name, "('".concat($1aba76fc0b58daa0$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $1aba76fc0b58daa0$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $1aba76fc0b58daa0$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$1aba76fc0b58daa0$var$RegExpPrototypeExec($1aba76fc0b58daa0$var$linkValueRegExp, value)) throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $1aba76fc0b58daa0$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $1aba76fc0b58daa0$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($1aba76fc0b58daa0$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $1aba76fc0b58daa0$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $1aba76fc0b58daa0$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $1aba76fc0b58daa0$var$isInt32,
    isUint32: $1aba76fc0b58daa0$var$isUint32,
    parseFileMode: $1aba76fc0b58daa0$var$parseFileMode,
    validateArray: $1aba76fc0b58daa0$var$validateArray,
    validateStringArray: $1aba76fc0b58daa0$var$validateStringArray,
    validateBooleanArray: $1aba76fc0b58daa0$var$validateBooleanArray,
    validateAbortSignalArray: $1aba76fc0b58daa0$var$validateAbortSignalArray,
    validateBoolean: $1aba76fc0b58daa0$var$validateBoolean,
    validateBuffer: $1aba76fc0b58daa0$var$validateBuffer,
    validateDictionary: $1aba76fc0b58daa0$var$validateDictionary,
    validateEncoding: $1aba76fc0b58daa0$var$validateEncoding,
    validateFunction: $1aba76fc0b58daa0$var$validateFunction,
    validateInt32: $1aba76fc0b58daa0$var$validateInt32,
    validateInteger: $1aba76fc0b58daa0$var$validateInteger,
    validateNumber: $1aba76fc0b58daa0$var$validateNumber,
    validateObject: $1aba76fc0b58daa0$var$validateObject,
    validateOneOf: $1aba76fc0b58daa0$var$validateOneOf,
    validatePlainFunction: $1aba76fc0b58daa0$var$validatePlainFunction,
    validatePort: $1aba76fc0b58daa0$var$validatePort,
    validateSignalName: $1aba76fc0b58daa0$var$validateSignalName,
    validateString: $1aba76fc0b58daa0$var$validateString,
    validateUint32: $1aba76fc0b58daa0$var$validateUint32,
    validateUndefined: $1aba76fc0b58daa0$var$validateUndefined,
    validateUnion: $1aba76fc0b58daa0$var$validateUnion,
    validateAbortSignal: $1aba76fc0b58daa0$var$validateAbortSignal,
    validateLinkHeaderValue: $1aba76fc0b58daa0$var$validateLinkHeaderValue
};

});

parcelRegister("dsQMn", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $dOAm6 = parcelRequire("dOAm6");
/* replacement end */ var $9cd6d4c4a7f69537$var$AbortError = $dOAm6.AbortError, $9cd6d4c4a7f69537$var$codes = $dOAm6.codes;
var $9cd6d4c4a7f69537$var$ERR_INVALID_ARG_TYPE = $9cd6d4c4a7f69537$var$codes.ERR_INVALID_ARG_TYPE, $9cd6d4c4a7f69537$var$ERR_STREAM_PREMATURE_CLOSE = $9cd6d4c4a7f69537$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $9cd6d4c4a7f69537$var$kEmptyObject = (parcelRequire("eqibB")).kEmptyObject, $9cd6d4c4a7f69537$var$once = (parcelRequire("eqibB")).once;

var $2ih1i = parcelRequire("2ih1i");
var $9cd6d4c4a7f69537$var$validateAbortSignal = $2ih1i.validateAbortSignal, $9cd6d4c4a7f69537$var$validateFunction = $2ih1i.validateFunction, $9cd6d4c4a7f69537$var$validateObject = $2ih1i.validateObject, $9cd6d4c4a7f69537$var$validateBoolean = $2ih1i.validateBoolean;

var $h2bKv = parcelRequire("h2bKv");
var $9cd6d4c4a7f69537$var$Promise = $h2bKv.Promise, $9cd6d4c4a7f69537$var$PromisePrototypeThen = $h2bKv.PromisePrototypeThen, $9cd6d4c4a7f69537$var$SymbolDispose = $h2bKv.SymbolDispose;

var $coKti = parcelRequire("coKti");
var $9cd6d4c4a7f69537$var$isClosed = $coKti.isClosed, $9cd6d4c4a7f69537$var$isReadable = $coKti.isReadable, $9cd6d4c4a7f69537$var$isReadableNodeStream = $coKti.isReadableNodeStream, $9cd6d4c4a7f69537$var$isReadableStream = $coKti.isReadableStream, $9cd6d4c4a7f69537$var$isReadableFinished = $coKti.isReadableFinished, $9cd6d4c4a7f69537$var$isReadableErrored = $coKti.isReadableErrored, $9cd6d4c4a7f69537$var$isWritable = $coKti.isWritable, $9cd6d4c4a7f69537$var$isWritableNodeStream = $coKti.isWritableNodeStream, $9cd6d4c4a7f69537$var$isWritableStream = $coKti.isWritableStream, $9cd6d4c4a7f69537$var$isWritableFinished = $coKti.isWritableFinished, $9cd6d4c4a7f69537$var$isWritableErrored = $coKti.isWritableErrored, $9cd6d4c4a7f69537$var$isNodeStream = $coKti.isNodeStream, $9cd6d4c4a7f69537$var$_willEmitClose = $coKti.willEmitClose, $9cd6d4c4a7f69537$var$kIsClosedPromise = $coKti.kIsClosedPromise;
var $9cd6d4c4a7f69537$var$addAbortListener;
function $9cd6d4c4a7f69537$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $9cd6d4c4a7f69537$var$nop = function() {};

function $9cd6d4c4a7f69537$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $9cd6d4c4a7f69537$var$kEmptyObject;
    } else if (options == null) options = $9cd6d4c4a7f69537$var$kEmptyObject;
    else $9cd6d4c4a7f69537$var$validateObject(options, 'options');
    $9cd6d4c4a7f69537$var$validateFunction(callback, 'callback');
    $9cd6d4c4a7f69537$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $9cd6d4c4a7f69537$var$once(callback);
    if ($9cd6d4c4a7f69537$var$isReadableStream(stream) || $9cd6d4c4a7f69537$var$isWritableStream(stream)) return $9cd6d4c4a7f69537$var$eosWeb(stream, options, callback);
    if (!$9cd6d4c4a7f69537$var$isNodeStream(stream)) throw new $9cd6d4c4a7f69537$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $9cd6d4c4a7f69537$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $9cd6d4c4a7f69537$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $9cd6d4c4a7f69537$var$_willEmitClose(stream) && $9cd6d4c4a7f69537$var$isReadableNodeStream(stream) === readable && $9cd6d4c4a7f69537$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $9cd6d4c4a7f69537$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $9cd6d4c4a7f69537$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $9cd6d4c4a7f69537$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $9cd6d4c4a7f69537$var$isWritableErrored(stream) || $9cd6d4c4a7f69537$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $9cd6d4c4a7f69537$var$isReadableNodeStream(stream, true)) {
            if (!$9cd6d4c4a7f69537$var$isReadableFinished(stream, false)) return callback.call(stream, new $9cd6d4c4a7f69537$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$9cd6d4c4a7f69537$var$isWritableFinished(stream, false)) return callback.call(stream, new $9cd6d4c4a7f69537$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $9cd6d4c4a7f69537$var$isWritableErrored(stream) || $9cd6d4c4a7f69537$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($9cd6d4c4a7f69537$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $9cd6d4c4a7f69537$var$isReadable(stream)) && (writableFinished || $9cd6d4c4a7f69537$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $9cd6d4c4a7f69537$var$isWritable(stream)) && (readableFinished || $9cd6d4c4a7f69537$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $9cd6d4c4a7f69537$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $9cd6d4c4a7f69537$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $9cd6d4c4a7f69537$var$addAbortListener = $9cd6d4c4a7f69537$var$addAbortListener || (parcelRequire("eqibB")).addAbortListener;
            var disposable = $9cd6d4c4a7f69537$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $9cd6d4c4a7f69537$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$9cd6d4c4a7f69537$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $9cd6d4c4a7f69537$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $9cd6d4c4a7f69537$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $9cd6d4c4a7f69537$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $9cd6d4c4a7f69537$var$addAbortListener = $9cd6d4c4a7f69537$var$addAbortListener || (parcelRequire("eqibB")).addAbortListener;
            var disposable = $9cd6d4c4a7f69537$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $9cd6d4c4a7f69537$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$9cd6d4c4a7f69537$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $9cd6d4c4a7f69537$var$PromisePrototypeThen(stream[$9cd6d4c4a7f69537$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $9cd6d4c4a7f69537$var$nop;
}
function $9cd6d4c4a7f69537$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $9cd6d4c4a7f69537$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $9cd6d4c4a7f69537$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $9cd6d4c4a7f69537$var$Promise(function(resolve, reject) {
        var cleanup = $9cd6d4c4a7f69537$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $9cd6d4c4a7f69537$var$eos;
module.exports.finished = $9cd6d4c4a7f69537$var$finished;

});
parcelRegister("coKti", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $906bc63953d3b5dd$var$SymbolAsyncIterator = $h2bKv.SymbolAsyncIterator, $906bc63953d3b5dd$var$SymbolIterator = $h2bKv.SymbolIterator, $906bc63953d3b5dd$var$SymbolFor = $h2bKv.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $906bc63953d3b5dd$var$kIsDestroyed = $906bc63953d3b5dd$var$SymbolFor('nodejs.stream.destroyed');
var $906bc63953d3b5dd$var$kIsErrored = $906bc63953d3b5dd$var$SymbolFor('nodejs.stream.errored');
var $906bc63953d3b5dd$var$kIsReadable = $906bc63953d3b5dd$var$SymbolFor('nodejs.stream.readable');
var $906bc63953d3b5dd$var$kIsWritable = $906bc63953d3b5dd$var$SymbolFor('nodejs.stream.writable');
var $906bc63953d3b5dd$var$kIsDisturbed = $906bc63953d3b5dd$var$SymbolFor('nodejs.stream.disturbed');
var $906bc63953d3b5dd$var$kIsClosedPromise = $906bc63953d3b5dd$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $906bc63953d3b5dd$var$kControllerErrorFunction = $906bc63953d3b5dd$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $906bc63953d3b5dd$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $906bc63953d3b5dd$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $906bc63953d3b5dd$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $906bc63953d3b5dd$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $906bc63953d3b5dd$var$isReadableStream(obj) {
    return !!(obj && !$906bc63953d3b5dd$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $906bc63953d3b5dd$var$isWritableStream(obj) {
    return !!(obj && !$906bc63953d3b5dd$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $906bc63953d3b5dd$var$isTransformStream(obj) {
    return !!(obj && !$906bc63953d3b5dd$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $906bc63953d3b5dd$var$isWebStream(obj) {
    return $906bc63953d3b5dd$var$isReadableStream(obj) || $906bc63953d3b5dd$var$isWritableStream(obj) || $906bc63953d3b5dd$var$isTransformStream(obj);
}
function $906bc63953d3b5dd$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$906bc63953d3b5dd$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$906bc63953d3b5dd$var$SymbolIterator] === 'function';
    return typeof obj[$906bc63953d3b5dd$var$SymbolAsyncIterator] === 'function' || typeof obj[$906bc63953d3b5dd$var$SymbolIterator] === 'function';
}
function $906bc63953d3b5dd$var$isDestroyed(stream) {
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$906bc63953d3b5dd$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $906bc63953d3b5dd$var$isWritableEnded(stream) {
    if (!$906bc63953d3b5dd$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $906bc63953d3b5dd$var$isWritableFinished(stream, strict) {
    if (!$906bc63953d3b5dd$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $906bc63953d3b5dd$var$isReadableEnded(stream) {
    if (!$906bc63953d3b5dd$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $906bc63953d3b5dd$var$isReadableFinished(stream, strict) {
    if (!$906bc63953d3b5dd$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $906bc63953d3b5dd$var$isReadable(stream) {
    if (stream && stream[$906bc63953d3b5dd$var$kIsReadable] != null) return stream[$906bc63953d3b5dd$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($906bc63953d3b5dd$var$isDestroyed(stream)) return false;
    return $906bc63953d3b5dd$var$isReadableNodeStream(stream) && stream.readable && !$906bc63953d3b5dd$var$isReadableFinished(stream);
}
function $906bc63953d3b5dd$var$isWritable(stream) {
    if (stream && stream[$906bc63953d3b5dd$var$kIsWritable] != null) return stream[$906bc63953d3b5dd$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($906bc63953d3b5dd$var$isDestroyed(stream)) return false;
    return $906bc63953d3b5dd$var$isWritableNodeStream(stream) && stream.writable && !$906bc63953d3b5dd$var$isWritableEnded(stream);
}
function $906bc63953d3b5dd$var$isFinished(stream, opts) {
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    if ($906bc63953d3b5dd$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $906bc63953d3b5dd$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $906bc63953d3b5dd$var$isWritable(stream)) return false;
    return true;
}
function $906bc63953d3b5dd$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $906bc63953d3b5dd$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $906bc63953d3b5dd$var$isClosed(stream) {
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $906bc63953d3b5dd$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $906bc63953d3b5dd$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $906bc63953d3b5dd$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $906bc63953d3b5dd$var$isOutgoingMessage(stream);
}
function $906bc63953d3b5dd$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $906bc63953d3b5dd$var$willEmitClose(stream) {
    if (!$906bc63953d3b5dd$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $906bc63953d3b5dd$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $906bc63953d3b5dd$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$906bc63953d3b5dd$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $906bc63953d3b5dd$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$906bc63953d3b5dd$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $906bc63953d3b5dd$var$isDestroyed,
    kIsDestroyed: $906bc63953d3b5dd$var$kIsDestroyed,
    isDisturbed: $906bc63953d3b5dd$var$isDisturbed,
    kIsDisturbed: $906bc63953d3b5dd$var$kIsDisturbed,
    isErrored: $906bc63953d3b5dd$var$isErrored,
    kIsErrored: $906bc63953d3b5dd$var$kIsErrored,
    isReadable: $906bc63953d3b5dd$var$isReadable,
    kIsReadable: $906bc63953d3b5dd$var$kIsReadable,
    kIsClosedPromise: $906bc63953d3b5dd$var$kIsClosedPromise,
    kControllerErrorFunction: $906bc63953d3b5dd$var$kControllerErrorFunction,
    kIsWritable: $906bc63953d3b5dd$var$kIsWritable,
    isClosed: $906bc63953d3b5dd$var$isClosed,
    isDuplexNodeStream: $906bc63953d3b5dd$var$isDuplexNodeStream,
    isFinished: $906bc63953d3b5dd$var$isFinished,
    isIterable: $906bc63953d3b5dd$var$isIterable,
    isReadableNodeStream: $906bc63953d3b5dd$var$isReadableNodeStream,
    isReadableStream: $906bc63953d3b5dd$var$isReadableStream,
    isReadableEnded: $906bc63953d3b5dd$var$isReadableEnded,
    isReadableFinished: $906bc63953d3b5dd$var$isReadableFinished,
    isReadableErrored: $906bc63953d3b5dd$var$isReadableErrored,
    isNodeStream: $906bc63953d3b5dd$var$isNodeStream,
    isWebStream: $906bc63953d3b5dd$var$isWebStream,
    isWritable: $906bc63953d3b5dd$var$isWritable,
    isWritableNodeStream: $906bc63953d3b5dd$var$isWritableNodeStream,
    isWritableStream: $906bc63953d3b5dd$var$isWritableStream,
    isWritableEnded: $906bc63953d3b5dd$var$isWritableEnded,
    isWritableFinished: $906bc63953d3b5dd$var$isWritableFinished,
    isWritableErrored: $906bc63953d3b5dd$var$isWritableErrored,
    isServerRequest: $906bc63953d3b5dd$var$isServerRequest,
    isServerResponse: $906bc63953d3b5dd$var$isServerResponse,
    willEmitClose: $906bc63953d3b5dd$var$willEmitClose,
    isTransformStream: $906bc63953d3b5dd$var$isTransformStream
};

});


parcelRegister("cv0BA", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $clB1p = parcelRequire("clB1p");
var $9198d97701789ce1$require$pipeline = $clB1p.pipeline;

var $5jQJn = parcelRequire("5jQJn");

var $hS2RW = parcelRequire("hS2RW");
var $9198d97701789ce1$require$destroyer = $hS2RW.destroyer;

var $coKti = parcelRequire("coKti");
var $9198d97701789ce1$var$isNodeStream = $coKti.isNodeStream, $9198d97701789ce1$var$isReadable = $coKti.isReadable, $9198d97701789ce1$var$isWritable = $coKti.isWritable, $9198d97701789ce1$var$isWebStream = $coKti.isWebStream, $9198d97701789ce1$var$isTransformStream = $coKti.isTransformStream, $9198d97701789ce1$var$isWritableStream = $coKti.isWritableStream, $9198d97701789ce1$var$isReadableStream = $coKti.isReadableStream;

var $dOAm6 = parcelRequire("dOAm6");
var $9198d97701789ce1$var$AbortError = $dOAm6.AbortError, $9198d97701789ce1$var$_require_codes = $dOAm6.codes, $9198d97701789ce1$var$ERR_INVALID_ARG_VALUE = $9198d97701789ce1$var$_require_codes.ERR_INVALID_ARG_VALUE, $9198d97701789ce1$var$ERR_MISSING_ARGS = $9198d97701789ce1$var$_require_codes.ERR_MISSING_ARGS;

var $dsQMn = parcelRequire("dsQMn");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $9198d97701789ce1$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $5jQJn.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $5jQJn.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $5jQJn.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$9198d97701789ce1$var$isNodeStream(streams[n]) && !$9198d97701789ce1$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($9198d97701789ce1$var$isReadable(streams[n]) || $9198d97701789ce1$var$isReadableStream(streams[n]) || $9198d97701789ce1$var$isTransformStream(streams[n]))) throw new $9198d97701789ce1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($9198d97701789ce1$var$isWritable(streams[n]) || $9198d97701789ce1$var$isWritableStream(streams[n]) || $9198d97701789ce1$var$isTransformStream(streams[n]))) throw new $9198d97701789ce1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $9198d97701789ce1$require$pipeline(streams, onfinished);
    var writable = !!($9198d97701789ce1$var$isWritable(head) || $9198d97701789ce1$var$isWritableStream(head) || $9198d97701789ce1$var$isTransformStream(head));
    var readable = !!($9198d97701789ce1$var$isReadable(tail) || $9198d97701789ce1$var$isReadableStream(tail) || $9198d97701789ce1$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $5jQJn({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($9198d97701789ce1$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($9198d97701789ce1$var$isWebStream(head)) {
            var writable1 = $9198d97701789ce1$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $9198d97701789ce1$var$isTransformStream(tail) ? tail.readable : tail;
        $dsQMn(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($9198d97701789ce1$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($9198d97701789ce1$var$isWebStream(tail)) {
            var readable1 = $9198d97701789ce1$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9198d97701789ce1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($9198d97701789ce1$var$isNodeStream(tail)) $9198d97701789ce1$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("clB1p", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $8fd429f0c7feaba6$var$ArrayIsArray = $h2bKv.ArrayIsArray, $8fd429f0c7feaba6$var$Promise = $h2bKv.Promise, $8fd429f0c7feaba6$var$SymbolAsyncIterator = $h2bKv.SymbolAsyncIterator, $8fd429f0c7feaba6$var$SymbolDispose = $h2bKv.SymbolDispose;

var $dsQMn = parcelRequire("dsQMn");

var $8fd429f0c7feaba6$require$once = (parcelRequire("eqibB")).once;

var $hS2RW = parcelRequire("hS2RW");

var $5jQJn = parcelRequire("5jQJn");

var $dOAm6 = parcelRequire("dOAm6");
var $8fd429f0c7feaba6$var$aggregateTwoErrors = $dOAm6.aggregateTwoErrors, $8fd429f0c7feaba6$var$_require_codes = $dOAm6.codes, $8fd429f0c7feaba6$var$ERR_INVALID_ARG_TYPE = $8fd429f0c7feaba6$var$_require_codes.ERR_INVALID_ARG_TYPE, $8fd429f0c7feaba6$var$ERR_INVALID_RETURN_VALUE = $8fd429f0c7feaba6$var$_require_codes.ERR_INVALID_RETURN_VALUE, $8fd429f0c7feaba6$var$ERR_MISSING_ARGS = $8fd429f0c7feaba6$var$_require_codes.ERR_MISSING_ARGS, $8fd429f0c7feaba6$var$ERR_STREAM_DESTROYED = $8fd429f0c7feaba6$var$_require_codes.ERR_STREAM_DESTROYED, $8fd429f0c7feaba6$var$ERR_STREAM_PREMATURE_CLOSE = $8fd429f0c7feaba6$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $8fd429f0c7feaba6$var$AbortError = $dOAm6.AbortError;

var $2ih1i = parcelRequire("2ih1i");
var $8fd429f0c7feaba6$var$validateFunction = $2ih1i.validateFunction, $8fd429f0c7feaba6$var$validateAbortSignal = $2ih1i.validateAbortSignal;

var $coKti = parcelRequire("coKti");
var $8fd429f0c7feaba6$var$isIterable = $coKti.isIterable, $8fd429f0c7feaba6$var$isReadable = $coKti.isReadable, $8fd429f0c7feaba6$var$isReadableNodeStream = $coKti.isReadableNodeStream, $8fd429f0c7feaba6$var$isNodeStream = $coKti.isNodeStream, $8fd429f0c7feaba6$var$isTransformStream = $coKti.isTransformStream, $8fd429f0c7feaba6$var$isWebStream = $coKti.isWebStream, $8fd429f0c7feaba6$var$isReadableStream = $coKti.isReadableStream, $8fd429f0c7feaba6$var$isReadableFinished = $coKti.isReadableFinished;

var $8fd429f0c7feaba6$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $8fd429f0c7feaba6$var$PassThrough;
var $8fd429f0c7feaba6$var$Readable;
var $8fd429f0c7feaba6$var$addAbortListener;
function $8fd429f0c7feaba6$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $dsQMn(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $hS2RW.destroyer(stream, err || new $8fd429f0c7feaba6$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $8fd429f0c7feaba6$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $8fd429f0c7feaba6$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $8fd429f0c7feaba6$var$makeAsyncIterable(val) {
    if ($8fd429f0c7feaba6$var$isIterable(val)) return val;
    else if ($8fd429f0c7feaba6$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $8fd429f0c7feaba6$var$fromReadable(val);
    throw new $8fd429f0c7feaba6$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $8fd429f0c7feaba6$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$8fd429f0c7feaba6$var$Readable) $8fd429f0c7feaba6$var$Readable = (parcelRequire("aUr4N"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($8fd429f0c7feaba6$var$Readable.prototype[$8fd429f0c7feaba6$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $8fd429f0c7feaba6$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $8fd429f0c7feaba6$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $dsQMn(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $8fd429f0c7feaba6$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $8fd429f0c7feaba6$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($8fd429f0c7feaba6$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $8fd429f0c7feaba6$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $8fd429f0c7feaba6$var$pipelineImpl(streams, $8fd429f0c7feaba6$require$once($8fd429f0c7feaba6$var$popCallback(streams)));
}


function $8fd429f0c7feaba6$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($8fd429f0c7feaba6$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $8fd429f0c7feaba6$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($8fd429f0c7feaba6$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($8fd429f0c7feaba6$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$8fd429f0c7feaba6$var$isIterable(ret)) throw new $8fd429f0c7feaba6$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($8fd429f0c7feaba6$var$isIterable(stream) || $8fd429f0c7feaba6$var$isReadableNodeStream(stream) || $8fd429f0c7feaba6$var$isTransformStream(stream)) ret = stream;
            else ret = $5jQJn.from(stream);
        } else if (typeof stream === 'function') {
            if ($8fd429f0c7feaba6$var$isTransformStream(ret)) {
                var _ret;
                ret = $8fd429f0c7feaba6$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $8fd429f0c7feaba6$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$8fd429f0c7feaba6$var$isIterable(ret, true)) throw new $8fd429f0c7feaba6$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$8fd429f0c7feaba6$var$PassThrough) $8fd429f0c7feaba6$var$PassThrough = (parcelRequire("jCm3a"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $8fd429f0c7feaba6$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($8fd429f0c7feaba6$var$isIterable(ret, true)) {
                    finishCount++;
                    $8fd429f0c7feaba6$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($8fd429f0c7feaba6$var$isReadableStream(ret) || $8fd429f0c7feaba6$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $8fd429f0c7feaba6$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $8fd429f0c7feaba6$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $8fd429f0c7feaba6$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($8fd429f0c7feaba6$var$isNodeStream(stream)) {
            if ($8fd429f0c7feaba6$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $8fd429f0c7feaba6$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($8fd429f0c7feaba6$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($8fd429f0c7feaba6$var$isTransformStream(ret) || $8fd429f0c7feaba6$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $8fd429f0c7feaba6$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($8fd429f0c7feaba6$var$isIterable(ret)) {
                finishCount++;
                $8fd429f0c7feaba6$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $8fd429f0c7feaba6$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($8fd429f0c7feaba6$var$isWebStream(stream)) {
            if ($8fd429f0c7feaba6$var$isReadableNodeStream(ret)) {
                finishCount++;
                $8fd429f0c7feaba6$var$pumpToWeb($8fd429f0c7feaba6$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($8fd429f0c7feaba6$var$isReadableStream(ret) || $8fd429f0c7feaba6$var$isIterable(ret)) {
                finishCount++;
                $8fd429f0c7feaba6$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($8fd429f0c7feaba6$var$isTransformStream(ret)) {
                finishCount++;
                $8fd429f0c7feaba6$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $8fd429f0c7feaba6$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $5jQJn.from(stream);
    };
    if (streams.length === 1 && $8fd429f0c7feaba6$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $8fd429f0c7feaba6$var$ERR_MISSING_ARGS('streams');
    var ac = new $8fd429f0c7feaba6$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $8fd429f0c7feaba6$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $8fd429f0c7feaba6$var$AbortError());
    }
    $8fd429f0c7feaba6$var$addAbortListener = $8fd429f0c7feaba6$var$addAbortListener || (parcelRequire("eqibB")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $8fd429f0c7feaba6$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$8fd429f0c7feaba6$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $8fd429f0c7feaba6$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $8fd429f0c7feaba6$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($8fd429f0c7feaba6$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $dsQMn(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $dsQMn(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $8fd429f0c7feaba6$var$pipelineImpl,
    pipeline: $8fd429f0c7feaba6$var$pipeline
};

});
parcelRegister("hS2RW", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $dOAm6 = parcelRequire("dOAm6");
/* replacement end */ var $d029b48c2ead1da7$var$aggregateTwoErrors = $dOAm6.aggregateTwoErrors, $d029b48c2ead1da7$var$ERR_MULTIPLE_CALLBACK = $dOAm6.codes.ERR_MULTIPLE_CALLBACK, $d029b48c2ead1da7$var$AbortError = $dOAm6.AbortError;

var $h2bKv = parcelRequire("h2bKv");
var $d029b48c2ead1da7$require$Symbol = $h2bKv.Symbol;

var $coKti = parcelRequire("coKti");
var $d029b48c2ead1da7$var$kIsDestroyed = $coKti.kIsDestroyed, $d029b48c2ead1da7$var$isDestroyed = $coKti.isDestroyed, $d029b48c2ead1da7$var$isFinished = $coKti.isFinished, $d029b48c2ead1da7$var$isServerRequest = $coKti.isServerRequest;
var $d029b48c2ead1da7$var$kDestroy = $d029b48c2ead1da7$require$Symbol('kDestroy');
var $d029b48c2ead1da7$var$kConstruct = $d029b48c2ead1da7$require$Symbol('kConstruct');
function $d029b48c2ead1da7$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $d029b48c2ead1da7$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $d029b48c2ead1da7$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($d029b48c2ead1da7$var$kDestroy, function(er) {
        $d029b48c2ead1da7$var$_destroy(this, $d029b48c2ead1da7$var$aggregateTwoErrors(er, err), cb);
    });
    else $d029b48c2ead1da7$var$_destroy(this, err, cb);
    return this;
}
function $d029b48c2ead1da7$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $d029b48c2ead1da7$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($d029b48c2ead1da7$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($d029b48c2ead1da7$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $d029b48c2ead1da7$var$emitErrorCloseNT(self, err) {
    $d029b48c2ead1da7$var$emitErrorNT(self, err);
    $d029b48c2ead1da7$var$emitCloseNT(self);
}
function $d029b48c2ead1da7$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $d029b48c2ead1da7$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $d029b48c2ead1da7$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $d029b48c2ead1da7$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($d029b48c2ead1da7$var$emitErrorNT, stream, err);
        else $d029b48c2ead1da7$var$emitErrorNT(stream, err);
    }
}
function $d029b48c2ead1da7$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($d029b48c2ead1da7$var$kConstruct, cb);
    if (stream.listenerCount($d029b48c2ead1da7$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($d029b48c2ead1da7$var$constructNT, stream);
}
function $d029b48c2ead1da7$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $d029b48c2ead1da7$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $d029b48c2ead1da7$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($d029b48c2ead1da7$var$kDestroy, err);
        else if (err) $d029b48c2ead1da7$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($d029b48c2ead1da7$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $d029b48c2ead1da7$var$emitConstructNT(stream) {
    stream.emit($d029b48c2ead1da7$var$kConstruct);
}
function $d029b48c2ead1da7$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $d029b48c2ead1da7$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $d029b48c2ead1da7$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($d029b48c2ead1da7$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $d029b48c2ead1da7$var$destroyer(stream, err) {
    if (!stream || $d029b48c2ead1da7$var$isDestroyed(stream)) return;
    if (!err && !$d029b48c2ead1da7$var$isFinished(stream)) err = new $d029b48c2ead1da7$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($d029b48c2ead1da7$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($d029b48c2ead1da7$var$isRequest(stream)) stream.abort();
    else if ($d029b48c2ead1da7$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($d029b48c2ead1da7$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($d029b48c2ead1da7$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$d029b48c2ead1da7$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $d029b48c2ead1da7$var$construct,
    destroyer: $d029b48c2ead1da7$var$destroyer,
    destroy: $d029b48c2ead1da7$var$destroy,
    undestroy: $d029b48c2ead1da7$var$undestroy,
    errorOrDestroy: $d029b48c2ead1da7$var$errorOrDestroy
};

});

parcelRegister("5jQJn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $3df7a1558d98e4b6$var$ObjectDefineProperties = $h2bKv.ObjectDefineProperties, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor = $h2bKv.ObjectGetOwnPropertyDescriptor, $3df7a1558d98e4b6$var$ObjectKeys = $h2bKv.ObjectKeys, $3df7a1558d98e4b6$var$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf;
module.exports = $3df7a1558d98e4b6$var$Duplex;

var $aUr4N = parcelRequire("aUr4N");

var $hM0g8 = parcelRequire("hM0g8");
$3df7a1558d98e4b6$var$ObjectSetPrototypeOf($3df7a1558d98e4b6$var$Duplex.prototype, $aUr4N.prototype);
$3df7a1558d98e4b6$var$ObjectSetPrototypeOf($3df7a1558d98e4b6$var$Duplex, $aUr4N);
{
    var $3df7a1558d98e4b6$var$keys = $3df7a1558d98e4b6$var$ObjectKeys($hM0g8.prototype);
    // Allow the keys array to be GC'ed.
    for(var $3df7a1558d98e4b6$var$i = 0; $3df7a1558d98e4b6$var$i < $3df7a1558d98e4b6$var$keys.length; $3df7a1558d98e4b6$var$i++){
        var $3df7a1558d98e4b6$var$method = $3df7a1558d98e4b6$var$keys[$3df7a1558d98e4b6$var$i];
        if (!$3df7a1558d98e4b6$var$Duplex.prototype[$3df7a1558d98e4b6$var$method]) $3df7a1558d98e4b6$var$Duplex.prototype[$3df7a1558d98e4b6$var$method] = $hM0g8.prototype[$3df7a1558d98e4b6$var$method];
    }
}function $3df7a1558d98e4b6$var$Duplex(options) {
    if (!(this instanceof $3df7a1558d98e4b6$var$Duplex)) return new $3df7a1558d98e4b6$var$Duplex(options);
    $aUr4N.call(this, options);
    $hM0g8.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$3df7a1558d98e4b6$var$ObjectDefineProperties($3df7a1558d98e4b6$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $3df7a1558d98e4b6$var$ObjectGetOwnPropertyDescriptor($hM0g8.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $3df7a1558d98e4b6$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3df7a1558d98e4b6$var$lazyWebStreams() {
    if ($3df7a1558d98e4b6$var$webStreamsAdapters === undefined) $3df7a1558d98e4b6$var$webStreamsAdapters = {};
    return $3df7a1558d98e4b6$var$webStreamsAdapters;
}
$3df7a1558d98e4b6$var$Duplex.fromWeb = function(pair, options) {
    return $3df7a1558d98e4b6$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$3df7a1558d98e4b6$var$Duplex.toWeb = function(duplex) {
    return $3df7a1558d98e4b6$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $3df7a1558d98e4b6$var$duplexify;

$3df7a1558d98e4b6$var$Duplex.from = function(body) {
    if (!$3df7a1558d98e4b6$var$duplexify) $3df7a1558d98e4b6$var$duplexify = (parcelRequire("fTkVz"));
    return $3df7a1558d98e4b6$var$duplexify(body, 'body');
};

});
parcelRegister("aUr4N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $h2bKv = parcelRequire("h2bKv");
/* replacement end */ var $7f14231ef7ae1f27$var$ArrayPrototypeIndexOf = $h2bKv.ArrayPrototypeIndexOf, $7f14231ef7ae1f27$var$NumberIsInteger = $h2bKv.NumberIsInteger, $7f14231ef7ae1f27$var$NumberIsNaN = $h2bKv.NumberIsNaN, $7f14231ef7ae1f27$var$NumberParseInt = $h2bKv.NumberParseInt, $7f14231ef7ae1f27$var$ObjectDefineProperties = $h2bKv.ObjectDefineProperties, $7f14231ef7ae1f27$var$ObjectKeys = $h2bKv.ObjectKeys, $7f14231ef7ae1f27$var$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf, $7f14231ef7ae1f27$var$Promise = $h2bKv.Promise, $7f14231ef7ae1f27$var$SafeSet = $h2bKv.SafeSet, $7f14231ef7ae1f27$var$SymbolAsyncDispose = $h2bKv.SymbolAsyncDispose, $7f14231ef7ae1f27$var$SymbolAsyncIterator = $h2bKv.SymbolAsyncIterator, $7f14231ef7ae1f27$var$Symbol = $h2bKv.Symbol;
module.exports = $7f14231ef7ae1f27$var$Readable;
$7f14231ef7ae1f27$var$Readable.ReadableState = $7f14231ef7ae1f27$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $7f14231ef7ae1f27$var$EE = $bBoAO.EventEmitter;

var $8IJMa = parcelRequire("8IJMa");
var $7f14231ef7ae1f27$var$Stream = $8IJMa.Stream, $7f14231ef7ae1f27$var$prependListener = $8IJMa.prependListener;

var $lqHhy = parcelRequire("lqHhy");
var $7f14231ef7ae1f27$require$Buffer = $lqHhy.Buffer;

var $fdpM7 = parcelRequire("fdpM7");
var $7f14231ef7ae1f27$require$addAbortSignal = $fdpM7.addAbortSignal;

var $dsQMn = parcelRequire("dsQMn");

var $7f14231ef7ae1f27$var$debug = (parcelRequire("eqibB")).debuglog('stream', function(fn) {
    $7f14231ef7ae1f27$var$debug = fn;
});

var $4qCup = parcelRequire("4qCup");

var $hS2RW = parcelRequire("hS2RW");

var $5poJJ = parcelRequire("5poJJ");
var $7f14231ef7ae1f27$var$getHighWaterMark = $5poJJ.getHighWaterMark, $7f14231ef7ae1f27$var$getDefaultHighWaterMark = $5poJJ.getDefaultHighWaterMark;

var $dOAm6 = parcelRequire("dOAm6");
var $7f14231ef7ae1f27$var$aggregateTwoErrors = $dOAm6.aggregateTwoErrors, $7f14231ef7ae1f27$var$_require_codes = $dOAm6.codes, $7f14231ef7ae1f27$var$ERR_INVALID_ARG_TYPE = $7f14231ef7ae1f27$var$_require_codes.ERR_INVALID_ARG_TYPE, $7f14231ef7ae1f27$var$ERR_METHOD_NOT_IMPLEMENTED = $7f14231ef7ae1f27$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $7f14231ef7ae1f27$var$ERR_OUT_OF_RANGE = $7f14231ef7ae1f27$var$_require_codes.ERR_OUT_OF_RANGE, $7f14231ef7ae1f27$var$ERR_STREAM_PUSH_AFTER_EOF = $7f14231ef7ae1f27$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $7f14231ef7ae1f27$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7f14231ef7ae1f27$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $7f14231ef7ae1f27$var$AbortError = $dOAm6.AbortError;

var $2ih1i = parcelRequire("2ih1i");
var $7f14231ef7ae1f27$require$validateObject = $2ih1i.validateObject;
var $7f14231ef7ae1f27$var$kPaused = $7f14231ef7ae1f27$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $7f14231ef7ae1f27$require$StringDecoder = $3Jf7C.StringDecoder;

var $6r9M9 = parcelRequire("6r9M9");
$7f14231ef7ae1f27$var$ObjectSetPrototypeOf($7f14231ef7ae1f27$var$Readable.prototype, $7f14231ef7ae1f27$var$Stream.prototype);
$7f14231ef7ae1f27$var$ObjectSetPrototypeOf($7f14231ef7ae1f27$var$Readable, $7f14231ef7ae1f27$var$Stream);
var $7f14231ef7ae1f27$var$nop = function() {};
var $7f14231ef7ae1f27$var$errorOrDestroy = $hS2RW.errorOrDestroy;
var $7f14231ef7ae1f27$var$kObjectMode = 1;
var $7f14231ef7ae1f27$var$kEnded = 2;
var $7f14231ef7ae1f27$var$kEndEmitted = 4;
var $7f14231ef7ae1f27$var$kReading = 8;
var $7f14231ef7ae1f27$var$kConstructed = 16;
var $7f14231ef7ae1f27$var$kSync = 32;
var $7f14231ef7ae1f27$var$kNeedReadable = 64;
var $7f14231ef7ae1f27$var$kEmittedReadable = 128;
var $7f14231ef7ae1f27$var$kReadableListening = 256;
var $7f14231ef7ae1f27$var$kResumeScheduled = 512;
var $7f14231ef7ae1f27$var$kErrorEmitted = 1024;
var $7f14231ef7ae1f27$var$kEmitClose = 2048;
var $7f14231ef7ae1f27$var$kAutoDestroy = 4096;
var $7f14231ef7ae1f27$var$kDestroyed = 8192;
var $7f14231ef7ae1f27$var$kClosed = 16384;
var $7f14231ef7ae1f27$var$kCloseEmitted = 32768;
var $7f14231ef7ae1f27$var$kMultiAwaitDrain = 65536;
var $7f14231ef7ae1f27$var$kReadingMore = 131072;
var $7f14231ef7ae1f27$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $7f14231ef7ae1f27$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$7f14231ef7ae1f27$var$ObjectDefineProperties($7f14231ef7ae1f27$var$ReadableState.prototype, {
    objectMode: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kObjectMode),
    ended: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kEnded),
    endEmitted: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kEndEmitted),
    reading: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kNeedReadable),
    emittedReadable: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kEmittedReadable),
    readableListening: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kReadableListening),
    resumeScheduled: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kErrorEmitted),
    emitClose: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kEmitClose),
    autoDestroy: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kCloseEmitted),
    multiAwaitDrain: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kReadingMore),
    dataEmitted: $7f14231ef7ae1f27$var$makeBitMapDescriptor($7f14231ef7ae1f27$var$kDataEmitted)
});

function $7f14231ef7ae1f27$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("5jQJn"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $7f14231ef7ae1f27$var$kEmitClose | $7f14231ef7ae1f27$var$kAutoDestroy | $7f14231ef7ae1f27$var$kConstructed | $7f14231ef7ae1f27$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $7f14231ef7ae1f27$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $7f14231ef7ae1f27$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $7f14231ef7ae1f27$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $7f14231ef7ae1f27$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4qCup();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$7f14231ef7ae1f27$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$7f14231ef7ae1f27$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$7f14231ef7ae1f27$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $7f14231ef7ae1f27$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7f14231ef7ae1f27$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $7f14231ef7ae1f27$var$Readable)) return new $7f14231ef7ae1f27$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("5jQJn"));
    this._readableState = new $7f14231ef7ae1f27$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $7f14231ef7ae1f27$require$addAbortSignal(options.signal, this);
    }
    $7f14231ef7ae1f27$var$Stream.call(this, options);
    $hS2RW.construct(this, function() {
        if (_this._readableState.needReadable) $7f14231ef7ae1f27$var$maybeReadMore(_this, _this._readableState);
    });
}
$7f14231ef7ae1f27$var$Readable.prototype.destroy = $hS2RW.destroy;
$7f14231ef7ae1f27$var$Readable.prototype._undestroy = $hS2RW.undestroy;
$7f14231ef7ae1f27$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$7f14231ef7ae1f27$var$Readable.prototype[$7f14231ef7ae1f27$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$7f14231ef7ae1f27$var$Readable.prototype[$7f14231ef7ae1f27$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $7f14231ef7ae1f27$var$AbortError();
        this.destroy(error);
    }
    return new $7f14231ef7ae1f27$var$Promise(function(resolve, reject) {
        return $dsQMn(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7f14231ef7ae1f27$var$Readable.prototype.push = function(chunk, encoding) {
    return $7f14231ef7ae1f27$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$7f14231ef7ae1f27$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $7f14231ef7ae1f27$var$readableAddChunk(this, chunk, encoding, true);
};
function $7f14231ef7ae1f27$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $7f14231ef7ae1f27$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $7f14231ef7ae1f27$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $7f14231ef7ae1f27$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $7f14231ef7ae1f27$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $7f14231ef7ae1f27$require$Buffer) encoding = '';
        else if ($7f14231ef7ae1f27$var$Stream._isUint8Array(chunk)) {
            chunk = $7f14231ef7ae1f27$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $7f14231ef7ae1f27$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $7f14231ef7ae1f27$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$7f14231ef7ae1f27$var$kReading;
        $7f14231ef7ae1f27$var$onEofChunk(stream, state);
    } else if ((state.state & $7f14231ef7ae1f27$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $7f14231ef7ae1f27$var$kEndEmitted) !== 0) $7f14231ef7ae1f27$var$errorOrDestroy(stream, new $7f14231ef7ae1f27$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $7f14231ef7ae1f27$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $7f14231ef7ae1f27$var$errorOrDestroy(stream, new $7f14231ef7ae1f27$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$7f14231ef7ae1f27$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $7f14231ef7ae1f27$var$addChunk(stream, state, chunk, false);
                else $7f14231ef7ae1f27$var$maybeReadMore(stream, state);
            } else $7f14231ef7ae1f27$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$7f14231ef7ae1f27$var$kReading;
        $7f14231ef7ae1f27$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7f14231ef7ae1f27$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $7f14231ef7ae1f27$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $7f14231ef7ae1f27$var$kNeedReadable) !== 0) $7f14231ef7ae1f27$var$emitReadable(stream);
    }
    $7f14231ef7ae1f27$var$maybeReadMore(stream, state);
}
$7f14231ef7ae1f27$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$7f14231ef7ae1f27$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$7f14231ef7ae1f27$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $7f14231ef7ae1f27$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$7f14231ef7ae1f27$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $7f14231ef7ae1f27$var$MAX_HWM = 0x40000000;
function $7f14231ef7ae1f27$var$computeNewHighWaterMark(n) {
    if (n > $7f14231ef7ae1f27$var$MAX_HWM) throw new $7f14231ef7ae1f27$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7f14231ef7ae1f27$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $7f14231ef7ae1f27$var$kObjectMode) !== 0) return 1;
    if ($7f14231ef7ae1f27$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$7f14231ef7ae1f27$var$Readable.prototype.read = function(n) {
    $7f14231ef7ae1f27$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$7f14231ef7ae1f27$var$NumberIsInteger(n)) n = $7f14231ef7ae1f27$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7f14231ef7ae1f27$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$7f14231ef7ae1f27$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7f14231ef7ae1f27$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7f14231ef7ae1f27$var$endReadable(this);
        else $7f14231ef7ae1f27$var$emitReadable(this);
        return null;
    }
    n = $7f14231ef7ae1f27$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7f14231ef7ae1f27$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $7f14231ef7ae1f27$var$kNeedReadable) !== 0;
    $7f14231ef7ae1f27$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7f14231ef7ae1f27$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $7f14231ef7ae1f27$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $7f14231ef7ae1f27$var$debug('do read');
        state.state |= $7f14231ef7ae1f27$var$kReading | $7f14231ef7ae1f27$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $7f14231ef7ae1f27$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $7f14231ef7ae1f27$var$errorOrDestroy(this, err);
        }
        state.state &= ~$7f14231ef7ae1f27$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7f14231ef7ae1f27$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7f14231ef7ae1f27$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7f14231ef7ae1f27$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $7f14231ef7ae1f27$var$onEofChunk(stream, state) {
    $7f14231ef7ae1f27$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $7f14231ef7ae1f27$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $7f14231ef7ae1f27$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7f14231ef7ae1f27$var$emitReadable(stream) {
    var state = stream._readableState;
    $7f14231ef7ae1f27$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7f14231ef7ae1f27$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($7f14231ef7ae1f27$var$emitReadable_, stream);
    }
}
function $7f14231ef7ae1f27$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7f14231ef7ae1f27$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7f14231ef7ae1f27$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7f14231ef7ae1f27$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($7f14231ef7ae1f27$var$maybeReadMore_, stream, state);
    }
}
function $7f14231ef7ae1f27$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7f14231ef7ae1f27$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7f14231ef7ae1f27$var$Readable.prototype._read = function(n) {
    throw new $7f14231ef7ae1f27$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$7f14231ef7ae1f27$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $7f14231ef7ae1f27$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $7f14231ef7ae1f27$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7f14231ef7ae1f27$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7f14231ef7ae1f27$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $7f14231ef7ae1f27$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $7f14231ef7ae1f27$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $7f14231ef7ae1f27$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $7f14231ef7ae1f27$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7f14231ef7ae1f27$var$debug('ondata');
        var ret = dest.write(chunk);
        $7f14231ef7ae1f27$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7f14231ef7ae1f27$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $7f14231ef7ae1f27$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $7f14231ef7ae1f27$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7f14231ef7ae1f27$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7f14231ef7ae1f27$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $7f14231ef7ae1f27$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7f14231ef7ae1f27$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $7f14231ef7ae1f27$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $7f14231ef7ae1f27$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$7f14231ef7ae1f27$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $7f14231ef7ae1f27$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$7f14231ef7ae1f27$var$Readable.prototype.on = function(ev, fn) {
    var res = $7f14231ef7ae1f27$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7f14231ef7ae1f27$var$debug('on readable', state.length, state.reading);
            if (state.length) $7f14231ef7ae1f27$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($7f14231ef7ae1f27$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7f14231ef7ae1f27$var$Readable.prototype.addListener = $7f14231ef7ae1f27$var$Readable.prototype.on;
$7f14231ef7ae1f27$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7f14231ef7ae1f27$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($7f14231ef7ae1f27$var$updateReadableListening, this);
    return res;
};
$7f14231ef7ae1f27$var$Readable.prototype.off = $7f14231ef7ae1f27$var$Readable.prototype.removeListener;
$7f14231ef7ae1f27$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7f14231ef7ae1f27$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($7f14231ef7ae1f27$var$updateReadableListening, this);
    return res;
};
function $7f14231ef7ae1f27$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$7f14231ef7ae1f27$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $7f14231ef7ae1f27$var$nReadingNextTick(self) {
    $7f14231ef7ae1f27$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7f14231ef7ae1f27$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7f14231ef7ae1f27$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $7f14231ef7ae1f27$var$resume(this, state);
    }
    state[$7f14231ef7ae1f27$var$kPaused] = false;
    return this;
};
function $7f14231ef7ae1f27$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($7f14231ef7ae1f27$var$resume_, stream, state);
    }
}
function $7f14231ef7ae1f27$var$resume_(stream, state) {
    $7f14231ef7ae1f27$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7f14231ef7ae1f27$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7f14231ef7ae1f27$var$Readable.prototype.pause = function() {
    $7f14231ef7ae1f27$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7f14231ef7ae1f27$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$7f14231ef7ae1f27$var$kPaused] = true;
    return this;
};
function $7f14231ef7ae1f27$var$flow(stream) {
    var state = stream._readableState;
    $7f14231ef7ae1f27$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7f14231ef7ae1f27$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $7f14231ef7ae1f27$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $7f14231ef7ae1f27$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$7f14231ef7ae1f27$var$Readable.prototype[$7f14231ef7ae1f27$var$SymbolAsyncIterator] = function() {
    return $7f14231ef7ae1f27$var$streamToAsyncIterator(this);
};
$7f14231ef7ae1f27$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $7f14231ef7ae1f27$require$validateObject(options, 'options');
    return $7f14231ef7ae1f27$var$streamToAsyncIterator(this, options);
};
function $7f14231ef7ae1f27$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $7f14231ef7ae1f27$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $7f14231ef7ae1f27$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $7f14231ef7ae1f27$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $7f14231ef7ae1f27$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $7f14231ef7ae1f27$var$nop;
                    stream.on('readable', next);
                    cleanup = $dsQMn(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $7f14231ef7ae1f27$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $7f14231ef7ae1f27$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $7f14231ef7ae1f27$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $7f14231ef7ae1f27$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $hS2RW.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$7f14231ef7ae1f27$var$ObjectDefineProperties($7f14231ef7ae1f27$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$7f14231ef7ae1f27$var$ObjectDefineProperties($7f14231ef7ae1f27$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$7f14231ef7ae1f27$var$kPaused] !== false;
        },
        set: function(value) {
            this[$7f14231ef7ae1f27$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$7f14231ef7ae1f27$var$Readable._fromList = $7f14231ef7ae1f27$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7f14231ef7ae1f27$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7f14231ef7ae1f27$var$endReadable(stream) {
    var state = stream._readableState;
    $7f14231ef7ae1f27$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($7f14231ef7ae1f27$var$endReadableNT, state, stream);
    }
}
function $7f14231ef7ae1f27$var$endReadableNT(state, stream) {
    $7f14231ef7ae1f27$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($7f14231ef7ae1f27$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $7f14231ef7ae1f27$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$7f14231ef7ae1f27$var$Readable.from = function(iterable, opts) {
    return $6r9M9($7f14231ef7ae1f27$var$Readable, iterable, opts);
};
var $7f14231ef7ae1f27$var$webStreamsAdapters;
// Lazy to avoid circular references
function $7f14231ef7ae1f27$var$lazyWebStreams() {
    if ($7f14231ef7ae1f27$var$webStreamsAdapters === undefined) $7f14231ef7ae1f27$var$webStreamsAdapters = {};
    return $7f14231ef7ae1f27$var$webStreamsAdapters;
}
$7f14231ef7ae1f27$var$Readable.fromWeb = function(readableStream, options) {
    return $7f14231ef7ae1f27$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$7f14231ef7ae1f27$var$Readable.toWeb = function(streamReadable, options) {
    return $7f14231ef7ae1f27$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$7f14231ef7ae1f27$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $7f14231ef7ae1f27$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $hS2RW.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("8IJMa", function(module, exports) {
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $6595f0eddbbe30ad$var$ArrayIsArray = $h2bKv.ArrayIsArray, $6595f0eddbbe30ad$var$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $6595f0eddbbe30ad$var$EE = $bBoAO.EventEmitter;
function $6595f0eddbbe30ad$var$Stream(opts) {
    $6595f0eddbbe30ad$var$EE.call(this, opts);
}
$6595f0eddbbe30ad$var$ObjectSetPrototypeOf($6595f0eddbbe30ad$var$Stream.prototype, $6595f0eddbbe30ad$var$EE.prototype);
$6595f0eddbbe30ad$var$ObjectSetPrototypeOf($6595f0eddbbe30ad$var$Stream, $6595f0eddbbe30ad$var$EE);
$6595f0eddbbe30ad$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($6595f0eddbbe30ad$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $6595f0eddbbe30ad$var$prependListener(source, 'error', onerror);
    $6595f0eddbbe30ad$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $6595f0eddbbe30ad$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($6595f0eddbbe30ad$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $6595f0eddbbe30ad$var$Stream,
    prependListener: $6595f0eddbbe30ad$var$prependListener
};

});

parcelRegister("fdpM7", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $b13c10568c01b551$export$e2db56ee53255a0; }, function (v) { return $b13c10568c01b551$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $b13c10568c01b551$export$11956e9313f43de0; }, function (v) { return $b13c10568c01b551$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $b13c10568c01b551$export$e2db56ee53255a0;
var $b13c10568c01b551$export$11956e9313f43de0;
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $b13c10568c01b551$require$SymbolDispose = $h2bKv.SymbolDispose;

var $dOAm6 = parcelRequire("dOAm6");
var $b13c10568c01b551$var$AbortError = $dOAm6.AbortError, $b13c10568c01b551$var$codes = $dOAm6.codes;

var $coKti = parcelRequire("coKti");
var $b13c10568c01b551$var$isNodeStream = $coKti.isNodeStream, $b13c10568c01b551$var$isWebStream = $coKti.isWebStream, $b13c10568c01b551$var$kControllerErrorFunction = $coKti.kControllerErrorFunction;

var $dsQMn = parcelRequire("dsQMn");
var $b13c10568c01b551$var$ERR_INVALID_ARG_TYPE = $b13c10568c01b551$var$codes.ERR_INVALID_ARG_TYPE;
var $b13c10568c01b551$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $b13c10568c01b551$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $b13c10568c01b551$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$b13c10568c01b551$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $b13c10568c01b551$var$validateAbortSignal(signal, 'signal');
    if (!$b13c10568c01b551$var$isNodeStream(stream) && !$b13c10568c01b551$var$isWebStream(stream)) throw new $b13c10568c01b551$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $b13c10568c01b551$export$11956e9313f43de0(signal, stream);
};

$b13c10568c01b551$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $b13c10568c01b551$var$isNodeStream(stream) ? function() {
        stream.destroy(new $b13c10568c01b551$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$b13c10568c01b551$var$kControllerErrorFunction](new $b13c10568c01b551$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $b13c10568c01b551$var$addAbortListener = $b13c10568c01b551$var$addAbortListener || (parcelRequire("eqibB")).addAbortListener;
        var disposable = $b13c10568c01b551$var$addAbortListener(signal, onAbort);
        $dsQMn(stream, disposable[$b13c10568c01b551$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4qCup", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $3397725170282eb2$var$StringPrototypeSlice = $h2bKv.StringPrototypeSlice, $3397725170282eb2$var$SymbolIterator = $h2bKv.SymbolIterator, $3397725170282eb2$var$TypedArrayPrototypeSet = $h2bKv.TypedArrayPrototypeSet, $3397725170282eb2$var$Uint8Array = $h2bKv.Uint8Array;

var $lqHhy = parcelRequire("lqHhy");
var $3397725170282eb2$require$Buffer = $lqHhy.Buffer;

var $eqibB = parcelRequire("eqibB");
var $3397725170282eb2$require$inspect = $eqibB.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $3397725170282eb2$require$Buffer.alloc(0);
                var ret = $3397725170282eb2$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $3397725170282eb2$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $3397725170282eb2$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $3397725170282eb2$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $3397725170282eb2$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $3397725170282eb2$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $3397725170282eb2$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $3397725170282eb2$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $3397725170282eb2$var$TypedArrayPrototypeSet(ret, new $3397725170282eb2$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $3397725170282eb2$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("5poJJ", function(module, exports) {
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $3f0279b9920253bd$var$MathFloor = $h2bKv.MathFloor, $3f0279b9920253bd$var$NumberIsInteger = $h2bKv.NumberIsInteger;

var $2ih1i = parcelRequire("2ih1i");
var $3f0279b9920253bd$require$validateInteger = $2ih1i.validateInteger;

var $3f0279b9920253bd$var$ERR_INVALID_ARG_VALUE = (parcelRequire("dOAm6")).codes.ERR_INVALID_ARG_VALUE;
var $3f0279b9920253bd$var$defaultHighWaterMarkBytes = 16384;
var $3f0279b9920253bd$var$defaultHighWaterMarkObjectMode = 16;
function $3f0279b9920253bd$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3f0279b9920253bd$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $3f0279b9920253bd$var$defaultHighWaterMarkObjectMode : $3f0279b9920253bd$var$defaultHighWaterMarkBytes;
}
function $3f0279b9920253bd$var$setDefaultHighWaterMark(objectMode, value) {
    $3f0279b9920253bd$require$validateInteger(value, 'value', 0);
    if (objectMode) $3f0279b9920253bd$var$defaultHighWaterMarkObjectMode = value;
    else $3f0279b9920253bd$var$defaultHighWaterMarkBytes = value;
}
function $3f0279b9920253bd$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $3f0279b9920253bd$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$3f0279b9920253bd$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $3f0279b9920253bd$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $3f0279b9920253bd$var$MathFloor(hwm);
    }
    // Default value
    return $3f0279b9920253bd$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $3f0279b9920253bd$var$getHighWaterMark,
    getDefaultHighWaterMark: $3f0279b9920253bd$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $3f0279b9920253bd$var$setDefaultHighWaterMark
};

});

parcelRegister("6r9M9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $h2bKv = parcelRequire("h2bKv");
/* replacement end */ var $4afcd8ef71b3a442$var$PromisePrototypeThen = $h2bKv.PromisePrototypeThen, $4afcd8ef71b3a442$var$SymbolAsyncIterator = $h2bKv.SymbolAsyncIterator, $4afcd8ef71b3a442$var$SymbolIterator = $h2bKv.SymbolIterator;

var $lqHhy = parcelRequire("lqHhy");
var $4afcd8ef71b3a442$require$Buffer = $lqHhy.Buffer;

var $dOAm6 = parcelRequire("dOAm6");
var $4afcd8ef71b3a442$require$_require_codes = $dOAm6.codes;
var $4afcd8ef71b3a442$var$ERR_INVALID_ARG_TYPE = $4afcd8ef71b3a442$require$_require_codes.ERR_INVALID_ARG_TYPE, $4afcd8ef71b3a442$var$ERR_STREAM_NULL_VALUES = $4afcd8ef71b3a442$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $4afcd8ef71b3a442$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $4afcd8ef71b3a442$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$4afcd8ef71b3a442$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$4afcd8ef71b3a442$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$4afcd8ef71b3a442$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$4afcd8ef71b3a442$var$SymbolIterator]();
    } else throw new $4afcd8ef71b3a442$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $4afcd8ef71b3a442$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $4afcd8ef71b3a442$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $4afcd8ef71b3a442$var$from;

});


parcelRegister("hM0g8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $h2bKv = parcelRequire("h2bKv");
/* replacement end */ var $cf071edba347527a$var$ArrayPrototypeSlice = $h2bKv.ArrayPrototypeSlice, $cf071edba347527a$var$Error = $h2bKv.Error, $cf071edba347527a$var$FunctionPrototypeSymbolHasInstance = $h2bKv.FunctionPrototypeSymbolHasInstance, $cf071edba347527a$var$ObjectDefineProperty = $h2bKv.ObjectDefineProperty, $cf071edba347527a$var$ObjectDefineProperties = $h2bKv.ObjectDefineProperties, $cf071edba347527a$var$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf, $cf071edba347527a$var$StringPrototypeToLowerCase = $h2bKv.StringPrototypeToLowerCase, $cf071edba347527a$var$Symbol = $h2bKv.Symbol, $cf071edba347527a$var$SymbolHasInstance = $h2bKv.SymbolHasInstance;
module.exports = $cf071edba347527a$var$Writable;
$cf071edba347527a$var$Writable.WritableState = $cf071edba347527a$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $cf071edba347527a$var$EE = $bBoAO.EventEmitter;

var $8IJMa = parcelRequire("8IJMa");
var $cf071edba347527a$require$Stream = $8IJMa.Stream;

var $lqHhy = parcelRequire("lqHhy");
var $cf071edba347527a$require$Buffer = $lqHhy.Buffer;

var $hS2RW = parcelRequire("hS2RW");

var $fdpM7 = parcelRequire("fdpM7");
var $cf071edba347527a$require$addAbortSignal = $fdpM7.addAbortSignal;

var $5poJJ = parcelRequire("5poJJ");
var $cf071edba347527a$var$getHighWaterMark = $5poJJ.getHighWaterMark, $cf071edba347527a$var$getDefaultHighWaterMark = $5poJJ.getDefaultHighWaterMark;

var $dOAm6 = parcelRequire("dOAm6");
var $cf071edba347527a$require$_require_codes = $dOAm6.codes;
var $cf071edba347527a$var$ERR_INVALID_ARG_TYPE = $cf071edba347527a$require$_require_codes.ERR_INVALID_ARG_TYPE, $cf071edba347527a$var$ERR_METHOD_NOT_IMPLEMENTED = $cf071edba347527a$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $cf071edba347527a$var$ERR_MULTIPLE_CALLBACK = $cf071edba347527a$require$_require_codes.ERR_MULTIPLE_CALLBACK, $cf071edba347527a$var$ERR_STREAM_CANNOT_PIPE = $cf071edba347527a$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $cf071edba347527a$var$ERR_STREAM_DESTROYED = $cf071edba347527a$require$_require_codes.ERR_STREAM_DESTROYED, $cf071edba347527a$var$ERR_STREAM_ALREADY_FINISHED = $cf071edba347527a$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $cf071edba347527a$var$ERR_STREAM_NULL_VALUES = $cf071edba347527a$require$_require_codes.ERR_STREAM_NULL_VALUES, $cf071edba347527a$var$ERR_STREAM_WRITE_AFTER_END = $cf071edba347527a$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $cf071edba347527a$var$ERR_UNKNOWN_ENCODING = $cf071edba347527a$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $cf071edba347527a$var$errorOrDestroy = $hS2RW.errorOrDestroy;
$cf071edba347527a$var$ObjectSetPrototypeOf($cf071edba347527a$var$Writable.prototype, $cf071edba347527a$require$Stream.prototype);
$cf071edba347527a$var$ObjectSetPrototypeOf($cf071edba347527a$var$Writable, $cf071edba347527a$require$Stream);
function $cf071edba347527a$var$nop() {}
var $cf071edba347527a$var$kOnFinished = $cf071edba347527a$var$Symbol('kOnFinished');

function $cf071edba347527a$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("5jQJn"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $cf071edba347527a$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $cf071edba347527a$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $cf071edba347527a$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $cf071edba347527a$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$cf071edba347527a$var$kOnFinished] = [];
}
function $cf071edba347527a$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$cf071edba347527a$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $cf071edba347527a$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$cf071edba347527a$var$ObjectDefineProperty($cf071edba347527a$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $cf071edba347527a$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("5jQJn"));
    if (!isDuplex && !$cf071edba347527a$var$FunctionPrototypeSymbolHasInstance($cf071edba347527a$var$Writable, this)) return new $cf071edba347527a$var$Writable(options);
    this._writableState = new $cf071edba347527a$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $cf071edba347527a$require$addAbortSignal(options.signal, this);
    }
    $cf071edba347527a$require$Stream.call(this, options);
    $hS2RW.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $cf071edba347527a$var$clearBuffer(_this, state);
        $cf071edba347527a$var$finishMaybe(_this, state);
    });
}
$cf071edba347527a$var$ObjectDefineProperty($cf071edba347527a$var$Writable, $cf071edba347527a$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($cf071edba347527a$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $cf071edba347527a$var$Writable) return false;
        return object && object._writableState instanceof $cf071edba347527a$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$cf071edba347527a$var$Writable.prototype.pipe = function() {
    $cf071edba347527a$var$errorOrDestroy(this, new $cf071edba347527a$var$ERR_STREAM_CANNOT_PIPE());
};
function $cf071edba347527a$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$cf071edba347527a$require$Buffer.isEncoding(encoding)) throw new $cf071edba347527a$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $cf071edba347527a$var$nop;
    }
    if (chunk === null) throw new $cf071edba347527a$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $cf071edba347527a$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $cf071edba347527a$require$Buffer) encoding = 'buffer';
        else if ($cf071edba347527a$require$Stream._isUint8Array(chunk)) {
            chunk = $cf071edba347527a$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $cf071edba347527a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $cf071edba347527a$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $cf071edba347527a$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $cf071edba347527a$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $cf071edba347527a$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$cf071edba347527a$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $cf071edba347527a$var$_write(this, chunk, encoding, cb) === true;
};
$cf071edba347527a$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$cf071edba347527a$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $cf071edba347527a$var$clearBuffer(this, state);
    }
};
$cf071edba347527a$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $cf071edba347527a$var$StringPrototypeToLowerCase(encoding);
    if (!$cf071edba347527a$require$Buffer.isEncoding(encoding)) throw new $cf071edba347527a$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $cf071edba347527a$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $cf071edba347527a$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $cf071edba347527a$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $cf071edba347527a$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $cf071edba347527a$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $cf071edba347527a$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $cf071edba347527a$var$errorOrDestroy(stream, er);
}
function $cf071edba347527a$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $cf071edba347527a$var$errorOrDestroy(stream, new $cf071edba347527a$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($cf071edba347527a$var$onwriteError, stream, state, er, cb);
        else $cf071edba347527a$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $cf071edba347527a$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($cf071edba347527a$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $cf071edba347527a$var$afterWrite(stream, state, 1, cb);
    }
}
function $cf071edba347527a$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $cf071edba347527a$var$afterWrite(stream, state, count, cb);
}
function $cf071edba347527a$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $cf071edba347527a$var$errorBuffer(state);
    $cf071edba347527a$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $cf071edba347527a$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $cf071edba347527a$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$cf071edba347527a$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $cf071edba347527a$var$ERR_STREAM_DESTROYED('end'));
    }
    $cf071edba347527a$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $cf071edba347527a$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $cf071edba347527a$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $cf071edba347527a$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $cf071edba347527a$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $cf071edba347527a$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $cf071edba347527a$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $cf071edba347527a$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$cf071edba347527a$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $cf071edba347527a$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$cf071edba347527a$var$Writable.prototype._writev = null;
$cf071edba347527a$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $cf071edba347527a$var$_write(this, chunk, encoding);
        if (ret instanceof $cf071edba347527a$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $cf071edba347527a$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $cf071edba347527a$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $cf071edba347527a$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$cf071edba347527a$var$kOnFinished].push(cb);
    }
    return this;
};
function $cf071edba347527a$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $cf071edba347527a$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $cf071edba347527a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $cf071edba347527a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$cf071edba347527a$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $cf071edba347527a$var$errorOrDestroy(stream, err, state.sync);
        } else if ($cf071edba347527a$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($cf071edba347527a$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $cf071edba347527a$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $cf071edba347527a$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $cf071edba347527a$var$finishMaybe(stream, state, sync) {
    if ($cf071edba347527a$var$needFinish(state)) {
        $cf071edba347527a$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($cf071edba347527a$var$needFinish(state)) $cf071edba347527a$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($cf071edba347527a$var$needFinish(state)) {
                state.pendingcb++;
                $cf071edba347527a$var$finish(stream, state);
            }
        }
    }
}
function $cf071edba347527a$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$cf071edba347527a$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$cf071edba347527a$var$ObjectDefineProperties($cf071edba347527a$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $cf071edba347527a$var$destroy = $hS2RW.destroy;
$cf071edba347527a$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$cf071edba347527a$var$kOnFinished].length)) $2Qkr5.nextTick($cf071edba347527a$var$errorBuffer, state);
    $cf071edba347527a$var$destroy.call(this, err, cb);
    return this;
};
$cf071edba347527a$var$Writable.prototype._undestroy = $hS2RW.undestroy;
$cf071edba347527a$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$cf071edba347527a$var$Writable.prototype[$cf071edba347527a$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $cf071edba347527a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $cf071edba347527a$var$lazyWebStreams() {
    if ($cf071edba347527a$var$webStreamsAdapters === undefined) $cf071edba347527a$var$webStreamsAdapters = {};
    return $cf071edba347527a$var$webStreamsAdapters;
}
$cf071edba347527a$var$Writable.fromWeb = function(writableStream, options) {
    return $cf071edba347527a$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$cf071edba347527a$var$Writable.toWeb = function(streamWritable) {
    return $cf071edba347527a$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("fTkVz", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $lqHhy = parcelRequire("lqHhy");

var $coKti = parcelRequire("coKti");
var $b91c39d3df0a8e25$var$isReadable = $coKti.isReadable, $b91c39d3df0a8e25$var$isWritable = $coKti.isWritable, $b91c39d3df0a8e25$var$isIterable = $coKti.isIterable, $b91c39d3df0a8e25$var$isNodeStream = $coKti.isNodeStream, $b91c39d3df0a8e25$var$isReadableNodeStream = $coKti.isReadableNodeStream, $b91c39d3df0a8e25$var$isWritableNodeStream = $coKti.isWritableNodeStream, $b91c39d3df0a8e25$var$isDuplexNodeStream = $coKti.isDuplexNodeStream, $b91c39d3df0a8e25$var$isReadableStream = $coKti.isReadableStream, $b91c39d3df0a8e25$var$isWritableStream = $coKti.isWritableStream;

var $dsQMn = parcelRequire("dsQMn");

var $dOAm6 = parcelRequire("dOAm6");
var $b91c39d3df0a8e25$var$AbortError = $dOAm6.AbortError, $b91c39d3df0a8e25$var$_require_codes = $dOAm6.codes, $b91c39d3df0a8e25$var$ERR_INVALID_ARG_TYPE = $b91c39d3df0a8e25$var$_require_codes.ERR_INVALID_ARG_TYPE, $b91c39d3df0a8e25$var$ERR_INVALID_RETURN_VALUE = $b91c39d3df0a8e25$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $hS2RW = parcelRequire("hS2RW");
var $b91c39d3df0a8e25$require$destroyer = $hS2RW.destroyer;

var $5jQJn = parcelRequire("5jQJn");

var $aUr4N = parcelRequire("aUr4N");

var $hM0g8 = parcelRequire("hM0g8");

var $eqibB = parcelRequire("eqibB");
var $b91c39d3df0a8e25$require$createDeferredPromise = $eqibB.createDeferredPromise;

var $6r9M9 = parcelRequire("6r9M9");
var $b91c39d3df0a8e25$var$Blob = globalThis.Blob || $lqHhy.Blob;
var $b91c39d3df0a8e25$var$isBlob = typeof $b91c39d3df0a8e25$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $b91c39d3df0a8e25$var$Blob;
} : function isBlob(b) {
    return false;
};

var $b91c39d3df0a8e25$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $h2bKv = parcelRequire("h2bKv");
var $b91c39d3df0a8e25$require$FunctionPrototypeCall = $h2bKv.FunctionPrototypeCall;
// This is needed for pre node 17.
var $b91c39d3df0a8e25$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($5jQJn);
module.exports = function duplexify(body, name) {
    if ($b91c39d3df0a8e25$var$isDuplexNodeStream(body)) return body;
    if ($b91c39d3df0a8e25$var$isReadableNodeStream(body)) return $b91c39d3df0a8e25$var$_duplexify({
        readable: body
    });
    if ($b91c39d3df0a8e25$var$isWritableNodeStream(body)) return $b91c39d3df0a8e25$var$_duplexify({
        writable: body
    });
    if ($b91c39d3df0a8e25$var$isNodeStream(body)) return $b91c39d3df0a8e25$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($b91c39d3df0a8e25$var$isReadableStream(body)) return $b91c39d3df0a8e25$var$_duplexify({
        readable: $aUr4N.fromWeb(body)
    });
    if ($b91c39d3df0a8e25$var$isWritableStream(body)) return $b91c39d3df0a8e25$var$_duplexify({
        writable: $hM0g8.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $b91c39d3df0a8e25$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($b91c39d3df0a8e25$var$isIterable(value)) return $6r9M9($b91c39d3df0a8e25$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $b91c39d3df0a8e25$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $b91c39d3df0a8e25$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $b91c39d3df0a8e25$require$destroyer(d, err);
            });
            return d = new $b91c39d3df0a8e25$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $b91c39d3df0a8e25$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($b91c39d3df0a8e25$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($b91c39d3df0a8e25$var$isIterable(body)) return $6r9M9($b91c39d3df0a8e25$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($b91c39d3df0a8e25$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $b91c39d3df0a8e25$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $b91c39d3df0a8e25$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $b91c39d3df0a8e25$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $b91c39d3df0a8e25$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $b91c39d3df0a8e25$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $b91c39d3df0a8e25$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $b91c39d3df0a8e25$require$destroyer(d1, err);
        });
        return d1 = new $b91c39d3df0a8e25$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $b91c39d3df0a8e25$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $b91c39d3df0a8e25$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $b91c39d3df0a8e25$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $b91c39d3df0a8e25$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $b91c39d3df0a8e25$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $b91c39d3df0a8e25$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $b91c39d3df0a8e25$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $aUr4N.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$b91c39d3df0a8e25$var$isReadable(r);
    var writable = !!$b91c39d3df0a8e25$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $b91c39d3df0a8e25$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $dsQMn(w, function(err) {
            writable = false;
            if (err) $b91c39d3df0a8e25$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $dsQMn(r, function(err) {
            readable = false;
            if (err) $b91c39d3df0a8e25$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $b91c39d3df0a8e25$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $b91c39d3df0a8e25$require$destroyer(w, err);
            $b91c39d3df0a8e25$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("jCm3a", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $e482aba44d57d0a6$require$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf;
module.exports = $e482aba44d57d0a6$var$PassThrough;

var $b0RrJ = parcelRequire("b0RrJ");
$e482aba44d57d0a6$require$ObjectSetPrototypeOf($e482aba44d57d0a6$var$PassThrough.prototype, $b0RrJ.prototype);
$e482aba44d57d0a6$require$ObjectSetPrototypeOf($e482aba44d57d0a6$var$PassThrough, $b0RrJ);
function $e482aba44d57d0a6$var$PassThrough(options) {
    if (!(this instanceof $e482aba44d57d0a6$var$PassThrough)) return new $e482aba44d57d0a6$var$PassThrough(options);
    $b0RrJ.call(this, options);
}
$e482aba44d57d0a6$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("b0RrJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $8049271c2889e490$var$ObjectSetPrototypeOf = $h2bKv.ObjectSetPrototypeOf, $8049271c2889e490$var$Symbol = $h2bKv.Symbol;
module.exports = $8049271c2889e490$var$Transform;

var $8049271c2889e490$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("dOAm6")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $5jQJn = parcelRequire("5jQJn");

var $5poJJ = parcelRequire("5poJJ");
var $8049271c2889e490$require$getHighWaterMark = $5poJJ.getHighWaterMark;
$8049271c2889e490$var$ObjectSetPrototypeOf($8049271c2889e490$var$Transform.prototype, $5jQJn.prototype);
$8049271c2889e490$var$ObjectSetPrototypeOf($8049271c2889e490$var$Transform, $5jQJn);
var $8049271c2889e490$var$kCallback = $8049271c2889e490$var$Symbol('kCallback');
function $8049271c2889e490$var$Transform(options) {
    if (!(this instanceof $8049271c2889e490$var$Transform)) return new $8049271c2889e490$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $8049271c2889e490$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $5jQJn.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8049271c2889e490$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8049271c2889e490$var$prefinish);
}
function $8049271c2889e490$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8049271c2889e490$var$prefinish() {
    if (this._final !== $8049271c2889e490$var$_final) $8049271c2889e490$var$_final.call(this);
}
$8049271c2889e490$var$Transform.prototype._final = $8049271c2889e490$var$_final;
$8049271c2889e490$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8049271c2889e490$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8049271c2889e490$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$8049271c2889e490$var$kCallback] = callback;
    });
};
$8049271c2889e490$var$Transform.prototype._read = function() {
    if (this[$8049271c2889e490$var$kCallback]) {
        var callback = this[$8049271c2889e490$var$kCallback];
        this[$8049271c2889e490$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("1c4Vy", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $h2bKv = parcelRequire("h2bKv");
var $0deabbe008dcfcb6$var$ArrayPrototypePop = $h2bKv.ArrayPrototypePop, $0deabbe008dcfcb6$var$Promise = $h2bKv.Promise;

var $coKti = parcelRequire("coKti");
var $0deabbe008dcfcb6$var$isIterable = $coKti.isIterable, $0deabbe008dcfcb6$var$isNodeStream = $coKti.isNodeStream, $0deabbe008dcfcb6$var$isWebStream = $coKti.isWebStream;

var $clB1p = parcelRequire("clB1p");
var $0deabbe008dcfcb6$var$pl = $clB1p.pipelineImpl;

var $dsQMn = parcelRequire("dsQMn");
var $0deabbe008dcfcb6$require$finished = $dsQMn.finished;
parcelRequire("cRPwj");
function $0deabbe008dcfcb6$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $0deabbe008dcfcb6$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$0deabbe008dcfcb6$var$isNodeStream(lastArg) && !$0deabbe008dcfcb6$var$isIterable(lastArg) && !$0deabbe008dcfcb6$var$isWebStream(lastArg)) {
            var options = $0deabbe008dcfcb6$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $0deabbe008dcfcb6$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $0deabbe008dcfcb6$require$finished,
    pipeline: $0deabbe008dcfcb6$var$pipeline
};

});



parcelRegister("8GYyi", function(module, exports) {
"use strict";
var $6541375a12ba0198$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6541375a12ba0198$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6541375a12ba0198$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6541375a12ba0198$var$__exportStar((parcelRequire("6P9ri")), module.exports);

});
parcelRegister("6P9ri", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Converter = void 0;

var $318ie = parcelRequire("318ie");

var $ia9U2 = parcelRequire("ia9U2");
/**
 * Converts SPARQL JSON results to a tree-based structure by splitting variables on a certain delimiter.
 */ var $4f7ed3f6604888ad$var$Converter = /*#__PURE__*/ function() {
    function Converter(settings) {
        (0, $jGAMp._)(this, Converter);
        settings = settings || {
            delimiter: '_'
        };
        settings.prefixVariableQuestionMark = false;
        this.delimiter = settings.delimiter || '_';
        this.parser = new $ia9U2.SparqlJsonParser(settings);
        this.materializeRdfJsTerms = settings.materializeRdfJsTerms;
    }
    (0, $byiyg._)(Converter, [
        {
            /**
     * Convert a complete SPARQL JSON response to a GraphQL results tree.
     * @param sparqlResponse A SPARQL JSON response.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */ key: "sparqlJsonResultsToTree",
            value: function sparqlJsonResultsToTree(sparqlResponse, schema) {
                return this.bindingsToTree(this.parser.parseJsonResults(sparqlResponse), schema || {
                    singularizeVariables: {}
                });
            }
        },
        {
            /**
     * Convert an array of bindings to a GraphQL results tree.
     * @param {IBindings[]} bindingsArray An array of bindings.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */ key: "bindingsToTree",
            value: function bindingsToTree(bindingsArray, schema) {
                var singularRoot = schema && schema.singularizeVariables[''];
                var tree = singularRoot ? {} : [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = bindingsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var bindings = _step.value;
                        var subTree = singularRoot ? {} : [
                            {}
                        ];
                        for(var key in bindings){
                            var path = key.split(this.delimiter);
                            var value = bindings[key];
                            Converter.addValueToTree(singularRoot ? subTree : subTree[0], path, value, '', schema, this.delimiter);
                        }
                        tree = Converter.mergeTrees(tree, subTree).result;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.materializeRdfJsTerms) tree = Converter.materializeTree(tree);
                return tree;
            }
        }
    ], [
        {
            key: "addValueToTree",
            value: /**
     * Adds a value to a tree.
     * @param tree A tree datastructure.
     * @param {string[]} path The path of keys in the tree.
     * @param {Term} value A value to add.
     * @param {string} lastKeyPath The accumulated key path (separated by the given delimiter)
     *                             through recursive calls, can be empty.
     * @param {ISchema} schema A schema.
     * @param {string} delimiter The string to join key paths by.
     */ function addValueToTree(tree, path, value, lastKeyPath, schema, delimiter) {
                var key = path[0];
                var keyPath = lastKeyPath ? lastKeyPath + delimiter + key : key;
                var singularize = schema.singularizeVariables[keyPath];
                if (path.length === 1) {
                    // Leaf nodes
                    if (singularize) {
                        if (!tree[key]) tree[key] = value;
                    } else {
                        if (!tree[key]) tree[key] = [];
                        tree[key].push(value);
                    }
                } else {
                    // Inner nodes
                    var nextNode;
                    if (singularize) {
                        if (!tree[key]) tree[key] = {};
                        nextNode = tree[key];
                    } else {
                        if (!tree[key]) tree[key] = [
                            {}
                        ];
                        nextNode = tree[key][0];
                    }
                    Converter.addValueToTree(nextNode, path.slice(1), value, keyPath, schema, delimiter);
                }
            }
        },
        {
            key: "mergeTrees",
            value: /**
     * Recursively merge the two given trees.
     * @param tree1 A first tree (has key priority on literals).
     * @param tree2 A second tree. All arrays will/should only have a single element.
     * @return {any} The merged tree.
     */ function mergeTrees(tree1, tree2) {
                if ((typeof tree1 === "undefined" ? "undefined" : (0, $3KZcf._)(tree1)) !== (typeof tree2 === "undefined" ? "undefined" : (0, $3KZcf._)(tree2))) throw new Error("Two incompatible tree nodes were found: ".concat(typeof tree1 === "undefined" ? "undefined" : (0, $3KZcf._)(tree1), " and ").concat(typeof tree2 === "undefined" ? "undefined" : (0, $3KZcf._)(tree2)));
                if (Array.isArray(tree1) !== Array.isArray(tree2)) throw new Error("Two incompatible tree nodes were found: Array?".concat(Array.isArray(tree1), " and Array?").concat(Array.isArray(tree2)));
                if ((typeof tree1 === "undefined" ? "undefined" : (0, $3KZcf._)(tree1)) === 'object' && (typeof tree2 === "undefined" ? "undefined" : (0, $3KZcf._)(tree2)) === 'object') {
                    if (tree1.termType && tree2.termType) {
                        if (tree1.equals(tree2)) return {
                            valid: true,
                            result: tree1
                        };
                        else return {
                            valid: false,
                            result: tree1
                        };
                    }
                    if (Array.isArray(tree1) && Array.isArray(tree2)) {
                        if (tree1.length > 0) {
                            var merged = [];
                            var valid = false;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = tree1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var tree1Element = _step.value;
                                    var mergedElement = Converter.mergeTrees(tree1Element, tree2[0]);
                                    if (mergedElement.valid) {
                                        valid = true;
                                        merged.push(mergedElement.result);
                                    } else merged.push(tree1Element);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (valid) return {
                                valid: true,
                                result: merged
                            };
                        }
                        return {
                            valid: true,
                            result: tree1.concat(tree2)
                        };
                    } else {
                        var merged1 = {};
                        for(var key2 in tree2)merged1[key2] = tree2[key2];
                        for(var key1 in tree1)if (merged1[key1]) {
                            var mergedElement1 = Converter.mergeTrees(tree1[key1], merged1[key1]);
                            if (mergedElement1.valid) merged1[key1] = mergedElement1.result;
                            else return {
                                valid: false,
                                result: tree1
                            };
                        } else merged1[key1] = tree1[key1];
                        return {
                            valid: true,
                            result: merged1
                        };
                    }
                } else throw new Error("Unmergable tree types: ".concat(typeof tree1 === "undefined" ? "undefined" : (0, $3KZcf._)(tree1), " and ").concat(typeof tree2 === "undefined" ? "undefined" : (0, $3KZcf._)(tree2)));
            }
        },
        {
            key: "materializeTree",
            value: /**
     * Materialize all RDF terms in the given tree to raw values.
     * This does not mutate the original tree.
     * @param tree A tree.
     * @return {any} A materialized tree.
     */ function materializeTree(tree) {
                if (tree.termType) return (0, $318ie.getTermRaw)(tree);
                else if (Array.isArray(tree)) return tree.map(Converter.materializeTree);
                else {
                    var materialized = {};
                    for(var key in tree)materialized[key] = Converter.materializeTree(tree[key]);
                    return materialized;
                }
            }
        }
    ]);
    return Converter;
}();
module.exports.Converter = $4f7ed3f6604888ad$var$Converter;

});
parcelRegister("318ie", function(module, exports) {
"use strict";
var $2327e5e7f9d6ef3b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2327e5e7f9d6ef3b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2327e5e7f9d6ef3b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSupportedJavaScriptPrimitives = module.exports.getSupportedRdfDatatypes = module.exports.getTermRaw = module.exports.toRdf = module.exports.fromRdf = void 0;

var $2ej16 = parcelRequire("2ej16");



$2327e5e7f9d6ef3b$var$__exportStar((parcelRequire("6Uwfd")), module.exports);

$2327e5e7f9d6ef3b$var$__exportStar((parcelRequire("v9H7l")), module.exports);

$2327e5e7f9d6ef3b$var$__exportStar((parcelRequire("93PWk")), module.exports);
var $2327e5e7f9d6ef3b$var$DF = new $2ej16.DataFactory();
// Construct translator with built-in handlers
var $2327e5e7f9d6ef3b$var$translator = new (parcelRequire("93PWk")).Translator();
$2327e5e7f9d6ef3b$var$translator.registerHandler(new (parcelRequire("6Uwfd")).TypeHandlerString(), (parcelRequire("6Uwfd")).TypeHandlerString.TYPES.map(function(t) {
    return $2327e5e7f9d6ef3b$var$DF.namedNode(t);
}), [
    'string'
]);
$2327e5e7f9d6ef3b$var$translator.registerHandler(new (parcelRequire("6Uwfd")).TypeHandlerBoolean(), [
    (parcelRequire("6Uwfd")).TypeHandlerBoolean.TYPE
].map(function(t) {
    return $2327e5e7f9d6ef3b$var$DF.namedNode(t);
}), [
    'boolean'
]);
$2327e5e7f9d6ef3b$var$translator.registerHandler(new (parcelRequire("6Uwfd")).TypeHandlerNumberDouble(), (parcelRequire("6Uwfd")).TypeHandlerNumberDouble.TYPES.map(function(t) {
    return $2327e5e7f9d6ef3b$var$DF.namedNode(t);
}), [
    'number'
]);
$2327e5e7f9d6ef3b$var$translator.registerHandler(new (parcelRequire("6Uwfd")).TypeHandlerNumberInteger(), (parcelRequire("6Uwfd")).TypeHandlerNumberInteger.TYPES.map(function(t) {
    return $2327e5e7f9d6ef3b$var$DF.namedNode(t);
}), [
    'number'
]);
$2327e5e7f9d6ef3b$var$translator.registerHandler(new (parcelRequire("6Uwfd")).TypeHandlerDate(), (parcelRequire("6Uwfd")).TypeHandlerDate.TYPES.map(function(t) {
    return $2327e5e7f9d6ef3b$var$DF.namedNode(t);
}), [
    'object'
]);
/**
 * Convert the given RDF literal to an JavaScript primitive.
 * @param {Literal} literal An RDF literal value.
 * @param {boolean} validate If the literal value should be validated against the datatype.
 * @return {any} A JavaScript primitive value.
 */ function $2327e5e7f9d6ef3b$var$fromRdf(literal, validate) {
    return $2327e5e7f9d6ef3b$var$translator.fromRdf(literal, validate);
}
module.exports.fromRdf = $2327e5e7f9d6ef3b$var$fromRdf;
/**
 * Convert the given JavaScript primitive to an RDF literal.
 * @param value A JavaScript primitive value.
 * @param options Options for RDF conversion. May also be a data factory.
 * @return {Literal} An RDF literal value.
 */ function $2327e5e7f9d6ef3b$var$toRdf(value, options) {
    // Backwards-compatibility to accept data factory as option arg.
    if (options && 'namedNode' in options) options = {
        dataFactory: options
    };
    // Set default data factory
    options = options || {};
    if (options && !options.dataFactory) options.dataFactory = $2327e5e7f9d6ef3b$var$DF;
    return $2327e5e7f9d6ef3b$var$translator.toRdf(value, options);
}
module.exports.toRdf = $2327e5e7f9d6ef3b$var$toRdf;
/**
 * Get the raw value of the given term.
 * If it is a literal, {@link fromRdf} will be called.
 * Otherwise {@link .value} will be returned.
 * @param {Term} term Any RDF term.
 * @param {boolean} validate If the literal value should be validated against the datatype.
 * @return {any} A JavaScript primitive value.
 */ function $2327e5e7f9d6ef3b$var$getTermRaw(term, validate) {
    if (term.termType === 'Literal') return $2327e5e7f9d6ef3b$var$fromRdf(term, validate);
    return term.value;
}
module.exports.getTermRaw = $2327e5e7f9d6ef3b$var$getTermRaw;
/**
 * @return {NamedNode[]} An array of all supported RDF datatypes.
 */ function $2327e5e7f9d6ef3b$var$getSupportedRdfDatatypes() {
    return $2327e5e7f9d6ef3b$var$translator.getSupportedRdfDatatypes();
}
module.exports.getSupportedRdfDatatypes = $2327e5e7f9d6ef3b$var$getSupportedRdfDatatypes;
/**
 * @return {string[]} An array of all supported JavaScript types.
 */ function $2327e5e7f9d6ef3b$var$getSupportedJavaScriptPrimitives() {
    return $2327e5e7f9d6ef3b$var$translator.getSupportedJavaScriptPrimitives();
}
module.exports.getSupportedJavaScriptPrimitives = $2327e5e7f9d6ef3b$var$getSupportedJavaScriptPrimitives;

});
parcelRegister("6Uwfd", function(module, exports) {
"use strict";
var $5080fc196488a96a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5080fc196488a96a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5080fc196488a96a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5080fc196488a96a$var$__exportStar((parcelRequire("iU1bk")), module.exports);

$5080fc196488a96a$var$__exportStar((parcelRequire("52aUo")), module.exports);

$5080fc196488a96a$var$__exportStar((parcelRequire("6O1wT")), module.exports);

$5080fc196488a96a$var$__exportStar((parcelRequire("bVirD")), module.exports);

$5080fc196488a96a$var$__exportStar((parcelRequire("esIdd")), module.exports);

});
parcelRegister("iU1bk", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerBoolean = void 0;

var $93PWk = parcelRequire("93PWk");
/**
 * Translates booleans.
 */ var $dc2e5f9a04fd35f5$var$TypeHandlerBoolean = /*#__PURE__*/ function() {
    function TypeHandlerBoolean() {
        (0, $jGAMp._)(this, TypeHandlerBoolean);
    }
    (0, $byiyg._)(TypeHandlerBoolean, [
        {
            key: "fromRdf",
            value: function fromRdf(literal, validate) {
                switch(literal.value){
                    case 'true':
                        return true;
                    case 'false':
                        return false;
                    case '1':
                        return true;
                    case '0':
                        return false;
                }
                if (validate) $93PWk.Translator.incorrectRdfDataType(literal);
                return false;
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, param) {
                var datatype = param.datatype, dataFactory = param.dataFactory;
                return dataFactory.literal(value ? 'true' : 'false', datatype || dataFactory.namedNode(TypeHandlerBoolean.TYPE));
            }
        }
    ]);
    return TypeHandlerBoolean;
}();
$dc2e5f9a04fd35f5$var$TypeHandlerBoolean.TYPE = 'http://www.w3.org/2001/XMLSchema#boolean';
module.exports.TypeHandlerBoolean = $dc2e5f9a04fd35f5$var$TypeHandlerBoolean;

});
parcelRegister("93PWk", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translator = void 0;
/**
 * Translates between an RDF literal and a JavaScript primitive.
 */ var $698caf03e3a1e94e$var$Translator = /*#__PURE__*/ function() {
    function Translator() {
        (0, $jGAMp._)(this, Translator);
        this.supportedRdfDatatypes = [];
        this.fromRdfHandlers = {};
        this.toRdfHandlers = {};
    }
    (0, $byiyg._)(Translator, [
        {
            key: "registerHandler",
            value: function registerHandler(handler, rdfDatatypes, javaScriptDataTypes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rdfDatatypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var rdfDatatype = _step.value;
                        this.supportedRdfDatatypes.push(rdfDatatype);
                        this.fromRdfHandlers[rdfDatatype.value] = handler;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = javaScriptDataTypes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var javaScriptDataType = _step1.value;
                        var existingToRdfHandlers = this.toRdfHandlers[javaScriptDataType];
                        if (!existingToRdfHandlers) this.toRdfHandlers[javaScriptDataType] = existingToRdfHandlers = [];
                        existingToRdfHandlers.push(handler);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "fromRdf",
            value: function fromRdf(literal, validate) {
                var handler = this.fromRdfHandlers[literal.datatype.value];
                if (handler) return handler.fromRdf(literal, validate);
                else return literal.value;
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, options) {
                var handlers = this.toRdfHandlers[typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (handlers) try {
                    for(var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        var ret = handler.toRdf(value, options);
                        if (ret) return ret;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                throw new Error("Invalid JavaScript value: '".concat(value, "'"));
            }
        },
        {
            /**
     * @return {NamedNode[]} An array of all supported RDF datatypes.
     */ key: "getSupportedRdfDatatypes",
            value: function getSupportedRdfDatatypes() {
                return this.supportedRdfDatatypes;
            }
        },
        {
            /**
     * @return {string[]} An array of all supported JavaScript types.
     */ key: "getSupportedJavaScriptPrimitives",
            value: function getSupportedJavaScriptPrimitives() {
                return Object.keys(this.toRdfHandlers);
            }
        }
    ], [
        {
            key: "incorrectRdfDataType",
            value: function incorrectRdfDataType(literal) {
                throw new Error("Invalid RDF ".concat(literal.datatype.value, " value: '").concat(literal.value, "'"));
            }
        }
    ]);
    return Translator;
}();
module.exports.Translator = $698caf03e3a1e94e$var$Translator;

});


parcelRegister("52aUo", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerDate = void 0;

var $93PWk = parcelRequire("93PWk");
/**
 * Translates dates.
 */ var $3aa599d86620b42e$var$TypeHandlerDate = /*#__PURE__*/ function() {
    function TypeHandlerDate() {
        (0, $jGAMp._)(this, TypeHandlerDate);
    }
    (0, $byiyg._)(TypeHandlerDate, [
        {
            key: "fromRdf",
            value: function fromRdf(literal, validate) {
                if (validate && !literal.value.match(TypeHandlerDate.VALIDATORS[literal.datatype.value.substr(33, literal.datatype.value.length)])) $93PWk.Translator.incorrectRdfDataType(literal);
                switch(literal.datatype.value){
                    case 'http://www.w3.org/2001/XMLSchema#gDay':
                        return new Date(0, 0, parseInt(literal.value, 10));
                    case 'http://www.w3.org/2001/XMLSchema#gMonthDay':
                        var partsMonthDay = literal.value.split('-');
                        return new Date(0, parseInt(partsMonthDay[0], 10) - 1, parseInt(partsMonthDay[1], 10));
                    case 'http://www.w3.org/2001/XMLSchema#gYear':
                        return new Date(literal.value + '-01-01');
                    case 'http://www.w3.org/2001/XMLSchema#gYearMonth':
                        return new Date(literal.value + '-01');
                    default:
                        return new Date(literal.value);
                }
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, param) {
                var datatype = param.datatype, dataFactory = param.dataFactory;
                datatype = datatype || dataFactory.namedNode(TypeHandlerDate.TYPES[0]);
                // Assume date values
                if (!(value instanceof Date)) return null;
                var date = value;
                var valueString;
                switch(datatype.value){
                    case 'http://www.w3.org/2001/XMLSchema#gDay':
                        valueString = String(date.getUTCDate());
                        break;
                    case 'http://www.w3.org/2001/XMLSchema#gMonthDay':
                        valueString = date.getUTCMonth() + 1 + '-' + date.getUTCDate();
                        break;
                    case 'http://www.w3.org/2001/XMLSchema#gYear':
                        valueString = String(date.getUTCFullYear());
                        break;
                    case 'http://www.w3.org/2001/XMLSchema#gYearMonth':
                        valueString = date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1);
                        break;
                    case 'http://www.w3.org/2001/XMLSchema#date':
                        valueString = date.toISOString().replace(/T.*$/, '');
                        break;
                    default:
                        valueString = date.toISOString();
                }
                return dataFactory.literal(valueString, datatype);
            }
        }
    ]);
    return TypeHandlerDate;
}();
$3aa599d86620b42e$var$TypeHandlerDate.TYPES = [
    'http://www.w3.org/2001/XMLSchema#dateTime',
    'http://www.w3.org/2001/XMLSchema#date',
    'http://www.w3.org/2001/XMLSchema#gDay',
    'http://www.w3.org/2001/XMLSchema#gMonthDay',
    'http://www.w3.org/2001/XMLSchema#gYear',
    'http://www.w3.org/2001/XMLSchema#gYearMonth'
];
$3aa599d86620b42e$var$TypeHandlerDate.VALIDATORS = {
    date: /^[0-9]+-[0-9][0-9]-[0-9][0-9]Z?$/,
    dateTime: /^[0-9]+-[0-9][0-9]-[0-9][0-9]T[0-9][0-9]:[0-9][0-9]:[0-9][0-9](\.[0-9][0-9][0-9])?((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
    gDay: /^[0-9]+$/,
    gMonthDay: /^[0-9]+-[0-9][0-9]$/,
    gYear: /^[0-9]+$/,
    gYearMonth: /^[0-9]+-[0-9][0-9]$/
};
module.exports.TypeHandlerDate = $3aa599d86620b42e$var$TypeHandlerDate;

});

parcelRegister("6O1wT", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerNumberDouble = void 0;

var $93PWk = parcelRequire("93PWk");
/**
 * Translates double numbers.
 */ var $4f4899521ef68bea$var$TypeHandlerNumberDouble = /*#__PURE__*/ function() {
    function TypeHandlerNumberDouble() {
        (0, $jGAMp._)(this, TypeHandlerNumberDouble);
    }
    (0, $byiyg._)(TypeHandlerNumberDouble, [
        {
            key: "fromRdf",
            value: function fromRdf(literal, validate) {
                var parsed = parseFloat(literal.value);
                if (validate) {
                    if (isNaN(parsed)) $93PWk.Translator.incorrectRdfDataType(literal);
                }
                return parsed;
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, param) {
                var datatype = param.datatype, dataFactory = param.dataFactory;
                datatype = datatype || dataFactory.namedNode(TypeHandlerNumberDouble.TYPES[0]);
                if (isNaN(value)) return dataFactory.literal('NaN', datatype);
                if (!isFinite(value)) return dataFactory.literal(value > 0 ? 'INF' : '-INF', datatype);
                if (value % 1 === 0) return null;
                return dataFactory.literal(value.toExponential(15).replace(/(\d)0*e\+?/, '$1E'), datatype);
            }
        }
    ]);
    return TypeHandlerNumberDouble;
}();
$4f4899521ef68bea$var$TypeHandlerNumberDouble.TYPES = [
    'http://www.w3.org/2001/XMLSchema#double',
    'http://www.w3.org/2001/XMLSchema#decimal',
    'http://www.w3.org/2001/XMLSchema#float'
];
module.exports.TypeHandlerNumberDouble = $4f4899521ef68bea$var$TypeHandlerNumberDouble;

});

parcelRegister("bVirD", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerNumberInteger = void 0;

var $93PWk = parcelRequire("93PWk");
/**
 * Translates integer numbers.
 */ var $8ae35353a8964989$var$TypeHandlerNumberInteger = /*#__PURE__*/ function() {
    function TypeHandlerNumberInteger() {
        (0, $jGAMp._)(this, TypeHandlerNumberInteger);
    }
    (0, $byiyg._)(TypeHandlerNumberInteger, [
        {
            key: "fromRdf",
            value: function fromRdf(literal, validate) {
                var parsed = parseInt(literal.value, 10);
                if (validate) {
                    if (isNaN(parsed) || literal.value.indexOf('.') >= 0) $93PWk.Translator.incorrectRdfDataType(literal);
                }
                return parsed;
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, param) {
                var datatype = param.datatype, dataFactory = param.dataFactory;
                return dataFactory.literal(String(value), datatype || (value <= TypeHandlerNumberInteger.MAX_INT && value >= TypeHandlerNumberInteger.MIN_INT ? dataFactory.namedNode(TypeHandlerNumberInteger.TYPES[0]) : dataFactory.namedNode(TypeHandlerNumberInteger.TYPES[1])));
            }
        }
    ]);
    return TypeHandlerNumberInteger;
}();
$8ae35353a8964989$var$TypeHandlerNumberInteger.TYPES = [
    'http://www.w3.org/2001/XMLSchema#integer',
    'http://www.w3.org/2001/XMLSchema#long',
    'http://www.w3.org/2001/XMLSchema#int',
    'http://www.w3.org/2001/XMLSchema#byte',
    'http://www.w3.org/2001/XMLSchema#short',
    'http://www.w3.org/2001/XMLSchema#negativeInteger',
    'http://www.w3.org/2001/XMLSchema#nonNegativeInteger',
    'http://www.w3.org/2001/XMLSchema#nonPositiveInteger',
    'http://www.w3.org/2001/XMLSchema#positiveInteger',
    'http://www.w3.org/2001/XMLSchema#unsignedByte',
    'http://www.w3.org/2001/XMLSchema#unsignedInt',
    'http://www.w3.org/2001/XMLSchema#unsignedLong',
    'http://www.w3.org/2001/XMLSchema#unsignedShort'
];
$8ae35353a8964989$var$TypeHandlerNumberInteger.MAX_INT = 2147483647;
$8ae35353a8964989$var$TypeHandlerNumberInteger.MIN_INT = -2147483648;
module.exports.TypeHandlerNumberInteger = $8ae35353a8964989$var$TypeHandlerNumberInteger;

});

parcelRegister("esIdd", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerString = void 0;
/**
 * Translates strings.
 */ var $a875f9d27eaee4fe$var$TypeHandlerString = /*#__PURE__*/ function() {
    function TypeHandlerString() {
        (0, $jGAMp._)(this, TypeHandlerString);
    }
    (0, $byiyg._)(TypeHandlerString, [
        {
            key: "fromRdf",
            value: function fromRdf(literal) {
                return literal.value;
            }
        },
        {
            key: "toRdf",
            value: function toRdf(value, param) {
                var datatype = param.datatype, dataFactory = param.dataFactory;
                return dataFactory.literal(value, datatype);
            }
        }
    ]);
    return TypeHandlerString;
}();
$a875f9d27eaee4fe$var$TypeHandlerString.TYPES = [
    'http://www.w3.org/2001/XMLSchema#string',
    'http://www.w3.org/2001/XMLSchema#normalizedString',
    'http://www.w3.org/2001/XMLSchema#anyURI',
    'http://www.w3.org/2001/XMLSchema#base64Binary',
    'http://www.w3.org/2001/XMLSchema#language',
    'http://www.w3.org/2001/XMLSchema#Name',
    'http://www.w3.org/2001/XMLSchema#NCName',
    'http://www.w3.org/2001/XMLSchema#NMTOKEN',
    'http://www.w3.org/2001/XMLSchema#token',
    'http://www.w3.org/2001/XMLSchema#hexBinary',
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString',
    'http://www.w3.org/2001/XMLSchema#time',
    'http://www.w3.org/2001/XMLSchema#duration'
];
module.exports.TypeHandlerString = $a875f9d27eaee4fe$var$TypeHandlerString;

});


parcelRegister("v9H7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("ia9U2", function(module, exports) {
"use strict";
var $d390d7ab0404b11b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d390d7ab0404b11b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d390d7ab0404b11b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d390d7ab0404b11b$var$__exportStar((parcelRequire("eMU6I")), module.exports);

});
parcelRegister("eMU6I", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlJsonParser = void 0;

var $2ej16 = parcelRequire("2ej16");

var $evS07 = parcelRequire("evS07");

var $3Ywen = parcelRequire("3Ywen");
/**
 * Parser for the SPARQL 1.1 Query Results JSON format.
 * @see https://www.w3.org/TR/sparql11-results-json/
 */ var $ac411223f5cf4769$var$SparqlJsonParser = /*#__PURE__*/ function() {
    function SparqlJsonParser(settings) {
        (0, $jGAMp._)(this, SparqlJsonParser);
        var _a;
        settings = settings || {};
        this.dataFactory = settings.dataFactory || new $2ej16.DataFactory();
        this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
        this.suppressMissingStreamResultsError = (_a = settings.suppressMissingStreamResultsError) !== null && _a !== void 0 ? _a : true;
    }
    (0, $byiyg._)(SparqlJsonParser, [
        {
            /**
     * Convert a SPARQL JSON bindings response to an array of bindings objects.
     * @param sparqlResponse A SPARQL JSON response.
     * @return {IBindings[]} An array of bindings.
     */ key: "parseJsonResults",
            value: function parseJsonResults(sparqlResponse) {
                var _this = this;
                return sparqlResponse.results.bindings.map(function(rawBindings) {
                    return _this.parseJsonBindings(rawBindings);
                });
            }
        },
        {
            /**
     * Convert a SPARQL JSON bindings response stream to a stream of bindings objects.
     *
     * The bindings stream will emit a 'variables' event that will contain
     * the array of variables (as RDF.Variable[]), as defined in the response head.
     *
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */ key: "parseJsonResultsStream",
            value: function parseJsonResultsStream(sparqlResponseStream) {
                var _this = this;
                var errorListener = function(error) {
                    return resultStream.emit('error', error);
                };
                sparqlResponseStream.on('error', errorListener);
                var jsonParser = new $3Ywen();
                jsonParser.onError = errorListener;
                var variablesFound = false;
                var resultsFound = false;
                jsonParser.onValue = function(value) {
                    if (jsonParser.key === "vars" && jsonParser.stack.length === 2 && jsonParser.stack[1].key === 'head') {
                        resultStream.emit('variables', value.map(function(v) {
                            return _this.dataFactory.variable(v);
                        }));
                        variablesFound = true;
                    } else if (jsonParser.key === "results" && jsonParser.stack.length === 1) resultsFound = true;
                    else if (typeof jsonParser.key === 'number' && jsonParser.stack.length === 3 && jsonParser.stack[1].key === 'results' && jsonParser.stack[2].key === 'bindings') try {
                        resultStream.push(_this.parseJsonBindings(value));
                    } catch (error) {
                        resultStream.emit("error", error);
                    }
                    else if (jsonParser.key === "metadata" && jsonParser.stack.length === 1) resultStream.emit('metadata', value);
                };
                var resultStream = sparqlResponseStream.on("end", function(_) {
                    if (!resultsFound && !_this.suppressMissingStreamResultsError) resultStream.emit("error", new Error("No valid SPARQL query results were found."));
                    else if (!variablesFound) resultStream.emit('variables', []);
                }).pipe(new $evS07.Transform({
                    objectMode: true,
                    transform: function(chunk, encoding, callback) {
                        jsonParser.write(chunk);
                        callback();
                    }
                }));
                return resultStream;
            }
        },
        {
            /**
     * Convert a SPARQL JSON result binding to a bindings object.
     * @param rawBindings A SPARQL JSON result binding.
     * @return {IBindings} A bindings object.
     */ key: "parseJsonBindings",
            value: function parseJsonBindings(rawBindings) {
                var bindings = {};
                for(var key in rawBindings){
                    var rawValue = rawBindings[key];
                    bindings[this.prefixVariableQuestionMark ? '?' + key : key] = this.parseJsonValue(rawValue);
                }
                return bindings;
            }
        },
        {
            /**
     * Convert a SPARQL JSON result value to an RDF term.
     * @param rawValue A SPARQL JSON result value
     * @return {RDF.Term} An RDF term.
     */ key: "parseJsonValue",
            value: function parseJsonValue(rawValue) {
                var value;
                switch(rawValue.type){
                    case 'bnode':
                        value = this.dataFactory.blankNode(rawValue.value);
                        break;
                    case 'literal':
                        if (rawValue['xml:lang']) value = this.dataFactory.literal(rawValue.value, rawValue['xml:lang']);
                        else if (rawValue.datatype) value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
                        else value = this.dataFactory.literal(rawValue.value);
                        break;
                    case 'typed-literal':
                        // Virtuoso uses this non-spec-compliant way of defining typed literals
                        value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
                        break;
                    case 'triple':
                        var tripleValue = rawValue.value;
                        if (!tripleValue || !tripleValue.subject || !tripleValue.predicate || !tripleValue.object) throw new Error('Invalid quoted triple: ' + JSON.stringify(rawValue));
                        value = this.dataFactory.quad(this.parseJsonValue(tripleValue.subject), this.parseJsonValue(tripleValue.predicate), this.parseJsonValue(tripleValue.object));
                        break;
                    default:
                        value = this.dataFactory.namedNode(rawValue.value);
                        break;
                }
                return value;
            }
        },
        {
            /**
     * Convert a SPARQL JSON boolean response to a boolean.
     * This will throw an error if the given reponse was not a valid boolean response.
     * @param sparqlResponse A SPARQL JSON response.
     * @return {IBindings[]} An array of bindings.
     */ key: "parseJsonBoolean",
            value: function parseJsonBoolean(sparqlResponse) {
                if ('boolean' in sparqlResponse) return sparqlResponse["boolean"];
                throw new Error('No valid ASK response was found.');
            }
        },
        {
            /**
     * Convert a SPARQL JSON boolean response stream to a promise resolving to a boolean.
     * This will reject if the given reponse was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {Promise<boolean>} The response boolean.
     */ key: "parseJsonBooleanStream",
            value: function parseJsonBooleanStream(sparqlResponseStream) {
                return new Promise(function(resolve, reject) {
                    var parser = new $3Ywen();
                    parser.onError = reject;
                    parser.onValue = function(value) {
                        if (parser.key === "boolean" && typeof value === 'boolean' && parser.stack.length === 1) resolve(value);
                    };
                    sparqlResponseStream.on('error', reject).on('data', function(d) {
                        return parser.write(d);
                    }).on('end', function() {
                        return reject(new Error('No valid ASK response was found.'));
                    });
                });
            }
        }
    ]);
    return SparqlJsonParser;
}();
module.exports.SparqlJsonParser = $ac411223f5cf4769$var$SparqlJsonParser;

});
parcelRegister("evS07", function(module, exports) {
'use strict';

var $fOikn = parcelRequire("fOikn");

var $9UwPA = parcelRequire("9UwPA");
var $a90dd96bafad7d7d$var$originalDestroy = $fOikn.Readable.destroy;
module.exports = $fOikn.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $fOikn._uint8ArrayToBuffer;
module.exports._isUint8Array = $fOikn._isUint8Array;
module.exports.isDisturbed = $fOikn.isDisturbed;
module.exports.isErrored = $fOikn.isErrored;
module.exports.isReadable = $fOikn.isReadable;
module.exports.Readable = $fOikn.Readable;
module.exports.Writable = $fOikn.Writable;
module.exports.Duplex = $fOikn.Duplex;
module.exports.Transform = $fOikn.Transform;
module.exports.PassThrough = $fOikn.PassThrough;
module.exports.addAbortSignal = $fOikn.addAbortSignal;
module.exports.finished = $fOikn.finished;
module.exports.destroy = $fOikn.destroy;
module.exports.destroy = $a90dd96bafad7d7d$var$originalDestroy;
module.exports.pipeline = $fOikn.pipeline;
module.exports.compose = $fOikn.compose;
Object.defineProperty($fOikn, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $9UwPA;
    }
});
module.exports.Stream = $fOikn.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("fOikn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $k4uY4 = parcelRequire("k4uY4");
var $b829be057d46c1a2$require$Buffer = $k4uY4.Buffer;

var $2LuAg = parcelRequire("2LuAg");
/* replacement end */ var $b829be057d46c1a2$var$ObjectDefineProperty = $2LuAg.ObjectDefineProperty, $b829be057d46c1a2$var$ObjectKeys = $2LuAg.ObjectKeys, $b829be057d46c1a2$var$ReflectApply = $2LuAg.ReflectApply;

var $bIvqM = parcelRequire("bIvqM");
var $b829be057d46c1a2$var$_require_promisify = $bIvqM.promisify, $b829be057d46c1a2$var$customPromisify = $b829be057d46c1a2$var$_require_promisify.custom;

var $4ZS5o = parcelRequire("4ZS5o");
var $b829be057d46c1a2$var$streamReturningOperators = $4ZS5o.streamReturningOperators, $b829be057d46c1a2$var$promiseReturningOperators = $4ZS5o.promiseReturningOperators;

var $7tH7p = parcelRequire("7tH7p");
var $b829be057d46c1a2$var$ERR_ILLEGAL_CONSTRUCTOR = $7tH7p.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $hFbae = parcelRequire("hFbae");

var $1tIzt = parcelRequire("1tIzt");
var $b829be057d46c1a2$var$setDefaultHighWaterMark = $1tIzt.setDefaultHighWaterMark, $b829be057d46c1a2$var$getDefaultHighWaterMark = $1tIzt.getDefaultHighWaterMark;

var $g8kIa = parcelRequire("g8kIa");
var $b829be057d46c1a2$require$pipeline = $g8kIa.pipeline;

var $90Hle = parcelRequire("90Hle");
var $b829be057d46c1a2$require$destroyer = $90Hle.destroyer;

var $hbj9O = parcelRequire("hbj9O");
var $b829be057d46c1a2$var$internalBuffer = {};

var $9UwPA = parcelRequire("9UwPA");

var $4nXXr = parcelRequire("4nXXr");

var $b829be057d46c1a2$var$Stream = module.exports = (parcelRequire("aCZ5T")).Stream;
$b829be057d46c1a2$var$Stream.isDestroyed = $4nXXr.isDestroyed;
$b829be057d46c1a2$var$Stream.isDisturbed = $4nXXr.isDisturbed;
$b829be057d46c1a2$var$Stream.isErrored = $4nXXr.isErrored;
$b829be057d46c1a2$var$Stream.isReadable = $4nXXr.isReadable;
$b829be057d46c1a2$var$Stream.isWritable = $4nXXr.isWritable;

$b829be057d46c1a2$var$Stream.Readable = (parcelRequire("itzhG"));
var $b829be057d46c1a2$var$_iteratorNormalCompletion = true, $b829be057d46c1a2$var$_didIteratorError = false, $b829be057d46c1a2$var$_iteratorError = undefined;
try {
    for(var $b829be057d46c1a2$var$_iterator = $b829be057d46c1a2$var$ObjectKeys($b829be057d46c1a2$var$streamReturningOperators)[Symbol.iterator](), $b829be057d46c1a2$var$_step; !($b829be057d46c1a2$var$_iteratorNormalCompletion = ($b829be057d46c1a2$var$_step = $b829be057d46c1a2$var$_iterator.next()).done); $b829be057d46c1a2$var$_iteratorNormalCompletion = true){
        var $b829be057d46c1a2$var$key = $b829be057d46c1a2$var$_step.value;
        var $b829be057d46c1a2$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $b829be057d46c1a2$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $b829be057d46c1a2$var$Stream.Readable.from($b829be057d46c1a2$var$ReflectApply($b829be057d46c1a2$var$op, this, args));
        };
        var $b829be057d46c1a2$var$op = $b829be057d46c1a2$var$streamReturningOperators[$b829be057d46c1a2$var$key];
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$fn, 'name', {
            __proto__: null,
            value: $b829be057d46c1a2$var$op.name
        });
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$fn, 'length', {
            __proto__: null,
            value: $b829be057d46c1a2$var$op.length
        });
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$Stream.Readable.prototype, $b829be057d46c1a2$var$key, {
            __proto__: null,
            value: $b829be057d46c1a2$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $b829be057d46c1a2$var$_didIteratorError = true;
    $b829be057d46c1a2$var$_iteratorError = err;
} finally{
    try {
        if (!$b829be057d46c1a2$var$_iteratorNormalCompletion && $b829be057d46c1a2$var$_iterator["return"] != null) {
            $b829be057d46c1a2$var$_iterator["return"]();
        }
    } finally{
        if ($b829be057d46c1a2$var$_didIteratorError) {
            throw $b829be057d46c1a2$var$_iteratorError;
        }
    }
}
var $b829be057d46c1a2$var$_iteratorNormalCompletion1 = true, $b829be057d46c1a2$var$_didIteratorError1 = false, $b829be057d46c1a2$var$_iteratorError1 = undefined;
try {
    for(var $b829be057d46c1a2$var$_iterator1 = $b829be057d46c1a2$var$ObjectKeys($b829be057d46c1a2$var$promiseReturningOperators)[Symbol.iterator](), $b829be057d46c1a2$var$_step1; !($b829be057d46c1a2$var$_iteratorNormalCompletion1 = ($b829be057d46c1a2$var$_step1 = $b829be057d46c1a2$var$_iterator1.next()).done); $b829be057d46c1a2$var$_iteratorNormalCompletion1 = true){
        var $b829be057d46c1a2$var$key1 = $b829be057d46c1a2$var$_step1.value;
        var $b829be057d46c1a2$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $b829be057d46c1a2$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $b829be057d46c1a2$var$ReflectApply($b829be057d46c1a2$var$op1, this, args);
        };
        var $b829be057d46c1a2$var$op1 = $b829be057d46c1a2$var$promiseReturningOperators[$b829be057d46c1a2$var$key1];
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$fn1, 'name', {
            __proto__: null,
            value: $b829be057d46c1a2$var$op1.name
        });
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$fn1, 'length', {
            __proto__: null,
            value: $b829be057d46c1a2$var$op1.length
        });
        $b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$Stream.Readable.prototype, $b829be057d46c1a2$var$key1, {
            __proto__: null,
            value: $b829be057d46c1a2$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $b829be057d46c1a2$var$_didIteratorError1 = true;
    $b829be057d46c1a2$var$_iteratorError1 = err;
} finally{
    try {
        if (!$b829be057d46c1a2$var$_iteratorNormalCompletion1 && $b829be057d46c1a2$var$_iterator1["return"] != null) {
            $b829be057d46c1a2$var$_iterator1["return"]();
        }
    } finally{
        if ($b829be057d46c1a2$var$_didIteratorError1) {
            throw $b829be057d46c1a2$var$_iteratorError1;
        }
    }
}

$b829be057d46c1a2$var$Stream.Writable = (parcelRequire("8lwKN"));

$b829be057d46c1a2$var$Stream.Duplex = (parcelRequire("84z6T"));

$b829be057d46c1a2$var$Stream.Transform = (parcelRequire("aTRg3"));

$b829be057d46c1a2$var$Stream.PassThrough = (parcelRequire("4OxoW"));
$b829be057d46c1a2$var$Stream.pipeline = $b829be057d46c1a2$require$pipeline;

var $lTl6r = parcelRequire("lTl6r");
var $b829be057d46c1a2$require$addAbortSignal = $lTl6r.addAbortSignal;
$b829be057d46c1a2$var$Stream.addAbortSignal = $b829be057d46c1a2$require$addAbortSignal;
$b829be057d46c1a2$var$Stream.finished = $hbj9O;
$b829be057d46c1a2$var$Stream.destroy = $b829be057d46c1a2$require$destroyer;
$b829be057d46c1a2$var$Stream.compose = $hFbae;
$b829be057d46c1a2$var$Stream.setDefaultHighWaterMark = $b829be057d46c1a2$var$setDefaultHighWaterMark;
$b829be057d46c1a2$var$Stream.getDefaultHighWaterMark = $b829be057d46c1a2$var$getDefaultHighWaterMark;
$b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $9UwPA;
    }
});
$b829be057d46c1a2$var$ObjectDefineProperty($b829be057d46c1a2$require$pipeline, $b829be057d46c1a2$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9UwPA.pipeline;
    }
});
$b829be057d46c1a2$var$ObjectDefineProperty($hbj9O, $b829be057d46c1a2$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $9UwPA.finished;
    }
});
// Backwards-compat with node 0.4.x
$b829be057d46c1a2$var$Stream.Stream = $b829be057d46c1a2$var$Stream;
$b829be057d46c1a2$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$b829be057d46c1a2$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $b829be057d46c1a2$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("k4uY4", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e9cc33ec64177b19$export$a143d493d941bafc; }, function (v) { return $e9cc33ec64177b19$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e9cc33ec64177b19$export$f99ded8fe4b79145; }, function (v) { return $e9cc33ec64177b19$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $e9cc33ec64177b19$export$a143d493d941bafc;
var $e9cc33ec64177b19$export$e4cf37d7f6fb9e0a;
var $e9cc33ec64177b19$export$f99ded8fe4b79145;
var $e9cc33ec64177b19$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $e9cc33ec64177b19$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e9cc33ec64177b19$export$a143d493d941bafc = $e9cc33ec64177b19$var$Buffer;
$e9cc33ec64177b19$export$e4cf37d7f6fb9e0a = $e9cc33ec64177b19$var$SlowBuffer;
$e9cc33ec64177b19$export$f99ded8fe4b79145 = 50;
var $e9cc33ec64177b19$var$K_MAX_LENGTH = 0x7fffffff;
$e9cc33ec64177b19$export$599f31c3813fae4d = $e9cc33ec64177b19$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e9cc33ec64177b19$var$Buffer.TYPED_ARRAY_SUPPORT = $e9cc33ec64177b19$var$typedArraySupport();
if (!$e9cc33ec64177b19$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e9cc33ec64177b19$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e9cc33ec64177b19$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$e9cc33ec64177b19$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e9cc33ec64177b19$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$e9cc33ec64177b19$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e9cc33ec64177b19$var$createBuffer(length) {
    if (length > $e9cc33ec64177b19$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e9cc33ec64177b19$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e9cc33ec64177b19$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e9cc33ec64177b19$var$allocUnsafe(arg);
    }
    return $e9cc33ec64177b19$var$from(arg, encodingOrOffset, length);
}
$e9cc33ec64177b19$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e9cc33ec64177b19$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e9cc33ec64177b19$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e9cc33ec64177b19$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($e9cc33ec64177b19$var$isInstance(value, ArrayBuffer) || value && $e9cc33ec64177b19$var$isInstance(value.buffer, ArrayBuffer)) return $e9cc33ec64177b19$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e9cc33ec64177b19$var$isInstance(value, SharedArrayBuffer) || value && $e9cc33ec64177b19$var$isInstance(value.buffer, SharedArrayBuffer))) return $e9cc33ec64177b19$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e9cc33ec64177b19$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e9cc33ec64177b19$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e9cc33ec64177b19$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e9cc33ec64177b19$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e9cc33ec64177b19$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e9cc33ec64177b19$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e9cc33ec64177b19$var$Buffer, Uint8Array);
function $e9cc33ec64177b19$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e9cc33ec64177b19$var$alloc(size, fill, encoding) {
    $e9cc33ec64177b19$var$assertSize(size);
    if (size <= 0) return $e9cc33ec64177b19$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e9cc33ec64177b19$var$createBuffer(size).fill(fill, encoding) : $e9cc33ec64177b19$var$createBuffer(size).fill(fill);
    return $e9cc33ec64177b19$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e9cc33ec64177b19$var$Buffer.alloc = function(size, fill, encoding) {
    return $e9cc33ec64177b19$var$alloc(size, fill, encoding);
};
function $e9cc33ec64177b19$var$allocUnsafe(size) {
    $e9cc33ec64177b19$var$assertSize(size);
    return $e9cc33ec64177b19$var$createBuffer(size < 0 ? 0 : $e9cc33ec64177b19$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e9cc33ec64177b19$var$Buffer.allocUnsafe = function(size) {
    return $e9cc33ec64177b19$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e9cc33ec64177b19$var$Buffer.allocUnsafeSlow = function(size) {
    return $e9cc33ec64177b19$var$allocUnsafe(size);
};
function $e9cc33ec64177b19$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e9cc33ec64177b19$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $e9cc33ec64177b19$var$byteLength(string, encoding) | 0;
    var buf = $e9cc33ec64177b19$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e9cc33ec64177b19$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e9cc33ec64177b19$var$checked(array.length) | 0;
    var buf = $e9cc33ec64177b19$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e9cc33ec64177b19$var$fromArrayView(arrayView) {
    if ($e9cc33ec64177b19$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e9cc33ec64177b19$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e9cc33ec64177b19$var$fromArrayLike(arrayView);
}
function $e9cc33ec64177b19$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e9cc33ec64177b19$var$Buffer.prototype);
    return buf;
}
function $e9cc33ec64177b19$var$fromObject(obj) {
    if ($e9cc33ec64177b19$var$Buffer.isBuffer(obj)) {
        var len = $e9cc33ec64177b19$var$checked(obj.length) | 0;
        var buf = $e9cc33ec64177b19$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e9cc33ec64177b19$var$numberIsNaN(obj.length)) return $e9cc33ec64177b19$var$createBuffer(0);
        return $e9cc33ec64177b19$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e9cc33ec64177b19$var$fromArrayLike(obj.data);
}
function $e9cc33ec64177b19$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e9cc33ec64177b19$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e9cc33ec64177b19$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e9cc33ec64177b19$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e9cc33ec64177b19$var$Buffer.alloc(+length);
}
$e9cc33ec64177b19$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e9cc33ec64177b19$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e9cc33ec64177b19$var$Buffer.compare = function compare(a, b) {
    if ($e9cc33ec64177b19$var$isInstance(a, Uint8Array)) a = $e9cc33ec64177b19$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e9cc33ec64177b19$var$isInstance(b, Uint8Array)) b = $e9cc33ec64177b19$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e9cc33ec64177b19$var$Buffer.isBuffer(a) || !$e9cc33ec64177b19$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e9cc33ec64177b19$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e9cc33ec64177b19$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e9cc33ec64177b19$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e9cc33ec64177b19$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e9cc33ec64177b19$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e9cc33ec64177b19$var$Buffer.isBuffer(buf)) buf = $e9cc33ec64177b19$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e9cc33ec64177b19$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e9cc33ec64177b19$var$byteLength(string, encoding) {
    if ($e9cc33ec64177b19$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e9cc33ec64177b19$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e9cc33ec64177b19$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e9cc33ec64177b19$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e9cc33ec64177b19$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e9cc33ec64177b19$var$Buffer.byteLength = $e9cc33ec64177b19$var$byteLength;
function $e9cc33ec64177b19$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e9cc33ec64177b19$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e9cc33ec64177b19$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e9cc33ec64177b19$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e9cc33ec64177b19$var$latin1Slice(this, start, end);
        case 'base64':
            return $e9cc33ec64177b19$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e9cc33ec64177b19$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e9cc33ec64177b19$var$Buffer.prototype._isBuffer = true;
function $e9cc33ec64177b19$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e9cc33ec64177b19$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$e9cc33ec64177b19$var$swap(this, i, i + 1);
    return this;
};
$e9cc33ec64177b19$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $e9cc33ec64177b19$var$swap(this, i, i + 3);
        $e9cc33ec64177b19$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e9cc33ec64177b19$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $e9cc33ec64177b19$var$swap(this, i, i + 7);
        $e9cc33ec64177b19$var$swap(this, i + 1, i + 6);
        $e9cc33ec64177b19$var$swap(this, i + 2, i + 5);
        $e9cc33ec64177b19$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e9cc33ec64177b19$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e9cc33ec64177b19$var$utf8Slice(this, 0, length);
    return $e9cc33ec64177b19$var$slowToString.apply(this, arguments);
};
$e9cc33ec64177b19$var$Buffer.prototype.toLocaleString = $e9cc33ec64177b19$var$Buffer.prototype.toString;
$e9cc33ec64177b19$var$Buffer.prototype.equals = function equals(b) {
    if (!$e9cc33ec64177b19$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e9cc33ec64177b19$var$Buffer.compare(this, b) === 0;
};
$e9cc33ec64177b19$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $e9cc33ec64177b19$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e9cc33ec64177b19$var$customInspectSymbol) $e9cc33ec64177b19$var$Buffer.prototype[$e9cc33ec64177b19$var$customInspectSymbol] = $e9cc33ec64177b19$var$Buffer.prototype.inspect;
$e9cc33ec64177b19$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e9cc33ec64177b19$var$isInstance(target, Uint8Array)) target = $e9cc33ec64177b19$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e9cc33ec64177b19$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e9cc33ec64177b19$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e9cc33ec64177b19$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e9cc33ec64177b19$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e9cc33ec64177b19$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e9cc33ec64177b19$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e9cc33ec64177b19$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e9cc33ec64177b19$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e9cc33ec64177b19$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e9cc33ec64177b19$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e9cc33ec64177b19$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e9cc33ec64177b19$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e9cc33ec64177b19$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e9cc33ec64177b19$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e9cc33ec64177b19$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e9cc33ec64177b19$var$utf8Write(buf, string, offset, length) {
    return $e9cc33ec64177b19$var$blitBuffer($e9cc33ec64177b19$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e9cc33ec64177b19$var$asciiWrite(buf, string, offset, length) {
    return $e9cc33ec64177b19$var$blitBuffer($e9cc33ec64177b19$var$asciiToBytes(string), buf, offset, length);
}
function $e9cc33ec64177b19$var$base64Write(buf, string, offset, length) {
    return $e9cc33ec64177b19$var$blitBuffer($e9cc33ec64177b19$var$base64ToBytes(string), buf, offset, length);
}
function $e9cc33ec64177b19$var$ucs2Write(buf, string, offset, length) {
    return $e9cc33ec64177b19$var$blitBuffer($e9cc33ec64177b19$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e9cc33ec64177b19$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e9cc33ec64177b19$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e9cc33ec64177b19$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e9cc33ec64177b19$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e9cc33ec64177b19$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e9cc33ec64177b19$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e9cc33ec64177b19$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e9cc33ec64177b19$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $e9cc33ec64177b19$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e9cc33ec64177b19$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e9cc33ec64177b19$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e9cc33ec64177b19$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e9cc33ec64177b19$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e9cc33ec64177b19$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e9cc33ec64177b19$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e9cc33ec64177b19$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e9cc33ec64177b19$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $e9cc33ec64177b19$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e9cc33ec64177b19$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e9cc33ec64177b19$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e9cc33ec64177b19$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e9cc33ec64177b19$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e9cc33ec64177b19$var$Buffer.prototype.readUintLE = $e9cc33ec64177b19$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readUintBE = $e9cc33ec64177b19$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readUint8 = $e9cc33ec64177b19$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e9cc33ec64177b19$var$Buffer.prototype.readUint16LE = $e9cc33ec64177b19$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e9cc33ec64177b19$var$Buffer.prototype.readUint16BE = $e9cc33ec64177b19$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e9cc33ec64177b19$var$Buffer.prototype.readUint32LE = $e9cc33ec64177b19$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e9cc33ec64177b19$var$Buffer.prototype.readUint32BE = $e9cc33ec64177b19$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e9cc33ec64177b19$var$Buffer.prototype.readBigUInt64LE = $e9cc33ec64177b19$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e9cc33ec64177b19$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e9cc33ec64177b19$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e9cc33ec64177b19$var$Buffer.prototype.readBigUInt64BE = $e9cc33ec64177b19$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e9cc33ec64177b19$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e9cc33ec64177b19$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e9cc33ec64177b19$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e9cc33ec64177b19$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e9cc33ec64177b19$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e9cc33ec64177b19$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e9cc33ec64177b19$var$Buffer.prototype.readBigInt64LE = $e9cc33ec64177b19$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e9cc33ec64177b19$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e9cc33ec64177b19$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$e9cc33ec64177b19$var$Buffer.prototype.readBigInt64BE = $e9cc33ec64177b19$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e9cc33ec64177b19$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e9cc33ec64177b19$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$e9cc33ec64177b19$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$e9cc33ec64177b19$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$e9cc33ec64177b19$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$e9cc33ec64177b19$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $e9cc33ec64177b19$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e9cc33ec64177b19$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e9cc33ec64177b19$var$Buffer.prototype.writeUintLE = $e9cc33ec64177b19$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e9cc33ec64177b19$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUintBE = $e9cc33ec64177b19$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e9cc33ec64177b19$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUint8 = $e9cc33ec64177b19$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUint16LE = $e9cc33ec64177b19$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUint16BE = $e9cc33ec64177b19$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUint32LE = $e9cc33ec64177b19$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeUint32BE = $e9cc33ec64177b19$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e9cc33ec64177b19$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e9cc33ec64177b19$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e9cc33ec64177b19$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e9cc33ec64177b19$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e9cc33ec64177b19$var$Buffer.prototype.writeBigUInt64LE = $e9cc33ec64177b19$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e9cc33ec64177b19$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e9cc33ec64177b19$var$Buffer.prototype.writeBigUInt64BE = $e9cc33ec64177b19$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e9cc33ec64177b19$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e9cc33ec64177b19$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e9cc33ec64177b19$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e9cc33ec64177b19$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e9cc33ec64177b19$var$Buffer.prototype.writeBigInt64LE = $e9cc33ec64177b19$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e9cc33ec64177b19$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e9cc33ec64177b19$var$Buffer.prototype.writeBigInt64BE = $e9cc33ec64177b19$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e9cc33ec64177b19$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e9cc33ec64177b19$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e9cc33ec64177b19$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e9cc33ec64177b19$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e9cc33ec64177b19$var$writeFloat(this, value, offset, true, noAssert);
};
$e9cc33ec64177b19$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e9cc33ec64177b19$var$writeFloat(this, value, offset, false, noAssert);
};
function $e9cc33ec64177b19$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e9cc33ec64177b19$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e9cc33ec64177b19$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e9cc33ec64177b19$var$writeDouble(this, value, offset, true, noAssert);
};
$e9cc33ec64177b19$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e9cc33ec64177b19$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e9cc33ec64177b19$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e9cc33ec64177b19$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e9cc33ec64177b19$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e9cc33ec64177b19$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e9cc33ec64177b19$var$Buffer.isBuffer(val) ? val : $e9cc33ec64177b19$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $e9cc33ec64177b19$var$errors = {};
function $e9cc33ec64177b19$var$E(sym, getMessage, Base) {
    $e9cc33ec64177b19$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$e9cc33ec64177b19$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e9cc33ec64177b19$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$e9cc33ec64177b19$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $e9cc33ec64177b19$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $e9cc33ec64177b19$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $e9cc33ec64177b19$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $e9cc33ec64177b19$var$checkBounds(buf, offset, byteLength) {
    $e9cc33ec64177b19$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e9cc33ec64177b19$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e9cc33ec64177b19$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $e9cc33ec64177b19$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e9cc33ec64177b19$var$checkBounds(buf, offset, byteLength);
}
function $e9cc33ec64177b19$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e9cc33ec64177b19$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e9cc33ec64177b19$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e9cc33ec64177b19$var$validateNumber(value, type);
        throw new $e9cc33ec64177b19$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e9cc33ec64177b19$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e9cc33ec64177b19$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $e9cc33ec64177b19$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e9cc33ec64177b19$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e9cc33ec64177b19$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e9cc33ec64177b19$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e9cc33ec64177b19$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e9cc33ec64177b19$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e9cc33ec64177b19$var$base64ToBytes(str) {
    return $abUaD.toByteArray($e9cc33ec64177b19$var$base64clean(str));
}
function $e9cc33ec64177b19$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e9cc33ec64177b19$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e9cc33ec64177b19$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e9cc33ec64177b19$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e9cc33ec64177b19$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e9cc33ec64177b19$var$BufferBigIntNotDefined : fn;
}
function $e9cc33ec64177b19$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("2LuAg", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $2037b1e6d2cb15bd$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $2037b1e6d2cb15bd$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("bIvqM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $k4uY4 = parcelRequire("k4uY4");

var $dmmAX = parcelRequire("dmmAX");
var $887c2f4b55f9aa54$var$format = $dmmAX.format, $887c2f4b55f9aa54$var$inspect = $dmmAX.inspect;

var $7tH7p = parcelRequire("7tH7p");
var $887c2f4b55f9aa54$var$ERR_INVALID_ARG_TYPE = $7tH7p.codes.ERR_INVALID_ARG_TYPE;

var $2LuAg = parcelRequire("2LuAg");
var $887c2f4b55f9aa54$var$kResistStopPropagation = $2LuAg.kResistStopPropagation, $887c2f4b55f9aa54$var$AggregateError = $2LuAg.AggregateError, $887c2f4b55f9aa54$var$SymbolDispose = $2LuAg.SymbolDispose;

var $887c2f4b55f9aa54$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $887c2f4b55f9aa54$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $887c2f4b55f9aa54$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $887c2f4b55f9aa54$var$Blob = globalThis.Blob || $k4uY4.Blob;
/* eslint-disable indent */ var $887c2f4b55f9aa54$var$isBlob = typeof $887c2f4b55f9aa54$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $887c2f4b55f9aa54$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $887c2f4b55f9aa54$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $887c2f4b55f9aa54$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $887c2f4b55f9aa54$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $887c2f4b55f9aa54$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $887c2f4b55f9aa54$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $887c2f4b55f9aa54$var$format,
    inspect: $887c2f4b55f9aa54$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $887c2f4b55f9aa54$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $887c2f4b55f9aa54$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $887c2f4b55f9aa54$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $887c2f4b55f9aa54$var$validateAbortSignal(signal, 'signal');
        $887c2f4b55f9aa54$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $887c2f4b55f9aa54$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $887c2f4b55f9aa54$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $887c2f4b55f9aa54$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $887c2f4b55f9aa54$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $887c2f4b55f9aa54$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("dmmAX", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("7tH7p", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $dmmAX = parcelRequire("dmmAX");
var $571cb048a1e8ba69$var$format = $dmmAX.format, $571cb048a1e8ba69$var$inspect = $dmmAX.inspect;

var $2LuAg = parcelRequire("2LuAg");
var $571cb048a1e8ba69$var$CustomAggregateError = $2LuAg.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $571cb048a1e8ba69$var$AggregateError = globalThis.AggregateError || $571cb048a1e8ba69$var$CustomAggregateError;
var $571cb048a1e8ba69$var$kIsNodeError = Symbol('kIsNodeError');
var $571cb048a1e8ba69$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $571cb048a1e8ba69$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $571cb048a1e8ba69$var$nodeInternalPrefix = '__node_internal_';
var $571cb048a1e8ba69$var$codes = {};
function $571cb048a1e8ba69$var$assert(value, message) {
    if (!value) throw new $571cb048a1e8ba69$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $571cb048a1e8ba69$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $571cb048a1e8ba69$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $571cb048a1e8ba69$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $571cb048a1e8ba69$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $571cb048a1e8ba69$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $571cb048a1e8ba69$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $571cb048a1e8ba69$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$571cb048a1e8ba69$var$kIsNodeError] = true;
    $571cb048a1e8ba69$var$codes[code] = NodeError;
}
function $571cb048a1e8ba69$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $571cb048a1e8ba69$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $571cb048a1e8ba69$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $571cb048a1e8ba69$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $571cb048a1e8ba69$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $571cb048a1e8ba69$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$571cb048a1e8ba69$var$E('ERR_ASSERTION', '%s', Error);
$571cb048a1e8ba69$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $571cb048a1e8ba69$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $571cb048a1e8ba69$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($571cb048a1e8ba69$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($571cb048a1e8ba69$var$classRegExp.test(value)) instances.push(value);
            else {
                $571cb048a1e8ba69$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $571cb048a1e8ba69$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $571cb048a1e8ba69$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$571cb048a1e8ba69$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $571cb048a1e8ba69$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$571cb048a1e8ba69$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$571cb048a1e8ba69$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $571cb048a1e8ba69$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$571cb048a1e8ba69$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $571cb048a1e8ba69$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $571cb048a1e8ba69$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $571cb048a1e8ba69$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $571cb048a1e8ba69$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$571cb048a1e8ba69$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$571cb048a1e8ba69$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$571cb048a1e8ba69$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$571cb048a1e8ba69$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$571cb048a1e8ba69$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $571cb048a1e8ba69$var$AbortError,
    aggregateTwoErrors: $571cb048a1e8ba69$var$hideStackFrames($571cb048a1e8ba69$var$aggregateTwoErrors),
    hideStackFrames: $571cb048a1e8ba69$var$hideStackFrames,
    codes: $571cb048a1e8ba69$var$codes
};

});


parcelRegister("4ZS5o", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $3a36d0430a957761$export$42af8c323be37587; }, function (v) { return $3a36d0430a957761$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $3a36d0430a957761$export$f405f72c701dad87; }, function (v) { return $3a36d0430a957761$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $3a36d0430a957761$export$42af8c323be37587;
var $3a36d0430a957761$export$f405f72c701dad87;
'use strict';

var $3a36d0430a957761$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $7tH7p = parcelRequire("7tH7p");
var $3a36d0430a957761$var$_require_codes = $7tH7p.codes, $3a36d0430a957761$var$ERR_INVALID_ARG_VALUE = $3a36d0430a957761$var$_require_codes.ERR_INVALID_ARG_VALUE, $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE = $3a36d0430a957761$var$_require_codes.ERR_INVALID_ARG_TYPE, $3a36d0430a957761$var$ERR_MISSING_ARGS = $3a36d0430a957761$var$_require_codes.ERR_MISSING_ARGS, $3a36d0430a957761$var$ERR_OUT_OF_RANGE = $3a36d0430a957761$var$_require_codes.ERR_OUT_OF_RANGE, $3a36d0430a957761$var$AbortError = $7tH7p.AbortError;

var $11JLe = parcelRequire("11JLe");
var $3a36d0430a957761$var$validateAbortSignal = $11JLe.validateAbortSignal, $3a36d0430a957761$var$validateInteger = $11JLe.validateInteger, $3a36d0430a957761$var$validateObject = $11JLe.validateObject;

var $3a36d0430a957761$var$kWeakHandler = (parcelRequire("2LuAg")).Symbol('kWeak');

var $3a36d0430a957761$var$kResistStopPropagation = (parcelRequire("2LuAg")).Symbol('kResistStopPropagation');

var $hbj9O = parcelRequire("hbj9O");
var $3a36d0430a957761$require$finished = $hbj9O.finished;

var $hFbae = parcelRequire("hFbae");

var $lTl6r = parcelRequire("lTl6r");
var $3a36d0430a957761$require$addAbortSignalNoValidate = $lTl6r.addAbortSignalNoValidate;

var $4nXXr = parcelRequire("4nXXr");
var $3a36d0430a957761$var$isWritable = $4nXXr.isWritable, $3a36d0430a957761$var$isNodeStream = $4nXXr.isNodeStream;

var $3a36d0430a957761$require$deprecate = (parcelRequire("bIvqM")).deprecate;

var $3a36d0430a957761$var$ArrayPrototypePush = (parcelRequire("2LuAg")).ArrayPrototypePush, $3a36d0430a957761$var$Boolean = (parcelRequire("2LuAg")).Boolean, $3a36d0430a957761$var$MathFloor = (parcelRequire("2LuAg")).MathFloor, $3a36d0430a957761$var$Number = (parcelRequire("2LuAg")).Number, $3a36d0430a957761$var$NumberIsNaN = (parcelRequire("2LuAg")).NumberIsNaN, $3a36d0430a957761$var$Promise = (parcelRequire("2LuAg")).Promise, $3a36d0430a957761$var$PromiseReject = (parcelRequire("2LuAg")).PromiseReject, $3a36d0430a957761$var$PromiseResolve = (parcelRequire("2LuAg")).PromiseResolve, $3a36d0430a957761$var$PromisePrototypeThen = (parcelRequire("2LuAg")).PromisePrototypeThen, $3a36d0430a957761$var$Symbol = (parcelRequire("2LuAg")).Symbol;
var $3a36d0430a957761$var$kEmpty = $3a36d0430a957761$var$Symbol('kEmpty');
var $3a36d0430a957761$var$kEof = $3a36d0430a957761$var$Symbol('kEof');
function $3a36d0430a957761$var$compose(stream, options) {
    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
    if ($3a36d0430a957761$var$isNodeStream(stream) && !$3a36d0430a957761$var$isWritable(stream)) throw new $3a36d0430a957761$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $hFbae(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $3a36d0430a957761$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $3a36d0430a957761$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $3a36d0430a957761$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $3a36d0430a957761$var$MathFloor(options.highWaterMark);
    $3a36d0430a957761$var$validateInteger(concurrency, 'options.concurrency', 1);
    $3a36d0430a957761$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $3a36d0430a957761$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $3a36d0430a957761$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $3a36d0430a957761$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $3a36d0430a957761$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $3a36d0430a957761$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $3a36d0430a957761$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($3a36d0430a957761$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $3a36d0430a957761$var$PromiseReject(err1);
                                $3a36d0430a957761$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("bIvqM")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($3a36d0430a957761$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $3a36d0430a957761$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $3a36d0430a957761$var$AbortError();
                        if (!(val !== $3a36d0430a957761$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $3a36d0430a957761$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3a36d0430a957761$var$asIndexedPairs(options) {
    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $3a36d0430a957761$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3a36d0430a957761$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3a36d0430a957761$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $3a36d0430a957761$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $3a36d0430a957761$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $3a36d0430a957761$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3a36d0430a957761$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $3a36d0430a957761$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $3a36d0430a957761$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3a36d0430a957761$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $3a36d0430a957761$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $3a36d0430a957761$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $3a36d0430a957761$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $3a36d0430a957761$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($3a36d0430a957761$var$ERR_MISSING_ARGS);
function $3a36d0430a957761$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $3a36d0430a957761$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $3a36d0430a957761$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $3a36d0430a957761$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $3a36d0430a957761$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $3a36d0430a957761$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $3a36d0430a957761$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $3a36d0430a957761$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $3a36d0430a957761$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $3a36d0430a957761$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $3a36d0430a957761$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $3a36d0430a957761$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $3a36d0430a957761$var$flatMap(fn, options) {
    var values = $3a36d0430a957761$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $3a36d0430a957761$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $3a36d0430a957761$var$Number(number);
    if ($3a36d0430a957761$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $3a36d0430a957761$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $3a36d0430a957761$var$drop(number, options) {
    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
    number = $3a36d0430a957761$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $3a36d0430a957761$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $3a36d0430a957761$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3a36d0430a957761$var$take(number, options) {
    if (options != null) $3a36d0430a957761$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3a36d0430a957761$var$validateAbortSignal(options.signal, 'options.signal');
    number = $3a36d0430a957761$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $3a36d0430a957761$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $3a36d0430a957761$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$3a36d0430a957761$export$42af8c323be37587 = {
    asIndexedPairs: $3a36d0430a957761$require$deprecate($3a36d0430a957761$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $3a36d0430a957761$var$drop,
    filter: $3a36d0430a957761$var$filter,
    flatMap: $3a36d0430a957761$var$flatMap,
    map: $3a36d0430a957761$var$map,
    take: $3a36d0430a957761$var$take,
    compose: $3a36d0430a957761$var$compose
};
$3a36d0430a957761$export$f405f72c701dad87 = {
    every: $3a36d0430a957761$var$every,
    forEach: $3a36d0430a957761$var$forEach,
    reduce: $3a36d0430a957761$var$reduce,
    toArray: $3a36d0430a957761$var$toArray,
    some: $3a36d0430a957761$var$some,
    find: $3a36d0430a957761$var$find
};

});
parcelRegister("11JLe", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $0bf96190b89bfa66$var$ArrayIsArray = $2LuAg.ArrayIsArray, $0bf96190b89bfa66$var$ArrayPrototypeIncludes = $2LuAg.ArrayPrototypeIncludes, $0bf96190b89bfa66$var$ArrayPrototypeJoin = $2LuAg.ArrayPrototypeJoin, $0bf96190b89bfa66$var$ArrayPrototypeMap = $2LuAg.ArrayPrototypeMap, $0bf96190b89bfa66$var$NumberIsInteger = $2LuAg.NumberIsInteger, $0bf96190b89bfa66$var$NumberIsNaN = $2LuAg.NumberIsNaN, $0bf96190b89bfa66$var$NumberMAX_SAFE_INTEGER = $2LuAg.NumberMAX_SAFE_INTEGER, $0bf96190b89bfa66$var$NumberMIN_SAFE_INTEGER = $2LuAg.NumberMIN_SAFE_INTEGER, $0bf96190b89bfa66$var$NumberParseInt = $2LuAg.NumberParseInt, $0bf96190b89bfa66$var$ObjectPrototypeHasOwnProperty = $2LuAg.ObjectPrototypeHasOwnProperty, $0bf96190b89bfa66$var$RegExpPrototypeExec = $2LuAg.RegExpPrototypeExec, $0bf96190b89bfa66$var$String = $2LuAg.String, $0bf96190b89bfa66$var$StringPrototypeToUpperCase = $2LuAg.StringPrototypeToUpperCase, $0bf96190b89bfa66$var$StringPrototypeTrim = $2LuAg.StringPrototypeTrim;

var $7tH7p = parcelRequire("7tH7p");
var $0bf96190b89bfa66$var$hideStackFrames = $7tH7p.hideStackFrames, $0bf96190b89bfa66$var$_require_codes = $7tH7p.codes, $0bf96190b89bfa66$var$ERR_SOCKET_BAD_PORT = $0bf96190b89bfa66$var$_require_codes.ERR_SOCKET_BAD_PORT, $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE = $0bf96190b89bfa66$var$_require_codes.ERR_INVALID_ARG_TYPE, $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE = $0bf96190b89bfa66$var$_require_codes.ERR_INVALID_ARG_VALUE, $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE = $0bf96190b89bfa66$var$_require_codes.ERR_OUT_OF_RANGE, $0bf96190b89bfa66$var$ERR_UNKNOWN_SIGNAL = $0bf96190b89bfa66$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $bIvqM = parcelRequire("bIvqM");
var $0bf96190b89bfa66$require$normalizeEncoding = $bIvqM.normalizeEncoding;

var $bIvqM = parcelRequire("bIvqM");
var $0bf96190b89bfa66$require$_require_types = $bIvqM.types;
var $0bf96190b89bfa66$var$isAsyncFunction = $0bf96190b89bfa66$require$_require_types.isAsyncFunction, $0bf96190b89bfa66$var$isArrayBufferView = $0bf96190b89bfa66$require$_require_types.isArrayBufferView;
var $0bf96190b89bfa66$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0bf96190b89bfa66$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0bf96190b89bfa66$var$isUint32(value) {
    return value === value >>> 0;
}
var $0bf96190b89bfa66$var$octalReg = /^[0-7]+$/;
var $0bf96190b89bfa66$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $0bf96190b89bfa66$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($0bf96190b89bfa66$var$RegExpPrototypeExec($0bf96190b89bfa66$var$octalReg, value) === null) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE(name, value, $0bf96190b89bfa66$var$modeDesc);
        value = $0bf96190b89bfa66$var$NumberParseInt(value, 8);
    }
    $0bf96190b89bfa66$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $0bf96190b89bfa66$var$validateInteger = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $0bf96190b89bfa66$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $0bf96190b89bfa66$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0bf96190b89bfa66$var$NumberIsInteger(value)) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $0bf96190b89bfa66$var$validateInt32 = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0bf96190b89bfa66$var$NumberIsInteger(value)) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $0bf96190b89bfa66$var$validateUint32 = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0bf96190b89bfa66$var$NumberIsInteger(value)) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $0bf96190b89bfa66$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $0bf96190b89bfa66$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $0bf96190b89bfa66$var$NumberIsNaN(value)) throw new $0bf96190b89bfa66$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $0bf96190b89bfa66$var$validateOneOf = $0bf96190b89bfa66$var$hideStackFrames(function(value, name, oneOf) {
    if (!$0bf96190b89bfa66$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $0bf96190b89bfa66$var$ArrayPrototypeJoin($0bf96190b89bfa66$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $0bf96190b89bfa66$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $0bf96190b89bfa66$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $0bf96190b89bfa66$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$0bf96190b89bfa66$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $0bf96190b89bfa66$var$validateObject = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $0bf96190b89bfa66$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $0bf96190b89bfa66$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $0bf96190b89bfa66$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $0bf96190b89bfa66$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $0bf96190b89bfa66$var$validateDictionary = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $0bf96190b89bfa66$var$validateArray = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$0bf96190b89bfa66$var$ArrayIsArray(value)) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $0bf96190b89bfa66$var$validateStringArray(value, name) {
    $0bf96190b89bfa66$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$0bf96190b89bfa66$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $0bf96190b89bfa66$var$validateBooleanArray(value, name) {
    $0bf96190b89bfa66$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$0bf96190b89bfa66$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $0bf96190b89bfa66$var$validateAbortSignalArray(value, name) {
    $0bf96190b89bfa66$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $0bf96190b89bfa66$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $0bf96190b89bfa66$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $0bf96190b89bfa66$var$validateString(signal, name);
    if ($0bf96190b89bfa66$var$signals[signal] === undefined) {
        if ($0bf96190b89bfa66$var$signals[$0bf96190b89bfa66$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $0bf96190b89bfa66$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $0bf96190b89bfa66$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $0bf96190b89bfa66$var$validateBuffer = $0bf96190b89bfa66$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$0bf96190b89bfa66$var$isArrayBufferView(buffer)) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $0bf96190b89bfa66$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $0bf96190b89bfa66$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $0bf96190b89bfa66$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $0bf96190b89bfa66$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $0bf96190b89bfa66$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $0bf96190b89bfa66$var$validateAbortSignal = $0bf96190b89bfa66$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $0bf96190b89bfa66$var$validateFunction = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $0bf96190b89bfa66$var$validatePlainFunction = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $0bf96190b89bfa66$var$isAsyncFunction(value)) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $0bf96190b89bfa66$var$validateUndefined = $0bf96190b89bfa66$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $0bf96190b89bfa66$var$validateUnion(value, name, union) {
    if (!$0bf96190b89bfa66$var$ArrayPrototypeIncludes(union, value)) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_TYPE(name, "('".concat($0bf96190b89bfa66$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $0bf96190b89bfa66$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $0bf96190b89bfa66$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$0bf96190b89bfa66$var$RegExpPrototypeExec($0bf96190b89bfa66$var$linkValueRegExp, value)) throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $0bf96190b89bfa66$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $0bf96190b89bfa66$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($0bf96190b89bfa66$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $0bf96190b89bfa66$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $0bf96190b89bfa66$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $0bf96190b89bfa66$var$isInt32,
    isUint32: $0bf96190b89bfa66$var$isUint32,
    parseFileMode: $0bf96190b89bfa66$var$parseFileMode,
    validateArray: $0bf96190b89bfa66$var$validateArray,
    validateStringArray: $0bf96190b89bfa66$var$validateStringArray,
    validateBooleanArray: $0bf96190b89bfa66$var$validateBooleanArray,
    validateAbortSignalArray: $0bf96190b89bfa66$var$validateAbortSignalArray,
    validateBoolean: $0bf96190b89bfa66$var$validateBoolean,
    validateBuffer: $0bf96190b89bfa66$var$validateBuffer,
    validateDictionary: $0bf96190b89bfa66$var$validateDictionary,
    validateEncoding: $0bf96190b89bfa66$var$validateEncoding,
    validateFunction: $0bf96190b89bfa66$var$validateFunction,
    validateInt32: $0bf96190b89bfa66$var$validateInt32,
    validateInteger: $0bf96190b89bfa66$var$validateInteger,
    validateNumber: $0bf96190b89bfa66$var$validateNumber,
    validateObject: $0bf96190b89bfa66$var$validateObject,
    validateOneOf: $0bf96190b89bfa66$var$validateOneOf,
    validatePlainFunction: $0bf96190b89bfa66$var$validatePlainFunction,
    validatePort: $0bf96190b89bfa66$var$validatePort,
    validateSignalName: $0bf96190b89bfa66$var$validateSignalName,
    validateString: $0bf96190b89bfa66$var$validateString,
    validateUint32: $0bf96190b89bfa66$var$validateUint32,
    validateUndefined: $0bf96190b89bfa66$var$validateUndefined,
    validateUnion: $0bf96190b89bfa66$var$validateUnion,
    validateAbortSignal: $0bf96190b89bfa66$var$validateAbortSignal,
    validateLinkHeaderValue: $0bf96190b89bfa66$var$validateLinkHeaderValue
};

});

parcelRegister("hbj9O", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $7tH7p = parcelRequire("7tH7p");
/* replacement end */ var $c82252fd3f1b3c22$var$AbortError = $7tH7p.AbortError, $c82252fd3f1b3c22$var$codes = $7tH7p.codes;
var $c82252fd3f1b3c22$var$ERR_INVALID_ARG_TYPE = $c82252fd3f1b3c22$var$codes.ERR_INVALID_ARG_TYPE, $c82252fd3f1b3c22$var$ERR_STREAM_PREMATURE_CLOSE = $c82252fd3f1b3c22$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $c82252fd3f1b3c22$var$kEmptyObject = (parcelRequire("bIvqM")).kEmptyObject, $c82252fd3f1b3c22$var$once = (parcelRequire("bIvqM")).once;

var $11JLe = parcelRequire("11JLe");
var $c82252fd3f1b3c22$var$validateAbortSignal = $11JLe.validateAbortSignal, $c82252fd3f1b3c22$var$validateFunction = $11JLe.validateFunction, $c82252fd3f1b3c22$var$validateObject = $11JLe.validateObject, $c82252fd3f1b3c22$var$validateBoolean = $11JLe.validateBoolean;

var $2LuAg = parcelRequire("2LuAg");
var $c82252fd3f1b3c22$var$Promise = $2LuAg.Promise, $c82252fd3f1b3c22$var$PromisePrototypeThen = $2LuAg.PromisePrototypeThen, $c82252fd3f1b3c22$var$SymbolDispose = $2LuAg.SymbolDispose;

var $4nXXr = parcelRequire("4nXXr");
var $c82252fd3f1b3c22$var$isClosed = $4nXXr.isClosed, $c82252fd3f1b3c22$var$isReadable = $4nXXr.isReadable, $c82252fd3f1b3c22$var$isReadableNodeStream = $4nXXr.isReadableNodeStream, $c82252fd3f1b3c22$var$isReadableStream = $4nXXr.isReadableStream, $c82252fd3f1b3c22$var$isReadableFinished = $4nXXr.isReadableFinished, $c82252fd3f1b3c22$var$isReadableErrored = $4nXXr.isReadableErrored, $c82252fd3f1b3c22$var$isWritable = $4nXXr.isWritable, $c82252fd3f1b3c22$var$isWritableNodeStream = $4nXXr.isWritableNodeStream, $c82252fd3f1b3c22$var$isWritableStream = $4nXXr.isWritableStream, $c82252fd3f1b3c22$var$isWritableFinished = $4nXXr.isWritableFinished, $c82252fd3f1b3c22$var$isWritableErrored = $4nXXr.isWritableErrored, $c82252fd3f1b3c22$var$isNodeStream = $4nXXr.isNodeStream, $c82252fd3f1b3c22$var$_willEmitClose = $4nXXr.willEmitClose, $c82252fd3f1b3c22$var$kIsClosedPromise = $4nXXr.kIsClosedPromise;
var $c82252fd3f1b3c22$var$addAbortListener;
function $c82252fd3f1b3c22$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $c82252fd3f1b3c22$var$nop = function() {};

function $c82252fd3f1b3c22$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $c82252fd3f1b3c22$var$kEmptyObject;
    } else if (options == null) options = $c82252fd3f1b3c22$var$kEmptyObject;
    else $c82252fd3f1b3c22$var$validateObject(options, 'options');
    $c82252fd3f1b3c22$var$validateFunction(callback, 'callback');
    $c82252fd3f1b3c22$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $c82252fd3f1b3c22$var$once(callback);
    if ($c82252fd3f1b3c22$var$isReadableStream(stream) || $c82252fd3f1b3c22$var$isWritableStream(stream)) return $c82252fd3f1b3c22$var$eosWeb(stream, options, callback);
    if (!$c82252fd3f1b3c22$var$isNodeStream(stream)) throw new $c82252fd3f1b3c22$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $c82252fd3f1b3c22$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $c82252fd3f1b3c22$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $c82252fd3f1b3c22$var$_willEmitClose(stream) && $c82252fd3f1b3c22$var$isReadableNodeStream(stream) === readable && $c82252fd3f1b3c22$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $c82252fd3f1b3c22$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $c82252fd3f1b3c22$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $c82252fd3f1b3c22$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $c82252fd3f1b3c22$var$isWritableErrored(stream) || $c82252fd3f1b3c22$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $c82252fd3f1b3c22$var$isReadableNodeStream(stream, true)) {
            if (!$c82252fd3f1b3c22$var$isReadableFinished(stream, false)) return callback.call(stream, new $c82252fd3f1b3c22$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$c82252fd3f1b3c22$var$isWritableFinished(stream, false)) return callback.call(stream, new $c82252fd3f1b3c22$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $c82252fd3f1b3c22$var$isWritableErrored(stream) || $c82252fd3f1b3c22$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($c82252fd3f1b3c22$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $c82252fd3f1b3c22$var$isReadable(stream)) && (writableFinished || $c82252fd3f1b3c22$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $c82252fd3f1b3c22$var$isWritable(stream)) && (readableFinished || $c82252fd3f1b3c22$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $c82252fd3f1b3c22$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $c82252fd3f1b3c22$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $c82252fd3f1b3c22$var$addAbortListener = $c82252fd3f1b3c22$var$addAbortListener || (parcelRequire("bIvqM")).addAbortListener;
            var disposable = $c82252fd3f1b3c22$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $c82252fd3f1b3c22$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$c82252fd3f1b3c22$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $c82252fd3f1b3c22$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $c82252fd3f1b3c22$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $c82252fd3f1b3c22$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $c82252fd3f1b3c22$var$addAbortListener = $c82252fd3f1b3c22$var$addAbortListener || (parcelRequire("bIvqM")).addAbortListener;
            var disposable = $c82252fd3f1b3c22$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $c82252fd3f1b3c22$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$c82252fd3f1b3c22$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $c82252fd3f1b3c22$var$PromisePrototypeThen(stream[$c82252fd3f1b3c22$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $c82252fd3f1b3c22$var$nop;
}
function $c82252fd3f1b3c22$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $c82252fd3f1b3c22$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $c82252fd3f1b3c22$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $c82252fd3f1b3c22$var$Promise(function(resolve, reject) {
        var cleanup = $c82252fd3f1b3c22$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $c82252fd3f1b3c22$var$eos;
module.exports.finished = $c82252fd3f1b3c22$var$finished;

});
parcelRegister("4nXXr", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $3317d1c82fbbdbe9$var$SymbolAsyncIterator = $2LuAg.SymbolAsyncIterator, $3317d1c82fbbdbe9$var$SymbolIterator = $2LuAg.SymbolIterator, $3317d1c82fbbdbe9$var$SymbolFor = $2LuAg.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $3317d1c82fbbdbe9$var$kIsDestroyed = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.stream.destroyed');
var $3317d1c82fbbdbe9$var$kIsErrored = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.stream.errored');
var $3317d1c82fbbdbe9$var$kIsReadable = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.stream.readable');
var $3317d1c82fbbdbe9$var$kIsWritable = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.stream.writable');
var $3317d1c82fbbdbe9$var$kIsDisturbed = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.stream.disturbed');
var $3317d1c82fbbdbe9$var$kIsClosedPromise = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $3317d1c82fbbdbe9$var$kControllerErrorFunction = $3317d1c82fbbdbe9$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $3317d1c82fbbdbe9$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $3317d1c82fbbdbe9$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $3317d1c82fbbdbe9$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $3317d1c82fbbdbe9$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $3317d1c82fbbdbe9$var$isReadableStream(obj) {
    return !!(obj && !$3317d1c82fbbdbe9$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $3317d1c82fbbdbe9$var$isWritableStream(obj) {
    return !!(obj && !$3317d1c82fbbdbe9$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $3317d1c82fbbdbe9$var$isTransformStream(obj) {
    return !!(obj && !$3317d1c82fbbdbe9$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $3317d1c82fbbdbe9$var$isWebStream(obj) {
    return $3317d1c82fbbdbe9$var$isReadableStream(obj) || $3317d1c82fbbdbe9$var$isWritableStream(obj) || $3317d1c82fbbdbe9$var$isTransformStream(obj);
}
function $3317d1c82fbbdbe9$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$3317d1c82fbbdbe9$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$3317d1c82fbbdbe9$var$SymbolIterator] === 'function';
    return typeof obj[$3317d1c82fbbdbe9$var$SymbolAsyncIterator] === 'function' || typeof obj[$3317d1c82fbbdbe9$var$SymbolIterator] === 'function';
}
function $3317d1c82fbbdbe9$var$isDestroyed(stream) {
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$3317d1c82fbbdbe9$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $3317d1c82fbbdbe9$var$isWritableEnded(stream) {
    if (!$3317d1c82fbbdbe9$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $3317d1c82fbbdbe9$var$isWritableFinished(stream, strict) {
    if (!$3317d1c82fbbdbe9$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $3317d1c82fbbdbe9$var$isReadableEnded(stream) {
    if (!$3317d1c82fbbdbe9$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $3317d1c82fbbdbe9$var$isReadableFinished(stream, strict) {
    if (!$3317d1c82fbbdbe9$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $3317d1c82fbbdbe9$var$isReadable(stream) {
    if (stream && stream[$3317d1c82fbbdbe9$var$kIsReadable] != null) return stream[$3317d1c82fbbdbe9$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($3317d1c82fbbdbe9$var$isDestroyed(stream)) return false;
    return $3317d1c82fbbdbe9$var$isReadableNodeStream(stream) && stream.readable && !$3317d1c82fbbdbe9$var$isReadableFinished(stream);
}
function $3317d1c82fbbdbe9$var$isWritable(stream) {
    if (stream && stream[$3317d1c82fbbdbe9$var$kIsWritable] != null) return stream[$3317d1c82fbbdbe9$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($3317d1c82fbbdbe9$var$isDestroyed(stream)) return false;
    return $3317d1c82fbbdbe9$var$isWritableNodeStream(stream) && stream.writable && !$3317d1c82fbbdbe9$var$isWritableEnded(stream);
}
function $3317d1c82fbbdbe9$var$isFinished(stream, opts) {
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    if ($3317d1c82fbbdbe9$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $3317d1c82fbbdbe9$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $3317d1c82fbbdbe9$var$isWritable(stream)) return false;
    return true;
}
function $3317d1c82fbbdbe9$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $3317d1c82fbbdbe9$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $3317d1c82fbbdbe9$var$isClosed(stream) {
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $3317d1c82fbbdbe9$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $3317d1c82fbbdbe9$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $3317d1c82fbbdbe9$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $3317d1c82fbbdbe9$var$isOutgoingMessage(stream);
}
function $3317d1c82fbbdbe9$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $3317d1c82fbbdbe9$var$willEmitClose(stream) {
    if (!$3317d1c82fbbdbe9$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $3317d1c82fbbdbe9$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $3317d1c82fbbdbe9$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$3317d1c82fbbdbe9$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $3317d1c82fbbdbe9$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$3317d1c82fbbdbe9$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $3317d1c82fbbdbe9$var$isDestroyed,
    kIsDestroyed: $3317d1c82fbbdbe9$var$kIsDestroyed,
    isDisturbed: $3317d1c82fbbdbe9$var$isDisturbed,
    kIsDisturbed: $3317d1c82fbbdbe9$var$kIsDisturbed,
    isErrored: $3317d1c82fbbdbe9$var$isErrored,
    kIsErrored: $3317d1c82fbbdbe9$var$kIsErrored,
    isReadable: $3317d1c82fbbdbe9$var$isReadable,
    kIsReadable: $3317d1c82fbbdbe9$var$kIsReadable,
    kIsClosedPromise: $3317d1c82fbbdbe9$var$kIsClosedPromise,
    kControllerErrorFunction: $3317d1c82fbbdbe9$var$kControllerErrorFunction,
    kIsWritable: $3317d1c82fbbdbe9$var$kIsWritable,
    isClosed: $3317d1c82fbbdbe9$var$isClosed,
    isDuplexNodeStream: $3317d1c82fbbdbe9$var$isDuplexNodeStream,
    isFinished: $3317d1c82fbbdbe9$var$isFinished,
    isIterable: $3317d1c82fbbdbe9$var$isIterable,
    isReadableNodeStream: $3317d1c82fbbdbe9$var$isReadableNodeStream,
    isReadableStream: $3317d1c82fbbdbe9$var$isReadableStream,
    isReadableEnded: $3317d1c82fbbdbe9$var$isReadableEnded,
    isReadableFinished: $3317d1c82fbbdbe9$var$isReadableFinished,
    isReadableErrored: $3317d1c82fbbdbe9$var$isReadableErrored,
    isNodeStream: $3317d1c82fbbdbe9$var$isNodeStream,
    isWebStream: $3317d1c82fbbdbe9$var$isWebStream,
    isWritable: $3317d1c82fbbdbe9$var$isWritable,
    isWritableNodeStream: $3317d1c82fbbdbe9$var$isWritableNodeStream,
    isWritableStream: $3317d1c82fbbdbe9$var$isWritableStream,
    isWritableEnded: $3317d1c82fbbdbe9$var$isWritableEnded,
    isWritableFinished: $3317d1c82fbbdbe9$var$isWritableFinished,
    isWritableErrored: $3317d1c82fbbdbe9$var$isWritableErrored,
    isServerRequest: $3317d1c82fbbdbe9$var$isServerRequest,
    isServerResponse: $3317d1c82fbbdbe9$var$isServerResponse,
    willEmitClose: $3317d1c82fbbdbe9$var$willEmitClose,
    isTransformStream: $3317d1c82fbbdbe9$var$isTransformStream
};

});


parcelRegister("hFbae", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $g8kIa = parcelRequire("g8kIa");
var $cdbeecf204ca553a$require$pipeline = $g8kIa.pipeline;

var $84z6T = parcelRequire("84z6T");

var $90Hle = parcelRequire("90Hle");
var $cdbeecf204ca553a$require$destroyer = $90Hle.destroyer;

var $4nXXr = parcelRequire("4nXXr");
var $cdbeecf204ca553a$var$isNodeStream = $4nXXr.isNodeStream, $cdbeecf204ca553a$var$isReadable = $4nXXr.isReadable, $cdbeecf204ca553a$var$isWritable = $4nXXr.isWritable, $cdbeecf204ca553a$var$isWebStream = $4nXXr.isWebStream, $cdbeecf204ca553a$var$isTransformStream = $4nXXr.isTransformStream, $cdbeecf204ca553a$var$isWritableStream = $4nXXr.isWritableStream, $cdbeecf204ca553a$var$isReadableStream = $4nXXr.isReadableStream;

var $7tH7p = parcelRequire("7tH7p");
var $cdbeecf204ca553a$var$AbortError = $7tH7p.AbortError, $cdbeecf204ca553a$var$_require_codes = $7tH7p.codes, $cdbeecf204ca553a$var$ERR_INVALID_ARG_VALUE = $cdbeecf204ca553a$var$_require_codes.ERR_INVALID_ARG_VALUE, $cdbeecf204ca553a$var$ERR_MISSING_ARGS = $cdbeecf204ca553a$var$_require_codes.ERR_MISSING_ARGS;

var $hbj9O = parcelRequire("hbj9O");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $cdbeecf204ca553a$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $84z6T.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $84z6T.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $84z6T.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$cdbeecf204ca553a$var$isNodeStream(streams[n]) && !$cdbeecf204ca553a$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($cdbeecf204ca553a$var$isReadable(streams[n]) || $cdbeecf204ca553a$var$isReadableStream(streams[n]) || $cdbeecf204ca553a$var$isTransformStream(streams[n]))) throw new $cdbeecf204ca553a$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($cdbeecf204ca553a$var$isWritable(streams[n]) || $cdbeecf204ca553a$var$isWritableStream(streams[n]) || $cdbeecf204ca553a$var$isTransformStream(streams[n]))) throw new $cdbeecf204ca553a$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $cdbeecf204ca553a$require$pipeline(streams, onfinished);
    var writable = !!($cdbeecf204ca553a$var$isWritable(head) || $cdbeecf204ca553a$var$isWritableStream(head) || $cdbeecf204ca553a$var$isTransformStream(head));
    var readable = !!($cdbeecf204ca553a$var$isReadable(tail) || $cdbeecf204ca553a$var$isReadableStream(tail) || $cdbeecf204ca553a$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $84z6T({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($cdbeecf204ca553a$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($cdbeecf204ca553a$var$isWebStream(head)) {
            var writable1 = $cdbeecf204ca553a$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $cdbeecf204ca553a$var$isTransformStream(tail) ? tail.readable : tail;
        $hbj9O(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($cdbeecf204ca553a$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($cdbeecf204ca553a$var$isWebStream(tail)) {
            var readable1 = $cdbeecf204ca553a$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $cdbeecf204ca553a$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($cdbeecf204ca553a$var$isNodeStream(tail)) $cdbeecf204ca553a$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("g8kIa", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $0307f58232f371e2$var$ArrayIsArray = $2LuAg.ArrayIsArray, $0307f58232f371e2$var$Promise = $2LuAg.Promise, $0307f58232f371e2$var$SymbolAsyncIterator = $2LuAg.SymbolAsyncIterator, $0307f58232f371e2$var$SymbolDispose = $2LuAg.SymbolDispose;

var $hbj9O = parcelRequire("hbj9O");

var $0307f58232f371e2$require$once = (parcelRequire("bIvqM")).once;

var $90Hle = parcelRequire("90Hle");

var $84z6T = parcelRequire("84z6T");

var $7tH7p = parcelRequire("7tH7p");
var $0307f58232f371e2$var$aggregateTwoErrors = $7tH7p.aggregateTwoErrors, $0307f58232f371e2$var$_require_codes = $7tH7p.codes, $0307f58232f371e2$var$ERR_INVALID_ARG_TYPE = $0307f58232f371e2$var$_require_codes.ERR_INVALID_ARG_TYPE, $0307f58232f371e2$var$ERR_INVALID_RETURN_VALUE = $0307f58232f371e2$var$_require_codes.ERR_INVALID_RETURN_VALUE, $0307f58232f371e2$var$ERR_MISSING_ARGS = $0307f58232f371e2$var$_require_codes.ERR_MISSING_ARGS, $0307f58232f371e2$var$ERR_STREAM_DESTROYED = $0307f58232f371e2$var$_require_codes.ERR_STREAM_DESTROYED, $0307f58232f371e2$var$ERR_STREAM_PREMATURE_CLOSE = $0307f58232f371e2$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $0307f58232f371e2$var$AbortError = $7tH7p.AbortError;

var $11JLe = parcelRequire("11JLe");
var $0307f58232f371e2$var$validateFunction = $11JLe.validateFunction, $0307f58232f371e2$var$validateAbortSignal = $11JLe.validateAbortSignal;

var $4nXXr = parcelRequire("4nXXr");
var $0307f58232f371e2$var$isIterable = $4nXXr.isIterable, $0307f58232f371e2$var$isReadable = $4nXXr.isReadable, $0307f58232f371e2$var$isReadableNodeStream = $4nXXr.isReadableNodeStream, $0307f58232f371e2$var$isNodeStream = $4nXXr.isNodeStream, $0307f58232f371e2$var$isTransformStream = $4nXXr.isTransformStream, $0307f58232f371e2$var$isWebStream = $4nXXr.isWebStream, $0307f58232f371e2$var$isReadableStream = $4nXXr.isReadableStream, $0307f58232f371e2$var$isReadableFinished = $4nXXr.isReadableFinished;

var $0307f58232f371e2$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $0307f58232f371e2$var$PassThrough;
var $0307f58232f371e2$var$Readable;
var $0307f58232f371e2$var$addAbortListener;
function $0307f58232f371e2$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $hbj9O(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $90Hle.destroyer(stream, err || new $0307f58232f371e2$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $0307f58232f371e2$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $0307f58232f371e2$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $0307f58232f371e2$var$makeAsyncIterable(val) {
    if ($0307f58232f371e2$var$isIterable(val)) return val;
    else if ($0307f58232f371e2$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $0307f58232f371e2$var$fromReadable(val);
    throw new $0307f58232f371e2$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $0307f58232f371e2$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$0307f58232f371e2$var$Readable) $0307f58232f371e2$var$Readable = (parcelRequire("itzhG"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($0307f58232f371e2$var$Readable.prototype[$0307f58232f371e2$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0307f58232f371e2$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $0307f58232f371e2$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $hbj9O(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $0307f58232f371e2$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0307f58232f371e2$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($0307f58232f371e2$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0307f58232f371e2$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $0307f58232f371e2$var$pipelineImpl(streams, $0307f58232f371e2$require$once($0307f58232f371e2$var$popCallback(streams)));
}


function $0307f58232f371e2$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($0307f58232f371e2$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $0307f58232f371e2$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($0307f58232f371e2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($0307f58232f371e2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$0307f58232f371e2$var$isIterable(ret)) throw new $0307f58232f371e2$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($0307f58232f371e2$var$isIterable(stream) || $0307f58232f371e2$var$isReadableNodeStream(stream) || $0307f58232f371e2$var$isTransformStream(stream)) ret = stream;
            else ret = $84z6T.from(stream);
        } else if (typeof stream === 'function') {
            if ($0307f58232f371e2$var$isTransformStream(ret)) {
                var _ret;
                ret = $0307f58232f371e2$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $0307f58232f371e2$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$0307f58232f371e2$var$isIterable(ret, true)) throw new $0307f58232f371e2$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$0307f58232f371e2$var$PassThrough) $0307f58232f371e2$var$PassThrough = (parcelRequire("4OxoW"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $0307f58232f371e2$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($0307f58232f371e2$var$isIterable(ret, true)) {
                    finishCount++;
                    $0307f58232f371e2$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($0307f58232f371e2$var$isReadableStream(ret) || $0307f58232f371e2$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $0307f58232f371e2$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $0307f58232f371e2$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $0307f58232f371e2$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($0307f58232f371e2$var$isNodeStream(stream)) {
            if ($0307f58232f371e2$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $0307f58232f371e2$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($0307f58232f371e2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($0307f58232f371e2$var$isTransformStream(ret) || $0307f58232f371e2$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $0307f58232f371e2$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($0307f58232f371e2$var$isIterable(ret)) {
                finishCount++;
                $0307f58232f371e2$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $0307f58232f371e2$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($0307f58232f371e2$var$isWebStream(stream)) {
            if ($0307f58232f371e2$var$isReadableNodeStream(ret)) {
                finishCount++;
                $0307f58232f371e2$var$pumpToWeb($0307f58232f371e2$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($0307f58232f371e2$var$isReadableStream(ret) || $0307f58232f371e2$var$isIterable(ret)) {
                finishCount++;
                $0307f58232f371e2$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($0307f58232f371e2$var$isTransformStream(ret)) {
                finishCount++;
                $0307f58232f371e2$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $0307f58232f371e2$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $84z6T.from(stream);
    };
    if (streams.length === 1 && $0307f58232f371e2$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $0307f58232f371e2$var$ERR_MISSING_ARGS('streams');
    var ac = new $0307f58232f371e2$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $0307f58232f371e2$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $0307f58232f371e2$var$AbortError());
    }
    $0307f58232f371e2$var$addAbortListener = $0307f58232f371e2$var$addAbortListener || (parcelRequire("bIvqM")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $0307f58232f371e2$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$0307f58232f371e2$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $0307f58232f371e2$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $0307f58232f371e2$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($0307f58232f371e2$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $hbj9O(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $hbj9O(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $0307f58232f371e2$var$pipelineImpl,
    pipeline: $0307f58232f371e2$var$pipeline
};

});
parcelRegister("90Hle", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $7tH7p = parcelRequire("7tH7p");
/* replacement end */ var $68f5bbd3bbcd3b1e$var$aggregateTwoErrors = $7tH7p.aggregateTwoErrors, $68f5bbd3bbcd3b1e$var$ERR_MULTIPLE_CALLBACK = $7tH7p.codes.ERR_MULTIPLE_CALLBACK, $68f5bbd3bbcd3b1e$var$AbortError = $7tH7p.AbortError;

var $2LuAg = parcelRequire("2LuAg");
var $68f5bbd3bbcd3b1e$require$Symbol = $2LuAg.Symbol;

var $4nXXr = parcelRequire("4nXXr");
var $68f5bbd3bbcd3b1e$var$kIsDestroyed = $4nXXr.kIsDestroyed, $68f5bbd3bbcd3b1e$var$isDestroyed = $4nXXr.isDestroyed, $68f5bbd3bbcd3b1e$var$isFinished = $4nXXr.isFinished, $68f5bbd3bbcd3b1e$var$isServerRequest = $4nXXr.isServerRequest;
var $68f5bbd3bbcd3b1e$var$kDestroy = $68f5bbd3bbcd3b1e$require$Symbol('kDestroy');
var $68f5bbd3bbcd3b1e$var$kConstruct = $68f5bbd3bbcd3b1e$require$Symbol('kConstruct');
function $68f5bbd3bbcd3b1e$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $68f5bbd3bbcd3b1e$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $68f5bbd3bbcd3b1e$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($68f5bbd3bbcd3b1e$var$kDestroy, function(er) {
        $68f5bbd3bbcd3b1e$var$_destroy(this, $68f5bbd3bbcd3b1e$var$aggregateTwoErrors(er, err), cb);
    });
    else $68f5bbd3bbcd3b1e$var$_destroy(this, err, cb);
    return this;
}
function $68f5bbd3bbcd3b1e$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $68f5bbd3bbcd3b1e$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $68f5bbd3bbcd3b1e$var$emitErrorCloseNT(self, err) {
    $68f5bbd3bbcd3b1e$var$emitErrorNT(self, err);
    $68f5bbd3bbcd3b1e$var$emitCloseNT(self);
}
function $68f5bbd3bbcd3b1e$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $68f5bbd3bbcd3b1e$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $68f5bbd3bbcd3b1e$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $68f5bbd3bbcd3b1e$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitErrorNT, stream, err);
        else $68f5bbd3bbcd3b1e$var$emitErrorNT(stream, err);
    }
}
function $68f5bbd3bbcd3b1e$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($68f5bbd3bbcd3b1e$var$kConstruct, cb);
    if (stream.listenerCount($68f5bbd3bbcd3b1e$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$constructNT, stream);
}
function $68f5bbd3bbcd3b1e$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $68f5bbd3bbcd3b1e$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $68f5bbd3bbcd3b1e$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($68f5bbd3bbcd3b1e$var$kDestroy, err);
        else if (err) $68f5bbd3bbcd3b1e$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $68f5bbd3bbcd3b1e$var$emitConstructNT(stream) {
    stream.emit($68f5bbd3bbcd3b1e$var$kConstruct);
}
function $68f5bbd3bbcd3b1e$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $68f5bbd3bbcd3b1e$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $68f5bbd3bbcd3b1e$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $68f5bbd3bbcd3b1e$var$destroyer(stream, err) {
    if (!stream || $68f5bbd3bbcd3b1e$var$isDestroyed(stream)) return;
    if (!err && !$68f5bbd3bbcd3b1e$var$isFinished(stream)) err = new $68f5bbd3bbcd3b1e$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($68f5bbd3bbcd3b1e$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($68f5bbd3bbcd3b1e$var$isRequest(stream)) stream.abort();
    else if ($68f5bbd3bbcd3b1e$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($68f5bbd3bbcd3b1e$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$68f5bbd3bbcd3b1e$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $68f5bbd3bbcd3b1e$var$construct,
    destroyer: $68f5bbd3bbcd3b1e$var$destroyer,
    destroy: $68f5bbd3bbcd3b1e$var$destroy,
    undestroy: $68f5bbd3bbcd3b1e$var$undestroy,
    errorOrDestroy: $68f5bbd3bbcd3b1e$var$errorOrDestroy
};

});

parcelRegister("84z6T", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $5e09eea023f87919$var$ObjectDefineProperties = $2LuAg.ObjectDefineProperties, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor = $2LuAg.ObjectGetOwnPropertyDescriptor, $5e09eea023f87919$var$ObjectKeys = $2LuAg.ObjectKeys, $5e09eea023f87919$var$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf;
module.exports = $5e09eea023f87919$var$Duplex;

var $itzhG = parcelRequire("itzhG");

var $8lwKN = parcelRequire("8lwKN");
$5e09eea023f87919$var$ObjectSetPrototypeOf($5e09eea023f87919$var$Duplex.prototype, $itzhG.prototype);
$5e09eea023f87919$var$ObjectSetPrototypeOf($5e09eea023f87919$var$Duplex, $itzhG);
{
    var $5e09eea023f87919$var$keys = $5e09eea023f87919$var$ObjectKeys($8lwKN.prototype);
    // Allow the keys array to be GC'ed.
    for(var $5e09eea023f87919$var$i = 0; $5e09eea023f87919$var$i < $5e09eea023f87919$var$keys.length; $5e09eea023f87919$var$i++){
        var $5e09eea023f87919$var$method = $5e09eea023f87919$var$keys[$5e09eea023f87919$var$i];
        if (!$5e09eea023f87919$var$Duplex.prototype[$5e09eea023f87919$var$method]) $5e09eea023f87919$var$Duplex.prototype[$5e09eea023f87919$var$method] = $8lwKN.prototype[$5e09eea023f87919$var$method];
    }
}function $5e09eea023f87919$var$Duplex(options) {
    if (!(this instanceof $5e09eea023f87919$var$Duplex)) return new $5e09eea023f87919$var$Duplex(options);
    $itzhG.call(this, options);
    $8lwKN.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$5e09eea023f87919$var$ObjectDefineProperties($5e09eea023f87919$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $5e09eea023f87919$var$ObjectGetOwnPropertyDescriptor($8lwKN.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $5e09eea023f87919$var$webStreamsAdapters;
// Lazy to avoid circular references
function $5e09eea023f87919$var$lazyWebStreams() {
    if ($5e09eea023f87919$var$webStreamsAdapters === undefined) $5e09eea023f87919$var$webStreamsAdapters = {};
    return $5e09eea023f87919$var$webStreamsAdapters;
}
$5e09eea023f87919$var$Duplex.fromWeb = function(pair, options) {
    return $5e09eea023f87919$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$5e09eea023f87919$var$Duplex.toWeb = function(duplex) {
    return $5e09eea023f87919$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $5e09eea023f87919$var$duplexify;

$5e09eea023f87919$var$Duplex.from = function(body) {
    if (!$5e09eea023f87919$var$duplexify) $5e09eea023f87919$var$duplexify = (parcelRequire("25yWP"));
    return $5e09eea023f87919$var$duplexify(body, 'body');
};

});
parcelRegister("itzhG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2LuAg = parcelRequire("2LuAg");
/* replacement end */ var $d7364e21d5353c8a$var$ArrayPrototypeIndexOf = $2LuAg.ArrayPrototypeIndexOf, $d7364e21d5353c8a$var$NumberIsInteger = $2LuAg.NumberIsInteger, $d7364e21d5353c8a$var$NumberIsNaN = $2LuAg.NumberIsNaN, $d7364e21d5353c8a$var$NumberParseInt = $2LuAg.NumberParseInt, $d7364e21d5353c8a$var$ObjectDefineProperties = $2LuAg.ObjectDefineProperties, $d7364e21d5353c8a$var$ObjectKeys = $2LuAg.ObjectKeys, $d7364e21d5353c8a$var$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf, $d7364e21d5353c8a$var$Promise = $2LuAg.Promise, $d7364e21d5353c8a$var$SafeSet = $2LuAg.SafeSet, $d7364e21d5353c8a$var$SymbolAsyncDispose = $2LuAg.SymbolAsyncDispose, $d7364e21d5353c8a$var$SymbolAsyncIterator = $2LuAg.SymbolAsyncIterator, $d7364e21d5353c8a$var$Symbol = $2LuAg.Symbol;
module.exports = $d7364e21d5353c8a$var$Readable;
$d7364e21d5353c8a$var$Readable.ReadableState = $d7364e21d5353c8a$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $d7364e21d5353c8a$var$EE = $bBoAO.EventEmitter;

var $aCZ5T = parcelRequire("aCZ5T");
var $d7364e21d5353c8a$var$Stream = $aCZ5T.Stream, $d7364e21d5353c8a$var$prependListener = $aCZ5T.prependListener;

var $k4uY4 = parcelRequire("k4uY4");
var $d7364e21d5353c8a$require$Buffer = $k4uY4.Buffer;

var $lTl6r = parcelRequire("lTl6r");
var $d7364e21d5353c8a$require$addAbortSignal = $lTl6r.addAbortSignal;

var $hbj9O = parcelRequire("hbj9O");

var $d7364e21d5353c8a$var$debug = (parcelRequire("bIvqM")).debuglog('stream', function(fn) {
    $d7364e21d5353c8a$var$debug = fn;
});

var $ie1Gd = parcelRequire("ie1Gd");

var $90Hle = parcelRequire("90Hle");

var $1tIzt = parcelRequire("1tIzt");
var $d7364e21d5353c8a$var$getHighWaterMark = $1tIzt.getHighWaterMark, $d7364e21d5353c8a$var$getDefaultHighWaterMark = $1tIzt.getDefaultHighWaterMark;

var $7tH7p = parcelRequire("7tH7p");
var $d7364e21d5353c8a$var$aggregateTwoErrors = $7tH7p.aggregateTwoErrors, $d7364e21d5353c8a$var$_require_codes = $7tH7p.codes, $d7364e21d5353c8a$var$ERR_INVALID_ARG_TYPE = $d7364e21d5353c8a$var$_require_codes.ERR_INVALID_ARG_TYPE, $d7364e21d5353c8a$var$ERR_METHOD_NOT_IMPLEMENTED = $d7364e21d5353c8a$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $d7364e21d5353c8a$var$ERR_OUT_OF_RANGE = $d7364e21d5353c8a$var$_require_codes.ERR_OUT_OF_RANGE, $d7364e21d5353c8a$var$ERR_STREAM_PUSH_AFTER_EOF = $d7364e21d5353c8a$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $d7364e21d5353c8a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d7364e21d5353c8a$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $d7364e21d5353c8a$var$AbortError = $7tH7p.AbortError;

var $11JLe = parcelRequire("11JLe");
var $d7364e21d5353c8a$require$validateObject = $11JLe.validateObject;
var $d7364e21d5353c8a$var$kPaused = $d7364e21d5353c8a$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $d7364e21d5353c8a$require$StringDecoder = $3Jf7C.StringDecoder;

var $kqgJw = parcelRequire("kqgJw");
$d7364e21d5353c8a$var$ObjectSetPrototypeOf($d7364e21d5353c8a$var$Readable.prototype, $d7364e21d5353c8a$var$Stream.prototype);
$d7364e21d5353c8a$var$ObjectSetPrototypeOf($d7364e21d5353c8a$var$Readable, $d7364e21d5353c8a$var$Stream);
var $d7364e21d5353c8a$var$nop = function() {};
var $d7364e21d5353c8a$var$errorOrDestroy = $90Hle.errorOrDestroy;
var $d7364e21d5353c8a$var$kObjectMode = 1;
var $d7364e21d5353c8a$var$kEnded = 2;
var $d7364e21d5353c8a$var$kEndEmitted = 4;
var $d7364e21d5353c8a$var$kReading = 8;
var $d7364e21d5353c8a$var$kConstructed = 16;
var $d7364e21d5353c8a$var$kSync = 32;
var $d7364e21d5353c8a$var$kNeedReadable = 64;
var $d7364e21d5353c8a$var$kEmittedReadable = 128;
var $d7364e21d5353c8a$var$kReadableListening = 256;
var $d7364e21d5353c8a$var$kResumeScheduled = 512;
var $d7364e21d5353c8a$var$kErrorEmitted = 1024;
var $d7364e21d5353c8a$var$kEmitClose = 2048;
var $d7364e21d5353c8a$var$kAutoDestroy = 4096;
var $d7364e21d5353c8a$var$kDestroyed = 8192;
var $d7364e21d5353c8a$var$kClosed = 16384;
var $d7364e21d5353c8a$var$kCloseEmitted = 32768;
var $d7364e21d5353c8a$var$kMultiAwaitDrain = 65536;
var $d7364e21d5353c8a$var$kReadingMore = 131072;
var $d7364e21d5353c8a$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $d7364e21d5353c8a$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$d7364e21d5353c8a$var$ObjectDefineProperties($d7364e21d5353c8a$var$ReadableState.prototype, {
    objectMode: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kObjectMode),
    ended: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kEnded),
    endEmitted: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kEndEmitted),
    reading: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kNeedReadable),
    emittedReadable: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kEmittedReadable),
    readableListening: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kReadableListening),
    resumeScheduled: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kErrorEmitted),
    emitClose: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kEmitClose),
    autoDestroy: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kCloseEmitted),
    multiAwaitDrain: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kReadingMore),
    dataEmitted: $d7364e21d5353c8a$var$makeBitMapDescriptor($d7364e21d5353c8a$var$kDataEmitted)
});

function $d7364e21d5353c8a$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("84z6T"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $d7364e21d5353c8a$var$kEmitClose | $d7364e21d5353c8a$var$kAutoDestroy | $d7364e21d5353c8a$var$kConstructed | $d7364e21d5353c8a$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $d7364e21d5353c8a$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $d7364e21d5353c8a$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $d7364e21d5353c8a$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $d7364e21d5353c8a$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $ie1Gd();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$d7364e21d5353c8a$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$d7364e21d5353c8a$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$d7364e21d5353c8a$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $d7364e21d5353c8a$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d7364e21d5353c8a$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $d7364e21d5353c8a$var$Readable)) return new $d7364e21d5353c8a$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("84z6T"));
    this._readableState = new $d7364e21d5353c8a$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $d7364e21d5353c8a$require$addAbortSignal(options.signal, this);
    }
    $d7364e21d5353c8a$var$Stream.call(this, options);
    $90Hle.construct(this, function() {
        if (_this._readableState.needReadable) $d7364e21d5353c8a$var$maybeReadMore(_this, _this._readableState);
    });
}
$d7364e21d5353c8a$var$Readable.prototype.destroy = $90Hle.destroy;
$d7364e21d5353c8a$var$Readable.prototype._undestroy = $90Hle.undestroy;
$d7364e21d5353c8a$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$d7364e21d5353c8a$var$Readable.prototype[$d7364e21d5353c8a$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$d7364e21d5353c8a$var$Readable.prototype[$d7364e21d5353c8a$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $d7364e21d5353c8a$var$AbortError();
        this.destroy(error);
    }
    return new $d7364e21d5353c8a$var$Promise(function(resolve, reject) {
        return $hbj9O(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d7364e21d5353c8a$var$Readable.prototype.push = function(chunk, encoding) {
    return $d7364e21d5353c8a$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$d7364e21d5353c8a$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $d7364e21d5353c8a$var$readableAddChunk(this, chunk, encoding, true);
};
function $d7364e21d5353c8a$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $d7364e21d5353c8a$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $d7364e21d5353c8a$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $d7364e21d5353c8a$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $d7364e21d5353c8a$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $d7364e21d5353c8a$require$Buffer) encoding = '';
        else if ($d7364e21d5353c8a$var$Stream._isUint8Array(chunk)) {
            chunk = $d7364e21d5353c8a$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $d7364e21d5353c8a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $d7364e21d5353c8a$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$d7364e21d5353c8a$var$kReading;
        $d7364e21d5353c8a$var$onEofChunk(stream, state);
    } else if ((state.state & $d7364e21d5353c8a$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $d7364e21d5353c8a$var$kEndEmitted) !== 0) $d7364e21d5353c8a$var$errorOrDestroy(stream, new $d7364e21d5353c8a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $d7364e21d5353c8a$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $d7364e21d5353c8a$var$errorOrDestroy(stream, new $d7364e21d5353c8a$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$d7364e21d5353c8a$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $d7364e21d5353c8a$var$addChunk(stream, state, chunk, false);
                else $d7364e21d5353c8a$var$maybeReadMore(stream, state);
            } else $d7364e21d5353c8a$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$d7364e21d5353c8a$var$kReading;
        $d7364e21d5353c8a$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d7364e21d5353c8a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $d7364e21d5353c8a$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $d7364e21d5353c8a$var$kNeedReadable) !== 0) $d7364e21d5353c8a$var$emitReadable(stream);
    }
    $d7364e21d5353c8a$var$maybeReadMore(stream, state);
}
$d7364e21d5353c8a$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$d7364e21d5353c8a$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$d7364e21d5353c8a$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $d7364e21d5353c8a$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$d7364e21d5353c8a$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $d7364e21d5353c8a$var$MAX_HWM = 0x40000000;
function $d7364e21d5353c8a$var$computeNewHighWaterMark(n) {
    if (n > $d7364e21d5353c8a$var$MAX_HWM) throw new $d7364e21d5353c8a$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d7364e21d5353c8a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $d7364e21d5353c8a$var$kObjectMode) !== 0) return 1;
    if ($d7364e21d5353c8a$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$d7364e21d5353c8a$var$Readable.prototype.read = function(n) {
    $d7364e21d5353c8a$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$d7364e21d5353c8a$var$NumberIsInteger(n)) n = $d7364e21d5353c8a$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d7364e21d5353c8a$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$d7364e21d5353c8a$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d7364e21d5353c8a$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $d7364e21d5353c8a$var$endReadable(this);
        else $d7364e21d5353c8a$var$emitReadable(this);
        return null;
    }
    n = $d7364e21d5353c8a$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d7364e21d5353c8a$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $d7364e21d5353c8a$var$kNeedReadable) !== 0;
    $d7364e21d5353c8a$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d7364e21d5353c8a$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $d7364e21d5353c8a$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $d7364e21d5353c8a$var$debug('do read');
        state.state |= $d7364e21d5353c8a$var$kReading | $d7364e21d5353c8a$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $d7364e21d5353c8a$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $d7364e21d5353c8a$var$errorOrDestroy(this, err);
        }
        state.state &= ~$d7364e21d5353c8a$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d7364e21d5353c8a$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d7364e21d5353c8a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d7364e21d5353c8a$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $d7364e21d5353c8a$var$onEofChunk(stream, state) {
    $d7364e21d5353c8a$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $d7364e21d5353c8a$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $d7364e21d5353c8a$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d7364e21d5353c8a$var$emitReadable(stream) {
    var state = stream._readableState;
    $d7364e21d5353c8a$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d7364e21d5353c8a$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($d7364e21d5353c8a$var$emitReadable_, stream);
    }
}
function $d7364e21d5353c8a$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d7364e21d5353c8a$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d7364e21d5353c8a$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d7364e21d5353c8a$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($d7364e21d5353c8a$var$maybeReadMore_, stream, state);
    }
}
function $d7364e21d5353c8a$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d7364e21d5353c8a$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d7364e21d5353c8a$var$Readable.prototype._read = function(n) {
    throw new $d7364e21d5353c8a$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$d7364e21d5353c8a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $d7364e21d5353c8a$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $d7364e21d5353c8a$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d7364e21d5353c8a$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d7364e21d5353c8a$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $d7364e21d5353c8a$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $d7364e21d5353c8a$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $d7364e21d5353c8a$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $d7364e21d5353c8a$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $d7364e21d5353c8a$var$debug('ondata');
        var ret = dest.write(chunk);
        $d7364e21d5353c8a$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d7364e21d5353c8a$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $d7364e21d5353c8a$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $d7364e21d5353c8a$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $d7364e21d5353c8a$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $d7364e21d5353c8a$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $d7364e21d5353c8a$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $d7364e21d5353c8a$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $d7364e21d5353c8a$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $d7364e21d5353c8a$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$d7364e21d5353c8a$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $d7364e21d5353c8a$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$d7364e21d5353c8a$var$Readable.prototype.on = function(ev, fn) {
    var res = $d7364e21d5353c8a$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d7364e21d5353c8a$var$debug('on readable', state.length, state.reading);
            if (state.length) $d7364e21d5353c8a$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($d7364e21d5353c8a$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d7364e21d5353c8a$var$Readable.prototype.addListener = $d7364e21d5353c8a$var$Readable.prototype.on;
$d7364e21d5353c8a$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $d7364e21d5353c8a$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($d7364e21d5353c8a$var$updateReadableListening, this);
    return res;
};
$d7364e21d5353c8a$var$Readable.prototype.off = $d7364e21d5353c8a$var$Readable.prototype.removeListener;
$d7364e21d5353c8a$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $d7364e21d5353c8a$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($d7364e21d5353c8a$var$updateReadableListening, this);
    return res;
};
function $d7364e21d5353c8a$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$d7364e21d5353c8a$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $d7364e21d5353c8a$var$nReadingNextTick(self) {
    $d7364e21d5353c8a$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d7364e21d5353c8a$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d7364e21d5353c8a$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $d7364e21d5353c8a$var$resume(this, state);
    }
    state[$d7364e21d5353c8a$var$kPaused] = false;
    return this;
};
function $d7364e21d5353c8a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($d7364e21d5353c8a$var$resume_, stream, state);
    }
}
function $d7364e21d5353c8a$var$resume_(stream, state) {
    $d7364e21d5353c8a$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $d7364e21d5353c8a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d7364e21d5353c8a$var$Readable.prototype.pause = function() {
    $d7364e21d5353c8a$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d7364e21d5353c8a$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$d7364e21d5353c8a$var$kPaused] = true;
    return this;
};
function $d7364e21d5353c8a$var$flow(stream) {
    var state = stream._readableState;
    $d7364e21d5353c8a$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d7364e21d5353c8a$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $d7364e21d5353c8a$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $d7364e21d5353c8a$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$d7364e21d5353c8a$var$Readable.prototype[$d7364e21d5353c8a$var$SymbolAsyncIterator] = function() {
    return $d7364e21d5353c8a$var$streamToAsyncIterator(this);
};
$d7364e21d5353c8a$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $d7364e21d5353c8a$require$validateObject(options, 'options');
    return $d7364e21d5353c8a$var$streamToAsyncIterator(this, options);
};
function $d7364e21d5353c8a$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $d7364e21d5353c8a$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $d7364e21d5353c8a$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $d7364e21d5353c8a$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $d7364e21d5353c8a$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $d7364e21d5353c8a$var$nop;
                    stream.on('readable', next);
                    cleanup = $hbj9O(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $d7364e21d5353c8a$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $d7364e21d5353c8a$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $d7364e21d5353c8a$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $d7364e21d5353c8a$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $90Hle.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$d7364e21d5353c8a$var$ObjectDefineProperties($d7364e21d5353c8a$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$d7364e21d5353c8a$var$ObjectDefineProperties($d7364e21d5353c8a$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$d7364e21d5353c8a$var$kPaused] !== false;
        },
        set: function(value) {
            this[$d7364e21d5353c8a$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$d7364e21d5353c8a$var$Readable._fromList = $d7364e21d5353c8a$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d7364e21d5353c8a$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d7364e21d5353c8a$var$endReadable(stream) {
    var state = stream._readableState;
    $d7364e21d5353c8a$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($d7364e21d5353c8a$var$endReadableNT, state, stream);
    }
}
function $d7364e21d5353c8a$var$endReadableNT(state, stream) {
    $d7364e21d5353c8a$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($d7364e21d5353c8a$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $d7364e21d5353c8a$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$d7364e21d5353c8a$var$Readable.from = function(iterable, opts) {
    return $kqgJw($d7364e21d5353c8a$var$Readable, iterable, opts);
};
var $d7364e21d5353c8a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d7364e21d5353c8a$var$lazyWebStreams() {
    if ($d7364e21d5353c8a$var$webStreamsAdapters === undefined) $d7364e21d5353c8a$var$webStreamsAdapters = {};
    return $d7364e21d5353c8a$var$webStreamsAdapters;
}
$d7364e21d5353c8a$var$Readable.fromWeb = function(readableStream, options) {
    return $d7364e21d5353c8a$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$d7364e21d5353c8a$var$Readable.toWeb = function(streamReadable, options) {
    return $d7364e21d5353c8a$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$d7364e21d5353c8a$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $d7364e21d5353c8a$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $90Hle.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("aCZ5T", function(module, exports) {
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $7bccd803c3203984$var$ArrayIsArray = $2LuAg.ArrayIsArray, $7bccd803c3203984$var$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $7bccd803c3203984$var$EE = $bBoAO.EventEmitter;
function $7bccd803c3203984$var$Stream(opts) {
    $7bccd803c3203984$var$EE.call(this, opts);
}
$7bccd803c3203984$var$ObjectSetPrototypeOf($7bccd803c3203984$var$Stream.prototype, $7bccd803c3203984$var$EE.prototype);
$7bccd803c3203984$var$ObjectSetPrototypeOf($7bccd803c3203984$var$Stream, $7bccd803c3203984$var$EE);
$7bccd803c3203984$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($7bccd803c3203984$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $7bccd803c3203984$var$prependListener(source, 'error', onerror);
    $7bccd803c3203984$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $7bccd803c3203984$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7bccd803c3203984$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $7bccd803c3203984$var$Stream,
    prependListener: $7bccd803c3203984$var$prependListener
};

});

parcelRegister("lTl6r", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $feff1aa5450f0f2f$export$e2db56ee53255a0; }, function (v) { return $feff1aa5450f0f2f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $feff1aa5450f0f2f$export$11956e9313f43de0; }, function (v) { return $feff1aa5450f0f2f$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $feff1aa5450f0f2f$export$e2db56ee53255a0;
var $feff1aa5450f0f2f$export$11956e9313f43de0;
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $feff1aa5450f0f2f$require$SymbolDispose = $2LuAg.SymbolDispose;

var $7tH7p = parcelRequire("7tH7p");
var $feff1aa5450f0f2f$var$AbortError = $7tH7p.AbortError, $feff1aa5450f0f2f$var$codes = $7tH7p.codes;

var $4nXXr = parcelRequire("4nXXr");
var $feff1aa5450f0f2f$var$isNodeStream = $4nXXr.isNodeStream, $feff1aa5450f0f2f$var$isWebStream = $4nXXr.isWebStream, $feff1aa5450f0f2f$var$kControllerErrorFunction = $4nXXr.kControllerErrorFunction;

var $hbj9O = parcelRequire("hbj9O");
var $feff1aa5450f0f2f$var$ERR_INVALID_ARG_TYPE = $feff1aa5450f0f2f$var$codes.ERR_INVALID_ARG_TYPE;
var $feff1aa5450f0f2f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $feff1aa5450f0f2f$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $feff1aa5450f0f2f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$feff1aa5450f0f2f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $feff1aa5450f0f2f$var$validateAbortSignal(signal, 'signal');
    if (!$feff1aa5450f0f2f$var$isNodeStream(stream) && !$feff1aa5450f0f2f$var$isWebStream(stream)) throw new $feff1aa5450f0f2f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $feff1aa5450f0f2f$export$11956e9313f43de0(signal, stream);
};

$feff1aa5450f0f2f$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $feff1aa5450f0f2f$var$isNodeStream(stream) ? function() {
        stream.destroy(new $feff1aa5450f0f2f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$feff1aa5450f0f2f$var$kControllerErrorFunction](new $feff1aa5450f0f2f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $feff1aa5450f0f2f$var$addAbortListener = $feff1aa5450f0f2f$var$addAbortListener || (parcelRequire("bIvqM")).addAbortListener;
        var disposable = $feff1aa5450f0f2f$var$addAbortListener(signal, onAbort);
        $hbj9O(stream, disposable[$feff1aa5450f0f2f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("ie1Gd", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $d44ad66b0ce70ab7$var$StringPrototypeSlice = $2LuAg.StringPrototypeSlice, $d44ad66b0ce70ab7$var$SymbolIterator = $2LuAg.SymbolIterator, $d44ad66b0ce70ab7$var$TypedArrayPrototypeSet = $2LuAg.TypedArrayPrototypeSet, $d44ad66b0ce70ab7$var$Uint8Array = $2LuAg.Uint8Array;

var $k4uY4 = parcelRequire("k4uY4");
var $d44ad66b0ce70ab7$require$Buffer = $k4uY4.Buffer;

var $bIvqM = parcelRequire("bIvqM");
var $d44ad66b0ce70ab7$require$inspect = $bIvqM.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $d44ad66b0ce70ab7$require$Buffer.alloc(0);
                var ret = $d44ad66b0ce70ab7$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $d44ad66b0ce70ab7$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $d44ad66b0ce70ab7$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $d44ad66b0ce70ab7$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $d44ad66b0ce70ab7$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $d44ad66b0ce70ab7$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $d44ad66b0ce70ab7$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $d44ad66b0ce70ab7$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $d44ad66b0ce70ab7$var$TypedArrayPrototypeSet(ret, new $d44ad66b0ce70ab7$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $d44ad66b0ce70ab7$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("1tIzt", function(module, exports) {
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $113b12caa8246914$var$MathFloor = $2LuAg.MathFloor, $113b12caa8246914$var$NumberIsInteger = $2LuAg.NumberIsInteger;

var $11JLe = parcelRequire("11JLe");
var $113b12caa8246914$require$validateInteger = $11JLe.validateInteger;

var $113b12caa8246914$var$ERR_INVALID_ARG_VALUE = (parcelRequire("7tH7p")).codes.ERR_INVALID_ARG_VALUE;
var $113b12caa8246914$var$defaultHighWaterMarkBytes = 16384;
var $113b12caa8246914$var$defaultHighWaterMarkObjectMode = 16;
function $113b12caa8246914$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $113b12caa8246914$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $113b12caa8246914$var$defaultHighWaterMarkObjectMode : $113b12caa8246914$var$defaultHighWaterMarkBytes;
}
function $113b12caa8246914$var$setDefaultHighWaterMark(objectMode, value) {
    $113b12caa8246914$require$validateInteger(value, 'value', 0);
    if (objectMode) $113b12caa8246914$var$defaultHighWaterMarkObjectMode = value;
    else $113b12caa8246914$var$defaultHighWaterMarkBytes = value;
}
function $113b12caa8246914$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $113b12caa8246914$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$113b12caa8246914$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $113b12caa8246914$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $113b12caa8246914$var$MathFloor(hwm);
    }
    // Default value
    return $113b12caa8246914$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $113b12caa8246914$var$getHighWaterMark,
    getDefaultHighWaterMark: $113b12caa8246914$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $113b12caa8246914$var$setDefaultHighWaterMark
};

});

parcelRegister("kqgJw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2LuAg = parcelRequire("2LuAg");
/* replacement end */ var $ede33734e08b0f9c$var$PromisePrototypeThen = $2LuAg.PromisePrototypeThen, $ede33734e08b0f9c$var$SymbolAsyncIterator = $2LuAg.SymbolAsyncIterator, $ede33734e08b0f9c$var$SymbolIterator = $2LuAg.SymbolIterator;

var $k4uY4 = parcelRequire("k4uY4");
var $ede33734e08b0f9c$require$Buffer = $k4uY4.Buffer;

var $7tH7p = parcelRequire("7tH7p");
var $ede33734e08b0f9c$require$_require_codes = $7tH7p.codes;
var $ede33734e08b0f9c$var$ERR_INVALID_ARG_TYPE = $ede33734e08b0f9c$require$_require_codes.ERR_INVALID_ARG_TYPE, $ede33734e08b0f9c$var$ERR_STREAM_NULL_VALUES = $ede33734e08b0f9c$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $ede33734e08b0f9c$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $ede33734e08b0f9c$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$ede33734e08b0f9c$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$ede33734e08b0f9c$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$ede33734e08b0f9c$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$ede33734e08b0f9c$var$SymbolIterator]();
    } else throw new $ede33734e08b0f9c$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $ede33734e08b0f9c$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $ede33734e08b0f9c$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $ede33734e08b0f9c$var$from;

});


parcelRegister("8lwKN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2LuAg = parcelRequire("2LuAg");
/* replacement end */ var $6139b122e6a7ed0f$var$ArrayPrototypeSlice = $2LuAg.ArrayPrototypeSlice, $6139b122e6a7ed0f$var$Error = $2LuAg.Error, $6139b122e6a7ed0f$var$FunctionPrototypeSymbolHasInstance = $2LuAg.FunctionPrototypeSymbolHasInstance, $6139b122e6a7ed0f$var$ObjectDefineProperty = $2LuAg.ObjectDefineProperty, $6139b122e6a7ed0f$var$ObjectDefineProperties = $2LuAg.ObjectDefineProperties, $6139b122e6a7ed0f$var$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf, $6139b122e6a7ed0f$var$StringPrototypeToLowerCase = $2LuAg.StringPrototypeToLowerCase, $6139b122e6a7ed0f$var$Symbol = $2LuAg.Symbol, $6139b122e6a7ed0f$var$SymbolHasInstance = $2LuAg.SymbolHasInstance;
module.exports = $6139b122e6a7ed0f$var$Writable;
$6139b122e6a7ed0f$var$Writable.WritableState = $6139b122e6a7ed0f$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $6139b122e6a7ed0f$var$EE = $bBoAO.EventEmitter;

var $aCZ5T = parcelRequire("aCZ5T");
var $6139b122e6a7ed0f$require$Stream = $aCZ5T.Stream;

var $k4uY4 = parcelRequire("k4uY4");
var $6139b122e6a7ed0f$require$Buffer = $k4uY4.Buffer;

var $90Hle = parcelRequire("90Hle");

var $lTl6r = parcelRequire("lTl6r");
var $6139b122e6a7ed0f$require$addAbortSignal = $lTl6r.addAbortSignal;

var $1tIzt = parcelRequire("1tIzt");
var $6139b122e6a7ed0f$var$getHighWaterMark = $1tIzt.getHighWaterMark, $6139b122e6a7ed0f$var$getDefaultHighWaterMark = $1tIzt.getDefaultHighWaterMark;

var $7tH7p = parcelRequire("7tH7p");
var $6139b122e6a7ed0f$require$_require_codes = $7tH7p.codes;
var $6139b122e6a7ed0f$var$ERR_INVALID_ARG_TYPE = $6139b122e6a7ed0f$require$_require_codes.ERR_INVALID_ARG_TYPE, $6139b122e6a7ed0f$var$ERR_METHOD_NOT_IMPLEMENTED = $6139b122e6a7ed0f$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $6139b122e6a7ed0f$var$ERR_MULTIPLE_CALLBACK = $6139b122e6a7ed0f$require$_require_codes.ERR_MULTIPLE_CALLBACK, $6139b122e6a7ed0f$var$ERR_STREAM_CANNOT_PIPE = $6139b122e6a7ed0f$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED = $6139b122e6a7ed0f$require$_require_codes.ERR_STREAM_DESTROYED, $6139b122e6a7ed0f$var$ERR_STREAM_ALREADY_FINISHED = $6139b122e6a7ed0f$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $6139b122e6a7ed0f$var$ERR_STREAM_NULL_VALUES = $6139b122e6a7ed0f$require$_require_codes.ERR_STREAM_NULL_VALUES, $6139b122e6a7ed0f$var$ERR_STREAM_WRITE_AFTER_END = $6139b122e6a7ed0f$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $6139b122e6a7ed0f$var$ERR_UNKNOWN_ENCODING = $6139b122e6a7ed0f$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $6139b122e6a7ed0f$var$errorOrDestroy = $90Hle.errorOrDestroy;
$6139b122e6a7ed0f$var$ObjectSetPrototypeOf($6139b122e6a7ed0f$var$Writable.prototype, $6139b122e6a7ed0f$require$Stream.prototype);
$6139b122e6a7ed0f$var$ObjectSetPrototypeOf($6139b122e6a7ed0f$var$Writable, $6139b122e6a7ed0f$require$Stream);
function $6139b122e6a7ed0f$var$nop() {}
var $6139b122e6a7ed0f$var$kOnFinished = $6139b122e6a7ed0f$var$Symbol('kOnFinished');

function $6139b122e6a7ed0f$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("84z6T"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $6139b122e6a7ed0f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $6139b122e6a7ed0f$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $6139b122e6a7ed0f$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $6139b122e6a7ed0f$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$6139b122e6a7ed0f$var$kOnFinished] = [];
}
function $6139b122e6a7ed0f$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$6139b122e6a7ed0f$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $6139b122e6a7ed0f$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$6139b122e6a7ed0f$var$ObjectDefineProperty($6139b122e6a7ed0f$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $6139b122e6a7ed0f$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("84z6T"));
    if (!isDuplex && !$6139b122e6a7ed0f$var$FunctionPrototypeSymbolHasInstance($6139b122e6a7ed0f$var$Writable, this)) return new $6139b122e6a7ed0f$var$Writable(options);
    this._writableState = new $6139b122e6a7ed0f$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $6139b122e6a7ed0f$require$addAbortSignal(options.signal, this);
    }
    $6139b122e6a7ed0f$require$Stream.call(this, options);
    $90Hle.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $6139b122e6a7ed0f$var$clearBuffer(_this, state);
        $6139b122e6a7ed0f$var$finishMaybe(_this, state);
    });
}
$6139b122e6a7ed0f$var$ObjectDefineProperty($6139b122e6a7ed0f$var$Writable, $6139b122e6a7ed0f$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($6139b122e6a7ed0f$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $6139b122e6a7ed0f$var$Writable) return false;
        return object && object._writableState instanceof $6139b122e6a7ed0f$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$6139b122e6a7ed0f$var$Writable.prototype.pipe = function() {
    $6139b122e6a7ed0f$var$errorOrDestroy(this, new $6139b122e6a7ed0f$var$ERR_STREAM_CANNOT_PIPE());
};
function $6139b122e6a7ed0f$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$6139b122e6a7ed0f$require$Buffer.isEncoding(encoding)) throw new $6139b122e6a7ed0f$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $6139b122e6a7ed0f$var$nop;
    }
    if (chunk === null) throw new $6139b122e6a7ed0f$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $6139b122e6a7ed0f$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $6139b122e6a7ed0f$require$Buffer) encoding = 'buffer';
        else if ($6139b122e6a7ed0f$require$Stream._isUint8Array(chunk)) {
            chunk = $6139b122e6a7ed0f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $6139b122e6a7ed0f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $6139b122e6a7ed0f$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $6139b122e6a7ed0f$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $6139b122e6a7ed0f$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$6139b122e6a7ed0f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $6139b122e6a7ed0f$var$_write(this, chunk, encoding, cb) === true;
};
$6139b122e6a7ed0f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$6139b122e6a7ed0f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $6139b122e6a7ed0f$var$clearBuffer(this, state);
    }
};
$6139b122e6a7ed0f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $6139b122e6a7ed0f$var$StringPrototypeToLowerCase(encoding);
    if (!$6139b122e6a7ed0f$require$Buffer.isEncoding(encoding)) throw new $6139b122e6a7ed0f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $6139b122e6a7ed0f$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $6139b122e6a7ed0f$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $6139b122e6a7ed0f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $6139b122e6a7ed0f$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $6139b122e6a7ed0f$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $6139b122e6a7ed0f$var$errorOrDestroy(stream, er);
}
function $6139b122e6a7ed0f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $6139b122e6a7ed0f$var$errorOrDestroy(stream, new $6139b122e6a7ed0f$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($6139b122e6a7ed0f$var$onwriteError, stream, state, er, cb);
        else $6139b122e6a7ed0f$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $6139b122e6a7ed0f$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($6139b122e6a7ed0f$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $6139b122e6a7ed0f$var$afterWrite(stream, state, 1, cb);
    }
}
function $6139b122e6a7ed0f$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $6139b122e6a7ed0f$var$afterWrite(stream, state, count, cb);
}
function $6139b122e6a7ed0f$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $6139b122e6a7ed0f$var$errorBuffer(state);
    $6139b122e6a7ed0f$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $6139b122e6a7ed0f$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$6139b122e6a7ed0f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED('end'));
    }
    $6139b122e6a7ed0f$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $6139b122e6a7ed0f$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $6139b122e6a7ed0f$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $6139b122e6a7ed0f$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $6139b122e6a7ed0f$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $6139b122e6a7ed0f$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $6139b122e6a7ed0f$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $6139b122e6a7ed0f$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$6139b122e6a7ed0f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $6139b122e6a7ed0f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$6139b122e6a7ed0f$var$Writable.prototype._writev = null;
$6139b122e6a7ed0f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $6139b122e6a7ed0f$var$_write(this, chunk, encoding);
        if (ret instanceof $6139b122e6a7ed0f$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $6139b122e6a7ed0f$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $6139b122e6a7ed0f$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $6139b122e6a7ed0f$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$6139b122e6a7ed0f$var$kOnFinished].push(cb);
    }
    return this;
};
function $6139b122e6a7ed0f$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $6139b122e6a7ed0f$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $6139b122e6a7ed0f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $6139b122e6a7ed0f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$6139b122e6a7ed0f$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $6139b122e6a7ed0f$var$errorOrDestroy(stream, err, state.sync);
        } else if ($6139b122e6a7ed0f$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($6139b122e6a7ed0f$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $6139b122e6a7ed0f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $6139b122e6a7ed0f$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $6139b122e6a7ed0f$var$finishMaybe(stream, state, sync) {
    if ($6139b122e6a7ed0f$var$needFinish(state)) {
        $6139b122e6a7ed0f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($6139b122e6a7ed0f$var$needFinish(state)) $6139b122e6a7ed0f$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($6139b122e6a7ed0f$var$needFinish(state)) {
                state.pendingcb++;
                $6139b122e6a7ed0f$var$finish(stream, state);
            }
        }
    }
}
function $6139b122e6a7ed0f$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$6139b122e6a7ed0f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$6139b122e6a7ed0f$var$ObjectDefineProperties($6139b122e6a7ed0f$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $6139b122e6a7ed0f$var$destroy = $90Hle.destroy;
$6139b122e6a7ed0f$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$6139b122e6a7ed0f$var$kOnFinished].length)) $2Qkr5.nextTick($6139b122e6a7ed0f$var$errorBuffer, state);
    $6139b122e6a7ed0f$var$destroy.call(this, err, cb);
    return this;
};
$6139b122e6a7ed0f$var$Writable.prototype._undestroy = $90Hle.undestroy;
$6139b122e6a7ed0f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$6139b122e6a7ed0f$var$Writable.prototype[$6139b122e6a7ed0f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $6139b122e6a7ed0f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6139b122e6a7ed0f$var$lazyWebStreams() {
    if ($6139b122e6a7ed0f$var$webStreamsAdapters === undefined) $6139b122e6a7ed0f$var$webStreamsAdapters = {};
    return $6139b122e6a7ed0f$var$webStreamsAdapters;
}
$6139b122e6a7ed0f$var$Writable.fromWeb = function(writableStream, options) {
    return $6139b122e6a7ed0f$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$6139b122e6a7ed0f$var$Writable.toWeb = function(streamWritable) {
    return $6139b122e6a7ed0f$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("25yWP", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $k4uY4 = parcelRequire("k4uY4");

var $4nXXr = parcelRequire("4nXXr");
var $1857285724b16c7d$var$isReadable = $4nXXr.isReadable, $1857285724b16c7d$var$isWritable = $4nXXr.isWritable, $1857285724b16c7d$var$isIterable = $4nXXr.isIterable, $1857285724b16c7d$var$isNodeStream = $4nXXr.isNodeStream, $1857285724b16c7d$var$isReadableNodeStream = $4nXXr.isReadableNodeStream, $1857285724b16c7d$var$isWritableNodeStream = $4nXXr.isWritableNodeStream, $1857285724b16c7d$var$isDuplexNodeStream = $4nXXr.isDuplexNodeStream, $1857285724b16c7d$var$isReadableStream = $4nXXr.isReadableStream, $1857285724b16c7d$var$isWritableStream = $4nXXr.isWritableStream;

var $hbj9O = parcelRequire("hbj9O");

var $7tH7p = parcelRequire("7tH7p");
var $1857285724b16c7d$var$AbortError = $7tH7p.AbortError, $1857285724b16c7d$var$_require_codes = $7tH7p.codes, $1857285724b16c7d$var$ERR_INVALID_ARG_TYPE = $1857285724b16c7d$var$_require_codes.ERR_INVALID_ARG_TYPE, $1857285724b16c7d$var$ERR_INVALID_RETURN_VALUE = $1857285724b16c7d$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $90Hle = parcelRequire("90Hle");
var $1857285724b16c7d$require$destroyer = $90Hle.destroyer;

var $84z6T = parcelRequire("84z6T");

var $itzhG = parcelRequire("itzhG");

var $8lwKN = parcelRequire("8lwKN");

var $bIvqM = parcelRequire("bIvqM");
var $1857285724b16c7d$require$createDeferredPromise = $bIvqM.createDeferredPromise;

var $kqgJw = parcelRequire("kqgJw");
var $1857285724b16c7d$var$Blob = globalThis.Blob || $k4uY4.Blob;
var $1857285724b16c7d$var$isBlob = typeof $1857285724b16c7d$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $1857285724b16c7d$var$Blob;
} : function isBlob(b) {
    return false;
};

var $1857285724b16c7d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $2LuAg = parcelRequire("2LuAg");
var $1857285724b16c7d$require$FunctionPrototypeCall = $2LuAg.FunctionPrototypeCall;
// This is needed for pre node 17.
var $1857285724b16c7d$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($84z6T);
module.exports = function duplexify(body, name) {
    if ($1857285724b16c7d$var$isDuplexNodeStream(body)) return body;
    if ($1857285724b16c7d$var$isReadableNodeStream(body)) return $1857285724b16c7d$var$_duplexify({
        readable: body
    });
    if ($1857285724b16c7d$var$isWritableNodeStream(body)) return $1857285724b16c7d$var$_duplexify({
        writable: body
    });
    if ($1857285724b16c7d$var$isNodeStream(body)) return $1857285724b16c7d$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($1857285724b16c7d$var$isReadableStream(body)) return $1857285724b16c7d$var$_duplexify({
        readable: $itzhG.fromWeb(body)
    });
    if ($1857285724b16c7d$var$isWritableStream(body)) return $1857285724b16c7d$var$_duplexify({
        writable: $8lwKN.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $1857285724b16c7d$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($1857285724b16c7d$var$isIterable(value)) return $kqgJw($1857285724b16c7d$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $1857285724b16c7d$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $1857285724b16c7d$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $1857285724b16c7d$require$destroyer(d, err);
            });
            return d = new $1857285724b16c7d$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $1857285724b16c7d$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($1857285724b16c7d$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($1857285724b16c7d$var$isIterable(body)) return $kqgJw($1857285724b16c7d$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($1857285724b16c7d$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $1857285724b16c7d$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $1857285724b16c7d$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $1857285724b16c7d$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $1857285724b16c7d$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $1857285724b16c7d$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $1857285724b16c7d$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $1857285724b16c7d$require$destroyer(d1, err);
        });
        return d1 = new $1857285724b16c7d$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $1857285724b16c7d$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $1857285724b16c7d$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $1857285724b16c7d$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $1857285724b16c7d$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $1857285724b16c7d$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $1857285724b16c7d$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $1857285724b16c7d$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $itzhG.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$1857285724b16c7d$var$isReadable(r);
    var writable = !!$1857285724b16c7d$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1857285724b16c7d$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $hbj9O(w, function(err) {
            writable = false;
            if (err) $1857285724b16c7d$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $hbj9O(r, function(err) {
            readable = false;
            if (err) $1857285724b16c7d$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $1857285724b16c7d$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $1857285724b16c7d$require$destroyer(w, err);
            $1857285724b16c7d$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("4OxoW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $3815bdc04342d589$require$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf;
module.exports = $3815bdc04342d589$var$PassThrough;

var $aTRg3 = parcelRequire("aTRg3");
$3815bdc04342d589$require$ObjectSetPrototypeOf($3815bdc04342d589$var$PassThrough.prototype, $aTRg3.prototype);
$3815bdc04342d589$require$ObjectSetPrototypeOf($3815bdc04342d589$var$PassThrough, $aTRg3);
function $3815bdc04342d589$var$PassThrough(options) {
    if (!(this instanceof $3815bdc04342d589$var$PassThrough)) return new $3815bdc04342d589$var$PassThrough(options);
    $aTRg3.call(this, options);
}
$3815bdc04342d589$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("aTRg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $7ef85a594ba8a127$var$ObjectSetPrototypeOf = $2LuAg.ObjectSetPrototypeOf, $7ef85a594ba8a127$var$Symbol = $2LuAg.Symbol;
module.exports = $7ef85a594ba8a127$var$Transform;

var $7ef85a594ba8a127$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("7tH7p")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $84z6T = parcelRequire("84z6T");

var $1tIzt = parcelRequire("1tIzt");
var $7ef85a594ba8a127$require$getHighWaterMark = $1tIzt.getHighWaterMark;
$7ef85a594ba8a127$var$ObjectSetPrototypeOf($7ef85a594ba8a127$var$Transform.prototype, $84z6T.prototype);
$7ef85a594ba8a127$var$ObjectSetPrototypeOf($7ef85a594ba8a127$var$Transform, $84z6T);
var $7ef85a594ba8a127$var$kCallback = $7ef85a594ba8a127$var$Symbol('kCallback');
function $7ef85a594ba8a127$var$Transform(options) {
    if (!(this instanceof $7ef85a594ba8a127$var$Transform)) return new $7ef85a594ba8a127$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $7ef85a594ba8a127$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $84z6T.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$7ef85a594ba8a127$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $7ef85a594ba8a127$var$prefinish);
}
function $7ef85a594ba8a127$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $7ef85a594ba8a127$var$prefinish() {
    if (this._final !== $7ef85a594ba8a127$var$_final) $7ef85a594ba8a127$var$_final.call(this);
}
$7ef85a594ba8a127$var$Transform.prototype._final = $7ef85a594ba8a127$var$_final;
$7ef85a594ba8a127$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $7ef85a594ba8a127$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$7ef85a594ba8a127$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$7ef85a594ba8a127$var$kCallback] = callback;
    });
};
$7ef85a594ba8a127$var$Transform.prototype._read = function() {
    if (this[$7ef85a594ba8a127$var$kCallback]) {
        var callback = this[$7ef85a594ba8a127$var$kCallback];
        this[$7ef85a594ba8a127$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("9UwPA", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2LuAg = parcelRequire("2LuAg");
var $7372cf946238a67e$var$ArrayPrototypePop = $2LuAg.ArrayPrototypePop, $7372cf946238a67e$var$Promise = $2LuAg.Promise;

var $4nXXr = parcelRequire("4nXXr");
var $7372cf946238a67e$var$isIterable = $4nXXr.isIterable, $7372cf946238a67e$var$isNodeStream = $4nXXr.isNodeStream, $7372cf946238a67e$var$isWebStream = $4nXXr.isWebStream;

var $g8kIa = parcelRequire("g8kIa");
var $7372cf946238a67e$var$pl = $g8kIa.pipelineImpl;

var $hbj9O = parcelRequire("hbj9O");
var $7372cf946238a67e$require$finished = $hbj9O.finished;
parcelRequire("fOikn");
function $7372cf946238a67e$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $7372cf946238a67e$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$7372cf946238a67e$var$isNodeStream(lastArg) && !$7372cf946238a67e$var$isIterable(lastArg) && !$7372cf946238a67e$var$isWebStream(lastArg)) {
            var options = $7372cf946238a67e$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $7372cf946238a67e$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $7372cf946238a67e$require$finished,
    pipeline: $7372cf946238a67e$var$pipeline
};

});



parcelRegister("3Ywen", function(module, exports) {

var $hefIh = parcelRequire("hefIh");
var $2e4ffa1952c3bfb6$require$Buffer = $hefIh.Buffer;
// Named constants with unique integer values
var $2e4ffa1952c3bfb6$var$C = {};
// Tokens
var $2e4ffa1952c3bfb6$var$LEFT_BRACE = $2e4ffa1952c3bfb6$var$C.LEFT_BRACE = 0x1;
var $2e4ffa1952c3bfb6$var$RIGHT_BRACE = $2e4ffa1952c3bfb6$var$C.RIGHT_BRACE = 0x2;
var $2e4ffa1952c3bfb6$var$LEFT_BRACKET = $2e4ffa1952c3bfb6$var$C.LEFT_BRACKET = 0x3;
var $2e4ffa1952c3bfb6$var$RIGHT_BRACKET = $2e4ffa1952c3bfb6$var$C.RIGHT_BRACKET = 0x4;
var $2e4ffa1952c3bfb6$var$COLON = $2e4ffa1952c3bfb6$var$C.COLON = 0x5;
var $2e4ffa1952c3bfb6$var$COMMA = $2e4ffa1952c3bfb6$var$C.COMMA = 0x6;
var $2e4ffa1952c3bfb6$var$TRUE = $2e4ffa1952c3bfb6$var$C.TRUE = 0x7;
var $2e4ffa1952c3bfb6$var$FALSE = $2e4ffa1952c3bfb6$var$C.FALSE = 0x8;
var $2e4ffa1952c3bfb6$var$NULL = $2e4ffa1952c3bfb6$var$C.NULL = 0x9;
var $2e4ffa1952c3bfb6$var$STRING = $2e4ffa1952c3bfb6$var$C.STRING = 0xa;
var $2e4ffa1952c3bfb6$var$NUMBER = $2e4ffa1952c3bfb6$var$C.NUMBER = 0xb;
// Tokenizer States
var $2e4ffa1952c3bfb6$var$START = $2e4ffa1952c3bfb6$var$C.START = 0x11;
var $2e4ffa1952c3bfb6$var$STOP = $2e4ffa1952c3bfb6$var$C.STOP = 0x12;
var $2e4ffa1952c3bfb6$var$TRUE1 = $2e4ffa1952c3bfb6$var$C.TRUE1 = 0x21;
var $2e4ffa1952c3bfb6$var$TRUE2 = $2e4ffa1952c3bfb6$var$C.TRUE2 = 0x22;
var $2e4ffa1952c3bfb6$var$TRUE3 = $2e4ffa1952c3bfb6$var$C.TRUE3 = 0x23;
var $2e4ffa1952c3bfb6$var$FALSE1 = $2e4ffa1952c3bfb6$var$C.FALSE1 = 0x31;
var $2e4ffa1952c3bfb6$var$FALSE2 = $2e4ffa1952c3bfb6$var$C.FALSE2 = 0x32;
var $2e4ffa1952c3bfb6$var$FALSE3 = $2e4ffa1952c3bfb6$var$C.FALSE3 = 0x33;
var $2e4ffa1952c3bfb6$var$FALSE4 = $2e4ffa1952c3bfb6$var$C.FALSE4 = 0x34;
var $2e4ffa1952c3bfb6$var$NULL1 = $2e4ffa1952c3bfb6$var$C.NULL1 = 0x41;
var $2e4ffa1952c3bfb6$var$NULL2 = $2e4ffa1952c3bfb6$var$C.NULL2 = 0x42;
var $2e4ffa1952c3bfb6$var$NULL3 = $2e4ffa1952c3bfb6$var$C.NULL3 = 0x43;
var $2e4ffa1952c3bfb6$var$NUMBER1 = $2e4ffa1952c3bfb6$var$C.NUMBER1 = 0x51;
var $2e4ffa1952c3bfb6$var$NUMBER3 = $2e4ffa1952c3bfb6$var$C.NUMBER3 = 0x53;
var $2e4ffa1952c3bfb6$var$STRING1 = $2e4ffa1952c3bfb6$var$C.STRING1 = 0x61;
var $2e4ffa1952c3bfb6$var$STRING2 = $2e4ffa1952c3bfb6$var$C.STRING2 = 0x62;
var $2e4ffa1952c3bfb6$var$STRING3 = $2e4ffa1952c3bfb6$var$C.STRING3 = 0x63;
var $2e4ffa1952c3bfb6$var$STRING4 = $2e4ffa1952c3bfb6$var$C.STRING4 = 0x64;
var $2e4ffa1952c3bfb6$var$STRING5 = $2e4ffa1952c3bfb6$var$C.STRING5 = 0x65;
var $2e4ffa1952c3bfb6$var$STRING6 = $2e4ffa1952c3bfb6$var$C.STRING6 = 0x66;
// Parser States
var $2e4ffa1952c3bfb6$var$VALUE = $2e4ffa1952c3bfb6$var$C.VALUE = 0x71;
var $2e4ffa1952c3bfb6$var$KEY = $2e4ffa1952c3bfb6$var$C.KEY = 0x72;
// Parser Modes
var $2e4ffa1952c3bfb6$var$OBJECT = $2e4ffa1952c3bfb6$var$C.OBJECT = 0x81;
var $2e4ffa1952c3bfb6$var$ARRAY = $2e4ffa1952c3bfb6$var$C.ARRAY = 0x82;
// Character constants
var $2e4ffa1952c3bfb6$var$BACK_SLASH = "\\".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$FORWARD_SLASH = "\/".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$BACKSPACE = "\b".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$FORM_FEED = "\f".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$NEWLINE = "\n".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$CARRIAGE_RETURN = "\r".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$TAB = "\t".charCodeAt(0);
var $2e4ffa1952c3bfb6$var$STRING_BUFFER_SIZE = 65536;
function $2e4ffa1952c3bfb6$var$alloc(size) {
    return $2e4ffa1952c3bfb6$require$Buffer.alloc ? $2e4ffa1952c3bfb6$require$Buffer.alloc(size) : new $2e4ffa1952c3bfb6$require$Buffer(size);
}
function $2e4ffa1952c3bfb6$var$Parser() {
    this.tState = $2e4ffa1952c3bfb6$var$START;
    this.value = undefined;
    this.string = undefined; // string data
    this.stringBuffer = $2e4ffa1952c3bfb6$var$alloc($2e4ffa1952c3bfb6$var$STRING_BUFFER_SIZE);
    this.stringBufferOffset = 0;
    this.unicode = undefined; // unicode escapes
    this.highSurrogate = undefined;
    this.key = undefined;
    this.mode = undefined;
    this.stack = [];
    this.state = $2e4ffa1952c3bfb6$var$VALUE;
    this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
    this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
    this.temp_buffs = {
        "2": $2e4ffa1952c3bfb6$var$alloc(2),
        "3": $2e4ffa1952c3bfb6$var$alloc(3),
        "4": $2e4ffa1952c3bfb6$var$alloc(4)
    }; // for rebuilding chars split before boundary is reached
    // Stream offset
    this.offset = -1;
}
// Slow code to string converter (only used when throwing syntax errors)
$2e4ffa1952c3bfb6$var$Parser.toknam = function(code) {
    var keys = Object.keys($2e4ffa1952c3bfb6$var$C);
    for(var i = 0, l = keys.length; i < l; i++){
        var key = keys[i];
        if ($2e4ffa1952c3bfb6$var$C[key] === code) return key;
    }
    return code && "0x" + code.toString(16);
};
var $2e4ffa1952c3bfb6$var$proto = $2e4ffa1952c3bfb6$var$Parser.prototype;
$2e4ffa1952c3bfb6$var$proto.onError = function(err) {
    throw err;
};
$2e4ffa1952c3bfb6$var$proto.charError = function(buffer, i) {
    this.tState = $2e4ffa1952c3bfb6$var$STOP;
    this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + $2e4ffa1952c3bfb6$var$Parser.toknam(this.tState)));
};
$2e4ffa1952c3bfb6$var$proto.appendStringChar = function(_char) {
    if (this.stringBufferOffset >= $2e4ffa1952c3bfb6$var$STRING_BUFFER_SIZE) {
        this.string += this.stringBuffer.toString('utf8');
        this.stringBufferOffset = 0;
    }
    this.stringBuffer[this.stringBufferOffset++] = _char;
};
$2e4ffa1952c3bfb6$var$proto.appendStringBuf = function(buf, start, end) {
    var size = buf.length;
    if (typeof start === 'number') {
        if (typeof end === 'number') {
            if (end < 0) // adding a negative end decreeses the size
            size = buf.length - start + end;
            else size = end - start;
        } else size = buf.length - start;
    }
    if (size < 0) size = 0;
    if (this.stringBufferOffset + size > $2e4ffa1952c3bfb6$var$STRING_BUFFER_SIZE) {
        this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
        this.stringBufferOffset = 0;
    }
    buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
    this.stringBufferOffset += size;
};
$2e4ffa1952c3bfb6$var$proto.write = function(buffer) {
    if (typeof buffer === "string") buffer = new $2e4ffa1952c3bfb6$require$Buffer(buffer);
    var n;
    for(var i = 0, l = buffer.length; i < l; i++){
        if (this.tState === $2e4ffa1952c3bfb6$var$START) {
            n = buffer[i];
            this.offset++;
            if (n === 0x7b) this.onToken($2e4ffa1952c3bfb6$var$LEFT_BRACE, "{"); // {
            else if (n === 0x7d) this.onToken($2e4ffa1952c3bfb6$var$RIGHT_BRACE, "}"); // }
            else if (n === 0x5b) this.onToken($2e4ffa1952c3bfb6$var$LEFT_BRACKET, "["); // [
            else if (n === 0x5d) this.onToken($2e4ffa1952c3bfb6$var$RIGHT_BRACKET, "]"); // ]
            else if (n === 0x3a) this.onToken($2e4ffa1952c3bfb6$var$COLON, ":"); // :
            else if (n === 0x2c) this.onToken($2e4ffa1952c3bfb6$var$COMMA, ","); // ,
            else if (n === 0x74) this.tState = $2e4ffa1952c3bfb6$var$TRUE1; // t
            else if (n === 0x66) this.tState = $2e4ffa1952c3bfb6$var$FALSE1; // f
            else if (n === 0x6e) this.tState = $2e4ffa1952c3bfb6$var$NULL1; // n
            else if (n === 0x22) {
                this.string = "";
                this.stringBufferOffset = 0;
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x2d) {
                this.string = "-";
                this.tState = $2e4ffa1952c3bfb6$var$NUMBER1; // -
            } else {
                if (n >= 0x30 && n < 0x40) {
                    this.string = String.fromCharCode(n);
                    this.tState = $2e4ffa1952c3bfb6$var$NUMBER3;
                } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ;
                else return this.charError(buffer, i);
            }
        } else if (this.tState === $2e4ffa1952c3bfb6$var$STRING1) {
            n = buffer[i]; // get current byte from buffer
            // check for carry over of a multi byte char split between data chunks
            // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
            if (this.bytes_remaining > 0) {
                for(var j = 0; j < this.bytes_remaining; j++)this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
                this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
                this.bytes_in_sequence = this.bytes_remaining = 0;
                i = i + j - 1;
            } else if (this.bytes_remaining === 0 && n >= 128) {
                if (n <= 193 || n > 244) return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + $2e4ffa1952c3bfb6$var$Parser.toknam(this.tState)));
                if (n >= 194 && n <= 223) this.bytes_in_sequence = 2;
                if (n >= 224 && n <= 239) this.bytes_in_sequence = 3;
                if (n >= 240 && n <= 244) this.bytes_in_sequence = 4;
                if (this.bytes_in_sequence + i > buffer.length) {
                    for(var k = 0; k <= buffer.length - 1 - i; k++)this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
                    this.bytes_remaining = i + this.bytes_in_sequence - buffer.length;
                    i = buffer.length - 1;
                } else {
                    this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
                    i = i + this.bytes_in_sequence - 1;
                }
            } else if (n === 0x22) {
                this.tState = $2e4ffa1952c3bfb6$var$START;
                this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
                this.stringBufferOffset = 0;
                this.onToken($2e4ffa1952c3bfb6$var$STRING, this.string);
                this.offset += $2e4ffa1952c3bfb6$require$Buffer.byteLength(this.string, 'utf8') + 1;
                this.string = undefined;
            } else if (n === 0x5c) this.tState = $2e4ffa1952c3bfb6$var$STRING2;
            else if (n >= 0x20) this.appendStringChar(n);
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$STRING2) {
            n = buffer[i];
            if (n === 0x22) {
                this.appendStringChar(n);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x5c) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$BACK_SLASH);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x2f) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$FORWARD_SLASH);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x62) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$BACKSPACE);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x66) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$FORM_FEED);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x6e) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$NEWLINE);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x72) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$CARRIAGE_RETURN);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x74) {
                this.appendStringChar($2e4ffa1952c3bfb6$var$TAB);
                this.tState = $2e4ffa1952c3bfb6$var$STRING1;
            } else if (n === 0x75) {
                this.unicode = "";
                this.tState = $2e4ffa1952c3bfb6$var$STRING3;
            } else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$STRING3 || this.tState === $2e4ffa1952c3bfb6$var$STRING4 || this.tState === $2e4ffa1952c3bfb6$var$STRING5 || this.tState === $2e4ffa1952c3bfb6$var$STRING6) {
            n = buffer[i];
            // 0-9 A-F a-f
            if (n >= 0x30 && n < 0x40 || n > 0x40 && n <= 0x46 || n > 0x60 && n <= 0x66) {
                this.unicode += String.fromCharCode(n);
                if (this.tState++ === $2e4ffa1952c3bfb6$var$STRING6) {
                    var intVal = parseInt(this.unicode, 16);
                    this.unicode = undefined;
                    if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < 57344) {
                        this.appendStringBuf(new $2e4ffa1952c3bfb6$require$Buffer(String.fromCharCode(this.highSurrogate, intVal)));
                        this.highSurrogate = undefined;
                    } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < 56320) this.highSurrogate = intVal;
                    else {
                        if (this.highSurrogate !== undefined) {
                            this.appendStringBuf(new $2e4ffa1952c3bfb6$require$Buffer(String.fromCharCode(this.highSurrogate)));
                            this.highSurrogate = undefined;
                        }
                        this.appendStringBuf(new $2e4ffa1952c3bfb6$require$Buffer(String.fromCharCode(intVal)));
                    }
                    this.tState = $2e4ffa1952c3bfb6$var$STRING1;
                }
            } else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$NUMBER1 || this.tState === $2e4ffa1952c3bfb6$var$NUMBER3) {
            n = buffer[i];
            switch(n){
                case 0x30:
                case 0x31:
                case 0x32:
                case 0x33:
                case 0x34:
                case 0x35:
                case 0x36:
                case 0x37:
                case 0x38:
                case 0x39:
                case 0x2e:
                case 0x65:
                case 0x45:
                case 0x2b:
                case 0x2d:
                    this.string += String.fromCharCode(n);
                    this.tState = $2e4ffa1952c3bfb6$var$NUMBER3;
                    break;
                default:
                    this.tState = $2e4ffa1952c3bfb6$var$START;
                    var error = this.numberReviver(this.string, buffer, i);
                    if (error) return error;
                    this.offset += this.string.length - 1;
                    this.string = undefined;
                    i--;
                    break;
            }
        } else if (this.tState === $2e4ffa1952c3bfb6$var$TRUE1) {
            if (buffer[i] === 0x72) this.tState = $2e4ffa1952c3bfb6$var$TRUE2;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$TRUE2) {
            if (buffer[i] === 0x75) this.tState = $2e4ffa1952c3bfb6$var$TRUE3;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$TRUE3) {
            if (buffer[i] === 0x65) {
                this.tState = $2e4ffa1952c3bfb6$var$START;
                this.onToken($2e4ffa1952c3bfb6$var$TRUE, true);
                this.offset += 3;
            } else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$FALSE1) {
            if (buffer[i] === 0x61) this.tState = $2e4ffa1952c3bfb6$var$FALSE2;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$FALSE2) {
            if (buffer[i] === 0x6c) this.tState = $2e4ffa1952c3bfb6$var$FALSE3;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$FALSE3) {
            if (buffer[i] === 0x73) this.tState = $2e4ffa1952c3bfb6$var$FALSE4;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$FALSE4) {
            if (buffer[i] === 0x65) {
                this.tState = $2e4ffa1952c3bfb6$var$START;
                this.onToken($2e4ffa1952c3bfb6$var$FALSE, false);
                this.offset += 4;
            } else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$NULL1) {
            if (buffer[i] === 0x75) this.tState = $2e4ffa1952c3bfb6$var$NULL2;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$NULL2) {
            if (buffer[i] === 0x6c) this.tState = $2e4ffa1952c3bfb6$var$NULL3;
            else return this.charError(buffer, i);
        } else if (this.tState === $2e4ffa1952c3bfb6$var$NULL3) {
            if (buffer[i] === 0x6c) {
                this.tState = $2e4ffa1952c3bfb6$var$START;
                this.onToken($2e4ffa1952c3bfb6$var$NULL, null);
                this.offset += 3;
            } else return this.charError(buffer, i);
        }
    }
};
$2e4ffa1952c3bfb6$var$proto.onToken = function(token, value) {
// Override this to get events
};
$2e4ffa1952c3bfb6$var$proto.parseError = function(token, value) {
    this.tState = $2e4ffa1952c3bfb6$var$STOP;
    this.onError(new Error("Unexpected " + $2e4ffa1952c3bfb6$var$Parser.toknam(token) + (value ? "(" + JSON.stringify(value) + ")" : "") + " in state " + $2e4ffa1952c3bfb6$var$Parser.toknam(this.state)));
};
$2e4ffa1952c3bfb6$var$proto.push = function() {
    this.stack.push({
        value: this.value,
        key: this.key,
        mode: this.mode
    });
};
$2e4ffa1952c3bfb6$var$proto.pop = function() {
    var value = this.value;
    var parent = this.stack.pop();
    this.value = parent.value;
    this.key = parent.key;
    this.mode = parent.mode;
    this.emit(value);
    if (!this.mode) this.state = $2e4ffa1952c3bfb6$var$VALUE;
};
$2e4ffa1952c3bfb6$var$proto.emit = function(value) {
    if (this.mode) this.state = $2e4ffa1952c3bfb6$var$COMMA;
    this.onValue(value);
};
$2e4ffa1952c3bfb6$var$proto.onValue = function(value) {
// Override me
};
$2e4ffa1952c3bfb6$var$proto.onToken = function(token, value) {
    if (this.state === $2e4ffa1952c3bfb6$var$VALUE) {
        if (token === $2e4ffa1952c3bfb6$var$STRING || token === $2e4ffa1952c3bfb6$var$NUMBER || token === $2e4ffa1952c3bfb6$var$TRUE || token === $2e4ffa1952c3bfb6$var$FALSE || token === $2e4ffa1952c3bfb6$var$NULL) {
            if (this.value) this.value[this.key] = value;
            this.emit(value);
        } else if (token === $2e4ffa1952c3bfb6$var$LEFT_BRACE) {
            this.push();
            if (this.value) this.value = this.value[this.key] = {};
            else this.value = {};
            this.key = undefined;
            this.state = $2e4ffa1952c3bfb6$var$KEY;
            this.mode = $2e4ffa1952c3bfb6$var$OBJECT;
        } else if (token === $2e4ffa1952c3bfb6$var$LEFT_BRACKET) {
            this.push();
            if (this.value) this.value = this.value[this.key] = [];
            else this.value = [];
            this.key = 0;
            this.mode = $2e4ffa1952c3bfb6$var$ARRAY;
            this.state = $2e4ffa1952c3bfb6$var$VALUE;
        } else if (token === $2e4ffa1952c3bfb6$var$RIGHT_BRACE) {
            if (this.mode === $2e4ffa1952c3bfb6$var$OBJECT) this.pop();
            else return this.parseError(token, value);
        } else if (token === $2e4ffa1952c3bfb6$var$RIGHT_BRACKET) {
            if (this.mode === $2e4ffa1952c3bfb6$var$ARRAY) this.pop();
            else return this.parseError(token, value);
        } else return this.parseError(token, value);
    } else if (this.state === $2e4ffa1952c3bfb6$var$KEY) {
        if (token === $2e4ffa1952c3bfb6$var$STRING) {
            this.key = value;
            this.state = $2e4ffa1952c3bfb6$var$COLON;
        } else if (token === $2e4ffa1952c3bfb6$var$RIGHT_BRACE) this.pop();
        else return this.parseError(token, value);
    } else if (this.state === $2e4ffa1952c3bfb6$var$COLON) {
        if (token === $2e4ffa1952c3bfb6$var$COLON) this.state = $2e4ffa1952c3bfb6$var$VALUE;
        else return this.parseError(token, value);
    } else if (this.state === $2e4ffa1952c3bfb6$var$COMMA) {
        if (token === $2e4ffa1952c3bfb6$var$COMMA) {
            if (this.mode === $2e4ffa1952c3bfb6$var$ARRAY) {
                this.key++;
                this.state = $2e4ffa1952c3bfb6$var$VALUE;
            } else if (this.mode === $2e4ffa1952c3bfb6$var$OBJECT) this.state = $2e4ffa1952c3bfb6$var$KEY;
        } else if (token === $2e4ffa1952c3bfb6$var$RIGHT_BRACKET && this.mode === $2e4ffa1952c3bfb6$var$ARRAY || token === $2e4ffa1952c3bfb6$var$RIGHT_BRACE && this.mode === $2e4ffa1952c3bfb6$var$OBJECT) this.pop();
        else return this.parseError(token, value);
    } else return this.parseError(token, value);
};
// Override to implement your own number reviver.
// Any value returned is treated as error and will interrupt parsing.
$2e4ffa1952c3bfb6$var$proto.numberReviver = function(text, buffer, i) {
    var result = Number(text);
    if (isNaN(result)) return this.charError(buffer, i);
    if (text.match(/[0-9]+/) == text && result.toString() != text) // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
    this.onToken($2e4ffa1952c3bfb6$var$STRING, text);
    else this.onToken($2e4ffa1952c3bfb6$var$NUMBER, result);
};
$2e4ffa1952c3bfb6$var$Parser.C = $2e4ffa1952c3bfb6$var$C;
module.exports = $2e4ffa1952c3bfb6$var$Parser;

});
parcelRegister("hefIh", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c8afeec92b2daa9b$export$a143d493d941bafc; }, function (v) { return $c8afeec92b2daa9b$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c8afeec92b2daa9b$export$f99ded8fe4b79145; }, function (v) { return $c8afeec92b2daa9b$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $c8afeec92b2daa9b$export$a143d493d941bafc;
var $c8afeec92b2daa9b$export$e4cf37d7f6fb9e0a;
var $c8afeec92b2daa9b$export$f99ded8fe4b79145;
var $c8afeec92b2daa9b$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $c8afeec92b2daa9b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c8afeec92b2daa9b$export$a143d493d941bafc = $c8afeec92b2daa9b$var$Buffer;
$c8afeec92b2daa9b$export$e4cf37d7f6fb9e0a = $c8afeec92b2daa9b$var$SlowBuffer;
$c8afeec92b2daa9b$export$f99ded8fe4b79145 = 50;
var $c8afeec92b2daa9b$var$K_MAX_LENGTH = 0x7fffffff;
$c8afeec92b2daa9b$export$599f31c3813fae4d = $c8afeec92b2daa9b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c8afeec92b2daa9b$var$Buffer.TYPED_ARRAY_SUPPORT = $c8afeec92b2daa9b$var$typedArraySupport();
if (!$c8afeec92b2daa9b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c8afeec92b2daa9b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c8afeec92b2daa9b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c8afeec92b2daa9b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c8afeec92b2daa9b$var$createBuffer(length) {
    if (length > $c8afeec92b2daa9b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c8afeec92b2daa9b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c8afeec92b2daa9b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c8afeec92b2daa9b$var$allocUnsafe(arg);
    }
    return $c8afeec92b2daa9b$var$from(arg, encodingOrOffset, length);
}
$c8afeec92b2daa9b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c8afeec92b2daa9b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c8afeec92b2daa9b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c8afeec92b2daa9b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($c8afeec92b2daa9b$var$isInstance(value, ArrayBuffer) || value && $c8afeec92b2daa9b$var$isInstance(value.buffer, ArrayBuffer)) return $c8afeec92b2daa9b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c8afeec92b2daa9b$var$isInstance(value, SharedArrayBuffer) || value && $c8afeec92b2daa9b$var$isInstance(value.buffer, SharedArrayBuffer))) return $c8afeec92b2daa9b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c8afeec92b2daa9b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c8afeec92b2daa9b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c8afeec92b2daa9b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c8afeec92b2daa9b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c8afeec92b2daa9b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c8afeec92b2daa9b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c8afeec92b2daa9b$var$Buffer, Uint8Array);
function $c8afeec92b2daa9b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c8afeec92b2daa9b$var$alloc(size, fill, encoding) {
    $c8afeec92b2daa9b$var$assertSize(size);
    if (size <= 0) return $c8afeec92b2daa9b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c8afeec92b2daa9b$var$createBuffer(size).fill(fill, encoding) : $c8afeec92b2daa9b$var$createBuffer(size).fill(fill);
    return $c8afeec92b2daa9b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c8afeec92b2daa9b$var$Buffer.alloc = function(size, fill, encoding) {
    return $c8afeec92b2daa9b$var$alloc(size, fill, encoding);
};
function $c8afeec92b2daa9b$var$allocUnsafe(size) {
    $c8afeec92b2daa9b$var$assertSize(size);
    return $c8afeec92b2daa9b$var$createBuffer(size < 0 ? 0 : $c8afeec92b2daa9b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c8afeec92b2daa9b$var$Buffer.allocUnsafe = function(size) {
    return $c8afeec92b2daa9b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c8afeec92b2daa9b$var$Buffer.allocUnsafeSlow = function(size) {
    return $c8afeec92b2daa9b$var$allocUnsafe(size);
};
function $c8afeec92b2daa9b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c8afeec92b2daa9b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $c8afeec92b2daa9b$var$byteLength(string, encoding) | 0;
    var buf = $c8afeec92b2daa9b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c8afeec92b2daa9b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c8afeec92b2daa9b$var$checked(array.length) | 0;
    var buf = $c8afeec92b2daa9b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c8afeec92b2daa9b$var$fromArrayView(arrayView) {
    if ($c8afeec92b2daa9b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c8afeec92b2daa9b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c8afeec92b2daa9b$var$fromArrayLike(arrayView);
}
function $c8afeec92b2daa9b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c8afeec92b2daa9b$var$Buffer.prototype);
    return buf;
}
function $c8afeec92b2daa9b$var$fromObject(obj) {
    if ($c8afeec92b2daa9b$var$Buffer.isBuffer(obj)) {
        var len = $c8afeec92b2daa9b$var$checked(obj.length) | 0;
        var buf = $c8afeec92b2daa9b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c8afeec92b2daa9b$var$numberIsNaN(obj.length)) return $c8afeec92b2daa9b$var$createBuffer(0);
        return $c8afeec92b2daa9b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c8afeec92b2daa9b$var$fromArrayLike(obj.data);
}
function $c8afeec92b2daa9b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c8afeec92b2daa9b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c8afeec92b2daa9b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c8afeec92b2daa9b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c8afeec92b2daa9b$var$Buffer.alloc(+length);
}
$c8afeec92b2daa9b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c8afeec92b2daa9b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c8afeec92b2daa9b$var$Buffer.compare = function compare(a, b) {
    if ($c8afeec92b2daa9b$var$isInstance(a, Uint8Array)) a = $c8afeec92b2daa9b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c8afeec92b2daa9b$var$isInstance(b, Uint8Array)) b = $c8afeec92b2daa9b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(a) || !$c8afeec92b2daa9b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c8afeec92b2daa9b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c8afeec92b2daa9b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c8afeec92b2daa9b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c8afeec92b2daa9b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c8afeec92b2daa9b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(buf)) buf = $c8afeec92b2daa9b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c8afeec92b2daa9b$var$byteLength(string, encoding) {
    if ($c8afeec92b2daa9b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c8afeec92b2daa9b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c8afeec92b2daa9b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c8afeec92b2daa9b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c8afeec92b2daa9b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c8afeec92b2daa9b$var$Buffer.byteLength = $c8afeec92b2daa9b$var$byteLength;
function $c8afeec92b2daa9b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c8afeec92b2daa9b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c8afeec92b2daa9b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c8afeec92b2daa9b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c8afeec92b2daa9b$var$latin1Slice(this, start, end);
        case 'base64':
            return $c8afeec92b2daa9b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c8afeec92b2daa9b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c8afeec92b2daa9b$var$Buffer.prototype._isBuffer = true;
function $c8afeec92b2daa9b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c8afeec92b2daa9b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$c8afeec92b2daa9b$var$swap(this, i, i + 1);
    return this;
};
$c8afeec92b2daa9b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $c8afeec92b2daa9b$var$swap(this, i, i + 3);
        $c8afeec92b2daa9b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c8afeec92b2daa9b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $c8afeec92b2daa9b$var$swap(this, i, i + 7);
        $c8afeec92b2daa9b$var$swap(this, i + 1, i + 6);
        $c8afeec92b2daa9b$var$swap(this, i + 2, i + 5);
        $c8afeec92b2daa9b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c8afeec92b2daa9b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c8afeec92b2daa9b$var$utf8Slice(this, 0, length);
    return $c8afeec92b2daa9b$var$slowToString.apply(this, arguments);
};
$c8afeec92b2daa9b$var$Buffer.prototype.toLocaleString = $c8afeec92b2daa9b$var$Buffer.prototype.toString;
$c8afeec92b2daa9b$var$Buffer.prototype.equals = function equals(b) {
    if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c8afeec92b2daa9b$var$Buffer.compare(this, b) === 0;
};
$c8afeec92b2daa9b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $c8afeec92b2daa9b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c8afeec92b2daa9b$var$customInspectSymbol) $c8afeec92b2daa9b$var$Buffer.prototype[$c8afeec92b2daa9b$var$customInspectSymbol] = $c8afeec92b2daa9b$var$Buffer.prototype.inspect;
$c8afeec92b2daa9b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c8afeec92b2daa9b$var$isInstance(target, Uint8Array)) target = $c8afeec92b2daa9b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c8afeec92b2daa9b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c8afeec92b2daa9b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c8afeec92b2daa9b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c8afeec92b2daa9b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c8afeec92b2daa9b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c8afeec92b2daa9b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c8afeec92b2daa9b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c8afeec92b2daa9b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c8afeec92b2daa9b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c8afeec92b2daa9b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c8afeec92b2daa9b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c8afeec92b2daa9b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c8afeec92b2daa9b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c8afeec92b2daa9b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c8afeec92b2daa9b$var$utf8Write(buf, string, offset, length) {
    return $c8afeec92b2daa9b$var$blitBuffer($c8afeec92b2daa9b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c8afeec92b2daa9b$var$asciiWrite(buf, string, offset, length) {
    return $c8afeec92b2daa9b$var$blitBuffer($c8afeec92b2daa9b$var$asciiToBytes(string), buf, offset, length);
}
function $c8afeec92b2daa9b$var$base64Write(buf, string, offset, length) {
    return $c8afeec92b2daa9b$var$blitBuffer($c8afeec92b2daa9b$var$base64ToBytes(string), buf, offset, length);
}
function $c8afeec92b2daa9b$var$ucs2Write(buf, string, offset, length) {
    return $c8afeec92b2daa9b$var$blitBuffer($c8afeec92b2daa9b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c8afeec92b2daa9b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c8afeec92b2daa9b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c8afeec92b2daa9b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c8afeec92b2daa9b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c8afeec92b2daa9b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c8afeec92b2daa9b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c8afeec92b2daa9b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c8afeec92b2daa9b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $c8afeec92b2daa9b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c8afeec92b2daa9b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c8afeec92b2daa9b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c8afeec92b2daa9b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c8afeec92b2daa9b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c8afeec92b2daa9b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c8afeec92b2daa9b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c8afeec92b2daa9b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c8afeec92b2daa9b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $c8afeec92b2daa9b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c8afeec92b2daa9b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c8afeec92b2daa9b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c8afeec92b2daa9b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c8afeec92b2daa9b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c8afeec92b2daa9b$var$Buffer.prototype.readUintLE = $c8afeec92b2daa9b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUintBE = $c8afeec92b2daa9b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUint8 = $c8afeec92b2daa9b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUint16LE = $c8afeec92b2daa9b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUint16BE = $c8afeec92b2daa9b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUint32LE = $c8afeec92b2daa9b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readUint32BE = $c8afeec92b2daa9b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c8afeec92b2daa9b$var$Buffer.prototype.readBigUInt64LE = $c8afeec92b2daa9b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c8afeec92b2daa9b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c8afeec92b2daa9b$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c8afeec92b2daa9b$var$Buffer.prototype.readBigUInt64BE = $c8afeec92b2daa9b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c8afeec92b2daa9b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c8afeec92b2daa9b$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c8afeec92b2daa9b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c8afeec92b2daa9b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c8afeec92b2daa9b$var$Buffer.prototype.readBigInt64LE = $c8afeec92b2daa9b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c8afeec92b2daa9b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c8afeec92b2daa9b$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$c8afeec92b2daa9b$var$Buffer.prototype.readBigInt64BE = $c8afeec92b2daa9b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c8afeec92b2daa9b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c8afeec92b2daa9b$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$c8afeec92b2daa9b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$c8afeec92b2daa9b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$c8afeec92b2daa9b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$c8afeec92b2daa9b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $c8afeec92b2daa9b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c8afeec92b2daa9b$var$Buffer.prototype.writeUintLE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c8afeec92b2daa9b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUintBE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c8afeec92b2daa9b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUint8 = $c8afeec92b2daa9b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUint16LE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUint16BE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUint32LE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeUint32BE = $c8afeec92b2daa9b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c8afeec92b2daa9b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c8afeec92b2daa9b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c8afeec92b2daa9b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c8afeec92b2daa9b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c8afeec92b2daa9b$var$Buffer.prototype.writeBigUInt64LE = $c8afeec92b2daa9b$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c8afeec92b2daa9b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c8afeec92b2daa9b$var$Buffer.prototype.writeBigUInt64BE = $c8afeec92b2daa9b$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c8afeec92b2daa9b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c8afeec92b2daa9b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c8afeec92b2daa9b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c8afeec92b2daa9b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeBigInt64LE = $c8afeec92b2daa9b$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c8afeec92b2daa9b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c8afeec92b2daa9b$var$Buffer.prototype.writeBigInt64BE = $c8afeec92b2daa9b$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c8afeec92b2daa9b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c8afeec92b2daa9b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c8afeec92b2daa9b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c8afeec92b2daa9b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c8afeec92b2daa9b$var$writeFloat(this, value, offset, true, noAssert);
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c8afeec92b2daa9b$var$writeFloat(this, value, offset, false, noAssert);
};
function $c8afeec92b2daa9b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c8afeec92b2daa9b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c8afeec92b2daa9b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c8afeec92b2daa9b$var$writeDouble(this, value, offset, true, noAssert);
};
$c8afeec92b2daa9b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c8afeec92b2daa9b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c8afeec92b2daa9b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c8afeec92b2daa9b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c8afeec92b2daa9b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c8afeec92b2daa9b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c8afeec92b2daa9b$var$Buffer.isBuffer(val) ? val : $c8afeec92b2daa9b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $c8afeec92b2daa9b$var$errors = {};
function $c8afeec92b2daa9b$var$E(sym, getMessage, Base) {
    $c8afeec92b2daa9b$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$c8afeec92b2daa9b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c8afeec92b2daa9b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$c8afeec92b2daa9b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $c8afeec92b2daa9b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $c8afeec92b2daa9b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $c8afeec92b2daa9b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $c8afeec92b2daa9b$var$checkBounds(buf, offset, byteLength) {
    $c8afeec92b2daa9b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c8afeec92b2daa9b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c8afeec92b2daa9b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $c8afeec92b2daa9b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c8afeec92b2daa9b$var$checkBounds(buf, offset, byteLength);
}
function $c8afeec92b2daa9b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c8afeec92b2daa9b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c8afeec92b2daa9b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c8afeec92b2daa9b$var$validateNumber(value, type);
        throw new $c8afeec92b2daa9b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c8afeec92b2daa9b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c8afeec92b2daa9b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $c8afeec92b2daa9b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c8afeec92b2daa9b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c8afeec92b2daa9b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c8afeec92b2daa9b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c8afeec92b2daa9b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c8afeec92b2daa9b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c8afeec92b2daa9b$var$base64ToBytes(str) {
    return $abUaD.toByteArray($c8afeec92b2daa9b$var$base64clean(str));
}
function $c8afeec92b2daa9b$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c8afeec92b2daa9b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c8afeec92b2daa9b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c8afeec92b2daa9b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c8afeec92b2daa9b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c8afeec92b2daa9b$var$BufferBigIntNotDefined : fn;
}
function $c8afeec92b2daa9b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});








parcelRegister("ggXMo", function(module, exports) {
"use strict";
var $bd8c82ed7f18592c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd8c82ed7f18592c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bd8c82ed7f18592c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bd8c82ed7f18592c$var$__exportStar((parcelRequire("kFdah")), module.exports);

});
parcelRegister("kFdah", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorCombineUnion = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica mediator that takes the union of all actor results.
 *
 * The actors that are registered first will have priority on setting overlapping fields.
 */ var $f0b1d93fa2a5a5e2$var$MediatorCombineUnion = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorCombineUnion, _core_1_Mediator);
    function MediatorCombineUnion(args) {
        (0, $jGAMp._)(this, MediatorCombineUnion);
        var _this;
        _this = (0, $kzDuW._)(this, MediatorCombineUnion, [
            args
        ]);
        _this.combiner = _this.createCombiner();
        return _this;
    }
    (0, $byiyg._)(MediatorCombineUnion, [
        {
            key: "mediate",
            value: function mediate(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var testResults, _testResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, reply, err, sideDatas, results;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                try {
                                    testResults = this.publish(action);
                                } catch (e) {
                                    testResults = [];
                                }
                                if (!this.filterFailures) return [
                                    3,
                                    9
                                ];
                                _testResults = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = testResults[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                result = _step.value;
                                return [
                                    4,
                                    result.reply
                                ];
                            case 3:
                                reply = _state.sent();
                                if (reply.isPassed()) _testResults.push(result);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                testResults = _testResults;
                                _state.label = 9;
                            case 9:
                                // Delegate reply errors.
                                sideDatas = [];
                                return [
                                    4,
                                    Promise.all(testResults.map(function(param, i) {
                                        var reply = param.reply;
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var awaited, value;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            reply
                                                        ];
                                                    case 1:
                                                        awaited = _state.sent();
                                                        value = awaited.getOrThrow();
                                                        sideDatas[i] = awaited.getSideData();
                                                        return [
                                                            2,
                                                            value
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    4,
                                    Promise.all(testResults.map(function(result, i) {
                                        return result.actor.runObservable(action, sideDatas[i]);
                                    }))
                                ];
                            case 11:
                                results = _state.sent();
                                // Return the combined results.
                                return [
                                    2,
                                    this.combiner(results)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "mediateWith",
            value: function mediateWith() {
                throw new Error('Method not supported.');
            }
        },
        {
            key: "createCombiner",
            value: function createCombiner() {
                var _this = this;
                return function(results) {
                    var data = {};
                    data[_this.field] = {};
                    // eslint-disable-next-line unicorn/prefer-spread
                    [
                        {}
                    ].concat(results.map(function(result) {
                        return result[_this.field];
                    }))// eslint-disable-next-line unicorn/no-array-for-each
                    .forEach(function(value) {
                        data[_this.field] = (0, $iT0je._)({}, value, data[_this.field]);
                    });
                    return data;
                };
            }
        }
    ]);
    return MediatorCombineUnion;
}($kNNoa.Mediator);
module.exports.MediatorCombineUnion = $f0b1d93fa2a5a5e2$var$MediatorCombineUnion;

});


parcelRegister("ci2mP", function(module, exports) {
"use strict";
var $8f29009125f1704b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8f29009125f1704b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8f29009125f1704b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8f29009125f1704b$var$__exportStar((parcelRequire("2NE83")), module.exports);

});
parcelRegister("2NE83", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorNumber = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A mediator that can mediate over a single number field.
 *
 * It takes the required 'field' and 'type' parameters.
 * The 'field' parameter represents the field name of the test result field over which must be mediated.
 * The 'type' parameter
 */ var $209f49255507f5fe$var$MediatorNumber = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorNumber, _core_1_Mediator);
    function MediatorNumber(args) {
        (0, $jGAMp._)(this, MediatorNumber);
        var _this;
        _this = (0, $kzDuW._)(this, MediatorNumber, [
            args
        ]);
        _this.indexPicker = _this.createIndexPicker();
        return _this;
    }
    (0, $byiyg._)(MediatorNumber, [
        {
            /**
     * @return {(tests: T[]) => number} A function that returns the index of the test result
     *                                  that has been chosen by this mediator.
     */ key: "createIndexPicker",
            value: function createIndexPicker() {
                var _this = this;
                switch(this.type){
                    case 'min':
                        return function(tests) {
                            return tests.reduce(function(prev, curr, i) {
                                var val = _this.getOrDefault(curr[_this.field], Number.POSITIVE_INFINITY);
                                return val !== null && (Number.isNaN(prev[0]) || prev[0] > val) ? [
                                    val,
                                    i
                                ] : prev;
                            }, [
                                Number.NaN,
                                -1
                            ])[1];
                        };
                    case 'max':
                        return function(tests) {
                            return tests.reduce(function(prev, curr, i) {
                                var val = _this.getOrDefault(curr[_this.field], Number.NEGATIVE_INFINITY);
                                return val !== null && (Number.isNaN(prev[0]) || prev[0] < val) ? [
                                    val,
                                    i
                                ] : prev;
                            }, [
                                Number.NaN,
                                -1
                            ])[1];
                        };
                    default:
                        // eslint-disable-next-line ts/restrict-template-expressions
                        throw new Error("No valid \"type\" value was given, must be either 'min' or 'max', but got: ".concat(this.type));
                }
            }
        },
        {
            key: "getOrDefault",
            value: function getOrDefault(value, defaultValue) {
                // eslint-disable-next-line ts/prefer-nullish-coalescing
                return value === undefined ? defaultValue : value;
            }
        },
        {
            key: "mediateWith",
            value: function mediateWith(action, testResults) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var wrappedResults, failures, dummy, sideDatas, results, index;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(testResults.map(function(param) {
                                        var reply = param.reply;
                                        return reply;
                                    }))
                                ];
                            case 1:
                                wrappedResults = _state.sent();
                                // Collect failures if we want to ignore them
                                failures = [];
                                if (this.ignoreFailures) {
                                    dummy = {};
                                    dummy[this.field] = null;
                                    wrappedResults = wrappedResults.map(function(result) {
                                        if (result.isFailed()) {
                                            failures.push(result.getFailMessage());
                                            return (0, $kNNoa.passTestWithSideData)(dummy, undefined);
                                        }
                                        return result;
                                    });
                                }
                                // Resolve values
                                sideDatas = [];
                                results = wrappedResults.map(function(result, i) {
                                    var value = result.getOrThrow();
                                    sideDatas[i] = result.getSideData();
                                    return value;
                                });
                                // Determine one value
                                index = this.indexPicker(results);
                                if (index < 0) return [
                                    2,
                                    (0, $kNNoa.failTest)(this.constructFailureMessage(action, failures))
                                ];
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)(testResults[index].actor, sideDatas[index])
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return MediatorNumber;
}($kNNoa.Mediator);
module.exports.MediatorNumber = $209f49255507f5fe$var$MediatorNumber;

});


parcelRegister("l1kfs", function(module, exports) {
"use strict";
var $f4d965db1e18719d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4d965db1e18719d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4d965db1e18719d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4d965db1e18719d$var$__exportStar((parcelRequire("lNNmv")), module.exports);

});
parcelRegister("lNNmv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceFallback = void 0;

var $9wyYb = parcelRequire("9wyYb");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Fallback Dereference Actor.
 */ var $fdf476d9554a97b9$var$ActorDereferenceFallback = /*#__PURE__*/ function(_bus_dereference_1_ActorDereference) {
    (0, $i3fW3._)(ActorDereferenceFallback, _bus_dereference_1_ActorDereference);
    function ActorDereferenceFallback(args) {
        (0, $jGAMp._)(this, ActorDereferenceFallback);
        return (0, $kzDuW._)(this, ActorDereferenceFallback, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereferenceFallback, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.handleDereferenceErrors(action, new Error("Could not dereference '".concat(action.url, "'")))
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorDereferenceFallback;
}($9wyYb.ActorDereference);
module.exports.ActorDereferenceFallback = $fdf476d9554a97b9$var$ActorDereferenceFallback;

});
parcelRegister("9wyYb", function(module, exports) {
"use strict";
var $6ef23a71ecfdecc2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ef23a71ecfdecc2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ef23a71ecfdecc2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6ef23a71ecfdecc2$var$__exportStar((parcelRequire("01r2G")), module.exports);

$6ef23a71ecfdecc2$var$__exportStar((parcelRequire("73pWo")), module.exports);

$6ef23a71ecfdecc2$var$__exportStar((parcelRequire("gdNaB")), module.exports);

});
parcelRegister("01r2G", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereference = void 0;

var $gdNaB = parcelRequire("gdNaB");
/**
 * A base actor for dereferencing URLs to (generic) streams.
 *
 * Actor types:
 * * Input:  IActionDereference:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceOutput: A Readable stream
 *
 * @see IActionDereference
 * @see IActorDereferenceOutput
 */ var $00451227aa9837e9$var$ActorDereference = /*#__PURE__*/ function(_ActorDereferenceBase_1_ActorDereferenceBase) {
    (0, $i3fW3._)(ActorDereference, _ActorDereferenceBase_1_ActorDereferenceBase);
    function ActorDereference(args) {
        (0, $jGAMp._)(this, ActorDereference);
        return (0, $kzDuW._)(this, ActorDereference, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereference, [
        {
            key: "handleDereferenceErrors",
            value: /**
     * Handle the given error as a rejection or delegate it to the logger,
     * depending on whether or not hard errors are enabled.
     * @param {IActionDereference} action A dereference action.
     * @param {Error} error An error that has occurred.
     * @param headers Optional HTTP headers to pass.
     * @param {number} requestTime The time it took to request the page in milliseconds.
     * @return {Promise<IActorDereferenceOutput>} A promise that rejects or resolves to an empty output.
     */ function handleDereferenceErrors(action, error, headers) {
                var requestTime = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.dereferenceErrorHandler(action, error, {
                                url: action.url,
                                exists: false,
                                headers: headers,
                                requestTime: requestTime
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorDereference;
}($gdNaB.ActorDereferenceBase);
module.exports.ActorDereference = $00451227aa9837e9$var$ActorDereference;

});
parcelRegister("gdNaB", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceBase = module.exports.isHardError = module.exports.emptyReadable = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $7S0Kx = parcelRequire("7S0Kx");
function $bcf4006039cecbb9$var$emptyReadable() {
    var data = new $7S0Kx.Readable();
    data.push(null);
    return data;
}
module.exports.emptyReadable = $bcf4006039cecbb9$var$emptyReadable;
/**
 * Check if hard errors should occur on HTTP or parse errors.
 * @param {IActionContext} context An action context.
 * @return {boolean} If hard errors are enabled.
 */ function $bcf4006039cecbb9$var$isHardError(context) {
    return !context.get($9nBhR.KeysInitQuery.lenient);
}
module.exports.isHardError = $bcf4006039cecbb9$var$isHardError;
/**
 * A base actor for dereferencing URLs to (generic) streams.
 *
 * Actor types:
 * * Input:  IActionDereference:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceOutput: A Readable stream
 *
 * @see IActionDereference
 * @see IActorDereferenceOutput
 */ var $bcf4006039cecbb9$var$ActorDereferenceBase = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorDereferenceBase, _core_1_Actor);
    function ActorDereferenceBase(args) {
        (0, $jGAMp._)(this, ActorDereferenceBase);
        return (0, $kzDuW._)(this, ActorDereferenceBase, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereferenceBase, [
        {
            key: "dereferenceErrorHandler",
            value: /**
     * Handle the given error as a rejection or delegate it to the logger,
     * depending on whether or not hard errors are enabled.
     * @param {I} action An action.
     * @param {Error} error An error that has occurred.
     * @param {N} output Data to add to the output
     */ function dereferenceErrorHandler(action, error, output) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if ($bcf4006039cecbb9$var$isHardError(action.context)) throw error;
                        this.logWarn(action.context, error.message, function() {
                            return {
                                url: action.url
                            };
                        });
                        return [
                            2,
                            (0, $emQHU._)((0, $iT0je._)({}, output), {
                                data: $bcf4006039cecbb9$var$emptyReadable()
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorDereferenceBase;
}($kNNoa.Actor);
module.exports.ActorDereferenceBase = $bcf4006039cecbb9$var$ActorDereferenceBase;

});
parcelRegister("7S0Kx", function(module, exports) {
'use strict';

var $6ycIt = parcelRequire("6ycIt");

var $hEuiV = parcelRequire("hEuiV");
var $5bae28696f09b4bf$var$originalDestroy = $6ycIt.Readable.destroy;
module.exports = $6ycIt.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $6ycIt._uint8ArrayToBuffer;
module.exports._isUint8Array = $6ycIt._isUint8Array;
module.exports.isDisturbed = $6ycIt.isDisturbed;
module.exports.isErrored = $6ycIt.isErrored;
module.exports.isReadable = $6ycIt.isReadable;
module.exports.Readable = $6ycIt.Readable;
module.exports.Writable = $6ycIt.Writable;
module.exports.Duplex = $6ycIt.Duplex;
module.exports.Transform = $6ycIt.Transform;
module.exports.PassThrough = $6ycIt.PassThrough;
module.exports.addAbortSignal = $6ycIt.addAbortSignal;
module.exports.finished = $6ycIt.finished;
module.exports.destroy = $6ycIt.destroy;
module.exports.destroy = $5bae28696f09b4bf$var$originalDestroy;
module.exports.pipeline = $6ycIt.pipeline;
module.exports.compose = $6ycIt.compose;
Object.defineProperty($6ycIt, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $hEuiV;
    }
});
module.exports.Stream = $6ycIt.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("6ycIt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $kAHTL = parcelRequire("kAHTL");
var $4c4fc83a8e51822e$require$Buffer = $kAHTL.Buffer;

var $2QaiP = parcelRequire("2QaiP");
/* replacement end */ var $4c4fc83a8e51822e$var$ObjectDefineProperty = $2QaiP.ObjectDefineProperty, $4c4fc83a8e51822e$var$ObjectKeys = $2QaiP.ObjectKeys, $4c4fc83a8e51822e$var$ReflectApply = $2QaiP.ReflectApply;

var $9Q0vO = parcelRequire("9Q0vO");
var $4c4fc83a8e51822e$var$_require_promisify = $9Q0vO.promisify, $4c4fc83a8e51822e$var$customPromisify = $4c4fc83a8e51822e$var$_require_promisify.custom;

var $h9kvW = parcelRequire("h9kvW");
var $4c4fc83a8e51822e$var$streamReturningOperators = $h9kvW.streamReturningOperators, $4c4fc83a8e51822e$var$promiseReturningOperators = $h9kvW.promiseReturningOperators;

var $c5mlQ = parcelRequire("c5mlQ");
var $4c4fc83a8e51822e$var$ERR_ILLEGAL_CONSTRUCTOR = $c5mlQ.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $kzJuO = parcelRequire("kzJuO");

var $1vd7s = parcelRequire("1vd7s");
var $4c4fc83a8e51822e$var$setDefaultHighWaterMark = $1vd7s.setDefaultHighWaterMark, $4c4fc83a8e51822e$var$getDefaultHighWaterMark = $1vd7s.getDefaultHighWaterMark;

var $hgLi3 = parcelRequire("hgLi3");
var $4c4fc83a8e51822e$require$pipeline = $hgLi3.pipeline;

var $3xISh = parcelRequire("3xISh");
var $4c4fc83a8e51822e$require$destroyer = $3xISh.destroyer;

var $dF61N = parcelRequire("dF61N");
var $4c4fc83a8e51822e$var$internalBuffer = {};

var $hEuiV = parcelRequire("hEuiV");

var $gbI0K = parcelRequire("gbI0K");

var $4c4fc83a8e51822e$var$Stream = module.exports = (parcelRequire("aXiX3")).Stream;
$4c4fc83a8e51822e$var$Stream.isDestroyed = $gbI0K.isDestroyed;
$4c4fc83a8e51822e$var$Stream.isDisturbed = $gbI0K.isDisturbed;
$4c4fc83a8e51822e$var$Stream.isErrored = $gbI0K.isErrored;
$4c4fc83a8e51822e$var$Stream.isReadable = $gbI0K.isReadable;
$4c4fc83a8e51822e$var$Stream.isWritable = $gbI0K.isWritable;

$4c4fc83a8e51822e$var$Stream.Readable = (parcelRequire("bsrWI"));
var $4c4fc83a8e51822e$var$_iteratorNormalCompletion = true, $4c4fc83a8e51822e$var$_didIteratorError = false, $4c4fc83a8e51822e$var$_iteratorError = undefined;
try {
    for(var $4c4fc83a8e51822e$var$_iterator = $4c4fc83a8e51822e$var$ObjectKeys($4c4fc83a8e51822e$var$streamReturningOperators)[Symbol.iterator](), $4c4fc83a8e51822e$var$_step; !($4c4fc83a8e51822e$var$_iteratorNormalCompletion = ($4c4fc83a8e51822e$var$_step = $4c4fc83a8e51822e$var$_iterator.next()).done); $4c4fc83a8e51822e$var$_iteratorNormalCompletion = true){
        var $4c4fc83a8e51822e$var$key = $4c4fc83a8e51822e$var$_step.value;
        var $4c4fc83a8e51822e$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $4c4fc83a8e51822e$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $4c4fc83a8e51822e$var$Stream.Readable.from($4c4fc83a8e51822e$var$ReflectApply($4c4fc83a8e51822e$var$op, this, args));
        };
        var $4c4fc83a8e51822e$var$op = $4c4fc83a8e51822e$var$streamReturningOperators[$4c4fc83a8e51822e$var$key];
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$fn, 'name', {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$op.name
        });
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$fn, 'length', {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$op.length
        });
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$Stream.Readable.prototype, $4c4fc83a8e51822e$var$key, {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $4c4fc83a8e51822e$var$_didIteratorError = true;
    $4c4fc83a8e51822e$var$_iteratorError = err;
} finally{
    try {
        if (!$4c4fc83a8e51822e$var$_iteratorNormalCompletion && $4c4fc83a8e51822e$var$_iterator["return"] != null) {
            $4c4fc83a8e51822e$var$_iterator["return"]();
        }
    } finally{
        if ($4c4fc83a8e51822e$var$_didIteratorError) {
            throw $4c4fc83a8e51822e$var$_iteratorError;
        }
    }
}
var $4c4fc83a8e51822e$var$_iteratorNormalCompletion1 = true, $4c4fc83a8e51822e$var$_didIteratorError1 = false, $4c4fc83a8e51822e$var$_iteratorError1 = undefined;
try {
    for(var $4c4fc83a8e51822e$var$_iterator1 = $4c4fc83a8e51822e$var$ObjectKeys($4c4fc83a8e51822e$var$promiseReturningOperators)[Symbol.iterator](), $4c4fc83a8e51822e$var$_step1; !($4c4fc83a8e51822e$var$_iteratorNormalCompletion1 = ($4c4fc83a8e51822e$var$_step1 = $4c4fc83a8e51822e$var$_iterator1.next()).done); $4c4fc83a8e51822e$var$_iteratorNormalCompletion1 = true){
        var $4c4fc83a8e51822e$var$key1 = $4c4fc83a8e51822e$var$_step1.value;
        var $4c4fc83a8e51822e$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $4c4fc83a8e51822e$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $4c4fc83a8e51822e$var$ReflectApply($4c4fc83a8e51822e$var$op1, this, args);
        };
        var $4c4fc83a8e51822e$var$op1 = $4c4fc83a8e51822e$var$promiseReturningOperators[$4c4fc83a8e51822e$var$key1];
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$fn1, 'name', {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$op1.name
        });
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$fn1, 'length', {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$op1.length
        });
        $4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$Stream.Readable.prototype, $4c4fc83a8e51822e$var$key1, {
            __proto__: null,
            value: $4c4fc83a8e51822e$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $4c4fc83a8e51822e$var$_didIteratorError1 = true;
    $4c4fc83a8e51822e$var$_iteratorError1 = err;
} finally{
    try {
        if (!$4c4fc83a8e51822e$var$_iteratorNormalCompletion1 && $4c4fc83a8e51822e$var$_iterator1["return"] != null) {
            $4c4fc83a8e51822e$var$_iterator1["return"]();
        }
    } finally{
        if ($4c4fc83a8e51822e$var$_didIteratorError1) {
            throw $4c4fc83a8e51822e$var$_iteratorError1;
        }
    }
}

$4c4fc83a8e51822e$var$Stream.Writable = (parcelRequire("hZw0T"));

$4c4fc83a8e51822e$var$Stream.Duplex = (parcelRequire("7mNYl"));

$4c4fc83a8e51822e$var$Stream.Transform = (parcelRequire("gzOD2"));

$4c4fc83a8e51822e$var$Stream.PassThrough = (parcelRequire("2B1wE"));
$4c4fc83a8e51822e$var$Stream.pipeline = $4c4fc83a8e51822e$require$pipeline;

var $eqziB = parcelRequire("eqziB");
var $4c4fc83a8e51822e$require$addAbortSignal = $eqziB.addAbortSignal;
$4c4fc83a8e51822e$var$Stream.addAbortSignal = $4c4fc83a8e51822e$require$addAbortSignal;
$4c4fc83a8e51822e$var$Stream.finished = $dF61N;
$4c4fc83a8e51822e$var$Stream.destroy = $4c4fc83a8e51822e$require$destroyer;
$4c4fc83a8e51822e$var$Stream.compose = $kzJuO;
$4c4fc83a8e51822e$var$Stream.setDefaultHighWaterMark = $4c4fc83a8e51822e$var$setDefaultHighWaterMark;
$4c4fc83a8e51822e$var$Stream.getDefaultHighWaterMark = $4c4fc83a8e51822e$var$getDefaultHighWaterMark;
$4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $hEuiV;
    }
});
$4c4fc83a8e51822e$var$ObjectDefineProperty($4c4fc83a8e51822e$require$pipeline, $4c4fc83a8e51822e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $hEuiV.pipeline;
    }
});
$4c4fc83a8e51822e$var$ObjectDefineProperty($dF61N, $4c4fc83a8e51822e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $hEuiV.finished;
    }
});
// Backwards-compat with node 0.4.x
$4c4fc83a8e51822e$var$Stream.Stream = $4c4fc83a8e51822e$var$Stream;
$4c4fc83a8e51822e$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$4c4fc83a8e51822e$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $4c4fc83a8e51822e$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("kAHTL", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $efd938bcee4024e5$export$a143d493d941bafc; }, function (v) { return $efd938bcee4024e5$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $efd938bcee4024e5$export$f99ded8fe4b79145; }, function (v) { return $efd938bcee4024e5$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $efd938bcee4024e5$export$a143d493d941bafc;
var $efd938bcee4024e5$export$e4cf37d7f6fb9e0a;
var $efd938bcee4024e5$export$f99ded8fe4b79145;
var $efd938bcee4024e5$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $efd938bcee4024e5$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$efd938bcee4024e5$export$a143d493d941bafc = $efd938bcee4024e5$var$Buffer;
$efd938bcee4024e5$export$e4cf37d7f6fb9e0a = $efd938bcee4024e5$var$SlowBuffer;
$efd938bcee4024e5$export$f99ded8fe4b79145 = 50;
var $efd938bcee4024e5$var$K_MAX_LENGTH = 0x7fffffff;
$efd938bcee4024e5$export$599f31c3813fae4d = $efd938bcee4024e5$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $efd938bcee4024e5$var$Buffer.TYPED_ARRAY_SUPPORT = $efd938bcee4024e5$var$typedArraySupport();
if (!$efd938bcee4024e5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $efd938bcee4024e5$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($efd938bcee4024e5$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$efd938bcee4024e5$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($efd938bcee4024e5$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$efd938bcee4024e5$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $efd938bcee4024e5$var$createBuffer(length) {
    if (length > $efd938bcee4024e5$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $efd938bcee4024e5$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $efd938bcee4024e5$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $efd938bcee4024e5$var$allocUnsafe(arg);
    }
    return $efd938bcee4024e5$var$from(arg, encodingOrOffset, length);
}
$efd938bcee4024e5$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $efd938bcee4024e5$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $efd938bcee4024e5$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $efd938bcee4024e5$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($efd938bcee4024e5$var$isInstance(value, ArrayBuffer) || value && $efd938bcee4024e5$var$isInstance(value.buffer, ArrayBuffer)) return $efd938bcee4024e5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($efd938bcee4024e5$var$isInstance(value, SharedArrayBuffer) || value && $efd938bcee4024e5$var$isInstance(value.buffer, SharedArrayBuffer))) return $efd938bcee4024e5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $efd938bcee4024e5$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $efd938bcee4024e5$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $efd938bcee4024e5$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $efd938bcee4024e5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $efd938bcee4024e5$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($efd938bcee4024e5$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($efd938bcee4024e5$var$Buffer, Uint8Array);
function $efd938bcee4024e5$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $efd938bcee4024e5$var$alloc(size, fill, encoding) {
    $efd938bcee4024e5$var$assertSize(size);
    if (size <= 0) return $efd938bcee4024e5$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $efd938bcee4024e5$var$createBuffer(size).fill(fill, encoding) : $efd938bcee4024e5$var$createBuffer(size).fill(fill);
    return $efd938bcee4024e5$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $efd938bcee4024e5$var$Buffer.alloc = function(size, fill, encoding) {
    return $efd938bcee4024e5$var$alloc(size, fill, encoding);
};
function $efd938bcee4024e5$var$allocUnsafe(size) {
    $efd938bcee4024e5$var$assertSize(size);
    return $efd938bcee4024e5$var$createBuffer(size < 0 ? 0 : $efd938bcee4024e5$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $efd938bcee4024e5$var$Buffer.allocUnsafe = function(size) {
    return $efd938bcee4024e5$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $efd938bcee4024e5$var$Buffer.allocUnsafeSlow = function(size) {
    return $efd938bcee4024e5$var$allocUnsafe(size);
};
function $efd938bcee4024e5$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$efd938bcee4024e5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $efd938bcee4024e5$var$byteLength(string, encoding) | 0;
    var buf = $efd938bcee4024e5$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $efd938bcee4024e5$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $efd938bcee4024e5$var$checked(array.length) | 0;
    var buf = $efd938bcee4024e5$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $efd938bcee4024e5$var$fromArrayView(arrayView) {
    if ($efd938bcee4024e5$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $efd938bcee4024e5$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $efd938bcee4024e5$var$fromArrayLike(arrayView);
}
function $efd938bcee4024e5$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $efd938bcee4024e5$var$Buffer.prototype);
    return buf;
}
function $efd938bcee4024e5$var$fromObject(obj) {
    if ($efd938bcee4024e5$var$Buffer.isBuffer(obj)) {
        var len = $efd938bcee4024e5$var$checked(obj.length) | 0;
        var buf = $efd938bcee4024e5$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $efd938bcee4024e5$var$numberIsNaN(obj.length)) return $efd938bcee4024e5$var$createBuffer(0);
        return $efd938bcee4024e5$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $efd938bcee4024e5$var$fromArrayLike(obj.data);
}
function $efd938bcee4024e5$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $efd938bcee4024e5$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $efd938bcee4024e5$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $efd938bcee4024e5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $efd938bcee4024e5$var$Buffer.alloc(+length);
}
$efd938bcee4024e5$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $efd938bcee4024e5$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$efd938bcee4024e5$var$Buffer.compare = function compare(a, b) {
    if ($efd938bcee4024e5$var$isInstance(a, Uint8Array)) a = $efd938bcee4024e5$var$Buffer.from(a, a.offset, a.byteLength);
    if ($efd938bcee4024e5$var$isInstance(b, Uint8Array)) b = $efd938bcee4024e5$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$efd938bcee4024e5$var$Buffer.isBuffer(a) || !$efd938bcee4024e5$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$efd938bcee4024e5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$efd938bcee4024e5$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $efd938bcee4024e5$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $efd938bcee4024e5$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($efd938bcee4024e5$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$efd938bcee4024e5$var$Buffer.isBuffer(buf)) buf = $efd938bcee4024e5$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$efd938bcee4024e5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $efd938bcee4024e5$var$byteLength(string, encoding) {
    if ($efd938bcee4024e5$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $efd938bcee4024e5$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $efd938bcee4024e5$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $efd938bcee4024e5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $efd938bcee4024e5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$efd938bcee4024e5$var$Buffer.byteLength = $efd938bcee4024e5$var$byteLength;
function $efd938bcee4024e5$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $efd938bcee4024e5$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $efd938bcee4024e5$var$utf8Slice(this, start, end);
        case 'ascii':
            return $efd938bcee4024e5$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $efd938bcee4024e5$var$latin1Slice(this, start, end);
        case 'base64':
            return $efd938bcee4024e5$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $efd938bcee4024e5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$efd938bcee4024e5$var$Buffer.prototype._isBuffer = true;
function $efd938bcee4024e5$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$efd938bcee4024e5$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$efd938bcee4024e5$var$swap(this, i, i + 1);
    return this;
};
$efd938bcee4024e5$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $efd938bcee4024e5$var$swap(this, i, i + 3);
        $efd938bcee4024e5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$efd938bcee4024e5$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $efd938bcee4024e5$var$swap(this, i, i + 7);
        $efd938bcee4024e5$var$swap(this, i + 1, i + 6);
        $efd938bcee4024e5$var$swap(this, i + 2, i + 5);
        $efd938bcee4024e5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$efd938bcee4024e5$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $efd938bcee4024e5$var$utf8Slice(this, 0, length);
    return $efd938bcee4024e5$var$slowToString.apply(this, arguments);
};
$efd938bcee4024e5$var$Buffer.prototype.toLocaleString = $efd938bcee4024e5$var$Buffer.prototype.toString;
$efd938bcee4024e5$var$Buffer.prototype.equals = function equals(b) {
    if (!$efd938bcee4024e5$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $efd938bcee4024e5$var$Buffer.compare(this, b) === 0;
};
$efd938bcee4024e5$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $efd938bcee4024e5$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($efd938bcee4024e5$var$customInspectSymbol) $efd938bcee4024e5$var$Buffer.prototype[$efd938bcee4024e5$var$customInspectSymbol] = $efd938bcee4024e5$var$Buffer.prototype.inspect;
$efd938bcee4024e5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($efd938bcee4024e5$var$isInstance(target, Uint8Array)) target = $efd938bcee4024e5$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$efd938bcee4024e5$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $efd938bcee4024e5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($efd938bcee4024e5$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $efd938bcee4024e5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($efd938bcee4024e5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $efd938bcee4024e5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $efd938bcee4024e5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $efd938bcee4024e5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$efd938bcee4024e5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$efd938bcee4024e5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $efd938bcee4024e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$efd938bcee4024e5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $efd938bcee4024e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $efd938bcee4024e5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($efd938bcee4024e5$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $efd938bcee4024e5$var$utf8Write(buf, string, offset, length) {
    return $efd938bcee4024e5$var$blitBuffer($efd938bcee4024e5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $efd938bcee4024e5$var$asciiWrite(buf, string, offset, length) {
    return $efd938bcee4024e5$var$blitBuffer($efd938bcee4024e5$var$asciiToBytes(string), buf, offset, length);
}
function $efd938bcee4024e5$var$base64Write(buf, string, offset, length) {
    return $efd938bcee4024e5$var$blitBuffer($efd938bcee4024e5$var$base64ToBytes(string), buf, offset, length);
}
function $efd938bcee4024e5$var$ucs2Write(buf, string, offset, length) {
    return $efd938bcee4024e5$var$blitBuffer($efd938bcee4024e5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$efd938bcee4024e5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $efd938bcee4024e5$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $efd938bcee4024e5$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $efd938bcee4024e5$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $efd938bcee4024e5$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $efd938bcee4024e5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$efd938bcee4024e5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $efd938bcee4024e5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $efd938bcee4024e5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $efd938bcee4024e5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $efd938bcee4024e5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $efd938bcee4024e5$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $efd938bcee4024e5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $efd938bcee4024e5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $efd938bcee4024e5$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $efd938bcee4024e5$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $efd938bcee4024e5$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $efd938bcee4024e5$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $efd938bcee4024e5$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$efd938bcee4024e5$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $efd938bcee4024e5$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $efd938bcee4024e5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$efd938bcee4024e5$var$Buffer.prototype.readUintLE = $efd938bcee4024e5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$efd938bcee4024e5$var$Buffer.prototype.readUintBE = $efd938bcee4024e5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$efd938bcee4024e5$var$Buffer.prototype.readUint8 = $efd938bcee4024e5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$efd938bcee4024e5$var$Buffer.prototype.readUint16LE = $efd938bcee4024e5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$efd938bcee4024e5$var$Buffer.prototype.readUint16BE = $efd938bcee4024e5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$efd938bcee4024e5$var$Buffer.prototype.readUint32LE = $efd938bcee4024e5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$efd938bcee4024e5$var$Buffer.prototype.readUint32BE = $efd938bcee4024e5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$efd938bcee4024e5$var$Buffer.prototype.readBigUInt64LE = $efd938bcee4024e5$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $efd938bcee4024e5$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $efd938bcee4024e5$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$efd938bcee4024e5$var$Buffer.prototype.readBigUInt64BE = $efd938bcee4024e5$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $efd938bcee4024e5$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $efd938bcee4024e5$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$efd938bcee4024e5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$efd938bcee4024e5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$efd938bcee4024e5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$efd938bcee4024e5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$efd938bcee4024e5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$efd938bcee4024e5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$efd938bcee4024e5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$efd938bcee4024e5$var$Buffer.prototype.readBigInt64LE = $efd938bcee4024e5$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $efd938bcee4024e5$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $efd938bcee4024e5$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$efd938bcee4024e5$var$Buffer.prototype.readBigInt64BE = $efd938bcee4024e5$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $efd938bcee4024e5$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $efd938bcee4024e5$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$efd938bcee4024e5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$efd938bcee4024e5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$efd938bcee4024e5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$efd938bcee4024e5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $efd938bcee4024e5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$efd938bcee4024e5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$efd938bcee4024e5$var$Buffer.prototype.writeUintLE = $efd938bcee4024e5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $efd938bcee4024e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUintBE = $efd938bcee4024e5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $efd938bcee4024e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUint8 = $efd938bcee4024e5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUint16LE = $efd938bcee4024e5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUint16BE = $efd938bcee4024e5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUint32LE = $efd938bcee4024e5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$efd938bcee4024e5$var$Buffer.prototype.writeUint32BE = $efd938bcee4024e5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $efd938bcee4024e5$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $efd938bcee4024e5$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $efd938bcee4024e5$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $efd938bcee4024e5$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$efd938bcee4024e5$var$Buffer.prototype.writeBigUInt64LE = $efd938bcee4024e5$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $efd938bcee4024e5$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$efd938bcee4024e5$var$Buffer.prototype.writeBigUInt64BE = $efd938bcee4024e5$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $efd938bcee4024e5$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$efd938bcee4024e5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $efd938bcee4024e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$efd938bcee4024e5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $efd938bcee4024e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$efd938bcee4024e5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$efd938bcee4024e5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$efd938bcee4024e5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$efd938bcee4024e5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$efd938bcee4024e5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$efd938bcee4024e5$var$Buffer.prototype.writeBigInt64LE = $efd938bcee4024e5$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $efd938bcee4024e5$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$efd938bcee4024e5$var$Buffer.prototype.writeBigInt64BE = $efd938bcee4024e5$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $efd938bcee4024e5$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $efd938bcee4024e5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $efd938bcee4024e5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$efd938bcee4024e5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $efd938bcee4024e5$var$writeFloat(this, value, offset, true, noAssert);
};
$efd938bcee4024e5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $efd938bcee4024e5$var$writeFloat(this, value, offset, false, noAssert);
};
function $efd938bcee4024e5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $efd938bcee4024e5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$efd938bcee4024e5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $efd938bcee4024e5$var$writeDouble(this, value, offset, true, noAssert);
};
$efd938bcee4024e5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $efd938bcee4024e5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$efd938bcee4024e5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$efd938bcee4024e5$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$efd938bcee4024e5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$efd938bcee4024e5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $efd938bcee4024e5$var$Buffer.isBuffer(val) ? val : $efd938bcee4024e5$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $efd938bcee4024e5$var$errors = {};
function $efd938bcee4024e5$var$E(sym, getMessage, Base) {
    $efd938bcee4024e5$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$efd938bcee4024e5$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$efd938bcee4024e5$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$efd938bcee4024e5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $efd938bcee4024e5$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $efd938bcee4024e5$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $efd938bcee4024e5$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $efd938bcee4024e5$var$checkBounds(buf, offset, byteLength) {
    $efd938bcee4024e5$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $efd938bcee4024e5$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $efd938bcee4024e5$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $efd938bcee4024e5$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $efd938bcee4024e5$var$checkBounds(buf, offset, byteLength);
}
function $efd938bcee4024e5$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $efd938bcee4024e5$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $efd938bcee4024e5$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $efd938bcee4024e5$var$validateNumber(value, type);
        throw new $efd938bcee4024e5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $efd938bcee4024e5$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $efd938bcee4024e5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $efd938bcee4024e5$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $efd938bcee4024e5$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($efd938bcee4024e5$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $efd938bcee4024e5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $efd938bcee4024e5$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $efd938bcee4024e5$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $efd938bcee4024e5$var$base64ToBytes(str) {
    return $abUaD.toByteArray($efd938bcee4024e5$var$base64clean(str));
}
function $efd938bcee4024e5$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $efd938bcee4024e5$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $efd938bcee4024e5$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $efd938bcee4024e5$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $efd938bcee4024e5$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $efd938bcee4024e5$var$BufferBigIntNotDefined : fn;
}
function $efd938bcee4024e5$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("2QaiP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $21186dfa40570d8e$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $21186dfa40570d8e$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("9Q0vO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $kAHTL = parcelRequire("kAHTL");

var $5z2AT = parcelRequire("5z2AT");
var $72995e13818a6085$var$format = $5z2AT.format, $72995e13818a6085$var$inspect = $5z2AT.inspect;

var $c5mlQ = parcelRequire("c5mlQ");
var $72995e13818a6085$var$ERR_INVALID_ARG_TYPE = $c5mlQ.codes.ERR_INVALID_ARG_TYPE;

var $2QaiP = parcelRequire("2QaiP");
var $72995e13818a6085$var$kResistStopPropagation = $2QaiP.kResistStopPropagation, $72995e13818a6085$var$AggregateError = $2QaiP.AggregateError, $72995e13818a6085$var$SymbolDispose = $2QaiP.SymbolDispose;

var $72995e13818a6085$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $72995e13818a6085$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $72995e13818a6085$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $72995e13818a6085$var$Blob = globalThis.Blob || $kAHTL.Blob;
/* eslint-disable indent */ var $72995e13818a6085$var$isBlob = typeof $72995e13818a6085$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $72995e13818a6085$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $72995e13818a6085$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $72995e13818a6085$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $72995e13818a6085$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $72995e13818a6085$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $72995e13818a6085$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $72995e13818a6085$var$format,
    inspect: $72995e13818a6085$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $72995e13818a6085$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $72995e13818a6085$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $72995e13818a6085$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $72995e13818a6085$var$validateAbortSignal(signal, 'signal');
        $72995e13818a6085$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $72995e13818a6085$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $72995e13818a6085$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $72995e13818a6085$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $72995e13818a6085$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $72995e13818a6085$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("5z2AT", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("c5mlQ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $5z2AT = parcelRequire("5z2AT");
var $8cc74a2c4e7fe7c2$var$format = $5z2AT.format, $8cc74a2c4e7fe7c2$var$inspect = $5z2AT.inspect;

var $2QaiP = parcelRequire("2QaiP");
var $8cc74a2c4e7fe7c2$var$CustomAggregateError = $2QaiP.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $8cc74a2c4e7fe7c2$var$AggregateError = globalThis.AggregateError || $8cc74a2c4e7fe7c2$var$CustomAggregateError;
var $8cc74a2c4e7fe7c2$var$kIsNodeError = Symbol('kIsNodeError');
var $8cc74a2c4e7fe7c2$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $8cc74a2c4e7fe7c2$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $8cc74a2c4e7fe7c2$var$nodeInternalPrefix = '__node_internal_';
var $8cc74a2c4e7fe7c2$var$codes = {};
function $8cc74a2c4e7fe7c2$var$assert(value, message) {
    if (!value) throw new $8cc74a2c4e7fe7c2$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $8cc74a2c4e7fe7c2$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $8cc74a2c4e7fe7c2$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $8cc74a2c4e7fe7c2$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $8cc74a2c4e7fe7c2$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $8cc74a2c4e7fe7c2$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $8cc74a2c4e7fe7c2$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $8cc74a2c4e7fe7c2$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$8cc74a2c4e7fe7c2$var$kIsNodeError] = true;
    $8cc74a2c4e7fe7c2$var$codes[code] = NodeError;
}
function $8cc74a2c4e7fe7c2$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $8cc74a2c4e7fe7c2$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $8cc74a2c4e7fe7c2$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $8cc74a2c4e7fe7c2$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $8cc74a2c4e7fe7c2$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $8cc74a2c4e7fe7c2$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$8cc74a2c4e7fe7c2$var$E('ERR_ASSERTION', '%s', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $8cc74a2c4e7fe7c2$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $8cc74a2c4e7fe7c2$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($8cc74a2c4e7fe7c2$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($8cc74a2c4e7fe7c2$var$classRegExp.test(value)) instances.push(value);
            else {
                $8cc74a2c4e7fe7c2$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $8cc74a2c4e7fe7c2$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $8cc74a2c4e7fe7c2$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$8cc74a2c4e7fe7c2$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $8cc74a2c4e7fe7c2$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$8cc74a2c4e7fe7c2$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$8cc74a2c4e7fe7c2$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $8cc74a2c4e7fe7c2$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$8cc74a2c4e7fe7c2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $8cc74a2c4e7fe7c2$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $8cc74a2c4e7fe7c2$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $8cc74a2c4e7fe7c2$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $8cc74a2c4e7fe7c2$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$8cc74a2c4e7fe7c2$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$8cc74a2c4e7fe7c2$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $8cc74a2c4e7fe7c2$var$AbortError,
    aggregateTwoErrors: $8cc74a2c4e7fe7c2$var$hideStackFrames($8cc74a2c4e7fe7c2$var$aggregateTwoErrors),
    hideStackFrames: $8cc74a2c4e7fe7c2$var$hideStackFrames,
    codes: $8cc74a2c4e7fe7c2$var$codes
};

});


parcelRegister("h9kvW", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c7c3309da91d3502$export$42af8c323be37587; }, function (v) { return $c7c3309da91d3502$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c7c3309da91d3502$export$f405f72c701dad87; }, function (v) { return $c7c3309da91d3502$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $c7c3309da91d3502$export$42af8c323be37587;
var $c7c3309da91d3502$export$f405f72c701dad87;
'use strict';

var $c7c3309da91d3502$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $c5mlQ = parcelRequire("c5mlQ");
var $c7c3309da91d3502$var$_require_codes = $c5mlQ.codes, $c7c3309da91d3502$var$ERR_INVALID_ARG_VALUE = $c7c3309da91d3502$var$_require_codes.ERR_INVALID_ARG_VALUE, $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE = $c7c3309da91d3502$var$_require_codes.ERR_INVALID_ARG_TYPE, $c7c3309da91d3502$var$ERR_MISSING_ARGS = $c7c3309da91d3502$var$_require_codes.ERR_MISSING_ARGS, $c7c3309da91d3502$var$ERR_OUT_OF_RANGE = $c7c3309da91d3502$var$_require_codes.ERR_OUT_OF_RANGE, $c7c3309da91d3502$var$AbortError = $c5mlQ.AbortError;

var $1iuxD = parcelRequire("1iuxD");
var $c7c3309da91d3502$var$validateAbortSignal = $1iuxD.validateAbortSignal, $c7c3309da91d3502$var$validateInteger = $1iuxD.validateInteger, $c7c3309da91d3502$var$validateObject = $1iuxD.validateObject;

var $c7c3309da91d3502$var$kWeakHandler = (parcelRequire("2QaiP")).Symbol('kWeak');

var $c7c3309da91d3502$var$kResistStopPropagation = (parcelRequire("2QaiP")).Symbol('kResistStopPropagation');

var $dF61N = parcelRequire("dF61N");
var $c7c3309da91d3502$require$finished = $dF61N.finished;

var $kzJuO = parcelRequire("kzJuO");

var $eqziB = parcelRequire("eqziB");
var $c7c3309da91d3502$require$addAbortSignalNoValidate = $eqziB.addAbortSignalNoValidate;

var $gbI0K = parcelRequire("gbI0K");
var $c7c3309da91d3502$var$isWritable = $gbI0K.isWritable, $c7c3309da91d3502$var$isNodeStream = $gbI0K.isNodeStream;

var $c7c3309da91d3502$require$deprecate = (parcelRequire("9Q0vO")).deprecate;

var $c7c3309da91d3502$var$ArrayPrototypePush = (parcelRequire("2QaiP")).ArrayPrototypePush, $c7c3309da91d3502$var$Boolean = (parcelRequire("2QaiP")).Boolean, $c7c3309da91d3502$var$MathFloor = (parcelRequire("2QaiP")).MathFloor, $c7c3309da91d3502$var$Number = (parcelRequire("2QaiP")).Number, $c7c3309da91d3502$var$NumberIsNaN = (parcelRequire("2QaiP")).NumberIsNaN, $c7c3309da91d3502$var$Promise = (parcelRequire("2QaiP")).Promise, $c7c3309da91d3502$var$PromiseReject = (parcelRequire("2QaiP")).PromiseReject, $c7c3309da91d3502$var$PromiseResolve = (parcelRequire("2QaiP")).PromiseResolve, $c7c3309da91d3502$var$PromisePrototypeThen = (parcelRequire("2QaiP")).PromisePrototypeThen, $c7c3309da91d3502$var$Symbol = (parcelRequire("2QaiP")).Symbol;
var $c7c3309da91d3502$var$kEmpty = $c7c3309da91d3502$var$Symbol('kEmpty');
var $c7c3309da91d3502$var$kEof = $c7c3309da91d3502$var$Symbol('kEof');
function $c7c3309da91d3502$var$compose(stream, options) {
    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
    if ($c7c3309da91d3502$var$isNodeStream(stream) && !$c7c3309da91d3502$var$isWritable(stream)) throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $kzJuO(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c7c3309da91d3502$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c7c3309da91d3502$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c7c3309da91d3502$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c7c3309da91d3502$var$MathFloor(options.highWaterMark);
    $c7c3309da91d3502$var$validateInteger(concurrency, 'options.concurrency', 1);
    $c7c3309da91d3502$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $c7c3309da91d3502$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $c7c3309da91d3502$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $c7c3309da91d3502$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $c7c3309da91d3502$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $c7c3309da91d3502$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $c7c3309da91d3502$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($c7c3309da91d3502$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $c7c3309da91d3502$var$PromiseReject(err1);
                                $c7c3309da91d3502$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("9Q0vO")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($c7c3309da91d3502$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $c7c3309da91d3502$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $c7c3309da91d3502$var$AbortError();
                        if (!(val !== $c7c3309da91d3502$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $c7c3309da91d3502$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c7c3309da91d3502$var$asIndexedPairs(options) {
    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c7c3309da91d3502$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c7c3309da91d3502$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c7c3309da91d3502$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $c7c3309da91d3502$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $c7c3309da91d3502$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $c7c3309da91d3502$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c7c3309da91d3502$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $c7c3309da91d3502$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $c7c3309da91d3502$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c7c3309da91d3502$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $c7c3309da91d3502$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $c7c3309da91d3502$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $c7c3309da91d3502$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $c7c3309da91d3502$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($c7c3309da91d3502$var$ERR_MISSING_ARGS);
function $c7c3309da91d3502$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $c7c3309da91d3502$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $c7c3309da91d3502$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $c7c3309da91d3502$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $c7c3309da91d3502$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $c7c3309da91d3502$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $c7c3309da91d3502$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c7c3309da91d3502$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $c7c3309da91d3502$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c7c3309da91d3502$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c7c3309da91d3502$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $c7c3309da91d3502$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $c7c3309da91d3502$var$flatMap(fn, options) {
    var values = $c7c3309da91d3502$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $c7c3309da91d3502$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c7c3309da91d3502$var$Number(number);
    if ($c7c3309da91d3502$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c7c3309da91d3502$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c7c3309da91d3502$var$drop(number, options) {
    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
    number = $c7c3309da91d3502$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c7c3309da91d3502$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c7c3309da91d3502$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c7c3309da91d3502$var$take(number, options) {
    if (options != null) $c7c3309da91d3502$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c7c3309da91d3502$var$validateAbortSignal(options.signal, 'options.signal');
    number = $c7c3309da91d3502$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c7c3309da91d3502$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c7c3309da91d3502$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$c7c3309da91d3502$export$42af8c323be37587 = {
    asIndexedPairs: $c7c3309da91d3502$require$deprecate($c7c3309da91d3502$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c7c3309da91d3502$var$drop,
    filter: $c7c3309da91d3502$var$filter,
    flatMap: $c7c3309da91d3502$var$flatMap,
    map: $c7c3309da91d3502$var$map,
    take: $c7c3309da91d3502$var$take,
    compose: $c7c3309da91d3502$var$compose
};
$c7c3309da91d3502$export$f405f72c701dad87 = {
    every: $c7c3309da91d3502$var$every,
    forEach: $c7c3309da91d3502$var$forEach,
    reduce: $c7c3309da91d3502$var$reduce,
    toArray: $c7c3309da91d3502$var$toArray,
    some: $c7c3309da91d3502$var$some,
    find: $c7c3309da91d3502$var$find
};

});
parcelRegister("1iuxD", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $0f1f29d095823dc9$var$ArrayIsArray = $2QaiP.ArrayIsArray, $0f1f29d095823dc9$var$ArrayPrototypeIncludes = $2QaiP.ArrayPrototypeIncludes, $0f1f29d095823dc9$var$ArrayPrototypeJoin = $2QaiP.ArrayPrototypeJoin, $0f1f29d095823dc9$var$ArrayPrototypeMap = $2QaiP.ArrayPrototypeMap, $0f1f29d095823dc9$var$NumberIsInteger = $2QaiP.NumberIsInteger, $0f1f29d095823dc9$var$NumberIsNaN = $2QaiP.NumberIsNaN, $0f1f29d095823dc9$var$NumberMAX_SAFE_INTEGER = $2QaiP.NumberMAX_SAFE_INTEGER, $0f1f29d095823dc9$var$NumberMIN_SAFE_INTEGER = $2QaiP.NumberMIN_SAFE_INTEGER, $0f1f29d095823dc9$var$NumberParseInt = $2QaiP.NumberParseInt, $0f1f29d095823dc9$var$ObjectPrototypeHasOwnProperty = $2QaiP.ObjectPrototypeHasOwnProperty, $0f1f29d095823dc9$var$RegExpPrototypeExec = $2QaiP.RegExpPrototypeExec, $0f1f29d095823dc9$var$String = $2QaiP.String, $0f1f29d095823dc9$var$StringPrototypeToUpperCase = $2QaiP.StringPrototypeToUpperCase, $0f1f29d095823dc9$var$StringPrototypeTrim = $2QaiP.StringPrototypeTrim;

var $c5mlQ = parcelRequire("c5mlQ");
var $0f1f29d095823dc9$var$hideStackFrames = $c5mlQ.hideStackFrames, $0f1f29d095823dc9$var$_require_codes = $c5mlQ.codes, $0f1f29d095823dc9$var$ERR_SOCKET_BAD_PORT = $0f1f29d095823dc9$var$_require_codes.ERR_SOCKET_BAD_PORT, $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE = $0f1f29d095823dc9$var$_require_codes.ERR_INVALID_ARG_TYPE, $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE = $0f1f29d095823dc9$var$_require_codes.ERR_INVALID_ARG_VALUE, $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE = $0f1f29d095823dc9$var$_require_codes.ERR_OUT_OF_RANGE, $0f1f29d095823dc9$var$ERR_UNKNOWN_SIGNAL = $0f1f29d095823dc9$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $9Q0vO = parcelRequire("9Q0vO");
var $0f1f29d095823dc9$require$normalizeEncoding = $9Q0vO.normalizeEncoding;

var $9Q0vO = parcelRequire("9Q0vO");
var $0f1f29d095823dc9$require$_require_types = $9Q0vO.types;
var $0f1f29d095823dc9$var$isAsyncFunction = $0f1f29d095823dc9$require$_require_types.isAsyncFunction, $0f1f29d095823dc9$var$isArrayBufferView = $0f1f29d095823dc9$require$_require_types.isArrayBufferView;
var $0f1f29d095823dc9$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0f1f29d095823dc9$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0f1f29d095823dc9$var$isUint32(value) {
    return value === value >>> 0;
}
var $0f1f29d095823dc9$var$octalReg = /^[0-7]+$/;
var $0f1f29d095823dc9$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $0f1f29d095823dc9$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($0f1f29d095823dc9$var$RegExpPrototypeExec($0f1f29d095823dc9$var$octalReg, value) === null) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE(name, value, $0f1f29d095823dc9$var$modeDesc);
        value = $0f1f29d095823dc9$var$NumberParseInt(value, 8);
    }
    $0f1f29d095823dc9$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $0f1f29d095823dc9$var$validateInteger = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $0f1f29d095823dc9$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $0f1f29d095823dc9$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0f1f29d095823dc9$var$NumberIsInteger(value)) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $0f1f29d095823dc9$var$validateInt32 = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0f1f29d095823dc9$var$NumberIsInteger(value)) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $0f1f29d095823dc9$var$validateUint32 = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0f1f29d095823dc9$var$NumberIsInteger(value)) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $0f1f29d095823dc9$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $0f1f29d095823dc9$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $0f1f29d095823dc9$var$NumberIsNaN(value)) throw new $0f1f29d095823dc9$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $0f1f29d095823dc9$var$validateOneOf = $0f1f29d095823dc9$var$hideStackFrames(function(value, name, oneOf) {
    if (!$0f1f29d095823dc9$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $0f1f29d095823dc9$var$ArrayPrototypeJoin($0f1f29d095823dc9$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $0f1f29d095823dc9$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $0f1f29d095823dc9$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $0f1f29d095823dc9$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$0f1f29d095823dc9$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $0f1f29d095823dc9$var$validateObject = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $0f1f29d095823dc9$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $0f1f29d095823dc9$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $0f1f29d095823dc9$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $0f1f29d095823dc9$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $0f1f29d095823dc9$var$validateDictionary = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $0f1f29d095823dc9$var$validateArray = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$0f1f29d095823dc9$var$ArrayIsArray(value)) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $0f1f29d095823dc9$var$validateStringArray(value, name) {
    $0f1f29d095823dc9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$0f1f29d095823dc9$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $0f1f29d095823dc9$var$validateBooleanArray(value, name) {
    $0f1f29d095823dc9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$0f1f29d095823dc9$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $0f1f29d095823dc9$var$validateAbortSignalArray(value, name) {
    $0f1f29d095823dc9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $0f1f29d095823dc9$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $0f1f29d095823dc9$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $0f1f29d095823dc9$var$validateString(signal, name);
    if ($0f1f29d095823dc9$var$signals[signal] === undefined) {
        if ($0f1f29d095823dc9$var$signals[$0f1f29d095823dc9$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $0f1f29d095823dc9$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $0f1f29d095823dc9$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $0f1f29d095823dc9$var$validateBuffer = $0f1f29d095823dc9$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$0f1f29d095823dc9$var$isArrayBufferView(buffer)) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $0f1f29d095823dc9$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $0f1f29d095823dc9$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $0f1f29d095823dc9$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $0f1f29d095823dc9$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $0f1f29d095823dc9$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $0f1f29d095823dc9$var$validateAbortSignal = $0f1f29d095823dc9$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $0f1f29d095823dc9$var$validateFunction = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $0f1f29d095823dc9$var$validatePlainFunction = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $0f1f29d095823dc9$var$isAsyncFunction(value)) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $0f1f29d095823dc9$var$validateUndefined = $0f1f29d095823dc9$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $0f1f29d095823dc9$var$validateUnion(value, name, union) {
    if (!$0f1f29d095823dc9$var$ArrayPrototypeIncludes(union, value)) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_TYPE(name, "('".concat($0f1f29d095823dc9$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $0f1f29d095823dc9$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $0f1f29d095823dc9$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$0f1f29d095823dc9$var$RegExpPrototypeExec($0f1f29d095823dc9$var$linkValueRegExp, value)) throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $0f1f29d095823dc9$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $0f1f29d095823dc9$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($0f1f29d095823dc9$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $0f1f29d095823dc9$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $0f1f29d095823dc9$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $0f1f29d095823dc9$var$isInt32,
    isUint32: $0f1f29d095823dc9$var$isUint32,
    parseFileMode: $0f1f29d095823dc9$var$parseFileMode,
    validateArray: $0f1f29d095823dc9$var$validateArray,
    validateStringArray: $0f1f29d095823dc9$var$validateStringArray,
    validateBooleanArray: $0f1f29d095823dc9$var$validateBooleanArray,
    validateAbortSignalArray: $0f1f29d095823dc9$var$validateAbortSignalArray,
    validateBoolean: $0f1f29d095823dc9$var$validateBoolean,
    validateBuffer: $0f1f29d095823dc9$var$validateBuffer,
    validateDictionary: $0f1f29d095823dc9$var$validateDictionary,
    validateEncoding: $0f1f29d095823dc9$var$validateEncoding,
    validateFunction: $0f1f29d095823dc9$var$validateFunction,
    validateInt32: $0f1f29d095823dc9$var$validateInt32,
    validateInteger: $0f1f29d095823dc9$var$validateInteger,
    validateNumber: $0f1f29d095823dc9$var$validateNumber,
    validateObject: $0f1f29d095823dc9$var$validateObject,
    validateOneOf: $0f1f29d095823dc9$var$validateOneOf,
    validatePlainFunction: $0f1f29d095823dc9$var$validatePlainFunction,
    validatePort: $0f1f29d095823dc9$var$validatePort,
    validateSignalName: $0f1f29d095823dc9$var$validateSignalName,
    validateString: $0f1f29d095823dc9$var$validateString,
    validateUint32: $0f1f29d095823dc9$var$validateUint32,
    validateUndefined: $0f1f29d095823dc9$var$validateUndefined,
    validateUnion: $0f1f29d095823dc9$var$validateUnion,
    validateAbortSignal: $0f1f29d095823dc9$var$validateAbortSignal,
    validateLinkHeaderValue: $0f1f29d095823dc9$var$validateLinkHeaderValue
};

});

parcelRegister("dF61N", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $c5mlQ = parcelRequire("c5mlQ");
/* replacement end */ var $9f23c7b623f91542$var$AbortError = $c5mlQ.AbortError, $9f23c7b623f91542$var$codes = $c5mlQ.codes;
var $9f23c7b623f91542$var$ERR_INVALID_ARG_TYPE = $9f23c7b623f91542$var$codes.ERR_INVALID_ARG_TYPE, $9f23c7b623f91542$var$ERR_STREAM_PREMATURE_CLOSE = $9f23c7b623f91542$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $9f23c7b623f91542$var$kEmptyObject = (parcelRequire("9Q0vO")).kEmptyObject, $9f23c7b623f91542$var$once = (parcelRequire("9Q0vO")).once;

var $1iuxD = parcelRequire("1iuxD");
var $9f23c7b623f91542$var$validateAbortSignal = $1iuxD.validateAbortSignal, $9f23c7b623f91542$var$validateFunction = $1iuxD.validateFunction, $9f23c7b623f91542$var$validateObject = $1iuxD.validateObject, $9f23c7b623f91542$var$validateBoolean = $1iuxD.validateBoolean;

var $2QaiP = parcelRequire("2QaiP");
var $9f23c7b623f91542$var$Promise = $2QaiP.Promise, $9f23c7b623f91542$var$PromisePrototypeThen = $2QaiP.PromisePrototypeThen, $9f23c7b623f91542$var$SymbolDispose = $2QaiP.SymbolDispose;

var $gbI0K = parcelRequire("gbI0K");
var $9f23c7b623f91542$var$isClosed = $gbI0K.isClosed, $9f23c7b623f91542$var$isReadable = $gbI0K.isReadable, $9f23c7b623f91542$var$isReadableNodeStream = $gbI0K.isReadableNodeStream, $9f23c7b623f91542$var$isReadableStream = $gbI0K.isReadableStream, $9f23c7b623f91542$var$isReadableFinished = $gbI0K.isReadableFinished, $9f23c7b623f91542$var$isReadableErrored = $gbI0K.isReadableErrored, $9f23c7b623f91542$var$isWritable = $gbI0K.isWritable, $9f23c7b623f91542$var$isWritableNodeStream = $gbI0K.isWritableNodeStream, $9f23c7b623f91542$var$isWritableStream = $gbI0K.isWritableStream, $9f23c7b623f91542$var$isWritableFinished = $gbI0K.isWritableFinished, $9f23c7b623f91542$var$isWritableErrored = $gbI0K.isWritableErrored, $9f23c7b623f91542$var$isNodeStream = $gbI0K.isNodeStream, $9f23c7b623f91542$var$_willEmitClose = $gbI0K.willEmitClose, $9f23c7b623f91542$var$kIsClosedPromise = $gbI0K.kIsClosedPromise;
var $9f23c7b623f91542$var$addAbortListener;
function $9f23c7b623f91542$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $9f23c7b623f91542$var$nop = function() {};

function $9f23c7b623f91542$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $9f23c7b623f91542$var$kEmptyObject;
    } else if (options == null) options = $9f23c7b623f91542$var$kEmptyObject;
    else $9f23c7b623f91542$var$validateObject(options, 'options');
    $9f23c7b623f91542$var$validateFunction(callback, 'callback');
    $9f23c7b623f91542$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $9f23c7b623f91542$var$once(callback);
    if ($9f23c7b623f91542$var$isReadableStream(stream) || $9f23c7b623f91542$var$isWritableStream(stream)) return $9f23c7b623f91542$var$eosWeb(stream, options, callback);
    if (!$9f23c7b623f91542$var$isNodeStream(stream)) throw new $9f23c7b623f91542$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $9f23c7b623f91542$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $9f23c7b623f91542$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $9f23c7b623f91542$var$_willEmitClose(stream) && $9f23c7b623f91542$var$isReadableNodeStream(stream) === readable && $9f23c7b623f91542$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $9f23c7b623f91542$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $9f23c7b623f91542$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $9f23c7b623f91542$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $9f23c7b623f91542$var$isWritableErrored(stream) || $9f23c7b623f91542$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $9f23c7b623f91542$var$isReadableNodeStream(stream, true)) {
            if (!$9f23c7b623f91542$var$isReadableFinished(stream, false)) return callback.call(stream, new $9f23c7b623f91542$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$9f23c7b623f91542$var$isWritableFinished(stream, false)) return callback.call(stream, new $9f23c7b623f91542$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $9f23c7b623f91542$var$isWritableErrored(stream) || $9f23c7b623f91542$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($9f23c7b623f91542$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $9f23c7b623f91542$var$isReadable(stream)) && (writableFinished || $9f23c7b623f91542$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $9f23c7b623f91542$var$isWritable(stream)) && (readableFinished || $9f23c7b623f91542$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $9f23c7b623f91542$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $9f23c7b623f91542$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $9f23c7b623f91542$var$addAbortListener = $9f23c7b623f91542$var$addAbortListener || (parcelRequire("9Q0vO")).addAbortListener;
            var disposable = $9f23c7b623f91542$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $9f23c7b623f91542$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$9f23c7b623f91542$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $9f23c7b623f91542$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $9f23c7b623f91542$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $9f23c7b623f91542$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $9f23c7b623f91542$var$addAbortListener = $9f23c7b623f91542$var$addAbortListener || (parcelRequire("9Q0vO")).addAbortListener;
            var disposable = $9f23c7b623f91542$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $9f23c7b623f91542$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$9f23c7b623f91542$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $9f23c7b623f91542$var$PromisePrototypeThen(stream[$9f23c7b623f91542$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $9f23c7b623f91542$var$nop;
}
function $9f23c7b623f91542$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $9f23c7b623f91542$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $9f23c7b623f91542$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $9f23c7b623f91542$var$Promise(function(resolve, reject) {
        var cleanup = $9f23c7b623f91542$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $9f23c7b623f91542$var$eos;
module.exports.finished = $9f23c7b623f91542$var$finished;

});
parcelRegister("gbI0K", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $bc8fd0166812de52$var$SymbolAsyncIterator = $2QaiP.SymbolAsyncIterator, $bc8fd0166812de52$var$SymbolIterator = $2QaiP.SymbolIterator, $bc8fd0166812de52$var$SymbolFor = $2QaiP.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $bc8fd0166812de52$var$kIsDestroyed = $bc8fd0166812de52$var$SymbolFor('nodejs.stream.destroyed');
var $bc8fd0166812de52$var$kIsErrored = $bc8fd0166812de52$var$SymbolFor('nodejs.stream.errored');
var $bc8fd0166812de52$var$kIsReadable = $bc8fd0166812de52$var$SymbolFor('nodejs.stream.readable');
var $bc8fd0166812de52$var$kIsWritable = $bc8fd0166812de52$var$SymbolFor('nodejs.stream.writable');
var $bc8fd0166812de52$var$kIsDisturbed = $bc8fd0166812de52$var$SymbolFor('nodejs.stream.disturbed');
var $bc8fd0166812de52$var$kIsClosedPromise = $bc8fd0166812de52$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $bc8fd0166812de52$var$kControllerErrorFunction = $bc8fd0166812de52$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $bc8fd0166812de52$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $bc8fd0166812de52$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $bc8fd0166812de52$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $bc8fd0166812de52$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $bc8fd0166812de52$var$isReadableStream(obj) {
    return !!(obj && !$bc8fd0166812de52$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $bc8fd0166812de52$var$isWritableStream(obj) {
    return !!(obj && !$bc8fd0166812de52$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $bc8fd0166812de52$var$isTransformStream(obj) {
    return !!(obj && !$bc8fd0166812de52$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $bc8fd0166812de52$var$isWebStream(obj) {
    return $bc8fd0166812de52$var$isReadableStream(obj) || $bc8fd0166812de52$var$isWritableStream(obj) || $bc8fd0166812de52$var$isTransformStream(obj);
}
function $bc8fd0166812de52$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$bc8fd0166812de52$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$bc8fd0166812de52$var$SymbolIterator] === 'function';
    return typeof obj[$bc8fd0166812de52$var$SymbolAsyncIterator] === 'function' || typeof obj[$bc8fd0166812de52$var$SymbolIterator] === 'function';
}
function $bc8fd0166812de52$var$isDestroyed(stream) {
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$bc8fd0166812de52$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $bc8fd0166812de52$var$isWritableEnded(stream) {
    if (!$bc8fd0166812de52$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $bc8fd0166812de52$var$isWritableFinished(stream, strict) {
    if (!$bc8fd0166812de52$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $bc8fd0166812de52$var$isReadableEnded(stream) {
    if (!$bc8fd0166812de52$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $bc8fd0166812de52$var$isReadableFinished(stream, strict) {
    if (!$bc8fd0166812de52$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $bc8fd0166812de52$var$isReadable(stream) {
    if (stream && stream[$bc8fd0166812de52$var$kIsReadable] != null) return stream[$bc8fd0166812de52$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($bc8fd0166812de52$var$isDestroyed(stream)) return false;
    return $bc8fd0166812de52$var$isReadableNodeStream(stream) && stream.readable && !$bc8fd0166812de52$var$isReadableFinished(stream);
}
function $bc8fd0166812de52$var$isWritable(stream) {
    if (stream && stream[$bc8fd0166812de52$var$kIsWritable] != null) return stream[$bc8fd0166812de52$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($bc8fd0166812de52$var$isDestroyed(stream)) return false;
    return $bc8fd0166812de52$var$isWritableNodeStream(stream) && stream.writable && !$bc8fd0166812de52$var$isWritableEnded(stream);
}
function $bc8fd0166812de52$var$isFinished(stream, opts) {
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    if ($bc8fd0166812de52$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $bc8fd0166812de52$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $bc8fd0166812de52$var$isWritable(stream)) return false;
    return true;
}
function $bc8fd0166812de52$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $bc8fd0166812de52$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $bc8fd0166812de52$var$isClosed(stream) {
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $bc8fd0166812de52$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $bc8fd0166812de52$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $bc8fd0166812de52$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $bc8fd0166812de52$var$isOutgoingMessage(stream);
}
function $bc8fd0166812de52$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $bc8fd0166812de52$var$willEmitClose(stream) {
    if (!$bc8fd0166812de52$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $bc8fd0166812de52$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $bc8fd0166812de52$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$bc8fd0166812de52$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $bc8fd0166812de52$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$bc8fd0166812de52$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $bc8fd0166812de52$var$isDestroyed,
    kIsDestroyed: $bc8fd0166812de52$var$kIsDestroyed,
    isDisturbed: $bc8fd0166812de52$var$isDisturbed,
    kIsDisturbed: $bc8fd0166812de52$var$kIsDisturbed,
    isErrored: $bc8fd0166812de52$var$isErrored,
    kIsErrored: $bc8fd0166812de52$var$kIsErrored,
    isReadable: $bc8fd0166812de52$var$isReadable,
    kIsReadable: $bc8fd0166812de52$var$kIsReadable,
    kIsClosedPromise: $bc8fd0166812de52$var$kIsClosedPromise,
    kControllerErrorFunction: $bc8fd0166812de52$var$kControllerErrorFunction,
    kIsWritable: $bc8fd0166812de52$var$kIsWritable,
    isClosed: $bc8fd0166812de52$var$isClosed,
    isDuplexNodeStream: $bc8fd0166812de52$var$isDuplexNodeStream,
    isFinished: $bc8fd0166812de52$var$isFinished,
    isIterable: $bc8fd0166812de52$var$isIterable,
    isReadableNodeStream: $bc8fd0166812de52$var$isReadableNodeStream,
    isReadableStream: $bc8fd0166812de52$var$isReadableStream,
    isReadableEnded: $bc8fd0166812de52$var$isReadableEnded,
    isReadableFinished: $bc8fd0166812de52$var$isReadableFinished,
    isReadableErrored: $bc8fd0166812de52$var$isReadableErrored,
    isNodeStream: $bc8fd0166812de52$var$isNodeStream,
    isWebStream: $bc8fd0166812de52$var$isWebStream,
    isWritable: $bc8fd0166812de52$var$isWritable,
    isWritableNodeStream: $bc8fd0166812de52$var$isWritableNodeStream,
    isWritableStream: $bc8fd0166812de52$var$isWritableStream,
    isWritableEnded: $bc8fd0166812de52$var$isWritableEnded,
    isWritableFinished: $bc8fd0166812de52$var$isWritableFinished,
    isWritableErrored: $bc8fd0166812de52$var$isWritableErrored,
    isServerRequest: $bc8fd0166812de52$var$isServerRequest,
    isServerResponse: $bc8fd0166812de52$var$isServerResponse,
    willEmitClose: $bc8fd0166812de52$var$willEmitClose,
    isTransformStream: $bc8fd0166812de52$var$isTransformStream
};

});


parcelRegister("kzJuO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hgLi3 = parcelRequire("hgLi3");
var $efaa5e106aa54b37$require$pipeline = $hgLi3.pipeline;

var $7mNYl = parcelRequire("7mNYl");

var $3xISh = parcelRequire("3xISh");
var $efaa5e106aa54b37$require$destroyer = $3xISh.destroyer;

var $gbI0K = parcelRequire("gbI0K");
var $efaa5e106aa54b37$var$isNodeStream = $gbI0K.isNodeStream, $efaa5e106aa54b37$var$isReadable = $gbI0K.isReadable, $efaa5e106aa54b37$var$isWritable = $gbI0K.isWritable, $efaa5e106aa54b37$var$isWebStream = $gbI0K.isWebStream, $efaa5e106aa54b37$var$isTransformStream = $gbI0K.isTransformStream, $efaa5e106aa54b37$var$isWritableStream = $gbI0K.isWritableStream, $efaa5e106aa54b37$var$isReadableStream = $gbI0K.isReadableStream;

var $c5mlQ = parcelRequire("c5mlQ");
var $efaa5e106aa54b37$var$AbortError = $c5mlQ.AbortError, $efaa5e106aa54b37$var$_require_codes = $c5mlQ.codes, $efaa5e106aa54b37$var$ERR_INVALID_ARG_VALUE = $efaa5e106aa54b37$var$_require_codes.ERR_INVALID_ARG_VALUE, $efaa5e106aa54b37$var$ERR_MISSING_ARGS = $efaa5e106aa54b37$var$_require_codes.ERR_MISSING_ARGS;

var $dF61N = parcelRequire("dF61N");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $efaa5e106aa54b37$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $7mNYl.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $7mNYl.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $7mNYl.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$efaa5e106aa54b37$var$isNodeStream(streams[n]) && !$efaa5e106aa54b37$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($efaa5e106aa54b37$var$isReadable(streams[n]) || $efaa5e106aa54b37$var$isReadableStream(streams[n]) || $efaa5e106aa54b37$var$isTransformStream(streams[n]))) throw new $efaa5e106aa54b37$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($efaa5e106aa54b37$var$isWritable(streams[n]) || $efaa5e106aa54b37$var$isWritableStream(streams[n]) || $efaa5e106aa54b37$var$isTransformStream(streams[n]))) throw new $efaa5e106aa54b37$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $efaa5e106aa54b37$require$pipeline(streams, onfinished);
    var writable = !!($efaa5e106aa54b37$var$isWritable(head) || $efaa5e106aa54b37$var$isWritableStream(head) || $efaa5e106aa54b37$var$isTransformStream(head));
    var readable = !!($efaa5e106aa54b37$var$isReadable(tail) || $efaa5e106aa54b37$var$isReadableStream(tail) || $efaa5e106aa54b37$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $7mNYl({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($efaa5e106aa54b37$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($efaa5e106aa54b37$var$isWebStream(head)) {
            var writable1 = $efaa5e106aa54b37$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $efaa5e106aa54b37$var$isTransformStream(tail) ? tail.readable : tail;
        $dF61N(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($efaa5e106aa54b37$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($efaa5e106aa54b37$var$isWebStream(tail)) {
            var readable1 = $efaa5e106aa54b37$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $efaa5e106aa54b37$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($efaa5e106aa54b37$var$isNodeStream(tail)) $efaa5e106aa54b37$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("hgLi3", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $c9289d263985925b$var$ArrayIsArray = $2QaiP.ArrayIsArray, $c9289d263985925b$var$Promise = $2QaiP.Promise, $c9289d263985925b$var$SymbolAsyncIterator = $2QaiP.SymbolAsyncIterator, $c9289d263985925b$var$SymbolDispose = $2QaiP.SymbolDispose;

var $dF61N = parcelRequire("dF61N");

var $c9289d263985925b$require$once = (parcelRequire("9Q0vO")).once;

var $3xISh = parcelRequire("3xISh");

var $7mNYl = parcelRequire("7mNYl");

var $c5mlQ = parcelRequire("c5mlQ");
var $c9289d263985925b$var$aggregateTwoErrors = $c5mlQ.aggregateTwoErrors, $c9289d263985925b$var$_require_codes = $c5mlQ.codes, $c9289d263985925b$var$ERR_INVALID_ARG_TYPE = $c9289d263985925b$var$_require_codes.ERR_INVALID_ARG_TYPE, $c9289d263985925b$var$ERR_INVALID_RETURN_VALUE = $c9289d263985925b$var$_require_codes.ERR_INVALID_RETURN_VALUE, $c9289d263985925b$var$ERR_MISSING_ARGS = $c9289d263985925b$var$_require_codes.ERR_MISSING_ARGS, $c9289d263985925b$var$ERR_STREAM_DESTROYED = $c9289d263985925b$var$_require_codes.ERR_STREAM_DESTROYED, $c9289d263985925b$var$ERR_STREAM_PREMATURE_CLOSE = $c9289d263985925b$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $c9289d263985925b$var$AbortError = $c5mlQ.AbortError;

var $1iuxD = parcelRequire("1iuxD");
var $c9289d263985925b$var$validateFunction = $1iuxD.validateFunction, $c9289d263985925b$var$validateAbortSignal = $1iuxD.validateAbortSignal;

var $gbI0K = parcelRequire("gbI0K");
var $c9289d263985925b$var$isIterable = $gbI0K.isIterable, $c9289d263985925b$var$isReadable = $gbI0K.isReadable, $c9289d263985925b$var$isReadableNodeStream = $gbI0K.isReadableNodeStream, $c9289d263985925b$var$isNodeStream = $gbI0K.isNodeStream, $c9289d263985925b$var$isTransformStream = $gbI0K.isTransformStream, $c9289d263985925b$var$isWebStream = $gbI0K.isWebStream, $c9289d263985925b$var$isReadableStream = $gbI0K.isReadableStream, $c9289d263985925b$var$isReadableFinished = $gbI0K.isReadableFinished;

var $c9289d263985925b$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $c9289d263985925b$var$PassThrough;
var $c9289d263985925b$var$Readable;
var $c9289d263985925b$var$addAbortListener;
function $c9289d263985925b$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $dF61N(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $3xISh.destroyer(stream, err || new $c9289d263985925b$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $c9289d263985925b$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $c9289d263985925b$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $c9289d263985925b$var$makeAsyncIterable(val) {
    if ($c9289d263985925b$var$isIterable(val)) return val;
    else if ($c9289d263985925b$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $c9289d263985925b$var$fromReadable(val);
    throw new $c9289d263985925b$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $c9289d263985925b$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$c9289d263985925b$var$Readable) $c9289d263985925b$var$Readable = (parcelRequire("bsrWI"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($c9289d263985925b$var$Readable.prototype[$c9289d263985925b$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $c9289d263985925b$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $c9289d263985925b$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $dF61N(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $c9289d263985925b$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c9289d263985925b$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($c9289d263985925b$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c9289d263985925b$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $c9289d263985925b$var$pipelineImpl(streams, $c9289d263985925b$require$once($c9289d263985925b$var$popCallback(streams)));
}


function $c9289d263985925b$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($c9289d263985925b$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $c9289d263985925b$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($c9289d263985925b$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($c9289d263985925b$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$c9289d263985925b$var$isIterable(ret)) throw new $c9289d263985925b$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($c9289d263985925b$var$isIterable(stream) || $c9289d263985925b$var$isReadableNodeStream(stream) || $c9289d263985925b$var$isTransformStream(stream)) ret = stream;
            else ret = $7mNYl.from(stream);
        } else if (typeof stream === 'function') {
            if ($c9289d263985925b$var$isTransformStream(ret)) {
                var _ret;
                ret = $c9289d263985925b$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $c9289d263985925b$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$c9289d263985925b$var$isIterable(ret, true)) throw new $c9289d263985925b$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$c9289d263985925b$var$PassThrough) $c9289d263985925b$var$PassThrough = (parcelRequire("2B1wE"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $c9289d263985925b$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($c9289d263985925b$var$isIterable(ret, true)) {
                    finishCount++;
                    $c9289d263985925b$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($c9289d263985925b$var$isReadableStream(ret) || $c9289d263985925b$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $c9289d263985925b$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $c9289d263985925b$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $c9289d263985925b$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($c9289d263985925b$var$isNodeStream(stream)) {
            if ($c9289d263985925b$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $c9289d263985925b$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($c9289d263985925b$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($c9289d263985925b$var$isTransformStream(ret) || $c9289d263985925b$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $c9289d263985925b$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($c9289d263985925b$var$isIterable(ret)) {
                finishCount++;
                $c9289d263985925b$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $c9289d263985925b$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($c9289d263985925b$var$isWebStream(stream)) {
            if ($c9289d263985925b$var$isReadableNodeStream(ret)) {
                finishCount++;
                $c9289d263985925b$var$pumpToWeb($c9289d263985925b$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($c9289d263985925b$var$isReadableStream(ret) || $c9289d263985925b$var$isIterable(ret)) {
                finishCount++;
                $c9289d263985925b$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($c9289d263985925b$var$isTransformStream(ret)) {
                finishCount++;
                $c9289d263985925b$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $c9289d263985925b$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $7mNYl.from(stream);
    };
    if (streams.length === 1 && $c9289d263985925b$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $c9289d263985925b$var$ERR_MISSING_ARGS('streams');
    var ac = new $c9289d263985925b$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $c9289d263985925b$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $c9289d263985925b$var$AbortError());
    }
    $c9289d263985925b$var$addAbortListener = $c9289d263985925b$var$addAbortListener || (parcelRequire("9Q0vO")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $c9289d263985925b$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$c9289d263985925b$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $c9289d263985925b$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $c9289d263985925b$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($c9289d263985925b$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $dF61N(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $dF61N(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $c9289d263985925b$var$pipelineImpl,
    pipeline: $c9289d263985925b$var$pipeline
};

});
parcelRegister("3xISh", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $c5mlQ = parcelRequire("c5mlQ");
/* replacement end */ var $294743499fedba53$var$aggregateTwoErrors = $c5mlQ.aggregateTwoErrors, $294743499fedba53$var$ERR_MULTIPLE_CALLBACK = $c5mlQ.codes.ERR_MULTIPLE_CALLBACK, $294743499fedba53$var$AbortError = $c5mlQ.AbortError;

var $2QaiP = parcelRequire("2QaiP");
var $294743499fedba53$require$Symbol = $2QaiP.Symbol;

var $gbI0K = parcelRequire("gbI0K");
var $294743499fedba53$var$kIsDestroyed = $gbI0K.kIsDestroyed, $294743499fedba53$var$isDestroyed = $gbI0K.isDestroyed, $294743499fedba53$var$isFinished = $gbI0K.isFinished, $294743499fedba53$var$isServerRequest = $gbI0K.isServerRequest;
var $294743499fedba53$var$kDestroy = $294743499fedba53$require$Symbol('kDestroy');
var $294743499fedba53$var$kConstruct = $294743499fedba53$require$Symbol('kConstruct');
function $294743499fedba53$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $294743499fedba53$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $294743499fedba53$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($294743499fedba53$var$kDestroy, function(er) {
        $294743499fedba53$var$_destroy(this, $294743499fedba53$var$aggregateTwoErrors(er, err), cb);
    });
    else $294743499fedba53$var$_destroy(this, err, cb);
    return this;
}
function $294743499fedba53$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $294743499fedba53$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($294743499fedba53$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($294743499fedba53$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $294743499fedba53$var$emitErrorCloseNT(self, err) {
    $294743499fedba53$var$emitErrorNT(self, err);
    $294743499fedba53$var$emitCloseNT(self);
}
function $294743499fedba53$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $294743499fedba53$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $294743499fedba53$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $294743499fedba53$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($294743499fedba53$var$emitErrorNT, stream, err);
        else $294743499fedba53$var$emitErrorNT(stream, err);
    }
}
function $294743499fedba53$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($294743499fedba53$var$kConstruct, cb);
    if (stream.listenerCount($294743499fedba53$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($294743499fedba53$var$constructNT, stream);
}
function $294743499fedba53$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $294743499fedba53$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $294743499fedba53$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($294743499fedba53$var$kDestroy, err);
        else if (err) $294743499fedba53$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($294743499fedba53$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $294743499fedba53$var$emitConstructNT(stream) {
    stream.emit($294743499fedba53$var$kConstruct);
}
function $294743499fedba53$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $294743499fedba53$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $294743499fedba53$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($294743499fedba53$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $294743499fedba53$var$destroyer(stream, err) {
    if (!stream || $294743499fedba53$var$isDestroyed(stream)) return;
    if (!err && !$294743499fedba53$var$isFinished(stream)) err = new $294743499fedba53$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($294743499fedba53$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($294743499fedba53$var$isRequest(stream)) stream.abort();
    else if ($294743499fedba53$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($294743499fedba53$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($294743499fedba53$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$294743499fedba53$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $294743499fedba53$var$construct,
    destroyer: $294743499fedba53$var$destroyer,
    destroy: $294743499fedba53$var$destroy,
    undestroy: $294743499fedba53$var$undestroy,
    errorOrDestroy: $294743499fedba53$var$errorOrDestroy
};

});

parcelRegister("7mNYl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $01625828f75b4322$var$ObjectDefineProperties = $2QaiP.ObjectDefineProperties, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor = $2QaiP.ObjectGetOwnPropertyDescriptor, $01625828f75b4322$var$ObjectKeys = $2QaiP.ObjectKeys, $01625828f75b4322$var$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf;
module.exports = $01625828f75b4322$var$Duplex;

var $bsrWI = parcelRequire("bsrWI");

var $hZw0T = parcelRequire("hZw0T");
$01625828f75b4322$var$ObjectSetPrototypeOf($01625828f75b4322$var$Duplex.prototype, $bsrWI.prototype);
$01625828f75b4322$var$ObjectSetPrototypeOf($01625828f75b4322$var$Duplex, $bsrWI);
{
    var $01625828f75b4322$var$keys = $01625828f75b4322$var$ObjectKeys($hZw0T.prototype);
    // Allow the keys array to be GC'ed.
    for(var $01625828f75b4322$var$i = 0; $01625828f75b4322$var$i < $01625828f75b4322$var$keys.length; $01625828f75b4322$var$i++){
        var $01625828f75b4322$var$method = $01625828f75b4322$var$keys[$01625828f75b4322$var$i];
        if (!$01625828f75b4322$var$Duplex.prototype[$01625828f75b4322$var$method]) $01625828f75b4322$var$Duplex.prototype[$01625828f75b4322$var$method] = $hZw0T.prototype[$01625828f75b4322$var$method];
    }
}function $01625828f75b4322$var$Duplex(options) {
    if (!(this instanceof $01625828f75b4322$var$Duplex)) return new $01625828f75b4322$var$Duplex(options);
    $bsrWI.call(this, options);
    $hZw0T.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$01625828f75b4322$var$ObjectDefineProperties($01625828f75b4322$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $01625828f75b4322$var$ObjectGetOwnPropertyDescriptor($hZw0T.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $01625828f75b4322$var$webStreamsAdapters;
// Lazy to avoid circular references
function $01625828f75b4322$var$lazyWebStreams() {
    if ($01625828f75b4322$var$webStreamsAdapters === undefined) $01625828f75b4322$var$webStreamsAdapters = {};
    return $01625828f75b4322$var$webStreamsAdapters;
}
$01625828f75b4322$var$Duplex.fromWeb = function(pair, options) {
    return $01625828f75b4322$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$01625828f75b4322$var$Duplex.toWeb = function(duplex) {
    return $01625828f75b4322$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $01625828f75b4322$var$duplexify;

$01625828f75b4322$var$Duplex.from = function(body) {
    if (!$01625828f75b4322$var$duplexify) $01625828f75b4322$var$duplexify = (parcelRequire("6VNBE"));
    return $01625828f75b4322$var$duplexify(body, 'body');
};

});
parcelRegister("bsrWI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2QaiP = parcelRequire("2QaiP");
/* replacement end */ var $8577fcbb69699834$var$ArrayPrototypeIndexOf = $2QaiP.ArrayPrototypeIndexOf, $8577fcbb69699834$var$NumberIsInteger = $2QaiP.NumberIsInteger, $8577fcbb69699834$var$NumberIsNaN = $2QaiP.NumberIsNaN, $8577fcbb69699834$var$NumberParseInt = $2QaiP.NumberParseInt, $8577fcbb69699834$var$ObjectDefineProperties = $2QaiP.ObjectDefineProperties, $8577fcbb69699834$var$ObjectKeys = $2QaiP.ObjectKeys, $8577fcbb69699834$var$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf, $8577fcbb69699834$var$Promise = $2QaiP.Promise, $8577fcbb69699834$var$SafeSet = $2QaiP.SafeSet, $8577fcbb69699834$var$SymbolAsyncDispose = $2QaiP.SymbolAsyncDispose, $8577fcbb69699834$var$SymbolAsyncIterator = $2QaiP.SymbolAsyncIterator, $8577fcbb69699834$var$Symbol = $2QaiP.Symbol;
module.exports = $8577fcbb69699834$var$Readable;
$8577fcbb69699834$var$Readable.ReadableState = $8577fcbb69699834$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $8577fcbb69699834$var$EE = $bBoAO.EventEmitter;

var $aXiX3 = parcelRequire("aXiX3");
var $8577fcbb69699834$var$Stream = $aXiX3.Stream, $8577fcbb69699834$var$prependListener = $aXiX3.prependListener;

var $kAHTL = parcelRequire("kAHTL");
var $8577fcbb69699834$require$Buffer = $kAHTL.Buffer;

var $eqziB = parcelRequire("eqziB");
var $8577fcbb69699834$require$addAbortSignal = $eqziB.addAbortSignal;

var $dF61N = parcelRequire("dF61N");

var $8577fcbb69699834$var$debug = (parcelRequire("9Q0vO")).debuglog('stream', function(fn) {
    $8577fcbb69699834$var$debug = fn;
});

var $iycrp = parcelRequire("iycrp");

var $3xISh = parcelRequire("3xISh");

var $1vd7s = parcelRequire("1vd7s");
var $8577fcbb69699834$var$getHighWaterMark = $1vd7s.getHighWaterMark, $8577fcbb69699834$var$getDefaultHighWaterMark = $1vd7s.getDefaultHighWaterMark;

var $c5mlQ = parcelRequire("c5mlQ");
var $8577fcbb69699834$var$aggregateTwoErrors = $c5mlQ.aggregateTwoErrors, $8577fcbb69699834$var$_require_codes = $c5mlQ.codes, $8577fcbb69699834$var$ERR_INVALID_ARG_TYPE = $8577fcbb69699834$var$_require_codes.ERR_INVALID_ARG_TYPE, $8577fcbb69699834$var$ERR_METHOD_NOT_IMPLEMENTED = $8577fcbb69699834$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $8577fcbb69699834$var$ERR_OUT_OF_RANGE = $8577fcbb69699834$var$_require_codes.ERR_OUT_OF_RANGE, $8577fcbb69699834$var$ERR_STREAM_PUSH_AFTER_EOF = $8577fcbb69699834$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $8577fcbb69699834$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $8577fcbb69699834$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $8577fcbb69699834$var$AbortError = $c5mlQ.AbortError;

var $1iuxD = parcelRequire("1iuxD");
var $8577fcbb69699834$require$validateObject = $1iuxD.validateObject;
var $8577fcbb69699834$var$kPaused = $8577fcbb69699834$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $8577fcbb69699834$require$StringDecoder = $3Jf7C.StringDecoder;

var $bay9D = parcelRequire("bay9D");
$8577fcbb69699834$var$ObjectSetPrototypeOf($8577fcbb69699834$var$Readable.prototype, $8577fcbb69699834$var$Stream.prototype);
$8577fcbb69699834$var$ObjectSetPrototypeOf($8577fcbb69699834$var$Readable, $8577fcbb69699834$var$Stream);
var $8577fcbb69699834$var$nop = function() {};
var $8577fcbb69699834$var$errorOrDestroy = $3xISh.errorOrDestroy;
var $8577fcbb69699834$var$kObjectMode = 1;
var $8577fcbb69699834$var$kEnded = 2;
var $8577fcbb69699834$var$kEndEmitted = 4;
var $8577fcbb69699834$var$kReading = 8;
var $8577fcbb69699834$var$kConstructed = 16;
var $8577fcbb69699834$var$kSync = 32;
var $8577fcbb69699834$var$kNeedReadable = 64;
var $8577fcbb69699834$var$kEmittedReadable = 128;
var $8577fcbb69699834$var$kReadableListening = 256;
var $8577fcbb69699834$var$kResumeScheduled = 512;
var $8577fcbb69699834$var$kErrorEmitted = 1024;
var $8577fcbb69699834$var$kEmitClose = 2048;
var $8577fcbb69699834$var$kAutoDestroy = 4096;
var $8577fcbb69699834$var$kDestroyed = 8192;
var $8577fcbb69699834$var$kClosed = 16384;
var $8577fcbb69699834$var$kCloseEmitted = 32768;
var $8577fcbb69699834$var$kMultiAwaitDrain = 65536;
var $8577fcbb69699834$var$kReadingMore = 131072;
var $8577fcbb69699834$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8577fcbb69699834$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8577fcbb69699834$var$ObjectDefineProperties($8577fcbb69699834$var$ReadableState.prototype, {
    objectMode: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kObjectMode),
    ended: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kEnded),
    endEmitted: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kEndEmitted),
    reading: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kNeedReadable),
    emittedReadable: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kEmittedReadable),
    readableListening: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kReadableListening),
    resumeScheduled: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kErrorEmitted),
    emitClose: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kEmitClose),
    autoDestroy: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kCloseEmitted),
    multiAwaitDrain: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kReadingMore),
    dataEmitted: $8577fcbb69699834$var$makeBitMapDescriptor($8577fcbb69699834$var$kDataEmitted)
});

function $8577fcbb69699834$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("7mNYl"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8577fcbb69699834$var$kEmitClose | $8577fcbb69699834$var$kAutoDestroy | $8577fcbb69699834$var$kConstructed | $8577fcbb69699834$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8577fcbb69699834$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8577fcbb69699834$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8577fcbb69699834$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8577fcbb69699834$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $iycrp();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8577fcbb69699834$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8577fcbb69699834$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8577fcbb69699834$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8577fcbb69699834$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8577fcbb69699834$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $8577fcbb69699834$var$Readable)) return new $8577fcbb69699834$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("7mNYl"));
    this._readableState = new $8577fcbb69699834$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8577fcbb69699834$require$addAbortSignal(options.signal, this);
    }
    $8577fcbb69699834$var$Stream.call(this, options);
    $3xISh.construct(this, function() {
        if (_this._readableState.needReadable) $8577fcbb69699834$var$maybeReadMore(_this, _this._readableState);
    });
}
$8577fcbb69699834$var$Readable.prototype.destroy = $3xISh.destroy;
$8577fcbb69699834$var$Readable.prototype._undestroy = $3xISh.undestroy;
$8577fcbb69699834$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8577fcbb69699834$var$Readable.prototype[$8577fcbb69699834$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8577fcbb69699834$var$Readable.prototype[$8577fcbb69699834$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8577fcbb69699834$var$AbortError();
        this.destroy(error);
    }
    return new $8577fcbb69699834$var$Promise(function(resolve, reject) {
        return $dF61N(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8577fcbb69699834$var$Readable.prototype.push = function(chunk, encoding) {
    return $8577fcbb69699834$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8577fcbb69699834$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8577fcbb69699834$var$readableAddChunk(this, chunk, encoding, true);
};
function $8577fcbb69699834$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8577fcbb69699834$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $8577fcbb69699834$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8577fcbb69699834$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8577fcbb69699834$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8577fcbb69699834$require$Buffer) encoding = '';
        else if ($8577fcbb69699834$var$Stream._isUint8Array(chunk)) {
            chunk = $8577fcbb69699834$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8577fcbb69699834$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8577fcbb69699834$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8577fcbb69699834$var$kReading;
        $8577fcbb69699834$var$onEofChunk(stream, state);
    } else if ((state.state & $8577fcbb69699834$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8577fcbb69699834$var$kEndEmitted) !== 0) $8577fcbb69699834$var$errorOrDestroy(stream, new $8577fcbb69699834$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8577fcbb69699834$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8577fcbb69699834$var$errorOrDestroy(stream, new $8577fcbb69699834$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8577fcbb69699834$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8577fcbb69699834$var$addChunk(stream, state, chunk, false);
                else $8577fcbb69699834$var$maybeReadMore(stream, state);
            } else $8577fcbb69699834$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8577fcbb69699834$var$kReading;
        $8577fcbb69699834$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8577fcbb69699834$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8577fcbb69699834$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8577fcbb69699834$var$kNeedReadable) !== 0) $8577fcbb69699834$var$emitReadable(stream);
    }
    $8577fcbb69699834$var$maybeReadMore(stream, state);
}
$8577fcbb69699834$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$8577fcbb69699834$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8577fcbb69699834$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $8577fcbb69699834$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$8577fcbb69699834$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $8577fcbb69699834$var$MAX_HWM = 0x40000000;
function $8577fcbb69699834$var$computeNewHighWaterMark(n) {
    if (n > $8577fcbb69699834$var$MAX_HWM) throw new $8577fcbb69699834$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8577fcbb69699834$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8577fcbb69699834$var$kObjectMode) !== 0) return 1;
    if ($8577fcbb69699834$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8577fcbb69699834$var$Readable.prototype.read = function(n) {
    $8577fcbb69699834$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8577fcbb69699834$var$NumberIsInteger(n)) n = $8577fcbb69699834$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8577fcbb69699834$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8577fcbb69699834$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8577fcbb69699834$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8577fcbb69699834$var$endReadable(this);
        else $8577fcbb69699834$var$emitReadable(this);
        return null;
    }
    n = $8577fcbb69699834$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8577fcbb69699834$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $8577fcbb69699834$var$kNeedReadable) !== 0;
    $8577fcbb69699834$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8577fcbb69699834$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8577fcbb69699834$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8577fcbb69699834$var$debug('do read');
        state.state |= $8577fcbb69699834$var$kReading | $8577fcbb69699834$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8577fcbb69699834$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8577fcbb69699834$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8577fcbb69699834$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8577fcbb69699834$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8577fcbb69699834$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8577fcbb69699834$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8577fcbb69699834$var$onEofChunk(stream, state) {
    $8577fcbb69699834$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8577fcbb69699834$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8577fcbb69699834$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8577fcbb69699834$var$emitReadable(stream) {
    var state = stream._readableState;
    $8577fcbb69699834$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8577fcbb69699834$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($8577fcbb69699834$var$emitReadable_, stream);
    }
}
function $8577fcbb69699834$var$emitReadable_(stream) {
    var state = stream._readableState;
    $8577fcbb69699834$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8577fcbb69699834$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8577fcbb69699834$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($8577fcbb69699834$var$maybeReadMore_, stream, state);
    }
}
function $8577fcbb69699834$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $8577fcbb69699834$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8577fcbb69699834$var$Readable.prototype._read = function(n) {
    throw new $8577fcbb69699834$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8577fcbb69699834$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8577fcbb69699834$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8577fcbb69699834$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8577fcbb69699834$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8577fcbb69699834$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $8577fcbb69699834$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8577fcbb69699834$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8577fcbb69699834$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8577fcbb69699834$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8577fcbb69699834$var$debug('ondata');
        var ret = dest.write(chunk);
        $8577fcbb69699834$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8577fcbb69699834$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8577fcbb69699834$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8577fcbb69699834$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8577fcbb69699834$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8577fcbb69699834$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8577fcbb69699834$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8577fcbb69699834$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8577fcbb69699834$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8577fcbb69699834$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8577fcbb69699834$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $8577fcbb69699834$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8577fcbb69699834$var$Readable.prototype.on = function(ev, fn) {
    var res = $8577fcbb69699834$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8577fcbb69699834$var$debug('on readable', state.length, state.reading);
            if (state.length) $8577fcbb69699834$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($8577fcbb69699834$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8577fcbb69699834$var$Readable.prototype.addListener = $8577fcbb69699834$var$Readable.prototype.on;
$8577fcbb69699834$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8577fcbb69699834$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8577fcbb69699834$var$updateReadableListening, this);
    return res;
};
$8577fcbb69699834$var$Readable.prototype.off = $8577fcbb69699834$var$Readable.prototype.removeListener;
$8577fcbb69699834$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8577fcbb69699834$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8577fcbb69699834$var$updateReadableListening, this);
    return res;
};
function $8577fcbb69699834$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8577fcbb69699834$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8577fcbb69699834$var$nReadingNextTick(self) {
    $8577fcbb69699834$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8577fcbb69699834$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8577fcbb69699834$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8577fcbb69699834$var$resume(this, state);
    }
    state[$8577fcbb69699834$var$kPaused] = false;
    return this;
};
function $8577fcbb69699834$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($8577fcbb69699834$var$resume_, stream, state);
    }
}
function $8577fcbb69699834$var$resume_(stream, state) {
    $8577fcbb69699834$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8577fcbb69699834$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8577fcbb69699834$var$Readable.prototype.pause = function() {
    $8577fcbb69699834$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8577fcbb69699834$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8577fcbb69699834$var$kPaused] = true;
    return this;
};
function $8577fcbb69699834$var$flow(stream) {
    var state = stream._readableState;
    $8577fcbb69699834$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8577fcbb69699834$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $8577fcbb69699834$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $8577fcbb69699834$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8577fcbb69699834$var$Readable.prototype[$8577fcbb69699834$var$SymbolAsyncIterator] = function() {
    return $8577fcbb69699834$var$streamToAsyncIterator(this);
};
$8577fcbb69699834$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8577fcbb69699834$require$validateObject(options, 'options');
    return $8577fcbb69699834$var$streamToAsyncIterator(this, options);
};
function $8577fcbb69699834$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8577fcbb69699834$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $8577fcbb69699834$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $8577fcbb69699834$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $8577fcbb69699834$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $8577fcbb69699834$var$nop;
                    stream.on('readable', next);
                    cleanup = $dF61N(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $8577fcbb69699834$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $8577fcbb69699834$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $8577fcbb69699834$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $8577fcbb69699834$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $3xISh.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8577fcbb69699834$var$ObjectDefineProperties($8577fcbb69699834$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8577fcbb69699834$var$ObjectDefineProperties($8577fcbb69699834$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$8577fcbb69699834$var$kPaused] !== false;
        },
        set: function(value) {
            this[$8577fcbb69699834$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8577fcbb69699834$var$Readable._fromList = $8577fcbb69699834$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8577fcbb69699834$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8577fcbb69699834$var$endReadable(stream) {
    var state = stream._readableState;
    $8577fcbb69699834$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($8577fcbb69699834$var$endReadableNT, state, stream);
    }
}
function $8577fcbb69699834$var$endReadableNT(state, stream) {
    $8577fcbb69699834$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($8577fcbb69699834$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8577fcbb69699834$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8577fcbb69699834$var$Readable.from = function(iterable, opts) {
    return $bay9D($8577fcbb69699834$var$Readable, iterable, opts);
};
var $8577fcbb69699834$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8577fcbb69699834$var$lazyWebStreams() {
    if ($8577fcbb69699834$var$webStreamsAdapters === undefined) $8577fcbb69699834$var$webStreamsAdapters = {};
    return $8577fcbb69699834$var$webStreamsAdapters;
}
$8577fcbb69699834$var$Readable.fromWeb = function(readableStream, options) {
    return $8577fcbb69699834$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8577fcbb69699834$var$Readable.toWeb = function(streamReadable, options) {
    return $8577fcbb69699834$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8577fcbb69699834$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8577fcbb69699834$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $3xISh.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("aXiX3", function(module, exports) {
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $7f9e1d70ee8c1583$var$ArrayIsArray = $2QaiP.ArrayIsArray, $7f9e1d70ee8c1583$var$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $7f9e1d70ee8c1583$var$EE = $bBoAO.EventEmitter;
function $7f9e1d70ee8c1583$var$Stream(opts) {
    $7f9e1d70ee8c1583$var$EE.call(this, opts);
}
$7f9e1d70ee8c1583$var$ObjectSetPrototypeOf($7f9e1d70ee8c1583$var$Stream.prototype, $7f9e1d70ee8c1583$var$EE.prototype);
$7f9e1d70ee8c1583$var$ObjectSetPrototypeOf($7f9e1d70ee8c1583$var$Stream, $7f9e1d70ee8c1583$var$EE);
$7f9e1d70ee8c1583$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($7f9e1d70ee8c1583$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $7f9e1d70ee8c1583$var$prependListener(source, 'error', onerror);
    $7f9e1d70ee8c1583$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $7f9e1d70ee8c1583$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7f9e1d70ee8c1583$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $7f9e1d70ee8c1583$var$Stream,
    prependListener: $7f9e1d70ee8c1583$var$prependListener
};

});

parcelRegister("eqziB", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $a80ee00ac435cd95$export$e2db56ee53255a0; }, function (v) { return $a80ee00ac435cd95$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $a80ee00ac435cd95$export$11956e9313f43de0; }, function (v) { return $a80ee00ac435cd95$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $a80ee00ac435cd95$export$e2db56ee53255a0;
var $a80ee00ac435cd95$export$11956e9313f43de0;
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $a80ee00ac435cd95$require$SymbolDispose = $2QaiP.SymbolDispose;

var $c5mlQ = parcelRequire("c5mlQ");
var $a80ee00ac435cd95$var$AbortError = $c5mlQ.AbortError, $a80ee00ac435cd95$var$codes = $c5mlQ.codes;

var $gbI0K = parcelRequire("gbI0K");
var $a80ee00ac435cd95$var$isNodeStream = $gbI0K.isNodeStream, $a80ee00ac435cd95$var$isWebStream = $gbI0K.isWebStream, $a80ee00ac435cd95$var$kControllerErrorFunction = $gbI0K.kControllerErrorFunction;

var $dF61N = parcelRequire("dF61N");
var $a80ee00ac435cd95$var$ERR_INVALID_ARG_TYPE = $a80ee00ac435cd95$var$codes.ERR_INVALID_ARG_TYPE;
var $a80ee00ac435cd95$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $a80ee00ac435cd95$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $a80ee00ac435cd95$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$a80ee00ac435cd95$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $a80ee00ac435cd95$var$validateAbortSignal(signal, 'signal');
    if (!$a80ee00ac435cd95$var$isNodeStream(stream) && !$a80ee00ac435cd95$var$isWebStream(stream)) throw new $a80ee00ac435cd95$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $a80ee00ac435cd95$export$11956e9313f43de0(signal, stream);
};

$a80ee00ac435cd95$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $a80ee00ac435cd95$var$isNodeStream(stream) ? function() {
        stream.destroy(new $a80ee00ac435cd95$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$a80ee00ac435cd95$var$kControllerErrorFunction](new $a80ee00ac435cd95$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $a80ee00ac435cd95$var$addAbortListener = $a80ee00ac435cd95$var$addAbortListener || (parcelRequire("9Q0vO")).addAbortListener;
        var disposable = $a80ee00ac435cd95$var$addAbortListener(signal, onAbort);
        $dF61N(stream, disposable[$a80ee00ac435cd95$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("iycrp", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $d8150d7ceae6141d$var$StringPrototypeSlice = $2QaiP.StringPrototypeSlice, $d8150d7ceae6141d$var$SymbolIterator = $2QaiP.SymbolIterator, $d8150d7ceae6141d$var$TypedArrayPrototypeSet = $2QaiP.TypedArrayPrototypeSet, $d8150d7ceae6141d$var$Uint8Array = $2QaiP.Uint8Array;

var $kAHTL = parcelRequire("kAHTL");
var $d8150d7ceae6141d$require$Buffer = $kAHTL.Buffer;

var $9Q0vO = parcelRequire("9Q0vO");
var $d8150d7ceae6141d$require$inspect = $9Q0vO.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $d8150d7ceae6141d$require$Buffer.alloc(0);
                var ret = $d8150d7ceae6141d$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $d8150d7ceae6141d$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $d8150d7ceae6141d$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $d8150d7ceae6141d$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $d8150d7ceae6141d$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $d8150d7ceae6141d$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $d8150d7ceae6141d$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $d8150d7ceae6141d$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $d8150d7ceae6141d$var$TypedArrayPrototypeSet(ret, new $d8150d7ceae6141d$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $d8150d7ceae6141d$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("1vd7s", function(module, exports) {
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $1182dce98a36ec40$var$MathFloor = $2QaiP.MathFloor, $1182dce98a36ec40$var$NumberIsInteger = $2QaiP.NumberIsInteger;

var $1iuxD = parcelRequire("1iuxD");
var $1182dce98a36ec40$require$validateInteger = $1iuxD.validateInteger;

var $1182dce98a36ec40$var$ERR_INVALID_ARG_VALUE = (parcelRequire("c5mlQ")).codes.ERR_INVALID_ARG_VALUE;
var $1182dce98a36ec40$var$defaultHighWaterMarkBytes = 16384;
var $1182dce98a36ec40$var$defaultHighWaterMarkObjectMode = 16;
function $1182dce98a36ec40$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1182dce98a36ec40$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $1182dce98a36ec40$var$defaultHighWaterMarkObjectMode : $1182dce98a36ec40$var$defaultHighWaterMarkBytes;
}
function $1182dce98a36ec40$var$setDefaultHighWaterMark(objectMode, value) {
    $1182dce98a36ec40$require$validateInteger(value, 'value', 0);
    if (objectMode) $1182dce98a36ec40$var$defaultHighWaterMarkObjectMode = value;
    else $1182dce98a36ec40$var$defaultHighWaterMarkBytes = value;
}
function $1182dce98a36ec40$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $1182dce98a36ec40$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$1182dce98a36ec40$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $1182dce98a36ec40$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $1182dce98a36ec40$var$MathFloor(hwm);
    }
    // Default value
    return $1182dce98a36ec40$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $1182dce98a36ec40$var$getHighWaterMark,
    getDefaultHighWaterMark: $1182dce98a36ec40$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $1182dce98a36ec40$var$setDefaultHighWaterMark
};

});

parcelRegister("bay9D", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2QaiP = parcelRequire("2QaiP");
/* replacement end */ var $821b1f357ccc8dc9$var$PromisePrototypeThen = $2QaiP.PromisePrototypeThen, $821b1f357ccc8dc9$var$SymbolAsyncIterator = $2QaiP.SymbolAsyncIterator, $821b1f357ccc8dc9$var$SymbolIterator = $2QaiP.SymbolIterator;

var $kAHTL = parcelRequire("kAHTL");
var $821b1f357ccc8dc9$require$Buffer = $kAHTL.Buffer;

var $c5mlQ = parcelRequire("c5mlQ");
var $821b1f357ccc8dc9$require$_require_codes = $c5mlQ.codes;
var $821b1f357ccc8dc9$var$ERR_INVALID_ARG_TYPE = $821b1f357ccc8dc9$require$_require_codes.ERR_INVALID_ARG_TYPE, $821b1f357ccc8dc9$var$ERR_STREAM_NULL_VALUES = $821b1f357ccc8dc9$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $821b1f357ccc8dc9$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $821b1f357ccc8dc9$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$821b1f357ccc8dc9$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$821b1f357ccc8dc9$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$821b1f357ccc8dc9$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$821b1f357ccc8dc9$var$SymbolIterator]();
    } else throw new $821b1f357ccc8dc9$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $821b1f357ccc8dc9$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $821b1f357ccc8dc9$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $821b1f357ccc8dc9$var$from;

});


parcelRegister("hZw0T", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $2QaiP = parcelRequire("2QaiP");
/* replacement end */ var $d190f75ada1eb742$var$ArrayPrototypeSlice = $2QaiP.ArrayPrototypeSlice, $d190f75ada1eb742$var$Error = $2QaiP.Error, $d190f75ada1eb742$var$FunctionPrototypeSymbolHasInstance = $2QaiP.FunctionPrototypeSymbolHasInstance, $d190f75ada1eb742$var$ObjectDefineProperty = $2QaiP.ObjectDefineProperty, $d190f75ada1eb742$var$ObjectDefineProperties = $2QaiP.ObjectDefineProperties, $d190f75ada1eb742$var$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf, $d190f75ada1eb742$var$StringPrototypeToLowerCase = $2QaiP.StringPrototypeToLowerCase, $d190f75ada1eb742$var$Symbol = $2QaiP.Symbol, $d190f75ada1eb742$var$SymbolHasInstance = $2QaiP.SymbolHasInstance;
module.exports = $d190f75ada1eb742$var$Writable;
$d190f75ada1eb742$var$Writable.WritableState = $d190f75ada1eb742$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $d190f75ada1eb742$var$EE = $bBoAO.EventEmitter;

var $aXiX3 = parcelRequire("aXiX3");
var $d190f75ada1eb742$require$Stream = $aXiX3.Stream;

var $kAHTL = parcelRequire("kAHTL");
var $d190f75ada1eb742$require$Buffer = $kAHTL.Buffer;

var $3xISh = parcelRequire("3xISh");

var $eqziB = parcelRequire("eqziB");
var $d190f75ada1eb742$require$addAbortSignal = $eqziB.addAbortSignal;

var $1vd7s = parcelRequire("1vd7s");
var $d190f75ada1eb742$var$getHighWaterMark = $1vd7s.getHighWaterMark, $d190f75ada1eb742$var$getDefaultHighWaterMark = $1vd7s.getDefaultHighWaterMark;

var $c5mlQ = parcelRequire("c5mlQ");
var $d190f75ada1eb742$require$_require_codes = $c5mlQ.codes;
var $d190f75ada1eb742$var$ERR_INVALID_ARG_TYPE = $d190f75ada1eb742$require$_require_codes.ERR_INVALID_ARG_TYPE, $d190f75ada1eb742$var$ERR_METHOD_NOT_IMPLEMENTED = $d190f75ada1eb742$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $d190f75ada1eb742$var$ERR_MULTIPLE_CALLBACK = $d190f75ada1eb742$require$_require_codes.ERR_MULTIPLE_CALLBACK, $d190f75ada1eb742$var$ERR_STREAM_CANNOT_PIPE = $d190f75ada1eb742$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $d190f75ada1eb742$var$ERR_STREAM_DESTROYED = $d190f75ada1eb742$require$_require_codes.ERR_STREAM_DESTROYED, $d190f75ada1eb742$var$ERR_STREAM_ALREADY_FINISHED = $d190f75ada1eb742$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $d190f75ada1eb742$var$ERR_STREAM_NULL_VALUES = $d190f75ada1eb742$require$_require_codes.ERR_STREAM_NULL_VALUES, $d190f75ada1eb742$var$ERR_STREAM_WRITE_AFTER_END = $d190f75ada1eb742$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $d190f75ada1eb742$var$ERR_UNKNOWN_ENCODING = $d190f75ada1eb742$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $d190f75ada1eb742$var$errorOrDestroy = $3xISh.errorOrDestroy;
$d190f75ada1eb742$var$ObjectSetPrototypeOf($d190f75ada1eb742$var$Writable.prototype, $d190f75ada1eb742$require$Stream.prototype);
$d190f75ada1eb742$var$ObjectSetPrototypeOf($d190f75ada1eb742$var$Writable, $d190f75ada1eb742$require$Stream);
function $d190f75ada1eb742$var$nop() {}
var $d190f75ada1eb742$var$kOnFinished = $d190f75ada1eb742$var$Symbol('kOnFinished');

function $d190f75ada1eb742$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("7mNYl"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $d190f75ada1eb742$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $d190f75ada1eb742$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $d190f75ada1eb742$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $d190f75ada1eb742$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$d190f75ada1eb742$var$kOnFinished] = [];
}
function $d190f75ada1eb742$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$d190f75ada1eb742$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $d190f75ada1eb742$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$d190f75ada1eb742$var$ObjectDefineProperty($d190f75ada1eb742$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $d190f75ada1eb742$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("7mNYl"));
    if (!isDuplex && !$d190f75ada1eb742$var$FunctionPrototypeSymbolHasInstance($d190f75ada1eb742$var$Writable, this)) return new $d190f75ada1eb742$var$Writable(options);
    this._writableState = new $d190f75ada1eb742$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $d190f75ada1eb742$require$addAbortSignal(options.signal, this);
    }
    $d190f75ada1eb742$require$Stream.call(this, options);
    $3xISh.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $d190f75ada1eb742$var$clearBuffer(_this, state);
        $d190f75ada1eb742$var$finishMaybe(_this, state);
    });
}
$d190f75ada1eb742$var$ObjectDefineProperty($d190f75ada1eb742$var$Writable, $d190f75ada1eb742$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($d190f75ada1eb742$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $d190f75ada1eb742$var$Writable) return false;
        return object && object._writableState instanceof $d190f75ada1eb742$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$d190f75ada1eb742$var$Writable.prototype.pipe = function() {
    $d190f75ada1eb742$var$errorOrDestroy(this, new $d190f75ada1eb742$var$ERR_STREAM_CANNOT_PIPE());
};
function $d190f75ada1eb742$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$d190f75ada1eb742$require$Buffer.isEncoding(encoding)) throw new $d190f75ada1eb742$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $d190f75ada1eb742$var$nop;
    }
    if (chunk === null) throw new $d190f75ada1eb742$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $d190f75ada1eb742$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $d190f75ada1eb742$require$Buffer) encoding = 'buffer';
        else if ($d190f75ada1eb742$require$Stream._isUint8Array(chunk)) {
            chunk = $d190f75ada1eb742$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $d190f75ada1eb742$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $d190f75ada1eb742$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $d190f75ada1eb742$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $d190f75ada1eb742$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $d190f75ada1eb742$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$d190f75ada1eb742$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $d190f75ada1eb742$var$_write(this, chunk, encoding, cb) === true;
};
$d190f75ada1eb742$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$d190f75ada1eb742$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $d190f75ada1eb742$var$clearBuffer(this, state);
    }
};
$d190f75ada1eb742$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $d190f75ada1eb742$var$StringPrototypeToLowerCase(encoding);
    if (!$d190f75ada1eb742$require$Buffer.isEncoding(encoding)) throw new $d190f75ada1eb742$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $d190f75ada1eb742$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $d190f75ada1eb742$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $d190f75ada1eb742$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $d190f75ada1eb742$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $d190f75ada1eb742$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $d190f75ada1eb742$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $d190f75ada1eb742$var$errorOrDestroy(stream, er);
}
function $d190f75ada1eb742$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $d190f75ada1eb742$var$errorOrDestroy(stream, new $d190f75ada1eb742$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($d190f75ada1eb742$var$onwriteError, stream, state, er, cb);
        else $d190f75ada1eb742$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $d190f75ada1eb742$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($d190f75ada1eb742$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $d190f75ada1eb742$var$afterWrite(stream, state, 1, cb);
    }
}
function $d190f75ada1eb742$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $d190f75ada1eb742$var$afterWrite(stream, state, count, cb);
}
function $d190f75ada1eb742$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $d190f75ada1eb742$var$errorBuffer(state);
    $d190f75ada1eb742$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $d190f75ada1eb742$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $d190f75ada1eb742$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$d190f75ada1eb742$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $d190f75ada1eb742$var$ERR_STREAM_DESTROYED('end'));
    }
    $d190f75ada1eb742$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $d190f75ada1eb742$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $d190f75ada1eb742$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $d190f75ada1eb742$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $d190f75ada1eb742$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $d190f75ada1eb742$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $d190f75ada1eb742$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $d190f75ada1eb742$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$d190f75ada1eb742$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $d190f75ada1eb742$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$d190f75ada1eb742$var$Writable.prototype._writev = null;
$d190f75ada1eb742$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $d190f75ada1eb742$var$_write(this, chunk, encoding);
        if (ret instanceof $d190f75ada1eb742$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $d190f75ada1eb742$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $d190f75ada1eb742$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $d190f75ada1eb742$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$d190f75ada1eb742$var$kOnFinished].push(cb);
    }
    return this;
};
function $d190f75ada1eb742$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $d190f75ada1eb742$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $d190f75ada1eb742$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $d190f75ada1eb742$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$d190f75ada1eb742$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $d190f75ada1eb742$var$errorOrDestroy(stream, err, state.sync);
        } else if ($d190f75ada1eb742$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($d190f75ada1eb742$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $d190f75ada1eb742$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $d190f75ada1eb742$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $d190f75ada1eb742$var$finishMaybe(stream, state, sync) {
    if ($d190f75ada1eb742$var$needFinish(state)) {
        $d190f75ada1eb742$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($d190f75ada1eb742$var$needFinish(state)) $d190f75ada1eb742$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($d190f75ada1eb742$var$needFinish(state)) {
                state.pendingcb++;
                $d190f75ada1eb742$var$finish(stream, state);
            }
        }
    }
}
function $d190f75ada1eb742$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$d190f75ada1eb742$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$d190f75ada1eb742$var$ObjectDefineProperties($d190f75ada1eb742$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $d190f75ada1eb742$var$destroy = $3xISh.destroy;
$d190f75ada1eb742$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$d190f75ada1eb742$var$kOnFinished].length)) $2Qkr5.nextTick($d190f75ada1eb742$var$errorBuffer, state);
    $d190f75ada1eb742$var$destroy.call(this, err, cb);
    return this;
};
$d190f75ada1eb742$var$Writable.prototype._undestroy = $3xISh.undestroy;
$d190f75ada1eb742$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$d190f75ada1eb742$var$Writable.prototype[$d190f75ada1eb742$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $d190f75ada1eb742$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d190f75ada1eb742$var$lazyWebStreams() {
    if ($d190f75ada1eb742$var$webStreamsAdapters === undefined) $d190f75ada1eb742$var$webStreamsAdapters = {};
    return $d190f75ada1eb742$var$webStreamsAdapters;
}
$d190f75ada1eb742$var$Writable.fromWeb = function(writableStream, options) {
    return $d190f75ada1eb742$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$d190f75ada1eb742$var$Writable.toWeb = function(streamWritable) {
    return $d190f75ada1eb742$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("6VNBE", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $kAHTL = parcelRequire("kAHTL");

var $gbI0K = parcelRequire("gbI0K");
var $50be8bb71c1ee0be$var$isReadable = $gbI0K.isReadable, $50be8bb71c1ee0be$var$isWritable = $gbI0K.isWritable, $50be8bb71c1ee0be$var$isIterable = $gbI0K.isIterable, $50be8bb71c1ee0be$var$isNodeStream = $gbI0K.isNodeStream, $50be8bb71c1ee0be$var$isReadableNodeStream = $gbI0K.isReadableNodeStream, $50be8bb71c1ee0be$var$isWritableNodeStream = $gbI0K.isWritableNodeStream, $50be8bb71c1ee0be$var$isDuplexNodeStream = $gbI0K.isDuplexNodeStream, $50be8bb71c1ee0be$var$isReadableStream = $gbI0K.isReadableStream, $50be8bb71c1ee0be$var$isWritableStream = $gbI0K.isWritableStream;

var $dF61N = parcelRequire("dF61N");

var $c5mlQ = parcelRequire("c5mlQ");
var $50be8bb71c1ee0be$var$AbortError = $c5mlQ.AbortError, $50be8bb71c1ee0be$var$_require_codes = $c5mlQ.codes, $50be8bb71c1ee0be$var$ERR_INVALID_ARG_TYPE = $50be8bb71c1ee0be$var$_require_codes.ERR_INVALID_ARG_TYPE, $50be8bb71c1ee0be$var$ERR_INVALID_RETURN_VALUE = $50be8bb71c1ee0be$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $3xISh = parcelRequire("3xISh");
var $50be8bb71c1ee0be$require$destroyer = $3xISh.destroyer;

var $7mNYl = parcelRequire("7mNYl");

var $bsrWI = parcelRequire("bsrWI");

var $hZw0T = parcelRequire("hZw0T");

var $9Q0vO = parcelRequire("9Q0vO");
var $50be8bb71c1ee0be$require$createDeferredPromise = $9Q0vO.createDeferredPromise;

var $bay9D = parcelRequire("bay9D");
var $50be8bb71c1ee0be$var$Blob = globalThis.Blob || $kAHTL.Blob;
var $50be8bb71c1ee0be$var$isBlob = typeof $50be8bb71c1ee0be$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $50be8bb71c1ee0be$var$Blob;
} : function isBlob(b) {
    return false;
};

var $50be8bb71c1ee0be$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $2QaiP = parcelRequire("2QaiP");
var $50be8bb71c1ee0be$require$FunctionPrototypeCall = $2QaiP.FunctionPrototypeCall;
// This is needed for pre node 17.
var $50be8bb71c1ee0be$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($7mNYl);
module.exports = function duplexify(body, name) {
    if ($50be8bb71c1ee0be$var$isDuplexNodeStream(body)) return body;
    if ($50be8bb71c1ee0be$var$isReadableNodeStream(body)) return $50be8bb71c1ee0be$var$_duplexify({
        readable: body
    });
    if ($50be8bb71c1ee0be$var$isWritableNodeStream(body)) return $50be8bb71c1ee0be$var$_duplexify({
        writable: body
    });
    if ($50be8bb71c1ee0be$var$isNodeStream(body)) return $50be8bb71c1ee0be$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($50be8bb71c1ee0be$var$isReadableStream(body)) return $50be8bb71c1ee0be$var$_duplexify({
        readable: $bsrWI.fromWeb(body)
    });
    if ($50be8bb71c1ee0be$var$isWritableStream(body)) return $50be8bb71c1ee0be$var$_duplexify({
        writable: $hZw0T.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $50be8bb71c1ee0be$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($50be8bb71c1ee0be$var$isIterable(value)) return $bay9D($50be8bb71c1ee0be$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $50be8bb71c1ee0be$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $50be8bb71c1ee0be$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $50be8bb71c1ee0be$require$destroyer(d, err);
            });
            return d = new $50be8bb71c1ee0be$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $50be8bb71c1ee0be$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($50be8bb71c1ee0be$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($50be8bb71c1ee0be$var$isIterable(body)) return $bay9D($50be8bb71c1ee0be$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($50be8bb71c1ee0be$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $50be8bb71c1ee0be$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $50be8bb71c1ee0be$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $50be8bb71c1ee0be$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $50be8bb71c1ee0be$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $50be8bb71c1ee0be$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $50be8bb71c1ee0be$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $50be8bb71c1ee0be$require$destroyer(d1, err);
        });
        return d1 = new $50be8bb71c1ee0be$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $50be8bb71c1ee0be$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $50be8bb71c1ee0be$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $50be8bb71c1ee0be$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $50be8bb71c1ee0be$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $50be8bb71c1ee0be$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $50be8bb71c1ee0be$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $50be8bb71c1ee0be$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $bsrWI.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$50be8bb71c1ee0be$var$isReadable(r);
    var writable = !!$50be8bb71c1ee0be$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $50be8bb71c1ee0be$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $dF61N(w, function(err) {
            writable = false;
            if (err) $50be8bb71c1ee0be$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $dF61N(r, function(err) {
            readable = false;
            if (err) $50be8bb71c1ee0be$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $50be8bb71c1ee0be$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $50be8bb71c1ee0be$require$destroyer(w, err);
            $50be8bb71c1ee0be$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2B1wE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $1e40386c354b2058$require$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf;
module.exports = $1e40386c354b2058$var$PassThrough;

var $gzOD2 = parcelRequire("gzOD2");
$1e40386c354b2058$require$ObjectSetPrototypeOf($1e40386c354b2058$var$PassThrough.prototype, $gzOD2.prototype);
$1e40386c354b2058$require$ObjectSetPrototypeOf($1e40386c354b2058$var$PassThrough, $gzOD2);
function $1e40386c354b2058$var$PassThrough(options) {
    if (!(this instanceof $1e40386c354b2058$var$PassThrough)) return new $1e40386c354b2058$var$PassThrough(options);
    $gzOD2.call(this, options);
}
$1e40386c354b2058$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("gzOD2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $c1173006c5af23df$var$ObjectSetPrototypeOf = $2QaiP.ObjectSetPrototypeOf, $c1173006c5af23df$var$Symbol = $2QaiP.Symbol;
module.exports = $c1173006c5af23df$var$Transform;

var $c1173006c5af23df$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("c5mlQ")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $7mNYl = parcelRequire("7mNYl");

var $1vd7s = parcelRequire("1vd7s");
var $c1173006c5af23df$require$getHighWaterMark = $1vd7s.getHighWaterMark;
$c1173006c5af23df$var$ObjectSetPrototypeOf($c1173006c5af23df$var$Transform.prototype, $7mNYl.prototype);
$c1173006c5af23df$var$ObjectSetPrototypeOf($c1173006c5af23df$var$Transform, $7mNYl);
var $c1173006c5af23df$var$kCallback = $c1173006c5af23df$var$Symbol('kCallback');
function $c1173006c5af23df$var$Transform(options) {
    if (!(this instanceof $c1173006c5af23df$var$Transform)) return new $c1173006c5af23df$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $c1173006c5af23df$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $7mNYl.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$c1173006c5af23df$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $c1173006c5af23df$var$prefinish);
}
function $c1173006c5af23df$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $c1173006c5af23df$var$prefinish() {
    if (this._final !== $c1173006c5af23df$var$_final) $c1173006c5af23df$var$_final.call(this);
}
$c1173006c5af23df$var$Transform.prototype._final = $c1173006c5af23df$var$_final;
$c1173006c5af23df$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $c1173006c5af23df$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$c1173006c5af23df$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$c1173006c5af23df$var$kCallback] = callback;
    });
};
$c1173006c5af23df$var$Transform.prototype._read = function() {
    if (this[$c1173006c5af23df$var$kCallback]) {
        var callback = this[$c1173006c5af23df$var$kCallback];
        this[$c1173006c5af23df$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("hEuiV", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $2QaiP = parcelRequire("2QaiP");
var $cd9dade792b66c2d$var$ArrayPrototypePop = $2QaiP.ArrayPrototypePop, $cd9dade792b66c2d$var$Promise = $2QaiP.Promise;

var $gbI0K = parcelRequire("gbI0K");
var $cd9dade792b66c2d$var$isIterable = $gbI0K.isIterable, $cd9dade792b66c2d$var$isNodeStream = $gbI0K.isNodeStream, $cd9dade792b66c2d$var$isWebStream = $gbI0K.isWebStream;

var $hgLi3 = parcelRequire("hgLi3");
var $cd9dade792b66c2d$var$pl = $hgLi3.pipelineImpl;

var $dF61N = parcelRequire("dF61N");
var $cd9dade792b66c2d$require$finished = $dF61N.finished;
parcelRequire("6ycIt");
function $cd9dade792b66c2d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $cd9dade792b66c2d$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$cd9dade792b66c2d$var$isNodeStream(lastArg) && !$cd9dade792b66c2d$var$isIterable(lastArg) && !$cd9dade792b66c2d$var$isWebStream(lastArg)) {
            var options = $cd9dade792b66c2d$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $cd9dade792b66c2d$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $cd9dade792b66c2d$require$finished,
    pipeline: $cd9dade792b66c2d$var$pipeline
};

});





parcelRegister("73pWo", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceParse = module.exports.getMediaTypeFromExtension = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $7S0Kx = parcelRequire("7S0Kx");

var $gdNaB = parcelRequire("gdNaB");
/**
 * Get the media type based on the extension of the given path,
 * which can be an URL or file path.
 * @param {string} path A path.
 * @param {Record<string, string>} mediaMappings A collection of mappings,
 * mapping file extensions to their corresponding media type.
 * @return {string} A media type or the empty string.
 */ function $522cef8ba71e857d$var$getMediaTypeFromExtension(path, mediaMappings) {
    var dotIndex = path.lastIndexOf('.');
    // Get extension after last dot and map to media
    // eslint-disable-next-line ts/prefer-nullish-coalescing
    return dotIndex >= 0 && (mediaMappings === null || mediaMappings === void 0 ? void 0 : mediaMappings[path.slice(dotIndex + 1)]) || '';
}
module.exports.getMediaTypeFromExtension = $522cef8ba71e857d$var$getMediaTypeFromExtension;
/**
 * An abstract actor that handles dereference and parse actions.
 *
 * Actor types:
 * Input:  IActionDereferenceParse:      A URL.
 * Test:   <none>
 * Output: IActorDereferenceParseOutput: A data stream of type output by the Parser.
 *
 */ var $522cef8ba71e857d$var$ActorDereferenceParse = /*#__PURE__*/ function(_ActorDereferenceBase_1_ActorDereferenceBase) {
    (0, $i3fW3._)(ActorDereferenceParse, _ActorDereferenceBase_1_ActorDereferenceBase);
    function ActorDereferenceParse(args) {
        (0, $jGAMp._)(this, ActorDereferenceParse);
        return (0, $kzDuW._)(this, ActorDereferenceParse, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereferenceParse, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            /**
     * If hard errors are disabled, modify the given stream so that errors are delegated to the logger.
     * @param {IActionDereferenceParse} action A dereference action.
     * @param {Readable} data A data stream.
     * @return {Readable} The resulting data stream.
     */ key: "handleDereferenceStreamErrors",
            value: function handleDereferenceStreamErrors(action, data) {
                var _this = this;
                // If we don't emit hard errors, make parsing error events log instead, and silence them downstream.
                if (!(0, $gdNaB.isHardError)(action.context)) {
                    data.on('error', function(error) {
                        _this.logWarn(action.context, error.message, function() {
                            return {
                                url: action.url
                            };
                        });
                        // Make sure the errored stream is ended.
                        data.push(null);
                    });
                    data = data.pipe(new $7S0Kx.PassThrough({
                        objectMode: true
                    }));
                }
                return data;
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, context, dereference, result, _, _1, _tmp, _tmp1, _tmp2, error, _dereference_data_close, _dereference_data, _dereference_data_close1, _dereference_data1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                context = action.context;
                                return [
                                    4,
                                    this.mediatorDereference.mediate((0, $emQHU._)((0, $iT0je._)({}, action), {
                                        mediaTypes: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _this, _this_mediatorParseMediatypes;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                (_this_mediatorParseMediatypes = this.mediatorParseMediatypes) === null || _this_mediatorParseMediatypes === void 0 ? void 0 : _this_mediatorParseMediatypes.mediate({
                                                                    context: context,
                                                                    mediaTypes: true
                                                                })
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (_this = _state.sent()) === null || _this === void 0 ? void 0 : _this.mediaTypes
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        }
                                    }))
                                ];
                            case 1:
                                dereference = _state.sent();
                                if (!dereference.exists) return [
                                    3,
                                    9
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    8
                                ]);
                                _1 = (_ = this.mediatorParse).mediate;
                                _tmp = {
                                    context: context
                                };
                                _tmp1 = [
                                    (0, $iT0je._)({
                                        context: context
                                    }, dereference)
                                ];
                                _tmp2 = {};
                                return [
                                    4,
                                    this.getMetadata(dereference)
                                ];
                            case 3:
                                return [
                                    4,
                                    _1.apply(_, [
                                        (_tmp.handle = (0, $emQHU._).apply(void 0, _tmp1.concat([
                                            (_tmp2.metadata = _state.sent(), _tmp2)
                                        ])), _tmp.// eslint-disable-next-line ts/prefer-nullish-coalescing
                                        handleMediaType = dereference.mediaType || action.mediaType || $522cef8ba71e857d$var$getMediaTypeFromExtension(dereference.url, this.mediaMappings), _tmp)
                                    ])
                                ];
                            case 4:
                                result = _state.sent().handle;
                                result.data = this.handleDereferenceStreamErrors(action, result.data);
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                error = _state.sent();
                                // Close the body, to avoid process to hang
                                return [
                                    4,
                                    (_dereference_data_close = (_dereference_data = dereference.data).close) === null || _dereference_data_close === void 0 ? void 0 : _dereference_data_close.call(_dereference_data)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    this.dereferenceErrorHandler(action, error, {})
                                ];
                            case 7:
                                result = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                // Close the dereference stream and return an empty response directly to avoid unnecessary processing.
                                // This code is equivalent to the error handler above in the catch clause, but avoids redundant processing.
                                return [
                                    4,
                                    (_dereference_data_close1 = (_dereference_data1 = dereference.data).close) === null || _dereference_data_close1 === void 0 ? void 0 : _dereference_data_close1.call(_dereference_data1)
                                ];
                            case 10:
                                _state.sent();
                                result = {
                                    data: (0, $gdNaB.emptyReadable)()
                                };
                                _state.label = 11;
                            case 11:
                                // Return the parsed stream and any metadata
                                return [
                                    2,
                                    (0, $iT0je._)({}, dereference, result)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorDereferenceParse;
}($gdNaB.ActorDereferenceBase);
module.exports.ActorDereferenceParse = $522cef8ba71e857d$var$ActorDereferenceParse;

});




parcelRegister("kxo2X", function(module, exports) {
"use strict";
var $ef398adfd97b3696$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef398adfd97b3696$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ef398adfd97b3696$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ef398adfd97b3696$var$__exportStar((parcelRequire("c33q1")), module.exports);

});
parcelRegister("c33q1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSortCardinality = void 0;

var $1djTI = parcelRequire("1djTI");

var $kNNoa = parcelRequire("kNNoa");
/**
 * An actor that sorts join entries by increasing cardinality.
 */ var $8c586aba3cf3d126$var$ActorRdfJoinEntriesSortCardinality = /*#__PURE__*/ function(_bus_rdf_join_entries_sort_1_ActorRdfJoinEntriesSort) {
    (0, $i3fW3._)(ActorRdfJoinEntriesSortCardinality, _bus_rdf_join_entries_sort_1_ActorRdfJoinEntriesSort);
    function ActorRdfJoinEntriesSortCardinality(args) {
        (0, $jGAMp._)(this, ActorRdfJoinEntriesSortCardinality);
        return (0, $kzDuW._)(this, ActorRdfJoinEntriesSortCardinality, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinEntriesSortCardinality, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                accuracy: action.entries.length === 0 ? 1 : action.entries.reduce(function(sum, entry) {
                                    return sum + (Number.isFinite(entry.metadata.cardinality.value) ? 1 : 0);
                                }, 0) / action.entries.length
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var entries;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        entries = (0, $7WNf6._)(action.entries).sort(function(entryLeft, entryRight) {
                            return entryLeft.metadata.cardinality.value - entryRight.metadata.cardinality.value;
                        });
                        return [
                            2,
                            {
                                entries: entries
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinEntriesSortCardinality;
}($1djTI.ActorRdfJoinEntriesSort);
module.exports.ActorRdfJoinEntriesSortCardinality = $8c586aba3cf3d126$var$ActorRdfJoinEntriesSortCardinality;

});
parcelRegister("1djTI", function(module, exports) {
"use strict";
var $0e26709efb00d1a0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0e26709efb00d1a0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0e26709efb00d1a0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0e26709efb00d1a0$var$__exportStar((parcelRequire("kKuxw")), module.exports);

});
parcelRegister("kKuxw", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSort = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-join-entries-sort events.
 *
 * Actor types:
 * * Input:  IActionRdfJoinEntriesSort:      Join entries.
 * * Test:   IActorTest:                     Test result.
 * * Output: IActorRdfJoinEntriesSortOutput: The sorted join entries.
 *
 * @see IActionRdfJoinEntriesSort
 * @see IActorTest
 * @see IActorRdfJoinEntriesSortOutput
 */ var $f1afcb0d052b1557$var$ActorRdfJoinEntriesSort = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfJoinEntriesSort, _core_1_Actor);
    function ActorRdfJoinEntriesSort(args) {
        (0, $jGAMp._)(this, ActorRdfJoinEntriesSort);
        return (0, $kzDuW._)(this, ActorRdfJoinEntriesSort, [
            args
        ]);
    }
    return ActorRdfJoinEntriesSort;
}($kNNoa.Actor);
module.exports.ActorRdfJoinEntriesSort = $f1afcb0d052b1557$var$ActorRdfJoinEntriesSort;

});




parcelRegister("lJFm0", function(module, exports) {
"use strict";
var $fd2de0fca522055b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd2de0fca522055b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd2de0fca522055b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fd2de0fca522055b$var$__exportStar((parcelRequire("4QVfE")), module.exports);

});
parcelRegister("4QVfE", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JoinTypes = module.exports.ActorRdfJoinSelectivityVariableCounting = void 0;

var $6b1Mk = parcelRequire("6b1Mk");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Variable Counting RDF Join Selectivity Actor.
 * Based on the "variable counting predicates" heuristic from
 * "SPARQL basic graph pattern optimization using selectivity estimation."
 */ var $38886db0fb54b58b$var$ActorRdfJoinSelectivityVariableCounting = /*#__PURE__*/ function(_bus_rdf_join_selectivity_1_ActorRdfJoinSelectivity) {
    (0, $i3fW3._)(ActorRdfJoinSelectivityVariableCounting, _bus_rdf_join_selectivity_1_ActorRdfJoinSelectivity);
    function ActorRdfJoinSelectivityVariableCounting(args) {
        (0, $jGAMp._)(this, ActorRdfJoinSelectivityVariableCounting);
        return (0, $kzDuW._)(this, ActorRdfJoinSelectivityVariableCounting, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinSelectivityVariableCounting, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                accuracy: 0.5
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.entries.length <= 1) return [
                            2,
                            {
                                selectivity: 1
                            }
                        ];
                        return [
                            2,
                            {
                                selectivity: ActorRdfJoinSelectivityVariableCounting.getOperationsJoinCost(action.entries.map(function(entry) {
                                    return entry.operation;
                                }))
                            }
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "getPatternCost",
            value: function getPatternCost(pattern) {
                var cost = 1;
                if (pattern.subject.termType === 'Variable') cost += 4;
                if (pattern.predicate.termType === 'Variable' || pattern.type === $hSHd8.Algebra.types.PATH) cost += 1;
                if (pattern.object.termType === 'Variable') cost += 2;
                if (pattern.graph.termType === 'Variable') cost += 1;
                return cost / 9;
            }
        },
        {
            key: "getJoinTypes",
            value: function getJoinTypes(operation1, operation2) {
                var joinTypes = [];
                // Check operation1.subject
                if (operation1.subject.termType === 'Variable') {
                    if (operation1.subject.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundSS);
                    if (operation2.type === 'pattern' && operation1.subject.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundSP);
                    if (operation1.subject.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundSO);
                    if (operation1.subject.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundSG);
                } else {
                    if (operation1.subject.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundSS);
                    if (operation2.type === 'pattern' && operation1.subject.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundSP);
                    if (operation1.subject.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundSO);
                    if (operation1.subject.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundSG);
                }
                // Check operation1.predicate
                if (operation1.type === 'pattern') {
                    if (operation1.predicate.termType === 'Variable') {
                        if (operation1.predicate.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundPS);
                        if (operation2.type === 'pattern' && operation1.predicate.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundPP);
                        if (operation1.predicate.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundPO);
                        if (operation1.predicate.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundPG);
                    } else {
                        if (operation1.predicate.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundPS);
                        if (operation2.type === 'pattern' && operation1.predicate.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundPP);
                        if (operation1.predicate.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundPO);
                        if (operation1.predicate.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundPG);
                    }
                }
                // Check operation1.object
                if (operation1.object.termType === 'Variable') {
                    if (operation1.object.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundOS);
                    if (operation2.type === 'pattern' && operation1.object.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundOP);
                    if (operation1.object.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundOO);
                    if (operation1.object.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundOG);
                } else {
                    if (operation1.object.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundOS);
                    if (operation2.type === 'pattern' && operation1.object.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundOP);
                    if (operation1.object.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundOO);
                    if (operation1.object.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundOG);
                }
                // Check operation1.graph
                if (operation1.graph.termType === 'Variable') {
                    if (operation1.graph.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundGS);
                    if (operation2.type === 'pattern' && operation1.graph.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundGP);
                    if (operation1.graph.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundGO);
                    if (operation1.graph.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.unboundGG);
                } else {
                    if (operation1.graph.equals(operation2.subject)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundGS);
                    if (operation2.type === 'pattern' && operation1.graph.equals(operation2.predicate)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundGP);
                    if (operation1.graph.equals(operation2.object)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundGO);
                    if (operation1.graph.equals(operation2.graph)) joinTypes.push($38886db0fb54b58b$var$JoinTypes.boundGG);
                }
                return joinTypes;
            }
        },
        {
            key: "getOperationsPairwiseJoinCost",
            value: function getOperationsPairwiseJoinCost(operation1, operation2) {
                var cost = ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ActorRdfJoinSelectivityVariableCounting.getJoinTypes(operation1, operation2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var joinType = _step.value;
                        switch(joinType){
                            case $38886db0fb54b58b$var$JoinTypes.boundSS:
                                cost -= 4;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundSP:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundSO:
                                cost -= 2;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundSG:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundPS:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundPP:
                                // Special case: patterns with equal (bound) predicates have the highest cost
                                return 1;
                            case $38886db0fb54b58b$var$JoinTypes.boundPO:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundPG:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundOS:
                                cost -= 2;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundOP:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundOO:
                                cost -= 2;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundOG:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundGS:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundGP:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundGO:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.boundGG:
                                cost -= 6;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundSS:
                                cost -= 2;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundSP:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundSO:
                                cost -= 1;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundSG:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundPS:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundPP:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundPO:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundPG:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundOS:
                                cost -= 1;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundOP:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundOO:
                                cost -= 1;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundOG:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundGS:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundGP:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundGO:
                                cost -= 3;
                                break;
                            case $38886db0fb54b58b$var$JoinTypes.unboundGG:
                                cost -= 3;
                                break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return cost / ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST;
            }
        },
        {
            key: "getOperationsJoinCost",
            value: function getOperationsJoinCost(operations) {
                // Determine all operations that select values (patterns and paths)
                var patterns = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var operation = _step.value;
                        var _obj;
                        $hSHd8.Util.recurseOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATTERN, function(pattern) {
                            patterns.push(pattern);
                            return false;
                        }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATH, function(path) {
                            patterns.push(path);
                            return false;
                        }), _obj));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Determine pairwise costs
                var totalCost = 0;
                var costEntries = 0;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = patterns[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var pattern1 = _step1.value;
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = patterns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var pattern2 = _step2.value;
                                if (pattern1 !== pattern2) {
                                    totalCost += ActorRdfJoinSelectivityVariableCounting.getOperationsPairwiseJoinCost(pattern1, pattern2);
                                    costEntries++;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                // If there are no overlapping patterns, the cost is 1
                if (costEntries === 0) return 1;
                // Combine all pairwise costs, and multiply with costs of each pattern separately
                return totalCost / costEntries * patterns.reduce(function(factor, pattern) {
                    return factor * ActorRdfJoinSelectivityVariableCounting.getPatternCost(pattern);
                }, 1);
            }
        }
    ]);
    return ActorRdfJoinSelectivityVariableCounting;
}($6b1Mk.ActorRdfJoinSelectivity);
module.exports.ActorRdfJoinSelectivityVariableCounting = $38886db0fb54b58b$var$ActorRdfJoinSelectivityVariableCounting;
// Calculated as sum of unbound join type costs times 2 (best-case)
$38886db0fb54b58b$var$ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST = 82;
var $38886db0fb54b58b$var$JoinTypes;
(function(JoinTypes) {
    JoinTypes[JoinTypes["boundSS"] = 0] = "boundSS";
    JoinTypes[JoinTypes["boundSP"] = 1] = "boundSP";
    JoinTypes[JoinTypes["boundSO"] = 2] = "boundSO";
    JoinTypes[JoinTypes["boundSG"] = 3] = "boundSG";
    JoinTypes[JoinTypes["boundPS"] = 4] = "boundPS";
    JoinTypes[JoinTypes["boundPP"] = 5] = "boundPP";
    JoinTypes[JoinTypes["boundPO"] = 6] = "boundPO";
    JoinTypes[JoinTypes["boundPG"] = 7] = "boundPG";
    JoinTypes[JoinTypes["boundOS"] = 8] = "boundOS";
    JoinTypes[JoinTypes["boundOP"] = 9] = "boundOP";
    JoinTypes[JoinTypes["boundOO"] = 10] = "boundOO";
    JoinTypes[JoinTypes["boundOG"] = 11] = "boundOG";
    JoinTypes[JoinTypes["boundGS"] = 12] = "boundGS";
    JoinTypes[JoinTypes["boundGP"] = 13] = "boundGP";
    JoinTypes[JoinTypes["boundGO"] = 14] = "boundGO";
    JoinTypes[JoinTypes["boundGG"] = 15] = "boundGG";
    JoinTypes[JoinTypes["unboundSS"] = 16] = "unboundSS";
    JoinTypes[JoinTypes["unboundSP"] = 17] = "unboundSP";
    JoinTypes[JoinTypes["unboundSO"] = 18] = "unboundSO";
    JoinTypes[JoinTypes["unboundSG"] = 19] = "unboundSG";
    JoinTypes[JoinTypes["unboundPS"] = 20] = "unboundPS";
    JoinTypes[JoinTypes["unboundPP"] = 21] = "unboundPP";
    JoinTypes[JoinTypes["unboundPO"] = 22] = "unboundPO";
    JoinTypes[JoinTypes["unboundPG"] = 23] = "unboundPG";
    JoinTypes[JoinTypes["unboundOS"] = 24] = "unboundOS";
    JoinTypes[JoinTypes["unboundOP"] = 25] = "unboundOP";
    JoinTypes[JoinTypes["unboundOO"] = 26] = "unboundOO";
    JoinTypes[JoinTypes["unboundOG"] = 27] = "unboundOG";
    JoinTypes[JoinTypes["unboundGS"] = 28] = "unboundGS";
    JoinTypes[JoinTypes["unboundGP"] = 29] = "unboundGP";
    JoinTypes[JoinTypes["unboundGO"] = 30] = "unboundGO";
    JoinTypes[JoinTypes["unboundGG"] = 31] = "unboundGG";
})($38886db0fb54b58b$var$JoinTypes || (module.exports.JoinTypes = $38886db0fb54b58b$var$JoinTypes = {}));

});
parcelRegister("6b1Mk", function(module, exports) {
"use strict";
var $47f52655519918f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $47f52655519918f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $47f52655519918f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$47f52655519918f0$var$__exportStar((parcelRequire("e4siJ")), module.exports);

});
parcelRegister("e4siJ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSelectivity = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-join-selectivity events.
 *
 * Actor types:
 * * Input:  IActionRdfJoinSelectivity:      Join entries.
 * * Test:   IMediatorTypeAccuracy:          The accuracy of the selectivity calculator.
 * * Output: IActorRdfJoinSelectivityOutput: The calculated join selectivity.
 *
 * @see IActionRdfJoinSelectivity
 * @see IActorRdfJoinSelectivityTest
 * @see IActorRdfJoinSelectivityOutput
 */ var $a3e7646e101527b4$var$ActorRdfJoinSelectivity = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfJoinSelectivity, _core_1_Actor);
    function ActorRdfJoinSelectivity(args) {
        (0, $jGAMp._)(this, ActorRdfJoinSelectivity);
        return (0, $kzDuW._)(this, ActorRdfJoinSelectivity, [
            args
        ]);
    }
    return ActorRdfJoinSelectivity;
}($kNNoa.Actor);
module.exports.ActorRdfJoinSelectivity = $a3e7646e101527b4$var$ActorRdfJoinSelectivity;

});




parcelRegister("2lLvY", function(module, exports) {
"use strict";
var $1b6266615ba94658$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1b6266615ba94658$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1b6266615ba94658$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1b6266615ba94658$var$__exportStar((parcelRequire("eXjsf")), module.exports);

});
parcelRegister("eXjsf", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataPrimaryTopic = void 0;

var $jEtfn = parcelRequire("jEtfn");

var $kNNoa = parcelRequire("kNNoa");

var $676QI = parcelRequire("676QI");
/**
 * An RDF Metadata Actor that splits off the metadata based on the existence of a 'foaf:primaryTopic' link.
 * Only non-triple quad streams are supported.
 */ var $ae35aaab23f668f9$var$ActorRdfMetadataPrimaryTopic = /*#__PURE__*/ function(_bus_rdf_metadata_1_ActorRdfMetadata) {
    (0, $i3fW3._)(ActorRdfMetadataPrimaryTopic, _bus_rdf_metadata_1_ActorRdfMetadata);
    function ActorRdfMetadataPrimaryTopic(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataPrimaryTopic);
        return (0, $kzDuW._)(this, ActorRdfMetadataPrimaryTopic, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataPrimaryTopic, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.triples) return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports non-triple quad streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, data, metadata, attachListeners;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        data = new $676QI.Readable({
                            objectMode: true
                        });
                        metadata = new $676QI.Readable({
                            objectMode: true
                        });
                        // Delay attachment of listeners until the data or metadata stream is being read.
                        attachListeners = function() {
                            // Attach listeners only once
                            data._read = metadata._read = function() {
                            // Do nothing
                            };
                            // Forward errors
                            action.quads.on('error', function(error) {
                                data.emit('error', error);
                                metadata.emit('error', error);
                            });
                            // First pass over data to categorize in graphs,
                            // and to detect the primaryTopic triple.
                            var graphs = {};
                            var endpointIdentifier;
                            var primaryTopics = {};
                            action.quads.on('data', function(quad) {
                                if (quad.predicate.value === 'http://rdfs.org/ns/void#subset' && quad.object.value === action.url) endpointIdentifier = quad.subject.value;
                                else if (quad.predicate.value === 'http://xmlns.com/foaf/0.1/primaryTopic') primaryTopics[quad.object.value] = quad.subject.value;
                                var quads = graphs[quad.graph.value];
                                if (!quads) quads = graphs[quad.graph.value] = [];
                                quads.push(quad);
                            });
                            // When the stream has finished,
                            // determine the appropriate metadata graph,
                            // and emit all quads to the appropriate streams.
                            action.quads.on('end', function() {
                                var metadataGraph = endpointIdentifier ? primaryTopics[endpointIdentifier] : undefined;
                                for(var graphName in graphs)if (graphName === metadataGraph) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = graphs[graphName][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var quad = _step.value;
                                            metadata.push(quad);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    // Also emit metadata to data if requested
                                    if (_this.metadataToData) try {
                                        for(var _iterator1 = graphs[graphName][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var quad1 = _step1.value;
                                            data.push(quad1);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                                _iterator1["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                } else {
                                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator2 = graphs[graphName][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            var quad2 = _step2.value;
                                            data.push(quad2);
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                _iterator2["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    if (!metadataGraph && _this.dataToMetadataOnInvalidMetadataGraph) try {
                                        for(var _iterator3 = graphs[graphName][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var quad3 = _step3.value;
                                            metadata.push(quad3);
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                                _iterator3["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                                data.push(null);
                                metadata.push(null);
                            });
                        };
                        data._read = metadata._read = function() {
                            attachListeners();
                        };
                        return [
                            2,
                            {
                                data: data,
                                metadata: metadata
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfMetadataPrimaryTopic;
}($jEtfn.ActorRdfMetadata);
module.exports.ActorRdfMetadataPrimaryTopic = $ae35aaab23f668f9$var$ActorRdfMetadataPrimaryTopic;

});
parcelRegister("jEtfn", function(module, exports) {
"use strict";
var $e4e87096bdf81543$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4e87096bdf81543$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e4e87096bdf81543$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e4e87096bdf81543$var$__exportStar((parcelRequire("eH6mS")), module.exports);

});
parcelRegister("eH6mS", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadata = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-metadata events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadata:      An RDF quad stream.
 * * Test:   <none>
 * * Output: IActorRdfMetadataOutput: An RDF quad data stream and RDF quad metadata stream.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ var $ab2a05624a5032bf$var$ActorRdfMetadata = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfMetadata, _core_1_Actor);
    function ActorRdfMetadata(args) {
        (0, $jGAMp._)(this, ActorRdfMetadata);
        return (0, $kzDuW._)(this, ActorRdfMetadata, [
            args
        ]);
    }
    return ActorRdfMetadata;
}($kNNoa.Actor);
module.exports.ActorRdfMetadata = $ab2a05624a5032bf$var$ActorRdfMetadata;

});


parcelRegister("676QI", function(module, exports) {
'use strict';

var $5NuOc = parcelRequire("5NuOc");

var $2Hebs = parcelRequire("2Hebs");
var $4738b5a47d338b3c$var$originalDestroy = $5NuOc.Readable.destroy;
module.exports = $5NuOc.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5NuOc._uint8ArrayToBuffer;
module.exports._isUint8Array = $5NuOc._isUint8Array;
module.exports.isDisturbed = $5NuOc.isDisturbed;
module.exports.isErrored = $5NuOc.isErrored;
module.exports.isReadable = $5NuOc.isReadable;
module.exports.Readable = $5NuOc.Readable;
module.exports.Writable = $5NuOc.Writable;
module.exports.Duplex = $5NuOc.Duplex;
module.exports.Transform = $5NuOc.Transform;
module.exports.PassThrough = $5NuOc.PassThrough;
module.exports.addAbortSignal = $5NuOc.addAbortSignal;
module.exports.finished = $5NuOc.finished;
module.exports.destroy = $5NuOc.destroy;
module.exports.destroy = $4738b5a47d338b3c$var$originalDestroy;
module.exports.pipeline = $5NuOc.pipeline;
module.exports.compose = $5NuOc.compose;
Object.defineProperty($5NuOc, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $2Hebs;
    }
});
module.exports.Stream = $5NuOc.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("5NuOc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $hGwiI = parcelRequire("hGwiI");
var $0116dc9a2d0c255e$require$Buffer = $hGwiI.Buffer;

var $g305F = parcelRequire("g305F");
/* replacement end */ var $0116dc9a2d0c255e$var$ObjectDefineProperty = $g305F.ObjectDefineProperty, $0116dc9a2d0c255e$var$ObjectKeys = $g305F.ObjectKeys, $0116dc9a2d0c255e$var$ReflectApply = $g305F.ReflectApply;

var $eaXHl = parcelRequire("eaXHl");
var $0116dc9a2d0c255e$var$_require_promisify = $eaXHl.promisify, $0116dc9a2d0c255e$var$customPromisify = $0116dc9a2d0c255e$var$_require_promisify.custom;

var $6E8Rj = parcelRequire("6E8Rj");
var $0116dc9a2d0c255e$var$streamReturningOperators = $6E8Rj.streamReturningOperators, $0116dc9a2d0c255e$var$promiseReturningOperators = $6E8Rj.promiseReturningOperators;

var $1pEH6 = parcelRequire("1pEH6");
var $0116dc9a2d0c255e$var$ERR_ILLEGAL_CONSTRUCTOR = $1pEH6.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $5QMlg = parcelRequire("5QMlg");

var $4yI6k = parcelRequire("4yI6k");
var $0116dc9a2d0c255e$var$setDefaultHighWaterMark = $4yI6k.setDefaultHighWaterMark, $0116dc9a2d0c255e$var$getDefaultHighWaterMark = $4yI6k.getDefaultHighWaterMark;

var $8eyL4 = parcelRequire("8eyL4");
var $0116dc9a2d0c255e$require$pipeline = $8eyL4.pipeline;

var $fTROH = parcelRequire("fTROH");
var $0116dc9a2d0c255e$require$destroyer = $fTROH.destroyer;

var $hMDLi = parcelRequire("hMDLi");
var $0116dc9a2d0c255e$var$internalBuffer = {};

var $2Hebs = parcelRequire("2Hebs");

var $8kV8l = parcelRequire("8kV8l");

var $0116dc9a2d0c255e$var$Stream = module.exports = (parcelRequire("4EmBp")).Stream;
$0116dc9a2d0c255e$var$Stream.isDestroyed = $8kV8l.isDestroyed;
$0116dc9a2d0c255e$var$Stream.isDisturbed = $8kV8l.isDisturbed;
$0116dc9a2d0c255e$var$Stream.isErrored = $8kV8l.isErrored;
$0116dc9a2d0c255e$var$Stream.isReadable = $8kV8l.isReadable;
$0116dc9a2d0c255e$var$Stream.isWritable = $8kV8l.isWritable;

$0116dc9a2d0c255e$var$Stream.Readable = (parcelRequire("3QMeK"));
var $0116dc9a2d0c255e$var$_iteratorNormalCompletion = true, $0116dc9a2d0c255e$var$_didIteratorError = false, $0116dc9a2d0c255e$var$_iteratorError = undefined;
try {
    for(var $0116dc9a2d0c255e$var$_iterator = $0116dc9a2d0c255e$var$ObjectKeys($0116dc9a2d0c255e$var$streamReturningOperators)[Symbol.iterator](), $0116dc9a2d0c255e$var$_step; !($0116dc9a2d0c255e$var$_iteratorNormalCompletion = ($0116dc9a2d0c255e$var$_step = $0116dc9a2d0c255e$var$_iterator.next()).done); $0116dc9a2d0c255e$var$_iteratorNormalCompletion = true){
        var $0116dc9a2d0c255e$var$key = $0116dc9a2d0c255e$var$_step.value;
        var $0116dc9a2d0c255e$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $0116dc9a2d0c255e$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0116dc9a2d0c255e$var$Stream.Readable.from($0116dc9a2d0c255e$var$ReflectApply($0116dc9a2d0c255e$var$op, this, args));
        };
        var $0116dc9a2d0c255e$var$op = $0116dc9a2d0c255e$var$streamReturningOperators[$0116dc9a2d0c255e$var$key];
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$fn, 'name', {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$op.name
        });
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$fn, 'length', {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$op.length
        });
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$Stream.Readable.prototype, $0116dc9a2d0c255e$var$key, {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0116dc9a2d0c255e$var$_didIteratorError = true;
    $0116dc9a2d0c255e$var$_iteratorError = err;
} finally{
    try {
        if (!$0116dc9a2d0c255e$var$_iteratorNormalCompletion && $0116dc9a2d0c255e$var$_iterator["return"] != null) {
            $0116dc9a2d0c255e$var$_iterator["return"]();
        }
    } finally{
        if ($0116dc9a2d0c255e$var$_didIteratorError) {
            throw $0116dc9a2d0c255e$var$_iteratorError;
        }
    }
}
var $0116dc9a2d0c255e$var$_iteratorNormalCompletion1 = true, $0116dc9a2d0c255e$var$_didIteratorError1 = false, $0116dc9a2d0c255e$var$_iteratorError1 = undefined;
try {
    for(var $0116dc9a2d0c255e$var$_iterator1 = $0116dc9a2d0c255e$var$ObjectKeys($0116dc9a2d0c255e$var$promiseReturningOperators)[Symbol.iterator](), $0116dc9a2d0c255e$var$_step1; !($0116dc9a2d0c255e$var$_iteratorNormalCompletion1 = ($0116dc9a2d0c255e$var$_step1 = $0116dc9a2d0c255e$var$_iterator1.next()).done); $0116dc9a2d0c255e$var$_iteratorNormalCompletion1 = true){
        var $0116dc9a2d0c255e$var$key1 = $0116dc9a2d0c255e$var$_step1.value;
        var $0116dc9a2d0c255e$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $0116dc9a2d0c255e$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0116dc9a2d0c255e$var$ReflectApply($0116dc9a2d0c255e$var$op1, this, args);
        };
        var $0116dc9a2d0c255e$var$op1 = $0116dc9a2d0c255e$var$promiseReturningOperators[$0116dc9a2d0c255e$var$key1];
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$fn1, 'name', {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$op1.name
        });
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$fn1, 'length', {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$op1.length
        });
        $0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$Stream.Readable.prototype, $0116dc9a2d0c255e$var$key1, {
            __proto__: null,
            value: $0116dc9a2d0c255e$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0116dc9a2d0c255e$var$_didIteratorError1 = true;
    $0116dc9a2d0c255e$var$_iteratorError1 = err;
} finally{
    try {
        if (!$0116dc9a2d0c255e$var$_iteratorNormalCompletion1 && $0116dc9a2d0c255e$var$_iterator1["return"] != null) {
            $0116dc9a2d0c255e$var$_iterator1["return"]();
        }
    } finally{
        if ($0116dc9a2d0c255e$var$_didIteratorError1) {
            throw $0116dc9a2d0c255e$var$_iteratorError1;
        }
    }
}

$0116dc9a2d0c255e$var$Stream.Writable = (parcelRequire("3qpeY"));

$0116dc9a2d0c255e$var$Stream.Duplex = (parcelRequire("bF3O9"));

$0116dc9a2d0c255e$var$Stream.Transform = (parcelRequire("4pjmg"));

$0116dc9a2d0c255e$var$Stream.PassThrough = (parcelRequire("dTTZ6"));
$0116dc9a2d0c255e$var$Stream.pipeline = $0116dc9a2d0c255e$require$pipeline;

var $4cAeS = parcelRequire("4cAeS");
var $0116dc9a2d0c255e$require$addAbortSignal = $4cAeS.addAbortSignal;
$0116dc9a2d0c255e$var$Stream.addAbortSignal = $0116dc9a2d0c255e$require$addAbortSignal;
$0116dc9a2d0c255e$var$Stream.finished = $hMDLi;
$0116dc9a2d0c255e$var$Stream.destroy = $0116dc9a2d0c255e$require$destroyer;
$0116dc9a2d0c255e$var$Stream.compose = $5QMlg;
$0116dc9a2d0c255e$var$Stream.setDefaultHighWaterMark = $0116dc9a2d0c255e$var$setDefaultHighWaterMark;
$0116dc9a2d0c255e$var$Stream.getDefaultHighWaterMark = $0116dc9a2d0c255e$var$getDefaultHighWaterMark;
$0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $2Hebs;
    }
});
$0116dc9a2d0c255e$var$ObjectDefineProperty($0116dc9a2d0c255e$require$pipeline, $0116dc9a2d0c255e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2Hebs.pipeline;
    }
});
$0116dc9a2d0c255e$var$ObjectDefineProperty($hMDLi, $0116dc9a2d0c255e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2Hebs.finished;
    }
});
// Backwards-compat with node 0.4.x
$0116dc9a2d0c255e$var$Stream.Stream = $0116dc9a2d0c255e$var$Stream;
$0116dc9a2d0c255e$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$0116dc9a2d0c255e$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $0116dc9a2d0c255e$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("hGwiI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $cdff6a3372a2494f$export$a143d493d941bafc; }, function (v) { return $cdff6a3372a2494f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $cdff6a3372a2494f$export$f99ded8fe4b79145; }, function (v) { return $cdff6a3372a2494f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $cdff6a3372a2494f$export$a143d493d941bafc;
var $cdff6a3372a2494f$export$e4cf37d7f6fb9e0a;
var $cdff6a3372a2494f$export$f99ded8fe4b79145;
var $cdff6a3372a2494f$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $cdff6a3372a2494f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$cdff6a3372a2494f$export$a143d493d941bafc = $cdff6a3372a2494f$var$Buffer;
$cdff6a3372a2494f$export$e4cf37d7f6fb9e0a = $cdff6a3372a2494f$var$SlowBuffer;
$cdff6a3372a2494f$export$f99ded8fe4b79145 = 50;
var $cdff6a3372a2494f$var$K_MAX_LENGTH = 0x7fffffff;
$cdff6a3372a2494f$export$599f31c3813fae4d = $cdff6a3372a2494f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $cdff6a3372a2494f$var$Buffer.TYPED_ARRAY_SUPPORT = $cdff6a3372a2494f$var$typedArraySupport();
if (!$cdff6a3372a2494f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $cdff6a3372a2494f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($cdff6a3372a2494f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$cdff6a3372a2494f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($cdff6a3372a2494f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$cdff6a3372a2494f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $cdff6a3372a2494f$var$createBuffer(length) {
    if (length > $cdff6a3372a2494f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $cdff6a3372a2494f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $cdff6a3372a2494f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $cdff6a3372a2494f$var$allocUnsafe(arg);
    }
    return $cdff6a3372a2494f$var$from(arg, encodingOrOffset, length);
}
$cdff6a3372a2494f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $cdff6a3372a2494f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $cdff6a3372a2494f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $cdff6a3372a2494f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($cdff6a3372a2494f$var$isInstance(value, ArrayBuffer) || value && $cdff6a3372a2494f$var$isInstance(value.buffer, ArrayBuffer)) return $cdff6a3372a2494f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($cdff6a3372a2494f$var$isInstance(value, SharedArrayBuffer) || value && $cdff6a3372a2494f$var$isInstance(value.buffer, SharedArrayBuffer))) return $cdff6a3372a2494f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $cdff6a3372a2494f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $cdff6a3372a2494f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $cdff6a3372a2494f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $cdff6a3372a2494f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $cdff6a3372a2494f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($cdff6a3372a2494f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($cdff6a3372a2494f$var$Buffer, Uint8Array);
function $cdff6a3372a2494f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $cdff6a3372a2494f$var$alloc(size, fill, encoding) {
    $cdff6a3372a2494f$var$assertSize(size);
    if (size <= 0) return $cdff6a3372a2494f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $cdff6a3372a2494f$var$createBuffer(size).fill(fill, encoding) : $cdff6a3372a2494f$var$createBuffer(size).fill(fill);
    return $cdff6a3372a2494f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $cdff6a3372a2494f$var$Buffer.alloc = function(size, fill, encoding) {
    return $cdff6a3372a2494f$var$alloc(size, fill, encoding);
};
function $cdff6a3372a2494f$var$allocUnsafe(size) {
    $cdff6a3372a2494f$var$assertSize(size);
    return $cdff6a3372a2494f$var$createBuffer(size < 0 ? 0 : $cdff6a3372a2494f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $cdff6a3372a2494f$var$Buffer.allocUnsafe = function(size) {
    return $cdff6a3372a2494f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $cdff6a3372a2494f$var$Buffer.allocUnsafeSlow = function(size) {
    return $cdff6a3372a2494f$var$allocUnsafe(size);
};
function $cdff6a3372a2494f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$cdff6a3372a2494f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $cdff6a3372a2494f$var$byteLength(string, encoding) | 0;
    var buf = $cdff6a3372a2494f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $cdff6a3372a2494f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $cdff6a3372a2494f$var$checked(array.length) | 0;
    var buf = $cdff6a3372a2494f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $cdff6a3372a2494f$var$fromArrayView(arrayView) {
    if ($cdff6a3372a2494f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $cdff6a3372a2494f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $cdff6a3372a2494f$var$fromArrayLike(arrayView);
}
function $cdff6a3372a2494f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $cdff6a3372a2494f$var$Buffer.prototype);
    return buf;
}
function $cdff6a3372a2494f$var$fromObject(obj) {
    if ($cdff6a3372a2494f$var$Buffer.isBuffer(obj)) {
        var len = $cdff6a3372a2494f$var$checked(obj.length) | 0;
        var buf = $cdff6a3372a2494f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $cdff6a3372a2494f$var$numberIsNaN(obj.length)) return $cdff6a3372a2494f$var$createBuffer(0);
        return $cdff6a3372a2494f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $cdff6a3372a2494f$var$fromArrayLike(obj.data);
}
function $cdff6a3372a2494f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $cdff6a3372a2494f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $cdff6a3372a2494f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $cdff6a3372a2494f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $cdff6a3372a2494f$var$Buffer.alloc(+length);
}
$cdff6a3372a2494f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $cdff6a3372a2494f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$cdff6a3372a2494f$var$Buffer.compare = function compare(a, b) {
    if ($cdff6a3372a2494f$var$isInstance(a, Uint8Array)) a = $cdff6a3372a2494f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($cdff6a3372a2494f$var$isInstance(b, Uint8Array)) b = $cdff6a3372a2494f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$cdff6a3372a2494f$var$Buffer.isBuffer(a) || !$cdff6a3372a2494f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$cdff6a3372a2494f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$cdff6a3372a2494f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $cdff6a3372a2494f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $cdff6a3372a2494f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($cdff6a3372a2494f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$cdff6a3372a2494f$var$Buffer.isBuffer(buf)) buf = $cdff6a3372a2494f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$cdff6a3372a2494f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $cdff6a3372a2494f$var$byteLength(string, encoding) {
    if ($cdff6a3372a2494f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $cdff6a3372a2494f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $cdff6a3372a2494f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $cdff6a3372a2494f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $cdff6a3372a2494f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$cdff6a3372a2494f$var$Buffer.byteLength = $cdff6a3372a2494f$var$byteLength;
function $cdff6a3372a2494f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $cdff6a3372a2494f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $cdff6a3372a2494f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $cdff6a3372a2494f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $cdff6a3372a2494f$var$latin1Slice(this, start, end);
        case 'base64':
            return $cdff6a3372a2494f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $cdff6a3372a2494f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$cdff6a3372a2494f$var$Buffer.prototype._isBuffer = true;
function $cdff6a3372a2494f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$cdff6a3372a2494f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$cdff6a3372a2494f$var$swap(this, i, i + 1);
    return this;
};
$cdff6a3372a2494f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $cdff6a3372a2494f$var$swap(this, i, i + 3);
        $cdff6a3372a2494f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$cdff6a3372a2494f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $cdff6a3372a2494f$var$swap(this, i, i + 7);
        $cdff6a3372a2494f$var$swap(this, i + 1, i + 6);
        $cdff6a3372a2494f$var$swap(this, i + 2, i + 5);
        $cdff6a3372a2494f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$cdff6a3372a2494f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $cdff6a3372a2494f$var$utf8Slice(this, 0, length);
    return $cdff6a3372a2494f$var$slowToString.apply(this, arguments);
};
$cdff6a3372a2494f$var$Buffer.prototype.toLocaleString = $cdff6a3372a2494f$var$Buffer.prototype.toString;
$cdff6a3372a2494f$var$Buffer.prototype.equals = function equals(b) {
    if (!$cdff6a3372a2494f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $cdff6a3372a2494f$var$Buffer.compare(this, b) === 0;
};
$cdff6a3372a2494f$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $cdff6a3372a2494f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($cdff6a3372a2494f$var$customInspectSymbol) $cdff6a3372a2494f$var$Buffer.prototype[$cdff6a3372a2494f$var$customInspectSymbol] = $cdff6a3372a2494f$var$Buffer.prototype.inspect;
$cdff6a3372a2494f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($cdff6a3372a2494f$var$isInstance(target, Uint8Array)) target = $cdff6a3372a2494f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$cdff6a3372a2494f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $cdff6a3372a2494f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($cdff6a3372a2494f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $cdff6a3372a2494f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($cdff6a3372a2494f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $cdff6a3372a2494f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $cdff6a3372a2494f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $cdff6a3372a2494f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$cdff6a3372a2494f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$cdff6a3372a2494f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $cdff6a3372a2494f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$cdff6a3372a2494f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $cdff6a3372a2494f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $cdff6a3372a2494f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($cdff6a3372a2494f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $cdff6a3372a2494f$var$utf8Write(buf, string, offset, length) {
    return $cdff6a3372a2494f$var$blitBuffer($cdff6a3372a2494f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $cdff6a3372a2494f$var$asciiWrite(buf, string, offset, length) {
    return $cdff6a3372a2494f$var$blitBuffer($cdff6a3372a2494f$var$asciiToBytes(string), buf, offset, length);
}
function $cdff6a3372a2494f$var$base64Write(buf, string, offset, length) {
    return $cdff6a3372a2494f$var$blitBuffer($cdff6a3372a2494f$var$base64ToBytes(string), buf, offset, length);
}
function $cdff6a3372a2494f$var$ucs2Write(buf, string, offset, length) {
    return $cdff6a3372a2494f$var$blitBuffer($cdff6a3372a2494f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$cdff6a3372a2494f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $cdff6a3372a2494f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $cdff6a3372a2494f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $cdff6a3372a2494f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $cdff6a3372a2494f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $cdff6a3372a2494f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$cdff6a3372a2494f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $cdff6a3372a2494f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $cdff6a3372a2494f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $cdff6a3372a2494f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $cdff6a3372a2494f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $cdff6a3372a2494f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $cdff6a3372a2494f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $cdff6a3372a2494f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $cdff6a3372a2494f$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $cdff6a3372a2494f$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $cdff6a3372a2494f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $cdff6a3372a2494f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $cdff6a3372a2494f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$cdff6a3372a2494f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $cdff6a3372a2494f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $cdff6a3372a2494f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$cdff6a3372a2494f$var$Buffer.prototype.readUintLE = $cdff6a3372a2494f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readUintBE = $cdff6a3372a2494f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readUint8 = $cdff6a3372a2494f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$cdff6a3372a2494f$var$Buffer.prototype.readUint16LE = $cdff6a3372a2494f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$cdff6a3372a2494f$var$Buffer.prototype.readUint16BE = $cdff6a3372a2494f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$cdff6a3372a2494f$var$Buffer.prototype.readUint32LE = $cdff6a3372a2494f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$cdff6a3372a2494f$var$Buffer.prototype.readUint32BE = $cdff6a3372a2494f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$cdff6a3372a2494f$var$Buffer.prototype.readBigUInt64LE = $cdff6a3372a2494f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $cdff6a3372a2494f$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $cdff6a3372a2494f$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$cdff6a3372a2494f$var$Buffer.prototype.readBigUInt64BE = $cdff6a3372a2494f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $cdff6a3372a2494f$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $cdff6a3372a2494f$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$cdff6a3372a2494f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$cdff6a3372a2494f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cdff6a3372a2494f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$cdff6a3372a2494f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$cdff6a3372a2494f$var$Buffer.prototype.readBigInt64LE = $cdff6a3372a2494f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $cdff6a3372a2494f$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $cdff6a3372a2494f$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$cdff6a3372a2494f$var$Buffer.prototype.readBigInt64BE = $cdff6a3372a2494f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $cdff6a3372a2494f$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $cdff6a3372a2494f$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$cdff6a3372a2494f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$cdff6a3372a2494f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$cdff6a3372a2494f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$cdff6a3372a2494f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $cdff6a3372a2494f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$cdff6a3372a2494f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$cdff6a3372a2494f$var$Buffer.prototype.writeUintLE = $cdff6a3372a2494f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cdff6a3372a2494f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUintBE = $cdff6a3372a2494f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cdff6a3372a2494f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUint8 = $cdff6a3372a2494f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUint16LE = $cdff6a3372a2494f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUint16BE = $cdff6a3372a2494f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUint32LE = $cdff6a3372a2494f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeUint32BE = $cdff6a3372a2494f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $cdff6a3372a2494f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $cdff6a3372a2494f$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $cdff6a3372a2494f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $cdff6a3372a2494f$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$cdff6a3372a2494f$var$Buffer.prototype.writeBigUInt64LE = $cdff6a3372a2494f$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $cdff6a3372a2494f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$cdff6a3372a2494f$var$Buffer.prototype.writeBigUInt64BE = $cdff6a3372a2494f$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $cdff6a3372a2494f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$cdff6a3372a2494f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cdff6a3372a2494f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cdff6a3372a2494f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$cdff6a3372a2494f$var$Buffer.prototype.writeBigInt64LE = $cdff6a3372a2494f$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $cdff6a3372a2494f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$cdff6a3372a2494f$var$Buffer.prototype.writeBigInt64BE = $cdff6a3372a2494f$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $cdff6a3372a2494f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $cdff6a3372a2494f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $cdff6a3372a2494f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$cdff6a3372a2494f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $cdff6a3372a2494f$var$writeFloat(this, value, offset, true, noAssert);
};
$cdff6a3372a2494f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $cdff6a3372a2494f$var$writeFloat(this, value, offset, false, noAssert);
};
function $cdff6a3372a2494f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cdff6a3372a2494f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$cdff6a3372a2494f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $cdff6a3372a2494f$var$writeDouble(this, value, offset, true, noAssert);
};
$cdff6a3372a2494f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $cdff6a3372a2494f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$cdff6a3372a2494f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$cdff6a3372a2494f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$cdff6a3372a2494f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$cdff6a3372a2494f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $cdff6a3372a2494f$var$Buffer.isBuffer(val) ? val : $cdff6a3372a2494f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $cdff6a3372a2494f$var$errors = {};
function $cdff6a3372a2494f$var$E(sym, getMessage, Base) {
    $cdff6a3372a2494f$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$cdff6a3372a2494f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$cdff6a3372a2494f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$cdff6a3372a2494f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $cdff6a3372a2494f$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $cdff6a3372a2494f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $cdff6a3372a2494f$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $cdff6a3372a2494f$var$checkBounds(buf, offset, byteLength) {
    $cdff6a3372a2494f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $cdff6a3372a2494f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $cdff6a3372a2494f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $cdff6a3372a2494f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $cdff6a3372a2494f$var$checkBounds(buf, offset, byteLength);
}
function $cdff6a3372a2494f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $cdff6a3372a2494f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $cdff6a3372a2494f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $cdff6a3372a2494f$var$validateNumber(value, type);
        throw new $cdff6a3372a2494f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $cdff6a3372a2494f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $cdff6a3372a2494f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $cdff6a3372a2494f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $cdff6a3372a2494f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($cdff6a3372a2494f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $cdff6a3372a2494f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $cdff6a3372a2494f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $cdff6a3372a2494f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $cdff6a3372a2494f$var$base64ToBytes(str) {
    return $abUaD.toByteArray($cdff6a3372a2494f$var$base64clean(str));
}
function $cdff6a3372a2494f$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $cdff6a3372a2494f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $cdff6a3372a2494f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $cdff6a3372a2494f$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $cdff6a3372a2494f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $cdff6a3372a2494f$var$BufferBigIntNotDefined : fn;
}
function $cdff6a3372a2494f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("g305F", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $baecff208876590a$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $baecff208876590a$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("eaXHl", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hGwiI = parcelRequire("hGwiI");

var $8YYDw = parcelRequire("8YYDw");
var $a5204ea979c7deb0$var$format = $8YYDw.format, $a5204ea979c7deb0$var$inspect = $8YYDw.inspect;

var $1pEH6 = parcelRequire("1pEH6");
var $a5204ea979c7deb0$var$ERR_INVALID_ARG_TYPE = $1pEH6.codes.ERR_INVALID_ARG_TYPE;

var $g305F = parcelRequire("g305F");
var $a5204ea979c7deb0$var$kResistStopPropagation = $g305F.kResistStopPropagation, $a5204ea979c7deb0$var$AggregateError = $g305F.AggregateError, $a5204ea979c7deb0$var$SymbolDispose = $g305F.SymbolDispose;

var $a5204ea979c7deb0$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $a5204ea979c7deb0$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $a5204ea979c7deb0$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $a5204ea979c7deb0$var$Blob = globalThis.Blob || $hGwiI.Blob;
/* eslint-disable indent */ var $a5204ea979c7deb0$var$isBlob = typeof $a5204ea979c7deb0$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $a5204ea979c7deb0$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $a5204ea979c7deb0$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $a5204ea979c7deb0$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $a5204ea979c7deb0$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $a5204ea979c7deb0$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $a5204ea979c7deb0$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $a5204ea979c7deb0$var$format,
    inspect: $a5204ea979c7deb0$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $a5204ea979c7deb0$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $a5204ea979c7deb0$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $a5204ea979c7deb0$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $a5204ea979c7deb0$var$validateAbortSignal(signal, 'signal');
        $a5204ea979c7deb0$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $a5204ea979c7deb0$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $a5204ea979c7deb0$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $a5204ea979c7deb0$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $a5204ea979c7deb0$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $a5204ea979c7deb0$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("8YYDw", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("1pEH6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $8YYDw = parcelRequire("8YYDw");
var $1077b1491aa99e49$var$format = $8YYDw.format, $1077b1491aa99e49$var$inspect = $8YYDw.inspect;

var $g305F = parcelRequire("g305F");
var $1077b1491aa99e49$var$CustomAggregateError = $g305F.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $1077b1491aa99e49$var$AggregateError = globalThis.AggregateError || $1077b1491aa99e49$var$CustomAggregateError;
var $1077b1491aa99e49$var$kIsNodeError = Symbol('kIsNodeError');
var $1077b1491aa99e49$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $1077b1491aa99e49$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $1077b1491aa99e49$var$nodeInternalPrefix = '__node_internal_';
var $1077b1491aa99e49$var$codes = {};
function $1077b1491aa99e49$var$assert(value, message) {
    if (!value) throw new $1077b1491aa99e49$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $1077b1491aa99e49$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $1077b1491aa99e49$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $1077b1491aa99e49$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $1077b1491aa99e49$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $1077b1491aa99e49$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $1077b1491aa99e49$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $1077b1491aa99e49$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$1077b1491aa99e49$var$kIsNodeError] = true;
    $1077b1491aa99e49$var$codes[code] = NodeError;
}
function $1077b1491aa99e49$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $1077b1491aa99e49$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $1077b1491aa99e49$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $1077b1491aa99e49$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $1077b1491aa99e49$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $1077b1491aa99e49$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$1077b1491aa99e49$var$E('ERR_ASSERTION', '%s', Error);
$1077b1491aa99e49$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $1077b1491aa99e49$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $1077b1491aa99e49$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($1077b1491aa99e49$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($1077b1491aa99e49$var$classRegExp.test(value)) instances.push(value);
            else {
                $1077b1491aa99e49$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $1077b1491aa99e49$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $1077b1491aa99e49$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$1077b1491aa99e49$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $1077b1491aa99e49$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$1077b1491aa99e49$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$1077b1491aa99e49$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $1077b1491aa99e49$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$1077b1491aa99e49$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $1077b1491aa99e49$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $1077b1491aa99e49$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $1077b1491aa99e49$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $1077b1491aa99e49$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$1077b1491aa99e49$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$1077b1491aa99e49$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$1077b1491aa99e49$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$1077b1491aa99e49$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$1077b1491aa99e49$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $1077b1491aa99e49$var$AbortError,
    aggregateTwoErrors: $1077b1491aa99e49$var$hideStackFrames($1077b1491aa99e49$var$aggregateTwoErrors),
    hideStackFrames: $1077b1491aa99e49$var$hideStackFrames,
    codes: $1077b1491aa99e49$var$codes
};

});


parcelRegister("6E8Rj", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $4d6d59b3d59fadb5$export$42af8c323be37587; }, function (v) { return $4d6d59b3d59fadb5$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $4d6d59b3d59fadb5$export$f405f72c701dad87; }, function (v) { return $4d6d59b3d59fadb5$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $4d6d59b3d59fadb5$export$42af8c323be37587;
var $4d6d59b3d59fadb5$export$f405f72c701dad87;
'use strict';

var $4d6d59b3d59fadb5$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $1pEH6 = parcelRequire("1pEH6");
var $4d6d59b3d59fadb5$var$_require_codes = $1pEH6.codes, $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_VALUE = $4d6d59b3d59fadb5$var$_require_codes.ERR_INVALID_ARG_VALUE, $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE = $4d6d59b3d59fadb5$var$_require_codes.ERR_INVALID_ARG_TYPE, $4d6d59b3d59fadb5$var$ERR_MISSING_ARGS = $4d6d59b3d59fadb5$var$_require_codes.ERR_MISSING_ARGS, $4d6d59b3d59fadb5$var$ERR_OUT_OF_RANGE = $4d6d59b3d59fadb5$var$_require_codes.ERR_OUT_OF_RANGE, $4d6d59b3d59fadb5$var$AbortError = $1pEH6.AbortError;

var $bKizF = parcelRequire("bKizF");
var $4d6d59b3d59fadb5$var$validateAbortSignal = $bKizF.validateAbortSignal, $4d6d59b3d59fadb5$var$validateInteger = $bKizF.validateInteger, $4d6d59b3d59fadb5$var$validateObject = $bKizF.validateObject;

var $4d6d59b3d59fadb5$var$kWeakHandler = (parcelRequire("g305F")).Symbol('kWeak');

var $4d6d59b3d59fadb5$var$kResistStopPropagation = (parcelRequire("g305F")).Symbol('kResistStopPropagation');

var $hMDLi = parcelRequire("hMDLi");
var $4d6d59b3d59fadb5$require$finished = $hMDLi.finished;

var $5QMlg = parcelRequire("5QMlg");

var $4cAeS = parcelRequire("4cAeS");
var $4d6d59b3d59fadb5$require$addAbortSignalNoValidate = $4cAeS.addAbortSignalNoValidate;

var $8kV8l = parcelRequire("8kV8l");
var $4d6d59b3d59fadb5$var$isWritable = $8kV8l.isWritable, $4d6d59b3d59fadb5$var$isNodeStream = $8kV8l.isNodeStream;

var $4d6d59b3d59fadb5$require$deprecate = (parcelRequire("eaXHl")).deprecate;

var $4d6d59b3d59fadb5$var$ArrayPrototypePush = (parcelRequire("g305F")).ArrayPrototypePush, $4d6d59b3d59fadb5$var$Boolean = (parcelRequire("g305F")).Boolean, $4d6d59b3d59fadb5$var$MathFloor = (parcelRequire("g305F")).MathFloor, $4d6d59b3d59fadb5$var$Number = (parcelRequire("g305F")).Number, $4d6d59b3d59fadb5$var$NumberIsNaN = (parcelRequire("g305F")).NumberIsNaN, $4d6d59b3d59fadb5$var$Promise = (parcelRequire("g305F")).Promise, $4d6d59b3d59fadb5$var$PromiseReject = (parcelRequire("g305F")).PromiseReject, $4d6d59b3d59fadb5$var$PromiseResolve = (parcelRequire("g305F")).PromiseResolve, $4d6d59b3d59fadb5$var$PromisePrototypeThen = (parcelRequire("g305F")).PromisePrototypeThen, $4d6d59b3d59fadb5$var$Symbol = (parcelRequire("g305F")).Symbol;
var $4d6d59b3d59fadb5$var$kEmpty = $4d6d59b3d59fadb5$var$Symbol('kEmpty');
var $4d6d59b3d59fadb5$var$kEof = $4d6d59b3d59fadb5$var$Symbol('kEof');
function $4d6d59b3d59fadb5$var$compose(stream, options) {
    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
    if ($4d6d59b3d59fadb5$var$isNodeStream(stream) && !$4d6d59b3d59fadb5$var$isWritable(stream)) throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $5QMlg(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $4d6d59b3d59fadb5$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $4d6d59b3d59fadb5$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $4d6d59b3d59fadb5$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $4d6d59b3d59fadb5$var$MathFloor(options.highWaterMark);
    $4d6d59b3d59fadb5$var$validateInteger(concurrency, 'options.concurrency', 1);
    $4d6d59b3d59fadb5$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $4d6d59b3d59fadb5$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $4d6d59b3d59fadb5$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $4d6d59b3d59fadb5$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $4d6d59b3d59fadb5$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $4d6d59b3d59fadb5$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($4d6d59b3d59fadb5$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $4d6d59b3d59fadb5$var$PromiseReject(err1);
                                $4d6d59b3d59fadb5$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("eaXHl")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($4d6d59b3d59fadb5$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $4d6d59b3d59fadb5$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                        if (!(val !== $4d6d59b3d59fadb5$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $4d6d59b3d59fadb5$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4d6d59b3d59fadb5$var$asIndexedPairs(options) {
    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $4d6d59b3d59fadb5$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4d6d59b3d59fadb5$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4d6d59b3d59fadb5$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $4d6d59b3d59fadb5$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $4d6d59b3d59fadb5$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $4d6d59b3d59fadb5$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4d6d59b3d59fadb5$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $4d6d59b3d59fadb5$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $4d6d59b3d59fadb5$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4d6d59b3d59fadb5$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $4d6d59b3d59fadb5$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $4d6d59b3d59fadb5$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $4d6d59b3d59fadb5$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $4d6d59b3d59fadb5$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($4d6d59b3d59fadb5$var$ERR_MISSING_ARGS);
function $4d6d59b3d59fadb5$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $4d6d59b3d59fadb5$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $4d6d59b3d59fadb5$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $4d6d59b3d59fadb5$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $4d6d59b3d59fadb5$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $4d6d59b3d59fadb5$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $4d6d59b3d59fadb5$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $4d6d59b3d59fadb5$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $4d6d59b3d59fadb5$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $4d6d59b3d59fadb5$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $4d6d59b3d59fadb5$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $4d6d59b3d59fadb5$var$flatMap(fn, options) {
    var values = $4d6d59b3d59fadb5$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $4d6d59b3d59fadb5$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $4d6d59b3d59fadb5$var$Number(number);
    if ($4d6d59b3d59fadb5$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $4d6d59b3d59fadb5$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $4d6d59b3d59fadb5$var$drop(number, options) {
    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4d6d59b3d59fadb5$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4d6d59b3d59fadb5$var$take(number, options) {
    if (options != null) $4d6d59b3d59fadb5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4d6d59b3d59fadb5$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4d6d59b3d59fadb5$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $4d6d59b3d59fadb5$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$4d6d59b3d59fadb5$export$42af8c323be37587 = {
    asIndexedPairs: $4d6d59b3d59fadb5$require$deprecate($4d6d59b3d59fadb5$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $4d6d59b3d59fadb5$var$drop,
    filter: $4d6d59b3d59fadb5$var$filter,
    flatMap: $4d6d59b3d59fadb5$var$flatMap,
    map: $4d6d59b3d59fadb5$var$map,
    take: $4d6d59b3d59fadb5$var$take,
    compose: $4d6d59b3d59fadb5$var$compose
};
$4d6d59b3d59fadb5$export$f405f72c701dad87 = {
    every: $4d6d59b3d59fadb5$var$every,
    forEach: $4d6d59b3d59fadb5$var$forEach,
    reduce: $4d6d59b3d59fadb5$var$reduce,
    toArray: $4d6d59b3d59fadb5$var$toArray,
    some: $4d6d59b3d59fadb5$var$some,
    find: $4d6d59b3d59fadb5$var$find
};

});
parcelRegister("bKizF", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $g305F = parcelRequire("g305F");
var $88d2661243a09a6f$var$ArrayIsArray = $g305F.ArrayIsArray, $88d2661243a09a6f$var$ArrayPrototypeIncludes = $g305F.ArrayPrototypeIncludes, $88d2661243a09a6f$var$ArrayPrototypeJoin = $g305F.ArrayPrototypeJoin, $88d2661243a09a6f$var$ArrayPrototypeMap = $g305F.ArrayPrototypeMap, $88d2661243a09a6f$var$NumberIsInteger = $g305F.NumberIsInteger, $88d2661243a09a6f$var$NumberIsNaN = $g305F.NumberIsNaN, $88d2661243a09a6f$var$NumberMAX_SAFE_INTEGER = $g305F.NumberMAX_SAFE_INTEGER, $88d2661243a09a6f$var$NumberMIN_SAFE_INTEGER = $g305F.NumberMIN_SAFE_INTEGER, $88d2661243a09a6f$var$NumberParseInt = $g305F.NumberParseInt, $88d2661243a09a6f$var$ObjectPrototypeHasOwnProperty = $g305F.ObjectPrototypeHasOwnProperty, $88d2661243a09a6f$var$RegExpPrototypeExec = $g305F.RegExpPrototypeExec, $88d2661243a09a6f$var$String = $g305F.String, $88d2661243a09a6f$var$StringPrototypeToUpperCase = $g305F.StringPrototypeToUpperCase, $88d2661243a09a6f$var$StringPrototypeTrim = $g305F.StringPrototypeTrim;

var $1pEH6 = parcelRequire("1pEH6");
var $88d2661243a09a6f$var$hideStackFrames = $1pEH6.hideStackFrames, $88d2661243a09a6f$var$_require_codes = $1pEH6.codes, $88d2661243a09a6f$var$ERR_SOCKET_BAD_PORT = $88d2661243a09a6f$var$_require_codes.ERR_SOCKET_BAD_PORT, $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE = $88d2661243a09a6f$var$_require_codes.ERR_INVALID_ARG_TYPE, $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE = $88d2661243a09a6f$var$_require_codes.ERR_INVALID_ARG_VALUE, $88d2661243a09a6f$var$ERR_OUT_OF_RANGE = $88d2661243a09a6f$var$_require_codes.ERR_OUT_OF_RANGE, $88d2661243a09a6f$var$ERR_UNKNOWN_SIGNAL = $88d2661243a09a6f$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $eaXHl = parcelRequire("eaXHl");
var $88d2661243a09a6f$require$normalizeEncoding = $eaXHl.normalizeEncoding;

var $eaXHl = parcelRequire("eaXHl");
var $88d2661243a09a6f$require$_require_types = $eaXHl.types;
var $88d2661243a09a6f$var$isAsyncFunction = $88d2661243a09a6f$require$_require_types.isAsyncFunction, $88d2661243a09a6f$var$isArrayBufferView = $88d2661243a09a6f$require$_require_types.isArrayBufferView;
var $88d2661243a09a6f$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $88d2661243a09a6f$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $88d2661243a09a6f$var$isUint32(value) {
    return value === value >>> 0;
}
var $88d2661243a09a6f$var$octalReg = /^[0-7]+$/;
var $88d2661243a09a6f$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $88d2661243a09a6f$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($88d2661243a09a6f$var$RegExpPrototypeExec($88d2661243a09a6f$var$octalReg, value) === null) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE(name, value, $88d2661243a09a6f$var$modeDesc);
        value = $88d2661243a09a6f$var$NumberParseInt(value, 8);
    }
    $88d2661243a09a6f$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $88d2661243a09a6f$var$validateInteger = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $88d2661243a09a6f$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $88d2661243a09a6f$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$88d2661243a09a6f$var$NumberIsInteger(value)) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $88d2661243a09a6f$var$validateInt32 = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$88d2661243a09a6f$var$NumberIsInteger(value)) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $88d2661243a09a6f$var$validateUint32 = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$88d2661243a09a6f$var$NumberIsInteger(value)) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $88d2661243a09a6f$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $88d2661243a09a6f$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $88d2661243a09a6f$var$NumberIsNaN(value)) throw new $88d2661243a09a6f$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $88d2661243a09a6f$var$validateOneOf = $88d2661243a09a6f$var$hideStackFrames(function(value, name, oneOf) {
    if (!$88d2661243a09a6f$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $88d2661243a09a6f$var$ArrayPrototypeJoin($88d2661243a09a6f$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $88d2661243a09a6f$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $88d2661243a09a6f$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $88d2661243a09a6f$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$88d2661243a09a6f$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $88d2661243a09a6f$var$validateObject = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $88d2661243a09a6f$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $88d2661243a09a6f$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $88d2661243a09a6f$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $88d2661243a09a6f$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $88d2661243a09a6f$var$validateDictionary = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $88d2661243a09a6f$var$validateArray = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$88d2661243a09a6f$var$ArrayIsArray(value)) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $88d2661243a09a6f$var$validateStringArray(value, name) {
    $88d2661243a09a6f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$88d2661243a09a6f$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $88d2661243a09a6f$var$validateBooleanArray(value, name) {
    $88d2661243a09a6f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$88d2661243a09a6f$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $88d2661243a09a6f$var$validateAbortSignalArray(value, name) {
    $88d2661243a09a6f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $88d2661243a09a6f$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $88d2661243a09a6f$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $88d2661243a09a6f$var$validateString(signal, name);
    if ($88d2661243a09a6f$var$signals[signal] === undefined) {
        if ($88d2661243a09a6f$var$signals[$88d2661243a09a6f$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $88d2661243a09a6f$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $88d2661243a09a6f$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $88d2661243a09a6f$var$validateBuffer = $88d2661243a09a6f$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$88d2661243a09a6f$var$isArrayBufferView(buffer)) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $88d2661243a09a6f$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $88d2661243a09a6f$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $88d2661243a09a6f$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $88d2661243a09a6f$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $88d2661243a09a6f$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $88d2661243a09a6f$var$validateAbortSignal = $88d2661243a09a6f$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $88d2661243a09a6f$var$validateFunction = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $88d2661243a09a6f$var$validatePlainFunction = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $88d2661243a09a6f$var$isAsyncFunction(value)) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $88d2661243a09a6f$var$validateUndefined = $88d2661243a09a6f$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $88d2661243a09a6f$var$validateUnion(value, name, union) {
    if (!$88d2661243a09a6f$var$ArrayPrototypeIncludes(union, value)) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_TYPE(name, "('".concat($88d2661243a09a6f$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $88d2661243a09a6f$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $88d2661243a09a6f$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$88d2661243a09a6f$var$RegExpPrototypeExec($88d2661243a09a6f$var$linkValueRegExp, value)) throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $88d2661243a09a6f$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $88d2661243a09a6f$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($88d2661243a09a6f$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $88d2661243a09a6f$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $88d2661243a09a6f$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $88d2661243a09a6f$var$isInt32,
    isUint32: $88d2661243a09a6f$var$isUint32,
    parseFileMode: $88d2661243a09a6f$var$parseFileMode,
    validateArray: $88d2661243a09a6f$var$validateArray,
    validateStringArray: $88d2661243a09a6f$var$validateStringArray,
    validateBooleanArray: $88d2661243a09a6f$var$validateBooleanArray,
    validateAbortSignalArray: $88d2661243a09a6f$var$validateAbortSignalArray,
    validateBoolean: $88d2661243a09a6f$var$validateBoolean,
    validateBuffer: $88d2661243a09a6f$var$validateBuffer,
    validateDictionary: $88d2661243a09a6f$var$validateDictionary,
    validateEncoding: $88d2661243a09a6f$var$validateEncoding,
    validateFunction: $88d2661243a09a6f$var$validateFunction,
    validateInt32: $88d2661243a09a6f$var$validateInt32,
    validateInteger: $88d2661243a09a6f$var$validateInteger,
    validateNumber: $88d2661243a09a6f$var$validateNumber,
    validateObject: $88d2661243a09a6f$var$validateObject,
    validateOneOf: $88d2661243a09a6f$var$validateOneOf,
    validatePlainFunction: $88d2661243a09a6f$var$validatePlainFunction,
    validatePort: $88d2661243a09a6f$var$validatePort,
    validateSignalName: $88d2661243a09a6f$var$validateSignalName,
    validateString: $88d2661243a09a6f$var$validateString,
    validateUint32: $88d2661243a09a6f$var$validateUint32,
    validateUndefined: $88d2661243a09a6f$var$validateUndefined,
    validateUnion: $88d2661243a09a6f$var$validateUnion,
    validateAbortSignal: $88d2661243a09a6f$var$validateAbortSignal,
    validateLinkHeaderValue: $88d2661243a09a6f$var$validateLinkHeaderValue
};

});

parcelRegister("hMDLi", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $1pEH6 = parcelRequire("1pEH6");
/* replacement end */ var $cf25c33a5f5ee8db$var$AbortError = $1pEH6.AbortError, $cf25c33a5f5ee8db$var$codes = $1pEH6.codes;
var $cf25c33a5f5ee8db$var$ERR_INVALID_ARG_TYPE = $cf25c33a5f5ee8db$var$codes.ERR_INVALID_ARG_TYPE, $cf25c33a5f5ee8db$var$ERR_STREAM_PREMATURE_CLOSE = $cf25c33a5f5ee8db$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $cf25c33a5f5ee8db$var$kEmptyObject = (parcelRequire("eaXHl")).kEmptyObject, $cf25c33a5f5ee8db$var$once = (parcelRequire("eaXHl")).once;

var $bKizF = parcelRequire("bKizF");
var $cf25c33a5f5ee8db$var$validateAbortSignal = $bKizF.validateAbortSignal, $cf25c33a5f5ee8db$var$validateFunction = $bKizF.validateFunction, $cf25c33a5f5ee8db$var$validateObject = $bKizF.validateObject, $cf25c33a5f5ee8db$var$validateBoolean = $bKizF.validateBoolean;

var $g305F = parcelRequire("g305F");
var $cf25c33a5f5ee8db$var$Promise = $g305F.Promise, $cf25c33a5f5ee8db$var$PromisePrototypeThen = $g305F.PromisePrototypeThen, $cf25c33a5f5ee8db$var$SymbolDispose = $g305F.SymbolDispose;

var $8kV8l = parcelRequire("8kV8l");
var $cf25c33a5f5ee8db$var$isClosed = $8kV8l.isClosed, $cf25c33a5f5ee8db$var$isReadable = $8kV8l.isReadable, $cf25c33a5f5ee8db$var$isReadableNodeStream = $8kV8l.isReadableNodeStream, $cf25c33a5f5ee8db$var$isReadableStream = $8kV8l.isReadableStream, $cf25c33a5f5ee8db$var$isReadableFinished = $8kV8l.isReadableFinished, $cf25c33a5f5ee8db$var$isReadableErrored = $8kV8l.isReadableErrored, $cf25c33a5f5ee8db$var$isWritable = $8kV8l.isWritable, $cf25c33a5f5ee8db$var$isWritableNodeStream = $8kV8l.isWritableNodeStream, $cf25c33a5f5ee8db$var$isWritableStream = $8kV8l.isWritableStream, $cf25c33a5f5ee8db$var$isWritableFinished = $8kV8l.isWritableFinished, $cf25c33a5f5ee8db$var$isWritableErrored = $8kV8l.isWritableErrored, $cf25c33a5f5ee8db$var$isNodeStream = $8kV8l.isNodeStream, $cf25c33a5f5ee8db$var$_willEmitClose = $8kV8l.willEmitClose, $cf25c33a5f5ee8db$var$kIsClosedPromise = $8kV8l.kIsClosedPromise;
var $cf25c33a5f5ee8db$var$addAbortListener;
function $cf25c33a5f5ee8db$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $cf25c33a5f5ee8db$var$nop = function() {};

function $cf25c33a5f5ee8db$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $cf25c33a5f5ee8db$var$kEmptyObject;
    } else if (options == null) options = $cf25c33a5f5ee8db$var$kEmptyObject;
    else $cf25c33a5f5ee8db$var$validateObject(options, 'options');
    $cf25c33a5f5ee8db$var$validateFunction(callback, 'callback');
    $cf25c33a5f5ee8db$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $cf25c33a5f5ee8db$var$once(callback);
    if ($cf25c33a5f5ee8db$var$isReadableStream(stream) || $cf25c33a5f5ee8db$var$isWritableStream(stream)) return $cf25c33a5f5ee8db$var$eosWeb(stream, options, callback);
    if (!$cf25c33a5f5ee8db$var$isNodeStream(stream)) throw new $cf25c33a5f5ee8db$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $cf25c33a5f5ee8db$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $cf25c33a5f5ee8db$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $cf25c33a5f5ee8db$var$_willEmitClose(stream) && $cf25c33a5f5ee8db$var$isReadableNodeStream(stream) === readable && $cf25c33a5f5ee8db$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $cf25c33a5f5ee8db$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $cf25c33a5f5ee8db$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $cf25c33a5f5ee8db$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $cf25c33a5f5ee8db$var$isWritableErrored(stream) || $cf25c33a5f5ee8db$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $cf25c33a5f5ee8db$var$isReadableNodeStream(stream, true)) {
            if (!$cf25c33a5f5ee8db$var$isReadableFinished(stream, false)) return callback.call(stream, new $cf25c33a5f5ee8db$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$cf25c33a5f5ee8db$var$isWritableFinished(stream, false)) return callback.call(stream, new $cf25c33a5f5ee8db$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $cf25c33a5f5ee8db$var$isWritableErrored(stream) || $cf25c33a5f5ee8db$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($cf25c33a5f5ee8db$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $cf25c33a5f5ee8db$var$isReadable(stream)) && (writableFinished || $cf25c33a5f5ee8db$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $cf25c33a5f5ee8db$var$isWritable(stream)) && (readableFinished || $cf25c33a5f5ee8db$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $cf25c33a5f5ee8db$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $cf25c33a5f5ee8db$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $cf25c33a5f5ee8db$var$addAbortListener = $cf25c33a5f5ee8db$var$addAbortListener || (parcelRequire("eaXHl")).addAbortListener;
            var disposable = $cf25c33a5f5ee8db$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $cf25c33a5f5ee8db$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$cf25c33a5f5ee8db$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $cf25c33a5f5ee8db$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $cf25c33a5f5ee8db$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $cf25c33a5f5ee8db$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $cf25c33a5f5ee8db$var$addAbortListener = $cf25c33a5f5ee8db$var$addAbortListener || (parcelRequire("eaXHl")).addAbortListener;
            var disposable = $cf25c33a5f5ee8db$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $cf25c33a5f5ee8db$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$cf25c33a5f5ee8db$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $cf25c33a5f5ee8db$var$PromisePrototypeThen(stream[$cf25c33a5f5ee8db$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $cf25c33a5f5ee8db$var$nop;
}
function $cf25c33a5f5ee8db$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $cf25c33a5f5ee8db$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $cf25c33a5f5ee8db$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $cf25c33a5f5ee8db$var$Promise(function(resolve, reject) {
        var cleanup = $cf25c33a5f5ee8db$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $cf25c33a5f5ee8db$var$eos;
module.exports.finished = $cf25c33a5f5ee8db$var$finished;

});
parcelRegister("8kV8l", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $g305F = parcelRequire("g305F");
var $611c828a152aa70d$var$SymbolAsyncIterator = $g305F.SymbolAsyncIterator, $611c828a152aa70d$var$SymbolIterator = $g305F.SymbolIterator, $611c828a152aa70d$var$SymbolFor = $g305F.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $611c828a152aa70d$var$kIsDestroyed = $611c828a152aa70d$var$SymbolFor('nodejs.stream.destroyed');
var $611c828a152aa70d$var$kIsErrored = $611c828a152aa70d$var$SymbolFor('nodejs.stream.errored');
var $611c828a152aa70d$var$kIsReadable = $611c828a152aa70d$var$SymbolFor('nodejs.stream.readable');
var $611c828a152aa70d$var$kIsWritable = $611c828a152aa70d$var$SymbolFor('nodejs.stream.writable');
var $611c828a152aa70d$var$kIsDisturbed = $611c828a152aa70d$var$SymbolFor('nodejs.stream.disturbed');
var $611c828a152aa70d$var$kIsClosedPromise = $611c828a152aa70d$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $611c828a152aa70d$var$kControllerErrorFunction = $611c828a152aa70d$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $611c828a152aa70d$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $611c828a152aa70d$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $611c828a152aa70d$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $611c828a152aa70d$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $611c828a152aa70d$var$isReadableStream(obj) {
    return !!(obj && !$611c828a152aa70d$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $611c828a152aa70d$var$isWritableStream(obj) {
    return !!(obj && !$611c828a152aa70d$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $611c828a152aa70d$var$isTransformStream(obj) {
    return !!(obj && !$611c828a152aa70d$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $611c828a152aa70d$var$isWebStream(obj) {
    return $611c828a152aa70d$var$isReadableStream(obj) || $611c828a152aa70d$var$isWritableStream(obj) || $611c828a152aa70d$var$isTransformStream(obj);
}
function $611c828a152aa70d$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$611c828a152aa70d$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$611c828a152aa70d$var$SymbolIterator] === 'function';
    return typeof obj[$611c828a152aa70d$var$SymbolAsyncIterator] === 'function' || typeof obj[$611c828a152aa70d$var$SymbolIterator] === 'function';
}
function $611c828a152aa70d$var$isDestroyed(stream) {
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$611c828a152aa70d$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $611c828a152aa70d$var$isWritableEnded(stream) {
    if (!$611c828a152aa70d$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $611c828a152aa70d$var$isWritableFinished(stream, strict) {
    if (!$611c828a152aa70d$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $611c828a152aa70d$var$isReadableEnded(stream) {
    if (!$611c828a152aa70d$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $611c828a152aa70d$var$isReadableFinished(stream, strict) {
    if (!$611c828a152aa70d$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $611c828a152aa70d$var$isReadable(stream) {
    if (stream && stream[$611c828a152aa70d$var$kIsReadable] != null) return stream[$611c828a152aa70d$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($611c828a152aa70d$var$isDestroyed(stream)) return false;
    return $611c828a152aa70d$var$isReadableNodeStream(stream) && stream.readable && !$611c828a152aa70d$var$isReadableFinished(stream);
}
function $611c828a152aa70d$var$isWritable(stream) {
    if (stream && stream[$611c828a152aa70d$var$kIsWritable] != null) return stream[$611c828a152aa70d$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($611c828a152aa70d$var$isDestroyed(stream)) return false;
    return $611c828a152aa70d$var$isWritableNodeStream(stream) && stream.writable && !$611c828a152aa70d$var$isWritableEnded(stream);
}
function $611c828a152aa70d$var$isFinished(stream, opts) {
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    if ($611c828a152aa70d$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $611c828a152aa70d$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $611c828a152aa70d$var$isWritable(stream)) return false;
    return true;
}
function $611c828a152aa70d$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $611c828a152aa70d$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $611c828a152aa70d$var$isClosed(stream) {
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $611c828a152aa70d$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $611c828a152aa70d$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $611c828a152aa70d$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $611c828a152aa70d$var$isOutgoingMessage(stream);
}
function $611c828a152aa70d$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $611c828a152aa70d$var$willEmitClose(stream) {
    if (!$611c828a152aa70d$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $611c828a152aa70d$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $611c828a152aa70d$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$611c828a152aa70d$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $611c828a152aa70d$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$611c828a152aa70d$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $611c828a152aa70d$var$isDestroyed,
    kIsDestroyed: $611c828a152aa70d$var$kIsDestroyed,
    isDisturbed: $611c828a152aa70d$var$isDisturbed,
    kIsDisturbed: $611c828a152aa70d$var$kIsDisturbed,
    isErrored: $611c828a152aa70d$var$isErrored,
    kIsErrored: $611c828a152aa70d$var$kIsErrored,
    isReadable: $611c828a152aa70d$var$isReadable,
    kIsReadable: $611c828a152aa70d$var$kIsReadable,
    kIsClosedPromise: $611c828a152aa70d$var$kIsClosedPromise,
    kControllerErrorFunction: $611c828a152aa70d$var$kControllerErrorFunction,
    kIsWritable: $611c828a152aa70d$var$kIsWritable,
    isClosed: $611c828a152aa70d$var$isClosed,
    isDuplexNodeStream: $611c828a152aa70d$var$isDuplexNodeStream,
    isFinished: $611c828a152aa70d$var$isFinished,
    isIterable: $611c828a152aa70d$var$isIterable,
    isReadableNodeStream: $611c828a152aa70d$var$isReadableNodeStream,
    isReadableStream: $611c828a152aa70d$var$isReadableStream,
    isReadableEnded: $611c828a152aa70d$var$isReadableEnded,
    isReadableFinished: $611c828a152aa70d$var$isReadableFinished,
    isReadableErrored: $611c828a152aa70d$var$isReadableErrored,
    isNodeStream: $611c828a152aa70d$var$isNodeStream,
    isWebStream: $611c828a152aa70d$var$isWebStream,
    isWritable: $611c828a152aa70d$var$isWritable,
    isWritableNodeStream: $611c828a152aa70d$var$isWritableNodeStream,
    isWritableStream: $611c828a152aa70d$var$isWritableStream,
    isWritableEnded: $611c828a152aa70d$var$isWritableEnded,
    isWritableFinished: $611c828a152aa70d$var$isWritableFinished,
    isWritableErrored: $611c828a152aa70d$var$isWritableErrored,
    isServerRequest: $611c828a152aa70d$var$isServerRequest,
    isServerResponse: $611c828a152aa70d$var$isServerResponse,
    willEmitClose: $611c828a152aa70d$var$willEmitClose,
    isTransformStream: $611c828a152aa70d$var$isTransformStream
};

});


parcelRegister("5QMlg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $8eyL4 = parcelRequire("8eyL4");
var $44274ec32f4c3dad$require$pipeline = $8eyL4.pipeline;

var $bF3O9 = parcelRequire("bF3O9");

var $fTROH = parcelRequire("fTROH");
var $44274ec32f4c3dad$require$destroyer = $fTROH.destroyer;

var $8kV8l = parcelRequire("8kV8l");
var $44274ec32f4c3dad$var$isNodeStream = $8kV8l.isNodeStream, $44274ec32f4c3dad$var$isReadable = $8kV8l.isReadable, $44274ec32f4c3dad$var$isWritable = $8kV8l.isWritable, $44274ec32f4c3dad$var$isWebStream = $8kV8l.isWebStream, $44274ec32f4c3dad$var$isTransformStream = $8kV8l.isTransformStream, $44274ec32f4c3dad$var$isWritableStream = $8kV8l.isWritableStream, $44274ec32f4c3dad$var$isReadableStream = $8kV8l.isReadableStream;

var $1pEH6 = parcelRequire("1pEH6");
var $44274ec32f4c3dad$var$AbortError = $1pEH6.AbortError, $44274ec32f4c3dad$var$_require_codes = $1pEH6.codes, $44274ec32f4c3dad$var$ERR_INVALID_ARG_VALUE = $44274ec32f4c3dad$var$_require_codes.ERR_INVALID_ARG_VALUE, $44274ec32f4c3dad$var$ERR_MISSING_ARGS = $44274ec32f4c3dad$var$_require_codes.ERR_MISSING_ARGS;

var $hMDLi = parcelRequire("hMDLi");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $44274ec32f4c3dad$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $bF3O9.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $bF3O9.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $bF3O9.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$44274ec32f4c3dad$var$isNodeStream(streams[n]) && !$44274ec32f4c3dad$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($44274ec32f4c3dad$var$isReadable(streams[n]) || $44274ec32f4c3dad$var$isReadableStream(streams[n]) || $44274ec32f4c3dad$var$isTransformStream(streams[n]))) throw new $44274ec32f4c3dad$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($44274ec32f4c3dad$var$isWritable(streams[n]) || $44274ec32f4c3dad$var$isWritableStream(streams[n]) || $44274ec32f4c3dad$var$isTransformStream(streams[n]))) throw new $44274ec32f4c3dad$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $44274ec32f4c3dad$require$pipeline(streams, onfinished);
    var writable = !!($44274ec32f4c3dad$var$isWritable(head) || $44274ec32f4c3dad$var$isWritableStream(head) || $44274ec32f4c3dad$var$isTransformStream(head));
    var readable = !!($44274ec32f4c3dad$var$isReadable(tail) || $44274ec32f4c3dad$var$isReadableStream(tail) || $44274ec32f4c3dad$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $bF3O9({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($44274ec32f4c3dad$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($44274ec32f4c3dad$var$isWebStream(head)) {
            var writable1 = $44274ec32f4c3dad$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $44274ec32f4c3dad$var$isTransformStream(tail) ? tail.readable : tail;
        $hMDLi(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($44274ec32f4c3dad$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($44274ec32f4c3dad$var$isWebStream(tail)) {
            var readable1 = $44274ec32f4c3dad$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $44274ec32f4c3dad$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($44274ec32f4c3dad$var$isNodeStream(tail)) $44274ec32f4c3dad$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("8eyL4", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $g305F = parcelRequire("g305F");
var $5fea97ce22629fc3$var$ArrayIsArray = $g305F.ArrayIsArray, $5fea97ce22629fc3$var$Promise = $g305F.Promise, $5fea97ce22629fc3$var$SymbolAsyncIterator = $g305F.SymbolAsyncIterator, $5fea97ce22629fc3$var$SymbolDispose = $g305F.SymbolDispose;

var $hMDLi = parcelRequire("hMDLi");

var $5fea97ce22629fc3$require$once = (parcelRequire("eaXHl")).once;

var $fTROH = parcelRequire("fTROH");

var $bF3O9 = parcelRequire("bF3O9");

var $1pEH6 = parcelRequire("1pEH6");
var $5fea97ce22629fc3$var$aggregateTwoErrors = $1pEH6.aggregateTwoErrors, $5fea97ce22629fc3$var$_require_codes = $1pEH6.codes, $5fea97ce22629fc3$var$ERR_INVALID_ARG_TYPE = $5fea97ce22629fc3$var$_require_codes.ERR_INVALID_ARG_TYPE, $5fea97ce22629fc3$var$ERR_INVALID_RETURN_VALUE = $5fea97ce22629fc3$var$_require_codes.ERR_INVALID_RETURN_VALUE, $5fea97ce22629fc3$var$ERR_MISSING_ARGS = $5fea97ce22629fc3$var$_require_codes.ERR_MISSING_ARGS, $5fea97ce22629fc3$var$ERR_STREAM_DESTROYED = $5fea97ce22629fc3$var$_require_codes.ERR_STREAM_DESTROYED, $5fea97ce22629fc3$var$ERR_STREAM_PREMATURE_CLOSE = $5fea97ce22629fc3$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $5fea97ce22629fc3$var$AbortError = $1pEH6.AbortError;

var $bKizF = parcelRequire("bKizF");
var $5fea97ce22629fc3$var$validateFunction = $bKizF.validateFunction, $5fea97ce22629fc3$var$validateAbortSignal = $bKizF.validateAbortSignal;

var $8kV8l = parcelRequire("8kV8l");
var $5fea97ce22629fc3$var$isIterable = $8kV8l.isIterable, $5fea97ce22629fc3$var$isReadable = $8kV8l.isReadable, $5fea97ce22629fc3$var$isReadableNodeStream = $8kV8l.isReadableNodeStream, $5fea97ce22629fc3$var$isNodeStream = $8kV8l.isNodeStream, $5fea97ce22629fc3$var$isTransformStream = $8kV8l.isTransformStream, $5fea97ce22629fc3$var$isWebStream = $8kV8l.isWebStream, $5fea97ce22629fc3$var$isReadableStream = $8kV8l.isReadableStream, $5fea97ce22629fc3$var$isReadableFinished = $8kV8l.isReadableFinished;

var $5fea97ce22629fc3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $5fea97ce22629fc3$var$PassThrough;
var $5fea97ce22629fc3$var$Readable;
var $5fea97ce22629fc3$var$addAbortListener;
function $5fea97ce22629fc3$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $hMDLi(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $fTROH.destroyer(stream, err || new $5fea97ce22629fc3$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $5fea97ce22629fc3$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $5fea97ce22629fc3$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $5fea97ce22629fc3$var$makeAsyncIterable(val) {
    if ($5fea97ce22629fc3$var$isIterable(val)) return val;
    else if ($5fea97ce22629fc3$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $5fea97ce22629fc3$var$fromReadable(val);
    throw new $5fea97ce22629fc3$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $5fea97ce22629fc3$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$5fea97ce22629fc3$var$Readable) $5fea97ce22629fc3$var$Readable = (parcelRequire("3QMeK"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($5fea97ce22629fc3$var$Readable.prototype[$5fea97ce22629fc3$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $5fea97ce22629fc3$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $5fea97ce22629fc3$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $hMDLi(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $5fea97ce22629fc3$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $5fea97ce22629fc3$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($5fea97ce22629fc3$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $5fea97ce22629fc3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $5fea97ce22629fc3$var$pipelineImpl(streams, $5fea97ce22629fc3$require$once($5fea97ce22629fc3$var$popCallback(streams)));
}


function $5fea97ce22629fc3$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($5fea97ce22629fc3$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $5fea97ce22629fc3$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($5fea97ce22629fc3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($5fea97ce22629fc3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$5fea97ce22629fc3$var$isIterable(ret)) throw new $5fea97ce22629fc3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($5fea97ce22629fc3$var$isIterable(stream) || $5fea97ce22629fc3$var$isReadableNodeStream(stream) || $5fea97ce22629fc3$var$isTransformStream(stream)) ret = stream;
            else ret = $bF3O9.from(stream);
        } else if (typeof stream === 'function') {
            if ($5fea97ce22629fc3$var$isTransformStream(ret)) {
                var _ret;
                ret = $5fea97ce22629fc3$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $5fea97ce22629fc3$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$5fea97ce22629fc3$var$isIterable(ret, true)) throw new $5fea97ce22629fc3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$5fea97ce22629fc3$var$PassThrough) $5fea97ce22629fc3$var$PassThrough = (parcelRequire("dTTZ6"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $5fea97ce22629fc3$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($5fea97ce22629fc3$var$isIterable(ret, true)) {
                    finishCount++;
                    $5fea97ce22629fc3$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($5fea97ce22629fc3$var$isReadableStream(ret) || $5fea97ce22629fc3$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $5fea97ce22629fc3$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $5fea97ce22629fc3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $5fea97ce22629fc3$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($5fea97ce22629fc3$var$isNodeStream(stream)) {
            if ($5fea97ce22629fc3$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $5fea97ce22629fc3$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($5fea97ce22629fc3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($5fea97ce22629fc3$var$isTransformStream(ret) || $5fea97ce22629fc3$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $5fea97ce22629fc3$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($5fea97ce22629fc3$var$isIterable(ret)) {
                finishCount++;
                $5fea97ce22629fc3$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $5fea97ce22629fc3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($5fea97ce22629fc3$var$isWebStream(stream)) {
            if ($5fea97ce22629fc3$var$isReadableNodeStream(ret)) {
                finishCount++;
                $5fea97ce22629fc3$var$pumpToWeb($5fea97ce22629fc3$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($5fea97ce22629fc3$var$isReadableStream(ret) || $5fea97ce22629fc3$var$isIterable(ret)) {
                finishCount++;
                $5fea97ce22629fc3$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($5fea97ce22629fc3$var$isTransformStream(ret)) {
                finishCount++;
                $5fea97ce22629fc3$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $5fea97ce22629fc3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $bF3O9.from(stream);
    };
    if (streams.length === 1 && $5fea97ce22629fc3$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5fea97ce22629fc3$var$ERR_MISSING_ARGS('streams');
    var ac = new $5fea97ce22629fc3$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $5fea97ce22629fc3$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $5fea97ce22629fc3$var$AbortError());
    }
    $5fea97ce22629fc3$var$addAbortListener = $5fea97ce22629fc3$var$addAbortListener || (parcelRequire("eaXHl")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $5fea97ce22629fc3$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$5fea97ce22629fc3$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $5fea97ce22629fc3$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $5fea97ce22629fc3$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($5fea97ce22629fc3$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $hMDLi(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $hMDLi(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $5fea97ce22629fc3$var$pipelineImpl,
    pipeline: $5fea97ce22629fc3$var$pipeline
};

});
parcelRegister("fTROH", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $1pEH6 = parcelRequire("1pEH6");
/* replacement end */ var $b935bcf3dd87c3b0$var$aggregateTwoErrors = $1pEH6.aggregateTwoErrors, $b935bcf3dd87c3b0$var$ERR_MULTIPLE_CALLBACK = $1pEH6.codes.ERR_MULTIPLE_CALLBACK, $b935bcf3dd87c3b0$var$AbortError = $1pEH6.AbortError;

var $g305F = parcelRequire("g305F");
var $b935bcf3dd87c3b0$require$Symbol = $g305F.Symbol;

var $8kV8l = parcelRequire("8kV8l");
var $b935bcf3dd87c3b0$var$kIsDestroyed = $8kV8l.kIsDestroyed, $b935bcf3dd87c3b0$var$isDestroyed = $8kV8l.isDestroyed, $b935bcf3dd87c3b0$var$isFinished = $8kV8l.isFinished, $b935bcf3dd87c3b0$var$isServerRequest = $8kV8l.isServerRequest;
var $b935bcf3dd87c3b0$var$kDestroy = $b935bcf3dd87c3b0$require$Symbol('kDestroy');
var $b935bcf3dd87c3b0$var$kConstruct = $b935bcf3dd87c3b0$require$Symbol('kConstruct');
function $b935bcf3dd87c3b0$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $b935bcf3dd87c3b0$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $b935bcf3dd87c3b0$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($b935bcf3dd87c3b0$var$kDestroy, function(er) {
        $b935bcf3dd87c3b0$var$_destroy(this, $b935bcf3dd87c3b0$var$aggregateTwoErrors(er, err), cb);
    });
    else $b935bcf3dd87c3b0$var$_destroy(this, err, cb);
    return this;
}
function $b935bcf3dd87c3b0$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $b935bcf3dd87c3b0$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $b935bcf3dd87c3b0$var$emitErrorCloseNT(self, err) {
    $b935bcf3dd87c3b0$var$emitErrorNT(self, err);
    $b935bcf3dd87c3b0$var$emitCloseNT(self);
}
function $b935bcf3dd87c3b0$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $b935bcf3dd87c3b0$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $b935bcf3dd87c3b0$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $b935bcf3dd87c3b0$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitErrorNT, stream, err);
        else $b935bcf3dd87c3b0$var$emitErrorNT(stream, err);
    }
}
function $b935bcf3dd87c3b0$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($b935bcf3dd87c3b0$var$kConstruct, cb);
    if (stream.listenerCount($b935bcf3dd87c3b0$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($b935bcf3dd87c3b0$var$constructNT, stream);
}
function $b935bcf3dd87c3b0$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $b935bcf3dd87c3b0$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $b935bcf3dd87c3b0$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($b935bcf3dd87c3b0$var$kDestroy, err);
        else if (err) $b935bcf3dd87c3b0$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $b935bcf3dd87c3b0$var$emitConstructNT(stream) {
    stream.emit($b935bcf3dd87c3b0$var$kConstruct);
}
function $b935bcf3dd87c3b0$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $b935bcf3dd87c3b0$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $b935bcf3dd87c3b0$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $b935bcf3dd87c3b0$var$destroyer(stream, err) {
    if (!stream || $b935bcf3dd87c3b0$var$isDestroyed(stream)) return;
    if (!err && !$b935bcf3dd87c3b0$var$isFinished(stream)) err = new $b935bcf3dd87c3b0$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($b935bcf3dd87c3b0$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($b935bcf3dd87c3b0$var$isRequest(stream)) stream.abort();
    else if ($b935bcf3dd87c3b0$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($b935bcf3dd87c3b0$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$b935bcf3dd87c3b0$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $b935bcf3dd87c3b0$var$construct,
    destroyer: $b935bcf3dd87c3b0$var$destroyer,
    destroy: $b935bcf3dd87c3b0$var$destroy,
    undestroy: $b935bcf3dd87c3b0$var$undestroy,
    errorOrDestroy: $b935bcf3dd87c3b0$var$errorOrDestroy
};

});

parcelRegister("bF3O9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $g305F = parcelRequire("g305F");
var $87d67a3143ada29f$var$ObjectDefineProperties = $g305F.ObjectDefineProperties, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor = $g305F.ObjectGetOwnPropertyDescriptor, $87d67a3143ada29f$var$ObjectKeys = $g305F.ObjectKeys, $87d67a3143ada29f$var$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf;
module.exports = $87d67a3143ada29f$var$Duplex;

var $3QMeK = parcelRequire("3QMeK");

var $3qpeY = parcelRequire("3qpeY");
$87d67a3143ada29f$var$ObjectSetPrototypeOf($87d67a3143ada29f$var$Duplex.prototype, $3QMeK.prototype);
$87d67a3143ada29f$var$ObjectSetPrototypeOf($87d67a3143ada29f$var$Duplex, $3QMeK);
{
    var $87d67a3143ada29f$var$keys = $87d67a3143ada29f$var$ObjectKeys($3qpeY.prototype);
    // Allow the keys array to be GC'ed.
    for(var $87d67a3143ada29f$var$i = 0; $87d67a3143ada29f$var$i < $87d67a3143ada29f$var$keys.length; $87d67a3143ada29f$var$i++){
        var $87d67a3143ada29f$var$method = $87d67a3143ada29f$var$keys[$87d67a3143ada29f$var$i];
        if (!$87d67a3143ada29f$var$Duplex.prototype[$87d67a3143ada29f$var$method]) $87d67a3143ada29f$var$Duplex.prototype[$87d67a3143ada29f$var$method] = $3qpeY.prototype[$87d67a3143ada29f$var$method];
    }
}function $87d67a3143ada29f$var$Duplex(options) {
    if (!(this instanceof $87d67a3143ada29f$var$Duplex)) return new $87d67a3143ada29f$var$Duplex(options);
    $3QMeK.call(this, options);
    $3qpeY.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$87d67a3143ada29f$var$ObjectDefineProperties($87d67a3143ada29f$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $87d67a3143ada29f$var$ObjectGetOwnPropertyDescriptor($3qpeY.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $87d67a3143ada29f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $87d67a3143ada29f$var$lazyWebStreams() {
    if ($87d67a3143ada29f$var$webStreamsAdapters === undefined) $87d67a3143ada29f$var$webStreamsAdapters = {};
    return $87d67a3143ada29f$var$webStreamsAdapters;
}
$87d67a3143ada29f$var$Duplex.fromWeb = function(pair, options) {
    return $87d67a3143ada29f$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$87d67a3143ada29f$var$Duplex.toWeb = function(duplex) {
    return $87d67a3143ada29f$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $87d67a3143ada29f$var$duplexify;

$87d67a3143ada29f$var$Duplex.from = function(body) {
    if (!$87d67a3143ada29f$var$duplexify) $87d67a3143ada29f$var$duplexify = (parcelRequire("hTc4e"));
    return $87d67a3143ada29f$var$duplexify(body, 'body');
};

});
parcelRegister("3QMeK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $g305F = parcelRequire("g305F");
/* replacement end */ var $2cdba546c66309b7$var$ArrayPrototypeIndexOf = $g305F.ArrayPrototypeIndexOf, $2cdba546c66309b7$var$NumberIsInteger = $g305F.NumberIsInteger, $2cdba546c66309b7$var$NumberIsNaN = $g305F.NumberIsNaN, $2cdba546c66309b7$var$NumberParseInt = $g305F.NumberParseInt, $2cdba546c66309b7$var$ObjectDefineProperties = $g305F.ObjectDefineProperties, $2cdba546c66309b7$var$ObjectKeys = $g305F.ObjectKeys, $2cdba546c66309b7$var$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf, $2cdba546c66309b7$var$Promise = $g305F.Promise, $2cdba546c66309b7$var$SafeSet = $g305F.SafeSet, $2cdba546c66309b7$var$SymbolAsyncDispose = $g305F.SymbolAsyncDispose, $2cdba546c66309b7$var$SymbolAsyncIterator = $g305F.SymbolAsyncIterator, $2cdba546c66309b7$var$Symbol = $g305F.Symbol;
module.exports = $2cdba546c66309b7$var$Readable;
$2cdba546c66309b7$var$Readable.ReadableState = $2cdba546c66309b7$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $2cdba546c66309b7$var$EE = $bBoAO.EventEmitter;

var $4EmBp = parcelRequire("4EmBp");
var $2cdba546c66309b7$var$Stream = $4EmBp.Stream, $2cdba546c66309b7$var$prependListener = $4EmBp.prependListener;

var $hGwiI = parcelRequire("hGwiI");
var $2cdba546c66309b7$require$Buffer = $hGwiI.Buffer;

var $4cAeS = parcelRequire("4cAeS");
var $2cdba546c66309b7$require$addAbortSignal = $4cAeS.addAbortSignal;

var $hMDLi = parcelRequire("hMDLi");

var $2cdba546c66309b7$var$debug = (parcelRequire("eaXHl")).debuglog('stream', function(fn) {
    $2cdba546c66309b7$var$debug = fn;
});

var $lfN9V = parcelRequire("lfN9V");

var $fTROH = parcelRequire("fTROH");

var $4yI6k = parcelRequire("4yI6k");
var $2cdba546c66309b7$var$getHighWaterMark = $4yI6k.getHighWaterMark, $2cdba546c66309b7$var$getDefaultHighWaterMark = $4yI6k.getDefaultHighWaterMark;

var $1pEH6 = parcelRequire("1pEH6");
var $2cdba546c66309b7$var$aggregateTwoErrors = $1pEH6.aggregateTwoErrors, $2cdba546c66309b7$var$_require_codes = $1pEH6.codes, $2cdba546c66309b7$var$ERR_INVALID_ARG_TYPE = $2cdba546c66309b7$var$_require_codes.ERR_INVALID_ARG_TYPE, $2cdba546c66309b7$var$ERR_METHOD_NOT_IMPLEMENTED = $2cdba546c66309b7$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $2cdba546c66309b7$var$ERR_OUT_OF_RANGE = $2cdba546c66309b7$var$_require_codes.ERR_OUT_OF_RANGE, $2cdba546c66309b7$var$ERR_STREAM_PUSH_AFTER_EOF = $2cdba546c66309b7$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $2cdba546c66309b7$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $2cdba546c66309b7$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $2cdba546c66309b7$var$AbortError = $1pEH6.AbortError;

var $bKizF = parcelRequire("bKizF");
var $2cdba546c66309b7$require$validateObject = $bKizF.validateObject;
var $2cdba546c66309b7$var$kPaused = $2cdba546c66309b7$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $2cdba546c66309b7$require$StringDecoder = $3Jf7C.StringDecoder;

var $f5S9Z = parcelRequire("f5S9Z");
$2cdba546c66309b7$var$ObjectSetPrototypeOf($2cdba546c66309b7$var$Readable.prototype, $2cdba546c66309b7$var$Stream.prototype);
$2cdba546c66309b7$var$ObjectSetPrototypeOf($2cdba546c66309b7$var$Readable, $2cdba546c66309b7$var$Stream);
var $2cdba546c66309b7$var$nop = function() {};
var $2cdba546c66309b7$var$errorOrDestroy = $fTROH.errorOrDestroy;
var $2cdba546c66309b7$var$kObjectMode = 1;
var $2cdba546c66309b7$var$kEnded = 2;
var $2cdba546c66309b7$var$kEndEmitted = 4;
var $2cdba546c66309b7$var$kReading = 8;
var $2cdba546c66309b7$var$kConstructed = 16;
var $2cdba546c66309b7$var$kSync = 32;
var $2cdba546c66309b7$var$kNeedReadable = 64;
var $2cdba546c66309b7$var$kEmittedReadable = 128;
var $2cdba546c66309b7$var$kReadableListening = 256;
var $2cdba546c66309b7$var$kResumeScheduled = 512;
var $2cdba546c66309b7$var$kErrorEmitted = 1024;
var $2cdba546c66309b7$var$kEmitClose = 2048;
var $2cdba546c66309b7$var$kAutoDestroy = 4096;
var $2cdba546c66309b7$var$kDestroyed = 8192;
var $2cdba546c66309b7$var$kClosed = 16384;
var $2cdba546c66309b7$var$kCloseEmitted = 32768;
var $2cdba546c66309b7$var$kMultiAwaitDrain = 65536;
var $2cdba546c66309b7$var$kReadingMore = 131072;
var $2cdba546c66309b7$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $2cdba546c66309b7$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$2cdba546c66309b7$var$ObjectDefineProperties($2cdba546c66309b7$var$ReadableState.prototype, {
    objectMode: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kObjectMode),
    ended: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kEnded),
    endEmitted: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kEndEmitted),
    reading: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kNeedReadable),
    emittedReadable: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kEmittedReadable),
    readableListening: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kReadableListening),
    resumeScheduled: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kErrorEmitted),
    emitClose: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kEmitClose),
    autoDestroy: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kCloseEmitted),
    multiAwaitDrain: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kReadingMore),
    dataEmitted: $2cdba546c66309b7$var$makeBitMapDescriptor($2cdba546c66309b7$var$kDataEmitted)
});

function $2cdba546c66309b7$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("bF3O9"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $2cdba546c66309b7$var$kEmitClose | $2cdba546c66309b7$var$kAutoDestroy | $2cdba546c66309b7$var$kConstructed | $2cdba546c66309b7$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $2cdba546c66309b7$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $2cdba546c66309b7$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $2cdba546c66309b7$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $2cdba546c66309b7$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $lfN9V();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$2cdba546c66309b7$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$2cdba546c66309b7$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$2cdba546c66309b7$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $2cdba546c66309b7$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $2cdba546c66309b7$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $2cdba546c66309b7$var$Readable)) return new $2cdba546c66309b7$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("bF3O9"));
    this._readableState = new $2cdba546c66309b7$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $2cdba546c66309b7$require$addAbortSignal(options.signal, this);
    }
    $2cdba546c66309b7$var$Stream.call(this, options);
    $fTROH.construct(this, function() {
        if (_this._readableState.needReadable) $2cdba546c66309b7$var$maybeReadMore(_this, _this._readableState);
    });
}
$2cdba546c66309b7$var$Readable.prototype.destroy = $fTROH.destroy;
$2cdba546c66309b7$var$Readable.prototype._undestroy = $fTROH.undestroy;
$2cdba546c66309b7$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$2cdba546c66309b7$var$Readable.prototype[$2cdba546c66309b7$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$2cdba546c66309b7$var$Readable.prototype[$2cdba546c66309b7$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $2cdba546c66309b7$var$AbortError();
        this.destroy(error);
    }
    return new $2cdba546c66309b7$var$Promise(function(resolve, reject) {
        return $hMDLi(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$2cdba546c66309b7$var$Readable.prototype.push = function(chunk, encoding) {
    return $2cdba546c66309b7$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$2cdba546c66309b7$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $2cdba546c66309b7$var$readableAddChunk(this, chunk, encoding, true);
};
function $2cdba546c66309b7$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $2cdba546c66309b7$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $2cdba546c66309b7$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $2cdba546c66309b7$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $2cdba546c66309b7$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $2cdba546c66309b7$require$Buffer) encoding = '';
        else if ($2cdba546c66309b7$var$Stream._isUint8Array(chunk)) {
            chunk = $2cdba546c66309b7$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $2cdba546c66309b7$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $2cdba546c66309b7$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$2cdba546c66309b7$var$kReading;
        $2cdba546c66309b7$var$onEofChunk(stream, state);
    } else if ((state.state & $2cdba546c66309b7$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $2cdba546c66309b7$var$kEndEmitted) !== 0) $2cdba546c66309b7$var$errorOrDestroy(stream, new $2cdba546c66309b7$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $2cdba546c66309b7$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $2cdba546c66309b7$var$errorOrDestroy(stream, new $2cdba546c66309b7$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$2cdba546c66309b7$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $2cdba546c66309b7$var$addChunk(stream, state, chunk, false);
                else $2cdba546c66309b7$var$maybeReadMore(stream, state);
            } else $2cdba546c66309b7$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$2cdba546c66309b7$var$kReading;
        $2cdba546c66309b7$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $2cdba546c66309b7$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $2cdba546c66309b7$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $2cdba546c66309b7$var$kNeedReadable) !== 0) $2cdba546c66309b7$var$emitReadable(stream);
    }
    $2cdba546c66309b7$var$maybeReadMore(stream, state);
}
$2cdba546c66309b7$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$2cdba546c66309b7$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$2cdba546c66309b7$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $2cdba546c66309b7$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$2cdba546c66309b7$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $2cdba546c66309b7$var$MAX_HWM = 0x40000000;
function $2cdba546c66309b7$var$computeNewHighWaterMark(n) {
    if (n > $2cdba546c66309b7$var$MAX_HWM) throw new $2cdba546c66309b7$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2cdba546c66309b7$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $2cdba546c66309b7$var$kObjectMode) !== 0) return 1;
    if ($2cdba546c66309b7$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$2cdba546c66309b7$var$Readable.prototype.read = function(n) {
    $2cdba546c66309b7$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$2cdba546c66309b7$var$NumberIsInteger(n)) n = $2cdba546c66309b7$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $2cdba546c66309b7$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$2cdba546c66309b7$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $2cdba546c66309b7$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $2cdba546c66309b7$var$endReadable(this);
        else $2cdba546c66309b7$var$emitReadable(this);
        return null;
    }
    n = $2cdba546c66309b7$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $2cdba546c66309b7$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $2cdba546c66309b7$var$kNeedReadable) !== 0;
    $2cdba546c66309b7$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $2cdba546c66309b7$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $2cdba546c66309b7$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $2cdba546c66309b7$var$debug('do read');
        state.state |= $2cdba546c66309b7$var$kReading | $2cdba546c66309b7$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $2cdba546c66309b7$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $2cdba546c66309b7$var$errorOrDestroy(this, err);
        }
        state.state &= ~$2cdba546c66309b7$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $2cdba546c66309b7$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $2cdba546c66309b7$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $2cdba546c66309b7$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $2cdba546c66309b7$var$onEofChunk(stream, state) {
    $2cdba546c66309b7$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $2cdba546c66309b7$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $2cdba546c66309b7$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $2cdba546c66309b7$var$emitReadable(stream) {
    var state = stream._readableState;
    $2cdba546c66309b7$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $2cdba546c66309b7$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($2cdba546c66309b7$var$emitReadable_, stream);
    }
}
function $2cdba546c66309b7$var$emitReadable_(stream) {
    var state = stream._readableState;
    $2cdba546c66309b7$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $2cdba546c66309b7$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $2cdba546c66309b7$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($2cdba546c66309b7$var$maybeReadMore_, stream, state);
    }
}
function $2cdba546c66309b7$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $2cdba546c66309b7$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$2cdba546c66309b7$var$Readable.prototype._read = function(n) {
    throw new $2cdba546c66309b7$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$2cdba546c66309b7$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $2cdba546c66309b7$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $2cdba546c66309b7$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $2cdba546c66309b7$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $2cdba546c66309b7$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $2cdba546c66309b7$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $2cdba546c66309b7$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $2cdba546c66309b7$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $2cdba546c66309b7$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $2cdba546c66309b7$var$debug('ondata');
        var ret = dest.write(chunk);
        $2cdba546c66309b7$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $2cdba546c66309b7$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $2cdba546c66309b7$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $2cdba546c66309b7$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $2cdba546c66309b7$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $2cdba546c66309b7$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $2cdba546c66309b7$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $2cdba546c66309b7$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $2cdba546c66309b7$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $2cdba546c66309b7$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$2cdba546c66309b7$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $2cdba546c66309b7$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$2cdba546c66309b7$var$Readable.prototype.on = function(ev, fn) {
    var res = $2cdba546c66309b7$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $2cdba546c66309b7$var$debug('on readable', state.length, state.reading);
            if (state.length) $2cdba546c66309b7$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($2cdba546c66309b7$var$nReadingNextTick, this);
        }
    }
    return res;
};
$2cdba546c66309b7$var$Readable.prototype.addListener = $2cdba546c66309b7$var$Readable.prototype.on;
$2cdba546c66309b7$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $2cdba546c66309b7$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($2cdba546c66309b7$var$updateReadableListening, this);
    return res;
};
$2cdba546c66309b7$var$Readable.prototype.off = $2cdba546c66309b7$var$Readable.prototype.removeListener;
$2cdba546c66309b7$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $2cdba546c66309b7$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($2cdba546c66309b7$var$updateReadableListening, this);
    return res;
};
function $2cdba546c66309b7$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$2cdba546c66309b7$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $2cdba546c66309b7$var$nReadingNextTick(self) {
    $2cdba546c66309b7$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$2cdba546c66309b7$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $2cdba546c66309b7$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $2cdba546c66309b7$var$resume(this, state);
    }
    state[$2cdba546c66309b7$var$kPaused] = false;
    return this;
};
function $2cdba546c66309b7$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($2cdba546c66309b7$var$resume_, stream, state);
    }
}
function $2cdba546c66309b7$var$resume_(stream, state) {
    $2cdba546c66309b7$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $2cdba546c66309b7$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$2cdba546c66309b7$var$Readable.prototype.pause = function() {
    $2cdba546c66309b7$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $2cdba546c66309b7$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$2cdba546c66309b7$var$kPaused] = true;
    return this;
};
function $2cdba546c66309b7$var$flow(stream) {
    var state = stream._readableState;
    $2cdba546c66309b7$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$2cdba546c66309b7$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $2cdba546c66309b7$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $2cdba546c66309b7$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$2cdba546c66309b7$var$Readable.prototype[$2cdba546c66309b7$var$SymbolAsyncIterator] = function() {
    return $2cdba546c66309b7$var$streamToAsyncIterator(this);
};
$2cdba546c66309b7$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $2cdba546c66309b7$require$validateObject(options, 'options');
    return $2cdba546c66309b7$var$streamToAsyncIterator(this, options);
};
function $2cdba546c66309b7$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $2cdba546c66309b7$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $2cdba546c66309b7$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $2cdba546c66309b7$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $2cdba546c66309b7$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $2cdba546c66309b7$var$nop;
                    stream.on('readable', next);
                    cleanup = $hMDLi(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $2cdba546c66309b7$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $2cdba546c66309b7$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $2cdba546c66309b7$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $2cdba546c66309b7$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $fTROH.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$2cdba546c66309b7$var$ObjectDefineProperties($2cdba546c66309b7$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$2cdba546c66309b7$var$ObjectDefineProperties($2cdba546c66309b7$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$2cdba546c66309b7$var$kPaused] !== false;
        },
        set: function(value) {
            this[$2cdba546c66309b7$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$2cdba546c66309b7$var$Readable._fromList = $2cdba546c66309b7$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2cdba546c66309b7$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $2cdba546c66309b7$var$endReadable(stream) {
    var state = stream._readableState;
    $2cdba546c66309b7$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($2cdba546c66309b7$var$endReadableNT, state, stream);
    }
}
function $2cdba546c66309b7$var$endReadableNT(state, stream) {
    $2cdba546c66309b7$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($2cdba546c66309b7$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $2cdba546c66309b7$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$2cdba546c66309b7$var$Readable.from = function(iterable, opts) {
    return $f5S9Z($2cdba546c66309b7$var$Readable, iterable, opts);
};
var $2cdba546c66309b7$var$webStreamsAdapters;
// Lazy to avoid circular references
function $2cdba546c66309b7$var$lazyWebStreams() {
    if ($2cdba546c66309b7$var$webStreamsAdapters === undefined) $2cdba546c66309b7$var$webStreamsAdapters = {};
    return $2cdba546c66309b7$var$webStreamsAdapters;
}
$2cdba546c66309b7$var$Readable.fromWeb = function(readableStream, options) {
    return $2cdba546c66309b7$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$2cdba546c66309b7$var$Readable.toWeb = function(streamReadable, options) {
    return $2cdba546c66309b7$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$2cdba546c66309b7$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $2cdba546c66309b7$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $fTROH.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("4EmBp", function(module, exports) {
'use strict';

var $g305F = parcelRequire("g305F");
var $362c6e3717f31908$var$ArrayIsArray = $g305F.ArrayIsArray, $362c6e3717f31908$var$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $362c6e3717f31908$var$EE = $bBoAO.EventEmitter;
function $362c6e3717f31908$var$Stream(opts) {
    $362c6e3717f31908$var$EE.call(this, opts);
}
$362c6e3717f31908$var$ObjectSetPrototypeOf($362c6e3717f31908$var$Stream.prototype, $362c6e3717f31908$var$EE.prototype);
$362c6e3717f31908$var$ObjectSetPrototypeOf($362c6e3717f31908$var$Stream, $362c6e3717f31908$var$EE);
$362c6e3717f31908$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($362c6e3717f31908$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $362c6e3717f31908$var$prependListener(source, 'error', onerror);
    $362c6e3717f31908$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $362c6e3717f31908$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($362c6e3717f31908$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $362c6e3717f31908$var$Stream,
    prependListener: $362c6e3717f31908$var$prependListener
};

});

parcelRegister("4cAeS", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $30f464b0a2c0eb55$export$e2db56ee53255a0; }, function (v) { return $30f464b0a2c0eb55$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $30f464b0a2c0eb55$export$11956e9313f43de0; }, function (v) { return $30f464b0a2c0eb55$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $30f464b0a2c0eb55$export$e2db56ee53255a0;
var $30f464b0a2c0eb55$export$11956e9313f43de0;
'use strict';

var $g305F = parcelRequire("g305F");
var $30f464b0a2c0eb55$require$SymbolDispose = $g305F.SymbolDispose;

var $1pEH6 = parcelRequire("1pEH6");
var $30f464b0a2c0eb55$var$AbortError = $1pEH6.AbortError, $30f464b0a2c0eb55$var$codes = $1pEH6.codes;

var $8kV8l = parcelRequire("8kV8l");
var $30f464b0a2c0eb55$var$isNodeStream = $8kV8l.isNodeStream, $30f464b0a2c0eb55$var$isWebStream = $8kV8l.isWebStream, $30f464b0a2c0eb55$var$kControllerErrorFunction = $8kV8l.kControllerErrorFunction;

var $hMDLi = parcelRequire("hMDLi");
var $30f464b0a2c0eb55$var$ERR_INVALID_ARG_TYPE = $30f464b0a2c0eb55$var$codes.ERR_INVALID_ARG_TYPE;
var $30f464b0a2c0eb55$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $30f464b0a2c0eb55$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $30f464b0a2c0eb55$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$30f464b0a2c0eb55$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $30f464b0a2c0eb55$var$validateAbortSignal(signal, 'signal');
    if (!$30f464b0a2c0eb55$var$isNodeStream(stream) && !$30f464b0a2c0eb55$var$isWebStream(stream)) throw new $30f464b0a2c0eb55$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $30f464b0a2c0eb55$export$11956e9313f43de0(signal, stream);
};

$30f464b0a2c0eb55$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $30f464b0a2c0eb55$var$isNodeStream(stream) ? function() {
        stream.destroy(new $30f464b0a2c0eb55$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$30f464b0a2c0eb55$var$kControllerErrorFunction](new $30f464b0a2c0eb55$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $30f464b0a2c0eb55$var$addAbortListener = $30f464b0a2c0eb55$var$addAbortListener || (parcelRequire("eaXHl")).addAbortListener;
        var disposable = $30f464b0a2c0eb55$var$addAbortListener(signal, onAbort);
        $hMDLi(stream, disposable[$30f464b0a2c0eb55$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("lfN9V", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $g305F = parcelRequire("g305F");
var $f79121a6b3ffbf4d$var$StringPrototypeSlice = $g305F.StringPrototypeSlice, $f79121a6b3ffbf4d$var$SymbolIterator = $g305F.SymbolIterator, $f79121a6b3ffbf4d$var$TypedArrayPrototypeSet = $g305F.TypedArrayPrototypeSet, $f79121a6b3ffbf4d$var$Uint8Array = $g305F.Uint8Array;

var $hGwiI = parcelRequire("hGwiI");
var $f79121a6b3ffbf4d$require$Buffer = $hGwiI.Buffer;

var $eaXHl = parcelRequire("eaXHl");
var $f79121a6b3ffbf4d$require$inspect = $eaXHl.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f79121a6b3ffbf4d$require$Buffer.alloc(0);
                var ret = $f79121a6b3ffbf4d$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f79121a6b3ffbf4d$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $f79121a6b3ffbf4d$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $f79121a6b3ffbf4d$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $f79121a6b3ffbf4d$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f79121a6b3ffbf4d$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $f79121a6b3ffbf4d$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $f79121a6b3ffbf4d$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $f79121a6b3ffbf4d$var$TypedArrayPrototypeSet(ret, new $f79121a6b3ffbf4d$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $f79121a6b3ffbf4d$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("4yI6k", function(module, exports) {
'use strict';

var $g305F = parcelRequire("g305F");
var $351c8bf2856c534c$var$MathFloor = $g305F.MathFloor, $351c8bf2856c534c$var$NumberIsInteger = $g305F.NumberIsInteger;

var $bKizF = parcelRequire("bKizF");
var $351c8bf2856c534c$require$validateInteger = $bKizF.validateInteger;

var $351c8bf2856c534c$var$ERR_INVALID_ARG_VALUE = (parcelRequire("1pEH6")).codes.ERR_INVALID_ARG_VALUE;
var $351c8bf2856c534c$var$defaultHighWaterMarkBytes = 16384;
var $351c8bf2856c534c$var$defaultHighWaterMarkObjectMode = 16;
function $351c8bf2856c534c$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $351c8bf2856c534c$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $351c8bf2856c534c$var$defaultHighWaterMarkObjectMode : $351c8bf2856c534c$var$defaultHighWaterMarkBytes;
}
function $351c8bf2856c534c$var$setDefaultHighWaterMark(objectMode, value) {
    $351c8bf2856c534c$require$validateInteger(value, 'value', 0);
    if (objectMode) $351c8bf2856c534c$var$defaultHighWaterMarkObjectMode = value;
    else $351c8bf2856c534c$var$defaultHighWaterMarkBytes = value;
}
function $351c8bf2856c534c$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $351c8bf2856c534c$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$351c8bf2856c534c$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $351c8bf2856c534c$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $351c8bf2856c534c$var$MathFloor(hwm);
    }
    // Default value
    return $351c8bf2856c534c$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $351c8bf2856c534c$var$getHighWaterMark,
    getDefaultHighWaterMark: $351c8bf2856c534c$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $351c8bf2856c534c$var$setDefaultHighWaterMark
};

});

parcelRegister("f5S9Z", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $g305F = parcelRequire("g305F");
/* replacement end */ var $afd155b3ceecd7ed$var$PromisePrototypeThen = $g305F.PromisePrototypeThen, $afd155b3ceecd7ed$var$SymbolAsyncIterator = $g305F.SymbolAsyncIterator, $afd155b3ceecd7ed$var$SymbolIterator = $g305F.SymbolIterator;

var $hGwiI = parcelRequire("hGwiI");
var $afd155b3ceecd7ed$require$Buffer = $hGwiI.Buffer;

var $1pEH6 = parcelRequire("1pEH6");
var $afd155b3ceecd7ed$require$_require_codes = $1pEH6.codes;
var $afd155b3ceecd7ed$var$ERR_INVALID_ARG_TYPE = $afd155b3ceecd7ed$require$_require_codes.ERR_INVALID_ARG_TYPE, $afd155b3ceecd7ed$var$ERR_STREAM_NULL_VALUES = $afd155b3ceecd7ed$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $afd155b3ceecd7ed$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $afd155b3ceecd7ed$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$afd155b3ceecd7ed$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$afd155b3ceecd7ed$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$afd155b3ceecd7ed$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$afd155b3ceecd7ed$var$SymbolIterator]();
    } else throw new $afd155b3ceecd7ed$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $afd155b3ceecd7ed$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $afd155b3ceecd7ed$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $afd155b3ceecd7ed$var$from;

});


parcelRegister("3qpeY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $g305F = parcelRequire("g305F");
/* replacement end */ var $27e7610811693a24$var$ArrayPrototypeSlice = $g305F.ArrayPrototypeSlice, $27e7610811693a24$var$Error = $g305F.Error, $27e7610811693a24$var$FunctionPrototypeSymbolHasInstance = $g305F.FunctionPrototypeSymbolHasInstance, $27e7610811693a24$var$ObjectDefineProperty = $g305F.ObjectDefineProperty, $27e7610811693a24$var$ObjectDefineProperties = $g305F.ObjectDefineProperties, $27e7610811693a24$var$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf, $27e7610811693a24$var$StringPrototypeToLowerCase = $g305F.StringPrototypeToLowerCase, $27e7610811693a24$var$Symbol = $g305F.Symbol, $27e7610811693a24$var$SymbolHasInstance = $g305F.SymbolHasInstance;
module.exports = $27e7610811693a24$var$Writable;
$27e7610811693a24$var$Writable.WritableState = $27e7610811693a24$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $27e7610811693a24$var$EE = $bBoAO.EventEmitter;

var $4EmBp = parcelRequire("4EmBp");
var $27e7610811693a24$require$Stream = $4EmBp.Stream;

var $hGwiI = parcelRequire("hGwiI");
var $27e7610811693a24$require$Buffer = $hGwiI.Buffer;

var $fTROH = parcelRequire("fTROH");

var $4cAeS = parcelRequire("4cAeS");
var $27e7610811693a24$require$addAbortSignal = $4cAeS.addAbortSignal;

var $4yI6k = parcelRequire("4yI6k");
var $27e7610811693a24$var$getHighWaterMark = $4yI6k.getHighWaterMark, $27e7610811693a24$var$getDefaultHighWaterMark = $4yI6k.getDefaultHighWaterMark;

var $1pEH6 = parcelRequire("1pEH6");
var $27e7610811693a24$require$_require_codes = $1pEH6.codes;
var $27e7610811693a24$var$ERR_INVALID_ARG_TYPE = $27e7610811693a24$require$_require_codes.ERR_INVALID_ARG_TYPE, $27e7610811693a24$var$ERR_METHOD_NOT_IMPLEMENTED = $27e7610811693a24$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $27e7610811693a24$var$ERR_MULTIPLE_CALLBACK = $27e7610811693a24$require$_require_codes.ERR_MULTIPLE_CALLBACK, $27e7610811693a24$var$ERR_STREAM_CANNOT_PIPE = $27e7610811693a24$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $27e7610811693a24$var$ERR_STREAM_DESTROYED = $27e7610811693a24$require$_require_codes.ERR_STREAM_DESTROYED, $27e7610811693a24$var$ERR_STREAM_ALREADY_FINISHED = $27e7610811693a24$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $27e7610811693a24$var$ERR_STREAM_NULL_VALUES = $27e7610811693a24$require$_require_codes.ERR_STREAM_NULL_VALUES, $27e7610811693a24$var$ERR_STREAM_WRITE_AFTER_END = $27e7610811693a24$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $27e7610811693a24$var$ERR_UNKNOWN_ENCODING = $27e7610811693a24$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $27e7610811693a24$var$errorOrDestroy = $fTROH.errorOrDestroy;
$27e7610811693a24$var$ObjectSetPrototypeOf($27e7610811693a24$var$Writable.prototype, $27e7610811693a24$require$Stream.prototype);
$27e7610811693a24$var$ObjectSetPrototypeOf($27e7610811693a24$var$Writable, $27e7610811693a24$require$Stream);
function $27e7610811693a24$var$nop() {}
var $27e7610811693a24$var$kOnFinished = $27e7610811693a24$var$Symbol('kOnFinished');

function $27e7610811693a24$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("bF3O9"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $27e7610811693a24$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $27e7610811693a24$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $27e7610811693a24$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $27e7610811693a24$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$27e7610811693a24$var$kOnFinished] = [];
}
function $27e7610811693a24$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$27e7610811693a24$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $27e7610811693a24$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$27e7610811693a24$var$ObjectDefineProperty($27e7610811693a24$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $27e7610811693a24$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("bF3O9"));
    if (!isDuplex && !$27e7610811693a24$var$FunctionPrototypeSymbolHasInstance($27e7610811693a24$var$Writable, this)) return new $27e7610811693a24$var$Writable(options);
    this._writableState = new $27e7610811693a24$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $27e7610811693a24$require$addAbortSignal(options.signal, this);
    }
    $27e7610811693a24$require$Stream.call(this, options);
    $fTROH.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $27e7610811693a24$var$clearBuffer(_this, state);
        $27e7610811693a24$var$finishMaybe(_this, state);
    });
}
$27e7610811693a24$var$ObjectDefineProperty($27e7610811693a24$var$Writable, $27e7610811693a24$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($27e7610811693a24$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $27e7610811693a24$var$Writable) return false;
        return object && object._writableState instanceof $27e7610811693a24$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$27e7610811693a24$var$Writable.prototype.pipe = function() {
    $27e7610811693a24$var$errorOrDestroy(this, new $27e7610811693a24$var$ERR_STREAM_CANNOT_PIPE());
};
function $27e7610811693a24$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$27e7610811693a24$require$Buffer.isEncoding(encoding)) throw new $27e7610811693a24$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $27e7610811693a24$var$nop;
    }
    if (chunk === null) throw new $27e7610811693a24$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $27e7610811693a24$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $27e7610811693a24$require$Buffer) encoding = 'buffer';
        else if ($27e7610811693a24$require$Stream._isUint8Array(chunk)) {
            chunk = $27e7610811693a24$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $27e7610811693a24$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $27e7610811693a24$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $27e7610811693a24$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $27e7610811693a24$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $27e7610811693a24$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$27e7610811693a24$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $27e7610811693a24$var$_write(this, chunk, encoding, cb) === true;
};
$27e7610811693a24$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$27e7610811693a24$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $27e7610811693a24$var$clearBuffer(this, state);
    }
};
$27e7610811693a24$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $27e7610811693a24$var$StringPrototypeToLowerCase(encoding);
    if (!$27e7610811693a24$require$Buffer.isEncoding(encoding)) throw new $27e7610811693a24$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $27e7610811693a24$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $27e7610811693a24$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $27e7610811693a24$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $27e7610811693a24$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $27e7610811693a24$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $27e7610811693a24$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $27e7610811693a24$var$errorOrDestroy(stream, er);
}
function $27e7610811693a24$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $27e7610811693a24$var$errorOrDestroy(stream, new $27e7610811693a24$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($27e7610811693a24$var$onwriteError, stream, state, er, cb);
        else $27e7610811693a24$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $27e7610811693a24$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($27e7610811693a24$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $27e7610811693a24$var$afterWrite(stream, state, 1, cb);
    }
}
function $27e7610811693a24$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $27e7610811693a24$var$afterWrite(stream, state, count, cb);
}
function $27e7610811693a24$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $27e7610811693a24$var$errorBuffer(state);
    $27e7610811693a24$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $27e7610811693a24$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $27e7610811693a24$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$27e7610811693a24$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $27e7610811693a24$var$ERR_STREAM_DESTROYED('end'));
    }
    $27e7610811693a24$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $27e7610811693a24$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $27e7610811693a24$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $27e7610811693a24$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $27e7610811693a24$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $27e7610811693a24$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $27e7610811693a24$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $27e7610811693a24$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$27e7610811693a24$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $27e7610811693a24$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$27e7610811693a24$var$Writable.prototype._writev = null;
$27e7610811693a24$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $27e7610811693a24$var$_write(this, chunk, encoding);
        if (ret instanceof $27e7610811693a24$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $27e7610811693a24$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $27e7610811693a24$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $27e7610811693a24$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$27e7610811693a24$var$kOnFinished].push(cb);
    }
    return this;
};
function $27e7610811693a24$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $27e7610811693a24$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $27e7610811693a24$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $27e7610811693a24$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$27e7610811693a24$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $27e7610811693a24$var$errorOrDestroy(stream, err, state.sync);
        } else if ($27e7610811693a24$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($27e7610811693a24$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $27e7610811693a24$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $27e7610811693a24$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $27e7610811693a24$var$finishMaybe(stream, state, sync) {
    if ($27e7610811693a24$var$needFinish(state)) {
        $27e7610811693a24$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($27e7610811693a24$var$needFinish(state)) $27e7610811693a24$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($27e7610811693a24$var$needFinish(state)) {
                state.pendingcb++;
                $27e7610811693a24$var$finish(stream, state);
            }
        }
    }
}
function $27e7610811693a24$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$27e7610811693a24$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$27e7610811693a24$var$ObjectDefineProperties($27e7610811693a24$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $27e7610811693a24$var$destroy = $fTROH.destroy;
$27e7610811693a24$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$27e7610811693a24$var$kOnFinished].length)) $2Qkr5.nextTick($27e7610811693a24$var$errorBuffer, state);
    $27e7610811693a24$var$destroy.call(this, err, cb);
    return this;
};
$27e7610811693a24$var$Writable.prototype._undestroy = $fTROH.undestroy;
$27e7610811693a24$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$27e7610811693a24$var$Writable.prototype[$27e7610811693a24$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $27e7610811693a24$var$webStreamsAdapters;
// Lazy to avoid circular references
function $27e7610811693a24$var$lazyWebStreams() {
    if ($27e7610811693a24$var$webStreamsAdapters === undefined) $27e7610811693a24$var$webStreamsAdapters = {};
    return $27e7610811693a24$var$webStreamsAdapters;
}
$27e7610811693a24$var$Writable.fromWeb = function(writableStream, options) {
    return $27e7610811693a24$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$27e7610811693a24$var$Writable.toWeb = function(streamWritable) {
    return $27e7610811693a24$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hTc4e", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $hGwiI = parcelRequire("hGwiI");

var $8kV8l = parcelRequire("8kV8l");
var $d060ef0b86c0152c$var$isReadable = $8kV8l.isReadable, $d060ef0b86c0152c$var$isWritable = $8kV8l.isWritable, $d060ef0b86c0152c$var$isIterable = $8kV8l.isIterable, $d060ef0b86c0152c$var$isNodeStream = $8kV8l.isNodeStream, $d060ef0b86c0152c$var$isReadableNodeStream = $8kV8l.isReadableNodeStream, $d060ef0b86c0152c$var$isWritableNodeStream = $8kV8l.isWritableNodeStream, $d060ef0b86c0152c$var$isDuplexNodeStream = $8kV8l.isDuplexNodeStream, $d060ef0b86c0152c$var$isReadableStream = $8kV8l.isReadableStream, $d060ef0b86c0152c$var$isWritableStream = $8kV8l.isWritableStream;

var $hMDLi = parcelRequire("hMDLi");

var $1pEH6 = parcelRequire("1pEH6");
var $d060ef0b86c0152c$var$AbortError = $1pEH6.AbortError, $d060ef0b86c0152c$var$_require_codes = $1pEH6.codes, $d060ef0b86c0152c$var$ERR_INVALID_ARG_TYPE = $d060ef0b86c0152c$var$_require_codes.ERR_INVALID_ARG_TYPE, $d060ef0b86c0152c$var$ERR_INVALID_RETURN_VALUE = $d060ef0b86c0152c$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $fTROH = parcelRequire("fTROH");
var $d060ef0b86c0152c$require$destroyer = $fTROH.destroyer;

var $bF3O9 = parcelRequire("bF3O9");

var $3QMeK = parcelRequire("3QMeK");

var $3qpeY = parcelRequire("3qpeY");

var $eaXHl = parcelRequire("eaXHl");
var $d060ef0b86c0152c$require$createDeferredPromise = $eaXHl.createDeferredPromise;

var $f5S9Z = parcelRequire("f5S9Z");
var $d060ef0b86c0152c$var$Blob = globalThis.Blob || $hGwiI.Blob;
var $d060ef0b86c0152c$var$isBlob = typeof $d060ef0b86c0152c$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $d060ef0b86c0152c$var$Blob;
} : function isBlob(b) {
    return false;
};

var $d060ef0b86c0152c$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $g305F = parcelRequire("g305F");
var $d060ef0b86c0152c$require$FunctionPrototypeCall = $g305F.FunctionPrototypeCall;
// This is needed for pre node 17.
var $d060ef0b86c0152c$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($bF3O9);
module.exports = function duplexify(body, name) {
    if ($d060ef0b86c0152c$var$isDuplexNodeStream(body)) return body;
    if ($d060ef0b86c0152c$var$isReadableNodeStream(body)) return $d060ef0b86c0152c$var$_duplexify({
        readable: body
    });
    if ($d060ef0b86c0152c$var$isWritableNodeStream(body)) return $d060ef0b86c0152c$var$_duplexify({
        writable: body
    });
    if ($d060ef0b86c0152c$var$isNodeStream(body)) return $d060ef0b86c0152c$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($d060ef0b86c0152c$var$isReadableStream(body)) return $d060ef0b86c0152c$var$_duplexify({
        readable: $3QMeK.fromWeb(body)
    });
    if ($d060ef0b86c0152c$var$isWritableStream(body)) return $d060ef0b86c0152c$var$_duplexify({
        writable: $3qpeY.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $d060ef0b86c0152c$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($d060ef0b86c0152c$var$isIterable(value)) return $f5S9Z($d060ef0b86c0152c$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $d060ef0b86c0152c$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $d060ef0b86c0152c$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $d060ef0b86c0152c$require$destroyer(d, err);
            });
            return d = new $d060ef0b86c0152c$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $d060ef0b86c0152c$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($d060ef0b86c0152c$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($d060ef0b86c0152c$var$isIterable(body)) return $f5S9Z($d060ef0b86c0152c$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($d060ef0b86c0152c$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $d060ef0b86c0152c$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $d060ef0b86c0152c$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $d060ef0b86c0152c$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $d060ef0b86c0152c$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $d060ef0b86c0152c$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $d060ef0b86c0152c$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $d060ef0b86c0152c$require$destroyer(d1, err);
        });
        return d1 = new $d060ef0b86c0152c$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $d060ef0b86c0152c$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $d060ef0b86c0152c$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $d060ef0b86c0152c$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $d060ef0b86c0152c$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $d060ef0b86c0152c$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $d060ef0b86c0152c$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $d060ef0b86c0152c$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $3QMeK.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$d060ef0b86c0152c$var$isReadable(r);
    var writable = !!$d060ef0b86c0152c$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $d060ef0b86c0152c$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $hMDLi(w, function(err) {
            writable = false;
            if (err) $d060ef0b86c0152c$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $hMDLi(r, function(err) {
            readable = false;
            if (err) $d060ef0b86c0152c$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $d060ef0b86c0152c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $d060ef0b86c0152c$require$destroyer(w, err);
            $d060ef0b86c0152c$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("dTTZ6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $g305F = parcelRequire("g305F");
var $a1ebd6c799af0c47$require$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf;
module.exports = $a1ebd6c799af0c47$var$PassThrough;

var $4pjmg = parcelRequire("4pjmg");
$a1ebd6c799af0c47$require$ObjectSetPrototypeOf($a1ebd6c799af0c47$var$PassThrough.prototype, $4pjmg.prototype);
$a1ebd6c799af0c47$require$ObjectSetPrototypeOf($a1ebd6c799af0c47$var$PassThrough, $4pjmg);
function $a1ebd6c799af0c47$var$PassThrough(options) {
    if (!(this instanceof $a1ebd6c799af0c47$var$PassThrough)) return new $a1ebd6c799af0c47$var$PassThrough(options);
    $4pjmg.call(this, options);
}
$a1ebd6c799af0c47$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("4pjmg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $g305F = parcelRequire("g305F");
var $3358835c010fff13$var$ObjectSetPrototypeOf = $g305F.ObjectSetPrototypeOf, $3358835c010fff13$var$Symbol = $g305F.Symbol;
module.exports = $3358835c010fff13$var$Transform;

var $3358835c010fff13$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("1pEH6")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $bF3O9 = parcelRequire("bF3O9");

var $4yI6k = parcelRequire("4yI6k");
var $3358835c010fff13$require$getHighWaterMark = $4yI6k.getHighWaterMark;
$3358835c010fff13$var$ObjectSetPrototypeOf($3358835c010fff13$var$Transform.prototype, $bF3O9.prototype);
$3358835c010fff13$var$ObjectSetPrototypeOf($3358835c010fff13$var$Transform, $bF3O9);
var $3358835c010fff13$var$kCallback = $3358835c010fff13$var$Symbol('kCallback');
function $3358835c010fff13$var$Transform(options) {
    if (!(this instanceof $3358835c010fff13$var$Transform)) return new $3358835c010fff13$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $3358835c010fff13$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $bF3O9.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$3358835c010fff13$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $3358835c010fff13$var$prefinish);
}
function $3358835c010fff13$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $3358835c010fff13$var$prefinish() {
    if (this._final !== $3358835c010fff13$var$_final) $3358835c010fff13$var$_final.call(this);
}
$3358835c010fff13$var$Transform.prototype._final = $3358835c010fff13$var$_final;
$3358835c010fff13$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $3358835c010fff13$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$3358835c010fff13$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$3358835c010fff13$var$kCallback] = callback;
    });
};
$3358835c010fff13$var$Transform.prototype._read = function() {
    if (this[$3358835c010fff13$var$kCallback]) {
        var callback = this[$3358835c010fff13$var$kCallback];
        this[$3358835c010fff13$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2Hebs", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $g305F = parcelRequire("g305F");
var $1f6a9986014a5369$var$ArrayPrototypePop = $g305F.ArrayPrototypePop, $1f6a9986014a5369$var$Promise = $g305F.Promise;

var $8kV8l = parcelRequire("8kV8l");
var $1f6a9986014a5369$var$isIterable = $8kV8l.isIterable, $1f6a9986014a5369$var$isNodeStream = $8kV8l.isNodeStream, $1f6a9986014a5369$var$isWebStream = $8kV8l.isWebStream;

var $8eyL4 = parcelRequire("8eyL4");
var $1f6a9986014a5369$var$pl = $8eyL4.pipelineImpl;

var $hMDLi = parcelRequire("hMDLi");
var $1f6a9986014a5369$require$finished = $hMDLi.finished;
parcelRequire("5NuOc");
function $1f6a9986014a5369$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $1f6a9986014a5369$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$1f6a9986014a5369$var$isNodeStream(lastArg) && !$1f6a9986014a5369$var$isIterable(lastArg) && !$1f6a9986014a5369$var$isWebStream(lastArg)) {
            var options = $1f6a9986014a5369$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $1f6a9986014a5369$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $1f6a9986014a5369$require$finished,
    pipeline: $1f6a9986014a5369$var$pipeline
};

});





parcelRegister("4CCr8", function(module, exports) {
"use strict";
var $35d886bca75b2177$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $35d886bca75b2177$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $35d886bca75b2177$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$35d886bca75b2177$var$__exportStar((parcelRequire("GKUbq")), module.exports);

});
parcelRegister("GKUbq", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAll = void 0;

var $jEtfn = parcelRequire("jEtfn");

var $kNNoa = parcelRequire("kNNoa");

var $lkY98 = parcelRequire("lkY98");
/**
 * A comunica All RDF Metadata Actor.
 */ var $08084ec0379010df$var$ActorRdfMetadataAll = /*#__PURE__*/ function(_bus_rdf_metadata_1_ActorRdfMetadata) {
    (0, $i3fW3._)(ActorRdfMetadataAll, _bus_rdf_metadata_1_ActorRdfMetadata);
    function ActorRdfMetadataAll(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataAll);
        return (0, $kzDuW._)(this, ActorRdfMetadataAll, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataAll, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data, metadata, read;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        data = new $lkY98.Readable({
                            objectMode: true
                        });
                        metadata = new $lkY98.Readable({
                            objectMode: true
                        });
                        // Forward errors (attach them immediately as they could arrive earlier)
                        action.quads.on('error', function(error) {
                            data.emit('error', error);
                            metadata.emit('error', error);
                        });
                        // Terminate both streams on-end
                        action.quads.on('end', function() {
                            data.push(null);
                            metadata.push(null);
                        });
                        read = data._read = metadata._read = function(size) {
                            while(size > 0){
                                var item = action.quads.read();
                                if (item === null) return action.quads.once('readable', function() {
                                    return read(size);
                                });
                                size--;
                                data.push(item);
                                metadata.push(item);
                            }
                        };
                        return [
                            2,
                            {
                                data: data,
                                metadata: metadata
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataAll;
}($jEtfn.ActorRdfMetadata);
module.exports.ActorRdfMetadataAll = $08084ec0379010df$var$ActorRdfMetadataAll;

});
parcelRegister("lkY98", function(module, exports) {
'use strict';

var $4UZla = parcelRequire("4UZla");

var $7xJ5J = parcelRequire("7xJ5J");
var $f88a1f077daf9196$var$originalDestroy = $4UZla.Readable.destroy;
module.exports = $4UZla.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $4UZla._uint8ArrayToBuffer;
module.exports._isUint8Array = $4UZla._isUint8Array;
module.exports.isDisturbed = $4UZla.isDisturbed;
module.exports.isErrored = $4UZla.isErrored;
module.exports.isReadable = $4UZla.isReadable;
module.exports.Readable = $4UZla.Readable;
module.exports.Writable = $4UZla.Writable;
module.exports.Duplex = $4UZla.Duplex;
module.exports.Transform = $4UZla.Transform;
module.exports.PassThrough = $4UZla.PassThrough;
module.exports.addAbortSignal = $4UZla.addAbortSignal;
module.exports.finished = $4UZla.finished;
module.exports.destroy = $4UZla.destroy;
module.exports.destroy = $f88a1f077daf9196$var$originalDestroy;
module.exports.pipeline = $4UZla.pipeline;
module.exports.compose = $4UZla.compose;
Object.defineProperty($4UZla, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $7xJ5J;
    }
});
module.exports.Stream = $4UZla.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("4UZla", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $cx11P = parcelRequire("cx11P");
var $394bf94a11b5ca4c$require$Buffer = $cx11P.Buffer;

var $6zAfR = parcelRequire("6zAfR");
/* replacement end */ var $394bf94a11b5ca4c$var$ObjectDefineProperty = $6zAfR.ObjectDefineProperty, $394bf94a11b5ca4c$var$ObjectKeys = $6zAfR.ObjectKeys, $394bf94a11b5ca4c$var$ReflectApply = $6zAfR.ReflectApply;

var $bsQpc = parcelRequire("bsQpc");
var $394bf94a11b5ca4c$var$_require_promisify = $bsQpc.promisify, $394bf94a11b5ca4c$var$customPromisify = $394bf94a11b5ca4c$var$_require_promisify.custom;

var $6NdpE = parcelRequire("6NdpE");
var $394bf94a11b5ca4c$var$streamReturningOperators = $6NdpE.streamReturningOperators, $394bf94a11b5ca4c$var$promiseReturningOperators = $6NdpE.promiseReturningOperators;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $394bf94a11b5ca4c$var$ERR_ILLEGAL_CONSTRUCTOR = $5Q9Jl.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $gU4DH = parcelRequire("gU4DH");

var $gUxqg = parcelRequire("gUxqg");
var $394bf94a11b5ca4c$var$setDefaultHighWaterMark = $gUxqg.setDefaultHighWaterMark, $394bf94a11b5ca4c$var$getDefaultHighWaterMark = $gUxqg.getDefaultHighWaterMark;

var $eHl1m = parcelRequire("eHl1m");
var $394bf94a11b5ca4c$require$pipeline = $eHl1m.pipeline;

var $jBUYd = parcelRequire("jBUYd");
var $394bf94a11b5ca4c$require$destroyer = $jBUYd.destroyer;

var $7UDrs = parcelRequire("7UDrs");
var $394bf94a11b5ca4c$var$internalBuffer = {};

var $7xJ5J = parcelRequire("7xJ5J");

var $kq58L = parcelRequire("kq58L");

var $394bf94a11b5ca4c$var$Stream = module.exports = (parcelRequire("CtYZv")).Stream;
$394bf94a11b5ca4c$var$Stream.isDestroyed = $kq58L.isDestroyed;
$394bf94a11b5ca4c$var$Stream.isDisturbed = $kq58L.isDisturbed;
$394bf94a11b5ca4c$var$Stream.isErrored = $kq58L.isErrored;
$394bf94a11b5ca4c$var$Stream.isReadable = $kq58L.isReadable;
$394bf94a11b5ca4c$var$Stream.isWritable = $kq58L.isWritable;

$394bf94a11b5ca4c$var$Stream.Readable = (parcelRequire("9gpVw"));
var $394bf94a11b5ca4c$var$_iteratorNormalCompletion = true, $394bf94a11b5ca4c$var$_didIteratorError = false, $394bf94a11b5ca4c$var$_iteratorError = undefined;
try {
    for(var $394bf94a11b5ca4c$var$_iterator = $394bf94a11b5ca4c$var$ObjectKeys($394bf94a11b5ca4c$var$streamReturningOperators)[Symbol.iterator](), $394bf94a11b5ca4c$var$_step; !($394bf94a11b5ca4c$var$_iteratorNormalCompletion = ($394bf94a11b5ca4c$var$_step = $394bf94a11b5ca4c$var$_iterator.next()).done); $394bf94a11b5ca4c$var$_iteratorNormalCompletion = true){
        var $394bf94a11b5ca4c$var$key = $394bf94a11b5ca4c$var$_step.value;
        var $394bf94a11b5ca4c$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $394bf94a11b5ca4c$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $394bf94a11b5ca4c$var$Stream.Readable.from($394bf94a11b5ca4c$var$ReflectApply($394bf94a11b5ca4c$var$op, this, args));
        };
        var $394bf94a11b5ca4c$var$op = $394bf94a11b5ca4c$var$streamReturningOperators[$394bf94a11b5ca4c$var$key];
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$fn, 'name', {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$op.name
        });
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$fn, 'length', {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$op.length
        });
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$Stream.Readable.prototype, $394bf94a11b5ca4c$var$key, {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $394bf94a11b5ca4c$var$_didIteratorError = true;
    $394bf94a11b5ca4c$var$_iteratorError = err;
} finally{
    try {
        if (!$394bf94a11b5ca4c$var$_iteratorNormalCompletion && $394bf94a11b5ca4c$var$_iterator["return"] != null) {
            $394bf94a11b5ca4c$var$_iterator["return"]();
        }
    } finally{
        if ($394bf94a11b5ca4c$var$_didIteratorError) {
            throw $394bf94a11b5ca4c$var$_iteratorError;
        }
    }
}
var $394bf94a11b5ca4c$var$_iteratorNormalCompletion1 = true, $394bf94a11b5ca4c$var$_didIteratorError1 = false, $394bf94a11b5ca4c$var$_iteratorError1 = undefined;
try {
    for(var $394bf94a11b5ca4c$var$_iterator1 = $394bf94a11b5ca4c$var$ObjectKeys($394bf94a11b5ca4c$var$promiseReturningOperators)[Symbol.iterator](), $394bf94a11b5ca4c$var$_step1; !($394bf94a11b5ca4c$var$_iteratorNormalCompletion1 = ($394bf94a11b5ca4c$var$_step1 = $394bf94a11b5ca4c$var$_iterator1.next()).done); $394bf94a11b5ca4c$var$_iteratorNormalCompletion1 = true){
        var $394bf94a11b5ca4c$var$key1 = $394bf94a11b5ca4c$var$_step1.value;
        var $394bf94a11b5ca4c$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $394bf94a11b5ca4c$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $394bf94a11b5ca4c$var$ReflectApply($394bf94a11b5ca4c$var$op1, this, args);
        };
        var $394bf94a11b5ca4c$var$op1 = $394bf94a11b5ca4c$var$promiseReturningOperators[$394bf94a11b5ca4c$var$key1];
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$fn1, 'name', {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$op1.name
        });
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$fn1, 'length', {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$op1.length
        });
        $394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$Stream.Readable.prototype, $394bf94a11b5ca4c$var$key1, {
            __proto__: null,
            value: $394bf94a11b5ca4c$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $394bf94a11b5ca4c$var$_didIteratorError1 = true;
    $394bf94a11b5ca4c$var$_iteratorError1 = err;
} finally{
    try {
        if (!$394bf94a11b5ca4c$var$_iteratorNormalCompletion1 && $394bf94a11b5ca4c$var$_iterator1["return"] != null) {
            $394bf94a11b5ca4c$var$_iterator1["return"]();
        }
    } finally{
        if ($394bf94a11b5ca4c$var$_didIteratorError1) {
            throw $394bf94a11b5ca4c$var$_iteratorError1;
        }
    }
}

$394bf94a11b5ca4c$var$Stream.Writable = (parcelRequire("6a7ra"));

$394bf94a11b5ca4c$var$Stream.Duplex = (parcelRequire("ab4Kx"));

$394bf94a11b5ca4c$var$Stream.Transform = (parcelRequire("GYlyq"));

$394bf94a11b5ca4c$var$Stream.PassThrough = (parcelRequire("7qh1D"));
$394bf94a11b5ca4c$var$Stream.pipeline = $394bf94a11b5ca4c$require$pipeline;

var $41Z6q = parcelRequire("41Z6q");
var $394bf94a11b5ca4c$require$addAbortSignal = $41Z6q.addAbortSignal;
$394bf94a11b5ca4c$var$Stream.addAbortSignal = $394bf94a11b5ca4c$require$addAbortSignal;
$394bf94a11b5ca4c$var$Stream.finished = $7UDrs;
$394bf94a11b5ca4c$var$Stream.destroy = $394bf94a11b5ca4c$require$destroyer;
$394bf94a11b5ca4c$var$Stream.compose = $gU4DH;
$394bf94a11b5ca4c$var$Stream.setDefaultHighWaterMark = $394bf94a11b5ca4c$var$setDefaultHighWaterMark;
$394bf94a11b5ca4c$var$Stream.getDefaultHighWaterMark = $394bf94a11b5ca4c$var$getDefaultHighWaterMark;
$394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $7xJ5J;
    }
});
$394bf94a11b5ca4c$var$ObjectDefineProperty($394bf94a11b5ca4c$require$pipeline, $394bf94a11b5ca4c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $7xJ5J.pipeline;
    }
});
$394bf94a11b5ca4c$var$ObjectDefineProperty($7UDrs, $394bf94a11b5ca4c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $7xJ5J.finished;
    }
});
// Backwards-compat with node 0.4.x
$394bf94a11b5ca4c$var$Stream.Stream = $394bf94a11b5ca4c$var$Stream;
$394bf94a11b5ca4c$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$394bf94a11b5ca4c$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $394bf94a11b5ca4c$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("cx11P", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $91f95d5c2eacfccd$export$a143d493d941bafc; }, function (v) { return $91f95d5c2eacfccd$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $91f95d5c2eacfccd$export$f99ded8fe4b79145; }, function (v) { return $91f95d5c2eacfccd$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $91f95d5c2eacfccd$export$a143d493d941bafc;
var $91f95d5c2eacfccd$export$e4cf37d7f6fb9e0a;
var $91f95d5c2eacfccd$export$f99ded8fe4b79145;
var $91f95d5c2eacfccd$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $91f95d5c2eacfccd$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$91f95d5c2eacfccd$export$a143d493d941bafc = $91f95d5c2eacfccd$var$Buffer;
$91f95d5c2eacfccd$export$e4cf37d7f6fb9e0a = $91f95d5c2eacfccd$var$SlowBuffer;
$91f95d5c2eacfccd$export$f99ded8fe4b79145 = 50;
var $91f95d5c2eacfccd$var$K_MAX_LENGTH = 0x7fffffff;
$91f95d5c2eacfccd$export$599f31c3813fae4d = $91f95d5c2eacfccd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $91f95d5c2eacfccd$var$Buffer.TYPED_ARRAY_SUPPORT = $91f95d5c2eacfccd$var$typedArraySupport();
if (!$91f95d5c2eacfccd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $91f95d5c2eacfccd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($91f95d5c2eacfccd$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($91f95d5c2eacfccd$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $91f95d5c2eacfccd$var$createBuffer(length) {
    if (length > $91f95d5c2eacfccd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $91f95d5c2eacfccd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $91f95d5c2eacfccd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $91f95d5c2eacfccd$var$allocUnsafe(arg);
    }
    return $91f95d5c2eacfccd$var$from(arg, encodingOrOffset, length);
}
$91f95d5c2eacfccd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $91f95d5c2eacfccd$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $91f95d5c2eacfccd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $91f95d5c2eacfccd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($91f95d5c2eacfccd$var$isInstance(value, ArrayBuffer) || value && $91f95d5c2eacfccd$var$isInstance(value.buffer, ArrayBuffer)) return $91f95d5c2eacfccd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($91f95d5c2eacfccd$var$isInstance(value, SharedArrayBuffer) || value && $91f95d5c2eacfccd$var$isInstance(value.buffer, SharedArrayBuffer))) return $91f95d5c2eacfccd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $91f95d5c2eacfccd$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $91f95d5c2eacfccd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $91f95d5c2eacfccd$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $91f95d5c2eacfccd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $91f95d5c2eacfccd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($91f95d5c2eacfccd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($91f95d5c2eacfccd$var$Buffer, Uint8Array);
function $91f95d5c2eacfccd$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $91f95d5c2eacfccd$var$alloc(size, fill, encoding) {
    $91f95d5c2eacfccd$var$assertSize(size);
    if (size <= 0) return $91f95d5c2eacfccd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $91f95d5c2eacfccd$var$createBuffer(size).fill(fill, encoding) : $91f95d5c2eacfccd$var$createBuffer(size).fill(fill);
    return $91f95d5c2eacfccd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $91f95d5c2eacfccd$var$Buffer.alloc = function(size, fill, encoding) {
    return $91f95d5c2eacfccd$var$alloc(size, fill, encoding);
};
function $91f95d5c2eacfccd$var$allocUnsafe(size) {
    $91f95d5c2eacfccd$var$assertSize(size);
    return $91f95d5c2eacfccd$var$createBuffer(size < 0 ? 0 : $91f95d5c2eacfccd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $91f95d5c2eacfccd$var$Buffer.allocUnsafe = function(size) {
    return $91f95d5c2eacfccd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $91f95d5c2eacfccd$var$Buffer.allocUnsafeSlow = function(size) {
    return $91f95d5c2eacfccd$var$allocUnsafe(size);
};
function $91f95d5c2eacfccd$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$91f95d5c2eacfccd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $91f95d5c2eacfccd$var$byteLength(string, encoding) | 0;
    var buf = $91f95d5c2eacfccd$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $91f95d5c2eacfccd$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $91f95d5c2eacfccd$var$checked(array.length) | 0;
    var buf = $91f95d5c2eacfccd$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $91f95d5c2eacfccd$var$fromArrayView(arrayView) {
    if ($91f95d5c2eacfccd$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $91f95d5c2eacfccd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $91f95d5c2eacfccd$var$fromArrayLike(arrayView);
}
function $91f95d5c2eacfccd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $91f95d5c2eacfccd$var$Buffer.prototype);
    return buf;
}
function $91f95d5c2eacfccd$var$fromObject(obj) {
    if ($91f95d5c2eacfccd$var$Buffer.isBuffer(obj)) {
        var len = $91f95d5c2eacfccd$var$checked(obj.length) | 0;
        var buf = $91f95d5c2eacfccd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $91f95d5c2eacfccd$var$numberIsNaN(obj.length)) return $91f95d5c2eacfccd$var$createBuffer(0);
        return $91f95d5c2eacfccd$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $91f95d5c2eacfccd$var$fromArrayLike(obj.data);
}
function $91f95d5c2eacfccd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $91f95d5c2eacfccd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $91f95d5c2eacfccd$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $91f95d5c2eacfccd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $91f95d5c2eacfccd$var$Buffer.alloc(+length);
}
$91f95d5c2eacfccd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $91f95d5c2eacfccd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$91f95d5c2eacfccd$var$Buffer.compare = function compare(a, b) {
    if ($91f95d5c2eacfccd$var$isInstance(a, Uint8Array)) a = $91f95d5c2eacfccd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($91f95d5c2eacfccd$var$isInstance(b, Uint8Array)) b = $91f95d5c2eacfccd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(a) || !$91f95d5c2eacfccd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$91f95d5c2eacfccd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$91f95d5c2eacfccd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $91f95d5c2eacfccd$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $91f95d5c2eacfccd$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($91f95d5c2eacfccd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(buf)) buf = $91f95d5c2eacfccd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $91f95d5c2eacfccd$var$byteLength(string, encoding) {
    if ($91f95d5c2eacfccd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $91f95d5c2eacfccd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $91f95d5c2eacfccd$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $91f95d5c2eacfccd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $91f95d5c2eacfccd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$91f95d5c2eacfccd$var$Buffer.byteLength = $91f95d5c2eacfccd$var$byteLength;
function $91f95d5c2eacfccd$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $91f95d5c2eacfccd$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $91f95d5c2eacfccd$var$utf8Slice(this, start, end);
        case 'ascii':
            return $91f95d5c2eacfccd$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $91f95d5c2eacfccd$var$latin1Slice(this, start, end);
        case 'base64':
            return $91f95d5c2eacfccd$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $91f95d5c2eacfccd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$91f95d5c2eacfccd$var$Buffer.prototype._isBuffer = true;
function $91f95d5c2eacfccd$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$91f95d5c2eacfccd$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$91f95d5c2eacfccd$var$swap(this, i, i + 1);
    return this;
};
$91f95d5c2eacfccd$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $91f95d5c2eacfccd$var$swap(this, i, i + 3);
        $91f95d5c2eacfccd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$91f95d5c2eacfccd$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $91f95d5c2eacfccd$var$swap(this, i, i + 7);
        $91f95d5c2eacfccd$var$swap(this, i + 1, i + 6);
        $91f95d5c2eacfccd$var$swap(this, i + 2, i + 5);
        $91f95d5c2eacfccd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$91f95d5c2eacfccd$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $91f95d5c2eacfccd$var$utf8Slice(this, 0, length);
    return $91f95d5c2eacfccd$var$slowToString.apply(this, arguments);
};
$91f95d5c2eacfccd$var$Buffer.prototype.toLocaleString = $91f95d5c2eacfccd$var$Buffer.prototype.toString;
$91f95d5c2eacfccd$var$Buffer.prototype.equals = function equals(b) {
    if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $91f95d5c2eacfccd$var$Buffer.compare(this, b) === 0;
};
$91f95d5c2eacfccd$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $91f95d5c2eacfccd$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($91f95d5c2eacfccd$var$customInspectSymbol) $91f95d5c2eacfccd$var$Buffer.prototype[$91f95d5c2eacfccd$var$customInspectSymbol] = $91f95d5c2eacfccd$var$Buffer.prototype.inspect;
$91f95d5c2eacfccd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($91f95d5c2eacfccd$var$isInstance(target, Uint8Array)) target = $91f95d5c2eacfccd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $91f95d5c2eacfccd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($91f95d5c2eacfccd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $91f95d5c2eacfccd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($91f95d5c2eacfccd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $91f95d5c2eacfccd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $91f95d5c2eacfccd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $91f95d5c2eacfccd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$91f95d5c2eacfccd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$91f95d5c2eacfccd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $91f95d5c2eacfccd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$91f95d5c2eacfccd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $91f95d5c2eacfccd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $91f95d5c2eacfccd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($91f95d5c2eacfccd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $91f95d5c2eacfccd$var$utf8Write(buf, string, offset, length) {
    return $91f95d5c2eacfccd$var$blitBuffer($91f95d5c2eacfccd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $91f95d5c2eacfccd$var$asciiWrite(buf, string, offset, length) {
    return $91f95d5c2eacfccd$var$blitBuffer($91f95d5c2eacfccd$var$asciiToBytes(string), buf, offset, length);
}
function $91f95d5c2eacfccd$var$base64Write(buf, string, offset, length) {
    return $91f95d5c2eacfccd$var$blitBuffer($91f95d5c2eacfccd$var$base64ToBytes(string), buf, offset, length);
}
function $91f95d5c2eacfccd$var$ucs2Write(buf, string, offset, length) {
    return $91f95d5c2eacfccd$var$blitBuffer($91f95d5c2eacfccd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$91f95d5c2eacfccd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $91f95d5c2eacfccd$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $91f95d5c2eacfccd$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $91f95d5c2eacfccd$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $91f95d5c2eacfccd$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $91f95d5c2eacfccd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$91f95d5c2eacfccd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $91f95d5c2eacfccd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $91f95d5c2eacfccd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $91f95d5c2eacfccd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $91f95d5c2eacfccd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $91f95d5c2eacfccd$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $91f95d5c2eacfccd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $91f95d5c2eacfccd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $91f95d5c2eacfccd$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $91f95d5c2eacfccd$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $91f95d5c2eacfccd$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $91f95d5c2eacfccd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $91f95d5c2eacfccd$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$91f95d5c2eacfccd$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $91f95d5c2eacfccd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $91f95d5c2eacfccd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$91f95d5c2eacfccd$var$Buffer.prototype.readUintLE = $91f95d5c2eacfccd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUintBE = $91f95d5c2eacfccd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUint8 = $91f95d5c2eacfccd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUint16LE = $91f95d5c2eacfccd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUint16BE = $91f95d5c2eacfccd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUint32LE = $91f95d5c2eacfccd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readUint32BE = $91f95d5c2eacfccd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$91f95d5c2eacfccd$var$Buffer.prototype.readBigUInt64LE = $91f95d5c2eacfccd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $91f95d5c2eacfccd$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $91f95d5c2eacfccd$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$91f95d5c2eacfccd$var$Buffer.prototype.readBigUInt64BE = $91f95d5c2eacfccd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $91f95d5c2eacfccd$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $91f95d5c2eacfccd$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$91f95d5c2eacfccd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$91f95d5c2eacfccd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$91f95d5c2eacfccd$var$Buffer.prototype.readBigInt64LE = $91f95d5c2eacfccd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $91f95d5c2eacfccd$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $91f95d5c2eacfccd$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$91f95d5c2eacfccd$var$Buffer.prototype.readBigInt64BE = $91f95d5c2eacfccd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $91f95d5c2eacfccd$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $91f95d5c2eacfccd$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$91f95d5c2eacfccd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$91f95d5c2eacfccd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$91f95d5c2eacfccd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$91f95d5c2eacfccd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $91f95d5c2eacfccd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$91f95d5c2eacfccd$var$Buffer.prototype.writeUintLE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $91f95d5c2eacfccd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUintBE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $91f95d5c2eacfccd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUint8 = $91f95d5c2eacfccd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUint16LE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUint16BE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUint32LE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeUint32BE = $91f95d5c2eacfccd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $91f95d5c2eacfccd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $91f95d5c2eacfccd$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $91f95d5c2eacfccd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $91f95d5c2eacfccd$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$91f95d5c2eacfccd$var$Buffer.prototype.writeBigUInt64LE = $91f95d5c2eacfccd$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $91f95d5c2eacfccd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$91f95d5c2eacfccd$var$Buffer.prototype.writeBigUInt64BE = $91f95d5c2eacfccd$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $91f95d5c2eacfccd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$91f95d5c2eacfccd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $91f95d5c2eacfccd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $91f95d5c2eacfccd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeBigInt64LE = $91f95d5c2eacfccd$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $91f95d5c2eacfccd$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$91f95d5c2eacfccd$var$Buffer.prototype.writeBigInt64BE = $91f95d5c2eacfccd$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $91f95d5c2eacfccd$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $91f95d5c2eacfccd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $91f95d5c2eacfccd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$91f95d5c2eacfccd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $91f95d5c2eacfccd$var$writeFloat(this, value, offset, true, noAssert);
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $91f95d5c2eacfccd$var$writeFloat(this, value, offset, false, noAssert);
};
function $91f95d5c2eacfccd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $91f95d5c2eacfccd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$91f95d5c2eacfccd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $91f95d5c2eacfccd$var$writeDouble(this, value, offset, true, noAssert);
};
$91f95d5c2eacfccd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $91f95d5c2eacfccd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$91f95d5c2eacfccd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$91f95d5c2eacfccd$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$91f95d5c2eacfccd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$91f95d5c2eacfccd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $91f95d5c2eacfccd$var$Buffer.isBuffer(val) ? val : $91f95d5c2eacfccd$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $91f95d5c2eacfccd$var$errors = {};
function $91f95d5c2eacfccd$var$E(sym, getMessage, Base) {
    $91f95d5c2eacfccd$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$91f95d5c2eacfccd$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$91f95d5c2eacfccd$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$91f95d5c2eacfccd$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $91f95d5c2eacfccd$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $91f95d5c2eacfccd$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $91f95d5c2eacfccd$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $91f95d5c2eacfccd$var$checkBounds(buf, offset, byteLength) {
    $91f95d5c2eacfccd$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $91f95d5c2eacfccd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $91f95d5c2eacfccd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $91f95d5c2eacfccd$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $91f95d5c2eacfccd$var$checkBounds(buf, offset, byteLength);
}
function $91f95d5c2eacfccd$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $91f95d5c2eacfccd$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $91f95d5c2eacfccd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $91f95d5c2eacfccd$var$validateNumber(value, type);
        throw new $91f95d5c2eacfccd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $91f95d5c2eacfccd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $91f95d5c2eacfccd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $91f95d5c2eacfccd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $91f95d5c2eacfccd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($91f95d5c2eacfccd$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $91f95d5c2eacfccd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $91f95d5c2eacfccd$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $91f95d5c2eacfccd$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $91f95d5c2eacfccd$var$base64ToBytes(str) {
    return $abUaD.toByteArray($91f95d5c2eacfccd$var$base64clean(str));
}
function $91f95d5c2eacfccd$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $91f95d5c2eacfccd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $91f95d5c2eacfccd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $91f95d5c2eacfccd$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $91f95d5c2eacfccd$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $91f95d5c2eacfccd$var$BufferBigIntNotDefined : fn;
}
function $91f95d5c2eacfccd$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("6zAfR", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $4c92226de4634c4e$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $4c92226de4634c4e$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("bsQpc", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $cx11P = parcelRequire("cx11P");

var $333Pc = parcelRequire("333Pc");
var $858af5d8a1b440e8$var$format = $333Pc.format, $858af5d8a1b440e8$var$inspect = $333Pc.inspect;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $858af5d8a1b440e8$var$ERR_INVALID_ARG_TYPE = $5Q9Jl.codes.ERR_INVALID_ARG_TYPE;

var $6zAfR = parcelRequire("6zAfR");
var $858af5d8a1b440e8$var$kResistStopPropagation = $6zAfR.kResistStopPropagation, $858af5d8a1b440e8$var$AggregateError = $6zAfR.AggregateError, $858af5d8a1b440e8$var$SymbolDispose = $6zAfR.SymbolDispose;

var $858af5d8a1b440e8$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $858af5d8a1b440e8$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $858af5d8a1b440e8$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $858af5d8a1b440e8$var$Blob = globalThis.Blob || $cx11P.Blob;
/* eslint-disable indent */ var $858af5d8a1b440e8$var$isBlob = typeof $858af5d8a1b440e8$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $858af5d8a1b440e8$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $858af5d8a1b440e8$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $858af5d8a1b440e8$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $858af5d8a1b440e8$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $858af5d8a1b440e8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $858af5d8a1b440e8$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $858af5d8a1b440e8$var$format,
    inspect: $858af5d8a1b440e8$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $858af5d8a1b440e8$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $858af5d8a1b440e8$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $858af5d8a1b440e8$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $858af5d8a1b440e8$var$validateAbortSignal(signal, 'signal');
        $858af5d8a1b440e8$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $858af5d8a1b440e8$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $858af5d8a1b440e8$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $858af5d8a1b440e8$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $858af5d8a1b440e8$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $858af5d8a1b440e8$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("333Pc", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("5Q9Jl", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $333Pc = parcelRequire("333Pc");
var $44095b530fff7bba$var$format = $333Pc.format, $44095b530fff7bba$var$inspect = $333Pc.inspect;

var $6zAfR = parcelRequire("6zAfR");
var $44095b530fff7bba$var$CustomAggregateError = $6zAfR.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $44095b530fff7bba$var$AggregateError = globalThis.AggregateError || $44095b530fff7bba$var$CustomAggregateError;
var $44095b530fff7bba$var$kIsNodeError = Symbol('kIsNodeError');
var $44095b530fff7bba$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $44095b530fff7bba$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $44095b530fff7bba$var$nodeInternalPrefix = '__node_internal_';
var $44095b530fff7bba$var$codes = {};
function $44095b530fff7bba$var$assert(value, message) {
    if (!value) throw new $44095b530fff7bba$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $44095b530fff7bba$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $44095b530fff7bba$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $44095b530fff7bba$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $44095b530fff7bba$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $44095b530fff7bba$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $44095b530fff7bba$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $44095b530fff7bba$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$44095b530fff7bba$var$kIsNodeError] = true;
    $44095b530fff7bba$var$codes[code] = NodeError;
}
function $44095b530fff7bba$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $44095b530fff7bba$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $44095b530fff7bba$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $44095b530fff7bba$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $44095b530fff7bba$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $44095b530fff7bba$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$44095b530fff7bba$var$E('ERR_ASSERTION', '%s', Error);
$44095b530fff7bba$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $44095b530fff7bba$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $44095b530fff7bba$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($44095b530fff7bba$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($44095b530fff7bba$var$classRegExp.test(value)) instances.push(value);
            else {
                $44095b530fff7bba$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $44095b530fff7bba$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $44095b530fff7bba$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$44095b530fff7bba$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $44095b530fff7bba$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$44095b530fff7bba$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$44095b530fff7bba$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $44095b530fff7bba$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$44095b530fff7bba$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $44095b530fff7bba$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $44095b530fff7bba$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $44095b530fff7bba$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $44095b530fff7bba$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$44095b530fff7bba$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$44095b530fff7bba$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$44095b530fff7bba$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$44095b530fff7bba$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$44095b530fff7bba$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$44095b530fff7bba$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$44095b530fff7bba$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$44095b530fff7bba$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$44095b530fff7bba$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$44095b530fff7bba$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$44095b530fff7bba$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $44095b530fff7bba$var$AbortError,
    aggregateTwoErrors: $44095b530fff7bba$var$hideStackFrames($44095b530fff7bba$var$aggregateTwoErrors),
    hideStackFrames: $44095b530fff7bba$var$hideStackFrames,
    codes: $44095b530fff7bba$var$codes
};

});


parcelRegister("6NdpE", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $4f21b925fa123d85$export$42af8c323be37587; }, function (v) { return $4f21b925fa123d85$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $4f21b925fa123d85$export$f405f72c701dad87; }, function (v) { return $4f21b925fa123d85$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $4f21b925fa123d85$export$42af8c323be37587;
var $4f21b925fa123d85$export$f405f72c701dad87;
'use strict';

var $4f21b925fa123d85$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $4f21b925fa123d85$var$_require_codes = $5Q9Jl.codes, $4f21b925fa123d85$var$ERR_INVALID_ARG_VALUE = $4f21b925fa123d85$var$_require_codes.ERR_INVALID_ARG_VALUE, $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE = $4f21b925fa123d85$var$_require_codes.ERR_INVALID_ARG_TYPE, $4f21b925fa123d85$var$ERR_MISSING_ARGS = $4f21b925fa123d85$var$_require_codes.ERR_MISSING_ARGS, $4f21b925fa123d85$var$ERR_OUT_OF_RANGE = $4f21b925fa123d85$var$_require_codes.ERR_OUT_OF_RANGE, $4f21b925fa123d85$var$AbortError = $5Q9Jl.AbortError;

var $1UD22 = parcelRequire("1UD22");
var $4f21b925fa123d85$var$validateAbortSignal = $1UD22.validateAbortSignal, $4f21b925fa123d85$var$validateInteger = $1UD22.validateInteger, $4f21b925fa123d85$var$validateObject = $1UD22.validateObject;

var $4f21b925fa123d85$var$kWeakHandler = (parcelRequire("6zAfR")).Symbol('kWeak');

var $4f21b925fa123d85$var$kResistStopPropagation = (parcelRequire("6zAfR")).Symbol('kResistStopPropagation');

var $7UDrs = parcelRequire("7UDrs");
var $4f21b925fa123d85$require$finished = $7UDrs.finished;

var $gU4DH = parcelRequire("gU4DH");

var $41Z6q = parcelRequire("41Z6q");
var $4f21b925fa123d85$require$addAbortSignalNoValidate = $41Z6q.addAbortSignalNoValidate;

var $kq58L = parcelRequire("kq58L");
var $4f21b925fa123d85$var$isWritable = $kq58L.isWritable, $4f21b925fa123d85$var$isNodeStream = $kq58L.isNodeStream;

var $4f21b925fa123d85$require$deprecate = (parcelRequire("bsQpc")).deprecate;

var $4f21b925fa123d85$var$ArrayPrototypePush = (parcelRequire("6zAfR")).ArrayPrototypePush, $4f21b925fa123d85$var$Boolean = (parcelRequire("6zAfR")).Boolean, $4f21b925fa123d85$var$MathFloor = (parcelRequire("6zAfR")).MathFloor, $4f21b925fa123d85$var$Number = (parcelRequire("6zAfR")).Number, $4f21b925fa123d85$var$NumberIsNaN = (parcelRequire("6zAfR")).NumberIsNaN, $4f21b925fa123d85$var$Promise = (parcelRequire("6zAfR")).Promise, $4f21b925fa123d85$var$PromiseReject = (parcelRequire("6zAfR")).PromiseReject, $4f21b925fa123d85$var$PromiseResolve = (parcelRequire("6zAfR")).PromiseResolve, $4f21b925fa123d85$var$PromisePrototypeThen = (parcelRequire("6zAfR")).PromisePrototypeThen, $4f21b925fa123d85$var$Symbol = (parcelRequire("6zAfR")).Symbol;
var $4f21b925fa123d85$var$kEmpty = $4f21b925fa123d85$var$Symbol('kEmpty');
var $4f21b925fa123d85$var$kEof = $4f21b925fa123d85$var$Symbol('kEof');
function $4f21b925fa123d85$var$compose(stream, options) {
    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
    if ($4f21b925fa123d85$var$isNodeStream(stream) && !$4f21b925fa123d85$var$isWritable(stream)) throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $gU4DH(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $4f21b925fa123d85$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $4f21b925fa123d85$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $4f21b925fa123d85$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $4f21b925fa123d85$var$MathFloor(options.highWaterMark);
    $4f21b925fa123d85$var$validateInteger(concurrency, 'options.concurrency', 1);
    $4f21b925fa123d85$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $4f21b925fa123d85$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $4f21b925fa123d85$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $4f21b925fa123d85$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $4f21b925fa123d85$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $4f21b925fa123d85$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $4f21b925fa123d85$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($4f21b925fa123d85$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $4f21b925fa123d85$var$PromiseReject(err1);
                                $4f21b925fa123d85$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("bsQpc")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($4f21b925fa123d85$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $4f21b925fa123d85$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $4f21b925fa123d85$var$AbortError();
                        if (!(val !== $4f21b925fa123d85$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $4f21b925fa123d85$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4f21b925fa123d85$var$asIndexedPairs(options) {
    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $4f21b925fa123d85$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4f21b925fa123d85$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4f21b925fa123d85$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $4f21b925fa123d85$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $4f21b925fa123d85$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $4f21b925fa123d85$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4f21b925fa123d85$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $4f21b925fa123d85$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $4f21b925fa123d85$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4f21b925fa123d85$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $4f21b925fa123d85$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $4f21b925fa123d85$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $4f21b925fa123d85$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $4f21b925fa123d85$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($4f21b925fa123d85$var$ERR_MISSING_ARGS);
function $4f21b925fa123d85$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $4f21b925fa123d85$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $4f21b925fa123d85$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $4f21b925fa123d85$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $4f21b925fa123d85$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $4f21b925fa123d85$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $4f21b925fa123d85$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $4f21b925fa123d85$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $4f21b925fa123d85$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $4f21b925fa123d85$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $4f21b925fa123d85$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $4f21b925fa123d85$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $4f21b925fa123d85$var$flatMap(fn, options) {
    var values = $4f21b925fa123d85$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $4f21b925fa123d85$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $4f21b925fa123d85$var$Number(number);
    if ($4f21b925fa123d85$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $4f21b925fa123d85$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $4f21b925fa123d85$var$drop(number, options) {
    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4f21b925fa123d85$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $4f21b925fa123d85$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $4f21b925fa123d85$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4f21b925fa123d85$var$take(number, options) {
    if (options != null) $4f21b925fa123d85$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4f21b925fa123d85$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4f21b925fa123d85$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $4f21b925fa123d85$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $4f21b925fa123d85$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$4f21b925fa123d85$export$42af8c323be37587 = {
    asIndexedPairs: $4f21b925fa123d85$require$deprecate($4f21b925fa123d85$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $4f21b925fa123d85$var$drop,
    filter: $4f21b925fa123d85$var$filter,
    flatMap: $4f21b925fa123d85$var$flatMap,
    map: $4f21b925fa123d85$var$map,
    take: $4f21b925fa123d85$var$take,
    compose: $4f21b925fa123d85$var$compose
};
$4f21b925fa123d85$export$f405f72c701dad87 = {
    every: $4f21b925fa123d85$var$every,
    forEach: $4f21b925fa123d85$var$forEach,
    reduce: $4f21b925fa123d85$var$reduce,
    toArray: $4f21b925fa123d85$var$toArray,
    some: $4f21b925fa123d85$var$some,
    find: $4f21b925fa123d85$var$find
};

});
parcelRegister("1UD22", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $16494c4ed308500f$var$ArrayIsArray = $6zAfR.ArrayIsArray, $16494c4ed308500f$var$ArrayPrototypeIncludes = $6zAfR.ArrayPrototypeIncludes, $16494c4ed308500f$var$ArrayPrototypeJoin = $6zAfR.ArrayPrototypeJoin, $16494c4ed308500f$var$ArrayPrototypeMap = $6zAfR.ArrayPrototypeMap, $16494c4ed308500f$var$NumberIsInteger = $6zAfR.NumberIsInteger, $16494c4ed308500f$var$NumberIsNaN = $6zAfR.NumberIsNaN, $16494c4ed308500f$var$NumberMAX_SAFE_INTEGER = $6zAfR.NumberMAX_SAFE_INTEGER, $16494c4ed308500f$var$NumberMIN_SAFE_INTEGER = $6zAfR.NumberMIN_SAFE_INTEGER, $16494c4ed308500f$var$NumberParseInt = $6zAfR.NumberParseInt, $16494c4ed308500f$var$ObjectPrototypeHasOwnProperty = $6zAfR.ObjectPrototypeHasOwnProperty, $16494c4ed308500f$var$RegExpPrototypeExec = $6zAfR.RegExpPrototypeExec, $16494c4ed308500f$var$String = $6zAfR.String, $16494c4ed308500f$var$StringPrototypeToUpperCase = $6zAfR.StringPrototypeToUpperCase, $16494c4ed308500f$var$StringPrototypeTrim = $6zAfR.StringPrototypeTrim;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $16494c4ed308500f$var$hideStackFrames = $5Q9Jl.hideStackFrames, $16494c4ed308500f$var$_require_codes = $5Q9Jl.codes, $16494c4ed308500f$var$ERR_SOCKET_BAD_PORT = $16494c4ed308500f$var$_require_codes.ERR_SOCKET_BAD_PORT, $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE = $16494c4ed308500f$var$_require_codes.ERR_INVALID_ARG_TYPE, $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE = $16494c4ed308500f$var$_require_codes.ERR_INVALID_ARG_VALUE, $16494c4ed308500f$var$ERR_OUT_OF_RANGE = $16494c4ed308500f$var$_require_codes.ERR_OUT_OF_RANGE, $16494c4ed308500f$var$ERR_UNKNOWN_SIGNAL = $16494c4ed308500f$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $bsQpc = parcelRequire("bsQpc");
var $16494c4ed308500f$require$normalizeEncoding = $bsQpc.normalizeEncoding;

var $bsQpc = parcelRequire("bsQpc");
var $16494c4ed308500f$require$_require_types = $bsQpc.types;
var $16494c4ed308500f$var$isAsyncFunction = $16494c4ed308500f$require$_require_types.isAsyncFunction, $16494c4ed308500f$var$isArrayBufferView = $16494c4ed308500f$require$_require_types.isArrayBufferView;
var $16494c4ed308500f$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $16494c4ed308500f$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $16494c4ed308500f$var$isUint32(value) {
    return value === value >>> 0;
}
var $16494c4ed308500f$var$octalReg = /^[0-7]+$/;
var $16494c4ed308500f$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $16494c4ed308500f$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($16494c4ed308500f$var$RegExpPrototypeExec($16494c4ed308500f$var$octalReg, value) === null) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE(name, value, $16494c4ed308500f$var$modeDesc);
        value = $16494c4ed308500f$var$NumberParseInt(value, 8);
    }
    $16494c4ed308500f$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $16494c4ed308500f$var$validateInteger = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $16494c4ed308500f$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $16494c4ed308500f$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$16494c4ed308500f$var$NumberIsInteger(value)) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $16494c4ed308500f$var$validateInt32 = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$16494c4ed308500f$var$NumberIsInteger(value)) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $16494c4ed308500f$var$validateUint32 = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$16494c4ed308500f$var$NumberIsInteger(value)) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $16494c4ed308500f$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $16494c4ed308500f$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $16494c4ed308500f$var$NumberIsNaN(value)) throw new $16494c4ed308500f$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $16494c4ed308500f$var$validateOneOf = $16494c4ed308500f$var$hideStackFrames(function(value, name, oneOf) {
    if (!$16494c4ed308500f$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $16494c4ed308500f$var$ArrayPrototypeJoin($16494c4ed308500f$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $16494c4ed308500f$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $16494c4ed308500f$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $16494c4ed308500f$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$16494c4ed308500f$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $16494c4ed308500f$var$validateObject = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $16494c4ed308500f$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $16494c4ed308500f$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $16494c4ed308500f$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $16494c4ed308500f$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $16494c4ed308500f$var$validateDictionary = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $16494c4ed308500f$var$validateArray = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$16494c4ed308500f$var$ArrayIsArray(value)) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $16494c4ed308500f$var$validateStringArray(value, name) {
    $16494c4ed308500f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$16494c4ed308500f$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $16494c4ed308500f$var$validateBooleanArray(value, name) {
    $16494c4ed308500f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$16494c4ed308500f$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $16494c4ed308500f$var$validateAbortSignalArray(value, name) {
    $16494c4ed308500f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $16494c4ed308500f$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $16494c4ed308500f$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $16494c4ed308500f$var$validateString(signal, name);
    if ($16494c4ed308500f$var$signals[signal] === undefined) {
        if ($16494c4ed308500f$var$signals[$16494c4ed308500f$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $16494c4ed308500f$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $16494c4ed308500f$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $16494c4ed308500f$var$validateBuffer = $16494c4ed308500f$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$16494c4ed308500f$var$isArrayBufferView(buffer)) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $16494c4ed308500f$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $16494c4ed308500f$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $16494c4ed308500f$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $16494c4ed308500f$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $16494c4ed308500f$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $16494c4ed308500f$var$validateAbortSignal = $16494c4ed308500f$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $16494c4ed308500f$var$validateFunction = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $16494c4ed308500f$var$validatePlainFunction = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $16494c4ed308500f$var$isAsyncFunction(value)) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $16494c4ed308500f$var$validateUndefined = $16494c4ed308500f$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $16494c4ed308500f$var$validateUnion(value, name, union) {
    if (!$16494c4ed308500f$var$ArrayPrototypeIncludes(union, value)) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_TYPE(name, "('".concat($16494c4ed308500f$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $16494c4ed308500f$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $16494c4ed308500f$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$16494c4ed308500f$var$RegExpPrototypeExec($16494c4ed308500f$var$linkValueRegExp, value)) throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $16494c4ed308500f$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $16494c4ed308500f$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($16494c4ed308500f$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $16494c4ed308500f$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $16494c4ed308500f$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $16494c4ed308500f$var$isInt32,
    isUint32: $16494c4ed308500f$var$isUint32,
    parseFileMode: $16494c4ed308500f$var$parseFileMode,
    validateArray: $16494c4ed308500f$var$validateArray,
    validateStringArray: $16494c4ed308500f$var$validateStringArray,
    validateBooleanArray: $16494c4ed308500f$var$validateBooleanArray,
    validateAbortSignalArray: $16494c4ed308500f$var$validateAbortSignalArray,
    validateBoolean: $16494c4ed308500f$var$validateBoolean,
    validateBuffer: $16494c4ed308500f$var$validateBuffer,
    validateDictionary: $16494c4ed308500f$var$validateDictionary,
    validateEncoding: $16494c4ed308500f$var$validateEncoding,
    validateFunction: $16494c4ed308500f$var$validateFunction,
    validateInt32: $16494c4ed308500f$var$validateInt32,
    validateInteger: $16494c4ed308500f$var$validateInteger,
    validateNumber: $16494c4ed308500f$var$validateNumber,
    validateObject: $16494c4ed308500f$var$validateObject,
    validateOneOf: $16494c4ed308500f$var$validateOneOf,
    validatePlainFunction: $16494c4ed308500f$var$validatePlainFunction,
    validatePort: $16494c4ed308500f$var$validatePort,
    validateSignalName: $16494c4ed308500f$var$validateSignalName,
    validateString: $16494c4ed308500f$var$validateString,
    validateUint32: $16494c4ed308500f$var$validateUint32,
    validateUndefined: $16494c4ed308500f$var$validateUndefined,
    validateUnion: $16494c4ed308500f$var$validateUnion,
    validateAbortSignal: $16494c4ed308500f$var$validateAbortSignal,
    validateLinkHeaderValue: $16494c4ed308500f$var$validateLinkHeaderValue
};

});

parcelRegister("7UDrs", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $5Q9Jl = parcelRequire("5Q9Jl");
/* replacement end */ var $5c2c5bb2d65e8717$var$AbortError = $5Q9Jl.AbortError, $5c2c5bb2d65e8717$var$codes = $5Q9Jl.codes;
var $5c2c5bb2d65e8717$var$ERR_INVALID_ARG_TYPE = $5c2c5bb2d65e8717$var$codes.ERR_INVALID_ARG_TYPE, $5c2c5bb2d65e8717$var$ERR_STREAM_PREMATURE_CLOSE = $5c2c5bb2d65e8717$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $5c2c5bb2d65e8717$var$kEmptyObject = (parcelRequire("bsQpc")).kEmptyObject, $5c2c5bb2d65e8717$var$once = (parcelRequire("bsQpc")).once;

var $1UD22 = parcelRequire("1UD22");
var $5c2c5bb2d65e8717$var$validateAbortSignal = $1UD22.validateAbortSignal, $5c2c5bb2d65e8717$var$validateFunction = $1UD22.validateFunction, $5c2c5bb2d65e8717$var$validateObject = $1UD22.validateObject, $5c2c5bb2d65e8717$var$validateBoolean = $1UD22.validateBoolean;

var $6zAfR = parcelRequire("6zAfR");
var $5c2c5bb2d65e8717$var$Promise = $6zAfR.Promise, $5c2c5bb2d65e8717$var$PromisePrototypeThen = $6zAfR.PromisePrototypeThen, $5c2c5bb2d65e8717$var$SymbolDispose = $6zAfR.SymbolDispose;

var $kq58L = parcelRequire("kq58L");
var $5c2c5bb2d65e8717$var$isClosed = $kq58L.isClosed, $5c2c5bb2d65e8717$var$isReadable = $kq58L.isReadable, $5c2c5bb2d65e8717$var$isReadableNodeStream = $kq58L.isReadableNodeStream, $5c2c5bb2d65e8717$var$isReadableStream = $kq58L.isReadableStream, $5c2c5bb2d65e8717$var$isReadableFinished = $kq58L.isReadableFinished, $5c2c5bb2d65e8717$var$isReadableErrored = $kq58L.isReadableErrored, $5c2c5bb2d65e8717$var$isWritable = $kq58L.isWritable, $5c2c5bb2d65e8717$var$isWritableNodeStream = $kq58L.isWritableNodeStream, $5c2c5bb2d65e8717$var$isWritableStream = $kq58L.isWritableStream, $5c2c5bb2d65e8717$var$isWritableFinished = $kq58L.isWritableFinished, $5c2c5bb2d65e8717$var$isWritableErrored = $kq58L.isWritableErrored, $5c2c5bb2d65e8717$var$isNodeStream = $kq58L.isNodeStream, $5c2c5bb2d65e8717$var$_willEmitClose = $kq58L.willEmitClose, $5c2c5bb2d65e8717$var$kIsClosedPromise = $kq58L.kIsClosedPromise;
var $5c2c5bb2d65e8717$var$addAbortListener;
function $5c2c5bb2d65e8717$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $5c2c5bb2d65e8717$var$nop = function() {};

function $5c2c5bb2d65e8717$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $5c2c5bb2d65e8717$var$kEmptyObject;
    } else if (options == null) options = $5c2c5bb2d65e8717$var$kEmptyObject;
    else $5c2c5bb2d65e8717$var$validateObject(options, 'options');
    $5c2c5bb2d65e8717$var$validateFunction(callback, 'callback');
    $5c2c5bb2d65e8717$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $5c2c5bb2d65e8717$var$once(callback);
    if ($5c2c5bb2d65e8717$var$isReadableStream(stream) || $5c2c5bb2d65e8717$var$isWritableStream(stream)) return $5c2c5bb2d65e8717$var$eosWeb(stream, options, callback);
    if (!$5c2c5bb2d65e8717$var$isNodeStream(stream)) throw new $5c2c5bb2d65e8717$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $5c2c5bb2d65e8717$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $5c2c5bb2d65e8717$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $5c2c5bb2d65e8717$var$_willEmitClose(stream) && $5c2c5bb2d65e8717$var$isReadableNodeStream(stream) === readable && $5c2c5bb2d65e8717$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $5c2c5bb2d65e8717$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $5c2c5bb2d65e8717$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $5c2c5bb2d65e8717$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $5c2c5bb2d65e8717$var$isWritableErrored(stream) || $5c2c5bb2d65e8717$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $5c2c5bb2d65e8717$var$isReadableNodeStream(stream, true)) {
            if (!$5c2c5bb2d65e8717$var$isReadableFinished(stream, false)) return callback.call(stream, new $5c2c5bb2d65e8717$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$5c2c5bb2d65e8717$var$isWritableFinished(stream, false)) return callback.call(stream, new $5c2c5bb2d65e8717$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $5c2c5bb2d65e8717$var$isWritableErrored(stream) || $5c2c5bb2d65e8717$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($5c2c5bb2d65e8717$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $5c2c5bb2d65e8717$var$isReadable(stream)) && (writableFinished || $5c2c5bb2d65e8717$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $5c2c5bb2d65e8717$var$isWritable(stream)) && (readableFinished || $5c2c5bb2d65e8717$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $5c2c5bb2d65e8717$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $5c2c5bb2d65e8717$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $5c2c5bb2d65e8717$var$addAbortListener = $5c2c5bb2d65e8717$var$addAbortListener || (parcelRequire("bsQpc")).addAbortListener;
            var disposable = $5c2c5bb2d65e8717$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $5c2c5bb2d65e8717$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$5c2c5bb2d65e8717$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $5c2c5bb2d65e8717$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $5c2c5bb2d65e8717$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $5c2c5bb2d65e8717$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $5c2c5bb2d65e8717$var$addAbortListener = $5c2c5bb2d65e8717$var$addAbortListener || (parcelRequire("bsQpc")).addAbortListener;
            var disposable = $5c2c5bb2d65e8717$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $5c2c5bb2d65e8717$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$5c2c5bb2d65e8717$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $5c2c5bb2d65e8717$var$PromisePrototypeThen(stream[$5c2c5bb2d65e8717$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $5c2c5bb2d65e8717$var$nop;
}
function $5c2c5bb2d65e8717$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $5c2c5bb2d65e8717$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $5c2c5bb2d65e8717$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $5c2c5bb2d65e8717$var$Promise(function(resolve, reject) {
        var cleanup = $5c2c5bb2d65e8717$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $5c2c5bb2d65e8717$var$eos;
module.exports.finished = $5c2c5bb2d65e8717$var$finished;

});
parcelRegister("kq58L", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $edda3924ad0a13f2$var$SymbolAsyncIterator = $6zAfR.SymbolAsyncIterator, $edda3924ad0a13f2$var$SymbolIterator = $6zAfR.SymbolIterator, $edda3924ad0a13f2$var$SymbolFor = $6zAfR.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $edda3924ad0a13f2$var$kIsDestroyed = $edda3924ad0a13f2$var$SymbolFor('nodejs.stream.destroyed');
var $edda3924ad0a13f2$var$kIsErrored = $edda3924ad0a13f2$var$SymbolFor('nodejs.stream.errored');
var $edda3924ad0a13f2$var$kIsReadable = $edda3924ad0a13f2$var$SymbolFor('nodejs.stream.readable');
var $edda3924ad0a13f2$var$kIsWritable = $edda3924ad0a13f2$var$SymbolFor('nodejs.stream.writable');
var $edda3924ad0a13f2$var$kIsDisturbed = $edda3924ad0a13f2$var$SymbolFor('nodejs.stream.disturbed');
var $edda3924ad0a13f2$var$kIsClosedPromise = $edda3924ad0a13f2$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $edda3924ad0a13f2$var$kControllerErrorFunction = $edda3924ad0a13f2$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $edda3924ad0a13f2$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $edda3924ad0a13f2$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $edda3924ad0a13f2$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $edda3924ad0a13f2$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $edda3924ad0a13f2$var$isReadableStream(obj) {
    return !!(obj && !$edda3924ad0a13f2$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $edda3924ad0a13f2$var$isWritableStream(obj) {
    return !!(obj && !$edda3924ad0a13f2$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $edda3924ad0a13f2$var$isTransformStream(obj) {
    return !!(obj && !$edda3924ad0a13f2$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $edda3924ad0a13f2$var$isWebStream(obj) {
    return $edda3924ad0a13f2$var$isReadableStream(obj) || $edda3924ad0a13f2$var$isWritableStream(obj) || $edda3924ad0a13f2$var$isTransformStream(obj);
}
function $edda3924ad0a13f2$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$edda3924ad0a13f2$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$edda3924ad0a13f2$var$SymbolIterator] === 'function';
    return typeof obj[$edda3924ad0a13f2$var$SymbolAsyncIterator] === 'function' || typeof obj[$edda3924ad0a13f2$var$SymbolIterator] === 'function';
}
function $edda3924ad0a13f2$var$isDestroyed(stream) {
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$edda3924ad0a13f2$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $edda3924ad0a13f2$var$isWritableEnded(stream) {
    if (!$edda3924ad0a13f2$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $edda3924ad0a13f2$var$isWritableFinished(stream, strict) {
    if (!$edda3924ad0a13f2$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $edda3924ad0a13f2$var$isReadableEnded(stream) {
    if (!$edda3924ad0a13f2$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $edda3924ad0a13f2$var$isReadableFinished(stream, strict) {
    if (!$edda3924ad0a13f2$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $edda3924ad0a13f2$var$isReadable(stream) {
    if (stream && stream[$edda3924ad0a13f2$var$kIsReadable] != null) return stream[$edda3924ad0a13f2$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($edda3924ad0a13f2$var$isDestroyed(stream)) return false;
    return $edda3924ad0a13f2$var$isReadableNodeStream(stream) && stream.readable && !$edda3924ad0a13f2$var$isReadableFinished(stream);
}
function $edda3924ad0a13f2$var$isWritable(stream) {
    if (stream && stream[$edda3924ad0a13f2$var$kIsWritable] != null) return stream[$edda3924ad0a13f2$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($edda3924ad0a13f2$var$isDestroyed(stream)) return false;
    return $edda3924ad0a13f2$var$isWritableNodeStream(stream) && stream.writable && !$edda3924ad0a13f2$var$isWritableEnded(stream);
}
function $edda3924ad0a13f2$var$isFinished(stream, opts) {
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    if ($edda3924ad0a13f2$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $edda3924ad0a13f2$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $edda3924ad0a13f2$var$isWritable(stream)) return false;
    return true;
}
function $edda3924ad0a13f2$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $edda3924ad0a13f2$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $edda3924ad0a13f2$var$isClosed(stream) {
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $edda3924ad0a13f2$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $edda3924ad0a13f2$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $edda3924ad0a13f2$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $edda3924ad0a13f2$var$isOutgoingMessage(stream);
}
function $edda3924ad0a13f2$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $edda3924ad0a13f2$var$willEmitClose(stream) {
    if (!$edda3924ad0a13f2$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $edda3924ad0a13f2$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $edda3924ad0a13f2$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$edda3924ad0a13f2$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $edda3924ad0a13f2$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$edda3924ad0a13f2$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $edda3924ad0a13f2$var$isDestroyed,
    kIsDestroyed: $edda3924ad0a13f2$var$kIsDestroyed,
    isDisturbed: $edda3924ad0a13f2$var$isDisturbed,
    kIsDisturbed: $edda3924ad0a13f2$var$kIsDisturbed,
    isErrored: $edda3924ad0a13f2$var$isErrored,
    kIsErrored: $edda3924ad0a13f2$var$kIsErrored,
    isReadable: $edda3924ad0a13f2$var$isReadable,
    kIsReadable: $edda3924ad0a13f2$var$kIsReadable,
    kIsClosedPromise: $edda3924ad0a13f2$var$kIsClosedPromise,
    kControllerErrorFunction: $edda3924ad0a13f2$var$kControllerErrorFunction,
    kIsWritable: $edda3924ad0a13f2$var$kIsWritable,
    isClosed: $edda3924ad0a13f2$var$isClosed,
    isDuplexNodeStream: $edda3924ad0a13f2$var$isDuplexNodeStream,
    isFinished: $edda3924ad0a13f2$var$isFinished,
    isIterable: $edda3924ad0a13f2$var$isIterable,
    isReadableNodeStream: $edda3924ad0a13f2$var$isReadableNodeStream,
    isReadableStream: $edda3924ad0a13f2$var$isReadableStream,
    isReadableEnded: $edda3924ad0a13f2$var$isReadableEnded,
    isReadableFinished: $edda3924ad0a13f2$var$isReadableFinished,
    isReadableErrored: $edda3924ad0a13f2$var$isReadableErrored,
    isNodeStream: $edda3924ad0a13f2$var$isNodeStream,
    isWebStream: $edda3924ad0a13f2$var$isWebStream,
    isWritable: $edda3924ad0a13f2$var$isWritable,
    isWritableNodeStream: $edda3924ad0a13f2$var$isWritableNodeStream,
    isWritableStream: $edda3924ad0a13f2$var$isWritableStream,
    isWritableEnded: $edda3924ad0a13f2$var$isWritableEnded,
    isWritableFinished: $edda3924ad0a13f2$var$isWritableFinished,
    isWritableErrored: $edda3924ad0a13f2$var$isWritableErrored,
    isServerRequest: $edda3924ad0a13f2$var$isServerRequest,
    isServerResponse: $edda3924ad0a13f2$var$isServerResponse,
    willEmitClose: $edda3924ad0a13f2$var$willEmitClose,
    isTransformStream: $edda3924ad0a13f2$var$isTransformStream
};

});


parcelRegister("gU4DH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eHl1m = parcelRequire("eHl1m");
var $c4e5798d12b1766e$require$pipeline = $eHl1m.pipeline;

var $ab4Kx = parcelRequire("ab4Kx");

var $jBUYd = parcelRequire("jBUYd");
var $c4e5798d12b1766e$require$destroyer = $jBUYd.destroyer;

var $kq58L = parcelRequire("kq58L");
var $c4e5798d12b1766e$var$isNodeStream = $kq58L.isNodeStream, $c4e5798d12b1766e$var$isReadable = $kq58L.isReadable, $c4e5798d12b1766e$var$isWritable = $kq58L.isWritable, $c4e5798d12b1766e$var$isWebStream = $kq58L.isWebStream, $c4e5798d12b1766e$var$isTransformStream = $kq58L.isTransformStream, $c4e5798d12b1766e$var$isWritableStream = $kq58L.isWritableStream, $c4e5798d12b1766e$var$isReadableStream = $kq58L.isReadableStream;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $c4e5798d12b1766e$var$AbortError = $5Q9Jl.AbortError, $c4e5798d12b1766e$var$_require_codes = $5Q9Jl.codes, $c4e5798d12b1766e$var$ERR_INVALID_ARG_VALUE = $c4e5798d12b1766e$var$_require_codes.ERR_INVALID_ARG_VALUE, $c4e5798d12b1766e$var$ERR_MISSING_ARGS = $c4e5798d12b1766e$var$_require_codes.ERR_MISSING_ARGS;

var $7UDrs = parcelRequire("7UDrs");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $c4e5798d12b1766e$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $ab4Kx.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $ab4Kx.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $ab4Kx.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$c4e5798d12b1766e$var$isNodeStream(streams[n]) && !$c4e5798d12b1766e$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($c4e5798d12b1766e$var$isReadable(streams[n]) || $c4e5798d12b1766e$var$isReadableStream(streams[n]) || $c4e5798d12b1766e$var$isTransformStream(streams[n]))) throw new $c4e5798d12b1766e$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($c4e5798d12b1766e$var$isWritable(streams[n]) || $c4e5798d12b1766e$var$isWritableStream(streams[n]) || $c4e5798d12b1766e$var$isTransformStream(streams[n]))) throw new $c4e5798d12b1766e$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $c4e5798d12b1766e$require$pipeline(streams, onfinished);
    var writable = !!($c4e5798d12b1766e$var$isWritable(head) || $c4e5798d12b1766e$var$isWritableStream(head) || $c4e5798d12b1766e$var$isTransformStream(head));
    var readable = !!($c4e5798d12b1766e$var$isReadable(tail) || $c4e5798d12b1766e$var$isReadableStream(tail) || $c4e5798d12b1766e$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ab4Kx({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($c4e5798d12b1766e$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($c4e5798d12b1766e$var$isWebStream(head)) {
            var writable1 = $c4e5798d12b1766e$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $c4e5798d12b1766e$var$isTransformStream(tail) ? tail.readable : tail;
        $7UDrs(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($c4e5798d12b1766e$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($c4e5798d12b1766e$var$isWebStream(tail)) {
            var readable1 = $c4e5798d12b1766e$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $c4e5798d12b1766e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($c4e5798d12b1766e$var$isNodeStream(tail)) $c4e5798d12b1766e$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("eHl1m", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $ab35632b46c6bc42$var$ArrayIsArray = $6zAfR.ArrayIsArray, $ab35632b46c6bc42$var$Promise = $6zAfR.Promise, $ab35632b46c6bc42$var$SymbolAsyncIterator = $6zAfR.SymbolAsyncIterator, $ab35632b46c6bc42$var$SymbolDispose = $6zAfR.SymbolDispose;

var $7UDrs = parcelRequire("7UDrs");

var $ab35632b46c6bc42$require$once = (parcelRequire("bsQpc")).once;

var $jBUYd = parcelRequire("jBUYd");

var $ab4Kx = parcelRequire("ab4Kx");

var $5Q9Jl = parcelRequire("5Q9Jl");
var $ab35632b46c6bc42$var$aggregateTwoErrors = $5Q9Jl.aggregateTwoErrors, $ab35632b46c6bc42$var$_require_codes = $5Q9Jl.codes, $ab35632b46c6bc42$var$ERR_INVALID_ARG_TYPE = $ab35632b46c6bc42$var$_require_codes.ERR_INVALID_ARG_TYPE, $ab35632b46c6bc42$var$ERR_INVALID_RETURN_VALUE = $ab35632b46c6bc42$var$_require_codes.ERR_INVALID_RETURN_VALUE, $ab35632b46c6bc42$var$ERR_MISSING_ARGS = $ab35632b46c6bc42$var$_require_codes.ERR_MISSING_ARGS, $ab35632b46c6bc42$var$ERR_STREAM_DESTROYED = $ab35632b46c6bc42$var$_require_codes.ERR_STREAM_DESTROYED, $ab35632b46c6bc42$var$ERR_STREAM_PREMATURE_CLOSE = $ab35632b46c6bc42$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $ab35632b46c6bc42$var$AbortError = $5Q9Jl.AbortError;

var $1UD22 = parcelRequire("1UD22");
var $ab35632b46c6bc42$var$validateFunction = $1UD22.validateFunction, $ab35632b46c6bc42$var$validateAbortSignal = $1UD22.validateAbortSignal;

var $kq58L = parcelRequire("kq58L");
var $ab35632b46c6bc42$var$isIterable = $kq58L.isIterable, $ab35632b46c6bc42$var$isReadable = $kq58L.isReadable, $ab35632b46c6bc42$var$isReadableNodeStream = $kq58L.isReadableNodeStream, $ab35632b46c6bc42$var$isNodeStream = $kq58L.isNodeStream, $ab35632b46c6bc42$var$isTransformStream = $kq58L.isTransformStream, $ab35632b46c6bc42$var$isWebStream = $kq58L.isWebStream, $ab35632b46c6bc42$var$isReadableStream = $kq58L.isReadableStream, $ab35632b46c6bc42$var$isReadableFinished = $kq58L.isReadableFinished;

var $ab35632b46c6bc42$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $ab35632b46c6bc42$var$PassThrough;
var $ab35632b46c6bc42$var$Readable;
var $ab35632b46c6bc42$var$addAbortListener;
function $ab35632b46c6bc42$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $7UDrs(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $jBUYd.destroyer(stream, err || new $ab35632b46c6bc42$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $ab35632b46c6bc42$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $ab35632b46c6bc42$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $ab35632b46c6bc42$var$makeAsyncIterable(val) {
    if ($ab35632b46c6bc42$var$isIterable(val)) return val;
    else if ($ab35632b46c6bc42$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $ab35632b46c6bc42$var$fromReadable(val);
    throw new $ab35632b46c6bc42$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $ab35632b46c6bc42$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$ab35632b46c6bc42$var$Readable) $ab35632b46c6bc42$var$Readable = (parcelRequire("9gpVw"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($ab35632b46c6bc42$var$Readable.prototype[$ab35632b46c6bc42$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $ab35632b46c6bc42$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $ab35632b46c6bc42$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $7UDrs(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $ab35632b46c6bc42$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ab35632b46c6bc42$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($ab35632b46c6bc42$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ab35632b46c6bc42$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $ab35632b46c6bc42$var$pipelineImpl(streams, $ab35632b46c6bc42$require$once($ab35632b46c6bc42$var$popCallback(streams)));
}


function $ab35632b46c6bc42$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($ab35632b46c6bc42$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $ab35632b46c6bc42$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($ab35632b46c6bc42$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($ab35632b46c6bc42$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$ab35632b46c6bc42$var$isIterable(ret)) throw new $ab35632b46c6bc42$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($ab35632b46c6bc42$var$isIterable(stream) || $ab35632b46c6bc42$var$isReadableNodeStream(stream) || $ab35632b46c6bc42$var$isTransformStream(stream)) ret = stream;
            else ret = $ab4Kx.from(stream);
        } else if (typeof stream === 'function') {
            if ($ab35632b46c6bc42$var$isTransformStream(ret)) {
                var _ret;
                ret = $ab35632b46c6bc42$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $ab35632b46c6bc42$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$ab35632b46c6bc42$var$isIterable(ret, true)) throw new $ab35632b46c6bc42$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$ab35632b46c6bc42$var$PassThrough) $ab35632b46c6bc42$var$PassThrough = (parcelRequire("7qh1D"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $ab35632b46c6bc42$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($ab35632b46c6bc42$var$isIterable(ret, true)) {
                    finishCount++;
                    $ab35632b46c6bc42$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($ab35632b46c6bc42$var$isReadableStream(ret) || $ab35632b46c6bc42$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $ab35632b46c6bc42$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $ab35632b46c6bc42$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $ab35632b46c6bc42$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($ab35632b46c6bc42$var$isNodeStream(stream)) {
            if ($ab35632b46c6bc42$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $ab35632b46c6bc42$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($ab35632b46c6bc42$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($ab35632b46c6bc42$var$isTransformStream(ret) || $ab35632b46c6bc42$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $ab35632b46c6bc42$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($ab35632b46c6bc42$var$isIterable(ret)) {
                finishCount++;
                $ab35632b46c6bc42$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $ab35632b46c6bc42$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($ab35632b46c6bc42$var$isWebStream(stream)) {
            if ($ab35632b46c6bc42$var$isReadableNodeStream(ret)) {
                finishCount++;
                $ab35632b46c6bc42$var$pumpToWeb($ab35632b46c6bc42$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($ab35632b46c6bc42$var$isReadableStream(ret) || $ab35632b46c6bc42$var$isIterable(ret)) {
                finishCount++;
                $ab35632b46c6bc42$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($ab35632b46c6bc42$var$isTransformStream(ret)) {
                finishCount++;
                $ab35632b46c6bc42$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $ab35632b46c6bc42$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $ab4Kx.from(stream);
    };
    if (streams.length === 1 && $ab35632b46c6bc42$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ab35632b46c6bc42$var$ERR_MISSING_ARGS('streams');
    var ac = new $ab35632b46c6bc42$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $ab35632b46c6bc42$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $ab35632b46c6bc42$var$AbortError());
    }
    $ab35632b46c6bc42$var$addAbortListener = $ab35632b46c6bc42$var$addAbortListener || (parcelRequire("bsQpc")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $ab35632b46c6bc42$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$ab35632b46c6bc42$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $ab35632b46c6bc42$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $ab35632b46c6bc42$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($ab35632b46c6bc42$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $7UDrs(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $7UDrs(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $ab35632b46c6bc42$var$pipelineImpl,
    pipeline: $ab35632b46c6bc42$var$pipeline
};

});
parcelRegister("jBUYd", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $5Q9Jl = parcelRequire("5Q9Jl");
/* replacement end */ var $e46daa1f6b135973$var$aggregateTwoErrors = $5Q9Jl.aggregateTwoErrors, $e46daa1f6b135973$var$ERR_MULTIPLE_CALLBACK = $5Q9Jl.codes.ERR_MULTIPLE_CALLBACK, $e46daa1f6b135973$var$AbortError = $5Q9Jl.AbortError;

var $6zAfR = parcelRequire("6zAfR");
var $e46daa1f6b135973$require$Symbol = $6zAfR.Symbol;

var $kq58L = parcelRequire("kq58L");
var $e46daa1f6b135973$var$kIsDestroyed = $kq58L.kIsDestroyed, $e46daa1f6b135973$var$isDestroyed = $kq58L.isDestroyed, $e46daa1f6b135973$var$isFinished = $kq58L.isFinished, $e46daa1f6b135973$var$isServerRequest = $kq58L.isServerRequest;
var $e46daa1f6b135973$var$kDestroy = $e46daa1f6b135973$require$Symbol('kDestroy');
var $e46daa1f6b135973$var$kConstruct = $e46daa1f6b135973$require$Symbol('kConstruct');
function $e46daa1f6b135973$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $e46daa1f6b135973$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $e46daa1f6b135973$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($e46daa1f6b135973$var$kDestroy, function(er) {
        $e46daa1f6b135973$var$_destroy(this, $e46daa1f6b135973$var$aggregateTwoErrors(er, err), cb);
    });
    else $e46daa1f6b135973$var$_destroy(this, err, cb);
    return this;
}
function $e46daa1f6b135973$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $e46daa1f6b135973$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($e46daa1f6b135973$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($e46daa1f6b135973$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $e46daa1f6b135973$var$emitErrorCloseNT(self, err) {
    $e46daa1f6b135973$var$emitErrorNT(self, err);
    $e46daa1f6b135973$var$emitCloseNT(self);
}
function $e46daa1f6b135973$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $e46daa1f6b135973$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $e46daa1f6b135973$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $e46daa1f6b135973$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($e46daa1f6b135973$var$emitErrorNT, stream, err);
        else $e46daa1f6b135973$var$emitErrorNT(stream, err);
    }
}
function $e46daa1f6b135973$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($e46daa1f6b135973$var$kConstruct, cb);
    if (stream.listenerCount($e46daa1f6b135973$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($e46daa1f6b135973$var$constructNT, stream);
}
function $e46daa1f6b135973$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $e46daa1f6b135973$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $e46daa1f6b135973$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($e46daa1f6b135973$var$kDestroy, err);
        else if (err) $e46daa1f6b135973$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($e46daa1f6b135973$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $e46daa1f6b135973$var$emitConstructNT(stream) {
    stream.emit($e46daa1f6b135973$var$kConstruct);
}
function $e46daa1f6b135973$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $e46daa1f6b135973$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $e46daa1f6b135973$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($e46daa1f6b135973$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $e46daa1f6b135973$var$destroyer(stream, err) {
    if (!stream || $e46daa1f6b135973$var$isDestroyed(stream)) return;
    if (!err && !$e46daa1f6b135973$var$isFinished(stream)) err = new $e46daa1f6b135973$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($e46daa1f6b135973$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($e46daa1f6b135973$var$isRequest(stream)) stream.abort();
    else if ($e46daa1f6b135973$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($e46daa1f6b135973$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($e46daa1f6b135973$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$e46daa1f6b135973$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $e46daa1f6b135973$var$construct,
    destroyer: $e46daa1f6b135973$var$destroyer,
    destroy: $e46daa1f6b135973$var$destroy,
    undestroy: $e46daa1f6b135973$var$undestroy,
    errorOrDestroy: $e46daa1f6b135973$var$errorOrDestroy
};

});

parcelRegister("ab4Kx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $768e9da36fa7104a$var$ObjectDefineProperties = $6zAfR.ObjectDefineProperties, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor = $6zAfR.ObjectGetOwnPropertyDescriptor, $768e9da36fa7104a$var$ObjectKeys = $6zAfR.ObjectKeys, $768e9da36fa7104a$var$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf;
module.exports = $768e9da36fa7104a$var$Duplex;

var $9gpVw = parcelRequire("9gpVw");

var $6a7ra = parcelRequire("6a7ra");
$768e9da36fa7104a$var$ObjectSetPrototypeOf($768e9da36fa7104a$var$Duplex.prototype, $9gpVw.prototype);
$768e9da36fa7104a$var$ObjectSetPrototypeOf($768e9da36fa7104a$var$Duplex, $9gpVw);
{
    var $768e9da36fa7104a$var$keys = $768e9da36fa7104a$var$ObjectKeys($6a7ra.prototype);
    // Allow the keys array to be GC'ed.
    for(var $768e9da36fa7104a$var$i = 0; $768e9da36fa7104a$var$i < $768e9da36fa7104a$var$keys.length; $768e9da36fa7104a$var$i++){
        var $768e9da36fa7104a$var$method = $768e9da36fa7104a$var$keys[$768e9da36fa7104a$var$i];
        if (!$768e9da36fa7104a$var$Duplex.prototype[$768e9da36fa7104a$var$method]) $768e9da36fa7104a$var$Duplex.prototype[$768e9da36fa7104a$var$method] = $6a7ra.prototype[$768e9da36fa7104a$var$method];
    }
}function $768e9da36fa7104a$var$Duplex(options) {
    if (!(this instanceof $768e9da36fa7104a$var$Duplex)) return new $768e9da36fa7104a$var$Duplex(options);
    $9gpVw.call(this, options);
    $6a7ra.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$768e9da36fa7104a$var$ObjectDefineProperties($768e9da36fa7104a$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $768e9da36fa7104a$var$ObjectGetOwnPropertyDescriptor($6a7ra.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $768e9da36fa7104a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $768e9da36fa7104a$var$lazyWebStreams() {
    if ($768e9da36fa7104a$var$webStreamsAdapters === undefined) $768e9da36fa7104a$var$webStreamsAdapters = {};
    return $768e9da36fa7104a$var$webStreamsAdapters;
}
$768e9da36fa7104a$var$Duplex.fromWeb = function(pair, options) {
    return $768e9da36fa7104a$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$768e9da36fa7104a$var$Duplex.toWeb = function(duplex) {
    return $768e9da36fa7104a$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $768e9da36fa7104a$var$duplexify;

$768e9da36fa7104a$var$Duplex.from = function(body) {
    if (!$768e9da36fa7104a$var$duplexify) $768e9da36fa7104a$var$duplexify = (parcelRequire("8JjDz"));
    return $768e9da36fa7104a$var$duplexify(body, 'body');
};

});
parcelRegister("9gpVw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6zAfR = parcelRequire("6zAfR");
/* replacement end */ var $6be9b834db2d39ef$var$ArrayPrototypeIndexOf = $6zAfR.ArrayPrototypeIndexOf, $6be9b834db2d39ef$var$NumberIsInteger = $6zAfR.NumberIsInteger, $6be9b834db2d39ef$var$NumberIsNaN = $6zAfR.NumberIsNaN, $6be9b834db2d39ef$var$NumberParseInt = $6zAfR.NumberParseInt, $6be9b834db2d39ef$var$ObjectDefineProperties = $6zAfR.ObjectDefineProperties, $6be9b834db2d39ef$var$ObjectKeys = $6zAfR.ObjectKeys, $6be9b834db2d39ef$var$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf, $6be9b834db2d39ef$var$Promise = $6zAfR.Promise, $6be9b834db2d39ef$var$SafeSet = $6zAfR.SafeSet, $6be9b834db2d39ef$var$SymbolAsyncDispose = $6zAfR.SymbolAsyncDispose, $6be9b834db2d39ef$var$SymbolAsyncIterator = $6zAfR.SymbolAsyncIterator, $6be9b834db2d39ef$var$Symbol = $6zAfR.Symbol;
module.exports = $6be9b834db2d39ef$var$Readable;
$6be9b834db2d39ef$var$Readable.ReadableState = $6be9b834db2d39ef$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $6be9b834db2d39ef$var$EE = $bBoAO.EventEmitter;

var $CtYZv = parcelRequire("CtYZv");
var $6be9b834db2d39ef$var$Stream = $CtYZv.Stream, $6be9b834db2d39ef$var$prependListener = $CtYZv.prependListener;

var $cx11P = parcelRequire("cx11P");
var $6be9b834db2d39ef$require$Buffer = $cx11P.Buffer;

var $41Z6q = parcelRequire("41Z6q");
var $6be9b834db2d39ef$require$addAbortSignal = $41Z6q.addAbortSignal;

var $7UDrs = parcelRequire("7UDrs");

var $6be9b834db2d39ef$var$debug = (parcelRequire("bsQpc")).debuglog('stream', function(fn) {
    $6be9b834db2d39ef$var$debug = fn;
});

var $ccDUV = parcelRequire("ccDUV");

var $jBUYd = parcelRequire("jBUYd");

var $gUxqg = parcelRequire("gUxqg");
var $6be9b834db2d39ef$var$getHighWaterMark = $gUxqg.getHighWaterMark, $6be9b834db2d39ef$var$getDefaultHighWaterMark = $gUxqg.getDefaultHighWaterMark;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $6be9b834db2d39ef$var$aggregateTwoErrors = $5Q9Jl.aggregateTwoErrors, $6be9b834db2d39ef$var$_require_codes = $5Q9Jl.codes, $6be9b834db2d39ef$var$ERR_INVALID_ARG_TYPE = $6be9b834db2d39ef$var$_require_codes.ERR_INVALID_ARG_TYPE, $6be9b834db2d39ef$var$ERR_METHOD_NOT_IMPLEMENTED = $6be9b834db2d39ef$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $6be9b834db2d39ef$var$ERR_OUT_OF_RANGE = $6be9b834db2d39ef$var$_require_codes.ERR_OUT_OF_RANGE, $6be9b834db2d39ef$var$ERR_STREAM_PUSH_AFTER_EOF = $6be9b834db2d39ef$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $6be9b834db2d39ef$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $6be9b834db2d39ef$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $6be9b834db2d39ef$var$AbortError = $5Q9Jl.AbortError;

var $1UD22 = parcelRequire("1UD22");
var $6be9b834db2d39ef$require$validateObject = $1UD22.validateObject;
var $6be9b834db2d39ef$var$kPaused = $6be9b834db2d39ef$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $6be9b834db2d39ef$require$StringDecoder = $3Jf7C.StringDecoder;

var $gs3K4 = parcelRequire("gs3K4");
$6be9b834db2d39ef$var$ObjectSetPrototypeOf($6be9b834db2d39ef$var$Readable.prototype, $6be9b834db2d39ef$var$Stream.prototype);
$6be9b834db2d39ef$var$ObjectSetPrototypeOf($6be9b834db2d39ef$var$Readable, $6be9b834db2d39ef$var$Stream);
var $6be9b834db2d39ef$var$nop = function() {};
var $6be9b834db2d39ef$var$errorOrDestroy = $jBUYd.errorOrDestroy;
var $6be9b834db2d39ef$var$kObjectMode = 1;
var $6be9b834db2d39ef$var$kEnded = 2;
var $6be9b834db2d39ef$var$kEndEmitted = 4;
var $6be9b834db2d39ef$var$kReading = 8;
var $6be9b834db2d39ef$var$kConstructed = 16;
var $6be9b834db2d39ef$var$kSync = 32;
var $6be9b834db2d39ef$var$kNeedReadable = 64;
var $6be9b834db2d39ef$var$kEmittedReadable = 128;
var $6be9b834db2d39ef$var$kReadableListening = 256;
var $6be9b834db2d39ef$var$kResumeScheduled = 512;
var $6be9b834db2d39ef$var$kErrorEmitted = 1024;
var $6be9b834db2d39ef$var$kEmitClose = 2048;
var $6be9b834db2d39ef$var$kAutoDestroy = 4096;
var $6be9b834db2d39ef$var$kDestroyed = 8192;
var $6be9b834db2d39ef$var$kClosed = 16384;
var $6be9b834db2d39ef$var$kCloseEmitted = 32768;
var $6be9b834db2d39ef$var$kMultiAwaitDrain = 65536;
var $6be9b834db2d39ef$var$kReadingMore = 131072;
var $6be9b834db2d39ef$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $6be9b834db2d39ef$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$6be9b834db2d39ef$var$ObjectDefineProperties($6be9b834db2d39ef$var$ReadableState.prototype, {
    objectMode: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kObjectMode),
    ended: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kEnded),
    endEmitted: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kEndEmitted),
    reading: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kNeedReadable),
    emittedReadable: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kEmittedReadable),
    readableListening: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kReadableListening),
    resumeScheduled: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kErrorEmitted),
    emitClose: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kEmitClose),
    autoDestroy: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kCloseEmitted),
    multiAwaitDrain: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kReadingMore),
    dataEmitted: $6be9b834db2d39ef$var$makeBitMapDescriptor($6be9b834db2d39ef$var$kDataEmitted)
});

function $6be9b834db2d39ef$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("ab4Kx"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $6be9b834db2d39ef$var$kEmitClose | $6be9b834db2d39ef$var$kAutoDestroy | $6be9b834db2d39ef$var$kConstructed | $6be9b834db2d39ef$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $6be9b834db2d39ef$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $6be9b834db2d39ef$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $6be9b834db2d39ef$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $6be9b834db2d39ef$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $ccDUV();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$6be9b834db2d39ef$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$6be9b834db2d39ef$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$6be9b834db2d39ef$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $6be9b834db2d39ef$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $6be9b834db2d39ef$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $6be9b834db2d39ef$var$Readable)) return new $6be9b834db2d39ef$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("ab4Kx"));
    this._readableState = new $6be9b834db2d39ef$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $6be9b834db2d39ef$require$addAbortSignal(options.signal, this);
    }
    $6be9b834db2d39ef$var$Stream.call(this, options);
    $jBUYd.construct(this, function() {
        if (_this._readableState.needReadable) $6be9b834db2d39ef$var$maybeReadMore(_this, _this._readableState);
    });
}
$6be9b834db2d39ef$var$Readable.prototype.destroy = $jBUYd.destroy;
$6be9b834db2d39ef$var$Readable.prototype._undestroy = $jBUYd.undestroy;
$6be9b834db2d39ef$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$6be9b834db2d39ef$var$Readable.prototype[$6be9b834db2d39ef$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$6be9b834db2d39ef$var$Readable.prototype[$6be9b834db2d39ef$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $6be9b834db2d39ef$var$AbortError();
        this.destroy(error);
    }
    return new $6be9b834db2d39ef$var$Promise(function(resolve, reject) {
        return $7UDrs(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$6be9b834db2d39ef$var$Readable.prototype.push = function(chunk, encoding) {
    return $6be9b834db2d39ef$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$6be9b834db2d39ef$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $6be9b834db2d39ef$var$readableAddChunk(this, chunk, encoding, true);
};
function $6be9b834db2d39ef$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $6be9b834db2d39ef$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $6be9b834db2d39ef$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $6be9b834db2d39ef$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $6be9b834db2d39ef$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $6be9b834db2d39ef$require$Buffer) encoding = '';
        else if ($6be9b834db2d39ef$var$Stream._isUint8Array(chunk)) {
            chunk = $6be9b834db2d39ef$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $6be9b834db2d39ef$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $6be9b834db2d39ef$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$6be9b834db2d39ef$var$kReading;
        $6be9b834db2d39ef$var$onEofChunk(stream, state);
    } else if ((state.state & $6be9b834db2d39ef$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $6be9b834db2d39ef$var$kEndEmitted) !== 0) $6be9b834db2d39ef$var$errorOrDestroy(stream, new $6be9b834db2d39ef$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $6be9b834db2d39ef$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $6be9b834db2d39ef$var$errorOrDestroy(stream, new $6be9b834db2d39ef$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$6be9b834db2d39ef$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $6be9b834db2d39ef$var$addChunk(stream, state, chunk, false);
                else $6be9b834db2d39ef$var$maybeReadMore(stream, state);
            } else $6be9b834db2d39ef$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$6be9b834db2d39ef$var$kReading;
        $6be9b834db2d39ef$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $6be9b834db2d39ef$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $6be9b834db2d39ef$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $6be9b834db2d39ef$var$kNeedReadable) !== 0) $6be9b834db2d39ef$var$emitReadable(stream);
    }
    $6be9b834db2d39ef$var$maybeReadMore(stream, state);
}
$6be9b834db2d39ef$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$6be9b834db2d39ef$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$6be9b834db2d39ef$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $6be9b834db2d39ef$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$6be9b834db2d39ef$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $6be9b834db2d39ef$var$MAX_HWM = 0x40000000;
function $6be9b834db2d39ef$var$computeNewHighWaterMark(n) {
    if (n > $6be9b834db2d39ef$var$MAX_HWM) throw new $6be9b834db2d39ef$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6be9b834db2d39ef$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $6be9b834db2d39ef$var$kObjectMode) !== 0) return 1;
    if ($6be9b834db2d39ef$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$6be9b834db2d39ef$var$Readable.prototype.read = function(n) {
    $6be9b834db2d39ef$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$6be9b834db2d39ef$var$NumberIsInteger(n)) n = $6be9b834db2d39ef$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $6be9b834db2d39ef$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$6be9b834db2d39ef$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $6be9b834db2d39ef$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $6be9b834db2d39ef$var$endReadable(this);
        else $6be9b834db2d39ef$var$emitReadable(this);
        return null;
    }
    n = $6be9b834db2d39ef$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $6be9b834db2d39ef$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $6be9b834db2d39ef$var$kNeedReadable) !== 0;
    $6be9b834db2d39ef$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $6be9b834db2d39ef$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $6be9b834db2d39ef$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $6be9b834db2d39ef$var$debug('do read');
        state.state |= $6be9b834db2d39ef$var$kReading | $6be9b834db2d39ef$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $6be9b834db2d39ef$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $6be9b834db2d39ef$var$errorOrDestroy(this, err);
        }
        state.state &= ~$6be9b834db2d39ef$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $6be9b834db2d39ef$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $6be9b834db2d39ef$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $6be9b834db2d39ef$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $6be9b834db2d39ef$var$onEofChunk(stream, state) {
    $6be9b834db2d39ef$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $6be9b834db2d39ef$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $6be9b834db2d39ef$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $6be9b834db2d39ef$var$emitReadable(stream) {
    var state = stream._readableState;
    $6be9b834db2d39ef$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $6be9b834db2d39ef$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($6be9b834db2d39ef$var$emitReadable_, stream);
    }
}
function $6be9b834db2d39ef$var$emitReadable_(stream) {
    var state = stream._readableState;
    $6be9b834db2d39ef$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $6be9b834db2d39ef$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $6be9b834db2d39ef$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($6be9b834db2d39ef$var$maybeReadMore_, stream, state);
    }
}
function $6be9b834db2d39ef$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $6be9b834db2d39ef$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$6be9b834db2d39ef$var$Readable.prototype._read = function(n) {
    throw new $6be9b834db2d39ef$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$6be9b834db2d39ef$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $6be9b834db2d39ef$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $6be9b834db2d39ef$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $6be9b834db2d39ef$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $6be9b834db2d39ef$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $6be9b834db2d39ef$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $6be9b834db2d39ef$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $6be9b834db2d39ef$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $6be9b834db2d39ef$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $6be9b834db2d39ef$var$debug('ondata');
        var ret = dest.write(chunk);
        $6be9b834db2d39ef$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $6be9b834db2d39ef$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $6be9b834db2d39ef$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $6be9b834db2d39ef$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $6be9b834db2d39ef$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $6be9b834db2d39ef$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $6be9b834db2d39ef$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $6be9b834db2d39ef$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $6be9b834db2d39ef$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $6be9b834db2d39ef$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$6be9b834db2d39ef$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $6be9b834db2d39ef$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$6be9b834db2d39ef$var$Readable.prototype.on = function(ev, fn) {
    var res = $6be9b834db2d39ef$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $6be9b834db2d39ef$var$debug('on readable', state.length, state.reading);
            if (state.length) $6be9b834db2d39ef$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($6be9b834db2d39ef$var$nReadingNextTick, this);
        }
    }
    return res;
};
$6be9b834db2d39ef$var$Readable.prototype.addListener = $6be9b834db2d39ef$var$Readable.prototype.on;
$6be9b834db2d39ef$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $6be9b834db2d39ef$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($6be9b834db2d39ef$var$updateReadableListening, this);
    return res;
};
$6be9b834db2d39ef$var$Readable.prototype.off = $6be9b834db2d39ef$var$Readable.prototype.removeListener;
$6be9b834db2d39ef$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $6be9b834db2d39ef$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($6be9b834db2d39ef$var$updateReadableListening, this);
    return res;
};
function $6be9b834db2d39ef$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$6be9b834db2d39ef$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $6be9b834db2d39ef$var$nReadingNextTick(self) {
    $6be9b834db2d39ef$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$6be9b834db2d39ef$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $6be9b834db2d39ef$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $6be9b834db2d39ef$var$resume(this, state);
    }
    state[$6be9b834db2d39ef$var$kPaused] = false;
    return this;
};
function $6be9b834db2d39ef$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($6be9b834db2d39ef$var$resume_, stream, state);
    }
}
function $6be9b834db2d39ef$var$resume_(stream, state) {
    $6be9b834db2d39ef$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $6be9b834db2d39ef$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$6be9b834db2d39ef$var$Readable.prototype.pause = function() {
    $6be9b834db2d39ef$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $6be9b834db2d39ef$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$6be9b834db2d39ef$var$kPaused] = true;
    return this;
};
function $6be9b834db2d39ef$var$flow(stream) {
    var state = stream._readableState;
    $6be9b834db2d39ef$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$6be9b834db2d39ef$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $6be9b834db2d39ef$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $6be9b834db2d39ef$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$6be9b834db2d39ef$var$Readable.prototype[$6be9b834db2d39ef$var$SymbolAsyncIterator] = function() {
    return $6be9b834db2d39ef$var$streamToAsyncIterator(this);
};
$6be9b834db2d39ef$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $6be9b834db2d39ef$require$validateObject(options, 'options');
    return $6be9b834db2d39ef$var$streamToAsyncIterator(this, options);
};
function $6be9b834db2d39ef$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $6be9b834db2d39ef$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $6be9b834db2d39ef$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $6be9b834db2d39ef$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $6be9b834db2d39ef$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $6be9b834db2d39ef$var$nop;
                    stream.on('readable', next);
                    cleanup = $7UDrs(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $6be9b834db2d39ef$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $6be9b834db2d39ef$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $6be9b834db2d39ef$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $6be9b834db2d39ef$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $jBUYd.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$6be9b834db2d39ef$var$ObjectDefineProperties($6be9b834db2d39ef$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$6be9b834db2d39ef$var$ObjectDefineProperties($6be9b834db2d39ef$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$6be9b834db2d39ef$var$kPaused] !== false;
        },
        set: function(value) {
            this[$6be9b834db2d39ef$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$6be9b834db2d39ef$var$Readable._fromList = $6be9b834db2d39ef$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6be9b834db2d39ef$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $6be9b834db2d39ef$var$endReadable(stream) {
    var state = stream._readableState;
    $6be9b834db2d39ef$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($6be9b834db2d39ef$var$endReadableNT, state, stream);
    }
}
function $6be9b834db2d39ef$var$endReadableNT(state, stream) {
    $6be9b834db2d39ef$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($6be9b834db2d39ef$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $6be9b834db2d39ef$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$6be9b834db2d39ef$var$Readable.from = function(iterable, opts) {
    return $gs3K4($6be9b834db2d39ef$var$Readable, iterable, opts);
};
var $6be9b834db2d39ef$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6be9b834db2d39ef$var$lazyWebStreams() {
    if ($6be9b834db2d39ef$var$webStreamsAdapters === undefined) $6be9b834db2d39ef$var$webStreamsAdapters = {};
    return $6be9b834db2d39ef$var$webStreamsAdapters;
}
$6be9b834db2d39ef$var$Readable.fromWeb = function(readableStream, options) {
    return $6be9b834db2d39ef$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$6be9b834db2d39ef$var$Readable.toWeb = function(streamReadable, options) {
    return $6be9b834db2d39ef$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$6be9b834db2d39ef$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $6be9b834db2d39ef$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $jBUYd.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("CtYZv", function(module, exports) {
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $073aceab50145704$var$ArrayIsArray = $6zAfR.ArrayIsArray, $073aceab50145704$var$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $073aceab50145704$var$EE = $bBoAO.EventEmitter;
function $073aceab50145704$var$Stream(opts) {
    $073aceab50145704$var$EE.call(this, opts);
}
$073aceab50145704$var$ObjectSetPrototypeOf($073aceab50145704$var$Stream.prototype, $073aceab50145704$var$EE.prototype);
$073aceab50145704$var$ObjectSetPrototypeOf($073aceab50145704$var$Stream, $073aceab50145704$var$EE);
$073aceab50145704$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($073aceab50145704$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $073aceab50145704$var$prependListener(source, 'error', onerror);
    $073aceab50145704$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $073aceab50145704$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($073aceab50145704$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $073aceab50145704$var$Stream,
    prependListener: $073aceab50145704$var$prependListener
};

});

parcelRegister("41Z6q", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $2ef6a72223756c2f$export$e2db56ee53255a0; }, function (v) { return $2ef6a72223756c2f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $2ef6a72223756c2f$export$11956e9313f43de0; }, function (v) { return $2ef6a72223756c2f$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $2ef6a72223756c2f$export$e2db56ee53255a0;
var $2ef6a72223756c2f$export$11956e9313f43de0;
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $2ef6a72223756c2f$require$SymbolDispose = $6zAfR.SymbolDispose;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $2ef6a72223756c2f$var$AbortError = $5Q9Jl.AbortError, $2ef6a72223756c2f$var$codes = $5Q9Jl.codes;

var $kq58L = parcelRequire("kq58L");
var $2ef6a72223756c2f$var$isNodeStream = $kq58L.isNodeStream, $2ef6a72223756c2f$var$isWebStream = $kq58L.isWebStream, $2ef6a72223756c2f$var$kControllerErrorFunction = $kq58L.kControllerErrorFunction;

var $7UDrs = parcelRequire("7UDrs");
var $2ef6a72223756c2f$var$ERR_INVALID_ARG_TYPE = $2ef6a72223756c2f$var$codes.ERR_INVALID_ARG_TYPE;
var $2ef6a72223756c2f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $2ef6a72223756c2f$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $2ef6a72223756c2f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$2ef6a72223756c2f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $2ef6a72223756c2f$var$validateAbortSignal(signal, 'signal');
    if (!$2ef6a72223756c2f$var$isNodeStream(stream) && !$2ef6a72223756c2f$var$isWebStream(stream)) throw new $2ef6a72223756c2f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $2ef6a72223756c2f$export$11956e9313f43de0(signal, stream);
};

$2ef6a72223756c2f$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $2ef6a72223756c2f$var$isNodeStream(stream) ? function() {
        stream.destroy(new $2ef6a72223756c2f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$2ef6a72223756c2f$var$kControllerErrorFunction](new $2ef6a72223756c2f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $2ef6a72223756c2f$var$addAbortListener = $2ef6a72223756c2f$var$addAbortListener || (parcelRequire("bsQpc")).addAbortListener;
        var disposable = $2ef6a72223756c2f$var$addAbortListener(signal, onAbort);
        $7UDrs(stream, disposable[$2ef6a72223756c2f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("ccDUV", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $8e2591c2a10b71f4$var$StringPrototypeSlice = $6zAfR.StringPrototypeSlice, $8e2591c2a10b71f4$var$SymbolIterator = $6zAfR.SymbolIterator, $8e2591c2a10b71f4$var$TypedArrayPrototypeSet = $6zAfR.TypedArrayPrototypeSet, $8e2591c2a10b71f4$var$Uint8Array = $6zAfR.Uint8Array;

var $cx11P = parcelRequire("cx11P");
var $8e2591c2a10b71f4$require$Buffer = $cx11P.Buffer;

var $bsQpc = parcelRequire("bsQpc");
var $8e2591c2a10b71f4$require$inspect = $bsQpc.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $8e2591c2a10b71f4$require$Buffer.alloc(0);
                var ret = $8e2591c2a10b71f4$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $8e2591c2a10b71f4$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $8e2591c2a10b71f4$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $8e2591c2a10b71f4$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $8e2591c2a10b71f4$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $8e2591c2a10b71f4$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $8e2591c2a10b71f4$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $8e2591c2a10b71f4$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $8e2591c2a10b71f4$var$TypedArrayPrototypeSet(ret, new $8e2591c2a10b71f4$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $8e2591c2a10b71f4$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("gUxqg", function(module, exports) {
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $c4fbcd5bced66483$var$MathFloor = $6zAfR.MathFloor, $c4fbcd5bced66483$var$NumberIsInteger = $6zAfR.NumberIsInteger;

var $1UD22 = parcelRequire("1UD22");
var $c4fbcd5bced66483$require$validateInteger = $1UD22.validateInteger;

var $c4fbcd5bced66483$var$ERR_INVALID_ARG_VALUE = (parcelRequire("5Q9Jl")).codes.ERR_INVALID_ARG_VALUE;
var $c4fbcd5bced66483$var$defaultHighWaterMarkBytes = 16384;
var $c4fbcd5bced66483$var$defaultHighWaterMarkObjectMode = 16;
function $c4fbcd5bced66483$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c4fbcd5bced66483$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $c4fbcd5bced66483$var$defaultHighWaterMarkObjectMode : $c4fbcd5bced66483$var$defaultHighWaterMarkBytes;
}
function $c4fbcd5bced66483$var$setDefaultHighWaterMark(objectMode, value) {
    $c4fbcd5bced66483$require$validateInteger(value, 'value', 0);
    if (objectMode) $c4fbcd5bced66483$var$defaultHighWaterMarkObjectMode = value;
    else $c4fbcd5bced66483$var$defaultHighWaterMarkBytes = value;
}
function $c4fbcd5bced66483$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c4fbcd5bced66483$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$c4fbcd5bced66483$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $c4fbcd5bced66483$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $c4fbcd5bced66483$var$MathFloor(hwm);
    }
    // Default value
    return $c4fbcd5bced66483$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $c4fbcd5bced66483$var$getHighWaterMark,
    getDefaultHighWaterMark: $c4fbcd5bced66483$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $c4fbcd5bced66483$var$setDefaultHighWaterMark
};

});

parcelRegister("gs3K4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6zAfR = parcelRequire("6zAfR");
/* replacement end */ var $bfa229f749afd35d$var$PromisePrototypeThen = $6zAfR.PromisePrototypeThen, $bfa229f749afd35d$var$SymbolAsyncIterator = $6zAfR.SymbolAsyncIterator, $bfa229f749afd35d$var$SymbolIterator = $6zAfR.SymbolIterator;

var $cx11P = parcelRequire("cx11P");
var $bfa229f749afd35d$require$Buffer = $cx11P.Buffer;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $bfa229f749afd35d$require$_require_codes = $5Q9Jl.codes;
var $bfa229f749afd35d$var$ERR_INVALID_ARG_TYPE = $bfa229f749afd35d$require$_require_codes.ERR_INVALID_ARG_TYPE, $bfa229f749afd35d$var$ERR_STREAM_NULL_VALUES = $bfa229f749afd35d$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $bfa229f749afd35d$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $bfa229f749afd35d$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$bfa229f749afd35d$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$bfa229f749afd35d$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$bfa229f749afd35d$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$bfa229f749afd35d$var$SymbolIterator]();
    } else throw new $bfa229f749afd35d$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $bfa229f749afd35d$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $bfa229f749afd35d$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $bfa229f749afd35d$var$from;

});


parcelRegister("6a7ra", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6zAfR = parcelRequire("6zAfR");
/* replacement end */ var $47c9721b9d5b5a42$var$ArrayPrototypeSlice = $6zAfR.ArrayPrototypeSlice, $47c9721b9d5b5a42$var$Error = $6zAfR.Error, $47c9721b9d5b5a42$var$FunctionPrototypeSymbolHasInstance = $6zAfR.FunctionPrototypeSymbolHasInstance, $47c9721b9d5b5a42$var$ObjectDefineProperty = $6zAfR.ObjectDefineProperty, $47c9721b9d5b5a42$var$ObjectDefineProperties = $6zAfR.ObjectDefineProperties, $47c9721b9d5b5a42$var$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf, $47c9721b9d5b5a42$var$StringPrototypeToLowerCase = $6zAfR.StringPrototypeToLowerCase, $47c9721b9d5b5a42$var$Symbol = $6zAfR.Symbol, $47c9721b9d5b5a42$var$SymbolHasInstance = $6zAfR.SymbolHasInstance;
module.exports = $47c9721b9d5b5a42$var$Writable;
$47c9721b9d5b5a42$var$Writable.WritableState = $47c9721b9d5b5a42$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $47c9721b9d5b5a42$var$EE = $bBoAO.EventEmitter;

var $CtYZv = parcelRequire("CtYZv");
var $47c9721b9d5b5a42$require$Stream = $CtYZv.Stream;

var $cx11P = parcelRequire("cx11P");
var $47c9721b9d5b5a42$require$Buffer = $cx11P.Buffer;

var $jBUYd = parcelRequire("jBUYd");

var $41Z6q = parcelRequire("41Z6q");
var $47c9721b9d5b5a42$require$addAbortSignal = $41Z6q.addAbortSignal;

var $gUxqg = parcelRequire("gUxqg");
var $47c9721b9d5b5a42$var$getHighWaterMark = $gUxqg.getHighWaterMark, $47c9721b9d5b5a42$var$getDefaultHighWaterMark = $gUxqg.getDefaultHighWaterMark;

var $5Q9Jl = parcelRequire("5Q9Jl");
var $47c9721b9d5b5a42$require$_require_codes = $5Q9Jl.codes;
var $47c9721b9d5b5a42$var$ERR_INVALID_ARG_TYPE = $47c9721b9d5b5a42$require$_require_codes.ERR_INVALID_ARG_TYPE, $47c9721b9d5b5a42$var$ERR_METHOD_NOT_IMPLEMENTED = $47c9721b9d5b5a42$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $47c9721b9d5b5a42$var$ERR_MULTIPLE_CALLBACK = $47c9721b9d5b5a42$require$_require_codes.ERR_MULTIPLE_CALLBACK, $47c9721b9d5b5a42$var$ERR_STREAM_CANNOT_PIPE = $47c9721b9d5b5a42$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED = $47c9721b9d5b5a42$require$_require_codes.ERR_STREAM_DESTROYED, $47c9721b9d5b5a42$var$ERR_STREAM_ALREADY_FINISHED = $47c9721b9d5b5a42$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $47c9721b9d5b5a42$var$ERR_STREAM_NULL_VALUES = $47c9721b9d5b5a42$require$_require_codes.ERR_STREAM_NULL_VALUES, $47c9721b9d5b5a42$var$ERR_STREAM_WRITE_AFTER_END = $47c9721b9d5b5a42$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $47c9721b9d5b5a42$var$ERR_UNKNOWN_ENCODING = $47c9721b9d5b5a42$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $47c9721b9d5b5a42$var$errorOrDestroy = $jBUYd.errorOrDestroy;
$47c9721b9d5b5a42$var$ObjectSetPrototypeOf($47c9721b9d5b5a42$var$Writable.prototype, $47c9721b9d5b5a42$require$Stream.prototype);
$47c9721b9d5b5a42$var$ObjectSetPrototypeOf($47c9721b9d5b5a42$var$Writable, $47c9721b9d5b5a42$require$Stream);
function $47c9721b9d5b5a42$var$nop() {}
var $47c9721b9d5b5a42$var$kOnFinished = $47c9721b9d5b5a42$var$Symbol('kOnFinished');

function $47c9721b9d5b5a42$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("ab4Kx"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $47c9721b9d5b5a42$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $47c9721b9d5b5a42$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $47c9721b9d5b5a42$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $47c9721b9d5b5a42$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$47c9721b9d5b5a42$var$kOnFinished] = [];
}
function $47c9721b9d5b5a42$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$47c9721b9d5b5a42$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $47c9721b9d5b5a42$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$47c9721b9d5b5a42$var$ObjectDefineProperty($47c9721b9d5b5a42$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $47c9721b9d5b5a42$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("ab4Kx"));
    if (!isDuplex && !$47c9721b9d5b5a42$var$FunctionPrototypeSymbolHasInstance($47c9721b9d5b5a42$var$Writable, this)) return new $47c9721b9d5b5a42$var$Writable(options);
    this._writableState = new $47c9721b9d5b5a42$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $47c9721b9d5b5a42$require$addAbortSignal(options.signal, this);
    }
    $47c9721b9d5b5a42$require$Stream.call(this, options);
    $jBUYd.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $47c9721b9d5b5a42$var$clearBuffer(_this, state);
        $47c9721b9d5b5a42$var$finishMaybe(_this, state);
    });
}
$47c9721b9d5b5a42$var$ObjectDefineProperty($47c9721b9d5b5a42$var$Writable, $47c9721b9d5b5a42$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($47c9721b9d5b5a42$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $47c9721b9d5b5a42$var$Writable) return false;
        return object && object._writableState instanceof $47c9721b9d5b5a42$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$47c9721b9d5b5a42$var$Writable.prototype.pipe = function() {
    $47c9721b9d5b5a42$var$errorOrDestroy(this, new $47c9721b9d5b5a42$var$ERR_STREAM_CANNOT_PIPE());
};
function $47c9721b9d5b5a42$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$47c9721b9d5b5a42$require$Buffer.isEncoding(encoding)) throw new $47c9721b9d5b5a42$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $47c9721b9d5b5a42$var$nop;
    }
    if (chunk === null) throw new $47c9721b9d5b5a42$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $47c9721b9d5b5a42$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $47c9721b9d5b5a42$require$Buffer) encoding = 'buffer';
        else if ($47c9721b9d5b5a42$require$Stream._isUint8Array(chunk)) {
            chunk = $47c9721b9d5b5a42$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $47c9721b9d5b5a42$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $47c9721b9d5b5a42$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $47c9721b9d5b5a42$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $47c9721b9d5b5a42$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$47c9721b9d5b5a42$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $47c9721b9d5b5a42$var$_write(this, chunk, encoding, cb) === true;
};
$47c9721b9d5b5a42$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$47c9721b9d5b5a42$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $47c9721b9d5b5a42$var$clearBuffer(this, state);
    }
};
$47c9721b9d5b5a42$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $47c9721b9d5b5a42$var$StringPrototypeToLowerCase(encoding);
    if (!$47c9721b9d5b5a42$require$Buffer.isEncoding(encoding)) throw new $47c9721b9d5b5a42$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $47c9721b9d5b5a42$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $47c9721b9d5b5a42$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $47c9721b9d5b5a42$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $47c9721b9d5b5a42$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $47c9721b9d5b5a42$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $47c9721b9d5b5a42$var$errorOrDestroy(stream, er);
}
function $47c9721b9d5b5a42$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $47c9721b9d5b5a42$var$errorOrDestroy(stream, new $47c9721b9d5b5a42$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($47c9721b9d5b5a42$var$onwriteError, stream, state, er, cb);
        else $47c9721b9d5b5a42$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $47c9721b9d5b5a42$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($47c9721b9d5b5a42$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $47c9721b9d5b5a42$var$afterWrite(stream, state, 1, cb);
    }
}
function $47c9721b9d5b5a42$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $47c9721b9d5b5a42$var$afterWrite(stream, state, count, cb);
}
function $47c9721b9d5b5a42$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $47c9721b9d5b5a42$var$errorBuffer(state);
    $47c9721b9d5b5a42$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $47c9721b9d5b5a42$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$47c9721b9d5b5a42$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED('end'));
    }
    $47c9721b9d5b5a42$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $47c9721b9d5b5a42$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $47c9721b9d5b5a42$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $47c9721b9d5b5a42$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $47c9721b9d5b5a42$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $47c9721b9d5b5a42$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $47c9721b9d5b5a42$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $47c9721b9d5b5a42$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$47c9721b9d5b5a42$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $47c9721b9d5b5a42$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$47c9721b9d5b5a42$var$Writable.prototype._writev = null;
$47c9721b9d5b5a42$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $47c9721b9d5b5a42$var$_write(this, chunk, encoding);
        if (ret instanceof $47c9721b9d5b5a42$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $47c9721b9d5b5a42$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $47c9721b9d5b5a42$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $47c9721b9d5b5a42$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$47c9721b9d5b5a42$var$kOnFinished].push(cb);
    }
    return this;
};
function $47c9721b9d5b5a42$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $47c9721b9d5b5a42$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $47c9721b9d5b5a42$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $47c9721b9d5b5a42$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$47c9721b9d5b5a42$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $47c9721b9d5b5a42$var$errorOrDestroy(stream, err, state.sync);
        } else if ($47c9721b9d5b5a42$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($47c9721b9d5b5a42$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $47c9721b9d5b5a42$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $47c9721b9d5b5a42$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $47c9721b9d5b5a42$var$finishMaybe(stream, state, sync) {
    if ($47c9721b9d5b5a42$var$needFinish(state)) {
        $47c9721b9d5b5a42$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($47c9721b9d5b5a42$var$needFinish(state)) $47c9721b9d5b5a42$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($47c9721b9d5b5a42$var$needFinish(state)) {
                state.pendingcb++;
                $47c9721b9d5b5a42$var$finish(stream, state);
            }
        }
    }
}
function $47c9721b9d5b5a42$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$47c9721b9d5b5a42$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$47c9721b9d5b5a42$var$ObjectDefineProperties($47c9721b9d5b5a42$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $47c9721b9d5b5a42$var$destroy = $jBUYd.destroy;
$47c9721b9d5b5a42$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$47c9721b9d5b5a42$var$kOnFinished].length)) $2Qkr5.nextTick($47c9721b9d5b5a42$var$errorBuffer, state);
    $47c9721b9d5b5a42$var$destroy.call(this, err, cb);
    return this;
};
$47c9721b9d5b5a42$var$Writable.prototype._undestroy = $jBUYd.undestroy;
$47c9721b9d5b5a42$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$47c9721b9d5b5a42$var$Writable.prototype[$47c9721b9d5b5a42$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $47c9721b9d5b5a42$var$webStreamsAdapters;
// Lazy to avoid circular references
function $47c9721b9d5b5a42$var$lazyWebStreams() {
    if ($47c9721b9d5b5a42$var$webStreamsAdapters === undefined) $47c9721b9d5b5a42$var$webStreamsAdapters = {};
    return $47c9721b9d5b5a42$var$webStreamsAdapters;
}
$47c9721b9d5b5a42$var$Writable.fromWeb = function(writableStream, options) {
    return $47c9721b9d5b5a42$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$47c9721b9d5b5a42$var$Writable.toWeb = function(streamWritable) {
    return $47c9721b9d5b5a42$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("8JjDz", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $cx11P = parcelRequire("cx11P");

var $kq58L = parcelRequire("kq58L");
var $65b1c23913f1b818$var$isReadable = $kq58L.isReadable, $65b1c23913f1b818$var$isWritable = $kq58L.isWritable, $65b1c23913f1b818$var$isIterable = $kq58L.isIterable, $65b1c23913f1b818$var$isNodeStream = $kq58L.isNodeStream, $65b1c23913f1b818$var$isReadableNodeStream = $kq58L.isReadableNodeStream, $65b1c23913f1b818$var$isWritableNodeStream = $kq58L.isWritableNodeStream, $65b1c23913f1b818$var$isDuplexNodeStream = $kq58L.isDuplexNodeStream, $65b1c23913f1b818$var$isReadableStream = $kq58L.isReadableStream, $65b1c23913f1b818$var$isWritableStream = $kq58L.isWritableStream;

var $7UDrs = parcelRequire("7UDrs");

var $5Q9Jl = parcelRequire("5Q9Jl");
var $65b1c23913f1b818$var$AbortError = $5Q9Jl.AbortError, $65b1c23913f1b818$var$_require_codes = $5Q9Jl.codes, $65b1c23913f1b818$var$ERR_INVALID_ARG_TYPE = $65b1c23913f1b818$var$_require_codes.ERR_INVALID_ARG_TYPE, $65b1c23913f1b818$var$ERR_INVALID_RETURN_VALUE = $65b1c23913f1b818$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $jBUYd = parcelRequire("jBUYd");
var $65b1c23913f1b818$require$destroyer = $jBUYd.destroyer;

var $ab4Kx = parcelRequire("ab4Kx");

var $9gpVw = parcelRequire("9gpVw");

var $6a7ra = parcelRequire("6a7ra");

var $bsQpc = parcelRequire("bsQpc");
var $65b1c23913f1b818$require$createDeferredPromise = $bsQpc.createDeferredPromise;

var $gs3K4 = parcelRequire("gs3K4");
var $65b1c23913f1b818$var$Blob = globalThis.Blob || $cx11P.Blob;
var $65b1c23913f1b818$var$isBlob = typeof $65b1c23913f1b818$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $65b1c23913f1b818$var$Blob;
} : function isBlob(b) {
    return false;
};

var $65b1c23913f1b818$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $6zAfR = parcelRequire("6zAfR");
var $65b1c23913f1b818$require$FunctionPrototypeCall = $6zAfR.FunctionPrototypeCall;
// This is needed for pre node 17.
var $65b1c23913f1b818$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($ab4Kx);
module.exports = function duplexify(body, name) {
    if ($65b1c23913f1b818$var$isDuplexNodeStream(body)) return body;
    if ($65b1c23913f1b818$var$isReadableNodeStream(body)) return $65b1c23913f1b818$var$_duplexify({
        readable: body
    });
    if ($65b1c23913f1b818$var$isWritableNodeStream(body)) return $65b1c23913f1b818$var$_duplexify({
        writable: body
    });
    if ($65b1c23913f1b818$var$isNodeStream(body)) return $65b1c23913f1b818$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($65b1c23913f1b818$var$isReadableStream(body)) return $65b1c23913f1b818$var$_duplexify({
        readable: $9gpVw.fromWeb(body)
    });
    if ($65b1c23913f1b818$var$isWritableStream(body)) return $65b1c23913f1b818$var$_duplexify({
        writable: $6a7ra.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $65b1c23913f1b818$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($65b1c23913f1b818$var$isIterable(value)) return $gs3K4($65b1c23913f1b818$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $65b1c23913f1b818$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $65b1c23913f1b818$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $65b1c23913f1b818$require$destroyer(d, err);
            });
            return d = new $65b1c23913f1b818$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $65b1c23913f1b818$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($65b1c23913f1b818$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($65b1c23913f1b818$var$isIterable(body)) return $gs3K4($65b1c23913f1b818$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($65b1c23913f1b818$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $65b1c23913f1b818$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $65b1c23913f1b818$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $65b1c23913f1b818$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $65b1c23913f1b818$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $65b1c23913f1b818$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $65b1c23913f1b818$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $65b1c23913f1b818$require$destroyer(d1, err);
        });
        return d1 = new $65b1c23913f1b818$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $65b1c23913f1b818$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $65b1c23913f1b818$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $65b1c23913f1b818$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $65b1c23913f1b818$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $65b1c23913f1b818$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $65b1c23913f1b818$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $65b1c23913f1b818$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $9gpVw.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$65b1c23913f1b818$var$isReadable(r);
    var writable = !!$65b1c23913f1b818$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $65b1c23913f1b818$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $7UDrs(w, function(err) {
            writable = false;
            if (err) $65b1c23913f1b818$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $7UDrs(r, function(err) {
            readable = false;
            if (err) $65b1c23913f1b818$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $65b1c23913f1b818$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $65b1c23913f1b818$require$destroyer(w, err);
            $65b1c23913f1b818$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("7qh1D", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $56782afaa4553982$require$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf;
module.exports = $56782afaa4553982$var$PassThrough;

var $GYlyq = parcelRequire("GYlyq");
$56782afaa4553982$require$ObjectSetPrototypeOf($56782afaa4553982$var$PassThrough.prototype, $GYlyq.prototype);
$56782afaa4553982$require$ObjectSetPrototypeOf($56782afaa4553982$var$PassThrough, $GYlyq);
function $56782afaa4553982$var$PassThrough(options) {
    if (!(this instanceof $56782afaa4553982$var$PassThrough)) return new $56782afaa4553982$var$PassThrough(options);
    $GYlyq.call(this, options);
}
$56782afaa4553982$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("GYlyq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $0812bbf22a91f263$var$ObjectSetPrototypeOf = $6zAfR.ObjectSetPrototypeOf, $0812bbf22a91f263$var$Symbol = $6zAfR.Symbol;
module.exports = $0812bbf22a91f263$var$Transform;

var $0812bbf22a91f263$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("5Q9Jl")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $ab4Kx = parcelRequire("ab4Kx");

var $gUxqg = parcelRequire("gUxqg");
var $0812bbf22a91f263$require$getHighWaterMark = $gUxqg.getHighWaterMark;
$0812bbf22a91f263$var$ObjectSetPrototypeOf($0812bbf22a91f263$var$Transform.prototype, $ab4Kx.prototype);
$0812bbf22a91f263$var$ObjectSetPrototypeOf($0812bbf22a91f263$var$Transform, $ab4Kx);
var $0812bbf22a91f263$var$kCallback = $0812bbf22a91f263$var$Symbol('kCallback');
function $0812bbf22a91f263$var$Transform(options) {
    if (!(this instanceof $0812bbf22a91f263$var$Transform)) return new $0812bbf22a91f263$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $0812bbf22a91f263$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $ab4Kx.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$0812bbf22a91f263$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $0812bbf22a91f263$var$prefinish);
}
function $0812bbf22a91f263$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $0812bbf22a91f263$var$prefinish() {
    if (this._final !== $0812bbf22a91f263$var$_final) $0812bbf22a91f263$var$_final.call(this);
}
$0812bbf22a91f263$var$Transform.prototype._final = $0812bbf22a91f263$var$_final;
$0812bbf22a91f263$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $0812bbf22a91f263$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$0812bbf22a91f263$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$0812bbf22a91f263$var$kCallback] = callback;
    });
};
$0812bbf22a91f263$var$Transform.prototype._read = function() {
    if (this[$0812bbf22a91f263$var$kCallback]) {
        var callback = this[$0812bbf22a91f263$var$kCallback];
        this[$0812bbf22a91f263$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("7xJ5J", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6zAfR = parcelRequire("6zAfR");
var $57de97b0ff4f0a24$var$ArrayPrototypePop = $6zAfR.ArrayPrototypePop, $57de97b0ff4f0a24$var$Promise = $6zAfR.Promise;

var $kq58L = parcelRequire("kq58L");
var $57de97b0ff4f0a24$var$isIterable = $kq58L.isIterable, $57de97b0ff4f0a24$var$isNodeStream = $kq58L.isNodeStream, $57de97b0ff4f0a24$var$isWebStream = $kq58L.isWebStream;

var $eHl1m = parcelRequire("eHl1m");
var $57de97b0ff4f0a24$var$pl = $eHl1m.pipelineImpl;

var $7UDrs = parcelRequire("7UDrs");
var $57de97b0ff4f0a24$require$finished = $7UDrs.finished;
parcelRequire("4UZla");
function $57de97b0ff4f0a24$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $57de97b0ff4f0a24$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$57de97b0ff4f0a24$var$isNodeStream(lastArg) && !$57de97b0ff4f0a24$var$isIterable(lastArg) && !$57de97b0ff4f0a24$var$isWebStream(lastArg)) {
            var options = $57de97b0ff4f0a24$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $57de97b0ff4f0a24$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $57de97b0ff4f0a24$require$finished,
    pipeline: $57de97b0ff4f0a24$var$pipeline
};

});





parcelRegister("l0iVg", function(module, exports) {
"use strict";
var $f4a846b453bb12bd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4a846b453bb12bd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4a846b453bb12bd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4a846b453bb12bd$var$__exportStar((parcelRequire("aP9ym")), module.exports);

});
parcelRegister("aP9ym", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulateCardinality = void 0;

var $ihMfU = parcelRequire("ihMfU");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Cardinality RDF Metadata Accumulate Actor.
 */ var $7e1613e12078b28c$var$ActorRdfMetadataAccumulateCardinality = /*#__PURE__*/ function(_bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate) {
    (0, $i3fW3._)(ActorRdfMetadataAccumulateCardinality, _bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate);
    function ActorRdfMetadataAccumulateCardinality(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataAccumulateCardinality);
        return (0, $kzDuW._)(this, ActorRdfMetadataAccumulateCardinality, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataAccumulateCardinality, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cardinality;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Return default value on initialize
                        if (action.mode === 'initialize') return [
                            2,
                            {
                                metadata: {
                                    cardinality: {
                                        type: 'exact',
                                        value: 0
                                    }
                                }
                            }
                        ];
                        // Otherwise, attempt to update existing value
                        cardinality = (0, $iT0je._)({}, action.accumulatedMetadata.cardinality);
                        if (cardinality.dataset) {
                            // If the accumulated cardinality refers to that of the full default graph (applicable for SPARQL endpoints)
                            if (action.accumulatedMetadata.defaultGraph === cardinality.dataset && cardinality.dataset !== action.appendingMetadata.cardinality.dataset) // Use the cardinality of the appending metadata.
                            return [
                                2,
                                {
                                    metadata: {
                                        cardinality: action.appendingMetadata.cardinality
                                    }
                                }
                            ];
                            if (action.appendingMetadata.cardinality.dataset) {
                                // If the accumulated cardinality is dataset-wide
                                if (cardinality.dataset !== action.appendingMetadata.cardinality.dataset && action.appendingMetadata.subsetOf === cardinality.dataset) // If the appending cardinality refers to the subset of a dataset,
                                // use the cardinality of the subset.
                                return [
                                    2,
                                    {
                                        metadata: {
                                            cardinality: action.appendingMetadata.cardinality
                                        }
                                    }
                                ];
                                if (cardinality.dataset === action.appendingMetadata.cardinality.dataset) // If the appending cardinality is for the same dataset,
                                // keep the accumulated cardinality unchanged.
                                return [
                                    2,
                                    {
                                        metadata: {
                                            cardinality: cardinality
                                        }
                                    }
                                ];
                                // If the appending cardinality refers to another dataset,
                                // remove the dataset scopes.
                                delete cardinality.dataset;
                            } else // If the appending cardinality refers to a dataset subset,
                            // keep the accumulated cardinality unchanged.
                            return [
                                2,
                                {
                                    metadata: {
                                        cardinality: cardinality
                                    }
                                }
                            ];
                        }
                        if (!action.appendingMetadata.cardinality || !Number.isFinite(action.appendingMetadata.cardinality.value)) {
                            // We're already at infinite, so ignore any later metadata
                            cardinality.type = 'estimate';
                            cardinality.value = Number.POSITIVE_INFINITY;
                        } else {
                            if (action.appendingMetadata.cardinality.type === 'estimate') cardinality.type = 'estimate';
                            cardinality.value += action.appendingMetadata.cardinality.value;
                        }
                        return [
                            2,
                            {
                                metadata: {
                                    cardinality: cardinality
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataAccumulateCardinality;
}($ihMfU.ActorRdfMetadataAccumulate);
module.exports.ActorRdfMetadataAccumulateCardinality = $7e1613e12078b28c$var$ActorRdfMetadataAccumulateCardinality;

});
parcelRegister("ihMfU", function(module, exports) {
"use strict";
var $d4ff3f18e87817dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d4ff3f18e87817dc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d4ff3f18e87817dc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d4ff3f18e87817dc$var$__exportStar((parcelRequire("jsHoM")), module.exports);

});
parcelRegister("jsHoM", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulate = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-metadata-accumulate events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadataAccumulate:      The metadata objects to accumulate,
 *                                              or a trigger for initializing a new value.
 * * Test:   <none>
 * * Output: IActorRdfMetadataAccumulateOutput: The accumulated metadata object.
 *
 * @see IActionRdfMetadataAccumulate
 * @see IActorRdfMetadataAccumulateOutput
 */ var $e2b24bec73f011ae$var$ActorRdfMetadataAccumulate = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfMetadataAccumulate, _core_1_Actor);
    function ActorRdfMetadataAccumulate(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataAccumulate);
        return (0, $kzDuW._)(this, ActorRdfMetadataAccumulate, [
            args
        ]);
    }
    return ActorRdfMetadataAccumulate;
}($kNNoa.Actor);
module.exports.ActorRdfMetadataAccumulate = $e2b24bec73f011ae$var$ActorRdfMetadataAccumulate;

});




parcelRegister("kF6rE", function(module, exports) {
"use strict";
var $f0aca2cf7df72ba8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0aca2cf7df72ba8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0aca2cf7df72ba8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0aca2cf7df72ba8$var$__exportStar((parcelRequire("iaeP1")), module.exports);

});
parcelRegister("iaeP1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulatePageSize = void 0;

var $ihMfU = parcelRequire("ihMfU");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica PageSize RDF Metadata Accumulate Actor.
 */ var $d394a87e0e01685e$var$ActorRdfMetadataAccumulatePageSize = /*#__PURE__*/ function(_bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate) {
    (0, $i3fW3._)(ActorRdfMetadataAccumulatePageSize, _bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate);
    function ActorRdfMetadataAccumulatePageSize(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataAccumulatePageSize);
        return (0, $kzDuW._)(this, ActorRdfMetadataAccumulatePageSize, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataAccumulatePageSize, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_accumulatedMetadata_pageSize, _action_appendingMetadata_pageSize;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Return nothing on initialize
                        if (action.mode === 'initialize') return [
                            2,
                            {
                                metadata: {}
                            }
                        ];
                        // Otherwise, attempt to increment existing value
                        return [
                            2,
                            {
                                metadata: (0, $iT0je._)({}, 'pageSize' in action.accumulatedMetadata || 'pageSize' in action.appendingMetadata ? {
                                    pageSize: ((_action_accumulatedMetadata_pageSize = action.accumulatedMetadata.pageSize) !== null && _action_accumulatedMetadata_pageSize !== void 0 ? _action_accumulatedMetadata_pageSize : 0) + ((_action_appendingMetadata_pageSize = action.appendingMetadata.pageSize) !== null && _action_appendingMetadata_pageSize !== void 0 ? _action_appendingMetadata_pageSize : 0)
                                } : {})
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataAccumulatePageSize;
}($ihMfU.ActorRdfMetadataAccumulate);
module.exports.ActorRdfMetadataAccumulatePageSize = $d394a87e0e01685e$var$ActorRdfMetadataAccumulatePageSize;

});


parcelRegister("jslhI", function(module, exports) {
"use strict";
var $e2a12488ce514393$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e2a12488ce514393$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e2a12488ce514393$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e2a12488ce514393$var$__exportStar((parcelRequire("bQnhu")), module.exports);

});
parcelRegister("bQnhu", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulateRequestTime = void 0;

var $ihMfU = parcelRequire("ihMfU");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica RequestTime RDF Metadata Accumulate Actor.
 */ var $89f69c2fa1836da2$var$ActorRdfMetadataAccumulateRequestTime = /*#__PURE__*/ function(_bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate) {
    (0, $i3fW3._)(ActorRdfMetadataAccumulateRequestTime, _bus_rdf_metadata_accumulate_1_ActorRdfMetadataAccumulate);
    function ActorRdfMetadataAccumulateRequestTime(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataAccumulateRequestTime);
        return (0, $kzDuW._)(this, ActorRdfMetadataAccumulateRequestTime, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataAccumulateRequestTime, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_accumulatedMetadata_requestTime, _action_appendingMetadata_requestTime;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Return nothing on initialize
                        if (action.mode === 'initialize') return [
                            2,
                            {
                                metadata: {}
                            }
                        ];
                        // Otherwise, attempt to increment existing value
                        return [
                            2,
                            {
                                metadata: (0, $iT0je._)({}, 'requestTime' in action.accumulatedMetadata || 'requestTime' in action.appendingMetadata ? {
                                    requestTime: ((_action_accumulatedMetadata_requestTime = action.accumulatedMetadata.requestTime) !== null && _action_accumulatedMetadata_requestTime !== void 0 ? _action_accumulatedMetadata_requestTime : 0) + ((_action_appendingMetadata_requestTime = action.appendingMetadata.requestTime) !== null && _action_appendingMetadata_requestTime !== void 0 ? _action_appendingMetadata_requestTime : 0)
                                } : {})
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataAccumulateRequestTime;
}($ihMfU.ActorRdfMetadataAccumulate);
module.exports.ActorRdfMetadataAccumulateRequestTime = $89f69c2fa1836da2$var$ActorRdfMetadataAccumulateRequestTime;

});


parcelRegister("45Y83", function(module, exports) {
"use strict";
var $2fb64569a2414abd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fb64569a2414abd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2fb64569a2414abd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2fb64569a2414abd$var$__exportStar((parcelRequire("bWrZP")), module.exports);

});
parcelRegister("bWrZP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraControls = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");

var $4WO2Q = parcelRequire("4WO2Q");
/**
 * An RDF Metadata Extract Actor that extracts all Hydra controls from the metadata stream.
 */ var $8b1ad3fb474cdda8$var$ActorRdfMetadataExtractHydraControls = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractHydraControls, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractHydraControls(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractHydraControls);
        var _this;
        _this = (0, $kzDuW._)(this, ActorRdfMetadataExtractHydraControls, [
            args
        ]);
        _this.parsedUriTemplateCache = {};
        return _this;
    }
    (0, $byiyg._)(ActorRdfMetadataExtractHydraControls, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Collect all Hydra page links from the given Hydra properties object.
     * @param pageUrl The page URL in which the Hydra properties are defined.
     * @param hydraProperties The collected Hydra properties.
     * @return The Hydra links
     */ key: "getLinks",
            value: function getLinks(pageUrl, hydraProperties) {
                return Object.fromEntries(ActorRdfMetadataExtractHydraControls.LINK_TYPES.map(function(link) {
                    // First check the correct hydra:next, then the deprecated hydra:nextPage
                    var links = hydraProperties[link] || hydraProperties["".concat(link, "Page")];
                    var linkTargets = links && links[pageUrl];
                    return [
                        link,
                        linkTargets && linkTargets.length > 0 ? [
                            linkTargets[0]
                        ] : []
                    ];
                }));
            }
        },
        {
            /**
     * Parse a URI template, or retrieve it from a cache.
     * @param {string} template A URI template string.
     * @return {} A parsed URI template object.
     */ key: "parseUriTemplateCached",
            value: function parseUriTemplateCached(template) {
                var cachedUriTemplate = this.parsedUriTemplateCache[template];
                if (cachedUriTemplate) return cachedUriTemplate;
                return this.parsedUriTemplateCache[template] = (0, $4WO2Q.parse)(template);
            }
        },
        {
            /**
     * Collect all search forms from the given Hydra properties object.
     * @param hydraProperties The collected Hydra properties.
     * @return The search forms.
     */ key: "getSearchForms",
            value: function getSearchForms(hydraProperties) {
                var searchFormData = hydraProperties.search;
                var searchForms = [];
                if (searchFormData) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    for(var dataset in searchFormData)try {
                        var _this, _loop = function() {
                            var searchFormId = _step.value;
                            var searchTemplates = (hydraProperties.template || {})[searchFormId] || [];
                            // Parse the template
                            if (searchTemplates.length !== 1) throw new Error("Expected 1 hydra:template for ".concat(searchFormId));
                            var template = searchTemplates[0];
                            var searchTemplate = _this.parseUriTemplateCached(template);
                            // Parse the template mappings
                            var mappings = Object.fromEntries(((hydraProperties.mapping || {})[searchFormId] || []).map(function(mapping) {
                                var variable = ((hydraProperties.variable || {})[mapping] || [])[0];
                                var property = ((hydraProperties.property || {})[mapping] || [])[0];
                                if (!variable) throw new Error("Expected a hydra:variable for ".concat(mapping));
                                if (!property) throw new Error("Expected a hydra:property for ".concat(mapping));
                                return [
                                    property,
                                    variable
                                ];
                            }));
                            // Gets the URL of the Triple Pattern Fragment with the given triple pattern
                            var getUri = function(entries) {
                                return searchTemplate.expand(Object.fromEntries(Object.keys(entries).map(function(key) {
                                    return [
                                        mappings[key],
                                        entries[key]
                                    ];
                                })));
                            };
                            searchForms.push({
                                dataset: dataset,
                                template: template,
                                mappings: mappings,
                                getUri: getUri
                            });
                        };
                        for(var _iterator = searchFormData[dataset][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return {
                    values: searchForms
                };
            }
        },
        {
            /**
     * Collect all hydra properties from a given metadata stream
     * in a nice convenient nested hash (property / subject / objects).
     * @param {RDF.Stream} metadata
     * @return The collected Hydra properties.
     */ key: "getHydraProperties",
            value: function getHydraProperties(metadata) {
                return new Promise(function(resolve, reject) {
                    metadata.on('error', reject);
                    // Collect all hydra properties in a nice convenient nested hash (property / subject / objects).
                    var hydraProperties = {};
                    metadata.on('data', function(quad) {
                        if (quad.predicate.value.startsWith(ActorRdfMetadataExtractHydraControls.HYDRA)) {
                            var property = quad.predicate.value.slice(ActorRdfMetadataExtractHydraControls.HYDRA.length);
                            var subjectProperties = hydraProperties[property] || (hydraProperties[property] = {});
                            var objects = subjectProperties[quad.subject.value] || (subjectProperties[quad.subject.value] = []);
                            objects.push(quad.object.value);
                        }
                    });
                    metadata.on('end', function() {
                        return resolve(hydraProperties);
                    });
                });
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadata, hydraProperties;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                metadata = {};
                                return [
                                    4,
                                    this.getHydraProperties(action.metadata)
                                ];
                            case 1:
                                hydraProperties = _state.sent();
                                Object.assign(metadata, this.getLinks(action.url, hydraProperties));
                                metadata.searchForms = this.getSearchForms(hydraProperties);
                                return [
                                    2,
                                    {
                                        metadata: metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfMetadataExtractHydraControls;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractHydraControls = $8b1ad3fb474cdda8$var$ActorRdfMetadataExtractHydraControls;
$8b1ad3fb474cdda8$var$ActorRdfMetadataExtractHydraControls.HYDRA = 'http://www.w3.org/ns/hydra/core#';
$8b1ad3fb474cdda8$var$ActorRdfMetadataExtractHydraControls.LINK_TYPES = [
    'first',
    'next',
    'previous',
    'last'
];

});
parcelRegister("d0T0u", function(module, exports) {
"use strict";
var $9795f1ad92f72eab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9795f1ad92f72eab$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9795f1ad92f72eab$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9795f1ad92f72eab$var$__exportStar((parcelRequire("9mmET")), module.exports);

});
parcelRegister("9mmET", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtract = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-metadata-extract events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadataExtract:      A metadata quad stream
 * * Test:   <none>
 * * Output: IActorRdfMetadataExtractOutput: A metadata hash.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ var $6d07bea989b6e06f$var$ActorRdfMetadataExtract = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfMetadataExtract, _core_1_Actor);
    function ActorRdfMetadataExtract(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtract);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtract, [
            args
        ]);
    }
    return ActorRdfMetadataExtract;
}($kNNoa.Actor);
module.exports.ActorRdfMetadataExtract = $6d07bea989b6e06f$var$ActorRdfMetadataExtract;

});


parcelRegister("4WO2Q", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
/*global unescape, module, define, window, global*/ /*
 UriTemplate Copyright (c) 2012-2013 Franz Antesberger. All Rights Reserved.
 Available via the MIT license.
*/ (function(exportCallback) {
    "use strict";
    var UriTemplateError = function() {
        function UriTemplateError(options) {
            this.options = options;
        }
        UriTemplateError.prototype.toString = function() {
            if (JSON && JSON.stringify) return JSON.stringify(this.options);
            else return this.options;
        };
        return UriTemplateError;
    }();
    var objectHelper = function() {
        function isArray(value) {
            return Object.prototype.toString.apply(value) === '[object Array]';
        }
        function isString(value) {
            return Object.prototype.toString.apply(value) === '[object String]';
        }
        function isNumber(value) {
            return Object.prototype.toString.apply(value) === '[object Number]';
        }
        function isBoolean(value) {
            return Object.prototype.toString.apply(value) === '[object Boolean]';
        }
        function join(arr, separator) {
            var result = '', first = true, index;
            for(index = 0; index < arr.length; index += 1){
                if (first) first = false;
                else result += separator;
                result += arr[index];
            }
            return result;
        }
        function map(arr, mapper) {
            var result = [], index = 0;
            for(; index < arr.length; index += 1)result.push(mapper(arr[index]));
            return result;
        }
        function filter(arr, predicate) {
            var result = [], index = 0;
            for(; index < arr.length; index += 1)if (predicate(arr[index])) result.push(arr[index]);
            return result;
        }
        function deepFreezeUsingObjectFreeze(object) {
            if ((typeof object === "undefined" ? "undefined" : (0, $3KZcf._)(object)) !== "object" || object === null) return object;
            Object.freeze(object);
            var property, propertyName;
            for(propertyName in object)if (object.hasOwnProperty(propertyName)) {
                property = object[propertyName];
                // be aware, arrays are 'object', too
                if ((typeof property === "undefined" ? "undefined" : (0, $3KZcf._)(property)) === "object") deepFreeze(property);
            }
            return object;
        }
        function deepFreeze(object) {
            if (typeof Object.freeze === 'function') return deepFreezeUsingObjectFreeze(object);
            return object;
        }
        return {
            isArray: isArray,
            isString: isString,
            isNumber: isNumber,
            isBoolean: isBoolean,
            join: join,
            map: map,
            filter: filter,
            deepFreeze: deepFreeze
        };
    }();
    var charHelper = function() {
        function isAlpha(chr) {
            return chr >= 'a' && chr <= 'z' || chr >= 'A' && chr <= 'Z';
        }
        function isDigit(chr) {
            return chr >= '0' && chr <= '9';
        }
        function isHexDigit(chr) {
            return isDigit(chr) || chr >= 'a' && chr <= 'f' || chr >= 'A' && chr <= 'F';
        }
        return {
            isAlpha: isAlpha,
            isDigit: isDigit,
            isHexDigit: isHexDigit
        };
    }();
    var pctEncoder = function() {
        var utf8 = {
            encode: function encode(chr) {
                // see http://ecmanaut.blogspot.de/2006/07/encoding-decoding-utf8-in-javascript.html
                return unescape(encodeURIComponent(chr));
            },
            numBytes: function numBytes(firstCharCode) {
                if (firstCharCode <= 0x7F) return 1;
                else if (0xC2 <= firstCharCode && firstCharCode <= 0xDF) return 2;
                else if (0xE0 <= firstCharCode && firstCharCode <= 0xEF) return 3;
                else if (0xF0 <= firstCharCode && firstCharCode <= 0xF4) return 4;
                // no valid first octet
                return 0;
            },
            isValidFollowingCharCode: function isValidFollowingCharCode(charCode) {
                return 0x80 <= charCode && charCode <= 0xBF;
            }
        };
        /**
     * encodes a character, if needed or not.
     * @param chr
     * @return pct-encoded character
     */ function encodeCharacter(chr) {
            var result = '', octets = utf8.encode(chr), octet, index;
            for(index = 0; index < octets.length; index += 1){
                octet = octets.charCodeAt(index);
                result += '%' + (octet < 0x10 ? '0' : '') + octet.toString(16).toUpperCase();
            }
            return result;
        }
        /**
     * Returns, whether the given text at start is in the form 'percent hex-digit hex-digit', like '%3F'
     * @param text
     * @param start
     * @return {boolean|*|*}
     */ function isPercentDigitDigit(text, start) {
            return text.charAt(start) === '%' && charHelper.isHexDigit(text.charAt(start + 1)) && charHelper.isHexDigit(text.charAt(start + 2));
        }
        /**
     * Parses a hex number from start with length 2.
     * @param text a string
     * @param start the start index of the 2-digit hex number
     * @return {Number}
     */ function parseHex2(text, start) {
            return parseInt(text.substr(start, 2), 16);
        }
        /**
     * Returns whether or not the given char sequence is a correctly pct-encoded sequence.
     * @param chr
     * @return {boolean}
     */ function isPctEncoded(chr) {
            if (!isPercentDigitDigit(chr, 0)) return false;
            var firstCharCode = parseHex2(chr, 1);
            var numBytes = utf8.numBytes(firstCharCode);
            if (numBytes === 0) return false;
            for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                if (!isPercentDigitDigit(chr, 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(chr, 3 * byteNumber + 1))) return false;
            }
            return true;
        }
        /**
     * Reads as much as needed from the text, e.g. '%20' or '%C3%B6'. It does not decode!
     * @param text
     * @param startIndex
     * @return the character or pct-string of the text at startIndex
     */ function pctCharAt(text, startIndex) {
            var chr = text.charAt(startIndex);
            if (!isPercentDigitDigit(text, startIndex)) return chr;
            var utf8CharCode = parseHex2(text, startIndex + 1);
            var numBytes = utf8.numBytes(utf8CharCode);
            if (numBytes === 0) return chr;
            for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                if (!isPercentDigitDigit(text, startIndex + 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(text, startIndex + 3 * byteNumber + 1))) return chr;
            }
            return text.substr(startIndex, 3 * numBytes);
        }
        return {
            encodeCharacter: encodeCharacter,
            isPctEncoded: isPctEncoded,
            pctCharAt: pctCharAt
        };
    }();
    var rfcCharHelper = function() {
        /**
     * Returns if an character is an varchar character according 2.3 of rfc 6570
     * @param chr
     * @return (Boolean)
     */ function isVarchar(chr) {
            return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '_' || pctEncoder.isPctEncoded(chr);
        }
        /**
     * Returns if chr is an unreserved character according 1.5 of rfc 6570
     * @param chr
     * @return {Boolean}
     */ function isUnreserved(chr) {
            return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '-' || chr === '.' || chr === '_' || chr === '~';
        }
        /**
     * Returns if chr is an reserved character according 1.5 of rfc 6570
     * or the percent character mentioned in 3.2.1.
     * @param chr
     * @return {Boolean}
     */ function isReserved(chr) {
            return chr === ':' || chr === '/' || chr === '?' || chr === '#' || chr === '[' || chr === ']' || chr === '@' || chr === '!' || chr === '$' || chr === '&' || chr === '(' || chr === ')' || chr === '*' || chr === '+' || chr === ',' || chr === ';' || chr === '=' || chr === "'";
        }
        return {
            isVarchar: isVarchar,
            isUnreserved: isUnreserved,
            isReserved: isReserved
        };
    }();
    /**
 * encoding of rfc 6570
 */ var encodingHelper = function() {
        function encode(text, passReserved) {
            var result = '', index, chr = '';
            if (typeof text === "number" || typeof text === "boolean") text = text.toString();
            for(index = 0; index < text.length; index += chr.length){
                chr = text.charAt(index);
                result += rfcCharHelper.isUnreserved(chr) || passReserved && rfcCharHelper.isReserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
            return result;
        }
        function encodePassReserved(text) {
            return encode(text, true);
        }
        function encodeLiteralCharacter(literal, index) {
            var chr = pctEncoder.pctCharAt(literal, index);
            if (chr.length > 1) return chr;
            else return rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
        }
        function encodeLiteral(literal) {
            var result = '', index, chr = '';
            for(index = 0; index < literal.length; index += chr.length){
                chr = pctEncoder.pctCharAt(literal, index);
                if (chr.length > 1) result += chr;
                else result += rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
            return result;
        }
        return {
            encode: encode,
            encodePassReserved: encodePassReserved,
            encodeLiteral: encodeLiteral,
            encodeLiteralCharacter: encodeLiteralCharacter
        };
    }();
    // the operators defined by rfc 6570
    var operators = function() {
        var bySymbol = {};
        function create(symbol) {
            bySymbol[symbol] = {
                symbol: symbol,
                separator: symbol === '?' ? '&' : symbol === '' || symbol === '+' || symbol === '#' ? ',' : symbol,
                named: symbol === ';' || symbol === '&' || symbol === '?',
                ifEmpty: symbol === '&' || symbol === '?' ? '=' : '',
                first: symbol === '+' ? '' : symbol,
                encode: symbol === '+' || symbol === '#' ? encodingHelper.encodePassReserved : encodingHelper.encode,
                toString: function toString() {
                    return this.symbol;
                }
            };
        }
        create('');
        create('+');
        create('#');
        create('.');
        create('/');
        create(';');
        create('?');
        create('&');
        return {
            valueOf: function valueOf(chr) {
                if (bySymbol[chr]) return bySymbol[chr];
                if ("=,!@|".indexOf(chr) >= 0) return null;
                return bySymbol[''];
            }
        };
    }();
    /**
 * Detects, whether a given element is defined in the sense of rfc 6570
 * Section 2.3 of the RFC makes clear defintions:
 * * undefined and null are not defined.
 * * the empty string is defined
 * * an array ("list") is defined, if it is not empty (even if all elements are not defined)
 * * an object ("map") is defined, if it contains at least one property with defined value
 * @param object
 * @return {Boolean}
 */ function isDefined(object) {
        var propertyName;
        if (object === null || object === undefined) return false;
        if (objectHelper.isArray(object)) // Section 2.3: A variable defined as a list value is considered undefined if the list contains zero members
        return object.length > 0;
        if (typeof object === "string" || typeof object === "number" || typeof object === "boolean") // falsy values like empty strings, false or 0 are "defined"
        return true;
        // else Object
        for(propertyName in object){
            if (object.hasOwnProperty(propertyName) && isDefined(object[propertyName])) return true;
        }
        return false;
    }
    var LiteralExpression = function() {
        function LiteralExpression(literal) {
            this.literal = encodingHelper.encodeLiteral(literal);
        }
        LiteralExpression.prototype.expand = function() {
            return this.literal;
        };
        LiteralExpression.prototype.toString = LiteralExpression.prototype.expand;
        return LiteralExpression;
    }();
    var parse = function() {
        function parseExpression(expressionText) {
            var operator, varspecs = [], varspec = null, varnameStart = null, maxLengthStart = null, index, chr = '';
            function closeVarname() {
                var varname = expressionText.substring(varnameStart, index);
                if (varname.length === 0) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "a varname must be specified",
                    position: index
                });
                varspec = {
                    varname: varname,
                    exploded: false,
                    maxLength: null
                };
                varnameStart = null;
            }
            function closeMaxLength() {
                if (maxLengthStart === index) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "after a ':' you have to specify the length",
                    position: index
                });
                varspec.maxLength = parseInt(expressionText.substring(maxLengthStart, index), 10);
                maxLengthStart = null;
            }
            operator = function(operatorText) {
                var op = operators.valueOf(operatorText);
                if (op === null) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "illegal use of reserved operator",
                    position: index,
                    operator: operatorText
                });
                return op;
            }(expressionText.charAt(0));
            index = operator.symbol.length;
            varnameStart = index;
            for(; index < expressionText.length; index += chr.length){
                chr = pctEncoder.pctCharAt(expressionText, index);
                if (varnameStart !== null) {
                    // the spec says: varname =  varchar *( ["."] varchar )
                    // so a dot is allowed except for the first char
                    if (chr === '.') {
                        if (varnameStart === index) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "a varname MUST NOT start with a dot",
                            position: index
                        });
                        continue;
                    }
                    if (rfcCharHelper.isVarchar(chr)) continue;
                    closeVarname();
                }
                if (maxLengthStart !== null) {
                    if (index === maxLengthStart && chr === '0') throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "A :prefix must not start with digit 0",
                        position: index
                    });
                    if (charHelper.isDigit(chr)) {
                        if (index - maxLengthStart >= 4) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "A :prefix must have max 4 digits",
                            position: index
                        });
                        continue;
                    }
                    closeMaxLength();
                }
                if (chr === ':') {
                    if (varspec.maxLength !== null) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "only one :maxLength is allowed per varspec",
                        position: index
                    });
                    if (varspec.exploded) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "an exploeded varspec MUST NOT be varspeced",
                        position: index
                    });
                    maxLengthStart = index + 1;
                    continue;
                }
                if (chr === '*') {
                    if (varspec === null) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "exploded without varspec",
                        position: index
                    });
                    if (varspec.exploded) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "exploded twice",
                        position: index
                    });
                    if (varspec.maxLength) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "an explode (*) MUST NOT follow to a prefix",
                        position: index
                    });
                    varspec.exploded = true;
                    continue;
                }
                // the only legal character now is the comma
                if (chr === ',') {
                    varspecs.push(varspec);
                    varspec = null;
                    varnameStart = index + 1;
                    continue;
                }
                throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "illegal character",
                    character: chr,
                    position: index
                });
            } // for chr
            if (varnameStart !== null) closeVarname();
            if (maxLengthStart !== null) closeMaxLength();
            varspecs.push(varspec);
            return new VariableExpression(expressionText, operator, varspecs);
        }
        function parse(uriTemplateText) {
            // assert filled string
            var index, chr, expressions = [], braceOpenIndex = null, literalStart = 0;
            for(index = 0; index < uriTemplateText.length; index += 1){
                chr = uriTemplateText.charAt(index);
                if (literalStart !== null) {
                    if (chr === '}') throw new UriTemplateError({
                        templateText: uriTemplateText,
                        message: "unopened brace closed",
                        position: index
                    });
                    if (chr === '{') {
                        if (literalStart < index) expressions.push(new LiteralExpression(uriTemplateText.substring(literalStart, index)));
                        literalStart = null;
                        braceOpenIndex = index;
                    }
                    continue;
                }
                if (braceOpenIndex !== null) {
                    // here just { is forbidden
                    if (chr === '{') throw new UriTemplateError({
                        templateText: uriTemplateText,
                        message: "brace already opened",
                        position: index
                    });
                    if (chr === '}') {
                        if (braceOpenIndex + 1 === index) throw new UriTemplateError({
                            templateText: uriTemplateText,
                            message: "empty braces",
                            position: braceOpenIndex
                        });
                        try {
                            expressions.push(parseExpression(uriTemplateText.substring(braceOpenIndex + 1, index)));
                        } catch (error) {
                            if (error.prototype === UriTemplateError.prototype) throw new UriTemplateError({
                                templateText: uriTemplateText,
                                message: error.options.message,
                                position: braceOpenIndex + error.options.position,
                                details: error.options
                            });
                            throw error;
                        }
                        braceOpenIndex = null;
                        literalStart = index + 1;
                    }
                    continue;
                }
                throw new Error('reached unreachable code');
            }
            if (braceOpenIndex !== null) throw new UriTemplateError({
                templateText: uriTemplateText,
                message: "unclosed brace",
                position: braceOpenIndex
            });
            if (literalStart < uriTemplateText.length) expressions.push(new LiteralExpression(uriTemplateText.substr(literalStart)));
            return new UriTemplate(uriTemplateText, expressions);
        }
        return parse;
    }();
    var VariableExpression = function() {
        // helper function if JSON is not available
        function prettyPrint(value) {
            return JSON && JSON.stringify ? JSON.stringify(value) : value;
        }
        function isEmpty(value) {
            if (!isDefined(value)) return true;
            if (objectHelper.isString(value)) return value === '';
            if (objectHelper.isNumber(value) || objectHelper.isBoolean(value)) return false;
            if (objectHelper.isArray(value)) return value.length === 0;
            for(var propertyName in value){
                if (value.hasOwnProperty(propertyName)) return false;
            }
            return true;
        }
        function propertyArray(object) {
            var result = [], propertyName;
            for(propertyName in object)if (object.hasOwnProperty(propertyName)) result.push({
                name: propertyName,
                value: object[propertyName]
            });
            return result;
        }
        function VariableExpression(templateText, operator, varspecs) {
            this.templateText = templateText;
            this.operator = operator;
            this.varspecs = varspecs;
        }
        VariableExpression.prototype.toString = function() {
            return this.templateText;
        };
        function expandSimpleValue(varspec, operator, value) {
            var result = '';
            value = value.toString();
            if (operator.named) {
                result += encodingHelper.encodeLiteral(varspec.varname);
                if (value === '') {
                    result += operator.ifEmpty;
                    return result;
                }
                result += '=';
            }
            if (varspec.maxLength !== null) value = value.substr(0, varspec.maxLength);
            result += operator.encode(value);
            return result;
        }
        function valueDefined(nameValue) {
            return isDefined(nameValue.value);
        }
        function expandNotExploded(varspec, operator, value) {
            var arr = [], result = '';
            if (operator.named) {
                result += encodingHelper.encodeLiteral(varspec.varname);
                if (isEmpty(value)) {
                    result += operator.ifEmpty;
                    return result;
                }
                result += '=';
            }
            if (objectHelper.isArray(value)) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, operator.encode);
                result += objectHelper.join(arr, ',');
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, valueDefined);
                arr = objectHelper.map(arr, function(nameValue) {
                    return operator.encode(nameValue.name) + ',' + operator.encode(nameValue.value);
                });
                result += objectHelper.join(arr, ',');
            }
            return result;
        }
        function expandExplodedNamed(varspec, operator, value) {
            var isArray = objectHelper.isArray(value), arr = [];
            if (isArray) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, function(listElement) {
                    var tmp = encodingHelper.encodeLiteral(varspec.varname);
                    if (isEmpty(listElement)) tmp += operator.ifEmpty;
                    else tmp += '=' + operator.encode(listElement);
                    return tmp;
                });
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, valueDefined);
                arr = objectHelper.map(arr, function(nameValue) {
                    var tmp = encodingHelper.encodeLiteral(nameValue.name);
                    if (isEmpty(nameValue.value)) tmp += operator.ifEmpty;
                    else tmp += '=' + operator.encode(nameValue.value);
                    return tmp;
                });
            }
            return objectHelper.join(arr, operator.separator);
        }
        function expandExplodedUnnamed(operator, value) {
            var arr = [], result = '';
            if (objectHelper.isArray(value)) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, operator.encode);
                result += objectHelper.join(arr, operator.separator);
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, function(nameValue) {
                    return isDefined(nameValue.value);
                });
                arr = objectHelper.map(arr, function(nameValue) {
                    return operator.encode(nameValue.name) + '=' + operator.encode(nameValue.value);
                });
                result += objectHelper.join(arr, operator.separator);
            }
            return result;
        }
        VariableExpression.prototype.expand = function(variables) {
            var expanded = [], index, varspec, value, valueIsArr, oneExploded = false, operator = this.operator;
            // expand each varspec and join with operator's separator
            for(index = 0; index < this.varspecs.length; index += 1){
                varspec = this.varspecs[index];
                value = variables[varspec.varname];
                // if (!isDefined(value)) {
                // if (variables.hasOwnProperty(varspec.name)) {
                if (value === null || value === undefined) continue;
                if (varspec.exploded) oneExploded = true;
                valueIsArr = objectHelper.isArray(value);
                if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") expanded.push(expandSimpleValue(varspec, operator, value));
                else if (varspec.maxLength && isDefined(value)) // 2.4.1 of the spec says: "Prefix modifiers are not applicable to variables that have composite values."
                throw new Error('Prefix modifiers are not applicable to variables that have composite values. You tried to expand ' + this + " with " + prettyPrint(value));
                else if (!varspec.exploded) {
                    if (operator.named || !isEmpty(value)) expanded.push(expandNotExploded(varspec, operator, value));
                } else if (isDefined(value)) {
                    if (operator.named) expanded.push(expandExplodedNamed(varspec, operator, value));
                    else expanded.push(expandExplodedUnnamed(operator, value));
                }
            }
            if (expanded.length === 0) return "";
            else return operator.first + objectHelper.join(expanded, operator.separator);
        };
        return VariableExpression;
    }();
    var UriTemplate = function() {
        function UriTemplate(templateText, expressions) {
            this.templateText = templateText;
            this.expressions = expressions;
            objectHelper.deepFreeze(this);
        }
        UriTemplate.prototype.toString = function() {
            return this.templateText;
        };
        UriTemplate.prototype.expand = function(variables) {
            // this.expressions.map(function (expression) {return expression.expand(variables);}).join('');
            var index, result = '';
            for(index = 0; index < this.expressions.length; index += 1)result += this.expressions[index].expand(variables);
            return result;
        };
        UriTemplate.parse = parse;
        UriTemplate.UriTemplateError = UriTemplateError;
        return UriTemplate;
    }();
    exportCallback(UriTemplate);
})(function(UriTemplate) {
    "use strict";
    module.exports = UriTemplate;
});

});



parcelRegister("dvyct", function(module, exports) {
"use strict";
var $9d58b30b229e0122$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9d58b30b229e0122$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9d58b30b229e0122$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9d58b30b229e0122$var$__exportStar((parcelRequire("87l9Z")), module.exports);

});
parcelRegister("87l9Z", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraCount = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * An RDF Metadata Extract Actor that extracts total items counts from a metadata stream based on the given predicates.
 */ var $5e8f641e5246e735$var$ActorRdfMetadataExtractHydraCount = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractHydraCount, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractHydraCount(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractHydraCount);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractHydraCount, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractHydraCount, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    // Forward errors
                    action.metadata.on('error', reject);
                    // Immediately resolve when a value has been found.
                    action.metadata.on('data', function(quad) {
                        if (_this.predicates.includes(quad.predicate.value)) resolve({
                            metadata: {
                                cardinality: {
                                    type: 'estimate',
                                    value: Number.parseInt(quad.object.value, 10),
                                    dataset: quad.subject.value
                                }
                            }
                        });
                    });
                    // If no value has been found, assume infinity.
                    action.metadata.on('end', function() {
                        resolve({
                            metadata: {
                                cardinality: {
                                    type: 'estimate',
                                    value: 0
                                }
                            }
                        });
                    });
                });
            }
        }
    ]);
    return ActorRdfMetadataExtractHydraCount;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractHydraCount = $5e8f641e5246e735$var$ActorRdfMetadataExtractHydraCount;

});


parcelRegister("2yLVw", function(module, exports) {
"use strict";
var $1dd3ef050e2bebc4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1dd3ef050e2bebc4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1dd3ef050e2bebc4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1dd3ef050e2bebc4$var$__exportStar((parcelRequire("aTrF8")), module.exports);

});
parcelRegister("aTrF8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraPagesize = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Hydra Pagesize RDF Metadata Extract Actor.
 */ var $7ee47fa311d0cfbb$var$ActorRdfMetadataExtractHydraPagesize = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractHydraPagesize, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractHydraPagesize(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractHydraPagesize);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractHydraPagesize, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractHydraPagesize, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                // Forward errors
                                action.metadata.on('error', reject);
                                // Immediately resolve when a value has been found.
                                action.metadata.on('data', function(quad) {
                                    if (_this.predicates.includes(quad.predicate.value)) resolve({
                                        metadata: {
                                            pageSize: Number.parseInt(quad.object.value, 10)
                                        }
                                    });
                                });
                                // If no value has been found, don't define the pageSize value.
                                action.metadata.on('end', function() {
                                    resolve({
                                        metadata: {}
                                    });
                                });
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfMetadataExtractHydraPagesize;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractHydraPagesize = $7ee47fa311d0cfbb$var$ActorRdfMetadataExtractHydraPagesize;

});


parcelRegister("4F2wW", function(module, exports) {
"use strict";
var $364cf43408f54860$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $364cf43408f54860$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $364cf43408f54860$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$364cf43408f54860$var$__exportStar((parcelRequire("jW0ER")), module.exports);

});
parcelRegister("jW0ER", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractRequestTime = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Request Time RDF Metadata Extract Actor.
 */ var $e833f1c8cd6896eb$var$ActorRdfMetadataExtractRequestTime = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractRequestTime, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractRequestTime(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractRequestTime);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractRequestTime, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractRequestTime, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                metadata: {
                                    requestTime: action.requestTime
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataExtractRequestTime;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractRequestTime = $e833f1c8cd6896eb$var$ActorRdfMetadataExtractRequestTime;

});


parcelRegister("4FR6v", function(module, exports) {
"use strict";
var $36742f1cff4bf4f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $36742f1cff4bf4f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $36742f1cff4bf4f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$36742f1cff4bf4f8$var$__exportStar((parcelRequire("8swti")), module.exports);

});
parcelRegister("8swti", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractAllowHttpMethods = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Allow HTTP Methods RDF Metadata Extract Actor.
 */ var $628a206debce55a3$var$ActorRdfMetadataExtractAllowHttpMethods = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractAllowHttpMethods, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractAllowHttpMethods(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractAllowHttpMethods);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractAllowHttpMethods, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractAllowHttpMethods, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_headers, _action_headers_get, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadata = {};
                        if ((_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : _action_headers.get('allow')) metadata.allowHttpMethods = (_action_headers_get = action.headers.get('allow')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.split(RegExp(", *", "u"));
                        return [
                            2,
                            {
                                metadata: metadata
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataExtractAllowHttpMethods;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractAllowHttpMethods = $628a206debce55a3$var$ActorRdfMetadataExtractAllowHttpMethods;

});


parcelRegister("3yj2a", function(module, exports) {
"use strict";
var $29634fd29e529abb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29634fd29e529abb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29634fd29e529abb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29634fd29e529abb$var$__exportStar((parcelRequire("di3qh")), module.exports);

});
parcelRegister("di3qh", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractPutAccepted = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica PUT Accepted RDF Metadata Extract Actor.
 */ var $9acf9c7d4e24ac56$var$ActorRdfMetadataExtractPutAccepted = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractPutAccepted, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractPutAccepted(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractPutAccepted);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractPutAccepted, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractPutAccepted, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_headers, _action_headers_get, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadata = {};
                        if ((_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : _action_headers.get('accept-put')) metadata.putAccepted = (_action_headers_get = action.headers.get('accept-put')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.split(RegExp(", *", "u"));
                        return [
                            2,
                            {
                                metadata: metadata
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataExtractPutAccepted;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractPutAccepted = $9acf9c7d4e24ac56$var$ActorRdfMetadataExtractPutAccepted;

});


parcelRegister("kG9HC", function(module, exports) {
"use strict";
var $f0df419a10680113$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0df419a10680113$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0df419a10680113$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0df419a10680113$var$__exportStar((parcelRequire("laQxo")), module.exports);

});
parcelRegister("laQxo", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractPatchSparqlUpdate = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Patch SPARQL Update RDF Metadata Extract Actor.
 */ var $f6a349073ed8cc01$var$ActorRdfMetadataExtractPatchSparqlUpdate = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractPatchSparqlUpdate, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractPatchSparqlUpdate(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractPatchSparqlUpdate);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractPatchSparqlUpdate, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractPatchSparqlUpdate, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_headers_get, _action_headers, _action_headers_get1, _action_headers1, metadata, _action_headers_get_includes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadata = {};
                        // The ms-author-via header is added for backwards-compatibility with old Solid servers
                        if ((_action_headers_get_includes = (_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : (_action_headers_get = _action_headers.get('accept-patch')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.includes('application/sparql-update')) !== null && _action_headers_get_includes !== void 0 ? _action_headers_get_includes : (_action_headers1 = action.headers) === null || _action_headers1 === void 0 ? void 0 : (_action_headers_get1 = _action_headers1.get('ms-author-via')) === null || _action_headers_get1 === void 0 ? void 0 : _action_headers_get1.includes('SPARQL')) metadata.patchSparqlUpdate = true;
                        return [
                            2,
                            {
                                metadata: metadata
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataExtractPatchSparqlUpdate;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractPatchSparqlUpdate = $f6a349073ed8cc01$var$ActorRdfMetadataExtractPatchSparqlUpdate;

});


parcelRegister("h1Oj6", function(module, exports) {
"use strict";
var $c6598d9842505da7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6598d9842505da7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c6598d9842505da7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c6598d9842505da7$var$__exportStar((parcelRequire("3jDTX")), module.exports);

});
parcelRegister("3jDTX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractSparqlService = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");

var $hDpjF = parcelRequire("hDpjF");
/**
 * Comunica RDF metadata extract actor for SPARQL Service Descriptions.
 */ var $26a2190f117e6734$var$ActorRdfMetadataExtractSparqlService = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractSparqlService, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractSparqlService(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractSparqlService);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractSparqlService, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractSparqlService, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                // Forward errors
                                action.metadata.on('error', reject);
                                // Filter the subject URIs to consider, to avoid picking up unrelated entries
                                var acceptSubjectUris = new Set([
                                    action.url
                                ]);
                                var metadata = {};
                                var inputFormats = new Set();
                                var resultFormats = new Set();
                                var supportedLanguages = new Set();
                                action.metadata.on('data', function(quad) {
                                    if (quad.predicate.value === 'http://rdfs.org/ns/void#subset' && quad.object.value === action.url) // When the requested URI is a subset of another dataset, as indicated by this predicate, then also
                                    // consider that other dataset for the extraction of the following predicate values.
                                    // This works an issue with Quad Pattern Fragments that has the sd:defaultGraph predicate associated
                                    // with a subject value that is neither the data source URI nor the sd:defaultDataset.
                                    acceptSubjectUris.add(quad.subject.value);
                                    else if (quad.subject.value === metadata.defaultDataset || quad.subject.termType === 'BlankNode' || acceptSubjectUris.has(quad.subject.value)) switch(quad.predicate.value){
                                        case 'http://www.w3.org/ns/sparql-service-description#endpoint':
                                            // The VoID specification defines this as IRI, but does not specify whether or not it can be a literal.
                                            // When the IRI is a literal, it can be relative, and needs to be resolved to absolute value.
                                            metadata.sparqlService = quad.object.termType === 'Literal' ? (0, $hDpjF.resolve)(quad.object.value, action.url) : quad.object.value;
                                            // Also fix a common mistake in SPARQL endpoint setups where HTTPS SD's refer to a non-existing HTTP API.
                                            if (_this.inferHttpsEndpoint && action.url.startsWith('https') && !quad.object.value.startsWith('https')) metadata.sparqlService = metadata.sparqlService.replace(RegExp("^http:", "u"), 'https:');
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#defaultDataset':
                                            metadata.defaultDataset = quad.object.value;
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#defaultGraph':
                                            metadata.defaultGraph = quad.object.value;
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#inputFormat':
                                            inputFormats.add(quad.object.value);
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#resultFormat':
                                            resultFormats.add(quad.object.value);
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#supportedLanguage':
                                            supportedLanguages.add(quad.object.value);
                                            break;
                                        case 'http://www.w3.org/ns/sparql-service-description#feature':
                                            if (quad.object.value === 'http://www.w3.org/ns/sparql-service-description#UnionDefaultGraph') metadata.unionDefaultGraph = true;
                                            else if (quad.object.value === 'http://www.w3.org/ns/sparql-service-description#BasicFederatedQuery') metadata.basicFederatedQuery = true;
                                            break;
                                    }
                                });
                                // Only return the metadata if an endpoint IRI was discovered
                                action.metadata.on('end', function() {
                                    resolve({
                                        metadata: (0, $iT0je._)({}, metadata, inputFormats.size > 0 ? {
                                            inputFormats: (0, $7WNf6._)(inputFormats.values())
                                        } : {}, resultFormats.size > 0 ? {
                                            resultFormats: (0, $7WNf6._)(resultFormats.values())
                                        } : {}, supportedLanguages.size > 0 ? {
                                            supportedLanguages: (0, $7WNf6._)(supportedLanguages.values())
                                        } : {})
                                    });
                                });
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfMetadataExtractSparqlService;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractSparqlService = $26a2190f117e6734$var$ActorRdfMetadataExtractSparqlService;

});


parcelRegister("hqvPN", function(module, exports) {
"use strict";
var $03462777cc903fd7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03462777cc903fd7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $03462777cc903fd7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$03462777cc903fd7$var$__exportStar((parcelRequire("3we31")), module.exports);

});
parcelRegister("3we31", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractVoid = void 0;

var $d0T0u = parcelRequire("d0T0u");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");

var $1yzcZ = parcelRequire("1yzcZ");

var $aaIo2 = parcelRequire("aaIo2");
/**
 * A comunica Void RDF Metadata Extract Actor.
 */ var $28ff41d89b0ef8ab$var$ActorRdfMetadataExtractVoid = /*#__PURE__*/ function(_bus_rdf_metadata_extract_1_ActorRdfMetadataExtract) {
    (0, $i3fW3._)(ActorRdfMetadataExtractVoid, _bus_rdf_metadata_extract_1_ActorRdfMetadataExtract);
    function ActorRdfMetadataExtractVoid(args) {
        (0, $jGAMp._)(this, ActorRdfMetadataExtractVoid);
        return (0, $kzDuW._)(this, ActorRdfMetadataExtractVoid, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfMetadataExtractVoid, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                // Track the URIs of identified datasets to extract or ignore
                                var datasetUris = new Set();
                                var ignoredUris = new Set();
                                // Track the other stats per-URI to allow arbitrary triple ordering in the stream
                                var triples = {};
                                var entities = {};
                                var vocabularies = {};
                                var classes = {};
                                var distinctObjects = {};
                                var distinctSubjects = {};
                                var uriRegexPatterns = {};
                                var propertyPartitions = {};
                                var propertyPartitionProperties = {};
                                var classPartitions = {};
                                var classPartitionClasses = {};
                                // Default dataset and graph to remove in case of sd:UnionDefaultGraph
                                var defaultDatasetUri;
                                var defaultGraphUri;
                                var unionDefaultGraph = false;
                                action.metadata.on('error', reject).on('data', function(quad) {
                                    switch(quad.predicate.value){
                                        case $1yzcZ.RDF_TYPE:
                                            if (quad.object.value === $1yzcZ.SD_GRAPH || quad.object.value === $1yzcZ.VOID_DATASET) datasetUris.add(quad.subject.value);
                                            break;
                                        case $1yzcZ.VOID_TRIPLES:
                                            triples[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                                            break;
                                        case $1yzcZ.VOID_ENTITIES:
                                            entities[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                                            break;
                                        case $1yzcZ.VOID_CLASSES:
                                            classes[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                                            break;
                                        case $1yzcZ.VOID_CLASS:
                                            classPartitionClasses[quad.subject.value] = quad.object.value;
                                            break;
                                        case $1yzcZ.VOID_PROPERTY:
                                            propertyPartitionProperties[quad.subject.value] = quad.object.value;
                                            break;
                                        case $1yzcZ.VOID_DISTINCT_OBJECTS:
                                            distinctObjects[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                                            break;
                                        case $1yzcZ.VOID_DISTINCT_SUBJECTS:
                                            distinctSubjects[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                                            break;
                                        case $1yzcZ.VOID_VOCABULARY:
                                            if (vocabularies[quad.subject.value]) vocabularies[quad.subject.value].push(quad.object.value);
                                            else vocabularies[quad.subject.value] = [
                                                quad.object.value
                                            ];
                                            break;
                                        case $1yzcZ.VOID_URI_SPACE:
                                            if (!uriRegexPatterns[quad.subject.value]) uriRegexPatterns[quad.subject.value] = new RegExp("^".concat(quad.object.value), 'u');
                                            break;
                                        case $1yzcZ.VOID_URI_REGEX_PATTERN:
                                            uriRegexPatterns[quad.subject.value] = new RegExp(quad.object.value, 'u');
                                            break;
                                        case $1yzcZ.VOID_PROPERTY_PARTITION:
                                            ignoredUris.add(quad.object.value);
                                            if (propertyPartitions[quad.subject.value]) propertyPartitions[quad.subject.value].push(quad.object.value);
                                            else propertyPartitions[quad.subject.value] = [
                                                quad.object.value
                                            ];
                                            break;
                                        case $1yzcZ.VOID_CLASS_PARTITION:
                                            ignoredUris.add(quad.object.value);
                                            if (classPartitions[quad.subject.value]) classPartitions[quad.subject.value].push(quad.object.value);
                                            else classPartitions[quad.subject.value] = [
                                                quad.object.value
                                            ];
                                            break;
                                        case $1yzcZ.SD_DEFAULT_DATASET:
                                            defaultDatasetUri = quad.object.value;
                                            break;
                                        case $1yzcZ.SD_DEFAULT_GRAPH:
                                            defaultGraphUri = quad.object.value;
                                            break;
                                        case $1yzcZ.SD_FEATURE:
                                            if (quad.object.value === $1yzcZ.SD_UNION_DEFAULT_GRAPH) unionDefaultGraph = true;
                                            break;
                                    }
                                }).on('end', function() {
                                    var datasets = [];
                                    // Helper function to extract property partitions into a map
                                    var getPropertyPartitions = function(uri) {
                                        var partitions = {};
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = propertyPartitions[uri][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var partitionUri = _step.value;
                                                var propertyUri = propertyPartitionProperties[partitionUri];
                                                if (propertyUri) partitions[propertyUri] = {
                                                    distinctObjects: distinctObjects[partitionUri],
                                                    distinctSubjects: distinctSubjects[partitionUri],
                                                    triples: triples[partitionUri]
                                                };
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return partitions;
                                    };
                                    // Helper function to extract class partitions into a map
                                    var getClassPartitions = function(uri) {
                                        var partitions = {};
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = classPartitions[uri][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var partitionUri = _step.value;
                                                var classUri = classPartitionClasses[partitionUri];
                                                if (classUri) partitions[classUri] = {
                                                    entities: entities[partitionUri],
                                                    propertyPartitions: propertyPartitions[partitionUri] ? getPropertyPartitions(partitionUri) : undefined
                                                };
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return partitions;
                                    };
                                    // Always ignore intermediate default dataset
                                    if (defaultDatasetUri) ignoredUris.add(defaultDatasetUri);
                                    // Ignore default graph URI when union default graph is set
                                    if (unionDefaultGraph && defaultGraphUri) ignoredUris.add(defaultGraphUri);
                                    var _vocabularies_defaultGraphUri;
                                    // Propagate vocabularies from higher level datasets to lower-level
                                    if (defaultDatasetUri && defaultGraphUri && vocabularies[defaultDatasetUri]) vocabularies[defaultGraphUri] = (0, $7WNf6._)((_vocabularies_defaultGraphUri = vocabularies[defaultGraphUri]) !== null && _vocabularies_defaultGraphUri !== void 0 ? _vocabularies_defaultGraphUri : []).concat((0, $7WNf6._)(vocabularies[defaultDatasetUri]));
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        // Delete all the to-be-ignored datasets, such as property and class partitions
                                        for(var _iterator = ignoredUris[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var uri = _step.value;
                                            datasetUris["delete"](uri);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        var _loop = function() {
                                            var uri = _step1.value;
                                            // Only the VoID descriptions with triple counts and class or property partitions are actually useful,
                                            // and any other ones would contain insufficient information to use in estimation, as the formulae
                                            // would go to 0 for most estimations.
                                            if (triples[uri]) {
                                                var _classPartitions_uri;
                                                var _classes_uri, _ref;
                                                var dataset = {
                                                    entities: entities[uri],
                                                    identifier: uri,
                                                    classes: (_ref = (_classes_uri = classes[uri]) !== null && _classes_uri !== void 0 ? _classes_uri : (_classPartitions_uri = classPartitions[uri]) === null || _classPartitions_uri === void 0 ? void 0 : _classPartitions_uri.length) !== null && _ref !== void 0 ? _ref : 0,
                                                    classPartitions: classPartitions[uri] ? getClassPartitions(uri) : undefined,
                                                    distinctObjects: distinctObjects[uri],
                                                    distinctSubjects: distinctSubjects[uri],
                                                    propertyPartitions: propertyPartitions[uri] ? getPropertyPartitions(uri) : undefined,
                                                    triples: triples[uri],
                                                    uriRegexPattern: uriRegexPatterns[uri],
                                                    vocabularies: vocabularies[uri]
                                                };
                                                datasets.push({
                                                    uri: uri,
                                                    source: action.url,
                                                    getCardinality: function(operation) {
                                                        if (operation.type === $hSHd8.Algebra.types.PATTERN) return (0, $emQHU._)((0, $iT0je._)({}, (0, $aaIo2.estimatePatternCardinality)(dataset, operation)), {
                                                            dataset: uri
                                                        });
                                                    }
                                                });
                                            }
                                        };
                                        for(var _iterator1 = datasetUris[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                                _iterator1["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    resolve({
                                        metadata: datasets.length > 0 ? {
                                            datasets: datasets
                                        } : {}
                                    });
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfMetadataExtractVoid;
}($d0T0u.ActorRdfMetadataExtract);
module.exports.ActorRdfMetadataExtractVoid = $28ff41d89b0ef8ab$var$ActorRdfMetadataExtractVoid;

});
parcelRegister("1yzcZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VOID_CLASS_PARTITION = module.exports.VOID_PROPERTY_PARTITION = module.exports.VOID_DISTINCT_SUBJECTS = module.exports.VOID_DISTINCT_OBJECTS = module.exports.VOID_URI_REGEX_PATTERN = module.exports.VOID_URI_SPACE = module.exports.VOID_VOCABULARY = module.exports.VOID_PROPERTY = module.exports.VOID_CLASS = module.exports.VOID_ENTITIES = module.exports.VOID_TRIPLES = module.exports.VOID_CLASSES = module.exports.VOID_DATASET = module.exports.VOID = module.exports.SD_GRAPH = module.exports.SD_FEATURE = module.exports.SD_UNION_DEFAULT_GRAPH = module.exports.SD_DEFAULT_GRAPH = module.exports.SD_DEFAULT_DATASET = module.exports.SD = module.exports.RDF_TYPE = void 0;
module.exports.RDF_TYPE = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';
module.exports.SD = 'http://www.w3.org/ns/sparql-service-description#';
module.exports.SD_DEFAULT_DATASET = "".concat(module.exports.SD, "defaultDataset");
module.exports.SD_DEFAULT_GRAPH = "".concat(module.exports.SD, "defaultGraph");
module.exports.SD_UNION_DEFAULT_GRAPH = "".concat(module.exports.SD, "UnionDefaultGraph");
module.exports.SD_FEATURE = "".concat(module.exports.SD, "feature");
module.exports.SD_GRAPH = "".concat(module.exports.SD, "Graph");
module.exports.VOID = 'http://rdfs.org/ns/void#';
module.exports.VOID_DATASET = "".concat(module.exports.VOID, "Dataset");
module.exports.VOID_CLASSES = "".concat(module.exports.VOID, "classes");
module.exports.VOID_TRIPLES = "".concat(module.exports.VOID, "triples");
module.exports.VOID_ENTITIES = "".concat(module.exports.VOID, "entities");
module.exports.VOID_CLASS = "".concat(module.exports.VOID, "class");
module.exports.VOID_PROPERTY = "".concat(module.exports.VOID, "property");
module.exports.VOID_VOCABULARY = "".concat(module.exports.VOID, "vocabulary");
module.exports.VOID_URI_SPACE = "".concat(module.exports.VOID, "uriSpace");
module.exports.VOID_URI_REGEX_PATTERN = "".concat(module.exports.VOID, "uriRegexPattern");
module.exports.VOID_DISTINCT_OBJECTS = "".concat(module.exports.VOID, "distinctSubjects");
module.exports.VOID_DISTINCT_SUBJECTS = "".concat(module.exports.VOID, "distinctObjects");
module.exports.VOID_PROPERTY_PARTITION = "".concat(module.exports.VOID, "propertyPartition");
module.exports.VOID_CLASS_PARTITION = "".concat(module.exports.VOID, "classPartition");

});

parcelRegister("aaIo2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getClassPartitionEntities = module.exports.getPredicateTriples = module.exports.getPredicateSubjects = module.exports.getPredicateObjects = module.exports.getDistinctSubjects = module.exports.getDistinctObjects = module.exports.estimatePatternCardinalityRaw = module.exports.matchPatternVocabularies = module.exports.matchPatternResourceUris = module.exports.estimatePatternCardinality = void 0;

var $1yzcZ = parcelRequire("1yzcZ");
/**
 * Estimate triple pattern cardinality, by first applying heuristics based on void:uriPatternRegex
 * and void:vocabulary data when available, before performing estimations using the formulae.
 */ function $767d44d8552d455c$var$estimatePatternCardinality(dataset, pattern) {
    var estimate = {
        type: 'exact',
        value: 0
    };
    if ($767d44d8552d455c$var$matchPatternVocabularies(dataset, pattern) && $767d44d8552d455c$var$matchPatternResourceUris(dataset, pattern)) {
        var value = $767d44d8552d455c$var$estimatePatternCardinalityRaw(dataset, pattern);
        if (value > 0) {
            estimate.value = value;
            estimate.type = 'estimate';
        }
    }
    return estimate;
}
module.exports.estimatePatternCardinality = $767d44d8552d455c$var$estimatePatternCardinality;
/**
 * Test whether the given albegra pattern could produce answers from a dataset with the specified resourceUriPattern.
 * Specifically, if both subject and object are IRIs, but neither matches the resourceUriPattern,
 * then the dataset does not contain any RDF resources that would satisfy the pattern.
 */ function $767d44d8552d455c$var$matchPatternResourceUris(dataset, pattern) {
    return !dataset.uriRegexPattern || pattern.subject.termType !== 'NamedNode' || dataset.uriRegexPattern.test(pattern.subject.value) || pattern.object.termType !== 'NamedNode' || dataset.uriRegexPattern.test(pattern.object.value);
}
module.exports.matchPatternResourceUris = $767d44d8552d455c$var$matchPatternResourceUris;
/**
 * Test whether the given algebra pattern could produce answers from a dataset with the specified vocabularies.
 * Specifically, if the predicate if an IRI but it does not use any of the specifiec vocabularies,
 * then the pattern cannot be answered by the dataset.
 */ function $767d44d8552d455c$var$matchPatternVocabularies(dataset, pattern) {
    if (dataset.vocabularies !== undefined && pattern.predicate.termType === 'NamedNode') return dataset.vocabularies.some(function(vc) {
        return pattern.predicate.value.startsWith(vc);
    });
    return true;
}
module.exports.matchPatternVocabularies = $767d44d8552d455c$var$matchPatternVocabularies;
/**
 * Estimate the triple pattern cardinality using the formulae from Hagedorn, Stefan, et al.
 * "Resource Planning for SPARQL Query Execution on Data Sharing Platforms." COLD 1264 (2014)
 */ function $767d44d8552d455c$var$estimatePatternCardinalityRaw(dataset, pattern) {
    // ?s rdf:type <o> (from the original paper)
    // ?s rdf:type _:o (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && pattern.predicate.value === $1yzcZ.RDF_TYPE && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) return $767d44d8552d455c$var$getClassPartitionEntities(dataset, pattern.object);
    // ?s ?p ?o (from the original paper)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'Variable' && pattern.object.termType === 'Variable') return dataset.triples;
    // <s> ?p ?o (from the original paper)
    // _:s ?p ?o (also accounted for)
    // <s> ?p "o"
    // _:s ?p "o"
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) {
        var distinctSubjects = $767d44d8552d455c$var$getDistinctSubjects(dataset);
        if (distinctSubjects > 0) return dataset.triples / distinctSubjects;
    }
    // ?s <p> ?o (from the original paper)
    // ?s <p> "o" (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) return $767d44d8552d455c$var$getPredicateTriples(dataset, pattern.predicate);
    // ?s ?p <o> (from the original paper)
    // ?s ?p _:o (also accounted for)
    // ?s ?p "o"
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode' || pattern.object.termType === 'Literal')) {
        var distinctObjects = $767d44d8552d455c$var$getDistinctObjects(dataset);
        if (distinctObjects > 0) return dataset.triples / distinctObjects;
    }
    // <s> <p> ?o (from the original paper)
    // _:s <p> ?o (also accounted for)
    // <s> <p> "o"
    // _:s <p> "o"
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) {
        var predicateTriples = $767d44d8552d455c$var$getPredicateTriples(dataset, pattern.predicate);
        var predicateSubjects = $767d44d8552d455c$var$getPredicateSubjects(dataset, pattern.predicate);
        return predicateSubjects > 0 ? predicateTriples / predicateSubjects : predicateTriples;
    }
    // <s> ?p <o> (from the original paper)
    // _:s ?p _:o (also accounted for)
    // _:s ?p <o>
    // <s> ?p _:o
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        var distinctSubjects1 = $767d44d8552d455c$var$getDistinctSubjects(dataset);
        var distinctObjects1 = $767d44d8552d455c$var$getDistinctObjects(dataset);
        if (distinctSubjects1 > 0 && distinctObjects1 > 0) return dataset.triples / (distinctSubjects1 * distinctObjects1);
    }
    // ?s <p> <o> (from the original paper)
    // ?s <p> _:o (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        var predicateTriples1 = $767d44d8552d455c$var$getPredicateTriples(dataset, pattern.predicate);
        var predicateObjects = $767d44d8552d455c$var$getPredicateObjects(dataset, pattern.predicate);
        return predicateObjects > 0 ? predicateTriples1 / predicateObjects : predicateTriples1;
    }
    // <s> <p> <o> (from the original paper)
    // _:s <p> _:o (also accounted for)
    // <s> <p> _:o
    // _:s <p> <o>
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        var predicateTriples2 = $767d44d8552d455c$var$getPredicateTriples(dataset, pattern.predicate);
        var predicateSubjects1 = $767d44d8552d455c$var$getPredicateSubjects(dataset, pattern.predicate);
        var predicateObjects1 = $767d44d8552d455c$var$getPredicateObjects(dataset, pattern.predicate);
        return predicateSubjects1 > 0 && predicateObjects1 > 0 ? predicateTriples2 / (predicateSubjects1 * predicateObjects1) : predicateTriples2;
    }
    // In all other cases, return the total triple count as absolute upper bound
    return dataset.triples;
}
module.exports.estimatePatternCardinalityRaw = $767d44d8552d455c$var$estimatePatternCardinalityRaw;
/**
 * Attempts to retrieve void:distinctObjects, falls back to void:entities.
 * Returns the total triple count as fallback upper bound.
 */ function $767d44d8552d455c$var$getDistinctObjects(dataset) {
    var _dataset_distinctObjects, _ref;
    return (_ref = (_dataset_distinctObjects = dataset.distinctObjects) !== null && _dataset_distinctObjects !== void 0 ? _dataset_distinctObjects : dataset.entities) !== null && _ref !== void 0 ? _ref : dataset.triples;
}
module.exports.getDistinctObjects = $767d44d8552d455c$var$getDistinctObjects;
/**
 * Attempts to retrieve void:distinctSubjects, falls back to void:entities.
 * Returns the total triple count as fallback upper bound.
 */ function $767d44d8552d455c$var$getDistinctSubjects(dataset) {
    var _dataset_distinctSubjects, _ref;
    return (_ref = (_dataset_distinctSubjects = dataset.distinctSubjects) !== null && _dataset_distinctSubjects !== void 0 ? _dataset_distinctSubjects : dataset.entities) !== null && _ref !== void 0 ? _ref : dataset.triples;
}
module.exports.getDistinctSubjects = $767d44d8552d455c$var$getDistinctSubjects;
/**
 * Attempts to retrieve void:distinctObjects from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $767d44d8552d455c$var$getPredicateObjects(dataset, predicate) {
    if (dataset.propertyPartitions) {
        var partition = dataset.propertyPartitions[predicate.value];
        var _partition_distinctObjects, _ref;
        return (_ref = (_partition_distinctObjects = partition === null || partition === void 0 ? void 0 : partition.distinctObjects) !== null && _partition_distinctObjects !== void 0 ? _partition_distinctObjects : partition === null || partition === void 0 ? void 0 : partition.triples) !== null && _ref !== void 0 ? _ref : 0;
    }
    return dataset.triples;
}
module.exports.getPredicateObjects = $767d44d8552d455c$var$getPredicateObjects;
/**
 * Attempts to retrieve void:distinctSubjects from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $767d44d8552d455c$var$getPredicateSubjects(dataset, predicate) {
    if (dataset.propertyPartitions) {
        var partition = dataset.propertyPartitions[predicate.value];
        var _partition_distinctSubjects, _ref;
        return (_ref = (_partition_distinctSubjects = partition === null || partition === void 0 ? void 0 : partition.distinctSubjects) !== null && _partition_distinctSubjects !== void 0 ? _partition_distinctSubjects : partition === null || partition === void 0 ? void 0 : partition.triples) !== null && _ref !== void 0 ? _ref : 0;
    }
    return dataset.triples;
}
module.exports.getPredicateSubjects = $767d44d8552d455c$var$getPredicateSubjects;
/**
 * Attempts to retrieve void:triples from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $767d44d8552d455c$var$getPredicateTriples(dataset, predicate) {
    var _dataset_propertyPartitions_predicate_value;
    var _dataset_propertyPartitions_predicate_value_triples;
    if (dataset.propertyPartitions) return (_dataset_propertyPartitions_predicate_value_triples = (_dataset_propertyPartitions_predicate_value = dataset.propertyPartitions[predicate.value]) === null || _dataset_propertyPartitions_predicate_value === void 0 ? void 0 : _dataset_propertyPartitions_predicate_value.triples) !== null && _dataset_propertyPartitions_predicate_value_triples !== void 0 ? _dataset_propertyPartitions_predicate_value_triples : 0;
    return dataset.triples;
}
module.exports.getPredicateTriples = $767d44d8552d455c$var$getPredicateTriples;
/**
 * Attempts to retrieve void:entities from a void:classPartition.
 * Returns 0 when class partitions are available but the specified class is not.
 * Falls back to estimation using void:entities and void:classes on the dataset,
 * and finally total dataset triple count as upper bound.
 */ function $767d44d8552d455c$var$getClassPartitionEntities(dataset, object) {
    var _dataset_classPartitions_object_value;
    var _dataset_classPartitions_object_value_entities;
    if (dataset.classPartitions) return (_dataset_classPartitions_object_value_entities = (_dataset_classPartitions_object_value = dataset.classPartitions[object.value]) === null || _dataset_classPartitions_object_value === void 0 ? void 0 : _dataset_classPartitions_object_value.entities) !== null && _dataset_classPartitions_object_value_entities !== void 0 ? _dataset_classPartitions_object_value_entities : 0;
    if (dataset.entities !== undefined && dataset.classes) return dataset.entities / dataset.classes;
    return dataset.triples;
}
module.exports.getClassPartitionEntities = $767d44d8552d455c$var$getClassPartitionEntities;

});



parcelRegister("lrPxK", function(module, exports) {
"use strict";
var $f9d41a06f1a5acd1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f9d41a06f1a5acd1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f9d41a06f1a5acd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f9d41a06f1a5acd1$var$__exportStar((parcelRequire("l0ekq")), module.exports);

});
parcelRegister("l0ekq", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseN3 = void 0;

var $1Nxez = parcelRequire("1Nxez");

var $9nBhR = parcelRequire("9nBhR");
parcelRequire("29pVS");
var $7dmRm = parcelRequire("7dmRm");
/**
 * An N3 RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to parse N3-based RDF serializations and announce the presence of them by media type.
 */ var $f4a4b65f329bafa7$var$ActorRdfParseN3 = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseN3, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseN3(args) {
        (0, $jGAMp._)(this, ActorRdfParseN3);
        return (0, $kzDuW._)(this, ActorRdfParseN3, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseN3, [
        {
            key: "runHandle",
            value: function runHandle(action, mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_metadata, dataFactory, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        action.data.on('error', function(error) {
                            return data.emit('error', error);
                        });
                        data = action.data.pipe(new $7dmRm.default({
                            factory: dataFactory,
                            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI,
                            // Enable RDF-star-mode on all formats, except N3, where this is not supported.
                            format: mediaType.endsWith('n3') ? mediaType : "".concat(mediaType, "*")
                        }));
                        return [
                            2,
                            {
                                data: data,
                                metadata: {
                                    triples: mediaType === 'text/turtle' || mediaType === 'application/n-triples' || mediaType === 'text/n3'
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseN3;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseN3 = $f4a4b65f329bafa7$var$ActorRdfParseN3;

});
parcelRegister("1Nxez", function(module, exports) {
"use strict";
var $14f425a7c1cba672$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14f425a7c1cba672$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $14f425a7c1cba672$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$14f425a7c1cba672$var$__exportStar((parcelRequire("9AKqh")), module.exports);

$14f425a7c1cba672$var$__exportStar((parcelRequire("9IUNV")), module.exports);

});
parcelRegister("9AKqh", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParse = void 0;

var $2T5vf = parcelRequire("2T5vf");
/**
 * A base actor for listening to RDF parse events.
 *
 * Actor types:
 * * Input:  IActionRdfParseOrMediaType:      A parse input or a media type input.
 * * Test:   <none>
 * * Output: IActorOutputRdfParseOrMediaType: The parsed quads.
 *
 * @see IActionInit
 */ var $6fbb7c7a64bef455$var$ActorRdfParse = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTyped) {
    (0, $i3fW3._)(ActorRdfParse, _actor_abstract_mediatyped_1_ActorAbstractMediaTyped);
    function ActorRdfParse(args) {
        (0, $jGAMp._)(this, ActorRdfParse);
        return (0, $kzDuW._)(this, ActorRdfParse, [
            args
        ]);
    }
    return ActorRdfParse;
}($2T5vf.ActorAbstractMediaTyped);
module.exports.ActorRdfParse = $6fbb7c7a64bef455$var$ActorRdfParse;

});

parcelRegister("9IUNV", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseFixedMediaTypes = void 0;

var $2T5vf = parcelRequire("2T5vf");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A base actor for listening to RDF parse events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionRdfParseOrMediaType:      A parse input or a media type input.
 * * Test:   <none>
 * * Output: IActorOutputRdfParseOrMediaType: The parsed quads.
 *
 * @see IActionInit
 */ var $7144493dbc34babe$var$ActorRdfParseFixedMediaTypes = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed) {
    (0, $i3fW3._)(ActorRdfParseFixedMediaTypes, _actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed);
    function ActorRdfParseFixedMediaTypes(args) {
        (0, $jGAMp._)(this, ActorRdfParseFixedMediaTypes);
        return (0, $kzDuW._)(this, ActorRdfParseFixedMediaTypes, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseFixedMediaTypes, [
        {
            key: "testHandleChecked",
            value: /* eslint-enable max-len */ function testHandleChecked(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseFixedMediaTypes;
}($2T5vf.ActorAbstractMediaTypedFixed);
module.exports.ActorRdfParseFixedMediaTypes = $7144493dbc34babe$var$ActorRdfParseFixedMediaTypes;

});


parcelRegister("29pVS", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("4lFIc")).default; });
$parcel$export(module.exports, "Writer", function () { return (parcelRequire("cfNAJ")).default; });
$parcel$export(module.exports, "Store", function () { return (parcelRequire("6rfrN")).default; });
$parcel$export(module.exports, "StreamParser", function () { return (parcelRequire("7dmRm")).default; });
$parcel$export(module.exports, "StreamWriter", function () { return (parcelRequire("fmFF3")).default; });
$parcel$export(module.exports, "DataFactory", function () { return (parcelRequire("ha9LD")).default; });
$parcel$export(module.exports, "NamedNode", function () { return (parcelRequire("ha9LD")).NamedNode; });

var $ytNSi = parcelRequire("ytNSi");

var $4lFIc = parcelRequire("4lFIc");

var $cfNAJ = parcelRequire("cfNAJ");

var $6rfrN = parcelRequire("6rfrN");

var $bKr1e = parcelRequire("bKr1e");

var $fsKxa = parcelRequire("fsKxa");

var $7dmRm = parcelRequire("7dmRm");

var $fmFF3 = parcelRequire("fmFF3");

var $3VMHQ = parcelRequire("3VMHQ");

var $7ijlK = parcelRequire("7ijlK");

var $ha9LD = parcelRequire("ha9LD");
var // Export all named exports as a default object for backward compatibility
$191089ae7f63c85b$export$2e2bcd8739ae039 = {
    Lexer: (0, $ytNSi.default),
    Parser: (0, $4lFIc.default),
    Writer: (0, $cfNAJ.default),
    Store: (0, $6rfrN.default),
    StoreFactory: (0, $bKr1e.default),
    EntityIndex: (0, $6rfrN.N3EntityIndex),
    StreamParser: (0, $7dmRm.default),
    StreamWriter: (0, $fmFF3.default),
    Util: $3VMHQ,
    Reasoner: (0, $fsKxa.default),
    BaseIRI: (0, $7ijlK.default),
    DataFactory: (0, $ha9LD.default),
    Term: (0, $ha9LD.Term),
    NamedNode: (0, $ha9LD.NamedNode),
    Literal: (0, $ha9LD.Literal),
    BlankNode: (0, $ha9LD.BlankNode),
    Variable: (0, $ha9LD.Variable),
    DefaultGraph: (0, $ha9LD.DefaultGraph),
    Quad: (0, $ha9LD.Quad),
    Triple: (0, $ha9LD.Triple),
    termFromId: (0, $ha9LD.termFromId),
    termToId: (0, $ha9LD.termToId)
};

});
parcelRegister("ytNSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $067a4b6e4cc70e23$export$2e2bcd8739ae039; });
// **N3Lexer** tokenizes N3 documents.

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $ikzXy = parcelRequire("ikzXy");

var $kEnRi = parcelRequire("kEnRi");
var $067a4b6e4cc70e23$var$xsd = (0, $kEnRi.default).xsd;
// Regular expression and replacement string to escape N3 strings
var $067a4b6e4cc70e23$var$escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
var $067a4b6e4cc70e23$var$escapeReplacements = {
    '\\': '\\',
    "'": "'",
    '"': '"',
    n: '\n',
    r: '\r',
    t: '\t',
    f: '\f',
    b: '\b',
    _: '_',
    '~': '~',
    '.': '.',
    '-': '-',
    '!': '!',
    $: '$',
    '&': '&',
    '(': '(',
    ')': ')',
    '*': '*',
    '+': '+',
    ',': ',',
    ';': ';',
    '=': '=',
    '/': '/',
    '?': '?',
    '#': '#',
    '@': '@',
    '%': '%'
};
var $067a4b6e4cc70e23$var$illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
var $067a4b6e4cc70e23$var$lineModeRegExps = {
    _iri: true,
    _unescapedIri: true,
    _simpleQuotedString: true,
    _langcode: true,
    _blank: true,
    _newline: true,
    _comment: true,
    _whitespace: true,
    _endOfFile: true
};
var $067a4b6e4cc70e23$var$invalidRegExp = /$0^/;
var $067a4b6e4cc70e23$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3Lexer(options) {
        (0, $jGAMp._)(this, N3Lexer);
        // ## Regular expressions
        // It's slightly faster to have these as properties than as in-scope variables
        this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/; // IRI with escape sequences; needs sanity check after unescaping
        this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/; // IRI without escape sequences; no unescaping
        this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/; // string without escape sequences
        this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
        this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
        this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
        this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
        this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
        this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
        this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
        this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
        this._keyword = /^@[a-z]+(?=[\s#<:])/i;
        this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
        this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
        this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
        this._comment = /#([^\n\r]*)/;
        this._whitespace = /^[ \t]+/;
        this._endOfFile = /^(?:#[^\n\r]*)?$/;
        options = options || {};
        // Whether the log:isImpliedBy predicate is supported
        this._isImpliedBy = options.isImpliedBy;
        // In line mode (N-Triples or N-Quads), only simple features may be parsed
        if (this._lineMode = !!options.lineMode) {
            this._n3Mode = false;
            // Don't tokenize special literals
            for(var key in this)if (!(key in $067a4b6e4cc70e23$var$lineModeRegExps) && this[key] instanceof RegExp) this[key] = $067a4b6e4cc70e23$var$invalidRegExp;
        } else this._n3Mode = options.n3 !== false;
        // Don't output comment tokens by default
        this.comments = !!options.comments;
        // Cache the last tested closing position of long literals
        this._literalClosingPos = 0;
    }
    (0, $byiyg._)(N3Lexer, [
        {
            // ## Private methods
            // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
            key: "_tokenizeToEnd",
            value: function _tokenizeToEnd(callback, inputFinished) {
                // Continue parsing as far as possible; the loop will return eventually
                var input = this._input;
                var currentLineLength = input.length;
                while(true){
                    // Count and skip whitespace lines
                    var whiteSpaceMatch = void 0, comment = void 0;
                    while(whiteSpaceMatch = this._newline.exec(input)){
                        // Try to find a comment
                        if (this.comments && (comment = this._comment.exec(whiteSpaceMatch[0]))) emitToken('comment', comment[1], '', this._line, whiteSpaceMatch[0].length);
                        // Advance the input
                        input = input.substr(whiteSpaceMatch[0].length, input.length);
                        currentLineLength = input.length;
                        this._line++;
                    }
                    // Skip whitespace on current line
                    if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input))) input = input.substr(whiteSpaceMatch[0].length, input.length);
                    // Stop for now if we're at the end
                    if (this._endOfFile.test(input)) {
                        // If the input is finished, emit EOF
                        if (inputFinished) {
                            // Try to find a final comment
                            if (this.comments && (comment = this._comment.exec(input))) emitToken('comment', comment[1], '', this._line, input.length);
                            input = null;
                            emitToken('eof', '', '', this._line, 0);
                        }
                        return this._input = input;
                    }
                    // Look for specific token types based on the first character
                    var line = this._line, firstChar = input[0];
                    var type = '', value = '', prefix = '', match = null, matchLength = 0, inconclusive = false;
                    switch(firstChar){
                        case '^':
                            // We need at least 3 tokens lookahead to distinguish ^^<IRI> and ^^pre:fixed
                            if (input.length < 3) break;
                            else if (input[1] === '^') {
                                this._previousMarker = '^^';
                                // Move to type IRI or prefixed name
                                input = input.substr(2);
                                if (input[0] !== '<') {
                                    inconclusive = true;
                                    break;
                                }
                            } else {
                                if (this._n3Mode) {
                                    matchLength = 1;
                                    type = '^';
                                }
                                break;
                            }
                        // Fall through in case the type is an IRI
                        case '<':
                            // Try to find a full IRI without escape sequences
                            if (match = this._unescapedIri.exec(input)) type = 'IRI', value = match[1];
                            else if (match = this._iri.exec(input)) {
                                value = this._unescape(match[1]);
                                if (value === null || $067a4b6e4cc70e23$var$illegalIriChars.test(value)) return reportSyntaxError(this);
                                type = 'IRI';
                            } else if (input.length > 1 && input[1] === '<') type = '<<', matchLength = 2;
                            else if (this._n3Mode && input.length > 1 && input[1] === '=') {
                                matchLength = 2;
                                if (this._isImpliedBy) type = 'abbreviation', value = '<';
                                else type = 'inverse', value = '>';
                            }
                            break;
                        case '>':
                            if (input.length > 1 && input[1] === '>') type = '>>', matchLength = 2;
                            break;
                        case '_':
                            // Try to find a blank node. Since it can contain (but not end with) a dot,
                            // we always need a non-dot character before deciding it is a blank node.
                            // Therefore, try inserting a space if we're at the end of the input.
                            if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec("".concat(input, " ")))) type = 'blank', prefix = '_', value = match[1];
                            break;
                        case '"':
                            // Try to find a literal without escape sequences
                            if (match = this._simpleQuotedString.exec(input)) value = match[1];
                            else {
                                var ref;
                                ref = this._parseLiteral(input), value = ref.value, matchLength = ref.matchLength, ref;
                                if (value === null) return reportSyntaxError(this);
                            }
                            if (match !== null || matchLength !== 0) {
                                type = 'literal';
                                this._literalClosingPos = 0;
                            }
                            break;
                        case "'":
                            if (!this._lineMode) {
                                // Try to find a literal without escape sequences
                                if (match = this._simpleApostropheString.exec(input)) value = match[1];
                                else {
                                    var ref1;
                                    ref1 = this._parseLiteral(input), value = ref1.value, matchLength = ref1.matchLength, ref1;
                                    if (value === null) return reportSyntaxError(this);
                                }
                                if (match !== null || matchLength !== 0) {
                                    type = 'literal';
                                    this._literalClosingPos = 0;
                                }
                            }
                            break;
                        case '?':
                            // Try to find a variable
                            if (this._n3Mode && (match = this._variable.exec(input))) type = 'var', value = match[0];
                            break;
                        case '@':
                            // Try to find a language code
                            if (this._previousMarker === 'literal' && (match = this._langcode.exec(input))) type = 'langcode', value = match[1];
                            else if (match = this._keyword.exec(input)) type = match[0];
                            break;
                        case '.':
                            // Try to find a dot as punctuation
                            if (input.length === 1 ? inputFinished : input[1] < '0' || input[1] > '9') {
                                type = '.';
                                matchLength = 1;
                                break;
                            }
                        // Fall through to numerical case (could be a decimal dot)
                        case '0':
                        case '1':
                        case '2':
                        case '3':
                        case '4':
                        case '5':
                        case '6':
                        case '7':
                        case '8':
                        case '9':
                        case '+':
                        case '-':
                            // Try to find a number. Since it can contain (but not end with) a dot,
                            // we always need a non-dot character before deciding it is a number.
                            // Therefore, try inserting a space if we're at the end of the input.
                            if (match = this._number.exec(input) || inputFinished && (match = this._number.exec("".concat(input, " ")))) {
                                type = 'literal', value = match[0];
                                prefix = typeof match[1] === 'string' ? $067a4b6e4cc70e23$var$xsd["double"] : typeof match[2] === 'string' ? $067a4b6e4cc70e23$var$xsd.decimal : $067a4b6e4cc70e23$var$xsd.integer;
                            }
                            break;
                        case 'B':
                        case 'b':
                        case 'p':
                        case 'P':
                        case 'G':
                        case 'g':
                            // Try to find a SPARQL-style keyword
                            if (match = this._sparqlKeyword.exec(input)) type = match[0].toUpperCase();
                            else inconclusive = true;
                            break;
                        case 'f':
                        case 't':
                            // Try to match a boolean
                            if (match = this._boolean.exec(input)) type = 'literal', value = match[0], prefix = $067a4b6e4cc70e23$var$xsd["boolean"];
                            else inconclusive = true;
                            break;
                        case 'a':
                            // Try to find an abbreviated predicate
                            if (match = this._shortPredicates.exec(input)) type = 'abbreviation', value = 'a';
                            else inconclusive = true;
                            break;
                        case '=':
                            // Try to find an implication arrow or equals sign
                            if (this._n3Mode && input.length > 1) {
                                type = 'abbreviation';
                                if (input[1] !== '>') matchLength = 1, value = '=';
                                else matchLength = 2, value = '>';
                            }
                            break;
                        case '!':
                            if (!this._n3Mode) break;
                        case ',':
                        case ';':
                        case '[':
                        case ']':
                        case '(':
                        case ')':
                        case '}':
                            if (!this._lineMode) {
                                matchLength = 1;
                                type = firstChar;
                            }
                            break;
                        case '{':
                            // We need at least 2 tokens lookahead to distinguish "{|" and "{ "
                            if (!this._lineMode && input.length >= 2) {
                                // Try to find a quoted triple annotation start
                                if (input[1] === '|') type = '{|', matchLength = 2;
                                else type = firstChar, matchLength = 1;
                            }
                            break;
                        case '|':
                            // We need 2 tokens lookahead to parse "|}"
                            // Try to find a quoted triple annotation end
                            if (input.length >= 2 && input[1] === '}') type = '|}', matchLength = 2;
                            break;
                        default:
                            inconclusive = true;
                    }
                    // Some first characters do not allow an immediate decision, so inspect more
                    if (inconclusive) {
                        // Try to find a prefix
                        if ((this._previousMarker === '@prefix' || this._previousMarker === 'PREFIX') && (match = this._prefix.exec(input))) type = 'prefix', value = match[1] || '';
                        else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec("".concat(input, " ")))) type = 'prefixed', prefix = match[1] || '', value = this._unescape(match[2]);
                    }
                    // A type token is special: it can only be emitted after an IRI or prefixed name is read
                    if (this._previousMarker === '^^') switch(type){
                        case 'prefixed':
                            type = 'type';
                            break;
                        case 'IRI':
                            type = 'typeIRI';
                            break;
                        default:
                            type = '';
                    }
                    // What if nothing of the above was found?
                    if (!type) {
                        // We could be in streaming mode, and then we just wait for more input to arrive.
                        // Otherwise, a syntax error has occurred in the input.
                        // One exception: error on an unaccounted linebreak (= not inside a triple-quoted literal).
                        if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input)) return reportSyntaxError(this);
                        else return this._input = input;
                    }
                    // Emit the parsed token
                    var length = matchLength || match[0].length;
                    var token = emitToken(type, value, prefix, line, length);
                    this.previousToken = token;
                    this._previousMarker = type;
                    // Advance to next part to tokenize
                    input = input.substr(length, input.length);
                }
                // Emits the token through the callback
                function emitToken(type, value, prefix, line, length) {
                    var start = input ? currentLineLength - input.length : currentLineLength;
                    var end = start + length;
                    var token = {
                        type: type,
                        value: value,
                        prefix: prefix,
                        line: line,
                        start: start,
                        end: end
                    };
                    callback(null, token);
                    return token;
                }
                // Signals the syntax error through the callback
                function reportSyntaxError(self) {
                    callback(self._syntaxError(/^\S*/.exec(input)[0]));
                }
            }
        },
        {
            // ### `_unescape` replaces N3 escape codes by their corresponding characters
            key: "_unescape",
            value: function _unescape(item) {
                var invalid = false;
                var replaced = item.replace($067a4b6e4cc70e23$var$escapeSequence, function(sequence, unicode4, unicode8, escapedChar) {
                    // 4-digit unicode character
                    if (typeof unicode4 === 'string') return String.fromCharCode(Number.parseInt(unicode4, 16));
                    // 8-digit unicode character
                    if (typeof unicode8 === 'string') {
                        var charCode = Number.parseInt(unicode8, 16);
                        return charCode <= 0xFFFF ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
                    }
                    // fixed escape sequence
                    if (escapedChar in $067a4b6e4cc70e23$var$escapeReplacements) return $067a4b6e4cc70e23$var$escapeReplacements[escapedChar];
                    // invalid escape sequence
                    invalid = true;
                    return '';
                });
                return invalid ? null : replaced;
            }
        },
        {
            // ### `_parseLiteral` parses a literal into an unescaped value
            key: "_parseLiteral",
            value: function _parseLiteral(input) {
                // Ensure we have enough lookahead to identify triple-quoted strings
                if (input.length >= 3) {
                    // Identify the opening quote(s)
                    var opening = input.match(/^(?:"""|"|'''|'|)/)[0];
                    var openingLength = opening.length;
                    // Find the next candidate closing quotes
                    var closingPos = Math.max(this._literalClosingPos, openingLength);
                    while((closingPos = input.indexOf(opening, closingPos)) > 0){
                        // Count backslashes right before the closing quotes
                        var backslashCount = 0;
                        while(input[closingPos - backslashCount - 1] === '\\')backslashCount++;
                        // An even number of backslashes (in particular 0)
                        // means these are actual, non-escaped closing quotes
                        if (backslashCount % 2 === 0) {
                            // Extract and unescape the value
                            var raw = input.substring(openingLength, closingPos);
                            var lines = raw.split(/\r\n|\r|\n/).length - 1;
                            var matchLength = closingPos + openingLength;
                            // Only triple-quoted strings can be multi-line
                            if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode) break;
                            this._line += lines;
                            return {
                                value: this._unescape(raw),
                                matchLength: matchLength
                            };
                        }
                        closingPos++;
                    }
                    this._literalClosingPos = input.length - openingLength + 1;
                }
                return {
                    value: '',
                    matchLength: 0
                };
            }
        },
        {
            // ### `_syntaxError` creates a syntax error for the given issue
            key: "_syntaxError",
            value: function _syntaxError(issue) {
                this._input = null;
                var err = new Error('Unexpected "'.concat(issue, '" on line ').concat(this._line, "."));
                err.context = {
                    token: undefined,
                    line: this._line,
                    previousToken: this.previousToken
                };
                return err;
            }
        },
        {
            // ### Strips off any starting UTF BOM mark.
            key: "_readStartingBom",
            value: function _readStartingBom(input) {
                return input.startsWith('\ufeff') ? input.substr(1) : input;
            }
        },
        {
            // ## Public methods
            // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
            // The input can be a string or a stream.
            key: "tokenize",
            value: function tokenize(input, callback) {
                var _this = this;
                this._line = 1;
                // If the input is a string, continuously emit tokens through the callback until the end
                if (typeof input === 'string') {
                    this._input = this._readStartingBom(input);
                    // If a callback was passed, asynchronously call it
                    if (typeof callback === 'function') queueMicrotask(function() {
                        return _this._tokenizeToEnd(callback, true);
                    });
                    else {
                        var tokens = [];
                        var error;
                        this._tokenizeToEnd(function(e, t) {
                            return e ? error = e : tokens.push(t);
                        }, true);
                        if (error) throw error;
                        return tokens;
                    }
                } else {
                    this._pendingBuffer = null;
                    if (typeof input.setEncoding === 'function') input.setEncoding('utf8');
                    // Adds the data chunk to the buffer and parses as far as possible
                    input.on('data', function(data) {
                        if (_this._input !== null && data.length !== 0) {
                            // Prepend any previous pending writes
                            if (_this._pendingBuffer) {
                                data = (0, $ikzXy.Buffer).concat([
                                    _this._pendingBuffer,
                                    data
                                ]);
                                _this._pendingBuffer = null;
                            }
                            // Hold if the buffer ends in an incomplete unicode sequence
                            if (data[data.length - 1] & 0x80) _this._pendingBuffer = data;
                            else {
                                // Only read a BOM at the start
                                if (typeof _this._input === 'undefined') _this._input = _this._readStartingBom(typeof data === 'string' ? data : data.toString());
                                else _this._input += data;
                                _this._tokenizeToEnd(callback, false);
                            }
                        }
                    });
                    // Parses until the end
                    input.on('end', function() {
                        if (typeof _this._input === 'string') _this._tokenizeToEnd(callback, true);
                    });
                    input.on('error', callback);
                }
            }
        }
    ]);
    return N3Lexer;
}();

});
parcelRegister("ikzXy", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d585fd0d9932fb71$export$a143d493d941bafc; }, function (v) { return $d585fd0d9932fb71$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d585fd0d9932fb71$export$f99ded8fe4b79145; }, function (v) { return $d585fd0d9932fb71$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $d585fd0d9932fb71$export$a143d493d941bafc;
var $d585fd0d9932fb71$export$e4cf37d7f6fb9e0a;
var $d585fd0d9932fb71$export$f99ded8fe4b79145;
var $d585fd0d9932fb71$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $d585fd0d9932fb71$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d585fd0d9932fb71$export$a143d493d941bafc = $d585fd0d9932fb71$var$Buffer;
$d585fd0d9932fb71$export$e4cf37d7f6fb9e0a = $d585fd0d9932fb71$var$SlowBuffer;
$d585fd0d9932fb71$export$f99ded8fe4b79145 = 50;
var $d585fd0d9932fb71$var$K_MAX_LENGTH = 0x7fffffff;
$d585fd0d9932fb71$export$599f31c3813fae4d = $d585fd0d9932fb71$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d585fd0d9932fb71$var$Buffer.TYPED_ARRAY_SUPPORT = $d585fd0d9932fb71$var$typedArraySupport();
if (!$d585fd0d9932fb71$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d585fd0d9932fb71$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d585fd0d9932fb71$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$d585fd0d9932fb71$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d585fd0d9932fb71$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$d585fd0d9932fb71$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d585fd0d9932fb71$var$createBuffer(length) {
    if (length > $d585fd0d9932fb71$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d585fd0d9932fb71$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d585fd0d9932fb71$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d585fd0d9932fb71$var$allocUnsafe(arg);
    }
    return $d585fd0d9932fb71$var$from(arg, encodingOrOffset, length);
}
$d585fd0d9932fb71$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d585fd0d9932fb71$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d585fd0d9932fb71$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d585fd0d9932fb71$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($d585fd0d9932fb71$var$isInstance(value, ArrayBuffer) || value && $d585fd0d9932fb71$var$isInstance(value.buffer, ArrayBuffer)) return $d585fd0d9932fb71$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d585fd0d9932fb71$var$isInstance(value, SharedArrayBuffer) || value && $d585fd0d9932fb71$var$isInstance(value.buffer, SharedArrayBuffer))) return $d585fd0d9932fb71$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d585fd0d9932fb71$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d585fd0d9932fb71$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d585fd0d9932fb71$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d585fd0d9932fb71$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d585fd0d9932fb71$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d585fd0d9932fb71$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d585fd0d9932fb71$var$Buffer, Uint8Array);
function $d585fd0d9932fb71$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d585fd0d9932fb71$var$alloc(size, fill, encoding) {
    $d585fd0d9932fb71$var$assertSize(size);
    if (size <= 0) return $d585fd0d9932fb71$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d585fd0d9932fb71$var$createBuffer(size).fill(fill, encoding) : $d585fd0d9932fb71$var$createBuffer(size).fill(fill);
    return $d585fd0d9932fb71$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d585fd0d9932fb71$var$Buffer.alloc = function(size, fill, encoding) {
    return $d585fd0d9932fb71$var$alloc(size, fill, encoding);
};
function $d585fd0d9932fb71$var$allocUnsafe(size) {
    $d585fd0d9932fb71$var$assertSize(size);
    return $d585fd0d9932fb71$var$createBuffer(size < 0 ? 0 : $d585fd0d9932fb71$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d585fd0d9932fb71$var$Buffer.allocUnsafe = function(size) {
    return $d585fd0d9932fb71$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d585fd0d9932fb71$var$Buffer.allocUnsafeSlow = function(size) {
    return $d585fd0d9932fb71$var$allocUnsafe(size);
};
function $d585fd0d9932fb71$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d585fd0d9932fb71$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d585fd0d9932fb71$var$byteLength(string, encoding) | 0;
    var buf = $d585fd0d9932fb71$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d585fd0d9932fb71$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d585fd0d9932fb71$var$checked(array.length) | 0;
    var buf = $d585fd0d9932fb71$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d585fd0d9932fb71$var$fromArrayView(arrayView) {
    if ($d585fd0d9932fb71$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d585fd0d9932fb71$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d585fd0d9932fb71$var$fromArrayLike(arrayView);
}
function $d585fd0d9932fb71$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d585fd0d9932fb71$var$Buffer.prototype);
    return buf;
}
function $d585fd0d9932fb71$var$fromObject(obj) {
    if ($d585fd0d9932fb71$var$Buffer.isBuffer(obj)) {
        var len = $d585fd0d9932fb71$var$checked(obj.length) | 0;
        var buf = $d585fd0d9932fb71$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d585fd0d9932fb71$var$numberIsNaN(obj.length)) return $d585fd0d9932fb71$var$createBuffer(0);
        return $d585fd0d9932fb71$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d585fd0d9932fb71$var$fromArrayLike(obj.data);
}
function $d585fd0d9932fb71$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d585fd0d9932fb71$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d585fd0d9932fb71$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d585fd0d9932fb71$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d585fd0d9932fb71$var$Buffer.alloc(+length);
}
$d585fd0d9932fb71$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d585fd0d9932fb71$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d585fd0d9932fb71$var$Buffer.compare = function compare(a, b) {
    if ($d585fd0d9932fb71$var$isInstance(a, Uint8Array)) a = $d585fd0d9932fb71$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d585fd0d9932fb71$var$isInstance(b, Uint8Array)) b = $d585fd0d9932fb71$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d585fd0d9932fb71$var$Buffer.isBuffer(a) || !$d585fd0d9932fb71$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d585fd0d9932fb71$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d585fd0d9932fb71$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d585fd0d9932fb71$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d585fd0d9932fb71$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d585fd0d9932fb71$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d585fd0d9932fb71$var$Buffer.isBuffer(buf)) buf = $d585fd0d9932fb71$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d585fd0d9932fb71$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d585fd0d9932fb71$var$byteLength(string, encoding) {
    if ($d585fd0d9932fb71$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d585fd0d9932fb71$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d585fd0d9932fb71$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d585fd0d9932fb71$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d585fd0d9932fb71$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d585fd0d9932fb71$var$Buffer.byteLength = $d585fd0d9932fb71$var$byteLength;
function $d585fd0d9932fb71$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d585fd0d9932fb71$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d585fd0d9932fb71$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d585fd0d9932fb71$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d585fd0d9932fb71$var$latin1Slice(this, start, end);
        case 'base64':
            return $d585fd0d9932fb71$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d585fd0d9932fb71$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d585fd0d9932fb71$var$Buffer.prototype._isBuffer = true;
function $d585fd0d9932fb71$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d585fd0d9932fb71$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d585fd0d9932fb71$var$swap(this, i, i + 1);
    return this;
};
$d585fd0d9932fb71$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d585fd0d9932fb71$var$swap(this, i, i + 3);
        $d585fd0d9932fb71$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d585fd0d9932fb71$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d585fd0d9932fb71$var$swap(this, i, i + 7);
        $d585fd0d9932fb71$var$swap(this, i + 1, i + 6);
        $d585fd0d9932fb71$var$swap(this, i + 2, i + 5);
        $d585fd0d9932fb71$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d585fd0d9932fb71$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d585fd0d9932fb71$var$utf8Slice(this, 0, length);
    return $d585fd0d9932fb71$var$slowToString.apply(this, arguments);
};
$d585fd0d9932fb71$var$Buffer.prototype.toLocaleString = $d585fd0d9932fb71$var$Buffer.prototype.toString;
$d585fd0d9932fb71$var$Buffer.prototype.equals = function equals(b) {
    if (!$d585fd0d9932fb71$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d585fd0d9932fb71$var$Buffer.compare(this, b) === 0;
};
$d585fd0d9932fb71$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d585fd0d9932fb71$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d585fd0d9932fb71$var$customInspectSymbol) $d585fd0d9932fb71$var$Buffer.prototype[$d585fd0d9932fb71$var$customInspectSymbol] = $d585fd0d9932fb71$var$Buffer.prototype.inspect;
$d585fd0d9932fb71$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d585fd0d9932fb71$var$isInstance(target, Uint8Array)) target = $d585fd0d9932fb71$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d585fd0d9932fb71$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d585fd0d9932fb71$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d585fd0d9932fb71$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d585fd0d9932fb71$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d585fd0d9932fb71$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d585fd0d9932fb71$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d585fd0d9932fb71$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d585fd0d9932fb71$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d585fd0d9932fb71$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d585fd0d9932fb71$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d585fd0d9932fb71$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d585fd0d9932fb71$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d585fd0d9932fb71$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d585fd0d9932fb71$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d585fd0d9932fb71$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d585fd0d9932fb71$var$utf8Write(buf, string, offset, length) {
    return $d585fd0d9932fb71$var$blitBuffer($d585fd0d9932fb71$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d585fd0d9932fb71$var$asciiWrite(buf, string, offset, length) {
    return $d585fd0d9932fb71$var$blitBuffer($d585fd0d9932fb71$var$asciiToBytes(string), buf, offset, length);
}
function $d585fd0d9932fb71$var$base64Write(buf, string, offset, length) {
    return $d585fd0d9932fb71$var$blitBuffer($d585fd0d9932fb71$var$base64ToBytes(string), buf, offset, length);
}
function $d585fd0d9932fb71$var$ucs2Write(buf, string, offset, length) {
    return $d585fd0d9932fb71$var$blitBuffer($d585fd0d9932fb71$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d585fd0d9932fb71$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d585fd0d9932fb71$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d585fd0d9932fb71$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d585fd0d9932fb71$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d585fd0d9932fb71$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d585fd0d9932fb71$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d585fd0d9932fb71$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d585fd0d9932fb71$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $d585fd0d9932fb71$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d585fd0d9932fb71$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d585fd0d9932fb71$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d585fd0d9932fb71$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d585fd0d9932fb71$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d585fd0d9932fb71$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d585fd0d9932fb71$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d585fd0d9932fb71$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d585fd0d9932fb71$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d585fd0d9932fb71$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d585fd0d9932fb71$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d585fd0d9932fb71$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d585fd0d9932fb71$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d585fd0d9932fb71$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d585fd0d9932fb71$var$Buffer.prototype.readUintLE = $d585fd0d9932fb71$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readUintBE = $d585fd0d9932fb71$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readUint8 = $d585fd0d9932fb71$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d585fd0d9932fb71$var$Buffer.prototype.readUint16LE = $d585fd0d9932fb71$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d585fd0d9932fb71$var$Buffer.prototype.readUint16BE = $d585fd0d9932fb71$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d585fd0d9932fb71$var$Buffer.prototype.readUint32LE = $d585fd0d9932fb71$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d585fd0d9932fb71$var$Buffer.prototype.readUint32BE = $d585fd0d9932fb71$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d585fd0d9932fb71$var$Buffer.prototype.readBigUInt64LE = $d585fd0d9932fb71$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d585fd0d9932fb71$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d585fd0d9932fb71$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d585fd0d9932fb71$var$Buffer.prototype.readBigUInt64BE = $d585fd0d9932fb71$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d585fd0d9932fb71$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d585fd0d9932fb71$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d585fd0d9932fb71$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d585fd0d9932fb71$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d585fd0d9932fb71$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d585fd0d9932fb71$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d585fd0d9932fb71$var$Buffer.prototype.readBigInt64LE = $d585fd0d9932fb71$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d585fd0d9932fb71$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d585fd0d9932fb71$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$d585fd0d9932fb71$var$Buffer.prototype.readBigInt64BE = $d585fd0d9932fb71$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d585fd0d9932fb71$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d585fd0d9932fb71$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$d585fd0d9932fb71$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$d585fd0d9932fb71$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$d585fd0d9932fb71$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$d585fd0d9932fb71$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $d585fd0d9932fb71$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d585fd0d9932fb71$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d585fd0d9932fb71$var$Buffer.prototype.writeUintLE = $d585fd0d9932fb71$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d585fd0d9932fb71$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUintBE = $d585fd0d9932fb71$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d585fd0d9932fb71$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUint8 = $d585fd0d9932fb71$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUint16LE = $d585fd0d9932fb71$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUint16BE = $d585fd0d9932fb71$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUint32LE = $d585fd0d9932fb71$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeUint32BE = $d585fd0d9932fb71$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d585fd0d9932fb71$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d585fd0d9932fb71$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d585fd0d9932fb71$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d585fd0d9932fb71$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d585fd0d9932fb71$var$Buffer.prototype.writeBigUInt64LE = $d585fd0d9932fb71$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d585fd0d9932fb71$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d585fd0d9932fb71$var$Buffer.prototype.writeBigUInt64BE = $d585fd0d9932fb71$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d585fd0d9932fb71$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d585fd0d9932fb71$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d585fd0d9932fb71$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d585fd0d9932fb71$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d585fd0d9932fb71$var$Buffer.prototype.writeBigInt64LE = $d585fd0d9932fb71$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d585fd0d9932fb71$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d585fd0d9932fb71$var$Buffer.prototype.writeBigInt64BE = $d585fd0d9932fb71$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d585fd0d9932fb71$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d585fd0d9932fb71$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d585fd0d9932fb71$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d585fd0d9932fb71$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d585fd0d9932fb71$var$writeFloat(this, value, offset, true, noAssert);
};
$d585fd0d9932fb71$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d585fd0d9932fb71$var$writeFloat(this, value, offset, false, noAssert);
};
function $d585fd0d9932fb71$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d585fd0d9932fb71$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d585fd0d9932fb71$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d585fd0d9932fb71$var$writeDouble(this, value, offset, true, noAssert);
};
$d585fd0d9932fb71$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d585fd0d9932fb71$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d585fd0d9932fb71$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d585fd0d9932fb71$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d585fd0d9932fb71$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d585fd0d9932fb71$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d585fd0d9932fb71$var$Buffer.isBuffer(val) ? val : $d585fd0d9932fb71$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $d585fd0d9932fb71$var$errors = {};
function $d585fd0d9932fb71$var$E(sym, getMessage, Base) {
    $d585fd0d9932fb71$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$d585fd0d9932fb71$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d585fd0d9932fb71$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$d585fd0d9932fb71$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d585fd0d9932fb71$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $d585fd0d9932fb71$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $d585fd0d9932fb71$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $d585fd0d9932fb71$var$checkBounds(buf, offset, byteLength) {
    $d585fd0d9932fb71$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d585fd0d9932fb71$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d585fd0d9932fb71$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $d585fd0d9932fb71$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d585fd0d9932fb71$var$checkBounds(buf, offset, byteLength);
}
function $d585fd0d9932fb71$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d585fd0d9932fb71$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d585fd0d9932fb71$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d585fd0d9932fb71$var$validateNumber(value, type);
        throw new $d585fd0d9932fb71$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d585fd0d9932fb71$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d585fd0d9932fb71$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $d585fd0d9932fb71$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d585fd0d9932fb71$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d585fd0d9932fb71$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d585fd0d9932fb71$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d585fd0d9932fb71$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d585fd0d9932fb71$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d585fd0d9932fb71$var$base64ToBytes(str) {
    return $abUaD.toByteArray($d585fd0d9932fb71$var$base64clean(str));
}
function $d585fd0d9932fb71$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d585fd0d9932fb71$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d585fd0d9932fb71$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d585fd0d9932fb71$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d585fd0d9932fb71$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d585fd0d9932fb71$var$BufferBigIntNotDefined : fn;
}
function $d585fd0d9932fb71$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("kEnRi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f08a0ce7bb41b279$export$2e2bcd8739ae039; });
var $f08a0ce7bb41b279$var$RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', $f08a0ce7bb41b279$var$XSD = 'http://www.w3.org/2001/XMLSchema#', $f08a0ce7bb41b279$var$SWAP = 'http://www.w3.org/2000/10/swap/';
var $f08a0ce7bb41b279$export$2e2bcd8739ae039 = {
    xsd: {
        decimal: "".concat($f08a0ce7bb41b279$var$XSD, "decimal"),
        boolean: "".concat($f08a0ce7bb41b279$var$XSD, "boolean"),
        double: "".concat($f08a0ce7bb41b279$var$XSD, "double"),
        integer: "".concat($f08a0ce7bb41b279$var$XSD, "integer"),
        string: "".concat($f08a0ce7bb41b279$var$XSD, "string")
    },
    rdf: {
        type: "".concat($f08a0ce7bb41b279$var$RDF, "type"),
        nil: "".concat($f08a0ce7bb41b279$var$RDF, "nil"),
        first: "".concat($f08a0ce7bb41b279$var$RDF, "first"),
        rest: "".concat($f08a0ce7bb41b279$var$RDF, "rest"),
        langString: "".concat($f08a0ce7bb41b279$var$RDF, "langString")
    },
    owl: {
        sameAs: 'http://www.w3.org/2002/07/owl#sameAs'
    },
    r: {
        forSome: "".concat($f08a0ce7bb41b279$var$SWAP, "reify#forSome"),
        forAll: "".concat($f08a0ce7bb41b279$var$SWAP, "reify#forAll")
    },
    log: {
        implies: "".concat($f08a0ce7bb41b279$var$SWAP, "log#implies"),
        isImpliedBy: "".concat($f08a0ce7bb41b279$var$SWAP, "log#isImpliedBy")
    }
};

});


parcelRegister("4lFIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a97ab54f532a77$export$2e2bcd8739ae039; });
// **N3Parser** parses N3 documents.

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $ytNSi = parcelRequire("ytNSi");

var $ha9LD = parcelRequire("ha9LD");

var $kEnRi = parcelRequire("kEnRi");
var $32a97ab54f532a77$var$blankNodePrefix = 0;
var $32a97ab54f532a77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3Parser(options) {
        (0, $jGAMp._)(this, N3Parser);
        this._contextStack = [];
        this._graph = null;
        // Set the document IRI
        options = options || {};
        this._setBase(options.baseIRI);
        options.factory && $32a97ab54f532a77$var$initDataFactory(this, options.factory);
        // Set supported features depending on the format
        var format = typeof options.format === 'string' ? options.format.match(/\w*$/)[0].toLowerCase() : '', isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
        if (!(this._supportsNamedGraphs = !(isTurtle || isN3))) this._readPredicateOrNamedGraph = this._readPredicate;
        // Support triples in other graphs
        this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
        // Whether the log:isImpliedBy predicate is supported
        this._isImpliedBy = options.isImpliedBy;
        // Support nesting of triples
        this._supportsRDFStar = format === '' || /star|\*$/.test(format);
        // Disable relative IRIs in N-Triples or N-Quads mode
        if (isLineMode) this._resolveRelativeIRI = function(iri) {
            return null;
        };
        this._blankNodePrefix = typeof options.blankNodePrefix !== 'string' ? '' : options.blankNodePrefix.replace(/^(?!_:)/, '_:');
        this._lexer = options.lexer || new (0, $ytNSi.default)({
            lineMode: isLineMode,
            n3: isN3,
            isImpliedBy: this._isImpliedBy
        });
        // Disable explicit quantifiers by default
        this._explicitQuantifiers = !!options.explicitQuantifiers;
    }
    (0, $byiyg._)(N3Parser, [
        {
            // ## Private methods
            // ### `_setBase` sets the base IRI to resolve relative IRIs
            key: "_setBase",
            value: function _setBase(baseIRI) {
                if (!baseIRI) {
                    this._base = '';
                    this._basePath = '';
                } else {
                    // Remove fragment if present
                    var fragmentPos = baseIRI.indexOf('#');
                    if (fragmentPos >= 0) baseIRI = baseIRI.substr(0, fragmentPos);
                    // Set base IRI and its components
                    this._base = baseIRI;
                    this._basePath = baseIRI.indexOf('/') < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, '');
                    baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
                    this._baseRoot = baseIRI[0];
                    this._baseScheme = baseIRI[1];
                }
            }
        },
        {
            // ### `_saveContext` stores the current parsing context
            // when entering a new scope (list, blank node, formula)
            key: "_saveContext",
            value: function _saveContext(type, graph, subject, predicate, object) {
                var n3Mode = this._n3Mode;
                this._contextStack.push({
                    type: type,
                    subject: subject,
                    predicate: predicate,
                    object: object,
                    graph: graph,
                    inverse: n3Mode ? this._inversePredicate : false,
                    blankPrefix: n3Mode ? this._prefixes._ : '',
                    quantified: n3Mode ? this._quantified : null
                });
                // The settings below only apply to N3 streams
                if (n3Mode) {
                    // Every new scope resets the predicate direction
                    this._inversePredicate = false;
                    // In N3, blank nodes are scoped to a formula
                    // (using a dot as separator, as a blank node label cannot start with it)
                    this._prefixes._ = this._graph ? "".concat(this._graph.value, ".") : '.';
                    // Quantifiers are scoped to a formula
                    this._quantified = Object.create(this._quantified);
                }
            }
        },
        {
            // ### `_restoreContext` restores the parent context
            // when leaving a scope (list, blank node, formula)
            key: "_restoreContext",
            value: function _restoreContext(type, token) {
                // Obtain the previous context
                var context = this._contextStack.pop();
                if (!context || context.type !== type) return this._error("Unexpected ".concat(token.type), token);
                // Restore the quad of the previous context
                this._subject = context.subject;
                this._predicate = context.predicate;
                this._object = context.object;
                this._graph = context.graph;
                // Restore N3 context settings
                if (this._n3Mode) {
                    this._inversePredicate = context.inverse;
                    this._prefixes._ = context.blankPrefix;
                    this._quantified = context.quantified;
                }
            }
        },
        {
            // ### `_readInTopContext` reads a token when in the top context
            key: "_readInTopContext",
            value: function _readInTopContext(token) {
                switch(token.type){
                    // If an EOF token arrives in the top context, signal that we're done
                    case 'eof':
                        if (this._graph !== null) return this._error('Unclosed graph', token);
                        delete this._prefixes._;
                        return this._callback(null, null, this._prefixes);
                    // It could be a prefix declaration
                    case 'PREFIX':
                        this._sparqlStyle = true;
                    case '@prefix':
                        return this._readPrefix;
                    // It could be a base declaration
                    case 'BASE':
                        this._sparqlStyle = true;
                    case '@base':
                        return this._readBaseIRI;
                    // It could be a graph
                    case '{':
                        if (this._supportsNamedGraphs) {
                            this._graph = '';
                            this._subject = null;
                            return this._readSubject;
                        }
                    case 'GRAPH':
                        if (this._supportsNamedGraphs) return this._readNamedGraphLabel;
                    // Otherwise, the next token must be a subject
                    default:
                        return this._readSubject(token);
                }
            }
        },
        {
            // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
            key: "_readEntity",
            value: function _readEntity(token, quantifier) {
                var value;
                switch(token.type){
                    // Read a relative or absolute IRI
                    case 'IRI':
                    case 'typeIRI':
                        var iri = this._resolveIRI(token.value);
                        if (iri === null) return this._error('Invalid IRI', token);
                        value = this._factory.namedNode(iri);
                        break;
                    // Read a prefixed name
                    case 'type':
                    case 'prefixed':
                        var prefix = this._prefixes[token.prefix];
                        if (prefix === undefined) return this._error('Undefined prefix "'.concat(token.prefix, ':"'), token);
                        value = this._factory.namedNode(prefix + token.value);
                        break;
                    // Read a blank node
                    case 'blank':
                        value = this._factory.blankNode(this._prefixes[token.prefix] + token.value);
                        break;
                    // Read a variable
                    case 'var':
                        value = this._factory.variable(token.value.substr(1));
                        break;
                    // Everything else is not an entity
                    default:
                        return this._error("Expected entity but got ".concat(token.type), token);
                }
                // In N3 mode, replace the entity if it is quantified
                if (!quantifier && this._n3Mode && value.id in this._quantified) value = this._quantified[value.id];
                return value;
            }
        },
        {
            // ### `_readSubject` reads a quad's subject
            key: "_readSubject",
            value: function _readSubject(token) {
                this._predicate = null;
                switch(token.type){
                    case '[':
                        // Start a new quad with a new blank node as subject
                        this._saveContext('blank', this._graph, this._subject = this._factory.blankNode(), null, null);
                        return this._readBlankNodeHead;
                    case '(':
                        // Start a new list
                        this._saveContext('list', this._graph, this.RDF_NIL, null, null);
                        this._subject = null;
                        return this._readListItem;
                    case '{':
                        // Start a new formula
                        if (!this._n3Mode) return this._error('Unexpected graph', token);
                        this._saveContext('formula', this._graph, this._graph = this._factory.blankNode(), null, null);
                        return this._readSubject;
                    case '}':
                        // No subject; the graph in which we are reading is closed instead
                        return this._readPunctuation(token);
                    case '@forSome':
                        if (!this._n3Mode) return this._error('Unexpected "@forSome"', token);
                        this._subject = null;
                        this._predicate = this.N3_FORSOME;
                        this._quantifier = 'blankNode';
                        return this._readQuantifierList;
                    case '@forAll':
                        if (!this._n3Mode) return this._error('Unexpected "@forAll"', token);
                        this._subject = null;
                        this._predicate = this.N3_FORALL;
                        this._quantifier = 'variable';
                        return this._readQuantifierList;
                    case 'literal':
                        if (!this._n3Mode) return this._error('Unexpected literal', token);
                        if (token.prefix.length === 0) {
                            this._literalValue = token.value;
                            return this._completeSubjectLiteral;
                        } else this._subject = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                        break;
                    case '<<':
                        if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                        this._saveContext('<<', this._graph, null, null, null);
                        this._graph = null;
                        return this._readSubject;
                    default:
                        // Read the subject entity
                        if ((this._subject = this._readEntity(token)) === undefined) return;
                        // In N3 mode, the subject might be a path
                        if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
                }
                // The next token must be a predicate,
                // or, if the subject was actually a graph IRI, a named graph
                return this._readPredicateOrNamedGraph;
            }
        },
        {
            // ### `_readPredicate` reads a quad's predicate
            key: "_readPredicate",
            value: function _readPredicate(token) {
                var type = token.type;
                switch(type){
                    case 'inverse':
                        this._inversePredicate = true;
                    case 'abbreviation':
                        this._predicate = this.ABBREVIATIONS[token.value];
                        break;
                    case '.':
                    case ']':
                    case '}':
                        // Expected predicate didn't come, must have been trailing semicolon
                        if (this._predicate === null) return this._error("Unexpected ".concat(type), token);
                        this._subject = null;
                        return type === ']' ? this._readBlankNodeTail(token) : this._readPunctuation(token);
                    case ';':
                        // Additional semicolons can be safely ignored
                        return this._predicate !== null ? this._readPredicate : this._error('Expected predicate but got ;', token);
                    case '[':
                        if (this._n3Mode) {
                            // Start a new quad with a new blank node as subject
                            this._saveContext('blank', this._graph, this._subject, this._subject = this._factory.blankNode(), null);
                            return this._readBlankNodeHead;
                        }
                    case 'blank':
                        if (!this._n3Mode) return this._error('Disallowed blank node as predicate', token);
                    default:
                        if ((this._predicate = this._readEntity(token)) === undefined) return;
                }
                // The next token must be an object
                return this._readObject;
            }
        },
        {
            // ### `_readObject` reads a quad's object
            key: "_readObject",
            value: function _readObject(token) {
                switch(token.type){
                    case 'literal':
                        // Regular literal, can still get a datatype or language
                        if (token.prefix.length === 0) {
                            this._literalValue = token.value;
                            return this._readDataTypeOrLang;
                        } else this._object = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                        break;
                    case '[':
                        // Start a new quad with a new blank node as subject
                        this._saveContext('blank', this._graph, this._subject, this._predicate, this._subject = this._factory.blankNode());
                        return this._readBlankNodeHead;
                    case '(':
                        // Start a new list
                        this._saveContext('list', this._graph, this._subject, this._predicate, this.RDF_NIL);
                        this._subject = null;
                        return this._readListItem;
                    case '{':
                        // Start a new formula
                        if (!this._n3Mode) return this._error('Unexpected graph', token);
                        this._saveContext('formula', this._graph, this._subject, this._predicate, this._graph = this._factory.blankNode());
                        return this._readSubject;
                    case '<<':
                        if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                        this._saveContext('<<', this._graph, this._subject, this._predicate, null);
                        this._graph = null;
                        return this._readSubject;
                    default:
                        // Read the object entity
                        if ((this._object = this._readEntity(token)) === undefined) return;
                        // In N3 mode, the object might be a path
                        if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
                }
                return this._getContextEndReader();
            }
        },
        {
            // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
            key: "_readPredicateOrNamedGraph",
            value: function _readPredicateOrNamedGraph(token) {
                return token.type === '{' ? this._readGraph(token) : this._readPredicate(token);
            }
        },
        {
            // ### `_readGraph` reads a graph
            key: "_readGraph",
            value: function _readGraph(token) {
                if (token.type !== '{') return this._error("Expected graph but got ".concat(token.type), token);
                // The "subject" we read is actually the GRAPH's label
                this._graph = this._subject, this._subject = null;
                return this._readSubject;
            }
        },
        {
            // ### `_readBlankNodeHead` reads the head of a blank node
            key: "_readBlankNodeHead",
            value: function _readBlankNodeHead(token) {
                if (token.type === ']') {
                    this._subject = null;
                    return this._readBlankNodeTail(token);
                } else {
                    this._predicate = null;
                    return this._readPredicate(token);
                }
            }
        },
        {
            // ### `_readBlankNodeTail` reads the end of a blank node
            key: "_readBlankNodeTail",
            value: function _readBlankNodeTail(token) {
                if (token.type !== ']') return this._readBlankNodePunctuation(token);
                // Store blank node quad
                if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
                // Restore the parent context containing this blank node
                var empty = this._predicate === null;
                this._restoreContext('blank', token);
                // If the blank node was the object, restore previous context and read punctuation
                if (this._object !== null) return this._getContextEndReader();
                else if (this._predicate !== null) return this._readObject;
                else // If the blank node was empty, it could be a named graph label
                return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
            }
        },
        {
            // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
            key: "_readPredicateAfterBlank",
            value: function _readPredicateAfterBlank(token) {
                switch(token.type){
                    case '.':
                    case '}':
                        // No predicate is coming if the triple is terminated here
                        this._subject = null;
                        return this._readPunctuation(token);
                    default:
                        return this._readPredicate(token);
                }
            }
        },
        {
            // ### `_readListItem` reads items from a list
            key: "_readListItem",
            value: function _readListItem(token) {
                var item = null, list = null, next = this._readListItem; // The next function to execute
                var previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1]; // The parent containing the current list
                switch(token.type){
                    case '[':
                        // Stack the current list quad and start a new quad with a blank node as subject
                        this._saveContext('blank', this._graph, list = this._factory.blankNode(), this.RDF_FIRST, this._subject = item = this._factory.blankNode());
                        next = this._readBlankNodeHead;
                        break;
                    case '(':
                        // Stack the current list quad and start a new list
                        this._saveContext('list', this._graph, list = this._factory.blankNode(), this.RDF_FIRST, this.RDF_NIL);
                        this._subject = null;
                        break;
                    case ')':
                        // Closing the list; restore the parent context
                        this._restoreContext('list', token);
                        // If this list is contained within a parent list, return the membership quad here.
                        // This will be `<parent list element> rdf:first <this list>.`.
                        if (stack.length !== 0 && stack[stack.length - 1].type === 'list') this._emit(this._subject, this._predicate, this._object, this._graph);
                        // Was this list the parent's subject?
                        if (this._predicate === null) {
                            // The next token is the predicate
                            next = this._readPredicate;
                            // No list tail if this was an empty list
                            if (this._subject === this.RDF_NIL) return next;
                        } else {
                            next = this._getContextEndReader();
                            // No list tail if this was an empty list
                            if (this._object === this.RDF_NIL) return next;
                        }
                        // Close the list by making the head nil
                        list = this.RDF_NIL;
                        break;
                    case 'literal':
                        // Regular literal, can still get a datatype or language
                        if (token.prefix.length === 0) {
                            this._literalValue = token.value;
                            next = this._readListItemDataTypeOrLang;
                        } else {
                            item = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                            next = this._getContextEndReader();
                        }
                        break;
                    case '{':
                        // Start a new formula
                        if (!this._n3Mode) return this._error('Unexpected graph', token);
                        this._saveContext('formula', this._graph, this._subject, this._predicate, this._graph = this._factory.blankNode());
                        return this._readSubject;
                    default:
                        if ((item = this._readEntity(token)) === undefined) return;
                }
                // Create a new blank node if no item head was assigned yet
                if (list === null) this._subject = list = this._factory.blankNode();
                // Is this the first element of the list?
                if (previousList === null) {
                    // This list is either the subject or the object of its parent
                    if (parent.predicate === null) parent.subject = list;
                    else parent.object = list;
                } else // Continue the previous list with the current list
                this._emit(previousList, this.RDF_REST, list, this._graph);
                // If an item was read, add it to the list
                if (item !== null) {
                    // In N3 mode, the item might be a path
                    if (this._n3Mode && (token.type === 'IRI' || token.type === 'prefixed')) {
                        // Create a new context to add the item's path
                        this._saveContext('item', this._graph, list, this.RDF_FIRST, item);
                        this._subject = item, this._predicate = null;
                        // _readPath will restore the context and output the item
                        return this._getPathReader(this._readListItem);
                    }
                    // Output the item
                    this._emit(list, this.RDF_FIRST, item, this._graph);
                }
                return next;
            }
        },
        {
            // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
            key: "_readDataTypeOrLang",
            value: function _readDataTypeOrLang(token) {
                return this._completeObjectLiteral(token, false);
            }
        },
        {
            // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
            key: "_readListItemDataTypeOrLang",
            value: function _readListItemDataTypeOrLang(token) {
                return this._completeObjectLiteral(token, true);
            }
        },
        {
            // ### `_completeLiteral` completes a literal with an optional datatype or language
            key: "_completeLiteral",
            value: function _completeLiteral(token) {
                // Create a simple string literal by default
                var literal = this._factory.literal(this._literalValue);
                switch(token.type){
                    // Create a datatyped literal
                    case 'type':
                    case 'typeIRI':
                        var datatype = this._readEntity(token);
                        if (datatype === undefined) return; // No datatype means an error occurred
                        literal = this._factory.literal(this._literalValue, datatype);
                        token = null;
                        break;
                    // Create a language-tagged string
                    case 'langcode':
                        literal = this._factory.literal(this._literalValue, token.value);
                        token = null;
                        break;
                }
                return {
                    token: token,
                    literal: literal
                };
            }
        },
        {
            // Completes a literal in subject position
            key: "_completeSubjectLiteral",
            value: function _completeSubjectLiteral(token) {
                this._subject = this._completeLiteral(token).literal;
                return this._readPredicateOrNamedGraph;
            }
        },
        {
            // Completes a literal in object position
            key: "_completeObjectLiteral",
            value: function _completeObjectLiteral(token, listItem) {
                var completed = this._completeLiteral(token);
                if (!completed) return;
                this._object = completed.literal;
                // If this literal was part of a list, write the item
                // (we could also check the context stack, but passing in a flag is faster)
                if (listItem) this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
                // If the token was consumed, continue with the rest of the input
                if (completed.token === null) return this._getContextEndReader();
                else {
                    this._readCallback = this._getContextEndReader();
                    return this._readCallback(completed.token);
                }
            }
        },
        {
            // ### `_readFormulaTail` reads the end of a formula
            key: "_readFormulaTail",
            value: function _readFormulaTail(token) {
                if (token.type !== '}') return this._readPunctuation(token);
                // Store the last quad of the formula
                if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
                // Restore the parent context containing this formula
                this._restoreContext('formula', token);
                // If the formula was the subject, continue reading the predicate.
                // If the formula was the object, read punctuation.
                return this._object === null ? this._readPredicate : this._getContextEndReader();
            }
        },
        {
            // ### `_readPunctuation` reads punctuation between quads or quad parts
            key: "_readPunctuation",
            value: function _readPunctuation(token) {
                var next, graph = this._graph;
                var subject = this._subject, inversePredicate = this._inversePredicate;
                switch(token.type){
                    // A closing brace ends a graph
                    case '}':
                        if (this._graph === null) return this._error('Unexpected graph closing', token);
                        if (this._n3Mode) return this._readFormulaTail(token);
                        this._graph = null;
                    // A dot just ends the statement, without sharing anything with the next
                    case '.':
                        this._subject = null;
                        next = this._contextStack.length ? this._readSubject : this._readInTopContext;
                        if (inversePredicate) this._inversePredicate = false;
                        break;
                    // Semicolon means the subject is shared; predicate and object are different
                    case ';':
                        next = this._readPredicate;
                        break;
                    // Comma means both the subject and predicate are shared; the object is different
                    case ',':
                        next = this._readObject;
                        break;
                    // {| means that the current triple is annotated with predicate-object pairs.
                    case '{|':
                        if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                        // Continue using the last triple as quoted triple subject for the predicate-object pairs.
                        var predicate = this._predicate, object = this._object;
                        this._subject = this._factory.quad(subject, predicate, object, this.DEFAULTGRAPH);
                        next = this._readPredicate;
                        break;
                    // |} means that the current quoted triple in annotation syntax is finalized.
                    case '|}':
                        if (this._subject.termType !== 'Quad') return this._error('Unexpected asserted triple closing', token);
                        this._subject = null;
                        next = this._readPunctuation;
                        break;
                    default:
                        // An entity means this is a quad (only allowed if not already inside a graph)
                        if (this._supportsQuads && this._graph === null && (graph = this._readEntity(token)) !== undefined) {
                            next = this._readQuadPunctuation;
                            break;
                        }
                        return this._error('Expected punctuation to follow "'.concat(this._object.id, '"'), token);
                }
                // A quad has been completed now, so return it
                if (subject !== null) {
                    var predicate1 = this._predicate, object1 = this._object;
                    if (!inversePredicate) this._emit(subject, predicate1, object1, graph);
                    else this._emit(object1, predicate1, subject, graph);
                }
                return next;
            }
        },
        {
            // ### `_readBlankNodePunctuation` reads punctuation in a blank node
            key: "_readBlankNodePunctuation",
            value: function _readBlankNodePunctuation(token) {
                var next;
                switch(token.type){
                    // Semicolon means the subject is shared; predicate and object are different
                    case ';':
                        next = this._readPredicate;
                        break;
                    // Comma means both the subject and predicate are shared; the object is different
                    case ',':
                        next = this._readObject;
                        break;
                    default:
                        return this._error('Expected punctuation to follow "'.concat(this._object.id, '"'), token);
                }
                // A quad has been completed now, so return it
                this._emit(this._subject, this._predicate, this._object, this._graph);
                return next;
            }
        },
        {
            // ### `_readQuadPunctuation` reads punctuation after a quad
            key: "_readQuadPunctuation",
            value: function _readQuadPunctuation(token) {
                if (token.type !== '.') return this._error('Expected dot to follow quad', token);
                return this._readInTopContext;
            }
        },
        {
            // ### `_readPrefix` reads the prefix of a prefix declaration
            key: "_readPrefix",
            value: function _readPrefix(token) {
                if (token.type !== 'prefix') return this._error('Expected prefix to follow @prefix', token);
                this._prefix = token.value;
                return this._readPrefixIRI;
            }
        },
        {
            // ### `_readPrefixIRI` reads the IRI of a prefix declaration
            key: "_readPrefixIRI",
            value: function _readPrefixIRI(token) {
                if (token.type !== 'IRI') return this._error('Expected IRI to follow prefix "'.concat(this._prefix, ':"'), token);
                var prefixNode = this._readEntity(token);
                this._prefixes[this._prefix] = prefixNode.value;
                this._prefixCallback(this._prefix, prefixNode);
                return this._readDeclarationPunctuation;
            }
        },
        {
            // ### `_readBaseIRI` reads the IRI of a base declaration
            key: "_readBaseIRI",
            value: function _readBaseIRI(token) {
                var iri = token.type === 'IRI' && this._resolveIRI(token.value);
                if (!iri) return this._error('Expected valid IRI to follow base declaration', token);
                this._setBase(iri);
                return this._readDeclarationPunctuation;
            }
        },
        {
            // ### `_readNamedGraphLabel` reads the label of a named graph
            key: "_readNamedGraphLabel",
            value: function _readNamedGraphLabel(token) {
                switch(token.type){
                    case 'IRI':
                    case 'blank':
                    case 'prefixed':
                        return this._readSubject(token), this._readGraph;
                    case '[':
                        return this._readNamedGraphBlankLabel;
                    default:
                        return this._error('Invalid graph label', token);
                }
            }
        },
        {
            // ### `_readNamedGraphLabel` reads a blank node label of a named graph
            key: "_readNamedGraphBlankLabel",
            value: function _readNamedGraphBlankLabel(token) {
                if (token.type !== ']') return this._error('Invalid graph label', token);
                this._subject = this._factory.blankNode();
                return this._readGraph;
            }
        },
        {
            // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
            key: "_readDeclarationPunctuation",
            value: function _readDeclarationPunctuation(token) {
                // SPARQL-style declarations don't have punctuation
                if (this._sparqlStyle) {
                    this._sparqlStyle = false;
                    return this._readInTopContext(token);
                }
                if (token.type !== '.') return this._error('Expected declaration to end with a dot', token);
                return this._readInTopContext;
            }
        },
        {
            // Reads a list of quantified symbols from a @forSome or @forAll statement
            key: "_readQuantifierList",
            value: function _readQuantifierList(token) {
                var entity;
                switch(token.type){
                    case 'IRI':
                    case 'prefixed':
                        if ((entity = this._readEntity(token, true)) !== undefined) break;
                    default:
                        return this._error("Unexpected ".concat(token.type), token);
                }
                // Without explicit quantifiers, map entities to a quantified entity
                if (!this._explicitQuantifiers) this._quantified[entity.id] = this._factory[this._quantifier](this._factory.blankNode().value);
                else {
                    // If this is the first item, start a new quantifier list
                    if (this._subject === null) this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._factory.blankNode(), this.QUANTIFIERS_GRAPH);
                    else this._emit(this._subject, this.RDF_REST, this._subject = this._factory.blankNode(), this.QUANTIFIERS_GRAPH);
                    // Output the list item
                    this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
                }
                return this._readQuantifierPunctuation;
            }
        },
        {
            // Reads punctuation from a @forSome or @forAll statement
            key: "_readQuantifierPunctuation",
            value: function _readQuantifierPunctuation(token) {
                // Read more quantifiers
                if (token.type === ',') return this._readQuantifierList;
                else {
                    // With explicit quantifiers, close the quantifier list
                    if (this._explicitQuantifiers) {
                        this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
                        this._subject = null;
                    }
                    // Read a dot
                    this._readCallback = this._getContextEndReader();
                    return this._readCallback(token);
                }
            }
        },
        {
            // ### `_getPathReader` reads a potential path and then resumes with the given function
            key: "_getPathReader",
            value: function _getPathReader(afterPath) {
                this._afterPath = afterPath;
                return this._readPath;
            }
        },
        {
            // ### `_readPath` reads a potential path
            key: "_readPath",
            value: function _readPath(token) {
                switch(token.type){
                    // Forward path
                    case '!':
                        return this._readForwardPath;
                    // Backward path
                    case '^':
                        return this._readBackwardPath;
                    // Not a path; resume reading where we left off
                    default:
                        var stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
                        // If we were reading a list item, we still need to output it
                        if (parent && parent.type === 'item') {
                            // The list item is the remaining subejct after reading the path
                            var item = this._subject;
                            // Switch back to the context of the list
                            this._restoreContext('item', token);
                            // Output the list item
                            this._emit(this._subject, this.RDF_FIRST, item, this._graph);
                        }
                        return this._afterPath(token);
                }
            }
        },
        {
            // ### `_readForwardPath` reads a '!' path
            key: "_readForwardPath",
            value: function _readForwardPath(token) {
                var subject, predicate;
                var object = this._factory.blankNode();
                // The next token is the predicate
                if ((predicate = this._readEntity(token)) === undefined) return;
                // If we were reading a subject, replace the subject by the path's object
                if (this._predicate === null) subject = this._subject, this._subject = object;
                else subject = this._object, this._object = object;
                // Emit the path's current quad and read its next section
                this._emit(subject, predicate, object, this._graph);
                return this._readPath;
            }
        },
        {
            // ### `_readBackwardPath` reads a '^' path
            key: "_readBackwardPath",
            value: function _readBackwardPath(token) {
                var subject = this._factory.blankNode();
                var predicate, object;
                // The next token is the predicate
                if ((predicate = this._readEntity(token)) === undefined) return;
                // If we were reading a subject, replace the subject by the path's subject
                if (this._predicate === null) object = this._subject, this._subject = subject;
                else object = this._object, this._object = subject;
                // Emit the path's current quad and read its next section
                this._emit(subject, predicate, object, this._graph);
                return this._readPath;
            }
        },
        {
            // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF-star quad or the end of a nested RDF-star triple
            key: "_readRDFStarTailOrGraph",
            value: function _readRDFStarTailOrGraph(token) {
                if (token.type !== '>>') {
                    // An entity means this is a quad (only allowed if not already inside a graph)
                    if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== undefined) return this._readRDFStarTail;
                    return this._error('Expected >> to follow "'.concat(this._object.id, '"'), token);
                }
                return this._readRDFStarTail(token);
            }
        },
        {
            // ### `_readRDFStarTail` reads the end of a nested RDF-star triple
            key: "_readRDFStarTail",
            value: function _readRDFStarTail(token) {
                if (token.type !== '>>') return this._error("Expected >> but got ".concat(token.type), token);
                // Read the quad and restore the previous context
                var quad = this._factory.quad(this._subject, this._predicate, this._object, this._graph || this.DEFAULTGRAPH);
                this._restoreContext('<<', token);
                // If the triple was the subject, continue by reading the predicate.
                if (this._subject === null) {
                    this._subject = quad;
                    return this._readPredicate;
                } else {
                    this._object = quad;
                    return this._getContextEndReader();
                }
            }
        },
        {
            // ### `_getContextEndReader` gets the next reader function at the end of a context
            key: "_getContextEndReader",
            value: function _getContextEndReader() {
                var contextStack = this._contextStack;
                if (!contextStack.length) return this._readPunctuation;
                switch(contextStack[contextStack.length - 1].type){
                    case 'blank':
                        return this._readBlankNodeTail;
                    case 'list':
                        return this._readListItem;
                    case 'formula':
                        return this._readFormulaTail;
                    case '<<':
                        return this._readRDFStarTailOrGraph;
                }
            }
        },
        {
            // ### `_emit` sends a quad through the callback
            key: "_emit",
            value: function _emit(subject, predicate, object, graph) {
                this._callback(null, this._factory.quad(subject, predicate, object, graph || this.DEFAULTGRAPH));
            }
        },
        {
            // ### `_error` emits an error message through the callback
            key: "_error",
            value: function _error(message, token) {
                var err = new Error("".concat(message, " on line ").concat(token.line, "."));
                err.context = {
                    token: token,
                    line: token.line,
                    previousToken: this._lexer.previousToken
                };
                this._callback(err);
                this._callback = $32a97ab54f532a77$var$noop;
            }
        },
        {
            // ### `_resolveIRI` resolves an IRI against the base path
            key: "_resolveIRI",
            value: function _resolveIRI(iri) {
                return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
            }
        },
        {
            // ### `_resolveRelativeIRI` resolves an IRI against the base path,
            // assuming that a base path has been set and that the IRI is indeed relative
            key: "_resolveRelativeIRI",
            value: function _resolveRelativeIRI(iri) {
                // An empty relative IRI indicates the base IRI
                if (!iri.length) return this._base;
                // Decide resolving strategy based in the first character
                switch(iri[0]){
                    // Resolve relative fragment IRIs against the base IRI
                    case '#':
                        return this._base + iri;
                    // Resolve relative query string IRIs by replacing the query string
                    case '?':
                        return this._base.replace(/(?:\?.*)?$/, iri);
                    // Resolve root-relative IRIs at the root of the base IRI
                    case '/':
                        // Resolve scheme-relative IRIs to the scheme
                        return (iri[1] === '/' ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
                    // Resolve all other IRIs at the base IRI's path
                    default:
                        // Relative IRIs cannot contain a colon in the first path segment
                        return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
                }
            }
        },
        {
            // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
            key: "_removeDotSegments",
            value: function _removeDotSegments(iri) {
                // Don't modify the IRI if it does not contain any dot segments
                if (!/(^|\/)\.\.?($|[/#?])/.test(iri)) return iri;
                // Start with an imaginary slash before the IRI in order to resolve trailing './' and '../'
                var length = iri.length;
                var result = '', i = -1, pathStart = -1, segmentStart = 0, next = '/';
                while(i < length){
                    switch(next){
                        // The path starts with the first slash after the authority
                        case ':':
                            if (pathStart < 0) {
                                // Skip two slashes before the authority
                                if (iri[++i] === '/' && iri[++i] === '/') // Skip to slash after the authority
                                while((pathStart = i + 1) < length && iri[pathStart] !== '/')i = pathStart;
                            }
                            break;
                        // Don't modify a query string or fragment
                        case '?':
                        case '#':
                            i = length;
                            break;
                        // Handle '/.' or '/..' path segments
                        case '/':
                            if (iri[i + 1] === '.') {
                                next = iri[++i + 1];
                                switch(next){
                                    // Remove a '/.' segment
                                    case '/':
                                        result += iri.substring(segmentStart, i - 1);
                                        segmentStart = i + 1;
                                        break;
                                    // Remove a trailing '/.' segment
                                    case undefined:
                                    case '?':
                                    case '#':
                                        return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
                                    // Remove a '/..' segment
                                    case '.':
                                        next = iri[++i + 1];
                                        if (next === undefined || next === '/' || next === '?' || next === '#') {
                                            result += iri.substring(segmentStart, i - 2);
                                            // Try to remove the parent path from result
                                            if ((segmentStart = result.lastIndexOf('/')) >= pathStart) result = result.substr(0, segmentStart);
                                            // Remove a trailing '/..' segment
                                            if (next !== '/') return "".concat(result, "/").concat(iri.substr(i + 1));
                                            segmentStart = i + 1;
                                        }
                                }
                            }
                    }
                    next = iri[++i];
                }
                return result + iri.substring(segmentStart);
            }
        },
        {
            // ## Public methods
            // ### `parse` parses the N3 input and emits each parsed quad through the onQuad callback.
            key: "parse",
            value: function parse(input, quadCallback, prefixCallback) {
                var _this = this;
                // The second parameter accepts an object { onQuad: ..., onPrefix: ..., onComment: ...}
                // As a second and third parameter it still accepts a separate quadCallback and prefixCallback for backward compatibility as well
                var onQuad, onPrefix, onComment;
                if (quadCallback && (quadCallback.onQuad || quadCallback.onPrefix || quadCallback.onComment)) {
                    onQuad = quadCallback.onQuad;
                    onPrefix = quadCallback.onPrefix;
                    onComment = quadCallback.onComment;
                } else {
                    onQuad = quadCallback;
                    onPrefix = prefixCallback;
                }
                // The read callback is the next function to be executed when a token arrives.
                // We start reading in the top context.
                this._readCallback = this._readInTopContext;
                this._sparqlStyle = false;
                this._prefixes = Object.create(null);
                this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : "b".concat($32a97ab54f532a77$var$blankNodePrefix++, "_");
                this._prefixCallback = onPrefix || $32a97ab54f532a77$var$noop;
                this._inversePredicate = false;
                this._quantified = Object.create(null);
                // Parse synchronously if no quad callback is given
                if (!onQuad) {
                    var quads = [];
                    var error;
                    this._callback = function(e, t) {
                        e ? error = e : t && quads.push(t);
                    };
                    this._lexer.tokenize(input).every(function(token) {
                        return _this._readCallback = _this._readCallback(token);
                    });
                    if (error) throw error;
                    return quads;
                }
                var processNextToken = function(error, token) {
                    if (error !== null) _this._callback(error), _this._callback = $32a97ab54f532a77$var$noop;
                    else if (_this._readCallback) _this._readCallback = _this._readCallback(token);
                };
                // Enable checking for comments on every token when a commentCallback has been set
                if (onComment) {
                    // Enable the lexer to return comments as tokens first (disabled by default)
                    this._lexer.comments = true;
                    // Patch the processNextToken function
                    processNextToken = function(error, token) {
                        if (error !== null) _this._callback(error), _this._callback = $32a97ab54f532a77$var$noop;
                        else if (_this._readCallback) {
                            if (token.type === 'comment') onComment(token.value);
                            else _this._readCallback = _this._readCallback(token);
                        }
                    };
                }
                // Parse asynchronously otherwise, executing the read callback when a token arrives
                this._callback = onQuad;
                this._lexer.tokenize(input, processNextToken);
            }
        }
    ], [
        {
            key: "_resetBlankNodePrefix",
            value: // ## Static class methods
            // ### `_resetBlankNodePrefix` restarts blank node prefix identification
            function _resetBlankNodePrefix() {
                $32a97ab54f532a77$var$blankNodePrefix = 0;
            }
        }
    ]);
    return N3Parser;
}();
// The empty function
function $32a97ab54f532a77$var$noop() {}
// Initializes the parser with the given data factory
function $32a97ab54f532a77$var$initDataFactory(parser, factory) {
    parser._factory = factory;
    parser.DEFAULTGRAPH = factory.defaultGraph();
    // Set common named nodes
    parser.RDF_FIRST = factory.namedNode((0, $kEnRi.default).rdf.first);
    parser.RDF_REST = factory.namedNode((0, $kEnRi.default).rdf.rest);
    parser.RDF_NIL = factory.namedNode((0, $kEnRi.default).rdf.nil);
    parser.N3_FORALL = factory.namedNode((0, $kEnRi.default).r.forAll);
    parser.N3_FORSOME = factory.namedNode((0, $kEnRi.default).r.forSome);
    parser.ABBREVIATIONS = {
        a: factory.namedNode((0, $kEnRi.default).rdf.type),
        '=': factory.namedNode((0, $kEnRi.default).owl.sameAs),
        '>': factory.namedNode((0, $kEnRi.default).log.implies),
        '<': factory.namedNode((0, $kEnRi.default).log.isImpliedBy)
    };
    parser.QUANTIFIERS_GRAPH = factory.namedNode('urn:n3:quantifiers');
}
$32a97ab54f532a77$var$initDataFactory($32a97ab54f532a77$export$2e2bcd8739ae039.prototype, (0, $ha9LD.default));

});
parcelRegister("ha9LD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7eaf26eb68e21df$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Term", function () { return $c7eaf26eb68e21df$export$656c1e606ad06131; });
$parcel$export(module.exports, "NamedNode", function () { return $c7eaf26eb68e21df$export$e55689a56c4c92c2; });
$parcel$export(module.exports, "Literal", function () { return $c7eaf26eb68e21df$export$e175ae9e414693bc; });
$parcel$export(module.exports, "BlankNode", function () { return $c7eaf26eb68e21df$export$1a8019c085269883; });
$parcel$export(module.exports, "Variable", function () { return $c7eaf26eb68e21df$export$c867a5c9595a1350; });
$parcel$export(module.exports, "DefaultGraph", function () { return $c7eaf26eb68e21df$export$4383f89a7161b240; });
$parcel$export(module.exports, "termFromId", function () { return $c7eaf26eb68e21df$export$85285e91bbd99cf; });
$parcel$export(module.exports, "termToId", function () { return $c7eaf26eb68e21df$export$fbf03d1179c9227e; });
$parcel$export(module.exports, "Quad", function () { return $c7eaf26eb68e21df$export$7005c9eb6671414d; });
$parcel$export(module.exports, "Triple", function () { return $c7eaf26eb68e21df$export$7005c9eb6671414d; });
// N3.js implementations of the RDF/JS core data types
// See http://rdf.js.org/data-model-spec/

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $foTGJ = parcelRequire("foTGJ");

var $kEnRi = parcelRequire("kEnRi");
var $c7eaf26eb68e21df$var$rdf = (0, $kEnRi.default).rdf, $c7eaf26eb68e21df$var$xsd = (0, $kEnRi.default).xsd;
// eslint-disable-next-line prefer-const
var $c7eaf26eb68e21df$var$DEFAULTGRAPH;
var $c7eaf26eb68e21df$var$_blankNodeCounter = 0;
var $c7eaf26eb68e21df$var$escapedLiteral = /^"(.*".*)(?="[^"]*$)/;
// ## DataFactory singleton
var $c7eaf26eb68e21df$var$DataFactory = {
    namedNode: $c7eaf26eb68e21df$var$namedNode,
    blankNode: $c7eaf26eb68e21df$var$blankNode,
    variable: $c7eaf26eb68e21df$var$variable,
    literal: $c7eaf26eb68e21df$var$literal,
    defaultGraph: $c7eaf26eb68e21df$var$defaultGraph,
    quad: $c7eaf26eb68e21df$var$quad,
    triple: $c7eaf26eb68e21df$var$quad,
    fromTerm: $c7eaf26eb68e21df$export$5f4f0fc25db47ca3,
    fromQuad: $c7eaf26eb68e21df$export$10a0669b95c12803
};
var $c7eaf26eb68e21df$export$2e2bcd8739ae039 = $c7eaf26eb68e21df$var$DataFactory;
var $c7eaf26eb68e21df$export$656c1e606ad06131 = /*#__PURE__*/ function() {
    "use strict";
    function Term(id) {
        (0, $jGAMp._)(this, Term);
        this.id = id;
    }
    (0, $byiyg._)(Term, [
        {
            key: "value",
            get: // ### The value of this term
            function get() {
                return this.id;
            }
        },
        {
            // ### Returns whether this object represents the same term as the other
            key: "equals",
            value: function equals(other) {
                // If both terms were created by this library,
                // equality can be computed through ids
                if (other instanceof Term) return this.id === other.id;
                // Otherwise, compare term type and value
                return !!other && this.termType === other.termType && this.value === other.value;
            }
        },
        {
            // ### Implement hashCode for Immutable.js, since we implement `equals`
            // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
            key: "hashCode",
            value: function hashCode() {
                return 0;
            }
        },
        {
            // ### Returns a plain object representation of this term
            key: "toJSON",
            value: function toJSON() {
                return {
                    termType: this.termType,
                    value: this.value
                };
            }
        }
    ]);
    return Term;
}();
var $c7eaf26eb68e21df$export$e55689a56c4c92c2 = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(NamedNode, Term);
    function NamedNode() {
        (0, $jGAMp._)(this, NamedNode);
        return (0, $kzDuW._)(this, NamedNode, arguments);
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'NamedNode';
            }
        }
    ]);
    return NamedNode;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
var $c7eaf26eb68e21df$export$e175ae9e414693bc = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(Literal, Term);
    function Literal() {
        (0, $jGAMp._)(this, Literal);
        return (0, $kzDuW._)(this, Literal, arguments);
    }
    (0, $byiyg._)(Literal, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'Literal';
            }
        },
        {
            key: "value",
            get: // ### The text value of this literal
            function get() {
                return this.id.substring(1, this.id.lastIndexOf('"'));
            }
        },
        {
            key: "language",
            get: // ### The language of this literal
            function get() {
                // Find the last quotation mark (e.g., '"abc"@en-us')
                var id = this.id;
                var atPos = id.lastIndexOf('"') + 1;
                // If "@" it follows, return the remaining substring; empty otherwise
                return atPos < id.length && id[atPos++] === '@' ? id.substr(atPos).toLowerCase() : '';
            }
        },
        {
            key: "datatype",
            get: // ### The datatype IRI of this literal
            function get() {
                return new $c7eaf26eb68e21df$export$e55689a56c4c92c2(this.datatypeString);
            }
        },
        {
            key: "datatypeString",
            get: // ### The datatype string of this literal
            function get() {
                // Find the last quotation mark (e.g., '"abc"^^http://ex.org/types#t')
                var id = this.id, dtPos = id.lastIndexOf('"') + 1;
                var char = dtPos < id.length ? id[dtPos] : '';
                // If "^" it follows, return the remaining substring
                return char === '^' ? id.substr(dtPos + 2) : // If "@" follows, return rdf:langString; xsd:string otherwise
                char !== '@' ? $c7eaf26eb68e21df$var$xsd.string : $c7eaf26eb68e21df$var$rdf.langString;
            }
        },
        {
            // ### Returns whether this object represents the same term as the other
            key: "equals",
            value: function equals(other) {
                // If both literals were created by this library,
                // equality can be computed through ids
                if (other instanceof Literal) return this.id === other.id;
                // Otherwise, compare term type, value, language, and datatype
                return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    termType: this.termType,
                    value: this.value,
                    language: this.language,
                    datatype: {
                        termType: 'NamedNode',
                        value: this.datatypeString
                    }
                };
            }
        }
    ]);
    return Literal;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
var $c7eaf26eb68e21df$export$1a8019c085269883 = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(BlankNode, Term);
    function BlankNode(name) {
        (0, $jGAMp._)(this, BlankNode);
        return (0, $kzDuW._)(this, BlankNode, [
            "_:".concat(name)
        ]);
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'BlankNode';
            }
        },
        {
            key: "value",
            get: // ### The name of this blank node
            function get() {
                return this.id.substr(2);
            }
        }
    ]);
    return BlankNode;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
var $c7eaf26eb68e21df$export$c867a5c9595a1350 = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(Variable, Term);
    function Variable(name) {
        (0, $jGAMp._)(this, Variable);
        return (0, $kzDuW._)(this, Variable, [
            "?".concat(name)
        ]);
    }
    (0, $byiyg._)(Variable, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'Variable';
            }
        },
        {
            key: "value",
            get: // ### The name of this variable
            function get() {
                return this.id.substr(1);
            }
        }
    ]);
    return Variable;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
var $c7eaf26eb68e21df$export$4383f89a7161b240 = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(DefaultGraph, Term);
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        var _this;
        _this = (0, $kzDuW._)(this, DefaultGraph, [
            ''
        ]);
        return (0, $foTGJ._)(_this, $c7eaf26eb68e21df$var$DEFAULTGRAPH || _this);
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'DefaultGraph';
            }
        },
        {
            // ### Returns whether this object represents the same term as the other
            key: "equals",
            value: function equals(other) {
                // If both terms were created by this library,
                // equality can be computed through strict equality;
                // otherwise, compare term types.
                return this === other || !!other && this.termType === other.termType;
            }
        }
    ]);
    return DefaultGraph;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
// ## DefaultGraph singleton
$c7eaf26eb68e21df$var$DEFAULTGRAPH = new $c7eaf26eb68e21df$export$4383f89a7161b240();
function $c7eaf26eb68e21df$export$85285e91bbd99cf(id, factory, nested) {
    factory = factory || $c7eaf26eb68e21df$var$DataFactory;
    // Falsy value or empty string indicate the default graph
    if (!id) return factory.defaultGraph();
    // Identify the term type based on the first character
    switch(id[0]){
        case '?':
            return factory.variable(id.substr(1));
        case '_':
            return factory.blankNode(id.substr(2));
        case '"':
            // Shortcut for internal literals
            if (factory === $c7eaf26eb68e21df$var$DataFactory) return new $c7eaf26eb68e21df$export$e175ae9e414693bc(id);
            // Literal without datatype or language
            if (id[id.length - 1] === '"') return factory.literal(id.substr(1, id.length - 2));
            // Literal with datatype or language
            var endPos = id.lastIndexOf('"', id.length - 1);
            return factory.literal(id.substr(1, endPos - 1), id[endPos + 1] === '@' ? id.substr(endPos + 2) : factory.namedNode(id.substr(endPos + 3)));
        case '[':
            id = JSON.parse(id);
            break;
        default:
            if (!nested || !Array.isArray(id)) return factory.namedNode(id);
    }
    return factory.quad($c7eaf26eb68e21df$export$85285e91bbd99cf(id[0], factory, true), $c7eaf26eb68e21df$export$85285e91bbd99cf(id[1], factory, true), $c7eaf26eb68e21df$export$85285e91bbd99cf(id[2], factory, true), id[3] && $c7eaf26eb68e21df$export$85285e91bbd99cf(id[3], factory, true));
}
function $c7eaf26eb68e21df$export$fbf03d1179c9227e(term, nested) {
    if (typeof term === 'string') return term;
    if (term instanceof $c7eaf26eb68e21df$export$656c1e606ad06131 && term.termType !== 'Quad') return term.id;
    if (!term) return $c7eaf26eb68e21df$var$DEFAULTGRAPH.id;
    // Term instantiated with another library
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return "_:".concat(term.value);
        case 'Variable':
            return "?".concat(term.value);
        case 'DefaultGraph':
            return '';
        case 'Literal':
            return '"'.concat(term.value, '"').concat(term.language ? "@".concat(term.language) : term.datatype && term.datatype.value !== $c7eaf26eb68e21df$var$xsd.string ? "^^".concat(term.datatype.value) : '');
        case 'Quad':
            var res = [
                $c7eaf26eb68e21df$export$fbf03d1179c9227e(term.subject, true),
                $c7eaf26eb68e21df$export$fbf03d1179c9227e(term.predicate, true),
                $c7eaf26eb68e21df$export$fbf03d1179c9227e(term.object, true)
            ];
            if (term.graph && term.graph.termType !== 'DefaultGraph') res.push($c7eaf26eb68e21df$export$fbf03d1179c9227e(term.graph, true));
            return nested ? res : JSON.stringify(res);
        default:
            throw new Error("Unexpected termType: ".concat(term.termType));
    }
}
var $c7eaf26eb68e21df$export$7005c9eb6671414d = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(Quad, Term);
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        var _this;
        _this = (0, $kzDuW._)(this, Quad, [
            ''
        ]);
        _this._subject = subject;
        _this._predicate = predicate;
        _this._object = object;
        _this._graph = graph || $c7eaf26eb68e21df$var$DEFAULTGRAPH;
        return _this;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "termType",
            get: // ### The term type of this term
            function get() {
                return 'Quad';
            }
        },
        {
            key: "subject",
            get: function get() {
                return this._subject;
            }
        },
        {
            key: "predicate",
            get: function get() {
                return this._predicate;
            }
        },
        {
            key: "object",
            get: function get() {
                return this._object;
            }
        },
        {
            key: "graph",
            get: function get() {
                return this._graph;
            }
        },
        {
            // ### Returns a plain object representation of this quad
            key: "toJSON",
            value: function toJSON() {
                return {
                    termType: this.termType,
                    subject: this._subject.toJSON(),
                    predicate: this._predicate.toJSON(),
                    object: this._object.toJSON(),
                    graph: this._graph.toJSON()
                };
            }
        },
        {
            // ### Returns whether this object represents the same quad as the other
            key: "equals",
            value: function equals(other) {
                return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
            }
        }
    ]);
    return Quad;
}($c7eaf26eb68e21df$export$656c1e606ad06131);
function $c7eaf26eb68e21df$export$3ff8cecf0aa87c28(id) {
    return id.replace($c7eaf26eb68e21df$var$escapedLiteral, function(_, quoted) {
        return '"'.concat(quoted.replace(/"/g, '""'));
    });
}
function $c7eaf26eb68e21df$export$7cedbcd33d1bf915(id) {
    return id.replace($c7eaf26eb68e21df$var$escapedLiteral, function(_, quoted) {
        return '"'.concat(quoted.replace(/""/g, '"'));
    });
}
// ### Creates an IRI
function $c7eaf26eb68e21df$var$namedNode(iri) {
    return new $c7eaf26eb68e21df$export$e55689a56c4c92c2(iri);
}
// ### Creates a blank node
function $c7eaf26eb68e21df$var$blankNode(name) {
    return new $c7eaf26eb68e21df$export$1a8019c085269883(name || "n3-".concat($c7eaf26eb68e21df$var$_blankNodeCounter++));
}
// ### Creates a literal
function $c7eaf26eb68e21df$var$literal(value, languageOrDataType) {
    // Create a language-tagged string
    if (typeof languageOrDataType === 'string') return new $c7eaf26eb68e21df$export$e175ae9e414693bc('"'.concat(value, '"@').concat(languageOrDataType.toLowerCase()));
    // Automatically determine datatype for booleans and numbers
    var datatype = languageOrDataType ? languageOrDataType.value : '';
    if (datatype === '') {
        // Convert a boolean
        if (typeof value === 'boolean') datatype = $c7eaf26eb68e21df$var$xsd["boolean"];
        else if (typeof value === 'number') {
            if (Number.isFinite(value)) datatype = Number.isInteger(value) ? $c7eaf26eb68e21df$var$xsd.integer : $c7eaf26eb68e21df$var$xsd["double"];
            else {
                datatype = $c7eaf26eb68e21df$var$xsd["double"];
                if (!Number.isNaN(value)) value = value > 0 ? 'INF' : '-INF';
            }
        }
    }
    // Create a datatyped literal
    return datatype === '' || datatype === $c7eaf26eb68e21df$var$xsd.string ? new $c7eaf26eb68e21df$export$e175ae9e414693bc('"'.concat(value, '"')) : new $c7eaf26eb68e21df$export$e175ae9e414693bc('"'.concat(value, '"^^').concat(datatype));
}
// ### Creates a variable
function $c7eaf26eb68e21df$var$variable(name) {
    return new $c7eaf26eb68e21df$export$c867a5c9595a1350(name);
}
// ### Returns the default graph
function $c7eaf26eb68e21df$var$defaultGraph() {
    return $c7eaf26eb68e21df$var$DEFAULTGRAPH;
}
// ### Creates a quad
function $c7eaf26eb68e21df$var$quad(subject, predicate, object, graph) {
    return new $c7eaf26eb68e21df$export$7005c9eb6671414d(subject, predicate, object, graph);
}
function $c7eaf26eb68e21df$export$5f4f0fc25db47ca3(term) {
    if (term instanceof $c7eaf26eb68e21df$export$656c1e606ad06131) return term;
    // Term instantiated with another library
    switch(term.termType){
        case 'NamedNode':
            return $c7eaf26eb68e21df$var$namedNode(term.value);
        case 'BlankNode':
            return $c7eaf26eb68e21df$var$blankNode(term.value);
        case 'Variable':
            return $c7eaf26eb68e21df$var$variable(term.value);
        case 'DefaultGraph':
            return $c7eaf26eb68e21df$var$DEFAULTGRAPH;
        case 'Literal':
            return $c7eaf26eb68e21df$var$literal(term.value, term.language || term.datatype);
        case 'Quad':
            return $c7eaf26eb68e21df$export$10a0669b95c12803(term);
        default:
            throw new Error("Unexpected termType: ".concat(term.termType));
    }
}
function $c7eaf26eb68e21df$export$10a0669b95c12803(inQuad) {
    if (inQuad instanceof $c7eaf26eb68e21df$export$7005c9eb6671414d) return inQuad;
    if (inQuad.termType !== 'Quad') throw new Error("Unexpected termType: ".concat(inQuad.termType));
    return $c7eaf26eb68e21df$var$quad($c7eaf26eb68e21df$export$5f4f0fc25db47ca3(inQuad.subject), $c7eaf26eb68e21df$export$5f4f0fc25db47ca3(inQuad.predicate), $c7eaf26eb68e21df$export$5f4f0fc25db47ca3(inQuad.object), $c7eaf26eb68e21df$export$5f4f0fc25db47ca3(inQuad.graph));
}

});


parcelRegister("cfNAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ebd5a952af6e21c$export$2e2bcd8739ae039; });
// **N3Writer** writes N3 documents.

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $kEnRi = parcelRequire("kEnRi");

var $ha9LD = parcelRequire("ha9LD");

var $3VMHQ = parcelRequire("3VMHQ");

var $7ijlK = parcelRequire("7ijlK");

var $hNP6n = parcelRequire("hNP6n");
var $8ebd5a952af6e21c$var$DEFAULTGRAPH = (0, $ha9LD.default).defaultGraph();
var $8ebd5a952af6e21c$var$rdf = (0, $kEnRi.default).rdf, $8ebd5a952af6e21c$var$xsd = (0, $kEnRi.default).xsd;
// Characters in literals that require escaping
var $8ebd5a952af6e21c$var$escape = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/, $8ebd5a952af6e21c$var$escapeAll = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g, $8ebd5a952af6e21c$var$escapedCharacters = {
    '\\': '\\\\',
    '"': '\\"',
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '\b': '\\b',
    '\f': '\\f'
};
// ## Placeholder class to represent already pretty-printed terms
var $8ebd5a952af6e21c$var$SerializedTerm = /*#__PURE__*/ function(Term) {
    "use strict";
    (0, $i3fW3._)(SerializedTerm, Term);
    function SerializedTerm() {
        (0, $jGAMp._)(this, SerializedTerm);
        return (0, $kzDuW._)(this, SerializedTerm, arguments);
    }
    (0, $byiyg._)(SerializedTerm, [
        {
            // Pretty-printed nodes are not equal to any other node
            // (e.g., [] does not equal [])
            key: "equals",
            value: function equals(other) {
                return other === this;
            }
        }
    ]);
    return SerializedTerm;
}((0, $ha9LD.Term));
var $8ebd5a952af6e21c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3Writer(outputStream, options) {
        (0, $jGAMp._)(this, N3Writer);
        // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
        this._prefixRegex = /$0^/;
        // Shift arguments if the first argument is not a stream
        if (outputStream && typeof outputStream.write !== 'function') options = outputStream, outputStream = null;
        options = options || {};
        this._lists = options.lists;
        // If no output stream given, send the output as string through the end callback
        if (!outputStream) {
            var output = '';
            this._outputStream = {
                write: function(chunk, encoding, done) {
                    output += chunk;
                    done && done();
                },
                end: function(done) {
                    done && done(null, output);
                }
            };
            this._endStream = true;
        } else {
            this._outputStream = outputStream;
            this._endStream = options.end === undefined ? true : !!options.end;
        }
        // Initialize writer, depending on the format
        this._subject = null;
        if (!/triple|quad/i.test(options.format)) {
            this._lineMode = false;
            this._graph = $8ebd5a952af6e21c$var$DEFAULTGRAPH;
            this._prefixIRIs = Object.create(null);
            options.prefixes && this.addPrefixes(options.prefixes);
            if (options.baseIRI) this._baseIri = new (0, $7ijlK.default)(options.baseIRI);
        } else {
            this._lineMode = true;
            this._writeQuad = this._writeQuadLine;
        }
    }
    (0, $byiyg._)(N3Writer, [
        {
            key: "_inDefaultGraph",
            get: // ## Private methods
            // ### Whether the current graph is the default graph
            function get() {
                return $8ebd5a952af6e21c$var$DEFAULTGRAPH.equals(this._graph);
            }
        },
        {
            // ### `_write` writes the argument to the output stream
            key: "_write",
            value: function _write(string, callback) {
                this._outputStream.write(string, 'utf8', callback);
            }
        },
        {
            // ### `_writeQuad` writes the quad to the output stream
            key: "_writeQuad",
            value: function _writeQuad(subject, predicate, object, graph, done) {
                try {
                    // Write the graph's label if it has changed
                    if (!graph.equals(this._graph)) {
                        // Close the previous graph and start the new one
                        this._write((this._subject === null ? '' : this._inDefaultGraph ? '.\n' : '\n}\n') + ($8ebd5a952af6e21c$var$DEFAULTGRAPH.equals(graph) ? '' : "".concat(this._encodeIriOrBlank(graph), " {\n")));
                        this._graph = graph;
                        this._subject = null;
                    }
                    // Don't repeat the subject if it's the same
                    if (subject.equals(this._subject)) {
                        // Don't repeat the predicate if it's the same
                        if (predicate.equals(this._predicate)) this._write(", ".concat(this._encodeObject(object)), done);
                        else this._write(";\n    ".concat(this._encodePredicate(this._predicate = predicate), " ").concat(this._encodeObject(object)), done);
                    } else this._write("".concat((this._subject === null ? '' : '.\n') + this._encodeSubject(this._subject = subject), " ").concat(this._encodePredicate(this._predicate = predicate), " ").concat(this._encodeObject(object)), done);
                } catch (error) {
                    done && done(error);
                }
            }
        },
        {
            // ### `_writeQuadLine` writes the quad to the output stream as a single line
            key: "_writeQuadLine",
            value: function _writeQuadLine(subject, predicate, object, graph, done) {
                // Write the quad without prefixes
                delete this._prefixMatch;
                this._write(this.quadToString(subject, predicate, object, graph), done);
            }
        },
        {
            // ### `quadToString` serializes a quad as a string
            key: "quadToString",
            value: function quadToString(subject, predicate, object, graph) {
                return "".concat(this._encodeSubject(subject), " ").concat(this._encodeIriOrBlank(predicate), " ").concat(this._encodeObject(object)).concat(graph && graph.value ? " ".concat(this._encodeIriOrBlank(graph), " .\n") : ' .\n');
            }
        },
        {
            // ### `quadsToString` serializes an array of quads as a string
            key: "quadsToString",
            value: function quadsToString(quads) {
                var quadsString = '';
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = quads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        quadsString += this.quadToString(quad.subject, quad.predicate, quad.object, quad.graph);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return quadsString;
            }
        },
        {
            // ### `_encodeSubject` represents a subject
            key: "_encodeSubject",
            value: function _encodeSubject(entity) {
                return entity.termType === 'Quad' ? this._encodeQuad(entity) : this._encodeIriOrBlank(entity);
            }
        },
        {
            // ### `_encodeIriOrBlank` represents an IRI or blank node
            key: "_encodeIriOrBlank",
            value: function _encodeIriOrBlank(entity) {
                // A blank node or list is represented as-is
                if (entity.termType !== 'NamedNode') {
                    // If it is a list head, pretty-print it
                    if (this._lists && entity.value in this._lists) entity = this.list(this._lists[entity.value]);
                    return 'id' in entity ? entity.id : "_:".concat(entity.value);
                }
                var iri = entity.value;
                // Use relative IRIs if requested and possible
                if (this._baseIri) iri = this._baseIri.toRelative(iri);
                // Escape special characters
                if ($8ebd5a952af6e21c$var$escape.test(iri)) iri = iri.replace($8ebd5a952af6e21c$var$escapeAll, $8ebd5a952af6e21c$var$characterReplacer);
                // Try to represent the IRI as prefixed name
                var prefixMatch = this._prefixRegex.exec(iri);
                return !prefixMatch ? "<".concat(iri, ">") : !prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2];
            }
        },
        {
            // ### `_encodeLiteral` represents a literal
            key: "_encodeLiteral",
            value: function _encodeLiteral(literal) {
                // Escape special characters
                var value = literal.value;
                if ($8ebd5a952af6e21c$var$escape.test(value)) value = value.replace($8ebd5a952af6e21c$var$escapeAll, $8ebd5a952af6e21c$var$characterReplacer);
                // Write a language-tagged literal
                if (literal.language) return '"'.concat(value, '"@').concat(literal.language);
                // Write dedicated literals per data type
                if (this._lineMode) {
                    // Only abbreviate strings in N-Triples or N-Quads
                    if (literal.datatype.value === $8ebd5a952af6e21c$var$xsd.string) return '"'.concat(value, '"');
                } else // Use common datatype abbreviations in Turtle or TriG
                switch(literal.datatype.value){
                    case $8ebd5a952af6e21c$var$xsd.string:
                        return '"'.concat(value, '"');
                    case $8ebd5a952af6e21c$var$xsd["boolean"]:
                        if (value === 'true' || value === 'false') return value;
                        break;
                    case $8ebd5a952af6e21c$var$xsd.integer:
                        if (/^[+-]?\d+$/.test(value)) return value;
                        break;
                    case $8ebd5a952af6e21c$var$xsd.decimal:
                        if (/^[+-]?\d*\.\d+$/.test(value)) return value;
                        break;
                    case $8ebd5a952af6e21c$var$xsd["double"]:
                        if (/^[+-]?(?:\d+\.\d*|\.?\d+)[eE][+-]?\d+$/.test(value)) return value;
                        break;
                }
                // Write a regular datatyped literal
                return '"'.concat(value, '"^^').concat(this._encodeIriOrBlank(literal.datatype));
            }
        },
        {
            // ### `_encodePredicate` represents a predicate
            key: "_encodePredicate",
            value: function _encodePredicate(predicate) {
                return predicate.value === $8ebd5a952af6e21c$var$rdf.type ? 'a' : this._encodeIriOrBlank(predicate);
            }
        },
        {
            // ### `_encodeObject` represents an object
            key: "_encodeObject",
            value: function _encodeObject(object) {
                switch(object.termType){
                    case 'Quad':
                        return this._encodeQuad(object);
                    case 'Literal':
                        return this._encodeLiteral(object);
                    default:
                        return this._encodeIriOrBlank(object);
                }
            }
        },
        {
            // ### `_encodeQuad` encodes an RDF-star quad
            key: "_encodeQuad",
            value: function _encodeQuad(param) {
                var subject = param.subject, predicate = param.predicate, object = param.object, graph = param.graph;
                return "<<".concat(this._encodeSubject(subject), " ").concat(this._encodePredicate(predicate), " ").concat(this._encodeObject(object)).concat((0, $3VMHQ.isDefaultGraph)(graph) ? '' : " ".concat(this._encodeIriOrBlank(graph)), ">>");
            }
        },
        {
            // ### `_blockedWrite` replaces `_write` after the writer has been closed
            key: "_blockedWrite",
            value: function _blockedWrite() {
                throw new Error('Cannot write because the writer has been closed.');
            }
        },
        {
            // ### `addQuad` adds the quad to the output stream
            key: "addQuad",
            value: function addQuad(subject, predicate, object, graph, done) {
                // The quad was given as an object, so shift parameters
                if (object === undefined) this._writeQuad(subject.subject, subject.predicate, subject.object, subject.graph, predicate);
                else if (typeof graph === 'function') this._writeQuad(subject, predicate, object, $8ebd5a952af6e21c$var$DEFAULTGRAPH, graph);
                else this._writeQuad(subject, predicate, object, graph || $8ebd5a952af6e21c$var$DEFAULTGRAPH, done);
            }
        },
        {
            // ### `addQuads` adds the quads to the output stream
            key: "addQuads",
            value: function addQuads(quads) {
                for(var i = 0; i < quads.length; i++)this.addQuad(quads[i]);
            }
        },
        {
            // ### `addPrefix` adds the prefix to the output stream
            key: "addPrefix",
            value: function addPrefix(prefix, iri, done) {
                var prefixes = {};
                prefixes[prefix] = iri;
                this.addPrefixes(prefixes, done);
            }
        },
        {
            // ### `addPrefixes` adds the prefixes to the output stream
            key: "addPrefixes",
            value: function addPrefixes(prefixes, done) {
                // Ignore prefixes if not supported by the serialization
                if (!this._prefixIRIs) return done && done();
                // Write all new prefixes
                var hasPrefixes = false;
                for(var prefix in prefixes){
                    var iri = prefixes[prefix];
                    if (typeof iri !== 'string') iri = iri.value;
                    hasPrefixes = true;
                    // Finish a possible pending quad
                    if (this._subject !== null) {
                        this._write(this._inDefaultGraph ? '.\n' : '\n}\n');
                        this._subject = null, this._graph = '';
                    }
                    // Store and write the prefix
                    this._prefixIRIs[iri] = prefix += ':';
                    this._write("@prefix ".concat(prefix, " <").concat(iri, ">.\n"));
                }
                // Recreate the prefix matcher
                if (hasPrefixes) {
                    var IRIlist = '', prefixList = '';
                    for(var prefixIRI in this._prefixIRIs){
                        IRIlist += IRIlist ? "|".concat(prefixIRI) : prefixIRI;
                        prefixList += (prefixList ? '|' : '') + this._prefixIRIs[prefixIRI];
                    }
                    IRIlist = (0, $hNP6n.escapeRegex)(IRIlist, /[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
                    this._prefixRegex = new RegExp("^(?:".concat(prefixList, ")[^/]*$|") + "^(".concat(IRIlist, ")([_a-zA-Z0-9][\\-_a-zA-Z0-9]*)$"));
                }
                // End a prefix block with a newline
                this._write(hasPrefixes ? '\n' : '', done);
            }
        },
        {
            // ### `blank` creates a blank node with the given content
            key: "blank",
            value: function blank(predicate, object) {
                var children = predicate, child, length;
                // Empty blank node
                if (predicate === undefined) children = [];
                else if (predicate.termType) children = [
                    {
                        predicate: predicate,
                        object: object
                    }
                ];
                else if (!('length' in predicate)) children = [
                    predicate
                ];
                switch(length = children.length){
                    // Generate an empty blank node
                    case 0:
                        return new $8ebd5a952af6e21c$var$SerializedTerm('[]');
                    // Generate a non-nested one-triple blank node
                    case 1:
                        child = children[0];
                        if (!(child.object instanceof $8ebd5a952af6e21c$var$SerializedTerm)) return new $8ebd5a952af6e21c$var$SerializedTerm("[ ".concat(this._encodePredicate(child.predicate), " ").concat(this._encodeObject(child.object), " ]"));
                    // Generate a multi-triple or nested blank node
                    default:
                        var contents = '[';
                        // Write all triples in order
                        for(var i = 0; i < length; i++){
                            child = children[i];
                            // Write only the object is the predicate is the same as the previous
                            if (child.predicate.equals(predicate)) contents += ", ".concat(this._encodeObject(child.object));
                            else {
                                contents += "".concat((i ? ';\n  ' : '\n  ') + this._encodePredicate(child.predicate), " ").concat(this._encodeObject(child.object));
                                predicate = child.predicate;
                            }
                        }
                        return new $8ebd5a952af6e21c$var$SerializedTerm("".concat(contents, "\n]"));
                }
            }
        },
        {
            // ### `list` creates a list node with the given content
            key: "list",
            value: function list(elements) {
                var length = elements && elements.length || 0, contents = new Array(length);
                for(var i = 0; i < length; i++)contents[i] = this._encodeObject(elements[i]);
                return new $8ebd5a952af6e21c$var$SerializedTerm("(".concat(contents.join(' '), ")"));
            }
        },
        {
            // ### `end` signals the end of the output stream
            key: "end",
            value: function end(done) {
                // Finish a possible pending quad
                if (this._subject !== null) {
                    this._write(this._inDefaultGraph ? '.\n' : '\n}\n');
                    this._subject = null;
                }
                // Disallow further writing
                this._write = this._blockedWrite;
                // Try to end the underlying stream, ensuring done is called exactly one time
                var singleDone = done && function(error, result) {
                    singleDone = null, done(error, result);
                };
                if (this._endStream) try {
                    return this._outputStream.end(singleDone);
                } catch (error) {}
                singleDone && singleDone();
            }
        }
    ]);
    return N3Writer;
}();
// Replaces a character by its escaped version
function $8ebd5a952af6e21c$var$characterReplacer(character) {
    // Replace a single character by its escaped version
    var result = $8ebd5a952af6e21c$var$escapedCharacters[character];
    if (result === undefined) {
        // Replace a single character with its 4-bit unicode escape sequence
        if (character.length === 1) {
            result = character.charCodeAt(0).toString(16);
            result = '\\u0000'.substr(0, 6 - result.length) + result;
        } else {
            result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
            result = '\\U00000000'.substr(0, 10 - result.length) + result;
        }
    }
    return result;
}

});
parcelRegister("3VMHQ", function(module, exports) {

$parcel$export(module.exports, "isNamedNode", function () { return $2dcc7a00179784ea$export$10490ce738f72284; });
$parcel$export(module.exports, "isBlankNode", function () { return $2dcc7a00179784ea$export$7b5b4967656acaac; });
$parcel$export(module.exports, "isLiteral", function () { return $2dcc7a00179784ea$export$899158ea22bb4609; });
$parcel$export(module.exports, "isVariable", function () { return $2dcc7a00179784ea$export$670a0c046e2ed227; });
$parcel$export(module.exports, "isQuad", function () { return $2dcc7a00179784ea$export$631d618571b0cb5d; });
$parcel$export(module.exports, "isDefaultGraph", function () { return $2dcc7a00179784ea$export$1a29e0fa6b36b0c8; });
$parcel$export(module.exports, "inDefaultGraph", function () { return $2dcc7a00179784ea$export$be8c4434e9c7c90b; });
$parcel$export(module.exports, "prefix", function () { return $2dcc7a00179784ea$export$82e9f45cca5ba907; });
$parcel$export(module.exports, "prefixes", function () { return $2dcc7a00179784ea$export$5d3c3f85c29a375; });
// **N3Util** provides N3 utility functions.

var $ha9LD = parcelRequire("ha9LD");
function $2dcc7a00179784ea$export$10490ce738f72284(term) {
    return !!term && term.termType === 'NamedNode';
}
function $2dcc7a00179784ea$export$7b5b4967656acaac(term) {
    return !!term && term.termType === 'BlankNode';
}
function $2dcc7a00179784ea$export$899158ea22bb4609(term) {
    return !!term && term.termType === 'Literal';
}
function $2dcc7a00179784ea$export$670a0c046e2ed227(term) {
    return !!term && term.termType === 'Variable';
}
function $2dcc7a00179784ea$export$631d618571b0cb5d(term) {
    return !!term && term.termType === 'Quad';
}
function $2dcc7a00179784ea$export$1a29e0fa6b36b0c8(term) {
    return !!term && term.termType === 'DefaultGraph';
}
function $2dcc7a00179784ea$export$be8c4434e9c7c90b(quad) {
    return $2dcc7a00179784ea$export$1a29e0fa6b36b0c8(quad.graph);
}
function $2dcc7a00179784ea$export$82e9f45cca5ba907(iri, factory) {
    return $2dcc7a00179784ea$export$5d3c3f85c29a375({
        '': iri.value || iri
    }, factory)('');
}
function $2dcc7a00179784ea$export$5d3c3f85c29a375(defaultPrefixes, factory) {
    // Add all of the default prefixes
    var prefixes = Object.create(null);
    for(var prefix in defaultPrefixes)processPrefix(prefix, defaultPrefixes[prefix]);
    // Set the default factory if none was specified
    factory = factory || (0, $ha9LD.default);
    // Registers a new prefix (if an IRI was specified)
    // or retrieves a function that expands an existing prefix (if no IRI was specified)
    function processPrefix(prefix, iri) {
        // Create a new prefix if an IRI is specified or the prefix doesn't exist
        if (typeof iri === 'string') {
            // Create a function that expands the prefix
            var cache = Object.create(null);
            prefixes[prefix] = function(local) {
                return cache[local] || (cache[local] = factory.namedNode(iri + local));
            };
        } else if (!(prefix in prefixes)) throw new Error("Unknown prefix: ".concat(prefix));
        return prefixes[prefix];
    }
    return processPrefix;
}

});

parcelRegister("7ijlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54f93950a0fd971c$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");

var $hNP6n = parcelRequire("hNP6n");
// Do not handle base IRIs without scheme, and currently unsupported cases:
// - file: IRIs (which could also use backslashes)
// - IRIs containing /. or /.. or //
var $54f93950a0fd971c$var$BASE_UNSUPPORTED = /^:?[^:?#]*(?:[?#]|$)|^file:|^[^:]*:\/*[^?#]+?\/(?:\.\.?(?:\/|$)|\/)/i;
var $54f93950a0fd971c$var$SUFFIX_SUPPORTED = /^(?:(?:[^/?#]{3,}|\.?[^/?#.]\.?)(?:\/[^/?#]{3,}|\.?[^/?#.]\.?)*\/?)?(?:[?#]|$)/;
var $54f93950a0fd971c$var$CURRENT = './';
var $54f93950a0fd971c$var$PARENT = '../';
var $54f93950a0fd971c$var$QUERY = '?';
var $54f93950a0fd971c$var$FRAGMENT = '#';
var $54f93950a0fd971c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function BaseIRI(base) {
        (0, $jGAMp._)(this, BaseIRI);
        this.base = base;
        this._baseLength = 0;
        this._baseMatcher = null;
        this._pathReplacements = new Array(base.length + 1);
    }
    (0, $byiyg._)(BaseIRI, [
        {
            key: "_getBaseMatcher",
            value: function _getBaseMatcher() {
                if (this._baseMatcher) return this._baseMatcher;
                if (!BaseIRI.supports(this.base)) return this._baseMatcher = /.^/;
                // Extract the scheme
                var scheme = /^[^:]*:\/*/.exec(this.base)[0];
                var regexHead = [
                    '^',
                    (0, $hNP6n.escapeRegex)(scheme)
                ];
                var regexTail = [];
                // Generate a regex for every path segment
                var segments = [], segmenter = RegExp("[^/?#]*([/?#])", "y");
                var segment, query = 0, fragment = 0, last = segmenter.lastIndex = scheme.length;
                while(!query && !fragment && (segment = segmenter.exec(this.base)))// Truncate base resolution path at fragment start
                if (segment[1] === $54f93950a0fd971c$var$FRAGMENT) fragment = segmenter.lastIndex - 1;
                else {
                    // Create regex that matches the segment
                    regexHead.push((0, $hNP6n.escapeRegex)(segment[0]), '(?:');
                    regexTail.push(')?');
                    // Create dedicated query string replacement
                    if (segment[1] !== $54f93950a0fd971c$var$QUERY) segments.push(last = segmenter.lastIndex);
                    else {
                        query = last = segmenter.lastIndex;
                        fragment = this.base.indexOf($54f93950a0fd971c$var$FRAGMENT, query);
                        this._pathReplacements[query] = $54f93950a0fd971c$var$QUERY;
                    }
                }
                // Precalculate parent path substitutions
                for(var i = 0; i < segments.length; i++)this._pathReplacements[segments[i]] = $54f93950a0fd971c$var$PARENT.repeat(segments.length - i - 1);
                this._pathReplacements[segments[segments.length - 1]] = $54f93950a0fd971c$var$CURRENT;
                // Add the remainder of the base IRI (without fragment) to the regex
                this._baseLength = fragment > 0 ? fragment : this.base.length;
                regexHead.push((0, $hNP6n.escapeRegex)(this.base.substring(last, this._baseLength)), query ? '(?:#|$)' : '(?:[?#]|$)');
                return this._baseMatcher = new RegExp((0, $7WNf6._)(regexHead).concat((0, $7WNf6._)(regexTail)).join(''));
            }
        },
        {
            key: "toRelative",
            value: function toRelative(iri) {
                // Unsupported or non-matching base IRI
                var match = this._getBaseMatcher().exec(iri);
                if (!match) return iri;
                // Exact base IRI match
                var length = match[0].length;
                if (length === this._baseLength && length === iri.length) return '';
                // Parent path match
                var parentPath = this._pathReplacements[length];
                if (parentPath) {
                    var suffix = iri.substring(length);
                    // Don't abbreviate unsupported path
                    if (parentPath !== $54f93950a0fd971c$var$QUERY && !$54f93950a0fd971c$var$SUFFIX_SUPPORTED.test(suffix)) return iri;
                    // Omit ./ with fragment or query string
                    if (parentPath === $54f93950a0fd971c$var$CURRENT && /^[^?#]/.test(suffix)) return suffix;
                    // Append suffix to relative parent path
                    return parentPath + suffix;
                }
                // Fragment or query string, so include delimiter
                return iri.substring(length - 1);
            }
        }
    ], [
        {
            key: "supports",
            value: function supports(base) {
                return !$54f93950a0fd971c$var$BASE_UNSUPPORTED.test(base);
            }
        }
    ]);
    return BaseIRI;
}();

});
parcelRegister("hNP6n", function(module, exports) {

$parcel$export(module.exports, "escapeRegex", function () { return $cf5ea70caa8e4df8$export$104ed90cc1a13451; });
function $cf5ea70caa8e4df8$export$104ed90cc1a13451(regex) {
    return regex.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
}

});



parcelRegister("6rfrN", function(module, exports) {

$parcel$export(module.exports, "N3EntityIndex", function () { return $4b013f341285c075$export$4e0df93146cafeaf; });
$parcel$export(module.exports, "default", function () { return $4b013f341285c075$export$2e2bcd8739ae039; });
// **N3Store** objects store N3 quads by graph in memory.

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $f9bYj = parcelRequire("f9bYj");

var $ha9LD = parcelRequire("ha9LD");

var $kEnRi = parcelRequire("kEnRi");

var $3VMHQ = parcelRequire("3VMHQ");

var $cfNAJ = parcelRequire("cfNAJ");
var $4b013f341285c075$var$ITERATOR = Symbol('iter');
function $4b013f341285c075$var$merge(target, source) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    if (depth === 0) return Object.assign(target, source);
    for(var key in source)target[key] = $4b013f341285c075$var$merge(target[key] || Object.create(null), source[key], depth - 1);
    return target;
}
/**
 * Determines the intersection of the `_graphs` index s1 and s2.
 * s1 and s2 *must* belong to Stores that share an `_entityIndex`.
 *
 * False is returned when there is no intersection; this should
 * *not* be set as the value for an index.
 */ function $4b013f341285c075$var$intersect(s1, s2) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    var target = false;
    for(var key in s1)if (key in s2) {
        var intersection = depth === 0 ? null : $4b013f341285c075$var$intersect(s1[key], s2[key], depth - 1);
        if (intersection !== false) {
            target = target || Object.create(null);
            target[key] = intersection;
        } else if (depth === 3) return false;
    }
    return target;
}
/**
 * Determines the difference of the `_graphs` index s1 and s2.
 * s1 and s2 *must* belong to Stores that share an `_entityIndex`.
 *
 * False is returned when there is no difference; this should
 * *not* be set as the value for an index.
 */ function $4b013f341285c075$var$difference(s1, s2) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    var target = false;
    for(var key in s1){
        // When the key is not in the index, then none of the triples defined by s1[key] are
        // in s2 and so we want to copy them over to the resultant store.
        if (!(key in s2)) {
            target = target || Object.create(null);
            target[key] = depth === 0 ? null : $4b013f341285c075$var$merge({}, s1[key], depth - 1);
        } else if (depth !== 0) {
            var diff = $4b013f341285c075$var$difference(s1[key], s2[key], depth - 1);
            if (diff !== false) {
                target = target || Object.create(null);
                target[key] = diff;
            } else if (depth === 3) return false;
        }
    }
    return target;
}
var $4b013f341285c075$export$4e0df93146cafeaf = /*#__PURE__*/ function() {
    "use strict";
    function N3EntityIndex() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $jGAMp._)(this, N3EntityIndex);
        this._id = 1;
        // `_ids` maps entities such as `http://xmlns.com/foaf/0.1/name` to numbers,
        // saving memory by using only numbers as keys in `_graphs`
        this._ids = Object.create(null);
        this._ids[''] = 1;
        // inverse of `_ids`
        this._entities = Object.create(null);
        this._entities[1] = '';
        // `_blankNodeIndex` is the index of the last automatically named blank node
        this._blankNodeIndex = 0;
        this._factory = options.factory || (0, $ha9LD.default);
    }
    (0, $byiyg._)(N3EntityIndex, [
        {
            key: "_termFromId",
            value: function _termFromId(id) {
                if (id[0] === '.') {
                    var entities = this._entities;
                    var terms = id.split('.');
                    var q = this._factory.quad(this._termFromId(entities[terms[1]]), this._termFromId(entities[terms[2]]), this._termFromId(entities[terms[3]]), terms[4] && this._termFromId(entities[terms[4]]));
                    return q;
                }
                return (0, $ha9LD.termFromId)(id, this._factory);
            }
        },
        {
            key: "_termToNumericId",
            value: function _termToNumericId(term) {
                if (term.termType === 'Quad') {
                    var s = this._termToNumericId(term.subject), p = this._termToNumericId(term.predicate), o = this._termToNumericId(term.object);
                    var g;
                    return s && p && o && ((0, $3VMHQ.isDefaultGraph)(term.graph) || (g = this._termToNumericId(term.graph))) && this._ids[g ? ".".concat(s, ".").concat(p, ".").concat(o, ".").concat(g) : ".".concat(s, ".").concat(p, ".").concat(o)];
                }
                return this._ids[(0, $ha9LD.termToId)(term)];
            }
        },
        {
            key: "_termToNewNumericId",
            value: function _termToNewNumericId(term) {
                // This assumes that no graph term is present - we may wish to error if there is one
                var str = term && term.termType === 'Quad' ? ".".concat(this._termToNewNumericId(term.subject), ".").concat(this._termToNewNumericId(term.predicate), ".").concat(this._termToNewNumericId(term.object)).concat((0, $3VMHQ.isDefaultGraph)(term.graph) ? '' : ".".concat(this._termToNewNumericId(term.graph))) : (0, $ha9LD.termToId)(term);
                return this._ids[str] || (this._ids[this._entities[++this._id] = str] = this._id);
            }
        },
        {
            key: "createBlankNode",
            value: function createBlankNode(suggestedName) {
                var name, index;
                // Generate a name based on the suggested name
                if (suggestedName) {
                    name = suggestedName = "_:".concat(suggestedName), index = 1;
                    while(this._ids[name])name = suggestedName + index++;
                } else do name = "_:b".concat(this._blankNodeIndex++);
                while (this._ids[name]);
                // Add the blank node to the entities, avoiding the generation of duplicates
                this._ids[name] = ++this._id;
                this._entities[this._id] = name;
                return this._factory.blankNode(name.substr(2));
            }
        }
    ]);
    return N3EntityIndex;
}();
var $4b013f341285c075$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3Store(quads, options) {
        (0, $jGAMp._)(this, N3Store);
        // The number of quads is initially zero
        this._size = 0;
        // `_graphs` contains subject, predicate, and object indexes per graph
        this._graphs = Object.create(null);
        // Shift parameters if `quads` is not given
        if (!options && quads && !quads[0] && !(typeof quads.match === 'function')) options = quads, quads = null;
        options = options || {};
        this._factory = options.factory || (0, $ha9LD.default);
        this._entityIndex = options.entityIndex || new $4b013f341285c075$export$4e0df93146cafeaf({
            factory: this._factory
        });
        this._entities = this._entityIndex._entities;
        this._termFromId = this._entityIndex._termFromId.bind(this._entityIndex);
        this._termToNumericId = this._entityIndex._termToNumericId.bind(this._entityIndex);
        this._termToNewNumericId = this._entityIndex._termToNewNumericId.bind(this._entityIndex);
        // Add quads if passed
        if (quads) this.addAll(quads);
    }
    (0, $byiyg._)(N3Store, [
        {
            key: "size",
            get: // ## Public properties
            // ### `size` returns the number of quads in the store
            function get() {
                // Return the quad count if if was cached
                var size = this._size;
                if (size !== null) return size;
                // Calculate the number of quads by counting to the deepest level
                size = 0;
                var graphs = this._graphs;
                var subjects, subject;
                for(var graphKey in graphs)for(var subjectKey in subjects = graphs[graphKey].subjects)for(var predicateKey in subject = subjects[subjectKey])size += Object.keys(subject[predicateKey]).length;
                return this._size = size;
            }
        },
        {
            // ## Private methods
            // ### `_addToIndex` adds a quad to a three-layered index.
            // Returns if the index has changed, if the entry did not already exist.
            key: "_addToIndex",
            value: function _addToIndex(index0, key0, key1, key2) {
                // Create layers as necessary
                var index1 = index0[key0] || (index0[key0] = {});
                var index2 = index1[key1] || (index1[key1] = {});
                // Setting the key to _any_ value signals the presence of the quad
                var existed = key2 in index2;
                if (!existed) index2[key2] = null;
                return !existed;
            }
        },
        {
            // ### `_removeFromIndex` removes a quad from a three-layered index
            key: "_removeFromIndex",
            value: function _removeFromIndex(index0, key0, key1, key2) {
                // Remove the quad from the index
                var index1 = index0[key0], index2 = index1[key1];
                delete index2[key2];
                // Remove intermediary index layers if they are empty
                for(var key in index2)return;
                delete index1[key1];
                for(var key3 in index1)return;
                delete index0[key0];
            }
        },
        {
            key: "_findInIndex",
            value: // ### `_findInIndex` finds a set of quads in a three-layered index.
            // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
            // Any of these keys can be undefined, which is interpreted as a wildcard.
            // `name0`, `name1`, and `name2` are the names of the keys at each level,
            // used when reconstructing the resulting quad
            // (for instance: _subject_, _predicate_, and _object_).
            // Finally, `graphId` will be the graph of the created quads.
            function _findInIndex(index0, key0, key1, key2, name0, name1, name2, graphId) {
                var tmp, index1, index2, entityKeys, graph, parts, _tmp, _tmp1, _i, value0, _tmp2, _tmp3, _i1, value1, values, l;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            entityKeys = this._entities;
                            graph = this._termFromId(entityKeys[graphId]);
                            parts = {
                                subject: null,
                                predicate: null,
                                object: null
                            };
                            // If a key is specified, use only that part of index 0.
                            if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
                            _tmp = [];
                            for(_tmp1 in index0)_tmp.push(_tmp1);
                            _i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(_i < _tmp.length)) return [
                                3,
                                8
                            ];
                            value0 = _tmp[_i];
                            if (!(index1 = index0[value0])) return [
                                3,
                                7
                            ];
                            parts[name0] = this._termFromId(entityKeys[value0]);
                            // If a key is specified, use only that part of index 1.
                            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
                            _tmp2 = [];
                            for(_tmp3 in index1)_tmp2.push(_tmp3);
                            _i1 = 0;
                            _state.label = 2;
                        case 2:
                            if (!(_i1 < _tmp2.length)) return [
                                3,
                                7
                            ];
                            value1 = _tmp2[_i1];
                            if (!(index2 = index1[value1])) return [
                                3,
                                6
                            ];
                            parts[name1] = this._termFromId(entityKeys[value1]);
                            // If a key is specified, use only that part of index 2, if it exists.
                            values = key2 ? key2 in index2 ? [
                                key2
                            ] : [] : Object.keys(index2);
                            l = 0;
                            _state.label = 3;
                        case 3:
                            if (!(l < values.length)) return [
                                3,
                                6
                            ];
                            parts[name2] = this._termFromId(entityKeys[values[l]]);
                            return [
                                4,
                                this._factory.quad(parts.subject, parts.predicate, parts.object, graph)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            l++;
                            return [
                                3,
                                3
                            ];
                        case 6:
                            _i1++;
                            return [
                                3,
                                2
                            ];
                        case 7:
                            _i++;
                            return [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // ### `_loop` executes the callback on all keys of index 0
            key: "_loop",
            value: function _loop(index0, callback) {
                for(var key0 in index0)callback(key0);
            }
        },
        {
            // ### `_loopByKey0` executes the callback on all keys of a certain entry in index 0
            key: "_loopByKey0",
            value: function _loopByKey0(index0, key0, callback) {
                var index1, key1;
                if (index1 = index0[key0]) for(key1 in index1)callback(key1);
            }
        },
        {
            // ### `_loopByKey1` executes the callback on given keys of all entries in index 0
            key: "_loopByKey1",
            value: function _loopByKey1(index0, key1, callback) {
                var key0, index1;
                for(key0 in index0){
                    index1 = index0[key0];
                    if (index1[key1]) callback(key0);
                }
            }
        },
        {
            // ### `_loopBy2Keys` executes the callback on given keys of certain entries in index 2
            key: "_loopBy2Keys",
            value: function _loopBy2Keys(index0, key0, key1, callback) {
                var index1, index2, key2;
                if ((index1 = index0[key0]) && (index2 = index1[key1])) for(key2 in index2)callback(key2);
            }
        },
        {
            // ### `_countInIndex` counts matching quads in a three-layered index.
            // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
            // Any of these keys can be undefined, which is interpreted as a wildcard.
            key: "_countInIndex",
            value: function _countInIndex(index0, key0, key1, key2) {
                var count = 0, tmp, index1, index2;
                // If a key is specified, count only that part of index 0
                if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
                for(var value0 in index0)if (index1 = index0[value0]) {
                    // If a key is specified, count only that part of index 1
                    if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
                    for(var value1 in index1)if (index2 = index1[value1]) {
                        // If a key is specified, count the quad if it exists
                        if (key2) key2 in index2 && count++;
                        else count += Object.keys(index2).length;
                    }
                }
                return count;
            }
        },
        {
            // ### `_getGraphs` returns an array with the given graph,
            // or all graphs if the argument is null or undefined.
            key: "_getGraphs",
            value: function _getGraphs(graph) {
                graph = graph === '' ? 1 : graph && (this._termToNumericId(graph) || -1);
                return typeof graph !== 'number' ? this._graphs : (0, $cqEAj._)({}, graph, this._graphs[graph]);
            }
        },
        {
            // ### `_uniqueEntities` returns a function that accepts an entity ID
            // and passes the corresponding entity to callback if it hasn't occurred before.
            key: "_uniqueEntities",
            value: function _uniqueEntities(callback) {
                var _this = this;
                var uniqueIds = Object.create(null);
                return function(id) {
                    if (!(id in uniqueIds)) {
                        uniqueIds[id] = true;
                        callback(_this._termFromId(_this._entities[id], _this._factory));
                    }
                };
            }
        },
        {
            // ## Public methods
            // ### `add` adds the specified quad to the dataset.
            // Returns the dataset instance it was called on.
            // Existing quads, as defined in Quad.equals, will be ignored.
            key: "add",
            value: function add(quad) {
                this.addQuad(quad);
                return this;
            }
        },
        {
            // ### `addQuad` adds a new quad to the store.
            // Returns if the quad index has changed, if the quad did not already exist.
            key: "addQuad",
            value: function addQuad(subject, predicate, object, graph) {
                // Shift arguments if a quad object is given instead of components
                if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
                // Convert terms to internal string representation
                graph = graph ? this._termToNewNumericId(graph) : 1;
                // Find the graph that will contain the triple
                var graphItem = this._graphs[graph];
                // Create the graph if it doesn't exist yet
                if (!graphItem) {
                    graphItem = this._graphs[graph] = {
                        subjects: {},
                        predicates: {},
                        objects: {}
                    };
                    // Freezing a graph helps subsequent `add` performance,
                    // and properties will never be modified anyway
                    Object.freeze(graphItem);
                }
                // Since entities can often be long IRIs, we avoid storing them in every index.
                // Instead, we have a separate index that maps entities to numbers,
                // which are then used as keys in the other indexes.
                subject = this._termToNewNumericId(subject);
                predicate = this._termToNewNumericId(predicate);
                object = this._termToNewNumericId(object);
                if (!this._addToIndex(graphItem.subjects, subject, predicate, object)) return false;
                this._addToIndex(graphItem.predicates, predicate, object, subject);
                this._addToIndex(graphItem.objects, object, subject, predicate);
                // The cached quad count is now invalid
                this._size = null;
                return true;
            }
        },
        {
            // ### `addQuads` adds multiple quads to the store
            key: "addQuads",
            value: function addQuads(quads) {
                for(var i = 0; i < quads.length; i++)this.addQuad(quads[i]);
            }
        },
        {
            // ### `delete` removes the specified quad from the dataset.
            // Returns the dataset instance it was called on.
            key: "delete",
            value: function _delete(quad) {
                this.removeQuad(quad);
                return this;
            }
        },
        {
            // ### `has` determines whether a dataset includes a certain quad or quad pattern.
            key: "has",
            value: function has(subjectOrQuad, predicate, object, graph) {
                var ref;
                if (subjectOrQuad && subjectOrQuad.subject) ref = subjectOrQuad, subjectOrQuad = ref.subject, predicate = ref.predicate, object = ref.object, graph = ref.graph, ref;
                return !this.readQuads(subjectOrQuad, predicate, object, graph).next().done;
            }
        },
        {
            // ### `import` adds a stream of quads to the store
            key: "import",
            value: function _import(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    _this.addQuad(quad);
                });
                return stream;
            }
        },
        {
            // ### `removeQuad` removes a quad from the store if it exists
            key: "removeQuad",
            value: function removeQuad(subject, predicate, object, graph) {
                var ref;
                // Shift arguments if a quad object is given instead of components
                if (!predicate) ref = subject, subject = ref.subject, predicate = ref.predicate, object = ref.object, graph = ref.graph, ref;
                // Convert terms to internal string representation
                graph = graph ? this._termToNumericId(graph) : 1;
                // Find internal identifiers for all components
                // and verify the quad exists.
                var graphs = this._graphs;
                var graphItem, subjects, predicates;
                if (!(subject = subject && this._termToNumericId(subject)) || !(predicate = predicate && this._termToNumericId(predicate)) || !(object = object && this._termToNumericId(object)) || !(graphItem = graphs[graph]) || !(subjects = graphItem.subjects[subject]) || !(predicates = subjects[predicate]) || !(object in predicates)) return false;
                // Remove it from all indexes
                this._removeFromIndex(graphItem.subjects, subject, predicate, object);
                this._removeFromIndex(graphItem.predicates, predicate, object, subject);
                this._removeFromIndex(graphItem.objects, object, subject, predicate);
                if (this._size !== null) this._size--;
                // Remove the graph if it is empty
                for(subject in graphItem.subjects)return true;
                delete graphs[graph];
                return true;
            }
        },
        {
            // ### `removeQuads` removes multiple quads from the store
            key: "removeQuads",
            value: function removeQuads(quads) {
                for(var i = 0; i < quads.length; i++)this.removeQuad(quads[i]);
            }
        },
        {
            // ### `remove` removes a stream of quads from the store
            key: "remove",
            value: function remove(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    _this.removeQuad(quad);
                });
                return stream;
            }
        },
        {
            // ### `removeMatches` removes all matching quads from the store
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "removeMatches",
            value: function removeMatches(subject, predicate, object, graph) {
                var stream = new (0, $f9bYj.Readable)({
                    objectMode: true
                });
                var iterable = this.readQuads(subject, predicate, object, graph);
                stream._read = function(size) {
                    while(--size >= 0){
                        var _iterable_next = iterable.next(), done = _iterable_next.done, value = _iterable_next.value;
                        if (done) {
                            stream.push(null);
                            return;
                        }
                        stream.push(value);
                    }
                };
                return this.remove(stream);
            }
        },
        {
            // ### `deleteGraph` removes all triples with the given graph from the store
            key: "deleteGraph",
            value: function deleteGraph(graph) {
                return this.removeMatches(null, null, null, graph);
            }
        },
        {
            // ### `getQuads` returns an array of quads matching a pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "getQuads",
            value: function getQuads(subject, predicate, object, graph) {
                return (0, $7WNf6._)(this.readQuads(subject, predicate, object, graph));
            }
        },
        {
            key: "readQuads",
            value: /**
   * `readQuads` returns a generator of quads matching a pattern.
   * Setting any field to `undefined` or `null` indicates a wildcard.
   * @deprecated Use `match` instead.
   */ function readQuads(subject, predicate, object, graph) {
                var graphs, content, subjectId, predicateId, objectId, _tmp, _tmp1, _i, graphId;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            graphs = this._getGraphs(graph);
                            // Translate IRIs to internal index keys.
                            if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return [
                                2
                            ];
                            _tmp = [];
                            for(_tmp1 in graphs)_tmp.push(_tmp1);
                            _i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(_i < _tmp.length)) return [
                                3,
                                13
                            ];
                            graphId = _tmp[_i];
                            if (!(content = graphs[graphId])) return [
                                3,
                                12
                            ];
                            if (!subjectId) return [
                                3,
                                6
                            ];
                            if (!objectId) return [
                                3,
                                3
                            ];
                            // If subject and object are given, the object index will be the fastest
                            return [
                                5,
                                (0, $9N5UN.__values)(this._findInIndex(content.objects, objectId, subjectId, predicateId, 'object', 'subject', 'predicate', graphId))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            // If only subject and possibly predicate are given, the subject index will be the fastest
                            return [
                                5,
                                (0, $9N5UN.__values)(this._findInIndex(content.subjects, subjectId, predicateId, null, 'subject', 'predicate', 'object', graphId))
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                3,
                                12
                            ];
                        case 6:
                            if (!predicateId) return [
                                3,
                                8
                            ];
                            // If only predicate and possibly object are given, the predicate index will be the fastest
                            return [
                                5,
                                (0, $9N5UN.__values)(this._findInIndex(content.predicates, predicateId, objectId, null, 'predicate', 'object', 'subject', graphId))
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 8:
                            if (!objectId) return [
                                3,
                                10
                            ];
                            // If only object is given, the object index will be the fastest
                            return [
                                5,
                                (0, $9N5UN.__values)(this._findInIndex(content.objects, objectId, null, null, 'object', 'subject', 'predicate', graphId))
                            ];
                        case 9:
                            _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 10:
                            // If nothing is given, iterate subjects and predicates first
                            return [
                                5,
                                (0, $9N5UN.__values)(this._findInIndex(content.subjects, null, null, null, 'subject', 'predicate', 'object', graphId))
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _i++;
                            return [
                                3,
                                1
                            ];
                        case 13:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // ### `match` returns a new dataset that is comprised of all quads in the current instance matching the given arguments.
            // The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
            // Note: This method always returns a new DatasetCore, even if that dataset contains no quads.
            // Note: Since a DatasetCore is an unordered set, the order of the quads within the returned sequence is arbitrary.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            // For backwards compatibility, the object return also implements the Readable stream interface.
            key: "match",
            value: function match(subject, predicate, object, graph) {
                return new $4b013f341285c075$var$DatasetCoreAndReadableStream(this, subject, predicate, object, graph, {
                    entityIndex: this._entityIndex
                });
            }
        },
        {
            // ### `countQuads` returns the number of quads matching a pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "countQuads",
            value: function countQuads(subject, predicate, object, graph) {
                var graphs = this._getGraphs(graph);
                var count = 0, content, subjectId, predicateId, objectId;
                // Translate IRIs to internal index keys.
                if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return 0;
                for(var graphId in graphs)// Only if the specified graph contains triples, there can be results
                if (content = graphs[graphId]) {
                    // Choose the optimal index, based on what fields are present
                    if (subject) {
                        if (object) // If subject and object are given, the object index will be the fastest
                        count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                        else // If only subject and possibly predicate are given, the subject index will be the fastest
                        count += this._countInIndex(content.subjects, subjectId, predicateId, objectId);
                    } else if (predicate) // If only predicate and possibly object are given, the predicate index will be the fastest
                    count += this._countInIndex(content.predicates, predicateId, objectId, subjectId);
                    else // If only object is possibly given, the object index will be the fastest
                    count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                }
                return count;
            }
        },
        {
            // ### `forEach` executes the callback on all quads.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "forEach",
            value: function forEach(callback, subject, predicate, object, graph) {
                var _this = this;
                this.some(function(quad) {
                    callback(quad, _this);
                    return false;
                }, subject, predicate, object, graph);
            }
        },
        {
            // ### `every` executes the callback on all quads,
            // and returns `true` if it returns truthy for all them.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "every",
            value: function every(callback, subject, predicate, object, graph) {
                var _this = this;
                return !this.some(function(quad) {
                    return !callback(quad, _this);
                }, subject, predicate, object, graph);
            }
        },
        {
            // ### `some` executes the callback on all quads,
            // and returns `true` if it returns truthy for any of them.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "some",
            value: function some(callback, subject, predicate, object, graph) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.readQuads(subject, predicate, object, graph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        if (callback(quad, this)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            // ### `getSubjects` returns all subjects that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "getSubjects",
            value: function getSubjects(predicate, object, graph) {
                var results = [];
                this.forSubjects(function(s) {
                    results.push(s);
                }, predicate, object, graph);
                return results;
            }
        },
        {
            // ### `forSubjects` executes the callback on all subjects that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "forSubjects",
            value: function forSubjects(callback, predicate, object, graph) {
                var graphs = this._getGraphs(graph);
                var content, predicateId, objectId;
                callback = this._uniqueEntities(callback);
                // Translate IRIs to internal index keys.
                if (predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
                for(graph in graphs)// Only if the specified graph contains triples, there can be results
                if (content = graphs[graph]) {
                    // Choose optimal index based on which fields are wildcards
                    if (predicateId) {
                        if (objectId) // If predicate and object are given, the POS index is best.
                        this._loopBy2Keys(content.predicates, predicateId, objectId, callback);
                        else // If only predicate is given, the SPO index is best.
                        this._loopByKey1(content.subjects, predicateId, callback);
                    } else if (objectId) // If only object is given, the OSP index is best.
                    this._loopByKey0(content.objects, objectId, callback);
                    else // If no params given, iterate all the subjects
                    this._loop(content.subjects, callback);
                }
            }
        },
        {
            // ### `getPredicates` returns all predicates that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "getPredicates",
            value: function getPredicates(subject, object, graph) {
                var results = [];
                this.forPredicates(function(p) {
                    results.push(p);
                }, subject, object, graph);
                return results;
            }
        },
        {
            // ### `forPredicates` executes the callback on all predicates that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "forPredicates",
            value: function forPredicates(callback, subject, object, graph) {
                var graphs = this._getGraphs(graph);
                var content, subjectId, objectId;
                callback = this._uniqueEntities(callback);
                // Translate IRIs to internal index keys.
                if (subject && !(subjectId = this._termToNumericId(subject)) || object && !(objectId = this._termToNumericId(object))) return;
                for(graph in graphs)// Only if the specified graph contains triples, there can be results
                if (content = graphs[graph]) {
                    // Choose optimal index based on which fields are wildcards
                    if (subjectId) {
                        if (objectId) // If subject and object are given, the OSP index is best.
                        this._loopBy2Keys(content.objects, objectId, subjectId, callback);
                        else // If only subject is given, the SPO index is best.
                        this._loopByKey0(content.subjects, subjectId, callback);
                    } else if (objectId) // If only object is given, the POS index is best.
                    this._loopByKey1(content.predicates, objectId, callback);
                    else // If no params given, iterate all the predicates.
                    this._loop(content.predicates, callback);
                }
            }
        },
        {
            // ### `getObjects` returns all objects that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "getObjects",
            value: function getObjects(subject, predicate, graph) {
                var results = [];
                this.forObjects(function(o) {
                    results.push(o);
                }, subject, predicate, graph);
                return results;
            }
        },
        {
            // ### `forObjects` executes the callback on all objects that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "forObjects",
            value: function forObjects(callback, subject, predicate, graph) {
                var graphs = this._getGraphs(graph);
                var content, subjectId, predicateId;
                callback = this._uniqueEntities(callback);
                // Translate IRIs to internal index keys.
                if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate))) return;
                for(graph in graphs)// Only if the specified graph contains triples, there can be results
                if (content = graphs[graph]) {
                    // Choose optimal index based on which fields are wildcards
                    if (subjectId) {
                        if (predicateId) // If subject and predicate are given, the SPO index is best.
                        this._loopBy2Keys(content.subjects, subjectId, predicateId, callback);
                        else // If only subject is given, the OSP index is best.
                        this._loopByKey1(content.objects, subjectId, callback);
                    } else if (predicateId) // If only predicate is given, the POS index is best.
                    this._loopByKey0(content.predicates, predicateId, callback);
                    else // If no params given, iterate all the objects.
                    this._loop(content.objects, callback);
                }
            }
        },
        {
            // ### `getGraphs` returns all graphs that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "getGraphs",
            value: function getGraphs(subject, predicate, object) {
                var results = [];
                this.forGraphs(function(g) {
                    results.push(g);
                }, subject, predicate, object);
                return results;
            }
        },
        {
            // ### `forGraphs` executes the callback on all graphs that match the pattern.
            // Setting any field to `undefined` or `null` indicates a wildcard.
            key: "forGraphs",
            value: function forGraphs(callback, subject, predicate, object) {
                for(var graph in this._graphs)this.some(function(quad) {
                    callback(quad.graph);
                    return true; // Halt iteration of some()
                }, subject, predicate, object, this._termFromId(this._entities[graph]));
            }
        },
        {
            // ### `createBlankNode` creates a new blank node, returning its name
            key: "createBlankNode",
            value: function createBlankNode(suggestedName) {
                return this._entityIndex.createBlankNode(suggestedName);
            }
        },
        {
            // ### `extractLists` finds and removes all list triples
            // and returns the items per list.
            key: "extractLists",
            value: function extractLists() {
                var _this = this;
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_remove = _ref.remove, remove = _ref_remove === void 0 ? false : _ref_remove, _ref_ignoreErrors = _ref.ignoreErrors, ignoreErrors = _ref_ignoreErrors === void 0 ? false : _ref_ignoreErrors;
                var lists = {}; // has scalar keys so could be a simple Object
                var onError = ignoreErrors ? function() {
                    return true;
                } : function(node, message) {
                    throw new Error("".concat(node.value, " ").concat(message));
                };
                // Traverse each list from its tail
                var tails = this.getQuads(null, (0, $kEnRi.default).rdf.rest, (0, $kEnRi.default).rdf.nil, null);
                var toRemove = remove ? (0, $7WNf6._)(tails) : [];
                tails.forEach(function(tailQuad) {
                    var items = []; // the members found as objects of rdf:first quads
                    var malformed = false; // signals whether the current list is malformed
                    var head; // the head of the list (_:b1 in above example)
                    var headPos; // set to subject or object when head is set
                    var graph = tailQuad.graph; // make sure list is in exactly one graph
                    // Traverse the list from tail to end
                    var current = tailQuad.subject;
                    while(current && !malformed){
                        var objectQuads = _this.getQuads(null, null, current, null);
                        var subjectQuads = _this.getQuads(current, null, null, null);
                        var quad = void 0, first = null, rest = null, parent = null;
                        // Find the first and rest of this list node
                        for(var i = 0; i < subjectQuads.length && !malformed; i++){
                            quad = subjectQuads[i];
                            if (!quad.graph.equals(graph)) malformed = onError(current, 'not confined to single graph');
                            else if (head) malformed = onError(current, 'has non-list arcs out');
                            else if (quad.predicate.value === (0, $kEnRi.default).rdf.first) {
                                if (first) malformed = onError(current, 'has multiple rdf:first arcs');
                                else toRemove.push(first = quad);
                            } else if (quad.predicate.value === (0, $kEnRi.default).rdf.rest) {
                                if (rest) malformed = onError(current, 'has multiple rdf:rest arcs');
                                else toRemove.push(rest = quad);
                            } else if (objectQuads.length) malformed = onError(current, 'can\'t be subject and object');
                            else {
                                head = quad; // e.g. { (1 2 3) :p :o }
                                headPos = 'subject';
                            }
                        }
                        // { :s :p (1 2) } arrives here with no head
                        // { (1 2) :p :o } arrives here with head set to the list.
                        for(var i1 = 0; i1 < objectQuads.length && !malformed; ++i1){
                            quad = objectQuads[i1];
                            if (head) malformed = onError(current, 'can\'t have coreferences');
                            else if (quad.predicate.value === (0, $kEnRi.default).rdf.rest) {
                                if (parent) malformed = onError(current, 'has incoming rdf:rest arcs');
                                else parent = quad;
                            } else {
                                head = quad; // e.g. { :s :p (1 2) }
                                headPos = 'object';
                            }
                        }
                        // Store the list item and continue with parent
                        if (!first) malformed = onError(current, 'has no list head');
                        else items.unshift(first.object);
                        current = parent && parent.subject;
                    }
                    // Don't remove any quads if the list is malformed
                    if (malformed) remove = false;
                    else if (head) lists[head[headPos].value] = items;
                });
                // Remove list quads if requested
                if (remove) this.removeQuads(toRemove);
                return lists;
            }
        },
        {
            /**
   * Returns `true` if the current dataset is a superset of the given dataset; in other words, returns `true` if
   * the given dataset is a subset of, i.e., is contained within, the current dataset.
   *
   * Blank Nodes will be normalized.
   */ key: "addAll",
            value: function addAll(quads) {
                if (quads instanceof $4b013f341285c075$var$DatasetCoreAndReadableStream) quads = quads.filtered;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (Array.isArray(quads)) this.addQuads(quads);
                else if (quads instanceof N3Store && quads._entityIndex === this._entityIndex) {
                    if (quads._size !== 0) {
                        this._graphs = $4b013f341285c075$var$merge(this._graphs, quads._graphs);
                        this._size = null; // Invalidate the cached size
                    }
                } else try {
                    for(var _iterator = quads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        this.add(quad);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            /**
   * Returns `true` if the current dataset is a superset of the given dataset; in other words, returns `true` if
   * the given dataset is a subset of, i.e., is contained within, the current dataset.
   *
   * Blank Nodes will be normalized.
   */ key: "contains",
            value: function contains(other) {
                var _this = this;
                if (other instanceof $4b013f341285c075$var$DatasetCoreAndReadableStream) other = other.filtered;
                if (other === this) return true;
                if (!(other instanceof N3Store) || this._entityIndex !== other._entityIndex) return other.every(function(quad) {
                    return _this.has(quad);
                });
                var g1 = this._graphs, g2 = other._graphs;
                var s1, s2, p1, p2, o1;
                for(var graph in g2){
                    if (!(s1 = g1[graph])) return false;
                    s1 = s1.subjects;
                    for(var subject in s2 = g2[graph].subjects){
                        if (!(p1 = s1[subject])) return false;
                        for(var predicate in p2 = s2[subject]){
                            if (!(o1 = p1[predicate])) return false;
                            for(var object in p2[predicate])if (!(object in o1)) return false;
                        }
                    }
                }
                return true;
            }
        },
        {
            /**
   * This method removes the quads in the current dataset that match the given arguments.
   *
   * The logic described in {@link https://rdf.js.org/dataset-spec/#quad-matching|Quad Matching} is applied for each
   * quad in this dataset, to select the quads which will be deleted.
   *
   * @param subject   The optional exact subject to match.
   * @param predicate The optional exact predicate to match.
   * @param object    The optional exact object to match.
   * @param graph     The optional exact graph to match.
   */ key: "deleteMatches",
            value: function deleteMatches(subject, predicate, object, graph) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.match(subject, predicate, object, graph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        this.removeQuad(quad);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            /**
   * Returns a new dataset that contains all quads from the current dataset that are not included in the given dataset.
   */ key: "difference",
            value: function difference1(other) {
                if (other && other instanceof $4b013f341285c075$var$DatasetCoreAndReadableStream) other = other.filtered;
                if (other === this) return new N3Store({
                    entityIndex: this._entityIndex
                });
                if (other instanceof N3Store && other._entityIndex === this._entityIndex) {
                    var store = new N3Store({
                        entityIndex: this._entityIndex
                    });
                    var graphs = $4b013f341285c075$var$difference(this._graphs, other._graphs);
                    if (graphs) {
                        store._graphs = graphs;
                        store._size = null;
                    }
                    return store;
                }
                return this.filter(function(quad) {
                    return !other.has(quad);
                });
            }
        },
        {
            /**
   * Returns true if the current dataset contains the same graph structure as the given dataset.
   *
   * Blank Nodes will be normalized.
   */ key: "equals",
            value: function equals(other) {
                if (other instanceof $4b013f341285c075$var$DatasetCoreAndReadableStream) other = other.filtered;
                return other === this || this.size === other.size && this.contains(other);
            }
        },
        {
            /**
   * Creates a new dataset with all the quads that pass the test implemented by the provided `iteratee`.
   *
   * This method is aligned with Array.prototype.filter() in ECMAScript-262.
   */ key: "filter",
            value: function filter(iteratee) {
                var store = new N3Store({
                    entityIndex: this._entityIndex
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        if (iteratee(quad, this)) store.add(quad);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return store;
            }
        },
        {
            /**
   * Returns a new dataset containing all quads from the current dataset that are also included in the given dataset.
   */ key: "intersection",
            value: function intersection(other) {
                if (other instanceof $4b013f341285c075$var$DatasetCoreAndReadableStream) other = other.filtered;
                if (other === this) {
                    var store = new N3Store({
                        entityIndex: this._entityIndex
                    });
                    store._graphs = $4b013f341285c075$var$merge(Object.create(null), this._graphs);
                    store._size = this._size;
                    return store;
                } else if (other instanceof N3Store && this._entityIndex === other._entityIndex) {
                    var store1 = new N3Store({
                        entityIndex: this._entityIndex
                    });
                    var graphs = $4b013f341285c075$var$intersect(other._graphs, this._graphs);
                    if (graphs) {
                        store1._graphs = graphs;
                        store1._size = null;
                    }
                    return store1;
                }
                return this.filter(function(quad) {
                    return other.has(quad);
                });
            }
        },
        {
            /**
   * Returns a new dataset containing all quads returned by applying `iteratee` to each quad in the current dataset.
   */ key: "map",
            value: function map(iteratee) {
                var store = new N3Store({
                    entityIndex: this._entityIndex
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        store.add(iteratee(quad, this));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return store;
            }
        },
        {
            /**
   * This method calls the `iteratee` method on each `quad` of the `Dataset`. The first time the `iteratee` method
   * is called, the `accumulator` value is the `initialValue`, or, if not given, equals the first quad of the `Dataset`.
   * The return value of each call to the `iteratee` method is used as the `accumulator` value for the next call.
   *
   * This method returns the return value of the last `iteratee` call.
   *
   * This method is aligned with `Array.prototype.reduce()` in ECMAScript-262.
   */ key: "reduce",
            value: function reduce(callback, initialValue) {
                var iter = this.readQuads();
                var accumulator = initialValue === undefined ? iter.next().value : initialValue;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = iter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        accumulator = callback(accumulator, quad, this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return accumulator;
            }
        },
        {
            /**
   * Returns the set of quads within the dataset as a host-language-native sequence, for example an `Array` in
   * ECMAScript-262.
   *
   * Since a `Dataset` is an unordered set, the order of the quads within the returned sequence is arbitrary.
   */ key: "toArray",
            value: function toArray() {
                return this.getQuads();
            }
        },
        {
            /**
   * Returns an N-Quads string representation of the dataset, preprocessed with the
   * {@link https://json-ld.github.io/normalization/spec/|RDF Dataset Normalization} algorithm.
   */ key: "toCanonical",
            value: function toCanonical() {
                throw new Error('not implemented');
            }
        },
        {
            /**
   * Returns a stream that contains all quads of the dataset.
   */ key: "toStream",
            value: function toStream() {
                return this.match();
            }
        },
        {
            /**
   * Returns an N-Quads string representation of the dataset.
   *
   * No prior normalization is required, therefore the results for the same quads may vary depending on the `Dataset`
   * implementation.
   */ key: "toString",
            value: function toString() {
                return new (0, $cfNAJ.default)().quadsToString(this);
            }
        },
        {
            /**
   * Returns a new `Dataset` that is a concatenation of this dataset and the quads given as an argument.
   */ key: "union",
            value: function union(quads) {
                var store = new N3Store({
                    entityIndex: this._entityIndex
                });
                store._graphs = $4b013f341285c075$var$merge(Object.create(null), this._graphs);
                store._size = this._size;
                store.addAll(quads);
                return store;
            }
        },
        {
            key: Symbol.iterator,
            value: // ### Store is an iterable.
            // Can be used where iterables are expected: for...of loops, array spread operator,
            // `yield*`, and destructuring assignment (order is not guaranteed).
            function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $9N5UN.__values)(this.readQuads())
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return N3Store;
}();
/**
 * Returns a subset of the `index` with that part of the index
 * matching the `ids` array. `ids` contains 3 elements that are
 * either numerical ids; or `null`.
 *
 * `false` is returned when there are no matching indices; this should
 * *not* be set as the value for an index.
 */ function $4b013f341285c075$var$indexMatch(index, ids) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var ind = ids[depth];
    if (ind && !(ind in index)) return false;
    var target = false;
    for(var key in ind ? (0, $cqEAj._)({}, ind, index[ind]) : index){
        var result = depth === 2 ? null : $4b013f341285c075$var$indexMatch(index[key], ids, depth + 1);
        if (result !== false) {
            target = target || Object.create(null);
            target[key] = result;
        }
    }
    return target;
}
/**
 * A class that implements both DatasetCore and Readable.
 */ var $4b013f341285c075$var$DatasetCoreAndReadableStream = /*#__PURE__*/ function(Readable) {
    "use strict";
    (0, $i3fW3._)(DatasetCoreAndReadableStream, Readable);
    function DatasetCoreAndReadableStream(n3Store, subject, predicate, object, graph, options) {
        (0, $jGAMp._)(this, DatasetCoreAndReadableStream);
        var _this;
        _this = (0, $kzDuW._)(this, DatasetCoreAndReadableStream, [
            {
                objectMode: true
            }
        ]);
        Object.assign(_this, {
            n3Store: n3Store,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            options: options
        });
        return _this;
    }
    (0, $byiyg._)(DatasetCoreAndReadableStream, [
        {
            key: "filtered",
            get: function get() {
                if (!this._filtered) {
                    var _this = this, n3Store = _this.n3Store, graph = _this.graph, object = _this.object, predicate = _this.predicate, subject = _this.subject;
                    var newStore = this._filtered = new $4b013f341285c075$export$2e2bcd8739ae039({
                        factory: n3Store._factory,
                        entityIndex: this.options.entityIndex
                    });
                    var subjectId, predicateId, objectId;
                    // Translate IRIs to internal index keys.
                    if (subject && !(subjectId = newStore._termToNumericId(subject)) || predicate && !(predicateId = newStore._termToNumericId(predicate)) || object && !(objectId = newStore._termToNumericId(object))) return newStore;
                    var graphs = n3Store._getGraphs(graph);
                    for(var graphKey in graphs){
                        var subjects = void 0, predicates = void 0, objects = void 0, content = void 0;
                        if (content = graphs[graphKey]) {
                            if (!subjectId && predicateId) {
                                if (predicates = $4b013f341285c075$var$indexMatch(content.predicates, [
                                    predicateId,
                                    objectId,
                                    subjectId
                                ])) {
                                    subjects = $4b013f341285c075$var$indexMatch(content.subjects, [
                                        subjectId,
                                        predicateId,
                                        objectId
                                    ]);
                                    objects = $4b013f341285c075$var$indexMatch(content.objects, [
                                        objectId,
                                        subjectId,
                                        predicateId
                                    ]);
                                }
                            } else if (objectId) {
                                if (objects = $4b013f341285c075$var$indexMatch(content.objects, [
                                    objectId,
                                    subjectId,
                                    predicateId
                                ])) {
                                    subjects = $4b013f341285c075$var$indexMatch(content.subjects, [
                                        subjectId,
                                        predicateId,
                                        objectId
                                    ]);
                                    predicates = $4b013f341285c075$var$indexMatch(content.predicates, [
                                        predicateId,
                                        objectId,
                                        subjectId
                                    ]);
                                }
                            } else if (subjects = $4b013f341285c075$var$indexMatch(content.subjects, [
                                subjectId,
                                predicateId,
                                objectId
                            ])) {
                                predicates = $4b013f341285c075$var$indexMatch(content.predicates, [
                                    predicateId,
                                    objectId,
                                    subjectId
                                ]);
                                objects = $4b013f341285c075$var$indexMatch(content.objects, [
                                    objectId,
                                    subjectId,
                                    predicateId
                                ]);
                            }
                            if (subjects) newStore._graphs[graphKey] = {
                                subjects: subjects,
                                predicates: predicates,
                                objects: objects
                            };
                        }
                    }
                    newStore._size = null;
                }
                return this._filtered;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.filtered.size;
            }
        },
        {
            key: "_read",
            value: function _read(size) {
                if (size > 0 && !this[$4b013f341285c075$var$ITERATOR]) this[$4b013f341285c075$var$ITERATOR] = this[Symbol.iterator]();
                var iterable = this[$4b013f341285c075$var$ITERATOR];
                while(--size >= 0){
                    var _iterable_next = iterable.next(), done = _iterable_next.done, value = _iterable_next.value;
                    if (done) {
                        this.push(null);
                        return;
                    }
                    this.push(value);
                }
            }
        },
        {
            key: "addAll",
            value: function addAll(quads) {
                return this.filtered.addAll(quads);
            }
        },
        {
            key: "contains",
            value: function contains(other) {
                return this.filtered.contains(other);
            }
        },
        {
            key: "deleteMatches",
            value: function deleteMatches(subject, predicate, object, graph) {
                return this.filtered.deleteMatches(subject, predicate, object, graph);
            }
        },
        {
            key: "difference",
            value: function difference(other) {
                return this.filtered.difference(other);
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                return this.filtered.equals(other);
            }
        },
        {
            key: "every",
            value: function every(callback, subject, predicate, object, graph) {
                return this.filtered.every(callback, subject, predicate, object, graph);
            }
        },
        {
            key: "filter",
            value: function filter(iteratee) {
                return this.filtered.filter(iteratee);
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, subject, predicate, object, graph) {
                return this.filtered.forEach(callback, subject, predicate, object, graph);
            }
        },
        {
            key: "import",
            value: function _import(stream) {
                return this.filtered["import"](stream);
            }
        },
        {
            key: "intersection",
            value: function intersection(other) {
                return this.filtered.intersection(other);
            }
        },
        {
            key: "map",
            value: function map(iteratee) {
                return this.filtered.map(iteratee);
            }
        },
        {
            key: "some",
            value: function some(callback, subject, predicate, object, graph) {
                return this.filtered.some(callback, subject, predicate, object, graph);
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                return this.filtered.toCanonical();
            }
        },
        {
            key: "toStream",
            value: function toStream() {
                return this._filtered ? this._filtered.toStream() : this.n3Store.match(this.subject, this.predicate, this.object, this.graph);
            }
        },
        {
            key: "union",
            value: function union(quads) {
                return this._filtered ? this._filtered.union(quads) : this.n3Store.match(this.subject, this.predicate, this.object, this.graph).addAll(quads);
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this._filtered ? this._filtered.toArray() : this.n3Store.getQuads(this.subject, this.predicate, this.object, this.graph);
            }
        },
        {
            key: "reduce",
            value: function reduce(callback, initialValue) {
                return this.filtered.reduce(callback, initialValue);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return new (0, $cfNAJ.default)().quadsToString(this);
            }
        },
        {
            key: "add",
            value: function add(quad) {
                return this.filtered.add(quad);
            }
        },
        {
            key: "delete",
            value: function _delete(quad) {
                return this.filtered["delete"](quad);
            }
        },
        {
            key: "has",
            value: function has(quad) {
                return this.filtered.has(quad);
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                return new DatasetCoreAndReadableStream(this.filtered, subject, predicate, object, graph, this.options);
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $9N5UN.__values)(this._filtered || this.n3Store.readQuads(this.subject, this.predicate, this.object, this.graph))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return DatasetCoreAndReadableStream;
}((0, $f9bYj.Readable));

});
parcelRegister("f9bYj", function(module, exports) {
'use strict';

var $iR1nQ = parcelRequire("iR1nQ");

var $5hMkG = parcelRequire("5hMkG");
var $b070fb9e5a87b65d$var$originalDestroy = $iR1nQ.Readable.destroy;
module.exports = $iR1nQ.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $iR1nQ._uint8ArrayToBuffer;
module.exports._isUint8Array = $iR1nQ._isUint8Array;
module.exports.isDisturbed = $iR1nQ.isDisturbed;
module.exports.isErrored = $iR1nQ.isErrored;
module.exports.isReadable = $iR1nQ.isReadable;
module.exports.Readable = $iR1nQ.Readable;
module.exports.Writable = $iR1nQ.Writable;
module.exports.Duplex = $iR1nQ.Duplex;
module.exports.Transform = $iR1nQ.Transform;
module.exports.PassThrough = $iR1nQ.PassThrough;
module.exports.addAbortSignal = $iR1nQ.addAbortSignal;
module.exports.finished = $iR1nQ.finished;
module.exports.destroy = $iR1nQ.destroy;
module.exports.destroy = $b070fb9e5a87b65d$var$originalDestroy;
module.exports.pipeline = $iR1nQ.pipeline;
module.exports.compose = $iR1nQ.compose;
Object.defineProperty($iR1nQ, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $5hMkG;
    }
});
module.exports.Stream = $iR1nQ.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("iR1nQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $ikzXy = parcelRequire("ikzXy");
var $db9e3ff9930cefc4$require$Buffer = $ikzXy.Buffer;

var $8PVhU = parcelRequire("8PVhU");
/* replacement end */ var $db9e3ff9930cefc4$var$ObjectDefineProperty = $8PVhU.ObjectDefineProperty, $db9e3ff9930cefc4$var$ObjectKeys = $8PVhU.ObjectKeys, $db9e3ff9930cefc4$var$ReflectApply = $8PVhU.ReflectApply;

var $f3A5e = parcelRequire("f3A5e");
var $db9e3ff9930cefc4$var$_require_promisify = $f3A5e.promisify, $db9e3ff9930cefc4$var$customPromisify = $db9e3ff9930cefc4$var$_require_promisify.custom;

var $jMeVs = parcelRequire("jMeVs");
var $db9e3ff9930cefc4$var$streamReturningOperators = $jMeVs.streamReturningOperators, $db9e3ff9930cefc4$var$promiseReturningOperators = $jMeVs.promiseReturningOperators;

var $i1Urf = parcelRequire("i1Urf");
var $db9e3ff9930cefc4$var$ERR_ILLEGAL_CONSTRUCTOR = $i1Urf.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $WdD80 = parcelRequire("WdD80");

var $fp08x = parcelRequire("fp08x");
var $db9e3ff9930cefc4$var$setDefaultHighWaterMark = $fp08x.setDefaultHighWaterMark, $db9e3ff9930cefc4$var$getDefaultHighWaterMark = $fp08x.getDefaultHighWaterMark;

var $l7PcQ = parcelRequire("l7PcQ");
var $db9e3ff9930cefc4$require$pipeline = $l7PcQ.pipeline;

var $6baNx = parcelRequire("6baNx");
var $db9e3ff9930cefc4$require$destroyer = $6baNx.destroyer;

var $lV7H7 = parcelRequire("lV7H7");
var $db9e3ff9930cefc4$var$internalBuffer = {};

var $5hMkG = parcelRequire("5hMkG");

var $iz3nv = parcelRequire("iz3nv");

var $db9e3ff9930cefc4$var$Stream = module.exports = (parcelRequire("cdt5A")).Stream;
$db9e3ff9930cefc4$var$Stream.isDestroyed = $iz3nv.isDestroyed;
$db9e3ff9930cefc4$var$Stream.isDisturbed = $iz3nv.isDisturbed;
$db9e3ff9930cefc4$var$Stream.isErrored = $iz3nv.isErrored;
$db9e3ff9930cefc4$var$Stream.isReadable = $iz3nv.isReadable;
$db9e3ff9930cefc4$var$Stream.isWritable = $iz3nv.isWritable;

$db9e3ff9930cefc4$var$Stream.Readable = (parcelRequire("6P7iX"));
var $db9e3ff9930cefc4$var$_iteratorNormalCompletion = true, $db9e3ff9930cefc4$var$_didIteratorError = false, $db9e3ff9930cefc4$var$_iteratorError = undefined;
try {
    for(var $db9e3ff9930cefc4$var$_iterator = $db9e3ff9930cefc4$var$ObjectKeys($db9e3ff9930cefc4$var$streamReturningOperators)[Symbol.iterator](), $db9e3ff9930cefc4$var$_step; !($db9e3ff9930cefc4$var$_iteratorNormalCompletion = ($db9e3ff9930cefc4$var$_step = $db9e3ff9930cefc4$var$_iterator.next()).done); $db9e3ff9930cefc4$var$_iteratorNormalCompletion = true){
        var $db9e3ff9930cefc4$var$key = $db9e3ff9930cefc4$var$_step.value;
        var $db9e3ff9930cefc4$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $db9e3ff9930cefc4$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $db9e3ff9930cefc4$var$Stream.Readable.from($db9e3ff9930cefc4$var$ReflectApply($db9e3ff9930cefc4$var$op, this, args));
        };
        var $db9e3ff9930cefc4$var$op = $db9e3ff9930cefc4$var$streamReturningOperators[$db9e3ff9930cefc4$var$key];
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$fn, 'name', {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$op.name
        });
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$fn, 'length', {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$op.length
        });
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$Stream.Readable.prototype, $db9e3ff9930cefc4$var$key, {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $db9e3ff9930cefc4$var$_didIteratorError = true;
    $db9e3ff9930cefc4$var$_iteratorError = err;
} finally{
    try {
        if (!$db9e3ff9930cefc4$var$_iteratorNormalCompletion && $db9e3ff9930cefc4$var$_iterator["return"] != null) {
            $db9e3ff9930cefc4$var$_iterator["return"]();
        }
    } finally{
        if ($db9e3ff9930cefc4$var$_didIteratorError) {
            throw $db9e3ff9930cefc4$var$_iteratorError;
        }
    }
}
var $db9e3ff9930cefc4$var$_iteratorNormalCompletion1 = true, $db9e3ff9930cefc4$var$_didIteratorError1 = false, $db9e3ff9930cefc4$var$_iteratorError1 = undefined;
try {
    for(var $db9e3ff9930cefc4$var$_iterator1 = $db9e3ff9930cefc4$var$ObjectKeys($db9e3ff9930cefc4$var$promiseReturningOperators)[Symbol.iterator](), $db9e3ff9930cefc4$var$_step1; !($db9e3ff9930cefc4$var$_iteratorNormalCompletion1 = ($db9e3ff9930cefc4$var$_step1 = $db9e3ff9930cefc4$var$_iterator1.next()).done); $db9e3ff9930cefc4$var$_iteratorNormalCompletion1 = true){
        var $db9e3ff9930cefc4$var$key1 = $db9e3ff9930cefc4$var$_step1.value;
        var $db9e3ff9930cefc4$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $db9e3ff9930cefc4$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $db9e3ff9930cefc4$var$ReflectApply($db9e3ff9930cefc4$var$op1, this, args);
        };
        var $db9e3ff9930cefc4$var$op1 = $db9e3ff9930cefc4$var$promiseReturningOperators[$db9e3ff9930cefc4$var$key1];
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$fn1, 'name', {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$op1.name
        });
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$fn1, 'length', {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$op1.length
        });
        $db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$Stream.Readable.prototype, $db9e3ff9930cefc4$var$key1, {
            __proto__: null,
            value: $db9e3ff9930cefc4$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $db9e3ff9930cefc4$var$_didIteratorError1 = true;
    $db9e3ff9930cefc4$var$_iteratorError1 = err;
} finally{
    try {
        if (!$db9e3ff9930cefc4$var$_iteratorNormalCompletion1 && $db9e3ff9930cefc4$var$_iterator1["return"] != null) {
            $db9e3ff9930cefc4$var$_iterator1["return"]();
        }
    } finally{
        if ($db9e3ff9930cefc4$var$_didIteratorError1) {
            throw $db9e3ff9930cefc4$var$_iteratorError1;
        }
    }
}

$db9e3ff9930cefc4$var$Stream.Writable = (parcelRequire("fuKAK"));

$db9e3ff9930cefc4$var$Stream.Duplex = (parcelRequire("iKBv6"));

$db9e3ff9930cefc4$var$Stream.Transform = (parcelRequire("02awK"));

$db9e3ff9930cefc4$var$Stream.PassThrough = (parcelRequire("avEMp"));
$db9e3ff9930cefc4$var$Stream.pipeline = $db9e3ff9930cefc4$require$pipeline;

var $8YI05 = parcelRequire("8YI05");
var $db9e3ff9930cefc4$require$addAbortSignal = $8YI05.addAbortSignal;
$db9e3ff9930cefc4$var$Stream.addAbortSignal = $db9e3ff9930cefc4$require$addAbortSignal;
$db9e3ff9930cefc4$var$Stream.finished = $lV7H7;
$db9e3ff9930cefc4$var$Stream.destroy = $db9e3ff9930cefc4$require$destroyer;
$db9e3ff9930cefc4$var$Stream.compose = $WdD80;
$db9e3ff9930cefc4$var$Stream.setDefaultHighWaterMark = $db9e3ff9930cefc4$var$setDefaultHighWaterMark;
$db9e3ff9930cefc4$var$Stream.getDefaultHighWaterMark = $db9e3ff9930cefc4$var$getDefaultHighWaterMark;
$db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $5hMkG;
    }
});
$db9e3ff9930cefc4$var$ObjectDefineProperty($db9e3ff9930cefc4$require$pipeline, $db9e3ff9930cefc4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5hMkG.pipeline;
    }
});
$db9e3ff9930cefc4$var$ObjectDefineProperty($lV7H7, $db9e3ff9930cefc4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5hMkG.finished;
    }
});
// Backwards-compat with node 0.4.x
$db9e3ff9930cefc4$var$Stream.Stream = $db9e3ff9930cefc4$var$Stream;
$db9e3ff9930cefc4$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$db9e3ff9930cefc4$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $db9e3ff9930cefc4$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("8PVhU", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $66ef864dde43352e$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $66ef864dde43352e$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("f3A5e", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $ikzXy = parcelRequire("ikzXy");

var $3wvRJ = parcelRequire("3wvRJ");
var $af63203e952a3567$var$format = $3wvRJ.format, $af63203e952a3567$var$inspect = $3wvRJ.inspect;

var $i1Urf = parcelRequire("i1Urf");
var $af63203e952a3567$var$ERR_INVALID_ARG_TYPE = $i1Urf.codes.ERR_INVALID_ARG_TYPE;

var $8PVhU = parcelRequire("8PVhU");
var $af63203e952a3567$var$kResistStopPropagation = $8PVhU.kResistStopPropagation, $af63203e952a3567$var$AggregateError = $8PVhU.AggregateError, $af63203e952a3567$var$SymbolDispose = $8PVhU.SymbolDispose;

var $af63203e952a3567$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $af63203e952a3567$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $af63203e952a3567$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $af63203e952a3567$var$Blob = globalThis.Blob || $ikzXy.Blob;
/* eslint-disable indent */ var $af63203e952a3567$var$isBlob = typeof $af63203e952a3567$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $af63203e952a3567$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $af63203e952a3567$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $af63203e952a3567$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $af63203e952a3567$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $af63203e952a3567$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $af63203e952a3567$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $af63203e952a3567$var$format,
    inspect: $af63203e952a3567$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $af63203e952a3567$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $af63203e952a3567$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $af63203e952a3567$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $af63203e952a3567$var$validateAbortSignal(signal, 'signal');
        $af63203e952a3567$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $af63203e952a3567$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $af63203e952a3567$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $af63203e952a3567$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $af63203e952a3567$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $af63203e952a3567$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("3wvRJ", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("i1Urf", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $3wvRJ = parcelRequire("3wvRJ");
var $d2041983c55e09d5$var$format = $3wvRJ.format, $d2041983c55e09d5$var$inspect = $3wvRJ.inspect;

var $8PVhU = parcelRequire("8PVhU");
var $d2041983c55e09d5$var$CustomAggregateError = $8PVhU.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $d2041983c55e09d5$var$AggregateError = globalThis.AggregateError || $d2041983c55e09d5$var$CustomAggregateError;
var $d2041983c55e09d5$var$kIsNodeError = Symbol('kIsNodeError');
var $d2041983c55e09d5$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $d2041983c55e09d5$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $d2041983c55e09d5$var$nodeInternalPrefix = '__node_internal_';
var $d2041983c55e09d5$var$codes = {};
function $d2041983c55e09d5$var$assert(value, message) {
    if (!value) throw new $d2041983c55e09d5$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $d2041983c55e09d5$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $d2041983c55e09d5$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $d2041983c55e09d5$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $d2041983c55e09d5$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $d2041983c55e09d5$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $d2041983c55e09d5$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $d2041983c55e09d5$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$d2041983c55e09d5$var$kIsNodeError] = true;
    $d2041983c55e09d5$var$codes[code] = NodeError;
}
function $d2041983c55e09d5$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $d2041983c55e09d5$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $d2041983c55e09d5$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $d2041983c55e09d5$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $d2041983c55e09d5$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $d2041983c55e09d5$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$d2041983c55e09d5$var$E('ERR_ASSERTION', '%s', Error);
$d2041983c55e09d5$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $d2041983c55e09d5$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $d2041983c55e09d5$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($d2041983c55e09d5$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($d2041983c55e09d5$var$classRegExp.test(value)) instances.push(value);
            else {
                $d2041983c55e09d5$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $d2041983c55e09d5$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $d2041983c55e09d5$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$d2041983c55e09d5$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $d2041983c55e09d5$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$d2041983c55e09d5$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$d2041983c55e09d5$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $d2041983c55e09d5$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$d2041983c55e09d5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $d2041983c55e09d5$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d2041983c55e09d5$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $d2041983c55e09d5$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $d2041983c55e09d5$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$d2041983c55e09d5$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$d2041983c55e09d5$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d2041983c55e09d5$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$d2041983c55e09d5$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$d2041983c55e09d5$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $d2041983c55e09d5$var$AbortError,
    aggregateTwoErrors: $d2041983c55e09d5$var$hideStackFrames($d2041983c55e09d5$var$aggregateTwoErrors),
    hideStackFrames: $d2041983c55e09d5$var$hideStackFrames,
    codes: $d2041983c55e09d5$var$codes
};

});


parcelRegister("jMeVs", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $e65e13ee6cabf1d3$export$42af8c323be37587; }, function (v) { return $e65e13ee6cabf1d3$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $e65e13ee6cabf1d3$export$f405f72c701dad87; }, function (v) { return $e65e13ee6cabf1d3$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $e65e13ee6cabf1d3$export$42af8c323be37587;
var $e65e13ee6cabf1d3$export$f405f72c701dad87;
'use strict';

var $e65e13ee6cabf1d3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $i1Urf = parcelRequire("i1Urf");
var $e65e13ee6cabf1d3$var$_require_codes = $i1Urf.codes, $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_VALUE = $e65e13ee6cabf1d3$var$_require_codes.ERR_INVALID_ARG_VALUE, $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE = $e65e13ee6cabf1d3$var$_require_codes.ERR_INVALID_ARG_TYPE, $e65e13ee6cabf1d3$var$ERR_MISSING_ARGS = $e65e13ee6cabf1d3$var$_require_codes.ERR_MISSING_ARGS, $e65e13ee6cabf1d3$var$ERR_OUT_OF_RANGE = $e65e13ee6cabf1d3$var$_require_codes.ERR_OUT_OF_RANGE, $e65e13ee6cabf1d3$var$AbortError = $i1Urf.AbortError;

var $angGq = parcelRequire("angGq");
var $e65e13ee6cabf1d3$var$validateAbortSignal = $angGq.validateAbortSignal, $e65e13ee6cabf1d3$var$validateInteger = $angGq.validateInteger, $e65e13ee6cabf1d3$var$validateObject = $angGq.validateObject;

var $e65e13ee6cabf1d3$var$kWeakHandler = (parcelRequire("8PVhU")).Symbol('kWeak');

var $e65e13ee6cabf1d3$var$kResistStopPropagation = (parcelRequire("8PVhU")).Symbol('kResistStopPropagation');

var $lV7H7 = parcelRequire("lV7H7");
var $e65e13ee6cabf1d3$require$finished = $lV7H7.finished;

var $WdD80 = parcelRequire("WdD80");

var $8YI05 = parcelRequire("8YI05");
var $e65e13ee6cabf1d3$require$addAbortSignalNoValidate = $8YI05.addAbortSignalNoValidate;

var $iz3nv = parcelRequire("iz3nv");
var $e65e13ee6cabf1d3$var$isWritable = $iz3nv.isWritable, $e65e13ee6cabf1d3$var$isNodeStream = $iz3nv.isNodeStream;

var $e65e13ee6cabf1d3$require$deprecate = (parcelRequire("f3A5e")).deprecate;

var $e65e13ee6cabf1d3$var$ArrayPrototypePush = (parcelRequire("8PVhU")).ArrayPrototypePush, $e65e13ee6cabf1d3$var$Boolean = (parcelRequire("8PVhU")).Boolean, $e65e13ee6cabf1d3$var$MathFloor = (parcelRequire("8PVhU")).MathFloor, $e65e13ee6cabf1d3$var$Number = (parcelRequire("8PVhU")).Number, $e65e13ee6cabf1d3$var$NumberIsNaN = (parcelRequire("8PVhU")).NumberIsNaN, $e65e13ee6cabf1d3$var$Promise = (parcelRequire("8PVhU")).Promise, $e65e13ee6cabf1d3$var$PromiseReject = (parcelRequire("8PVhU")).PromiseReject, $e65e13ee6cabf1d3$var$PromiseResolve = (parcelRequire("8PVhU")).PromiseResolve, $e65e13ee6cabf1d3$var$PromisePrototypeThen = (parcelRequire("8PVhU")).PromisePrototypeThen, $e65e13ee6cabf1d3$var$Symbol = (parcelRequire("8PVhU")).Symbol;
var $e65e13ee6cabf1d3$var$kEmpty = $e65e13ee6cabf1d3$var$Symbol('kEmpty');
var $e65e13ee6cabf1d3$var$kEof = $e65e13ee6cabf1d3$var$Symbol('kEof');
function $e65e13ee6cabf1d3$var$compose(stream, options) {
    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
    if ($e65e13ee6cabf1d3$var$isNodeStream(stream) && !$e65e13ee6cabf1d3$var$isWritable(stream)) throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $WdD80(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $e65e13ee6cabf1d3$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $e65e13ee6cabf1d3$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $e65e13ee6cabf1d3$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $e65e13ee6cabf1d3$var$MathFloor(options.highWaterMark);
    $e65e13ee6cabf1d3$var$validateInteger(concurrency, 'options.concurrency', 1);
    $e65e13ee6cabf1d3$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $e65e13ee6cabf1d3$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $e65e13ee6cabf1d3$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $e65e13ee6cabf1d3$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $e65e13ee6cabf1d3$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $e65e13ee6cabf1d3$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($e65e13ee6cabf1d3$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $e65e13ee6cabf1d3$var$PromiseReject(err1);
                                $e65e13ee6cabf1d3$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("f3A5e")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($e65e13ee6cabf1d3$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $e65e13ee6cabf1d3$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                        if (!(val !== $e65e13ee6cabf1d3$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $e65e13ee6cabf1d3$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $e65e13ee6cabf1d3$var$asIndexedPairs(options) {
    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $e65e13ee6cabf1d3$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $e65e13ee6cabf1d3$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($e65e13ee6cabf1d3$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $e65e13ee6cabf1d3$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $e65e13ee6cabf1d3$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $e65e13ee6cabf1d3$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($e65e13ee6cabf1d3$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $e65e13ee6cabf1d3$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $e65e13ee6cabf1d3$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($e65e13ee6cabf1d3$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $e65e13ee6cabf1d3$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $e65e13ee6cabf1d3$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $e65e13ee6cabf1d3$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $e65e13ee6cabf1d3$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($e65e13ee6cabf1d3$var$ERR_MISSING_ARGS);
function $e65e13ee6cabf1d3$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $e65e13ee6cabf1d3$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $e65e13ee6cabf1d3$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $e65e13ee6cabf1d3$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $e65e13ee6cabf1d3$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $e65e13ee6cabf1d3$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $e65e13ee6cabf1d3$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $e65e13ee6cabf1d3$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $e65e13ee6cabf1d3$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $e65e13ee6cabf1d3$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $e65e13ee6cabf1d3$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $e65e13ee6cabf1d3$var$flatMap(fn, options) {
    var values = $e65e13ee6cabf1d3$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $e65e13ee6cabf1d3$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $e65e13ee6cabf1d3$var$Number(number);
    if ($e65e13ee6cabf1d3$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $e65e13ee6cabf1d3$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $e65e13ee6cabf1d3$var$drop(number, options) {
    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
    number = $e65e13ee6cabf1d3$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $e65e13ee6cabf1d3$var$take(number, options) {
    if (options != null) $e65e13ee6cabf1d3$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $e65e13ee6cabf1d3$var$validateAbortSignal(options.signal, 'options.signal');
    number = $e65e13ee6cabf1d3$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $e65e13ee6cabf1d3$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$e65e13ee6cabf1d3$export$42af8c323be37587 = {
    asIndexedPairs: $e65e13ee6cabf1d3$require$deprecate($e65e13ee6cabf1d3$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $e65e13ee6cabf1d3$var$drop,
    filter: $e65e13ee6cabf1d3$var$filter,
    flatMap: $e65e13ee6cabf1d3$var$flatMap,
    map: $e65e13ee6cabf1d3$var$map,
    take: $e65e13ee6cabf1d3$var$take,
    compose: $e65e13ee6cabf1d3$var$compose
};
$e65e13ee6cabf1d3$export$f405f72c701dad87 = {
    every: $e65e13ee6cabf1d3$var$every,
    forEach: $e65e13ee6cabf1d3$var$forEach,
    reduce: $e65e13ee6cabf1d3$var$reduce,
    toArray: $e65e13ee6cabf1d3$var$toArray,
    some: $e65e13ee6cabf1d3$var$some,
    find: $e65e13ee6cabf1d3$var$find
};

});
parcelRegister("angGq", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $78d8fe4c175cdfdd$var$ArrayIsArray = $8PVhU.ArrayIsArray, $78d8fe4c175cdfdd$var$ArrayPrototypeIncludes = $8PVhU.ArrayPrototypeIncludes, $78d8fe4c175cdfdd$var$ArrayPrototypeJoin = $8PVhU.ArrayPrototypeJoin, $78d8fe4c175cdfdd$var$ArrayPrototypeMap = $8PVhU.ArrayPrototypeMap, $78d8fe4c175cdfdd$var$NumberIsInteger = $8PVhU.NumberIsInteger, $78d8fe4c175cdfdd$var$NumberIsNaN = $8PVhU.NumberIsNaN, $78d8fe4c175cdfdd$var$NumberMAX_SAFE_INTEGER = $8PVhU.NumberMAX_SAFE_INTEGER, $78d8fe4c175cdfdd$var$NumberMIN_SAFE_INTEGER = $8PVhU.NumberMIN_SAFE_INTEGER, $78d8fe4c175cdfdd$var$NumberParseInt = $8PVhU.NumberParseInt, $78d8fe4c175cdfdd$var$ObjectPrototypeHasOwnProperty = $8PVhU.ObjectPrototypeHasOwnProperty, $78d8fe4c175cdfdd$var$RegExpPrototypeExec = $8PVhU.RegExpPrototypeExec, $78d8fe4c175cdfdd$var$String = $8PVhU.String, $78d8fe4c175cdfdd$var$StringPrototypeToUpperCase = $8PVhU.StringPrototypeToUpperCase, $78d8fe4c175cdfdd$var$StringPrototypeTrim = $8PVhU.StringPrototypeTrim;

var $i1Urf = parcelRequire("i1Urf");
var $78d8fe4c175cdfdd$var$hideStackFrames = $i1Urf.hideStackFrames, $78d8fe4c175cdfdd$var$_require_codes = $i1Urf.codes, $78d8fe4c175cdfdd$var$ERR_SOCKET_BAD_PORT = $78d8fe4c175cdfdd$var$_require_codes.ERR_SOCKET_BAD_PORT, $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE = $78d8fe4c175cdfdd$var$_require_codes.ERR_INVALID_ARG_TYPE, $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE = $78d8fe4c175cdfdd$var$_require_codes.ERR_INVALID_ARG_VALUE, $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE = $78d8fe4c175cdfdd$var$_require_codes.ERR_OUT_OF_RANGE, $78d8fe4c175cdfdd$var$ERR_UNKNOWN_SIGNAL = $78d8fe4c175cdfdd$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $f3A5e = parcelRequire("f3A5e");
var $78d8fe4c175cdfdd$require$normalizeEncoding = $f3A5e.normalizeEncoding;

var $f3A5e = parcelRequire("f3A5e");
var $78d8fe4c175cdfdd$require$_require_types = $f3A5e.types;
var $78d8fe4c175cdfdd$var$isAsyncFunction = $78d8fe4c175cdfdd$require$_require_types.isAsyncFunction, $78d8fe4c175cdfdd$var$isArrayBufferView = $78d8fe4c175cdfdd$require$_require_types.isArrayBufferView;
var $78d8fe4c175cdfdd$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $78d8fe4c175cdfdd$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $78d8fe4c175cdfdd$var$isUint32(value) {
    return value === value >>> 0;
}
var $78d8fe4c175cdfdd$var$octalReg = /^[0-7]+$/;
var $78d8fe4c175cdfdd$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $78d8fe4c175cdfdd$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($78d8fe4c175cdfdd$var$RegExpPrototypeExec($78d8fe4c175cdfdd$var$octalReg, value) === null) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE(name, value, $78d8fe4c175cdfdd$var$modeDesc);
        value = $78d8fe4c175cdfdd$var$NumberParseInt(value, 8);
    }
    $78d8fe4c175cdfdd$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $78d8fe4c175cdfdd$var$validateInteger = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $78d8fe4c175cdfdd$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $78d8fe4c175cdfdd$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$78d8fe4c175cdfdd$var$NumberIsInteger(value)) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $78d8fe4c175cdfdd$var$validateInt32 = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$78d8fe4c175cdfdd$var$NumberIsInteger(value)) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $78d8fe4c175cdfdd$var$validateUint32 = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$78d8fe4c175cdfdd$var$NumberIsInteger(value)) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $78d8fe4c175cdfdd$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $78d8fe4c175cdfdd$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $78d8fe4c175cdfdd$var$NumberIsNaN(value)) throw new $78d8fe4c175cdfdd$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $78d8fe4c175cdfdd$var$validateOneOf = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name, oneOf) {
    if (!$78d8fe4c175cdfdd$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $78d8fe4c175cdfdd$var$ArrayPrototypeJoin($78d8fe4c175cdfdd$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $78d8fe4c175cdfdd$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $78d8fe4c175cdfdd$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $78d8fe4c175cdfdd$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$78d8fe4c175cdfdd$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $78d8fe4c175cdfdd$var$validateObject = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $78d8fe4c175cdfdd$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $78d8fe4c175cdfdd$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $78d8fe4c175cdfdd$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $78d8fe4c175cdfdd$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $78d8fe4c175cdfdd$var$validateDictionary = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $78d8fe4c175cdfdd$var$validateArray = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$78d8fe4c175cdfdd$var$ArrayIsArray(value)) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $78d8fe4c175cdfdd$var$validateStringArray(value, name) {
    $78d8fe4c175cdfdd$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$78d8fe4c175cdfdd$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $78d8fe4c175cdfdd$var$validateBooleanArray(value, name) {
    $78d8fe4c175cdfdd$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$78d8fe4c175cdfdd$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $78d8fe4c175cdfdd$var$validateAbortSignalArray(value, name) {
    $78d8fe4c175cdfdd$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $78d8fe4c175cdfdd$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $78d8fe4c175cdfdd$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $78d8fe4c175cdfdd$var$validateString(signal, name);
    if ($78d8fe4c175cdfdd$var$signals[signal] === undefined) {
        if ($78d8fe4c175cdfdd$var$signals[$78d8fe4c175cdfdd$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $78d8fe4c175cdfdd$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $78d8fe4c175cdfdd$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $78d8fe4c175cdfdd$var$validateBuffer = $78d8fe4c175cdfdd$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$78d8fe4c175cdfdd$var$isArrayBufferView(buffer)) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $78d8fe4c175cdfdd$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $78d8fe4c175cdfdd$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $78d8fe4c175cdfdd$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $78d8fe4c175cdfdd$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $78d8fe4c175cdfdd$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $78d8fe4c175cdfdd$var$validateAbortSignal = $78d8fe4c175cdfdd$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $78d8fe4c175cdfdd$var$validateFunction = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $78d8fe4c175cdfdd$var$validatePlainFunction = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $78d8fe4c175cdfdd$var$isAsyncFunction(value)) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $78d8fe4c175cdfdd$var$validateUndefined = $78d8fe4c175cdfdd$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $78d8fe4c175cdfdd$var$validateUnion(value, name, union) {
    if (!$78d8fe4c175cdfdd$var$ArrayPrototypeIncludes(union, value)) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_TYPE(name, "('".concat($78d8fe4c175cdfdd$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $78d8fe4c175cdfdd$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $78d8fe4c175cdfdd$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$78d8fe4c175cdfdd$var$RegExpPrototypeExec($78d8fe4c175cdfdd$var$linkValueRegExp, value)) throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $78d8fe4c175cdfdd$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $78d8fe4c175cdfdd$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($78d8fe4c175cdfdd$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $78d8fe4c175cdfdd$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $78d8fe4c175cdfdd$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $78d8fe4c175cdfdd$var$isInt32,
    isUint32: $78d8fe4c175cdfdd$var$isUint32,
    parseFileMode: $78d8fe4c175cdfdd$var$parseFileMode,
    validateArray: $78d8fe4c175cdfdd$var$validateArray,
    validateStringArray: $78d8fe4c175cdfdd$var$validateStringArray,
    validateBooleanArray: $78d8fe4c175cdfdd$var$validateBooleanArray,
    validateAbortSignalArray: $78d8fe4c175cdfdd$var$validateAbortSignalArray,
    validateBoolean: $78d8fe4c175cdfdd$var$validateBoolean,
    validateBuffer: $78d8fe4c175cdfdd$var$validateBuffer,
    validateDictionary: $78d8fe4c175cdfdd$var$validateDictionary,
    validateEncoding: $78d8fe4c175cdfdd$var$validateEncoding,
    validateFunction: $78d8fe4c175cdfdd$var$validateFunction,
    validateInt32: $78d8fe4c175cdfdd$var$validateInt32,
    validateInteger: $78d8fe4c175cdfdd$var$validateInteger,
    validateNumber: $78d8fe4c175cdfdd$var$validateNumber,
    validateObject: $78d8fe4c175cdfdd$var$validateObject,
    validateOneOf: $78d8fe4c175cdfdd$var$validateOneOf,
    validatePlainFunction: $78d8fe4c175cdfdd$var$validatePlainFunction,
    validatePort: $78d8fe4c175cdfdd$var$validatePort,
    validateSignalName: $78d8fe4c175cdfdd$var$validateSignalName,
    validateString: $78d8fe4c175cdfdd$var$validateString,
    validateUint32: $78d8fe4c175cdfdd$var$validateUint32,
    validateUndefined: $78d8fe4c175cdfdd$var$validateUndefined,
    validateUnion: $78d8fe4c175cdfdd$var$validateUnion,
    validateAbortSignal: $78d8fe4c175cdfdd$var$validateAbortSignal,
    validateLinkHeaderValue: $78d8fe4c175cdfdd$var$validateLinkHeaderValue
};

});

parcelRegister("lV7H7", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $i1Urf = parcelRequire("i1Urf");
/* replacement end */ var $ff54e3ccfd612d5e$var$AbortError = $i1Urf.AbortError, $ff54e3ccfd612d5e$var$codes = $i1Urf.codes;
var $ff54e3ccfd612d5e$var$ERR_INVALID_ARG_TYPE = $ff54e3ccfd612d5e$var$codes.ERR_INVALID_ARG_TYPE, $ff54e3ccfd612d5e$var$ERR_STREAM_PREMATURE_CLOSE = $ff54e3ccfd612d5e$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $ff54e3ccfd612d5e$var$kEmptyObject = (parcelRequire("f3A5e")).kEmptyObject, $ff54e3ccfd612d5e$var$once = (parcelRequire("f3A5e")).once;

var $angGq = parcelRequire("angGq");
var $ff54e3ccfd612d5e$var$validateAbortSignal = $angGq.validateAbortSignal, $ff54e3ccfd612d5e$var$validateFunction = $angGq.validateFunction, $ff54e3ccfd612d5e$var$validateObject = $angGq.validateObject, $ff54e3ccfd612d5e$var$validateBoolean = $angGq.validateBoolean;

var $8PVhU = parcelRequire("8PVhU");
var $ff54e3ccfd612d5e$var$Promise = $8PVhU.Promise, $ff54e3ccfd612d5e$var$PromisePrototypeThen = $8PVhU.PromisePrototypeThen, $ff54e3ccfd612d5e$var$SymbolDispose = $8PVhU.SymbolDispose;

var $iz3nv = parcelRequire("iz3nv");
var $ff54e3ccfd612d5e$var$isClosed = $iz3nv.isClosed, $ff54e3ccfd612d5e$var$isReadable = $iz3nv.isReadable, $ff54e3ccfd612d5e$var$isReadableNodeStream = $iz3nv.isReadableNodeStream, $ff54e3ccfd612d5e$var$isReadableStream = $iz3nv.isReadableStream, $ff54e3ccfd612d5e$var$isReadableFinished = $iz3nv.isReadableFinished, $ff54e3ccfd612d5e$var$isReadableErrored = $iz3nv.isReadableErrored, $ff54e3ccfd612d5e$var$isWritable = $iz3nv.isWritable, $ff54e3ccfd612d5e$var$isWritableNodeStream = $iz3nv.isWritableNodeStream, $ff54e3ccfd612d5e$var$isWritableStream = $iz3nv.isWritableStream, $ff54e3ccfd612d5e$var$isWritableFinished = $iz3nv.isWritableFinished, $ff54e3ccfd612d5e$var$isWritableErrored = $iz3nv.isWritableErrored, $ff54e3ccfd612d5e$var$isNodeStream = $iz3nv.isNodeStream, $ff54e3ccfd612d5e$var$_willEmitClose = $iz3nv.willEmitClose, $ff54e3ccfd612d5e$var$kIsClosedPromise = $iz3nv.kIsClosedPromise;
var $ff54e3ccfd612d5e$var$addAbortListener;
function $ff54e3ccfd612d5e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $ff54e3ccfd612d5e$var$nop = function() {};

function $ff54e3ccfd612d5e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $ff54e3ccfd612d5e$var$kEmptyObject;
    } else if (options == null) options = $ff54e3ccfd612d5e$var$kEmptyObject;
    else $ff54e3ccfd612d5e$var$validateObject(options, 'options');
    $ff54e3ccfd612d5e$var$validateFunction(callback, 'callback');
    $ff54e3ccfd612d5e$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $ff54e3ccfd612d5e$var$once(callback);
    if ($ff54e3ccfd612d5e$var$isReadableStream(stream) || $ff54e3ccfd612d5e$var$isWritableStream(stream)) return $ff54e3ccfd612d5e$var$eosWeb(stream, options, callback);
    if (!$ff54e3ccfd612d5e$var$isNodeStream(stream)) throw new $ff54e3ccfd612d5e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $ff54e3ccfd612d5e$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $ff54e3ccfd612d5e$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $ff54e3ccfd612d5e$var$_willEmitClose(stream) && $ff54e3ccfd612d5e$var$isReadableNodeStream(stream) === readable && $ff54e3ccfd612d5e$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $ff54e3ccfd612d5e$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $ff54e3ccfd612d5e$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $ff54e3ccfd612d5e$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $ff54e3ccfd612d5e$var$isWritableErrored(stream) || $ff54e3ccfd612d5e$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $ff54e3ccfd612d5e$var$isReadableNodeStream(stream, true)) {
            if (!$ff54e3ccfd612d5e$var$isReadableFinished(stream, false)) return callback.call(stream, new $ff54e3ccfd612d5e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$ff54e3ccfd612d5e$var$isWritableFinished(stream, false)) return callback.call(stream, new $ff54e3ccfd612d5e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $ff54e3ccfd612d5e$var$isWritableErrored(stream) || $ff54e3ccfd612d5e$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($ff54e3ccfd612d5e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $ff54e3ccfd612d5e$var$isReadable(stream)) && (writableFinished || $ff54e3ccfd612d5e$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $ff54e3ccfd612d5e$var$isWritable(stream)) && (readableFinished || $ff54e3ccfd612d5e$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $ff54e3ccfd612d5e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $ff54e3ccfd612d5e$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $ff54e3ccfd612d5e$var$addAbortListener = $ff54e3ccfd612d5e$var$addAbortListener || (parcelRequire("f3A5e")).addAbortListener;
            var disposable = $ff54e3ccfd612d5e$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $ff54e3ccfd612d5e$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$ff54e3ccfd612d5e$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $ff54e3ccfd612d5e$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $ff54e3ccfd612d5e$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $ff54e3ccfd612d5e$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $ff54e3ccfd612d5e$var$addAbortListener = $ff54e3ccfd612d5e$var$addAbortListener || (parcelRequire("f3A5e")).addAbortListener;
            var disposable = $ff54e3ccfd612d5e$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $ff54e3ccfd612d5e$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$ff54e3ccfd612d5e$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $ff54e3ccfd612d5e$var$PromisePrototypeThen(stream[$ff54e3ccfd612d5e$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $ff54e3ccfd612d5e$var$nop;
}
function $ff54e3ccfd612d5e$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $ff54e3ccfd612d5e$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $ff54e3ccfd612d5e$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $ff54e3ccfd612d5e$var$Promise(function(resolve, reject) {
        var cleanup = $ff54e3ccfd612d5e$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $ff54e3ccfd612d5e$var$eos;
module.exports.finished = $ff54e3ccfd612d5e$var$finished;

});
parcelRegister("iz3nv", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $d83e1db7a32a7c31$var$SymbolAsyncIterator = $8PVhU.SymbolAsyncIterator, $d83e1db7a32a7c31$var$SymbolIterator = $8PVhU.SymbolIterator, $d83e1db7a32a7c31$var$SymbolFor = $8PVhU.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $d83e1db7a32a7c31$var$kIsDestroyed = $d83e1db7a32a7c31$var$SymbolFor('nodejs.stream.destroyed');
var $d83e1db7a32a7c31$var$kIsErrored = $d83e1db7a32a7c31$var$SymbolFor('nodejs.stream.errored');
var $d83e1db7a32a7c31$var$kIsReadable = $d83e1db7a32a7c31$var$SymbolFor('nodejs.stream.readable');
var $d83e1db7a32a7c31$var$kIsWritable = $d83e1db7a32a7c31$var$SymbolFor('nodejs.stream.writable');
var $d83e1db7a32a7c31$var$kIsDisturbed = $d83e1db7a32a7c31$var$SymbolFor('nodejs.stream.disturbed');
var $d83e1db7a32a7c31$var$kIsClosedPromise = $d83e1db7a32a7c31$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $d83e1db7a32a7c31$var$kControllerErrorFunction = $d83e1db7a32a7c31$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $d83e1db7a32a7c31$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $d83e1db7a32a7c31$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $d83e1db7a32a7c31$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $d83e1db7a32a7c31$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $d83e1db7a32a7c31$var$isReadableStream(obj) {
    return !!(obj && !$d83e1db7a32a7c31$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $d83e1db7a32a7c31$var$isWritableStream(obj) {
    return !!(obj && !$d83e1db7a32a7c31$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $d83e1db7a32a7c31$var$isTransformStream(obj) {
    return !!(obj && !$d83e1db7a32a7c31$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $d83e1db7a32a7c31$var$isWebStream(obj) {
    return $d83e1db7a32a7c31$var$isReadableStream(obj) || $d83e1db7a32a7c31$var$isWritableStream(obj) || $d83e1db7a32a7c31$var$isTransformStream(obj);
}
function $d83e1db7a32a7c31$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$d83e1db7a32a7c31$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$d83e1db7a32a7c31$var$SymbolIterator] === 'function';
    return typeof obj[$d83e1db7a32a7c31$var$SymbolAsyncIterator] === 'function' || typeof obj[$d83e1db7a32a7c31$var$SymbolIterator] === 'function';
}
function $d83e1db7a32a7c31$var$isDestroyed(stream) {
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$d83e1db7a32a7c31$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $d83e1db7a32a7c31$var$isWritableEnded(stream) {
    if (!$d83e1db7a32a7c31$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $d83e1db7a32a7c31$var$isWritableFinished(stream, strict) {
    if (!$d83e1db7a32a7c31$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $d83e1db7a32a7c31$var$isReadableEnded(stream) {
    if (!$d83e1db7a32a7c31$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $d83e1db7a32a7c31$var$isReadableFinished(stream, strict) {
    if (!$d83e1db7a32a7c31$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $d83e1db7a32a7c31$var$isReadable(stream) {
    if (stream && stream[$d83e1db7a32a7c31$var$kIsReadable] != null) return stream[$d83e1db7a32a7c31$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($d83e1db7a32a7c31$var$isDestroyed(stream)) return false;
    return $d83e1db7a32a7c31$var$isReadableNodeStream(stream) && stream.readable && !$d83e1db7a32a7c31$var$isReadableFinished(stream);
}
function $d83e1db7a32a7c31$var$isWritable(stream) {
    if (stream && stream[$d83e1db7a32a7c31$var$kIsWritable] != null) return stream[$d83e1db7a32a7c31$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($d83e1db7a32a7c31$var$isDestroyed(stream)) return false;
    return $d83e1db7a32a7c31$var$isWritableNodeStream(stream) && stream.writable && !$d83e1db7a32a7c31$var$isWritableEnded(stream);
}
function $d83e1db7a32a7c31$var$isFinished(stream, opts) {
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    if ($d83e1db7a32a7c31$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $d83e1db7a32a7c31$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $d83e1db7a32a7c31$var$isWritable(stream)) return false;
    return true;
}
function $d83e1db7a32a7c31$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $d83e1db7a32a7c31$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $d83e1db7a32a7c31$var$isClosed(stream) {
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $d83e1db7a32a7c31$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $d83e1db7a32a7c31$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $d83e1db7a32a7c31$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $d83e1db7a32a7c31$var$isOutgoingMessage(stream);
}
function $d83e1db7a32a7c31$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $d83e1db7a32a7c31$var$willEmitClose(stream) {
    if (!$d83e1db7a32a7c31$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $d83e1db7a32a7c31$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $d83e1db7a32a7c31$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$d83e1db7a32a7c31$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $d83e1db7a32a7c31$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$d83e1db7a32a7c31$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $d83e1db7a32a7c31$var$isDestroyed,
    kIsDestroyed: $d83e1db7a32a7c31$var$kIsDestroyed,
    isDisturbed: $d83e1db7a32a7c31$var$isDisturbed,
    kIsDisturbed: $d83e1db7a32a7c31$var$kIsDisturbed,
    isErrored: $d83e1db7a32a7c31$var$isErrored,
    kIsErrored: $d83e1db7a32a7c31$var$kIsErrored,
    isReadable: $d83e1db7a32a7c31$var$isReadable,
    kIsReadable: $d83e1db7a32a7c31$var$kIsReadable,
    kIsClosedPromise: $d83e1db7a32a7c31$var$kIsClosedPromise,
    kControllerErrorFunction: $d83e1db7a32a7c31$var$kControllerErrorFunction,
    kIsWritable: $d83e1db7a32a7c31$var$kIsWritable,
    isClosed: $d83e1db7a32a7c31$var$isClosed,
    isDuplexNodeStream: $d83e1db7a32a7c31$var$isDuplexNodeStream,
    isFinished: $d83e1db7a32a7c31$var$isFinished,
    isIterable: $d83e1db7a32a7c31$var$isIterable,
    isReadableNodeStream: $d83e1db7a32a7c31$var$isReadableNodeStream,
    isReadableStream: $d83e1db7a32a7c31$var$isReadableStream,
    isReadableEnded: $d83e1db7a32a7c31$var$isReadableEnded,
    isReadableFinished: $d83e1db7a32a7c31$var$isReadableFinished,
    isReadableErrored: $d83e1db7a32a7c31$var$isReadableErrored,
    isNodeStream: $d83e1db7a32a7c31$var$isNodeStream,
    isWebStream: $d83e1db7a32a7c31$var$isWebStream,
    isWritable: $d83e1db7a32a7c31$var$isWritable,
    isWritableNodeStream: $d83e1db7a32a7c31$var$isWritableNodeStream,
    isWritableStream: $d83e1db7a32a7c31$var$isWritableStream,
    isWritableEnded: $d83e1db7a32a7c31$var$isWritableEnded,
    isWritableFinished: $d83e1db7a32a7c31$var$isWritableFinished,
    isWritableErrored: $d83e1db7a32a7c31$var$isWritableErrored,
    isServerRequest: $d83e1db7a32a7c31$var$isServerRequest,
    isServerResponse: $d83e1db7a32a7c31$var$isServerResponse,
    willEmitClose: $d83e1db7a32a7c31$var$willEmitClose,
    isTransformStream: $d83e1db7a32a7c31$var$isTransformStream
};

});


parcelRegister("WdD80", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $l7PcQ = parcelRequire("l7PcQ");
var $0aeffd8c3fd780b1$require$pipeline = $l7PcQ.pipeline;

var $iKBv6 = parcelRequire("iKBv6");

var $6baNx = parcelRequire("6baNx");
var $0aeffd8c3fd780b1$require$destroyer = $6baNx.destroyer;

var $iz3nv = parcelRequire("iz3nv");
var $0aeffd8c3fd780b1$var$isNodeStream = $iz3nv.isNodeStream, $0aeffd8c3fd780b1$var$isReadable = $iz3nv.isReadable, $0aeffd8c3fd780b1$var$isWritable = $iz3nv.isWritable, $0aeffd8c3fd780b1$var$isWebStream = $iz3nv.isWebStream, $0aeffd8c3fd780b1$var$isTransformStream = $iz3nv.isTransformStream, $0aeffd8c3fd780b1$var$isWritableStream = $iz3nv.isWritableStream, $0aeffd8c3fd780b1$var$isReadableStream = $iz3nv.isReadableStream;

var $i1Urf = parcelRequire("i1Urf");
var $0aeffd8c3fd780b1$var$AbortError = $i1Urf.AbortError, $0aeffd8c3fd780b1$var$_require_codes = $i1Urf.codes, $0aeffd8c3fd780b1$var$ERR_INVALID_ARG_VALUE = $0aeffd8c3fd780b1$var$_require_codes.ERR_INVALID_ARG_VALUE, $0aeffd8c3fd780b1$var$ERR_MISSING_ARGS = $0aeffd8c3fd780b1$var$_require_codes.ERR_MISSING_ARGS;

var $lV7H7 = parcelRequire("lV7H7");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $0aeffd8c3fd780b1$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $iKBv6.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $iKBv6.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $iKBv6.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$0aeffd8c3fd780b1$var$isNodeStream(streams[n]) && !$0aeffd8c3fd780b1$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($0aeffd8c3fd780b1$var$isReadable(streams[n]) || $0aeffd8c3fd780b1$var$isReadableStream(streams[n]) || $0aeffd8c3fd780b1$var$isTransformStream(streams[n]))) throw new $0aeffd8c3fd780b1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($0aeffd8c3fd780b1$var$isWritable(streams[n]) || $0aeffd8c3fd780b1$var$isWritableStream(streams[n]) || $0aeffd8c3fd780b1$var$isTransformStream(streams[n]))) throw new $0aeffd8c3fd780b1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $0aeffd8c3fd780b1$require$pipeline(streams, onfinished);
    var writable = !!($0aeffd8c3fd780b1$var$isWritable(head) || $0aeffd8c3fd780b1$var$isWritableStream(head) || $0aeffd8c3fd780b1$var$isTransformStream(head));
    var readable = !!($0aeffd8c3fd780b1$var$isReadable(tail) || $0aeffd8c3fd780b1$var$isReadableStream(tail) || $0aeffd8c3fd780b1$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $iKBv6({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($0aeffd8c3fd780b1$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($0aeffd8c3fd780b1$var$isWebStream(head)) {
            var writable1 = $0aeffd8c3fd780b1$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $0aeffd8c3fd780b1$var$isTransformStream(tail) ? tail.readable : tail;
        $lV7H7(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($0aeffd8c3fd780b1$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($0aeffd8c3fd780b1$var$isWebStream(tail)) {
            var readable1 = $0aeffd8c3fd780b1$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $0aeffd8c3fd780b1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($0aeffd8c3fd780b1$var$isNodeStream(tail)) $0aeffd8c3fd780b1$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("l7PcQ", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $f611f8e319c2ddf7$var$ArrayIsArray = $8PVhU.ArrayIsArray, $f611f8e319c2ddf7$var$Promise = $8PVhU.Promise, $f611f8e319c2ddf7$var$SymbolAsyncIterator = $8PVhU.SymbolAsyncIterator, $f611f8e319c2ddf7$var$SymbolDispose = $8PVhU.SymbolDispose;

var $lV7H7 = parcelRequire("lV7H7");

var $f611f8e319c2ddf7$require$once = (parcelRequire("f3A5e")).once;

var $6baNx = parcelRequire("6baNx");

var $iKBv6 = parcelRequire("iKBv6");

var $i1Urf = parcelRequire("i1Urf");
var $f611f8e319c2ddf7$var$aggregateTwoErrors = $i1Urf.aggregateTwoErrors, $f611f8e319c2ddf7$var$_require_codes = $i1Urf.codes, $f611f8e319c2ddf7$var$ERR_INVALID_ARG_TYPE = $f611f8e319c2ddf7$var$_require_codes.ERR_INVALID_ARG_TYPE, $f611f8e319c2ddf7$var$ERR_INVALID_RETURN_VALUE = $f611f8e319c2ddf7$var$_require_codes.ERR_INVALID_RETURN_VALUE, $f611f8e319c2ddf7$var$ERR_MISSING_ARGS = $f611f8e319c2ddf7$var$_require_codes.ERR_MISSING_ARGS, $f611f8e319c2ddf7$var$ERR_STREAM_DESTROYED = $f611f8e319c2ddf7$var$_require_codes.ERR_STREAM_DESTROYED, $f611f8e319c2ddf7$var$ERR_STREAM_PREMATURE_CLOSE = $f611f8e319c2ddf7$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $f611f8e319c2ddf7$var$AbortError = $i1Urf.AbortError;

var $angGq = parcelRequire("angGq");
var $f611f8e319c2ddf7$var$validateFunction = $angGq.validateFunction, $f611f8e319c2ddf7$var$validateAbortSignal = $angGq.validateAbortSignal;

var $iz3nv = parcelRequire("iz3nv");
var $f611f8e319c2ddf7$var$isIterable = $iz3nv.isIterable, $f611f8e319c2ddf7$var$isReadable = $iz3nv.isReadable, $f611f8e319c2ddf7$var$isReadableNodeStream = $iz3nv.isReadableNodeStream, $f611f8e319c2ddf7$var$isNodeStream = $iz3nv.isNodeStream, $f611f8e319c2ddf7$var$isTransformStream = $iz3nv.isTransformStream, $f611f8e319c2ddf7$var$isWebStream = $iz3nv.isWebStream, $f611f8e319c2ddf7$var$isReadableStream = $iz3nv.isReadableStream, $f611f8e319c2ddf7$var$isReadableFinished = $iz3nv.isReadableFinished;

var $f611f8e319c2ddf7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $f611f8e319c2ddf7$var$PassThrough;
var $f611f8e319c2ddf7$var$Readable;
var $f611f8e319c2ddf7$var$addAbortListener;
function $f611f8e319c2ddf7$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $lV7H7(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $6baNx.destroyer(stream, err || new $f611f8e319c2ddf7$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $f611f8e319c2ddf7$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $f611f8e319c2ddf7$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $f611f8e319c2ddf7$var$makeAsyncIterable(val) {
    if ($f611f8e319c2ddf7$var$isIterable(val)) return val;
    else if ($f611f8e319c2ddf7$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $f611f8e319c2ddf7$var$fromReadable(val);
    throw new $f611f8e319c2ddf7$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $f611f8e319c2ddf7$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$f611f8e319c2ddf7$var$Readable) $f611f8e319c2ddf7$var$Readable = (parcelRequire("6P7iX"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($f611f8e319c2ddf7$var$Readable.prototype[$f611f8e319c2ddf7$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f611f8e319c2ddf7$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $f611f8e319c2ddf7$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $lV7H7(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $f611f8e319c2ddf7$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $f611f8e319c2ddf7$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($f611f8e319c2ddf7$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $f611f8e319c2ddf7$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $f611f8e319c2ddf7$var$pipelineImpl(streams, $f611f8e319c2ddf7$require$once($f611f8e319c2ddf7$var$popCallback(streams)));
}


function $f611f8e319c2ddf7$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($f611f8e319c2ddf7$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $f611f8e319c2ddf7$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($f611f8e319c2ddf7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($f611f8e319c2ddf7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$f611f8e319c2ddf7$var$isIterable(ret)) throw new $f611f8e319c2ddf7$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($f611f8e319c2ddf7$var$isIterable(stream) || $f611f8e319c2ddf7$var$isReadableNodeStream(stream) || $f611f8e319c2ddf7$var$isTransformStream(stream)) ret = stream;
            else ret = $iKBv6.from(stream);
        } else if (typeof stream === 'function') {
            if ($f611f8e319c2ddf7$var$isTransformStream(ret)) {
                var _ret;
                ret = $f611f8e319c2ddf7$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $f611f8e319c2ddf7$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$f611f8e319c2ddf7$var$isIterable(ret, true)) throw new $f611f8e319c2ddf7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$f611f8e319c2ddf7$var$PassThrough) $f611f8e319c2ddf7$var$PassThrough = (parcelRequire("avEMp"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $f611f8e319c2ddf7$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($f611f8e319c2ddf7$var$isIterable(ret, true)) {
                    finishCount++;
                    $f611f8e319c2ddf7$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($f611f8e319c2ddf7$var$isReadableStream(ret) || $f611f8e319c2ddf7$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $f611f8e319c2ddf7$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $f611f8e319c2ddf7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $f611f8e319c2ddf7$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($f611f8e319c2ddf7$var$isNodeStream(stream)) {
            if ($f611f8e319c2ddf7$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $f611f8e319c2ddf7$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($f611f8e319c2ddf7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($f611f8e319c2ddf7$var$isTransformStream(ret) || $f611f8e319c2ddf7$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $f611f8e319c2ddf7$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($f611f8e319c2ddf7$var$isIterable(ret)) {
                finishCount++;
                $f611f8e319c2ddf7$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $f611f8e319c2ddf7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($f611f8e319c2ddf7$var$isWebStream(stream)) {
            if ($f611f8e319c2ddf7$var$isReadableNodeStream(ret)) {
                finishCount++;
                $f611f8e319c2ddf7$var$pumpToWeb($f611f8e319c2ddf7$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($f611f8e319c2ddf7$var$isReadableStream(ret) || $f611f8e319c2ddf7$var$isIterable(ret)) {
                finishCount++;
                $f611f8e319c2ddf7$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($f611f8e319c2ddf7$var$isTransformStream(ret)) {
                finishCount++;
                $f611f8e319c2ddf7$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $f611f8e319c2ddf7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $iKBv6.from(stream);
    };
    if (streams.length === 1 && $f611f8e319c2ddf7$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $f611f8e319c2ddf7$var$ERR_MISSING_ARGS('streams');
    var ac = new $f611f8e319c2ddf7$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $f611f8e319c2ddf7$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $f611f8e319c2ddf7$var$AbortError());
    }
    $f611f8e319c2ddf7$var$addAbortListener = $f611f8e319c2ddf7$var$addAbortListener || (parcelRequire("f3A5e")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $f611f8e319c2ddf7$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$f611f8e319c2ddf7$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $f611f8e319c2ddf7$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $f611f8e319c2ddf7$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($f611f8e319c2ddf7$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $lV7H7(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $lV7H7(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $f611f8e319c2ddf7$var$pipelineImpl,
    pipeline: $f611f8e319c2ddf7$var$pipeline
};

});
parcelRegister("6baNx", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $i1Urf = parcelRequire("i1Urf");
/* replacement end */ var $47fc25647c285446$var$aggregateTwoErrors = $i1Urf.aggregateTwoErrors, $47fc25647c285446$var$ERR_MULTIPLE_CALLBACK = $i1Urf.codes.ERR_MULTIPLE_CALLBACK, $47fc25647c285446$var$AbortError = $i1Urf.AbortError;

var $8PVhU = parcelRequire("8PVhU");
var $47fc25647c285446$require$Symbol = $8PVhU.Symbol;

var $iz3nv = parcelRequire("iz3nv");
var $47fc25647c285446$var$kIsDestroyed = $iz3nv.kIsDestroyed, $47fc25647c285446$var$isDestroyed = $iz3nv.isDestroyed, $47fc25647c285446$var$isFinished = $iz3nv.isFinished, $47fc25647c285446$var$isServerRequest = $iz3nv.isServerRequest;
var $47fc25647c285446$var$kDestroy = $47fc25647c285446$require$Symbol('kDestroy');
var $47fc25647c285446$var$kConstruct = $47fc25647c285446$require$Symbol('kConstruct');
function $47fc25647c285446$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $47fc25647c285446$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $47fc25647c285446$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($47fc25647c285446$var$kDestroy, function(er) {
        $47fc25647c285446$var$_destroy(this, $47fc25647c285446$var$aggregateTwoErrors(er, err), cb);
    });
    else $47fc25647c285446$var$_destroy(this, err, cb);
    return this;
}
function $47fc25647c285446$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $47fc25647c285446$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($47fc25647c285446$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($47fc25647c285446$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $47fc25647c285446$var$emitErrorCloseNT(self, err) {
    $47fc25647c285446$var$emitErrorNT(self, err);
    $47fc25647c285446$var$emitCloseNT(self);
}
function $47fc25647c285446$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $47fc25647c285446$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $47fc25647c285446$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $47fc25647c285446$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($47fc25647c285446$var$emitErrorNT, stream, err);
        else $47fc25647c285446$var$emitErrorNT(stream, err);
    }
}
function $47fc25647c285446$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($47fc25647c285446$var$kConstruct, cb);
    if (stream.listenerCount($47fc25647c285446$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($47fc25647c285446$var$constructNT, stream);
}
function $47fc25647c285446$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $47fc25647c285446$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $47fc25647c285446$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($47fc25647c285446$var$kDestroy, err);
        else if (err) $47fc25647c285446$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($47fc25647c285446$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $47fc25647c285446$var$emitConstructNT(stream) {
    stream.emit($47fc25647c285446$var$kConstruct);
}
function $47fc25647c285446$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $47fc25647c285446$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $47fc25647c285446$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($47fc25647c285446$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $47fc25647c285446$var$destroyer(stream, err) {
    if (!stream || $47fc25647c285446$var$isDestroyed(stream)) return;
    if (!err && !$47fc25647c285446$var$isFinished(stream)) err = new $47fc25647c285446$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($47fc25647c285446$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($47fc25647c285446$var$isRequest(stream)) stream.abort();
    else if ($47fc25647c285446$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($47fc25647c285446$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($47fc25647c285446$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$47fc25647c285446$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $47fc25647c285446$var$construct,
    destroyer: $47fc25647c285446$var$destroyer,
    destroy: $47fc25647c285446$var$destroy,
    undestroy: $47fc25647c285446$var$undestroy,
    errorOrDestroy: $47fc25647c285446$var$errorOrDestroy
};

});

parcelRegister("iKBv6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $da699cb838be9440$var$ObjectDefineProperties = $8PVhU.ObjectDefineProperties, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor = $8PVhU.ObjectGetOwnPropertyDescriptor, $da699cb838be9440$var$ObjectKeys = $8PVhU.ObjectKeys, $da699cb838be9440$var$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf;
module.exports = $da699cb838be9440$var$Duplex;

var $6P7iX = parcelRequire("6P7iX");

var $fuKAK = parcelRequire("fuKAK");
$da699cb838be9440$var$ObjectSetPrototypeOf($da699cb838be9440$var$Duplex.prototype, $6P7iX.prototype);
$da699cb838be9440$var$ObjectSetPrototypeOf($da699cb838be9440$var$Duplex, $6P7iX);
{
    var $da699cb838be9440$var$keys = $da699cb838be9440$var$ObjectKeys($fuKAK.prototype);
    // Allow the keys array to be GC'ed.
    for(var $da699cb838be9440$var$i = 0; $da699cb838be9440$var$i < $da699cb838be9440$var$keys.length; $da699cb838be9440$var$i++){
        var $da699cb838be9440$var$method = $da699cb838be9440$var$keys[$da699cb838be9440$var$i];
        if (!$da699cb838be9440$var$Duplex.prototype[$da699cb838be9440$var$method]) $da699cb838be9440$var$Duplex.prototype[$da699cb838be9440$var$method] = $fuKAK.prototype[$da699cb838be9440$var$method];
    }
}function $da699cb838be9440$var$Duplex(options) {
    if (!(this instanceof $da699cb838be9440$var$Duplex)) return new $da699cb838be9440$var$Duplex(options);
    $6P7iX.call(this, options);
    $fuKAK.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$da699cb838be9440$var$ObjectDefineProperties($da699cb838be9440$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $da699cb838be9440$var$ObjectGetOwnPropertyDescriptor($fuKAK.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $da699cb838be9440$var$webStreamsAdapters;
// Lazy to avoid circular references
function $da699cb838be9440$var$lazyWebStreams() {
    if ($da699cb838be9440$var$webStreamsAdapters === undefined) $da699cb838be9440$var$webStreamsAdapters = {};
    return $da699cb838be9440$var$webStreamsAdapters;
}
$da699cb838be9440$var$Duplex.fromWeb = function(pair, options) {
    return $da699cb838be9440$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$da699cb838be9440$var$Duplex.toWeb = function(duplex) {
    return $da699cb838be9440$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $da699cb838be9440$var$duplexify;

$da699cb838be9440$var$Duplex.from = function(body) {
    if (!$da699cb838be9440$var$duplexify) $da699cb838be9440$var$duplexify = (parcelRequire("2zM5v"));
    return $da699cb838be9440$var$duplexify(body, 'body');
};

});
parcelRegister("6P7iX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8PVhU = parcelRequire("8PVhU");
/* replacement end */ var $4f7d2c16b257e230$var$ArrayPrototypeIndexOf = $8PVhU.ArrayPrototypeIndexOf, $4f7d2c16b257e230$var$NumberIsInteger = $8PVhU.NumberIsInteger, $4f7d2c16b257e230$var$NumberIsNaN = $8PVhU.NumberIsNaN, $4f7d2c16b257e230$var$NumberParseInt = $8PVhU.NumberParseInt, $4f7d2c16b257e230$var$ObjectDefineProperties = $8PVhU.ObjectDefineProperties, $4f7d2c16b257e230$var$ObjectKeys = $8PVhU.ObjectKeys, $4f7d2c16b257e230$var$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf, $4f7d2c16b257e230$var$Promise = $8PVhU.Promise, $4f7d2c16b257e230$var$SafeSet = $8PVhU.SafeSet, $4f7d2c16b257e230$var$SymbolAsyncDispose = $8PVhU.SymbolAsyncDispose, $4f7d2c16b257e230$var$SymbolAsyncIterator = $8PVhU.SymbolAsyncIterator, $4f7d2c16b257e230$var$Symbol = $8PVhU.Symbol;
module.exports = $4f7d2c16b257e230$var$Readable;
$4f7d2c16b257e230$var$Readable.ReadableState = $4f7d2c16b257e230$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $4f7d2c16b257e230$var$EE = $bBoAO.EventEmitter;

var $cdt5A = parcelRequire("cdt5A");
var $4f7d2c16b257e230$var$Stream = $cdt5A.Stream, $4f7d2c16b257e230$var$prependListener = $cdt5A.prependListener;

var $ikzXy = parcelRequire("ikzXy");
var $4f7d2c16b257e230$require$Buffer = $ikzXy.Buffer;

var $8YI05 = parcelRequire("8YI05");
var $4f7d2c16b257e230$require$addAbortSignal = $8YI05.addAbortSignal;

var $lV7H7 = parcelRequire("lV7H7");

var $4f7d2c16b257e230$var$debug = (parcelRequire("f3A5e")).debuglog('stream', function(fn) {
    $4f7d2c16b257e230$var$debug = fn;
});

var $daH3z = parcelRequire("daH3z");

var $6baNx = parcelRequire("6baNx");

var $fp08x = parcelRequire("fp08x");
var $4f7d2c16b257e230$var$getHighWaterMark = $fp08x.getHighWaterMark, $4f7d2c16b257e230$var$getDefaultHighWaterMark = $fp08x.getDefaultHighWaterMark;

var $i1Urf = parcelRequire("i1Urf");
var $4f7d2c16b257e230$var$aggregateTwoErrors = $i1Urf.aggregateTwoErrors, $4f7d2c16b257e230$var$_require_codes = $i1Urf.codes, $4f7d2c16b257e230$var$ERR_INVALID_ARG_TYPE = $4f7d2c16b257e230$var$_require_codes.ERR_INVALID_ARG_TYPE, $4f7d2c16b257e230$var$ERR_METHOD_NOT_IMPLEMENTED = $4f7d2c16b257e230$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $4f7d2c16b257e230$var$ERR_OUT_OF_RANGE = $4f7d2c16b257e230$var$_require_codes.ERR_OUT_OF_RANGE, $4f7d2c16b257e230$var$ERR_STREAM_PUSH_AFTER_EOF = $4f7d2c16b257e230$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $4f7d2c16b257e230$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $4f7d2c16b257e230$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $4f7d2c16b257e230$var$AbortError = $i1Urf.AbortError;

var $angGq = parcelRequire("angGq");
var $4f7d2c16b257e230$require$validateObject = $angGq.validateObject;
var $4f7d2c16b257e230$var$kPaused = $4f7d2c16b257e230$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $4f7d2c16b257e230$require$StringDecoder = $3Jf7C.StringDecoder;

var $deZ4B = parcelRequire("deZ4B");
$4f7d2c16b257e230$var$ObjectSetPrototypeOf($4f7d2c16b257e230$var$Readable.prototype, $4f7d2c16b257e230$var$Stream.prototype);
$4f7d2c16b257e230$var$ObjectSetPrototypeOf($4f7d2c16b257e230$var$Readable, $4f7d2c16b257e230$var$Stream);
var $4f7d2c16b257e230$var$nop = function() {};
var $4f7d2c16b257e230$var$errorOrDestroy = $6baNx.errorOrDestroy;
var $4f7d2c16b257e230$var$kObjectMode = 1;
var $4f7d2c16b257e230$var$kEnded = 2;
var $4f7d2c16b257e230$var$kEndEmitted = 4;
var $4f7d2c16b257e230$var$kReading = 8;
var $4f7d2c16b257e230$var$kConstructed = 16;
var $4f7d2c16b257e230$var$kSync = 32;
var $4f7d2c16b257e230$var$kNeedReadable = 64;
var $4f7d2c16b257e230$var$kEmittedReadable = 128;
var $4f7d2c16b257e230$var$kReadableListening = 256;
var $4f7d2c16b257e230$var$kResumeScheduled = 512;
var $4f7d2c16b257e230$var$kErrorEmitted = 1024;
var $4f7d2c16b257e230$var$kEmitClose = 2048;
var $4f7d2c16b257e230$var$kAutoDestroy = 4096;
var $4f7d2c16b257e230$var$kDestroyed = 8192;
var $4f7d2c16b257e230$var$kClosed = 16384;
var $4f7d2c16b257e230$var$kCloseEmitted = 32768;
var $4f7d2c16b257e230$var$kMultiAwaitDrain = 65536;
var $4f7d2c16b257e230$var$kReadingMore = 131072;
var $4f7d2c16b257e230$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $4f7d2c16b257e230$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$4f7d2c16b257e230$var$ObjectDefineProperties($4f7d2c16b257e230$var$ReadableState.prototype, {
    objectMode: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kObjectMode),
    ended: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kEnded),
    endEmitted: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kEndEmitted),
    reading: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kNeedReadable),
    emittedReadable: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kEmittedReadable),
    readableListening: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kReadableListening),
    resumeScheduled: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kErrorEmitted),
    emitClose: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kEmitClose),
    autoDestroy: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kCloseEmitted),
    multiAwaitDrain: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kReadingMore),
    dataEmitted: $4f7d2c16b257e230$var$makeBitMapDescriptor($4f7d2c16b257e230$var$kDataEmitted)
});

function $4f7d2c16b257e230$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("iKBv6"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $4f7d2c16b257e230$var$kEmitClose | $4f7d2c16b257e230$var$kAutoDestroy | $4f7d2c16b257e230$var$kConstructed | $4f7d2c16b257e230$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $4f7d2c16b257e230$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $4f7d2c16b257e230$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $4f7d2c16b257e230$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $4f7d2c16b257e230$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $daH3z();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$4f7d2c16b257e230$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$4f7d2c16b257e230$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$4f7d2c16b257e230$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $4f7d2c16b257e230$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $4f7d2c16b257e230$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $4f7d2c16b257e230$var$Readable)) return new $4f7d2c16b257e230$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("iKBv6"));
    this._readableState = new $4f7d2c16b257e230$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $4f7d2c16b257e230$require$addAbortSignal(options.signal, this);
    }
    $4f7d2c16b257e230$var$Stream.call(this, options);
    $6baNx.construct(this, function() {
        if (_this._readableState.needReadable) $4f7d2c16b257e230$var$maybeReadMore(_this, _this._readableState);
    });
}
$4f7d2c16b257e230$var$Readable.prototype.destroy = $6baNx.destroy;
$4f7d2c16b257e230$var$Readable.prototype._undestroy = $6baNx.undestroy;
$4f7d2c16b257e230$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4f7d2c16b257e230$var$Readable.prototype[$4f7d2c16b257e230$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$4f7d2c16b257e230$var$Readable.prototype[$4f7d2c16b257e230$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $4f7d2c16b257e230$var$AbortError();
        this.destroy(error);
    }
    return new $4f7d2c16b257e230$var$Promise(function(resolve, reject) {
        return $lV7H7(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$4f7d2c16b257e230$var$Readable.prototype.push = function(chunk, encoding) {
    return $4f7d2c16b257e230$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$4f7d2c16b257e230$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $4f7d2c16b257e230$var$readableAddChunk(this, chunk, encoding, true);
};
function $4f7d2c16b257e230$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $4f7d2c16b257e230$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $4f7d2c16b257e230$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $4f7d2c16b257e230$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $4f7d2c16b257e230$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $4f7d2c16b257e230$require$Buffer) encoding = '';
        else if ($4f7d2c16b257e230$var$Stream._isUint8Array(chunk)) {
            chunk = $4f7d2c16b257e230$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $4f7d2c16b257e230$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $4f7d2c16b257e230$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$4f7d2c16b257e230$var$kReading;
        $4f7d2c16b257e230$var$onEofChunk(stream, state);
    } else if ((state.state & $4f7d2c16b257e230$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $4f7d2c16b257e230$var$kEndEmitted) !== 0) $4f7d2c16b257e230$var$errorOrDestroy(stream, new $4f7d2c16b257e230$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $4f7d2c16b257e230$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $4f7d2c16b257e230$var$errorOrDestroy(stream, new $4f7d2c16b257e230$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$4f7d2c16b257e230$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $4f7d2c16b257e230$var$addChunk(stream, state, chunk, false);
                else $4f7d2c16b257e230$var$maybeReadMore(stream, state);
            } else $4f7d2c16b257e230$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$4f7d2c16b257e230$var$kReading;
        $4f7d2c16b257e230$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $4f7d2c16b257e230$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $4f7d2c16b257e230$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $4f7d2c16b257e230$var$kNeedReadable) !== 0) $4f7d2c16b257e230$var$emitReadable(stream);
    }
    $4f7d2c16b257e230$var$maybeReadMore(stream, state);
}
$4f7d2c16b257e230$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$4f7d2c16b257e230$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$4f7d2c16b257e230$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $4f7d2c16b257e230$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$4f7d2c16b257e230$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $4f7d2c16b257e230$var$MAX_HWM = 0x40000000;
function $4f7d2c16b257e230$var$computeNewHighWaterMark(n) {
    if (n > $4f7d2c16b257e230$var$MAX_HWM) throw new $4f7d2c16b257e230$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4f7d2c16b257e230$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $4f7d2c16b257e230$var$kObjectMode) !== 0) return 1;
    if ($4f7d2c16b257e230$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$4f7d2c16b257e230$var$Readable.prototype.read = function(n) {
    $4f7d2c16b257e230$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$4f7d2c16b257e230$var$NumberIsInteger(n)) n = $4f7d2c16b257e230$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $4f7d2c16b257e230$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$4f7d2c16b257e230$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $4f7d2c16b257e230$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $4f7d2c16b257e230$var$endReadable(this);
        else $4f7d2c16b257e230$var$emitReadable(this);
        return null;
    }
    n = $4f7d2c16b257e230$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $4f7d2c16b257e230$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $4f7d2c16b257e230$var$kNeedReadable) !== 0;
    $4f7d2c16b257e230$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $4f7d2c16b257e230$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $4f7d2c16b257e230$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $4f7d2c16b257e230$var$debug('do read');
        state.state |= $4f7d2c16b257e230$var$kReading | $4f7d2c16b257e230$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $4f7d2c16b257e230$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $4f7d2c16b257e230$var$errorOrDestroy(this, err);
        }
        state.state &= ~$4f7d2c16b257e230$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $4f7d2c16b257e230$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $4f7d2c16b257e230$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $4f7d2c16b257e230$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $4f7d2c16b257e230$var$onEofChunk(stream, state) {
    $4f7d2c16b257e230$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $4f7d2c16b257e230$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $4f7d2c16b257e230$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $4f7d2c16b257e230$var$emitReadable(stream) {
    var state = stream._readableState;
    $4f7d2c16b257e230$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $4f7d2c16b257e230$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($4f7d2c16b257e230$var$emitReadable_, stream);
    }
}
function $4f7d2c16b257e230$var$emitReadable_(stream) {
    var state = stream._readableState;
    $4f7d2c16b257e230$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $4f7d2c16b257e230$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $4f7d2c16b257e230$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($4f7d2c16b257e230$var$maybeReadMore_, stream, state);
    }
}
function $4f7d2c16b257e230$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $4f7d2c16b257e230$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$4f7d2c16b257e230$var$Readable.prototype._read = function(n) {
    throw new $4f7d2c16b257e230$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$4f7d2c16b257e230$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $4f7d2c16b257e230$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $4f7d2c16b257e230$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $4f7d2c16b257e230$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $4f7d2c16b257e230$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $4f7d2c16b257e230$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $4f7d2c16b257e230$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $4f7d2c16b257e230$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $4f7d2c16b257e230$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $4f7d2c16b257e230$var$debug('ondata');
        var ret = dest.write(chunk);
        $4f7d2c16b257e230$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $4f7d2c16b257e230$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $4f7d2c16b257e230$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $4f7d2c16b257e230$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $4f7d2c16b257e230$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $4f7d2c16b257e230$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $4f7d2c16b257e230$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $4f7d2c16b257e230$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $4f7d2c16b257e230$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $4f7d2c16b257e230$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$4f7d2c16b257e230$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $4f7d2c16b257e230$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$4f7d2c16b257e230$var$Readable.prototype.on = function(ev, fn) {
    var res = $4f7d2c16b257e230$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $4f7d2c16b257e230$var$debug('on readable', state.length, state.reading);
            if (state.length) $4f7d2c16b257e230$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($4f7d2c16b257e230$var$nReadingNextTick, this);
        }
    }
    return res;
};
$4f7d2c16b257e230$var$Readable.prototype.addListener = $4f7d2c16b257e230$var$Readable.prototype.on;
$4f7d2c16b257e230$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $4f7d2c16b257e230$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($4f7d2c16b257e230$var$updateReadableListening, this);
    return res;
};
$4f7d2c16b257e230$var$Readable.prototype.off = $4f7d2c16b257e230$var$Readable.prototype.removeListener;
$4f7d2c16b257e230$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $4f7d2c16b257e230$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($4f7d2c16b257e230$var$updateReadableListening, this);
    return res;
};
function $4f7d2c16b257e230$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$4f7d2c16b257e230$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $4f7d2c16b257e230$var$nReadingNextTick(self) {
    $4f7d2c16b257e230$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$4f7d2c16b257e230$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $4f7d2c16b257e230$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $4f7d2c16b257e230$var$resume(this, state);
    }
    state[$4f7d2c16b257e230$var$kPaused] = false;
    return this;
};
function $4f7d2c16b257e230$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($4f7d2c16b257e230$var$resume_, stream, state);
    }
}
function $4f7d2c16b257e230$var$resume_(stream, state) {
    $4f7d2c16b257e230$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $4f7d2c16b257e230$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$4f7d2c16b257e230$var$Readable.prototype.pause = function() {
    $4f7d2c16b257e230$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $4f7d2c16b257e230$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$4f7d2c16b257e230$var$kPaused] = true;
    return this;
};
function $4f7d2c16b257e230$var$flow(stream) {
    var state = stream._readableState;
    $4f7d2c16b257e230$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$4f7d2c16b257e230$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $4f7d2c16b257e230$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $4f7d2c16b257e230$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$4f7d2c16b257e230$var$Readable.prototype[$4f7d2c16b257e230$var$SymbolAsyncIterator] = function() {
    return $4f7d2c16b257e230$var$streamToAsyncIterator(this);
};
$4f7d2c16b257e230$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $4f7d2c16b257e230$require$validateObject(options, 'options');
    return $4f7d2c16b257e230$var$streamToAsyncIterator(this, options);
};
function $4f7d2c16b257e230$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $4f7d2c16b257e230$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $4f7d2c16b257e230$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $4f7d2c16b257e230$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $4f7d2c16b257e230$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $4f7d2c16b257e230$var$nop;
                    stream.on('readable', next);
                    cleanup = $lV7H7(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $4f7d2c16b257e230$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $4f7d2c16b257e230$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $4f7d2c16b257e230$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $4f7d2c16b257e230$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $6baNx.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$4f7d2c16b257e230$var$ObjectDefineProperties($4f7d2c16b257e230$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$4f7d2c16b257e230$var$ObjectDefineProperties($4f7d2c16b257e230$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$4f7d2c16b257e230$var$kPaused] !== false;
        },
        set: function(value) {
            this[$4f7d2c16b257e230$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$4f7d2c16b257e230$var$Readable._fromList = $4f7d2c16b257e230$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4f7d2c16b257e230$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $4f7d2c16b257e230$var$endReadable(stream) {
    var state = stream._readableState;
    $4f7d2c16b257e230$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($4f7d2c16b257e230$var$endReadableNT, state, stream);
    }
}
function $4f7d2c16b257e230$var$endReadableNT(state, stream) {
    $4f7d2c16b257e230$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($4f7d2c16b257e230$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $4f7d2c16b257e230$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$4f7d2c16b257e230$var$Readable.from = function(iterable, opts) {
    return $deZ4B($4f7d2c16b257e230$var$Readable, iterable, opts);
};
var $4f7d2c16b257e230$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4f7d2c16b257e230$var$lazyWebStreams() {
    if ($4f7d2c16b257e230$var$webStreamsAdapters === undefined) $4f7d2c16b257e230$var$webStreamsAdapters = {};
    return $4f7d2c16b257e230$var$webStreamsAdapters;
}
$4f7d2c16b257e230$var$Readable.fromWeb = function(readableStream, options) {
    return $4f7d2c16b257e230$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$4f7d2c16b257e230$var$Readable.toWeb = function(streamReadable, options) {
    return $4f7d2c16b257e230$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$4f7d2c16b257e230$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $4f7d2c16b257e230$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $6baNx.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("cdt5A", function(module, exports) {
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $8e4d43730889c639$var$ArrayIsArray = $8PVhU.ArrayIsArray, $8e4d43730889c639$var$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $8e4d43730889c639$var$EE = $bBoAO.EventEmitter;
function $8e4d43730889c639$var$Stream(opts) {
    $8e4d43730889c639$var$EE.call(this, opts);
}
$8e4d43730889c639$var$ObjectSetPrototypeOf($8e4d43730889c639$var$Stream.prototype, $8e4d43730889c639$var$EE.prototype);
$8e4d43730889c639$var$ObjectSetPrototypeOf($8e4d43730889c639$var$Stream, $8e4d43730889c639$var$EE);
$8e4d43730889c639$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($8e4d43730889c639$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $8e4d43730889c639$var$prependListener(source, 'error', onerror);
    $8e4d43730889c639$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $8e4d43730889c639$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($8e4d43730889c639$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $8e4d43730889c639$var$Stream,
    prependListener: $8e4d43730889c639$var$prependListener
};

});

parcelRegister("8YI05", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $68960ee6f5a3b5e7$export$e2db56ee53255a0; }, function (v) { return $68960ee6f5a3b5e7$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $68960ee6f5a3b5e7$export$11956e9313f43de0; }, function (v) { return $68960ee6f5a3b5e7$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $68960ee6f5a3b5e7$export$e2db56ee53255a0;
var $68960ee6f5a3b5e7$export$11956e9313f43de0;
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $68960ee6f5a3b5e7$require$SymbolDispose = $8PVhU.SymbolDispose;

var $i1Urf = parcelRequire("i1Urf");
var $68960ee6f5a3b5e7$var$AbortError = $i1Urf.AbortError, $68960ee6f5a3b5e7$var$codes = $i1Urf.codes;

var $iz3nv = parcelRequire("iz3nv");
var $68960ee6f5a3b5e7$var$isNodeStream = $iz3nv.isNodeStream, $68960ee6f5a3b5e7$var$isWebStream = $iz3nv.isWebStream, $68960ee6f5a3b5e7$var$kControllerErrorFunction = $iz3nv.kControllerErrorFunction;

var $lV7H7 = parcelRequire("lV7H7");
var $68960ee6f5a3b5e7$var$ERR_INVALID_ARG_TYPE = $68960ee6f5a3b5e7$var$codes.ERR_INVALID_ARG_TYPE;
var $68960ee6f5a3b5e7$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $68960ee6f5a3b5e7$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $68960ee6f5a3b5e7$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$68960ee6f5a3b5e7$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $68960ee6f5a3b5e7$var$validateAbortSignal(signal, 'signal');
    if (!$68960ee6f5a3b5e7$var$isNodeStream(stream) && !$68960ee6f5a3b5e7$var$isWebStream(stream)) throw new $68960ee6f5a3b5e7$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $68960ee6f5a3b5e7$export$11956e9313f43de0(signal, stream);
};

$68960ee6f5a3b5e7$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $68960ee6f5a3b5e7$var$isNodeStream(stream) ? function() {
        stream.destroy(new $68960ee6f5a3b5e7$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$68960ee6f5a3b5e7$var$kControllerErrorFunction](new $68960ee6f5a3b5e7$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $68960ee6f5a3b5e7$var$addAbortListener = $68960ee6f5a3b5e7$var$addAbortListener || (parcelRequire("f3A5e")).addAbortListener;
        var disposable = $68960ee6f5a3b5e7$var$addAbortListener(signal, onAbort);
        $lV7H7(stream, disposable[$68960ee6f5a3b5e7$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("daH3z", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $996d9baa275cb5a9$var$StringPrototypeSlice = $8PVhU.StringPrototypeSlice, $996d9baa275cb5a9$var$SymbolIterator = $8PVhU.SymbolIterator, $996d9baa275cb5a9$var$TypedArrayPrototypeSet = $8PVhU.TypedArrayPrototypeSet, $996d9baa275cb5a9$var$Uint8Array = $8PVhU.Uint8Array;

var $ikzXy = parcelRequire("ikzXy");
var $996d9baa275cb5a9$require$Buffer = $ikzXy.Buffer;

var $f3A5e = parcelRequire("f3A5e");
var $996d9baa275cb5a9$require$inspect = $f3A5e.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $996d9baa275cb5a9$require$Buffer.alloc(0);
                var ret = $996d9baa275cb5a9$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $996d9baa275cb5a9$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $996d9baa275cb5a9$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $996d9baa275cb5a9$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $996d9baa275cb5a9$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $996d9baa275cb5a9$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $996d9baa275cb5a9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $996d9baa275cb5a9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $996d9baa275cb5a9$var$TypedArrayPrototypeSet(ret, new $996d9baa275cb5a9$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $996d9baa275cb5a9$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fp08x", function(module, exports) {
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $b3694bf97491f6b9$var$MathFloor = $8PVhU.MathFloor, $b3694bf97491f6b9$var$NumberIsInteger = $8PVhU.NumberIsInteger;

var $angGq = parcelRequire("angGq");
var $b3694bf97491f6b9$require$validateInteger = $angGq.validateInteger;

var $b3694bf97491f6b9$var$ERR_INVALID_ARG_VALUE = (parcelRequire("i1Urf")).codes.ERR_INVALID_ARG_VALUE;
var $b3694bf97491f6b9$var$defaultHighWaterMarkBytes = 16384;
var $b3694bf97491f6b9$var$defaultHighWaterMarkObjectMode = 16;
function $b3694bf97491f6b9$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $b3694bf97491f6b9$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $b3694bf97491f6b9$var$defaultHighWaterMarkObjectMode : $b3694bf97491f6b9$var$defaultHighWaterMarkBytes;
}
function $b3694bf97491f6b9$var$setDefaultHighWaterMark(objectMode, value) {
    $b3694bf97491f6b9$require$validateInteger(value, 'value', 0);
    if (objectMode) $b3694bf97491f6b9$var$defaultHighWaterMarkObjectMode = value;
    else $b3694bf97491f6b9$var$defaultHighWaterMarkBytes = value;
}
function $b3694bf97491f6b9$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $b3694bf97491f6b9$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$b3694bf97491f6b9$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $b3694bf97491f6b9$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $b3694bf97491f6b9$var$MathFloor(hwm);
    }
    // Default value
    return $b3694bf97491f6b9$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $b3694bf97491f6b9$var$getHighWaterMark,
    getDefaultHighWaterMark: $b3694bf97491f6b9$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $b3694bf97491f6b9$var$setDefaultHighWaterMark
};

});

parcelRegister("deZ4B", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8PVhU = parcelRequire("8PVhU");
/* replacement end */ var $9a3bf50ece43d42c$var$PromisePrototypeThen = $8PVhU.PromisePrototypeThen, $9a3bf50ece43d42c$var$SymbolAsyncIterator = $8PVhU.SymbolAsyncIterator, $9a3bf50ece43d42c$var$SymbolIterator = $8PVhU.SymbolIterator;

var $ikzXy = parcelRequire("ikzXy");
var $9a3bf50ece43d42c$require$Buffer = $ikzXy.Buffer;

var $i1Urf = parcelRequire("i1Urf");
var $9a3bf50ece43d42c$require$_require_codes = $i1Urf.codes;
var $9a3bf50ece43d42c$var$ERR_INVALID_ARG_TYPE = $9a3bf50ece43d42c$require$_require_codes.ERR_INVALID_ARG_TYPE, $9a3bf50ece43d42c$var$ERR_STREAM_NULL_VALUES = $9a3bf50ece43d42c$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $9a3bf50ece43d42c$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $9a3bf50ece43d42c$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$9a3bf50ece43d42c$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$9a3bf50ece43d42c$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$9a3bf50ece43d42c$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$9a3bf50ece43d42c$var$SymbolIterator]();
    } else throw new $9a3bf50ece43d42c$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $9a3bf50ece43d42c$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $9a3bf50ece43d42c$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $9a3bf50ece43d42c$var$from;

});


parcelRegister("fuKAK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8PVhU = parcelRequire("8PVhU");
/* replacement end */ var $b47dcc80ef53c9da$var$ArrayPrototypeSlice = $8PVhU.ArrayPrototypeSlice, $b47dcc80ef53c9da$var$Error = $8PVhU.Error, $b47dcc80ef53c9da$var$FunctionPrototypeSymbolHasInstance = $8PVhU.FunctionPrototypeSymbolHasInstance, $b47dcc80ef53c9da$var$ObjectDefineProperty = $8PVhU.ObjectDefineProperty, $b47dcc80ef53c9da$var$ObjectDefineProperties = $8PVhU.ObjectDefineProperties, $b47dcc80ef53c9da$var$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf, $b47dcc80ef53c9da$var$StringPrototypeToLowerCase = $8PVhU.StringPrototypeToLowerCase, $b47dcc80ef53c9da$var$Symbol = $8PVhU.Symbol, $b47dcc80ef53c9da$var$SymbolHasInstance = $8PVhU.SymbolHasInstance;
module.exports = $b47dcc80ef53c9da$var$Writable;
$b47dcc80ef53c9da$var$Writable.WritableState = $b47dcc80ef53c9da$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $b47dcc80ef53c9da$var$EE = $bBoAO.EventEmitter;

var $cdt5A = parcelRequire("cdt5A");
var $b47dcc80ef53c9da$require$Stream = $cdt5A.Stream;

var $ikzXy = parcelRequire("ikzXy");
var $b47dcc80ef53c9da$require$Buffer = $ikzXy.Buffer;

var $6baNx = parcelRequire("6baNx");

var $8YI05 = parcelRequire("8YI05");
var $b47dcc80ef53c9da$require$addAbortSignal = $8YI05.addAbortSignal;

var $fp08x = parcelRequire("fp08x");
var $b47dcc80ef53c9da$var$getHighWaterMark = $fp08x.getHighWaterMark, $b47dcc80ef53c9da$var$getDefaultHighWaterMark = $fp08x.getDefaultHighWaterMark;

var $i1Urf = parcelRequire("i1Urf");
var $b47dcc80ef53c9da$require$_require_codes = $i1Urf.codes;
var $b47dcc80ef53c9da$var$ERR_INVALID_ARG_TYPE = $b47dcc80ef53c9da$require$_require_codes.ERR_INVALID_ARG_TYPE, $b47dcc80ef53c9da$var$ERR_METHOD_NOT_IMPLEMENTED = $b47dcc80ef53c9da$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $b47dcc80ef53c9da$var$ERR_MULTIPLE_CALLBACK = $b47dcc80ef53c9da$require$_require_codes.ERR_MULTIPLE_CALLBACK, $b47dcc80ef53c9da$var$ERR_STREAM_CANNOT_PIPE = $b47dcc80ef53c9da$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED = $b47dcc80ef53c9da$require$_require_codes.ERR_STREAM_DESTROYED, $b47dcc80ef53c9da$var$ERR_STREAM_ALREADY_FINISHED = $b47dcc80ef53c9da$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $b47dcc80ef53c9da$var$ERR_STREAM_NULL_VALUES = $b47dcc80ef53c9da$require$_require_codes.ERR_STREAM_NULL_VALUES, $b47dcc80ef53c9da$var$ERR_STREAM_WRITE_AFTER_END = $b47dcc80ef53c9da$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $b47dcc80ef53c9da$var$ERR_UNKNOWN_ENCODING = $b47dcc80ef53c9da$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $b47dcc80ef53c9da$var$errorOrDestroy = $6baNx.errorOrDestroy;
$b47dcc80ef53c9da$var$ObjectSetPrototypeOf($b47dcc80ef53c9da$var$Writable.prototype, $b47dcc80ef53c9da$require$Stream.prototype);
$b47dcc80ef53c9da$var$ObjectSetPrototypeOf($b47dcc80ef53c9da$var$Writable, $b47dcc80ef53c9da$require$Stream);
function $b47dcc80ef53c9da$var$nop() {}
var $b47dcc80ef53c9da$var$kOnFinished = $b47dcc80ef53c9da$var$Symbol('kOnFinished');

function $b47dcc80ef53c9da$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("iKBv6"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $b47dcc80ef53c9da$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $b47dcc80ef53c9da$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $b47dcc80ef53c9da$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $b47dcc80ef53c9da$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$b47dcc80ef53c9da$var$kOnFinished] = [];
}
function $b47dcc80ef53c9da$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$b47dcc80ef53c9da$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $b47dcc80ef53c9da$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$b47dcc80ef53c9da$var$ObjectDefineProperty($b47dcc80ef53c9da$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $b47dcc80ef53c9da$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("iKBv6"));
    if (!isDuplex && !$b47dcc80ef53c9da$var$FunctionPrototypeSymbolHasInstance($b47dcc80ef53c9da$var$Writable, this)) return new $b47dcc80ef53c9da$var$Writable(options);
    this._writableState = new $b47dcc80ef53c9da$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $b47dcc80ef53c9da$require$addAbortSignal(options.signal, this);
    }
    $b47dcc80ef53c9da$require$Stream.call(this, options);
    $6baNx.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $b47dcc80ef53c9da$var$clearBuffer(_this, state);
        $b47dcc80ef53c9da$var$finishMaybe(_this, state);
    });
}
$b47dcc80ef53c9da$var$ObjectDefineProperty($b47dcc80ef53c9da$var$Writable, $b47dcc80ef53c9da$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($b47dcc80ef53c9da$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $b47dcc80ef53c9da$var$Writable) return false;
        return object && object._writableState instanceof $b47dcc80ef53c9da$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$b47dcc80ef53c9da$var$Writable.prototype.pipe = function() {
    $b47dcc80ef53c9da$var$errorOrDestroy(this, new $b47dcc80ef53c9da$var$ERR_STREAM_CANNOT_PIPE());
};
function $b47dcc80ef53c9da$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$b47dcc80ef53c9da$require$Buffer.isEncoding(encoding)) throw new $b47dcc80ef53c9da$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $b47dcc80ef53c9da$var$nop;
    }
    if (chunk === null) throw new $b47dcc80ef53c9da$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $b47dcc80ef53c9da$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $b47dcc80ef53c9da$require$Buffer) encoding = 'buffer';
        else if ($b47dcc80ef53c9da$require$Stream._isUint8Array(chunk)) {
            chunk = $b47dcc80ef53c9da$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $b47dcc80ef53c9da$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $b47dcc80ef53c9da$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $b47dcc80ef53c9da$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $b47dcc80ef53c9da$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$b47dcc80ef53c9da$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $b47dcc80ef53c9da$var$_write(this, chunk, encoding, cb) === true;
};
$b47dcc80ef53c9da$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b47dcc80ef53c9da$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $b47dcc80ef53c9da$var$clearBuffer(this, state);
    }
};
$b47dcc80ef53c9da$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $b47dcc80ef53c9da$var$StringPrototypeToLowerCase(encoding);
    if (!$b47dcc80ef53c9da$require$Buffer.isEncoding(encoding)) throw new $b47dcc80ef53c9da$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b47dcc80ef53c9da$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $b47dcc80ef53c9da$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $b47dcc80ef53c9da$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b47dcc80ef53c9da$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $b47dcc80ef53c9da$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $b47dcc80ef53c9da$var$errorOrDestroy(stream, er);
}
function $b47dcc80ef53c9da$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $b47dcc80ef53c9da$var$errorOrDestroy(stream, new $b47dcc80ef53c9da$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($b47dcc80ef53c9da$var$onwriteError, stream, state, er, cb);
        else $b47dcc80ef53c9da$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $b47dcc80ef53c9da$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($b47dcc80ef53c9da$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $b47dcc80ef53c9da$var$afterWrite(stream, state, 1, cb);
    }
}
function $b47dcc80ef53c9da$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $b47dcc80ef53c9da$var$afterWrite(stream, state, count, cb);
}
function $b47dcc80ef53c9da$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $b47dcc80ef53c9da$var$errorBuffer(state);
    $b47dcc80ef53c9da$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $b47dcc80ef53c9da$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$b47dcc80ef53c9da$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED('end'));
    }
    $b47dcc80ef53c9da$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $b47dcc80ef53c9da$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $b47dcc80ef53c9da$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $b47dcc80ef53c9da$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $b47dcc80ef53c9da$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $b47dcc80ef53c9da$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $b47dcc80ef53c9da$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $b47dcc80ef53c9da$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$b47dcc80ef53c9da$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $b47dcc80ef53c9da$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$b47dcc80ef53c9da$var$Writable.prototype._writev = null;
$b47dcc80ef53c9da$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $b47dcc80ef53c9da$var$_write(this, chunk, encoding);
        if (ret instanceof $b47dcc80ef53c9da$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $b47dcc80ef53c9da$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $b47dcc80ef53c9da$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $b47dcc80ef53c9da$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$b47dcc80ef53c9da$var$kOnFinished].push(cb);
    }
    return this;
};
function $b47dcc80ef53c9da$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $b47dcc80ef53c9da$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $b47dcc80ef53c9da$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $b47dcc80ef53c9da$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$b47dcc80ef53c9da$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $b47dcc80ef53c9da$var$errorOrDestroy(stream, err, state.sync);
        } else if ($b47dcc80ef53c9da$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($b47dcc80ef53c9da$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $b47dcc80ef53c9da$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $b47dcc80ef53c9da$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b47dcc80ef53c9da$var$finishMaybe(stream, state, sync) {
    if ($b47dcc80ef53c9da$var$needFinish(state)) {
        $b47dcc80ef53c9da$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($b47dcc80ef53c9da$var$needFinish(state)) $b47dcc80ef53c9da$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($b47dcc80ef53c9da$var$needFinish(state)) {
                state.pendingcb++;
                $b47dcc80ef53c9da$var$finish(stream, state);
            }
        }
    }
}
function $b47dcc80ef53c9da$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$b47dcc80ef53c9da$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$b47dcc80ef53c9da$var$ObjectDefineProperties($b47dcc80ef53c9da$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $b47dcc80ef53c9da$var$destroy = $6baNx.destroy;
$b47dcc80ef53c9da$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$b47dcc80ef53c9da$var$kOnFinished].length)) $2Qkr5.nextTick($b47dcc80ef53c9da$var$errorBuffer, state);
    $b47dcc80ef53c9da$var$destroy.call(this, err, cb);
    return this;
};
$b47dcc80ef53c9da$var$Writable.prototype._undestroy = $6baNx.undestroy;
$b47dcc80ef53c9da$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$b47dcc80ef53c9da$var$Writable.prototype[$b47dcc80ef53c9da$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $b47dcc80ef53c9da$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b47dcc80ef53c9da$var$lazyWebStreams() {
    if ($b47dcc80ef53c9da$var$webStreamsAdapters === undefined) $b47dcc80ef53c9da$var$webStreamsAdapters = {};
    return $b47dcc80ef53c9da$var$webStreamsAdapters;
}
$b47dcc80ef53c9da$var$Writable.fromWeb = function(writableStream, options) {
    return $b47dcc80ef53c9da$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$b47dcc80ef53c9da$var$Writable.toWeb = function(streamWritable) {
    return $b47dcc80ef53c9da$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("2zM5v", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $ikzXy = parcelRequire("ikzXy");

var $iz3nv = parcelRequire("iz3nv");
var $1e0426de8e115239$var$isReadable = $iz3nv.isReadable, $1e0426de8e115239$var$isWritable = $iz3nv.isWritable, $1e0426de8e115239$var$isIterable = $iz3nv.isIterable, $1e0426de8e115239$var$isNodeStream = $iz3nv.isNodeStream, $1e0426de8e115239$var$isReadableNodeStream = $iz3nv.isReadableNodeStream, $1e0426de8e115239$var$isWritableNodeStream = $iz3nv.isWritableNodeStream, $1e0426de8e115239$var$isDuplexNodeStream = $iz3nv.isDuplexNodeStream, $1e0426de8e115239$var$isReadableStream = $iz3nv.isReadableStream, $1e0426de8e115239$var$isWritableStream = $iz3nv.isWritableStream;

var $lV7H7 = parcelRequire("lV7H7");

var $i1Urf = parcelRequire("i1Urf");
var $1e0426de8e115239$var$AbortError = $i1Urf.AbortError, $1e0426de8e115239$var$_require_codes = $i1Urf.codes, $1e0426de8e115239$var$ERR_INVALID_ARG_TYPE = $1e0426de8e115239$var$_require_codes.ERR_INVALID_ARG_TYPE, $1e0426de8e115239$var$ERR_INVALID_RETURN_VALUE = $1e0426de8e115239$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $6baNx = parcelRequire("6baNx");
var $1e0426de8e115239$require$destroyer = $6baNx.destroyer;

var $iKBv6 = parcelRequire("iKBv6");

var $6P7iX = parcelRequire("6P7iX");

var $fuKAK = parcelRequire("fuKAK");

var $f3A5e = parcelRequire("f3A5e");
var $1e0426de8e115239$require$createDeferredPromise = $f3A5e.createDeferredPromise;

var $deZ4B = parcelRequire("deZ4B");
var $1e0426de8e115239$var$Blob = globalThis.Blob || $ikzXy.Blob;
var $1e0426de8e115239$var$isBlob = typeof $1e0426de8e115239$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $1e0426de8e115239$var$Blob;
} : function isBlob(b) {
    return false;
};

var $1e0426de8e115239$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $8PVhU = parcelRequire("8PVhU");
var $1e0426de8e115239$require$FunctionPrototypeCall = $8PVhU.FunctionPrototypeCall;
// This is needed for pre node 17.
var $1e0426de8e115239$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($iKBv6);
module.exports = function duplexify(body, name) {
    if ($1e0426de8e115239$var$isDuplexNodeStream(body)) return body;
    if ($1e0426de8e115239$var$isReadableNodeStream(body)) return $1e0426de8e115239$var$_duplexify({
        readable: body
    });
    if ($1e0426de8e115239$var$isWritableNodeStream(body)) return $1e0426de8e115239$var$_duplexify({
        writable: body
    });
    if ($1e0426de8e115239$var$isNodeStream(body)) return $1e0426de8e115239$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($1e0426de8e115239$var$isReadableStream(body)) return $1e0426de8e115239$var$_duplexify({
        readable: $6P7iX.fromWeb(body)
    });
    if ($1e0426de8e115239$var$isWritableStream(body)) return $1e0426de8e115239$var$_duplexify({
        writable: $fuKAK.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $1e0426de8e115239$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($1e0426de8e115239$var$isIterable(value)) return $deZ4B($1e0426de8e115239$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $1e0426de8e115239$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $1e0426de8e115239$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $1e0426de8e115239$require$destroyer(d, err);
            });
            return d = new $1e0426de8e115239$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $1e0426de8e115239$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($1e0426de8e115239$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($1e0426de8e115239$var$isIterable(body)) return $deZ4B($1e0426de8e115239$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($1e0426de8e115239$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $1e0426de8e115239$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $1e0426de8e115239$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $1e0426de8e115239$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $1e0426de8e115239$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $1e0426de8e115239$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $1e0426de8e115239$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $1e0426de8e115239$require$destroyer(d1, err);
        });
        return d1 = new $1e0426de8e115239$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $1e0426de8e115239$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $1e0426de8e115239$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $1e0426de8e115239$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $1e0426de8e115239$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $1e0426de8e115239$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $1e0426de8e115239$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $1e0426de8e115239$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $6P7iX.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$1e0426de8e115239$var$isReadable(r);
    var writable = !!$1e0426de8e115239$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1e0426de8e115239$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $lV7H7(w, function(err) {
            writable = false;
            if (err) $1e0426de8e115239$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $lV7H7(r, function(err) {
            readable = false;
            if (err) $1e0426de8e115239$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $1e0426de8e115239$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $1e0426de8e115239$require$destroyer(w, err);
            $1e0426de8e115239$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("avEMp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $7a6c6ea18bc2aa13$require$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf;
module.exports = $7a6c6ea18bc2aa13$var$PassThrough;

var $02awK = parcelRequire("02awK");
$7a6c6ea18bc2aa13$require$ObjectSetPrototypeOf($7a6c6ea18bc2aa13$var$PassThrough.prototype, $02awK.prototype);
$7a6c6ea18bc2aa13$require$ObjectSetPrototypeOf($7a6c6ea18bc2aa13$var$PassThrough, $02awK);
function $7a6c6ea18bc2aa13$var$PassThrough(options) {
    if (!(this instanceof $7a6c6ea18bc2aa13$var$PassThrough)) return new $7a6c6ea18bc2aa13$var$PassThrough(options);
    $02awK.call(this, options);
}
$7a6c6ea18bc2aa13$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("02awK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $00685a7e9f29b725$var$ObjectSetPrototypeOf = $8PVhU.ObjectSetPrototypeOf, $00685a7e9f29b725$var$Symbol = $8PVhU.Symbol;
module.exports = $00685a7e9f29b725$var$Transform;

var $00685a7e9f29b725$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("i1Urf")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $iKBv6 = parcelRequire("iKBv6");

var $fp08x = parcelRequire("fp08x");
var $00685a7e9f29b725$require$getHighWaterMark = $fp08x.getHighWaterMark;
$00685a7e9f29b725$var$ObjectSetPrototypeOf($00685a7e9f29b725$var$Transform.prototype, $iKBv6.prototype);
$00685a7e9f29b725$var$ObjectSetPrototypeOf($00685a7e9f29b725$var$Transform, $iKBv6);
var $00685a7e9f29b725$var$kCallback = $00685a7e9f29b725$var$Symbol('kCallback');
function $00685a7e9f29b725$var$Transform(options) {
    if (!(this instanceof $00685a7e9f29b725$var$Transform)) return new $00685a7e9f29b725$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $00685a7e9f29b725$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $iKBv6.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$00685a7e9f29b725$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $00685a7e9f29b725$var$prefinish);
}
function $00685a7e9f29b725$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $00685a7e9f29b725$var$prefinish() {
    if (this._final !== $00685a7e9f29b725$var$_final) $00685a7e9f29b725$var$_final.call(this);
}
$00685a7e9f29b725$var$Transform.prototype._final = $00685a7e9f29b725$var$_final;
$00685a7e9f29b725$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $00685a7e9f29b725$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$00685a7e9f29b725$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$00685a7e9f29b725$var$kCallback] = callback;
    });
};
$00685a7e9f29b725$var$Transform.prototype._read = function() {
    if (this[$00685a7e9f29b725$var$kCallback]) {
        var callback = this[$00685a7e9f29b725$var$kCallback];
        this[$00685a7e9f29b725$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("5hMkG", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $8PVhU = parcelRequire("8PVhU");
var $3d94081ad5708e7f$var$ArrayPrototypePop = $8PVhU.ArrayPrototypePop, $3d94081ad5708e7f$var$Promise = $8PVhU.Promise;

var $iz3nv = parcelRequire("iz3nv");
var $3d94081ad5708e7f$var$isIterable = $iz3nv.isIterable, $3d94081ad5708e7f$var$isNodeStream = $iz3nv.isNodeStream, $3d94081ad5708e7f$var$isWebStream = $iz3nv.isWebStream;

var $l7PcQ = parcelRequire("l7PcQ");
var $3d94081ad5708e7f$var$pl = $l7PcQ.pipelineImpl;

var $lV7H7 = parcelRequire("lV7H7");
var $3d94081ad5708e7f$require$finished = $lV7H7.finished;
parcelRequire("iR1nQ");
function $3d94081ad5708e7f$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $3d94081ad5708e7f$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$3d94081ad5708e7f$var$isNodeStream(lastArg) && !$3d94081ad5708e7f$var$isIterable(lastArg) && !$3d94081ad5708e7f$var$isWebStream(lastArg)) {
            var options = $3d94081ad5708e7f$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $3d94081ad5708e7f$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $3d94081ad5708e7f$require$finished,
    pipeline: $3d94081ad5708e7f$var$pipeline
};

});




parcelRegister("bKr1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d8f2f5d2d524f1$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $6rfrN = parcelRequire("6rfrN");
var $88d8f2f5d2d524f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3DatasetCoreFactory() {
        (0, $jGAMp._)(this, N3DatasetCoreFactory);
    }
    (0, $byiyg._)(N3DatasetCoreFactory, [
        {
            key: "dataset",
            value: function dataset(quads) {
                return new (0, $6rfrN.default)(quads);
            }
        }
    ]);
    return N3DatasetCoreFactory;
}();

});

parcelRegister("fsKxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b41d9133134a237c$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $ha9LD = parcelRequire("ha9LD");
function $b41d9133134a237c$export$d4c7b9e4255161a(dataset) {
    var rules = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dataset.match(null, (0, $ha9LD.default).namedNode('http://www.w3.org/2000/10/swap/log#implies'), null, (0, $ha9LD.default).defaultGraph())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, subject = _step_value.subject, object = _step_value.object;
            var premise = (0, $7WNf6._)(dataset.match(null, null, null, subject));
            var conclusion = (0, $7WNf6._)(dataset.match(null, null, null, object));
            rules.push({
                premise: premise,
                conclusion: conclusion
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rules;
}
var $b41d9133134a237c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function N3Reasoner(store) {
        (0, $jGAMp._)(this, N3Reasoner);
        this._store = store;
    }
    (0, $byiyg._)(N3Reasoner, [
        {
            key: "_add",
            value: function _add(subject, predicate, object, graphItem, cb) {
                // Only add to the remaining indexes if there is not already a value in the index
                if (!this._store._addToIndex(graphItem.subjects, subject, predicate, object)) return;
                this._store._addToIndex(graphItem.predicates, predicate, object, subject);
                this._store._addToIndex(graphItem.objects, object, subject, predicate);
                cb();
            }
        },
        {
            // eslint-disable-next-line no-warning-comments
            key: "_evaluatePremise",
            value: function _evaluatePremise(rule, content, cb) {
                var _this = this;
                var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var v1, v2, value, index1, index2;
                var _rule_premise_i_value = (0, $32TW8._)(rule.premise[i].value, 3), val0 = _rule_premise_i_value[0], val1 = _rule_premise_i_value[1], val2 = _rule_premise_i_value[2], index = content[rule.premise[i].content];
                var v0 = !(value = val0.value);
                for(value in v0 ? index : (0, $cqEAj._)({}, value, index[value]))if (index1 = index[value]) {
                    if (v0) val0.value = Number(value);
                    v1 = !(value = val1.value);
                    for(value in v1 ? index1 : (0, $cqEAj._)({}, value, index1[value]))if (index2 = index1[value]) {
                        if (v1) val1.value = Number(value);
                        v2 = !(value = val2.value);
                        for(value in v2 ? index2 : (0, $cqEAj._)({}, value, index2[value])){
                            if (v2) val2.value = Number(value);
                            if (i === rule.premise.length - 1) rule.conclusion.forEach(function(c) {
                                // eslint-disable-next-line max-nested-callbacks
                                _this._add(c.subject.value, c.predicate.value, c.object.value, content, function() {
                                    cb(c);
                                });
                            });
                            else this._evaluatePremise(rule, content, cb, i + 1);
                        }
                        if (v2) val2.value = null;
                    }
                    if (v1) val1.value = null;
                }
                if (v0) val0.value = null;
            }
        },
        {
            key: "_evaluateRules",
            value: function _evaluateRules(rules, content, cb) {
                for(var i = 0; i < rules.length; i++)this._evaluatePremise(rules[i], content, cb);
            }
        },
        {
            // A naive reasoning algorithm where rules are just applied by repeatedly applying rules
            // until no more evaluations are made
            key: "_reasonGraphNaive",
            value: function _reasonGraphNaive(rules, content) {
                var _this = this;
                var newRules = [];
                function addRule(conclusion) {
                    if (conclusion.next) conclusion.next.forEach(function(rule) {
                        newRules.push([
                            conclusion.subject.value,
                            conclusion.predicate.value,
                            conclusion.object.value,
                            rule
                        ]);
                    });
                }
                // eslint-disable-next-line func-style
                var addConclusions = function(conclusion) {
                    conclusion.forEach(function(c) {
                        // eslint-disable-next-line max-nested-callbacks
                        _this._add(c.subject.value, c.predicate.value, c.object.value, content, function() {
                            addRule(c);
                        });
                    });
                };
                this._evaluateRules(rules, content, addRule);
                var r;
                while((r = newRules.pop()) !== undefined){
                    var _r = (0, $32TW8._)(r, 4), subject = _r[0], predicate = _r[1], object = _r[2], rule = _r[3];
                    var v1 = rule.basePremise.subject.value;
                    if (!v1) rule.basePremise.subject.value = subject;
                    var v2 = rule.basePremise.predicate.value;
                    if (!v2) rule.basePremise.predicate.value = predicate;
                    var v3 = rule.basePremise.object.value;
                    if (!v3) rule.basePremise.object.value = object;
                    if (rule.premise.length === 0) addConclusions(rule.conclusion);
                    else this._evaluatePremise(rule, content, addRule);
                    if (!v1) rule.basePremise.subject.value = null;
                    if (!v2) rule.basePremise.predicate.value = null;
                    if (!v3) rule.basePremise.object.value = null;
                }
            }
        },
        {
            key: "_createRule",
            value: function _createRule(param) {
                var _this = this;
                var premise = param.premise, conclusion = param.conclusion;
                var varMapping = {};
                var toId = function(value) {
                    return value.termType === 'Variable' ? // If the term is a variable, then create an empty object that values can be placed into
                    varMapping[value.value] = varMapping[value.value] || {} : // If the term is not a variable, then set the ID value
                    {
                        value: _this._store._termToNewNumericId(value)
                    };
                };
                // eslint-disable-next-line func-style
                var t = function(term) {
                    return {
                        subject: toId(term.subject),
                        predicate: toId(term.predicate),
                        object: toId(term.object)
                    };
                };
                return {
                    premise: premise.map(function(p) {
                        return t(p);
                    }),
                    conclusion: conclusion.map(function(p) {
                        return t(p);
                    }),
                    variables: Object.values(varMapping)
                };
            }
        },
        {
            key: "reason",
            value: function reason(rules) {
                var _this = this;
                if (!Array.isArray(rules)) rules = $b41d9133134a237c$export$d4c7b9e4255161a(rules);
                rules = rules.map(function(rule) {
                    return _this._createRule(rule);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r1 = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = rules[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var r2 = _step1.value;
                                for(var i = 0; i < r2.premise.length; i++){
                                    var p = r2.premise[i];
                                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator2 = r1.conclusion[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            var c = _step2.value;
                                            if ($b41d9133134a237c$var$termEq(p.subject, c.subject) && $b41d9133134a237c$var$termEq(p.predicate, c.predicate) && $b41d9133134a237c$var$termEq(p.object, c.object)) {
                                                var set = new Set();
                                                var premise = [];
                                                // Since these *will* be substituted when we apply the rule,
                                                // we need to do this, so that we index correctly in the subsequent section
                                                p.subject.value = p.subject.value || 1;
                                                p.object.value = p.object.value || 1;
                                                p.predicate.value = p.predicate.value || 1;
                                                for(var j = 0; j < r2.premise.length; j++)if (j !== i) premise.push($b41d9133134a237c$var$getIndex(r2.premise[j], set));
                                                // eslint-disable-next-line no-warning-comments
                                                // TODO: Create new rule, with new indexing
                                                //       Future, 'collapse' the next statements when they share a premise/base-premise
                                                (c.next = c.next || []).push({
                                                    premise: premise,
                                                    conclusion: r2.conclusion,
                                                    // This is a single premise of the form { subject, predicate, object },
                                                    // which we can use to instantiate the rule using the new data that was emitted
                                                    basePremise: p
                                                });
                                            }
                                            r2.variables.forEach(function(v) {
                                                v.value = null;
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                _iterator2["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    var _loop = function() {
                        var rule = _step3.value;
                        var set = new Set();
                        rule.premise = rule.premise.map(function(p) {
                            return $b41d9133134a237c$var$getIndex(p, set);
                        });
                    };
                    for(var _iterator3 = rules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)_loop();
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                            _iterator3["return"]();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                var graphs = this._store._getGraphs();
                for(var graphId in graphs)this._reasonGraphNaive(rules, graphs[graphId]);
                this._store._size = null;
            }
        }
    ]);
    return N3Reasoner;
}();
function $b41d9133134a237c$var$getIndex(param, set) {
    var subject = param.subject, predicate = param.predicate, object = param.object;
    var s = subject.value || set.has(subject) || (set.add(subject), false);
    var p = predicate.value || set.has(predicate) || (set.add(predicate), false);
    var o = object.value || set.has(object) || (set.add(object), false);
    return !s && p ? {
        content: 'predicates',
        value: [
            predicate,
            object,
            subject
        ]
    } : o ? {
        content: 'objects',
        value: [
            object,
            subject,
            predicate
        ]
    } : {
        content: 'subjects',
        value: [
            subject,
            predicate,
            object
        ]
    };
}
function $b41d9133134a237c$var$termEq(t1, t2) {
    if (t1.value === null) t1.value = t2.value;
    return t1.value === t2.value;
}

});

parcelRegister("7dmRm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $540b7ac34968927d$export$2e2bcd8739ae039; });
// **N3StreamParser** parses a text stream into a quad stream.

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $f9bYj = parcelRequire("f9bYj");

var $4lFIc = parcelRequire("4lFIc");
var $540b7ac34968927d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transform) {
    "use strict";
    (0, $i3fW3._)(N3StreamParser, Transform);
    function N3StreamParser(options) {
        (0, $jGAMp._)(this, N3StreamParser);
        var _this;
        _this = (0, $kzDuW._)(this, N3StreamParser, [
            {
                decodeStrings: true
            }
        ]);
        _this._readableState.objectMode = true;
        // Set up parser with dummy stream to obtain `data` and `end` callbacks
        var parser = new (0, $4lFIc.default)(options);
        var onData, onEnd;
        var callbacks = {
            // Handle quads by pushing them down the pipeline
            onQuad: function(error, quad) {
                error && _this.emit('error', error) || quad && _this.push(quad);
            },
            // Emit prefixes through the `prefix` event
            onPrefix: function(prefix, uri) {
                _this.emit('prefix', prefix, uri);
            }
        };
        if (options && options.comments) callbacks.onComment = function(comment) {
            _this.emit('comment', comment);
        };
        parser.parse({
            on: function(event, callback) {
                switch(event){
                    case 'data':
                        onData = callback;
                        break;
                    case 'end':
                        onEnd = callback;
                        break;
                }
            }
        }, callbacks);
        // Implement Transform methods through parser callbacks
        _this._transform = function(chunk, encoding, done) {
            onData(chunk);
            done();
        };
        _this._flush = function(done) {
            onEnd();
            done();
        };
        return _this;
    }
    (0, $byiyg._)(N3StreamParser, [
        {
            // ### Parses a stream of strings
            key: "import",
            value: function _import(stream) {
                var _this = this;
                stream.on('data', function(chunk) {
                    _this.write(chunk);
                });
                stream.on('end', function() {
                    _this.end();
                });
                stream.on('error', function(error) {
                    _this.emit('error', error);
                });
                return this;
            }
        }
    ]);
    return N3StreamParser;
}((0, $f9bYj.Transform));

});

parcelRegister("fmFF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f93a1d3c391765$export$2e2bcd8739ae039; });
// **N3StreamWriter** serializes a quad stream into a text stream.

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $f9bYj = parcelRequire("f9bYj");

var $cfNAJ = parcelRequire("cfNAJ");
var $b2f93a1d3c391765$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transform) {
    "use strict";
    (0, $i3fW3._)(N3StreamWriter, Transform);
    function N3StreamWriter(options) {
        (0, $jGAMp._)(this, N3StreamWriter);
        var _this;
        _this = (0, $kzDuW._)(this, N3StreamWriter, [
            {
                encoding: 'utf8',
                writableObjectMode: true
            }
        ]);
        // Set up writer with a dummy stream object
        var writer = _this._writer = new (0, $cfNAJ.default)({
            write: function(quad, encoding, callback) {
                _this.push(quad);
                callback && callback();
            },
            end: function(callback) {
                _this.push(null);
                callback && callback();
            }
        }, options);
        // Implement Transform methods on top of writer
        _this._transform = function(quad, encoding, done) {
            writer.addQuad(quad, done);
        };
        _this._flush = function(done) {
            writer.end(done);
        };
        return _this;
    }
    (0, $byiyg._)(N3StreamWriter, [
        {
            // ### Serializes a stream of quads
            key: "import",
            value: function _import(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    _this.write(quad);
                });
                stream.on('end', function() {
                    _this.end();
                });
                stream.on('error', function(error) {
                    _this.emit('error', error);
                });
                stream.on('prefix', function(prefix, iri) {
                    _this._writer.addPrefix(prefix, iri);
                });
                return this;
            }
        }
    ]);
    return N3StreamWriter;
}((0, $f9bYj.Transform));

});




parcelRegister("gUxwi", function(module, exports) {
"use strict";
var $c4fbe0a707560ce7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c4fbe0a707560ce7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c4fbe0a707560ce7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c4fbe0a707560ce7$var$__exportStar((parcelRequire("7NvU5")), module.exports);

});
parcelRegister("7NvU5", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseRdfXml = void 0;

var $1Nxez = parcelRequire("1Nxez");

var $9nBhR = parcelRequire("9nBhR");

var $43Sp8 = parcelRequire("43Sp8");
/**
 * A comunica RDF/XML RDF Parse Actor.
 */ var $5ad5db6142e86b3d$var$ActorRdfParseRdfXml = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseRdfXml, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseRdfXml(args) {
        (0, $jGAMp._)(this, ActorRdfParseRdfXml);
        return (0, $kzDuW._)(this, ActorRdfParseRdfXml, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseRdfXml, [
        {
            key: "runHandle",
            value: function runHandle(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_metadata, dataFactory, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        action.data.on('error', function(error) {
                            return data.emit('error', error);
                        });
                        data = action.data.pipe(new $43Sp8.RdfXmlParser({
                            dataFactory: dataFactory,
                            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI
                        }));
                        return [
                            2,
                            {
                                data: data,
                                metadata: {
                                    triples: true
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseRdfXml;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseRdfXml = $5ad5db6142e86b3d$var$ActorRdfParseRdfXml;

});
parcelRegister("43Sp8", function(module, exports) {
"use strict";
var $2f51a4cc71e5e5d2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2f51a4cc71e5e5d2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2f51a4cc71e5e5d2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2f51a4cc71e5e5d2$var$__exportStar((parcelRequire("d1Yc3")), module.exports);

});
parcelRegister("d1Yc3", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseType = module.exports.RdfXmlParser = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $6R7JQ = parcelRequire("6R7JQ");

var $8drNf = parcelRequire("8drNf");

var $gZ4nC = parcelRequire("gZ4nC");

var $2ej16 = parcelRequire("2ej16");

var $eALDR = parcelRequire("eALDR");
var $97ca0f80eb317346$var$RdfXmlParser = /*#__PURE__*/ function(_readable_stream_1_Transform) {
    (0, $i3fW3._)(RdfXmlParser, _readable_stream_1_Transform);
    function RdfXmlParser(args) {
        (0, $jGAMp._)(this, RdfXmlParser);
        var _this;
        _this = (0, $kzDuW._)(this, RdfXmlParser, [
            {
                readableObjectMode: true
            }
        ]);
        _this.activeTagStack = [];
        _this.nodeIds = {};
        if (args) {
            Object.assign(_this, args);
            _this.options = args;
        }
        if (!_this.dataFactory) _this.dataFactory = new $2ej16.DataFactory();
        if (!_this.baseIRI) _this.baseIRI = '';
        if (!_this.defaultGraph) _this.defaultGraph = _this.dataFactory.defaultGraph();
        if (_this.validateUri !== false) _this.validateUri = true;
        if (!_this.iriValidationStrategy) _this.iriValidationStrategy = _this.validateUri ? $eALDR.IriValidationStrategy.Pragmatic : $eALDR.IriValidationStrategy.None;
        _this.saxParser = new $6R7JQ.SaxesParser({
            xmlns: true,
            position: _this.trackPosition
        });
        _this.attachSaxListeners();
        return _this;
    }
    (0, $byiyg._)(RdfXmlParser, [
        {
            /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ key: "import",
            value: function _import(stream) {
                var output = new $8drNf.PassThrough({
                    readableObjectMode: true
                });
                stream.on('error', function(error) {
                    return parsed.emit('error', error);
                });
                stream.on('data', function(data) {
                    return output.push(data);
                });
                stream.on('end', function() {
                    return output.push(null);
                });
                var parsed = output.pipe(new RdfXmlParser(this.options));
                return parsed;
            }
        },
        {
            key: "_transform",
            value: function _transform(chunk, encoding, callback) {
                try {
                    this.saxParser.write(chunk);
                } catch (e) {
                    return callback(e);
                }
                callback();
            }
        },
        {
            /**
     * Create a new parse error instance.
     * @param {string} message An error message.
     * @return {Error} An error instance.
     */ key: "newParseError",
            value: function newParseError(message) {
                return new $gZ4nC.ParseError(this, message);
            }
        },
        {
            /**
     * Convert the given value to a IRI by taking into account the baseIRI.
     *
     * This will follow the RDF/XML spec for converting values with baseIRIs to a IRI.
     *
     * @param {string} value The value to convert to an IRI.
     * @param {IActiveTag} activeTag The active tag.
     * @return {NamedNode} an IRI.
     */ key: "valueToUri",
            value: function valueToUri(value, activeTag) {
                return this.uriToNamedNode((0, $hDpjF.resolve)(value, activeTag.baseIRI));
            }
        },
        {
            /**
     * Convert the given value URI string to a named node.
     *
     * This throw an error if the URI is invalid.
     *
     * @param {string} uri A URI string.
     * @return {NamedNode} a named node.
     */ key: "uriToNamedNode",
            value: function uriToNamedNode(uri) {
                // Validate URI
                var uriValidationResult = (0, $eALDR.validateIri)(uri, this.iriValidationStrategy);
                if (uriValidationResult instanceof Error) throw this.newParseError(uriValidationResult.message);
                return this.dataFactory.namedNode(uri);
            }
        },
        {
            /**
     * Validate the given value as an NCName: https://www.w3.org/TR/xml-names/#NT-NCName
     * If it is invalid, an error will thrown emitted.
     * @param {string} value A value.
     */ key: "validateNcname",
            value: function validateNcname(value) {
                // Validate term as an NCName: https://www.w3.org/TR/xml-names/#NT-NCName
                if (!RdfXmlParser.NCNAME_MATCHER.test(value)) throw this.newParseError("Not a valid NCName: ".concat(value));
            }
        },
        {
            key: "attachSaxListeners",
            value: function attachSaxListeners() {
                var _this = this;
                this.saxParser.on('error', function(error) {
                    return _this.emit('error', error);
                });
                this.saxParser.on('opentag', this.onTag.bind(this));
                this.saxParser.on('text', this.onText.bind(this));
                this.saxParser.on('cdata', this.onText.bind(this));
                this.saxParser.on('closetag', this.onCloseTag.bind(this));
                this.saxParser.on('doctype', this.onDoctype.bind(this));
            }
        },
        {
            /**
     * Handle the given tag.
     * @param {SaxesTagNS} tag A SAX tag.
     */ key: "onTag",
            value: function onTag(tag) {
                // Get parent tag
                var parentTag = this.activeTagStack.length ? this.activeTagStack[this.activeTagStack.length - 1] : null;
                var currentParseType = $97ca0f80eb317346$var$ParseType.RESOURCE;
                if (parentTag) {
                    parentTag.hadChildren = true;
                    currentParseType = parentTag.childrenParseType;
                }
                // Check if this tag needs to be converted to a string
                if (parentTag && parentTag.childrenStringTags) {
                    // Convert this tag to a string
                    var tagName = tag.name;
                    var attributes = '';
                    for(var attributeKey in tag.attributes)attributes += " ".concat(attributeKey, '="').concat(tag.attributes[attributeKey].value, '"');
                    var tagContents = "".concat(tagName).concat(attributes);
                    var tagString = "<".concat(tagContents, ">");
                    parentTag.childrenStringTags.push(tagString);
                    // Inherit the array, so that deeper tags are appended to this same array
                    var stringActiveTag = {
                        childrenStringTags: parentTag.childrenStringTags
                    };
                    stringActiveTag.childrenStringEmitClosingTag = "</".concat(tagName, ">");
                    this.activeTagStack.push(stringActiveTag);
                    // Halt any further processing
                    return;
                }
                var activeTag = {};
                if (parentTag) {
                    // Inherit language scope and baseIRI from parent
                    activeTag.language = parentTag.language;
                    activeTag.baseIRI = parentTag.baseIRI;
                } else activeTag.baseIRI = this.baseIRI;
                this.activeTagStack.push(activeTag);
                if (currentParseType === $97ca0f80eb317346$var$ParseType.RESOURCE) this.onTagResource(tag, activeTag, parentTag, !parentTag);
                else this.onTagProperty(tag, activeTag, parentTag);
            }
        },
        {
            /**
     * Handle the given node element in resource-mode.
     * @param {SaxesTagNS} tag A SAX tag.
     * @param {IActiveTag} activeTag The currently active tag.
     * @param {IActiveTag} parentTag The parent tag or null.
     * @param {boolean} rootTag If we are currently processing the root tag.
     */ key: "onTagResource",
            value: function onTagResource(tag, activeTag, parentTag, rootTag) {
                activeTag.childrenParseType = $97ca0f80eb317346$var$ParseType.PROPERTY;
                // Assume that the current node is a _typed_ node (2.13), unless we find an rdf:Description as node name
                var typedNode = true;
                if (tag.uri === RdfXmlParser.RDF) {
                    // Check forbidden property element names
                    if (!rootTag && RdfXmlParser.FORBIDDEN_NODE_ELEMENTS.indexOf(tag.local) >= 0) throw this.newParseError("Illegal node element name: ".concat(tag.local));
                    switch(tag.local){
                        case 'RDF':
                            // Tags under <rdf:RDF> must always be resources
                            activeTag.childrenParseType = $97ca0f80eb317346$var$ParseType.RESOURCE;
                        case 'Description':
                            typedNode = false;
                    }
                }
                var predicates = [];
                var objects = [];
                // Collect all attributes as triples
                // Assign subject value only after all attributes have been processed, because baseIRI may change the final val
                var activeSubjectValue = null;
                var claimSubjectNodeId = false;
                var subjectValueBlank = false;
                var explicitType = null;
                for(var attributeKey in tag.attributes){
                    var attribute = tag.attributes[attributeKey];
                    if (parentTag && attribute.uri === RdfXmlParser.RDF) switch(attribute.local){
                        case 'about':
                            if (activeSubjectValue) throw this.newParseError("Only one of rdf:about, rdf:nodeID and rdf:ID can be present, while ".concat(attribute.value, " and ").concat(activeSubjectValue, " where found."));
                            activeSubjectValue = attribute.value;
                            continue;
                        case 'ID':
                            if (activeSubjectValue) throw this.newParseError("Only one of rdf:about, rdf:nodeID and rdf:ID can be present, while ".concat(attribute.value, " and ").concat(activeSubjectValue, " where found."));
                            this.validateNcname(attribute.value);
                            activeSubjectValue = '#' + attribute.value;
                            claimSubjectNodeId = true;
                            continue;
                        case 'nodeID':
                            if (activeSubjectValue) throw this.newParseError("Only one of rdf:about, rdf:nodeID and rdf:ID can be present, while ".concat(attribute.value, " and ").concat(activeSubjectValue, " where found."));
                            this.validateNcname(attribute.value);
                            activeSubjectValue = attribute.value;
                            subjectValueBlank = true;
                            continue;
                        case 'bagID':
                            throw this.newParseError("rdf:bagID is not supported.");
                        case 'type':
                            // Emit the rdf:type later as named node instead of the default literal
                            explicitType = attribute.value;
                            continue;
                        case 'aboutEach':
                            throw this.newParseError("rdf:aboutEach is not supported.");
                        case 'aboutEachPrefix':
                            throw this.newParseError("rdf:aboutEachPrefix is not supported.");
                        case 'li':
                            throw this.newParseError("rdf:li on node elements are not supported.");
                    }
                    else if (attribute.uri === RdfXmlParser.XML) {
                        if (attribute.local === 'lang') {
                            activeTag.language = attribute.value === '' ? null : attribute.value.toLowerCase();
                            continue;
                        } else if (attribute.local === 'base') {
                            // SAX Parser does not expand xml:base, based on DOCTYPE, so we have to do it manually
                            activeTag.baseIRI = (0, $hDpjF.resolve)(attribute.value, activeTag.baseIRI);
                            continue;
                        }
                    }
                    // Interpret attributes at this point as properties on this node,
                    // but we ignore attributes that have no prefix or known expanded URI
                    if (attribute.prefix !== 'xml' && attribute.prefix !== 'xmlns' && (attribute.prefix !== '' || attribute.local !== 'xmlns') && attribute.uri) {
                        predicates.push(this.uriToNamedNode(attribute.uri + attribute.local));
                        objects.push(attribute.value);
                    }
                }
                // Create the subject value _after_ all attributes have been processed
                if (activeSubjectValue !== null) {
                    activeTag.subject = subjectValueBlank ? this.dataFactory.blankNode(activeSubjectValue) : this.valueToUri(activeSubjectValue, activeTag);
                    if (claimSubjectNodeId) this.claimNodeId(activeTag.subject);
                }
                // Force the creation of a subject if it doesn't exist yet
                if (!activeTag.subject) activeTag.subject = this.dataFactory.blankNode();
                // Emit the type if we're at a typed node
                if (typedNode) {
                    var type = this.uriToNamedNode(tag.uri + tag.local);
                    this.emitTriple(activeTag.subject, this.dataFactory.namedNode(RdfXmlParser.RDF + 'type'), type, parentTag ? parentTag.reifiedStatementId : null);
                }
                if (parentTag) {
                    // If the parent tag defined a predicate, add the current tag as property value
                    if (parentTag.predicate) {
                        if (parentTag.childrenCollectionSubject) {
                            // RDF:List-based properties
                            var linkTerm = this.dataFactory.blankNode();
                            // Emit <x> <p> <current-chain> OR <previous-chain> <rdf:rest> <current-chain>
                            this.emitTriple(parentTag.childrenCollectionSubject, parentTag.childrenCollectionPredicate, linkTerm, parentTag.reifiedStatementId);
                            // Emit <current-chain> <rdf:first> value
                            this.emitTriple(linkTerm, this.dataFactory.namedNode(RdfXmlParser.RDF + 'first'), activeTag.subject, activeTag.reifiedStatementId);
                            // Store <current-chain> in the parent node
                            parentTag.childrenCollectionSubject = linkTerm;
                            parentTag.childrenCollectionPredicate = this.dataFactory.namedNode(RdfXmlParser.RDF + 'rest');
                        } else {
                            // Set-based properties
                            this.emitTriple(parentTag.subject, parentTag.predicate, activeTag.subject, parentTag.reifiedStatementId);
                            // Emit pending properties on the parent tag that had no defined subject yet.
                            for(var i = 0; i < parentTag.predicateSubPredicates.length; i++)this.emitTriple(activeTag.subject, parentTag.predicateSubPredicates[i], parentTag.predicateSubObjects[i], null);
                            // Cleanup so we don't emit them again when the parent tag is closed
                            parentTag.predicateSubPredicates = [];
                            parentTag.predicateSubObjects = [];
                            parentTag.predicateEmitted = true;
                        }
                    }
                    // Emit all collected triples
                    for(var i1 = 0; i1 < predicates.length; i1++){
                        var object = this.dataFactory.literal(objects[i1], activeTag.datatype || activeTag.language);
                        this.emitTriple(activeTag.subject, predicates[i1], object, parentTag.reifiedStatementId);
                    }
                    // Emit the rdf:type as named node instead of literal
                    if (explicitType) this.emitTriple(activeTag.subject, this.dataFactory.namedNode(RdfXmlParser.RDF + 'type'), this.uriToNamedNode(explicitType), null);
                }
            }
        },
        {
            /**
     * Handle the given property element in property-mode.
     * @param {SaxesTagNS} tag A SAX tag.
     * @param {IActiveTag} activeTag The currently active tag.
     * @param {IActiveTag} parentTag The parent tag or null.
     */ key: "onTagProperty",
            value: function onTagProperty(tag, activeTag, parentTag) {
                activeTag.childrenParseType = $97ca0f80eb317346$var$ParseType.RESOURCE;
                activeTag.subject = parentTag.subject; // Inherit parent subject
                if (tag.uri === RdfXmlParser.RDF && tag.local === 'li') {
                    // Convert rdf:li to rdf:_x
                    if (!parentTag.listItemCounter) parentTag.listItemCounter = 1;
                    activeTag.predicate = this.uriToNamedNode(tag.uri + '_' + parentTag.listItemCounter++);
                } else activeTag.predicate = this.uriToNamedNode(tag.uri + tag.local);
                // Check forbidden property element names
                if (tag.uri === RdfXmlParser.RDF && RdfXmlParser.FORBIDDEN_PROPERTY_ELEMENTS.indexOf(tag.local) >= 0) throw this.newParseError("Illegal property element name: ".concat(tag.local));
                activeTag.predicateSubPredicates = [];
                activeTag.predicateSubObjects = [];
                var parseType = false;
                var attributedProperty = false;
                // Collect all attributes as triples
                // Assign subject value only after all attributes have been processed, because baseIRI may change the final val
                var activeSubSubjectValue = null;
                var subSubjectValueBlank = true;
                var predicates = [];
                var objects = [];
                for(var propertyAttributeKey in tag.attributes){
                    var propertyAttribute = tag.attributes[propertyAttributeKey];
                    if (propertyAttribute.uri === RdfXmlParser.RDF) switch(propertyAttribute.local){
                        case 'resource':
                            if (activeSubSubjectValue) throw this.newParseError("Found both rdf:resource (".concat(propertyAttribute.value, ") and rdf:nodeID (").concat(activeSubSubjectValue, ")."));
                            if (parseType) throw this.newParseError("rdf:parseType is not allowed on property elements with rdf:resource (".concat(propertyAttribute.value, ")"));
                            activeTag.hadChildren = true;
                            activeSubSubjectValue = propertyAttribute.value;
                            subSubjectValueBlank = false;
                            continue;
                        case 'datatype':
                            if (attributedProperty) throw this.newParseError("Found both non-rdf:* property attributes and rdf:datatype (".concat(propertyAttribute.value, ")."));
                            if (parseType) throw this.newParseError("rdf:parseType is not allowed on property elements with rdf:datatype (".concat(propertyAttribute.value, ")"));
                            activeTag.datatype = this.valueToUri(propertyAttribute.value, activeTag);
                            continue;
                        case 'nodeID':
                            if (attributedProperty) throw this.newParseError("Found both non-rdf:* property attributes and rdf:nodeID (".concat(propertyAttribute.value, ")."));
                            if (activeTag.hadChildren) throw this.newParseError("Found both rdf:resource and rdf:nodeID (".concat(propertyAttribute.value, ")."));
                            if (parseType) throw this.newParseError("rdf:parseType is not allowed on property elements with rdf:nodeID (".concat(propertyAttribute.value, ")"));
                            this.validateNcname(propertyAttribute.value);
                            activeTag.hadChildren = true;
                            activeSubSubjectValue = propertyAttribute.value;
                            subSubjectValueBlank = true;
                            continue;
                        case 'bagID':
                            throw this.newParseError("rdf:bagID is not supported.");
                        case 'parseType':
                            // Validation
                            if (attributedProperty) throw this.newParseError("rdf:parseType is not allowed when non-rdf:* property attributes are present");
                            if (activeTag.datatype) throw this.newParseError("rdf:parseType is not allowed on property elements with rdf:datatype (".concat(activeTag.datatype.value, ")"));
                            if (activeSubSubjectValue) throw this.newParseError("rdf:parseType is not allowed on property elements with rdf:nodeID or rdf:resource (".concat(activeSubSubjectValue, ")"));
                            if (propertyAttribute.value === 'Resource') {
                                parseType = true;
                                activeTag.childrenParseType = $97ca0f80eb317346$var$ParseType.PROPERTY;
                                // Turn this property element into a node element
                                var nestedBNode = this.dataFactory.blankNode();
                                this.emitTriple(activeTag.subject, activeTag.predicate, nestedBNode, activeTag.reifiedStatementId);
                                activeTag.subject = nestedBNode;
                                activeTag.predicate = null;
                            } else if (propertyAttribute.value === 'Collection') {
                                parseType = true;
                                // Interpret children as being part of an rdf:List
                                activeTag.hadChildren = true;
                                activeTag.childrenCollectionSubject = activeTag.subject;
                                activeTag.childrenCollectionPredicate = activeTag.predicate;
                                subSubjectValueBlank = false;
                            } else if (propertyAttribute.value === 'Literal') {
                                parseType = true;
                                // Interpret children as being part of a literal string
                                activeTag.childrenTagsToString = true;
                                activeTag.childrenStringTags = [];
                            }
                            continue;
                        case 'ID':
                            this.validateNcname(propertyAttribute.value);
                            activeTag.reifiedStatementId = this.valueToUri('#' + propertyAttribute.value, activeTag);
                            this.claimNodeId(activeTag.reifiedStatementId);
                            continue;
                    }
                    else if (propertyAttribute.uri === RdfXmlParser.XML && propertyAttribute.local === 'lang') {
                        activeTag.language = propertyAttribute.value === '' ? null : propertyAttribute.value.toLowerCase();
                        continue;
                    }
                    // Interpret attributes at this point as properties via implicit blank nodes on the property,
                    // but we ignore attributes that have no prefix or known expanded URI
                    if (propertyAttribute.prefix !== 'xml' && propertyAttribute.prefix !== 'xmlns' && (propertyAttribute.prefix !== '' || propertyAttribute.local !== 'xmlns') && propertyAttribute.uri) {
                        if (parseType || activeTag.datatype) throw this.newParseError("Found illegal rdf:* properties on property element with attribute: ".concat(propertyAttribute.value));
                        activeTag.hadChildren = true;
                        attributedProperty = true;
                        predicates.push(this.uriToNamedNode(propertyAttribute.uri + propertyAttribute.local));
                        objects.push(this.dataFactory.literal(propertyAttribute.value, activeTag.datatype || activeTag.language));
                    }
                }
                // Create the subject value _after_ all attributes have been processed
                if (activeSubSubjectValue !== null) {
                    var subjectParent = activeTag.subject;
                    activeTag.subject = subSubjectValueBlank ? this.dataFactory.blankNode(activeSubSubjectValue) : this.valueToUri(activeSubSubjectValue, activeTag);
                    this.emitTriple(subjectParent, activeTag.predicate, activeTag.subject, activeTag.reifiedStatementId);
                    // Emit our buffered triples
                    for(var i = 0; i < predicates.length; i++)this.emitTriple(activeTag.subject, predicates[i], objects[i], null);
                    activeTag.predicateEmitted = true;
                } else if (subSubjectValueBlank) {
                    // The current property element has no defined subject
                    // Let's buffer the properties until the child node defines a subject,
                    // or if the tag closes.
                    activeTag.predicateSubPredicates = predicates;
                    activeTag.predicateSubObjects = objects;
                    activeTag.predicateEmitted = false;
                }
            }
        },
        {
            /**
     * Emit the given triple to the stream.
     * @param {Term} subject A subject term.
     * @param {Term} predicate A predicate term.
     * @param {Term} object An object term.
     * @param {Term} statementId An optional resource that identifies the triple.
     *                           If truthy, then the given triple will also be emitted reified.
     */ key: "emitTriple",
            value: function emitTriple(subject, predicate, object, statementId) {
                this.push(this.dataFactory.quad(subject, predicate, object, this.defaultGraph));
                // Reify triple
                if (statementId) {
                    this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode(RdfXmlParser.RDF + 'type'), this.dataFactory.namedNode(RdfXmlParser.RDF + 'Statement'), this.defaultGraph));
                    this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode(RdfXmlParser.RDF + 'subject'), subject, this.defaultGraph));
                    this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode(RdfXmlParser.RDF + 'predicate'), predicate, this.defaultGraph));
                    this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode(RdfXmlParser.RDF + 'object'), object, this.defaultGraph));
                }
            }
        },
        {
            /**
     * Register the given term as a node ID.
     * If one was already registered, this will emit an error.
     *
     * This is used to check duplicate occurrences of rdf:ID in scope of the baseIRI.
     * @param {Term} term An RDF term.
     */ key: "claimNodeId",
            value: function claimNodeId(term) {
                if (!this.allowDuplicateRdfIds) {
                    if (this.nodeIds[term.value]) throw this.newParseError("Found multiple occurrences of rdf:ID='".concat(term.value, "'."));
                    this.nodeIds[term.value] = true;
                }
            }
        },
        {
            /**
     * Handle the given text string.
     * @param {string} text A parsed text string.
     */ key: "onText",
            value: function onText(text) {
                var activeTag = this.activeTagStack.length ? this.activeTagStack[this.activeTagStack.length - 1] : null;
                if (activeTag) {
                    if (activeTag.childrenStringTags) activeTag.childrenStringTags.push(text);
                    else if (activeTag.predicate) activeTag.text = text;
                }
            }
        },
        {
            /**
     * Handle the closing of the last tag.
     */ key: "onCloseTag",
            value: function onCloseTag() {
                var poppedTag = this.activeTagStack.pop();
                // If we were converting a tag to a string, and the tag was not self-closing, close it here.
                if (poppedTag.childrenStringEmitClosingTag) poppedTag.childrenStringTags.push(poppedTag.childrenStringEmitClosingTag);
                // Set the literal value if we were collecting XML tags to string
                if (poppedTag.childrenTagsToString) {
                    poppedTag.datatype = this.dataFactory.namedNode(RdfXmlParser.RDF + 'XMLLiteral');
                    poppedTag.text = poppedTag.childrenStringTags.join('');
                    poppedTag.hadChildren = false; // Force a literal triple to be emitted hereafter
                }
                if (poppedTag.childrenCollectionSubject) // Terminate the rdf:List
                this.emitTriple(poppedTag.childrenCollectionSubject, poppedTag.childrenCollectionPredicate, this.dataFactory.namedNode(RdfXmlParser.RDF + 'nil'), poppedTag.reifiedStatementId);
                else if (poppedTag.predicate) {
                    if (!poppedTag.hadChildren && poppedTag.childrenParseType !== $97ca0f80eb317346$var$ParseType.PROPERTY) // Property element contains text
                    this.emitTriple(poppedTag.subject, poppedTag.predicate, this.dataFactory.literal(poppedTag.text || '', poppedTag.datatype || poppedTag.language), poppedTag.reifiedStatementId);
                    else if (!poppedTag.predicateEmitted) {
                        // Emit remaining properties on an anonymous property element
                        var subject = this.dataFactory.blankNode();
                        this.emitTriple(poppedTag.subject, poppedTag.predicate, subject, poppedTag.reifiedStatementId);
                        for(var i = 0; i < poppedTag.predicateSubPredicates.length; i++)this.emitTriple(subject, poppedTag.predicateSubPredicates[i], poppedTag.predicateSubObjects[i], null);
                    }
                }
            }
        },
        {
            /**
     * Fetch local DOCTYPE ENTITY's and make the parser recognise them.
     * @param {string} doctype The read doctype.
     */ key: "onDoctype",
            value: function onDoctype(doctype) {
                var _this = this;
                doctype.replace(/<!ENTITY\s+([^\s]+)\s+["']([^"']+)["']\s*>/g, function(match, prefix, uri) {
                    _this.saxParser.ENTITIES[prefix] = uri;
                    return '';
                });
            }
        }
    ]);
    return RdfXmlParser;
}($8drNf.Transform);
module.exports.RdfXmlParser = $97ca0f80eb317346$var$RdfXmlParser;
$97ca0f80eb317346$var$RdfXmlParser.MIME_TYPE = 'application/rdf+xml';
$97ca0f80eb317346$var$RdfXmlParser.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$97ca0f80eb317346$var$RdfXmlParser.XML = 'http://www.w3.org/XML/1998/namespace';
$97ca0f80eb317346$var$RdfXmlParser.FORBIDDEN_NODE_ELEMENTS = [
    'RDF',
    'ID',
    'about',
    'bagID',
    'parseType',
    'resource',
    'nodeID',
    'li',
    'aboutEach',
    'aboutEachPrefix'
];
$97ca0f80eb317346$var$RdfXmlParser.FORBIDDEN_PROPERTY_ELEMENTS = [
    'Description',
    'RDF',
    'ID',
    'about',
    'bagID',
    'parseType',
    'resource',
    'nodeID',
    'aboutEach',
    'aboutEachPrefix'
];
// tslint:disable-next-line:max-line-length
$97ca0f80eb317346$var$RdfXmlParser.NCNAME_MATCHER = RegExp("^([A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\u{F8}-\\u{2FF}\\u{370}-\\u{37D}\\u{37F}-\\u{1FFF}\\u{200C}-\\u{200D}\\u{2070}-\\u{218F}\\u{2C00}-\\u{2FEF}\\u{3001}-\\u{D7FF}\\u{F900}-\\u{FDCF}\\u{FDF0}-\\u{FFFD}\\u{10000}-\\u{EFFFF}_])([A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\u{F8}-\\u{2FF}\\u{370}-\\u{37D}\\u{37F}-\\u{1FFF}\\u{200C}-\\u{200D}\\u{2070}-\\u{218F}\\u{2C00}-\\u{2FEF}\\u{3001}-\\u{D7FF}\\u{F900}-\\u{FDCF}\\u{FDF0}-\\u{FFFD}\\u{10000}-\\u{EFFFF}_\\-.0-9#xB7\\u{0300}-\\u{036F}\\u{203F}-\\u{2040}])*$", "u");
var $97ca0f80eb317346$var$ParseType;
(function(ParseType) {
    ParseType[ParseType["RESOURCE"] = 0] = "RESOURCE";
    ParseType[ParseType["PROPERTY"] = 1] = "PROPERTY";
})($97ca0f80eb317346$var$ParseType || (module.exports.ParseType = $97ca0f80eb317346$var$ParseType = {}));

});
parcelRegister("6R7JQ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SaxesParser = module.exports.EVENTS = void 0;

var $9VQvW = parcelRequire("9VQvW");

var $ify35 = parcelRequire("ify35");

var $j77V9 = parcelRequire("j77V9");
var $4fddb201687eb167$var$isS = $9VQvW.isS;
var $4fddb201687eb167$var$isChar10 = $9VQvW.isChar;
var $4fddb201687eb167$var$isNameStartChar = $9VQvW.isNameStartChar;
var $4fddb201687eb167$var$isNameChar = $9VQvW.isNameChar;
var $4fddb201687eb167$var$S_LIST = $9VQvW.S_LIST;
var $4fddb201687eb167$var$NAME_RE = $9VQvW.NAME_RE;
var $4fddb201687eb167$var$isChar11 = $ify35.isChar;
var $4fddb201687eb167$var$isNCNameStartChar = $j77V9.isNCNameStartChar;
var $4fddb201687eb167$var$isNCNameChar = $j77V9.isNCNameChar;
var $4fddb201687eb167$var$NC_NAME_RE = $j77V9.NC_NAME_RE;
var $4fddb201687eb167$var$XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var $4fddb201687eb167$var$XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var $4fddb201687eb167$var$rootNS = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    xml: $4fddb201687eb167$var$XML_NAMESPACE,
    xmlns: $4fddb201687eb167$var$XMLNS_NAMESPACE
};
var $4fddb201687eb167$var$XML_ENTITIES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    amp: "&",
    gt: ">",
    lt: "<",
    quot: "\"",
    apos: "'"
};
// EOC: end-of-chunk
var $4fddb201687eb167$var$EOC = -1;
var $4fddb201687eb167$var$NL_LIKE = -2;
var $4fddb201687eb167$var$S_BEGIN = 0; // Initial state.
var $4fddb201687eb167$var$S_BEGIN_WHITESPACE = 1; // leading whitespace
var $4fddb201687eb167$var$S_DOCTYPE = 2; // <!DOCTYPE
var $4fddb201687eb167$var$S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
var $4fddb201687eb167$var$S_DTD = 4; // <!DOCTYPE "//blah" [ ...
var $4fddb201687eb167$var$S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
var $4fddb201687eb167$var$S_DTD_OPEN_WAKA = 6;
var $4fddb201687eb167$var$S_DTD_OPEN_WAKA_BANG = 7;
var $4fddb201687eb167$var$S_DTD_COMMENT = 8; // <!--
var $4fddb201687eb167$var$S_DTD_COMMENT_ENDING = 9; // <!-- blah -
var $4fddb201687eb167$var$S_DTD_COMMENT_ENDED = 10; // <!-- blah --
var $4fddb201687eb167$var$S_DTD_PI = 11; // <?
var $4fddb201687eb167$var$S_DTD_PI_ENDING = 12; // <?hi "there" ?
var $4fddb201687eb167$var$S_TEXT = 13; // general stuff
var $4fddb201687eb167$var$S_ENTITY = 14; // &amp and such
var $4fddb201687eb167$var$S_OPEN_WAKA = 15; // <
var $4fddb201687eb167$var$S_OPEN_WAKA_BANG = 16; // <!...
var $4fddb201687eb167$var$S_COMMENT = 17; // <!--
var $4fddb201687eb167$var$S_COMMENT_ENDING = 18; // <!-- blah -
var $4fddb201687eb167$var$S_COMMENT_ENDED = 19; // <!-- blah --
var $4fddb201687eb167$var$S_CDATA = 20; // <![CDATA[ something
var $4fddb201687eb167$var$S_CDATA_ENDING = 21; // ]
var $4fddb201687eb167$var$S_CDATA_ENDING_2 = 22; // ]]
var $4fddb201687eb167$var$S_PI_FIRST_CHAR = 23; // <?hi, first char
var $4fddb201687eb167$var$S_PI_REST = 24; // <?hi, rest of the name
var $4fddb201687eb167$var$S_PI_BODY = 25; // <?hi there
var $4fddb201687eb167$var$S_PI_ENDING = 26; // <?hi "there" ?
var $4fddb201687eb167$var$S_XML_DECL_NAME_START = 27; // <?xml
var $4fddb201687eb167$var$S_XML_DECL_NAME = 28; // <?xml foo
var $4fddb201687eb167$var$S_XML_DECL_EQ = 29; // <?xml foo=
var $4fddb201687eb167$var$S_XML_DECL_VALUE_START = 30; // <?xml foo=
var $4fddb201687eb167$var$S_XML_DECL_VALUE = 31; // <?xml foo="bar"
var $4fddb201687eb167$var$S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
var $4fddb201687eb167$var$S_XML_DECL_ENDING = 33; // <?xml ... ?
var $4fddb201687eb167$var$S_OPEN_TAG = 34; // <strong
var $4fddb201687eb167$var$S_OPEN_TAG_SLASH = 35; // <strong /
var $4fddb201687eb167$var$S_ATTRIB = 36; // <a
var $4fddb201687eb167$var$S_ATTRIB_NAME = 37; // <a foo
var $4fddb201687eb167$var$S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
var $4fddb201687eb167$var$S_ATTRIB_VALUE = 39; // <a foo=
var $4fddb201687eb167$var$S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
var $4fddb201687eb167$var$S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
var $4fddb201687eb167$var$S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
var $4fddb201687eb167$var$S_CLOSE_TAG = 43; // </a
var $4fddb201687eb167$var$S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
var $4fddb201687eb167$var$TAB = 9;
var $4fddb201687eb167$var$NL = 0xA;
var $4fddb201687eb167$var$CR = 0xD;
var $4fddb201687eb167$var$SPACE = 0x20;
var $4fddb201687eb167$var$BANG = 0x21;
var $4fddb201687eb167$var$DQUOTE = 0x22;
var $4fddb201687eb167$var$AMP = 0x26;
var $4fddb201687eb167$var$SQUOTE = 0x27;
var $4fddb201687eb167$var$MINUS = 0x2D;
var $4fddb201687eb167$var$FORWARD_SLASH = 0x2F;
var $4fddb201687eb167$var$SEMICOLON = 0x3B;
var $4fddb201687eb167$var$LESS = 0x3C;
var $4fddb201687eb167$var$EQUAL = 0x3D;
var $4fddb201687eb167$var$GREATER = 0x3E;
var $4fddb201687eb167$var$QUESTION = 0x3F;
var $4fddb201687eb167$var$OPEN_BRACKET = 0x5B;
var $4fddb201687eb167$var$CLOSE_BRACKET = 0x5D;
var $4fddb201687eb167$var$NEL = 0x85;
var $4fddb201687eb167$var$LS = 0x2028; // Line Separator
var $4fddb201687eb167$var$isQuote = function(c) {
    return c === $4fddb201687eb167$var$DQUOTE || c === $4fddb201687eb167$var$SQUOTE;
};
var $4fddb201687eb167$var$QUOTES = [
    $4fddb201687eb167$var$DQUOTE,
    $4fddb201687eb167$var$SQUOTE
];
var $4fddb201687eb167$var$DOCTYPE_TERMINATOR = (0, $7WNf6._)($4fddb201687eb167$var$QUOTES).concat([
    $4fddb201687eb167$var$OPEN_BRACKET,
    $4fddb201687eb167$var$GREATER
]);
var $4fddb201687eb167$var$DTD_TERMINATOR = (0, $7WNf6._)($4fddb201687eb167$var$QUOTES).concat([
    $4fddb201687eb167$var$LESS,
    $4fddb201687eb167$var$CLOSE_BRACKET
]);
var $4fddb201687eb167$var$XML_DECL_NAME_TERMINATOR = [
    $4fddb201687eb167$var$EQUAL,
    $4fddb201687eb167$var$QUESTION
].concat((0, $7WNf6._)($4fddb201687eb167$var$S_LIST));
var $4fddb201687eb167$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR = (0, $7WNf6._)($4fddb201687eb167$var$S_LIST).concat([
    $4fddb201687eb167$var$GREATER,
    $4fddb201687eb167$var$AMP,
    $4fddb201687eb167$var$LESS
]);
function $4fddb201687eb167$var$nsPairCheck(parser, prefix, uri) {
    switch(prefix){
        case "xml":
            if (uri !== $4fddb201687eb167$var$XML_NAMESPACE) parser.fail("xml prefix must be bound to ".concat($4fddb201687eb167$var$XML_NAMESPACE, "."));
            break;
        case "xmlns":
            if (uri !== $4fddb201687eb167$var$XMLNS_NAMESPACE) parser.fail("xmlns prefix must be bound to ".concat($4fddb201687eb167$var$XMLNS_NAMESPACE, "."));
            break;
        default:
    }
    switch(uri){
        case $4fddb201687eb167$var$XMLNS_NAMESPACE:
            parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : 'may not assign a prefix (even "xmlns") to the URI '.concat($4fddb201687eb167$var$XMLNS_NAMESPACE, "."));
            break;
        case $4fddb201687eb167$var$XML_NAMESPACE:
            switch(prefix){
                case "xml":
                    break;
                case "":
                    parser.fail("the default namespace may not be set to ".concat(uri, "."));
                    break;
                default:
                    parser.fail("may not assign the xml namespace to another prefix.");
            }
            break;
        default:
    }
}
function $4fddb201687eb167$var$nsMappingCheck(parser, mapping) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(mapping)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var local = _step.value;
            $4fddb201687eb167$var$nsPairCheck(parser, local, mapping[local]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $4fddb201687eb167$var$isNCName = function(name) {
    return $4fddb201687eb167$var$NC_NAME_RE.test(name);
};
var $4fddb201687eb167$var$isName = function(name) {
    return $4fddb201687eb167$var$NAME_RE.test(name);
};
var $4fddb201687eb167$var$FORBIDDEN_START = 0;
var $4fddb201687eb167$var$FORBIDDEN_BRACKET = 1;
var $4fddb201687eb167$var$FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */ module.exports.EVENTS = [
    "xmldecl",
    "text",
    "processinginstruction",
    "doctype",
    "comment",
    "opentagstart",
    "attribute",
    "opentag",
    "closetag",
    "cdata",
    "error",
    "end",
    "ready"
];
var $4fddb201687eb167$var$EVENT_NAME_TO_HANDLER_NAME = {
    xmldecl: "xmldeclHandler",
    text: "textHandler",
    processinginstruction: "piHandler",
    doctype: "doctypeHandler",
    comment: "commentHandler",
    opentagstart: "openTagStartHandler",
    attribute: "attributeHandler",
    opentag: "openTagHandler",
    closetag: "closeTagHandler",
    cdata: "cdataHandler",
    error: "errorHandler",
    end: "endHandler",
    ready: "readyHandler"
};
// eslint-disable-next-line @typescript-eslint/ban-types
var $4fddb201687eb167$var$SaxesParser = /*#__PURE__*/ function() {
    function SaxesParser(opt) {
        (0, $jGAMp._)(this, SaxesParser);
        this.opt = opt !== null && opt !== void 0 ? opt : {};
        this.fragmentOpt = !!this.opt.fragment;
        var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
        this.trackPosition = this.opt.position !== false;
        this.fileName = this.opt.fileName;
        if (xmlnsOpt) {
            // This is the function we use to perform name checks on PIs and entities.
            // When namespaces are used, colons are not allowed in PI target names or
            // entity names. So the check depends on whether namespaces are used. See:
            //
            // https://www.w3.org/XML/xml-names-19990114-errata.html
            // NE08
            //
            this.nameStartCheck = $4fddb201687eb167$var$isNCNameStartChar;
            this.nameCheck = $4fddb201687eb167$var$isNCNameChar;
            this.isName = $4fddb201687eb167$var$isNCName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsNS;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribNS;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
            this.ns = Object.assign({
                __proto__: null
            }, $4fddb201687eb167$var$rootNS);
            var additional = this.opt.additionalNamespaces;
            if (additional != null) {
                $4fddb201687eb167$var$nsMappingCheck(this, additional);
                Object.assign(this.ns, additional);
            }
        } else {
            this.nameStartCheck = $4fddb201687eb167$var$isNameStartChar;
            this.nameCheck = $4fddb201687eb167$var$isNameChar;
            this.isName = $4fddb201687eb167$var$isName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsPlain;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribPlain;
        }
        //
        // The order of the members in this table needs to correspond to the state
        // numbers given to the states that correspond to the methods being recorded
        // here.
        //
        this.stateTable = [
            /* eslint-disable @typescript-eslint/unbound-method */ this.sBegin,
            this.sBeginWhitespace,
            this.sDoctype,
            this.sDoctypeQuote,
            this.sDTD,
            this.sDTDQuoted,
            this.sDTDOpenWaka,
            this.sDTDOpenWakaBang,
            this.sDTDComment,
            this.sDTDCommentEnding,
            this.sDTDCommentEnded,
            this.sDTDPI,
            this.sDTDPIEnding,
            this.sText,
            this.sEntity,
            this.sOpenWaka,
            this.sOpenWakaBang,
            this.sComment,
            this.sCommentEnding,
            this.sCommentEnded,
            this.sCData,
            this.sCDataEnding,
            this.sCDataEnding2,
            this.sPIFirstChar,
            this.sPIRest,
            this.sPIBody,
            this.sPIEnding,
            this.sXMLDeclNameStart,
            this.sXMLDeclName,
            this.sXMLDeclEq,
            this.sXMLDeclValueStart,
            this.sXMLDeclValue,
            this.sXMLDeclSeparator,
            this.sXMLDeclEnding,
            this.sOpenTag,
            this.sOpenTagSlash,
            this.sAttrib,
            this.sAttribName,
            this.sAttribNameSawWhite,
            this.sAttribValue,
            this.sAttribValueQuoted,
            this.sAttribValueClosed,
            this.sAttribValueUnquoted,
            this.sCloseTag,
            this.sCloseTagSawWhite
        ];
        this._init();
    }
    (0, $byiyg._)(SaxesParser, [
        {
            key: "closed",
            get: /**
     * Indicates whether or not the parser is closed. If ``true``, wait for
     * the ``ready`` event to write again.
     */ function get() {
                return this._closed;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _a;
                this.openWakaBang = "";
                this.text = "";
                this.name = "";
                this.piTarget = "";
                this.entity = "";
                this.q = null;
                this.tags = [];
                this.tag = null;
                this.topNS = null;
                this.chunk = "";
                this.chunkPosition = 0;
                this.i = 0;
                this.prevI = 0;
                this.carriedFromPrevious = undefined;
                this.forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                this.attribList = [];
                // The logic is organized so as to minimize the need to check
                // this.opt.fragment while parsing.
                var fragmentOpt = this.fragmentOpt;
                this.state = fragmentOpt ? $4fddb201687eb167$var$S_TEXT : $4fddb201687eb167$var$S_BEGIN;
                // We want these to be all true if we are dealing with a fragment.
                this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
                // An XML declaration is intially possible only when parsing whole
                // documents.
                this.xmlDeclPossible = !fragmentOpt;
                this.xmlDeclExpects = [
                    "version"
                ];
                this.entityReturnState = undefined;
                var defaultXMLVersion = this.opt.defaultXMLVersion;
                if (defaultXMLVersion === undefined) {
                    if (this.opt.forceXMLVersion === true) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                    defaultXMLVersion = "1.0";
                }
                this.setXMLVersion(defaultXMLVersion);
                this.positionAtNewLine = 0;
                this.doctype = false;
                this._closed = false;
                this.xmlDecl = {
                    version: undefined,
                    encoding: undefined,
                    standalone: undefined
                };
                this.line = 1;
                this.column = 0;
                this.ENTITIES = Object.create($4fddb201687eb167$var$XML_ENTITIES);
                (_a = this.readyHandler) === null || _a === void 0 || _a.call(this);
            }
        },
        {
            key: "position",
            get: /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */ function get() {
                return this.chunkPosition + this.i;
            }
        },
        {
            key: "columnIndex",
            get: /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */ function get() {
                return this.position - this.positionAtNewLine;
            }
        },
        {
            /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */ key: "on",
            value: function on(name, handler) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                this[$4fddb201687eb167$var$EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
            }
        },
        {
            /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */ key: "off",
            value: function off(name) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                this[$4fddb201687eb167$var$EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
            }
        },
        {
            /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */ key: "makeError",
            value: function makeError(message) {
                var _a;
                var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
                if (this.trackPosition) {
                    if (msg.length > 0) msg += ":";
                    msg += "".concat(this.line, ":").concat(this.column);
                }
                if (msg.length > 0) msg += ": ";
                return new Error(msg + message);
            }
        },
        {
            /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */ key: "fail",
            value: function fail(message) {
                var err = this.makeError(message);
                var handler = this.errorHandler;
                if (handler === undefined) throw err;
                else handler(err);
                return this;
            }
        },
        {
            /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */ // We do need object for the type here. Yes, it often causes problems
            // but not in this case.
            key: "write",
            value: function write(chunk) {
                if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                var end = false;
                if (chunk === null) {
                    // We cannot return immediately because carriedFromPrevious may need
                    // processing.
                    end = true;
                    chunk = "";
                } else if ((typeof chunk === "undefined" ? "undefined" : (0, $3KZcf._)(chunk)) === "object") chunk = chunk.toString();
                // We checked if performing a pre-decomposition of the string into an array
                // of single complete characters (``Array.from(chunk)``) would be faster
                // than the current repeated calls to ``charCodeAt``. As of August 2018, it
                // isn't. (There may be Node-specific code that would perform faster than
                // ``Array.from`` but don't want to be dependent on Node.)
                if (this.carriedFromPrevious !== undefined) {
                    // The previous chunk had char we must carry over.
                    chunk = "".concat(this.carriedFromPrevious).concat(chunk);
                    this.carriedFromPrevious = undefined;
                }
                var limit = chunk.length;
                var lastCode = chunk.charCodeAt(limit - 1);
                if (!end && // A trailing CR or surrogate must be carried over to the next
                // chunk.
                (lastCode === $4fddb201687eb167$var$CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
                    // The chunk ends with a character that must be carried over. We cannot
                    // know how to handle it until we get the next chunk or the end of the
                    // stream. So save it for later.
                    this.carriedFromPrevious = chunk[limit - 1];
                    limit--;
                    chunk = chunk.slice(0, limit);
                }
                var stateTable = this.stateTable;
                this.chunk = chunk;
                this.i = 0;
                while(this.i < limit)// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
                stateTable[this.state].call(this);
                this.chunkPosition += limit;
                return end ? this.end() : this;
            }
        },
        {
            /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */ key: "close",
            value: function close() {
                return this.write(null);
            }
        },
        {
            /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */ key: "getCode10",
            value: function getCode10() {
                var _this = this, chunk = _this.chunk, i = _this.i;
                this.prevI = i;
                // Yes, we do this instead of doing this.i++. Doing it this way, we do not
                // read this.i again, which is a bit faster.
                this.i = i + 1;
                if (i >= chunk.length) return $4fddb201687eb167$var$EOC;
                // Using charCodeAt and handling the surrogates ourselves is faster
                // than using codePointAt.
                var code = chunk.charCodeAt(i);
                this.column++;
                if (code < 0xD800) {
                    if (code >= $4fddb201687eb167$var$SPACE || code === $4fddb201687eb167$var$TAB) return code;
                    switch(code){
                        case $4fddb201687eb167$var$NL:
                            this.line++;
                            this.column = 0;
                            this.positionAtNewLine = this.position;
                            return $4fddb201687eb167$var$NL;
                        case $4fddb201687eb167$var$CR:
                            // We may get NaN if we read past the end of the chunk, which is fine.
                            if (chunk.charCodeAt(i + 1) === $4fddb201687eb167$var$NL) // A \r\n sequence is converted to \n so we have to skip over the
                            // next character. We already know it has a size of 1 so ++ is fine
                            // here.
                            this.i = i + 2;
                            // Otherwise, a \r is just converted to \n, so we don't have to skip
                            // ahead.
                            // In either case, \r becomes \n.
                            this.line++;
                            this.column = 0;
                            this.positionAtNewLine = this.position;
                            return $4fddb201687eb167$var$NL_LIKE;
                        default:
                            // If we get here, then code < SPACE and it is not NL CR or TAB.
                            this.fail("disallowed character.");
                            return code;
                    }
                }
                if (code > 0xDBFF) {
                    // This is a specialized version of isChar10 that takes into account
                    // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
                    // test cases that don't need testing.
                    if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
                    return code;
                }
                var _final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
                this.i = i + 2;
                // This is a specialized version of isChar10 that takes into account that in
                // this context necessarily final >= 0x10000.
                if (_final > 0x10FFFF) this.fail("disallowed character.");
                return _final;
            }
        },
        {
            /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */ key: "getCode11",
            value: function getCode11() {
                var _this = this, chunk = _this.chunk, i = _this.i;
                this.prevI = i;
                // Yes, we do this instead of doing this.i++. Doing it this way, we do not
                // read this.i again, which is a bit faster.
                this.i = i + 1;
                if (i >= chunk.length) return $4fddb201687eb167$var$EOC;
                // Using charCodeAt and handling the surrogates ourselves is faster
                // than using codePointAt.
                var code = chunk.charCodeAt(i);
                this.column++;
                if (code < 0xD800) {
                    if (code > 0x1F && code < 0x7F || code > 0x9F && code !== $4fddb201687eb167$var$LS || code === $4fddb201687eb167$var$TAB) return code;
                    switch(code){
                        case $4fddb201687eb167$var$NL:
                            this.line++;
                            this.column = 0;
                            this.positionAtNewLine = this.position;
                            return $4fddb201687eb167$var$NL;
                        case $4fddb201687eb167$var$CR:
                            {
                                // We may get NaN if we read past the end of the chunk, which is
                                // fine.
                                var next = chunk.charCodeAt(i + 1);
                                if (next === $4fddb201687eb167$var$NL || next === $4fddb201687eb167$var$NEL) // A CR NL or CR NEL sequence is converted to NL so we have to skip
                                // over the next character. We already know it has a size of 1.
                                this.i = i + 2;
                            // Otherwise, a CR is just converted to NL, no skip.
                            }
                        /* yes, fall through */ case $4fddb201687eb167$var$NEL:
                        case $4fddb201687eb167$var$LS:
                            this.line++;
                            this.column = 0;
                            this.positionAtNewLine = this.position;
                            return $4fddb201687eb167$var$NL_LIKE;
                        default:
                            this.fail("disallowed character.");
                            return code;
                    }
                }
                if (code > 0xDBFF) {
                    // This is a specialized version of isCharAndNotRestricted that takes into
                    // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
                    // does not test cases that don't need testing.
                    if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
                    return code;
                }
                var _final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
                this.i = i + 2;
                // This is a specialized version of isCharAndNotRestricted that takes into
                // account that in this context necessarily final >= 0x10000.
                if (_final > 0x10FFFF) this.fail("disallowed character.");
                return _final;
            }
        },
        {
            /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */ key: "getCodeNorm",
            value: function getCodeNorm() {
                var c = this.getCode();
                return c === $4fddb201687eb167$var$NL_LIKE ? $4fddb201687eb167$var$NL : c;
            }
        },
        {
            key: "unget",
            value: function unget() {
                this.i = this.prevI;
                this.column--;
            }
        },
        {
            /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ key: "captureTo",
            value: function captureTo(chars) {
                var _this = this, start = _this.i;
                var chunk = this.chunk;
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var c = this.getCode();
                    var isNLLike = c === $4fddb201687eb167$var$NL_LIKE;
                    var _final = isNLLike ? $4fddb201687eb167$var$NL : c;
                    if (_final === $4fddb201687eb167$var$EOC || chars.includes(_final)) {
                        this.text += chunk.slice(start, this.prevI);
                        return _final;
                    }
                    if (isNLLike) {
                        this.text += "".concat(chunk.slice(start, this.prevI), "\n");
                        start = this.i;
                    }
                }
            }
        },
        {
            /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */ key: "captureToChar",
            value: function captureToChar(_char) {
                var _this = this, start = _this.i;
                var chunk = this.chunk;
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var c = this.getCode();
                    switch(c){
                        case $4fddb201687eb167$var$NL_LIKE:
                            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
                            start = this.i;
                            c = $4fddb201687eb167$var$NL;
                            break;
                        case $4fddb201687eb167$var$EOC:
                            this.text += chunk.slice(start);
                            return false;
                        default:
                    }
                    if (c === _char) {
                        this.text += chunk.slice(start, this.prevI);
                        return true;
                    }
                }
            }
        },
        {
            /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ key: "captureNameChars",
            value: function captureNameChars() {
                var _this = this, chunk = _this.chunk, start = _this.i;
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var c = this.getCode();
                    if (c === $4fddb201687eb167$var$EOC) {
                        this.name += chunk.slice(start);
                        return $4fddb201687eb167$var$EOC;
                    }
                    // NL is not a name char so we don't have to test specifically for it.
                    if (!$4fddb201687eb167$var$isNameChar(c)) {
                        this.name += chunk.slice(start, this.prevI);
                        return c === $4fddb201687eb167$var$NL_LIKE ? $4fddb201687eb167$var$NL : c;
                    }
                }
            }
        },
        {
            /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ key: "skipSpaces",
            value: function skipSpaces() {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var c = this.getCodeNorm();
                    if (c === $4fddb201687eb167$var$EOC || !$4fddb201687eb167$var$isS(c)) return c;
                }
            }
        },
        {
            key: "setXMLVersion",
            value: function setXMLVersion(version) {
                this.currentXMLVersion = version;
                /*  eslint-disable @typescript-eslint/unbound-method */ if (version === "1.0") {
                    this.isChar = $4fddb201687eb167$var$isChar10;
                    this.getCode = this.getCode10;
                } else {
                    this.isChar = $4fddb201687eb167$var$isChar11;
                    this.getCode = this.getCode11;
                }
            /* eslint-enable @typescript-eslint/unbound-method */ }
        },
        {
            // STATE ENGINE METHODS
            // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
            // to be sure never to come back to this state later.
            key: "sBegin",
            value: function sBegin() {
                // We are essentially peeking at the first character of the chunk. Since
                // S_BEGIN can be in effect only when we start working on the first chunk,
                // the index at which we must look is necessarily 0. Note also that the
                // following test does not depend on decoding surrogates.
                // If the initial character is 0xFEFF, ignore it.
                if (this.chunk.charCodeAt(0) === 0xFEFF) {
                    this.i++;
                    this.column++;
                }
                this.state = $4fddb201687eb167$var$S_BEGIN_WHITESPACE;
            }
        },
        {
            key: "sBeginWhitespace",
            value: function sBeginWhitespace() {
                // We need to know whether we've encountered spaces or not because as soon
                // as we run into a space, an XML declaration is no longer possible. Rather
                // than slow down skipSpaces even in places where we don't care whether it
                // skipped anything or not, we check whether prevI is equal to the value of
                // i from before we skip spaces.
                var iBefore = this.i;
                var c = this.skipSpaces();
                if (this.prevI !== iBefore) this.xmlDeclPossible = false;
                switch(c){
                    case $4fddb201687eb167$var$LESS:
                        this.state = $4fddb201687eb167$var$S_OPEN_WAKA;
                        // We could naively call closeText but in this state, it is not normal
                        // to have text be filled with any data.
                        if (this.text.length !== 0) throw new Error("no-empty text at start");
                        break;
                    case $4fddb201687eb167$var$EOC:
                        break;
                    default:
                        this.unget();
                        this.state = $4fddb201687eb167$var$S_TEXT;
                        this.xmlDeclPossible = false;
                }
            }
        },
        {
            key: "sDoctype",
            value: function sDoctype() {
                var _a;
                var c = this.captureTo($4fddb201687eb167$var$DOCTYPE_TERMINATOR);
                switch(c){
                    case $4fddb201687eb167$var$GREATER:
                        (_a = this.doctypeHandler) === null || _a === void 0 || _a.call(this, this.text);
                        this.text = "";
                        this.state = $4fddb201687eb167$var$S_TEXT;
                        this.doctype = true; // just remember that we saw it.
                        break;
                    case $4fddb201687eb167$var$EOC:
                        break;
                    default:
                        this.text += String.fromCodePoint(c);
                        if (c === $4fddb201687eb167$var$OPEN_BRACKET) this.state = $4fddb201687eb167$var$S_DTD;
                        else if ($4fddb201687eb167$var$isQuote(c)) {
                            this.state = $4fddb201687eb167$var$S_DOCTYPE_QUOTE;
                            this.q = c;
                        }
                }
            }
        },
        {
            key: "sDoctypeQuote",
            value: function sDoctypeQuote() {
                var q = this.q;
                if (this.captureToChar(q)) {
                    this.text += String.fromCodePoint(q);
                    this.q = null;
                    this.state = $4fddb201687eb167$var$S_DOCTYPE;
                }
            }
        },
        {
            key: "sDTD",
            value: function sDTD() {
                var c = this.captureTo($4fddb201687eb167$var$DTD_TERMINATOR);
                if (c === $4fddb201687eb167$var$EOC) return;
                this.text += String.fromCodePoint(c);
                if (c === $4fddb201687eb167$var$CLOSE_BRACKET) this.state = $4fddb201687eb167$var$S_DOCTYPE;
                else if (c === $4fddb201687eb167$var$LESS) this.state = $4fddb201687eb167$var$S_DTD_OPEN_WAKA;
                else if ($4fddb201687eb167$var$isQuote(c)) {
                    this.state = $4fddb201687eb167$var$S_DTD_QUOTED;
                    this.q = c;
                }
            }
        },
        {
            key: "sDTDQuoted",
            value: function sDTDQuoted() {
                var q = this.q;
                if (this.captureToChar(q)) {
                    this.text += String.fromCodePoint(q);
                    this.state = $4fddb201687eb167$var$S_DTD;
                    this.q = null;
                }
            }
        },
        {
            key: "sDTDOpenWaka",
            value: function sDTDOpenWaka() {
                var c = this.getCodeNorm();
                this.text += String.fromCodePoint(c);
                switch(c){
                    case $4fddb201687eb167$var$BANG:
                        this.state = $4fddb201687eb167$var$S_DTD_OPEN_WAKA_BANG;
                        this.openWakaBang = "";
                        break;
                    case $4fddb201687eb167$var$QUESTION:
                        this.state = $4fddb201687eb167$var$S_DTD_PI;
                        break;
                    default:
                        this.state = $4fddb201687eb167$var$S_DTD;
                }
            }
        },
        {
            key: "sDTDOpenWakaBang",
            value: function sDTDOpenWakaBang() {
                var _char = String.fromCodePoint(this.getCodeNorm());
                var owb = this.openWakaBang += _char;
                this.text += _char;
                if (owb !== "-") {
                    this.state = owb === "--" ? $4fddb201687eb167$var$S_DTD_COMMENT : $4fddb201687eb167$var$S_DTD;
                    this.openWakaBang = "";
                }
            }
        },
        {
            key: "sDTDComment",
            value: function sDTDComment() {
                if (this.captureToChar($4fddb201687eb167$var$MINUS)) {
                    this.text += "-";
                    this.state = $4fddb201687eb167$var$S_DTD_COMMENT_ENDING;
                }
            }
        },
        {
            key: "sDTDCommentEnding",
            value: function sDTDCommentEnding() {
                var c = this.getCodeNorm();
                this.text += String.fromCodePoint(c);
                this.state = c === $4fddb201687eb167$var$MINUS ? $4fddb201687eb167$var$S_DTD_COMMENT_ENDED : $4fddb201687eb167$var$S_DTD_COMMENT;
            }
        },
        {
            key: "sDTDCommentEnded",
            value: function sDTDCommentEnded() {
                var c = this.getCodeNorm();
                this.text += String.fromCodePoint(c);
                if (c === $4fddb201687eb167$var$GREATER) this.state = $4fddb201687eb167$var$S_DTD;
                else {
                    this.fail("malformed comment.");
                    // <!-- blah -- bloo --> will be recorded as
                    // a comment of " blah -- bloo "
                    this.state = $4fddb201687eb167$var$S_DTD_COMMENT;
                }
            }
        },
        {
            key: "sDTDPI",
            value: function sDTDPI() {
                if (this.captureToChar($4fddb201687eb167$var$QUESTION)) {
                    this.text += "?";
                    this.state = $4fddb201687eb167$var$S_DTD_PI_ENDING;
                }
            }
        },
        {
            key: "sDTDPIEnding",
            value: function sDTDPIEnding() {
                var c = this.getCodeNorm();
                this.text += String.fromCodePoint(c);
                if (c === $4fddb201687eb167$var$GREATER) this.state = $4fddb201687eb167$var$S_DTD;
            }
        },
        {
            key: "sText",
            value: function sText() {
                //
                // We did try a version of saxes where the S_TEXT state was split in two
                // states: one for text inside the root element, and one for text
                // outside. This was avoiding having to test this.tags.length to decide
                // what implementation to actually use.
                //
                // Peformance testing on gigabyte-size files did not show any advantage to
                // using the two states solution instead of the current one. Conversely, it
                // made the code a bit more complicated elsewhere. For instance, a comment
                // can appear before the root element so when a comment ended it was
                // necessary to determine whether to return to the S_TEXT state or to the
                // new text-outside-root state.
                //
                if (this.tags.length !== 0) this.handleTextInRoot();
                else this.handleTextOutsideRoot();
            }
        },
        {
            key: "sEntity",
            value: function sEntity() {
                // This is essentially a specialized version of captureToChar(SEMICOLON...)
                var _this = this, start = _this.i;
                var chunk = this.chunk;
                // eslint-disable-next-line no-labels, no-restricted-syntax
                loop: // eslint-disable-next-line no-constant-condition
                while(true)switch(this.getCode()){
                    case $4fddb201687eb167$var$NL_LIKE:
                        this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
                        start = this.i;
                        break;
                    case $4fddb201687eb167$var$SEMICOLON:
                        {
                            var entityReturnState = this.entityReturnState;
                            var entity = this.entity + chunk.slice(start, this.prevI);
                            this.state = entityReturnState;
                            var parsed = void 0;
                            if (entity === "") {
                                this.fail("empty entity name.");
                                parsed = "&;";
                            } else {
                                parsed = this.parseEntity(entity);
                                this.entity = "";
                            }
                            if (entityReturnState !== $4fddb201687eb167$var$S_TEXT || this.textHandler !== undefined) this.text += parsed;
                            break loop;
                        }
                    case $4fddb201687eb167$var$EOC:
                        this.entity += chunk.slice(start);
                        break loop;
                    default:
                }
            }
        },
        {
            key: "sOpenWaka",
            value: function sOpenWaka() {
                // Reminder: a state handler is called with at least one character
                // available in the current chunk. So the first call to get code inside of
                // a state handler cannot return ``EOC``. That's why we don't test
                // for it.
                var c = this.getCode();
                // either a /, ?, !, or text is coming next.
                if ($4fddb201687eb167$var$isNameStartChar(c)) {
                    this.state = $4fddb201687eb167$var$S_OPEN_TAG;
                    this.unget();
                    this.xmlDeclPossible = false;
                } else switch(c){
                    case $4fddb201687eb167$var$FORWARD_SLASH:
                        this.state = $4fddb201687eb167$var$S_CLOSE_TAG;
                        this.xmlDeclPossible = false;
                        break;
                    case $4fddb201687eb167$var$BANG:
                        this.state = $4fddb201687eb167$var$S_OPEN_WAKA_BANG;
                        this.openWakaBang = "";
                        this.xmlDeclPossible = false;
                        break;
                    case $4fddb201687eb167$var$QUESTION:
                        this.state = $4fddb201687eb167$var$S_PI_FIRST_CHAR;
                        break;
                    default:
                        this.fail("disallowed character in tag name");
                        this.state = $4fddb201687eb167$var$S_TEXT;
                        this.xmlDeclPossible = false;
                }
            }
        },
        {
            key: "sOpenWakaBang",
            value: function sOpenWakaBang() {
                this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
                switch(this.openWakaBang){
                    case "[CDATA[":
                        if (!this.sawRoot && !this.reportedTextBeforeRoot) {
                            this.fail("text data outside of root node.");
                            this.reportedTextBeforeRoot = true;
                        }
                        if (this.closedRoot && !this.reportedTextAfterRoot) {
                            this.fail("text data outside of root node.");
                            this.reportedTextAfterRoot = true;
                        }
                        this.state = $4fddb201687eb167$var$S_CDATA;
                        this.openWakaBang = "";
                        break;
                    case "--":
                        this.state = $4fddb201687eb167$var$S_COMMENT;
                        this.openWakaBang = "";
                        break;
                    case "DOCTYPE":
                        this.state = $4fddb201687eb167$var$S_DOCTYPE;
                        if (this.doctype || this.sawRoot) this.fail("inappropriately located doctype declaration.");
                        this.openWakaBang = "";
                        break;
                    default:
                        // 7 happens to be the maximum length of the string that can possibly
                        // match one of the cases above.
                        if (this.openWakaBang.length >= 7) this.fail("incorrect syntax.");
                }
            }
        },
        {
            key: "sComment",
            value: function sComment() {
                if (this.captureToChar($4fddb201687eb167$var$MINUS)) this.state = $4fddb201687eb167$var$S_COMMENT_ENDING;
            }
        },
        {
            key: "sCommentEnding",
            value: function sCommentEnding() {
                var _a;
                var c = this.getCodeNorm();
                if (c === $4fddb201687eb167$var$MINUS) {
                    this.state = $4fddb201687eb167$var$S_COMMENT_ENDED;
                    (_a = this.commentHandler) === null || _a === void 0 || _a.call(this, this.text);
                    this.text = "";
                } else {
                    this.text += "-".concat(String.fromCodePoint(c));
                    this.state = $4fddb201687eb167$var$S_COMMENT;
                }
            }
        },
        {
            key: "sCommentEnded",
            value: function sCommentEnded() {
                var c = this.getCodeNorm();
                if (c !== $4fddb201687eb167$var$GREATER) {
                    this.fail("malformed comment.");
                    // <!-- blah -- bloo --> will be recorded as
                    // a comment of " blah -- bloo "
                    this.text += "--".concat(String.fromCodePoint(c));
                    this.state = $4fddb201687eb167$var$S_COMMENT;
                } else this.state = $4fddb201687eb167$var$S_TEXT;
            }
        },
        {
            key: "sCData",
            value: function sCData() {
                if (this.captureToChar($4fddb201687eb167$var$CLOSE_BRACKET)) this.state = $4fddb201687eb167$var$S_CDATA_ENDING;
            }
        },
        {
            key: "sCDataEnding",
            value: function sCDataEnding() {
                var c = this.getCodeNorm();
                if (c === $4fddb201687eb167$var$CLOSE_BRACKET) this.state = $4fddb201687eb167$var$S_CDATA_ENDING_2;
                else {
                    this.text += "]".concat(String.fromCodePoint(c));
                    this.state = $4fddb201687eb167$var$S_CDATA;
                }
            }
        },
        {
            key: "sCDataEnding2",
            value: function sCDataEnding2() {
                var _a;
                var c = this.getCodeNorm();
                switch(c){
                    case $4fddb201687eb167$var$GREATER:
                        (_a = this.cdataHandler) === null || _a === void 0 || _a.call(this, this.text);
                        this.text = "";
                        this.state = $4fddb201687eb167$var$S_TEXT;
                        break;
                    case $4fddb201687eb167$var$CLOSE_BRACKET:
                        this.text += "]";
                        break;
                    default:
                        this.text += "]]".concat(String.fromCodePoint(c));
                        this.state = $4fddb201687eb167$var$S_CDATA;
                }
            }
        },
        {
            // We need this separate state to check the first character fo the pi target
            // with this.nameStartCheck which allows less characters than this.nameCheck.
            key: "sPIFirstChar",
            value: function sPIFirstChar() {
                var c = this.getCodeNorm();
                // This is first because in the case where the file is well-formed this is
                // the branch taken. We optimize for well-formedness.
                if (this.nameStartCheck(c)) {
                    this.piTarget += String.fromCodePoint(c);
                    this.state = $4fddb201687eb167$var$S_PI_REST;
                } else if (c === $4fddb201687eb167$var$QUESTION || $4fddb201687eb167$var$isS(c)) {
                    this.fail("processing instruction without a target.");
                    this.state = c === $4fddb201687eb167$var$QUESTION ? $4fddb201687eb167$var$S_PI_ENDING : $4fddb201687eb167$var$S_PI_BODY;
                } else {
                    this.fail("disallowed character in processing instruction name.");
                    this.piTarget += String.fromCodePoint(c);
                    this.state = $4fddb201687eb167$var$S_PI_REST;
                }
            }
        },
        {
            key: "sPIRest",
            value: function sPIRest() {
                // Capture characters into a piTarget while ``this.nameCheck`` run on the
                // character read returns true.
                var _this = this, chunk = _this.chunk, start = _this.i;
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var c = this.getCodeNorm();
                    if (c === $4fddb201687eb167$var$EOC) {
                        this.piTarget += chunk.slice(start);
                        return;
                    }
                    // NL cannot satisfy this.nameCheck so we don't have to test specifically
                    // for it.
                    if (!this.nameCheck(c)) {
                        this.piTarget += chunk.slice(start, this.prevI);
                        var isQuestion = c === $4fddb201687eb167$var$QUESTION;
                        if (isQuestion || $4fddb201687eb167$var$isS(c)) {
                            if (this.piTarget === "xml") {
                                if (!this.xmlDeclPossible) this.fail("an XML declaration must be at the start of the document.");
                                this.state = isQuestion ? $4fddb201687eb167$var$S_XML_DECL_ENDING : $4fddb201687eb167$var$S_XML_DECL_NAME_START;
                            } else this.state = isQuestion ? $4fddb201687eb167$var$S_PI_ENDING : $4fddb201687eb167$var$S_PI_BODY;
                        } else {
                            this.fail("disallowed character in processing instruction name.");
                            this.piTarget += String.fromCodePoint(c);
                        }
                        break;
                    }
                }
            }
        },
        {
            key: "sPIBody",
            value: function sPIBody() {
                if (this.text.length === 0) {
                    var c = this.getCodeNorm();
                    if (c === $4fddb201687eb167$var$QUESTION) this.state = $4fddb201687eb167$var$S_PI_ENDING;
                    else if (!$4fddb201687eb167$var$isS(c)) this.text = String.fromCodePoint(c);
                } else if (this.captureToChar($4fddb201687eb167$var$QUESTION)) this.state = $4fddb201687eb167$var$S_PI_ENDING;
            }
        },
        {
            key: "sPIEnding",
            value: function sPIEnding() {
                var _a;
                var c = this.getCodeNorm();
                if (c === $4fddb201687eb167$var$GREATER) {
                    var piTarget = this.piTarget;
                    if (piTarget.toLowerCase() === "xml") this.fail("the XML declaration must appear at the start of the document.");
                    (_a = this.piHandler) === null || _a === void 0 || _a.call(this, {
                        target: piTarget,
                        body: this.text
                    });
                    this.piTarget = this.text = "";
                    this.state = $4fddb201687eb167$var$S_TEXT;
                } else if (c === $4fddb201687eb167$var$QUESTION) // We ran into ?? as part of a processing instruction. We initially took
                // the first ? as a sign that the PI was ending, but it is not. So we have
                // to add it to the body but we take the new ? as a sign that the PI is
                // ending.
                this.text += "?";
                else {
                    this.text += "?".concat(String.fromCodePoint(c));
                    this.state = $4fddb201687eb167$var$S_PI_BODY;
                }
                this.xmlDeclPossible = false;
            }
        },
        {
            key: "sXMLDeclNameStart",
            value: function sXMLDeclNameStart() {
                var c = this.skipSpaces();
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    // It is valid to go to S_XML_DECL_ENDING from this state.
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    return;
                }
                if (c !== $4fddb201687eb167$var$EOC) {
                    this.state = $4fddb201687eb167$var$S_XML_DECL_NAME;
                    this.name = String.fromCodePoint(c);
                }
            }
        },
        {
            key: "sXMLDeclName",
            value: function sXMLDeclName() {
                var c = this.captureTo($4fddb201687eb167$var$XML_DECL_NAME_TERMINATOR);
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    this.name += this.text;
                    this.text = "";
                    this.fail("XML declaration is incomplete.");
                    return;
                }
                if (!($4fddb201687eb167$var$isS(c) || c === $4fddb201687eb167$var$EQUAL)) return;
                this.name += this.text;
                this.text = "";
                if (!this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                    case 0:
                        this.fail("did not expect any more name/value pairs.");
                        break;
                    case 1:
                        this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
                        break;
                    default:
                        this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
                }
                this.state = c === $4fddb201687eb167$var$EQUAL ? $4fddb201687eb167$var$S_XML_DECL_VALUE_START : $4fddb201687eb167$var$S_XML_DECL_EQ;
            }
        },
        {
            key: "sXMLDeclEq",
            value: function sXMLDeclEq() {
                var c = this.getCodeNorm();
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    this.fail("XML declaration is incomplete.");
                    return;
                }
                if ($4fddb201687eb167$var$isS(c)) return;
                if (c !== $4fddb201687eb167$var$EQUAL) this.fail("value required.");
                this.state = $4fddb201687eb167$var$S_XML_DECL_VALUE_START;
            }
        },
        {
            key: "sXMLDeclValueStart",
            value: function sXMLDeclValueStart() {
                var c = this.getCodeNorm();
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    this.fail("XML declaration is incomplete.");
                    return;
                }
                if ($4fddb201687eb167$var$isS(c)) return;
                if (!$4fddb201687eb167$var$isQuote(c)) {
                    this.fail("value must be quoted.");
                    this.q = $4fddb201687eb167$var$SPACE;
                } else this.q = c;
                this.state = $4fddb201687eb167$var$S_XML_DECL_VALUE;
            }
        },
        {
            key: "sXMLDeclValue",
            value: function sXMLDeclValue() {
                var c = this.captureTo([
                    this.q,
                    $4fddb201687eb167$var$QUESTION
                ]);
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    this.text = "";
                    this.fail("XML declaration is incomplete.");
                    return;
                }
                if (c === $4fddb201687eb167$var$EOC) return;
                var value = this.text;
                this.text = "";
                switch(this.name){
                    case "version":
                        {
                            this.xmlDeclExpects = [
                                "encoding",
                                "standalone"
                            ];
                            var version = value;
                            this.xmlDecl.version = version;
                            // This is the test specified by XML 1.0 but it is fine for XML 1.1.
                            if (!/^1\.[0-9]+$/.test(version)) this.fail("version number must match /^1\\.[0-9]+$/.");
                            else if (!this.opt.forceXMLVersion) this.setXMLVersion(version);
                            break;
                        }
                    case "encoding":
                        if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
                        this.xmlDeclExpects = [
                            "standalone"
                        ];
                        this.xmlDecl.encoding = value;
                        break;
                    case "standalone":
                        if (value !== "yes" && value !== "no") this.fail("standalone value must match \"yes\" or \"no\".");
                        this.xmlDeclExpects = [];
                        this.xmlDecl.standalone = value;
                        break;
                    default:
                }
                this.name = "";
                this.state = $4fddb201687eb167$var$S_XML_DECL_SEPARATOR;
            }
        },
        {
            key: "sXMLDeclSeparator",
            value: function sXMLDeclSeparator() {
                var c = this.getCodeNorm();
                // The question mark character is not valid inside any of the XML
                // declaration name/value pairs.
                if (c === $4fddb201687eb167$var$QUESTION) {
                    // It is valid to go to S_XML_DECL_ENDING from this state.
                    this.state = $4fddb201687eb167$var$S_XML_DECL_ENDING;
                    return;
                }
                if (!$4fddb201687eb167$var$isS(c)) {
                    this.fail("whitespace required.");
                    this.unget();
                }
                this.state = $4fddb201687eb167$var$S_XML_DECL_NAME_START;
            }
        },
        {
            key: "sXMLDeclEnding",
            value: function sXMLDeclEnding() {
                var _a;
                var c = this.getCodeNorm();
                if (c === $4fddb201687eb167$var$GREATER) {
                    if (this.piTarget !== "xml") this.fail("processing instructions are not allowed before root.");
                    else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) this.fail("XML declaration must contain a version.");
                    (_a = this.xmldeclHandler) === null || _a === void 0 || _a.call(this, this.xmlDecl);
                    this.name = "";
                    this.piTarget = this.text = "";
                    this.state = $4fddb201687eb167$var$S_TEXT;
                } else // We got here because the previous character was a ?, but the question
                // mark character is not valid inside any of the XML declaration
                // name/value pairs.
                this.fail("The character ? is disallowed anywhere in XML declarations.");
                this.xmlDeclPossible = false;
            }
        },
        {
            key: "sOpenTag",
            value: function sOpenTag() {
                var _a;
                var c = this.captureNameChars();
                if (c === $4fddb201687eb167$var$EOC) return;
                var tag = this.tag = {
                    name: this.name,
                    attributes: Object.create(null)
                };
                this.name = "";
                if (this.xmlnsOpt) this.topNS = tag.ns = Object.create(null);
                (_a = this.openTagStartHandler) === null || _a === void 0 || _a.call(this, tag);
                this.sawRoot = true;
                if (!this.fragmentOpt && this.closedRoot) this.fail("documents may contain only one root.");
                switch(c){
                    case $4fddb201687eb167$var$GREATER:
                        this.openTag();
                        break;
                    case $4fddb201687eb167$var$FORWARD_SLASH:
                        this.state = $4fddb201687eb167$var$S_OPEN_TAG_SLASH;
                        break;
                    default:
                        if (!$4fddb201687eb167$var$isS(c)) this.fail("disallowed character in tag name.");
                        this.state = $4fddb201687eb167$var$S_ATTRIB;
                }
            }
        },
        {
            key: "sOpenTagSlash",
            value: function sOpenTagSlash() {
                if (this.getCode() === $4fddb201687eb167$var$GREATER) this.openSelfClosingTag();
                else {
                    this.fail("forward-slash in opening tag not followed by >.");
                    this.state = $4fddb201687eb167$var$S_ATTRIB;
                }
            }
        },
        {
            key: "sAttrib",
            value: function sAttrib() {
                var c = this.skipSpaces();
                if (c === $4fddb201687eb167$var$EOC) return;
                if ($4fddb201687eb167$var$isNameStartChar(c)) {
                    this.unget();
                    this.state = $4fddb201687eb167$var$S_ATTRIB_NAME;
                } else if (c === $4fddb201687eb167$var$GREATER) this.openTag();
                else if (c === $4fddb201687eb167$var$FORWARD_SLASH) this.state = $4fddb201687eb167$var$S_OPEN_TAG_SLASH;
                else this.fail("disallowed character in attribute name.");
            }
        },
        {
            key: "sAttribName",
            value: function sAttribName() {
                var c = this.captureNameChars();
                if (c === $4fddb201687eb167$var$EQUAL) this.state = $4fddb201687eb167$var$S_ATTRIB_VALUE;
                else if ($4fddb201687eb167$var$isS(c)) this.state = $4fddb201687eb167$var$S_ATTRIB_NAME_SAW_WHITE;
                else if (c === $4fddb201687eb167$var$GREATER) {
                    this.fail("attribute without value.");
                    this.pushAttrib(this.name, this.name);
                    this.name = this.text = "";
                    this.openTag();
                } else if (c !== $4fddb201687eb167$var$EOC) this.fail("disallowed character in attribute name.");
            }
        },
        {
            key: "sAttribNameSawWhite",
            value: function sAttribNameSawWhite() {
                var c = this.skipSpaces();
                switch(c){
                    case $4fddb201687eb167$var$EOC:
                        return;
                    case $4fddb201687eb167$var$EQUAL:
                        this.state = $4fddb201687eb167$var$S_ATTRIB_VALUE;
                        break;
                    default:
                        this.fail("attribute without value.");
                        // Should we do this???
                        // this.tag.attributes[this.name] = "";
                        this.text = "";
                        this.name = "";
                        if (c === $4fddb201687eb167$var$GREATER) this.openTag();
                        else if ($4fddb201687eb167$var$isNameStartChar(c)) {
                            this.unget();
                            this.state = $4fddb201687eb167$var$S_ATTRIB_NAME;
                        } else {
                            this.fail("disallowed character in attribute name.");
                            this.state = $4fddb201687eb167$var$S_ATTRIB;
                        }
                }
            }
        },
        {
            key: "sAttribValue",
            value: function sAttribValue() {
                var c = this.getCodeNorm();
                if ($4fddb201687eb167$var$isQuote(c)) {
                    this.q = c;
                    this.state = $4fddb201687eb167$var$S_ATTRIB_VALUE_QUOTED;
                } else if (!$4fddb201687eb167$var$isS(c)) {
                    this.fail("unquoted attribute value.");
                    this.state = $4fddb201687eb167$var$S_ATTRIB_VALUE_UNQUOTED;
                    this.unget();
                }
            }
        },
        {
            key: "sAttribValueQuoted",
            value: function sAttribValueQuoted() {
                // We deliberately do not use captureTo here. The specialized code we use
                // here is faster than using captureTo.
                var _this = this, q = _this.q, chunk = _this.chunk;
                var _this1 = this, start = _this1.i;
                // eslint-disable-next-line no-constant-condition
                while(true)switch(this.getCode()){
                    case q:
                        this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
                        this.name = this.text = "";
                        this.q = null;
                        this.state = $4fddb201687eb167$var$S_ATTRIB_VALUE_CLOSED;
                        return;
                    case $4fddb201687eb167$var$AMP:
                        this.text += chunk.slice(start, this.prevI);
                        this.state = $4fddb201687eb167$var$S_ENTITY;
                        this.entityReturnState = $4fddb201687eb167$var$S_ATTRIB_VALUE_QUOTED;
                        return;
                    case $4fddb201687eb167$var$NL:
                    case $4fddb201687eb167$var$NL_LIKE:
                    case $4fddb201687eb167$var$TAB:
                        this.text += "".concat(chunk.slice(start, this.prevI), " ");
                        start = this.i;
                        break;
                    case $4fddb201687eb167$var$LESS:
                        this.text += chunk.slice(start, this.prevI);
                        this.fail("disallowed character.");
                        return;
                    case $4fddb201687eb167$var$EOC:
                        this.text += chunk.slice(start);
                        return;
                    default:
                }
            }
        },
        {
            key: "sAttribValueClosed",
            value: function sAttribValueClosed() {
                var c = this.getCodeNorm();
                if ($4fddb201687eb167$var$isS(c)) this.state = $4fddb201687eb167$var$S_ATTRIB;
                else if (c === $4fddb201687eb167$var$GREATER) this.openTag();
                else if (c === $4fddb201687eb167$var$FORWARD_SLASH) this.state = $4fddb201687eb167$var$S_OPEN_TAG_SLASH;
                else if ($4fddb201687eb167$var$isNameStartChar(c)) {
                    this.fail("no whitespace between attributes.");
                    this.unget();
                    this.state = $4fddb201687eb167$var$S_ATTRIB_NAME;
                } else this.fail("disallowed character in attribute name.");
            }
        },
        {
            key: "sAttribValueUnquoted",
            value: function sAttribValueUnquoted() {
                // We don't do anything regarding EOL or space handling for unquoted
                // attributes. We already have failed by the time we get here, and the
                // contract that saxes upholds states that upon failure, it is not safe to
                // rely on the data passed to event handlers (other than
                // ``onerror``). Passing "bad" data is not a problem.
                var c = this.captureTo($4fddb201687eb167$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR);
                switch(c){
                    case $4fddb201687eb167$var$AMP:
                        this.state = $4fddb201687eb167$var$S_ENTITY;
                        this.entityReturnState = $4fddb201687eb167$var$S_ATTRIB_VALUE_UNQUOTED;
                        break;
                    case $4fddb201687eb167$var$LESS:
                        this.fail("disallowed character.");
                        break;
                    case $4fddb201687eb167$var$EOC:
                        break;
                    default:
                        if (this.text.includes("]]>")) this.fail("the string \"]]>\" is disallowed in char data.");
                        this.pushAttrib(this.name, this.text);
                        this.name = this.text = "";
                        if (c === $4fddb201687eb167$var$GREATER) this.openTag();
                        else this.state = $4fddb201687eb167$var$S_ATTRIB;
                }
            }
        },
        {
            key: "sCloseTag",
            value: function sCloseTag() {
                var c = this.captureNameChars();
                if (c === $4fddb201687eb167$var$GREATER) this.closeTag();
                else if ($4fddb201687eb167$var$isS(c)) this.state = $4fddb201687eb167$var$S_CLOSE_TAG_SAW_WHITE;
                else if (c !== $4fddb201687eb167$var$EOC) this.fail("disallowed character in closing tag.");
            }
        },
        {
            key: "sCloseTagSawWhite",
            value: function sCloseTagSawWhite() {
                switch(this.skipSpaces()){
                    case $4fddb201687eb167$var$GREATER:
                        this.closeTag();
                        break;
                    case $4fddb201687eb167$var$EOC:
                        break;
                    default:
                        this.fail("disallowed character in closing tag.");
                }
            }
        },
        {
            // END OF STATE ENGINE METHODS
            key: "handleTextInRoot",
            value: function handleTextInRoot() {
                // This is essentially a specialized version of captureTo which is optimized
                // for performing the ]]> check. A previous version of this code, checked
                // ``this.text`` for the presence of ]]>. It simplified the code but was
                // very costly when character data contained a lot of entities to be parsed.
                //
                // Since we are using a specialized loop, we also keep track of the presence
                // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
                //
                var _this = this, start = _this.i, forbiddenState = _this.forbiddenState;
                var _this1 = this, chunk = _this1.chunk, handler = _this1.textHandler;
                // eslint-disable-next-line no-labels, no-restricted-syntax
                scanLoop: // eslint-disable-next-line no-constant-condition
                while(true)switch(this.getCode()){
                    case $4fddb201687eb167$var$LESS:
                        this.state = $4fddb201687eb167$var$S_OPEN_WAKA;
                        if (handler !== undefined) {
                            var text = this.text;
                            var slice = chunk.slice(start, this.prevI);
                            if (text.length !== 0) {
                                handler(text + slice);
                                this.text = "";
                            } else if (slice.length !== 0) handler(slice);
                        }
                        forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                        break scanLoop;
                    case $4fddb201687eb167$var$AMP:
                        this.state = $4fddb201687eb167$var$S_ENTITY;
                        this.entityReturnState = $4fddb201687eb167$var$S_TEXT;
                        if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                        forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                        break scanLoop;
                    case $4fddb201687eb167$var$CLOSE_BRACKET:
                        switch(forbiddenState){
                            case $4fddb201687eb167$var$FORBIDDEN_START:
                                forbiddenState = $4fddb201687eb167$var$FORBIDDEN_BRACKET;
                                break;
                            case $4fddb201687eb167$var$FORBIDDEN_BRACKET:
                                forbiddenState = $4fddb201687eb167$var$FORBIDDEN_BRACKET_BRACKET;
                                break;
                            case $4fddb201687eb167$var$FORBIDDEN_BRACKET_BRACKET:
                                break;
                            default:
                                throw new Error("impossible state");
                        }
                        break;
                    case $4fddb201687eb167$var$GREATER:
                        if (forbiddenState === $4fddb201687eb167$var$FORBIDDEN_BRACKET_BRACKET) this.fail("the string \"]]>\" is disallowed in char data.");
                        forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                        break;
                    case $4fddb201687eb167$var$NL_LIKE:
                        if (handler !== undefined) this.text += "".concat(chunk.slice(start, this.prevI), "\n");
                        start = this.i;
                        forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                        break;
                    case $4fddb201687eb167$var$EOC:
                        if (handler !== undefined) this.text += chunk.slice(start);
                        break scanLoop;
                    default:
                        forbiddenState = $4fddb201687eb167$var$FORBIDDEN_START;
                }
                this.forbiddenState = forbiddenState;
            }
        },
        {
            key: "handleTextOutsideRoot",
            value: function handleTextOutsideRoot() {
                // This is essentially a specialized version of captureTo which is optimized
                // for a specialized task. We keep track of the presence of non-space
                // characters in the text since these are errors when appearing outside the
                // document root element.
                var _this = this, start = _this.i;
                var _this1 = this, chunk = _this1.chunk, handler = _this1.textHandler;
                var nonSpace = false;
                // eslint-disable-next-line no-labels, no-restricted-syntax
                outRootLoop: // eslint-disable-next-line no-constant-condition
                while(true){
                    var code = this.getCode();
                    switch(code){
                        case $4fddb201687eb167$var$LESS:
                            this.state = $4fddb201687eb167$var$S_OPEN_WAKA;
                            if (handler !== undefined) {
                                var text = this.text;
                                var slice = chunk.slice(start, this.prevI);
                                if (text.length !== 0) {
                                    handler(text + slice);
                                    this.text = "";
                                } else if (slice.length !== 0) handler(slice);
                            }
                            break outRootLoop;
                        case $4fddb201687eb167$var$AMP:
                            this.state = $4fddb201687eb167$var$S_ENTITY;
                            this.entityReturnState = $4fddb201687eb167$var$S_TEXT;
                            if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                            nonSpace = true;
                            break outRootLoop;
                        case $4fddb201687eb167$var$NL_LIKE:
                            if (handler !== undefined) this.text += "".concat(chunk.slice(start, this.prevI), "\n");
                            start = this.i;
                            break;
                        case $4fddb201687eb167$var$EOC:
                            if (handler !== undefined) this.text += chunk.slice(start);
                            break outRootLoop;
                        default:
                            if (!$4fddb201687eb167$var$isS(code)) nonSpace = true;
                    }
                }
                if (!nonSpace) return;
                // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
                // to avoid reporting errors for every single character that is out of
                // place.
                if (!this.sawRoot && !this.reportedTextBeforeRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextBeforeRoot = true;
                }
                if (this.closedRoot && !this.reportedTextAfterRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextAfterRoot = true;
                }
            }
        },
        {
            key: "pushAttribNS",
            value: function pushAttribNS(name, value) {
                var _a;
                var _this_qname = this.qname(name), prefix = _this_qname.prefix, local = _this_qname.local;
                var attr = {
                    name: name,
                    prefix: prefix,
                    local: local,
                    value: value
                };
                this.attribList.push(attr);
                (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
                if (prefix === "xmlns") {
                    var trimmed = value.trim();
                    if (this.currentXMLVersion === "1.0" && trimmed === "") this.fail("invalid attempt to undefine prefix in XML 1.0");
                    this.topNS[local] = trimmed;
                    $4fddb201687eb167$var$nsPairCheck(this, local, trimmed);
                } else if (name === "xmlns") {
                    var trimmed1 = value.trim();
                    this.topNS[""] = trimmed1;
                    $4fddb201687eb167$var$nsPairCheck(this, "", trimmed1);
                }
            }
        },
        {
            key: "pushAttribPlain",
            value: function pushAttribPlain(name, value) {
                var _a;
                var attr = {
                    name: name,
                    value: value
                };
                this.attribList.push(attr);
                (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
            }
        },
        {
            /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */ key: "end",
            value: function end() {
                var _a, _b;
                if (!this.sawRoot) this.fail("document must contain a root element.");
                var tags = this.tags;
                while(tags.length > 0){
                    var tag = tags.pop();
                    this.fail("unclosed tag: ".concat(tag.name));
                }
                if (this.state !== $4fddb201687eb167$var$S_BEGIN && this.state !== $4fddb201687eb167$var$S_TEXT) this.fail("unexpected end.");
                var text = this.text;
                if (text.length !== 0) {
                    (_a = this.textHandler) === null || _a === void 0 || _a.call(this, text);
                    this.text = "";
                }
                this._closed = true;
                (_b = this.endHandler) === null || _b === void 0 || _b.call(this);
                this._init();
                return this;
            }
        },
        {
            /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */ key: "resolve",
            value: function resolve(prefix) {
                var _a, _b;
                var uri = this.topNS[prefix];
                if (uri !== undefined) return uri;
                var tags = this.tags;
                for(var index = tags.length - 1; index >= 0; index--){
                    uri = tags[index].ns[prefix];
                    if (uri !== undefined) return uri;
                }
                uri = this.ns[prefix];
                if (uri !== undefined) return uri;
                return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
            }
        },
        {
            /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */ key: "qname",
            value: function qname(name) {
                // This is faster than using name.split(":").
                var colon = name.indexOf(":");
                if (colon === -1) return {
                    prefix: "",
                    local: name
                };
                var local = name.slice(colon + 1);
                var prefix = name.slice(0, colon);
                if (prefix === "" || local === "" || local.includes(":")) this.fail("malformed name: ".concat(name, "."));
                return {
                    prefix: prefix,
                    local: local
                };
            }
        },
        {
            key: "processAttribsNS",
            value: function processAttribsNS() {
                var _a;
                var attribList = this.attribList;
                var tag = this.tag;
                {
                    // add namespace info to tag
                    var _this_qname = this.qname(tag.name), prefix = _this_qname.prefix, local = _this_qname.local;
                    tag.prefix = prefix;
                    tag.local = local;
                    var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
                    if (prefix !== "") {
                        if (prefix === "xmlns") this.fail("tags may not have \"xmlns\" as prefix.");
                        if (uri === "") {
                            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
                            tag.uri = prefix;
                        }
                    }
                }
                if (attribList.length === 0) return;
                var attributes = tag.attributes;
                var seen = new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Note: do not apply default ns to attributes:
                    //   http://www.w3.org/TR/REC-xml-names/#defaulting
                    for(var _iterator = attribList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attr = _step.value;
                        var name = attr.name, prefix1 = attr.prefix, local1 = attr.local;
                        var uri1 = void 0;
                        var eqname = void 0;
                        if (prefix1 === "") {
                            uri1 = name === "xmlns" ? $4fddb201687eb167$var$XMLNS_NAMESPACE : "";
                            eqname = name;
                        } else {
                            uri1 = this.resolve(prefix1);
                            // if there's any attributes with an undefined namespace,
                            // then fail on them now.
                            if (uri1 === undefined) {
                                this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix1), "."));
                                uri1 = prefix1;
                            }
                            eqname = "{".concat(uri1, "}").concat(local1);
                        }
                        if (seen.has(eqname)) this.fail("duplicate attribute: ".concat(eqname, "."));
                        seen.add(eqname);
                        attr.uri = uri1;
                        attributes[name] = attr;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.attribList = [];
            }
        },
        {
            key: "processAttribsPlain",
            value: function processAttribsPlain() {
                var attribList = this.attribList;
                // eslint-disable-next-line prefer-destructuring
                var attributes = this.tag.attributes;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = attribList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        if (attributes[name] !== undefined) this.fail("duplicate attribute: ".concat(name, "."));
                        attributes[name] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.attribList = [];
            }
        },
        {
            /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */ key: "openTag",
            value: function openTag() {
                var _a;
                this.processAttribs();
                var tags = this.tags;
                var tag = this.tag;
                tag.isSelfClosing = false;
                // There cannot be any pending text here due to the onopentagstart that was
                // necessarily emitted before we get here. So we do not check text.
                (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
                tags.push(tag);
                this.state = $4fddb201687eb167$var$S_TEXT;
                this.name = "";
            }
        },
        {
            /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */ key: "openSelfClosingTag",
            value: function openSelfClosingTag() {
                var _a, _b, _c;
                this.processAttribs();
                var tags = this.tags;
                var tag = this.tag;
                tag.isSelfClosing = true;
                // There cannot be any pending text here due to the onopentagstart that was
                // necessarily emitted before we get here. So we do not check text.
                (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
                (_b = this.closeTagHandler) === null || _b === void 0 || _b.call(this, tag);
                var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
                if (top === null) this.closedRoot = true;
                this.state = $4fddb201687eb167$var$S_TEXT;
                this.name = "";
            }
        },
        {
            /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */ key: "closeTag",
            value: function closeTag() {
                var _this = this, tags = _this.tags, name = _this.name;
                // Our state after this will be S_TEXT, no matter what, and we can clear
                // tagName now.
                this.state = $4fddb201687eb167$var$S_TEXT;
                this.name = "";
                if (name === "") {
                    this.fail("weird empty close tag.");
                    this.text += "</>";
                    return;
                }
                var handler = this.closeTagHandler;
                var l = tags.length;
                while(l-- > 0){
                    var tag = this.tag = tags.pop();
                    this.topNS = tag.ns;
                    handler === null || handler === void 0 || handler(tag);
                    if (tag.name === name) break;
                    this.fail("unexpected close tag.");
                }
                if (l === 0) this.closedRoot = true;
                else if (l < 0) {
                    this.fail("unmatched closing tag: ".concat(name, "."));
                    this.text += "</".concat(name, ">");
                }
            }
        },
        {
            /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */ key: "parseEntity",
            value: function parseEntity(entity) {
                // startsWith would be significantly slower for this test.
                if (entity[0] !== "#") {
                    var defined = this.ENTITIES[entity];
                    if (defined !== undefined) return defined;
                    this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
                    return "&".concat(entity, ";");
                }
                var num = NaN;
                if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) num = parseInt(entity.slice(2), 16);
                else if (/^#[0-9]+$/.test(entity)) num = parseInt(entity.slice(1), 10);
                // The character reference is required to match the CHAR production.
                if (!this.isChar(num)) {
                    this.fail("malformed character entity.");
                    return "&".concat(entity, ";");
                }
                return String.fromCodePoint(num);
            }
        }
    ]);
    return SaxesParser;
}();
module.exports.SaxesParser = $4fddb201687eb167$var$SaxesParser;

});
parcelRegister("9VQvW", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "\t\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $73b22c22a0955de4$var$TAB = 9;
var $73b22c22a0955de4$var$NL = 0xA;
var $73b22c22a0955de4$var$CR = 0xD;
var $73b22c22a0955de4$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $73b22c22a0955de4$var$SPACE,
    $73b22c22a0955de4$var$NL,
    $73b22c22a0955de4$var$CR,
    $73b22c22a0955de4$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $73b22c22a0955de4$var$isChar(c) {
    return c >= $73b22c22a0955de4$var$SPACE && c <= 0xD7FF || c === $73b22c22a0955de4$var$NL || c === $73b22c22a0955de4$var$CR || c === $73b22c22a0955de4$var$TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $73b22c22a0955de4$var$isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $73b22c22a0955de4$var$isS(c) {
    return c === $73b22c22a0955de4$var$SPACE || c === $73b22c22a0955de4$var$NL || c === $73b22c22a0955de4$var$CR || c === $73b22c22a0955de4$var$TAB;
}
module.exports.isS = $73b22c22a0955de4$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ function $73b22c22a0955de4$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $73b22c22a0955de4$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $73b22c22a0955de4$var$isNameChar(c) {
    return $73b22c22a0955de4$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $73b22c22a0955de4$var$isNameChar;

});

parcelRegister("ify35", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "\u0001-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.RESTRICTED_CHAR = "\u0001-\u0008\u000B\u000C\u000E-\u001F\u007F-\u0084\u0086-\u009F";
module.exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.RESTRICTED_CHAR_RE = new RegExp("^[" + module.exports.RESTRICTED_CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $d4940a1c44198359$var$TAB = 9;
var $d4940a1c44198359$var$NL = 0xA;
var $d4940a1c44198359$var$CR = 0xD;
var $d4940a1c44198359$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $d4940a1c44198359$var$SPACE,
    $d4940a1c44198359$var$NL,
    $d4940a1c44198359$var$CR,
    $d4940a1c44198359$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $d4940a1c44198359$var$isChar(c) {
    return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $d4940a1c44198359$var$isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */ function $d4940a1c44198359$var$isRestrictedChar(c) {
    return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}
module.exports.isRestrictedChar = $d4940a1c44198359$var$isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */ function $d4940a1c44198359$var$isCharAndNotRestricted(c) {
    return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isCharAndNotRestricted = $d4940a1c44198359$var$isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $d4940a1c44198359$var$isS(c) {
    return c === $d4940a1c44198359$var$SPACE || c === $d4940a1c44198359$var$NL || c === $d4940a1c44198359$var$CR || c === $d4940a1c44198359$var$TAB;
}
module.exports.isS = $d4940a1c44198359$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $d4940a1c44198359$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $d4940a1c44198359$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $d4940a1c44198359$var$isNameChar(c) {
    return $d4940a1c44198359$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $d4940a1c44198359$var$isNameChar;

});

parcelRegister("j77V9", function(module, exports) {
"use strict";
/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
// tslint:disable-next-line:max-line-length
module.exports.NC_NAME_START_CHAR = "A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NC_NAME_CHAR = "-" + module.exports.NC_NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "]$", "u");
module.exports.NC_NAME_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_CHAR + "]$", "u");
module.exports.NC_NAME_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "][" + module.exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $dea4d0abbfd04f88$var$isNCNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNCNameStartChar = $dea4d0abbfd04f88$var$isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ function $dea4d0abbfd04f88$var$isNCNameChar(c) {
    return $dea4d0abbfd04f88$var$isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNCNameChar = $dea4d0abbfd04f88$var$isNCNameChar;

});


parcelRegister("8drNf", function(module, exports) {
'use strict';

var $j1Kf1 = parcelRequire("j1Kf1");

var $f0bPU = parcelRequire("f0bPU");
var $5fb518cb57075ae2$var$originalDestroy = $j1Kf1.Readable.destroy;
module.exports = $j1Kf1.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $j1Kf1._uint8ArrayToBuffer;
module.exports._isUint8Array = $j1Kf1._isUint8Array;
module.exports.isDisturbed = $j1Kf1.isDisturbed;
module.exports.isErrored = $j1Kf1.isErrored;
module.exports.isReadable = $j1Kf1.isReadable;
module.exports.Readable = $j1Kf1.Readable;
module.exports.Writable = $j1Kf1.Writable;
module.exports.Duplex = $j1Kf1.Duplex;
module.exports.Transform = $j1Kf1.Transform;
module.exports.PassThrough = $j1Kf1.PassThrough;
module.exports.addAbortSignal = $j1Kf1.addAbortSignal;
module.exports.finished = $j1Kf1.finished;
module.exports.destroy = $j1Kf1.destroy;
module.exports.destroy = $5fb518cb57075ae2$var$originalDestroy;
module.exports.pipeline = $j1Kf1.pipeline;
module.exports.compose = $j1Kf1.compose;
Object.defineProperty($j1Kf1, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $f0bPU;
    }
});
module.exports.Stream = $j1Kf1.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("j1Kf1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $eIVzI = parcelRequire("eIVzI");
var $dda1fae23a8c7808$require$Buffer = $eIVzI.Buffer;

var $gPFMe = parcelRequire("gPFMe");
/* replacement end */ var $dda1fae23a8c7808$var$ObjectDefineProperty = $gPFMe.ObjectDefineProperty, $dda1fae23a8c7808$var$ObjectKeys = $gPFMe.ObjectKeys, $dda1fae23a8c7808$var$ReflectApply = $gPFMe.ReflectApply;

var $ivGzv = parcelRequire("ivGzv");
var $dda1fae23a8c7808$var$_require_promisify = $ivGzv.promisify, $dda1fae23a8c7808$var$customPromisify = $dda1fae23a8c7808$var$_require_promisify.custom;

var $6GWnb = parcelRequire("6GWnb");
var $dda1fae23a8c7808$var$streamReturningOperators = $6GWnb.streamReturningOperators, $dda1fae23a8c7808$var$promiseReturningOperators = $6GWnb.promiseReturningOperators;

var $gDydr = parcelRequire("gDydr");
var $dda1fae23a8c7808$var$ERR_ILLEGAL_CONSTRUCTOR = $gDydr.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $3J29d = parcelRequire("3J29d");

var $iAzvv = parcelRequire("iAzvv");
var $dda1fae23a8c7808$var$setDefaultHighWaterMark = $iAzvv.setDefaultHighWaterMark, $dda1fae23a8c7808$var$getDefaultHighWaterMark = $iAzvv.getDefaultHighWaterMark;

var $khkUM = parcelRequire("khkUM");
var $dda1fae23a8c7808$require$pipeline = $khkUM.pipeline;

var $irwcz = parcelRequire("irwcz");
var $dda1fae23a8c7808$require$destroyer = $irwcz.destroyer;

var $vZAIl = parcelRequire("vZAIl");
var $dda1fae23a8c7808$var$internalBuffer = {};

var $f0bPU = parcelRequire("f0bPU");

var $65HYg = parcelRequire("65HYg");

var $dda1fae23a8c7808$var$Stream = module.exports = (parcelRequire("daBj0")).Stream;
$dda1fae23a8c7808$var$Stream.isDestroyed = $65HYg.isDestroyed;
$dda1fae23a8c7808$var$Stream.isDisturbed = $65HYg.isDisturbed;
$dda1fae23a8c7808$var$Stream.isErrored = $65HYg.isErrored;
$dda1fae23a8c7808$var$Stream.isReadable = $65HYg.isReadable;
$dda1fae23a8c7808$var$Stream.isWritable = $65HYg.isWritable;

$dda1fae23a8c7808$var$Stream.Readable = (parcelRequire("lOqOF"));
var $dda1fae23a8c7808$var$_iteratorNormalCompletion = true, $dda1fae23a8c7808$var$_didIteratorError = false, $dda1fae23a8c7808$var$_iteratorError = undefined;
try {
    for(var $dda1fae23a8c7808$var$_iterator = $dda1fae23a8c7808$var$ObjectKeys($dda1fae23a8c7808$var$streamReturningOperators)[Symbol.iterator](), $dda1fae23a8c7808$var$_step; !($dda1fae23a8c7808$var$_iteratorNormalCompletion = ($dda1fae23a8c7808$var$_step = $dda1fae23a8c7808$var$_iterator.next()).done); $dda1fae23a8c7808$var$_iteratorNormalCompletion = true){
        var $dda1fae23a8c7808$var$key = $dda1fae23a8c7808$var$_step.value;
        var $dda1fae23a8c7808$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $dda1fae23a8c7808$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $dda1fae23a8c7808$var$Stream.Readable.from($dda1fae23a8c7808$var$ReflectApply($dda1fae23a8c7808$var$op, this, args));
        };
        var $dda1fae23a8c7808$var$op = $dda1fae23a8c7808$var$streamReturningOperators[$dda1fae23a8c7808$var$key];
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$fn, 'name', {
            __proto__: null,
            value: $dda1fae23a8c7808$var$op.name
        });
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$fn, 'length', {
            __proto__: null,
            value: $dda1fae23a8c7808$var$op.length
        });
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$Stream.Readable.prototype, $dda1fae23a8c7808$var$key, {
            __proto__: null,
            value: $dda1fae23a8c7808$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $dda1fae23a8c7808$var$_didIteratorError = true;
    $dda1fae23a8c7808$var$_iteratorError = err;
} finally{
    try {
        if (!$dda1fae23a8c7808$var$_iteratorNormalCompletion && $dda1fae23a8c7808$var$_iterator["return"] != null) {
            $dda1fae23a8c7808$var$_iterator["return"]();
        }
    } finally{
        if ($dda1fae23a8c7808$var$_didIteratorError) {
            throw $dda1fae23a8c7808$var$_iteratorError;
        }
    }
}
var $dda1fae23a8c7808$var$_iteratorNormalCompletion1 = true, $dda1fae23a8c7808$var$_didIteratorError1 = false, $dda1fae23a8c7808$var$_iteratorError1 = undefined;
try {
    for(var $dda1fae23a8c7808$var$_iterator1 = $dda1fae23a8c7808$var$ObjectKeys($dda1fae23a8c7808$var$promiseReturningOperators)[Symbol.iterator](), $dda1fae23a8c7808$var$_step1; !($dda1fae23a8c7808$var$_iteratorNormalCompletion1 = ($dda1fae23a8c7808$var$_step1 = $dda1fae23a8c7808$var$_iterator1.next()).done); $dda1fae23a8c7808$var$_iteratorNormalCompletion1 = true){
        var $dda1fae23a8c7808$var$key1 = $dda1fae23a8c7808$var$_step1.value;
        var $dda1fae23a8c7808$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $dda1fae23a8c7808$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $dda1fae23a8c7808$var$ReflectApply($dda1fae23a8c7808$var$op1, this, args);
        };
        var $dda1fae23a8c7808$var$op1 = $dda1fae23a8c7808$var$promiseReturningOperators[$dda1fae23a8c7808$var$key1];
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$fn1, 'name', {
            __proto__: null,
            value: $dda1fae23a8c7808$var$op1.name
        });
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$fn1, 'length', {
            __proto__: null,
            value: $dda1fae23a8c7808$var$op1.length
        });
        $dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$Stream.Readable.prototype, $dda1fae23a8c7808$var$key1, {
            __proto__: null,
            value: $dda1fae23a8c7808$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $dda1fae23a8c7808$var$_didIteratorError1 = true;
    $dda1fae23a8c7808$var$_iteratorError1 = err;
} finally{
    try {
        if (!$dda1fae23a8c7808$var$_iteratorNormalCompletion1 && $dda1fae23a8c7808$var$_iterator1["return"] != null) {
            $dda1fae23a8c7808$var$_iterator1["return"]();
        }
    } finally{
        if ($dda1fae23a8c7808$var$_didIteratorError1) {
            throw $dda1fae23a8c7808$var$_iteratorError1;
        }
    }
}

$dda1fae23a8c7808$var$Stream.Writable = (parcelRequire("2ArKA"));

$dda1fae23a8c7808$var$Stream.Duplex = (parcelRequire("kT5fT"));

$dda1fae23a8c7808$var$Stream.Transform = (parcelRequire("cx1cR"));

$dda1fae23a8c7808$var$Stream.PassThrough = (parcelRequire("a6J00"));
$dda1fae23a8c7808$var$Stream.pipeline = $dda1fae23a8c7808$require$pipeline;

var $32Tj5 = parcelRequire("32Tj5");
var $dda1fae23a8c7808$require$addAbortSignal = $32Tj5.addAbortSignal;
$dda1fae23a8c7808$var$Stream.addAbortSignal = $dda1fae23a8c7808$require$addAbortSignal;
$dda1fae23a8c7808$var$Stream.finished = $vZAIl;
$dda1fae23a8c7808$var$Stream.destroy = $dda1fae23a8c7808$require$destroyer;
$dda1fae23a8c7808$var$Stream.compose = $3J29d;
$dda1fae23a8c7808$var$Stream.setDefaultHighWaterMark = $dda1fae23a8c7808$var$setDefaultHighWaterMark;
$dda1fae23a8c7808$var$Stream.getDefaultHighWaterMark = $dda1fae23a8c7808$var$getDefaultHighWaterMark;
$dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $f0bPU;
    }
});
$dda1fae23a8c7808$var$ObjectDefineProperty($dda1fae23a8c7808$require$pipeline, $dda1fae23a8c7808$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $f0bPU.pipeline;
    }
});
$dda1fae23a8c7808$var$ObjectDefineProperty($vZAIl, $dda1fae23a8c7808$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $f0bPU.finished;
    }
});
// Backwards-compat with node 0.4.x
$dda1fae23a8c7808$var$Stream.Stream = $dda1fae23a8c7808$var$Stream;
$dda1fae23a8c7808$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$dda1fae23a8c7808$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $dda1fae23a8c7808$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("eIVzI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $ab81d5f296e15606$export$a143d493d941bafc; }, function (v) { return $ab81d5f296e15606$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $ab81d5f296e15606$export$f99ded8fe4b79145; }, function (v) { return $ab81d5f296e15606$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $ab81d5f296e15606$export$a143d493d941bafc;
var $ab81d5f296e15606$export$e4cf37d7f6fb9e0a;
var $ab81d5f296e15606$export$f99ded8fe4b79145;
var $ab81d5f296e15606$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $ab81d5f296e15606$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ab81d5f296e15606$export$a143d493d941bafc = $ab81d5f296e15606$var$Buffer;
$ab81d5f296e15606$export$e4cf37d7f6fb9e0a = $ab81d5f296e15606$var$SlowBuffer;
$ab81d5f296e15606$export$f99ded8fe4b79145 = 50;
var $ab81d5f296e15606$var$K_MAX_LENGTH = 0x7fffffff;
$ab81d5f296e15606$export$599f31c3813fae4d = $ab81d5f296e15606$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ab81d5f296e15606$var$Buffer.TYPED_ARRAY_SUPPORT = $ab81d5f296e15606$var$typedArraySupport();
if (!$ab81d5f296e15606$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ab81d5f296e15606$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ab81d5f296e15606$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$ab81d5f296e15606$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ab81d5f296e15606$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$ab81d5f296e15606$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ab81d5f296e15606$var$createBuffer(length) {
    if (length > $ab81d5f296e15606$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ab81d5f296e15606$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ab81d5f296e15606$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ab81d5f296e15606$var$allocUnsafe(arg);
    }
    return $ab81d5f296e15606$var$from(arg, encodingOrOffset, length);
}
$ab81d5f296e15606$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ab81d5f296e15606$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ab81d5f296e15606$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ab81d5f296e15606$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($ab81d5f296e15606$var$isInstance(value, ArrayBuffer) || value && $ab81d5f296e15606$var$isInstance(value.buffer, ArrayBuffer)) return $ab81d5f296e15606$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ab81d5f296e15606$var$isInstance(value, SharedArrayBuffer) || value && $ab81d5f296e15606$var$isInstance(value.buffer, SharedArrayBuffer))) return $ab81d5f296e15606$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ab81d5f296e15606$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $ab81d5f296e15606$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ab81d5f296e15606$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ab81d5f296e15606$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ab81d5f296e15606$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ab81d5f296e15606$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ab81d5f296e15606$var$Buffer, Uint8Array);
function $ab81d5f296e15606$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ab81d5f296e15606$var$alloc(size, fill, encoding) {
    $ab81d5f296e15606$var$assertSize(size);
    if (size <= 0) return $ab81d5f296e15606$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ab81d5f296e15606$var$createBuffer(size).fill(fill, encoding) : $ab81d5f296e15606$var$createBuffer(size).fill(fill);
    return $ab81d5f296e15606$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ab81d5f296e15606$var$Buffer.alloc = function(size, fill, encoding) {
    return $ab81d5f296e15606$var$alloc(size, fill, encoding);
};
function $ab81d5f296e15606$var$allocUnsafe(size) {
    $ab81d5f296e15606$var$assertSize(size);
    return $ab81d5f296e15606$var$createBuffer(size < 0 ? 0 : $ab81d5f296e15606$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ab81d5f296e15606$var$Buffer.allocUnsafe = function(size) {
    return $ab81d5f296e15606$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ab81d5f296e15606$var$Buffer.allocUnsafeSlow = function(size) {
    return $ab81d5f296e15606$var$allocUnsafe(size);
};
function $ab81d5f296e15606$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ab81d5f296e15606$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $ab81d5f296e15606$var$byteLength(string, encoding) | 0;
    var buf = $ab81d5f296e15606$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ab81d5f296e15606$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $ab81d5f296e15606$var$checked(array.length) | 0;
    var buf = $ab81d5f296e15606$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ab81d5f296e15606$var$fromArrayView(arrayView) {
    if ($ab81d5f296e15606$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $ab81d5f296e15606$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ab81d5f296e15606$var$fromArrayLike(arrayView);
}
function $ab81d5f296e15606$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ab81d5f296e15606$var$Buffer.prototype);
    return buf;
}
function $ab81d5f296e15606$var$fromObject(obj) {
    if ($ab81d5f296e15606$var$Buffer.isBuffer(obj)) {
        var len = $ab81d5f296e15606$var$checked(obj.length) | 0;
        var buf = $ab81d5f296e15606$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ab81d5f296e15606$var$numberIsNaN(obj.length)) return $ab81d5f296e15606$var$createBuffer(0);
        return $ab81d5f296e15606$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ab81d5f296e15606$var$fromArrayLike(obj.data);
}
function $ab81d5f296e15606$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ab81d5f296e15606$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ab81d5f296e15606$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ab81d5f296e15606$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ab81d5f296e15606$var$Buffer.alloc(+length);
}
$ab81d5f296e15606$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ab81d5f296e15606$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ab81d5f296e15606$var$Buffer.compare = function compare(a, b) {
    if ($ab81d5f296e15606$var$isInstance(a, Uint8Array)) a = $ab81d5f296e15606$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ab81d5f296e15606$var$isInstance(b, Uint8Array)) b = $ab81d5f296e15606$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ab81d5f296e15606$var$Buffer.isBuffer(a) || !$ab81d5f296e15606$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ab81d5f296e15606$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ab81d5f296e15606$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ab81d5f296e15606$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $ab81d5f296e15606$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($ab81d5f296e15606$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ab81d5f296e15606$var$Buffer.isBuffer(buf)) buf = $ab81d5f296e15606$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ab81d5f296e15606$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ab81d5f296e15606$var$byteLength(string, encoding) {
    if ($ab81d5f296e15606$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ab81d5f296e15606$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ab81d5f296e15606$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ab81d5f296e15606$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ab81d5f296e15606$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ab81d5f296e15606$var$Buffer.byteLength = $ab81d5f296e15606$var$byteLength;
function $ab81d5f296e15606$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ab81d5f296e15606$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ab81d5f296e15606$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ab81d5f296e15606$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ab81d5f296e15606$var$latin1Slice(this, start, end);
        case 'base64':
            return $ab81d5f296e15606$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ab81d5f296e15606$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ab81d5f296e15606$var$Buffer.prototype._isBuffer = true;
function $ab81d5f296e15606$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ab81d5f296e15606$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$ab81d5f296e15606$var$swap(this, i, i + 1);
    return this;
};
$ab81d5f296e15606$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $ab81d5f296e15606$var$swap(this, i, i + 3);
        $ab81d5f296e15606$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ab81d5f296e15606$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $ab81d5f296e15606$var$swap(this, i, i + 7);
        $ab81d5f296e15606$var$swap(this, i + 1, i + 6);
        $ab81d5f296e15606$var$swap(this, i + 2, i + 5);
        $ab81d5f296e15606$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ab81d5f296e15606$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ab81d5f296e15606$var$utf8Slice(this, 0, length);
    return $ab81d5f296e15606$var$slowToString.apply(this, arguments);
};
$ab81d5f296e15606$var$Buffer.prototype.toLocaleString = $ab81d5f296e15606$var$Buffer.prototype.toString;
$ab81d5f296e15606$var$Buffer.prototype.equals = function equals(b) {
    if (!$ab81d5f296e15606$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ab81d5f296e15606$var$Buffer.compare(this, b) === 0;
};
$ab81d5f296e15606$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $ab81d5f296e15606$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ab81d5f296e15606$var$customInspectSymbol) $ab81d5f296e15606$var$Buffer.prototype[$ab81d5f296e15606$var$customInspectSymbol] = $ab81d5f296e15606$var$Buffer.prototype.inspect;
$ab81d5f296e15606$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ab81d5f296e15606$var$isInstance(target, Uint8Array)) target = $ab81d5f296e15606$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ab81d5f296e15606$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ab81d5f296e15606$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ab81d5f296e15606$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ab81d5f296e15606$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ab81d5f296e15606$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ab81d5f296e15606$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ab81d5f296e15606$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ab81d5f296e15606$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ab81d5f296e15606$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ab81d5f296e15606$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ab81d5f296e15606$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ab81d5f296e15606$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ab81d5f296e15606$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ab81d5f296e15606$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ab81d5f296e15606$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ab81d5f296e15606$var$utf8Write(buf, string, offset, length) {
    return $ab81d5f296e15606$var$blitBuffer($ab81d5f296e15606$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ab81d5f296e15606$var$asciiWrite(buf, string, offset, length) {
    return $ab81d5f296e15606$var$blitBuffer($ab81d5f296e15606$var$asciiToBytes(string), buf, offset, length);
}
function $ab81d5f296e15606$var$base64Write(buf, string, offset, length) {
    return $ab81d5f296e15606$var$blitBuffer($ab81d5f296e15606$var$base64ToBytes(string), buf, offset, length);
}
function $ab81d5f296e15606$var$ucs2Write(buf, string, offset, length) {
    return $ab81d5f296e15606$var$blitBuffer($ab81d5f296e15606$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ab81d5f296e15606$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ab81d5f296e15606$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ab81d5f296e15606$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ab81d5f296e15606$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ab81d5f296e15606$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ab81d5f296e15606$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ab81d5f296e15606$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ab81d5f296e15606$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $ab81d5f296e15606$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ab81d5f296e15606$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $ab81d5f296e15606$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ab81d5f296e15606$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $ab81d5f296e15606$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ab81d5f296e15606$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ab81d5f296e15606$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ab81d5f296e15606$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ab81d5f296e15606$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $ab81d5f296e15606$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ab81d5f296e15606$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ab81d5f296e15606$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ab81d5f296e15606$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ab81d5f296e15606$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ab81d5f296e15606$var$Buffer.prototype.readUintLE = $ab81d5f296e15606$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ab81d5f296e15606$var$Buffer.prototype.readUintBE = $ab81d5f296e15606$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ab81d5f296e15606$var$Buffer.prototype.readUint8 = $ab81d5f296e15606$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ab81d5f296e15606$var$Buffer.prototype.readUint16LE = $ab81d5f296e15606$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ab81d5f296e15606$var$Buffer.prototype.readUint16BE = $ab81d5f296e15606$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ab81d5f296e15606$var$Buffer.prototype.readUint32LE = $ab81d5f296e15606$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ab81d5f296e15606$var$Buffer.prototype.readUint32BE = $ab81d5f296e15606$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ab81d5f296e15606$var$Buffer.prototype.readBigUInt64LE = $ab81d5f296e15606$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ab81d5f296e15606$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ab81d5f296e15606$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ab81d5f296e15606$var$Buffer.prototype.readBigUInt64BE = $ab81d5f296e15606$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ab81d5f296e15606$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ab81d5f296e15606$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ab81d5f296e15606$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab81d5f296e15606$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab81d5f296e15606$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ab81d5f296e15606$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab81d5f296e15606$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab81d5f296e15606$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ab81d5f296e15606$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ab81d5f296e15606$var$Buffer.prototype.readBigInt64LE = $ab81d5f296e15606$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ab81d5f296e15606$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ab81d5f296e15606$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$ab81d5f296e15606$var$Buffer.prototype.readBigInt64BE = $ab81d5f296e15606$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ab81d5f296e15606$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $ab81d5f296e15606$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$ab81d5f296e15606$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$ab81d5f296e15606$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$ab81d5f296e15606$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$ab81d5f296e15606$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $ab81d5f296e15606$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ab81d5f296e15606$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ab81d5f296e15606$var$Buffer.prototype.writeUintLE = $ab81d5f296e15606$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab81d5f296e15606$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUintBE = $ab81d5f296e15606$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab81d5f296e15606$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUint8 = $ab81d5f296e15606$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUint16LE = $ab81d5f296e15606$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUint16BE = $ab81d5f296e15606$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUint32LE = $ab81d5f296e15606$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ab81d5f296e15606$var$Buffer.prototype.writeUint32BE = $ab81d5f296e15606$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ab81d5f296e15606$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ab81d5f296e15606$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ab81d5f296e15606$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ab81d5f296e15606$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ab81d5f296e15606$var$Buffer.prototype.writeBigUInt64LE = $ab81d5f296e15606$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ab81d5f296e15606$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ab81d5f296e15606$var$Buffer.prototype.writeBigUInt64BE = $ab81d5f296e15606$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ab81d5f296e15606$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ab81d5f296e15606$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ab81d5f296e15606$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab81d5f296e15606$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ab81d5f296e15606$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab81d5f296e15606$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab81d5f296e15606$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab81d5f296e15606$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab81d5f296e15606$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ab81d5f296e15606$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ab81d5f296e15606$var$Buffer.prototype.writeBigInt64LE = $ab81d5f296e15606$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ab81d5f296e15606$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ab81d5f296e15606$var$Buffer.prototype.writeBigInt64BE = $ab81d5f296e15606$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $ab81d5f296e15606$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ab81d5f296e15606$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ab81d5f296e15606$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ab81d5f296e15606$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ab81d5f296e15606$var$writeFloat(this, value, offset, true, noAssert);
};
$ab81d5f296e15606$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ab81d5f296e15606$var$writeFloat(this, value, offset, false, noAssert);
};
function $ab81d5f296e15606$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab81d5f296e15606$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ab81d5f296e15606$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ab81d5f296e15606$var$writeDouble(this, value, offset, true, noAssert);
};
$ab81d5f296e15606$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ab81d5f296e15606$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ab81d5f296e15606$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ab81d5f296e15606$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ab81d5f296e15606$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ab81d5f296e15606$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $ab81d5f296e15606$var$Buffer.isBuffer(val) ? val : $ab81d5f296e15606$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $ab81d5f296e15606$var$errors = {};
function $ab81d5f296e15606$var$E(sym, getMessage, Base) {
    $ab81d5f296e15606$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$ab81d5f296e15606$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ab81d5f296e15606$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$ab81d5f296e15606$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $ab81d5f296e15606$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $ab81d5f296e15606$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $ab81d5f296e15606$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $ab81d5f296e15606$var$checkBounds(buf, offset, byteLength) {
    $ab81d5f296e15606$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ab81d5f296e15606$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ab81d5f296e15606$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $ab81d5f296e15606$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ab81d5f296e15606$var$checkBounds(buf, offset, byteLength);
}
function $ab81d5f296e15606$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ab81d5f296e15606$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ab81d5f296e15606$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ab81d5f296e15606$var$validateNumber(value, type);
        throw new $ab81d5f296e15606$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ab81d5f296e15606$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ab81d5f296e15606$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $ab81d5f296e15606$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ab81d5f296e15606$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ab81d5f296e15606$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ab81d5f296e15606$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ab81d5f296e15606$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ab81d5f296e15606$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ab81d5f296e15606$var$base64ToBytes(str) {
    return $abUaD.toByteArray($ab81d5f296e15606$var$base64clean(str));
}
function $ab81d5f296e15606$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ab81d5f296e15606$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ab81d5f296e15606$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $ab81d5f296e15606$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ab81d5f296e15606$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ab81d5f296e15606$var$BufferBigIntNotDefined : fn;
}
function $ab81d5f296e15606$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("gPFMe", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $c411d0c5c6fed8d2$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $c411d0c5c6fed8d2$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("ivGzv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eIVzI = parcelRequire("eIVzI");

var $g31vX = parcelRequire("g31vX");
var $d79c2511774a17f6$var$format = $g31vX.format, $d79c2511774a17f6$var$inspect = $g31vX.inspect;

var $gDydr = parcelRequire("gDydr");
var $d79c2511774a17f6$var$ERR_INVALID_ARG_TYPE = $gDydr.codes.ERR_INVALID_ARG_TYPE;

var $gPFMe = parcelRequire("gPFMe");
var $d79c2511774a17f6$var$kResistStopPropagation = $gPFMe.kResistStopPropagation, $d79c2511774a17f6$var$AggregateError = $gPFMe.AggregateError, $d79c2511774a17f6$var$SymbolDispose = $gPFMe.SymbolDispose;

var $d79c2511774a17f6$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $d79c2511774a17f6$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $d79c2511774a17f6$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $d79c2511774a17f6$var$Blob = globalThis.Blob || $eIVzI.Blob;
/* eslint-disable indent */ var $d79c2511774a17f6$var$isBlob = typeof $d79c2511774a17f6$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $d79c2511774a17f6$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $d79c2511774a17f6$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $d79c2511774a17f6$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $d79c2511774a17f6$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $d79c2511774a17f6$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $d79c2511774a17f6$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $d79c2511774a17f6$var$format,
    inspect: $d79c2511774a17f6$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $d79c2511774a17f6$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $d79c2511774a17f6$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $d79c2511774a17f6$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $d79c2511774a17f6$var$validateAbortSignal(signal, 'signal');
        $d79c2511774a17f6$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $d79c2511774a17f6$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $d79c2511774a17f6$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $d79c2511774a17f6$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $d79c2511774a17f6$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $d79c2511774a17f6$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("g31vX", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("gDydr", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $g31vX = parcelRequire("g31vX");
var $c1cad46aff56a37b$var$format = $g31vX.format, $c1cad46aff56a37b$var$inspect = $g31vX.inspect;

var $gPFMe = parcelRequire("gPFMe");
var $c1cad46aff56a37b$var$CustomAggregateError = $gPFMe.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $c1cad46aff56a37b$var$AggregateError = globalThis.AggregateError || $c1cad46aff56a37b$var$CustomAggregateError;
var $c1cad46aff56a37b$var$kIsNodeError = Symbol('kIsNodeError');
var $c1cad46aff56a37b$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $c1cad46aff56a37b$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $c1cad46aff56a37b$var$nodeInternalPrefix = '__node_internal_';
var $c1cad46aff56a37b$var$codes = {};
function $c1cad46aff56a37b$var$assert(value, message) {
    if (!value) throw new $c1cad46aff56a37b$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $c1cad46aff56a37b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $c1cad46aff56a37b$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $c1cad46aff56a37b$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $c1cad46aff56a37b$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $c1cad46aff56a37b$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $c1cad46aff56a37b$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $c1cad46aff56a37b$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$c1cad46aff56a37b$var$kIsNodeError] = true;
    $c1cad46aff56a37b$var$codes[code] = NodeError;
}
function $c1cad46aff56a37b$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $c1cad46aff56a37b$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $c1cad46aff56a37b$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $c1cad46aff56a37b$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $c1cad46aff56a37b$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $c1cad46aff56a37b$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$c1cad46aff56a37b$var$E('ERR_ASSERTION', '%s', Error);
$c1cad46aff56a37b$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $c1cad46aff56a37b$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $c1cad46aff56a37b$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($c1cad46aff56a37b$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($c1cad46aff56a37b$var$classRegExp.test(value)) instances.push(value);
            else {
                $c1cad46aff56a37b$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $c1cad46aff56a37b$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $c1cad46aff56a37b$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$c1cad46aff56a37b$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $c1cad46aff56a37b$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$c1cad46aff56a37b$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$c1cad46aff56a37b$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $c1cad46aff56a37b$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$c1cad46aff56a37b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $c1cad46aff56a37b$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $c1cad46aff56a37b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $c1cad46aff56a37b$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $c1cad46aff56a37b$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$c1cad46aff56a37b$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$c1cad46aff56a37b$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c1cad46aff56a37b$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$c1cad46aff56a37b$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$c1cad46aff56a37b$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $c1cad46aff56a37b$var$AbortError,
    aggregateTwoErrors: $c1cad46aff56a37b$var$hideStackFrames($c1cad46aff56a37b$var$aggregateTwoErrors),
    hideStackFrames: $c1cad46aff56a37b$var$hideStackFrames,
    codes: $c1cad46aff56a37b$var$codes
};

});


parcelRegister("6GWnb", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $4df3f1f513f5c16d$export$42af8c323be37587; }, function (v) { return $4df3f1f513f5c16d$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $4df3f1f513f5c16d$export$f405f72c701dad87; }, function (v) { return $4df3f1f513f5c16d$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $4df3f1f513f5c16d$export$42af8c323be37587;
var $4df3f1f513f5c16d$export$f405f72c701dad87;
'use strict';

var $4df3f1f513f5c16d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $gDydr = parcelRequire("gDydr");
var $4df3f1f513f5c16d$var$_require_codes = $gDydr.codes, $4df3f1f513f5c16d$var$ERR_INVALID_ARG_VALUE = $4df3f1f513f5c16d$var$_require_codes.ERR_INVALID_ARG_VALUE, $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE = $4df3f1f513f5c16d$var$_require_codes.ERR_INVALID_ARG_TYPE, $4df3f1f513f5c16d$var$ERR_MISSING_ARGS = $4df3f1f513f5c16d$var$_require_codes.ERR_MISSING_ARGS, $4df3f1f513f5c16d$var$ERR_OUT_OF_RANGE = $4df3f1f513f5c16d$var$_require_codes.ERR_OUT_OF_RANGE, $4df3f1f513f5c16d$var$AbortError = $gDydr.AbortError;

var $kSEof = parcelRequire("kSEof");
var $4df3f1f513f5c16d$var$validateAbortSignal = $kSEof.validateAbortSignal, $4df3f1f513f5c16d$var$validateInteger = $kSEof.validateInteger, $4df3f1f513f5c16d$var$validateObject = $kSEof.validateObject;

var $4df3f1f513f5c16d$var$kWeakHandler = (parcelRequire("gPFMe")).Symbol('kWeak');

var $4df3f1f513f5c16d$var$kResistStopPropagation = (parcelRequire("gPFMe")).Symbol('kResistStopPropagation');

var $vZAIl = parcelRequire("vZAIl");
var $4df3f1f513f5c16d$require$finished = $vZAIl.finished;

var $3J29d = parcelRequire("3J29d");

var $32Tj5 = parcelRequire("32Tj5");
var $4df3f1f513f5c16d$require$addAbortSignalNoValidate = $32Tj5.addAbortSignalNoValidate;

var $65HYg = parcelRequire("65HYg");
var $4df3f1f513f5c16d$var$isWritable = $65HYg.isWritable, $4df3f1f513f5c16d$var$isNodeStream = $65HYg.isNodeStream;

var $4df3f1f513f5c16d$require$deprecate = (parcelRequire("ivGzv")).deprecate;

var $4df3f1f513f5c16d$var$ArrayPrototypePush = (parcelRequire("gPFMe")).ArrayPrototypePush, $4df3f1f513f5c16d$var$Boolean = (parcelRequire("gPFMe")).Boolean, $4df3f1f513f5c16d$var$MathFloor = (parcelRequire("gPFMe")).MathFloor, $4df3f1f513f5c16d$var$Number = (parcelRequire("gPFMe")).Number, $4df3f1f513f5c16d$var$NumberIsNaN = (parcelRequire("gPFMe")).NumberIsNaN, $4df3f1f513f5c16d$var$Promise = (parcelRequire("gPFMe")).Promise, $4df3f1f513f5c16d$var$PromiseReject = (parcelRequire("gPFMe")).PromiseReject, $4df3f1f513f5c16d$var$PromiseResolve = (parcelRequire("gPFMe")).PromiseResolve, $4df3f1f513f5c16d$var$PromisePrototypeThen = (parcelRequire("gPFMe")).PromisePrototypeThen, $4df3f1f513f5c16d$var$Symbol = (parcelRequire("gPFMe")).Symbol;
var $4df3f1f513f5c16d$var$kEmpty = $4df3f1f513f5c16d$var$Symbol('kEmpty');
var $4df3f1f513f5c16d$var$kEof = $4df3f1f513f5c16d$var$Symbol('kEof');
function $4df3f1f513f5c16d$var$compose(stream, options) {
    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
    if ($4df3f1f513f5c16d$var$isNodeStream(stream) && !$4df3f1f513f5c16d$var$isWritable(stream)) throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $3J29d(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $4df3f1f513f5c16d$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $4df3f1f513f5c16d$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $4df3f1f513f5c16d$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $4df3f1f513f5c16d$var$MathFloor(options.highWaterMark);
    $4df3f1f513f5c16d$var$validateInteger(concurrency, 'options.concurrency', 1);
    $4df3f1f513f5c16d$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $4df3f1f513f5c16d$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $4df3f1f513f5c16d$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $4df3f1f513f5c16d$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $4df3f1f513f5c16d$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $4df3f1f513f5c16d$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($4df3f1f513f5c16d$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $4df3f1f513f5c16d$var$PromiseReject(err1);
                                $4df3f1f513f5c16d$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("ivGzv")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($4df3f1f513f5c16d$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $4df3f1f513f5c16d$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                        if (!(val !== $4df3f1f513f5c16d$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $4df3f1f513f5c16d$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4df3f1f513f5c16d$var$asIndexedPairs(options) {
    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $4df3f1f513f5c16d$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4df3f1f513f5c16d$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4df3f1f513f5c16d$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $4df3f1f513f5c16d$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $4df3f1f513f5c16d$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $4df3f1f513f5c16d$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4df3f1f513f5c16d$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $4df3f1f513f5c16d$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $4df3f1f513f5c16d$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($4df3f1f513f5c16d$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $4df3f1f513f5c16d$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $4df3f1f513f5c16d$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $4df3f1f513f5c16d$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $4df3f1f513f5c16d$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($4df3f1f513f5c16d$var$ERR_MISSING_ARGS);
function $4df3f1f513f5c16d$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $4df3f1f513f5c16d$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $4df3f1f513f5c16d$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $4df3f1f513f5c16d$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $4df3f1f513f5c16d$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $4df3f1f513f5c16d$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $4df3f1f513f5c16d$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $4df3f1f513f5c16d$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $4df3f1f513f5c16d$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $4df3f1f513f5c16d$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $4df3f1f513f5c16d$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $4df3f1f513f5c16d$var$flatMap(fn, options) {
    var values = $4df3f1f513f5c16d$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $4df3f1f513f5c16d$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $4df3f1f513f5c16d$var$Number(number);
    if ($4df3f1f513f5c16d$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $4df3f1f513f5c16d$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $4df3f1f513f5c16d$var$drop(number, options) {
    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4df3f1f513f5c16d$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $4df3f1f513f5c16d$var$take(number, options) {
    if (options != null) $4df3f1f513f5c16d$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4df3f1f513f5c16d$var$validateAbortSignal(options.signal, 'options.signal');
    number = $4df3f1f513f5c16d$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $4df3f1f513f5c16d$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$4df3f1f513f5c16d$export$42af8c323be37587 = {
    asIndexedPairs: $4df3f1f513f5c16d$require$deprecate($4df3f1f513f5c16d$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $4df3f1f513f5c16d$var$drop,
    filter: $4df3f1f513f5c16d$var$filter,
    flatMap: $4df3f1f513f5c16d$var$flatMap,
    map: $4df3f1f513f5c16d$var$map,
    take: $4df3f1f513f5c16d$var$take,
    compose: $4df3f1f513f5c16d$var$compose
};
$4df3f1f513f5c16d$export$f405f72c701dad87 = {
    every: $4df3f1f513f5c16d$var$every,
    forEach: $4df3f1f513f5c16d$var$forEach,
    reduce: $4df3f1f513f5c16d$var$reduce,
    toArray: $4df3f1f513f5c16d$var$toArray,
    some: $4df3f1f513f5c16d$var$some,
    find: $4df3f1f513f5c16d$var$find
};

});
parcelRegister("kSEof", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $f3382e668956ce56$var$ArrayIsArray = $gPFMe.ArrayIsArray, $f3382e668956ce56$var$ArrayPrototypeIncludes = $gPFMe.ArrayPrototypeIncludes, $f3382e668956ce56$var$ArrayPrototypeJoin = $gPFMe.ArrayPrototypeJoin, $f3382e668956ce56$var$ArrayPrototypeMap = $gPFMe.ArrayPrototypeMap, $f3382e668956ce56$var$NumberIsInteger = $gPFMe.NumberIsInteger, $f3382e668956ce56$var$NumberIsNaN = $gPFMe.NumberIsNaN, $f3382e668956ce56$var$NumberMAX_SAFE_INTEGER = $gPFMe.NumberMAX_SAFE_INTEGER, $f3382e668956ce56$var$NumberMIN_SAFE_INTEGER = $gPFMe.NumberMIN_SAFE_INTEGER, $f3382e668956ce56$var$NumberParseInt = $gPFMe.NumberParseInt, $f3382e668956ce56$var$ObjectPrototypeHasOwnProperty = $gPFMe.ObjectPrototypeHasOwnProperty, $f3382e668956ce56$var$RegExpPrototypeExec = $gPFMe.RegExpPrototypeExec, $f3382e668956ce56$var$String = $gPFMe.String, $f3382e668956ce56$var$StringPrototypeToUpperCase = $gPFMe.StringPrototypeToUpperCase, $f3382e668956ce56$var$StringPrototypeTrim = $gPFMe.StringPrototypeTrim;

var $gDydr = parcelRequire("gDydr");
var $f3382e668956ce56$var$hideStackFrames = $gDydr.hideStackFrames, $f3382e668956ce56$var$_require_codes = $gDydr.codes, $f3382e668956ce56$var$ERR_SOCKET_BAD_PORT = $f3382e668956ce56$var$_require_codes.ERR_SOCKET_BAD_PORT, $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE = $f3382e668956ce56$var$_require_codes.ERR_INVALID_ARG_TYPE, $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE = $f3382e668956ce56$var$_require_codes.ERR_INVALID_ARG_VALUE, $f3382e668956ce56$var$ERR_OUT_OF_RANGE = $f3382e668956ce56$var$_require_codes.ERR_OUT_OF_RANGE, $f3382e668956ce56$var$ERR_UNKNOWN_SIGNAL = $f3382e668956ce56$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $ivGzv = parcelRequire("ivGzv");
var $f3382e668956ce56$require$normalizeEncoding = $ivGzv.normalizeEncoding;

var $ivGzv = parcelRequire("ivGzv");
var $f3382e668956ce56$require$_require_types = $ivGzv.types;
var $f3382e668956ce56$var$isAsyncFunction = $f3382e668956ce56$require$_require_types.isAsyncFunction, $f3382e668956ce56$var$isArrayBufferView = $f3382e668956ce56$require$_require_types.isArrayBufferView;
var $f3382e668956ce56$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f3382e668956ce56$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f3382e668956ce56$var$isUint32(value) {
    return value === value >>> 0;
}
var $f3382e668956ce56$var$octalReg = /^[0-7]+$/;
var $f3382e668956ce56$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $f3382e668956ce56$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($f3382e668956ce56$var$RegExpPrototypeExec($f3382e668956ce56$var$octalReg, value) === null) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE(name, value, $f3382e668956ce56$var$modeDesc);
        value = $f3382e668956ce56$var$NumberParseInt(value, 8);
    }
    $f3382e668956ce56$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $f3382e668956ce56$var$validateInteger = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f3382e668956ce56$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $f3382e668956ce56$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f3382e668956ce56$var$NumberIsInteger(value)) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $f3382e668956ce56$var$validateInt32 = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f3382e668956ce56$var$NumberIsInteger(value)) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $f3382e668956ce56$var$validateUint32 = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f3382e668956ce56$var$NumberIsInteger(value)) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $f3382e668956ce56$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $f3382e668956ce56$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $f3382e668956ce56$var$NumberIsNaN(value)) throw new $f3382e668956ce56$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $f3382e668956ce56$var$validateOneOf = $f3382e668956ce56$var$hideStackFrames(function(value, name, oneOf) {
    if (!$f3382e668956ce56$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $f3382e668956ce56$var$ArrayPrototypeJoin($f3382e668956ce56$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $f3382e668956ce56$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $f3382e668956ce56$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $f3382e668956ce56$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$f3382e668956ce56$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $f3382e668956ce56$var$validateObject = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $f3382e668956ce56$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $f3382e668956ce56$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $f3382e668956ce56$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $f3382e668956ce56$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $f3382e668956ce56$var$validateDictionary = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $f3382e668956ce56$var$validateArray = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$f3382e668956ce56$var$ArrayIsArray(value)) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $f3382e668956ce56$var$validateStringArray(value, name) {
    $f3382e668956ce56$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$f3382e668956ce56$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $f3382e668956ce56$var$validateBooleanArray(value, name) {
    $f3382e668956ce56$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$f3382e668956ce56$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $f3382e668956ce56$var$validateAbortSignalArray(value, name) {
    $f3382e668956ce56$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $f3382e668956ce56$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $f3382e668956ce56$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $f3382e668956ce56$var$validateString(signal, name);
    if ($f3382e668956ce56$var$signals[signal] === undefined) {
        if ($f3382e668956ce56$var$signals[$f3382e668956ce56$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $f3382e668956ce56$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $f3382e668956ce56$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $f3382e668956ce56$var$validateBuffer = $f3382e668956ce56$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$f3382e668956ce56$var$isArrayBufferView(buffer)) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $f3382e668956ce56$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $f3382e668956ce56$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $f3382e668956ce56$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $f3382e668956ce56$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $f3382e668956ce56$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $f3382e668956ce56$var$validateAbortSignal = $f3382e668956ce56$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $f3382e668956ce56$var$validateFunction = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $f3382e668956ce56$var$validatePlainFunction = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $f3382e668956ce56$var$isAsyncFunction(value)) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $f3382e668956ce56$var$validateUndefined = $f3382e668956ce56$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $f3382e668956ce56$var$validateUnion(value, name, union) {
    if (!$f3382e668956ce56$var$ArrayPrototypeIncludes(union, value)) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_TYPE(name, "('".concat($f3382e668956ce56$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $f3382e668956ce56$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $f3382e668956ce56$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$f3382e668956ce56$var$RegExpPrototypeExec($f3382e668956ce56$var$linkValueRegExp, value)) throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $f3382e668956ce56$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $f3382e668956ce56$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($f3382e668956ce56$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $f3382e668956ce56$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $f3382e668956ce56$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $f3382e668956ce56$var$isInt32,
    isUint32: $f3382e668956ce56$var$isUint32,
    parseFileMode: $f3382e668956ce56$var$parseFileMode,
    validateArray: $f3382e668956ce56$var$validateArray,
    validateStringArray: $f3382e668956ce56$var$validateStringArray,
    validateBooleanArray: $f3382e668956ce56$var$validateBooleanArray,
    validateAbortSignalArray: $f3382e668956ce56$var$validateAbortSignalArray,
    validateBoolean: $f3382e668956ce56$var$validateBoolean,
    validateBuffer: $f3382e668956ce56$var$validateBuffer,
    validateDictionary: $f3382e668956ce56$var$validateDictionary,
    validateEncoding: $f3382e668956ce56$var$validateEncoding,
    validateFunction: $f3382e668956ce56$var$validateFunction,
    validateInt32: $f3382e668956ce56$var$validateInt32,
    validateInteger: $f3382e668956ce56$var$validateInteger,
    validateNumber: $f3382e668956ce56$var$validateNumber,
    validateObject: $f3382e668956ce56$var$validateObject,
    validateOneOf: $f3382e668956ce56$var$validateOneOf,
    validatePlainFunction: $f3382e668956ce56$var$validatePlainFunction,
    validatePort: $f3382e668956ce56$var$validatePort,
    validateSignalName: $f3382e668956ce56$var$validateSignalName,
    validateString: $f3382e668956ce56$var$validateString,
    validateUint32: $f3382e668956ce56$var$validateUint32,
    validateUndefined: $f3382e668956ce56$var$validateUndefined,
    validateUnion: $f3382e668956ce56$var$validateUnion,
    validateAbortSignal: $f3382e668956ce56$var$validateAbortSignal,
    validateLinkHeaderValue: $f3382e668956ce56$var$validateLinkHeaderValue
};

});

parcelRegister("vZAIl", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $gDydr = parcelRequire("gDydr");
/* replacement end */ var $0602ac1675956aa5$var$AbortError = $gDydr.AbortError, $0602ac1675956aa5$var$codes = $gDydr.codes;
var $0602ac1675956aa5$var$ERR_INVALID_ARG_TYPE = $0602ac1675956aa5$var$codes.ERR_INVALID_ARG_TYPE, $0602ac1675956aa5$var$ERR_STREAM_PREMATURE_CLOSE = $0602ac1675956aa5$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $0602ac1675956aa5$var$kEmptyObject = (parcelRequire("ivGzv")).kEmptyObject, $0602ac1675956aa5$var$once = (parcelRequire("ivGzv")).once;

var $kSEof = parcelRequire("kSEof");
var $0602ac1675956aa5$var$validateAbortSignal = $kSEof.validateAbortSignal, $0602ac1675956aa5$var$validateFunction = $kSEof.validateFunction, $0602ac1675956aa5$var$validateObject = $kSEof.validateObject, $0602ac1675956aa5$var$validateBoolean = $kSEof.validateBoolean;

var $gPFMe = parcelRequire("gPFMe");
var $0602ac1675956aa5$var$Promise = $gPFMe.Promise, $0602ac1675956aa5$var$PromisePrototypeThen = $gPFMe.PromisePrototypeThen, $0602ac1675956aa5$var$SymbolDispose = $gPFMe.SymbolDispose;

var $65HYg = parcelRequire("65HYg");
var $0602ac1675956aa5$var$isClosed = $65HYg.isClosed, $0602ac1675956aa5$var$isReadable = $65HYg.isReadable, $0602ac1675956aa5$var$isReadableNodeStream = $65HYg.isReadableNodeStream, $0602ac1675956aa5$var$isReadableStream = $65HYg.isReadableStream, $0602ac1675956aa5$var$isReadableFinished = $65HYg.isReadableFinished, $0602ac1675956aa5$var$isReadableErrored = $65HYg.isReadableErrored, $0602ac1675956aa5$var$isWritable = $65HYg.isWritable, $0602ac1675956aa5$var$isWritableNodeStream = $65HYg.isWritableNodeStream, $0602ac1675956aa5$var$isWritableStream = $65HYg.isWritableStream, $0602ac1675956aa5$var$isWritableFinished = $65HYg.isWritableFinished, $0602ac1675956aa5$var$isWritableErrored = $65HYg.isWritableErrored, $0602ac1675956aa5$var$isNodeStream = $65HYg.isNodeStream, $0602ac1675956aa5$var$_willEmitClose = $65HYg.willEmitClose, $0602ac1675956aa5$var$kIsClosedPromise = $65HYg.kIsClosedPromise;
var $0602ac1675956aa5$var$addAbortListener;
function $0602ac1675956aa5$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $0602ac1675956aa5$var$nop = function() {};

function $0602ac1675956aa5$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $0602ac1675956aa5$var$kEmptyObject;
    } else if (options == null) options = $0602ac1675956aa5$var$kEmptyObject;
    else $0602ac1675956aa5$var$validateObject(options, 'options');
    $0602ac1675956aa5$var$validateFunction(callback, 'callback');
    $0602ac1675956aa5$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $0602ac1675956aa5$var$once(callback);
    if ($0602ac1675956aa5$var$isReadableStream(stream) || $0602ac1675956aa5$var$isWritableStream(stream)) return $0602ac1675956aa5$var$eosWeb(stream, options, callback);
    if (!$0602ac1675956aa5$var$isNodeStream(stream)) throw new $0602ac1675956aa5$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $0602ac1675956aa5$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $0602ac1675956aa5$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $0602ac1675956aa5$var$_willEmitClose(stream) && $0602ac1675956aa5$var$isReadableNodeStream(stream) === readable && $0602ac1675956aa5$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $0602ac1675956aa5$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $0602ac1675956aa5$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $0602ac1675956aa5$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $0602ac1675956aa5$var$isWritableErrored(stream) || $0602ac1675956aa5$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $0602ac1675956aa5$var$isReadableNodeStream(stream, true)) {
            if (!$0602ac1675956aa5$var$isReadableFinished(stream, false)) return callback.call(stream, new $0602ac1675956aa5$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$0602ac1675956aa5$var$isWritableFinished(stream, false)) return callback.call(stream, new $0602ac1675956aa5$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $0602ac1675956aa5$var$isWritableErrored(stream) || $0602ac1675956aa5$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($0602ac1675956aa5$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $0602ac1675956aa5$var$isReadable(stream)) && (writableFinished || $0602ac1675956aa5$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $0602ac1675956aa5$var$isWritable(stream)) && (readableFinished || $0602ac1675956aa5$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $0602ac1675956aa5$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $0602ac1675956aa5$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $0602ac1675956aa5$var$addAbortListener = $0602ac1675956aa5$var$addAbortListener || (parcelRequire("ivGzv")).addAbortListener;
            var disposable = $0602ac1675956aa5$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $0602ac1675956aa5$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$0602ac1675956aa5$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $0602ac1675956aa5$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $0602ac1675956aa5$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $0602ac1675956aa5$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $0602ac1675956aa5$var$addAbortListener = $0602ac1675956aa5$var$addAbortListener || (parcelRequire("ivGzv")).addAbortListener;
            var disposable = $0602ac1675956aa5$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $0602ac1675956aa5$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$0602ac1675956aa5$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $0602ac1675956aa5$var$PromisePrototypeThen(stream[$0602ac1675956aa5$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $0602ac1675956aa5$var$nop;
}
function $0602ac1675956aa5$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $0602ac1675956aa5$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $0602ac1675956aa5$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $0602ac1675956aa5$var$Promise(function(resolve, reject) {
        var cleanup = $0602ac1675956aa5$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $0602ac1675956aa5$var$eos;
module.exports.finished = $0602ac1675956aa5$var$finished;

});
parcelRegister("65HYg", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $46f5516a91e652ff$var$SymbolAsyncIterator = $gPFMe.SymbolAsyncIterator, $46f5516a91e652ff$var$SymbolIterator = $gPFMe.SymbolIterator, $46f5516a91e652ff$var$SymbolFor = $gPFMe.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $46f5516a91e652ff$var$kIsDestroyed = $46f5516a91e652ff$var$SymbolFor('nodejs.stream.destroyed');
var $46f5516a91e652ff$var$kIsErrored = $46f5516a91e652ff$var$SymbolFor('nodejs.stream.errored');
var $46f5516a91e652ff$var$kIsReadable = $46f5516a91e652ff$var$SymbolFor('nodejs.stream.readable');
var $46f5516a91e652ff$var$kIsWritable = $46f5516a91e652ff$var$SymbolFor('nodejs.stream.writable');
var $46f5516a91e652ff$var$kIsDisturbed = $46f5516a91e652ff$var$SymbolFor('nodejs.stream.disturbed');
var $46f5516a91e652ff$var$kIsClosedPromise = $46f5516a91e652ff$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $46f5516a91e652ff$var$kControllerErrorFunction = $46f5516a91e652ff$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $46f5516a91e652ff$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $46f5516a91e652ff$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $46f5516a91e652ff$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $46f5516a91e652ff$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $46f5516a91e652ff$var$isReadableStream(obj) {
    return !!(obj && !$46f5516a91e652ff$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $46f5516a91e652ff$var$isWritableStream(obj) {
    return !!(obj && !$46f5516a91e652ff$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $46f5516a91e652ff$var$isTransformStream(obj) {
    return !!(obj && !$46f5516a91e652ff$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $46f5516a91e652ff$var$isWebStream(obj) {
    return $46f5516a91e652ff$var$isReadableStream(obj) || $46f5516a91e652ff$var$isWritableStream(obj) || $46f5516a91e652ff$var$isTransformStream(obj);
}
function $46f5516a91e652ff$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$46f5516a91e652ff$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$46f5516a91e652ff$var$SymbolIterator] === 'function';
    return typeof obj[$46f5516a91e652ff$var$SymbolAsyncIterator] === 'function' || typeof obj[$46f5516a91e652ff$var$SymbolIterator] === 'function';
}
function $46f5516a91e652ff$var$isDestroyed(stream) {
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$46f5516a91e652ff$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $46f5516a91e652ff$var$isWritableEnded(stream) {
    if (!$46f5516a91e652ff$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $46f5516a91e652ff$var$isWritableFinished(stream, strict) {
    if (!$46f5516a91e652ff$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $46f5516a91e652ff$var$isReadableEnded(stream) {
    if (!$46f5516a91e652ff$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $46f5516a91e652ff$var$isReadableFinished(stream, strict) {
    if (!$46f5516a91e652ff$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $46f5516a91e652ff$var$isReadable(stream) {
    if (stream && stream[$46f5516a91e652ff$var$kIsReadable] != null) return stream[$46f5516a91e652ff$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($46f5516a91e652ff$var$isDestroyed(stream)) return false;
    return $46f5516a91e652ff$var$isReadableNodeStream(stream) && stream.readable && !$46f5516a91e652ff$var$isReadableFinished(stream);
}
function $46f5516a91e652ff$var$isWritable(stream) {
    if (stream && stream[$46f5516a91e652ff$var$kIsWritable] != null) return stream[$46f5516a91e652ff$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($46f5516a91e652ff$var$isDestroyed(stream)) return false;
    return $46f5516a91e652ff$var$isWritableNodeStream(stream) && stream.writable && !$46f5516a91e652ff$var$isWritableEnded(stream);
}
function $46f5516a91e652ff$var$isFinished(stream, opts) {
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    if ($46f5516a91e652ff$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $46f5516a91e652ff$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $46f5516a91e652ff$var$isWritable(stream)) return false;
    return true;
}
function $46f5516a91e652ff$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $46f5516a91e652ff$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $46f5516a91e652ff$var$isClosed(stream) {
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $46f5516a91e652ff$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $46f5516a91e652ff$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $46f5516a91e652ff$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $46f5516a91e652ff$var$isOutgoingMessage(stream);
}
function $46f5516a91e652ff$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $46f5516a91e652ff$var$willEmitClose(stream) {
    if (!$46f5516a91e652ff$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $46f5516a91e652ff$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $46f5516a91e652ff$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$46f5516a91e652ff$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $46f5516a91e652ff$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$46f5516a91e652ff$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $46f5516a91e652ff$var$isDestroyed,
    kIsDestroyed: $46f5516a91e652ff$var$kIsDestroyed,
    isDisturbed: $46f5516a91e652ff$var$isDisturbed,
    kIsDisturbed: $46f5516a91e652ff$var$kIsDisturbed,
    isErrored: $46f5516a91e652ff$var$isErrored,
    kIsErrored: $46f5516a91e652ff$var$kIsErrored,
    isReadable: $46f5516a91e652ff$var$isReadable,
    kIsReadable: $46f5516a91e652ff$var$kIsReadable,
    kIsClosedPromise: $46f5516a91e652ff$var$kIsClosedPromise,
    kControllerErrorFunction: $46f5516a91e652ff$var$kControllerErrorFunction,
    kIsWritable: $46f5516a91e652ff$var$kIsWritable,
    isClosed: $46f5516a91e652ff$var$isClosed,
    isDuplexNodeStream: $46f5516a91e652ff$var$isDuplexNodeStream,
    isFinished: $46f5516a91e652ff$var$isFinished,
    isIterable: $46f5516a91e652ff$var$isIterable,
    isReadableNodeStream: $46f5516a91e652ff$var$isReadableNodeStream,
    isReadableStream: $46f5516a91e652ff$var$isReadableStream,
    isReadableEnded: $46f5516a91e652ff$var$isReadableEnded,
    isReadableFinished: $46f5516a91e652ff$var$isReadableFinished,
    isReadableErrored: $46f5516a91e652ff$var$isReadableErrored,
    isNodeStream: $46f5516a91e652ff$var$isNodeStream,
    isWebStream: $46f5516a91e652ff$var$isWebStream,
    isWritable: $46f5516a91e652ff$var$isWritable,
    isWritableNodeStream: $46f5516a91e652ff$var$isWritableNodeStream,
    isWritableStream: $46f5516a91e652ff$var$isWritableStream,
    isWritableEnded: $46f5516a91e652ff$var$isWritableEnded,
    isWritableFinished: $46f5516a91e652ff$var$isWritableFinished,
    isWritableErrored: $46f5516a91e652ff$var$isWritableErrored,
    isServerRequest: $46f5516a91e652ff$var$isServerRequest,
    isServerResponse: $46f5516a91e652ff$var$isServerResponse,
    willEmitClose: $46f5516a91e652ff$var$willEmitClose,
    isTransformStream: $46f5516a91e652ff$var$isTransformStream
};

});


parcelRegister("3J29d", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $khkUM = parcelRequire("khkUM");
var $2b673d900dbb92a6$require$pipeline = $khkUM.pipeline;

var $kT5fT = parcelRequire("kT5fT");

var $irwcz = parcelRequire("irwcz");
var $2b673d900dbb92a6$require$destroyer = $irwcz.destroyer;

var $65HYg = parcelRequire("65HYg");
var $2b673d900dbb92a6$var$isNodeStream = $65HYg.isNodeStream, $2b673d900dbb92a6$var$isReadable = $65HYg.isReadable, $2b673d900dbb92a6$var$isWritable = $65HYg.isWritable, $2b673d900dbb92a6$var$isWebStream = $65HYg.isWebStream, $2b673d900dbb92a6$var$isTransformStream = $65HYg.isTransformStream, $2b673d900dbb92a6$var$isWritableStream = $65HYg.isWritableStream, $2b673d900dbb92a6$var$isReadableStream = $65HYg.isReadableStream;

var $gDydr = parcelRequire("gDydr");
var $2b673d900dbb92a6$var$AbortError = $gDydr.AbortError, $2b673d900dbb92a6$var$_require_codes = $gDydr.codes, $2b673d900dbb92a6$var$ERR_INVALID_ARG_VALUE = $2b673d900dbb92a6$var$_require_codes.ERR_INVALID_ARG_VALUE, $2b673d900dbb92a6$var$ERR_MISSING_ARGS = $2b673d900dbb92a6$var$_require_codes.ERR_MISSING_ARGS;

var $vZAIl = parcelRequire("vZAIl");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $2b673d900dbb92a6$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $kT5fT.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $kT5fT.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $kT5fT.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$2b673d900dbb92a6$var$isNodeStream(streams[n]) && !$2b673d900dbb92a6$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($2b673d900dbb92a6$var$isReadable(streams[n]) || $2b673d900dbb92a6$var$isReadableStream(streams[n]) || $2b673d900dbb92a6$var$isTransformStream(streams[n]))) throw new $2b673d900dbb92a6$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($2b673d900dbb92a6$var$isWritable(streams[n]) || $2b673d900dbb92a6$var$isWritableStream(streams[n]) || $2b673d900dbb92a6$var$isTransformStream(streams[n]))) throw new $2b673d900dbb92a6$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $2b673d900dbb92a6$require$pipeline(streams, onfinished);
    var writable = !!($2b673d900dbb92a6$var$isWritable(head) || $2b673d900dbb92a6$var$isWritableStream(head) || $2b673d900dbb92a6$var$isTransformStream(head));
    var readable = !!($2b673d900dbb92a6$var$isReadable(tail) || $2b673d900dbb92a6$var$isReadableStream(tail) || $2b673d900dbb92a6$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $kT5fT({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($2b673d900dbb92a6$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($2b673d900dbb92a6$var$isWebStream(head)) {
            var writable1 = $2b673d900dbb92a6$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $2b673d900dbb92a6$var$isTransformStream(tail) ? tail.readable : tail;
        $vZAIl(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($2b673d900dbb92a6$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($2b673d900dbb92a6$var$isWebStream(tail)) {
            var readable1 = $2b673d900dbb92a6$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2b673d900dbb92a6$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($2b673d900dbb92a6$var$isNodeStream(tail)) $2b673d900dbb92a6$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("khkUM", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $ec359e6fe73218f1$var$ArrayIsArray = $gPFMe.ArrayIsArray, $ec359e6fe73218f1$var$Promise = $gPFMe.Promise, $ec359e6fe73218f1$var$SymbolAsyncIterator = $gPFMe.SymbolAsyncIterator, $ec359e6fe73218f1$var$SymbolDispose = $gPFMe.SymbolDispose;

var $vZAIl = parcelRequire("vZAIl");

var $ec359e6fe73218f1$require$once = (parcelRequire("ivGzv")).once;

var $irwcz = parcelRequire("irwcz");

var $kT5fT = parcelRequire("kT5fT");

var $gDydr = parcelRequire("gDydr");
var $ec359e6fe73218f1$var$aggregateTwoErrors = $gDydr.aggregateTwoErrors, $ec359e6fe73218f1$var$_require_codes = $gDydr.codes, $ec359e6fe73218f1$var$ERR_INVALID_ARG_TYPE = $ec359e6fe73218f1$var$_require_codes.ERR_INVALID_ARG_TYPE, $ec359e6fe73218f1$var$ERR_INVALID_RETURN_VALUE = $ec359e6fe73218f1$var$_require_codes.ERR_INVALID_RETURN_VALUE, $ec359e6fe73218f1$var$ERR_MISSING_ARGS = $ec359e6fe73218f1$var$_require_codes.ERR_MISSING_ARGS, $ec359e6fe73218f1$var$ERR_STREAM_DESTROYED = $ec359e6fe73218f1$var$_require_codes.ERR_STREAM_DESTROYED, $ec359e6fe73218f1$var$ERR_STREAM_PREMATURE_CLOSE = $ec359e6fe73218f1$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $ec359e6fe73218f1$var$AbortError = $gDydr.AbortError;

var $kSEof = parcelRequire("kSEof");
var $ec359e6fe73218f1$var$validateFunction = $kSEof.validateFunction, $ec359e6fe73218f1$var$validateAbortSignal = $kSEof.validateAbortSignal;

var $65HYg = parcelRequire("65HYg");
var $ec359e6fe73218f1$var$isIterable = $65HYg.isIterable, $ec359e6fe73218f1$var$isReadable = $65HYg.isReadable, $ec359e6fe73218f1$var$isReadableNodeStream = $65HYg.isReadableNodeStream, $ec359e6fe73218f1$var$isNodeStream = $65HYg.isNodeStream, $ec359e6fe73218f1$var$isTransformStream = $65HYg.isTransformStream, $ec359e6fe73218f1$var$isWebStream = $65HYg.isWebStream, $ec359e6fe73218f1$var$isReadableStream = $65HYg.isReadableStream, $ec359e6fe73218f1$var$isReadableFinished = $65HYg.isReadableFinished;

var $ec359e6fe73218f1$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $ec359e6fe73218f1$var$PassThrough;
var $ec359e6fe73218f1$var$Readable;
var $ec359e6fe73218f1$var$addAbortListener;
function $ec359e6fe73218f1$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $vZAIl(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $irwcz.destroyer(stream, err || new $ec359e6fe73218f1$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $ec359e6fe73218f1$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $ec359e6fe73218f1$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $ec359e6fe73218f1$var$makeAsyncIterable(val) {
    if ($ec359e6fe73218f1$var$isIterable(val)) return val;
    else if ($ec359e6fe73218f1$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $ec359e6fe73218f1$var$fromReadable(val);
    throw new $ec359e6fe73218f1$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $ec359e6fe73218f1$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$ec359e6fe73218f1$var$Readable) $ec359e6fe73218f1$var$Readable = (parcelRequire("lOqOF"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($ec359e6fe73218f1$var$Readable.prototype[$ec359e6fe73218f1$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $ec359e6fe73218f1$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $ec359e6fe73218f1$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $vZAIl(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $ec359e6fe73218f1$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ec359e6fe73218f1$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($ec359e6fe73218f1$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ec359e6fe73218f1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $ec359e6fe73218f1$var$pipelineImpl(streams, $ec359e6fe73218f1$require$once($ec359e6fe73218f1$var$popCallback(streams)));
}


function $ec359e6fe73218f1$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($ec359e6fe73218f1$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $ec359e6fe73218f1$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($ec359e6fe73218f1$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($ec359e6fe73218f1$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$ec359e6fe73218f1$var$isIterable(ret)) throw new $ec359e6fe73218f1$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($ec359e6fe73218f1$var$isIterable(stream) || $ec359e6fe73218f1$var$isReadableNodeStream(stream) || $ec359e6fe73218f1$var$isTransformStream(stream)) ret = stream;
            else ret = $kT5fT.from(stream);
        } else if (typeof stream === 'function') {
            if ($ec359e6fe73218f1$var$isTransformStream(ret)) {
                var _ret;
                ret = $ec359e6fe73218f1$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $ec359e6fe73218f1$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$ec359e6fe73218f1$var$isIterable(ret, true)) throw new $ec359e6fe73218f1$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$ec359e6fe73218f1$var$PassThrough) $ec359e6fe73218f1$var$PassThrough = (parcelRequire("a6J00"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $ec359e6fe73218f1$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($ec359e6fe73218f1$var$isIterable(ret, true)) {
                    finishCount++;
                    $ec359e6fe73218f1$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($ec359e6fe73218f1$var$isReadableStream(ret) || $ec359e6fe73218f1$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $ec359e6fe73218f1$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $ec359e6fe73218f1$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $ec359e6fe73218f1$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($ec359e6fe73218f1$var$isNodeStream(stream)) {
            if ($ec359e6fe73218f1$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $ec359e6fe73218f1$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($ec359e6fe73218f1$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($ec359e6fe73218f1$var$isTransformStream(ret) || $ec359e6fe73218f1$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $ec359e6fe73218f1$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($ec359e6fe73218f1$var$isIterable(ret)) {
                finishCount++;
                $ec359e6fe73218f1$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $ec359e6fe73218f1$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($ec359e6fe73218f1$var$isWebStream(stream)) {
            if ($ec359e6fe73218f1$var$isReadableNodeStream(ret)) {
                finishCount++;
                $ec359e6fe73218f1$var$pumpToWeb($ec359e6fe73218f1$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($ec359e6fe73218f1$var$isReadableStream(ret) || $ec359e6fe73218f1$var$isIterable(ret)) {
                finishCount++;
                $ec359e6fe73218f1$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($ec359e6fe73218f1$var$isTransformStream(ret)) {
                finishCount++;
                $ec359e6fe73218f1$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $ec359e6fe73218f1$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $kT5fT.from(stream);
    };
    if (streams.length === 1 && $ec359e6fe73218f1$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ec359e6fe73218f1$var$ERR_MISSING_ARGS('streams');
    var ac = new $ec359e6fe73218f1$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $ec359e6fe73218f1$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $ec359e6fe73218f1$var$AbortError());
    }
    $ec359e6fe73218f1$var$addAbortListener = $ec359e6fe73218f1$var$addAbortListener || (parcelRequire("ivGzv")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $ec359e6fe73218f1$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$ec359e6fe73218f1$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $ec359e6fe73218f1$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $ec359e6fe73218f1$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($ec359e6fe73218f1$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $vZAIl(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $vZAIl(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $ec359e6fe73218f1$var$pipelineImpl,
    pipeline: $ec359e6fe73218f1$var$pipeline
};

});
parcelRegister("irwcz", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $gDydr = parcelRequire("gDydr");
/* replacement end */ var $d6d3ba2ea9f04f83$var$aggregateTwoErrors = $gDydr.aggregateTwoErrors, $d6d3ba2ea9f04f83$var$ERR_MULTIPLE_CALLBACK = $gDydr.codes.ERR_MULTIPLE_CALLBACK, $d6d3ba2ea9f04f83$var$AbortError = $gDydr.AbortError;

var $gPFMe = parcelRequire("gPFMe");
var $d6d3ba2ea9f04f83$require$Symbol = $gPFMe.Symbol;

var $65HYg = parcelRequire("65HYg");
var $d6d3ba2ea9f04f83$var$kIsDestroyed = $65HYg.kIsDestroyed, $d6d3ba2ea9f04f83$var$isDestroyed = $65HYg.isDestroyed, $d6d3ba2ea9f04f83$var$isFinished = $65HYg.isFinished, $d6d3ba2ea9f04f83$var$isServerRequest = $65HYg.isServerRequest;
var $d6d3ba2ea9f04f83$var$kDestroy = $d6d3ba2ea9f04f83$require$Symbol('kDestroy');
var $d6d3ba2ea9f04f83$var$kConstruct = $d6d3ba2ea9f04f83$require$Symbol('kConstruct');
function $d6d3ba2ea9f04f83$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $d6d3ba2ea9f04f83$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $d6d3ba2ea9f04f83$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($d6d3ba2ea9f04f83$var$kDestroy, function(er) {
        $d6d3ba2ea9f04f83$var$_destroy(this, $d6d3ba2ea9f04f83$var$aggregateTwoErrors(er, err), cb);
    });
    else $d6d3ba2ea9f04f83$var$_destroy(this, err, cb);
    return this;
}
function $d6d3ba2ea9f04f83$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $d6d3ba2ea9f04f83$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $d6d3ba2ea9f04f83$var$emitErrorCloseNT(self, err) {
    $d6d3ba2ea9f04f83$var$emitErrorNT(self, err);
    $d6d3ba2ea9f04f83$var$emitCloseNT(self);
}
function $d6d3ba2ea9f04f83$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $d6d3ba2ea9f04f83$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $d6d3ba2ea9f04f83$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $d6d3ba2ea9f04f83$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitErrorNT, stream, err);
        else $d6d3ba2ea9f04f83$var$emitErrorNT(stream, err);
    }
}
function $d6d3ba2ea9f04f83$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($d6d3ba2ea9f04f83$var$kConstruct, cb);
    if (stream.listenerCount($d6d3ba2ea9f04f83$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$constructNT, stream);
}
function $d6d3ba2ea9f04f83$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $d6d3ba2ea9f04f83$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $d6d3ba2ea9f04f83$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($d6d3ba2ea9f04f83$var$kDestroy, err);
        else if (err) $d6d3ba2ea9f04f83$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $d6d3ba2ea9f04f83$var$emitConstructNT(stream) {
    stream.emit($d6d3ba2ea9f04f83$var$kConstruct);
}
function $d6d3ba2ea9f04f83$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $d6d3ba2ea9f04f83$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $d6d3ba2ea9f04f83$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $d6d3ba2ea9f04f83$var$destroyer(stream, err) {
    if (!stream || $d6d3ba2ea9f04f83$var$isDestroyed(stream)) return;
    if (!err && !$d6d3ba2ea9f04f83$var$isFinished(stream)) err = new $d6d3ba2ea9f04f83$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($d6d3ba2ea9f04f83$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($d6d3ba2ea9f04f83$var$isRequest(stream)) stream.abort();
    else if ($d6d3ba2ea9f04f83$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($d6d3ba2ea9f04f83$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$d6d3ba2ea9f04f83$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $d6d3ba2ea9f04f83$var$construct,
    destroyer: $d6d3ba2ea9f04f83$var$destroyer,
    destroy: $d6d3ba2ea9f04f83$var$destroy,
    undestroy: $d6d3ba2ea9f04f83$var$undestroy,
    errorOrDestroy: $d6d3ba2ea9f04f83$var$errorOrDestroy
};

});

parcelRegister("kT5fT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $f34d0552c9f69c33$var$ObjectDefineProperties = $gPFMe.ObjectDefineProperties, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor = $gPFMe.ObjectGetOwnPropertyDescriptor, $f34d0552c9f69c33$var$ObjectKeys = $gPFMe.ObjectKeys, $f34d0552c9f69c33$var$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf;
module.exports = $f34d0552c9f69c33$var$Duplex;

var $lOqOF = parcelRequire("lOqOF");

var $2ArKA = parcelRequire("2ArKA");
$f34d0552c9f69c33$var$ObjectSetPrototypeOf($f34d0552c9f69c33$var$Duplex.prototype, $lOqOF.prototype);
$f34d0552c9f69c33$var$ObjectSetPrototypeOf($f34d0552c9f69c33$var$Duplex, $lOqOF);
{
    var $f34d0552c9f69c33$var$keys = $f34d0552c9f69c33$var$ObjectKeys($2ArKA.prototype);
    // Allow the keys array to be GC'ed.
    for(var $f34d0552c9f69c33$var$i = 0; $f34d0552c9f69c33$var$i < $f34d0552c9f69c33$var$keys.length; $f34d0552c9f69c33$var$i++){
        var $f34d0552c9f69c33$var$method = $f34d0552c9f69c33$var$keys[$f34d0552c9f69c33$var$i];
        if (!$f34d0552c9f69c33$var$Duplex.prototype[$f34d0552c9f69c33$var$method]) $f34d0552c9f69c33$var$Duplex.prototype[$f34d0552c9f69c33$var$method] = $2ArKA.prototype[$f34d0552c9f69c33$var$method];
    }
}function $f34d0552c9f69c33$var$Duplex(options) {
    if (!(this instanceof $f34d0552c9f69c33$var$Duplex)) return new $f34d0552c9f69c33$var$Duplex(options);
    $lOqOF.call(this, options);
    $2ArKA.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$f34d0552c9f69c33$var$ObjectDefineProperties($f34d0552c9f69c33$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $f34d0552c9f69c33$var$ObjectGetOwnPropertyDescriptor($2ArKA.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $f34d0552c9f69c33$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f34d0552c9f69c33$var$lazyWebStreams() {
    if ($f34d0552c9f69c33$var$webStreamsAdapters === undefined) $f34d0552c9f69c33$var$webStreamsAdapters = {};
    return $f34d0552c9f69c33$var$webStreamsAdapters;
}
$f34d0552c9f69c33$var$Duplex.fromWeb = function(pair, options) {
    return $f34d0552c9f69c33$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$f34d0552c9f69c33$var$Duplex.toWeb = function(duplex) {
    return $f34d0552c9f69c33$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $f34d0552c9f69c33$var$duplexify;

$f34d0552c9f69c33$var$Duplex.from = function(body) {
    if (!$f34d0552c9f69c33$var$duplexify) $f34d0552c9f69c33$var$duplexify = (parcelRequire("1xCo0"));
    return $f34d0552c9f69c33$var$duplexify(body, 'body');
};

});
parcelRegister("lOqOF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $gPFMe = parcelRequire("gPFMe");
/* replacement end */ var $fe1311a465a06abc$var$ArrayPrototypeIndexOf = $gPFMe.ArrayPrototypeIndexOf, $fe1311a465a06abc$var$NumberIsInteger = $gPFMe.NumberIsInteger, $fe1311a465a06abc$var$NumberIsNaN = $gPFMe.NumberIsNaN, $fe1311a465a06abc$var$NumberParseInt = $gPFMe.NumberParseInt, $fe1311a465a06abc$var$ObjectDefineProperties = $gPFMe.ObjectDefineProperties, $fe1311a465a06abc$var$ObjectKeys = $gPFMe.ObjectKeys, $fe1311a465a06abc$var$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf, $fe1311a465a06abc$var$Promise = $gPFMe.Promise, $fe1311a465a06abc$var$SafeSet = $gPFMe.SafeSet, $fe1311a465a06abc$var$SymbolAsyncDispose = $gPFMe.SymbolAsyncDispose, $fe1311a465a06abc$var$SymbolAsyncIterator = $gPFMe.SymbolAsyncIterator, $fe1311a465a06abc$var$Symbol = $gPFMe.Symbol;
module.exports = $fe1311a465a06abc$var$Readable;
$fe1311a465a06abc$var$Readable.ReadableState = $fe1311a465a06abc$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $fe1311a465a06abc$var$EE = $bBoAO.EventEmitter;

var $daBj0 = parcelRequire("daBj0");
var $fe1311a465a06abc$var$Stream = $daBj0.Stream, $fe1311a465a06abc$var$prependListener = $daBj0.prependListener;

var $eIVzI = parcelRequire("eIVzI");
var $fe1311a465a06abc$require$Buffer = $eIVzI.Buffer;

var $32Tj5 = parcelRequire("32Tj5");
var $fe1311a465a06abc$require$addAbortSignal = $32Tj5.addAbortSignal;

var $vZAIl = parcelRequire("vZAIl");

var $fe1311a465a06abc$var$debug = (parcelRequire("ivGzv")).debuglog('stream', function(fn) {
    $fe1311a465a06abc$var$debug = fn;
});

var $azyjf = parcelRequire("azyjf");

var $irwcz = parcelRequire("irwcz");

var $iAzvv = parcelRequire("iAzvv");
var $fe1311a465a06abc$var$getHighWaterMark = $iAzvv.getHighWaterMark, $fe1311a465a06abc$var$getDefaultHighWaterMark = $iAzvv.getDefaultHighWaterMark;

var $gDydr = parcelRequire("gDydr");
var $fe1311a465a06abc$var$aggregateTwoErrors = $gDydr.aggregateTwoErrors, $fe1311a465a06abc$var$_require_codes = $gDydr.codes, $fe1311a465a06abc$var$ERR_INVALID_ARG_TYPE = $fe1311a465a06abc$var$_require_codes.ERR_INVALID_ARG_TYPE, $fe1311a465a06abc$var$ERR_METHOD_NOT_IMPLEMENTED = $fe1311a465a06abc$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $fe1311a465a06abc$var$ERR_OUT_OF_RANGE = $fe1311a465a06abc$var$_require_codes.ERR_OUT_OF_RANGE, $fe1311a465a06abc$var$ERR_STREAM_PUSH_AFTER_EOF = $fe1311a465a06abc$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $fe1311a465a06abc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $fe1311a465a06abc$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $fe1311a465a06abc$var$AbortError = $gDydr.AbortError;

var $kSEof = parcelRequire("kSEof");
var $fe1311a465a06abc$require$validateObject = $kSEof.validateObject;
var $fe1311a465a06abc$var$kPaused = $fe1311a465a06abc$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $fe1311a465a06abc$require$StringDecoder = $3Jf7C.StringDecoder;

var $5boRJ = parcelRequire("5boRJ");
$fe1311a465a06abc$var$ObjectSetPrototypeOf($fe1311a465a06abc$var$Readable.prototype, $fe1311a465a06abc$var$Stream.prototype);
$fe1311a465a06abc$var$ObjectSetPrototypeOf($fe1311a465a06abc$var$Readable, $fe1311a465a06abc$var$Stream);
var $fe1311a465a06abc$var$nop = function() {};
var $fe1311a465a06abc$var$errorOrDestroy = $irwcz.errorOrDestroy;
var $fe1311a465a06abc$var$kObjectMode = 1;
var $fe1311a465a06abc$var$kEnded = 2;
var $fe1311a465a06abc$var$kEndEmitted = 4;
var $fe1311a465a06abc$var$kReading = 8;
var $fe1311a465a06abc$var$kConstructed = 16;
var $fe1311a465a06abc$var$kSync = 32;
var $fe1311a465a06abc$var$kNeedReadable = 64;
var $fe1311a465a06abc$var$kEmittedReadable = 128;
var $fe1311a465a06abc$var$kReadableListening = 256;
var $fe1311a465a06abc$var$kResumeScheduled = 512;
var $fe1311a465a06abc$var$kErrorEmitted = 1024;
var $fe1311a465a06abc$var$kEmitClose = 2048;
var $fe1311a465a06abc$var$kAutoDestroy = 4096;
var $fe1311a465a06abc$var$kDestroyed = 8192;
var $fe1311a465a06abc$var$kClosed = 16384;
var $fe1311a465a06abc$var$kCloseEmitted = 32768;
var $fe1311a465a06abc$var$kMultiAwaitDrain = 65536;
var $fe1311a465a06abc$var$kReadingMore = 131072;
var $fe1311a465a06abc$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $fe1311a465a06abc$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$fe1311a465a06abc$var$ObjectDefineProperties($fe1311a465a06abc$var$ReadableState.prototype, {
    objectMode: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kObjectMode),
    ended: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kEnded),
    endEmitted: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kEndEmitted),
    reading: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kNeedReadable),
    emittedReadable: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kEmittedReadable),
    readableListening: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kReadableListening),
    resumeScheduled: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kErrorEmitted),
    emitClose: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kEmitClose),
    autoDestroy: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kCloseEmitted),
    multiAwaitDrain: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kReadingMore),
    dataEmitted: $fe1311a465a06abc$var$makeBitMapDescriptor($fe1311a465a06abc$var$kDataEmitted)
});

function $fe1311a465a06abc$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kT5fT"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $fe1311a465a06abc$var$kEmitClose | $fe1311a465a06abc$var$kAutoDestroy | $fe1311a465a06abc$var$kConstructed | $fe1311a465a06abc$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $fe1311a465a06abc$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $fe1311a465a06abc$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $fe1311a465a06abc$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $fe1311a465a06abc$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $azyjf();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$fe1311a465a06abc$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$fe1311a465a06abc$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$fe1311a465a06abc$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $fe1311a465a06abc$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $fe1311a465a06abc$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $fe1311a465a06abc$var$Readable)) return new $fe1311a465a06abc$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("kT5fT"));
    this._readableState = new $fe1311a465a06abc$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $fe1311a465a06abc$require$addAbortSignal(options.signal, this);
    }
    $fe1311a465a06abc$var$Stream.call(this, options);
    $irwcz.construct(this, function() {
        if (_this._readableState.needReadable) $fe1311a465a06abc$var$maybeReadMore(_this, _this._readableState);
    });
}
$fe1311a465a06abc$var$Readable.prototype.destroy = $irwcz.destroy;
$fe1311a465a06abc$var$Readable.prototype._undestroy = $irwcz.undestroy;
$fe1311a465a06abc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$fe1311a465a06abc$var$Readable.prototype[$fe1311a465a06abc$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$fe1311a465a06abc$var$Readable.prototype[$fe1311a465a06abc$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $fe1311a465a06abc$var$AbortError();
        this.destroy(error);
    }
    return new $fe1311a465a06abc$var$Promise(function(resolve, reject) {
        return $vZAIl(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$fe1311a465a06abc$var$Readable.prototype.push = function(chunk, encoding) {
    return $fe1311a465a06abc$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$fe1311a465a06abc$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $fe1311a465a06abc$var$readableAddChunk(this, chunk, encoding, true);
};
function $fe1311a465a06abc$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $fe1311a465a06abc$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $fe1311a465a06abc$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $fe1311a465a06abc$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $fe1311a465a06abc$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $fe1311a465a06abc$require$Buffer) encoding = '';
        else if ($fe1311a465a06abc$var$Stream._isUint8Array(chunk)) {
            chunk = $fe1311a465a06abc$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $fe1311a465a06abc$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $fe1311a465a06abc$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$fe1311a465a06abc$var$kReading;
        $fe1311a465a06abc$var$onEofChunk(stream, state);
    } else if ((state.state & $fe1311a465a06abc$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $fe1311a465a06abc$var$kEndEmitted) !== 0) $fe1311a465a06abc$var$errorOrDestroy(stream, new $fe1311a465a06abc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $fe1311a465a06abc$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $fe1311a465a06abc$var$errorOrDestroy(stream, new $fe1311a465a06abc$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$fe1311a465a06abc$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $fe1311a465a06abc$var$addChunk(stream, state, chunk, false);
                else $fe1311a465a06abc$var$maybeReadMore(stream, state);
            } else $fe1311a465a06abc$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$fe1311a465a06abc$var$kReading;
        $fe1311a465a06abc$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $fe1311a465a06abc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $fe1311a465a06abc$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $fe1311a465a06abc$var$kNeedReadable) !== 0) $fe1311a465a06abc$var$emitReadable(stream);
    }
    $fe1311a465a06abc$var$maybeReadMore(stream, state);
}
$fe1311a465a06abc$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$fe1311a465a06abc$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$fe1311a465a06abc$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $fe1311a465a06abc$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$fe1311a465a06abc$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $fe1311a465a06abc$var$MAX_HWM = 0x40000000;
function $fe1311a465a06abc$var$computeNewHighWaterMark(n) {
    if (n > $fe1311a465a06abc$var$MAX_HWM) throw new $fe1311a465a06abc$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fe1311a465a06abc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $fe1311a465a06abc$var$kObjectMode) !== 0) return 1;
    if ($fe1311a465a06abc$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$fe1311a465a06abc$var$Readable.prototype.read = function(n) {
    $fe1311a465a06abc$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$fe1311a465a06abc$var$NumberIsInteger(n)) n = $fe1311a465a06abc$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $fe1311a465a06abc$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$fe1311a465a06abc$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $fe1311a465a06abc$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $fe1311a465a06abc$var$endReadable(this);
        else $fe1311a465a06abc$var$emitReadable(this);
        return null;
    }
    n = $fe1311a465a06abc$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $fe1311a465a06abc$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $fe1311a465a06abc$var$kNeedReadable) !== 0;
    $fe1311a465a06abc$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $fe1311a465a06abc$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $fe1311a465a06abc$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $fe1311a465a06abc$var$debug('do read');
        state.state |= $fe1311a465a06abc$var$kReading | $fe1311a465a06abc$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $fe1311a465a06abc$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $fe1311a465a06abc$var$errorOrDestroy(this, err);
        }
        state.state &= ~$fe1311a465a06abc$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $fe1311a465a06abc$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $fe1311a465a06abc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $fe1311a465a06abc$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $fe1311a465a06abc$var$onEofChunk(stream, state) {
    $fe1311a465a06abc$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $fe1311a465a06abc$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $fe1311a465a06abc$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $fe1311a465a06abc$var$emitReadable(stream) {
    var state = stream._readableState;
    $fe1311a465a06abc$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $fe1311a465a06abc$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($fe1311a465a06abc$var$emitReadable_, stream);
    }
}
function $fe1311a465a06abc$var$emitReadable_(stream) {
    var state = stream._readableState;
    $fe1311a465a06abc$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $fe1311a465a06abc$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $fe1311a465a06abc$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($fe1311a465a06abc$var$maybeReadMore_, stream, state);
    }
}
function $fe1311a465a06abc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $fe1311a465a06abc$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$fe1311a465a06abc$var$Readable.prototype._read = function(n) {
    throw new $fe1311a465a06abc$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$fe1311a465a06abc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $fe1311a465a06abc$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $fe1311a465a06abc$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $fe1311a465a06abc$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $fe1311a465a06abc$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $fe1311a465a06abc$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $fe1311a465a06abc$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $fe1311a465a06abc$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $fe1311a465a06abc$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $fe1311a465a06abc$var$debug('ondata');
        var ret = dest.write(chunk);
        $fe1311a465a06abc$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $fe1311a465a06abc$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $fe1311a465a06abc$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $fe1311a465a06abc$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $fe1311a465a06abc$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $fe1311a465a06abc$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $fe1311a465a06abc$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $fe1311a465a06abc$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $fe1311a465a06abc$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $fe1311a465a06abc$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$fe1311a465a06abc$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $fe1311a465a06abc$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$fe1311a465a06abc$var$Readable.prototype.on = function(ev, fn) {
    var res = $fe1311a465a06abc$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $fe1311a465a06abc$var$debug('on readable', state.length, state.reading);
            if (state.length) $fe1311a465a06abc$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($fe1311a465a06abc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$fe1311a465a06abc$var$Readable.prototype.addListener = $fe1311a465a06abc$var$Readable.prototype.on;
$fe1311a465a06abc$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $fe1311a465a06abc$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($fe1311a465a06abc$var$updateReadableListening, this);
    return res;
};
$fe1311a465a06abc$var$Readable.prototype.off = $fe1311a465a06abc$var$Readable.prototype.removeListener;
$fe1311a465a06abc$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $fe1311a465a06abc$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($fe1311a465a06abc$var$updateReadableListening, this);
    return res;
};
function $fe1311a465a06abc$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$fe1311a465a06abc$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $fe1311a465a06abc$var$nReadingNextTick(self) {
    $fe1311a465a06abc$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$fe1311a465a06abc$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $fe1311a465a06abc$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $fe1311a465a06abc$var$resume(this, state);
    }
    state[$fe1311a465a06abc$var$kPaused] = false;
    return this;
};
function $fe1311a465a06abc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($fe1311a465a06abc$var$resume_, stream, state);
    }
}
function $fe1311a465a06abc$var$resume_(stream, state) {
    $fe1311a465a06abc$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $fe1311a465a06abc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$fe1311a465a06abc$var$Readable.prototype.pause = function() {
    $fe1311a465a06abc$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $fe1311a465a06abc$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$fe1311a465a06abc$var$kPaused] = true;
    return this;
};
function $fe1311a465a06abc$var$flow(stream) {
    var state = stream._readableState;
    $fe1311a465a06abc$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$fe1311a465a06abc$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $fe1311a465a06abc$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $fe1311a465a06abc$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$fe1311a465a06abc$var$Readable.prototype[$fe1311a465a06abc$var$SymbolAsyncIterator] = function() {
    return $fe1311a465a06abc$var$streamToAsyncIterator(this);
};
$fe1311a465a06abc$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $fe1311a465a06abc$require$validateObject(options, 'options');
    return $fe1311a465a06abc$var$streamToAsyncIterator(this, options);
};
function $fe1311a465a06abc$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $fe1311a465a06abc$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $fe1311a465a06abc$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $fe1311a465a06abc$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $fe1311a465a06abc$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $fe1311a465a06abc$var$nop;
                    stream.on('readable', next);
                    cleanup = $vZAIl(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $fe1311a465a06abc$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $fe1311a465a06abc$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $fe1311a465a06abc$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $fe1311a465a06abc$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $irwcz.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$fe1311a465a06abc$var$ObjectDefineProperties($fe1311a465a06abc$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$fe1311a465a06abc$var$ObjectDefineProperties($fe1311a465a06abc$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$fe1311a465a06abc$var$kPaused] !== false;
        },
        set: function(value) {
            this[$fe1311a465a06abc$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$fe1311a465a06abc$var$Readable._fromList = $fe1311a465a06abc$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fe1311a465a06abc$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $fe1311a465a06abc$var$endReadable(stream) {
    var state = stream._readableState;
    $fe1311a465a06abc$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($fe1311a465a06abc$var$endReadableNT, state, stream);
    }
}
function $fe1311a465a06abc$var$endReadableNT(state, stream) {
    $fe1311a465a06abc$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($fe1311a465a06abc$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $fe1311a465a06abc$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$fe1311a465a06abc$var$Readable.from = function(iterable, opts) {
    return $5boRJ($fe1311a465a06abc$var$Readable, iterable, opts);
};
var $fe1311a465a06abc$var$webStreamsAdapters;
// Lazy to avoid circular references
function $fe1311a465a06abc$var$lazyWebStreams() {
    if ($fe1311a465a06abc$var$webStreamsAdapters === undefined) $fe1311a465a06abc$var$webStreamsAdapters = {};
    return $fe1311a465a06abc$var$webStreamsAdapters;
}
$fe1311a465a06abc$var$Readable.fromWeb = function(readableStream, options) {
    return $fe1311a465a06abc$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$fe1311a465a06abc$var$Readable.toWeb = function(streamReadable, options) {
    return $fe1311a465a06abc$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$fe1311a465a06abc$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $fe1311a465a06abc$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $irwcz.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("daBj0", function(module, exports) {
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $9969259dce83636e$var$ArrayIsArray = $gPFMe.ArrayIsArray, $9969259dce83636e$var$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $9969259dce83636e$var$EE = $bBoAO.EventEmitter;
function $9969259dce83636e$var$Stream(opts) {
    $9969259dce83636e$var$EE.call(this, opts);
}
$9969259dce83636e$var$ObjectSetPrototypeOf($9969259dce83636e$var$Stream.prototype, $9969259dce83636e$var$EE.prototype);
$9969259dce83636e$var$ObjectSetPrototypeOf($9969259dce83636e$var$Stream, $9969259dce83636e$var$EE);
$9969259dce83636e$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($9969259dce83636e$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $9969259dce83636e$var$prependListener(source, 'error', onerror);
    $9969259dce83636e$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $9969259dce83636e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($9969259dce83636e$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $9969259dce83636e$var$Stream,
    prependListener: $9969259dce83636e$var$prependListener
};

});

parcelRegister("32Tj5", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $237c75cc2d6f2180$export$e2db56ee53255a0; }, function (v) { return $237c75cc2d6f2180$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $237c75cc2d6f2180$export$11956e9313f43de0; }, function (v) { return $237c75cc2d6f2180$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $237c75cc2d6f2180$export$e2db56ee53255a0;
var $237c75cc2d6f2180$export$11956e9313f43de0;
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $237c75cc2d6f2180$require$SymbolDispose = $gPFMe.SymbolDispose;

var $gDydr = parcelRequire("gDydr");
var $237c75cc2d6f2180$var$AbortError = $gDydr.AbortError, $237c75cc2d6f2180$var$codes = $gDydr.codes;

var $65HYg = parcelRequire("65HYg");
var $237c75cc2d6f2180$var$isNodeStream = $65HYg.isNodeStream, $237c75cc2d6f2180$var$isWebStream = $65HYg.isWebStream, $237c75cc2d6f2180$var$kControllerErrorFunction = $65HYg.kControllerErrorFunction;

var $vZAIl = parcelRequire("vZAIl");
var $237c75cc2d6f2180$var$ERR_INVALID_ARG_TYPE = $237c75cc2d6f2180$var$codes.ERR_INVALID_ARG_TYPE;
var $237c75cc2d6f2180$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $237c75cc2d6f2180$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $237c75cc2d6f2180$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$237c75cc2d6f2180$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $237c75cc2d6f2180$var$validateAbortSignal(signal, 'signal');
    if (!$237c75cc2d6f2180$var$isNodeStream(stream) && !$237c75cc2d6f2180$var$isWebStream(stream)) throw new $237c75cc2d6f2180$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $237c75cc2d6f2180$export$11956e9313f43de0(signal, stream);
};

$237c75cc2d6f2180$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $237c75cc2d6f2180$var$isNodeStream(stream) ? function() {
        stream.destroy(new $237c75cc2d6f2180$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$237c75cc2d6f2180$var$kControllerErrorFunction](new $237c75cc2d6f2180$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $237c75cc2d6f2180$var$addAbortListener = $237c75cc2d6f2180$var$addAbortListener || (parcelRequire("ivGzv")).addAbortListener;
        var disposable = $237c75cc2d6f2180$var$addAbortListener(signal, onAbort);
        $vZAIl(stream, disposable[$237c75cc2d6f2180$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("azyjf", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $7b27c96a2b06b1b0$var$StringPrototypeSlice = $gPFMe.StringPrototypeSlice, $7b27c96a2b06b1b0$var$SymbolIterator = $gPFMe.SymbolIterator, $7b27c96a2b06b1b0$var$TypedArrayPrototypeSet = $gPFMe.TypedArrayPrototypeSet, $7b27c96a2b06b1b0$var$Uint8Array = $gPFMe.Uint8Array;

var $eIVzI = parcelRequire("eIVzI");
var $7b27c96a2b06b1b0$require$Buffer = $eIVzI.Buffer;

var $ivGzv = parcelRequire("ivGzv");
var $7b27c96a2b06b1b0$require$inspect = $ivGzv.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7b27c96a2b06b1b0$require$Buffer.alloc(0);
                var ret = $7b27c96a2b06b1b0$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7b27c96a2b06b1b0$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $7b27c96a2b06b1b0$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $7b27c96a2b06b1b0$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $7b27c96a2b06b1b0$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7b27c96a2b06b1b0$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $7b27c96a2b06b1b0$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $7b27c96a2b06b1b0$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $7b27c96a2b06b1b0$var$TypedArrayPrototypeSet(ret, new $7b27c96a2b06b1b0$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $7b27c96a2b06b1b0$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("iAzvv", function(module, exports) {
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $d88721c304b29b63$var$MathFloor = $gPFMe.MathFloor, $d88721c304b29b63$var$NumberIsInteger = $gPFMe.NumberIsInteger;

var $kSEof = parcelRequire("kSEof");
var $d88721c304b29b63$require$validateInteger = $kSEof.validateInteger;

var $d88721c304b29b63$var$ERR_INVALID_ARG_VALUE = (parcelRequire("gDydr")).codes.ERR_INVALID_ARG_VALUE;
var $d88721c304b29b63$var$defaultHighWaterMarkBytes = 16384;
var $d88721c304b29b63$var$defaultHighWaterMarkObjectMode = 16;
function $d88721c304b29b63$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d88721c304b29b63$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $d88721c304b29b63$var$defaultHighWaterMarkObjectMode : $d88721c304b29b63$var$defaultHighWaterMarkBytes;
}
function $d88721c304b29b63$var$setDefaultHighWaterMark(objectMode, value) {
    $d88721c304b29b63$require$validateInteger(value, 'value', 0);
    if (objectMode) $d88721c304b29b63$var$defaultHighWaterMarkObjectMode = value;
    else $d88721c304b29b63$var$defaultHighWaterMarkBytes = value;
}
function $d88721c304b29b63$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d88721c304b29b63$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$d88721c304b29b63$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $d88721c304b29b63$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $d88721c304b29b63$var$MathFloor(hwm);
    }
    // Default value
    return $d88721c304b29b63$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $d88721c304b29b63$var$getHighWaterMark,
    getDefaultHighWaterMark: $d88721c304b29b63$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $d88721c304b29b63$var$setDefaultHighWaterMark
};

});

parcelRegister("5boRJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $gPFMe = parcelRequire("gPFMe");
/* replacement end */ var $3c61449c26844e13$var$PromisePrototypeThen = $gPFMe.PromisePrototypeThen, $3c61449c26844e13$var$SymbolAsyncIterator = $gPFMe.SymbolAsyncIterator, $3c61449c26844e13$var$SymbolIterator = $gPFMe.SymbolIterator;

var $eIVzI = parcelRequire("eIVzI");
var $3c61449c26844e13$require$Buffer = $eIVzI.Buffer;

var $gDydr = parcelRequire("gDydr");
var $3c61449c26844e13$require$_require_codes = $gDydr.codes;
var $3c61449c26844e13$var$ERR_INVALID_ARG_TYPE = $3c61449c26844e13$require$_require_codes.ERR_INVALID_ARG_TYPE, $3c61449c26844e13$var$ERR_STREAM_NULL_VALUES = $3c61449c26844e13$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $3c61449c26844e13$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $3c61449c26844e13$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$3c61449c26844e13$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$3c61449c26844e13$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$3c61449c26844e13$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$3c61449c26844e13$var$SymbolIterator]();
    } else throw new $3c61449c26844e13$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $3c61449c26844e13$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $3c61449c26844e13$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $3c61449c26844e13$var$from;

});


parcelRegister("2ArKA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $gPFMe = parcelRequire("gPFMe");
/* replacement end */ var $1e24783d581a3bbc$var$ArrayPrototypeSlice = $gPFMe.ArrayPrototypeSlice, $1e24783d581a3bbc$var$Error = $gPFMe.Error, $1e24783d581a3bbc$var$FunctionPrototypeSymbolHasInstance = $gPFMe.FunctionPrototypeSymbolHasInstance, $1e24783d581a3bbc$var$ObjectDefineProperty = $gPFMe.ObjectDefineProperty, $1e24783d581a3bbc$var$ObjectDefineProperties = $gPFMe.ObjectDefineProperties, $1e24783d581a3bbc$var$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf, $1e24783d581a3bbc$var$StringPrototypeToLowerCase = $gPFMe.StringPrototypeToLowerCase, $1e24783d581a3bbc$var$Symbol = $gPFMe.Symbol, $1e24783d581a3bbc$var$SymbolHasInstance = $gPFMe.SymbolHasInstance;
module.exports = $1e24783d581a3bbc$var$Writable;
$1e24783d581a3bbc$var$Writable.WritableState = $1e24783d581a3bbc$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $1e24783d581a3bbc$var$EE = $bBoAO.EventEmitter;

var $daBj0 = parcelRequire("daBj0");
var $1e24783d581a3bbc$require$Stream = $daBj0.Stream;

var $eIVzI = parcelRequire("eIVzI");
var $1e24783d581a3bbc$require$Buffer = $eIVzI.Buffer;

var $irwcz = parcelRequire("irwcz");

var $32Tj5 = parcelRequire("32Tj5");
var $1e24783d581a3bbc$require$addAbortSignal = $32Tj5.addAbortSignal;

var $iAzvv = parcelRequire("iAzvv");
var $1e24783d581a3bbc$var$getHighWaterMark = $iAzvv.getHighWaterMark, $1e24783d581a3bbc$var$getDefaultHighWaterMark = $iAzvv.getDefaultHighWaterMark;

var $gDydr = parcelRequire("gDydr");
var $1e24783d581a3bbc$require$_require_codes = $gDydr.codes;
var $1e24783d581a3bbc$var$ERR_INVALID_ARG_TYPE = $1e24783d581a3bbc$require$_require_codes.ERR_INVALID_ARG_TYPE, $1e24783d581a3bbc$var$ERR_METHOD_NOT_IMPLEMENTED = $1e24783d581a3bbc$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $1e24783d581a3bbc$var$ERR_MULTIPLE_CALLBACK = $1e24783d581a3bbc$require$_require_codes.ERR_MULTIPLE_CALLBACK, $1e24783d581a3bbc$var$ERR_STREAM_CANNOT_PIPE = $1e24783d581a3bbc$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED = $1e24783d581a3bbc$require$_require_codes.ERR_STREAM_DESTROYED, $1e24783d581a3bbc$var$ERR_STREAM_ALREADY_FINISHED = $1e24783d581a3bbc$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $1e24783d581a3bbc$var$ERR_STREAM_NULL_VALUES = $1e24783d581a3bbc$require$_require_codes.ERR_STREAM_NULL_VALUES, $1e24783d581a3bbc$var$ERR_STREAM_WRITE_AFTER_END = $1e24783d581a3bbc$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $1e24783d581a3bbc$var$ERR_UNKNOWN_ENCODING = $1e24783d581a3bbc$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $1e24783d581a3bbc$var$errorOrDestroy = $irwcz.errorOrDestroy;
$1e24783d581a3bbc$var$ObjectSetPrototypeOf($1e24783d581a3bbc$var$Writable.prototype, $1e24783d581a3bbc$require$Stream.prototype);
$1e24783d581a3bbc$var$ObjectSetPrototypeOf($1e24783d581a3bbc$var$Writable, $1e24783d581a3bbc$require$Stream);
function $1e24783d581a3bbc$var$nop() {}
var $1e24783d581a3bbc$var$kOnFinished = $1e24783d581a3bbc$var$Symbol('kOnFinished');

function $1e24783d581a3bbc$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kT5fT"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $1e24783d581a3bbc$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $1e24783d581a3bbc$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $1e24783d581a3bbc$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $1e24783d581a3bbc$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$1e24783d581a3bbc$var$kOnFinished] = [];
}
function $1e24783d581a3bbc$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$1e24783d581a3bbc$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $1e24783d581a3bbc$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$1e24783d581a3bbc$var$ObjectDefineProperty($1e24783d581a3bbc$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $1e24783d581a3bbc$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("kT5fT"));
    if (!isDuplex && !$1e24783d581a3bbc$var$FunctionPrototypeSymbolHasInstance($1e24783d581a3bbc$var$Writable, this)) return new $1e24783d581a3bbc$var$Writable(options);
    this._writableState = new $1e24783d581a3bbc$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $1e24783d581a3bbc$require$addAbortSignal(options.signal, this);
    }
    $1e24783d581a3bbc$require$Stream.call(this, options);
    $irwcz.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $1e24783d581a3bbc$var$clearBuffer(_this, state);
        $1e24783d581a3bbc$var$finishMaybe(_this, state);
    });
}
$1e24783d581a3bbc$var$ObjectDefineProperty($1e24783d581a3bbc$var$Writable, $1e24783d581a3bbc$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($1e24783d581a3bbc$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $1e24783d581a3bbc$var$Writable) return false;
        return object && object._writableState instanceof $1e24783d581a3bbc$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$1e24783d581a3bbc$var$Writable.prototype.pipe = function() {
    $1e24783d581a3bbc$var$errorOrDestroy(this, new $1e24783d581a3bbc$var$ERR_STREAM_CANNOT_PIPE());
};
function $1e24783d581a3bbc$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$1e24783d581a3bbc$require$Buffer.isEncoding(encoding)) throw new $1e24783d581a3bbc$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $1e24783d581a3bbc$var$nop;
    }
    if (chunk === null) throw new $1e24783d581a3bbc$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $1e24783d581a3bbc$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $1e24783d581a3bbc$require$Buffer) encoding = 'buffer';
        else if ($1e24783d581a3bbc$require$Stream._isUint8Array(chunk)) {
            chunk = $1e24783d581a3bbc$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $1e24783d581a3bbc$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $1e24783d581a3bbc$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $1e24783d581a3bbc$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $1e24783d581a3bbc$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$1e24783d581a3bbc$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $1e24783d581a3bbc$var$_write(this, chunk, encoding, cb) === true;
};
$1e24783d581a3bbc$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1e24783d581a3bbc$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $1e24783d581a3bbc$var$clearBuffer(this, state);
    }
};
$1e24783d581a3bbc$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $1e24783d581a3bbc$var$StringPrototypeToLowerCase(encoding);
    if (!$1e24783d581a3bbc$require$Buffer.isEncoding(encoding)) throw new $1e24783d581a3bbc$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1e24783d581a3bbc$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $1e24783d581a3bbc$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $1e24783d581a3bbc$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1e24783d581a3bbc$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $1e24783d581a3bbc$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $1e24783d581a3bbc$var$errorOrDestroy(stream, er);
}
function $1e24783d581a3bbc$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $1e24783d581a3bbc$var$errorOrDestroy(stream, new $1e24783d581a3bbc$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($1e24783d581a3bbc$var$onwriteError, stream, state, er, cb);
        else $1e24783d581a3bbc$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $1e24783d581a3bbc$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($1e24783d581a3bbc$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $1e24783d581a3bbc$var$afterWrite(stream, state, 1, cb);
    }
}
function $1e24783d581a3bbc$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $1e24783d581a3bbc$var$afterWrite(stream, state, count, cb);
}
function $1e24783d581a3bbc$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $1e24783d581a3bbc$var$errorBuffer(state);
    $1e24783d581a3bbc$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $1e24783d581a3bbc$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$1e24783d581a3bbc$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED('end'));
    }
    $1e24783d581a3bbc$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $1e24783d581a3bbc$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $1e24783d581a3bbc$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $1e24783d581a3bbc$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $1e24783d581a3bbc$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $1e24783d581a3bbc$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $1e24783d581a3bbc$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $1e24783d581a3bbc$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$1e24783d581a3bbc$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $1e24783d581a3bbc$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$1e24783d581a3bbc$var$Writable.prototype._writev = null;
$1e24783d581a3bbc$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $1e24783d581a3bbc$var$_write(this, chunk, encoding);
        if (ret instanceof $1e24783d581a3bbc$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $1e24783d581a3bbc$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $1e24783d581a3bbc$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $1e24783d581a3bbc$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$1e24783d581a3bbc$var$kOnFinished].push(cb);
    }
    return this;
};
function $1e24783d581a3bbc$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $1e24783d581a3bbc$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $1e24783d581a3bbc$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $1e24783d581a3bbc$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$1e24783d581a3bbc$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $1e24783d581a3bbc$var$errorOrDestroy(stream, err, state.sync);
        } else if ($1e24783d581a3bbc$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($1e24783d581a3bbc$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $1e24783d581a3bbc$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $1e24783d581a3bbc$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1e24783d581a3bbc$var$finishMaybe(stream, state, sync) {
    if ($1e24783d581a3bbc$var$needFinish(state)) {
        $1e24783d581a3bbc$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($1e24783d581a3bbc$var$needFinish(state)) $1e24783d581a3bbc$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($1e24783d581a3bbc$var$needFinish(state)) {
                state.pendingcb++;
                $1e24783d581a3bbc$var$finish(stream, state);
            }
        }
    }
}
function $1e24783d581a3bbc$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$1e24783d581a3bbc$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$1e24783d581a3bbc$var$ObjectDefineProperties($1e24783d581a3bbc$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $1e24783d581a3bbc$var$destroy = $irwcz.destroy;
$1e24783d581a3bbc$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$1e24783d581a3bbc$var$kOnFinished].length)) $2Qkr5.nextTick($1e24783d581a3bbc$var$errorBuffer, state);
    $1e24783d581a3bbc$var$destroy.call(this, err, cb);
    return this;
};
$1e24783d581a3bbc$var$Writable.prototype._undestroy = $irwcz.undestroy;
$1e24783d581a3bbc$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1e24783d581a3bbc$var$Writable.prototype[$1e24783d581a3bbc$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $1e24783d581a3bbc$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1e24783d581a3bbc$var$lazyWebStreams() {
    if ($1e24783d581a3bbc$var$webStreamsAdapters === undefined) $1e24783d581a3bbc$var$webStreamsAdapters = {};
    return $1e24783d581a3bbc$var$webStreamsAdapters;
}
$1e24783d581a3bbc$var$Writable.fromWeb = function(writableStream, options) {
    return $1e24783d581a3bbc$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$1e24783d581a3bbc$var$Writable.toWeb = function(streamWritable) {
    return $1e24783d581a3bbc$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("1xCo0", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $eIVzI = parcelRequire("eIVzI");

var $65HYg = parcelRequire("65HYg");
var $11f6a63708a55d37$var$isReadable = $65HYg.isReadable, $11f6a63708a55d37$var$isWritable = $65HYg.isWritable, $11f6a63708a55d37$var$isIterable = $65HYg.isIterable, $11f6a63708a55d37$var$isNodeStream = $65HYg.isNodeStream, $11f6a63708a55d37$var$isReadableNodeStream = $65HYg.isReadableNodeStream, $11f6a63708a55d37$var$isWritableNodeStream = $65HYg.isWritableNodeStream, $11f6a63708a55d37$var$isDuplexNodeStream = $65HYg.isDuplexNodeStream, $11f6a63708a55d37$var$isReadableStream = $65HYg.isReadableStream, $11f6a63708a55d37$var$isWritableStream = $65HYg.isWritableStream;

var $vZAIl = parcelRequire("vZAIl");

var $gDydr = parcelRequire("gDydr");
var $11f6a63708a55d37$var$AbortError = $gDydr.AbortError, $11f6a63708a55d37$var$_require_codes = $gDydr.codes, $11f6a63708a55d37$var$ERR_INVALID_ARG_TYPE = $11f6a63708a55d37$var$_require_codes.ERR_INVALID_ARG_TYPE, $11f6a63708a55d37$var$ERR_INVALID_RETURN_VALUE = $11f6a63708a55d37$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $irwcz = parcelRequire("irwcz");
var $11f6a63708a55d37$require$destroyer = $irwcz.destroyer;

var $kT5fT = parcelRequire("kT5fT");

var $lOqOF = parcelRequire("lOqOF");

var $2ArKA = parcelRequire("2ArKA");

var $ivGzv = parcelRequire("ivGzv");
var $11f6a63708a55d37$require$createDeferredPromise = $ivGzv.createDeferredPromise;

var $5boRJ = parcelRequire("5boRJ");
var $11f6a63708a55d37$var$Blob = globalThis.Blob || $eIVzI.Blob;
var $11f6a63708a55d37$var$isBlob = typeof $11f6a63708a55d37$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $11f6a63708a55d37$var$Blob;
} : function isBlob(b) {
    return false;
};

var $11f6a63708a55d37$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $gPFMe = parcelRequire("gPFMe");
var $11f6a63708a55d37$require$FunctionPrototypeCall = $gPFMe.FunctionPrototypeCall;
// This is needed for pre node 17.
var $11f6a63708a55d37$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($kT5fT);
module.exports = function duplexify(body, name) {
    if ($11f6a63708a55d37$var$isDuplexNodeStream(body)) return body;
    if ($11f6a63708a55d37$var$isReadableNodeStream(body)) return $11f6a63708a55d37$var$_duplexify({
        readable: body
    });
    if ($11f6a63708a55d37$var$isWritableNodeStream(body)) return $11f6a63708a55d37$var$_duplexify({
        writable: body
    });
    if ($11f6a63708a55d37$var$isNodeStream(body)) return $11f6a63708a55d37$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($11f6a63708a55d37$var$isReadableStream(body)) return $11f6a63708a55d37$var$_duplexify({
        readable: $lOqOF.fromWeb(body)
    });
    if ($11f6a63708a55d37$var$isWritableStream(body)) return $11f6a63708a55d37$var$_duplexify({
        writable: $2ArKA.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $11f6a63708a55d37$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($11f6a63708a55d37$var$isIterable(value)) return $5boRJ($11f6a63708a55d37$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $11f6a63708a55d37$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $11f6a63708a55d37$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $11f6a63708a55d37$require$destroyer(d, err);
            });
            return d = new $11f6a63708a55d37$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $11f6a63708a55d37$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($11f6a63708a55d37$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($11f6a63708a55d37$var$isIterable(body)) return $5boRJ($11f6a63708a55d37$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($11f6a63708a55d37$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $11f6a63708a55d37$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $11f6a63708a55d37$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $11f6a63708a55d37$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $11f6a63708a55d37$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $11f6a63708a55d37$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $11f6a63708a55d37$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $11f6a63708a55d37$require$destroyer(d1, err);
        });
        return d1 = new $11f6a63708a55d37$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $11f6a63708a55d37$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $11f6a63708a55d37$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $11f6a63708a55d37$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $11f6a63708a55d37$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $11f6a63708a55d37$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $11f6a63708a55d37$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $11f6a63708a55d37$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $lOqOF.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$11f6a63708a55d37$var$isReadable(r);
    var writable = !!$11f6a63708a55d37$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $11f6a63708a55d37$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $vZAIl(w, function(err) {
            writable = false;
            if (err) $11f6a63708a55d37$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $vZAIl(r, function(err) {
            readable = false;
            if (err) $11f6a63708a55d37$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $11f6a63708a55d37$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $11f6a63708a55d37$require$destroyer(w, err);
            $11f6a63708a55d37$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("a6J00", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $75bd5ed465aa9251$require$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf;
module.exports = $75bd5ed465aa9251$var$PassThrough;

var $cx1cR = parcelRequire("cx1cR");
$75bd5ed465aa9251$require$ObjectSetPrototypeOf($75bd5ed465aa9251$var$PassThrough.prototype, $cx1cR.prototype);
$75bd5ed465aa9251$require$ObjectSetPrototypeOf($75bd5ed465aa9251$var$PassThrough, $cx1cR);
function $75bd5ed465aa9251$var$PassThrough(options) {
    if (!(this instanceof $75bd5ed465aa9251$var$PassThrough)) return new $75bd5ed465aa9251$var$PassThrough(options);
    $cx1cR.call(this, options);
}
$75bd5ed465aa9251$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("cx1cR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $91f980adba6a86dd$var$ObjectSetPrototypeOf = $gPFMe.ObjectSetPrototypeOf, $91f980adba6a86dd$var$Symbol = $gPFMe.Symbol;
module.exports = $91f980adba6a86dd$var$Transform;

var $91f980adba6a86dd$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("gDydr")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $kT5fT = parcelRequire("kT5fT");

var $iAzvv = parcelRequire("iAzvv");
var $91f980adba6a86dd$require$getHighWaterMark = $iAzvv.getHighWaterMark;
$91f980adba6a86dd$var$ObjectSetPrototypeOf($91f980adba6a86dd$var$Transform.prototype, $kT5fT.prototype);
$91f980adba6a86dd$var$ObjectSetPrototypeOf($91f980adba6a86dd$var$Transform, $kT5fT);
var $91f980adba6a86dd$var$kCallback = $91f980adba6a86dd$var$Symbol('kCallback');
function $91f980adba6a86dd$var$Transform(options) {
    if (!(this instanceof $91f980adba6a86dd$var$Transform)) return new $91f980adba6a86dd$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $91f980adba6a86dd$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $kT5fT.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$91f980adba6a86dd$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $91f980adba6a86dd$var$prefinish);
}
function $91f980adba6a86dd$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $91f980adba6a86dd$var$prefinish() {
    if (this._final !== $91f980adba6a86dd$var$_final) $91f980adba6a86dd$var$_final.call(this);
}
$91f980adba6a86dd$var$Transform.prototype._final = $91f980adba6a86dd$var$_final;
$91f980adba6a86dd$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $91f980adba6a86dd$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$91f980adba6a86dd$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$91f980adba6a86dd$var$kCallback] = callback;
    });
};
$91f980adba6a86dd$var$Transform.prototype._read = function() {
    if (this[$91f980adba6a86dd$var$kCallback]) {
        var callback = this[$91f980adba6a86dd$var$kCallback];
        this[$91f980adba6a86dd$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("f0bPU", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $gPFMe = parcelRequire("gPFMe");
var $aec0098463c207b1$var$ArrayPrototypePop = $gPFMe.ArrayPrototypePop, $aec0098463c207b1$var$Promise = $gPFMe.Promise;

var $65HYg = parcelRequire("65HYg");
var $aec0098463c207b1$var$isIterable = $65HYg.isIterable, $aec0098463c207b1$var$isNodeStream = $65HYg.isNodeStream, $aec0098463c207b1$var$isWebStream = $65HYg.isWebStream;

var $khkUM = parcelRequire("khkUM");
var $aec0098463c207b1$var$pl = $khkUM.pipelineImpl;

var $vZAIl = parcelRequire("vZAIl");
var $aec0098463c207b1$require$finished = $vZAIl.finished;
parcelRequire("j1Kf1");
function $aec0098463c207b1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $aec0098463c207b1$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$aec0098463c207b1$var$isNodeStream(lastArg) && !$aec0098463c207b1$var$isIterable(lastArg) && !$aec0098463c207b1$var$isWebStream(lastArg)) {
            var options = $aec0098463c207b1$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $aec0098463c207b1$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $aec0098463c207b1$require$finished,
    pipeline: $aec0098463c207b1$var$pipeline
};

});



parcelRegister("gZ4nC", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseError = void 0;
/**
 * An error that includes line and column in the error message.
 */ var $c5d5bda0a44c04a5$var$ParseError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ParseError, Error1);
    function ParseError(parser, message) {
        (0, $jGAMp._)(this, ParseError);
        var saxParser = parser.saxParser;
        return (0, $kzDuW._)(this, ParseError, [
            parser.trackPosition ? "Line ".concat(saxParser.line, " column ").concat(saxParser.column + 1, ": ").concat(message) : message
        ]);
    }
    return ParseError;
}((0, $8AW3P._)(Error));
module.exports.ParseError = $c5d5bda0a44c04a5$var$ParseError;

});

parcelRegister("eALDR", function(module, exports) {
"use strict";
var $a9f9622c5fdff96b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9f9622c5fdff96b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9f9622c5fdff96b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9f9622c5fdff96b$var$__exportStar((parcelRequire("eT7is")), module.exports);

});
parcelRegister("eT7is", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateIri = module.exports.IriValidationStrategy = void 0;
function $ad6bdcb7eec1f09d$var$buildAbsoluteIriRfc3987Regex() {
    // The syntax is defined in https://www.rfc-editor.org/rfc/rfc3987#section-2.2
    // Rules are defined in reversed order
    var sub_delims_raw = "!$&'()*+,;=";
    var sub_delims = "[".concat(sub_delims_raw, "]");
    var pct_encoded = "%[a-fA-F0-9]{2}";
    var dec_octet = '([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
    var ipv4address = "".concat(dec_octet, "\\.").concat(dec_octet, "\\.").concat(dec_octet, "\\.").concat(dec_octet);
    var h16 = "[a-fA-F0-9]{1,4}";
    var ls32 = "(".concat(h16, ":").concat(h16, "|").concat(ipv4address, ")");
    var ipv6address = "((".concat(h16, ":){6}").concat(ls32, "|::(").concat(h16, ":){5}").concat(ls32, "|(").concat(h16, ")?::(").concat(h16, ":){4}").concat(ls32, "|((").concat(h16, ":){0,1}").concat(h16, ")?::(").concat(h16, ":){3}").concat(ls32, "|((").concat(h16, ":){0,2}").concat(h16, ")?::(").concat(h16, ":){2}").concat(ls32, "|((").concat(h16, ":){0,3}").concat(h16, ")?::").concat(h16, ":").concat(ls32, "|((").concat(h16, ":){0,4}").concat(h16, ")?::").concat(ls32, "|((").concat(h16, ":){0,5}").concat(h16, ")?::").concat(h16, "|((").concat(h16, ":){0,6}").concat(h16, ")?::)");
    var ipvfuture = "v[a-fA-F0-9]+\\.(".concat(sub_delims, "|").concat(sub_delims, '|":)+');
    var ip_literal = "\\[(".concat(ipv6address, "|").concat(ipvfuture, ")\\]");
    var port = "[0-9]*";
    var scheme = "[a-zA-Z][a-zA-Z0-9+\\-.]*";
    var iprivate_raw = "\uE000-\uF8FF\uDB80\uDC00-\uDBBF\uDFFD\uDBC0\uDC00-\uDBFF\uDFFD";
    var iprivate = "[".concat(iprivate_raw, "]");
    var ucschar_raw = "\xa0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\uD800\uDC00-\uD83F\uDFFD\uD840\uDC00-\uD87F\uDFFD\uD880\uDC00-\uD8BF\uDFFD\uD8C0\uDC00-\uD8FF\uDFFD\uD900\uDC00-\uD93F\uDFFD\uD940\uDC00-\uD97F\uDFFD\uD980\uDC00-\uD9BF\uDFFD\uD9C0\uDC00-\uD9FF\uDFFD\uDA00\uDC00-\uDA3F\uDFFD\uDA40\uDC00-\uDA7F\uDFFD\uDA80\uDC00-\uDABF\uDFFD\uDAC0\uDC00-\uDAFF\uDFFD\uDB00\uDC00-\uDB3F\uDFFD\uDB44\uDC00-\uDB7F\uDFFD";
    var iunreserved_raw = "a-zA-Z0-9\\-._~".concat(ucschar_raw);
    var iunreserved = "[".concat(iunreserved_raw, "]");
    var ipchar = "(".concat(iunreserved, "|").concat(pct_encoded, "|").concat(sub_delims, "|[:@])*");
    var ifragment = "(".concat(ipchar, "|[\\/?])*");
    var iquery = "(".concat(ipchar, "|").concat(iprivate, "|[\\/?])*");
    var isegment_nz = "(".concat(ipchar, ")+");
    var isegment = "(".concat(ipchar, ")*");
    var ipath_empty = '';
    var ipath_rootless = "".concat(isegment_nz, "(\\/").concat(isegment, ")*");
    var ipath_absolute = "\\/(".concat(isegment_nz, "(\\/").concat(isegment, ")*)?");
    var ipath_abempty = "(\\/".concat(isegment, ")*");
    var ireg_name = "(".concat(iunreserved, "|").concat(pct_encoded, "|").concat(sub_delims, ")*");
    var ihost = "(".concat(ip_literal, "|").concat(ipv4address, "|").concat(ireg_name, ")");
    var iuserinfo = "(".concat(iunreserved, "|").concat(pct_encoded, "|").concat(sub_delims, "|:)*");
    var iauthority = "(".concat(iuserinfo, "@)?").concat(ihost, "(:").concat(port, ")?");
    var ihier_part = "(\\/\\/".concat(iauthority).concat(ipath_abempty, "|").concat(ipath_absolute, "|").concat(ipath_rootless, "|").concat(ipath_empty, ")");
    var iri = "^".concat(scheme, ":").concat(ihier_part, "(\\?").concat(iquery, ")?(#").concat(ifragment, ")?$");
    return new RegExp(iri, 'u');
}
var $ad6bdcb7eec1f09d$var$STRICT_IRI_REGEX = $ad6bdcb7eec1f09d$var$buildAbsoluteIriRfc3987Regex();
// eslint-disable-next-line no-control-regex
var $ad6bdcb7eec1f09d$var$PRAGMATIC_IRI_REGEX = RegExp('^[A-Za-z][\\d+-.A-Za-z]*:[^\\u0000-\\u0020"<>\\\\^`{|}]*$', "u");
/**
 * Possible ways of validating an IRI
 */ var $ad6bdcb7eec1f09d$var$IriValidationStrategy;
(function(IriValidationStrategy) {
    /**
     * Validates the IRI according to RFC 3987.
     */ IriValidationStrategy["Strict"] = "strict";
    /**
     * Validates that the IRI has a valid scheme and does not contain any character forbidden by the Turtle specification.
     */ IriValidationStrategy["Pragmatic"] = "pragmatic";
    /**
     * Does not validate the IRI at all.
     */ IriValidationStrategy["None"] = "none";
})($ad6bdcb7eec1f09d$var$IriValidationStrategy = module.exports.IriValidationStrategy || (module.exports.IriValidationStrategy = {}));
/**
 * Validate a given IRI according to the given strategy.
 *
 * By default the IRI is fully validated according to RFC 3987.
 * But it is possible to do a lighter a faster validation using the "pragmatic" strategy.
 *
 * @param {string} iri a string that may be an IRI.
 * @param {IriValidationStrategy} strategy IRI validation strategy.
 * @return {Error | undefined} An error if the IRI is invalid, or undefined if it is valid.
 */ function $ad6bdcb7eec1f09d$var$validateIri(iri) {
    var strategy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ad6bdcb7eec1f09d$var$IriValidationStrategy.Strict;
    switch(strategy){
        case $ad6bdcb7eec1f09d$var$IriValidationStrategy.Strict:
            return $ad6bdcb7eec1f09d$var$STRICT_IRI_REGEX.test(iri) ? undefined : new Error("Invalid IRI according to RFC 3987: '".concat(iri, "'"));
        case $ad6bdcb7eec1f09d$var$IriValidationStrategy.Pragmatic:
            return $ad6bdcb7eec1f09d$var$PRAGMATIC_IRI_REGEX.test(iri) ? undefined : new Error("Invalid IRI according to RDF Turtle: '".concat(iri, "'"));
        case $ad6bdcb7eec1f09d$var$IriValidationStrategy.None:
            return undefined;
        default:
            return new Error('Not supported validation strategy "'.concat(strategy, '"'));
    }
}
module.exports.validateIri = $ad6bdcb7eec1f09d$var$validateIri;

});






parcelRegister("7BGO6", function(module, exports) {
"use strict";
var $589d31b26349364a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $589d31b26349364a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $589d31b26349364a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$589d31b26349364a$var$__exportStar((parcelRequire("9p0QH")), module.exports);

});
parcelRegister("9p0QH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseXmlRdfa = void 0;

var $1Nxez = parcelRequire("1Nxez");

var $9nBhR = parcelRequire("9nBhR");

var $jWd6e = parcelRequire("jWd6e");
/**
 * A comunica XML RDFa RDF Parse Actor.
 */ var $6d871b70f9a4e88a$var$ActorRdfParseXmlRdfa = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseXmlRdfa, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseXmlRdfa(args) {
        (0, $jGAMp._)(this, ActorRdfParseXmlRdfa);
        return (0, $kzDuW._)(this, ActorRdfParseXmlRdfa, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseXmlRdfa, [
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_metadata, dataFactory, _ref, language, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        language = (_ref = action.headers && action.headers.get('content-language')) !== null && _ref !== void 0 ? _ref : undefined;
                        action.data.on('error', function(error) {
                            return data.emit('error', error);
                        });
                        data = action.data.pipe(new $jWd6e.RdfaParser({
                            dataFactory: dataFactory,
                            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI,
                            profile: 'xml',
                            language: language
                        }));
                        return [
                            2,
                            {
                                data: data,
                                metadata: {
                                    triples: true
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseXmlRdfa;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseXmlRdfa = $6d871b70f9a4e88a$var$ActorRdfParseXmlRdfa;

});
parcelRegister("jWd6e", function(module, exports) {
"use strict";
var $e83d985daa67684d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e83d985daa67684d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e83d985daa67684d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e83d985daa67684d$var$__exportStar((parcelRequire("lM48m")), module.exports);

$e83d985daa67684d$var$__exportStar((parcelRequire("5zDMl")), module.exports);

$e83d985daa67684d$var$__exportStar((parcelRequire("ftL7q")), module.exports);

$e83d985daa67684d$var$__exportStar((parcelRequire("iEdZg")), module.exports);

$e83d985daa67684d$var$__exportStar((parcelRequire("ktphf")), module.exports);

$e83d985daa67684d$var$__exportStar((parcelRequire("gUL8T")), module.exports);

});
parcelRegister("lM48m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5zDMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ftL7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iEdZg", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfaParser = void 0;
parcelRequire("8TUUs");
var $gDl0h = parcelRequire("gDl0h");

var $2G1Uq = parcelRequire("2G1Uq");

var $4x0uF = parcelRequire("4x0uF");

var $aI8sN = parcelRequire("aI8sN");

var $ktphf = parcelRequire("ktphf");

var $gUL8T = parcelRequire("gUL8T");
/**
 * A stream transformer that parses RDFa (text) streams to an {@link RDF.Stream}.
 */ var $d936cffb3a18238e$var$RdfaParser = /*#__PURE__*/ function(_readable_stream_1_Transform) {
    (0, $i3fW3._)(RdfaParser, _readable_stream_1_Transform);
    function RdfaParser(options) {
        (0, $jGAMp._)(this, RdfaParser);
        var _this;
        _this = (0, $kzDuW._)(this, RdfaParser, [
            {
                readableObjectMode: true
            }
        ]);
        _this.activeTagStack = [];
        options = options || {};
        _this.options = options;
        _this.util = new $gUL8T.Util(options.dataFactory, options.baseIRI);
        _this.defaultGraph = options.defaultGraph || _this.util.dataFactory.defaultGraph();
        var profile = options.contentType ? $gUL8T.Util.contentTypeToProfile(options.contentType) : options.profile || '';
        _this.features = options.features || $ktphf.RDFA_FEATURES[profile];
        _this.htmlParseListener = options.htmlParseListener;
        _this.rdfaPatterns = _this.features.copyRdfaPatterns ? {} : null;
        _this.pendingRdfaPatternCopies = _this.features.copyRdfaPatterns ? {} : null;
        _this.parser = _this.initializeParser(profile === 'xml');
        _this.activeTagStack.push({
            incompleteTriples: [],
            inlist: false,
            language: options.language,
            listMapping: {},
            listMappingLocal: {},
            name: '',
            prefixesAll: Object.assign(Object.assign({}, $aI8sN["@context"]), _this.features.xhtmlInitialContext ? $4x0uF["@context"] : {}),
            prefixesCustom: {},
            skipElement: false,
            vocab: options.vocab
        });
        return _this;
    }
    (0, $byiyg._)(RdfaParser, [
        {
            /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ key: "import",
            value: function _import(stream) {
                var output = new $2G1Uq.PassThrough({
                    readableObjectMode: true
                });
                stream.on('error', function(error) {
                    return parsed.emit('error', error);
                });
                stream.on('data', function(data) {
                    return output.push(data);
                });
                stream.on('end', function() {
                    return output.push(null);
                });
                var parsed = output.pipe(new RdfaParser(this.options));
                return parsed;
            }
        },
        {
            key: "_transform",
            value: function _transform(chunk, encoding, callback) {
                this.parser.write(chunk.toString());
                callback();
            }
        },
        {
            key: "_flush",
            value: function _flush(callback) {
                this.parser.end();
                callback();
            }
        },
        {
            key: "onTagOpen",
            value: function onTagOpen(name, attributes) {
                // Determine the parent tag (ignore skipped tags)
                var parentTagI = this.activeTagStack.length - 1;
                while(parentTagI > 0 && this.activeTagStack[parentTagI].skipElement)parentTagI--;
                var parentTag = this.activeTagStack[parentTagI];
                // If we skipped a tag, make sure we DO use the lang, prefixes and vocab of the skipped tag
                if (parentTagI !== this.activeTagStack.length - 1) parentTag = Object.assign(Object.assign({}, parentTag), {
                    language: this.activeTagStack[this.activeTagStack.length - 1].language,
                    prefixesAll: this.activeTagStack[this.activeTagStack.length - 1].prefixesAll,
                    prefixesCustom: this.activeTagStack[this.activeTagStack.length - 1].prefixesCustom,
                    vocab: this.activeTagStack[this.activeTagStack.length - 1].vocab
                });
                // Create a new active tag and inherit language scope and baseIRI from parent
                var activeTag = {
                    collectChildTags: parentTag.collectChildTags,
                    incompleteTriples: [],
                    inlist: 'inlist' in attributes,
                    listMapping: [],
                    listMappingLocal: parentTag.listMapping,
                    localBaseIRI: parentTag.localBaseIRI,
                    name: name,
                    prefixesAll: null,
                    prefixesCustom: null,
                    skipElement: false
                };
                this.activeTagStack.push(activeTag);
                // Save the tag contents if needed
                if (activeTag.collectChildTags) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Add explicitly defined xmlns, xmlns:* and prefixes to attributes, as required by the spec (Step 11, note)
                        // Sort prefixes alphabetically for deterministic namespace declaration order
                        for(var _iterator = Object.keys(parentTag.prefixesCustom).sort()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var prefix = _step.value;
                            var suffix = parentTag.prefixesCustom[prefix];
                            var attributeKey = prefix === '' ? 'xmlns' : 'xmlns:' + prefix;
                            if (!(attributeKey in attributes)) attributes[attributeKey] = suffix;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var attributesSerialized = Object.keys(attributes).map(function(key) {
                        return "".concat(key, '="').concat(attributes[key], '"');
                    }).join(' ');
                    activeTag.text = [
                        "<".concat(name).concat(attributesSerialized ? ' ' + attributesSerialized : '', ">")
                    ];
                    if (this.features.skipHandlingXmlLiteralChildren) return;
                }
                var allowTermsInRelPredicates = true;
                var allowTermsInRevPredicates = true;
                if (this.features.onlyAllowUriRelRevIfProperty) {
                    // Ignore illegal rel/rev values when property is present
                    if ('property' in attributes && 'rel' in attributes) {
                        allowTermsInRelPredicates = false;
                        if (attributes.rel.indexOf(':') < 0) delete attributes.rel;
                    }
                    if ('property' in attributes && 'rev' in attributes) {
                        allowTermsInRevPredicates = false;
                        if (attributes.rev.indexOf(':') < 0) delete attributes.rev;
                    }
                }
                if (this.features.copyRdfaPatterns) {
                    // Save the tag if needed
                    if (parentTag.collectedPatternTag) {
                        var patternTag = {
                            attributes: attributes,
                            children: [],
                            name: name,
                            referenced: false,
                            rootPattern: false,
                            text: []
                        };
                        parentTag.collectedPatternTag.children.push(patternTag);
                        activeTag.collectedPatternTag = patternTag;
                        return;
                    }
                    // Store tags with type rdfa:Pattern as patterns
                    if (attributes["typeof"] === 'rdfa:Pattern') {
                        activeTag.collectedPatternTag = {
                            attributes: attributes,
                            children: [],
                            name: name,
                            parentTag: parentTag,
                            referenced: false,
                            rootPattern: true,
                            text: []
                        };
                        return;
                    }
                    // Instantiate patterns on rdfa:copy
                    if (attributes.property === 'rdfa:copy') {
                        var copyTargetPatternId = attributes.resource || attributes.href || attributes.src;
                        if (this.rdfaPatterns[copyTargetPatternId]) this.emitPatternCopy(parentTag, this.rdfaPatterns[copyTargetPatternId], copyTargetPatternId);
                        else {
                            if (!this.pendingRdfaPatternCopies[copyTargetPatternId]) this.pendingRdfaPatternCopies[copyTargetPatternId] = [];
                            this.pendingRdfaPatternCopies[copyTargetPatternId].push(parentTag);
                        }
                        return;
                    }
                }
                // <base> tags override the baseIRI of the whole document
                if (this.features.baseTag && name === 'base' && attributes.href) this.util.baseIRI = this.util.getBaseIRI(attributes.href);
                // xml:base attributes override the baseIRI of the current tag and children
                if (this.features.xmlBase && attributes['xml:base']) activeTag.localBaseIRI = this.util.getBaseIRI(attributes['xml:base']);
                // <time> tags set an initial datatype
                if (this.features.timeTag && name === 'time' && !attributes.datatype) activeTag.interpretObjectAsTime = true;
                // Processing based on https://www.w3.org/TR/rdfa-core/#s_rdfaindetail
                // 1: initialize values
                var newSubject;
                var currentObjectResource;
                var typedResource;
                // 2: handle vocab attribute to set active vocabulary
                // Vocab sets the active vocabulary
                if ('vocab' in attributes) {
                    if (attributes.vocab) {
                        activeTag.vocab = attributes.vocab;
                        this.emitTriple(this.util.getBaseIriTerm(activeTag), this.util.dataFactory.namedNode($gUL8T.Util.RDFA + 'usesVocabulary'), this.util.dataFactory.namedNode(activeTag.vocab));
                    } else // If vocab is set to '', then we fallback to the root vocab as defined via the parser constructor
                    activeTag.vocab = this.activeTagStack[0].vocab;
                } else activeTag.vocab = parentTag.vocab;
                // 3: handle prefixes
                activeTag.prefixesCustom = $gUL8T.Util.parsePrefixes(attributes, parentTag.prefixesCustom, this.features.xmlnsPrefixMappings);
                activeTag.prefixesAll = Object.keys(activeTag.prefixesCustom).length > 0 ? Object.assign(Object.assign({}, parentTag.prefixesAll), activeTag.prefixesCustom) : parentTag.prefixesAll;
                // Handle role attribute
                if (this.features.roleAttribute && attributes.role) {
                    var roleSubject = attributes.id ? this.util.createIri('#' + attributes.id, activeTag, false, false, false) : this.util.createBlankNode();
                    // Temporarily override vocab
                    var vocabOld = activeTag.vocab;
                    activeTag.vocab = 'http://www.w3.org/1999/xhtml/vocab#';
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = this.util.createVocabIris(attributes.role, activeTag, true, false)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var role = _step1.value;
                            this.emitTriple(roleSubject, this.util.dataFactory.namedNode('http://www.w3.org/1999/xhtml/vocab#role'), role);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    activeTag.vocab = vocabOld;
                }
                // 4: handle language
                // Save language attribute value in active tag
                if ('xml:lang' in attributes || this.features.langAttribute && 'lang' in attributes) activeTag.language = attributes['xml:lang'] || attributes.lang;
                else activeTag.language = parentTag.language;
                var isRootTag = this.activeTagStack.length === 2;
                if (!('rel' in attributes) && !('rev' in attributes)) {
                    // 5: Determine the new subject when rel and rev are not present
                    if ('property' in attributes && !('content' in attributes) && !('datatype' in attributes)) {
                        // 5.1: property is present, but not content and datatype
                        // Determine new subject
                        if ('about' in attributes) {
                            newSubject = this.util.createIri(attributes.about, activeTag, false, true, true);
                            activeTag.explicitNewSubject = !!newSubject;
                        } else if (isRootTag) newSubject = true;
                        else if (parentTag.object) newSubject = parentTag.object;
                        // Determine type
                        if ('typeof' in attributes) {
                            if ('about' in attributes) typedResource = this.util.createIri(attributes.about, activeTag, false, true, true);
                            if (!typedResource && isRootTag) typedResource = true;
                            if (!typedResource && 'resource' in attributes) typedResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
                            if (!typedResource && ('href' in attributes || 'src' in attributes)) typedResource = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                            if (!typedResource && this.isInheritSubjectInHeadBody(name)) typedResource = newSubject;
                            if (!typedResource) typedResource = this.util.createBlankNode();
                            currentObjectResource = typedResource;
                        }
                    } else {
                        // 5.2
                        if ('about' in attributes || 'resource' in attributes) {
                            newSubject = this.util.createIri(attributes.about || attributes.resource, activeTag, false, true, true);
                            activeTag.explicitNewSubject = !!newSubject;
                        }
                        if (!newSubject && ('href' in attributes || 'src' in attributes)) {
                            newSubject = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                            activeTag.explicitNewSubject = !!newSubject;
                        }
                        if (!newSubject) {
                            if (isRootTag) newSubject = true;
                            else if (this.isInheritSubjectInHeadBody(name)) newSubject = parentTag.object;
                            else if ('typeof' in attributes) {
                                newSubject = this.util.createBlankNode();
                                activeTag.explicitNewSubject = true;
                            } else if (parentTag.object) {
                                newSubject = parentTag.object;
                                if (!('property' in attributes)) activeTag.skipElement = true;
                            }
                        }
                        // Determine type
                        if ('typeof' in attributes) typedResource = newSubject;
                    }
                } else {
                    // 6: Determine the new subject when rel or rev are present
                    // Define new subject
                    if ('about' in attributes) {
                        newSubject = this.util.createIri(attributes.about, activeTag, false, true, true);
                        activeTag.explicitNewSubject = !!newSubject;
                        if ('typeof' in attributes) typedResource = newSubject;
                    } else if (isRootTag) newSubject = true;
                    else if (parentTag.object) newSubject = parentTag.object;
                    // Define object
                    if ('resource' in attributes) currentObjectResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
                    if (!currentObjectResource) {
                        if ('href' in attributes || 'src' in attributes) currentObjectResource = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                        else if ('typeof' in attributes && !('about' in attributes) && !this.isInheritSubjectInHeadBody(name)) currentObjectResource = this.util.createBlankNode();
                    }
                    // Set typed resource
                    if ('typeof' in attributes && !('about' in attributes)) {
                        if (this.isInheritSubjectInHeadBody(name)) typedResource = newSubject;
                        else typedResource = currentObjectResource;
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                // 7: If a typed resource was defined, emit it as a triple
                if (typedResource) try {
                    for(var _iterator2 = this.util.createVocabIris(attributes["typeof"], activeTag, true, true)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var type = _step2.value;
                        this.emitTriple(this.util.getResourceOrBaseIri(typedResource, activeTag), this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'type'), type);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                // 8: Reset list mapping if we have a new subject
                if (newSubject) activeTag.listMapping = {};
                // 9: If an object was defined, emit triples for it
                if (currentObjectResource) {
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    // Handle list mapping
                    if ('rel' in attributes && 'inlist' in attributes) try {
                        for(var _iterator3 = this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var predicate = _step3.value;
                            this.addListMapping(activeTag, newSubject, predicate, currentObjectResource);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                _iterator3["return"]();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    // Determine predicates using rel or rev (unless rel and inlist are present)
                    if (!('rel' in attributes && 'inlist' in attributes)) {
                        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        if ('rel' in attributes) try {
                            for(var _iterator4 = this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                var predicate1 = _step4.value;
                                this.emitTriple(this.util.getResourceOrBaseIri(newSubject, activeTag), predicate1, this.util.getResourceOrBaseIri(currentObjectResource, activeTag));
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                    _iterator4["return"]();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                        var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                        if ('rev' in attributes) try {
                            for(var _iterator5 = this.util.createVocabIris(attributes.rev, activeTag, allowTermsInRevPredicates, false)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                var predicate2 = _step5.value;
                                this.emitTriple(this.util.getResourceOrBaseIri(currentObjectResource, activeTag), predicate2, this.util.getResourceOrBaseIri(newSubject, activeTag));
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                    _iterator5["return"]();
                                }
                            } finally{
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                }
                // 10: Store incomplete triples if we don't have an object, but we do have predicates
                if (!currentObjectResource) {
                    if ('rel' in attributes) {
                        var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined, _iteratorNormalCompletion7 = true, _didIteratorError7 = false, _iteratorError7 = undefined;
                        if ('inlist' in attributes) try {
                            for(var _iterator6 = this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                var predicate3 = _step6.value;
                                this.addListMapping(activeTag, newSubject, predicate3, null);
                                activeTag.incompleteTriples.push({
                                    predicate: predicate3,
                                    reverse: false,
                                    list: true
                                });
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                                    _iterator6["return"]();
                                }
                            } finally{
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                        else try {
                            for(var _iterator7 = this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                                var predicate4 = _step7.value;
                                activeTag.incompleteTriples.push({
                                    predicate: predicate4,
                                    reverse: false
                                });
                            }
                        } catch (err) {
                            _didIteratorError7 = true;
                            _iteratorError7 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                                    _iterator7["return"]();
                                }
                            } finally{
                                if (_didIteratorError7) {
                                    throw _iteratorError7;
                                }
                            }
                        }
                    }
                    var _iteratorNormalCompletion8 = true, _didIteratorError8 = false, _iteratorError8 = undefined;
                    if ('rev' in attributes) try {
                        for(var _iterator8 = this.util.createVocabIris(attributes.rev, activeTag, allowTermsInRevPredicates, false)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true){
                            var predicate5 = _step8.value;
                            activeTag.incompleteTriples.push({
                                predicate: predicate5,
                                reverse: true
                            });
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8["return"] != null) {
                                _iterator8["return"]();
                            }
                        } finally{
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                    // Set a blank node object, so the children can make use of this when completing the triples
                    if (activeTag.incompleteTriples.length > 0) currentObjectResource = this.util.createBlankNode();
                }
                // 11: Determine current property value
                if ('property' in attributes) {
                    // Create predicates
                    activeTag.predicates = this.util.createVocabIris(attributes.property, activeTag, true, false);
                    // Save datatype attribute value in active tag
                    var localObjectResource;
                    if ('datatype' in attributes) {
                        activeTag.datatype = this.util.createIri(attributes.datatype, activeTag, true, true, false);
                        if (activeTag.datatype && (activeTag.datatype.value === $gUL8T.Util.RDF + 'XMLLiteral' || this.features.htmlDatatype && activeTag.datatype.value === $gUL8T.Util.RDF + 'HTML')) activeTag.collectChildTags = true;
                    } else {
                        // Try to determine resource
                        if (!('rev' in attributes) && !('rel' in attributes) && !('content' in attributes)) {
                            if ('resource' in attributes) localObjectResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
                            if (!localObjectResource && 'href' in attributes) localObjectResource = this.util.createIri(attributes.href, activeTag, false, false, true);
                            if (!localObjectResource && 'src' in attributes) localObjectResource = this.util.createIri(attributes.src, activeTag, false, false, true);
                        }
                        if ('typeof' in attributes && !('about' in attributes)) localObjectResource = typedResource;
                    }
                    if ('content' in attributes) {
                        // Emit triples based on content attribute has preference over text content
                        var object = this.util.createLiteral(attributes.content, activeTag);
                        var _iteratorNormalCompletion9 = true, _didIteratorError9 = false, _iteratorError9 = undefined;
                        if ('inlist' in attributes) try {
                            for(var _iterator9 = activeTag.predicates[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true){
                                var predicate6 = _step9.value;
                                this.addListMapping(activeTag, newSubject, predicate6, object);
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9["return"] != null) {
                                    _iterator9["return"]();
                                }
                            } finally{
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }
                        else {
                            var subject = this.util.getResourceOrBaseIri(newSubject, activeTag);
                            var _iteratorNormalCompletion10 = true, _didIteratorError10 = false, _iteratorError10 = undefined;
                            try {
                                for(var _iterator10 = activeTag.predicates[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true){
                                    var predicate7 = _step10.value;
                                    this.emitTriple(subject, predicate7, object);
                                }
                            } catch (err) {
                                _didIteratorError10 = true;
                                _iteratorError10 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion10 && _iterator10["return"] != null) {
                                        _iterator10["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError10) {
                                        throw _iteratorError10;
                                    }
                                }
                            }
                        }
                        // Unset predicate to avoid text contents to produce new triples
                        activeTag.predicates = null;
                    } else if (this.features.datetimeAttribute && 'datetime' in attributes) {
                        activeTag.interpretObjectAsTime = true;
                        // Datetime attribute on time tag has preference over text content
                        var object1 = this.util.createLiteral(attributes.datetime, activeTag);
                        var _iteratorNormalCompletion11 = true, _didIteratorError11 = false, _iteratorError11 = undefined;
                        if ('inlist' in attributes) try {
                            for(var _iterator11 = activeTag.predicates[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true){
                                var predicate8 = _step11.value;
                                this.addListMapping(activeTag, newSubject, predicate8, object1);
                            }
                        } catch (err) {
                            _didIteratorError11 = true;
                            _iteratorError11 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion11 && _iterator11["return"] != null) {
                                    _iterator11["return"]();
                                }
                            } finally{
                                if (_didIteratorError11) {
                                    throw _iteratorError11;
                                }
                            }
                        }
                        else {
                            var subject1 = this.util.getResourceOrBaseIri(newSubject, activeTag);
                            var _iteratorNormalCompletion12 = true, _didIteratorError12 = false, _iteratorError12 = undefined;
                            try {
                                for(var _iterator12 = activeTag.predicates[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true){
                                    var predicate9 = _step12.value;
                                    this.emitTriple(subject1, predicate9, object1);
                                }
                            } catch (err) {
                                _didIteratorError12 = true;
                                _iteratorError12 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion12 && _iterator12["return"] != null) {
                                        _iterator12["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError12) {
                                        throw _iteratorError12;
                                    }
                                }
                            }
                        }
                        // Unset predicate to avoid text contents to produce new triples
                        activeTag.predicates = null;
                    } else if (localObjectResource) {
                        // Emit triples for all resource objects
                        var object2 = this.util.getResourceOrBaseIri(localObjectResource, activeTag);
                        var _iteratorNormalCompletion13 = true, _didIteratorError13 = false, _iteratorError13 = undefined;
                        if ('inlist' in attributes) try {
                            for(var _iterator13 = activeTag.predicates[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true){
                                var predicate10 = _step13.value;
                                this.addListMapping(activeTag, newSubject, predicate10, object2);
                            }
                        } catch (err) {
                            _didIteratorError13 = true;
                            _iteratorError13 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion13 && _iterator13["return"] != null) {
                                    _iterator13["return"]();
                                }
                            } finally{
                                if (_didIteratorError13) {
                                    throw _iteratorError13;
                                }
                            }
                        }
                        else {
                            var subject2 = this.util.getResourceOrBaseIri(newSubject, activeTag);
                            var _iteratorNormalCompletion14 = true, _didIteratorError14 = false, _iteratorError14 = undefined;
                            try {
                                for(var _iterator14 = activeTag.predicates[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true){
                                    var predicate11 = _step14.value;
                                    this.emitTriple(subject2, predicate11, object2);
                                }
                            } catch (err) {
                                _didIteratorError14 = true;
                                _iteratorError14 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion14 && _iterator14["return"] != null) {
                                        _iterator14["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError14) {
                                        throw _iteratorError14;
                                    }
                                }
                            }
                        }
                        // Unset predicate to avoid text contents to produce new triples
                        activeTag.predicates = null;
                    }
                }
                // 12: Complete incomplete triples
                var incompleteTriplesCompleted = false;
                if (!activeTag.skipElement && newSubject && parentTag.incompleteTriples.length > 0) {
                    incompleteTriplesCompleted = true;
                    var subject3 = this.util.getResourceOrBaseIri(parentTag.subject, activeTag);
                    var object3 = this.util.getResourceOrBaseIri(newSubject, activeTag);
                    var _iteratorNormalCompletion15 = true, _didIteratorError15 = false, _iteratorError15 = undefined;
                    try {
                        for(var _iterator15 = parentTag.incompleteTriples[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true){
                            var incompleteTriple = _step15.value;
                            if (!incompleteTriple.reverse) {
                                if (incompleteTriple.list) {
                                    // Find the active tag that defined the list by going up the stack
                                    var firstInListTag = null;
                                    for(var i = this.activeTagStack.length - 1; i >= 0; i--)if (this.activeTagStack[i].inlist) {
                                        firstInListTag = this.activeTagStack[i];
                                        break;
                                    }
                                    // firstInListTag is guaranteed to be non-null
                                    this.addListMapping(firstInListTag, newSubject, incompleteTriple.predicate, object3);
                                } else this.emitTriple(subject3, incompleteTriple.predicate, object3);
                            } else this.emitTriple(object3, incompleteTriple.predicate, subject3);
                        }
                    } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion15 && _iterator15["return"] != null) {
                                _iterator15["return"]();
                            }
                        } finally{
                            if (_didIteratorError15) {
                                throw _iteratorError15;
                            }
                        }
                    }
                }
                if (!incompleteTriplesCompleted && parentTag.incompleteTriples.length > 0) activeTag.incompleteTriples = activeTag.incompleteTriples.concat(parentTag.incompleteTriples);
                // 13: Save evaluation context into active tag
                activeTag.subject = newSubject || parentTag.subject;
                activeTag.object = currentObjectResource || newSubject;
            }
        },
        {
            key: "onText",
            value: function onText(data) {
                var activeTag = this.activeTagStack[this.activeTagStack.length - 1];
                // Collect text in pattern tag if needed
                if (this.features.copyRdfaPatterns && activeTag.collectedPatternTag) {
                    activeTag.collectedPatternTag.text.push(data);
                    return;
                }
                // Save the text inside the active tag
                if (!activeTag.text) activeTag.text = [];
                activeTag.text.push(data);
            }
        },
        {
            key: "onTagClose",
            value: function onTagClose() {
                var _this = this;
                // Get the active tag
                var activeTag = this.activeTagStack[this.activeTagStack.length - 1];
                var parentTag = this.activeTagStack[this.activeTagStack.length - 2];
                if (!(activeTag.collectChildTags && parentTag.collectChildTags && this.features.skipHandlingXmlLiteralChildren)) {
                    // If we detect a finalized rdfa:Pattern tag, store it
                    if (this.features.copyRdfaPatterns && activeTag.collectedPatternTag && activeTag.collectedPatternTag.rootPattern) {
                        var patternId = activeTag.collectedPatternTag.attributes.resource;
                        // Remove resource and typeof attributes to avoid it being seen as a new pattern
                        delete activeTag.collectedPatternTag.attributes.resource;
                        delete activeTag.collectedPatternTag.attributes["typeof"];
                        // Store the pattern
                        this.rdfaPatterns[patternId] = activeTag.collectedPatternTag;
                        // Apply all pending copies for this pattern
                        if (this.pendingRdfaPatternCopies[patternId]) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this.pendingRdfaPatternCopies[patternId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var tag = _step.value;
                                    this.emitPatternCopy(tag, activeTag.collectedPatternTag, patternId);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            delete this.pendingRdfaPatternCopies[patternId];
                        }
                        // Remove the active tag from the stack
                        this.activeTagStack.pop();
                        return;
                    }
                    // Emit all triples that were determined in the active tag
                    if (activeTag.predicates) {
                        var subject = this.util.getResourceOrBaseIri(activeTag.subject, activeTag);
                        var textSegments = activeTag.text || [];
                        if (activeTag.collectChildTags && parentTag.collectChildTags) // If we are inside an XMLLiteral child that also has RDFa content, ignore the tag name that was collected.
                        textSegments = textSegments.slice(1);
                        var object = this.util.createLiteral(textSegments.join(''), activeTag);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        if (activeTag.inlist) try {
                            for(var _iterator1 = activeTag.predicates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var predicate = _step1.value;
                                this.addListMapping(activeTag, subject, predicate, object);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else try {
                            for(var _iterator2 = activeTag.predicates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var predicate1 = _step2.value;
                                this.emitTriple(subject, predicate1, object);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        // Reset text, unless the parent is also collecting text
                        if (!parentTag.predicates) activeTag.text = null;
                    }
                    // 14: Handle local list mapping
                    if (activeTag.object && Object.keys(activeTag.listMapping).length > 0) {
                        var subject1 = this.util.getResourceOrBaseIri(activeTag.object, activeTag);
                        for(var predicateValue in activeTag.listMapping){
                            var predicate2 = this.util.dataFactory.namedNode(predicateValue);
                            var values = activeTag.listMapping[predicateValue];
                            if (values.length > 0) {
                                // Non-empty list, emit linked list of rdf:first and rdf:rest chains
                                var bnodes = values.map(function() {
                                    return _this.util.createBlankNode();
                                });
                                for(var i = 0; i < values.length; i++){
                                    var object1 = this.util.getResourceOrBaseIri(values[i], activeTag);
                                    this.emitTriple(bnodes[i], this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'first'), object1);
                                    this.emitTriple(bnodes[i], this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'rest'), i < values.length - 1 ? bnodes[i + 1] : this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'nil'));
                                }
                                // Emit triple for the first linked list chain
                                this.emitTriple(subject1, predicate2, bnodes[0]);
                            } else // Empty list, just emit rdf:nil
                            this.emitTriple(subject1, predicate2, this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'nil'));
                        }
                    }
                }
                // Remove the active tag from the stack
                this.activeTagStack.pop();
                // Save the tag contents if needed
                if (activeTag.collectChildTags && activeTag.text) activeTag.text.push("</".concat(activeTag.name, ">"));
                // If we still have text contents, try to append it to the parent tag
                if (activeTag.text && parentTag) {
                    if (!parentTag.text) parentTag.text = activeTag.text;
                    else parentTag.text = parentTag.text.concat(activeTag.text);
                }
            }
        },
        {
            key: "onEnd",
            value: function onEnd() {
                if (this.features.copyRdfaPatterns) {
                    this.features.copyRdfaPatterns = false;
                    // Emit all unreferenced patterns
                    for(var patternId in this.rdfaPatterns){
                        var pattern = this.rdfaPatterns[patternId];
                        if (!pattern.referenced) {
                            pattern.attributes["typeof"] = 'rdfa:Pattern';
                            pattern.attributes.resource = patternId;
                            this.emitPatternCopy(pattern.parentTag, pattern, patternId);
                            pattern.referenced = false;
                            delete pattern.attributes["typeof"];
                            delete pattern.attributes.resource;
                        }
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // Emit all unreferenced copy links
                    for(var patternId1 in this.pendingRdfaPatternCopies)try {
                        for(var _iterator = this.pendingRdfaPatternCopies[patternId1][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var parentTag = _step.value;
                            this.activeTagStack.push(parentTag);
                            this.onTagOpen('link', {
                                property: 'rdfa:copy',
                                href: patternId1
                            });
                            this.onTagClose();
                            this.activeTagStack.pop();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.features.copyRdfaPatterns = true;
                }
            }
        },
        {
            /**
     * If the new subject can be inherited from the parent object
     * if the resource defines no new subject.
     * @param {string} name The current tag name.
     * @returns {boolean} If the subject can be inherited.
     */ key: "isInheritSubjectInHeadBody",
            value: function isInheritSubjectInHeadBody(name) {
                return this.features.inheritSubjectInHeadBody && (name === 'head' || name === 'body');
            }
        },
        {
            /**
     * Add a list mapping for the given predicate and object in the active tag.
     * @param {IActiveTag} activeTag The active tag.
     * @param {Term | boolean} subject A subject term, this will only be used to create a separate list
     *                                 if activeTag.explicitNewSubject is true.
     * @param {Term} predicate A predicate term.
     * @param {Term | boolean} currentObjectResource The current object resource.
     */ key: "addListMapping",
            value: function addListMapping(activeTag, subject, predicate, currentObjectResource) {
                if (activeTag.explicitNewSubject) {
                    var bNode = this.util.createBlankNode();
                    this.emitTriple(this.util.getResourceOrBaseIri(subject, activeTag), predicate, bNode);
                    this.emitTriple(bNode, this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'first'), this.util.getResourceOrBaseIri(currentObjectResource, activeTag));
                    this.emitTriple(bNode, this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'rest'), this.util.dataFactory.namedNode($gUL8T.Util.RDF + 'nil'));
                } else {
                    var predicateList = activeTag.listMappingLocal[predicate.value];
                    if (!predicateList) activeTag.listMappingLocal[predicate.value] = predicateList = [];
                    if (currentObjectResource) predicateList.push(currentObjectResource);
                }
            }
        },
        {
            /**
     * Emit the given triple to the stream.
     * @param {Term} subject A subject term.
     * @param {Term} predicate A predicate term.
     * @param {Term} object An object term.
     */ key: "emitTriple",
            value: function emitTriple(subject, predicate, object) {
                // Validate IRIs
                if (subject.termType === 'NamedNode' && subject.value.indexOf(':') < 0 || predicate.termType === 'NamedNode' && predicate.value.indexOf(':') < 0 || object.termType === 'NamedNode' && object.value.indexOf(':') < 0) return;
                this.push(this.util.dataFactory.quad(subject, predicate, object, this.defaultGraph));
            }
        },
        {
            /**
     * Emit an instantiation of the given pattern with the given parent tag.
     * @param {IActiveTag} parentTag The parent tag to instantiate in.
     * @param {IRdfaPattern} pattern The pattern to instantiate.
     * @param {string} rootPatternId The pattern id.
     */ key: "emitPatternCopy",
            value: function emitPatternCopy(parentTag, pattern, rootPatternId) {
                var _this = this;
                this.activeTagStack.push(parentTag);
                pattern.referenced = true;
                // Ensure that blank nodes within patterns are instantiated only once.
                // All next pattern copies will reuse the instantiated blank nodes from the first pattern.
                if (!pattern.constructedBlankNodes) {
                    pattern.constructedBlankNodes = [];
                    this.util.blankNodeFactory = function() {
                        var bNode = _this.util.dataFactory.blankNode();
                        pattern.constructedBlankNodes.push(bNode);
                        return bNode;
                    };
                } else {
                    var blankNodeIndex = 0;
                    this.util.blankNodeFactory = function() {
                        return pattern.constructedBlankNodes[blankNodeIndex++];
                    };
                }
                // Apply everything within the pattern
                this.emitPatternCopyAbsolute(pattern, true, rootPatternId);
                this.util.blankNodeFactory = null;
                this.activeTagStack.pop();
            }
        },
        {
            /**
     * Emit an instantiation of the given pattern with the given parent tag.
     *
     * This should probably not be called directly,
     * call {@link emitPatternCopy} instead.
     *
     * @param {IRdfaPattern} pattern The pattern to instantiate.
     * @param {boolean} root If this is the root call for the given pattern.
     * @param {string} rootPatternId The pattern id.
     */ key: "emitPatternCopyAbsolute",
            value: function emitPatternCopyAbsolute(pattern, root, rootPatternId) {
                // Stop on detection of cyclic patterns
                if (!root && pattern.attributes.property === 'rdfa:copy' && pattern.attributes.href === rootPatternId) return;
                this.onTagOpen(pattern.name, pattern.attributes);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pattern.text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var text = _step.value;
                        this.onText(text);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = pattern.children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var child = _step1.value;
                        this.emitPatternCopyAbsolute(child, false, rootPatternId);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this.onTagClose();
            }
        },
        {
            key: "initializeParser",
            value: function initializeParser(xmlMode) {
                var _this = this;
                return new $gDl0h.Parser({
                    onclosetag: function() {
                        try {
                            _this.onTagClose();
                            if (_this.htmlParseListener) _this.htmlParseListener.onTagClose();
                        } catch (e) {
                            _this.emit('error', e);
                        }
                    },
                    onend: function() {
                        try {
                            _this.onEnd();
                            if (_this.htmlParseListener) _this.htmlParseListener.onEnd();
                        } catch (e) {
                            _this.emit('error', e);
                        }
                    },
                    onopentag: function(name, attributes) {
                        try {
                            _this.onTagOpen(name, attributes);
                            if (_this.htmlParseListener) _this.htmlParseListener.onTagOpen(name, attributes);
                        } catch (e) {
                            _this.emit('error', e);
                        }
                    },
                    ontext: function(data) {
                        try {
                            _this.onText(data);
                            if (_this.htmlParseListener) _this.htmlParseListener.onText(data);
                        } catch (e) {
                            _this.emit('error', e);
                        }
                    }
                }, {
                    decodeEntities: true,
                    recognizeSelfClosing: true,
                    xmlMode: xmlMode
                });
            }
        }
    ]);
    return RdfaParser;
}($2G1Uq.Transform);
module.exports.RdfaParser = $d936cffb3a18238e$var$RdfaParser;

});
parcelRegister("8TUUs", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("gDl0h")).Parser; });

var $gDl0h = parcelRequire("gDl0h");

var $fjj4Z = parcelRequire("fjj4Z");

var $1uIGs = parcelRequire("1uIGs");

var $gDDlX = parcelRequire("gDDlX");
parcelRequire("4u3Uv");
var $b6XQv = parcelRequire("b6XQv");
function $67af9ade9a7c3304$export$b6a9369736b19f4d(data, options) {
    var handler = new (0, $fjj4Z.DomHandler)(undefined, options);
    new (0, $gDl0h.Parser)(handler, options).end(data);
    return handler.root;
}
function $67af9ade9a7c3304$export$d66b332881d9723f(data, options) {
    return $67af9ade9a7c3304$export$b6a9369736b19f4d(data, options).children;
}
function $67af9ade9a7c3304$export$2bbd0317573b00fc(callback, options, elementCallback) {
    var handler = new (0, $fjj4Z.DomHandler)(callback, options, elementCallback);
    return new (0, $gDl0h.Parser)(handler, options);
}
var $67af9ade9a7c3304$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $67af9ade9a7c3304$export$5267abf679cd576b(feed) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67af9ade9a7c3304$var$parseFeedDefaultOptions;
    return (0, $b6XQv.getFeed)($67af9ade9a7c3304$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("gDl0h", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $c1c094b3237b9e3f$export$7acfa6ed01010e37; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $1uIGs = parcelRequire("1uIGs");

var $gkpNv = parcelRequire("gkpNv");
var $c1c094b3237b9e3f$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $c1c094b3237b9e3f$var$pTag = new Set([
    "p"
]);
var $c1c094b3237b9e3f$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $c1c094b3237b9e3f$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $c1c094b3237b9e3f$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $c1c094b3237b9e3f$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h1",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h2",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h3",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h4",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h5",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "h6",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "select",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "input",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "output",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "button",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "datalist",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "textarea",
        $c1c094b3237b9e3f$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $c1c094b3237b9e3f$var$ddtTags
    ],
    [
        "dt",
        $c1c094b3237b9e3f$var$ddtTags
    ],
    [
        "address",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "article",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "aside",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "blockquote",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "details",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "div",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "dl",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "fieldset",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "figcaption",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "figure",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "footer",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "form",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "header",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "hr",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "main",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "nav",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "ol",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "pre",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "section",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "table",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "ul",
        $c1c094b3237b9e3f$var$pTag
    ],
    [
        "rt",
        $c1c094b3237b9e3f$var$rtpTags
    ],
    [
        "rp",
        $c1c094b3237b9e3f$var$rtpTags
    ],
    [
        "tbody",
        $c1c094b3237b9e3f$var$tableSectionTags
    ],
    [
        "tfoot",
        $c1c094b3237b9e3f$var$tableSectionTags
    ]
]);
var $c1c094b3237b9e3f$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $c1c094b3237b9e3f$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $c1c094b3237b9e3f$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $c1c094b3237b9e3f$var$reNameEnd = /\s|\//;
var $c1c094b3237b9e3f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser(cbs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, Parser);
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $1uIGs.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    (0, $byiyg._)(Parser, [
        {
            // Tokenizer event handlers
            /** @internal */ key: "ontext",
            value: function ontext(start, endIndex) {
                var _a, _b;
                var data = this.getSlice(start, endIndex);
                this.endIndex = endIndex - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
                this.startIndex = endIndex;
            }
        },
        {
            /** @internal */ key: "ontextentity",
            value: function ontextentity(cp) {
                var _a, _b;
                /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ var index = this.tokenizer.getSectionStart();
                this.endIndex = index - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $gkpNv.fromCodePoint)(cp));
                this.startIndex = index;
            }
        },
        {
            key: "isVoidElement",
            value: function isVoidElement(name) {
                return !this.options.xmlMode && $c1c094b3237b9e3f$var$voidElements.has(name);
            }
        },
        {
            /** @internal */ key: "onopentagname",
            value: function onopentagname(start, endIndex) {
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                this.emitOpenTag(name);
            }
        },
        {
            key: "emitOpenTag",
            value: function emitOpenTag(name) {
                var _a, _b, _c, _d;
                this.openTagStart = this.startIndex;
                this.tagname = name;
                var impliesClose = !this.options.xmlMode && $c1c094b3237b9e3f$var$openImpliesClose.get(name);
                if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
                    var element = this.stack.pop();
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
                }
                if (!this.isVoidElement(name)) {
                    this.stack.push(name);
                    if ($c1c094b3237b9e3f$var$foreignContextElements.has(name)) this.foreignContext.push(true);
                    else if ($c1c094b3237b9e3f$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
                }
                (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
                if (this.cbs.onopentag) this.attribs = {};
            }
        },
        {
            key: "endOpenTag",
            value: function endOpenTag(isImplied) {
                var _a, _b;
                this.startIndex = this.openTagStart;
                if (this.attribs) {
                    (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
                    this.attribs = null;
                }
                if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
                this.tagname = "";
            }
        },
        {
            /** @internal */ key: "onopentagend",
            value: function onopentagend(endIndex) {
                this.endIndex = endIndex;
                this.endOpenTag(false);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onclosetag",
            value: function onclosetag(start, endIndex) {
                var _a, _b, _c, _d, _e, _f;
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                if ($c1c094b3237b9e3f$var$foreignContextElements.has(name) || $c1c094b3237b9e3f$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
                if (!this.isVoidElement(name)) {
                    var pos = this.stack.lastIndexOf(name);
                    if (pos !== -1) {
                        if (this.cbs.onclosetag) {
                            var count = this.stack.length - pos;
                            while(count--)// We know the stack has sufficient elements.
                            this.cbs.onclosetag(this.stack.pop(), count !== 0);
                        } else this.stack.length = pos;
                    } else if (!this.options.xmlMode && name === "p") {
                        // Implicit open before close
                        this.emitOpenTag("p");
                        this.closeCurrentTag(true);
                    }
                } else if (!this.options.xmlMode && name === "br") {
                    // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
                    (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
                    (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
                    (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onselfclosingtag",
            value: function onselfclosingtag(endIndex) {
                this.endIndex = endIndex;
                if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
                    this.closeCurrentTag(false);
                    // Set `startIndex` for next node
                    this.startIndex = endIndex + 1;
                } else // Ignore the fact that the tag is self-closing.
                this.onopentagend(endIndex);
            }
        },
        {
            key: "closeCurrentTag",
            value: function closeCurrentTag(isOpenImplied) {
                var _a, _b;
                var name = this.tagname;
                this.endOpenTag(isOpenImplied);
                // Self-closing tags will be on the top of the stack
                if (this.stack[this.stack.length - 1] === name) {
                    // If the opening tag isn't implied, the closing tag has to be implied.
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
                    this.stack.pop();
                }
            }
        },
        {
            /** @internal */ key: "onattribname",
            value: function onattribname(start, endIndex) {
                this.startIndex = start;
                var name = this.getSlice(start, endIndex);
                this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
            }
        },
        {
            /** @internal */ key: "onattribdata",
            value: function onattribdata(start, endIndex) {
                this.attribvalue += this.getSlice(start, endIndex);
            }
        },
        {
            /** @internal */ key: "onattribentity",
            value: function onattribentity(cp) {
                this.attribvalue += (0, $gkpNv.fromCodePoint)(cp);
            }
        },
        {
            /** @internal */ key: "onattribend",
            value: function onattribend(quote, endIndex) {
                var _a, _b;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $1uIGs.QuoteType).Double ? '"' : quote === (0, $1uIGs.QuoteType).Single ? "'" : quote === (0, $1uIGs.QuoteType).NoValue ? undefined : null);
                if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
                this.attribvalue = "";
            }
        },
        {
            key: "getInstructionName",
            value: function getInstructionName(value) {
                var index = value.search($c1c094b3237b9e3f$var$reNameEnd);
                var name = index < 0 ? value : value.substr(0, index);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                return name;
            }
        },
        {
            /** @internal */ key: "ondeclaration",
            value: function ondeclaration(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onprocessinginstruction",
            value: function onprocessinginstruction(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncomment",
            value: function oncomment(start, endIndex, offset) {
                var _a, _b, _c, _d;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
                (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncdata",
            value: function oncdata(start, endIndex, offset) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex - offset);
                if (this.options.xmlMode || this.options.recognizeCDATA) {
                    (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
                    (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
                    (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
                } else {
                    (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
                    (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onend",
            value: function onend() {
                var _a, _b;
                if (this.cbs.onclosetag) {
                    // Set the end index for all remaining tags
                    this.endIndex = this.startIndex;
                    for(var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
                }
                (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
            }
        },
        {
            /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ key: "reset",
            value: function reset() {
                var _a, _b, _c, _d;
                (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
                this.tokenizer.reset();
                this.tagname = "";
                this.attribname = "";
                this.attribs = null;
                this.stack.length = 0;
                this.startIndex = 0;
                this.endIndex = 0;
                (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
                this.buffers.length = 0;
                this.bufferOffset = 0;
                this.writeIndex = 0;
                this.ended = false;
            }
        },
        {
            /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ key: "parseComplete",
            value: function parseComplete(data) {
                this.reset();
                this.end(data);
            }
        },
        {
            key: "getSlice",
            value: function getSlice(start, end) {
                while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
                var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
                while(end - this.bufferOffset > this.buffers[0].length){
                    this.shiftBuffer();
                    slice += this.buffers[0].slice(0, end - this.bufferOffset);
                }
                return slice;
            }
        },
        {
            key: "shiftBuffer",
            value: function shiftBuffer() {
                this.bufferOffset += this.buffers[0].length;
                this.writeIndex--;
                this.buffers.shift();
            }
        },
        {
            /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ key: "write",
            value: function write(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
                    return;
                }
                this.buffers.push(chunk);
                if (this.tokenizer.running) {
                    this.tokenizer.write(chunk);
                    this.writeIndex++;
                }
            }
        },
        {
            /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ key: "end",
            value: function end(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
                    return;
                }
                if (chunk) this.write(chunk);
                this.ended = true;
                this.tokenizer.end();
            }
        },
        {
            /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ key: "pause",
            value: function pause() {
                this.tokenizer.pause();
            }
        },
        {
            /**
     * Resumes parsing after `pause` was called.
     */ key: "resume",
            value: function resume() {
                this.tokenizer.resume();
                while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
                if (this.ended) this.tokenizer.end();
            }
        },
        {
            /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ key: "parseChunk",
            value: function parseChunk(chunk) {
                this.write(chunk);
            }
        },
        {
            /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ key: "done",
            value: function done(chunk) {
                this.end(chunk);
            }
        }
    ]);
    return Parser;
}();

});
parcelRegister("1uIGs", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $116b410936e437c2$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $116b410936e437c2$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $gkpNv = parcelRequire("gkpNv");
var $116b410936e437c2$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($116b410936e437c2$var$CharCodes || ($116b410936e437c2$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $116b410936e437c2$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($116b410936e437c2$var$State || ($116b410936e437c2$var$State = {}));
function $116b410936e437c2$var$isWhitespace(c) {
    return c === $116b410936e437c2$var$CharCodes.Space || c === $116b410936e437c2$var$CharCodes.NewLine || c === $116b410936e437c2$var$CharCodes.Tab || c === $116b410936e437c2$var$CharCodes.FormFeed || c === $116b410936e437c2$var$CharCodes.CarriageReturn;
}
function $116b410936e437c2$var$isEndOfTagSection(c) {
    return c === $116b410936e437c2$var$CharCodes.Slash || c === $116b410936e437c2$var$CharCodes.Gt || $116b410936e437c2$var$isWhitespace(c);
}
function $116b410936e437c2$var$isNumber(c) {
    return c >= $116b410936e437c2$var$CharCodes.Zero && c <= $116b410936e437c2$var$CharCodes.Nine;
}
function $116b410936e437c2$var$isASCIIAlpha(c) {
    return c >= $116b410936e437c2$var$CharCodes.LowerA && c <= $116b410936e437c2$var$CharCodes.LowerZ || c >= $116b410936e437c2$var$CharCodes.UpperA && c <= $116b410936e437c2$var$CharCodes.UpperZ;
}
function $116b410936e437c2$var$isHexDigit(c) {
    return c >= $116b410936e437c2$var$CharCodes.UpperA && c <= $116b410936e437c2$var$CharCodes.UpperF || c >= $116b410936e437c2$var$CharCodes.LowerA && c <= $116b410936e437c2$var$CharCodes.LowerF;
}
var $116b410936e437c2$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($116b410936e437c2$export$cbf5509cea2ad22 || ($116b410936e437c2$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $116b410936e437c2$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
var $116b410936e437c2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Tokenizer(param, cbs) {
        var _param_xmlMode = param.xmlMode, xmlMode = _param_xmlMode === void 0 ? false : _param_xmlMode, _param_decodeEntities = param.decodeEntities, decodeEntities = _param_decodeEntities === void 0 ? true : _param_decodeEntities;
        (0, $jGAMp._)(this, Tokenizer);
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $116b410936e437c2$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $116b410936e437c2$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $gkpNv.xmlDecodeTree) : (0, $gkpNv.htmlDecodeTree);
    }
    (0, $byiyg._)(Tokenizer, [
        {
            key: "reset",
            value: function reset() {
                this.state = $116b410936e437c2$var$State.Text;
                this.buffer = "";
                this.sectionStart = 0;
                this.index = 0;
                this.baseState = $116b410936e437c2$var$State.Text;
                this.currentSequence = undefined;
                this.running = true;
                this.offset = 0;
            }
        },
        {
            key: "write",
            value: function write(chunk) {
                this.offset += this.buffer.length;
                this.buffer = chunk;
                this.parse();
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.running) this.finish();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.running = false;
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.running = true;
                if (this.index < this.buffer.length + this.offset) this.parse();
            }
        },
        {
            /**
     * The current index within all of the written data.
     */ key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            /**
     * The start of the current section.
     */ key: "getSectionStart",
            value: function getSectionStart() {
                return this.sectionStart;
            }
        },
        {
            key: "stateText",
            value: function stateText(c) {
                if (c === $116b410936e437c2$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($116b410936e437c2$var$CharCodes.Lt)) {
                    if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
                    this.state = $116b410936e437c2$var$State.BeforeTagName;
                    this.sectionStart = this.index;
                } else if (this.decodeEntities && c === $116b410936e437c2$var$CharCodes.Amp) this.state = $116b410936e437c2$var$State.BeforeEntity;
            }
        },
        {
            key: "stateSpecialStartSequence",
            value: function stateSpecialStartSequence(c) {
                var isEnd = this.sequenceIndex === this.currentSequence.length;
                var isMatch = isEnd ? $116b410936e437c2$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
                if (!isMatch) this.isSpecial = false;
                else if (!isEnd) {
                    this.sequenceIndex++;
                    return;
                }
                this.sequenceIndex = 0;
                this.state = $116b410936e437c2$var$State.InTagName;
                this.stateInTagName(c);
            }
        },
        {
            /** Look for an end tag. For <title> tags, also decode entities. */ key: "stateInSpecialTag",
            value: function stateInSpecialTag(c) {
                if (this.sequenceIndex === this.currentSequence.length) {
                    if (c === $116b410936e437c2$var$CharCodes.Gt || $116b410936e437c2$var$isWhitespace(c)) {
                        var endOfText = this.index - this.currentSequence.length;
                        if (this.sectionStart < endOfText) {
                            // Spoof the index so that reported locations match up.
                            var actualIndex = this.index;
                            this.index = endOfText;
                            this.cbs.ontext(this.sectionStart, endOfText);
                            this.index = actualIndex;
                        }
                        this.isSpecial = false;
                        this.sectionStart = endOfText + 2; // Skip over the `</`
                        this.stateInClosingTagName(c);
                        return; // We are done; skip the rest of the function.
                    }
                    this.sequenceIndex = 0;
                }
                if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
                else if (this.sequenceIndex === 0) {
                    if (this.currentSequence === $116b410936e437c2$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
                    {
                        if (this.decodeEntities && c === $116b410936e437c2$var$CharCodes.Amp) this.state = $116b410936e437c2$var$State.BeforeEntity;
                    } else if (this.fastForwardTo($116b410936e437c2$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
                    this.sequenceIndex = 1;
                } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
                this.sequenceIndex = Number(c === $116b410936e437c2$var$CharCodes.Lt);
            }
        },
        {
            key: "stateCDATASequence",
            value: function stateCDATASequence(c) {
                if (c === $116b410936e437c2$var$Sequences.Cdata[this.sequenceIndex]) {
                    if (++this.sequenceIndex === $116b410936e437c2$var$Sequences.Cdata.length) {
                        this.state = $116b410936e437c2$var$State.InCommentLike;
                        this.currentSequence = $116b410936e437c2$var$Sequences.CdataEnd;
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                    }
                } else {
                    this.sequenceIndex = 0;
                    this.state = $116b410936e437c2$var$State.InDeclaration;
                    this.stateInDeclaration(c); // Reconsume the character
                }
            }
        },
        {
            /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ key: "fastForwardTo",
            value: function fastForwardTo(c) {
                while(++this.index < this.buffer.length + this.offset){
                    if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
                }
                /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
                return false;
            }
        },
        {
            /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ key: "stateInCommentLike",
            value: function stateInCommentLike(c) {
                if (c === this.currentSequence[this.sequenceIndex]) {
                    if (++this.sequenceIndex === this.currentSequence.length) {
                        if (this.currentSequence === $116b410936e437c2$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                        else this.cbs.oncomment(this.sectionStart, this.index, 2);
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                        this.state = $116b410936e437c2$var$State.Text;
                    }
                } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
                {
                    if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
                } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
                this.sequenceIndex = 0;
            }
        },
        {
            /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ key: "isTagStartChar",
            value: function isTagStartChar(c) {
                return this.xmlMode ? !$116b410936e437c2$var$isEndOfTagSection(c) : $116b410936e437c2$var$isASCIIAlpha(c);
            }
        },
        {
            key: "startSpecial",
            value: function startSpecial(sequence, offset) {
                this.isSpecial = true;
                this.currentSequence = sequence;
                this.sequenceIndex = offset;
                this.state = $116b410936e437c2$var$State.SpecialStartSequence;
            }
        },
        {
            key: "stateBeforeTagName",
            value: function stateBeforeTagName(c) {
                if (c === $116b410936e437c2$var$CharCodes.ExclamationMark) {
                    this.state = $116b410936e437c2$var$State.BeforeDeclaration;
                    this.sectionStart = this.index + 1;
                } else if (c === $116b410936e437c2$var$CharCodes.Questionmark) {
                    this.state = $116b410936e437c2$var$State.InProcessingInstruction;
                    this.sectionStart = this.index + 1;
                } else if (this.isTagStartChar(c)) {
                    var lower = c | 0x20;
                    this.sectionStart = this.index;
                    if (!this.xmlMode && lower === $116b410936e437c2$var$Sequences.TitleEnd[2]) this.startSpecial($116b410936e437c2$var$Sequences.TitleEnd, 3);
                    else this.state = !this.xmlMode && lower === $116b410936e437c2$var$Sequences.ScriptEnd[2] ? $116b410936e437c2$var$State.BeforeSpecialS : $116b410936e437c2$var$State.InTagName;
                } else if (c === $116b410936e437c2$var$CharCodes.Slash) this.state = $116b410936e437c2$var$State.BeforeClosingTagName;
                else {
                    this.state = $116b410936e437c2$var$State.Text;
                    this.stateText(c);
                }
            }
        },
        {
            key: "stateInTagName",
            value: function stateInTagName(c) {
                if ($116b410936e437c2$var$isEndOfTagSection(c)) {
                    this.cbs.onopentagname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $116b410936e437c2$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateBeforeClosingTagName",
            value: function stateBeforeClosingTagName(c) {
                if ($116b410936e437c2$var$isWhitespace(c)) ;
                else if (c === $116b410936e437c2$var$CharCodes.Gt) this.state = $116b410936e437c2$var$State.Text;
                else {
                    this.state = this.isTagStartChar(c) ? $116b410936e437c2$var$State.InClosingTagName : $116b410936e437c2$var$State.InSpecialComment;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInClosingTagName",
            value: function stateInClosingTagName(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt || $116b410936e437c2$var$isWhitespace(c)) {
                    this.cbs.onclosetag(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $116b410936e437c2$var$State.AfterClosingTagName;
                    this.stateAfterClosingTagName(c);
                }
            }
        },
        {
            key: "stateAfterClosingTagName",
            value: function stateAfterClosingTagName(c) {
                // Skip everything until ">"
                if (c === $116b410936e437c2$var$CharCodes.Gt || this.fastForwardTo($116b410936e437c2$var$CharCodes.Gt)) {
                    this.state = $116b410936e437c2$var$State.Text;
                    this.baseState = $116b410936e437c2$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeAttributeName",
            value: function stateBeforeAttributeName(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt) {
                    this.cbs.onopentagend(this.index);
                    if (this.isSpecial) {
                        this.state = $116b410936e437c2$var$State.InSpecialTag;
                        this.sequenceIndex = 0;
                    } else this.state = $116b410936e437c2$var$State.Text;
                    this.baseState = this.state;
                    this.sectionStart = this.index + 1;
                } else if (c === $116b410936e437c2$var$CharCodes.Slash) this.state = $116b410936e437c2$var$State.InSelfClosingTag;
                else if (!$116b410936e437c2$var$isWhitespace(c)) {
                    this.state = $116b410936e437c2$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInSelfClosingTag",
            value: function stateInSelfClosingTag(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt) {
                    this.cbs.onselfclosingtag(this.index);
                    this.state = $116b410936e437c2$var$State.Text;
                    this.baseState = $116b410936e437c2$var$State.Text;
                    this.sectionStart = this.index + 1;
                    this.isSpecial = false; // Reset special state, in case of self-closing special tags
                } else if (!$116b410936e437c2$var$isWhitespace(c)) {
                    this.state = $116b410936e437c2$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateInAttributeName",
            value: function stateInAttributeName(c) {
                if (c === $116b410936e437c2$var$CharCodes.Eq || $116b410936e437c2$var$isEndOfTagSection(c)) {
                    this.cbs.onattribname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $116b410936e437c2$var$State.AfterAttributeName;
                    this.stateAfterAttributeName(c);
                }
            }
        },
        {
            key: "stateAfterAttributeName",
            value: function stateAfterAttributeName(c) {
                if (c === $116b410936e437c2$var$CharCodes.Eq) this.state = $116b410936e437c2$var$State.BeforeAttributeValue;
                else if (c === $116b410936e437c2$var$CharCodes.Slash || c === $116b410936e437c2$var$CharCodes.Gt) {
                    this.cbs.onattribend($116b410936e437c2$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $116b410936e437c2$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (!$116b410936e437c2$var$isWhitespace(c)) {
                    this.cbs.onattribend($116b410936e437c2$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $116b410936e437c2$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateBeforeAttributeValue",
            value: function stateBeforeAttributeValue(c) {
                if (c === $116b410936e437c2$var$CharCodes.DoubleQuote) {
                    this.state = $116b410936e437c2$var$State.InAttributeValueDq;
                    this.sectionStart = this.index + 1;
                } else if (c === $116b410936e437c2$var$CharCodes.SingleQuote) {
                    this.state = $116b410936e437c2$var$State.InAttributeValueSq;
                    this.sectionStart = this.index + 1;
                } else if (!$116b410936e437c2$var$isWhitespace(c)) {
                    this.sectionStart = this.index;
                    this.state = $116b410936e437c2$var$State.InAttributeValueNq;
                    this.stateInAttributeValueNoQuotes(c); // Reconsume token
                }
            }
        },
        {
            key: "handleInAttributeValue",
            value: function handleInAttributeValue(c, quote) {
                if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend(quote === $116b410936e437c2$var$CharCodes.DoubleQuote ? $116b410936e437c2$export$cbf5509cea2ad22.Double : $116b410936e437c2$export$cbf5509cea2ad22.Single, this.index);
                    this.state = $116b410936e437c2$var$State.BeforeAttributeName;
                } else if (this.decodeEntities && c === $116b410936e437c2$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $116b410936e437c2$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateInAttributeValueDoubleQuotes",
            value: function stateInAttributeValueDoubleQuotes(c) {
                this.handleInAttributeValue(c, $116b410936e437c2$var$CharCodes.DoubleQuote);
            }
        },
        {
            key: "stateInAttributeValueSingleQuotes",
            value: function stateInAttributeValueSingleQuotes(c) {
                this.handleInAttributeValue(c, $116b410936e437c2$var$CharCodes.SingleQuote);
            }
        },
        {
            key: "stateInAttributeValueNoQuotes",
            value: function stateInAttributeValueNoQuotes(c) {
                if ($116b410936e437c2$var$isWhitespace(c) || c === $116b410936e437c2$var$CharCodes.Gt) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend($116b410936e437c2$export$cbf5509cea2ad22.Unquoted, this.index);
                    this.state = $116b410936e437c2$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (this.decodeEntities && c === $116b410936e437c2$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $116b410936e437c2$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateBeforeDeclaration",
            value: function stateBeforeDeclaration(c) {
                if (c === $116b410936e437c2$var$CharCodes.OpeningSquareBracket) {
                    this.state = $116b410936e437c2$var$State.CDATASequence;
                    this.sequenceIndex = 0;
                } else this.state = c === $116b410936e437c2$var$CharCodes.Dash ? $116b410936e437c2$var$State.BeforeComment : $116b410936e437c2$var$State.InDeclaration;
            }
        },
        {
            key: "stateInDeclaration",
            value: function stateInDeclaration(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt || this.fastForwardTo($116b410936e437c2$var$CharCodes.Gt)) {
                    this.cbs.ondeclaration(this.sectionStart, this.index);
                    this.state = $116b410936e437c2$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateInProcessingInstruction",
            value: function stateInProcessingInstruction(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt || this.fastForwardTo($116b410936e437c2$var$CharCodes.Gt)) {
                    this.cbs.onprocessinginstruction(this.sectionStart, this.index);
                    this.state = $116b410936e437c2$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeComment",
            value: function stateBeforeComment(c) {
                if (c === $116b410936e437c2$var$CharCodes.Dash) {
                    this.state = $116b410936e437c2$var$State.InCommentLike;
                    this.currentSequence = $116b410936e437c2$var$Sequences.CommentEnd;
                    // Allow short comments (eg. <!-->)
                    this.sequenceIndex = 2;
                    this.sectionStart = this.index + 1;
                } else this.state = $116b410936e437c2$var$State.InDeclaration;
            }
        },
        {
            key: "stateInSpecialComment",
            value: function stateInSpecialComment(c) {
                if (c === $116b410936e437c2$var$CharCodes.Gt || this.fastForwardTo($116b410936e437c2$var$CharCodes.Gt)) {
                    this.cbs.oncomment(this.sectionStart, this.index, 0);
                    this.state = $116b410936e437c2$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeSpecialS",
            value: function stateBeforeSpecialS(c) {
                var lower = c | 0x20;
                if (lower === $116b410936e437c2$var$Sequences.ScriptEnd[3]) this.startSpecial($116b410936e437c2$var$Sequences.ScriptEnd, 4);
                else if (lower === $116b410936e437c2$var$Sequences.StyleEnd[3]) this.startSpecial($116b410936e437c2$var$Sequences.StyleEnd, 4);
                else {
                    this.state = $116b410936e437c2$var$State.InTagName;
                    this.stateInTagName(c); // Consume the token again
                }
            }
        },
        {
            key: "stateBeforeEntity",
            value: function stateBeforeEntity(c) {
                // Start excess with 1 to include the '&'
                this.entityExcess = 1;
                this.entityResult = 0;
                if (c === $116b410936e437c2$var$CharCodes.Number) this.state = $116b410936e437c2$var$State.BeforeNumericEntity;
                else if (c === $116b410936e437c2$var$CharCodes.Amp) ;
                else {
                    this.trieIndex = 0;
                    this.trieCurrent = this.entityTrie[0];
                    this.state = $116b410936e437c2$var$State.InNamedEntity;
                    this.stateInNamedEntity(c);
                }
            }
        },
        {
            key: "stateInNamedEntity",
            value: function stateInNamedEntity(c) {
                this.entityExcess += 1;
                this.trieIndex = (0, $gkpNv.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
                if (this.trieIndex < 0) {
                    this.emitNamedEntity();
                    this.index--;
                    return;
                }
                this.trieCurrent = this.entityTrie[this.trieIndex];
                var masked = this.trieCurrent & (0, $gkpNv.BinTrieFlags).VALUE_LENGTH;
                // If the branch is a value, store it and continue
                if (masked) {
                    // The mask is the number of bytes of the value, including the current byte.
                    var valueLength = (masked >> 14) - 1;
                    // If we have a legacy entity while parsing strictly, just skip the number of bytes
                    if (!this.allowLegacyEntity() && c !== $116b410936e437c2$var$CharCodes.Semi) this.trieIndex += valueLength;
                    else {
                        // Add 1 as we have already incremented the excess
                        var entityStart = this.index - this.entityExcess + 1;
                        if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                        // If this is a surrogate pair, consume the next two bytes
                        this.entityResult = this.trieIndex;
                        this.trieIndex += valueLength;
                        this.entityExcess = 0;
                        this.sectionStart = this.index + 1;
                        if (valueLength === 0) this.emitNamedEntity();
                    }
                }
            }
        },
        {
            key: "emitNamedEntity",
            value: function emitNamedEntity() {
                this.state = this.baseState;
                if (this.entityResult === 0) return;
                var valueLength = (this.entityTrie[this.entityResult] & (0, $gkpNv.BinTrieFlags).VALUE_LENGTH) >> 14;
                switch(valueLength){
                    case 1:
                        this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $gkpNv.BinTrieFlags).VALUE_LENGTH);
                        break;
                    case 2:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        break;
                    case 3:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
                }
            }
        },
        {
            key: "stateBeforeNumericEntity",
            value: function stateBeforeNumericEntity(c) {
                if ((c | 0x20) === $116b410936e437c2$var$CharCodes.LowerX) {
                    this.entityExcess++;
                    this.state = $116b410936e437c2$var$State.InHexEntity;
                } else {
                    this.state = $116b410936e437c2$var$State.InNumericEntity;
                    this.stateInNumericEntity(c);
                }
            }
        },
        {
            key: "emitNumericEntity",
            value: function emitNumericEntity(strict) {
                var entityStart = this.index - this.entityExcess - 1;
                var numberStart = entityStart + 2 + Number(this.state === $116b410936e437c2$var$State.InHexEntity);
                if (numberStart !== this.index) {
                    // Emit leading data if any
                    if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                    this.sectionStart = this.index + Number(strict);
                    this.emitCodePoint((0, $gkpNv.replaceCodePoint)(this.entityResult));
                }
                this.state = this.baseState;
            }
        },
        {
            key: "stateInNumericEntity",
            value: function stateInNumericEntity(c) {
                if (c === $116b410936e437c2$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($116b410936e437c2$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 10 + (c - $116b410936e437c2$var$CharCodes.Zero);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "stateInHexEntity",
            value: function stateInHexEntity(c) {
                if (c === $116b410936e437c2$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($116b410936e437c2$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 16 + (c - $116b410936e437c2$var$CharCodes.Zero);
                    this.entityExcess++;
                } else if ($116b410936e437c2$var$isHexDigit(c)) {
                    this.entityResult = this.entityResult * 16 + ((c | 0x20) - $116b410936e437c2$var$CharCodes.LowerA + 10);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "allowLegacyEntity",
            value: function allowLegacyEntity() {
                return !this.xmlMode && (this.baseState === $116b410936e437c2$var$State.Text || this.baseState === $116b410936e437c2$var$State.InSpecialTag);
            }
        },
        {
            /**
     * Remove data that has already been consumed from the buffer.
     */ key: "cleanup",
            value: function cleanup() {
                // If we are inside of text or attributes, emit what we already have.
                if (this.running && this.sectionStart !== this.index) {
                    if (this.state === $116b410936e437c2$var$State.Text || this.state === $116b410936e437c2$var$State.InSpecialTag && this.sequenceIndex === 0) {
                        this.cbs.ontext(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    } else if (this.state === $116b410936e437c2$var$State.InAttributeValueDq || this.state === $116b410936e437c2$var$State.InAttributeValueSq || this.state === $116b410936e437c2$var$State.InAttributeValueNq) {
                        this.cbs.onattribdata(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    }
                }
            }
        },
        {
            key: "shouldContinue",
            value: function shouldContinue() {
                return this.index < this.buffer.length + this.offset && this.running;
            }
        },
        {
            /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ key: "parse",
            value: function parse() {
                while(this.shouldContinue()){
                    var c = this.buffer.charCodeAt(this.index - this.offset);
                    switch(this.state){
                        case $116b410936e437c2$var$State.Text:
                            this.stateText(c);
                            break;
                        case $116b410936e437c2$var$State.SpecialStartSequence:
                            this.stateSpecialStartSequence(c);
                            break;
                        case $116b410936e437c2$var$State.InSpecialTag:
                            this.stateInSpecialTag(c);
                            break;
                        case $116b410936e437c2$var$State.CDATASequence:
                            this.stateCDATASequence(c);
                            break;
                        case $116b410936e437c2$var$State.InAttributeValueDq:
                            this.stateInAttributeValueDoubleQuotes(c);
                            break;
                        case $116b410936e437c2$var$State.InAttributeName:
                            this.stateInAttributeName(c);
                            break;
                        case $116b410936e437c2$var$State.InCommentLike:
                            this.stateInCommentLike(c);
                            break;
                        case $116b410936e437c2$var$State.InSpecialComment:
                            this.stateInSpecialComment(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeAttributeName:
                            this.stateBeforeAttributeName(c);
                            break;
                        case $116b410936e437c2$var$State.InTagName:
                            this.stateInTagName(c);
                            break;
                        case $116b410936e437c2$var$State.InClosingTagName:
                            this.stateInClosingTagName(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeTagName:
                            this.stateBeforeTagName(c);
                            break;
                        case $116b410936e437c2$var$State.AfterAttributeName:
                            this.stateAfterAttributeName(c);
                            break;
                        case $116b410936e437c2$var$State.InAttributeValueSq:
                            this.stateInAttributeValueSingleQuotes(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeAttributeValue:
                            this.stateBeforeAttributeValue(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeClosingTagName:
                            this.stateBeforeClosingTagName(c);
                            break;
                        case $116b410936e437c2$var$State.AfterClosingTagName:
                            this.stateAfterClosingTagName(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeSpecialS:
                            this.stateBeforeSpecialS(c);
                            break;
                        case $116b410936e437c2$var$State.InAttributeValueNq:
                            this.stateInAttributeValueNoQuotes(c);
                            break;
                        case $116b410936e437c2$var$State.InSelfClosingTag:
                            this.stateInSelfClosingTag(c);
                            break;
                        case $116b410936e437c2$var$State.InDeclaration:
                            this.stateInDeclaration(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeDeclaration:
                            this.stateBeforeDeclaration(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeComment:
                            this.stateBeforeComment(c);
                            break;
                        case $116b410936e437c2$var$State.InProcessingInstruction:
                            this.stateInProcessingInstruction(c);
                            break;
                        case $116b410936e437c2$var$State.InNamedEntity:
                            this.stateInNamedEntity(c);
                            break;
                        case $116b410936e437c2$var$State.BeforeEntity:
                            this.stateBeforeEntity(c);
                            break;
                        case $116b410936e437c2$var$State.InHexEntity:
                            this.stateInHexEntity(c);
                            break;
                        case $116b410936e437c2$var$State.InNumericEntity:
                            this.stateInNumericEntity(c);
                            break;
                        default:
                            // `this._state === State.BeforeNumericEntity`
                            this.stateBeforeNumericEntity(c);
                    }
                    this.index++;
                }
                this.cleanup();
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.state === $116b410936e437c2$var$State.InNamedEntity) this.emitNamedEntity();
                // If there is remaining data, emit it in a reasonable way
                if (this.sectionStart < this.index) this.handleTrailingData();
                this.cbs.onend();
            }
        },
        {
            /** Handle any trailing data. */ key: "handleTrailingData",
            value: function handleTrailingData() {
                var endIndex = this.buffer.length + this.offset;
                if (this.state === $116b410936e437c2$var$State.InCommentLike) {
                    if (this.currentSequence === $116b410936e437c2$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
                    else this.cbs.oncomment(this.sectionStart, endIndex, 0);
                } else if (this.state === $116b410936e437c2$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $116b410936e437c2$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $116b410936e437c2$var$State.InTagName || this.state === $116b410936e437c2$var$State.BeforeAttributeName || this.state === $116b410936e437c2$var$State.BeforeAttributeValue || this.state === $116b410936e437c2$var$State.AfterAttributeName || this.state === $116b410936e437c2$var$State.InAttributeName || this.state === $116b410936e437c2$var$State.InAttributeValueSq || this.state === $116b410936e437c2$var$State.InAttributeValueDq || this.state === $116b410936e437c2$var$State.InAttributeValueNq || this.state === $116b410936e437c2$var$State.InClosingTagName) ;
                else this.cbs.ontext(this.sectionStart, endIndex);
            }
        },
        {
            key: "emitPartial",
            value: function emitPartial(start, endIndex) {
                if (this.baseState !== $116b410936e437c2$var$State.Text && this.baseState !== $116b410936e437c2$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
                else this.cbs.ontext(start, endIndex);
            }
        },
        {
            key: "emitCodePoint",
            value: function emitCodePoint(cp) {
                if (this.baseState !== $116b410936e437c2$var$State.Text && this.baseState !== $116b410936e437c2$var$State.InSpecialTag) this.cbs.onattribentity(cp);
                else this.cbs.ontextentity(cp);
            }
        }
    ]);
    return Tokenizer;
}();

});
parcelRegister("gkpNv", function(module, exports) {
"use strict";
var $be32866caba6c335$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $be32866caba6c335$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $be32866caba6c335$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $be32866caba6c335$var$__createBinding(result, mod, k);
    }
    $be32866caba6c335$var$__setModuleDefault(result, mod);
    return result;
};
var $be32866caba6c335$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $be32866caba6c335$var$decode_data_html_js_1 = $be32866caba6c335$var$__importDefault((parcelRequire("lvHpx")));
module.exports.htmlDecodeTree = $be32866caba6c335$var$decode_data_html_js_1["default"];

var $be32866caba6c335$var$decode_data_xml_js_1 = $be32866caba6c335$var$__importDefault((parcelRequire("dxm8j")));
module.exports.xmlDecodeTree = $be32866caba6c335$var$decode_data_xml_js_1["default"];

var $be32866caba6c335$var$decode_codepoint_js_1 = $be32866caba6c335$var$__importStar((parcelRequire("fepo1")));
module.exports.decodeCodePoint = $be32866caba6c335$var$decode_codepoint_js_1["default"];

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("fepo1")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("fepo1")).fromCodePoint;
    }
});
var $be32866caba6c335$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($be32866caba6c335$var$CharCodes || ($be32866caba6c335$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $be32866caba6c335$var$TO_LOWER_BIT = 32;
var $be32866caba6c335$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($be32866caba6c335$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $be32866caba6c335$var$isNumber(code) {
    return code >= $be32866caba6c335$var$CharCodes.ZERO && code <= $be32866caba6c335$var$CharCodes.NINE;
}
function $be32866caba6c335$var$isHexadecimalCharacter(code) {
    return code >= $be32866caba6c335$var$CharCodes.UPPER_A && code <= $be32866caba6c335$var$CharCodes.UPPER_F || code >= $be32866caba6c335$var$CharCodes.LOWER_A && code <= $be32866caba6c335$var$CharCodes.LOWER_F;
}
function $be32866caba6c335$var$isAsciiAlphaNumeric(code) {
    return code >= $be32866caba6c335$var$CharCodes.UPPER_A && code <= $be32866caba6c335$var$CharCodes.UPPER_Z || code >= $be32866caba6c335$var$CharCodes.LOWER_A && code <= $be32866caba6c335$var$CharCodes.LOWER_Z || $be32866caba6c335$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $be32866caba6c335$var$isEntityInAttributeInvalidEnd(code) {
    return code === $be32866caba6c335$var$CharCodes.EQUALS || $be32866caba6c335$var$isAsciiAlphaNumeric(code);
}
var $be32866caba6c335$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($be32866caba6c335$var$EntityDecoderState || ($be32866caba6c335$var$EntityDecoderState = {}));
var $be32866caba6c335$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($be32866caba6c335$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $be32866caba6c335$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $be32866caba6c335$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $be32866caba6c335$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $be32866caba6c335$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $be32866caba6c335$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $be32866caba6c335$var$CharCodes.NUM) {
                    this.state = $be32866caba6c335$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $be32866caba6c335$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $be32866caba6c335$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $be32866caba6c335$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $be32866caba6c335$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $be32866caba6c335$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $be32866caba6c335$var$TO_LOWER_BIT) === $be32866caba6c335$var$CharCodes.LOWER_X) {
            this.state = $be32866caba6c335$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $be32866caba6c335$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var _char = str.charCodeAt(offset);
            if ($be32866caba6c335$var$isNumber(_char) || $be32866caba6c335$var$isHexadecimalCharacter(_char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(_char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var _char = str.charCodeAt(offset);
            if ($be32866caba6c335$var$isNumber(_char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(_char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $be32866caba6c335$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $be32866caba6c335$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $be32866caba6c335$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $be32866caba6c335$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $be32866caba6c335$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var _char = str.charCodeAt(offset);
            this.treeIndex = $be32866caba6c335$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), _char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $be32866caba6c335$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $be32866caba6c335$var$isEntityInAttributeInvalidEnd(_char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $be32866caba6c335$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (_char === $be32866caba6c335$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $be32866caba6c335$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $be32866caba6c335$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$be32866caba6c335$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $be32866caba6c335$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $be32866caba6c335$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $be32866caba6c335$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $be32866caba6c335$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $be32866caba6c335$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $be32866caba6c335$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $be32866caba6c335$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $be32866caba6c335$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $be32866caba6c335$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $be32866caba6c335$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $be32866caba6c335$var$determineBranch(decodeTree, current, nodeIdx, _char) {
    var branchCount = (current & $be32866caba6c335$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $be32866caba6c335$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && _char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = _char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < _char) lo = mid + 1;
        else if (midVal > _char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $be32866caba6c335$var$determineBranch;
var $be32866caba6c335$var$htmlDecoder = $be32866caba6c335$var$getDecoder($be32866caba6c335$var$decode_data_html_js_1["default"]);
var $be32866caba6c335$var$xmlDecoder = $be32866caba6c335$var$getDecoder($be32866caba6c335$var$decode_data_xml_js_1["default"]);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $be32866caba6c335$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $be32866caba6c335$var$DecodingMode.Legacy;
    return $be32866caba6c335$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $be32866caba6c335$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $be32866caba6c335$var$decodeHTMLAttribute(str) {
    return $be32866caba6c335$var$htmlDecoder(str, $be32866caba6c335$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $be32866caba6c335$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $be32866caba6c335$var$decodeHTMLStrict(str) {
    return $be32866caba6c335$var$htmlDecoder(str, $be32866caba6c335$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $be32866caba6c335$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $be32866caba6c335$var$decodeXML(str) {
    return $be32866caba6c335$var$xmlDecoder(str, $be32866caba6c335$var$DecodingMode.Strict);
}
module.exports.decodeXML = $be32866caba6c335$var$decodeXML;

});
parcelRegister("lvHpx", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("dxm8j", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("fepo1", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $b16bdb06a8923a6b$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $b16bdb06a8923a6b$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($b16bdb06a8923a6b$var$_a = String.fromCodePoint) !== null && $b16bdb06a8923a6b$var$_a !== void 0 ? $b16bdb06a8923a6b$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $b16bdb06a8923a6b$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $b16bdb06a8923a6b$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $b16bdb06a8923a6b$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $b16bdb06a8923a6b$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($b16bdb06a8923a6b$var$replaceCodePoint(codePoint));
}
module.exports["default"] = $b16bdb06a8923a6b$var$decodeCodePoint;

});




parcelRegister("fjj4Z", function(module, exports) {
$parcel$export(module.exports, "CDATA", function () { return (parcelRequire("g4pN0")).CDATA; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("g4pN0")).Comment; });
$parcel$export(module.exports, "Document", function () { return (parcelRequire("g4pN0")).Document; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("g4pN0")).Element; });
$parcel$export(module.exports, "hasChildren", function () { return (parcelRequire("g4pN0")).hasChildren; });
$parcel$export(module.exports, "isCDATA", function () { return (parcelRequire("g4pN0")).isCDATA; });
$parcel$export(module.exports, "isComment", function () { return (parcelRequire("g4pN0")).isComment; });
$parcel$export(module.exports, "isTag", function () { return (parcelRequire("g4pN0")).isTag; });
$parcel$export(module.exports, "isText", function () { return (parcelRequire("g4pN0")).isText; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return (parcelRequire("g4pN0")).ProcessingInstruction; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("g4pN0")).Text; });

$parcel$export(module.exports, "DomHandler", function () { return $b2576e201dc90c7b$export$ff8ccbac9225de62; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");

var $gDDlX = parcelRequire("gDDlX");

var $g4pN0 = parcelRequire("g4pN0");
// Default options
var $b2576e201dc90c7b$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $b2576e201dc90c7b$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    "use strict";
    function DomHandler(callback, options, elementCB) {
        (0, $jGAMp._)(this, DomHandler);
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $g4pN0.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $b2576e201dc90c7b$var$defaultOpts;
        }
        if ((typeof callback === "undefined" ? "undefined" : (0, $3KZcf._)(callback)) === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $b2576e201dc90c7b$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    (0, $byiyg._)(DomHandler, [
        {
            key: "onparserinit",
            value: function onparserinit(parser) {
                this.parser = parser;
            }
        },
        {
            // Resets the handler back to starting state
            key: "onreset",
            value: function onreset() {
                this.dom = [];
                this.root = new (0, $g4pN0.Document)(this.dom);
                this.done = false;
                this.tagStack = [
                    this.root
                ];
                this.lastNode = null;
                this.parser = null;
            }
        },
        {
            // Signals the handler that parsing is done
            key: "onend",
            value: function onend() {
                if (this.done) return;
                this.done = true;
                this.parser = null;
                this.handleCallback(null);
            }
        },
        {
            key: "onerror",
            value: function onerror(error) {
                this.handleCallback(error);
            }
        },
        {
            key: "onclosetag",
            value: function onclosetag() {
                this.lastNode = null;
                var elem = this.tagStack.pop();
                if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
                if (this.elementCB) this.elementCB(elem);
            }
        },
        {
            key: "onopentag",
            value: function onopentag(name, attribs) {
                var type = this.options.xmlMode ? (0, $gDDlX.ElementType).Tag : undefined;
                var element = new (0, $g4pN0.Element)(name, attribs, undefined, type);
                this.addNode(element);
                this.tagStack.push(element);
            }
        },
        {
            key: "ontext",
            value: function ontext(data) {
                var lastNode = this.lastNode;
                if (lastNode && lastNode.type === (0, $gDDlX.ElementType).Text) {
                    lastNode.data += data;
                    if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
                } else {
                    var node = new (0, $g4pN0.Text)(data);
                    this.addNode(node);
                    this.lastNode = node;
                }
            }
        },
        {
            key: "oncomment",
            value: function oncomment(data) {
                if (this.lastNode && this.lastNode.type === (0, $gDDlX.ElementType).Comment) {
                    this.lastNode.data += data;
                    return;
                }
                var node = new (0, $g4pN0.Comment)(data);
                this.addNode(node);
                this.lastNode = node;
            }
        },
        {
            key: "oncommentend",
            value: function oncommentend() {
                this.lastNode = null;
            }
        },
        {
            key: "oncdatastart",
            value: function oncdatastart() {
                var text = new (0, $g4pN0.Text)("");
                var node = new (0, $g4pN0.CDATA)([
                    text
                ]);
                this.addNode(node);
                text.parent = node;
                this.lastNode = text;
            }
        },
        {
            key: "oncdataend",
            value: function oncdataend() {
                this.lastNode = null;
            }
        },
        {
            key: "onprocessinginstruction",
            value: function onprocessinginstruction(name, data) {
                var node = new (0, $g4pN0.ProcessingInstruction)(name, data);
                this.addNode(node);
            }
        },
        {
            key: "handleCallback",
            value: function handleCallback(error) {
                if (typeof this.callback === "function") this.callback(error, this.dom);
                else if (error) throw error;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                var parent = this.tagStack[this.tagStack.length - 1];
                var previousSibling = parent.children[parent.children.length - 1];
                if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
                if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
                parent.children.push(node);
                if (previousSibling) {
                    node.prev = previousSibling;
                    previousSibling.next = node;
                }
                node.parent = parent;
                this.lastNode = null;
            }
        }
    ]);
    return DomHandler;
}();
var $b2576e201dc90c7b$export$2e2bcd8739ae039 = $b2576e201dc90c7b$export$ff8ccbac9225de62;

});
parcelRegister("gDDlX", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $03203d2b947dc393$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $03203d2b947dc393$export$3bf645f08efe3292; });
$parcel$export(module.exports, "Root", function () { return $03203d2b947dc393$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Text", function () { return $03203d2b947dc393$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Directive", function () { return $03203d2b947dc393$export$befdefbdce210f91; });
$parcel$export(module.exports, "Comment", function () { return $03203d2b947dc393$export$4d299b491347818a; });
$parcel$export(module.exports, "Script", function () { return $03203d2b947dc393$export$2f8b47a141e57afc; });
$parcel$export(module.exports, "Style", function () { return $03203d2b947dc393$export$d9e45bc13d335801; });
$parcel$export(module.exports, "Tag", function () { return $03203d2b947dc393$export$3288d34c523a1192; });
$parcel$export(module.exports, "CDATA", function () { return $03203d2b947dc393$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Doctype", function () { return $03203d2b947dc393$export$31b44af36ff2c60f; });
/** Types of elements found in htmlparser2's DOM */ var $03203d2b947dc393$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($03203d2b947dc393$export$b992dc138d950e31 || ($03203d2b947dc393$export$b992dc138d950e31 = {}));
function $03203d2b947dc393$export$3bf645f08efe3292(elem) {
    return elem.type === $03203d2b947dc393$export$b992dc138d950e31.Tag || elem.type === $03203d2b947dc393$export$b992dc138d950e31.Script || elem.type === $03203d2b947dc393$export$b992dc138d950e31.Style;
}
var $03203d2b947dc393$export$be92b6f5f03c0fe9 = $03203d2b947dc393$export$b992dc138d950e31.Root;
var $03203d2b947dc393$export$5f1af8db9871e1d6 = $03203d2b947dc393$export$b992dc138d950e31.Text;
var $03203d2b947dc393$export$befdefbdce210f91 = $03203d2b947dc393$export$b992dc138d950e31.Directive;
var $03203d2b947dc393$export$4d299b491347818a = $03203d2b947dc393$export$b992dc138d950e31.Comment;
var $03203d2b947dc393$export$2f8b47a141e57afc = $03203d2b947dc393$export$b992dc138d950e31.Script;
var $03203d2b947dc393$export$d9e45bc13d335801 = $03203d2b947dc393$export$b992dc138d950e31.Style;
var $03203d2b947dc393$export$3288d34c523a1192 = $03203d2b947dc393$export$b992dc138d950e31.Tag;
var $03203d2b947dc393$export$1f8b8f7e5c763232 = $03203d2b947dc393$export$b992dc138d950e31.CDATA;
var $03203d2b947dc393$export$31b44af36ff2c60f = $03203d2b947dc393$export$b992dc138d950e31.Doctype;

});

parcelRegister("g4pN0", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $bb3106494ad75eeb$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $bb3106494ad75eeb$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $bb3106494ad75eeb$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $bb3106494ad75eeb$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $bb3106494ad75eeb$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $bb3106494ad75eeb$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "isTag", function () { return $bb3106494ad75eeb$export$3bf645f08efe3292; });
$parcel$export(module.exports, "isCDATA", function () { return $bb3106494ad75eeb$export$c2d65aed98d39b56; });
$parcel$export(module.exports, "isText", function () { return $bb3106494ad75eeb$export$1879817ac5c922b7; });
$parcel$export(module.exports, "isComment", function () { return $bb3106494ad75eeb$export$3ab01370f5e64ac8; });
$parcel$export(module.exports, "hasChildren", function () { return $bb3106494ad75eeb$export$bd5ff50f0e53d41c; });

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $8AW3P = parcelRequire("8AW3P");

var $gDDlX = parcelRequire("gDDlX");
var $bb3106494ad75eeb$export$85c928794f8d04d4 = /*#__PURE__*/ function() {
    "use strict";
    function Node() {
        (0, $jGAMp._)(this, Node);
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    (0, $byiyg._)(Node, [
        {
            key: "parentNode",
            get: // Read-write aliases for properties
            /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.parent;
            },
            set: function set(parent) {
                this.parent = parent;
            }
        },
        {
            key: "previousSibling",
            get: /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.prev;
            },
            set: function set(prev) {
                this.prev = prev;
            }
        },
        {
            key: "nextSibling",
            get: /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.next;
            },
            set: function set(next) {
                this.next = next;
            }
        },
        {
            /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ key: "cloneNode",
            value: function cloneNode1() {
                var recursive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                return $bb3106494ad75eeb$export$ae8e35ea29ddac22(this, recursive);
            }
        }
    ]);
    return Node;
}();
var $bb3106494ad75eeb$export$c3569d91cd44d357 = /*#__PURE__*/ function(Node) {
    "use strict";
    (0, $i3fW3._)(DataNode, Node);
    function DataNode(data) {
        (0, $jGAMp._)(this, DataNode);
        var _this;
        _this = (0, $kzDuW._)(this, DataNode);
        _this.data = data;
        return _this;
    }
    (0, $byiyg._)(DataNode, [
        {
            key: "nodeValue",
            get: /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.data;
            },
            set: function set(data) {
                this.data = data;
            }
        }
    ]);
    return DataNode;
}((0, $8AW3P._)($bb3106494ad75eeb$export$85c928794f8d04d4));
var $bb3106494ad75eeb$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $i3fW3._)(Text, DataNode);
    function Text() {
        (0, $jGAMp._)(this, Text);
        var _this;
        _this = (0, $kzDuW._)(this, Text, arguments);
        _this.type = (0, $gDDlX.ElementType).Text;
        return _this;
    }
    (0, $byiyg._)(Text, [
        {
            key: "nodeType",
            get: function get() {
                return 3;
            }
        }
    ]);
    return Text;
}($bb3106494ad75eeb$export$c3569d91cd44d357);
var $bb3106494ad75eeb$export$4d299b491347818a = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $i3fW3._)(Comment, DataNode);
    function Comment() {
        (0, $jGAMp._)(this, Comment);
        var _this;
        _this = (0, $kzDuW._)(this, Comment, arguments);
        _this.type = (0, $gDDlX.ElementType).Comment;
        return _this;
    }
    (0, $byiyg._)(Comment, [
        {
            key: "nodeType",
            get: function get() {
                return 8;
            }
        }
    ]);
    return Comment;
}($bb3106494ad75eeb$export$c3569d91cd44d357);
var $bb3106494ad75eeb$export$9269dce19ee35e96 = /*#__PURE__*/ function(DataNode) {
    "use strict";
    (0, $i3fW3._)(ProcessingInstruction, DataNode);
    function ProcessingInstruction(name, data) {
        (0, $jGAMp._)(this, ProcessingInstruction);
        var _this;
        _this = (0, $kzDuW._)(this, ProcessingInstruction, [
            data
        ]);
        _this.name = name;
        _this.type = (0, $gDDlX.ElementType).Directive;
        return _this;
    }
    (0, $byiyg._)(ProcessingInstruction, [
        {
            key: "nodeType",
            get: function get() {
                return 1;
            }
        }
    ]);
    return ProcessingInstruction;
}($bb3106494ad75eeb$export$c3569d91cd44d357);
var $bb3106494ad75eeb$export$62be934f90997196 = /*#__PURE__*/ function(Node) {
    "use strict";
    (0, $i3fW3._)(NodeWithChildren, Node);
    function NodeWithChildren(children) {
        (0, $jGAMp._)(this, NodeWithChildren);
        var _this;
        _this = (0, $kzDuW._)(this, NodeWithChildren);
        _this.children = children;
        return _this;
    }
    (0, $byiyg._)(NodeWithChildren, [
        {
            key: "firstChild",
            get: // Aliases
            /** First child of the node. */ function get() {
                var _a;
                return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
            }
        },
        {
            key: "lastChild",
            get: /** Last child of the node. */ function get() {
                return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            }
        },
        {
            key: "childNodes",
            get: /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.children;
            },
            set: function set(children) {
                this.children = children;
            }
        }
    ]);
    return NodeWithChildren;
}((0, $8AW3P._)($bb3106494ad75eeb$export$85c928794f8d04d4));
var $bb3106494ad75eeb$export$1f8b8f7e5c763232 = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $i3fW3._)(CDATA, NodeWithChildren);
    function CDATA() {
        (0, $jGAMp._)(this, CDATA);
        var _this;
        _this = (0, $kzDuW._)(this, CDATA, arguments);
        _this.type = (0, $gDDlX.ElementType).CDATA;
        return _this;
    }
    (0, $byiyg._)(CDATA, [
        {
            key: "nodeType",
            get: function get() {
                return 4;
            }
        }
    ]);
    return CDATA;
}($bb3106494ad75eeb$export$62be934f90997196);
var $bb3106494ad75eeb$export$b34a105447964f9f = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $i3fW3._)(Document, NodeWithChildren);
    function Document() {
        (0, $jGAMp._)(this, Document);
        var _this;
        _this = (0, $kzDuW._)(this, Document, arguments);
        _this.type = (0, $gDDlX.ElementType).Root;
        return _this;
    }
    (0, $byiyg._)(Document, [
        {
            key: "nodeType",
            get: function get() {
                return 9;
            }
        }
    ]);
    return Document;
}($bb3106494ad75eeb$export$62be934f90997196);
var $bb3106494ad75eeb$export$db77ccec0bb4ccac = /*#__PURE__*/ function(NodeWithChildren) {
    "use strict";
    (0, $i3fW3._)(Element, NodeWithChildren);
    function Element(name, attribs) {
        var children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : name === "script" ? (0, $gDDlX.ElementType).Script : name === "style" ? (0, $gDDlX.ElementType).Style : (0, $gDDlX.ElementType).Tag;
        (0, $jGAMp._)(this, Element);
        var _this;
        _this = (0, $kzDuW._)(this, Element, [
            children
        ]);
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    (0, $byiyg._)(Element, [
        {
            key: "nodeType",
            get: function get() {
                return 1;
            }
        },
        {
            key: "tagName",
            get: // DOM Level 1 aliases
            /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ function get() {
                return this.name;
            },
            set: function set(name) {
                this.name = name;
            }
        },
        {
            key: "attributes",
            get: function get() {
                var _this = this;
                return Object.keys(this.attribs).map(function(name) {
                    var _a, _b;
                    return {
                        name: name,
                        value: _this.attribs[name],
                        namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                        prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                    };
                });
            }
        }
    ]);
    return Element;
}($bb3106494ad75eeb$export$62be934f90997196);
function $bb3106494ad75eeb$export$3bf645f08efe3292(node) {
    return (0, $gDDlX.isTag)(node);
}
function $bb3106494ad75eeb$export$c2d65aed98d39b56(node) {
    return node.type === (0, $gDDlX.ElementType).CDATA;
}
function $bb3106494ad75eeb$export$1879817ac5c922b7(node) {
    return node.type === (0, $gDDlX.ElementType).Text;
}
function $bb3106494ad75eeb$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $gDDlX.ElementType).Comment;
}
function $bb3106494ad75eeb$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $gDDlX.ElementType).Directive;
}
function $bb3106494ad75eeb$export$62858bae88b53fd0(node) {
    return node.type === (0, $gDDlX.ElementType).Root;
}
function $bb3106494ad75eeb$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $bb3106494ad75eeb$export$ae8e35ea29ddac22(node) {
    var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var result;
    if ($bb3106494ad75eeb$export$1879817ac5c922b7(node)) result = new $bb3106494ad75eeb$export$5f1af8db9871e1d6(node.data);
    else if ($bb3106494ad75eeb$export$3ab01370f5e64ac8(node)) result = new $bb3106494ad75eeb$export$4d299b491347818a(node.data);
    else if ($bb3106494ad75eeb$export$3bf645f08efe3292(node)) {
        var children = recursive ? $bb3106494ad75eeb$var$cloneChildren(node.children) : [];
        var clone = new $bb3106494ad75eeb$export$db77ccec0bb4ccac(node.name, (0, $iT0je._)({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone;
        });
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = (0, $iT0je._)({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = (0, $iT0je._)({}, node["x-attribsPrefix"]);
        result = clone;
    } else if ($bb3106494ad75eeb$export$c2d65aed98d39b56(node)) {
        var children1 = recursive ? $bb3106494ad75eeb$var$cloneChildren(node.children) : [];
        var clone1 = new $bb3106494ad75eeb$export$1f8b8f7e5c763232(children1);
        children1.forEach(function(child) {
            return child.parent = clone1;
        });
        result = clone1;
    } else if ($bb3106494ad75eeb$export$62858bae88b53fd0(node)) {
        var children2 = recursive ? $bb3106494ad75eeb$var$cloneChildren(node.children) : [];
        var clone2 = new $bb3106494ad75eeb$export$b34a105447964f9f(children2);
        children2.forEach(function(child) {
            return child.parent = clone2;
        });
        if (node["x-mode"]) clone2["x-mode"] = node["x-mode"];
        result = clone2;
    } else if ($bb3106494ad75eeb$export$4b5d79f26e0e3ad5(node)) {
        var instruction = new $bb3106494ad75eeb$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $bb3106494ad75eeb$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $bb3106494ad75eeb$export$ae8e35ea29ddac22(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("4u3Uv", function(module, exports) {
$parcel$export(module.exports, "getFeed", function () { return (parcelRequire("b6XQv")).getFeed; });
parcelRequire("eb7YS");
parcelRequire("74sVR");
parcelRequire("goE2L");
parcelRequire("iJCJc");
parcelRequire("1XsPO");
parcelRequire("2tH8w");
parcelRequire("b6XQv");
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");

});
parcelRegister("eb7YS", function(module, exports) {

$parcel$export(module.exports, "textContent", function () { return $a528489a9fc3d94f$export$e0e0794250e9118f; });
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");

var $aMfLb = parcelRequire("aMfLb");

var $gDDlX = parcelRequire("gDDlX");
function $a528489a9fc3d94f$export$39484b727cc2f324(node, options) {
    return (0, $aMfLb.default)(node, options);
}
function $a528489a9fc3d94f$export$7ed15b4d2218408(node, options) {
    return (0, $g4pN0.hasChildren)(node) ? node.children.map(function(node) {
        return $a528489a9fc3d94f$export$39484b727cc2f324(node, options);
    }).join("") : "";
}
function $a528489a9fc3d94f$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($a528489a9fc3d94f$export$c72d34660a162238).join("");
    if ((0, $g4pN0.isTag)(node)) return node.name === "br" ? "\n" : $a528489a9fc3d94f$export$c72d34660a162238(node.children);
    if ((0, $g4pN0.isCDATA)(node)) return $a528489a9fc3d94f$export$c72d34660a162238(node.children);
    if ((0, $g4pN0.isText)(node)) return node.data;
    return "";
}
function $a528489a9fc3d94f$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($a528489a9fc3d94f$export$e0e0794250e9118f).join("");
    if ((0, $g4pN0.hasChildren)(node) && !(0, $g4pN0.isComment)(node)) return $a528489a9fc3d94f$export$e0e0794250e9118f(node.children);
    if ((0, $g4pN0.isText)(node)) return node.data;
    return "";
}
function $a528489a9fc3d94f$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($a528489a9fc3d94f$export$5864bc2a45f1eb81).join("");
    if ((0, $g4pN0.hasChildren)(node) && (node.type === (0, $gDDlX.ElementType).Tag || (0, $g4pN0.isCDATA)(node))) return $a528489a9fc3d94f$export$5864bc2a45f1eb81(node.children);
    if ((0, $g4pN0.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("aMfLb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d8a9caa6a7c36db$export$2e2bcd8739ae039; });
/*
 * Module dependencies
 */ 
var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $gDDlX = parcelRequire("gDDlX");
parcelRequire("hZiEu");
var $4SyBQ = parcelRequire("4SyBQ");

var $leAl2 = parcelRequire("leAl2");
var $7d8a9caa6a7c36db$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $7d8a9caa6a7c36db$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $7d8a9caa6a7c36db$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $7d8a9caa6a7c36db$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $4SyBQ.encodeXML) : (0, $4SyBQ.escapeAttribute);
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $leAl2.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return "".concat(key, '="').concat(encode(value), '"');
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $7d8a9caa6a7c36db$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $7d8a9caa6a7c36db$export$b3890eb0ae9dca99(node) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $7d8a9caa6a7c36db$var$renderNode(nodes[i], options);
    return output;
}
var $7d8a9caa6a7c36db$export$2e2bcd8739ae039 = $7d8a9caa6a7c36db$export$b3890eb0ae9dca99;
function $7d8a9caa6a7c36db$var$renderNode(node, options) {
    switch(node.type){
        case $gDDlX.Root:
            return $7d8a9caa6a7c36db$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $gDDlX.Doctype:
        case $gDDlX.Directive:
            return $7d8a9caa6a7c36db$var$renderDirective(node);
        case $gDDlX.Comment:
            return $7d8a9caa6a7c36db$var$renderComment(node);
        case $gDDlX.CDATA:
            return $7d8a9caa6a7c36db$var$renderCdata(node);
        case $gDDlX.Script:
        case $gDDlX.Style:
        case $gDDlX.Tag:
            return $7d8a9caa6a7c36db$var$renderTag(node, options);
        case $gDDlX.Text:
            return $7d8a9caa6a7c36db$var$renderText(node, options);
    }
}
var $7d8a9caa6a7c36db$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $7d8a9caa6a7c36db$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $7d8a9caa6a7c36db$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $leAl2.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $7d8a9caa6a7c36db$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = (0, $emQHU._)((0, $iT0je._)({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $7d8a9caa6a7c36db$var$foreignElements.has(elem.name)) opts = (0, $emQHU._)((0, $iT0je._)({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<".concat(elem.name);
    var attribs = $7d8a9caa6a7c36db$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " ".concat(attribs);
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $7d8a9caa6a7c36db$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $7d8a9caa6a7c36db$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$7d8a9caa6a7c36db$var$singleTag.has(elem.name)) tag += "</".concat(elem.name, ">");
    }
    return tag;
}
function $7d8a9caa6a7c36db$var$renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function $7d8a9caa6a7c36db$var$renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $7d8a9caa6a7c36db$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $4SyBQ.encodeXML)(data) : (0, $4SyBQ.escapeText)(data);
    return data;
}
function $7d8a9caa6a7c36db$var$renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function $7d8a9caa6a7c36db$var$renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

});
parcelRegister("hZiEu", function(module, exports) {

$parcel$export(module.exports, "encodeXML", function () { return (parcelRequire("4SyBQ")).encodeXML; });
$parcel$export(module.exports, "escapeAttribute", function () { return (parcelRequire("4SyBQ")).escapeAttribute; });
$parcel$export(module.exports, "escapeText", function () { return (parcelRequire("4SyBQ")).escapeText; });

var $3KZcf = parcelRequire("3KZcf");

var $hFGUt = parcelRequire("hFGUt");

var $2lQeC = parcelRequire("2lQeC");

var $4SyBQ = parcelRequire("4SyBQ");
var $d1869a149c2a0a0a$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($d1869a149c2a0a0a$export$b8c86583d9718b50 || ($d1869a149c2a0a0a$export$b8c86583d9718b50 = {}));
var $d1869a149c2a0a0a$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($d1869a149c2a0a0a$export$1851b20d614eb756 || ($d1869a149c2a0a0a$export$1851b20d614eb756 = {}));
function $d1869a149c2a0a0a$export$2f872c0f2117be69(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d1869a149c2a0a0a$export$b8c86583d9718b50.XML;
    var level = typeof options === "number" ? options : options.level;
    if (level === $d1869a149c2a0a0a$export$b8c86583d9718b50.HTML) {
        var mode = (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) === "object" ? options.mode : undefined;
        return (0, $hFGUt.decodeHTML)(data, mode);
    }
    return (0, $hFGUt.decodeXML)(data);
}
function $d1869a149c2a0a0a$export$c94669f4c7d36be4(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d1869a149c2a0a0a$export$b8c86583d9718b50.XML;
    var _a;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $hFGUt.DecodingMode).Strict;
    return $d1869a149c2a0a0a$export$2f872c0f2117be69(data, opts);
}
function $d1869a149c2a0a0a$export$c564cdbbe6da493(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d1869a149c2a0a0a$export$b8c86583d9718b50.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $d1869a149c2a0a0a$export$1851b20d614eb756.UTF8) return (0, $4SyBQ.escapeUTF8)(data);
    if (opts.mode === $d1869a149c2a0a0a$export$1851b20d614eb756.Attribute) return (0, $4SyBQ.escapeAttribute)(data);
    if (opts.mode === $d1869a149c2a0a0a$export$1851b20d614eb756.Text) return (0, $4SyBQ.escapeText)(data);
    if (opts.level === $d1869a149c2a0a0a$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $d1869a149c2a0a0a$export$1851b20d614eb756.ASCII) return (0, $2lQeC.encodeNonAsciiHTML)(data);
        return (0, $2lQeC.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $4SyBQ.encodeXML)(data);
}

});
parcelRegister("hFGUt", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", function () { return $cdd78d0896d78810$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $cdd78d0896d78810$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $cdd78d0896d78810$export$88e3b9643a8bd06e; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i2Woe = parcelRequire("i2Woe");

var $gRQXs = parcelRequire("gRQXs");

var $dTt1l = parcelRequire("dTt1l");
var $cdd78d0896d78810$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($cdd78d0896d78810$var$CharCodes || ($cdd78d0896d78810$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $cdd78d0896d78810$var$TO_LOWER_BIT = 32;
var $cdd78d0896d78810$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($cdd78d0896d78810$export$6a4325c613e0faec || ($cdd78d0896d78810$export$6a4325c613e0faec = {}));
function $cdd78d0896d78810$var$isNumber(code) {
    return code >= $cdd78d0896d78810$var$CharCodes.ZERO && code <= $cdd78d0896d78810$var$CharCodes.NINE;
}
function $cdd78d0896d78810$var$isHexadecimalCharacter(code) {
    return code >= $cdd78d0896d78810$var$CharCodes.UPPER_A && code <= $cdd78d0896d78810$var$CharCodes.UPPER_F || code >= $cdd78d0896d78810$var$CharCodes.LOWER_A && code <= $cdd78d0896d78810$var$CharCodes.LOWER_F;
}
function $cdd78d0896d78810$var$isAsciiAlphaNumeric(code) {
    return code >= $cdd78d0896d78810$var$CharCodes.UPPER_A && code <= $cdd78d0896d78810$var$CharCodes.UPPER_Z || code >= $cdd78d0896d78810$var$CharCodes.LOWER_A && code <= $cdd78d0896d78810$var$CharCodes.LOWER_Z || $cdd78d0896d78810$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $cdd78d0896d78810$var$isEntityInAttributeInvalidEnd(code) {
    return code === $cdd78d0896d78810$var$CharCodes.EQUALS || $cdd78d0896d78810$var$isAsciiAlphaNumeric(code);
}
var $cdd78d0896d78810$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($cdd78d0896d78810$var$EntityDecoderState || ($cdd78d0896d78810$var$EntityDecoderState = {}));
var $cdd78d0896d78810$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($cdd78d0896d78810$export$8c8f129ce60f53c || ($cdd78d0896d78810$export$8c8f129ce60f53c = {}));
var $cdd78d0896d78810$export$15263a93ff7ec8ba = /*#__PURE__*/ function() {
    "use strict";
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        (0, $jGAMp._)(this, EntityDecoder);
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $cdd78d0896d78810$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $cdd78d0896d78810$export$8c8f129ce60f53c.Strict;
    }
    (0, $byiyg._)(EntityDecoder, [
        {
            /** Resets the instance to make it reusable. */ key: "startEntity",
            value: function startEntity(decodeMode) {
                this.decodeMode = decodeMode;
                this.state = $cdd78d0896d78810$var$EntityDecoderState.EntityStart;
                this.result = 0;
                this.treeIndex = 0;
                this.excess = 1;
                this.consumed = 1;
            }
        },
        {
            /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "write",
            value: function write(str, offset) {
                switch(this.state){
                    case $cdd78d0896d78810$var$EntityDecoderState.EntityStart:
                        if (str.charCodeAt(offset) === $cdd78d0896d78810$var$CharCodes.NUM) {
                            this.state = $cdd78d0896d78810$var$EntityDecoderState.NumericStart;
                            this.consumed += 1;
                            return this.stateNumericStart(str, offset + 1);
                        }
                        this.state = $cdd78d0896d78810$var$EntityDecoderState.NamedEntity;
                        return this.stateNamedEntity(str, offset);
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericStart:
                        return this.stateNumericStart(str, offset);
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericDecimal:
                        return this.stateNumericDecimal(str, offset);
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericHex:
                        return this.stateNumericHex(str, offset);
                    case $cdd78d0896d78810$var$EntityDecoderState.NamedEntity:
                        return this.stateNamedEntity(str, offset);
                }
            }
        },
        {
            /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericStart",
            value: function stateNumericStart(str, offset) {
                if (offset >= str.length) return -1;
                if ((str.charCodeAt(offset) | $cdd78d0896d78810$var$TO_LOWER_BIT) === $cdd78d0896d78810$var$CharCodes.LOWER_X) {
                    this.state = $cdd78d0896d78810$var$EntityDecoderState.NumericHex;
                    this.consumed += 1;
                    return this.stateNumericHex(str, offset + 1);
                }
                this.state = $cdd78d0896d78810$var$EntityDecoderState.NumericDecimal;
                return this.stateNumericDecimal(str, offset);
            }
        },
        {
            key: "addToNumericResult",
            value: function addToNumericResult(str, start, end, base) {
                if (start !== end) {
                    var digitCount = end - start;
                    this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
                    this.consumed += digitCount;
                }
            }
        },
        {
            /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericHex",
            value: function stateNumericHex(str, offset) {
                var startIdx = offset;
                while(offset < str.length){
                    var char = str.charCodeAt(offset);
                    if ($cdd78d0896d78810$var$isNumber(char) || $cdd78d0896d78810$var$isHexadecimalCharacter(char)) offset += 1;
                    else {
                        this.addToNumericResult(str, startIdx, offset, 16);
                        return this.emitNumericEntity(char, 3);
                    }
                }
                this.addToNumericResult(str, startIdx, offset, 16);
                return -1;
            }
        },
        {
            /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericDecimal",
            value: function stateNumericDecimal(str, offset) {
                var startIdx = offset;
                while(offset < str.length){
                    var char = str.charCodeAt(offset);
                    if ($cdd78d0896d78810$var$isNumber(char)) offset += 1;
                    else {
                        this.addToNumericResult(str, startIdx, offset, 10);
                        return this.emitNumericEntity(char, 2);
                    }
                }
                this.addToNumericResult(str, startIdx, offset, 10);
                return -1;
            }
        },
        {
            /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ key: "emitNumericEntity",
            value: function emitNumericEntity(lastCp, expectedLength) {
                var _a;
                // Ensure we consumed at least one digit.
                if (this.consumed <= expectedLength) {
                    (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                    return 0;
                }
                // Figure out if this is a legit end of the entity
                if (lastCp === $cdd78d0896d78810$var$CharCodes.SEMI) this.consumed += 1;
                else if (this.decodeMode === $cdd78d0896d78810$export$8c8f129ce60f53c.Strict) return 0;
                this.emitCodePoint((0, $dTt1l.replaceCodePoint)(this.result), this.consumed);
                if (this.errors) {
                    if (lastCp !== $cdd78d0896d78810$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
                    this.errors.validateNumericCharacterReference(this.result);
                }
                return this.consumed;
            }
        },
        {
            /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNamedEntity",
            value: function stateNamedEntity(str, offset) {
                var decodeTree = this.decodeTree;
                var current = decodeTree[this.treeIndex];
                // The mask is the number of bytes of the value, including the current byte.
                var valueLength = (current & $cdd78d0896d78810$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                for(; offset < str.length; offset++, this.excess++){
                    var char = str.charCodeAt(offset);
                    this.treeIndex = $cdd78d0896d78810$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
                    if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
                    this.decodeMode === $cdd78d0896d78810$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
                    (valueLength === 0 || // And there should be no invalid characters.
                    $cdd78d0896d78810$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
                    current = decodeTree[this.treeIndex];
                    valueLength = (current & $cdd78d0896d78810$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                    // If the branch is a value, store it and continue
                    if (valueLength !== 0) {
                        // If the entity is terminated by a semicolon, we are done.
                        if (char === $cdd78d0896d78810$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                        // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                        if (this.decodeMode !== $cdd78d0896d78810$export$8c8f129ce60f53c.Strict) {
                            this.result = this.treeIndex;
                            this.consumed += this.excess;
                            this.excess = 0;
                        }
                    }
                }
                return -1;
            }
        },
        {
            /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ key: "emitNotTerminatedNamedEntity",
            value: function emitNotTerminatedNamedEntity() {
                var _a;
                var _this = this, result = _this.result, decodeTree = _this.decodeTree;
                var valueLength = (decodeTree[result] & $cdd78d0896d78810$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
                this.emitNamedEntityData(result, valueLength, this.consumed);
                (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
                return this.consumed;
            }
        },
        {
            /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ key: "emitNamedEntityData",
            value: function emitNamedEntityData(result, valueLength, consumed) {
                var decodeTree = this.decodeTree;
                this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$cdd78d0896d78810$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
                if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
                this.emitCodePoint(decodeTree[result + 2], consumed);
                return consumed;
            }
        },
        {
            /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ key: "end",
            value: function end() {
                var _a;
                switch(this.state){
                    case $cdd78d0896d78810$var$EntityDecoderState.NamedEntity:
                        // Emit a named entity if we have one.
                        return this.result !== 0 && (this.decodeMode !== $cdd78d0896d78810$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
                    // Otherwise, emit a numeric entity if we have one.
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericDecimal:
                        return this.emitNumericEntity(0, 2);
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericHex:
                        return this.emitNumericEntity(0, 3);
                    case $cdd78d0896d78810$var$EntityDecoderState.NumericStart:
                        (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                        return 0;
                    case $cdd78d0896d78810$var$EntityDecoderState.EntityStart:
                        // Return 0 if we have no entity.
                        return 0;
                }
            }
        }
    ]);
    return EntityDecoder;
}();
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $cdd78d0896d78810$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $cdd78d0896d78810$export$15263a93ff7ec8ba(decodeTree, function(str) {
        return ret += (0, $dTt1l.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $cdd78d0896d78810$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $cdd78d0896d78810$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $cdd78d0896d78810$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
var $cdd78d0896d78810$var$htmlDecoder = $cdd78d0896d78810$var$getDecoder((0, $i2Woe.default));
var $cdd78d0896d78810$var$xmlDecoder = $cdd78d0896d78810$var$getDecoder((0, $gRQXs.default));
function $cdd78d0896d78810$export$f045cb747ce77a19(str) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cdd78d0896d78810$export$8c8f129ce60f53c.Legacy;
    return $cdd78d0896d78810$var$htmlDecoder(str, mode);
}
function $cdd78d0896d78810$export$49f5e8089adb006a(str) {
    return $cdd78d0896d78810$var$htmlDecoder(str, $cdd78d0896d78810$export$8c8f129ce60f53c.Attribute);
}
function $cdd78d0896d78810$export$da52f4371b3f37de(str) {
    return $cdd78d0896d78810$var$htmlDecoder(str, $cdd78d0896d78810$export$8c8f129ce60f53c.Strict);
}
function $cdd78d0896d78810$export$88e3b9643a8bd06e(str) {
    return $cdd78d0896d78810$var$xmlDecoder(str, $cdd78d0896d78810$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("i2Woe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d235b4e0ef6f1f88$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $d235b4e0ef6f1f88$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("gRQXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47aacf5643021ce$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $c47aacf5643021ce$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("dTt1l", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $a1d6ec5634462ac6$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $a1d6ec5634462ac6$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $a1d6ec5634462ac6$var$_a;
var $a1d6ec5634462ac6$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
var $a1d6ec5634462ac6$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($a1d6ec5634462ac6$var$_a = String.fromCodePoint) !== null && $a1d6ec5634462ac6$var$_a !== void 0 ? $a1d6ec5634462ac6$var$_a : function fromCodePoint(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $a1d6ec5634462ac6$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $a1d6ec5634462ac6$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $a1d6ec5634462ac6$export$2e2bcd8739ae039(codePoint) {
    return $a1d6ec5634462ac6$export$73bfc63873071f74($a1d6ec5634462ac6$export$b978ab756102108a(codePoint));
}

});


parcelRegister("2lQeC", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", function () { return $1b660fa6ff5d4698$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $1b660fa6ff5d4698$export$e6e86c76506f1190; });

var $3KZcf = parcelRequire("3KZcf");

var $dp6KB = parcelRequire("dp6KB");

var $4SyBQ = parcelRequire("4SyBQ");
var $1b660fa6ff5d4698$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $1b660fa6ff5d4698$export$f9d6449b9af28dc1(data) {
    return $1b660fa6ff5d4698$var$encodeHTMLTrieRe($1b660fa6ff5d4698$var$htmlReplacer, data);
}
function $1b660fa6ff5d4698$export$e6e86c76506f1190(data) {
    return $1b660fa6ff5d4698$var$encodeHTMLTrieRe((0, $4SyBQ.xmlReplacer), data);
}
function $1b660fa6ff5d4698$var$encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = regExp.exec(str)) !== null){
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var _char = str.charCodeAt(i);
        var next = (0, $dp6KB.default).get(_char);
        if ((typeof next === "undefined" ? "undefined" : (0, $3KZcf._)(next)) === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            var cp = (0, $4SyBQ.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== _char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("dp6KB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c22d8b77e1cc2bd$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $9c22d8b77e1cc2bd$var$restoreDiff(arr) {
    for(var i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$9c22d8b77e1cc2bd$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $9c22d8b77e1cc2bd$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $9c22d8b77e1cc2bd$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $9c22d8b77e1cc2bd$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $9c22d8b77e1cc2bd$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("4SyBQ", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", function () { return $38d70d49963b6ffd$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $38d70d49963b6ffd$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $38d70d49963b6ffd$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $38d70d49963b6ffd$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $38d70d49963b6ffd$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $38d70d49963b6ffd$export$96e6fc3a139b2555; });
var $38d70d49963b6ffd$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
var $38d70d49963b6ffd$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
var $38d70d49963b6ffd$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
function $38d70d49963b6ffd$export$18855ec5be97da16(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = $38d70d49963b6ffd$export$5699810ce3244ab8.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $38d70d49963b6ffd$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat($38d70d49963b6ffd$export$e02688b8085d016b(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = $38d70d49963b6ffd$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
var $38d70d49963b6ffd$export$4e7f196112fea3c5 = $38d70d49963b6ffd$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $38d70d49963b6ffd$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
var $38d70d49963b6ffd$export$9e081872deefdcb0 = $38d70d49963b6ffd$var$getEscaper(/[&<>'"]/g, $38d70d49963b6ffd$var$xmlCodeMap);
var $38d70d49963b6ffd$export$30330f3d5eb70e11 = $38d70d49963b6ffd$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
var $38d70d49963b6ffd$export$96e6fc3a139b2555 = $38d70d49963b6ffd$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("leAl2", function(module, exports) {

$parcel$export(module.exports, "elementNames", function () { return $f75717cdd2c6f96e$export$82b917442d249e05; });
$parcel$export(module.exports, "attributeNames", function () { return $f75717cdd2c6f96e$export$b4cfbfd90280b005; });
var $f75717cdd2c6f96e$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));
var $f75717cdd2c6f96e$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));

});



parcelRegister("74sVR", function(module, exports) {
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");
function $525f597309b53c83$export$f8cf48ee793b41be(elem) {
    return (0, $g4pN0.hasChildren)(elem) ? elem.children : [];
}
function $525f597309b53c83$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $525f597309b53c83$export$f312c3733b79ac0d(elem) {
    var parent = $525f597309b53c83$export$58081aedf094d85b(elem);
    if (parent != null) return $525f597309b53c83$export$f8cf48ee793b41be(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        prev = prev.prev;
    }
    while(next != null){
        siblings.push(next);
        next = next.next;
    }
    return siblings;
}
function $525f597309b53c83$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $525f597309b53c83$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $525f597309b53c83$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $525f597309b53c83$export$9be3779649ef9cc7(elem) {
    var next = elem.next;
    while(next !== null && !(0, $g4pN0.isTag)(next))next = next.next;
    return next;
}
function $525f597309b53c83$export$c8bafb6e59c0b8e(elem) {
    var prev = elem.prev;
    while(prev !== null && !(0, $g4pN0.isTag)(prev))prev = prev.prev;
    return prev;
}

});

parcelRegister("goE2L", function(module, exports) {
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $befdf308904a9aec$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $befdf308904a9aec$export$2dfe578f95754f6a(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $befdf308904a9aec$export$1b8e57c9ea42f1d2(parent, child) {
    $befdf308904a9aec$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $befdf308904a9aec$export$10d8903dec122b9d(elem, next) {
    $befdf308904a9aec$export$f883456a56996078(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $befdf308904a9aec$export$47b51e6d100007bc(parent, child) {
    $befdf308904a9aec$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $befdf308904a9aec$export$68159836694e22c1(elem, prev) {
    $befdf308904a9aec$export$f883456a56996078(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("iJCJc", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $da3a788691894aa7$export$3dea766d36a8935f; });
$parcel$export(module.exports, "findOne", function () { return $da3a788691894aa7$export$a541876d5d7daf90; });
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");
function $da3a788691894aa7$export$3dea766d36a8935f(test, node) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return $da3a788691894aa7$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $da3a788691894aa7$export$71aa6c912b956294(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */ var nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ var indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $g4pN0.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $da3a788691894aa7$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $da3a788691894aa7$export$a541876d5d7daf90(test, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(var i = 0; i < searchedNodes.length; i++){
        var node = searchedNodes[i];
        if ((0, $g4pN0.isTag)(node) && test(node)) return node;
        if (recurse && (0, $g4pN0.hasChildren)(node) && node.children.length > 0) {
            var found = $da3a788691894aa7$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $da3a788691894aa7$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some(function(node) {
        return (0, $g4pN0.isTag)(node) && test(node) || (0, $g4pN0.hasChildren)(node) && $da3a788691894aa7$export$9d99dce58ac4a31b(test, node.children);
    });
}
function $da3a788691894aa7$export$18200ea6c8035394(test, nodes) {
    var result = [];
    var nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    var indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if ((0, $g4pN0.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $g4pN0.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("1XsPO", function(module, exports) {

$parcel$export(module.exports, "getElementsByTagName", function () { return $16d1ab1c76bf1581$export$af941c3c7c3b40f5; });
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");

var $iJCJc = parcelRequire("iJCJc");
/**
 * A map of functions to check nodes against.
 */ var $16d1ab1c76bf1581$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $g4pN0.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return 0, $g4pN0.isTag;
        return function(elem) {
            return (0, $g4pN0.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $g4pN0.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $g4pN0.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $16d1ab1c76bf1581$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $g4pN0.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $g4pN0.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $16d1ab1c76bf1581$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $16d1ab1c76bf1581$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($16d1ab1c76bf1581$var$Checks, key) ? $16d1ab1c76bf1581$var$Checks[key](value) : $16d1ab1c76bf1581$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($16d1ab1c76bf1581$var$combineFuncs);
}
function $16d1ab1c76bf1581$export$7b31db6b5a0b2f32(options, node) {
    var test = $16d1ab1c76bf1581$var$compileTest(options);
    return test ? test(node) : true;
}
function $16d1ab1c76bf1581$export$73eac51a39d6b0eb(options, nodes, recurse) {
    var limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    var test = $16d1ab1c76bf1581$var$compileTest(options);
    return test ? (0, $iJCJc.filter)(test, nodes, recurse, limit) : [];
}
function $16d1ab1c76bf1581$export$83595b84fc78b9b4(id, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $iJCJc.findOne)($16d1ab1c76bf1581$var$getAttribCheck("id", id), nodes, recurse);
}
function $16d1ab1c76bf1581$export$af941c3c7c3b40f5(tagName, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return (0, $iJCJc.filter)($16d1ab1c76bf1581$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $16d1ab1c76bf1581$export$764e2797d3aa1cff(className, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return (0, $iJCJc.filter)($16d1ab1c76bf1581$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $16d1ab1c76bf1581$export$f5d981e30be5545b(type, nodes) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
    return (0, $iJCJc.filter)($16d1ab1c76bf1581$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("2tH8w", function(module, exports) {
parcelRequire("fjj4Z");
var $g4pN0 = parcelRequire("g4pN0");
function $1cdfc035b1ebcdea$export$171dc294232ebeef(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $1cdfc035b1ebcdea$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($1cdfc035b1ebcdea$export$406a59d989e8005a || ($1cdfc035b1ebcdea$export$406a59d989e8005a = {}));
function $1cdfc035b1ebcdea$export$17303b8fea718ecc(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $g4pN0.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $g4pN0.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $1cdfc035b1ebcdea$export$406a59d989e8005a.DISCONNECTED;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $1cdfc035b1ebcdea$export$406a59d989e8005a.FOLLOWING | $1cdfc035b1ebcdea$export$406a59d989e8005a.CONTAINED_BY;
        return $1cdfc035b1ebcdea$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $1cdfc035b1ebcdea$export$406a59d989e8005a.PRECEDING | $1cdfc035b1ebcdea$export$406a59d989e8005a.CONTAINS;
    return $1cdfc035b1ebcdea$export$406a59d989e8005a.PRECEDING;
}
function $1cdfc035b1ebcdea$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $1cdfc035b1ebcdea$export$17303b8fea718ecc(a, b);
        if (relative & $1cdfc035b1ebcdea$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $1cdfc035b1ebcdea$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("b6XQv", function(module, exports) {

$parcel$export(module.exports, "getFeed", function () { return $816ead698f635f9d$export$ad32138c9e09ad4; });

var $eb7YS = parcelRequire("eb7YS");

var $1XsPO = parcelRequire("1XsPO");
function $816ead698f635f9d$export$ad32138c9e09ad4(doc) {
    var feedRoot = $816ead698f635f9d$var$getOneElement($816ead698f635f9d$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $816ead698f635f9d$var$getAtomFeed(feedRoot) : $816ead698f635f9d$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $816ead698f635f9d$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $1XsPO.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $816ead698f635f9d$var$getMediaElements(children)
            };
            $816ead698f635f9d$var$addConditionally(entry, "id", "id", children);
            $816ead698f635f9d$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $816ead698f635f9d$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            var description = $816ead698f635f9d$var$fetch("summary", children) || $816ead698f635f9d$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $816ead698f635f9d$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $816ead698f635f9d$var$addConditionally(feed, "id", "id", childs);
    $816ead698f635f9d$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $816ead698f635f9d$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $816ead698f635f9d$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $816ead698f635f9d$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $816ead698f635f9d$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $816ead698f635f9d$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $816ead698f635f9d$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $1XsPO.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $816ead698f635f9d$var$getMediaElements(children)
            };
            $816ead698f635f9d$var$addConditionally(entry, "id", "guid", children);
            $816ead698f635f9d$var$addConditionally(entry, "title", "title", children);
            $816ead698f635f9d$var$addConditionally(entry, "link", "link", children);
            $816ead698f635f9d$var$addConditionally(entry, "description", "description", children);
            var pubDate = $816ead698f635f9d$var$fetch("pubDate", children) || $816ead698f635f9d$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $816ead698f635f9d$var$addConditionally(feed, "title", "title", childs);
    $816ead698f635f9d$var$addConditionally(feed, "link", "link", childs);
    $816ead698f635f9d$var$addConditionally(feed, "description", "description", childs);
    var updated = $816ead698f635f9d$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $816ead698f635f9d$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $816ead698f635f9d$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $816ead698f635f9d$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $816ead698f635f9d$var$getMediaElements(where) {
    return (0, $1XsPO.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $816ead698f635f9d$var$MEDIA_KEYS_STRING[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var attrib = _step.value;
                if (attribs[attrib]) media[attrib] = attribs[attrib];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = $816ead698f635f9d$var$MEDIA_KEYS_INT[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var attrib1 = _step1.value;
                if (attribs[attrib1]) media[attrib1] = parseInt(attribs[attrib1], 10);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $816ead698f635f9d$var$getOneElement(tagName, node) {
    return (0, $1XsPO.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $816ead698f635f9d$var$fetch(tagName, where) {
    var recurse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0, $eb7YS.textContent)((0, $1XsPO.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $816ead698f635f9d$var$addConditionally(obj, prop, tagName, where) {
    var recurse = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var val = $816ead698f635f9d$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $816ead698f635f9d$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRegister("2G1Uq", function(module, exports) {
'use strict';

var $1DnQ8 = parcelRequire("1DnQ8");

var $aZB9a = parcelRequire("aZB9a");
var $1f30fc203a5d7b52$var$originalDestroy = $1DnQ8.Readable.destroy;
module.exports = $1DnQ8.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $1DnQ8._uint8ArrayToBuffer;
module.exports._isUint8Array = $1DnQ8._isUint8Array;
module.exports.isDisturbed = $1DnQ8.isDisturbed;
module.exports.isErrored = $1DnQ8.isErrored;
module.exports.isReadable = $1DnQ8.isReadable;
module.exports.Readable = $1DnQ8.Readable;
module.exports.Writable = $1DnQ8.Writable;
module.exports.Duplex = $1DnQ8.Duplex;
module.exports.Transform = $1DnQ8.Transform;
module.exports.PassThrough = $1DnQ8.PassThrough;
module.exports.addAbortSignal = $1DnQ8.addAbortSignal;
module.exports.finished = $1DnQ8.finished;
module.exports.destroy = $1DnQ8.destroy;
module.exports.destroy = $1f30fc203a5d7b52$var$originalDestroy;
module.exports.pipeline = $1DnQ8.pipeline;
module.exports.compose = $1DnQ8.compose;
Object.defineProperty($1DnQ8, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $aZB9a;
    }
});
module.exports.Stream = $1DnQ8.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("1DnQ8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $6JBOZ = parcelRequire("6JBOZ");
var $130bed10b950a50a$require$Buffer = $6JBOZ.Buffer;

var $83Xfu = parcelRequire("83Xfu");
/* replacement end */ var $130bed10b950a50a$var$ObjectDefineProperty = $83Xfu.ObjectDefineProperty, $130bed10b950a50a$var$ObjectKeys = $83Xfu.ObjectKeys, $130bed10b950a50a$var$ReflectApply = $83Xfu.ReflectApply;

var $imWI3 = parcelRequire("imWI3");
var $130bed10b950a50a$var$_require_promisify = $imWI3.promisify, $130bed10b950a50a$var$customPromisify = $130bed10b950a50a$var$_require_promisify.custom;

var $1j4aK = parcelRequire("1j4aK");
var $130bed10b950a50a$var$streamReturningOperators = $1j4aK.streamReturningOperators, $130bed10b950a50a$var$promiseReturningOperators = $1j4aK.promiseReturningOperators;

var $bnTha = parcelRequire("bnTha");
var $130bed10b950a50a$var$ERR_ILLEGAL_CONSTRUCTOR = $bnTha.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $1MGKm = parcelRequire("1MGKm");

var $hgv2A = parcelRequire("hgv2A");
var $130bed10b950a50a$var$setDefaultHighWaterMark = $hgv2A.setDefaultHighWaterMark, $130bed10b950a50a$var$getDefaultHighWaterMark = $hgv2A.getDefaultHighWaterMark;

var $eFsFu = parcelRequire("eFsFu");
var $130bed10b950a50a$require$pipeline = $eFsFu.pipeline;

var $jxsg7 = parcelRequire("jxsg7");
var $130bed10b950a50a$require$destroyer = $jxsg7.destroyer;

var $iuCMz = parcelRequire("iuCMz");
var $130bed10b950a50a$var$internalBuffer = {};

var $aZB9a = parcelRequire("aZB9a");

var $4yxjC = parcelRequire("4yxjC");

var $130bed10b950a50a$var$Stream = module.exports = (parcelRequire("d5bgu")).Stream;
$130bed10b950a50a$var$Stream.isDestroyed = $4yxjC.isDestroyed;
$130bed10b950a50a$var$Stream.isDisturbed = $4yxjC.isDisturbed;
$130bed10b950a50a$var$Stream.isErrored = $4yxjC.isErrored;
$130bed10b950a50a$var$Stream.isReadable = $4yxjC.isReadable;
$130bed10b950a50a$var$Stream.isWritable = $4yxjC.isWritable;

$130bed10b950a50a$var$Stream.Readable = (parcelRequire("2kjDT"));
var $130bed10b950a50a$var$_iteratorNormalCompletion = true, $130bed10b950a50a$var$_didIteratorError = false, $130bed10b950a50a$var$_iteratorError = undefined;
try {
    for(var $130bed10b950a50a$var$_iterator = $130bed10b950a50a$var$ObjectKeys($130bed10b950a50a$var$streamReturningOperators)[Symbol.iterator](), $130bed10b950a50a$var$_step; !($130bed10b950a50a$var$_iteratorNormalCompletion = ($130bed10b950a50a$var$_step = $130bed10b950a50a$var$_iterator.next()).done); $130bed10b950a50a$var$_iteratorNormalCompletion = true){
        var $130bed10b950a50a$var$key = $130bed10b950a50a$var$_step.value;
        var $130bed10b950a50a$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $130bed10b950a50a$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $130bed10b950a50a$var$Stream.Readable.from($130bed10b950a50a$var$ReflectApply($130bed10b950a50a$var$op, this, args));
        };
        var $130bed10b950a50a$var$op = $130bed10b950a50a$var$streamReturningOperators[$130bed10b950a50a$var$key];
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$fn, 'name', {
            __proto__: null,
            value: $130bed10b950a50a$var$op.name
        });
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$fn, 'length', {
            __proto__: null,
            value: $130bed10b950a50a$var$op.length
        });
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$Stream.Readable.prototype, $130bed10b950a50a$var$key, {
            __proto__: null,
            value: $130bed10b950a50a$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $130bed10b950a50a$var$_didIteratorError = true;
    $130bed10b950a50a$var$_iteratorError = err;
} finally{
    try {
        if (!$130bed10b950a50a$var$_iteratorNormalCompletion && $130bed10b950a50a$var$_iterator["return"] != null) {
            $130bed10b950a50a$var$_iterator["return"]();
        }
    } finally{
        if ($130bed10b950a50a$var$_didIteratorError) {
            throw $130bed10b950a50a$var$_iteratorError;
        }
    }
}
var $130bed10b950a50a$var$_iteratorNormalCompletion1 = true, $130bed10b950a50a$var$_didIteratorError1 = false, $130bed10b950a50a$var$_iteratorError1 = undefined;
try {
    for(var $130bed10b950a50a$var$_iterator1 = $130bed10b950a50a$var$ObjectKeys($130bed10b950a50a$var$promiseReturningOperators)[Symbol.iterator](), $130bed10b950a50a$var$_step1; !($130bed10b950a50a$var$_iteratorNormalCompletion1 = ($130bed10b950a50a$var$_step1 = $130bed10b950a50a$var$_iterator1.next()).done); $130bed10b950a50a$var$_iteratorNormalCompletion1 = true){
        var $130bed10b950a50a$var$key1 = $130bed10b950a50a$var$_step1.value;
        var $130bed10b950a50a$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $130bed10b950a50a$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $130bed10b950a50a$var$ReflectApply($130bed10b950a50a$var$op1, this, args);
        };
        var $130bed10b950a50a$var$op1 = $130bed10b950a50a$var$promiseReturningOperators[$130bed10b950a50a$var$key1];
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$fn1, 'name', {
            __proto__: null,
            value: $130bed10b950a50a$var$op1.name
        });
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$fn1, 'length', {
            __proto__: null,
            value: $130bed10b950a50a$var$op1.length
        });
        $130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$Stream.Readable.prototype, $130bed10b950a50a$var$key1, {
            __proto__: null,
            value: $130bed10b950a50a$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $130bed10b950a50a$var$_didIteratorError1 = true;
    $130bed10b950a50a$var$_iteratorError1 = err;
} finally{
    try {
        if (!$130bed10b950a50a$var$_iteratorNormalCompletion1 && $130bed10b950a50a$var$_iterator1["return"] != null) {
            $130bed10b950a50a$var$_iterator1["return"]();
        }
    } finally{
        if ($130bed10b950a50a$var$_didIteratorError1) {
            throw $130bed10b950a50a$var$_iteratorError1;
        }
    }
}

$130bed10b950a50a$var$Stream.Writable = (parcelRequire("lRXk3"));

$130bed10b950a50a$var$Stream.Duplex = (parcelRequire("a0xaf"));

$130bed10b950a50a$var$Stream.Transform = (parcelRequire("bYntR"));

$130bed10b950a50a$var$Stream.PassThrough = (parcelRequire("htMxd"));
$130bed10b950a50a$var$Stream.pipeline = $130bed10b950a50a$require$pipeline;

var $7HqJd = parcelRequire("7HqJd");
var $130bed10b950a50a$require$addAbortSignal = $7HqJd.addAbortSignal;
$130bed10b950a50a$var$Stream.addAbortSignal = $130bed10b950a50a$require$addAbortSignal;
$130bed10b950a50a$var$Stream.finished = $iuCMz;
$130bed10b950a50a$var$Stream.destroy = $130bed10b950a50a$require$destroyer;
$130bed10b950a50a$var$Stream.compose = $1MGKm;
$130bed10b950a50a$var$Stream.setDefaultHighWaterMark = $130bed10b950a50a$var$setDefaultHighWaterMark;
$130bed10b950a50a$var$Stream.getDefaultHighWaterMark = $130bed10b950a50a$var$getDefaultHighWaterMark;
$130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $aZB9a;
    }
});
$130bed10b950a50a$var$ObjectDefineProperty($130bed10b950a50a$require$pipeline, $130bed10b950a50a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $aZB9a.pipeline;
    }
});
$130bed10b950a50a$var$ObjectDefineProperty($iuCMz, $130bed10b950a50a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $aZB9a.finished;
    }
});
// Backwards-compat with node 0.4.x
$130bed10b950a50a$var$Stream.Stream = $130bed10b950a50a$var$Stream;
$130bed10b950a50a$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$130bed10b950a50a$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $130bed10b950a50a$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("6JBOZ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $4e744894b0da9700$export$a143d493d941bafc; }, function (v) { return $4e744894b0da9700$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $4e744894b0da9700$export$f99ded8fe4b79145; }, function (v) { return $4e744894b0da9700$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $4e744894b0da9700$export$a143d493d941bafc;
var $4e744894b0da9700$export$e4cf37d7f6fb9e0a;
var $4e744894b0da9700$export$f99ded8fe4b79145;
var $4e744894b0da9700$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $4e744894b0da9700$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4e744894b0da9700$export$a143d493d941bafc = $4e744894b0da9700$var$Buffer;
$4e744894b0da9700$export$e4cf37d7f6fb9e0a = $4e744894b0da9700$var$SlowBuffer;
$4e744894b0da9700$export$f99ded8fe4b79145 = 50;
var $4e744894b0da9700$var$K_MAX_LENGTH = 0x7fffffff;
$4e744894b0da9700$export$599f31c3813fae4d = $4e744894b0da9700$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4e744894b0da9700$var$Buffer.TYPED_ARRAY_SUPPORT = $4e744894b0da9700$var$typedArraySupport();
if (!$4e744894b0da9700$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4e744894b0da9700$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4e744894b0da9700$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$4e744894b0da9700$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4e744894b0da9700$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$4e744894b0da9700$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4e744894b0da9700$var$createBuffer(length) {
    if (length > $4e744894b0da9700$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4e744894b0da9700$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4e744894b0da9700$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4e744894b0da9700$var$allocUnsafe(arg);
    }
    return $4e744894b0da9700$var$from(arg, encodingOrOffset, length);
}
$4e744894b0da9700$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4e744894b0da9700$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4e744894b0da9700$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4e744894b0da9700$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($4e744894b0da9700$var$isInstance(value, ArrayBuffer) || value && $4e744894b0da9700$var$isInstance(value.buffer, ArrayBuffer)) return $4e744894b0da9700$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4e744894b0da9700$var$isInstance(value, SharedArrayBuffer) || value && $4e744894b0da9700$var$isInstance(value.buffer, SharedArrayBuffer))) return $4e744894b0da9700$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4e744894b0da9700$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $4e744894b0da9700$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4e744894b0da9700$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4e744894b0da9700$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4e744894b0da9700$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4e744894b0da9700$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4e744894b0da9700$var$Buffer, Uint8Array);
function $4e744894b0da9700$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4e744894b0da9700$var$alloc(size, fill, encoding) {
    $4e744894b0da9700$var$assertSize(size);
    if (size <= 0) return $4e744894b0da9700$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4e744894b0da9700$var$createBuffer(size).fill(fill, encoding) : $4e744894b0da9700$var$createBuffer(size).fill(fill);
    return $4e744894b0da9700$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4e744894b0da9700$var$Buffer.alloc = function(size, fill, encoding) {
    return $4e744894b0da9700$var$alloc(size, fill, encoding);
};
function $4e744894b0da9700$var$allocUnsafe(size) {
    $4e744894b0da9700$var$assertSize(size);
    return $4e744894b0da9700$var$createBuffer(size < 0 ? 0 : $4e744894b0da9700$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4e744894b0da9700$var$Buffer.allocUnsafe = function(size) {
    return $4e744894b0da9700$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4e744894b0da9700$var$Buffer.allocUnsafeSlow = function(size) {
    return $4e744894b0da9700$var$allocUnsafe(size);
};
function $4e744894b0da9700$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4e744894b0da9700$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $4e744894b0da9700$var$byteLength(string, encoding) | 0;
    var buf = $4e744894b0da9700$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4e744894b0da9700$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $4e744894b0da9700$var$checked(array.length) | 0;
    var buf = $4e744894b0da9700$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4e744894b0da9700$var$fromArrayView(arrayView) {
    if ($4e744894b0da9700$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $4e744894b0da9700$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4e744894b0da9700$var$fromArrayLike(arrayView);
}
function $4e744894b0da9700$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4e744894b0da9700$var$Buffer.prototype);
    return buf;
}
function $4e744894b0da9700$var$fromObject(obj) {
    if ($4e744894b0da9700$var$Buffer.isBuffer(obj)) {
        var len = $4e744894b0da9700$var$checked(obj.length) | 0;
        var buf = $4e744894b0da9700$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4e744894b0da9700$var$numberIsNaN(obj.length)) return $4e744894b0da9700$var$createBuffer(0);
        return $4e744894b0da9700$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4e744894b0da9700$var$fromArrayLike(obj.data);
}
function $4e744894b0da9700$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4e744894b0da9700$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4e744894b0da9700$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4e744894b0da9700$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4e744894b0da9700$var$Buffer.alloc(+length);
}
$4e744894b0da9700$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4e744894b0da9700$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4e744894b0da9700$var$Buffer.compare = function compare(a, b) {
    if ($4e744894b0da9700$var$isInstance(a, Uint8Array)) a = $4e744894b0da9700$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4e744894b0da9700$var$isInstance(b, Uint8Array)) b = $4e744894b0da9700$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4e744894b0da9700$var$Buffer.isBuffer(a) || !$4e744894b0da9700$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4e744894b0da9700$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4e744894b0da9700$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4e744894b0da9700$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $4e744894b0da9700$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($4e744894b0da9700$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4e744894b0da9700$var$Buffer.isBuffer(buf)) buf = $4e744894b0da9700$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4e744894b0da9700$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4e744894b0da9700$var$byteLength(string, encoding) {
    if ($4e744894b0da9700$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4e744894b0da9700$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4e744894b0da9700$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4e744894b0da9700$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4e744894b0da9700$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4e744894b0da9700$var$Buffer.byteLength = $4e744894b0da9700$var$byteLength;
function $4e744894b0da9700$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4e744894b0da9700$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4e744894b0da9700$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4e744894b0da9700$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4e744894b0da9700$var$latin1Slice(this, start, end);
        case 'base64':
            return $4e744894b0da9700$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4e744894b0da9700$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4e744894b0da9700$var$Buffer.prototype._isBuffer = true;
function $4e744894b0da9700$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4e744894b0da9700$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$4e744894b0da9700$var$swap(this, i, i + 1);
    return this;
};
$4e744894b0da9700$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $4e744894b0da9700$var$swap(this, i, i + 3);
        $4e744894b0da9700$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4e744894b0da9700$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $4e744894b0da9700$var$swap(this, i, i + 7);
        $4e744894b0da9700$var$swap(this, i + 1, i + 6);
        $4e744894b0da9700$var$swap(this, i + 2, i + 5);
        $4e744894b0da9700$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4e744894b0da9700$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4e744894b0da9700$var$utf8Slice(this, 0, length);
    return $4e744894b0da9700$var$slowToString.apply(this, arguments);
};
$4e744894b0da9700$var$Buffer.prototype.toLocaleString = $4e744894b0da9700$var$Buffer.prototype.toString;
$4e744894b0da9700$var$Buffer.prototype.equals = function equals(b) {
    if (!$4e744894b0da9700$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4e744894b0da9700$var$Buffer.compare(this, b) === 0;
};
$4e744894b0da9700$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $4e744894b0da9700$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4e744894b0da9700$var$customInspectSymbol) $4e744894b0da9700$var$Buffer.prototype[$4e744894b0da9700$var$customInspectSymbol] = $4e744894b0da9700$var$Buffer.prototype.inspect;
$4e744894b0da9700$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4e744894b0da9700$var$isInstance(target, Uint8Array)) target = $4e744894b0da9700$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4e744894b0da9700$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4e744894b0da9700$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4e744894b0da9700$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4e744894b0da9700$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4e744894b0da9700$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4e744894b0da9700$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4e744894b0da9700$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4e744894b0da9700$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4e744894b0da9700$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4e744894b0da9700$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4e744894b0da9700$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4e744894b0da9700$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4e744894b0da9700$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4e744894b0da9700$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4e744894b0da9700$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4e744894b0da9700$var$utf8Write(buf, string, offset, length) {
    return $4e744894b0da9700$var$blitBuffer($4e744894b0da9700$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4e744894b0da9700$var$asciiWrite(buf, string, offset, length) {
    return $4e744894b0da9700$var$blitBuffer($4e744894b0da9700$var$asciiToBytes(string), buf, offset, length);
}
function $4e744894b0da9700$var$base64Write(buf, string, offset, length) {
    return $4e744894b0da9700$var$blitBuffer($4e744894b0da9700$var$base64ToBytes(string), buf, offset, length);
}
function $4e744894b0da9700$var$ucs2Write(buf, string, offset, length) {
    return $4e744894b0da9700$var$blitBuffer($4e744894b0da9700$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4e744894b0da9700$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4e744894b0da9700$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4e744894b0da9700$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4e744894b0da9700$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4e744894b0da9700$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4e744894b0da9700$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4e744894b0da9700$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4e744894b0da9700$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $4e744894b0da9700$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4e744894b0da9700$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $4e744894b0da9700$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4e744894b0da9700$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $4e744894b0da9700$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4e744894b0da9700$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4e744894b0da9700$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4e744894b0da9700$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4e744894b0da9700$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $4e744894b0da9700$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4e744894b0da9700$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4e744894b0da9700$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4e744894b0da9700$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4e744894b0da9700$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4e744894b0da9700$var$Buffer.prototype.readUintLE = $4e744894b0da9700$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4e744894b0da9700$var$Buffer.prototype.readUintBE = $4e744894b0da9700$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4e744894b0da9700$var$Buffer.prototype.readUint8 = $4e744894b0da9700$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4e744894b0da9700$var$Buffer.prototype.readUint16LE = $4e744894b0da9700$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4e744894b0da9700$var$Buffer.prototype.readUint16BE = $4e744894b0da9700$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4e744894b0da9700$var$Buffer.prototype.readUint32LE = $4e744894b0da9700$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4e744894b0da9700$var$Buffer.prototype.readUint32BE = $4e744894b0da9700$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4e744894b0da9700$var$Buffer.prototype.readBigUInt64LE = $4e744894b0da9700$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4e744894b0da9700$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4e744894b0da9700$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4e744894b0da9700$var$Buffer.prototype.readBigUInt64BE = $4e744894b0da9700$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4e744894b0da9700$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4e744894b0da9700$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4e744894b0da9700$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4e744894b0da9700$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4e744894b0da9700$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4e744894b0da9700$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4e744894b0da9700$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4e744894b0da9700$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4e744894b0da9700$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4e744894b0da9700$var$Buffer.prototype.readBigInt64LE = $4e744894b0da9700$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4e744894b0da9700$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4e744894b0da9700$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$4e744894b0da9700$var$Buffer.prototype.readBigInt64BE = $4e744894b0da9700$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4e744894b0da9700$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4e744894b0da9700$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$4e744894b0da9700$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$4e744894b0da9700$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$4e744894b0da9700$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$4e744894b0da9700$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $4e744894b0da9700$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4e744894b0da9700$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4e744894b0da9700$var$Buffer.prototype.writeUintLE = $4e744894b0da9700$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4e744894b0da9700$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4e744894b0da9700$var$Buffer.prototype.writeUintBE = $4e744894b0da9700$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4e744894b0da9700$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4e744894b0da9700$var$Buffer.prototype.writeUint8 = $4e744894b0da9700$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4e744894b0da9700$var$Buffer.prototype.writeUint16LE = $4e744894b0da9700$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4e744894b0da9700$var$Buffer.prototype.writeUint16BE = $4e744894b0da9700$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4e744894b0da9700$var$Buffer.prototype.writeUint32LE = $4e744894b0da9700$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4e744894b0da9700$var$Buffer.prototype.writeUint32BE = $4e744894b0da9700$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4e744894b0da9700$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4e744894b0da9700$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4e744894b0da9700$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4e744894b0da9700$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4e744894b0da9700$var$Buffer.prototype.writeBigUInt64LE = $4e744894b0da9700$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4e744894b0da9700$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4e744894b0da9700$var$Buffer.prototype.writeBigUInt64BE = $4e744894b0da9700$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4e744894b0da9700$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4e744894b0da9700$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4e744894b0da9700$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4e744894b0da9700$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4e744894b0da9700$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4e744894b0da9700$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4e744894b0da9700$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4e744894b0da9700$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4e744894b0da9700$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4e744894b0da9700$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4e744894b0da9700$var$Buffer.prototype.writeBigInt64LE = $4e744894b0da9700$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4e744894b0da9700$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$4e744894b0da9700$var$Buffer.prototype.writeBigInt64BE = $4e744894b0da9700$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4e744894b0da9700$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $4e744894b0da9700$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4e744894b0da9700$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4e744894b0da9700$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4e744894b0da9700$var$writeFloat(this, value, offset, true, noAssert);
};
$4e744894b0da9700$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4e744894b0da9700$var$writeFloat(this, value, offset, false, noAssert);
};
function $4e744894b0da9700$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4e744894b0da9700$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4e744894b0da9700$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4e744894b0da9700$var$writeDouble(this, value, offset, true, noAssert);
};
$4e744894b0da9700$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4e744894b0da9700$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4e744894b0da9700$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4e744894b0da9700$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4e744894b0da9700$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4e744894b0da9700$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $4e744894b0da9700$var$Buffer.isBuffer(val) ? val : $4e744894b0da9700$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $4e744894b0da9700$var$errors = {};
function $4e744894b0da9700$var$E(sym, getMessage, Base) {
    $4e744894b0da9700$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$4e744894b0da9700$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$4e744894b0da9700$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$4e744894b0da9700$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $4e744894b0da9700$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $4e744894b0da9700$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $4e744894b0da9700$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $4e744894b0da9700$var$checkBounds(buf, offset, byteLength) {
    $4e744894b0da9700$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4e744894b0da9700$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4e744894b0da9700$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $4e744894b0da9700$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $4e744894b0da9700$var$checkBounds(buf, offset, byteLength);
}
function $4e744894b0da9700$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $4e744894b0da9700$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $4e744894b0da9700$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4e744894b0da9700$var$validateNumber(value, type);
        throw new $4e744894b0da9700$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $4e744894b0da9700$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4e744894b0da9700$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $4e744894b0da9700$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4e744894b0da9700$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4e744894b0da9700$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4e744894b0da9700$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4e744894b0da9700$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4e744894b0da9700$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4e744894b0da9700$var$base64ToBytes(str) {
    return $abUaD.toByteArray($4e744894b0da9700$var$base64clean(str));
}
function $4e744894b0da9700$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4e744894b0da9700$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4e744894b0da9700$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $4e744894b0da9700$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4e744894b0da9700$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $4e744894b0da9700$var$BufferBigIntNotDefined : fn;
}
function $4e744894b0da9700$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("83Xfu", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $5dec9025371cb871$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $5dec9025371cb871$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("imWI3", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $6JBOZ = parcelRequire("6JBOZ");

var $bs7qZ = parcelRequire("bs7qZ");
var $d5f7d29539fba484$var$format = $bs7qZ.format, $d5f7d29539fba484$var$inspect = $bs7qZ.inspect;

var $bnTha = parcelRequire("bnTha");
var $d5f7d29539fba484$var$ERR_INVALID_ARG_TYPE = $bnTha.codes.ERR_INVALID_ARG_TYPE;

var $83Xfu = parcelRequire("83Xfu");
var $d5f7d29539fba484$var$kResistStopPropagation = $83Xfu.kResistStopPropagation, $d5f7d29539fba484$var$AggregateError = $83Xfu.AggregateError, $d5f7d29539fba484$var$SymbolDispose = $83Xfu.SymbolDispose;

var $d5f7d29539fba484$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $d5f7d29539fba484$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $d5f7d29539fba484$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $d5f7d29539fba484$var$Blob = globalThis.Blob || $6JBOZ.Blob;
/* eslint-disable indent */ var $d5f7d29539fba484$var$isBlob = typeof $d5f7d29539fba484$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $d5f7d29539fba484$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $d5f7d29539fba484$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $d5f7d29539fba484$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $d5f7d29539fba484$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $d5f7d29539fba484$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $d5f7d29539fba484$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $d5f7d29539fba484$var$format,
    inspect: $d5f7d29539fba484$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $d5f7d29539fba484$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $d5f7d29539fba484$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $d5f7d29539fba484$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $d5f7d29539fba484$var$validateAbortSignal(signal, 'signal');
        $d5f7d29539fba484$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $d5f7d29539fba484$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $d5f7d29539fba484$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $d5f7d29539fba484$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $d5f7d29539fba484$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $d5f7d29539fba484$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("bs7qZ", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("bnTha", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $bs7qZ = parcelRequire("bs7qZ");
var $849cb851a7355b4b$var$format = $bs7qZ.format, $849cb851a7355b4b$var$inspect = $bs7qZ.inspect;

var $83Xfu = parcelRequire("83Xfu");
var $849cb851a7355b4b$var$CustomAggregateError = $83Xfu.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $849cb851a7355b4b$var$AggregateError = globalThis.AggregateError || $849cb851a7355b4b$var$CustomAggregateError;
var $849cb851a7355b4b$var$kIsNodeError = Symbol('kIsNodeError');
var $849cb851a7355b4b$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $849cb851a7355b4b$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $849cb851a7355b4b$var$nodeInternalPrefix = '__node_internal_';
var $849cb851a7355b4b$var$codes = {};
function $849cb851a7355b4b$var$assert(value, message) {
    if (!value) throw new $849cb851a7355b4b$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $849cb851a7355b4b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $849cb851a7355b4b$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $849cb851a7355b4b$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $849cb851a7355b4b$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $849cb851a7355b4b$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $849cb851a7355b4b$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $849cb851a7355b4b$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$849cb851a7355b4b$var$kIsNodeError] = true;
    $849cb851a7355b4b$var$codes[code] = NodeError;
}
function $849cb851a7355b4b$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $849cb851a7355b4b$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $849cb851a7355b4b$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $849cb851a7355b4b$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $849cb851a7355b4b$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $849cb851a7355b4b$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$849cb851a7355b4b$var$E('ERR_ASSERTION', '%s', Error);
$849cb851a7355b4b$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $849cb851a7355b4b$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $849cb851a7355b4b$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($849cb851a7355b4b$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($849cb851a7355b4b$var$classRegExp.test(value)) instances.push(value);
            else {
                $849cb851a7355b4b$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $849cb851a7355b4b$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $849cb851a7355b4b$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$849cb851a7355b4b$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $849cb851a7355b4b$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$849cb851a7355b4b$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$849cb851a7355b4b$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $849cb851a7355b4b$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$849cb851a7355b4b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $849cb851a7355b4b$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $849cb851a7355b4b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $849cb851a7355b4b$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $849cb851a7355b4b$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$849cb851a7355b4b$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$849cb851a7355b4b$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$849cb851a7355b4b$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$849cb851a7355b4b$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$849cb851a7355b4b$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $849cb851a7355b4b$var$AbortError,
    aggregateTwoErrors: $849cb851a7355b4b$var$hideStackFrames($849cb851a7355b4b$var$aggregateTwoErrors),
    hideStackFrames: $849cb851a7355b4b$var$hideStackFrames,
    codes: $849cb851a7355b4b$var$codes
};

});


parcelRegister("1j4aK", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $0f3acd51df621dd2$export$42af8c323be37587; }, function (v) { return $0f3acd51df621dd2$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $0f3acd51df621dd2$export$f405f72c701dad87; }, function (v) { return $0f3acd51df621dd2$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $0f3acd51df621dd2$export$42af8c323be37587;
var $0f3acd51df621dd2$export$f405f72c701dad87;
'use strict';

var $0f3acd51df621dd2$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $bnTha = parcelRequire("bnTha");
var $0f3acd51df621dd2$var$_require_codes = $bnTha.codes, $0f3acd51df621dd2$var$ERR_INVALID_ARG_VALUE = $0f3acd51df621dd2$var$_require_codes.ERR_INVALID_ARG_VALUE, $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE = $0f3acd51df621dd2$var$_require_codes.ERR_INVALID_ARG_TYPE, $0f3acd51df621dd2$var$ERR_MISSING_ARGS = $0f3acd51df621dd2$var$_require_codes.ERR_MISSING_ARGS, $0f3acd51df621dd2$var$ERR_OUT_OF_RANGE = $0f3acd51df621dd2$var$_require_codes.ERR_OUT_OF_RANGE, $0f3acd51df621dd2$var$AbortError = $bnTha.AbortError;

var $6Vqqj = parcelRequire("6Vqqj");
var $0f3acd51df621dd2$var$validateAbortSignal = $6Vqqj.validateAbortSignal, $0f3acd51df621dd2$var$validateInteger = $6Vqqj.validateInteger, $0f3acd51df621dd2$var$validateObject = $6Vqqj.validateObject;

var $0f3acd51df621dd2$var$kWeakHandler = (parcelRequire("83Xfu")).Symbol('kWeak');

var $0f3acd51df621dd2$var$kResistStopPropagation = (parcelRequire("83Xfu")).Symbol('kResistStopPropagation');

var $iuCMz = parcelRequire("iuCMz");
var $0f3acd51df621dd2$require$finished = $iuCMz.finished;

var $1MGKm = parcelRequire("1MGKm");

var $7HqJd = parcelRequire("7HqJd");
var $0f3acd51df621dd2$require$addAbortSignalNoValidate = $7HqJd.addAbortSignalNoValidate;

var $4yxjC = parcelRequire("4yxjC");
var $0f3acd51df621dd2$var$isWritable = $4yxjC.isWritable, $0f3acd51df621dd2$var$isNodeStream = $4yxjC.isNodeStream;

var $0f3acd51df621dd2$require$deprecate = (parcelRequire("imWI3")).deprecate;

var $0f3acd51df621dd2$var$ArrayPrototypePush = (parcelRequire("83Xfu")).ArrayPrototypePush, $0f3acd51df621dd2$var$Boolean = (parcelRequire("83Xfu")).Boolean, $0f3acd51df621dd2$var$MathFloor = (parcelRequire("83Xfu")).MathFloor, $0f3acd51df621dd2$var$Number = (parcelRequire("83Xfu")).Number, $0f3acd51df621dd2$var$NumberIsNaN = (parcelRequire("83Xfu")).NumberIsNaN, $0f3acd51df621dd2$var$Promise = (parcelRequire("83Xfu")).Promise, $0f3acd51df621dd2$var$PromiseReject = (parcelRequire("83Xfu")).PromiseReject, $0f3acd51df621dd2$var$PromiseResolve = (parcelRequire("83Xfu")).PromiseResolve, $0f3acd51df621dd2$var$PromisePrototypeThen = (parcelRequire("83Xfu")).PromisePrototypeThen, $0f3acd51df621dd2$var$Symbol = (parcelRequire("83Xfu")).Symbol;
var $0f3acd51df621dd2$var$kEmpty = $0f3acd51df621dd2$var$Symbol('kEmpty');
var $0f3acd51df621dd2$var$kEof = $0f3acd51df621dd2$var$Symbol('kEof');
function $0f3acd51df621dd2$var$compose(stream, options) {
    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
    if ($0f3acd51df621dd2$var$isNodeStream(stream) && !$0f3acd51df621dd2$var$isWritable(stream)) throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $1MGKm(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $0f3acd51df621dd2$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $0f3acd51df621dd2$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $0f3acd51df621dd2$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $0f3acd51df621dd2$var$MathFloor(options.highWaterMark);
    $0f3acd51df621dd2$var$validateInteger(concurrency, 'options.concurrency', 1);
    $0f3acd51df621dd2$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $0f3acd51df621dd2$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $0f3acd51df621dd2$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $0f3acd51df621dd2$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $0f3acd51df621dd2$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $0f3acd51df621dd2$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($0f3acd51df621dd2$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $0f3acd51df621dd2$var$PromiseReject(err1);
                                $0f3acd51df621dd2$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("imWI3")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($0f3acd51df621dd2$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $0f3acd51df621dd2$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                        if (!(val !== $0f3acd51df621dd2$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $0f3acd51df621dd2$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0f3acd51df621dd2$var$asIndexedPairs(options) {
    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $0f3acd51df621dd2$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0f3acd51df621dd2$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0f3acd51df621dd2$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $0f3acd51df621dd2$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $0f3acd51df621dd2$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $0f3acd51df621dd2$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0f3acd51df621dd2$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $0f3acd51df621dd2$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $0f3acd51df621dd2$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($0f3acd51df621dd2$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $0f3acd51df621dd2$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $0f3acd51df621dd2$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $0f3acd51df621dd2$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $0f3acd51df621dd2$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($0f3acd51df621dd2$var$ERR_MISSING_ARGS);
function $0f3acd51df621dd2$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $0f3acd51df621dd2$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $0f3acd51df621dd2$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $0f3acd51df621dd2$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $0f3acd51df621dd2$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $0f3acd51df621dd2$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $0f3acd51df621dd2$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $0f3acd51df621dd2$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0f3acd51df621dd2$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $0f3acd51df621dd2$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $0f3acd51df621dd2$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $0f3acd51df621dd2$var$flatMap(fn, options) {
    var values = $0f3acd51df621dd2$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $0f3acd51df621dd2$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $0f3acd51df621dd2$var$Number(number);
    if ($0f3acd51df621dd2$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $0f3acd51df621dd2$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $0f3acd51df621dd2$var$drop(number, options) {
    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
    number = $0f3acd51df621dd2$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $0f3acd51df621dd2$var$take(number, options) {
    if (options != null) $0f3acd51df621dd2$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0f3acd51df621dd2$var$validateAbortSignal(options.signal, 'options.signal');
    number = $0f3acd51df621dd2$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $0f3acd51df621dd2$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$0f3acd51df621dd2$export$42af8c323be37587 = {
    asIndexedPairs: $0f3acd51df621dd2$require$deprecate($0f3acd51df621dd2$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $0f3acd51df621dd2$var$drop,
    filter: $0f3acd51df621dd2$var$filter,
    flatMap: $0f3acd51df621dd2$var$flatMap,
    map: $0f3acd51df621dd2$var$map,
    take: $0f3acd51df621dd2$var$take,
    compose: $0f3acd51df621dd2$var$compose
};
$0f3acd51df621dd2$export$f405f72c701dad87 = {
    every: $0f3acd51df621dd2$var$every,
    forEach: $0f3acd51df621dd2$var$forEach,
    reduce: $0f3acd51df621dd2$var$reduce,
    toArray: $0f3acd51df621dd2$var$toArray,
    some: $0f3acd51df621dd2$var$some,
    find: $0f3acd51df621dd2$var$find
};

});
parcelRegister("6Vqqj", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $50ac901a523709c3$var$ArrayIsArray = $83Xfu.ArrayIsArray, $50ac901a523709c3$var$ArrayPrototypeIncludes = $83Xfu.ArrayPrototypeIncludes, $50ac901a523709c3$var$ArrayPrototypeJoin = $83Xfu.ArrayPrototypeJoin, $50ac901a523709c3$var$ArrayPrototypeMap = $83Xfu.ArrayPrototypeMap, $50ac901a523709c3$var$NumberIsInteger = $83Xfu.NumberIsInteger, $50ac901a523709c3$var$NumberIsNaN = $83Xfu.NumberIsNaN, $50ac901a523709c3$var$NumberMAX_SAFE_INTEGER = $83Xfu.NumberMAX_SAFE_INTEGER, $50ac901a523709c3$var$NumberMIN_SAFE_INTEGER = $83Xfu.NumberMIN_SAFE_INTEGER, $50ac901a523709c3$var$NumberParseInt = $83Xfu.NumberParseInt, $50ac901a523709c3$var$ObjectPrototypeHasOwnProperty = $83Xfu.ObjectPrototypeHasOwnProperty, $50ac901a523709c3$var$RegExpPrototypeExec = $83Xfu.RegExpPrototypeExec, $50ac901a523709c3$var$String = $83Xfu.String, $50ac901a523709c3$var$StringPrototypeToUpperCase = $83Xfu.StringPrototypeToUpperCase, $50ac901a523709c3$var$StringPrototypeTrim = $83Xfu.StringPrototypeTrim;

var $bnTha = parcelRequire("bnTha");
var $50ac901a523709c3$var$hideStackFrames = $bnTha.hideStackFrames, $50ac901a523709c3$var$_require_codes = $bnTha.codes, $50ac901a523709c3$var$ERR_SOCKET_BAD_PORT = $50ac901a523709c3$var$_require_codes.ERR_SOCKET_BAD_PORT, $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE = $50ac901a523709c3$var$_require_codes.ERR_INVALID_ARG_TYPE, $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE = $50ac901a523709c3$var$_require_codes.ERR_INVALID_ARG_VALUE, $50ac901a523709c3$var$ERR_OUT_OF_RANGE = $50ac901a523709c3$var$_require_codes.ERR_OUT_OF_RANGE, $50ac901a523709c3$var$ERR_UNKNOWN_SIGNAL = $50ac901a523709c3$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $imWI3 = parcelRequire("imWI3");
var $50ac901a523709c3$require$normalizeEncoding = $imWI3.normalizeEncoding;

var $imWI3 = parcelRequire("imWI3");
var $50ac901a523709c3$require$_require_types = $imWI3.types;
var $50ac901a523709c3$var$isAsyncFunction = $50ac901a523709c3$require$_require_types.isAsyncFunction, $50ac901a523709c3$var$isArrayBufferView = $50ac901a523709c3$require$_require_types.isArrayBufferView;
var $50ac901a523709c3$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $50ac901a523709c3$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $50ac901a523709c3$var$isUint32(value) {
    return value === value >>> 0;
}
var $50ac901a523709c3$var$octalReg = /^[0-7]+$/;
var $50ac901a523709c3$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $50ac901a523709c3$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($50ac901a523709c3$var$RegExpPrototypeExec($50ac901a523709c3$var$octalReg, value) === null) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE(name, value, $50ac901a523709c3$var$modeDesc);
        value = $50ac901a523709c3$var$NumberParseInt(value, 8);
    }
    $50ac901a523709c3$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $50ac901a523709c3$var$validateInteger = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $50ac901a523709c3$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $50ac901a523709c3$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$50ac901a523709c3$var$NumberIsInteger(value)) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $50ac901a523709c3$var$validateInt32 = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$50ac901a523709c3$var$NumberIsInteger(value)) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $50ac901a523709c3$var$validateUint32 = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$50ac901a523709c3$var$NumberIsInteger(value)) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $50ac901a523709c3$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $50ac901a523709c3$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $50ac901a523709c3$var$NumberIsNaN(value)) throw new $50ac901a523709c3$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $50ac901a523709c3$var$validateOneOf = $50ac901a523709c3$var$hideStackFrames(function(value, name, oneOf) {
    if (!$50ac901a523709c3$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $50ac901a523709c3$var$ArrayPrototypeJoin($50ac901a523709c3$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $50ac901a523709c3$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $50ac901a523709c3$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $50ac901a523709c3$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$50ac901a523709c3$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $50ac901a523709c3$var$validateObject = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $50ac901a523709c3$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $50ac901a523709c3$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $50ac901a523709c3$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $50ac901a523709c3$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $50ac901a523709c3$var$validateDictionary = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $50ac901a523709c3$var$validateArray = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$50ac901a523709c3$var$ArrayIsArray(value)) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $50ac901a523709c3$var$validateStringArray(value, name) {
    $50ac901a523709c3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$50ac901a523709c3$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $50ac901a523709c3$var$validateBooleanArray(value, name) {
    $50ac901a523709c3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$50ac901a523709c3$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $50ac901a523709c3$var$validateAbortSignalArray(value, name) {
    $50ac901a523709c3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $50ac901a523709c3$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $50ac901a523709c3$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $50ac901a523709c3$var$validateString(signal, name);
    if ($50ac901a523709c3$var$signals[signal] === undefined) {
        if ($50ac901a523709c3$var$signals[$50ac901a523709c3$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $50ac901a523709c3$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $50ac901a523709c3$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $50ac901a523709c3$var$validateBuffer = $50ac901a523709c3$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$50ac901a523709c3$var$isArrayBufferView(buffer)) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $50ac901a523709c3$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $50ac901a523709c3$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $50ac901a523709c3$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $50ac901a523709c3$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $50ac901a523709c3$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $50ac901a523709c3$var$validateAbortSignal = $50ac901a523709c3$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $50ac901a523709c3$var$validateFunction = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $50ac901a523709c3$var$validatePlainFunction = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $50ac901a523709c3$var$isAsyncFunction(value)) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $50ac901a523709c3$var$validateUndefined = $50ac901a523709c3$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $50ac901a523709c3$var$validateUnion(value, name, union) {
    if (!$50ac901a523709c3$var$ArrayPrototypeIncludes(union, value)) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_TYPE(name, "('".concat($50ac901a523709c3$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $50ac901a523709c3$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $50ac901a523709c3$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$50ac901a523709c3$var$RegExpPrototypeExec($50ac901a523709c3$var$linkValueRegExp, value)) throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $50ac901a523709c3$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $50ac901a523709c3$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($50ac901a523709c3$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $50ac901a523709c3$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $50ac901a523709c3$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $50ac901a523709c3$var$isInt32,
    isUint32: $50ac901a523709c3$var$isUint32,
    parseFileMode: $50ac901a523709c3$var$parseFileMode,
    validateArray: $50ac901a523709c3$var$validateArray,
    validateStringArray: $50ac901a523709c3$var$validateStringArray,
    validateBooleanArray: $50ac901a523709c3$var$validateBooleanArray,
    validateAbortSignalArray: $50ac901a523709c3$var$validateAbortSignalArray,
    validateBoolean: $50ac901a523709c3$var$validateBoolean,
    validateBuffer: $50ac901a523709c3$var$validateBuffer,
    validateDictionary: $50ac901a523709c3$var$validateDictionary,
    validateEncoding: $50ac901a523709c3$var$validateEncoding,
    validateFunction: $50ac901a523709c3$var$validateFunction,
    validateInt32: $50ac901a523709c3$var$validateInt32,
    validateInteger: $50ac901a523709c3$var$validateInteger,
    validateNumber: $50ac901a523709c3$var$validateNumber,
    validateObject: $50ac901a523709c3$var$validateObject,
    validateOneOf: $50ac901a523709c3$var$validateOneOf,
    validatePlainFunction: $50ac901a523709c3$var$validatePlainFunction,
    validatePort: $50ac901a523709c3$var$validatePort,
    validateSignalName: $50ac901a523709c3$var$validateSignalName,
    validateString: $50ac901a523709c3$var$validateString,
    validateUint32: $50ac901a523709c3$var$validateUint32,
    validateUndefined: $50ac901a523709c3$var$validateUndefined,
    validateUnion: $50ac901a523709c3$var$validateUnion,
    validateAbortSignal: $50ac901a523709c3$var$validateAbortSignal,
    validateLinkHeaderValue: $50ac901a523709c3$var$validateLinkHeaderValue
};

});

parcelRegister("iuCMz", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bnTha = parcelRequire("bnTha");
/* replacement end */ var $d7691cb3793f941f$var$AbortError = $bnTha.AbortError, $d7691cb3793f941f$var$codes = $bnTha.codes;
var $d7691cb3793f941f$var$ERR_INVALID_ARG_TYPE = $d7691cb3793f941f$var$codes.ERR_INVALID_ARG_TYPE, $d7691cb3793f941f$var$ERR_STREAM_PREMATURE_CLOSE = $d7691cb3793f941f$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $d7691cb3793f941f$var$kEmptyObject = (parcelRequire("imWI3")).kEmptyObject, $d7691cb3793f941f$var$once = (parcelRequire("imWI3")).once;

var $6Vqqj = parcelRequire("6Vqqj");
var $d7691cb3793f941f$var$validateAbortSignal = $6Vqqj.validateAbortSignal, $d7691cb3793f941f$var$validateFunction = $6Vqqj.validateFunction, $d7691cb3793f941f$var$validateObject = $6Vqqj.validateObject, $d7691cb3793f941f$var$validateBoolean = $6Vqqj.validateBoolean;

var $83Xfu = parcelRequire("83Xfu");
var $d7691cb3793f941f$var$Promise = $83Xfu.Promise, $d7691cb3793f941f$var$PromisePrototypeThen = $83Xfu.PromisePrototypeThen, $d7691cb3793f941f$var$SymbolDispose = $83Xfu.SymbolDispose;

var $4yxjC = parcelRequire("4yxjC");
var $d7691cb3793f941f$var$isClosed = $4yxjC.isClosed, $d7691cb3793f941f$var$isReadable = $4yxjC.isReadable, $d7691cb3793f941f$var$isReadableNodeStream = $4yxjC.isReadableNodeStream, $d7691cb3793f941f$var$isReadableStream = $4yxjC.isReadableStream, $d7691cb3793f941f$var$isReadableFinished = $4yxjC.isReadableFinished, $d7691cb3793f941f$var$isReadableErrored = $4yxjC.isReadableErrored, $d7691cb3793f941f$var$isWritable = $4yxjC.isWritable, $d7691cb3793f941f$var$isWritableNodeStream = $4yxjC.isWritableNodeStream, $d7691cb3793f941f$var$isWritableStream = $4yxjC.isWritableStream, $d7691cb3793f941f$var$isWritableFinished = $4yxjC.isWritableFinished, $d7691cb3793f941f$var$isWritableErrored = $4yxjC.isWritableErrored, $d7691cb3793f941f$var$isNodeStream = $4yxjC.isNodeStream, $d7691cb3793f941f$var$_willEmitClose = $4yxjC.willEmitClose, $d7691cb3793f941f$var$kIsClosedPromise = $4yxjC.kIsClosedPromise;
var $d7691cb3793f941f$var$addAbortListener;
function $d7691cb3793f941f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $d7691cb3793f941f$var$nop = function() {};

function $d7691cb3793f941f$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $d7691cb3793f941f$var$kEmptyObject;
    } else if (options == null) options = $d7691cb3793f941f$var$kEmptyObject;
    else $d7691cb3793f941f$var$validateObject(options, 'options');
    $d7691cb3793f941f$var$validateFunction(callback, 'callback');
    $d7691cb3793f941f$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $d7691cb3793f941f$var$once(callback);
    if ($d7691cb3793f941f$var$isReadableStream(stream) || $d7691cb3793f941f$var$isWritableStream(stream)) return $d7691cb3793f941f$var$eosWeb(stream, options, callback);
    if (!$d7691cb3793f941f$var$isNodeStream(stream)) throw new $d7691cb3793f941f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $d7691cb3793f941f$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $d7691cb3793f941f$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $d7691cb3793f941f$var$_willEmitClose(stream) && $d7691cb3793f941f$var$isReadableNodeStream(stream) === readable && $d7691cb3793f941f$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $d7691cb3793f941f$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $d7691cb3793f941f$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $d7691cb3793f941f$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $d7691cb3793f941f$var$isWritableErrored(stream) || $d7691cb3793f941f$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $d7691cb3793f941f$var$isReadableNodeStream(stream, true)) {
            if (!$d7691cb3793f941f$var$isReadableFinished(stream, false)) return callback.call(stream, new $d7691cb3793f941f$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$d7691cb3793f941f$var$isWritableFinished(stream, false)) return callback.call(stream, new $d7691cb3793f941f$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $d7691cb3793f941f$var$isWritableErrored(stream) || $d7691cb3793f941f$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($d7691cb3793f941f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $d7691cb3793f941f$var$isReadable(stream)) && (writableFinished || $d7691cb3793f941f$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $d7691cb3793f941f$var$isWritable(stream)) && (readableFinished || $d7691cb3793f941f$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $d7691cb3793f941f$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $d7691cb3793f941f$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $d7691cb3793f941f$var$addAbortListener = $d7691cb3793f941f$var$addAbortListener || (parcelRequire("imWI3")).addAbortListener;
            var disposable = $d7691cb3793f941f$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $d7691cb3793f941f$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$d7691cb3793f941f$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $d7691cb3793f941f$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $d7691cb3793f941f$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $d7691cb3793f941f$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $d7691cb3793f941f$var$addAbortListener = $d7691cb3793f941f$var$addAbortListener || (parcelRequire("imWI3")).addAbortListener;
            var disposable = $d7691cb3793f941f$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $d7691cb3793f941f$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$d7691cb3793f941f$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $d7691cb3793f941f$var$PromisePrototypeThen(stream[$d7691cb3793f941f$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $d7691cb3793f941f$var$nop;
}
function $d7691cb3793f941f$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $d7691cb3793f941f$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $d7691cb3793f941f$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $d7691cb3793f941f$var$Promise(function(resolve, reject) {
        var cleanup = $d7691cb3793f941f$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $d7691cb3793f941f$var$eos;
module.exports.finished = $d7691cb3793f941f$var$finished;

});
parcelRegister("4yxjC", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $35142e28e3195dc7$var$SymbolAsyncIterator = $83Xfu.SymbolAsyncIterator, $35142e28e3195dc7$var$SymbolIterator = $83Xfu.SymbolIterator, $35142e28e3195dc7$var$SymbolFor = $83Xfu.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $35142e28e3195dc7$var$kIsDestroyed = $35142e28e3195dc7$var$SymbolFor('nodejs.stream.destroyed');
var $35142e28e3195dc7$var$kIsErrored = $35142e28e3195dc7$var$SymbolFor('nodejs.stream.errored');
var $35142e28e3195dc7$var$kIsReadable = $35142e28e3195dc7$var$SymbolFor('nodejs.stream.readable');
var $35142e28e3195dc7$var$kIsWritable = $35142e28e3195dc7$var$SymbolFor('nodejs.stream.writable');
var $35142e28e3195dc7$var$kIsDisturbed = $35142e28e3195dc7$var$SymbolFor('nodejs.stream.disturbed');
var $35142e28e3195dc7$var$kIsClosedPromise = $35142e28e3195dc7$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $35142e28e3195dc7$var$kControllerErrorFunction = $35142e28e3195dc7$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $35142e28e3195dc7$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $35142e28e3195dc7$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $35142e28e3195dc7$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $35142e28e3195dc7$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $35142e28e3195dc7$var$isReadableStream(obj) {
    return !!(obj && !$35142e28e3195dc7$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $35142e28e3195dc7$var$isWritableStream(obj) {
    return !!(obj && !$35142e28e3195dc7$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $35142e28e3195dc7$var$isTransformStream(obj) {
    return !!(obj && !$35142e28e3195dc7$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $35142e28e3195dc7$var$isWebStream(obj) {
    return $35142e28e3195dc7$var$isReadableStream(obj) || $35142e28e3195dc7$var$isWritableStream(obj) || $35142e28e3195dc7$var$isTransformStream(obj);
}
function $35142e28e3195dc7$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$35142e28e3195dc7$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$35142e28e3195dc7$var$SymbolIterator] === 'function';
    return typeof obj[$35142e28e3195dc7$var$SymbolAsyncIterator] === 'function' || typeof obj[$35142e28e3195dc7$var$SymbolIterator] === 'function';
}
function $35142e28e3195dc7$var$isDestroyed(stream) {
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$35142e28e3195dc7$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $35142e28e3195dc7$var$isWritableEnded(stream) {
    if (!$35142e28e3195dc7$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $35142e28e3195dc7$var$isWritableFinished(stream, strict) {
    if (!$35142e28e3195dc7$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $35142e28e3195dc7$var$isReadableEnded(stream) {
    if (!$35142e28e3195dc7$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $35142e28e3195dc7$var$isReadableFinished(stream, strict) {
    if (!$35142e28e3195dc7$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $35142e28e3195dc7$var$isReadable(stream) {
    if (stream && stream[$35142e28e3195dc7$var$kIsReadable] != null) return stream[$35142e28e3195dc7$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($35142e28e3195dc7$var$isDestroyed(stream)) return false;
    return $35142e28e3195dc7$var$isReadableNodeStream(stream) && stream.readable && !$35142e28e3195dc7$var$isReadableFinished(stream);
}
function $35142e28e3195dc7$var$isWritable(stream) {
    if (stream && stream[$35142e28e3195dc7$var$kIsWritable] != null) return stream[$35142e28e3195dc7$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($35142e28e3195dc7$var$isDestroyed(stream)) return false;
    return $35142e28e3195dc7$var$isWritableNodeStream(stream) && stream.writable && !$35142e28e3195dc7$var$isWritableEnded(stream);
}
function $35142e28e3195dc7$var$isFinished(stream, opts) {
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    if ($35142e28e3195dc7$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $35142e28e3195dc7$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $35142e28e3195dc7$var$isWritable(stream)) return false;
    return true;
}
function $35142e28e3195dc7$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $35142e28e3195dc7$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $35142e28e3195dc7$var$isClosed(stream) {
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $35142e28e3195dc7$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $35142e28e3195dc7$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $35142e28e3195dc7$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $35142e28e3195dc7$var$isOutgoingMessage(stream);
}
function $35142e28e3195dc7$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $35142e28e3195dc7$var$willEmitClose(stream) {
    if (!$35142e28e3195dc7$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $35142e28e3195dc7$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $35142e28e3195dc7$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$35142e28e3195dc7$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $35142e28e3195dc7$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$35142e28e3195dc7$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $35142e28e3195dc7$var$isDestroyed,
    kIsDestroyed: $35142e28e3195dc7$var$kIsDestroyed,
    isDisturbed: $35142e28e3195dc7$var$isDisturbed,
    kIsDisturbed: $35142e28e3195dc7$var$kIsDisturbed,
    isErrored: $35142e28e3195dc7$var$isErrored,
    kIsErrored: $35142e28e3195dc7$var$kIsErrored,
    isReadable: $35142e28e3195dc7$var$isReadable,
    kIsReadable: $35142e28e3195dc7$var$kIsReadable,
    kIsClosedPromise: $35142e28e3195dc7$var$kIsClosedPromise,
    kControllerErrorFunction: $35142e28e3195dc7$var$kControllerErrorFunction,
    kIsWritable: $35142e28e3195dc7$var$kIsWritable,
    isClosed: $35142e28e3195dc7$var$isClosed,
    isDuplexNodeStream: $35142e28e3195dc7$var$isDuplexNodeStream,
    isFinished: $35142e28e3195dc7$var$isFinished,
    isIterable: $35142e28e3195dc7$var$isIterable,
    isReadableNodeStream: $35142e28e3195dc7$var$isReadableNodeStream,
    isReadableStream: $35142e28e3195dc7$var$isReadableStream,
    isReadableEnded: $35142e28e3195dc7$var$isReadableEnded,
    isReadableFinished: $35142e28e3195dc7$var$isReadableFinished,
    isReadableErrored: $35142e28e3195dc7$var$isReadableErrored,
    isNodeStream: $35142e28e3195dc7$var$isNodeStream,
    isWebStream: $35142e28e3195dc7$var$isWebStream,
    isWritable: $35142e28e3195dc7$var$isWritable,
    isWritableNodeStream: $35142e28e3195dc7$var$isWritableNodeStream,
    isWritableStream: $35142e28e3195dc7$var$isWritableStream,
    isWritableEnded: $35142e28e3195dc7$var$isWritableEnded,
    isWritableFinished: $35142e28e3195dc7$var$isWritableFinished,
    isWritableErrored: $35142e28e3195dc7$var$isWritableErrored,
    isServerRequest: $35142e28e3195dc7$var$isServerRequest,
    isServerResponse: $35142e28e3195dc7$var$isServerResponse,
    willEmitClose: $35142e28e3195dc7$var$willEmitClose,
    isTransformStream: $35142e28e3195dc7$var$isTransformStream
};

});


parcelRegister("1MGKm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eFsFu = parcelRequire("eFsFu");
var $14cb6ec6735cf9c4$require$pipeline = $eFsFu.pipeline;

var $a0xaf = parcelRequire("a0xaf");

var $jxsg7 = parcelRequire("jxsg7");
var $14cb6ec6735cf9c4$require$destroyer = $jxsg7.destroyer;

var $4yxjC = parcelRequire("4yxjC");
var $14cb6ec6735cf9c4$var$isNodeStream = $4yxjC.isNodeStream, $14cb6ec6735cf9c4$var$isReadable = $4yxjC.isReadable, $14cb6ec6735cf9c4$var$isWritable = $4yxjC.isWritable, $14cb6ec6735cf9c4$var$isWebStream = $4yxjC.isWebStream, $14cb6ec6735cf9c4$var$isTransformStream = $4yxjC.isTransformStream, $14cb6ec6735cf9c4$var$isWritableStream = $4yxjC.isWritableStream, $14cb6ec6735cf9c4$var$isReadableStream = $4yxjC.isReadableStream;

var $bnTha = parcelRequire("bnTha");
var $14cb6ec6735cf9c4$var$AbortError = $bnTha.AbortError, $14cb6ec6735cf9c4$var$_require_codes = $bnTha.codes, $14cb6ec6735cf9c4$var$ERR_INVALID_ARG_VALUE = $14cb6ec6735cf9c4$var$_require_codes.ERR_INVALID_ARG_VALUE, $14cb6ec6735cf9c4$var$ERR_MISSING_ARGS = $14cb6ec6735cf9c4$var$_require_codes.ERR_MISSING_ARGS;

var $iuCMz = parcelRequire("iuCMz");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $14cb6ec6735cf9c4$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $a0xaf.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $a0xaf.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $a0xaf.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$14cb6ec6735cf9c4$var$isNodeStream(streams[n]) && !$14cb6ec6735cf9c4$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($14cb6ec6735cf9c4$var$isReadable(streams[n]) || $14cb6ec6735cf9c4$var$isReadableStream(streams[n]) || $14cb6ec6735cf9c4$var$isTransformStream(streams[n]))) throw new $14cb6ec6735cf9c4$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($14cb6ec6735cf9c4$var$isWritable(streams[n]) || $14cb6ec6735cf9c4$var$isWritableStream(streams[n]) || $14cb6ec6735cf9c4$var$isTransformStream(streams[n]))) throw new $14cb6ec6735cf9c4$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $14cb6ec6735cf9c4$require$pipeline(streams, onfinished);
    var writable = !!($14cb6ec6735cf9c4$var$isWritable(head) || $14cb6ec6735cf9c4$var$isWritableStream(head) || $14cb6ec6735cf9c4$var$isTransformStream(head));
    var readable = !!($14cb6ec6735cf9c4$var$isReadable(tail) || $14cb6ec6735cf9c4$var$isReadableStream(tail) || $14cb6ec6735cf9c4$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $a0xaf({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($14cb6ec6735cf9c4$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($14cb6ec6735cf9c4$var$isWebStream(head)) {
            var writable1 = $14cb6ec6735cf9c4$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $14cb6ec6735cf9c4$var$isTransformStream(tail) ? tail.readable : tail;
        $iuCMz(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($14cb6ec6735cf9c4$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($14cb6ec6735cf9c4$var$isWebStream(tail)) {
            var readable1 = $14cb6ec6735cf9c4$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $14cb6ec6735cf9c4$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($14cb6ec6735cf9c4$var$isNodeStream(tail)) $14cb6ec6735cf9c4$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("eFsFu", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $aadb21ebe68c9e5d$var$ArrayIsArray = $83Xfu.ArrayIsArray, $aadb21ebe68c9e5d$var$Promise = $83Xfu.Promise, $aadb21ebe68c9e5d$var$SymbolAsyncIterator = $83Xfu.SymbolAsyncIterator, $aadb21ebe68c9e5d$var$SymbolDispose = $83Xfu.SymbolDispose;

var $iuCMz = parcelRequire("iuCMz");

var $aadb21ebe68c9e5d$require$once = (parcelRequire("imWI3")).once;

var $jxsg7 = parcelRequire("jxsg7");

var $a0xaf = parcelRequire("a0xaf");

var $bnTha = parcelRequire("bnTha");
var $aadb21ebe68c9e5d$var$aggregateTwoErrors = $bnTha.aggregateTwoErrors, $aadb21ebe68c9e5d$var$_require_codes = $bnTha.codes, $aadb21ebe68c9e5d$var$ERR_INVALID_ARG_TYPE = $aadb21ebe68c9e5d$var$_require_codes.ERR_INVALID_ARG_TYPE, $aadb21ebe68c9e5d$var$ERR_INVALID_RETURN_VALUE = $aadb21ebe68c9e5d$var$_require_codes.ERR_INVALID_RETURN_VALUE, $aadb21ebe68c9e5d$var$ERR_MISSING_ARGS = $aadb21ebe68c9e5d$var$_require_codes.ERR_MISSING_ARGS, $aadb21ebe68c9e5d$var$ERR_STREAM_DESTROYED = $aadb21ebe68c9e5d$var$_require_codes.ERR_STREAM_DESTROYED, $aadb21ebe68c9e5d$var$ERR_STREAM_PREMATURE_CLOSE = $aadb21ebe68c9e5d$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $aadb21ebe68c9e5d$var$AbortError = $bnTha.AbortError;

var $6Vqqj = parcelRequire("6Vqqj");
var $aadb21ebe68c9e5d$var$validateFunction = $6Vqqj.validateFunction, $aadb21ebe68c9e5d$var$validateAbortSignal = $6Vqqj.validateAbortSignal;

var $4yxjC = parcelRequire("4yxjC");
var $aadb21ebe68c9e5d$var$isIterable = $4yxjC.isIterable, $aadb21ebe68c9e5d$var$isReadable = $4yxjC.isReadable, $aadb21ebe68c9e5d$var$isReadableNodeStream = $4yxjC.isReadableNodeStream, $aadb21ebe68c9e5d$var$isNodeStream = $4yxjC.isNodeStream, $aadb21ebe68c9e5d$var$isTransformStream = $4yxjC.isTransformStream, $aadb21ebe68c9e5d$var$isWebStream = $4yxjC.isWebStream, $aadb21ebe68c9e5d$var$isReadableStream = $4yxjC.isReadableStream, $aadb21ebe68c9e5d$var$isReadableFinished = $4yxjC.isReadableFinished;

var $aadb21ebe68c9e5d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $aadb21ebe68c9e5d$var$PassThrough;
var $aadb21ebe68c9e5d$var$Readable;
var $aadb21ebe68c9e5d$var$addAbortListener;
function $aadb21ebe68c9e5d$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $iuCMz(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $jxsg7.destroyer(stream, err || new $aadb21ebe68c9e5d$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $aadb21ebe68c9e5d$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $aadb21ebe68c9e5d$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $aadb21ebe68c9e5d$var$makeAsyncIterable(val) {
    if ($aadb21ebe68c9e5d$var$isIterable(val)) return val;
    else if ($aadb21ebe68c9e5d$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $aadb21ebe68c9e5d$var$fromReadable(val);
    throw new $aadb21ebe68c9e5d$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $aadb21ebe68c9e5d$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$aadb21ebe68c9e5d$var$Readable) $aadb21ebe68c9e5d$var$Readable = (parcelRequire("2kjDT"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($aadb21ebe68c9e5d$var$Readable.prototype[$aadb21ebe68c9e5d$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $aadb21ebe68c9e5d$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $aadb21ebe68c9e5d$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $iuCMz(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $aadb21ebe68c9e5d$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $aadb21ebe68c9e5d$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($aadb21ebe68c9e5d$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $aadb21ebe68c9e5d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $aadb21ebe68c9e5d$var$pipelineImpl(streams, $aadb21ebe68c9e5d$require$once($aadb21ebe68c9e5d$var$popCallback(streams)));
}


function $aadb21ebe68c9e5d$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($aadb21ebe68c9e5d$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $aadb21ebe68c9e5d$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($aadb21ebe68c9e5d$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($aadb21ebe68c9e5d$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$aadb21ebe68c9e5d$var$isIterable(ret)) throw new $aadb21ebe68c9e5d$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($aadb21ebe68c9e5d$var$isIterable(stream) || $aadb21ebe68c9e5d$var$isReadableNodeStream(stream) || $aadb21ebe68c9e5d$var$isTransformStream(stream)) ret = stream;
            else ret = $a0xaf.from(stream);
        } else if (typeof stream === 'function') {
            if ($aadb21ebe68c9e5d$var$isTransformStream(ret)) {
                var _ret;
                ret = $aadb21ebe68c9e5d$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $aadb21ebe68c9e5d$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$aadb21ebe68c9e5d$var$isIterable(ret, true)) throw new $aadb21ebe68c9e5d$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$aadb21ebe68c9e5d$var$PassThrough) $aadb21ebe68c9e5d$var$PassThrough = (parcelRequire("htMxd"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $aadb21ebe68c9e5d$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($aadb21ebe68c9e5d$var$isIterable(ret, true)) {
                    finishCount++;
                    $aadb21ebe68c9e5d$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($aadb21ebe68c9e5d$var$isReadableStream(ret) || $aadb21ebe68c9e5d$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $aadb21ebe68c9e5d$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $aadb21ebe68c9e5d$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $aadb21ebe68c9e5d$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($aadb21ebe68c9e5d$var$isNodeStream(stream)) {
            if ($aadb21ebe68c9e5d$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $aadb21ebe68c9e5d$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($aadb21ebe68c9e5d$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($aadb21ebe68c9e5d$var$isTransformStream(ret) || $aadb21ebe68c9e5d$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $aadb21ebe68c9e5d$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($aadb21ebe68c9e5d$var$isIterable(ret)) {
                finishCount++;
                $aadb21ebe68c9e5d$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $aadb21ebe68c9e5d$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($aadb21ebe68c9e5d$var$isWebStream(stream)) {
            if ($aadb21ebe68c9e5d$var$isReadableNodeStream(ret)) {
                finishCount++;
                $aadb21ebe68c9e5d$var$pumpToWeb($aadb21ebe68c9e5d$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($aadb21ebe68c9e5d$var$isReadableStream(ret) || $aadb21ebe68c9e5d$var$isIterable(ret)) {
                finishCount++;
                $aadb21ebe68c9e5d$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($aadb21ebe68c9e5d$var$isTransformStream(ret)) {
                finishCount++;
                $aadb21ebe68c9e5d$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $aadb21ebe68c9e5d$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $a0xaf.from(stream);
    };
    if (streams.length === 1 && $aadb21ebe68c9e5d$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $aadb21ebe68c9e5d$var$ERR_MISSING_ARGS('streams');
    var ac = new $aadb21ebe68c9e5d$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $aadb21ebe68c9e5d$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $aadb21ebe68c9e5d$var$AbortError());
    }
    $aadb21ebe68c9e5d$var$addAbortListener = $aadb21ebe68c9e5d$var$addAbortListener || (parcelRequire("imWI3")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $aadb21ebe68c9e5d$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$aadb21ebe68c9e5d$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $aadb21ebe68c9e5d$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $aadb21ebe68c9e5d$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($aadb21ebe68c9e5d$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $iuCMz(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $iuCMz(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $aadb21ebe68c9e5d$var$pipelineImpl,
    pipeline: $aadb21ebe68c9e5d$var$pipeline
};

});
parcelRegister("jxsg7", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bnTha = parcelRequire("bnTha");
/* replacement end */ var $e39705033ce9f3a4$var$aggregateTwoErrors = $bnTha.aggregateTwoErrors, $e39705033ce9f3a4$var$ERR_MULTIPLE_CALLBACK = $bnTha.codes.ERR_MULTIPLE_CALLBACK, $e39705033ce9f3a4$var$AbortError = $bnTha.AbortError;

var $83Xfu = parcelRequire("83Xfu");
var $e39705033ce9f3a4$require$Symbol = $83Xfu.Symbol;

var $4yxjC = parcelRequire("4yxjC");
var $e39705033ce9f3a4$var$kIsDestroyed = $4yxjC.kIsDestroyed, $e39705033ce9f3a4$var$isDestroyed = $4yxjC.isDestroyed, $e39705033ce9f3a4$var$isFinished = $4yxjC.isFinished, $e39705033ce9f3a4$var$isServerRequest = $4yxjC.isServerRequest;
var $e39705033ce9f3a4$var$kDestroy = $e39705033ce9f3a4$require$Symbol('kDestroy');
var $e39705033ce9f3a4$var$kConstruct = $e39705033ce9f3a4$require$Symbol('kConstruct');
function $e39705033ce9f3a4$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $e39705033ce9f3a4$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $e39705033ce9f3a4$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($e39705033ce9f3a4$var$kDestroy, function(er) {
        $e39705033ce9f3a4$var$_destroy(this, $e39705033ce9f3a4$var$aggregateTwoErrors(er, err), cb);
    });
    else $e39705033ce9f3a4$var$_destroy(this, err, cb);
    return this;
}
function $e39705033ce9f3a4$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $e39705033ce9f3a4$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($e39705033ce9f3a4$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($e39705033ce9f3a4$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $e39705033ce9f3a4$var$emitErrorCloseNT(self, err) {
    $e39705033ce9f3a4$var$emitErrorNT(self, err);
    $e39705033ce9f3a4$var$emitCloseNT(self);
}
function $e39705033ce9f3a4$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $e39705033ce9f3a4$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $e39705033ce9f3a4$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $e39705033ce9f3a4$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($e39705033ce9f3a4$var$emitErrorNT, stream, err);
        else $e39705033ce9f3a4$var$emitErrorNT(stream, err);
    }
}
function $e39705033ce9f3a4$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($e39705033ce9f3a4$var$kConstruct, cb);
    if (stream.listenerCount($e39705033ce9f3a4$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($e39705033ce9f3a4$var$constructNT, stream);
}
function $e39705033ce9f3a4$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $e39705033ce9f3a4$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $e39705033ce9f3a4$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($e39705033ce9f3a4$var$kDestroy, err);
        else if (err) $e39705033ce9f3a4$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($e39705033ce9f3a4$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $e39705033ce9f3a4$var$emitConstructNT(stream) {
    stream.emit($e39705033ce9f3a4$var$kConstruct);
}
function $e39705033ce9f3a4$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $e39705033ce9f3a4$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $e39705033ce9f3a4$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($e39705033ce9f3a4$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $e39705033ce9f3a4$var$destroyer(stream, err) {
    if (!stream || $e39705033ce9f3a4$var$isDestroyed(stream)) return;
    if (!err && !$e39705033ce9f3a4$var$isFinished(stream)) err = new $e39705033ce9f3a4$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($e39705033ce9f3a4$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($e39705033ce9f3a4$var$isRequest(stream)) stream.abort();
    else if ($e39705033ce9f3a4$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($e39705033ce9f3a4$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($e39705033ce9f3a4$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$e39705033ce9f3a4$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $e39705033ce9f3a4$var$construct,
    destroyer: $e39705033ce9f3a4$var$destroyer,
    destroy: $e39705033ce9f3a4$var$destroy,
    undestroy: $e39705033ce9f3a4$var$undestroy,
    errorOrDestroy: $e39705033ce9f3a4$var$errorOrDestroy
};

});

parcelRegister("a0xaf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $7493a1362c6fd1e8$var$ObjectDefineProperties = $83Xfu.ObjectDefineProperties, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor = $83Xfu.ObjectGetOwnPropertyDescriptor, $7493a1362c6fd1e8$var$ObjectKeys = $83Xfu.ObjectKeys, $7493a1362c6fd1e8$var$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf;
module.exports = $7493a1362c6fd1e8$var$Duplex;

var $2kjDT = parcelRequire("2kjDT");

var $lRXk3 = parcelRequire("lRXk3");
$7493a1362c6fd1e8$var$ObjectSetPrototypeOf($7493a1362c6fd1e8$var$Duplex.prototype, $2kjDT.prototype);
$7493a1362c6fd1e8$var$ObjectSetPrototypeOf($7493a1362c6fd1e8$var$Duplex, $2kjDT);
{
    var $7493a1362c6fd1e8$var$keys = $7493a1362c6fd1e8$var$ObjectKeys($lRXk3.prototype);
    // Allow the keys array to be GC'ed.
    for(var $7493a1362c6fd1e8$var$i = 0; $7493a1362c6fd1e8$var$i < $7493a1362c6fd1e8$var$keys.length; $7493a1362c6fd1e8$var$i++){
        var $7493a1362c6fd1e8$var$method = $7493a1362c6fd1e8$var$keys[$7493a1362c6fd1e8$var$i];
        if (!$7493a1362c6fd1e8$var$Duplex.prototype[$7493a1362c6fd1e8$var$method]) $7493a1362c6fd1e8$var$Duplex.prototype[$7493a1362c6fd1e8$var$method] = $lRXk3.prototype[$7493a1362c6fd1e8$var$method];
    }
}function $7493a1362c6fd1e8$var$Duplex(options) {
    if (!(this instanceof $7493a1362c6fd1e8$var$Duplex)) return new $7493a1362c6fd1e8$var$Duplex(options);
    $2kjDT.call(this, options);
    $lRXk3.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$7493a1362c6fd1e8$var$ObjectDefineProperties($7493a1362c6fd1e8$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $7493a1362c6fd1e8$var$ObjectGetOwnPropertyDescriptor($lRXk3.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $7493a1362c6fd1e8$var$webStreamsAdapters;
// Lazy to avoid circular references
function $7493a1362c6fd1e8$var$lazyWebStreams() {
    if ($7493a1362c6fd1e8$var$webStreamsAdapters === undefined) $7493a1362c6fd1e8$var$webStreamsAdapters = {};
    return $7493a1362c6fd1e8$var$webStreamsAdapters;
}
$7493a1362c6fd1e8$var$Duplex.fromWeb = function(pair, options) {
    return $7493a1362c6fd1e8$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$7493a1362c6fd1e8$var$Duplex.toWeb = function(duplex) {
    return $7493a1362c6fd1e8$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $7493a1362c6fd1e8$var$duplexify;

$7493a1362c6fd1e8$var$Duplex.from = function(body) {
    if (!$7493a1362c6fd1e8$var$duplexify) $7493a1362c6fd1e8$var$duplexify = (parcelRequire("4xizM"));
    return $7493a1362c6fd1e8$var$duplexify(body, 'body');
};

});
parcelRegister("2kjDT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $83Xfu = parcelRequire("83Xfu");
/* replacement end */ var $1b1caf9c526b7b04$var$ArrayPrototypeIndexOf = $83Xfu.ArrayPrototypeIndexOf, $1b1caf9c526b7b04$var$NumberIsInteger = $83Xfu.NumberIsInteger, $1b1caf9c526b7b04$var$NumberIsNaN = $83Xfu.NumberIsNaN, $1b1caf9c526b7b04$var$NumberParseInt = $83Xfu.NumberParseInt, $1b1caf9c526b7b04$var$ObjectDefineProperties = $83Xfu.ObjectDefineProperties, $1b1caf9c526b7b04$var$ObjectKeys = $83Xfu.ObjectKeys, $1b1caf9c526b7b04$var$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf, $1b1caf9c526b7b04$var$Promise = $83Xfu.Promise, $1b1caf9c526b7b04$var$SafeSet = $83Xfu.SafeSet, $1b1caf9c526b7b04$var$SymbolAsyncDispose = $83Xfu.SymbolAsyncDispose, $1b1caf9c526b7b04$var$SymbolAsyncIterator = $83Xfu.SymbolAsyncIterator, $1b1caf9c526b7b04$var$Symbol = $83Xfu.Symbol;
module.exports = $1b1caf9c526b7b04$var$Readable;
$1b1caf9c526b7b04$var$Readable.ReadableState = $1b1caf9c526b7b04$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $1b1caf9c526b7b04$var$EE = $bBoAO.EventEmitter;

var $d5bgu = parcelRequire("d5bgu");
var $1b1caf9c526b7b04$var$Stream = $d5bgu.Stream, $1b1caf9c526b7b04$var$prependListener = $d5bgu.prependListener;

var $6JBOZ = parcelRequire("6JBOZ");
var $1b1caf9c526b7b04$require$Buffer = $6JBOZ.Buffer;

var $7HqJd = parcelRequire("7HqJd");
var $1b1caf9c526b7b04$require$addAbortSignal = $7HqJd.addAbortSignal;

var $iuCMz = parcelRequire("iuCMz");

var $1b1caf9c526b7b04$var$debug = (parcelRequire("imWI3")).debuglog('stream', function(fn) {
    $1b1caf9c526b7b04$var$debug = fn;
});

var $7M9oH = parcelRequire("7M9oH");

var $jxsg7 = parcelRequire("jxsg7");

var $hgv2A = parcelRequire("hgv2A");
var $1b1caf9c526b7b04$var$getHighWaterMark = $hgv2A.getHighWaterMark, $1b1caf9c526b7b04$var$getDefaultHighWaterMark = $hgv2A.getDefaultHighWaterMark;

var $bnTha = parcelRequire("bnTha");
var $1b1caf9c526b7b04$var$aggregateTwoErrors = $bnTha.aggregateTwoErrors, $1b1caf9c526b7b04$var$_require_codes = $bnTha.codes, $1b1caf9c526b7b04$var$ERR_INVALID_ARG_TYPE = $1b1caf9c526b7b04$var$_require_codes.ERR_INVALID_ARG_TYPE, $1b1caf9c526b7b04$var$ERR_METHOD_NOT_IMPLEMENTED = $1b1caf9c526b7b04$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $1b1caf9c526b7b04$var$ERR_OUT_OF_RANGE = $1b1caf9c526b7b04$var$_require_codes.ERR_OUT_OF_RANGE, $1b1caf9c526b7b04$var$ERR_STREAM_PUSH_AFTER_EOF = $1b1caf9c526b7b04$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $1b1caf9c526b7b04$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $1b1caf9c526b7b04$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $1b1caf9c526b7b04$var$AbortError = $bnTha.AbortError;

var $6Vqqj = parcelRequire("6Vqqj");
var $1b1caf9c526b7b04$require$validateObject = $6Vqqj.validateObject;
var $1b1caf9c526b7b04$var$kPaused = $1b1caf9c526b7b04$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $1b1caf9c526b7b04$require$StringDecoder = $3Jf7C.StringDecoder;

var $fajtH = parcelRequire("fajtH");
$1b1caf9c526b7b04$var$ObjectSetPrototypeOf($1b1caf9c526b7b04$var$Readable.prototype, $1b1caf9c526b7b04$var$Stream.prototype);
$1b1caf9c526b7b04$var$ObjectSetPrototypeOf($1b1caf9c526b7b04$var$Readable, $1b1caf9c526b7b04$var$Stream);
var $1b1caf9c526b7b04$var$nop = function() {};
var $1b1caf9c526b7b04$var$errorOrDestroy = $jxsg7.errorOrDestroy;
var $1b1caf9c526b7b04$var$kObjectMode = 1;
var $1b1caf9c526b7b04$var$kEnded = 2;
var $1b1caf9c526b7b04$var$kEndEmitted = 4;
var $1b1caf9c526b7b04$var$kReading = 8;
var $1b1caf9c526b7b04$var$kConstructed = 16;
var $1b1caf9c526b7b04$var$kSync = 32;
var $1b1caf9c526b7b04$var$kNeedReadable = 64;
var $1b1caf9c526b7b04$var$kEmittedReadable = 128;
var $1b1caf9c526b7b04$var$kReadableListening = 256;
var $1b1caf9c526b7b04$var$kResumeScheduled = 512;
var $1b1caf9c526b7b04$var$kErrorEmitted = 1024;
var $1b1caf9c526b7b04$var$kEmitClose = 2048;
var $1b1caf9c526b7b04$var$kAutoDestroy = 4096;
var $1b1caf9c526b7b04$var$kDestroyed = 8192;
var $1b1caf9c526b7b04$var$kClosed = 16384;
var $1b1caf9c526b7b04$var$kCloseEmitted = 32768;
var $1b1caf9c526b7b04$var$kMultiAwaitDrain = 65536;
var $1b1caf9c526b7b04$var$kReadingMore = 131072;
var $1b1caf9c526b7b04$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $1b1caf9c526b7b04$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$1b1caf9c526b7b04$var$ObjectDefineProperties($1b1caf9c526b7b04$var$ReadableState.prototype, {
    objectMode: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kObjectMode),
    ended: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kEnded),
    endEmitted: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kEndEmitted),
    reading: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kNeedReadable),
    emittedReadable: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kEmittedReadable),
    readableListening: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kReadableListening),
    resumeScheduled: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kErrorEmitted),
    emitClose: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kEmitClose),
    autoDestroy: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kCloseEmitted),
    multiAwaitDrain: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kReadingMore),
    dataEmitted: $1b1caf9c526b7b04$var$makeBitMapDescriptor($1b1caf9c526b7b04$var$kDataEmitted)
});

function $1b1caf9c526b7b04$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("a0xaf"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $1b1caf9c526b7b04$var$kEmitClose | $1b1caf9c526b7b04$var$kAutoDestroy | $1b1caf9c526b7b04$var$kConstructed | $1b1caf9c526b7b04$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $1b1caf9c526b7b04$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $1b1caf9c526b7b04$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $1b1caf9c526b7b04$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $1b1caf9c526b7b04$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $7M9oH();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$1b1caf9c526b7b04$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$1b1caf9c526b7b04$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$1b1caf9c526b7b04$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $1b1caf9c526b7b04$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $1b1caf9c526b7b04$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $1b1caf9c526b7b04$var$Readable)) return new $1b1caf9c526b7b04$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("a0xaf"));
    this._readableState = new $1b1caf9c526b7b04$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $1b1caf9c526b7b04$require$addAbortSignal(options.signal, this);
    }
    $1b1caf9c526b7b04$var$Stream.call(this, options);
    $jxsg7.construct(this, function() {
        if (_this._readableState.needReadable) $1b1caf9c526b7b04$var$maybeReadMore(_this, _this._readableState);
    });
}
$1b1caf9c526b7b04$var$Readable.prototype.destroy = $jxsg7.destroy;
$1b1caf9c526b7b04$var$Readable.prototype._undestroy = $jxsg7.undestroy;
$1b1caf9c526b7b04$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1b1caf9c526b7b04$var$Readable.prototype[$1b1caf9c526b7b04$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$1b1caf9c526b7b04$var$Readable.prototype[$1b1caf9c526b7b04$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $1b1caf9c526b7b04$var$AbortError();
        this.destroy(error);
    }
    return new $1b1caf9c526b7b04$var$Promise(function(resolve, reject) {
        return $iuCMz(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$1b1caf9c526b7b04$var$Readable.prototype.push = function(chunk, encoding) {
    return $1b1caf9c526b7b04$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$1b1caf9c526b7b04$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $1b1caf9c526b7b04$var$readableAddChunk(this, chunk, encoding, true);
};
function $1b1caf9c526b7b04$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $1b1caf9c526b7b04$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $1b1caf9c526b7b04$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $1b1caf9c526b7b04$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $1b1caf9c526b7b04$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $1b1caf9c526b7b04$require$Buffer) encoding = '';
        else if ($1b1caf9c526b7b04$var$Stream._isUint8Array(chunk)) {
            chunk = $1b1caf9c526b7b04$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $1b1caf9c526b7b04$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $1b1caf9c526b7b04$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$1b1caf9c526b7b04$var$kReading;
        $1b1caf9c526b7b04$var$onEofChunk(stream, state);
    } else if ((state.state & $1b1caf9c526b7b04$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $1b1caf9c526b7b04$var$kEndEmitted) !== 0) $1b1caf9c526b7b04$var$errorOrDestroy(stream, new $1b1caf9c526b7b04$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $1b1caf9c526b7b04$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $1b1caf9c526b7b04$var$errorOrDestroy(stream, new $1b1caf9c526b7b04$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$1b1caf9c526b7b04$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $1b1caf9c526b7b04$var$addChunk(stream, state, chunk, false);
                else $1b1caf9c526b7b04$var$maybeReadMore(stream, state);
            } else $1b1caf9c526b7b04$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$1b1caf9c526b7b04$var$kReading;
        $1b1caf9c526b7b04$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $1b1caf9c526b7b04$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $1b1caf9c526b7b04$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $1b1caf9c526b7b04$var$kNeedReadable) !== 0) $1b1caf9c526b7b04$var$emitReadable(stream);
    }
    $1b1caf9c526b7b04$var$maybeReadMore(stream, state);
}
$1b1caf9c526b7b04$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$1b1caf9c526b7b04$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$1b1caf9c526b7b04$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $1b1caf9c526b7b04$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$1b1caf9c526b7b04$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $1b1caf9c526b7b04$var$MAX_HWM = 0x40000000;
function $1b1caf9c526b7b04$var$computeNewHighWaterMark(n) {
    if (n > $1b1caf9c526b7b04$var$MAX_HWM) throw new $1b1caf9c526b7b04$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1b1caf9c526b7b04$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $1b1caf9c526b7b04$var$kObjectMode) !== 0) return 1;
    if ($1b1caf9c526b7b04$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$1b1caf9c526b7b04$var$Readable.prototype.read = function(n) {
    $1b1caf9c526b7b04$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$1b1caf9c526b7b04$var$NumberIsInteger(n)) n = $1b1caf9c526b7b04$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $1b1caf9c526b7b04$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$1b1caf9c526b7b04$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $1b1caf9c526b7b04$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $1b1caf9c526b7b04$var$endReadable(this);
        else $1b1caf9c526b7b04$var$emitReadable(this);
        return null;
    }
    n = $1b1caf9c526b7b04$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $1b1caf9c526b7b04$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $1b1caf9c526b7b04$var$kNeedReadable) !== 0;
    $1b1caf9c526b7b04$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $1b1caf9c526b7b04$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $1b1caf9c526b7b04$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $1b1caf9c526b7b04$var$debug('do read');
        state.state |= $1b1caf9c526b7b04$var$kReading | $1b1caf9c526b7b04$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $1b1caf9c526b7b04$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $1b1caf9c526b7b04$var$errorOrDestroy(this, err);
        }
        state.state &= ~$1b1caf9c526b7b04$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $1b1caf9c526b7b04$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $1b1caf9c526b7b04$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $1b1caf9c526b7b04$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $1b1caf9c526b7b04$var$onEofChunk(stream, state) {
    $1b1caf9c526b7b04$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $1b1caf9c526b7b04$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $1b1caf9c526b7b04$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $1b1caf9c526b7b04$var$emitReadable(stream) {
    var state = stream._readableState;
    $1b1caf9c526b7b04$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $1b1caf9c526b7b04$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($1b1caf9c526b7b04$var$emitReadable_, stream);
    }
}
function $1b1caf9c526b7b04$var$emitReadable_(stream) {
    var state = stream._readableState;
    $1b1caf9c526b7b04$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $1b1caf9c526b7b04$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $1b1caf9c526b7b04$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($1b1caf9c526b7b04$var$maybeReadMore_, stream, state);
    }
}
function $1b1caf9c526b7b04$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $1b1caf9c526b7b04$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$1b1caf9c526b7b04$var$Readable.prototype._read = function(n) {
    throw new $1b1caf9c526b7b04$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$1b1caf9c526b7b04$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $1b1caf9c526b7b04$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $1b1caf9c526b7b04$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $1b1caf9c526b7b04$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $1b1caf9c526b7b04$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $1b1caf9c526b7b04$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $1b1caf9c526b7b04$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $1b1caf9c526b7b04$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $1b1caf9c526b7b04$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $1b1caf9c526b7b04$var$debug('ondata');
        var ret = dest.write(chunk);
        $1b1caf9c526b7b04$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $1b1caf9c526b7b04$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $1b1caf9c526b7b04$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $1b1caf9c526b7b04$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $1b1caf9c526b7b04$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $1b1caf9c526b7b04$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $1b1caf9c526b7b04$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $1b1caf9c526b7b04$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $1b1caf9c526b7b04$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $1b1caf9c526b7b04$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$1b1caf9c526b7b04$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $1b1caf9c526b7b04$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$1b1caf9c526b7b04$var$Readable.prototype.on = function(ev, fn) {
    var res = $1b1caf9c526b7b04$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $1b1caf9c526b7b04$var$debug('on readable', state.length, state.reading);
            if (state.length) $1b1caf9c526b7b04$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($1b1caf9c526b7b04$var$nReadingNextTick, this);
        }
    }
    return res;
};
$1b1caf9c526b7b04$var$Readable.prototype.addListener = $1b1caf9c526b7b04$var$Readable.prototype.on;
$1b1caf9c526b7b04$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $1b1caf9c526b7b04$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($1b1caf9c526b7b04$var$updateReadableListening, this);
    return res;
};
$1b1caf9c526b7b04$var$Readable.prototype.off = $1b1caf9c526b7b04$var$Readable.prototype.removeListener;
$1b1caf9c526b7b04$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $1b1caf9c526b7b04$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($1b1caf9c526b7b04$var$updateReadableListening, this);
    return res;
};
function $1b1caf9c526b7b04$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$1b1caf9c526b7b04$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $1b1caf9c526b7b04$var$nReadingNextTick(self) {
    $1b1caf9c526b7b04$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$1b1caf9c526b7b04$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $1b1caf9c526b7b04$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $1b1caf9c526b7b04$var$resume(this, state);
    }
    state[$1b1caf9c526b7b04$var$kPaused] = false;
    return this;
};
function $1b1caf9c526b7b04$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($1b1caf9c526b7b04$var$resume_, stream, state);
    }
}
function $1b1caf9c526b7b04$var$resume_(stream, state) {
    $1b1caf9c526b7b04$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $1b1caf9c526b7b04$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$1b1caf9c526b7b04$var$Readable.prototype.pause = function() {
    $1b1caf9c526b7b04$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $1b1caf9c526b7b04$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$1b1caf9c526b7b04$var$kPaused] = true;
    return this;
};
function $1b1caf9c526b7b04$var$flow(stream) {
    var state = stream._readableState;
    $1b1caf9c526b7b04$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$1b1caf9c526b7b04$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $1b1caf9c526b7b04$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $1b1caf9c526b7b04$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$1b1caf9c526b7b04$var$Readable.prototype[$1b1caf9c526b7b04$var$SymbolAsyncIterator] = function() {
    return $1b1caf9c526b7b04$var$streamToAsyncIterator(this);
};
$1b1caf9c526b7b04$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $1b1caf9c526b7b04$require$validateObject(options, 'options');
    return $1b1caf9c526b7b04$var$streamToAsyncIterator(this, options);
};
function $1b1caf9c526b7b04$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $1b1caf9c526b7b04$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $1b1caf9c526b7b04$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $1b1caf9c526b7b04$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $1b1caf9c526b7b04$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $1b1caf9c526b7b04$var$nop;
                    stream.on('readable', next);
                    cleanup = $iuCMz(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $1b1caf9c526b7b04$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $1b1caf9c526b7b04$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $1b1caf9c526b7b04$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $1b1caf9c526b7b04$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $jxsg7.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$1b1caf9c526b7b04$var$ObjectDefineProperties($1b1caf9c526b7b04$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$1b1caf9c526b7b04$var$ObjectDefineProperties($1b1caf9c526b7b04$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$1b1caf9c526b7b04$var$kPaused] !== false;
        },
        set: function(value) {
            this[$1b1caf9c526b7b04$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$1b1caf9c526b7b04$var$Readable._fromList = $1b1caf9c526b7b04$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1b1caf9c526b7b04$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $1b1caf9c526b7b04$var$endReadable(stream) {
    var state = stream._readableState;
    $1b1caf9c526b7b04$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($1b1caf9c526b7b04$var$endReadableNT, state, stream);
    }
}
function $1b1caf9c526b7b04$var$endReadableNT(state, stream) {
    $1b1caf9c526b7b04$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($1b1caf9c526b7b04$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $1b1caf9c526b7b04$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$1b1caf9c526b7b04$var$Readable.from = function(iterable, opts) {
    return $fajtH($1b1caf9c526b7b04$var$Readable, iterable, opts);
};
var $1b1caf9c526b7b04$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1b1caf9c526b7b04$var$lazyWebStreams() {
    if ($1b1caf9c526b7b04$var$webStreamsAdapters === undefined) $1b1caf9c526b7b04$var$webStreamsAdapters = {};
    return $1b1caf9c526b7b04$var$webStreamsAdapters;
}
$1b1caf9c526b7b04$var$Readable.fromWeb = function(readableStream, options) {
    return $1b1caf9c526b7b04$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$1b1caf9c526b7b04$var$Readable.toWeb = function(streamReadable, options) {
    return $1b1caf9c526b7b04$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$1b1caf9c526b7b04$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $1b1caf9c526b7b04$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $jxsg7.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("d5bgu", function(module, exports) {
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $98647af57cbf1eed$var$ArrayIsArray = $83Xfu.ArrayIsArray, $98647af57cbf1eed$var$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $98647af57cbf1eed$var$EE = $bBoAO.EventEmitter;
function $98647af57cbf1eed$var$Stream(opts) {
    $98647af57cbf1eed$var$EE.call(this, opts);
}
$98647af57cbf1eed$var$ObjectSetPrototypeOf($98647af57cbf1eed$var$Stream.prototype, $98647af57cbf1eed$var$EE.prototype);
$98647af57cbf1eed$var$ObjectSetPrototypeOf($98647af57cbf1eed$var$Stream, $98647af57cbf1eed$var$EE);
$98647af57cbf1eed$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($98647af57cbf1eed$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $98647af57cbf1eed$var$prependListener(source, 'error', onerror);
    $98647af57cbf1eed$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $98647af57cbf1eed$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($98647af57cbf1eed$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $98647af57cbf1eed$var$Stream,
    prependListener: $98647af57cbf1eed$var$prependListener
};

});

parcelRegister("7HqJd", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $59b14837d45f0963$export$e2db56ee53255a0; }, function (v) { return $59b14837d45f0963$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $59b14837d45f0963$export$11956e9313f43de0; }, function (v) { return $59b14837d45f0963$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $59b14837d45f0963$export$e2db56ee53255a0;
var $59b14837d45f0963$export$11956e9313f43de0;
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $59b14837d45f0963$require$SymbolDispose = $83Xfu.SymbolDispose;

var $bnTha = parcelRequire("bnTha");
var $59b14837d45f0963$var$AbortError = $bnTha.AbortError, $59b14837d45f0963$var$codes = $bnTha.codes;

var $4yxjC = parcelRequire("4yxjC");
var $59b14837d45f0963$var$isNodeStream = $4yxjC.isNodeStream, $59b14837d45f0963$var$isWebStream = $4yxjC.isWebStream, $59b14837d45f0963$var$kControllerErrorFunction = $4yxjC.kControllerErrorFunction;

var $iuCMz = parcelRequire("iuCMz");
var $59b14837d45f0963$var$ERR_INVALID_ARG_TYPE = $59b14837d45f0963$var$codes.ERR_INVALID_ARG_TYPE;
var $59b14837d45f0963$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $59b14837d45f0963$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $59b14837d45f0963$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$59b14837d45f0963$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $59b14837d45f0963$var$validateAbortSignal(signal, 'signal');
    if (!$59b14837d45f0963$var$isNodeStream(stream) && !$59b14837d45f0963$var$isWebStream(stream)) throw new $59b14837d45f0963$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $59b14837d45f0963$export$11956e9313f43de0(signal, stream);
};

$59b14837d45f0963$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $59b14837d45f0963$var$isNodeStream(stream) ? function() {
        stream.destroy(new $59b14837d45f0963$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$59b14837d45f0963$var$kControllerErrorFunction](new $59b14837d45f0963$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $59b14837d45f0963$var$addAbortListener = $59b14837d45f0963$var$addAbortListener || (parcelRequire("imWI3")).addAbortListener;
        var disposable = $59b14837d45f0963$var$addAbortListener(signal, onAbort);
        $iuCMz(stream, disposable[$59b14837d45f0963$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("7M9oH", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $5a944e3917308233$var$StringPrototypeSlice = $83Xfu.StringPrototypeSlice, $5a944e3917308233$var$SymbolIterator = $83Xfu.SymbolIterator, $5a944e3917308233$var$TypedArrayPrototypeSet = $83Xfu.TypedArrayPrototypeSet, $5a944e3917308233$var$Uint8Array = $83Xfu.Uint8Array;

var $6JBOZ = parcelRequire("6JBOZ");
var $5a944e3917308233$require$Buffer = $6JBOZ.Buffer;

var $imWI3 = parcelRequire("imWI3");
var $5a944e3917308233$require$inspect = $imWI3.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $5a944e3917308233$require$Buffer.alloc(0);
                var ret = $5a944e3917308233$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $5a944e3917308233$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $5a944e3917308233$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $5a944e3917308233$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $5a944e3917308233$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $5a944e3917308233$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $5a944e3917308233$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $5a944e3917308233$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $5a944e3917308233$var$TypedArrayPrototypeSet(ret, new $5a944e3917308233$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $5a944e3917308233$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("hgv2A", function(module, exports) {
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $c91c0250d91ca339$var$MathFloor = $83Xfu.MathFloor, $c91c0250d91ca339$var$NumberIsInteger = $83Xfu.NumberIsInteger;

var $6Vqqj = parcelRequire("6Vqqj");
var $c91c0250d91ca339$require$validateInteger = $6Vqqj.validateInteger;

var $c91c0250d91ca339$var$ERR_INVALID_ARG_VALUE = (parcelRequire("bnTha")).codes.ERR_INVALID_ARG_VALUE;
var $c91c0250d91ca339$var$defaultHighWaterMarkBytes = 16384;
var $c91c0250d91ca339$var$defaultHighWaterMarkObjectMode = 16;
function $c91c0250d91ca339$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c91c0250d91ca339$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $c91c0250d91ca339$var$defaultHighWaterMarkObjectMode : $c91c0250d91ca339$var$defaultHighWaterMarkBytes;
}
function $c91c0250d91ca339$var$setDefaultHighWaterMark(objectMode, value) {
    $c91c0250d91ca339$require$validateInteger(value, 'value', 0);
    if (objectMode) $c91c0250d91ca339$var$defaultHighWaterMarkObjectMode = value;
    else $c91c0250d91ca339$var$defaultHighWaterMarkBytes = value;
}
function $c91c0250d91ca339$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c91c0250d91ca339$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$c91c0250d91ca339$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $c91c0250d91ca339$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $c91c0250d91ca339$var$MathFloor(hwm);
    }
    // Default value
    return $c91c0250d91ca339$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $c91c0250d91ca339$var$getHighWaterMark,
    getDefaultHighWaterMark: $c91c0250d91ca339$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $c91c0250d91ca339$var$setDefaultHighWaterMark
};

});

parcelRegister("fajtH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $83Xfu = parcelRequire("83Xfu");
/* replacement end */ var $b0a6e62076869725$var$PromisePrototypeThen = $83Xfu.PromisePrototypeThen, $b0a6e62076869725$var$SymbolAsyncIterator = $83Xfu.SymbolAsyncIterator, $b0a6e62076869725$var$SymbolIterator = $83Xfu.SymbolIterator;

var $6JBOZ = parcelRequire("6JBOZ");
var $b0a6e62076869725$require$Buffer = $6JBOZ.Buffer;

var $bnTha = parcelRequire("bnTha");
var $b0a6e62076869725$require$_require_codes = $bnTha.codes;
var $b0a6e62076869725$var$ERR_INVALID_ARG_TYPE = $b0a6e62076869725$require$_require_codes.ERR_INVALID_ARG_TYPE, $b0a6e62076869725$var$ERR_STREAM_NULL_VALUES = $b0a6e62076869725$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $b0a6e62076869725$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $b0a6e62076869725$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$b0a6e62076869725$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$b0a6e62076869725$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$b0a6e62076869725$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$b0a6e62076869725$var$SymbolIterator]();
    } else throw new $b0a6e62076869725$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $b0a6e62076869725$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $b0a6e62076869725$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $b0a6e62076869725$var$from;

});


parcelRegister("lRXk3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $83Xfu = parcelRequire("83Xfu");
/* replacement end */ var $febc906de48be365$var$ArrayPrototypeSlice = $83Xfu.ArrayPrototypeSlice, $febc906de48be365$var$Error = $83Xfu.Error, $febc906de48be365$var$FunctionPrototypeSymbolHasInstance = $83Xfu.FunctionPrototypeSymbolHasInstance, $febc906de48be365$var$ObjectDefineProperty = $83Xfu.ObjectDefineProperty, $febc906de48be365$var$ObjectDefineProperties = $83Xfu.ObjectDefineProperties, $febc906de48be365$var$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf, $febc906de48be365$var$StringPrototypeToLowerCase = $83Xfu.StringPrototypeToLowerCase, $febc906de48be365$var$Symbol = $83Xfu.Symbol, $febc906de48be365$var$SymbolHasInstance = $83Xfu.SymbolHasInstance;
module.exports = $febc906de48be365$var$Writable;
$febc906de48be365$var$Writable.WritableState = $febc906de48be365$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $febc906de48be365$var$EE = $bBoAO.EventEmitter;

var $d5bgu = parcelRequire("d5bgu");
var $febc906de48be365$require$Stream = $d5bgu.Stream;

var $6JBOZ = parcelRequire("6JBOZ");
var $febc906de48be365$require$Buffer = $6JBOZ.Buffer;

var $jxsg7 = parcelRequire("jxsg7");

var $7HqJd = parcelRequire("7HqJd");
var $febc906de48be365$require$addAbortSignal = $7HqJd.addAbortSignal;

var $hgv2A = parcelRequire("hgv2A");
var $febc906de48be365$var$getHighWaterMark = $hgv2A.getHighWaterMark, $febc906de48be365$var$getDefaultHighWaterMark = $hgv2A.getDefaultHighWaterMark;

var $bnTha = parcelRequire("bnTha");
var $febc906de48be365$require$_require_codes = $bnTha.codes;
var $febc906de48be365$var$ERR_INVALID_ARG_TYPE = $febc906de48be365$require$_require_codes.ERR_INVALID_ARG_TYPE, $febc906de48be365$var$ERR_METHOD_NOT_IMPLEMENTED = $febc906de48be365$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $febc906de48be365$var$ERR_MULTIPLE_CALLBACK = $febc906de48be365$require$_require_codes.ERR_MULTIPLE_CALLBACK, $febc906de48be365$var$ERR_STREAM_CANNOT_PIPE = $febc906de48be365$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $febc906de48be365$var$ERR_STREAM_DESTROYED = $febc906de48be365$require$_require_codes.ERR_STREAM_DESTROYED, $febc906de48be365$var$ERR_STREAM_ALREADY_FINISHED = $febc906de48be365$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $febc906de48be365$var$ERR_STREAM_NULL_VALUES = $febc906de48be365$require$_require_codes.ERR_STREAM_NULL_VALUES, $febc906de48be365$var$ERR_STREAM_WRITE_AFTER_END = $febc906de48be365$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $febc906de48be365$var$ERR_UNKNOWN_ENCODING = $febc906de48be365$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $febc906de48be365$var$errorOrDestroy = $jxsg7.errorOrDestroy;
$febc906de48be365$var$ObjectSetPrototypeOf($febc906de48be365$var$Writable.prototype, $febc906de48be365$require$Stream.prototype);
$febc906de48be365$var$ObjectSetPrototypeOf($febc906de48be365$var$Writable, $febc906de48be365$require$Stream);
function $febc906de48be365$var$nop() {}
var $febc906de48be365$var$kOnFinished = $febc906de48be365$var$Symbol('kOnFinished');

function $febc906de48be365$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("a0xaf"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $febc906de48be365$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $febc906de48be365$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $febc906de48be365$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $febc906de48be365$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$febc906de48be365$var$kOnFinished] = [];
}
function $febc906de48be365$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$febc906de48be365$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $febc906de48be365$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$febc906de48be365$var$ObjectDefineProperty($febc906de48be365$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $febc906de48be365$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("a0xaf"));
    if (!isDuplex && !$febc906de48be365$var$FunctionPrototypeSymbolHasInstance($febc906de48be365$var$Writable, this)) return new $febc906de48be365$var$Writable(options);
    this._writableState = new $febc906de48be365$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $febc906de48be365$require$addAbortSignal(options.signal, this);
    }
    $febc906de48be365$require$Stream.call(this, options);
    $jxsg7.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $febc906de48be365$var$clearBuffer(_this, state);
        $febc906de48be365$var$finishMaybe(_this, state);
    });
}
$febc906de48be365$var$ObjectDefineProperty($febc906de48be365$var$Writable, $febc906de48be365$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($febc906de48be365$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $febc906de48be365$var$Writable) return false;
        return object && object._writableState instanceof $febc906de48be365$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$febc906de48be365$var$Writable.prototype.pipe = function() {
    $febc906de48be365$var$errorOrDestroy(this, new $febc906de48be365$var$ERR_STREAM_CANNOT_PIPE());
};
function $febc906de48be365$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$febc906de48be365$require$Buffer.isEncoding(encoding)) throw new $febc906de48be365$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $febc906de48be365$var$nop;
    }
    if (chunk === null) throw new $febc906de48be365$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $febc906de48be365$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $febc906de48be365$require$Buffer) encoding = 'buffer';
        else if ($febc906de48be365$require$Stream._isUint8Array(chunk)) {
            chunk = $febc906de48be365$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $febc906de48be365$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $febc906de48be365$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $febc906de48be365$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $febc906de48be365$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $febc906de48be365$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$febc906de48be365$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $febc906de48be365$var$_write(this, chunk, encoding, cb) === true;
};
$febc906de48be365$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$febc906de48be365$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $febc906de48be365$var$clearBuffer(this, state);
    }
};
$febc906de48be365$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $febc906de48be365$var$StringPrototypeToLowerCase(encoding);
    if (!$febc906de48be365$require$Buffer.isEncoding(encoding)) throw new $febc906de48be365$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $febc906de48be365$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $febc906de48be365$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $febc906de48be365$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $febc906de48be365$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $febc906de48be365$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $febc906de48be365$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $febc906de48be365$var$errorOrDestroy(stream, er);
}
function $febc906de48be365$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $febc906de48be365$var$errorOrDestroy(stream, new $febc906de48be365$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($febc906de48be365$var$onwriteError, stream, state, er, cb);
        else $febc906de48be365$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $febc906de48be365$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($febc906de48be365$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $febc906de48be365$var$afterWrite(stream, state, 1, cb);
    }
}
function $febc906de48be365$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $febc906de48be365$var$afterWrite(stream, state, count, cb);
}
function $febc906de48be365$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $febc906de48be365$var$errorBuffer(state);
    $febc906de48be365$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $febc906de48be365$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $febc906de48be365$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$febc906de48be365$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $febc906de48be365$var$ERR_STREAM_DESTROYED('end'));
    }
    $febc906de48be365$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $febc906de48be365$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $febc906de48be365$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $febc906de48be365$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $febc906de48be365$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $febc906de48be365$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $febc906de48be365$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $febc906de48be365$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$febc906de48be365$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $febc906de48be365$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$febc906de48be365$var$Writable.prototype._writev = null;
$febc906de48be365$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $febc906de48be365$var$_write(this, chunk, encoding);
        if (ret instanceof $febc906de48be365$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $febc906de48be365$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $febc906de48be365$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $febc906de48be365$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$febc906de48be365$var$kOnFinished].push(cb);
    }
    return this;
};
function $febc906de48be365$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $febc906de48be365$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $febc906de48be365$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $febc906de48be365$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$febc906de48be365$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $febc906de48be365$var$errorOrDestroy(stream, err, state.sync);
        } else if ($febc906de48be365$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($febc906de48be365$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $febc906de48be365$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $febc906de48be365$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $febc906de48be365$var$finishMaybe(stream, state, sync) {
    if ($febc906de48be365$var$needFinish(state)) {
        $febc906de48be365$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($febc906de48be365$var$needFinish(state)) $febc906de48be365$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($febc906de48be365$var$needFinish(state)) {
                state.pendingcb++;
                $febc906de48be365$var$finish(stream, state);
            }
        }
    }
}
function $febc906de48be365$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$febc906de48be365$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$febc906de48be365$var$ObjectDefineProperties($febc906de48be365$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $febc906de48be365$var$destroy = $jxsg7.destroy;
$febc906de48be365$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$febc906de48be365$var$kOnFinished].length)) $2Qkr5.nextTick($febc906de48be365$var$errorBuffer, state);
    $febc906de48be365$var$destroy.call(this, err, cb);
    return this;
};
$febc906de48be365$var$Writable.prototype._undestroy = $jxsg7.undestroy;
$febc906de48be365$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$febc906de48be365$var$Writable.prototype[$febc906de48be365$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $febc906de48be365$var$webStreamsAdapters;
// Lazy to avoid circular references
function $febc906de48be365$var$lazyWebStreams() {
    if ($febc906de48be365$var$webStreamsAdapters === undefined) $febc906de48be365$var$webStreamsAdapters = {};
    return $febc906de48be365$var$webStreamsAdapters;
}
$febc906de48be365$var$Writable.fromWeb = function(writableStream, options) {
    return $febc906de48be365$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$febc906de48be365$var$Writable.toWeb = function(streamWritable) {
    return $febc906de48be365$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("4xizM", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $6JBOZ = parcelRequire("6JBOZ");

var $4yxjC = parcelRequire("4yxjC");
var $34d8a74d287b3bc4$var$isReadable = $4yxjC.isReadable, $34d8a74d287b3bc4$var$isWritable = $4yxjC.isWritable, $34d8a74d287b3bc4$var$isIterable = $4yxjC.isIterable, $34d8a74d287b3bc4$var$isNodeStream = $4yxjC.isNodeStream, $34d8a74d287b3bc4$var$isReadableNodeStream = $4yxjC.isReadableNodeStream, $34d8a74d287b3bc4$var$isWritableNodeStream = $4yxjC.isWritableNodeStream, $34d8a74d287b3bc4$var$isDuplexNodeStream = $4yxjC.isDuplexNodeStream, $34d8a74d287b3bc4$var$isReadableStream = $4yxjC.isReadableStream, $34d8a74d287b3bc4$var$isWritableStream = $4yxjC.isWritableStream;

var $iuCMz = parcelRequire("iuCMz");

var $bnTha = parcelRequire("bnTha");
var $34d8a74d287b3bc4$var$AbortError = $bnTha.AbortError, $34d8a74d287b3bc4$var$_require_codes = $bnTha.codes, $34d8a74d287b3bc4$var$ERR_INVALID_ARG_TYPE = $34d8a74d287b3bc4$var$_require_codes.ERR_INVALID_ARG_TYPE, $34d8a74d287b3bc4$var$ERR_INVALID_RETURN_VALUE = $34d8a74d287b3bc4$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $jxsg7 = parcelRequire("jxsg7");
var $34d8a74d287b3bc4$require$destroyer = $jxsg7.destroyer;

var $a0xaf = parcelRequire("a0xaf");

var $2kjDT = parcelRequire("2kjDT");

var $lRXk3 = parcelRequire("lRXk3");

var $imWI3 = parcelRequire("imWI3");
var $34d8a74d287b3bc4$require$createDeferredPromise = $imWI3.createDeferredPromise;

var $fajtH = parcelRequire("fajtH");
var $34d8a74d287b3bc4$var$Blob = globalThis.Blob || $6JBOZ.Blob;
var $34d8a74d287b3bc4$var$isBlob = typeof $34d8a74d287b3bc4$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $34d8a74d287b3bc4$var$Blob;
} : function isBlob(b) {
    return false;
};

var $34d8a74d287b3bc4$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $83Xfu = parcelRequire("83Xfu");
var $34d8a74d287b3bc4$require$FunctionPrototypeCall = $83Xfu.FunctionPrototypeCall;
// This is needed for pre node 17.
var $34d8a74d287b3bc4$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($a0xaf);
module.exports = function duplexify(body, name) {
    if ($34d8a74d287b3bc4$var$isDuplexNodeStream(body)) return body;
    if ($34d8a74d287b3bc4$var$isReadableNodeStream(body)) return $34d8a74d287b3bc4$var$_duplexify({
        readable: body
    });
    if ($34d8a74d287b3bc4$var$isWritableNodeStream(body)) return $34d8a74d287b3bc4$var$_duplexify({
        writable: body
    });
    if ($34d8a74d287b3bc4$var$isNodeStream(body)) return $34d8a74d287b3bc4$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($34d8a74d287b3bc4$var$isReadableStream(body)) return $34d8a74d287b3bc4$var$_duplexify({
        readable: $2kjDT.fromWeb(body)
    });
    if ($34d8a74d287b3bc4$var$isWritableStream(body)) return $34d8a74d287b3bc4$var$_duplexify({
        writable: $lRXk3.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $34d8a74d287b3bc4$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($34d8a74d287b3bc4$var$isIterable(value)) return $fajtH($34d8a74d287b3bc4$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $34d8a74d287b3bc4$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $34d8a74d287b3bc4$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $34d8a74d287b3bc4$require$destroyer(d, err);
            });
            return d = new $34d8a74d287b3bc4$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $34d8a74d287b3bc4$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($34d8a74d287b3bc4$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($34d8a74d287b3bc4$var$isIterable(body)) return $fajtH($34d8a74d287b3bc4$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($34d8a74d287b3bc4$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $34d8a74d287b3bc4$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $34d8a74d287b3bc4$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $34d8a74d287b3bc4$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $34d8a74d287b3bc4$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $34d8a74d287b3bc4$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $34d8a74d287b3bc4$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $34d8a74d287b3bc4$require$destroyer(d1, err);
        });
        return d1 = new $34d8a74d287b3bc4$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $34d8a74d287b3bc4$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $34d8a74d287b3bc4$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $34d8a74d287b3bc4$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $34d8a74d287b3bc4$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $34d8a74d287b3bc4$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $34d8a74d287b3bc4$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $34d8a74d287b3bc4$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $2kjDT.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$34d8a74d287b3bc4$var$isReadable(r);
    var writable = !!$34d8a74d287b3bc4$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $34d8a74d287b3bc4$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $iuCMz(w, function(err) {
            writable = false;
            if (err) $34d8a74d287b3bc4$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $iuCMz(r, function(err) {
            readable = false;
            if (err) $34d8a74d287b3bc4$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $34d8a74d287b3bc4$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $34d8a74d287b3bc4$require$destroyer(w, err);
            $34d8a74d287b3bc4$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("htMxd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $cb9acb19a106ead5$require$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf;
module.exports = $cb9acb19a106ead5$var$PassThrough;

var $bYntR = parcelRequire("bYntR");
$cb9acb19a106ead5$require$ObjectSetPrototypeOf($cb9acb19a106ead5$var$PassThrough.prototype, $bYntR.prototype);
$cb9acb19a106ead5$require$ObjectSetPrototypeOf($cb9acb19a106ead5$var$PassThrough, $bYntR);
function $cb9acb19a106ead5$var$PassThrough(options) {
    if (!(this instanceof $cb9acb19a106ead5$var$PassThrough)) return new $cb9acb19a106ead5$var$PassThrough(options);
    $bYntR.call(this, options);
}
$cb9acb19a106ead5$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("bYntR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $8b7783115a52fc88$var$ObjectSetPrototypeOf = $83Xfu.ObjectSetPrototypeOf, $8b7783115a52fc88$var$Symbol = $83Xfu.Symbol;
module.exports = $8b7783115a52fc88$var$Transform;

var $8b7783115a52fc88$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("bnTha")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $a0xaf = parcelRequire("a0xaf");

var $hgv2A = parcelRequire("hgv2A");
var $8b7783115a52fc88$require$getHighWaterMark = $hgv2A.getHighWaterMark;
$8b7783115a52fc88$var$ObjectSetPrototypeOf($8b7783115a52fc88$var$Transform.prototype, $a0xaf.prototype);
$8b7783115a52fc88$var$ObjectSetPrototypeOf($8b7783115a52fc88$var$Transform, $a0xaf);
var $8b7783115a52fc88$var$kCallback = $8b7783115a52fc88$var$Symbol('kCallback');
function $8b7783115a52fc88$var$Transform(options) {
    if (!(this instanceof $8b7783115a52fc88$var$Transform)) return new $8b7783115a52fc88$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $8b7783115a52fc88$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $a0xaf.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8b7783115a52fc88$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8b7783115a52fc88$var$prefinish);
}
function $8b7783115a52fc88$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8b7783115a52fc88$var$prefinish() {
    if (this._final !== $8b7783115a52fc88$var$_final) $8b7783115a52fc88$var$_final.call(this);
}
$8b7783115a52fc88$var$Transform.prototype._final = $8b7783115a52fc88$var$_final;
$8b7783115a52fc88$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8b7783115a52fc88$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8b7783115a52fc88$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$8b7783115a52fc88$var$kCallback] = callback;
    });
};
$8b7783115a52fc88$var$Transform.prototype._read = function() {
    if (this[$8b7783115a52fc88$var$kCallback]) {
        var callback = this[$8b7783115a52fc88$var$kCallback];
        this[$8b7783115a52fc88$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("aZB9a", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $83Xfu = parcelRequire("83Xfu");
var $800c6a8096eeb6df$var$ArrayPrototypePop = $83Xfu.ArrayPrototypePop, $800c6a8096eeb6df$var$Promise = $83Xfu.Promise;

var $4yxjC = parcelRequire("4yxjC");
var $800c6a8096eeb6df$var$isIterable = $4yxjC.isIterable, $800c6a8096eeb6df$var$isNodeStream = $4yxjC.isNodeStream, $800c6a8096eeb6df$var$isWebStream = $4yxjC.isWebStream;

var $eFsFu = parcelRequire("eFsFu");
var $800c6a8096eeb6df$var$pl = $eFsFu.pipelineImpl;

var $iuCMz = parcelRequire("iuCMz");
var $800c6a8096eeb6df$require$finished = $iuCMz.finished;
parcelRequire("1DnQ8");
function $800c6a8096eeb6df$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $800c6a8096eeb6df$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$800c6a8096eeb6df$var$isNodeStream(lastArg) && !$800c6a8096eeb6df$var$isIterable(lastArg) && !$800c6a8096eeb6df$var$isWebStream(lastArg)) {
            var options = $800c6a8096eeb6df$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $800c6a8096eeb6df$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $800c6a8096eeb6df$require$finished,
    pipeline: $800c6a8096eeb6df$var$pipeline
};

});



parcelRegister("4x0uF", function(module, exports) {
module.exports = JSON.parse("{\"@context\":{\"alternate\":\"http://www.w3.org/1999/xhtml/vocab#alternate\",\"appendix\":\"http://www.w3.org/1999/xhtml/vocab#appendix\",\"cite\":\"http://www.w3.org/1999/xhtml/vocab#cite\",\"bookmark\":\"http://www.w3.org/1999/xhtml/vocab#bookmark\",\"contents\":\"http://www.w3.org/1999/xhtml/vocab#contents\",\"chapter\":\"http://www.w3.org/1999/xhtml/vocab#chapter\",\"copyright\":\"http://www.w3.org/1999/xhtml/vocab#copyright\",\"first\":\"http://www.w3.org/1999/xhtml/vocab#first\",\"glossary\":\"http://www.w3.org/1999/xhtml/vocab#glossary\",\"help\":\"http://www.w3.org/1999/xhtml/vocab#help\",\"icon\":\"http://www.w3.org/1999/xhtml/vocab#icon\",\"index\":\"http://www.w3.org/1999/xhtml/vocab#index\",\"last\":\"http://www.w3.org/1999/xhtml/vocab#last\",\"license\":\"http://www.w3.org/1999/xhtml/vocab#license\",\"meta\":\"http://www.w3.org/1999/xhtml/vocab#meta\",\"next\":\"http://www.w3.org/1999/xhtml/vocab#next\",\"prev\":\"http://www.w3.org/1999/xhtml/vocab#prev\",\"previous\":\"http://www.w3.org/1999/xhtml/vocab#previous\",\"section\":\"http://www.w3.org/1999/xhtml/vocab#section\",\"start\":\"http://www.w3.org/1999/xhtml/vocab#start\",\"stylesheet\":\"http://www.w3.org/1999/xhtml/vocab#stylesheet\",\"subsection\":\"http://www.w3.org/1999/xhtml/vocab#subsection\",\"top\":\"http://www.w3.org/1999/xhtml/vocab#top\",\"up\":\"http://www.w3.org/1999/xhtml/vocab#up\",\"p3pv1\":\"http://www.w3.org/1999/xhtml/vocab#p3pv1\"}}");

});

parcelRegister("aI8sN", function(module, exports) {
module.exports = JSON.parse("{\"@context\":{\"as\":\"https://www.w3.org/ns/activitystreams#\",\"cat\":\"http://www.w3.org/ns/dcat#\",\"cc\":\"http://creativecommons.org/ns#\",\"cnt\":\"http://www.w3.org/2008/content#\",\"csvw\":\"http://www.w3.org/ns/csvw#\",\"ctag\":\"http://commontag.org/ns#\",\"dc\":\"http://purl.org/dc/terms/\",\"dc11\":\"http://purl.org/dc/elements/1.1/\",\"dcat\":\"http://www.w3.org/ns/dcat#\",\"dcterms\":\"http://purl.org/dc/terms/\",\"dqv\":\"http://www.w3.org/ns/dqv#\",\"duv\":\"https://www.w3.org/TR/vocab-duv#\",\"earl\":\"http://www.w3.org/ns/earl#\",\"foaf\":\"http://xmlns.com/foaf/0.1/\",\"gldp\":\"http://www.w3.org/ns/people#\",\"gr\":\"http://purl.org/goodrelations/v1#\",\"grddl\":\"http://www.w3.org/2003/g/data-view#\",\"ht\":\"http://www.w3.org/2006/http#\",\"ical\":\"http://www.w3.org/2002/12/cal/icaltzd#\",\"ldp\":\"http://www.w3.org/ns/ldp#\",\"ma\":\"http://www.w3.org/ns/ma-ont#\",\"oa\":\"http://www.w3.org/ns/oa#\",\"odrl\":\"http://www.w3.org/ns/odrl/2/\",\"og\":\"http://ogp.me/ns#\",\"org\":\"http://www.w3.org/ns/org#\",\"owl\":\"http://www.w3.org/2002/07/owl#\",\"prov\":\"http://www.w3.org/ns/prov#\",\"ptr\":\"http://www.w3.org/2009/pointers#\",\"qb\":\"http://purl.org/linked-data/cube#\",\"rev\":\"http://purl.org/stuff/rev#\",\"rdf\":\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdfa\":\"http://www.w3.org/ns/rdfa#\",\"rdfs\":\"http://www.w3.org/2000/01/rdf-schema#\",\"rif\":\"http://www.w3.org/2007/rif#\",\"rr\":\"http://www.w3.org/ns/r2rml#\",\"schema\":\"http://schema.org/\",\"sd\":\"http://www.w3.org/ns/sparql-service-description#\",\"sioc\":\"http://rdfs.org/sioc/ns#\",\"skos\":\"http://www.w3.org/2004/02/skos/core#\",\"skosxl\":\"http://www.w3.org/2008/05/skos-xl#\",\"ssn\":\"http://www.w3.org/ns/ssn/\",\"sosa\":\"http://www.w3.org/ns/sosa/\",\"time\":\"http://www.w3.org/2006/time#\",\"v\":\"http://rdf.data-vocabulary.org/#\",\"vcard\":\"http://www.w3.org/2006/vcard/ns#\",\"void\":\"http://rdfs.org/ns/void#\",\"wdr\":\"http://www.w3.org/2007/05/powder#\",\"wdrs\":\"http://www.w3.org/2007/05/powder-s#\",\"xhv\":\"http://www.w3.org/1999/xhtml/vocab#\",\"xml\":\"http://www.w3.org/XML/1998/namespace\",\"xsd\":\"http://www.w3.org/2001/XMLSchema#\",\"describedby\":\"http://www.w3.org/2007/05/powder-s#describedby\",\"license\":\"http://www.w3.org/1999/xhtml/vocab#license\",\"role\":\"http://www.w3.org/1999/xhtml/vocab#role\"}}");

});

parcelRegister("ktphf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RDFA_CONTENTTYPES = module.exports.RDFA_FEATURES = void 0;
/**
 * A mapping of RDFa profile to a features object.
 */ // tslint:disable:object-literal-sort-keys
module.exports.RDFA_FEATURES = {
    '': {
        baseTag: true,
        xmlBase: true,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: true,
        roleAttribute: true
    },
    core: {
        baseTag: false,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: false,
        datetimeAttribute: false,
        timeTag: false,
        htmlDatatype: false,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: false
    },
    html: {
        baseTag: true,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: true
    },
    xhtml: {
        baseTag: true,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: true,
        roleAttribute: true
    },
    xml: {
        baseTag: false,
        xmlBase: true,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: false,
        inheritSubjectInHeadBody: false,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: false,
        copyRdfaPatterns: false,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: true
    }
};
// tslint:enable:object-literal-sort-keys
// tslint:disable:object-literal-sort-keys
module.exports.RDFA_CONTENTTYPES = {
    // HTML
    'text/html': 'html',
    // XHTML
    'application/xhtml+xml': 'xhtml',
    // XML
    'application/xml': 'xml',
    'text/xml': 'xml',
    'image/svg+xml': 'xml'
}; // tslint:enable:object-literal-sort-keys

});

parcelRegister("gUL8T", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $ktphf = parcelRequire("ktphf");

var $2ej16 = parcelRequire("2ej16");
/**
 * A collection of utility functions.
 */ var $c50671d021854cfc$var$Util = /*#__PURE__*/ function() {
    function Util(dataFactory, baseIRI) {
        (0, $jGAMp._)(this, Util);
        this.dataFactory = dataFactory || new $2ej16.DataFactory();
        this.baseIRI = this.dataFactory.namedNode(baseIRI || '');
        this.baseIRIDocument = this.baseIRI;
    }
    (0, $byiyg._)(Util, [
        {
            /**
     * Get the base IRI.
     * @param {string} baseIriValue A base IRI value.
     * @return A base IRI named node.
     */ key: "getBaseIRI",
            value: function getBaseIRI(baseIriValue) {
                var href = baseIriValue;
                var fragmentIndex = href.indexOf('#');
                if (fragmentIndex >= 0) href = href.substr(0, fragmentIndex);
                return this.dataFactory.namedNode((0, $hDpjF.resolve)(href, this.baseIRI.value));
            }
        },
        {
            /**
     * If the term is a boolean, return the baseIRI, otherwise return the term as-is.
     * @param {Term | boolean} term A term or boolean, where the boolean indicates the baseIRI.
     * @param {IActiveTag} activeTag An active tag.
     * @returns {Term} A term.
     */ key: "getResourceOrBaseIri",
            value: function getResourceOrBaseIri(term, activeTag) {
                return term === true ? this.getBaseIriTerm(activeTag) : term;
            }
        },
        {
            /**
     * Get the active base IRI as an RDF term.
     * @param {IActiveTag} activeTag The active tag.
     * @return {NamedNode} The base IRI term.
     */ key: "getBaseIriTerm",
            value: function getBaseIriTerm(activeTag) {
                return activeTag.localBaseIRI || this.baseIRI;
            }
        },
        {
            key: "createVocabIris",
            value: function createVocabIris(terms, activeTag, allowTerms, allowBlankNode) {
                var _this = this;
                return terms.split(/\s+/).filter(function(term) {
                    return term && (allowTerms || term.indexOf(':') >= 0);
                }).map(function(property) {
                    return _this.createIri(property, activeTag, true, true, allowBlankNode);
                }).filter(function(term) {
                    return term != null;
                });
            }
        },
        {
            /**
     * Create a new literal node.
     * @param {string} literal The literal value.
     * @param {IActiveTag} activeTag The current active tag.
     * @return {Literal} A new literal node.
     */ key: "createLiteral",
            value: function createLiteral(literal, activeTag) {
                if (activeTag.interpretObjectAsTime && !activeTag.datatype) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Util.TIME_REGEXES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (literal.match(entry.regex)) {
                                activeTag.datatype = this.dataFactory.namedNode(Util.XSD + entry.type);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return this.dataFactory.literal(literal, activeTag.datatype || activeTag.language);
            }
        },
        {
            /**
     * Create a blank node.
     * @returns {BlankNode} A new blank node.
     */ key: "createBlankNode",
            value: function createBlankNode() {
                if (this.blankNodeFactory) return this.blankNodeFactory();
                return this.dataFactory.blankNode();
            }
        },
        {
            key: "createIri",
            value: function createIri(term, activeTag, vocab, allowSafeCurie, allowBlankNode) {
                term = term || '';
                if (!allowSafeCurie) {
                    if (!vocab) term = (0, $hDpjF.resolve)(term, this.getBaseIriTerm(activeTag).value);
                    if (!Util.isValidIri(term)) return null;
                    return this.dataFactory.namedNode(term);
                }
                // Handle strict CURIEs
                if (term.length > 0 && term[0] === '[' && term[term.length - 1] === ']') {
                    term = term.substr(1, term.length - 2);
                    // Strict CURIEs MUST have a prefix separator
                    if (term.indexOf(':') < 0) return null;
                }
                // Handle blank nodes
                if (term.startsWith('_:')) return allowBlankNode ? this.dataFactory.blankNode(term.substr(2) || 'b_identity') : null;
                // Handle vocab IRIs
                if (vocab) {
                    if (activeTag.vocab && term.indexOf(':') < 0) return this.dataFactory.namedNode(activeTag.vocab + term);
                }
                // Handle prefixed IRIs
                var iri = Util.expandPrefixedTerm(term, activeTag);
                // Resolve against baseIRI if in base-mode, or if the term was a prefixed relative IRI
                if (!vocab) iri = (0, $hDpjF.resolve)(iri, this.getBaseIriTerm(activeTag).value);
                else if (term !== iri) iri = (0, $hDpjF.resolve)(iri, this.baseIRIDocument.value);
                if (!Util.isValidIri(iri)) return null;
                return this.dataFactory.namedNode(iri);
            }
        }
    ], [
        {
            key: "parsePrefixes",
            value: /**
     * Retrieve the prefixes of the current tag's attributes.
     * @param {{[p: string]: string}} attributes A tag's attributes.
     * @param {{[p: string]: string}} parentPrefixes The prefixes from the parent tag.
     * @param {boolean} xmlnsPrefixMappings If prefixes should be extracted from xmlnsPrefixMappings.
     * @return {{[p: string]: string}} The new prefixes.
     */ function parsePrefixes(attributes, parentPrefixes, xmlnsPrefixMappings) {
                var additionalPrefixes = {};
                if (xmlnsPrefixMappings) {
                    for(var attribute in attributes)if (attribute.startsWith('xmlns')) additionalPrefixes[attribute.substr(6)] = attributes[attribute];
                }
                if (attributes.prefix || Object.keys(additionalPrefixes).length > 0) {
                    var prefixes = Object.assign(Object.assign({}, parentPrefixes), additionalPrefixes);
                    if (attributes.prefix) {
                        var prefixMatch;
                        // tslint:disable-next-line:no-conditional-assignment
                        while(prefixMatch = Util.PREFIX_REGEX.exec(attributes.prefix))prefixes[prefixMatch[1]] = prefixMatch[2];
                    }
                    return prefixes;
                } else return parentPrefixes;
            }
        },
        {
            key: "expandPrefixedTerm",
            value: /**
     * Expand the given term value based on the given prefixes.
     * @param {string} term A term value.
     * @param {{[p: string]: string}[]} prefixes The available prefixes.
     * @return {string} An expanded URL, or the term as-is.
     */ function expandPrefixedTerm(term, activeTag) {
                // Check if the term is prefixed
                var colonIndex = term.indexOf(':');
                var prefix;
                var local;
                if (colonIndex >= 0) {
                    prefix = term.substr(0, colonIndex);
                    local = term.substr(colonIndex + 1);
                }
                // Expand default namespace
                if (prefix === '') return 'http://www.w3.org/1999/xhtml/vocab#' + local;
                // Try to expand the prefix
                if (prefix) {
                    var prefixElement = activeTag.prefixesAll[prefix];
                    if (prefixElement) return prefixElement + local;
                }
                // Try to expand the term
                if (term) {
                    var expandedTerm = activeTag.prefixesAll[term.toLocaleLowerCase()];
                    if (expandedTerm) return expandedTerm;
                }
                return term;
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Util.IRI_REGEX.test(iri);
            }
        },
        {
            key: "contentTypeToProfile",
            value: /**
     * Determine the RDFa profile from the given content type.
     * Defaults to the default RDFa profile (all features enabled) for unknown content types.
     * @param {string} contentType A content type.
     * @returns {RdfaProfile} An RDFa profile.
     */ function contentTypeToProfile(contentType) {
                return $ktphf.RDFA_CONTENTTYPES[contentType] || '';
            }
        }
    ]);
    return Util;
}();
module.exports.Util = $c50671d021854cfc$var$Util;
$c50671d021854cfc$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$c50671d021854cfc$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$c50671d021854cfc$var$Util.RDFA = 'http://www.w3.org/ns/rdfa#';
$c50671d021854cfc$var$Util.PREFIX_REGEX = /\s*([^:\s]*)*:\s*([^\s]*)*\s*/g;
$c50671d021854cfc$var$Util.TIME_REGEXES = [
    {
        regex: /^-?P([0-9]+Y)?([0-9]+M)?([0-9]+D)?(T([0-9]+H)?([0-9]+M)?([0-9]+(\.[0-9])?S)?)?$/,
        type: 'duration'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]-[0-9][0-9]T[0-9][0-9]:[0-9][0-9]:[0-9][0-9]((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
        type: 'dateTime'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]-[0-9][0-9]Z?$/,
        type: 'date'
    },
    {
        regex: /^[0-9][0-9]:[0-9][0-9]:[0-9][0-9]((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
        type: 'time'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]$/,
        type: 'gYearMonth'
    },
    {
        regex: /^[0-9]+$/,
        type: 'gYear'
    }
];
$c50671d021854cfc$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`]*$/;

});





parcelRegister("1slhB", function(module, exports) {
"use strict";
var $10f8ea55f511cb3c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $10f8ea55f511cb3c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $10f8ea55f511cb3c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$10f8ea55f511cb3c$var$__exportStar((parcelRequire("1oFrr")), module.exports);

});
parcelRegister("1oFrr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseShaclc = void 0;

var $1Nxez = parcelRequire("1Nxez");

var $99iqU = parcelRequire("99iqU");

var $10f60 = parcelRequire("10f60");

var $4l0Zq = parcelRequire("4l0Zq");

var $cuY1y = parcelRequire("cuY1y");
/**
 * A comunica SHACL Compact Syntax RDF Parse Actor.
 */ var $10482dc2accc4aed$var$ActorRdfParseShaclc = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseShaclc, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseShaclc(args) {
        (0, $jGAMp._)(this, ActorRdfParseShaclc);
        return (0, $kzDuW._)(this, ActorRdfParseShaclc, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseShaclc, [
        {
            key: "runHandle",
            value: function runHandle(action, mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _readable, prefixIterator, readable;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        prefixIterator = new $cuY1y.PrefixWrappingIterator(// TODO: pass data factory
                        (0, $99iqU.stringify)(action.data).then(function(str) {
                            var _action_metadata;
                            return (0, $4l0Zq.parse)(str, {
                                extendedSyntax: mediaType === 'text/shaclc-ext',
                                baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI
                            });
                        }));
                        readable = new $10f60.Readable({
                            objectMode: true
                        });
                        prefixIterator.on('prefix', function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (_readable = readable).emit.apply(_readable, [
                                'prefix'
                            ].concat((0, $7WNf6._)(args)));
                        });
                        return [
                            2,
                            {
                                data: readable.wrap(prefixIterator),
                                metadata: {
                                    triples: true
                                }
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseShaclc;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseShaclc = $10482dc2accc4aed$var$ActorRdfParseShaclc;

});
parcelRegister("99iqU", function(module, exports) {

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $6a9340b54a542bba$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringify = $6a9340b54a542bba$var$stringify;

var $3sgrk = parcelRequire("3sgrk");
function $6a9340b54a542bba$var$stringify(ee) {
    return $6a9340b54a542bba$var$__awaiter(this, void 0, void 0, function() {
        var str;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    str = '';
                    ee.on('data', function(chunk) {
                        str += chunk;
                    });
                    return [
                        4,
                        (0, $3sgrk.promisifyEventEmitter)(ee)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        str
                    ];
            }
        });
    });
}

});
parcelRegister("3sgrk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promisifyEventEmitter = void 0;
function $2840bd3863ab9bb3$var$promisifyEventEmitter(event, result) {
    return new Promise(function(resolve, reject) {
        event.on('end', function() {
            return resolve(result);
        });
        event.on('error', reject);
    });
}
module.exports.promisifyEventEmitter = $2840bd3863ab9bb3$var$promisifyEventEmitter;

});


parcelRegister("10f60", function(module, exports) {
'use strict';

var $lRddb = parcelRequire("lRddb");

var $fk2lo = parcelRequire("fk2lo");
var $0bb1803bf8f5c599$var$originalDestroy = $lRddb.Readable.destroy;
module.exports = $lRddb.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $lRddb._uint8ArrayToBuffer;
module.exports._isUint8Array = $lRddb._isUint8Array;
module.exports.isDisturbed = $lRddb.isDisturbed;
module.exports.isErrored = $lRddb.isErrored;
module.exports.isReadable = $lRddb.isReadable;
module.exports.Readable = $lRddb.Readable;
module.exports.Writable = $lRddb.Writable;
module.exports.Duplex = $lRddb.Duplex;
module.exports.Transform = $lRddb.Transform;
module.exports.PassThrough = $lRddb.PassThrough;
module.exports.addAbortSignal = $lRddb.addAbortSignal;
module.exports.finished = $lRddb.finished;
module.exports.destroy = $lRddb.destroy;
module.exports.destroy = $0bb1803bf8f5c599$var$originalDestroy;
module.exports.pipeline = $lRddb.pipeline;
module.exports.compose = $lRddb.compose;
Object.defineProperty($lRddb, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $fk2lo;
    }
});
module.exports.Stream = $lRddb.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("lRddb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $16PNf = parcelRequire("16PNf");
var $fe98cbbeed0e0384$require$Buffer = $16PNf.Buffer;

var $dQoAF = parcelRequire("dQoAF");
/* replacement end */ var $fe98cbbeed0e0384$var$ObjectDefineProperty = $dQoAF.ObjectDefineProperty, $fe98cbbeed0e0384$var$ObjectKeys = $dQoAF.ObjectKeys, $fe98cbbeed0e0384$var$ReflectApply = $dQoAF.ReflectApply;

var $kZ6jV = parcelRequire("kZ6jV");
var $fe98cbbeed0e0384$var$_require_promisify = $kZ6jV.promisify, $fe98cbbeed0e0384$var$customPromisify = $fe98cbbeed0e0384$var$_require_promisify.custom;

var $kFSZl = parcelRequire("kFSZl");
var $fe98cbbeed0e0384$var$streamReturningOperators = $kFSZl.streamReturningOperators, $fe98cbbeed0e0384$var$promiseReturningOperators = $kFSZl.promiseReturningOperators;

var $3bC1q = parcelRequire("3bC1q");
var $fe98cbbeed0e0384$var$ERR_ILLEGAL_CONSTRUCTOR = $3bC1q.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $6tWOT = parcelRequire("6tWOT");

var $5qFLZ = parcelRequire("5qFLZ");
var $fe98cbbeed0e0384$var$setDefaultHighWaterMark = $5qFLZ.setDefaultHighWaterMark, $fe98cbbeed0e0384$var$getDefaultHighWaterMark = $5qFLZ.getDefaultHighWaterMark;

var $1OB2I = parcelRequire("1OB2I");
var $fe98cbbeed0e0384$require$pipeline = $1OB2I.pipeline;

var $5nXCW = parcelRequire("5nXCW");
var $fe98cbbeed0e0384$require$destroyer = $5nXCW.destroyer;

var $2yyE0 = parcelRequire("2yyE0");
var $fe98cbbeed0e0384$var$internalBuffer = {};

var $fk2lo = parcelRequire("fk2lo");

var $14flQ = parcelRequire("14flQ");

var $fe98cbbeed0e0384$var$Stream = module.exports = (parcelRequire("gFxYk")).Stream;
$fe98cbbeed0e0384$var$Stream.isDestroyed = $14flQ.isDestroyed;
$fe98cbbeed0e0384$var$Stream.isDisturbed = $14flQ.isDisturbed;
$fe98cbbeed0e0384$var$Stream.isErrored = $14flQ.isErrored;
$fe98cbbeed0e0384$var$Stream.isReadable = $14flQ.isReadable;
$fe98cbbeed0e0384$var$Stream.isWritable = $14flQ.isWritable;

$fe98cbbeed0e0384$var$Stream.Readable = (parcelRequire("ghfC5"));
var $fe98cbbeed0e0384$var$_iteratorNormalCompletion = true, $fe98cbbeed0e0384$var$_didIteratorError = false, $fe98cbbeed0e0384$var$_iteratorError = undefined;
try {
    for(var $fe98cbbeed0e0384$var$_iterator = $fe98cbbeed0e0384$var$ObjectKeys($fe98cbbeed0e0384$var$streamReturningOperators)[Symbol.iterator](), $fe98cbbeed0e0384$var$_step; !($fe98cbbeed0e0384$var$_iteratorNormalCompletion = ($fe98cbbeed0e0384$var$_step = $fe98cbbeed0e0384$var$_iterator.next()).done); $fe98cbbeed0e0384$var$_iteratorNormalCompletion = true){
        var $fe98cbbeed0e0384$var$key = $fe98cbbeed0e0384$var$_step.value;
        var $fe98cbbeed0e0384$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $fe98cbbeed0e0384$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $fe98cbbeed0e0384$var$Stream.Readable.from($fe98cbbeed0e0384$var$ReflectApply($fe98cbbeed0e0384$var$op, this, args));
        };
        var $fe98cbbeed0e0384$var$op = $fe98cbbeed0e0384$var$streamReturningOperators[$fe98cbbeed0e0384$var$key];
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$fn, 'name', {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$op.name
        });
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$fn, 'length', {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$op.length
        });
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$Stream.Readable.prototype, $fe98cbbeed0e0384$var$key, {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $fe98cbbeed0e0384$var$_didIteratorError = true;
    $fe98cbbeed0e0384$var$_iteratorError = err;
} finally{
    try {
        if (!$fe98cbbeed0e0384$var$_iteratorNormalCompletion && $fe98cbbeed0e0384$var$_iterator["return"] != null) {
            $fe98cbbeed0e0384$var$_iterator["return"]();
        }
    } finally{
        if ($fe98cbbeed0e0384$var$_didIteratorError) {
            throw $fe98cbbeed0e0384$var$_iteratorError;
        }
    }
}
var $fe98cbbeed0e0384$var$_iteratorNormalCompletion1 = true, $fe98cbbeed0e0384$var$_didIteratorError1 = false, $fe98cbbeed0e0384$var$_iteratorError1 = undefined;
try {
    for(var $fe98cbbeed0e0384$var$_iterator1 = $fe98cbbeed0e0384$var$ObjectKeys($fe98cbbeed0e0384$var$promiseReturningOperators)[Symbol.iterator](), $fe98cbbeed0e0384$var$_step1; !($fe98cbbeed0e0384$var$_iteratorNormalCompletion1 = ($fe98cbbeed0e0384$var$_step1 = $fe98cbbeed0e0384$var$_iterator1.next()).done); $fe98cbbeed0e0384$var$_iteratorNormalCompletion1 = true){
        var $fe98cbbeed0e0384$var$key1 = $fe98cbbeed0e0384$var$_step1.value;
        var $fe98cbbeed0e0384$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $fe98cbbeed0e0384$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $fe98cbbeed0e0384$var$ReflectApply($fe98cbbeed0e0384$var$op1, this, args);
        };
        var $fe98cbbeed0e0384$var$op1 = $fe98cbbeed0e0384$var$promiseReturningOperators[$fe98cbbeed0e0384$var$key1];
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$fn1, 'name', {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$op1.name
        });
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$fn1, 'length', {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$op1.length
        });
        $fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$Stream.Readable.prototype, $fe98cbbeed0e0384$var$key1, {
            __proto__: null,
            value: $fe98cbbeed0e0384$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $fe98cbbeed0e0384$var$_didIteratorError1 = true;
    $fe98cbbeed0e0384$var$_iteratorError1 = err;
} finally{
    try {
        if (!$fe98cbbeed0e0384$var$_iteratorNormalCompletion1 && $fe98cbbeed0e0384$var$_iterator1["return"] != null) {
            $fe98cbbeed0e0384$var$_iterator1["return"]();
        }
    } finally{
        if ($fe98cbbeed0e0384$var$_didIteratorError1) {
            throw $fe98cbbeed0e0384$var$_iteratorError1;
        }
    }
}

$fe98cbbeed0e0384$var$Stream.Writable = (parcelRequire("dQ4MS"));

$fe98cbbeed0e0384$var$Stream.Duplex = (parcelRequire("WB9ys"));

$fe98cbbeed0e0384$var$Stream.Transform = (parcelRequire("fFs2u"));

$fe98cbbeed0e0384$var$Stream.PassThrough = (parcelRequire("jLV2p"));
$fe98cbbeed0e0384$var$Stream.pipeline = $fe98cbbeed0e0384$require$pipeline;

var $kGxTp = parcelRequire("kGxTp");
var $fe98cbbeed0e0384$require$addAbortSignal = $kGxTp.addAbortSignal;
$fe98cbbeed0e0384$var$Stream.addAbortSignal = $fe98cbbeed0e0384$require$addAbortSignal;
$fe98cbbeed0e0384$var$Stream.finished = $2yyE0;
$fe98cbbeed0e0384$var$Stream.destroy = $fe98cbbeed0e0384$require$destroyer;
$fe98cbbeed0e0384$var$Stream.compose = $6tWOT;
$fe98cbbeed0e0384$var$Stream.setDefaultHighWaterMark = $fe98cbbeed0e0384$var$setDefaultHighWaterMark;
$fe98cbbeed0e0384$var$Stream.getDefaultHighWaterMark = $fe98cbbeed0e0384$var$getDefaultHighWaterMark;
$fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $fk2lo;
    }
});
$fe98cbbeed0e0384$var$ObjectDefineProperty($fe98cbbeed0e0384$require$pipeline, $fe98cbbeed0e0384$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $fk2lo.pipeline;
    }
});
$fe98cbbeed0e0384$var$ObjectDefineProperty($2yyE0, $fe98cbbeed0e0384$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $fk2lo.finished;
    }
});
// Backwards-compat with node 0.4.x
$fe98cbbeed0e0384$var$Stream.Stream = $fe98cbbeed0e0384$var$Stream;
$fe98cbbeed0e0384$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$fe98cbbeed0e0384$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $fe98cbbeed0e0384$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("16PNf", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $0cee870b504ed59e$export$a143d493d941bafc; }, function (v) { return $0cee870b504ed59e$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $0cee870b504ed59e$export$f99ded8fe4b79145; }, function (v) { return $0cee870b504ed59e$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $0cee870b504ed59e$export$a143d493d941bafc;
var $0cee870b504ed59e$export$e4cf37d7f6fb9e0a;
var $0cee870b504ed59e$export$f99ded8fe4b79145;
var $0cee870b504ed59e$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $0cee870b504ed59e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0cee870b504ed59e$export$a143d493d941bafc = $0cee870b504ed59e$var$Buffer;
$0cee870b504ed59e$export$e4cf37d7f6fb9e0a = $0cee870b504ed59e$var$SlowBuffer;
$0cee870b504ed59e$export$f99ded8fe4b79145 = 50;
var $0cee870b504ed59e$var$K_MAX_LENGTH = 0x7fffffff;
$0cee870b504ed59e$export$599f31c3813fae4d = $0cee870b504ed59e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0cee870b504ed59e$var$Buffer.TYPED_ARRAY_SUPPORT = $0cee870b504ed59e$var$typedArraySupport();
if (!$0cee870b504ed59e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0cee870b504ed59e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0cee870b504ed59e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$0cee870b504ed59e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0cee870b504ed59e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$0cee870b504ed59e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0cee870b504ed59e$var$createBuffer(length) {
    if (length > $0cee870b504ed59e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0cee870b504ed59e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0cee870b504ed59e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0cee870b504ed59e$var$allocUnsafe(arg);
    }
    return $0cee870b504ed59e$var$from(arg, encodingOrOffset, length);
}
$0cee870b504ed59e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0cee870b504ed59e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0cee870b504ed59e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0cee870b504ed59e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($0cee870b504ed59e$var$isInstance(value, ArrayBuffer) || value && $0cee870b504ed59e$var$isInstance(value.buffer, ArrayBuffer)) return $0cee870b504ed59e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0cee870b504ed59e$var$isInstance(value, SharedArrayBuffer) || value && $0cee870b504ed59e$var$isInstance(value.buffer, SharedArrayBuffer))) return $0cee870b504ed59e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0cee870b504ed59e$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $0cee870b504ed59e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0cee870b504ed59e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0cee870b504ed59e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0cee870b504ed59e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0cee870b504ed59e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0cee870b504ed59e$var$Buffer, Uint8Array);
function $0cee870b504ed59e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0cee870b504ed59e$var$alloc(size, fill, encoding) {
    $0cee870b504ed59e$var$assertSize(size);
    if (size <= 0) return $0cee870b504ed59e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0cee870b504ed59e$var$createBuffer(size).fill(fill, encoding) : $0cee870b504ed59e$var$createBuffer(size).fill(fill);
    return $0cee870b504ed59e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0cee870b504ed59e$var$Buffer.alloc = function(size, fill, encoding) {
    return $0cee870b504ed59e$var$alloc(size, fill, encoding);
};
function $0cee870b504ed59e$var$allocUnsafe(size) {
    $0cee870b504ed59e$var$assertSize(size);
    return $0cee870b504ed59e$var$createBuffer(size < 0 ? 0 : $0cee870b504ed59e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0cee870b504ed59e$var$Buffer.allocUnsafe = function(size) {
    return $0cee870b504ed59e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0cee870b504ed59e$var$Buffer.allocUnsafeSlow = function(size) {
    return $0cee870b504ed59e$var$allocUnsafe(size);
};
function $0cee870b504ed59e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0cee870b504ed59e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $0cee870b504ed59e$var$byteLength(string, encoding) | 0;
    var buf = $0cee870b504ed59e$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0cee870b504ed59e$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $0cee870b504ed59e$var$checked(array.length) | 0;
    var buf = $0cee870b504ed59e$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0cee870b504ed59e$var$fromArrayView(arrayView) {
    if ($0cee870b504ed59e$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $0cee870b504ed59e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0cee870b504ed59e$var$fromArrayLike(arrayView);
}
function $0cee870b504ed59e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0cee870b504ed59e$var$Buffer.prototype);
    return buf;
}
function $0cee870b504ed59e$var$fromObject(obj) {
    if ($0cee870b504ed59e$var$Buffer.isBuffer(obj)) {
        var len = $0cee870b504ed59e$var$checked(obj.length) | 0;
        var buf = $0cee870b504ed59e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0cee870b504ed59e$var$numberIsNaN(obj.length)) return $0cee870b504ed59e$var$createBuffer(0);
        return $0cee870b504ed59e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0cee870b504ed59e$var$fromArrayLike(obj.data);
}
function $0cee870b504ed59e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0cee870b504ed59e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0cee870b504ed59e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0cee870b504ed59e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0cee870b504ed59e$var$Buffer.alloc(+length);
}
$0cee870b504ed59e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0cee870b504ed59e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0cee870b504ed59e$var$Buffer.compare = function compare(a, b) {
    if ($0cee870b504ed59e$var$isInstance(a, Uint8Array)) a = $0cee870b504ed59e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0cee870b504ed59e$var$isInstance(b, Uint8Array)) b = $0cee870b504ed59e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0cee870b504ed59e$var$Buffer.isBuffer(a) || !$0cee870b504ed59e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0cee870b504ed59e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0cee870b504ed59e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0cee870b504ed59e$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $0cee870b504ed59e$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($0cee870b504ed59e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0cee870b504ed59e$var$Buffer.isBuffer(buf)) buf = $0cee870b504ed59e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0cee870b504ed59e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0cee870b504ed59e$var$byteLength(string, encoding) {
    if ($0cee870b504ed59e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0cee870b504ed59e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0cee870b504ed59e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0cee870b504ed59e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0cee870b504ed59e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0cee870b504ed59e$var$Buffer.byteLength = $0cee870b504ed59e$var$byteLength;
function $0cee870b504ed59e$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0cee870b504ed59e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0cee870b504ed59e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0cee870b504ed59e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0cee870b504ed59e$var$latin1Slice(this, start, end);
        case 'base64':
            return $0cee870b504ed59e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0cee870b504ed59e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0cee870b504ed59e$var$Buffer.prototype._isBuffer = true;
function $0cee870b504ed59e$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0cee870b504ed59e$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$0cee870b504ed59e$var$swap(this, i, i + 1);
    return this;
};
$0cee870b504ed59e$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $0cee870b504ed59e$var$swap(this, i, i + 3);
        $0cee870b504ed59e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0cee870b504ed59e$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $0cee870b504ed59e$var$swap(this, i, i + 7);
        $0cee870b504ed59e$var$swap(this, i + 1, i + 6);
        $0cee870b504ed59e$var$swap(this, i + 2, i + 5);
        $0cee870b504ed59e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0cee870b504ed59e$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0cee870b504ed59e$var$utf8Slice(this, 0, length);
    return $0cee870b504ed59e$var$slowToString.apply(this, arguments);
};
$0cee870b504ed59e$var$Buffer.prototype.toLocaleString = $0cee870b504ed59e$var$Buffer.prototype.toString;
$0cee870b504ed59e$var$Buffer.prototype.equals = function equals(b) {
    if (!$0cee870b504ed59e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0cee870b504ed59e$var$Buffer.compare(this, b) === 0;
};
$0cee870b504ed59e$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $0cee870b504ed59e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0cee870b504ed59e$var$customInspectSymbol) $0cee870b504ed59e$var$Buffer.prototype[$0cee870b504ed59e$var$customInspectSymbol] = $0cee870b504ed59e$var$Buffer.prototype.inspect;
$0cee870b504ed59e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0cee870b504ed59e$var$isInstance(target, Uint8Array)) target = $0cee870b504ed59e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0cee870b504ed59e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0cee870b504ed59e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0cee870b504ed59e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0cee870b504ed59e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0cee870b504ed59e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0cee870b504ed59e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0cee870b504ed59e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0cee870b504ed59e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0cee870b504ed59e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0cee870b504ed59e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0cee870b504ed59e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0cee870b504ed59e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0cee870b504ed59e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0cee870b504ed59e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0cee870b504ed59e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0cee870b504ed59e$var$utf8Write(buf, string, offset, length) {
    return $0cee870b504ed59e$var$blitBuffer($0cee870b504ed59e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0cee870b504ed59e$var$asciiWrite(buf, string, offset, length) {
    return $0cee870b504ed59e$var$blitBuffer($0cee870b504ed59e$var$asciiToBytes(string), buf, offset, length);
}
function $0cee870b504ed59e$var$base64Write(buf, string, offset, length) {
    return $0cee870b504ed59e$var$blitBuffer($0cee870b504ed59e$var$base64ToBytes(string), buf, offset, length);
}
function $0cee870b504ed59e$var$ucs2Write(buf, string, offset, length) {
    return $0cee870b504ed59e$var$blitBuffer($0cee870b504ed59e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0cee870b504ed59e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0cee870b504ed59e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0cee870b504ed59e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0cee870b504ed59e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0cee870b504ed59e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0cee870b504ed59e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0cee870b504ed59e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0cee870b504ed59e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $0cee870b504ed59e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0cee870b504ed59e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $0cee870b504ed59e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0cee870b504ed59e$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $0cee870b504ed59e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0cee870b504ed59e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0cee870b504ed59e$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0cee870b504ed59e$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0cee870b504ed59e$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $0cee870b504ed59e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0cee870b504ed59e$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0cee870b504ed59e$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0cee870b504ed59e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0cee870b504ed59e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0cee870b504ed59e$var$Buffer.prototype.readUintLE = $0cee870b504ed59e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0cee870b504ed59e$var$Buffer.prototype.readUintBE = $0cee870b504ed59e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0cee870b504ed59e$var$Buffer.prototype.readUint8 = $0cee870b504ed59e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0cee870b504ed59e$var$Buffer.prototype.readUint16LE = $0cee870b504ed59e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0cee870b504ed59e$var$Buffer.prototype.readUint16BE = $0cee870b504ed59e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0cee870b504ed59e$var$Buffer.prototype.readUint32LE = $0cee870b504ed59e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0cee870b504ed59e$var$Buffer.prototype.readUint32BE = $0cee870b504ed59e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0cee870b504ed59e$var$Buffer.prototype.readBigUInt64LE = $0cee870b504ed59e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0cee870b504ed59e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0cee870b504ed59e$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0cee870b504ed59e$var$Buffer.prototype.readBigUInt64BE = $0cee870b504ed59e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0cee870b504ed59e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0cee870b504ed59e$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0cee870b504ed59e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0cee870b504ed59e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0cee870b504ed59e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0cee870b504ed59e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0cee870b504ed59e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0cee870b504ed59e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0cee870b504ed59e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0cee870b504ed59e$var$Buffer.prototype.readBigInt64LE = $0cee870b504ed59e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0cee870b504ed59e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0cee870b504ed59e$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$0cee870b504ed59e$var$Buffer.prototype.readBigInt64BE = $0cee870b504ed59e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0cee870b504ed59e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0cee870b504ed59e$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$0cee870b504ed59e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$0cee870b504ed59e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$0cee870b504ed59e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$0cee870b504ed59e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $0cee870b504ed59e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0cee870b504ed59e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0cee870b504ed59e$var$Buffer.prototype.writeUintLE = $0cee870b504ed59e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0cee870b504ed59e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUintBE = $0cee870b504ed59e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0cee870b504ed59e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUint8 = $0cee870b504ed59e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUint16LE = $0cee870b504ed59e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUint16BE = $0cee870b504ed59e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUint32LE = $0cee870b504ed59e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0cee870b504ed59e$var$Buffer.prototype.writeUint32BE = $0cee870b504ed59e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0cee870b504ed59e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0cee870b504ed59e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0cee870b504ed59e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0cee870b504ed59e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0cee870b504ed59e$var$Buffer.prototype.writeBigUInt64LE = $0cee870b504ed59e$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0cee870b504ed59e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0cee870b504ed59e$var$Buffer.prototype.writeBigUInt64BE = $0cee870b504ed59e$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0cee870b504ed59e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0cee870b504ed59e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0cee870b504ed59e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0cee870b504ed59e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0cee870b504ed59e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0cee870b504ed59e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0cee870b504ed59e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0cee870b504ed59e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0cee870b504ed59e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0cee870b504ed59e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0cee870b504ed59e$var$Buffer.prototype.writeBigInt64LE = $0cee870b504ed59e$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0cee870b504ed59e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0cee870b504ed59e$var$Buffer.prototype.writeBigInt64BE = $0cee870b504ed59e$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0cee870b504ed59e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0cee870b504ed59e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0cee870b504ed59e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0cee870b504ed59e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0cee870b504ed59e$var$writeFloat(this, value, offset, true, noAssert);
};
$0cee870b504ed59e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0cee870b504ed59e$var$writeFloat(this, value, offset, false, noAssert);
};
function $0cee870b504ed59e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cee870b504ed59e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0cee870b504ed59e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0cee870b504ed59e$var$writeDouble(this, value, offset, true, noAssert);
};
$0cee870b504ed59e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0cee870b504ed59e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0cee870b504ed59e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0cee870b504ed59e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0cee870b504ed59e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0cee870b504ed59e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $0cee870b504ed59e$var$Buffer.isBuffer(val) ? val : $0cee870b504ed59e$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $0cee870b504ed59e$var$errors = {};
function $0cee870b504ed59e$var$E(sym, getMessage, Base) {
    $0cee870b504ed59e$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$0cee870b504ed59e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0cee870b504ed59e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$0cee870b504ed59e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $0cee870b504ed59e$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $0cee870b504ed59e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $0cee870b504ed59e$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $0cee870b504ed59e$var$checkBounds(buf, offset, byteLength) {
    $0cee870b504ed59e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0cee870b504ed59e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0cee870b504ed59e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $0cee870b504ed59e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0cee870b504ed59e$var$checkBounds(buf, offset, byteLength);
}
function $0cee870b504ed59e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0cee870b504ed59e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0cee870b504ed59e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0cee870b504ed59e$var$validateNumber(value, type);
        throw new $0cee870b504ed59e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0cee870b504ed59e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0cee870b504ed59e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $0cee870b504ed59e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0cee870b504ed59e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0cee870b504ed59e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0cee870b504ed59e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0cee870b504ed59e$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0cee870b504ed59e$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0cee870b504ed59e$var$base64ToBytes(str) {
    return $abUaD.toByteArray($0cee870b504ed59e$var$base64clean(str));
}
function $0cee870b504ed59e$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0cee870b504ed59e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0cee870b504ed59e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $0cee870b504ed59e$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0cee870b504ed59e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0cee870b504ed59e$var$BufferBigIntNotDefined : fn;
}
function $0cee870b504ed59e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("dQoAF", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $a14334dbb79cc6df$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $a14334dbb79cc6df$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("kZ6jV", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $16PNf = parcelRequire("16PNf");

var $gQ2lw = parcelRequire("gQ2lw");
var $f46e68393b77fac3$var$format = $gQ2lw.format, $f46e68393b77fac3$var$inspect = $gQ2lw.inspect;

var $3bC1q = parcelRequire("3bC1q");
var $f46e68393b77fac3$var$ERR_INVALID_ARG_TYPE = $3bC1q.codes.ERR_INVALID_ARG_TYPE;

var $dQoAF = parcelRequire("dQoAF");
var $f46e68393b77fac3$var$kResistStopPropagation = $dQoAF.kResistStopPropagation, $f46e68393b77fac3$var$AggregateError = $dQoAF.AggregateError, $f46e68393b77fac3$var$SymbolDispose = $dQoAF.SymbolDispose;

var $f46e68393b77fac3$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $f46e68393b77fac3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $f46e68393b77fac3$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $f46e68393b77fac3$var$Blob = globalThis.Blob || $16PNf.Blob;
/* eslint-disable indent */ var $f46e68393b77fac3$var$isBlob = typeof $f46e68393b77fac3$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $f46e68393b77fac3$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $f46e68393b77fac3$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $f46e68393b77fac3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $f46e68393b77fac3$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $f46e68393b77fac3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $f46e68393b77fac3$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $f46e68393b77fac3$var$format,
    inspect: $f46e68393b77fac3$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $f46e68393b77fac3$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $f46e68393b77fac3$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $f46e68393b77fac3$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $f46e68393b77fac3$var$validateAbortSignal(signal, 'signal');
        $f46e68393b77fac3$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $f46e68393b77fac3$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $f46e68393b77fac3$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $f46e68393b77fac3$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $f46e68393b77fac3$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $f46e68393b77fac3$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("gQ2lw", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("3bC1q", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $gQ2lw = parcelRequire("gQ2lw");
var $251fe490b742a45a$var$format = $gQ2lw.format, $251fe490b742a45a$var$inspect = $gQ2lw.inspect;

var $dQoAF = parcelRequire("dQoAF");
var $251fe490b742a45a$var$CustomAggregateError = $dQoAF.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $251fe490b742a45a$var$AggregateError = globalThis.AggregateError || $251fe490b742a45a$var$CustomAggregateError;
var $251fe490b742a45a$var$kIsNodeError = Symbol('kIsNodeError');
var $251fe490b742a45a$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $251fe490b742a45a$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $251fe490b742a45a$var$nodeInternalPrefix = '__node_internal_';
var $251fe490b742a45a$var$codes = {};
function $251fe490b742a45a$var$assert(value, message) {
    if (!value) throw new $251fe490b742a45a$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $251fe490b742a45a$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $251fe490b742a45a$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $251fe490b742a45a$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $251fe490b742a45a$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $251fe490b742a45a$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $251fe490b742a45a$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $251fe490b742a45a$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$251fe490b742a45a$var$kIsNodeError] = true;
    $251fe490b742a45a$var$codes[code] = NodeError;
}
function $251fe490b742a45a$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $251fe490b742a45a$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $251fe490b742a45a$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $251fe490b742a45a$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $251fe490b742a45a$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $251fe490b742a45a$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$251fe490b742a45a$var$E('ERR_ASSERTION', '%s', Error);
$251fe490b742a45a$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $251fe490b742a45a$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $251fe490b742a45a$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($251fe490b742a45a$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($251fe490b742a45a$var$classRegExp.test(value)) instances.push(value);
            else {
                $251fe490b742a45a$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $251fe490b742a45a$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $251fe490b742a45a$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$251fe490b742a45a$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $251fe490b742a45a$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$251fe490b742a45a$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$251fe490b742a45a$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $251fe490b742a45a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$251fe490b742a45a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $251fe490b742a45a$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $251fe490b742a45a$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $251fe490b742a45a$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $251fe490b742a45a$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$251fe490b742a45a$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$251fe490b742a45a$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$251fe490b742a45a$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$251fe490b742a45a$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$251fe490b742a45a$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$251fe490b742a45a$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$251fe490b742a45a$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$251fe490b742a45a$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$251fe490b742a45a$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$251fe490b742a45a$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$251fe490b742a45a$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $251fe490b742a45a$var$AbortError,
    aggregateTwoErrors: $251fe490b742a45a$var$hideStackFrames($251fe490b742a45a$var$aggregateTwoErrors),
    hideStackFrames: $251fe490b742a45a$var$hideStackFrames,
    codes: $251fe490b742a45a$var$codes
};

});


parcelRegister("kFSZl", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $f0d24a8848463cdb$export$42af8c323be37587; }, function (v) { return $f0d24a8848463cdb$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $f0d24a8848463cdb$export$f405f72c701dad87; }, function (v) { return $f0d24a8848463cdb$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $f0d24a8848463cdb$export$42af8c323be37587;
var $f0d24a8848463cdb$export$f405f72c701dad87;
'use strict';

var $f0d24a8848463cdb$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $3bC1q = parcelRequire("3bC1q");
var $f0d24a8848463cdb$var$_require_codes = $3bC1q.codes, $f0d24a8848463cdb$var$ERR_INVALID_ARG_VALUE = $f0d24a8848463cdb$var$_require_codes.ERR_INVALID_ARG_VALUE, $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE = $f0d24a8848463cdb$var$_require_codes.ERR_INVALID_ARG_TYPE, $f0d24a8848463cdb$var$ERR_MISSING_ARGS = $f0d24a8848463cdb$var$_require_codes.ERR_MISSING_ARGS, $f0d24a8848463cdb$var$ERR_OUT_OF_RANGE = $f0d24a8848463cdb$var$_require_codes.ERR_OUT_OF_RANGE, $f0d24a8848463cdb$var$AbortError = $3bC1q.AbortError;

var $7K1q3 = parcelRequire("7K1q3");
var $f0d24a8848463cdb$var$validateAbortSignal = $7K1q3.validateAbortSignal, $f0d24a8848463cdb$var$validateInteger = $7K1q3.validateInteger, $f0d24a8848463cdb$var$validateObject = $7K1q3.validateObject;

var $f0d24a8848463cdb$var$kWeakHandler = (parcelRequire("dQoAF")).Symbol('kWeak');

var $f0d24a8848463cdb$var$kResistStopPropagation = (parcelRequire("dQoAF")).Symbol('kResistStopPropagation');

var $2yyE0 = parcelRequire("2yyE0");
var $f0d24a8848463cdb$require$finished = $2yyE0.finished;

var $6tWOT = parcelRequire("6tWOT");

var $kGxTp = parcelRequire("kGxTp");
var $f0d24a8848463cdb$require$addAbortSignalNoValidate = $kGxTp.addAbortSignalNoValidate;

var $14flQ = parcelRequire("14flQ");
var $f0d24a8848463cdb$var$isWritable = $14flQ.isWritable, $f0d24a8848463cdb$var$isNodeStream = $14flQ.isNodeStream;

var $f0d24a8848463cdb$require$deprecate = (parcelRequire("kZ6jV")).deprecate;

var $f0d24a8848463cdb$var$ArrayPrototypePush = (parcelRequire("dQoAF")).ArrayPrototypePush, $f0d24a8848463cdb$var$Boolean = (parcelRequire("dQoAF")).Boolean, $f0d24a8848463cdb$var$MathFloor = (parcelRequire("dQoAF")).MathFloor, $f0d24a8848463cdb$var$Number = (parcelRequire("dQoAF")).Number, $f0d24a8848463cdb$var$NumberIsNaN = (parcelRequire("dQoAF")).NumberIsNaN, $f0d24a8848463cdb$var$Promise = (parcelRequire("dQoAF")).Promise, $f0d24a8848463cdb$var$PromiseReject = (parcelRequire("dQoAF")).PromiseReject, $f0d24a8848463cdb$var$PromiseResolve = (parcelRequire("dQoAF")).PromiseResolve, $f0d24a8848463cdb$var$PromisePrototypeThen = (parcelRequire("dQoAF")).PromisePrototypeThen, $f0d24a8848463cdb$var$Symbol = (parcelRequire("dQoAF")).Symbol;
var $f0d24a8848463cdb$var$kEmpty = $f0d24a8848463cdb$var$Symbol('kEmpty');
var $f0d24a8848463cdb$var$kEof = $f0d24a8848463cdb$var$Symbol('kEof');
function $f0d24a8848463cdb$var$compose(stream, options) {
    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
    if ($f0d24a8848463cdb$var$isNodeStream(stream) && !$f0d24a8848463cdb$var$isWritable(stream)) throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $6tWOT(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $f0d24a8848463cdb$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $f0d24a8848463cdb$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $f0d24a8848463cdb$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $f0d24a8848463cdb$var$MathFloor(options.highWaterMark);
    $f0d24a8848463cdb$var$validateInteger(concurrency, 'options.concurrency', 1);
    $f0d24a8848463cdb$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $f0d24a8848463cdb$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $f0d24a8848463cdb$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $f0d24a8848463cdb$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $f0d24a8848463cdb$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $f0d24a8848463cdb$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($f0d24a8848463cdb$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $f0d24a8848463cdb$var$PromiseReject(err1);
                                $f0d24a8848463cdb$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("kZ6jV")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($f0d24a8848463cdb$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $f0d24a8848463cdb$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                        if (!(val !== $f0d24a8848463cdb$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $f0d24a8848463cdb$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $f0d24a8848463cdb$var$asIndexedPairs(options) {
    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $f0d24a8848463cdb$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $f0d24a8848463cdb$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($f0d24a8848463cdb$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $f0d24a8848463cdb$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $f0d24a8848463cdb$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $f0d24a8848463cdb$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($f0d24a8848463cdb$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $f0d24a8848463cdb$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $f0d24a8848463cdb$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($f0d24a8848463cdb$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $f0d24a8848463cdb$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $f0d24a8848463cdb$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $f0d24a8848463cdb$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $f0d24a8848463cdb$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($f0d24a8848463cdb$var$ERR_MISSING_ARGS);
function $f0d24a8848463cdb$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $f0d24a8848463cdb$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $f0d24a8848463cdb$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $f0d24a8848463cdb$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $f0d24a8848463cdb$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $f0d24a8848463cdb$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $f0d24a8848463cdb$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $f0d24a8848463cdb$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $f0d24a8848463cdb$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $f0d24a8848463cdb$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $f0d24a8848463cdb$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $f0d24a8848463cdb$var$flatMap(fn, options) {
    var values = $f0d24a8848463cdb$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $f0d24a8848463cdb$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $f0d24a8848463cdb$var$Number(number);
    if ($f0d24a8848463cdb$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $f0d24a8848463cdb$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $f0d24a8848463cdb$var$drop(number, options) {
    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
    number = $f0d24a8848463cdb$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $f0d24a8848463cdb$var$take(number, options) {
    if (options != null) $f0d24a8848463cdb$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0d24a8848463cdb$var$validateAbortSignal(options.signal, 'options.signal');
    number = $f0d24a8848463cdb$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $f0d24a8848463cdb$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$f0d24a8848463cdb$export$42af8c323be37587 = {
    asIndexedPairs: $f0d24a8848463cdb$require$deprecate($f0d24a8848463cdb$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $f0d24a8848463cdb$var$drop,
    filter: $f0d24a8848463cdb$var$filter,
    flatMap: $f0d24a8848463cdb$var$flatMap,
    map: $f0d24a8848463cdb$var$map,
    take: $f0d24a8848463cdb$var$take,
    compose: $f0d24a8848463cdb$var$compose
};
$f0d24a8848463cdb$export$f405f72c701dad87 = {
    every: $f0d24a8848463cdb$var$every,
    forEach: $f0d24a8848463cdb$var$forEach,
    reduce: $f0d24a8848463cdb$var$reduce,
    toArray: $f0d24a8848463cdb$var$toArray,
    some: $f0d24a8848463cdb$var$some,
    find: $f0d24a8848463cdb$var$find
};

});
parcelRegister("7K1q3", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $5a2dee1a329b7db3$var$ArrayIsArray = $dQoAF.ArrayIsArray, $5a2dee1a329b7db3$var$ArrayPrototypeIncludes = $dQoAF.ArrayPrototypeIncludes, $5a2dee1a329b7db3$var$ArrayPrototypeJoin = $dQoAF.ArrayPrototypeJoin, $5a2dee1a329b7db3$var$ArrayPrototypeMap = $dQoAF.ArrayPrototypeMap, $5a2dee1a329b7db3$var$NumberIsInteger = $dQoAF.NumberIsInteger, $5a2dee1a329b7db3$var$NumberIsNaN = $dQoAF.NumberIsNaN, $5a2dee1a329b7db3$var$NumberMAX_SAFE_INTEGER = $dQoAF.NumberMAX_SAFE_INTEGER, $5a2dee1a329b7db3$var$NumberMIN_SAFE_INTEGER = $dQoAF.NumberMIN_SAFE_INTEGER, $5a2dee1a329b7db3$var$NumberParseInt = $dQoAF.NumberParseInt, $5a2dee1a329b7db3$var$ObjectPrototypeHasOwnProperty = $dQoAF.ObjectPrototypeHasOwnProperty, $5a2dee1a329b7db3$var$RegExpPrototypeExec = $dQoAF.RegExpPrototypeExec, $5a2dee1a329b7db3$var$String = $dQoAF.String, $5a2dee1a329b7db3$var$StringPrototypeToUpperCase = $dQoAF.StringPrototypeToUpperCase, $5a2dee1a329b7db3$var$StringPrototypeTrim = $dQoAF.StringPrototypeTrim;

var $3bC1q = parcelRequire("3bC1q");
var $5a2dee1a329b7db3$var$hideStackFrames = $3bC1q.hideStackFrames, $5a2dee1a329b7db3$var$_require_codes = $3bC1q.codes, $5a2dee1a329b7db3$var$ERR_SOCKET_BAD_PORT = $5a2dee1a329b7db3$var$_require_codes.ERR_SOCKET_BAD_PORT, $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE = $5a2dee1a329b7db3$var$_require_codes.ERR_INVALID_ARG_TYPE, $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE = $5a2dee1a329b7db3$var$_require_codes.ERR_INVALID_ARG_VALUE, $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE = $5a2dee1a329b7db3$var$_require_codes.ERR_OUT_OF_RANGE, $5a2dee1a329b7db3$var$ERR_UNKNOWN_SIGNAL = $5a2dee1a329b7db3$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $kZ6jV = parcelRequire("kZ6jV");
var $5a2dee1a329b7db3$require$normalizeEncoding = $kZ6jV.normalizeEncoding;

var $kZ6jV = parcelRequire("kZ6jV");
var $5a2dee1a329b7db3$require$_require_types = $kZ6jV.types;
var $5a2dee1a329b7db3$var$isAsyncFunction = $5a2dee1a329b7db3$require$_require_types.isAsyncFunction, $5a2dee1a329b7db3$var$isArrayBufferView = $5a2dee1a329b7db3$require$_require_types.isArrayBufferView;
var $5a2dee1a329b7db3$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $5a2dee1a329b7db3$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $5a2dee1a329b7db3$var$isUint32(value) {
    return value === value >>> 0;
}
var $5a2dee1a329b7db3$var$octalReg = /^[0-7]+$/;
var $5a2dee1a329b7db3$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $5a2dee1a329b7db3$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($5a2dee1a329b7db3$var$RegExpPrototypeExec($5a2dee1a329b7db3$var$octalReg, value) === null) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE(name, value, $5a2dee1a329b7db3$var$modeDesc);
        value = $5a2dee1a329b7db3$var$NumberParseInt(value, 8);
    }
    $5a2dee1a329b7db3$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $5a2dee1a329b7db3$var$validateInteger = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $5a2dee1a329b7db3$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $5a2dee1a329b7db3$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$5a2dee1a329b7db3$var$NumberIsInteger(value)) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $5a2dee1a329b7db3$var$validateInt32 = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$5a2dee1a329b7db3$var$NumberIsInteger(value)) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $5a2dee1a329b7db3$var$validateUint32 = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$5a2dee1a329b7db3$var$NumberIsInteger(value)) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $5a2dee1a329b7db3$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $5a2dee1a329b7db3$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $5a2dee1a329b7db3$var$NumberIsNaN(value)) throw new $5a2dee1a329b7db3$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $5a2dee1a329b7db3$var$validateOneOf = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name, oneOf) {
    if (!$5a2dee1a329b7db3$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $5a2dee1a329b7db3$var$ArrayPrototypeJoin($5a2dee1a329b7db3$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $5a2dee1a329b7db3$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $5a2dee1a329b7db3$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $5a2dee1a329b7db3$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$5a2dee1a329b7db3$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $5a2dee1a329b7db3$var$validateObject = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $5a2dee1a329b7db3$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $5a2dee1a329b7db3$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $5a2dee1a329b7db3$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $5a2dee1a329b7db3$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $5a2dee1a329b7db3$var$validateDictionary = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $5a2dee1a329b7db3$var$validateArray = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$5a2dee1a329b7db3$var$ArrayIsArray(value)) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $5a2dee1a329b7db3$var$validateStringArray(value, name) {
    $5a2dee1a329b7db3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$5a2dee1a329b7db3$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $5a2dee1a329b7db3$var$validateBooleanArray(value, name) {
    $5a2dee1a329b7db3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$5a2dee1a329b7db3$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $5a2dee1a329b7db3$var$validateAbortSignalArray(value, name) {
    $5a2dee1a329b7db3$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $5a2dee1a329b7db3$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $5a2dee1a329b7db3$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $5a2dee1a329b7db3$var$validateString(signal, name);
    if ($5a2dee1a329b7db3$var$signals[signal] === undefined) {
        if ($5a2dee1a329b7db3$var$signals[$5a2dee1a329b7db3$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $5a2dee1a329b7db3$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $5a2dee1a329b7db3$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $5a2dee1a329b7db3$var$validateBuffer = $5a2dee1a329b7db3$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$5a2dee1a329b7db3$var$isArrayBufferView(buffer)) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $5a2dee1a329b7db3$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $5a2dee1a329b7db3$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $5a2dee1a329b7db3$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $5a2dee1a329b7db3$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $5a2dee1a329b7db3$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $5a2dee1a329b7db3$var$validateAbortSignal = $5a2dee1a329b7db3$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $5a2dee1a329b7db3$var$validateFunction = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $5a2dee1a329b7db3$var$validatePlainFunction = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $5a2dee1a329b7db3$var$isAsyncFunction(value)) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $5a2dee1a329b7db3$var$validateUndefined = $5a2dee1a329b7db3$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $5a2dee1a329b7db3$var$validateUnion(value, name, union) {
    if (!$5a2dee1a329b7db3$var$ArrayPrototypeIncludes(union, value)) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_TYPE(name, "('".concat($5a2dee1a329b7db3$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $5a2dee1a329b7db3$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $5a2dee1a329b7db3$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$5a2dee1a329b7db3$var$RegExpPrototypeExec($5a2dee1a329b7db3$var$linkValueRegExp, value)) throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $5a2dee1a329b7db3$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $5a2dee1a329b7db3$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($5a2dee1a329b7db3$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $5a2dee1a329b7db3$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $5a2dee1a329b7db3$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $5a2dee1a329b7db3$var$isInt32,
    isUint32: $5a2dee1a329b7db3$var$isUint32,
    parseFileMode: $5a2dee1a329b7db3$var$parseFileMode,
    validateArray: $5a2dee1a329b7db3$var$validateArray,
    validateStringArray: $5a2dee1a329b7db3$var$validateStringArray,
    validateBooleanArray: $5a2dee1a329b7db3$var$validateBooleanArray,
    validateAbortSignalArray: $5a2dee1a329b7db3$var$validateAbortSignalArray,
    validateBoolean: $5a2dee1a329b7db3$var$validateBoolean,
    validateBuffer: $5a2dee1a329b7db3$var$validateBuffer,
    validateDictionary: $5a2dee1a329b7db3$var$validateDictionary,
    validateEncoding: $5a2dee1a329b7db3$var$validateEncoding,
    validateFunction: $5a2dee1a329b7db3$var$validateFunction,
    validateInt32: $5a2dee1a329b7db3$var$validateInt32,
    validateInteger: $5a2dee1a329b7db3$var$validateInteger,
    validateNumber: $5a2dee1a329b7db3$var$validateNumber,
    validateObject: $5a2dee1a329b7db3$var$validateObject,
    validateOneOf: $5a2dee1a329b7db3$var$validateOneOf,
    validatePlainFunction: $5a2dee1a329b7db3$var$validatePlainFunction,
    validatePort: $5a2dee1a329b7db3$var$validatePort,
    validateSignalName: $5a2dee1a329b7db3$var$validateSignalName,
    validateString: $5a2dee1a329b7db3$var$validateString,
    validateUint32: $5a2dee1a329b7db3$var$validateUint32,
    validateUndefined: $5a2dee1a329b7db3$var$validateUndefined,
    validateUnion: $5a2dee1a329b7db3$var$validateUnion,
    validateAbortSignal: $5a2dee1a329b7db3$var$validateAbortSignal,
    validateLinkHeaderValue: $5a2dee1a329b7db3$var$validateLinkHeaderValue
};

});

parcelRegister("2yyE0", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3bC1q = parcelRequire("3bC1q");
/* replacement end */ var $1dc9a165999a5a58$var$AbortError = $3bC1q.AbortError, $1dc9a165999a5a58$var$codes = $3bC1q.codes;
var $1dc9a165999a5a58$var$ERR_INVALID_ARG_TYPE = $1dc9a165999a5a58$var$codes.ERR_INVALID_ARG_TYPE, $1dc9a165999a5a58$var$ERR_STREAM_PREMATURE_CLOSE = $1dc9a165999a5a58$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $1dc9a165999a5a58$var$kEmptyObject = (parcelRequire("kZ6jV")).kEmptyObject, $1dc9a165999a5a58$var$once = (parcelRequire("kZ6jV")).once;

var $7K1q3 = parcelRequire("7K1q3");
var $1dc9a165999a5a58$var$validateAbortSignal = $7K1q3.validateAbortSignal, $1dc9a165999a5a58$var$validateFunction = $7K1q3.validateFunction, $1dc9a165999a5a58$var$validateObject = $7K1q3.validateObject, $1dc9a165999a5a58$var$validateBoolean = $7K1q3.validateBoolean;

var $dQoAF = parcelRequire("dQoAF");
var $1dc9a165999a5a58$var$Promise = $dQoAF.Promise, $1dc9a165999a5a58$var$PromisePrototypeThen = $dQoAF.PromisePrototypeThen, $1dc9a165999a5a58$var$SymbolDispose = $dQoAF.SymbolDispose;

var $14flQ = parcelRequire("14flQ");
var $1dc9a165999a5a58$var$isClosed = $14flQ.isClosed, $1dc9a165999a5a58$var$isReadable = $14flQ.isReadable, $1dc9a165999a5a58$var$isReadableNodeStream = $14flQ.isReadableNodeStream, $1dc9a165999a5a58$var$isReadableStream = $14flQ.isReadableStream, $1dc9a165999a5a58$var$isReadableFinished = $14flQ.isReadableFinished, $1dc9a165999a5a58$var$isReadableErrored = $14flQ.isReadableErrored, $1dc9a165999a5a58$var$isWritable = $14flQ.isWritable, $1dc9a165999a5a58$var$isWritableNodeStream = $14flQ.isWritableNodeStream, $1dc9a165999a5a58$var$isWritableStream = $14flQ.isWritableStream, $1dc9a165999a5a58$var$isWritableFinished = $14flQ.isWritableFinished, $1dc9a165999a5a58$var$isWritableErrored = $14flQ.isWritableErrored, $1dc9a165999a5a58$var$isNodeStream = $14flQ.isNodeStream, $1dc9a165999a5a58$var$_willEmitClose = $14flQ.willEmitClose, $1dc9a165999a5a58$var$kIsClosedPromise = $14flQ.kIsClosedPromise;
var $1dc9a165999a5a58$var$addAbortListener;
function $1dc9a165999a5a58$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $1dc9a165999a5a58$var$nop = function() {};

function $1dc9a165999a5a58$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $1dc9a165999a5a58$var$kEmptyObject;
    } else if (options == null) options = $1dc9a165999a5a58$var$kEmptyObject;
    else $1dc9a165999a5a58$var$validateObject(options, 'options');
    $1dc9a165999a5a58$var$validateFunction(callback, 'callback');
    $1dc9a165999a5a58$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $1dc9a165999a5a58$var$once(callback);
    if ($1dc9a165999a5a58$var$isReadableStream(stream) || $1dc9a165999a5a58$var$isWritableStream(stream)) return $1dc9a165999a5a58$var$eosWeb(stream, options, callback);
    if (!$1dc9a165999a5a58$var$isNodeStream(stream)) throw new $1dc9a165999a5a58$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $1dc9a165999a5a58$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $1dc9a165999a5a58$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $1dc9a165999a5a58$var$_willEmitClose(stream) && $1dc9a165999a5a58$var$isReadableNodeStream(stream) === readable && $1dc9a165999a5a58$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $1dc9a165999a5a58$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $1dc9a165999a5a58$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $1dc9a165999a5a58$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $1dc9a165999a5a58$var$isWritableErrored(stream) || $1dc9a165999a5a58$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $1dc9a165999a5a58$var$isReadableNodeStream(stream, true)) {
            if (!$1dc9a165999a5a58$var$isReadableFinished(stream, false)) return callback.call(stream, new $1dc9a165999a5a58$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$1dc9a165999a5a58$var$isWritableFinished(stream, false)) return callback.call(stream, new $1dc9a165999a5a58$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $1dc9a165999a5a58$var$isWritableErrored(stream) || $1dc9a165999a5a58$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($1dc9a165999a5a58$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $1dc9a165999a5a58$var$isReadable(stream)) && (writableFinished || $1dc9a165999a5a58$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $1dc9a165999a5a58$var$isWritable(stream)) && (readableFinished || $1dc9a165999a5a58$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $1dc9a165999a5a58$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $1dc9a165999a5a58$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $1dc9a165999a5a58$var$addAbortListener = $1dc9a165999a5a58$var$addAbortListener || (parcelRequire("kZ6jV")).addAbortListener;
            var disposable = $1dc9a165999a5a58$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $1dc9a165999a5a58$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$1dc9a165999a5a58$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $1dc9a165999a5a58$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $1dc9a165999a5a58$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $1dc9a165999a5a58$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $1dc9a165999a5a58$var$addAbortListener = $1dc9a165999a5a58$var$addAbortListener || (parcelRequire("kZ6jV")).addAbortListener;
            var disposable = $1dc9a165999a5a58$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $1dc9a165999a5a58$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$1dc9a165999a5a58$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $1dc9a165999a5a58$var$PromisePrototypeThen(stream[$1dc9a165999a5a58$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $1dc9a165999a5a58$var$nop;
}
function $1dc9a165999a5a58$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $1dc9a165999a5a58$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $1dc9a165999a5a58$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $1dc9a165999a5a58$var$Promise(function(resolve, reject) {
        var cleanup = $1dc9a165999a5a58$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $1dc9a165999a5a58$var$eos;
module.exports.finished = $1dc9a165999a5a58$var$finished;

});
parcelRegister("14flQ", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $0c7212a4e9896ef0$var$SymbolAsyncIterator = $dQoAF.SymbolAsyncIterator, $0c7212a4e9896ef0$var$SymbolIterator = $dQoAF.SymbolIterator, $0c7212a4e9896ef0$var$SymbolFor = $dQoAF.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $0c7212a4e9896ef0$var$kIsDestroyed = $0c7212a4e9896ef0$var$SymbolFor('nodejs.stream.destroyed');
var $0c7212a4e9896ef0$var$kIsErrored = $0c7212a4e9896ef0$var$SymbolFor('nodejs.stream.errored');
var $0c7212a4e9896ef0$var$kIsReadable = $0c7212a4e9896ef0$var$SymbolFor('nodejs.stream.readable');
var $0c7212a4e9896ef0$var$kIsWritable = $0c7212a4e9896ef0$var$SymbolFor('nodejs.stream.writable');
var $0c7212a4e9896ef0$var$kIsDisturbed = $0c7212a4e9896ef0$var$SymbolFor('nodejs.stream.disturbed');
var $0c7212a4e9896ef0$var$kIsClosedPromise = $0c7212a4e9896ef0$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $0c7212a4e9896ef0$var$kControllerErrorFunction = $0c7212a4e9896ef0$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $0c7212a4e9896ef0$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $0c7212a4e9896ef0$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $0c7212a4e9896ef0$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $0c7212a4e9896ef0$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $0c7212a4e9896ef0$var$isReadableStream(obj) {
    return !!(obj && !$0c7212a4e9896ef0$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $0c7212a4e9896ef0$var$isWritableStream(obj) {
    return !!(obj && !$0c7212a4e9896ef0$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $0c7212a4e9896ef0$var$isTransformStream(obj) {
    return !!(obj && !$0c7212a4e9896ef0$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $0c7212a4e9896ef0$var$isWebStream(obj) {
    return $0c7212a4e9896ef0$var$isReadableStream(obj) || $0c7212a4e9896ef0$var$isWritableStream(obj) || $0c7212a4e9896ef0$var$isTransformStream(obj);
}
function $0c7212a4e9896ef0$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$0c7212a4e9896ef0$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$0c7212a4e9896ef0$var$SymbolIterator] === 'function';
    return typeof obj[$0c7212a4e9896ef0$var$SymbolAsyncIterator] === 'function' || typeof obj[$0c7212a4e9896ef0$var$SymbolIterator] === 'function';
}
function $0c7212a4e9896ef0$var$isDestroyed(stream) {
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$0c7212a4e9896ef0$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $0c7212a4e9896ef0$var$isWritableEnded(stream) {
    if (!$0c7212a4e9896ef0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $0c7212a4e9896ef0$var$isWritableFinished(stream, strict) {
    if (!$0c7212a4e9896ef0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $0c7212a4e9896ef0$var$isReadableEnded(stream) {
    if (!$0c7212a4e9896ef0$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $0c7212a4e9896ef0$var$isReadableFinished(stream, strict) {
    if (!$0c7212a4e9896ef0$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $0c7212a4e9896ef0$var$isReadable(stream) {
    if (stream && stream[$0c7212a4e9896ef0$var$kIsReadable] != null) return stream[$0c7212a4e9896ef0$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($0c7212a4e9896ef0$var$isDestroyed(stream)) return false;
    return $0c7212a4e9896ef0$var$isReadableNodeStream(stream) && stream.readable && !$0c7212a4e9896ef0$var$isReadableFinished(stream);
}
function $0c7212a4e9896ef0$var$isWritable(stream) {
    if (stream && stream[$0c7212a4e9896ef0$var$kIsWritable] != null) return stream[$0c7212a4e9896ef0$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($0c7212a4e9896ef0$var$isDestroyed(stream)) return false;
    return $0c7212a4e9896ef0$var$isWritableNodeStream(stream) && stream.writable && !$0c7212a4e9896ef0$var$isWritableEnded(stream);
}
function $0c7212a4e9896ef0$var$isFinished(stream, opts) {
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    if ($0c7212a4e9896ef0$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $0c7212a4e9896ef0$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $0c7212a4e9896ef0$var$isWritable(stream)) return false;
    return true;
}
function $0c7212a4e9896ef0$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $0c7212a4e9896ef0$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $0c7212a4e9896ef0$var$isClosed(stream) {
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $0c7212a4e9896ef0$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $0c7212a4e9896ef0$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $0c7212a4e9896ef0$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $0c7212a4e9896ef0$var$isOutgoingMessage(stream);
}
function $0c7212a4e9896ef0$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $0c7212a4e9896ef0$var$willEmitClose(stream) {
    if (!$0c7212a4e9896ef0$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $0c7212a4e9896ef0$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $0c7212a4e9896ef0$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$0c7212a4e9896ef0$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $0c7212a4e9896ef0$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$0c7212a4e9896ef0$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $0c7212a4e9896ef0$var$isDestroyed,
    kIsDestroyed: $0c7212a4e9896ef0$var$kIsDestroyed,
    isDisturbed: $0c7212a4e9896ef0$var$isDisturbed,
    kIsDisturbed: $0c7212a4e9896ef0$var$kIsDisturbed,
    isErrored: $0c7212a4e9896ef0$var$isErrored,
    kIsErrored: $0c7212a4e9896ef0$var$kIsErrored,
    isReadable: $0c7212a4e9896ef0$var$isReadable,
    kIsReadable: $0c7212a4e9896ef0$var$kIsReadable,
    kIsClosedPromise: $0c7212a4e9896ef0$var$kIsClosedPromise,
    kControllerErrorFunction: $0c7212a4e9896ef0$var$kControllerErrorFunction,
    kIsWritable: $0c7212a4e9896ef0$var$kIsWritable,
    isClosed: $0c7212a4e9896ef0$var$isClosed,
    isDuplexNodeStream: $0c7212a4e9896ef0$var$isDuplexNodeStream,
    isFinished: $0c7212a4e9896ef0$var$isFinished,
    isIterable: $0c7212a4e9896ef0$var$isIterable,
    isReadableNodeStream: $0c7212a4e9896ef0$var$isReadableNodeStream,
    isReadableStream: $0c7212a4e9896ef0$var$isReadableStream,
    isReadableEnded: $0c7212a4e9896ef0$var$isReadableEnded,
    isReadableFinished: $0c7212a4e9896ef0$var$isReadableFinished,
    isReadableErrored: $0c7212a4e9896ef0$var$isReadableErrored,
    isNodeStream: $0c7212a4e9896ef0$var$isNodeStream,
    isWebStream: $0c7212a4e9896ef0$var$isWebStream,
    isWritable: $0c7212a4e9896ef0$var$isWritable,
    isWritableNodeStream: $0c7212a4e9896ef0$var$isWritableNodeStream,
    isWritableStream: $0c7212a4e9896ef0$var$isWritableStream,
    isWritableEnded: $0c7212a4e9896ef0$var$isWritableEnded,
    isWritableFinished: $0c7212a4e9896ef0$var$isWritableFinished,
    isWritableErrored: $0c7212a4e9896ef0$var$isWritableErrored,
    isServerRequest: $0c7212a4e9896ef0$var$isServerRequest,
    isServerResponse: $0c7212a4e9896ef0$var$isServerResponse,
    willEmitClose: $0c7212a4e9896ef0$var$willEmitClose,
    isTransformStream: $0c7212a4e9896ef0$var$isTransformStream
};

});


parcelRegister("6tWOT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $1OB2I = parcelRequire("1OB2I");
var $4b8313e574120e0e$require$pipeline = $1OB2I.pipeline;

var $WB9ys = parcelRequire("WB9ys");

var $5nXCW = parcelRequire("5nXCW");
var $4b8313e574120e0e$require$destroyer = $5nXCW.destroyer;

var $14flQ = parcelRequire("14flQ");
var $4b8313e574120e0e$var$isNodeStream = $14flQ.isNodeStream, $4b8313e574120e0e$var$isReadable = $14flQ.isReadable, $4b8313e574120e0e$var$isWritable = $14flQ.isWritable, $4b8313e574120e0e$var$isWebStream = $14flQ.isWebStream, $4b8313e574120e0e$var$isTransformStream = $14flQ.isTransformStream, $4b8313e574120e0e$var$isWritableStream = $14flQ.isWritableStream, $4b8313e574120e0e$var$isReadableStream = $14flQ.isReadableStream;

var $3bC1q = parcelRequire("3bC1q");
var $4b8313e574120e0e$var$AbortError = $3bC1q.AbortError, $4b8313e574120e0e$var$_require_codes = $3bC1q.codes, $4b8313e574120e0e$var$ERR_INVALID_ARG_VALUE = $4b8313e574120e0e$var$_require_codes.ERR_INVALID_ARG_VALUE, $4b8313e574120e0e$var$ERR_MISSING_ARGS = $4b8313e574120e0e$var$_require_codes.ERR_MISSING_ARGS;

var $2yyE0 = parcelRequire("2yyE0");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $4b8313e574120e0e$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $WB9ys.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $WB9ys.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $WB9ys.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$4b8313e574120e0e$var$isNodeStream(streams[n]) && !$4b8313e574120e0e$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($4b8313e574120e0e$var$isReadable(streams[n]) || $4b8313e574120e0e$var$isReadableStream(streams[n]) || $4b8313e574120e0e$var$isTransformStream(streams[n]))) throw new $4b8313e574120e0e$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($4b8313e574120e0e$var$isWritable(streams[n]) || $4b8313e574120e0e$var$isWritableStream(streams[n]) || $4b8313e574120e0e$var$isTransformStream(streams[n]))) throw new $4b8313e574120e0e$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $4b8313e574120e0e$require$pipeline(streams, onfinished);
    var writable = !!($4b8313e574120e0e$var$isWritable(head) || $4b8313e574120e0e$var$isWritableStream(head) || $4b8313e574120e0e$var$isTransformStream(head));
    var readable = !!($4b8313e574120e0e$var$isReadable(tail) || $4b8313e574120e0e$var$isReadableStream(tail) || $4b8313e574120e0e$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $WB9ys({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($4b8313e574120e0e$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($4b8313e574120e0e$var$isWebStream(head)) {
            var writable1 = $4b8313e574120e0e$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $4b8313e574120e0e$var$isTransformStream(tail) ? tail.readable : tail;
        $2yyE0(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($4b8313e574120e0e$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($4b8313e574120e0e$var$isWebStream(tail)) {
            var readable1 = $4b8313e574120e0e$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $4b8313e574120e0e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($4b8313e574120e0e$var$isNodeStream(tail)) $4b8313e574120e0e$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("1OB2I", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $152731e34fd023ce$var$ArrayIsArray = $dQoAF.ArrayIsArray, $152731e34fd023ce$var$Promise = $dQoAF.Promise, $152731e34fd023ce$var$SymbolAsyncIterator = $dQoAF.SymbolAsyncIterator, $152731e34fd023ce$var$SymbolDispose = $dQoAF.SymbolDispose;

var $2yyE0 = parcelRequire("2yyE0");

var $152731e34fd023ce$require$once = (parcelRequire("kZ6jV")).once;

var $5nXCW = parcelRequire("5nXCW");

var $WB9ys = parcelRequire("WB9ys");

var $3bC1q = parcelRequire("3bC1q");
var $152731e34fd023ce$var$aggregateTwoErrors = $3bC1q.aggregateTwoErrors, $152731e34fd023ce$var$_require_codes = $3bC1q.codes, $152731e34fd023ce$var$ERR_INVALID_ARG_TYPE = $152731e34fd023ce$var$_require_codes.ERR_INVALID_ARG_TYPE, $152731e34fd023ce$var$ERR_INVALID_RETURN_VALUE = $152731e34fd023ce$var$_require_codes.ERR_INVALID_RETURN_VALUE, $152731e34fd023ce$var$ERR_MISSING_ARGS = $152731e34fd023ce$var$_require_codes.ERR_MISSING_ARGS, $152731e34fd023ce$var$ERR_STREAM_DESTROYED = $152731e34fd023ce$var$_require_codes.ERR_STREAM_DESTROYED, $152731e34fd023ce$var$ERR_STREAM_PREMATURE_CLOSE = $152731e34fd023ce$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $152731e34fd023ce$var$AbortError = $3bC1q.AbortError;

var $7K1q3 = parcelRequire("7K1q3");
var $152731e34fd023ce$var$validateFunction = $7K1q3.validateFunction, $152731e34fd023ce$var$validateAbortSignal = $7K1q3.validateAbortSignal;

var $14flQ = parcelRequire("14flQ");
var $152731e34fd023ce$var$isIterable = $14flQ.isIterable, $152731e34fd023ce$var$isReadable = $14flQ.isReadable, $152731e34fd023ce$var$isReadableNodeStream = $14flQ.isReadableNodeStream, $152731e34fd023ce$var$isNodeStream = $14flQ.isNodeStream, $152731e34fd023ce$var$isTransformStream = $14flQ.isTransformStream, $152731e34fd023ce$var$isWebStream = $14flQ.isWebStream, $152731e34fd023ce$var$isReadableStream = $14flQ.isReadableStream, $152731e34fd023ce$var$isReadableFinished = $14flQ.isReadableFinished;

var $152731e34fd023ce$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $152731e34fd023ce$var$PassThrough;
var $152731e34fd023ce$var$Readable;
var $152731e34fd023ce$var$addAbortListener;
function $152731e34fd023ce$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $2yyE0(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $5nXCW.destroyer(stream, err || new $152731e34fd023ce$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $152731e34fd023ce$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $152731e34fd023ce$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $152731e34fd023ce$var$makeAsyncIterable(val) {
    if ($152731e34fd023ce$var$isIterable(val)) return val;
    else if ($152731e34fd023ce$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $152731e34fd023ce$var$fromReadable(val);
    throw new $152731e34fd023ce$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $152731e34fd023ce$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$152731e34fd023ce$var$Readable) $152731e34fd023ce$var$Readable = (parcelRequire("ghfC5"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($152731e34fd023ce$var$Readable.prototype[$152731e34fd023ce$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $152731e34fd023ce$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $152731e34fd023ce$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $2yyE0(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $152731e34fd023ce$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $152731e34fd023ce$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($152731e34fd023ce$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $152731e34fd023ce$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $152731e34fd023ce$var$pipelineImpl(streams, $152731e34fd023ce$require$once($152731e34fd023ce$var$popCallback(streams)));
}


function $152731e34fd023ce$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($152731e34fd023ce$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $152731e34fd023ce$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($152731e34fd023ce$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($152731e34fd023ce$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$152731e34fd023ce$var$isIterable(ret)) throw new $152731e34fd023ce$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($152731e34fd023ce$var$isIterable(stream) || $152731e34fd023ce$var$isReadableNodeStream(stream) || $152731e34fd023ce$var$isTransformStream(stream)) ret = stream;
            else ret = $WB9ys.from(stream);
        } else if (typeof stream === 'function') {
            if ($152731e34fd023ce$var$isTransformStream(ret)) {
                var _ret;
                ret = $152731e34fd023ce$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $152731e34fd023ce$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$152731e34fd023ce$var$isIterable(ret, true)) throw new $152731e34fd023ce$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$152731e34fd023ce$var$PassThrough) $152731e34fd023ce$var$PassThrough = (parcelRequire("jLV2p"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $152731e34fd023ce$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($152731e34fd023ce$var$isIterable(ret, true)) {
                    finishCount++;
                    $152731e34fd023ce$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($152731e34fd023ce$var$isReadableStream(ret) || $152731e34fd023ce$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $152731e34fd023ce$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $152731e34fd023ce$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $152731e34fd023ce$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($152731e34fd023ce$var$isNodeStream(stream)) {
            if ($152731e34fd023ce$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $152731e34fd023ce$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($152731e34fd023ce$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($152731e34fd023ce$var$isTransformStream(ret) || $152731e34fd023ce$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $152731e34fd023ce$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($152731e34fd023ce$var$isIterable(ret)) {
                finishCount++;
                $152731e34fd023ce$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $152731e34fd023ce$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($152731e34fd023ce$var$isWebStream(stream)) {
            if ($152731e34fd023ce$var$isReadableNodeStream(ret)) {
                finishCount++;
                $152731e34fd023ce$var$pumpToWeb($152731e34fd023ce$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($152731e34fd023ce$var$isReadableStream(ret) || $152731e34fd023ce$var$isIterable(ret)) {
                finishCount++;
                $152731e34fd023ce$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($152731e34fd023ce$var$isTransformStream(ret)) {
                finishCount++;
                $152731e34fd023ce$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $152731e34fd023ce$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $WB9ys.from(stream);
    };
    if (streams.length === 1 && $152731e34fd023ce$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $152731e34fd023ce$var$ERR_MISSING_ARGS('streams');
    var ac = new $152731e34fd023ce$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $152731e34fd023ce$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $152731e34fd023ce$var$AbortError());
    }
    $152731e34fd023ce$var$addAbortListener = $152731e34fd023ce$var$addAbortListener || (parcelRequire("kZ6jV")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $152731e34fd023ce$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$152731e34fd023ce$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $152731e34fd023ce$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $152731e34fd023ce$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($152731e34fd023ce$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2yyE0(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2yyE0(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $152731e34fd023ce$var$pipelineImpl,
    pipeline: $152731e34fd023ce$var$pipeline
};

});
parcelRegister("5nXCW", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3bC1q = parcelRequire("3bC1q");
/* replacement end */ var $3ebd5a702c4c19ee$var$aggregateTwoErrors = $3bC1q.aggregateTwoErrors, $3ebd5a702c4c19ee$var$ERR_MULTIPLE_CALLBACK = $3bC1q.codes.ERR_MULTIPLE_CALLBACK, $3ebd5a702c4c19ee$var$AbortError = $3bC1q.AbortError;

var $dQoAF = parcelRequire("dQoAF");
var $3ebd5a702c4c19ee$require$Symbol = $dQoAF.Symbol;

var $14flQ = parcelRequire("14flQ");
var $3ebd5a702c4c19ee$var$kIsDestroyed = $14flQ.kIsDestroyed, $3ebd5a702c4c19ee$var$isDestroyed = $14flQ.isDestroyed, $3ebd5a702c4c19ee$var$isFinished = $14flQ.isFinished, $3ebd5a702c4c19ee$var$isServerRequest = $14flQ.isServerRequest;
var $3ebd5a702c4c19ee$var$kDestroy = $3ebd5a702c4c19ee$require$Symbol('kDestroy');
var $3ebd5a702c4c19ee$var$kConstruct = $3ebd5a702c4c19ee$require$Symbol('kConstruct');
function $3ebd5a702c4c19ee$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $3ebd5a702c4c19ee$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $3ebd5a702c4c19ee$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($3ebd5a702c4c19ee$var$kDestroy, function(er) {
        $3ebd5a702c4c19ee$var$_destroy(this, $3ebd5a702c4c19ee$var$aggregateTwoErrors(er, err), cb);
    });
    else $3ebd5a702c4c19ee$var$_destroy(this, err, cb);
    return this;
}
function $3ebd5a702c4c19ee$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $3ebd5a702c4c19ee$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $3ebd5a702c4c19ee$var$emitErrorCloseNT(self, err) {
    $3ebd5a702c4c19ee$var$emitErrorNT(self, err);
    $3ebd5a702c4c19ee$var$emitCloseNT(self);
}
function $3ebd5a702c4c19ee$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $3ebd5a702c4c19ee$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $3ebd5a702c4c19ee$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $3ebd5a702c4c19ee$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitErrorNT, stream, err);
        else $3ebd5a702c4c19ee$var$emitErrorNT(stream, err);
    }
}
function $3ebd5a702c4c19ee$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($3ebd5a702c4c19ee$var$kConstruct, cb);
    if (stream.listenerCount($3ebd5a702c4c19ee$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($3ebd5a702c4c19ee$var$constructNT, stream);
}
function $3ebd5a702c4c19ee$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $3ebd5a702c4c19ee$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $3ebd5a702c4c19ee$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($3ebd5a702c4c19ee$var$kDestroy, err);
        else if (err) $3ebd5a702c4c19ee$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $3ebd5a702c4c19ee$var$emitConstructNT(stream) {
    stream.emit($3ebd5a702c4c19ee$var$kConstruct);
}
function $3ebd5a702c4c19ee$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $3ebd5a702c4c19ee$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $3ebd5a702c4c19ee$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $3ebd5a702c4c19ee$var$destroyer(stream, err) {
    if (!stream || $3ebd5a702c4c19ee$var$isDestroyed(stream)) return;
    if (!err && !$3ebd5a702c4c19ee$var$isFinished(stream)) err = new $3ebd5a702c4c19ee$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($3ebd5a702c4c19ee$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($3ebd5a702c4c19ee$var$isRequest(stream)) stream.abort();
    else if ($3ebd5a702c4c19ee$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($3ebd5a702c4c19ee$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$3ebd5a702c4c19ee$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $3ebd5a702c4c19ee$var$construct,
    destroyer: $3ebd5a702c4c19ee$var$destroyer,
    destroy: $3ebd5a702c4c19ee$var$destroy,
    undestroy: $3ebd5a702c4c19ee$var$undestroy,
    errorOrDestroy: $3ebd5a702c4c19ee$var$errorOrDestroy
};

});

parcelRegister("WB9ys", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $0b023cba72199dcf$var$ObjectDefineProperties = $dQoAF.ObjectDefineProperties, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor = $dQoAF.ObjectGetOwnPropertyDescriptor, $0b023cba72199dcf$var$ObjectKeys = $dQoAF.ObjectKeys, $0b023cba72199dcf$var$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf;
module.exports = $0b023cba72199dcf$var$Duplex;

var $ghfC5 = parcelRequire("ghfC5");

var $dQ4MS = parcelRequire("dQ4MS");
$0b023cba72199dcf$var$ObjectSetPrototypeOf($0b023cba72199dcf$var$Duplex.prototype, $ghfC5.prototype);
$0b023cba72199dcf$var$ObjectSetPrototypeOf($0b023cba72199dcf$var$Duplex, $ghfC5);
{
    var $0b023cba72199dcf$var$keys = $0b023cba72199dcf$var$ObjectKeys($dQ4MS.prototype);
    // Allow the keys array to be GC'ed.
    for(var $0b023cba72199dcf$var$i = 0; $0b023cba72199dcf$var$i < $0b023cba72199dcf$var$keys.length; $0b023cba72199dcf$var$i++){
        var $0b023cba72199dcf$var$method = $0b023cba72199dcf$var$keys[$0b023cba72199dcf$var$i];
        if (!$0b023cba72199dcf$var$Duplex.prototype[$0b023cba72199dcf$var$method]) $0b023cba72199dcf$var$Duplex.prototype[$0b023cba72199dcf$var$method] = $dQ4MS.prototype[$0b023cba72199dcf$var$method];
    }
}function $0b023cba72199dcf$var$Duplex(options) {
    if (!(this instanceof $0b023cba72199dcf$var$Duplex)) return new $0b023cba72199dcf$var$Duplex(options);
    $ghfC5.call(this, options);
    $dQ4MS.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$0b023cba72199dcf$var$ObjectDefineProperties($0b023cba72199dcf$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $0b023cba72199dcf$var$ObjectGetOwnPropertyDescriptor($dQ4MS.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $0b023cba72199dcf$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0b023cba72199dcf$var$lazyWebStreams() {
    if ($0b023cba72199dcf$var$webStreamsAdapters === undefined) $0b023cba72199dcf$var$webStreamsAdapters = {};
    return $0b023cba72199dcf$var$webStreamsAdapters;
}
$0b023cba72199dcf$var$Duplex.fromWeb = function(pair, options) {
    return $0b023cba72199dcf$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$0b023cba72199dcf$var$Duplex.toWeb = function(duplex) {
    return $0b023cba72199dcf$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $0b023cba72199dcf$var$duplexify;

$0b023cba72199dcf$var$Duplex.from = function(body) {
    if (!$0b023cba72199dcf$var$duplexify) $0b023cba72199dcf$var$duplexify = (parcelRequire("4sF8T"));
    return $0b023cba72199dcf$var$duplexify(body, 'body');
};

});
parcelRegister("ghfC5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $dQoAF = parcelRequire("dQoAF");
/* replacement end */ var $bd9a58538672a6a0$var$ArrayPrototypeIndexOf = $dQoAF.ArrayPrototypeIndexOf, $bd9a58538672a6a0$var$NumberIsInteger = $dQoAF.NumberIsInteger, $bd9a58538672a6a0$var$NumberIsNaN = $dQoAF.NumberIsNaN, $bd9a58538672a6a0$var$NumberParseInt = $dQoAF.NumberParseInt, $bd9a58538672a6a0$var$ObjectDefineProperties = $dQoAF.ObjectDefineProperties, $bd9a58538672a6a0$var$ObjectKeys = $dQoAF.ObjectKeys, $bd9a58538672a6a0$var$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf, $bd9a58538672a6a0$var$Promise = $dQoAF.Promise, $bd9a58538672a6a0$var$SafeSet = $dQoAF.SafeSet, $bd9a58538672a6a0$var$SymbolAsyncDispose = $dQoAF.SymbolAsyncDispose, $bd9a58538672a6a0$var$SymbolAsyncIterator = $dQoAF.SymbolAsyncIterator, $bd9a58538672a6a0$var$Symbol = $dQoAF.Symbol;
module.exports = $bd9a58538672a6a0$var$Readable;
$bd9a58538672a6a0$var$Readable.ReadableState = $bd9a58538672a6a0$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $bd9a58538672a6a0$var$EE = $bBoAO.EventEmitter;

var $gFxYk = parcelRequire("gFxYk");
var $bd9a58538672a6a0$var$Stream = $gFxYk.Stream, $bd9a58538672a6a0$var$prependListener = $gFxYk.prependListener;

var $16PNf = parcelRequire("16PNf");
var $bd9a58538672a6a0$require$Buffer = $16PNf.Buffer;

var $kGxTp = parcelRequire("kGxTp");
var $bd9a58538672a6a0$require$addAbortSignal = $kGxTp.addAbortSignal;

var $2yyE0 = parcelRequire("2yyE0");

var $bd9a58538672a6a0$var$debug = (parcelRequire("kZ6jV")).debuglog('stream', function(fn) {
    $bd9a58538672a6a0$var$debug = fn;
});

var $89kCO = parcelRequire("89kCO");

var $5nXCW = parcelRequire("5nXCW");

var $5qFLZ = parcelRequire("5qFLZ");
var $bd9a58538672a6a0$var$getHighWaterMark = $5qFLZ.getHighWaterMark, $bd9a58538672a6a0$var$getDefaultHighWaterMark = $5qFLZ.getDefaultHighWaterMark;

var $3bC1q = parcelRequire("3bC1q");
var $bd9a58538672a6a0$var$aggregateTwoErrors = $3bC1q.aggregateTwoErrors, $bd9a58538672a6a0$var$_require_codes = $3bC1q.codes, $bd9a58538672a6a0$var$ERR_INVALID_ARG_TYPE = $bd9a58538672a6a0$var$_require_codes.ERR_INVALID_ARG_TYPE, $bd9a58538672a6a0$var$ERR_METHOD_NOT_IMPLEMENTED = $bd9a58538672a6a0$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $bd9a58538672a6a0$var$ERR_OUT_OF_RANGE = $bd9a58538672a6a0$var$_require_codes.ERR_OUT_OF_RANGE, $bd9a58538672a6a0$var$ERR_STREAM_PUSH_AFTER_EOF = $bd9a58538672a6a0$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $bd9a58538672a6a0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $bd9a58538672a6a0$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $bd9a58538672a6a0$var$AbortError = $3bC1q.AbortError;

var $7K1q3 = parcelRequire("7K1q3");
var $bd9a58538672a6a0$require$validateObject = $7K1q3.validateObject;
var $bd9a58538672a6a0$var$kPaused = $bd9a58538672a6a0$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $bd9a58538672a6a0$require$StringDecoder = $3Jf7C.StringDecoder;

var $7pJkk = parcelRequire("7pJkk");
$bd9a58538672a6a0$var$ObjectSetPrototypeOf($bd9a58538672a6a0$var$Readable.prototype, $bd9a58538672a6a0$var$Stream.prototype);
$bd9a58538672a6a0$var$ObjectSetPrototypeOf($bd9a58538672a6a0$var$Readable, $bd9a58538672a6a0$var$Stream);
var $bd9a58538672a6a0$var$nop = function() {};
var $bd9a58538672a6a0$var$errorOrDestroy = $5nXCW.errorOrDestroy;
var $bd9a58538672a6a0$var$kObjectMode = 1;
var $bd9a58538672a6a0$var$kEnded = 2;
var $bd9a58538672a6a0$var$kEndEmitted = 4;
var $bd9a58538672a6a0$var$kReading = 8;
var $bd9a58538672a6a0$var$kConstructed = 16;
var $bd9a58538672a6a0$var$kSync = 32;
var $bd9a58538672a6a0$var$kNeedReadable = 64;
var $bd9a58538672a6a0$var$kEmittedReadable = 128;
var $bd9a58538672a6a0$var$kReadableListening = 256;
var $bd9a58538672a6a0$var$kResumeScheduled = 512;
var $bd9a58538672a6a0$var$kErrorEmitted = 1024;
var $bd9a58538672a6a0$var$kEmitClose = 2048;
var $bd9a58538672a6a0$var$kAutoDestroy = 4096;
var $bd9a58538672a6a0$var$kDestroyed = 8192;
var $bd9a58538672a6a0$var$kClosed = 16384;
var $bd9a58538672a6a0$var$kCloseEmitted = 32768;
var $bd9a58538672a6a0$var$kMultiAwaitDrain = 65536;
var $bd9a58538672a6a0$var$kReadingMore = 131072;
var $bd9a58538672a6a0$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $bd9a58538672a6a0$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$bd9a58538672a6a0$var$ObjectDefineProperties($bd9a58538672a6a0$var$ReadableState.prototype, {
    objectMode: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kObjectMode),
    ended: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kEnded),
    endEmitted: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kEndEmitted),
    reading: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kNeedReadable),
    emittedReadable: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kEmittedReadable),
    readableListening: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kReadableListening),
    resumeScheduled: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kErrorEmitted),
    emitClose: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kEmitClose),
    autoDestroy: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kCloseEmitted),
    multiAwaitDrain: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kReadingMore),
    dataEmitted: $bd9a58538672a6a0$var$makeBitMapDescriptor($bd9a58538672a6a0$var$kDataEmitted)
});

function $bd9a58538672a6a0$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("WB9ys"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $bd9a58538672a6a0$var$kEmitClose | $bd9a58538672a6a0$var$kAutoDestroy | $bd9a58538672a6a0$var$kConstructed | $bd9a58538672a6a0$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $bd9a58538672a6a0$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $bd9a58538672a6a0$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $bd9a58538672a6a0$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $bd9a58538672a6a0$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $89kCO();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$bd9a58538672a6a0$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$bd9a58538672a6a0$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$bd9a58538672a6a0$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $bd9a58538672a6a0$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bd9a58538672a6a0$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $bd9a58538672a6a0$var$Readable)) return new $bd9a58538672a6a0$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("WB9ys"));
    this._readableState = new $bd9a58538672a6a0$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $bd9a58538672a6a0$require$addAbortSignal(options.signal, this);
    }
    $bd9a58538672a6a0$var$Stream.call(this, options);
    $5nXCW.construct(this, function() {
        if (_this._readableState.needReadable) $bd9a58538672a6a0$var$maybeReadMore(_this, _this._readableState);
    });
}
$bd9a58538672a6a0$var$Readable.prototype.destroy = $5nXCW.destroy;
$bd9a58538672a6a0$var$Readable.prototype._undestroy = $5nXCW.undestroy;
$bd9a58538672a6a0$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$bd9a58538672a6a0$var$Readable.prototype[$bd9a58538672a6a0$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$bd9a58538672a6a0$var$Readable.prototype[$bd9a58538672a6a0$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $bd9a58538672a6a0$var$AbortError();
        this.destroy(error);
    }
    return new $bd9a58538672a6a0$var$Promise(function(resolve, reject) {
        return $2yyE0(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bd9a58538672a6a0$var$Readable.prototype.push = function(chunk, encoding) {
    return $bd9a58538672a6a0$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$bd9a58538672a6a0$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $bd9a58538672a6a0$var$readableAddChunk(this, chunk, encoding, true);
};
function $bd9a58538672a6a0$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $bd9a58538672a6a0$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $bd9a58538672a6a0$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $bd9a58538672a6a0$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $bd9a58538672a6a0$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $bd9a58538672a6a0$require$Buffer) encoding = '';
        else if ($bd9a58538672a6a0$var$Stream._isUint8Array(chunk)) {
            chunk = $bd9a58538672a6a0$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $bd9a58538672a6a0$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $bd9a58538672a6a0$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$bd9a58538672a6a0$var$kReading;
        $bd9a58538672a6a0$var$onEofChunk(stream, state);
    } else if ((state.state & $bd9a58538672a6a0$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $bd9a58538672a6a0$var$kEndEmitted) !== 0) $bd9a58538672a6a0$var$errorOrDestroy(stream, new $bd9a58538672a6a0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $bd9a58538672a6a0$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $bd9a58538672a6a0$var$errorOrDestroy(stream, new $bd9a58538672a6a0$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$bd9a58538672a6a0$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $bd9a58538672a6a0$var$addChunk(stream, state, chunk, false);
                else $bd9a58538672a6a0$var$maybeReadMore(stream, state);
            } else $bd9a58538672a6a0$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$bd9a58538672a6a0$var$kReading;
        $bd9a58538672a6a0$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bd9a58538672a6a0$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $bd9a58538672a6a0$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $bd9a58538672a6a0$var$kNeedReadable) !== 0) $bd9a58538672a6a0$var$emitReadable(stream);
    }
    $bd9a58538672a6a0$var$maybeReadMore(stream, state);
}
$bd9a58538672a6a0$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$bd9a58538672a6a0$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$bd9a58538672a6a0$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $bd9a58538672a6a0$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$bd9a58538672a6a0$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $bd9a58538672a6a0$var$MAX_HWM = 0x40000000;
function $bd9a58538672a6a0$var$computeNewHighWaterMark(n) {
    if (n > $bd9a58538672a6a0$var$MAX_HWM) throw new $bd9a58538672a6a0$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bd9a58538672a6a0$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $bd9a58538672a6a0$var$kObjectMode) !== 0) return 1;
    if ($bd9a58538672a6a0$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$bd9a58538672a6a0$var$Readable.prototype.read = function(n) {
    $bd9a58538672a6a0$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$bd9a58538672a6a0$var$NumberIsInteger(n)) n = $bd9a58538672a6a0$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bd9a58538672a6a0$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$bd9a58538672a6a0$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bd9a58538672a6a0$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bd9a58538672a6a0$var$endReadable(this);
        else $bd9a58538672a6a0$var$emitReadable(this);
        return null;
    }
    n = $bd9a58538672a6a0$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bd9a58538672a6a0$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $bd9a58538672a6a0$var$kNeedReadable) !== 0;
    $bd9a58538672a6a0$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bd9a58538672a6a0$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $bd9a58538672a6a0$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $bd9a58538672a6a0$var$debug('do read');
        state.state |= $bd9a58538672a6a0$var$kReading | $bd9a58538672a6a0$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $bd9a58538672a6a0$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $bd9a58538672a6a0$var$errorOrDestroy(this, err);
        }
        state.state &= ~$bd9a58538672a6a0$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bd9a58538672a6a0$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bd9a58538672a6a0$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bd9a58538672a6a0$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $bd9a58538672a6a0$var$onEofChunk(stream, state) {
    $bd9a58538672a6a0$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $bd9a58538672a6a0$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $bd9a58538672a6a0$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bd9a58538672a6a0$var$emitReadable(stream) {
    var state = stream._readableState;
    $bd9a58538672a6a0$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bd9a58538672a6a0$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($bd9a58538672a6a0$var$emitReadable_, stream);
    }
}
function $bd9a58538672a6a0$var$emitReadable_(stream) {
    var state = stream._readableState;
    $bd9a58538672a6a0$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bd9a58538672a6a0$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bd9a58538672a6a0$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($bd9a58538672a6a0$var$maybeReadMore_, stream, state);
    }
}
function $bd9a58538672a6a0$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $bd9a58538672a6a0$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bd9a58538672a6a0$var$Readable.prototype._read = function(n) {
    throw new $bd9a58538672a6a0$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$bd9a58538672a6a0$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $bd9a58538672a6a0$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $bd9a58538672a6a0$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bd9a58538672a6a0$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bd9a58538672a6a0$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $bd9a58538672a6a0$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $bd9a58538672a6a0$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $bd9a58538672a6a0$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $bd9a58538672a6a0$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $bd9a58538672a6a0$var$debug('ondata');
        var ret = dest.write(chunk);
        $bd9a58538672a6a0$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bd9a58538672a6a0$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $bd9a58538672a6a0$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $bd9a58538672a6a0$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bd9a58538672a6a0$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bd9a58538672a6a0$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $bd9a58538672a6a0$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bd9a58538672a6a0$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $bd9a58538672a6a0$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $bd9a58538672a6a0$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$bd9a58538672a6a0$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $bd9a58538672a6a0$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$bd9a58538672a6a0$var$Readable.prototype.on = function(ev, fn) {
    var res = $bd9a58538672a6a0$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bd9a58538672a6a0$var$debug('on readable', state.length, state.reading);
            if (state.length) $bd9a58538672a6a0$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($bd9a58538672a6a0$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bd9a58538672a6a0$var$Readable.prototype.addListener = $bd9a58538672a6a0$var$Readable.prototype.on;
$bd9a58538672a6a0$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $bd9a58538672a6a0$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($bd9a58538672a6a0$var$updateReadableListening, this);
    return res;
};
$bd9a58538672a6a0$var$Readable.prototype.off = $bd9a58538672a6a0$var$Readable.prototype.removeListener;
$bd9a58538672a6a0$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $bd9a58538672a6a0$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($bd9a58538672a6a0$var$updateReadableListening, this);
    return res;
};
function $bd9a58538672a6a0$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$bd9a58538672a6a0$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $bd9a58538672a6a0$var$nReadingNextTick(self) {
    $bd9a58538672a6a0$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bd9a58538672a6a0$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bd9a58538672a6a0$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $bd9a58538672a6a0$var$resume(this, state);
    }
    state[$bd9a58538672a6a0$var$kPaused] = false;
    return this;
};
function $bd9a58538672a6a0$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($bd9a58538672a6a0$var$resume_, stream, state);
    }
}
function $bd9a58538672a6a0$var$resume_(stream, state) {
    $bd9a58538672a6a0$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $bd9a58538672a6a0$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bd9a58538672a6a0$var$Readable.prototype.pause = function() {
    $bd9a58538672a6a0$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bd9a58538672a6a0$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$bd9a58538672a6a0$var$kPaused] = true;
    return this;
};
function $bd9a58538672a6a0$var$flow(stream) {
    var state = stream._readableState;
    $bd9a58538672a6a0$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bd9a58538672a6a0$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $bd9a58538672a6a0$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $bd9a58538672a6a0$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$bd9a58538672a6a0$var$Readable.prototype[$bd9a58538672a6a0$var$SymbolAsyncIterator] = function() {
    return $bd9a58538672a6a0$var$streamToAsyncIterator(this);
};
$bd9a58538672a6a0$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $bd9a58538672a6a0$require$validateObject(options, 'options');
    return $bd9a58538672a6a0$var$streamToAsyncIterator(this, options);
};
function $bd9a58538672a6a0$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $bd9a58538672a6a0$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $bd9a58538672a6a0$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $bd9a58538672a6a0$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $bd9a58538672a6a0$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $bd9a58538672a6a0$var$nop;
                    stream.on('readable', next);
                    cleanup = $2yyE0(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $bd9a58538672a6a0$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $bd9a58538672a6a0$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $bd9a58538672a6a0$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $bd9a58538672a6a0$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $5nXCW.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$bd9a58538672a6a0$var$ObjectDefineProperties($bd9a58538672a6a0$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$bd9a58538672a6a0$var$ObjectDefineProperties($bd9a58538672a6a0$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$bd9a58538672a6a0$var$kPaused] !== false;
        },
        set: function(value) {
            this[$bd9a58538672a6a0$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$bd9a58538672a6a0$var$Readable._fromList = $bd9a58538672a6a0$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bd9a58538672a6a0$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bd9a58538672a6a0$var$endReadable(stream) {
    var state = stream._readableState;
    $bd9a58538672a6a0$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($bd9a58538672a6a0$var$endReadableNT, state, stream);
    }
}
function $bd9a58538672a6a0$var$endReadableNT(state, stream) {
    $bd9a58538672a6a0$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($bd9a58538672a6a0$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $bd9a58538672a6a0$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$bd9a58538672a6a0$var$Readable.from = function(iterable, opts) {
    return $7pJkk($bd9a58538672a6a0$var$Readable, iterable, opts);
};
var $bd9a58538672a6a0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $bd9a58538672a6a0$var$lazyWebStreams() {
    if ($bd9a58538672a6a0$var$webStreamsAdapters === undefined) $bd9a58538672a6a0$var$webStreamsAdapters = {};
    return $bd9a58538672a6a0$var$webStreamsAdapters;
}
$bd9a58538672a6a0$var$Readable.fromWeb = function(readableStream, options) {
    return $bd9a58538672a6a0$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$bd9a58538672a6a0$var$Readable.toWeb = function(streamReadable, options) {
    return $bd9a58538672a6a0$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$bd9a58538672a6a0$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $bd9a58538672a6a0$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $5nXCW.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("gFxYk", function(module, exports) {
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $c22ad3cfa8fefe60$var$ArrayIsArray = $dQoAF.ArrayIsArray, $c22ad3cfa8fefe60$var$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $c22ad3cfa8fefe60$var$EE = $bBoAO.EventEmitter;
function $c22ad3cfa8fefe60$var$Stream(opts) {
    $c22ad3cfa8fefe60$var$EE.call(this, opts);
}
$c22ad3cfa8fefe60$var$ObjectSetPrototypeOf($c22ad3cfa8fefe60$var$Stream.prototype, $c22ad3cfa8fefe60$var$EE.prototype);
$c22ad3cfa8fefe60$var$ObjectSetPrototypeOf($c22ad3cfa8fefe60$var$Stream, $c22ad3cfa8fefe60$var$EE);
$c22ad3cfa8fefe60$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($c22ad3cfa8fefe60$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $c22ad3cfa8fefe60$var$prependListener(source, 'error', onerror);
    $c22ad3cfa8fefe60$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $c22ad3cfa8fefe60$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($c22ad3cfa8fefe60$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $c22ad3cfa8fefe60$var$Stream,
    prependListener: $c22ad3cfa8fefe60$var$prependListener
};

});

parcelRegister("kGxTp", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $f0f2054a6370c405$export$e2db56ee53255a0; }, function (v) { return $f0f2054a6370c405$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $f0f2054a6370c405$export$11956e9313f43de0; }, function (v) { return $f0f2054a6370c405$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $f0f2054a6370c405$export$e2db56ee53255a0;
var $f0f2054a6370c405$export$11956e9313f43de0;
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $f0f2054a6370c405$require$SymbolDispose = $dQoAF.SymbolDispose;

var $3bC1q = parcelRequire("3bC1q");
var $f0f2054a6370c405$var$AbortError = $3bC1q.AbortError, $f0f2054a6370c405$var$codes = $3bC1q.codes;

var $14flQ = parcelRequire("14flQ");
var $f0f2054a6370c405$var$isNodeStream = $14flQ.isNodeStream, $f0f2054a6370c405$var$isWebStream = $14flQ.isWebStream, $f0f2054a6370c405$var$kControllerErrorFunction = $14flQ.kControllerErrorFunction;

var $2yyE0 = parcelRequire("2yyE0");
var $f0f2054a6370c405$var$ERR_INVALID_ARG_TYPE = $f0f2054a6370c405$var$codes.ERR_INVALID_ARG_TYPE;
var $f0f2054a6370c405$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $f0f2054a6370c405$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $f0f2054a6370c405$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$f0f2054a6370c405$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $f0f2054a6370c405$var$validateAbortSignal(signal, 'signal');
    if (!$f0f2054a6370c405$var$isNodeStream(stream) && !$f0f2054a6370c405$var$isWebStream(stream)) throw new $f0f2054a6370c405$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $f0f2054a6370c405$export$11956e9313f43de0(signal, stream);
};

$f0f2054a6370c405$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $f0f2054a6370c405$var$isNodeStream(stream) ? function() {
        stream.destroy(new $f0f2054a6370c405$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$f0f2054a6370c405$var$kControllerErrorFunction](new $f0f2054a6370c405$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $f0f2054a6370c405$var$addAbortListener = $f0f2054a6370c405$var$addAbortListener || (parcelRequire("kZ6jV")).addAbortListener;
        var disposable = $f0f2054a6370c405$var$addAbortListener(signal, onAbort);
        $2yyE0(stream, disposable[$f0f2054a6370c405$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("89kCO", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $5eef29b45f5feaec$var$StringPrototypeSlice = $dQoAF.StringPrototypeSlice, $5eef29b45f5feaec$var$SymbolIterator = $dQoAF.SymbolIterator, $5eef29b45f5feaec$var$TypedArrayPrototypeSet = $dQoAF.TypedArrayPrototypeSet, $5eef29b45f5feaec$var$Uint8Array = $dQoAF.Uint8Array;

var $16PNf = parcelRequire("16PNf");
var $5eef29b45f5feaec$require$Buffer = $16PNf.Buffer;

var $kZ6jV = parcelRequire("kZ6jV");
var $5eef29b45f5feaec$require$inspect = $kZ6jV.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $5eef29b45f5feaec$require$Buffer.alloc(0);
                var ret = $5eef29b45f5feaec$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $5eef29b45f5feaec$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $5eef29b45f5feaec$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $5eef29b45f5feaec$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $5eef29b45f5feaec$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $5eef29b45f5feaec$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $5eef29b45f5feaec$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $5eef29b45f5feaec$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $5eef29b45f5feaec$var$TypedArrayPrototypeSet(ret, new $5eef29b45f5feaec$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $5eef29b45f5feaec$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("5qFLZ", function(module, exports) {
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $3f3fc8b15d196408$var$MathFloor = $dQoAF.MathFloor, $3f3fc8b15d196408$var$NumberIsInteger = $dQoAF.NumberIsInteger;

var $7K1q3 = parcelRequire("7K1q3");
var $3f3fc8b15d196408$require$validateInteger = $7K1q3.validateInteger;

var $3f3fc8b15d196408$var$ERR_INVALID_ARG_VALUE = (parcelRequire("3bC1q")).codes.ERR_INVALID_ARG_VALUE;
var $3f3fc8b15d196408$var$defaultHighWaterMarkBytes = 16384;
var $3f3fc8b15d196408$var$defaultHighWaterMarkObjectMode = 16;
function $3f3fc8b15d196408$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3f3fc8b15d196408$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $3f3fc8b15d196408$var$defaultHighWaterMarkObjectMode : $3f3fc8b15d196408$var$defaultHighWaterMarkBytes;
}
function $3f3fc8b15d196408$var$setDefaultHighWaterMark(objectMode, value) {
    $3f3fc8b15d196408$require$validateInteger(value, 'value', 0);
    if (objectMode) $3f3fc8b15d196408$var$defaultHighWaterMarkObjectMode = value;
    else $3f3fc8b15d196408$var$defaultHighWaterMarkBytes = value;
}
function $3f3fc8b15d196408$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $3f3fc8b15d196408$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$3f3fc8b15d196408$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $3f3fc8b15d196408$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $3f3fc8b15d196408$var$MathFloor(hwm);
    }
    // Default value
    return $3f3fc8b15d196408$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $3f3fc8b15d196408$var$getHighWaterMark,
    getDefaultHighWaterMark: $3f3fc8b15d196408$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $3f3fc8b15d196408$var$setDefaultHighWaterMark
};

});

parcelRegister("7pJkk", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $dQoAF = parcelRequire("dQoAF");
/* replacement end */ var $565e072d33066c91$var$PromisePrototypeThen = $dQoAF.PromisePrototypeThen, $565e072d33066c91$var$SymbolAsyncIterator = $dQoAF.SymbolAsyncIterator, $565e072d33066c91$var$SymbolIterator = $dQoAF.SymbolIterator;

var $16PNf = parcelRequire("16PNf");
var $565e072d33066c91$require$Buffer = $16PNf.Buffer;

var $3bC1q = parcelRequire("3bC1q");
var $565e072d33066c91$require$_require_codes = $3bC1q.codes;
var $565e072d33066c91$var$ERR_INVALID_ARG_TYPE = $565e072d33066c91$require$_require_codes.ERR_INVALID_ARG_TYPE, $565e072d33066c91$var$ERR_STREAM_NULL_VALUES = $565e072d33066c91$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $565e072d33066c91$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $565e072d33066c91$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$565e072d33066c91$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$565e072d33066c91$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$565e072d33066c91$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$565e072d33066c91$var$SymbolIterator]();
    } else throw new $565e072d33066c91$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $565e072d33066c91$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $565e072d33066c91$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $565e072d33066c91$var$from;

});


parcelRegister("dQ4MS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $dQoAF = parcelRequire("dQoAF");
/* replacement end */ var $a133d85fc09fbfc7$var$ArrayPrototypeSlice = $dQoAF.ArrayPrototypeSlice, $a133d85fc09fbfc7$var$Error = $dQoAF.Error, $a133d85fc09fbfc7$var$FunctionPrototypeSymbolHasInstance = $dQoAF.FunctionPrototypeSymbolHasInstance, $a133d85fc09fbfc7$var$ObjectDefineProperty = $dQoAF.ObjectDefineProperty, $a133d85fc09fbfc7$var$ObjectDefineProperties = $dQoAF.ObjectDefineProperties, $a133d85fc09fbfc7$var$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf, $a133d85fc09fbfc7$var$StringPrototypeToLowerCase = $dQoAF.StringPrototypeToLowerCase, $a133d85fc09fbfc7$var$Symbol = $dQoAF.Symbol, $a133d85fc09fbfc7$var$SymbolHasInstance = $dQoAF.SymbolHasInstance;
module.exports = $a133d85fc09fbfc7$var$Writable;
$a133d85fc09fbfc7$var$Writable.WritableState = $a133d85fc09fbfc7$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a133d85fc09fbfc7$var$EE = $bBoAO.EventEmitter;

var $gFxYk = parcelRequire("gFxYk");
var $a133d85fc09fbfc7$require$Stream = $gFxYk.Stream;

var $16PNf = parcelRequire("16PNf");
var $a133d85fc09fbfc7$require$Buffer = $16PNf.Buffer;

var $5nXCW = parcelRequire("5nXCW");

var $kGxTp = parcelRequire("kGxTp");
var $a133d85fc09fbfc7$require$addAbortSignal = $kGxTp.addAbortSignal;

var $5qFLZ = parcelRequire("5qFLZ");
var $a133d85fc09fbfc7$var$getHighWaterMark = $5qFLZ.getHighWaterMark, $a133d85fc09fbfc7$var$getDefaultHighWaterMark = $5qFLZ.getDefaultHighWaterMark;

var $3bC1q = parcelRequire("3bC1q");
var $a133d85fc09fbfc7$require$_require_codes = $3bC1q.codes;
var $a133d85fc09fbfc7$var$ERR_INVALID_ARG_TYPE = $a133d85fc09fbfc7$require$_require_codes.ERR_INVALID_ARG_TYPE, $a133d85fc09fbfc7$var$ERR_METHOD_NOT_IMPLEMENTED = $a133d85fc09fbfc7$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a133d85fc09fbfc7$var$ERR_MULTIPLE_CALLBACK = $a133d85fc09fbfc7$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a133d85fc09fbfc7$var$ERR_STREAM_CANNOT_PIPE = $a133d85fc09fbfc7$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED = $a133d85fc09fbfc7$require$_require_codes.ERR_STREAM_DESTROYED, $a133d85fc09fbfc7$var$ERR_STREAM_ALREADY_FINISHED = $a133d85fc09fbfc7$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a133d85fc09fbfc7$var$ERR_STREAM_NULL_VALUES = $a133d85fc09fbfc7$require$_require_codes.ERR_STREAM_NULL_VALUES, $a133d85fc09fbfc7$var$ERR_STREAM_WRITE_AFTER_END = $a133d85fc09fbfc7$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a133d85fc09fbfc7$var$ERR_UNKNOWN_ENCODING = $a133d85fc09fbfc7$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a133d85fc09fbfc7$var$errorOrDestroy = $5nXCW.errorOrDestroy;
$a133d85fc09fbfc7$var$ObjectSetPrototypeOf($a133d85fc09fbfc7$var$Writable.prototype, $a133d85fc09fbfc7$require$Stream.prototype);
$a133d85fc09fbfc7$var$ObjectSetPrototypeOf($a133d85fc09fbfc7$var$Writable, $a133d85fc09fbfc7$require$Stream);
function $a133d85fc09fbfc7$var$nop() {}
var $a133d85fc09fbfc7$var$kOnFinished = $a133d85fc09fbfc7$var$Symbol('kOnFinished');

function $a133d85fc09fbfc7$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("WB9ys"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a133d85fc09fbfc7$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a133d85fc09fbfc7$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a133d85fc09fbfc7$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a133d85fc09fbfc7$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a133d85fc09fbfc7$var$kOnFinished] = [];
}
function $a133d85fc09fbfc7$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a133d85fc09fbfc7$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a133d85fc09fbfc7$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a133d85fc09fbfc7$var$ObjectDefineProperty($a133d85fc09fbfc7$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a133d85fc09fbfc7$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("WB9ys"));
    if (!isDuplex && !$a133d85fc09fbfc7$var$FunctionPrototypeSymbolHasInstance($a133d85fc09fbfc7$var$Writable, this)) return new $a133d85fc09fbfc7$var$Writable(options);
    this._writableState = new $a133d85fc09fbfc7$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a133d85fc09fbfc7$require$addAbortSignal(options.signal, this);
    }
    $a133d85fc09fbfc7$require$Stream.call(this, options);
    $5nXCW.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a133d85fc09fbfc7$var$clearBuffer(_this, state);
        $a133d85fc09fbfc7$var$finishMaybe(_this, state);
    });
}
$a133d85fc09fbfc7$var$ObjectDefineProperty($a133d85fc09fbfc7$var$Writable, $a133d85fc09fbfc7$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a133d85fc09fbfc7$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a133d85fc09fbfc7$var$Writable) return false;
        return object && object._writableState instanceof $a133d85fc09fbfc7$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a133d85fc09fbfc7$var$Writable.prototype.pipe = function() {
    $a133d85fc09fbfc7$var$errorOrDestroy(this, new $a133d85fc09fbfc7$var$ERR_STREAM_CANNOT_PIPE());
};
function $a133d85fc09fbfc7$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a133d85fc09fbfc7$require$Buffer.isEncoding(encoding)) throw new $a133d85fc09fbfc7$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a133d85fc09fbfc7$var$nop;
    }
    if (chunk === null) throw new $a133d85fc09fbfc7$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a133d85fc09fbfc7$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a133d85fc09fbfc7$require$Buffer) encoding = 'buffer';
        else if ($a133d85fc09fbfc7$require$Stream._isUint8Array(chunk)) {
            chunk = $a133d85fc09fbfc7$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a133d85fc09fbfc7$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a133d85fc09fbfc7$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a133d85fc09fbfc7$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a133d85fc09fbfc7$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a133d85fc09fbfc7$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a133d85fc09fbfc7$var$_write(this, chunk, encoding, cb) === true;
};
$a133d85fc09fbfc7$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a133d85fc09fbfc7$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a133d85fc09fbfc7$var$clearBuffer(this, state);
    }
};
$a133d85fc09fbfc7$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a133d85fc09fbfc7$var$StringPrototypeToLowerCase(encoding);
    if (!$a133d85fc09fbfc7$require$Buffer.isEncoding(encoding)) throw new $a133d85fc09fbfc7$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a133d85fc09fbfc7$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a133d85fc09fbfc7$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a133d85fc09fbfc7$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a133d85fc09fbfc7$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a133d85fc09fbfc7$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a133d85fc09fbfc7$var$errorOrDestroy(stream, er);
}
function $a133d85fc09fbfc7$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a133d85fc09fbfc7$var$errorOrDestroy(stream, new $a133d85fc09fbfc7$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a133d85fc09fbfc7$var$onwriteError, stream, state, er, cb);
        else $a133d85fc09fbfc7$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a133d85fc09fbfc7$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a133d85fc09fbfc7$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a133d85fc09fbfc7$var$afterWrite(stream, state, 1, cb);
    }
}
function $a133d85fc09fbfc7$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a133d85fc09fbfc7$var$afterWrite(stream, state, count, cb);
}
function $a133d85fc09fbfc7$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a133d85fc09fbfc7$var$errorBuffer(state);
    $a133d85fc09fbfc7$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a133d85fc09fbfc7$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a133d85fc09fbfc7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED('end'));
    }
    $a133d85fc09fbfc7$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a133d85fc09fbfc7$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a133d85fc09fbfc7$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a133d85fc09fbfc7$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a133d85fc09fbfc7$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a133d85fc09fbfc7$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a133d85fc09fbfc7$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a133d85fc09fbfc7$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a133d85fc09fbfc7$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a133d85fc09fbfc7$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a133d85fc09fbfc7$var$Writable.prototype._writev = null;
$a133d85fc09fbfc7$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a133d85fc09fbfc7$var$_write(this, chunk, encoding);
        if (ret instanceof $a133d85fc09fbfc7$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a133d85fc09fbfc7$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a133d85fc09fbfc7$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a133d85fc09fbfc7$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a133d85fc09fbfc7$var$kOnFinished].push(cb);
    }
    return this;
};
function $a133d85fc09fbfc7$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a133d85fc09fbfc7$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a133d85fc09fbfc7$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a133d85fc09fbfc7$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a133d85fc09fbfc7$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a133d85fc09fbfc7$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a133d85fc09fbfc7$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a133d85fc09fbfc7$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a133d85fc09fbfc7$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a133d85fc09fbfc7$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a133d85fc09fbfc7$var$finishMaybe(stream, state, sync) {
    if ($a133d85fc09fbfc7$var$needFinish(state)) {
        $a133d85fc09fbfc7$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a133d85fc09fbfc7$var$needFinish(state)) $a133d85fc09fbfc7$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a133d85fc09fbfc7$var$needFinish(state)) {
                state.pendingcb++;
                $a133d85fc09fbfc7$var$finish(stream, state);
            }
        }
    }
}
function $a133d85fc09fbfc7$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a133d85fc09fbfc7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a133d85fc09fbfc7$var$ObjectDefineProperties($a133d85fc09fbfc7$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a133d85fc09fbfc7$var$destroy = $5nXCW.destroy;
$a133d85fc09fbfc7$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a133d85fc09fbfc7$var$kOnFinished].length)) $2Qkr5.nextTick($a133d85fc09fbfc7$var$errorBuffer, state);
    $a133d85fc09fbfc7$var$destroy.call(this, err, cb);
    return this;
};
$a133d85fc09fbfc7$var$Writable.prototype._undestroy = $5nXCW.undestroy;
$a133d85fc09fbfc7$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a133d85fc09fbfc7$var$Writable.prototype[$a133d85fc09fbfc7$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a133d85fc09fbfc7$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a133d85fc09fbfc7$var$lazyWebStreams() {
    if ($a133d85fc09fbfc7$var$webStreamsAdapters === undefined) $a133d85fc09fbfc7$var$webStreamsAdapters = {};
    return $a133d85fc09fbfc7$var$webStreamsAdapters;
}
$a133d85fc09fbfc7$var$Writable.fromWeb = function(writableStream, options) {
    return $a133d85fc09fbfc7$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a133d85fc09fbfc7$var$Writable.toWeb = function(streamWritable) {
    return $a133d85fc09fbfc7$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("4sF8T", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $16PNf = parcelRequire("16PNf");

var $14flQ = parcelRequire("14flQ");
var $33f9b0fe4ada16a7$var$isReadable = $14flQ.isReadable, $33f9b0fe4ada16a7$var$isWritable = $14flQ.isWritable, $33f9b0fe4ada16a7$var$isIterable = $14flQ.isIterable, $33f9b0fe4ada16a7$var$isNodeStream = $14flQ.isNodeStream, $33f9b0fe4ada16a7$var$isReadableNodeStream = $14flQ.isReadableNodeStream, $33f9b0fe4ada16a7$var$isWritableNodeStream = $14flQ.isWritableNodeStream, $33f9b0fe4ada16a7$var$isDuplexNodeStream = $14flQ.isDuplexNodeStream, $33f9b0fe4ada16a7$var$isReadableStream = $14flQ.isReadableStream, $33f9b0fe4ada16a7$var$isWritableStream = $14flQ.isWritableStream;

var $2yyE0 = parcelRequire("2yyE0");

var $3bC1q = parcelRequire("3bC1q");
var $33f9b0fe4ada16a7$var$AbortError = $3bC1q.AbortError, $33f9b0fe4ada16a7$var$_require_codes = $3bC1q.codes, $33f9b0fe4ada16a7$var$ERR_INVALID_ARG_TYPE = $33f9b0fe4ada16a7$var$_require_codes.ERR_INVALID_ARG_TYPE, $33f9b0fe4ada16a7$var$ERR_INVALID_RETURN_VALUE = $33f9b0fe4ada16a7$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $5nXCW = parcelRequire("5nXCW");
var $33f9b0fe4ada16a7$require$destroyer = $5nXCW.destroyer;

var $WB9ys = parcelRequire("WB9ys");

var $ghfC5 = parcelRequire("ghfC5");

var $dQ4MS = parcelRequire("dQ4MS");

var $kZ6jV = parcelRequire("kZ6jV");
var $33f9b0fe4ada16a7$require$createDeferredPromise = $kZ6jV.createDeferredPromise;

var $7pJkk = parcelRequire("7pJkk");
var $33f9b0fe4ada16a7$var$Blob = globalThis.Blob || $16PNf.Blob;
var $33f9b0fe4ada16a7$var$isBlob = typeof $33f9b0fe4ada16a7$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $33f9b0fe4ada16a7$var$Blob;
} : function isBlob(b) {
    return false;
};

var $33f9b0fe4ada16a7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $dQoAF = parcelRequire("dQoAF");
var $33f9b0fe4ada16a7$require$FunctionPrototypeCall = $dQoAF.FunctionPrototypeCall;
// This is needed for pre node 17.
var $33f9b0fe4ada16a7$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($WB9ys);
module.exports = function duplexify(body, name) {
    if ($33f9b0fe4ada16a7$var$isDuplexNodeStream(body)) return body;
    if ($33f9b0fe4ada16a7$var$isReadableNodeStream(body)) return $33f9b0fe4ada16a7$var$_duplexify({
        readable: body
    });
    if ($33f9b0fe4ada16a7$var$isWritableNodeStream(body)) return $33f9b0fe4ada16a7$var$_duplexify({
        writable: body
    });
    if ($33f9b0fe4ada16a7$var$isNodeStream(body)) return $33f9b0fe4ada16a7$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($33f9b0fe4ada16a7$var$isReadableStream(body)) return $33f9b0fe4ada16a7$var$_duplexify({
        readable: $ghfC5.fromWeb(body)
    });
    if ($33f9b0fe4ada16a7$var$isWritableStream(body)) return $33f9b0fe4ada16a7$var$_duplexify({
        writable: $dQ4MS.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $33f9b0fe4ada16a7$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($33f9b0fe4ada16a7$var$isIterable(value)) return $7pJkk($33f9b0fe4ada16a7$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $33f9b0fe4ada16a7$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $33f9b0fe4ada16a7$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $33f9b0fe4ada16a7$require$destroyer(d, err);
            });
            return d = new $33f9b0fe4ada16a7$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $33f9b0fe4ada16a7$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($33f9b0fe4ada16a7$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($33f9b0fe4ada16a7$var$isIterable(body)) return $7pJkk($33f9b0fe4ada16a7$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($33f9b0fe4ada16a7$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $33f9b0fe4ada16a7$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $33f9b0fe4ada16a7$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $33f9b0fe4ada16a7$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $33f9b0fe4ada16a7$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $33f9b0fe4ada16a7$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $33f9b0fe4ada16a7$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $33f9b0fe4ada16a7$require$destroyer(d1, err);
        });
        return d1 = new $33f9b0fe4ada16a7$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $33f9b0fe4ada16a7$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $33f9b0fe4ada16a7$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $33f9b0fe4ada16a7$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $33f9b0fe4ada16a7$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $33f9b0fe4ada16a7$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $33f9b0fe4ada16a7$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $33f9b0fe4ada16a7$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $ghfC5.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$33f9b0fe4ada16a7$var$isReadable(r);
    var writable = !!$33f9b0fe4ada16a7$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $33f9b0fe4ada16a7$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2yyE0(w, function(err) {
            writable = false;
            if (err) $33f9b0fe4ada16a7$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2yyE0(r, function(err) {
            readable = false;
            if (err) $33f9b0fe4ada16a7$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $33f9b0fe4ada16a7$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $33f9b0fe4ada16a7$require$destroyer(w, err);
            $33f9b0fe4ada16a7$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("jLV2p", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $e64ea6a14f5ac23b$require$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf;
module.exports = $e64ea6a14f5ac23b$var$PassThrough;

var $fFs2u = parcelRequire("fFs2u");
$e64ea6a14f5ac23b$require$ObjectSetPrototypeOf($e64ea6a14f5ac23b$var$PassThrough.prototype, $fFs2u.prototype);
$e64ea6a14f5ac23b$require$ObjectSetPrototypeOf($e64ea6a14f5ac23b$var$PassThrough, $fFs2u);
function $e64ea6a14f5ac23b$var$PassThrough(options) {
    if (!(this instanceof $e64ea6a14f5ac23b$var$PassThrough)) return new $e64ea6a14f5ac23b$var$PassThrough(options);
    $fFs2u.call(this, options);
}
$e64ea6a14f5ac23b$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("fFs2u", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $b6806f53f73dd9ba$var$ObjectSetPrototypeOf = $dQoAF.ObjectSetPrototypeOf, $b6806f53f73dd9ba$var$Symbol = $dQoAF.Symbol;
module.exports = $b6806f53f73dd9ba$var$Transform;

var $b6806f53f73dd9ba$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("3bC1q")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $WB9ys = parcelRequire("WB9ys");

var $5qFLZ = parcelRequire("5qFLZ");
var $b6806f53f73dd9ba$require$getHighWaterMark = $5qFLZ.getHighWaterMark;
$b6806f53f73dd9ba$var$ObjectSetPrototypeOf($b6806f53f73dd9ba$var$Transform.prototype, $WB9ys.prototype);
$b6806f53f73dd9ba$var$ObjectSetPrototypeOf($b6806f53f73dd9ba$var$Transform, $WB9ys);
var $b6806f53f73dd9ba$var$kCallback = $b6806f53f73dd9ba$var$Symbol('kCallback');
function $b6806f53f73dd9ba$var$Transform(options) {
    if (!(this instanceof $b6806f53f73dd9ba$var$Transform)) return new $b6806f53f73dd9ba$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $b6806f53f73dd9ba$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $WB9ys.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$b6806f53f73dd9ba$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $b6806f53f73dd9ba$var$prefinish);
}
function $b6806f53f73dd9ba$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $b6806f53f73dd9ba$var$prefinish() {
    if (this._final !== $b6806f53f73dd9ba$var$_final) $b6806f53f73dd9ba$var$_final.call(this);
}
$b6806f53f73dd9ba$var$Transform.prototype._final = $b6806f53f73dd9ba$var$_final;
$b6806f53f73dd9ba$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $b6806f53f73dd9ba$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$b6806f53f73dd9ba$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$b6806f53f73dd9ba$var$kCallback] = callback;
    });
};
$b6806f53f73dd9ba$var$Transform.prototype._read = function() {
    if (this[$b6806f53f73dd9ba$var$kCallback]) {
        var callback = this[$b6806f53f73dd9ba$var$kCallback];
        this[$b6806f53f73dd9ba$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("fk2lo", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $dQoAF = parcelRequire("dQoAF");
var $b27a8abc1355d0ea$var$ArrayPrototypePop = $dQoAF.ArrayPrototypePop, $b27a8abc1355d0ea$var$Promise = $dQoAF.Promise;

var $14flQ = parcelRequire("14flQ");
var $b27a8abc1355d0ea$var$isIterable = $14flQ.isIterable, $b27a8abc1355d0ea$var$isNodeStream = $14flQ.isNodeStream, $b27a8abc1355d0ea$var$isWebStream = $14flQ.isWebStream;

var $1OB2I = parcelRequire("1OB2I");
var $b27a8abc1355d0ea$var$pl = $1OB2I.pipelineImpl;

var $2yyE0 = parcelRequire("2yyE0");
var $b27a8abc1355d0ea$require$finished = $2yyE0.finished;
parcelRequire("lRddb");
function $b27a8abc1355d0ea$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $b27a8abc1355d0ea$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$b27a8abc1355d0ea$var$isNodeStream(lastArg) && !$b27a8abc1355d0ea$var$isIterable(lastArg) && !$b27a8abc1355d0ea$var$isWebStream(lastArg)) {
            var options = $b27a8abc1355d0ea$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $b27a8abc1355d0ea$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $b27a8abc1355d0ea$require$finished,
    pipeline: $b27a8abc1355d0ea$var$pipeline
};

});



parcelRegister("4l0Zq", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $3289e426f2d46e9c$export$98e6a39c04603d36; }, function (v) { return $3289e426f2d46e9c$export$98e6a39c04603d36 = v; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
var $3289e426f2d46e9c$export$7acfa6ed01010e37;
var $3289e426f2d46e9c$export$98e6a39c04603d36;

var $fCIwl = parcelRequire("fCIwl");
var $3289e426f2d46e9c$require$ShaclcParser = $fCIwl.Parser;
parcelRequire("29pVS");
var $ha9LD = parcelRequire("ha9LD");
var $4lFIc = parcelRequire("4lFIc");
var $3289e426f2d46e9c$var$Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser() {
        (0, $jGAMp._)(this, Parser);
    }
    (0, $byiyg._)(Parser, [
        {
            key: "parse",
            value: function parse(str) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, extendedSyntax = _ref.extendedSyntax, baseIRI = _ref.baseIRI;
                this._parser = new $3289e426f2d46e9c$require$ShaclcParser();
                this._parser.Parser.factory = $ha9LD.default;
                this._parser.Parser.base = $ha9LD.default.namedNode(baseIRI || 'urn:x-base:default');
                this._parser.Parser.extended = extendedSyntax === true;
                this._parser.Parser.prefixes = {
                    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
                    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
                    sh: 'http://www.w3.org/ns/shacl#',
                    xsd: 'http://www.w3.org/2001/XMLSchema#',
                    owl: 'http://www.w3.org/2002/07/owl#'
                };
                this._parser.Parser.currentNodeShape = undefined;
                this._parser.Parser.currentPropertyNode = undefined;
                this._parser.Parser.nodeShapeStack = [];
                this._parser.Parser.tempCurrentNodeShape = undefined;
                this._parser.Parser.n3Parser = new $4lFIc.default({
                    baseIRI: baseIRI || 'urn:x-base:default'
                });
                var arr = [];
                this._parser.Parser.onQuad = function(quad) {
                    arr.push(quad);
                };
                this._parser.parse(str);
                arr.prefixes = this._parser.Parser.prefixes;
                return arr;
            }
        }
    ]);
    return Parser;
}();
$3289e426f2d46e9c$export$7acfa6ed01010e37 = $3289e426f2d46e9c$var$Parser;
$3289e426f2d46e9c$export$98e6a39c04603d36 = function parse(str, options) {
    var parser = new $3289e426f2d46e9c$var$Parser();
    return parser.parse(str, options);
};

});
parcelRegister("fCIwl", function(module, exports) {
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ 
var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");
var $b5fcf07b8ce2f5fd$var$ShaclcParser = function() {
    var o = function o(k, v, _o, l) {
        for(_o = _o || {}, l = k.length; l--; _o[k[l]] = v);
        return _o;
    }, $V0 = [
        7,
        12,
        13,
        14,
        15,
        16,
        20,
        25,
        115,
        130
    ], $V1 = [
        7,
        13,
        16,
        20,
        25,
        115,
        130
    ], $V2 = [
        7,
        13,
        16,
        115,
        130
    ], $V3 = [
        1,
        25
    ], $V4 = [
        1,
        29
    ], $V5 = [
        1,
        27
    ], $V6 = [
        1,
        28
    ], $V7 = [
        13,
        16,
        115,
        130
    ], $V8 = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        61,
        67,
        85,
        87,
        92,
        93,
        95,
        96,
        102,
        110,
        111,
        115,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $V9 = [
        28,
        56
    ], $Va = [
        1,
        42
    ], $Vb = [
        46,
        48,
        53,
        56
    ], $Vc = [
        1,
        54
    ], $Vd = [
        1,
        60
    ], $Ve = [
        1,
        56
    ], $Vf = [
        1,
        57
    ], $Vg = [
        1,
        58
    ], $Vh = [
        1,
        63
    ], $Vi = [
        1,
        64
    ], $Vj = [
        1,
        65
    ], $Vk = [
        1,
        66
    ], $Vl = [
        1,
        67
    ], $Vm = [
        1,
        68
    ], $Vn = [
        1,
        75
    ], $Vo = [
        28,
        46,
        48,
        53,
        56
    ], $Vp = [
        28,
        42,
        46,
        48,
        53,
        56
    ], $Vq = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vr = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        67,
        85,
        87,
        92,
        95,
        96,
        115,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vs = [
        13,
        16,
        38,
        40,
        44,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vt = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        67,
        85,
        87,
        92,
        95,
        96,
        115,
        117,
        118,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vu = [
        13,
        16,
        28,
        56,
        115,
        130
    ], $Vv = [
        13,
        16,
        38,
        58,
        87,
        96,
        109,
        115,
        126,
        130
    ], $Vw = [
        1,
        116
    ], $Vx = [
        1,
        112
    ], $Vy = [
        1,
        108
    ], $Vz = [
        1,
        114
    ], $VA = [
        1,
        111
    ], $VB = [
        7,
        13,
        16,
        20,
        25,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VC = [
        48,
        53
    ], $VD = [
        48,
        53,
        87,
        96,
        126
    ], $VE = [
        13,
        16,
        44,
        48,
        53,
        56,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VF = [
        1,
        126
    ], $VG = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VH = [
        1,
        129
    ], $VI = [
        48,
        53,
        67,
        87,
        96,
        126
    ], $VJ = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VK = [
        1,
        133
    ], $VL = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        102,
        115,
        128,
        129,
        130
    ], $VM = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        93,
        95,
        96,
        102,
        110,
        111,
        115,
        128,
        129,
        130
    ], $VN = [
        1,
        151
    ], $VO = [
        1,
        153
    ], $VP = [
        1,
        156
    ], $VQ = [
        1,
        157
    ], $VR = [
        1,
        158
    ], $VS = [
        1,
        167
    ], $VT = [
        1,
        175
    ], $VU = [
        13,
        16,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VV = [
        13,
        16,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        126,
        128,
        129,
        130
    ], $VW = [
        13,
        16,
        46,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            error: 2,
            shaclDoc: 3,
            shaclDoc_repetition0: 4,
            shaclDoc_repetition1: 5,
            ttlSection: 6,
            EOF: 7,
            directive: 8,
            baseDecl: 9,
            importsDecl: 10,
            prefixDecl: 11,
            KW_BASE: 12,
            IRIREF: 13,
            KW_IMPORTS: 14,
            KW_PREFIX: 15,
            PNAME_NS: 16,
            nodeShapeIri: 17,
            iri: 18,
            nodeShape: 19,
            KW_SHAPE: 20,
            nodeShape_option0: 21,
            nodeShape_option1: 22,
            nodeShapeBody: 23,
            shapeClass: 24,
            KW_SHAPE_CLASS: 25,
            shapeClass_option0: 26,
            turtleAnnotation: 27,
            ";": 28,
            turtleAnnotation2: 29,
            predicate: 30,
            turtleAnnotation2_option0: 31,
            objectList: 32,
            object: 33,
            objectList_repetition0: 34,
            iriOrLiteral: 35,
            blankNodeSection: 36,
            list: 37,
            "(": 38,
            list_repetition0: 39,
            ")": 40,
            objectTail: 41,
            ",": 42,
            LB: 43,
            "[": 44,
            RB: 45,
            "]": 46,
            LP: 47,
            "%": 48,
            RP: 49,
            pcSection: 50,
            iriHead: 51,
            ttlStatement: 52,
            ".": 53,
            ttlSection_repetition0: 54,
            startNodeShape: 55,
            "{": 56,
            endNodeShape: 57,
            "}": 58,
            nodeShapeBody_repetition0: 59,
            targetClass: 60,
            "->": 61,
            targetClass_repetition_plus0: 62,
            constraint: 63,
            constraint_group0: 64,
            constraint_option0: 65,
            orNotComponent: 66,
            "|": 67,
            nodeNot: 68,
            nodeOrEmit: 69,
            nodeOr: 70,
            nodeOr_repetition_plus0: 71,
            nodeValue: 72,
            negation: 73,
            nodeValue_group0: 74,
            "=": 75,
            iriOrLiteralOrArray: 76,
            propertyShape: 77,
            path: 78,
            propertyShape_repetition0: 79,
            propertyOrComponent: 80,
            propertyNot: 81,
            propertyOr: 82,
            propertyOr_repetition_plus0: 83,
            propertyAtom: 84,
            NODEKIND: 85,
            shapeRef: 86,
            PARAM: 87,
            propertyCount: 88,
            propertyMinCount: 89,
            "..": 90,
            propertyMaxCount: 91,
            INTEGER: 92,
            "*": 93,
            shapeRef_group0: 94,
            "@": 95,
            "!": 96,
            pathAlternative: 97,
            additionalAlternative: 98,
            pathSequence: 99,
            pathAlternative_repetition_plus0: 100,
            additionalSequence: 101,
            "/": 102,
            pathEltOrInverse: 103,
            pathSequence_repetition_plus0: 104,
            pathElt: 105,
            pathPrimary: 106,
            pathMod: 107,
            pathInverse: 108,
            "^": 109,
            "?": 110,
            "+": 111,
            iriOrLiteralOrArray_repetition0: 112,
            literal: 113,
            iri_group0: 114,
            a: 115,
            string: 116,
            LANGTAG: 117,
            "^^": 118,
            DECIMAL: 119,
            DOUBLE: 120,
            literal_group0: 121,
            string_group0: 122,
            string_group1: 123,
            shaclDoc_repetition1_group0: 124,
            constraint_group0_repetition_plus0: 125,
            TARGET: 126,
            propertyShape_repetition0_group0: 127,
            ATPNAME_LN: 128,
            ATPNAME_NS: 129,
            PNAME_LN: 130,
            KW_TRUE: 131,
            KW_FALSE: 132,
            STRING_LITERAL1: 133,
            STRING_LITERAL2: 134,
            STRING_LITERAL_LONG1: 135,
            STRING_LITERAL_LONG2: 136,
            $accept: 0,
            $end: 1
        },
        terminals_: {
            2: "error",
            7: "EOF",
            12: "KW_BASE",
            13: "IRIREF",
            14: "KW_IMPORTS",
            15: "KW_PREFIX",
            16: "PNAME_NS",
            20: "KW_SHAPE",
            25: "KW_SHAPE_CLASS",
            28: ";",
            38: "(",
            40: ")",
            42: ",",
            44: "[",
            46: "]",
            48: "%",
            53: ".",
            56: "{",
            58: "}",
            61: "->",
            67: "|",
            75: "=",
            85: "NODEKIND",
            87: "PARAM",
            90: "..",
            92: "INTEGER",
            93: "*",
            95: "@",
            96: "!",
            102: "/",
            109: "^",
            110: "?",
            111: "+",
            115: "a",
            117: "LANGTAG",
            118: "^^",
            119: "DECIMAL",
            120: "DOUBLE",
            126: "TARGET",
            128: "ATPNAME_LN",
            129: "ATPNAME_NS",
            130: "PNAME_LN",
            131: "KW_TRUE",
            132: "KW_FALSE",
            133: "STRING_LITERAL1",
            134: "STRING_LITERAL2",
            135: "STRING_LITERAL_LONG1",
            136: "STRING_LITERAL_LONG2"
        },
        productions_: [
            0,
            [
                3,
                4
            ],
            [
                8,
                1
            ],
            [
                8,
                1
            ],
            [
                8,
                1
            ],
            [
                9,
                2
            ],
            [
                10,
                2
            ],
            [
                11,
                3
            ],
            [
                17,
                1
            ],
            [
                19,
                5
            ],
            [
                24,
                4
            ],
            [
                27,
                2
            ],
            [
                29,
                2
            ],
            [
                30,
                2
            ],
            [
                32,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                37,
                3
            ],
            [
                41,
                2
            ],
            [
                43,
                1
            ],
            [
                45,
                1
            ],
            [
                36,
                3
            ],
            [
                47,
                1
            ],
            [
                49,
                1
            ],
            [
                50,
                3
            ],
            [
                51,
                1
            ],
            [
                52,
                3
            ],
            [
                6,
                1
            ],
            [
                55,
                1
            ],
            [
                57,
                1
            ],
            [
                23,
                3
            ],
            [
                60,
                2
            ],
            [
                63,
                3
            ],
            [
                66,
                2
            ],
            [
                69,
                1
            ],
            [
                70,
                1
            ],
            [
                70,
                2
            ],
            [
                68,
                1
            ],
            [
                68,
                2
            ],
            [
                72,
                3
            ],
            [
                77,
                2
            ],
            [
                80,
                2
            ],
            [
                82,
                1
            ],
            [
                82,
                2
            ],
            [
                81,
                1
            ],
            [
                81,
                2
            ],
            [
                84,
                1
            ],
            [
                84,
                1
            ],
            [
                84,
                1
            ],
            [
                84,
                3
            ],
            [
                84,
                1
            ],
            [
                88,
                5
            ],
            [
                89,
                1
            ],
            [
                91,
                1
            ],
            [
                91,
                1
            ],
            [
                86,
                1
            ],
            [
                86,
                2
            ],
            [
                73,
                1
            ],
            [
                78,
                1
            ],
            [
                98,
                2
            ],
            [
                97,
                1
            ],
            [
                97,
                2
            ],
            [
                101,
                2
            ],
            [
                99,
                1
            ],
            [
                99,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                2
            ],
            [
                103,
                1
            ],
            [
                103,
                2
            ],
            [
                108,
                1
            ],
            [
                107,
                1
            ],
            [
                107,
                1
            ],
            [
                107,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                3
            ],
            [
                76,
                1
            ],
            [
                76,
                3
            ],
            [
                35,
                1
            ],
            [
                35,
                1
            ],
            [
                18,
                1
            ],
            [
                18,
                1
            ],
            [
                18,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                2
            ],
            [
                113,
                3
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                116,
                1
            ],
            [
                116,
                1
            ],
            [
                4,
                0
            ],
            [
                4,
                2
            ],
            [
                124,
                1
            ],
            [
                124,
                1
            ],
            [
                5,
                0
            ],
            [
                5,
                2
            ],
            [
                21,
                0
            ],
            [
                21,
                1
            ],
            [
                22,
                0
            ],
            [
                22,
                1
            ],
            [
                26,
                0
            ],
            [
                26,
                1
            ],
            [
                31,
                0
            ],
            [
                31,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                39,
                0
            ],
            [
                39,
                2
            ],
            [
                54,
                0
            ],
            [
                54,
                2
            ],
            [
                59,
                0
            ],
            [
                59,
                2
            ],
            [
                62,
                1
            ],
            [
                62,
                2
            ],
            [
                125,
                1
            ],
            [
                125,
                2
            ],
            [
                64,
                1
            ],
            [
                64,
                1
            ],
            [
                65,
                0
            ],
            [
                65,
                1
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                1
            ],
            [
                127,
                1
            ],
            [
                127,
                1
            ],
            [
                79,
                0
            ],
            [
                79,
                2
            ],
            [
                83,
                1
            ],
            [
                83,
                2
            ],
            [
                94,
                1
            ],
            [
                94,
                1
            ],
            [
                100,
                1
            ],
            [
                100,
                2
            ],
            [
                104,
                1
            ],
            [
                104,
                2
            ],
            [
                112,
                0
            ],
            [
                112,
                2
            ],
            [
                114,
                1
            ],
            [
                114,
                1
            ],
            [
                121,
                1
            ],
            [
                121,
                1
            ],
            [
                122,
                1
            ],
            [
                122,
                1
            ],
            [
                123,
                1
            ],
            [
                123,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    this.$ = emit(Parser.factory.namedNode(resolveIRI('')), Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(OWL + 'Ontology'));
                    break;
                case 5:
                    Parser.base = Parser.factory.namedNode($$[$0].slice(1, -1));
                    Parser.n3Parser._setBase(resolveIRI(Parser.base.value));
                    break;
                case 6:
                    this.$ = emit(Parser.base, Parser.factory.namedNode(OWL + 'imports'), Parser.factory.namedNode($$[$0].slice(1, -1)));
                    break;
                case 7:
                    this.$ = Parser.prefixes[$$[$0 - 1].substr(0, $$[$0 - 1].length - 1)] = resolveIRI($$[$0]);
                    break;
                case 8:
                    Parser.nodeShapeStack = false;
                    emit(Parser.currentNodeShape = $$[$0], Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(SH + 'NodeShape'));
                    break;
                case 10:
                    this.$ = emit(Parser.currentNodeShape, Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(RDFS + 'Class'));
                    break;
                case 11:
                    this.$ = ensureExtended();
                    break;
                case 13:
                    this.$ = $$[$0].forEach(function(e) {
                        return emit(Parser.currentNodeShape, $$[$0 - 1], e);
                    });
                    break;
                case 14:
                    this.$ = [
                        $$[$0 - 1]
                    ].concat((0, $7WNf6._)($$[$0]));
                    break;
                case 18:
                    this.$ = addList($$[$0 - 1], true);
                    break;
                case 19:
                case 34:
                case 42:
                case 60:
                case 63:
                    this.$ = $$[$0];
                    break;
                case 20:
                    Parser.tempCurrentNodeShape = Parser.currentNodeShape;
                    this.$ = Parser.currentNodeShape = blank();
                    break;
                case 21:
                    Parser.currentNodeShape = Parser.tempCurrentNodeShape;
                    break;
                case 22:
                case 31:
                    this.$ = $$[$0 - 2];
                    break;
                case 23:
                    Parser.tempCurrentNodeShape = Parser.currentNodeShape;
                    Parser.currentNodeShape = Parser.currentPropertyNode;
                    break;
                case 24:
                    Parser.currentNodeShape = Parser.tempCurrentNodeShape;
                    break;
                case 26:
                    Parser.currentNodeShape = $$[$0];
                    break;
                case 29:
                    if (!Parser.nodeShapeStack) Parser.nodeShapeStack = [];
                    else {
                        Parser.nodeShapeStack.push(Parser.currentNodeShape);
                        emit(// In the grammar a path signals the start of a new property declaration
                        Parser.currentPropertyNode, Parser.factory.namedNode(SH + 'node'), Parser.currentNodeShape = blank());
                    }
                    this.$ = Parser.currentNodeShape;
                    break;
                case 30:
                    if (Parser.nodeShapeStack.length > 0) Parser.currentNodeShape = Parser.nodeShapeStack.pop();
                    break;
                case 32:
                    this.$ = $$[$0].forEach(function(node) {
                        emit(Parser.currentNodeShape, Parser.factory.namedNode(SH + 'targetClass'), node);
                    });
                    break;
                case 35:
                    this.$ = emit(Parser.currentNodeShape, Parser.factory.namedNode(SH + $$[$0][0]), $$[$0][1]);
                    break;
                case 36:
                    break;
                case 37:
                    var o = addList([
                        $$[$0 - 1]
                    ].concat((0, $7WNf6._)($$[$0])).map(function(elem) {
                        var x = blank();
                        emit(x, Parser.factory.namedNode(SH + elem[0]), elem[1]);
                        return x;
                    }));
                    this.$ = [
                        'or',
                        o
                    ];
                    break;
                case 39:
                case 46:
                    this.$ = chainProperty.apply(void 0, [
                        'not'
                    ].concat((0, $7WNf6._)($$[$0])));
                    break;
                case 40:
                case 50:
                    this.$ = [
                        $$[$0 - 2],
                        $$[$0]
                    ];
                    break;
                case 43:
                    this.$ = $$[$0] && emitProperty.apply(void 0, (0, $7WNf6._)($$[$0]));
                    break;
                case 44:
                    this.$ = emitProperty('or', addList([
                        $$[$0 - 1]
                    ].concat((0, $7WNf6._)($$[$0])).map(function(elem) {
                        var x = blank();
                        emit(x, Parser.factory.namedNode(SH + elem[0]), elem[1]);
                        return x;
                    })));
                    break;
                case 47:
                    this.$ = [
                        datatypes[$$[$0].value] ? 'datatype' : 'class',
                        $$[$0]
                    ];
                    break;
                case 48:
                    this.$ = [
                        'nodeKind',
                        Parser.factory.namedNode(SH + $$[$0])
                    ];
                    break;
                case 49:
                    this.$ = [
                        'node',
                        Parser.factory.namedNode($$[$0])
                    ];
                    break;
                case 51:
                    this.$ = undefined //['node', $$[$0]];
                    ;
                    break;
                case 53:
                    this.$ = $$[$0] > 0 && emitProperty('minCount', createTypedLiteral($$[$0], XSD_INTEGER));
                    break;
                case 54:
                    this.$ = emitProperty('maxCount', createTypedLiteral($$[$0], XSD_INTEGER));
                    break;
                case 56:
                    this.$ = expandPrefix($$[$0].slice(1));
                    break;
                case 57:
                    this.$ = resolveIRI($$[$0]);
                    break;
                case 59:
                    emit(// In the grammar a path signals the start of a new property declaration
                    Parser.currentNodeShape, Parser.factory.namedNode(SH + 'property'), Parser.currentPropertyNode = blank());
                    emitProperty('path', $$[$0]);
                    break;
                case 62:
                    var n = blank();
                    emit(n, Parser.factory.namedNode(SH + 'alternativePath'), addList([
                        $$[$0 - 1]
                    ].concat((0, $7WNf6._)($$[$0]))));
                    this.$ = n;
                    break;
                case 65:
                    this.$ = addList([
                        $$[$0 - 1]
                    ].concat((0, $7WNf6._)($$[$0])));
                    break;
                case 67:
                    emit(this.$ = blank(), Parser.factory.namedNode(SH + $$[$0]), $$[$0 - 1]);
                    break;
                case 69:
                    emit(this.$ = blank(), Parser.factory.namedNode(SH + 'inversePath'), $$[$0]);
                    break;
                case 71:
                    this.$ = 'zeroOrOnePath';
                    break;
                case 72:
                    this.$ = 'zeroOrMorePath';
                    break;
                case 73:
                    this.$ = 'oneOrMorePath';
                    break;
                case 75:
                    this.$ = $$[$0 - 1];
                    break;
                case 77:
                    this.$ = addList($$[$0 - 1]);
                    break;
                case 80:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 81:
                    this.$ = Parser.factory.namedNode(expandPrefix($$[$0]));
                    break;
                case 82:
                    this.$ = ensureExtended(Parser.factory.namedNode(RDF_TYPE));
                    break;
                case 83:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 84:
                    this.$ = createLangLiteral($$[$0 - 1], $$[$0].substr(1).toLowerCase());
                    break;
                case 85:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 86:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 87:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 88:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_DOUBLE);
                    break;
                case 89:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 90:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 91:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 92:
                case 96:
                case 106:
                case 108:
                case 110:
                case 112:
                case 128:
                case 138:
                    this.$ = [];
                    break;
                case 93:
                case 97:
                case 107:
                case 109:
                case 111:
                case 113:
                case 115:
                case 117:
                case 123:
                case 129:
                case 131:
                case 135:
                case 137:
                case 139:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 114:
                case 116:
                case 122:
                case 130:
                case 134:
                case 136:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
            }
        },
        table: [
            o($V0, [
                2,
                92
            ], {
                3: 1,
                4: 2
            }),
            {
                1: [
                    3
                ]
            },
            o($V1, [
                2,
                96
            ], {
                5: 3,
                8: 4,
                9: 5,
                10: 6,
                11: 7,
                12: [
                    1,
                    8
                ],
                14: [
                    1,
                    9
                ],
                15: [
                    1,
                    10
                ]
            }),
            o($V2, [
                2,
                110
            ], {
                6: 11,
                124: 12,
                54: 13,
                19: 14,
                24: 15,
                20: [
                    1,
                    16
                ],
                25: [
                    1,
                    17
                ]
            }),
            o($V0, [
                2,
                93
            ]),
            o($V0, [
                2,
                2
            ]),
            o($V0, [
                2,
                3
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    18
                ]
            },
            {
                13: [
                    1,
                    19
                ]
            },
            {
                16: [
                    1,
                    20
                ]
            },
            {
                7: [
                    1,
                    21
                ]
            },
            o($V1, [
                2,
                97
            ]),
            {
                7: [
                    2,
                    28
                ],
                13: $V3,
                16: $V4,
                18: 24,
                51: 23,
                52: 22,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V1, [
                2,
                94
            ]),
            o($V1, [
                2,
                95
            ]),
            {
                13: $V3,
                16: $V4,
                17: 30,
                18: 31,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                13: $V3,
                16: $V4,
                17: 32,
                18: 31,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V0, [
                2,
                5
            ]),
            o($V0, [
                2,
                6
            ]),
            {
                13: [
                    1,
                    33
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            o($V2, [
                2,
                111
            ]),
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 34,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V7, [
                2,
                26
            ]),
            o($V8, [
                2,
                80
            ]),
            o($V8, [
                2,
                81
            ]),
            o($V8, [
                2,
                82
            ]),
            o($V8, [
                2,
                140
            ]),
            o($V8, [
                2,
                141
            ]),
            o($V9, [
                2,
                98
            ], {
                21: 37,
                60: 38,
                61: [
                    1,
                    39
                ]
            }),
            o([
                28,
                56,
                61
            ], [
                2,
                8
            ]),
            {
                26: 40,
                27: 41,
                28: $Va,
                56: [
                    2,
                    102
                ]
            },
            o($V0, [
                2,
                7
            ]),
            {
                53: [
                    1,
                    43
                ]
            },
            o($Vb, [
                2,
                104
            ], {
                31: 44,
                27: 45,
                28: $Va
            }),
            {
                13: $V3,
                16: $V4,
                18: 51,
                32: 46,
                33: 47,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            {
                22: 69,
                27: 70,
                28: $Va,
                56: [
                    2,
                    100
                ]
            },
            o($V9, [
                2,
                99
            ]),
            {
                13: $V3,
                16: $V4,
                18: 72,
                62: 71,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                23: 73,
                55: 74,
                56: $Vn
            },
            {
                56: [
                    2,
                    103
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 76,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V2, [
                2,
                27
            ]),
            o($Vb, [
                2,
                12
            ]),
            o($Vb, [
                2,
                105
            ]),
            o($Vo, [
                2,
                13
            ]),
            o($Vp, [
                2,
                106
            ], {
                34: 77
            }),
            o($Vq, [
                2,
                15
            ]),
            o($Vq, [
                2,
                16
            ]),
            o($Vq, [
                2,
                17
            ]),
            o($Vr, [
                2,
                78
            ]),
            o($Vr, [
                2,
                79
            ]),
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 78,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($Vs, [
                2,
                108
            ], {
                39: 79
            }),
            o($Vr, [
                2,
                83
            ], {
                117: [
                    1,
                    80
                ],
                118: [
                    1,
                    81
                ]
            }),
            o($Vr, [
                2,
                86
            ]),
            o($Vr, [
                2,
                87
            ]),
            o($Vr, [
                2,
                88
            ]),
            o($Vr, [
                2,
                89
            ]),
            o($V7, [
                2,
                20
            ]),
            o($Vt, [
                2,
                90
            ]),
            o($Vt, [
                2,
                91
            ]),
            o($Vr, [
                2,
                142
            ]),
            o($Vr, [
                2,
                143
            ]),
            o($Vt, [
                2,
                144
            ]),
            o($Vt, [
                2,
                145
            ]),
            o($Vt, [
                2,
                146
            ]),
            o($Vt, [
                2,
                147
            ]),
            {
                23: 82,
                55: 74,
                56: $Vn
            },
            {
                56: [
                    2,
                    101
                ]
            },
            o($V9, [
                2,
                32
            ], {
                114: 26,
                18: 83,
                13: $V3,
                16: $V4,
                115: $V5,
                130: $V6
            }),
            o($Vu, [
                2,
                114
            ]),
            o($V1, [
                2,
                10
            ]),
            o($Vv, [
                2,
                112
            ], {
                59: 84
            }),
            o($Vv, [
                2,
                29
            ]),
            o($Vb, [
                2,
                11
            ]),
            o($Vo, [
                2,
                14
            ], {
                41: 85,
                42: [
                    1,
                    86
                ]
            }),
            {
                45: 87,
                46: [
                    1,
                    88
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 51,
                33: 90,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                40: [
                    1,
                    89
                ],
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($Vr, [
                2,
                84
            ]),
            {
                13: $V3,
                16: $V4,
                18: 91,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V1, [
                2,
                9
            ]),
            o($Vu, [
                2,
                115
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                57: 92,
                58: [
                    1,
                    94
                ],
                63: 93,
                64: 95,
                68: 102,
                69: 98,
                70: 100,
                72: 104,
                73: 105,
                74: 107,
                77: 97,
                78: 99,
                87: $Vx,
                96: $Vy,
                97: 101,
                99: 103,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                125: 96,
                126: $VA,
                130: $V6
            },
            o($Vp, [
                2,
                107
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                33: 117,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($Vq, [
                2,
                22
            ]),
            o($Vq, [
                2,
                21
            ]),
            o($Vq, [
                2,
                18
            ]),
            o($Vs, [
                2,
                109
            ]),
            o($Vr, [
                2,
                85
            ]),
            o($VB, [
                2,
                31
            ]),
            o($Vv, [
                2,
                113
            ]),
            o($VB, [
                2,
                30
            ]),
            {
                47: 120,
                48: [
                    1,
                    121
                ],
                50: 119,
                53: [
                    2,
                    120
                ],
                65: 118
            },
            o($VC, [
                2,
                118
            ], {
                70: 100,
                68: 102,
                72: 104,
                73: 105,
                74: 107,
                69: 122,
                87: $Vx,
                96: $Vy,
                126: $VA
            }),
            o($VC, [
                2,
                119
            ]),
            o($VD, [
                2,
                116
            ]),
            o($VE, [
                2,
                128
            ], {
                79: 123
            }),
            o($VD, [
                2,
                35
            ]),
            o($VE, [
                2,
                59
            ]),
            o($VD, [
                2,
                36
            ], {
                71: 124,
                66: 125,
                67: $VF
            }),
            o($VG, [
                2,
                61
            ], {
                100: 127,
                98: 128,
                67: $VH
            }),
            o($VI, [
                2,
                38
            ]),
            {
                72: 130,
                74: 107,
                87: $Vx,
                126: $VA
            },
            o($VJ, [
                2,
                64
            ], {
                104: 131,
                101: 132,
                102: $VK
            }),
            {
                75: [
                    1,
                    134
                ]
            },
            o([
                13,
                16,
                56,
                85,
                87,
                95,
                115,
                126,
                128,
                129,
                130
            ], [
                2,
                58
            ]),
            o($VL, [
                2,
                68
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                105: 135,
                106: 113,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                75: [
                    2,
                    124
                ]
            },
            {
                75: [
                    2,
                    125
                ]
            },
            o($VL, [
                2,
                66
            ], {
                107: 136,
                93: [
                    1,
                    138
                ],
                110: [
                    1,
                    137
                ],
                111: [
                    1,
                    139
                ]
            }),
            o([
                13,
                16,
                38,
                115,
                130
            ], [
                2,
                70
            ]),
            o($VM, [
                2,
                74
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                97: 140,
                99: 103,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($Vp, [
                2,
                19
            ]),
            {
                53: [
                    1,
                    141
                ]
            },
            {
                53: [
                    2,
                    121
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 142,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V7, [
                2,
                23
            ]),
            o($VD, [
                2,
                117
            ]),
            o($VC, [
                2,
                41
            ], {
                114: 26,
                55: 74,
                127: 143,
                88: 144,
                82: 145,
                81: 147,
                84: 148,
                73: 149,
                18: 150,
                86: 152,
                23: 154,
                94: 155,
                13: $V3,
                16: $V4,
                44: [
                    1,
                    146
                ],
                56: $Vn,
                85: $VN,
                87: $VO,
                95: $VP,
                96: $Vy,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            }),
            o($VD, [
                2,
                37
            ], {
                66: 159,
                67: $VF
            }),
            o($VI, [
                2,
                122
            ]),
            {
                68: 160,
                72: 104,
                73: 105,
                74: 107,
                87: $Vx,
                96: $Vy,
                126: $VA
            },
            o($VG, [
                2,
                62
            ], {
                98: 161,
                67: $VH
            }),
            o($VJ, [
                2,
                134
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                99: 162,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($VI, [
                2,
                39
            ]),
            o($VJ, [
                2,
                65
            ], {
                101: 163,
                102: $VK
            }),
            o($VL, [
                2,
                136
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                103: 164,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 166,
                44: $VS,
                76: 165,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($VL, [
                2,
                69
            ]),
            o($VL, [
                2,
                67
            ]),
            o($VL, [
                2,
                71
            ]),
            o($VL, [
                2,
                72
            ]),
            o($VL, [
                2,
                73
            ]),
            {
                40: [
                    1,
                    168
                ]
            },
            o($Vv, [
                2,
                33
            ]),
            {
                48: [
                    1,
                    170
                ],
                49: 169
            },
            o($VE, [
                2,
                129
            ]),
            o($VE, [
                2,
                126
            ]),
            o($VE, [
                2,
                127
            ]),
            {
                89: 171,
                92: [
                    1,
                    172
                ]
            },
            o($VE, [
                2,
                43
            ], {
                83: 173,
                80: 174,
                67: $VT
            }),
            o($VU, [
                2,
                45
            ]),
            {
                13: $V3,
                16: $V4,
                18: 150,
                23: 154,
                55: 74,
                56: $Vn,
                84: 176,
                85: $VN,
                86: 152,
                87: $VO,
                94: 155,
                95: $VP,
                114: 26,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            },
            o($VU, [
                2,
                47
            ]),
            o($VU, [
                2,
                48
            ]),
            o($VU, [
                2,
                49
            ]),
            {
                75: [
                    1,
                    177
                ]
            },
            o($VU, [
                2,
                51
            ]),
            o($VU, [
                2,
                56
            ]),
            {
                13: [
                    1,
                    178
                ]
            },
            o($VU, [
                2,
                132
            ]),
            o($VU, [
                2,
                133
            ]),
            o($VI, [
                2,
                123
            ]),
            o($VI, [
                2,
                34
            ]),
            o($VJ, [
                2,
                135
            ]),
            o($VJ, [
                2,
                60
            ]),
            o($VL, [
                2,
                137
            ]),
            o($VL, [
                2,
                63
            ]),
            o($VI, [
                2,
                40
            ]),
            o($VV, [
                2,
                76
            ]),
            o($VW, [
                2,
                138
            ], {
                112: 179
            }),
            o($VM, [
                2,
                75
            ]),
            {
                53: [
                    2,
                    25
                ]
            },
            {
                53: [
                    2,
                    24
                ]
            },
            {
                90: [
                    1,
                    180
                ]
            },
            {
                90: [
                    2,
                    53
                ]
            },
            o($VE, [
                2,
                44
            ], {
                80: 181,
                67: $VT
            }),
            o($VU, [
                2,
                130
            ]),
            {
                13: $V3,
                16: $V4,
                18: 150,
                23: 154,
                55: 74,
                56: $Vn,
                73: 149,
                81: 182,
                84: 148,
                85: $VN,
                86: 152,
                87: $VO,
                94: 155,
                95: $VP,
                96: $Vy,
                114: 26,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            },
            o($VU, [
                2,
                46
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 166,
                44: $VS,
                76: 183,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($VU, [
                2,
                57
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 185,
                46: [
                    1,
                    184
                ],
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            {
                91: 186,
                92: [
                    1,
                    187
                ],
                93: [
                    1,
                    188
                ]
            },
            o($VU, [
                2,
                131
            ]),
            o($VU, [
                2,
                42
            ]),
            o($VU, [
                2,
                50
            ]),
            o($VV, [
                2,
                77
            ]),
            o($VW, [
                2,
                139
            ]),
            {
                46: [
                    1,
                    189
                ]
            },
            {
                46: [
                    2,
                    54
                ]
            },
            {
                46: [
                    2,
                    55
                ]
            },
            o($VE, [
                2,
                52
            ])
        ],
        defaultActions: {
            21: [
                2,
                1
            ],
            41: [
                2,
                103
            ],
            70: [
                2,
                101
            ],
            111: [
                2,
                124
            ],
            112: [
                2,
                125
            ],
            119: [
                2,
                121
            ],
            169: [
                2,
                25
            ],
            170: [
                2,
                24
            ],
            172: [
                2,
                53
            ],
            187: [
                2,
                54
            ],
            188: [
                2,
                55
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function lex() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == 'undefined') symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push('\'' + this.terminals_[p] + '\'');
                    if (lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                    else errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== 'undefined') return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    Grammar specification for a SHACL compact
    syntax parser.
    Several functions are from <https://github.com/RubenVerborgh/SPARQL.js/>
*/ // Common namespaces and entities
    var RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', RDF_TYPE = RDF + 'type', RDF_FIRST = RDF + 'first', RDF_REST = RDF + 'rest', RDF_NIL = RDF + 'nil', XSD = 'http://www.w3.org/2001/XMLSchema#', XSD_INTEGER = XSD + 'integer', XSD_DECIMAL = XSD + 'decimal', XSD_DOUBLE = XSD + 'double', XSD_BOOLEAN = XSD + 'boolean', SH = 'http://www.w3.org/ns/shacl#', OWL = 'http://www.w3.org/2002/07/owl#', RDFS = 'http://www.w3.org/2000/01/rdf-schema#';
    var _obj;
    // TODO: Make sure all SPARQL supported datatypes are here
    var datatypes = (_obj = {}, (0, $cqEAj._)(_obj, XSD_INTEGER, true), (0, $cqEAj._)(_obj, XSD_DECIMAL, true), (0, $cqEAj._)(_obj, XSD + 'float', true), (0, $cqEAj._)(_obj, XSD_DOUBLE, true), (0, $cqEAj._)(_obj, XSD + 'string', true), (0, $cqEAj._)(_obj, XSD_BOOLEAN, true), (0, $cqEAj._)(_obj, XSD + 'dateTime', true), (0, $cqEAj._)(_obj, XSD + 'nonPositiveInteger', true), (0, $cqEAj._)(_obj, XSD + 'negativeInteger', true), (0, $cqEAj._)(_obj, XSD + 'long', true), (0, $cqEAj._)(_obj, XSD + 'int', true), (0, $cqEAj._)(_obj, XSD + 'short', true), (0, $cqEAj._)(_obj, XSD + 'byte', true), (0, $cqEAj._)(_obj, XSD + 'nonNegativeInteger', true), (0, $cqEAj._)(_obj, XSD + 'unsignedLong', true), (0, $cqEAj._)(_obj, XSD + 'unsignedShort', true), (0, $cqEAj._)(_obj, XSD + 'unsignedByte', true), (0, $cqEAj._)(_obj, XSD + 'positiveInteger', true), (0, $cqEAj._)(_obj, RDF + 'langString', true), _obj);
    function addList(elems) {
        var ttlList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var i = 0, l = elems.length;
        // TODO: Double check this behavior and see why it differes from the other l == 0 case
        if (ttlList && l === 0) return Parser.factory.namedNode(RDF_NIL);
        var list = head = blank();
        if (l === 0) // TODO: see if this should be here 
        emit(head, Parser.factory.namedNode(RDF_REST), Parser.factory.namedNode(RDF_NIL));
        elems.forEach(function(elem) {
            if (elem === undefined) throw new Error('b');
            emit(head, Parser.factory.namedNode(RDF_FIRST), elem);
            emit(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        });
        return list;
    }
    // TODO: Port over any updates to this from SPARLQL.js
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets and resolve the IRI
        return Parser.n3Parser._resolveIRI(iri[0] === '<' ? iri.substring(1, iri.length - 1) : iri);
    }
    function expandPrefix(iri) {
        var namePos = iri.indexOf(':'), prefix = iri.substr(0, namePos), expansion = Parser.prefixes[prefix];
        if (!expansion) throw new Error('Unknown prefix: ' + prefix);
        return resolveIRI(expansion + iri.substr(namePos + 1));
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== 'NamedNode') type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === 'string') {
            if (name.startsWith('e_')) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode('e_' + name);
        }
        return Parser.factory.blankNode('g_' + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        '\\': '\\',
        "'": "'",
        '"': '"',
        t: '\t',
        b: '\b',
        n: '\n',
        r: '\r',
        f: '\f'
    }, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        return Parser.n3Parser._lexer._unescape(string.substring(trimLength, string.length - trimLength));
    }
    function emit(s, p, o) {
        if (!s.termType || !p.termType || p.value.includes(',') || !o.termType) throw new Error("boo ".concat(s.value, " ").concat(p.value, " ").concat(o.value));
        Parser.onQuad(Parser.factory.quad(s, p, o));
    }
    function emitProperty(p, o) {
        emit(Parser.currentPropertyNode, Parser.factory.namedNode(SH + p), o);
    }
    function chainProperty(name, p, o) {
        var b = blank();
        emit(b, Parser.factory.namedNode(SH + p), o);
        return [
            name,
            b
        ];
    }
    function ensureExtended(input) {
        if (!Parser.extended) throw new Error('Encountered extended SHACLC syntax; but extended parsing is disabled');
        return input;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function setInput(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function more() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function test_match(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function next() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                flex: true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 14;
                    case 3:
                        return 15;
                    case 4:
                        return 25;
                    case 5:
                        return 20;
                    case 6:
                        return 131;
                    case 7:
                        return 132;
                    case 8:
                        return 85;
                    case 9:
                        return 126;
                    case 10:
                        return 87;
                    case 11:
                        return 'PASS';
                    case 12:
                        return 'COMMENT';
                    case 13:
                        return 13;
                    case 14:
                        return 16;
                    case 15:
                        return 130;
                    case 16:
                        return 129;
                    case 17:
                        return 128;
                    case 18:
                        return 117;
                    case 19:
                        return 92;
                    case 20:
                        return 119;
                    case 21:
                        return 120;
                    case 22:
                        return 'EXPONENT';
                    case 23:
                        return 133;
                    case 24:
                        return 134;
                    case 25:
                        return 135;
                    case 26:
                        return 136;
                    case 27:
                        return 61;
                    case 28:
                        return 90;
                    case 29:
                        return 58;
                    case 30:
                        return 56;
                    case 31:
                        return 38;
                    case 32:
                        return 40;
                    case 33:
                        return 44;
                    case 34:
                        return 46;
                    case 35:
                        return 110;
                    case 36:
                        return 93;
                    case 37:
                        return 111;
                    case 38:
                        return 67;
                    case 39:
                        return 118;
                    case 40:
                        return 53;
                    case 41:
                        return 96;
                    case 42:
                        return 102;
                    case 43:
                        return 75;
                    case 44:
                        return 95;
                    case 45:
                        return 109;
                    case 46:
                        return 28;
                    case 47:
                        return 42;
                    case 48:
                        return 48;
                    case 49:
                        return 115;
                    case 50:
                        return 7;
                    case 51:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|#[^\n\r]*)/i,
                /^(?:BASE)/i,
                /^(?:IMPORTS)/i,
                /^(?:PREFIX)/i,
                /^(?:shapeClass)/i,
                /^(?:shape)/i,
                /^(?:true)/i,
                /^(?:false)/i,
                /^(?:(BlankNode|IRI|Literal|BlankNodeOrIRI|BlankNodeOrLiteral|IRIOrLiteral\b))/i,
                /^(?:(targetNode|targetObjectsOf|targetSubjectsOf\b))/i,
                /^(?:(deactivated|severity|message|class|datatype|nodeKind|minExclusive|minInclusive|maxExclusive|maxInclusive|minLength|maxLength|pattern|flags|languageIn|uniqueLang|equals|disjoint|lessThan|lessThanOrEquals|qualifiedValueShape|qualifiedMinCount|qualifiedMaxCount|qualifiedValueShapesDisjoint|closed|ignoredProperties|hasValue|in))/i,
                /^(?:([ \t\r\n]+))/i,
                /^(?:(#[\r\n]*))/i,
                /^(?:(<([^=<>\"\{\}\|\^`\\\u0000-\u0020]|(\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])))*>))/i,
                /^(?:((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:)(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|:|[0-9]|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(@(([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:))/i,
                /^(?:(@((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:)(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|:|[0-9]|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(@[a-zA-Z]+(-[a-zA-Z0-9]+)*))/i,
                /^(?:([+-]?[0-9]+))/i,
                /^(?:([+-]?[0-9]*\.[0-9]+))/i,
                /^(?:([+-]?([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.?[0-9]+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"\']))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"\']))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"\'])))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"\'])))*"""))/i,
                /^(?:->)/i,
                /^(?:\.\.)/i,
                /^(?:\})/i,
                /^(?:\{)/i,
                /^(?:\()/i,
                /^(?:\))/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\?)/i,
                /^(?:\*)/i,
                /^(?:\+)/i,
                /^(?:\|)/i,
                /^(?:\^\^)/i,
                /^(?:\.)/i,
                /^(?:!)/i,
                /^(?:\/)/i,
                /^(?:=)/i,
                /^(?:@)/i,
                /^(?:\^)/i,
                /^(?:;)/i,
                /^(?:,)/i,
                /^(?:%)/i,
                /^(?:a)/i,
                /^(?:$)/i,
                /^(?:.)/i
            ],
            conditions: {
                INITIAL: {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
module.exports = $b5fcf07b8ce2f5fd$var$ShaclcParser;

});


parcelRegister("cuY1y", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrefixWrappingIterator = void 0;

var $aafx9 = parcelRequire("aafx9");
/**
 * An iterator that emits prefixes on the first read call where prefixes are available
 */ var $9196d8ed2c365ec2$var$PrefixWrappingIterator = /*#__PURE__*/ function(_asynciterator_1_WrappingIterator) {
    (0, $i3fW3._)(PrefixWrappingIterator, _asynciterator_1_WrappingIterator);
    function PrefixWrappingIterator(source) {
        (0, $jGAMp._)(this, PrefixWrappingIterator);
        var _this;
        return _this = (0, $kzDuW._)(this, PrefixWrappingIterator, [
            source === null || source === void 0 ? void 0 : source.then(function(src) {
                (0, $hMpIh._)(_this).prefixes = src.prefixes;
                return src;
            })
        ]);
    }
    (0, $byiyg._)(PrefixWrappingIterator, [
        {
            key: "read",
            value: function read() {
                // On the first read where the prefixes are available, emit them
                if (this.prefixes) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(this.prefixes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var args = _step.value;
                            this.emit.apply(this, [
                                'prefix'
                            ].concat((0, $7WNf6._)(args)));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    delete this.prefixes;
                }
                return (0, $fXhL4._)((0, $hxFDX._)(PrefixWrappingIterator.prototype), "read", this).call(this);
            }
        }
    ]);
    return PrefixWrappingIterator;
}($aafx9.WrappingIterator);
module.exports.PrefixWrappingIterator = $9196d8ed2c365ec2$var$PrefixWrappingIterator;

});



parcelRegister("en4lX", function(module, exports) {
"use strict";
var $a766971897f1f07b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a766971897f1f07b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a766971897f1f07b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a766971897f1f07b$var$__exportStar((parcelRequire("5gxxG")), module.exports);

});
parcelRegister("5gxxG", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtml = void 0;

var $1Nxez = parcelRequire("1Nxez");
parcelRequire("iiOJq");
var $hLllB = parcelRequire("hLllB");

var $bJahJ = parcelRequire("bJahJ");
/**
 * A comunica HTML RDF Parse Actor.
 * It creates an HTML parser, and delegates its events via the bus-rdf-parse-html bus to other HTML parsing actors.
 */ var $3d58772d4a265f15$var$ActorRdfParseHtml = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseHtml, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseHtml(args) {
        (0, $jGAMp._)(this, ActorRdfParseHtml);
        return (0, $kzDuW._)(this, ActorRdfParseHtml, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseHtml, [
        {
            key: "runHandle",
            value: function runHandle(action, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_metadata, data, maxSize, endBarrier, _action_metadata_baseIRI, htmlAction, outputs, htmlParseListeners, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, output, htmlParseListener, err, parser, read, e;
                    function error(subError) {
                        data.emit('error', subError);
                    }
                    function end() {
                        if (--endBarrier === 0) data.push(null);
                    }
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = new $bJahJ.Readable({
                                    objectMode: true
                                });
                                data._read = function() {
                                // Do nothing
                                };
                                maxSize = 0;
                                // Create callbacks action
                                endBarrier = 1;
                                htmlAction = {
                                    baseIRI: (_action_metadata_baseIRI = (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI) !== null && _action_metadata_baseIRI !== void 0 ? _action_metadata_baseIRI : '',
                                    context: context,
                                    emit: function(quad) {
                                        maxSize--;
                                        data.push(quad);
                                    },
                                    end: end,
                                    error: error,
                                    headers: action.headers
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    11,
                                    ,
                                    12
                                ]);
                                return [
                                    4,
                                    Promise.all(this.busRdfParseHtml.publish(htmlAction))
                                ];
                            case 2:
                                outputs = _state.sent();
                                endBarrier += outputs.length;
                                htmlParseListeners = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = outputs[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                output = _step.value;
                                return [
                                    4,
                                    output.actor.run(htmlAction, undefined)
                                ];
                            case 5:
                                htmlParseListener = _state.sent().htmlParseListener;
                                htmlParseListeners.push(htmlParseListener);
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                // Create parser
                                parser = new $hLllB.Parser({
                                    onclosetag: function() {
                                        try {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = htmlParseListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var htmlParseListener = _step.value;
                                                    htmlParseListener.onTagClose();
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        } catch (error_) {
                                            error(error_);
                                        }
                                    },
                                    onend: function() {
                                        try {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = htmlParseListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var htmlParseListener = _step.value;
                                                    htmlParseListener.onEnd();
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        } catch (error_) {
                                            error(error_);
                                        }
                                        end();
                                    },
                                    onopentag: function(name, attributes) {
                                        try {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = htmlParseListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var htmlParseListener = _step.value;
                                                    htmlParseListener.onTagOpen(name, attributes);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        } catch (error_) {
                                            error(error_);
                                        }
                                    },
                                    ontext: function(text) {
                                        try {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = htmlParseListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var htmlParseListener = _step.value;
                                                    htmlParseListener.onText(text);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        } catch (error_) {
                                            error(error_);
                                        }
                                    }
                                }, {
                                    decodeEntities: true,
                                    recognizeSelfClosing: true,
                                    xmlMode: false
                                });
                                read = data._read = function(size) {
                                    maxSize = Math.max(size, maxSize);
                                    // eslint-disable-next-line no-unmodified-loop-condition
                                    while(maxSize > 0){
                                        var item = action.data.read();
                                        if (item === null) {
                                            action.data.once('readable', function() {
                                                return read(0);
                                            });
                                            return;
                                        }
                                        parser.write(item.toString());
                                    }
                                };
                                action.data.on('error', error).on('end', function() {
                                    return parser.end();
                                });
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                e = _state.sent();
                                setTimeout(function() {
                                    data.emit('error', e);
                                });
                                return [
                                    3,
                                    12
                                ];
                            case 12:
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfParseHtml;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseHtml = $3d58772d4a265f15$var$ActorRdfParseHtml;

});
parcelRegister("iiOJq", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("hLllB")).Parser; });

var $hLllB = parcelRequire("hLllB");

var $fjj4Z = parcelRequire("fjj4Z");

var $irrER = parcelRequire("irrER");

var $gDDlX = parcelRequire("gDDlX");
parcelRequire("4u3Uv");
var $b6XQv = parcelRequire("b6XQv");
function $d53142ad792dae2c$export$b6a9369736b19f4d(data, options) {
    var handler = new (0, $fjj4Z.DomHandler)(undefined, options);
    new (0, $hLllB.Parser)(handler, options).end(data);
    return handler.root;
}
function $d53142ad792dae2c$export$d66b332881d9723f(data, options) {
    return $d53142ad792dae2c$export$b6a9369736b19f4d(data, options).children;
}
function $d53142ad792dae2c$export$d6f7114fde618113(callback, options, elementCallback) {
    var handler = new (0, $fjj4Z.DomHandler)(function(error) {
        return callback(error, handler.root);
    }, options, elementCallback);
    return new (0, $hLllB.Parser)(handler, options);
}
function $d53142ad792dae2c$export$2bbd0317573b00fc(callback, options, elementCallback) {
    var handler = new (0, $fjj4Z.DomHandler)(callback, options, elementCallback);
    return new (0, $hLllB.Parser)(handler, options);
}
var $d53142ad792dae2c$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $d53142ad792dae2c$export$5267abf679cd576b(feed) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d53142ad792dae2c$var$parseFeedDefaultOptions;
    return (0, $b6XQv.getFeed)($d53142ad792dae2c$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("hLllB", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $cee76299186666cd$export$7acfa6ed01010e37; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $irrER = parcelRequire("irrER");

var $jnJXa = parcelRequire("jnJXa");
var $cee76299186666cd$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $cee76299186666cd$var$pTag = new Set([
    "p"
]);
var $cee76299186666cd$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $cee76299186666cd$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $cee76299186666cd$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $cee76299186666cd$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $cee76299186666cd$var$pTag
    ],
    [
        "h1",
        $cee76299186666cd$var$pTag
    ],
    [
        "h2",
        $cee76299186666cd$var$pTag
    ],
    [
        "h3",
        $cee76299186666cd$var$pTag
    ],
    [
        "h4",
        $cee76299186666cd$var$pTag
    ],
    [
        "h5",
        $cee76299186666cd$var$pTag
    ],
    [
        "h6",
        $cee76299186666cd$var$pTag
    ],
    [
        "select",
        $cee76299186666cd$var$formTags
    ],
    [
        "input",
        $cee76299186666cd$var$formTags
    ],
    [
        "output",
        $cee76299186666cd$var$formTags
    ],
    [
        "button",
        $cee76299186666cd$var$formTags
    ],
    [
        "datalist",
        $cee76299186666cd$var$formTags
    ],
    [
        "textarea",
        $cee76299186666cd$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $cee76299186666cd$var$ddtTags
    ],
    [
        "dt",
        $cee76299186666cd$var$ddtTags
    ],
    [
        "address",
        $cee76299186666cd$var$pTag
    ],
    [
        "article",
        $cee76299186666cd$var$pTag
    ],
    [
        "aside",
        $cee76299186666cd$var$pTag
    ],
    [
        "blockquote",
        $cee76299186666cd$var$pTag
    ],
    [
        "details",
        $cee76299186666cd$var$pTag
    ],
    [
        "div",
        $cee76299186666cd$var$pTag
    ],
    [
        "dl",
        $cee76299186666cd$var$pTag
    ],
    [
        "fieldset",
        $cee76299186666cd$var$pTag
    ],
    [
        "figcaption",
        $cee76299186666cd$var$pTag
    ],
    [
        "figure",
        $cee76299186666cd$var$pTag
    ],
    [
        "footer",
        $cee76299186666cd$var$pTag
    ],
    [
        "form",
        $cee76299186666cd$var$pTag
    ],
    [
        "header",
        $cee76299186666cd$var$pTag
    ],
    [
        "hr",
        $cee76299186666cd$var$pTag
    ],
    [
        "main",
        $cee76299186666cd$var$pTag
    ],
    [
        "nav",
        $cee76299186666cd$var$pTag
    ],
    [
        "ol",
        $cee76299186666cd$var$pTag
    ],
    [
        "pre",
        $cee76299186666cd$var$pTag
    ],
    [
        "section",
        $cee76299186666cd$var$pTag
    ],
    [
        "table",
        $cee76299186666cd$var$pTag
    ],
    [
        "ul",
        $cee76299186666cd$var$pTag
    ],
    [
        "rt",
        $cee76299186666cd$var$rtpTags
    ],
    [
        "rp",
        $cee76299186666cd$var$rtpTags
    ],
    [
        "tbody",
        $cee76299186666cd$var$tableSectionTags
    ],
    [
        "tfoot",
        $cee76299186666cd$var$tableSectionTags
    ]
]);
var $cee76299186666cd$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $cee76299186666cd$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $cee76299186666cd$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $cee76299186666cd$var$reNameEnd = /\s|\//;
var $cee76299186666cd$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser(cbs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, Parser);
        var _a, _b, _c, _d, _e, _f;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.recognizeSelfClosing = (_c = options.recognizeSelfClosing) !== null && _c !== void 0 ? _c : !this.htmlMode;
        this.tokenizer = new ((_d = options.Tokenizer) !== null && _d !== void 0 ? _d : (0, $irrER.default))(this.options, this);
        this.foreignContext = [
            !this.htmlMode
        ];
        (_f = (_e = this.cbs).onparserinit) === null || _f === void 0 || _f.call(_e, this);
    }
    (0, $byiyg._)(Parser, [
        {
            // Tokenizer event handlers
            /** @internal */ key: "ontext",
            value: function ontext(start, endIndex) {
                var _a, _b;
                var data = this.getSlice(start, endIndex);
                this.endIndex = endIndex - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
                this.startIndex = endIndex;
            }
        },
        {
            /** @internal */ key: "ontextentity",
            value: function ontextentity(cp, endIndex) {
                var _a, _b;
                this.endIndex = endIndex - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $jnJXa.fromCodePoint)(cp));
                this.startIndex = endIndex;
            }
        },
        {
            /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */ key: "isVoidElement",
            value: function isVoidElement(name) {
                return this.htmlMode && $cee76299186666cd$var$voidElements.has(name);
            }
        },
        {
            /** @internal */ key: "onopentagname",
            value: function onopentagname(start, endIndex) {
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                this.emitOpenTag(name);
            }
        },
        {
            key: "emitOpenTag",
            value: function emitOpenTag(name) {
                var _a, _b, _c, _d;
                this.openTagStart = this.startIndex;
                this.tagname = name;
                var impliesClose = this.htmlMode && $cee76299186666cd$var$openImpliesClose.get(name);
                if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0])){
                    var element = this.stack.shift();
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
                }
                if (!this.isVoidElement(name)) {
                    this.stack.unshift(name);
                    if (this.htmlMode) {
                        if ($cee76299186666cd$var$foreignContextElements.has(name)) this.foreignContext.unshift(true);
                        else if ($cee76299186666cd$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift(false);
                    }
                }
                (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
                if (this.cbs.onopentag) this.attribs = {};
            }
        },
        {
            key: "endOpenTag",
            value: function endOpenTag(isImplied) {
                var _a, _b;
                this.startIndex = this.openTagStart;
                if (this.attribs) {
                    (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
                    this.attribs = null;
                }
                if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
                this.tagname = "";
            }
        },
        {
            /** @internal */ key: "onopentagend",
            value: function onopentagend(endIndex) {
                this.endIndex = endIndex;
                this.endOpenTag(false);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onclosetag",
            value: function onclosetag(start, endIndex) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                if (this.htmlMode && ($cee76299186666cd$var$foreignContextElements.has(name) || $cee76299186666cd$var$htmlIntegrationElements.has(name))) this.foreignContext.shift();
                if (!this.isVoidElement(name)) {
                    var pos = this.stack.indexOf(name);
                    if (pos !== -1) for(var index = 0; index <= pos; index++){
                        var element = this.stack.shift();
                        // We know the stack has sufficient elements.
                        (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, index !== pos);
                    }
                    else if (this.htmlMode && name === "p") {
                        // Implicit open before close
                        this.emitOpenTag("p");
                        this.closeCurrentTag(true);
                    }
                } else if (this.htmlMode && name === "br") {
                    // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
                    (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, "br");
                    (_f = (_e = this.cbs).onopentag) === null || _f === void 0 || _f.call(_e, "br", {}, true);
                    (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 || _h.call(_g, "br", false);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onselfclosingtag",
            value: function onselfclosingtag(endIndex) {
                this.endIndex = endIndex;
                if (this.recognizeSelfClosing || this.foreignContext[0]) {
                    this.closeCurrentTag(false);
                    // Set `startIndex` for next node
                    this.startIndex = endIndex + 1;
                } else // Ignore the fact that the tag is self-closing.
                this.onopentagend(endIndex);
            }
        },
        {
            key: "closeCurrentTag",
            value: function closeCurrentTag(isOpenImplied) {
                var _a, _b;
                var name = this.tagname;
                this.endOpenTag(isOpenImplied);
                // Self-closing tags will be on the top of the stack
                if (this.stack[0] === name) {
                    // If the opening tag isn't implied, the closing tag has to be implied.
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
                    this.stack.shift();
                }
            }
        },
        {
            /** @internal */ key: "onattribname",
            value: function onattribname(start, endIndex) {
                this.startIndex = start;
                var name = this.getSlice(start, endIndex);
                this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
            }
        },
        {
            /** @internal */ key: "onattribdata",
            value: function onattribdata(start, endIndex) {
                this.attribvalue += this.getSlice(start, endIndex);
            }
        },
        {
            /** @internal */ key: "onattribentity",
            value: function onattribentity(cp) {
                this.attribvalue += (0, $jnJXa.fromCodePoint)(cp);
            }
        },
        {
            /** @internal */ key: "onattribend",
            value: function onattribend(quote, endIndex) {
                var _a, _b;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $irrER.QuoteType).Double ? '"' : quote === (0, $irrER.QuoteType).Single ? "'" : quote === (0, $irrER.QuoteType).NoValue ? undefined : null);
                if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
                this.attribvalue = "";
            }
        },
        {
            key: "getInstructionName",
            value: function getInstructionName(value) {
                var index = value.search($cee76299186666cd$var$reNameEnd);
                var name = index < 0 ? value : value.substr(0, index);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                return name;
            }
        },
        {
            /** @internal */ key: "ondeclaration",
            value: function ondeclaration(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onprocessinginstruction",
            value: function onprocessinginstruction(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncomment",
            value: function oncomment(start, endIndex, offset) {
                var _a, _b, _c, _d;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
                (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncdata",
            value: function oncdata(start, endIndex, offset) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex - offset);
                if (!this.htmlMode || this.options.recognizeCDATA) {
                    (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
                    (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
                    (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
                } else {
                    (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
                    (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onend",
            value: function onend() {
                var _a, _b;
                if (this.cbs.onclosetag) {
                    // Set the end index for all remaining tags
                    this.endIndex = this.startIndex;
                    for(var index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
                }
                (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
            }
        },
        {
            /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ key: "reset",
            value: function reset() {
                var _a, _b, _c, _d;
                (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
                this.tokenizer.reset();
                this.tagname = "";
                this.attribname = "";
                this.attribs = null;
                this.stack.length = 0;
                this.startIndex = 0;
                this.endIndex = 0;
                (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
                this.buffers.length = 0;
                this.foreignContext.length = 0;
                this.foreignContext.unshift(!this.htmlMode);
                this.bufferOffset = 0;
                this.writeIndex = 0;
                this.ended = false;
            }
        },
        {
            /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ key: "parseComplete",
            value: function parseComplete(data) {
                this.reset();
                this.end(data);
            }
        },
        {
            key: "getSlice",
            value: function getSlice(start, end) {
                while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
                var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
                while(end - this.bufferOffset > this.buffers[0].length){
                    this.shiftBuffer();
                    slice += this.buffers[0].slice(0, end - this.bufferOffset);
                }
                return slice;
            }
        },
        {
            key: "shiftBuffer",
            value: function shiftBuffer() {
                this.bufferOffset += this.buffers[0].length;
                this.writeIndex--;
                this.buffers.shift();
            }
        },
        {
            /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ key: "write",
            value: function write(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
                    return;
                }
                this.buffers.push(chunk);
                if (this.tokenizer.running) {
                    this.tokenizer.write(chunk);
                    this.writeIndex++;
                }
            }
        },
        {
            /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ key: "end",
            value: function end(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
                    return;
                }
                if (chunk) this.write(chunk);
                this.ended = true;
                this.tokenizer.end();
            }
        },
        {
            /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ key: "pause",
            value: function pause() {
                this.tokenizer.pause();
            }
        },
        {
            /**
     * Resumes parsing after `pause` was called.
     */ key: "resume",
            value: function resume() {
                this.tokenizer.resume();
                while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
                if (this.ended) this.tokenizer.end();
            }
        },
        {
            /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ key: "parseChunk",
            value: function parseChunk(chunk) {
                this.write(chunk);
            }
        },
        {
            /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ key: "done",
            value: function done(chunk) {
                this.end(chunk);
            }
        }
    ]);
    return Parser;
}();

});
parcelRegister("irrER", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $d6d033ef172001c7$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $d6d033ef172001c7$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $jnJXa = parcelRequire("jnJXa");
var $d6d033ef172001c7$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($d6d033ef172001c7$var$CharCodes || ($d6d033ef172001c7$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $d6d033ef172001c7$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["BeforeSpecialT"] = 23] = "BeforeSpecialT";
    State[State["SpecialStartSequence"] = 24] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 25] = "InSpecialTag";
    State[State["InEntity"] = 26] = "InEntity";
})($d6d033ef172001c7$var$State || ($d6d033ef172001c7$var$State = {}));
function $d6d033ef172001c7$var$isWhitespace(c) {
    return c === $d6d033ef172001c7$var$CharCodes.Space || c === $d6d033ef172001c7$var$CharCodes.NewLine || c === $d6d033ef172001c7$var$CharCodes.Tab || c === $d6d033ef172001c7$var$CharCodes.FormFeed || c === $d6d033ef172001c7$var$CharCodes.CarriageReturn;
}
function $d6d033ef172001c7$var$isEndOfTagSection(c) {
    return c === $d6d033ef172001c7$var$CharCodes.Slash || c === $d6d033ef172001c7$var$CharCodes.Gt || $d6d033ef172001c7$var$isWhitespace(c);
}
function $d6d033ef172001c7$var$isASCIIAlpha(c) {
    return c >= $d6d033ef172001c7$var$CharCodes.LowerA && c <= $d6d033ef172001c7$var$CharCodes.LowerZ || c >= $d6d033ef172001c7$var$CharCodes.UpperA && c <= $d6d033ef172001c7$var$CharCodes.UpperZ;
}
var $d6d033ef172001c7$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($d6d033ef172001c7$export$cbf5509cea2ad22 || ($d6d033ef172001c7$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $d6d033ef172001c7$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ]),
    TextareaEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x65,
        0x78,
        0x74,
        0x61,
        0x72,
        0x65,
        0x61
    ]),
    XmpEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x78,
        0x6d,
        0x70
    ])
};
var $d6d033ef172001c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Tokenizer(param, cbs) {
        var _this = this;
        var _param_xmlMode = param.xmlMode, xmlMode = _param_xmlMode === void 0 ? false : _param_xmlMode, _param_decodeEntities = param.decodeEntities, decodeEntities = _param_decodeEntities === void 0 ? true : _param_decodeEntities;
        (0, $jGAMp._)(this, Tokenizer);
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $d6d033ef172001c7$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $d6d033ef172001c7$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new (0, $jnJXa.EntityDecoder)(xmlMode ? (0, $jnJXa.xmlDecodeTree) : (0, $jnJXa.htmlDecodeTree), function(cp, consumed) {
            return _this.emitCodePoint(cp, consumed);
        });
    }
    (0, $byiyg._)(Tokenizer, [
        {
            key: "reset",
            value: function reset() {
                this.state = $d6d033ef172001c7$var$State.Text;
                this.buffer = "";
                this.sectionStart = 0;
                this.index = 0;
                this.baseState = $d6d033ef172001c7$var$State.Text;
                this.currentSequence = undefined;
                this.running = true;
                this.offset = 0;
            }
        },
        {
            key: "write",
            value: function write(chunk) {
                this.offset += this.buffer.length;
                this.buffer = chunk;
                this.parse();
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.running) this.finish();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.running = false;
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.running = true;
                if (this.index < this.buffer.length + this.offset) this.parse();
            }
        },
        {
            key: "stateText",
            value: function stateText(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Lt)) {
                    if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
                    this.state = $d6d033ef172001c7$var$State.BeforeTagName;
                    this.sectionStart = this.index;
                } else if (this.decodeEntities && c === $d6d033ef172001c7$var$CharCodes.Amp) this.startEntity();
            }
        },
        {
            key: "stateSpecialStartSequence",
            value: function stateSpecialStartSequence(c) {
                var isEnd = this.sequenceIndex === this.currentSequence.length;
                var isMatch = isEnd ? $d6d033ef172001c7$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
                if (!isMatch) this.isSpecial = false;
                else if (!isEnd) {
                    this.sequenceIndex++;
                    return;
                }
                this.sequenceIndex = 0;
                this.state = $d6d033ef172001c7$var$State.InTagName;
                this.stateInTagName(c);
            }
        },
        {
            /** Look for an end tag. For <title> tags, also decode entities. */ key: "stateInSpecialTag",
            value: function stateInSpecialTag(c) {
                if (this.sequenceIndex === this.currentSequence.length) {
                    if (c === $d6d033ef172001c7$var$CharCodes.Gt || $d6d033ef172001c7$var$isWhitespace(c)) {
                        var endOfText = this.index - this.currentSequence.length;
                        if (this.sectionStart < endOfText) {
                            // Spoof the index so that reported locations match up.
                            var actualIndex = this.index;
                            this.index = endOfText;
                            this.cbs.ontext(this.sectionStart, endOfText);
                            this.index = actualIndex;
                        }
                        this.isSpecial = false;
                        this.sectionStart = endOfText + 2; // Skip over the `</`
                        this.stateInClosingTagName(c);
                        return; // We are done; skip the rest of the function.
                    }
                    this.sequenceIndex = 0;
                }
                if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
                else if (this.sequenceIndex === 0) {
                    if (this.currentSequence === $d6d033ef172001c7$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
                    {
                        if (this.decodeEntities && c === $d6d033ef172001c7$var$CharCodes.Amp) this.startEntity();
                    } else if (this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
                    this.sequenceIndex = 1;
                } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
                this.sequenceIndex = Number(c === $d6d033ef172001c7$var$CharCodes.Lt);
            }
        },
        {
            key: "stateCDATASequence",
            value: function stateCDATASequence(c) {
                if (c === $d6d033ef172001c7$var$Sequences.Cdata[this.sequenceIndex]) {
                    if (++this.sequenceIndex === $d6d033ef172001c7$var$Sequences.Cdata.length) {
                        this.state = $d6d033ef172001c7$var$State.InCommentLike;
                        this.currentSequence = $d6d033ef172001c7$var$Sequences.CdataEnd;
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                    }
                } else {
                    this.sequenceIndex = 0;
                    this.state = $d6d033ef172001c7$var$State.InDeclaration;
                    this.stateInDeclaration(c); // Reconsume the character
                }
            }
        },
        {
            /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ key: "fastForwardTo",
            value: function fastForwardTo(c) {
                while(++this.index < this.buffer.length + this.offset){
                    if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
                }
                /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
                return false;
            }
        },
        {
            /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ key: "stateInCommentLike",
            value: function stateInCommentLike(c) {
                if (c === this.currentSequence[this.sequenceIndex]) {
                    if (++this.sequenceIndex === this.currentSequence.length) {
                        if (this.currentSequence === $d6d033ef172001c7$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                        else this.cbs.oncomment(this.sectionStart, this.index, 2);
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                        this.state = $d6d033ef172001c7$var$State.Text;
                    }
                } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
                {
                    if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
                } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
                this.sequenceIndex = 0;
            }
        },
        {
            /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ key: "isTagStartChar",
            value: function isTagStartChar(c) {
                return this.xmlMode ? !$d6d033ef172001c7$var$isEndOfTagSection(c) : $d6d033ef172001c7$var$isASCIIAlpha(c);
            }
        },
        {
            key: "startSpecial",
            value: function startSpecial(sequence, offset) {
                this.isSpecial = true;
                this.currentSequence = sequence;
                this.sequenceIndex = offset;
                this.state = $d6d033ef172001c7$var$State.SpecialStartSequence;
            }
        },
        {
            key: "stateBeforeTagName",
            value: function stateBeforeTagName(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.ExclamationMark) {
                    this.state = $d6d033ef172001c7$var$State.BeforeDeclaration;
                    this.sectionStart = this.index + 1;
                } else if (c === $d6d033ef172001c7$var$CharCodes.Questionmark) {
                    this.state = $d6d033ef172001c7$var$State.InProcessingInstruction;
                    this.sectionStart = this.index + 1;
                } else if (this.isTagStartChar(c)) {
                    var lower = c | 0x20;
                    this.sectionStart = this.index;
                    if (this.xmlMode) this.state = $d6d033ef172001c7$var$State.InTagName;
                    else if (lower === $d6d033ef172001c7$var$Sequences.ScriptEnd[2]) this.state = $d6d033ef172001c7$var$State.BeforeSpecialS;
                    else if (lower === $d6d033ef172001c7$var$Sequences.TitleEnd[2] || lower === $d6d033ef172001c7$var$Sequences.XmpEnd[2]) this.state = $d6d033ef172001c7$var$State.BeforeSpecialT;
                    else this.state = $d6d033ef172001c7$var$State.InTagName;
                } else if (c === $d6d033ef172001c7$var$CharCodes.Slash) this.state = $d6d033ef172001c7$var$State.BeforeClosingTagName;
                else {
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.stateText(c);
                }
            }
        },
        {
            key: "stateInTagName",
            value: function stateInTagName(c) {
                if ($d6d033ef172001c7$var$isEndOfTagSection(c)) {
                    this.cbs.onopentagname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $d6d033ef172001c7$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateBeforeClosingTagName",
            value: function stateBeforeClosingTagName(c) {
                if ($d6d033ef172001c7$var$isWhitespace(c)) ;
                else if (c === $d6d033ef172001c7$var$CharCodes.Gt) this.state = $d6d033ef172001c7$var$State.Text;
                else {
                    this.state = this.isTagStartChar(c) ? $d6d033ef172001c7$var$State.InClosingTagName : $d6d033ef172001c7$var$State.InSpecialComment;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInClosingTagName",
            value: function stateInClosingTagName(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt || $d6d033ef172001c7$var$isWhitespace(c)) {
                    this.cbs.onclosetag(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $d6d033ef172001c7$var$State.AfterClosingTagName;
                    this.stateAfterClosingTagName(c);
                }
            }
        },
        {
            key: "stateAfterClosingTagName",
            value: function stateAfterClosingTagName(c) {
                // Skip everything until ">"
                if (c === $d6d033ef172001c7$var$CharCodes.Gt || this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Gt)) {
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeAttributeName",
            value: function stateBeforeAttributeName(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt) {
                    this.cbs.onopentagend(this.index);
                    if (this.isSpecial) {
                        this.state = $d6d033ef172001c7$var$State.InSpecialTag;
                        this.sequenceIndex = 0;
                    } else this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                } else if (c === $d6d033ef172001c7$var$CharCodes.Slash) this.state = $d6d033ef172001c7$var$State.InSelfClosingTag;
                else if (!$d6d033ef172001c7$var$isWhitespace(c)) {
                    this.state = $d6d033ef172001c7$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInSelfClosingTag",
            value: function stateInSelfClosingTag(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt) {
                    this.cbs.onselfclosingtag(this.index);
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                    this.isSpecial = false; // Reset special state, in case of self-closing special tags
                } else if (!$d6d033ef172001c7$var$isWhitespace(c)) {
                    this.state = $d6d033ef172001c7$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateInAttributeName",
            value: function stateInAttributeName(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Eq || $d6d033ef172001c7$var$isEndOfTagSection(c)) {
                    this.cbs.onattribname(this.sectionStart, this.index);
                    this.sectionStart = this.index;
                    this.state = $d6d033ef172001c7$var$State.AfterAttributeName;
                    this.stateAfterAttributeName(c);
                }
            }
        },
        {
            key: "stateAfterAttributeName",
            value: function stateAfterAttributeName(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Eq) this.state = $d6d033ef172001c7$var$State.BeforeAttributeValue;
                else if (c === $d6d033ef172001c7$var$CharCodes.Slash || c === $d6d033ef172001c7$var$CharCodes.Gt) {
                    this.cbs.onattribend($d6d033ef172001c7$export$cbf5509cea2ad22.NoValue, this.sectionStart);
                    this.sectionStart = -1;
                    this.state = $d6d033ef172001c7$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (!$d6d033ef172001c7$var$isWhitespace(c)) {
                    this.cbs.onattribend($d6d033ef172001c7$export$cbf5509cea2ad22.NoValue, this.sectionStart);
                    this.state = $d6d033ef172001c7$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateBeforeAttributeValue",
            value: function stateBeforeAttributeValue(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.DoubleQuote) {
                    this.state = $d6d033ef172001c7$var$State.InAttributeValueDq;
                    this.sectionStart = this.index + 1;
                } else if (c === $d6d033ef172001c7$var$CharCodes.SingleQuote) {
                    this.state = $d6d033ef172001c7$var$State.InAttributeValueSq;
                    this.sectionStart = this.index + 1;
                } else if (!$d6d033ef172001c7$var$isWhitespace(c)) {
                    this.sectionStart = this.index;
                    this.state = $d6d033ef172001c7$var$State.InAttributeValueNq;
                    this.stateInAttributeValueNoQuotes(c); // Reconsume token
                }
            }
        },
        {
            key: "handleInAttributeValue",
            value: function handleInAttributeValue(c, quote) {
                if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend(quote === $d6d033ef172001c7$var$CharCodes.DoubleQuote ? $d6d033ef172001c7$export$cbf5509cea2ad22.Double : $d6d033ef172001c7$export$cbf5509cea2ad22.Single, this.index + 1);
                    this.state = $d6d033ef172001c7$var$State.BeforeAttributeName;
                } else if (this.decodeEntities && c === $d6d033ef172001c7$var$CharCodes.Amp) this.startEntity();
            }
        },
        {
            key: "stateInAttributeValueDoubleQuotes",
            value: function stateInAttributeValueDoubleQuotes(c) {
                this.handleInAttributeValue(c, $d6d033ef172001c7$var$CharCodes.DoubleQuote);
            }
        },
        {
            key: "stateInAttributeValueSingleQuotes",
            value: function stateInAttributeValueSingleQuotes(c) {
                this.handleInAttributeValue(c, $d6d033ef172001c7$var$CharCodes.SingleQuote);
            }
        },
        {
            key: "stateInAttributeValueNoQuotes",
            value: function stateInAttributeValueNoQuotes(c) {
                if ($d6d033ef172001c7$var$isWhitespace(c) || c === $d6d033ef172001c7$var$CharCodes.Gt) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend($d6d033ef172001c7$export$cbf5509cea2ad22.Unquoted, this.index);
                    this.state = $d6d033ef172001c7$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (this.decodeEntities && c === $d6d033ef172001c7$var$CharCodes.Amp) this.startEntity();
            }
        },
        {
            key: "stateBeforeDeclaration",
            value: function stateBeforeDeclaration(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.OpeningSquareBracket) {
                    this.state = $d6d033ef172001c7$var$State.CDATASequence;
                    this.sequenceIndex = 0;
                } else this.state = c === $d6d033ef172001c7$var$CharCodes.Dash ? $d6d033ef172001c7$var$State.BeforeComment : $d6d033ef172001c7$var$State.InDeclaration;
            }
        },
        {
            key: "stateInDeclaration",
            value: function stateInDeclaration(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt || this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Gt)) {
                    this.cbs.ondeclaration(this.sectionStart, this.index);
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateInProcessingInstruction",
            value: function stateInProcessingInstruction(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt || this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Gt)) {
                    this.cbs.onprocessinginstruction(this.sectionStart, this.index);
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeComment",
            value: function stateBeforeComment(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Dash) {
                    this.state = $d6d033ef172001c7$var$State.InCommentLike;
                    this.currentSequence = $d6d033ef172001c7$var$Sequences.CommentEnd;
                    // Allow short comments (eg. <!-->)
                    this.sequenceIndex = 2;
                    this.sectionStart = this.index + 1;
                } else this.state = $d6d033ef172001c7$var$State.InDeclaration;
            }
        },
        {
            key: "stateInSpecialComment",
            value: function stateInSpecialComment(c) {
                if (c === $d6d033ef172001c7$var$CharCodes.Gt || this.fastForwardTo($d6d033ef172001c7$var$CharCodes.Gt)) {
                    this.cbs.oncomment(this.sectionStart, this.index, 0);
                    this.state = $d6d033ef172001c7$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeSpecialS",
            value: function stateBeforeSpecialS(c) {
                var lower = c | 0x20;
                if (lower === $d6d033ef172001c7$var$Sequences.ScriptEnd[3]) this.startSpecial($d6d033ef172001c7$var$Sequences.ScriptEnd, 4);
                else if (lower === $d6d033ef172001c7$var$Sequences.StyleEnd[3]) this.startSpecial($d6d033ef172001c7$var$Sequences.StyleEnd, 4);
                else {
                    this.state = $d6d033ef172001c7$var$State.InTagName;
                    this.stateInTagName(c); // Consume the token again
                }
            }
        },
        {
            key: "stateBeforeSpecialT",
            value: function stateBeforeSpecialT(c) {
                var lower = c | 0x20;
                switch(lower){
                    case $d6d033ef172001c7$var$Sequences.TitleEnd[3]:
                        this.startSpecial($d6d033ef172001c7$var$Sequences.TitleEnd, 4);
                        break;
                    case $d6d033ef172001c7$var$Sequences.TextareaEnd[3]:
                        this.startSpecial($d6d033ef172001c7$var$Sequences.TextareaEnd, 4);
                        break;
                    case $d6d033ef172001c7$var$Sequences.XmpEnd[3]:
                        this.startSpecial($d6d033ef172001c7$var$Sequences.XmpEnd, 4);
                        break;
                    default:
                        this.state = $d6d033ef172001c7$var$State.InTagName;
                        this.stateInTagName(c); // Consume the token again
                }
            }
        },
        {
            key: "startEntity",
            value: function startEntity() {
                this.baseState = this.state;
                this.state = $d6d033ef172001c7$var$State.InEntity;
                this.entityStart = this.index;
                this.entityDecoder.startEntity(this.xmlMode ? (0, $jnJXa.DecodingMode).Strict : this.baseState === $d6d033ef172001c7$var$State.Text || this.baseState === $d6d033ef172001c7$var$State.InSpecialTag ? (0, $jnJXa.DecodingMode).Legacy : (0, $jnJXa.DecodingMode).Attribute);
            }
        },
        {
            key: "stateInEntity",
            value: function stateInEntity() {
                var length = this.entityDecoder.write(this.buffer, this.index - this.offset);
                // If `length` is positive, we are done with the entity.
                if (length >= 0) {
                    this.state = this.baseState;
                    if (length === 0) this.index = this.entityStart;
                } else // Mark buffer as consumed.
                this.index = this.offset + this.buffer.length - 1;
            }
        },
        {
            /**
     * Remove data that has already been consumed from the buffer.
     */ key: "cleanup",
            value: function cleanup() {
                // If we are inside of text or attributes, emit what we already have.
                if (this.running && this.sectionStart !== this.index) {
                    if (this.state === $d6d033ef172001c7$var$State.Text || this.state === $d6d033ef172001c7$var$State.InSpecialTag && this.sequenceIndex === 0) {
                        this.cbs.ontext(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    } else if (this.state === $d6d033ef172001c7$var$State.InAttributeValueDq || this.state === $d6d033ef172001c7$var$State.InAttributeValueSq || this.state === $d6d033ef172001c7$var$State.InAttributeValueNq) {
                        this.cbs.onattribdata(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    }
                }
            }
        },
        {
            key: "shouldContinue",
            value: function shouldContinue() {
                return this.index < this.buffer.length + this.offset && this.running;
            }
        },
        {
            /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ key: "parse",
            value: function parse() {
                while(this.shouldContinue()){
                    var c = this.buffer.charCodeAt(this.index - this.offset);
                    switch(this.state){
                        case $d6d033ef172001c7$var$State.Text:
                            this.stateText(c);
                            break;
                        case $d6d033ef172001c7$var$State.SpecialStartSequence:
                            this.stateSpecialStartSequence(c);
                            break;
                        case $d6d033ef172001c7$var$State.InSpecialTag:
                            this.stateInSpecialTag(c);
                            break;
                        case $d6d033ef172001c7$var$State.CDATASequence:
                            this.stateCDATASequence(c);
                            break;
                        case $d6d033ef172001c7$var$State.InAttributeValueDq:
                            this.stateInAttributeValueDoubleQuotes(c);
                            break;
                        case $d6d033ef172001c7$var$State.InAttributeName:
                            this.stateInAttributeName(c);
                            break;
                        case $d6d033ef172001c7$var$State.InCommentLike:
                            this.stateInCommentLike(c);
                            break;
                        case $d6d033ef172001c7$var$State.InSpecialComment:
                            this.stateInSpecialComment(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeAttributeName:
                            this.stateBeforeAttributeName(c);
                            break;
                        case $d6d033ef172001c7$var$State.InTagName:
                            this.stateInTagName(c);
                            break;
                        case $d6d033ef172001c7$var$State.InClosingTagName:
                            this.stateInClosingTagName(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeTagName:
                            this.stateBeforeTagName(c);
                            break;
                        case $d6d033ef172001c7$var$State.AfterAttributeName:
                            this.stateAfterAttributeName(c);
                            break;
                        case $d6d033ef172001c7$var$State.InAttributeValueSq:
                            this.stateInAttributeValueSingleQuotes(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeAttributeValue:
                            this.stateBeforeAttributeValue(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeClosingTagName:
                            this.stateBeforeClosingTagName(c);
                            break;
                        case $d6d033ef172001c7$var$State.AfterClosingTagName:
                            this.stateAfterClosingTagName(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeSpecialS:
                            this.stateBeforeSpecialS(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeSpecialT:
                            this.stateBeforeSpecialT(c);
                            break;
                        case $d6d033ef172001c7$var$State.InAttributeValueNq:
                            this.stateInAttributeValueNoQuotes(c);
                            break;
                        case $d6d033ef172001c7$var$State.InSelfClosingTag:
                            this.stateInSelfClosingTag(c);
                            break;
                        case $d6d033ef172001c7$var$State.InDeclaration:
                            this.stateInDeclaration(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeDeclaration:
                            this.stateBeforeDeclaration(c);
                            break;
                        case $d6d033ef172001c7$var$State.BeforeComment:
                            this.stateBeforeComment(c);
                            break;
                        case $d6d033ef172001c7$var$State.InProcessingInstruction:
                            this.stateInProcessingInstruction(c);
                            break;
                        case $d6d033ef172001c7$var$State.InEntity:
                            this.stateInEntity();
                            break;
                    }
                    this.index++;
                }
                this.cleanup();
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.state === $d6d033ef172001c7$var$State.InEntity) {
                    this.entityDecoder.end();
                    this.state = this.baseState;
                }
                this.handleTrailingData();
                this.cbs.onend();
            }
        },
        {
            /** Handle any trailing data. */ key: "handleTrailingData",
            value: function handleTrailingData() {
                var endIndex = this.buffer.length + this.offset;
                // If there is no remaining data, we are done.
                if (this.sectionStart >= endIndex) return;
                if (this.state === $d6d033ef172001c7$var$State.InCommentLike) {
                    if (this.currentSequence === $d6d033ef172001c7$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
                    else this.cbs.oncomment(this.sectionStart, endIndex, 0);
                } else if (this.state === $d6d033ef172001c7$var$State.InTagName || this.state === $d6d033ef172001c7$var$State.BeforeAttributeName || this.state === $d6d033ef172001c7$var$State.BeforeAttributeValue || this.state === $d6d033ef172001c7$var$State.AfterAttributeName || this.state === $d6d033ef172001c7$var$State.InAttributeName || this.state === $d6d033ef172001c7$var$State.InAttributeValueSq || this.state === $d6d033ef172001c7$var$State.InAttributeValueDq || this.state === $d6d033ef172001c7$var$State.InAttributeValueNq || this.state === $d6d033ef172001c7$var$State.InClosingTagName) ;
                else this.cbs.ontext(this.sectionStart, endIndex);
            }
        },
        {
            key: "emitCodePoint",
            value: function emitCodePoint(cp, consumed) {
                if (this.baseState !== $d6d033ef172001c7$var$State.Text && this.baseState !== $d6d033ef172001c7$var$State.InSpecialTag) {
                    if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
                    this.sectionStart = this.entityStart + consumed;
                    this.index = this.sectionStart - 1;
                    this.cbs.onattribentity(cp);
                } else {
                    if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
                    this.sectionStart = this.entityStart + consumed;
                    this.index = this.sectionStart - 1;
                    this.cbs.ontextentity(cp, this.sectionStart);
                }
            }
        }
    ]);
    return Tokenizer;
}();

});
parcelRegister("jnJXa", function(module, exports) {
// Make exports work in Node < 12
// eslint-disable-next-line no-undef, unicorn/prefer-module

module.exports = (parcelRequire("iffeP"));

});
parcelRegister("iffeP", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = void 0;
module.exports.determineBranch = $d48572b11c4b8190$var$determineBranch;
module.exports.decodeHTML = $d48572b11c4b8190$var$decodeHTML;
module.exports.decodeHTMLAttribute = $d48572b11c4b8190$var$decodeHTMLAttribute;
module.exports.decodeHTMLStrict = $d48572b11c4b8190$var$decodeHTMLStrict;
module.exports.decodeXML = $d48572b11c4b8190$var$decodeXML;

var $fXIc3 = parcelRequire("fXIc3");

var $by4pE = parcelRequire("by4pE");

var $aXdBJ = parcelRequire("aXdBJ");
var $d48572b11c4b8190$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($d48572b11c4b8190$var$CharCodes || ($d48572b11c4b8190$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $d48572b11c4b8190$var$TO_LOWER_BIT = 32;
var $d48572b11c4b8190$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($d48572b11c4b8190$var$BinTrieFlags || (module.exports.BinTrieFlags = $d48572b11c4b8190$var$BinTrieFlags = {}));
function $d48572b11c4b8190$var$isNumber(code) {
    return code >= $d48572b11c4b8190$var$CharCodes.ZERO && code <= $d48572b11c4b8190$var$CharCodes.NINE;
}
function $d48572b11c4b8190$var$isHexadecimalCharacter(code) {
    return code >= $d48572b11c4b8190$var$CharCodes.UPPER_A && code <= $d48572b11c4b8190$var$CharCodes.UPPER_F || code >= $d48572b11c4b8190$var$CharCodes.LOWER_A && code <= $d48572b11c4b8190$var$CharCodes.LOWER_F;
}
function $d48572b11c4b8190$var$isAsciiAlphaNumeric(code) {
    return code >= $d48572b11c4b8190$var$CharCodes.UPPER_A && code <= $d48572b11c4b8190$var$CharCodes.UPPER_Z || code >= $d48572b11c4b8190$var$CharCodes.LOWER_A && code <= $d48572b11c4b8190$var$CharCodes.LOWER_Z || $d48572b11c4b8190$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $d48572b11c4b8190$var$isEntityInAttributeInvalidEnd(code) {
    return code === $d48572b11c4b8190$var$CharCodes.EQUALS || $d48572b11c4b8190$var$isAsciiAlphaNumeric(code);
}
var $d48572b11c4b8190$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($d48572b11c4b8190$var$EntityDecoderState || ($d48572b11c4b8190$var$EntityDecoderState = {}));
var $d48572b11c4b8190$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($d48572b11c4b8190$var$DecodingMode || (module.exports.DecodingMode = $d48572b11c4b8190$var$DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $d48572b11c4b8190$var$EntityDecoder = /*#__PURE__*/ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        (0, $jGAMp._)(this, EntityDecoder);
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $d48572b11c4b8190$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $d48572b11c4b8190$var$DecodingMode.Strict;
    }
    (0, $byiyg._)(EntityDecoder, [
        {
            /** Resets the instance to make it reusable. */ key: "startEntity",
            value: function startEntity(decodeMode) {
                this.decodeMode = decodeMode;
                this.state = $d48572b11c4b8190$var$EntityDecoderState.EntityStart;
                this.result = 0;
                this.treeIndex = 0;
                this.excess = 1;
                this.consumed = 1;
            }
        },
        {
            /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "write",
            value: function write(input, offset) {
                switch(this.state){
                    case $d48572b11c4b8190$var$EntityDecoderState.EntityStart:
                        if (input.charCodeAt(offset) === $d48572b11c4b8190$var$CharCodes.NUM) {
                            this.state = $d48572b11c4b8190$var$EntityDecoderState.NumericStart;
                            this.consumed += 1;
                            return this.stateNumericStart(input, offset + 1);
                        }
                        this.state = $d48572b11c4b8190$var$EntityDecoderState.NamedEntity;
                        return this.stateNamedEntity(input, offset);
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericStart:
                        return this.stateNumericStart(input, offset);
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericDecimal:
                        return this.stateNumericDecimal(input, offset);
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericHex:
                        return this.stateNumericHex(input, offset);
                    case $d48572b11c4b8190$var$EntityDecoderState.NamedEntity:
                        return this.stateNamedEntity(input, offset);
                }
            }
        },
        {
            /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericStart",
            value: function stateNumericStart(input, offset) {
                if (offset >= input.length) return -1;
                if ((input.charCodeAt(offset) | $d48572b11c4b8190$var$TO_LOWER_BIT) === $d48572b11c4b8190$var$CharCodes.LOWER_X) {
                    this.state = $d48572b11c4b8190$var$EntityDecoderState.NumericHex;
                    this.consumed += 1;
                    return this.stateNumericHex(input, offset + 1);
                }
                this.state = $d48572b11c4b8190$var$EntityDecoderState.NumericDecimal;
                return this.stateNumericDecimal(input, offset);
            }
        },
        {
            key: "addToNumericResult",
            value: function addToNumericResult(input, start, end, base) {
                if (start !== end) {
                    var digitCount = end - start;
                    this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
                    this.consumed += digitCount;
                }
            }
        },
        {
            /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericHex",
            value: function stateNumericHex(input, offset) {
                var startIndex = offset;
                while(offset < input.length){
                    var _char = input.charCodeAt(offset);
                    if ($d48572b11c4b8190$var$isNumber(_char) || $d48572b11c4b8190$var$isHexadecimalCharacter(_char)) offset += 1;
                    else {
                        this.addToNumericResult(input, startIndex, offset, 16);
                        return this.emitNumericEntity(_char, 3);
                    }
                }
                this.addToNumericResult(input, startIndex, offset, 16);
                return -1;
            }
        },
        {
            /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNumericDecimal",
            value: function stateNumericDecimal(input, offset) {
                var startIndex = offset;
                while(offset < input.length){
                    var _char = input.charCodeAt(offset);
                    if ($d48572b11c4b8190$var$isNumber(_char)) offset += 1;
                    else {
                        this.addToNumericResult(input, startIndex, offset, 10);
                        return this.emitNumericEntity(_char, 2);
                    }
                }
                this.addToNumericResult(input, startIndex, offset, 10);
                return -1;
            }
        },
        {
            /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ key: "emitNumericEntity",
            value: function emitNumericEntity(lastCp, expectedLength) {
                var _a;
                // Ensure we consumed at least one digit.
                if (this.consumed <= expectedLength) {
                    (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                    return 0;
                }
                // Figure out if this is a legit end of the entity
                if (lastCp === $d48572b11c4b8190$var$CharCodes.SEMI) this.consumed += 1;
                else if (this.decodeMode === $d48572b11c4b8190$var$DecodingMode.Strict) return 0;
                this.emitCodePoint((0, $aXdBJ.replaceCodePoint)(this.result), this.consumed);
                if (this.errors) {
                    if (lastCp !== $d48572b11c4b8190$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
                    this.errors.validateNumericCharacterReference(this.result);
                }
                return this.consumed;
            }
        },
        {
            /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ key: "stateNamedEntity",
            value: function stateNamedEntity(input, offset) {
                var decodeTree = this.decodeTree;
                var current = decodeTree[this.treeIndex];
                // The mask is the number of bytes of the value, including the current byte.
                var valueLength = (current & $d48572b11c4b8190$var$BinTrieFlags.VALUE_LENGTH) >> 14;
                for(; offset < input.length; offset++, this.excess++){
                    var _char = input.charCodeAt(offset);
                    this.treeIndex = $d48572b11c4b8190$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), _char);
                    if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
                    this.decodeMode === $d48572b11c4b8190$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
                    (valueLength === 0 || // And there should be no invalid characters.
                    $d48572b11c4b8190$var$isEntityInAttributeInvalidEnd(_char)) ? 0 : this.emitNotTerminatedNamedEntity();
                    current = decodeTree[this.treeIndex];
                    valueLength = (current & $d48572b11c4b8190$var$BinTrieFlags.VALUE_LENGTH) >> 14;
                    // If the branch is a value, store it and continue
                    if (valueLength !== 0) {
                        // If the entity is terminated by a semicolon, we are done.
                        if (_char === $d48572b11c4b8190$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                        // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                        if (this.decodeMode !== $d48572b11c4b8190$var$DecodingMode.Strict) {
                            this.result = this.treeIndex;
                            this.consumed += this.excess;
                            this.excess = 0;
                        }
                    }
                }
                return -1;
            }
        },
        {
            /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ key: "emitNotTerminatedNamedEntity",
            value: function emitNotTerminatedNamedEntity() {
                var _a;
                var _this = this, result = _this.result, decodeTree = _this.decodeTree;
                var valueLength = (decodeTree[result] & $d48572b11c4b8190$var$BinTrieFlags.VALUE_LENGTH) >> 14;
                this.emitNamedEntityData(result, valueLength, this.consumed);
                (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
                return this.consumed;
            }
        },
        {
            /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ key: "emitNamedEntityData",
            value: function emitNamedEntityData(result, valueLength, consumed) {
                var decodeTree = this.decodeTree;
                this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$d48572b11c4b8190$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
                if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
                this.emitCodePoint(decodeTree[result + 2], consumed);
                return consumed;
            }
        },
        {
            /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ key: "end",
            value: function end() {
                var _a;
                switch(this.state){
                    case $d48572b11c4b8190$var$EntityDecoderState.NamedEntity:
                        // Emit a named entity if we have one.
                        return this.result !== 0 && (this.decodeMode !== $d48572b11c4b8190$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
                    // Otherwise, emit a numeric entity if we have one.
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericDecimal:
                        return this.emitNumericEntity(0, 2);
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericHex:
                        return this.emitNumericEntity(0, 3);
                    case $d48572b11c4b8190$var$EntityDecoderState.NumericStart:
                        (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                        return 0;
                    case $d48572b11c4b8190$var$EntityDecoderState.EntityStart:
                        // Return 0 if we have no entity.
                        return 0;
                }
            }
        }
    ]);
    return EntityDecoder;
}();
module.exports.EntityDecoder = $d48572b11c4b8190$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $d48572b11c4b8190$var$getDecoder(decodeTree) {
    var returnValue = "";
    var decoder = new $d48572b11c4b8190$var$EntityDecoder(decodeTree, function(data) {
        return returnValue += (0, $aXdBJ.fromCodePoint)(data);
    });
    return function decodeWithTrie(input, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $d48572b11c4b8190$var$determineBranch(decodeTree, current, nodeIndex, _char) {
    var branchCount = (current & $d48572b11c4b8190$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $d48572b11c4b8190$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && _char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = _char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIndex;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midValue = decodeTree[mid];
        if (midValue < _char) lo = mid + 1;
        else if (midValue > _char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
var $d48572b11c4b8190$var$htmlDecoder = /* #__PURE__ */ $d48572b11c4b8190$var$getDecoder($fXIc3.htmlDecodeTree);
var $d48572b11c4b8190$var$xmlDecoder = /* #__PURE__ */ $d48572b11c4b8190$var$getDecoder($by4pE.xmlDecodeTree);
/**
 * Decodes an HTML string.
 *
 * @param htmlString The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $d48572b11c4b8190$var$decodeHTML(htmlString) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d48572b11c4b8190$var$DecodingMode.Legacy;
    return $d48572b11c4b8190$var$htmlDecoder(htmlString, mode);
}
/**
 * Decodes an HTML string in an attribute.
 *
 * @param htmlAttribute The string to decode.
 * @returns The decoded string.
 */ function $d48572b11c4b8190$var$decodeHTMLAttribute(htmlAttribute) {
    return $d48572b11c4b8190$var$htmlDecoder(htmlAttribute, $d48572b11c4b8190$var$DecodingMode.Attribute);
}
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param htmlString The string to decode.
 * @returns The decoded string.
 */ function $d48572b11c4b8190$var$decodeHTMLStrict(htmlString) {
    return $d48572b11c4b8190$var$htmlDecoder(htmlString, $d48572b11c4b8190$var$DecodingMode.Strict);
}
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param xmlString The string to decode.
 * @returns The decoded string.
 */ function $d48572b11c4b8190$var$decodeXML(xmlString) {
    return $d48572b11c4b8190$var$xmlDecoder(xmlString, $d48572b11c4b8190$var$DecodingMode.Strict);
}

var $fXIc3 = parcelRequire("fXIc3");
Object.defineProperty(module.exports, "htmlDecodeTree", {
    enumerable: true,
    get: function get() {
        return $fXIc3.htmlDecodeTree;
    }
});

var $by4pE = parcelRequire("by4pE");
Object.defineProperty(module.exports, "xmlDecodeTree", {
    enumerable: true,
    get: function get() {
        return $by4pE.xmlDecodeTree;
    }
});

var $aXdBJ = parcelRequire("aXdBJ");
Object.defineProperty(module.exports, "decodeCodePoint", {
    enumerable: true,
    get: function get() {
        return $aXdBJ.decodeCodePoint;
    }
});
Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function get() {
        return $aXdBJ.replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function get() {
        return $aXdBJ.fromCodePoint;
    }
});

});
parcelRegister("fXIc3", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.htmlDecodeTree = void 0;
module.exports.htmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("by4pE", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xmlDecodeTree = void 0;
module.exports.xmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("aXdBJ", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $7f99f83c08880a88$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = void 0;
module.exports.replaceCodePoint = $7f99f83c08880a88$var$replaceCodePoint;
module.exports.decodeCodePoint = $7f99f83c08880a88$var$decodeCodePoint;
var $7f99f83c08880a88$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($7f99f83c08880a88$var$_a = String.fromCodePoint) !== null && $7f99f83c08880a88$var$_a !== void 0 ? $7f99f83c08880a88$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $7f99f83c08880a88$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $7f99f83c08880a88$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $7f99f83c08880a88$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($7f99f83c08880a88$var$replaceCodePoint(codePoint));
}

});






parcelRegister("bJahJ", function(module, exports) {
'use strict';

var $6LDFM = parcelRequire("6LDFM");

var $eZJqN = parcelRequire("eZJqN");
var $889be0167ef0d3df$var$originalDestroy = $6LDFM.Readable.destroy;
module.exports = $6LDFM.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $6LDFM._uint8ArrayToBuffer;
module.exports._isUint8Array = $6LDFM._isUint8Array;
module.exports.isDisturbed = $6LDFM.isDisturbed;
module.exports.isErrored = $6LDFM.isErrored;
module.exports.isReadable = $6LDFM.isReadable;
module.exports.Readable = $6LDFM.Readable;
module.exports.Writable = $6LDFM.Writable;
module.exports.Duplex = $6LDFM.Duplex;
module.exports.Transform = $6LDFM.Transform;
module.exports.PassThrough = $6LDFM.PassThrough;
module.exports.addAbortSignal = $6LDFM.addAbortSignal;
module.exports.finished = $6LDFM.finished;
module.exports.destroy = $6LDFM.destroy;
module.exports.destroy = $889be0167ef0d3df$var$originalDestroy;
module.exports.pipeline = $6LDFM.pipeline;
module.exports.compose = $6LDFM.compose;
Object.defineProperty($6LDFM, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $eZJqN;
    }
});
module.exports.Stream = $6LDFM.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("6LDFM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $ln3Kf = parcelRequire("ln3Kf");
var $4ed5e817e3ae0237$require$Buffer = $ln3Kf.Buffer;

var $5846a = parcelRequire("5846a");
/* replacement end */ var $4ed5e817e3ae0237$var$ObjectDefineProperty = $5846a.ObjectDefineProperty, $4ed5e817e3ae0237$var$ObjectKeys = $5846a.ObjectKeys, $4ed5e817e3ae0237$var$ReflectApply = $5846a.ReflectApply;

var $dGIAp = parcelRequire("dGIAp");
var $4ed5e817e3ae0237$var$_require_promisify = $dGIAp.promisify, $4ed5e817e3ae0237$var$customPromisify = $4ed5e817e3ae0237$var$_require_promisify.custom;

var $fHQLj = parcelRequire("fHQLj");
var $4ed5e817e3ae0237$var$streamReturningOperators = $fHQLj.streamReturningOperators, $4ed5e817e3ae0237$var$promiseReturningOperators = $fHQLj.promiseReturningOperators;

var $bGcyc = parcelRequire("bGcyc");
var $4ed5e817e3ae0237$var$ERR_ILLEGAL_CONSTRUCTOR = $bGcyc.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $bFF8j = parcelRequire("bFF8j");

var $cSqYz = parcelRequire("cSqYz");
var $4ed5e817e3ae0237$var$setDefaultHighWaterMark = $cSqYz.setDefaultHighWaterMark, $4ed5e817e3ae0237$var$getDefaultHighWaterMark = $cSqYz.getDefaultHighWaterMark;

var $gjVuq = parcelRequire("gjVuq");
var $4ed5e817e3ae0237$require$pipeline = $gjVuq.pipeline;

var $gNAKV = parcelRequire("gNAKV");
var $4ed5e817e3ae0237$require$destroyer = $gNAKV.destroyer;

var $edHDL = parcelRequire("edHDL");
var $4ed5e817e3ae0237$var$internalBuffer = {};

var $eZJqN = parcelRequire("eZJqN");

var $dolix = parcelRequire("dolix");

var $4ed5e817e3ae0237$var$Stream = module.exports = (parcelRequire("cZ0xR")).Stream;
$4ed5e817e3ae0237$var$Stream.isDestroyed = $dolix.isDestroyed;
$4ed5e817e3ae0237$var$Stream.isDisturbed = $dolix.isDisturbed;
$4ed5e817e3ae0237$var$Stream.isErrored = $dolix.isErrored;
$4ed5e817e3ae0237$var$Stream.isReadable = $dolix.isReadable;
$4ed5e817e3ae0237$var$Stream.isWritable = $dolix.isWritable;

$4ed5e817e3ae0237$var$Stream.Readable = (parcelRequire("8DqnA"));
var $4ed5e817e3ae0237$var$_iteratorNormalCompletion = true, $4ed5e817e3ae0237$var$_didIteratorError = false, $4ed5e817e3ae0237$var$_iteratorError = undefined;
try {
    for(var $4ed5e817e3ae0237$var$_iterator = $4ed5e817e3ae0237$var$ObjectKeys($4ed5e817e3ae0237$var$streamReturningOperators)[Symbol.iterator](), $4ed5e817e3ae0237$var$_step; !($4ed5e817e3ae0237$var$_iteratorNormalCompletion = ($4ed5e817e3ae0237$var$_step = $4ed5e817e3ae0237$var$_iterator.next()).done); $4ed5e817e3ae0237$var$_iteratorNormalCompletion = true){
        var $4ed5e817e3ae0237$var$key = $4ed5e817e3ae0237$var$_step.value;
        var $4ed5e817e3ae0237$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $4ed5e817e3ae0237$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $4ed5e817e3ae0237$var$Stream.Readable.from($4ed5e817e3ae0237$var$ReflectApply($4ed5e817e3ae0237$var$op, this, args));
        };
        var $4ed5e817e3ae0237$var$op = $4ed5e817e3ae0237$var$streamReturningOperators[$4ed5e817e3ae0237$var$key];
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$fn, 'name', {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$op.name
        });
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$fn, 'length', {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$op.length
        });
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$Stream.Readable.prototype, $4ed5e817e3ae0237$var$key, {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $4ed5e817e3ae0237$var$_didIteratorError = true;
    $4ed5e817e3ae0237$var$_iteratorError = err;
} finally{
    try {
        if (!$4ed5e817e3ae0237$var$_iteratorNormalCompletion && $4ed5e817e3ae0237$var$_iterator["return"] != null) {
            $4ed5e817e3ae0237$var$_iterator["return"]();
        }
    } finally{
        if ($4ed5e817e3ae0237$var$_didIteratorError) {
            throw $4ed5e817e3ae0237$var$_iteratorError;
        }
    }
}
var $4ed5e817e3ae0237$var$_iteratorNormalCompletion1 = true, $4ed5e817e3ae0237$var$_didIteratorError1 = false, $4ed5e817e3ae0237$var$_iteratorError1 = undefined;
try {
    for(var $4ed5e817e3ae0237$var$_iterator1 = $4ed5e817e3ae0237$var$ObjectKeys($4ed5e817e3ae0237$var$promiseReturningOperators)[Symbol.iterator](), $4ed5e817e3ae0237$var$_step1; !($4ed5e817e3ae0237$var$_iteratorNormalCompletion1 = ($4ed5e817e3ae0237$var$_step1 = $4ed5e817e3ae0237$var$_iterator1.next()).done); $4ed5e817e3ae0237$var$_iteratorNormalCompletion1 = true){
        var $4ed5e817e3ae0237$var$key1 = $4ed5e817e3ae0237$var$_step1.value;
        var $4ed5e817e3ae0237$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $4ed5e817e3ae0237$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $4ed5e817e3ae0237$var$ReflectApply($4ed5e817e3ae0237$var$op1, this, args);
        };
        var $4ed5e817e3ae0237$var$op1 = $4ed5e817e3ae0237$var$promiseReturningOperators[$4ed5e817e3ae0237$var$key1];
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$fn1, 'name', {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$op1.name
        });
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$fn1, 'length', {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$op1.length
        });
        $4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$Stream.Readable.prototype, $4ed5e817e3ae0237$var$key1, {
            __proto__: null,
            value: $4ed5e817e3ae0237$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $4ed5e817e3ae0237$var$_didIteratorError1 = true;
    $4ed5e817e3ae0237$var$_iteratorError1 = err;
} finally{
    try {
        if (!$4ed5e817e3ae0237$var$_iteratorNormalCompletion1 && $4ed5e817e3ae0237$var$_iterator1["return"] != null) {
            $4ed5e817e3ae0237$var$_iterator1["return"]();
        }
    } finally{
        if ($4ed5e817e3ae0237$var$_didIteratorError1) {
            throw $4ed5e817e3ae0237$var$_iteratorError1;
        }
    }
}

$4ed5e817e3ae0237$var$Stream.Writable = (parcelRequire("eaI15"));

$4ed5e817e3ae0237$var$Stream.Duplex = (parcelRequire("hAfPa"));

$4ed5e817e3ae0237$var$Stream.Transform = (parcelRequire("bl49w"));

$4ed5e817e3ae0237$var$Stream.PassThrough = (parcelRequire("2vlFN"));
$4ed5e817e3ae0237$var$Stream.pipeline = $4ed5e817e3ae0237$require$pipeline;

var $4N0ZQ = parcelRequire("4N0ZQ");
var $4ed5e817e3ae0237$require$addAbortSignal = $4N0ZQ.addAbortSignal;
$4ed5e817e3ae0237$var$Stream.addAbortSignal = $4ed5e817e3ae0237$require$addAbortSignal;
$4ed5e817e3ae0237$var$Stream.finished = $edHDL;
$4ed5e817e3ae0237$var$Stream.destroy = $4ed5e817e3ae0237$require$destroyer;
$4ed5e817e3ae0237$var$Stream.compose = $bFF8j;
$4ed5e817e3ae0237$var$Stream.setDefaultHighWaterMark = $4ed5e817e3ae0237$var$setDefaultHighWaterMark;
$4ed5e817e3ae0237$var$Stream.getDefaultHighWaterMark = $4ed5e817e3ae0237$var$getDefaultHighWaterMark;
$4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $eZJqN;
    }
});
$4ed5e817e3ae0237$var$ObjectDefineProperty($4ed5e817e3ae0237$require$pipeline, $4ed5e817e3ae0237$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $eZJqN.pipeline;
    }
});
$4ed5e817e3ae0237$var$ObjectDefineProperty($edHDL, $4ed5e817e3ae0237$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $eZJqN.finished;
    }
});
// Backwards-compat with node 0.4.x
$4ed5e817e3ae0237$var$Stream.Stream = $4ed5e817e3ae0237$var$Stream;
$4ed5e817e3ae0237$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$4ed5e817e3ae0237$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $4ed5e817e3ae0237$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("ln3Kf", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f8eea69cebada191$export$a143d493d941bafc; }, function (v) { return $f8eea69cebada191$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f8eea69cebada191$export$f99ded8fe4b79145; }, function (v) { return $f8eea69cebada191$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $f8eea69cebada191$export$a143d493d941bafc;
var $f8eea69cebada191$export$e4cf37d7f6fb9e0a;
var $f8eea69cebada191$export$f99ded8fe4b79145;
var $f8eea69cebada191$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $f8eea69cebada191$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f8eea69cebada191$export$a143d493d941bafc = $f8eea69cebada191$var$Buffer;
$f8eea69cebada191$export$e4cf37d7f6fb9e0a = $f8eea69cebada191$var$SlowBuffer;
$f8eea69cebada191$export$f99ded8fe4b79145 = 50;
var $f8eea69cebada191$var$K_MAX_LENGTH = 0x7fffffff;
$f8eea69cebada191$export$599f31c3813fae4d = $f8eea69cebada191$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f8eea69cebada191$var$Buffer.TYPED_ARRAY_SUPPORT = $f8eea69cebada191$var$typedArraySupport();
if (!$f8eea69cebada191$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f8eea69cebada191$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f8eea69cebada191$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$f8eea69cebada191$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f8eea69cebada191$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$f8eea69cebada191$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f8eea69cebada191$var$createBuffer(length) {
    if (length > $f8eea69cebada191$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f8eea69cebada191$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f8eea69cebada191$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f8eea69cebada191$var$allocUnsafe(arg);
    }
    return $f8eea69cebada191$var$from(arg, encodingOrOffset, length);
}
$f8eea69cebada191$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f8eea69cebada191$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f8eea69cebada191$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f8eea69cebada191$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($f8eea69cebada191$var$isInstance(value, ArrayBuffer) || value && $f8eea69cebada191$var$isInstance(value.buffer, ArrayBuffer)) return $f8eea69cebada191$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f8eea69cebada191$var$isInstance(value, SharedArrayBuffer) || value && $f8eea69cebada191$var$isInstance(value.buffer, SharedArrayBuffer))) return $f8eea69cebada191$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f8eea69cebada191$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f8eea69cebada191$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f8eea69cebada191$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f8eea69cebada191$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f8eea69cebada191$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f8eea69cebada191$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f8eea69cebada191$var$Buffer, Uint8Array);
function $f8eea69cebada191$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f8eea69cebada191$var$alloc(size, fill, encoding) {
    $f8eea69cebada191$var$assertSize(size);
    if (size <= 0) return $f8eea69cebada191$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f8eea69cebada191$var$createBuffer(size).fill(fill, encoding) : $f8eea69cebada191$var$createBuffer(size).fill(fill);
    return $f8eea69cebada191$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f8eea69cebada191$var$Buffer.alloc = function(size, fill, encoding) {
    return $f8eea69cebada191$var$alloc(size, fill, encoding);
};
function $f8eea69cebada191$var$allocUnsafe(size) {
    $f8eea69cebada191$var$assertSize(size);
    return $f8eea69cebada191$var$createBuffer(size < 0 ? 0 : $f8eea69cebada191$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f8eea69cebada191$var$Buffer.allocUnsafe = function(size) {
    return $f8eea69cebada191$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f8eea69cebada191$var$Buffer.allocUnsafeSlow = function(size) {
    return $f8eea69cebada191$var$allocUnsafe(size);
};
function $f8eea69cebada191$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f8eea69cebada191$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f8eea69cebada191$var$byteLength(string, encoding) | 0;
    var buf = $f8eea69cebada191$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f8eea69cebada191$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f8eea69cebada191$var$checked(array.length) | 0;
    var buf = $f8eea69cebada191$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f8eea69cebada191$var$fromArrayView(arrayView) {
    if ($f8eea69cebada191$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f8eea69cebada191$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f8eea69cebada191$var$fromArrayLike(arrayView);
}
function $f8eea69cebada191$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f8eea69cebada191$var$Buffer.prototype);
    return buf;
}
function $f8eea69cebada191$var$fromObject(obj) {
    if ($f8eea69cebada191$var$Buffer.isBuffer(obj)) {
        var len = $f8eea69cebada191$var$checked(obj.length) | 0;
        var buf = $f8eea69cebada191$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f8eea69cebada191$var$numberIsNaN(obj.length)) return $f8eea69cebada191$var$createBuffer(0);
        return $f8eea69cebada191$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f8eea69cebada191$var$fromArrayLike(obj.data);
}
function $f8eea69cebada191$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f8eea69cebada191$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f8eea69cebada191$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f8eea69cebada191$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f8eea69cebada191$var$Buffer.alloc(+length);
}
$f8eea69cebada191$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f8eea69cebada191$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f8eea69cebada191$var$Buffer.compare = function compare(a, b) {
    if ($f8eea69cebada191$var$isInstance(a, Uint8Array)) a = $f8eea69cebada191$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f8eea69cebada191$var$isInstance(b, Uint8Array)) b = $f8eea69cebada191$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f8eea69cebada191$var$Buffer.isBuffer(a) || !$f8eea69cebada191$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f8eea69cebada191$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f8eea69cebada191$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f8eea69cebada191$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f8eea69cebada191$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f8eea69cebada191$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f8eea69cebada191$var$Buffer.isBuffer(buf)) buf = $f8eea69cebada191$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f8eea69cebada191$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f8eea69cebada191$var$byteLength(string, encoding) {
    if ($f8eea69cebada191$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f8eea69cebada191$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f8eea69cebada191$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f8eea69cebada191$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f8eea69cebada191$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f8eea69cebada191$var$Buffer.byteLength = $f8eea69cebada191$var$byteLength;
function $f8eea69cebada191$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f8eea69cebada191$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f8eea69cebada191$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f8eea69cebada191$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f8eea69cebada191$var$latin1Slice(this, start, end);
        case 'base64':
            return $f8eea69cebada191$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f8eea69cebada191$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f8eea69cebada191$var$Buffer.prototype._isBuffer = true;
function $f8eea69cebada191$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f8eea69cebada191$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f8eea69cebada191$var$swap(this, i, i + 1);
    return this;
};
$f8eea69cebada191$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f8eea69cebada191$var$swap(this, i, i + 3);
        $f8eea69cebada191$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f8eea69cebada191$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f8eea69cebada191$var$swap(this, i, i + 7);
        $f8eea69cebada191$var$swap(this, i + 1, i + 6);
        $f8eea69cebada191$var$swap(this, i + 2, i + 5);
        $f8eea69cebada191$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f8eea69cebada191$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f8eea69cebada191$var$utf8Slice(this, 0, length);
    return $f8eea69cebada191$var$slowToString.apply(this, arguments);
};
$f8eea69cebada191$var$Buffer.prototype.toLocaleString = $f8eea69cebada191$var$Buffer.prototype.toString;
$f8eea69cebada191$var$Buffer.prototype.equals = function equals(b) {
    if (!$f8eea69cebada191$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f8eea69cebada191$var$Buffer.compare(this, b) === 0;
};
$f8eea69cebada191$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f8eea69cebada191$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f8eea69cebada191$var$customInspectSymbol) $f8eea69cebada191$var$Buffer.prototype[$f8eea69cebada191$var$customInspectSymbol] = $f8eea69cebada191$var$Buffer.prototype.inspect;
$f8eea69cebada191$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f8eea69cebada191$var$isInstance(target, Uint8Array)) target = $f8eea69cebada191$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f8eea69cebada191$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f8eea69cebada191$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f8eea69cebada191$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f8eea69cebada191$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f8eea69cebada191$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f8eea69cebada191$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f8eea69cebada191$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f8eea69cebada191$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f8eea69cebada191$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f8eea69cebada191$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f8eea69cebada191$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f8eea69cebada191$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f8eea69cebada191$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f8eea69cebada191$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f8eea69cebada191$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f8eea69cebada191$var$utf8Write(buf, string, offset, length) {
    return $f8eea69cebada191$var$blitBuffer($f8eea69cebada191$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f8eea69cebada191$var$asciiWrite(buf, string, offset, length) {
    return $f8eea69cebada191$var$blitBuffer($f8eea69cebada191$var$asciiToBytes(string), buf, offset, length);
}
function $f8eea69cebada191$var$base64Write(buf, string, offset, length) {
    return $f8eea69cebada191$var$blitBuffer($f8eea69cebada191$var$base64ToBytes(string), buf, offset, length);
}
function $f8eea69cebada191$var$ucs2Write(buf, string, offset, length) {
    return $f8eea69cebada191$var$blitBuffer($f8eea69cebada191$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f8eea69cebada191$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f8eea69cebada191$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f8eea69cebada191$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f8eea69cebada191$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f8eea69cebada191$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f8eea69cebada191$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f8eea69cebada191$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f8eea69cebada191$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $f8eea69cebada191$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f8eea69cebada191$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f8eea69cebada191$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f8eea69cebada191$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f8eea69cebada191$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f8eea69cebada191$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f8eea69cebada191$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f8eea69cebada191$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f8eea69cebada191$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f8eea69cebada191$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f8eea69cebada191$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f8eea69cebada191$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f8eea69cebada191$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f8eea69cebada191$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f8eea69cebada191$var$Buffer.prototype.readUintLE = $f8eea69cebada191$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f8eea69cebada191$var$Buffer.prototype.readUintBE = $f8eea69cebada191$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f8eea69cebada191$var$Buffer.prototype.readUint8 = $f8eea69cebada191$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f8eea69cebada191$var$Buffer.prototype.readUint16LE = $f8eea69cebada191$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f8eea69cebada191$var$Buffer.prototype.readUint16BE = $f8eea69cebada191$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f8eea69cebada191$var$Buffer.prototype.readUint32LE = $f8eea69cebada191$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f8eea69cebada191$var$Buffer.prototype.readUint32BE = $f8eea69cebada191$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f8eea69cebada191$var$Buffer.prototype.readBigUInt64LE = $f8eea69cebada191$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f8eea69cebada191$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f8eea69cebada191$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f8eea69cebada191$var$Buffer.prototype.readBigUInt64BE = $f8eea69cebada191$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f8eea69cebada191$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f8eea69cebada191$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f8eea69cebada191$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f8eea69cebada191$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f8eea69cebada191$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f8eea69cebada191$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f8eea69cebada191$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f8eea69cebada191$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f8eea69cebada191$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f8eea69cebada191$var$Buffer.prototype.readBigInt64LE = $f8eea69cebada191$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f8eea69cebada191$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f8eea69cebada191$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$f8eea69cebada191$var$Buffer.prototype.readBigInt64BE = $f8eea69cebada191$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f8eea69cebada191$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $f8eea69cebada191$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$f8eea69cebada191$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$f8eea69cebada191$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$f8eea69cebada191$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$f8eea69cebada191$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $f8eea69cebada191$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f8eea69cebada191$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f8eea69cebada191$var$Buffer.prototype.writeUintLE = $f8eea69cebada191$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f8eea69cebada191$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f8eea69cebada191$var$Buffer.prototype.writeUintBE = $f8eea69cebada191$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f8eea69cebada191$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f8eea69cebada191$var$Buffer.prototype.writeUint8 = $f8eea69cebada191$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f8eea69cebada191$var$Buffer.prototype.writeUint16LE = $f8eea69cebada191$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f8eea69cebada191$var$Buffer.prototype.writeUint16BE = $f8eea69cebada191$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f8eea69cebada191$var$Buffer.prototype.writeUint32LE = $f8eea69cebada191$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f8eea69cebada191$var$Buffer.prototype.writeUint32BE = $f8eea69cebada191$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f8eea69cebada191$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f8eea69cebada191$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f8eea69cebada191$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f8eea69cebada191$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f8eea69cebada191$var$Buffer.prototype.writeBigUInt64LE = $f8eea69cebada191$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f8eea69cebada191$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f8eea69cebada191$var$Buffer.prototype.writeBigUInt64BE = $f8eea69cebada191$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f8eea69cebada191$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f8eea69cebada191$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f8eea69cebada191$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f8eea69cebada191$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f8eea69cebada191$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f8eea69cebada191$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f8eea69cebada191$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f8eea69cebada191$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f8eea69cebada191$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f8eea69cebada191$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f8eea69cebada191$var$Buffer.prototype.writeBigInt64LE = $f8eea69cebada191$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f8eea69cebada191$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f8eea69cebada191$var$Buffer.prototype.writeBigInt64BE = $f8eea69cebada191$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $f8eea69cebada191$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f8eea69cebada191$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f8eea69cebada191$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f8eea69cebada191$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f8eea69cebada191$var$writeFloat(this, value, offset, true, noAssert);
};
$f8eea69cebada191$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f8eea69cebada191$var$writeFloat(this, value, offset, false, noAssert);
};
function $f8eea69cebada191$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f8eea69cebada191$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f8eea69cebada191$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f8eea69cebada191$var$writeDouble(this, value, offset, true, noAssert);
};
$f8eea69cebada191$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f8eea69cebada191$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f8eea69cebada191$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f8eea69cebada191$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f8eea69cebada191$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f8eea69cebada191$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f8eea69cebada191$var$Buffer.isBuffer(val) ? val : $f8eea69cebada191$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $f8eea69cebada191$var$errors = {};
function $f8eea69cebada191$var$E(sym, getMessage, Base) {
    $f8eea69cebada191$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$f8eea69cebada191$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f8eea69cebada191$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$f8eea69cebada191$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $f8eea69cebada191$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $f8eea69cebada191$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $f8eea69cebada191$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $f8eea69cebada191$var$checkBounds(buf, offset, byteLength) {
    $f8eea69cebada191$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f8eea69cebada191$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f8eea69cebada191$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $f8eea69cebada191$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f8eea69cebada191$var$checkBounds(buf, offset, byteLength);
}
function $f8eea69cebada191$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f8eea69cebada191$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f8eea69cebada191$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f8eea69cebada191$var$validateNumber(value, type);
        throw new $f8eea69cebada191$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f8eea69cebada191$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f8eea69cebada191$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $f8eea69cebada191$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f8eea69cebada191$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f8eea69cebada191$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f8eea69cebada191$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f8eea69cebada191$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f8eea69cebada191$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f8eea69cebada191$var$base64ToBytes(str) {
    return $abUaD.toByteArray($f8eea69cebada191$var$base64clean(str));
}
function $f8eea69cebada191$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f8eea69cebada191$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f8eea69cebada191$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f8eea69cebada191$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f8eea69cebada191$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f8eea69cebada191$var$BufferBigIntNotDefined : fn;
}
function $f8eea69cebada191$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("5846a", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $3bc0e0fd709a0536$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $3bc0e0fd709a0536$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("dGIAp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $ln3Kf = parcelRequire("ln3Kf");

var $8bKRm = parcelRequire("8bKRm");
var $9f71c87eeee295c4$var$format = $8bKRm.format, $9f71c87eeee295c4$var$inspect = $8bKRm.inspect;

var $bGcyc = parcelRequire("bGcyc");
var $9f71c87eeee295c4$var$ERR_INVALID_ARG_TYPE = $bGcyc.codes.ERR_INVALID_ARG_TYPE;

var $5846a = parcelRequire("5846a");
var $9f71c87eeee295c4$var$kResistStopPropagation = $5846a.kResistStopPropagation, $9f71c87eeee295c4$var$AggregateError = $5846a.AggregateError, $9f71c87eeee295c4$var$SymbolDispose = $5846a.SymbolDispose;

var $9f71c87eeee295c4$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $9f71c87eeee295c4$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $9f71c87eeee295c4$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $9f71c87eeee295c4$var$Blob = globalThis.Blob || $ln3Kf.Blob;
/* eslint-disable indent */ var $9f71c87eeee295c4$var$isBlob = typeof $9f71c87eeee295c4$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $9f71c87eeee295c4$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $9f71c87eeee295c4$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $9f71c87eeee295c4$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $9f71c87eeee295c4$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $9f71c87eeee295c4$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $9f71c87eeee295c4$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $9f71c87eeee295c4$var$format,
    inspect: $9f71c87eeee295c4$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $9f71c87eeee295c4$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $9f71c87eeee295c4$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $9f71c87eeee295c4$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $9f71c87eeee295c4$var$validateAbortSignal(signal, 'signal');
        $9f71c87eeee295c4$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $9f71c87eeee295c4$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $9f71c87eeee295c4$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $9f71c87eeee295c4$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $9f71c87eeee295c4$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $9f71c87eeee295c4$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("8bKRm", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("bGcyc", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $8bKRm = parcelRequire("8bKRm");
var $880d5a3cba6e8a8d$var$format = $8bKRm.format, $880d5a3cba6e8a8d$var$inspect = $8bKRm.inspect;

var $5846a = parcelRequire("5846a");
var $880d5a3cba6e8a8d$var$CustomAggregateError = $5846a.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $880d5a3cba6e8a8d$var$AggregateError = globalThis.AggregateError || $880d5a3cba6e8a8d$var$CustomAggregateError;
var $880d5a3cba6e8a8d$var$kIsNodeError = Symbol('kIsNodeError');
var $880d5a3cba6e8a8d$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $880d5a3cba6e8a8d$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $880d5a3cba6e8a8d$var$nodeInternalPrefix = '__node_internal_';
var $880d5a3cba6e8a8d$var$codes = {};
function $880d5a3cba6e8a8d$var$assert(value, message) {
    if (!value) throw new $880d5a3cba6e8a8d$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $880d5a3cba6e8a8d$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $880d5a3cba6e8a8d$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $880d5a3cba6e8a8d$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $880d5a3cba6e8a8d$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $880d5a3cba6e8a8d$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $880d5a3cba6e8a8d$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $880d5a3cba6e8a8d$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$880d5a3cba6e8a8d$var$kIsNodeError] = true;
    $880d5a3cba6e8a8d$var$codes[code] = NodeError;
}
function $880d5a3cba6e8a8d$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $880d5a3cba6e8a8d$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $880d5a3cba6e8a8d$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $880d5a3cba6e8a8d$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $880d5a3cba6e8a8d$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $880d5a3cba6e8a8d$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$880d5a3cba6e8a8d$var$E('ERR_ASSERTION', '%s', Error);
$880d5a3cba6e8a8d$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $880d5a3cba6e8a8d$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $880d5a3cba6e8a8d$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($880d5a3cba6e8a8d$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($880d5a3cba6e8a8d$var$classRegExp.test(value)) instances.push(value);
            else {
                $880d5a3cba6e8a8d$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $880d5a3cba6e8a8d$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $880d5a3cba6e8a8d$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$880d5a3cba6e8a8d$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $880d5a3cba6e8a8d$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$880d5a3cba6e8a8d$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$880d5a3cba6e8a8d$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $880d5a3cba6e8a8d$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$880d5a3cba6e8a8d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $880d5a3cba6e8a8d$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $880d5a3cba6e8a8d$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $880d5a3cba6e8a8d$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $880d5a3cba6e8a8d$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$880d5a3cba6e8a8d$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$880d5a3cba6e8a8d$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$880d5a3cba6e8a8d$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$880d5a3cba6e8a8d$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $880d5a3cba6e8a8d$var$AbortError,
    aggregateTwoErrors: $880d5a3cba6e8a8d$var$hideStackFrames($880d5a3cba6e8a8d$var$aggregateTwoErrors),
    hideStackFrames: $880d5a3cba6e8a8d$var$hideStackFrames,
    codes: $880d5a3cba6e8a8d$var$codes
};

});


parcelRegister("fHQLj", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $b6f3cc9e8a2ad944$export$42af8c323be37587; }, function (v) { return $b6f3cc9e8a2ad944$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $b6f3cc9e8a2ad944$export$f405f72c701dad87; }, function (v) { return $b6f3cc9e8a2ad944$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $b6f3cc9e8a2ad944$export$42af8c323be37587;
var $b6f3cc9e8a2ad944$export$f405f72c701dad87;
'use strict';

var $b6f3cc9e8a2ad944$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $bGcyc = parcelRequire("bGcyc");
var $b6f3cc9e8a2ad944$var$_require_codes = $bGcyc.codes, $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_VALUE = $b6f3cc9e8a2ad944$var$_require_codes.ERR_INVALID_ARG_VALUE, $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE = $b6f3cc9e8a2ad944$var$_require_codes.ERR_INVALID_ARG_TYPE, $b6f3cc9e8a2ad944$var$ERR_MISSING_ARGS = $b6f3cc9e8a2ad944$var$_require_codes.ERR_MISSING_ARGS, $b6f3cc9e8a2ad944$var$ERR_OUT_OF_RANGE = $b6f3cc9e8a2ad944$var$_require_codes.ERR_OUT_OF_RANGE, $b6f3cc9e8a2ad944$var$AbortError = $bGcyc.AbortError;

var $97dki = parcelRequire("97dki");
var $b6f3cc9e8a2ad944$var$validateAbortSignal = $97dki.validateAbortSignal, $b6f3cc9e8a2ad944$var$validateInteger = $97dki.validateInteger, $b6f3cc9e8a2ad944$var$validateObject = $97dki.validateObject;

var $b6f3cc9e8a2ad944$var$kWeakHandler = (parcelRequire("5846a")).Symbol('kWeak');

var $b6f3cc9e8a2ad944$var$kResistStopPropagation = (parcelRequire("5846a")).Symbol('kResistStopPropagation');

var $edHDL = parcelRequire("edHDL");
var $b6f3cc9e8a2ad944$require$finished = $edHDL.finished;

var $bFF8j = parcelRequire("bFF8j");

var $4N0ZQ = parcelRequire("4N0ZQ");
var $b6f3cc9e8a2ad944$require$addAbortSignalNoValidate = $4N0ZQ.addAbortSignalNoValidate;

var $dolix = parcelRequire("dolix");
var $b6f3cc9e8a2ad944$var$isWritable = $dolix.isWritable, $b6f3cc9e8a2ad944$var$isNodeStream = $dolix.isNodeStream;

var $b6f3cc9e8a2ad944$require$deprecate = (parcelRequire("dGIAp")).deprecate;

var $b6f3cc9e8a2ad944$var$ArrayPrototypePush = (parcelRequire("5846a")).ArrayPrototypePush, $b6f3cc9e8a2ad944$var$Boolean = (parcelRequire("5846a")).Boolean, $b6f3cc9e8a2ad944$var$MathFloor = (parcelRequire("5846a")).MathFloor, $b6f3cc9e8a2ad944$var$Number = (parcelRequire("5846a")).Number, $b6f3cc9e8a2ad944$var$NumberIsNaN = (parcelRequire("5846a")).NumberIsNaN, $b6f3cc9e8a2ad944$var$Promise = (parcelRequire("5846a")).Promise, $b6f3cc9e8a2ad944$var$PromiseReject = (parcelRequire("5846a")).PromiseReject, $b6f3cc9e8a2ad944$var$PromiseResolve = (parcelRequire("5846a")).PromiseResolve, $b6f3cc9e8a2ad944$var$PromisePrototypeThen = (parcelRequire("5846a")).PromisePrototypeThen, $b6f3cc9e8a2ad944$var$Symbol = (parcelRequire("5846a")).Symbol;
var $b6f3cc9e8a2ad944$var$kEmpty = $b6f3cc9e8a2ad944$var$Symbol('kEmpty');
var $b6f3cc9e8a2ad944$var$kEof = $b6f3cc9e8a2ad944$var$Symbol('kEof');
function $b6f3cc9e8a2ad944$var$compose(stream, options) {
    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
    if ($b6f3cc9e8a2ad944$var$isNodeStream(stream) && !$b6f3cc9e8a2ad944$var$isWritable(stream)) throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $bFF8j(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $b6f3cc9e8a2ad944$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $b6f3cc9e8a2ad944$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $b6f3cc9e8a2ad944$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $b6f3cc9e8a2ad944$var$MathFloor(options.highWaterMark);
    $b6f3cc9e8a2ad944$var$validateInteger(concurrency, 'options.concurrency', 1);
    $b6f3cc9e8a2ad944$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $b6f3cc9e8a2ad944$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $b6f3cc9e8a2ad944$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $b6f3cc9e8a2ad944$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $b6f3cc9e8a2ad944$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $b6f3cc9e8a2ad944$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($b6f3cc9e8a2ad944$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $b6f3cc9e8a2ad944$var$PromiseReject(err1);
                                $b6f3cc9e8a2ad944$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("dGIAp")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($b6f3cc9e8a2ad944$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $b6f3cc9e8a2ad944$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                        if (!(val !== $b6f3cc9e8a2ad944$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $b6f3cc9e8a2ad944$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$asIndexedPairs(options) {
    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b6f3cc9e8a2ad944$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $b6f3cc9e8a2ad944$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b6f3cc9e8a2ad944$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $b6f3cc9e8a2ad944$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b6f3cc9e8a2ad944$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $b6f3cc9e8a2ad944$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $b6f3cc9e8a2ad944$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $b6f3cc9e8a2ad944$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($b6f3cc9e8a2ad944$var$ERR_MISSING_ARGS);
function $b6f3cc9e8a2ad944$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $b6f3cc9e8a2ad944$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $b6f3cc9e8a2ad944$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $b6f3cc9e8a2ad944$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $b6f3cc9e8a2ad944$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $b6f3cc9e8a2ad944$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $b6f3cc9e8a2ad944$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $b6f3cc9e8a2ad944$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $b6f3cc9e8a2ad944$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $b6f3cc9e8a2ad944$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$flatMap(fn, options) {
    var values = $b6f3cc9e8a2ad944$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $b6f3cc9e8a2ad944$var$Number(number);
    if ($b6f3cc9e8a2ad944$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $b6f3cc9e8a2ad944$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $b6f3cc9e8a2ad944$var$drop(number, options) {
    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
    number = $b6f3cc9e8a2ad944$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b6f3cc9e8a2ad944$var$take(number, options) {
    if (options != null) $b6f3cc9e8a2ad944$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b6f3cc9e8a2ad944$var$validateAbortSignal(options.signal, 'options.signal');
    number = $b6f3cc9e8a2ad944$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $b6f3cc9e8a2ad944$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$b6f3cc9e8a2ad944$export$42af8c323be37587 = {
    asIndexedPairs: $b6f3cc9e8a2ad944$require$deprecate($b6f3cc9e8a2ad944$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $b6f3cc9e8a2ad944$var$drop,
    filter: $b6f3cc9e8a2ad944$var$filter,
    flatMap: $b6f3cc9e8a2ad944$var$flatMap,
    map: $b6f3cc9e8a2ad944$var$map,
    take: $b6f3cc9e8a2ad944$var$take,
    compose: $b6f3cc9e8a2ad944$var$compose
};
$b6f3cc9e8a2ad944$export$f405f72c701dad87 = {
    every: $b6f3cc9e8a2ad944$var$every,
    forEach: $b6f3cc9e8a2ad944$var$forEach,
    reduce: $b6f3cc9e8a2ad944$var$reduce,
    toArray: $b6f3cc9e8a2ad944$var$toArray,
    some: $b6f3cc9e8a2ad944$var$some,
    find: $b6f3cc9e8a2ad944$var$find
};

});
parcelRegister("97dki", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $5846a = parcelRequire("5846a");
var $6a2f1ad98fa3425c$var$ArrayIsArray = $5846a.ArrayIsArray, $6a2f1ad98fa3425c$var$ArrayPrototypeIncludes = $5846a.ArrayPrototypeIncludes, $6a2f1ad98fa3425c$var$ArrayPrototypeJoin = $5846a.ArrayPrototypeJoin, $6a2f1ad98fa3425c$var$ArrayPrototypeMap = $5846a.ArrayPrototypeMap, $6a2f1ad98fa3425c$var$NumberIsInteger = $5846a.NumberIsInteger, $6a2f1ad98fa3425c$var$NumberIsNaN = $5846a.NumberIsNaN, $6a2f1ad98fa3425c$var$NumberMAX_SAFE_INTEGER = $5846a.NumberMAX_SAFE_INTEGER, $6a2f1ad98fa3425c$var$NumberMIN_SAFE_INTEGER = $5846a.NumberMIN_SAFE_INTEGER, $6a2f1ad98fa3425c$var$NumberParseInt = $5846a.NumberParseInt, $6a2f1ad98fa3425c$var$ObjectPrototypeHasOwnProperty = $5846a.ObjectPrototypeHasOwnProperty, $6a2f1ad98fa3425c$var$RegExpPrototypeExec = $5846a.RegExpPrototypeExec, $6a2f1ad98fa3425c$var$String = $5846a.String, $6a2f1ad98fa3425c$var$StringPrototypeToUpperCase = $5846a.StringPrototypeToUpperCase, $6a2f1ad98fa3425c$var$StringPrototypeTrim = $5846a.StringPrototypeTrim;

var $bGcyc = parcelRequire("bGcyc");
var $6a2f1ad98fa3425c$var$hideStackFrames = $bGcyc.hideStackFrames, $6a2f1ad98fa3425c$var$_require_codes = $bGcyc.codes, $6a2f1ad98fa3425c$var$ERR_SOCKET_BAD_PORT = $6a2f1ad98fa3425c$var$_require_codes.ERR_SOCKET_BAD_PORT, $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE = $6a2f1ad98fa3425c$var$_require_codes.ERR_INVALID_ARG_TYPE, $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE = $6a2f1ad98fa3425c$var$_require_codes.ERR_INVALID_ARG_VALUE, $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE = $6a2f1ad98fa3425c$var$_require_codes.ERR_OUT_OF_RANGE, $6a2f1ad98fa3425c$var$ERR_UNKNOWN_SIGNAL = $6a2f1ad98fa3425c$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $dGIAp = parcelRequire("dGIAp");
var $6a2f1ad98fa3425c$require$normalizeEncoding = $dGIAp.normalizeEncoding;

var $dGIAp = parcelRequire("dGIAp");
var $6a2f1ad98fa3425c$require$_require_types = $dGIAp.types;
var $6a2f1ad98fa3425c$var$isAsyncFunction = $6a2f1ad98fa3425c$require$_require_types.isAsyncFunction, $6a2f1ad98fa3425c$var$isArrayBufferView = $6a2f1ad98fa3425c$require$_require_types.isArrayBufferView;
var $6a2f1ad98fa3425c$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6a2f1ad98fa3425c$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6a2f1ad98fa3425c$var$isUint32(value) {
    return value === value >>> 0;
}
var $6a2f1ad98fa3425c$var$octalReg = /^[0-7]+$/;
var $6a2f1ad98fa3425c$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $6a2f1ad98fa3425c$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($6a2f1ad98fa3425c$var$RegExpPrototypeExec($6a2f1ad98fa3425c$var$octalReg, value) === null) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE(name, value, $6a2f1ad98fa3425c$var$modeDesc);
        value = $6a2f1ad98fa3425c$var$NumberParseInt(value, 8);
    }
    $6a2f1ad98fa3425c$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $6a2f1ad98fa3425c$var$validateInteger = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $6a2f1ad98fa3425c$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $6a2f1ad98fa3425c$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6a2f1ad98fa3425c$var$NumberIsInteger(value)) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $6a2f1ad98fa3425c$var$validateInt32 = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6a2f1ad98fa3425c$var$NumberIsInteger(value)) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $6a2f1ad98fa3425c$var$validateUint32 = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6a2f1ad98fa3425c$var$NumberIsInteger(value)) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $6a2f1ad98fa3425c$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $6a2f1ad98fa3425c$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $6a2f1ad98fa3425c$var$NumberIsNaN(value)) throw new $6a2f1ad98fa3425c$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $6a2f1ad98fa3425c$var$validateOneOf = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name, oneOf) {
    if (!$6a2f1ad98fa3425c$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $6a2f1ad98fa3425c$var$ArrayPrototypeJoin($6a2f1ad98fa3425c$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $6a2f1ad98fa3425c$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $6a2f1ad98fa3425c$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $6a2f1ad98fa3425c$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$6a2f1ad98fa3425c$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $6a2f1ad98fa3425c$var$validateObject = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $6a2f1ad98fa3425c$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $6a2f1ad98fa3425c$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $6a2f1ad98fa3425c$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $6a2f1ad98fa3425c$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $6a2f1ad98fa3425c$var$validateDictionary = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $6a2f1ad98fa3425c$var$validateArray = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$6a2f1ad98fa3425c$var$ArrayIsArray(value)) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $6a2f1ad98fa3425c$var$validateStringArray(value, name) {
    $6a2f1ad98fa3425c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$6a2f1ad98fa3425c$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $6a2f1ad98fa3425c$var$validateBooleanArray(value, name) {
    $6a2f1ad98fa3425c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$6a2f1ad98fa3425c$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $6a2f1ad98fa3425c$var$validateAbortSignalArray(value, name) {
    $6a2f1ad98fa3425c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $6a2f1ad98fa3425c$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $6a2f1ad98fa3425c$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $6a2f1ad98fa3425c$var$validateString(signal, name);
    if ($6a2f1ad98fa3425c$var$signals[signal] === undefined) {
        if ($6a2f1ad98fa3425c$var$signals[$6a2f1ad98fa3425c$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $6a2f1ad98fa3425c$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $6a2f1ad98fa3425c$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $6a2f1ad98fa3425c$var$validateBuffer = $6a2f1ad98fa3425c$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$6a2f1ad98fa3425c$var$isArrayBufferView(buffer)) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $6a2f1ad98fa3425c$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $6a2f1ad98fa3425c$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $6a2f1ad98fa3425c$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $6a2f1ad98fa3425c$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $6a2f1ad98fa3425c$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $6a2f1ad98fa3425c$var$validateAbortSignal = $6a2f1ad98fa3425c$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $6a2f1ad98fa3425c$var$validateFunction = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $6a2f1ad98fa3425c$var$validatePlainFunction = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $6a2f1ad98fa3425c$var$isAsyncFunction(value)) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $6a2f1ad98fa3425c$var$validateUndefined = $6a2f1ad98fa3425c$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $6a2f1ad98fa3425c$var$validateUnion(value, name, union) {
    if (!$6a2f1ad98fa3425c$var$ArrayPrototypeIncludes(union, value)) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_TYPE(name, "('".concat($6a2f1ad98fa3425c$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $6a2f1ad98fa3425c$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $6a2f1ad98fa3425c$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$6a2f1ad98fa3425c$var$RegExpPrototypeExec($6a2f1ad98fa3425c$var$linkValueRegExp, value)) throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $6a2f1ad98fa3425c$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $6a2f1ad98fa3425c$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($6a2f1ad98fa3425c$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $6a2f1ad98fa3425c$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $6a2f1ad98fa3425c$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $6a2f1ad98fa3425c$var$isInt32,
    isUint32: $6a2f1ad98fa3425c$var$isUint32,
    parseFileMode: $6a2f1ad98fa3425c$var$parseFileMode,
    validateArray: $6a2f1ad98fa3425c$var$validateArray,
    validateStringArray: $6a2f1ad98fa3425c$var$validateStringArray,
    validateBooleanArray: $6a2f1ad98fa3425c$var$validateBooleanArray,
    validateAbortSignalArray: $6a2f1ad98fa3425c$var$validateAbortSignalArray,
    validateBoolean: $6a2f1ad98fa3425c$var$validateBoolean,
    validateBuffer: $6a2f1ad98fa3425c$var$validateBuffer,
    validateDictionary: $6a2f1ad98fa3425c$var$validateDictionary,
    validateEncoding: $6a2f1ad98fa3425c$var$validateEncoding,
    validateFunction: $6a2f1ad98fa3425c$var$validateFunction,
    validateInt32: $6a2f1ad98fa3425c$var$validateInt32,
    validateInteger: $6a2f1ad98fa3425c$var$validateInteger,
    validateNumber: $6a2f1ad98fa3425c$var$validateNumber,
    validateObject: $6a2f1ad98fa3425c$var$validateObject,
    validateOneOf: $6a2f1ad98fa3425c$var$validateOneOf,
    validatePlainFunction: $6a2f1ad98fa3425c$var$validatePlainFunction,
    validatePort: $6a2f1ad98fa3425c$var$validatePort,
    validateSignalName: $6a2f1ad98fa3425c$var$validateSignalName,
    validateString: $6a2f1ad98fa3425c$var$validateString,
    validateUint32: $6a2f1ad98fa3425c$var$validateUint32,
    validateUndefined: $6a2f1ad98fa3425c$var$validateUndefined,
    validateUnion: $6a2f1ad98fa3425c$var$validateUnion,
    validateAbortSignal: $6a2f1ad98fa3425c$var$validateAbortSignal,
    validateLinkHeaderValue: $6a2f1ad98fa3425c$var$validateLinkHeaderValue
};

});

parcelRegister("edHDL", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bGcyc = parcelRequire("bGcyc");
/* replacement end */ var $a5a421a89fa002f7$var$AbortError = $bGcyc.AbortError, $a5a421a89fa002f7$var$codes = $bGcyc.codes;
var $a5a421a89fa002f7$var$ERR_INVALID_ARG_TYPE = $a5a421a89fa002f7$var$codes.ERR_INVALID_ARG_TYPE, $a5a421a89fa002f7$var$ERR_STREAM_PREMATURE_CLOSE = $a5a421a89fa002f7$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $a5a421a89fa002f7$var$kEmptyObject = (parcelRequire("dGIAp")).kEmptyObject, $a5a421a89fa002f7$var$once = (parcelRequire("dGIAp")).once;

var $97dki = parcelRequire("97dki");
var $a5a421a89fa002f7$var$validateAbortSignal = $97dki.validateAbortSignal, $a5a421a89fa002f7$var$validateFunction = $97dki.validateFunction, $a5a421a89fa002f7$var$validateObject = $97dki.validateObject, $a5a421a89fa002f7$var$validateBoolean = $97dki.validateBoolean;

var $5846a = parcelRequire("5846a");
var $a5a421a89fa002f7$var$Promise = $5846a.Promise, $a5a421a89fa002f7$var$PromisePrototypeThen = $5846a.PromisePrototypeThen, $a5a421a89fa002f7$var$SymbolDispose = $5846a.SymbolDispose;

var $dolix = parcelRequire("dolix");
var $a5a421a89fa002f7$var$isClosed = $dolix.isClosed, $a5a421a89fa002f7$var$isReadable = $dolix.isReadable, $a5a421a89fa002f7$var$isReadableNodeStream = $dolix.isReadableNodeStream, $a5a421a89fa002f7$var$isReadableStream = $dolix.isReadableStream, $a5a421a89fa002f7$var$isReadableFinished = $dolix.isReadableFinished, $a5a421a89fa002f7$var$isReadableErrored = $dolix.isReadableErrored, $a5a421a89fa002f7$var$isWritable = $dolix.isWritable, $a5a421a89fa002f7$var$isWritableNodeStream = $dolix.isWritableNodeStream, $a5a421a89fa002f7$var$isWritableStream = $dolix.isWritableStream, $a5a421a89fa002f7$var$isWritableFinished = $dolix.isWritableFinished, $a5a421a89fa002f7$var$isWritableErrored = $dolix.isWritableErrored, $a5a421a89fa002f7$var$isNodeStream = $dolix.isNodeStream, $a5a421a89fa002f7$var$_willEmitClose = $dolix.willEmitClose, $a5a421a89fa002f7$var$kIsClosedPromise = $dolix.kIsClosedPromise;
var $a5a421a89fa002f7$var$addAbortListener;
function $a5a421a89fa002f7$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $a5a421a89fa002f7$var$nop = function() {};

function $a5a421a89fa002f7$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a5a421a89fa002f7$var$kEmptyObject;
    } else if (options == null) options = $a5a421a89fa002f7$var$kEmptyObject;
    else $a5a421a89fa002f7$var$validateObject(options, 'options');
    $a5a421a89fa002f7$var$validateFunction(callback, 'callback');
    $a5a421a89fa002f7$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $a5a421a89fa002f7$var$once(callback);
    if ($a5a421a89fa002f7$var$isReadableStream(stream) || $a5a421a89fa002f7$var$isWritableStream(stream)) return $a5a421a89fa002f7$var$eosWeb(stream, options, callback);
    if (!$a5a421a89fa002f7$var$isNodeStream(stream)) throw new $a5a421a89fa002f7$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a5a421a89fa002f7$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a5a421a89fa002f7$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $a5a421a89fa002f7$var$_willEmitClose(stream) && $a5a421a89fa002f7$var$isReadableNodeStream(stream) === readable && $a5a421a89fa002f7$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $a5a421a89fa002f7$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $a5a421a89fa002f7$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $a5a421a89fa002f7$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $a5a421a89fa002f7$var$isWritableErrored(stream) || $a5a421a89fa002f7$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a5a421a89fa002f7$var$isReadableNodeStream(stream, true)) {
            if (!$a5a421a89fa002f7$var$isReadableFinished(stream, false)) return callback.call(stream, new $a5a421a89fa002f7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a5a421a89fa002f7$var$isWritableFinished(stream, false)) return callback.call(stream, new $a5a421a89fa002f7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $a5a421a89fa002f7$var$isWritableErrored(stream) || $a5a421a89fa002f7$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($a5a421a89fa002f7$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a5a421a89fa002f7$var$isReadable(stream)) && (writableFinished || $a5a421a89fa002f7$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a5a421a89fa002f7$var$isWritable(stream)) && (readableFinished || $a5a421a89fa002f7$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $a5a421a89fa002f7$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a5a421a89fa002f7$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $a5a421a89fa002f7$var$addAbortListener = $a5a421a89fa002f7$var$addAbortListener || (parcelRequire("dGIAp")).addAbortListener;
            var disposable = $a5a421a89fa002f7$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $a5a421a89fa002f7$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$a5a421a89fa002f7$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a5a421a89fa002f7$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $a5a421a89fa002f7$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $a5a421a89fa002f7$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $a5a421a89fa002f7$var$addAbortListener = $a5a421a89fa002f7$var$addAbortListener || (parcelRequire("dGIAp")).addAbortListener;
            var disposable = $a5a421a89fa002f7$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $a5a421a89fa002f7$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$a5a421a89fa002f7$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $a5a421a89fa002f7$var$PromisePrototypeThen(stream[$a5a421a89fa002f7$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a5a421a89fa002f7$var$nop;
}
function $a5a421a89fa002f7$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $a5a421a89fa002f7$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a5a421a89fa002f7$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a5a421a89fa002f7$var$Promise(function(resolve, reject) {
        var cleanup = $a5a421a89fa002f7$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a5a421a89fa002f7$var$eos;
module.exports.finished = $a5a421a89fa002f7$var$finished;

});
parcelRegister("dolix", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $5846a = parcelRequire("5846a");
var $9bfe0992896bb982$var$SymbolAsyncIterator = $5846a.SymbolAsyncIterator, $9bfe0992896bb982$var$SymbolIterator = $5846a.SymbolIterator, $9bfe0992896bb982$var$SymbolFor = $5846a.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $9bfe0992896bb982$var$kIsDestroyed = $9bfe0992896bb982$var$SymbolFor('nodejs.stream.destroyed');
var $9bfe0992896bb982$var$kIsErrored = $9bfe0992896bb982$var$SymbolFor('nodejs.stream.errored');
var $9bfe0992896bb982$var$kIsReadable = $9bfe0992896bb982$var$SymbolFor('nodejs.stream.readable');
var $9bfe0992896bb982$var$kIsWritable = $9bfe0992896bb982$var$SymbolFor('nodejs.stream.writable');
var $9bfe0992896bb982$var$kIsDisturbed = $9bfe0992896bb982$var$SymbolFor('nodejs.stream.disturbed');
var $9bfe0992896bb982$var$kIsClosedPromise = $9bfe0992896bb982$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $9bfe0992896bb982$var$kControllerErrorFunction = $9bfe0992896bb982$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $9bfe0992896bb982$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9bfe0992896bb982$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9bfe0992896bb982$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $9bfe0992896bb982$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $9bfe0992896bb982$var$isReadableStream(obj) {
    return !!(obj && !$9bfe0992896bb982$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $9bfe0992896bb982$var$isWritableStream(obj) {
    return !!(obj && !$9bfe0992896bb982$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $9bfe0992896bb982$var$isTransformStream(obj) {
    return !!(obj && !$9bfe0992896bb982$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $9bfe0992896bb982$var$isWebStream(obj) {
    return $9bfe0992896bb982$var$isReadableStream(obj) || $9bfe0992896bb982$var$isWritableStream(obj) || $9bfe0992896bb982$var$isTransformStream(obj);
}
function $9bfe0992896bb982$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9bfe0992896bb982$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$9bfe0992896bb982$var$SymbolIterator] === 'function';
    return typeof obj[$9bfe0992896bb982$var$SymbolAsyncIterator] === 'function' || typeof obj[$9bfe0992896bb982$var$SymbolIterator] === 'function';
}
function $9bfe0992896bb982$var$isDestroyed(stream) {
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$9bfe0992896bb982$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9bfe0992896bb982$var$isWritableEnded(stream) {
    if (!$9bfe0992896bb982$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9bfe0992896bb982$var$isWritableFinished(stream, strict) {
    if (!$9bfe0992896bb982$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9bfe0992896bb982$var$isReadableEnded(stream) {
    if (!$9bfe0992896bb982$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9bfe0992896bb982$var$isReadableFinished(stream, strict) {
    if (!$9bfe0992896bb982$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9bfe0992896bb982$var$isReadable(stream) {
    if (stream && stream[$9bfe0992896bb982$var$kIsReadable] != null) return stream[$9bfe0992896bb982$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($9bfe0992896bb982$var$isDestroyed(stream)) return false;
    return $9bfe0992896bb982$var$isReadableNodeStream(stream) && stream.readable && !$9bfe0992896bb982$var$isReadableFinished(stream);
}
function $9bfe0992896bb982$var$isWritable(stream) {
    if (stream && stream[$9bfe0992896bb982$var$kIsWritable] != null) return stream[$9bfe0992896bb982$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($9bfe0992896bb982$var$isDestroyed(stream)) return false;
    return $9bfe0992896bb982$var$isWritableNodeStream(stream) && stream.writable && !$9bfe0992896bb982$var$isWritableEnded(stream);
}
function $9bfe0992896bb982$var$isFinished(stream, opts) {
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    if ($9bfe0992896bb982$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9bfe0992896bb982$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9bfe0992896bb982$var$isWritable(stream)) return false;
    return true;
}
function $9bfe0992896bb982$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9bfe0992896bb982$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9bfe0992896bb982$var$isClosed(stream) {
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $9bfe0992896bb982$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9bfe0992896bb982$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $9bfe0992896bb982$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $9bfe0992896bb982$var$isOutgoingMessage(stream);
}
function $9bfe0992896bb982$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9bfe0992896bb982$var$willEmitClose(stream) {
    if (!$9bfe0992896bb982$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $9bfe0992896bb982$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9bfe0992896bb982$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9bfe0992896bb982$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9bfe0992896bb982$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9bfe0992896bb982$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9bfe0992896bb982$var$isDestroyed,
    kIsDestroyed: $9bfe0992896bb982$var$kIsDestroyed,
    isDisturbed: $9bfe0992896bb982$var$isDisturbed,
    kIsDisturbed: $9bfe0992896bb982$var$kIsDisturbed,
    isErrored: $9bfe0992896bb982$var$isErrored,
    kIsErrored: $9bfe0992896bb982$var$kIsErrored,
    isReadable: $9bfe0992896bb982$var$isReadable,
    kIsReadable: $9bfe0992896bb982$var$kIsReadable,
    kIsClosedPromise: $9bfe0992896bb982$var$kIsClosedPromise,
    kControllerErrorFunction: $9bfe0992896bb982$var$kControllerErrorFunction,
    kIsWritable: $9bfe0992896bb982$var$kIsWritable,
    isClosed: $9bfe0992896bb982$var$isClosed,
    isDuplexNodeStream: $9bfe0992896bb982$var$isDuplexNodeStream,
    isFinished: $9bfe0992896bb982$var$isFinished,
    isIterable: $9bfe0992896bb982$var$isIterable,
    isReadableNodeStream: $9bfe0992896bb982$var$isReadableNodeStream,
    isReadableStream: $9bfe0992896bb982$var$isReadableStream,
    isReadableEnded: $9bfe0992896bb982$var$isReadableEnded,
    isReadableFinished: $9bfe0992896bb982$var$isReadableFinished,
    isReadableErrored: $9bfe0992896bb982$var$isReadableErrored,
    isNodeStream: $9bfe0992896bb982$var$isNodeStream,
    isWebStream: $9bfe0992896bb982$var$isWebStream,
    isWritable: $9bfe0992896bb982$var$isWritable,
    isWritableNodeStream: $9bfe0992896bb982$var$isWritableNodeStream,
    isWritableStream: $9bfe0992896bb982$var$isWritableStream,
    isWritableEnded: $9bfe0992896bb982$var$isWritableEnded,
    isWritableFinished: $9bfe0992896bb982$var$isWritableFinished,
    isWritableErrored: $9bfe0992896bb982$var$isWritableErrored,
    isServerRequest: $9bfe0992896bb982$var$isServerRequest,
    isServerResponse: $9bfe0992896bb982$var$isServerResponse,
    willEmitClose: $9bfe0992896bb982$var$willEmitClose,
    isTransformStream: $9bfe0992896bb982$var$isTransformStream
};

});


parcelRegister("bFF8j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $gjVuq = parcelRequire("gjVuq");
var $87f36e39b81d3f12$require$pipeline = $gjVuq.pipeline;

var $hAfPa = parcelRequire("hAfPa");

var $gNAKV = parcelRequire("gNAKV");
var $87f36e39b81d3f12$require$destroyer = $gNAKV.destroyer;

var $dolix = parcelRequire("dolix");
var $87f36e39b81d3f12$var$isNodeStream = $dolix.isNodeStream, $87f36e39b81d3f12$var$isReadable = $dolix.isReadable, $87f36e39b81d3f12$var$isWritable = $dolix.isWritable, $87f36e39b81d3f12$var$isWebStream = $dolix.isWebStream, $87f36e39b81d3f12$var$isTransformStream = $dolix.isTransformStream, $87f36e39b81d3f12$var$isWritableStream = $dolix.isWritableStream, $87f36e39b81d3f12$var$isReadableStream = $dolix.isReadableStream;

var $bGcyc = parcelRequire("bGcyc");
var $87f36e39b81d3f12$var$AbortError = $bGcyc.AbortError, $87f36e39b81d3f12$var$_require_codes = $bGcyc.codes, $87f36e39b81d3f12$var$ERR_INVALID_ARG_VALUE = $87f36e39b81d3f12$var$_require_codes.ERR_INVALID_ARG_VALUE, $87f36e39b81d3f12$var$ERR_MISSING_ARGS = $87f36e39b81d3f12$var$_require_codes.ERR_MISSING_ARGS;

var $edHDL = parcelRequire("edHDL");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $87f36e39b81d3f12$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $hAfPa.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $hAfPa.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $hAfPa.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$87f36e39b81d3f12$var$isNodeStream(streams[n]) && !$87f36e39b81d3f12$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($87f36e39b81d3f12$var$isReadable(streams[n]) || $87f36e39b81d3f12$var$isReadableStream(streams[n]) || $87f36e39b81d3f12$var$isTransformStream(streams[n]))) throw new $87f36e39b81d3f12$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($87f36e39b81d3f12$var$isWritable(streams[n]) || $87f36e39b81d3f12$var$isWritableStream(streams[n]) || $87f36e39b81d3f12$var$isTransformStream(streams[n]))) throw new $87f36e39b81d3f12$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $87f36e39b81d3f12$require$pipeline(streams, onfinished);
    var writable = !!($87f36e39b81d3f12$var$isWritable(head) || $87f36e39b81d3f12$var$isWritableStream(head) || $87f36e39b81d3f12$var$isTransformStream(head));
    var readable = !!($87f36e39b81d3f12$var$isReadable(tail) || $87f36e39b81d3f12$var$isReadableStream(tail) || $87f36e39b81d3f12$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $hAfPa({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($87f36e39b81d3f12$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($87f36e39b81d3f12$var$isWebStream(head)) {
            var writable1 = $87f36e39b81d3f12$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $87f36e39b81d3f12$var$isTransformStream(tail) ? tail.readable : tail;
        $edHDL(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($87f36e39b81d3f12$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($87f36e39b81d3f12$var$isWebStream(tail)) {
            var readable1 = $87f36e39b81d3f12$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $87f36e39b81d3f12$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($87f36e39b81d3f12$var$isNodeStream(tail)) $87f36e39b81d3f12$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("gjVuq", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $5846a = parcelRequire("5846a");
var $be1b03f693b80dc7$var$ArrayIsArray = $5846a.ArrayIsArray, $be1b03f693b80dc7$var$Promise = $5846a.Promise, $be1b03f693b80dc7$var$SymbolAsyncIterator = $5846a.SymbolAsyncIterator, $be1b03f693b80dc7$var$SymbolDispose = $5846a.SymbolDispose;

var $edHDL = parcelRequire("edHDL");

var $be1b03f693b80dc7$require$once = (parcelRequire("dGIAp")).once;

var $gNAKV = parcelRequire("gNAKV");

var $hAfPa = parcelRequire("hAfPa");

var $bGcyc = parcelRequire("bGcyc");
var $be1b03f693b80dc7$var$aggregateTwoErrors = $bGcyc.aggregateTwoErrors, $be1b03f693b80dc7$var$_require_codes = $bGcyc.codes, $be1b03f693b80dc7$var$ERR_INVALID_ARG_TYPE = $be1b03f693b80dc7$var$_require_codes.ERR_INVALID_ARG_TYPE, $be1b03f693b80dc7$var$ERR_INVALID_RETURN_VALUE = $be1b03f693b80dc7$var$_require_codes.ERR_INVALID_RETURN_VALUE, $be1b03f693b80dc7$var$ERR_MISSING_ARGS = $be1b03f693b80dc7$var$_require_codes.ERR_MISSING_ARGS, $be1b03f693b80dc7$var$ERR_STREAM_DESTROYED = $be1b03f693b80dc7$var$_require_codes.ERR_STREAM_DESTROYED, $be1b03f693b80dc7$var$ERR_STREAM_PREMATURE_CLOSE = $be1b03f693b80dc7$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $be1b03f693b80dc7$var$AbortError = $bGcyc.AbortError;

var $97dki = parcelRequire("97dki");
var $be1b03f693b80dc7$var$validateFunction = $97dki.validateFunction, $be1b03f693b80dc7$var$validateAbortSignal = $97dki.validateAbortSignal;

var $dolix = parcelRequire("dolix");
var $be1b03f693b80dc7$var$isIterable = $dolix.isIterable, $be1b03f693b80dc7$var$isReadable = $dolix.isReadable, $be1b03f693b80dc7$var$isReadableNodeStream = $dolix.isReadableNodeStream, $be1b03f693b80dc7$var$isNodeStream = $dolix.isNodeStream, $be1b03f693b80dc7$var$isTransformStream = $dolix.isTransformStream, $be1b03f693b80dc7$var$isWebStream = $dolix.isWebStream, $be1b03f693b80dc7$var$isReadableStream = $dolix.isReadableStream, $be1b03f693b80dc7$var$isReadableFinished = $dolix.isReadableFinished;

var $be1b03f693b80dc7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $be1b03f693b80dc7$var$PassThrough;
var $be1b03f693b80dc7$var$Readable;
var $be1b03f693b80dc7$var$addAbortListener;
function $be1b03f693b80dc7$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $edHDL(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $gNAKV.destroyer(stream, err || new $be1b03f693b80dc7$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $be1b03f693b80dc7$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $be1b03f693b80dc7$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $be1b03f693b80dc7$var$makeAsyncIterable(val) {
    if ($be1b03f693b80dc7$var$isIterable(val)) return val;
    else if ($be1b03f693b80dc7$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $be1b03f693b80dc7$var$fromReadable(val);
    throw new $be1b03f693b80dc7$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $be1b03f693b80dc7$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$be1b03f693b80dc7$var$Readable) $be1b03f693b80dc7$var$Readable = (parcelRequire("8DqnA"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($be1b03f693b80dc7$var$Readable.prototype[$be1b03f693b80dc7$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $be1b03f693b80dc7$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $be1b03f693b80dc7$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $edHDL(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $be1b03f693b80dc7$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $be1b03f693b80dc7$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($be1b03f693b80dc7$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $be1b03f693b80dc7$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $be1b03f693b80dc7$var$pipelineImpl(streams, $be1b03f693b80dc7$require$once($be1b03f693b80dc7$var$popCallback(streams)));
}


function $be1b03f693b80dc7$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($be1b03f693b80dc7$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $be1b03f693b80dc7$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($be1b03f693b80dc7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($be1b03f693b80dc7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$be1b03f693b80dc7$var$isIterable(ret)) throw new $be1b03f693b80dc7$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($be1b03f693b80dc7$var$isIterable(stream) || $be1b03f693b80dc7$var$isReadableNodeStream(stream) || $be1b03f693b80dc7$var$isTransformStream(stream)) ret = stream;
            else ret = $hAfPa.from(stream);
        } else if (typeof stream === 'function') {
            if ($be1b03f693b80dc7$var$isTransformStream(ret)) {
                var _ret;
                ret = $be1b03f693b80dc7$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $be1b03f693b80dc7$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$be1b03f693b80dc7$var$isIterable(ret, true)) throw new $be1b03f693b80dc7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$be1b03f693b80dc7$var$PassThrough) $be1b03f693b80dc7$var$PassThrough = (parcelRequire("2vlFN"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $be1b03f693b80dc7$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($be1b03f693b80dc7$var$isIterable(ret, true)) {
                    finishCount++;
                    $be1b03f693b80dc7$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($be1b03f693b80dc7$var$isReadableStream(ret) || $be1b03f693b80dc7$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $be1b03f693b80dc7$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $be1b03f693b80dc7$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $be1b03f693b80dc7$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($be1b03f693b80dc7$var$isNodeStream(stream)) {
            if ($be1b03f693b80dc7$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $be1b03f693b80dc7$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($be1b03f693b80dc7$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($be1b03f693b80dc7$var$isTransformStream(ret) || $be1b03f693b80dc7$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $be1b03f693b80dc7$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($be1b03f693b80dc7$var$isIterable(ret)) {
                finishCount++;
                $be1b03f693b80dc7$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $be1b03f693b80dc7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($be1b03f693b80dc7$var$isWebStream(stream)) {
            if ($be1b03f693b80dc7$var$isReadableNodeStream(ret)) {
                finishCount++;
                $be1b03f693b80dc7$var$pumpToWeb($be1b03f693b80dc7$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($be1b03f693b80dc7$var$isReadableStream(ret) || $be1b03f693b80dc7$var$isIterable(ret)) {
                finishCount++;
                $be1b03f693b80dc7$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($be1b03f693b80dc7$var$isTransformStream(ret)) {
                finishCount++;
                $be1b03f693b80dc7$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $be1b03f693b80dc7$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $hAfPa.from(stream);
    };
    if (streams.length === 1 && $be1b03f693b80dc7$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $be1b03f693b80dc7$var$ERR_MISSING_ARGS('streams');
    var ac = new $be1b03f693b80dc7$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $be1b03f693b80dc7$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $be1b03f693b80dc7$var$AbortError());
    }
    $be1b03f693b80dc7$var$addAbortListener = $be1b03f693b80dc7$var$addAbortListener || (parcelRequire("dGIAp")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $be1b03f693b80dc7$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$be1b03f693b80dc7$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $be1b03f693b80dc7$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $be1b03f693b80dc7$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($be1b03f693b80dc7$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $edHDL(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $edHDL(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $be1b03f693b80dc7$var$pipelineImpl,
    pipeline: $be1b03f693b80dc7$var$pipeline
};

});
parcelRegister("gNAKV", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bGcyc = parcelRequire("bGcyc");
/* replacement end */ var $c3adbbe3767e7fbd$var$aggregateTwoErrors = $bGcyc.aggregateTwoErrors, $c3adbbe3767e7fbd$var$ERR_MULTIPLE_CALLBACK = $bGcyc.codes.ERR_MULTIPLE_CALLBACK, $c3adbbe3767e7fbd$var$AbortError = $bGcyc.AbortError;

var $5846a = parcelRequire("5846a");
var $c3adbbe3767e7fbd$require$Symbol = $5846a.Symbol;

var $dolix = parcelRequire("dolix");
var $c3adbbe3767e7fbd$var$kIsDestroyed = $dolix.kIsDestroyed, $c3adbbe3767e7fbd$var$isDestroyed = $dolix.isDestroyed, $c3adbbe3767e7fbd$var$isFinished = $dolix.isFinished, $c3adbbe3767e7fbd$var$isServerRequest = $dolix.isServerRequest;
var $c3adbbe3767e7fbd$var$kDestroy = $c3adbbe3767e7fbd$require$Symbol('kDestroy');
var $c3adbbe3767e7fbd$var$kConstruct = $c3adbbe3767e7fbd$require$Symbol('kConstruct');
function $c3adbbe3767e7fbd$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $c3adbbe3767e7fbd$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $c3adbbe3767e7fbd$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($c3adbbe3767e7fbd$var$kDestroy, function(er) {
        $c3adbbe3767e7fbd$var$_destroy(this, $c3adbbe3767e7fbd$var$aggregateTwoErrors(er, err), cb);
    });
    else $c3adbbe3767e7fbd$var$_destroy(this, err, cb);
    return this;
}
function $c3adbbe3767e7fbd$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $c3adbbe3767e7fbd$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $c3adbbe3767e7fbd$var$emitErrorCloseNT(self, err) {
    $c3adbbe3767e7fbd$var$emitErrorNT(self, err);
    $c3adbbe3767e7fbd$var$emitCloseNT(self);
}
function $c3adbbe3767e7fbd$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $c3adbbe3767e7fbd$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $c3adbbe3767e7fbd$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $c3adbbe3767e7fbd$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitErrorNT, stream, err);
        else $c3adbbe3767e7fbd$var$emitErrorNT(stream, err);
    }
}
function $c3adbbe3767e7fbd$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($c3adbbe3767e7fbd$var$kConstruct, cb);
    if (stream.listenerCount($c3adbbe3767e7fbd$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($c3adbbe3767e7fbd$var$constructNT, stream);
}
function $c3adbbe3767e7fbd$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $c3adbbe3767e7fbd$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $c3adbbe3767e7fbd$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($c3adbbe3767e7fbd$var$kDestroy, err);
        else if (err) $c3adbbe3767e7fbd$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $c3adbbe3767e7fbd$var$emitConstructNT(stream) {
    stream.emit($c3adbbe3767e7fbd$var$kConstruct);
}
function $c3adbbe3767e7fbd$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $c3adbbe3767e7fbd$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $c3adbbe3767e7fbd$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $c3adbbe3767e7fbd$var$destroyer(stream, err) {
    if (!stream || $c3adbbe3767e7fbd$var$isDestroyed(stream)) return;
    if (!err && !$c3adbbe3767e7fbd$var$isFinished(stream)) err = new $c3adbbe3767e7fbd$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($c3adbbe3767e7fbd$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($c3adbbe3767e7fbd$var$isRequest(stream)) stream.abort();
    else if ($c3adbbe3767e7fbd$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($c3adbbe3767e7fbd$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$c3adbbe3767e7fbd$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $c3adbbe3767e7fbd$var$construct,
    destroyer: $c3adbbe3767e7fbd$var$destroyer,
    destroy: $c3adbbe3767e7fbd$var$destroy,
    undestroy: $c3adbbe3767e7fbd$var$undestroy,
    errorOrDestroy: $c3adbbe3767e7fbd$var$errorOrDestroy
};

});

parcelRegister("hAfPa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $5846a = parcelRequire("5846a");
var $ccd212cf6d2b4f7e$var$ObjectDefineProperties = $5846a.ObjectDefineProperties, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor = $5846a.ObjectGetOwnPropertyDescriptor, $ccd212cf6d2b4f7e$var$ObjectKeys = $5846a.ObjectKeys, $ccd212cf6d2b4f7e$var$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf;
module.exports = $ccd212cf6d2b4f7e$var$Duplex;

var $8DqnA = parcelRequire("8DqnA");

var $eaI15 = parcelRequire("eaI15");
$ccd212cf6d2b4f7e$var$ObjectSetPrototypeOf($ccd212cf6d2b4f7e$var$Duplex.prototype, $8DqnA.prototype);
$ccd212cf6d2b4f7e$var$ObjectSetPrototypeOf($ccd212cf6d2b4f7e$var$Duplex, $8DqnA);
{
    var $ccd212cf6d2b4f7e$var$keys = $ccd212cf6d2b4f7e$var$ObjectKeys($eaI15.prototype);
    // Allow the keys array to be GC'ed.
    for(var $ccd212cf6d2b4f7e$var$i = 0; $ccd212cf6d2b4f7e$var$i < $ccd212cf6d2b4f7e$var$keys.length; $ccd212cf6d2b4f7e$var$i++){
        var $ccd212cf6d2b4f7e$var$method = $ccd212cf6d2b4f7e$var$keys[$ccd212cf6d2b4f7e$var$i];
        if (!$ccd212cf6d2b4f7e$var$Duplex.prototype[$ccd212cf6d2b4f7e$var$method]) $ccd212cf6d2b4f7e$var$Duplex.prototype[$ccd212cf6d2b4f7e$var$method] = $eaI15.prototype[$ccd212cf6d2b4f7e$var$method];
    }
}function $ccd212cf6d2b4f7e$var$Duplex(options) {
    if (!(this instanceof $ccd212cf6d2b4f7e$var$Duplex)) return new $ccd212cf6d2b4f7e$var$Duplex(options);
    $8DqnA.call(this, options);
    $eaI15.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$ccd212cf6d2b4f7e$var$ObjectDefineProperties($ccd212cf6d2b4f7e$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $ccd212cf6d2b4f7e$var$ObjectGetOwnPropertyDescriptor($eaI15.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $ccd212cf6d2b4f7e$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ccd212cf6d2b4f7e$var$lazyWebStreams() {
    if ($ccd212cf6d2b4f7e$var$webStreamsAdapters === undefined) $ccd212cf6d2b4f7e$var$webStreamsAdapters = {};
    return $ccd212cf6d2b4f7e$var$webStreamsAdapters;
}
$ccd212cf6d2b4f7e$var$Duplex.fromWeb = function(pair, options) {
    return $ccd212cf6d2b4f7e$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$ccd212cf6d2b4f7e$var$Duplex.toWeb = function(duplex) {
    return $ccd212cf6d2b4f7e$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $ccd212cf6d2b4f7e$var$duplexify;

$ccd212cf6d2b4f7e$var$Duplex.from = function(body) {
    if (!$ccd212cf6d2b4f7e$var$duplexify) $ccd212cf6d2b4f7e$var$duplexify = (parcelRequire("54KC9"));
    return $ccd212cf6d2b4f7e$var$duplexify(body, 'body');
};

});
parcelRegister("8DqnA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $5846a = parcelRequire("5846a");
/* replacement end */ var $64966da2f845d691$var$ArrayPrototypeIndexOf = $5846a.ArrayPrototypeIndexOf, $64966da2f845d691$var$NumberIsInteger = $5846a.NumberIsInteger, $64966da2f845d691$var$NumberIsNaN = $5846a.NumberIsNaN, $64966da2f845d691$var$NumberParseInt = $5846a.NumberParseInt, $64966da2f845d691$var$ObjectDefineProperties = $5846a.ObjectDefineProperties, $64966da2f845d691$var$ObjectKeys = $5846a.ObjectKeys, $64966da2f845d691$var$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf, $64966da2f845d691$var$Promise = $5846a.Promise, $64966da2f845d691$var$SafeSet = $5846a.SafeSet, $64966da2f845d691$var$SymbolAsyncDispose = $5846a.SymbolAsyncDispose, $64966da2f845d691$var$SymbolAsyncIterator = $5846a.SymbolAsyncIterator, $64966da2f845d691$var$Symbol = $5846a.Symbol;
module.exports = $64966da2f845d691$var$Readable;
$64966da2f845d691$var$Readable.ReadableState = $64966da2f845d691$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $64966da2f845d691$var$EE = $bBoAO.EventEmitter;

var $cZ0xR = parcelRequire("cZ0xR");
var $64966da2f845d691$var$Stream = $cZ0xR.Stream, $64966da2f845d691$var$prependListener = $cZ0xR.prependListener;

var $ln3Kf = parcelRequire("ln3Kf");
var $64966da2f845d691$require$Buffer = $ln3Kf.Buffer;

var $4N0ZQ = parcelRequire("4N0ZQ");
var $64966da2f845d691$require$addAbortSignal = $4N0ZQ.addAbortSignal;

var $edHDL = parcelRequire("edHDL");

var $64966da2f845d691$var$debug = (parcelRequire("dGIAp")).debuglog('stream', function(fn) {
    $64966da2f845d691$var$debug = fn;
});

var $7IOwu = parcelRequire("7IOwu");

var $gNAKV = parcelRequire("gNAKV");

var $cSqYz = parcelRequire("cSqYz");
var $64966da2f845d691$var$getHighWaterMark = $cSqYz.getHighWaterMark, $64966da2f845d691$var$getDefaultHighWaterMark = $cSqYz.getDefaultHighWaterMark;

var $bGcyc = parcelRequire("bGcyc");
var $64966da2f845d691$var$aggregateTwoErrors = $bGcyc.aggregateTwoErrors, $64966da2f845d691$var$_require_codes = $bGcyc.codes, $64966da2f845d691$var$ERR_INVALID_ARG_TYPE = $64966da2f845d691$var$_require_codes.ERR_INVALID_ARG_TYPE, $64966da2f845d691$var$ERR_METHOD_NOT_IMPLEMENTED = $64966da2f845d691$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $64966da2f845d691$var$ERR_OUT_OF_RANGE = $64966da2f845d691$var$_require_codes.ERR_OUT_OF_RANGE, $64966da2f845d691$var$ERR_STREAM_PUSH_AFTER_EOF = $64966da2f845d691$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $64966da2f845d691$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $64966da2f845d691$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $64966da2f845d691$var$AbortError = $bGcyc.AbortError;

var $97dki = parcelRequire("97dki");
var $64966da2f845d691$require$validateObject = $97dki.validateObject;
var $64966da2f845d691$var$kPaused = $64966da2f845d691$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $64966da2f845d691$require$StringDecoder = $3Jf7C.StringDecoder;

var $3vUY6 = parcelRequire("3vUY6");
$64966da2f845d691$var$ObjectSetPrototypeOf($64966da2f845d691$var$Readable.prototype, $64966da2f845d691$var$Stream.prototype);
$64966da2f845d691$var$ObjectSetPrototypeOf($64966da2f845d691$var$Readable, $64966da2f845d691$var$Stream);
var $64966da2f845d691$var$nop = function() {};
var $64966da2f845d691$var$errorOrDestroy = $gNAKV.errorOrDestroy;
var $64966da2f845d691$var$kObjectMode = 1;
var $64966da2f845d691$var$kEnded = 2;
var $64966da2f845d691$var$kEndEmitted = 4;
var $64966da2f845d691$var$kReading = 8;
var $64966da2f845d691$var$kConstructed = 16;
var $64966da2f845d691$var$kSync = 32;
var $64966da2f845d691$var$kNeedReadable = 64;
var $64966da2f845d691$var$kEmittedReadable = 128;
var $64966da2f845d691$var$kReadableListening = 256;
var $64966da2f845d691$var$kResumeScheduled = 512;
var $64966da2f845d691$var$kErrorEmitted = 1024;
var $64966da2f845d691$var$kEmitClose = 2048;
var $64966da2f845d691$var$kAutoDestroy = 4096;
var $64966da2f845d691$var$kDestroyed = 8192;
var $64966da2f845d691$var$kClosed = 16384;
var $64966da2f845d691$var$kCloseEmitted = 32768;
var $64966da2f845d691$var$kMultiAwaitDrain = 65536;
var $64966da2f845d691$var$kReadingMore = 131072;
var $64966da2f845d691$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $64966da2f845d691$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$64966da2f845d691$var$ObjectDefineProperties($64966da2f845d691$var$ReadableState.prototype, {
    objectMode: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kObjectMode),
    ended: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kEnded),
    endEmitted: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kEndEmitted),
    reading: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kNeedReadable),
    emittedReadable: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kEmittedReadable),
    readableListening: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kReadableListening),
    resumeScheduled: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kErrorEmitted),
    emitClose: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kEmitClose),
    autoDestroy: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kCloseEmitted),
    multiAwaitDrain: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kReadingMore),
    dataEmitted: $64966da2f845d691$var$makeBitMapDescriptor($64966da2f845d691$var$kDataEmitted)
});

function $64966da2f845d691$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hAfPa"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $64966da2f845d691$var$kEmitClose | $64966da2f845d691$var$kAutoDestroy | $64966da2f845d691$var$kConstructed | $64966da2f845d691$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $64966da2f845d691$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $64966da2f845d691$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $64966da2f845d691$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $64966da2f845d691$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $7IOwu();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$64966da2f845d691$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$64966da2f845d691$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$64966da2f845d691$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $64966da2f845d691$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $64966da2f845d691$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $64966da2f845d691$var$Readable)) return new $64966da2f845d691$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("hAfPa"));
    this._readableState = new $64966da2f845d691$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $64966da2f845d691$require$addAbortSignal(options.signal, this);
    }
    $64966da2f845d691$var$Stream.call(this, options);
    $gNAKV.construct(this, function() {
        if (_this._readableState.needReadable) $64966da2f845d691$var$maybeReadMore(_this, _this._readableState);
    });
}
$64966da2f845d691$var$Readable.prototype.destroy = $gNAKV.destroy;
$64966da2f845d691$var$Readable.prototype._undestroy = $gNAKV.undestroy;
$64966da2f845d691$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$64966da2f845d691$var$Readable.prototype[$64966da2f845d691$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$64966da2f845d691$var$Readable.prototype[$64966da2f845d691$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $64966da2f845d691$var$AbortError();
        this.destroy(error);
    }
    return new $64966da2f845d691$var$Promise(function(resolve, reject) {
        return $edHDL(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$64966da2f845d691$var$Readable.prototype.push = function(chunk, encoding) {
    return $64966da2f845d691$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$64966da2f845d691$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $64966da2f845d691$var$readableAddChunk(this, chunk, encoding, true);
};
function $64966da2f845d691$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $64966da2f845d691$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $64966da2f845d691$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $64966da2f845d691$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $64966da2f845d691$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $64966da2f845d691$require$Buffer) encoding = '';
        else if ($64966da2f845d691$var$Stream._isUint8Array(chunk)) {
            chunk = $64966da2f845d691$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $64966da2f845d691$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $64966da2f845d691$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$64966da2f845d691$var$kReading;
        $64966da2f845d691$var$onEofChunk(stream, state);
    } else if ((state.state & $64966da2f845d691$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $64966da2f845d691$var$kEndEmitted) !== 0) $64966da2f845d691$var$errorOrDestroy(stream, new $64966da2f845d691$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $64966da2f845d691$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $64966da2f845d691$var$errorOrDestroy(stream, new $64966da2f845d691$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$64966da2f845d691$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $64966da2f845d691$var$addChunk(stream, state, chunk, false);
                else $64966da2f845d691$var$maybeReadMore(stream, state);
            } else $64966da2f845d691$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$64966da2f845d691$var$kReading;
        $64966da2f845d691$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $64966da2f845d691$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $64966da2f845d691$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $64966da2f845d691$var$kNeedReadable) !== 0) $64966da2f845d691$var$emitReadable(stream);
    }
    $64966da2f845d691$var$maybeReadMore(stream, state);
}
$64966da2f845d691$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$64966da2f845d691$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$64966da2f845d691$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $64966da2f845d691$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$64966da2f845d691$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $64966da2f845d691$var$MAX_HWM = 0x40000000;
function $64966da2f845d691$var$computeNewHighWaterMark(n) {
    if (n > $64966da2f845d691$var$MAX_HWM) throw new $64966da2f845d691$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64966da2f845d691$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $64966da2f845d691$var$kObjectMode) !== 0) return 1;
    if ($64966da2f845d691$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$64966da2f845d691$var$Readable.prototype.read = function(n) {
    $64966da2f845d691$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$64966da2f845d691$var$NumberIsInteger(n)) n = $64966da2f845d691$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $64966da2f845d691$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$64966da2f845d691$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $64966da2f845d691$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $64966da2f845d691$var$endReadable(this);
        else $64966da2f845d691$var$emitReadable(this);
        return null;
    }
    n = $64966da2f845d691$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $64966da2f845d691$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $64966da2f845d691$var$kNeedReadable) !== 0;
    $64966da2f845d691$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $64966da2f845d691$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $64966da2f845d691$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $64966da2f845d691$var$debug('do read');
        state.state |= $64966da2f845d691$var$kReading | $64966da2f845d691$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $64966da2f845d691$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $64966da2f845d691$var$errorOrDestroy(this, err);
        }
        state.state &= ~$64966da2f845d691$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $64966da2f845d691$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $64966da2f845d691$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $64966da2f845d691$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $64966da2f845d691$var$onEofChunk(stream, state) {
    $64966da2f845d691$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $64966da2f845d691$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $64966da2f845d691$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $64966da2f845d691$var$emitReadable(stream) {
    var state = stream._readableState;
    $64966da2f845d691$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $64966da2f845d691$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($64966da2f845d691$var$emitReadable_, stream);
    }
}
function $64966da2f845d691$var$emitReadable_(stream) {
    var state = stream._readableState;
    $64966da2f845d691$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $64966da2f845d691$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $64966da2f845d691$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($64966da2f845d691$var$maybeReadMore_, stream, state);
    }
}
function $64966da2f845d691$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $64966da2f845d691$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$64966da2f845d691$var$Readable.prototype._read = function(n) {
    throw new $64966da2f845d691$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$64966da2f845d691$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $64966da2f845d691$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $64966da2f845d691$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $64966da2f845d691$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $64966da2f845d691$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $64966da2f845d691$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $64966da2f845d691$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $64966da2f845d691$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $64966da2f845d691$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $64966da2f845d691$var$debug('ondata');
        var ret = dest.write(chunk);
        $64966da2f845d691$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $64966da2f845d691$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $64966da2f845d691$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $64966da2f845d691$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $64966da2f845d691$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $64966da2f845d691$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $64966da2f845d691$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $64966da2f845d691$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $64966da2f845d691$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $64966da2f845d691$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$64966da2f845d691$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $64966da2f845d691$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$64966da2f845d691$var$Readable.prototype.on = function(ev, fn) {
    var res = $64966da2f845d691$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $64966da2f845d691$var$debug('on readable', state.length, state.reading);
            if (state.length) $64966da2f845d691$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($64966da2f845d691$var$nReadingNextTick, this);
        }
    }
    return res;
};
$64966da2f845d691$var$Readable.prototype.addListener = $64966da2f845d691$var$Readable.prototype.on;
$64966da2f845d691$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $64966da2f845d691$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($64966da2f845d691$var$updateReadableListening, this);
    return res;
};
$64966da2f845d691$var$Readable.prototype.off = $64966da2f845d691$var$Readable.prototype.removeListener;
$64966da2f845d691$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $64966da2f845d691$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($64966da2f845d691$var$updateReadableListening, this);
    return res;
};
function $64966da2f845d691$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$64966da2f845d691$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $64966da2f845d691$var$nReadingNextTick(self) {
    $64966da2f845d691$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$64966da2f845d691$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $64966da2f845d691$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $64966da2f845d691$var$resume(this, state);
    }
    state[$64966da2f845d691$var$kPaused] = false;
    return this;
};
function $64966da2f845d691$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($64966da2f845d691$var$resume_, stream, state);
    }
}
function $64966da2f845d691$var$resume_(stream, state) {
    $64966da2f845d691$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $64966da2f845d691$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$64966da2f845d691$var$Readable.prototype.pause = function() {
    $64966da2f845d691$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $64966da2f845d691$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$64966da2f845d691$var$kPaused] = true;
    return this;
};
function $64966da2f845d691$var$flow(stream) {
    var state = stream._readableState;
    $64966da2f845d691$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$64966da2f845d691$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $64966da2f845d691$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $64966da2f845d691$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$64966da2f845d691$var$Readable.prototype[$64966da2f845d691$var$SymbolAsyncIterator] = function() {
    return $64966da2f845d691$var$streamToAsyncIterator(this);
};
$64966da2f845d691$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $64966da2f845d691$require$validateObject(options, 'options');
    return $64966da2f845d691$var$streamToAsyncIterator(this, options);
};
function $64966da2f845d691$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $64966da2f845d691$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $64966da2f845d691$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $64966da2f845d691$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $64966da2f845d691$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $64966da2f845d691$var$nop;
                    stream.on('readable', next);
                    cleanup = $edHDL(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $64966da2f845d691$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $64966da2f845d691$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $64966da2f845d691$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $64966da2f845d691$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $gNAKV.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$64966da2f845d691$var$ObjectDefineProperties($64966da2f845d691$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$64966da2f845d691$var$ObjectDefineProperties($64966da2f845d691$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$64966da2f845d691$var$kPaused] !== false;
        },
        set: function(value) {
            this[$64966da2f845d691$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$64966da2f845d691$var$Readable._fromList = $64966da2f845d691$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64966da2f845d691$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $64966da2f845d691$var$endReadable(stream) {
    var state = stream._readableState;
    $64966da2f845d691$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($64966da2f845d691$var$endReadableNT, state, stream);
    }
}
function $64966da2f845d691$var$endReadableNT(state, stream) {
    $64966da2f845d691$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($64966da2f845d691$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $64966da2f845d691$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$64966da2f845d691$var$Readable.from = function(iterable, opts) {
    return $3vUY6($64966da2f845d691$var$Readable, iterable, opts);
};
var $64966da2f845d691$var$webStreamsAdapters;
// Lazy to avoid circular references
function $64966da2f845d691$var$lazyWebStreams() {
    if ($64966da2f845d691$var$webStreamsAdapters === undefined) $64966da2f845d691$var$webStreamsAdapters = {};
    return $64966da2f845d691$var$webStreamsAdapters;
}
$64966da2f845d691$var$Readable.fromWeb = function(readableStream, options) {
    return $64966da2f845d691$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$64966da2f845d691$var$Readable.toWeb = function(streamReadable, options) {
    return $64966da2f845d691$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$64966da2f845d691$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $64966da2f845d691$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $gNAKV.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("cZ0xR", function(module, exports) {
'use strict';

var $5846a = parcelRequire("5846a");
var $973b9ac6d7101619$var$ArrayIsArray = $5846a.ArrayIsArray, $973b9ac6d7101619$var$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $973b9ac6d7101619$var$EE = $bBoAO.EventEmitter;
function $973b9ac6d7101619$var$Stream(opts) {
    $973b9ac6d7101619$var$EE.call(this, opts);
}
$973b9ac6d7101619$var$ObjectSetPrototypeOf($973b9ac6d7101619$var$Stream.prototype, $973b9ac6d7101619$var$EE.prototype);
$973b9ac6d7101619$var$ObjectSetPrototypeOf($973b9ac6d7101619$var$Stream, $973b9ac6d7101619$var$EE);
$973b9ac6d7101619$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($973b9ac6d7101619$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $973b9ac6d7101619$var$prependListener(source, 'error', onerror);
    $973b9ac6d7101619$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $973b9ac6d7101619$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($973b9ac6d7101619$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $973b9ac6d7101619$var$Stream,
    prependListener: $973b9ac6d7101619$var$prependListener
};

});

parcelRegister("4N0ZQ", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $37cc82ed64787db0$export$e2db56ee53255a0; }, function (v) { return $37cc82ed64787db0$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $37cc82ed64787db0$export$11956e9313f43de0; }, function (v) { return $37cc82ed64787db0$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $37cc82ed64787db0$export$e2db56ee53255a0;
var $37cc82ed64787db0$export$11956e9313f43de0;
'use strict';

var $5846a = parcelRequire("5846a");
var $37cc82ed64787db0$require$SymbolDispose = $5846a.SymbolDispose;

var $bGcyc = parcelRequire("bGcyc");
var $37cc82ed64787db0$var$AbortError = $bGcyc.AbortError, $37cc82ed64787db0$var$codes = $bGcyc.codes;

var $dolix = parcelRequire("dolix");
var $37cc82ed64787db0$var$isNodeStream = $dolix.isNodeStream, $37cc82ed64787db0$var$isWebStream = $dolix.isWebStream, $37cc82ed64787db0$var$kControllerErrorFunction = $dolix.kControllerErrorFunction;

var $edHDL = parcelRequire("edHDL");
var $37cc82ed64787db0$var$ERR_INVALID_ARG_TYPE = $37cc82ed64787db0$var$codes.ERR_INVALID_ARG_TYPE;
var $37cc82ed64787db0$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $37cc82ed64787db0$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $37cc82ed64787db0$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$37cc82ed64787db0$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $37cc82ed64787db0$var$validateAbortSignal(signal, 'signal');
    if (!$37cc82ed64787db0$var$isNodeStream(stream) && !$37cc82ed64787db0$var$isWebStream(stream)) throw new $37cc82ed64787db0$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $37cc82ed64787db0$export$11956e9313f43de0(signal, stream);
};

$37cc82ed64787db0$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $37cc82ed64787db0$var$isNodeStream(stream) ? function() {
        stream.destroy(new $37cc82ed64787db0$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$37cc82ed64787db0$var$kControllerErrorFunction](new $37cc82ed64787db0$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $37cc82ed64787db0$var$addAbortListener = $37cc82ed64787db0$var$addAbortListener || (parcelRequire("dGIAp")).addAbortListener;
        var disposable = $37cc82ed64787db0$var$addAbortListener(signal, onAbort);
        $edHDL(stream, disposable[$37cc82ed64787db0$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("7IOwu", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $5846a = parcelRequire("5846a");
var $59f3d547a9b5a1aa$var$StringPrototypeSlice = $5846a.StringPrototypeSlice, $59f3d547a9b5a1aa$var$SymbolIterator = $5846a.SymbolIterator, $59f3d547a9b5a1aa$var$TypedArrayPrototypeSet = $5846a.TypedArrayPrototypeSet, $59f3d547a9b5a1aa$var$Uint8Array = $5846a.Uint8Array;

var $ln3Kf = parcelRequire("ln3Kf");
var $59f3d547a9b5a1aa$require$Buffer = $ln3Kf.Buffer;

var $dGIAp = parcelRequire("dGIAp");
var $59f3d547a9b5a1aa$require$inspect = $dGIAp.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $59f3d547a9b5a1aa$require$Buffer.alloc(0);
                var ret = $59f3d547a9b5a1aa$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $59f3d547a9b5a1aa$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $59f3d547a9b5a1aa$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $59f3d547a9b5a1aa$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $59f3d547a9b5a1aa$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $59f3d547a9b5a1aa$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $59f3d547a9b5a1aa$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $59f3d547a9b5a1aa$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $59f3d547a9b5a1aa$var$TypedArrayPrototypeSet(ret, new $59f3d547a9b5a1aa$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $59f3d547a9b5a1aa$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cSqYz", function(module, exports) {
'use strict';

var $5846a = parcelRequire("5846a");
var $95ff74091abf86df$var$MathFloor = $5846a.MathFloor, $95ff74091abf86df$var$NumberIsInteger = $5846a.NumberIsInteger;

var $97dki = parcelRequire("97dki");
var $95ff74091abf86df$require$validateInteger = $97dki.validateInteger;

var $95ff74091abf86df$var$ERR_INVALID_ARG_VALUE = (parcelRequire("bGcyc")).codes.ERR_INVALID_ARG_VALUE;
var $95ff74091abf86df$var$defaultHighWaterMarkBytes = 16384;
var $95ff74091abf86df$var$defaultHighWaterMarkObjectMode = 16;
function $95ff74091abf86df$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $95ff74091abf86df$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $95ff74091abf86df$var$defaultHighWaterMarkObjectMode : $95ff74091abf86df$var$defaultHighWaterMarkBytes;
}
function $95ff74091abf86df$var$setDefaultHighWaterMark(objectMode, value) {
    $95ff74091abf86df$require$validateInteger(value, 'value', 0);
    if (objectMode) $95ff74091abf86df$var$defaultHighWaterMarkObjectMode = value;
    else $95ff74091abf86df$var$defaultHighWaterMarkBytes = value;
}
function $95ff74091abf86df$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $95ff74091abf86df$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$95ff74091abf86df$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $95ff74091abf86df$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $95ff74091abf86df$var$MathFloor(hwm);
    }
    // Default value
    return $95ff74091abf86df$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $95ff74091abf86df$var$getHighWaterMark,
    getDefaultHighWaterMark: $95ff74091abf86df$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $95ff74091abf86df$var$setDefaultHighWaterMark
};

});

parcelRegister("3vUY6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $5846a = parcelRequire("5846a");
/* replacement end */ var $28f07516a34a0276$var$PromisePrototypeThen = $5846a.PromisePrototypeThen, $28f07516a34a0276$var$SymbolAsyncIterator = $5846a.SymbolAsyncIterator, $28f07516a34a0276$var$SymbolIterator = $5846a.SymbolIterator;

var $ln3Kf = parcelRequire("ln3Kf");
var $28f07516a34a0276$require$Buffer = $ln3Kf.Buffer;

var $bGcyc = parcelRequire("bGcyc");
var $28f07516a34a0276$require$_require_codes = $bGcyc.codes;
var $28f07516a34a0276$var$ERR_INVALID_ARG_TYPE = $28f07516a34a0276$require$_require_codes.ERR_INVALID_ARG_TYPE, $28f07516a34a0276$var$ERR_STREAM_NULL_VALUES = $28f07516a34a0276$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $28f07516a34a0276$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $28f07516a34a0276$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$28f07516a34a0276$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$28f07516a34a0276$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$28f07516a34a0276$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$28f07516a34a0276$var$SymbolIterator]();
    } else throw new $28f07516a34a0276$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $28f07516a34a0276$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $28f07516a34a0276$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $28f07516a34a0276$var$from;

});


parcelRegister("eaI15", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $5846a = parcelRequire("5846a");
/* replacement end */ var $a514249fcd2b110a$var$ArrayPrototypeSlice = $5846a.ArrayPrototypeSlice, $a514249fcd2b110a$var$Error = $5846a.Error, $a514249fcd2b110a$var$FunctionPrototypeSymbolHasInstance = $5846a.FunctionPrototypeSymbolHasInstance, $a514249fcd2b110a$var$ObjectDefineProperty = $5846a.ObjectDefineProperty, $a514249fcd2b110a$var$ObjectDefineProperties = $5846a.ObjectDefineProperties, $a514249fcd2b110a$var$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf, $a514249fcd2b110a$var$StringPrototypeToLowerCase = $5846a.StringPrototypeToLowerCase, $a514249fcd2b110a$var$Symbol = $5846a.Symbol, $a514249fcd2b110a$var$SymbolHasInstance = $5846a.SymbolHasInstance;
module.exports = $a514249fcd2b110a$var$Writable;
$a514249fcd2b110a$var$Writable.WritableState = $a514249fcd2b110a$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a514249fcd2b110a$var$EE = $bBoAO.EventEmitter;

var $cZ0xR = parcelRequire("cZ0xR");
var $a514249fcd2b110a$require$Stream = $cZ0xR.Stream;

var $ln3Kf = parcelRequire("ln3Kf");
var $a514249fcd2b110a$require$Buffer = $ln3Kf.Buffer;

var $gNAKV = parcelRequire("gNAKV");

var $4N0ZQ = parcelRequire("4N0ZQ");
var $a514249fcd2b110a$require$addAbortSignal = $4N0ZQ.addAbortSignal;

var $cSqYz = parcelRequire("cSqYz");
var $a514249fcd2b110a$var$getHighWaterMark = $cSqYz.getHighWaterMark, $a514249fcd2b110a$var$getDefaultHighWaterMark = $cSqYz.getDefaultHighWaterMark;

var $bGcyc = parcelRequire("bGcyc");
var $a514249fcd2b110a$require$_require_codes = $bGcyc.codes;
var $a514249fcd2b110a$var$ERR_INVALID_ARG_TYPE = $a514249fcd2b110a$require$_require_codes.ERR_INVALID_ARG_TYPE, $a514249fcd2b110a$var$ERR_METHOD_NOT_IMPLEMENTED = $a514249fcd2b110a$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a514249fcd2b110a$var$ERR_MULTIPLE_CALLBACK = $a514249fcd2b110a$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a514249fcd2b110a$var$ERR_STREAM_CANNOT_PIPE = $a514249fcd2b110a$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a514249fcd2b110a$var$ERR_STREAM_DESTROYED = $a514249fcd2b110a$require$_require_codes.ERR_STREAM_DESTROYED, $a514249fcd2b110a$var$ERR_STREAM_ALREADY_FINISHED = $a514249fcd2b110a$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a514249fcd2b110a$var$ERR_STREAM_NULL_VALUES = $a514249fcd2b110a$require$_require_codes.ERR_STREAM_NULL_VALUES, $a514249fcd2b110a$var$ERR_STREAM_WRITE_AFTER_END = $a514249fcd2b110a$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a514249fcd2b110a$var$ERR_UNKNOWN_ENCODING = $a514249fcd2b110a$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a514249fcd2b110a$var$errorOrDestroy = $gNAKV.errorOrDestroy;
$a514249fcd2b110a$var$ObjectSetPrototypeOf($a514249fcd2b110a$var$Writable.prototype, $a514249fcd2b110a$require$Stream.prototype);
$a514249fcd2b110a$var$ObjectSetPrototypeOf($a514249fcd2b110a$var$Writable, $a514249fcd2b110a$require$Stream);
function $a514249fcd2b110a$var$nop() {}
var $a514249fcd2b110a$var$kOnFinished = $a514249fcd2b110a$var$Symbol('kOnFinished');

function $a514249fcd2b110a$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hAfPa"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a514249fcd2b110a$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a514249fcd2b110a$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a514249fcd2b110a$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a514249fcd2b110a$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a514249fcd2b110a$var$kOnFinished] = [];
}
function $a514249fcd2b110a$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a514249fcd2b110a$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a514249fcd2b110a$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a514249fcd2b110a$var$ObjectDefineProperty($a514249fcd2b110a$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a514249fcd2b110a$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("hAfPa"));
    if (!isDuplex && !$a514249fcd2b110a$var$FunctionPrototypeSymbolHasInstance($a514249fcd2b110a$var$Writable, this)) return new $a514249fcd2b110a$var$Writable(options);
    this._writableState = new $a514249fcd2b110a$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a514249fcd2b110a$require$addAbortSignal(options.signal, this);
    }
    $a514249fcd2b110a$require$Stream.call(this, options);
    $gNAKV.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a514249fcd2b110a$var$clearBuffer(_this, state);
        $a514249fcd2b110a$var$finishMaybe(_this, state);
    });
}
$a514249fcd2b110a$var$ObjectDefineProperty($a514249fcd2b110a$var$Writable, $a514249fcd2b110a$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a514249fcd2b110a$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a514249fcd2b110a$var$Writable) return false;
        return object && object._writableState instanceof $a514249fcd2b110a$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a514249fcd2b110a$var$Writable.prototype.pipe = function() {
    $a514249fcd2b110a$var$errorOrDestroy(this, new $a514249fcd2b110a$var$ERR_STREAM_CANNOT_PIPE());
};
function $a514249fcd2b110a$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a514249fcd2b110a$require$Buffer.isEncoding(encoding)) throw new $a514249fcd2b110a$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a514249fcd2b110a$var$nop;
    }
    if (chunk === null) throw new $a514249fcd2b110a$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a514249fcd2b110a$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a514249fcd2b110a$require$Buffer) encoding = 'buffer';
        else if ($a514249fcd2b110a$require$Stream._isUint8Array(chunk)) {
            chunk = $a514249fcd2b110a$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a514249fcd2b110a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a514249fcd2b110a$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a514249fcd2b110a$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a514249fcd2b110a$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a514249fcd2b110a$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a514249fcd2b110a$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a514249fcd2b110a$var$_write(this, chunk, encoding, cb) === true;
};
$a514249fcd2b110a$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a514249fcd2b110a$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a514249fcd2b110a$var$clearBuffer(this, state);
    }
};
$a514249fcd2b110a$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a514249fcd2b110a$var$StringPrototypeToLowerCase(encoding);
    if (!$a514249fcd2b110a$require$Buffer.isEncoding(encoding)) throw new $a514249fcd2b110a$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a514249fcd2b110a$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a514249fcd2b110a$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a514249fcd2b110a$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a514249fcd2b110a$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a514249fcd2b110a$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a514249fcd2b110a$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a514249fcd2b110a$var$errorOrDestroy(stream, er);
}
function $a514249fcd2b110a$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a514249fcd2b110a$var$errorOrDestroy(stream, new $a514249fcd2b110a$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a514249fcd2b110a$var$onwriteError, stream, state, er, cb);
        else $a514249fcd2b110a$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a514249fcd2b110a$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a514249fcd2b110a$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a514249fcd2b110a$var$afterWrite(stream, state, 1, cb);
    }
}
function $a514249fcd2b110a$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a514249fcd2b110a$var$afterWrite(stream, state, count, cb);
}
function $a514249fcd2b110a$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a514249fcd2b110a$var$errorBuffer(state);
    $a514249fcd2b110a$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a514249fcd2b110a$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a514249fcd2b110a$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a514249fcd2b110a$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a514249fcd2b110a$var$ERR_STREAM_DESTROYED('end'));
    }
    $a514249fcd2b110a$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a514249fcd2b110a$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a514249fcd2b110a$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a514249fcd2b110a$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a514249fcd2b110a$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a514249fcd2b110a$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a514249fcd2b110a$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a514249fcd2b110a$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a514249fcd2b110a$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a514249fcd2b110a$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a514249fcd2b110a$var$Writable.prototype._writev = null;
$a514249fcd2b110a$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a514249fcd2b110a$var$_write(this, chunk, encoding);
        if (ret instanceof $a514249fcd2b110a$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a514249fcd2b110a$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a514249fcd2b110a$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a514249fcd2b110a$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a514249fcd2b110a$var$kOnFinished].push(cb);
    }
    return this;
};
function $a514249fcd2b110a$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a514249fcd2b110a$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a514249fcd2b110a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a514249fcd2b110a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a514249fcd2b110a$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a514249fcd2b110a$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a514249fcd2b110a$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a514249fcd2b110a$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a514249fcd2b110a$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a514249fcd2b110a$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a514249fcd2b110a$var$finishMaybe(stream, state, sync) {
    if ($a514249fcd2b110a$var$needFinish(state)) {
        $a514249fcd2b110a$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a514249fcd2b110a$var$needFinish(state)) $a514249fcd2b110a$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a514249fcd2b110a$var$needFinish(state)) {
                state.pendingcb++;
                $a514249fcd2b110a$var$finish(stream, state);
            }
        }
    }
}
function $a514249fcd2b110a$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a514249fcd2b110a$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a514249fcd2b110a$var$ObjectDefineProperties($a514249fcd2b110a$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a514249fcd2b110a$var$destroy = $gNAKV.destroy;
$a514249fcd2b110a$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a514249fcd2b110a$var$kOnFinished].length)) $2Qkr5.nextTick($a514249fcd2b110a$var$errorBuffer, state);
    $a514249fcd2b110a$var$destroy.call(this, err, cb);
    return this;
};
$a514249fcd2b110a$var$Writable.prototype._undestroy = $gNAKV.undestroy;
$a514249fcd2b110a$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a514249fcd2b110a$var$Writable.prototype[$a514249fcd2b110a$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a514249fcd2b110a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a514249fcd2b110a$var$lazyWebStreams() {
    if ($a514249fcd2b110a$var$webStreamsAdapters === undefined) $a514249fcd2b110a$var$webStreamsAdapters = {};
    return $a514249fcd2b110a$var$webStreamsAdapters;
}
$a514249fcd2b110a$var$Writable.fromWeb = function(writableStream, options) {
    return $a514249fcd2b110a$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a514249fcd2b110a$var$Writable.toWeb = function(streamWritable) {
    return $a514249fcd2b110a$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("54KC9", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $ln3Kf = parcelRequire("ln3Kf");

var $dolix = parcelRequire("dolix");
var $3b217c18812a804a$var$isReadable = $dolix.isReadable, $3b217c18812a804a$var$isWritable = $dolix.isWritable, $3b217c18812a804a$var$isIterable = $dolix.isIterable, $3b217c18812a804a$var$isNodeStream = $dolix.isNodeStream, $3b217c18812a804a$var$isReadableNodeStream = $dolix.isReadableNodeStream, $3b217c18812a804a$var$isWritableNodeStream = $dolix.isWritableNodeStream, $3b217c18812a804a$var$isDuplexNodeStream = $dolix.isDuplexNodeStream, $3b217c18812a804a$var$isReadableStream = $dolix.isReadableStream, $3b217c18812a804a$var$isWritableStream = $dolix.isWritableStream;

var $edHDL = parcelRequire("edHDL");

var $bGcyc = parcelRequire("bGcyc");
var $3b217c18812a804a$var$AbortError = $bGcyc.AbortError, $3b217c18812a804a$var$_require_codes = $bGcyc.codes, $3b217c18812a804a$var$ERR_INVALID_ARG_TYPE = $3b217c18812a804a$var$_require_codes.ERR_INVALID_ARG_TYPE, $3b217c18812a804a$var$ERR_INVALID_RETURN_VALUE = $3b217c18812a804a$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $gNAKV = parcelRequire("gNAKV");
var $3b217c18812a804a$require$destroyer = $gNAKV.destroyer;

var $hAfPa = parcelRequire("hAfPa");

var $8DqnA = parcelRequire("8DqnA");

var $eaI15 = parcelRequire("eaI15");

var $dGIAp = parcelRequire("dGIAp");
var $3b217c18812a804a$require$createDeferredPromise = $dGIAp.createDeferredPromise;

var $3vUY6 = parcelRequire("3vUY6");
var $3b217c18812a804a$var$Blob = globalThis.Blob || $ln3Kf.Blob;
var $3b217c18812a804a$var$isBlob = typeof $3b217c18812a804a$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $3b217c18812a804a$var$Blob;
} : function isBlob(b) {
    return false;
};

var $3b217c18812a804a$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $5846a = parcelRequire("5846a");
var $3b217c18812a804a$require$FunctionPrototypeCall = $5846a.FunctionPrototypeCall;
// This is needed for pre node 17.
var $3b217c18812a804a$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($hAfPa);
module.exports = function duplexify(body, name) {
    if ($3b217c18812a804a$var$isDuplexNodeStream(body)) return body;
    if ($3b217c18812a804a$var$isReadableNodeStream(body)) return $3b217c18812a804a$var$_duplexify({
        readable: body
    });
    if ($3b217c18812a804a$var$isWritableNodeStream(body)) return $3b217c18812a804a$var$_duplexify({
        writable: body
    });
    if ($3b217c18812a804a$var$isNodeStream(body)) return $3b217c18812a804a$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($3b217c18812a804a$var$isReadableStream(body)) return $3b217c18812a804a$var$_duplexify({
        readable: $8DqnA.fromWeb(body)
    });
    if ($3b217c18812a804a$var$isWritableStream(body)) return $3b217c18812a804a$var$_duplexify({
        writable: $eaI15.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $3b217c18812a804a$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($3b217c18812a804a$var$isIterable(value)) return $3vUY6($3b217c18812a804a$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $3b217c18812a804a$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $3b217c18812a804a$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $3b217c18812a804a$require$destroyer(d, err);
            });
            return d = new $3b217c18812a804a$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $3b217c18812a804a$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($3b217c18812a804a$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($3b217c18812a804a$var$isIterable(body)) return $3vUY6($3b217c18812a804a$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($3b217c18812a804a$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $3b217c18812a804a$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $3b217c18812a804a$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $3b217c18812a804a$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $3b217c18812a804a$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $3b217c18812a804a$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $3b217c18812a804a$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $3b217c18812a804a$require$destroyer(d1, err);
        });
        return d1 = new $3b217c18812a804a$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $3b217c18812a804a$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $3b217c18812a804a$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $3b217c18812a804a$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $3b217c18812a804a$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $3b217c18812a804a$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $3b217c18812a804a$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $3b217c18812a804a$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $8DqnA.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$3b217c18812a804a$var$isReadable(r);
    var writable = !!$3b217c18812a804a$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $3b217c18812a804a$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $edHDL(w, function(err) {
            writable = false;
            if (err) $3b217c18812a804a$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $edHDL(r, function(err) {
            readable = false;
            if (err) $3b217c18812a804a$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $3b217c18812a804a$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $3b217c18812a804a$require$destroyer(w, err);
            $3b217c18812a804a$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2vlFN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $5846a = parcelRequire("5846a");
var $1d2f49d8e175ec29$require$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf;
module.exports = $1d2f49d8e175ec29$var$PassThrough;

var $bl49w = parcelRequire("bl49w");
$1d2f49d8e175ec29$require$ObjectSetPrototypeOf($1d2f49d8e175ec29$var$PassThrough.prototype, $bl49w.prototype);
$1d2f49d8e175ec29$require$ObjectSetPrototypeOf($1d2f49d8e175ec29$var$PassThrough, $bl49w);
function $1d2f49d8e175ec29$var$PassThrough(options) {
    if (!(this instanceof $1d2f49d8e175ec29$var$PassThrough)) return new $1d2f49d8e175ec29$var$PassThrough(options);
    $bl49w.call(this, options);
}
$1d2f49d8e175ec29$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("bl49w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $5846a = parcelRequire("5846a");
var $8414e07f2a8024d2$var$ObjectSetPrototypeOf = $5846a.ObjectSetPrototypeOf, $8414e07f2a8024d2$var$Symbol = $5846a.Symbol;
module.exports = $8414e07f2a8024d2$var$Transform;

var $8414e07f2a8024d2$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("bGcyc")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $hAfPa = parcelRequire("hAfPa");

var $cSqYz = parcelRequire("cSqYz");
var $8414e07f2a8024d2$require$getHighWaterMark = $cSqYz.getHighWaterMark;
$8414e07f2a8024d2$var$ObjectSetPrototypeOf($8414e07f2a8024d2$var$Transform.prototype, $hAfPa.prototype);
$8414e07f2a8024d2$var$ObjectSetPrototypeOf($8414e07f2a8024d2$var$Transform, $hAfPa);
var $8414e07f2a8024d2$var$kCallback = $8414e07f2a8024d2$var$Symbol('kCallback');
function $8414e07f2a8024d2$var$Transform(options) {
    if (!(this instanceof $8414e07f2a8024d2$var$Transform)) return new $8414e07f2a8024d2$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $8414e07f2a8024d2$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $hAfPa.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8414e07f2a8024d2$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8414e07f2a8024d2$var$prefinish);
}
function $8414e07f2a8024d2$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8414e07f2a8024d2$var$prefinish() {
    if (this._final !== $8414e07f2a8024d2$var$_final) $8414e07f2a8024d2$var$_final.call(this);
}
$8414e07f2a8024d2$var$Transform.prototype._final = $8414e07f2a8024d2$var$_final;
$8414e07f2a8024d2$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8414e07f2a8024d2$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8414e07f2a8024d2$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$8414e07f2a8024d2$var$kCallback] = callback;
    });
};
$8414e07f2a8024d2$var$Transform.prototype._read = function() {
    if (this[$8414e07f2a8024d2$var$kCallback]) {
        var callback = this[$8414e07f2a8024d2$var$kCallback];
        this[$8414e07f2a8024d2$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("eZJqN", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $5846a = parcelRequire("5846a");
var $aeaa00de62fe9b48$var$ArrayPrototypePop = $5846a.ArrayPrototypePop, $aeaa00de62fe9b48$var$Promise = $5846a.Promise;

var $dolix = parcelRequire("dolix");
var $aeaa00de62fe9b48$var$isIterable = $dolix.isIterable, $aeaa00de62fe9b48$var$isNodeStream = $dolix.isNodeStream, $aeaa00de62fe9b48$var$isWebStream = $dolix.isWebStream;

var $gjVuq = parcelRequire("gjVuq");
var $aeaa00de62fe9b48$var$pl = $gjVuq.pipelineImpl;

var $edHDL = parcelRequire("edHDL");
var $aeaa00de62fe9b48$require$finished = $edHDL.finished;
parcelRequire("6LDFM");
function $aeaa00de62fe9b48$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $aeaa00de62fe9b48$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$aeaa00de62fe9b48$var$isNodeStream(lastArg) && !$aeaa00de62fe9b48$var$isIterable(lastArg) && !$aeaa00de62fe9b48$var$isWebStream(lastArg)) {
            var options = $aeaa00de62fe9b48$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $aeaa00de62fe9b48$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $aeaa00de62fe9b48$require$finished,
    pipeline: $aeaa00de62fe9b48$var$pipeline
};

});





parcelRegister("2DXpo", function(module, exports) {
"use strict";
var $1ecd4e98c5e43736$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ecd4e98c5e43736$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1ecd4e98c5e43736$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1ecd4e98c5e43736$var$__exportStar((parcelRequire("jO28i")), module.exports);

});
parcelRegister("jO28i", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlMicrodata = void 0;

var $6JPXL = parcelRequire("6JPXL");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $9O6dB = parcelRequire("9O6dB");
/**
 * A comunica Microdata RDF Parse Html Actor.
 */ var $03b8960ddefdad43$var$ActorRdfParseHtmlMicrodata = /*#__PURE__*/ function(_bus_rdf_parse_html_1_ActorRdfParseHtml) {
    (0, $i3fW3._)(ActorRdfParseHtmlMicrodata, _bus_rdf_parse_html_1_ActorRdfParseHtml);
    function ActorRdfParseHtmlMicrodata(args) {
        (0, $jGAMp._)(this, ActorRdfParseHtmlMicrodata);
        return (0, $kzDuW._)(this, ActorRdfParseHtmlMicrodata, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseHtmlMicrodata, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, mediaType, xmlMode, htmlParseListener, onTagEndOld;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        mediaType = action.headers ? action.headers.get('content-type') : null;
                        xmlMode = mediaType === null || mediaType === void 0 ? void 0 : mediaType.includes('xml');
                        htmlParseListener = new $9O6dB.MicrodataRdfParser({
                            dataFactory: dataFactory,
                            baseIRI: action.baseIRI,
                            xmlMode: xmlMode
                        });
                        htmlParseListener.on('error', action.error);
                        htmlParseListener.on('data', action.emit);
                        // eslint-disable-next-line ts/unbound-method
                        onTagEndOld = htmlParseListener.onEnd;
                        htmlParseListener.onEnd = function() {
                            onTagEndOld.call(htmlParseListener);
                            action.end();
                        };
                        return [
                            2,
                            {
                                htmlParseListener: htmlParseListener
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseHtmlMicrodata;
}($6JPXL.ActorRdfParseHtml);
module.exports.ActorRdfParseHtmlMicrodata = $03b8960ddefdad43$var$ActorRdfParseHtmlMicrodata;

});
parcelRegister("6JPXL", function(module, exports) {
"use strict";
var $4e7f40cb5b54ec2a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e7f40cb5b54ec2a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4e7f40cb5b54ec2a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4e7f40cb5b54ec2a$var$__exportStar((parcelRequire("c9Z3I")), module.exports);

});
parcelRegister("c9Z3I", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtml = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-parse-html events.
 *
 * Actor types:
 * * Input:  IActionRdfParseHtml:      Callbacks for parsing results.
 * * Test:   <none>
 * * Output: IActorRdfParseHtmlOutput: An HTML event listeners.
 *
 * @see IActionRdfParseHtml
 * @see IActorRdfParseHtmlOutput
 */ var $8da5b053f33b6820$var$ActorRdfParseHtml = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfParseHtml, _core_1_Actor);
    function ActorRdfParseHtml(args) {
        (0, $jGAMp._)(this, ActorRdfParseHtml);
        return (0, $kzDuW._)(this, ActorRdfParseHtml, [
            args
        ]);
    }
    return ActorRdfParseHtml;
}($kNNoa.Actor);
module.exports.ActorRdfParseHtml = $8da5b053f33b6820$var$ActorRdfParseHtml;

});


parcelRegister("9O6dB", function(module, exports) {
"use strict";
var $723d9b6a47ecff38$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $723d9b6a47ecff38$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $723d9b6a47ecff38$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$723d9b6a47ecff38$var$__exportStar((parcelRequire("ii4lP")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("4GBms")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("1hSHU")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("9wRYl")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("eycdq")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("iLUbj")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("9rJTX")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("6jNeI")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("1M2zI")), module.exports);

$723d9b6a47ecff38$var$__exportStar((parcelRequire("kWU3H")), module.exports);

});
parcelRegister("ii4lP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4GBms", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerContent = void 0;
/**
 * Handler for an item property with the 'content' attribute.
 */ var $369810d4d1688b45$var$ItemPropertyHandlerContent = /*#__PURE__*/ function() {
    function ItemPropertyHandlerContent() {
        (0, $jGAMp._)(this, ItemPropertyHandlerContent);
    }
    (0, $byiyg._)(ItemPropertyHandlerContent, [
        {
            key: "canHandle",
            value: function canHandle(tagName, attributes) {
                return 'content' in attributes;
            }
        },
        {
            key: "getObject",
            value: function getObject(attributes, util, itemScope) {
                return util.createLiteral(attributes.content, itemScope);
            }
        }
    ]);
    return ItemPropertyHandlerContent;
}();
module.exports.ItemPropertyHandlerContent = $369810d4d1688b45$var$ItemPropertyHandlerContent;

});

parcelRegister("1hSHU", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerNumber = void 0;

var $kWU3H = parcelRequire("kWU3H");
/**
 * Handler for an item property with a number attribute.
 */ var $0f01d0b47045af7a$var$ItemPropertyHandlerNumber = /*#__PURE__*/ function() {
    function ItemPropertyHandlerNumber(tagName, attributeName) {
        (0, $jGAMp._)(this, ItemPropertyHandlerNumber);
        this.tagName = tagName;
        this.attributeName = attributeName;
    }
    (0, $byiyg._)(ItemPropertyHandlerNumber, [
        {
            key: "canHandle",
            value: function canHandle(tagName, attributes) {
                return this.tagName === tagName && this.attributeName in attributes;
            }
        },
        {
            key: "getObject",
            value: function getObject(attributes, util, itemScope) {
                var value = attributes[this.attributeName];
                var datatype;
                if (!Number.isNaN(Number.parseInt(value, 10)) && !value.includes('.')) datatype = "".concat($kWU3H.Util.XSD, "integer");
                else if (!Number.isNaN(Number.parseFloat(value))) datatype = "".concat($kWU3H.Util.XSD, "double");
                return util.dataFactory.literal(value, datatype && util.dataFactory.namedNode(datatype));
            }
        }
    ]);
    return ItemPropertyHandlerNumber;
}();
module.exports.ItemPropertyHandlerNumber = $0f01d0b47045af7a$var$ItemPropertyHandlerNumber;

});
parcelRegister("kWU3H", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $2ej16 = parcelRequire("2ej16");

var $hDpjF = parcelRequire("hDpjF");
/**
 * A collection of utility functions.
 */ var $f404b580b6f3d684$var$Util = /*#__PURE__*/ function() {
    function Util(dataFactory, baseIRI) {
        (0, $jGAMp._)(this, Util);
        this.dataFactory = dataFactory || new $2ej16.DataFactory();
        this.baseIRI = baseIRI || '';
    }
    (0, $byiyg._)(Util, [
        {
            /**
     * Create vocab terms for the given terms attribute.
     *
     * Relative IRIs will be based on the active vocab or baseIRI if `allowRelativeIris` is true.
     *
     * @param {string} terms An attribute value.
     * @param {IItemScope} itemScope The active item scope.
     * @param {boolean} allowRelativeIris If relative IRIs are allowed.
     * @return {Term[]} The IRI terms.
     */ key: "createVocabIris",
            value: function createVocabIris(terms, itemScope, allowRelativeIris) {
                var _this = this;
                return terms.split(RegExp("\\s+", "u")).filter(function(term) {
                    return !!term;
                }).map(function(property) {
                    if (!Util.isValidIri(property)) {
                        if (!allowRelativeIris) return;
                        property = "".concat(itemScope.vocab || "".concat(_this.baseIRI, "#")).concat(property);
                    }
                    return _this.dataFactory.namedNode(property);
                }).filter(function(term) {
                    return !!term;
                });
            }
        },
        {
            /**
     * Get the predicates for which the given itemprop value should cause vocabulary expansion.
     * @param terms An attribute value.
     * @param itemScope The active item scope.
     * @param vocabRegistry The active vocabulary registry.
     */ key: "getVocabularyExpansionType",
            value: function getVocabularyExpansionType(terms, itemScope, vocabRegistry) {
                var _this = this;
                // Check the presence of subPropertyOf or equivalentProperty
                var parts = terms.split(RegExp("\\s+", "u"));
                if (parts.includes('subPropertyOf') || parts.includes('equivalentProperty')) return [
                    this.dataFactory.namedNode("".concat(Util.RDF, "type"))
                ];
                // Check in the item scope's vocab
                if (itemScope.vocab && itemScope.vocab in vocabRegistry && vocabRegistry[itemScope.vocab].properties) {
                    var predicates = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(vocabRegistry[itemScope.vocab].properties)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $32TW8._)(_step.value, 2), property = _step_value[0], expansions = _step_value[1];
                            if (parts.includes(property)) predicates = (0, $7WNf6._)(Object.values(expansions).map(function(iri) {
                                return _this.dataFactory.namedNode(iri);
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return predicates;
                }
                return [];
            }
        },
        {
            /**
     * Create a named node for the given term, which can be relative to the document base.
     * @param {string} iri A term string.
     * @return {Term} An RDF term, or undefined if invalid.
     */ key: "createSubject",
            value: function createSubject(iri) {
                if (!Util.isValidIri(iri)) try {
                    iri = (0, $hDpjF.resolve)(iri, this.baseIRI);
                } catch (_a) {
                    return;
                }
                return this.dataFactory.namedNode(iri);
            }
        },
        {
            /**
     * Create a new literal node.
     * @param {string} literal The literal value.
     * @param {IActiveTag} activeTag The current active tag.
     * @return {Literal} A new literal node.
     */ key: "createLiteral",
            value: function createLiteral(literal, activeTag) {
                return this.dataFactory.literal(literal, activeTag.language);
            }
        },
        {
            /**
     * Determine the vocab IRI from a given type IRI.
     * @link https://w3c.github.io/microdata-rdf/#property-uri-generation
     * @param typeIri A type IRI.
     * @param vocabRegistry The active vocabulary registry.
     */ key: "deriveVocab",
            value: function deriveVocab(typeIri, vocabRegistry) {
                var vocab;
                // First check if we find a prefix in the vocab registry
                for(var uriPrefix in vocabRegistry)if (typeIri.startsWith(uriPrefix)) {
                    vocab = uriPrefix;
                    // Append fragment if prefix does not end with a slash
                    if (!vocab.endsWith('/')) vocab += '#';
                    break;
                }
                // If no match was found, remove the last path segment from the URI
                if (!vocab) {
                    var hashPos = typeIri.indexOf('#');
                    if (hashPos > 0) vocab = typeIri.slice(0, hashPos + 1);
                    else vocab = (0, $hDpjF.resolve)('.', typeIri);
                }
                return vocab;
            }
        }
    ], [
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Util.IRI_REGEX.test(iri);
            }
        }
    ]);
    return Util;
}();
module.exports.Util = $f404b580b6f3d684$var$Util;
$f404b580b6f3d684$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$f404b580b6f3d684$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$f404b580b6f3d684$var$Util.RDFA = 'http://www.w3.org/ns/rdfa#';
$f404b580b6f3d684$var$Util.IRI_REGEX = RegExp('^([A-Za-z][\\d+-.A-Za-z]*|_):[^ "<>[\\\\\\]`{|}]*$', "u");

});


parcelRegister("9wRYl", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerTime = void 0;

var $kWU3H = parcelRequire("kWU3H");
/**
 * Handler for an item property for time tags.
 */ var $6f00f7fafdb82c2b$var$ItemPropertyHandlerTime = /*#__PURE__*/ function() {
    function ItemPropertyHandlerTime() {
        (0, $jGAMp._)(this, ItemPropertyHandlerTime);
    }
    (0, $byiyg._)(ItemPropertyHandlerTime, [
        {
            key: "canHandle",
            value: function canHandle(tagName, attributes) {
                return tagName === 'time' && 'datetime' in attributes;
            }
        },
        {
            key: "getObject",
            value: function getObject(attributes, util, itemScope) {
                var value = attributes.datetime;
                var datatype;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ItemPropertyHandlerTime.TIME_REGEXES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (entry.regex.test(value)) {
                            datatype = util.dataFactory.namedNode($kWU3H.Util.XSD + entry.type);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return util.dataFactory.literal(value, datatype);
            }
        }
    ]);
    return ItemPropertyHandlerTime;
}();
module.exports.ItemPropertyHandlerTime = $6f00f7fafdb82c2b$var$ItemPropertyHandlerTime;
$6f00f7fafdb82c2b$var$ItemPropertyHandlerTime.TIME_REGEXES = [
    {
        regex: RegExp("^-?P(\\d+Y)?(\\d+M)?(\\d+D)?(T(\\d+H)?(\\d+M)?(\\d+(\\.\\d)?S)?)?$", "u"),
        type: 'duration'
    },
    {
        regex: RegExp("^\\d+-\\d\\d-\\d\\dT\\d\\d:\\d\\d:\\d\\d((Z?)|([+-]\\d\\d:\\d\\d))$", "u"),
        type: 'dateTime'
    },
    {
        regex: RegExp("^\\d+-\\d\\d-\\d\\dZ?$", "u"),
        type: 'date'
    },
    {
        regex: RegExp("^\\d\\d:\\d\\d:\\d\\d((Z?)|([+-]\\d\\d:\\d\\d))$", "u"),
        type: 'time'
    },
    {
        regex: RegExp("^\\d+-\\d\\d$", "u"),
        type: 'gYearMonth'
    },
    {
        regex: RegExp("^\\d+$", "u"),
        type: 'gYear'
    }
];

});

parcelRegister("eycdq", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerUrl = void 0;

var $hDpjF = parcelRequire("hDpjF");
/**
 * Handler for an item property with a URL attribute.
 */ var $a97db764612814f0$var$ItemPropertyHandlerUrl = /*#__PURE__*/ function() {
    function ItemPropertyHandlerUrl(tagName, attributeName) {
        (0, $jGAMp._)(this, ItemPropertyHandlerUrl);
        this.tagName = tagName;
        this.attributeName = attributeName;
    }
    (0, $byiyg._)(ItemPropertyHandlerUrl, [
        {
            key: "canHandle",
            value: function canHandle(tagName, attributes) {
                return this.tagName === tagName && this.attributeName in attributes;
            }
        },
        {
            key: "getObject",
            value: function getObject(attributes, util, itemScope) {
                return util.dataFactory.namedNode((0, $hDpjF.resolve)(attributes[this.attributeName], util.baseIRI));
            }
        }
    ]);
    return ItemPropertyHandlerUrl;
}();
module.exports.ItemPropertyHandlerUrl = $a97db764612814f0$var$ItemPropertyHandlerUrl;

});

parcelRegister("iLUbj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9rJTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6jNeI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1M2zI", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicrodataRdfParser = void 0;
parcelRequire("3DFcJ");
var $X2jrl = parcelRequire("X2jrl");

var $bpBa6 = parcelRequire("bpBa6");

var $4GBms = parcelRequire("4GBms");

var $1hSHU = parcelRequire("1hSHU");

var $9wRYl = parcelRequire("9wRYl");

var $eycdq = parcelRequire("eycdq");

var $kWU3H = parcelRequire("kWU3H");

var $dDvbT = parcelRequire("dDvbT");
/**
 * A stream transformer that parses Microdata (text) streams to an {@link RDF.Stream}.
 */ var $14ac457def5b2aea$var$MicrodataRdfParser = /*#__PURE__*/ function(_readable_stream_1_Transform) {
    (0, $i3fW3._)(MicrodataRdfParser, _readable_stream_1_Transform);
    function MicrodataRdfParser(options) {
        (0, $jGAMp._)(this, MicrodataRdfParser);
        var _this;
        _this = (0, $kzDuW._)(this, MicrodataRdfParser, [
            {
                readableObjectMode: true
            }
        ]);
        // Stacks, where the key is the current depth.
        _this.itemScopeStack = [];
        _this.textBufferStack = [];
        // Variables for managing itemrefs.
        _this.isEmittingReferences = false;
        _this.pendingItemRefsDomain = {};
        _this.pendingItemRefsRangeFinalized = {};
        // eslint-disable-next-line lines-between-class-members
        _this.pendingItemRefsRangeCollecting = {};
        options = options || {};
        _this.options = options;
        _this.util = new $kWU3H.Util(options.dataFactory, options.baseIRI);
        _this.defaultGraph = options.defaultGraph || _this.util.dataFactory.defaultGraph();
        _this.htmlParseListener = options.htmlParseListener;
        _this.vocabRegistry = options.vocabRegistry || $dDvbT;
        _this.parser = _this.initializeParser(!!options.xmlMode);
        return _this;
    }
    (0, $byiyg._)(MicrodataRdfParser, [
        {
            /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ key: "import",
            value: function _import(stream) {
                var output = new $bpBa6.PassThrough({
                    readableObjectMode: true
                });
                stream.on('error', function(error) {
                    return parsed.emit('error', error);
                });
                stream.on('data', function(data) {
                    return output.push(data);
                });
                stream.on('end', function() {
                    return output.push(null);
                });
                var parsed = output.pipe(new MicrodataRdfParser(this.options));
                return parsed;
            }
        },
        {
            key: "_transform",
            value: function _transform(chunk, encoding, callback) {
                this.parser.write(chunk.toString());
                callback();
            }
        },
        {
            key: "_flush",
            value: function _flush(callback) {
                this.parser.end();
                callback();
            }
        },
        {
            /**
     * Get the current item scope for the current depth.
     * This will skip all undefined item scopes.
     * @param parent If we should start looking one level higher in the stack.
     */ key: "getItemScope",
            value: function getItemScope(parent) {
                var parentTagI = this.itemScopeStack.length - (parent ? 2 : 1);
                while(parentTagI > 0 && !this.itemScopeStack[parentTagI])parentTagI--;
                return this.itemScopeStack[parentTagI];
            }
        },
        {
            /**
     * Get the current stack depth.
     */ key: "getDepth",
            value: function getDepth() {
                return this.itemScopeStack.length;
            }
        },
        {
            key: "onTagOpen",
            value: function onTagOpen(name, attributes) {
                if (!this.isEmittingReferences) {
                    // If the tag has an 'id', start collecting the whole stack in the item reference buffer
                    if ('id' in attributes) {
                        var id = attributes.id;
                        this.pendingItemRefsRangeCollecting[id] = {
                            events: [],
                            counter: 0,
                            ids: []
                        };
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Store this event in all collecting item reference buffers
                        for(var _iterator = Object.values(this.pendingItemRefsRangeCollecting)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var buffer = _step.value;
                            buffer.counter++;
                            buffer.events.push({
                                type: 'open',
                                name: name,
                                attributes: attributes
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // Ensure the text buffer stack is in line with the stack depth
                this.textBufferStack.push(undefined);
                // Processing steps based on https://w3c.github.io/microdata-rdf/#rdf-conversion-algorithm
                // 1. Determine the current item scope
                var itemScope;
                if ('itemscope' in attributes) {
                    // Create a new item scope
                    var subject;
                    if (this.emittingReferencesItemScopeIdGenerator) subject = this.emittingReferencesItemScopeIdGenerator();
                    else {
                        subject = 'itemid' in attributes && this.util.createSubject(attributes.itemid) || this.util.dataFactory.blankNode();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            // Store the genererated id in all collecting item reference buffers
                            for(var _iterator1 = Object.values(this.pendingItemRefsRangeCollecting)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var buffer1 = _step1.value;
                                buffer1.ids.push(subject);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                    itemScope = {
                        subject: subject
                    };
                    // If the id was reused from a reference, block any new triples to be generated from it
                    if (this.isEmittingReferences) itemScope.blockEmission = true;
                    // Inherit vocab from parent item scope
                    var parentItemScope = this.getItemScope();
                    if (parentItemScope && parentItemScope.vocab) itemScope.vocab = parentItemScope.vocab;
                    // 2. Push any changes to the item scope to the stack
                    this.itemScopeStack.push(itemScope);
                } else {
                    // Determine the parent item scope
                    itemScope = this.getItemScope();
                    // 2. Push any changes to the item scope to the stack
                    this.itemScopeStack.push(undefined);
                }
                // If we have a valid item scope, process the current node
                if (itemScope) {
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    // 3. Handle item types
                    if ('itemtype' in attributes) try {
                        for(var _iterator2 = this.util.createVocabIris(attributes.itemtype, itemScope, false)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var type = _step2.value;
                            // 4. Vocab identifier is the first valid item
                            if (!itemScope.vocab) // 5. Modify vocab based on registry
                            itemScope.vocab = this.util.deriveVocab(type.value, this.vocabRegistry);
                            // Emit item type
                            if (!itemScope.blockEmission) this.emitTriple(itemScope.subject, this.util.dataFactory.namedNode("".concat($kWU3H.Util.RDF, "type")), type);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                _iterator2["return"]();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    // Save language in item scope
                    if ('lang' in attributes) itemScope.language = attributes.lang;
                    if ('xml:lang' in attributes) itemScope.language = attributes['xml:lang'];
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    // Handle itemrefs (only if we also had an itemscope)
                    // If we have an itemref, store it in our domain buffer.
                    if ('itemscope' in attributes && !this.isEmittingReferences && 'itemref' in attributes) try {
                        for(var _iterator3 = attributes.itemref.split(RegExp("\\s+", "u"))[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var reference = _step3.value;
                            if (!(reference in this.pendingItemRefsDomain)) this.pendingItemRefsDomain[reference] = [];
                            this.pendingItemRefsDomain[reference].push(itemScope);
                            this.tryToEmitReferences(reference, itemScope);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                _iterator3["return"]();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
                // 6. Handle item properties
                if ('itemprop' in attributes) this.handleItemProperties(attributes.itemprop, false, itemScope, name, attributes);
                // Handle reverse item properties
                // https://w3c.github.io/microdata-rdf/#reverse-itemprop
                if ('itemprop-reverse' in attributes) this.handleItemProperties(attributes['itemprop-reverse'], true, itemScope, name, attributes);
            }
        },
        {
            key: "onText",
            value: function onText(data) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // Store this event in all collecting item reference buffers
                if (!this.isEmittingReferences) try {
                    for(var _iterator = Object.values(this.pendingItemRefsRangeCollecting)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var buffer = _step.value;
                        buffer.events.push({
                            type: 'text',
                            data: data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Save the text inside all item scopes that need to collect text
                    for(var _iterator1 = this.textBufferStack[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var textBuffer = _step1.value;
                        if (textBuffer) textBuffer.push(data);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "onTagClose",
            value: function onTagClose() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // Store this event in all collecting item reference buffers
                if (!this.isEmittingReferences) try {
                    for(var _iterator = Object.entries(this.pendingItemRefsRangeCollecting)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), reference = _step_value[0], buffer = _step_value[1];
                        buffer.counter--;
                        buffer.events.push({
                            type: 'close'
                        });
                        // Once the counter becomes zero, the tag is fully buffered, so we finalize it.
                        if (buffer.counter === 0) {
                            this.pendingItemRefsRangeFinalized[reference] = buffer;
                            delete this.pendingItemRefsRangeCollecting[reference];
                            // Try to emit this reference with buffered domain items
                            this.tryToEmitReferences(reference);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Emit all triples that were determined in the active tag
                var itemScope = this.getItemScope(true);
                if (itemScope) {
                    var depth = this.getDepth();
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (itemScope.predicates && depth in itemScope.predicates) try {
                        for(var _iterator1 = Object.entries(itemScope.predicates[depth])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value1 = (0, $32TW8._)(_step1.value, 2), predicateKey = _step_value1[0], predicates = _step_value1[1];
                            // First check if we have a child item scope, otherwise get the text content
                            // Safely cast textBufferStack, as it is always defined when itemScope.predicates is defined.
                            var object = this.util.createLiteral(this.textBufferStack[depth].join(''), itemScope);
                            this.emitPredicateTriples(itemScope, predicates, object, predicateKey === 'reverse');
                            delete itemScope.predicates[depth][predicateKey];
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                // Remove the active tag from the stack
                this.itemScopeStack.pop();
                this.textBufferStack.pop();
            }
        },
        {
            key: "onEnd",
            value: function onEnd() {
            // Nothing important should happen here.
            }
        },
        {
            /**
     * Initialize a new HtmlParser.
     * @param xmlMode If the parser should be setup in strict mode.
     */ key: "initializeParser",
            value: function initializeParser(xmlMode) {
                var _this = this;
                return new $X2jrl.Parser({
                    onclosetag: function() {
                        try {
                            _this.onTagClose();
                            if (_this.htmlParseListener) _this.htmlParseListener.onTagClose();
                        } catch (error) {
                            _this.emit('error', error);
                        }
                    },
                    onend: function() {
                        try {
                            _this.onEnd();
                            if (_this.htmlParseListener) _this.htmlParseListener.onEnd();
                        } catch (error) {
                            _this.emit('error', error);
                        }
                    },
                    onopentag: function(name, attributes) {
                        try {
                            _this.onTagOpen(name, attributes);
                            if (_this.htmlParseListener) _this.htmlParseListener.onTagOpen(name, attributes);
                        } catch (error) {
                            _this.emit('error', error);
                        }
                    },
                    ontext: function(data) {
                        try {
                            _this.onText(data);
                            if (_this.htmlParseListener) _this.htmlParseListener.onText(data);
                        } catch (error) {
                            _this.emit('error', error);
                        }
                    }
                }, {
                    decodeEntities: true,
                    recognizeSelfClosing: true,
                    xmlMode: xmlMode
                });
            }
        },
        {
            /**
     * Handle the given item properties.
     * @param itempropValue The value of itemprop or itemprop-reverse.
     * @param reverse If the item properties are reversed (itemprop-reverse).
     * @param itemScope The current item scope.
     * @param tagName The current tag name.
     * @param tagAttributes The current tag attributes.
     */ key: "handleItemProperties",
            value: function handleItemProperties(itempropValue, reverse, itemScope, tagName, tagAttributes) {
                var parentItemScope = this.getItemScope(true);
                if (parentItemScope) {
                    // Set predicates in the scope, and handle them on tag close.
                    var depth = this.getDepth();
                    var predicates = this.util.createVocabIris(itempropValue, parentItemScope, true);
                    if (!parentItemScope.predicates) parentItemScope.predicates = {};
                    if (!parentItemScope.predicates[depth]) parentItemScope.predicates[depth] = {};
                    var predicatesKey = reverse ? 'reverse' : 'forward';
                    parentItemScope.predicates[depth][predicatesKey] = predicates;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Append rdf:type predicate if vocabulary expansion applies
                        for(var _iterator = this.util.getVocabularyExpansionType(itempropValue, parentItemScope, this.vocabRegistry)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var vocabularyExpansionType = _step.value;
                            predicates.push(vocabularyExpansionType);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Check if a property handler that applies, forcefully use that as predicate value.
                    // But DON'T call handlers in this prop is a direct (nested) itemscope.
                    if (itemScope && 'itemscope' in tagAttributes) {
                        this.emitPredicateTriples(parentItemScope, predicates, itemScope.subject, reverse);
                        // Finalize the predicates, so text values do not apply to them.
                        delete parentItemScope.predicates[depth][predicatesKey];
                    } else {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = MicrodataRdfParser.ITEM_PROPERTY_HANDLERS[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var handler = _step1.value;
                                if (handler.canHandle(tagName, tagAttributes)) {
                                    var object = handler.getObject(tagAttributes, this.util, parentItemScope);
                                    this.emitPredicateTriples(parentItemScope, predicates, object, reverse);
                                    // Finalize the predicates, so text values do not apply to them.
                                    delete parentItemScope.predicates[depth][predicatesKey];
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                    // If no valid handler was found, indicate that we should collect text at this depth.
                    if (parentItemScope.predicates[depth][predicatesKey]) this.textBufferStack[depth] = [];
                }
            }
        },
        {
            /**
     * Emit the given object for the given predicates.
     * @param itemScope The current item scope.
     * @param predicates An array of predicates.
     * @param object An object.
     * @param reverse If the triples should be reversed.
     */ key: "emitPredicateTriples",
            value: function emitPredicateTriples(itemScope, predicates, object, reverse) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (!itemScope.blockEmission) try {
                    for(var _iterator = predicates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var predicate = _step.value;
                        if (reverse) // Literals can not exist in subject position, so they must be ignored.
                        {
                            if (object.termType !== 'Literal') this.emitTriple(object, predicate, itemScope.subject);
                        } else this.emitTriple(itemScope.subject, predicate, object);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Emit the given triple to the stream.
     * @param {Quad_Subject} subject A subject term.
     * @param {Quad_Predicate} predicate A predicate term.
     * @param {Quad_Object} object An object term.
     */ key: "emitTriple",
            value: function emitTriple(subject, predicate, object) {
                this.push(this.util.dataFactory.quad(subject, predicate, object, this.defaultGraph));
            }
        },
        {
            /**
     * Attempt to emit all pending itemrefs for the given reference.
     * @param reference An item reference id.
     * @param itemScopeDomain An optional item scope. If defined, only refs from this scope will be emitted.
     */ key: "tryToEmitReferences",
            value: function tryToEmitReferences(reference, itemScopeDomain) {
                var range = this.pendingItemRefsRangeFinalized[reference];
                if (range) {
                    // Determine the item scope domains to emit
                    var applicableItemScopes;
                    if (itemScopeDomain) {
                        applicableItemScopes = [
                            itemScopeDomain
                        ];
                        // Remove the item from the pending array
                        // Element is guaranteed to exist in buffer
                        var itemScopeDomainIndex = this.pendingItemRefsDomain[reference].indexOf(itemScopeDomain);
                        this.pendingItemRefsDomain[reference].splice(itemScopeDomainIndex, 1);
                    } else {
                        applicableItemScopes = this.pendingItemRefsDomain[reference];
                        // Remove all items from the pending array
                        delete this.pendingItemRefsDomain[reference];
                    }
                    if (applicableItemScopes) {
                        // Save the stack state
                        var itemScopeStackOld = this.itemScopeStack;
                        var textBufferStackOld = this.textBufferStack;
                        this.isEmittingReferences = true;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this, _loop = function() {
                                var itemScope = _step.value;
                                _this.itemScopeStack = [
                                    itemScope
                                ];
                                _this.textBufferStack = [
                                    undefined
                                ];
                                var pendingIds = (0, $7WNf6._)(range.ids);
                                _this.emittingReferencesItemScopeIdGenerator = function() {
                                    return pendingIds.shift();
                                };
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = range.events[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var event = _step1.value;
                                        switch(event.type){
                                            case 'open':
                                                _this.onTagOpen(event.name, event.attributes);
                                                break;
                                            case 'text':
                                                _this.onText(event.data);
                                                break;
                                            case 'close':
                                                _this.onTagClose();
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            };
                            // For all applicable item scopes, emit the buffered events.
                            for(var _iterator = applicableItemScopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Restore the stack state
                        this.emittingReferencesItemScopeIdGenerator = undefined;
                        this.itemScopeStack = itemScopeStackOld;
                        this.textBufferStack = textBufferStackOld;
                        this.isEmittingReferences = false;
                    }
                }
            }
        }
    ]);
    return MicrodataRdfParser;
}($bpBa6.Transform);
module.exports.MicrodataRdfParser = $14ac457def5b2aea$var$MicrodataRdfParser;
$14ac457def5b2aea$var$MicrodataRdfParser.ITEM_PROPERTY_HANDLERS = [
    new $4GBms.ItemPropertyHandlerContent(),
    new $eycdq.ItemPropertyHandlerUrl('a', 'href'),
    new $eycdq.ItemPropertyHandlerUrl('area', 'href'),
    new $eycdq.ItemPropertyHandlerUrl('audio', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('embed', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('iframe', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('img', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('link', 'href'),
    new $eycdq.ItemPropertyHandlerUrl('object', 'data'),
    new $eycdq.ItemPropertyHandlerUrl('source', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('track', 'src'),
    new $eycdq.ItemPropertyHandlerUrl('video', 'src'),
    new $1hSHU.ItemPropertyHandlerNumber('data', 'value'),
    new $1hSHU.ItemPropertyHandlerNumber('meter', 'value'),
    new $9wRYl.ItemPropertyHandlerTime()
];

});
parcelRegister("3DFcJ", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("X2jrl")).Parser; });

var $X2jrl = parcelRequire("X2jrl");

var $fjj4Z = parcelRequire("fjj4Z");

var $gZIel = parcelRequire("gZIel");

var $gDDlX = parcelRequire("gDDlX");
parcelRequire("4u3Uv");
var $b6XQv = parcelRequire("b6XQv");
function $2a64f9f184ad085d$export$b6a9369736b19f4d(data, options) {
    var handler = new (0, $fjj4Z.DomHandler)(undefined, options);
    new (0, $X2jrl.Parser)(handler, options).end(data);
    return handler.root;
}
function $2a64f9f184ad085d$export$d66b332881d9723f(data, options) {
    return $2a64f9f184ad085d$export$b6a9369736b19f4d(data, options).children;
}
function $2a64f9f184ad085d$export$2bbd0317573b00fc(callback, options, elementCallback) {
    var handler = new (0, $fjj4Z.DomHandler)(callback, options, elementCallback);
    return new (0, $X2jrl.Parser)(handler, options);
}
var $2a64f9f184ad085d$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $2a64f9f184ad085d$export$5267abf679cd576b(feed) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2a64f9f184ad085d$var$parseFeedDefaultOptions;
    return (0, $b6XQv.getFeed)($2a64f9f184ad085d$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("X2jrl", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $0b174e06eeae7a48$export$7acfa6ed01010e37; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $gZIel = parcelRequire("gZIel");

var $gkpNv = parcelRequire("gkpNv");
var $0b174e06eeae7a48$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $0b174e06eeae7a48$var$pTag = new Set([
    "p"
]);
var $0b174e06eeae7a48$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $0b174e06eeae7a48$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $0b174e06eeae7a48$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $0b174e06eeae7a48$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h1",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h2",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h3",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h4",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h5",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "h6",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "select",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "input",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "output",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "button",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "datalist",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "textarea",
        $0b174e06eeae7a48$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $0b174e06eeae7a48$var$ddtTags
    ],
    [
        "dt",
        $0b174e06eeae7a48$var$ddtTags
    ],
    [
        "address",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "article",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "aside",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "blockquote",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "details",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "div",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "dl",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "fieldset",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "figcaption",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "figure",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "footer",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "form",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "header",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "hr",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "main",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "nav",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "ol",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "pre",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "section",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "table",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "ul",
        $0b174e06eeae7a48$var$pTag
    ],
    [
        "rt",
        $0b174e06eeae7a48$var$rtpTags
    ],
    [
        "rp",
        $0b174e06eeae7a48$var$rtpTags
    ],
    [
        "tbody",
        $0b174e06eeae7a48$var$tableSectionTags
    ],
    [
        "tfoot",
        $0b174e06eeae7a48$var$tableSectionTags
    ]
]);
var $0b174e06eeae7a48$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $0b174e06eeae7a48$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $0b174e06eeae7a48$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $0b174e06eeae7a48$var$reNameEnd = /\s|\//;
var $0b174e06eeae7a48$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser(cbs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $jGAMp._)(this, Parser);
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $gZIel.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    (0, $byiyg._)(Parser, [
        {
            // Tokenizer event handlers
            /** @internal */ key: "ontext",
            value: function ontext(start, endIndex) {
                var _a, _b;
                var data = this.getSlice(start, endIndex);
                this.endIndex = endIndex - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
                this.startIndex = endIndex;
            }
        },
        {
            /** @internal */ key: "ontextentity",
            value: function ontextentity(cp) {
                var _a, _b;
                /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ var index = this.tokenizer.getSectionStart();
                this.endIndex = index - 1;
                (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $gkpNv.fromCodePoint)(cp));
                this.startIndex = index;
            }
        },
        {
            key: "isVoidElement",
            value: function isVoidElement(name) {
                return !this.options.xmlMode && $0b174e06eeae7a48$var$voidElements.has(name);
            }
        },
        {
            /** @internal */ key: "onopentagname",
            value: function onopentagname(start, endIndex) {
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                this.emitOpenTag(name);
            }
        },
        {
            key: "emitOpenTag",
            value: function emitOpenTag(name) {
                var _a, _b, _c, _d;
                this.openTagStart = this.startIndex;
                this.tagname = name;
                var impliesClose = !this.options.xmlMode && $0b174e06eeae7a48$var$openImpliesClose.get(name);
                if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
                    var element = this.stack.pop();
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
                }
                if (!this.isVoidElement(name)) {
                    this.stack.push(name);
                    if ($0b174e06eeae7a48$var$foreignContextElements.has(name)) this.foreignContext.push(true);
                    else if ($0b174e06eeae7a48$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
                }
                (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
                if (this.cbs.onopentag) this.attribs = {};
            }
        },
        {
            key: "endOpenTag",
            value: function endOpenTag(isImplied) {
                var _a, _b;
                this.startIndex = this.openTagStart;
                if (this.attribs) {
                    (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
                    this.attribs = null;
                }
                if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
                this.tagname = "";
            }
        },
        {
            /** @internal */ key: "onopentagend",
            value: function onopentagend(endIndex) {
                this.endIndex = endIndex;
                this.endOpenTag(false);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onclosetag",
            value: function onclosetag(start, endIndex) {
                var _a, _b, _c, _d, _e, _f;
                this.endIndex = endIndex;
                var name = this.getSlice(start, endIndex);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                if ($0b174e06eeae7a48$var$foreignContextElements.has(name) || $0b174e06eeae7a48$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
                if (!this.isVoidElement(name)) {
                    var pos = this.stack.lastIndexOf(name);
                    if (pos !== -1) {
                        if (this.cbs.onclosetag) {
                            var count = this.stack.length - pos;
                            while(count--)// We know the stack has sufficient elements.
                            this.cbs.onclosetag(this.stack.pop(), count !== 0);
                        } else this.stack.length = pos;
                    } else if (!this.options.xmlMode && name === "p") {
                        // Implicit open before close
                        this.emitOpenTag("p");
                        this.closeCurrentTag(true);
                    }
                } else if (!this.options.xmlMode && name === "br") {
                    // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
                    (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
                    (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
                    (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onselfclosingtag",
            value: function onselfclosingtag(endIndex) {
                this.endIndex = endIndex;
                if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
                    this.closeCurrentTag(false);
                    // Set `startIndex` for next node
                    this.startIndex = endIndex + 1;
                } else // Ignore the fact that the tag is self-closing.
                this.onopentagend(endIndex);
            }
        },
        {
            key: "closeCurrentTag",
            value: function closeCurrentTag(isOpenImplied) {
                var _a, _b;
                var name = this.tagname;
                this.endOpenTag(isOpenImplied);
                // Self-closing tags will be on the top of the stack
                if (this.stack[this.stack.length - 1] === name) {
                    // If the opening tag isn't implied, the closing tag has to be implied.
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
                    this.stack.pop();
                }
            }
        },
        {
            /** @internal */ key: "onattribname",
            value: function onattribname(start, endIndex) {
                this.startIndex = start;
                var name = this.getSlice(start, endIndex);
                this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
            }
        },
        {
            /** @internal */ key: "onattribdata",
            value: function onattribdata(start, endIndex) {
                this.attribvalue += this.getSlice(start, endIndex);
            }
        },
        {
            /** @internal */ key: "onattribentity",
            value: function onattribentity(cp) {
                this.attribvalue += (0, $gkpNv.fromCodePoint)(cp);
            }
        },
        {
            /** @internal */ key: "onattribend",
            value: function onattribend(quote, endIndex) {
                var _a, _b;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $gZIel.QuoteType).Double ? '"' : quote === (0, $gZIel.QuoteType).Single ? "'" : quote === (0, $gZIel.QuoteType).NoValue ? undefined : null);
                if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
                this.attribvalue = "";
            }
        },
        {
            key: "getInstructionName",
            value: function getInstructionName(value) {
                var index = value.search($0b174e06eeae7a48$var$reNameEnd);
                var name = index < 0 ? value : value.substr(0, index);
                if (this.lowerCaseTagNames) name = name.toLowerCase();
                return name;
            }
        },
        {
            /** @internal */ key: "ondeclaration",
            value: function ondeclaration(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onprocessinginstruction",
            value: function onprocessinginstruction(start, endIndex) {
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex);
                if (this.cbs.onprocessinginstruction) {
                    var name = this.getInstructionName(value);
                    this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncomment",
            value: function oncomment(start, endIndex, offset) {
                var _a, _b, _c, _d;
                this.endIndex = endIndex;
                (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
                (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "oncdata",
            value: function oncdata(start, endIndex, offset) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                this.endIndex = endIndex;
                var value = this.getSlice(start, endIndex - offset);
                if (this.options.xmlMode || this.options.recognizeCDATA) {
                    (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
                    (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
                    (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
                } else {
                    (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
                    (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
                }
                // Set `startIndex` for next node
                this.startIndex = endIndex + 1;
            }
        },
        {
            /** @internal */ key: "onend",
            value: function onend() {
                var _a, _b;
                if (this.cbs.onclosetag) {
                    // Set the end index for all remaining tags
                    this.endIndex = this.startIndex;
                    for(var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
                }
                (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
            }
        },
        {
            /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ key: "reset",
            value: function reset() {
                var _a, _b, _c, _d;
                (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
                this.tokenizer.reset();
                this.tagname = "";
                this.attribname = "";
                this.attribs = null;
                this.stack.length = 0;
                this.startIndex = 0;
                this.endIndex = 0;
                (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
                this.buffers.length = 0;
                this.bufferOffset = 0;
                this.writeIndex = 0;
                this.ended = false;
            }
        },
        {
            /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ key: "parseComplete",
            value: function parseComplete(data) {
                this.reset();
                this.end(data);
            }
        },
        {
            key: "getSlice",
            value: function getSlice(start, end) {
                while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
                var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
                while(end - this.bufferOffset > this.buffers[0].length){
                    this.shiftBuffer();
                    slice += this.buffers[0].slice(0, end - this.bufferOffset);
                }
                return slice;
            }
        },
        {
            key: "shiftBuffer",
            value: function shiftBuffer() {
                this.bufferOffset += this.buffers[0].length;
                this.writeIndex--;
                this.buffers.shift();
            }
        },
        {
            /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ key: "write",
            value: function write(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
                    return;
                }
                this.buffers.push(chunk);
                if (this.tokenizer.running) {
                    this.tokenizer.write(chunk);
                    this.writeIndex++;
                }
            }
        },
        {
            /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ key: "end",
            value: function end(chunk) {
                var _a, _b;
                if (this.ended) {
                    (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
                    return;
                }
                if (chunk) this.write(chunk);
                this.ended = true;
                this.tokenizer.end();
            }
        },
        {
            /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ key: "pause",
            value: function pause() {
                this.tokenizer.pause();
            }
        },
        {
            /**
     * Resumes parsing after `pause` was called.
     */ key: "resume",
            value: function resume() {
                this.tokenizer.resume();
                while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
                if (this.ended) this.tokenizer.end();
            }
        },
        {
            /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ key: "parseChunk",
            value: function parseChunk(chunk) {
                this.write(chunk);
            }
        },
        {
            /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ key: "done",
            value: function done(chunk) {
                this.end(chunk);
            }
        }
    ]);
    return Parser;
}();

});
parcelRegister("gZIel", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $c5f4a714dbcbadda$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $c5f4a714dbcbadda$export$2e2bcd8739ae039; });

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $gkpNv = parcelRequire("gkpNv");
var $c5f4a714dbcbadda$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($c5f4a714dbcbadda$var$CharCodes || ($c5f4a714dbcbadda$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $c5f4a714dbcbadda$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($c5f4a714dbcbadda$var$State || ($c5f4a714dbcbadda$var$State = {}));
function $c5f4a714dbcbadda$var$isWhitespace(c) {
    return c === $c5f4a714dbcbadda$var$CharCodes.Space || c === $c5f4a714dbcbadda$var$CharCodes.NewLine || c === $c5f4a714dbcbadda$var$CharCodes.Tab || c === $c5f4a714dbcbadda$var$CharCodes.FormFeed || c === $c5f4a714dbcbadda$var$CharCodes.CarriageReturn;
}
function $c5f4a714dbcbadda$var$isEndOfTagSection(c) {
    return c === $c5f4a714dbcbadda$var$CharCodes.Slash || c === $c5f4a714dbcbadda$var$CharCodes.Gt || $c5f4a714dbcbadda$var$isWhitespace(c);
}
function $c5f4a714dbcbadda$var$isNumber(c) {
    return c >= $c5f4a714dbcbadda$var$CharCodes.Zero && c <= $c5f4a714dbcbadda$var$CharCodes.Nine;
}
function $c5f4a714dbcbadda$var$isASCIIAlpha(c) {
    return c >= $c5f4a714dbcbadda$var$CharCodes.LowerA && c <= $c5f4a714dbcbadda$var$CharCodes.LowerZ || c >= $c5f4a714dbcbadda$var$CharCodes.UpperA && c <= $c5f4a714dbcbadda$var$CharCodes.UpperZ;
}
function $c5f4a714dbcbadda$var$isHexDigit(c) {
    return c >= $c5f4a714dbcbadda$var$CharCodes.UpperA && c <= $c5f4a714dbcbadda$var$CharCodes.UpperF || c >= $c5f4a714dbcbadda$var$CharCodes.LowerA && c <= $c5f4a714dbcbadda$var$CharCodes.LowerF;
}
var $c5f4a714dbcbadda$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($c5f4a714dbcbadda$export$cbf5509cea2ad22 || ($c5f4a714dbcbadda$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $c5f4a714dbcbadda$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
var $c5f4a714dbcbadda$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Tokenizer(param, cbs) {
        var _param_xmlMode = param.xmlMode, xmlMode = _param_xmlMode === void 0 ? false : _param_xmlMode, _param_decodeEntities = param.decodeEntities, decodeEntities = _param_decodeEntities === void 0 ? true : _param_decodeEntities;
        (0, $jGAMp._)(this, Tokenizer);
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $c5f4a714dbcbadda$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $c5f4a714dbcbadda$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $gkpNv.xmlDecodeTree) : (0, $gkpNv.htmlDecodeTree);
    }
    (0, $byiyg._)(Tokenizer, [
        {
            key: "reset",
            value: function reset() {
                this.state = $c5f4a714dbcbadda$var$State.Text;
                this.buffer = "";
                this.sectionStart = 0;
                this.index = 0;
                this.baseState = $c5f4a714dbcbadda$var$State.Text;
                this.currentSequence = undefined;
                this.running = true;
                this.offset = 0;
            }
        },
        {
            key: "write",
            value: function write(chunk) {
                this.offset += this.buffer.length;
                this.buffer = chunk;
                this.parse();
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.running) this.finish();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.running = false;
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.running = true;
                if (this.index < this.buffer.length + this.offset) this.parse();
            }
        },
        {
            /**
     * The current index within all of the written data.
     */ key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            /**
     * The start of the current section.
     */ key: "getSectionStart",
            value: function getSectionStart() {
                return this.sectionStart;
            }
        },
        {
            key: "stateText",
            value: function stateText(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Lt)) {
                    if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.BeforeTagName;
                    this.sectionStart = this.index;
                } else if (this.decodeEntities && c === $c5f4a714dbcbadda$var$CharCodes.Amp) this.state = $c5f4a714dbcbadda$var$State.BeforeEntity;
            }
        },
        {
            key: "stateSpecialStartSequence",
            value: function stateSpecialStartSequence(c) {
                var isEnd = this.sequenceIndex === this.currentSequence.length;
                var isMatch = isEnd ? $c5f4a714dbcbadda$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
                if (!isMatch) this.isSpecial = false;
                else if (!isEnd) {
                    this.sequenceIndex++;
                    return;
                }
                this.sequenceIndex = 0;
                this.state = $c5f4a714dbcbadda$var$State.InTagName;
                this.stateInTagName(c);
            }
        },
        {
            /** Look for an end tag. For <title> tags, also decode entities. */ key: "stateInSpecialTag",
            value: function stateInSpecialTag(c) {
                if (this.sequenceIndex === this.currentSequence.length) {
                    if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || $c5f4a714dbcbadda$var$isWhitespace(c)) {
                        var endOfText = this.index - this.currentSequence.length;
                        if (this.sectionStart < endOfText) {
                            // Spoof the index so that reported locations match up.
                            var actualIndex = this.index;
                            this.index = endOfText;
                            this.cbs.ontext(this.sectionStart, endOfText);
                            this.index = actualIndex;
                        }
                        this.isSpecial = false;
                        this.sectionStart = endOfText + 2; // Skip over the `</`
                        this.stateInClosingTagName(c);
                        return; // We are done; skip the rest of the function.
                    }
                    this.sequenceIndex = 0;
                }
                if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
                else if (this.sequenceIndex === 0) {
                    if (this.currentSequence === $c5f4a714dbcbadda$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
                    {
                        if (this.decodeEntities && c === $c5f4a714dbcbadda$var$CharCodes.Amp) this.state = $c5f4a714dbcbadda$var$State.BeforeEntity;
                    } else if (this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
                    this.sequenceIndex = 1;
                } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
                this.sequenceIndex = Number(c === $c5f4a714dbcbadda$var$CharCodes.Lt);
            }
        },
        {
            key: "stateCDATASequence",
            value: function stateCDATASequence(c) {
                if (c === $c5f4a714dbcbadda$var$Sequences.Cdata[this.sequenceIndex]) {
                    if (++this.sequenceIndex === $c5f4a714dbcbadda$var$Sequences.Cdata.length) {
                        this.state = $c5f4a714dbcbadda$var$State.InCommentLike;
                        this.currentSequence = $c5f4a714dbcbadda$var$Sequences.CdataEnd;
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                    }
                } else {
                    this.sequenceIndex = 0;
                    this.state = $c5f4a714dbcbadda$var$State.InDeclaration;
                    this.stateInDeclaration(c); // Reconsume the character
                }
            }
        },
        {
            /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ key: "fastForwardTo",
            value: function fastForwardTo(c) {
                while(++this.index < this.buffer.length + this.offset){
                    if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
                }
                /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
                return false;
            }
        },
        {
            /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ key: "stateInCommentLike",
            value: function stateInCommentLike(c) {
                if (c === this.currentSequence[this.sequenceIndex]) {
                    if (++this.sequenceIndex === this.currentSequence.length) {
                        if (this.currentSequence === $c5f4a714dbcbadda$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                        else this.cbs.oncomment(this.sectionStart, this.index, 2);
                        this.sequenceIndex = 0;
                        this.sectionStart = this.index + 1;
                        this.state = $c5f4a714dbcbadda$var$State.Text;
                    }
                } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
                {
                    if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
                } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
                this.sequenceIndex = 0;
            }
        },
        {
            /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ key: "isTagStartChar",
            value: function isTagStartChar(c) {
                return this.xmlMode ? !$c5f4a714dbcbadda$var$isEndOfTagSection(c) : $c5f4a714dbcbadda$var$isASCIIAlpha(c);
            }
        },
        {
            key: "startSpecial",
            value: function startSpecial(sequence, offset) {
                this.isSpecial = true;
                this.currentSequence = sequence;
                this.sequenceIndex = offset;
                this.state = $c5f4a714dbcbadda$var$State.SpecialStartSequence;
            }
        },
        {
            key: "stateBeforeTagName",
            value: function stateBeforeTagName(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.ExclamationMark) {
                    this.state = $c5f4a714dbcbadda$var$State.BeforeDeclaration;
                    this.sectionStart = this.index + 1;
                } else if (c === $c5f4a714dbcbadda$var$CharCodes.Questionmark) {
                    this.state = $c5f4a714dbcbadda$var$State.InProcessingInstruction;
                    this.sectionStart = this.index + 1;
                } else if (this.isTagStartChar(c)) {
                    var lower = c | 0x20;
                    this.sectionStart = this.index;
                    if (!this.xmlMode && lower === $c5f4a714dbcbadda$var$Sequences.TitleEnd[2]) this.startSpecial($c5f4a714dbcbadda$var$Sequences.TitleEnd, 3);
                    else this.state = !this.xmlMode && lower === $c5f4a714dbcbadda$var$Sequences.ScriptEnd[2] ? $c5f4a714dbcbadda$var$State.BeforeSpecialS : $c5f4a714dbcbadda$var$State.InTagName;
                } else if (c === $c5f4a714dbcbadda$var$CharCodes.Slash) this.state = $c5f4a714dbcbadda$var$State.BeforeClosingTagName;
                else {
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.stateText(c);
                }
            }
        },
        {
            key: "stateInTagName",
            value: function stateInTagName(c) {
                if ($c5f4a714dbcbadda$var$isEndOfTagSection(c)) {
                    this.cbs.onopentagname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateBeforeClosingTagName",
            value: function stateBeforeClosingTagName(c) {
                if ($c5f4a714dbcbadda$var$isWhitespace(c)) ;
                else if (c === $c5f4a714dbcbadda$var$CharCodes.Gt) this.state = $c5f4a714dbcbadda$var$State.Text;
                else {
                    this.state = this.isTagStartChar(c) ? $c5f4a714dbcbadda$var$State.InClosingTagName : $c5f4a714dbcbadda$var$State.InSpecialComment;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInClosingTagName",
            value: function stateInClosingTagName(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || $c5f4a714dbcbadda$var$isWhitespace(c)) {
                    this.cbs.onclosetag(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $c5f4a714dbcbadda$var$State.AfterClosingTagName;
                    this.stateAfterClosingTagName(c);
                }
            }
        },
        {
            key: "stateAfterClosingTagName",
            value: function stateAfterClosingTagName(c) {
                // Skip everything until ">"
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Gt)) {
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.baseState = $c5f4a714dbcbadda$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeAttributeName",
            value: function stateBeforeAttributeName(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt) {
                    this.cbs.onopentagend(this.index);
                    if (this.isSpecial) {
                        this.state = $c5f4a714dbcbadda$var$State.InSpecialTag;
                        this.sequenceIndex = 0;
                    } else this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.baseState = this.state;
                    this.sectionStart = this.index + 1;
                } else if (c === $c5f4a714dbcbadda$var$CharCodes.Slash) this.state = $c5f4a714dbcbadda$var$State.InSelfClosingTag;
                else if (!$c5f4a714dbcbadda$var$isWhitespace(c)) {
                    this.state = $c5f4a714dbcbadda$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateInSelfClosingTag",
            value: function stateInSelfClosingTag(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt) {
                    this.cbs.onselfclosingtag(this.index);
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.baseState = $c5f4a714dbcbadda$var$State.Text;
                    this.sectionStart = this.index + 1;
                    this.isSpecial = false; // Reset special state, in case of self-closing special tags
                } else if (!$c5f4a714dbcbadda$var$isWhitespace(c)) {
                    this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                }
            }
        },
        {
            key: "stateInAttributeName",
            value: function stateInAttributeName(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Eq || $c5f4a714dbcbadda$var$isEndOfTagSection(c)) {
                    this.cbs.onattribname(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.state = $c5f4a714dbcbadda$var$State.AfterAttributeName;
                    this.stateAfterAttributeName(c);
                }
            }
        },
        {
            key: "stateAfterAttributeName",
            value: function stateAfterAttributeName(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Eq) this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeValue;
                else if (c === $c5f4a714dbcbadda$var$CharCodes.Slash || c === $c5f4a714dbcbadda$var$CharCodes.Gt) {
                    this.cbs.onattribend($c5f4a714dbcbadda$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (!$c5f4a714dbcbadda$var$isWhitespace(c)) {
                    this.cbs.onattribend($c5f4a714dbcbadda$export$cbf5509cea2ad22.NoValue, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.InAttributeName;
                    this.sectionStart = this.index;
                }
            }
        },
        {
            key: "stateBeforeAttributeValue",
            value: function stateBeforeAttributeValue(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.DoubleQuote) {
                    this.state = $c5f4a714dbcbadda$var$State.InAttributeValueDq;
                    this.sectionStart = this.index + 1;
                } else if (c === $c5f4a714dbcbadda$var$CharCodes.SingleQuote) {
                    this.state = $c5f4a714dbcbadda$var$State.InAttributeValueSq;
                    this.sectionStart = this.index + 1;
                } else if (!$c5f4a714dbcbadda$var$isWhitespace(c)) {
                    this.sectionStart = this.index;
                    this.state = $c5f4a714dbcbadda$var$State.InAttributeValueNq;
                    this.stateInAttributeValueNoQuotes(c); // Reconsume token
                }
            }
        },
        {
            key: "handleInAttributeValue",
            value: function handleInAttributeValue(c, quote) {
                if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend(quote === $c5f4a714dbcbadda$var$CharCodes.DoubleQuote ? $c5f4a714dbcbadda$export$cbf5509cea2ad22.Double : $c5f4a714dbcbadda$export$cbf5509cea2ad22.Single, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeName;
                } else if (this.decodeEntities && c === $c5f4a714dbcbadda$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $c5f4a714dbcbadda$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateInAttributeValueDoubleQuotes",
            value: function stateInAttributeValueDoubleQuotes(c) {
                this.handleInAttributeValue(c, $c5f4a714dbcbadda$var$CharCodes.DoubleQuote);
            }
        },
        {
            key: "stateInAttributeValueSingleQuotes",
            value: function stateInAttributeValueSingleQuotes(c) {
                this.handleInAttributeValue(c, $c5f4a714dbcbadda$var$CharCodes.SingleQuote);
            }
        },
        {
            key: "stateInAttributeValueNoQuotes",
            value: function stateInAttributeValueNoQuotes(c) {
                if ($c5f4a714dbcbadda$var$isWhitespace(c) || c === $c5f4a714dbcbadda$var$CharCodes.Gt) {
                    this.cbs.onattribdata(this.sectionStart, this.index);
                    this.sectionStart = -1;
                    this.cbs.onattribend($c5f4a714dbcbadda$export$cbf5509cea2ad22.Unquoted, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.BeforeAttributeName;
                    this.stateBeforeAttributeName(c);
                } else if (this.decodeEntities && c === $c5f4a714dbcbadda$var$CharCodes.Amp) {
                    this.baseState = this.state;
                    this.state = $c5f4a714dbcbadda$var$State.BeforeEntity;
                }
            }
        },
        {
            key: "stateBeforeDeclaration",
            value: function stateBeforeDeclaration(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.OpeningSquareBracket) {
                    this.state = $c5f4a714dbcbadda$var$State.CDATASequence;
                    this.sequenceIndex = 0;
                } else this.state = c === $c5f4a714dbcbadda$var$CharCodes.Dash ? $c5f4a714dbcbadda$var$State.BeforeComment : $c5f4a714dbcbadda$var$State.InDeclaration;
            }
        },
        {
            key: "stateInDeclaration",
            value: function stateInDeclaration(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Gt)) {
                    this.cbs.ondeclaration(this.sectionStart, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateInProcessingInstruction",
            value: function stateInProcessingInstruction(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Gt)) {
                    this.cbs.onprocessinginstruction(this.sectionStart, this.index);
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeComment",
            value: function stateBeforeComment(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Dash) {
                    this.state = $c5f4a714dbcbadda$var$State.InCommentLike;
                    this.currentSequence = $c5f4a714dbcbadda$var$Sequences.CommentEnd;
                    // Allow short comments (eg. <!-->)
                    this.sequenceIndex = 2;
                    this.sectionStart = this.index + 1;
                } else this.state = $c5f4a714dbcbadda$var$State.InDeclaration;
            }
        },
        {
            key: "stateInSpecialComment",
            value: function stateInSpecialComment(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Gt || this.fastForwardTo($c5f4a714dbcbadda$var$CharCodes.Gt)) {
                    this.cbs.oncomment(this.sectionStart, this.index, 0);
                    this.state = $c5f4a714dbcbadda$var$State.Text;
                    this.sectionStart = this.index + 1;
                }
            }
        },
        {
            key: "stateBeforeSpecialS",
            value: function stateBeforeSpecialS(c) {
                var lower = c | 0x20;
                if (lower === $c5f4a714dbcbadda$var$Sequences.ScriptEnd[3]) this.startSpecial($c5f4a714dbcbadda$var$Sequences.ScriptEnd, 4);
                else if (lower === $c5f4a714dbcbadda$var$Sequences.StyleEnd[3]) this.startSpecial($c5f4a714dbcbadda$var$Sequences.StyleEnd, 4);
                else {
                    this.state = $c5f4a714dbcbadda$var$State.InTagName;
                    this.stateInTagName(c); // Consume the token again
                }
            }
        },
        {
            key: "stateBeforeEntity",
            value: function stateBeforeEntity(c) {
                // Start excess with 1 to include the '&'
                this.entityExcess = 1;
                this.entityResult = 0;
                if (c === $c5f4a714dbcbadda$var$CharCodes.Number) this.state = $c5f4a714dbcbadda$var$State.BeforeNumericEntity;
                else if (c === $c5f4a714dbcbadda$var$CharCodes.Amp) ;
                else {
                    this.trieIndex = 0;
                    this.trieCurrent = this.entityTrie[0];
                    this.state = $c5f4a714dbcbadda$var$State.InNamedEntity;
                    this.stateInNamedEntity(c);
                }
            }
        },
        {
            key: "stateInNamedEntity",
            value: function stateInNamedEntity(c) {
                this.entityExcess += 1;
                this.trieIndex = (0, $gkpNv.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
                if (this.trieIndex < 0) {
                    this.emitNamedEntity();
                    this.index--;
                    return;
                }
                this.trieCurrent = this.entityTrie[this.trieIndex];
                var masked = this.trieCurrent & (0, $gkpNv.BinTrieFlags).VALUE_LENGTH;
                // If the branch is a value, store it and continue
                if (masked) {
                    // The mask is the number of bytes of the value, including the current byte.
                    var valueLength = (masked >> 14) - 1;
                    // If we have a legacy entity while parsing strictly, just skip the number of bytes
                    if (!this.allowLegacyEntity() && c !== $c5f4a714dbcbadda$var$CharCodes.Semi) this.trieIndex += valueLength;
                    else {
                        // Add 1 as we have already incremented the excess
                        var entityStart = this.index - this.entityExcess + 1;
                        if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                        // If this is a surrogate pair, consume the next two bytes
                        this.entityResult = this.trieIndex;
                        this.trieIndex += valueLength;
                        this.entityExcess = 0;
                        this.sectionStart = this.index + 1;
                        if (valueLength === 0) this.emitNamedEntity();
                    }
                }
            }
        },
        {
            key: "emitNamedEntity",
            value: function emitNamedEntity() {
                this.state = this.baseState;
                if (this.entityResult === 0) return;
                var valueLength = (this.entityTrie[this.entityResult] & (0, $gkpNv.BinTrieFlags).VALUE_LENGTH) >> 14;
                switch(valueLength){
                    case 1:
                        this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $gkpNv.BinTrieFlags).VALUE_LENGTH);
                        break;
                    case 2:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        break;
                    case 3:
                        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                        this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
                }
            }
        },
        {
            key: "stateBeforeNumericEntity",
            value: function stateBeforeNumericEntity(c) {
                if ((c | 0x20) === $c5f4a714dbcbadda$var$CharCodes.LowerX) {
                    this.entityExcess++;
                    this.state = $c5f4a714dbcbadda$var$State.InHexEntity;
                } else {
                    this.state = $c5f4a714dbcbadda$var$State.InNumericEntity;
                    this.stateInNumericEntity(c);
                }
            }
        },
        {
            key: "emitNumericEntity",
            value: function emitNumericEntity(strict) {
                var entityStart = this.index - this.entityExcess - 1;
                var numberStart = entityStart + 2 + Number(this.state === $c5f4a714dbcbadda$var$State.InHexEntity);
                if (numberStart !== this.index) {
                    // Emit leading data if any
                    if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                    this.sectionStart = this.index + Number(strict);
                    this.emitCodePoint((0, $gkpNv.replaceCodePoint)(this.entityResult));
                }
                this.state = this.baseState;
            }
        },
        {
            key: "stateInNumericEntity",
            value: function stateInNumericEntity(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($c5f4a714dbcbadda$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 10 + (c - $c5f4a714dbcbadda$var$CharCodes.Zero);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "stateInHexEntity",
            value: function stateInHexEntity(c) {
                if (c === $c5f4a714dbcbadda$var$CharCodes.Semi) this.emitNumericEntity(true);
                else if ($c5f4a714dbcbadda$var$isNumber(c)) {
                    this.entityResult = this.entityResult * 16 + (c - $c5f4a714dbcbadda$var$CharCodes.Zero);
                    this.entityExcess++;
                } else if ($c5f4a714dbcbadda$var$isHexDigit(c)) {
                    this.entityResult = this.entityResult * 16 + ((c | 0x20) - $c5f4a714dbcbadda$var$CharCodes.LowerA + 10);
                    this.entityExcess++;
                } else {
                    if (this.allowLegacyEntity()) this.emitNumericEntity(false);
                    else this.state = this.baseState;
                    this.index--;
                }
            }
        },
        {
            key: "allowLegacyEntity",
            value: function allowLegacyEntity() {
                return !this.xmlMode && (this.baseState === $c5f4a714dbcbadda$var$State.Text || this.baseState === $c5f4a714dbcbadda$var$State.InSpecialTag);
            }
        },
        {
            /**
     * Remove data that has already been consumed from the buffer.
     */ key: "cleanup",
            value: function cleanup() {
                // If we are inside of text or attributes, emit what we already have.
                if (this.running && this.sectionStart !== this.index) {
                    if (this.state === $c5f4a714dbcbadda$var$State.Text || this.state === $c5f4a714dbcbadda$var$State.InSpecialTag && this.sequenceIndex === 0) {
                        this.cbs.ontext(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    } else if (this.state === $c5f4a714dbcbadda$var$State.InAttributeValueDq || this.state === $c5f4a714dbcbadda$var$State.InAttributeValueSq || this.state === $c5f4a714dbcbadda$var$State.InAttributeValueNq) {
                        this.cbs.onattribdata(this.sectionStart, this.index);
                        this.sectionStart = this.index;
                    }
                }
            }
        },
        {
            key: "shouldContinue",
            value: function shouldContinue() {
                return this.index < this.buffer.length + this.offset && this.running;
            }
        },
        {
            /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ key: "parse",
            value: function parse() {
                while(this.shouldContinue()){
                    var c = this.buffer.charCodeAt(this.index - this.offset);
                    switch(this.state){
                        case $c5f4a714dbcbadda$var$State.Text:
                            this.stateText(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.SpecialStartSequence:
                            this.stateSpecialStartSequence(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InSpecialTag:
                            this.stateInSpecialTag(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.CDATASequence:
                            this.stateCDATASequence(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InAttributeValueDq:
                            this.stateInAttributeValueDoubleQuotes(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InAttributeName:
                            this.stateInAttributeName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InCommentLike:
                            this.stateInCommentLike(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InSpecialComment:
                            this.stateInSpecialComment(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeAttributeName:
                            this.stateBeforeAttributeName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InTagName:
                            this.stateInTagName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InClosingTagName:
                            this.stateInClosingTagName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeTagName:
                            this.stateBeforeTagName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.AfterAttributeName:
                            this.stateAfterAttributeName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InAttributeValueSq:
                            this.stateInAttributeValueSingleQuotes(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeAttributeValue:
                            this.stateBeforeAttributeValue(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeClosingTagName:
                            this.stateBeforeClosingTagName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.AfterClosingTagName:
                            this.stateAfterClosingTagName(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeSpecialS:
                            this.stateBeforeSpecialS(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InAttributeValueNq:
                            this.stateInAttributeValueNoQuotes(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InSelfClosingTag:
                            this.stateInSelfClosingTag(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InDeclaration:
                            this.stateInDeclaration(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeDeclaration:
                            this.stateBeforeDeclaration(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeComment:
                            this.stateBeforeComment(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InProcessingInstruction:
                            this.stateInProcessingInstruction(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InNamedEntity:
                            this.stateInNamedEntity(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.BeforeEntity:
                            this.stateBeforeEntity(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InHexEntity:
                            this.stateInHexEntity(c);
                            break;
                        case $c5f4a714dbcbadda$var$State.InNumericEntity:
                            this.stateInNumericEntity(c);
                            break;
                        default:
                            // `this._state === State.BeforeNumericEntity`
                            this.stateBeforeNumericEntity(c);
                    }
                    this.index++;
                }
                this.cleanup();
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.state === $c5f4a714dbcbadda$var$State.InNamedEntity) this.emitNamedEntity();
                // If there is remaining data, emit it in a reasonable way
                if (this.sectionStart < this.index) this.handleTrailingData();
                this.cbs.onend();
            }
        },
        {
            /** Handle any trailing data. */ key: "handleTrailingData",
            value: function handleTrailingData() {
                var endIndex = this.buffer.length + this.offset;
                if (this.state === $c5f4a714dbcbadda$var$State.InCommentLike) {
                    if (this.currentSequence === $c5f4a714dbcbadda$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
                    else this.cbs.oncomment(this.sectionStart, endIndex, 0);
                } else if (this.state === $c5f4a714dbcbadda$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $c5f4a714dbcbadda$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
                else if (this.state === $c5f4a714dbcbadda$var$State.InTagName || this.state === $c5f4a714dbcbadda$var$State.BeforeAttributeName || this.state === $c5f4a714dbcbadda$var$State.BeforeAttributeValue || this.state === $c5f4a714dbcbadda$var$State.AfterAttributeName || this.state === $c5f4a714dbcbadda$var$State.InAttributeName || this.state === $c5f4a714dbcbadda$var$State.InAttributeValueSq || this.state === $c5f4a714dbcbadda$var$State.InAttributeValueDq || this.state === $c5f4a714dbcbadda$var$State.InAttributeValueNq || this.state === $c5f4a714dbcbadda$var$State.InClosingTagName) ;
                else this.cbs.ontext(this.sectionStart, endIndex);
            }
        },
        {
            key: "emitPartial",
            value: function emitPartial(start, endIndex) {
                if (this.baseState !== $c5f4a714dbcbadda$var$State.Text && this.baseState !== $c5f4a714dbcbadda$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
                else this.cbs.ontext(start, endIndex);
            }
        },
        {
            key: "emitCodePoint",
            value: function emitCodePoint(cp) {
                if (this.baseState !== $c5f4a714dbcbadda$var$State.Text && this.baseState !== $c5f4a714dbcbadda$var$State.InSpecialTag) this.cbs.onattribentity(cp);
                else this.cbs.ontextentity(cp);
            }
        }
    ]);
    return Tokenizer;
}();

});



parcelRegister("bpBa6", function(module, exports) {
'use strict';

var $9MhwH = parcelRequire("9MhwH");

var $ee7vV = parcelRequire("ee7vV");
var $84eedb163b44f2bf$var$originalDestroy = $9MhwH.Readable.destroy;
module.exports = $9MhwH.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $9MhwH._uint8ArrayToBuffer;
module.exports._isUint8Array = $9MhwH._isUint8Array;
module.exports.isDisturbed = $9MhwH.isDisturbed;
module.exports.isErrored = $9MhwH.isErrored;
module.exports.isReadable = $9MhwH.isReadable;
module.exports.Readable = $9MhwH.Readable;
module.exports.Writable = $9MhwH.Writable;
module.exports.Duplex = $9MhwH.Duplex;
module.exports.Transform = $9MhwH.Transform;
module.exports.PassThrough = $9MhwH.PassThrough;
module.exports.addAbortSignal = $9MhwH.addAbortSignal;
module.exports.finished = $9MhwH.finished;
module.exports.destroy = $9MhwH.destroy;
module.exports.destroy = $84eedb163b44f2bf$var$originalDestroy;
module.exports.pipeline = $9MhwH.pipeline;
module.exports.compose = $9MhwH.compose;
Object.defineProperty($9MhwH, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $ee7vV;
    }
});
module.exports.Stream = $9MhwH.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("9MhwH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $aIGzY = parcelRequire("aIGzY");
var $71e6311f91728697$require$Buffer = $aIGzY.Buffer;

var $v3qKH = parcelRequire("v3qKH");
/* replacement end */ var $71e6311f91728697$var$ObjectDefineProperty = $v3qKH.ObjectDefineProperty, $71e6311f91728697$var$ObjectKeys = $v3qKH.ObjectKeys, $71e6311f91728697$var$ReflectApply = $v3qKH.ReflectApply;

var $8L76f = parcelRequire("8L76f");
var $71e6311f91728697$var$_require_promisify = $8L76f.promisify, $71e6311f91728697$var$customPromisify = $71e6311f91728697$var$_require_promisify.custom;

var $5iYAX = parcelRequire("5iYAX");
var $71e6311f91728697$var$streamReturningOperators = $5iYAX.streamReturningOperators, $71e6311f91728697$var$promiseReturningOperators = $5iYAX.promiseReturningOperators;

var $ahgAy = parcelRequire("ahgAy");
var $71e6311f91728697$var$ERR_ILLEGAL_CONSTRUCTOR = $ahgAy.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $5AZNL = parcelRequire("5AZNL");

var $gC29b = parcelRequire("gC29b");
var $71e6311f91728697$var$setDefaultHighWaterMark = $gC29b.setDefaultHighWaterMark, $71e6311f91728697$var$getDefaultHighWaterMark = $gC29b.getDefaultHighWaterMark;

var $kRkns = parcelRequire("kRkns");
var $71e6311f91728697$require$pipeline = $kRkns.pipeline;

var $EVPNo = parcelRequire("EVPNo");
var $71e6311f91728697$require$destroyer = $EVPNo.destroyer;

var $2JzI0 = parcelRequire("2JzI0");
var $71e6311f91728697$var$internalBuffer = {};

var $ee7vV = parcelRequire("ee7vV");

var $8gLGB = parcelRequire("8gLGB");

var $71e6311f91728697$var$Stream = module.exports = (parcelRequire("kQQwm")).Stream;
$71e6311f91728697$var$Stream.isDestroyed = $8gLGB.isDestroyed;
$71e6311f91728697$var$Stream.isDisturbed = $8gLGB.isDisturbed;
$71e6311f91728697$var$Stream.isErrored = $8gLGB.isErrored;
$71e6311f91728697$var$Stream.isReadable = $8gLGB.isReadable;
$71e6311f91728697$var$Stream.isWritable = $8gLGB.isWritable;

$71e6311f91728697$var$Stream.Readable = (parcelRequire("ikhVC"));
var $71e6311f91728697$var$_iteratorNormalCompletion = true, $71e6311f91728697$var$_didIteratorError = false, $71e6311f91728697$var$_iteratorError = undefined;
try {
    for(var $71e6311f91728697$var$_iterator = $71e6311f91728697$var$ObjectKeys($71e6311f91728697$var$streamReturningOperators)[Symbol.iterator](), $71e6311f91728697$var$_step; !($71e6311f91728697$var$_iteratorNormalCompletion = ($71e6311f91728697$var$_step = $71e6311f91728697$var$_iterator.next()).done); $71e6311f91728697$var$_iteratorNormalCompletion = true){
        var $71e6311f91728697$var$key = $71e6311f91728697$var$_step.value;
        var $71e6311f91728697$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $71e6311f91728697$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $71e6311f91728697$var$Stream.Readable.from($71e6311f91728697$var$ReflectApply($71e6311f91728697$var$op, this, args));
        };
        var $71e6311f91728697$var$op = $71e6311f91728697$var$streamReturningOperators[$71e6311f91728697$var$key];
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$fn, 'name', {
            __proto__: null,
            value: $71e6311f91728697$var$op.name
        });
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$fn, 'length', {
            __proto__: null,
            value: $71e6311f91728697$var$op.length
        });
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$Stream.Readable.prototype, $71e6311f91728697$var$key, {
            __proto__: null,
            value: $71e6311f91728697$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $71e6311f91728697$var$_didIteratorError = true;
    $71e6311f91728697$var$_iteratorError = err;
} finally{
    try {
        if (!$71e6311f91728697$var$_iteratorNormalCompletion && $71e6311f91728697$var$_iterator["return"] != null) {
            $71e6311f91728697$var$_iterator["return"]();
        }
    } finally{
        if ($71e6311f91728697$var$_didIteratorError) {
            throw $71e6311f91728697$var$_iteratorError;
        }
    }
}
var $71e6311f91728697$var$_iteratorNormalCompletion1 = true, $71e6311f91728697$var$_didIteratorError1 = false, $71e6311f91728697$var$_iteratorError1 = undefined;
try {
    for(var $71e6311f91728697$var$_iterator1 = $71e6311f91728697$var$ObjectKeys($71e6311f91728697$var$promiseReturningOperators)[Symbol.iterator](), $71e6311f91728697$var$_step1; !($71e6311f91728697$var$_iteratorNormalCompletion1 = ($71e6311f91728697$var$_step1 = $71e6311f91728697$var$_iterator1.next()).done); $71e6311f91728697$var$_iteratorNormalCompletion1 = true){
        var $71e6311f91728697$var$key1 = $71e6311f91728697$var$_step1.value;
        var $71e6311f91728697$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $71e6311f91728697$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $71e6311f91728697$var$ReflectApply($71e6311f91728697$var$op1, this, args);
        };
        var $71e6311f91728697$var$op1 = $71e6311f91728697$var$promiseReturningOperators[$71e6311f91728697$var$key1];
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$fn1, 'name', {
            __proto__: null,
            value: $71e6311f91728697$var$op1.name
        });
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$fn1, 'length', {
            __proto__: null,
            value: $71e6311f91728697$var$op1.length
        });
        $71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$Stream.Readable.prototype, $71e6311f91728697$var$key1, {
            __proto__: null,
            value: $71e6311f91728697$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $71e6311f91728697$var$_didIteratorError1 = true;
    $71e6311f91728697$var$_iteratorError1 = err;
} finally{
    try {
        if (!$71e6311f91728697$var$_iteratorNormalCompletion1 && $71e6311f91728697$var$_iterator1["return"] != null) {
            $71e6311f91728697$var$_iterator1["return"]();
        }
    } finally{
        if ($71e6311f91728697$var$_didIteratorError1) {
            throw $71e6311f91728697$var$_iteratorError1;
        }
    }
}

$71e6311f91728697$var$Stream.Writable = (parcelRequire("115Jk"));

$71e6311f91728697$var$Stream.Duplex = (parcelRequire("74J3X"));

$71e6311f91728697$var$Stream.Transform = (parcelRequire("kDq98"));

$71e6311f91728697$var$Stream.PassThrough = (parcelRequire("eFXFq"));
$71e6311f91728697$var$Stream.pipeline = $71e6311f91728697$require$pipeline;

var $4ojGs = parcelRequire("4ojGs");
var $71e6311f91728697$require$addAbortSignal = $4ojGs.addAbortSignal;
$71e6311f91728697$var$Stream.addAbortSignal = $71e6311f91728697$require$addAbortSignal;
$71e6311f91728697$var$Stream.finished = $2JzI0;
$71e6311f91728697$var$Stream.destroy = $71e6311f91728697$require$destroyer;
$71e6311f91728697$var$Stream.compose = $5AZNL;
$71e6311f91728697$var$Stream.setDefaultHighWaterMark = $71e6311f91728697$var$setDefaultHighWaterMark;
$71e6311f91728697$var$Stream.getDefaultHighWaterMark = $71e6311f91728697$var$getDefaultHighWaterMark;
$71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $ee7vV;
    }
});
$71e6311f91728697$var$ObjectDefineProperty($71e6311f91728697$require$pipeline, $71e6311f91728697$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $ee7vV.pipeline;
    }
});
$71e6311f91728697$var$ObjectDefineProperty($2JzI0, $71e6311f91728697$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $ee7vV.finished;
    }
});
// Backwards-compat with node 0.4.x
$71e6311f91728697$var$Stream.Stream = $71e6311f91728697$var$Stream;
$71e6311f91728697$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$71e6311f91728697$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $71e6311f91728697$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("aIGzY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $7cdf0ad04623b5a4$export$a143d493d941bafc; }, function (v) { return $7cdf0ad04623b5a4$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $7cdf0ad04623b5a4$export$f99ded8fe4b79145; }, function (v) { return $7cdf0ad04623b5a4$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $7cdf0ad04623b5a4$export$a143d493d941bafc;
var $7cdf0ad04623b5a4$export$e4cf37d7f6fb9e0a;
var $7cdf0ad04623b5a4$export$f99ded8fe4b79145;
var $7cdf0ad04623b5a4$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $7cdf0ad04623b5a4$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$7cdf0ad04623b5a4$export$a143d493d941bafc = $7cdf0ad04623b5a4$var$Buffer;
$7cdf0ad04623b5a4$export$e4cf37d7f6fb9e0a = $7cdf0ad04623b5a4$var$SlowBuffer;
$7cdf0ad04623b5a4$export$f99ded8fe4b79145 = 50;
var $7cdf0ad04623b5a4$var$K_MAX_LENGTH = 0x7fffffff;
$7cdf0ad04623b5a4$export$599f31c3813fae4d = $7cdf0ad04623b5a4$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $7cdf0ad04623b5a4$var$Buffer.TYPED_ARRAY_SUPPORT = $7cdf0ad04623b5a4$var$typedArraySupport();
if (!$7cdf0ad04623b5a4$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $7cdf0ad04623b5a4$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($7cdf0ad04623b5a4$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($7cdf0ad04623b5a4$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $7cdf0ad04623b5a4$var$createBuffer(length) {
    if (length > $7cdf0ad04623b5a4$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $7cdf0ad04623b5a4$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7cdf0ad04623b5a4$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $7cdf0ad04623b5a4$var$allocUnsafe(arg);
    }
    return $7cdf0ad04623b5a4$var$from(arg, encodingOrOffset, length);
}
$7cdf0ad04623b5a4$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $7cdf0ad04623b5a4$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $7cdf0ad04623b5a4$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $7cdf0ad04623b5a4$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($7cdf0ad04623b5a4$var$isInstance(value, ArrayBuffer) || value && $7cdf0ad04623b5a4$var$isInstance(value.buffer, ArrayBuffer)) return $7cdf0ad04623b5a4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($7cdf0ad04623b5a4$var$isInstance(value, SharedArrayBuffer) || value && $7cdf0ad04623b5a4$var$isInstance(value.buffer, SharedArrayBuffer))) return $7cdf0ad04623b5a4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $7cdf0ad04623b5a4$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $7cdf0ad04623b5a4$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $7cdf0ad04623b5a4$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7cdf0ad04623b5a4$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7cdf0ad04623b5a4$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($7cdf0ad04623b5a4$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($7cdf0ad04623b5a4$var$Buffer, Uint8Array);
function $7cdf0ad04623b5a4$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $7cdf0ad04623b5a4$var$alloc(size, fill, encoding) {
    $7cdf0ad04623b5a4$var$assertSize(size);
    if (size <= 0) return $7cdf0ad04623b5a4$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $7cdf0ad04623b5a4$var$createBuffer(size).fill(fill, encoding) : $7cdf0ad04623b5a4$var$createBuffer(size).fill(fill);
    return $7cdf0ad04623b5a4$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7cdf0ad04623b5a4$var$Buffer.alloc = function(size, fill, encoding) {
    return $7cdf0ad04623b5a4$var$alloc(size, fill, encoding);
};
function $7cdf0ad04623b5a4$var$allocUnsafe(size) {
    $7cdf0ad04623b5a4$var$assertSize(size);
    return $7cdf0ad04623b5a4$var$createBuffer(size < 0 ? 0 : $7cdf0ad04623b5a4$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7cdf0ad04623b5a4$var$Buffer.allocUnsafe = function(size) {
    return $7cdf0ad04623b5a4$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7cdf0ad04623b5a4$var$Buffer.allocUnsafeSlow = function(size) {
    return $7cdf0ad04623b5a4$var$allocUnsafe(size);
};
function $7cdf0ad04623b5a4$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$7cdf0ad04623b5a4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $7cdf0ad04623b5a4$var$byteLength(string, encoding) | 0;
    var buf = $7cdf0ad04623b5a4$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $7cdf0ad04623b5a4$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $7cdf0ad04623b5a4$var$checked(array.length) | 0;
    var buf = $7cdf0ad04623b5a4$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $7cdf0ad04623b5a4$var$fromArrayView(arrayView) {
    if ($7cdf0ad04623b5a4$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $7cdf0ad04623b5a4$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $7cdf0ad04623b5a4$var$fromArrayLike(arrayView);
}
function $7cdf0ad04623b5a4$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $7cdf0ad04623b5a4$var$Buffer.prototype);
    return buf;
}
function $7cdf0ad04623b5a4$var$fromObject(obj) {
    if ($7cdf0ad04623b5a4$var$Buffer.isBuffer(obj)) {
        var len = $7cdf0ad04623b5a4$var$checked(obj.length) | 0;
        var buf = $7cdf0ad04623b5a4$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $7cdf0ad04623b5a4$var$numberIsNaN(obj.length)) return $7cdf0ad04623b5a4$var$createBuffer(0);
        return $7cdf0ad04623b5a4$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $7cdf0ad04623b5a4$var$fromArrayLike(obj.data);
}
function $7cdf0ad04623b5a4$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7cdf0ad04623b5a4$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7cdf0ad04623b5a4$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $7cdf0ad04623b5a4$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7cdf0ad04623b5a4$var$Buffer.alloc(+length);
}
$7cdf0ad04623b5a4$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $7cdf0ad04623b5a4$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$7cdf0ad04623b5a4$var$Buffer.compare = function compare(a, b) {
    if ($7cdf0ad04623b5a4$var$isInstance(a, Uint8Array)) a = $7cdf0ad04623b5a4$var$Buffer.from(a, a.offset, a.byteLength);
    if ($7cdf0ad04623b5a4$var$isInstance(b, Uint8Array)) b = $7cdf0ad04623b5a4$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(a) || !$7cdf0ad04623b5a4$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7cdf0ad04623b5a4$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$7cdf0ad04623b5a4$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7cdf0ad04623b5a4$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7cdf0ad04623b5a4$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($7cdf0ad04623b5a4$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(buf)) buf = $7cdf0ad04623b5a4$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7cdf0ad04623b5a4$var$byteLength(string, encoding) {
    if ($7cdf0ad04623b5a4$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $7cdf0ad04623b5a4$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $7cdf0ad04623b5a4$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $7cdf0ad04623b5a4$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $7cdf0ad04623b5a4$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7cdf0ad04623b5a4$var$Buffer.byteLength = $7cdf0ad04623b5a4$var$byteLength;
function $7cdf0ad04623b5a4$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $7cdf0ad04623b5a4$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $7cdf0ad04623b5a4$var$utf8Slice(this, start, end);
        case 'ascii':
            return $7cdf0ad04623b5a4$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $7cdf0ad04623b5a4$var$latin1Slice(this, start, end);
        case 'base64':
            return $7cdf0ad04623b5a4$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7cdf0ad04623b5a4$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$7cdf0ad04623b5a4$var$Buffer.prototype._isBuffer = true;
function $7cdf0ad04623b5a4$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$7cdf0ad04623b5a4$var$swap(this, i, i + 1);
    return this;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $7cdf0ad04623b5a4$var$swap(this, i, i + 3);
        $7cdf0ad04623b5a4$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $7cdf0ad04623b5a4$var$swap(this, i, i + 7);
        $7cdf0ad04623b5a4$var$swap(this, i + 1, i + 6);
        $7cdf0ad04623b5a4$var$swap(this, i + 2, i + 5);
        $7cdf0ad04623b5a4$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $7cdf0ad04623b5a4$var$utf8Slice(this, 0, length);
    return $7cdf0ad04623b5a4$var$slowToString.apply(this, arguments);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.toLocaleString = $7cdf0ad04623b5a4$var$Buffer.prototype.toString;
$7cdf0ad04623b5a4$var$Buffer.prototype.equals = function equals(b) {
    if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $7cdf0ad04623b5a4$var$Buffer.compare(this, b) === 0;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $7cdf0ad04623b5a4$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($7cdf0ad04623b5a4$var$customInspectSymbol) $7cdf0ad04623b5a4$var$Buffer.prototype[$7cdf0ad04623b5a4$var$customInspectSymbol] = $7cdf0ad04623b5a4$var$Buffer.prototype.inspect;
$7cdf0ad04623b5a4$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($7cdf0ad04623b5a4$var$isInstance(target, Uint8Array)) target = $7cdf0ad04623b5a4$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7cdf0ad04623b5a4$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($7cdf0ad04623b5a4$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $7cdf0ad04623b5a4$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7cdf0ad04623b5a4$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7cdf0ad04623b5a4$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7cdf0ad04623b5a4$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $7cdf0ad04623b5a4$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7cdf0ad04623b5a4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7cdf0ad04623b5a4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7cdf0ad04623b5a4$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($7cdf0ad04623b5a4$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7cdf0ad04623b5a4$var$utf8Write(buf, string, offset, length) {
    return $7cdf0ad04623b5a4$var$blitBuffer($7cdf0ad04623b5a4$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7cdf0ad04623b5a4$var$asciiWrite(buf, string, offset, length) {
    return $7cdf0ad04623b5a4$var$blitBuffer($7cdf0ad04623b5a4$var$asciiToBytes(string), buf, offset, length);
}
function $7cdf0ad04623b5a4$var$base64Write(buf, string, offset, length) {
    return $7cdf0ad04623b5a4$var$blitBuffer($7cdf0ad04623b5a4$var$base64ToBytes(string), buf, offset, length);
}
function $7cdf0ad04623b5a4$var$ucs2Write(buf, string, offset, length) {
    return $7cdf0ad04623b5a4$var$blitBuffer($7cdf0ad04623b5a4$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7cdf0ad04623b5a4$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $7cdf0ad04623b5a4$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $7cdf0ad04623b5a4$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $7cdf0ad04623b5a4$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $7cdf0ad04623b5a4$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7cdf0ad04623b5a4$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7cdf0ad04623b5a4$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7cdf0ad04623b5a4$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $7cdf0ad04623b5a4$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7cdf0ad04623b5a4$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7cdf0ad04623b5a4$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7cdf0ad04623b5a4$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7cdf0ad04623b5a4$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7cdf0ad04623b5a4$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7cdf0ad04623b5a4$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7cdf0ad04623b5a4$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7cdf0ad04623b5a4$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $7cdf0ad04623b5a4$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $7cdf0ad04623b5a4$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $7cdf0ad04623b5a4$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7cdf0ad04623b5a4$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$7cdf0ad04623b5a4$var$Buffer.prototype.readUintLE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUintBE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUint8 = $7cdf0ad04623b5a4$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUint16LE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUint16BE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUint32LE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readUint32BE = $7cdf0ad04623b5a4$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readBigUInt64LE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $7cdf0ad04623b5a4$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $7cdf0ad04623b5a4$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$7cdf0ad04623b5a4$var$Buffer.prototype.readBigUInt64BE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $7cdf0ad04623b5a4$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $7cdf0ad04623b5a4$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$7cdf0ad04623b5a4$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readBigInt64LE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $7cdf0ad04623b5a4$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $7cdf0ad04623b5a4$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$7cdf0ad04623b5a4$var$Buffer.prototype.readBigInt64BE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $7cdf0ad04623b5a4$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $7cdf0ad04623b5a4$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$7cdf0ad04623b5a4$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $7cdf0ad04623b5a4$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUintLE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7cdf0ad04623b5a4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUintBE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7cdf0ad04623b5a4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUint8 = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUint16LE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUint16BE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUint32LE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeUint32BE = $7cdf0ad04623b5a4$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $7cdf0ad04623b5a4$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $7cdf0ad04623b5a4$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $7cdf0ad04623b5a4$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $7cdf0ad04623b5a4$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.writeBigUInt64LE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $7cdf0ad04623b5a4$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$7cdf0ad04623b5a4$var$Buffer.prototype.writeBigUInt64BE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $7cdf0ad04623b5a4$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$7cdf0ad04623b5a4$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7cdf0ad04623b5a4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7cdf0ad04623b5a4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeBigInt64LE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $7cdf0ad04623b5a4$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$7cdf0ad04623b5a4$var$Buffer.prototype.writeBigInt64BE = $7cdf0ad04623b5a4$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $7cdf0ad04623b5a4$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $7cdf0ad04623b5a4$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $7cdf0ad04623b5a4$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7cdf0ad04623b5a4$var$writeFloat(this, value, offset, true, noAssert);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7cdf0ad04623b5a4$var$writeFloat(this, value, offset, false, noAssert);
};
function $7cdf0ad04623b5a4$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7cdf0ad04623b5a4$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7cdf0ad04623b5a4$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7cdf0ad04623b5a4$var$writeDouble(this, value, offset, true, noAssert);
};
$7cdf0ad04623b5a4$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7cdf0ad04623b5a4$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7cdf0ad04623b5a4$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$7cdf0ad04623b5a4$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7cdf0ad04623b5a4$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$7cdf0ad04623b5a4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7cdf0ad04623b5a4$var$Buffer.isBuffer(val) ? val : $7cdf0ad04623b5a4$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $7cdf0ad04623b5a4$var$errors = {};
function $7cdf0ad04623b5a4$var$E(sym, getMessage, Base) {
    $7cdf0ad04623b5a4$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$7cdf0ad04623b5a4$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$7cdf0ad04623b5a4$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$7cdf0ad04623b5a4$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $7cdf0ad04623b5a4$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $7cdf0ad04623b5a4$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $7cdf0ad04623b5a4$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $7cdf0ad04623b5a4$var$checkBounds(buf, offset, byteLength) {
    $7cdf0ad04623b5a4$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $7cdf0ad04623b5a4$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $7cdf0ad04623b5a4$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $7cdf0ad04623b5a4$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $7cdf0ad04623b5a4$var$checkBounds(buf, offset, byteLength);
}
function $7cdf0ad04623b5a4$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $7cdf0ad04623b5a4$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $7cdf0ad04623b5a4$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $7cdf0ad04623b5a4$var$validateNumber(value, type);
        throw new $7cdf0ad04623b5a4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $7cdf0ad04623b5a4$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $7cdf0ad04623b5a4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $7cdf0ad04623b5a4$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $7cdf0ad04623b5a4$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($7cdf0ad04623b5a4$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $7cdf0ad04623b5a4$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $7cdf0ad04623b5a4$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7cdf0ad04623b5a4$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7cdf0ad04623b5a4$var$base64ToBytes(str) {
    return $abUaD.toByteArray($7cdf0ad04623b5a4$var$base64clean(str));
}
function $7cdf0ad04623b5a4$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $7cdf0ad04623b5a4$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $7cdf0ad04623b5a4$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $7cdf0ad04623b5a4$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $7cdf0ad04623b5a4$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $7cdf0ad04623b5a4$var$BufferBigIntNotDefined : fn;
}
function $7cdf0ad04623b5a4$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("v3qKH", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $05d58e96aa192add$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $05d58e96aa192add$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("8L76f", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $aIGzY = parcelRequire("aIGzY");

var $8Uwak = parcelRequire("8Uwak");
var $6608385c1e4e68bf$var$format = $8Uwak.format, $6608385c1e4e68bf$var$inspect = $8Uwak.inspect;

var $ahgAy = parcelRequire("ahgAy");
var $6608385c1e4e68bf$var$ERR_INVALID_ARG_TYPE = $ahgAy.codes.ERR_INVALID_ARG_TYPE;

var $v3qKH = parcelRequire("v3qKH");
var $6608385c1e4e68bf$var$kResistStopPropagation = $v3qKH.kResistStopPropagation, $6608385c1e4e68bf$var$AggregateError = $v3qKH.AggregateError, $6608385c1e4e68bf$var$SymbolDispose = $v3qKH.SymbolDispose;

var $6608385c1e4e68bf$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $6608385c1e4e68bf$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $6608385c1e4e68bf$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $6608385c1e4e68bf$var$Blob = globalThis.Blob || $aIGzY.Blob;
/* eslint-disable indent */ var $6608385c1e4e68bf$var$isBlob = typeof $6608385c1e4e68bf$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $6608385c1e4e68bf$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $6608385c1e4e68bf$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $6608385c1e4e68bf$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $6608385c1e4e68bf$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $6608385c1e4e68bf$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $6608385c1e4e68bf$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $6608385c1e4e68bf$var$format,
    inspect: $6608385c1e4e68bf$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $6608385c1e4e68bf$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $6608385c1e4e68bf$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $6608385c1e4e68bf$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $6608385c1e4e68bf$var$validateAbortSignal(signal, 'signal');
        $6608385c1e4e68bf$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $6608385c1e4e68bf$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $6608385c1e4e68bf$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $6608385c1e4e68bf$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $6608385c1e4e68bf$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $6608385c1e4e68bf$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("8Uwak", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("ahgAy", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $8Uwak = parcelRequire("8Uwak");
var $77b85c0eed0247af$var$format = $8Uwak.format, $77b85c0eed0247af$var$inspect = $8Uwak.inspect;

var $v3qKH = parcelRequire("v3qKH");
var $77b85c0eed0247af$var$CustomAggregateError = $v3qKH.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $77b85c0eed0247af$var$AggregateError = globalThis.AggregateError || $77b85c0eed0247af$var$CustomAggregateError;
var $77b85c0eed0247af$var$kIsNodeError = Symbol('kIsNodeError');
var $77b85c0eed0247af$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $77b85c0eed0247af$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $77b85c0eed0247af$var$nodeInternalPrefix = '__node_internal_';
var $77b85c0eed0247af$var$codes = {};
function $77b85c0eed0247af$var$assert(value, message) {
    if (!value) throw new $77b85c0eed0247af$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $77b85c0eed0247af$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $77b85c0eed0247af$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $77b85c0eed0247af$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $77b85c0eed0247af$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $77b85c0eed0247af$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $77b85c0eed0247af$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $77b85c0eed0247af$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$77b85c0eed0247af$var$kIsNodeError] = true;
    $77b85c0eed0247af$var$codes[code] = NodeError;
}
function $77b85c0eed0247af$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $77b85c0eed0247af$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $77b85c0eed0247af$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $77b85c0eed0247af$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $77b85c0eed0247af$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $77b85c0eed0247af$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$77b85c0eed0247af$var$E('ERR_ASSERTION', '%s', Error);
$77b85c0eed0247af$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $77b85c0eed0247af$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $77b85c0eed0247af$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($77b85c0eed0247af$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($77b85c0eed0247af$var$classRegExp.test(value)) instances.push(value);
            else {
                $77b85c0eed0247af$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $77b85c0eed0247af$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $77b85c0eed0247af$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$77b85c0eed0247af$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $77b85c0eed0247af$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$77b85c0eed0247af$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$77b85c0eed0247af$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $77b85c0eed0247af$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$77b85c0eed0247af$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $77b85c0eed0247af$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $77b85c0eed0247af$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $77b85c0eed0247af$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $77b85c0eed0247af$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$77b85c0eed0247af$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$77b85c0eed0247af$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$77b85c0eed0247af$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$77b85c0eed0247af$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$77b85c0eed0247af$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $77b85c0eed0247af$var$AbortError,
    aggregateTwoErrors: $77b85c0eed0247af$var$hideStackFrames($77b85c0eed0247af$var$aggregateTwoErrors),
    hideStackFrames: $77b85c0eed0247af$var$hideStackFrames,
    codes: $77b85c0eed0247af$var$codes
};

});


parcelRegister("5iYAX", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $3dcda31fd61333f5$export$42af8c323be37587; }, function (v) { return $3dcda31fd61333f5$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $3dcda31fd61333f5$export$f405f72c701dad87; }, function (v) { return $3dcda31fd61333f5$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $3dcda31fd61333f5$export$42af8c323be37587;
var $3dcda31fd61333f5$export$f405f72c701dad87;
'use strict';

var $3dcda31fd61333f5$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $ahgAy = parcelRequire("ahgAy");
var $3dcda31fd61333f5$var$_require_codes = $ahgAy.codes, $3dcda31fd61333f5$var$ERR_INVALID_ARG_VALUE = $3dcda31fd61333f5$var$_require_codes.ERR_INVALID_ARG_VALUE, $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE = $3dcda31fd61333f5$var$_require_codes.ERR_INVALID_ARG_TYPE, $3dcda31fd61333f5$var$ERR_MISSING_ARGS = $3dcda31fd61333f5$var$_require_codes.ERR_MISSING_ARGS, $3dcda31fd61333f5$var$ERR_OUT_OF_RANGE = $3dcda31fd61333f5$var$_require_codes.ERR_OUT_OF_RANGE, $3dcda31fd61333f5$var$AbortError = $ahgAy.AbortError;

var $40Ktl = parcelRequire("40Ktl");
var $3dcda31fd61333f5$var$validateAbortSignal = $40Ktl.validateAbortSignal, $3dcda31fd61333f5$var$validateInteger = $40Ktl.validateInteger, $3dcda31fd61333f5$var$validateObject = $40Ktl.validateObject;

var $3dcda31fd61333f5$var$kWeakHandler = (parcelRequire("v3qKH")).Symbol('kWeak');

var $3dcda31fd61333f5$var$kResistStopPropagation = (parcelRequire("v3qKH")).Symbol('kResistStopPropagation');

var $2JzI0 = parcelRequire("2JzI0");
var $3dcda31fd61333f5$require$finished = $2JzI0.finished;

var $5AZNL = parcelRequire("5AZNL");

var $4ojGs = parcelRequire("4ojGs");
var $3dcda31fd61333f5$require$addAbortSignalNoValidate = $4ojGs.addAbortSignalNoValidate;

var $8gLGB = parcelRequire("8gLGB");
var $3dcda31fd61333f5$var$isWritable = $8gLGB.isWritable, $3dcda31fd61333f5$var$isNodeStream = $8gLGB.isNodeStream;

var $3dcda31fd61333f5$require$deprecate = (parcelRequire("8L76f")).deprecate;

var $3dcda31fd61333f5$var$ArrayPrototypePush = (parcelRequire("v3qKH")).ArrayPrototypePush, $3dcda31fd61333f5$var$Boolean = (parcelRequire("v3qKH")).Boolean, $3dcda31fd61333f5$var$MathFloor = (parcelRequire("v3qKH")).MathFloor, $3dcda31fd61333f5$var$Number = (parcelRequire("v3qKH")).Number, $3dcda31fd61333f5$var$NumberIsNaN = (parcelRequire("v3qKH")).NumberIsNaN, $3dcda31fd61333f5$var$Promise = (parcelRequire("v3qKH")).Promise, $3dcda31fd61333f5$var$PromiseReject = (parcelRequire("v3qKH")).PromiseReject, $3dcda31fd61333f5$var$PromiseResolve = (parcelRequire("v3qKH")).PromiseResolve, $3dcda31fd61333f5$var$PromisePrototypeThen = (parcelRequire("v3qKH")).PromisePrototypeThen, $3dcda31fd61333f5$var$Symbol = (parcelRequire("v3qKH")).Symbol;
var $3dcda31fd61333f5$var$kEmpty = $3dcda31fd61333f5$var$Symbol('kEmpty');
var $3dcda31fd61333f5$var$kEof = $3dcda31fd61333f5$var$Symbol('kEof');
function $3dcda31fd61333f5$var$compose(stream, options) {
    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
    if ($3dcda31fd61333f5$var$isNodeStream(stream) && !$3dcda31fd61333f5$var$isWritable(stream)) throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $5AZNL(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $3dcda31fd61333f5$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $3dcda31fd61333f5$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $3dcda31fd61333f5$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $3dcda31fd61333f5$var$MathFloor(options.highWaterMark);
    $3dcda31fd61333f5$var$validateInteger(concurrency, 'options.concurrency', 1);
    $3dcda31fd61333f5$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $3dcda31fd61333f5$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $3dcda31fd61333f5$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $3dcda31fd61333f5$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $3dcda31fd61333f5$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $3dcda31fd61333f5$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($3dcda31fd61333f5$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $3dcda31fd61333f5$var$PromiseReject(err1);
                                $3dcda31fd61333f5$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("8L76f")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($3dcda31fd61333f5$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $3dcda31fd61333f5$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                        if (!(val !== $3dcda31fd61333f5$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $3dcda31fd61333f5$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3dcda31fd61333f5$var$asIndexedPairs(options) {
    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $3dcda31fd61333f5$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3dcda31fd61333f5$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3dcda31fd61333f5$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $3dcda31fd61333f5$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $3dcda31fd61333f5$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $3dcda31fd61333f5$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3dcda31fd61333f5$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $3dcda31fd61333f5$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $3dcda31fd61333f5$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($3dcda31fd61333f5$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $3dcda31fd61333f5$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $3dcda31fd61333f5$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $3dcda31fd61333f5$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $3dcda31fd61333f5$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($3dcda31fd61333f5$var$ERR_MISSING_ARGS);
function $3dcda31fd61333f5$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $3dcda31fd61333f5$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $3dcda31fd61333f5$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $3dcda31fd61333f5$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $3dcda31fd61333f5$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $3dcda31fd61333f5$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $3dcda31fd61333f5$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $3dcda31fd61333f5$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $3dcda31fd61333f5$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $3dcda31fd61333f5$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $3dcda31fd61333f5$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $3dcda31fd61333f5$var$flatMap(fn, options) {
    var values = $3dcda31fd61333f5$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $3dcda31fd61333f5$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $3dcda31fd61333f5$var$Number(number);
    if ($3dcda31fd61333f5$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $3dcda31fd61333f5$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $3dcda31fd61333f5$var$drop(number, options) {
    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
    number = $3dcda31fd61333f5$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $3dcda31fd61333f5$var$take(number, options) {
    if (options != null) $3dcda31fd61333f5$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $3dcda31fd61333f5$var$validateAbortSignal(options.signal, 'options.signal');
    number = $3dcda31fd61333f5$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $3dcda31fd61333f5$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$3dcda31fd61333f5$export$42af8c323be37587 = {
    asIndexedPairs: $3dcda31fd61333f5$require$deprecate($3dcda31fd61333f5$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $3dcda31fd61333f5$var$drop,
    filter: $3dcda31fd61333f5$var$filter,
    flatMap: $3dcda31fd61333f5$var$flatMap,
    map: $3dcda31fd61333f5$var$map,
    take: $3dcda31fd61333f5$var$take,
    compose: $3dcda31fd61333f5$var$compose
};
$3dcda31fd61333f5$export$f405f72c701dad87 = {
    every: $3dcda31fd61333f5$var$every,
    forEach: $3dcda31fd61333f5$var$forEach,
    reduce: $3dcda31fd61333f5$var$reduce,
    toArray: $3dcda31fd61333f5$var$toArray,
    some: $3dcda31fd61333f5$var$some,
    find: $3dcda31fd61333f5$var$find
};

});
parcelRegister("40Ktl", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $2ebb35f696c9d198$var$ArrayIsArray = $v3qKH.ArrayIsArray, $2ebb35f696c9d198$var$ArrayPrototypeIncludes = $v3qKH.ArrayPrototypeIncludes, $2ebb35f696c9d198$var$ArrayPrototypeJoin = $v3qKH.ArrayPrototypeJoin, $2ebb35f696c9d198$var$ArrayPrototypeMap = $v3qKH.ArrayPrototypeMap, $2ebb35f696c9d198$var$NumberIsInteger = $v3qKH.NumberIsInteger, $2ebb35f696c9d198$var$NumberIsNaN = $v3qKH.NumberIsNaN, $2ebb35f696c9d198$var$NumberMAX_SAFE_INTEGER = $v3qKH.NumberMAX_SAFE_INTEGER, $2ebb35f696c9d198$var$NumberMIN_SAFE_INTEGER = $v3qKH.NumberMIN_SAFE_INTEGER, $2ebb35f696c9d198$var$NumberParseInt = $v3qKH.NumberParseInt, $2ebb35f696c9d198$var$ObjectPrototypeHasOwnProperty = $v3qKH.ObjectPrototypeHasOwnProperty, $2ebb35f696c9d198$var$RegExpPrototypeExec = $v3qKH.RegExpPrototypeExec, $2ebb35f696c9d198$var$String = $v3qKH.String, $2ebb35f696c9d198$var$StringPrototypeToUpperCase = $v3qKH.StringPrototypeToUpperCase, $2ebb35f696c9d198$var$StringPrototypeTrim = $v3qKH.StringPrototypeTrim;

var $ahgAy = parcelRequire("ahgAy");
var $2ebb35f696c9d198$var$hideStackFrames = $ahgAy.hideStackFrames, $2ebb35f696c9d198$var$_require_codes = $ahgAy.codes, $2ebb35f696c9d198$var$ERR_SOCKET_BAD_PORT = $2ebb35f696c9d198$var$_require_codes.ERR_SOCKET_BAD_PORT, $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE = $2ebb35f696c9d198$var$_require_codes.ERR_INVALID_ARG_TYPE, $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE = $2ebb35f696c9d198$var$_require_codes.ERR_INVALID_ARG_VALUE, $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE = $2ebb35f696c9d198$var$_require_codes.ERR_OUT_OF_RANGE, $2ebb35f696c9d198$var$ERR_UNKNOWN_SIGNAL = $2ebb35f696c9d198$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $8L76f = parcelRequire("8L76f");
var $2ebb35f696c9d198$require$normalizeEncoding = $8L76f.normalizeEncoding;

var $8L76f = parcelRequire("8L76f");
var $2ebb35f696c9d198$require$_require_types = $8L76f.types;
var $2ebb35f696c9d198$var$isAsyncFunction = $2ebb35f696c9d198$require$_require_types.isAsyncFunction, $2ebb35f696c9d198$var$isArrayBufferView = $2ebb35f696c9d198$require$_require_types.isArrayBufferView;
var $2ebb35f696c9d198$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2ebb35f696c9d198$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2ebb35f696c9d198$var$isUint32(value) {
    return value === value >>> 0;
}
var $2ebb35f696c9d198$var$octalReg = /^[0-7]+$/;
var $2ebb35f696c9d198$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $2ebb35f696c9d198$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($2ebb35f696c9d198$var$RegExpPrototypeExec($2ebb35f696c9d198$var$octalReg, value) === null) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE(name, value, $2ebb35f696c9d198$var$modeDesc);
        value = $2ebb35f696c9d198$var$NumberParseInt(value, 8);
    }
    $2ebb35f696c9d198$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $2ebb35f696c9d198$var$validateInteger = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2ebb35f696c9d198$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $2ebb35f696c9d198$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2ebb35f696c9d198$var$NumberIsInteger(value)) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $2ebb35f696c9d198$var$validateInt32 = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2ebb35f696c9d198$var$NumberIsInteger(value)) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $2ebb35f696c9d198$var$validateUint32 = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2ebb35f696c9d198$var$NumberIsInteger(value)) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $2ebb35f696c9d198$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $2ebb35f696c9d198$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $2ebb35f696c9d198$var$NumberIsNaN(value)) throw new $2ebb35f696c9d198$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $2ebb35f696c9d198$var$validateOneOf = $2ebb35f696c9d198$var$hideStackFrames(function(value, name, oneOf) {
    if (!$2ebb35f696c9d198$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $2ebb35f696c9d198$var$ArrayPrototypeJoin($2ebb35f696c9d198$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $2ebb35f696c9d198$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $2ebb35f696c9d198$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $2ebb35f696c9d198$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$2ebb35f696c9d198$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $2ebb35f696c9d198$var$validateObject = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $2ebb35f696c9d198$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $2ebb35f696c9d198$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $2ebb35f696c9d198$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $2ebb35f696c9d198$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $2ebb35f696c9d198$var$validateDictionary = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $2ebb35f696c9d198$var$validateArray = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$2ebb35f696c9d198$var$ArrayIsArray(value)) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $2ebb35f696c9d198$var$validateStringArray(value, name) {
    $2ebb35f696c9d198$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2ebb35f696c9d198$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $2ebb35f696c9d198$var$validateBooleanArray(value, name) {
    $2ebb35f696c9d198$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2ebb35f696c9d198$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $2ebb35f696c9d198$var$validateAbortSignalArray(value, name) {
    $2ebb35f696c9d198$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $2ebb35f696c9d198$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $2ebb35f696c9d198$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $2ebb35f696c9d198$var$validateString(signal, name);
    if ($2ebb35f696c9d198$var$signals[signal] === undefined) {
        if ($2ebb35f696c9d198$var$signals[$2ebb35f696c9d198$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $2ebb35f696c9d198$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $2ebb35f696c9d198$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $2ebb35f696c9d198$var$validateBuffer = $2ebb35f696c9d198$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$2ebb35f696c9d198$var$isArrayBufferView(buffer)) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $2ebb35f696c9d198$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $2ebb35f696c9d198$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $2ebb35f696c9d198$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $2ebb35f696c9d198$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $2ebb35f696c9d198$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $2ebb35f696c9d198$var$validateAbortSignal = $2ebb35f696c9d198$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $2ebb35f696c9d198$var$validateFunction = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $2ebb35f696c9d198$var$validatePlainFunction = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $2ebb35f696c9d198$var$isAsyncFunction(value)) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $2ebb35f696c9d198$var$validateUndefined = $2ebb35f696c9d198$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $2ebb35f696c9d198$var$validateUnion(value, name, union) {
    if (!$2ebb35f696c9d198$var$ArrayPrototypeIncludes(union, value)) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_TYPE(name, "('".concat($2ebb35f696c9d198$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $2ebb35f696c9d198$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $2ebb35f696c9d198$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$2ebb35f696c9d198$var$RegExpPrototypeExec($2ebb35f696c9d198$var$linkValueRegExp, value)) throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $2ebb35f696c9d198$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $2ebb35f696c9d198$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($2ebb35f696c9d198$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $2ebb35f696c9d198$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $2ebb35f696c9d198$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $2ebb35f696c9d198$var$isInt32,
    isUint32: $2ebb35f696c9d198$var$isUint32,
    parseFileMode: $2ebb35f696c9d198$var$parseFileMode,
    validateArray: $2ebb35f696c9d198$var$validateArray,
    validateStringArray: $2ebb35f696c9d198$var$validateStringArray,
    validateBooleanArray: $2ebb35f696c9d198$var$validateBooleanArray,
    validateAbortSignalArray: $2ebb35f696c9d198$var$validateAbortSignalArray,
    validateBoolean: $2ebb35f696c9d198$var$validateBoolean,
    validateBuffer: $2ebb35f696c9d198$var$validateBuffer,
    validateDictionary: $2ebb35f696c9d198$var$validateDictionary,
    validateEncoding: $2ebb35f696c9d198$var$validateEncoding,
    validateFunction: $2ebb35f696c9d198$var$validateFunction,
    validateInt32: $2ebb35f696c9d198$var$validateInt32,
    validateInteger: $2ebb35f696c9d198$var$validateInteger,
    validateNumber: $2ebb35f696c9d198$var$validateNumber,
    validateObject: $2ebb35f696c9d198$var$validateObject,
    validateOneOf: $2ebb35f696c9d198$var$validateOneOf,
    validatePlainFunction: $2ebb35f696c9d198$var$validatePlainFunction,
    validatePort: $2ebb35f696c9d198$var$validatePort,
    validateSignalName: $2ebb35f696c9d198$var$validateSignalName,
    validateString: $2ebb35f696c9d198$var$validateString,
    validateUint32: $2ebb35f696c9d198$var$validateUint32,
    validateUndefined: $2ebb35f696c9d198$var$validateUndefined,
    validateUnion: $2ebb35f696c9d198$var$validateUnion,
    validateAbortSignal: $2ebb35f696c9d198$var$validateAbortSignal,
    validateLinkHeaderValue: $2ebb35f696c9d198$var$validateLinkHeaderValue
};

});

parcelRegister("2JzI0", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $ahgAy = parcelRequire("ahgAy");
/* replacement end */ var $1fdb7bc62735339a$var$AbortError = $ahgAy.AbortError, $1fdb7bc62735339a$var$codes = $ahgAy.codes;
var $1fdb7bc62735339a$var$ERR_INVALID_ARG_TYPE = $1fdb7bc62735339a$var$codes.ERR_INVALID_ARG_TYPE, $1fdb7bc62735339a$var$ERR_STREAM_PREMATURE_CLOSE = $1fdb7bc62735339a$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $1fdb7bc62735339a$var$kEmptyObject = (parcelRequire("8L76f")).kEmptyObject, $1fdb7bc62735339a$var$once = (parcelRequire("8L76f")).once;

var $40Ktl = parcelRequire("40Ktl");
var $1fdb7bc62735339a$var$validateAbortSignal = $40Ktl.validateAbortSignal, $1fdb7bc62735339a$var$validateFunction = $40Ktl.validateFunction, $1fdb7bc62735339a$var$validateObject = $40Ktl.validateObject, $1fdb7bc62735339a$var$validateBoolean = $40Ktl.validateBoolean;

var $v3qKH = parcelRequire("v3qKH");
var $1fdb7bc62735339a$var$Promise = $v3qKH.Promise, $1fdb7bc62735339a$var$PromisePrototypeThen = $v3qKH.PromisePrototypeThen, $1fdb7bc62735339a$var$SymbolDispose = $v3qKH.SymbolDispose;

var $8gLGB = parcelRequire("8gLGB");
var $1fdb7bc62735339a$var$isClosed = $8gLGB.isClosed, $1fdb7bc62735339a$var$isReadable = $8gLGB.isReadable, $1fdb7bc62735339a$var$isReadableNodeStream = $8gLGB.isReadableNodeStream, $1fdb7bc62735339a$var$isReadableStream = $8gLGB.isReadableStream, $1fdb7bc62735339a$var$isReadableFinished = $8gLGB.isReadableFinished, $1fdb7bc62735339a$var$isReadableErrored = $8gLGB.isReadableErrored, $1fdb7bc62735339a$var$isWritable = $8gLGB.isWritable, $1fdb7bc62735339a$var$isWritableNodeStream = $8gLGB.isWritableNodeStream, $1fdb7bc62735339a$var$isWritableStream = $8gLGB.isWritableStream, $1fdb7bc62735339a$var$isWritableFinished = $8gLGB.isWritableFinished, $1fdb7bc62735339a$var$isWritableErrored = $8gLGB.isWritableErrored, $1fdb7bc62735339a$var$isNodeStream = $8gLGB.isNodeStream, $1fdb7bc62735339a$var$_willEmitClose = $8gLGB.willEmitClose, $1fdb7bc62735339a$var$kIsClosedPromise = $8gLGB.kIsClosedPromise;
var $1fdb7bc62735339a$var$addAbortListener;
function $1fdb7bc62735339a$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $1fdb7bc62735339a$var$nop = function() {};

function $1fdb7bc62735339a$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $1fdb7bc62735339a$var$kEmptyObject;
    } else if (options == null) options = $1fdb7bc62735339a$var$kEmptyObject;
    else $1fdb7bc62735339a$var$validateObject(options, 'options');
    $1fdb7bc62735339a$var$validateFunction(callback, 'callback');
    $1fdb7bc62735339a$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $1fdb7bc62735339a$var$once(callback);
    if ($1fdb7bc62735339a$var$isReadableStream(stream) || $1fdb7bc62735339a$var$isWritableStream(stream)) return $1fdb7bc62735339a$var$eosWeb(stream, options, callback);
    if (!$1fdb7bc62735339a$var$isNodeStream(stream)) throw new $1fdb7bc62735339a$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $1fdb7bc62735339a$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $1fdb7bc62735339a$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $1fdb7bc62735339a$var$_willEmitClose(stream) && $1fdb7bc62735339a$var$isReadableNodeStream(stream) === readable && $1fdb7bc62735339a$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $1fdb7bc62735339a$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $1fdb7bc62735339a$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $1fdb7bc62735339a$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $1fdb7bc62735339a$var$isWritableErrored(stream) || $1fdb7bc62735339a$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $1fdb7bc62735339a$var$isReadableNodeStream(stream, true)) {
            if (!$1fdb7bc62735339a$var$isReadableFinished(stream, false)) return callback.call(stream, new $1fdb7bc62735339a$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$1fdb7bc62735339a$var$isWritableFinished(stream, false)) return callback.call(stream, new $1fdb7bc62735339a$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $1fdb7bc62735339a$var$isWritableErrored(stream) || $1fdb7bc62735339a$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($1fdb7bc62735339a$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $1fdb7bc62735339a$var$isReadable(stream)) && (writableFinished || $1fdb7bc62735339a$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $1fdb7bc62735339a$var$isWritable(stream)) && (readableFinished || $1fdb7bc62735339a$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $1fdb7bc62735339a$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $1fdb7bc62735339a$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $1fdb7bc62735339a$var$addAbortListener = $1fdb7bc62735339a$var$addAbortListener || (parcelRequire("8L76f")).addAbortListener;
            var disposable = $1fdb7bc62735339a$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $1fdb7bc62735339a$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$1fdb7bc62735339a$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $1fdb7bc62735339a$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $1fdb7bc62735339a$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $1fdb7bc62735339a$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $1fdb7bc62735339a$var$addAbortListener = $1fdb7bc62735339a$var$addAbortListener || (parcelRequire("8L76f")).addAbortListener;
            var disposable = $1fdb7bc62735339a$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $1fdb7bc62735339a$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$1fdb7bc62735339a$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $1fdb7bc62735339a$var$PromisePrototypeThen(stream[$1fdb7bc62735339a$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $1fdb7bc62735339a$var$nop;
}
function $1fdb7bc62735339a$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $1fdb7bc62735339a$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $1fdb7bc62735339a$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $1fdb7bc62735339a$var$Promise(function(resolve, reject) {
        var cleanup = $1fdb7bc62735339a$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $1fdb7bc62735339a$var$eos;
module.exports.finished = $1fdb7bc62735339a$var$finished;

});
parcelRegister("8gLGB", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $6054ced05a1bae19$var$SymbolAsyncIterator = $v3qKH.SymbolAsyncIterator, $6054ced05a1bae19$var$SymbolIterator = $v3qKH.SymbolIterator, $6054ced05a1bae19$var$SymbolFor = $v3qKH.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $6054ced05a1bae19$var$kIsDestroyed = $6054ced05a1bae19$var$SymbolFor('nodejs.stream.destroyed');
var $6054ced05a1bae19$var$kIsErrored = $6054ced05a1bae19$var$SymbolFor('nodejs.stream.errored');
var $6054ced05a1bae19$var$kIsReadable = $6054ced05a1bae19$var$SymbolFor('nodejs.stream.readable');
var $6054ced05a1bae19$var$kIsWritable = $6054ced05a1bae19$var$SymbolFor('nodejs.stream.writable');
var $6054ced05a1bae19$var$kIsDisturbed = $6054ced05a1bae19$var$SymbolFor('nodejs.stream.disturbed');
var $6054ced05a1bae19$var$kIsClosedPromise = $6054ced05a1bae19$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $6054ced05a1bae19$var$kControllerErrorFunction = $6054ced05a1bae19$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $6054ced05a1bae19$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $6054ced05a1bae19$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $6054ced05a1bae19$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $6054ced05a1bae19$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $6054ced05a1bae19$var$isReadableStream(obj) {
    return !!(obj && !$6054ced05a1bae19$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $6054ced05a1bae19$var$isWritableStream(obj) {
    return !!(obj && !$6054ced05a1bae19$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $6054ced05a1bae19$var$isTransformStream(obj) {
    return !!(obj && !$6054ced05a1bae19$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $6054ced05a1bae19$var$isWebStream(obj) {
    return $6054ced05a1bae19$var$isReadableStream(obj) || $6054ced05a1bae19$var$isWritableStream(obj) || $6054ced05a1bae19$var$isTransformStream(obj);
}
function $6054ced05a1bae19$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$6054ced05a1bae19$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$6054ced05a1bae19$var$SymbolIterator] === 'function';
    return typeof obj[$6054ced05a1bae19$var$SymbolAsyncIterator] === 'function' || typeof obj[$6054ced05a1bae19$var$SymbolIterator] === 'function';
}
function $6054ced05a1bae19$var$isDestroyed(stream) {
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$6054ced05a1bae19$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $6054ced05a1bae19$var$isWritableEnded(stream) {
    if (!$6054ced05a1bae19$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $6054ced05a1bae19$var$isWritableFinished(stream, strict) {
    if (!$6054ced05a1bae19$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $6054ced05a1bae19$var$isReadableEnded(stream) {
    if (!$6054ced05a1bae19$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $6054ced05a1bae19$var$isReadableFinished(stream, strict) {
    if (!$6054ced05a1bae19$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $6054ced05a1bae19$var$isReadable(stream) {
    if (stream && stream[$6054ced05a1bae19$var$kIsReadable] != null) return stream[$6054ced05a1bae19$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($6054ced05a1bae19$var$isDestroyed(stream)) return false;
    return $6054ced05a1bae19$var$isReadableNodeStream(stream) && stream.readable && !$6054ced05a1bae19$var$isReadableFinished(stream);
}
function $6054ced05a1bae19$var$isWritable(stream) {
    if (stream && stream[$6054ced05a1bae19$var$kIsWritable] != null) return stream[$6054ced05a1bae19$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($6054ced05a1bae19$var$isDestroyed(stream)) return false;
    return $6054ced05a1bae19$var$isWritableNodeStream(stream) && stream.writable && !$6054ced05a1bae19$var$isWritableEnded(stream);
}
function $6054ced05a1bae19$var$isFinished(stream, opts) {
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    if ($6054ced05a1bae19$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $6054ced05a1bae19$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $6054ced05a1bae19$var$isWritable(stream)) return false;
    return true;
}
function $6054ced05a1bae19$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $6054ced05a1bae19$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $6054ced05a1bae19$var$isClosed(stream) {
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $6054ced05a1bae19$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $6054ced05a1bae19$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $6054ced05a1bae19$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $6054ced05a1bae19$var$isOutgoingMessage(stream);
}
function $6054ced05a1bae19$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $6054ced05a1bae19$var$willEmitClose(stream) {
    if (!$6054ced05a1bae19$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $6054ced05a1bae19$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $6054ced05a1bae19$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$6054ced05a1bae19$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $6054ced05a1bae19$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$6054ced05a1bae19$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $6054ced05a1bae19$var$isDestroyed,
    kIsDestroyed: $6054ced05a1bae19$var$kIsDestroyed,
    isDisturbed: $6054ced05a1bae19$var$isDisturbed,
    kIsDisturbed: $6054ced05a1bae19$var$kIsDisturbed,
    isErrored: $6054ced05a1bae19$var$isErrored,
    kIsErrored: $6054ced05a1bae19$var$kIsErrored,
    isReadable: $6054ced05a1bae19$var$isReadable,
    kIsReadable: $6054ced05a1bae19$var$kIsReadable,
    kIsClosedPromise: $6054ced05a1bae19$var$kIsClosedPromise,
    kControllerErrorFunction: $6054ced05a1bae19$var$kControllerErrorFunction,
    kIsWritable: $6054ced05a1bae19$var$kIsWritable,
    isClosed: $6054ced05a1bae19$var$isClosed,
    isDuplexNodeStream: $6054ced05a1bae19$var$isDuplexNodeStream,
    isFinished: $6054ced05a1bae19$var$isFinished,
    isIterable: $6054ced05a1bae19$var$isIterable,
    isReadableNodeStream: $6054ced05a1bae19$var$isReadableNodeStream,
    isReadableStream: $6054ced05a1bae19$var$isReadableStream,
    isReadableEnded: $6054ced05a1bae19$var$isReadableEnded,
    isReadableFinished: $6054ced05a1bae19$var$isReadableFinished,
    isReadableErrored: $6054ced05a1bae19$var$isReadableErrored,
    isNodeStream: $6054ced05a1bae19$var$isNodeStream,
    isWebStream: $6054ced05a1bae19$var$isWebStream,
    isWritable: $6054ced05a1bae19$var$isWritable,
    isWritableNodeStream: $6054ced05a1bae19$var$isWritableNodeStream,
    isWritableStream: $6054ced05a1bae19$var$isWritableStream,
    isWritableEnded: $6054ced05a1bae19$var$isWritableEnded,
    isWritableFinished: $6054ced05a1bae19$var$isWritableFinished,
    isWritableErrored: $6054ced05a1bae19$var$isWritableErrored,
    isServerRequest: $6054ced05a1bae19$var$isServerRequest,
    isServerResponse: $6054ced05a1bae19$var$isServerResponse,
    willEmitClose: $6054ced05a1bae19$var$willEmitClose,
    isTransformStream: $6054ced05a1bae19$var$isTransformStream
};

});


parcelRegister("5AZNL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $kRkns = parcelRequire("kRkns");
var $41304113509f1113$require$pipeline = $kRkns.pipeline;

var $74J3X = parcelRequire("74J3X");

var $EVPNo = parcelRequire("EVPNo");
var $41304113509f1113$require$destroyer = $EVPNo.destroyer;

var $8gLGB = parcelRequire("8gLGB");
var $41304113509f1113$var$isNodeStream = $8gLGB.isNodeStream, $41304113509f1113$var$isReadable = $8gLGB.isReadable, $41304113509f1113$var$isWritable = $8gLGB.isWritable, $41304113509f1113$var$isWebStream = $8gLGB.isWebStream, $41304113509f1113$var$isTransformStream = $8gLGB.isTransformStream, $41304113509f1113$var$isWritableStream = $8gLGB.isWritableStream, $41304113509f1113$var$isReadableStream = $8gLGB.isReadableStream;

var $ahgAy = parcelRequire("ahgAy");
var $41304113509f1113$var$AbortError = $ahgAy.AbortError, $41304113509f1113$var$_require_codes = $ahgAy.codes, $41304113509f1113$var$ERR_INVALID_ARG_VALUE = $41304113509f1113$var$_require_codes.ERR_INVALID_ARG_VALUE, $41304113509f1113$var$ERR_MISSING_ARGS = $41304113509f1113$var$_require_codes.ERR_MISSING_ARGS;

var $2JzI0 = parcelRequire("2JzI0");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $41304113509f1113$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $74J3X.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $74J3X.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $74J3X.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$41304113509f1113$var$isNodeStream(streams[n]) && !$41304113509f1113$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($41304113509f1113$var$isReadable(streams[n]) || $41304113509f1113$var$isReadableStream(streams[n]) || $41304113509f1113$var$isTransformStream(streams[n]))) throw new $41304113509f1113$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($41304113509f1113$var$isWritable(streams[n]) || $41304113509f1113$var$isWritableStream(streams[n]) || $41304113509f1113$var$isTransformStream(streams[n]))) throw new $41304113509f1113$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $41304113509f1113$require$pipeline(streams, onfinished);
    var writable = !!($41304113509f1113$var$isWritable(head) || $41304113509f1113$var$isWritableStream(head) || $41304113509f1113$var$isTransformStream(head));
    var readable = !!($41304113509f1113$var$isReadable(tail) || $41304113509f1113$var$isReadableStream(tail) || $41304113509f1113$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $74J3X({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($41304113509f1113$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($41304113509f1113$var$isWebStream(head)) {
            var writable1 = $41304113509f1113$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $41304113509f1113$var$isTransformStream(tail) ? tail.readable : tail;
        $2JzI0(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($41304113509f1113$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($41304113509f1113$var$isWebStream(tail)) {
            var readable1 = $41304113509f1113$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $41304113509f1113$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($41304113509f1113$var$isNodeStream(tail)) $41304113509f1113$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("kRkns", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $f2f8906b60e93643$var$ArrayIsArray = $v3qKH.ArrayIsArray, $f2f8906b60e93643$var$Promise = $v3qKH.Promise, $f2f8906b60e93643$var$SymbolAsyncIterator = $v3qKH.SymbolAsyncIterator, $f2f8906b60e93643$var$SymbolDispose = $v3qKH.SymbolDispose;

var $2JzI0 = parcelRequire("2JzI0");

var $f2f8906b60e93643$require$once = (parcelRequire("8L76f")).once;

var $EVPNo = parcelRequire("EVPNo");

var $74J3X = parcelRequire("74J3X");

var $ahgAy = parcelRequire("ahgAy");
var $f2f8906b60e93643$var$aggregateTwoErrors = $ahgAy.aggregateTwoErrors, $f2f8906b60e93643$var$_require_codes = $ahgAy.codes, $f2f8906b60e93643$var$ERR_INVALID_ARG_TYPE = $f2f8906b60e93643$var$_require_codes.ERR_INVALID_ARG_TYPE, $f2f8906b60e93643$var$ERR_INVALID_RETURN_VALUE = $f2f8906b60e93643$var$_require_codes.ERR_INVALID_RETURN_VALUE, $f2f8906b60e93643$var$ERR_MISSING_ARGS = $f2f8906b60e93643$var$_require_codes.ERR_MISSING_ARGS, $f2f8906b60e93643$var$ERR_STREAM_DESTROYED = $f2f8906b60e93643$var$_require_codes.ERR_STREAM_DESTROYED, $f2f8906b60e93643$var$ERR_STREAM_PREMATURE_CLOSE = $f2f8906b60e93643$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $f2f8906b60e93643$var$AbortError = $ahgAy.AbortError;

var $40Ktl = parcelRequire("40Ktl");
var $f2f8906b60e93643$var$validateFunction = $40Ktl.validateFunction, $f2f8906b60e93643$var$validateAbortSignal = $40Ktl.validateAbortSignal;

var $8gLGB = parcelRequire("8gLGB");
var $f2f8906b60e93643$var$isIterable = $8gLGB.isIterable, $f2f8906b60e93643$var$isReadable = $8gLGB.isReadable, $f2f8906b60e93643$var$isReadableNodeStream = $8gLGB.isReadableNodeStream, $f2f8906b60e93643$var$isNodeStream = $8gLGB.isNodeStream, $f2f8906b60e93643$var$isTransformStream = $8gLGB.isTransformStream, $f2f8906b60e93643$var$isWebStream = $8gLGB.isWebStream, $f2f8906b60e93643$var$isReadableStream = $8gLGB.isReadableStream, $f2f8906b60e93643$var$isReadableFinished = $8gLGB.isReadableFinished;

var $f2f8906b60e93643$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $f2f8906b60e93643$var$PassThrough;
var $f2f8906b60e93643$var$Readable;
var $f2f8906b60e93643$var$addAbortListener;
function $f2f8906b60e93643$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $2JzI0(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $EVPNo.destroyer(stream, err || new $f2f8906b60e93643$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $f2f8906b60e93643$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $f2f8906b60e93643$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $f2f8906b60e93643$var$makeAsyncIterable(val) {
    if ($f2f8906b60e93643$var$isIterable(val)) return val;
    else if ($f2f8906b60e93643$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $f2f8906b60e93643$var$fromReadable(val);
    throw new $f2f8906b60e93643$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $f2f8906b60e93643$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$f2f8906b60e93643$var$Readable) $f2f8906b60e93643$var$Readable = (parcelRequire("ikhVC"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($f2f8906b60e93643$var$Readable.prototype[$f2f8906b60e93643$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f2f8906b60e93643$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $f2f8906b60e93643$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $2JzI0(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $f2f8906b60e93643$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $f2f8906b60e93643$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($f2f8906b60e93643$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $f2f8906b60e93643$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $f2f8906b60e93643$var$pipelineImpl(streams, $f2f8906b60e93643$require$once($f2f8906b60e93643$var$popCallback(streams)));
}


function $f2f8906b60e93643$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($f2f8906b60e93643$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $f2f8906b60e93643$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($f2f8906b60e93643$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($f2f8906b60e93643$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$f2f8906b60e93643$var$isIterable(ret)) throw new $f2f8906b60e93643$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($f2f8906b60e93643$var$isIterable(stream) || $f2f8906b60e93643$var$isReadableNodeStream(stream) || $f2f8906b60e93643$var$isTransformStream(stream)) ret = stream;
            else ret = $74J3X.from(stream);
        } else if (typeof stream === 'function') {
            if ($f2f8906b60e93643$var$isTransformStream(ret)) {
                var _ret;
                ret = $f2f8906b60e93643$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $f2f8906b60e93643$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$f2f8906b60e93643$var$isIterable(ret, true)) throw new $f2f8906b60e93643$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$f2f8906b60e93643$var$PassThrough) $f2f8906b60e93643$var$PassThrough = (parcelRequire("eFXFq"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $f2f8906b60e93643$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($f2f8906b60e93643$var$isIterable(ret, true)) {
                    finishCount++;
                    $f2f8906b60e93643$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($f2f8906b60e93643$var$isReadableStream(ret) || $f2f8906b60e93643$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $f2f8906b60e93643$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $f2f8906b60e93643$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $f2f8906b60e93643$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($f2f8906b60e93643$var$isNodeStream(stream)) {
            if ($f2f8906b60e93643$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $f2f8906b60e93643$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($f2f8906b60e93643$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($f2f8906b60e93643$var$isTransformStream(ret) || $f2f8906b60e93643$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $f2f8906b60e93643$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($f2f8906b60e93643$var$isIterable(ret)) {
                finishCount++;
                $f2f8906b60e93643$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $f2f8906b60e93643$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($f2f8906b60e93643$var$isWebStream(stream)) {
            if ($f2f8906b60e93643$var$isReadableNodeStream(ret)) {
                finishCount++;
                $f2f8906b60e93643$var$pumpToWeb($f2f8906b60e93643$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($f2f8906b60e93643$var$isReadableStream(ret) || $f2f8906b60e93643$var$isIterable(ret)) {
                finishCount++;
                $f2f8906b60e93643$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($f2f8906b60e93643$var$isTransformStream(ret)) {
                finishCount++;
                $f2f8906b60e93643$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $f2f8906b60e93643$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $74J3X.from(stream);
    };
    if (streams.length === 1 && $f2f8906b60e93643$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $f2f8906b60e93643$var$ERR_MISSING_ARGS('streams');
    var ac = new $f2f8906b60e93643$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $f2f8906b60e93643$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $f2f8906b60e93643$var$AbortError());
    }
    $f2f8906b60e93643$var$addAbortListener = $f2f8906b60e93643$var$addAbortListener || (parcelRequire("8L76f")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $f2f8906b60e93643$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$f2f8906b60e93643$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $f2f8906b60e93643$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $f2f8906b60e93643$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($f2f8906b60e93643$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2JzI0(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2JzI0(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $f2f8906b60e93643$var$pipelineImpl,
    pipeline: $f2f8906b60e93643$var$pipeline
};

});
parcelRegister("EVPNo", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $ahgAy = parcelRequire("ahgAy");
/* replacement end */ var $07b099404dccafd5$var$aggregateTwoErrors = $ahgAy.aggregateTwoErrors, $07b099404dccafd5$var$ERR_MULTIPLE_CALLBACK = $ahgAy.codes.ERR_MULTIPLE_CALLBACK, $07b099404dccafd5$var$AbortError = $ahgAy.AbortError;

var $v3qKH = parcelRequire("v3qKH");
var $07b099404dccafd5$require$Symbol = $v3qKH.Symbol;

var $8gLGB = parcelRequire("8gLGB");
var $07b099404dccafd5$var$kIsDestroyed = $8gLGB.kIsDestroyed, $07b099404dccafd5$var$isDestroyed = $8gLGB.isDestroyed, $07b099404dccafd5$var$isFinished = $8gLGB.isFinished, $07b099404dccafd5$var$isServerRequest = $8gLGB.isServerRequest;
var $07b099404dccafd5$var$kDestroy = $07b099404dccafd5$require$Symbol('kDestroy');
var $07b099404dccafd5$var$kConstruct = $07b099404dccafd5$require$Symbol('kConstruct');
function $07b099404dccafd5$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $07b099404dccafd5$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $07b099404dccafd5$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($07b099404dccafd5$var$kDestroy, function(er) {
        $07b099404dccafd5$var$_destroy(this, $07b099404dccafd5$var$aggregateTwoErrors(er, err), cb);
    });
    else $07b099404dccafd5$var$_destroy(this, err, cb);
    return this;
}
function $07b099404dccafd5$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $07b099404dccafd5$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($07b099404dccafd5$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($07b099404dccafd5$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $07b099404dccafd5$var$emitErrorCloseNT(self, err) {
    $07b099404dccafd5$var$emitErrorNT(self, err);
    $07b099404dccafd5$var$emitCloseNT(self);
}
function $07b099404dccafd5$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $07b099404dccafd5$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $07b099404dccafd5$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $07b099404dccafd5$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($07b099404dccafd5$var$emitErrorNT, stream, err);
        else $07b099404dccafd5$var$emitErrorNT(stream, err);
    }
}
function $07b099404dccafd5$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($07b099404dccafd5$var$kConstruct, cb);
    if (stream.listenerCount($07b099404dccafd5$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($07b099404dccafd5$var$constructNT, stream);
}
function $07b099404dccafd5$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $07b099404dccafd5$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $07b099404dccafd5$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($07b099404dccafd5$var$kDestroy, err);
        else if (err) $07b099404dccafd5$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($07b099404dccafd5$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $07b099404dccafd5$var$emitConstructNT(stream) {
    stream.emit($07b099404dccafd5$var$kConstruct);
}
function $07b099404dccafd5$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $07b099404dccafd5$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $07b099404dccafd5$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($07b099404dccafd5$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $07b099404dccafd5$var$destroyer(stream, err) {
    if (!stream || $07b099404dccafd5$var$isDestroyed(stream)) return;
    if (!err && !$07b099404dccafd5$var$isFinished(stream)) err = new $07b099404dccafd5$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($07b099404dccafd5$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($07b099404dccafd5$var$isRequest(stream)) stream.abort();
    else if ($07b099404dccafd5$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($07b099404dccafd5$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($07b099404dccafd5$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$07b099404dccafd5$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $07b099404dccafd5$var$construct,
    destroyer: $07b099404dccafd5$var$destroyer,
    destroy: $07b099404dccafd5$var$destroy,
    undestroy: $07b099404dccafd5$var$undestroy,
    errorOrDestroy: $07b099404dccafd5$var$errorOrDestroy
};

});

parcelRegister("74J3X", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $526bdcaa9aeafd2b$var$ObjectDefineProperties = $v3qKH.ObjectDefineProperties, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor = $v3qKH.ObjectGetOwnPropertyDescriptor, $526bdcaa9aeafd2b$var$ObjectKeys = $v3qKH.ObjectKeys, $526bdcaa9aeafd2b$var$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf;
module.exports = $526bdcaa9aeafd2b$var$Duplex;

var $ikhVC = parcelRequire("ikhVC");

var $115Jk = parcelRequire("115Jk");
$526bdcaa9aeafd2b$var$ObjectSetPrototypeOf($526bdcaa9aeafd2b$var$Duplex.prototype, $ikhVC.prototype);
$526bdcaa9aeafd2b$var$ObjectSetPrototypeOf($526bdcaa9aeafd2b$var$Duplex, $ikhVC);
{
    var $526bdcaa9aeafd2b$var$keys = $526bdcaa9aeafd2b$var$ObjectKeys($115Jk.prototype);
    // Allow the keys array to be GC'ed.
    for(var $526bdcaa9aeafd2b$var$i = 0; $526bdcaa9aeafd2b$var$i < $526bdcaa9aeafd2b$var$keys.length; $526bdcaa9aeafd2b$var$i++){
        var $526bdcaa9aeafd2b$var$method = $526bdcaa9aeafd2b$var$keys[$526bdcaa9aeafd2b$var$i];
        if (!$526bdcaa9aeafd2b$var$Duplex.prototype[$526bdcaa9aeafd2b$var$method]) $526bdcaa9aeafd2b$var$Duplex.prototype[$526bdcaa9aeafd2b$var$method] = $115Jk.prototype[$526bdcaa9aeafd2b$var$method];
    }
}function $526bdcaa9aeafd2b$var$Duplex(options) {
    if (!(this instanceof $526bdcaa9aeafd2b$var$Duplex)) return new $526bdcaa9aeafd2b$var$Duplex(options);
    $ikhVC.call(this, options);
    $115Jk.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$526bdcaa9aeafd2b$var$ObjectDefineProperties($526bdcaa9aeafd2b$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $526bdcaa9aeafd2b$var$ObjectGetOwnPropertyDescriptor($115Jk.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $526bdcaa9aeafd2b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $526bdcaa9aeafd2b$var$lazyWebStreams() {
    if ($526bdcaa9aeafd2b$var$webStreamsAdapters === undefined) $526bdcaa9aeafd2b$var$webStreamsAdapters = {};
    return $526bdcaa9aeafd2b$var$webStreamsAdapters;
}
$526bdcaa9aeafd2b$var$Duplex.fromWeb = function(pair, options) {
    return $526bdcaa9aeafd2b$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$526bdcaa9aeafd2b$var$Duplex.toWeb = function(duplex) {
    return $526bdcaa9aeafd2b$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $526bdcaa9aeafd2b$var$duplexify;

$526bdcaa9aeafd2b$var$Duplex.from = function(body) {
    if (!$526bdcaa9aeafd2b$var$duplexify) $526bdcaa9aeafd2b$var$duplexify = (parcelRequire("kOvLz"));
    return $526bdcaa9aeafd2b$var$duplexify(body, 'body');
};

});
parcelRegister("ikhVC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $v3qKH = parcelRequire("v3qKH");
/* replacement end */ var $d578007384a67159$var$ArrayPrototypeIndexOf = $v3qKH.ArrayPrototypeIndexOf, $d578007384a67159$var$NumberIsInteger = $v3qKH.NumberIsInteger, $d578007384a67159$var$NumberIsNaN = $v3qKH.NumberIsNaN, $d578007384a67159$var$NumberParseInt = $v3qKH.NumberParseInt, $d578007384a67159$var$ObjectDefineProperties = $v3qKH.ObjectDefineProperties, $d578007384a67159$var$ObjectKeys = $v3qKH.ObjectKeys, $d578007384a67159$var$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf, $d578007384a67159$var$Promise = $v3qKH.Promise, $d578007384a67159$var$SafeSet = $v3qKH.SafeSet, $d578007384a67159$var$SymbolAsyncDispose = $v3qKH.SymbolAsyncDispose, $d578007384a67159$var$SymbolAsyncIterator = $v3qKH.SymbolAsyncIterator, $d578007384a67159$var$Symbol = $v3qKH.Symbol;
module.exports = $d578007384a67159$var$Readable;
$d578007384a67159$var$Readable.ReadableState = $d578007384a67159$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $d578007384a67159$var$EE = $bBoAO.EventEmitter;

var $kQQwm = parcelRequire("kQQwm");
var $d578007384a67159$var$Stream = $kQQwm.Stream, $d578007384a67159$var$prependListener = $kQQwm.prependListener;

var $aIGzY = parcelRequire("aIGzY");
var $d578007384a67159$require$Buffer = $aIGzY.Buffer;

var $4ojGs = parcelRequire("4ojGs");
var $d578007384a67159$require$addAbortSignal = $4ojGs.addAbortSignal;

var $2JzI0 = parcelRequire("2JzI0");

var $d578007384a67159$var$debug = (parcelRequire("8L76f")).debuglog('stream', function(fn) {
    $d578007384a67159$var$debug = fn;
});

var $9zAuO = parcelRequire("9zAuO");

var $EVPNo = parcelRequire("EVPNo");

var $gC29b = parcelRequire("gC29b");
var $d578007384a67159$var$getHighWaterMark = $gC29b.getHighWaterMark, $d578007384a67159$var$getDefaultHighWaterMark = $gC29b.getDefaultHighWaterMark;

var $ahgAy = parcelRequire("ahgAy");
var $d578007384a67159$var$aggregateTwoErrors = $ahgAy.aggregateTwoErrors, $d578007384a67159$var$_require_codes = $ahgAy.codes, $d578007384a67159$var$ERR_INVALID_ARG_TYPE = $d578007384a67159$var$_require_codes.ERR_INVALID_ARG_TYPE, $d578007384a67159$var$ERR_METHOD_NOT_IMPLEMENTED = $d578007384a67159$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $d578007384a67159$var$ERR_OUT_OF_RANGE = $d578007384a67159$var$_require_codes.ERR_OUT_OF_RANGE, $d578007384a67159$var$ERR_STREAM_PUSH_AFTER_EOF = $d578007384a67159$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $d578007384a67159$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d578007384a67159$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $d578007384a67159$var$AbortError = $ahgAy.AbortError;

var $40Ktl = parcelRequire("40Ktl");
var $d578007384a67159$require$validateObject = $40Ktl.validateObject;
var $d578007384a67159$var$kPaused = $d578007384a67159$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $d578007384a67159$require$StringDecoder = $3Jf7C.StringDecoder;

var $5CvYW = parcelRequire("5CvYW");
$d578007384a67159$var$ObjectSetPrototypeOf($d578007384a67159$var$Readable.prototype, $d578007384a67159$var$Stream.prototype);
$d578007384a67159$var$ObjectSetPrototypeOf($d578007384a67159$var$Readable, $d578007384a67159$var$Stream);
var $d578007384a67159$var$nop = function() {};
var $d578007384a67159$var$errorOrDestroy = $EVPNo.errorOrDestroy;
var $d578007384a67159$var$kObjectMode = 1;
var $d578007384a67159$var$kEnded = 2;
var $d578007384a67159$var$kEndEmitted = 4;
var $d578007384a67159$var$kReading = 8;
var $d578007384a67159$var$kConstructed = 16;
var $d578007384a67159$var$kSync = 32;
var $d578007384a67159$var$kNeedReadable = 64;
var $d578007384a67159$var$kEmittedReadable = 128;
var $d578007384a67159$var$kReadableListening = 256;
var $d578007384a67159$var$kResumeScheduled = 512;
var $d578007384a67159$var$kErrorEmitted = 1024;
var $d578007384a67159$var$kEmitClose = 2048;
var $d578007384a67159$var$kAutoDestroy = 4096;
var $d578007384a67159$var$kDestroyed = 8192;
var $d578007384a67159$var$kClosed = 16384;
var $d578007384a67159$var$kCloseEmitted = 32768;
var $d578007384a67159$var$kMultiAwaitDrain = 65536;
var $d578007384a67159$var$kReadingMore = 131072;
var $d578007384a67159$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $d578007384a67159$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$d578007384a67159$var$ObjectDefineProperties($d578007384a67159$var$ReadableState.prototype, {
    objectMode: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kObjectMode),
    ended: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kEnded),
    endEmitted: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kEndEmitted),
    reading: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kNeedReadable),
    emittedReadable: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kEmittedReadable),
    readableListening: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kReadableListening),
    resumeScheduled: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kErrorEmitted),
    emitClose: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kEmitClose),
    autoDestroy: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kCloseEmitted),
    multiAwaitDrain: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kReadingMore),
    dataEmitted: $d578007384a67159$var$makeBitMapDescriptor($d578007384a67159$var$kDataEmitted)
});

function $d578007384a67159$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("74J3X"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $d578007384a67159$var$kEmitClose | $d578007384a67159$var$kAutoDestroy | $d578007384a67159$var$kConstructed | $d578007384a67159$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $d578007384a67159$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $d578007384a67159$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $d578007384a67159$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $d578007384a67159$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9zAuO();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$d578007384a67159$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$d578007384a67159$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$d578007384a67159$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $d578007384a67159$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d578007384a67159$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $d578007384a67159$var$Readable)) return new $d578007384a67159$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("74J3X"));
    this._readableState = new $d578007384a67159$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $d578007384a67159$require$addAbortSignal(options.signal, this);
    }
    $d578007384a67159$var$Stream.call(this, options);
    $EVPNo.construct(this, function() {
        if (_this._readableState.needReadable) $d578007384a67159$var$maybeReadMore(_this, _this._readableState);
    });
}
$d578007384a67159$var$Readable.prototype.destroy = $EVPNo.destroy;
$d578007384a67159$var$Readable.prototype._undestroy = $EVPNo.undestroy;
$d578007384a67159$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$d578007384a67159$var$Readable.prototype[$d578007384a67159$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$d578007384a67159$var$Readable.prototype[$d578007384a67159$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $d578007384a67159$var$AbortError();
        this.destroy(error);
    }
    return new $d578007384a67159$var$Promise(function(resolve, reject) {
        return $2JzI0(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d578007384a67159$var$Readable.prototype.push = function(chunk, encoding) {
    return $d578007384a67159$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$d578007384a67159$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $d578007384a67159$var$readableAddChunk(this, chunk, encoding, true);
};
function $d578007384a67159$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $d578007384a67159$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $d578007384a67159$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $d578007384a67159$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $d578007384a67159$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $d578007384a67159$require$Buffer) encoding = '';
        else if ($d578007384a67159$var$Stream._isUint8Array(chunk)) {
            chunk = $d578007384a67159$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $d578007384a67159$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $d578007384a67159$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$d578007384a67159$var$kReading;
        $d578007384a67159$var$onEofChunk(stream, state);
    } else if ((state.state & $d578007384a67159$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $d578007384a67159$var$kEndEmitted) !== 0) $d578007384a67159$var$errorOrDestroy(stream, new $d578007384a67159$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $d578007384a67159$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $d578007384a67159$var$errorOrDestroy(stream, new $d578007384a67159$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$d578007384a67159$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $d578007384a67159$var$addChunk(stream, state, chunk, false);
                else $d578007384a67159$var$maybeReadMore(stream, state);
            } else $d578007384a67159$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$d578007384a67159$var$kReading;
        $d578007384a67159$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d578007384a67159$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $d578007384a67159$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $d578007384a67159$var$kNeedReadable) !== 0) $d578007384a67159$var$emitReadable(stream);
    }
    $d578007384a67159$var$maybeReadMore(stream, state);
}
$d578007384a67159$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$d578007384a67159$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$d578007384a67159$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $d578007384a67159$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$d578007384a67159$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $d578007384a67159$var$MAX_HWM = 0x40000000;
function $d578007384a67159$var$computeNewHighWaterMark(n) {
    if (n > $d578007384a67159$var$MAX_HWM) throw new $d578007384a67159$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d578007384a67159$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $d578007384a67159$var$kObjectMode) !== 0) return 1;
    if ($d578007384a67159$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$d578007384a67159$var$Readable.prototype.read = function(n) {
    $d578007384a67159$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$d578007384a67159$var$NumberIsInteger(n)) n = $d578007384a67159$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d578007384a67159$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$d578007384a67159$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d578007384a67159$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $d578007384a67159$var$endReadable(this);
        else $d578007384a67159$var$emitReadable(this);
        return null;
    }
    n = $d578007384a67159$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d578007384a67159$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $d578007384a67159$var$kNeedReadable) !== 0;
    $d578007384a67159$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d578007384a67159$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $d578007384a67159$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $d578007384a67159$var$debug('do read');
        state.state |= $d578007384a67159$var$kReading | $d578007384a67159$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $d578007384a67159$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $d578007384a67159$var$errorOrDestroy(this, err);
        }
        state.state &= ~$d578007384a67159$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d578007384a67159$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d578007384a67159$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d578007384a67159$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $d578007384a67159$var$onEofChunk(stream, state) {
    $d578007384a67159$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $d578007384a67159$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $d578007384a67159$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d578007384a67159$var$emitReadable(stream) {
    var state = stream._readableState;
    $d578007384a67159$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d578007384a67159$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($d578007384a67159$var$emitReadable_, stream);
    }
}
function $d578007384a67159$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d578007384a67159$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d578007384a67159$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d578007384a67159$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($d578007384a67159$var$maybeReadMore_, stream, state);
    }
}
function $d578007384a67159$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d578007384a67159$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d578007384a67159$var$Readable.prototype._read = function(n) {
    throw new $d578007384a67159$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$d578007384a67159$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $d578007384a67159$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $d578007384a67159$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d578007384a67159$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d578007384a67159$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $d578007384a67159$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $d578007384a67159$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $d578007384a67159$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $d578007384a67159$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $d578007384a67159$var$debug('ondata');
        var ret = dest.write(chunk);
        $d578007384a67159$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d578007384a67159$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $d578007384a67159$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $d578007384a67159$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $d578007384a67159$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $d578007384a67159$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $d578007384a67159$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $d578007384a67159$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $d578007384a67159$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $d578007384a67159$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$d578007384a67159$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $d578007384a67159$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$d578007384a67159$var$Readable.prototype.on = function(ev, fn) {
    var res = $d578007384a67159$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d578007384a67159$var$debug('on readable', state.length, state.reading);
            if (state.length) $d578007384a67159$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($d578007384a67159$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d578007384a67159$var$Readable.prototype.addListener = $d578007384a67159$var$Readable.prototype.on;
$d578007384a67159$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $d578007384a67159$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($d578007384a67159$var$updateReadableListening, this);
    return res;
};
$d578007384a67159$var$Readable.prototype.off = $d578007384a67159$var$Readable.prototype.removeListener;
$d578007384a67159$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $d578007384a67159$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($d578007384a67159$var$updateReadableListening, this);
    return res;
};
function $d578007384a67159$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$d578007384a67159$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $d578007384a67159$var$nReadingNextTick(self) {
    $d578007384a67159$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d578007384a67159$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d578007384a67159$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $d578007384a67159$var$resume(this, state);
    }
    state[$d578007384a67159$var$kPaused] = false;
    return this;
};
function $d578007384a67159$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($d578007384a67159$var$resume_, stream, state);
    }
}
function $d578007384a67159$var$resume_(stream, state) {
    $d578007384a67159$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $d578007384a67159$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d578007384a67159$var$Readable.prototype.pause = function() {
    $d578007384a67159$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d578007384a67159$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$d578007384a67159$var$kPaused] = true;
    return this;
};
function $d578007384a67159$var$flow(stream) {
    var state = stream._readableState;
    $d578007384a67159$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d578007384a67159$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $d578007384a67159$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $d578007384a67159$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$d578007384a67159$var$Readable.prototype[$d578007384a67159$var$SymbolAsyncIterator] = function() {
    return $d578007384a67159$var$streamToAsyncIterator(this);
};
$d578007384a67159$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $d578007384a67159$require$validateObject(options, 'options');
    return $d578007384a67159$var$streamToAsyncIterator(this, options);
};
function $d578007384a67159$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $d578007384a67159$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $d578007384a67159$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $d578007384a67159$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $d578007384a67159$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $d578007384a67159$var$nop;
                    stream.on('readable', next);
                    cleanup = $2JzI0(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $d578007384a67159$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $d578007384a67159$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $d578007384a67159$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $d578007384a67159$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $EVPNo.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$d578007384a67159$var$ObjectDefineProperties($d578007384a67159$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$d578007384a67159$var$ObjectDefineProperties($d578007384a67159$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$d578007384a67159$var$kPaused] !== false;
        },
        set: function(value) {
            this[$d578007384a67159$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$d578007384a67159$var$Readable._fromList = $d578007384a67159$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d578007384a67159$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d578007384a67159$var$endReadable(stream) {
    var state = stream._readableState;
    $d578007384a67159$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($d578007384a67159$var$endReadableNT, state, stream);
    }
}
function $d578007384a67159$var$endReadableNT(state, stream) {
    $d578007384a67159$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($d578007384a67159$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $d578007384a67159$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$d578007384a67159$var$Readable.from = function(iterable, opts) {
    return $5CvYW($d578007384a67159$var$Readable, iterable, opts);
};
var $d578007384a67159$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d578007384a67159$var$lazyWebStreams() {
    if ($d578007384a67159$var$webStreamsAdapters === undefined) $d578007384a67159$var$webStreamsAdapters = {};
    return $d578007384a67159$var$webStreamsAdapters;
}
$d578007384a67159$var$Readable.fromWeb = function(readableStream, options) {
    return $d578007384a67159$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$d578007384a67159$var$Readable.toWeb = function(streamReadable, options) {
    return $d578007384a67159$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$d578007384a67159$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $d578007384a67159$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $EVPNo.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("kQQwm", function(module, exports) {
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $f2e1678f3d68f830$var$ArrayIsArray = $v3qKH.ArrayIsArray, $f2e1678f3d68f830$var$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $f2e1678f3d68f830$var$EE = $bBoAO.EventEmitter;
function $f2e1678f3d68f830$var$Stream(opts) {
    $f2e1678f3d68f830$var$EE.call(this, opts);
}
$f2e1678f3d68f830$var$ObjectSetPrototypeOf($f2e1678f3d68f830$var$Stream.prototype, $f2e1678f3d68f830$var$EE.prototype);
$f2e1678f3d68f830$var$ObjectSetPrototypeOf($f2e1678f3d68f830$var$Stream, $f2e1678f3d68f830$var$EE);
$f2e1678f3d68f830$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($f2e1678f3d68f830$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $f2e1678f3d68f830$var$prependListener(source, 'error', onerror);
    $f2e1678f3d68f830$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $f2e1678f3d68f830$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($f2e1678f3d68f830$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $f2e1678f3d68f830$var$Stream,
    prependListener: $f2e1678f3d68f830$var$prependListener
};

});

parcelRegister("4ojGs", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $3328ac1b6e4e08e9$export$e2db56ee53255a0; }, function (v) { return $3328ac1b6e4e08e9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $3328ac1b6e4e08e9$export$11956e9313f43de0; }, function (v) { return $3328ac1b6e4e08e9$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $3328ac1b6e4e08e9$export$e2db56ee53255a0;
var $3328ac1b6e4e08e9$export$11956e9313f43de0;
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $3328ac1b6e4e08e9$require$SymbolDispose = $v3qKH.SymbolDispose;

var $ahgAy = parcelRequire("ahgAy");
var $3328ac1b6e4e08e9$var$AbortError = $ahgAy.AbortError, $3328ac1b6e4e08e9$var$codes = $ahgAy.codes;

var $8gLGB = parcelRequire("8gLGB");
var $3328ac1b6e4e08e9$var$isNodeStream = $8gLGB.isNodeStream, $3328ac1b6e4e08e9$var$isWebStream = $8gLGB.isWebStream, $3328ac1b6e4e08e9$var$kControllerErrorFunction = $8gLGB.kControllerErrorFunction;

var $2JzI0 = parcelRequire("2JzI0");
var $3328ac1b6e4e08e9$var$ERR_INVALID_ARG_TYPE = $3328ac1b6e4e08e9$var$codes.ERR_INVALID_ARG_TYPE;
var $3328ac1b6e4e08e9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $3328ac1b6e4e08e9$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $3328ac1b6e4e08e9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$3328ac1b6e4e08e9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $3328ac1b6e4e08e9$var$validateAbortSignal(signal, 'signal');
    if (!$3328ac1b6e4e08e9$var$isNodeStream(stream) && !$3328ac1b6e4e08e9$var$isWebStream(stream)) throw new $3328ac1b6e4e08e9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $3328ac1b6e4e08e9$export$11956e9313f43de0(signal, stream);
};

$3328ac1b6e4e08e9$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $3328ac1b6e4e08e9$var$isNodeStream(stream) ? function() {
        stream.destroy(new $3328ac1b6e4e08e9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$3328ac1b6e4e08e9$var$kControllerErrorFunction](new $3328ac1b6e4e08e9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $3328ac1b6e4e08e9$var$addAbortListener = $3328ac1b6e4e08e9$var$addAbortListener || (parcelRequire("8L76f")).addAbortListener;
        var disposable = $3328ac1b6e4e08e9$var$addAbortListener(signal, onAbort);
        $2JzI0(stream, disposable[$3328ac1b6e4e08e9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9zAuO", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $6f83b14b4063a65f$var$StringPrototypeSlice = $v3qKH.StringPrototypeSlice, $6f83b14b4063a65f$var$SymbolIterator = $v3qKH.SymbolIterator, $6f83b14b4063a65f$var$TypedArrayPrototypeSet = $v3qKH.TypedArrayPrototypeSet, $6f83b14b4063a65f$var$Uint8Array = $v3qKH.Uint8Array;

var $aIGzY = parcelRequire("aIGzY");
var $6f83b14b4063a65f$require$Buffer = $aIGzY.Buffer;

var $8L76f = parcelRequire("8L76f");
var $6f83b14b4063a65f$require$inspect = $8L76f.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $6f83b14b4063a65f$require$Buffer.alloc(0);
                var ret = $6f83b14b4063a65f$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $6f83b14b4063a65f$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $6f83b14b4063a65f$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $6f83b14b4063a65f$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $6f83b14b4063a65f$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $6f83b14b4063a65f$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $6f83b14b4063a65f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $6f83b14b4063a65f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $6f83b14b4063a65f$var$TypedArrayPrototypeSet(ret, new $6f83b14b4063a65f$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $6f83b14b4063a65f$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("gC29b", function(module, exports) {
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $c181dc56de32de40$var$MathFloor = $v3qKH.MathFloor, $c181dc56de32de40$var$NumberIsInteger = $v3qKH.NumberIsInteger;

var $40Ktl = parcelRequire("40Ktl");
var $c181dc56de32de40$require$validateInteger = $40Ktl.validateInteger;

var $c181dc56de32de40$var$ERR_INVALID_ARG_VALUE = (parcelRequire("ahgAy")).codes.ERR_INVALID_ARG_VALUE;
var $c181dc56de32de40$var$defaultHighWaterMarkBytes = 16384;
var $c181dc56de32de40$var$defaultHighWaterMarkObjectMode = 16;
function $c181dc56de32de40$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c181dc56de32de40$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $c181dc56de32de40$var$defaultHighWaterMarkObjectMode : $c181dc56de32de40$var$defaultHighWaterMarkBytes;
}
function $c181dc56de32de40$var$setDefaultHighWaterMark(objectMode, value) {
    $c181dc56de32de40$require$validateInteger(value, 'value', 0);
    if (objectMode) $c181dc56de32de40$var$defaultHighWaterMarkObjectMode = value;
    else $c181dc56de32de40$var$defaultHighWaterMarkBytes = value;
}
function $c181dc56de32de40$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c181dc56de32de40$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$c181dc56de32de40$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $c181dc56de32de40$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $c181dc56de32de40$var$MathFloor(hwm);
    }
    // Default value
    return $c181dc56de32de40$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $c181dc56de32de40$var$getHighWaterMark,
    getDefaultHighWaterMark: $c181dc56de32de40$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $c181dc56de32de40$var$setDefaultHighWaterMark
};

});

parcelRegister("5CvYW", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $v3qKH = parcelRequire("v3qKH");
/* replacement end */ var $41794f53eb799798$var$PromisePrototypeThen = $v3qKH.PromisePrototypeThen, $41794f53eb799798$var$SymbolAsyncIterator = $v3qKH.SymbolAsyncIterator, $41794f53eb799798$var$SymbolIterator = $v3qKH.SymbolIterator;

var $aIGzY = parcelRequire("aIGzY");
var $41794f53eb799798$require$Buffer = $aIGzY.Buffer;

var $ahgAy = parcelRequire("ahgAy");
var $41794f53eb799798$require$_require_codes = $ahgAy.codes;
var $41794f53eb799798$var$ERR_INVALID_ARG_TYPE = $41794f53eb799798$require$_require_codes.ERR_INVALID_ARG_TYPE, $41794f53eb799798$var$ERR_STREAM_NULL_VALUES = $41794f53eb799798$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $41794f53eb799798$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $41794f53eb799798$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$41794f53eb799798$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$41794f53eb799798$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$41794f53eb799798$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$41794f53eb799798$var$SymbolIterator]();
    } else throw new $41794f53eb799798$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $41794f53eb799798$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $41794f53eb799798$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $41794f53eb799798$var$from;

});


parcelRegister("115Jk", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $v3qKH = parcelRequire("v3qKH");
/* replacement end */ var $0bda545243bb75d7$var$ArrayPrototypeSlice = $v3qKH.ArrayPrototypeSlice, $0bda545243bb75d7$var$Error = $v3qKH.Error, $0bda545243bb75d7$var$FunctionPrototypeSymbolHasInstance = $v3qKH.FunctionPrototypeSymbolHasInstance, $0bda545243bb75d7$var$ObjectDefineProperty = $v3qKH.ObjectDefineProperty, $0bda545243bb75d7$var$ObjectDefineProperties = $v3qKH.ObjectDefineProperties, $0bda545243bb75d7$var$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf, $0bda545243bb75d7$var$StringPrototypeToLowerCase = $v3qKH.StringPrototypeToLowerCase, $0bda545243bb75d7$var$Symbol = $v3qKH.Symbol, $0bda545243bb75d7$var$SymbolHasInstance = $v3qKH.SymbolHasInstance;
module.exports = $0bda545243bb75d7$var$Writable;
$0bda545243bb75d7$var$Writable.WritableState = $0bda545243bb75d7$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $0bda545243bb75d7$var$EE = $bBoAO.EventEmitter;

var $kQQwm = parcelRequire("kQQwm");
var $0bda545243bb75d7$require$Stream = $kQQwm.Stream;

var $aIGzY = parcelRequire("aIGzY");
var $0bda545243bb75d7$require$Buffer = $aIGzY.Buffer;

var $EVPNo = parcelRequire("EVPNo");

var $4ojGs = parcelRequire("4ojGs");
var $0bda545243bb75d7$require$addAbortSignal = $4ojGs.addAbortSignal;

var $gC29b = parcelRequire("gC29b");
var $0bda545243bb75d7$var$getHighWaterMark = $gC29b.getHighWaterMark, $0bda545243bb75d7$var$getDefaultHighWaterMark = $gC29b.getDefaultHighWaterMark;

var $ahgAy = parcelRequire("ahgAy");
var $0bda545243bb75d7$require$_require_codes = $ahgAy.codes;
var $0bda545243bb75d7$var$ERR_INVALID_ARG_TYPE = $0bda545243bb75d7$require$_require_codes.ERR_INVALID_ARG_TYPE, $0bda545243bb75d7$var$ERR_METHOD_NOT_IMPLEMENTED = $0bda545243bb75d7$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $0bda545243bb75d7$var$ERR_MULTIPLE_CALLBACK = $0bda545243bb75d7$require$_require_codes.ERR_MULTIPLE_CALLBACK, $0bda545243bb75d7$var$ERR_STREAM_CANNOT_PIPE = $0bda545243bb75d7$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $0bda545243bb75d7$var$ERR_STREAM_DESTROYED = $0bda545243bb75d7$require$_require_codes.ERR_STREAM_DESTROYED, $0bda545243bb75d7$var$ERR_STREAM_ALREADY_FINISHED = $0bda545243bb75d7$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $0bda545243bb75d7$var$ERR_STREAM_NULL_VALUES = $0bda545243bb75d7$require$_require_codes.ERR_STREAM_NULL_VALUES, $0bda545243bb75d7$var$ERR_STREAM_WRITE_AFTER_END = $0bda545243bb75d7$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $0bda545243bb75d7$var$ERR_UNKNOWN_ENCODING = $0bda545243bb75d7$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $0bda545243bb75d7$var$errorOrDestroy = $EVPNo.errorOrDestroy;
$0bda545243bb75d7$var$ObjectSetPrototypeOf($0bda545243bb75d7$var$Writable.prototype, $0bda545243bb75d7$require$Stream.prototype);
$0bda545243bb75d7$var$ObjectSetPrototypeOf($0bda545243bb75d7$var$Writable, $0bda545243bb75d7$require$Stream);
function $0bda545243bb75d7$var$nop() {}
var $0bda545243bb75d7$var$kOnFinished = $0bda545243bb75d7$var$Symbol('kOnFinished');

function $0bda545243bb75d7$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("74J3X"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $0bda545243bb75d7$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $0bda545243bb75d7$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $0bda545243bb75d7$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $0bda545243bb75d7$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$0bda545243bb75d7$var$kOnFinished] = [];
}
function $0bda545243bb75d7$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$0bda545243bb75d7$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $0bda545243bb75d7$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$0bda545243bb75d7$var$ObjectDefineProperty($0bda545243bb75d7$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $0bda545243bb75d7$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("74J3X"));
    if (!isDuplex && !$0bda545243bb75d7$var$FunctionPrototypeSymbolHasInstance($0bda545243bb75d7$var$Writable, this)) return new $0bda545243bb75d7$var$Writable(options);
    this._writableState = new $0bda545243bb75d7$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $0bda545243bb75d7$require$addAbortSignal(options.signal, this);
    }
    $0bda545243bb75d7$require$Stream.call(this, options);
    $EVPNo.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $0bda545243bb75d7$var$clearBuffer(_this, state);
        $0bda545243bb75d7$var$finishMaybe(_this, state);
    });
}
$0bda545243bb75d7$var$ObjectDefineProperty($0bda545243bb75d7$var$Writable, $0bda545243bb75d7$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($0bda545243bb75d7$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $0bda545243bb75d7$var$Writable) return false;
        return object && object._writableState instanceof $0bda545243bb75d7$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$0bda545243bb75d7$var$Writable.prototype.pipe = function() {
    $0bda545243bb75d7$var$errorOrDestroy(this, new $0bda545243bb75d7$var$ERR_STREAM_CANNOT_PIPE());
};
function $0bda545243bb75d7$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$0bda545243bb75d7$require$Buffer.isEncoding(encoding)) throw new $0bda545243bb75d7$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $0bda545243bb75d7$var$nop;
    }
    if (chunk === null) throw new $0bda545243bb75d7$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $0bda545243bb75d7$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $0bda545243bb75d7$require$Buffer) encoding = 'buffer';
        else if ($0bda545243bb75d7$require$Stream._isUint8Array(chunk)) {
            chunk = $0bda545243bb75d7$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $0bda545243bb75d7$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $0bda545243bb75d7$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $0bda545243bb75d7$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $0bda545243bb75d7$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $0bda545243bb75d7$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$0bda545243bb75d7$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $0bda545243bb75d7$var$_write(this, chunk, encoding, cb) === true;
};
$0bda545243bb75d7$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$0bda545243bb75d7$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $0bda545243bb75d7$var$clearBuffer(this, state);
    }
};
$0bda545243bb75d7$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $0bda545243bb75d7$var$StringPrototypeToLowerCase(encoding);
    if (!$0bda545243bb75d7$require$Buffer.isEncoding(encoding)) throw new $0bda545243bb75d7$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $0bda545243bb75d7$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $0bda545243bb75d7$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $0bda545243bb75d7$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $0bda545243bb75d7$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $0bda545243bb75d7$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $0bda545243bb75d7$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $0bda545243bb75d7$var$errorOrDestroy(stream, er);
}
function $0bda545243bb75d7$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $0bda545243bb75d7$var$errorOrDestroy(stream, new $0bda545243bb75d7$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($0bda545243bb75d7$var$onwriteError, stream, state, er, cb);
        else $0bda545243bb75d7$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $0bda545243bb75d7$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($0bda545243bb75d7$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $0bda545243bb75d7$var$afterWrite(stream, state, 1, cb);
    }
}
function $0bda545243bb75d7$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $0bda545243bb75d7$var$afterWrite(stream, state, count, cb);
}
function $0bda545243bb75d7$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $0bda545243bb75d7$var$errorBuffer(state);
    $0bda545243bb75d7$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $0bda545243bb75d7$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $0bda545243bb75d7$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$0bda545243bb75d7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $0bda545243bb75d7$var$ERR_STREAM_DESTROYED('end'));
    }
    $0bda545243bb75d7$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $0bda545243bb75d7$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $0bda545243bb75d7$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $0bda545243bb75d7$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $0bda545243bb75d7$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $0bda545243bb75d7$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $0bda545243bb75d7$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $0bda545243bb75d7$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$0bda545243bb75d7$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $0bda545243bb75d7$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$0bda545243bb75d7$var$Writable.prototype._writev = null;
$0bda545243bb75d7$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $0bda545243bb75d7$var$_write(this, chunk, encoding);
        if (ret instanceof $0bda545243bb75d7$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $0bda545243bb75d7$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $0bda545243bb75d7$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $0bda545243bb75d7$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$0bda545243bb75d7$var$kOnFinished].push(cb);
    }
    return this;
};
function $0bda545243bb75d7$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $0bda545243bb75d7$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $0bda545243bb75d7$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $0bda545243bb75d7$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$0bda545243bb75d7$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $0bda545243bb75d7$var$errorOrDestroy(stream, err, state.sync);
        } else if ($0bda545243bb75d7$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($0bda545243bb75d7$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $0bda545243bb75d7$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $0bda545243bb75d7$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $0bda545243bb75d7$var$finishMaybe(stream, state, sync) {
    if ($0bda545243bb75d7$var$needFinish(state)) {
        $0bda545243bb75d7$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($0bda545243bb75d7$var$needFinish(state)) $0bda545243bb75d7$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($0bda545243bb75d7$var$needFinish(state)) {
                state.pendingcb++;
                $0bda545243bb75d7$var$finish(stream, state);
            }
        }
    }
}
function $0bda545243bb75d7$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$0bda545243bb75d7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$0bda545243bb75d7$var$ObjectDefineProperties($0bda545243bb75d7$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $0bda545243bb75d7$var$destroy = $EVPNo.destroy;
$0bda545243bb75d7$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$0bda545243bb75d7$var$kOnFinished].length)) $2Qkr5.nextTick($0bda545243bb75d7$var$errorBuffer, state);
    $0bda545243bb75d7$var$destroy.call(this, err, cb);
    return this;
};
$0bda545243bb75d7$var$Writable.prototype._undestroy = $EVPNo.undestroy;
$0bda545243bb75d7$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$0bda545243bb75d7$var$Writable.prototype[$0bda545243bb75d7$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $0bda545243bb75d7$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0bda545243bb75d7$var$lazyWebStreams() {
    if ($0bda545243bb75d7$var$webStreamsAdapters === undefined) $0bda545243bb75d7$var$webStreamsAdapters = {};
    return $0bda545243bb75d7$var$webStreamsAdapters;
}
$0bda545243bb75d7$var$Writable.fromWeb = function(writableStream, options) {
    return $0bda545243bb75d7$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$0bda545243bb75d7$var$Writable.toWeb = function(streamWritable) {
    return $0bda545243bb75d7$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("kOvLz", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $aIGzY = parcelRequire("aIGzY");

var $8gLGB = parcelRequire("8gLGB");
var $f2711e46bd35cc94$var$isReadable = $8gLGB.isReadable, $f2711e46bd35cc94$var$isWritable = $8gLGB.isWritable, $f2711e46bd35cc94$var$isIterable = $8gLGB.isIterable, $f2711e46bd35cc94$var$isNodeStream = $8gLGB.isNodeStream, $f2711e46bd35cc94$var$isReadableNodeStream = $8gLGB.isReadableNodeStream, $f2711e46bd35cc94$var$isWritableNodeStream = $8gLGB.isWritableNodeStream, $f2711e46bd35cc94$var$isDuplexNodeStream = $8gLGB.isDuplexNodeStream, $f2711e46bd35cc94$var$isReadableStream = $8gLGB.isReadableStream, $f2711e46bd35cc94$var$isWritableStream = $8gLGB.isWritableStream;

var $2JzI0 = parcelRequire("2JzI0");

var $ahgAy = parcelRequire("ahgAy");
var $f2711e46bd35cc94$var$AbortError = $ahgAy.AbortError, $f2711e46bd35cc94$var$_require_codes = $ahgAy.codes, $f2711e46bd35cc94$var$ERR_INVALID_ARG_TYPE = $f2711e46bd35cc94$var$_require_codes.ERR_INVALID_ARG_TYPE, $f2711e46bd35cc94$var$ERR_INVALID_RETURN_VALUE = $f2711e46bd35cc94$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $EVPNo = parcelRequire("EVPNo");
var $f2711e46bd35cc94$require$destroyer = $EVPNo.destroyer;

var $74J3X = parcelRequire("74J3X");

var $ikhVC = parcelRequire("ikhVC");

var $115Jk = parcelRequire("115Jk");

var $8L76f = parcelRequire("8L76f");
var $f2711e46bd35cc94$require$createDeferredPromise = $8L76f.createDeferredPromise;

var $5CvYW = parcelRequire("5CvYW");
var $f2711e46bd35cc94$var$Blob = globalThis.Blob || $aIGzY.Blob;
var $f2711e46bd35cc94$var$isBlob = typeof $f2711e46bd35cc94$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $f2711e46bd35cc94$var$Blob;
} : function isBlob(b) {
    return false;
};

var $f2711e46bd35cc94$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $v3qKH = parcelRequire("v3qKH");
var $f2711e46bd35cc94$require$FunctionPrototypeCall = $v3qKH.FunctionPrototypeCall;
// This is needed for pre node 17.
var $f2711e46bd35cc94$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($74J3X);
module.exports = function duplexify(body, name) {
    if ($f2711e46bd35cc94$var$isDuplexNodeStream(body)) return body;
    if ($f2711e46bd35cc94$var$isReadableNodeStream(body)) return $f2711e46bd35cc94$var$_duplexify({
        readable: body
    });
    if ($f2711e46bd35cc94$var$isWritableNodeStream(body)) return $f2711e46bd35cc94$var$_duplexify({
        writable: body
    });
    if ($f2711e46bd35cc94$var$isNodeStream(body)) return $f2711e46bd35cc94$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($f2711e46bd35cc94$var$isReadableStream(body)) return $f2711e46bd35cc94$var$_duplexify({
        readable: $ikhVC.fromWeb(body)
    });
    if ($f2711e46bd35cc94$var$isWritableStream(body)) return $f2711e46bd35cc94$var$_duplexify({
        writable: $115Jk.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $f2711e46bd35cc94$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($f2711e46bd35cc94$var$isIterable(value)) return $5CvYW($f2711e46bd35cc94$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $f2711e46bd35cc94$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $f2711e46bd35cc94$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $f2711e46bd35cc94$require$destroyer(d, err);
            });
            return d = new $f2711e46bd35cc94$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $f2711e46bd35cc94$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($f2711e46bd35cc94$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($f2711e46bd35cc94$var$isIterable(body)) return $5CvYW($f2711e46bd35cc94$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($f2711e46bd35cc94$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $f2711e46bd35cc94$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $f2711e46bd35cc94$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $f2711e46bd35cc94$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $f2711e46bd35cc94$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $f2711e46bd35cc94$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $f2711e46bd35cc94$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $f2711e46bd35cc94$require$destroyer(d1, err);
        });
        return d1 = new $f2711e46bd35cc94$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $f2711e46bd35cc94$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $f2711e46bd35cc94$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $f2711e46bd35cc94$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $f2711e46bd35cc94$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $f2711e46bd35cc94$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $f2711e46bd35cc94$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $f2711e46bd35cc94$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $ikhVC.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$f2711e46bd35cc94$var$isReadable(r);
    var writable = !!$f2711e46bd35cc94$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $f2711e46bd35cc94$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2JzI0(w, function(err) {
            writable = false;
            if (err) $f2711e46bd35cc94$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2JzI0(r, function(err) {
            readable = false;
            if (err) $f2711e46bd35cc94$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $f2711e46bd35cc94$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $f2711e46bd35cc94$require$destroyer(w, err);
            $f2711e46bd35cc94$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("eFXFq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $aaf32dab5874572a$require$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf;
module.exports = $aaf32dab5874572a$var$PassThrough;

var $kDq98 = parcelRequire("kDq98");
$aaf32dab5874572a$require$ObjectSetPrototypeOf($aaf32dab5874572a$var$PassThrough.prototype, $kDq98.prototype);
$aaf32dab5874572a$require$ObjectSetPrototypeOf($aaf32dab5874572a$var$PassThrough, $kDq98);
function $aaf32dab5874572a$var$PassThrough(options) {
    if (!(this instanceof $aaf32dab5874572a$var$PassThrough)) return new $aaf32dab5874572a$var$PassThrough(options);
    $kDq98.call(this, options);
}
$aaf32dab5874572a$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("kDq98", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $f05bbb499935002f$var$ObjectSetPrototypeOf = $v3qKH.ObjectSetPrototypeOf, $f05bbb499935002f$var$Symbol = $v3qKH.Symbol;
module.exports = $f05bbb499935002f$var$Transform;

var $f05bbb499935002f$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("ahgAy")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $74J3X = parcelRequire("74J3X");

var $gC29b = parcelRequire("gC29b");
var $f05bbb499935002f$require$getHighWaterMark = $gC29b.getHighWaterMark;
$f05bbb499935002f$var$ObjectSetPrototypeOf($f05bbb499935002f$var$Transform.prototype, $74J3X.prototype);
$f05bbb499935002f$var$ObjectSetPrototypeOf($f05bbb499935002f$var$Transform, $74J3X);
var $f05bbb499935002f$var$kCallback = $f05bbb499935002f$var$Symbol('kCallback');
function $f05bbb499935002f$var$Transform(options) {
    if (!(this instanceof $f05bbb499935002f$var$Transform)) return new $f05bbb499935002f$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $f05bbb499935002f$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $74J3X.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$f05bbb499935002f$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $f05bbb499935002f$var$prefinish);
}
function $f05bbb499935002f$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $f05bbb499935002f$var$prefinish() {
    if (this._final !== $f05bbb499935002f$var$_final) $f05bbb499935002f$var$_final.call(this);
}
$f05bbb499935002f$var$Transform.prototype._final = $f05bbb499935002f$var$_final;
$f05bbb499935002f$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $f05bbb499935002f$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$f05bbb499935002f$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$f05bbb499935002f$var$kCallback] = callback;
    });
};
$f05bbb499935002f$var$Transform.prototype._read = function() {
    if (this[$f05bbb499935002f$var$kCallback]) {
        var callback = this[$f05bbb499935002f$var$kCallback];
        this[$f05bbb499935002f$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("ee7vV", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $v3qKH = parcelRequire("v3qKH");
var $a5b8339c867833c1$var$ArrayPrototypePop = $v3qKH.ArrayPrototypePop, $a5b8339c867833c1$var$Promise = $v3qKH.Promise;

var $8gLGB = parcelRequire("8gLGB");
var $a5b8339c867833c1$var$isIterable = $8gLGB.isIterable, $a5b8339c867833c1$var$isNodeStream = $8gLGB.isNodeStream, $a5b8339c867833c1$var$isWebStream = $8gLGB.isWebStream;

var $kRkns = parcelRequire("kRkns");
var $a5b8339c867833c1$var$pl = $kRkns.pipelineImpl;

var $2JzI0 = parcelRequire("2JzI0");
var $a5b8339c867833c1$require$finished = $2JzI0.finished;
parcelRequire("9MhwH");
function $a5b8339c867833c1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $a5b8339c867833c1$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$a5b8339c867833c1$var$isNodeStream(lastArg) && !$a5b8339c867833c1$var$isIterable(lastArg) && !$a5b8339c867833c1$var$isWebStream(lastArg)) {
            var options = $a5b8339c867833c1$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $a5b8339c867833c1$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $a5b8339c867833c1$require$finished,
    pipeline: $a5b8339c867833c1$var$pipeline
};

});



parcelRegister("dDvbT", function(module, exports) {
module.exports = JSON.parse("{\"http://schema.org/\":{\"properties\":{\"additionalType\":{\"subPropertyOf\":\"http://www.w3.org/1999/02/22-rdf-syntax-ns#type\"}}},\"http://microformats.org/profile/hcard\":{}}");

});





parcelRegister("djEjK", function(module, exports) {
"use strict";
var $9b1c52f3931cb4f3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b1c52f3931cb4f3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9b1c52f3931cb4f3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9b1c52f3931cb4f3$var$__exportStar((parcelRequire("8wd2x")), module.exports);

});
parcelRegister("8wd2x", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlRdfa = void 0;

var $6JPXL = parcelRequire("6JPXL");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $jWd6e = parcelRequire("jWd6e");
/**
 * A comunica RDFa RDF Parse Html Actor.
 */ var $633b6d5d6208e19f$var$ActorRdfParseHtmlRdfa = /*#__PURE__*/ function(_bus_rdf_parse_html_1_ActorRdfParseHtml) {
    (0, $i3fW3._)(ActorRdfParseHtmlRdfa, _bus_rdf_parse_html_1_ActorRdfParseHtml);
    function ActorRdfParseHtmlRdfa(args) {
        (0, $jGAMp._)(this, ActorRdfParseHtmlRdfa);
        return (0, $kzDuW._)(this, ActorRdfParseHtmlRdfa, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseHtmlRdfa, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, mediaType, _ref, language, profile, htmlParseListener, onTagEndOld;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        mediaType = action.headers ? action.headers.get('content-type') : null;
                        language = (_ref = action.headers && action.headers.get('content-language')) !== null && _ref !== void 0 ? _ref : undefined;
                        profile = mediaType && mediaType.includes('xml') ? 'xhtml' : 'html';
                        htmlParseListener = new $jWd6e.RdfaParser({
                            dataFactory: dataFactory,
                            baseIRI: action.baseIRI,
                            profile: profile,
                            language: language
                        });
                        htmlParseListener.on('error', action.error);
                        htmlParseListener.on('data', action.emit);
                        // eslint-disable-next-line ts/unbound-method
                        onTagEndOld = htmlParseListener.onEnd;
                        htmlParseListener.onEnd = function() {
                            onTagEndOld.call(htmlParseListener);
                            action.end();
                        };
                        return [
                            2,
                            {
                                htmlParseListener: htmlParseListener
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfParseHtmlRdfa;
}($6JPXL.ActorRdfParseHtml);
module.exports.ActorRdfParseHtmlRdfa = $633b6d5d6208e19f$var$ActorRdfParseHtmlRdfa;

});


parcelRegister("hB6KM", function(module, exports) {
"use strict";
var $ccfb217f7d954164$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ccfb217f7d954164$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ccfb217f7d954164$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ccfb217f7d954164$var$__exportStar((parcelRequire("cH8hX")), module.exports);

});
parcelRegister("cH8hX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksNext = void 0;

var $ekSbN = parcelRequire("ekSbN");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Next RDF Resolve Hypermedia Links Actor.
 */ var $93dfee25faf25d97$var$ActorRdfResolveHypermediaLinksNext = /*#__PURE__*/ function(_bus_rdf_resolve_hypermedia_links_1_ActorRdfResolveHypermediaLinks) {
    (0, $i3fW3._)(ActorRdfResolveHypermediaLinksNext, _bus_rdf_resolve_hypermedia_links_1_ActorRdfResolveHypermediaLinks);
    function ActorRdfResolveHypermediaLinksNext(args) {
        (0, $jGAMp._)(this, ActorRdfResolveHypermediaLinksNext);
        return (0, $kzDuW._)(this, ActorRdfResolveHypermediaLinksNext, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfResolveHypermediaLinksNext, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.metadata.next || action.metadata.next.length === 0) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " requires a 'next' metadata entry."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                links: action.metadata.next.map(function(url) {
                                    return {
                                        url: url
                                    };
                                })
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfResolveHypermediaLinksNext;
}($ekSbN.ActorRdfResolveHypermediaLinks);
module.exports.ActorRdfResolveHypermediaLinksNext = $93dfee25faf25d97$var$ActorRdfResolveHypermediaLinksNext;

});
parcelRegister("ekSbN", function(module, exports) {
"use strict";
var $a6fcf7d454f3df66$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a6fcf7d454f3df66$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a6fcf7d454f3df66$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a6fcf7d454f3df66$var$__exportStar((parcelRequire("9gZiw")), module.exports);

});
parcelRegister("9gZiw", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinks = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-resolve-hypermedia-links events.
 *
 * Actor types:
 * * Input:  IActionRdfResolveHypermediaLinks:      The metadata from which the links should be extracted.
 * * Test:   <none>
 * * Output: IActorRdfResolveHypermediaLinksOutput: The URLs that were detected.
 *
 * @see IActionRdfResolveHypermediaLinks
 * @see IActorRdfResolveHypermediaLinksOutput
 */ var $6c052824fcc396a8$var$ActorRdfResolveHypermediaLinks = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfResolveHypermediaLinks, _core_1_Actor);
    function ActorRdfResolveHypermediaLinks(args) {
        (0, $jGAMp._)(this, ActorRdfResolveHypermediaLinks);
        return (0, $kzDuW._)(this, ActorRdfResolveHypermediaLinks, [
            args
        ]);
    }
    return ActorRdfResolveHypermediaLinks;
}($kNNoa.Actor);
module.exports.ActorRdfResolveHypermediaLinks = $6c052824fcc396a8$var$ActorRdfResolveHypermediaLinks;

});




parcelRegister("cGWfA", function(module, exports) {
"use strict";
var $93d6979b8b8ebe89$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93d6979b8b8ebe89$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93d6979b8b8ebe89$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93d6979b8b8ebe89$var$__exportStar((parcelRequire("4lrFO")), module.exports);

$93d6979b8b8ebe89$var$__exportStar((parcelRequire("6z5Ts")), module.exports);

});
parcelRegister("4lrFO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksQueueFifo = void 0;

var $8fcMG = parcelRequire("8fcMG");

var $kNNoa = parcelRequire("kNNoa");

var $6z5Ts = parcelRequire("6z5Ts");
/**
 * A comunica FIFO RDF Resolve Hypermedia Links Queue Actor.
 */ var $329e96f4fb053a51$var$ActorRdfResolveHypermediaLinksQueueFifo = /*#__PURE__*/ function(_bus_rdf_resolve_hypermedia_links_queue_1_ActorRdfResolveHypermediaLinksQueue) {
    (0, $i3fW3._)(ActorRdfResolveHypermediaLinksQueueFifo, _bus_rdf_resolve_hypermedia_links_queue_1_ActorRdfResolveHypermediaLinksQueue);
    function ActorRdfResolveHypermediaLinksQueueFifo(args) {
        (0, $jGAMp._)(this, ActorRdfResolveHypermediaLinksQueueFifo);
        return (0, $kzDuW._)(this, ActorRdfResolveHypermediaLinksQueueFifo, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfResolveHypermediaLinksQueueFifo, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                linkQueue: new $6z5Ts.LinkQueueFifo()
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfResolveHypermediaLinksQueueFifo;
}($8fcMG.ActorRdfResolveHypermediaLinksQueue);
module.exports.ActorRdfResolveHypermediaLinksQueueFifo = $329e96f4fb053a51$var$ActorRdfResolveHypermediaLinksQueueFifo;

});
parcelRegister("8fcMG", function(module, exports) {
"use strict";
var $6009a41b6fe7ec34$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6009a41b6fe7ec34$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6009a41b6fe7ec34$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6009a41b6fe7ec34$var$__exportStar((parcelRequire("cQpV5")), module.exports);

$6009a41b6fe7ec34$var$__exportStar((parcelRequire("c598A")), module.exports);

$6009a41b6fe7ec34$var$__exportStar((parcelRequire("6ErEo")), module.exports);

});
parcelRegister("cQpV5", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksQueue = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-resolve-hypermedia-links-queue events.
 *
 * Actor types:
 * * Input:  IActionRdfResolveHypermediaLinksQueue:      Creates a new {@link ILinkQueue} for the given seed URL.
 * * Test:   <none>
 * * Output: IActorRdfResolveHypermediaLinksQueueOutput: The created {@link ILinkQueue}.
 *
 * @see IActionRdfResolveHypermediaLinksQueue
 * @see IActorRdfResolveHypermediaLinksQueueOutput
 */ var $959e727c859486a3$var$ActorRdfResolveHypermediaLinksQueue = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfResolveHypermediaLinksQueue, _core_1_Actor);
    function ActorRdfResolveHypermediaLinksQueue(args) {
        (0, $jGAMp._)(this, ActorRdfResolveHypermediaLinksQueue);
        return (0, $kzDuW._)(this, ActorRdfResolveHypermediaLinksQueue, [
            args
        ]);
    }
    return ActorRdfResolveHypermediaLinksQueue;
}($kNNoa.Actor);
module.exports.ActorRdfResolveHypermediaLinksQueue = $959e727c859486a3$var$ActorRdfResolveHypermediaLinksQueue;

});

parcelRegister("c598A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6ErEo", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkQueueWrapper = void 0;
/**
 * A link queue that wraps a given link queue.
 */ var $4d7bed52d3ea33dd$var$LinkQueueWrapper = /*#__PURE__*/ function() {
    function LinkQueueWrapper(linkQueue) {
        (0, $jGAMp._)(this, LinkQueueWrapper);
        this.linkQueue = linkQueue;
    }
    (0, $byiyg._)(LinkQueueWrapper, [
        {
            key: "push",
            value: function push(link, parent) {
                return this.linkQueue.push(link, parent);
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.linkQueue.getSize();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.linkQueue.isEmpty();
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.linkQueue.pop();
            }
        },
        {
            key: "peek",
            value: function peek() {
                return this.linkQueue.peek();
            }
        }
    ]);
    return LinkQueueWrapper;
}();
module.exports.LinkQueueWrapper = $4d7bed52d3ea33dd$var$LinkQueueWrapper;

});


parcelRegister("6z5Ts", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkQueueFifo = void 0;
/**
 * A link queue in FIFO (first-in first-out) order.
 */ var $4c7a9549631b499d$var$LinkQueueFifo = /*#__PURE__*/ function() {
    function LinkQueueFifo() {
        (0, $jGAMp._)(this, LinkQueueFifo);
        this.links = [];
    }
    (0, $byiyg._)(LinkQueueFifo, [
        {
            key: "push",
            value: function push(link) {
                this.links.push(link);
                return true;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.links.length;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.links.length === 0;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.links.shift();
            }
        },
        {
            key: "peek",
            value: function peek() {
                return this.links[0];
            }
        }
    ]);
    return LinkQueueFifo;
}();
module.exports.LinkQueueFifo = $4c7a9549631b499d$var$LinkQueueFifo;

});



parcelRegister("blqeN", function(module, exports) {
"use strict";
var $8426021eec2d49a1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8426021eec2d49a1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8426021eec2d49a1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8426021eec2d49a1$var$__exportStar((parcelRequire("kEA5A")), module.exports);

});
parcelRegister("kEA5A", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeN3 = void 0;

var $bxueq = parcelRequire("bxueq");
parcelRequire("29pVS");
var $fmFF3 = parcelRequire("fmFF3");
/**
 * A comunica N3 RDF Serialize Actor.
 */ var $f09389a4744a8c62$var$ActorRdfSerializeN3 = /*#__PURE__*/ function(_bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfSerializeN3, _bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes);
    function ActorRdfSerializeN3(args) {
        (0, $jGAMp._)(this, ActorRdfSerializeN3);
        return (0, $kzDuW._)(this, ActorRdfSerializeN3, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfSerializeN3, [
        {
            key: "runHandle",
            value: function runHandle(action, mediaType) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var writer, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        writer = new $fmFF3.default({
                            format: mediaType
                        });
                        if ('pipe' in action.quadStream) {
                            // Prefer piping if possible, to maintain backpressure
                            action.quadStream.on('error', function(error) {
                                return writer.emit('error', error);
                            });
                            data = action.quadStream.pipe(writer);
                        } else data = writer["import"](action.quadStream);
                        return [
                            2,
                            {
                                data: data,
                                triples: mediaType === 'text/turtle' || mediaType === 'application/n-triples' || mediaType === 'text/n3'
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfSerializeN3;
}($bxueq.ActorRdfSerializeFixedMediaTypes);
module.exports.ActorRdfSerializeN3 = $f09389a4744a8c62$var$ActorRdfSerializeN3;

});
parcelRegister("bxueq", function(module, exports) {
"use strict";
var $866a3a24c1256279$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $866a3a24c1256279$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $866a3a24c1256279$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$866a3a24c1256279$var$__exportStar((parcelRequire("kW8PV")), module.exports);

$866a3a24c1256279$var$__exportStar((parcelRequire("82O3N")), module.exports);

});
parcelRegister("kW8PV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerialize = void 0;

var $2T5vf = parcelRequire("2T5vf");
/**
 * A comunica actor for RDF parse events.
 *
 * Actor types:
 * * Input:  IActionRdfSerialize:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorRdfSerializeOutput: The serialized quads.
 *
 * @see IActionRdfSerialize
 * @see IActorRdfSerializeOutput
 */ var $f3e0142d825e9b1e$var$ActorRdfSerialize = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTyped) {
    (0, $i3fW3._)(ActorRdfSerialize, _actor_abstract_mediatyped_1_ActorAbstractMediaTyped);
    function ActorRdfSerialize(args) {
        (0, $jGAMp._)(this, ActorRdfSerialize);
        return (0, $kzDuW._)(this, ActorRdfSerialize, [
            args
        ]);
    }
    return ActorRdfSerialize;
}($2T5vf.ActorAbstractMediaTyped);
module.exports.ActorRdfSerialize = $f3e0142d825e9b1e$var$ActorRdfSerialize;

});

parcelRegister("82O3N", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeFixedMediaTypes = void 0;

var $2T5vf = parcelRequire("2T5vf");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A base actor for listening to RDF serialize events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionRdfSerializeOrMediaType:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorRdfSerializeOutputOrMediaType: The serialized quads.
 *
 * @see IActionInit
 */ var $5db5578896df2110$var$ActorRdfSerializeFixedMediaTypes = /*#__PURE__*/ function(_actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed) {
    (0, $i3fW3._)(ActorRdfSerializeFixedMediaTypes, _actor_abstract_mediatyped_1_ActorAbstractMediaTypedFixed);
    function ActorRdfSerializeFixedMediaTypes(args) {
        (0, $jGAMp._)(this, ActorRdfSerializeFixedMediaTypes);
        return (0, $kzDuW._)(this, ActorRdfSerializeFixedMediaTypes, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfSerializeFixedMediaTypes, [
        {
            key: "testHandleChecked",
            value: /* eslint-enable max-len */ function testHandleChecked() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfSerializeFixedMediaTypes;
}($2T5vf.ActorAbstractMediaTypedFixed);
module.exports.ActorRdfSerializeFixedMediaTypes = $5db5578896df2110$var$ActorRdfSerializeFixedMediaTypes;

});




parcelRegister("7Vy2O", function(module, exports) {
"use strict";
var $5c5843c73e5fd3bc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5c5843c73e5fd3bc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5c5843c73e5fd3bc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5c5843c73e5fd3bc$var$__exportStar((parcelRequire("kJezi")), module.exports);

});
parcelRegister("kJezi", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeJsonLd = void 0;

var $bxueq = parcelRequire("bxueq");

var $7U3u2 = parcelRequire("7U3u2");
/**
 * A comunica Jsonld RDF Serialize Actor.
 */ var $f1734f944d616100$var$ActorRdfSerializeJsonLd = /*#__PURE__*/ function(_bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfSerializeJsonLd, _bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes);
    function ActorRdfSerializeJsonLd(args) {
        (0, $jGAMp._)(this, ActorRdfSerializeJsonLd);
        return (0, $kzDuW._)(this, ActorRdfSerializeJsonLd, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfSerializeJsonLd, [
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var writer, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        writer = new $7U3u2.JsonLdSerializer({
                            space: ' '.repeat(this.jsonStringifyIndentSpaces)
                        });
                        if ('pipe' in action.quadStream) {
                            // Prefer piping if possible, to maintain backpressure
                            action.quadStream.on('error', function(error) {
                                return writer.emit('error', error);
                            });
                            data = action.quadStream.pipe(writer);
                        } else data = writer["import"](action.quadStream);
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfSerializeJsonLd;
}($bxueq.ActorRdfSerializeFixedMediaTypes);
module.exports.ActorRdfSerializeJsonLd = $f1734f944d616100$var$ActorRdfSerializeJsonLd;

});
parcelRegister("7U3u2", function(module, exports) {
"use strict";
var $5c10771d209760b4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5c10771d209760b4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5c10771d209760b4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5c10771d209760b4$var$__exportStar((parcelRequire("6kPA4")), module.exports);

$5c10771d209760b4$var$__exportStar((parcelRequire("fCsJx")), module.exports);

});
parcelRegister("6kPA4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonLdSerializer = void 0;

var $kR5z5 = parcelRequire("kR5z5");

var $7RPHv = parcelRequire("7RPHv");

var $fCsJx = parcelRequire("fCsJx");

var $4SWYf = parcelRequire("4SWYf");
/**
 * A stream transformer that transforms an {@link RDF.Stream} into a JSON-LD (text) stream.
 */ var $49cc9f37b190a83c$var$JsonLdSerializer = /*#__PURE__*/ function(_readable_stream_1_Transform) {
    (0, $i3fW3._)(JsonLdSerializer, _readable_stream_1_Transform);
    function JsonLdSerializer() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $jGAMp._)(this, JsonLdSerializer);
        var _this;
        _this = (0, $kzDuW._)(this, JsonLdSerializer, [
            {
                objectMode: true
            }
        ]);
        _this.indentation = 0;
        _this.options = options;
        // Parse the context
        if (_this.options.baseIRI && !_this.options.context) _this.options.context = {
            '@base': _this.options.baseIRI
        };
        if (_this.options.context) {
            _this.originalContext = _this.options.context;
            _this.context = new $kR5z5.ContextParser().parse(_this.options.context, {
                baseIRI: _this.options.baseIRI
            });
        } else _this.context = Promise.resolve(new $kR5z5.JsonLdContextNormalized({}));
        return _this;
    }
    (0, $byiyg._)(JsonLdSerializer, [
        {
            /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {NodeJS.EventEmitter} A quad stream.
     */ key: "import",
            value: function _import(stream) {
                var output = new $4SWYf.PassThrough({
                    objectMode: true
                });
                stream.on('error', function(error) {
                    return parsed.emit('error', error);
                });
                stream.on('data', function(data) {
                    return output.push(data);
                });
                stream.on('end', function() {
                    return output.push(null);
                });
                var parsed = output.pipe(new JsonLdSerializer(this.options));
                return parsed;
            }
        },
        {
            /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {string} encoding An (ignored) encoding.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the transformation is done
     * @private
     */ key: "_transform",
            value: function _transform(quad, encoding, callback) {
                var _this = this;
                this.context.then(function(context) {
                    _this.transformQuad(quad, context);
                    callback();
                })["catch"](callback);
            }
        },
        {
            key: "list",
            value: /**
     * Construct a list in an RDF.Term object that can be used
     * inside a quad's object to write into the serializer
     * as a list using the @list keyword.
     * @param {RDF.Quad_Object[]} values A list of values, can be empty.
     * @return {RDF.Quad_Object} A term that should be used in the object position of the quad that is written to the serializer.
     */ function list(values) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, context;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.context
                                ];
                            case 1:
                                context = _state.sent();
                                return [
                                    2,
                                    {
                                        '@list': values.map(function(value) {
                                            return $fCsJx.Util.termToValue(value, context, _this.options);
                                        })
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Called when the incoming stream is closed.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the flushing is done.
     * @private
     */ key: "_flush",
            value: function _flush(callback) {
                // If the stream was empty, ensure that we push the opening array
                if (!this.opened) this.pushDocumentStart();
                if (this.lastPredicate) this.endPredicate();
                if (this.lastSubject) this.endSubject();
                if (this.lastGraph && this.lastGraph.termType !== 'DefaultGraph') this.endGraph();
                this.endDocument();
                return callback(null, null);
            }
        },
        {
            /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {JsonLdContextNormalized} context A context for compacting.
     */ key: "transformQuad",
            value: function transformQuad(quad, context) {
                // Open the array before the first quad
                if (!this.opened) this.pushDocumentStart();
                // Check if the subject equals the last named graph
                // In that case, we can reuse the already-existing @id node
                var lastGraphMatchesSubject = this.lastGraph && this.lastGraph.termType !== 'DefaultGraph' && this.lastGraph.equals(quad.subject);
                // Write graph
                if (!lastGraphMatchesSubject && (!this.lastGraph || !quad.graph.equals(this.lastGraph))) {
                    // Check if the named graph equals the last subject
                    // In that case, we can reuse the already-existing @id node
                    var lastSubjectMatchesGraph = quad.graph.termType !== 'DefaultGraph' && this.lastSubject && this.lastSubject.equals(quad.graph);
                    if (this.lastGraph) {
                        if (this.lastGraph.termType !== 'DefaultGraph') {
                            // The last graph was named
                            this.endPredicate();
                            this.endSubject();
                            this.endGraph(true);
                            lastSubjectMatchesGraph = false; // Special-case to avoid deeper nesting
                        } else // The last graph was default
                        if (!lastSubjectMatchesGraph) {
                            this.endPredicate();
                            this.endSubject(true);
                        } else {
                            this.endPredicate(true);
                            this.lastSubject = null;
                        }
                    }
                    // Push the graph
                    if (quad.graph.termType !== 'DefaultGraph') {
                        if (!lastSubjectMatchesGraph) this.pushId(quad.graph, true, context);
                        this.pushSeparator(this.options.space ? $7RPHv.SeparatorType.GRAPH_FIELD_NONCOMPACT : $7RPHv.SeparatorType.GRAPH_FIELD_COMPACT);
                        this.indentation++;
                    }
                    this.lastGraph = quad.graph;
                }
                // Write subject
                if (!this.lastSubject || !quad.subject.equals(this.lastSubject)) {
                    if (lastGraphMatchesSubject) {
                        this.endPredicate();
                        this.endSubject();
                        this.indentation--;
                        this.pushSeparator($7RPHv.SeparatorType.ARRAY_END_COMMA);
                        this.lastGraph = quad.graph;
                    } else {
                        if (this.lastSubject) {
                            this.endPredicate();
                            this.endSubject(true);
                        }
                        // Open a new node for the new subject
                        this.pushId(quad.subject, true, context);
                    }
                    this.lastSubject = quad.subject;
                }
                // Write predicate
                if (!this.lastPredicate || !quad.predicate.equals(this.lastPredicate)) {
                    if (this.lastPredicate) this.endPredicate(true);
                    // Open a new array for the new predicate
                    this.pushPredicate(quad.predicate, context);
                }
                // Write the object value
                this.pushObject(quad.object, context);
            }
        },
        {
            key: "pushDocumentStart",
            value: function pushDocumentStart() {
                this.opened = true;
                if (this.originalContext && !this.options.excludeContext) {
                    this.pushSeparator($7RPHv.SeparatorType.OBJECT_START);
                    this.indentation++;
                    this.pushSeparator($7RPHv.SeparatorType.CONTEXT_FIELD);
                    this.pushIndented(JSON.stringify(this.originalContext, null, this.options.space) + ',');
                    this.pushSeparator(this.options.space ? $7RPHv.SeparatorType.GRAPH_FIELD_NONCOMPACT : $7RPHv.SeparatorType.GRAPH_FIELD_COMPACT);
                    this.indentation++;
                } else {
                    this.pushSeparator($7RPHv.SeparatorType.ARRAY_START);
                    this.indentation++;
                }
            }
        },
        {
            /**
     * Push the given term as an @id field.
     * @param {Term} term An RDF term.
     * @param startOnNewLine If `{` should start on a new line
     * @param {JsonLdContextNormalized} context The context.
     */ key: "pushId",
            value: function pushId(term, startOnNewLine, context) {
                if (term.termType === 'Quad') this.pushNestedQuad(term, true, context);
                else {
                    var subjectValue = term.termType === 'BlankNode' ? '_:' + term.value : context.compactIri(term.value, false);
                    if (startOnNewLine) this.pushSeparator($7RPHv.SeparatorType.OBJECT_START);
                    else {
                        this.push($7RPHv.SeparatorType.OBJECT_START.label);
                        if (this.options.space) this.push('\n');
                    }
                    this.indentation++;
                    this.pushIndented(this.options.space ? '"@id": "'.concat(subjectValue, '",') : '"@id":"'.concat(subjectValue, '",'));
                }
            }
        },
        {
            /**
     * Push the given predicate field.
     * @param {Term} predicate An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     */ key: "pushPredicate",
            value: function pushPredicate(predicate, context) {
                var property = predicate.value;
                // Convert rdf:type into @type if not disabled.
                if (!this.options.useRdfType && property === $fCsJx.Util.RDF_TYPE) {
                    property = '@type';
                    this.objectOptions = Object.assign(Object.assign({}, this.options), {
                        compactIds: true,
                        vocab: true
                    });
                }
                // Open array for following objects
                var compactedProperty = context.compactIri(property, true);
                this.pushIndented(this.options.space ? '"'.concat(compactedProperty, '": [') : '"'.concat(compactedProperty, '":['));
                this.indentation++;
                this.lastPredicate = predicate;
            }
        },
        {
            /**
     * Push the given object value.
     * @param {Term} object An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     */ key: "pushObject",
            value: function pushObject(object, context) {
                // Add a comma if we already had an object for this predicate
                if (!this.hadObjectForPredicate) this.hadObjectForPredicate = true;
                else this.pushSeparator($7RPHv.SeparatorType.COMMA);
                // Handle nested quad
                if (object.termType === 'Quad') {
                    var lastLastSubject = this.lastSubject;
                    var lastLastPredicate = this.lastPredicate;
                    this.hadObjectForPredicate = false;
                    this.pushNestedQuad(object, false, context);
                    this.endSubject(false); // Terminate identifier node of nested quad again, since we won't attach additional information to it.
                    this.hadObjectForPredicate = true;
                    this.lastPredicate = lastLastPredicate;
                    this.lastSubject = lastLastSubject;
                    return;
                }
                // Convert the object into a value and push it
                var value;
                try {
                    if (object['@list']) value = object;
                    else value = $fCsJx.Util.termToValue(object, context, this.objectOptions || this.options);
                } catch (e) {
                    return this.emit('error', e);
                }
                this.pushIndented(JSON.stringify(value, null, this.options.space));
            }
        },
        {
            key: "pushNestedQuad",
            value: function pushNestedQuad(nestedQuad, commaAfterSubject, context) {
                // Start a nested quad
                this.pushSeparator($7RPHv.SeparatorType.OBJECT_START);
                this.indentation++;
                this.pushIndented(this.options.space ? '"@id": ' : '"@id":', false);
                // Print the nested quad
                if (nestedQuad.graph.termType !== 'DefaultGraph') this.emit('error', new Error("Found a nested quad with the non-default graph: ".concat(nestedQuad.graph.value)));
                this.pushId(nestedQuad.subject, false, context);
                this.pushPredicate(nestedQuad.predicate, context);
                this.pushObject(nestedQuad.object, context);
                this.endPredicate(false);
                this.endSubject(commaAfterSubject);
            }
        },
        {
            key: "endDocument",
            value: function endDocument() {
                this.opened = false;
                if (this.originalContext && !this.options.excludeContext) {
                    this.indentation--;
                    this.pushSeparator($7RPHv.SeparatorType.ARRAY_END);
                    this.indentation--;
                    this.pushSeparator($7RPHv.SeparatorType.OBJECT_END);
                } else {
                    this.indentation--;
                    this.pushSeparator($7RPHv.SeparatorType.ARRAY_END);
                }
            }
        },
        {
            /**
     * Push the end of a predicate and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ key: "endPredicate",
            value: function endPredicate(comma) {
                // Close the predicate array
                this.indentation--;
                this.pushSeparator(comma ? $7RPHv.SeparatorType.ARRAY_END_COMMA : $7RPHv.SeparatorType.ARRAY_END);
                // Reset object buffer
                this.hadObjectForPredicate = false;
                this.objectOptions = null;
                // Reset predicate buffer
                this.lastPredicate = null;
            }
        },
        {
            /**
     * Push the end of a subject and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ key: "endSubject",
            value: function endSubject(comma) {
                // Close the last subject's node;
                this.indentation--;
                this.pushSeparator(comma ? $7RPHv.SeparatorType.OBJECT_END_COMMA : $7RPHv.SeparatorType.OBJECT_END);
                // Reset subject buffer
                this.lastSubject = null;
            }
        },
        {
            /**
     * Push the end of a graph and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ key: "endGraph",
            value: function endGraph(comma) {
                // Close the graph array
                this.indentation--;
                this.pushSeparator($7RPHv.SeparatorType.ARRAY_END);
                // Close the graph id node
                this.indentation--;
                this.pushSeparator(comma ? $7RPHv.SeparatorType.OBJECT_END_COMMA : $7RPHv.SeparatorType.OBJECT_END);
                // Reset graph buffer
                this.lastGraph = null;
            }
        },
        {
            /**
     * Puh the given separator.
     * @param {SeparatorType} type A type of separator.
     */ key: "pushSeparator",
            value: function pushSeparator(type) {
                this.pushIndented(type.label);
            }
        },
        {
            /**
     * An indentation-aware variant of {@link #push}.
     * All strings that are pushed here will be prefixed by {@link #indentation} amount of spaces.
     * @param {string} data A string.
     * @param pushNewLine If a newline should be pushed afterwards.
     */ key: "pushIndented",
            value: function pushIndented(data) {
                var pushNewLine = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var prefix = this.getIndentPrefix();
                var lines = data.split('\n').map(function(line) {
                    return prefix + line;
                }).join('\n');
                this.push(lines);
                if (this.options.space && pushNewLine) this.push('\n');
            }
        },
        {
            /**
     * @return {string} Get the current indentation prefix based on {@link #indentation}.
     */ key: "getIndentPrefix",
            value: function getIndentPrefix() {
                return this.options.space ? this.options.space.repeat(this.indentation) : '';
            }
        }
    ]);
    return JsonLdSerializer;
}($4SWYf.Transform);
module.exports.JsonLdSerializer = $49cc9f37b190a83c$var$JsonLdSerializer;

});
parcelRegister("kR5z5", function(module, exports) {
"use strict";
var $f2ed12f12ace1d67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f2ed12f12ace1d67$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f2ed12f12ace1d67$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("2e3r5")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("6QEYr")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("10M6A")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("aKN7C")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("aPddL")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("3OuQD")), module.exports);

$f2ed12f12ace1d67$var$__exportStar((parcelRequire("46k7F")), module.exports);

});
parcelRegister("2e3r5", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $6QEYr = parcelRequire("6QEYr");

var $10M6A = parcelRequire("10M6A");

var $3OuQD = parcelRequire("3OuQD");

var $46k7F = parcelRequire("46k7F");
/**
 * Parses JSON-LD contexts.
 */ var $19ef8dda0ff9c783$var$ContextParser = /*#__PURE__*/ function() {
    function ContextParser(options) {
        (0, $jGAMp._)(this, ContextParser);
        options = options || {};
        this.documentLoader = options.documentLoader || new $10M6A.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
    (0, $byiyg._)(ContextParser, [
        {
            /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ key: "idifyReverseTerms",
            value: function idifyReverseTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (value['@reverse'] && !value['@id']) {
                                if (typeof value['@reverse'] !== 'string' || $46k7F.Util.isValidKeyword(value['@reverse'])) throw new $6QEYr.ErrorCoded("Invalid @reverse value, must be absolute IRI or blank node: '".concat(value['@reverse'], "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                value = context[key] = Object.assign(Object.assign({}, value), {
                                    '@id': value['@reverse']
                                });
                                value['@id'] = value['@reverse'];
                                if ($46k7F.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                                else value['@reverse'] = true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return context;
            }
        },
        {
            /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ key: "expandPrefixedTerms",
            value: function expandPrefixedTerms(context, expandContentTypeToBase, keys) {
                var contextRaw = context.getContextRaw();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys || Object.keys(contextRaw))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Only expand allowed keys
                        if ($46k7F.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$46k7F.Util.isReservedInternalKeyword(key)) {
                            // Error if we try to alias a keyword to something else.
                            var keyValue = contextRaw[key];
                            if ($46k7F.Util.isPotentialKeyword(key) && $46k7F.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                                if (key !== '@type' || (0, $3KZcf._)(contextRaw[key]) === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $6QEYr.ErrorCoded("Keywords can not be aliased to something else.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $6QEYr.ERROR_CODES.KEYWORD_REDEFINITION);
                            }
                            // Error if we try to alias to an illegal keyword
                            if ($46k7F.Util.ALIAS_RANGE_BLACKLIST.indexOf($46k7F.Util.getContextValueId(keyValue)) >= 0) throw new $6QEYr.ErrorCoded("Aliasing to certain keywords is not allowed.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $6QEYr.ERROR_CODES.INVALID_KEYWORD_ALIAS);
                            // Error if this term was marked as prefix as well
                            if (keyValue && $46k7F.Util.isPotentialKeyword($46k7F.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $6QEYr.ErrorCoded("Tried to use keyword aliases as prefix: '".concat(key, "': '").concat(JSON.stringify(keyValue), "'"), $6QEYr.ERROR_CODES.INVALID_TERM_DEFINITION);
                            // Loop because prefixes might be nested
                            while($46k7F.Util.isPrefixValue(contextRaw[key])){
                                var value = contextRaw[key];
                                var changed = false;
                                if (typeof value === 'string') {
                                    contextRaw[key] = context.expandTerm(value, true);
                                    changed = changed || value !== contextRaw[key];
                                } else {
                                    var id = value['@id'];
                                    var type = value['@type'];
                                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                                    var canAddIdEntry = !('@prefix' in value) || $46k7F.Util.isValidIri(key);
                                    if ('@id' in value) // Use @id value for expansion
                                    {
                                        if (id !== undefined && id !== null && typeof id === 'string') {
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': context.expandTerm(id, true)
                                            });
                                            changed = changed || id !== contextRaw[key]['@id'];
                                        }
                                    } else if (!$46k7F.Util.isPotentialKeyword(key) && canAddIdEntry) {
                                        // Add an explicit @id value based on the expanded key value
                                        var newId = context.expandTerm(key, true);
                                        if (newId !== key) {
                                            // Don't set @id if expansion failed
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': newId
                                            });
                                            changed = true;
                                        }
                                    }
                                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                                        // First check @vocab, then fallback to @base
                                        var expandedType = context.expandTerm(type, true);
                                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                                        if (expandedType !== type) {
                                            changed = true;
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@type': expandedType
                                            });
                                        }
                                    }
                                }
                                if (!changed) break;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ key: "normalize",
            value: function normalize(context, param) {
                var processingMode = param.processingMode, normalizeLanguageTags = param.normalizeLanguageTags;
                // Lowercase language keys in 1.0
                if (normalizeLanguageTags || processingMode === 1.0) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
                            else {
                                var value = context[key];
                                if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                    if (typeof value['@language'] === 'string') {
                                        var lowercase = value['@language'].toLowerCase();
                                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                                            '@language': lowercase
                                        });
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ key: "containersToHash",
            value: function containersToHash(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                                '@container': (0, $cqEAj._)({}, value['@container'], true)
                            });
                            else if (Array.isArray(value['@container'])) {
                                var newValue = {};
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = value['@container'][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var containerValue = _step1.value;
                                        newValue[containerValue] = true;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                context[key] = Object.assign(Object.assign({}, value), {
                                    '@container': newValue
                                });
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ key: "applyScopedProtected",
            value: function applyScopedProtected(context, param, expandOptions) {
                var processingMode = param.processingMode;
                if (processingMode && processingMode >= 1.1) {
                    if (context['@protected']) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var key = _step.value;
                                if ($46k7F.Util.isReservedInternalKeyword(key)) continue;
                                if (!$46k7F.Util.isPotentialKeyword(key) && !$46k7F.Util.isTermProtected(context, key)) {
                                    var value = context[key];
                                    if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                        if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                                        context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@protected': true
                                        });
                                    } else {
                                        // Convert string-based term values to object-based values with @protected: true
                                        context[key] = {
                                            '@id': value,
                                            '@protected': true
                                        };
                                        if ($46k7F.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@prefix': true
                                        });
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        delete context['@protected'];
                    }
                }
            }
        },
        {
            /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ key: "validateKeywordRedefinitions",
            value: function validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if ($46k7F.Util.isTermProtected(contextBefore, key)) {
                            // The entry in the context before will always be in object-mode
                            // If the new entry is in string-mode, convert it to object-mode
                            // before checking if it is identical.
                            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                                '@id': contextAfter[key],
                                '@protected': true
                            };
                            else // We modify this deliberately,
                            // as we need it for the value comparison (they must be identical modulo '@protected')),
                            // and for the fact that this new value will override the first one.
                            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                                '@protected': true
                            });
                            // Error if they are not identical
                            if (!$46k7F.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $6QEYr.ErrorCoded("Attempted to override the protected keyword ".concat(key, " from ").concat(JSON.stringify($46k7F.Util.getContextValueId(contextBefore[key])), " to ").concat(JSON.stringify($46k7F.Util.getContextValueId(contextAfter[key]))), $6QEYr.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ key: "validate",
            value: function validate(context, param) {
                var processingMode = param.processingMode;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Ignore reserved internal keywords.
                        if ($46k7F.Util.isReservedInternalKeyword(key)) continue;
                        // Do not allow empty term
                        if (key === '') throw new $6QEYr.ErrorCoded("The empty term is not allowed, got: '".concat(key, "': '").concat(JSON.stringify(context[key]), "'"), $6QEYr.ERROR_CODES.INVALID_TERM_DEFINITION);
                        var value = context[key];
                        var valueType = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
                        // First check if the key is a keyword
                        if ($46k7F.Util.isPotentialKeyword(key)) {
                            switch(key.substr(1)){
                                case 'vocab':
                                    if (value !== null && valueType !== 'string') throw new $6QEYr.ErrorCoded("Found an invalid @vocab IRI: ".concat(value), $6QEYr.ERROR_CODES.INVALID_VOCAB_MAPPING);
                                    break;
                                case 'base':
                                    if (value !== null && valueType !== 'string') throw new $6QEYr.ErrorCoded("Found an invalid @base IRI: ".concat(context[key]), $6QEYr.ERROR_CODES.INVALID_BASE_IRI);
                                    break;
                                case 'language':
                                    if (value !== null) ContextParser.validateLanguage(value, true, $6QEYr.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                                    break;
                                case 'version':
                                    if (value !== null && valueType !== 'number') throw new $6QEYr.ErrorCoded("Found an invalid @version number: ".concat(value), $6QEYr.ERROR_CODES.INVALID_VERSION_VALUE);
                                    break;
                                case 'direction':
                                    if (value !== null) ContextParser.validateDirection(value, true);
                                    break;
                                case 'propagate':
                                    if (processingMode === 1.0) throw new $6QEYr.ErrorCoded("Found an illegal @propagate keyword: ".concat(value), $6QEYr.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                    if (value !== null && valueType !== 'boolean') throw new $6QEYr.ErrorCoded("Found an invalid @propagate value: ".concat(value), $6QEYr.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                                    break;
                            }
                            // Don't allow keywords to be overridden
                            if ($46k7F.Util.isValidKeyword(key) && $46k7F.Util.isValidKeyword($46k7F.Util.getContextValueId(value))) throw new $6QEYr.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat($46k7F.Util.getContextValueId(value), "'"), $6QEYr.ERROR_CODES.KEYWORD_REDEFINITION);
                            continue;
                        }
                        // Otherwise, consider the key a term
                        if (value !== null) switch(valueType){
                            case 'string':
                                if ($46k7F.Util.getPrefix(value, context) === key) throw new $6QEYr.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                if ($46k7F.Util.isValidIriWeak(key)) {
                                    if (value === '@type') throw new $6QEYr.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(value, "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($46k7F.Util.isValidIri(value) && value !== new $3OuQD.JsonLdContextNormalized(context).expandTerm(key)) throw new $6QEYr.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(value, "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                break;
                            case 'object':
                                if (!$46k7F.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $6QEYr.ErrorCoded("Missing @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Object.keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var objectKey = _step1.value;
                                        var objectValue = value[objectKey];
                                        if (!objectValue) continue;
                                        switch(objectKey){
                                            case '@id':
                                                if ($46k7F.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $6QEYr.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($46k7F.Util.isValidIriWeak(key)) {
                                                    if (objectValue === '@type') throw new $6QEYr.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                                    else if ($46k7F.Util.isValidIri(objectValue) && objectValue !== new $3OuQD.JsonLdContextNormalized(context).expandTerm(key)) throw new $6QEYr.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                                }
                                                if (typeof objectValue !== 'string') throw new $6QEYr.ErrorCoded("Detected non-string @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($46k7F.Util.getPrefix(objectValue, context) === key) throw new $6QEYr.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                                break;
                                            case '@type':
                                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $6QEYr.ErrorCoded("@container: @type only allows @type: @id or @vocab, but got: '".concat(key, "': '").concat(objectValue, "'"), $6QEYr.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (typeof objectValue !== 'string') throw new $6QEYr.ErrorCoded("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"), $6QEYr.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$46k7F.Util.isValidIri(objectValue))) throw new $6QEYr.ErrorCoded("A context @type must be an absolute IRI, found: '".concat(key, "': '").concat(objectValue, "'"), $6QEYr.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                break;
                                            case '@reverse':
                                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $6QEYr.ErrorCoded("Found non-matching @id and @reverse term values in '".concat(key, "':'").concat(objectValue, "' and '").concat(value['@id'], "'"), $6QEYr.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                if ('@nest' in value) throw new $6QEYr.ErrorCoded("@nest is not allowed in the reverse property '".concat(key, "'"), $6QEYr.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                break;
                                            case '@container':
                                                if (processingMode === 1.0) {
                                                    if (Object.keys(objectValue).length > 1 || $46k7F.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $6QEYr.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(Object.keys(objectValue), "') in 1.0, must be only one of ").concat($46k7F.Util.CONTAINERS_1_0.join(', ')), $6QEYr.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                }
                                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(var _iterator2 = Object.keys(objectValue)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        var containerValue = _step2.value;
                                                        if (containerValue === '@list' && value['@reverse']) throw new $6QEYr.ErrorCoded("Term value can not be @container: @list and @reverse at the same time on '".concat(key, "'"), $6QEYr.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                        if ($46k7F.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $6QEYr.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(containerValue, "'), must be one of ").concat($46k7F.Util.CONTAINERS.join(', ')), $6QEYr.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                            _iterator2["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                                break;
                                            case '@language':
                                                ContextParser.validateLanguage(objectValue, true, $6QEYr.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                                break;
                                            case '@direction':
                                                ContextParser.validateDirection(objectValue, true);
                                                break;
                                            case '@prefix':
                                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $6QEYr.ErrorCoded("Found an invalid term @prefix boolean in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_PREFIX_VALUE);
                                                if (!('@id' in value) && !$46k7F.Util.isValidIri(key)) throw new $6QEYr.ErrorCoded("Invalid @prefix definition for '".concat(key, "' ('").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@index':
                                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $6QEYr.ErrorCoded("Attempt to add illegal key to value object: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@nest':
                                                if ($46k7F.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $6QEYr.ErrorCoded("Found an invalid term @nest value in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_NEST_VALUE);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new $6QEYr.ErrorCoded("Found an invalid term value: '".concat(key, "': '").concat(value, "'"), $6QEYr.ERROR_CODES.INVALID_TERM_DEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ key: "applyBaseEntry",
            value: function applyBaseEntry(context, options, inheritFromParent) {
                // In some special cases, this can be a string, so ignore those.
                if (typeof context === 'string') return context;
                // Give priority to @base in the parent context
                if (inheritFromParent && !('@base' in context) && options.parentContext && (0, $3KZcf._)(options.parentContext) === 'object' && '@base' in options.parentContext) {
                    context['@base'] = options.parentContext['@base'];
                    if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
                }
                // Override the base IRI if provided.
                if (options.baseIRI && !options.external) {
                    if (!('@base' in context)) {
                        // The context base is the document base
                        context['@base'] = options.baseIRI;
                        context['@__baseDocument'] = true;
                    } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$46k7F.Util.isValidIri(context['@base'])) // The context base is relative to the document base
                    context['@base'] = (0, $hDpjF.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
                }
                return context;
            }
        },
        {
            /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ key: "normalizeContextIri",
            value: function normalizeContextIri(contextIri, baseIRI) {
                if (!$46k7F.Util.isValidIri(contextIri)) try {
                    contextIri = (0, $hDpjF.resolve)(contextIri, baseIRI);
                } catch (_a) {
                    throw new Error("Invalid context IRI: ".concat(contextIri));
                }
                // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
                if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
                return contextIri;
            }
        },
        {
            key: "parseInnerContexts",
            value: /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ function parseInnerContexts(context, options, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, value, parentContext, e, _, _tmp, _tmp1, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    11,
                                    12
                                ]);
                                _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(context))[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    9
                                ];
                                key = _step.value;
                                value = context[key];
                                if (!(value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object')) return [
                                    3,
                                    8
                                ];
                                if (!('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts)) return [
                                    3,
                                    8
                                ];
                                if (!this.validateContext) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                parentContext = Object.assign(Object.assign({}, context), (0, $cqEAj._)({}, key, Object.assign({}, context[key])));
                                delete parentContext[key]['@context'];
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        parentContext: parentContext,
                                        ignoreProtection: true,
                                        ignoreRemoteScopedContexts: true,
                                        ignoreScopedContexts: true
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                throw new $6QEYr.ErrorCoded(e.message, $6QEYr.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                            case 6:
                                _ = Object.assign;
                                _tmp = [
                                    Object.assign({}, value)
                                ];
                                _tmp1 = {};
                                _1 = '@context';
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        minimalProcessing: true,
                                        ignoreRemoteScopedContexts: true,
                                        parentContext: context
                                    }))
                                ];
                            case 7:
                                context[key] = _.apply(Object, _tmp.concat([
                                    (_tmp1[_1] = _state.sent().getContextRaw(), _tmp1)
                                ]));
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    context
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parse",
            value: function parse(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(context) {
                    var _this, options, // These options are only for internal use on recursive calls and should not be used by
                    // libraries consuming this function
                    internalOptions, baseIRI, parentContext, external, _options_processingMode, processingMode, normalizeLanguageTags, ignoreProtection, minimalProcessing, remoteContexts, contextIri, overriddenLoad, parsedStringContext, _, _1, contextIris, contexts, reducedContexts, importContext, newContext, keys, overlappingKeys, key, newContextWrapped;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, internalOptions = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                                baseIRI = options.baseIRI, parentContext = options.parentContext, external = options.external, _options_processingMode = options.processingMode, processingMode = _options_processingMode === void 0 ? ContextParser.DEFAULT_PROCESSING_MODE : _options_processingMode, normalizeLanguageTags = options.normalizeLanguageTags, ignoreProtection = options.ignoreProtection, minimalProcessing = options.minimalProcessing;
                                remoteContexts = options.remoteContexts || {};
                                // Avoid remote context overflows
                                if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $6QEYr.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $6QEYr.ERROR_CODES.CONTEXT_OVERFLOW);
                                if (!(context === null || context === undefined)) return [
                                    3,
                                    1
                                ];
                                // Don't allow context nullification and there are protected terms
                                if (!ignoreProtection && parentContext && $46k7F.Util.hasProtectedTerms(parentContext)) throw new $6QEYr.ErrorCoded('Illegal context nullification when terms are protected', $6QEYr.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
                                // Context that are explicitly set to null are empty.
                                return [
                                    2,
                                    new $3OuQD.JsonLdContextNormalized(this.applyBaseEntry({}, options, false))
                                ];
                            case 1:
                                if (!(typeof context === 'string')) return [
                                    3,
                                    4
                                ];
                                contextIri = this.normalizeContextIri(context, baseIRI);
                                overriddenLoad = this.getOverriddenLoad(contextIri, options);
                                if (overriddenLoad) return [
                                    2,
                                    new $3OuQD.JsonLdContextNormalized(overriddenLoad)
                                ];
                                _1 = (_ = this).parse;
                                return [
                                    4,
                                    this.load(contextIri)
                                ];
                            case 2:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent(),
                                        Object.assign(Object.assign({}, options), {
                                            baseIRI: contextIri,
                                            external: true,
                                            remoteContexts: Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIri, true))
                                        })
                                    ])
                                ];
                            case 3:
                                parsedStringContext = _state.sent();
                                this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
                                return [
                                    2,
                                    parsedStringContext
                                ];
                            case 4:
                                if (!Array.isArray(context)) return [
                                    3,
                                    7
                                ];
                                // As a performance consideration, first load all external contexts in parallel.
                                contextIris = [];
                                return [
                                    4,
                                    Promise.all(context.map(function(subContext, i) {
                                        if (typeof subContext === 'string') {
                                            var contextIri = _this.normalizeContextIri(subContext, baseIRI);
                                            contextIris[i] = contextIri;
                                            var overriddenLoad = _this.getOverriddenLoad(contextIri, options);
                                            if (overriddenLoad) return overriddenLoad;
                                            return _this.load(contextIri);
                                        } else return subContext;
                                    }))
                                ];
                            case 5:
                                contexts = _state.sent();
                                // Don't apply inheritance logic on minimal processing
                                if (minimalProcessing) return [
                                    2,
                                    new $3OuQD.JsonLdContextNormalized(contexts)
                                ];
                                return [
                                    4,
                                    contexts.reduce(function(accContextPromise, contextEntry, i) {
                                        return accContextPromise.then(function(accContext) {
                                            return _this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                                                baseIRI: contextIris[i] || options.baseIRI,
                                                external: !!contextIris[i] || options.external,
                                                parentContext: accContext.getContextRaw(),
                                                remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIris[i], true)) : remoteContexts
                                            }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                                            {
                                                skipValidation: i < contexts.length - 1
                                            });
                                        });
                                    }, Promise.resolve(new $3OuQD.JsonLdContextNormalized(parentContext || {})))
                                ];
                            case 6:
                                reducedContexts = _state.sent();
                                // Override the base IRI if provided.
                                this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
                                return [
                                    2,
                                    reducedContexts
                                ];
                            case 7:
                                if (!((typeof context === "undefined" ? "undefined" : (0, $3KZcf._)(context)) === 'object')) return [
                                    3,
                                    14
                                ];
                                if (!('@context' in context)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.parse(context['@context'], options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                // Make a deep clone of the given context, to avoid modifying it.
                                context = Object.assign({}, context);
                                // According to the JSON-LD spec, @base must be ignored from external contexts.
                                if (external) delete context['@base'];
                                // Override the base IRI if provided.
                                this.applyBaseEntry(context, options, true);
                                // Hashify container entries
                                // Do this before protected term validation as that influences term format
                                this.containersToHash(context);
                                // Don't perform any other modifications if only minimal processing is needed.
                                if (minimalProcessing) return [
                                    2,
                                    new $3OuQD.JsonLdContextNormalized(context)
                                ];
                                // In JSON-LD 1.1, load @import'ed context prior to processing.
                                importContext = {};
                                if (!('@import' in context)) return [
                                    3,
                                    12
                                ];
                                if (!(processingMode >= 1.1)) return [
                                    3,
                                    11
                                ];
                                // Only accept string values
                                if (typeof context['@import'] !== 'string') throw new $6QEYr.ErrorCoded('An @import value must be a string, but got ' + (0, $3KZcf._)(context['@import']), $6QEYr.ERROR_CODES.INVALID_IMPORT_VALUE);
                                return [
                                    4,
                                    this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI))
                                ];
                            case 10:
                                // Load context
                                importContext = _state.sent();
                                delete context['@import'];
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                throw new $6QEYr.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $6QEYr.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                            case 12:
                                this.applyScopedProtected(importContext, {
                                    processingMode: processingMode
                                }, $3OuQD.defaultExpandOptions);
                                newContext = Object.assign(importContext, context);
                                // Handle terms (before protection checks)
                                this.idifyReverseTerms(newContext);
                                this.normalize(newContext, {
                                    processingMode: processingMode,
                                    normalizeLanguageTags: normalizeLanguageTags
                                });
                                this.applyScopedProtected(newContext, {
                                    processingMode: processingMode
                                }, $3OuQD.defaultExpandOptions);
                                keys = Object.keys(newContext);
                                overlappingKeys = [];
                                if ((typeof parentContext === "undefined" ? "undefined" : (0, $3KZcf._)(parentContext)) === 'object') {
                                    // Merge different parts of the final context in order
                                    for(var key in parentContext)if (key in newContext) overlappingKeys.push(key);
                                    else newContext[key] = parentContext[key];
                                }
                                // Parse inner contexts with minimal processing
                                return [
                                    4,
                                    this.parseInnerContexts(newContext, options, keys)
                                ];
                            case 13:
                                _state.sent();
                                newContextWrapped = new $3OuQD.JsonLdContextNormalized(newContext);
                                // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
                                if ((newContext && newContext['@version'] || ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                                    if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                                    else if ($46k7F.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                                    newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
                                }
                                this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
                                // In JSON-LD 1.1, check if we are not redefining any protected keywords
                                if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $3OuQD.defaultExpandOptions, overlappingKeys);
                                if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                                    processingMode: processingMode
                                });
                                return [
                                    2,
                                    newContextWrapped
                                ];
                            case 14:
                                throw new $6QEYr.ErrorCoded("Tried parsing a context that is not a string, array or object, but got ".concat(context), $6QEYr.ERROR_CODES.INVALID_LOCAL_CONTEXT);
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "load",
            value: /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cached, document, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // First try to retrieve the context from cache
                                cached = this.documentCache[url];
                                if (cached) return [
                                    2,
                                    cached
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.documentLoader.load(url)
                                ];
                            case 2:
                                document = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                throw new $6QEYr.ErrorCoded("Failed to load remote context ".concat(url, ": ").concat(e.message), $6QEYr.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
                            case 4:
                                // Validate the context
                                if (!('@context' in document)) throw new $6QEYr.ErrorCoded("Missing @context in remote context at ".concat(url), $6QEYr.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                return [
                                    2,
                                    this.documentCache[url] = document['@context']
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ key: "getOverriddenLoad",
            value: function getOverriddenLoad(url, options) {
                if (url in (options.remoteContexts || {})) {
                    if (options.ignoreRemoteScopedContexts) return url;
                    else throw new $6QEYr.ErrorCoded('Detected a cyclic context inclusion of ' + url, $6QEYr.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
                }
                return null;
            }
        },
        {
            key: "loadImportContext",
            value: /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ function loadImportContext(importContextIri) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var importContext;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.load(importContextIri)
                                ];
                            case 1:
                                importContext = _state.sent();
                                // Require the context to be a non-array object
                                if ((typeof importContext === "undefined" ? "undefined" : (0, $3KZcf._)(importContext)) !== 'object' || Array.isArray(importContext)) throw new $6QEYr.ErrorCoded('An imported context must be a single object: ' + importContextIri, $6QEYr.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                // Error if the context contains another @import
                                if ('@import' in importContext) throw new $6QEYr.ErrorCoded('An imported context can not import another context: ' + importContextIri, $6QEYr.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                importContext = Object.assign({}, importContext);
                                // Containers have to be converted into hash values the same way as for the importing context
                                // Otherwise context validation will fail for container values
                                this.containersToHash(importContext);
                                return [
                                    2,
                                    importContext
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "validateLanguage",
            value: /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateLanguage(value, strictRange, errorCode) {
                if (typeof value !== 'string') throw new $6QEYr.ErrorCoded("The value of an '@language' must be a string, got '".concat(JSON.stringify(value), "'"), errorCode);
                if (!$46k7F.Util.REGEX_LANGUAGE_TAG.test(value)) {
                    if (strictRange) throw new $6QEYr.ErrorCoded("The value of an '@language' must be a valid language tag, got '".concat(JSON.stringify(value), "'"), errorCode);
                    else return false;
                }
                return true;
            }
        },
        {
            key: "validateDirection",
            value: /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateDirection(value, strictValues) {
                if (typeof value !== 'string') throw new $6QEYr.ErrorCoded("The value of an '@direction' must be a string, got '".concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_BASE_DIRECTION);
                if (!$46k7F.Util.REGEX_DIRECTION_TAG.test(value)) {
                    if (strictValues) throw new $6QEYr.ErrorCoded("The value of an '@direction' must be 'ltr' or 'rtl', got '".concat(JSON.stringify(value), "'"), $6QEYr.ERROR_CODES.INVALID_BASE_DIRECTION);
                    else return false;
                }
                return true;
            }
        }
    ]);
    return ContextParser;
}();
$19ef8dda0ff9c783$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $19ef8dda0ff9c783$var$ContextParser;

});
parcelRegister("6QEYr", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ var $4fc761f9f50b8eac$var$ErrorCoded = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ErrorCoded, Error1);
    function ErrorCoded(message, code) {
        (0, $jGAMp._)(this, ErrorCoded);
        var _this;
        _this = (0, $kzDuW._)(this, ErrorCoded, [
            message
        ]);
        _this.code = code;
        return _this;
    }
    return ErrorCoded;
}((0, $8AW3P._)(Error));
module.exports.ErrorCoded = $4fc761f9f50b8eac$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $4fc761f9f50b8eac$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($4fc761f9f50b8eac$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("10M6A", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $6QEYr = parcelRequire("6QEYr");

var $fdIar = parcelRequire("fdIar");

var $hDpjF = parcelRequire("hDpjF");
/**
 * Loads documents via the fetch API.
 */ var $0bcb1b3493b4b741$var$FetchDocumentLoader = /*#__PURE__*/ function() {
    function FetchDocumentLoader(fetcher) {
        (0, $jGAMp._)(this, FetchDocumentLoader);
        this.fetcher = fetcher;
    }
    (0, $byiyg._)(FetchDocumentLoader, [
        {
            key: "load",
            value: function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var response, mediaType, colonPos, alternateUrl;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (this.fetcher || fetch)(url, {
                                        headers: new Headers({
                                            accept: 'application/ld+json'
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!(response.ok && response.headers)) return [
                                    3,
                                    5
                                ];
                                mediaType = response.headers.get('Content-Type');
                                if (mediaType) {
                                    colonPos = mediaType.indexOf(';');
                                    if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
                                }
                                if (!(mediaType === 'application/ld+json')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                // Return JSON-LD if proper content type was returned
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                // Check for alternate link for a non-JSON-LD response
                                if (response.headers.has('Link')) {
                                    ;
                                    response.headers.forEach(function(value, key) {
                                        if (key === 'link') {
                                            var linkHeader = (0, $fdIar.parse)(value);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = linkHeader.get('type', 'application/ld+json')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var link = _step.value;
                                                    if (link.rel === 'alternate') {
                                                        if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                                        alternateUrl = (0, $hDpjF.resolve)(link.uri, url);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                    if (alternateUrl) return [
                                        2,
                                        this.load(alternateUrl)
                                    ];
                                }
                                throw new $6QEYr.ErrorCoded("Unsupported JSON-LD media type ".concat(mediaType), $6QEYr.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error(response.statusText || "Status code: ".concat(response.status));
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return FetchDocumentLoader;
}();
module.exports.FetchDocumentLoader = $0bcb1b3493b4b741$var$FetchDocumentLoader;

});

parcelRegister("3OuQD", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $6QEYr = parcelRequire("6QEYr");

var $46k7F = parcelRequire("46k7F");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ var $2c6df862c8db07d4$var$JsonLdContextNormalized = /*#__PURE__*/ function() {
    function JsonLdContextNormalized(contextRaw) {
        (0, $jGAMp._)(this, JsonLdContextNormalized);
        this.contextRaw = contextRaw;
    }
    (0, $byiyg._)(JsonLdContextNormalized, [
        {
            /**
     * @return The raw inner context.
     */ key: "getContextRaw",
            value: function getContextRaw() {
                return this.contextRaw;
            }
        },
        {
            /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ key: "expandTerm",
            value: function expandTerm(term, expandVocab) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultExpandOptions;
                var contextValue = this.contextRaw[term];
                // Immediately return if the term was disabled in the context
                if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
                // Check the @id
                var validIriMapping = true;
                if (contextValue && expandVocab) {
                    var value = $46k7F.Util.getContextValueId(contextValue);
                    if (value && value !== term) {
                        if (typeof value !== 'string' || !$46k7F.Util.isValidIri(value) && !$46k7F.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                        {
                            if (!$46k7F.Util.isPotentialKeyword(value)) validIriMapping = false;
                        } else return value;
                    }
                }
                // Check if the term is prefixed
                var prefix = $46k7F.Util.getPrefix(term, this.contextRaw);
                var vocab = this.contextRaw['@vocab'];
                var vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
                var base = this.contextRaw['@base'];
                var potentialKeyword = $46k7F.Util.isPotentialKeyword(term);
                if (prefix) {
                    var contextPrefixValue = this.contextRaw[prefix];
                    var value1 = $46k7F.Util.getContextValueId(contextPrefixValue);
                    if (value1) {
                        if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                            // If we have a simple term definition,
                            // check the last character of the prefix to determine whether or not it is a prefix.
                            // Validate that prefix ends with gen-delim character, unless @prefix is true
                            if (!$46k7F.Util.isSimpleTermDefinitionPrefix(value1, options)) // Treat the term as an absolute IRI
                            return term;
                        } else {
                            // If we have an expanded term definition, default to @prefix: false
                            if (value1[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                            return term;
                        }
                        return value1 + term.substr(prefix.length + 1);
                    }
                } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$46k7F.Util.isCompactIri(term)) {
                    if (vocabRelative) {
                        if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $hDpjF.resolve)(vocab, base) : '') + term;
                        else throw new $6QEYr.ErrorCoded("Relative vocab expansion for term '".concat(term, "' with vocab '").concat(vocab, "' is not allowed."), $6QEYr.ERROR_CODES.INVALID_VOCAB_MAPPING);
                    } else return vocab + term;
                } else if (!expandVocab && base && !potentialKeyword && !$46k7F.Util.isCompactIri(term)) return (0, $hDpjF.resolve)(term, base);
                // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
                if (validIriMapping) return term;
                else throw new $6QEYr.ErrorCoded("Invalid IRI mapping found for context entry '".concat(term, "': '").concat(JSON.stringify(contextValue), "'"), $6QEYr.ERROR_CODES.INVALID_IRI_MAPPING);
            }
        },
        {
            /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ key: "compactIri",
            value: function compactIri(iri, vocab) {
                // Try @vocab compacting
                if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
                // Try @base compacting
                if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
                // Loop over all terms in the context
                // This will try to prefix as short as possible.
                // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
                var shortestPrefixing = {
                    prefix: '',
                    suffix: iri
                };
                for(var key in this.contextRaw){
                    var value = this.contextRaw[key];
                    if (value && !$46k7F.Util.isPotentialKeyword(key)) {
                        var contextIri = $46k7F.Util.getContextValueId(value);
                        if (iri.startsWith(contextIri)) {
                            var suffix = iri.substr(contextIri.length);
                            if (!suffix) {
                                if (vocab) // Immediately return on compacted alias
                                return key;
                            } else if (suffix.length < shortestPrefixing.suffix.length) {
                                // Overwrite the shortest prefix
                                shortestPrefixing.prefix = key;
                                shortestPrefixing.suffix = suffix;
                            }
                        }
                    }
                }
                // Return the shortest prefix
                if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
                return iri;
            }
        }
    ]);
    return JsonLdContextNormalized;
}();
module.exports.JsonLdContextNormalized = $2c6df862c8db07d4$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("46k7F", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
var $2fc754e78f5290a9$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "isCompactIri",
            value: /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ function isCompactIri(term) {
                return term.indexOf(':') > 0 && !(term && term[0] === '#');
            }
        },
        {
            key: "getPrefix",
            value: /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ function getPrefix(term, context) {
                // Do not consider relative IRIs starting with a hash as compact IRIs
                if (term && term[0] === '#') return null;
                var separatorPos = term.indexOf(':');
                if (separatorPos >= 0) {
                    // Suffix can not begin with two slashes
                    if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
                    var prefix = term.substr(0, separatorPos);
                    // Prefix can not be an underscore (this is a blank node)
                    if (prefix === '_') return null;
                    // Prefix must match a term in the active context
                    if (context[prefix]) return prefix;
                }
                return null;
            }
        },
        {
            key: "getContextValueId",
            value: /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ function getContextValueId(contextValue) {
                if (contextValue === null || typeof contextValue === 'string') return contextValue;
                var id = contextValue['@id'];
                return id ? id : null;
            }
        },
        {
            key: "isSimpleTermDefinitionPrefix",
            value: /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ function isSimpleTermDefinitionPrefix(value, options) {
                return !Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || Util.isPrefixIriEndingWithGenDelim(value)));
            }
        },
        {
            key: "isPotentialKeyword",
            value: /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ function isPotentialKeyword(keyword) {
                return typeof keyword === 'string' && Util.KEYWORD_REGEX.test(keyword);
            }
        },
        {
            key: "isPrefixIriEndingWithGenDelim",
            value: /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ function isPrefixIriEndingWithGenDelim(prefixIri) {
                return Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
            }
        },
        {
            key: "isPrefixValue",
            value: /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ function isPrefixValue(value) {
                return value && (typeof value === 'string' || value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object');
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Boolean(iri && Util.IRI_REGEX.test(iri));
            }
        },
        {
            key: "isValidIriWeak",
            value: /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIriWeak(iri) {
                return !!iri && iri[0] !== ':' && Util.IRI_REGEX_WEAK.test(iri);
            }
        },
        {
            key: "isValidKeyword",
            value: /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ function isValidKeyword(keyword) {
                return Util.VALID_KEYWORDS[keyword];
            }
        },
        {
            key: "isTermProtected",
            value: /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ function isTermProtected(context, key) {
                var value = context[key];
                return !(typeof value === 'string') && value && value['@protected'];
            }
        },
        {
            key: "hasProtectedTerms",
            value: /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ function hasProtectedTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (Util.isTermProtected(context, key)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isReservedInternalKeyword",
            value: /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ function isReservedInternalKeyword(key) {
                return key.startsWith('@__');
            }
        },
        {
            key: "deepEqual",
            value: /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ function deepEqual(object1, object2) {
                var _this = this;
                var objKeys1 = Object.keys(object1);
                var objKeys2 = Object.keys(object2);
                if (objKeys1.length !== objKeys2.length) return false;
                return objKeys1.every(function(key) {
                    var value1 = object1[key];
                    var value2 = object2[key];
                    return value1 === value2 || value1 !== null && value2 !== null && (typeof value1 === "undefined" ? "undefined" : (0, $3KZcf._)(value1)) === "object" && (typeof value2 === "undefined" ? "undefined" : (0, $3KZcf._)(value2)) === "object" && _this.deepEqual(value1, value2);
                });
            }
        }
    ]);
    return Util;
}();
// Regex for valid IRIs
$2fc754e78f5290a9$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$2fc754e78f5290a9$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$2fc754e78f5290a9$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$2fc754e78f5290a9$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$2fc754e78f5290a9$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$2fc754e78f5290a9$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$2fc754e78f5290a9$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$2fc754e78f5290a9$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$2fc754e78f5290a9$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$2fc754e78f5290a9$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$2fc754e78f5290a9$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$2fc754e78f5290a9$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $2fc754e78f5290a9$var$Util;

});



parcelRegister("aKN7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aPddL", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("7RPHv", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SeparatorType = void 0;
/**
 * A type of JSON separator.
 */ var $5ba5964e12dbc7f9$var$SeparatorType = function SeparatorType(label) {
    (0, $jGAMp._)(this, SeparatorType);
    this.label = label;
};
module.exports.SeparatorType = $5ba5964e12dbc7f9$var$SeparatorType;
$5ba5964e12dbc7f9$var$SeparatorType.COMMA = new $5ba5964e12dbc7f9$var$SeparatorType(',');
$5ba5964e12dbc7f9$var$SeparatorType.OBJECT_START = new $5ba5964e12dbc7f9$var$SeparatorType('{');
$5ba5964e12dbc7f9$var$SeparatorType.OBJECT_END = new $5ba5964e12dbc7f9$var$SeparatorType('}');
$5ba5964e12dbc7f9$var$SeparatorType.OBJECT_END_COMMA = new $5ba5964e12dbc7f9$var$SeparatorType('},');
$5ba5964e12dbc7f9$var$SeparatorType.ARRAY_START = new $5ba5964e12dbc7f9$var$SeparatorType('[');
$5ba5964e12dbc7f9$var$SeparatorType.ARRAY_END = new $5ba5964e12dbc7f9$var$SeparatorType(']');
$5ba5964e12dbc7f9$var$SeparatorType.ARRAY_END_COMMA = new $5ba5964e12dbc7f9$var$SeparatorType('],');
$5ba5964e12dbc7f9$var$SeparatorType.GRAPH_FIELD_NONCOMPACT = new $5ba5964e12dbc7f9$var$SeparatorType('"@graph": [');
$5ba5964e12dbc7f9$var$SeparatorType.GRAPH_FIELD_COMPACT = new $5ba5964e12dbc7f9$var$SeparatorType('"@graph":[');
$5ba5964e12dbc7f9$var$SeparatorType.CONTEXT_FIELD = new $5ba5964e12dbc7f9$var$SeparatorType('"@context":');

});

parcelRegister("fCsJx", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $kR5z5 = parcelRequire("kR5z5");
/**
 * Utility functions and methods.
 */ var $b5f0b17c6f2c906c$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "termToValue",
            value: /**
     * Convert an RDF term to a JSON value.
     * @param {Term} term An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     * @param {ITermToValueOptions} options Conversion options.
     * @return {any} A JSON value.
     */ function termToValue(term, context) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
                    compactIds: false,
                    useNativeTypes: false
                };
                switch(term.termType){
                    case 'NamedNode':
                        var compacted = context.compactIri(term.value, options.vocab);
                        return options.compactIds ? compacted : {
                            '@id': compacted
                        };
                    case 'DefaultGraph':
                        return options.compactIds ? term.value : {
                            '@id': term.value
                        };
                    case 'BlankNode':
                        var id = "_:".concat(term.value);
                        return options.compactIds ? id : {
                            '@id': id
                        };
                    case 'Literal':
                        // Handle JSON datatype
                        if (term.datatype.value === Util.RDF_JSON) {
                            var parsedJson;
                            try {
                                parsedJson = JSON.parse(term.value);
                            } catch (e) {
                                throw new $kR5z5.ErrorCoded('Invalid JSON literal: ' + e.message, $kR5z5.ERROR_CODES.INVALID_JSON_LITERAL);
                            }
                            return {
                                '@value': parsedJson,
                                '@type': '@json'
                            };
                        }
                        // Handle rdfDirection: i18n-datatype
                        if (options.rdfDirection === 'i18n-datatype' && term.datatype.value.startsWith(Util.I18N)) {
                            var _term_datatype_value_substr_split = (0, $32TW8._)(term.datatype.value.substr(Util.I18N.length, term.datatype.value.length).split('_'), 2), language = _term_datatype_value_substr_split[0], direction = _term_datatype_value_substr_split[1];
                            return Object.assign(Object.assign({
                                '@value': term.value
                            }, language ? {
                                '@language': language
                            } : {}), direction ? {
                                '@direction': direction
                            } : {});
                        }
                        var stringType = term.datatype.value === Util.XSD_STRING;
                        var rawValue = {
                            '@value': !stringType && options.useNativeTypes ? Util.stringToNativeType(term.value, term.datatype.value) : term.value
                        };
                        if (term.language) return Object.assign(Object.assign({}, rawValue), {
                            '@language': term.language
                        });
                        else if (!stringType && typeof rawValue['@value'] === 'string') return Object.assign(Object.assign({}, rawValue), {
                            '@type': term.datatype.value
                        });
                        else return rawValue;
                }
            }
        },
        {
            key: "stringToNativeType",
            value: /**
     * Convert a string term to a native type.
     * If no conversion is possible, the original string will be returned.
     * @param {string} value An RDF term's string value.
     * @param {string} type
     * @return {any}
     */ function stringToNativeType(value, type) {
                if (type.startsWith(Util.XSD)) {
                    var xsdType = type.substr(Util.XSD.length);
                    switch(xsdType){
                        case 'boolean':
                            if (value === 'true') return true;
                            else if (value === 'false') return false;
                            throw new Error("Invalid xsd:boolean value '".concat(value, "'"));
                        case 'integer':
                        case 'number':
                        case 'int':
                        case 'byte':
                        case 'long':
                            var parsedInt = parseInt(value, 10);
                            if (isNaN(parsedInt)) throw new Error("Invalid xsd:integer value '".concat(value, "'"));
                            return parsedInt;
                        case 'float':
                        case 'double':
                            var parsedFloat = parseFloat(value);
                            if (isNaN(parsedFloat)) throw new Error("Invalid xsd:float value '".concat(value, "'"));
                            return parsedFloat;
                    }
                }
                return value;
            }
        }
    ]);
    return Util;
}();
module.exports.Util = $b5f0b17c6f2c906c$var$Util;
$b5f0b17c6f2c906c$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$b5f0b17c6f2c906c$var$Util.XSD_STRING = $b5f0b17c6f2c906c$var$Util.XSD + 'string';
$b5f0b17c6f2c906c$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$b5f0b17c6f2c906c$var$Util.RDF_TYPE = $b5f0b17c6f2c906c$var$Util.RDF + 'type';
$b5f0b17c6f2c906c$var$Util.RDF_JSON = $b5f0b17c6f2c906c$var$Util.RDF + 'JSON';
$b5f0b17c6f2c906c$var$Util.I18N = 'https://www.w3.org/ns/i18n#';

});

parcelRegister("4SWYf", function(module, exports) {
'use strict';

var $4JSVX = parcelRequire("4JSVX");

var $bU68h = parcelRequire("bU68h");
var $38e9f2f1428da2c6$var$originalDestroy = $4JSVX.Readable.destroy;
module.exports = $4JSVX.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $4JSVX._uint8ArrayToBuffer;
module.exports._isUint8Array = $4JSVX._isUint8Array;
module.exports.isDisturbed = $4JSVX.isDisturbed;
module.exports.isErrored = $4JSVX.isErrored;
module.exports.isReadable = $4JSVX.isReadable;
module.exports.Readable = $4JSVX.Readable;
module.exports.Writable = $4JSVX.Writable;
module.exports.Duplex = $4JSVX.Duplex;
module.exports.Transform = $4JSVX.Transform;
module.exports.PassThrough = $4JSVX.PassThrough;
module.exports.addAbortSignal = $4JSVX.addAbortSignal;
module.exports.finished = $4JSVX.finished;
module.exports.destroy = $4JSVX.destroy;
module.exports.destroy = $38e9f2f1428da2c6$var$originalDestroy;
module.exports.pipeline = $4JSVX.pipeline;
module.exports.compose = $4JSVX.compose;
Object.defineProperty($4JSVX, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $bU68h;
    }
});
module.exports.Stream = $4JSVX.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("4JSVX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $jXfVE = parcelRequire("jXfVE");
var $3735fa1d9a597c52$require$Buffer = $jXfVE.Buffer;

var $fKwjf = parcelRequire("fKwjf");
/* replacement end */ var $3735fa1d9a597c52$var$ObjectDefineProperty = $fKwjf.ObjectDefineProperty, $3735fa1d9a597c52$var$ObjectKeys = $fKwjf.ObjectKeys, $3735fa1d9a597c52$var$ReflectApply = $fKwjf.ReflectApply;

var $kigZM = parcelRequire("kigZM");
var $3735fa1d9a597c52$var$_require_promisify = $kigZM.promisify, $3735fa1d9a597c52$var$customPromisify = $3735fa1d9a597c52$var$_require_promisify.custom;

var $1A9U1 = parcelRequire("1A9U1");
var $3735fa1d9a597c52$var$streamReturningOperators = $1A9U1.streamReturningOperators, $3735fa1d9a597c52$var$promiseReturningOperators = $1A9U1.promiseReturningOperators;

var $cNQWQ = parcelRequire("cNQWQ");
var $3735fa1d9a597c52$var$ERR_ILLEGAL_CONSTRUCTOR = $cNQWQ.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $dCI7E = parcelRequire("dCI7E");

var $4UHK4 = parcelRequire("4UHK4");
var $3735fa1d9a597c52$var$setDefaultHighWaterMark = $4UHK4.setDefaultHighWaterMark, $3735fa1d9a597c52$var$getDefaultHighWaterMark = $4UHK4.getDefaultHighWaterMark;

var $gKhO1 = parcelRequire("gKhO1");
var $3735fa1d9a597c52$require$pipeline = $gKhO1.pipeline;

var $hSI17 = parcelRequire("hSI17");
var $3735fa1d9a597c52$require$destroyer = $hSI17.destroyer;

var $fvjOO = parcelRequire("fvjOO");
var $3735fa1d9a597c52$var$internalBuffer = {};

var $bU68h = parcelRequire("bU68h");

var $eYXq6 = parcelRequire("eYXq6");

var $3735fa1d9a597c52$var$Stream = module.exports = (parcelRequire("fNe2J")).Stream;
$3735fa1d9a597c52$var$Stream.isDestroyed = $eYXq6.isDestroyed;
$3735fa1d9a597c52$var$Stream.isDisturbed = $eYXq6.isDisturbed;
$3735fa1d9a597c52$var$Stream.isErrored = $eYXq6.isErrored;
$3735fa1d9a597c52$var$Stream.isReadable = $eYXq6.isReadable;
$3735fa1d9a597c52$var$Stream.isWritable = $eYXq6.isWritable;

$3735fa1d9a597c52$var$Stream.Readable = (parcelRequire("uUoiN"));
var $3735fa1d9a597c52$var$_iteratorNormalCompletion = true, $3735fa1d9a597c52$var$_didIteratorError = false, $3735fa1d9a597c52$var$_iteratorError = undefined;
try {
    for(var $3735fa1d9a597c52$var$_iterator = $3735fa1d9a597c52$var$ObjectKeys($3735fa1d9a597c52$var$streamReturningOperators)[Symbol.iterator](), $3735fa1d9a597c52$var$_step; !($3735fa1d9a597c52$var$_iteratorNormalCompletion = ($3735fa1d9a597c52$var$_step = $3735fa1d9a597c52$var$_iterator.next()).done); $3735fa1d9a597c52$var$_iteratorNormalCompletion = true){
        var $3735fa1d9a597c52$var$key = $3735fa1d9a597c52$var$_step.value;
        var $3735fa1d9a597c52$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $3735fa1d9a597c52$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3735fa1d9a597c52$var$Stream.Readable.from($3735fa1d9a597c52$var$ReflectApply($3735fa1d9a597c52$var$op, this, args));
        };
        var $3735fa1d9a597c52$var$op = $3735fa1d9a597c52$var$streamReturningOperators[$3735fa1d9a597c52$var$key];
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$fn, 'name', {
            __proto__: null,
            value: $3735fa1d9a597c52$var$op.name
        });
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$fn, 'length', {
            __proto__: null,
            value: $3735fa1d9a597c52$var$op.length
        });
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$Stream.Readable.prototype, $3735fa1d9a597c52$var$key, {
            __proto__: null,
            value: $3735fa1d9a597c52$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3735fa1d9a597c52$var$_didIteratorError = true;
    $3735fa1d9a597c52$var$_iteratorError = err;
} finally{
    try {
        if (!$3735fa1d9a597c52$var$_iteratorNormalCompletion && $3735fa1d9a597c52$var$_iterator["return"] != null) {
            $3735fa1d9a597c52$var$_iterator["return"]();
        }
    } finally{
        if ($3735fa1d9a597c52$var$_didIteratorError) {
            throw $3735fa1d9a597c52$var$_iteratorError;
        }
    }
}
var $3735fa1d9a597c52$var$_iteratorNormalCompletion1 = true, $3735fa1d9a597c52$var$_didIteratorError1 = false, $3735fa1d9a597c52$var$_iteratorError1 = undefined;
try {
    for(var $3735fa1d9a597c52$var$_iterator1 = $3735fa1d9a597c52$var$ObjectKeys($3735fa1d9a597c52$var$promiseReturningOperators)[Symbol.iterator](), $3735fa1d9a597c52$var$_step1; !($3735fa1d9a597c52$var$_iteratorNormalCompletion1 = ($3735fa1d9a597c52$var$_step1 = $3735fa1d9a597c52$var$_iterator1.next()).done); $3735fa1d9a597c52$var$_iteratorNormalCompletion1 = true){
        var $3735fa1d9a597c52$var$key1 = $3735fa1d9a597c52$var$_step1.value;
        var $3735fa1d9a597c52$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $3735fa1d9a597c52$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3735fa1d9a597c52$var$ReflectApply($3735fa1d9a597c52$var$op1, this, args);
        };
        var $3735fa1d9a597c52$var$op1 = $3735fa1d9a597c52$var$promiseReturningOperators[$3735fa1d9a597c52$var$key1];
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$fn1, 'name', {
            __proto__: null,
            value: $3735fa1d9a597c52$var$op1.name
        });
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$fn1, 'length', {
            __proto__: null,
            value: $3735fa1d9a597c52$var$op1.length
        });
        $3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$Stream.Readable.prototype, $3735fa1d9a597c52$var$key1, {
            __proto__: null,
            value: $3735fa1d9a597c52$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3735fa1d9a597c52$var$_didIteratorError1 = true;
    $3735fa1d9a597c52$var$_iteratorError1 = err;
} finally{
    try {
        if (!$3735fa1d9a597c52$var$_iteratorNormalCompletion1 && $3735fa1d9a597c52$var$_iterator1["return"] != null) {
            $3735fa1d9a597c52$var$_iterator1["return"]();
        }
    } finally{
        if ($3735fa1d9a597c52$var$_didIteratorError1) {
            throw $3735fa1d9a597c52$var$_iteratorError1;
        }
    }
}

$3735fa1d9a597c52$var$Stream.Writable = (parcelRequire("exdZH"));

$3735fa1d9a597c52$var$Stream.Duplex = (parcelRequire("1MYa6"));

$3735fa1d9a597c52$var$Stream.Transform = (parcelRequire("lK2pA"));

$3735fa1d9a597c52$var$Stream.PassThrough = (parcelRequire("fsm9m"));
$3735fa1d9a597c52$var$Stream.pipeline = $3735fa1d9a597c52$require$pipeline;

var $bcrOJ = parcelRequire("bcrOJ");
var $3735fa1d9a597c52$require$addAbortSignal = $bcrOJ.addAbortSignal;
$3735fa1d9a597c52$var$Stream.addAbortSignal = $3735fa1d9a597c52$require$addAbortSignal;
$3735fa1d9a597c52$var$Stream.finished = $fvjOO;
$3735fa1d9a597c52$var$Stream.destroy = $3735fa1d9a597c52$require$destroyer;
$3735fa1d9a597c52$var$Stream.compose = $dCI7E;
$3735fa1d9a597c52$var$Stream.setDefaultHighWaterMark = $3735fa1d9a597c52$var$setDefaultHighWaterMark;
$3735fa1d9a597c52$var$Stream.getDefaultHighWaterMark = $3735fa1d9a597c52$var$getDefaultHighWaterMark;
$3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $bU68h;
    }
});
$3735fa1d9a597c52$var$ObjectDefineProperty($3735fa1d9a597c52$require$pipeline, $3735fa1d9a597c52$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $bU68h.pipeline;
    }
});
$3735fa1d9a597c52$var$ObjectDefineProperty($fvjOO, $3735fa1d9a597c52$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $bU68h.finished;
    }
});
// Backwards-compat with node 0.4.x
$3735fa1d9a597c52$var$Stream.Stream = $3735fa1d9a597c52$var$Stream;
$3735fa1d9a597c52$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$3735fa1d9a597c52$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $3735fa1d9a597c52$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("jXfVE", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e86fe2297e8b7b1b$export$a143d493d941bafc; }, function (v) { return $e86fe2297e8b7b1b$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e86fe2297e8b7b1b$export$f99ded8fe4b79145; }, function (v) { return $e86fe2297e8b7b1b$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $e86fe2297e8b7b1b$export$a143d493d941bafc;
var $e86fe2297e8b7b1b$export$e4cf37d7f6fb9e0a;
var $e86fe2297e8b7b1b$export$f99ded8fe4b79145;
var $e86fe2297e8b7b1b$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $e86fe2297e8b7b1b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e86fe2297e8b7b1b$export$a143d493d941bafc = $e86fe2297e8b7b1b$var$Buffer;
$e86fe2297e8b7b1b$export$e4cf37d7f6fb9e0a = $e86fe2297e8b7b1b$var$SlowBuffer;
$e86fe2297e8b7b1b$export$f99ded8fe4b79145 = 50;
var $e86fe2297e8b7b1b$var$K_MAX_LENGTH = 0x7fffffff;
$e86fe2297e8b7b1b$export$599f31c3813fae4d = $e86fe2297e8b7b1b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e86fe2297e8b7b1b$var$Buffer.TYPED_ARRAY_SUPPORT = $e86fe2297e8b7b1b$var$typedArraySupport();
if (!$e86fe2297e8b7b1b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e86fe2297e8b7b1b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e86fe2297e8b7b1b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e86fe2297e8b7b1b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e86fe2297e8b7b1b$var$createBuffer(length) {
    if (length > $e86fe2297e8b7b1b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e86fe2297e8b7b1b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e86fe2297e8b7b1b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e86fe2297e8b7b1b$var$allocUnsafe(arg);
    }
    return $e86fe2297e8b7b1b$var$from(arg, encodingOrOffset, length);
}
$e86fe2297e8b7b1b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e86fe2297e8b7b1b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e86fe2297e8b7b1b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e86fe2297e8b7b1b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($e86fe2297e8b7b1b$var$isInstance(value, ArrayBuffer) || value && $e86fe2297e8b7b1b$var$isInstance(value.buffer, ArrayBuffer)) return $e86fe2297e8b7b1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e86fe2297e8b7b1b$var$isInstance(value, SharedArrayBuffer) || value && $e86fe2297e8b7b1b$var$isInstance(value.buffer, SharedArrayBuffer))) return $e86fe2297e8b7b1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e86fe2297e8b7b1b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e86fe2297e8b7b1b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e86fe2297e8b7b1b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e86fe2297e8b7b1b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e86fe2297e8b7b1b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e86fe2297e8b7b1b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e86fe2297e8b7b1b$var$Buffer, Uint8Array);
function $e86fe2297e8b7b1b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e86fe2297e8b7b1b$var$alloc(size, fill, encoding) {
    $e86fe2297e8b7b1b$var$assertSize(size);
    if (size <= 0) return $e86fe2297e8b7b1b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e86fe2297e8b7b1b$var$createBuffer(size).fill(fill, encoding) : $e86fe2297e8b7b1b$var$createBuffer(size).fill(fill);
    return $e86fe2297e8b7b1b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e86fe2297e8b7b1b$var$Buffer.alloc = function(size, fill, encoding) {
    return $e86fe2297e8b7b1b$var$alloc(size, fill, encoding);
};
function $e86fe2297e8b7b1b$var$allocUnsafe(size) {
    $e86fe2297e8b7b1b$var$assertSize(size);
    return $e86fe2297e8b7b1b$var$createBuffer(size < 0 ? 0 : $e86fe2297e8b7b1b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e86fe2297e8b7b1b$var$Buffer.allocUnsafe = function(size) {
    return $e86fe2297e8b7b1b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e86fe2297e8b7b1b$var$Buffer.allocUnsafeSlow = function(size) {
    return $e86fe2297e8b7b1b$var$allocUnsafe(size);
};
function $e86fe2297e8b7b1b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e86fe2297e8b7b1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $e86fe2297e8b7b1b$var$byteLength(string, encoding) | 0;
    var buf = $e86fe2297e8b7b1b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e86fe2297e8b7b1b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e86fe2297e8b7b1b$var$checked(array.length) | 0;
    var buf = $e86fe2297e8b7b1b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e86fe2297e8b7b1b$var$fromArrayView(arrayView) {
    if ($e86fe2297e8b7b1b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e86fe2297e8b7b1b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e86fe2297e8b7b1b$var$fromArrayLike(arrayView);
}
function $e86fe2297e8b7b1b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e86fe2297e8b7b1b$var$Buffer.prototype);
    return buf;
}
function $e86fe2297e8b7b1b$var$fromObject(obj) {
    if ($e86fe2297e8b7b1b$var$Buffer.isBuffer(obj)) {
        var len = $e86fe2297e8b7b1b$var$checked(obj.length) | 0;
        var buf = $e86fe2297e8b7b1b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e86fe2297e8b7b1b$var$numberIsNaN(obj.length)) return $e86fe2297e8b7b1b$var$createBuffer(0);
        return $e86fe2297e8b7b1b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e86fe2297e8b7b1b$var$fromArrayLike(obj.data);
}
function $e86fe2297e8b7b1b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e86fe2297e8b7b1b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e86fe2297e8b7b1b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e86fe2297e8b7b1b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e86fe2297e8b7b1b$var$Buffer.alloc(+length);
}
$e86fe2297e8b7b1b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e86fe2297e8b7b1b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e86fe2297e8b7b1b$var$Buffer.compare = function compare(a, b) {
    if ($e86fe2297e8b7b1b$var$isInstance(a, Uint8Array)) a = $e86fe2297e8b7b1b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e86fe2297e8b7b1b$var$isInstance(b, Uint8Array)) b = $e86fe2297e8b7b1b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(a) || !$e86fe2297e8b7b1b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e86fe2297e8b7b1b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e86fe2297e8b7b1b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e86fe2297e8b7b1b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e86fe2297e8b7b1b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e86fe2297e8b7b1b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(buf)) buf = $e86fe2297e8b7b1b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e86fe2297e8b7b1b$var$byteLength(string, encoding) {
    if ($e86fe2297e8b7b1b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e86fe2297e8b7b1b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e86fe2297e8b7b1b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e86fe2297e8b7b1b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e86fe2297e8b7b1b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e86fe2297e8b7b1b$var$Buffer.byteLength = $e86fe2297e8b7b1b$var$byteLength;
function $e86fe2297e8b7b1b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e86fe2297e8b7b1b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e86fe2297e8b7b1b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e86fe2297e8b7b1b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e86fe2297e8b7b1b$var$latin1Slice(this, start, end);
        case 'base64':
            return $e86fe2297e8b7b1b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e86fe2297e8b7b1b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e86fe2297e8b7b1b$var$Buffer.prototype._isBuffer = true;
function $e86fe2297e8b7b1b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$e86fe2297e8b7b1b$var$swap(this, i, i + 1);
    return this;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $e86fe2297e8b7b1b$var$swap(this, i, i + 3);
        $e86fe2297e8b7b1b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $e86fe2297e8b7b1b$var$swap(this, i, i + 7);
        $e86fe2297e8b7b1b$var$swap(this, i + 1, i + 6);
        $e86fe2297e8b7b1b$var$swap(this, i + 2, i + 5);
        $e86fe2297e8b7b1b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e86fe2297e8b7b1b$var$utf8Slice(this, 0, length);
    return $e86fe2297e8b7b1b$var$slowToString.apply(this, arguments);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.toLocaleString = $e86fe2297e8b7b1b$var$Buffer.prototype.toString;
$e86fe2297e8b7b1b$var$Buffer.prototype.equals = function equals(b) {
    if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e86fe2297e8b7b1b$var$Buffer.compare(this, b) === 0;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $e86fe2297e8b7b1b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e86fe2297e8b7b1b$var$customInspectSymbol) $e86fe2297e8b7b1b$var$Buffer.prototype[$e86fe2297e8b7b1b$var$customInspectSymbol] = $e86fe2297e8b7b1b$var$Buffer.prototype.inspect;
$e86fe2297e8b7b1b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e86fe2297e8b7b1b$var$isInstance(target, Uint8Array)) target = $e86fe2297e8b7b1b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e86fe2297e8b7b1b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e86fe2297e8b7b1b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e86fe2297e8b7b1b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e86fe2297e8b7b1b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e86fe2297e8b7b1b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e86fe2297e8b7b1b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e86fe2297e8b7b1b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e86fe2297e8b7b1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e86fe2297e8b7b1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e86fe2297e8b7b1b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e86fe2297e8b7b1b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e86fe2297e8b7b1b$var$utf8Write(buf, string, offset, length) {
    return $e86fe2297e8b7b1b$var$blitBuffer($e86fe2297e8b7b1b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e86fe2297e8b7b1b$var$asciiWrite(buf, string, offset, length) {
    return $e86fe2297e8b7b1b$var$blitBuffer($e86fe2297e8b7b1b$var$asciiToBytes(string), buf, offset, length);
}
function $e86fe2297e8b7b1b$var$base64Write(buf, string, offset, length) {
    return $e86fe2297e8b7b1b$var$blitBuffer($e86fe2297e8b7b1b$var$base64ToBytes(string), buf, offset, length);
}
function $e86fe2297e8b7b1b$var$ucs2Write(buf, string, offset, length) {
    return $e86fe2297e8b7b1b$var$blitBuffer($e86fe2297e8b7b1b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e86fe2297e8b7b1b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e86fe2297e8b7b1b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e86fe2297e8b7b1b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e86fe2297e8b7b1b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e86fe2297e8b7b1b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e86fe2297e8b7b1b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e86fe2297e8b7b1b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e86fe2297e8b7b1b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $e86fe2297e8b7b1b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e86fe2297e8b7b1b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e86fe2297e8b7b1b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e86fe2297e8b7b1b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e86fe2297e8b7b1b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e86fe2297e8b7b1b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e86fe2297e8b7b1b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e86fe2297e8b7b1b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e86fe2297e8b7b1b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $e86fe2297e8b7b1b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e86fe2297e8b7b1b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e86fe2297e8b7b1b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e86fe2297e8b7b1b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e86fe2297e8b7b1b$var$Buffer.prototype.readUintLE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUintBE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUint8 = $e86fe2297e8b7b1b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUint16LE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUint16BE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUint32LE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readUint32BE = $e86fe2297e8b7b1b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readBigUInt64LE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e86fe2297e8b7b1b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e86fe2297e8b7b1b$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e86fe2297e8b7b1b$var$Buffer.prototype.readBigUInt64BE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e86fe2297e8b7b1b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e86fe2297e8b7b1b$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e86fe2297e8b7b1b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readBigInt64LE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e86fe2297e8b7b1b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e86fe2297e8b7b1b$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$e86fe2297e8b7b1b$var$Buffer.prototype.readBigInt64BE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e86fe2297e8b7b1b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $e86fe2297e8b7b1b$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$e86fe2297e8b7b1b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $e86fe2297e8b7b1b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUintLE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e86fe2297e8b7b1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUintBE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e86fe2297e8b7b1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUint8 = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUint16LE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUint16BE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUint32LE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeUint32BE = $e86fe2297e8b7b1b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e86fe2297e8b7b1b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e86fe2297e8b7b1b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e86fe2297e8b7b1b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e86fe2297e8b7b1b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.writeBigUInt64LE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e86fe2297e8b7b1b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e86fe2297e8b7b1b$var$Buffer.prototype.writeBigUInt64BE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e86fe2297e8b7b1b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e86fe2297e8b7b1b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e86fe2297e8b7b1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e86fe2297e8b7b1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeBigInt64LE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e86fe2297e8b7b1b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e86fe2297e8b7b1b$var$Buffer.prototype.writeBigInt64BE = $e86fe2297e8b7b1b$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $e86fe2297e8b7b1b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e86fe2297e8b7b1b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e86fe2297e8b7b1b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e86fe2297e8b7b1b$var$writeFloat(this, value, offset, true, noAssert);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e86fe2297e8b7b1b$var$writeFloat(this, value, offset, false, noAssert);
};
function $e86fe2297e8b7b1b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e86fe2297e8b7b1b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e86fe2297e8b7b1b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e86fe2297e8b7b1b$var$writeDouble(this, value, offset, true, noAssert);
};
$e86fe2297e8b7b1b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e86fe2297e8b7b1b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e86fe2297e8b7b1b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e86fe2297e8b7b1b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e86fe2297e8b7b1b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e86fe2297e8b7b1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e86fe2297e8b7b1b$var$Buffer.isBuffer(val) ? val : $e86fe2297e8b7b1b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $e86fe2297e8b7b1b$var$errors = {};
function $e86fe2297e8b7b1b$var$E(sym, getMessage, Base) {
    $e86fe2297e8b7b1b$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$e86fe2297e8b7b1b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e86fe2297e8b7b1b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$e86fe2297e8b7b1b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $e86fe2297e8b7b1b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $e86fe2297e8b7b1b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $e86fe2297e8b7b1b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $e86fe2297e8b7b1b$var$checkBounds(buf, offset, byteLength) {
    $e86fe2297e8b7b1b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e86fe2297e8b7b1b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e86fe2297e8b7b1b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $e86fe2297e8b7b1b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e86fe2297e8b7b1b$var$checkBounds(buf, offset, byteLength);
}
function $e86fe2297e8b7b1b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e86fe2297e8b7b1b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e86fe2297e8b7b1b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e86fe2297e8b7b1b$var$validateNumber(value, type);
        throw new $e86fe2297e8b7b1b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e86fe2297e8b7b1b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e86fe2297e8b7b1b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $e86fe2297e8b7b1b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e86fe2297e8b7b1b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e86fe2297e8b7b1b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e86fe2297e8b7b1b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e86fe2297e8b7b1b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e86fe2297e8b7b1b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e86fe2297e8b7b1b$var$base64ToBytes(str) {
    return $abUaD.toByteArray($e86fe2297e8b7b1b$var$base64clean(str));
}
function $e86fe2297e8b7b1b$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e86fe2297e8b7b1b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e86fe2297e8b7b1b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e86fe2297e8b7b1b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e86fe2297e8b7b1b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e86fe2297e8b7b1b$var$BufferBigIntNotDefined : fn;
}
function $e86fe2297e8b7b1b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("fKwjf", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $b77436e4d7bfc1e1$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $b77436e4d7bfc1e1$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("kigZM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $jXfVE = parcelRequire("jXfVE");

var $hSLD2 = parcelRequire("hSLD2");
var $ec62ac06fb4719d3$var$format = $hSLD2.format, $ec62ac06fb4719d3$var$inspect = $hSLD2.inspect;

var $cNQWQ = parcelRequire("cNQWQ");
var $ec62ac06fb4719d3$var$ERR_INVALID_ARG_TYPE = $cNQWQ.codes.ERR_INVALID_ARG_TYPE;

var $fKwjf = parcelRequire("fKwjf");
var $ec62ac06fb4719d3$var$kResistStopPropagation = $fKwjf.kResistStopPropagation, $ec62ac06fb4719d3$var$AggregateError = $fKwjf.AggregateError, $ec62ac06fb4719d3$var$SymbolDispose = $fKwjf.SymbolDispose;

var $ec62ac06fb4719d3$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $ec62ac06fb4719d3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $ec62ac06fb4719d3$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $ec62ac06fb4719d3$var$Blob = globalThis.Blob || $jXfVE.Blob;
/* eslint-disable indent */ var $ec62ac06fb4719d3$var$isBlob = typeof $ec62ac06fb4719d3$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ec62ac06fb4719d3$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $ec62ac06fb4719d3$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $ec62ac06fb4719d3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $ec62ac06fb4719d3$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $ec62ac06fb4719d3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ec62ac06fb4719d3$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $ec62ac06fb4719d3$var$format,
    inspect: $ec62ac06fb4719d3$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $ec62ac06fb4719d3$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ec62ac06fb4719d3$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ec62ac06fb4719d3$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ec62ac06fb4719d3$var$validateAbortSignal(signal, 'signal');
        $ec62ac06fb4719d3$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $ec62ac06fb4719d3$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $ec62ac06fb4719d3$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $ec62ac06fb4719d3$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $ec62ac06fb4719d3$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $ec62ac06fb4719d3$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("hSLD2", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("cNQWQ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $hSLD2 = parcelRequire("hSLD2");
var $9523220ae4a98a35$var$format = $hSLD2.format, $9523220ae4a98a35$var$inspect = $hSLD2.inspect;

var $fKwjf = parcelRequire("fKwjf");
var $9523220ae4a98a35$var$CustomAggregateError = $fKwjf.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $9523220ae4a98a35$var$AggregateError = globalThis.AggregateError || $9523220ae4a98a35$var$CustomAggregateError;
var $9523220ae4a98a35$var$kIsNodeError = Symbol('kIsNodeError');
var $9523220ae4a98a35$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $9523220ae4a98a35$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $9523220ae4a98a35$var$nodeInternalPrefix = '__node_internal_';
var $9523220ae4a98a35$var$codes = {};
function $9523220ae4a98a35$var$assert(value, message) {
    if (!value) throw new $9523220ae4a98a35$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $9523220ae4a98a35$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $9523220ae4a98a35$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $9523220ae4a98a35$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $9523220ae4a98a35$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $9523220ae4a98a35$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $9523220ae4a98a35$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $9523220ae4a98a35$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$9523220ae4a98a35$var$kIsNodeError] = true;
    $9523220ae4a98a35$var$codes[code] = NodeError;
}
function $9523220ae4a98a35$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $9523220ae4a98a35$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $9523220ae4a98a35$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $9523220ae4a98a35$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $9523220ae4a98a35$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $9523220ae4a98a35$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$9523220ae4a98a35$var$E('ERR_ASSERTION', '%s', Error);
$9523220ae4a98a35$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $9523220ae4a98a35$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $9523220ae4a98a35$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($9523220ae4a98a35$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($9523220ae4a98a35$var$classRegExp.test(value)) instances.push(value);
            else {
                $9523220ae4a98a35$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $9523220ae4a98a35$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $9523220ae4a98a35$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$9523220ae4a98a35$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $9523220ae4a98a35$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$9523220ae4a98a35$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$9523220ae4a98a35$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $9523220ae4a98a35$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$9523220ae4a98a35$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $9523220ae4a98a35$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $9523220ae4a98a35$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $9523220ae4a98a35$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $9523220ae4a98a35$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$9523220ae4a98a35$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$9523220ae4a98a35$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$9523220ae4a98a35$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$9523220ae4a98a35$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$9523220ae4a98a35$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $9523220ae4a98a35$var$AbortError,
    aggregateTwoErrors: $9523220ae4a98a35$var$hideStackFrames($9523220ae4a98a35$var$aggregateTwoErrors),
    hideStackFrames: $9523220ae4a98a35$var$hideStackFrames,
    codes: $9523220ae4a98a35$var$codes
};

});


parcelRegister("1A9U1", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $1270d5aba7a14665$export$42af8c323be37587; }, function (v) { return $1270d5aba7a14665$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $1270d5aba7a14665$export$f405f72c701dad87; }, function (v) { return $1270d5aba7a14665$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $1270d5aba7a14665$export$42af8c323be37587;
var $1270d5aba7a14665$export$f405f72c701dad87;
'use strict';

var $1270d5aba7a14665$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $cNQWQ = parcelRequire("cNQWQ");
var $1270d5aba7a14665$var$_require_codes = $cNQWQ.codes, $1270d5aba7a14665$var$ERR_INVALID_ARG_VALUE = $1270d5aba7a14665$var$_require_codes.ERR_INVALID_ARG_VALUE, $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE = $1270d5aba7a14665$var$_require_codes.ERR_INVALID_ARG_TYPE, $1270d5aba7a14665$var$ERR_MISSING_ARGS = $1270d5aba7a14665$var$_require_codes.ERR_MISSING_ARGS, $1270d5aba7a14665$var$ERR_OUT_OF_RANGE = $1270d5aba7a14665$var$_require_codes.ERR_OUT_OF_RANGE, $1270d5aba7a14665$var$AbortError = $cNQWQ.AbortError;

var $hbaXS = parcelRequire("hbaXS");
var $1270d5aba7a14665$var$validateAbortSignal = $hbaXS.validateAbortSignal, $1270d5aba7a14665$var$validateInteger = $hbaXS.validateInteger, $1270d5aba7a14665$var$validateObject = $hbaXS.validateObject;

var $1270d5aba7a14665$var$kWeakHandler = (parcelRequire("fKwjf")).Symbol('kWeak');

var $1270d5aba7a14665$var$kResistStopPropagation = (parcelRequire("fKwjf")).Symbol('kResistStopPropagation');

var $fvjOO = parcelRequire("fvjOO");
var $1270d5aba7a14665$require$finished = $fvjOO.finished;

var $dCI7E = parcelRequire("dCI7E");

var $bcrOJ = parcelRequire("bcrOJ");
var $1270d5aba7a14665$require$addAbortSignalNoValidate = $bcrOJ.addAbortSignalNoValidate;

var $eYXq6 = parcelRequire("eYXq6");
var $1270d5aba7a14665$var$isWritable = $eYXq6.isWritable, $1270d5aba7a14665$var$isNodeStream = $eYXq6.isNodeStream;

var $1270d5aba7a14665$require$deprecate = (parcelRequire("kigZM")).deprecate;

var $1270d5aba7a14665$var$ArrayPrototypePush = (parcelRequire("fKwjf")).ArrayPrototypePush, $1270d5aba7a14665$var$Boolean = (parcelRequire("fKwjf")).Boolean, $1270d5aba7a14665$var$MathFloor = (parcelRequire("fKwjf")).MathFloor, $1270d5aba7a14665$var$Number = (parcelRequire("fKwjf")).Number, $1270d5aba7a14665$var$NumberIsNaN = (parcelRequire("fKwjf")).NumberIsNaN, $1270d5aba7a14665$var$Promise = (parcelRequire("fKwjf")).Promise, $1270d5aba7a14665$var$PromiseReject = (parcelRequire("fKwjf")).PromiseReject, $1270d5aba7a14665$var$PromiseResolve = (parcelRequire("fKwjf")).PromiseResolve, $1270d5aba7a14665$var$PromisePrototypeThen = (parcelRequire("fKwjf")).PromisePrototypeThen, $1270d5aba7a14665$var$Symbol = (parcelRequire("fKwjf")).Symbol;
var $1270d5aba7a14665$var$kEmpty = $1270d5aba7a14665$var$Symbol('kEmpty');
var $1270d5aba7a14665$var$kEof = $1270d5aba7a14665$var$Symbol('kEof');
function $1270d5aba7a14665$var$compose(stream, options) {
    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
    if ($1270d5aba7a14665$var$isNodeStream(stream) && !$1270d5aba7a14665$var$isWritable(stream)) throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $dCI7E(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $1270d5aba7a14665$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $1270d5aba7a14665$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $1270d5aba7a14665$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $1270d5aba7a14665$var$MathFloor(options.highWaterMark);
    $1270d5aba7a14665$var$validateInteger(concurrency, 'options.concurrency', 1);
    $1270d5aba7a14665$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $1270d5aba7a14665$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $1270d5aba7a14665$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $1270d5aba7a14665$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $1270d5aba7a14665$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $1270d5aba7a14665$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $1270d5aba7a14665$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($1270d5aba7a14665$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $1270d5aba7a14665$var$PromiseReject(err1);
                                $1270d5aba7a14665$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("kigZM")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($1270d5aba7a14665$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $1270d5aba7a14665$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $1270d5aba7a14665$var$AbortError();
                        if (!(val !== $1270d5aba7a14665$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $1270d5aba7a14665$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $1270d5aba7a14665$var$asIndexedPairs(options) {
    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $1270d5aba7a14665$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $1270d5aba7a14665$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($1270d5aba7a14665$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $1270d5aba7a14665$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $1270d5aba7a14665$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $1270d5aba7a14665$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($1270d5aba7a14665$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $1270d5aba7a14665$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $1270d5aba7a14665$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($1270d5aba7a14665$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $1270d5aba7a14665$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $1270d5aba7a14665$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $1270d5aba7a14665$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $1270d5aba7a14665$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($1270d5aba7a14665$var$ERR_MISSING_ARGS);
function $1270d5aba7a14665$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $1270d5aba7a14665$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $1270d5aba7a14665$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $1270d5aba7a14665$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $1270d5aba7a14665$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $1270d5aba7a14665$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $1270d5aba7a14665$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $1270d5aba7a14665$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $1270d5aba7a14665$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $1270d5aba7a14665$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $1270d5aba7a14665$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $1270d5aba7a14665$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $1270d5aba7a14665$var$flatMap(fn, options) {
    var values = $1270d5aba7a14665$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $1270d5aba7a14665$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $1270d5aba7a14665$var$Number(number);
    if ($1270d5aba7a14665$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $1270d5aba7a14665$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $1270d5aba7a14665$var$drop(number, options) {
    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
    number = $1270d5aba7a14665$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $1270d5aba7a14665$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $1270d5aba7a14665$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $1270d5aba7a14665$var$take(number, options) {
    if (options != null) $1270d5aba7a14665$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $1270d5aba7a14665$var$validateAbortSignal(options.signal, 'options.signal');
    number = $1270d5aba7a14665$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $1270d5aba7a14665$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $1270d5aba7a14665$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$1270d5aba7a14665$export$42af8c323be37587 = {
    asIndexedPairs: $1270d5aba7a14665$require$deprecate($1270d5aba7a14665$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $1270d5aba7a14665$var$drop,
    filter: $1270d5aba7a14665$var$filter,
    flatMap: $1270d5aba7a14665$var$flatMap,
    map: $1270d5aba7a14665$var$map,
    take: $1270d5aba7a14665$var$take,
    compose: $1270d5aba7a14665$var$compose
};
$1270d5aba7a14665$export$f405f72c701dad87 = {
    every: $1270d5aba7a14665$var$every,
    forEach: $1270d5aba7a14665$var$forEach,
    reduce: $1270d5aba7a14665$var$reduce,
    toArray: $1270d5aba7a14665$var$toArray,
    some: $1270d5aba7a14665$var$some,
    find: $1270d5aba7a14665$var$find
};

});
parcelRegister("hbaXS", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $c81bf81f9d0426b1$var$ArrayIsArray = $fKwjf.ArrayIsArray, $c81bf81f9d0426b1$var$ArrayPrototypeIncludes = $fKwjf.ArrayPrototypeIncludes, $c81bf81f9d0426b1$var$ArrayPrototypeJoin = $fKwjf.ArrayPrototypeJoin, $c81bf81f9d0426b1$var$ArrayPrototypeMap = $fKwjf.ArrayPrototypeMap, $c81bf81f9d0426b1$var$NumberIsInteger = $fKwjf.NumberIsInteger, $c81bf81f9d0426b1$var$NumberIsNaN = $fKwjf.NumberIsNaN, $c81bf81f9d0426b1$var$NumberMAX_SAFE_INTEGER = $fKwjf.NumberMAX_SAFE_INTEGER, $c81bf81f9d0426b1$var$NumberMIN_SAFE_INTEGER = $fKwjf.NumberMIN_SAFE_INTEGER, $c81bf81f9d0426b1$var$NumberParseInt = $fKwjf.NumberParseInt, $c81bf81f9d0426b1$var$ObjectPrototypeHasOwnProperty = $fKwjf.ObjectPrototypeHasOwnProperty, $c81bf81f9d0426b1$var$RegExpPrototypeExec = $fKwjf.RegExpPrototypeExec, $c81bf81f9d0426b1$var$String = $fKwjf.String, $c81bf81f9d0426b1$var$StringPrototypeToUpperCase = $fKwjf.StringPrototypeToUpperCase, $c81bf81f9d0426b1$var$StringPrototypeTrim = $fKwjf.StringPrototypeTrim;

var $cNQWQ = parcelRequire("cNQWQ");
var $c81bf81f9d0426b1$var$hideStackFrames = $cNQWQ.hideStackFrames, $c81bf81f9d0426b1$var$_require_codes = $cNQWQ.codes, $c81bf81f9d0426b1$var$ERR_SOCKET_BAD_PORT = $c81bf81f9d0426b1$var$_require_codes.ERR_SOCKET_BAD_PORT, $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE = $c81bf81f9d0426b1$var$_require_codes.ERR_INVALID_ARG_TYPE, $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE = $c81bf81f9d0426b1$var$_require_codes.ERR_INVALID_ARG_VALUE, $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE = $c81bf81f9d0426b1$var$_require_codes.ERR_OUT_OF_RANGE, $c81bf81f9d0426b1$var$ERR_UNKNOWN_SIGNAL = $c81bf81f9d0426b1$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $kigZM = parcelRequire("kigZM");
var $c81bf81f9d0426b1$require$normalizeEncoding = $kigZM.normalizeEncoding;

var $kigZM = parcelRequire("kigZM");
var $c81bf81f9d0426b1$require$_require_types = $kigZM.types;
var $c81bf81f9d0426b1$var$isAsyncFunction = $c81bf81f9d0426b1$require$_require_types.isAsyncFunction, $c81bf81f9d0426b1$var$isArrayBufferView = $c81bf81f9d0426b1$require$_require_types.isArrayBufferView;
var $c81bf81f9d0426b1$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $c81bf81f9d0426b1$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $c81bf81f9d0426b1$var$isUint32(value) {
    return value === value >>> 0;
}
var $c81bf81f9d0426b1$var$octalReg = /^[0-7]+$/;
var $c81bf81f9d0426b1$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $c81bf81f9d0426b1$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($c81bf81f9d0426b1$var$RegExpPrototypeExec($c81bf81f9d0426b1$var$octalReg, value) === null) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE(name, value, $c81bf81f9d0426b1$var$modeDesc);
        value = $c81bf81f9d0426b1$var$NumberParseInt(value, 8);
    }
    $c81bf81f9d0426b1$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $c81bf81f9d0426b1$var$validateInteger = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c81bf81f9d0426b1$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $c81bf81f9d0426b1$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c81bf81f9d0426b1$var$NumberIsInteger(value)) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $c81bf81f9d0426b1$var$validateInt32 = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c81bf81f9d0426b1$var$NumberIsInteger(value)) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $c81bf81f9d0426b1$var$validateUint32 = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c81bf81f9d0426b1$var$NumberIsInteger(value)) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $c81bf81f9d0426b1$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $c81bf81f9d0426b1$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $c81bf81f9d0426b1$var$NumberIsNaN(value)) throw new $c81bf81f9d0426b1$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $c81bf81f9d0426b1$var$validateOneOf = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name, oneOf) {
    if (!$c81bf81f9d0426b1$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $c81bf81f9d0426b1$var$ArrayPrototypeJoin($c81bf81f9d0426b1$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $c81bf81f9d0426b1$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $c81bf81f9d0426b1$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $c81bf81f9d0426b1$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$c81bf81f9d0426b1$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $c81bf81f9d0426b1$var$validateObject = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $c81bf81f9d0426b1$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $c81bf81f9d0426b1$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $c81bf81f9d0426b1$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $c81bf81f9d0426b1$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $c81bf81f9d0426b1$var$validateDictionary = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $c81bf81f9d0426b1$var$validateArray = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$c81bf81f9d0426b1$var$ArrayIsArray(value)) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $c81bf81f9d0426b1$var$validateStringArray(value, name) {
    $c81bf81f9d0426b1$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$c81bf81f9d0426b1$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $c81bf81f9d0426b1$var$validateBooleanArray(value, name) {
    $c81bf81f9d0426b1$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$c81bf81f9d0426b1$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $c81bf81f9d0426b1$var$validateAbortSignalArray(value, name) {
    $c81bf81f9d0426b1$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $c81bf81f9d0426b1$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $c81bf81f9d0426b1$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $c81bf81f9d0426b1$var$validateString(signal, name);
    if ($c81bf81f9d0426b1$var$signals[signal] === undefined) {
        if ($c81bf81f9d0426b1$var$signals[$c81bf81f9d0426b1$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $c81bf81f9d0426b1$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $c81bf81f9d0426b1$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $c81bf81f9d0426b1$var$validateBuffer = $c81bf81f9d0426b1$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$c81bf81f9d0426b1$var$isArrayBufferView(buffer)) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $c81bf81f9d0426b1$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $c81bf81f9d0426b1$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $c81bf81f9d0426b1$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $c81bf81f9d0426b1$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $c81bf81f9d0426b1$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $c81bf81f9d0426b1$var$validateAbortSignal = $c81bf81f9d0426b1$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $c81bf81f9d0426b1$var$validateFunction = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $c81bf81f9d0426b1$var$validatePlainFunction = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $c81bf81f9d0426b1$var$isAsyncFunction(value)) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $c81bf81f9d0426b1$var$validateUndefined = $c81bf81f9d0426b1$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $c81bf81f9d0426b1$var$validateUnion(value, name, union) {
    if (!$c81bf81f9d0426b1$var$ArrayPrototypeIncludes(union, value)) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_TYPE(name, "('".concat($c81bf81f9d0426b1$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $c81bf81f9d0426b1$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $c81bf81f9d0426b1$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$c81bf81f9d0426b1$var$RegExpPrototypeExec($c81bf81f9d0426b1$var$linkValueRegExp, value)) throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $c81bf81f9d0426b1$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $c81bf81f9d0426b1$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($c81bf81f9d0426b1$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $c81bf81f9d0426b1$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $c81bf81f9d0426b1$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $c81bf81f9d0426b1$var$isInt32,
    isUint32: $c81bf81f9d0426b1$var$isUint32,
    parseFileMode: $c81bf81f9d0426b1$var$parseFileMode,
    validateArray: $c81bf81f9d0426b1$var$validateArray,
    validateStringArray: $c81bf81f9d0426b1$var$validateStringArray,
    validateBooleanArray: $c81bf81f9d0426b1$var$validateBooleanArray,
    validateAbortSignalArray: $c81bf81f9d0426b1$var$validateAbortSignalArray,
    validateBoolean: $c81bf81f9d0426b1$var$validateBoolean,
    validateBuffer: $c81bf81f9d0426b1$var$validateBuffer,
    validateDictionary: $c81bf81f9d0426b1$var$validateDictionary,
    validateEncoding: $c81bf81f9d0426b1$var$validateEncoding,
    validateFunction: $c81bf81f9d0426b1$var$validateFunction,
    validateInt32: $c81bf81f9d0426b1$var$validateInt32,
    validateInteger: $c81bf81f9d0426b1$var$validateInteger,
    validateNumber: $c81bf81f9d0426b1$var$validateNumber,
    validateObject: $c81bf81f9d0426b1$var$validateObject,
    validateOneOf: $c81bf81f9d0426b1$var$validateOneOf,
    validatePlainFunction: $c81bf81f9d0426b1$var$validatePlainFunction,
    validatePort: $c81bf81f9d0426b1$var$validatePort,
    validateSignalName: $c81bf81f9d0426b1$var$validateSignalName,
    validateString: $c81bf81f9d0426b1$var$validateString,
    validateUint32: $c81bf81f9d0426b1$var$validateUint32,
    validateUndefined: $c81bf81f9d0426b1$var$validateUndefined,
    validateUnion: $c81bf81f9d0426b1$var$validateUnion,
    validateAbortSignal: $c81bf81f9d0426b1$var$validateAbortSignal,
    validateLinkHeaderValue: $c81bf81f9d0426b1$var$validateLinkHeaderValue
};

});

parcelRegister("fvjOO", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $cNQWQ = parcelRequire("cNQWQ");
/* replacement end */ var $b4991fd62dc28c53$var$AbortError = $cNQWQ.AbortError, $b4991fd62dc28c53$var$codes = $cNQWQ.codes;
var $b4991fd62dc28c53$var$ERR_INVALID_ARG_TYPE = $b4991fd62dc28c53$var$codes.ERR_INVALID_ARG_TYPE, $b4991fd62dc28c53$var$ERR_STREAM_PREMATURE_CLOSE = $b4991fd62dc28c53$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $b4991fd62dc28c53$var$kEmptyObject = (parcelRequire("kigZM")).kEmptyObject, $b4991fd62dc28c53$var$once = (parcelRequire("kigZM")).once;

var $hbaXS = parcelRequire("hbaXS");
var $b4991fd62dc28c53$var$validateAbortSignal = $hbaXS.validateAbortSignal, $b4991fd62dc28c53$var$validateFunction = $hbaXS.validateFunction, $b4991fd62dc28c53$var$validateObject = $hbaXS.validateObject, $b4991fd62dc28c53$var$validateBoolean = $hbaXS.validateBoolean;

var $fKwjf = parcelRequire("fKwjf");
var $b4991fd62dc28c53$var$Promise = $fKwjf.Promise, $b4991fd62dc28c53$var$PromisePrototypeThen = $fKwjf.PromisePrototypeThen, $b4991fd62dc28c53$var$SymbolDispose = $fKwjf.SymbolDispose;

var $eYXq6 = parcelRequire("eYXq6");
var $b4991fd62dc28c53$var$isClosed = $eYXq6.isClosed, $b4991fd62dc28c53$var$isReadable = $eYXq6.isReadable, $b4991fd62dc28c53$var$isReadableNodeStream = $eYXq6.isReadableNodeStream, $b4991fd62dc28c53$var$isReadableStream = $eYXq6.isReadableStream, $b4991fd62dc28c53$var$isReadableFinished = $eYXq6.isReadableFinished, $b4991fd62dc28c53$var$isReadableErrored = $eYXq6.isReadableErrored, $b4991fd62dc28c53$var$isWritable = $eYXq6.isWritable, $b4991fd62dc28c53$var$isWritableNodeStream = $eYXq6.isWritableNodeStream, $b4991fd62dc28c53$var$isWritableStream = $eYXq6.isWritableStream, $b4991fd62dc28c53$var$isWritableFinished = $eYXq6.isWritableFinished, $b4991fd62dc28c53$var$isWritableErrored = $eYXq6.isWritableErrored, $b4991fd62dc28c53$var$isNodeStream = $eYXq6.isNodeStream, $b4991fd62dc28c53$var$_willEmitClose = $eYXq6.willEmitClose, $b4991fd62dc28c53$var$kIsClosedPromise = $eYXq6.kIsClosedPromise;
var $b4991fd62dc28c53$var$addAbortListener;
function $b4991fd62dc28c53$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $b4991fd62dc28c53$var$nop = function() {};

function $b4991fd62dc28c53$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $b4991fd62dc28c53$var$kEmptyObject;
    } else if (options == null) options = $b4991fd62dc28c53$var$kEmptyObject;
    else $b4991fd62dc28c53$var$validateObject(options, 'options');
    $b4991fd62dc28c53$var$validateFunction(callback, 'callback');
    $b4991fd62dc28c53$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $b4991fd62dc28c53$var$once(callback);
    if ($b4991fd62dc28c53$var$isReadableStream(stream) || $b4991fd62dc28c53$var$isWritableStream(stream)) return $b4991fd62dc28c53$var$eosWeb(stream, options, callback);
    if (!$b4991fd62dc28c53$var$isNodeStream(stream)) throw new $b4991fd62dc28c53$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $b4991fd62dc28c53$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $b4991fd62dc28c53$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $b4991fd62dc28c53$var$_willEmitClose(stream) && $b4991fd62dc28c53$var$isReadableNodeStream(stream) === readable && $b4991fd62dc28c53$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $b4991fd62dc28c53$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $b4991fd62dc28c53$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $b4991fd62dc28c53$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $b4991fd62dc28c53$var$isWritableErrored(stream) || $b4991fd62dc28c53$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $b4991fd62dc28c53$var$isReadableNodeStream(stream, true)) {
            if (!$b4991fd62dc28c53$var$isReadableFinished(stream, false)) return callback.call(stream, new $b4991fd62dc28c53$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$b4991fd62dc28c53$var$isWritableFinished(stream, false)) return callback.call(stream, new $b4991fd62dc28c53$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $b4991fd62dc28c53$var$isWritableErrored(stream) || $b4991fd62dc28c53$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($b4991fd62dc28c53$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $b4991fd62dc28c53$var$isReadable(stream)) && (writableFinished || $b4991fd62dc28c53$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $b4991fd62dc28c53$var$isWritable(stream)) && (readableFinished || $b4991fd62dc28c53$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $b4991fd62dc28c53$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $b4991fd62dc28c53$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $b4991fd62dc28c53$var$addAbortListener = $b4991fd62dc28c53$var$addAbortListener || (parcelRequire("kigZM")).addAbortListener;
            var disposable = $b4991fd62dc28c53$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $b4991fd62dc28c53$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$b4991fd62dc28c53$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $b4991fd62dc28c53$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $b4991fd62dc28c53$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $b4991fd62dc28c53$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $b4991fd62dc28c53$var$addAbortListener = $b4991fd62dc28c53$var$addAbortListener || (parcelRequire("kigZM")).addAbortListener;
            var disposable = $b4991fd62dc28c53$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $b4991fd62dc28c53$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$b4991fd62dc28c53$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $b4991fd62dc28c53$var$PromisePrototypeThen(stream[$b4991fd62dc28c53$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $b4991fd62dc28c53$var$nop;
}
function $b4991fd62dc28c53$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $b4991fd62dc28c53$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $b4991fd62dc28c53$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $b4991fd62dc28c53$var$Promise(function(resolve, reject) {
        var cleanup = $b4991fd62dc28c53$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $b4991fd62dc28c53$var$eos;
module.exports.finished = $b4991fd62dc28c53$var$finished;

});
parcelRegister("eYXq6", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $ae84c2dac784a999$var$SymbolAsyncIterator = $fKwjf.SymbolAsyncIterator, $ae84c2dac784a999$var$SymbolIterator = $fKwjf.SymbolIterator, $ae84c2dac784a999$var$SymbolFor = $fKwjf.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $ae84c2dac784a999$var$kIsDestroyed = $ae84c2dac784a999$var$SymbolFor('nodejs.stream.destroyed');
var $ae84c2dac784a999$var$kIsErrored = $ae84c2dac784a999$var$SymbolFor('nodejs.stream.errored');
var $ae84c2dac784a999$var$kIsReadable = $ae84c2dac784a999$var$SymbolFor('nodejs.stream.readable');
var $ae84c2dac784a999$var$kIsWritable = $ae84c2dac784a999$var$SymbolFor('nodejs.stream.writable');
var $ae84c2dac784a999$var$kIsDisturbed = $ae84c2dac784a999$var$SymbolFor('nodejs.stream.disturbed');
var $ae84c2dac784a999$var$kIsClosedPromise = $ae84c2dac784a999$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $ae84c2dac784a999$var$kControllerErrorFunction = $ae84c2dac784a999$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $ae84c2dac784a999$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $ae84c2dac784a999$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $ae84c2dac784a999$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $ae84c2dac784a999$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $ae84c2dac784a999$var$isReadableStream(obj) {
    return !!(obj && !$ae84c2dac784a999$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $ae84c2dac784a999$var$isWritableStream(obj) {
    return !!(obj && !$ae84c2dac784a999$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $ae84c2dac784a999$var$isTransformStream(obj) {
    return !!(obj && !$ae84c2dac784a999$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $ae84c2dac784a999$var$isWebStream(obj) {
    return $ae84c2dac784a999$var$isReadableStream(obj) || $ae84c2dac784a999$var$isWritableStream(obj) || $ae84c2dac784a999$var$isTransformStream(obj);
}
function $ae84c2dac784a999$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$ae84c2dac784a999$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$ae84c2dac784a999$var$SymbolIterator] === 'function';
    return typeof obj[$ae84c2dac784a999$var$SymbolAsyncIterator] === 'function' || typeof obj[$ae84c2dac784a999$var$SymbolIterator] === 'function';
}
function $ae84c2dac784a999$var$isDestroyed(stream) {
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$ae84c2dac784a999$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $ae84c2dac784a999$var$isWritableEnded(stream) {
    if (!$ae84c2dac784a999$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $ae84c2dac784a999$var$isWritableFinished(stream, strict) {
    if (!$ae84c2dac784a999$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $ae84c2dac784a999$var$isReadableEnded(stream) {
    if (!$ae84c2dac784a999$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $ae84c2dac784a999$var$isReadableFinished(stream, strict) {
    if (!$ae84c2dac784a999$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $ae84c2dac784a999$var$isReadable(stream) {
    if (stream && stream[$ae84c2dac784a999$var$kIsReadable] != null) return stream[$ae84c2dac784a999$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($ae84c2dac784a999$var$isDestroyed(stream)) return false;
    return $ae84c2dac784a999$var$isReadableNodeStream(stream) && stream.readable && !$ae84c2dac784a999$var$isReadableFinished(stream);
}
function $ae84c2dac784a999$var$isWritable(stream) {
    if (stream && stream[$ae84c2dac784a999$var$kIsWritable] != null) return stream[$ae84c2dac784a999$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($ae84c2dac784a999$var$isDestroyed(stream)) return false;
    return $ae84c2dac784a999$var$isWritableNodeStream(stream) && stream.writable && !$ae84c2dac784a999$var$isWritableEnded(stream);
}
function $ae84c2dac784a999$var$isFinished(stream, opts) {
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    if ($ae84c2dac784a999$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $ae84c2dac784a999$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $ae84c2dac784a999$var$isWritable(stream)) return false;
    return true;
}
function $ae84c2dac784a999$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $ae84c2dac784a999$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $ae84c2dac784a999$var$isClosed(stream) {
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $ae84c2dac784a999$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $ae84c2dac784a999$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $ae84c2dac784a999$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $ae84c2dac784a999$var$isOutgoingMessage(stream);
}
function $ae84c2dac784a999$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $ae84c2dac784a999$var$willEmitClose(stream) {
    if (!$ae84c2dac784a999$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $ae84c2dac784a999$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $ae84c2dac784a999$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$ae84c2dac784a999$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $ae84c2dac784a999$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$ae84c2dac784a999$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $ae84c2dac784a999$var$isDestroyed,
    kIsDestroyed: $ae84c2dac784a999$var$kIsDestroyed,
    isDisturbed: $ae84c2dac784a999$var$isDisturbed,
    kIsDisturbed: $ae84c2dac784a999$var$kIsDisturbed,
    isErrored: $ae84c2dac784a999$var$isErrored,
    kIsErrored: $ae84c2dac784a999$var$kIsErrored,
    isReadable: $ae84c2dac784a999$var$isReadable,
    kIsReadable: $ae84c2dac784a999$var$kIsReadable,
    kIsClosedPromise: $ae84c2dac784a999$var$kIsClosedPromise,
    kControllerErrorFunction: $ae84c2dac784a999$var$kControllerErrorFunction,
    kIsWritable: $ae84c2dac784a999$var$kIsWritable,
    isClosed: $ae84c2dac784a999$var$isClosed,
    isDuplexNodeStream: $ae84c2dac784a999$var$isDuplexNodeStream,
    isFinished: $ae84c2dac784a999$var$isFinished,
    isIterable: $ae84c2dac784a999$var$isIterable,
    isReadableNodeStream: $ae84c2dac784a999$var$isReadableNodeStream,
    isReadableStream: $ae84c2dac784a999$var$isReadableStream,
    isReadableEnded: $ae84c2dac784a999$var$isReadableEnded,
    isReadableFinished: $ae84c2dac784a999$var$isReadableFinished,
    isReadableErrored: $ae84c2dac784a999$var$isReadableErrored,
    isNodeStream: $ae84c2dac784a999$var$isNodeStream,
    isWebStream: $ae84c2dac784a999$var$isWebStream,
    isWritable: $ae84c2dac784a999$var$isWritable,
    isWritableNodeStream: $ae84c2dac784a999$var$isWritableNodeStream,
    isWritableStream: $ae84c2dac784a999$var$isWritableStream,
    isWritableEnded: $ae84c2dac784a999$var$isWritableEnded,
    isWritableFinished: $ae84c2dac784a999$var$isWritableFinished,
    isWritableErrored: $ae84c2dac784a999$var$isWritableErrored,
    isServerRequest: $ae84c2dac784a999$var$isServerRequest,
    isServerResponse: $ae84c2dac784a999$var$isServerResponse,
    willEmitClose: $ae84c2dac784a999$var$willEmitClose,
    isTransformStream: $ae84c2dac784a999$var$isTransformStream
};

});


parcelRegister("dCI7E", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $gKhO1 = parcelRequire("gKhO1");
var $9eb10cc791f159e3$require$pipeline = $gKhO1.pipeline;

var $1MYa6 = parcelRequire("1MYa6");

var $hSI17 = parcelRequire("hSI17");
var $9eb10cc791f159e3$require$destroyer = $hSI17.destroyer;

var $eYXq6 = parcelRequire("eYXq6");
var $9eb10cc791f159e3$var$isNodeStream = $eYXq6.isNodeStream, $9eb10cc791f159e3$var$isReadable = $eYXq6.isReadable, $9eb10cc791f159e3$var$isWritable = $eYXq6.isWritable, $9eb10cc791f159e3$var$isWebStream = $eYXq6.isWebStream, $9eb10cc791f159e3$var$isTransformStream = $eYXq6.isTransformStream, $9eb10cc791f159e3$var$isWritableStream = $eYXq6.isWritableStream, $9eb10cc791f159e3$var$isReadableStream = $eYXq6.isReadableStream;

var $cNQWQ = parcelRequire("cNQWQ");
var $9eb10cc791f159e3$var$AbortError = $cNQWQ.AbortError, $9eb10cc791f159e3$var$_require_codes = $cNQWQ.codes, $9eb10cc791f159e3$var$ERR_INVALID_ARG_VALUE = $9eb10cc791f159e3$var$_require_codes.ERR_INVALID_ARG_VALUE, $9eb10cc791f159e3$var$ERR_MISSING_ARGS = $9eb10cc791f159e3$var$_require_codes.ERR_MISSING_ARGS;

var $fvjOO = parcelRequire("fvjOO");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $9eb10cc791f159e3$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1MYa6.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $1MYa6.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $1MYa6.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$9eb10cc791f159e3$var$isNodeStream(streams[n]) && !$9eb10cc791f159e3$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($9eb10cc791f159e3$var$isReadable(streams[n]) || $9eb10cc791f159e3$var$isReadableStream(streams[n]) || $9eb10cc791f159e3$var$isTransformStream(streams[n]))) throw new $9eb10cc791f159e3$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($9eb10cc791f159e3$var$isWritable(streams[n]) || $9eb10cc791f159e3$var$isWritableStream(streams[n]) || $9eb10cc791f159e3$var$isTransformStream(streams[n]))) throw new $9eb10cc791f159e3$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $9eb10cc791f159e3$require$pipeline(streams, onfinished);
    var writable = !!($9eb10cc791f159e3$var$isWritable(head) || $9eb10cc791f159e3$var$isWritableStream(head) || $9eb10cc791f159e3$var$isTransformStream(head));
    var readable = !!($9eb10cc791f159e3$var$isReadable(tail) || $9eb10cc791f159e3$var$isReadableStream(tail) || $9eb10cc791f159e3$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1MYa6({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($9eb10cc791f159e3$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($9eb10cc791f159e3$var$isWebStream(head)) {
            var writable1 = $9eb10cc791f159e3$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $9eb10cc791f159e3$var$isTransformStream(tail) ? tail.readable : tail;
        $fvjOO(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($9eb10cc791f159e3$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($9eb10cc791f159e3$var$isWebStream(tail)) {
            var readable1 = $9eb10cc791f159e3$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9eb10cc791f159e3$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($9eb10cc791f159e3$var$isNodeStream(tail)) $9eb10cc791f159e3$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("gKhO1", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $c30ec11a84f38c16$var$ArrayIsArray = $fKwjf.ArrayIsArray, $c30ec11a84f38c16$var$Promise = $fKwjf.Promise, $c30ec11a84f38c16$var$SymbolAsyncIterator = $fKwjf.SymbolAsyncIterator, $c30ec11a84f38c16$var$SymbolDispose = $fKwjf.SymbolDispose;

var $fvjOO = parcelRequire("fvjOO");

var $c30ec11a84f38c16$require$once = (parcelRequire("kigZM")).once;

var $hSI17 = parcelRequire("hSI17");

var $1MYa6 = parcelRequire("1MYa6");

var $cNQWQ = parcelRequire("cNQWQ");
var $c30ec11a84f38c16$var$aggregateTwoErrors = $cNQWQ.aggregateTwoErrors, $c30ec11a84f38c16$var$_require_codes = $cNQWQ.codes, $c30ec11a84f38c16$var$ERR_INVALID_ARG_TYPE = $c30ec11a84f38c16$var$_require_codes.ERR_INVALID_ARG_TYPE, $c30ec11a84f38c16$var$ERR_INVALID_RETURN_VALUE = $c30ec11a84f38c16$var$_require_codes.ERR_INVALID_RETURN_VALUE, $c30ec11a84f38c16$var$ERR_MISSING_ARGS = $c30ec11a84f38c16$var$_require_codes.ERR_MISSING_ARGS, $c30ec11a84f38c16$var$ERR_STREAM_DESTROYED = $c30ec11a84f38c16$var$_require_codes.ERR_STREAM_DESTROYED, $c30ec11a84f38c16$var$ERR_STREAM_PREMATURE_CLOSE = $c30ec11a84f38c16$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $c30ec11a84f38c16$var$AbortError = $cNQWQ.AbortError;

var $hbaXS = parcelRequire("hbaXS");
var $c30ec11a84f38c16$var$validateFunction = $hbaXS.validateFunction, $c30ec11a84f38c16$var$validateAbortSignal = $hbaXS.validateAbortSignal;

var $eYXq6 = parcelRequire("eYXq6");
var $c30ec11a84f38c16$var$isIterable = $eYXq6.isIterable, $c30ec11a84f38c16$var$isReadable = $eYXq6.isReadable, $c30ec11a84f38c16$var$isReadableNodeStream = $eYXq6.isReadableNodeStream, $c30ec11a84f38c16$var$isNodeStream = $eYXq6.isNodeStream, $c30ec11a84f38c16$var$isTransformStream = $eYXq6.isTransformStream, $c30ec11a84f38c16$var$isWebStream = $eYXq6.isWebStream, $c30ec11a84f38c16$var$isReadableStream = $eYXq6.isReadableStream, $c30ec11a84f38c16$var$isReadableFinished = $eYXq6.isReadableFinished;

var $c30ec11a84f38c16$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $c30ec11a84f38c16$var$PassThrough;
var $c30ec11a84f38c16$var$Readable;
var $c30ec11a84f38c16$var$addAbortListener;
function $c30ec11a84f38c16$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $fvjOO(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $hSI17.destroyer(stream, err || new $c30ec11a84f38c16$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $c30ec11a84f38c16$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $c30ec11a84f38c16$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $c30ec11a84f38c16$var$makeAsyncIterable(val) {
    if ($c30ec11a84f38c16$var$isIterable(val)) return val;
    else if ($c30ec11a84f38c16$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $c30ec11a84f38c16$var$fromReadable(val);
    throw new $c30ec11a84f38c16$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $c30ec11a84f38c16$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$c30ec11a84f38c16$var$Readable) $c30ec11a84f38c16$var$Readable = (parcelRequire("uUoiN"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($c30ec11a84f38c16$var$Readable.prototype[$c30ec11a84f38c16$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $c30ec11a84f38c16$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $c30ec11a84f38c16$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $fvjOO(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $c30ec11a84f38c16$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c30ec11a84f38c16$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($c30ec11a84f38c16$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c30ec11a84f38c16$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $c30ec11a84f38c16$var$pipelineImpl(streams, $c30ec11a84f38c16$require$once($c30ec11a84f38c16$var$popCallback(streams)));
}


function $c30ec11a84f38c16$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($c30ec11a84f38c16$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $c30ec11a84f38c16$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($c30ec11a84f38c16$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($c30ec11a84f38c16$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$c30ec11a84f38c16$var$isIterable(ret)) throw new $c30ec11a84f38c16$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($c30ec11a84f38c16$var$isIterable(stream) || $c30ec11a84f38c16$var$isReadableNodeStream(stream) || $c30ec11a84f38c16$var$isTransformStream(stream)) ret = stream;
            else ret = $1MYa6.from(stream);
        } else if (typeof stream === 'function') {
            if ($c30ec11a84f38c16$var$isTransformStream(ret)) {
                var _ret;
                ret = $c30ec11a84f38c16$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $c30ec11a84f38c16$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$c30ec11a84f38c16$var$isIterable(ret, true)) throw new $c30ec11a84f38c16$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$c30ec11a84f38c16$var$PassThrough) $c30ec11a84f38c16$var$PassThrough = (parcelRequire("fsm9m"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $c30ec11a84f38c16$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($c30ec11a84f38c16$var$isIterable(ret, true)) {
                    finishCount++;
                    $c30ec11a84f38c16$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($c30ec11a84f38c16$var$isReadableStream(ret) || $c30ec11a84f38c16$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $c30ec11a84f38c16$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $c30ec11a84f38c16$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $c30ec11a84f38c16$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($c30ec11a84f38c16$var$isNodeStream(stream)) {
            if ($c30ec11a84f38c16$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $c30ec11a84f38c16$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($c30ec11a84f38c16$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($c30ec11a84f38c16$var$isTransformStream(ret) || $c30ec11a84f38c16$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $c30ec11a84f38c16$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($c30ec11a84f38c16$var$isIterable(ret)) {
                finishCount++;
                $c30ec11a84f38c16$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $c30ec11a84f38c16$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($c30ec11a84f38c16$var$isWebStream(stream)) {
            if ($c30ec11a84f38c16$var$isReadableNodeStream(ret)) {
                finishCount++;
                $c30ec11a84f38c16$var$pumpToWeb($c30ec11a84f38c16$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($c30ec11a84f38c16$var$isReadableStream(ret) || $c30ec11a84f38c16$var$isIterable(ret)) {
                finishCount++;
                $c30ec11a84f38c16$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($c30ec11a84f38c16$var$isTransformStream(ret)) {
                finishCount++;
                $c30ec11a84f38c16$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $c30ec11a84f38c16$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1MYa6.from(stream);
    };
    if (streams.length === 1 && $c30ec11a84f38c16$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $c30ec11a84f38c16$var$ERR_MISSING_ARGS('streams');
    var ac = new $c30ec11a84f38c16$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $c30ec11a84f38c16$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $c30ec11a84f38c16$var$AbortError());
    }
    $c30ec11a84f38c16$var$addAbortListener = $c30ec11a84f38c16$var$addAbortListener || (parcelRequire("kigZM")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $c30ec11a84f38c16$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$c30ec11a84f38c16$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $c30ec11a84f38c16$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $c30ec11a84f38c16$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($c30ec11a84f38c16$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $fvjOO(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $fvjOO(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $c30ec11a84f38c16$var$pipelineImpl,
    pipeline: $c30ec11a84f38c16$var$pipeline
};

});
parcelRegister("hSI17", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $cNQWQ = parcelRequire("cNQWQ");
/* replacement end */ var $d0499fb09de1561a$var$aggregateTwoErrors = $cNQWQ.aggregateTwoErrors, $d0499fb09de1561a$var$ERR_MULTIPLE_CALLBACK = $cNQWQ.codes.ERR_MULTIPLE_CALLBACK, $d0499fb09de1561a$var$AbortError = $cNQWQ.AbortError;

var $fKwjf = parcelRequire("fKwjf");
var $d0499fb09de1561a$require$Symbol = $fKwjf.Symbol;

var $eYXq6 = parcelRequire("eYXq6");
var $d0499fb09de1561a$var$kIsDestroyed = $eYXq6.kIsDestroyed, $d0499fb09de1561a$var$isDestroyed = $eYXq6.isDestroyed, $d0499fb09de1561a$var$isFinished = $eYXq6.isFinished, $d0499fb09de1561a$var$isServerRequest = $eYXq6.isServerRequest;
var $d0499fb09de1561a$var$kDestroy = $d0499fb09de1561a$require$Symbol('kDestroy');
var $d0499fb09de1561a$var$kConstruct = $d0499fb09de1561a$require$Symbol('kConstruct');
function $d0499fb09de1561a$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $d0499fb09de1561a$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $d0499fb09de1561a$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($d0499fb09de1561a$var$kDestroy, function(er) {
        $d0499fb09de1561a$var$_destroy(this, $d0499fb09de1561a$var$aggregateTwoErrors(er, err), cb);
    });
    else $d0499fb09de1561a$var$_destroy(this, err, cb);
    return this;
}
function $d0499fb09de1561a$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $d0499fb09de1561a$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($d0499fb09de1561a$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($d0499fb09de1561a$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $d0499fb09de1561a$var$emitErrorCloseNT(self, err) {
    $d0499fb09de1561a$var$emitErrorNT(self, err);
    $d0499fb09de1561a$var$emitCloseNT(self);
}
function $d0499fb09de1561a$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $d0499fb09de1561a$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $d0499fb09de1561a$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $d0499fb09de1561a$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($d0499fb09de1561a$var$emitErrorNT, stream, err);
        else $d0499fb09de1561a$var$emitErrorNT(stream, err);
    }
}
function $d0499fb09de1561a$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($d0499fb09de1561a$var$kConstruct, cb);
    if (stream.listenerCount($d0499fb09de1561a$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($d0499fb09de1561a$var$constructNT, stream);
}
function $d0499fb09de1561a$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $d0499fb09de1561a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $d0499fb09de1561a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($d0499fb09de1561a$var$kDestroy, err);
        else if (err) $d0499fb09de1561a$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($d0499fb09de1561a$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $d0499fb09de1561a$var$emitConstructNT(stream) {
    stream.emit($d0499fb09de1561a$var$kConstruct);
}
function $d0499fb09de1561a$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $d0499fb09de1561a$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $d0499fb09de1561a$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($d0499fb09de1561a$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $d0499fb09de1561a$var$destroyer(stream, err) {
    if (!stream || $d0499fb09de1561a$var$isDestroyed(stream)) return;
    if (!err && !$d0499fb09de1561a$var$isFinished(stream)) err = new $d0499fb09de1561a$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($d0499fb09de1561a$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($d0499fb09de1561a$var$isRequest(stream)) stream.abort();
    else if ($d0499fb09de1561a$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($d0499fb09de1561a$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($d0499fb09de1561a$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$d0499fb09de1561a$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $d0499fb09de1561a$var$construct,
    destroyer: $d0499fb09de1561a$var$destroyer,
    destroy: $d0499fb09de1561a$var$destroy,
    undestroy: $d0499fb09de1561a$var$undestroy,
    errorOrDestroy: $d0499fb09de1561a$var$errorOrDestroy
};

});

parcelRegister("1MYa6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $14d8f1086b509f3b$var$ObjectDefineProperties = $fKwjf.ObjectDefineProperties, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor = $fKwjf.ObjectGetOwnPropertyDescriptor, $14d8f1086b509f3b$var$ObjectKeys = $fKwjf.ObjectKeys, $14d8f1086b509f3b$var$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf;
module.exports = $14d8f1086b509f3b$var$Duplex;

var $uUoiN = parcelRequire("uUoiN");

var $exdZH = parcelRequire("exdZH");
$14d8f1086b509f3b$var$ObjectSetPrototypeOf($14d8f1086b509f3b$var$Duplex.prototype, $uUoiN.prototype);
$14d8f1086b509f3b$var$ObjectSetPrototypeOf($14d8f1086b509f3b$var$Duplex, $uUoiN);
{
    var $14d8f1086b509f3b$var$keys = $14d8f1086b509f3b$var$ObjectKeys($exdZH.prototype);
    // Allow the keys array to be GC'ed.
    for(var $14d8f1086b509f3b$var$i = 0; $14d8f1086b509f3b$var$i < $14d8f1086b509f3b$var$keys.length; $14d8f1086b509f3b$var$i++){
        var $14d8f1086b509f3b$var$method = $14d8f1086b509f3b$var$keys[$14d8f1086b509f3b$var$i];
        if (!$14d8f1086b509f3b$var$Duplex.prototype[$14d8f1086b509f3b$var$method]) $14d8f1086b509f3b$var$Duplex.prototype[$14d8f1086b509f3b$var$method] = $exdZH.prototype[$14d8f1086b509f3b$var$method];
    }
}function $14d8f1086b509f3b$var$Duplex(options) {
    if (!(this instanceof $14d8f1086b509f3b$var$Duplex)) return new $14d8f1086b509f3b$var$Duplex(options);
    $uUoiN.call(this, options);
    $exdZH.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$14d8f1086b509f3b$var$ObjectDefineProperties($14d8f1086b509f3b$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $14d8f1086b509f3b$var$ObjectGetOwnPropertyDescriptor($exdZH.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $14d8f1086b509f3b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $14d8f1086b509f3b$var$lazyWebStreams() {
    if ($14d8f1086b509f3b$var$webStreamsAdapters === undefined) $14d8f1086b509f3b$var$webStreamsAdapters = {};
    return $14d8f1086b509f3b$var$webStreamsAdapters;
}
$14d8f1086b509f3b$var$Duplex.fromWeb = function(pair, options) {
    return $14d8f1086b509f3b$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$14d8f1086b509f3b$var$Duplex.toWeb = function(duplex) {
    return $14d8f1086b509f3b$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $14d8f1086b509f3b$var$duplexify;

$14d8f1086b509f3b$var$Duplex.from = function(body) {
    if (!$14d8f1086b509f3b$var$duplexify) $14d8f1086b509f3b$var$duplexify = (parcelRequire("hKhGQ"));
    return $14d8f1086b509f3b$var$duplexify(body, 'body');
};

});
parcelRegister("uUoiN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fKwjf = parcelRequire("fKwjf");
/* replacement end */ var $05ce8b87614819b6$var$ArrayPrototypeIndexOf = $fKwjf.ArrayPrototypeIndexOf, $05ce8b87614819b6$var$NumberIsInteger = $fKwjf.NumberIsInteger, $05ce8b87614819b6$var$NumberIsNaN = $fKwjf.NumberIsNaN, $05ce8b87614819b6$var$NumberParseInt = $fKwjf.NumberParseInt, $05ce8b87614819b6$var$ObjectDefineProperties = $fKwjf.ObjectDefineProperties, $05ce8b87614819b6$var$ObjectKeys = $fKwjf.ObjectKeys, $05ce8b87614819b6$var$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf, $05ce8b87614819b6$var$Promise = $fKwjf.Promise, $05ce8b87614819b6$var$SafeSet = $fKwjf.SafeSet, $05ce8b87614819b6$var$SymbolAsyncDispose = $fKwjf.SymbolAsyncDispose, $05ce8b87614819b6$var$SymbolAsyncIterator = $fKwjf.SymbolAsyncIterator, $05ce8b87614819b6$var$Symbol = $fKwjf.Symbol;
module.exports = $05ce8b87614819b6$var$Readable;
$05ce8b87614819b6$var$Readable.ReadableState = $05ce8b87614819b6$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $05ce8b87614819b6$var$EE = $bBoAO.EventEmitter;

var $fNe2J = parcelRequire("fNe2J");
var $05ce8b87614819b6$var$Stream = $fNe2J.Stream, $05ce8b87614819b6$var$prependListener = $fNe2J.prependListener;

var $jXfVE = parcelRequire("jXfVE");
var $05ce8b87614819b6$require$Buffer = $jXfVE.Buffer;

var $bcrOJ = parcelRequire("bcrOJ");
var $05ce8b87614819b6$require$addAbortSignal = $bcrOJ.addAbortSignal;

var $fvjOO = parcelRequire("fvjOO");

var $05ce8b87614819b6$var$debug = (parcelRequire("kigZM")).debuglog('stream', function(fn) {
    $05ce8b87614819b6$var$debug = fn;
});

var $ibqCo = parcelRequire("ibqCo");

var $hSI17 = parcelRequire("hSI17");

var $4UHK4 = parcelRequire("4UHK4");
var $05ce8b87614819b6$var$getHighWaterMark = $4UHK4.getHighWaterMark, $05ce8b87614819b6$var$getDefaultHighWaterMark = $4UHK4.getDefaultHighWaterMark;

var $cNQWQ = parcelRequire("cNQWQ");
var $05ce8b87614819b6$var$aggregateTwoErrors = $cNQWQ.aggregateTwoErrors, $05ce8b87614819b6$var$_require_codes = $cNQWQ.codes, $05ce8b87614819b6$var$ERR_INVALID_ARG_TYPE = $05ce8b87614819b6$var$_require_codes.ERR_INVALID_ARG_TYPE, $05ce8b87614819b6$var$ERR_METHOD_NOT_IMPLEMENTED = $05ce8b87614819b6$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $05ce8b87614819b6$var$ERR_OUT_OF_RANGE = $05ce8b87614819b6$var$_require_codes.ERR_OUT_OF_RANGE, $05ce8b87614819b6$var$ERR_STREAM_PUSH_AFTER_EOF = $05ce8b87614819b6$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $05ce8b87614819b6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $05ce8b87614819b6$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $05ce8b87614819b6$var$AbortError = $cNQWQ.AbortError;

var $hbaXS = parcelRequire("hbaXS");
var $05ce8b87614819b6$require$validateObject = $hbaXS.validateObject;
var $05ce8b87614819b6$var$kPaused = $05ce8b87614819b6$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $05ce8b87614819b6$require$StringDecoder = $3Jf7C.StringDecoder;

var $3tkz9 = parcelRequire("3tkz9");
$05ce8b87614819b6$var$ObjectSetPrototypeOf($05ce8b87614819b6$var$Readable.prototype, $05ce8b87614819b6$var$Stream.prototype);
$05ce8b87614819b6$var$ObjectSetPrototypeOf($05ce8b87614819b6$var$Readable, $05ce8b87614819b6$var$Stream);
var $05ce8b87614819b6$var$nop = function() {};
var $05ce8b87614819b6$var$errorOrDestroy = $hSI17.errorOrDestroy;
var $05ce8b87614819b6$var$kObjectMode = 1;
var $05ce8b87614819b6$var$kEnded = 2;
var $05ce8b87614819b6$var$kEndEmitted = 4;
var $05ce8b87614819b6$var$kReading = 8;
var $05ce8b87614819b6$var$kConstructed = 16;
var $05ce8b87614819b6$var$kSync = 32;
var $05ce8b87614819b6$var$kNeedReadable = 64;
var $05ce8b87614819b6$var$kEmittedReadable = 128;
var $05ce8b87614819b6$var$kReadableListening = 256;
var $05ce8b87614819b6$var$kResumeScheduled = 512;
var $05ce8b87614819b6$var$kErrorEmitted = 1024;
var $05ce8b87614819b6$var$kEmitClose = 2048;
var $05ce8b87614819b6$var$kAutoDestroy = 4096;
var $05ce8b87614819b6$var$kDestroyed = 8192;
var $05ce8b87614819b6$var$kClosed = 16384;
var $05ce8b87614819b6$var$kCloseEmitted = 32768;
var $05ce8b87614819b6$var$kMultiAwaitDrain = 65536;
var $05ce8b87614819b6$var$kReadingMore = 131072;
var $05ce8b87614819b6$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $05ce8b87614819b6$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$05ce8b87614819b6$var$ObjectDefineProperties($05ce8b87614819b6$var$ReadableState.prototype, {
    objectMode: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kObjectMode),
    ended: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kEnded),
    endEmitted: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kEndEmitted),
    reading: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kNeedReadable),
    emittedReadable: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kEmittedReadable),
    readableListening: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kReadableListening),
    resumeScheduled: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kErrorEmitted),
    emitClose: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kEmitClose),
    autoDestroy: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kCloseEmitted),
    multiAwaitDrain: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kReadingMore),
    dataEmitted: $05ce8b87614819b6$var$makeBitMapDescriptor($05ce8b87614819b6$var$kDataEmitted)
});

function $05ce8b87614819b6$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1MYa6"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $05ce8b87614819b6$var$kEmitClose | $05ce8b87614819b6$var$kAutoDestroy | $05ce8b87614819b6$var$kConstructed | $05ce8b87614819b6$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $05ce8b87614819b6$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $05ce8b87614819b6$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $05ce8b87614819b6$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $05ce8b87614819b6$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $ibqCo();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$05ce8b87614819b6$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$05ce8b87614819b6$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$05ce8b87614819b6$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $05ce8b87614819b6$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $05ce8b87614819b6$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $05ce8b87614819b6$var$Readable)) return new $05ce8b87614819b6$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("1MYa6"));
    this._readableState = new $05ce8b87614819b6$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $05ce8b87614819b6$require$addAbortSignal(options.signal, this);
    }
    $05ce8b87614819b6$var$Stream.call(this, options);
    $hSI17.construct(this, function() {
        if (_this._readableState.needReadable) $05ce8b87614819b6$var$maybeReadMore(_this, _this._readableState);
    });
}
$05ce8b87614819b6$var$Readable.prototype.destroy = $hSI17.destroy;
$05ce8b87614819b6$var$Readable.prototype._undestroy = $hSI17.undestroy;
$05ce8b87614819b6$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$05ce8b87614819b6$var$Readable.prototype[$05ce8b87614819b6$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$05ce8b87614819b6$var$Readable.prototype[$05ce8b87614819b6$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $05ce8b87614819b6$var$AbortError();
        this.destroy(error);
    }
    return new $05ce8b87614819b6$var$Promise(function(resolve, reject) {
        return $fvjOO(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$05ce8b87614819b6$var$Readable.prototype.push = function(chunk, encoding) {
    return $05ce8b87614819b6$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$05ce8b87614819b6$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $05ce8b87614819b6$var$readableAddChunk(this, chunk, encoding, true);
};
function $05ce8b87614819b6$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $05ce8b87614819b6$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $05ce8b87614819b6$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $05ce8b87614819b6$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $05ce8b87614819b6$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $05ce8b87614819b6$require$Buffer) encoding = '';
        else if ($05ce8b87614819b6$var$Stream._isUint8Array(chunk)) {
            chunk = $05ce8b87614819b6$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $05ce8b87614819b6$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $05ce8b87614819b6$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$05ce8b87614819b6$var$kReading;
        $05ce8b87614819b6$var$onEofChunk(stream, state);
    } else if ((state.state & $05ce8b87614819b6$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $05ce8b87614819b6$var$kEndEmitted) !== 0) $05ce8b87614819b6$var$errorOrDestroy(stream, new $05ce8b87614819b6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $05ce8b87614819b6$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $05ce8b87614819b6$var$errorOrDestroy(stream, new $05ce8b87614819b6$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$05ce8b87614819b6$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $05ce8b87614819b6$var$addChunk(stream, state, chunk, false);
                else $05ce8b87614819b6$var$maybeReadMore(stream, state);
            } else $05ce8b87614819b6$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$05ce8b87614819b6$var$kReading;
        $05ce8b87614819b6$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $05ce8b87614819b6$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $05ce8b87614819b6$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $05ce8b87614819b6$var$kNeedReadable) !== 0) $05ce8b87614819b6$var$emitReadable(stream);
    }
    $05ce8b87614819b6$var$maybeReadMore(stream, state);
}
$05ce8b87614819b6$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$05ce8b87614819b6$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$05ce8b87614819b6$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $05ce8b87614819b6$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$05ce8b87614819b6$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $05ce8b87614819b6$var$MAX_HWM = 0x40000000;
function $05ce8b87614819b6$var$computeNewHighWaterMark(n) {
    if (n > $05ce8b87614819b6$var$MAX_HWM) throw new $05ce8b87614819b6$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $05ce8b87614819b6$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $05ce8b87614819b6$var$kObjectMode) !== 0) return 1;
    if ($05ce8b87614819b6$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$05ce8b87614819b6$var$Readable.prototype.read = function(n) {
    $05ce8b87614819b6$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$05ce8b87614819b6$var$NumberIsInteger(n)) n = $05ce8b87614819b6$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $05ce8b87614819b6$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$05ce8b87614819b6$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $05ce8b87614819b6$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $05ce8b87614819b6$var$endReadable(this);
        else $05ce8b87614819b6$var$emitReadable(this);
        return null;
    }
    n = $05ce8b87614819b6$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $05ce8b87614819b6$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $05ce8b87614819b6$var$kNeedReadable) !== 0;
    $05ce8b87614819b6$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $05ce8b87614819b6$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $05ce8b87614819b6$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $05ce8b87614819b6$var$debug('do read');
        state.state |= $05ce8b87614819b6$var$kReading | $05ce8b87614819b6$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $05ce8b87614819b6$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $05ce8b87614819b6$var$errorOrDestroy(this, err);
        }
        state.state &= ~$05ce8b87614819b6$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $05ce8b87614819b6$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $05ce8b87614819b6$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $05ce8b87614819b6$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $05ce8b87614819b6$var$onEofChunk(stream, state) {
    $05ce8b87614819b6$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $05ce8b87614819b6$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $05ce8b87614819b6$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $05ce8b87614819b6$var$emitReadable(stream) {
    var state = stream._readableState;
    $05ce8b87614819b6$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $05ce8b87614819b6$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($05ce8b87614819b6$var$emitReadable_, stream);
    }
}
function $05ce8b87614819b6$var$emitReadable_(stream) {
    var state = stream._readableState;
    $05ce8b87614819b6$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $05ce8b87614819b6$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $05ce8b87614819b6$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($05ce8b87614819b6$var$maybeReadMore_, stream, state);
    }
}
function $05ce8b87614819b6$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $05ce8b87614819b6$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$05ce8b87614819b6$var$Readable.prototype._read = function(n) {
    throw new $05ce8b87614819b6$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$05ce8b87614819b6$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $05ce8b87614819b6$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $05ce8b87614819b6$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $05ce8b87614819b6$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $05ce8b87614819b6$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $05ce8b87614819b6$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $05ce8b87614819b6$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $05ce8b87614819b6$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $05ce8b87614819b6$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $05ce8b87614819b6$var$debug('ondata');
        var ret = dest.write(chunk);
        $05ce8b87614819b6$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $05ce8b87614819b6$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $05ce8b87614819b6$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $05ce8b87614819b6$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $05ce8b87614819b6$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $05ce8b87614819b6$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $05ce8b87614819b6$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $05ce8b87614819b6$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $05ce8b87614819b6$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $05ce8b87614819b6$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$05ce8b87614819b6$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $05ce8b87614819b6$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$05ce8b87614819b6$var$Readable.prototype.on = function(ev, fn) {
    var res = $05ce8b87614819b6$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $05ce8b87614819b6$var$debug('on readable', state.length, state.reading);
            if (state.length) $05ce8b87614819b6$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($05ce8b87614819b6$var$nReadingNextTick, this);
        }
    }
    return res;
};
$05ce8b87614819b6$var$Readable.prototype.addListener = $05ce8b87614819b6$var$Readable.prototype.on;
$05ce8b87614819b6$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $05ce8b87614819b6$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($05ce8b87614819b6$var$updateReadableListening, this);
    return res;
};
$05ce8b87614819b6$var$Readable.prototype.off = $05ce8b87614819b6$var$Readable.prototype.removeListener;
$05ce8b87614819b6$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $05ce8b87614819b6$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($05ce8b87614819b6$var$updateReadableListening, this);
    return res;
};
function $05ce8b87614819b6$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$05ce8b87614819b6$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $05ce8b87614819b6$var$nReadingNextTick(self) {
    $05ce8b87614819b6$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$05ce8b87614819b6$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $05ce8b87614819b6$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $05ce8b87614819b6$var$resume(this, state);
    }
    state[$05ce8b87614819b6$var$kPaused] = false;
    return this;
};
function $05ce8b87614819b6$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($05ce8b87614819b6$var$resume_, stream, state);
    }
}
function $05ce8b87614819b6$var$resume_(stream, state) {
    $05ce8b87614819b6$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $05ce8b87614819b6$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$05ce8b87614819b6$var$Readable.prototype.pause = function() {
    $05ce8b87614819b6$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $05ce8b87614819b6$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$05ce8b87614819b6$var$kPaused] = true;
    return this;
};
function $05ce8b87614819b6$var$flow(stream) {
    var state = stream._readableState;
    $05ce8b87614819b6$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$05ce8b87614819b6$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $05ce8b87614819b6$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $05ce8b87614819b6$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$05ce8b87614819b6$var$Readable.prototype[$05ce8b87614819b6$var$SymbolAsyncIterator] = function() {
    return $05ce8b87614819b6$var$streamToAsyncIterator(this);
};
$05ce8b87614819b6$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $05ce8b87614819b6$require$validateObject(options, 'options');
    return $05ce8b87614819b6$var$streamToAsyncIterator(this, options);
};
function $05ce8b87614819b6$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $05ce8b87614819b6$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $05ce8b87614819b6$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $05ce8b87614819b6$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $05ce8b87614819b6$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $05ce8b87614819b6$var$nop;
                    stream.on('readable', next);
                    cleanup = $fvjOO(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $05ce8b87614819b6$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $05ce8b87614819b6$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $05ce8b87614819b6$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $05ce8b87614819b6$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $hSI17.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$05ce8b87614819b6$var$ObjectDefineProperties($05ce8b87614819b6$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$05ce8b87614819b6$var$ObjectDefineProperties($05ce8b87614819b6$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$05ce8b87614819b6$var$kPaused] !== false;
        },
        set: function(value) {
            this[$05ce8b87614819b6$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$05ce8b87614819b6$var$Readable._fromList = $05ce8b87614819b6$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $05ce8b87614819b6$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $05ce8b87614819b6$var$endReadable(stream) {
    var state = stream._readableState;
    $05ce8b87614819b6$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($05ce8b87614819b6$var$endReadableNT, state, stream);
    }
}
function $05ce8b87614819b6$var$endReadableNT(state, stream) {
    $05ce8b87614819b6$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($05ce8b87614819b6$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $05ce8b87614819b6$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$05ce8b87614819b6$var$Readable.from = function(iterable, opts) {
    return $3tkz9($05ce8b87614819b6$var$Readable, iterable, opts);
};
var $05ce8b87614819b6$var$webStreamsAdapters;
// Lazy to avoid circular references
function $05ce8b87614819b6$var$lazyWebStreams() {
    if ($05ce8b87614819b6$var$webStreamsAdapters === undefined) $05ce8b87614819b6$var$webStreamsAdapters = {};
    return $05ce8b87614819b6$var$webStreamsAdapters;
}
$05ce8b87614819b6$var$Readable.fromWeb = function(readableStream, options) {
    return $05ce8b87614819b6$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$05ce8b87614819b6$var$Readable.toWeb = function(streamReadable, options) {
    return $05ce8b87614819b6$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$05ce8b87614819b6$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $05ce8b87614819b6$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $hSI17.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("fNe2J", function(module, exports) {
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $b7f653429c89f063$var$ArrayIsArray = $fKwjf.ArrayIsArray, $b7f653429c89f063$var$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $b7f653429c89f063$var$EE = $bBoAO.EventEmitter;
function $b7f653429c89f063$var$Stream(opts) {
    $b7f653429c89f063$var$EE.call(this, opts);
}
$b7f653429c89f063$var$ObjectSetPrototypeOf($b7f653429c89f063$var$Stream.prototype, $b7f653429c89f063$var$EE.prototype);
$b7f653429c89f063$var$ObjectSetPrototypeOf($b7f653429c89f063$var$Stream, $b7f653429c89f063$var$EE);
$b7f653429c89f063$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($b7f653429c89f063$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $b7f653429c89f063$var$prependListener(source, 'error', onerror);
    $b7f653429c89f063$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $b7f653429c89f063$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($b7f653429c89f063$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $b7f653429c89f063$var$Stream,
    prependListener: $b7f653429c89f063$var$prependListener
};

});

parcelRegister("bcrOJ", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $827664a188bb2f7b$export$e2db56ee53255a0; }, function (v) { return $827664a188bb2f7b$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $827664a188bb2f7b$export$11956e9313f43de0; }, function (v) { return $827664a188bb2f7b$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $827664a188bb2f7b$export$e2db56ee53255a0;
var $827664a188bb2f7b$export$11956e9313f43de0;
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $827664a188bb2f7b$require$SymbolDispose = $fKwjf.SymbolDispose;

var $cNQWQ = parcelRequire("cNQWQ");
var $827664a188bb2f7b$var$AbortError = $cNQWQ.AbortError, $827664a188bb2f7b$var$codes = $cNQWQ.codes;

var $eYXq6 = parcelRequire("eYXq6");
var $827664a188bb2f7b$var$isNodeStream = $eYXq6.isNodeStream, $827664a188bb2f7b$var$isWebStream = $eYXq6.isWebStream, $827664a188bb2f7b$var$kControllerErrorFunction = $eYXq6.kControllerErrorFunction;

var $fvjOO = parcelRequire("fvjOO");
var $827664a188bb2f7b$var$ERR_INVALID_ARG_TYPE = $827664a188bb2f7b$var$codes.ERR_INVALID_ARG_TYPE;
var $827664a188bb2f7b$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $827664a188bb2f7b$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $827664a188bb2f7b$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$827664a188bb2f7b$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $827664a188bb2f7b$var$validateAbortSignal(signal, 'signal');
    if (!$827664a188bb2f7b$var$isNodeStream(stream) && !$827664a188bb2f7b$var$isWebStream(stream)) throw new $827664a188bb2f7b$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $827664a188bb2f7b$export$11956e9313f43de0(signal, stream);
};

$827664a188bb2f7b$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $827664a188bb2f7b$var$isNodeStream(stream) ? function() {
        stream.destroy(new $827664a188bb2f7b$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$827664a188bb2f7b$var$kControllerErrorFunction](new $827664a188bb2f7b$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $827664a188bb2f7b$var$addAbortListener = $827664a188bb2f7b$var$addAbortListener || (parcelRequire("kigZM")).addAbortListener;
        var disposable = $827664a188bb2f7b$var$addAbortListener(signal, onAbort);
        $fvjOO(stream, disposable[$827664a188bb2f7b$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("ibqCo", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $d3cde6e77e6d8a2f$var$StringPrototypeSlice = $fKwjf.StringPrototypeSlice, $d3cde6e77e6d8a2f$var$SymbolIterator = $fKwjf.SymbolIterator, $d3cde6e77e6d8a2f$var$TypedArrayPrototypeSet = $fKwjf.TypedArrayPrototypeSet, $d3cde6e77e6d8a2f$var$Uint8Array = $fKwjf.Uint8Array;

var $jXfVE = parcelRequire("jXfVE");
var $d3cde6e77e6d8a2f$require$Buffer = $jXfVE.Buffer;

var $kigZM = parcelRequire("kigZM");
var $d3cde6e77e6d8a2f$require$inspect = $kigZM.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $d3cde6e77e6d8a2f$require$Buffer.alloc(0);
                var ret = $d3cde6e77e6d8a2f$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $d3cde6e77e6d8a2f$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $d3cde6e77e6d8a2f$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $d3cde6e77e6d8a2f$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $d3cde6e77e6d8a2f$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $d3cde6e77e6d8a2f$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $d3cde6e77e6d8a2f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $d3cde6e77e6d8a2f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $d3cde6e77e6d8a2f$var$TypedArrayPrototypeSet(ret, new $d3cde6e77e6d8a2f$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $d3cde6e77e6d8a2f$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("4UHK4", function(module, exports) {
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $393e52a9bbb6e3ff$var$MathFloor = $fKwjf.MathFloor, $393e52a9bbb6e3ff$var$NumberIsInteger = $fKwjf.NumberIsInteger;

var $hbaXS = parcelRequire("hbaXS");
var $393e52a9bbb6e3ff$require$validateInteger = $hbaXS.validateInteger;

var $393e52a9bbb6e3ff$var$ERR_INVALID_ARG_VALUE = (parcelRequire("cNQWQ")).codes.ERR_INVALID_ARG_VALUE;
var $393e52a9bbb6e3ff$var$defaultHighWaterMarkBytes = 16384;
var $393e52a9bbb6e3ff$var$defaultHighWaterMarkObjectMode = 16;
function $393e52a9bbb6e3ff$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $393e52a9bbb6e3ff$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $393e52a9bbb6e3ff$var$defaultHighWaterMarkObjectMode : $393e52a9bbb6e3ff$var$defaultHighWaterMarkBytes;
}
function $393e52a9bbb6e3ff$var$setDefaultHighWaterMark(objectMode, value) {
    $393e52a9bbb6e3ff$require$validateInteger(value, 'value', 0);
    if (objectMode) $393e52a9bbb6e3ff$var$defaultHighWaterMarkObjectMode = value;
    else $393e52a9bbb6e3ff$var$defaultHighWaterMarkBytes = value;
}
function $393e52a9bbb6e3ff$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $393e52a9bbb6e3ff$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$393e52a9bbb6e3ff$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $393e52a9bbb6e3ff$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $393e52a9bbb6e3ff$var$MathFloor(hwm);
    }
    // Default value
    return $393e52a9bbb6e3ff$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $393e52a9bbb6e3ff$var$getHighWaterMark,
    getDefaultHighWaterMark: $393e52a9bbb6e3ff$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $393e52a9bbb6e3ff$var$setDefaultHighWaterMark
};

});

parcelRegister("3tkz9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fKwjf = parcelRequire("fKwjf");
/* replacement end */ var $2874087e8532c9ba$var$PromisePrototypeThen = $fKwjf.PromisePrototypeThen, $2874087e8532c9ba$var$SymbolAsyncIterator = $fKwjf.SymbolAsyncIterator, $2874087e8532c9ba$var$SymbolIterator = $fKwjf.SymbolIterator;

var $jXfVE = parcelRequire("jXfVE");
var $2874087e8532c9ba$require$Buffer = $jXfVE.Buffer;

var $cNQWQ = parcelRequire("cNQWQ");
var $2874087e8532c9ba$require$_require_codes = $cNQWQ.codes;
var $2874087e8532c9ba$var$ERR_INVALID_ARG_TYPE = $2874087e8532c9ba$require$_require_codes.ERR_INVALID_ARG_TYPE, $2874087e8532c9ba$var$ERR_STREAM_NULL_VALUES = $2874087e8532c9ba$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $2874087e8532c9ba$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $2874087e8532c9ba$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$2874087e8532c9ba$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$2874087e8532c9ba$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$2874087e8532c9ba$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$2874087e8532c9ba$var$SymbolIterator]();
    } else throw new $2874087e8532c9ba$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $2874087e8532c9ba$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $2874087e8532c9ba$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $2874087e8532c9ba$var$from;

});


parcelRegister("exdZH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fKwjf = parcelRequire("fKwjf");
/* replacement end */ var $a94f00afbed65cd8$var$ArrayPrototypeSlice = $fKwjf.ArrayPrototypeSlice, $a94f00afbed65cd8$var$Error = $fKwjf.Error, $a94f00afbed65cd8$var$FunctionPrototypeSymbolHasInstance = $fKwjf.FunctionPrototypeSymbolHasInstance, $a94f00afbed65cd8$var$ObjectDefineProperty = $fKwjf.ObjectDefineProperty, $a94f00afbed65cd8$var$ObjectDefineProperties = $fKwjf.ObjectDefineProperties, $a94f00afbed65cd8$var$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf, $a94f00afbed65cd8$var$StringPrototypeToLowerCase = $fKwjf.StringPrototypeToLowerCase, $a94f00afbed65cd8$var$Symbol = $fKwjf.Symbol, $a94f00afbed65cd8$var$SymbolHasInstance = $fKwjf.SymbolHasInstance;
module.exports = $a94f00afbed65cd8$var$Writable;
$a94f00afbed65cd8$var$Writable.WritableState = $a94f00afbed65cd8$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a94f00afbed65cd8$var$EE = $bBoAO.EventEmitter;

var $fNe2J = parcelRequire("fNe2J");
var $a94f00afbed65cd8$require$Stream = $fNe2J.Stream;

var $jXfVE = parcelRequire("jXfVE");
var $a94f00afbed65cd8$require$Buffer = $jXfVE.Buffer;

var $hSI17 = parcelRequire("hSI17");

var $bcrOJ = parcelRequire("bcrOJ");
var $a94f00afbed65cd8$require$addAbortSignal = $bcrOJ.addAbortSignal;

var $4UHK4 = parcelRequire("4UHK4");
var $a94f00afbed65cd8$var$getHighWaterMark = $4UHK4.getHighWaterMark, $a94f00afbed65cd8$var$getDefaultHighWaterMark = $4UHK4.getDefaultHighWaterMark;

var $cNQWQ = parcelRequire("cNQWQ");
var $a94f00afbed65cd8$require$_require_codes = $cNQWQ.codes;
var $a94f00afbed65cd8$var$ERR_INVALID_ARG_TYPE = $a94f00afbed65cd8$require$_require_codes.ERR_INVALID_ARG_TYPE, $a94f00afbed65cd8$var$ERR_METHOD_NOT_IMPLEMENTED = $a94f00afbed65cd8$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a94f00afbed65cd8$var$ERR_MULTIPLE_CALLBACK = $a94f00afbed65cd8$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a94f00afbed65cd8$var$ERR_STREAM_CANNOT_PIPE = $a94f00afbed65cd8$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED = $a94f00afbed65cd8$require$_require_codes.ERR_STREAM_DESTROYED, $a94f00afbed65cd8$var$ERR_STREAM_ALREADY_FINISHED = $a94f00afbed65cd8$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a94f00afbed65cd8$var$ERR_STREAM_NULL_VALUES = $a94f00afbed65cd8$require$_require_codes.ERR_STREAM_NULL_VALUES, $a94f00afbed65cd8$var$ERR_STREAM_WRITE_AFTER_END = $a94f00afbed65cd8$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a94f00afbed65cd8$var$ERR_UNKNOWN_ENCODING = $a94f00afbed65cd8$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a94f00afbed65cd8$var$errorOrDestroy = $hSI17.errorOrDestroy;
$a94f00afbed65cd8$var$ObjectSetPrototypeOf($a94f00afbed65cd8$var$Writable.prototype, $a94f00afbed65cd8$require$Stream.prototype);
$a94f00afbed65cd8$var$ObjectSetPrototypeOf($a94f00afbed65cd8$var$Writable, $a94f00afbed65cd8$require$Stream);
function $a94f00afbed65cd8$var$nop() {}
var $a94f00afbed65cd8$var$kOnFinished = $a94f00afbed65cd8$var$Symbol('kOnFinished');

function $a94f00afbed65cd8$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1MYa6"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a94f00afbed65cd8$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a94f00afbed65cd8$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a94f00afbed65cd8$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a94f00afbed65cd8$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a94f00afbed65cd8$var$kOnFinished] = [];
}
function $a94f00afbed65cd8$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a94f00afbed65cd8$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a94f00afbed65cd8$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a94f00afbed65cd8$var$ObjectDefineProperty($a94f00afbed65cd8$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a94f00afbed65cd8$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("1MYa6"));
    if (!isDuplex && !$a94f00afbed65cd8$var$FunctionPrototypeSymbolHasInstance($a94f00afbed65cd8$var$Writable, this)) return new $a94f00afbed65cd8$var$Writable(options);
    this._writableState = new $a94f00afbed65cd8$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a94f00afbed65cd8$require$addAbortSignal(options.signal, this);
    }
    $a94f00afbed65cd8$require$Stream.call(this, options);
    $hSI17.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a94f00afbed65cd8$var$clearBuffer(_this, state);
        $a94f00afbed65cd8$var$finishMaybe(_this, state);
    });
}
$a94f00afbed65cd8$var$ObjectDefineProperty($a94f00afbed65cd8$var$Writable, $a94f00afbed65cd8$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a94f00afbed65cd8$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a94f00afbed65cd8$var$Writable) return false;
        return object && object._writableState instanceof $a94f00afbed65cd8$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a94f00afbed65cd8$var$Writable.prototype.pipe = function() {
    $a94f00afbed65cd8$var$errorOrDestroy(this, new $a94f00afbed65cd8$var$ERR_STREAM_CANNOT_PIPE());
};
function $a94f00afbed65cd8$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a94f00afbed65cd8$require$Buffer.isEncoding(encoding)) throw new $a94f00afbed65cd8$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a94f00afbed65cd8$var$nop;
    }
    if (chunk === null) throw new $a94f00afbed65cd8$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a94f00afbed65cd8$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a94f00afbed65cd8$require$Buffer) encoding = 'buffer';
        else if ($a94f00afbed65cd8$require$Stream._isUint8Array(chunk)) {
            chunk = $a94f00afbed65cd8$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a94f00afbed65cd8$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a94f00afbed65cd8$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a94f00afbed65cd8$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a94f00afbed65cd8$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a94f00afbed65cd8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a94f00afbed65cd8$var$_write(this, chunk, encoding, cb) === true;
};
$a94f00afbed65cd8$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a94f00afbed65cd8$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a94f00afbed65cd8$var$clearBuffer(this, state);
    }
};
$a94f00afbed65cd8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a94f00afbed65cd8$var$StringPrototypeToLowerCase(encoding);
    if (!$a94f00afbed65cd8$require$Buffer.isEncoding(encoding)) throw new $a94f00afbed65cd8$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a94f00afbed65cd8$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a94f00afbed65cd8$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a94f00afbed65cd8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a94f00afbed65cd8$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a94f00afbed65cd8$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a94f00afbed65cd8$var$errorOrDestroy(stream, er);
}
function $a94f00afbed65cd8$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a94f00afbed65cd8$var$errorOrDestroy(stream, new $a94f00afbed65cd8$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a94f00afbed65cd8$var$onwriteError, stream, state, er, cb);
        else $a94f00afbed65cd8$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a94f00afbed65cd8$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a94f00afbed65cd8$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a94f00afbed65cd8$var$afterWrite(stream, state, 1, cb);
    }
}
function $a94f00afbed65cd8$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a94f00afbed65cd8$var$afterWrite(stream, state, count, cb);
}
function $a94f00afbed65cd8$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a94f00afbed65cd8$var$errorBuffer(state);
    $a94f00afbed65cd8$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a94f00afbed65cd8$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a94f00afbed65cd8$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED('end'));
    }
    $a94f00afbed65cd8$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a94f00afbed65cd8$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a94f00afbed65cd8$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a94f00afbed65cd8$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a94f00afbed65cd8$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a94f00afbed65cd8$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a94f00afbed65cd8$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a94f00afbed65cd8$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a94f00afbed65cd8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a94f00afbed65cd8$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a94f00afbed65cd8$var$Writable.prototype._writev = null;
$a94f00afbed65cd8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a94f00afbed65cd8$var$_write(this, chunk, encoding);
        if (ret instanceof $a94f00afbed65cd8$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a94f00afbed65cd8$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a94f00afbed65cd8$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a94f00afbed65cd8$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a94f00afbed65cd8$var$kOnFinished].push(cb);
    }
    return this;
};
function $a94f00afbed65cd8$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a94f00afbed65cd8$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a94f00afbed65cd8$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a94f00afbed65cd8$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a94f00afbed65cd8$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a94f00afbed65cd8$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a94f00afbed65cd8$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a94f00afbed65cd8$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a94f00afbed65cd8$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a94f00afbed65cd8$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a94f00afbed65cd8$var$finishMaybe(stream, state, sync) {
    if ($a94f00afbed65cd8$var$needFinish(state)) {
        $a94f00afbed65cd8$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a94f00afbed65cd8$var$needFinish(state)) $a94f00afbed65cd8$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a94f00afbed65cd8$var$needFinish(state)) {
                state.pendingcb++;
                $a94f00afbed65cd8$var$finish(stream, state);
            }
        }
    }
}
function $a94f00afbed65cd8$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a94f00afbed65cd8$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a94f00afbed65cd8$var$ObjectDefineProperties($a94f00afbed65cd8$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a94f00afbed65cd8$var$destroy = $hSI17.destroy;
$a94f00afbed65cd8$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a94f00afbed65cd8$var$kOnFinished].length)) $2Qkr5.nextTick($a94f00afbed65cd8$var$errorBuffer, state);
    $a94f00afbed65cd8$var$destroy.call(this, err, cb);
    return this;
};
$a94f00afbed65cd8$var$Writable.prototype._undestroy = $hSI17.undestroy;
$a94f00afbed65cd8$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a94f00afbed65cd8$var$Writable.prototype[$a94f00afbed65cd8$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a94f00afbed65cd8$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a94f00afbed65cd8$var$lazyWebStreams() {
    if ($a94f00afbed65cd8$var$webStreamsAdapters === undefined) $a94f00afbed65cd8$var$webStreamsAdapters = {};
    return $a94f00afbed65cd8$var$webStreamsAdapters;
}
$a94f00afbed65cd8$var$Writable.fromWeb = function(writableStream, options) {
    return $a94f00afbed65cd8$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a94f00afbed65cd8$var$Writable.toWeb = function(streamWritable) {
    return $a94f00afbed65cd8$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hKhGQ", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $jXfVE = parcelRequire("jXfVE");

var $eYXq6 = parcelRequire("eYXq6");
var $ceb4746c902ba5be$var$isReadable = $eYXq6.isReadable, $ceb4746c902ba5be$var$isWritable = $eYXq6.isWritable, $ceb4746c902ba5be$var$isIterable = $eYXq6.isIterable, $ceb4746c902ba5be$var$isNodeStream = $eYXq6.isNodeStream, $ceb4746c902ba5be$var$isReadableNodeStream = $eYXq6.isReadableNodeStream, $ceb4746c902ba5be$var$isWritableNodeStream = $eYXq6.isWritableNodeStream, $ceb4746c902ba5be$var$isDuplexNodeStream = $eYXq6.isDuplexNodeStream, $ceb4746c902ba5be$var$isReadableStream = $eYXq6.isReadableStream, $ceb4746c902ba5be$var$isWritableStream = $eYXq6.isWritableStream;

var $fvjOO = parcelRequire("fvjOO");

var $cNQWQ = parcelRequire("cNQWQ");
var $ceb4746c902ba5be$var$AbortError = $cNQWQ.AbortError, $ceb4746c902ba5be$var$_require_codes = $cNQWQ.codes, $ceb4746c902ba5be$var$ERR_INVALID_ARG_TYPE = $ceb4746c902ba5be$var$_require_codes.ERR_INVALID_ARG_TYPE, $ceb4746c902ba5be$var$ERR_INVALID_RETURN_VALUE = $ceb4746c902ba5be$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $hSI17 = parcelRequire("hSI17");
var $ceb4746c902ba5be$require$destroyer = $hSI17.destroyer;

var $1MYa6 = parcelRequire("1MYa6");

var $uUoiN = parcelRequire("uUoiN");

var $exdZH = parcelRequire("exdZH");

var $kigZM = parcelRequire("kigZM");
var $ceb4746c902ba5be$require$createDeferredPromise = $kigZM.createDeferredPromise;

var $3tkz9 = parcelRequire("3tkz9");
var $ceb4746c902ba5be$var$Blob = globalThis.Blob || $jXfVE.Blob;
var $ceb4746c902ba5be$var$isBlob = typeof $ceb4746c902ba5be$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $ceb4746c902ba5be$var$Blob;
} : function isBlob(b) {
    return false;
};

var $ceb4746c902ba5be$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $fKwjf = parcelRequire("fKwjf");
var $ceb4746c902ba5be$require$FunctionPrototypeCall = $fKwjf.FunctionPrototypeCall;
// This is needed for pre node 17.
var $ceb4746c902ba5be$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($1MYa6);
module.exports = function duplexify(body, name) {
    if ($ceb4746c902ba5be$var$isDuplexNodeStream(body)) return body;
    if ($ceb4746c902ba5be$var$isReadableNodeStream(body)) return $ceb4746c902ba5be$var$_duplexify({
        readable: body
    });
    if ($ceb4746c902ba5be$var$isWritableNodeStream(body)) return $ceb4746c902ba5be$var$_duplexify({
        writable: body
    });
    if ($ceb4746c902ba5be$var$isNodeStream(body)) return $ceb4746c902ba5be$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($ceb4746c902ba5be$var$isReadableStream(body)) return $ceb4746c902ba5be$var$_duplexify({
        readable: $uUoiN.fromWeb(body)
    });
    if ($ceb4746c902ba5be$var$isWritableStream(body)) return $ceb4746c902ba5be$var$_duplexify({
        writable: $exdZH.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $ceb4746c902ba5be$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($ceb4746c902ba5be$var$isIterable(value)) return $3tkz9($ceb4746c902ba5be$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $ceb4746c902ba5be$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $ceb4746c902ba5be$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $ceb4746c902ba5be$require$destroyer(d, err);
            });
            return d = new $ceb4746c902ba5be$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $ceb4746c902ba5be$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($ceb4746c902ba5be$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($ceb4746c902ba5be$var$isIterable(body)) return $3tkz9($ceb4746c902ba5be$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($ceb4746c902ba5be$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $ceb4746c902ba5be$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $ceb4746c902ba5be$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $ceb4746c902ba5be$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $ceb4746c902ba5be$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $ceb4746c902ba5be$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $ceb4746c902ba5be$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $ceb4746c902ba5be$require$destroyer(d1, err);
        });
        return d1 = new $ceb4746c902ba5be$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $ceb4746c902ba5be$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $ceb4746c902ba5be$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $ceb4746c902ba5be$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $ceb4746c902ba5be$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $ceb4746c902ba5be$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $ceb4746c902ba5be$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $ceb4746c902ba5be$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $uUoiN.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$ceb4746c902ba5be$var$isReadable(r);
    var writable = !!$ceb4746c902ba5be$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ceb4746c902ba5be$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $fvjOO(w, function(err) {
            writable = false;
            if (err) $ceb4746c902ba5be$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $fvjOO(r, function(err) {
            readable = false;
            if (err) $ceb4746c902ba5be$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ceb4746c902ba5be$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $ceb4746c902ba5be$require$destroyer(w, err);
            $ceb4746c902ba5be$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("fsm9m", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $b40aa712bbf4d285$require$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf;
module.exports = $b40aa712bbf4d285$var$PassThrough;

var $lK2pA = parcelRequire("lK2pA");
$b40aa712bbf4d285$require$ObjectSetPrototypeOf($b40aa712bbf4d285$var$PassThrough.prototype, $lK2pA.prototype);
$b40aa712bbf4d285$require$ObjectSetPrototypeOf($b40aa712bbf4d285$var$PassThrough, $lK2pA);
function $b40aa712bbf4d285$var$PassThrough(options) {
    if (!(this instanceof $b40aa712bbf4d285$var$PassThrough)) return new $b40aa712bbf4d285$var$PassThrough(options);
    $lK2pA.call(this, options);
}
$b40aa712bbf4d285$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("lK2pA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $fd3fc3c4650aeae2$var$ObjectSetPrototypeOf = $fKwjf.ObjectSetPrototypeOf, $fd3fc3c4650aeae2$var$Symbol = $fKwjf.Symbol;
module.exports = $fd3fc3c4650aeae2$var$Transform;

var $fd3fc3c4650aeae2$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("cNQWQ")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $1MYa6 = parcelRequire("1MYa6");

var $4UHK4 = parcelRequire("4UHK4");
var $fd3fc3c4650aeae2$require$getHighWaterMark = $4UHK4.getHighWaterMark;
$fd3fc3c4650aeae2$var$ObjectSetPrototypeOf($fd3fc3c4650aeae2$var$Transform.prototype, $1MYa6.prototype);
$fd3fc3c4650aeae2$var$ObjectSetPrototypeOf($fd3fc3c4650aeae2$var$Transform, $1MYa6);
var $fd3fc3c4650aeae2$var$kCallback = $fd3fc3c4650aeae2$var$Symbol('kCallback');
function $fd3fc3c4650aeae2$var$Transform(options) {
    if (!(this instanceof $fd3fc3c4650aeae2$var$Transform)) return new $fd3fc3c4650aeae2$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $fd3fc3c4650aeae2$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1MYa6.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$fd3fc3c4650aeae2$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $fd3fc3c4650aeae2$var$prefinish);
}
function $fd3fc3c4650aeae2$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $fd3fc3c4650aeae2$var$prefinish() {
    if (this._final !== $fd3fc3c4650aeae2$var$_final) $fd3fc3c4650aeae2$var$_final.call(this);
}
$fd3fc3c4650aeae2$var$Transform.prototype._final = $fd3fc3c4650aeae2$var$_final;
$fd3fc3c4650aeae2$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $fd3fc3c4650aeae2$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$fd3fc3c4650aeae2$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$fd3fc3c4650aeae2$var$kCallback] = callback;
    });
};
$fd3fc3c4650aeae2$var$Transform.prototype._read = function() {
    if (this[$fd3fc3c4650aeae2$var$kCallback]) {
        var callback = this[$fd3fc3c4650aeae2$var$kCallback];
        this[$fd3fc3c4650aeae2$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("bU68h", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fKwjf = parcelRequire("fKwjf");
var $8aa9ae74fc11ee17$var$ArrayPrototypePop = $fKwjf.ArrayPrototypePop, $8aa9ae74fc11ee17$var$Promise = $fKwjf.Promise;

var $eYXq6 = parcelRequire("eYXq6");
var $8aa9ae74fc11ee17$var$isIterable = $eYXq6.isIterable, $8aa9ae74fc11ee17$var$isNodeStream = $eYXq6.isNodeStream, $8aa9ae74fc11ee17$var$isWebStream = $eYXq6.isWebStream;

var $gKhO1 = parcelRequire("gKhO1");
var $8aa9ae74fc11ee17$var$pl = $gKhO1.pipelineImpl;

var $fvjOO = parcelRequire("fvjOO");
var $8aa9ae74fc11ee17$require$finished = $fvjOO.finished;
parcelRequire("4JSVX");
function $8aa9ae74fc11ee17$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $8aa9ae74fc11ee17$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$8aa9ae74fc11ee17$var$isNodeStream(lastArg) && !$8aa9ae74fc11ee17$var$isIterable(lastArg) && !$8aa9ae74fc11ee17$var$isWebStream(lastArg)) {
            var options = $8aa9ae74fc11ee17$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $8aa9ae74fc11ee17$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $8aa9ae74fc11ee17$require$finished,
    pipeline: $8aa9ae74fc11ee17$var$pipeline
};

});







parcelRegister("3HhXO", function(module, exports) {
"use strict";
var $2b1352754d615895$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b1352754d615895$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b1352754d615895$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2b1352754d615895$var$__exportStar((parcelRequire("b2zYL")), module.exports);

});
parcelRegister("b2zYL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeShaclc = void 0;

var $bxueq = parcelRequire("bxueq");

var $5vuoK = parcelRequire("5vuoK");

var $gRZ1W = parcelRequire("gRZ1W");

var $4TLSu = parcelRequire("4TLSu");
/**
 * A comunica SHACL Compact Syntax RDF Serialize Actor.
 */ var $021307644cbf4670$var$ActorRdfSerializeShaclc = /*#__PURE__*/ function(_bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfSerializeShaclc, _bus_rdf_serialize_1_ActorRdfSerializeFixedMediaTypes);
    function ActorRdfSerializeShaclc(args) {
        (0, $jGAMp._)(this, ActorRdfSerializeShaclc);
        return (0, $kzDuW._)(this, ActorRdfSerializeShaclc, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfSerializeShaclc, [
        {
            key: "runHandle",
            value: function runHandle(action, mediaType) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var data, prefixes, text, _, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = new $gRZ1W.Readable();
                                data._read = function() {
                                // Do nothing
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                prefixes = {};
                                action.quadStream.on('prefix', function(prefix, iri) {
                                    prefixes[prefix] = iri;
                                });
                                _ = (0, $4TLSu.write);
                                return [
                                    4,
                                    (0, $5vuoK.default)(action.quadStream)
                                ];
                            case 2:
                                return [
                                    4,
                                    _.apply(void 0, [
                                        _state.sent(),
                                        {
                                            errorOnUnused: true,
                                            extendedSyntax: mediaType === 'text/shaclc-ext',
                                            prefixes: prefixes
                                        }
                                    ])
                                ];
                            case 3:
                                text = _state.sent().text;
                                data.push(text);
                                data.push(null);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                // Push the error into the stream
                                data._read = function() {
                                    data.emit('error', error);
                                };
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    {
                                        data: data,
                                        triples: true
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ActorRdfSerializeShaclc;
}($bxueq.ActorRdfSerializeFixedMediaTypes);
module.exports.ActorRdfSerializeShaclc = $021307644cbf4670$var$ActorRdfSerializeShaclc;

});
parcelRegister("5vuoK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $40276d6e83ad9ebd$var$promisifyEventEmitter(event, result) {
    return new Promise(function(resolve, reject) {
        event.on('end', function() {
            return resolve(result);
        });
        event.on('error', reject);
    });
}
function $40276d6e83ad9ebd$var$arrayifyStream(stream) {
    var array = [];
    return $40276d6e83ad9ebd$var$promisifyEventEmitter(stream.on('data', function(data) {
        return array.push(data);
    }), array);
}
module.exports["default"] = $40276d6e83ad9ebd$var$arrayifyStream;

});

parcelRegister("gRZ1W", function(module, exports) {
'use strict';

var $5sxdt = parcelRequire("5sxdt");

var $2Vjk4 = parcelRequire("2Vjk4");
var $c480efe8a58645b5$var$originalDestroy = $5sxdt.Readable.destroy;
module.exports = $5sxdt.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5sxdt._uint8ArrayToBuffer;
module.exports._isUint8Array = $5sxdt._isUint8Array;
module.exports.isDisturbed = $5sxdt.isDisturbed;
module.exports.isErrored = $5sxdt.isErrored;
module.exports.isReadable = $5sxdt.isReadable;
module.exports.Readable = $5sxdt.Readable;
module.exports.Writable = $5sxdt.Writable;
module.exports.Duplex = $5sxdt.Duplex;
module.exports.Transform = $5sxdt.Transform;
module.exports.PassThrough = $5sxdt.PassThrough;
module.exports.addAbortSignal = $5sxdt.addAbortSignal;
module.exports.finished = $5sxdt.finished;
module.exports.destroy = $5sxdt.destroy;
module.exports.destroy = $c480efe8a58645b5$var$originalDestroy;
module.exports.pipeline = $5sxdt.pipeline;
module.exports.compose = $5sxdt.compose;
Object.defineProperty($5sxdt, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $2Vjk4;
    }
});
module.exports.Stream = $5sxdt.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("5sxdt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $eVkja = parcelRequire("eVkja");
var $3f99555af3243bf3$require$Buffer = $eVkja.Buffer;

var $enBcu = parcelRequire("enBcu");
/* replacement end */ var $3f99555af3243bf3$var$ObjectDefineProperty = $enBcu.ObjectDefineProperty, $3f99555af3243bf3$var$ObjectKeys = $enBcu.ObjectKeys, $3f99555af3243bf3$var$ReflectApply = $enBcu.ReflectApply;

var $fCNX2 = parcelRequire("fCNX2");
var $3f99555af3243bf3$var$_require_promisify = $fCNX2.promisify, $3f99555af3243bf3$var$customPromisify = $3f99555af3243bf3$var$_require_promisify.custom;

var $h7E5W = parcelRequire("h7E5W");
var $3f99555af3243bf3$var$streamReturningOperators = $h7E5W.streamReturningOperators, $3f99555af3243bf3$var$promiseReturningOperators = $h7E5W.promiseReturningOperators;

var $aALsV = parcelRequire("aALsV");
var $3f99555af3243bf3$var$ERR_ILLEGAL_CONSTRUCTOR = $aALsV.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $2PA0G = parcelRequire("2PA0G");

var $kZ9n7 = parcelRequire("kZ9n7");
var $3f99555af3243bf3$var$setDefaultHighWaterMark = $kZ9n7.setDefaultHighWaterMark, $3f99555af3243bf3$var$getDefaultHighWaterMark = $kZ9n7.getDefaultHighWaterMark;

var $5U91j = parcelRequire("5U91j");
var $3f99555af3243bf3$require$pipeline = $5U91j.pipeline;

var $3aXq0 = parcelRequire("3aXq0");
var $3f99555af3243bf3$require$destroyer = $3aXq0.destroyer;

var $dXW2j = parcelRequire("dXW2j");
var $3f99555af3243bf3$var$internalBuffer = {};

var $2Vjk4 = parcelRequire("2Vjk4");

var $C5MxV = parcelRequire("C5MxV");

var $3f99555af3243bf3$var$Stream = module.exports = (parcelRequire("ewFWJ")).Stream;
$3f99555af3243bf3$var$Stream.isDestroyed = $C5MxV.isDestroyed;
$3f99555af3243bf3$var$Stream.isDisturbed = $C5MxV.isDisturbed;
$3f99555af3243bf3$var$Stream.isErrored = $C5MxV.isErrored;
$3f99555af3243bf3$var$Stream.isReadable = $C5MxV.isReadable;
$3f99555af3243bf3$var$Stream.isWritable = $C5MxV.isWritable;

$3f99555af3243bf3$var$Stream.Readable = (parcelRequire("jXcuS"));
var $3f99555af3243bf3$var$_iteratorNormalCompletion = true, $3f99555af3243bf3$var$_didIteratorError = false, $3f99555af3243bf3$var$_iteratorError = undefined;
try {
    for(var $3f99555af3243bf3$var$_iterator = $3f99555af3243bf3$var$ObjectKeys($3f99555af3243bf3$var$streamReturningOperators)[Symbol.iterator](), $3f99555af3243bf3$var$_step; !($3f99555af3243bf3$var$_iteratorNormalCompletion = ($3f99555af3243bf3$var$_step = $3f99555af3243bf3$var$_iterator.next()).done); $3f99555af3243bf3$var$_iteratorNormalCompletion = true){
        var $3f99555af3243bf3$var$key = $3f99555af3243bf3$var$_step.value;
        var $3f99555af3243bf3$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $3f99555af3243bf3$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3f99555af3243bf3$var$Stream.Readable.from($3f99555af3243bf3$var$ReflectApply($3f99555af3243bf3$var$op, this, args));
        };
        var $3f99555af3243bf3$var$op = $3f99555af3243bf3$var$streamReturningOperators[$3f99555af3243bf3$var$key];
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$fn, 'name', {
            __proto__: null,
            value: $3f99555af3243bf3$var$op.name
        });
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$fn, 'length', {
            __proto__: null,
            value: $3f99555af3243bf3$var$op.length
        });
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$Stream.Readable.prototype, $3f99555af3243bf3$var$key, {
            __proto__: null,
            value: $3f99555af3243bf3$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3f99555af3243bf3$var$_didIteratorError = true;
    $3f99555af3243bf3$var$_iteratorError = err;
} finally{
    try {
        if (!$3f99555af3243bf3$var$_iteratorNormalCompletion && $3f99555af3243bf3$var$_iterator["return"] != null) {
            $3f99555af3243bf3$var$_iterator["return"]();
        }
    } finally{
        if ($3f99555af3243bf3$var$_didIteratorError) {
            throw $3f99555af3243bf3$var$_iteratorError;
        }
    }
}
var $3f99555af3243bf3$var$_iteratorNormalCompletion1 = true, $3f99555af3243bf3$var$_didIteratorError1 = false, $3f99555af3243bf3$var$_iteratorError1 = undefined;
try {
    for(var $3f99555af3243bf3$var$_iterator1 = $3f99555af3243bf3$var$ObjectKeys($3f99555af3243bf3$var$promiseReturningOperators)[Symbol.iterator](), $3f99555af3243bf3$var$_step1; !($3f99555af3243bf3$var$_iteratorNormalCompletion1 = ($3f99555af3243bf3$var$_step1 = $3f99555af3243bf3$var$_iterator1.next()).done); $3f99555af3243bf3$var$_iteratorNormalCompletion1 = true){
        var $3f99555af3243bf3$var$key1 = $3f99555af3243bf3$var$_step1.value;
        var $3f99555af3243bf3$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $3f99555af3243bf3$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3f99555af3243bf3$var$ReflectApply($3f99555af3243bf3$var$op1, this, args);
        };
        var $3f99555af3243bf3$var$op1 = $3f99555af3243bf3$var$promiseReturningOperators[$3f99555af3243bf3$var$key1];
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$fn1, 'name', {
            __proto__: null,
            value: $3f99555af3243bf3$var$op1.name
        });
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$fn1, 'length', {
            __proto__: null,
            value: $3f99555af3243bf3$var$op1.length
        });
        $3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$Stream.Readable.prototype, $3f99555af3243bf3$var$key1, {
            __proto__: null,
            value: $3f99555af3243bf3$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3f99555af3243bf3$var$_didIteratorError1 = true;
    $3f99555af3243bf3$var$_iteratorError1 = err;
} finally{
    try {
        if (!$3f99555af3243bf3$var$_iteratorNormalCompletion1 && $3f99555af3243bf3$var$_iterator1["return"] != null) {
            $3f99555af3243bf3$var$_iterator1["return"]();
        }
    } finally{
        if ($3f99555af3243bf3$var$_didIteratorError1) {
            throw $3f99555af3243bf3$var$_iteratorError1;
        }
    }
}

$3f99555af3243bf3$var$Stream.Writable = (parcelRequire("efk7c"));

$3f99555af3243bf3$var$Stream.Duplex = (parcelRequire("8bwfW"));

$3f99555af3243bf3$var$Stream.Transform = (parcelRequire("jkjNY"));

$3f99555af3243bf3$var$Stream.PassThrough = (parcelRequire("9nhuj"));
$3f99555af3243bf3$var$Stream.pipeline = $3f99555af3243bf3$require$pipeline;

var $e2Flm = parcelRequire("e2Flm");
var $3f99555af3243bf3$require$addAbortSignal = $e2Flm.addAbortSignal;
$3f99555af3243bf3$var$Stream.addAbortSignal = $3f99555af3243bf3$require$addAbortSignal;
$3f99555af3243bf3$var$Stream.finished = $dXW2j;
$3f99555af3243bf3$var$Stream.destroy = $3f99555af3243bf3$require$destroyer;
$3f99555af3243bf3$var$Stream.compose = $2PA0G;
$3f99555af3243bf3$var$Stream.setDefaultHighWaterMark = $3f99555af3243bf3$var$setDefaultHighWaterMark;
$3f99555af3243bf3$var$Stream.getDefaultHighWaterMark = $3f99555af3243bf3$var$getDefaultHighWaterMark;
$3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $2Vjk4;
    }
});
$3f99555af3243bf3$var$ObjectDefineProperty($3f99555af3243bf3$require$pipeline, $3f99555af3243bf3$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2Vjk4.pipeline;
    }
});
$3f99555af3243bf3$var$ObjectDefineProperty($dXW2j, $3f99555af3243bf3$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2Vjk4.finished;
    }
});
// Backwards-compat with node 0.4.x
$3f99555af3243bf3$var$Stream.Stream = $3f99555af3243bf3$var$Stream;
$3f99555af3243bf3$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$3f99555af3243bf3$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $3f99555af3243bf3$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("eVkja", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $add624580c3ade50$export$a143d493d941bafc; }, function (v) { return $add624580c3ade50$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $add624580c3ade50$export$f99ded8fe4b79145; }, function (v) { return $add624580c3ade50$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $add624580c3ade50$export$a143d493d941bafc;
var $add624580c3ade50$export$e4cf37d7f6fb9e0a;
var $add624580c3ade50$export$f99ded8fe4b79145;
var $add624580c3ade50$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $add624580c3ade50$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$add624580c3ade50$export$a143d493d941bafc = $add624580c3ade50$var$Buffer;
$add624580c3ade50$export$e4cf37d7f6fb9e0a = $add624580c3ade50$var$SlowBuffer;
$add624580c3ade50$export$f99ded8fe4b79145 = 50;
var $add624580c3ade50$var$K_MAX_LENGTH = 0x7fffffff;
$add624580c3ade50$export$599f31c3813fae4d = $add624580c3ade50$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $add624580c3ade50$var$Buffer.TYPED_ARRAY_SUPPORT = $add624580c3ade50$var$typedArraySupport();
if (!$add624580c3ade50$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $add624580c3ade50$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($add624580c3ade50$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$add624580c3ade50$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($add624580c3ade50$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$add624580c3ade50$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $add624580c3ade50$var$createBuffer(length) {
    if (length > $add624580c3ade50$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $add624580c3ade50$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $add624580c3ade50$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $add624580c3ade50$var$allocUnsafe(arg);
    }
    return $add624580c3ade50$var$from(arg, encodingOrOffset, length);
}
$add624580c3ade50$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $add624580c3ade50$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $add624580c3ade50$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $add624580c3ade50$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($add624580c3ade50$var$isInstance(value, ArrayBuffer) || value && $add624580c3ade50$var$isInstance(value.buffer, ArrayBuffer)) return $add624580c3ade50$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($add624580c3ade50$var$isInstance(value, SharedArrayBuffer) || value && $add624580c3ade50$var$isInstance(value.buffer, SharedArrayBuffer))) return $add624580c3ade50$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $add624580c3ade50$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $add624580c3ade50$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $add624580c3ade50$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $add624580c3ade50$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $add624580c3ade50$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($add624580c3ade50$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($add624580c3ade50$var$Buffer, Uint8Array);
function $add624580c3ade50$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $add624580c3ade50$var$alloc(size, fill, encoding) {
    $add624580c3ade50$var$assertSize(size);
    if (size <= 0) return $add624580c3ade50$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $add624580c3ade50$var$createBuffer(size).fill(fill, encoding) : $add624580c3ade50$var$createBuffer(size).fill(fill);
    return $add624580c3ade50$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $add624580c3ade50$var$Buffer.alloc = function(size, fill, encoding) {
    return $add624580c3ade50$var$alloc(size, fill, encoding);
};
function $add624580c3ade50$var$allocUnsafe(size) {
    $add624580c3ade50$var$assertSize(size);
    return $add624580c3ade50$var$createBuffer(size < 0 ? 0 : $add624580c3ade50$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $add624580c3ade50$var$Buffer.allocUnsafe = function(size) {
    return $add624580c3ade50$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $add624580c3ade50$var$Buffer.allocUnsafeSlow = function(size) {
    return $add624580c3ade50$var$allocUnsafe(size);
};
function $add624580c3ade50$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$add624580c3ade50$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $add624580c3ade50$var$byteLength(string, encoding) | 0;
    var buf = $add624580c3ade50$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $add624580c3ade50$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $add624580c3ade50$var$checked(array.length) | 0;
    var buf = $add624580c3ade50$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $add624580c3ade50$var$fromArrayView(arrayView) {
    if ($add624580c3ade50$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $add624580c3ade50$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $add624580c3ade50$var$fromArrayLike(arrayView);
}
function $add624580c3ade50$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $add624580c3ade50$var$Buffer.prototype);
    return buf;
}
function $add624580c3ade50$var$fromObject(obj) {
    if ($add624580c3ade50$var$Buffer.isBuffer(obj)) {
        var len = $add624580c3ade50$var$checked(obj.length) | 0;
        var buf = $add624580c3ade50$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $add624580c3ade50$var$numberIsNaN(obj.length)) return $add624580c3ade50$var$createBuffer(0);
        return $add624580c3ade50$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $add624580c3ade50$var$fromArrayLike(obj.data);
}
function $add624580c3ade50$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $add624580c3ade50$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $add624580c3ade50$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $add624580c3ade50$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $add624580c3ade50$var$Buffer.alloc(+length);
}
$add624580c3ade50$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $add624580c3ade50$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$add624580c3ade50$var$Buffer.compare = function compare(a, b) {
    if ($add624580c3ade50$var$isInstance(a, Uint8Array)) a = $add624580c3ade50$var$Buffer.from(a, a.offset, a.byteLength);
    if ($add624580c3ade50$var$isInstance(b, Uint8Array)) b = $add624580c3ade50$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$add624580c3ade50$var$Buffer.isBuffer(a) || !$add624580c3ade50$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$add624580c3ade50$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$add624580c3ade50$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $add624580c3ade50$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $add624580c3ade50$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($add624580c3ade50$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$add624580c3ade50$var$Buffer.isBuffer(buf)) buf = $add624580c3ade50$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$add624580c3ade50$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $add624580c3ade50$var$byteLength(string, encoding) {
    if ($add624580c3ade50$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $add624580c3ade50$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $add624580c3ade50$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $add624580c3ade50$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $add624580c3ade50$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$add624580c3ade50$var$Buffer.byteLength = $add624580c3ade50$var$byteLength;
function $add624580c3ade50$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $add624580c3ade50$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $add624580c3ade50$var$utf8Slice(this, start, end);
        case 'ascii':
            return $add624580c3ade50$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $add624580c3ade50$var$latin1Slice(this, start, end);
        case 'base64':
            return $add624580c3ade50$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $add624580c3ade50$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$add624580c3ade50$var$Buffer.prototype._isBuffer = true;
function $add624580c3ade50$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$add624580c3ade50$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$add624580c3ade50$var$swap(this, i, i + 1);
    return this;
};
$add624580c3ade50$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $add624580c3ade50$var$swap(this, i, i + 3);
        $add624580c3ade50$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$add624580c3ade50$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $add624580c3ade50$var$swap(this, i, i + 7);
        $add624580c3ade50$var$swap(this, i + 1, i + 6);
        $add624580c3ade50$var$swap(this, i + 2, i + 5);
        $add624580c3ade50$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$add624580c3ade50$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $add624580c3ade50$var$utf8Slice(this, 0, length);
    return $add624580c3ade50$var$slowToString.apply(this, arguments);
};
$add624580c3ade50$var$Buffer.prototype.toLocaleString = $add624580c3ade50$var$Buffer.prototype.toString;
$add624580c3ade50$var$Buffer.prototype.equals = function equals(b) {
    if (!$add624580c3ade50$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $add624580c3ade50$var$Buffer.compare(this, b) === 0;
};
$add624580c3ade50$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $add624580c3ade50$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($add624580c3ade50$var$customInspectSymbol) $add624580c3ade50$var$Buffer.prototype[$add624580c3ade50$var$customInspectSymbol] = $add624580c3ade50$var$Buffer.prototype.inspect;
$add624580c3ade50$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($add624580c3ade50$var$isInstance(target, Uint8Array)) target = $add624580c3ade50$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$add624580c3ade50$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $add624580c3ade50$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($add624580c3ade50$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $add624580c3ade50$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($add624580c3ade50$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $add624580c3ade50$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $add624580c3ade50$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $add624580c3ade50$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$add624580c3ade50$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$add624580c3ade50$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $add624580c3ade50$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$add624580c3ade50$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $add624580c3ade50$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $add624580c3ade50$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($add624580c3ade50$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $add624580c3ade50$var$utf8Write(buf, string, offset, length) {
    return $add624580c3ade50$var$blitBuffer($add624580c3ade50$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $add624580c3ade50$var$asciiWrite(buf, string, offset, length) {
    return $add624580c3ade50$var$blitBuffer($add624580c3ade50$var$asciiToBytes(string), buf, offset, length);
}
function $add624580c3ade50$var$base64Write(buf, string, offset, length) {
    return $add624580c3ade50$var$blitBuffer($add624580c3ade50$var$base64ToBytes(string), buf, offset, length);
}
function $add624580c3ade50$var$ucs2Write(buf, string, offset, length) {
    return $add624580c3ade50$var$blitBuffer($add624580c3ade50$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$add624580c3ade50$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $add624580c3ade50$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $add624580c3ade50$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $add624580c3ade50$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $add624580c3ade50$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $add624580c3ade50$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$add624580c3ade50$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $add624580c3ade50$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $add624580c3ade50$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $add624580c3ade50$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $add624580c3ade50$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $add624580c3ade50$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $add624580c3ade50$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $add624580c3ade50$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $add624580c3ade50$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $add624580c3ade50$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $add624580c3ade50$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $add624580c3ade50$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $add624580c3ade50$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$add624580c3ade50$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $add624580c3ade50$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $add624580c3ade50$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$add624580c3ade50$var$Buffer.prototype.readUintLE = $add624580c3ade50$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$add624580c3ade50$var$Buffer.prototype.readUintBE = $add624580c3ade50$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$add624580c3ade50$var$Buffer.prototype.readUint8 = $add624580c3ade50$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$add624580c3ade50$var$Buffer.prototype.readUint16LE = $add624580c3ade50$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$add624580c3ade50$var$Buffer.prototype.readUint16BE = $add624580c3ade50$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$add624580c3ade50$var$Buffer.prototype.readUint32LE = $add624580c3ade50$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$add624580c3ade50$var$Buffer.prototype.readUint32BE = $add624580c3ade50$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$add624580c3ade50$var$Buffer.prototype.readBigUInt64LE = $add624580c3ade50$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $add624580c3ade50$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $add624580c3ade50$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$add624580c3ade50$var$Buffer.prototype.readBigUInt64BE = $add624580c3ade50$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $add624580c3ade50$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $add624580c3ade50$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$add624580c3ade50$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$add624580c3ade50$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$add624580c3ade50$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$add624580c3ade50$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$add624580c3ade50$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$add624580c3ade50$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$add624580c3ade50$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$add624580c3ade50$var$Buffer.prototype.readBigInt64LE = $add624580c3ade50$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $add624580c3ade50$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $add624580c3ade50$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$add624580c3ade50$var$Buffer.prototype.readBigInt64BE = $add624580c3ade50$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $add624580c3ade50$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $add624580c3ade50$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$add624580c3ade50$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$add624580c3ade50$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$add624580c3ade50$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$add624580c3ade50$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $add624580c3ade50$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$add624580c3ade50$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$add624580c3ade50$var$Buffer.prototype.writeUintLE = $add624580c3ade50$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $add624580c3ade50$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$add624580c3ade50$var$Buffer.prototype.writeUintBE = $add624580c3ade50$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $add624580c3ade50$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$add624580c3ade50$var$Buffer.prototype.writeUint8 = $add624580c3ade50$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$add624580c3ade50$var$Buffer.prototype.writeUint16LE = $add624580c3ade50$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$add624580c3ade50$var$Buffer.prototype.writeUint16BE = $add624580c3ade50$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$add624580c3ade50$var$Buffer.prototype.writeUint32LE = $add624580c3ade50$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$add624580c3ade50$var$Buffer.prototype.writeUint32BE = $add624580c3ade50$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $add624580c3ade50$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $add624580c3ade50$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $add624580c3ade50$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $add624580c3ade50$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$add624580c3ade50$var$Buffer.prototype.writeBigUInt64LE = $add624580c3ade50$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $add624580c3ade50$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$add624580c3ade50$var$Buffer.prototype.writeBigUInt64BE = $add624580c3ade50$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $add624580c3ade50$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$add624580c3ade50$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $add624580c3ade50$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$add624580c3ade50$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $add624580c3ade50$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$add624580c3ade50$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$add624580c3ade50$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$add624580c3ade50$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$add624580c3ade50$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$add624580c3ade50$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$add624580c3ade50$var$Buffer.prototype.writeBigInt64LE = $add624580c3ade50$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $add624580c3ade50$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$add624580c3ade50$var$Buffer.prototype.writeBigInt64BE = $add624580c3ade50$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $add624580c3ade50$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $add624580c3ade50$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $add624580c3ade50$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$add624580c3ade50$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $add624580c3ade50$var$writeFloat(this, value, offset, true, noAssert);
};
$add624580c3ade50$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $add624580c3ade50$var$writeFloat(this, value, offset, false, noAssert);
};
function $add624580c3ade50$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $add624580c3ade50$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$add624580c3ade50$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $add624580c3ade50$var$writeDouble(this, value, offset, true, noAssert);
};
$add624580c3ade50$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $add624580c3ade50$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$add624580c3ade50$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$add624580c3ade50$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$add624580c3ade50$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$add624580c3ade50$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $add624580c3ade50$var$Buffer.isBuffer(val) ? val : $add624580c3ade50$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $add624580c3ade50$var$errors = {};
function $add624580c3ade50$var$E(sym, getMessage, Base) {
    $add624580c3ade50$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$add624580c3ade50$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$add624580c3ade50$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$add624580c3ade50$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $add624580c3ade50$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $add624580c3ade50$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $add624580c3ade50$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $add624580c3ade50$var$checkBounds(buf, offset, byteLength) {
    $add624580c3ade50$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $add624580c3ade50$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $add624580c3ade50$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $add624580c3ade50$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $add624580c3ade50$var$checkBounds(buf, offset, byteLength);
}
function $add624580c3ade50$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $add624580c3ade50$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $add624580c3ade50$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $add624580c3ade50$var$validateNumber(value, type);
        throw new $add624580c3ade50$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $add624580c3ade50$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $add624580c3ade50$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $add624580c3ade50$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $add624580c3ade50$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($add624580c3ade50$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $add624580c3ade50$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $add624580c3ade50$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $add624580c3ade50$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $add624580c3ade50$var$base64ToBytes(str) {
    return $abUaD.toByteArray($add624580c3ade50$var$base64clean(str));
}
function $add624580c3ade50$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $add624580c3ade50$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $add624580c3ade50$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $add624580c3ade50$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $add624580c3ade50$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $add624580c3ade50$var$BufferBigIntNotDefined : fn;
}
function $add624580c3ade50$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("enBcu", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $a78011ebd9185af0$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $a78011ebd9185af0$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("fCNX2", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eVkja = parcelRequire("eVkja");

var $2fIx5 = parcelRequire("2fIx5");
var $b60126e50e6d0246$var$format = $2fIx5.format, $b60126e50e6d0246$var$inspect = $2fIx5.inspect;

var $aALsV = parcelRequire("aALsV");
var $b60126e50e6d0246$var$ERR_INVALID_ARG_TYPE = $aALsV.codes.ERR_INVALID_ARG_TYPE;

var $enBcu = parcelRequire("enBcu");
var $b60126e50e6d0246$var$kResistStopPropagation = $enBcu.kResistStopPropagation, $b60126e50e6d0246$var$AggregateError = $enBcu.AggregateError, $b60126e50e6d0246$var$SymbolDispose = $enBcu.SymbolDispose;

var $b60126e50e6d0246$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $b60126e50e6d0246$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $b60126e50e6d0246$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $b60126e50e6d0246$var$Blob = globalThis.Blob || $eVkja.Blob;
/* eslint-disable indent */ var $b60126e50e6d0246$var$isBlob = typeof $b60126e50e6d0246$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $b60126e50e6d0246$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $b60126e50e6d0246$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $b60126e50e6d0246$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $b60126e50e6d0246$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $b60126e50e6d0246$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $b60126e50e6d0246$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $b60126e50e6d0246$var$format,
    inspect: $b60126e50e6d0246$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $b60126e50e6d0246$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $b60126e50e6d0246$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $b60126e50e6d0246$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $b60126e50e6d0246$var$validateAbortSignal(signal, 'signal');
        $b60126e50e6d0246$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $b60126e50e6d0246$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $b60126e50e6d0246$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $b60126e50e6d0246$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $b60126e50e6d0246$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $b60126e50e6d0246$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("2fIx5", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("aALsV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $2fIx5 = parcelRequire("2fIx5");
var $7b6215d98c6b1f8c$var$format = $2fIx5.format, $7b6215d98c6b1f8c$var$inspect = $2fIx5.inspect;

var $enBcu = parcelRequire("enBcu");
var $7b6215d98c6b1f8c$var$CustomAggregateError = $enBcu.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $7b6215d98c6b1f8c$var$AggregateError = globalThis.AggregateError || $7b6215d98c6b1f8c$var$CustomAggregateError;
var $7b6215d98c6b1f8c$var$kIsNodeError = Symbol('kIsNodeError');
var $7b6215d98c6b1f8c$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $7b6215d98c6b1f8c$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $7b6215d98c6b1f8c$var$nodeInternalPrefix = '__node_internal_';
var $7b6215d98c6b1f8c$var$codes = {};
function $7b6215d98c6b1f8c$var$assert(value, message) {
    if (!value) throw new $7b6215d98c6b1f8c$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $7b6215d98c6b1f8c$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $7b6215d98c6b1f8c$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $7b6215d98c6b1f8c$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $7b6215d98c6b1f8c$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $7b6215d98c6b1f8c$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $7b6215d98c6b1f8c$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $7b6215d98c6b1f8c$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$7b6215d98c6b1f8c$var$kIsNodeError] = true;
    $7b6215d98c6b1f8c$var$codes[code] = NodeError;
}
function $7b6215d98c6b1f8c$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $7b6215d98c6b1f8c$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $7b6215d98c6b1f8c$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $7b6215d98c6b1f8c$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $7b6215d98c6b1f8c$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $7b6215d98c6b1f8c$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$7b6215d98c6b1f8c$var$E('ERR_ASSERTION', '%s', Error);
$7b6215d98c6b1f8c$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $7b6215d98c6b1f8c$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $7b6215d98c6b1f8c$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($7b6215d98c6b1f8c$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($7b6215d98c6b1f8c$var$classRegExp.test(value)) instances.push(value);
            else {
                $7b6215d98c6b1f8c$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $7b6215d98c6b1f8c$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $7b6215d98c6b1f8c$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$7b6215d98c6b1f8c$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $7b6215d98c6b1f8c$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$7b6215d98c6b1f8c$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$7b6215d98c6b1f8c$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $7b6215d98c6b1f8c$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7b6215d98c6b1f8c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $7b6215d98c6b1f8c$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $7b6215d98c6b1f8c$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $7b6215d98c6b1f8c$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $7b6215d98c6b1f8c$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$7b6215d98c6b1f8c$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$7b6215d98c6b1f8c$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$7b6215d98c6b1f8c$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$7b6215d98c6b1f8c$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $7b6215d98c6b1f8c$var$AbortError,
    aggregateTwoErrors: $7b6215d98c6b1f8c$var$hideStackFrames($7b6215d98c6b1f8c$var$aggregateTwoErrors),
    hideStackFrames: $7b6215d98c6b1f8c$var$hideStackFrames,
    codes: $7b6215d98c6b1f8c$var$codes
};

});


parcelRegister("h7E5W", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c77231194bda648a$export$42af8c323be37587; }, function (v) { return $c77231194bda648a$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c77231194bda648a$export$f405f72c701dad87; }, function (v) { return $c77231194bda648a$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $c77231194bda648a$export$42af8c323be37587;
var $c77231194bda648a$export$f405f72c701dad87;
'use strict';

var $c77231194bda648a$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $aALsV = parcelRequire("aALsV");
var $c77231194bda648a$var$_require_codes = $aALsV.codes, $c77231194bda648a$var$ERR_INVALID_ARG_VALUE = $c77231194bda648a$var$_require_codes.ERR_INVALID_ARG_VALUE, $c77231194bda648a$var$ERR_INVALID_ARG_TYPE = $c77231194bda648a$var$_require_codes.ERR_INVALID_ARG_TYPE, $c77231194bda648a$var$ERR_MISSING_ARGS = $c77231194bda648a$var$_require_codes.ERR_MISSING_ARGS, $c77231194bda648a$var$ERR_OUT_OF_RANGE = $c77231194bda648a$var$_require_codes.ERR_OUT_OF_RANGE, $c77231194bda648a$var$AbortError = $aALsV.AbortError;

var $jr5DF = parcelRequire("jr5DF");
var $c77231194bda648a$var$validateAbortSignal = $jr5DF.validateAbortSignal, $c77231194bda648a$var$validateInteger = $jr5DF.validateInteger, $c77231194bda648a$var$validateObject = $jr5DF.validateObject;

var $c77231194bda648a$var$kWeakHandler = (parcelRequire("enBcu")).Symbol('kWeak');

var $c77231194bda648a$var$kResistStopPropagation = (parcelRequire("enBcu")).Symbol('kResistStopPropagation');

var $dXW2j = parcelRequire("dXW2j");
var $c77231194bda648a$require$finished = $dXW2j.finished;

var $2PA0G = parcelRequire("2PA0G");

var $e2Flm = parcelRequire("e2Flm");
var $c77231194bda648a$require$addAbortSignalNoValidate = $e2Flm.addAbortSignalNoValidate;

var $C5MxV = parcelRequire("C5MxV");
var $c77231194bda648a$var$isWritable = $C5MxV.isWritable, $c77231194bda648a$var$isNodeStream = $C5MxV.isNodeStream;

var $c77231194bda648a$require$deprecate = (parcelRequire("fCNX2")).deprecate;

var $c77231194bda648a$var$ArrayPrototypePush = (parcelRequire("enBcu")).ArrayPrototypePush, $c77231194bda648a$var$Boolean = (parcelRequire("enBcu")).Boolean, $c77231194bda648a$var$MathFloor = (parcelRequire("enBcu")).MathFloor, $c77231194bda648a$var$Number = (parcelRequire("enBcu")).Number, $c77231194bda648a$var$NumberIsNaN = (parcelRequire("enBcu")).NumberIsNaN, $c77231194bda648a$var$Promise = (parcelRequire("enBcu")).Promise, $c77231194bda648a$var$PromiseReject = (parcelRequire("enBcu")).PromiseReject, $c77231194bda648a$var$PromiseResolve = (parcelRequire("enBcu")).PromiseResolve, $c77231194bda648a$var$PromisePrototypeThen = (parcelRequire("enBcu")).PromisePrototypeThen, $c77231194bda648a$var$Symbol = (parcelRequire("enBcu")).Symbol;
var $c77231194bda648a$var$kEmpty = $c77231194bda648a$var$Symbol('kEmpty');
var $c77231194bda648a$var$kEof = $c77231194bda648a$var$Symbol('kEof');
function $c77231194bda648a$var$compose(stream, options) {
    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
    if ($c77231194bda648a$var$isNodeStream(stream) && !$c77231194bda648a$var$isWritable(stream)) throw new $c77231194bda648a$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $2PA0G(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c77231194bda648a$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c77231194bda648a$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c77231194bda648a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c77231194bda648a$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c77231194bda648a$var$MathFloor(options.highWaterMark);
    $c77231194bda648a$var$validateInteger(concurrency, 'options.concurrency', 1);
    $c77231194bda648a$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $c77231194bda648a$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $c77231194bda648a$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $c77231194bda648a$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $c77231194bda648a$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $c77231194bda648a$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $c77231194bda648a$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($c77231194bda648a$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $c77231194bda648a$var$PromiseReject(err1);
                                $c77231194bda648a$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("fCNX2")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($c77231194bda648a$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $c77231194bda648a$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $c77231194bda648a$var$AbortError();
                        if (!(val !== $c77231194bda648a$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $c77231194bda648a$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c77231194bda648a$var$asIndexedPairs(options) {
    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c77231194bda648a$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c77231194bda648a$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c77231194bda648a$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $c77231194bda648a$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $c77231194bda648a$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $c77231194bda648a$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $c77231194bda648a$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c77231194bda648a$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $c77231194bda648a$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $c77231194bda648a$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $c77231194bda648a$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($c77231194bda648a$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $c77231194bda648a$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c77231194bda648a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $c77231194bda648a$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $c77231194bda648a$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $c77231194bda648a$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($c77231194bda648a$var$ERR_MISSING_ARGS);
function $c77231194bda648a$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $c77231194bda648a$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $c77231194bda648a$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $c77231194bda648a$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $c77231194bda648a$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $c77231194bda648a$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $c77231194bda648a$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c77231194bda648a$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $c77231194bda648a$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c77231194bda648a$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c77231194bda648a$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $c77231194bda648a$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $c77231194bda648a$var$flatMap(fn, options) {
    var values = $c77231194bda648a$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $c77231194bda648a$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c77231194bda648a$var$Number(number);
    if ($c77231194bda648a$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c77231194bda648a$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c77231194bda648a$var$drop(number, options) {
    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
    number = $c77231194bda648a$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c77231194bda648a$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c77231194bda648a$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $c77231194bda648a$var$take(number, options) {
    if (options != null) $c77231194bda648a$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c77231194bda648a$var$validateAbortSignal(options.signal, 'options.signal');
    number = $c77231194bda648a$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c77231194bda648a$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c77231194bda648a$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$c77231194bda648a$export$42af8c323be37587 = {
    asIndexedPairs: $c77231194bda648a$require$deprecate($c77231194bda648a$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c77231194bda648a$var$drop,
    filter: $c77231194bda648a$var$filter,
    flatMap: $c77231194bda648a$var$flatMap,
    map: $c77231194bda648a$var$map,
    take: $c77231194bda648a$var$take,
    compose: $c77231194bda648a$var$compose
};
$c77231194bda648a$export$f405f72c701dad87 = {
    every: $c77231194bda648a$var$every,
    forEach: $c77231194bda648a$var$forEach,
    reduce: $c77231194bda648a$var$reduce,
    toArray: $c77231194bda648a$var$toArray,
    some: $c77231194bda648a$var$some,
    find: $c77231194bda648a$var$find
};

});
parcelRegister("jr5DF", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $e264e9ae2acdcf2a$var$ArrayIsArray = $enBcu.ArrayIsArray, $e264e9ae2acdcf2a$var$ArrayPrototypeIncludes = $enBcu.ArrayPrototypeIncludes, $e264e9ae2acdcf2a$var$ArrayPrototypeJoin = $enBcu.ArrayPrototypeJoin, $e264e9ae2acdcf2a$var$ArrayPrototypeMap = $enBcu.ArrayPrototypeMap, $e264e9ae2acdcf2a$var$NumberIsInteger = $enBcu.NumberIsInteger, $e264e9ae2acdcf2a$var$NumberIsNaN = $enBcu.NumberIsNaN, $e264e9ae2acdcf2a$var$NumberMAX_SAFE_INTEGER = $enBcu.NumberMAX_SAFE_INTEGER, $e264e9ae2acdcf2a$var$NumberMIN_SAFE_INTEGER = $enBcu.NumberMIN_SAFE_INTEGER, $e264e9ae2acdcf2a$var$NumberParseInt = $enBcu.NumberParseInt, $e264e9ae2acdcf2a$var$ObjectPrototypeHasOwnProperty = $enBcu.ObjectPrototypeHasOwnProperty, $e264e9ae2acdcf2a$var$RegExpPrototypeExec = $enBcu.RegExpPrototypeExec, $e264e9ae2acdcf2a$var$String = $enBcu.String, $e264e9ae2acdcf2a$var$StringPrototypeToUpperCase = $enBcu.StringPrototypeToUpperCase, $e264e9ae2acdcf2a$var$StringPrototypeTrim = $enBcu.StringPrototypeTrim;

var $aALsV = parcelRequire("aALsV");
var $e264e9ae2acdcf2a$var$hideStackFrames = $aALsV.hideStackFrames, $e264e9ae2acdcf2a$var$_require_codes = $aALsV.codes, $e264e9ae2acdcf2a$var$ERR_SOCKET_BAD_PORT = $e264e9ae2acdcf2a$var$_require_codes.ERR_SOCKET_BAD_PORT, $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE = $e264e9ae2acdcf2a$var$_require_codes.ERR_INVALID_ARG_TYPE, $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE = $e264e9ae2acdcf2a$var$_require_codes.ERR_INVALID_ARG_VALUE, $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE = $e264e9ae2acdcf2a$var$_require_codes.ERR_OUT_OF_RANGE, $e264e9ae2acdcf2a$var$ERR_UNKNOWN_SIGNAL = $e264e9ae2acdcf2a$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $fCNX2 = parcelRequire("fCNX2");
var $e264e9ae2acdcf2a$require$normalizeEncoding = $fCNX2.normalizeEncoding;

var $fCNX2 = parcelRequire("fCNX2");
var $e264e9ae2acdcf2a$require$_require_types = $fCNX2.types;
var $e264e9ae2acdcf2a$var$isAsyncFunction = $e264e9ae2acdcf2a$require$_require_types.isAsyncFunction, $e264e9ae2acdcf2a$var$isArrayBufferView = $e264e9ae2acdcf2a$require$_require_types.isArrayBufferView;
var $e264e9ae2acdcf2a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e264e9ae2acdcf2a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e264e9ae2acdcf2a$var$isUint32(value) {
    return value === value >>> 0;
}
var $e264e9ae2acdcf2a$var$octalReg = /^[0-7]+$/;
var $e264e9ae2acdcf2a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e264e9ae2acdcf2a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e264e9ae2acdcf2a$var$RegExpPrototypeExec($e264e9ae2acdcf2a$var$octalReg, value) === null) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE(name, value, $e264e9ae2acdcf2a$var$modeDesc);
        value = $e264e9ae2acdcf2a$var$NumberParseInt(value, 8);
    }
    $e264e9ae2acdcf2a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $e264e9ae2acdcf2a$var$validateInteger = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e264e9ae2acdcf2a$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $e264e9ae2acdcf2a$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e264e9ae2acdcf2a$var$NumberIsInteger(value)) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $e264e9ae2acdcf2a$var$validateInt32 = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e264e9ae2acdcf2a$var$NumberIsInteger(value)) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $e264e9ae2acdcf2a$var$validateUint32 = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e264e9ae2acdcf2a$var$NumberIsInteger(value)) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e264e9ae2acdcf2a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e264e9ae2acdcf2a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e264e9ae2acdcf2a$var$NumberIsNaN(value)) throw new $e264e9ae2acdcf2a$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $e264e9ae2acdcf2a$var$validateOneOf = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name, oneOf) {
    if (!$e264e9ae2acdcf2a$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $e264e9ae2acdcf2a$var$ArrayPrototypeJoin($e264e9ae2acdcf2a$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $e264e9ae2acdcf2a$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e264e9ae2acdcf2a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e264e9ae2acdcf2a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e264e9ae2acdcf2a$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $e264e9ae2acdcf2a$var$validateObject = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $e264e9ae2acdcf2a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $e264e9ae2acdcf2a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $e264e9ae2acdcf2a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e264e9ae2acdcf2a$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $e264e9ae2acdcf2a$var$validateDictionary = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $e264e9ae2acdcf2a$var$validateArray = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$e264e9ae2acdcf2a$var$ArrayIsArray(value)) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e264e9ae2acdcf2a$var$validateStringArray(value, name) {
    $e264e9ae2acdcf2a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e264e9ae2acdcf2a$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e264e9ae2acdcf2a$var$validateBooleanArray(value, name) {
    $e264e9ae2acdcf2a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$e264e9ae2acdcf2a$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e264e9ae2acdcf2a$var$validateAbortSignalArray(value, name) {
    $e264e9ae2acdcf2a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e264e9ae2acdcf2a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e264e9ae2acdcf2a$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $e264e9ae2acdcf2a$var$validateString(signal, name);
    if ($e264e9ae2acdcf2a$var$signals[signal] === undefined) {
        if ($e264e9ae2acdcf2a$var$signals[$e264e9ae2acdcf2a$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e264e9ae2acdcf2a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e264e9ae2acdcf2a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $e264e9ae2acdcf2a$var$validateBuffer = $e264e9ae2acdcf2a$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$e264e9ae2acdcf2a$var$isArrayBufferView(buffer)) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e264e9ae2acdcf2a$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $e264e9ae2acdcf2a$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e264e9ae2acdcf2a$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e264e9ae2acdcf2a$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e264e9ae2acdcf2a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $e264e9ae2acdcf2a$var$validateAbortSignal = $e264e9ae2acdcf2a$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $e264e9ae2acdcf2a$var$validateFunction = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $e264e9ae2acdcf2a$var$validatePlainFunction = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $e264e9ae2acdcf2a$var$isAsyncFunction(value)) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $e264e9ae2acdcf2a$var$validateUndefined = $e264e9ae2acdcf2a$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e264e9ae2acdcf2a$var$validateUnion(value, name, union) {
    if (!$e264e9ae2acdcf2a$var$ArrayPrototypeIncludes(union, value)) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_TYPE(name, "('".concat($e264e9ae2acdcf2a$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $e264e9ae2acdcf2a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e264e9ae2acdcf2a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e264e9ae2acdcf2a$var$RegExpPrototypeExec($e264e9ae2acdcf2a$var$linkValueRegExp, value)) throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e264e9ae2acdcf2a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e264e9ae2acdcf2a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e264e9ae2acdcf2a$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $e264e9ae2acdcf2a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e264e9ae2acdcf2a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e264e9ae2acdcf2a$var$isInt32,
    isUint32: $e264e9ae2acdcf2a$var$isUint32,
    parseFileMode: $e264e9ae2acdcf2a$var$parseFileMode,
    validateArray: $e264e9ae2acdcf2a$var$validateArray,
    validateStringArray: $e264e9ae2acdcf2a$var$validateStringArray,
    validateBooleanArray: $e264e9ae2acdcf2a$var$validateBooleanArray,
    validateAbortSignalArray: $e264e9ae2acdcf2a$var$validateAbortSignalArray,
    validateBoolean: $e264e9ae2acdcf2a$var$validateBoolean,
    validateBuffer: $e264e9ae2acdcf2a$var$validateBuffer,
    validateDictionary: $e264e9ae2acdcf2a$var$validateDictionary,
    validateEncoding: $e264e9ae2acdcf2a$var$validateEncoding,
    validateFunction: $e264e9ae2acdcf2a$var$validateFunction,
    validateInt32: $e264e9ae2acdcf2a$var$validateInt32,
    validateInteger: $e264e9ae2acdcf2a$var$validateInteger,
    validateNumber: $e264e9ae2acdcf2a$var$validateNumber,
    validateObject: $e264e9ae2acdcf2a$var$validateObject,
    validateOneOf: $e264e9ae2acdcf2a$var$validateOneOf,
    validatePlainFunction: $e264e9ae2acdcf2a$var$validatePlainFunction,
    validatePort: $e264e9ae2acdcf2a$var$validatePort,
    validateSignalName: $e264e9ae2acdcf2a$var$validateSignalName,
    validateString: $e264e9ae2acdcf2a$var$validateString,
    validateUint32: $e264e9ae2acdcf2a$var$validateUint32,
    validateUndefined: $e264e9ae2acdcf2a$var$validateUndefined,
    validateUnion: $e264e9ae2acdcf2a$var$validateUnion,
    validateAbortSignal: $e264e9ae2acdcf2a$var$validateAbortSignal,
    validateLinkHeaderValue: $e264e9ae2acdcf2a$var$validateLinkHeaderValue
};

});

parcelRegister("dXW2j", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $aALsV = parcelRequire("aALsV");
/* replacement end */ var $a2adcdda48bcea7e$var$AbortError = $aALsV.AbortError, $a2adcdda48bcea7e$var$codes = $aALsV.codes;
var $a2adcdda48bcea7e$var$ERR_INVALID_ARG_TYPE = $a2adcdda48bcea7e$var$codes.ERR_INVALID_ARG_TYPE, $a2adcdda48bcea7e$var$ERR_STREAM_PREMATURE_CLOSE = $a2adcdda48bcea7e$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $a2adcdda48bcea7e$var$kEmptyObject = (parcelRequire("fCNX2")).kEmptyObject, $a2adcdda48bcea7e$var$once = (parcelRequire("fCNX2")).once;

var $jr5DF = parcelRequire("jr5DF");
var $a2adcdda48bcea7e$var$validateAbortSignal = $jr5DF.validateAbortSignal, $a2adcdda48bcea7e$var$validateFunction = $jr5DF.validateFunction, $a2adcdda48bcea7e$var$validateObject = $jr5DF.validateObject, $a2adcdda48bcea7e$var$validateBoolean = $jr5DF.validateBoolean;

var $enBcu = parcelRequire("enBcu");
var $a2adcdda48bcea7e$var$Promise = $enBcu.Promise, $a2adcdda48bcea7e$var$PromisePrototypeThen = $enBcu.PromisePrototypeThen, $a2adcdda48bcea7e$var$SymbolDispose = $enBcu.SymbolDispose;

var $C5MxV = parcelRequire("C5MxV");
var $a2adcdda48bcea7e$var$isClosed = $C5MxV.isClosed, $a2adcdda48bcea7e$var$isReadable = $C5MxV.isReadable, $a2adcdda48bcea7e$var$isReadableNodeStream = $C5MxV.isReadableNodeStream, $a2adcdda48bcea7e$var$isReadableStream = $C5MxV.isReadableStream, $a2adcdda48bcea7e$var$isReadableFinished = $C5MxV.isReadableFinished, $a2adcdda48bcea7e$var$isReadableErrored = $C5MxV.isReadableErrored, $a2adcdda48bcea7e$var$isWritable = $C5MxV.isWritable, $a2adcdda48bcea7e$var$isWritableNodeStream = $C5MxV.isWritableNodeStream, $a2adcdda48bcea7e$var$isWritableStream = $C5MxV.isWritableStream, $a2adcdda48bcea7e$var$isWritableFinished = $C5MxV.isWritableFinished, $a2adcdda48bcea7e$var$isWritableErrored = $C5MxV.isWritableErrored, $a2adcdda48bcea7e$var$isNodeStream = $C5MxV.isNodeStream, $a2adcdda48bcea7e$var$_willEmitClose = $C5MxV.willEmitClose, $a2adcdda48bcea7e$var$kIsClosedPromise = $C5MxV.kIsClosedPromise;
var $a2adcdda48bcea7e$var$addAbortListener;
function $a2adcdda48bcea7e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $a2adcdda48bcea7e$var$nop = function() {};

function $a2adcdda48bcea7e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a2adcdda48bcea7e$var$kEmptyObject;
    } else if (options == null) options = $a2adcdda48bcea7e$var$kEmptyObject;
    else $a2adcdda48bcea7e$var$validateObject(options, 'options');
    $a2adcdda48bcea7e$var$validateFunction(callback, 'callback');
    $a2adcdda48bcea7e$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $a2adcdda48bcea7e$var$once(callback);
    if ($a2adcdda48bcea7e$var$isReadableStream(stream) || $a2adcdda48bcea7e$var$isWritableStream(stream)) return $a2adcdda48bcea7e$var$eosWeb(stream, options, callback);
    if (!$a2adcdda48bcea7e$var$isNodeStream(stream)) throw new $a2adcdda48bcea7e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a2adcdda48bcea7e$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a2adcdda48bcea7e$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $a2adcdda48bcea7e$var$_willEmitClose(stream) && $a2adcdda48bcea7e$var$isReadableNodeStream(stream) === readable && $a2adcdda48bcea7e$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $a2adcdda48bcea7e$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $a2adcdda48bcea7e$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $a2adcdda48bcea7e$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $a2adcdda48bcea7e$var$isWritableErrored(stream) || $a2adcdda48bcea7e$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a2adcdda48bcea7e$var$isReadableNodeStream(stream, true)) {
            if (!$a2adcdda48bcea7e$var$isReadableFinished(stream, false)) return callback.call(stream, new $a2adcdda48bcea7e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a2adcdda48bcea7e$var$isWritableFinished(stream, false)) return callback.call(stream, new $a2adcdda48bcea7e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $a2adcdda48bcea7e$var$isWritableErrored(stream) || $a2adcdda48bcea7e$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($a2adcdda48bcea7e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a2adcdda48bcea7e$var$isReadable(stream)) && (writableFinished || $a2adcdda48bcea7e$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a2adcdda48bcea7e$var$isWritable(stream)) && (readableFinished || $a2adcdda48bcea7e$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $a2adcdda48bcea7e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a2adcdda48bcea7e$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $a2adcdda48bcea7e$var$addAbortListener = $a2adcdda48bcea7e$var$addAbortListener || (parcelRequire("fCNX2")).addAbortListener;
            var disposable = $a2adcdda48bcea7e$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $a2adcdda48bcea7e$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$a2adcdda48bcea7e$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a2adcdda48bcea7e$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $a2adcdda48bcea7e$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $a2adcdda48bcea7e$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $a2adcdda48bcea7e$var$addAbortListener = $a2adcdda48bcea7e$var$addAbortListener || (parcelRequire("fCNX2")).addAbortListener;
            var disposable = $a2adcdda48bcea7e$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $a2adcdda48bcea7e$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$a2adcdda48bcea7e$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $a2adcdda48bcea7e$var$PromisePrototypeThen(stream[$a2adcdda48bcea7e$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a2adcdda48bcea7e$var$nop;
}
function $a2adcdda48bcea7e$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $a2adcdda48bcea7e$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a2adcdda48bcea7e$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a2adcdda48bcea7e$var$Promise(function(resolve, reject) {
        var cleanup = $a2adcdda48bcea7e$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a2adcdda48bcea7e$var$eos;
module.exports.finished = $a2adcdda48bcea7e$var$finished;

});
parcelRegister("C5MxV", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $072808e8efe2df31$var$SymbolAsyncIterator = $enBcu.SymbolAsyncIterator, $072808e8efe2df31$var$SymbolIterator = $enBcu.SymbolIterator, $072808e8efe2df31$var$SymbolFor = $enBcu.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $072808e8efe2df31$var$kIsDestroyed = $072808e8efe2df31$var$SymbolFor('nodejs.stream.destroyed');
var $072808e8efe2df31$var$kIsErrored = $072808e8efe2df31$var$SymbolFor('nodejs.stream.errored');
var $072808e8efe2df31$var$kIsReadable = $072808e8efe2df31$var$SymbolFor('nodejs.stream.readable');
var $072808e8efe2df31$var$kIsWritable = $072808e8efe2df31$var$SymbolFor('nodejs.stream.writable');
var $072808e8efe2df31$var$kIsDisturbed = $072808e8efe2df31$var$SymbolFor('nodejs.stream.disturbed');
var $072808e8efe2df31$var$kIsClosedPromise = $072808e8efe2df31$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $072808e8efe2df31$var$kControllerErrorFunction = $072808e8efe2df31$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $072808e8efe2df31$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $072808e8efe2df31$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $072808e8efe2df31$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $072808e8efe2df31$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $072808e8efe2df31$var$isReadableStream(obj) {
    return !!(obj && !$072808e8efe2df31$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $072808e8efe2df31$var$isWritableStream(obj) {
    return !!(obj && !$072808e8efe2df31$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $072808e8efe2df31$var$isTransformStream(obj) {
    return !!(obj && !$072808e8efe2df31$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $072808e8efe2df31$var$isWebStream(obj) {
    return $072808e8efe2df31$var$isReadableStream(obj) || $072808e8efe2df31$var$isWritableStream(obj) || $072808e8efe2df31$var$isTransformStream(obj);
}
function $072808e8efe2df31$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$072808e8efe2df31$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$072808e8efe2df31$var$SymbolIterator] === 'function';
    return typeof obj[$072808e8efe2df31$var$SymbolAsyncIterator] === 'function' || typeof obj[$072808e8efe2df31$var$SymbolIterator] === 'function';
}
function $072808e8efe2df31$var$isDestroyed(stream) {
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$072808e8efe2df31$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $072808e8efe2df31$var$isWritableEnded(stream) {
    if (!$072808e8efe2df31$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $072808e8efe2df31$var$isWritableFinished(stream, strict) {
    if (!$072808e8efe2df31$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $072808e8efe2df31$var$isReadableEnded(stream) {
    if (!$072808e8efe2df31$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $072808e8efe2df31$var$isReadableFinished(stream, strict) {
    if (!$072808e8efe2df31$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $072808e8efe2df31$var$isReadable(stream) {
    if (stream && stream[$072808e8efe2df31$var$kIsReadable] != null) return stream[$072808e8efe2df31$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($072808e8efe2df31$var$isDestroyed(stream)) return false;
    return $072808e8efe2df31$var$isReadableNodeStream(stream) && stream.readable && !$072808e8efe2df31$var$isReadableFinished(stream);
}
function $072808e8efe2df31$var$isWritable(stream) {
    if (stream && stream[$072808e8efe2df31$var$kIsWritable] != null) return stream[$072808e8efe2df31$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($072808e8efe2df31$var$isDestroyed(stream)) return false;
    return $072808e8efe2df31$var$isWritableNodeStream(stream) && stream.writable && !$072808e8efe2df31$var$isWritableEnded(stream);
}
function $072808e8efe2df31$var$isFinished(stream, opts) {
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    if ($072808e8efe2df31$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $072808e8efe2df31$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $072808e8efe2df31$var$isWritable(stream)) return false;
    return true;
}
function $072808e8efe2df31$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $072808e8efe2df31$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $072808e8efe2df31$var$isClosed(stream) {
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $072808e8efe2df31$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $072808e8efe2df31$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $072808e8efe2df31$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $072808e8efe2df31$var$isOutgoingMessage(stream);
}
function $072808e8efe2df31$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $072808e8efe2df31$var$willEmitClose(stream) {
    if (!$072808e8efe2df31$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $072808e8efe2df31$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $072808e8efe2df31$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$072808e8efe2df31$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $072808e8efe2df31$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$072808e8efe2df31$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $072808e8efe2df31$var$isDestroyed,
    kIsDestroyed: $072808e8efe2df31$var$kIsDestroyed,
    isDisturbed: $072808e8efe2df31$var$isDisturbed,
    kIsDisturbed: $072808e8efe2df31$var$kIsDisturbed,
    isErrored: $072808e8efe2df31$var$isErrored,
    kIsErrored: $072808e8efe2df31$var$kIsErrored,
    isReadable: $072808e8efe2df31$var$isReadable,
    kIsReadable: $072808e8efe2df31$var$kIsReadable,
    kIsClosedPromise: $072808e8efe2df31$var$kIsClosedPromise,
    kControllerErrorFunction: $072808e8efe2df31$var$kControllerErrorFunction,
    kIsWritable: $072808e8efe2df31$var$kIsWritable,
    isClosed: $072808e8efe2df31$var$isClosed,
    isDuplexNodeStream: $072808e8efe2df31$var$isDuplexNodeStream,
    isFinished: $072808e8efe2df31$var$isFinished,
    isIterable: $072808e8efe2df31$var$isIterable,
    isReadableNodeStream: $072808e8efe2df31$var$isReadableNodeStream,
    isReadableStream: $072808e8efe2df31$var$isReadableStream,
    isReadableEnded: $072808e8efe2df31$var$isReadableEnded,
    isReadableFinished: $072808e8efe2df31$var$isReadableFinished,
    isReadableErrored: $072808e8efe2df31$var$isReadableErrored,
    isNodeStream: $072808e8efe2df31$var$isNodeStream,
    isWebStream: $072808e8efe2df31$var$isWebStream,
    isWritable: $072808e8efe2df31$var$isWritable,
    isWritableNodeStream: $072808e8efe2df31$var$isWritableNodeStream,
    isWritableStream: $072808e8efe2df31$var$isWritableStream,
    isWritableEnded: $072808e8efe2df31$var$isWritableEnded,
    isWritableFinished: $072808e8efe2df31$var$isWritableFinished,
    isWritableErrored: $072808e8efe2df31$var$isWritableErrored,
    isServerRequest: $072808e8efe2df31$var$isServerRequest,
    isServerResponse: $072808e8efe2df31$var$isServerResponse,
    willEmitClose: $072808e8efe2df31$var$willEmitClose,
    isTransformStream: $072808e8efe2df31$var$isTransformStream
};

});


parcelRegister("2PA0G", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $5U91j = parcelRequire("5U91j");
var $20fc470d6b022e50$require$pipeline = $5U91j.pipeline;

var $8bwfW = parcelRequire("8bwfW");

var $3aXq0 = parcelRequire("3aXq0");
var $20fc470d6b022e50$require$destroyer = $3aXq0.destroyer;

var $C5MxV = parcelRequire("C5MxV");
var $20fc470d6b022e50$var$isNodeStream = $C5MxV.isNodeStream, $20fc470d6b022e50$var$isReadable = $C5MxV.isReadable, $20fc470d6b022e50$var$isWritable = $C5MxV.isWritable, $20fc470d6b022e50$var$isWebStream = $C5MxV.isWebStream, $20fc470d6b022e50$var$isTransformStream = $C5MxV.isTransformStream, $20fc470d6b022e50$var$isWritableStream = $C5MxV.isWritableStream, $20fc470d6b022e50$var$isReadableStream = $C5MxV.isReadableStream;

var $aALsV = parcelRequire("aALsV");
var $20fc470d6b022e50$var$AbortError = $aALsV.AbortError, $20fc470d6b022e50$var$_require_codes = $aALsV.codes, $20fc470d6b022e50$var$ERR_INVALID_ARG_VALUE = $20fc470d6b022e50$var$_require_codes.ERR_INVALID_ARG_VALUE, $20fc470d6b022e50$var$ERR_MISSING_ARGS = $20fc470d6b022e50$var$_require_codes.ERR_MISSING_ARGS;

var $dXW2j = parcelRequire("dXW2j");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $20fc470d6b022e50$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $8bwfW.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $8bwfW.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $8bwfW.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$20fc470d6b022e50$var$isNodeStream(streams[n]) && !$20fc470d6b022e50$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($20fc470d6b022e50$var$isReadable(streams[n]) || $20fc470d6b022e50$var$isReadableStream(streams[n]) || $20fc470d6b022e50$var$isTransformStream(streams[n]))) throw new $20fc470d6b022e50$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($20fc470d6b022e50$var$isWritable(streams[n]) || $20fc470d6b022e50$var$isWritableStream(streams[n]) || $20fc470d6b022e50$var$isTransformStream(streams[n]))) throw new $20fc470d6b022e50$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $20fc470d6b022e50$require$pipeline(streams, onfinished);
    var writable = !!($20fc470d6b022e50$var$isWritable(head) || $20fc470d6b022e50$var$isWritableStream(head) || $20fc470d6b022e50$var$isTransformStream(head));
    var readable = !!($20fc470d6b022e50$var$isReadable(tail) || $20fc470d6b022e50$var$isReadableStream(tail) || $20fc470d6b022e50$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $8bwfW({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($20fc470d6b022e50$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($20fc470d6b022e50$var$isWebStream(head)) {
            var writable1 = $20fc470d6b022e50$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $20fc470d6b022e50$var$isTransformStream(tail) ? tail.readable : tail;
        $dXW2j(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($20fc470d6b022e50$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($20fc470d6b022e50$var$isWebStream(tail)) {
            var readable1 = $20fc470d6b022e50$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $20fc470d6b022e50$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($20fc470d6b022e50$var$isNodeStream(tail)) $20fc470d6b022e50$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("5U91j", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $44c92df45ffff83e$var$ArrayIsArray = $enBcu.ArrayIsArray, $44c92df45ffff83e$var$Promise = $enBcu.Promise, $44c92df45ffff83e$var$SymbolAsyncIterator = $enBcu.SymbolAsyncIterator, $44c92df45ffff83e$var$SymbolDispose = $enBcu.SymbolDispose;

var $dXW2j = parcelRequire("dXW2j");

var $44c92df45ffff83e$require$once = (parcelRequire("fCNX2")).once;

var $3aXq0 = parcelRequire("3aXq0");

var $8bwfW = parcelRequire("8bwfW");

var $aALsV = parcelRequire("aALsV");
var $44c92df45ffff83e$var$aggregateTwoErrors = $aALsV.aggregateTwoErrors, $44c92df45ffff83e$var$_require_codes = $aALsV.codes, $44c92df45ffff83e$var$ERR_INVALID_ARG_TYPE = $44c92df45ffff83e$var$_require_codes.ERR_INVALID_ARG_TYPE, $44c92df45ffff83e$var$ERR_INVALID_RETURN_VALUE = $44c92df45ffff83e$var$_require_codes.ERR_INVALID_RETURN_VALUE, $44c92df45ffff83e$var$ERR_MISSING_ARGS = $44c92df45ffff83e$var$_require_codes.ERR_MISSING_ARGS, $44c92df45ffff83e$var$ERR_STREAM_DESTROYED = $44c92df45ffff83e$var$_require_codes.ERR_STREAM_DESTROYED, $44c92df45ffff83e$var$ERR_STREAM_PREMATURE_CLOSE = $44c92df45ffff83e$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $44c92df45ffff83e$var$AbortError = $aALsV.AbortError;

var $jr5DF = parcelRequire("jr5DF");
var $44c92df45ffff83e$var$validateFunction = $jr5DF.validateFunction, $44c92df45ffff83e$var$validateAbortSignal = $jr5DF.validateAbortSignal;

var $C5MxV = parcelRequire("C5MxV");
var $44c92df45ffff83e$var$isIterable = $C5MxV.isIterable, $44c92df45ffff83e$var$isReadable = $C5MxV.isReadable, $44c92df45ffff83e$var$isReadableNodeStream = $C5MxV.isReadableNodeStream, $44c92df45ffff83e$var$isNodeStream = $C5MxV.isNodeStream, $44c92df45ffff83e$var$isTransformStream = $C5MxV.isTransformStream, $44c92df45ffff83e$var$isWebStream = $C5MxV.isWebStream, $44c92df45ffff83e$var$isReadableStream = $C5MxV.isReadableStream, $44c92df45ffff83e$var$isReadableFinished = $C5MxV.isReadableFinished;

var $44c92df45ffff83e$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $44c92df45ffff83e$var$PassThrough;
var $44c92df45ffff83e$var$Readable;
var $44c92df45ffff83e$var$addAbortListener;
function $44c92df45ffff83e$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $dXW2j(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $3aXq0.destroyer(stream, err || new $44c92df45ffff83e$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $44c92df45ffff83e$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $44c92df45ffff83e$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $44c92df45ffff83e$var$makeAsyncIterable(val) {
    if ($44c92df45ffff83e$var$isIterable(val)) return val;
    else if ($44c92df45ffff83e$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $44c92df45ffff83e$var$fromReadable(val);
    throw new $44c92df45ffff83e$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $44c92df45ffff83e$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$44c92df45ffff83e$var$Readable) $44c92df45ffff83e$var$Readable = (parcelRequire("jXcuS"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($44c92df45ffff83e$var$Readable.prototype[$44c92df45ffff83e$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $44c92df45ffff83e$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $44c92df45ffff83e$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $dXW2j(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $44c92df45ffff83e$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $44c92df45ffff83e$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($44c92df45ffff83e$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $44c92df45ffff83e$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $44c92df45ffff83e$var$pipelineImpl(streams, $44c92df45ffff83e$require$once($44c92df45ffff83e$var$popCallback(streams)));
}


function $44c92df45ffff83e$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($44c92df45ffff83e$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $44c92df45ffff83e$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($44c92df45ffff83e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($44c92df45ffff83e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$44c92df45ffff83e$var$isIterable(ret)) throw new $44c92df45ffff83e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($44c92df45ffff83e$var$isIterable(stream) || $44c92df45ffff83e$var$isReadableNodeStream(stream) || $44c92df45ffff83e$var$isTransformStream(stream)) ret = stream;
            else ret = $8bwfW.from(stream);
        } else if (typeof stream === 'function') {
            if ($44c92df45ffff83e$var$isTransformStream(ret)) {
                var _ret;
                ret = $44c92df45ffff83e$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $44c92df45ffff83e$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$44c92df45ffff83e$var$isIterable(ret, true)) throw new $44c92df45ffff83e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$44c92df45ffff83e$var$PassThrough) $44c92df45ffff83e$var$PassThrough = (parcelRequire("9nhuj"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $44c92df45ffff83e$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($44c92df45ffff83e$var$isIterable(ret, true)) {
                    finishCount++;
                    $44c92df45ffff83e$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($44c92df45ffff83e$var$isReadableStream(ret) || $44c92df45ffff83e$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $44c92df45ffff83e$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $44c92df45ffff83e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $44c92df45ffff83e$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($44c92df45ffff83e$var$isNodeStream(stream)) {
            if ($44c92df45ffff83e$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $44c92df45ffff83e$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($44c92df45ffff83e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($44c92df45ffff83e$var$isTransformStream(ret) || $44c92df45ffff83e$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $44c92df45ffff83e$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($44c92df45ffff83e$var$isIterable(ret)) {
                finishCount++;
                $44c92df45ffff83e$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $44c92df45ffff83e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($44c92df45ffff83e$var$isWebStream(stream)) {
            if ($44c92df45ffff83e$var$isReadableNodeStream(ret)) {
                finishCount++;
                $44c92df45ffff83e$var$pumpToWeb($44c92df45ffff83e$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($44c92df45ffff83e$var$isReadableStream(ret) || $44c92df45ffff83e$var$isIterable(ret)) {
                finishCount++;
                $44c92df45ffff83e$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($44c92df45ffff83e$var$isTransformStream(ret)) {
                finishCount++;
                $44c92df45ffff83e$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $44c92df45ffff83e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $8bwfW.from(stream);
    };
    if (streams.length === 1 && $44c92df45ffff83e$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $44c92df45ffff83e$var$ERR_MISSING_ARGS('streams');
    var ac = new $44c92df45ffff83e$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $44c92df45ffff83e$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $44c92df45ffff83e$var$AbortError());
    }
    $44c92df45ffff83e$var$addAbortListener = $44c92df45ffff83e$var$addAbortListener || (parcelRequire("fCNX2")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $44c92df45ffff83e$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$44c92df45ffff83e$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $44c92df45ffff83e$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $44c92df45ffff83e$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($44c92df45ffff83e$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $dXW2j(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $dXW2j(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $44c92df45ffff83e$var$pipelineImpl,
    pipeline: $44c92df45ffff83e$var$pipeline
};

});
parcelRegister("3aXq0", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $aALsV = parcelRequire("aALsV");
/* replacement end */ var $25006586530ea4ae$var$aggregateTwoErrors = $aALsV.aggregateTwoErrors, $25006586530ea4ae$var$ERR_MULTIPLE_CALLBACK = $aALsV.codes.ERR_MULTIPLE_CALLBACK, $25006586530ea4ae$var$AbortError = $aALsV.AbortError;

var $enBcu = parcelRequire("enBcu");
var $25006586530ea4ae$require$Symbol = $enBcu.Symbol;

var $C5MxV = parcelRequire("C5MxV");
var $25006586530ea4ae$var$kIsDestroyed = $C5MxV.kIsDestroyed, $25006586530ea4ae$var$isDestroyed = $C5MxV.isDestroyed, $25006586530ea4ae$var$isFinished = $C5MxV.isFinished, $25006586530ea4ae$var$isServerRequest = $C5MxV.isServerRequest;
var $25006586530ea4ae$var$kDestroy = $25006586530ea4ae$require$Symbol('kDestroy');
var $25006586530ea4ae$var$kConstruct = $25006586530ea4ae$require$Symbol('kConstruct');
function $25006586530ea4ae$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $25006586530ea4ae$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $25006586530ea4ae$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($25006586530ea4ae$var$kDestroy, function(er) {
        $25006586530ea4ae$var$_destroy(this, $25006586530ea4ae$var$aggregateTwoErrors(er, err), cb);
    });
    else $25006586530ea4ae$var$_destroy(this, err, cb);
    return this;
}
function $25006586530ea4ae$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $25006586530ea4ae$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($25006586530ea4ae$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($25006586530ea4ae$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $25006586530ea4ae$var$emitErrorCloseNT(self, err) {
    $25006586530ea4ae$var$emitErrorNT(self, err);
    $25006586530ea4ae$var$emitCloseNT(self);
}
function $25006586530ea4ae$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $25006586530ea4ae$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $25006586530ea4ae$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $25006586530ea4ae$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($25006586530ea4ae$var$emitErrorNT, stream, err);
        else $25006586530ea4ae$var$emitErrorNT(stream, err);
    }
}
function $25006586530ea4ae$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($25006586530ea4ae$var$kConstruct, cb);
    if (stream.listenerCount($25006586530ea4ae$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($25006586530ea4ae$var$constructNT, stream);
}
function $25006586530ea4ae$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $25006586530ea4ae$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $25006586530ea4ae$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($25006586530ea4ae$var$kDestroy, err);
        else if (err) $25006586530ea4ae$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($25006586530ea4ae$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $25006586530ea4ae$var$emitConstructNT(stream) {
    stream.emit($25006586530ea4ae$var$kConstruct);
}
function $25006586530ea4ae$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $25006586530ea4ae$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $25006586530ea4ae$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($25006586530ea4ae$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $25006586530ea4ae$var$destroyer(stream, err) {
    if (!stream || $25006586530ea4ae$var$isDestroyed(stream)) return;
    if (!err && !$25006586530ea4ae$var$isFinished(stream)) err = new $25006586530ea4ae$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($25006586530ea4ae$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($25006586530ea4ae$var$isRequest(stream)) stream.abort();
    else if ($25006586530ea4ae$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($25006586530ea4ae$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($25006586530ea4ae$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$25006586530ea4ae$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $25006586530ea4ae$var$construct,
    destroyer: $25006586530ea4ae$var$destroyer,
    destroy: $25006586530ea4ae$var$destroy,
    undestroy: $25006586530ea4ae$var$undestroy,
    errorOrDestroy: $25006586530ea4ae$var$errorOrDestroy
};

});

parcelRegister("8bwfW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $5f585f3626a7ae6f$var$ObjectDefineProperties = $enBcu.ObjectDefineProperties, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor = $enBcu.ObjectGetOwnPropertyDescriptor, $5f585f3626a7ae6f$var$ObjectKeys = $enBcu.ObjectKeys, $5f585f3626a7ae6f$var$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf;
module.exports = $5f585f3626a7ae6f$var$Duplex;

var $jXcuS = parcelRequire("jXcuS");

var $efk7c = parcelRequire("efk7c");
$5f585f3626a7ae6f$var$ObjectSetPrototypeOf($5f585f3626a7ae6f$var$Duplex.prototype, $jXcuS.prototype);
$5f585f3626a7ae6f$var$ObjectSetPrototypeOf($5f585f3626a7ae6f$var$Duplex, $jXcuS);
{
    var $5f585f3626a7ae6f$var$keys = $5f585f3626a7ae6f$var$ObjectKeys($efk7c.prototype);
    // Allow the keys array to be GC'ed.
    for(var $5f585f3626a7ae6f$var$i = 0; $5f585f3626a7ae6f$var$i < $5f585f3626a7ae6f$var$keys.length; $5f585f3626a7ae6f$var$i++){
        var $5f585f3626a7ae6f$var$method = $5f585f3626a7ae6f$var$keys[$5f585f3626a7ae6f$var$i];
        if (!$5f585f3626a7ae6f$var$Duplex.prototype[$5f585f3626a7ae6f$var$method]) $5f585f3626a7ae6f$var$Duplex.prototype[$5f585f3626a7ae6f$var$method] = $efk7c.prototype[$5f585f3626a7ae6f$var$method];
    }
}function $5f585f3626a7ae6f$var$Duplex(options) {
    if (!(this instanceof $5f585f3626a7ae6f$var$Duplex)) return new $5f585f3626a7ae6f$var$Duplex(options);
    $jXcuS.call(this, options);
    $efk7c.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$5f585f3626a7ae6f$var$ObjectDefineProperties($5f585f3626a7ae6f$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $5f585f3626a7ae6f$var$ObjectGetOwnPropertyDescriptor($efk7c.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $5f585f3626a7ae6f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $5f585f3626a7ae6f$var$lazyWebStreams() {
    if ($5f585f3626a7ae6f$var$webStreamsAdapters === undefined) $5f585f3626a7ae6f$var$webStreamsAdapters = {};
    return $5f585f3626a7ae6f$var$webStreamsAdapters;
}
$5f585f3626a7ae6f$var$Duplex.fromWeb = function(pair, options) {
    return $5f585f3626a7ae6f$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$5f585f3626a7ae6f$var$Duplex.toWeb = function(duplex) {
    return $5f585f3626a7ae6f$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $5f585f3626a7ae6f$var$duplexify;

$5f585f3626a7ae6f$var$Duplex.from = function(body) {
    if (!$5f585f3626a7ae6f$var$duplexify) $5f585f3626a7ae6f$var$duplexify = (parcelRequire("jKRDT"));
    return $5f585f3626a7ae6f$var$duplexify(body, 'body');
};

});
parcelRegister("jXcuS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $enBcu = parcelRequire("enBcu");
/* replacement end */ var $e86d38ae31ad9502$var$ArrayPrototypeIndexOf = $enBcu.ArrayPrototypeIndexOf, $e86d38ae31ad9502$var$NumberIsInteger = $enBcu.NumberIsInteger, $e86d38ae31ad9502$var$NumberIsNaN = $enBcu.NumberIsNaN, $e86d38ae31ad9502$var$NumberParseInt = $enBcu.NumberParseInt, $e86d38ae31ad9502$var$ObjectDefineProperties = $enBcu.ObjectDefineProperties, $e86d38ae31ad9502$var$ObjectKeys = $enBcu.ObjectKeys, $e86d38ae31ad9502$var$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf, $e86d38ae31ad9502$var$Promise = $enBcu.Promise, $e86d38ae31ad9502$var$SafeSet = $enBcu.SafeSet, $e86d38ae31ad9502$var$SymbolAsyncDispose = $enBcu.SymbolAsyncDispose, $e86d38ae31ad9502$var$SymbolAsyncIterator = $enBcu.SymbolAsyncIterator, $e86d38ae31ad9502$var$Symbol = $enBcu.Symbol;
module.exports = $e86d38ae31ad9502$var$Readable;
$e86d38ae31ad9502$var$Readable.ReadableState = $e86d38ae31ad9502$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $e86d38ae31ad9502$var$EE = $bBoAO.EventEmitter;

var $ewFWJ = parcelRequire("ewFWJ");
var $e86d38ae31ad9502$var$Stream = $ewFWJ.Stream, $e86d38ae31ad9502$var$prependListener = $ewFWJ.prependListener;

var $eVkja = parcelRequire("eVkja");
var $e86d38ae31ad9502$require$Buffer = $eVkja.Buffer;

var $e2Flm = parcelRequire("e2Flm");
var $e86d38ae31ad9502$require$addAbortSignal = $e2Flm.addAbortSignal;

var $dXW2j = parcelRequire("dXW2j");

var $e86d38ae31ad9502$var$debug = (parcelRequire("fCNX2")).debuglog('stream', function(fn) {
    $e86d38ae31ad9502$var$debug = fn;
});

var $15GbM = parcelRequire("15GbM");

var $3aXq0 = parcelRequire("3aXq0");

var $kZ9n7 = parcelRequire("kZ9n7");
var $e86d38ae31ad9502$var$getHighWaterMark = $kZ9n7.getHighWaterMark, $e86d38ae31ad9502$var$getDefaultHighWaterMark = $kZ9n7.getDefaultHighWaterMark;

var $aALsV = parcelRequire("aALsV");
var $e86d38ae31ad9502$var$aggregateTwoErrors = $aALsV.aggregateTwoErrors, $e86d38ae31ad9502$var$_require_codes = $aALsV.codes, $e86d38ae31ad9502$var$ERR_INVALID_ARG_TYPE = $e86d38ae31ad9502$var$_require_codes.ERR_INVALID_ARG_TYPE, $e86d38ae31ad9502$var$ERR_METHOD_NOT_IMPLEMENTED = $e86d38ae31ad9502$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $e86d38ae31ad9502$var$ERR_OUT_OF_RANGE = $e86d38ae31ad9502$var$_require_codes.ERR_OUT_OF_RANGE, $e86d38ae31ad9502$var$ERR_STREAM_PUSH_AFTER_EOF = $e86d38ae31ad9502$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $e86d38ae31ad9502$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $e86d38ae31ad9502$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $e86d38ae31ad9502$var$AbortError = $aALsV.AbortError;

var $jr5DF = parcelRequire("jr5DF");
var $e86d38ae31ad9502$require$validateObject = $jr5DF.validateObject;
var $e86d38ae31ad9502$var$kPaused = $e86d38ae31ad9502$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $e86d38ae31ad9502$require$StringDecoder = $3Jf7C.StringDecoder;

var $2H6yd = parcelRequire("2H6yd");
$e86d38ae31ad9502$var$ObjectSetPrototypeOf($e86d38ae31ad9502$var$Readable.prototype, $e86d38ae31ad9502$var$Stream.prototype);
$e86d38ae31ad9502$var$ObjectSetPrototypeOf($e86d38ae31ad9502$var$Readable, $e86d38ae31ad9502$var$Stream);
var $e86d38ae31ad9502$var$nop = function() {};
var $e86d38ae31ad9502$var$errorOrDestroy = $3aXq0.errorOrDestroy;
var $e86d38ae31ad9502$var$kObjectMode = 1;
var $e86d38ae31ad9502$var$kEnded = 2;
var $e86d38ae31ad9502$var$kEndEmitted = 4;
var $e86d38ae31ad9502$var$kReading = 8;
var $e86d38ae31ad9502$var$kConstructed = 16;
var $e86d38ae31ad9502$var$kSync = 32;
var $e86d38ae31ad9502$var$kNeedReadable = 64;
var $e86d38ae31ad9502$var$kEmittedReadable = 128;
var $e86d38ae31ad9502$var$kReadableListening = 256;
var $e86d38ae31ad9502$var$kResumeScheduled = 512;
var $e86d38ae31ad9502$var$kErrorEmitted = 1024;
var $e86d38ae31ad9502$var$kEmitClose = 2048;
var $e86d38ae31ad9502$var$kAutoDestroy = 4096;
var $e86d38ae31ad9502$var$kDestroyed = 8192;
var $e86d38ae31ad9502$var$kClosed = 16384;
var $e86d38ae31ad9502$var$kCloseEmitted = 32768;
var $e86d38ae31ad9502$var$kMultiAwaitDrain = 65536;
var $e86d38ae31ad9502$var$kReadingMore = 131072;
var $e86d38ae31ad9502$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $e86d38ae31ad9502$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$e86d38ae31ad9502$var$ObjectDefineProperties($e86d38ae31ad9502$var$ReadableState.prototype, {
    objectMode: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kObjectMode),
    ended: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kEnded),
    endEmitted: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kEndEmitted),
    reading: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kNeedReadable),
    emittedReadable: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kEmittedReadable),
    readableListening: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kReadableListening),
    resumeScheduled: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kErrorEmitted),
    emitClose: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kEmitClose),
    autoDestroy: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kCloseEmitted),
    multiAwaitDrain: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kReadingMore),
    dataEmitted: $e86d38ae31ad9502$var$makeBitMapDescriptor($e86d38ae31ad9502$var$kDataEmitted)
});

function $e86d38ae31ad9502$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("8bwfW"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $e86d38ae31ad9502$var$kEmitClose | $e86d38ae31ad9502$var$kAutoDestroy | $e86d38ae31ad9502$var$kConstructed | $e86d38ae31ad9502$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $e86d38ae31ad9502$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $e86d38ae31ad9502$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $e86d38ae31ad9502$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $e86d38ae31ad9502$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $15GbM();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$e86d38ae31ad9502$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$e86d38ae31ad9502$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$e86d38ae31ad9502$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $e86d38ae31ad9502$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $e86d38ae31ad9502$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $e86d38ae31ad9502$var$Readable)) return new $e86d38ae31ad9502$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("8bwfW"));
    this._readableState = new $e86d38ae31ad9502$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $e86d38ae31ad9502$require$addAbortSignal(options.signal, this);
    }
    $e86d38ae31ad9502$var$Stream.call(this, options);
    $3aXq0.construct(this, function() {
        if (_this._readableState.needReadable) $e86d38ae31ad9502$var$maybeReadMore(_this, _this._readableState);
    });
}
$e86d38ae31ad9502$var$Readable.prototype.destroy = $3aXq0.destroy;
$e86d38ae31ad9502$var$Readable.prototype._undestroy = $3aXq0.undestroy;
$e86d38ae31ad9502$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$e86d38ae31ad9502$var$Readable.prototype[$e86d38ae31ad9502$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$e86d38ae31ad9502$var$Readable.prototype[$e86d38ae31ad9502$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $e86d38ae31ad9502$var$AbortError();
        this.destroy(error);
    }
    return new $e86d38ae31ad9502$var$Promise(function(resolve, reject) {
        return $dXW2j(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$e86d38ae31ad9502$var$Readable.prototype.push = function(chunk, encoding) {
    return $e86d38ae31ad9502$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$e86d38ae31ad9502$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $e86d38ae31ad9502$var$readableAddChunk(this, chunk, encoding, true);
};
function $e86d38ae31ad9502$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $e86d38ae31ad9502$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $e86d38ae31ad9502$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $e86d38ae31ad9502$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $e86d38ae31ad9502$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $e86d38ae31ad9502$require$Buffer) encoding = '';
        else if ($e86d38ae31ad9502$var$Stream._isUint8Array(chunk)) {
            chunk = $e86d38ae31ad9502$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $e86d38ae31ad9502$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $e86d38ae31ad9502$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$e86d38ae31ad9502$var$kReading;
        $e86d38ae31ad9502$var$onEofChunk(stream, state);
    } else if ((state.state & $e86d38ae31ad9502$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $e86d38ae31ad9502$var$kEndEmitted) !== 0) $e86d38ae31ad9502$var$errorOrDestroy(stream, new $e86d38ae31ad9502$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $e86d38ae31ad9502$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $e86d38ae31ad9502$var$errorOrDestroy(stream, new $e86d38ae31ad9502$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$e86d38ae31ad9502$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $e86d38ae31ad9502$var$addChunk(stream, state, chunk, false);
                else $e86d38ae31ad9502$var$maybeReadMore(stream, state);
            } else $e86d38ae31ad9502$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$e86d38ae31ad9502$var$kReading;
        $e86d38ae31ad9502$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $e86d38ae31ad9502$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $e86d38ae31ad9502$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $e86d38ae31ad9502$var$kNeedReadable) !== 0) $e86d38ae31ad9502$var$emitReadable(stream);
    }
    $e86d38ae31ad9502$var$maybeReadMore(stream, state);
}
$e86d38ae31ad9502$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$e86d38ae31ad9502$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$e86d38ae31ad9502$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $e86d38ae31ad9502$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$e86d38ae31ad9502$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $e86d38ae31ad9502$var$MAX_HWM = 0x40000000;
function $e86d38ae31ad9502$var$computeNewHighWaterMark(n) {
    if (n > $e86d38ae31ad9502$var$MAX_HWM) throw new $e86d38ae31ad9502$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e86d38ae31ad9502$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $e86d38ae31ad9502$var$kObjectMode) !== 0) return 1;
    if ($e86d38ae31ad9502$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$e86d38ae31ad9502$var$Readable.prototype.read = function(n) {
    $e86d38ae31ad9502$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$e86d38ae31ad9502$var$NumberIsInteger(n)) n = $e86d38ae31ad9502$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $e86d38ae31ad9502$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$e86d38ae31ad9502$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $e86d38ae31ad9502$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $e86d38ae31ad9502$var$endReadable(this);
        else $e86d38ae31ad9502$var$emitReadable(this);
        return null;
    }
    n = $e86d38ae31ad9502$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $e86d38ae31ad9502$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $e86d38ae31ad9502$var$kNeedReadable) !== 0;
    $e86d38ae31ad9502$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $e86d38ae31ad9502$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $e86d38ae31ad9502$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $e86d38ae31ad9502$var$debug('do read');
        state.state |= $e86d38ae31ad9502$var$kReading | $e86d38ae31ad9502$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $e86d38ae31ad9502$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $e86d38ae31ad9502$var$errorOrDestroy(this, err);
        }
        state.state &= ~$e86d38ae31ad9502$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $e86d38ae31ad9502$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $e86d38ae31ad9502$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $e86d38ae31ad9502$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $e86d38ae31ad9502$var$onEofChunk(stream, state) {
    $e86d38ae31ad9502$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $e86d38ae31ad9502$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $e86d38ae31ad9502$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $e86d38ae31ad9502$var$emitReadable(stream) {
    var state = stream._readableState;
    $e86d38ae31ad9502$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $e86d38ae31ad9502$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($e86d38ae31ad9502$var$emitReadable_, stream);
    }
}
function $e86d38ae31ad9502$var$emitReadable_(stream) {
    var state = stream._readableState;
    $e86d38ae31ad9502$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $e86d38ae31ad9502$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $e86d38ae31ad9502$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($e86d38ae31ad9502$var$maybeReadMore_, stream, state);
    }
}
function $e86d38ae31ad9502$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $e86d38ae31ad9502$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$e86d38ae31ad9502$var$Readable.prototype._read = function(n) {
    throw new $e86d38ae31ad9502$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$e86d38ae31ad9502$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $e86d38ae31ad9502$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $e86d38ae31ad9502$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $e86d38ae31ad9502$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $e86d38ae31ad9502$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $e86d38ae31ad9502$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $e86d38ae31ad9502$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $e86d38ae31ad9502$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $e86d38ae31ad9502$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $e86d38ae31ad9502$var$debug('ondata');
        var ret = dest.write(chunk);
        $e86d38ae31ad9502$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $e86d38ae31ad9502$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $e86d38ae31ad9502$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $e86d38ae31ad9502$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $e86d38ae31ad9502$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $e86d38ae31ad9502$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $e86d38ae31ad9502$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $e86d38ae31ad9502$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $e86d38ae31ad9502$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $e86d38ae31ad9502$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$e86d38ae31ad9502$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $e86d38ae31ad9502$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$e86d38ae31ad9502$var$Readable.prototype.on = function(ev, fn) {
    var res = $e86d38ae31ad9502$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $e86d38ae31ad9502$var$debug('on readable', state.length, state.reading);
            if (state.length) $e86d38ae31ad9502$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($e86d38ae31ad9502$var$nReadingNextTick, this);
        }
    }
    return res;
};
$e86d38ae31ad9502$var$Readable.prototype.addListener = $e86d38ae31ad9502$var$Readable.prototype.on;
$e86d38ae31ad9502$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $e86d38ae31ad9502$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($e86d38ae31ad9502$var$updateReadableListening, this);
    return res;
};
$e86d38ae31ad9502$var$Readable.prototype.off = $e86d38ae31ad9502$var$Readable.prototype.removeListener;
$e86d38ae31ad9502$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $e86d38ae31ad9502$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($e86d38ae31ad9502$var$updateReadableListening, this);
    return res;
};
function $e86d38ae31ad9502$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$e86d38ae31ad9502$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $e86d38ae31ad9502$var$nReadingNextTick(self) {
    $e86d38ae31ad9502$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$e86d38ae31ad9502$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $e86d38ae31ad9502$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $e86d38ae31ad9502$var$resume(this, state);
    }
    state[$e86d38ae31ad9502$var$kPaused] = false;
    return this;
};
function $e86d38ae31ad9502$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($e86d38ae31ad9502$var$resume_, stream, state);
    }
}
function $e86d38ae31ad9502$var$resume_(stream, state) {
    $e86d38ae31ad9502$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $e86d38ae31ad9502$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$e86d38ae31ad9502$var$Readable.prototype.pause = function() {
    $e86d38ae31ad9502$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $e86d38ae31ad9502$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$e86d38ae31ad9502$var$kPaused] = true;
    return this;
};
function $e86d38ae31ad9502$var$flow(stream) {
    var state = stream._readableState;
    $e86d38ae31ad9502$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$e86d38ae31ad9502$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $e86d38ae31ad9502$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $e86d38ae31ad9502$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$e86d38ae31ad9502$var$Readable.prototype[$e86d38ae31ad9502$var$SymbolAsyncIterator] = function() {
    return $e86d38ae31ad9502$var$streamToAsyncIterator(this);
};
$e86d38ae31ad9502$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $e86d38ae31ad9502$require$validateObject(options, 'options');
    return $e86d38ae31ad9502$var$streamToAsyncIterator(this, options);
};
function $e86d38ae31ad9502$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $e86d38ae31ad9502$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $e86d38ae31ad9502$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $e86d38ae31ad9502$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $e86d38ae31ad9502$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $e86d38ae31ad9502$var$nop;
                    stream.on('readable', next);
                    cleanup = $dXW2j(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $e86d38ae31ad9502$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $e86d38ae31ad9502$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $e86d38ae31ad9502$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $e86d38ae31ad9502$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $3aXq0.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$e86d38ae31ad9502$var$ObjectDefineProperties($e86d38ae31ad9502$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$e86d38ae31ad9502$var$ObjectDefineProperties($e86d38ae31ad9502$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$e86d38ae31ad9502$var$kPaused] !== false;
        },
        set: function(value) {
            this[$e86d38ae31ad9502$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$e86d38ae31ad9502$var$Readable._fromList = $e86d38ae31ad9502$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e86d38ae31ad9502$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $e86d38ae31ad9502$var$endReadable(stream) {
    var state = stream._readableState;
    $e86d38ae31ad9502$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($e86d38ae31ad9502$var$endReadableNT, state, stream);
    }
}
function $e86d38ae31ad9502$var$endReadableNT(state, stream) {
    $e86d38ae31ad9502$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($e86d38ae31ad9502$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $e86d38ae31ad9502$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$e86d38ae31ad9502$var$Readable.from = function(iterable, opts) {
    return $2H6yd($e86d38ae31ad9502$var$Readable, iterable, opts);
};
var $e86d38ae31ad9502$var$webStreamsAdapters;
// Lazy to avoid circular references
function $e86d38ae31ad9502$var$lazyWebStreams() {
    if ($e86d38ae31ad9502$var$webStreamsAdapters === undefined) $e86d38ae31ad9502$var$webStreamsAdapters = {};
    return $e86d38ae31ad9502$var$webStreamsAdapters;
}
$e86d38ae31ad9502$var$Readable.fromWeb = function(readableStream, options) {
    return $e86d38ae31ad9502$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$e86d38ae31ad9502$var$Readable.toWeb = function(streamReadable, options) {
    return $e86d38ae31ad9502$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$e86d38ae31ad9502$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $e86d38ae31ad9502$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $3aXq0.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("ewFWJ", function(module, exports) {
'use strict';

var $enBcu = parcelRequire("enBcu");
var $a934977b4e0add9d$var$ArrayIsArray = $enBcu.ArrayIsArray, $a934977b4e0add9d$var$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $a934977b4e0add9d$var$EE = $bBoAO.EventEmitter;
function $a934977b4e0add9d$var$Stream(opts) {
    $a934977b4e0add9d$var$EE.call(this, opts);
}
$a934977b4e0add9d$var$ObjectSetPrototypeOf($a934977b4e0add9d$var$Stream.prototype, $a934977b4e0add9d$var$EE.prototype);
$a934977b4e0add9d$var$ObjectSetPrototypeOf($a934977b4e0add9d$var$Stream, $a934977b4e0add9d$var$EE);
$a934977b4e0add9d$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a934977b4e0add9d$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $a934977b4e0add9d$var$prependListener(source, 'error', onerror);
    $a934977b4e0add9d$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $a934977b4e0add9d$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($a934977b4e0add9d$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $a934977b4e0add9d$var$Stream,
    prependListener: $a934977b4e0add9d$var$prependListener
};

});

parcelRegister("e2Flm", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $a39152939942a930$export$e2db56ee53255a0; }, function (v) { return $a39152939942a930$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $a39152939942a930$export$11956e9313f43de0; }, function (v) { return $a39152939942a930$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $a39152939942a930$export$e2db56ee53255a0;
var $a39152939942a930$export$11956e9313f43de0;
'use strict';

var $enBcu = parcelRequire("enBcu");
var $a39152939942a930$require$SymbolDispose = $enBcu.SymbolDispose;

var $aALsV = parcelRequire("aALsV");
var $a39152939942a930$var$AbortError = $aALsV.AbortError, $a39152939942a930$var$codes = $aALsV.codes;

var $C5MxV = parcelRequire("C5MxV");
var $a39152939942a930$var$isNodeStream = $C5MxV.isNodeStream, $a39152939942a930$var$isWebStream = $C5MxV.isWebStream, $a39152939942a930$var$kControllerErrorFunction = $C5MxV.kControllerErrorFunction;

var $dXW2j = parcelRequire("dXW2j");
var $a39152939942a930$var$ERR_INVALID_ARG_TYPE = $a39152939942a930$var$codes.ERR_INVALID_ARG_TYPE;
var $a39152939942a930$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $a39152939942a930$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $a39152939942a930$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$a39152939942a930$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $a39152939942a930$var$validateAbortSignal(signal, 'signal');
    if (!$a39152939942a930$var$isNodeStream(stream) && !$a39152939942a930$var$isWebStream(stream)) throw new $a39152939942a930$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $a39152939942a930$export$11956e9313f43de0(signal, stream);
};

$a39152939942a930$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $a39152939942a930$var$isNodeStream(stream) ? function() {
        stream.destroy(new $a39152939942a930$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$a39152939942a930$var$kControllerErrorFunction](new $a39152939942a930$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $a39152939942a930$var$addAbortListener = $a39152939942a930$var$addAbortListener || (parcelRequire("fCNX2")).addAbortListener;
        var disposable = $a39152939942a930$var$addAbortListener(signal, onAbort);
        $dXW2j(stream, disposable[$a39152939942a930$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("15GbM", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $0cb6fbeb7756fff2$var$StringPrototypeSlice = $enBcu.StringPrototypeSlice, $0cb6fbeb7756fff2$var$SymbolIterator = $enBcu.SymbolIterator, $0cb6fbeb7756fff2$var$TypedArrayPrototypeSet = $enBcu.TypedArrayPrototypeSet, $0cb6fbeb7756fff2$var$Uint8Array = $enBcu.Uint8Array;

var $eVkja = parcelRequire("eVkja");
var $0cb6fbeb7756fff2$require$Buffer = $eVkja.Buffer;

var $fCNX2 = parcelRequire("fCNX2");
var $0cb6fbeb7756fff2$require$inspect = $fCNX2.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $0cb6fbeb7756fff2$require$Buffer.alloc(0);
                var ret = $0cb6fbeb7756fff2$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $0cb6fbeb7756fff2$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $0cb6fbeb7756fff2$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $0cb6fbeb7756fff2$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $0cb6fbeb7756fff2$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $0cb6fbeb7756fff2$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $0cb6fbeb7756fff2$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $0cb6fbeb7756fff2$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $0cb6fbeb7756fff2$var$TypedArrayPrototypeSet(ret, new $0cb6fbeb7756fff2$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $0cb6fbeb7756fff2$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("kZ9n7", function(module, exports) {
'use strict';

var $enBcu = parcelRequire("enBcu");
var $f470c63539abac49$var$MathFloor = $enBcu.MathFloor, $f470c63539abac49$var$NumberIsInteger = $enBcu.NumberIsInteger;

var $jr5DF = parcelRequire("jr5DF");
var $f470c63539abac49$require$validateInteger = $jr5DF.validateInteger;

var $f470c63539abac49$var$ERR_INVALID_ARG_VALUE = (parcelRequire("aALsV")).codes.ERR_INVALID_ARG_VALUE;
var $f470c63539abac49$var$defaultHighWaterMarkBytes = 16384;
var $f470c63539abac49$var$defaultHighWaterMarkObjectMode = 16;
function $f470c63539abac49$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f470c63539abac49$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f470c63539abac49$var$defaultHighWaterMarkObjectMode : $f470c63539abac49$var$defaultHighWaterMarkBytes;
}
function $f470c63539abac49$var$setDefaultHighWaterMark(objectMode, value) {
    $f470c63539abac49$require$validateInteger(value, 'value', 0);
    if (objectMode) $f470c63539abac49$var$defaultHighWaterMarkObjectMode = value;
    else $f470c63539abac49$var$defaultHighWaterMarkBytes = value;
}
function $f470c63539abac49$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $f470c63539abac49$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f470c63539abac49$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $f470c63539abac49$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f470c63539abac49$var$MathFloor(hwm);
    }
    // Default value
    return $f470c63539abac49$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f470c63539abac49$var$getHighWaterMark,
    getDefaultHighWaterMark: $f470c63539abac49$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f470c63539abac49$var$setDefaultHighWaterMark
};

});

parcelRegister("2H6yd", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $enBcu = parcelRequire("enBcu");
/* replacement end */ var $1f64adcb871c9750$var$PromisePrototypeThen = $enBcu.PromisePrototypeThen, $1f64adcb871c9750$var$SymbolAsyncIterator = $enBcu.SymbolAsyncIterator, $1f64adcb871c9750$var$SymbolIterator = $enBcu.SymbolIterator;

var $eVkja = parcelRequire("eVkja");
var $1f64adcb871c9750$require$Buffer = $eVkja.Buffer;

var $aALsV = parcelRequire("aALsV");
var $1f64adcb871c9750$require$_require_codes = $aALsV.codes;
var $1f64adcb871c9750$var$ERR_INVALID_ARG_TYPE = $1f64adcb871c9750$require$_require_codes.ERR_INVALID_ARG_TYPE, $1f64adcb871c9750$var$ERR_STREAM_NULL_VALUES = $1f64adcb871c9750$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $1f64adcb871c9750$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $1f64adcb871c9750$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$1f64adcb871c9750$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$1f64adcb871c9750$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$1f64adcb871c9750$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$1f64adcb871c9750$var$SymbolIterator]();
    } else throw new $1f64adcb871c9750$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $1f64adcb871c9750$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $1f64adcb871c9750$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $1f64adcb871c9750$var$from;

});


parcelRegister("efk7c", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $enBcu = parcelRequire("enBcu");
/* replacement end */ var $a5f211d5b3257dca$var$ArrayPrototypeSlice = $enBcu.ArrayPrototypeSlice, $a5f211d5b3257dca$var$Error = $enBcu.Error, $a5f211d5b3257dca$var$FunctionPrototypeSymbolHasInstance = $enBcu.FunctionPrototypeSymbolHasInstance, $a5f211d5b3257dca$var$ObjectDefineProperty = $enBcu.ObjectDefineProperty, $a5f211d5b3257dca$var$ObjectDefineProperties = $enBcu.ObjectDefineProperties, $a5f211d5b3257dca$var$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf, $a5f211d5b3257dca$var$StringPrototypeToLowerCase = $enBcu.StringPrototypeToLowerCase, $a5f211d5b3257dca$var$Symbol = $enBcu.Symbol, $a5f211d5b3257dca$var$SymbolHasInstance = $enBcu.SymbolHasInstance;
module.exports = $a5f211d5b3257dca$var$Writable;
$a5f211d5b3257dca$var$Writable.WritableState = $a5f211d5b3257dca$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a5f211d5b3257dca$var$EE = $bBoAO.EventEmitter;

var $ewFWJ = parcelRequire("ewFWJ");
var $a5f211d5b3257dca$require$Stream = $ewFWJ.Stream;

var $eVkja = parcelRequire("eVkja");
var $a5f211d5b3257dca$require$Buffer = $eVkja.Buffer;

var $3aXq0 = parcelRequire("3aXq0");

var $e2Flm = parcelRequire("e2Flm");
var $a5f211d5b3257dca$require$addAbortSignal = $e2Flm.addAbortSignal;

var $kZ9n7 = parcelRequire("kZ9n7");
var $a5f211d5b3257dca$var$getHighWaterMark = $kZ9n7.getHighWaterMark, $a5f211d5b3257dca$var$getDefaultHighWaterMark = $kZ9n7.getDefaultHighWaterMark;

var $aALsV = parcelRequire("aALsV");
var $a5f211d5b3257dca$require$_require_codes = $aALsV.codes;
var $a5f211d5b3257dca$var$ERR_INVALID_ARG_TYPE = $a5f211d5b3257dca$require$_require_codes.ERR_INVALID_ARG_TYPE, $a5f211d5b3257dca$var$ERR_METHOD_NOT_IMPLEMENTED = $a5f211d5b3257dca$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a5f211d5b3257dca$var$ERR_MULTIPLE_CALLBACK = $a5f211d5b3257dca$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a5f211d5b3257dca$var$ERR_STREAM_CANNOT_PIPE = $a5f211d5b3257dca$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED = $a5f211d5b3257dca$require$_require_codes.ERR_STREAM_DESTROYED, $a5f211d5b3257dca$var$ERR_STREAM_ALREADY_FINISHED = $a5f211d5b3257dca$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a5f211d5b3257dca$var$ERR_STREAM_NULL_VALUES = $a5f211d5b3257dca$require$_require_codes.ERR_STREAM_NULL_VALUES, $a5f211d5b3257dca$var$ERR_STREAM_WRITE_AFTER_END = $a5f211d5b3257dca$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a5f211d5b3257dca$var$ERR_UNKNOWN_ENCODING = $a5f211d5b3257dca$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a5f211d5b3257dca$var$errorOrDestroy = $3aXq0.errorOrDestroy;
$a5f211d5b3257dca$var$ObjectSetPrototypeOf($a5f211d5b3257dca$var$Writable.prototype, $a5f211d5b3257dca$require$Stream.prototype);
$a5f211d5b3257dca$var$ObjectSetPrototypeOf($a5f211d5b3257dca$var$Writable, $a5f211d5b3257dca$require$Stream);
function $a5f211d5b3257dca$var$nop() {}
var $a5f211d5b3257dca$var$kOnFinished = $a5f211d5b3257dca$var$Symbol('kOnFinished');

function $a5f211d5b3257dca$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("8bwfW"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a5f211d5b3257dca$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a5f211d5b3257dca$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a5f211d5b3257dca$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a5f211d5b3257dca$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a5f211d5b3257dca$var$kOnFinished] = [];
}
function $a5f211d5b3257dca$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a5f211d5b3257dca$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a5f211d5b3257dca$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a5f211d5b3257dca$var$ObjectDefineProperty($a5f211d5b3257dca$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a5f211d5b3257dca$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("8bwfW"));
    if (!isDuplex && !$a5f211d5b3257dca$var$FunctionPrototypeSymbolHasInstance($a5f211d5b3257dca$var$Writable, this)) return new $a5f211d5b3257dca$var$Writable(options);
    this._writableState = new $a5f211d5b3257dca$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a5f211d5b3257dca$require$addAbortSignal(options.signal, this);
    }
    $a5f211d5b3257dca$require$Stream.call(this, options);
    $3aXq0.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a5f211d5b3257dca$var$clearBuffer(_this, state);
        $a5f211d5b3257dca$var$finishMaybe(_this, state);
    });
}
$a5f211d5b3257dca$var$ObjectDefineProperty($a5f211d5b3257dca$var$Writable, $a5f211d5b3257dca$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a5f211d5b3257dca$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a5f211d5b3257dca$var$Writable) return false;
        return object && object._writableState instanceof $a5f211d5b3257dca$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a5f211d5b3257dca$var$Writable.prototype.pipe = function() {
    $a5f211d5b3257dca$var$errorOrDestroy(this, new $a5f211d5b3257dca$var$ERR_STREAM_CANNOT_PIPE());
};
function $a5f211d5b3257dca$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a5f211d5b3257dca$require$Buffer.isEncoding(encoding)) throw new $a5f211d5b3257dca$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a5f211d5b3257dca$var$nop;
    }
    if (chunk === null) throw new $a5f211d5b3257dca$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a5f211d5b3257dca$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a5f211d5b3257dca$require$Buffer) encoding = 'buffer';
        else if ($a5f211d5b3257dca$require$Stream._isUint8Array(chunk)) {
            chunk = $a5f211d5b3257dca$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a5f211d5b3257dca$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a5f211d5b3257dca$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a5f211d5b3257dca$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a5f211d5b3257dca$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a5f211d5b3257dca$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a5f211d5b3257dca$var$_write(this, chunk, encoding, cb) === true;
};
$a5f211d5b3257dca$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a5f211d5b3257dca$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a5f211d5b3257dca$var$clearBuffer(this, state);
    }
};
$a5f211d5b3257dca$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a5f211d5b3257dca$var$StringPrototypeToLowerCase(encoding);
    if (!$a5f211d5b3257dca$require$Buffer.isEncoding(encoding)) throw new $a5f211d5b3257dca$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a5f211d5b3257dca$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a5f211d5b3257dca$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a5f211d5b3257dca$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a5f211d5b3257dca$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a5f211d5b3257dca$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a5f211d5b3257dca$var$errorOrDestroy(stream, er);
}
function $a5f211d5b3257dca$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a5f211d5b3257dca$var$errorOrDestroy(stream, new $a5f211d5b3257dca$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a5f211d5b3257dca$var$onwriteError, stream, state, er, cb);
        else $a5f211d5b3257dca$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a5f211d5b3257dca$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a5f211d5b3257dca$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a5f211d5b3257dca$var$afterWrite(stream, state, 1, cb);
    }
}
function $a5f211d5b3257dca$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a5f211d5b3257dca$var$afterWrite(stream, state, count, cb);
}
function $a5f211d5b3257dca$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a5f211d5b3257dca$var$errorBuffer(state);
    $a5f211d5b3257dca$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a5f211d5b3257dca$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a5f211d5b3257dca$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED('end'));
    }
    $a5f211d5b3257dca$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a5f211d5b3257dca$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a5f211d5b3257dca$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a5f211d5b3257dca$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a5f211d5b3257dca$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a5f211d5b3257dca$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a5f211d5b3257dca$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a5f211d5b3257dca$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a5f211d5b3257dca$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a5f211d5b3257dca$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a5f211d5b3257dca$var$Writable.prototype._writev = null;
$a5f211d5b3257dca$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a5f211d5b3257dca$var$_write(this, chunk, encoding);
        if (ret instanceof $a5f211d5b3257dca$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a5f211d5b3257dca$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a5f211d5b3257dca$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a5f211d5b3257dca$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a5f211d5b3257dca$var$kOnFinished].push(cb);
    }
    return this;
};
function $a5f211d5b3257dca$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a5f211d5b3257dca$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a5f211d5b3257dca$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a5f211d5b3257dca$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a5f211d5b3257dca$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a5f211d5b3257dca$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a5f211d5b3257dca$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a5f211d5b3257dca$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a5f211d5b3257dca$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a5f211d5b3257dca$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a5f211d5b3257dca$var$finishMaybe(stream, state, sync) {
    if ($a5f211d5b3257dca$var$needFinish(state)) {
        $a5f211d5b3257dca$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a5f211d5b3257dca$var$needFinish(state)) $a5f211d5b3257dca$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a5f211d5b3257dca$var$needFinish(state)) {
                state.pendingcb++;
                $a5f211d5b3257dca$var$finish(stream, state);
            }
        }
    }
}
function $a5f211d5b3257dca$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a5f211d5b3257dca$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a5f211d5b3257dca$var$ObjectDefineProperties($a5f211d5b3257dca$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a5f211d5b3257dca$var$destroy = $3aXq0.destroy;
$a5f211d5b3257dca$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a5f211d5b3257dca$var$kOnFinished].length)) $2Qkr5.nextTick($a5f211d5b3257dca$var$errorBuffer, state);
    $a5f211d5b3257dca$var$destroy.call(this, err, cb);
    return this;
};
$a5f211d5b3257dca$var$Writable.prototype._undestroy = $3aXq0.undestroy;
$a5f211d5b3257dca$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a5f211d5b3257dca$var$Writable.prototype[$a5f211d5b3257dca$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a5f211d5b3257dca$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a5f211d5b3257dca$var$lazyWebStreams() {
    if ($a5f211d5b3257dca$var$webStreamsAdapters === undefined) $a5f211d5b3257dca$var$webStreamsAdapters = {};
    return $a5f211d5b3257dca$var$webStreamsAdapters;
}
$a5f211d5b3257dca$var$Writable.fromWeb = function(writableStream, options) {
    return $a5f211d5b3257dca$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a5f211d5b3257dca$var$Writable.toWeb = function(streamWritable) {
    return $a5f211d5b3257dca$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("jKRDT", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $eVkja = parcelRequire("eVkja");

var $C5MxV = parcelRequire("C5MxV");
var $e61bec7a38836aa1$var$isReadable = $C5MxV.isReadable, $e61bec7a38836aa1$var$isWritable = $C5MxV.isWritable, $e61bec7a38836aa1$var$isIterable = $C5MxV.isIterable, $e61bec7a38836aa1$var$isNodeStream = $C5MxV.isNodeStream, $e61bec7a38836aa1$var$isReadableNodeStream = $C5MxV.isReadableNodeStream, $e61bec7a38836aa1$var$isWritableNodeStream = $C5MxV.isWritableNodeStream, $e61bec7a38836aa1$var$isDuplexNodeStream = $C5MxV.isDuplexNodeStream, $e61bec7a38836aa1$var$isReadableStream = $C5MxV.isReadableStream, $e61bec7a38836aa1$var$isWritableStream = $C5MxV.isWritableStream;

var $dXW2j = parcelRequire("dXW2j");

var $aALsV = parcelRequire("aALsV");
var $e61bec7a38836aa1$var$AbortError = $aALsV.AbortError, $e61bec7a38836aa1$var$_require_codes = $aALsV.codes, $e61bec7a38836aa1$var$ERR_INVALID_ARG_TYPE = $e61bec7a38836aa1$var$_require_codes.ERR_INVALID_ARG_TYPE, $e61bec7a38836aa1$var$ERR_INVALID_RETURN_VALUE = $e61bec7a38836aa1$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $3aXq0 = parcelRequire("3aXq0");
var $e61bec7a38836aa1$require$destroyer = $3aXq0.destroyer;

var $8bwfW = parcelRequire("8bwfW");

var $jXcuS = parcelRequire("jXcuS");

var $efk7c = parcelRequire("efk7c");

var $fCNX2 = parcelRequire("fCNX2");
var $e61bec7a38836aa1$require$createDeferredPromise = $fCNX2.createDeferredPromise;

var $2H6yd = parcelRequire("2H6yd");
var $e61bec7a38836aa1$var$Blob = globalThis.Blob || $eVkja.Blob;
var $e61bec7a38836aa1$var$isBlob = typeof $e61bec7a38836aa1$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $e61bec7a38836aa1$var$Blob;
} : function isBlob(b) {
    return false;
};

var $e61bec7a38836aa1$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $enBcu = parcelRequire("enBcu");
var $e61bec7a38836aa1$require$FunctionPrototypeCall = $enBcu.FunctionPrototypeCall;
// This is needed for pre node 17.
var $e61bec7a38836aa1$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($8bwfW);
module.exports = function duplexify(body, name) {
    if ($e61bec7a38836aa1$var$isDuplexNodeStream(body)) return body;
    if ($e61bec7a38836aa1$var$isReadableNodeStream(body)) return $e61bec7a38836aa1$var$_duplexify({
        readable: body
    });
    if ($e61bec7a38836aa1$var$isWritableNodeStream(body)) return $e61bec7a38836aa1$var$_duplexify({
        writable: body
    });
    if ($e61bec7a38836aa1$var$isNodeStream(body)) return $e61bec7a38836aa1$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($e61bec7a38836aa1$var$isReadableStream(body)) return $e61bec7a38836aa1$var$_duplexify({
        readable: $jXcuS.fromWeb(body)
    });
    if ($e61bec7a38836aa1$var$isWritableStream(body)) return $e61bec7a38836aa1$var$_duplexify({
        writable: $efk7c.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $e61bec7a38836aa1$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($e61bec7a38836aa1$var$isIterable(value)) return $2H6yd($e61bec7a38836aa1$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $e61bec7a38836aa1$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $e61bec7a38836aa1$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $e61bec7a38836aa1$require$destroyer(d, err);
            });
            return d = new $e61bec7a38836aa1$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $e61bec7a38836aa1$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($e61bec7a38836aa1$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($e61bec7a38836aa1$var$isIterable(body)) return $2H6yd($e61bec7a38836aa1$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($e61bec7a38836aa1$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $e61bec7a38836aa1$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $e61bec7a38836aa1$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $e61bec7a38836aa1$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $e61bec7a38836aa1$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $e61bec7a38836aa1$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $e61bec7a38836aa1$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $e61bec7a38836aa1$require$destroyer(d1, err);
        });
        return d1 = new $e61bec7a38836aa1$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $e61bec7a38836aa1$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $e61bec7a38836aa1$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $e61bec7a38836aa1$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $e61bec7a38836aa1$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $e61bec7a38836aa1$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $e61bec7a38836aa1$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $e61bec7a38836aa1$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $jXcuS.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$e61bec7a38836aa1$var$isReadable(r);
    var writable = !!$e61bec7a38836aa1$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $e61bec7a38836aa1$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $dXW2j(w, function(err) {
            writable = false;
            if (err) $e61bec7a38836aa1$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $dXW2j(r, function(err) {
            readable = false;
            if (err) $e61bec7a38836aa1$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $e61bec7a38836aa1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $e61bec7a38836aa1$require$destroyer(w, err);
            $e61bec7a38836aa1$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("9nhuj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $enBcu = parcelRequire("enBcu");
var $6d33d3c52dc2b87f$require$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf;
module.exports = $6d33d3c52dc2b87f$var$PassThrough;

var $jkjNY = parcelRequire("jkjNY");
$6d33d3c52dc2b87f$require$ObjectSetPrototypeOf($6d33d3c52dc2b87f$var$PassThrough.prototype, $jkjNY.prototype);
$6d33d3c52dc2b87f$require$ObjectSetPrototypeOf($6d33d3c52dc2b87f$var$PassThrough, $jkjNY);
function $6d33d3c52dc2b87f$var$PassThrough(options) {
    if (!(this instanceof $6d33d3c52dc2b87f$var$PassThrough)) return new $6d33d3c52dc2b87f$var$PassThrough(options);
    $jkjNY.call(this, options);
}
$6d33d3c52dc2b87f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("jkjNY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $e11f3f743e72682f$var$ObjectSetPrototypeOf = $enBcu.ObjectSetPrototypeOf, $e11f3f743e72682f$var$Symbol = $enBcu.Symbol;
module.exports = $e11f3f743e72682f$var$Transform;

var $e11f3f743e72682f$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("aALsV")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $8bwfW = parcelRequire("8bwfW");

var $kZ9n7 = parcelRequire("kZ9n7");
var $e11f3f743e72682f$require$getHighWaterMark = $kZ9n7.getHighWaterMark;
$e11f3f743e72682f$var$ObjectSetPrototypeOf($e11f3f743e72682f$var$Transform.prototype, $8bwfW.prototype);
$e11f3f743e72682f$var$ObjectSetPrototypeOf($e11f3f743e72682f$var$Transform, $8bwfW);
var $e11f3f743e72682f$var$kCallback = $e11f3f743e72682f$var$Symbol('kCallback');
function $e11f3f743e72682f$var$Transform(options) {
    if (!(this instanceof $e11f3f743e72682f$var$Transform)) return new $e11f3f743e72682f$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $e11f3f743e72682f$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $8bwfW.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$e11f3f743e72682f$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $e11f3f743e72682f$var$prefinish);
}
function $e11f3f743e72682f$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $e11f3f743e72682f$var$prefinish() {
    if (this._final !== $e11f3f743e72682f$var$_final) $e11f3f743e72682f$var$_final.call(this);
}
$e11f3f743e72682f$var$Transform.prototype._final = $e11f3f743e72682f$var$_final;
$e11f3f743e72682f$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $e11f3f743e72682f$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$e11f3f743e72682f$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$e11f3f743e72682f$var$kCallback] = callback;
    });
};
$e11f3f743e72682f$var$Transform.prototype._read = function() {
    if (this[$e11f3f743e72682f$var$kCallback]) {
        var callback = this[$e11f3f743e72682f$var$kCallback];
        this[$e11f3f743e72682f$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2Vjk4", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $enBcu = parcelRequire("enBcu");
var $220fe4b5e5b7fd5c$var$ArrayPrototypePop = $enBcu.ArrayPrototypePop, $220fe4b5e5b7fd5c$var$Promise = $enBcu.Promise;

var $C5MxV = parcelRequire("C5MxV");
var $220fe4b5e5b7fd5c$var$isIterable = $C5MxV.isIterable, $220fe4b5e5b7fd5c$var$isNodeStream = $C5MxV.isNodeStream, $220fe4b5e5b7fd5c$var$isWebStream = $C5MxV.isWebStream;

var $5U91j = parcelRequire("5U91j");
var $220fe4b5e5b7fd5c$var$pl = $5U91j.pipelineImpl;

var $dXW2j = parcelRequire("dXW2j");
var $220fe4b5e5b7fd5c$require$finished = $dXW2j.finished;
parcelRequire("5sxdt");
function $220fe4b5e5b7fd5c$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $220fe4b5e5b7fd5c$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$220fe4b5e5b7fd5c$var$isNodeStream(lastArg) && !$220fe4b5e5b7fd5c$var$isIterable(lastArg) && !$220fe4b5e5b7fd5c$var$isWebStream(lastArg)) {
            var options = $220fe4b5e5b7fd5c$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $220fe4b5e5b7fd5c$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $220fe4b5e5b7fd5c$require$finished,
    pipeline: $220fe4b5e5b7fd5c$var$pipeline
};

});



parcelRegister("4TLSu", function(module, exports) {

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $3911700cb858aed6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3911700cb858aed6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.write = void 0;
parcelRequire("29pVS");
var $ha9LD = parcelRequire("ha9LD");

var $3911700cb858aed6$var$ShaclcGenerator_1 = $3911700cb858aed6$var$__importDefault((parcelRequire("7Njjf")));

var $3911700cb858aed6$var$writer_1 = $3911700cb858aed6$var$__importDefault((parcelRequire("fc4Ef")));

var $3911700cb858aed6$var$volatile_store_1 = $3911700cb858aed6$var$__importDefault((parcelRequire("jM3Yi")));
function $3911700cb858aed6$var$write(quads, options) {
    return $3911700cb858aed6$var$__awaiter(this, void 0, void 0, function() {
        var _this;
        return (0, $9N5UN.__generator)(this, function(_state) {
            _this = this;
            // eslint-disable-next-line no-async-promise-executor
            return [
                2,
                new Promise(function(resolve, reject) {
                    return $3911700cb858aed6$var$__awaiter(_this, void 0, void 0, function() {
                        var s, volatileStore, graphs, w, writer, e;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    s = '';
                                    volatileStore = new $3911700cb858aed6$var$volatile_store_1["default"](quads);
                                    graphs = volatileStore.getGraphs(null, null, null);
                                    if (graphs.length > 1) throw new Error('More than one graph found - can serialize in the default graph');
                                    if (graphs.length === 1 && !graphs[0].equals($ha9LD.default.defaultGraph())) throw new Error("Expected all triples to be in the default graph, instead triples were in ".concat(graphs[0].value));
                                    w = new $3911700cb858aed6$var$writer_1["default"]({
                                        write: function(chunk) {
                                            s += chunk;
                                        },
                                        end: function() {
                                            var extraQuads = volatileStore.getQuads(null, null, null, null);
                                            if (extraQuads.length === 0) extraQuads = undefined;
                                            resolve({
                                                text: s,
                                                extraQuads: extraQuads
                                            });
                                        }
                                    });
                                    writer = new $3911700cb858aed6$var$ShaclcGenerator_1["default"](volatileStore, w, options === null || options === void 0 ? void 0 : options.prefixes, undefined, (options === null || options === void 0 ? void 0 : options.errorOnUnused) !== false, options === null || options === void 0 ? void 0 : options.mintPrefixes, options === null || options === void 0 ? void 0 : options.fetch, options === null || options === void 0 ? void 0 : options.extendedSyntax, (options === null || options === void 0 ? void 0 : options.requireBase) !== false);
                                    return [
                                        4,
                                        writer.write()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    reject(e);
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
module.exports.write = $3911700cb858aed6$var$write;

});
parcelRegister("7Njjf", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $5acc1676613aaf50$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5acc1676613aaf50$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("29pVS");
var $ha9LD = parcelRequire("ha9LD");
var $cfNAJ = parcelRequire("cfNAJ");

var $8cSZX = parcelRequire("8cSZX");

var $3veIK = parcelRequire("3veIK");

var $25zlz = parcelRequire("25zlz");

var $5acc1676613aaf50$var$property_param_1 = $5acc1676613aaf50$var$__importDefault((parcelRequire("aHb7T")));

var $5acc1676613aaf50$var$base_prefixes_1 = $5acc1676613aaf50$var$__importDefault((parcelRequire("6i4LQ")));

var $5acc1676613aaf50$var$node_param_1 = $5acc1676613aaf50$var$__importDefault((parcelRequire("hbtpk")));
function $5acc1676613aaf50$var$getNamespace(str) {
    var _a;
    return (_a = /^[^]*[#/]/.exec(str)) === null || _a === void 0 ? void 0 : _a[0];
}
var $5acc1676613aaf50$var$knownNamespaces = {
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#': 'rdf',
    'http://www.w3.org/2000/01/rdf-schema#': 'rdfs',
    'http://www.w3.org/ns/shacl#': 'sh',
    'http://www.w3.org/2001/XMLSchema#': 'xsd'
};
var $5acc1676613aaf50$var$knownPrefixes = {
    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
    sh: 'http://www.w3.org/ns/shacl#',
    xsd: 'http://www.w3.org/2001/XMLSchema#'
};
var $5acc1676613aaf50$var$SHACLCWriter = /*#__PURE__*/ function() {
    function SHACLCWriter(// eslint-disable-next-line no-unused-vars
    store, // eslint-disable-next-line no-unused-vars
    writer) {
        var prefixes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, // eslint-disable-next-line no-unused-vars
        base = arguments.length > 3 ? arguments[3] : void 0, errorOnExtraQuads = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, mintUnspecifiedPrefixes = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, fetch = arguments.length > 6 ? arguments[6] : void 0, extendedSyntax = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false, requireBase = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : true;
        (0, $jGAMp._)(this, SHACLCWriter);
        this.store = store;
        this.base = base;
        this.errorOnExtraQuads = errorOnExtraQuads;
        this.mintUnspecifiedPrefixes = mintUnspecifiedPrefixes;
        this.fetch = fetch;
        this.extendedSyntax = extendedSyntax;
        this.requireBase = requireBase;
        this.prefixes = {};
        this.prefixRev = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(prefixes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var iri = prefixes[key];
                var value = typeof iri === 'string' ? iri : iri.value;
                if (!(value in $5acc1676613aaf50$var$knownNamespaces) && !(key in $5acc1676613aaf50$var$knownPrefixes)) {
                    this.prefixRev[value] = key;
                    this.prefixes[key] = value;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.writer = writer;
        this.requireBase = requireBase;
    }
    (0, $byiyg._)(SHACLCWriter, [
        {
            /**
     * Used to initiate the flow of data through the writer.
     */ // TODO: Make initialisation async
            key: "write",
            value: function write() {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _this, onotology, base, namespaces, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, term, namespace, existingPrefixes, allNamespaces, key, subjects, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, subject, _, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                onotology = this.store.getQuads(null, "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ , "http://www.w3.org/2002/07/owl#Ontology" /* owl.Ontology */ , null);
                                if (!(onotology.length === 1 && onotology[0].subject.termType === 'NamedNode')) return [
                                    3,
                                    2
                                ];
                                base = onotology[0].subject;
                                this.store.removeQuads(onotology);
                                // Don't write default
                                if (!base.equals(new $ha9LD.NamedNode('urn:x-base:default'))) this.writer.add("BASE ".concat((0, $3veIK.termToString)(base)));
                                return [
                                    4,
                                    this.writeImports(base)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                if (this.requireBase) throw new Error('Base expected');
                                _state.label = 3;
                            case 3:
                                if (!this.mintUnspecifiedPrefixes) return [
                                    3,
                                    5
                                ];
                                namespaces = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = (0, $7WNf6._)(this.store.getSubjects(null, null, null)).concat((0, $7WNf6._)(this.store.getPredicates(null, null, null)), (0, $7WNf6._)(this.store.getObjects(null, null, null)))[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        term = _step.value;
                                        if (term.termType === 'NamedNode') {
                                            namespace = $5acc1676613aaf50$var$getNamespace(term.value);
                                            if (namespace && !(namespace in this.prefixRev) && !(namespace in $5acc1676613aaf50$var$knownNamespaces)) namespaces.add(namespace);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                existingPrefixes = Object.assign(Object.assign({}, this.prefixes), $5acc1676613aaf50$var$knownPrefixes);
                                return [
                                    4,
                                    Promise.all((0, $7WNf6._)(namespaces).map(function(ns) {
                                        return (0, $8cSZX.uriToPrefix)(ns, {
                                            fetch: _this.fetch,
                                            mintOnUnknown: true,
                                            existingPrefixes: existingPrefixes
                                        }).then(function(pref) {
                                            _this.prefixes[pref] = ns;
                                            existingPrefixes[pref] = ns;
                                            _this.prefixRev[ns] = pref;
                                        });
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                allNamespaces = new Set((0, $7WNf6._)(this.store.getSubjects(null, null, null)).concat((0, $7WNf6._)(this.store.getPredicates(null, null, null)), (0, $7WNf6._)(this.store.getObjects(null, null, null))).filter(function(term) {
                                    return term.termType === 'NamedNode';
                                }).map(function(term) {
                                    return $5acc1676613aaf50$var$getNamespace(term.value);
                                }).filter(function(str) {
                                    return typeof str === 'string';
                                }));
                                for(var key in this.prefixRev)if (!allNamespaces.has(key)) {
                                    delete this.prefixes[this.prefixRev[key]];
                                    delete this.prefixRev[key];
                                }
                                return [
                                    4,
                                    this.writePrefixes()
                                ];
                            case 6:
                                _state.sent();
                                this.prefixes = Object.assign(Object.assign({}, this.prefixes), $5acc1676613aaf50$var$knownPrefixes);
                                this.prefixRev = Object.assign(Object.assign({}, this.prefixRev), $5acc1676613aaf50$var$knownNamespaces);
                                this.writer.newLine();
                                return [
                                    4,
                                    this.writeShapes()
                                ];
                            case 7:
                                _state.sent();
                                if (!this.extendedSyntax) return [
                                    3,
                                    17
                                ];
                                subjects = this.store.getSubjects(null, null, null);
                                if (subjects.length > 0) this.writer.newLine(1);
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 8;
                            case 8:
                                _state.trys.push([
                                    8,
                                    14,
                                    15,
                                    16
                                ]);
                                _iterator1 = subjects[Symbol.iterator]();
                                _state.label = 9;
                            case 9:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    13
                                ];
                                subject = _step1.value;
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(subject, true, true)
                                ];
                            case 10:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                this.writer.add(' ');
                                this.writer.indent();
                                return [
                                    4,
                                    this.writeTurtlePredicates(subject)
                                ];
                            case 11:
                                _state.sent();
                                this.writer.deindent();
                                _state.label = 12;
                            case 12:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    9
                                ];
                            case 13:
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 16:
                                if (subjects.length > 0) {
                                    this.writer.add(' .');
                                    this.writer.newLine();
                                }
                                _state.label = 17;
                            case 17:
                                if (this.errorOnExtraQuads && this.store.size > 0) throw new Error("Dataset contains quads that cannot be written in SHACLC [\n".concat(new $cfNAJ.default({
                                    prefixes: this.prefixes
                                }).quadsToString(this.store.getQuads(null, null, null, null)), "]"));
                                this.writer.end();
                                return [
                                    2
                                ];
                        }
                    });
                // this.failedQuads.append(this.store.getQuads(null, null, null, null))
                });
            }
        },
        {
            key: "writeImports",
            value: function writeImports(base) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var imports, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, imp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        imports = this.store.getObjectsOnce(base, new $ha9LD.NamedNode("http://www.w3.org/2002/07/owl#imports" /* owl.imports */ ), null);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (imports.length > 0) try {
                            for(_iterator = imports[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                imp = _step.value;
                                this.writer.add("IMPORTS <".concat(imp.value, ">"), true);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "writePrefixes",
            value: function writePrefixes() {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        keys = Object.keys(this.prefixes).filter(function(key) {
                            return !(key in $5acc1676613aaf50$var$base_prefixes_1["default"]);
                        }).sort();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (keys.length > 0) try {
                            for(_iterator = keys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                this.writer.add("PREFIX ".concat(key, ": <").concat(this.prefixes[key], ">"), true);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "termToString",
            value: function termToString(term) {
                var disableShaclName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, allowBlankNodes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var namespace;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // TODO: Make sure this does not introduce any errors
                        try {
                            if (disableShaclName) throw new Error('Shacl name disabled');
                            return [
                                2,
                                (0, $25zlz.getShaclName)(term)
                            ];
                        // eslint-disable-next-line no-empty
                        } catch (e) {}
                        if (term.termType === 'NamedNode') {
                            namespace = $5acc1676613aaf50$var$getNamespace(term.value);
                            if (namespace && namespace in this.prefixRev) {
                                if (namespace in this.prefixRev) return [
                                    2,
                                    "".concat(this.prefixRev[namespace], ":").concat(term.value.slice(namespace.length))
                                ];
                            }
                            return [
                                2,
                                (0, $3veIK.termToString)(term)
                            ];
                        }
                        if (term.termType === 'Literal') {
                            if (term.datatypeString === 'http://www.w3.org/2001/XMLSchema#integer' || term.datatypeString === 'http://www.w3.org/2001/XMLSchema#boolean') return [
                                2,
                                term.value
                            ];
                            return [
                                2,
                                (0, $3veIK.termToString)(term)
                            ];
                        }
                        if (term.termType === 'BlankNode' && allowBlankNodes) (0, $3veIK.termToString)(term);
                        throw new Error("Invalid term type for extra statement ".concat(term.value, " (").concat(term.termType, ")"));
                    });
                });
            }
        },
        {
            key: "writeShapes",
            value: function writeShapes() {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, subject, _, _1, targetClasses, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, targetClass, _2, _3, _4, _5, err, unusedPredicates, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    20,
                                    21,
                                    22
                                ]);
                                _iterator = this.store.getSubjectsOnce(new $ha9LD.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ ), new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#NodeShape" /* sh.NodeShape */ ), null)[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    19
                                ];
                                subject = _step.value;
                                if (this.store.getQuadsOnce(subject, new $ha9LD.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ ), new $ha9LD.NamedNode("http://www.w3.org/2000/01/rdf-schema#Class" /* rdfs.Class */ ), null).length > 0) this.writer.add('shapeClass ');
                                else this.writer.add('shape ');
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(subject)
                                ];
                            case 3:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                this.writer.add(' ');
                                targetClasses = this.store.getObjectsOnce(subject, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#targetClass" /* sh.targetClass */ ), null);
                                if (!(targetClasses.length > 0)) return [
                                    3,
                                    14
                                ];
                                this.writer.add('-> ');
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator1 = targetClasses[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    11
                                ];
                                targetClass = _step1.value;
                                if (!(targetClass.termType === 'NamedNode')) return [
                                    3,
                                    7
                                ];
                                _3 = (_2 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(targetClass)
                                ];
                            case 6:
                                _3.apply(_2, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                this.writer.add('!');
                                _5 = (_4 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(this.singleObject(targetClass, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#not" /* sh.not */ ), true))
                                ];
                            case 8:
                                _5.apply(_4, [
                                    _state.sent()
                                ]);
                                _state.label = 9;
                            case 9:
                                this.writer.add(' ');
                                _state.label = 10;
                            case 10:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    5
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                unusedPredicates = this.store.getPredicates(subject, null, null).filter(function(property) {
                                    return [
                                        new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#targetClass" /* sh.targetClass */ ),
                                        new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#property" /* sh.property */ ),
                                        // TODO: See if "and" should be here as well
                                        new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#or" /* sh.or */ )
                                    ].concat((0, $7WNf6._)(Object.keys($5acc1676613aaf50$var$node_param_1["default"]).map(function(key) {
                                        return new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#" /* sh._ */  + key);
                                    }))).every(function(elem) {
                                        return !property.equals(elem);
                                    });
                                });
                                if (unusedPredicates.length > 0) {
                                    this.writer.add(';');
                                    this.writer.indent();
                                    this.writer.newLine(1);
                                }
                                if (!this.extendedSyntax) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    this.writeGivenTurtlePredicates(subject, unusedPredicates)
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                if (unusedPredicates.length > 0) {
                                    this.writer.add(' ');
                                    this.writer.deindent();
                                }
                                return [
                                    4,
                                    this.writeShapeBody(subject, false)
                                ];
                            case 17:
                                _state.sent();
                                _state.label = 18;
                            case 18:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 19:
                                return [
                                    3,
                                    22
                                ];
                            case 20:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    22
                                ];
                            case 21:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 22:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getSingleProperty",
            value: function getSingleProperty(quad, allowedPredicates) {
                // let tempQuad = quad;
                var examining = [
                    quad
                ];
                try {
                    var name = (0, $25zlz.getShaclName)(quad.predicate);
                    var type = 'pred';
                    if (name === 'not') {
                        var quads = this.store.getQuadsOnce(quad.object, null, null, null);
                        // TODO: See if this line is necessary
                        examining = examining.concat(quads);
                        if (quads.length !== 1) throw new Error('Can only handle having one predicate of \'not\'');
                        var ref;
                        // eslint-disable-next-line no-param-reassign
                        ref = (0, $32TW8._)(quads, 1), quad = ref[0], ref;
                        name = (0, $25zlz.getShaclName)(quad.predicate);
                        type = 'not';
                    }
                    if (!(name in allowedPredicates)) throw new Error("".concat(name, " is not allowed"));
                    return {
                        name: name,
                        type: type,
                        object: quad.object
                    };
                } catch (e) {
                    this.store.addQuads(examining);
                }
                return undefined;
            }
        },
        {
            key: "singleLayerPropertiesList",
            value: function singleLayerPropertiesList(term, allowedPredicates) {
                var result = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.store.getQuadsOnce(term, null, null, null)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        var property = this.getSingleProperty(quad, allowedPredicates);
                        if (property) result.push(property);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "expectOneProperty",
            value: function expectOneProperty(term, allowedPredicates) {
                var quads = this.store.getQuadsOnce(term, null, null, null);
                if (quads.length === 1) {
                    var data = this.getSingleProperty(quads[0], allowedPredicates);
                    if (data) return data;
                }
                this.store.addQuads(quads);
                return undefined;
            }
        },
        {
            key: "orProperties",
            value: function orProperties(term, allowedPredicates) {
                var orProperties = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.store.getQuadsOnce(term, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#or" /* sh.or */ ), null, null)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        var statement = [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = this.getList(quad.object)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var item = _step1.value;
                                var property = this.expectOneProperty(item, allowedPredicates);
                                if (!property) {
                                    // TODO HANDLE THIS CASE BY EXTENDING SHACLC SYNTAX
                                    this.store.addQuad(quad);
                                    throw new Error('Each entry of the \'or\' statement must declare exactly one property');
                                }
                                statement.push(property);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        orProperties.push(statement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return orProperties;
            }
        },
        {
            /**
     * Extract an rdf:list
     */ key: "getList",
            value: function getList(term) {
                // TODO: Fix gross type casting
                var termTemp = term;
                var list = [];
                // TODO: Handle poorly formed RDF lists
                while(!termTemp.equals(new $ha9LD.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil" /* rdf.nil */ ))){
                    list.push(this.singleObject(termTemp, new $ha9LD.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first" /* rdf.first */ ), true));
                    termTemp = this.singleObject(termTemp, new $ha9LD.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest" /* rdf.rest */ ), true);
                }
                return list;
            }
        },
        {
            key: "writeIriLiteralOrArray",
            value: function writeIriLiteralOrArray(object) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, term, _, _1, err, _2, _3;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(object.termType === 'BlankNode')) return [
                                    3,
                                    9
                                ];
                                this.writer.add('[');
                                first = true;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = this.getList(object)[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                term = _step.value;
                                if (first) first = false;
                                else this.writer.add(' ');
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(term)
                                ];
                            case 3:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                this.writer.add(']');
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                _3 = (_2 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(object)
                                ];
                            case 10:
                                _3.apply(_2, [
                                    _state.sent()
                                ]);
                                _state.label = 11;
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "singleObject",
            value: function singleObject(subject, predicate, strict) {
                var _a;
                return (_a = this.singleQuad(subject, predicate, strict)) === null || _a === void 0 ? void 0 : _a.object;
            }
        },
        {
            key: "singleQuad",
            value: function singleQuad(subject, predicate) {
                var strict = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var objects = this.store.getQuadsOnce(subject, predicate, null, null);
                if (strict && objects.length !== 1) {
                    this.store.addQuads(objects);
                    throw new Error("The subject and predicate ".concat(subject === null || subject === void 0 ? void 0 : subject.value, " ").concat(predicate === null || predicate === void 0 ? void 0 : predicate.value, " must have exactly one object. Instead has ").concat(objects.length));
                }
                if (objects.length > 1) {
                    this.store.addQuads(objects);
                    throw new Error("The subject and predicate ".concat(subject === null || subject === void 0 ? void 0 : subject.value, " ").concat(predicate === null || predicate === void 0 ? void 0 : predicate.value, " can have at most one object. Instead has ").concat(objects.length));
                }
                return objects.length === 1 ? objects[0] : undefined;
            }
        },
        {
            key: "writeAssigment",
            value: function writeAssigment(param) {
                var name = param.name, type = param.type, object = param.object;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (type === 'not') this.writer.add('!');
                                this.writer.add(name);
                                this.writer.add('=');
                                return [
                                    4,
                                    this.writeIriLiteralOrArray(object)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeAtom",
            value: function writeAtom(param) {
                var name = param.name, type = param.type, object = param.object;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _, _1, _2, _3, _4, _5, _6, _7;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (type === 'not') this.writer.add('!');
                                switch(name){
                                    case 'node':
                                        return [
                                            3,
                                            1
                                        ];
                                    case 'nodeKind':
                                        return [
                                            3,
                                            7
                                        ];
                                    case 'class':
                                        return [
                                            3,
                                            8
                                        ];
                                    case 'datatype':
                                        return [
                                            3,
                                            10
                                        ];
                                }
                                return [
                                    3,
                                    12
                                ];
                            case 1:
                                if (!(object.termType === 'NamedNode')) return [
                                    3,
                                    3
                                ];
                                _1 = (_ = this.writer).add;
                                _3 = (_2 = "@").concat;
                                return [
                                    4,
                                    this.termToString(object)
                                ];
                            case 2:
                                _1.apply(_, [
                                    _3.apply(_2, [
                                        _state.sent()
                                    ])
                                ]);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                if (!(object.termType === 'BlankNode')) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.writeShapeBody(object)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error('Invalid nested shape, must be blank node or IRI');
                            case 6:
                                return [
                                    2
                                ];
                            case 7:
                                this.writer.add((0, $25zlz.getShaclName)(object));
                                return [
                                    2
                                ];
                            case 8:
                                _5 = (_4 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(object)
                                ];
                            case 9:
                                _5.apply(_4, [
                                    _state.sent()
                                ]);
                                return [
                                    2
                                ];
                            case 10:
                                _7 = (_6 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(object)
                                ];
                            case 11:
                                _7.apply(_6, [
                                    _state.sent()
                                ]);
                                return [
                                    2
                                ];
                            case 12:
                                this.writer.add(name);
                                this.writer.add('=');
                                return [
                                    4,
                                    this.writeIriLiteralOrArray(object)
                                ];
                            case 13:
                                _state.sent();
                                _state.label = 14;
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeAssigments",
            value: function writeAssigments(assignments) {
                var divider = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ' ', first = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shortcuts = arguments.length > 3 ? arguments[3] : void 0;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, assignment, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = assignments[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                assignment = _step.value;
                                if (first) // eslint-disable-next-line no-param-reassign
                                first = false;
                                else this.writer.add(divider);
                                if (!shortcuts) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.writeAtom(assignment)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    this.writeAssigment(assignment)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeParams",
            value: function writeParams(term) {
                var first = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, allowedParam = arguments.length > 2 ? arguments[2] : void 0, shortcuts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, surroundings = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var or, params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, statement, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // TODO Stream this part
                                or = this.orProperties(term, allowedParam);
                                params = this.singleLayerPropertiesList(term, allowedParam);
                                if (surroundings && (or.length > 0 || params.length > 0)) this.writer.newLine(1);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = or[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                statement = _step.value;
                                if (first) // eslint-disable-next-line no-param-reassign
                                first = false;
                                else this.writer.add(' ');
                                return [
                                    4,
                                    this.writeAssigments(statement, '|', true, shortcuts)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    4,
                                    this.writeAssigments(params, ' ', first, shortcuts)
                                ];
                            case 9:
                                _state.sent();
                                if (surroundings && (or.length > 0 || params.length > 0)) this.writer.add(' .');
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeShapeBody",
            value: function writeShapeBody(term) {
                var nested = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var properties, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, property, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.writer.add('{').indent();
                                properties = this.store.getObjectsOnce(term, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#property" /* sh.property */ ), null);
                                return [
                                    4,
                                    this.writeParams(term, true, $5acc1676613aaf50$var$node_param_1["default"], false, true)
                                ];
                            case 1:
                                _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = properties[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                property = _step.value;
                                this.writer.newLine(1);
                                return [
                                    4,
                                    this.writeProperty(property)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                this.writer.deindent().newLine(1);
                                if (nested) this.writer.add('} .');
                                else this.writer.add('}').newLine(1);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeProperty",
            value: function writeProperty(property) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var min, max, nodeKind, propertyClass, datatype, nodeShapes, _, _1, _2, _3, nestedShapes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, _4, _5, _6, _7, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, shape, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.writePath(this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#path" /* sh.path */ ), true))
                                ];
                            case 1:
                                _state.sent();
                                min = this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#minCount" /* sh.minCount */ ));
                                max = this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#maxCount" /* sh.maxCount */ ));
                                nodeKind = this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#nodeKind" /* sh.nodeKind */ ));
                                // eslint-disable-next-line no-underscore-dangle
                                propertyClass = this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#class" /* sh._class */ ));
                                datatype = this.singleObject(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#datatype" /* sh.datatype */ ));
                                nodeShapes = this.store.getObjectsOnce(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#node" /* sh.node */ ), null);
                                if (nodeKind) {
                                    this.writer.add(' ');
                                    this.writer.add((0, $25zlz.getShaclName)(nodeKind));
                                }
                                if (!propertyClass) return [
                                    3,
                                    3
                                ];
                                this.writer.add(' ');
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(propertyClass)
                                ];
                            case 2:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                _state.label = 3;
                            case 3:
                                if (!datatype) return [
                                    3,
                                    5
                                ];
                                this.writer.add(' ');
                                _3 = (_2 = this.writer).add;
                                return [
                                    4,
                                    this.termToString(datatype)
                                ];
                            case 4:
                                _3.apply(_2, [
                                    _state.sent()
                                ]);
                                _state.label = 5;
                            case 5:
                                if (min !== undefined || max !== undefined) {
                                    this.writer.add(' [');
                                    if (min) {
                                        if (min.termType !== 'Literal' || min.datatypeString !== 'http://www.w3.org/2001/XMLSchema#integer') throw new Error('Invalid min value, must me an integer literal');
                                        this.writer.add(min.value);
                                    } else this.writer.add('0');
                                    this.writer.add('..');
                                    if (max) {
                                        if (max.termType !== 'Literal' || max.datatypeString !== 'http://www.w3.org/2001/XMLSchema#integer') throw new Error('Invalid max value, must me an integer literal');
                                        this.store.removeMatches(property, new $ha9LD.NamedNode("http://www.w3.org/ns/shacl#maxCount" /* sh.maxCount */ ), undefined, undefined);
                                        this.writer.add(max.value);
                                    } else this.writer.add('*');
                                    this.writer.add(']');
                                }
                                return [
                                    4,
                                    this.writeParams(property, false, $5acc1676613aaf50$var$property_param_1["default"], true)
                                ];
                            case 6:
                                _state.sent();
                                nestedShapes = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 7;
                            case 7:
                                _state.trys.push([
                                    7,
                                    13,
                                    14,
                                    15
                                ]);
                                _iterator = nodeShapes[Symbol.iterator]();
                                _state.label = 8;
                            case 8:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    12
                                ];
                                node = _step.value;
                                if (!(node.termType === 'NamedNode')) return [
                                    3,
                                    10
                                ];
                                this.writer.add(' ');
                                _5 = (_4 = this.writer).add;
                                _7 = (_6 = "@").concat;
                                return [
                                    4,
                                    this.termToString(node)
                                ];
                            case 9:
                                _5.apply(_4, [
                                    _7.apply(_6, [
                                        _state.sent()
                                    ])
                                ]);
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (node.termType === 'BlankNode') nestedShapes.push(node);
                                else throw new Error('Invalid nested shape, must be blank node or IRI');
                                _state.label = 11;
                            case 11:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    8
                                ];
                            case 12:
                                return [
                                    3,
                                    15
                                ];
                            case 13:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 15:
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 16;
                            case 16:
                                _state.trys.push([
                                    16,
                                    21,
                                    22,
                                    23
                                ]);
                                _iterator1 = nestedShapes[Symbol.iterator]();
                                _state.label = 17;
                            case 17:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    20
                                ];
                                shape = _step1.value;
                                this.writer.add(' ');
                                return [
                                    4,
                                    this.writeShapeBody(shape)
                                ];
                            case 18:
                                _state.sent();
                                _state.label = 19;
                            case 19:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    17
                                ];
                            case 20:
                                return [
                                    3,
                                    23
                                ];
                            case 21:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    23
                                ];
                            case 22:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 23:
                                if (!(this.extendedSyntax && this.store.getQuads(property, null, null, null).length > 0)) return [
                                    3,
                                    25
                                ];
                                this.writer.add(' %');
                                this.writer.indent();
                                this.writer.newLine(1);
                                return [
                                    4,
                                    this.writeTurtlePredicates(property)
                                ];
                            case 24:
                                _state.sent();
                                this.writer.deindent();
                                this.writer.newLine(1);
                                this.writer.add('%');
                                _state.label = 25;
                            case 25:
                                if (nestedShapes.length === 0) this.writer.add(' .');
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeTurtlePredicates",
            value: function writeTurtlePredicates(term) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.writeGivenTurtlePredicates(term, this.store.getPredicates(term, null, null))
                        ];
                    });
                });
            }
        },
        {
            key: "writeGivenTurtlePredicates",
            value: function writeGivenTurtlePredicates(term, predicates) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var semi, types, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, predicate, _, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                semi = false;
                                if (!predicates.some(function(predicate) {
                                    return predicate.equals($ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'));
                                })) return [
                                    3,
                                    2
                                ];
                                types = this.store.getObjectsOnce(term, $ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
                                if (!(types.length > 0)) return [
                                    3,
                                    2
                                ];
                                semi = true;
                                this.writer.add('a ');
                                return [
                                    4,
                                    this.writeTurtleObjects(types)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = predicates[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                predicate = _step.value;
                                if (!!predicate.equals($ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'))) return [
                                    3,
                                    7
                                ];
                                if (semi) {
                                    this.writer.add(' ;');
                                    this.writer.newLine(1);
                                } else semi = true;
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(predicate, true)
                                ];
                            case 5:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                this.writer.add(' ');
                                return [
                                    4,
                                    this.writeTurtleObjects(this.store.getObjectsOnce(term, predicate, null))
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeTurtleObjects",
            value: function writeTurtleObjects(objects) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blankObjects, nonBlankObjects, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, object, _, _1, comma, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, blank, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                blankObjects = [];
                                nonBlankObjects = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = objects[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        object = _step.value;
                                        if (object.termType === 'BlankNode' && (0, $7WNf6._)(this.store.match(null, null, object)).concat((0, $7WNf6._)(this.store.match(null, object, null))).length === 0) blankObjects.push(object);
                                        else nonBlankObjects.push(object);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    Promise.all(nonBlankObjects.map(function(object) {
                                        return _this.termToString(object, true, true);
                                    }))
                                ];
                            case 1:
                                _1.apply(_, [
                                    _state.sent().join(', ')
                                ]);
                                comma = nonBlankObjects.length > 0;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!(blankObjects.length > 0)) return [
                                    3,
                                    10
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator1 = blankObjects[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    7
                                ];
                                blank = _step1.value;
                                if (comma) this.writer.add(', ');
                                else comma = true;
                                return [
                                    4,
                                    this.writeList(blank)
                                ];
                            case 4:
                                if (!!_state.sent()) return [
                                    3,
                                    6
                                ];
                                this.writer.add('[');
                                this.writer.indent();
                                this.writer.newLine(1);
                                return [
                                    4,
                                    this.writeTurtlePredicates(blank)
                                ];
                            case 5:
                                _state.sent();
                                this.writer.deindent();
                                this.writer.newLine(1);
                                this.writer.add(']');
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    3
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writeList",
            value: function writeList(object) {
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var node, elems, quads, _quads, first, rest, space, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, elem, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                node = object;
                                elems = [];
                                quads = [];
                                while(!node.equals($ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil'))){
                                    ;
                                    first = this.store.getQuadsOnce(node, $ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'), null, null);
                                    rest = this.store.getQuadsOnce(node, $ha9LD.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'), null, null);
                                    (_quads = quads).push.apply(_quads, (0, $7WNf6._)(first).concat((0, $7WNf6._)(rest)));
                                    if (first.length !== 1 || rest.length !== 1 || this.store.getQuads(node, null, null, null).length !== 0) {
                                        this.store.addQuads(quads);
                                        return [
                                            2,
                                            false
                                        ];
                                    }
                                    elems.push(first[0].object);
                                    node = rest[0].object;
                                }
                                space = false;
                                this.writer.add('(');
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = elems[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                elem = _step.value;
                                if (space) this.writer.add(' ');
                                else space = true;
                                return [
                                    4,
                                    this.writeTurtleObjects([
                                        elem
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                this.writer.add(')');
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "writePath",
            value: function writePath(term) {
                var braces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return $5acc1676613aaf50$var$__awaiter(this, void 0, void 0, function() {
                    var _, _1, quads, _quads_, predicate, object, _2, alternatives, first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, alt, err, sequence, first1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, alt1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(term.termType === 'NamedNode')) return [
                                    3,
                                    2
                                ];
                                _1 = (_ = this.writer).add;
                                return [
                                    4,
                                    this.termToString(term)
                                ];
                            case 1:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    38
                                ];
                            case 2:
                                if (!(term.termType === 'BlankNode')) return [
                                    3,
                                    37
                                ];
                                quads = this.store.getQuadsOnce(term, null, null, null);
                                if (!(quads.length === 1)) return [
                                    3,
                                    26
                                ];
                                _quads_ = quads[0], predicate = _quads_.predicate, object = _quads_.object;
                                _2 = predicate.value;
                                switch(_2){
                                    case "http://www.w3.org/ns/shacl#inversePath" /* sh.inversePath */ :
                                        return [
                                            3,
                                            3
                                        ];
                                    case "http://www.w3.org/ns/shacl#alternativePath" /* sh.alternativePath */ :
                                        return [
                                            3,
                                            5
                                        ];
                                    case "http://www.w3.org/ns/shacl#zeroOrMorePath" /* sh.zeroOrMorePath */ :
                                        return [
                                            3,
                                            18
                                        ];
                                    case "http://www.w3.org/ns/shacl#oneOrMorePath" /* sh.oneOrMorePath */ :
                                        return [
                                            3,
                                            20
                                        ];
                                    case "http://www.w3.org/ns/shacl#zeroOrOnePath" /* sh.zeroOrOnePath */ :
                                        return [
                                            3,
                                            22
                                        ];
                                }
                                return [
                                    3,
                                    24
                                ];
                            case 3:
                                this.writer.add('^');
                                return [
                                    4,
                                    this.writePath(object, true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 5:
                                alternatives = this.getList(object);
                                if (!(alternatives.length === 0)) return [
                                    3,
                                    6
                                ];
                                throw new Error('Invalid Alternative Path - no options');
                            case 6:
                                if (!(alternatives.length === 1)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    this.writePath(alternatives[0])
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 8:
                                if (braces) this.writer.add('(');
                                first = true;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 9;
                            case 9:
                                _state.trys.push([
                                    9,
                                    14,
                                    15,
                                    16
                                ]);
                                _iterator = alternatives[Symbol.iterator]();
                                _state.label = 10;
                            case 10:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    13
                                ];
                                alt = _step.value;
                                if (first) first = false;
                                else this.writer.add('|');
                                return [
                                    4,
                                    this.writePath(alt, true)
                                ];
                            case 11:
                                _state.sent();
                                _state.label = 12;
                            case 12:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    10
                                ];
                            case 13:
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 16:
                                if (braces) this.writer.add(')');
                                _state.label = 17;
                            case 17:
                                return [
                                    2
                                ];
                            case 18:
                                return [
                                    4,
                                    this.writePath(object, true)
                                ];
                            case 19:
                                _state.sent();
                                this.writer.add('*');
                                return [
                                    2
                                ];
                            case 20:
                                return [
                                    4,
                                    this.writePath(object, true)
                                ];
                            case 21:
                                _state.sent();
                                this.writer.add('+');
                                return [
                                    2
                                ];
                            case 22:
                                return [
                                    4,
                                    this.writePath(object, true)
                                ];
                            case 23:
                                _state.sent();
                                this.writer.add('?');
                                return [
                                    2
                                ];
                            case 24:
                                throw new Error("Invalid path type ".concat(term.value));
                            case 25:
                                return [
                                    3,
                                    36
                                ];
                            case 26:
                                // TODO Make more efficient
                                this.store.addQuads(quads);
                                sequence = this.getList(term);
                                if (!(sequence.length === 0)) return [
                                    3,
                                    27
                                ];
                                throw new Error('Invalid Path');
                            case 27:
                                if (braces) this.writer.add('(');
                                first1 = true;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 28;
                            case 28:
                                _state.trys.push([
                                    28,
                                    33,
                                    34,
                                    35
                                ]);
                                _iterator1 = sequence[Symbol.iterator]();
                                _state.label = 29;
                            case 29:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    32
                                ];
                                alt1 = _step1.value;
                                if (first1) first1 = false;
                                else this.writer.add('/');
                                return [
                                    4,
                                    this.writePath(alt1, true)
                                ];
                            case 30:
                                _state.sent();
                                _state.label = 31;
                            case 31:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    29
                                ];
                            case 32:
                                return [
                                    3,
                                    35
                                ];
                            case 33:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    35
                                ];
                            case 34:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 35:
                                if (braces) this.writer.add(')');
                                _state.label = 36;
                            case 36:
                                return [
                                    3,
                                    38
                                ];
                            case 37:
                                throw new Error('Path should be named node or blank node');
                            case 38:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return SHACLCWriter;
}();
module.exports["default"] = $5acc1676613aaf50$var$SHACLCWriter;

});
parcelRegister("8cSZX", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $5f9a1b38c965db5c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupAllPrefixes = module.exports.prefixToUri = module.exports.uriToPrefix = void 0;

var $2F29x = parcelRequire("2F29x");

var $eoryc = parcelRequire("eoryc");
function $5f9a1b38c965db5c$var$uriToPrefix(uri, options) {
    return $5f9a1b38c965db5c$var$__awaiter(this, void 0, void 0, function() {
        var result, _a, i;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $eoryc.lookupPrefix)(uri, options)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _a = _state.sent();
                    if (options === null || options === void 0 ? void 0 : options.mintOnUnknown) // Keep prefixes at most 4 characters long when minting a new one
                    result = (0, $2F29x.fragment)(uri).slice(0, 4);
                    return [
                        3,
                        3
                    ];
                case 3:
                    // If there is a bank of existing prefixes make sure to make a unique one
                    // by postfixing a number
                    if (typeof result !== 'undefined' && (0, $3KZcf._)(options === null || options === void 0 ? void 0 : options.existingPrefixes) === 'object' && result in options.existingPrefixes) {
                        i = 0;
                        while("".concat(result).concat(i) in options.existingPrefixes)i += 1;
                        result = "".concat(result).concat(i);
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
module.exports.uriToPrefix = $5f9a1b38c965db5c$var$uriToPrefix;
/**
 * Lookup the namespace commonly associated with a given prefix
 * @param prefix The prefix to lookup the namespace for
 * @param options You can optionally pass a custom fetch function
 */ function $5f9a1b38c965db5c$var$prefixToUri(prefix, options) {
    return $5f9a1b38c965db5c$var$__awaiter(this, void 0, void 0, function() {
        var _a;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $eoryc.lookupUri)(prefix, options)
                    ];
                case 1:
                    // The await needs to be here so that we can return undefined on rejection
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _a = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
}
module.exports.prefixToUri = $5f9a1b38c965db5c$var$prefixToUri;

var $eoryc = parcelRequire("eoryc");
Object.defineProperty(module.exports, "lookupAllPrefixes", {
    enumerable: true,
    get: function get() {
        return $eoryc.lookupAllPrefixes;
    }
});

});
parcelRegister("2F29x", function(module, exports) {

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fragment = void 0;
function $1f0114a154e08d82$var$getFragment(inputStr) {
    var _Math;
    var str = inputStr;
    if (str.endsWith('/') || str.endsWith('#')) str = str.slice(0, str.length - 1);
    var args = [];
    if (str.lastIndexOf('/') > 0) args.push(str.lastIndexOf('/'));
    if (str.lastIndexOf('#') > 0) args.push(str.lastIndexOf('#'));
    var i = (_Math = Math).max.apply(_Math, (0, $7WNf6._)(args));
    return str.slice(i + 1);
}
function $1f0114a154e08d82$var$camelize(str) {
    var _a;
    var res = (_a = str.split(/[^a-z0-9]+/ig).filter(function(s) {
        return s !== '';
    }).map(function(s) {
        return s[0].toUpperCase() + s.slice(1);
    }).join('')// Make sure the prefix does not start with a number
    .match(/[a-z][a-z0-9]+/ig)) === null || _a === void 0 ? void 0 : _a[0];
    // Include 'v' so we always return something matching the pattern
    // [a-z][a-z0-9]+
    return typeof res === 'undefined' ? undefined : res[0].toLowerCase() + res.slice(1);
}
function $1f0114a154e08d82$var$fragment(str) {
    var value = $1f0114a154e08d82$var$getFragment(str);
    value = value ? $1f0114a154e08d82$var$camelize(value) : undefined;
    return value || 'v';
}
module.exports.fragment = $1f0114a154e08d82$var$fragment;

});

parcelRegister("eoryc", function(module, exports) {
"use strict";
var $a7a8ad8f317a976c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7a8ad8f317a976c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a7a8ad8f317a976c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a7a8ad8f317a976c$var$__exportStar((parcelRequire("8Hi9C")), module.exports);

$a7a8ad8f317a976c$var$__exportStar((parcelRequire("29KGF")), module.exports);

$a7a8ad8f317a976c$var$__exportStar((parcelRequire("hxXsT")), module.exports);

});
parcelRegister("8Hi9C", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $65506bef36494af9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupUri = void 0;

var $dzhs4 = parcelRequire("dzhs4");
/**
 * Use prefix.cc to look up the namespace associated with a given prefix.
 * Errors if one cannot be found.
 *
 * @param prefix The prefix of which to obtain the namespace
 * @param options Optional fetch function to use
 */ function $65506bef36494af9$var$lookupUri(prefix, options) {
    return $65506bef36494af9$var$__awaiter(this, void 0, void 0, function() {
        var uri;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $dzhs4.fetchContext)("https://prefix.cc/".concat(prefix, ".file.jsonld"), options)
                    ];
                case 1:
                    uri = _state.sent()[prefix];
                    if (typeof uri !== 'string') throw new Error("Expected uri to be a string, received: ".concat(uri, " of type ").concat(typeof uri === "undefined" ? "undefined" : (0, $3KZcf._)(uri)));
                    return [
                        2,
                        uri
                    ];
            }
        });
    });
}
module.exports.lookupUri = $65506bef36494af9$var$lookupUri;

});
parcelRegister("dzhs4", function(module, exports) {

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $9e0c14c73d8da24c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchContext = module.exports.fetchJson = void 0;

var $66n5d = parcelRequire("66n5d");
function $9e0c14c73d8da24c$var$fetchJson(url, options) {
    var _a;
    return $9e0c14c73d8da24c$var$__awaiter(this, void 0, void 0, function() {
        var fetchFn;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Select the correct fetch function
                    fetchFn = (_a = options === null || options === void 0 ? void 0 : options.fetch) !== null && _a !== void 0 ? _a : $66n5d.fetch;
                    return [
                        4,
                        fetchFn(url)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().json()
                    ];
            }
        });
    });
}
module.exports.fetchJson = $9e0c14c73d8da24c$var$fetchJson;
function $9e0c14c73d8da24c$var$fetchContext(url, options) {
    return $9e0c14c73d8da24c$var$__awaiter(this, void 0, void 0, function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $9e0c14c73d8da24c$var$fetchJson(url, options)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()['@context']
                    ];
            }
        });
    });
}
module.exports.fetchContext = $9e0c14c73d8da24c$var$fetchContext;

});
parcelRegister("66n5d", function(module, exports) {
// Save global object in a variable

var $3KZcf = parcelRequire("3KZcf");
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function next() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && (0, $3KZcf._)(init.headers) === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("29KGF", function(module, exports) {

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $1920a323fa5a3f27$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupPrefix = void 0;

var $dzhs4 = parcelRequire("dzhs4");
/**
 * Use prefix.cc to look up the prefix for a URI namespace, rejects if there is an error in
 * looking up the prefix, or if no prefixes are returned
 *
 * @param uri The URI to obtain a prefix for
 * @param options Optional fetch function to use
 */ function $1920a323fa5a3f27$var$lookupPrefix(uri, options) {
    return $1920a323fa5a3f27$var$__awaiter(this, void 0, void 0, function() {
        var url, prefixes, _;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Create the correct url to lookup including search parameters
                    url = new URL('https://prefix.cc/reverse');
                    url.searchParams.append('uri', uri);
                    url.searchParams.append('format', 'jsonld');
                    _ = Object.keys;
                    return [
                        4,
                        (0, $dzhs4.fetchContext)(url, options)
                    ];
                case 1:
                    prefixes = _.apply(Object, [
                        _state.sent()
                    ]);
                    if (prefixes.length === 0) throw new Error('No prefixes returned');
                    return [
                        2,
                        prefixes[0]
                    ];
            }
        });
    });
}
module.exports.lookupPrefix = $1920a323fa5a3f27$var$lookupPrefix;

});

parcelRegister("hxXsT", function(module, exports) {

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $cc63a542e20481fa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupAllPrefixes = void 0;

var $dzhs4 = parcelRequire("dzhs4");
/**
 * Use prefix.cc to look up all recorded prefixes
 */ function $cc63a542e20481fa$var$lookupAllPrefixes(options) {
    return $cc63a542e20481fa$var$__awaiter(this, void 0, void 0, function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2,
                (0, $dzhs4.fetchContext)('https://prefix.cc/context', options)
            ];
        });
    });
}
module.exports.lookupAllPrefixes = $cc63a542e20481fa$var$lookupAllPrefixes;

});



parcelRegister("25zlz", function(module, exports) {
"use strict";
/**
  * Get the frame of an IRI that we expect to be in the SHACL namespace
  */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getShaclName = void 0;
// eslint-disable-next-line import/prefer-default-export
function $1857778d6754d0b5$var$getShaclName(term) {
    if (term.termType !== 'NamedNode' || !term.value.startsWith("http://www.w3.org/ns/shacl#" /* sh._ */ )) throw new Error("Term ".concat(term.value, " is not part of the SHACL namespace"));
    return term.value.slice(27);
}
module.exports.getShaclName = $1857778d6754d0b5$var$getShaclName;

});

parcelRegister("aHb7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Allowed parameters for a PropertyShape
 */ module.exports["default"] = {
    deactivated: true,
    severity: true,
    message: true,
    "class": true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    uniqueLang: true,
    equals: true,
    disjoint: true,
    lessThan: true,
    lessThanOrEquals: true,
    qualifiedValueShape: true,
    qualifiedMinCount: true,
    qualifiedMaxCount: true,
    qualifiedValueShapesDisjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    "in": true,
    // This is here so that we can exract it from alts
    node: true
};

});

parcelRegister("6i4LQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * The base prefixes default to SHACLC syntax
 */ // TODO: Double check the defaults
module.exports["default"] = {
    owl: 'http://www.w3.org/2002/07/owl#',
    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
    sh: 'http://www.w3.org/ns/shacl#',
    xsd: 'http://www.w3.org/2001/XMLSchema#'
};

});

parcelRegister("hbtpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Allowed parameters for a NodeShape
 */ module.exports["default"] = {
    targetNode: true,
    targetObjectsOf: true,
    targetSubjectsOf: true,
    deactivated: true,
    severity: true,
    message: true,
    "class": true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    equals: true,
    disjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    "in": true
};

});


parcelRegister("fc4Ef", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Convenience class used to write chunks
 */ var $b0fb9502e53cb28d$var$Writer = /*#__PURE__*/ function() {
    function Writer(options) {
        (0, $jGAMp._)(this, Writer);
        this.indents = 0;
        this.write = options.write;
        this.end = options.end;
    }
    (0, $byiyg._)(Writer, [
        {
            key: "indent",
            value: function indent() {
                this.indents += 1;
                return this;
            }
        },
        {
            key: "deindent",
            value: function deindent() {
                if (this.indents < 1) throw new Error("Trying to deindent when indent is only ".concat(this.indents));
                this.indents -= 1;
                return this;
            }
        },
        {
            key: "add",
            value: function add(s) {
                var newLine = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.write(newLine ? "\n".concat('\t'.repeat(this.indents)).concat(s) : s, 'utf-8');
                return this;
            }
        },
        {
            key: "newLine",
            value: function newLine() {
                var no = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                this.write('\n'.repeat(no) + '\t'.repeat(this.indents), 'utf-8');
                return this;
            }
        }
    ]);
    return Writer;
}();
module.exports["default"] = $b0fb9502e53cb28d$var$Writer;

});

parcelRegister("jM3Yi", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("29pVS");
var $6rfrN = parcelRequire("6rfrN");
var $e65594ae530c234e$var$VolitileStore = /*#__PURE__*/ function(_n3_1_Store) {
    (0, $i3fW3._)(VolitileStore, _n3_1_Store);
    function VolitileStore() {
        (0, $jGAMp._)(this, VolitileStore);
        return (0, $kzDuW._)(this, VolitileStore, arguments);
    }
    (0, $byiyg._)(VolitileStore, [
        {
            key: "getQuadsOnce",
            value: function getQuadsOnce(s, p, o, g) {
                var quads = this.getQuads(s, p, o, g);
                this.removeQuads(quads);
                return quads;
            }
        },
        {
            key: "getSubjectsOnce",
            value: function getSubjectsOnce(p, o, g) {
                return this.getQuadsOnce(null, p, o, g).map(function(term) {
                    return term.subject;
                });
            }
        },
        {
            key: "getObjectsOnce",
            value: function getObjectsOnce(s, p, g) {
                return this.getQuadsOnce(s, p, null, g).map(function(term) {
                    return term.object;
                });
            }
        }
    ]);
    return VolitileStore;
}($6rfrN.default);
module.exports["default"] = $e65594ae530c234e$var$VolitileStore;

});




parcelRegister("5qvrA", function(module, exports) {
"use strict";
var $3f37c594ef52aac8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3f37c594ef52aac8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3f37c594ef52aac8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3f37c594ef52aac8$var$__exportStar((parcelRequire("bsPkn")), module.exports);

});
parcelRegister("bsPkn", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsRdfJsStore = void 0;

var $8UQh4 = parcelRequire("8UQh4");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $cjofa = parcelRequire("cjofa");
/**
 * A comunica RDFJS Store RDF Update Quads Actor.
 */ var $858a1fd79268cbef$var$ActorRdfUpdateQuadsRdfJsStore = /*#__PURE__*/ function(_bus_rdf_update_quads_1_ActorRdfUpdateQuadsDestination) {
    (0, $i3fW3._)(ActorRdfUpdateQuadsRdfJsStore, _bus_rdf_update_quads_1_ActorRdfUpdateQuadsDestination);
    function ActorRdfUpdateQuadsRdfJsStore(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateQuadsRdfJsStore);
        return (0, $kzDuW._)(this, ActorRdfUpdateQuadsRdfJsStore, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfUpdateQuadsRdfJsStore, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _destination_value, destination;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        destination = (0, $8UQh4.getContextDestination)(action.context);
                        if (!destination || typeof destination === 'string' || !('remove' in destination) && 'value' in destination && !((_destination_value = destination.value) === null || _destination_value === void 0 ? void 0 : _destination_value.remove)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " received an invalid rdfjsStore."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getDestination",
            value: function getDestination(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var destination;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        destination = (0, $8UQh4.getContextDestination)(context);
                        return [
                            2,
                            new $cjofa.RdfJsQuadDestination(context.getSafe($9nBhR.KeysInitQuery.dataFactory), 'remove' in destination ? destination : destination.value)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfUpdateQuadsRdfJsStore;
}($8UQh4.ActorRdfUpdateQuadsDestination);
module.exports.ActorRdfUpdateQuadsRdfJsStore = $858a1fd79268cbef$var$ActorRdfUpdateQuadsRdfJsStore;

});
parcelRegister("8UQh4", function(module, exports) {
"use strict";
var $67dc1a4e9563fe4e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $67dc1a4e9563fe4e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $67dc1a4e9563fe4e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$67dc1a4e9563fe4e$var$__exportStar((parcelRequire("aWbHd")), module.exports);

$67dc1a4e9563fe4e$var$__exportStar((parcelRequire("cisL9")), module.exports);

$67dc1a4e9563fe4e$var$__exportStar((parcelRequire("ddVUK")), module.exports);

$67dc1a4e9563fe4e$var$__exportStar((parcelRequire("cC5Am")), module.exports);

});
parcelRegister("aWbHd", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuads = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-update-quads events.
 *
 * Actor types:
 * * Input:  IActionRdfUpdateQuads:      Quad insertion and deletion streams.
 * * Test:   <none>
 * * Output: IActorRdfUpdateQuadsOutput: A promise resolving when the update operation is done.
 *
 * @see IActionRdfUpdateQuads
 * @see IActorRdfUpdateQuadsOutput
 */ var $7f6864c4304f63cb$var$ActorRdfUpdateQuads = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfUpdateQuads, _core_1_Actor);
    function ActorRdfUpdateQuads(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateQuads);
        return (0, $kzDuW._)(this, ActorRdfUpdateQuads, [
            args
        ]);
    }
    return ActorRdfUpdateQuads;
}($kNNoa.Actor);
module.exports.ActorRdfUpdateQuads = $7f6864c4304f63cb$var$ActorRdfUpdateQuads;

});

parcelRegister("cisL9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsDestination = module.exports.deskolemize = module.exports.deskolemizeStream = void 0;

var $8rRId = parcelRequire("8rRId");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $aWbHd = parcelRequire("aWbHd");
function $8f3d79807fab01db$var$deskolemizeStream(dataFactory, stream, id) {
    return stream === null || stream === void 0 ? void 0 : stream.map(function(quad) {
        return (0, $8rRId.deskolemizeQuad)(dataFactory, quad, id);
    });
}
module.exports.deskolemizeStream = $8f3d79807fab01db$var$deskolemizeStream;
function $8f3d79807fab01db$var$deskolemize(action) {
    var _action_context_get;
    var dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
    var destination = action.context.get($9nBhR.KeysRdfUpdateQuads.destination);
    var id = (_action_context_get = action.context.get($9nBhR.KeysQuerySourceIdentify.sourceIds)) === null || _action_context_get === void 0 ? void 0 : _action_context_get.get(destination);
    if (!id) return action;
    return (0, $emQHU._)((0, $iT0je._)({}, action), {
        quadStreamInsert: $8f3d79807fab01db$var$deskolemizeStream(dataFactory, action.quadStreamInsert, id),
        quadStreamDelete: $8f3d79807fab01db$var$deskolemizeStream(dataFactory, action.quadStreamDelete, id)
    });
}
module.exports.deskolemize = $8f3d79807fab01db$var$deskolemize;
/**
 * A base implementation for rdf-update-quads events
 * that wraps around an {@link IQuadDestination}.
 *
 * @see IQuadDestination
 */ var $8f3d79807fab01db$var$ActorRdfUpdateQuadsDestination = /*#__PURE__*/ function(_ActorRdfUpdateQuads_1_ActorRdfUpdateQuads) {
    (0, $i3fW3._)(ActorRdfUpdateQuadsDestination, _ActorRdfUpdateQuads_1_ActorRdfUpdateQuads);
    function ActorRdfUpdateQuadsDestination() {
        (0, $jGAMp._)(this, ActorRdfUpdateQuadsDestination);
        return (0, $kzDuW._)(this, ActorRdfUpdateQuadsDestination, arguments);
    }
    (0, $byiyg._)(ActorRdfUpdateQuadsDestination, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var destination;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getDestination(action.context)
                                ];
                            case 1:
                                destination = _state.sent();
                                return [
                                    4,
                                    this.getOutput(destination, $8f3d79807fab01db$var$deskolemize(action))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: /**
     * Get the output of the given action on a destination.
     * @param {IQuadDestination} destination A quad destination, possibly lazy.
     * @param {IActionRdfUpdateQuads} action The action.
     */ function getOutput(destination, action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        execute = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                destination.update({
                                                    insert: action.quadStreamInsert,
                                                    "delete": action.quadStreamDelete
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                action.deleteGraphs ? destination.deleteGraphs(action.deleteGraphs.graphs, action.deleteGraphs.requireExistence, action.deleteGraphs.dropGraphs) : Promise.resolve()
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                4,
                                                action.createGraphs ? destination.createGraphs(action.createGraphs.graphs, action.createGraphs.requireNonExistence) : Promise.resolve()
                                            ];
                                        case 3:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        };
                        return [
                            2,
                            {
                                execute: execute
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfUpdateQuadsDestination;
}($aWbHd.ActorRdfUpdateQuads);
module.exports.ActorRdfUpdateQuadsDestination = $8f3d79807fab01db$var$ActorRdfUpdateQuadsDestination;

});

parcelRegister("ddVUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cC5Am", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getContextDestinationUrl = module.exports.getContextDestination = module.exports.getDataDestinationContext = module.exports.getDataDestinationValue = module.exports.getDataDestinationType = module.exports.isDataDestinationRawType = void 0;

var $9nBhR = parcelRequire("9nBhR");
/**
 * Check if the given data destination is a string or RDF store.
 * @param dataDestination A data destination.
 */ function $92ed5dd060f0182b$var$isDataDestinationRawType(dataDestination) {
    return typeof dataDestination === 'string' || 'remove' in dataDestination;
}
module.exports.isDataDestinationRawType = $92ed5dd060f0182b$var$isDataDestinationRawType;
/**
 * Get the data destination type.
 * @param dataDestination A data destination.
 */ function $92ed5dd060f0182b$var$getDataDestinationType(dataDestination) {
    if (typeof dataDestination === 'string') return '';
    return 'remove' in dataDestination ? 'rdfjsStore' : dataDestination.type;
}
module.exports.getDataDestinationType = $92ed5dd060f0182b$var$getDataDestinationType;
/**
 * Get the data destination value.
 * @param dataDestination A data destination.
 */ function $92ed5dd060f0182b$var$getDataDestinationValue(dataDestination) {
    return $92ed5dd060f0182b$var$isDataDestinationRawType(dataDestination) ? dataDestination : dataDestination.value;
}
module.exports.getDataDestinationValue = $92ed5dd060f0182b$var$getDataDestinationValue;
/**
 * Get the context of the given destination, merged with the given context.
 * @param dataDestination A data destination.
 * @param context A context to merge with.
 */ function $92ed5dd060f0182b$var$getDataDestinationContext(dataDestination, context) {
    if (typeof dataDestination === 'string' || 'remove' in dataDestination || !dataDestination.context) return context;
    return context.merge(dataDestination.context);
}
module.exports.getDataDestinationContext = $92ed5dd060f0182b$var$getDataDestinationContext;
/**
 * Get the source destination from the given context.
 * @param {ActionContext} context An optional context.
 * @return {IDataDestination} The destination or undefined.
 */ function $92ed5dd060f0182b$var$getContextDestination(context) {
    return context.get($9nBhR.KeysRdfUpdateQuads.destination);
}
module.exports.getContextDestination = $92ed5dd060f0182b$var$getContextDestination;
/**
 * Get the destination's raw URL value from the given context.
 * @param {IDataDestination} destination A destination.
 * @return {string} The URL or undefined.
 */ function $92ed5dd060f0182b$var$getContextDestinationUrl(destination) {
    if (destination) {
        var fileUrl = $92ed5dd060f0182b$var$getDataDestinationValue(destination);
        if (typeof fileUrl === 'string') {
            // Remove hashes from source
            var hashPosition = fileUrl.indexOf('#');
            if (hashPosition >= 0) fileUrl = fileUrl.slice(0, hashPosition);
            return fileUrl;
        }
    }
}
module.exports.getContextDestinationUrl = $92ed5dd060f0182b$var$getContextDestinationUrl;

});


parcelRegister("cjofa", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfJsQuadDestination = void 0;

var $3sgrk = parcelRequire("3sgrk");

var $gQYIc = parcelRequire("gQYIc");
/**
 * A quad destination that wraps around an {@link RDF.Store}.
 */ var $8f6a10a9c0807bce$var$RdfJsQuadDestination = /*#__PURE__*/ function() {
    function RdfJsQuadDestination(dataFactory, store) {
        (0, $jGAMp._)(this, RdfJsQuadDestination);
        this.dataFactory = dataFactory;
        this.store = store;
    }
    (0, $byiyg._)(RdfJsQuadDestination, [
        {
            key: "update",
            value: function update(quadStreams) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!quadStreams["delete"]) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3sgrk.promisifyEventEmitter)(this.store.remove(quadStreams["delete"]))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!quadStreams.insert) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0, $3sgrk.promisifyEventEmitter)(this.store["import"](quadStreams.insert))
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteGraphs",
            value: function deleteGraphs(graphs, _requireExistence, _dropGraphs) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, allQuads, namedGraphs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, graph, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                switch(graphs){
                                    case 'ALL':
                                        return [
                                            3,
                                            1
                                        ];
                                    case 'NAMED':
                                        return [
                                            3,
                                            3
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 1:
                                /* eslint-disable no-fallthrough */ // Remove the default graph
                                return [
                                    4,
                                    (0, $3sgrk.promisifyEventEmitter)(this.store.deleteGraph(this.dataFactory.defaultGraph()))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                /* eslint-enable no-fallthrough */ // Warning: this is sub-optimal!
                                // Query ALL quads to determine all named graphs
                                // eslint-disable-next-line no-case-declarations
                                allQuads = this.store.match();
                                // eslint-disable-next-line no-case-declarations
                                namedGraphs = {};
                                allQuads.on('data', function(quad) {
                                    if (quad.graph.termType !== 'DefaultGraph') namedGraphs[(0, $gQYIc.termToString)(quad.graph)] = true;
                                });
                                return [
                                    4,
                                    (0, $3sgrk.promisifyEventEmitter)(allQuads)
                                ];
                            case 4:
                                _state.sent();
                                // Delete all named graphs
                                return [
                                    4,
                                    Promise.all(Object.keys(namedGraphs).map(function(namedGraph) {
                                        return (0, $3sgrk.promisifyEventEmitter)(_this.store.deleteGraph((0, $gQYIc.stringToTerm)(namedGraph, _this.dataFactory)));
                                    }))
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    14
                                ];
                            case 6:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 7;
                            case 7:
                                _state.trys.push([
                                    7,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator = (Array.isArray(graphs) ? graphs : [
                                    graphs
                                ])[Symbol.iterator]();
                                _state.label = 8;
                            case 8:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    11
                                ];
                                graph = _step.value;
                                return [
                                    4,
                                    (0, $3sgrk.promisifyEventEmitter)(this.store.deleteGraph(graph))
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    8
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createGraphs",
            value: function createGraphs(graphs, requireNonExistence) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this, _loop, _iterator, _step, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!requireNonExistence) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var graph, eventEmitter;
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                graph = _step.value;
                                                eventEmitter = _this.store.match(undefined, undefined, undefined, graph);
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        eventEmitter.once('data', function() {
                                                            reject(new Error("Unable to create graph ".concat(graph.value, " as it already exists")));
                                                        });
                                                        eventEmitter.on('end', resolve);
                                                        eventEmitter.on('error', reject);
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = graphs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this = this;
                                return [
                                    5,
                                    (0, $9N5UN.__values)(_loop())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return RdfJsQuadDestination;
}();
module.exports.RdfJsQuadDestination = $8f6a10a9c0807bce$var$RdfJsQuadDestination;

});



parcelRegister("fTJn2", function(module, exports) {
"use strict";
var $b92f2fb73367c276$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b92f2fb73367c276$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b92f2fb73367c276$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b92f2fb73367c276$var$__exportStar((parcelRequire("8fbJV")), module.exports);

});
parcelRegister("8fbJV", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionBnode = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $jtSs1 = parcelRequire("jtSs1");
/**
 * A comunica ExpressionFunctionBnode Function Factory Actor.
 */ var $6008d4b0cfe8829c$var$ActorFunctionFactoryExpressionBnode = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionBnode, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionBnode(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionBnode);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionBnode, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.BNODE
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionBnode, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $jtSs1.ExpressionFunctionBnode()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionBnode;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionBnode = $6008d4b0cfe8829c$var$ActorFunctionFactoryExpressionBnode;

});
parcelRegister("jtSs1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionBnode = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $ck9FR = parcelRequire("ck9FR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-bnode
 * id has to be distinct over all id's in dataset
 */ var $e2eaf693d70248e4$var$ExpressionFunctionBnode = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionBnode, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionBnode() {
        (0, $jGAMp._)(this, ExpressionFunctionBnode);
        return (0, $kzDuW._)(this, ExpressionFunctionBnode, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: $aduX6.SparqlOperator.BNODE,
                apply: function(context) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var args, mapping, exprEval, input, _tmp, strInput, operation, bnode;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    args = context.args, mapping = context.mapping, exprEval = context.exprEval;
                                    if (!(args.length === 1)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(args[0], mapping)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    _tmp = undefined;
                                    _state.label = 3;
                                case 3:
                                    input = _tmp;
                                    if (input) {
                                        operation = ExpressionFunctionBnode.bnodeTree.search([
                                            input
                                        ], exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider), exprEval.context.getSafe($9nBhR.KeysInitQuery.functionArgumentsCache));
                                        if (!operation) throw new $aduX6.InvalidArgumentTypes(args, $aduX6.SparqlOperator.BNODE);
                                        strInput = operation(exprEval)([
                                            input
                                        ]).str();
                                    }
                                    bnode = new $ck9FR.BlankNodeBindingsScoped(strInput !== null && strInput !== void 0 ? strInput : "BNODE_".concat(ExpressionFunctionBnode.bnodeCounter++));
                                    return [
                                        2,
                                        new $aduX6.BlankNode(bnode)
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    (0, $byiyg._)(ExpressionFunctionBnode, [
        {
            key: "checkArity",
            value: function checkArity(args) {
                return args.length === 0 || args.length === 1;
            }
        }
    ]);
    return ExpressionFunctionBnode;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionBnode = $e2eaf693d70248e4$var$ExpressionFunctionBnode;
/**
 * This OverloadTree with the constant function will handle both type promotion and subtype-substitution
 */ $e2eaf693d70248e4$var$ExpressionFunctionBnode.bnodeTree = (0, $aduX6.declare)($aduX6.SparqlOperator.BNODE).onString1(function() {
    return function(arg) {
        return arg;
    };
}).collect();
/**
 * A counter that keeps track blank node generated through BNODE() SPARQL
 * expressions.
 */ $e2eaf693d70248e4$var$ExpressionFunctionBnode.bnodeCounter = 0;

});



parcelRegister("kcyoh", function(module, exports) {
"use strict";
var $eb4f9aeaecbfa144$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb4f9aeaecbfa144$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eb4f9aeaecbfa144$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$eb4f9aeaecbfa144$var$__exportStar((parcelRequire("4UBNm")), module.exports);

});
parcelRegister("4UBNm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionBound = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $4QrbW = parcelRequire("4QrbW");
/**
 * A comunica ExpressionFunctionBound Function Factory Actor.
 */ var $3939b5b7b7f8172e$var$ActorFunctionFactoryExpressionBound = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionBound, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionBound(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionBound);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionBound, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.BOUND
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionBound, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $4QrbW.ExpressionFunctionBound()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionBound;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionBound = $3939b5b7b7f8172e$var$ActorFunctionFactoryExpressionBound;

});
parcelRegister("4QrbW", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionBound = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $gIvya = parcelRequire("gIvya");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-bound
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $38711c711af58826$var$ExpressionFunctionBound = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionBound, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionBound() {
        (0, $jGAMp._)(this, ExpressionFunctionBound);
        return (0, $kzDuW._)(this, ExpressionFunctionBound, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.BOUND,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var variable, val;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            variable = args[0];
                            if (variable.expressionType !== $gIvya.ExpressionType.Variable) throw new $aduX6.InvalidArgumentTypes(args, $aduX6.SparqlOperator.BOUND);
                            val = mapping.has((0, $aduX6.expressionToVar)(exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory), variable));
                            return [
                                2,
                                (0, $aduX6.bool)(val)
                            ];
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionBound;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionBound = $38711c711af58826$var$ExpressionFunctionBound;

});



parcelRegister("g1xTT", function(module, exports) {
"use strict";
var $0302b1b2bb958864$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0302b1b2bb958864$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0302b1b2bb958864$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0302b1b2bb958864$var$__exportStar((parcelRequire("a0BnH")), module.exports);

});
parcelRegister("a0BnH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionCoalesce = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dqjpI = parcelRequire("dqjpI");
/**
 * A comunica ExpressionFunctionCoalesce Function Factory Actor.
 */ var $7496e69a14ff9a1b$var$ActorFunctionFactoryExpressionCoalesce = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionCoalesce, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionCoalesce(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionCoalesce);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionCoalesce, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.COALESCE
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionCoalesce, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $dqjpI.ExpressionFunctionCoalesce()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionCoalesce;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionCoalesce = $7496e69a14ff9a1b$var$ActorFunctionFactoryExpressionCoalesce;

});
parcelRegister("dqjpI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionCoalesce = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-coalesce
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $0285a00d606381d3$var$ExpressionFunctionCoalesce = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionCoalesce, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionCoalesce() {
        (0, $jGAMp._)(this, ExpressionFunctionCoalesce);
        return (0, $kzDuW._)(this, ExpressionFunctionCoalesce, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: $aduX6.SparqlOperator.COALESCE,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, expr, error, err;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    errors = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        8,
                                        9,
                                        10
                                    ]);
                                    _iterator = args[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        7
                                    ];
                                    expr = _step.value;
                                    _state.label = 3;
                                case 3:
                                    _state.trys.push([
                                        3,
                                        5,
                                        ,
                                        6
                                    ]);
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(expr, mapping)
                                    ];
                                case 4:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 5:
                                    error = _state.sent();
                                    errors.push(error);
                                    return [
                                        3,
                                        6
                                    ];
                                case 6:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 7:
                                    return [
                                        3,
                                        10
                                    ];
                                case 8:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        10
                                    ];
                                case 9:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 10:
                                    throw new $aduX6.CoalesceError(errors);
                            }
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionCoalesce;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionCoalesce = $0285a00d606381d3$var$ExpressionFunctionCoalesce;

});



parcelRegister("fEb1l", function(module, exports) {
"use strict";
var $b64323e679dfbed9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b64323e679dfbed9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b64323e679dfbed9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b64323e679dfbed9$var$__exportStar((parcelRequire("8NhRz")), module.exports);

});
parcelRegister("8NhRz", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionConcat = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $UJmiv = parcelRequire("UJmiv");
/**
 * A comunica ExpressionFunctionConcat Function Factory Actor.
 */ var $6670c195ac1b3d10$var$ActorFunctionFactoryExpressionConcat = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionConcat, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionConcat(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionConcat);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionConcat, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.CONCAT
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionConcat, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $UJmiv.ExpressionFunctionConcat()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionConcat;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionConcat = $6670c195ac1b3d10$var$ActorFunctionFactoryExpressionConcat;

});
parcelRegister("UJmiv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionConcat = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-concat
 */ var $0aa86a5ba7f2de02$var$ExpressionFunctionConcat = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionConcat, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionConcat() {
        (0, $jGAMp._)(this, ExpressionFunctionConcat);
        return (0, $kzDuW._)(this, ExpressionFunctionConcat, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: $aduX6.SparqlOperator.CONCAT,
                apply: function(context) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var args, mapping, exprEval, pLits, lits, strings, joined, lang;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    args = context.args, mapping = context.mapping, exprEval = context.exprEval;
                                    pLits = args.map(function(expr) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    exprEval.evaluatorExpressionEvaluation(expr, mapping)
                                                ];
                                            });
                                        })();
                                    }).map(function(pTerm) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var operation, _, _1, _2;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _1 = (_ = ExpressionFunctionConcat.concatTree).search;
                                                        return [
                                                            4,
                                                            pTerm
                                                        ];
                                                    case 1:
                                                        operation = _1.apply(_, [
                                                            [
                                                                _state.sent()
                                                            ],
                                                            exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider),
                                                            exprEval.context.getSafe($9nBhR.KeysInitQuery.functionArgumentsCache)
                                                        ]);
                                                        if (!operation) throw new $aduX6.InvalidArgumentTypes(args, $aduX6.SparqlOperator.CONCAT);
                                                        _2 = operation(exprEval);
                                                        return [
                                                            4,
                                                            pTerm
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _2.apply(void 0, [
                                                                [
                                                                    _state.sent()
                                                                ]
                                                            ])
                                                        ];
                                                }
                                            });
                                        })();
                                    });
                                    return [
                                        4,
                                        Promise.all(pLits)
                                    ];
                                case 1:
                                    lits = _state.sent();
                                    strings = lits.map(function(lit) {
                                        return lit.typedValue;
                                    });
                                    joined = strings.join('');
                                    lang = ExpressionFunctionConcat.langAllEqual(lits) ? lits[0].language : undefined;
                                    return [
                                        2,
                                        lang ? (0, $aduX6.langString)(joined, lang) : (0, $aduX6.string)(joined)
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    (0, $byiyg._)(ExpressionFunctionConcat, null, [
        {
            key: "langAllEqual",
            value: function langAllEqual(lits) {
                return lits.length > 0 && lits.every(function(lit) {
                    return lit.language === lits[0].language;
                });
            }
        }
    ]);
    return ExpressionFunctionConcat;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionConcat = $0aa86a5ba7f2de02$var$ExpressionFunctionConcat;
/**
 * This OverloadTree with the constant function will handle both type promotion and subtype-substitution
 */ $0aa86a5ba7f2de02$var$ExpressionFunctionConcat.concatTree = (0, $aduX6.declare)($aduX6.SparqlOperator.CONCAT).onStringly1(function() {
    return function(expr) {
        return expr;
    };
}).collect();

});



parcelRegister("fzdBt", function(module, exports) {
"use strict";
var $b554ad3c3472f446$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b554ad3c3472f446$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b554ad3c3472f446$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b554ad3c3472f446$var$__exportStar((parcelRequire("iXNMg")), module.exports);

});
parcelRegister("iXNMg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionExtensions = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2ej16 = parcelRequire("2ej16");

var $9VlYX = parcelRequire("9VlYX");
/**
 * A comunica Expression Function Extensions Function Factory Actor.
 */ var $dce459726c3c71ca$var$ActorFunctionFactoryExpressionExtensions = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactory) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionExtensions, _bus_function_factory_1_ActorFunctionFactory);
    function ActorFunctionFactoryExpressionExtensions(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionExtensions);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionExtensions, [
            args
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionExtensions, [
        {
            key: "test",
            value: function test(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, functionName, extensionFinder, definition;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, functionName = param.functionName;
                                extensionFinder = context.getSafe($9nBhR.KeysExpressionEvaluator.extensionFunctionCreator);
                                return [
                                    4,
                                    extensionFinder(new $2ej16.DataFactory().namedNode(functionName))
                                ];
                            case 1:
                                definition = _state.sent();
                                if (definition) return [
                                    2,
                                    (0, $kNNoa.passTestVoid)()
                                ];
                                return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only provide non-termExpression implementations for functions that are provided through config entries like: ").concat($9nBhR.KeysInitQuery.extensionFunctionCreator.name, " or ").concat($9nBhR.KeysInitQuery.extensionFunctions.name))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, functionName, extensionFinder, definition;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, functionName = param.functionName;
                                extensionFinder = context.getSafe($9nBhR.KeysExpressionEvaluator.extensionFunctionCreator);
                                return [
                                    4,
                                    extensionFinder(new $2ej16.DataFactory().namedNode(functionName))
                                ];
                            case 1:
                                definition = _state.sent();
                                return [
                                    2,
                                    new $9VlYX.NamedExtension({
                                        operator: functionName,
                                        functionDefinition: definition
                                    })
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorFunctionFactoryExpressionExtensions;
}($1W2eA.ActorFunctionFactory);
module.exports.ActorFunctionFactoryExpressionExtensions = $dce459726c3c71ca$var$ActorFunctionFactoryExpressionExtensions;

});
parcelRegister("9VlYX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedExtension = void 0;

var $3Novs = parcelRequire("3Novs");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
var $739a7d20a1cd2b11$var$NamedExtension = /*#__PURE__*/ function(_Core_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(NamedExtension, _Core_1_ExpressionFunctionBase);
    function NamedExtension(param) {
        var operator = param.operator, functionDefinition = param.functionDefinition;
        (0, $jGAMp._)(this, NamedExtension);
        var _this;
        var _this1;
        _this = (0, $kzDuW._)(this, NamedExtension, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: operator,
                apply: function(param) {
                    var args = param.args, exprEval = param.exprEval, mapping = param.mapping;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var evaluatedArgs, _, _1, error;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        Promise.all(args.map(function(arg) {
                                            return exprEval.evaluatorExpressionEvaluation(arg, mapping);
                                        }))
                                    ];
                                case 1:
                                    evaluatedArgs = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]);
                                    _1 = (_ = new $aduX6.TermTransformer(exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider))).transformRDFTermUnsafe;
                                    return [
                                        4,
                                        functionDefinition(evaluatedArgs.map(function(term) {
                                            return term.toRDF(exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory));
                                        }))
                                    ];
                                case 3:
                                    return [
                                        2,
                                        _1.apply(_, [
                                            _state.sent()
                                        ])
                                    ];
                                case 4:
                                    error = _state.sent();
                                    throw new $aduX6.ExtensionFunctionError(_this1.operator, error);
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }
        ]), _this1 = _this;
        return _this;
    }
    return NamedExtension;
}($3Novs.ExpressionFunctionBase);
module.exports.NamedExtension = $739a7d20a1cd2b11$var$NamedExtension;

});



parcelRegister("9Sd9e", function(module, exports) {
"use strict";
var $73035b1ce1199ab9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $73035b1ce1199ab9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $73035b1ce1199ab9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$73035b1ce1199ab9$var$__exportStar((parcelRequire("jG8gm")), module.exports);

});
parcelRegister("jG8gm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionIf = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $4AFhG = parcelRequire("4AFhG");
/**
 * A comunica ExpressionFunctionIf Function Factory Actor.
 */ var $e53859691ecacc02$var$ActorFunctionFactoryExpressionIf = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionIf, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionIf(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionIf);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionIf, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IF
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionIf, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $4AFhG.ExpressionFunctionIf()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionIf;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionIf = $e53859691ecacc02$var$ActorFunctionFactoryExpressionIf;

});
parcelRegister("4AFhG", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionIf = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-if
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $357a8c64b04a1dda$var$ExpressionFunctionIf = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionIf, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionIf() {
        (0, $jGAMp._)(this, ExpressionFunctionIf);
        return (0, $kzDuW._)(this, ExpressionFunctionIf, [
            {
                arity: 3,
                operator: $aduX6.SparqlOperator.IF,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var valFirst, ebv;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(args[0], mapping)
                                    ];
                                case 1:
                                    valFirst = _state.sent();
                                    ebv = valFirst.coerceEBV();
                                    return [
                                        2,
                                        ebv ? exprEval.evaluatorExpressionEvaluation(args[1], mapping) : exprEval.evaluatorExpressionEvaluation(args[2], mapping)
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionIf;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionIf = $357a8c64b04a1dda$var$ExpressionFunctionIf;

});



parcelRegister("lXYT0", function(module, exports) {
"use strict";
var $ffde5663433481ba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ffde5663433481ba$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ffde5663433481ba$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ffde5663433481ba$var$__exportStar((parcelRequire("bPpQn")), module.exports);

});
parcelRegister("bPpQn", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionLogicalAnd = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $juYkH = parcelRequire("juYkH");
/**
 * A comunica ExpressionFunctionLogicalAnd Function Factory Actor.
 */ var $89c881313f299a0d$var$ActorFunctionFactoryExpressionLogicalAnd = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionLogicalAnd, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionLogicalAnd(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionLogicalAnd);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionLogicalAnd, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LOGICAL_AND
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionLogicalAnd, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $juYkH.ExpressionFunctionLogicalAnd()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionLogicalAnd;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionLogicalAnd = $89c881313f299a0d$var$ActorFunctionFactoryExpressionLogicalAnd;

});
parcelRegister("juYkH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionLogicalAnd = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-logical-and
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $e31f9e7cbb1228f0$var$ExpressionFunctionLogicalAnd = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionLogicalAnd, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionLogicalAnd() {
        (0, $jGAMp._)(this, ExpressionFunctionLogicalAnd);
        return (0, $kzDuW._)(this, ExpressionFunctionLogicalAnd, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.LOGICAL_AND,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var _args, leftExpr, rightExpr, leftTerm, left, rightTerm, right, error, rightErrorTerm, rightError;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _args = (0, $32TW8._)(args, 2), leftExpr = _args[0], rightExpr = _args[1];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        6
                                    ]);
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(leftExpr, mapping)
                                    ];
                                case 2:
                                    leftTerm = _state.sent();
                                    left = leftTerm.coerceEBV();
                                    if (!left) return [
                                        2,
                                        (0, $aduX6.bool)(false)
                                    ];
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(rightExpr, mapping)
                                    ];
                                case 3:
                                    rightTerm = _state.sent();
                                    right = rightTerm.coerceEBV();
                                    return [
                                        2,
                                        (0, $aduX6.bool)(right)
                                    ];
                                case 4:
                                    error = _state.sent();
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(rightExpr, mapping)
                                    ];
                                case 5:
                                    rightErrorTerm = _state.sent();
                                    rightError = rightErrorTerm.coerceEBV();
                                    if (rightError) throw error;
                                    return [
                                        2,
                                        (0, $aduX6.bool)(false)
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionLogicalAnd;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionLogicalAnd = $e31f9e7cbb1228f0$var$ExpressionFunctionLogicalAnd;

});



parcelRegister("g12h3", function(module, exports) {
"use strict";
var $ba8e80ec3d792bb0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba8e80ec3d792bb0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba8e80ec3d792bb0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba8e80ec3d792bb0$var$__exportStar((parcelRequire("gHhX4")), module.exports);

});
parcelRegister("gHhX4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionLogicalOr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $8lseC = parcelRequire("8lseC");
/**
 * A comunica ExpressionFunctionLogicalOr Function Factory Actor.
 */ var $c27e9651b947a60f$var$ActorFunctionFactoryExpressionLogicalOr = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionLogicalOr, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionLogicalOr(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionLogicalOr);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionLogicalOr, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LOGICAL_OR
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionLogicalOr, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $8lseC.ExpressionFunctionLogicalOr()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionLogicalOr;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionLogicalOr = $c27e9651b947a60f$var$ActorFunctionFactoryExpressionLogicalOr;

});
parcelRegister("8lseC", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionLogicalOr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-logical-or
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $61362fbfe5d794f8$var$ExpressionFunctionLogicalOr = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionLogicalOr, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionLogicalOr() {
        (0, $jGAMp._)(this, ExpressionFunctionLogicalOr);
        return (0, $kzDuW._)(this, ExpressionFunctionLogicalOr, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.LOGICAL_OR,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var _args, leftExpr, rightExpr, leftTerm, left, rightTerm, right, error, rightErrorTerm, rightError;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _args = (0, $32TW8._)(args, 2), leftExpr = _args[0], rightExpr = _args[1];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        6
                                    ]);
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(leftExpr, mapping)
                                    ];
                                case 2:
                                    leftTerm = _state.sent();
                                    left = leftTerm.coerceEBV();
                                    if (left) return [
                                        2,
                                        (0, $aduX6.bool)(true)
                                    ];
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(rightExpr, mapping)
                                    ];
                                case 3:
                                    rightTerm = _state.sent();
                                    right = rightTerm.coerceEBV();
                                    return [
                                        2,
                                        (0, $aduX6.bool)(right)
                                    ];
                                case 4:
                                    error = _state.sent();
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(rightExpr, mapping)
                                    ];
                                case 5:
                                    rightErrorTerm = _state.sent();
                                    rightError = rightErrorTerm.coerceEBV();
                                    if (!rightError) throw error;
                                    return [
                                        2,
                                        (0, $aduX6.bool)(true)
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionLogicalOr;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionLogicalOr = $61362fbfe5d794f8$var$ExpressionFunctionLogicalOr;

});



parcelRegister("eIuJ6", function(module, exports) {
"use strict";
var $ab6d025eb4b68926$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab6d025eb4b68926$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ab6d025eb4b68926$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ab6d025eb4b68926$var$__exportStar((parcelRequire("i8xMP")), module.exports);

});
parcelRegister("i8xMP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionSameTerm = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $EAhoF = parcelRequire("EAhoF");
/**
 * A comunica ExpressionFunctionSameTerm Function Factory Actor.
 */ var $d3432ead20913612$var$ActorFunctionFactoryExpressionSameTerm = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionSameTerm, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionSameTerm(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionSameTerm);
        return (0, $kzDuW._)(this, ActorFunctionFactoryExpressionSameTerm, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SAME_TERM
                ],
                termFunction: false
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionSameTerm, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $EAhoF.ExpressionFunctionSameTerm()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryExpressionSameTerm;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionSameTerm = $d3432ead20913612$var$ActorFunctionFactoryExpressionSameTerm;

});
parcelRegister("EAhoF", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionSameTerm = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sameTerm
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $079fe0e9dd8d4f31$var$ExpressionFunctionSameTerm = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionSameTerm, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionSameTerm() {
        (0, $jGAMp._)(this, ExpressionFunctionSameTerm);
        return (0, $kzDuW._)(this, ExpressionFunctionSameTerm, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.SAME_TERM,
                apply: function(param) {
                    var args = param.args, mapping = param.mapping, exprEval = param.exprEval;
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var dataFactory, _args_map, leftExpr, rightExpr, _ref, left, right;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dataFactory = exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                    _args_map = (0, $32TW8._)(args.map(function(arg) {
                                        return exprEval.evaluatorExpressionEvaluation(arg, mapping);
                                    }), 2), leftExpr = _args_map[0], rightExpr = _args_map[1];
                                    return [
                                        4,
                                        Promise.all([
                                            leftExpr,
                                            rightExpr
                                        ])
                                    ];
                                case 1:
                                    _ref = (0, $32TW8._).apply(void 0, [
                                        _state.sent(),
                                        2
                                    ]), left = _ref[0], right = _ref[1];
                                    return [
                                        2,
                                        (0, $aduX6.bool)(left.toRDF(dataFactory).equals(right.toRDF(dataFactory)))
                                    ];
                            }
                        });
                    })();
                }
            }
        ]);
    }
    return ExpressionFunctionSameTerm;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionSameTerm = $079fe0e9dd8d4f31$var$ExpressionFunctionSameTerm;

});



parcelRegister("gpQB3", function(module, exports) {
"use strict";
var $bf37c7b9fa12ff98$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf37c7b9fa12ff98$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bf37c7b9fa12ff98$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bf37c7b9fa12ff98$var$__exportStar((parcelRequire("j4YFj")), module.exports);

});
parcelRegister("j4YFj", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermAbs = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $l5e3I = parcelRequire("l5e3I");
/**
 * A comunica TermFunctionAbs Function Factory Actor.
 */ var $de3d72ed61a2eab3$var$ActorFunctionFactoryTermAbs = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermAbs, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermAbs(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermAbs);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermAbs, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.ABS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermAbs, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $l5e3I.TermFunctionAbs()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermAbs;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermAbs = $de3d72ed61a2eab3$var$ActorFunctionFactoryTermAbs;

});
parcelRegister("l5e3I", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionAbs = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-abs
 */ var $f594f8704a1afca4$var$TermFunctionAbs = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionAbs, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionAbs() {
        (0, $jGAMp._)(this, TermFunctionAbs);
        return (0, $kzDuW._)(this, TermFunctionAbs, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.ABS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.ABS).numericConverter(function() {
                    return function(num) {
                        return Math.abs(num);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionAbs;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionAbs = $f594f8704a1afca4$var$TermFunctionAbs;

});



parcelRegister("hGtWh", function(module, exports) {
"use strict";
var $cdfd952bc8f92a45$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cdfd952bc8f92a45$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cdfd952bc8f92a45$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cdfd952bc8f92a45$var$__exportStar((parcelRequire("kh4R0")), module.exports);

});
parcelRegister("kh4R0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermAddition = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $3Vu2J = parcelRequire("3Vu2J");
/**
 * A comunica TermFunctionAddition Function Factory Actor.
 */ var $ec2929179bd5b254$var$ActorFunctionFactoryTermAddition = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermAddition, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermAddition(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermAddition);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermAddition, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.ADDITION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermAddition, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $3Vu2J.TermFunctionAddition()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermAddition;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermAddition = $ec2929179bd5b254$var$ActorFunctionFactoryTermAddition;

});
parcelRegister("3Vu2J", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionAddition = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $56IvR = parcelRequire("56IvR");
var $2dbdffe2e2f9acea$var$TermFunctionAddition = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionAddition, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionAddition() {
        (0, $jGAMp._)(this, TermFunctionAddition);
        return (0, $kzDuW._)(this, TermFunctionAddition, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.ADDITION,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.ADDITION).arithmetic(function() {
                    return function(left, right) {
                        return new $56IvR.BigNumber(left).plus(right).toNumber();
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DATE_TIME,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), date = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-dateTime
                        new $aduX6.DateTimeLiteral((0, $aduX6.addDurationToDateTime)(date.typedValue, (0, $aduX6.defaultedDurationRepresentation)(dur.typedValue))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_DATE,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), date = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-date
                        new $aduX6.DateLiteral((0, $aduX6.addDurationToDateTime)((0, $aduX6.defaultedDateTimeRepresentation)(date.typedValue), (0, $aduX6.defaultedDurationRepresentation)(dur.typedValue))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_TIME,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), time = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-time
                        new $aduX6.TimeLiteral((0, $aduX6.addDurationToDateTime)((0, $aduX6.defaultedDateTimeRepresentation)(time.typedValue), (0, $aduX6.defaultedDurationRepresentation)(dur.typedValue))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_TIME,
                        $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_TIME,
                        $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                    ]
                }).collect()
            }
        ]);
    }
    return TermFunctionAddition;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionAddition = $2dbdffe2e2f9acea$var$TermFunctionAddition;

});
parcelRegister("56IvR", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if ((typeof obj === "undefined" ? "undefined" : (0, $3KZcf._)(obj)) == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if ((typeof v === "undefined" ? "undefined" : (0, $3KZcf._)(v)) == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function random53bitInt() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne + (id === 2 && e > ne);
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && (typeof rm === "undefined" ? "undefined" : (0, $3KZcf._)(rm)) == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && (typeof dp === "undefined" ? "undefined" : (0, $3KZcf._)(dp)) == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if ((typeof format === "undefined" ? "undefined" : (0, $3KZcf._)(format)) != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(undefined);

});




parcelRegister("kKFFN", function(module, exports) {
"use strict";
var $f1b86df00e473123$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1b86df00e473123$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1b86df00e473123$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f1b86df00e473123$var$__exportStar((parcelRequire("fpun9")), module.exports);

});
parcelRegister("fpun9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermCeil = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $9RBIr = parcelRequire("9RBIr");
/**
 * A comunica TermFunctionCeil Function Factory Actor.
 */ var $b380c025e9179163$var$ActorFunctionFactoryTermCeil = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermCeil, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermCeil(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermCeil);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermCeil, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.CEIL
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermCeil, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $9RBIr.TermFunctionCeil()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermCeil;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermCeil = $b380c025e9179163$var$ActorFunctionFactoryTermCeil;

});
parcelRegister("9RBIr", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionCeil = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-ceil
 */ var $72e651e08a7a3150$var$TermFunctionCeil = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionCeil, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionCeil() {
        (0, $jGAMp._)(this, TermFunctionCeil);
        return (0, $kzDuW._)(this, TermFunctionCeil, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.CEIL,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.CEIL).numericConverter(function() {
                    return function(num) {
                        return Math.ceil(num);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionCeil;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionCeil = $72e651e08a7a3150$var$TermFunctionCeil;

});



parcelRegister("gePIu", function(module, exports) {
"use strict";
var $bd2611f7cbf7ffca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd2611f7cbf7ffca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bd2611f7cbf7ffca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bd2611f7cbf7ffca$var$__exportStar((parcelRequire("7p0ar")), module.exports);

});
parcelRegister("7p0ar", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermContains = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $8AoD3 = parcelRequire("8AoD3");
/**
 * A comunica TermFunctionContains Function Factory Actor.
 */ var $563aff70e745c50d$var$ActorFunctionFactoryTermContains = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermContains, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermContains(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermContains);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermContains, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.CONTAINS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermContains, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $8AoD3.TermFunctionContains()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermContains;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermContains = $563aff70e745c50d$var$ActorFunctionFactoryTermContains;

});
parcelRegister("8AoD3", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionContains = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-contains
 */ var $6404ca51d9aeff61$var$TermFunctionContains = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionContains, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionContains() {
        (0, $jGAMp._)(this, TermFunctionContains);
        return (0, $kzDuW._)(this, TermFunctionContains, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.CONTAINS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.CONTAINS).onBinaryTyped([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        return (0, $aduX6.bool)(arg1.includes(arg2));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(arg1, arg2) {
                        if (arg1.language !== arg2.language) throw new $aduX6.IncompatibleLanguageOperation(arg1, arg2);
                        return (0, $aduX6.bool)(arg1.typedValue.includes(arg2.typedValue));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionContains;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionContains = $6404ca51d9aeff61$var$TermFunctionContains;

});



parcelRegister("2bGm8", function(module, exports) {
"use strict";
var $197d76d9b49dce06$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $197d76d9b49dce06$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $197d76d9b49dce06$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$197d76d9b49dce06$var$__exportStar((parcelRequire("dRvBw")), module.exports);

});
parcelRegister("dRvBw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDatatype = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $86MdF = parcelRequire("86MdF");
/**
 * A comunica TermFunctionDatatype Function Factory Actor.
 */ var $a178bd84e519d08c$var$ActorFunctionFactoryTermDatatype = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermDatatype, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermDatatype(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermDatatype);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermDatatype, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.DATATYPE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermDatatype, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $86MdF.TermFunctionDatatype()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermDatatype;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermDatatype = $a178bd84e519d08c$var$ActorFunctionFactoryTermDatatype;

});
parcelRegister("86MdF", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDatatype = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-datatype
 */ var $5e7449a7a5ab705b$var$TermFunctionDatatype = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionDatatype, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionDatatype() {
        (0, $jGAMp._)(this, TermFunctionDatatype);
        return (0, $kzDuW._)(this, TermFunctionDatatype, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.DATATYPE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.DATATYPE).onLiteral1(function() {
                    return function(lit) {
                        return new $aduX6.NamedNode(lit.dataType);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionDatatype;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionDatatype = $5e7449a7a5ab705b$var$TermFunctionDatatype;

});



parcelRegister("esdDo", function(module, exports) {
"use strict";
var $a85e41bbdc0f8cd4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a85e41bbdc0f8cd4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a85e41bbdc0f8cd4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a85e41bbdc0f8cd4$var$__exportStar((parcelRequire("azqLI")), module.exports);

});
parcelRegister("azqLI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDay = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $4tGNP = parcelRequire("4tGNP");
/**
 * A comunica TermFunctionDay Function Factory Actor.
 */ var $7b21efeef384566e$var$ActorFunctionFactoryTermDay = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermDay, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermDay(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermDay);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermDay, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.DAY
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermDay, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $4tGNP.TermFunctionDay()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermDay;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermDay = $7b21efeef384566e$var$ActorFunctionFactoryTermDay;

});
parcelRegister("4tGNP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDay = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-day
 */ var $342b128de27c7cdf$var$TermFunctionDay = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionDay, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionDay() {
        (0, $jGAMp._)(this, TermFunctionDay);
        return (0, $kzDuW._)(this, TermFunctionDay, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.DAY,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.DAY).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.integer)(date.typedValue.day);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DATE
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), date = _param[0];
                        return (0, $aduX6.integer)(date.typedValue.day);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionDay;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionDay = $342b128de27c7cdf$var$TermFunctionDay;

});



parcelRegister("dOomI", function(module, exports) {
"use strict";
var $a0e2d85917b49608$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0e2d85917b49608$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a0e2d85917b49608$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a0e2d85917b49608$var$__exportStar((parcelRequire("iofJo")), module.exports);

});
parcelRegister("iofJo", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDivision = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $B40EP = parcelRequire("B40EP");
/**
 * A comunica TermFunctionDivision Function Factory Actor.
 */ var $d636abbfcb2258d1$var$ActorFunctionFactoryTermDivision = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermDivision, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermDivision(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermDivision);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermDivision, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.DIVISION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermDivision, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $B40EP.TermFunctionDivision()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermDivision;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermDivision = $d636abbfcb2258d1$var$ActorFunctionFactoryTermDivision;

});
parcelRegister("B40EP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDivision = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $56IvR = parcelRequire("56IvR");
var $06f6910a40faee00$var$TermFunctionDivision = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionDivision, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionDivision() {
        (0, $jGAMp._)(this, TermFunctionDivision);
        return (0, $kzDuW._)(this, TermFunctionDivision, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.DIVISION,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.DIVISION).arithmetic(function() {
                    return function(left, right) {
                        return new $56IvR.BigNumber(left).div(right).toNumber();
                    };
                }).onBinaryTyped([
                    $aduX6.TypeURL.XSD_INTEGER,
                    $aduX6.TypeURL.XSD_INTEGER
                ], function() {
                    return function(left, right) {
                        if (right === 0) throw new $aduX6.ExpressionError('Integer division by 0');
                        return (0, $aduX6.decimal)(new $56IvR.BigNumber(left).div(right).toNumber());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionDivision;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionDivision = $06f6910a40faee00$var$TermFunctionDivision;

});



parcelRegister("jD9Kl", function(module, exports) {
"use strict";
var $e4a9384c6e681576$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4a9384c6e681576$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e4a9384c6e681576$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e4a9384c6e681576$var$__exportStar((parcelRequire("kOG2U")), module.exports);

});
parcelRegister("kOG2U", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermEncodeForUri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $18wZ8 = parcelRequire("18wZ8");
/**
 * A comunica TermFunctionEncodeForUri Function Factory Actor.
 */ var $f279179e24d1d22e$var$ActorFunctionFactoryTermEncodeForUri = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermEncodeForUri, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermEncodeForUri(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermEncodeForUri);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermEncodeForUri, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.ENCODE_FOR_URI
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermEncodeForUri, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $18wZ8.TermFunctionEncodeForUri()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermEncodeForUri;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermEncodeForUri = $f279179e24d1d22e$var$ActorFunctionFactoryTermEncodeForUri;

});
parcelRegister("18wZ8", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionEncodeForUri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-encode
 */ var $0d401ff07b038a6b$var$TermFunctionEncodeForUri = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionEncodeForUri, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionEncodeForUri() {
        (0, $jGAMp._)(this, TermFunctionEncodeForUri);
        return (0, $kzDuW._)(this, TermFunctionEncodeForUri, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.ENCODE_FOR_URI,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.ENCODE_FOR_URI).onStringly1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.string)(encodeURI(val));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionEncodeForUri;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionEncodeForUri = $0d401ff07b038a6b$var$TermFunctionEncodeForUri;

});



parcelRegister("1lRUZ", function(module, exports) {
"use strict";
var $0fc193a700ea6596$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0fc193a700ea6596$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0fc193a700ea6596$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0fc193a700ea6596$var$__exportStar((parcelRequire("ipyOf")), module.exports);

});
parcelRegister("ipyOf", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermEquality = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $20mI9 = parcelRequire("20mI9");
/**
 * A comunica TermFunctionEquality Function Factory Actor.
 */ var $d67590336a46e4c7$var$ActorFunctionFactoryTermEquality = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermEquality, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermEquality(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermEquality);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermEquality, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.EQUAL
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermEquality, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $20mI9.TermFunctionEquality()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermEquality;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermEquality = $d67590336a46e4c7$var$ActorFunctionFactoryTermEquality;

});
parcelRegister("20mI9", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionEquality = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-RDFterm-equal
 */ var $175d32d24e18738b$var$TermFunctionEquality = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionEquality, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionEquality() {
        (0, $jGAMp._)(this, TermFunctionEquality);
        var _this;
        return _this = (0, $kzDuW._)(this, TermFunctionEquality, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.EQUAL,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.EQUAL).numberTest(function() {
                    return function(left, right) {
                        return left === right;
                    };
                }).stringTest(function() {
                    return function(left, right) {
                        return left.localeCompare(right) === 0;
                    };
                }).set([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        return (0, $aduX6.bool)(left.str() === right.str() && left.language === right.language);
                    };
                })// Fall through: a TypeURL.XSD_STRING is never equal to a TypeURL.RDF_LANG_STRING.
                .set([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeAlias.SPARQL_STRINGLY
                ], function() {
                    return function() {
                        return (0, $aduX6.bool)(false);
                    };
                }).booleanTest(function() {
                    return function(left, right) {
                        return left === right;
                    };
                }).dateTimeTest(function(exprEval) {
                    return function(left, right) {
                        return (0, $aduX6.toUTCDate)(left, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime() === (0, $aduX6.toUTCDate)(right, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime();
                    };
                }).copy({
                    // https://www.w3.org/TR/xpath-functions/#func-date-equal
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_DATE
                    ]
                }).set([
                    'quad',
                    'quad'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        return (0, $aduX6.bool)((0, $hMpIh._)(_this).applyOnTerms([
                            left.subject,
                            right.subject
                        ], exprEval).coerceEBV() && (0, $hMpIh._)(_this).applyOnTerms([
                            left.predicate,
                            right.predicate
                        ], exprEval).coerceEBV() && (0, $hMpIh._)(_this).applyOnTerms([
                            left.object,
                            right.object
                        ], exprEval).coerceEBV() && (0, $hMpIh._)(_this).applyOnTerms([
                            left.graph,
                            right.graph
                        ], exprEval).coerceEBV());
                    };
                }, false).set([
                    'term',
                    'term'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), _left = _param[0], _right = _param[1];
                        var left = _left.toRDF(exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory));
                        var right = _right.toRDF(exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory));
                        var val = left.equals(right);
                        if (!val && left.termType === 'Literal' && right.termType === 'Literal') throw new $aduX6.RDFEqualTypeError([
                            _left,
                            _right
                        ]);
                        return (0, $aduX6.bool)(val);
                    };
                }, false).set([
                    $aduX6.TypeURL.XSD_DURATION,
                    $aduX6.TypeURL.XSD_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), dur1 = _param[0], dur2 = _param[1];
                        return (0, $aduX6.bool)((0, $aduX6.yearMonthDurationsToMonths)((0, $aduX6.defaultedYearMonthDurationRepresentation)(dur1.typedValue)) === (0, $aduX6.yearMonthDurationsToMonths)((0, $aduX6.defaultedYearMonthDurationRepresentation)(dur2.typedValue)) && (0, $aduX6.dayTimeDurationsToSeconds)((0, $aduX6.defaultedDayTimeDurationRepresentation)(dur1.typedValue)) === (0, $aduX6.dayTimeDurationsToSeconds)((0, $aduX6.defaultedDayTimeDurationRepresentation)(dur2.typedValue)));
                    };
                }).set([
                    $aduX6.TypeURL.XSD_TIME,
                    $aduX6.TypeURL.XSD_TIME
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), time1 = _param[0], time2 = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-time-equal
                        (0, $aduX6.bool)((0, $aduX6.toUTCDate)((0, $aduX6.defaultedDateTimeRepresentation)(time1.typedValue), exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime() === (0, $aduX6.toUTCDate)((0, $aduX6.defaultedDateTimeRepresentation)(time2.typedValue), exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionEquality;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionEquality = $175d32d24e18738b$var$TermFunctionEquality;

});



parcelRegister("kG6VY", function(module, exports) {
"use strict";
var $f0dd1bdecb48519e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0dd1bdecb48519e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0dd1bdecb48519e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0dd1bdecb48519e$var$__exportStar((parcelRequire("5QA7m")), module.exports);

});
parcelRegister("5QA7m", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermFloor = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $5Rc7K = parcelRequire("5Rc7K");
/**
 * A comunica TermFunctionFloor Function Factory Actor.
 */ var $441dd34dddcfd2d0$var$ActorFunctionFactoryTermFloor = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermFloor, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermFloor(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermFloor);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermFloor, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.FLOOR
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermFloor, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $5Rc7K.TermFunctionFloor()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermFloor;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermFloor = $441dd34dddcfd2d0$var$ActorFunctionFactoryTermFloor;

});
parcelRegister("5Rc7K", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionFloor = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-floor
 */ var $443b4e8e1484157a$var$TermFunctionFloor = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionFloor, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionFloor() {
        (0, $jGAMp._)(this, TermFunctionFloor);
        return (0, $kzDuW._)(this, TermFunctionFloor, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.FLOOR,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.FLOOR).numericConverter(function() {
                    return function(num) {
                        return Math.floor(num);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionFloor;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionFloor = $443b4e8e1484157a$var$TermFunctionFloor;

});



parcelRegister("hUUIQ", function(module, exports) {
"use strict";
var $d0b3aa80545ac2e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d0b3aa80545ac2e6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d0b3aa80545ac2e6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d0b3aa80545ac2e6$var$__exportStar((parcelRequire("lMxhy")), module.exports);

});
parcelRegister("lMxhy", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermHours = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $187Ms = parcelRequire("187Ms");
/**
 * A comunica TermFunctionHours Function Factory Actor.
 */ var $fdb7e5cace07c240$var$ActorFunctionFactoryTermHours = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermHours, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermHours(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermHours);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermHours, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.HOURS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermHours, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $187Ms.TermFunctionHours()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermHours;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermHours = $fdb7e5cace07c240$var$ActorFunctionFactoryTermHours;

});
parcelRegister("187Ms", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionHours = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-hours
 */ var $0d2c92da0f522ea7$var$TermFunctionHours = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionHours, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionHours() {
        (0, $jGAMp._)(this, TermFunctionHours);
        return (0, $kzDuW._)(this, TermFunctionHours, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.HOURS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.HOURS).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.integer)(date.typedValue.hours);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_TIME
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), time = _param[0];
                        return (0, $aduX6.integer)(time.typedValue.hours);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionHours;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionHours = $0d2c92da0f522ea7$var$TermFunctionHours;

});



parcelRegister("lOdya", function(module, exports) {
"use strict";
var $fe08c741000f73da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe08c741000f73da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fe08c741000f73da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fe08c741000f73da$var$__exportStar((parcelRequire("ed2u6")), module.exports);

});
parcelRegister("ed2u6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $7bwug = parcelRequire("7bwug");
/**
 * A comunica TermFunctionIri Function Factory Actor.
 */ var $a58434f2c35a7eca$var$ActorFunctionFactoryTermIri = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIri, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIri(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIri);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIri, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IRI,
                    $aduX6.SparqlOperator.URI
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIri, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $7bwug.TermFunctionIri()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIri;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIri = $a58434f2c35a7eca$var$ActorFunctionFactoryTermIri;

});
parcelRegister("7bwug", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");

var $hDpjF = parcelRequire("hDpjF");
/**
 * https://www.w3.org/TR/sparql11-query/#func-iri
 */ var $53b2c2c225b0a3a3$var$TermFunctionIri = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIri, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIri() {
        (0, $jGAMp._)(this, TermFunctionIri);
        return (0, $kzDuW._)(this, TermFunctionIri, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IRI,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IRI).set([
                    'namedNode'
                ], function(exprEval) {
                    return function(args) {
                        var lit = args[0];
                        var _exprEval_context_get;
                        var iri = (0, $hDpjF.resolve)(lit.str(), (_exprEval_context_get = exprEval.context.get($9nBhR.KeysInitQuery.baseIRI)) !== null && _exprEval_context_get !== void 0 ? _exprEval_context_get : '');
                        return new $aduX6.NamedNode(iri);
                    };
                }).onString1(function(exprEval) {
                    return function(lit) {
                        var _exprEval_context_get;
                        var iri = (0, $hDpjF.resolve)(lit.str(), (_exprEval_context_get = exprEval.context.get($9nBhR.KeysInitQuery.baseIRI)) !== null && _exprEval_context_get !== void 0 ? _exprEval_context_get : '');
                        return new $aduX6.NamedNode(iri);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIri;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIri = $53b2c2c225b0a3a3$var$TermFunctionIri;

});



parcelRegister("iiju5", function(module, exports) {
"use strict";
var $d5190598776f9f82$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5190598776f9f82$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d5190598776f9f82$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d5190598776f9f82$var$__exportStar((parcelRequire("7o7pr")), module.exports);

});
parcelRegister("7o7pr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsBlank = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $bS3n0 = parcelRequire("bS3n0");
/**
 * A comunica TermFunctionIsBlank Function Factory Actor.
 */ var $561085a8e7198864$var$ActorFunctionFactoryTermIsBlank = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIsBlank, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIsBlank(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIsBlank);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIsBlank, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IS_BLANK
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIsBlank, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $bS3n0.TermFunctionIsBlank()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIsBlank;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIsBlank = $561085a8e7198864$var$ActorFunctionFactoryTermIsBlank;

});
parcelRegister("bS3n0", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsBlank = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isBlank
 */ var $8a475a1ade90f5f4$var$TermFunctionIsBlank = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIsBlank, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIsBlank() {
        (0, $jGAMp._)(this, TermFunctionIsBlank);
        return (0, $kzDuW._)(this, TermFunctionIsBlank, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IS_BLANK,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IS_BLANK).onTerm1(function() {
                    return function(term) {
                        return (0, $aduX6.bool)(term.termType === 'blankNode');
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIsBlank;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIsBlank = $8a475a1ade90f5f4$var$TermFunctionIsBlank;

});



parcelRegister("4q8EB", function(module, exports) {
"use strict";
var $33804d96ab9eb59f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $33804d96ab9eb59f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $33804d96ab9eb59f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$33804d96ab9eb59f$var$__exportStar((parcelRequire("3iJvR")), module.exports);

});
parcelRegister("3iJvR", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsIri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $e4w1y = parcelRequire("e4w1y");
/**
 * A comunica TermFunctionIsIri Function Factory Actor.
 */ var $26765b73ba969bd0$var$ActorFunctionFactoryTermIsIri = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIsIri, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIsIri(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIsIri);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIsIri, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IS_IRI,
                    $aduX6.SparqlOperator.IS_URI
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIsIri, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $e4w1y.TermFunctionIsIri()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIsIri;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIsIri = $26765b73ba969bd0$var$ActorFunctionFactoryTermIsIri;

});
parcelRegister("e4w1y", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsIri = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isIRI
 */ var $a3ea47b78a0568e2$var$TermFunctionIsIri = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIsIri, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIsIri() {
        (0, $jGAMp._)(this, TermFunctionIsIri);
        return (0, $kzDuW._)(this, TermFunctionIsIri, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IS_IRI,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IS_IRI).onTerm1(function() {
                    return function(term) {
                        return (0, $aduX6.bool)(term.termType === 'namedNode');
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIsIri;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIsIri = $a3ea47b78a0568e2$var$TermFunctionIsIri;

});



parcelRegister("bxCon", function(module, exports) {
"use strict";
var $86708ea3382d534a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $86708ea3382d534a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $86708ea3382d534a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$86708ea3382d534a$var$__exportStar((parcelRequire("933EO")), module.exports);

});
parcelRegister("933EO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsLiteral = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $ld1P7 = parcelRequire("ld1P7");
/**
 * A comunica TermFunctionIsLiteral Function Factory Actor.
 */ var $69673b1d1b4af8cc$var$ActorFunctionFactoryTermIsLiteral = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIsLiteral, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIsLiteral(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIsLiteral);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIsLiteral, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IS_LITERAL
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIsLiteral, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $ld1P7.TermFunctionIsLiteral()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIsLiteral;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIsLiteral = $69673b1d1b4af8cc$var$ActorFunctionFactoryTermIsLiteral;

});
parcelRegister("ld1P7", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsLiteral = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isLiteral
 */ var $f70c39feba410966$var$TermFunctionIsLiteral = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIsLiteral, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIsLiteral() {
        (0, $jGAMp._)(this, TermFunctionIsLiteral);
        return (0, $kzDuW._)(this, TermFunctionIsLiteral, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IS_LITERAL,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IS_LITERAL).onTerm1(function() {
                    return function(term) {
                        return (0, $aduX6.bool)(term.termType === 'literal');
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIsLiteral;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIsLiteral = $f70c39feba410966$var$TermFunctionIsLiteral;

});



parcelRegister("bNFsp", function(module, exports) {
"use strict";
var $89746dd96ed93455$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89746dd96ed93455$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $89746dd96ed93455$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$89746dd96ed93455$var$__exportStar((parcelRequire("h4UGi")), module.exports);

});
parcelRegister("h4UGi", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsNumeric = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $2Mgyj = parcelRequire("2Mgyj");
/**
 * A comunica TermFunctionIsNumeric Function Factory Actor.
 */ var $c6eec71c93d22f8d$var$ActorFunctionFactoryTermIsNumeric = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIsNumeric, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIsNumeric(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIsNumeric);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIsNumeric, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IS_NUMERIC
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIsNumeric, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $2Mgyj.TermFunctionIsNumeric()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIsNumeric;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIsNumeric = $c6eec71c93d22f8d$var$ActorFunctionFactoryTermIsNumeric;

});
parcelRegister("2Mgyj", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsNumeric = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isNumeric
 */ var $205ce76be2efd2f7$var$TermFunctionIsNumeric = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIsNumeric, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIsNumeric() {
        (0, $jGAMp._)(this, TermFunctionIsNumeric);
        return (0, $kzDuW._)(this, TermFunctionIsNumeric, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IS_NUMERIC,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IS_NUMERIC).onNumeric1(function() {
                    return function() {
                        return (0, $aduX6.bool)(true);
                    };
                }).onTerm1(function() {
                    return function() {
                        return (0, $aduX6.bool)(false);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIsNumeric;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIsNumeric = $205ce76be2efd2f7$var$TermFunctionIsNumeric;

});



parcelRegister("1Fvoy", function(module, exports) {
"use strict";
var $1371f92b95077d5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1371f92b95077d5f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1371f92b95077d5f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1371f92b95077d5f$var$__exportStar((parcelRequire("k27it")), module.exports);

});
parcelRegister("k27it", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsTriple = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $1t66s = parcelRequire("1t66s");
/**
 * A comunica TermFunctionIsTriple Function Factory Actor.
 */ var $e959a793a0dab03e$var$ActorFunctionFactoryTermIsTriple = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermIsTriple, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermIsTriple(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermIsTriple);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermIsTriple, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IS_TRIPLE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermIsTriple, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $1t66s.TermFunctionIsTriple()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermIsTriple;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermIsTriple = $e959a793a0dab03e$var$ActorFunctionFactoryTermIsTriple;

});
parcelRegister("1t66s", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsTriple = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#istriple
 */ var $111d3bd399155098$var$TermFunctionIsTriple = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionIsTriple, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionIsTriple() {
        (0, $jGAMp._)(this, TermFunctionIsTriple);
        return (0, $kzDuW._)(this, TermFunctionIsTriple, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.IS_TRIPLE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.IS_TRIPLE).onTerm1(function() {
                    return function(term) {
                        return (0, $aduX6.bool)(term.termType === 'quad');
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionIsTriple;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionIsTriple = $111d3bd399155098$var$TermFunctionIsTriple;

});



parcelRegister("hF0s3", function(module, exports) {
"use strict";
var $cdb69da8a3b26291$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cdb69da8a3b26291$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cdb69da8a3b26291$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cdb69da8a3b26291$var$__exportStar((parcelRequire("4bCOM")), module.exports);

});
parcelRegister("4bCOM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLang = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $jXl7z = parcelRequire("jXl7z");
/**
 * A comunica TermFunctionLang Function Factory Actor.
 */ var $30c64cf98a24e18f$var$ActorFunctionFactoryTermLang = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermLang, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermLang(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermLang);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermLang, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LANG
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermLang, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $jXl7z.TermFunctionLang()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermLang;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermLang = $30c64cf98a24e18f$var$ActorFunctionFactoryTermLang;

});
parcelRegister("jXl7z", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLang = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-lang
 */ var $e873e93eb6ae6243$var$TermFunctionLang = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionLang, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionLang() {
        (0, $jGAMp._)(this, TermFunctionLang);
        return (0, $kzDuW._)(this, TermFunctionLang, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.LANG,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.LANG).onLiteral1(function() {
                    return function(lit) {
                        var _lit_language;
                        return (0, $aduX6.string)((_lit_language = lit.language) !== null && _lit_language !== void 0 ? _lit_language : '');
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionLang;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionLang = $e873e93eb6ae6243$var$TermFunctionLang;

});



parcelRegister("hnfyg", function(module, exports) {
"use strict";
var $ca60a5e3478d8de5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ca60a5e3478d8de5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ca60a5e3478d8de5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ca60a5e3478d8de5$var$__exportStar((parcelRequire("kskJP")), module.exports);

});
parcelRegister("kskJP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLangmatches = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $kRYLq = parcelRequire("kRYLq");
/**
 * A comunica TermFunctionLangmatches Function Factory Actor.
 */ var $ee468259aa0bc292$var$ActorFunctionFactoryTermLangmatches = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermLangmatches, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermLangmatches(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermLangmatches);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermLangmatches, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LANG_MATCHES
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermLangmatches, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $kRYLq.TermFunctionLangmatches()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermLangmatches;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermLangmatches = $ee468259aa0bc292$var$ActorFunctionFactoryTermLangmatches;

});
parcelRegister("kRYLq", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLangmatches = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-langMatches
 */ var $f317e4564eff84c5$var$TermFunctionLangmatches = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionLangmatches, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionLangmatches() {
        (0, $jGAMp._)(this, TermFunctionLangmatches);
        return (0, $kzDuW._)(this, TermFunctionLangmatches, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.LANG_MATCHES,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.LANG_MATCHES).onBinaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(tag, range) {
                        return (0, $aduX6.bool)(TermFunctionLangmatches.langMatches(tag, range));
                    };
                }).collect()
            }
        ]);
    }
    (0, $byiyg._)(TermFunctionLangmatches, null, [
        {
            key: "langMatches",
            value: // TODO: Not an XPath function
            // TODO: Publish as package
            // https://www.ietf.org/rfc/rfc4647.txt
            // https://www.w3.org/TR/sparql11-query/#func-langMatches
            function langMatches(tag, range) {
                var langTags = tag.split('-');
                var rangeTags = range.split('-');
                if (!TermFunctionLangmatches.matchLangTag(rangeTags[0], langTags[0]) && !TermFunctionLangmatches.isWildCard(langTags[0])) return false;
                var lI = 1;
                var rI = 1;
                while(rI < rangeTags.length){
                    if (TermFunctionLangmatches.isWildCard(rangeTags[rI])) {
                        rI++;
                        continue;
                    }
                    if (lI === langTags.length) return false;
                    if (TermFunctionLangmatches.matchLangTag(rangeTags[rI], langTags[lI])) {
                        lI++;
                        rI++;
                        continue;
                    }
                    if (langTags[lI].length === 1) return false;
                    lI++;
                }
                return true;
            }
        },
        {
            key: "isWildCard",
            value: function isWildCard(tag) {
                return tag === '*';
            }
        },
        {
            key: "matchLangTag",
            value: function matchLangTag(left, right) {
                var matchInitial = new RegExp("/".concat(left, "/"), 'iu');
                return matchInitial.test("/".concat(right, "/"));
            }
        }
    ]);
    return TermFunctionLangmatches;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionLangmatches = $f317e4564eff84c5$var$TermFunctionLangmatches;

});



parcelRegister("6QSwS", function(module, exports) {
"use strict";
var $4fd1e5c3d8cc1cae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4fd1e5c3d8cc1cae$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4fd1e5c3d8cc1cae$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4fd1e5c3d8cc1cae$var$__exportStar((parcelRequire("kDTKr")), module.exports);

});
parcelRegister("kDTKr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLcase = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $9sYEH = parcelRequire("9sYEH");
/**
 * A comunica TermFunctionLcase Function Factory Actor.
 */ var $f072b190aa87972b$var$ActorFunctionFactoryTermLcase = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermLcase, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermLcase(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermLcase);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermLcase, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LCASE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermLcase, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $9sYEH.TermFunctionLcase()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermLcase;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermLcase = $f072b190aa87972b$var$ActorFunctionFactoryTermLcase;

});
parcelRegister("9sYEH", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLcase = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-lcase
 */ var $6e45c778236aa104$var$TermFunctionLcase = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionLcase, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionLcase() {
        (0, $jGAMp._)(this, TermFunctionLcase);
        return (0, $kzDuW._)(this, TermFunctionLcase, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.LCASE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.LCASE).onString1Typed(function() {
                    return function(lit) {
                        return (0, $aduX6.string)(lit.toLowerCase());
                    };
                }).onLangString1(function() {
                    return function(lit) {
                        return (0, $aduX6.langString)(lit.typedValue.toLowerCase(), lit.language);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionLcase;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionLcase = $6e45c778236aa104$var$TermFunctionLcase;

});



parcelRegister("8X8wJ", function(module, exports) {
"use strict";
var $684a72b6cd8503a9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $684a72b6cd8503a9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $684a72b6cd8503a9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$684a72b6cd8503a9$var$__exportStar((parcelRequire("irGTr")), module.exports);

});
parcelRegister("irGTr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMd5 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $43nyx = parcelRequire("43nyx");
/**
 * A comunica TermFunctionMd5 Function Factory Actor.
 */ var $d6dc054dec6338ba$var$ActorFunctionFactoryTermMd5 = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermMd5, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermMd5(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermMd5);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermMd5, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.MD5
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermMd5, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $43nyx.TermFunctionMd5()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermMd5;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermMd5 = $d6dc054dec6338ba$var$ActorFunctionFactoryTermMd5;

});
parcelRegister("43nyx", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMd5 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $3cy6W = parcelRequire("3cy6W");
/**
 * https://www.w3.org/TR/sparql11-query/#func-md5
 */ var $2f39b6fef946d7db$var$TermFunctionMd5 = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionMd5, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionMd5() {
        (0, $jGAMp._)(this, TermFunctionMd5);
        return (0, $kzDuW._)(this, TermFunctionMd5, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.MD5,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.MD5).onString1Typed(function() {
                    return function(str) {
                        return (0, $aduX6.string)((0, $3cy6W.hash)(str));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionMd5;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionMd5 = $2f39b6fef946d7db$var$TermFunctionMd5;

});
parcelRegister("3cy6W", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function add32(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function add32(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});




parcelRegister("ktqm3", function(module, exports) {
"use strict";
var $ee7af5940c8dfc67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee7af5940c8dfc67$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee7af5940c8dfc67$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ee7af5940c8dfc67$var$__exportStar((parcelRequire("4M2SJ")), module.exports);

});
parcelRegister("4M2SJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMinutes = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $eSPAz = parcelRequire("eSPAz");
/**
 * A comunica TermFunctionMinutes Function Factory Actor.
 */ var $379de162920b0609$var$ActorFunctionFactoryTermMinutes = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermMinutes, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermMinutes(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermMinutes);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermMinutes, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.MINUTES
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermMinutes, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $eSPAz.TermFunctionMinutes()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermMinutes;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermMinutes = $379de162920b0609$var$ActorFunctionFactoryTermMinutes;

});
parcelRegister("eSPAz", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMinutes = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-minutes
 */ var $ad5e2052d02056d4$var$TermFunctionMinutes = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionMinutes, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionMinutes() {
        (0, $jGAMp._)(this, TermFunctionMinutes);
        return (0, $kzDuW._)(this, TermFunctionMinutes, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.MINUTES,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.MINUTES).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.integer)(date.typedValue.minutes);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_TIME
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), time = _param[0];
                        return (0, $aduX6.integer)(time.typedValue.minutes);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionMinutes;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionMinutes = $ad5e2052d02056d4$var$TermFunctionMinutes;

});



parcelRegister("kJHq1", function(module, exports) {
"use strict";
var $f189b0af5e7f2296$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f189b0af5e7f2296$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f189b0af5e7f2296$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f189b0af5e7f2296$var$__exportStar((parcelRequire("8tAId")), module.exports);

});
parcelRegister("8tAId", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMonth = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $lacFg = parcelRequire("lacFg");
/**
 * A comunica TermFunctionMonth Function Factory Actor.
 */ var $62bd8269b2b42c2b$var$ActorFunctionFactoryTermMonth = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermMonth, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermMonth(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermMonth);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermMonth, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.MONTH
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermMonth, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $lacFg.TermFunctionMonth()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermMonth;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermMonth = $62bd8269b2b42c2b$var$ActorFunctionFactoryTermMonth;

});
parcelRegister("lacFg", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMonth = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-month
 */ var $f6845b15cefd9c5c$var$TermFunctionMonth = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionMonth, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionMonth() {
        (0, $jGAMp._)(this, TermFunctionMonth);
        return (0, $kzDuW._)(this, TermFunctionMonth, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.MONTH,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.MONTH).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.integer)(date.typedValue.month);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DATE
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), date = _param[0];
                        return (0, $aduX6.integer)(date.typedValue.month);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionMonth;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionMonth = $f6845b15cefd9c5c$var$TermFunctionMonth;

});



parcelRegister("1F228", function(module, exports) {
"use strict";
var $135b32901bdf5d0c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $135b32901bdf5d0c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $135b32901bdf5d0c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$135b32901bdf5d0c$var$__exportStar((parcelRequire("9gXL4")), module.exports);

});
parcelRegister("9gXL4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMultiplication = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $1tCZN = parcelRequire("1tCZN");
/**
 * A comunica TermFunctionMultiplication Function Factory Actor.
 */ var $6c03f6693334908e$var$ActorFunctionFactoryTermMultiplication = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermMultiplication, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermMultiplication(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermMultiplication);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermMultiplication, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.MULTIPLICATION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermMultiplication, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $1tCZN.TermFunctionMultiplication()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermMultiplication;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermMultiplication = $6c03f6693334908e$var$ActorFunctionFactoryTermMultiplication;

});
parcelRegister("1tCZN", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMultiplication = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $56IvR = parcelRequire("56IvR");
var $1136bfa369e25f40$var$TermFunctionMultiplication = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionMultiplication, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionMultiplication() {
        (0, $jGAMp._)(this, TermFunctionMultiplication);
        return (0, $kzDuW._)(this, TermFunctionMultiplication, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.MULTIPLICATION,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.MULTIPLICATION).arithmetic(function() {
                    return function(left, right) {
                        return new $56IvR.BigNumber(left).times(right).toNumber();
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionMultiplication;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionMultiplication = $1136bfa369e25f40$var$TermFunctionMultiplication;

});



parcelRegister("fEqC4", function(module, exports) {
"use strict";
var $b64f3c41c0f0909b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b64f3c41c0f0909b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b64f3c41c0f0909b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b64f3c41c0f0909b$var$__exportStar((parcelRequire("6y6f2")), module.exports);

});
parcelRegister("6y6f2", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermNot = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $eVs32 = parcelRequire("eVs32");
/**
 * A comunica TermFunctionNot Function Factory Actor.
 */ var $4c4ac27c99f00ab5$var$ActorFunctionFactoryTermNot = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermNot, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermNot(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermNot);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermNot, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.NOT
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermNot, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $eVs32.TermFunctionNot()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermNot;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermNot = $4c4ac27c99f00ab5$var$ActorFunctionFactoryTermNot;

});
parcelRegister("eVs32", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionNot = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $addc25530500d262$var$TermFunctionNot = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionNot, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionNot() {
        (0, $jGAMp._)(this, TermFunctionNot);
        return (0, $kzDuW._)(this, TermFunctionNot, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.NOT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.NOT).onTerm1(function() {
                    return function(val) {
                        return (0, $aduX6.bool)(!val.coerceEBV());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionNot;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionNot = $addc25530500d262$var$TermFunctionNot;

});



parcelRegister("2g5Io", function(module, exports) {
"use strict";
var $1a51824c73d2824e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1a51824c73d2824e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1a51824c73d2824e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1a51824c73d2824e$var$__exportStar((parcelRequire("5SY3V")), module.exports);

});
parcelRegister("5SY3V", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermNow = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $5kwIl = parcelRequire("5kwIl");
/**
 * A comunica TermFunctionNow Function Factory Actor.
 */ var $449095ff50c174fc$var$ActorFunctionFactoryTermNow = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermNow, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermNow(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermNow);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermNow, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.NOW
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermNow, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $5kwIl.TermFunctionNow()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermNow;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermNow = $449095ff50c174fc$var$ActorFunctionFactoryTermNow;

});
parcelRegister("5kwIl", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionNow = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-now
 */ var $3e18325b711bc251$var$TermFunctionNow = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionNow, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionNow() {
        (0, $jGAMp._)(this, TermFunctionNow);
        return (0, $kzDuW._)(this, TermFunctionNow, [
            {
                arity: 0,
                operator: $aduX6.SparqlOperator.NOW,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.NOW).set([], function(exprEval) {
                    return function() {
                        return new $aduX6.DateTimeLiteral((0, $aduX6.toDateTimeRepresentation)({
                            date: exprEval.context.getSafe($9nBhR.KeysInitQuery.queryTimestamp),
                            timeZone: exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)
                        }));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionNow;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionNow = $3e18325b711bc251$var$TermFunctionNow;

});



parcelRegister("2gkFS", function(module, exports) {
"use strict";
var $1a5d1ce4e2cd810f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1a5d1ce4e2cd810f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1a5d1ce4e2cd810f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1a5d1ce4e2cd810f$var$__exportStar((parcelRequire("k5tTF")), module.exports);

});
parcelRegister("k5tTF", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermObject = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $keR7V = parcelRequire("keR7V");
/**
 * A comunica TermFunctionObject Function Factory Actor.
 */ var $e9fb7731ec3b707e$var$ActorFunctionFactoryTermObject = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermObject, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermObject(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermObject);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermObject, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.OBJECT
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermObject, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $keR7V.TermFunctionObject()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermObject;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermObject = $e9fb7731ec3b707e$var$ActorFunctionFactoryTermObject;

});
parcelRegister("keR7V", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionObject = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#object
 */ var $ebbe5356525a564c$var$TermFunctionObject = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionObject, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionObject() {
        (0, $jGAMp._)(this, TermFunctionObject);
        return (0, $kzDuW._)(this, TermFunctionObject, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.OBJECT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.OBJECT).onQuad1(function() {
                    return function(quad) {
                        return quad.object;
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionObject;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionObject = $ebbe5356525a564c$var$TermFunctionObject;

});



parcelRegister("bgUrQ", function(module, exports) {
"use strict";
var $834cf9bcf27c089e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $834cf9bcf27c089e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $834cf9bcf27c089e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$834cf9bcf27c089e$var$__exportStar((parcelRequire("6MLLT")), module.exports);

});
parcelRegister("6MLLT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermPredicate = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $2D9U6 = parcelRequire("2D9U6");
/**
 * A comunica TermFunctionPredicate Function Factory Actor.
 */ var $4f0c4831f5f73452$var$ActorFunctionFactoryTermPredicate = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermPredicate, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermPredicate(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermPredicate);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermPredicate, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.PREDICATE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermPredicate, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $2D9U6.TermFunctionPredicate()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermPredicate;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermPredicate = $4f0c4831f5f73452$var$ActorFunctionFactoryTermPredicate;

});
parcelRegister("2D9U6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionPredicate = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#predicate
 */ var $1ea6e7ff90ae83c0$var$TermFunctionPredicate = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionPredicate, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionPredicate() {
        (0, $jGAMp._)(this, TermFunctionPredicate);
        return (0, $kzDuW._)(this, TermFunctionPredicate, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.PREDICATE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.PREDICATE).onQuad1(function() {
                    return function(quad) {
                        return quad.predicate;
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionPredicate;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionPredicate = $1ea6e7ff90ae83c0$var$TermFunctionPredicate;

});



parcelRegister("luK5n", function(module, exports) {
"use strict";
var $fa6025fe7902b95d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fa6025fe7902b95d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fa6025fe7902b95d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fa6025fe7902b95d$var$__exportStar((parcelRequire("gpMU4")), module.exports);

});
parcelRegister("gpMU4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRand = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $7fymF = parcelRequire("7fymF");
/**
 * A comunica TermFunctionRand Function Factory Actor.
 */ var $bf34ea558c27aa2b$var$ActorFunctionFactoryTermRand = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermRand, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermRand(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermRand);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermRand, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.RAND
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermRand, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $7fymF.TermFunctionRand()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermRand;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermRand = $bf34ea558c27aa2b$var$ActorFunctionFactoryTermRand;

});
parcelRegister("7fymF", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRand = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#idp2130040
 */ var $54749736790fa020$var$TermFunctionRand = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionRand, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionRand() {
        (0, $jGAMp._)(this, TermFunctionRand);
        return (0, $kzDuW._)(this, TermFunctionRand, [
            {
                arity: 0,
                operator: $aduX6.SparqlOperator.RAND,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.RAND).set([], function() {
                    return function() {
                        return (0, $aduX6.double)(Math.random());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionRand;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionRand = $54749736790fa020$var$TermFunctionRand;

});



parcelRegister("hWbTr", function(module, exports) {
"use strict";
var $d0f1142c16c2aeb5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d0f1142c16c2aeb5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d0f1142c16c2aeb5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d0f1142c16c2aeb5$var$__exportStar((parcelRequire("fCCkg")), module.exports);

$d0f1142c16c2aeb5$var$__exportStar((parcelRequire("14v6U")), module.exports);

});
parcelRegister("fCCkg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRegex = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $14v6U = parcelRequire("14v6U");
/**
 * A comunica TermFunctionRegex Function Factory Actor.
 */ var $b5f8225d0b385553$var$ActorFunctionFactoryTermRegex = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermRegex, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermRegex(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermRegex);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermRegex, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.REGEX
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermRegex, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $14v6U.TermFunctionRegex()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermRegex;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermRegex = $b5f8225d0b385553$var$ActorFunctionFactoryTermRegex;

});
parcelRegister("14v6U", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRegex = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-regex
 */ var $0c7e4c11d09edeb0$var$TermFunctionRegex = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionRegex, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionRegex() {
        (0, $jGAMp._)(this, TermFunctionRegex);
        return (0, $kzDuW._)(this, TermFunctionRegex, [
            {
                arity: [
                    2,
                    3
                ],
                operator: $aduX6.SparqlOperator.REGEX,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.REGEX).onBinaryTyped([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeURL.XSD_STRING
                ], TermFunctionRegex.regex2).onTernaryTyped([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], TermFunctionRegex.regex3).collect()
            }
        ]);
    }
    (0, $byiyg._)(TermFunctionRegex, null, [
        {
            key: "regex2",
            value: function regex2() {
                return function(text, pattern) {
                    return (0, $aduX6.bool)(TermFunctionRegex.matches(text, pattern));
                };
            }
        },
        {
            key: "regex3",
            value: function regex3() {
                return function(text, pattern, flags) {
                    return (0, $aduX6.bool)(TermFunctionRegex.matches(text, pattern, flags));
                };
            }
        },
        {
            key: "matches",
            value: // https://www.w3.org/TR/xpath-functions/#func-matches
            // https://www.w3.org/TR/xpath-functions/#flags
            function matches(text, pattern) {
                var flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                // Flags:
                //   i: case-insensitive: same as the 'i' flag in JavaScript
                //   m: multi-line mode: same as the 'm' flag in JavaScript
                //   s: dot-all mode: matches 's' flag in JavaScript very well.
                //   x: whitespace characters (#x9, #xA, #xD and #x20)
                //      in the regular expression are removed prior to matching with one exception:
                //        whitespace characters within character class expressions.
                //   q: regex-no-metacharacters:
                //      all characters in the regular expression are treated as representing themselves, not as metacharacters
                //      If it is used together with the m, s, or x flag, that flag has no effect.
                flags = TermFunctionRegex.cleanFlags(flags);
                if (flags.includes('x')) pattern = TermFunctionRegex.flagX(pattern);
                if (flags.includes('q')) pattern = TermFunctionRegex.flagQ(pattern);
                var reg = new RegExp(pattern, flags.replaceAll(RegExp("[qx]", "gu"), ''));
                return reg.test(text);
            }
        },
        {
            key: "cleanFlags",
            value: function cleanFlags(flags) {
                // Check flag validity
                if (!RegExp("^[imsxq]*$", "u").test(flags)) throw new Error('Invalid flags');
                var duplicateFlag = (0, $7WNf6._)(flags).find(function(value, index, self) {
                    return self.indexOf(value) !== index;
                });
                if (duplicateFlag) throw new Error("Duplicate flag: ".concat(duplicateFlag));
                // If the 'q' flag is used, the 'm', 's', and 'x' flags have no effect
                if (flags === null || flags === void 0 ? void 0 : flags.includes('q')) flags = flags.replaceAll(RegExp("[msx]", "gu"), '');
                // Add the JS 'u' flag to the flags to allow for safer regex execution.
                // See reasons given by [ESLint](https://eslint.org/docs/latest/rules/require-unicode-regexp).
                // Disable [Annex B](https://262.ecma-international.org/6.0/#sec-regular-expressions-patterns)
                return "".concat(flags, "u");
            }
        },
        {
            key: "flagX",
            value: function flagX(pattern) {
                if (!pattern) return pattern;
                // Remove all spaces in the pattern, excluding those in character classes
                var prev = pattern[0];
                while([
                    '\u0009',
                    '\u000A',
                    '\u000D',
                    '\u0020'
                ].includes(prev)){
                    pattern = pattern.slice(1);
                    prev = pattern[0];
                }
                var inClass = prev === '[';
                for(var i = 1; i < pattern.length; i++){
                    var c = pattern[i];
                    if ([
                        '\u0009',
                        '\u000A',
                        '\u000D',
                        '\u0020'
                    ].includes(c) && !inClass) {
                        pattern = pattern.slice(0, i) + pattern.slice(i + 1);
                        i--;
                    } else if (c === '[' && prev !== '\\') inClass = true;
                    else if (c === ']' && prev !== '\\') inClass = false;
                    prev = c;
                }
                return pattern;
            }
        },
        {
            key: "flagQ",
            value: function flagQ(pattern) {
                // Escape all metacharacters in the pattern
                return pattern.replaceAll(RegExp("([?+*.{}()[\\]\\\\|])", "gu"), '\\$1').replaceAll(RegExp("^\\^", "gu"), '\\^').replaceAll(RegExp("\\$$", "gu"), '\\$');
            }
        }
    ]);
    return TermFunctionRegex;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionRegex = $0c7e4c11d09edeb0$var$TermFunctionRegex;

});



parcelRegister("9gzVJ", function(module, exports) {
"use strict";
var $6bf17aaf80b984a5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6bf17aaf80b984a5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6bf17aaf80b984a5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6bf17aaf80b984a5$var$__exportStar((parcelRequire("7AMMQ")), module.exports);

});
parcelRegister("7AMMQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermReplace = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $ddP4q = parcelRequire("ddP4q");
/**
 * A comunica TermFunctionReplace Function Factory Actor.
 */ var $5871bd3bf1f50a63$var$ActorFunctionFactoryTermReplace = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermReplace, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermReplace(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermReplace);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermReplace, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.REPLACE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermReplace, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $ddP4q.TermFunctionReplace()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermReplace;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermReplace = $5871bd3bf1f50a63$var$ActorFunctionFactoryTermReplace;

});
parcelRegister("ddP4q", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionReplace = void 0;

var $hWbTr = parcelRequire("hWbTr");

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-replace
 */ var $9a041ac02a91f672$var$TermFunctionReplace = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionReplace, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionReplace() {
        (0, $jGAMp._)(this, TermFunctionReplace);
        return (0, $kzDuW._)(this, TermFunctionReplace, [
            {
                arity: [
                    3,
                    4
                ],
                operator: $aduX6.SparqlOperator.REPLACE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.REPLACE).onTernaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg, pattern, replacement) {
                        return (0, $aduX6.string)(TermFunctionReplace.replace(arg, pattern, replacement));
                    };
                }).set([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 3), arg = _param[0], pattern = _param[1], replacement = _param[2];
                        var result = TermFunctionReplace.replace(arg.typedValue, pattern.typedValue, replacement.typedValue);
                        return (0, $aduX6.langString)(result, arg.language);
                    };
                }).onQuaternaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg, pattern, replacement, flags) {
                        return (0, $aduX6.string)(TermFunctionReplace.replace(arg, pattern, replacement, flags));
                    };
                }).set([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 4), arg = _param[0], pattern = _param[1], replacement = _param[2], flags = _param[3];
                        var result = TermFunctionReplace.replace(arg.typedValue, pattern.typedValue, replacement.typedValue, flags.typedValue);
                        return (0, $aduX6.langString)(result, arg.language);
                    };
                }).collect()
            }
        ]);
    }
    (0, $byiyg._)(TermFunctionReplace, null, [
        {
            key: "replace",
            value: // https://www.w3.org/TR/xpath-functions/#func-replace
            function replace(arg, pattern, replacement) {
                var flags = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
                flags = $hWbTr.TermFunctionRegex.cleanFlags(flags);
                if (flags.includes('x')) pattern = $hWbTr.TermFunctionRegex.flagX(pattern);
                if (flags.includes('q')) pattern = $hWbTr.TermFunctionRegex.flagQ(pattern);
                else replacement = replacement.replaceAll('$0', function() {
                    return '$&';
                });
                flags = "".concat(flags.replaceAll(RegExp("[qx]", "gu"), ''), "g");
                return arg.replaceAll(new RegExp(pattern, flags), replacement);
            }
        }
    ]);
    return TermFunctionReplace;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionReplace = $9a041ac02a91f672$var$TermFunctionReplace;

});



parcelRegister("hECp6", function(module, exports) {
"use strict";
var $cda3f6507193fb87$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cda3f6507193fb87$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cda3f6507193fb87$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cda3f6507193fb87$var$__exportStar((parcelRequire("g19Ax")), module.exports);

});
parcelRegister("g19Ax", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRound = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $64bbP = parcelRequire("64bbP");
/**
 * A comunica TermFunctionRound Function Factory Actor.
 */ var $ba942d5dec0b804e$var$ActorFunctionFactoryTermRound = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermRound, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermRound(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermRound);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermRound, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.ROUND
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermRound, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $64bbP.TermFunctionRound()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermRound;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermRound = $ba942d5dec0b804e$var$ActorFunctionFactoryTermRound;

});
parcelRegister("64bbP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRound = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-round
 */ var $46abcbde65563cf3$var$TermFunctionRound = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionRound, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionRound() {
        (0, $jGAMp._)(this, TermFunctionRound);
        return (0, $kzDuW._)(this, TermFunctionRound, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.ROUND,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.ROUND).numericConverter(function() {
                    return function(num) {
                        return Math.round(num);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionRound;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionRound = $46abcbde65563cf3$var$TermFunctionRound;

});



parcelRegister("evz6F", function(module, exports) {
"use strict";
var $a8ff315d8b9b0257$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a8ff315d8b9b0257$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a8ff315d8b9b0257$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a8ff315d8b9b0257$var$__exportStar((parcelRequire("5Nw0D")), module.exports);

});
parcelRegister("5Nw0D", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSeconds = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $APZq0 = parcelRequire("APZq0");
/**
 * A comunica TermFunctionSeconds Function Factory Actor.
 */ var $438a5bb46dd4858b$var$ActorFunctionFactoryTermSeconds = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSeconds, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSeconds(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSeconds);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSeconds, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SECONDS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSeconds, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $APZq0.TermFunctionSeconds()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSeconds;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSeconds = $438a5bb46dd4858b$var$ActorFunctionFactoryTermSeconds;

});
parcelRegister("APZq0", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSeconds = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-seconds
 */ var $06ebb0f6a1b42240$var$TermFunctionSeconds = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSeconds, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSeconds() {
        (0, $jGAMp._)(this, TermFunctionSeconds);
        return (0, $kzDuW._)(this, TermFunctionSeconds, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SECONDS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SECONDS).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.decimal)(date.typedValue.seconds);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_TIME
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), time = _param[0];
                        return (0, $aduX6.integer)(time.typedValue.seconds);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSeconds;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSeconds = $06ebb0f6a1b42240$var$TermFunctionSeconds;

});



parcelRegister("iwuut", function(module, exports) {
"use strict";
var $d7c2ddeb0618b881$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d7c2ddeb0618b881$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d7c2ddeb0618b881$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d7c2ddeb0618b881$var$__exportStar((parcelRequire("7vL2a")), module.exports);

});
parcelRegister("7vL2a", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha1 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $cPlYV = parcelRequire("cPlYV");
/**
 * A comunica TermFunctionSha1 Function Factory Actor.
 */ var $577fe9977f4b5b83$var$ActorFunctionFactoryTermSha1 = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSha1, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSha1(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSha1);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSha1, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SHA1
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSha1, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $cPlYV.TermFunctionSha1()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSha1;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSha1 = $577fe9977f4b5b83$var$ActorFunctionFactoryTermSha1;

});
parcelRegister("cPlYV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha1 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $168PV = parcelRequire("168PV");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha1
 */ var $956b4c94daae12f8$var$TermFunctionSha1 = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSha1, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSha1() {
        (0, $jGAMp._)(this, TermFunctionSha1);
        return (0, $kzDuW._)(this, TermFunctionSha1, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SHA1,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SHA1).onString1Typed(function() {
                    return function(str) {
                        return (0, $aduX6.string)((0, $168PV.sha1)().update(str).digest('hex'));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSha1;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSha1 = $956b4c94daae12f8$var$TermFunctionSha1;

});



parcelRegister("lKx3X", function(module, exports) {
"use strict";
var $fd578a6fd0563175$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd578a6fd0563175$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd578a6fd0563175$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fd578a6fd0563175$var$__exportStar((parcelRequire("01UYV")), module.exports);

});
parcelRegister("01UYV", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha256 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $2p8qK = parcelRequire("2p8qK");
/**
 * A comunica TermFunctionSha256 Function Factory Actor.
 */ var $005c4b781bde9045$var$ActorFunctionFactoryTermSha256 = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSha256, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSha256(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSha256);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSha256, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SHA256
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSha256, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $2p8qK.TermFunctionSha256()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSha256;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSha256 = $005c4b781bde9045$var$ActorFunctionFactoryTermSha256;

});
parcelRegister("2p8qK", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha256 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $168PV = parcelRequire("168PV");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha256
 */ var $1c0474b08a3d4f0e$var$TermFunctionSha256 = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSha256, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSha256() {
        (0, $jGAMp._)(this, TermFunctionSha256);
        return (0, $kzDuW._)(this, TermFunctionSha256, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SHA256,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SHA256).onString1Typed(function() {
                    return function(str) {
                        return (0, $aduX6.string)((0, $168PV.sha256)().update(str).digest('hex'));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSha256;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSha256 = $1c0474b08a3d4f0e$var$TermFunctionSha256;

});



parcelRegister("i8gx1", function(module, exports) {
"use strict";
var $d335cc32c3210ad2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d335cc32c3210ad2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d335cc32c3210ad2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d335cc32c3210ad2$var$__exportStar((parcelRequire("lwm8O")), module.exports);

});
parcelRegister("lwm8O", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha384 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $guMDu = parcelRequire("guMDu");
/**
 * A comunica TermFunctionSha384 Function Factory Actor.
 */ var $faadc2e42b1fa8a7$var$ActorFunctionFactoryTermSha384 = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSha384, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSha384(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSha384);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSha384, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SHA384
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSha384, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $guMDu.TermFunctionSha384()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSha384;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSha384 = $faadc2e42b1fa8a7$var$ActorFunctionFactoryTermSha384;

});
parcelRegister("guMDu", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha384 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $168PV = parcelRequire("168PV");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha384
 */ var $c0252cbfde955d31$var$TermFunctionSha384 = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSha384, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSha384() {
        (0, $jGAMp._)(this, TermFunctionSha384);
        return (0, $kzDuW._)(this, TermFunctionSha384, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SHA384,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SHA384).onString1Typed(function() {
                    return function(str) {
                        return (0, $aduX6.string)((0, $168PV.sha384)().update(str).digest('hex'));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSha384;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSha384 = $c0252cbfde955d31$var$TermFunctionSha384;

});



parcelRegister("3kz0A", function(module, exports) {
"use strict";
var $26ce654eed0ddf9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26ce654eed0ddf9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $26ce654eed0ddf9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$26ce654eed0ddf9b$var$__exportStar((parcelRequire("2iAbP")), module.exports);

});
parcelRegister("2iAbP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha512 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $bcmqv = parcelRequire("bcmqv");
/**
 * A comunica TermFunctionSha512 Function Factory Actor.
 */ var $1ac955bbe576eb1c$var$ActorFunctionFactoryTermSha512 = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSha512, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSha512(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSha512);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSha512, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SHA512
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSha512, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $bcmqv.TermFunctionSha512()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSha512;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSha512 = $1ac955bbe576eb1c$var$ActorFunctionFactoryTermSha512;

});
parcelRegister("bcmqv", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha512 = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $168PV = parcelRequire("168PV");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha512
 */ var $82723624166ef198$var$TermFunctionSha512 = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSha512, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSha512() {
        (0, $jGAMp._)(this, TermFunctionSha512);
        return (0, $kzDuW._)(this, TermFunctionSha512, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SHA512,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SHA512).onString1Typed(function() {
                    return function(str) {
                        return (0, $aduX6.string)((0, $168PV.sha512)().update(str).digest('hex'));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSha512;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSha512 = $82723624166ef198$var$TermFunctionSha512;

});



parcelRegister("bfIpY", function(module, exports) {
"use strict";
var $83138ce06be804e9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83138ce06be804e9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $83138ce06be804e9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$83138ce06be804e9$var$__exportStar((parcelRequire("gwLq9")), module.exports);

});
parcelRegister("gwLq9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrAfter = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $59gta = parcelRequire("59gta");
/**
 * A comunica TermFunctionStrAfter Function Factory Actor.
 */ var $c0846b4ce9eb1200$var$ActorFunctionFactoryTermStrAfter = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrAfter, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrAfter(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrAfter);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrAfter, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRAFTER
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrAfter, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $59gta.TermFunctionStrAfter()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrAfter;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrAfter = $c0846b4ce9eb1200$var$ActorFunctionFactoryTermStrAfter;

});
parcelRegister("59gta", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrAfter = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strafter
 */ var $3bfa917d66674151$var$TermFunctionStrAfter = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrAfter, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrAfter() {
        (0, $jGAMp._)(this, TermFunctionStrAfter);
        return (0, $kzDuW._)(this, TermFunctionStrAfter, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRAFTER,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRAFTER).onBinaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        return (0, $aduX6.string)(arg1.slice(arg1.indexOf(arg2)).slice(arg2.length));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        var _ref = [
                            arg1.typedValue,
                            arg2.typedValue
                        ], a1 = _ref[0], a2 = _ref[1];
                        var sub = a1.slice(a1.indexOf(a2)).slice(a2.length);
                        return sub || !a2 ? (0, $aduX6.langString)(sub, arg1.language) : (0, $aduX6.string)(sub);
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(arg1, arg2) {
                        if (arg1.language !== arg2.language) throw new $aduX6.IncompatibleLanguageOperation(arg1, arg2);
                        var _ref = [
                            arg1.typedValue,
                            arg2.typedValue
                        ], a1 = _ref[0], a2 = _ref[1];
                        var sub = a1.slice(a1.indexOf(a2)).slice(a2.length);
                        return sub || !a2 ? (0, $aduX6.langString)(sub, arg1.language) : (0, $aduX6.string)(sub);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrAfter;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrAfter = $3bfa917d66674151$var$TermFunctionStrAfter;

});



parcelRegister("fpz1G", function(module, exports) {
"use strict";
var $b3845c4bb7171123$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3845c4bb7171123$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b3845c4bb7171123$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b3845c4bb7171123$var$__exportStar((parcelRequire("8Y4bw")), module.exports);

});
parcelRegister("8Y4bw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrBefore = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $763UT = parcelRequire("763UT");
/**
 * A comunica TermFunctionStrBefore Function Factory Actor.
 */ var $68772c5af2b28168$var$ActorFunctionFactoryTermStrBefore = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrBefore, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrBefore(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrBefore);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrBefore, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRBEFORE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrBefore, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $763UT.TermFunctionStrBefore()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrBefore;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrBefore = $68772c5af2b28168$var$ActorFunctionFactoryTermStrBefore;

});
parcelRegister("763UT", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrBefore = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strbefore
 */ var $52ac21b2eeaea752$var$TermFunctionStrBefore = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrBefore, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrBefore() {
        (0, $jGAMp._)(this, TermFunctionStrBefore);
        return (0, $kzDuW._)(this, TermFunctionStrBefore, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRBEFORE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRBEFORE).onBinaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        return (0, $aduX6.string)(arg1.slice(0, Math.max(0, arg1.indexOf(arg2))));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        var _ref = [
                            arg1.typedValue,
                            arg2.typedValue
                        ], a1 = _ref[0], a2 = _ref[1];
                        var sub = arg1.typedValue.slice(0, Math.max(0, a1.indexOf(a2)));
                        return sub || !a2 ? (0, $aduX6.langString)(sub, arg1.language) : (0, $aduX6.string)(sub);
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(arg1, arg2) {
                        if (arg1.language !== arg2.language) throw new $aduX6.IncompatibleLanguageOperation(arg1, arg2);
                        var _ref = [
                            arg1.typedValue,
                            arg2.typedValue
                        ], a1 = _ref[0], a2 = _ref[1];
                        var sub = arg1.typedValue.slice(0, Math.max(0, a1.indexOf(a2)));
                        return sub || !a2 ? (0, $aduX6.langString)(sub, arg1.language) : (0, $aduX6.string)(sub);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrBefore;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrBefore = $52ac21b2eeaea752$var$TermFunctionStrBefore;

});



parcelRegister("bO2Yg", function(module, exports) {
"use strict";
var $8986ab2f7b4c3101$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8986ab2f7b4c3101$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8986ab2f7b4c3101$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8986ab2f7b4c3101$var$__exportStar((parcelRequire("kejNX")), module.exports);

});
parcelRegister("kejNX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrDt = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $83Ijt = parcelRequire("83Ijt");
/**
 * A comunica TermFunctionStrDt Function Factory Actor.
 */ var $eba47a4757f79775$var$ActorFunctionFactoryTermStrDt = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrDt, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrDt(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrDt);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrDt, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRDT
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrDt, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $83Ijt.TermFunctionStrDt()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrDt;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrDt = $eba47a4757f79775$var$ActorFunctionFactoryTermStrDt;

});
parcelRegister("83Ijt", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrDt = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strdt
 */ var $5de0fa34ba2d0c8a$var$TermFunctionStrDt = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrDt, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrDt() {
        (0, $jGAMp._)(this, TermFunctionStrDt);
        return (0, $kzDuW._)(this, TermFunctionStrDt, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRDT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRDT).set([
                    $aduX6.TypeURL.XSD_STRING,
                    'namedNode'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), str = _param[0], iri = _param[1];
                        var dataFactory = exprEval.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        var lit = dataFactory.literal(str.typedValue, dataFactory.namedNode(iri.value));
                        return new $aduX6.TermTransformer(exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider)).transformLiteral(lit);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrDt;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrDt = $5de0fa34ba2d0c8a$var$TermFunctionStrDt;

});



parcelRegister("04ryT", function(module, exports) {
"use strict";
var $00d5c108b5310b2e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $00d5c108b5310b2e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $00d5c108b5310b2e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$00d5c108b5310b2e$var$__exportStar((parcelRequire("cExAd")), module.exports);

});
parcelRegister("cExAd", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrEnds = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $nHUdA = parcelRequire("nHUdA");
/**
 * A comunica TermFunctionStrEnds Function Factory Actor.
 */ var $9363456356d72514$var$ActorFunctionFactoryTermStrEnds = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrEnds, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrEnds(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrEnds);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrEnds, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRENDS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrEnds, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $nHUdA.TermFunctionStrEnds()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrEnds;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrEnds = $9363456356d72514$var$ActorFunctionFactoryTermStrEnds;

});
parcelRegister("nHUdA", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrEnds = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strends
 */ var $047434dd186a3477$var$TermFunctionStrEnds = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrEnds, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrEnds() {
        (0, $jGAMp._)(this, TermFunctionStrEnds);
        return (0, $kzDuW._)(this, TermFunctionStrEnds, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRENDS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRENDS).onBinaryTyped([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        return (0, $aduX6.bool)(arg1.endsWith(arg2));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(arg1, arg2) {
                        if (arg1.language !== arg2.language) throw new $aduX6.IncompatibleLanguageOperation(arg1, arg2);
                        return (0, $aduX6.bool)(arg1.typedValue.endsWith(arg2.typedValue));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrEnds;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrEnds = $047434dd186a3477$var$TermFunctionStrEnds;

});



parcelRegister("7lURB", function(module, exports) {
"use strict";
var $55a69a81b91ed34d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55a69a81b91ed34d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $55a69a81b91ed34d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$55a69a81b91ed34d$var$__exportStar((parcelRequire("k3TIh")), module.exports);

});
parcelRegister("k3TIh", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrLang = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $3mMxD = parcelRequire("3mMxD");
/**
 * A comunica TermFunctionStrLang Function Factory Actor.
 */ var $e9af4df25e087688$var$ActorFunctionFactoryTermStrLang = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrLang, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrLang(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrLang);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrLang, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRLANG
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrLang, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $3mMxD.TermFunctionStrLang()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrLang;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrLang = $e9af4df25e087688$var$ActorFunctionFactoryTermStrLang;

});
parcelRegister("3mMxD", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrLang = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strlang
 */ var $2739147daf7f4ce3$var$TermFunctionStrLang = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrLang, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrLang() {
        (0, $jGAMp._)(this, TermFunctionStrLang);
        return (0, $kzDuW._)(this, TermFunctionStrLang, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRLANG,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRLANG).onBinaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(val, language) {
                        return new $aduX6.LangStringLiteral(val, language.toLowerCase());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrLang;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrLang = $2739147daf7f4ce3$var$TermFunctionStrLang;

});



parcelRegister("98mTy", function(module, exports) {
"use strict";
var $6a669ee028247c27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6a669ee028247c27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6a669ee028247c27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6a669ee028247c27$var$__exportStar((parcelRequire("45qU0")), module.exports);

});
parcelRegister("45qU0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrLen = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $KS8N3 = parcelRequire("KS8N3");
/**
 * A comunica TermFunctionStrLen Function Factory Actor.
 */ var $2f9c7f487b116a29$var$ActorFunctionFactoryTermStrLen = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrLen, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrLen(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrLen);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrLen, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRLEN
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrLen, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $KS8N3.TermFunctionStrLen()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrLen;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrLen = $2f9c7f487b116a29$var$ActorFunctionFactoryTermStrLen;

});
parcelRegister("KS8N3", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrLen = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strlen
 */ var $08ce4b3916e3aa20$var$TermFunctionStrLen = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrLen, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrLen() {
        (0, $jGAMp._)(this, TermFunctionStrLen);
        return (0, $kzDuW._)(this, TermFunctionStrLen, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.STRLEN,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRLEN).onStringly1(function() {
                    return function(str) {
                        return (0, $aduX6.integer)((0, $7WNf6._)(str.typedValue).length);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrLen;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrLen = $08ce4b3916e3aa20$var$TermFunctionStrLen;

});



parcelRegister("l0rRO", function(module, exports) {
"use strict";
var $f4af36ddf2b4c3f1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4af36ddf2b4c3f1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4af36ddf2b4c3f1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4af36ddf2b4c3f1$var$__exportStar((parcelRequire("63PMx")), module.exports);

});
parcelRegister("63PMx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrStarts = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $9tHuS = parcelRequire("9tHuS");
/**
 * A comunica TermFunctionStrStarts Function Factory Actor.
 */ var $469b30b676847ddf$var$ActorFunctionFactoryTermStrStarts = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrStarts, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrStarts(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrStarts);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrStarts, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRSTARTS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrStarts, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $9tHuS.TermFunctionStrStarts()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrStarts;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrStarts = $469b30b676847ddf$var$ActorFunctionFactoryTermStrStarts;

});
parcelRegister("9tHuS", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrStarts = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strstarts
 * for this and the following functions you'll see (string, langstring) is not allowed. This behaviour is defined in:
 * https://www.w3.org/TR/sparql11-query/#func-arg-compatibility
 */ var $01c7e14ac5e13fd7$var$TermFunctionStrStarts = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrStarts, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrStarts() {
        (0, $jGAMp._)(this, TermFunctionStrStarts);
        return (0, $kzDuW._)(this, TermFunctionStrStarts, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.STRSTARTS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRSTARTS).onBinaryTyped([
                    $aduX6.TypeAlias.SPARQL_STRINGLY,
                    $aduX6.TypeURL.XSD_STRING
                ], function() {
                    return function(arg1, arg2) {
                        return (0, $aduX6.bool)(arg1.startsWith(arg2));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.RDF_LANG_STRING
                ], function() {
                    return function(arg1, arg2) {
                        if (arg1.language !== arg2.language) throw new $aduX6.IncompatibleLanguageOperation(arg1, arg2);
                        return (0, $aduX6.bool)(arg1.typedValue.startsWith(arg2.typedValue));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrStarts;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrStarts = $01c7e14ac5e13fd7$var$TermFunctionStrStarts;

});



parcelRegister("5NCvw", function(module, exports) {
"use strict";
var $438f66233bd6fa03$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $438f66233bd6fa03$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $438f66233bd6fa03$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$438f66233bd6fa03$var$__exportStar((parcelRequire("aX4Du")), module.exports);

});
parcelRegister("aX4Du", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrUuid = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dN63P = parcelRequire("dN63P");
/**
 * A comunica TermFunctionStrUuid Function Factory Actor.
 */ var $7f9302a83640f002$var$ActorFunctionFactoryTermStrUuid = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStrUuid, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStrUuid(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStrUuid);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStrUuid, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STRUUID
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStrUuid, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $dN63P.TermFunctionStrUuid()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStrUuid;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStrUuid = $7f9302a83640f002$var$ActorFunctionFactoryTermStrUuid;

});
parcelRegister("dN63P", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrUuid = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dVrhd = parcelRequire("dVrhd");
/**
 * https://www.w3.org/TR/sparql11-query/#func-struuid
 */ var $a0a48d87966d5c9d$var$TermFunctionStrUuid = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStrUuid, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStrUuid() {
        (0, $jGAMp._)(this, TermFunctionStrUuid);
        return (0, $kzDuW._)(this, TermFunctionStrUuid, [
            {
                arity: 0,
                operator: $aduX6.SparqlOperator.STRUUID,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STRUUID).set([], function() {
                    return function() {
                        return (0, $aduX6.string)($dVrhd.default());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStrUuid;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStrUuid = $a0a48d87966d5c9d$var$TermFunctionStrUuid;

});
parcelRegister("dVrhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a235c1d479e3f5b3$export$2e2bcd8739ae039; });

var $aPyel = parcelRequire("aPyel");

var $hO1Fy = parcelRequire("hO1Fy");

var $dQQIX = parcelRequire("dQQIX");
function $a235c1d479e3f5b3$var$v4(options, buf, offset) {
    var _options_rng;
    if ((0, $aPyel.default).randomUUID && !buf && !options) return (0, $aPyel.default).randomUUID();
    options = options || {};
    var _options_random, _ref;
    var rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, $hO1Fy.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError("UUID byte range ".concat(offset, ":").concat(offset + 15, " is out of buffer bounds"));
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dQQIX.unsafeStringify)(rnds);
}
var $a235c1d479e3f5b3$export$2e2bcd8739ae039 = $a235c1d479e3f5b3$var$v4;

});
parcelRegister("aPyel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e293839b75ab9f2$export$2e2bcd8739ae039; });
var $7e293839b75ab9f2$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7e293839b75ab9f2$export$2e2bcd8739ae039 = {
    randomUUID: $7e293839b75ab9f2$var$randomUUID
};

});

parcelRegister("hO1Fy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf6866a84bf5515b$export$2e2bcd8739ae039; });
var $cf6866a84bf5515b$var$getRandomValues;
var $cf6866a84bf5515b$var$rnds8 = new Uint8Array(16);
function $cf6866a84bf5515b$export$2e2bcd8739ae039() {
    if (!$cf6866a84bf5515b$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $cf6866a84bf5515b$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $cf6866a84bf5515b$var$getRandomValues($cf6866a84bf5515b$var$rnds8);
}

});

parcelRegister("dQQIX", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $a15907a0969828ea$export$8fb373d660548968; });

var $5Demw = parcelRequire("5Demw");
var $a15907a0969828ea$var$byteToHex = [];
for(var $a15907a0969828ea$var$i = 0; $a15907a0969828ea$var$i < 256; ++$a15907a0969828ea$var$i)$a15907a0969828ea$var$byteToHex.push(($a15907a0969828ea$var$i + 0x100).toString(16).slice(1));
function $a15907a0969828ea$export$8fb373d660548968(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return ($a15907a0969828ea$var$byteToHex[arr[offset + 0]] + $a15907a0969828ea$var$byteToHex[arr[offset + 1]] + $a15907a0969828ea$var$byteToHex[arr[offset + 2]] + $a15907a0969828ea$var$byteToHex[arr[offset + 3]] + '-' + $a15907a0969828ea$var$byteToHex[arr[offset + 4]] + $a15907a0969828ea$var$byteToHex[arr[offset + 5]] + '-' + $a15907a0969828ea$var$byteToHex[arr[offset + 6]] + $a15907a0969828ea$var$byteToHex[arr[offset + 7]] + '-' + $a15907a0969828ea$var$byteToHex[arr[offset + 8]] + $a15907a0969828ea$var$byteToHex[arr[offset + 9]] + '-' + $a15907a0969828ea$var$byteToHex[arr[offset + 10]] + $a15907a0969828ea$var$byteToHex[arr[offset + 11]] + $a15907a0969828ea$var$byteToHex[arr[offset + 12]] + $a15907a0969828ea$var$byteToHex[arr[offset + 13]] + $a15907a0969828ea$var$byteToHex[arr[offset + 14]] + $a15907a0969828ea$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $a15907a0969828ea$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = $a15907a0969828ea$export$8fb373d660548968(arr, offset);
    if (!(0, $5Demw.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $a15907a0969828ea$export$2e2bcd8739ae039 = $a15907a0969828ea$var$stringify;

});
parcelRegister("5Demw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $419bbc4a153fe1eb$export$2e2bcd8739ae039; });

var $evwZl = parcelRequire("evwZl");
function $419bbc4a153fe1eb$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $evwZl.default).test(uuid);
}
var $419bbc4a153fe1eb$export$2e2bcd8739ae039 = $419bbc4a153fe1eb$var$validate;

});
parcelRegister("evwZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8fd8cbd7f7d84a2$export$2e2bcd8739ae039; });
var $a8fd8cbd7f7d84a2$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});







parcelRegister("9WRq4", function(module, exports) {
"use strict";
var $73e2f7d14e7d3f40$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $73e2f7d14e7d3f40$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $73e2f7d14e7d3f40$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$73e2f7d14e7d3f40$var$__exportStar((parcelRequire("kybdG")), module.exports);

});
parcelRegister("kybdG", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $6tVIB = parcelRequire("6tVIB");
/**
 * A comunica TermFunctionStr Function Factory Actor.
 */ var $ef5fafa22f9be2df$var$ActorFunctionFactoryTermStr = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermStr, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermStr(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermStr);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermStr, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.STR
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermStr, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $6tVIB.TermFunctionStr()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermStr;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermStr = $ef5fafa22f9be2df$var$ActorFunctionFactoryTermStr;

});
parcelRegister("6tVIB", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-str
 */ var $4b82392dcabbb993$var$TermFunctionStr = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionStr, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionStr() {
        (0, $jGAMp._)(this, TermFunctionStr);
        return (0, $kzDuW._)(this, TermFunctionStr, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.STR,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.STR).onTerm1(function() {
                    return function(term) {
                        return (0, $aduX6.string)(term.str());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionStr;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionStr = $4b82392dcabbb993$var$TermFunctionStr;

});



parcelRegister("6phxZ", function(module, exports) {
"use strict";
var $01342c229eeda1c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $01342c229eeda1c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $01342c229eeda1c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$01342c229eeda1c8$var$__exportStar((parcelRequire("3bp2Z")), module.exports);

});
parcelRegister("3bp2Z", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubStr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $kO1Cx = parcelRequire("kO1Cx");
/**
 * A comunica TermFunctionSubStr Function Factory Actor.
 */ var $2515d4040d4c1de5$var$ActorFunctionFactoryTermSubStr = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSubStr, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSubStr(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSubStr);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSubStr, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SUBSTR
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSubStr, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $kO1Cx.TermFunctionSubStr()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSubStr;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSubStr = $2515d4040d4c1de5$var$ActorFunctionFactoryTermSubStr;

});
parcelRegister("kO1Cx", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubStr = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-substr
 */ var $f259bbf7759694bf$var$TermFunctionSubStr = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSubStr, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSubStr() {
        (0, $jGAMp._)(this, TermFunctionSubStr);
        return (0, $kzDuW._)(this, TermFunctionSubStr, [
            {
                arity: [
                    2,
                    3
                ],
                operator: $aduX6.SparqlOperator.SUBSTR,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SUBSTR).onBinaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_INTEGER
                ], function() {
                    return function(source, startingLoc) {
                        return (0, $aduX6.string)((0, $7WNf6._)(source).slice(startingLoc - 1).join(''));
                    };
                }).onBinary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_INTEGER
                ], function() {
                    return function(source, startingLoc) {
                        var sub = (0, $7WNf6._)(source.typedValue).slice(startingLoc.typedValue - 1).join('');
                        return (0, $aduX6.langString)(sub, source.language);
                    };
                }).onTernaryTyped([
                    $aduX6.TypeURL.XSD_STRING,
                    $aduX6.TypeURL.XSD_INTEGER,
                    $aduX6.TypeURL.XSD_INTEGER
                ], function() {
                    return function(source, startingLoc, length) {
                        return (0, $aduX6.string)((0, $7WNf6._)(source).slice(startingLoc - 1, length + startingLoc - 1).join(''));
                    };
                }).onTernary([
                    $aduX6.TypeURL.RDF_LANG_STRING,
                    $aduX6.TypeURL.XSD_INTEGER,
                    $aduX6.TypeURL.XSD_INTEGER
                ], function() {
                    return function(source, startingLoc, length) {
                        var sub = (0, $7WNf6._)(source.typedValue).slice(startingLoc.typedValue - 1, length.typedValue + startingLoc.typedValue - 1).join('');
                        return (0, $aduX6.langString)(sub, source.language);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSubStr;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSubStr = $f259bbf7759694bf$var$TermFunctionSubStr;

});



parcelRegister("1PbTR", function(module, exports) {
"use strict";
var $1543c8f83c7e6b40$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1543c8f83c7e6b40$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1543c8f83c7e6b40$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1543c8f83c7e6b40$var$__exportStar((parcelRequire("b8Lw4")), module.exports);

});
parcelRegister("b8Lw4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubject = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $gNFqu = parcelRequire("gNFqu");
/**
 * A comunica TermFunctionSubject Function Factory Actor.
 */ var $81c54cc7750891d7$var$ActorFunctionFactoryTermSubject = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSubject, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSubject(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSubject);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSubject, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SUBJECT
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSubject, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $gNFqu.TermFunctionSubject()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSubject;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSubject = $81c54cc7750891d7$var$ActorFunctionFactoryTermSubject;

});
parcelRegister("gNFqu", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubject = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#subject
 */ var $c3b15b5221ca3050$var$TermFunctionSubject = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSubject, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSubject() {
        (0, $jGAMp._)(this, TermFunctionSubject);
        return (0, $kzDuW._)(this, TermFunctionSubject, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.SUBJECT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SUBJECT).onQuad1(function() {
                    return function(quad) {
                        return quad.subject;
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSubject;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSubject = $c3b15b5221ca3050$var$TermFunctionSubject;

});



parcelRegister("jK0VQ", function(module, exports) {
"use strict";
var $e5f3093f38c19af5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5f3093f38c19af5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5f3093f38c19af5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5f3093f38c19af5$var$__exportStar((parcelRequire("lameI")), module.exports);

});
parcelRegister("lameI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubtraction = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $jw4zo = parcelRequire("jw4zo");
/**
 * A comunica TermFunctionSubtraction Function Factory Actor.
 */ var $f68bc7ce10b6d5b9$var$ActorFunctionFactoryTermSubtraction = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermSubtraction, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermSubtraction(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermSubtraction);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermSubtraction, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.SUBTRACTION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermSubtraction, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $jw4zo.TermFunctionSubtraction()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermSubtraction;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermSubtraction = $f68bc7ce10b6d5b9$var$ActorFunctionFactoryTermSubtraction;

});
parcelRegister("jw4zo", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubtraction = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");

var $56IvR = parcelRequire("56IvR");
var $e3548cf4ce2b7a7f$var$TermFunctionSubtraction = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionSubtraction, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionSubtraction() {
        (0, $jGAMp._)(this, TermFunctionSubtraction);
        return (0, $kzDuW._)(this, TermFunctionSubtraction, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.SUBTRACTION,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.SUBTRACTION).arithmetic(function() {
                    return function(left, right) {
                        return new $56IvR.BigNumber(left).minus(right).toNumber();
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DATE_TIME,
                    $aduX6.TypeURL.XSD_DATE_TIME
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), date1 = _param[0], date2 = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-subtract-dateTimes;
                        new $aduX6.DayTimeDurationLiteral((0, $aduX6.elapsedDuration)(date1.typedValue, date2.typedValue, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_DATE
                    ]
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_TIME,
                        $aduX6.TypeURL.XSD_TIME
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_DATE_TIME,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), date = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-dateTime
                        new $aduX6.DateTimeLiteral((0, $aduX6.addDurationToDateTime)(date.typedValue, (0, $aduX6.defaultedDurationRepresentation)((0, $aduX6.negateDuration)(dur.typedValue)))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_DATE,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), date = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-date
                        new $aduX6.DateLiteral((0, $aduX6.addDurationToDateTime)((0, $aduX6.defaultedDateTimeRepresentation)(date.typedValue), (0, $aduX6.defaultedDurationRepresentation)((0, $aduX6.negateDuration)(dur.typedValue)))));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_TIME,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), time = _param[0], dur = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-date
                        new $aduX6.TimeLiteral((0, $aduX6.addDurationToDateTime)((0, $aduX6.defaultedDateTimeRepresentation)(time.typedValue), (0, $aduX6.defaultedDurationRepresentation)((0, $aduX6.negateDuration)(dur.typedValue)))));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionSubtraction;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionSubtraction = $e3548cf4ce2b7a7f$var$TermFunctionSubtraction;

});



parcelRegister("5RCgw", function(module, exports) {
"use strict";
var $444f95b7b5cbafc9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $444f95b7b5cbafc9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $444f95b7b5cbafc9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$444f95b7b5cbafc9$var$__exportStar((parcelRequire("d3Cnr")), module.exports);

});
parcelRegister("d3Cnr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTimezone = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $eMoGV = parcelRequire("eMoGV");
/**
 * A comunica TermFunctionTimezone Function Factory Actor.
 */ var $981953130c07ef37$var$ActorFunctionFactoryTermTimezone = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermTimezone, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermTimezone(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermTimezone);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermTimezone, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.TIMEZONE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermTimezone, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $eMoGV.TermFunctionTimezone()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermTimezone;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermTimezone = $981953130c07ef37$var$ActorFunctionFactoryTermTimezone;

});
parcelRegister("eMoGV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTimezone = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-timezone
 */ var $ac28b39532bc6dab$var$TermFunctionTimezone = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionTimezone, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionTimezone() {
        (0, $jGAMp._)(this, TermFunctionTimezone);
        return (0, $kzDuW._)(this, TermFunctionTimezone, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.TIMEZONE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.TIMEZONE).onDateTime1(function() {
                    return function(date) {
                        var duration = {
                            hours: date.typedValue.zoneHours,
                            minutes: date.typedValue.zoneMinutes
                        };
                        if (duration.hours === undefined && duration.minutes === undefined) throw new $aduX6.InvalidTimezoneCall(date.str());
                        return new $aduX6.DayTimeDurationLiteral(duration);
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE
                    ]
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_TIME
                    ]
                }).collect()
            }
        ]);
    }
    return TermFunctionTimezone;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionTimezone = $ac28b39532bc6dab$var$TermFunctionTimezone;

});



parcelRegister("446W0", function(module, exports) {
"use strict";
var $2f5cea3ba87b3288$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2f5cea3ba87b3288$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2f5cea3ba87b3288$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2f5cea3ba87b3288$var$__exportStar((parcelRequire("bHrKW")), module.exports);

});
parcelRegister("bHrKW", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTriple = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $1hA1m = parcelRequire("1hA1m");
/**
 * A comunica TermFunctionTriple Function Factory Actor.
 */ var $88493da3a142d042$var$ActorFunctionFactoryTermTriple = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermTriple, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermTriple(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermTriple);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermTriple, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.TRIPLE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermTriple, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $1hA1m.TermFunctionTriple()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermTriple;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermTriple = $88493da3a142d042$var$ActorFunctionFactoryTermTriple;

});
parcelRegister("1hA1m", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTriple = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#triple-function
 */ var $0ef35200e9e07525$var$TermFunctionTriple = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionTriple, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionTriple() {
        (0, $jGAMp._)(this, TermFunctionTriple);
        return (0, $kzDuW._)(this, TermFunctionTriple, [
            {
                arity: 3,
                operator: $aduX6.SparqlOperator.TRIPLE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.TRIPLE).onTerm3(function(_) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return new $aduX6.Quad(args[0], args[1], args[2], new $aduX6.DefaultGraph());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionTriple;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionTriple = $0ef35200e9e07525$var$TermFunctionTriple;

});



parcelRegister("8ayCt", function(module, exports) {
"use strict";
var $5f2a1c9dfbda7983$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5f2a1c9dfbda7983$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5f2a1c9dfbda7983$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5f2a1c9dfbda7983$var$__exportStar((parcelRequire("fLBFT")), module.exports);

});
parcelRegister("fLBFT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTz = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dkYaE = parcelRequire("dkYaE");
/**
 * A comunica TermFunctionTz Function Factory Actor.
 */ var $b7a8783899886bf0$var$ActorFunctionFactoryTermTz = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermTz, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermTz(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermTz);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermTz, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.TZ
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermTz, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $dkYaE.TermFunctionTz()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermTz;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermTz = $b7a8783899886bf0$var$ActorFunctionFactoryTermTz;

});
parcelRegister("dkYaE", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTz = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-tz
 */ var $9b5bd14cc266e1a0$var$TermFunctionTz = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionTz, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionTz() {
        (0, $jGAMp._)(this, TermFunctionTz);
        return (0, $kzDuW._)(this, TermFunctionTz, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.TZ,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.TZ).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.string)((0, $aduX6.extractRawTimeZone)(date.str()));
                    };
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE
                    ]
                }).copy({
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_TIME
                    ]
                }).collect()
            }
        ]);
    }
    return TermFunctionTz;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionTz = $9b5bd14cc266e1a0$var$TermFunctionTz;

});



parcelRegister("9ojU7", function(module, exports) {
"use strict";
var $6d65cb80ec497c8f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d65cb80ec497c8f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d65cb80ec497c8f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6d65cb80ec497c8f$var$__exportStar((parcelRequire("h8E9u")), module.exports);

});
parcelRegister("h8E9u", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUcase = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $k5Jod = parcelRequire("k5Jod");
/**
 * A comunica TermFunctionUcase Function Factory Actor.
 */ var $c7a25469401213cf$var$ActorFunctionFactoryTermUcase = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermUcase, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermUcase(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermUcase);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermUcase, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.UCASE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermUcase, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $k5Jod.TermFunctionUcase()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermUcase;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermUcase = $c7a25469401213cf$var$ActorFunctionFactoryTermUcase;

});
parcelRegister("k5Jod", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUcase = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-ucase
 */ var $ea077bb522f9e455$var$TermFunctionUcase = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionUcase, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionUcase() {
        (0, $jGAMp._)(this, TermFunctionUcase);
        return (0, $kzDuW._)(this, TermFunctionUcase, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.UCASE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.UCASE).onString1Typed(function() {
                    return function(lit) {
                        return (0, $aduX6.string)(lit.toUpperCase());
                    };
                }).onLangString1(function() {
                    return function(lit) {
                        return (0, $aduX6.langString)(lit.typedValue.toUpperCase(), lit.language);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionUcase;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionUcase = $ea077bb522f9e455$var$TermFunctionUcase;

});



parcelRegister("bUWt8", function(module, exports) {
"use strict";
var $8ad247639c304600$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ad247639c304600$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ad247639c304600$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8ad247639c304600$var$__exportStar((parcelRequire("deLQG")), module.exports);

});
parcelRegister("deLQG", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUnaryMinus = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $a6Hnb = parcelRequire("a6Hnb");
/**
 * A comunica TermFunctionUnaryMinus Function Factory Actor.
 */ var $9a31b2e8413b32bc$var$ActorFunctionFactoryTermUnaryMinus = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermUnaryMinus, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermUnaryMinus(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermUnaryMinus);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermUnaryMinus, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.UMINUS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermUnaryMinus, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $a6Hnb.TermFunctionUnaryMinus()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermUnaryMinus;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermUnaryMinus = $9a31b2e8413b32bc$var$ActorFunctionFactoryTermUnaryMinus;

});
parcelRegister("a6Hnb", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUnaryMinus = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $75bc1be6558225c9$var$TermFunctionUnaryMinus = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionUnaryMinus, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionUnaryMinus() {
        (0, $jGAMp._)(this, TermFunctionUnaryMinus);
        return (0, $kzDuW._)(this, TermFunctionUnaryMinus, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.UMINUS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.UMINUS).numericConverter(function() {
                    return function(val) {
                        return -val;
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionUnaryMinus;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionUnaryMinus = $75bc1be6558225c9$var$TermFunctionUnaryMinus;

});



parcelRegister("8xIuJ", function(module, exports) {
"use strict";
var $6383eb7f3c0c36b2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6383eb7f3c0c36b2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6383eb7f3c0c36b2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6383eb7f3c0c36b2$var$__exportStar((parcelRequire("6ulrb")), module.exports);

});
parcelRegister("6ulrb", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUnaryPlus = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $gsCQp = parcelRequire("gsCQp");
/**
 * A comunica TermFunctionUnaryPlus Function Factory Actor.
 */ var $4b962c6f2bc54d33$var$ActorFunctionFactoryTermUnaryPlus = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermUnaryPlus, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermUnaryPlus(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermUnaryPlus);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermUnaryPlus, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.UPLUS
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermUnaryPlus, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $gsCQp.TermFunctionUnaryPlus()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermUnaryPlus;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermUnaryPlus = $4b962c6f2bc54d33$var$ActorFunctionFactoryTermUnaryPlus;

});
parcelRegister("gsCQp", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUnaryPlus = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $bfbd64851e157f61$var$TermFunctionUnaryPlus = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionUnaryPlus, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionUnaryPlus() {
        (0, $jGAMp._)(this, TermFunctionUnaryPlus);
        return (0, $kzDuW._)(this, TermFunctionUnaryPlus, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.UPLUS,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.UPLUS).numericConverter(function() {
                    return function(val) {
                        return val;
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionUnaryPlus;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionUnaryPlus = $bfbd64851e157f61$var$TermFunctionUnaryPlus;

});



parcelRegister("8BVL0", function(module, exports) {
"use strict";
var $644e94cc1d2a2164$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $644e94cc1d2a2164$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $644e94cc1d2a2164$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$644e94cc1d2a2164$var$__exportStar((parcelRequire("8s6Pv")), module.exports);

});
parcelRegister("8s6Pv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUuid = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $erRYc = parcelRequire("erRYc");
/**
 * A comunica TermFunctionUuid Function Factory Actor.
 */ var $62763c8559209680$var$ActorFunctionFactoryTermUuid = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermUuid, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermUuid(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermUuid);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermUuid, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.UUID
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermUuid, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $erRYc.TermFunctionUuid()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermUuid;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermUuid = $62763c8559209680$var$ActorFunctionFactoryTermUuid;

});
parcelRegister("erRYc", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUuid = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dVrhd = parcelRequire("dVrhd");
/**
 * https://www.w3.org/TR/sparql11-query/#func-uuid
 */ var $a84d739e44fe1561$var$TermFunctionUuid = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionUuid, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionUuid() {
        (0, $jGAMp._)(this, TermFunctionUuid);
        return (0, $kzDuW._)(this, TermFunctionUuid, [
            {
                arity: 0,
                operator: $aduX6.SparqlOperator.UUID,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.UUID).set([], function() {
                    return function() {
                        return new $aduX6.NamedNode("urn:uuid:".concat($dVrhd.default()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionUuid;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionUuid = $a84d739e44fe1561$var$TermFunctionUuid;

});



parcelRegister("jVMit", function(module, exports) {
"use strict";
var $e828cdf59a4971f2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e828cdf59a4971f2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e828cdf59a4971f2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e828cdf59a4971f2$var$__exportStar((parcelRequire("dApgj")), module.exports);

});
parcelRegister("dApgj", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToBoolean = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $512UY = parcelRequire("512UY");
/**
 * A comunica TermFunctionXsdToBoolean Function Factory Actor.
 */ var $9e423ba9f2fe30d5$var$ActorFunctionFactoryTermXsdToBoolean = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToBoolean, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToBoolean(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToBoolean);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToBoolean, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_BOOLEAN
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToBoolean, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $512UY.TermFunctionXsdToBoolean()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToBoolean;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToBoolean = $9e423ba9f2fe30d5$var$ActorFunctionFactoryTermXsdToBoolean;

});
parcelRegister("512UY", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToBoolean = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $3a6f4f312afe0145$var$TermFunctionXsdToBoolean = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToBoolean, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToBoolean() {
        (0, $jGAMp._)(this, TermFunctionXsdToBoolean);
        return (0, $kzDuW._)(this, TermFunctionXsdToBoolean, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_BOOLEAN,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_BOOLEAN).onNumeric1(function() {
                    return function(val) {
                        return (0, $aduX6.bool)(val.coerceEBV());
                    };
                }, true).onUnary($aduX6.TypeURL.XSD_BOOLEAN, function() {
                    return function(val) {
                        return (0, $aduX6.bool)(val.coerceEBV());
                    };
                }, true).onUnary($aduX6.TypeURL.XSD_STRING, function() {
                    return function(val) {
                        switch(val.str()){
                            case 'true':
                                return (0, $aduX6.bool)(true);
                            case 'false':
                                return (0, $aduX6.bool)(false);
                            case '1':
                                return (0, $aduX6.bool)(true);
                            case '0':
                                return (0, $aduX6.bool)(false);
                            default:
                                throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_BOOLEAN);
                        }
                    };
                }, false).collect()
            }
        ]);
    }
    return TermFunctionXsdToBoolean;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToBoolean = $3a6f4f312afe0145$var$TermFunctionXsdToBoolean;

});



parcelRegister("e8Qpy", function(module, exports) {
"use strict";
var $a4ba77c9e8c07684$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a4ba77c9e8c07684$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a4ba77c9e8c07684$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a4ba77c9e8c07684$var$__exportStar((parcelRequire("1BR9j")), module.exports);

});
parcelRegister("1BR9j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDate = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $jqE0P = parcelRequire("jqE0P");
/**
 * A comunica TermFunctionXsdToDate Function Factory Actor.
 */ var $12c2797708ec0052$var$ActorFunctionFactoryTermXsdToDate = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDate, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDate(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDate);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDate, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DATE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDate, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $jqE0P.TermFunctionXsdToDate()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDate;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDate = $12c2797708ec0052$var$ActorFunctionFactoryTermXsdToDate;

});
parcelRegister("jqE0P", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDate = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $e24f7ba82c4d9ae1$var$TermFunctionXsdToDate = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDate, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDate() {
        (0, $jGAMp._)(this, TermFunctionXsdToDate);
        return (0, $kzDuW._)(this, TermFunctionXsdToDate, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DATE,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DATE).onUnary($aduX6.TypeURL.XSD_DATE, function() {
                    return function(val) {
                        return new $aduX6.DateLiteral(val.typedValue, val.strValue);
                    };
                }).onUnary($aduX6.TypeURL.XSD_DATE_TIME, function() {
                    return function(val) {
                        return new $aduX6.DateLiteral(val.typedValue);
                    };
                }).onStringly1(function() {
                    return function(val) {
                        return new $aduX6.DateLiteral((0, $aduX6.parseDate)(val.str()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToDate;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDate = $e24f7ba82c4d9ae1$var$TermFunctionXsdToDate;

});



parcelRegister("eywyp", function(module, exports) {
"use strict";
var $a98d7e331f482f11$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a98d7e331f482f11$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a98d7e331f482f11$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a98d7e331f482f11$var$__exportStar((parcelRequire("iYBIK")), module.exports);

});
parcelRegister("iYBIK", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDatetime = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $X2Ux5 = parcelRequire("X2Ux5");
/**
 * A comunica TermFunctionXsdToDatetime Function Factory Actor.
 */ var $dd0b1721109333c8$var$ActorFunctionFactoryTermXsdToDatetime = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDatetime, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDatetime(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDatetime);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDatetime, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DATE_TIME
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDatetime, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $X2Ux5.TermFunctionXsdToDatetime()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDatetime;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDatetime = $dd0b1721109333c8$var$ActorFunctionFactoryTermXsdToDatetime;

});
parcelRegister("X2Ux5", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDatetime = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $0b17c4d498a24363$var$TermFunctionXsdToDatetime = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDatetime, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDatetime() {
        (0, $jGAMp._)(this, TermFunctionXsdToDatetime);
        return (0, $kzDuW._)(this, TermFunctionXsdToDatetime, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DATE_TIME,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DATE_TIME).onUnary($aduX6.TypeURL.XSD_DATE_TIME, function() {
                    return function(val) {
                        return val;
                    };
                }).onUnary($aduX6.TypeURL.XSD_STRING, function() {
                    return function(val) {
                        return (0, $aduX6.dateTime)((0, $aduX6.parseDateTime)(val.str()), val.str());
                    };
                }, false).onUnary($aduX6.TypeURL.XSD_DATE, function() {
                    return function(val) {
                        return new $aduX6.DateTimeLiteral((0, $emQHU._)((0, $iT0je._)({}, val.typedValue), {
                            hours: 0,
                            minutes: 0,
                            seconds: 0
                        }));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToDatetime;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDatetime = $0b17c4d498a24363$var$TermFunctionXsdToDatetime;

});



parcelRegister("eV8N9", function(module, exports) {
"use strict";
var $adcd356f3d25f84e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $adcd356f3d25f84e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $adcd356f3d25f84e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$adcd356f3d25f84e$var$__exportStar((parcelRequire("emPm0")), module.exports);

});
parcelRegister("emPm0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDayTimeDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $3DaTW = parcelRequire("3DaTW");
/**
 * A comunica TermFunctionXsdToDayTimeDuration Function Factory Actor.
 */ var $a75af49807389637$var$ActorFunctionFactoryTermXsdToDayTimeDuration = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDayTimeDuration, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDayTimeDuration(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDayTimeDuration);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDayTimeDuration, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDayTimeDuration, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $3DaTW.TermFunctionXsdToDayTimeDuration()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDayTimeDuration;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDayTimeDuration = $a75af49807389637$var$ActorFunctionFactoryTermXsdToDayTimeDuration;

});
parcelRegister("3DaTW", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDayTimeDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $2a4d7860d179bacc$var$TermFunctionXsdToDayTimeDuration = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDayTimeDuration, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDayTimeDuration() {
        (0, $jGAMp._)(this, TermFunctionXsdToDayTimeDuration);
        return (0, $kzDuW._)(this, TermFunctionXsdToDayTimeDuration, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DAY_TIME_DURATION,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DAY_TIME_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
                .onUnary($aduX6.TypeURL.XSD_DURATION, function() {
                    return function(val) {
                        return(// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                        new $aduX6.DayTimeDurationLiteral((0, $aduX6.trimToDayTimeDuration)(val.typedValue)));
                    };
                }).onStringly1(function() {
                    return function(val) {
                        return new $aduX6.DayTimeDurationLiteral((0, $aduX6.parseDayTimeDuration)(val.str()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToDayTimeDuration;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDayTimeDuration = $2a4d7860d179bacc$var$TermFunctionXsdToDayTimeDuration;

});



parcelRegister("9vlPs", function(module, exports) {
"use strict";
var $6eb7f117a0dbdc4b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6eb7f117a0dbdc4b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6eb7f117a0dbdc4b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6eb7f117a0dbdc4b$var$__exportStar((parcelRequire("c3AVh")), module.exports);

});
parcelRegister("c3AVh", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDecimal = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $gET5o = parcelRequire("gET5o");
/**
 * A comunica TermFunctionXsdToDecimal Function Factory Actor.
 */ var $8c7267f363697af0$var$ActorFunctionFactoryTermXsdToDecimal = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDecimal, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDecimal(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDecimal);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDecimal, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DECIMAL
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDecimal, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $gET5o.TermFunctionXsdToDecimal()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDecimal;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDecimal = $8c7267f363697af0$var$ActorFunctionFactoryTermXsdToDecimal;

});
parcelRegister("gET5o", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDecimal = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $c20b1cb88fa85dee$var$TermFunctionXsdToDecimal = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDecimal, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDecimal() {
        (0, $jGAMp._)(this, TermFunctionXsdToDecimal);
        return (0, $kzDuW._)(this, TermFunctionXsdToDecimal, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DECIMAL,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DECIMAL).onNumeric1(function() {
                    return function(val) {
                        var result = (0, $aduX6.parseXSDDecimal)(val.str());
                        if (result === undefined) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_DECIMAL);
                        return (0, $aduX6.decimal)(result);
                    };
                }).onString1(function() {
                    return function(val) {
                        var str = val.str();
                        var result = RegExp("^([+-])?(\\d+(\\.\\d+)?)$", "u").test(str) ? (0, $aduX6.parseXSDDecimal)(str) : undefined;
                        if (result === undefined) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_DECIMAL);
                        return (0, $aduX6.decimal)(result);
                    };
                }, false).onBoolean1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.decimal)(val ? 1 : 0);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToDecimal;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDecimal = $c20b1cb88fa85dee$var$TermFunctionXsdToDecimal;

});



parcelRegister("eE7o6", function(module, exports) {
"use strict";
var $aa9a8831d6e71540$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aa9a8831d6e71540$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aa9a8831d6e71540$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aa9a8831d6e71540$var$__exportStar((parcelRequire("5O6xk")), module.exports);

});
parcelRegister("5O6xk", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDouble = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $8D5Jm = parcelRequire("8D5Jm");
/**
 * A comunica TermFunctionXsdToDouble Function Factory Actor.
 */ var $43a6b14fcc96f950$var$ActorFunctionFactoryTermXsdToDouble = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDouble, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDouble(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDouble);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDouble, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DOUBLE
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDouble, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $8D5Jm.TermFunctionXsdToDouble()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDouble;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDouble = $43a6b14fcc96f950$var$ActorFunctionFactoryTermXsdToDouble;

});
parcelRegister("8D5Jm", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDouble = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $6486694004a27a69$var$TermFunctionXsdToDouble = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDouble, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDouble() {
        (0, $jGAMp._)(this, TermFunctionXsdToDouble);
        return (0, $kzDuW._)(this, TermFunctionXsdToDouble, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DOUBLE,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DOUBLE).onNumeric1(function() {
                    return function(val) {
                        return (0, $aduX6.double)(val.typedValue);
                    };
                }).onBoolean1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.double)(val ? 1 : 0);
                    };
                }).onUnary($aduX6.TypeURL.XSD_STRING, function() {
                    return function(val) {
                        var result = (0, $aduX6.parseXSDFloat)(val.str());
                        if (result === undefined) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_DOUBLE);
                        return (0, $aduX6.double)(result);
                    };
                }, false).collect()
            }
        ]);
    }
    return TermFunctionXsdToDouble;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDouble = $6486694004a27a69$var$TermFunctionXsdToDouble;

});



parcelRegister("kWp2j", function(module, exports) {
"use strict";
var $f3eca51b8b9cdd51$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f3eca51b8b9cdd51$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f3eca51b8b9cdd51$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f3eca51b8b9cdd51$var$__exportStar((parcelRequire("ki4G2")), module.exports);

});
parcelRegister("ki4G2", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $cm2QR = parcelRequire("cm2QR");
/**
 * A comunica TermFunctionXsdToDuration Function Factory Actor.
 */ var $ec591ddab004f0df$var$ActorFunctionFactoryTermXsdToDuration = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToDuration, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToDuration(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToDuration);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToDuration, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_DURATION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToDuration, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $cm2QR.TermFunctionXsdToDuration()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToDuration;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToDuration = $ec591ddab004f0df$var$ActorFunctionFactoryTermXsdToDuration;

});
parcelRegister("cm2QR", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $8fe9c0643c9696d4$var$TermFunctionXsdToDuration = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToDuration, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToDuration() {
        (0, $jGAMp._)(this, TermFunctionXsdToDuration);
        return (0, $kzDuW._)(this, TermFunctionXsdToDuration, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_DAY_TIME_DURATION,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
                .onUnary($aduX6.TypeURL.XSD_DURATION, function() {
                    return function(val) {
                        return(// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                        new $aduX6.DurationLiteral(val.typedValue, val.strValue));
                    };
                }).onStringly1(function() {
                    return function(val) {
                        return new $aduX6.DurationLiteral((0, $aduX6.parseDuration)(val.str()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToDuration;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToDuration = $8fe9c0643c9696d4$var$TermFunctionXsdToDuration;

});



parcelRegister("aOUuf", function(module, exports) {
"use strict";
var $7e0a640680f5c15d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7e0a640680f5c15d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7e0a640680f5c15d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7e0a640680f5c15d$var$__exportStar((parcelRequire("5mUtZ")), module.exports);

});
parcelRegister("5mUtZ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToFloat = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $cj7XF = parcelRequire("cj7XF");
/**
 * A comunica TermFunctionXsdToFloat Function Factory Actor.
 */ var $3e8ad21c0f2801fd$var$ActorFunctionFactoryTermXsdToFloat = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToFloat, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToFloat(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToFloat);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToFloat, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_FLOAT
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToFloat, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $cj7XF.TermFunctionXsdToFloat()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToFloat;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToFloat = $3e8ad21c0f2801fd$var$ActorFunctionFactoryTermXsdToFloat;

});
parcelRegister("cj7XF", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToFloat = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $8f5d6f5a4d92af3e$var$TermFunctionXsdToFloat = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToFloat, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToFloat() {
        (0, $jGAMp._)(this, TermFunctionXsdToFloat);
        return (0, $kzDuW._)(this, TermFunctionXsdToFloat, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_FLOAT,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_FLOAT).onNumeric1(function() {
                    return function(val) {
                        return (0, $aduX6.float)(val.typedValue);
                    };
                }).onBoolean1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.float)(val ? 1 : 0);
                    };
                }).onUnary($aduX6.TypeURL.XSD_STRING, function() {
                    return function(val) {
                        var result = (0, $aduX6.parseXSDFloat)(val.str());
                        if (result === undefined) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_FLOAT);
                        return (0, $aduX6.float)(result);
                    };
                }, false).collect()
            }
        ]);
    }
    return TermFunctionXsdToFloat;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToFloat = $8f5d6f5a4d92af3e$var$TermFunctionXsdToFloat;

});



parcelRegister("hN8E0", function(module, exports) {
"use strict";
var $cf3db7dc17470843$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cf3db7dc17470843$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cf3db7dc17470843$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cf3db7dc17470843$var$__exportStar((parcelRequire("lD0qa")), module.exports);

});
parcelRegister("lD0qa", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToInteger = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $cgcys = parcelRequire("cgcys");
/**
 * A comunica TermFunctionXsdToInteger Function Factory Actor.
 */ var $fbed911c68b185c9$var$ActorFunctionFactoryTermXsdToInteger = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToInteger, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToInteger(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToInteger);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToInteger, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_INTEGER
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToInteger, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $cgcys.TermFunctionXsdToInteger()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToInteger;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToInteger = $fbed911c68b185c9$var$ActorFunctionFactoryTermXsdToInteger;

});
parcelRegister("cgcys", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToInteger = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $8ed0b7c739f2a517$var$TermFunctionXsdToInteger = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToInteger, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToInteger() {
        (0, $jGAMp._)(this, TermFunctionXsdToInteger);
        return (0, $kzDuW._)(this, TermFunctionXsdToInteger, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_INTEGER,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_INTEGER).onBoolean1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.integer)(val ? 1 : 0);
                    };
                }).onNumeric1(function() {
                    return function(val) {
                        if (!Number.isFinite(val.typedValue)) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_INTEGER);
                        return (0, $aduX6.integer)(Math.trunc(val.typedValue));
                    };
                }).onString1(function() {
                    return function(val) {
                        var str = val.str();
                        var result = RegExp("^\\d+$", "u").test(str) ? Number.parseInt(str, 10) : undefined;
                        if (result === undefined) throw new $aduX6.CastError(val, $aduX6.TypeURL.XSD_INTEGER);
                        return (0, $aduX6.integer)(result);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToInteger;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToInteger = $8ed0b7c739f2a517$var$TermFunctionXsdToInteger;

});



parcelRegister("bcjoZ", function(module, exports) {
"use strict";
var $826fdd86ceff3c7a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $826fdd86ceff3c7a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $826fdd86ceff3c7a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$826fdd86ceff3c7a$var$__exportStar((parcelRequire("diPHz")), module.exports);

});
parcelRegister("diPHz", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToString = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $2RX2I = parcelRequire("2RX2I");
/**
 * A comunica TermFunctionXsdToString Function Factory Actor.
 */ var $9af50fad203bb928$var$ActorFunctionFactoryTermXsdToString = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToString, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToString(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToString);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToString, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_STRING
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToString, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $2RX2I.TermFunctionXsdToString()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToString;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToString = $9af50fad203bb928$var$ActorFunctionFactoryTermXsdToString;

});
parcelRegister("2RX2I", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToString = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/xpath-functions/#casting-to-string
 */ var $216e54ad50bba499$var$TermFunctionXsdToString = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToString, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToString() {
        (0, $jGAMp._)(this, TermFunctionXsdToString);
        return (0, $kzDuW._)(this, TermFunctionXsdToString, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_STRING,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_STRING).onNumeric1(function() {
                    return function(val) {
                        return (0, $aduX6.string)((0, $aduX6.float)(val.typedValue).str());
                    };
                }).onBoolean1Typed(function() {
                    return function(val) {
                        return (0, $aduX6.string)((0, $aduX6.bool)(val).str());
                    };
                }).onTerm1(function() {
                    return function(val) {
                        return (0, $aduX6.string)(val.str());
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToString;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToString = $216e54ad50bba499$var$TermFunctionXsdToString;

});



parcelRegister("iseW2", function(module, exports) {
"use strict";
var $d6f66d4c0a3be773$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d6f66d4c0a3be773$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d6f66d4c0a3be773$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d6f66d4c0a3be773$var$__exportStar((parcelRequire("eYOJ9")), module.exports);

});
parcelRegister("eYOJ9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToTime = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $PjvN8 = parcelRequire("PjvN8");
/**
 * A comunica TermFunctionXsdToTime Function Factory Actor.
 */ var $ae7e04a6b6b8c842$var$ActorFunctionFactoryTermXsdToTime = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToTime, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToTime(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToTime);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToTime, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_TIME
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToTime, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $PjvN8.TermFunctionXsdToTime()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToTime;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToTime = $ae7e04a6b6b8c842$var$ActorFunctionFactoryTermXsdToTime;

});
parcelRegister("PjvN8", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToTime = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $09a3e62a5e2b9494$var$TermFunctionXsdToTime = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToTime, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToTime() {
        (0, $jGAMp._)(this, TermFunctionXsdToTime);
        return (0, $kzDuW._)(this, TermFunctionXsdToTime, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_TIME,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_TIME).onUnary($aduX6.TypeURL.XSD_TIME, function() {
                    return function(val) {
                        return new $aduX6.TimeLiteral(val.typedValue, val.strValue);
                    };
                }).onUnary($aduX6.TypeURL.XSD_DATE_TIME, function() {
                    return function(val) {
                        return new $aduX6.TimeLiteral(val.typedValue);
                    };
                }).onStringly1(function() {
                    return function(val) {
                        return new $aduX6.TimeLiteral((0, $aduX6.parseTime)(val.str()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToTime;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToTime = $09a3e62a5e2b9494$var$TermFunctionXsdToTime;

});



parcelRegister("cL8W5", function(module, exports) {
"use strict";
var $94a0ce4b940440a5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $94a0ce4b940440a5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $94a0ce4b940440a5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$94a0ce4b940440a5$var$__exportStar((parcelRequire("5TezJ")), module.exports);

});
parcelRegister("5TezJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToYearMonthDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $3PQ2r = parcelRequire("3PQ2r");
/**
 * A comunica TermFunctionXsdToYearMonthDuration Function Factory Actor.
 */ var $449d6526efdc6334$var$ActorFunctionFactoryTermXsdToYearMonthDuration = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermXsdToYearMonthDuration, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermXsdToYearMonthDuration(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermXsdToYearMonthDuration);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermXsdToYearMonthDuration, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermXsdToYearMonthDuration, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $3PQ2r.TermFunctionXsdToYearMonthDuration()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermXsdToYearMonthDuration;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermXsdToYearMonthDuration = $449d6526efdc6334$var$ActorFunctionFactoryTermXsdToYearMonthDuration;

});
parcelRegister("3PQ2r", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToYearMonthDuration = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $2cae8043571b3b23$var$TermFunctionXsdToYearMonthDuration = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionXsdToYearMonthDuration, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionXsdToYearMonthDuration() {
        (0, $jGAMp._)(this, TermFunctionXsdToYearMonthDuration);
        return (0, $kzDuW._)(this, TermFunctionXsdToYearMonthDuration, [
            {
                arity: 1,
                operator: $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION,
                overloads: (0, $aduX6.declare)($aduX6.TypeURL.XSD_YEAR_MONTH_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
                .onUnary($aduX6.TypeURL.XSD_DURATION, function() {
                    return function(val) {
                        return(// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                        new $aduX6.YearMonthDurationLiteral((0, $aduX6.trimToYearMonthDuration)(val.typedValue)));
                    };
                }).onStringly1(function() {
                    return function(val) {
                        return new $aduX6.YearMonthDurationLiteral((0, $aduX6.parseYearMonthDuration)(val.str()));
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionXsdToYearMonthDuration;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionXsdToYearMonthDuration = $2cae8043571b3b23$var$TermFunctionXsdToYearMonthDuration;

});



parcelRegister("1TYtu", function(module, exports) {
"use strict";
var $1629d67b98a4c467$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1629d67b98a4c467$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1629d67b98a4c467$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1629d67b98a4c467$var$__exportStar((parcelRequire("6GdT0")), module.exports);

});
parcelRegister("6GdT0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermYear = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $jYpGA = parcelRequire("jYpGA");
/**
 * A comunica TermFunctionYear Function Factory Actor.
 */ var $4dd16fd3649a5d4f$var$ActorFunctionFactoryTermYear = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermYear, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermYear(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermYear);
        return (0, $kzDuW._)(this, ActorFunctionFactoryTermYear, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.YEAR
                ],
                termFunction: true
            })
        ]);
    }
    (0, $byiyg._)(ActorFunctionFactoryTermYear, [
        {
            key: "run",
            value: function run(_) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            new $jYpGA.TermFunctionYear()
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorFunctionFactoryTermYear;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermYear = $4dd16fd3649a5d4f$var$ActorFunctionFactoryTermYear;

});
parcelRegister("jYpGA", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionYear = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-year
 */ var $e8a78b9e489f73e1$var$TermFunctionYear = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionYear, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionYear() {
        (0, $jGAMp._)(this, TermFunctionYear);
        return (0, $kzDuW._)(this, TermFunctionYear, [
            {
                arity: 1,
                operator: $aduX6.SparqlOperator.YEAR,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.YEAR).onDateTime1(function() {
                    return function(date) {
                        return (0, $aduX6.integer)(date.typedValue.year);
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DATE
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 1), date = _param[0];
                        return (0, $aduX6.integer)(date.typedValue.year);
                    };
                }).collect()
            }
        ]);
    }
    return TermFunctionYear;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionYear = $e8a78b9e489f73e1$var$TermFunctionYear;

});



parcelRegister("3Yylx", function(module, exports) {
"use strict";
var $2e519e305ee1304f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2e519e305ee1304f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2e519e305ee1304f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2e519e305ee1304f$var$__exportStar((parcelRequire("eKBJ8")), module.exports);

});
parcelRegister("eKBJ8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpFetch = void 0;

var $2terW = parcelRequire("2terW");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $ii5zJ = parcelRequire("ii5zJ");

var $6ti1d = parcelRequire("6ti1d");
var $abd2a05de24bfa05$var$ActorHttpFetch = /*#__PURE__*/ function(_bus_http_1_ActorHttp) {
    (0, $i3fW3._)(ActorHttpFetch, _bus_http_1_ActorHttp);
    function ActorHttpFetch(args) {
        (0, $jGAMp._)(this, ActorHttpFetch);
        var _this;
        _this = (0, $kzDuW._)(this, ActorHttpFetch, [
            args
        ]);
        _this.fetchInitPreprocessor = new $6ti1d.FetchInitPreprocessor(args.agentOptions);
        return _this;
    }
    (0, $byiyg._)(ActorHttpFetch, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                time: Number.POSITIVE_INFINITY
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var headers, init, httpTimeout, httpBodyTimeout, _action_context_get, fetchFunction, requestInit, timeoutCallback, timeoutHandle, abortController, response;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = this.prepareRequestHeaders(action);
                                init = (0, $emQHU._)((0, $iT0je._)({
                                    method: 'GET'
                                }, action.init), {
                                    headers: headers
                                });
                                this.logInfo(action.context, "Requesting ".concat($2terW.ActorHttp.getInputUrl(action.input).href), function() {
                                    return {
                                        headers: $2terW.ActorHttp.headersToHash(headers),
                                        method: init.method
                                    };
                                });
                                // TODO: remove this workaround once this has a fix: https://github.com/inrupt/solid-client-authn-js/issues/1708
                                if (action.context.has($9nBhR.KeysHttp.fetch)) init.headers = $2terW.ActorHttp.headersToHash(headers);
                                if (action.context.get($9nBhR.KeysHttp.includeCredentials)) init.credentials = 'include';
                                httpTimeout = action.context.get($9nBhR.KeysHttp.httpTimeout);
                                httpBodyTimeout = action.context.get($9nBhR.KeysHttp.httpBodyTimeout);
                                fetchFunction = (_action_context_get = action.context.get($9nBhR.KeysHttp.fetch)) !== null && _action_context_get !== void 0 ? _action_context_get : fetch;
                                return [
                                    4,
                                    this.fetchInitPreprocessor.handle(init)
                                ];
                            case 1:
                                requestInit = _state.sent();
                                if (httpTimeout) {
                                    abortController = new AbortController();
                                    requestInit.signal = abortController.signal;
                                    timeoutCallback = function() {
                                        return abortController.abort(new Error("Fetch timed out for ".concat($2terW.ActorHttp.getInputUrl(action.input).href, " after ").concat(httpTimeout, " ms")));
                                    };
                                    timeoutHandle = setTimeout(function() {
                                        return timeoutCallback();
                                    }, httpTimeout);
                                }
                                return [
                                    4,
                                    fetchFunction(action.input, requestInit)
                                ];
                            case 2:
                                response = _state.sent();
                                if (httpTimeout && (!httpBodyTimeout || !response.body)) clearTimeout(timeoutHandle);
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Prepares the request headers, taking into account the environment.
     * @param {IActionHttp} action The HTTP action
     * @returns {Headers} Headers
     */ key: "prepareRequestHeaders",
            value: function prepareRequestHeaders(action) {
                var _action_init;
                var headers = new Headers((_action_init = action.init) === null || _action_init === void 0 ? void 0 : _action_init.headers);
                if ($2terW.ActorHttp.isBrowser()) // When running in a browser, the User-Agent header should never be set
                headers["delete"]('user-agent');
                else if (!headers.has('user-agent')) // Otherwise, if no header value is provided, use the actor one
                headers.set('user-agent', ActorHttpFetch.userAgent);
                var authString = action.context.get($9nBhR.KeysHttp.auth);
                if (authString) headers.set('Authorization', "Basic ".concat(ActorHttpFetch.stringToBase64(authString)));
                return headers;
            }
        }
    ], [
        {
            key: "stringToBase64",
            value: /**
     * Converts a string, including ones with Unicode symbols, to Base64 encoding.
     * This function was adapted from the MDN example function here:
     * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
     * @param {string} value The string value to encode
     * @returns {string} The Base64-encoded value
     */ function stringToBase64(value) {
                var bytes = new TextEncoder().encode(value);
                var binString = Array.from(bytes, function(_byte) {
                    return String.fromCodePoint(_byte);
                }).join('');
                return btoa(binString);
            }
        }
    ]);
    return ActorHttpFetch;
}($2terW.ActorHttp);
module.exports.ActorHttpFetch = $abd2a05de24bfa05$var$ActorHttpFetch;
$abd2a05de24bfa05$var$ActorHttpFetch.userAgent = $2terW.ActorHttp.createUserAgent('ActorHttpFetch', $ii5zJ.version);

});
parcelRegister("2terW", function(module, exports) {
"use strict";
var $1cc97f9f2546f804$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1cc97f9f2546f804$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1cc97f9f2546f804$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1cc97f9f2546f804$var$__exportStar((parcelRequire("gR6Lt")), module.exports);

$1cc97f9f2546f804$var$__exportStar((parcelRequire("gWlaP")), module.exports);

});
parcelRegister("gR6Lt", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttp = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $2dfGl = parcelRequire("2dfGl");

var $fUgD9 = parcelRequire("fUgD9");

var $2fLbT = parcelRequire("2fLbT");
/**
 * A base actor for listening to HTTP events.
 *
 * Actor types:
 * * Input:  IActionHttp:      The HTTP request.
 * * Test:   IActorHttpTest:   An estimate for the response time.
 * * Output: IActorHttpOutput: The HTTP response.
 *
 * @see IActionHttp
 * @see IActorHttpTest
 * @see IActorHttpOutput
 */ var $c456d7e40880701c$var$ActorHttp = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorHttp, _core_1_Actor);
    function ActorHttp(args) {
        (0, $jGAMp._)(this, ActorHttp);
        return (0, $kzDuW._)(this, ActorHttp, [
            args
        ]);
    }
    (0, $byiyg._)(ActorHttp, null, [
        {
            key: "toNodeReadable",
            value: /**
     * Converts WhatWG streams to Node streams if required.
     * Returns the input in case the stream already is a Node stream.
     * @param {ReadableStream} body
     * @returns {NodeJS.ReadableStream} A node stream.
     */ function toNodeReadable(body) {
                return $fUgD9(body) || body === null ? body : (0, $2dfGl.readableFromWeb)(body);
            }
        },
        {
            key: "toWebReadableStream",
            value: /**
     * Converts Node streams to WhatWG streams.
     * @param {NodeJS.ReadableStream} body
     * @returns {ReadableStream} A web stream.
     */ function toWebReadableStream1(body) {
                return $2fLbT(body);
            }
        },
        {
            key: "headersToHash",
            value: /**
     * Convert the given headers object into a raw hash.
     * @param headers A headers object.
     */ function headersToHash(headers) {
                var hash = {};
                // eslint-disable-next-line unicorn/no-array-for-each
                headers.forEach(function(value, key) {
                    hash[key] = value;
                });
                return hash;
            }
        },
        {
            key: "getInputUrl",
            value: /**
     * Extract the requested URL from the action input.
     * @param {RequestInfo | URL} input The request input.
     * @returns {URL} The extracted URL.
     */ function getInputUrl(input) {
                return new URL(input instanceof Request ? input.url : input);
            }
        },
        {
            key: "createUserAgent",
            value: /**
     * Creates an appropriate User-Agent header string for Node.js or other environments.
     * Within browsers, returns undefined, because the value should not be overridden due to potential CORS issues.
     */ function createUserAgent(actorName, actorVersion) {
                if (!ActorHttp.isBrowser()) {
                    var versions = [
                        "Comunica/".concat(actorVersion.split('.')[0], ".0"),
                        "".concat(actorName, "/").concat(actorVersion)
                    ];
                    if ((0, $3KZcf._)(globalThis.navigator) === 'object' && typeof globalThis.navigator.userAgent === 'string') // Most runtimes like Node.js 21+, Deno and Bun implement navigator.userAgent
                    versions.push(globalThis.navigator.userAgent);
                    else if ((0, $3KZcf._)(globalThis.process) === 'object' && (0, $3KZcf._)(globalThis.process.versions) === 'object' && typeof globalThis.process.versions.node === 'string') // TODO: remove this entire 'else if' when support for Node.js 20 is dropped, this only exists for that one
                    versions.push("Node.js/".concat(globalThis.process.versions.node.split('.')[0]));
                    if ((0, $3KZcf._)(globalThis.process) === 'object' && typeof globalThis.process.platform === 'string' && typeof globalThis.process.arch === 'string') versions.splice(1, 0, "(".concat(globalThis.process.platform, "; ").concat(globalThis.process.arch, ")"));
                    return versions.join(' ');
                }
            }
        },
        {
            key: "isBrowser",
            value: /**
     * Attempts to determine whether the current environment is a browser or not.
     * @returns {boolean} True for browsers and web workers, false for other runtimes.
     */ function isBrowser() {
                return(// The window global and the document are available in browsers, but not in web workers
                // https://developer.mozilla.org/en-US/docs/Glossary/Global_object
                (0, $3KZcf._)(globalThis.window) === 'object' && (0, $3KZcf._)(globalThis.window.document) === 'object' || // The importScripts function is only available in Web Workers
                // https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/importScripts
                typeof globalThis.importScripts === 'function');
            }
        }
    ]);
    return ActorHttp;
}($kNNoa.Actor);
module.exports.ActorHttp = $c456d7e40880701c$var$ActorHttp;

});
parcelRegister("2dfGl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readableFromWeb = void 0;

var $87Hcw = parcelRequire("87Hcw");
Object.defineProperty(module.exports, "readableFromWeb", {
    enumerable: true,
    get: function get() {
        return $87Hcw.readableFromWeb;
    }
});

});
parcelRegister("87Hcw", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readableFromWeb = module.exports.ReadableFromWeb = void 0;

var $2Y6Kq = parcelRequire("2Y6Kq");
var $5ea07cff52e118e2$var$ReadableFromWeb = /*#__PURE__*/ function(_readable_stream_1_Readable) {
    (0, $i3fW3._)(ReadableFromWeb, _readable_stream_1_Readable);
    function ReadableFromWeb(stream, options) {
        (0, $jGAMp._)(this, ReadableFromWeb);
        var _this;
        _this = (0, $kzDuW._)(this, ReadableFromWeb, [
            options
        ]);
        _this.reader = stream.getReader();
        _this.readerClosed = false;
        _this.reader.closed.then(function() {
            _this.readerClosed = true;
        })["catch"](function(error) {
            _this.readerClosed = true;
            _this.destroy(error);
        });
        return _this;
    }
    (0, $byiyg._)(ReadableFromWeb, [
        {
            // eslint-disable-next-line ts/naming-convention
            key: "_read",
            value: function _read() {
                var _this = this;
                this.reader.read().then(function(chunk) {
                    return _this.push(chunk.done ? null : chunk.value);
                })["catch"](function(error) {
                    return _this.destroy(error);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy(error) {
                if (!this.readerClosed) this.reader.cancel(error).then()["catch"](function() {
                // Ideally, the error from cancel should be handled here.
                // However, an error thrown in cancel does not seem to reach this callback.
                // Therefore, the error is simply not handled here.
                });
                return (0, $fXhL4._)((0, $hxFDX._)(ReadableFromWeb.prototype), "destroy", this).call(this, error);
            }
        }
    ]);
    return ReadableFromWeb;
}($2Y6Kq.Readable);
module.exports.ReadableFromWeb = $5ea07cff52e118e2$var$ReadableFromWeb;
function $5ea07cff52e118e2$var$readableFromWeb(stream, options) {
    return new $5ea07cff52e118e2$var$ReadableFromWeb(stream, options);
}
module.exports.readableFromWeb = $5ea07cff52e118e2$var$readableFromWeb;

});
parcelRegister("2Y6Kq", function(module, exports) {
'use strict';

var $a9pwl = parcelRequire("a9pwl");

var $kfcDo = parcelRequire("kfcDo");
var $22966b5090ad4d9c$var$originalDestroy = $a9pwl.Readable.destroy;
module.exports = $a9pwl.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $a9pwl._uint8ArrayToBuffer;
module.exports._isUint8Array = $a9pwl._isUint8Array;
module.exports.isDisturbed = $a9pwl.isDisturbed;
module.exports.isErrored = $a9pwl.isErrored;
module.exports.isReadable = $a9pwl.isReadable;
module.exports.Readable = $a9pwl.Readable;
module.exports.Writable = $a9pwl.Writable;
module.exports.Duplex = $a9pwl.Duplex;
module.exports.Transform = $a9pwl.Transform;
module.exports.PassThrough = $a9pwl.PassThrough;
module.exports.addAbortSignal = $a9pwl.addAbortSignal;
module.exports.finished = $a9pwl.finished;
module.exports.destroy = $a9pwl.destroy;
module.exports.destroy = $22966b5090ad4d9c$var$originalDestroy;
module.exports.pipeline = $a9pwl.pipeline;
module.exports.compose = $a9pwl.compose;
Object.defineProperty($a9pwl, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $kfcDo;
    }
});
module.exports.Stream = $a9pwl.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("a9pwl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $iaL1d = parcelRequire("iaL1d");
var $763e8a8720f853e8$require$Buffer = $iaL1d.Buffer;

var $6EUyW = parcelRequire("6EUyW");
/* replacement end */ var $763e8a8720f853e8$var$ObjectDefineProperty = $6EUyW.ObjectDefineProperty, $763e8a8720f853e8$var$ObjectKeys = $6EUyW.ObjectKeys, $763e8a8720f853e8$var$ReflectApply = $6EUyW.ReflectApply;

var $dNICR = parcelRequire("dNICR");
var $763e8a8720f853e8$var$_require_promisify = $dNICR.promisify, $763e8a8720f853e8$var$customPromisify = $763e8a8720f853e8$var$_require_promisify.custom;

var $iHSz9 = parcelRequire("iHSz9");
var $763e8a8720f853e8$var$streamReturningOperators = $iHSz9.streamReturningOperators, $763e8a8720f853e8$var$promiseReturningOperators = $iHSz9.promiseReturningOperators;

var $3Yp2a = parcelRequire("3Yp2a");
var $763e8a8720f853e8$var$ERR_ILLEGAL_CONSTRUCTOR = $3Yp2a.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $3aRTL = parcelRequire("3aRTL");

var $5R1Lu = parcelRequire("5R1Lu");
var $763e8a8720f853e8$var$setDefaultHighWaterMark = $5R1Lu.setDefaultHighWaterMark, $763e8a8720f853e8$var$getDefaultHighWaterMark = $5R1Lu.getDefaultHighWaterMark;

var $eV3GP = parcelRequire("eV3GP");
var $763e8a8720f853e8$require$pipeline = $eV3GP.pipeline;

var $5lyk7 = parcelRequire("5lyk7");
var $763e8a8720f853e8$require$destroyer = $5lyk7.destroyer;

var $gvFwV = parcelRequire("gvFwV");
var $763e8a8720f853e8$var$internalBuffer = {};

var $kfcDo = parcelRequire("kfcDo");

var $h5dib = parcelRequire("h5dib");

var $763e8a8720f853e8$var$Stream = module.exports = (parcelRequire("exnkP")).Stream;
$763e8a8720f853e8$var$Stream.isDestroyed = $h5dib.isDestroyed;
$763e8a8720f853e8$var$Stream.isDisturbed = $h5dib.isDisturbed;
$763e8a8720f853e8$var$Stream.isErrored = $h5dib.isErrored;
$763e8a8720f853e8$var$Stream.isReadable = $h5dib.isReadable;
$763e8a8720f853e8$var$Stream.isWritable = $h5dib.isWritable;

$763e8a8720f853e8$var$Stream.Readable = (parcelRequire("sAhw0"));
var $763e8a8720f853e8$var$_iteratorNormalCompletion = true, $763e8a8720f853e8$var$_didIteratorError = false, $763e8a8720f853e8$var$_iteratorError = undefined;
try {
    for(var $763e8a8720f853e8$var$_iterator = $763e8a8720f853e8$var$ObjectKeys($763e8a8720f853e8$var$streamReturningOperators)[Symbol.iterator](), $763e8a8720f853e8$var$_step; !($763e8a8720f853e8$var$_iteratorNormalCompletion = ($763e8a8720f853e8$var$_step = $763e8a8720f853e8$var$_iterator.next()).done); $763e8a8720f853e8$var$_iteratorNormalCompletion = true){
        var $763e8a8720f853e8$var$key = $763e8a8720f853e8$var$_step.value;
        var $763e8a8720f853e8$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $763e8a8720f853e8$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $763e8a8720f853e8$var$Stream.Readable.from($763e8a8720f853e8$var$ReflectApply($763e8a8720f853e8$var$op, this, args));
        };
        var $763e8a8720f853e8$var$op = $763e8a8720f853e8$var$streamReturningOperators[$763e8a8720f853e8$var$key];
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$fn, 'name', {
            __proto__: null,
            value: $763e8a8720f853e8$var$op.name
        });
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$fn, 'length', {
            __proto__: null,
            value: $763e8a8720f853e8$var$op.length
        });
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$Stream.Readable.prototype, $763e8a8720f853e8$var$key, {
            __proto__: null,
            value: $763e8a8720f853e8$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $763e8a8720f853e8$var$_didIteratorError = true;
    $763e8a8720f853e8$var$_iteratorError = err;
} finally{
    try {
        if (!$763e8a8720f853e8$var$_iteratorNormalCompletion && $763e8a8720f853e8$var$_iterator["return"] != null) {
            $763e8a8720f853e8$var$_iterator["return"]();
        }
    } finally{
        if ($763e8a8720f853e8$var$_didIteratorError) {
            throw $763e8a8720f853e8$var$_iteratorError;
        }
    }
}
var $763e8a8720f853e8$var$_iteratorNormalCompletion1 = true, $763e8a8720f853e8$var$_didIteratorError1 = false, $763e8a8720f853e8$var$_iteratorError1 = undefined;
try {
    for(var $763e8a8720f853e8$var$_iterator1 = $763e8a8720f853e8$var$ObjectKeys($763e8a8720f853e8$var$promiseReturningOperators)[Symbol.iterator](), $763e8a8720f853e8$var$_step1; !($763e8a8720f853e8$var$_iteratorNormalCompletion1 = ($763e8a8720f853e8$var$_step1 = $763e8a8720f853e8$var$_iterator1.next()).done); $763e8a8720f853e8$var$_iteratorNormalCompletion1 = true){
        var $763e8a8720f853e8$var$key1 = $763e8a8720f853e8$var$_step1.value;
        var $763e8a8720f853e8$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $763e8a8720f853e8$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $763e8a8720f853e8$var$ReflectApply($763e8a8720f853e8$var$op1, this, args);
        };
        var $763e8a8720f853e8$var$op1 = $763e8a8720f853e8$var$promiseReturningOperators[$763e8a8720f853e8$var$key1];
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$fn1, 'name', {
            __proto__: null,
            value: $763e8a8720f853e8$var$op1.name
        });
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$fn1, 'length', {
            __proto__: null,
            value: $763e8a8720f853e8$var$op1.length
        });
        $763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$Stream.Readable.prototype, $763e8a8720f853e8$var$key1, {
            __proto__: null,
            value: $763e8a8720f853e8$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $763e8a8720f853e8$var$_didIteratorError1 = true;
    $763e8a8720f853e8$var$_iteratorError1 = err;
} finally{
    try {
        if (!$763e8a8720f853e8$var$_iteratorNormalCompletion1 && $763e8a8720f853e8$var$_iterator1["return"] != null) {
            $763e8a8720f853e8$var$_iterator1["return"]();
        }
    } finally{
        if ($763e8a8720f853e8$var$_didIteratorError1) {
            throw $763e8a8720f853e8$var$_iteratorError1;
        }
    }
}

$763e8a8720f853e8$var$Stream.Writable = (parcelRequire("2jNx5"));

$763e8a8720f853e8$var$Stream.Duplex = (parcelRequire("8Lioq"));

$763e8a8720f853e8$var$Stream.Transform = (parcelRequire("gFzPY"));

$763e8a8720f853e8$var$Stream.PassThrough = (parcelRequire("hHQw5"));
$763e8a8720f853e8$var$Stream.pipeline = $763e8a8720f853e8$require$pipeline;

var $coaKh = parcelRequire("coaKh");
var $763e8a8720f853e8$require$addAbortSignal = $coaKh.addAbortSignal;
$763e8a8720f853e8$var$Stream.addAbortSignal = $763e8a8720f853e8$require$addAbortSignal;
$763e8a8720f853e8$var$Stream.finished = $gvFwV;
$763e8a8720f853e8$var$Stream.destroy = $763e8a8720f853e8$require$destroyer;
$763e8a8720f853e8$var$Stream.compose = $3aRTL;
$763e8a8720f853e8$var$Stream.setDefaultHighWaterMark = $763e8a8720f853e8$var$setDefaultHighWaterMark;
$763e8a8720f853e8$var$Stream.getDefaultHighWaterMark = $763e8a8720f853e8$var$getDefaultHighWaterMark;
$763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $kfcDo;
    }
});
$763e8a8720f853e8$var$ObjectDefineProperty($763e8a8720f853e8$require$pipeline, $763e8a8720f853e8$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $kfcDo.pipeline;
    }
});
$763e8a8720f853e8$var$ObjectDefineProperty($gvFwV, $763e8a8720f853e8$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $kfcDo.finished;
    }
});
// Backwards-compat with node 0.4.x
$763e8a8720f853e8$var$Stream.Stream = $763e8a8720f853e8$var$Stream;
$763e8a8720f853e8$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$763e8a8720f853e8$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $763e8a8720f853e8$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("iaL1d", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d3ada21021416ff6$export$a143d493d941bafc; }, function (v) { return $d3ada21021416ff6$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d3ada21021416ff6$export$f99ded8fe4b79145; }, function (v) { return $d3ada21021416ff6$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $d3ada21021416ff6$export$a143d493d941bafc;
var $d3ada21021416ff6$export$e4cf37d7f6fb9e0a;
var $d3ada21021416ff6$export$f99ded8fe4b79145;
var $d3ada21021416ff6$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $d3ada21021416ff6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d3ada21021416ff6$export$a143d493d941bafc = $d3ada21021416ff6$var$Buffer;
$d3ada21021416ff6$export$e4cf37d7f6fb9e0a = $d3ada21021416ff6$var$SlowBuffer;
$d3ada21021416ff6$export$f99ded8fe4b79145 = 50;
var $d3ada21021416ff6$var$K_MAX_LENGTH = 0x7fffffff;
$d3ada21021416ff6$export$599f31c3813fae4d = $d3ada21021416ff6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d3ada21021416ff6$var$Buffer.TYPED_ARRAY_SUPPORT = $d3ada21021416ff6$var$typedArraySupport();
if (!$d3ada21021416ff6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d3ada21021416ff6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d3ada21021416ff6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$d3ada21021416ff6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d3ada21021416ff6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$d3ada21021416ff6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d3ada21021416ff6$var$createBuffer(length) {
    if (length > $d3ada21021416ff6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d3ada21021416ff6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d3ada21021416ff6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d3ada21021416ff6$var$allocUnsafe(arg);
    }
    return $d3ada21021416ff6$var$from(arg, encodingOrOffset, length);
}
$d3ada21021416ff6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d3ada21021416ff6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d3ada21021416ff6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d3ada21021416ff6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($d3ada21021416ff6$var$isInstance(value, ArrayBuffer) || value && $d3ada21021416ff6$var$isInstance(value.buffer, ArrayBuffer)) return $d3ada21021416ff6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d3ada21021416ff6$var$isInstance(value, SharedArrayBuffer) || value && $d3ada21021416ff6$var$isInstance(value.buffer, SharedArrayBuffer))) return $d3ada21021416ff6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d3ada21021416ff6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d3ada21021416ff6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d3ada21021416ff6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d3ada21021416ff6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d3ada21021416ff6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d3ada21021416ff6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d3ada21021416ff6$var$Buffer, Uint8Array);
function $d3ada21021416ff6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d3ada21021416ff6$var$alloc(size, fill, encoding) {
    $d3ada21021416ff6$var$assertSize(size);
    if (size <= 0) return $d3ada21021416ff6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d3ada21021416ff6$var$createBuffer(size).fill(fill, encoding) : $d3ada21021416ff6$var$createBuffer(size).fill(fill);
    return $d3ada21021416ff6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d3ada21021416ff6$var$Buffer.alloc = function(size, fill, encoding) {
    return $d3ada21021416ff6$var$alloc(size, fill, encoding);
};
function $d3ada21021416ff6$var$allocUnsafe(size) {
    $d3ada21021416ff6$var$assertSize(size);
    return $d3ada21021416ff6$var$createBuffer(size < 0 ? 0 : $d3ada21021416ff6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d3ada21021416ff6$var$Buffer.allocUnsafe = function(size) {
    return $d3ada21021416ff6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d3ada21021416ff6$var$Buffer.allocUnsafeSlow = function(size) {
    return $d3ada21021416ff6$var$allocUnsafe(size);
};
function $d3ada21021416ff6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d3ada21021416ff6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d3ada21021416ff6$var$byteLength(string, encoding) | 0;
    var buf = $d3ada21021416ff6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d3ada21021416ff6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d3ada21021416ff6$var$checked(array.length) | 0;
    var buf = $d3ada21021416ff6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d3ada21021416ff6$var$fromArrayView(arrayView) {
    if ($d3ada21021416ff6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d3ada21021416ff6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d3ada21021416ff6$var$fromArrayLike(arrayView);
}
function $d3ada21021416ff6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d3ada21021416ff6$var$Buffer.prototype);
    return buf;
}
function $d3ada21021416ff6$var$fromObject(obj) {
    if ($d3ada21021416ff6$var$Buffer.isBuffer(obj)) {
        var len = $d3ada21021416ff6$var$checked(obj.length) | 0;
        var buf = $d3ada21021416ff6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d3ada21021416ff6$var$numberIsNaN(obj.length)) return $d3ada21021416ff6$var$createBuffer(0);
        return $d3ada21021416ff6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d3ada21021416ff6$var$fromArrayLike(obj.data);
}
function $d3ada21021416ff6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d3ada21021416ff6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d3ada21021416ff6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d3ada21021416ff6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d3ada21021416ff6$var$Buffer.alloc(+length);
}
$d3ada21021416ff6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d3ada21021416ff6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d3ada21021416ff6$var$Buffer.compare = function compare(a, b) {
    if ($d3ada21021416ff6$var$isInstance(a, Uint8Array)) a = $d3ada21021416ff6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d3ada21021416ff6$var$isInstance(b, Uint8Array)) b = $d3ada21021416ff6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d3ada21021416ff6$var$Buffer.isBuffer(a) || !$d3ada21021416ff6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d3ada21021416ff6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d3ada21021416ff6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d3ada21021416ff6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d3ada21021416ff6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d3ada21021416ff6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d3ada21021416ff6$var$Buffer.isBuffer(buf)) buf = $d3ada21021416ff6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d3ada21021416ff6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d3ada21021416ff6$var$byteLength(string, encoding) {
    if ($d3ada21021416ff6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d3ada21021416ff6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d3ada21021416ff6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d3ada21021416ff6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d3ada21021416ff6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d3ada21021416ff6$var$Buffer.byteLength = $d3ada21021416ff6$var$byteLength;
function $d3ada21021416ff6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d3ada21021416ff6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d3ada21021416ff6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d3ada21021416ff6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d3ada21021416ff6$var$latin1Slice(this, start, end);
        case 'base64':
            return $d3ada21021416ff6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d3ada21021416ff6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d3ada21021416ff6$var$Buffer.prototype._isBuffer = true;
function $d3ada21021416ff6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d3ada21021416ff6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d3ada21021416ff6$var$swap(this, i, i + 1);
    return this;
};
$d3ada21021416ff6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d3ada21021416ff6$var$swap(this, i, i + 3);
        $d3ada21021416ff6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d3ada21021416ff6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d3ada21021416ff6$var$swap(this, i, i + 7);
        $d3ada21021416ff6$var$swap(this, i + 1, i + 6);
        $d3ada21021416ff6$var$swap(this, i + 2, i + 5);
        $d3ada21021416ff6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d3ada21021416ff6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d3ada21021416ff6$var$utf8Slice(this, 0, length);
    return $d3ada21021416ff6$var$slowToString.apply(this, arguments);
};
$d3ada21021416ff6$var$Buffer.prototype.toLocaleString = $d3ada21021416ff6$var$Buffer.prototype.toString;
$d3ada21021416ff6$var$Buffer.prototype.equals = function equals(b) {
    if (!$d3ada21021416ff6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d3ada21021416ff6$var$Buffer.compare(this, b) === 0;
};
$d3ada21021416ff6$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d3ada21021416ff6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d3ada21021416ff6$var$customInspectSymbol) $d3ada21021416ff6$var$Buffer.prototype[$d3ada21021416ff6$var$customInspectSymbol] = $d3ada21021416ff6$var$Buffer.prototype.inspect;
$d3ada21021416ff6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d3ada21021416ff6$var$isInstance(target, Uint8Array)) target = $d3ada21021416ff6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d3ada21021416ff6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d3ada21021416ff6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d3ada21021416ff6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d3ada21021416ff6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d3ada21021416ff6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d3ada21021416ff6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d3ada21021416ff6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d3ada21021416ff6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d3ada21021416ff6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d3ada21021416ff6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d3ada21021416ff6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d3ada21021416ff6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d3ada21021416ff6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d3ada21021416ff6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d3ada21021416ff6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d3ada21021416ff6$var$utf8Write(buf, string, offset, length) {
    return $d3ada21021416ff6$var$blitBuffer($d3ada21021416ff6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d3ada21021416ff6$var$asciiWrite(buf, string, offset, length) {
    return $d3ada21021416ff6$var$blitBuffer($d3ada21021416ff6$var$asciiToBytes(string), buf, offset, length);
}
function $d3ada21021416ff6$var$base64Write(buf, string, offset, length) {
    return $d3ada21021416ff6$var$blitBuffer($d3ada21021416ff6$var$base64ToBytes(string), buf, offset, length);
}
function $d3ada21021416ff6$var$ucs2Write(buf, string, offset, length) {
    return $d3ada21021416ff6$var$blitBuffer($d3ada21021416ff6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d3ada21021416ff6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d3ada21021416ff6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d3ada21021416ff6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d3ada21021416ff6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d3ada21021416ff6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d3ada21021416ff6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d3ada21021416ff6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d3ada21021416ff6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $d3ada21021416ff6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d3ada21021416ff6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d3ada21021416ff6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d3ada21021416ff6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d3ada21021416ff6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d3ada21021416ff6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d3ada21021416ff6$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d3ada21021416ff6$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d3ada21021416ff6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d3ada21021416ff6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d3ada21021416ff6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d3ada21021416ff6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d3ada21021416ff6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d3ada21021416ff6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d3ada21021416ff6$var$Buffer.prototype.readUintLE = $d3ada21021416ff6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d3ada21021416ff6$var$Buffer.prototype.readUintBE = $d3ada21021416ff6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d3ada21021416ff6$var$Buffer.prototype.readUint8 = $d3ada21021416ff6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d3ada21021416ff6$var$Buffer.prototype.readUint16LE = $d3ada21021416ff6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d3ada21021416ff6$var$Buffer.prototype.readUint16BE = $d3ada21021416ff6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d3ada21021416ff6$var$Buffer.prototype.readUint32LE = $d3ada21021416ff6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d3ada21021416ff6$var$Buffer.prototype.readUint32BE = $d3ada21021416ff6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d3ada21021416ff6$var$Buffer.prototype.readBigUInt64LE = $d3ada21021416ff6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d3ada21021416ff6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d3ada21021416ff6$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d3ada21021416ff6$var$Buffer.prototype.readBigUInt64BE = $d3ada21021416ff6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d3ada21021416ff6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d3ada21021416ff6$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d3ada21021416ff6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d3ada21021416ff6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d3ada21021416ff6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d3ada21021416ff6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d3ada21021416ff6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d3ada21021416ff6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d3ada21021416ff6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d3ada21021416ff6$var$Buffer.prototype.readBigInt64LE = $d3ada21021416ff6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d3ada21021416ff6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d3ada21021416ff6$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$d3ada21021416ff6$var$Buffer.prototype.readBigInt64BE = $d3ada21021416ff6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d3ada21021416ff6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d3ada21021416ff6$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$d3ada21021416ff6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$d3ada21021416ff6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$d3ada21021416ff6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$d3ada21021416ff6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $d3ada21021416ff6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d3ada21021416ff6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d3ada21021416ff6$var$Buffer.prototype.writeUintLE = $d3ada21021416ff6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d3ada21021416ff6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUintBE = $d3ada21021416ff6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d3ada21021416ff6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUint8 = $d3ada21021416ff6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUint16LE = $d3ada21021416ff6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUint16BE = $d3ada21021416ff6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUint32LE = $d3ada21021416ff6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d3ada21021416ff6$var$Buffer.prototype.writeUint32BE = $d3ada21021416ff6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d3ada21021416ff6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d3ada21021416ff6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d3ada21021416ff6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d3ada21021416ff6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d3ada21021416ff6$var$Buffer.prototype.writeBigUInt64LE = $d3ada21021416ff6$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d3ada21021416ff6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d3ada21021416ff6$var$Buffer.prototype.writeBigUInt64BE = $d3ada21021416ff6$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d3ada21021416ff6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d3ada21021416ff6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d3ada21021416ff6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d3ada21021416ff6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d3ada21021416ff6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d3ada21021416ff6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d3ada21021416ff6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d3ada21021416ff6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d3ada21021416ff6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d3ada21021416ff6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d3ada21021416ff6$var$Buffer.prototype.writeBigInt64LE = $d3ada21021416ff6$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d3ada21021416ff6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d3ada21021416ff6$var$Buffer.prototype.writeBigInt64BE = $d3ada21021416ff6$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d3ada21021416ff6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d3ada21021416ff6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d3ada21021416ff6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d3ada21021416ff6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d3ada21021416ff6$var$writeFloat(this, value, offset, true, noAssert);
};
$d3ada21021416ff6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d3ada21021416ff6$var$writeFloat(this, value, offset, false, noAssert);
};
function $d3ada21021416ff6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d3ada21021416ff6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d3ada21021416ff6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d3ada21021416ff6$var$writeDouble(this, value, offset, true, noAssert);
};
$d3ada21021416ff6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d3ada21021416ff6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d3ada21021416ff6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d3ada21021416ff6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d3ada21021416ff6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d3ada21021416ff6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d3ada21021416ff6$var$Buffer.isBuffer(val) ? val : $d3ada21021416ff6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $d3ada21021416ff6$var$errors = {};
function $d3ada21021416ff6$var$E(sym, getMessage, Base) {
    $d3ada21021416ff6$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$d3ada21021416ff6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d3ada21021416ff6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$d3ada21021416ff6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d3ada21021416ff6$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $d3ada21021416ff6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $d3ada21021416ff6$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $d3ada21021416ff6$var$checkBounds(buf, offset, byteLength) {
    $d3ada21021416ff6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d3ada21021416ff6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d3ada21021416ff6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $d3ada21021416ff6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d3ada21021416ff6$var$checkBounds(buf, offset, byteLength);
}
function $d3ada21021416ff6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d3ada21021416ff6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d3ada21021416ff6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d3ada21021416ff6$var$validateNumber(value, type);
        throw new $d3ada21021416ff6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d3ada21021416ff6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d3ada21021416ff6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $d3ada21021416ff6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d3ada21021416ff6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d3ada21021416ff6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d3ada21021416ff6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d3ada21021416ff6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d3ada21021416ff6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d3ada21021416ff6$var$base64ToBytes(str) {
    return $abUaD.toByteArray($d3ada21021416ff6$var$base64clean(str));
}
function $d3ada21021416ff6$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d3ada21021416ff6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d3ada21021416ff6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d3ada21021416ff6$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d3ada21021416ff6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d3ada21021416ff6$var$BufferBigIntNotDefined : fn;
}
function $d3ada21021416ff6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("6EUyW", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $4d925aac261d39d2$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $4d925aac261d39d2$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("dNICR", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $iaL1d = parcelRequire("iaL1d");

var $cO7Ev = parcelRequire("cO7Ev");
var $a0c277b5daff08f2$var$format = $cO7Ev.format, $a0c277b5daff08f2$var$inspect = $cO7Ev.inspect;

var $3Yp2a = parcelRequire("3Yp2a");
var $a0c277b5daff08f2$var$ERR_INVALID_ARG_TYPE = $3Yp2a.codes.ERR_INVALID_ARG_TYPE;

var $6EUyW = parcelRequire("6EUyW");
var $a0c277b5daff08f2$var$kResistStopPropagation = $6EUyW.kResistStopPropagation, $a0c277b5daff08f2$var$AggregateError = $6EUyW.AggregateError, $a0c277b5daff08f2$var$SymbolDispose = $6EUyW.SymbolDispose;

var $a0c277b5daff08f2$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $a0c277b5daff08f2$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $a0c277b5daff08f2$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $a0c277b5daff08f2$var$Blob = globalThis.Blob || $iaL1d.Blob;
/* eslint-disable indent */ var $a0c277b5daff08f2$var$isBlob = typeof $a0c277b5daff08f2$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $a0c277b5daff08f2$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $a0c277b5daff08f2$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $a0c277b5daff08f2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $a0c277b5daff08f2$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $a0c277b5daff08f2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $a0c277b5daff08f2$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $a0c277b5daff08f2$var$format,
    inspect: $a0c277b5daff08f2$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $a0c277b5daff08f2$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $a0c277b5daff08f2$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $a0c277b5daff08f2$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $a0c277b5daff08f2$var$validateAbortSignal(signal, 'signal');
        $a0c277b5daff08f2$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $a0c277b5daff08f2$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $a0c277b5daff08f2$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $a0c277b5daff08f2$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $a0c277b5daff08f2$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $a0c277b5daff08f2$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("cO7Ev", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("3Yp2a", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $cO7Ev = parcelRequire("cO7Ev");
var $2e4a64e698e50232$var$format = $cO7Ev.format, $2e4a64e698e50232$var$inspect = $cO7Ev.inspect;

var $6EUyW = parcelRequire("6EUyW");
var $2e4a64e698e50232$var$CustomAggregateError = $6EUyW.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $2e4a64e698e50232$var$AggregateError = globalThis.AggregateError || $2e4a64e698e50232$var$CustomAggregateError;
var $2e4a64e698e50232$var$kIsNodeError = Symbol('kIsNodeError');
var $2e4a64e698e50232$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $2e4a64e698e50232$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $2e4a64e698e50232$var$nodeInternalPrefix = '__node_internal_';
var $2e4a64e698e50232$var$codes = {};
function $2e4a64e698e50232$var$assert(value, message) {
    if (!value) throw new $2e4a64e698e50232$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $2e4a64e698e50232$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $2e4a64e698e50232$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $2e4a64e698e50232$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $2e4a64e698e50232$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $2e4a64e698e50232$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $2e4a64e698e50232$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $2e4a64e698e50232$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$2e4a64e698e50232$var$kIsNodeError] = true;
    $2e4a64e698e50232$var$codes[code] = NodeError;
}
function $2e4a64e698e50232$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $2e4a64e698e50232$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $2e4a64e698e50232$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $2e4a64e698e50232$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $2e4a64e698e50232$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $2e4a64e698e50232$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$2e4a64e698e50232$var$E('ERR_ASSERTION', '%s', Error);
$2e4a64e698e50232$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $2e4a64e698e50232$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $2e4a64e698e50232$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($2e4a64e698e50232$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($2e4a64e698e50232$var$classRegExp.test(value)) instances.push(value);
            else {
                $2e4a64e698e50232$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $2e4a64e698e50232$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $2e4a64e698e50232$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$2e4a64e698e50232$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $2e4a64e698e50232$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$2e4a64e698e50232$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$2e4a64e698e50232$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $2e4a64e698e50232$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$2e4a64e698e50232$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $2e4a64e698e50232$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $2e4a64e698e50232$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $2e4a64e698e50232$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $2e4a64e698e50232$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$2e4a64e698e50232$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$2e4a64e698e50232$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$2e4a64e698e50232$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$2e4a64e698e50232$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$2e4a64e698e50232$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $2e4a64e698e50232$var$AbortError,
    aggregateTwoErrors: $2e4a64e698e50232$var$hideStackFrames($2e4a64e698e50232$var$aggregateTwoErrors),
    hideStackFrames: $2e4a64e698e50232$var$hideStackFrames,
    codes: $2e4a64e698e50232$var$codes
};

});


parcelRegister("iHSz9", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $d9e691ccd0977299$export$42af8c323be37587; }, function (v) { return $d9e691ccd0977299$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $d9e691ccd0977299$export$f405f72c701dad87; }, function (v) { return $d9e691ccd0977299$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $d9e691ccd0977299$export$42af8c323be37587;
var $d9e691ccd0977299$export$f405f72c701dad87;
'use strict';

var $d9e691ccd0977299$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $3Yp2a = parcelRequire("3Yp2a");
var $d9e691ccd0977299$var$_require_codes = $3Yp2a.codes, $d9e691ccd0977299$var$ERR_INVALID_ARG_VALUE = $d9e691ccd0977299$var$_require_codes.ERR_INVALID_ARG_VALUE, $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE = $d9e691ccd0977299$var$_require_codes.ERR_INVALID_ARG_TYPE, $d9e691ccd0977299$var$ERR_MISSING_ARGS = $d9e691ccd0977299$var$_require_codes.ERR_MISSING_ARGS, $d9e691ccd0977299$var$ERR_OUT_OF_RANGE = $d9e691ccd0977299$var$_require_codes.ERR_OUT_OF_RANGE, $d9e691ccd0977299$var$AbortError = $3Yp2a.AbortError;

var $d6Z3R = parcelRequire("d6Z3R");
var $d9e691ccd0977299$var$validateAbortSignal = $d6Z3R.validateAbortSignal, $d9e691ccd0977299$var$validateInteger = $d6Z3R.validateInteger, $d9e691ccd0977299$var$validateObject = $d6Z3R.validateObject;

var $d9e691ccd0977299$var$kWeakHandler = (parcelRequire("6EUyW")).Symbol('kWeak');

var $d9e691ccd0977299$var$kResistStopPropagation = (parcelRequire("6EUyW")).Symbol('kResistStopPropagation');

var $gvFwV = parcelRequire("gvFwV");
var $d9e691ccd0977299$require$finished = $gvFwV.finished;

var $3aRTL = parcelRequire("3aRTL");

var $coaKh = parcelRequire("coaKh");
var $d9e691ccd0977299$require$addAbortSignalNoValidate = $coaKh.addAbortSignalNoValidate;

var $h5dib = parcelRequire("h5dib");
var $d9e691ccd0977299$var$isWritable = $h5dib.isWritable, $d9e691ccd0977299$var$isNodeStream = $h5dib.isNodeStream;

var $d9e691ccd0977299$require$deprecate = (parcelRequire("dNICR")).deprecate;

var $d9e691ccd0977299$var$ArrayPrototypePush = (parcelRequire("6EUyW")).ArrayPrototypePush, $d9e691ccd0977299$var$Boolean = (parcelRequire("6EUyW")).Boolean, $d9e691ccd0977299$var$MathFloor = (parcelRequire("6EUyW")).MathFloor, $d9e691ccd0977299$var$Number = (parcelRequire("6EUyW")).Number, $d9e691ccd0977299$var$NumberIsNaN = (parcelRequire("6EUyW")).NumberIsNaN, $d9e691ccd0977299$var$Promise = (parcelRequire("6EUyW")).Promise, $d9e691ccd0977299$var$PromiseReject = (parcelRequire("6EUyW")).PromiseReject, $d9e691ccd0977299$var$PromiseResolve = (parcelRequire("6EUyW")).PromiseResolve, $d9e691ccd0977299$var$PromisePrototypeThen = (parcelRequire("6EUyW")).PromisePrototypeThen, $d9e691ccd0977299$var$Symbol = (parcelRequire("6EUyW")).Symbol;
var $d9e691ccd0977299$var$kEmpty = $d9e691ccd0977299$var$Symbol('kEmpty');
var $d9e691ccd0977299$var$kEof = $d9e691ccd0977299$var$Symbol('kEof');
function $d9e691ccd0977299$var$compose(stream, options) {
    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
    if ($d9e691ccd0977299$var$isNodeStream(stream) && !$d9e691ccd0977299$var$isWritable(stream)) throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $3aRTL(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $d9e691ccd0977299$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $d9e691ccd0977299$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $d9e691ccd0977299$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $d9e691ccd0977299$var$MathFloor(options.highWaterMark);
    $d9e691ccd0977299$var$validateInteger(concurrency, 'options.concurrency', 1);
    $d9e691ccd0977299$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $d9e691ccd0977299$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $d9e691ccd0977299$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $d9e691ccd0977299$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $d9e691ccd0977299$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $d9e691ccd0977299$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $d9e691ccd0977299$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($d9e691ccd0977299$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $d9e691ccd0977299$var$PromiseReject(err1);
                                $d9e691ccd0977299$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("dNICR")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($d9e691ccd0977299$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $d9e691ccd0977299$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $d9e691ccd0977299$var$AbortError();
                        if (!(val !== $d9e691ccd0977299$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $d9e691ccd0977299$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $d9e691ccd0977299$var$asIndexedPairs(options) {
    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $d9e691ccd0977299$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $d9e691ccd0977299$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($d9e691ccd0977299$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $d9e691ccd0977299$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $d9e691ccd0977299$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $d9e691ccd0977299$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($d9e691ccd0977299$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $d9e691ccd0977299$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $d9e691ccd0977299$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($d9e691ccd0977299$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $d9e691ccd0977299$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $d9e691ccd0977299$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $d9e691ccd0977299$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $d9e691ccd0977299$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($d9e691ccd0977299$var$ERR_MISSING_ARGS);
function $d9e691ccd0977299$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $d9e691ccd0977299$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $d9e691ccd0977299$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $d9e691ccd0977299$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $d9e691ccd0977299$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $d9e691ccd0977299$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $d9e691ccd0977299$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $d9e691ccd0977299$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $d9e691ccd0977299$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $d9e691ccd0977299$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $d9e691ccd0977299$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $d9e691ccd0977299$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $d9e691ccd0977299$var$flatMap(fn, options) {
    var values = $d9e691ccd0977299$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $d9e691ccd0977299$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $d9e691ccd0977299$var$Number(number);
    if ($d9e691ccd0977299$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $d9e691ccd0977299$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $d9e691ccd0977299$var$drop(number, options) {
    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
    number = $d9e691ccd0977299$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $d9e691ccd0977299$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $d9e691ccd0977299$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $d9e691ccd0977299$var$take(number, options) {
    if (options != null) $d9e691ccd0977299$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $d9e691ccd0977299$var$validateAbortSignal(options.signal, 'options.signal');
    number = $d9e691ccd0977299$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $d9e691ccd0977299$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $d9e691ccd0977299$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$d9e691ccd0977299$export$42af8c323be37587 = {
    asIndexedPairs: $d9e691ccd0977299$require$deprecate($d9e691ccd0977299$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $d9e691ccd0977299$var$drop,
    filter: $d9e691ccd0977299$var$filter,
    flatMap: $d9e691ccd0977299$var$flatMap,
    map: $d9e691ccd0977299$var$map,
    take: $d9e691ccd0977299$var$take,
    compose: $d9e691ccd0977299$var$compose
};
$d9e691ccd0977299$export$f405f72c701dad87 = {
    every: $d9e691ccd0977299$var$every,
    forEach: $d9e691ccd0977299$var$forEach,
    reduce: $d9e691ccd0977299$var$reduce,
    toArray: $d9e691ccd0977299$var$toArray,
    some: $d9e691ccd0977299$var$some,
    find: $d9e691ccd0977299$var$find
};

});
parcelRegister("d6Z3R", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $98bb3360ebb2f023$var$ArrayIsArray = $6EUyW.ArrayIsArray, $98bb3360ebb2f023$var$ArrayPrototypeIncludes = $6EUyW.ArrayPrototypeIncludes, $98bb3360ebb2f023$var$ArrayPrototypeJoin = $6EUyW.ArrayPrototypeJoin, $98bb3360ebb2f023$var$ArrayPrototypeMap = $6EUyW.ArrayPrototypeMap, $98bb3360ebb2f023$var$NumberIsInteger = $6EUyW.NumberIsInteger, $98bb3360ebb2f023$var$NumberIsNaN = $6EUyW.NumberIsNaN, $98bb3360ebb2f023$var$NumberMAX_SAFE_INTEGER = $6EUyW.NumberMAX_SAFE_INTEGER, $98bb3360ebb2f023$var$NumberMIN_SAFE_INTEGER = $6EUyW.NumberMIN_SAFE_INTEGER, $98bb3360ebb2f023$var$NumberParseInt = $6EUyW.NumberParseInt, $98bb3360ebb2f023$var$ObjectPrototypeHasOwnProperty = $6EUyW.ObjectPrototypeHasOwnProperty, $98bb3360ebb2f023$var$RegExpPrototypeExec = $6EUyW.RegExpPrototypeExec, $98bb3360ebb2f023$var$String = $6EUyW.String, $98bb3360ebb2f023$var$StringPrototypeToUpperCase = $6EUyW.StringPrototypeToUpperCase, $98bb3360ebb2f023$var$StringPrototypeTrim = $6EUyW.StringPrototypeTrim;

var $3Yp2a = parcelRequire("3Yp2a");
var $98bb3360ebb2f023$var$hideStackFrames = $3Yp2a.hideStackFrames, $98bb3360ebb2f023$var$_require_codes = $3Yp2a.codes, $98bb3360ebb2f023$var$ERR_SOCKET_BAD_PORT = $98bb3360ebb2f023$var$_require_codes.ERR_SOCKET_BAD_PORT, $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE = $98bb3360ebb2f023$var$_require_codes.ERR_INVALID_ARG_TYPE, $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE = $98bb3360ebb2f023$var$_require_codes.ERR_INVALID_ARG_VALUE, $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE = $98bb3360ebb2f023$var$_require_codes.ERR_OUT_OF_RANGE, $98bb3360ebb2f023$var$ERR_UNKNOWN_SIGNAL = $98bb3360ebb2f023$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $dNICR = parcelRequire("dNICR");
var $98bb3360ebb2f023$require$normalizeEncoding = $dNICR.normalizeEncoding;

var $dNICR = parcelRequire("dNICR");
var $98bb3360ebb2f023$require$_require_types = $dNICR.types;
var $98bb3360ebb2f023$var$isAsyncFunction = $98bb3360ebb2f023$require$_require_types.isAsyncFunction, $98bb3360ebb2f023$var$isArrayBufferView = $98bb3360ebb2f023$require$_require_types.isArrayBufferView;
var $98bb3360ebb2f023$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $98bb3360ebb2f023$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $98bb3360ebb2f023$var$isUint32(value) {
    return value === value >>> 0;
}
var $98bb3360ebb2f023$var$octalReg = /^[0-7]+$/;
var $98bb3360ebb2f023$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $98bb3360ebb2f023$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($98bb3360ebb2f023$var$RegExpPrototypeExec($98bb3360ebb2f023$var$octalReg, value) === null) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE(name, value, $98bb3360ebb2f023$var$modeDesc);
        value = $98bb3360ebb2f023$var$NumberParseInt(value, 8);
    }
    $98bb3360ebb2f023$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $98bb3360ebb2f023$var$validateInteger = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $98bb3360ebb2f023$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $98bb3360ebb2f023$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$98bb3360ebb2f023$var$NumberIsInteger(value)) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $98bb3360ebb2f023$var$validateInt32 = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$98bb3360ebb2f023$var$NumberIsInteger(value)) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $98bb3360ebb2f023$var$validateUint32 = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$98bb3360ebb2f023$var$NumberIsInteger(value)) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $98bb3360ebb2f023$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $98bb3360ebb2f023$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $98bb3360ebb2f023$var$NumberIsNaN(value)) throw new $98bb3360ebb2f023$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $98bb3360ebb2f023$var$validateOneOf = $98bb3360ebb2f023$var$hideStackFrames(function(value, name, oneOf) {
    if (!$98bb3360ebb2f023$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $98bb3360ebb2f023$var$ArrayPrototypeJoin($98bb3360ebb2f023$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $98bb3360ebb2f023$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $98bb3360ebb2f023$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $98bb3360ebb2f023$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$98bb3360ebb2f023$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $98bb3360ebb2f023$var$validateObject = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $98bb3360ebb2f023$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $98bb3360ebb2f023$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $98bb3360ebb2f023$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $98bb3360ebb2f023$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $98bb3360ebb2f023$var$validateDictionary = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $98bb3360ebb2f023$var$validateArray = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$98bb3360ebb2f023$var$ArrayIsArray(value)) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $98bb3360ebb2f023$var$validateStringArray(value, name) {
    $98bb3360ebb2f023$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$98bb3360ebb2f023$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $98bb3360ebb2f023$var$validateBooleanArray(value, name) {
    $98bb3360ebb2f023$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$98bb3360ebb2f023$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $98bb3360ebb2f023$var$validateAbortSignalArray(value, name) {
    $98bb3360ebb2f023$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $98bb3360ebb2f023$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $98bb3360ebb2f023$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $98bb3360ebb2f023$var$validateString(signal, name);
    if ($98bb3360ebb2f023$var$signals[signal] === undefined) {
        if ($98bb3360ebb2f023$var$signals[$98bb3360ebb2f023$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $98bb3360ebb2f023$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $98bb3360ebb2f023$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $98bb3360ebb2f023$var$validateBuffer = $98bb3360ebb2f023$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$98bb3360ebb2f023$var$isArrayBufferView(buffer)) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $98bb3360ebb2f023$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $98bb3360ebb2f023$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $98bb3360ebb2f023$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $98bb3360ebb2f023$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $98bb3360ebb2f023$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $98bb3360ebb2f023$var$validateAbortSignal = $98bb3360ebb2f023$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $98bb3360ebb2f023$var$validateFunction = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $98bb3360ebb2f023$var$validatePlainFunction = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $98bb3360ebb2f023$var$isAsyncFunction(value)) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $98bb3360ebb2f023$var$validateUndefined = $98bb3360ebb2f023$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $98bb3360ebb2f023$var$validateUnion(value, name, union) {
    if (!$98bb3360ebb2f023$var$ArrayPrototypeIncludes(union, value)) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_TYPE(name, "('".concat($98bb3360ebb2f023$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $98bb3360ebb2f023$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $98bb3360ebb2f023$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$98bb3360ebb2f023$var$RegExpPrototypeExec($98bb3360ebb2f023$var$linkValueRegExp, value)) throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $98bb3360ebb2f023$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $98bb3360ebb2f023$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($98bb3360ebb2f023$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $98bb3360ebb2f023$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $98bb3360ebb2f023$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $98bb3360ebb2f023$var$isInt32,
    isUint32: $98bb3360ebb2f023$var$isUint32,
    parseFileMode: $98bb3360ebb2f023$var$parseFileMode,
    validateArray: $98bb3360ebb2f023$var$validateArray,
    validateStringArray: $98bb3360ebb2f023$var$validateStringArray,
    validateBooleanArray: $98bb3360ebb2f023$var$validateBooleanArray,
    validateAbortSignalArray: $98bb3360ebb2f023$var$validateAbortSignalArray,
    validateBoolean: $98bb3360ebb2f023$var$validateBoolean,
    validateBuffer: $98bb3360ebb2f023$var$validateBuffer,
    validateDictionary: $98bb3360ebb2f023$var$validateDictionary,
    validateEncoding: $98bb3360ebb2f023$var$validateEncoding,
    validateFunction: $98bb3360ebb2f023$var$validateFunction,
    validateInt32: $98bb3360ebb2f023$var$validateInt32,
    validateInteger: $98bb3360ebb2f023$var$validateInteger,
    validateNumber: $98bb3360ebb2f023$var$validateNumber,
    validateObject: $98bb3360ebb2f023$var$validateObject,
    validateOneOf: $98bb3360ebb2f023$var$validateOneOf,
    validatePlainFunction: $98bb3360ebb2f023$var$validatePlainFunction,
    validatePort: $98bb3360ebb2f023$var$validatePort,
    validateSignalName: $98bb3360ebb2f023$var$validateSignalName,
    validateString: $98bb3360ebb2f023$var$validateString,
    validateUint32: $98bb3360ebb2f023$var$validateUint32,
    validateUndefined: $98bb3360ebb2f023$var$validateUndefined,
    validateUnion: $98bb3360ebb2f023$var$validateUnion,
    validateAbortSignal: $98bb3360ebb2f023$var$validateAbortSignal,
    validateLinkHeaderValue: $98bb3360ebb2f023$var$validateLinkHeaderValue
};

});

parcelRegister("gvFwV", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3Yp2a = parcelRequire("3Yp2a");
/* replacement end */ var $c04fc1926c15e788$var$AbortError = $3Yp2a.AbortError, $c04fc1926c15e788$var$codes = $3Yp2a.codes;
var $c04fc1926c15e788$var$ERR_INVALID_ARG_TYPE = $c04fc1926c15e788$var$codes.ERR_INVALID_ARG_TYPE, $c04fc1926c15e788$var$ERR_STREAM_PREMATURE_CLOSE = $c04fc1926c15e788$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $c04fc1926c15e788$var$kEmptyObject = (parcelRequire("dNICR")).kEmptyObject, $c04fc1926c15e788$var$once = (parcelRequire("dNICR")).once;

var $d6Z3R = parcelRequire("d6Z3R");
var $c04fc1926c15e788$var$validateAbortSignal = $d6Z3R.validateAbortSignal, $c04fc1926c15e788$var$validateFunction = $d6Z3R.validateFunction, $c04fc1926c15e788$var$validateObject = $d6Z3R.validateObject, $c04fc1926c15e788$var$validateBoolean = $d6Z3R.validateBoolean;

var $6EUyW = parcelRequire("6EUyW");
var $c04fc1926c15e788$var$Promise = $6EUyW.Promise, $c04fc1926c15e788$var$PromisePrototypeThen = $6EUyW.PromisePrototypeThen, $c04fc1926c15e788$var$SymbolDispose = $6EUyW.SymbolDispose;

var $h5dib = parcelRequire("h5dib");
var $c04fc1926c15e788$var$isClosed = $h5dib.isClosed, $c04fc1926c15e788$var$isReadable = $h5dib.isReadable, $c04fc1926c15e788$var$isReadableNodeStream = $h5dib.isReadableNodeStream, $c04fc1926c15e788$var$isReadableStream = $h5dib.isReadableStream, $c04fc1926c15e788$var$isReadableFinished = $h5dib.isReadableFinished, $c04fc1926c15e788$var$isReadableErrored = $h5dib.isReadableErrored, $c04fc1926c15e788$var$isWritable = $h5dib.isWritable, $c04fc1926c15e788$var$isWritableNodeStream = $h5dib.isWritableNodeStream, $c04fc1926c15e788$var$isWritableStream = $h5dib.isWritableStream, $c04fc1926c15e788$var$isWritableFinished = $h5dib.isWritableFinished, $c04fc1926c15e788$var$isWritableErrored = $h5dib.isWritableErrored, $c04fc1926c15e788$var$isNodeStream = $h5dib.isNodeStream, $c04fc1926c15e788$var$_willEmitClose = $h5dib.willEmitClose, $c04fc1926c15e788$var$kIsClosedPromise = $h5dib.kIsClosedPromise;
var $c04fc1926c15e788$var$addAbortListener;
function $c04fc1926c15e788$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $c04fc1926c15e788$var$nop = function() {};

function $c04fc1926c15e788$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $c04fc1926c15e788$var$kEmptyObject;
    } else if (options == null) options = $c04fc1926c15e788$var$kEmptyObject;
    else $c04fc1926c15e788$var$validateObject(options, 'options');
    $c04fc1926c15e788$var$validateFunction(callback, 'callback');
    $c04fc1926c15e788$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $c04fc1926c15e788$var$once(callback);
    if ($c04fc1926c15e788$var$isReadableStream(stream) || $c04fc1926c15e788$var$isWritableStream(stream)) return $c04fc1926c15e788$var$eosWeb(stream, options, callback);
    if (!$c04fc1926c15e788$var$isNodeStream(stream)) throw new $c04fc1926c15e788$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $c04fc1926c15e788$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $c04fc1926c15e788$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $c04fc1926c15e788$var$_willEmitClose(stream) && $c04fc1926c15e788$var$isReadableNodeStream(stream) === readable && $c04fc1926c15e788$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $c04fc1926c15e788$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $c04fc1926c15e788$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $c04fc1926c15e788$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $c04fc1926c15e788$var$isWritableErrored(stream) || $c04fc1926c15e788$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $c04fc1926c15e788$var$isReadableNodeStream(stream, true)) {
            if (!$c04fc1926c15e788$var$isReadableFinished(stream, false)) return callback.call(stream, new $c04fc1926c15e788$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$c04fc1926c15e788$var$isWritableFinished(stream, false)) return callback.call(stream, new $c04fc1926c15e788$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $c04fc1926c15e788$var$isWritableErrored(stream) || $c04fc1926c15e788$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($c04fc1926c15e788$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $c04fc1926c15e788$var$isReadable(stream)) && (writableFinished || $c04fc1926c15e788$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $c04fc1926c15e788$var$isWritable(stream)) && (readableFinished || $c04fc1926c15e788$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $c04fc1926c15e788$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $c04fc1926c15e788$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $c04fc1926c15e788$var$addAbortListener = $c04fc1926c15e788$var$addAbortListener || (parcelRequire("dNICR")).addAbortListener;
            var disposable = $c04fc1926c15e788$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $c04fc1926c15e788$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$c04fc1926c15e788$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $c04fc1926c15e788$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $c04fc1926c15e788$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $c04fc1926c15e788$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $c04fc1926c15e788$var$addAbortListener = $c04fc1926c15e788$var$addAbortListener || (parcelRequire("dNICR")).addAbortListener;
            var disposable = $c04fc1926c15e788$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $c04fc1926c15e788$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$c04fc1926c15e788$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $c04fc1926c15e788$var$PromisePrototypeThen(stream[$c04fc1926c15e788$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $c04fc1926c15e788$var$nop;
}
function $c04fc1926c15e788$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $c04fc1926c15e788$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $c04fc1926c15e788$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $c04fc1926c15e788$var$Promise(function(resolve, reject) {
        var cleanup = $c04fc1926c15e788$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $c04fc1926c15e788$var$eos;
module.exports.finished = $c04fc1926c15e788$var$finished;

});
parcelRegister("h5dib", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $c6fd36daf660b36f$var$SymbolAsyncIterator = $6EUyW.SymbolAsyncIterator, $c6fd36daf660b36f$var$SymbolIterator = $6EUyW.SymbolIterator, $c6fd36daf660b36f$var$SymbolFor = $6EUyW.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $c6fd36daf660b36f$var$kIsDestroyed = $c6fd36daf660b36f$var$SymbolFor('nodejs.stream.destroyed');
var $c6fd36daf660b36f$var$kIsErrored = $c6fd36daf660b36f$var$SymbolFor('nodejs.stream.errored');
var $c6fd36daf660b36f$var$kIsReadable = $c6fd36daf660b36f$var$SymbolFor('nodejs.stream.readable');
var $c6fd36daf660b36f$var$kIsWritable = $c6fd36daf660b36f$var$SymbolFor('nodejs.stream.writable');
var $c6fd36daf660b36f$var$kIsDisturbed = $c6fd36daf660b36f$var$SymbolFor('nodejs.stream.disturbed');
var $c6fd36daf660b36f$var$kIsClosedPromise = $c6fd36daf660b36f$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $c6fd36daf660b36f$var$kControllerErrorFunction = $c6fd36daf660b36f$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $c6fd36daf660b36f$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $c6fd36daf660b36f$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $c6fd36daf660b36f$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $c6fd36daf660b36f$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $c6fd36daf660b36f$var$isReadableStream(obj) {
    return !!(obj && !$c6fd36daf660b36f$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $c6fd36daf660b36f$var$isWritableStream(obj) {
    return !!(obj && !$c6fd36daf660b36f$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $c6fd36daf660b36f$var$isTransformStream(obj) {
    return !!(obj && !$c6fd36daf660b36f$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $c6fd36daf660b36f$var$isWebStream(obj) {
    return $c6fd36daf660b36f$var$isReadableStream(obj) || $c6fd36daf660b36f$var$isWritableStream(obj) || $c6fd36daf660b36f$var$isTransformStream(obj);
}
function $c6fd36daf660b36f$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$c6fd36daf660b36f$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$c6fd36daf660b36f$var$SymbolIterator] === 'function';
    return typeof obj[$c6fd36daf660b36f$var$SymbolAsyncIterator] === 'function' || typeof obj[$c6fd36daf660b36f$var$SymbolIterator] === 'function';
}
function $c6fd36daf660b36f$var$isDestroyed(stream) {
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$c6fd36daf660b36f$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $c6fd36daf660b36f$var$isWritableEnded(stream) {
    if (!$c6fd36daf660b36f$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $c6fd36daf660b36f$var$isWritableFinished(stream, strict) {
    if (!$c6fd36daf660b36f$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $c6fd36daf660b36f$var$isReadableEnded(stream) {
    if (!$c6fd36daf660b36f$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $c6fd36daf660b36f$var$isReadableFinished(stream, strict) {
    if (!$c6fd36daf660b36f$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $c6fd36daf660b36f$var$isReadable(stream) {
    if (stream && stream[$c6fd36daf660b36f$var$kIsReadable] != null) return stream[$c6fd36daf660b36f$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($c6fd36daf660b36f$var$isDestroyed(stream)) return false;
    return $c6fd36daf660b36f$var$isReadableNodeStream(stream) && stream.readable && !$c6fd36daf660b36f$var$isReadableFinished(stream);
}
function $c6fd36daf660b36f$var$isWritable(stream) {
    if (stream && stream[$c6fd36daf660b36f$var$kIsWritable] != null) return stream[$c6fd36daf660b36f$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($c6fd36daf660b36f$var$isDestroyed(stream)) return false;
    return $c6fd36daf660b36f$var$isWritableNodeStream(stream) && stream.writable && !$c6fd36daf660b36f$var$isWritableEnded(stream);
}
function $c6fd36daf660b36f$var$isFinished(stream, opts) {
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    if ($c6fd36daf660b36f$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $c6fd36daf660b36f$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $c6fd36daf660b36f$var$isWritable(stream)) return false;
    return true;
}
function $c6fd36daf660b36f$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $c6fd36daf660b36f$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $c6fd36daf660b36f$var$isClosed(stream) {
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $c6fd36daf660b36f$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $c6fd36daf660b36f$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $c6fd36daf660b36f$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $c6fd36daf660b36f$var$isOutgoingMessage(stream);
}
function $c6fd36daf660b36f$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $c6fd36daf660b36f$var$willEmitClose(stream) {
    if (!$c6fd36daf660b36f$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $c6fd36daf660b36f$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $c6fd36daf660b36f$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$c6fd36daf660b36f$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $c6fd36daf660b36f$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$c6fd36daf660b36f$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $c6fd36daf660b36f$var$isDestroyed,
    kIsDestroyed: $c6fd36daf660b36f$var$kIsDestroyed,
    isDisturbed: $c6fd36daf660b36f$var$isDisturbed,
    kIsDisturbed: $c6fd36daf660b36f$var$kIsDisturbed,
    isErrored: $c6fd36daf660b36f$var$isErrored,
    kIsErrored: $c6fd36daf660b36f$var$kIsErrored,
    isReadable: $c6fd36daf660b36f$var$isReadable,
    kIsReadable: $c6fd36daf660b36f$var$kIsReadable,
    kIsClosedPromise: $c6fd36daf660b36f$var$kIsClosedPromise,
    kControllerErrorFunction: $c6fd36daf660b36f$var$kControllerErrorFunction,
    kIsWritable: $c6fd36daf660b36f$var$kIsWritable,
    isClosed: $c6fd36daf660b36f$var$isClosed,
    isDuplexNodeStream: $c6fd36daf660b36f$var$isDuplexNodeStream,
    isFinished: $c6fd36daf660b36f$var$isFinished,
    isIterable: $c6fd36daf660b36f$var$isIterable,
    isReadableNodeStream: $c6fd36daf660b36f$var$isReadableNodeStream,
    isReadableStream: $c6fd36daf660b36f$var$isReadableStream,
    isReadableEnded: $c6fd36daf660b36f$var$isReadableEnded,
    isReadableFinished: $c6fd36daf660b36f$var$isReadableFinished,
    isReadableErrored: $c6fd36daf660b36f$var$isReadableErrored,
    isNodeStream: $c6fd36daf660b36f$var$isNodeStream,
    isWebStream: $c6fd36daf660b36f$var$isWebStream,
    isWritable: $c6fd36daf660b36f$var$isWritable,
    isWritableNodeStream: $c6fd36daf660b36f$var$isWritableNodeStream,
    isWritableStream: $c6fd36daf660b36f$var$isWritableStream,
    isWritableEnded: $c6fd36daf660b36f$var$isWritableEnded,
    isWritableFinished: $c6fd36daf660b36f$var$isWritableFinished,
    isWritableErrored: $c6fd36daf660b36f$var$isWritableErrored,
    isServerRequest: $c6fd36daf660b36f$var$isServerRequest,
    isServerResponse: $c6fd36daf660b36f$var$isServerResponse,
    willEmitClose: $c6fd36daf660b36f$var$willEmitClose,
    isTransformStream: $c6fd36daf660b36f$var$isTransformStream
};

});


parcelRegister("3aRTL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $eV3GP = parcelRequire("eV3GP");
var $24fc1d5f4e023acb$require$pipeline = $eV3GP.pipeline;

var $8Lioq = parcelRequire("8Lioq");

var $5lyk7 = parcelRequire("5lyk7");
var $24fc1d5f4e023acb$require$destroyer = $5lyk7.destroyer;

var $h5dib = parcelRequire("h5dib");
var $24fc1d5f4e023acb$var$isNodeStream = $h5dib.isNodeStream, $24fc1d5f4e023acb$var$isReadable = $h5dib.isReadable, $24fc1d5f4e023acb$var$isWritable = $h5dib.isWritable, $24fc1d5f4e023acb$var$isWebStream = $h5dib.isWebStream, $24fc1d5f4e023acb$var$isTransformStream = $h5dib.isTransformStream, $24fc1d5f4e023acb$var$isWritableStream = $h5dib.isWritableStream, $24fc1d5f4e023acb$var$isReadableStream = $h5dib.isReadableStream;

var $3Yp2a = parcelRequire("3Yp2a");
var $24fc1d5f4e023acb$var$AbortError = $3Yp2a.AbortError, $24fc1d5f4e023acb$var$_require_codes = $3Yp2a.codes, $24fc1d5f4e023acb$var$ERR_INVALID_ARG_VALUE = $24fc1d5f4e023acb$var$_require_codes.ERR_INVALID_ARG_VALUE, $24fc1d5f4e023acb$var$ERR_MISSING_ARGS = $24fc1d5f4e023acb$var$_require_codes.ERR_MISSING_ARGS;

var $gvFwV = parcelRequire("gvFwV");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $24fc1d5f4e023acb$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $8Lioq.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $8Lioq.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $8Lioq.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$24fc1d5f4e023acb$var$isNodeStream(streams[n]) && !$24fc1d5f4e023acb$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($24fc1d5f4e023acb$var$isReadable(streams[n]) || $24fc1d5f4e023acb$var$isReadableStream(streams[n]) || $24fc1d5f4e023acb$var$isTransformStream(streams[n]))) throw new $24fc1d5f4e023acb$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($24fc1d5f4e023acb$var$isWritable(streams[n]) || $24fc1d5f4e023acb$var$isWritableStream(streams[n]) || $24fc1d5f4e023acb$var$isTransformStream(streams[n]))) throw new $24fc1d5f4e023acb$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $24fc1d5f4e023acb$require$pipeline(streams, onfinished);
    var writable = !!($24fc1d5f4e023acb$var$isWritable(head) || $24fc1d5f4e023acb$var$isWritableStream(head) || $24fc1d5f4e023acb$var$isTransformStream(head));
    var readable = !!($24fc1d5f4e023acb$var$isReadable(tail) || $24fc1d5f4e023acb$var$isReadableStream(tail) || $24fc1d5f4e023acb$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $8Lioq({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($24fc1d5f4e023acb$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($24fc1d5f4e023acb$var$isWebStream(head)) {
            var writable1 = $24fc1d5f4e023acb$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $24fc1d5f4e023acb$var$isTransformStream(tail) ? tail.readable : tail;
        $gvFwV(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($24fc1d5f4e023acb$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($24fc1d5f4e023acb$var$isWebStream(tail)) {
            var readable1 = $24fc1d5f4e023acb$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $24fc1d5f4e023acb$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($24fc1d5f4e023acb$var$isNodeStream(tail)) $24fc1d5f4e023acb$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("eV3GP", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $adc940409add276c$var$ArrayIsArray = $6EUyW.ArrayIsArray, $adc940409add276c$var$Promise = $6EUyW.Promise, $adc940409add276c$var$SymbolAsyncIterator = $6EUyW.SymbolAsyncIterator, $adc940409add276c$var$SymbolDispose = $6EUyW.SymbolDispose;

var $gvFwV = parcelRequire("gvFwV");

var $adc940409add276c$require$once = (parcelRequire("dNICR")).once;

var $5lyk7 = parcelRequire("5lyk7");

var $8Lioq = parcelRequire("8Lioq");

var $3Yp2a = parcelRequire("3Yp2a");
var $adc940409add276c$var$aggregateTwoErrors = $3Yp2a.aggregateTwoErrors, $adc940409add276c$var$_require_codes = $3Yp2a.codes, $adc940409add276c$var$ERR_INVALID_ARG_TYPE = $adc940409add276c$var$_require_codes.ERR_INVALID_ARG_TYPE, $adc940409add276c$var$ERR_INVALID_RETURN_VALUE = $adc940409add276c$var$_require_codes.ERR_INVALID_RETURN_VALUE, $adc940409add276c$var$ERR_MISSING_ARGS = $adc940409add276c$var$_require_codes.ERR_MISSING_ARGS, $adc940409add276c$var$ERR_STREAM_DESTROYED = $adc940409add276c$var$_require_codes.ERR_STREAM_DESTROYED, $adc940409add276c$var$ERR_STREAM_PREMATURE_CLOSE = $adc940409add276c$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $adc940409add276c$var$AbortError = $3Yp2a.AbortError;

var $d6Z3R = parcelRequire("d6Z3R");
var $adc940409add276c$var$validateFunction = $d6Z3R.validateFunction, $adc940409add276c$var$validateAbortSignal = $d6Z3R.validateAbortSignal;

var $h5dib = parcelRequire("h5dib");
var $adc940409add276c$var$isIterable = $h5dib.isIterable, $adc940409add276c$var$isReadable = $h5dib.isReadable, $adc940409add276c$var$isReadableNodeStream = $h5dib.isReadableNodeStream, $adc940409add276c$var$isNodeStream = $h5dib.isNodeStream, $adc940409add276c$var$isTransformStream = $h5dib.isTransformStream, $adc940409add276c$var$isWebStream = $h5dib.isWebStream, $adc940409add276c$var$isReadableStream = $h5dib.isReadableStream, $adc940409add276c$var$isReadableFinished = $h5dib.isReadableFinished;

var $adc940409add276c$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $adc940409add276c$var$PassThrough;
var $adc940409add276c$var$Readable;
var $adc940409add276c$var$addAbortListener;
function $adc940409add276c$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $gvFwV(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $5lyk7.destroyer(stream, err || new $adc940409add276c$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $adc940409add276c$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $adc940409add276c$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $adc940409add276c$var$makeAsyncIterable(val) {
    if ($adc940409add276c$var$isIterable(val)) return val;
    else if ($adc940409add276c$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $adc940409add276c$var$fromReadable(val);
    throw new $adc940409add276c$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $adc940409add276c$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$adc940409add276c$var$Readable) $adc940409add276c$var$Readable = (parcelRequire("sAhw0"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($adc940409add276c$var$Readable.prototype[$adc940409add276c$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $adc940409add276c$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $adc940409add276c$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $gvFwV(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $adc940409add276c$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $adc940409add276c$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($adc940409add276c$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $adc940409add276c$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $adc940409add276c$var$pipelineImpl(streams, $adc940409add276c$require$once($adc940409add276c$var$popCallback(streams)));
}


function $adc940409add276c$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($adc940409add276c$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $adc940409add276c$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($adc940409add276c$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($adc940409add276c$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$adc940409add276c$var$isIterable(ret)) throw new $adc940409add276c$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($adc940409add276c$var$isIterable(stream) || $adc940409add276c$var$isReadableNodeStream(stream) || $adc940409add276c$var$isTransformStream(stream)) ret = stream;
            else ret = $8Lioq.from(stream);
        } else if (typeof stream === 'function') {
            if ($adc940409add276c$var$isTransformStream(ret)) {
                var _ret;
                ret = $adc940409add276c$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $adc940409add276c$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$adc940409add276c$var$isIterable(ret, true)) throw new $adc940409add276c$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$adc940409add276c$var$PassThrough) $adc940409add276c$var$PassThrough = (parcelRequire("hHQw5"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $adc940409add276c$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($adc940409add276c$var$isIterable(ret, true)) {
                    finishCount++;
                    $adc940409add276c$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($adc940409add276c$var$isReadableStream(ret) || $adc940409add276c$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $adc940409add276c$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $adc940409add276c$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $adc940409add276c$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($adc940409add276c$var$isNodeStream(stream)) {
            if ($adc940409add276c$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $adc940409add276c$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($adc940409add276c$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($adc940409add276c$var$isTransformStream(ret) || $adc940409add276c$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $adc940409add276c$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($adc940409add276c$var$isIterable(ret)) {
                finishCount++;
                $adc940409add276c$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $adc940409add276c$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($adc940409add276c$var$isWebStream(stream)) {
            if ($adc940409add276c$var$isReadableNodeStream(ret)) {
                finishCount++;
                $adc940409add276c$var$pumpToWeb($adc940409add276c$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($adc940409add276c$var$isReadableStream(ret) || $adc940409add276c$var$isIterable(ret)) {
                finishCount++;
                $adc940409add276c$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($adc940409add276c$var$isTransformStream(ret)) {
                finishCount++;
                $adc940409add276c$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $adc940409add276c$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $8Lioq.from(stream);
    };
    if (streams.length === 1 && $adc940409add276c$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $adc940409add276c$var$ERR_MISSING_ARGS('streams');
    var ac = new $adc940409add276c$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $adc940409add276c$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $adc940409add276c$var$AbortError());
    }
    $adc940409add276c$var$addAbortListener = $adc940409add276c$var$addAbortListener || (parcelRequire("dNICR")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $adc940409add276c$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$adc940409add276c$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $adc940409add276c$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $adc940409add276c$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($adc940409add276c$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $gvFwV(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $gvFwV(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $adc940409add276c$var$pipelineImpl,
    pipeline: $adc940409add276c$var$pipeline
};

});
parcelRegister("5lyk7", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3Yp2a = parcelRequire("3Yp2a");
/* replacement end */ var $3e4989dace079b63$var$aggregateTwoErrors = $3Yp2a.aggregateTwoErrors, $3e4989dace079b63$var$ERR_MULTIPLE_CALLBACK = $3Yp2a.codes.ERR_MULTIPLE_CALLBACK, $3e4989dace079b63$var$AbortError = $3Yp2a.AbortError;

var $6EUyW = parcelRequire("6EUyW");
var $3e4989dace079b63$require$Symbol = $6EUyW.Symbol;

var $h5dib = parcelRequire("h5dib");
var $3e4989dace079b63$var$kIsDestroyed = $h5dib.kIsDestroyed, $3e4989dace079b63$var$isDestroyed = $h5dib.isDestroyed, $3e4989dace079b63$var$isFinished = $h5dib.isFinished, $3e4989dace079b63$var$isServerRequest = $h5dib.isServerRequest;
var $3e4989dace079b63$var$kDestroy = $3e4989dace079b63$require$Symbol('kDestroy');
var $3e4989dace079b63$var$kConstruct = $3e4989dace079b63$require$Symbol('kConstruct');
function $3e4989dace079b63$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $3e4989dace079b63$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $3e4989dace079b63$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($3e4989dace079b63$var$kDestroy, function(er) {
        $3e4989dace079b63$var$_destroy(this, $3e4989dace079b63$var$aggregateTwoErrors(er, err), cb);
    });
    else $3e4989dace079b63$var$_destroy(this, err, cb);
    return this;
}
function $3e4989dace079b63$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $3e4989dace079b63$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($3e4989dace079b63$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($3e4989dace079b63$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $3e4989dace079b63$var$emitErrorCloseNT(self, err) {
    $3e4989dace079b63$var$emitErrorNT(self, err);
    $3e4989dace079b63$var$emitCloseNT(self);
}
function $3e4989dace079b63$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $3e4989dace079b63$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $3e4989dace079b63$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $3e4989dace079b63$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($3e4989dace079b63$var$emitErrorNT, stream, err);
        else $3e4989dace079b63$var$emitErrorNT(stream, err);
    }
}
function $3e4989dace079b63$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($3e4989dace079b63$var$kConstruct, cb);
    if (stream.listenerCount($3e4989dace079b63$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($3e4989dace079b63$var$constructNT, stream);
}
function $3e4989dace079b63$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $3e4989dace079b63$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $3e4989dace079b63$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($3e4989dace079b63$var$kDestroy, err);
        else if (err) $3e4989dace079b63$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($3e4989dace079b63$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $3e4989dace079b63$var$emitConstructNT(stream) {
    stream.emit($3e4989dace079b63$var$kConstruct);
}
function $3e4989dace079b63$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $3e4989dace079b63$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $3e4989dace079b63$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($3e4989dace079b63$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $3e4989dace079b63$var$destroyer(stream, err) {
    if (!stream || $3e4989dace079b63$var$isDestroyed(stream)) return;
    if (!err && !$3e4989dace079b63$var$isFinished(stream)) err = new $3e4989dace079b63$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($3e4989dace079b63$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($3e4989dace079b63$var$isRequest(stream)) stream.abort();
    else if ($3e4989dace079b63$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($3e4989dace079b63$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($3e4989dace079b63$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$3e4989dace079b63$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $3e4989dace079b63$var$construct,
    destroyer: $3e4989dace079b63$var$destroyer,
    destroy: $3e4989dace079b63$var$destroy,
    undestroy: $3e4989dace079b63$var$undestroy,
    errorOrDestroy: $3e4989dace079b63$var$errorOrDestroy
};

});

parcelRegister("8Lioq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $6610fafc440d4128$var$ObjectDefineProperties = $6EUyW.ObjectDefineProperties, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor = $6EUyW.ObjectGetOwnPropertyDescriptor, $6610fafc440d4128$var$ObjectKeys = $6EUyW.ObjectKeys, $6610fafc440d4128$var$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf;
module.exports = $6610fafc440d4128$var$Duplex;

var $sAhw0 = parcelRequire("sAhw0");

var $2jNx5 = parcelRequire("2jNx5");
$6610fafc440d4128$var$ObjectSetPrototypeOf($6610fafc440d4128$var$Duplex.prototype, $sAhw0.prototype);
$6610fafc440d4128$var$ObjectSetPrototypeOf($6610fafc440d4128$var$Duplex, $sAhw0);
{
    var $6610fafc440d4128$var$keys = $6610fafc440d4128$var$ObjectKeys($2jNx5.prototype);
    // Allow the keys array to be GC'ed.
    for(var $6610fafc440d4128$var$i = 0; $6610fafc440d4128$var$i < $6610fafc440d4128$var$keys.length; $6610fafc440d4128$var$i++){
        var $6610fafc440d4128$var$method = $6610fafc440d4128$var$keys[$6610fafc440d4128$var$i];
        if (!$6610fafc440d4128$var$Duplex.prototype[$6610fafc440d4128$var$method]) $6610fafc440d4128$var$Duplex.prototype[$6610fafc440d4128$var$method] = $2jNx5.prototype[$6610fafc440d4128$var$method];
    }
}function $6610fafc440d4128$var$Duplex(options) {
    if (!(this instanceof $6610fafc440d4128$var$Duplex)) return new $6610fafc440d4128$var$Duplex(options);
    $sAhw0.call(this, options);
    $2jNx5.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$6610fafc440d4128$var$ObjectDefineProperties($6610fafc440d4128$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $6610fafc440d4128$var$ObjectGetOwnPropertyDescriptor($2jNx5.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $6610fafc440d4128$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6610fafc440d4128$var$lazyWebStreams() {
    if ($6610fafc440d4128$var$webStreamsAdapters === undefined) $6610fafc440d4128$var$webStreamsAdapters = {};
    return $6610fafc440d4128$var$webStreamsAdapters;
}
$6610fafc440d4128$var$Duplex.fromWeb = function(pair, options) {
    return $6610fafc440d4128$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$6610fafc440d4128$var$Duplex.toWeb = function(duplex) {
    return $6610fafc440d4128$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $6610fafc440d4128$var$duplexify;

$6610fafc440d4128$var$Duplex.from = function(body) {
    if (!$6610fafc440d4128$var$duplexify) $6610fafc440d4128$var$duplexify = (parcelRequire("bJFLi"));
    return $6610fafc440d4128$var$duplexify(body, 'body');
};

});
parcelRegister("sAhw0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6EUyW = parcelRequire("6EUyW");
/* replacement end */ var $055ec263ff6a96ed$var$ArrayPrototypeIndexOf = $6EUyW.ArrayPrototypeIndexOf, $055ec263ff6a96ed$var$NumberIsInteger = $6EUyW.NumberIsInteger, $055ec263ff6a96ed$var$NumberIsNaN = $6EUyW.NumberIsNaN, $055ec263ff6a96ed$var$NumberParseInt = $6EUyW.NumberParseInt, $055ec263ff6a96ed$var$ObjectDefineProperties = $6EUyW.ObjectDefineProperties, $055ec263ff6a96ed$var$ObjectKeys = $6EUyW.ObjectKeys, $055ec263ff6a96ed$var$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf, $055ec263ff6a96ed$var$Promise = $6EUyW.Promise, $055ec263ff6a96ed$var$SafeSet = $6EUyW.SafeSet, $055ec263ff6a96ed$var$SymbolAsyncDispose = $6EUyW.SymbolAsyncDispose, $055ec263ff6a96ed$var$SymbolAsyncIterator = $6EUyW.SymbolAsyncIterator, $055ec263ff6a96ed$var$Symbol = $6EUyW.Symbol;
module.exports = $055ec263ff6a96ed$var$Readable;
$055ec263ff6a96ed$var$Readable.ReadableState = $055ec263ff6a96ed$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $055ec263ff6a96ed$var$EE = $bBoAO.EventEmitter;

var $exnkP = parcelRequire("exnkP");
var $055ec263ff6a96ed$var$Stream = $exnkP.Stream, $055ec263ff6a96ed$var$prependListener = $exnkP.prependListener;

var $iaL1d = parcelRequire("iaL1d");
var $055ec263ff6a96ed$require$Buffer = $iaL1d.Buffer;

var $coaKh = parcelRequire("coaKh");
var $055ec263ff6a96ed$require$addAbortSignal = $coaKh.addAbortSignal;

var $gvFwV = parcelRequire("gvFwV");

var $055ec263ff6a96ed$var$debug = (parcelRequire("dNICR")).debuglog('stream', function(fn) {
    $055ec263ff6a96ed$var$debug = fn;
});

var $e802U = parcelRequire("e802U");

var $5lyk7 = parcelRequire("5lyk7");

var $5R1Lu = parcelRequire("5R1Lu");
var $055ec263ff6a96ed$var$getHighWaterMark = $5R1Lu.getHighWaterMark, $055ec263ff6a96ed$var$getDefaultHighWaterMark = $5R1Lu.getDefaultHighWaterMark;

var $3Yp2a = parcelRequire("3Yp2a");
var $055ec263ff6a96ed$var$aggregateTwoErrors = $3Yp2a.aggregateTwoErrors, $055ec263ff6a96ed$var$_require_codes = $3Yp2a.codes, $055ec263ff6a96ed$var$ERR_INVALID_ARG_TYPE = $055ec263ff6a96ed$var$_require_codes.ERR_INVALID_ARG_TYPE, $055ec263ff6a96ed$var$ERR_METHOD_NOT_IMPLEMENTED = $055ec263ff6a96ed$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $055ec263ff6a96ed$var$ERR_OUT_OF_RANGE = $055ec263ff6a96ed$var$_require_codes.ERR_OUT_OF_RANGE, $055ec263ff6a96ed$var$ERR_STREAM_PUSH_AFTER_EOF = $055ec263ff6a96ed$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $055ec263ff6a96ed$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $055ec263ff6a96ed$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $055ec263ff6a96ed$var$AbortError = $3Yp2a.AbortError;

var $d6Z3R = parcelRequire("d6Z3R");
var $055ec263ff6a96ed$require$validateObject = $d6Z3R.validateObject;
var $055ec263ff6a96ed$var$kPaused = $055ec263ff6a96ed$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $055ec263ff6a96ed$require$StringDecoder = $3Jf7C.StringDecoder;

var $bPJJ6 = parcelRequire("bPJJ6");
$055ec263ff6a96ed$var$ObjectSetPrototypeOf($055ec263ff6a96ed$var$Readable.prototype, $055ec263ff6a96ed$var$Stream.prototype);
$055ec263ff6a96ed$var$ObjectSetPrototypeOf($055ec263ff6a96ed$var$Readable, $055ec263ff6a96ed$var$Stream);
var $055ec263ff6a96ed$var$nop = function() {};
var $055ec263ff6a96ed$var$errorOrDestroy = $5lyk7.errorOrDestroy;
var $055ec263ff6a96ed$var$kObjectMode = 1;
var $055ec263ff6a96ed$var$kEnded = 2;
var $055ec263ff6a96ed$var$kEndEmitted = 4;
var $055ec263ff6a96ed$var$kReading = 8;
var $055ec263ff6a96ed$var$kConstructed = 16;
var $055ec263ff6a96ed$var$kSync = 32;
var $055ec263ff6a96ed$var$kNeedReadable = 64;
var $055ec263ff6a96ed$var$kEmittedReadable = 128;
var $055ec263ff6a96ed$var$kReadableListening = 256;
var $055ec263ff6a96ed$var$kResumeScheduled = 512;
var $055ec263ff6a96ed$var$kErrorEmitted = 1024;
var $055ec263ff6a96ed$var$kEmitClose = 2048;
var $055ec263ff6a96ed$var$kAutoDestroy = 4096;
var $055ec263ff6a96ed$var$kDestroyed = 8192;
var $055ec263ff6a96ed$var$kClosed = 16384;
var $055ec263ff6a96ed$var$kCloseEmitted = 32768;
var $055ec263ff6a96ed$var$kMultiAwaitDrain = 65536;
var $055ec263ff6a96ed$var$kReadingMore = 131072;
var $055ec263ff6a96ed$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $055ec263ff6a96ed$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$055ec263ff6a96ed$var$ObjectDefineProperties($055ec263ff6a96ed$var$ReadableState.prototype, {
    objectMode: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kObjectMode),
    ended: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kEnded),
    endEmitted: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kEndEmitted),
    reading: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kNeedReadable),
    emittedReadable: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kEmittedReadable),
    readableListening: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kReadableListening),
    resumeScheduled: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kErrorEmitted),
    emitClose: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kEmitClose),
    autoDestroy: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kCloseEmitted),
    multiAwaitDrain: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kReadingMore),
    dataEmitted: $055ec263ff6a96ed$var$makeBitMapDescriptor($055ec263ff6a96ed$var$kDataEmitted)
});

function $055ec263ff6a96ed$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("8Lioq"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $055ec263ff6a96ed$var$kEmitClose | $055ec263ff6a96ed$var$kAutoDestroy | $055ec263ff6a96ed$var$kConstructed | $055ec263ff6a96ed$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $055ec263ff6a96ed$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $055ec263ff6a96ed$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $055ec263ff6a96ed$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $055ec263ff6a96ed$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $e802U();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$055ec263ff6a96ed$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$055ec263ff6a96ed$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$055ec263ff6a96ed$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $055ec263ff6a96ed$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $055ec263ff6a96ed$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $055ec263ff6a96ed$var$Readable)) return new $055ec263ff6a96ed$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("8Lioq"));
    this._readableState = new $055ec263ff6a96ed$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $055ec263ff6a96ed$require$addAbortSignal(options.signal, this);
    }
    $055ec263ff6a96ed$var$Stream.call(this, options);
    $5lyk7.construct(this, function() {
        if (_this._readableState.needReadable) $055ec263ff6a96ed$var$maybeReadMore(_this, _this._readableState);
    });
}
$055ec263ff6a96ed$var$Readable.prototype.destroy = $5lyk7.destroy;
$055ec263ff6a96ed$var$Readable.prototype._undestroy = $5lyk7.undestroy;
$055ec263ff6a96ed$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$055ec263ff6a96ed$var$Readable.prototype[$055ec263ff6a96ed$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$055ec263ff6a96ed$var$Readable.prototype[$055ec263ff6a96ed$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $055ec263ff6a96ed$var$AbortError();
        this.destroy(error);
    }
    return new $055ec263ff6a96ed$var$Promise(function(resolve, reject) {
        return $gvFwV(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$055ec263ff6a96ed$var$Readable.prototype.push = function(chunk, encoding) {
    return $055ec263ff6a96ed$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$055ec263ff6a96ed$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $055ec263ff6a96ed$var$readableAddChunk(this, chunk, encoding, true);
};
function $055ec263ff6a96ed$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $055ec263ff6a96ed$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $055ec263ff6a96ed$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $055ec263ff6a96ed$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $055ec263ff6a96ed$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $055ec263ff6a96ed$require$Buffer) encoding = '';
        else if ($055ec263ff6a96ed$var$Stream._isUint8Array(chunk)) {
            chunk = $055ec263ff6a96ed$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $055ec263ff6a96ed$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $055ec263ff6a96ed$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$055ec263ff6a96ed$var$kReading;
        $055ec263ff6a96ed$var$onEofChunk(stream, state);
    } else if ((state.state & $055ec263ff6a96ed$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $055ec263ff6a96ed$var$kEndEmitted) !== 0) $055ec263ff6a96ed$var$errorOrDestroy(stream, new $055ec263ff6a96ed$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $055ec263ff6a96ed$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $055ec263ff6a96ed$var$errorOrDestroy(stream, new $055ec263ff6a96ed$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$055ec263ff6a96ed$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $055ec263ff6a96ed$var$addChunk(stream, state, chunk, false);
                else $055ec263ff6a96ed$var$maybeReadMore(stream, state);
            } else $055ec263ff6a96ed$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$055ec263ff6a96ed$var$kReading;
        $055ec263ff6a96ed$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $055ec263ff6a96ed$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $055ec263ff6a96ed$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $055ec263ff6a96ed$var$kNeedReadable) !== 0) $055ec263ff6a96ed$var$emitReadable(stream);
    }
    $055ec263ff6a96ed$var$maybeReadMore(stream, state);
}
$055ec263ff6a96ed$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$055ec263ff6a96ed$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$055ec263ff6a96ed$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $055ec263ff6a96ed$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$055ec263ff6a96ed$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $055ec263ff6a96ed$var$MAX_HWM = 0x40000000;
function $055ec263ff6a96ed$var$computeNewHighWaterMark(n) {
    if (n > $055ec263ff6a96ed$var$MAX_HWM) throw new $055ec263ff6a96ed$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $055ec263ff6a96ed$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $055ec263ff6a96ed$var$kObjectMode) !== 0) return 1;
    if ($055ec263ff6a96ed$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$055ec263ff6a96ed$var$Readable.prototype.read = function(n) {
    $055ec263ff6a96ed$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$055ec263ff6a96ed$var$NumberIsInteger(n)) n = $055ec263ff6a96ed$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $055ec263ff6a96ed$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$055ec263ff6a96ed$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $055ec263ff6a96ed$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $055ec263ff6a96ed$var$endReadable(this);
        else $055ec263ff6a96ed$var$emitReadable(this);
        return null;
    }
    n = $055ec263ff6a96ed$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $055ec263ff6a96ed$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $055ec263ff6a96ed$var$kNeedReadable) !== 0;
    $055ec263ff6a96ed$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $055ec263ff6a96ed$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $055ec263ff6a96ed$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $055ec263ff6a96ed$var$debug('do read');
        state.state |= $055ec263ff6a96ed$var$kReading | $055ec263ff6a96ed$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $055ec263ff6a96ed$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $055ec263ff6a96ed$var$errorOrDestroy(this, err);
        }
        state.state &= ~$055ec263ff6a96ed$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $055ec263ff6a96ed$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $055ec263ff6a96ed$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $055ec263ff6a96ed$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $055ec263ff6a96ed$var$onEofChunk(stream, state) {
    $055ec263ff6a96ed$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $055ec263ff6a96ed$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $055ec263ff6a96ed$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $055ec263ff6a96ed$var$emitReadable(stream) {
    var state = stream._readableState;
    $055ec263ff6a96ed$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $055ec263ff6a96ed$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($055ec263ff6a96ed$var$emitReadable_, stream);
    }
}
function $055ec263ff6a96ed$var$emitReadable_(stream) {
    var state = stream._readableState;
    $055ec263ff6a96ed$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $055ec263ff6a96ed$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $055ec263ff6a96ed$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($055ec263ff6a96ed$var$maybeReadMore_, stream, state);
    }
}
function $055ec263ff6a96ed$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $055ec263ff6a96ed$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$055ec263ff6a96ed$var$Readable.prototype._read = function(n) {
    throw new $055ec263ff6a96ed$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$055ec263ff6a96ed$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $055ec263ff6a96ed$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $055ec263ff6a96ed$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $055ec263ff6a96ed$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $055ec263ff6a96ed$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $055ec263ff6a96ed$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $055ec263ff6a96ed$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $055ec263ff6a96ed$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $055ec263ff6a96ed$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $055ec263ff6a96ed$var$debug('ondata');
        var ret = dest.write(chunk);
        $055ec263ff6a96ed$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $055ec263ff6a96ed$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $055ec263ff6a96ed$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $055ec263ff6a96ed$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $055ec263ff6a96ed$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $055ec263ff6a96ed$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $055ec263ff6a96ed$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $055ec263ff6a96ed$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $055ec263ff6a96ed$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $055ec263ff6a96ed$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$055ec263ff6a96ed$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $055ec263ff6a96ed$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$055ec263ff6a96ed$var$Readable.prototype.on = function(ev, fn) {
    var res = $055ec263ff6a96ed$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $055ec263ff6a96ed$var$debug('on readable', state.length, state.reading);
            if (state.length) $055ec263ff6a96ed$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($055ec263ff6a96ed$var$nReadingNextTick, this);
        }
    }
    return res;
};
$055ec263ff6a96ed$var$Readable.prototype.addListener = $055ec263ff6a96ed$var$Readable.prototype.on;
$055ec263ff6a96ed$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $055ec263ff6a96ed$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($055ec263ff6a96ed$var$updateReadableListening, this);
    return res;
};
$055ec263ff6a96ed$var$Readable.prototype.off = $055ec263ff6a96ed$var$Readable.prototype.removeListener;
$055ec263ff6a96ed$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $055ec263ff6a96ed$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($055ec263ff6a96ed$var$updateReadableListening, this);
    return res;
};
function $055ec263ff6a96ed$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$055ec263ff6a96ed$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $055ec263ff6a96ed$var$nReadingNextTick(self) {
    $055ec263ff6a96ed$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$055ec263ff6a96ed$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $055ec263ff6a96ed$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $055ec263ff6a96ed$var$resume(this, state);
    }
    state[$055ec263ff6a96ed$var$kPaused] = false;
    return this;
};
function $055ec263ff6a96ed$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($055ec263ff6a96ed$var$resume_, stream, state);
    }
}
function $055ec263ff6a96ed$var$resume_(stream, state) {
    $055ec263ff6a96ed$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $055ec263ff6a96ed$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$055ec263ff6a96ed$var$Readable.prototype.pause = function() {
    $055ec263ff6a96ed$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $055ec263ff6a96ed$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$055ec263ff6a96ed$var$kPaused] = true;
    return this;
};
function $055ec263ff6a96ed$var$flow(stream) {
    var state = stream._readableState;
    $055ec263ff6a96ed$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$055ec263ff6a96ed$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $055ec263ff6a96ed$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $055ec263ff6a96ed$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$055ec263ff6a96ed$var$Readable.prototype[$055ec263ff6a96ed$var$SymbolAsyncIterator] = function() {
    return $055ec263ff6a96ed$var$streamToAsyncIterator(this);
};
$055ec263ff6a96ed$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $055ec263ff6a96ed$require$validateObject(options, 'options');
    return $055ec263ff6a96ed$var$streamToAsyncIterator(this, options);
};
function $055ec263ff6a96ed$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $055ec263ff6a96ed$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $055ec263ff6a96ed$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $055ec263ff6a96ed$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $055ec263ff6a96ed$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $055ec263ff6a96ed$var$nop;
                    stream.on('readable', next);
                    cleanup = $gvFwV(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $055ec263ff6a96ed$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $055ec263ff6a96ed$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $055ec263ff6a96ed$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $055ec263ff6a96ed$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $5lyk7.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$055ec263ff6a96ed$var$ObjectDefineProperties($055ec263ff6a96ed$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$055ec263ff6a96ed$var$ObjectDefineProperties($055ec263ff6a96ed$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$055ec263ff6a96ed$var$kPaused] !== false;
        },
        set: function(value) {
            this[$055ec263ff6a96ed$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$055ec263ff6a96ed$var$Readable._fromList = $055ec263ff6a96ed$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $055ec263ff6a96ed$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $055ec263ff6a96ed$var$endReadable(stream) {
    var state = stream._readableState;
    $055ec263ff6a96ed$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($055ec263ff6a96ed$var$endReadableNT, state, stream);
    }
}
function $055ec263ff6a96ed$var$endReadableNT(state, stream) {
    $055ec263ff6a96ed$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($055ec263ff6a96ed$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $055ec263ff6a96ed$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$055ec263ff6a96ed$var$Readable.from = function(iterable, opts) {
    return $bPJJ6($055ec263ff6a96ed$var$Readable, iterable, opts);
};
var $055ec263ff6a96ed$var$webStreamsAdapters;
// Lazy to avoid circular references
function $055ec263ff6a96ed$var$lazyWebStreams() {
    if ($055ec263ff6a96ed$var$webStreamsAdapters === undefined) $055ec263ff6a96ed$var$webStreamsAdapters = {};
    return $055ec263ff6a96ed$var$webStreamsAdapters;
}
$055ec263ff6a96ed$var$Readable.fromWeb = function(readableStream, options) {
    return $055ec263ff6a96ed$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$055ec263ff6a96ed$var$Readable.toWeb = function(streamReadable, options) {
    return $055ec263ff6a96ed$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$055ec263ff6a96ed$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $055ec263ff6a96ed$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $5lyk7.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("exnkP", function(module, exports) {
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $a9563f9c6127e74e$var$ArrayIsArray = $6EUyW.ArrayIsArray, $a9563f9c6127e74e$var$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $a9563f9c6127e74e$var$EE = $bBoAO.EventEmitter;
function $a9563f9c6127e74e$var$Stream(opts) {
    $a9563f9c6127e74e$var$EE.call(this, opts);
}
$a9563f9c6127e74e$var$ObjectSetPrototypeOf($a9563f9c6127e74e$var$Stream.prototype, $a9563f9c6127e74e$var$EE.prototype);
$a9563f9c6127e74e$var$ObjectSetPrototypeOf($a9563f9c6127e74e$var$Stream, $a9563f9c6127e74e$var$EE);
$a9563f9c6127e74e$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a9563f9c6127e74e$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $a9563f9c6127e74e$var$prependListener(source, 'error', onerror);
    $a9563f9c6127e74e$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $a9563f9c6127e74e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($a9563f9c6127e74e$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $a9563f9c6127e74e$var$Stream,
    prependListener: $a9563f9c6127e74e$var$prependListener
};

});

parcelRegister("coaKh", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $90500fc06ad43fa9$export$e2db56ee53255a0; }, function (v) { return $90500fc06ad43fa9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $90500fc06ad43fa9$export$11956e9313f43de0; }, function (v) { return $90500fc06ad43fa9$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $90500fc06ad43fa9$export$e2db56ee53255a0;
var $90500fc06ad43fa9$export$11956e9313f43de0;
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $90500fc06ad43fa9$require$SymbolDispose = $6EUyW.SymbolDispose;

var $3Yp2a = parcelRequire("3Yp2a");
var $90500fc06ad43fa9$var$AbortError = $3Yp2a.AbortError, $90500fc06ad43fa9$var$codes = $3Yp2a.codes;

var $h5dib = parcelRequire("h5dib");
var $90500fc06ad43fa9$var$isNodeStream = $h5dib.isNodeStream, $90500fc06ad43fa9$var$isWebStream = $h5dib.isWebStream, $90500fc06ad43fa9$var$kControllerErrorFunction = $h5dib.kControllerErrorFunction;

var $gvFwV = parcelRequire("gvFwV");
var $90500fc06ad43fa9$var$ERR_INVALID_ARG_TYPE = $90500fc06ad43fa9$var$codes.ERR_INVALID_ARG_TYPE;
var $90500fc06ad43fa9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $90500fc06ad43fa9$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $90500fc06ad43fa9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$90500fc06ad43fa9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $90500fc06ad43fa9$var$validateAbortSignal(signal, 'signal');
    if (!$90500fc06ad43fa9$var$isNodeStream(stream) && !$90500fc06ad43fa9$var$isWebStream(stream)) throw new $90500fc06ad43fa9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $90500fc06ad43fa9$export$11956e9313f43de0(signal, stream);
};

$90500fc06ad43fa9$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $90500fc06ad43fa9$var$isNodeStream(stream) ? function() {
        stream.destroy(new $90500fc06ad43fa9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$90500fc06ad43fa9$var$kControllerErrorFunction](new $90500fc06ad43fa9$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $90500fc06ad43fa9$var$addAbortListener = $90500fc06ad43fa9$var$addAbortListener || (parcelRequire("dNICR")).addAbortListener;
        var disposable = $90500fc06ad43fa9$var$addAbortListener(signal, onAbort);
        $gvFwV(stream, disposable[$90500fc06ad43fa9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("e802U", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $a491d924474e184f$var$StringPrototypeSlice = $6EUyW.StringPrototypeSlice, $a491d924474e184f$var$SymbolIterator = $6EUyW.SymbolIterator, $a491d924474e184f$var$TypedArrayPrototypeSet = $6EUyW.TypedArrayPrototypeSet, $a491d924474e184f$var$Uint8Array = $6EUyW.Uint8Array;

var $iaL1d = parcelRequire("iaL1d");
var $a491d924474e184f$require$Buffer = $iaL1d.Buffer;

var $dNICR = parcelRequire("dNICR");
var $a491d924474e184f$require$inspect = $dNICR.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $a491d924474e184f$require$Buffer.alloc(0);
                var ret = $a491d924474e184f$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $a491d924474e184f$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $a491d924474e184f$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $a491d924474e184f$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $a491d924474e184f$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $a491d924474e184f$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $a491d924474e184f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $a491d924474e184f$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $a491d924474e184f$var$TypedArrayPrototypeSet(ret, new $a491d924474e184f$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $a491d924474e184f$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("5R1Lu", function(module, exports) {
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $4433457aebcb1139$var$MathFloor = $6EUyW.MathFloor, $4433457aebcb1139$var$NumberIsInteger = $6EUyW.NumberIsInteger;

var $d6Z3R = parcelRequire("d6Z3R");
var $4433457aebcb1139$require$validateInteger = $d6Z3R.validateInteger;

var $4433457aebcb1139$var$ERR_INVALID_ARG_VALUE = (parcelRequire("3Yp2a")).codes.ERR_INVALID_ARG_VALUE;
var $4433457aebcb1139$var$defaultHighWaterMarkBytes = 16384;
var $4433457aebcb1139$var$defaultHighWaterMarkObjectMode = 16;
function $4433457aebcb1139$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $4433457aebcb1139$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $4433457aebcb1139$var$defaultHighWaterMarkObjectMode : $4433457aebcb1139$var$defaultHighWaterMarkBytes;
}
function $4433457aebcb1139$var$setDefaultHighWaterMark(objectMode, value) {
    $4433457aebcb1139$require$validateInteger(value, 'value', 0);
    if (objectMode) $4433457aebcb1139$var$defaultHighWaterMarkObjectMode = value;
    else $4433457aebcb1139$var$defaultHighWaterMarkBytes = value;
}
function $4433457aebcb1139$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $4433457aebcb1139$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$4433457aebcb1139$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $4433457aebcb1139$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $4433457aebcb1139$var$MathFloor(hwm);
    }
    // Default value
    return $4433457aebcb1139$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $4433457aebcb1139$var$getHighWaterMark,
    getDefaultHighWaterMark: $4433457aebcb1139$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $4433457aebcb1139$var$setDefaultHighWaterMark
};

});

parcelRegister("bPJJ6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6EUyW = parcelRequire("6EUyW");
/* replacement end */ var $89d7ed787c1b59c7$var$PromisePrototypeThen = $6EUyW.PromisePrototypeThen, $89d7ed787c1b59c7$var$SymbolAsyncIterator = $6EUyW.SymbolAsyncIterator, $89d7ed787c1b59c7$var$SymbolIterator = $6EUyW.SymbolIterator;

var $iaL1d = parcelRequire("iaL1d");
var $89d7ed787c1b59c7$require$Buffer = $iaL1d.Buffer;

var $3Yp2a = parcelRequire("3Yp2a");
var $89d7ed787c1b59c7$require$_require_codes = $3Yp2a.codes;
var $89d7ed787c1b59c7$var$ERR_INVALID_ARG_TYPE = $89d7ed787c1b59c7$require$_require_codes.ERR_INVALID_ARG_TYPE, $89d7ed787c1b59c7$var$ERR_STREAM_NULL_VALUES = $89d7ed787c1b59c7$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $89d7ed787c1b59c7$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $89d7ed787c1b59c7$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$89d7ed787c1b59c7$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$89d7ed787c1b59c7$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$89d7ed787c1b59c7$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$89d7ed787c1b59c7$var$SymbolIterator]();
    } else throw new $89d7ed787c1b59c7$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $89d7ed787c1b59c7$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $89d7ed787c1b59c7$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $89d7ed787c1b59c7$var$from;

});


parcelRegister("2jNx5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $6EUyW = parcelRequire("6EUyW");
/* replacement end */ var $1b03c747021d1f15$var$ArrayPrototypeSlice = $6EUyW.ArrayPrototypeSlice, $1b03c747021d1f15$var$Error = $6EUyW.Error, $1b03c747021d1f15$var$FunctionPrototypeSymbolHasInstance = $6EUyW.FunctionPrototypeSymbolHasInstance, $1b03c747021d1f15$var$ObjectDefineProperty = $6EUyW.ObjectDefineProperty, $1b03c747021d1f15$var$ObjectDefineProperties = $6EUyW.ObjectDefineProperties, $1b03c747021d1f15$var$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf, $1b03c747021d1f15$var$StringPrototypeToLowerCase = $6EUyW.StringPrototypeToLowerCase, $1b03c747021d1f15$var$Symbol = $6EUyW.Symbol, $1b03c747021d1f15$var$SymbolHasInstance = $6EUyW.SymbolHasInstance;
module.exports = $1b03c747021d1f15$var$Writable;
$1b03c747021d1f15$var$Writable.WritableState = $1b03c747021d1f15$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $1b03c747021d1f15$var$EE = $bBoAO.EventEmitter;

var $exnkP = parcelRequire("exnkP");
var $1b03c747021d1f15$require$Stream = $exnkP.Stream;

var $iaL1d = parcelRequire("iaL1d");
var $1b03c747021d1f15$require$Buffer = $iaL1d.Buffer;

var $5lyk7 = parcelRequire("5lyk7");

var $coaKh = parcelRequire("coaKh");
var $1b03c747021d1f15$require$addAbortSignal = $coaKh.addAbortSignal;

var $5R1Lu = parcelRequire("5R1Lu");
var $1b03c747021d1f15$var$getHighWaterMark = $5R1Lu.getHighWaterMark, $1b03c747021d1f15$var$getDefaultHighWaterMark = $5R1Lu.getDefaultHighWaterMark;

var $3Yp2a = parcelRequire("3Yp2a");
var $1b03c747021d1f15$require$_require_codes = $3Yp2a.codes;
var $1b03c747021d1f15$var$ERR_INVALID_ARG_TYPE = $1b03c747021d1f15$require$_require_codes.ERR_INVALID_ARG_TYPE, $1b03c747021d1f15$var$ERR_METHOD_NOT_IMPLEMENTED = $1b03c747021d1f15$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $1b03c747021d1f15$var$ERR_MULTIPLE_CALLBACK = $1b03c747021d1f15$require$_require_codes.ERR_MULTIPLE_CALLBACK, $1b03c747021d1f15$var$ERR_STREAM_CANNOT_PIPE = $1b03c747021d1f15$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $1b03c747021d1f15$var$ERR_STREAM_DESTROYED = $1b03c747021d1f15$require$_require_codes.ERR_STREAM_DESTROYED, $1b03c747021d1f15$var$ERR_STREAM_ALREADY_FINISHED = $1b03c747021d1f15$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $1b03c747021d1f15$var$ERR_STREAM_NULL_VALUES = $1b03c747021d1f15$require$_require_codes.ERR_STREAM_NULL_VALUES, $1b03c747021d1f15$var$ERR_STREAM_WRITE_AFTER_END = $1b03c747021d1f15$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $1b03c747021d1f15$var$ERR_UNKNOWN_ENCODING = $1b03c747021d1f15$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $1b03c747021d1f15$var$errorOrDestroy = $5lyk7.errorOrDestroy;
$1b03c747021d1f15$var$ObjectSetPrototypeOf($1b03c747021d1f15$var$Writable.prototype, $1b03c747021d1f15$require$Stream.prototype);
$1b03c747021d1f15$var$ObjectSetPrototypeOf($1b03c747021d1f15$var$Writable, $1b03c747021d1f15$require$Stream);
function $1b03c747021d1f15$var$nop() {}
var $1b03c747021d1f15$var$kOnFinished = $1b03c747021d1f15$var$Symbol('kOnFinished');

function $1b03c747021d1f15$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("8Lioq"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $1b03c747021d1f15$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $1b03c747021d1f15$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $1b03c747021d1f15$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $1b03c747021d1f15$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$1b03c747021d1f15$var$kOnFinished] = [];
}
function $1b03c747021d1f15$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$1b03c747021d1f15$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $1b03c747021d1f15$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$1b03c747021d1f15$var$ObjectDefineProperty($1b03c747021d1f15$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $1b03c747021d1f15$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("8Lioq"));
    if (!isDuplex && !$1b03c747021d1f15$var$FunctionPrototypeSymbolHasInstance($1b03c747021d1f15$var$Writable, this)) return new $1b03c747021d1f15$var$Writable(options);
    this._writableState = new $1b03c747021d1f15$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $1b03c747021d1f15$require$addAbortSignal(options.signal, this);
    }
    $1b03c747021d1f15$require$Stream.call(this, options);
    $5lyk7.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $1b03c747021d1f15$var$clearBuffer(_this, state);
        $1b03c747021d1f15$var$finishMaybe(_this, state);
    });
}
$1b03c747021d1f15$var$ObjectDefineProperty($1b03c747021d1f15$var$Writable, $1b03c747021d1f15$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($1b03c747021d1f15$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $1b03c747021d1f15$var$Writable) return false;
        return object && object._writableState instanceof $1b03c747021d1f15$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$1b03c747021d1f15$var$Writable.prototype.pipe = function() {
    $1b03c747021d1f15$var$errorOrDestroy(this, new $1b03c747021d1f15$var$ERR_STREAM_CANNOT_PIPE());
};
function $1b03c747021d1f15$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$1b03c747021d1f15$require$Buffer.isEncoding(encoding)) throw new $1b03c747021d1f15$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $1b03c747021d1f15$var$nop;
    }
    if (chunk === null) throw new $1b03c747021d1f15$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $1b03c747021d1f15$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $1b03c747021d1f15$require$Buffer) encoding = 'buffer';
        else if ($1b03c747021d1f15$require$Stream._isUint8Array(chunk)) {
            chunk = $1b03c747021d1f15$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $1b03c747021d1f15$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $1b03c747021d1f15$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $1b03c747021d1f15$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $1b03c747021d1f15$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $1b03c747021d1f15$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$1b03c747021d1f15$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $1b03c747021d1f15$var$_write(this, chunk, encoding, cb) === true;
};
$1b03c747021d1f15$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1b03c747021d1f15$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $1b03c747021d1f15$var$clearBuffer(this, state);
    }
};
$1b03c747021d1f15$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $1b03c747021d1f15$var$StringPrototypeToLowerCase(encoding);
    if (!$1b03c747021d1f15$require$Buffer.isEncoding(encoding)) throw new $1b03c747021d1f15$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1b03c747021d1f15$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $1b03c747021d1f15$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $1b03c747021d1f15$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1b03c747021d1f15$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1b03c747021d1f15$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $1b03c747021d1f15$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $1b03c747021d1f15$var$errorOrDestroy(stream, er);
}
function $1b03c747021d1f15$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $1b03c747021d1f15$var$errorOrDestroy(stream, new $1b03c747021d1f15$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($1b03c747021d1f15$var$onwriteError, stream, state, er, cb);
        else $1b03c747021d1f15$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $1b03c747021d1f15$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($1b03c747021d1f15$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $1b03c747021d1f15$var$afterWrite(stream, state, 1, cb);
    }
}
function $1b03c747021d1f15$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $1b03c747021d1f15$var$afterWrite(stream, state, count, cb);
}
function $1b03c747021d1f15$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $1b03c747021d1f15$var$errorBuffer(state);
    $1b03c747021d1f15$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $1b03c747021d1f15$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $1b03c747021d1f15$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$1b03c747021d1f15$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $1b03c747021d1f15$var$ERR_STREAM_DESTROYED('end'));
    }
    $1b03c747021d1f15$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $1b03c747021d1f15$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $1b03c747021d1f15$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $1b03c747021d1f15$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $1b03c747021d1f15$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $1b03c747021d1f15$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $1b03c747021d1f15$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $1b03c747021d1f15$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$1b03c747021d1f15$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $1b03c747021d1f15$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$1b03c747021d1f15$var$Writable.prototype._writev = null;
$1b03c747021d1f15$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $1b03c747021d1f15$var$_write(this, chunk, encoding);
        if (ret instanceof $1b03c747021d1f15$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $1b03c747021d1f15$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $1b03c747021d1f15$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $1b03c747021d1f15$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$1b03c747021d1f15$var$kOnFinished].push(cb);
    }
    return this;
};
function $1b03c747021d1f15$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $1b03c747021d1f15$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $1b03c747021d1f15$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $1b03c747021d1f15$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$1b03c747021d1f15$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $1b03c747021d1f15$var$errorOrDestroy(stream, err, state.sync);
        } else if ($1b03c747021d1f15$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($1b03c747021d1f15$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $1b03c747021d1f15$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $1b03c747021d1f15$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1b03c747021d1f15$var$finishMaybe(stream, state, sync) {
    if ($1b03c747021d1f15$var$needFinish(state)) {
        $1b03c747021d1f15$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($1b03c747021d1f15$var$needFinish(state)) $1b03c747021d1f15$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($1b03c747021d1f15$var$needFinish(state)) {
                state.pendingcb++;
                $1b03c747021d1f15$var$finish(stream, state);
            }
        }
    }
}
function $1b03c747021d1f15$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$1b03c747021d1f15$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$1b03c747021d1f15$var$ObjectDefineProperties($1b03c747021d1f15$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $1b03c747021d1f15$var$destroy = $5lyk7.destroy;
$1b03c747021d1f15$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$1b03c747021d1f15$var$kOnFinished].length)) $2Qkr5.nextTick($1b03c747021d1f15$var$errorBuffer, state);
    $1b03c747021d1f15$var$destroy.call(this, err, cb);
    return this;
};
$1b03c747021d1f15$var$Writable.prototype._undestroy = $5lyk7.undestroy;
$1b03c747021d1f15$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1b03c747021d1f15$var$Writable.prototype[$1b03c747021d1f15$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $1b03c747021d1f15$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1b03c747021d1f15$var$lazyWebStreams() {
    if ($1b03c747021d1f15$var$webStreamsAdapters === undefined) $1b03c747021d1f15$var$webStreamsAdapters = {};
    return $1b03c747021d1f15$var$webStreamsAdapters;
}
$1b03c747021d1f15$var$Writable.fromWeb = function(writableStream, options) {
    return $1b03c747021d1f15$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$1b03c747021d1f15$var$Writable.toWeb = function(streamWritable) {
    return $1b03c747021d1f15$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("bJFLi", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $iaL1d = parcelRequire("iaL1d");

var $h5dib = parcelRequire("h5dib");
var $88b44abb4db48704$var$isReadable = $h5dib.isReadable, $88b44abb4db48704$var$isWritable = $h5dib.isWritable, $88b44abb4db48704$var$isIterable = $h5dib.isIterable, $88b44abb4db48704$var$isNodeStream = $h5dib.isNodeStream, $88b44abb4db48704$var$isReadableNodeStream = $h5dib.isReadableNodeStream, $88b44abb4db48704$var$isWritableNodeStream = $h5dib.isWritableNodeStream, $88b44abb4db48704$var$isDuplexNodeStream = $h5dib.isDuplexNodeStream, $88b44abb4db48704$var$isReadableStream = $h5dib.isReadableStream, $88b44abb4db48704$var$isWritableStream = $h5dib.isWritableStream;

var $gvFwV = parcelRequire("gvFwV");

var $3Yp2a = parcelRequire("3Yp2a");
var $88b44abb4db48704$var$AbortError = $3Yp2a.AbortError, $88b44abb4db48704$var$_require_codes = $3Yp2a.codes, $88b44abb4db48704$var$ERR_INVALID_ARG_TYPE = $88b44abb4db48704$var$_require_codes.ERR_INVALID_ARG_TYPE, $88b44abb4db48704$var$ERR_INVALID_RETURN_VALUE = $88b44abb4db48704$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $5lyk7 = parcelRequire("5lyk7");
var $88b44abb4db48704$require$destroyer = $5lyk7.destroyer;

var $8Lioq = parcelRequire("8Lioq");

var $sAhw0 = parcelRequire("sAhw0");

var $2jNx5 = parcelRequire("2jNx5");

var $dNICR = parcelRequire("dNICR");
var $88b44abb4db48704$require$createDeferredPromise = $dNICR.createDeferredPromise;

var $bPJJ6 = parcelRequire("bPJJ6");
var $88b44abb4db48704$var$Blob = globalThis.Blob || $iaL1d.Blob;
var $88b44abb4db48704$var$isBlob = typeof $88b44abb4db48704$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $88b44abb4db48704$var$Blob;
} : function isBlob(b) {
    return false;
};

var $88b44abb4db48704$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $6EUyW = parcelRequire("6EUyW");
var $88b44abb4db48704$require$FunctionPrototypeCall = $6EUyW.FunctionPrototypeCall;
// This is needed for pre node 17.
var $88b44abb4db48704$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($8Lioq);
module.exports = function duplexify(body, name) {
    if ($88b44abb4db48704$var$isDuplexNodeStream(body)) return body;
    if ($88b44abb4db48704$var$isReadableNodeStream(body)) return $88b44abb4db48704$var$_duplexify({
        readable: body
    });
    if ($88b44abb4db48704$var$isWritableNodeStream(body)) return $88b44abb4db48704$var$_duplexify({
        writable: body
    });
    if ($88b44abb4db48704$var$isNodeStream(body)) return $88b44abb4db48704$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($88b44abb4db48704$var$isReadableStream(body)) return $88b44abb4db48704$var$_duplexify({
        readable: $sAhw0.fromWeb(body)
    });
    if ($88b44abb4db48704$var$isWritableStream(body)) return $88b44abb4db48704$var$_duplexify({
        writable: $2jNx5.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $88b44abb4db48704$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($88b44abb4db48704$var$isIterable(value)) return $bPJJ6($88b44abb4db48704$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $88b44abb4db48704$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $88b44abb4db48704$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $88b44abb4db48704$require$destroyer(d, err);
            });
            return d = new $88b44abb4db48704$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $88b44abb4db48704$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($88b44abb4db48704$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($88b44abb4db48704$var$isIterable(body)) return $bPJJ6($88b44abb4db48704$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($88b44abb4db48704$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $88b44abb4db48704$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $88b44abb4db48704$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $88b44abb4db48704$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $88b44abb4db48704$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $88b44abb4db48704$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $88b44abb4db48704$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $88b44abb4db48704$require$destroyer(d1, err);
        });
        return d1 = new $88b44abb4db48704$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $88b44abb4db48704$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $88b44abb4db48704$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $88b44abb4db48704$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $88b44abb4db48704$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $88b44abb4db48704$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $88b44abb4db48704$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $88b44abb4db48704$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $sAhw0.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$88b44abb4db48704$var$isReadable(r);
    var writable = !!$88b44abb4db48704$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $88b44abb4db48704$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $gvFwV(w, function(err) {
            writable = false;
            if (err) $88b44abb4db48704$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $gvFwV(r, function(err) {
            readable = false;
            if (err) $88b44abb4db48704$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $88b44abb4db48704$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $88b44abb4db48704$require$destroyer(w, err);
            $88b44abb4db48704$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("hHQw5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $ce3f3086356915bc$require$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf;
module.exports = $ce3f3086356915bc$var$PassThrough;

var $gFzPY = parcelRequire("gFzPY");
$ce3f3086356915bc$require$ObjectSetPrototypeOf($ce3f3086356915bc$var$PassThrough.prototype, $gFzPY.prototype);
$ce3f3086356915bc$require$ObjectSetPrototypeOf($ce3f3086356915bc$var$PassThrough, $gFzPY);
function $ce3f3086356915bc$var$PassThrough(options) {
    if (!(this instanceof $ce3f3086356915bc$var$PassThrough)) return new $ce3f3086356915bc$var$PassThrough(options);
    $gFzPY.call(this, options);
}
$ce3f3086356915bc$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("gFzPY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $c22c4636c2a23ab5$var$ObjectSetPrototypeOf = $6EUyW.ObjectSetPrototypeOf, $c22c4636c2a23ab5$var$Symbol = $6EUyW.Symbol;
module.exports = $c22c4636c2a23ab5$var$Transform;

var $c22c4636c2a23ab5$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("3Yp2a")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $8Lioq = parcelRequire("8Lioq");

var $5R1Lu = parcelRequire("5R1Lu");
var $c22c4636c2a23ab5$require$getHighWaterMark = $5R1Lu.getHighWaterMark;
$c22c4636c2a23ab5$var$ObjectSetPrototypeOf($c22c4636c2a23ab5$var$Transform.prototype, $8Lioq.prototype);
$c22c4636c2a23ab5$var$ObjectSetPrototypeOf($c22c4636c2a23ab5$var$Transform, $8Lioq);
var $c22c4636c2a23ab5$var$kCallback = $c22c4636c2a23ab5$var$Symbol('kCallback');
function $c22c4636c2a23ab5$var$Transform(options) {
    if (!(this instanceof $c22c4636c2a23ab5$var$Transform)) return new $c22c4636c2a23ab5$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $c22c4636c2a23ab5$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $8Lioq.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$c22c4636c2a23ab5$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $c22c4636c2a23ab5$var$prefinish);
}
function $c22c4636c2a23ab5$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $c22c4636c2a23ab5$var$prefinish() {
    if (this._final !== $c22c4636c2a23ab5$var$_final) $c22c4636c2a23ab5$var$_final.call(this);
}
$c22c4636c2a23ab5$var$Transform.prototype._final = $c22c4636c2a23ab5$var$_final;
$c22c4636c2a23ab5$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $c22c4636c2a23ab5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$c22c4636c2a23ab5$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$c22c4636c2a23ab5$var$kCallback] = callback;
    });
};
$c22c4636c2a23ab5$var$Transform.prototype._read = function() {
    if (this[$c22c4636c2a23ab5$var$kCallback]) {
        var callback = this[$c22c4636c2a23ab5$var$kCallback];
        this[$c22c4636c2a23ab5$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("kfcDo", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $6EUyW = parcelRequire("6EUyW");
var $ebcf024bf6125462$var$ArrayPrototypePop = $6EUyW.ArrayPrototypePop, $ebcf024bf6125462$var$Promise = $6EUyW.Promise;

var $h5dib = parcelRequire("h5dib");
var $ebcf024bf6125462$var$isIterable = $h5dib.isIterable, $ebcf024bf6125462$var$isNodeStream = $h5dib.isNodeStream, $ebcf024bf6125462$var$isWebStream = $h5dib.isWebStream;

var $eV3GP = parcelRequire("eV3GP");
var $ebcf024bf6125462$var$pl = $eV3GP.pipelineImpl;

var $gvFwV = parcelRequire("gvFwV");
var $ebcf024bf6125462$require$finished = $gvFwV.finished;
parcelRequire("a9pwl");
function $ebcf024bf6125462$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $ebcf024bf6125462$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$ebcf024bf6125462$var$isNodeStream(lastArg) && !$ebcf024bf6125462$var$isIterable(lastArg) && !$ebcf024bf6125462$var$isWebStream(lastArg)) {
            var options = $ebcf024bf6125462$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $ebcf024bf6125462$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $ebcf024bf6125462$require$finished,
    pipeline: $ebcf024bf6125462$var$pipeline
};

});





parcelRegister("fUgD9", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';
var $b948fc6ab3338c0f$var$isStream = function(stream) {
    return stream !== null && (typeof stream === "undefined" ? "undefined" : (0, $3KZcf._)(stream)) === 'object' && typeof stream.pipe === 'function';
};
$b948fc6ab3338c0f$var$isStream.writable = function(stream) {
    return $b948fc6ab3338c0f$var$isStream(stream) && stream.writable !== false && typeof stream._write === 'function' && (0, $3KZcf._)(stream._writableState) === 'object';
};
$b948fc6ab3338c0f$var$isStream.readable = function(stream) {
    return $b948fc6ab3338c0f$var$isStream(stream) && stream.readable !== false && typeof stream._read === 'function' && (0, $3KZcf._)(stream._readableState) === 'object';
};
$b948fc6ab3338c0f$var$isStream.duplex = function(stream) {
    return $b948fc6ab3338c0f$var$isStream.writable(stream) && $b948fc6ab3338c0f$var$isStream.readable(stream);
};
$b948fc6ab3338c0f$var$isStream.transform = function(stream) {
    return $b948fc6ab3338c0f$var$isStream.duplex(stream) && typeof stream._transform === 'function';
};
module.exports = $b948fc6ab3338c0f$var$isStream;

});

parcelRegister("2fLbT", function(module, exports) {
/* global ReadableStream */ module.exports = $1a4196a02356a962$var$nodeToWeb;
module.exports.WEBSTREAM_SUPPORT = typeof ReadableStream !== 'undefined';
function $1a4196a02356a962$var$nodeToWeb(nodeStream) {
    // Assumes the nodeStream has not ended/closed
    if (!module.exports.WEBSTREAM_SUPPORT) throw new Error('No web ReadableStream support');
    var destroyed = false;
    var listeners = {};
    function start(controller) {
        listeners['data'] = onData;
        listeners['end'] = onData;
        listeners['end'] = onDestroy;
        listeners['close'] = onDestroy;
        listeners['error'] = onDestroy;
        for(var name in listeners)nodeStream.on(name, listeners[name]);
        nodeStream.pause();
        function onData(chunk) {
            if (destroyed) return;
            controller.enqueue(chunk);
            nodeStream.pause();
        }
        function onDestroy(err) {
            if (destroyed) return;
            destroyed = true;
            for(var name in listeners)nodeStream.removeListener(name, listeners[name]);
            if (err) controller.error(err);
            else controller.close();
        }
    }
    function pull() {
        if (destroyed) return;
        nodeStream.resume();
    }
    function cancel() {
        destroyed = true;
        for(var name in listeners)nodeStream.removeListener(name, listeners[name]);
        nodeStream.push(null);
        nodeStream.pause();
        if (nodeStream.destroy) nodeStream.destroy();
        else if (nodeStream.close) nodeStream.close();
    }
    return new ReadableStream({
        start: start,
        pull: pull,
        cancel: cancel
    });
}

});


parcelRegister("gWlaP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAndCloseHttpResponse = void 0;

var $99iqU = parcelRequire("99iqU");

var $gR6Lt = parcelRequire("gR6Lt");
/**
 * Check if the http response is valid, and throw an error if not.
 * @param url The original URL that was to be updated.
 * @param httpResponse The update response.
 */ function $c5527cc77f78e9ab$var$validateAndCloseHttpResponse(url, httpResponse) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _httpResponse_body, bodyString, responseStream;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(httpResponse.status >= 400)) return [
                        3,
                        3
                    ];
                    // Consume the body, to avoid process to hang
                    bodyString = 'empty response';
                    if (!httpResponse.body) return [
                        3,
                        2
                    ];
                    responseStream = $gR6Lt.ActorHttp.toNodeReadable(httpResponse.body);
                    return [
                        4,
                        (0, $99iqU.stringify)(responseStream)
                    ];
                case 1:
                    bodyString = _state.sent();
                    _state.label = 2;
                case 2:
                    throw new Error("Could not update ".concat(url, " (HTTP status ").concat(httpResponse.status, "):\n").concat(bodyString));
                case 3:
                    // Close response body, as we don't need it
                    return [
                        4,
                        (_httpResponse_body = httpResponse.body) === null || _httpResponse_body === void 0 ? void 0 : _httpResponse_body.cancel()
                    ];
                case 4:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
module.exports.validateAndCloseHttpResponse = $c5527cc77f78e9ab$var$validateAndCloseHttpResponse;

});


parcelRegister("ii5zJ", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@comunica/actor-http-fetch\",\"version\":\"4.2.0\",\"description\":\"A fetch http actor\",\"lsd:module\":true,\"license\":\"MIT\",\"funding\":{\"type\":\"opencollective\",\"url\":\"https://opencollective.com/comunica-association\"},\"homepage\":\"https://comunica.dev/\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/comunica/comunica.git\",\"directory\":\"packages/actor-http-fetch\"},\"bugs\":{\"url\":\"https://github.com/comunica/comunica/issues\"},\"keywords\":[\"comunica\",\"runner\"],\"sideEffects\":false,\"main\":\"lib/index.js\",\"typings\":\"lib/index\",\"publishConfig\":{\"access\":\"public\"},\"files\":[\"components\",\"lib/**/*.d.ts\",\"lib/**/*.js\",\"lib/**/*.js.map\"],\"scripts\":{\"build\":\"yarn run build:ts && yarn run build:components\",\"build:ts\":\"node \\\"../../node_modules/typescript/bin/tsc\\\"\",\"build:components\":\"componentsjs-generator\"},\"dependencies\":{\"@comunica/bus-http\":\"^4.2.0\",\"@comunica/context-entries\":\"^4.2.0\",\"@comunica/core\":\"^4.2.0\",\"@comunica/mediatortype-time\":\"^4.2.0\"},\"browser\":{\"./lib/FetchInitPreprocessor.js\":\"./lib/FetchInitPreprocessor-browser.js\"},\"gitHead\":\"94e1eacab069551590cc250074b36bce08720c4c\"}");

});

parcelRegister("6ti1d", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchInitPreprocessor = void 0;
/**
 * Overrides things for fetch requests in browsers
 */ var $4b636da278b54a7f$var$FetchInitPreprocessor = /*#__PURE__*/ function() {
    function FetchInitPreprocessor() {
        (0, $jGAMp._)(this, FetchInitPreprocessor);
    }
    (0, $byiyg._)(FetchInitPreprocessor, [
        {
            key: "handle",
            value: function handle(init) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var reader, chunks, _ref, done, value;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(init.body && typeof init.body !== 'string' && 'getReader' in init.body)) return [
                                    3,
                                    4
                                ];
                                reader = init.body.getReader();
                                chunks = [];
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                if (done) return [
                                    3,
                                    3
                                ];
                                chunks.push(value);
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                init.body = chunks.join('');
                                _state.label = 4;
                            case 4:
                                // Only enable keepalive functionality if we are not sending a body (some browsers seem to trip over this)
                                return [
                                    2,
                                    (0, $emQHU._)((0, $iT0je._)({}, init), {
                                        keepalive: !init.body
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FetchInitPreprocessor;
}();
module.exports.FetchInitPreprocessor = $4b636da278b54a7f$var$FetchInitPreprocessor;

});



parcelRegister("g7ZYB", function(module, exports) {
"use strict";
var $bbdd600787462e84$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbdd600787462e84$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbdd600787462e84$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bbdd600787462e84$var$__exportStar((parcelRequire("6v6OQ")), module.exports);

});
parcelRegister("6v6OQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationSource = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Source Query Operation Actor.
 */ var $4bbaed73b3178fb4$var$ActorQueryOperationSource = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperation) {
    (0, $i3fW3._)(ActorQueryOperationSource, _bus_query_operation_1_ActorQueryOperation);
    function ActorQueryOperationSource(args) {
        (0, $jGAMp._)(this, ActorQueryOperationSource);
        return (0, $kzDuW._)(this, ActorQueryOperationSource, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationSource, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!(0, $2n9RU.getOperationSource)(action.operation)) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " requires an operation with source annotation."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                httpRequests: 1
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var physicalQueryPlanLogger, sourceWrapper, mergedContext, construct, quadStream, metadata, bindingsStream, metadata1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Log to physical plan
                        physicalQueryPlanLogger = action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanLogger);
                        if (physicalQueryPlanLogger) {
                            physicalQueryPlanLogger.logOperation(action.operation.type, undefined, action.operation, action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanNode), this.name, {});
                            action.context = action.context.set($9nBhR.KeysInitQuery.physicalQueryPlanNode, action.operation);
                        }
                        sourceWrapper = (0, $2n9RU.getOperationSource)(action.operation);
                        mergedContext = sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context;
                        // Check if the operation is a CONSTRUCT query
                        // We recurse because it may be wrapped in other operations such as SLICE and FROM
                        construct = false;
                        $hSHd8.Util.recurseOperation(action.operation, {
                            construct: function() {
                                construct = true;
                                return false;
                            }
                        });
                        // If so, delegate to queryQuads
                        if (construct) {
                            quadStream = sourceWrapper.source.queryQuads(action.operation, mergedContext);
                            metadata = (0, $jZbVy.getMetadataQuads)(quadStream);
                            return [
                                2,
                                {
                                    type: 'quads',
                                    quadStream: quadStream,
                                    metadata: metadata
                                }
                            ];
                        }
                        // eslint-disable-next-line ts/switch-exhaustiveness-check
                        switch(action.operation.type){
                            case $hSHd8.Algebra.types.ASK:
                                return [
                                    2,
                                    {
                                        type: 'boolean',
                                        execute: function() {
                                            return sourceWrapper.source.queryBoolean(action.operation, mergedContext);
                                        }
                                    }
                                ];
                            case $hSHd8.Algebra.types.COMPOSITE_UPDATE:
                            case $hSHd8.Algebra.types.DELETE_INSERT:
                            case $hSHd8.Algebra.types.LOAD:
                            case $hSHd8.Algebra.types.CLEAR:
                            case $hSHd8.Algebra.types.CREATE:
                            case $hSHd8.Algebra.types.DROP:
                            case $hSHd8.Algebra.types.ADD:
                            case $hSHd8.Algebra.types.MOVE:
                            case $hSHd8.Algebra.types.COPY:
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: function() {
                                            return sourceWrapper.source.queryVoid(action.operation, mergedContext);
                                        }
                                    }
                                ];
                        }
                        bindingsStream = sourceWrapper.source.queryBindings(action.operation, mergedContext);
                        metadata1 = (0, $jZbVy.getMetadataBindings)(bindingsStream);
                        return [
                            2,
                            {
                                type: 'bindings',
                                bindingsStream: bindingsStream,
                                metadata: metadata1
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationSource;
}($dng5S.ActorQueryOperation);
module.exports.ActorQueryOperationSource = $4bbaed73b3178fb4$var$ActorQueryOperationSource;

});


parcelRegister("9S8Do", function(module, exports) {
"use strict";
var $72ffdacce217f08b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $72ffdacce217f08b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $72ffdacce217f08b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$72ffdacce217f08b$var$__exportStar((parcelRequire("jfhmT")), module.exports);

});
parcelRegister("jfhmT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorJoinCoefficientsFixed = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A mediator that mediates over actors implementing the Join Coefficients mediator type and assigns fixed weights
 * to calculate an overall score and pick the actor with the lowest score.
 */ var $e02ce3fbe886e424$var$MediatorJoinCoefficientsFixed = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorJoinCoefficientsFixed, _core_1_Mediator);
    function MediatorJoinCoefficientsFixed(args) {
        (0, $jGAMp._)(this, MediatorJoinCoefficientsFixed);
        return (0, $kzDuW._)(this, MediatorJoinCoefficientsFixed, [
            args
        ]);
    }
    (0, $byiyg._)(MediatorJoinCoefficientsFixed, [
        {
            key: "mediateWith",
            value: function mediateWith(action, testResults) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, _Math, _core_1_Actor_getContextLogger, errors, promises, results, costs, maxCost, limitIndicator, minIndex, minValue, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, cost, bestActor, _tmp, _, _tmp1, _tmp2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                // Obtain test results
                                errors = [];
                                promises = testResults.map(function(param) {
                                    var reply = param.reply;
                                    return reply;
                                });
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 1:
                                results = _state.sent().map(function(testResult) {
                                    if (testResult.isFailed()) {
                                        errors.push(testResult.getFailMessage());
                                        // eslint-disable-next-line array-callback-return
                                        return;
                                    }
                                    return {
                                        value: testResult.get(),
                                        sideData: testResult.getSideData()
                                    };
                                });
                                // Calculate costs
                                costs = results// eslint-disable-next-line array-callback-return
                                .map(function(result) {
                                    if (result) return result.value.iterations * _this.cpuWeight + result.value.persistedItems * _this.memoryWeight + result.value.blockingItems * _this.timeWeight + result.value.requestTime * _this.ioWeight;
                                });
                                maxCost = (_Math = Math).max.apply(_Math, (0, $7WNf6._)(costs.filter(function(cost) {
                                    return cost !== undefined;
                                })));
                                // If we have a limit indicator in the context,
                                // increase cost of entries that have a number of iterations that is higher than the limit AND block items.
                                // In these cases, join operators that produce results early on will be preferred.
                                limitIndicator = action.context.get($9nBhR.KeysQueryOperation.limitIndicator);
                                if (limitIndicator) costs = costs.map(function(cost, i) {
                                    var _results_i, _results_i1;
                                    if (cost !== undefined && ((_results_i = results[i]) === null || _results_i === void 0 ? void 0 : _results_i.value).blockingItems > 0 && ((_results_i1 = results[i]) === null || _results_i1 === void 0 ? void 0 : _results_i1.value).iterations > limitIndicator) return cost + maxCost;
                                    return cost;
                                });
                                // Determine index with lowest cost
                                minIndex = -1;
                                minValue = Number.POSITIVE_INFINITY;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = costs.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], cost = _step_value[1];
                                        if (cost !== undefined && (minIndex === -1 || cost < minValue)) {
                                            minIndex = i;
                                            minValue = cost;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                // Reject if all actors rejected
                                if (minIndex < 0) return [
                                    2,
                                    (0, $kNNoa.failTest)(this.constructFailureMessage(action, errors))
                                ];
                                // Return actor with lowest cost
                                bestActor = testResults[minIndex].actor;
                                if (!bestActor.includeInLogs) return [
                                    3,
                                    5
                                ];
                                if (!((_core_1_Actor_getContextLogger = $kNNoa.Actor.getContextLogger(action.context)) === null || _core_1_Actor_getContextLogger === void 0)) return [
                                    3,
                                    2
                                ];
                                _tmp = void 0;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                _ = _core_1_Actor_getContextLogger.debug;
                                _tmp1 = [
                                    "Determined physical join operator '".concat(bestActor.logicalType, "-").concat(bestActor.physicalName, "'")
                                ];
                                _tmp2 = {
                                    entries: action.entries.length
                                };
                                return [
                                    4,
                                    Promise.all(action.entries.map(function(entry) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            entry.output.metadata()
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent().variables.map(function(variable) {
                                                                return variable.variable.value;
                                                            })
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 3:
                                _tmp = _.apply(_core_1_Actor_getContextLogger, _tmp1.concat([
                                    (_tmp2.variables = _state.sent(), _tmp2.costs = Object.fromEntries(costs.map(function(coeff, i) {
                                        return [
                                            "".concat(testResults[i].actor.logicalType, "-").concat(testResults[i].actor.physicalName),
                                            coeff
                                        ];
                                    }).filter(function(entry) {
                                        return entry[1] !== undefined;
                                    })), _tmp2.coefficients = Object.fromEntries(results.map(function(result, i) {
                                        return [
                                            "".concat(testResults[i].actor.logicalType, "-").concat(testResults[i].actor.physicalName),
                                            result === null || result === void 0 ? void 0 : result.value
                                        ];
                                    }).filter(function(entry) {
                                        return entry[1] !== undefined;
                                    })), _tmp2)
                                ]));
                                _state.label = 4;
                            case 4:
                                _tmp;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)(bestActor, results[minIndex].sideData)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return MediatorJoinCoefficientsFixed;
}($kNNoa.Mediator);
module.exports.MediatorJoinCoefficientsFixed = $e02ce3fbe886e424$var$MediatorJoinCoefficientsFixed;

});


parcelRegister("cGCel", function(module, exports) {
"use strict";
var $93c7100c1cceddc0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93c7100c1cceddc0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93c7100c1cceddc0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93c7100c1cceddc0$var$__exportStar((parcelRequire("agzX9")), module.exports);

$93c7100c1cceddc0$var$__exportStar((parcelRequire("bdOLM")), module.exports);

});
parcelRegister("agzX9", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpInvalidate = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for http-invalidate events.
 *
 * Actor types:
 * * Input:  IActionHttpInvalidate:      An action for invalidating the cached contents of given URL.
 * * Test:   <none>
 * * Output: IActorHttpInvalidateOutput: An empty response.
 *
 * @see IActionHttpInvalidate
 * @see IActorHttpInvalidateOutput
 */ var $7797498581f6a73d$var$ActorHttpInvalidate = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorHttpInvalidate, _core_1_Actor);
    function ActorHttpInvalidate(args) {
        (0, $jGAMp._)(this, ActorHttpInvalidate);
        return (0, $kzDuW._)(this, ActorHttpInvalidate, [
            args
        ]);
    }
    return ActorHttpInvalidate;
}($kNNoa.Actor);
module.exports.ActorHttpInvalidate = $7797498581f6a73d$var$ActorHttpInvalidate;

});

parcelRegister("bdOLM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpInvalidateListenable = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $agzX9 = parcelRequire("agzX9");
/**
 * An ActorHttpInvalidate actor that allows listeners to be attached.
 *
 * @see ActorHttpInvalidate
 */ var $82b84a671ef06a30$var$ActorHttpInvalidateListenable = /*#__PURE__*/ function(_ActorHttpInvalidate_1_ActorHttpInvalidate) {
    (0, $i3fW3._)(ActorHttpInvalidateListenable, _ActorHttpInvalidate_1_ActorHttpInvalidate);
    function ActorHttpInvalidateListenable(args) {
        (0, $jGAMp._)(this, ActorHttpInvalidateListenable);
        var _this;
        _this = (0, $kzDuW._)(this, ActorHttpInvalidateListenable, [
            args
        ]);
        _this.invalidateListeners = [];
        _this.invalidateListeners = [];
        return _this;
    }
    (0, $byiyg._)(ActorHttpInvalidateListenable, [
        {
            key: "addInvalidateListener",
            value: function addInvalidateListener(listener) {
                this.invalidateListeners.push(listener);
            }
        },
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, listener;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = this.invalidateListeners[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                listener = _step.value;
                                listener(action);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            {}
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorHttpInvalidateListenable;
}($agzX9.ActorHttpInvalidate);
module.exports.ActorHttpInvalidateListenable = $82b84a671ef06a30$var$ActorHttpInvalidateListenable;

});


parcelRegister("dKlTA", function(module, exports) {
"use strict";
var $a0208e3783e48498$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0208e3783e48498$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a0208e3783e48498$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a0208e3783e48498$var$__exportStar((parcelRequire("9rChH")), module.exports);

});
parcelRegister("9rChH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorAll = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica mediator that runs all actors that resolve their test.
 * This mediator will always resolve to the first actor's output.
 */ var $6e045529a60b2687$var$MediatorAll = /*#__PURE__*/ function(_core_1_Mediator) {
    (0, $i3fW3._)(MediatorAll, _core_1_Mediator);
    function MediatorAll(args) {
        (0, $jGAMp._)(this, MediatorAll);
        return (0, $kzDuW._)(this, MediatorAll, [
            args
        ]);
    }
    (0, $byiyg._)(MediatorAll, [
        {
            key: "mediate",
            value: function mediate(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var passedResults, testResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, testResult, reply, err, outputs;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Collect all actors that resolve their test
                                passedResults = [];
                                try {
                                    testResults = this.publish(action);
                                } catch (e) {
                                    testResults = [];
                                }
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = testResults[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                testResult = _step.value;
                                return [
                                    4,
                                    testResult.reply
                                ];
                            case 3:
                                reply = _state.sent();
                                if (reply.isPassed()) passedResults.push({
                                    actor: testResult.actor,
                                    sideData: reply.getSideData()
                                });
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    4,
                                    Promise.all(passedResults.map(function(result) {
                                        return result.actor.runObservable(action, result.sideData);
                                    }))
                                ];
                            case 9:
                                outputs = _state.sent();
                                return [
                                    2,
                                    outputs[0]
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "mediateWith",
            value: function mediateWith() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error('Unsupported operation: MediatorAll#mediateWith');
                    });
                })();
            }
        }
    ]);
    return MediatorAll;
}($kNNoa.Mediator);
module.exports.MediatorAll = $6e045529a60b2687$var$MediatorAll;

});


parcelRegister("8KRAp", function(module, exports) {
"use strict";
var $65fc2fb6405b2777$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $65fc2fb6405b2777$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $65fc2fb6405b2777$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$65fc2fb6405b2777$var$__exportStar((parcelRequire("8dqyM")), module.exports);

});
parcelRegister("8dqyM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSortSelectivity = void 0;

var $1djTI = parcelRequire("1djTI");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Selectivity RDF Join Entries Sort Actor.
 */ var $5fb423e75645a4b5$var$ActorRdfJoinEntriesSortSelectivity = /*#__PURE__*/ function(_bus_rdf_join_entries_sort_1_ActorRdfJoinEntriesSort) {
    (0, $i3fW3._)(ActorRdfJoinEntriesSortSelectivity, _bus_rdf_join_entries_sort_1_ActorRdfJoinEntriesSort);
    function ActorRdfJoinEntriesSortSelectivity(args) {
        (0, $jGAMp._)(this, ActorRdfJoinEntriesSortSelectivity);
        return (0, $kzDuW._)(this, ActorRdfJoinEntriesSortSelectivity, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinEntriesSortSelectivity, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                accuracy: 0.501
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var remainingEntries, finalEntries, minSelectivity, minEntryIndex, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, remainingEntryIndex, remainingEntry, selectivity, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                remainingEntries = (0, $7WNf6._)(action.entries);
                                finalEntries = [];
                                _state.label = 1;
                            case 1:
                                if (!(remainingEntries.length > 0)) return [
                                    3,
                                    10
                                ];
                                minSelectivity = Number.MAX_VALUE;
                                minEntryIndex = -1;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = remainingEntries.entries()[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                _step_value = (0, $32TW8._)(_step.value, 2), remainingEntryIndex = _step_value[0], remainingEntry = _step_value[1];
                                return [
                                    4,
                                    this.mediatorJoinSelectivity.mediate({
                                        entries: [
                                            remainingEntry
                                        ].concat((0, $7WNf6._)(finalEntries)),
                                        context: action.context
                                    })
                                ];
                            case 4:
                                selectivity = _state.sent().selectivity;
                                if (selectivity < minSelectivity) {
                                    minSelectivity = selectivity;
                                    minEntryIndex = remainingEntryIndex;
                                }
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                finalEntries.push(remainingEntries[minEntryIndex]);
                                remainingEntries.splice(minEntryIndex, 1);
                                return [
                                    3,
                                    1
                                ];
                            case 10:
                                return [
                                    2,
                                    {
                                        entries: finalEntries
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfJoinEntriesSortSelectivity;
}($1djTI.ActorRdfJoinEntriesSort);
module.exports.ActorRdfJoinEntriesSortSelectivity = $5fb423e75645a4b5$var$ActorRdfJoinEntriesSortSelectivity;

});


parcelRegister("lmIWK", function(module, exports) {
"use strict";
var $f8de8483055d3841$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f8de8483055d3841$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f8de8483055d3841$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f8de8483055d3841$var$__exportStar((parcelRequire("Ag6Ru")), module.exports);

});
parcelRegister("Ag6Ru", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSingle = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Single RDF Join Actor.
 */ var $06cfdbf3ef122a27$var$ActorRdfJoinSingle = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinSingle, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinSingle(args) {
        (0, $jGAMp._)(this, ActorRdfJoinSingle);
        var _this;
        _this = (0, $kzDuW._)(this, ActorRdfJoinSingle, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'single',
                limitEntries: 1
            }
        ]);
        _this.includeInLogs = false;
        return _this;
    }
    (0, $byiyg._)(ActorRdfJoinSingle, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Allow joining of one or zero streams
                                if (action.entries.length !== 1) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only join a single entry"))
                                ];
                                return [
                                    4,
                                    this.getJoinCoefficients(action, undefined)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                result: action.entries[0].output
                            }
                        ];
                    });
                })();
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: 0,
                                persistedItems: 0,
                                blockingItems: 0,
                                requestTime: 0
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinSingle;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinSingle = $06cfdbf3ef122a27$var$ActorRdfJoinSingle;

});
parcelRegister("17TpP", function(module, exports) {
"use strict";
var $0d216e43d42e8cb5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0d216e43d42e8cb5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0d216e43d42e8cb5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0d216e43d42e8cb5$var$__exportStar((parcelRequire("9VNwm")), module.exports);

});
parcelRegister("9VNwm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoin = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $kQuvF = parcelRequire("kQuvF");

var $jZbVy = parcelRequire("jZbVy");
/**
 * A comunica actor for joining 2 binding streams.
 *
 * Actor types:
 * * Input:  IActionRdfJoin:                The streams that need to be joined.
 * * Test:   IMediatorTypeJoinCoefficients: Join coefficients.
 * * Output: IActorRdfJoinOutput:           The resulting joined stream.
 *
 * @see IActionRdfJoin
 * @see IActorQueryOperationOutput
 */ var $73afd9c1c9b4fd32$var$ActorRdfJoin = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfJoin, _core_1_Actor);
    function ActorRdfJoin(args, options) {
        (0, $jGAMp._)(this, ActorRdfJoin);
        var _this;
        _this = (0, $kzDuW._)(this, ActorRdfJoin, [
            args
        ]);
        /**
         * If this actor will be logged in the debugger and physical query plan logger
         */ _this.includeInLogs = true;
        _this.logicalType = options.logicalType;
        _this.physicalName = options.physicalName;
        var _options_limitEntries;
        _this.limitEntries = (_options_limitEntries = options.limitEntries) !== null && _options_limitEntries !== void 0 ? _options_limitEntries : Number.POSITIVE_INFINITY;
        var _options_limitEntriesMin;
        _this.limitEntriesMin = (_options_limitEntriesMin = options.limitEntriesMin) !== null && _options_limitEntriesMin !== void 0 ? _options_limitEntriesMin : false;
        var _options_canHandleUndefs;
        _this.canHandleUndefs = (_options_canHandleUndefs = options.canHandleUndefs) !== null && _options_canHandleUndefs !== void 0 ? _options_canHandleUndefs : false;
        var _options_isLeaf;
        _this.isLeaf = (_options_isLeaf = options.isLeaf) !== null && _options_isLeaf !== void 0 ? _options_isLeaf : true;
        var _options_requiresVariableOverlap;
        _this.requiresVariableOverlap = (_options_requiresVariableOverlap = options.requiresVariableOverlap) !== null && _options_requiresVariableOverlap !== void 0 ? _options_requiresVariableOverlap : false;
        return _this;
    }
    (0, $byiyg._)(ActorRdfJoin, [
        {
            /**
     * Construct a metadata validation state for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ key: "constructState",
            value: function constructState(metadatas) {
                // Propagate metadata invalidations
                var state = new $jZbVy.MetadataValidationState();
                var invalidateListener = function() {
                    return state.invalidate();
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = metadatas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var metadata = _step.value;
                        metadata.state.addInvalidateListener(invalidateListener);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return state;
            }
        },
        {
            key: "constructResultMetadata",
            value: /**
     * Helper function to create a new metadata object for the join result.
     * For required metadata entries that are not provided, sane defaults are calculated.
     * @param entries Join entries.
     * @param metadatas Metadata of the join entries.
     * @param context The action context.
     * @param partialMetadata Partial metadata entries.
     * @param optional If metadata for an optional operation must be calculated.
     */ function constructResultMetadata(_0, _1, _2) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(entries, metadatas, context) {
                    var partialMetadata, optional, cardinalityJoined, hasZeroCardinality, _;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                partialMetadata = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, optional = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                                if (!partialMetadata.cardinality) return [
                                    3,
                                    1
                                ];
                                cardinalityJoined = partialMetadata.cardinality;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                hasZeroCardinality = false;
                                cardinalityJoined = metadatas.reduce(function(acc, metadata) {
                                    var cardinalityThis = ActorRdfJoin.getCardinality(metadata);
                                    if (cardinalityThis.value === 0) hasZeroCardinality = true;
                                    return {
                                        type: cardinalityThis.type === 'estimate' ? 'estimate' : acc.type,
                                        value: acc.value * (optional ? Math.max(1, cardinalityThis.value) : cardinalityThis.value)
                                    };
                                }, {
                                    type: 'exact',
                                    value: 1
                                });
                                if (!(!hasZeroCardinality || optional)) return [
                                    3,
                                    3
                                ];
                                _ = cardinalityJoined.value;
                                return [
                                    4,
                                    this.mediatorJoinSelectivity.mediate({
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 2:
                                _ *= _state.sent().selectivity;
                                if (cardinalityJoined.value === 0) cardinalityJoined.value = Number.MIN_VALUE;
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    (0, $emQHU._)((0, $iT0je._)({
                                        state: this.constructState(metadatas)
                                    }, partialMetadata), {
                                        cardinality: {
                                            type: cardinalityJoined.type,
                                            value: cardinalityJoined.value
                                        },
                                        variables: ActorRdfJoin.joinVariables(context.getSafe($9nBhR.KeysInitQuery.dataFactory), metadatas, optional)
                                    })
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "test",
            value: /**
     * Default test function for join actors.
     * Checks whether all iterators have metadata.
     * If yes: call the abstract getIterations method, if not: return Infinity.
     * @param {IActionRdfJoin} action The input action containing the relevant iterators
     * @returns {Promise<IMediatorTypeJoinCoefficients>} The join coefficients.
     */ function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, metadatas, overlappingVariables;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Validate logical join type
                                if (action.type !== this.logicalType) return [
                                    2,
                                    (0, $kNNoa.failTest)("".concat(this.name, " can only handle logical joins of type '").concat(this.logicalType, "', while '").concat(action.type, "' was given."))
                                ];
                                // Don't allow joining of one or zero streams
                                if (action.entries.length <= 1) return [
                                    2,
                                    (0, $kNNoa.failTest)("".concat(this.name, " requires at least two join entries."))
                                ];
                                // Check if this actor can handle the given number of streams
                                if (this.limitEntriesMin ? action.entries.length < this.limitEntries : action.entries.length > this.limitEntries) return [
                                    2,
                                    (0, $kNNoa.failTest)("".concat(this.name, " requires ").concat(this.limitEntries, " join entries at ").concat(this.limitEntriesMin ? 'least' : 'most', ". The input contained ").concat(action.entries.length, "."))
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // Check if all streams are bindings streams
                                    for(_iterator = action.entries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        entry = _step.value;
                                        if (entry.output.type !== 'bindings') // eslint-disable-next-line ts/restrict-template-expressions
                                        return [
                                            2,
                                            (0, $kNNoa.failTest)("Invalid type of a join entry: Expected 'bindings' but got '".concat(entry.output.type, "'"))
                                        ];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    ActorRdfJoin.getMetadatas(action.entries)
                                ];
                            case 1:
                                metadatas = _state.sent();
                                if (!this.canHandleUndefs) {
                                    overlappingVariables = ActorRdfJoin.overlappingVariables(metadatas);
                                    if (overlappingVariables.some(function(variable) {
                                        return variable.canBeUndef;
                                    })) return [
                                        2,
                                        (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not join streams containing undefs"))
                                    ];
                                }
                                // This actor only works with common variables
                                if (this.requiresVariableOverlap && (overlappingVariables !== null && overlappingVariables !== void 0 ? overlappingVariables : ActorRdfJoin.overlappingVariables(metadatas)).length === 0) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only join entries with at least one common variable"))
                                ];
                                return [
                                    4,
                                    this.getJoinCoefficients(action, {
                                        metadatas: metadatas
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: /**
     * Returns default input for 0 or 1 entries. Calls the getOutput function otherwise
     * @param {IActionRdfJoin} action
     * @param sideData Side data from the test method
     * @returns {Promise<IQueryOperationResultBindings>} A bindings result.
     */ function run(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var parentPhysicalQueryPlanNode, physicalQueryPlanLogger, planMetadata, _ref, result, physicalPlanMetadata, cardinalities, i, entry;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (action.context.has($9nBhR.KeysInitQuery.physicalQueryPlanLogger)) {
                                    parentPhysicalQueryPlanNode = action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanNode);
                                    action.context = action.context.set($9nBhR.KeysInitQuery.physicalQueryPlanNode, action);
                                }
                                // Log to physical plan
                                physicalQueryPlanLogger = action.context.get($9nBhR.KeysInitQuery.physicalQueryPlanLogger);
                                if (this.includeInLogs && physicalQueryPlanLogger) {
                                    planMetadata = {};
                                    // Stash non-join children, as they will be unstashed later in sub-joins.
                                    physicalQueryPlanLogger.stashChildren(parentPhysicalQueryPlanNode, function(node) {
                                        return node.logicalOperator.startsWith('join');
                                    });
                                    physicalQueryPlanLogger.logOperation("join-".concat(this.logicalType), this.physicalName, action, parentPhysicalQueryPlanNode, this.name, planMetadata);
                                }
                                return [
                                    4,
                                    this.getOutput(action, sideData)
                                ];
                            case 1:
                                _ref = _state.sent(), result = _ref.result, physicalPlanMetadata = _ref.physicalPlanMetadata;
                                if (!planMetadata) return [
                                    3,
                                    3
                                ];
                                // eslint-disable-next-line ts/no-floating-promises
                                (0, $kQuvF.instrumentIterator)(result.bindingsStream).then(function(counters) {
                                    physicalQueryPlanLogger.appendMetadata(action, {
                                        cardinalityReal: counters.count,
                                        timeSelf: counters.timeSelf,
                                        timeLife: counters.timeLife
                                    });
                                });
                                Object.assign(planMetadata, physicalPlanMetadata);
                                cardinalities = sideData.metadatas.map(ActorRdfJoin.getCardinality);
                                planMetadata.cardinalities = cardinalities;
                                return [
                                    4,
                                    this.getJoinCoefficients(action, sideData)
                                ];
                            case 2:
                                planMetadata.joinCoefficients = _state.sent().getOrThrow();
                                // If this is a leaf operation, include join entries in plan metadata.
                                if (this.isLeaf) for(i = 0; i < action.entries.length; i++){
                                    entry = action.entries[i];
                                    physicalQueryPlanLogger.unstashChild(entry.operation, action);
                                    physicalQueryPlanLogger.appendMetadata(entry.operation, {
                                        cardinality: cardinalities[i]
                                    });
                                }
                                _state.label = 3;
                            case 3:
                                // Cache metadata
                                result.metadata = (0, $jZbVy.cachifyMetadata)(result.metadata);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "overlappingVariables",
            value: /**
     * Returns an array containing all the variable names that occur in all bindings streams.
     * @param {MetadataBindings[]} metadatas An array of optional metadata objects for the entries.
     * @returns {RDF.Variable[]} An array of variables.
     */ function overlappingVariables(metadatas) {
                var variablesIndexed = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = metadatas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var metadata = _step.value;
                        try {
                            for(var _iterator1 = metadata.variables[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var variable = _step1.value;
                                if (!variablesIndexed[variable.variable.value]) variablesIndexed[variable.variable.value] = {
                                    variable: variable.variable,
                                    canBeUndef: variable.canBeUndef,
                                    occurrences: 0
                                };
                                var entry = variablesIndexed[variable.variable.value];
                                entry.canBeUndef = entry.canBeUndef || variable.canBeUndef;
                                entry.occurrences++;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return Object.values(variablesIndexed).filter(function(entry) {
                    return entry.occurrences === metadatas.length;
                }).map(function(entry) {
                    return {
                        variable: entry.variable,
                        canBeUndef: entry.canBeUndef
                    };
                });
            }
        },
        {
            key: "joinVariables",
            value: /**
     * Returns the variables that will occur in the joined bindings.
     * @param dataFactory The data factory.
     * @param {MetadataBindings[]} metadatas An array of metadata objects for the entries.
     * @param optional If an optional join is being performed.
     * @returns {RDF.Variable[]} An array of joined variables.
     */ function joinVariables(dataFactory, metadatas) {
                var optional = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var variablesIndexed = {};
                var first = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = metadatas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var metadata = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = metadata.variables[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var variable = _step1.value;
                                variablesIndexed[variable.variable.value] = variablesIndexed[variable.variable.value] || variable.canBeUndef || !first && optional && !(variable.variable.value in variablesIndexed);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        first = false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Object.entries(variablesIndexed).map(function(param) {
                    var _param = (0, $32TW8._)(param, 2), variableLabel = _param[0], canBeUndef = _param[1];
                    return {
                        variable: dataFactory.variable(variableLabel),
                        canBeUndef: canBeUndef
                    };
                });
            }
        },
        {
            key: "joinBindings",
            value: /**
     * Returns the result of joining bindings, or `null` if no join is possible.
     * @param {Bindings[]} bindings
     * @returns {Bindings}
     */ function joinBindings() {
                for(var _len = arguments.length, bindings = new Array(_len), _key = 0; _key < _len; _key++){
                    bindings[_key] = arguments[_key];
                }
                if (bindings.length === 0) return null;
                if (bindings.length === 1) return bindings[0];
                var acc = bindings[0];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = bindings.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var binding = _step.value;
                        var merged = acc.merge(binding);
                        if (!merged) return null;
                        acc = merged;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return acc;
            }
        },
        {
            key: "getCardinality",
            value: /**
     * Get the estimated number of items from the given metadata.
     * @param {Record<string, any>} metadata A metadata object.
     * @return {number} The estimated number of items, or `Infinity` if cardinality is falsy.
     */ function getCardinality(metadata) {
                return metadata.cardinality;
            }
        },
        {
            key: "getMetadatas",
            value: /**
     * Obtain the metadata from all given join entries.
     * @param entries Join entries.
     */ function getMetadatas(entries) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(entries.map(function(entry) {
                                        return entry.output.metadata();
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEntriesWithMetadatas",
            value: /**
     * Obtain the join entries witt metadata from all given join entries.
     * @param entries Join entries.
     */ function getEntriesWithMetadatas(entries) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    ActorRdfJoin.getMetadatas(entries)
                                ];
                            case 1:
                                metadatas = _state.sent();
                                return [
                                    2,
                                    entries.map(function(entry, i) {
                                        return (0, $emQHU._)((0, $iT0je._)({}, entry), {
                                            metadata: metadatas[i]
                                        });
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRequestInitialTimes",
            value: /**
     * Calculate the time to initiate a request for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ function getRequestInitialTimes(metadatas) {
                return metadatas.map(function(metadata) {
                    var _metadata_requestTime;
                    return metadata.pageSize ? 0 : (_metadata_requestTime = metadata.requestTime) !== null && _metadata_requestTime !== void 0 ? _metadata_requestTime : 0;
                });
            }
        },
        {
            key: "getRequestItemTimes",
            value: /**
     * Calculate the time to receive a single item for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ function getRequestItemTimes(metadatas) {
                return metadatas.map(function(metadata) {
                    var _metadata_requestTime;
                    return metadata.pageSize ? ((_metadata_requestTime = metadata.requestTime) !== null && _metadata_requestTime !== void 0 ? _metadata_requestTime : 0) / metadata.pageSize : 0;
                });
            }
        },
        {
            key: "sortJoinEntries",
            value: /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {MediatorRdfJoinEntriesSort} mediatorJoinEntriesSort A mediator for sorting join entries.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ function sortJoinEntries(mediatorJoinEntriesSort, entries, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var hasUndefVars, variableOccurrences, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, entry, _iterator1, _step1, variable, counter, multiOccurrenceVariables, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step_value, variable1, count, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // If there is a stream that can contain undefs, we don't modify the join order.
                                hasUndefVars = entries.some(function(entry) {
                                    return entry.metadata.variables.some(function(variable) {
                                        return variable.canBeUndef;
                                    });
                                });
                                if (hasUndefVars) return [
                                    2,
                                    (0, $kNNoa.passTest)(entries)
                                ];
                                // Calculate number of occurrences of each variable
                                variableOccurrences = {};
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator = entries[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        entry = _step.value;
                                        try {
                                            for(_iterator1 = entry.metadata.variables[Symbol.iterator](); !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                variable = _step1.value;
                                                counter = variableOccurrences[variable.variable.value];
                                                if (!counter) counter = 0;
                                                variableOccurrences[variable.variable.value] = ++counter;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                                    _iterator1["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                // Determine variables that occur in at least two join entries
                                multiOccurrenceVariables = [];
                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(_iterator2 = Object.entries(variableOccurrences)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        _step_value = (0, $32TW8._)(_step2.value, 2), variable1 = _step_value[0], count = _step_value[1];
                                        if (count >= 2) multiOccurrenceVariables.push(variable1);
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                // Reject if no entries have common variables
                                if (multiOccurrenceVariables.length === 0) return [
                                    2,
                                    (0, $kNNoa.failTest)("Bind join can only join entries with at least one common variable")
                                ];
                                _ = (0, $kNNoa.passTest);
                                return [
                                    4,
                                    mediatorJoinEntriesSort.mediate({
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(void 0, [
                                        _state.sent().entries
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoin;
}($kNNoa.Actor);
module.exports.ActorRdfJoin = $73afd9c1c9b4fd32$var$ActorRdfJoin;

});
parcelRegister("kQuvF", function(module, exports) {
"use strict";
var $f2d05493ffb88665$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f2d05493ffb88665$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f2d05493ffb88665$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f2d05493ffb88665$var$__exportStar((parcelRequire("cq8N9")), module.exports);

$f2d05493ffb88665$var$__exportStar((parcelRequire("g9Jkr")), module.exports);

$f2d05493ffb88665$var$__exportStar((parcelRequire("33GpH")), module.exports);

$f2d05493ffb88665$var$__exportStar((parcelRequire("4XDMh")), module.exports);

});
parcelRegister("cq8N9", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedIterator = void 0;

var $aafx9 = parcelRequire("aafx9");
/**
 * Splits an iterator into chunks based on a given block size.
 */ var $90aebb9548b1c61b$var$ChunkedIterator = /*#__PURE__*/ function(_asynciterator_1_TransformIterator) {
    (0, $i3fW3._)(ChunkedIterator, _asynciterator_1_TransformIterator);
    function ChunkedIterator(source, blockSize, options) {
        (0, $jGAMp._)(this, ChunkedIterator);
        var _this;
        _this = (0, $kzDuW._)(this, ChunkedIterator, [
            source,
            options
        ]);
        _this.chunk = [];
        _this.blockSize = blockSize;
        return _this;
    }
    (0, $byiyg._)(ChunkedIterator, [
        {
            key: "consumeChunkAsIterator",
            value: function consumeChunkAsIterator() {
                var it = new $aafx9.ArrayIterator(this.chunk, {
                    autoStart: false
                });
                this.chunk = [];
                return it;
            }
        },
        {
            key: "_transform",
            value: function _transform(item, done, push) {
                this.chunk.push(item);
                if (this.chunk.length >= this.blockSize) push(this.consumeChunkAsIterator());
                done();
            }
        },
        {
            key: "_flush",
            value: function _flush(done) {
                if (this.chunk.length > 0) this._push(this.consumeChunkAsIterator());
                (0, $fXhL4._)((0, $hxFDX._)(ChunkedIterator.prototype), "_flush", this).call(this, done);
            }
        }
    ]);
    return ChunkedIterator;
}($aafx9.TransformIterator);
module.exports.ChunkedIterator = $90aebb9548b1c61b$var$ChunkedIterator;

});

parcelRegister("g9Jkr", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClosableIterator = void 0;

var $aafx9 = parcelRequire("aafx9");
/**
 * An AsyncIterator with a callback for when this iterator is closed in any way.
 * In contrast to ClosableTransformIterator, this does not add the overhead of a TransformIterator.
 */ var $bc30a5f56b97f787$var$ClosableIterator = /*#__PURE__*/ function(_asynciterator_1_AsyncIterator) {
    (0, $i3fW3._)(ClosableIterator, _asynciterator_1_AsyncIterator);
    function ClosableIterator(source, options) {
        (0, $jGAMp._)(this, ClosableIterator);
        var _this;
        _this = (0, $kzDuW._)(this, ClosableIterator);
        _this.onClose = options.onClose;
        _this._source = source;
        // Wire up the source for reading
        _this._source[$aafx9.DESTINATION] = _this;
        _this._source.on('end', $bc30a5f56b97f787$var$destinationClose);
        _this._source.on('error', $bc30a5f56b97f787$var$destinationEmitError);
        _this._source.on('readable', $bc30a5f56b97f787$var$destinationSetReadable);
        _this.readable = _this._source.readable;
        return _this;
    }
    (0, $byiyg._)(ClosableIterator, [
        {
            key: "read",
            value: function read() {
                var ret = this._source.read();
                if (!ret) {
                    // Mark as non-readable if ret was null
                    this.readable = false;
                    // Close this iterator if the source is empty
                    if (this._source.done) this.close();
                }
                return ret;
            }
        },
        {
            key: "_end",
            value: function _end(destroy) {
                this.onClose();
                this._source.removeListener('end', $bc30a5f56b97f787$var$destinationClose);
                this._source.removeListener('error', $bc30a5f56b97f787$var$destinationEmitError);
                this._source.removeListener('readable', $bc30a5f56b97f787$var$destinationSetReadable);
                delete this._source[$aafx9.DESTINATION];
                this._source.destroy();
                (0, $fXhL4._)((0, $hxFDX._)(ClosableIterator.prototype), "_end", this).call(this, destroy);
            }
        }
    ]);
    return ClosableIterator;
}($aafx9.AsyncIterator);
module.exports.ClosableIterator = $bc30a5f56b97f787$var$ClosableIterator;
// Helpers below are copied from AsyncIterator, as they are not exported from there.
function $bc30a5f56b97f787$var$destinationSetReadable() {
    this[$aafx9.DESTINATION].readable = true;
}
function $bc30a5f56b97f787$var$destinationEmitError(error) {
    this[$aafx9.DESTINATION].emit('error', error);
}
function $bc30a5f56b97f787$var$destinationClose() {
    this[$aafx9.DESTINATION].close();
}

});

parcelRegister("33GpH", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClosableTransformIterator = void 0;

var $aafx9 = parcelRequire("aafx9");
/**
 * A TransformIterator with a callback for when this iterator is closed in any way.
 */ var $23a28d5ddc9800e3$var$ClosableTransformIterator = /*#__PURE__*/ function(_asynciterator_1_TransformIterator) {
    (0, $i3fW3._)(ClosableTransformIterator, _asynciterator_1_TransformIterator);
    function ClosableTransformIterator(source, options) {
        (0, $jGAMp._)(this, ClosableTransformIterator);
        var _this;
        _this = (0, $kzDuW._)(this, ClosableTransformIterator, [
            source,
            options
        ]);
        _this.onClose = options.onClose;
        return _this;
    }
    (0, $byiyg._)(ClosableTransformIterator, [
        {
            key: "_end",
            value: function _end(destroy) {
                this.onClose();
                (0, $fXhL4._)((0, $hxFDX._)(ClosableTransformIterator.prototype), "_end", this).call(this, destroy);
            }
        }
    ]);
    return ClosableTransformIterator;
}($aafx9.TransformIterator);
module.exports.ClosableTransformIterator = $23a28d5ddc9800e3$var$ClosableTransformIterator;

});

parcelRegister("4XDMh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.instrumentIterator = void 0;
/**
 * Profile an iterator by monkey-patching its `_read` and `read` methods.
 * @param iterator
 */ function $39cb871f823f449f$var$instrumentIterator(iterator) {
    var counters = {
        count: 0,
        timeSelf: 0,
        timeLife: 0
    };
    $39cb871f823f449f$var$instrumentIteratorInner(iterator, counters, true);
    return new Promise(function(resolve) {
        iterator.on('end', function() {
            resolve(counters);
        });
    });
}
module.exports.instrumentIterator = $39cb871f823f449f$var$instrumentIterator;
function $39cb871f823f449f$var$instrumentIteratorInner(iterator, counter, top) {
    if (!('_profileInstrumented' in iterator)) {
        // Only patch an iterator once.
        iterator._profileInstrumented = true;
        // Patch _read
        if ('_read' in iterator) {
            var readOld = iterator._read;
            iterator._read = function(count, done) {
                var startTime = performance.now();
                readOld.call(iterator, count, function() {
                    counter.timeSelf += performance.now() - startTime;
                    done();
                });
            };
        }
        // Patch read
        if ('read' in iterator) {
            // eslint-disable-next-line ts/unbound-method
            var readOld1 = iterator.read;
            iterator.read = function() {
                var startTime = performance.now();
                var ret = readOld1.call(iterator);
                if (top && ret) counter.count++;
                counter.timeSelf += performance.now() - startTime;
                return ret;
            };
        }
        // Measure total time
        if (top) {
            var startTime = performance.now();
            iterator.on('end', function() {
                counter.timeLife = performance.now() - startTime;
            });
        }
        // Also patch children
        if ('_source' in iterator) $39cb871f823f449f$var$instrumentIteratorInner(iterator._source, counter, false);
    }
}

});






parcelRegister("jPiTb", function(module, exports) {
"use strict";
var $e6f16eb38b186855$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6f16eb38b186855$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e6f16eb38b186855$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e6f16eb38b186855$var$__exportStar((parcelRequire("dPeSr")), module.exports);

});
parcelRegister("dPeSr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiEmpty = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica Multi Empty RDF Join Actor.
 */ var $a10b940f7096ebf2$var$ActorRdfJoinMultiEmpty = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMultiEmpty, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMultiEmpty(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMultiEmpty);
        return (0, $kzDuW._)(this, ActorRdfJoinMultiEmpty, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'multi-empty',
                canHandleUndefs: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMultiEmpty, [
        {
            key: "test",
            value: function test(action) {
                var _this = this;
                var _this1 = this, _superprop_get_test = function() {
                    return (0, $fXhL4._)((0, $hxFDX._)(ActorRdfJoinMultiEmpty.prototype), "test", _this);
                };
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                ];
                            case 1:
                                if (_state.sent().every(function(metadata) {
                                    return $17TpP.ActorRdfJoin.getCardinality(metadata).value > 0;
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only join entries where at least one is empty"))
                                ];
                                return [
                                    2,
                                    _superprop_get_test().call(_this1, action)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, dataFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // Close all entries
                            for(_iterator = action.entries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                entry = _step.value;
                                entry.output.bindingsStream.close();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        return [
                            2,
                            {
                                result: {
                                    bindingsStream: new $aafx9.ArrayIterator([], {
                                        autoStart: false
                                    }),
                                    metadata: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp, _, _1, _tmp1;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {
                                                            state: new $jZbVy.MetadataValidationState(),
                                                            cardinality: {
                                                                type: 'exact',
                                                                value: 0
                                                            }
                                                        };
                                                        _1 = (_ = $17TpP.ActorRdfJoin).joinVariables;
                                                        _tmp1 = [
                                                            dataFactory
                                                        ];
                                                        return [
                                                            4,
                                                            $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.variables = _1.apply(_, _tmp1.concat([
                                                                _state.sent()
                                                            ])), _tmp)
                                                        ];
                                                }
                                            });
                                        })();
                                    },
                                    type: 'bindings'
                                }
                            }
                        ];
                    });
                })();
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: 0,
                                persistedItems: 0,
                                blockingItems: 0,
                                requestTime: 0
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinMultiEmpty;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMultiEmpty = $a10b940f7096ebf2$var$ActorRdfJoinMultiEmpty;

});


parcelRegister("g7Uez", function(module, exports) {
"use strict";
var $bbd8ebad2568d144$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbd8ebad2568d144$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbd8ebad2568d144$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bbd8ebad2568d144$var$__exportStar((parcelRequire("kGPxs")), module.exports);

});
parcelRegister("kGPxs", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinHash = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $45AY1 = parcelRequire("45AY1");

var $kQuvF = parcelRequire("kQuvF");

var $aafx9 = parcelRequire("aafx9");

var $16a9F = parcelRequire("16a9F");

var $gQYIc = parcelRequire("gQYIc");
/**
 * A comunica Hash RDF Join Actor.
 */ var $f0ffb55dd69bfe73$var$ActorRdfJoinHash = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinHash, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinHash(args) {
        (0, $jGAMp._)(this, ActorRdfJoinHash);
        return (0, $kzDuW._)(this, ActorRdfJoinHash, [
            args,
            {
                logicalType: 'inner',
                physicalName: "hash-".concat(args.canHandleUndefs ? 'undef' : 'def'),
                limitEntries: 2,
                requiresVariableOverlap: true,
                canHandleUndefs: args.canHandleUndefs
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinHash, [
        {
            key: "getOutput",
            value: function getOutput(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, metadatas, bindingsStream, variables, buffer, output, hashFunction, variablesRaw;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                metadatas = sideData.metadatas;
                                variables = $17TpP.ActorRdfJoin.overlappingVariables(metadatas);
                                if (!this.canHandleUndefs) return [
                                    3,
                                    1
                                ];
                                /* Handle undefined values in bindings */ buffer = sideData.entriesSorted[0].output;
                                output = sideData.entriesSorted[1].output;
                                bindingsStream = new $kQuvF.ClosableTransformIterator(function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var index;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // We index all bindings from the left-hand iterator first in a blocking manner.
                                                    index = new $45AY1.BindingsIndexUndef(variables, function(term) {
                                                        return term && term.termType !== 'Variable' ? (0, $gQYIc.termToString)(term) : '';
                                                    }, true);
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            buffer.bindingsStream.on('data', function(bindings) {
                                                                var _index_getFirst;
                                                                var iterator = (_index_getFirst = index.getFirst(bindings, false)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, []);
                                                                iterator.push(bindings);
                                                            });
                                                            buffer.bindingsStream.on('end', resolve);
                                                            buffer.bindingsStream.on('error', function(error) {
                                                                bindingsStream.emit('error', error);
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    // Start our left-hand iterator and try to join with the index
                                                    return [
                                                        2,
                                                        new $aafx9.MultiTransformIterator(output.bindingsStream, {
                                                            multiTransform: function(bindings) {
                                                                return new $aafx9.ArrayIterator(index.get(bindings).flat().map(function(indexBindings) {
                                                                    return $17TpP.ActorRdfJoin.joinBindings(bindings, indexBindings);
                                                                }).filter(function(b) {
                                                                    return b !== null;
                                                                }), {
                                                                    autoStart: false
                                                                });
                                                            },
                                                            autoStart: false
                                                        })
                                                    ];
                                            }
                                        });
                                    })();
                                }, {
                                    autoStart: false,
                                    onClose: function() {
                                        buffer.bindingsStream.destroy();
                                        output.bindingsStream.destroy();
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    this.mediatorHashBindings.mediate({
                                        context: action.context
                                    })
                                ];
                            case 2:
                                hashFunction = _state.sent().hashFunction;
                                variablesRaw = variables.map(function(v) {
                                    return v.variable;
                                });
                                bindingsStream = new $16a9F.HashJoin(sideData.entriesSorted[0].output.bindingsStream, sideData.entriesSorted[1].output.bindingsStream, function(entry) {
                                    return hashFunction(entry, variablesRaw);
                                }, $17TpP.ActorRdfJoin.joinBindings);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    this.constructResultMetadata(sideData.entriesSorted, metadatas, action.context)
                                                                ];
                                                            case 1:
                                                                return [
                                                                    2,
                                                                    _state.sent()
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var entriesSorted, metadatas, requestInitialTimes, requestItemTimes, iterations;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Ensure the left build stream is the smallest
                        entriesSorted = action.entries;
                        if (sideData.metadatas[1].cardinality.value < sideData.metadatas[0].cardinality.value) {
                            sideData.metadatas = [
                                sideData.metadatas[1],
                                sideData.metadatas[0]
                            ];
                            entriesSorted = [
                                action.entries[1],
                                action.entries[0]
                            ];
                        }
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
                        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
                        iterations *= 0.8;
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: iterations,
                                persistedItems: metadatas[0].cardinality.value,
                                blockingItems: metadatas[0].cardinality.value,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, (0, $emQHU._)((0, $iT0je._)({}, sideData), {
                                entriesSorted: entriesSorted
                            }))
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfJoinHash;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinHash = $f0ffb55dd69bfe73$var$ActorRdfJoinHash;

});
parcelRegister("45AY1", function(module, exports) {
"use strict";
var $2fa44df431d2f46f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fa44df431d2f46f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2fa44df431d2f46f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2fa44df431d2f46f$var$__exportStar((parcelRequire("elGvu")), module.exports);

$2fa44df431d2f46f$var$__exportStar((parcelRequire("ijMSI")), module.exports);

$2fa44df431d2f46f$var$__exportStar((parcelRequire("5Jtdo")), module.exports);

});
parcelRegister("elGvu", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsIndexDef = void 0;
/**
 * A simple efficient hash-based index for maintaining bindings,
 * and checking whether or not a bindings is contained in this index.
 *
 * This can not handle bindings with undefined values.
 */ var $a723ffd808d867ba$var$BindingsIndexDef = /*#__PURE__*/ function() {
    function BindingsIndexDef(keys, hashFn) {
        (0, $jGAMp._)(this, BindingsIndexDef);
        this.keys = keys.map(function(v) {
            return v.variable;
        });
        this.hashFn = hashFn;
        this.index = {};
    }
    (0, $byiyg._)(BindingsIndexDef, [
        {
            key: "put",
            value: function put(bindings, value) {
                return this.index[this.hashFn(bindings, this.keys)] = value;
            }
        },
        {
            key: "get",
            value: function get(bindings) {
                var v = this.getFirst(bindings);
                return v ? [
                    v
                ] : [];
            }
        },
        {
            key: "getFirst",
            value: function getFirst(bindings) {
                return this.index[this.hashFn(bindings, this.keys)];
            }
        },
        {
            key: "values",
            value: function values() {
                return Object.values(this.index);
            }
        }
    ]);
    return BindingsIndexDef;
}();
module.exports.BindingsIndexDef = $a723ffd808d867ba$var$BindingsIndexDef;

});

parcelRegister("ijMSI", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $1UYmo = parcelRequire("1UYmo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsIndexUndef = void 0;
/**
 * A simple efficient tree-based index for maintaining bindings,
 * and checking whether or not a bindings is contained in this index.
 *
 * This will consider bindings with a variable term or an undefined term
 * as a 'match-all' with other terms.
 */ var $d55feb33f9833305$var$BindingsIndexUndef = /*#__PURE__*/ function() {
    function BindingsIndexUndef(keys, hashFn, allowDisjointDomains) {
        (0, $jGAMp._)(this, BindingsIndexUndef);
        this.data = {};
        this.keys = keys.map(function(v) {
            return v.variable;
        });
        this.hashFn = hashFn;
        this.allowDisjointDomains = allowDisjointDomains && this.keys.length > 0;
    }
    (0, $byiyg._)(BindingsIndexUndef, [
        {
            /**
     * Add the given bindings to the index.
     * @param {Bindings} bindings A bindings.
     * @param {V} value The value to put.
     */ key: "put",
            value: function put(bindings, value) {
                if (this.allowDisjointDomains || this.isBindingsValid(bindings)) {
                    var dataIt = this.data;
                    for(var i = 0; i < this.keys.length; i++){
                        var key = this.keys[i];
                        var dataKey = this.hashFn(bindings.get(key));
                        var subDataIt = dataIt[dataKey];
                        if (!subDataIt) subDataIt = dataIt[dataKey] = i === this.keys.length - 1 ? value : {};
                        dataIt = subDataIt;
                    }
                }
                return value;
            }
        },
        {
            key: "isBindingsValid",
            value: function isBindingsValid(bindings) {
                var validKeys = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (bindings.has(key)) {
                            validKeys = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return validKeys;
            }
        },
        {
            /**
     * Get the value of the given bindings is contained in this index.
     * @param {Bindings} bindings A bindings.
     * @return {V[]} The values.
     */ key: "get",
            value: function get(bindings) {
                // Always return empty if the bindings contain none of the expected keys
                if (!(this.allowDisjointDomains || this.isBindingsValid(bindings))) return [];
                return this.getRecursive(bindings, this.keys, [
                    this.data
                ]);
            }
        },
        {
            key: "getRecursive",
            value: function getRecursive(bindings, keys, dataIndexes) {
                if (keys.length === 0) return dataIndexes;
                var key;
                var ref;
                // eslint-disable-next-line prefer-const
                ref = (0, $1UYmo._)(keys), key = ref[0], keys = ref.slice(1), ref;
                var matchingRecursive = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = dataIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var data = _step.value;
                        // If the index contained a variable, all terms will match.
                        var dataKey = this.hashFn(bindings === null || bindings === void 0 ? void 0 : bindings.get(key));
                        if (dataKey) {
                            // Check the entry for the term, and the variable term.
                            var subDatas = [
                                data[dataKey],
                                data['']
                            ].filter(Boolean);
                            if (subDatas.length === 0) continue;
                            matchingRecursive.push(this.getRecursive(bindings, keys, subDatas));
                        } else {
                            // Iterate over all entries
                            var subDatas1 = Object.values(data);
                            if (subDatas1.length === 0) continue;
                            matchingRecursive.push(this.getRecursive(bindings, keys, subDatas1));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return matchingRecursive.flat();
            }
        },
        {
            /**
     * Get the first value of the given bindings is contained in this index.
     * @param {Bindings} bindings A bindings.
     * @param matchUndefsAsWildcard If undefs in the given bindings should match with any existing values.
     *                              Otherwise, undefs will only match values that were inserted as undefs.
     * @return {V | undefined} The value.
     */ key: "getFirst",
            value: function getFirst(bindings) {
                var matchUndefsAsWildcard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                // Always return undefined if the bindings contain none of the expected keys
                if (!(this.allowDisjointDomains || this.isBindingsValid(bindings))) return undefined;
                return this.getRecursiveFirst(bindings, this.keys, [
                    this.data
                ], matchUndefsAsWildcard);
            }
        },
        {
            key: "getRecursiveFirst",
            value: function getRecursiveFirst(bindings, keys, dataIndexes, matchUndefsAsWildcard) {
                if (keys.length === 0) return dataIndexes[0];
                var key;
                var ref;
                // eslint-disable-next-line prefer-const
                ref = (0, $1UYmo._)(keys), key = ref[0], keys = ref.slice(1), ref;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = dataIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var data = _step.value;
                        // If the index contained a variable, all terms will match.
                        var dataKey = this.hashFn(bindings.get(key));
                        if (dataKey || !matchUndefsAsWildcard) {
                            // Check the entry for the term, and the variable term.
                            var subDatas = [
                                data[dataKey],
                                data['']
                            ].filter(Boolean);
                            if (subDatas.length === 0) continue;
                            var ret = this.getRecursiveFirst(bindings, keys, subDatas, matchUndefsAsWildcard);
                            if (ret) return ret;
                        } else {
                            // Iterate over all entries
                            var subDatas1 = Object.values(data);
                            if (subDatas1.length === 0) continue;
                            var ret1 = this.getRecursiveFirst(bindings, keys, subDatas1, matchUndefsAsWildcard);
                            if (ret1) return ret1;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        },
        {
            key: "values",
            value: function values() {
                return this.keys.length === 0 ? [] : this.getRecursive(undefined, this.keys, [
                    this.data
                ]);
            }
        }
    ]);
    return BindingsIndexUndef;
}();
module.exports.BindingsIndexUndef = $d55feb33f9833305$var$BindingsIndexUndef;

});

parcelRegister("5Jtdo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("16a9F", function(module, exports) {

var $7vURV = parcelRequire("7vURV");

var $h7HdQ = parcelRequire("h7HdQ");

var $3d1rB = parcelRequire("3d1rB");

var $k02Db = parcelRequire("k02Db");

var $9T73G = parcelRequire("9T73G");
module.exports = {
    DynamicNestedLoopJoin: $7vURV,
    HashJoin: $h7HdQ,
    NestedLoopJoin: $3d1rB,
    SymmetricHashJoin: $k02Db,
    MergeStream: $9T73G
};

});
parcelRegister("7vURV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $aafx9 = parcelRequire("aafx9");
var $57878a96dc8ac095$var$MultiTransformIterator = $aafx9.MultiTransformIterator;
var $57878a96dc8ac095$var$SimpleTransformIterator = $aafx9.SimpleTransformIterator;
// Nested Loop Join, but the values of the inner loop are determined by each value of the outer loop, possibly reducing the number of necessary checks
var $57878a96dc8ac095$var$DynamicNestedLoopJoin = /*#__PURE__*/ function(MultiTransformIterator) {
    "use strict";
    (0, $i3fW3._)(DynamicNestedLoopJoin, MultiTransformIterator);
    function DynamicNestedLoopJoin(left, funRight, funJoin, options) {
        (0, $jGAMp._)(this, DynamicNestedLoopJoin);
        var _this;
        _this = (0, $kzDuW._)(this, DynamicNestedLoopJoin, [
            left,
            options
        ]);
        _this.funRight = funRight;
        _this.funJoin = funJoin;
        return _this;
    }
    (0, $byiyg._)(DynamicNestedLoopJoin, [
        {
            key: "_createTransformer",
            value: function _createTransformer(leftItem) {
                var _this = this;
                return new $57878a96dc8ac095$var$SimpleTransformIterator(this.funRight(leftItem), {
                    transform: function(rightItem, done, push) {
                        var result = _this.funJoin(leftItem, rightItem);
                        if (result !== null) push(result);
                        done();
                    }
                });
            }
        }
    ]);
    return DynamicNestedLoopJoin;
}($57878a96dc8ac095$var$MultiTransformIterator);
module.exports = $57878a96dc8ac095$var$DynamicNestedLoopJoin;

});

parcelRegister("h7HdQ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $aafx9 = parcelRequire("aafx9");
var $c7749e2b91b859be$require$AsyncIterator = $aafx9.AsyncIterator;
// https://en.wikipedia.org/wiki/Hash_join
var $c7749e2b91b859be$var$HashJoin = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(HashJoin, AsyncIterator);
    function HashJoin(left, right, funHash, funJoin) {
        (0, $jGAMp._)(this, HashJoin);
        var _this;
        var allowJoining = function allowJoining() {
            var _this = this;
            this.readable = true;
            this.right.on('readable', function() {
                return _this.readable = true;
            });
            this.right.on('end', function() {
                if (!_this.hasResults()) _this._end();
            });
        };
        _this = (0, $kzDuW._)(this, HashJoin);
        _this.addedDataListener = false;
        _this.left = left;
        _this.right = right;
        _this.funHash = funHash;
        _this.funJoin = funJoin;
        _this.leftMap = new Map();
        _this.match = null;
        _this.matches = [];
        _this.matchIdx = 0;
        _this.left.on('error', function(error) {
            return _this.destroy(error);
        });
        _this.right.on('error', function(error) {
            return _this.destroy(error);
        });
        _this.readable = false;
        _this.left.on('end', allowJoining.bind(_this));
        _this.on('newListener', function(eventName) {
            if (eventName === 'data') _this._addDataListenerIfNeeded();
        });
        if (_this.left.readable) _this._addDataListenerIfNeeded();
        _this.left.on('readable', function() {
            return _this._addDataListenerIfNeeded();
        });
        return _this;
    }
    (0, $byiyg._)(HashJoin, [
        {
            key: "hasResults",
            value: function hasResults() {
                return !this.right.ended || this.matchIdx < this.matches.length;
            }
        },
        {
            key: "_end",
            value: function _end() {
                (0, $fXhL4._)((0, $hxFDX._)(HashJoin.prototype), "_end", this).call(this);
                this.left.destroy();
                this.right.destroy();
            }
        },
        {
            key: "read",
            value: function read() {
                this._addDataListenerIfNeeded();
                while(true){
                    if (this.ended || !this.readable) return null;
                    while(this.matchIdx < this.matches.length){
                        var item = this.matches[this.matchIdx++];
                        var result = this.funJoin(item, this.match);
                        if (result !== null) return result;
                    }
                    if (!this.hasResults()) this._end();
                    this.match = this.right.read();
                    if (this.match === null) {
                        this.readable = false;
                        return null;
                    }
                    var hash = this.funHash(this.match);
                    this.matches = this.leftMap.get(hash) || [];
                    this.matchIdx = 0;
                }
            }
        },
        {
            key: "_addDataListenerIfNeeded",
            value: function _addDataListenerIfNeeded() {
                if (!this.addedDataListener) {
                    this.addedDataListener = true;
                    this._addDataListener();
                }
            }
        },
        {
            key: "_addDataListener",
            value: function _addDataListener() {
                this.left.on('data', addItem.bind(this));
                function addItem(item) {
                    var hash = this.funHash(item);
                    var arr = this.leftMap.get(hash);
                    if (!arr) {
                        arr = [];
                        this.leftMap.set(hash, arr);
                    }
                    arr.push(item);
                }
            }
        }
    ]);
    return HashJoin;
}($c7749e2b91b859be$require$AsyncIterator);
module.exports = $c7749e2b91b859be$var$HashJoin;

});

parcelRegister("3d1rB", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $aafx9 = parcelRequire("aafx9");
var $2563b4c3b243015a$var$MultiTransformIterator = $aafx9.MultiTransformIterator, $2563b4c3b243015a$var$SimpleTransformIterator = $aafx9.SimpleTransformIterator, $2563b4c3b243015a$var$scheduleTask = $aafx9.scheduleTask;
// https://en.wikipedia.org/wiki/Nested_loop_join
var $2563b4c3b243015a$var$NestedLoopJoin = /*#__PURE__*/ function(MultiTransformIterator) {
    "use strict";
    (0, $i3fW3._)(NestedLoopJoin, MultiTransformIterator);
    function NestedLoopJoin(left, right, funJoin, options) {
        (0, $jGAMp._)(this, NestedLoopJoin);
        var _this;
        _this = (0, $kzDuW._)(this, NestedLoopJoin, [
            left,
            options
        ]);
        _this.right = right;
        _this.funJoin = funJoin; // function that joins 2 elements or returns null if join is not possible
        _this.on('end', function() {
            return _this.right.close();
        });
        return _this;
    }
    (0, $byiyg._)(NestedLoopJoin, [
        {
            key: "_end",
            value: function _end() {
                var _this = this;
                (0, $fXhL4._)((0, $hxFDX._)(NestedLoopJoin.prototype), "_end", this).call(this);
                $2563b4c3b243015a$var$scheduleTask(function() {
                    return _this.right.destroy();
                });
            }
        },
        {
            key: "_createTransformer",
            value: function _createTransformer(leftItem) {
                var _this = this;
                return new $2563b4c3b243015a$var$SimpleTransformIterator(this.right.clone(), {
                    transform: function(rightItem, done, push) {
                        var result = _this.funJoin(leftItem, rightItem);
                        if (result !== null) push(result);
                        done();
                    }
                });
            }
        }
    ]);
    return NestedLoopJoin;
}($2563b4c3b243015a$var$MultiTransformIterator);
module.exports = $2563b4c3b243015a$var$NestedLoopJoin;

});

parcelRegister("k02Db", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $aafx9 = parcelRequire("aafx9");
var $e8f5d92ea31b2892$require$AsyncIterator = $aafx9.AsyncIterator;
// https://en.wikipedia.org/wiki/Symmetric_Hash_Join
var $e8f5d92ea31b2892$var$SymmetricHashJoin = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(SymmetricHashJoin, AsyncIterator);
    function SymmetricHashJoin(left, right, funHash, funJoin) {
        (0, $jGAMp._)(this, SymmetricHashJoin);
        var _this;
        _this = (0, $kzDuW._)(this, SymmetricHashJoin);
        _this.left = left;
        _this.right = right;
        _this.funHash = funHash;
        _this.funJoin = funJoin;
        _this.usedLeft = false;
        _this.leftMap = new Map();
        _this.rightMap = new Map();
        _this.on('end', function() {
            return _this._cleanup();
        });
        _this.match = null;
        _this.matches = [];
        _this.matchIdx = 0;
        if (_this.left.readable || _this.right.readable) _this.readable = true;
        _this.left.on('error', function(error) {
            return _this.destroy(error);
        });
        _this.right.on('error', function(error) {
            return _this.destroy(error);
        });
        _this.left.on('readable', function() {
            return _this.readable = true;
        });
        _this.right.on('readable', function() {
            return _this.readable = true;
        });
        // this needs to be here since it's possible the left/right streams only get ended after there are no more results left
        _this.left.on('end', function() {
            if (!_this.hasResults()) _this._end();
        });
        _this.right.on('end', function() {
            if (!_this.hasResults()) _this._end();
        });
        return _this;
    }
    (0, $byiyg._)(SymmetricHashJoin, [
        {
            key: "hasResults",
            value: function hasResults() {
                // The "!!this.match" condition was added as a workaround to race
                // conditions and/or duplicate "end" events that may lead to premature
                // cleanups of the "this.matches" array.
                // See https://github.com/joachimvh/asyncjoin/issues/7
                return !this.left.ended || !this.right.ended || !!this.matches && this.matchIdx < this.matches.length;
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup() {
                // motivate garbage collector to remove these
                this.leftMap = null;
                this.rightMap = null;
                this.matches = null;
            }
        },
        {
            key: "_end",
            value: function _end() {
                (0, $fXhL4._)((0, $hxFDX._)(SymmetricHashJoin.prototype), "_end", this).call(this);
                this.left.destroy();
                this.right.destroy();
            }
        },
        {
            key: "read",
            value: function read() {
                while(true){
                    if (this.ended) return null;
                    while(this.matchIdx < this.matches.length){
                        var item = this.matches[this.matchIdx++];
                        var result = this.usedLeft ? this.funJoin(this.match, item) : this.funJoin(item, this.match);
                        if (result !== null) return result;
                    }
                    if (!this.hasResults()) this._end();
                    var item1 = null;
                    // try both streams if the first one has no value
                    for(var i = 0; i < 2; ++i){
                        item1 = this.usedLeft ? this.right.read() : this.left.read();
                        this.usedLeft = !this.usedLeft; // try other stream next time
                        // found a result, no need to check the other stream this run
                        if (item1 !== null) break;
                    }
                    if (this.done || item1 === null) {
                        this.readable = false;
                        return null;
                    }
                    var hash = this.funHash(item1);
                    if (this.usedLeft && this.right.done) this.leftMap = null;
                    else if (this.left.done) this.rightMap = null;
                    else {
                        var map = this.usedLeft ? this.leftMap : this.rightMap;
                        if (!map.has(hash)) map.set(hash, []);
                        var arr = map.get(hash);
                        if (!arr) {
                            arr = [];
                            map.set(hash, arr);
                        }
                        arr.push(item1);
                    }
                    this.match = item1;
                    this.matches = (this.usedLeft ? this.rightMap : this.leftMap).get(hash) || [];
                    this.matchIdx = 0;
                }
            }
        }
    ]);
    return SymmetricHashJoin;
}($e8f5d92ea31b2892$require$AsyncIterator);
module.exports = $e8f5d92ea31b2892$var$SymmetricHashJoin;

});

parcelRegister("9T73G", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $aafx9 = parcelRequire("aafx9");
var $732eb9c5c0423097$require$AsyncIterator = $aafx9.AsyncIterator;
// merges the contents of multiple streams
var $732eb9c5c0423097$var$MergeIterator = /*#__PURE__*/ function(AsyncIterator) {
    "use strict";
    (0, $i3fW3._)(MergeIterator, AsyncIterator);
    function MergeIterator(streams) {
        (0, $jGAMp._)(this, MergeIterator);
        var _this;
        _this = (0, $kzDuW._)(this, MergeIterator);
        if (!Array.isArray(streams)) streams = Array.prototype.slice.call(arguments);
        _this.streams = streams;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var stream = _step.value;
                stream.on('readable', function() {
                    return _this.emit('readable');
                });
                stream.on('end', function() {
                    return _this._removeStream(stream);
                });
            };
            for(var _iterator = streams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (_this.streams.length === 0) _this.close();
        _this.idx = _this.streams.length - 1;
        return _this;
    }
    (0, $byiyg._)(MergeIterator, [
        {
            key: "_removeStream",
            value: function _removeStream(stream) {
                var idx = this.streams.indexOf(stream);
                if (idx < 0) return;
                this.streams.splice(idx, 1);
                if (this.idx >= this.streams.length) --this.idx;
                if (this.streams.length === 0) this._end();
            }
        },
        {
            key: "close",
            value: function close() {
                (0, $fXhL4._)((0, $hxFDX._)(MergeIterator.prototype), "close", this).call(this);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.streams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var stream = _step.value;
                        stream.close();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "read",
            value: function read() {
                for(var attempts = 0; attempts < this.streams.length; ++attempts){
                    this.idx = (this.idx + 1) % this.streams.length;
                    var item = this.streams[this.idx].read();
                    if (item !== null) return item;
                }
                return null;
            }
        }
    ]);
    return MergeIterator;
}($732eb9c5c0423097$require$AsyncIterator);
module.exports = $732eb9c5c0423097$var$MergeIterator;

});




parcelRegister("3hhVx", function(module, exports) {
"use strict";
var $2630dd9686686136$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2630dd9686686136$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2630dd9686686136$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2630dd9686686136$var$__exportStar((parcelRequire("cBkcx")), module.exports);

});
parcelRegister("cBkcx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSymmetricHash = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $16a9F = parcelRequire("16a9F");
/**
 * A comunica Hash RDF Join Actor.
 */ var $92c89c4cdae9150c$var$ActorRdfJoinSymmetricHash = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinSymmetricHash, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinSymmetricHash(args) {
        (0, $jGAMp._)(this, ActorRdfJoinSymmetricHash);
        return (0, $kzDuW._)(this, ActorRdfJoinSymmetricHash, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'symmetric-hash',
                limitEntries: 2,
                requiresVariableOverlap: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinSymmetricHash, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, metadatas, variables, hashFunction, variablesRaw, join;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                ];
                            case 1:
                                metadatas = _state.sent();
                                variables = $17TpP.ActorRdfJoin.overlappingVariables(metadatas);
                                return [
                                    4,
                                    this.mediatorHashBindings.mediate({
                                        context: action.context
                                    })
                                ];
                            case 2:
                                hashFunction = _state.sent().hashFunction;
                                variablesRaw = variables.map(function(v) {
                                    return v.variable;
                                });
                                join = new $16a9F.SymmetricHashJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, function(entry) {
                                    return hashFunction(entry, variablesRaw);
                                }, $17TpP.ActorRdfJoin.joinBindings);
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: join,
                                            metadata: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    this.constructResultMetadata(action.entries, metadatas, action.context)
                                                                ];
                                                            case 1:
                                                                return [
                                                                    2,
                                                                    _state.sent()
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: metadatas[0].cardinality.value + metadatas[1].cardinality.value,
                                persistedItems: metadatas[0].cardinality.value + metadatas[1].cardinality.value,
                                blockingItems: 0,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinSymmetricHash;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinSymmetricHash = $92c89c4cdae9150c$var$ActorRdfJoinSymmetricHash;

});


parcelRegister("dr8ya", function(module, exports) {
"use strict";
var $9c846dda51d0b512$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9c846dda51d0b512$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9c846dda51d0b512$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9c846dda51d0b512$var$__exportStar((parcelRequire("hTPKU")), module.exports);

});
parcelRegister("hTPKU", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinNestedLoop = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $16a9F = parcelRequire("16a9F");
/**
 * A comunica NestedLoop RDF Join Actor.
 */ var $d07fb853665578cb$var$ActorRdfJoinNestedLoop = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinNestedLoop, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinNestedLoop(args) {
        (0, $jGAMp._)(this, ActorRdfJoinNestedLoop);
        return (0, $kzDuW._)(this, ActorRdfJoinNestedLoop, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'nested-loop',
                limitEntries: 2,
                canHandleUndefs: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinNestedLoop, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, join;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        join = new $16a9F.NestedLoopJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, $17TpP.ActorRdfJoin.joinBindings, {
                            autoStart: false
                        });
                        return [
                            2,
                            {
                                result: {
                                    type: 'bindings',
                                    bindingsStream: join,
                                    metadata: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _, _1, _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _1 = (_ = this).constructResultMetadata;
                                                        _tmp = [
                                                            action.entries
                                                        ];
                                                        return [
                                                            4,
                                                            $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                                        ];
                                                    case 1:
                                                        return [
                                                            4,
                                                            _1.apply(_, _tmp.concat([
                                                                _state.sent(),
                                                                action.context
                                                            ]))
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }
                                }
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value,
                                persistedItems: 0,
                                blockingItems: 0,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinNestedLoop;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinNestedLoop = $d07fb853665578cb$var$ActorRdfJoinNestedLoop;

});


parcelRegister("9stAK", function(module, exports) {
"use strict";
var $6e2daee3d0f185a0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e2daee3d0f185a0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e2daee3d0f185a0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e2daee3d0f185a0$var$__exportStar((parcelRequire("e4dE6")), module.exports);

});
parcelRegister("e4dE6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalHash = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $45AY1 = parcelRequire("45AY1");

var $kQuvF = parcelRequire("kQuvF");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");
/**
 * A comunica Optional Hash RDF Join Actor.
 */ var $a3dc06307ff76a48$var$ActorRdfJoinOptionalHash = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinOptionalHash, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinOptionalHash(args) {
        (0, $jGAMp._)(this, ActorRdfJoinOptionalHash);
        return (0, $kzDuW._)(this, ActorRdfJoinOptionalHash, [
            args,
            {
                logicalType: 'optional',
                physicalName: "hash-".concat(args.canHandleUndefs ? 'undef' : 'def', "-").concat(args.blocking ? 'blocking' : 'nonblocking'),
                limitEntries: 2,
                canHandleUndefs: args.canHandleUndefs,
                requiresVariableOverlap: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinOptionalHash, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, buffer, output, metadatas, commonVariables, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                buffer = action.entries[1].output;
                                output = action.entries[0].output;
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                ];
                            case 1:
                                metadatas = _state.sent();
                                commonVariables = $17TpP.ActorRdfJoin.overlappingVariables(metadatas);
                                if (this.blocking) // -- Blocking optional ---
                                bindingsStream = new $kQuvF.ClosableTransformIterator(function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var index;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // We index all bindings from the right-hand OPTIONAL iterator first in a blocking manner.
                                                    index = ActorRdfJoinOptionalHash.constructIndex(this.canHandleUndefs, commonVariables);
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            buffer.bindingsStream.on('data', function(bindings) {
                                                                var _index_getFirst;
                                                                var iterator = (_index_getFirst = index.getFirst(bindings, true)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, []);
                                                                iterator.push(bindings);
                                                            });
                                                            buffer.bindingsStream.on('end', resolve);
                                                            buffer.bindingsStream.on('error', function(error) {
                                                                bindingsStream.emit('error', error);
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    // Start our left-hand iterator and try to join with the index
                                                    return [
                                                        2,
                                                        new $aafx9.MultiTransformIterator(output.bindingsStream, {
                                                            multiTransform: function(bindings) {
                                                                return new $aafx9.ArrayIterator(index.get(bindings).flat().map(function(indexBindings) {
                                                                    return $17TpP.ActorRdfJoin.joinBindings(bindings, indexBindings);
                                                                }).filter(function(b) {
                                                                    return b !== null;
                                                                }), {
                                                                    autoStart: false
                                                                });
                                                            },
                                                            optional: true,
                                                            autoStart: false
                                                        })
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                }, {
                                    autoStart: false,
                                    onClose: function() {
                                        buffer.bindingsStream.destroy();
                                        output.bindingsStream.destroy();
                                    }
                                });
                                else // -- Non-blocking optional ---
                                // This can be slightly slower than the blocking one above, due to the streaming overhead.
                                bindingsStream = new $kQuvF.ClosableTransformIterator(function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var index, indexActive;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            // We index all bindings from the right-hand OPTIONAL iterator.
                                            // They are indexed with iterator values, so our main stream can already get started.
                                            index = ActorRdfJoinOptionalHash.constructIndex(this.canHandleUndefs, commonVariables);
                                            indexActive = true;
                                            buffer.bindingsStream.on('data', function(bindings) {
                                                var _index_getFirst;
                                                var iterator = (_index_getFirst = index.getFirst(bindings, true)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, new $aafx9.BufferedIterator({
                                                    autoStart: false
                                                }));
                                                iterator._push(bindings);
                                            });
                                            buffer.bindingsStream.on('end', function() {
                                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(var _iterator = index.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        var iterator = _step.value;
                                                        iterator.close();
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                            _iterator["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                indexActive = false;
                                            });
                                            buffer.bindingsStream.on('error', function(error) {
                                                bindingsStream.emit('error', error);
                                            });
                                            // Start our left-hand iterator and try to join with the index
                                            return [
                                                2,
                                                new $aafx9.MultiTransformIterator(output.bindingsStream, {
                                                    multiTransform: function(bindings) {
                                                        // Find iterators from the index
                                                        var iterators = index.get(bindings);
                                                        // If no index entry was found, set an empty iterator.
                                                        // If we index has been closed already, don't modify the index, but just use an empty dummy iterator.
                                                        if (iterators.length === 0) {
                                                            if (indexActive) iterators = [
                                                                index.put(bindings, new $aafx9.BufferedIterator({
                                                                    autoStart: false
                                                                }))
                                                            ];
                                                            else iterators = [];
                                                        }
                                                        // Merge all iterators in a single one,
                                                        // and clone each one to make sure we can still use them in the future.
                                                        var iterator = new $aafx9.UnionIterator(iterators.map(function(it) {
                                                            return it.clone();
                                                        }), {
                                                            autoStart: false
                                                        });
                                                        return iterator.map(function(indexBindings) {
                                                            return $17TpP.ActorRdfJoin.joinBindings(bindings, indexBindings);
                                                        });
                                                    },
                                                    optional: true,
                                                    autoStart: false
                                                })
                                            ];
                                        });
                                    }).call(_this);
                                }, {
                                    autoStart: false,
                                    onClose: function() {
                                        buffer.bindingsStream.destroy();
                                        output.bindingsStream.destroy();
                                    }
                                });
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    this.constructResultMetadata(action.entries, metadatas, action.context, {}, true)
                                                                ];
                                                            case 1:
                                                                return [
                                                                    2,
                                                                    _state.sent()
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes, iterations;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
                        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
                        iterations *= 0.8;
                        if (this.blocking) // Our blocking implementation is slightly more performant.
                        iterations *= 0.9;
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: iterations,
                                persistedItems: metadatas[0].cardinality.value,
                                blockingItems: this.blocking ? metadatas[0].cardinality.value : 0,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, sideData)
                        ];
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "constructIndex",
            value: function constructIndex(undef, commonVariables) {
                return undef ? new $45AY1.BindingsIndexUndef(commonVariables, function(term) {
                    return term && term.termType !== 'Variable' ? (0, $gQYIc.termToString)(term) : '';
                }, true) : new $45AY1.BindingsIndexDef(commonVariables, $itFzw.bindingsToCompactString);
            }
        }
    ]);
    return ActorRdfJoinOptionalHash;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinOptionalHash = $a3dc06307ff76a48$var$ActorRdfJoinOptionalHash;

});
parcelRegister("itFzw", function(module, exports) {
"use strict";
var $d73b2ec30c3633e2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d73b2ec30c3633e2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d73b2ec30c3633e2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d73b2ec30c3633e2$var$__exportStar((parcelRequire("ewJCk")), module.exports);

$d73b2ec30c3633e2$var$__exportStar((parcelRequire("dhTJ0")), module.exports);

$d73b2ec30c3633e2$var$__exportStar((parcelRequire("fQhbK")), module.exports);

});
parcelRegister("ewJCk", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bindings = void 0;

var $kNNoa = parcelRequire("kNNoa");

var $ejkDQ = parcelRequire("ejkDQ");

var $fQhbK = parcelRequire("fQhbK");
/**
 * An immutable.js-based Bindings object.
 */ var $a9377075e779d879$var$Bindings = /*#__PURE__*/ function() {
    function Bindings(dataFactory, entries, contextHolder) {
        (0, $jGAMp._)(this, Bindings);
        this.type = 'bindings';
        this.dataFactory = dataFactory;
        this.entries = entries;
        this.contextHolder = contextHolder;
    }
    (0, $byiyg._)(Bindings, [
        {
            key: "has",
            value: function has(key) {
                return this.entries.has(typeof key === 'string' ? key : key.value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.entries.get(typeof key === 'string' ? key : key.value);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                return new Bindings(this.dataFactory, this.entries.set(typeof key === 'string' ? key : key.value, value), this.contextHolder);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return new Bindings(this.dataFactory, this.entries["delete"](typeof key === 'string' ? key : key.value), this.contextHolder);
            }
        },
        {
            key: "keys",
            value: function keys() {
                var _this = this;
                return this.mapIterable(this.iteratorToIterable(this.entries.keys()), function(key) {
                    return _this.dataFactory.variable(key);
                });
            }
        },
        {
            key: "values",
            value: function values() {
                return this.iteratorToIterable(this.entries.values());
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.entries.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        fn(value, this.dataFactory.variable(key));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "size",
            get: function get() {
                return this.entries.size;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                var _this = this;
                return this.mapIterable(this.iteratorToIterable(this.entries.entries()), function(param) {
                    var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                    return [
                        _this.dataFactory.variable(key),
                        value
                    ];
                })[Symbol.iterator]();
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                if (this === other) return true;
                // First check if size is equal
                if (this.size !== other.size) return false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Then check if keys and values are equal
                    for(var _iterator = this.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var _this_get;
                        if (!((_this_get = this.get(key)) === null || _this_get === void 0 ? void 0 : _this_get.equals(other.get(key)))) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this = this;
                return new Bindings(this.dataFactory, (0, $ejkDQ.Map)(this.entries.filter(function(value, key) {
                    return fn(value, _this.dataFactory.variable(key));
                })), this.contextHolder);
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this = this;
                return new Bindings(this.dataFactory, (0, $ejkDQ.Map)(this.entries.map(function(value, key) {
                    return fn(value, _this.dataFactory.variable(key));
                })), this.contextHolder);
            }
        },
        {
            key: "merge",
            value: function merge(other) {
                if (this.size < other.size && other instanceof Bindings) return other.merge(this);
                var entries = this.entries;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                // Check if other is of type Bindings, in that case we can access entries immediately.
                // This skips the unnecessary conversion from string to variable.
                if (other instanceof Bindings) try {
                    for(var _iterator = other.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), variable = _step_value[0], right = _step_value[1];
                        var left = this.entries.get(variable);
                        if (left && !left.equals(right)) return;
                        entries = entries.set(variable, right);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else try {
                    for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $32TW8._)(_step1.value, 2), variable1 = _step_value1[0], right1 = _step_value1[1];
                        var left1 = this.entries.get(variable1.value);
                        if (left1 && !left1.equals(right1)) return;
                        entries = entries.set(variable1.value, right1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return this.createBindingsWithContexts(entries, other);
            }
        },
        {
            key: "mergeWith",
            value: function mergeWith(merger, other) {
                if (this.size < other.size && other instanceof Bindings) return other.mergeWith(merger, this);
                var entries = this.entries;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                // For code comments see Bindings.merge function
                if (other instanceof Bindings) try {
                    for(var _iterator = other.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), variable = _step_value[0], right = _step_value[1];
                        var left = this.entries.get(variable);
                        var value = void 0;
                        if (left && !left.equals(right)) value = merger(left, right, this.dataFactory.variable(variable));
                        else value = right;
                        entries = entries.set(variable, value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else try {
                    for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $32TW8._)(_step1.value, 2), variable1 = _step_value1[0], right1 = _step_value1[1];
                        var left1 = this.entries.get(variable1.value);
                        var value1 = void 0;
                        if (left1 && !left1.equals(right1)) value1 = merger(left1, right1, variable1);
                        else value1 = right1;
                        entries = entries.set(variable1.value, value1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return this.createBindingsWithContexts(entries, other);
            }
        },
        {
            key: "createBindingsWithContexts",
            value: function createBindingsWithContexts(entries, other) {
                // If any context is empty, we skip merging contexts
                if (this.contextHolder && this.contextHolder.context) {
                    var mergedContext = this.contextHolder.context;
                    // Only merge if the other has a context
                    if ('contextHolder' in other && other.contextHolder && other.contextHolder.context) mergedContext = Bindings.mergeContext(this.contextHolder.contextMergeHandlers, mergedContext, other.contextHolder.context);
                    return new Bindings(this.dataFactory, entries, {
                        contextMergeHandlers: this.contextHolder.contextMergeHandlers,
                        context: mergedContext
                    });
                }
                // Otherwise, use optional context from other
                return new Bindings(this.dataFactory, entries, other.contextHolder);
            }
        },
        {
            key: "setContextEntry",
            value: function setContextEntry(key, value) {
                return this.setContextEntryRaw(key, value);
            }
        },
        {
            key: "setContextEntryRaw",
            value: function setContextEntryRaw(key, value) {
                var _this_contextHolder;
                if (this.contextHolder && this.contextHolder.context) return new Bindings(this.dataFactory, this.entries, {
                    contextMergeHandlers: this.contextHolder.contextMergeHandlers,
                    context: this.contextHolder.context.set(key, value)
                });
                var _this_contextHolder_contextMergeHandlers;
                return new Bindings(this.dataFactory, this.entries, {
                    contextMergeHandlers: (_this_contextHolder_contextMergeHandlers = (_this_contextHolder = this.contextHolder) === null || _this_contextHolder === void 0 ? void 0 : _this_contextHolder.contextMergeHandlers) !== null && _this_contextHolder_contextMergeHandlers !== void 0 ? _this_contextHolder_contextMergeHandlers : {},
                    context: new $kNNoa.ActionContext().set(key, value)
                });
            }
        },
        {
            key: "deleteContextEntry",
            value: function deleteContextEntry(key) {
                return this.deleteContextEntryRaw(key);
            }
        },
        {
            key: "deleteContextEntryRaw",
            value: function deleteContextEntryRaw(key) {
                var _this_contextHolder_context;
                if (this.contextHolder) return new Bindings(this.dataFactory, this.entries, {
                    contextMergeHandlers: this.contextHolder.contextMergeHandlers,
                    context: (_this_contextHolder_context = this.contextHolder.context) === null || _this_contextHolder_context === void 0 ? void 0 : _this_contextHolder_context["delete"](key)
                });
                return new Bindings(this.dataFactory, this.entries);
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                var _this_contextHolder;
                return (_this_contextHolder = this.contextHolder) === null || _this_contextHolder === void 0 ? void 0 : _this_contextHolder.context;
            }
        },
        {
            key: "getContextEntry",
            value: function getContextEntry(key) {
                var _this_getContext;
                return (_this_getContext = this.getContext()) === null || _this_getContext === void 0 ? void 0 : _this_getContext.get(key);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return (0, $fQhbK.bindingsToString)(this);
            }
        },
        {
            key: "mapIterable",
            value: function mapIterable(iterable, callback) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = iterable[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            x = _step.value;
                            return [
                                4,
                                callback(x)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "iteratorToIterable",
            value: function iteratorToIterable(iterator) {
                return (0, $cqEAj._)({}, Symbol.iterator, function() {
                    return iterator;
                });
            }
        }
    ], [
        {
            key: "mergeContext",
            value: function mergeContext(contextMergeHandlers, context, otherContext) {
                // All keys can contain duplicates, we prevent this by checking our built datamap for duplicates
                var allKeys = (0, $7WNf6._)(context.keys()).concat((0, $7WNf6._)(otherContext.keys()));
                // Map we build up with merged context values
                var newContextData = {};
                var handledKeys = {};
                // Set of names of keys in other context to allow for constant time lookup
                var keysSetOtherContext = new Set(otherContext.keys().map(function(key) {
                    return key.name;
                }));
                var keysBothContext = context.keys().filter(function(key) {
                    return keysSetOtherContext.has(key.name);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var key = _step.value;
                        // If duplicate key, we continue iterating
                        if (handledKeys[key.name] === 1) return "continue";
                        // We've processed this key and shouldn't repeat it
                        handledKeys[key.name] = 1;
                        // Determine whether this key occurs in both contexts
                        var occursInBoth = keysBothContext.some(function(x) {
                            return x.name === key.name;
                        });
                        // If we execute this function, we already check for existence of context merge handlers
                        // This if statement is first as the most likely case for non-empty contexts is that we have mergehandlers
                        // and both contexts have an entry
                        if (contextMergeHandlers[key.name] && occursInBoth) {
                            newContextData[key.name] = contextMergeHandlers[key.name].run(context.get(key), otherContext.get(key));
                            return "continue";
                        }
                        // If we have no merge handler, but both contexts have entries for key, we don't add it to new context
                        if (!contextMergeHandlers[key.name] && occursInBoth) return "continue";
                        // If key doesn't occur in own context, it must be in other context
                        // (if we get to this point, the key doesn't occur in both)
                        if (!context.get(key)) {
                            newContextData[key.name] = otherContext.get(key);
                            return "continue";
                        }
                        // This could likely be else statement, but don't want to risk it
                        if (!otherContext.get(key)) newContextData[key.name] = context.get(key);
                    };
                    for(var _iterator = allKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new $kNNoa.ActionContext(newContextData);
            }
        }
    ]);
    return Bindings;
}();
module.exports.Bindings = $a9377075e779d879$var$Bindings;

});
parcelRegister("fQhbK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindingsToCompactString = module.exports.bindingsToString = void 0;

var $gQYIc = parcelRequire("gQYIc");
/**
 * Convert a bindings object to a human-readable string.
 * @param bindings A bindings object.
 */ function $b8890b99826f5e89$var$bindingsToString(bindings) {
    var raw = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = bindings.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            raw[key.value] = (0, $gQYIc.termToString)(bindings.get(key));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return JSON.stringify(raw, null, '  ');
}
module.exports.bindingsToString = $b8890b99826f5e89$var$bindingsToString;
/**
 * Convert a bindings object to a compact string.
 * This is mainly useful for internal indexing purposes.
 *
 * This function is guaranteed to not produce clashing bindings for unequal terms.
 *
 * This function will not sort the variables and expects them to be in the same order for every call.
 *
 * @param bindings A bindings object.
 * @param variables The variables to consider when converting the bindings to a string.
 */ function $b8890b99826f5e89$var$bindingsToCompactString(bindings, variables) {
    return variables.map(function(variable) {
        var term = bindings.get(variable);
        if (term) return (0, $gQYIc.termToString)(term);
        return '';
    }).join('');
}
module.exports.bindingsToCompactString = $b8890b99826f5e89$var$bindingsToCompactString;

});


parcelRegister("dhTJ0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsFactory = void 0;

var $ejkDQ = parcelRequire("ejkDQ");

var $ewJCk = parcelRequire("ewJCk");
/**
 * A Bindings factory that provides Bindings backed by immutable.js.
 */ var $9ac816b20a1db028$var$BindingsFactory = /*#__PURE__*/ function() {
    function BindingsFactory(dataFactory, contextMergeHandlers) {
        (0, $jGAMp._)(this, BindingsFactory);
        this.dataFactory = dataFactory;
        this.contextMergeHandlers = contextMergeHandlers;
    }
    (0, $byiyg._)(BindingsFactory, [
        {
            key: "bindings",
            value: function bindings() {
                var entries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                return new $ewJCk.Bindings(this.dataFactory, (0, $ejkDQ.Map)(entries.map(function(param) {
                    var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                    return [
                        key.value,
                        value
                    ];
                })), this.contextMergeHandlers ? {
                    contextMergeHandlers: this.contextMergeHandlers
                } : undefined);
            }
        },
        {
            key: "fromBindings",
            value: function fromBindings(bindings) {
                return this.bindings((0, $7WNf6._)(bindings));
            }
        },
        {
            key: "fromRecord",
            value: function fromRecord(record) {
                var _this = this;
                return this.bindings(Object.entries(record).map(function(param) {
                    var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                    return [
                        _this.dataFactory.variable(key),
                        value
                    ];
                }));
            }
        }
    ], [
        {
            key: "create",
            value: function create(mediatorMergeBindingsContext, context, dataFactory) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = BindingsFactory.bind;
                                _tmp = [
                                    void 0,
                                    dataFactory
                                ];
                                return [
                                    4,
                                    mediatorMergeBindingsContext.mediate({
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_.apply(BindingsFactory, _tmp.concat([
                                        _state.sent().mergeHandlers
                                    ])))
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BindingsFactory;
}();
module.exports.BindingsFactory = $9ac816b20a1db028$var$BindingsFactory;

});




parcelRegister("iMV5m", function(module, exports) {
"use strict";
var $dad8fda78bd36f2b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dad8fda78bd36f2b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dad8fda78bd36f2b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dad8fda78bd36f2b$var$__exportStar((parcelRequire("jZ7FX")), module.exports);

});
parcelRegister("jZ7FX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalNestedLoop = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $16a9F = parcelRequire("16a9F");
/**
 * A comunica Optional Nested Loop RDF Join Actor.
 */ var $e8c9ab0f0e89166a$var$ActorRdfJoinOptionalNestedLoop = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinOptionalNestedLoop, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinOptionalNestedLoop(args) {
        (0, $jGAMp._)(this, ActorRdfJoinOptionalNestedLoop);
        return (0, $kzDuW._)(this, ActorRdfJoinOptionalNestedLoop, [
            args,
            {
                logicalType: 'optional',
                physicalName: 'nested-loop',
                limitEntries: 2,
                canHandleUndefs: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinOptionalNestedLoop, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, join;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        join = new $16a9F.NestedLoopJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, $17TpP.ActorRdfJoin.joinBindings, {
                            optional: true,
                            autoStart: false
                        });
                        return [
                            2,
                            {
                                result: {
                                    type: 'bindings',
                                    bindingsStream: join,
                                    metadata: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _, _1, _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _1 = (_ = this).constructResultMetadata;
                                                        _tmp = [
                                                            action.entries
                                                        ];
                                                        return [
                                                            4,
                                                            $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                                        ];
                                                    case 1:
                                                        return [
                                                            4,
                                                            _1.apply(_, _tmp.concat([
                                                                _state.sent(),
                                                                action.context,
                                                                {},
                                                                true
                                                            ]))
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }
                                }
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value,
                                persistedItems: 0,
                                blockingItems: 0,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinOptionalNestedLoop;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinOptionalNestedLoop = $e8c9ab0f0e89166a$var$ActorRdfJoinOptionalNestedLoop;

});


parcelRegister("l8BQG", function(module, exports) {
"use strict";
var $f637b446ab530831$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f637b446ab530831$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f637b446ab530831$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f637b446ab530831$var$__exportStar((parcelRequire("5wnyk")), module.exports);

});
parcelRegister("5wnyk", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMinusHash = void 0;

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $45AY1 = parcelRequire("45AY1");

var $kQuvF = parcelRequire("kQuvF");

var $gQYIc = parcelRequire("gQYIc");
/**
 * A comunica Minus Hash RDF Join Actor.
 */ var $405235ff2b00822c$var$ActorRdfJoinMinusHash = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMinusHash, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMinusHash(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMinusHash);
        return (0, $kzDuW._)(this, ActorRdfJoinMinusHash, [
            args,
            {
                logicalType: 'minus',
                physicalName: "hash-".concat(args.canHandleUndefs ? 'undef' : 'def'),
                limitEntries: 2,
                canHandleUndefs: args.canHandleUndefs
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMinusHash, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, buffer, output, metadatas, commonVariables, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                buffer = action.entries[1].output;
                                output = action.entries[0].output;
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                ];
                            case 1:
                                metadatas = _state.sent();
                                commonVariables = $17TpP.ActorRdfJoin.overlappingVariables(metadatas);
                                // Destroy the buffer stream since it is not needed when
                                // there are no common variables.
                                if (commonVariables.length === 0) {
                                    buffer.bindingsStream.destroy();
                                    return [
                                        2,
                                        {
                                            result: output
                                        }
                                    ];
                                }
                                bindingsStream = new $kQuvF.ClosableTransformIterator(function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var index;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // We index all bindings from the buffer iterator first in a blocking manner.
                                                    index = ActorRdfJoinMinusHash.constructIndex(this.canHandleUndefs, commonVariables);
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            buffer.bindingsStream.on('data', function(bindings) {
                                                                return index.put(bindings, true);
                                                            });
                                                            buffer.bindingsStream.on('end', resolve);
                                                            buffer.bindingsStream.on('error', function(error) {
                                                                return bindingsStream.emit('error', error);
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    // From the left-hand iterator filter out all entries of the index
                                                    return [
                                                        2,
                                                        output.bindingsStream.filter(function(bindings) {
                                                            return !index.getFirst(bindings, true);
                                                        })
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                }, {
                                    autoStart: false,
                                    onClose: function() {
                                        buffer.bindingsStream.destroy();
                                        output.bindingsStream.destroy();
                                    }
                                });
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: output.metadata
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes, iterations;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        metadatas = sideData.metadatas;
                        requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                        requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                        iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
                        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
                        iterations *= 0.8;
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: iterations,
                                persistedItems: metadatas[0].cardinality.value,
                                blockingItems: metadatas[0].cardinality.value,
                                requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
                            }, sideData)
                        ];
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "constructIndex",
            value: function constructIndex(undef, commonVariables) {
                return undef ? new $45AY1.BindingsIndexUndef(commonVariables, function(term) {
                    return term && term.termType !== 'Variable' ? (0, $gQYIc.termToString)(term) : '';
                }, false) : new $45AY1.BindingsIndexDef(commonVariables, $itFzw.bindingsToCompactString);
            }
        }
    ]);
    return ActorRdfJoinMinusHash;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMinusHash = $405235ff2b00822c$var$ActorRdfJoinMinusHash;

});


parcelRegister("6SuO1", function(module, exports) {
"use strict";
var $501fae9c673d41ea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $501fae9c673d41ea$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $501fae9c673d41ea$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$501fae9c673d41ea$var$__exportStar((parcelRequire("9tzdO")), module.exports);

});
parcelRegister("9tzdO", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceRdfParse = void 0;

var $gxXo4 = parcelRequire("gxXo4");
/**
 * A comunica Parse Dereference RDF Actor.
 */ var $6e6224c934c26720$var$ActorDereferenceRdfParse = /*#__PURE__*/ function(_bus_dereference_rdf_1_ActorDereferenceRdf) {
    (0, $i3fW3._)(ActorDereferenceRdfParse, _bus_dereference_rdf_1_ActorDereferenceRdf);
    function ActorDereferenceRdfParse(args) {
        (0, $jGAMp._)(this, ActorDereferenceRdfParse);
        return (0, $kzDuW._)(this, ActorDereferenceRdfParse, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereferenceRdfParse, [
        {
            key: "getMetadata",
            value: function getMetadata(dereference) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                baseIRI: dereference.url
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorDereferenceRdfParse;
}($gxXo4.ActorDereferenceRdf);
module.exports.ActorDereferenceRdfParse = $6e6224c934c26720$var$ActorDereferenceRdfParse;

});
parcelRegister("gxXo4", function(module, exports) {
"use strict";
var $c0bdcb7d90452917$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0bdcb7d90452917$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c0bdcb7d90452917$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c0bdcb7d90452917$var$__exportStar((parcelRequire("eI2JD")), module.exports);

});
parcelRegister("eI2JD", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceRdf = void 0;

var $9wyYb = parcelRequire("9wyYb");
/**
 * A base actor for dereferencing URLs to quad streams.
 *
 * Actor types:
 * * Input:  IActionDereferenceRdf:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceRdfOutput: A quad stream.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ var $ab574be48130ec08$var$ActorDereferenceRdf = /*#__PURE__*/ function(_bus_dereference_1_ActorDereferenceParse) {
    (0, $i3fW3._)(ActorDereferenceRdf, _bus_dereference_1_ActorDereferenceParse);
    function ActorDereferenceRdf(args) {
        (0, $jGAMp._)(this, ActorDereferenceRdf);
        return (0, $kzDuW._)(this, ActorDereferenceRdf, [
            args
        ]);
    }
    return ActorDereferenceRdf;
}($9wyYb.ActorDereferenceParse);
module.exports.ActorDereferenceRdf = $ab574be48130ec08$var$ActorDereferenceRdf;

});




parcelRegister("bptQC", function(module, exports) {
"use strict";
var $84e92ea3fe0e91c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84e92ea3fe0e91c6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $84e92ea3fe0e91c6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$84e92ea3fe0e91c6$var$__exportStar((parcelRequire("cILr7")), module.exports);

});
parcelRegister("cILr7", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlScript = void 0;

var $6JPXL = parcelRequire("6JPXL");

var $kNNoa = parcelRequire("kNNoa");

var $3lDnl = parcelRequire("3lDnl");
/**
 * A HTML script RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to extract and parse any RDF serialization from script tags in HTML files
 * and announce the presence of them by media type.
 */ var $942e63feb08f2da4$var$ActorRdfParseHtmlScript = /*#__PURE__*/ function(_bus_rdf_parse_html_1_ActorRdfParseHtml) {
    (0, $i3fW3._)(ActorRdfParseHtmlScript, _bus_rdf_parse_html_1_ActorRdfParseHtml);
    function ActorRdfParseHtmlScript(args) {
        (0, $jGAMp._)(this, ActorRdfParseHtmlScript);
        return (0, $kzDuW._)(this, ActorRdfParseHtmlScript, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseHtmlScript, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var supportedTypes, htmlParseListener;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorRdfParseMediatypes.mediate({
                                        context: action.context,
                                        mediaTypes: true
                                    })
                                ];
                            case 1:
                                supportedTypes = _state.sent().mediaTypes;
                                htmlParseListener = new $3lDnl.HtmlScriptListener(this.mediatorRdfParseHandle, action.emit, action.error, action.end, supportedTypes, action.context, action.baseIRI, action.headers);
                                return [
                                    2,
                                    {
                                        htmlParseListener: htmlParseListener
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfParseHtmlScript;
}($6JPXL.ActorRdfParseHtml);
module.exports.ActorRdfParseHtmlScript = $942e63feb08f2da4$var$ActorRdfParseHtmlScript;

});
parcelRegister("3lDnl", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HtmlScriptListener = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $jUMw3 = parcelRequire("jUMw3");

var $hDpjF = parcelRequire("hDpjF");
/**
 * An HTML parse listeners that detects <script> data blocks with known RDF media types,
 * parses them, and outputs the resulting quads.
 */ var $2701e06fde8eff40$var$HtmlScriptListener = /*#__PURE__*/ function() {
    function HtmlScriptListener(mediatorRdfParseHandle, cbQuad, cbError, cbEnd, supportedTypes, context, baseIRI, headers) {
        (0, $jGAMp._)(this, HtmlScriptListener);
        this.textChunksJsonLd = [];
        this.endBarrier = 1;
        this.passedScripts = 0;
        this.isFinalJsonLdProcessing = false;
        this.mediatorRdfParseHandle = mediatorRdfParseHandle;
        this.cbQuad = cbQuad;
        this.cbError = cbError;
        this.cbEnd = cbEnd;
        this.supportedTypes = supportedTypes;
        this.context = context.set($9nBhR.KeysRdfParseHtmlScript.processingHtmlScript, true);
        this.baseIRI = baseIRI;
        this.headers = headers;
        this.onlyFirstScript = context.get($9nBhR.KeysRdfParseHtmlScript.extractAllScripts) === false;
        var fragmentPos = this.baseIRI.indexOf('#');
        this.targetScriptId = fragmentPos > 0 ? this.baseIRI.slice(fragmentPos + 1, this.baseIRI.length) : null;
    }
    (0, $byiyg._)(HtmlScriptListener, [
        {
            key: "onEnd",
            value: function onEnd() {
                if (--this.endBarrier === 0) {
                    if (this.textChunksJsonLd.length > 0) {
                        // First process buffered JSON-LD chunks if we have any.
                        this.handleMediaType = 'application/ld+json';
                        this.textChunks = this.textChunksJsonLd;
                        this.textChunks.push(']');
                        this.textChunksJsonLd = [];
                        this.isFinalJsonLdProcessing = true;
                        this.endBarrier++;
                        // This will call onEnd again
                        this.onTagClose();
                    } else {
                        // Otherwise, end processing
                        if (this.passedScripts === 0 && this.targetScriptId) this.cbError(HtmlScriptListener.newErrorCoded('Failed to find targeted script id "'.concat(this.targetScriptId, '"'), 'loading document failed'));
                        this.cbEnd();
                    }
                    this.isFinalJsonLdProcessing = false;
                }
            }
        },
        {
            key: "onTagClose",
            value: function onTagClose() {
                var _this = this;
                if (this.handleMediaType) {
                    if (this.requiresCustomJsonLdHandling(this.handleMediaType) && !this.isFinalJsonLdProcessing) {
                        // Reset the media type and text stream
                        this.handleMediaType = undefined;
                        this.textChunks = undefined;
                        this.onEnd();
                    } else {
                        // Create a temporary text stream for pushing all the text chunks
                        var textStream = new $jUMw3.Readable({
                            objectMode: true
                        });
                        textStream._read = function() {
                        // Do nothing
                        };
                        var textChunksLocal = this.textChunks;
                        // Send all collected text to parser
                        var parseAction = {
                            context: this.context,
                            handle: {
                                metadata: {
                                    baseIRI: this.baseIRI
                                },
                                data: textStream,
                                headers: this.headers,
                                context: this.context
                            },
                            handleMediaType: this.handleMediaType
                        };
                        this.mediatorRdfParseHandle.mediate(parseAction).then(function(param) {
                            var handle = param.handle;
                            // Initialize text parsing
                            handle.data.on('error', function(error) {
                                return _this.cbError(HtmlScriptListener.newErrorCoded(error.message, 'invalid script element'));
                            }).on('data', _this.cbQuad).on('end', function() {
                                return _this.onEnd();
                            });
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                // Push the text stream after all events have been attached
                                for(var _iterator = textChunksLocal[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var textChunk = _step.value;
                                    textStream.push(textChunk);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            textStream.push(null);
                        })["catch"](function(error) {
                            if (_this.targetScriptId) // Error if we are targeting this script tag specifically
                            _this.cbError(HtmlScriptListener.newErrorCoded(error.message, 'loading document failed'));
                            else // Ignore script tags that we don't understand
                            _this.onEnd();
                        });
                        // Reset the media type and text stream
                        this.handleMediaType = undefined;
                        this.textChunks = undefined;
                    }
                }
            }
        },
        {
            key: "onTagOpen",
            value: function onTagOpen(name, attributes) {
                // Take into account baseIRI overrides
                if (name === 'base' && attributes.href) this.baseIRI = (0, $hDpjF.resolve)(attributes.href, this.baseIRI);
                // Only handle script tags with a parseable content type
                // If targetScriptId is defined, only extract from script with that id
                if (name === 'script' && (!this.targetScriptId || attributes.id === this.targetScriptId)) {
                    if (this.supportedTypes[attributes.type]) {
                        if (this.onlyFirstScript && this.passedScripts > 0) // Ignore script tag if only one should be extracted
                        this.handleMediaType = undefined;
                        else {
                            this.passedScripts++;
                            this.handleMediaType = attributes.type;
                            this.endBarrier++;
                            if (this.requiresCustomJsonLdHandling(this.handleMediaType)) {
                                this.textChunks = this.textChunksJsonLd;
                                this.textChunks.push(this.textChunks.length === 0 ? '[' : ',');
                            } else this.textChunks = [];
                        }
                    } else if (this.targetScriptId) this.cbError(HtmlScriptListener.newErrorCoded('Targeted script "'.concat(this.targetScriptId, '" does not have a supported type'), 'loading document failed'));
                } else this.handleMediaType = undefined;
            }
        },
        {
            key: "onText",
            value: function onText(data) {
                if (this.handleMediaType) this.textChunks.push(data);
            }
        },
        {
            /**
     * If we require custom JSON-LD handling for the given media type.
     *
     * The JSON-LD spec requires JSON-LD within script tags to be seen as a single document.
     * As such, we have to buffer all JSON-LD until the end of HTML processing,
     * and encapsulate all found contents in an array.
     *
     * @param mediaType A: IActionRdfParseHtml media type.
     */ key: "requiresCustomJsonLdHandling",
            value: function requiresCustomJsonLdHandling(mediaType) {
                return !this.onlyFirstScript && !this.targetScriptId && mediaType === 'application/ld+json';
            }
        }
    ], [
        {
            key: "newErrorCoded",
            value: function newErrorCoded(message, code) {
                // Error codes are required by the JSON-LD spec
                var error = new Error(message);
                error.code = code;
                return error;
            }
        }
    ]);
    return HtmlScriptListener;
}();
module.exports.HtmlScriptListener = $2701e06fde8eff40$var$HtmlScriptListener;

});
parcelRegister("jUMw3", function(module, exports) {
'use strict';

var $hZ2ma = parcelRequire("hZ2ma");

var $i7OtI = parcelRequire("i7OtI");
var $e7f8e18a9a0d5924$var$originalDestroy = $hZ2ma.Readable.destroy;
module.exports = $hZ2ma.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $hZ2ma._uint8ArrayToBuffer;
module.exports._isUint8Array = $hZ2ma._isUint8Array;
module.exports.isDisturbed = $hZ2ma.isDisturbed;
module.exports.isErrored = $hZ2ma.isErrored;
module.exports.isReadable = $hZ2ma.isReadable;
module.exports.Readable = $hZ2ma.Readable;
module.exports.Writable = $hZ2ma.Writable;
module.exports.Duplex = $hZ2ma.Duplex;
module.exports.Transform = $hZ2ma.Transform;
module.exports.PassThrough = $hZ2ma.PassThrough;
module.exports.addAbortSignal = $hZ2ma.addAbortSignal;
module.exports.finished = $hZ2ma.finished;
module.exports.destroy = $hZ2ma.destroy;
module.exports.destroy = $e7f8e18a9a0d5924$var$originalDestroy;
module.exports.pipeline = $hZ2ma.pipeline;
module.exports.compose = $hZ2ma.compose;
Object.defineProperty($hZ2ma, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $i7OtI;
    }
});
module.exports.Stream = $hZ2ma.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("hZ2ma", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $becUP = parcelRequire("becUP");
var $d179f61eb715dad6$require$Buffer = $becUP.Buffer;

var $hgdke = parcelRequire("hgdke");
/* replacement end */ var $d179f61eb715dad6$var$ObjectDefineProperty = $hgdke.ObjectDefineProperty, $d179f61eb715dad6$var$ObjectKeys = $hgdke.ObjectKeys, $d179f61eb715dad6$var$ReflectApply = $hgdke.ReflectApply;

var $1CjWp = parcelRequire("1CjWp");
var $d179f61eb715dad6$var$_require_promisify = $1CjWp.promisify, $d179f61eb715dad6$var$customPromisify = $d179f61eb715dad6$var$_require_promisify.custom;

var $dOLm3 = parcelRequire("dOLm3");
var $d179f61eb715dad6$var$streamReturningOperators = $dOLm3.streamReturningOperators, $d179f61eb715dad6$var$promiseReturningOperators = $dOLm3.promiseReturningOperators;

var $fjBv2 = parcelRequire("fjBv2");
var $d179f61eb715dad6$var$ERR_ILLEGAL_CONSTRUCTOR = $fjBv2.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $esW12 = parcelRequire("esW12");

var $gKnMe = parcelRequire("gKnMe");
var $d179f61eb715dad6$var$setDefaultHighWaterMark = $gKnMe.setDefaultHighWaterMark, $d179f61eb715dad6$var$getDefaultHighWaterMark = $gKnMe.getDefaultHighWaterMark;

var $9sHDO = parcelRequire("9sHDO");
var $d179f61eb715dad6$require$pipeline = $9sHDO.pipeline;

var $5Ble2 = parcelRequire("5Ble2");
var $d179f61eb715dad6$require$destroyer = $5Ble2.destroyer;

var $8Hinb = parcelRequire("8Hinb");
var $d179f61eb715dad6$var$internalBuffer = {};

var $i7OtI = parcelRequire("i7OtI");

var $cWkNZ = parcelRequire("cWkNZ");

var $d179f61eb715dad6$var$Stream = module.exports = (parcelRequire("juCgb")).Stream;
$d179f61eb715dad6$var$Stream.isDestroyed = $cWkNZ.isDestroyed;
$d179f61eb715dad6$var$Stream.isDisturbed = $cWkNZ.isDisturbed;
$d179f61eb715dad6$var$Stream.isErrored = $cWkNZ.isErrored;
$d179f61eb715dad6$var$Stream.isReadable = $cWkNZ.isReadable;
$d179f61eb715dad6$var$Stream.isWritable = $cWkNZ.isWritable;

$d179f61eb715dad6$var$Stream.Readable = (parcelRequire("gax2P"));
var $d179f61eb715dad6$var$_iteratorNormalCompletion = true, $d179f61eb715dad6$var$_didIteratorError = false, $d179f61eb715dad6$var$_iteratorError = undefined;
try {
    for(var $d179f61eb715dad6$var$_iterator = $d179f61eb715dad6$var$ObjectKeys($d179f61eb715dad6$var$streamReturningOperators)[Symbol.iterator](), $d179f61eb715dad6$var$_step; !($d179f61eb715dad6$var$_iteratorNormalCompletion = ($d179f61eb715dad6$var$_step = $d179f61eb715dad6$var$_iterator.next()).done); $d179f61eb715dad6$var$_iteratorNormalCompletion = true){
        var $d179f61eb715dad6$var$key = $d179f61eb715dad6$var$_step.value;
        var $d179f61eb715dad6$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $d179f61eb715dad6$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $d179f61eb715dad6$var$Stream.Readable.from($d179f61eb715dad6$var$ReflectApply($d179f61eb715dad6$var$op, this, args));
        };
        var $d179f61eb715dad6$var$op = $d179f61eb715dad6$var$streamReturningOperators[$d179f61eb715dad6$var$key];
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$fn, 'name', {
            __proto__: null,
            value: $d179f61eb715dad6$var$op.name
        });
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$fn, 'length', {
            __proto__: null,
            value: $d179f61eb715dad6$var$op.length
        });
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$Stream.Readable.prototype, $d179f61eb715dad6$var$key, {
            __proto__: null,
            value: $d179f61eb715dad6$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $d179f61eb715dad6$var$_didIteratorError = true;
    $d179f61eb715dad6$var$_iteratorError = err;
} finally{
    try {
        if (!$d179f61eb715dad6$var$_iteratorNormalCompletion && $d179f61eb715dad6$var$_iterator["return"] != null) {
            $d179f61eb715dad6$var$_iterator["return"]();
        }
    } finally{
        if ($d179f61eb715dad6$var$_didIteratorError) {
            throw $d179f61eb715dad6$var$_iteratorError;
        }
    }
}
var $d179f61eb715dad6$var$_iteratorNormalCompletion1 = true, $d179f61eb715dad6$var$_didIteratorError1 = false, $d179f61eb715dad6$var$_iteratorError1 = undefined;
try {
    for(var $d179f61eb715dad6$var$_iterator1 = $d179f61eb715dad6$var$ObjectKeys($d179f61eb715dad6$var$promiseReturningOperators)[Symbol.iterator](), $d179f61eb715dad6$var$_step1; !($d179f61eb715dad6$var$_iteratorNormalCompletion1 = ($d179f61eb715dad6$var$_step1 = $d179f61eb715dad6$var$_iterator1.next()).done); $d179f61eb715dad6$var$_iteratorNormalCompletion1 = true){
        var $d179f61eb715dad6$var$key1 = $d179f61eb715dad6$var$_step1.value;
        var $d179f61eb715dad6$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $d179f61eb715dad6$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $d179f61eb715dad6$var$ReflectApply($d179f61eb715dad6$var$op1, this, args);
        };
        var $d179f61eb715dad6$var$op1 = $d179f61eb715dad6$var$promiseReturningOperators[$d179f61eb715dad6$var$key1];
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$fn1, 'name', {
            __proto__: null,
            value: $d179f61eb715dad6$var$op1.name
        });
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$fn1, 'length', {
            __proto__: null,
            value: $d179f61eb715dad6$var$op1.length
        });
        $d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$Stream.Readable.prototype, $d179f61eb715dad6$var$key1, {
            __proto__: null,
            value: $d179f61eb715dad6$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $d179f61eb715dad6$var$_didIteratorError1 = true;
    $d179f61eb715dad6$var$_iteratorError1 = err;
} finally{
    try {
        if (!$d179f61eb715dad6$var$_iteratorNormalCompletion1 && $d179f61eb715dad6$var$_iterator1["return"] != null) {
            $d179f61eb715dad6$var$_iterator1["return"]();
        }
    } finally{
        if ($d179f61eb715dad6$var$_didIteratorError1) {
            throw $d179f61eb715dad6$var$_iteratorError1;
        }
    }
}

$d179f61eb715dad6$var$Stream.Writable = (parcelRequire("guOHm"));

$d179f61eb715dad6$var$Stream.Duplex = (parcelRequire("4nQiX"));

$d179f61eb715dad6$var$Stream.Transform = (parcelRequire("aaGPw"));

$d179f61eb715dad6$var$Stream.PassThrough = (parcelRequire("87bsp"));
$d179f61eb715dad6$var$Stream.pipeline = $d179f61eb715dad6$require$pipeline;

var $9yDYJ = parcelRequire("9yDYJ");
var $d179f61eb715dad6$require$addAbortSignal = $9yDYJ.addAbortSignal;
$d179f61eb715dad6$var$Stream.addAbortSignal = $d179f61eb715dad6$require$addAbortSignal;
$d179f61eb715dad6$var$Stream.finished = $8Hinb;
$d179f61eb715dad6$var$Stream.destroy = $d179f61eb715dad6$require$destroyer;
$d179f61eb715dad6$var$Stream.compose = $esW12;
$d179f61eb715dad6$var$Stream.setDefaultHighWaterMark = $d179f61eb715dad6$var$setDefaultHighWaterMark;
$d179f61eb715dad6$var$Stream.getDefaultHighWaterMark = $d179f61eb715dad6$var$getDefaultHighWaterMark;
$d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $i7OtI;
    }
});
$d179f61eb715dad6$var$ObjectDefineProperty($d179f61eb715dad6$require$pipeline, $d179f61eb715dad6$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $i7OtI.pipeline;
    }
});
$d179f61eb715dad6$var$ObjectDefineProperty($8Hinb, $d179f61eb715dad6$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $i7OtI.finished;
    }
});
// Backwards-compat with node 0.4.x
$d179f61eb715dad6$var$Stream.Stream = $d179f61eb715dad6$var$Stream;
$d179f61eb715dad6$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$d179f61eb715dad6$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $d179f61eb715dad6$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("becUP", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82cb0542f7f85135$export$a143d493d941bafc; }, function (v) { return $82cb0542f7f85135$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82cb0542f7f85135$export$f99ded8fe4b79145; }, function (v) { return $82cb0542f7f85135$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $82cb0542f7f85135$export$a143d493d941bafc;
var $82cb0542f7f85135$export$e4cf37d7f6fb9e0a;
var $82cb0542f7f85135$export$f99ded8fe4b79145;
var $82cb0542f7f85135$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $82cb0542f7f85135$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82cb0542f7f85135$export$a143d493d941bafc = $82cb0542f7f85135$var$Buffer;
$82cb0542f7f85135$export$e4cf37d7f6fb9e0a = $82cb0542f7f85135$var$SlowBuffer;
$82cb0542f7f85135$export$f99ded8fe4b79145 = 50;
var $82cb0542f7f85135$var$K_MAX_LENGTH = 0x7fffffff;
$82cb0542f7f85135$export$599f31c3813fae4d = $82cb0542f7f85135$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82cb0542f7f85135$var$Buffer.TYPED_ARRAY_SUPPORT = $82cb0542f7f85135$var$typedArraySupport();
if (!$82cb0542f7f85135$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82cb0542f7f85135$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82cb0542f7f85135$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$82cb0542f7f85135$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82cb0542f7f85135$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$82cb0542f7f85135$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82cb0542f7f85135$var$createBuffer(length) {
    if (length > $82cb0542f7f85135$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82cb0542f7f85135$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82cb0542f7f85135$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82cb0542f7f85135$var$allocUnsafe(arg);
    }
    return $82cb0542f7f85135$var$from(arg, encodingOrOffset, length);
}
$82cb0542f7f85135$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82cb0542f7f85135$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82cb0542f7f85135$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82cb0542f7f85135$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($82cb0542f7f85135$var$isInstance(value, ArrayBuffer) || value && $82cb0542f7f85135$var$isInstance(value.buffer, ArrayBuffer)) return $82cb0542f7f85135$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82cb0542f7f85135$var$isInstance(value, SharedArrayBuffer) || value && $82cb0542f7f85135$var$isInstance(value.buffer, SharedArrayBuffer))) return $82cb0542f7f85135$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82cb0542f7f85135$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $82cb0542f7f85135$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82cb0542f7f85135$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82cb0542f7f85135$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82cb0542f7f85135$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82cb0542f7f85135$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82cb0542f7f85135$var$Buffer, Uint8Array);
function $82cb0542f7f85135$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82cb0542f7f85135$var$alloc(size, fill, encoding) {
    $82cb0542f7f85135$var$assertSize(size);
    if (size <= 0) return $82cb0542f7f85135$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82cb0542f7f85135$var$createBuffer(size).fill(fill, encoding) : $82cb0542f7f85135$var$createBuffer(size).fill(fill);
    return $82cb0542f7f85135$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82cb0542f7f85135$var$Buffer.alloc = function(size, fill, encoding) {
    return $82cb0542f7f85135$var$alloc(size, fill, encoding);
};
function $82cb0542f7f85135$var$allocUnsafe(size) {
    $82cb0542f7f85135$var$assertSize(size);
    return $82cb0542f7f85135$var$createBuffer(size < 0 ? 0 : $82cb0542f7f85135$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82cb0542f7f85135$var$Buffer.allocUnsafe = function(size) {
    return $82cb0542f7f85135$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82cb0542f7f85135$var$Buffer.allocUnsafeSlow = function(size) {
    return $82cb0542f7f85135$var$allocUnsafe(size);
};
function $82cb0542f7f85135$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82cb0542f7f85135$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $82cb0542f7f85135$var$byteLength(string, encoding) | 0;
    var buf = $82cb0542f7f85135$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82cb0542f7f85135$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $82cb0542f7f85135$var$checked(array.length) | 0;
    var buf = $82cb0542f7f85135$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82cb0542f7f85135$var$fromArrayView(arrayView) {
    if ($82cb0542f7f85135$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $82cb0542f7f85135$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82cb0542f7f85135$var$fromArrayLike(arrayView);
}
function $82cb0542f7f85135$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82cb0542f7f85135$var$Buffer.prototype);
    return buf;
}
function $82cb0542f7f85135$var$fromObject(obj) {
    if ($82cb0542f7f85135$var$Buffer.isBuffer(obj)) {
        var len = $82cb0542f7f85135$var$checked(obj.length) | 0;
        var buf = $82cb0542f7f85135$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82cb0542f7f85135$var$numberIsNaN(obj.length)) return $82cb0542f7f85135$var$createBuffer(0);
        return $82cb0542f7f85135$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82cb0542f7f85135$var$fromArrayLike(obj.data);
}
function $82cb0542f7f85135$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82cb0542f7f85135$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82cb0542f7f85135$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82cb0542f7f85135$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82cb0542f7f85135$var$Buffer.alloc(+length);
}
$82cb0542f7f85135$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82cb0542f7f85135$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82cb0542f7f85135$var$Buffer.compare = function compare(a, b) {
    if ($82cb0542f7f85135$var$isInstance(a, Uint8Array)) a = $82cb0542f7f85135$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82cb0542f7f85135$var$isInstance(b, Uint8Array)) b = $82cb0542f7f85135$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82cb0542f7f85135$var$Buffer.isBuffer(a) || !$82cb0542f7f85135$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82cb0542f7f85135$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82cb0542f7f85135$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82cb0542f7f85135$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $82cb0542f7f85135$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($82cb0542f7f85135$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82cb0542f7f85135$var$Buffer.isBuffer(buf)) buf = $82cb0542f7f85135$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82cb0542f7f85135$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82cb0542f7f85135$var$byteLength(string, encoding) {
    if ($82cb0542f7f85135$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82cb0542f7f85135$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82cb0542f7f85135$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82cb0542f7f85135$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82cb0542f7f85135$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82cb0542f7f85135$var$Buffer.byteLength = $82cb0542f7f85135$var$byteLength;
function $82cb0542f7f85135$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82cb0542f7f85135$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82cb0542f7f85135$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82cb0542f7f85135$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82cb0542f7f85135$var$latin1Slice(this, start, end);
        case 'base64':
            return $82cb0542f7f85135$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82cb0542f7f85135$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82cb0542f7f85135$var$Buffer.prototype._isBuffer = true;
function $82cb0542f7f85135$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82cb0542f7f85135$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$82cb0542f7f85135$var$swap(this, i, i + 1);
    return this;
};
$82cb0542f7f85135$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $82cb0542f7f85135$var$swap(this, i, i + 3);
        $82cb0542f7f85135$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82cb0542f7f85135$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $82cb0542f7f85135$var$swap(this, i, i + 7);
        $82cb0542f7f85135$var$swap(this, i + 1, i + 6);
        $82cb0542f7f85135$var$swap(this, i + 2, i + 5);
        $82cb0542f7f85135$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82cb0542f7f85135$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82cb0542f7f85135$var$utf8Slice(this, 0, length);
    return $82cb0542f7f85135$var$slowToString.apply(this, arguments);
};
$82cb0542f7f85135$var$Buffer.prototype.toLocaleString = $82cb0542f7f85135$var$Buffer.prototype.toString;
$82cb0542f7f85135$var$Buffer.prototype.equals = function equals(b) {
    if (!$82cb0542f7f85135$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82cb0542f7f85135$var$Buffer.compare(this, b) === 0;
};
$82cb0542f7f85135$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $82cb0542f7f85135$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82cb0542f7f85135$var$customInspectSymbol) $82cb0542f7f85135$var$Buffer.prototype[$82cb0542f7f85135$var$customInspectSymbol] = $82cb0542f7f85135$var$Buffer.prototype.inspect;
$82cb0542f7f85135$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82cb0542f7f85135$var$isInstance(target, Uint8Array)) target = $82cb0542f7f85135$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82cb0542f7f85135$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82cb0542f7f85135$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82cb0542f7f85135$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82cb0542f7f85135$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82cb0542f7f85135$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82cb0542f7f85135$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82cb0542f7f85135$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82cb0542f7f85135$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82cb0542f7f85135$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82cb0542f7f85135$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82cb0542f7f85135$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82cb0542f7f85135$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82cb0542f7f85135$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82cb0542f7f85135$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82cb0542f7f85135$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82cb0542f7f85135$var$utf8Write(buf, string, offset, length) {
    return $82cb0542f7f85135$var$blitBuffer($82cb0542f7f85135$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82cb0542f7f85135$var$asciiWrite(buf, string, offset, length) {
    return $82cb0542f7f85135$var$blitBuffer($82cb0542f7f85135$var$asciiToBytes(string), buf, offset, length);
}
function $82cb0542f7f85135$var$base64Write(buf, string, offset, length) {
    return $82cb0542f7f85135$var$blitBuffer($82cb0542f7f85135$var$base64ToBytes(string), buf, offset, length);
}
function $82cb0542f7f85135$var$ucs2Write(buf, string, offset, length) {
    return $82cb0542f7f85135$var$blitBuffer($82cb0542f7f85135$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82cb0542f7f85135$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82cb0542f7f85135$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82cb0542f7f85135$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82cb0542f7f85135$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82cb0542f7f85135$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82cb0542f7f85135$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82cb0542f7f85135$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82cb0542f7f85135$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $82cb0542f7f85135$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82cb0542f7f85135$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $82cb0542f7f85135$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82cb0542f7f85135$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $82cb0542f7f85135$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82cb0542f7f85135$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82cb0542f7f85135$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82cb0542f7f85135$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82cb0542f7f85135$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $82cb0542f7f85135$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82cb0542f7f85135$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82cb0542f7f85135$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82cb0542f7f85135$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82cb0542f7f85135$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82cb0542f7f85135$var$Buffer.prototype.readUintLE = $82cb0542f7f85135$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82cb0542f7f85135$var$Buffer.prototype.readUintBE = $82cb0542f7f85135$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82cb0542f7f85135$var$Buffer.prototype.readUint8 = $82cb0542f7f85135$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82cb0542f7f85135$var$Buffer.prototype.readUint16LE = $82cb0542f7f85135$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82cb0542f7f85135$var$Buffer.prototype.readUint16BE = $82cb0542f7f85135$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82cb0542f7f85135$var$Buffer.prototype.readUint32LE = $82cb0542f7f85135$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82cb0542f7f85135$var$Buffer.prototype.readUint32BE = $82cb0542f7f85135$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82cb0542f7f85135$var$Buffer.prototype.readBigUInt64LE = $82cb0542f7f85135$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82cb0542f7f85135$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $82cb0542f7f85135$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82cb0542f7f85135$var$Buffer.prototype.readBigUInt64BE = $82cb0542f7f85135$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82cb0542f7f85135$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $82cb0542f7f85135$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82cb0542f7f85135$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82cb0542f7f85135$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82cb0542f7f85135$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82cb0542f7f85135$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82cb0542f7f85135$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82cb0542f7f85135$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82cb0542f7f85135$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82cb0542f7f85135$var$Buffer.prototype.readBigInt64LE = $82cb0542f7f85135$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82cb0542f7f85135$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $82cb0542f7f85135$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$82cb0542f7f85135$var$Buffer.prototype.readBigInt64BE = $82cb0542f7f85135$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82cb0542f7f85135$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $82cb0542f7f85135$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$82cb0542f7f85135$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$82cb0542f7f85135$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$82cb0542f7f85135$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$82cb0542f7f85135$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $82cb0542f7f85135$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82cb0542f7f85135$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82cb0542f7f85135$var$Buffer.prototype.writeUintLE = $82cb0542f7f85135$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82cb0542f7f85135$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUintBE = $82cb0542f7f85135$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82cb0542f7f85135$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUint8 = $82cb0542f7f85135$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUint16LE = $82cb0542f7f85135$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUint16BE = $82cb0542f7f85135$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUint32LE = $82cb0542f7f85135$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82cb0542f7f85135$var$Buffer.prototype.writeUint32BE = $82cb0542f7f85135$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82cb0542f7f85135$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82cb0542f7f85135$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82cb0542f7f85135$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82cb0542f7f85135$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82cb0542f7f85135$var$Buffer.prototype.writeBigUInt64LE = $82cb0542f7f85135$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $82cb0542f7f85135$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82cb0542f7f85135$var$Buffer.prototype.writeBigUInt64BE = $82cb0542f7f85135$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $82cb0542f7f85135$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82cb0542f7f85135$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82cb0542f7f85135$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82cb0542f7f85135$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82cb0542f7f85135$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82cb0542f7f85135$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82cb0542f7f85135$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82cb0542f7f85135$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82cb0542f7f85135$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82cb0542f7f85135$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82cb0542f7f85135$var$Buffer.prototype.writeBigInt64LE = $82cb0542f7f85135$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $82cb0542f7f85135$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82cb0542f7f85135$var$Buffer.prototype.writeBigInt64BE = $82cb0542f7f85135$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $82cb0542f7f85135$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82cb0542f7f85135$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82cb0542f7f85135$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82cb0542f7f85135$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82cb0542f7f85135$var$writeFloat(this, value, offset, true, noAssert);
};
$82cb0542f7f85135$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82cb0542f7f85135$var$writeFloat(this, value, offset, false, noAssert);
};
function $82cb0542f7f85135$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82cb0542f7f85135$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82cb0542f7f85135$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82cb0542f7f85135$var$writeDouble(this, value, offset, true, noAssert);
};
$82cb0542f7f85135$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82cb0542f7f85135$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82cb0542f7f85135$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82cb0542f7f85135$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82cb0542f7f85135$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82cb0542f7f85135$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $82cb0542f7f85135$var$Buffer.isBuffer(val) ? val : $82cb0542f7f85135$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $82cb0542f7f85135$var$errors = {};
function $82cb0542f7f85135$var$E(sym, getMessage, Base) {
    $82cb0542f7f85135$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$82cb0542f7f85135$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82cb0542f7f85135$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$82cb0542f7f85135$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $82cb0542f7f85135$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $82cb0542f7f85135$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $82cb0542f7f85135$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $82cb0542f7f85135$var$checkBounds(buf, offset, byteLength) {
    $82cb0542f7f85135$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82cb0542f7f85135$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82cb0542f7f85135$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $82cb0542f7f85135$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82cb0542f7f85135$var$checkBounds(buf, offset, byteLength);
}
function $82cb0542f7f85135$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82cb0542f7f85135$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82cb0542f7f85135$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82cb0542f7f85135$var$validateNumber(value, type);
        throw new $82cb0542f7f85135$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82cb0542f7f85135$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82cb0542f7f85135$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $82cb0542f7f85135$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82cb0542f7f85135$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82cb0542f7f85135$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82cb0542f7f85135$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82cb0542f7f85135$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82cb0542f7f85135$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82cb0542f7f85135$var$base64ToBytes(str) {
    return $abUaD.toByteArray($82cb0542f7f85135$var$base64clean(str));
}
function $82cb0542f7f85135$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82cb0542f7f85135$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82cb0542f7f85135$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $82cb0542f7f85135$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82cb0542f7f85135$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82cb0542f7f85135$var$BufferBigIntNotDefined : fn;
}
function $82cb0542f7f85135$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("hgdke", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $c90e4468dde70e03$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $c90e4468dde70e03$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("1CjWp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $becUP = parcelRequire("becUP");

var $6S7NU = parcelRequire("6S7NU");
var $12d8ceef95a1e07c$var$format = $6S7NU.format, $12d8ceef95a1e07c$var$inspect = $6S7NU.inspect;

var $fjBv2 = parcelRequire("fjBv2");
var $12d8ceef95a1e07c$var$ERR_INVALID_ARG_TYPE = $fjBv2.codes.ERR_INVALID_ARG_TYPE;

var $hgdke = parcelRequire("hgdke");
var $12d8ceef95a1e07c$var$kResistStopPropagation = $hgdke.kResistStopPropagation, $12d8ceef95a1e07c$var$AggregateError = $hgdke.AggregateError, $12d8ceef95a1e07c$var$SymbolDispose = $hgdke.SymbolDispose;

var $12d8ceef95a1e07c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $12d8ceef95a1e07c$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $12d8ceef95a1e07c$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $12d8ceef95a1e07c$var$Blob = globalThis.Blob || $becUP.Blob;
/* eslint-disable indent */ var $12d8ceef95a1e07c$var$isBlob = typeof $12d8ceef95a1e07c$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $12d8ceef95a1e07c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $12d8ceef95a1e07c$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $12d8ceef95a1e07c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $12d8ceef95a1e07c$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $12d8ceef95a1e07c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $12d8ceef95a1e07c$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $12d8ceef95a1e07c$var$format,
    inspect: $12d8ceef95a1e07c$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $12d8ceef95a1e07c$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $12d8ceef95a1e07c$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $12d8ceef95a1e07c$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $12d8ceef95a1e07c$var$validateAbortSignal(signal, 'signal');
        $12d8ceef95a1e07c$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $12d8ceef95a1e07c$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $12d8ceef95a1e07c$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $12d8ceef95a1e07c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $12d8ceef95a1e07c$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $12d8ceef95a1e07c$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("6S7NU", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("fjBv2", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $6S7NU = parcelRequire("6S7NU");
var $b265b7fb5140978a$var$format = $6S7NU.format, $b265b7fb5140978a$var$inspect = $6S7NU.inspect;

var $hgdke = parcelRequire("hgdke");
var $b265b7fb5140978a$var$CustomAggregateError = $hgdke.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $b265b7fb5140978a$var$AggregateError = globalThis.AggregateError || $b265b7fb5140978a$var$CustomAggregateError;
var $b265b7fb5140978a$var$kIsNodeError = Symbol('kIsNodeError');
var $b265b7fb5140978a$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $b265b7fb5140978a$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $b265b7fb5140978a$var$nodeInternalPrefix = '__node_internal_';
var $b265b7fb5140978a$var$codes = {};
function $b265b7fb5140978a$var$assert(value, message) {
    if (!value) throw new $b265b7fb5140978a$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $b265b7fb5140978a$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $b265b7fb5140978a$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $b265b7fb5140978a$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $b265b7fb5140978a$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $b265b7fb5140978a$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $b265b7fb5140978a$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $b265b7fb5140978a$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$b265b7fb5140978a$var$kIsNodeError] = true;
    $b265b7fb5140978a$var$codes[code] = NodeError;
}
function $b265b7fb5140978a$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $b265b7fb5140978a$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $b265b7fb5140978a$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $b265b7fb5140978a$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $b265b7fb5140978a$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $b265b7fb5140978a$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$b265b7fb5140978a$var$E('ERR_ASSERTION', '%s', Error);
$b265b7fb5140978a$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $b265b7fb5140978a$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $b265b7fb5140978a$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($b265b7fb5140978a$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($b265b7fb5140978a$var$classRegExp.test(value)) instances.push(value);
            else {
                $b265b7fb5140978a$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $b265b7fb5140978a$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $b265b7fb5140978a$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$b265b7fb5140978a$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $b265b7fb5140978a$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$b265b7fb5140978a$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$b265b7fb5140978a$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $b265b7fb5140978a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$b265b7fb5140978a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $b265b7fb5140978a$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $b265b7fb5140978a$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $b265b7fb5140978a$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $b265b7fb5140978a$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$b265b7fb5140978a$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$b265b7fb5140978a$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$b265b7fb5140978a$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$b265b7fb5140978a$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$b265b7fb5140978a$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $b265b7fb5140978a$var$AbortError,
    aggregateTwoErrors: $b265b7fb5140978a$var$hideStackFrames($b265b7fb5140978a$var$aggregateTwoErrors),
    hideStackFrames: $b265b7fb5140978a$var$hideStackFrames,
    codes: $b265b7fb5140978a$var$codes
};

});


parcelRegister("dOLm3", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $a0f4ad858dc021e7$export$42af8c323be37587; }, function (v) { return $a0f4ad858dc021e7$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $a0f4ad858dc021e7$export$f405f72c701dad87; }, function (v) { return $a0f4ad858dc021e7$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $a0f4ad858dc021e7$export$42af8c323be37587;
var $a0f4ad858dc021e7$export$f405f72c701dad87;
'use strict';

var $a0f4ad858dc021e7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $fjBv2 = parcelRequire("fjBv2");
var $a0f4ad858dc021e7$var$_require_codes = $fjBv2.codes, $a0f4ad858dc021e7$var$ERR_INVALID_ARG_VALUE = $a0f4ad858dc021e7$var$_require_codes.ERR_INVALID_ARG_VALUE, $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE = $a0f4ad858dc021e7$var$_require_codes.ERR_INVALID_ARG_TYPE, $a0f4ad858dc021e7$var$ERR_MISSING_ARGS = $a0f4ad858dc021e7$var$_require_codes.ERR_MISSING_ARGS, $a0f4ad858dc021e7$var$ERR_OUT_OF_RANGE = $a0f4ad858dc021e7$var$_require_codes.ERR_OUT_OF_RANGE, $a0f4ad858dc021e7$var$AbortError = $fjBv2.AbortError;

var $LzD4s = parcelRequire("LzD4s");
var $a0f4ad858dc021e7$var$validateAbortSignal = $LzD4s.validateAbortSignal, $a0f4ad858dc021e7$var$validateInteger = $LzD4s.validateInteger, $a0f4ad858dc021e7$var$validateObject = $LzD4s.validateObject;

var $a0f4ad858dc021e7$var$kWeakHandler = (parcelRequire("hgdke")).Symbol('kWeak');

var $a0f4ad858dc021e7$var$kResistStopPropagation = (parcelRequire("hgdke")).Symbol('kResistStopPropagation');

var $8Hinb = parcelRequire("8Hinb");
var $a0f4ad858dc021e7$require$finished = $8Hinb.finished;

var $esW12 = parcelRequire("esW12");

var $9yDYJ = parcelRequire("9yDYJ");
var $a0f4ad858dc021e7$require$addAbortSignalNoValidate = $9yDYJ.addAbortSignalNoValidate;

var $cWkNZ = parcelRequire("cWkNZ");
var $a0f4ad858dc021e7$var$isWritable = $cWkNZ.isWritable, $a0f4ad858dc021e7$var$isNodeStream = $cWkNZ.isNodeStream;

var $a0f4ad858dc021e7$require$deprecate = (parcelRequire("1CjWp")).deprecate;

var $a0f4ad858dc021e7$var$ArrayPrototypePush = (parcelRequire("hgdke")).ArrayPrototypePush, $a0f4ad858dc021e7$var$Boolean = (parcelRequire("hgdke")).Boolean, $a0f4ad858dc021e7$var$MathFloor = (parcelRequire("hgdke")).MathFloor, $a0f4ad858dc021e7$var$Number = (parcelRequire("hgdke")).Number, $a0f4ad858dc021e7$var$NumberIsNaN = (parcelRequire("hgdke")).NumberIsNaN, $a0f4ad858dc021e7$var$Promise = (parcelRequire("hgdke")).Promise, $a0f4ad858dc021e7$var$PromiseReject = (parcelRequire("hgdke")).PromiseReject, $a0f4ad858dc021e7$var$PromiseResolve = (parcelRequire("hgdke")).PromiseResolve, $a0f4ad858dc021e7$var$PromisePrototypeThen = (parcelRequire("hgdke")).PromisePrototypeThen, $a0f4ad858dc021e7$var$Symbol = (parcelRequire("hgdke")).Symbol;
var $a0f4ad858dc021e7$var$kEmpty = $a0f4ad858dc021e7$var$Symbol('kEmpty');
var $a0f4ad858dc021e7$var$kEof = $a0f4ad858dc021e7$var$Symbol('kEof');
function $a0f4ad858dc021e7$var$compose(stream, options) {
    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
    if ($a0f4ad858dc021e7$var$isNodeStream(stream) && !$a0f4ad858dc021e7$var$isWritable(stream)) throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $esW12(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $a0f4ad858dc021e7$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $a0f4ad858dc021e7$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $a0f4ad858dc021e7$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $a0f4ad858dc021e7$var$MathFloor(options.highWaterMark);
    $a0f4ad858dc021e7$var$validateInteger(concurrency, 'options.concurrency', 1);
    $a0f4ad858dc021e7$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $a0f4ad858dc021e7$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $a0f4ad858dc021e7$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $a0f4ad858dc021e7$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $a0f4ad858dc021e7$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $a0f4ad858dc021e7$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($a0f4ad858dc021e7$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $a0f4ad858dc021e7$var$PromiseReject(err1);
                                $a0f4ad858dc021e7$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("1CjWp")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($a0f4ad858dc021e7$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $a0f4ad858dc021e7$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                        if (!(val !== $a0f4ad858dc021e7$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $a0f4ad858dc021e7$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a0f4ad858dc021e7$var$asIndexedPairs(options) {
    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $a0f4ad858dc021e7$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a0f4ad858dc021e7$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a0f4ad858dc021e7$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $a0f4ad858dc021e7$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $a0f4ad858dc021e7$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $a0f4ad858dc021e7$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a0f4ad858dc021e7$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $a0f4ad858dc021e7$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $a0f4ad858dc021e7$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($a0f4ad858dc021e7$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $a0f4ad858dc021e7$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $a0f4ad858dc021e7$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $a0f4ad858dc021e7$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $a0f4ad858dc021e7$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($a0f4ad858dc021e7$var$ERR_MISSING_ARGS);
function $a0f4ad858dc021e7$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $a0f4ad858dc021e7$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $a0f4ad858dc021e7$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $a0f4ad858dc021e7$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $a0f4ad858dc021e7$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $a0f4ad858dc021e7$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $a0f4ad858dc021e7$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $a0f4ad858dc021e7$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $a0f4ad858dc021e7$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $a0f4ad858dc021e7$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $a0f4ad858dc021e7$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $a0f4ad858dc021e7$var$flatMap(fn, options) {
    var values = $a0f4ad858dc021e7$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $a0f4ad858dc021e7$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $a0f4ad858dc021e7$var$Number(number);
    if ($a0f4ad858dc021e7$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $a0f4ad858dc021e7$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $a0f4ad858dc021e7$var$drop(number, options) {
    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
    number = $a0f4ad858dc021e7$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $a0f4ad858dc021e7$var$take(number, options) {
    if (options != null) $a0f4ad858dc021e7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a0f4ad858dc021e7$var$validateAbortSignal(options.signal, 'options.signal');
    number = $a0f4ad858dc021e7$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $a0f4ad858dc021e7$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$a0f4ad858dc021e7$export$42af8c323be37587 = {
    asIndexedPairs: $a0f4ad858dc021e7$require$deprecate($a0f4ad858dc021e7$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $a0f4ad858dc021e7$var$drop,
    filter: $a0f4ad858dc021e7$var$filter,
    flatMap: $a0f4ad858dc021e7$var$flatMap,
    map: $a0f4ad858dc021e7$var$map,
    take: $a0f4ad858dc021e7$var$take,
    compose: $a0f4ad858dc021e7$var$compose
};
$a0f4ad858dc021e7$export$f405f72c701dad87 = {
    every: $a0f4ad858dc021e7$var$every,
    forEach: $a0f4ad858dc021e7$var$forEach,
    reduce: $a0f4ad858dc021e7$var$reduce,
    toArray: $a0f4ad858dc021e7$var$toArray,
    some: $a0f4ad858dc021e7$var$some,
    find: $a0f4ad858dc021e7$var$find
};

});
parcelRegister("LzD4s", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $08f0071cd997260c$var$ArrayIsArray = $hgdke.ArrayIsArray, $08f0071cd997260c$var$ArrayPrototypeIncludes = $hgdke.ArrayPrototypeIncludes, $08f0071cd997260c$var$ArrayPrototypeJoin = $hgdke.ArrayPrototypeJoin, $08f0071cd997260c$var$ArrayPrototypeMap = $hgdke.ArrayPrototypeMap, $08f0071cd997260c$var$NumberIsInteger = $hgdke.NumberIsInteger, $08f0071cd997260c$var$NumberIsNaN = $hgdke.NumberIsNaN, $08f0071cd997260c$var$NumberMAX_SAFE_INTEGER = $hgdke.NumberMAX_SAFE_INTEGER, $08f0071cd997260c$var$NumberMIN_SAFE_INTEGER = $hgdke.NumberMIN_SAFE_INTEGER, $08f0071cd997260c$var$NumberParseInt = $hgdke.NumberParseInt, $08f0071cd997260c$var$ObjectPrototypeHasOwnProperty = $hgdke.ObjectPrototypeHasOwnProperty, $08f0071cd997260c$var$RegExpPrototypeExec = $hgdke.RegExpPrototypeExec, $08f0071cd997260c$var$String = $hgdke.String, $08f0071cd997260c$var$StringPrototypeToUpperCase = $hgdke.StringPrototypeToUpperCase, $08f0071cd997260c$var$StringPrototypeTrim = $hgdke.StringPrototypeTrim;

var $fjBv2 = parcelRequire("fjBv2");
var $08f0071cd997260c$var$hideStackFrames = $fjBv2.hideStackFrames, $08f0071cd997260c$var$_require_codes = $fjBv2.codes, $08f0071cd997260c$var$ERR_SOCKET_BAD_PORT = $08f0071cd997260c$var$_require_codes.ERR_SOCKET_BAD_PORT, $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE = $08f0071cd997260c$var$_require_codes.ERR_INVALID_ARG_TYPE, $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE = $08f0071cd997260c$var$_require_codes.ERR_INVALID_ARG_VALUE, $08f0071cd997260c$var$ERR_OUT_OF_RANGE = $08f0071cd997260c$var$_require_codes.ERR_OUT_OF_RANGE, $08f0071cd997260c$var$ERR_UNKNOWN_SIGNAL = $08f0071cd997260c$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $1CjWp = parcelRequire("1CjWp");
var $08f0071cd997260c$require$normalizeEncoding = $1CjWp.normalizeEncoding;

var $1CjWp = parcelRequire("1CjWp");
var $08f0071cd997260c$require$_require_types = $1CjWp.types;
var $08f0071cd997260c$var$isAsyncFunction = $08f0071cd997260c$require$_require_types.isAsyncFunction, $08f0071cd997260c$var$isArrayBufferView = $08f0071cd997260c$require$_require_types.isArrayBufferView;
var $08f0071cd997260c$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $08f0071cd997260c$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $08f0071cd997260c$var$isUint32(value) {
    return value === value >>> 0;
}
var $08f0071cd997260c$var$octalReg = /^[0-7]+$/;
var $08f0071cd997260c$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $08f0071cd997260c$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($08f0071cd997260c$var$RegExpPrototypeExec($08f0071cd997260c$var$octalReg, value) === null) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE(name, value, $08f0071cd997260c$var$modeDesc);
        value = $08f0071cd997260c$var$NumberParseInt(value, 8);
    }
    $08f0071cd997260c$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $08f0071cd997260c$var$validateInteger = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $08f0071cd997260c$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $08f0071cd997260c$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08f0071cd997260c$var$NumberIsInteger(value)) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $08f0071cd997260c$var$validateInt32 = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08f0071cd997260c$var$NumberIsInteger(value)) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $08f0071cd997260c$var$validateUint32 = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08f0071cd997260c$var$NumberIsInteger(value)) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $08f0071cd997260c$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $08f0071cd997260c$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $08f0071cd997260c$var$NumberIsNaN(value)) throw new $08f0071cd997260c$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $08f0071cd997260c$var$validateOneOf = $08f0071cd997260c$var$hideStackFrames(function(value, name, oneOf) {
    if (!$08f0071cd997260c$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $08f0071cd997260c$var$ArrayPrototypeJoin($08f0071cd997260c$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $08f0071cd997260c$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $08f0071cd997260c$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $08f0071cd997260c$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$08f0071cd997260c$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $08f0071cd997260c$var$validateObject = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $08f0071cd997260c$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $08f0071cd997260c$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $08f0071cd997260c$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $08f0071cd997260c$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $08f0071cd997260c$var$validateDictionary = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $08f0071cd997260c$var$validateArray = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$08f0071cd997260c$var$ArrayIsArray(value)) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $08f0071cd997260c$var$validateStringArray(value, name) {
    $08f0071cd997260c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$08f0071cd997260c$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $08f0071cd997260c$var$validateBooleanArray(value, name) {
    $08f0071cd997260c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$08f0071cd997260c$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $08f0071cd997260c$var$validateAbortSignalArray(value, name) {
    $08f0071cd997260c$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $08f0071cd997260c$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $08f0071cd997260c$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $08f0071cd997260c$var$validateString(signal, name);
    if ($08f0071cd997260c$var$signals[signal] === undefined) {
        if ($08f0071cd997260c$var$signals[$08f0071cd997260c$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $08f0071cd997260c$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $08f0071cd997260c$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $08f0071cd997260c$var$validateBuffer = $08f0071cd997260c$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$08f0071cd997260c$var$isArrayBufferView(buffer)) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $08f0071cd997260c$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $08f0071cd997260c$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $08f0071cd997260c$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $08f0071cd997260c$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $08f0071cd997260c$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $08f0071cd997260c$var$validateAbortSignal = $08f0071cd997260c$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $08f0071cd997260c$var$validateFunction = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $08f0071cd997260c$var$validatePlainFunction = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $08f0071cd997260c$var$isAsyncFunction(value)) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $08f0071cd997260c$var$validateUndefined = $08f0071cd997260c$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $08f0071cd997260c$var$validateUnion(value, name, union) {
    if (!$08f0071cd997260c$var$ArrayPrototypeIncludes(union, value)) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_TYPE(name, "('".concat($08f0071cd997260c$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $08f0071cd997260c$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $08f0071cd997260c$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$08f0071cd997260c$var$RegExpPrototypeExec($08f0071cd997260c$var$linkValueRegExp, value)) throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $08f0071cd997260c$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $08f0071cd997260c$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($08f0071cd997260c$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $08f0071cd997260c$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $08f0071cd997260c$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $08f0071cd997260c$var$isInt32,
    isUint32: $08f0071cd997260c$var$isUint32,
    parseFileMode: $08f0071cd997260c$var$parseFileMode,
    validateArray: $08f0071cd997260c$var$validateArray,
    validateStringArray: $08f0071cd997260c$var$validateStringArray,
    validateBooleanArray: $08f0071cd997260c$var$validateBooleanArray,
    validateAbortSignalArray: $08f0071cd997260c$var$validateAbortSignalArray,
    validateBoolean: $08f0071cd997260c$var$validateBoolean,
    validateBuffer: $08f0071cd997260c$var$validateBuffer,
    validateDictionary: $08f0071cd997260c$var$validateDictionary,
    validateEncoding: $08f0071cd997260c$var$validateEncoding,
    validateFunction: $08f0071cd997260c$var$validateFunction,
    validateInt32: $08f0071cd997260c$var$validateInt32,
    validateInteger: $08f0071cd997260c$var$validateInteger,
    validateNumber: $08f0071cd997260c$var$validateNumber,
    validateObject: $08f0071cd997260c$var$validateObject,
    validateOneOf: $08f0071cd997260c$var$validateOneOf,
    validatePlainFunction: $08f0071cd997260c$var$validatePlainFunction,
    validatePort: $08f0071cd997260c$var$validatePort,
    validateSignalName: $08f0071cd997260c$var$validateSignalName,
    validateString: $08f0071cd997260c$var$validateString,
    validateUint32: $08f0071cd997260c$var$validateUint32,
    validateUndefined: $08f0071cd997260c$var$validateUndefined,
    validateUnion: $08f0071cd997260c$var$validateUnion,
    validateAbortSignal: $08f0071cd997260c$var$validateAbortSignal,
    validateLinkHeaderValue: $08f0071cd997260c$var$validateLinkHeaderValue
};

});

parcelRegister("8Hinb", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fjBv2 = parcelRequire("fjBv2");
/* replacement end */ var $65509758fdfeb074$var$AbortError = $fjBv2.AbortError, $65509758fdfeb074$var$codes = $fjBv2.codes;
var $65509758fdfeb074$var$ERR_INVALID_ARG_TYPE = $65509758fdfeb074$var$codes.ERR_INVALID_ARG_TYPE, $65509758fdfeb074$var$ERR_STREAM_PREMATURE_CLOSE = $65509758fdfeb074$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $65509758fdfeb074$var$kEmptyObject = (parcelRequire("1CjWp")).kEmptyObject, $65509758fdfeb074$var$once = (parcelRequire("1CjWp")).once;

var $LzD4s = parcelRequire("LzD4s");
var $65509758fdfeb074$var$validateAbortSignal = $LzD4s.validateAbortSignal, $65509758fdfeb074$var$validateFunction = $LzD4s.validateFunction, $65509758fdfeb074$var$validateObject = $LzD4s.validateObject, $65509758fdfeb074$var$validateBoolean = $LzD4s.validateBoolean;

var $hgdke = parcelRequire("hgdke");
var $65509758fdfeb074$var$Promise = $hgdke.Promise, $65509758fdfeb074$var$PromisePrototypeThen = $hgdke.PromisePrototypeThen, $65509758fdfeb074$var$SymbolDispose = $hgdke.SymbolDispose;

var $cWkNZ = parcelRequire("cWkNZ");
var $65509758fdfeb074$var$isClosed = $cWkNZ.isClosed, $65509758fdfeb074$var$isReadable = $cWkNZ.isReadable, $65509758fdfeb074$var$isReadableNodeStream = $cWkNZ.isReadableNodeStream, $65509758fdfeb074$var$isReadableStream = $cWkNZ.isReadableStream, $65509758fdfeb074$var$isReadableFinished = $cWkNZ.isReadableFinished, $65509758fdfeb074$var$isReadableErrored = $cWkNZ.isReadableErrored, $65509758fdfeb074$var$isWritable = $cWkNZ.isWritable, $65509758fdfeb074$var$isWritableNodeStream = $cWkNZ.isWritableNodeStream, $65509758fdfeb074$var$isWritableStream = $cWkNZ.isWritableStream, $65509758fdfeb074$var$isWritableFinished = $cWkNZ.isWritableFinished, $65509758fdfeb074$var$isWritableErrored = $cWkNZ.isWritableErrored, $65509758fdfeb074$var$isNodeStream = $cWkNZ.isNodeStream, $65509758fdfeb074$var$_willEmitClose = $cWkNZ.willEmitClose, $65509758fdfeb074$var$kIsClosedPromise = $cWkNZ.kIsClosedPromise;
var $65509758fdfeb074$var$addAbortListener;
function $65509758fdfeb074$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $65509758fdfeb074$var$nop = function() {};

function $65509758fdfeb074$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $65509758fdfeb074$var$kEmptyObject;
    } else if (options == null) options = $65509758fdfeb074$var$kEmptyObject;
    else $65509758fdfeb074$var$validateObject(options, 'options');
    $65509758fdfeb074$var$validateFunction(callback, 'callback');
    $65509758fdfeb074$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $65509758fdfeb074$var$once(callback);
    if ($65509758fdfeb074$var$isReadableStream(stream) || $65509758fdfeb074$var$isWritableStream(stream)) return $65509758fdfeb074$var$eosWeb(stream, options, callback);
    if (!$65509758fdfeb074$var$isNodeStream(stream)) throw new $65509758fdfeb074$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $65509758fdfeb074$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $65509758fdfeb074$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $65509758fdfeb074$var$_willEmitClose(stream) && $65509758fdfeb074$var$isReadableNodeStream(stream) === readable && $65509758fdfeb074$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $65509758fdfeb074$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $65509758fdfeb074$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $65509758fdfeb074$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $65509758fdfeb074$var$isWritableErrored(stream) || $65509758fdfeb074$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $65509758fdfeb074$var$isReadableNodeStream(stream, true)) {
            if (!$65509758fdfeb074$var$isReadableFinished(stream, false)) return callback.call(stream, new $65509758fdfeb074$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$65509758fdfeb074$var$isWritableFinished(stream, false)) return callback.call(stream, new $65509758fdfeb074$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $65509758fdfeb074$var$isWritableErrored(stream) || $65509758fdfeb074$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($65509758fdfeb074$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $65509758fdfeb074$var$isReadable(stream)) && (writableFinished || $65509758fdfeb074$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $65509758fdfeb074$var$isWritable(stream)) && (readableFinished || $65509758fdfeb074$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $65509758fdfeb074$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $65509758fdfeb074$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $65509758fdfeb074$var$addAbortListener = $65509758fdfeb074$var$addAbortListener || (parcelRequire("1CjWp")).addAbortListener;
            var disposable = $65509758fdfeb074$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $65509758fdfeb074$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$65509758fdfeb074$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $65509758fdfeb074$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $65509758fdfeb074$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $65509758fdfeb074$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $65509758fdfeb074$var$addAbortListener = $65509758fdfeb074$var$addAbortListener || (parcelRequire("1CjWp")).addAbortListener;
            var disposable = $65509758fdfeb074$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $65509758fdfeb074$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$65509758fdfeb074$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $65509758fdfeb074$var$PromisePrototypeThen(stream[$65509758fdfeb074$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $65509758fdfeb074$var$nop;
}
function $65509758fdfeb074$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $65509758fdfeb074$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $65509758fdfeb074$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $65509758fdfeb074$var$Promise(function(resolve, reject) {
        var cleanup = $65509758fdfeb074$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $65509758fdfeb074$var$eos;
module.exports.finished = $65509758fdfeb074$var$finished;

});
parcelRegister("cWkNZ", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $96bb0a51fb131682$var$SymbolAsyncIterator = $hgdke.SymbolAsyncIterator, $96bb0a51fb131682$var$SymbolIterator = $hgdke.SymbolIterator, $96bb0a51fb131682$var$SymbolFor = $hgdke.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $96bb0a51fb131682$var$kIsDestroyed = $96bb0a51fb131682$var$SymbolFor('nodejs.stream.destroyed');
var $96bb0a51fb131682$var$kIsErrored = $96bb0a51fb131682$var$SymbolFor('nodejs.stream.errored');
var $96bb0a51fb131682$var$kIsReadable = $96bb0a51fb131682$var$SymbolFor('nodejs.stream.readable');
var $96bb0a51fb131682$var$kIsWritable = $96bb0a51fb131682$var$SymbolFor('nodejs.stream.writable');
var $96bb0a51fb131682$var$kIsDisturbed = $96bb0a51fb131682$var$SymbolFor('nodejs.stream.disturbed');
var $96bb0a51fb131682$var$kIsClosedPromise = $96bb0a51fb131682$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $96bb0a51fb131682$var$kControllerErrorFunction = $96bb0a51fb131682$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $96bb0a51fb131682$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $96bb0a51fb131682$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $96bb0a51fb131682$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $96bb0a51fb131682$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $96bb0a51fb131682$var$isReadableStream(obj) {
    return !!(obj && !$96bb0a51fb131682$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $96bb0a51fb131682$var$isWritableStream(obj) {
    return !!(obj && !$96bb0a51fb131682$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $96bb0a51fb131682$var$isTransformStream(obj) {
    return !!(obj && !$96bb0a51fb131682$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $96bb0a51fb131682$var$isWebStream(obj) {
    return $96bb0a51fb131682$var$isReadableStream(obj) || $96bb0a51fb131682$var$isWritableStream(obj) || $96bb0a51fb131682$var$isTransformStream(obj);
}
function $96bb0a51fb131682$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$96bb0a51fb131682$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$96bb0a51fb131682$var$SymbolIterator] === 'function';
    return typeof obj[$96bb0a51fb131682$var$SymbolAsyncIterator] === 'function' || typeof obj[$96bb0a51fb131682$var$SymbolIterator] === 'function';
}
function $96bb0a51fb131682$var$isDestroyed(stream) {
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$96bb0a51fb131682$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $96bb0a51fb131682$var$isWritableEnded(stream) {
    if (!$96bb0a51fb131682$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $96bb0a51fb131682$var$isWritableFinished(stream, strict) {
    if (!$96bb0a51fb131682$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $96bb0a51fb131682$var$isReadableEnded(stream) {
    if (!$96bb0a51fb131682$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $96bb0a51fb131682$var$isReadableFinished(stream, strict) {
    if (!$96bb0a51fb131682$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $96bb0a51fb131682$var$isReadable(stream) {
    if (stream && stream[$96bb0a51fb131682$var$kIsReadable] != null) return stream[$96bb0a51fb131682$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($96bb0a51fb131682$var$isDestroyed(stream)) return false;
    return $96bb0a51fb131682$var$isReadableNodeStream(stream) && stream.readable && !$96bb0a51fb131682$var$isReadableFinished(stream);
}
function $96bb0a51fb131682$var$isWritable(stream) {
    if (stream && stream[$96bb0a51fb131682$var$kIsWritable] != null) return stream[$96bb0a51fb131682$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($96bb0a51fb131682$var$isDestroyed(stream)) return false;
    return $96bb0a51fb131682$var$isWritableNodeStream(stream) && stream.writable && !$96bb0a51fb131682$var$isWritableEnded(stream);
}
function $96bb0a51fb131682$var$isFinished(stream, opts) {
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    if ($96bb0a51fb131682$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $96bb0a51fb131682$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $96bb0a51fb131682$var$isWritable(stream)) return false;
    return true;
}
function $96bb0a51fb131682$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $96bb0a51fb131682$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $96bb0a51fb131682$var$isClosed(stream) {
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $96bb0a51fb131682$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $96bb0a51fb131682$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $96bb0a51fb131682$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $96bb0a51fb131682$var$isOutgoingMessage(stream);
}
function $96bb0a51fb131682$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $96bb0a51fb131682$var$willEmitClose(stream) {
    if (!$96bb0a51fb131682$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $96bb0a51fb131682$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $96bb0a51fb131682$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$96bb0a51fb131682$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $96bb0a51fb131682$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$96bb0a51fb131682$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $96bb0a51fb131682$var$isDestroyed,
    kIsDestroyed: $96bb0a51fb131682$var$kIsDestroyed,
    isDisturbed: $96bb0a51fb131682$var$isDisturbed,
    kIsDisturbed: $96bb0a51fb131682$var$kIsDisturbed,
    isErrored: $96bb0a51fb131682$var$isErrored,
    kIsErrored: $96bb0a51fb131682$var$kIsErrored,
    isReadable: $96bb0a51fb131682$var$isReadable,
    kIsReadable: $96bb0a51fb131682$var$kIsReadable,
    kIsClosedPromise: $96bb0a51fb131682$var$kIsClosedPromise,
    kControllerErrorFunction: $96bb0a51fb131682$var$kControllerErrorFunction,
    kIsWritable: $96bb0a51fb131682$var$kIsWritable,
    isClosed: $96bb0a51fb131682$var$isClosed,
    isDuplexNodeStream: $96bb0a51fb131682$var$isDuplexNodeStream,
    isFinished: $96bb0a51fb131682$var$isFinished,
    isIterable: $96bb0a51fb131682$var$isIterable,
    isReadableNodeStream: $96bb0a51fb131682$var$isReadableNodeStream,
    isReadableStream: $96bb0a51fb131682$var$isReadableStream,
    isReadableEnded: $96bb0a51fb131682$var$isReadableEnded,
    isReadableFinished: $96bb0a51fb131682$var$isReadableFinished,
    isReadableErrored: $96bb0a51fb131682$var$isReadableErrored,
    isNodeStream: $96bb0a51fb131682$var$isNodeStream,
    isWebStream: $96bb0a51fb131682$var$isWebStream,
    isWritable: $96bb0a51fb131682$var$isWritable,
    isWritableNodeStream: $96bb0a51fb131682$var$isWritableNodeStream,
    isWritableStream: $96bb0a51fb131682$var$isWritableStream,
    isWritableEnded: $96bb0a51fb131682$var$isWritableEnded,
    isWritableFinished: $96bb0a51fb131682$var$isWritableFinished,
    isWritableErrored: $96bb0a51fb131682$var$isWritableErrored,
    isServerRequest: $96bb0a51fb131682$var$isServerRequest,
    isServerResponse: $96bb0a51fb131682$var$isServerResponse,
    willEmitClose: $96bb0a51fb131682$var$willEmitClose,
    isTransformStream: $96bb0a51fb131682$var$isTransformStream
};

});


parcelRegister("esW12", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $9sHDO = parcelRequire("9sHDO");
var $a880aef4da3cb1c7$require$pipeline = $9sHDO.pipeline;

var $4nQiX = parcelRequire("4nQiX");

var $5Ble2 = parcelRequire("5Ble2");
var $a880aef4da3cb1c7$require$destroyer = $5Ble2.destroyer;

var $cWkNZ = parcelRequire("cWkNZ");
var $a880aef4da3cb1c7$var$isNodeStream = $cWkNZ.isNodeStream, $a880aef4da3cb1c7$var$isReadable = $cWkNZ.isReadable, $a880aef4da3cb1c7$var$isWritable = $cWkNZ.isWritable, $a880aef4da3cb1c7$var$isWebStream = $cWkNZ.isWebStream, $a880aef4da3cb1c7$var$isTransformStream = $cWkNZ.isTransformStream, $a880aef4da3cb1c7$var$isWritableStream = $cWkNZ.isWritableStream, $a880aef4da3cb1c7$var$isReadableStream = $cWkNZ.isReadableStream;

var $fjBv2 = parcelRequire("fjBv2");
var $a880aef4da3cb1c7$var$AbortError = $fjBv2.AbortError, $a880aef4da3cb1c7$var$_require_codes = $fjBv2.codes, $a880aef4da3cb1c7$var$ERR_INVALID_ARG_VALUE = $a880aef4da3cb1c7$var$_require_codes.ERR_INVALID_ARG_VALUE, $a880aef4da3cb1c7$var$ERR_MISSING_ARGS = $a880aef4da3cb1c7$var$_require_codes.ERR_MISSING_ARGS;

var $8Hinb = parcelRequire("8Hinb");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $a880aef4da3cb1c7$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $4nQiX.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $4nQiX.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $4nQiX.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$a880aef4da3cb1c7$var$isNodeStream(streams[n]) && !$a880aef4da3cb1c7$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($a880aef4da3cb1c7$var$isReadable(streams[n]) || $a880aef4da3cb1c7$var$isReadableStream(streams[n]) || $a880aef4da3cb1c7$var$isTransformStream(streams[n]))) throw new $a880aef4da3cb1c7$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($a880aef4da3cb1c7$var$isWritable(streams[n]) || $a880aef4da3cb1c7$var$isWritableStream(streams[n]) || $a880aef4da3cb1c7$var$isTransformStream(streams[n]))) throw new $a880aef4da3cb1c7$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $a880aef4da3cb1c7$require$pipeline(streams, onfinished);
    var writable = !!($a880aef4da3cb1c7$var$isWritable(head) || $a880aef4da3cb1c7$var$isWritableStream(head) || $a880aef4da3cb1c7$var$isTransformStream(head));
    var readable = !!($a880aef4da3cb1c7$var$isReadable(tail) || $a880aef4da3cb1c7$var$isReadableStream(tail) || $a880aef4da3cb1c7$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $4nQiX({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($a880aef4da3cb1c7$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($a880aef4da3cb1c7$var$isWebStream(head)) {
            var writable1 = $a880aef4da3cb1c7$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $a880aef4da3cb1c7$var$isTransformStream(tail) ? tail.readable : tail;
        $8Hinb(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($a880aef4da3cb1c7$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($a880aef4da3cb1c7$var$isWebStream(tail)) {
            var readable1 = $a880aef4da3cb1c7$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $a880aef4da3cb1c7$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($a880aef4da3cb1c7$var$isNodeStream(tail)) $a880aef4da3cb1c7$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("9sHDO", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $6e3894ce88870d96$var$ArrayIsArray = $hgdke.ArrayIsArray, $6e3894ce88870d96$var$Promise = $hgdke.Promise, $6e3894ce88870d96$var$SymbolAsyncIterator = $hgdke.SymbolAsyncIterator, $6e3894ce88870d96$var$SymbolDispose = $hgdke.SymbolDispose;

var $8Hinb = parcelRequire("8Hinb");

var $6e3894ce88870d96$require$once = (parcelRequire("1CjWp")).once;

var $5Ble2 = parcelRequire("5Ble2");

var $4nQiX = parcelRequire("4nQiX");

var $fjBv2 = parcelRequire("fjBv2");
var $6e3894ce88870d96$var$aggregateTwoErrors = $fjBv2.aggregateTwoErrors, $6e3894ce88870d96$var$_require_codes = $fjBv2.codes, $6e3894ce88870d96$var$ERR_INVALID_ARG_TYPE = $6e3894ce88870d96$var$_require_codes.ERR_INVALID_ARG_TYPE, $6e3894ce88870d96$var$ERR_INVALID_RETURN_VALUE = $6e3894ce88870d96$var$_require_codes.ERR_INVALID_RETURN_VALUE, $6e3894ce88870d96$var$ERR_MISSING_ARGS = $6e3894ce88870d96$var$_require_codes.ERR_MISSING_ARGS, $6e3894ce88870d96$var$ERR_STREAM_DESTROYED = $6e3894ce88870d96$var$_require_codes.ERR_STREAM_DESTROYED, $6e3894ce88870d96$var$ERR_STREAM_PREMATURE_CLOSE = $6e3894ce88870d96$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $6e3894ce88870d96$var$AbortError = $fjBv2.AbortError;

var $LzD4s = parcelRequire("LzD4s");
var $6e3894ce88870d96$var$validateFunction = $LzD4s.validateFunction, $6e3894ce88870d96$var$validateAbortSignal = $LzD4s.validateAbortSignal;

var $cWkNZ = parcelRequire("cWkNZ");
var $6e3894ce88870d96$var$isIterable = $cWkNZ.isIterable, $6e3894ce88870d96$var$isReadable = $cWkNZ.isReadable, $6e3894ce88870d96$var$isReadableNodeStream = $cWkNZ.isReadableNodeStream, $6e3894ce88870d96$var$isNodeStream = $cWkNZ.isNodeStream, $6e3894ce88870d96$var$isTransformStream = $cWkNZ.isTransformStream, $6e3894ce88870d96$var$isWebStream = $cWkNZ.isWebStream, $6e3894ce88870d96$var$isReadableStream = $cWkNZ.isReadableStream, $6e3894ce88870d96$var$isReadableFinished = $cWkNZ.isReadableFinished;

var $6e3894ce88870d96$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $6e3894ce88870d96$var$PassThrough;
var $6e3894ce88870d96$var$Readable;
var $6e3894ce88870d96$var$addAbortListener;
function $6e3894ce88870d96$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $8Hinb(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $5Ble2.destroyer(stream, err || new $6e3894ce88870d96$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $6e3894ce88870d96$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $6e3894ce88870d96$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $6e3894ce88870d96$var$makeAsyncIterable(val) {
    if ($6e3894ce88870d96$var$isIterable(val)) return val;
    else if ($6e3894ce88870d96$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $6e3894ce88870d96$var$fromReadable(val);
    throw new $6e3894ce88870d96$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $6e3894ce88870d96$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$6e3894ce88870d96$var$Readable) $6e3894ce88870d96$var$Readable = (parcelRequire("gax2P"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($6e3894ce88870d96$var$Readable.prototype[$6e3894ce88870d96$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $6e3894ce88870d96$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $6e3894ce88870d96$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $8Hinb(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $6e3894ce88870d96$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $6e3894ce88870d96$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($6e3894ce88870d96$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $6e3894ce88870d96$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $6e3894ce88870d96$var$pipelineImpl(streams, $6e3894ce88870d96$require$once($6e3894ce88870d96$var$popCallback(streams)));
}


function $6e3894ce88870d96$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($6e3894ce88870d96$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $6e3894ce88870d96$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($6e3894ce88870d96$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($6e3894ce88870d96$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$6e3894ce88870d96$var$isIterable(ret)) throw new $6e3894ce88870d96$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($6e3894ce88870d96$var$isIterable(stream) || $6e3894ce88870d96$var$isReadableNodeStream(stream) || $6e3894ce88870d96$var$isTransformStream(stream)) ret = stream;
            else ret = $4nQiX.from(stream);
        } else if (typeof stream === 'function') {
            if ($6e3894ce88870d96$var$isTransformStream(ret)) {
                var _ret;
                ret = $6e3894ce88870d96$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $6e3894ce88870d96$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$6e3894ce88870d96$var$isIterable(ret, true)) throw new $6e3894ce88870d96$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$6e3894ce88870d96$var$PassThrough) $6e3894ce88870d96$var$PassThrough = (parcelRequire("87bsp"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $6e3894ce88870d96$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($6e3894ce88870d96$var$isIterable(ret, true)) {
                    finishCount++;
                    $6e3894ce88870d96$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($6e3894ce88870d96$var$isReadableStream(ret) || $6e3894ce88870d96$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $6e3894ce88870d96$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $6e3894ce88870d96$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $6e3894ce88870d96$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($6e3894ce88870d96$var$isNodeStream(stream)) {
            if ($6e3894ce88870d96$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $6e3894ce88870d96$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($6e3894ce88870d96$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($6e3894ce88870d96$var$isTransformStream(ret) || $6e3894ce88870d96$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $6e3894ce88870d96$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($6e3894ce88870d96$var$isIterable(ret)) {
                finishCount++;
                $6e3894ce88870d96$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $6e3894ce88870d96$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($6e3894ce88870d96$var$isWebStream(stream)) {
            if ($6e3894ce88870d96$var$isReadableNodeStream(ret)) {
                finishCount++;
                $6e3894ce88870d96$var$pumpToWeb($6e3894ce88870d96$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($6e3894ce88870d96$var$isReadableStream(ret) || $6e3894ce88870d96$var$isIterable(ret)) {
                finishCount++;
                $6e3894ce88870d96$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($6e3894ce88870d96$var$isTransformStream(ret)) {
                finishCount++;
                $6e3894ce88870d96$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $6e3894ce88870d96$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $4nQiX.from(stream);
    };
    if (streams.length === 1 && $6e3894ce88870d96$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $6e3894ce88870d96$var$ERR_MISSING_ARGS('streams');
    var ac = new $6e3894ce88870d96$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $6e3894ce88870d96$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $6e3894ce88870d96$var$AbortError());
    }
    $6e3894ce88870d96$var$addAbortListener = $6e3894ce88870d96$var$addAbortListener || (parcelRequire("1CjWp")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $6e3894ce88870d96$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$6e3894ce88870d96$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $6e3894ce88870d96$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $6e3894ce88870d96$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($6e3894ce88870d96$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $8Hinb(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $8Hinb(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $6e3894ce88870d96$var$pipelineImpl,
    pipeline: $6e3894ce88870d96$var$pipeline
};

});
parcelRegister("5Ble2", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fjBv2 = parcelRequire("fjBv2");
/* replacement end */ var $4140df63a895bbbe$var$aggregateTwoErrors = $fjBv2.aggregateTwoErrors, $4140df63a895bbbe$var$ERR_MULTIPLE_CALLBACK = $fjBv2.codes.ERR_MULTIPLE_CALLBACK, $4140df63a895bbbe$var$AbortError = $fjBv2.AbortError;

var $hgdke = parcelRequire("hgdke");
var $4140df63a895bbbe$require$Symbol = $hgdke.Symbol;

var $cWkNZ = parcelRequire("cWkNZ");
var $4140df63a895bbbe$var$kIsDestroyed = $cWkNZ.kIsDestroyed, $4140df63a895bbbe$var$isDestroyed = $cWkNZ.isDestroyed, $4140df63a895bbbe$var$isFinished = $cWkNZ.isFinished, $4140df63a895bbbe$var$isServerRequest = $cWkNZ.isServerRequest;
var $4140df63a895bbbe$var$kDestroy = $4140df63a895bbbe$require$Symbol('kDestroy');
var $4140df63a895bbbe$var$kConstruct = $4140df63a895bbbe$require$Symbol('kConstruct');
function $4140df63a895bbbe$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $4140df63a895bbbe$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $4140df63a895bbbe$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($4140df63a895bbbe$var$kDestroy, function(er) {
        $4140df63a895bbbe$var$_destroy(this, $4140df63a895bbbe$var$aggregateTwoErrors(er, err), cb);
    });
    else $4140df63a895bbbe$var$_destroy(this, err, cb);
    return this;
}
function $4140df63a895bbbe$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $4140df63a895bbbe$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($4140df63a895bbbe$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($4140df63a895bbbe$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $4140df63a895bbbe$var$emitErrorCloseNT(self, err) {
    $4140df63a895bbbe$var$emitErrorNT(self, err);
    $4140df63a895bbbe$var$emitCloseNT(self);
}
function $4140df63a895bbbe$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $4140df63a895bbbe$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $4140df63a895bbbe$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $4140df63a895bbbe$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($4140df63a895bbbe$var$emitErrorNT, stream, err);
        else $4140df63a895bbbe$var$emitErrorNT(stream, err);
    }
}
function $4140df63a895bbbe$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($4140df63a895bbbe$var$kConstruct, cb);
    if (stream.listenerCount($4140df63a895bbbe$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($4140df63a895bbbe$var$constructNT, stream);
}
function $4140df63a895bbbe$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $4140df63a895bbbe$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $4140df63a895bbbe$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($4140df63a895bbbe$var$kDestroy, err);
        else if (err) $4140df63a895bbbe$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($4140df63a895bbbe$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $4140df63a895bbbe$var$emitConstructNT(stream) {
    stream.emit($4140df63a895bbbe$var$kConstruct);
}
function $4140df63a895bbbe$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $4140df63a895bbbe$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $4140df63a895bbbe$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($4140df63a895bbbe$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $4140df63a895bbbe$var$destroyer(stream, err) {
    if (!stream || $4140df63a895bbbe$var$isDestroyed(stream)) return;
    if (!err && !$4140df63a895bbbe$var$isFinished(stream)) err = new $4140df63a895bbbe$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($4140df63a895bbbe$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($4140df63a895bbbe$var$isRequest(stream)) stream.abort();
    else if ($4140df63a895bbbe$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($4140df63a895bbbe$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($4140df63a895bbbe$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$4140df63a895bbbe$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $4140df63a895bbbe$var$construct,
    destroyer: $4140df63a895bbbe$var$destroyer,
    destroy: $4140df63a895bbbe$var$destroy,
    undestroy: $4140df63a895bbbe$var$undestroy,
    errorOrDestroy: $4140df63a895bbbe$var$errorOrDestroy
};

});

parcelRegister("4nQiX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $3311e2099e237309$var$ObjectDefineProperties = $hgdke.ObjectDefineProperties, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor = $hgdke.ObjectGetOwnPropertyDescriptor, $3311e2099e237309$var$ObjectKeys = $hgdke.ObjectKeys, $3311e2099e237309$var$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf;
module.exports = $3311e2099e237309$var$Duplex;

var $gax2P = parcelRequire("gax2P");

var $guOHm = parcelRequire("guOHm");
$3311e2099e237309$var$ObjectSetPrototypeOf($3311e2099e237309$var$Duplex.prototype, $gax2P.prototype);
$3311e2099e237309$var$ObjectSetPrototypeOf($3311e2099e237309$var$Duplex, $gax2P);
{
    var $3311e2099e237309$var$keys = $3311e2099e237309$var$ObjectKeys($guOHm.prototype);
    // Allow the keys array to be GC'ed.
    for(var $3311e2099e237309$var$i = 0; $3311e2099e237309$var$i < $3311e2099e237309$var$keys.length; $3311e2099e237309$var$i++){
        var $3311e2099e237309$var$method = $3311e2099e237309$var$keys[$3311e2099e237309$var$i];
        if (!$3311e2099e237309$var$Duplex.prototype[$3311e2099e237309$var$method]) $3311e2099e237309$var$Duplex.prototype[$3311e2099e237309$var$method] = $guOHm.prototype[$3311e2099e237309$var$method];
    }
}function $3311e2099e237309$var$Duplex(options) {
    if (!(this instanceof $3311e2099e237309$var$Duplex)) return new $3311e2099e237309$var$Duplex(options);
    $gax2P.call(this, options);
    $guOHm.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$3311e2099e237309$var$ObjectDefineProperties($3311e2099e237309$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $3311e2099e237309$var$ObjectGetOwnPropertyDescriptor($guOHm.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $3311e2099e237309$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3311e2099e237309$var$lazyWebStreams() {
    if ($3311e2099e237309$var$webStreamsAdapters === undefined) $3311e2099e237309$var$webStreamsAdapters = {};
    return $3311e2099e237309$var$webStreamsAdapters;
}
$3311e2099e237309$var$Duplex.fromWeb = function(pair, options) {
    return $3311e2099e237309$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$3311e2099e237309$var$Duplex.toWeb = function(duplex) {
    return $3311e2099e237309$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $3311e2099e237309$var$duplexify;

$3311e2099e237309$var$Duplex.from = function(body) {
    if (!$3311e2099e237309$var$duplexify) $3311e2099e237309$var$duplexify = (parcelRequire("l4huW"));
    return $3311e2099e237309$var$duplexify(body, 'body');
};

});
parcelRegister("gax2P", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hgdke = parcelRequire("hgdke");
/* replacement end */ var $bc573679ea7bdc8a$var$ArrayPrototypeIndexOf = $hgdke.ArrayPrototypeIndexOf, $bc573679ea7bdc8a$var$NumberIsInteger = $hgdke.NumberIsInteger, $bc573679ea7bdc8a$var$NumberIsNaN = $hgdke.NumberIsNaN, $bc573679ea7bdc8a$var$NumberParseInt = $hgdke.NumberParseInt, $bc573679ea7bdc8a$var$ObjectDefineProperties = $hgdke.ObjectDefineProperties, $bc573679ea7bdc8a$var$ObjectKeys = $hgdke.ObjectKeys, $bc573679ea7bdc8a$var$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf, $bc573679ea7bdc8a$var$Promise = $hgdke.Promise, $bc573679ea7bdc8a$var$SafeSet = $hgdke.SafeSet, $bc573679ea7bdc8a$var$SymbolAsyncDispose = $hgdke.SymbolAsyncDispose, $bc573679ea7bdc8a$var$SymbolAsyncIterator = $hgdke.SymbolAsyncIterator, $bc573679ea7bdc8a$var$Symbol = $hgdke.Symbol;
module.exports = $bc573679ea7bdc8a$var$Readable;
$bc573679ea7bdc8a$var$Readable.ReadableState = $bc573679ea7bdc8a$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $bc573679ea7bdc8a$var$EE = $bBoAO.EventEmitter;

var $juCgb = parcelRequire("juCgb");
var $bc573679ea7bdc8a$var$Stream = $juCgb.Stream, $bc573679ea7bdc8a$var$prependListener = $juCgb.prependListener;

var $becUP = parcelRequire("becUP");
var $bc573679ea7bdc8a$require$Buffer = $becUP.Buffer;

var $9yDYJ = parcelRequire("9yDYJ");
var $bc573679ea7bdc8a$require$addAbortSignal = $9yDYJ.addAbortSignal;

var $8Hinb = parcelRequire("8Hinb");

var $bc573679ea7bdc8a$var$debug = (parcelRequire("1CjWp")).debuglog('stream', function(fn) {
    $bc573679ea7bdc8a$var$debug = fn;
});

var $JO6FJ = parcelRequire("JO6FJ");

var $5Ble2 = parcelRequire("5Ble2");

var $gKnMe = parcelRequire("gKnMe");
var $bc573679ea7bdc8a$var$getHighWaterMark = $gKnMe.getHighWaterMark, $bc573679ea7bdc8a$var$getDefaultHighWaterMark = $gKnMe.getDefaultHighWaterMark;

var $fjBv2 = parcelRequire("fjBv2");
var $bc573679ea7bdc8a$var$aggregateTwoErrors = $fjBv2.aggregateTwoErrors, $bc573679ea7bdc8a$var$_require_codes = $fjBv2.codes, $bc573679ea7bdc8a$var$ERR_INVALID_ARG_TYPE = $bc573679ea7bdc8a$var$_require_codes.ERR_INVALID_ARG_TYPE, $bc573679ea7bdc8a$var$ERR_METHOD_NOT_IMPLEMENTED = $bc573679ea7bdc8a$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $bc573679ea7bdc8a$var$ERR_OUT_OF_RANGE = $bc573679ea7bdc8a$var$_require_codes.ERR_OUT_OF_RANGE, $bc573679ea7bdc8a$var$ERR_STREAM_PUSH_AFTER_EOF = $bc573679ea7bdc8a$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $bc573679ea7bdc8a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $bc573679ea7bdc8a$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $bc573679ea7bdc8a$var$AbortError = $fjBv2.AbortError;

var $LzD4s = parcelRequire("LzD4s");
var $bc573679ea7bdc8a$require$validateObject = $LzD4s.validateObject;
var $bc573679ea7bdc8a$var$kPaused = $bc573679ea7bdc8a$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $bc573679ea7bdc8a$require$StringDecoder = $3Jf7C.StringDecoder;

var $hl27j = parcelRequire("hl27j");
$bc573679ea7bdc8a$var$ObjectSetPrototypeOf($bc573679ea7bdc8a$var$Readable.prototype, $bc573679ea7bdc8a$var$Stream.prototype);
$bc573679ea7bdc8a$var$ObjectSetPrototypeOf($bc573679ea7bdc8a$var$Readable, $bc573679ea7bdc8a$var$Stream);
var $bc573679ea7bdc8a$var$nop = function() {};
var $bc573679ea7bdc8a$var$errorOrDestroy = $5Ble2.errorOrDestroy;
var $bc573679ea7bdc8a$var$kObjectMode = 1;
var $bc573679ea7bdc8a$var$kEnded = 2;
var $bc573679ea7bdc8a$var$kEndEmitted = 4;
var $bc573679ea7bdc8a$var$kReading = 8;
var $bc573679ea7bdc8a$var$kConstructed = 16;
var $bc573679ea7bdc8a$var$kSync = 32;
var $bc573679ea7bdc8a$var$kNeedReadable = 64;
var $bc573679ea7bdc8a$var$kEmittedReadable = 128;
var $bc573679ea7bdc8a$var$kReadableListening = 256;
var $bc573679ea7bdc8a$var$kResumeScheduled = 512;
var $bc573679ea7bdc8a$var$kErrorEmitted = 1024;
var $bc573679ea7bdc8a$var$kEmitClose = 2048;
var $bc573679ea7bdc8a$var$kAutoDestroy = 4096;
var $bc573679ea7bdc8a$var$kDestroyed = 8192;
var $bc573679ea7bdc8a$var$kClosed = 16384;
var $bc573679ea7bdc8a$var$kCloseEmitted = 32768;
var $bc573679ea7bdc8a$var$kMultiAwaitDrain = 65536;
var $bc573679ea7bdc8a$var$kReadingMore = 131072;
var $bc573679ea7bdc8a$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $bc573679ea7bdc8a$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$bc573679ea7bdc8a$var$ObjectDefineProperties($bc573679ea7bdc8a$var$ReadableState.prototype, {
    objectMode: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kObjectMode),
    ended: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kEnded),
    endEmitted: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kEndEmitted),
    reading: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kNeedReadable),
    emittedReadable: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kEmittedReadable),
    readableListening: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kReadableListening),
    resumeScheduled: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kErrorEmitted),
    emitClose: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kEmitClose),
    autoDestroy: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kCloseEmitted),
    multiAwaitDrain: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kReadingMore),
    dataEmitted: $bc573679ea7bdc8a$var$makeBitMapDescriptor($bc573679ea7bdc8a$var$kDataEmitted)
});

function $bc573679ea7bdc8a$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("4nQiX"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $bc573679ea7bdc8a$var$kEmitClose | $bc573679ea7bdc8a$var$kAutoDestroy | $bc573679ea7bdc8a$var$kConstructed | $bc573679ea7bdc8a$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $bc573679ea7bdc8a$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $bc573679ea7bdc8a$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $bc573679ea7bdc8a$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $bc573679ea7bdc8a$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $JO6FJ();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$bc573679ea7bdc8a$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$bc573679ea7bdc8a$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$bc573679ea7bdc8a$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $bc573679ea7bdc8a$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bc573679ea7bdc8a$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $bc573679ea7bdc8a$var$Readable)) return new $bc573679ea7bdc8a$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("4nQiX"));
    this._readableState = new $bc573679ea7bdc8a$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $bc573679ea7bdc8a$require$addAbortSignal(options.signal, this);
    }
    $bc573679ea7bdc8a$var$Stream.call(this, options);
    $5Ble2.construct(this, function() {
        if (_this._readableState.needReadable) $bc573679ea7bdc8a$var$maybeReadMore(_this, _this._readableState);
    });
}
$bc573679ea7bdc8a$var$Readable.prototype.destroy = $5Ble2.destroy;
$bc573679ea7bdc8a$var$Readable.prototype._undestroy = $5Ble2.undestroy;
$bc573679ea7bdc8a$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$bc573679ea7bdc8a$var$Readable.prototype[$bc573679ea7bdc8a$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$bc573679ea7bdc8a$var$Readable.prototype[$bc573679ea7bdc8a$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $bc573679ea7bdc8a$var$AbortError();
        this.destroy(error);
    }
    return new $bc573679ea7bdc8a$var$Promise(function(resolve, reject) {
        return $8Hinb(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bc573679ea7bdc8a$var$Readable.prototype.push = function(chunk, encoding) {
    return $bc573679ea7bdc8a$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$bc573679ea7bdc8a$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $bc573679ea7bdc8a$var$readableAddChunk(this, chunk, encoding, true);
};
function $bc573679ea7bdc8a$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $bc573679ea7bdc8a$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $bc573679ea7bdc8a$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $bc573679ea7bdc8a$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $bc573679ea7bdc8a$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $bc573679ea7bdc8a$require$Buffer) encoding = '';
        else if ($bc573679ea7bdc8a$var$Stream._isUint8Array(chunk)) {
            chunk = $bc573679ea7bdc8a$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $bc573679ea7bdc8a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $bc573679ea7bdc8a$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$bc573679ea7bdc8a$var$kReading;
        $bc573679ea7bdc8a$var$onEofChunk(stream, state);
    } else if ((state.state & $bc573679ea7bdc8a$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $bc573679ea7bdc8a$var$kEndEmitted) !== 0) $bc573679ea7bdc8a$var$errorOrDestroy(stream, new $bc573679ea7bdc8a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $bc573679ea7bdc8a$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $bc573679ea7bdc8a$var$errorOrDestroy(stream, new $bc573679ea7bdc8a$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$bc573679ea7bdc8a$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $bc573679ea7bdc8a$var$addChunk(stream, state, chunk, false);
                else $bc573679ea7bdc8a$var$maybeReadMore(stream, state);
            } else $bc573679ea7bdc8a$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$bc573679ea7bdc8a$var$kReading;
        $bc573679ea7bdc8a$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bc573679ea7bdc8a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $bc573679ea7bdc8a$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $bc573679ea7bdc8a$var$kNeedReadable) !== 0) $bc573679ea7bdc8a$var$emitReadable(stream);
    }
    $bc573679ea7bdc8a$var$maybeReadMore(stream, state);
}
$bc573679ea7bdc8a$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$bc573679ea7bdc8a$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$bc573679ea7bdc8a$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $bc573679ea7bdc8a$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$bc573679ea7bdc8a$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $bc573679ea7bdc8a$var$MAX_HWM = 0x40000000;
function $bc573679ea7bdc8a$var$computeNewHighWaterMark(n) {
    if (n > $bc573679ea7bdc8a$var$MAX_HWM) throw new $bc573679ea7bdc8a$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc573679ea7bdc8a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $bc573679ea7bdc8a$var$kObjectMode) !== 0) return 1;
    if ($bc573679ea7bdc8a$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$bc573679ea7bdc8a$var$Readable.prototype.read = function(n) {
    $bc573679ea7bdc8a$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$bc573679ea7bdc8a$var$NumberIsInteger(n)) n = $bc573679ea7bdc8a$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bc573679ea7bdc8a$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$bc573679ea7bdc8a$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bc573679ea7bdc8a$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bc573679ea7bdc8a$var$endReadable(this);
        else $bc573679ea7bdc8a$var$emitReadable(this);
        return null;
    }
    n = $bc573679ea7bdc8a$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bc573679ea7bdc8a$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $bc573679ea7bdc8a$var$kNeedReadable) !== 0;
    $bc573679ea7bdc8a$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bc573679ea7bdc8a$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $bc573679ea7bdc8a$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $bc573679ea7bdc8a$var$debug('do read');
        state.state |= $bc573679ea7bdc8a$var$kReading | $bc573679ea7bdc8a$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $bc573679ea7bdc8a$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $bc573679ea7bdc8a$var$errorOrDestroy(this, err);
        }
        state.state &= ~$bc573679ea7bdc8a$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bc573679ea7bdc8a$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bc573679ea7bdc8a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bc573679ea7bdc8a$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $bc573679ea7bdc8a$var$onEofChunk(stream, state) {
    $bc573679ea7bdc8a$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $bc573679ea7bdc8a$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $bc573679ea7bdc8a$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bc573679ea7bdc8a$var$emitReadable(stream) {
    var state = stream._readableState;
    $bc573679ea7bdc8a$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bc573679ea7bdc8a$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($bc573679ea7bdc8a$var$emitReadable_, stream);
    }
}
function $bc573679ea7bdc8a$var$emitReadable_(stream) {
    var state = stream._readableState;
    $bc573679ea7bdc8a$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bc573679ea7bdc8a$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bc573679ea7bdc8a$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($bc573679ea7bdc8a$var$maybeReadMore_, stream, state);
    }
}
function $bc573679ea7bdc8a$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $bc573679ea7bdc8a$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bc573679ea7bdc8a$var$Readable.prototype._read = function(n) {
    throw new $bc573679ea7bdc8a$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$bc573679ea7bdc8a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $bc573679ea7bdc8a$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $bc573679ea7bdc8a$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bc573679ea7bdc8a$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bc573679ea7bdc8a$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $bc573679ea7bdc8a$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $bc573679ea7bdc8a$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $bc573679ea7bdc8a$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $bc573679ea7bdc8a$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $bc573679ea7bdc8a$var$debug('ondata');
        var ret = dest.write(chunk);
        $bc573679ea7bdc8a$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bc573679ea7bdc8a$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $bc573679ea7bdc8a$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $bc573679ea7bdc8a$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bc573679ea7bdc8a$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bc573679ea7bdc8a$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $bc573679ea7bdc8a$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bc573679ea7bdc8a$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $bc573679ea7bdc8a$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $bc573679ea7bdc8a$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$bc573679ea7bdc8a$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $bc573679ea7bdc8a$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$bc573679ea7bdc8a$var$Readable.prototype.on = function(ev, fn) {
    var res = $bc573679ea7bdc8a$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bc573679ea7bdc8a$var$debug('on readable', state.length, state.reading);
            if (state.length) $bc573679ea7bdc8a$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($bc573679ea7bdc8a$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bc573679ea7bdc8a$var$Readable.prototype.addListener = $bc573679ea7bdc8a$var$Readable.prototype.on;
$bc573679ea7bdc8a$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $bc573679ea7bdc8a$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($bc573679ea7bdc8a$var$updateReadableListening, this);
    return res;
};
$bc573679ea7bdc8a$var$Readable.prototype.off = $bc573679ea7bdc8a$var$Readable.prototype.removeListener;
$bc573679ea7bdc8a$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $bc573679ea7bdc8a$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($bc573679ea7bdc8a$var$updateReadableListening, this);
    return res;
};
function $bc573679ea7bdc8a$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$bc573679ea7bdc8a$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $bc573679ea7bdc8a$var$nReadingNextTick(self) {
    $bc573679ea7bdc8a$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bc573679ea7bdc8a$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bc573679ea7bdc8a$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $bc573679ea7bdc8a$var$resume(this, state);
    }
    state[$bc573679ea7bdc8a$var$kPaused] = false;
    return this;
};
function $bc573679ea7bdc8a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($bc573679ea7bdc8a$var$resume_, stream, state);
    }
}
function $bc573679ea7bdc8a$var$resume_(stream, state) {
    $bc573679ea7bdc8a$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $bc573679ea7bdc8a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bc573679ea7bdc8a$var$Readable.prototype.pause = function() {
    $bc573679ea7bdc8a$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bc573679ea7bdc8a$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$bc573679ea7bdc8a$var$kPaused] = true;
    return this;
};
function $bc573679ea7bdc8a$var$flow(stream) {
    var state = stream._readableState;
    $bc573679ea7bdc8a$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bc573679ea7bdc8a$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $bc573679ea7bdc8a$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $bc573679ea7bdc8a$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$bc573679ea7bdc8a$var$Readable.prototype[$bc573679ea7bdc8a$var$SymbolAsyncIterator] = function() {
    return $bc573679ea7bdc8a$var$streamToAsyncIterator(this);
};
$bc573679ea7bdc8a$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $bc573679ea7bdc8a$require$validateObject(options, 'options');
    return $bc573679ea7bdc8a$var$streamToAsyncIterator(this, options);
};
function $bc573679ea7bdc8a$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $bc573679ea7bdc8a$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $bc573679ea7bdc8a$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $bc573679ea7bdc8a$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $bc573679ea7bdc8a$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $bc573679ea7bdc8a$var$nop;
                    stream.on('readable', next);
                    cleanup = $8Hinb(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $bc573679ea7bdc8a$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $bc573679ea7bdc8a$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $bc573679ea7bdc8a$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $bc573679ea7bdc8a$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $5Ble2.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$bc573679ea7bdc8a$var$ObjectDefineProperties($bc573679ea7bdc8a$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$bc573679ea7bdc8a$var$ObjectDefineProperties($bc573679ea7bdc8a$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$bc573679ea7bdc8a$var$kPaused] !== false;
        },
        set: function(value) {
            this[$bc573679ea7bdc8a$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$bc573679ea7bdc8a$var$Readable._fromList = $bc573679ea7bdc8a$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc573679ea7bdc8a$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bc573679ea7bdc8a$var$endReadable(stream) {
    var state = stream._readableState;
    $bc573679ea7bdc8a$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($bc573679ea7bdc8a$var$endReadableNT, state, stream);
    }
}
function $bc573679ea7bdc8a$var$endReadableNT(state, stream) {
    $bc573679ea7bdc8a$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($bc573679ea7bdc8a$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $bc573679ea7bdc8a$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$bc573679ea7bdc8a$var$Readable.from = function(iterable, opts) {
    return $hl27j($bc573679ea7bdc8a$var$Readable, iterable, opts);
};
var $bc573679ea7bdc8a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $bc573679ea7bdc8a$var$lazyWebStreams() {
    if ($bc573679ea7bdc8a$var$webStreamsAdapters === undefined) $bc573679ea7bdc8a$var$webStreamsAdapters = {};
    return $bc573679ea7bdc8a$var$webStreamsAdapters;
}
$bc573679ea7bdc8a$var$Readable.fromWeb = function(readableStream, options) {
    return $bc573679ea7bdc8a$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$bc573679ea7bdc8a$var$Readable.toWeb = function(streamReadable, options) {
    return $bc573679ea7bdc8a$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$bc573679ea7bdc8a$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $bc573679ea7bdc8a$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $5Ble2.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("juCgb", function(module, exports) {
'use strict';

var $hgdke = parcelRequire("hgdke");
var $e30e7f4ec63eb6c7$var$ArrayIsArray = $hgdke.ArrayIsArray, $e30e7f4ec63eb6c7$var$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $e30e7f4ec63eb6c7$var$EE = $bBoAO.EventEmitter;
function $e30e7f4ec63eb6c7$var$Stream(opts) {
    $e30e7f4ec63eb6c7$var$EE.call(this, opts);
}
$e30e7f4ec63eb6c7$var$ObjectSetPrototypeOf($e30e7f4ec63eb6c7$var$Stream.prototype, $e30e7f4ec63eb6c7$var$EE.prototype);
$e30e7f4ec63eb6c7$var$ObjectSetPrototypeOf($e30e7f4ec63eb6c7$var$Stream, $e30e7f4ec63eb6c7$var$EE);
$e30e7f4ec63eb6c7$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e30e7f4ec63eb6c7$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $e30e7f4ec63eb6c7$var$prependListener(source, 'error', onerror);
    $e30e7f4ec63eb6c7$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $e30e7f4ec63eb6c7$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($e30e7f4ec63eb6c7$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $e30e7f4ec63eb6c7$var$Stream,
    prependListener: $e30e7f4ec63eb6c7$var$prependListener
};

});

parcelRegister("9yDYJ", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $6f564cec49ca9e1c$export$e2db56ee53255a0; }, function (v) { return $6f564cec49ca9e1c$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $6f564cec49ca9e1c$export$11956e9313f43de0; }, function (v) { return $6f564cec49ca9e1c$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $6f564cec49ca9e1c$export$e2db56ee53255a0;
var $6f564cec49ca9e1c$export$11956e9313f43de0;
'use strict';

var $hgdke = parcelRequire("hgdke");
var $6f564cec49ca9e1c$require$SymbolDispose = $hgdke.SymbolDispose;

var $fjBv2 = parcelRequire("fjBv2");
var $6f564cec49ca9e1c$var$AbortError = $fjBv2.AbortError, $6f564cec49ca9e1c$var$codes = $fjBv2.codes;

var $cWkNZ = parcelRequire("cWkNZ");
var $6f564cec49ca9e1c$var$isNodeStream = $cWkNZ.isNodeStream, $6f564cec49ca9e1c$var$isWebStream = $cWkNZ.isWebStream, $6f564cec49ca9e1c$var$kControllerErrorFunction = $cWkNZ.kControllerErrorFunction;

var $8Hinb = parcelRequire("8Hinb");
var $6f564cec49ca9e1c$var$ERR_INVALID_ARG_TYPE = $6f564cec49ca9e1c$var$codes.ERR_INVALID_ARG_TYPE;
var $6f564cec49ca9e1c$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $6f564cec49ca9e1c$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $6f564cec49ca9e1c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$6f564cec49ca9e1c$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $6f564cec49ca9e1c$var$validateAbortSignal(signal, 'signal');
    if (!$6f564cec49ca9e1c$var$isNodeStream(stream) && !$6f564cec49ca9e1c$var$isWebStream(stream)) throw new $6f564cec49ca9e1c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $6f564cec49ca9e1c$export$11956e9313f43de0(signal, stream);
};

$6f564cec49ca9e1c$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $6f564cec49ca9e1c$var$isNodeStream(stream) ? function() {
        stream.destroy(new $6f564cec49ca9e1c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$6f564cec49ca9e1c$var$kControllerErrorFunction](new $6f564cec49ca9e1c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $6f564cec49ca9e1c$var$addAbortListener = $6f564cec49ca9e1c$var$addAbortListener || (parcelRequire("1CjWp")).addAbortListener;
        var disposable = $6f564cec49ca9e1c$var$addAbortListener(signal, onAbort);
        $8Hinb(stream, disposable[$6f564cec49ca9e1c$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("JO6FJ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $089b1236c5815891$var$StringPrototypeSlice = $hgdke.StringPrototypeSlice, $089b1236c5815891$var$SymbolIterator = $hgdke.SymbolIterator, $089b1236c5815891$var$TypedArrayPrototypeSet = $hgdke.TypedArrayPrototypeSet, $089b1236c5815891$var$Uint8Array = $hgdke.Uint8Array;

var $becUP = parcelRequire("becUP");
var $089b1236c5815891$require$Buffer = $becUP.Buffer;

var $1CjWp = parcelRequire("1CjWp");
var $089b1236c5815891$require$inspect = $1CjWp.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $089b1236c5815891$require$Buffer.alloc(0);
                var ret = $089b1236c5815891$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $089b1236c5815891$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $089b1236c5815891$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $089b1236c5815891$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $089b1236c5815891$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $089b1236c5815891$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $089b1236c5815891$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $089b1236c5815891$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $089b1236c5815891$var$TypedArrayPrototypeSet(ret, new $089b1236c5815891$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $089b1236c5815891$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("gKnMe", function(module, exports) {
'use strict';

var $hgdke = parcelRequire("hgdke");
var $c31362cd8f5ef3da$var$MathFloor = $hgdke.MathFloor, $c31362cd8f5ef3da$var$NumberIsInteger = $hgdke.NumberIsInteger;

var $LzD4s = parcelRequire("LzD4s");
var $c31362cd8f5ef3da$require$validateInteger = $LzD4s.validateInteger;

var $c31362cd8f5ef3da$var$ERR_INVALID_ARG_VALUE = (parcelRequire("fjBv2")).codes.ERR_INVALID_ARG_VALUE;
var $c31362cd8f5ef3da$var$defaultHighWaterMarkBytes = 16384;
var $c31362cd8f5ef3da$var$defaultHighWaterMarkObjectMode = 16;
function $c31362cd8f5ef3da$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c31362cd8f5ef3da$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $c31362cd8f5ef3da$var$defaultHighWaterMarkObjectMode : $c31362cd8f5ef3da$var$defaultHighWaterMarkBytes;
}
function $c31362cd8f5ef3da$var$setDefaultHighWaterMark(objectMode, value) {
    $c31362cd8f5ef3da$require$validateInteger(value, 'value', 0);
    if (objectMode) $c31362cd8f5ef3da$var$defaultHighWaterMarkObjectMode = value;
    else $c31362cd8f5ef3da$var$defaultHighWaterMarkBytes = value;
}
function $c31362cd8f5ef3da$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c31362cd8f5ef3da$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$c31362cd8f5ef3da$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $c31362cd8f5ef3da$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $c31362cd8f5ef3da$var$MathFloor(hwm);
    }
    // Default value
    return $c31362cd8f5ef3da$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $c31362cd8f5ef3da$var$getHighWaterMark,
    getDefaultHighWaterMark: $c31362cd8f5ef3da$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $c31362cd8f5ef3da$var$setDefaultHighWaterMark
};

});

parcelRegister("hl27j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hgdke = parcelRequire("hgdke");
/* replacement end */ var $c9f60a38f5477a93$var$PromisePrototypeThen = $hgdke.PromisePrototypeThen, $c9f60a38f5477a93$var$SymbolAsyncIterator = $hgdke.SymbolAsyncIterator, $c9f60a38f5477a93$var$SymbolIterator = $hgdke.SymbolIterator;

var $becUP = parcelRequire("becUP");
var $c9f60a38f5477a93$require$Buffer = $becUP.Buffer;

var $fjBv2 = parcelRequire("fjBv2");
var $c9f60a38f5477a93$require$_require_codes = $fjBv2.codes;
var $c9f60a38f5477a93$var$ERR_INVALID_ARG_TYPE = $c9f60a38f5477a93$require$_require_codes.ERR_INVALID_ARG_TYPE, $c9f60a38f5477a93$var$ERR_STREAM_NULL_VALUES = $c9f60a38f5477a93$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $c9f60a38f5477a93$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $c9f60a38f5477a93$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$c9f60a38f5477a93$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$c9f60a38f5477a93$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$c9f60a38f5477a93$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$c9f60a38f5477a93$var$SymbolIterator]();
    } else throw new $c9f60a38f5477a93$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $c9f60a38f5477a93$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $c9f60a38f5477a93$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $c9f60a38f5477a93$var$from;

});


parcelRegister("guOHm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $hgdke = parcelRequire("hgdke");
/* replacement end */ var $c026c65736b99160$var$ArrayPrototypeSlice = $hgdke.ArrayPrototypeSlice, $c026c65736b99160$var$Error = $hgdke.Error, $c026c65736b99160$var$FunctionPrototypeSymbolHasInstance = $hgdke.FunctionPrototypeSymbolHasInstance, $c026c65736b99160$var$ObjectDefineProperty = $hgdke.ObjectDefineProperty, $c026c65736b99160$var$ObjectDefineProperties = $hgdke.ObjectDefineProperties, $c026c65736b99160$var$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf, $c026c65736b99160$var$StringPrototypeToLowerCase = $hgdke.StringPrototypeToLowerCase, $c026c65736b99160$var$Symbol = $hgdke.Symbol, $c026c65736b99160$var$SymbolHasInstance = $hgdke.SymbolHasInstance;
module.exports = $c026c65736b99160$var$Writable;
$c026c65736b99160$var$Writable.WritableState = $c026c65736b99160$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $c026c65736b99160$var$EE = $bBoAO.EventEmitter;

var $juCgb = parcelRequire("juCgb");
var $c026c65736b99160$require$Stream = $juCgb.Stream;

var $becUP = parcelRequire("becUP");
var $c026c65736b99160$require$Buffer = $becUP.Buffer;

var $5Ble2 = parcelRequire("5Ble2");

var $9yDYJ = parcelRequire("9yDYJ");
var $c026c65736b99160$require$addAbortSignal = $9yDYJ.addAbortSignal;

var $gKnMe = parcelRequire("gKnMe");
var $c026c65736b99160$var$getHighWaterMark = $gKnMe.getHighWaterMark, $c026c65736b99160$var$getDefaultHighWaterMark = $gKnMe.getDefaultHighWaterMark;

var $fjBv2 = parcelRequire("fjBv2");
var $c026c65736b99160$require$_require_codes = $fjBv2.codes;
var $c026c65736b99160$var$ERR_INVALID_ARG_TYPE = $c026c65736b99160$require$_require_codes.ERR_INVALID_ARG_TYPE, $c026c65736b99160$var$ERR_METHOD_NOT_IMPLEMENTED = $c026c65736b99160$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $c026c65736b99160$var$ERR_MULTIPLE_CALLBACK = $c026c65736b99160$require$_require_codes.ERR_MULTIPLE_CALLBACK, $c026c65736b99160$var$ERR_STREAM_CANNOT_PIPE = $c026c65736b99160$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $c026c65736b99160$var$ERR_STREAM_DESTROYED = $c026c65736b99160$require$_require_codes.ERR_STREAM_DESTROYED, $c026c65736b99160$var$ERR_STREAM_ALREADY_FINISHED = $c026c65736b99160$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $c026c65736b99160$var$ERR_STREAM_NULL_VALUES = $c026c65736b99160$require$_require_codes.ERR_STREAM_NULL_VALUES, $c026c65736b99160$var$ERR_STREAM_WRITE_AFTER_END = $c026c65736b99160$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $c026c65736b99160$var$ERR_UNKNOWN_ENCODING = $c026c65736b99160$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $c026c65736b99160$var$errorOrDestroy = $5Ble2.errorOrDestroy;
$c026c65736b99160$var$ObjectSetPrototypeOf($c026c65736b99160$var$Writable.prototype, $c026c65736b99160$require$Stream.prototype);
$c026c65736b99160$var$ObjectSetPrototypeOf($c026c65736b99160$var$Writable, $c026c65736b99160$require$Stream);
function $c026c65736b99160$var$nop() {}
var $c026c65736b99160$var$kOnFinished = $c026c65736b99160$var$Symbol('kOnFinished');

function $c026c65736b99160$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("4nQiX"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $c026c65736b99160$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $c026c65736b99160$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $c026c65736b99160$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $c026c65736b99160$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$c026c65736b99160$var$kOnFinished] = [];
}
function $c026c65736b99160$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$c026c65736b99160$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $c026c65736b99160$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$c026c65736b99160$var$ObjectDefineProperty($c026c65736b99160$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $c026c65736b99160$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("4nQiX"));
    if (!isDuplex && !$c026c65736b99160$var$FunctionPrototypeSymbolHasInstance($c026c65736b99160$var$Writable, this)) return new $c026c65736b99160$var$Writable(options);
    this._writableState = new $c026c65736b99160$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $c026c65736b99160$require$addAbortSignal(options.signal, this);
    }
    $c026c65736b99160$require$Stream.call(this, options);
    $5Ble2.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $c026c65736b99160$var$clearBuffer(_this, state);
        $c026c65736b99160$var$finishMaybe(_this, state);
    });
}
$c026c65736b99160$var$ObjectDefineProperty($c026c65736b99160$var$Writable, $c026c65736b99160$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($c026c65736b99160$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $c026c65736b99160$var$Writable) return false;
        return object && object._writableState instanceof $c026c65736b99160$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$c026c65736b99160$var$Writable.prototype.pipe = function() {
    $c026c65736b99160$var$errorOrDestroy(this, new $c026c65736b99160$var$ERR_STREAM_CANNOT_PIPE());
};
function $c026c65736b99160$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$c026c65736b99160$require$Buffer.isEncoding(encoding)) throw new $c026c65736b99160$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $c026c65736b99160$var$nop;
    }
    if (chunk === null) throw new $c026c65736b99160$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $c026c65736b99160$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $c026c65736b99160$require$Buffer) encoding = 'buffer';
        else if ($c026c65736b99160$require$Stream._isUint8Array(chunk)) {
            chunk = $c026c65736b99160$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $c026c65736b99160$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $c026c65736b99160$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $c026c65736b99160$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $c026c65736b99160$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $c026c65736b99160$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$c026c65736b99160$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $c026c65736b99160$var$_write(this, chunk, encoding, cb) === true;
};
$c026c65736b99160$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$c026c65736b99160$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $c026c65736b99160$var$clearBuffer(this, state);
    }
};
$c026c65736b99160$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $c026c65736b99160$var$StringPrototypeToLowerCase(encoding);
    if (!$c026c65736b99160$require$Buffer.isEncoding(encoding)) throw new $c026c65736b99160$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c026c65736b99160$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $c026c65736b99160$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $c026c65736b99160$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $c026c65736b99160$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c026c65736b99160$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $c026c65736b99160$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $c026c65736b99160$var$errorOrDestroy(stream, er);
}
function $c026c65736b99160$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $c026c65736b99160$var$errorOrDestroy(stream, new $c026c65736b99160$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($c026c65736b99160$var$onwriteError, stream, state, er, cb);
        else $c026c65736b99160$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $c026c65736b99160$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($c026c65736b99160$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $c026c65736b99160$var$afterWrite(stream, state, 1, cb);
    }
}
function $c026c65736b99160$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $c026c65736b99160$var$afterWrite(stream, state, count, cb);
}
function $c026c65736b99160$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $c026c65736b99160$var$errorBuffer(state);
    $c026c65736b99160$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $c026c65736b99160$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $c026c65736b99160$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$c026c65736b99160$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $c026c65736b99160$var$ERR_STREAM_DESTROYED('end'));
    }
    $c026c65736b99160$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $c026c65736b99160$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $c026c65736b99160$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $c026c65736b99160$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $c026c65736b99160$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $c026c65736b99160$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $c026c65736b99160$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $c026c65736b99160$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$c026c65736b99160$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $c026c65736b99160$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$c026c65736b99160$var$Writable.prototype._writev = null;
$c026c65736b99160$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $c026c65736b99160$var$_write(this, chunk, encoding);
        if (ret instanceof $c026c65736b99160$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $c026c65736b99160$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $c026c65736b99160$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $c026c65736b99160$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$c026c65736b99160$var$kOnFinished].push(cb);
    }
    return this;
};
function $c026c65736b99160$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $c026c65736b99160$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $c026c65736b99160$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $c026c65736b99160$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$c026c65736b99160$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $c026c65736b99160$var$errorOrDestroy(stream, err, state.sync);
        } else if ($c026c65736b99160$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($c026c65736b99160$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $c026c65736b99160$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $c026c65736b99160$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $c026c65736b99160$var$finishMaybe(stream, state, sync) {
    if ($c026c65736b99160$var$needFinish(state)) {
        $c026c65736b99160$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($c026c65736b99160$var$needFinish(state)) $c026c65736b99160$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($c026c65736b99160$var$needFinish(state)) {
                state.pendingcb++;
                $c026c65736b99160$var$finish(stream, state);
            }
        }
    }
}
function $c026c65736b99160$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$c026c65736b99160$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$c026c65736b99160$var$ObjectDefineProperties($c026c65736b99160$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $c026c65736b99160$var$destroy = $5Ble2.destroy;
$c026c65736b99160$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$c026c65736b99160$var$kOnFinished].length)) $2Qkr5.nextTick($c026c65736b99160$var$errorBuffer, state);
    $c026c65736b99160$var$destroy.call(this, err, cb);
    return this;
};
$c026c65736b99160$var$Writable.prototype._undestroy = $5Ble2.undestroy;
$c026c65736b99160$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$c026c65736b99160$var$Writable.prototype[$c026c65736b99160$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $c026c65736b99160$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c026c65736b99160$var$lazyWebStreams() {
    if ($c026c65736b99160$var$webStreamsAdapters === undefined) $c026c65736b99160$var$webStreamsAdapters = {};
    return $c026c65736b99160$var$webStreamsAdapters;
}
$c026c65736b99160$var$Writable.fromWeb = function(writableStream, options) {
    return $c026c65736b99160$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$c026c65736b99160$var$Writable.toWeb = function(streamWritable) {
    return $c026c65736b99160$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("l4huW", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $becUP = parcelRequire("becUP");

var $cWkNZ = parcelRequire("cWkNZ");
var $f5678b741dd0d065$var$isReadable = $cWkNZ.isReadable, $f5678b741dd0d065$var$isWritable = $cWkNZ.isWritable, $f5678b741dd0d065$var$isIterable = $cWkNZ.isIterable, $f5678b741dd0d065$var$isNodeStream = $cWkNZ.isNodeStream, $f5678b741dd0d065$var$isReadableNodeStream = $cWkNZ.isReadableNodeStream, $f5678b741dd0d065$var$isWritableNodeStream = $cWkNZ.isWritableNodeStream, $f5678b741dd0d065$var$isDuplexNodeStream = $cWkNZ.isDuplexNodeStream, $f5678b741dd0d065$var$isReadableStream = $cWkNZ.isReadableStream, $f5678b741dd0d065$var$isWritableStream = $cWkNZ.isWritableStream;

var $8Hinb = parcelRequire("8Hinb");

var $fjBv2 = parcelRequire("fjBv2");
var $f5678b741dd0d065$var$AbortError = $fjBv2.AbortError, $f5678b741dd0d065$var$_require_codes = $fjBv2.codes, $f5678b741dd0d065$var$ERR_INVALID_ARG_TYPE = $f5678b741dd0d065$var$_require_codes.ERR_INVALID_ARG_TYPE, $f5678b741dd0d065$var$ERR_INVALID_RETURN_VALUE = $f5678b741dd0d065$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $5Ble2 = parcelRequire("5Ble2");
var $f5678b741dd0d065$require$destroyer = $5Ble2.destroyer;

var $4nQiX = parcelRequire("4nQiX");

var $gax2P = parcelRequire("gax2P");

var $guOHm = parcelRequire("guOHm");

var $1CjWp = parcelRequire("1CjWp");
var $f5678b741dd0d065$require$createDeferredPromise = $1CjWp.createDeferredPromise;

var $hl27j = parcelRequire("hl27j");
var $f5678b741dd0d065$var$Blob = globalThis.Blob || $becUP.Blob;
var $f5678b741dd0d065$var$isBlob = typeof $f5678b741dd0d065$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $f5678b741dd0d065$var$Blob;
} : function isBlob(b) {
    return false;
};

var $f5678b741dd0d065$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $hgdke = parcelRequire("hgdke");
var $f5678b741dd0d065$require$FunctionPrototypeCall = $hgdke.FunctionPrototypeCall;
// This is needed for pre node 17.
var $f5678b741dd0d065$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($4nQiX);
module.exports = function duplexify(body, name) {
    if ($f5678b741dd0d065$var$isDuplexNodeStream(body)) return body;
    if ($f5678b741dd0d065$var$isReadableNodeStream(body)) return $f5678b741dd0d065$var$_duplexify({
        readable: body
    });
    if ($f5678b741dd0d065$var$isWritableNodeStream(body)) return $f5678b741dd0d065$var$_duplexify({
        writable: body
    });
    if ($f5678b741dd0d065$var$isNodeStream(body)) return $f5678b741dd0d065$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($f5678b741dd0d065$var$isReadableStream(body)) return $f5678b741dd0d065$var$_duplexify({
        readable: $gax2P.fromWeb(body)
    });
    if ($f5678b741dd0d065$var$isWritableStream(body)) return $f5678b741dd0d065$var$_duplexify({
        writable: $guOHm.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $f5678b741dd0d065$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($f5678b741dd0d065$var$isIterable(value)) return $hl27j($f5678b741dd0d065$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $f5678b741dd0d065$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $f5678b741dd0d065$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $f5678b741dd0d065$require$destroyer(d, err);
            });
            return d = new $f5678b741dd0d065$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $f5678b741dd0d065$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($f5678b741dd0d065$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($f5678b741dd0d065$var$isIterable(body)) return $hl27j($f5678b741dd0d065$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($f5678b741dd0d065$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $f5678b741dd0d065$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $f5678b741dd0d065$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $f5678b741dd0d065$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $f5678b741dd0d065$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $f5678b741dd0d065$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $f5678b741dd0d065$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $f5678b741dd0d065$require$destroyer(d1, err);
        });
        return d1 = new $f5678b741dd0d065$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $f5678b741dd0d065$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $f5678b741dd0d065$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $f5678b741dd0d065$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $f5678b741dd0d065$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $f5678b741dd0d065$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $f5678b741dd0d065$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $f5678b741dd0d065$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $gax2P.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$f5678b741dd0d065$var$isReadable(r);
    var writable = !!$f5678b741dd0d065$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $f5678b741dd0d065$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $8Hinb(w, function(err) {
            writable = false;
            if (err) $f5678b741dd0d065$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $8Hinb(r, function(err) {
            readable = false;
            if (err) $f5678b741dd0d065$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $f5678b741dd0d065$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $f5678b741dd0d065$require$destroyer(w, err);
            $f5678b741dd0d065$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("87bsp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $hgdke = parcelRequire("hgdke");
var $5e87dd57441c36e1$require$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf;
module.exports = $5e87dd57441c36e1$var$PassThrough;

var $aaGPw = parcelRequire("aaGPw");
$5e87dd57441c36e1$require$ObjectSetPrototypeOf($5e87dd57441c36e1$var$PassThrough.prototype, $aaGPw.prototype);
$5e87dd57441c36e1$require$ObjectSetPrototypeOf($5e87dd57441c36e1$var$PassThrough, $aaGPw);
function $5e87dd57441c36e1$var$PassThrough(options) {
    if (!(this instanceof $5e87dd57441c36e1$var$PassThrough)) return new $5e87dd57441c36e1$var$PassThrough(options);
    $aaGPw.call(this, options);
}
$5e87dd57441c36e1$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("aaGPw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $767c0fb7fa3d4f71$var$ObjectSetPrototypeOf = $hgdke.ObjectSetPrototypeOf, $767c0fb7fa3d4f71$var$Symbol = $hgdke.Symbol;
module.exports = $767c0fb7fa3d4f71$var$Transform;

var $767c0fb7fa3d4f71$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("fjBv2")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $4nQiX = parcelRequire("4nQiX");

var $gKnMe = parcelRequire("gKnMe");
var $767c0fb7fa3d4f71$require$getHighWaterMark = $gKnMe.getHighWaterMark;
$767c0fb7fa3d4f71$var$ObjectSetPrototypeOf($767c0fb7fa3d4f71$var$Transform.prototype, $4nQiX.prototype);
$767c0fb7fa3d4f71$var$ObjectSetPrototypeOf($767c0fb7fa3d4f71$var$Transform, $4nQiX);
var $767c0fb7fa3d4f71$var$kCallback = $767c0fb7fa3d4f71$var$Symbol('kCallback');
function $767c0fb7fa3d4f71$var$Transform(options) {
    if (!(this instanceof $767c0fb7fa3d4f71$var$Transform)) return new $767c0fb7fa3d4f71$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $767c0fb7fa3d4f71$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $4nQiX.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$767c0fb7fa3d4f71$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $767c0fb7fa3d4f71$var$prefinish);
}
function $767c0fb7fa3d4f71$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $767c0fb7fa3d4f71$var$prefinish() {
    if (this._final !== $767c0fb7fa3d4f71$var$_final) $767c0fb7fa3d4f71$var$_final.call(this);
}
$767c0fb7fa3d4f71$var$Transform.prototype._final = $767c0fb7fa3d4f71$var$_final;
$767c0fb7fa3d4f71$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $767c0fb7fa3d4f71$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$767c0fb7fa3d4f71$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$767c0fb7fa3d4f71$var$kCallback] = callback;
    });
};
$767c0fb7fa3d4f71$var$Transform.prototype._read = function() {
    if (this[$767c0fb7fa3d4f71$var$kCallback]) {
        var callback = this[$767c0fb7fa3d4f71$var$kCallback];
        this[$767c0fb7fa3d4f71$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("i7OtI", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $hgdke = parcelRequire("hgdke");
var $d3200965a99261d8$var$ArrayPrototypePop = $hgdke.ArrayPrototypePop, $d3200965a99261d8$var$Promise = $hgdke.Promise;

var $cWkNZ = parcelRequire("cWkNZ");
var $d3200965a99261d8$var$isIterable = $cWkNZ.isIterable, $d3200965a99261d8$var$isNodeStream = $cWkNZ.isNodeStream, $d3200965a99261d8$var$isWebStream = $cWkNZ.isWebStream;

var $9sHDO = parcelRequire("9sHDO");
var $d3200965a99261d8$var$pl = $9sHDO.pipelineImpl;

var $8Hinb = parcelRequire("8Hinb");
var $d3200965a99261d8$require$finished = $8Hinb.finished;
parcelRequire("hZ2ma");
function $d3200965a99261d8$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $d3200965a99261d8$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$d3200965a99261d8$var$isNodeStream(lastArg) && !$d3200965a99261d8$var$isIterable(lastArg) && !$d3200965a99261d8$var$isWebStream(lastArg)) {
            var options = $d3200965a99261d8$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $d3200965a99261d8$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $d3200965a99261d8$require$finished,
    pipeline: $d3200965a99261d8$var$pipeline
};

});






parcelRegister("lpMNw", function(module, exports) {
"use strict";
var $f971c8fb91e829bc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f971c8fb91e829bc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f971c8fb91e829bc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f971c8fb91e829bc$var$__exportStar((parcelRequire("6frxF")), module.exports);

});
parcelRegister("6frxF", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeRdf = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica RDF Query Result Serialize Actor.
 *
 * It serializes quad streams (for example resulting from a CONSTRUCT query)
 * to an RDF syntax.
 */ var $48c9820a90f3f70f$var$ActorQueryResultSerializeRdf = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerialize) {
    (0, $i3fW3._)(ActorQueryResultSerializeRdf, _bus_query_result_serialize_1_ActorQueryResultSerialize);
    function ActorQueryResultSerializeRdf(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeRdf);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeRdf, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeRdf, [
        {
            key: "testHandle",
            value: function testHandle(action, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var mediaTypes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Check if we are provided with a quad stream
                                if (action.type !== 'quads') return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only handle quad streams"))
                                ];
                                return [
                                    4,
                                    this.mediatorMediaTypeCombiner.mediate({
                                        context: context,
                                        mediaTypes: true
                                    })
                                ];
                            case 1:
                                mediaTypes = _state.sent().mediaTypes;
                                if (!(mediaType in mediaTypes)) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not handle media type ").// eslint-disable-next-line ts/restrict-template-expressions
                                    concat(mediaType, ". All available types: ").concat(Object.keys(mediaTypes)))
                                ];
                                return [
                                    2,
                                    (0, $kNNoa.passTestVoid)()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorRdfSerialize.mediate({
                                        context: context,
                                        handle: {
                                            context: context,
                                            quadStream: action.quadStream
                                        },
                                        handleMediaType: mediaType
                                    })
                                ];
                            case 1:
                                // Delegate handling to the mediator
                                return [
                                    2,
                                    _state.sent().handle
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "testMediaType",
            value: function testMediaType(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "getMediaTypes",
            value: function getMediaTypes(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorMediaTypeCombiner.mediate({
                                        context: context,
                                        mediaTypes: true
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().mediaTypes
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "testMediaTypeFormats",
            value: function testMediaTypeFormats(_context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "getMediaTypeFormats",
            value: function getMediaTypeFormats(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorMediaTypeFormatCombiner.mediate({
                                        context: context,
                                        mediaTypeFormats: true
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().mediaTypeFormats
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryResultSerializeRdf;
}($cqzMF.ActorQueryResultSerialize);
module.exports.ActorQueryResultSerializeRdf = $48c9820a90f3f70f$var$ActorQueryResultSerializeRdf;

});


parcelRegister("2MTlf", function(module, exports) {
"use strict";
var $207afe31e16f6f19$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $207afe31e16f6f19$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $207afe31e16f6f19$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$207afe31e16f6f19$var$__exportStar((parcelRequire("9CSoW")), module.exports);

$207afe31e16f6f19$var$__exportStar((parcelRequire("SD4Lq")), module.exports);

});
parcelRegister("9CSoW", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryGroupConcat = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $SD4Lq = parcelRequire("SD4Lq");
/**
 * A comunica Group Concat Expression Evaluator Aggregate Actor.
 */ var $7021dca1fb9c305a$var$ActorBindingsAggregatorFactoryGroupConcat = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryGroupConcat, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryGroupConcat(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryGroupConcat);
        return (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryGroupConcat, [
            args
        ]);
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryGroupConcat, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'group_concat') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'group_concat\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $SD4Lq.GroupConcatAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        expr.distinct,
                                        context.getSafe($9nBhR.KeysInitQuery.dataFactory),
                                        expr.separator
                                    ]))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryGroupConcat;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryGroupConcat = $7021dca1fb9c305a$var$ActorBindingsAggregatorFactoryGroupConcat;

});
parcelRegister("gaR6U", function(module, exports) {
"use strict";
var $bc66c7258f7bbcd3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bc66c7258f7bbcd3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bc66c7258f7bbcd3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bc66c7258f7bbcd3$var$__exportStar((parcelRequire("iBiX2")), module.exports);

$bc66c7258f7bbcd3$var$__exportStar((parcelRequire("awQUh")), module.exports);

});
parcelRegister("iBiX2", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactory = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for creating Binding-Aggregator-factories.
 *
 * Actor types:
 * * Input:  IActionBindingsAggregatorFactory:      A SPARQL expression and a factory for an expression evaluator.
 * * Test:   <none>
 * * Output: IActorBindingsAggregatorFactoryOutput: An aggregator of RDF bindings.
 *
 * @see IActionBindingsAggregatorFactory
 * @see IActorBindingsAggregatorFactoryOutput
 */ var $d8aa6208cdc4336b$var$ActorBindingsAggregatorFactory = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactory, _core_1_Actor);
    function ActorBindingsAggregatorFactory(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactory);
        var _this;
        _this = (0, $kzDuW._)(this, ActorBindingsAggregatorFactory, [
            args
        ]);
        _this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        return _this;
    }
    return ActorBindingsAggregatorFactory;
}($kNNoa.Actor);
module.exports.ActorBindingsAggregatorFactory = $d8aa6208cdc4336b$var$ActorBindingsAggregatorFactory;

});

parcelRegister("awQUh", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AggregateEvaluator = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");

var $gQYIc = parcelRequire("gQYIc");
/**
 * This is the base class for all aggregators.
 * NOTE: The wildcard count aggregator significantly differs from the others and overloads parts of this class.
 */ var $7aa5eeb8f192a261$var$AggregateEvaluator = /*#__PURE__*/ function() {
    function AggregateEvaluator(evaluator, distinct) {
        var throwError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $jGAMp._)(this, AggregateEvaluator);
        this.evaluator = evaluator;
        this.distinct = distinct;
        this.throwError = throwError;
        this.errorOccurred = false;
        this.errorOccurred = false;
        this.superTypeProvider = evaluator.context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider);
        this.termTransformer = new $aduX6.TermTransformer(this.superTypeProvider);
        this.variableValues = new Set();
    }
    (0, $byiyg._)(AggregateEvaluator, [
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return undefined;
            }
        },
        {
            /**
     * The spec says to throw an error when a set function is called on an empty
     * set (unless explicitly mentioned otherwise like COUNT).
     * However, aggregate error handling says to not bind the result in case of an
     * error. So to simplify logic in the caller, we return undefined by default.
     */ key: "emptyValue",
            value: function emptyValue() {
                var val = this.emptyValueTerm();
                if (val === undefined && this.throwError) throw new $aduX6.EmptyAggregateError();
                return val;
            }
        },
        {
            key: "putBindings",
            value: /**
     * Base implementation of putBindings, that evaluates to a term and then calls putTerm.
     * The WildcardCountAggregator will completely discard this implementation.
     * @param bindings
     */ function putBindings(bindings) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var term, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.errorOccurred) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.evaluator.evaluate(bindings)
                                ];
                            case 2:
                                term = _state.sent();
                                if (!term || this.errorOccurred) return [
                                    2
                                ];
                                // Handle DISTINCT before putting the term
                                if (!this.distinct || !this.variableValues.has($gQYIc.termToString(term))) {
                                    this.putTerm(term);
                                    if (this.distinct) this.variableValues.add($gQYIc.termToString(term));
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                this.safeThrow(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "result",
            value: function result() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (this.errorOccurred) return [
                            2,
                            undefined
                        ];
                        return [
                            2,
                            this.termResult()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "safeThrow",
            value: function safeThrow(err) {
                if (this.throwError) throw err;
                else this.errorOccurred = true;
            }
        },
        {
            key: "termToNumericOrError",
            value: function termToNumericOrError(term) {
                if (term.termType !== 'Literal') throw new Error("Term with value ".concat(term.value, " has type ").concat(term.termType, " and is not a numeric literal"));
                else if (!$aduX6.isSubTypeOf(term.datatype.value, $aduX6.TypeAlias.SPARQL_NUMERIC, this.superTypeProvider)) throw new Error("Term datatype ".concat(term.datatype.value, " with value ").concat(term.value, " has type ").concat(term.termType, " and is not a numeric literal"));
                return this.termTransformer.transformLiteral(term);
            }
        }
    ]);
    return AggregateEvaluator;
}();
module.exports.AggregateEvaluator = $7aa5eeb8f192a261$var$AggregateEvaluator;

});


parcelRegister("SD4Lq", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GroupConcatAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $aduX6 = parcelRequire("aduX6");
var $0a435ae86918a12a$var$GroupConcatAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(GroupConcatAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function GroupConcatAggregator(evaluator, distinct, dataFactory, separator, throwError) {
        (0, $jGAMp._)(this, GroupConcatAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, GroupConcatAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.dataFactory = dataFactory;
        _this.state = undefined;
        _this.lastLanguageValid = true;
        _this.lastLanguage = undefined;
        _this.separator = separator !== null && separator !== void 0 ? separator : ' ';
        return _this;
    }
    (0, $byiyg._)(GroupConcatAggregator, [
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return $aduX6.typedLiteral('', $aduX6.TypeURL.XSD_STRING);
            }
        },
        {
            key: "putTerm",
            value: function putTerm(term) {
                if (this.state === undefined) {
                    this.state = term.value;
                    if (term.termType === 'Literal') this.lastLanguage = term.language;
                } else {
                    this.state += this.separator + term.value;
                    if (this.lastLanguageValid && term.termType === 'Literal' && this.lastLanguage !== term.language) {
                        this.lastLanguageValid = false;
                        this.lastLanguage = undefined;
                    }
                }
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                if (this.lastLanguageValid && this.lastLanguage) return $aduX6.langString(this.state, this.lastLanguage).toRDF(this.dataFactory);
                return $aduX6.typedLiteral(this.state, $aduX6.TypeURL.XSD_STRING);
            }
        }
    ]);
    return GroupConcatAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.GroupConcatAggregator = $0a435ae86918a12a$var$GroupConcatAggregator;

});



parcelRegister("6HdhD", function(module, exports) {
"use strict";
var $4e0110077383cf72$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e0110077383cf72$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4e0110077383cf72$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4e0110077383cf72$var$__exportStar((parcelRequire("gCGMx")), module.exports);

$4e0110077383cf72$var$__exportStar((parcelRequire("dSD06")), module.exports);

});
parcelRegister("gCGMx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryCount = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");

var $dSD06 = parcelRequire("dSD06");
/**
 * A comunica Count Expression Evaluator Aggregate Actor.
 */ var $c1a1618d178f6e7f$var$ActorBindingsAggregatorFactoryCount = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryCount, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryCount(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryCount);
        return (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryCount, [
            args
        ]);
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryCount, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'count' || action.expr.expression.expressionType === $hSHd8.Algebra.expressionTypes.WILDCARD) return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'count\' aggregator without wildcard.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $dSD06.CountAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        expr.distinct
                                    ]))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryCount;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryCount = $c1a1618d178f6e7f$var$ActorBindingsAggregatorFactoryCount;

});
parcelRegister("dSD06", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CountAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $aduX6 = parcelRequire("aduX6");
var $a1ae9237b9d9ed47$var$CountAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(CountAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function CountAggregator(evaluator, distinct, throwError) {
        (0, $jGAMp._)(this, CountAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, CountAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(CountAggregator, [
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return (0, $aduX6.typedLiteral)('0', $aduX6.TypeURL.XSD_INTEGER);
            }
        },
        {
            key: "putTerm",
            value: function putTerm(_) {
                if (this.state === undefined) this.state = 0;
                this.state++;
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return (0, $aduX6.typedLiteral)(String(this.state), $aduX6.TypeURL.XSD_INTEGER);
            }
        }
    ]);
    return CountAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.CountAggregator = $a1ae9237b9d9ed47$var$CountAggregator;

});



parcelRegister("6hH92", function(module, exports) {
"use strict";
var $4935cc3e8b46b73f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4935cc3e8b46b73f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4935cc3e8b46b73f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4935cc3e8b46b73f$var$__exportStar((parcelRequire("aDiMk")), module.exports);

$4935cc3e8b46b73f$var$__exportStar((parcelRequire("0Rfqj")), module.exports);

});
parcelRegister("aDiMk", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactorySample = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $kNNoa = parcelRequire("kNNoa");

var $0Rfqj = parcelRequire("0Rfqj");
/**
 * A comunica Sample Expression Evaluator Aggregate Actor.
 */ var $7bdc1ce9b9f8707b$var$ActorBindingsAggregatorFactorySample = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactorySample, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactorySample(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactorySample);
        return (0, $kzDuW._)(this, ActorBindingsAggregatorFactorySample, [
            args
        ]);
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactorySample, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'sample') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'sample\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $0Rfqj.SampleAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        expr.distinct
                                    ]))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactorySample;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactorySample = $7bdc1ce9b9f8707b$var$ActorBindingsAggregatorFactorySample;

});
parcelRegister("0Rfqj", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SampleAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");
var $00294e193f774e4f$var$SampleAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(SampleAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function SampleAggregator(evaluator, distinct, throwError) {
        (0, $jGAMp._)(this, SampleAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, SampleAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(SampleAggregator, [
        {
            key: "putTerm",
            value: function putTerm(term) {
                // First value is our sample
                if (this.state === undefined) this.state = term;
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return this.state;
            }
        }
    ]);
    return SampleAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.SampleAggregator = $00294e193f774e4f$var$SampleAggregator;

});



parcelRegister("cVuER", function(module, exports) {
"use strict";
var $969296f05501b8c0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $969296f05501b8c0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $969296f05501b8c0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$969296f05501b8c0$var$__exportStar((parcelRequire("7V0jC")), module.exports);

$969296f05501b8c0$var$__exportStar((parcelRequire("9NZYv")), module.exports);

});
parcelRegister("7V0jC", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryWildcardCount = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $kNNoa = parcelRequire("kNNoa");

var $9NZYv = parcelRequire("9NZYv");
/**
 * A comunica Wildcard Count Expression Evaluator Aggregate Actor.
 */ var $5c3e19ec55baaf7a$var$ActorBindingsAggregatorFactoryWildcardCount = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryWildcardCount, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryWildcardCount(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryWildcardCount);
        return (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryWildcardCount, [
            args
        ]);
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryWildcardCount, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'count' || action.expr.expression.expressionType !== 'wildcard') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'count\' aggregator with wildcard.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $9NZYv.WildcardCountAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        expr.distinct
                                    ]))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryWildcardCount;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryWildcardCount = $5c3e19ec55baaf7a$var$ActorBindingsAggregatorFactoryWildcardCount;

});
parcelRegister("9NZYv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardCountAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $aduX6 = parcelRequire("aduX6");

var $gQYIc = parcelRequire("gQYIc");
var $7238c38ff6a5b498$var$WildcardCountAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(WildcardCountAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function WildcardCountAggregator(evaluator, distinct, throwError) {
        (0, $jGAMp._)(this, WildcardCountAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, WildcardCountAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.bindingValues = new Map();
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(WildcardCountAggregator, [
        {
            key: "putTerm",
            value: function putTerm(_term) {
            // Do nothing, not needed
            }
        },
        {
            key: "putBindings",
            value: function putBindings(bindings) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!this.handleDistinct(bindings)) {
                            if (this.state === undefined) this.state = 0;
                            this.state += 1;
                        }
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return (0, $aduX6.typedLiteral)('0', $aduX6.TypeURL.XSD_INTEGER);
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return (0, $aduX6.typedLiteral)(String(this.state), $aduX6.TypeURL.XSD_INTEGER);
            }
        },
        {
            /**
     * Returns true if the given bindings should be skipped.
     * @param bindings
     * @private
     */ key: "handleDistinct",
            value: function handleDistinct(bindings) {
                if (this.distinct) {
                    var bindingList = (0, $7WNf6._)(bindings);
                    bindingList.sort(function(first, snd) {
                        return first[0].value.localeCompare(snd[0].value);
                    });
                    var variables = bindingList.map(function(param) {
                        var _param = (0, $32TW8._)(param, 1), variable = _param[0];
                        return variable.value;
                    }).join(',');
                    var terms = bindingList.map(function(param) {
                        var _param = (0, $32TW8._)(param, 2), term = _param[1];
                        return $gQYIc.termToString(term);
                    }).join(',');
                    var set = this.bindingValues.get(variables);
                    var result = set !== undefined && set.has(terms);
                    // Add to the set:
                    if (!set) this.bindingValues.set(variables, new Set());
                    this.bindingValues.get(variables).add(terms);
                    return result;
                }
                return false;
            }
        }
    ]);
    return WildcardCountAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.WildcardCountAggregator = $7238c38ff6a5b498$var$WildcardCountAggregator;

});



parcelRegister("56jOZ", function(module, exports) {
"use strict";
var $3b6ce36708ee0c75$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b6ce36708ee0c75$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b6ce36708ee0c75$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b6ce36708ee0c75$var$__exportStar((parcelRequire("6n2GH")), module.exports);

$3b6ce36708ee0c75$var$__exportStar((parcelRequire("3tnkf")), module.exports);

});
parcelRegister("6n2GH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryAverage = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $aduX6 = parcelRequire("aduX6");

var $3tnkf = parcelRequire("3tnkf");
/**
 * A comunica Average Expression Evaluator Aggregate Actor.
 */ var $4a36f9c4c78d6ac4$var$ActorBindingsAggregatorFactoryAverage = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryAverage, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryAverage(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryAverage);
        var _this;
        _this = (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryAverage, [
            args
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryAverage, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'avg') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'avg\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $3tnkf.AverageAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                _tmp = [
                                    void 0,
                                    _state.sent(),
                                    expr.distinct,
                                    context.getSafe($9nBhR.KeysInitQuery.dataFactory)
                                ];
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.ADDITION,
                                        context: context,
                                        requireTermExpression: true
                                    })
                                ];
                            case 2:
                                _tmp = _tmp.concat([
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.DIVISION,
                                        context: context,
                                        requireTermExpression: true
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryAverage;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryAverage = $4a36f9c4c78d6ac4$var$ActorBindingsAggregatorFactoryAverage;

});
parcelRegister("3tnkf", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AverageAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $aduX6 = parcelRequire("aduX6");
var $28762c835e39d69d$var$AverageAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(AverageAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function AverageAggregator(evaluator, distinct, dataFactory, additionFunction, divisionFunction, throwError) {
        (0, $jGAMp._)(this, AverageAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, AverageAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.dataFactory = dataFactory;
        _this.additionFunction = additionFunction;
        _this.divisionFunction = divisionFunction;
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(AverageAggregator, [
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return $aduX6.typedLiteral('0', $aduX6.TypeURL.XSD_INTEGER);
            }
        },
        {
            key: "putTerm",
            value: function putTerm(term) {
                if (this.state === undefined) {
                    var sum = this.termToNumericOrError(term);
                    this.state = {
                        sum: sum,
                        count: 1
                    };
                } else {
                    var internalTerm = this.termToNumericOrError(term);
                    this.state.sum = this.additionFunction.applyOnTerms([
                        this.state.sum,
                        internalTerm
                    ], this.evaluator);
                    this.state.count++;
                }
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                var count = new $aduX6.IntegerLiteral(this.state.count);
                var result = this.divisionFunction.applyOnTerms([
                    this.state.sum,
                    count
                ], this.evaluator);
                return result.toRDF(this.dataFactory);
            }
        }
    ]);
    return AverageAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.AverageAggregator = $28762c835e39d69d$var$AverageAggregator;

});



parcelRegister("3j5jH", function(module, exports) {
"use strict";
var $2687453f1d22ba57$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2687453f1d22ba57$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2687453f1d22ba57$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2687453f1d22ba57$var$__exportStar((parcelRequire("9a8m0")), module.exports);

$2687453f1d22ba57$var$__exportStar((parcelRequire("fbFt6")), module.exports);

});
parcelRegister("9a8m0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactorySum = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $aduX6 = parcelRequire("aduX6");

var $fbFt6 = parcelRequire("fbFt6");
/**
 * A comunica Sum Expression Evaluator Aggregate Actor.
 */ var $6abb872774ed538a$var$ActorBindingsAggregatorFactorySum = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactorySum, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactorySum(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactorySum);
        var _this;
        _this = (0, $kzDuW._)(this, ActorBindingsAggregatorFactorySum, [
            args
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactorySum, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'sum') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'sum\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var expr, context, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                expr = param.expr, context = param.context;
                                _1 = (_ = $fbFt6.SumAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                _tmp = [
                                    void 0,
                                    _state.sent(),
                                    expr.distinct,
                                    context.getSafe($9nBhR.KeysInitQuery.dataFactory)
                                ];
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.ADDITION,
                                        context: context,
                                        requireTermExpression: true
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactorySum;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactorySum = $6abb872774ed538a$var$ActorBindingsAggregatorFactorySum;

});
parcelRegister("fbFt6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SumAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $aduX6 = parcelRequire("aduX6");
var $02da73d202609791$var$SumAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(SumAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function SumAggregator(evaluator, distinct, dataFactory, additionFunction, throwError) {
        (0, $jGAMp._)(this, SumAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, SumAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.dataFactory = dataFactory;
        _this.additionFunction = additionFunction;
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(SumAggregator, [
        {
            key: "emptyValueTerm",
            value: function emptyValueTerm() {
                return (0, $aduX6.typedLiteral)('0', $aduX6.TypeURL.XSD_INTEGER);
            }
        },
        {
            key: "putTerm",
            value: function putTerm(term) {
                if (this.state === undefined) this.state = this.termToNumericOrError(term);
                else {
                    var internalTerm = this.termToNumericOrError(term);
                    this.state = this.additionFunction.applyOnTerms([
                        this.state,
                        internalTerm
                    ], this.evaluator);
                }
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return this.state.toRDF(this.dataFactory);
            }
        }
    ]);
    return SumAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.SumAggregator = $02da73d202609791$var$SumAggregator;

});



parcelRegister("cPsBY", function(module, exports) {
"use strict";
var $95707113f782696b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $95707113f782696b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $95707113f782696b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$95707113f782696b$var$__exportStar((parcelRequire("7mhH6")), module.exports);

});
parcelRegister("7mhH6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionIn = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $8DQ12 = parcelRequire("8DQ12");
/**
 * A comunica ExpressionFunctionIn Function Factory Actor.
 */ var $55b8502df4fbc2b8$var$ActorFunctionFactoryExpressionIn = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionIn, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionIn(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionIn);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryExpressionIn, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.IN
                ],
                termFunction: false
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionIn, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var equalityFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.EQUAL,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                equalityFunction = _state.sent();
                                return [
                                    2,
                                    new $8DQ12.ExpressionFunctionIn(equalityFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryExpressionIn;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionIn = $55b8502df4fbc2b8$var$ActorFunctionFactoryExpressionIn;

});
parcelRegister("8DQ12", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $1UYmo = parcelRequire("1UYmo");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionIn = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-in
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $019fa67597efbea9$var$ExpressionFunctionIn = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionIn, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionIn(equalityFunction) {
        (0, $jGAMp._)(this, ExpressionFunctionIn);
        var _this;
        var _this1;
        _this = (0, $kzDuW._)(this, ExpressionFunctionIn, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: $aduX6.SparqlOperator.IN,
                apply: function(context) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var args, mapping, exprEval, _args, leftExpr, remaining, left;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    args = context.args, mapping = context.mapping, exprEval = context.exprEval;
                                    _args = (0, $1UYmo._)(args), leftExpr = _args[0], remaining = _args.slice(1);
                                    return [
                                        4,
                                        exprEval.evaluatorExpressionEvaluation(leftExpr, mapping)
                                    ];
                                case 1:
                                    left = _state.sent();
                                    return [
                                        4,
                                        _this1.inRecursive(left, (0, $emQHU._)((0, $iT0je._)({}, context), {
                                            args: remaining
                                        }), [])
                                    ];
                                case 2:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    })();
                }
            }
        ]), _this1 = _this;
        _this1.equalityFunction = equalityFunction;
        return _this;
    }
    (0, $byiyg._)(ExpressionFunctionIn, [
        {
            key: "checkArity",
            value: function checkArity(args) {
                return args.length > 0;
            }
        },
        {
            key: "inRecursive",
            value: function inRecursive(needle, context, results) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var args, mapping, exprEval, noErrors, nextExpression, next, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = context.args, mapping = context.mapping, exprEval = context.exprEval;
                                if (args.length === 0) {
                                    noErrors = results.every(function(val) {
                                        return !val;
                                    });
                                    return [
                                        2,
                                        noErrors ? (0, $aduX6.bool)(false) : Promise.reject(new $aduX6.InError(results))
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // We know this will not be undefined because we check args.length === 0
                                nextExpression = args.shift();
                                return [
                                    4,
                                    exprEval.evaluatorExpressionEvaluation(nextExpression, mapping)
                                ];
                            case 2:
                                next = _state.sent();
                                if (this.equalityFunction.applyOnTerms([
                                    needle,
                                    next
                                ], exprEval).typedValue) return [
                                    2,
                                    (0, $aduX6.bool)(true)
                                ];
                                return [
                                    2,
                                    this.inRecursive(needle, context, (0, $7WNf6._)(results).concat([
                                        false
                                    ]))
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    this.inRecursive(needle, context, (0, $7WNf6._)(results).concat([
                                        error
                                    ]))
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ExpressionFunctionIn;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionIn = $019fa67597efbea9$var$ExpressionFunctionIn;

});



parcelRegister("1wTtT", function(module, exports) {
"use strict";
var $11d3d0fc11a5046a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $11d3d0fc11a5046a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $11d3d0fc11a5046a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$11d3d0fc11a5046a$var$__exportStar((parcelRequire("3cPQs")), module.exports);

});
parcelRegister("3cPQs", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionNotIn = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $7z4EI = parcelRequire("7z4EI");
/**
 * A comunica ExpressionFunctionNotIn Function Factory Actor.
 */ var $255ab573be571bc7$var$ActorFunctionFactoryExpressionNotIn = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryExpressionNotIn, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryExpressionNotIn(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryExpressionNotIn);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryExpressionNotIn, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.NOT_IN
                ],
                termFunction: false
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryExpressionNotIn, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var inFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.IN,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                inFunction = _state.sent();
                                return [
                                    2,
                                    new $7z4EI.ExpressionFunctionNotIn(inFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryExpressionNotIn;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryExpressionNotIn = $255ab573be571bc7$var$ActorFunctionFactoryExpressionNotIn;

});
parcelRegister("7z4EI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionNotIn = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
/**
 * https://www.w3.org/TR/sparql11-query/#func-not-in
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ var $581f69d5eab35cd6$var$ExpressionFunctionNotIn = /*#__PURE__*/ function(_bus_function_factory_1_ExpressionFunctionBase) {
    (0, $i3fW3._)(ExpressionFunctionNotIn, _bus_function_factory_1_ExpressionFunctionBase);
    function ExpressionFunctionNotIn(inFunction) {
        (0, $jGAMp._)(this, ExpressionFunctionNotIn);
        var _this;
        var _this1;
        _this = (0, $kzDuW._)(this, ExpressionFunctionNotIn, [
            {
                arity: Number.POSITIVE_INFINITY,
                operator: $aduX6.SparqlOperator.NOT_IN,
                apply: function(context) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var isIn;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this1.inFunction.apply(context)
                                    ];
                                case 1:
                                    isIn = _state.sent();
                                    return [
                                        2,
                                        (0, $aduX6.bool)(!isIn.typedValue)
                                    ];
                            }
                        });
                    })();
                }
            }
        ]), _this1 = _this;
        _this1.inFunction = inFunction;
        return _this;
    }
    (0, $byiyg._)(ExpressionFunctionNotIn, [
        {
            key: "checkArity",
            value: function checkArity(args) {
                return args.length > 0;
            }
        }
    ]);
    return ExpressionFunctionNotIn;
}($1W2eA.ExpressionFunctionBase);
module.exports.ExpressionFunctionNotIn = $581f69d5eab35cd6$var$ExpressionFunctionNotIn;

});



parcelRegister("apIh3", function(module, exports) {
"use strict";
var $794e951b229500e8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $794e951b229500e8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $794e951b229500e8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$794e951b229500e8$var$__exportStar((parcelRequire("exDlN")), module.exports);

});
parcelRegister("exDlN", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermGreaterThanEqual = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $6Fsqi = parcelRequire("6Fsqi");
/**
 * A comunica TermFunctionGreaterThanEqual Function Factory Actor.
 */ var $a962abf4a1d183ec$var$ActorFunctionFactoryTermGreaterThanEqual = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermGreaterThanEqual, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermGreaterThanEqual(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermGreaterThanEqual);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryTermGreaterThanEqual, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.GTE
                ],
                termFunction: true
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryTermGreaterThanEqual, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var lessThanEqualFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.LTE,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                lessThanEqualFunction = _state.sent();
                                return [
                                    2,
                                    new $6Fsqi.TermFunctionGreaterThanEqual(lessThanEqualFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryTermGreaterThanEqual;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermGreaterThanEqual = $a962abf4a1d183ec$var$ActorFunctionFactoryTermGreaterThanEqual;

});
parcelRegister("6Fsqi", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionGreaterThanEqual = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $4dac9eab5b4c3946$var$TermFunctionGreaterThanEqual = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionGreaterThanEqual, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionGreaterThanEqual(lessThanEqualFunction) {
        (0, $jGAMp._)(this, TermFunctionGreaterThanEqual);
        var _this;
        _this = (0, $kzDuW._)(this, TermFunctionGreaterThanEqual, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.GTE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.GTE).set([
                    'term',
                    'term'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), first = _param[0], second = _param[1];
                        return(// X >= Y -> Y <= X
                        (0, $hMpIh._)(_this).lessThanEqualFunction.applyOnTerms([
                            second,
                            first
                        ], exprEval));
                    };
                }).collect()
            }
        ]);
        _this.lessThanEqualFunction = lessThanEqualFunction;
        return _this;
    }
    return TermFunctionGreaterThanEqual;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionGreaterThanEqual = $4dac9eab5b4c3946$var$TermFunctionGreaterThanEqual;

});



parcelRegister("gAfo6", function(module, exports) {
"use strict";
var $c12bf1cc73f56d20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c12bf1cc73f56d20$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c12bf1cc73f56d20$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c12bf1cc73f56d20$var$__exportStar((parcelRequire("f7zop")), module.exports);

});
parcelRegister("f7zop", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermGreaterThan = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $5AfuH = parcelRequire("5AfuH");
/**
 * A comunica TermFunctionGreaterThan Function Factory Actor.
 */ var $b022f6b7a29fe4fe$var$ActorFunctionFactoryTermGreaterThan = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermGreaterThan, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermGreaterThan(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermGreaterThan);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryTermGreaterThan, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.GT
                ],
                termFunction: true
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryTermGreaterThan, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var lessThanFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.LT,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                lessThanFunction = _state.sent();
                                return [
                                    2,
                                    new $5AfuH.TermFunctionGreaterThan(lessThanFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryTermGreaterThan;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermGreaterThan = $b022f6b7a29fe4fe$var$ActorFunctionFactoryTermGreaterThan;

});
parcelRegister("5AfuH", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionGreaterThan = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $410c555f4379476f$var$TermFunctionGreaterThan = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionGreaterThan, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionGreaterThan(lessThanFunction) {
        (0, $jGAMp._)(this, TermFunctionGreaterThan);
        var _this;
        _this = (0, $kzDuW._)(this, TermFunctionGreaterThan, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.GT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.GT).set([
                    'term',
                    'term'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), first = _param[0], second = _param[1];
                        return(// X < Y -> Y > X
                        (0, $hMpIh._)(_this).lessThanFunction.applyOnTerms([
                            second,
                            first
                        ], expressionEvaluator));
                    };
                }).collect()
            }
        ]);
        _this.lessThanFunction = lessThanFunction;
        return _this;
    }
    return TermFunctionGreaterThan;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionGreaterThan = $410c555f4379476f$var$TermFunctionGreaterThan;

});



parcelRegister("3QKdb", function(module, exports) {
"use strict";
var $2cda1314b7e1efd6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2cda1314b7e1efd6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2cda1314b7e1efd6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2cda1314b7e1efd6$var$__exportStar((parcelRequire("j6mCn")), module.exports);

});
parcelRegister("j6mCn", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermInequality = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $h01BB = parcelRequire("h01BB");
/**
 * A comunica TermFunctionInequality Function Factory Actor.
 */ var $de801f54c1c018d9$var$ActorFunctionFactoryTermInequality = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermInequality, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermInequality(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermInequality);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryTermInequality, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.NOT_EQUAL
                ],
                termFunction: true
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryTermInequality, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var equalityFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.EQUAL,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                equalityFunction = _state.sent();
                                return [
                                    2,
                                    new $h01BB.TermFunctionInequality(equalityFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryTermInequality;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermInequality = $de801f54c1c018d9$var$ActorFunctionFactoryTermInequality;

});
parcelRegister("h01BB", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionInequality = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $c603ae8da1ed4259$var$TermFunctionInequality = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionInequality, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionInequality(equalityFunction) {
        (0, $jGAMp._)(this, TermFunctionInequality);
        var _this;
        _this = (0, $kzDuW._)(this, TermFunctionInequality, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.NOT_EQUAL,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.NOT_EQUAL).set([
                    'term',
                    'term'
                ], function(expressionEvaluator) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), first = _param[0], second = _param[1];
                        return (0, $aduX6.bool)(!(0, $hMpIh._)(_this).equalityFunction.applyOnTerms([
                            first,
                            second
                        ], expressionEvaluator).typedValue);
                    };
                }).collect()
            }
        ]);
        _this.equalityFunction = equalityFunction;
        return _this;
    }
    return TermFunctionInequality;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionInequality = $c603ae8da1ed4259$var$TermFunctionInequality;

});



parcelRegister("pPlxK", function(module, exports) {
"use strict";
var $04da2a410839d6e0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04da2a410839d6e0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $04da2a410839d6e0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$04da2a410839d6e0$var$__exportStar((parcelRequire("8sRh8")), module.exports);

});
parcelRegister("8sRh8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLesserThanEqual = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $dcJUx = parcelRequire("dcJUx");
/**
 * A comunica TermFunctionLesserThanEqual Function Factory Actor.
 */ var $629a439e3b617f52$var$ActorFunctionFactoryTermLesserThanEqual = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermLesserThanEqual, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermLesserThanEqual(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermLesserThanEqual);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryTermLesserThanEqual, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LTE
                ],
                termFunction: true
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryTermLesserThanEqual, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var equalityFunction, lessThanFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.EQUAL,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                equalityFunction = _state.sent();
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.LT,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 2:
                                lessThanFunction = _state.sent();
                                return [
                                    2,
                                    new $dcJUx.TermFunctionLesserThanEqual(equalityFunction, lessThanFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryTermLesserThanEqual;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermLesserThanEqual = $629a439e3b617f52$var$ActorFunctionFactoryTermLesserThanEqual;

});
parcelRegister("dcJUx", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLesserThanEqual = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");
var $99d00249ac7471a3$var$TermFunctionLesserThanEqual = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionLesserThanEqual, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionLesserThanEqual(equalityFunction, lessThanFunction) {
        (0, $jGAMp._)(this, TermFunctionLesserThanEqual);
        var _this;
        _this = (0, $kzDuW._)(this, TermFunctionLesserThanEqual, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.LTE,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.LTE).set([
                    'term',
                    'term'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), first = _param[0], second = _param[1];
                        return(// X <= Y -> X < Y || X = Y
                        // First check if the first is lesser than the second, then check if they are equal.
                        // Doing this, the correct error will be thrown,
                        // each type that has a lesserThanEqual has a matching lesserThan.
                        (0, $aduX6.bool)((0, $hMpIh._)(_this).lessThanFunction.applyOnTerms([
                            first,
                            second
                        ], exprEval).typedValue || (0, $hMpIh._)(_this).equalityFunction.applyOnTerms([
                            first,
                            second
                        ], exprEval).typedValue));
                    };
                }).collect()
            }
        ]);
        _this.equalityFunction = equalityFunction;
        _this.lessThanFunction = lessThanFunction;
        return _this;
    }
    return TermFunctionLesserThanEqual;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionLesserThanEqual = $99d00249ac7471a3$var$TermFunctionLesserThanEqual;

});



parcelRegister("37h0Z", function(module, exports) {
"use strict";
var $244f39563e7eb471$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $244f39563e7eb471$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $244f39563e7eb471$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$244f39563e7eb471$var$__exportStar((parcelRequire("cZ4de")), module.exports);

});
parcelRegister("cZ4de", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLesserThan = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $aduX6 = parcelRequire("aduX6");

var $Nwxh6 = parcelRequire("Nwxh6");
/**
 * A comunica TermFunctionLesserThan Function Factory Actor.
 */ var $973e730c356d8000$var$ActorFunctionFactoryTermLesserThan = /*#__PURE__*/ function(_bus_function_factory_1_ActorFunctionFactoryDedicated) {
    (0, $i3fW3._)(ActorFunctionFactoryTermLesserThan, _bus_function_factory_1_ActorFunctionFactoryDedicated);
    function ActorFunctionFactoryTermLesserThan(args) {
        (0, $jGAMp._)(this, ActorFunctionFactoryTermLesserThan);
        var _this;
        _this = (0, $kzDuW._)(this, ActorFunctionFactoryTermLesserThan, [
            (0, $emQHU._)((0, $iT0je._)({}, args), {
                functionNames: [
                    $aduX6.SparqlOperator.LT
                ],
                termFunction: true
            })
        ]);
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(ActorFunctionFactoryTermLesserThan, [
        {
            key: "run",
            value: function run(args) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var equalityFunction;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.EQUAL,
                                        requireTermExpression: true,
                                        context: args.context,
                                        arguments: args["arguments"]
                                    })
                                ];
                            case 1:
                                equalityFunction = _state.sent();
                                return [
                                    2,
                                    new $Nwxh6.TermFunctionLesserThan(equalityFunction)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorFunctionFactoryTermLesserThan;
}($1W2eA.ActorFunctionFactoryDedicated);
module.exports.ActorFunctionFactoryTermLesserThan = $973e730c356d8000$var$ActorFunctionFactoryTermLesserThan;

});
parcelRegister("Nwxh6", function(module, exports) {

var $hMpIh = parcelRequire("hMpIh");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLesserThan = void 0;

var $1W2eA = parcelRequire("1W2eA");

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");
var $094dd0a0f8e46415$var$TermFunctionLesserThan = /*#__PURE__*/ function(_bus_function_factory_1_TermFunctionBase) {
    (0, $i3fW3._)(TermFunctionLesserThan, _bus_function_factory_1_TermFunctionBase);
    function TermFunctionLesserThan(equalityFunction) {
        (0, $jGAMp._)(this, TermFunctionLesserThan);
        var _this;
        _this = (0, $kzDuW._)(this, TermFunctionLesserThan, [
            {
                arity: 2,
                operator: $aduX6.SparqlOperator.LT,
                overloads: (0, $aduX6.declare)($aduX6.SparqlOperator.LT).numberTest(function() {
                    return function(left, right) {
                        return left < right;
                    };
                }).stringTest(function() {
                    return function(left, right) {
                        return left.localeCompare(right) === -1;
                    };
                }).booleanTest(function() {
                    return function(left, right) {
                        return left < right;
                    };
                }).dateTimeTest(function(exprEval) {
                    return function(left, right) {
                        return (0, $aduX6.toUTCDate)(left, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime() < (0, $aduX6.toUTCDate)(right, exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime();
                    };
                }).copy({
                    // https://www.w3.org/TR/xpath-functions/#func-date-less-than
                    from: [
                        $aduX6.TypeURL.XSD_DATE_TIME,
                        $aduX6.TypeURL.XSD_DATE_TIME
                    ],
                    to: [
                        $aduX6.TypeURL.XSD_DATE,
                        $aduX6.TypeURL.XSD_DATE
                    ]
                }).set([
                    $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION,
                    $aduX6.TypeURL.XSD_YEAR_MONTH_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), dur1L = _param[0], dur2L = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-yearMonthDuration-less-than
                        (0, $aduX6.bool)((0, $aduX6.yearMonthDurationsToMonths)((0, $aduX6.defaultedYearMonthDurationRepresentation)(dur1L.typedValue)) < (0, $aduX6.yearMonthDurationsToMonths)((0, $aduX6.defaultedYearMonthDurationRepresentation)(dur2L.typedValue))));
                    };
                }).set([
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION,
                    $aduX6.TypeURL.XSD_DAY_TIME_DURATION
                ], function() {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), dur1 = _param[0], dur2 = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-dayTimeDuration-greater-than
                        (0, $aduX6.bool)((0, $aduX6.dayTimeDurationsToSeconds)((0, $aduX6.defaultedDayTimeDurationRepresentation)(dur1.typedValue)) < (0, $aduX6.dayTimeDurationsToSeconds)((0, $aduX6.defaultedDayTimeDurationRepresentation)(dur2.typedValue))));
                    };
                }).set([
                    $aduX6.TypeURL.XSD_TIME,
                    $aduX6.TypeURL.XSD_TIME
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), time1 = _param[0], time2 = _param[1];
                        return(// https://www.w3.org/TR/xpath-functions/#func-time-less-than
                        (0, $aduX6.bool)((0, $aduX6.toUTCDate)((0, $aduX6.defaultedDateTimeRepresentation)(time1.typedValue), exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime() < (0, $aduX6.toUTCDate)((0, $aduX6.defaultedDateTimeRepresentation)(time2.typedValue), exprEval.context.getSafe($9nBhR.KeysExpressionEvaluator.defaultTimeZone)).getTime()));
                    };
                }).set([
                    'quad',
                    'quad'
                ], function(exprEval) {
                    return function(param) {
                        var _param = (0, $32TW8._)(param, 2), left = _param[0], right = _param[1];
                        var subjectTest = (0, $hMpIh._)(_this).quadComponentTest(left.subject, right.subject, exprEval);
                        if (subjectTest !== undefined) return (0, $aduX6.bool)(subjectTest);
                        var predicateTest = (0, $hMpIh._)(_this).quadComponentTest(left.predicate, right.predicate, exprEval);
                        if (predicateTest !== undefined) return (0, $aduX6.bool)(predicateTest);
                        var objectTest = (0, $hMpIh._)(_this).quadComponentTest(left.object, right.object, exprEval);
                        if (objectTest !== undefined) return (0, $aduX6.bool)(objectTest);
                        var _this_quadComponentTest;
                        return (0, $aduX6.bool)((_this_quadComponentTest = (0, $hMpIh._)(_this).quadComponentTest(left.graph, right.graph, exprEval)) !== null && _this_quadComponentTest !== void 0 ? _this_quadComponentTest : false);
                    };
                }, false).collect()
            }
        ]);
        _this.equalityFunction = equalityFunction;
        return _this;
    }
    (0, $byiyg._)(TermFunctionLesserThan, [
        {
            key: "quadComponentTest",
            value: function quadComponentTest(left, right, exprEval) {
                // If components are equal, we don't have an answer
                var componentEqual = this.equalityFunction.applyOnTerms([
                    left,
                    right
                ], exprEval);
                if (componentEqual.typedValue) return undefined;
                var componentLess = this.applyOnTerms([
                    left,
                    right
                ], exprEval);
                return componentLess.typedValue;
            }
        }
    ]);
    return TermFunctionLesserThan;
}($1W2eA.TermFunctionBase);
module.exports.TermFunctionLesserThan = $094dd0a0f8e46415$var$TermFunctionLesserThan;

});



parcelRegister("aGPm7", function(module, exports) {
"use strict";
var $7c85a9d1dc550c3e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c85a9d1dc550c3e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c85a9d1dc550c3e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7c85a9d1dc550c3e$var$__exportStar((parcelRequire("695Kp")), module.exports);

});
parcelRegister("695Kp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpWayback = void 0;

var $2terW = parcelRequire("2terW");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $99iqU = parcelRequire("99iqU");
var $47980ab18c9d2794$var$WAYBACK_URL = 'http://wayback.archive-it.org/';
function $47980ab18c9d2794$var$addWayback(action) {
    var request = new Request(action.input, action.init);
    return {
        input: new Request(new URL("/".concat(request.url), $47980ab18c9d2794$var$WAYBACK_URL), request)
    };
}
function $47980ab18c9d2794$var$getProxyHandler(context) {
    var handler = context.get($9nBhR.KeysHttpProxy.httpProxyHandler);
    if (handler) return function(action) {
        return handler.getProxy($47980ab18c9d2794$var$addWayback(action));
    };
    return function(action) {
        return Promise.resolve($47980ab18c9d2794$var$addWayback(action));
    };
}
/**
 * A Comunica actor to intercept HTTP requests to recover broken links using the WayBack Machine
 */ var $47980ab18c9d2794$var$ActorHttpWayback = /*#__PURE__*/ function(_bus_http_1_ActorHttp) {
    (0, $i3fW3._)(ActorHttpWayback, _bus_http_1_ActorHttp);
    function ActorHttpWayback(args) {
        (0, $jGAMp._)(this, ActorHttpWayback);
        return (0, $kzDuW._)(this, ActorHttpWayback, [
            args
        ]);
    }
    (0, $byiyg._)(ActorHttpWayback, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var result, fallbackResult, ref, body;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorHttp.mediate(action)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(result.status === 404 && action.context.get($9nBhR.KeysHttpWayback.recoverBrokenLinks))) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.mediatorHttp.mediate((0, $emQHU._)((0, $iT0je._)({}, action), {
                                        context: action.context.set($9nBhR.KeysHttpWayback.recoverBrokenLinks, false).set($9nBhR.KeysHttpProxy.httpProxyHandler, {
                                            getProxy: $47980ab18c9d2794$var$getProxyHandler(action.context)
                                        })
                                    }))
                                ];
                            case 2:
                                fallbackResult = _state.sent();
                                // If the wayback machine returns a 200 status then use that result
                                if (fallbackResult.status === 200) ref = [
                                    fallbackResult,
                                    result
                                ], result = ref[0], fallbackResult = ref[1], ref;
                                // Consume stream to avoid process
                                body = fallbackResult.body;
                                if (!body) return [
                                    3,
                                    7
                                ];
                                if (!('cancel' in body && typeof body.cancel === 'function')) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    body.cancel()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 4:
                                if (!('destroy' in body && typeof body.destroy === 'function')) return [
                                    3,
                                    5
                                ];
                                body.destroy();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    (0, $99iqU.stringify)($2terW.ActorHttp.toNodeReadable(body))
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorHttpWayback;
}($2terW.ActorHttp);
module.exports.ActorHttpWayback = $47980ab18c9d2794$var$ActorHttpWayback;

});


parcelRegister("jLMV2", function(module, exports) {
"use strict";
var $e6485a649d35aa4a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6485a649d35aa4a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e6485a649d35aa4a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e6485a649d35aa4a$var$__exportStar((parcelRequire("fLDl8")), module.exports);

$e6485a649d35aa4a$var$__exportStar((parcelRequire("97kIC")), module.exports);

});
parcelRegister("fLDl8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseJsonLd = void 0;

var $1Nxez = parcelRequire("1Nxez");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $9KyjG = parcelRequire("9KyjG");

var $97kIC = parcelRequire("97kIC");
/**
 * A JSON-LD RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to parse JSON-LD-based RDF serializations and announce the presence of them by media type.
 */ var $b7a9c2e4a86d41ef$var$ActorRdfParseJsonLd = /*#__PURE__*/ function(_bus_rdf_parse_1_ActorRdfParseFixedMediaTypes) {
    (0, $i3fW3._)(ActorRdfParseJsonLd, _bus_rdf_parse_1_ActorRdfParseFixedMediaTypes);
    function ActorRdfParseJsonLd(args) {
        (0, $jGAMp._)(this, ActorRdfParseJsonLd);
        return (0, $kzDuW._)(this, ActorRdfParseJsonLd, [
            args
        ]);
    }
    (0, $byiyg._)(ActorRdfParseJsonLd, [
        {
            key: "testHandle",
            value: function testHandle(action, mediaType, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (context.has($9nBhR.KeysRdfParseHtmlScript.processingHtmlScript) && mediaType !== 'application/ld+json') return [
                                    2,
                                    (0, $kNNoa.failTest)("JSON-LD in script tags can only have media type 'application/ld+json'")
                                ];
                                if (!mediaType || !(mediaType in this.mediaTypePriorities || mediaType.endsWith('+json'))) return [
                                    2,
                                    (0, $kNNoa.failTest)("Unrecognized media type: ".concat(mediaType))
                                ];
                                return [
                                    4,
                                    this.testHandleChecked(action)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, mediaType, actionContext) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_metadata, dataFactory, _action_metadata_baseIRI, _actionContext_get, parser, data;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        parser = $9KyjG.JsonLdParser.fromHttpResponse((_action_metadata_baseIRI = (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI) !== null && _action_metadata_baseIRI !== void 0 ? _action_metadata_baseIRI : '', mediaType, action.headers, (0, $iT0je._)({
                            dataFactory: dataFactory,
                            documentLoader: (_actionContext_get = actionContext.get($9nBhR.KeysRdfParseJsonLd.documentLoader)) !== null && _actionContext_get !== void 0 ? _actionContext_get : new $97kIC.DocumentLoaderMediated(this.mediatorHttp, actionContext),
                            strictValues: actionContext.get($9nBhR.KeysRdfParseJsonLd.strictValues)
                        }, actionContext.get($9nBhR.KeysRdfParseJsonLd.parserOptions)));
                        data = parser["import"](action.data);
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfParseJsonLd;
}($1Nxez.ActorRdfParseFixedMediaTypes);
module.exports.ActorRdfParseJsonLd = $b7a9c2e4a86d41ef$var$ActorRdfParseJsonLd;

});
parcelRegister("9KyjG", function(module, exports) {
"use strict";
var $719307762132a803$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $719307762132a803$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $719307762132a803$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$719307762132a803$var$__exportStar((parcelRequire("agzTm")), module.exports);

});
parcelRegister("agzTm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonLdParser = void 0;

var $3Ywen = parcelRequire("3Ywen");

var $auQ3n = parcelRequire("auQ3n");

var $gwoF0 = parcelRequire("gwoF0");

var $b6Fqk = parcelRequire("b6Fqk");

var $dkxPt = parcelRequire("dkxPt");

var $3YuF6 = parcelRequire("3YuF6");

var $5Torg = parcelRequire("5Torg");

var $2sPh7 = parcelRequire("2sPh7");

var $6OtFe = parcelRequire("6OtFe");

var $7rf23 = parcelRequire("7rf23");

var $efKCv = parcelRequire("efKCv");

var $5cma4 = parcelRequire("5cma4");

var $9qUmR = parcelRequire("9qUmR");

var $3zt6j = parcelRequire("3zt6j");

var $ilpEq = parcelRequire("ilpEq");

var $aA3b4 = parcelRequire("aA3b4");

var $aalae = parcelRequire("aalae");

var $fdIar = parcelRequire("fdIar");

var $aiMM8 = parcelRequire("aiMM8");
/**
 * A stream transformer that parses JSON-LD (text) streams to an {@link RDF.Stream}.
 */ var $77973d69b4baa447$var$JsonLdParser = /*#__PURE__*/ function(_readable_stream_1_Transform) {
    (0, $i3fW3._)(JsonLdParser, _readable_stream_1_Transform);
    function JsonLdParser(options) {
        (0, $jGAMp._)(this, JsonLdParser);
        var _this;
        _this = (0, $kzDuW._)(this, JsonLdParser, [
            {
                readableObjectMode: true
            }
        ]);
        options = options || {};
        _this.options = options;
        _this.parsingContext = new $aA3b4.ParsingContext(Object.assign({
            parser: _this
        }, options));
        _this.util = new $aalae.Util({
            dataFactory: options.dataFactory,
            parsingContext: _this.parsingContext
        });
        _this.jsonParser = new $3Ywen();
        _this.contextJobs = [];
        _this.typeJobs = [];
        _this.contextAwaitingJobs = [];
        _this.lastDepth = 0;
        _this.lastKeys = [];
        _this.lastOnValueJob = Promise.resolve();
        _this.attachJsonParserListeners();
        _this.on('end', function() {
            if (typeof _this.jsonParser.mode !== 'undefined') _this.emit('error', new Error('Unclosed document'));
        });
        return _this;
    }
    (0, $byiyg._)(JsonLdParser, [
        {
            /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ key: "import",
            value: function _import(stream) {
                if ('pipe' in stream) {
                    stream.on('error', function(error) {
                        return parsed.emit('error', error);
                    });
                    var parsed = stream.pipe(new JsonLdParser(this.options));
                    return parsed;
                } else {
                    var output = new $gwoF0.PassThrough({
                        readableObjectMode: true
                    });
                    stream.on('error', function(error) {
                        return parsed1.emit('error', error);
                    });
                    stream.on('data', function(data) {
                        return output.push(data);
                    });
                    stream.on('end', function() {
                        return output.push(null);
                    });
                    var parsed1 = output.pipe(new JsonLdParser(this.options));
                    return parsed1;
                }
            }
        },
        {
            key: "_transform",
            value: function _transform(chunk, encoding, callback) {
                this.jsonParser.write(chunk);
                this.lastOnValueJob.then(function() {
                    return callback();
                }, function(error) {
                    return callback(error);
                });
            }
        },
        {
            key: "newOnValueJob",
            value: /**
     * Start a new job for parsing the given value.
     *
     * This will let the first valid {@link IEntryHandler} handle the entry.
     *
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @param {boolean} lastDepthCheck If the lastDepth check should be done for buffer draining.
     * @return {Promise<void>} A promise resolving when the job is done.
     */ function newOnValueJob(keys, value, depth, lastDepthCheck) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var flushStacks, listPointer, key, parentKey, handleKey, inProperty, i, validationResult, _tmp, _, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entryHandler, testResult, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                flushStacks = true;
                                if (!(lastDepthCheck && depth < this.lastDepth)) return [
                                    3,
                                    4
                                ];
                                // Check if we had any RDF lists that need to be terminated with an rdf:nil
                                listPointer = this.parsingContext.listPointerStack[this.lastDepth];
                                if (listPointer) {
                                    // Terminate the list if the had at least one value
                                    if (listPointer.value) this.push(this.util.dataFactory.quad(listPointer.value, this.util.rdfRest, this.util.rdfNil, this.util.getDefaultGraph()));
                                    // Add the list id to the id stack, so it can be used higher up in the stack
                                    listPointer.listId.listHead = true;
                                    this.parsingContext.idStack[listPointer.listRootDepth + 1] = [
                                        listPointer.listId
                                    ];
                                    this.parsingContext.listPointerStack.splice(this.lastDepth, 1);
                                }
                                return [
                                    4,
                                    $dkxPt.EntryHandlerContainer.isBufferableContainerHandler(this.parsingContext, this.lastKeys, this.lastDepth)
                                ];
                            case 1:
                                if (!_state.sent()) return [
                                    3,
                                    2
                                ];
                                this.parsingContext.pendingContainerFlushBuffers.push({
                                    depth: this.lastDepth,
                                    keys: this.lastKeys.slice(0, this.lastKeys.length)
                                });
                                flushStacks = false;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    this.flushBuffer(this.lastDepth, this.lastKeys)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    this.util.unaliasKeyword(keys[depth], keys, depth)
                                ];
                            case 5:
                                key = _state.sent();
                                return [
                                    4,
                                    this.util.unaliasKeywordParent(keys, depth)
                                ];
                            case 6:
                                parentKey = _state.sent();
                                this.parsingContext.emittedStack[depth] = true;
                                handleKey = true;
                                // Keywords inside @reverse is not allowed apart from @context
                                if ($auQ3n.Util.isValidKeyword(key) && parentKey === '@reverse' && key !== '@context') this.emit('error', new $auQ3n.ErrorCoded("Found the @id '".concat(value, "' inside an @reverse property"), $auQ3n.ERROR_CODES.INVALID_REVERSE_PROPERTY_MAP));
                                // Skip further processing if one of the parent nodes are invalid.
                                // We use the validationStack to reuse validation results that were produced before with common key stacks.
                                inProperty = false;
                                if (this.parsingContext.validationStack.length > 1) inProperty = this.parsingContext.validationStack[this.parsingContext.validationStack.length - 1].property;
                                i = Math.max(1, this.parsingContext.validationStack.length - 1);
                                _state.label = 7;
                            case 7:
                                if (!(i < keys.length - 1)) return [
                                    3,
                                    11
                                ];
                                _tmp = this.parsingContext.validationStack[i];
                                if (_tmp) return [
                                    3,
                                    9
                                ];
                                _ = this.parsingContext.validationStack;
                                return [
                                    4,
                                    this.validateKey(keys.slice(0, i + 1), i, inProperty)
                                ];
                            case 8:
                                _tmp = _[i] = _state.sent();
                                _state.label = 9;
                            case 9:
                                validationResult = _tmp;
                                if (!validationResult.valid) {
                                    this.parsingContext.emittedStack[depth] = false;
                                    handleKey = false;
                                    return [
                                        3,
                                        11
                                    ];
                                } else if (!inProperty && validationResult.property) inProperty = true;
                                _state.label = 10;
                            case 10:
                                i++;
                                return [
                                    3,
                                    7
                                ];
                            case 11:
                                return [
                                    4,
                                    this.util.isLiteral(keys, depth)
                                ];
                            case 12:
                                // Skip further processing if this node is part of a literal
                                if (_state.sent()) handleKey = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!handleKey) return [
                                    3,
                                    21
                                ];
                                _state.label = 13;
                            case 13:
                                _state.trys.push([
                                    13,
                                    19,
                                    20,
                                    21
                                ]);
                                _iterator = JsonLdParser.ENTRY_HANDLERS[Symbol.iterator]();
                                _state.label = 14;
                            case 14:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    18
                                ];
                                entryHandler = _step.value;
                                return [
                                    4,
                                    entryHandler.test(this.parsingContext, this.util, key, keys, depth)
                                ];
                            case 15:
                                testResult = _state.sent();
                                if (!testResult) return [
                                    3,
                                    17
                                ];
                                // Pass processing over to the handler
                                return [
                                    4,
                                    entryHandler.handle(this.parsingContext, this.util, key, keys, value, depth, testResult)
                                ];
                            case 16:
                                _state.sent();
                                // Flag that this depth is processed
                                if (entryHandler.isStackProcessor()) this.parsingContext.processingStack[depth] = true;
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    14
                                ];
                            case 18:
                                return [
                                    3,
                                    21
                                ];
                            case 19:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    21
                                ];
                            case 20:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 21:
                                if (!(depth === 0 && Array.isArray(value))) return [
                                    3,
                                    23
                                ];
                                return [
                                    4,
                                    this.util.validateValueIndexes(value)
                                ];
                            case 22:
                                _state.sent();
                                _state.label = 23;
                            case 23:
                                // When we go up the stack, flush the old stack
                                if (flushStacks && depth < this.lastDepth) // Reset our stacks
                                this.flushStacks(this.lastDepth);
                                this.lastDepth = depth;
                                this.lastKeys = keys;
                                // Clear the keyword cache at this depth, and everything underneath.
                                this.parsingContext.unaliasedKeywordCacheStack.splice(depth - 1);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Flush the processing stacks at the given depth.
     * @param {number} depth A depth.
     */ key: "flushStacks",
            value: function flushStacks(depth) {
                this.parsingContext.processingStack.splice(depth, 1);
                this.parsingContext.processingType.splice(depth, 1);
                this.parsingContext.emittedStack.splice(depth, 1);
                this.parsingContext.idStack.splice(depth, 1);
                this.parsingContext.graphStack.splice(depth + 1, 1);
                this.parsingContext.graphContainerTermStack.splice(depth, 1);
                this.parsingContext.jsonLiteralStack.splice(depth, 1);
                this.parsingContext.validationStack.splice(depth - 1, 2);
                this.parsingContext.literalStack.splice(depth, this.parsingContext.literalStack.length - depth);
                this.parsingContext.annotationsBuffer.splice(depth, 1);
            // TODO: just like the literal stack, splice all other stack until the end as well?
            }
        },
        {
            key: "flushBuffer",
            value: /**
     * Flush buffers for the given depth.
     *
     * This should be called after the last entry at a given depth was processed.
     *
     * @param {number} depth A depth.
     * @param {any[]} keys A stack of keys.
     * @return {Promise<void>} A promise resolving if flushing is done.
     */ function flushBuffer(depth, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var subjects, subjectsWasDefined, valueBuffer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, subject, depthOffsetGraph, graphs, _tmp, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, graph, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, bufferedValue, subGraphBuffer, _, _1, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, bufferedValue1, err, graphBuffer, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, subject1, graph1, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, bufferedValue2, annotationsBuffer, annotationsBufferParent, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, annotation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                subjects = this.parsingContext.idStack[depth];
                                subjectsWasDefined = !!subjects;
                                if (!subjectsWasDefined) subjects = this.parsingContext.idStack[depth] = [
                                    this.util.dataFactory.blankNode()
                                ];
                                // Flush values at this level
                                valueBuffer = this.parsingContext.unidentifiedValuesBuffer[depth];
                                if (!valueBuffer) return [
                                    3,
                                    14
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    11,
                                    12,
                                    13
                                ]);
                                _iterator = subjects[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    10
                                ];
                                subject = _step.value;
                                return [
                                    4,
                                    this.util.getDepthOffsetGraph(depth, keys)
                                ];
                            case 3:
                                depthOffsetGraph = _state.sent();
                                if (!(this.parsingContext.graphStack[depth] || depthOffsetGraph >= 0)) return [
                                    3,
                                    4
                                ];
                                _tmp = this.parsingContext.idStack[depth - depthOffsetGraph - 1];
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    this.util.getGraphContainerValue(keys, depth)
                                ];
                            case 5:
                                _tmp = [
                                    _state.sent()
                                ];
                                _state.label = 6;
                            case 6:
                                graphs = _tmp;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!graphs) return [
                                    3,
                                    7
                                ];
                                try {
                                    for(_iterator1 = graphs[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        graph = _step1.value;
                                        // Flush values to stream if the graph @id is known
                                        this.parsingContext.emittedStack[depth] = true;
                                        _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                        try {
                                            for(_iterator2 = valueBuffer[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                bufferedValue = _step2.value;
                                                this.util.emitQuadChecked(depth, subject, bufferedValue.predicate, bufferedValue.object, graph, bufferedValue.reverse, bufferedValue.isEmbedded);
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                    _iterator2["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                _1 = (_ = this.parsingContext).getUnidentifiedGraphBufferSafe;
                                return [
                                    4,
                                    this.util.getDepthOffsetGraph(depth, keys)
                                ];
                            case 8:
                                subGraphBuffer = _1.apply(_, [
                                    depth - _state.sent() - 1
                                ]);
                                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                try {
                                    for(_iterator3 = valueBuffer[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                        bufferedValue1 = _step3.value;
                                        if (bufferedValue1.reverse) subGraphBuffer.push({
                                            object: subject,
                                            predicate: bufferedValue1.predicate,
                                            subject: bufferedValue1.object,
                                            isEmbedded: bufferedValue1.isEmbedded
                                        });
                                        else subGraphBuffer.push({
                                            object: bufferedValue1.object,
                                            predicate: bufferedValue1.predicate,
                                            subject: subject,
                                            isEmbedded: bufferedValue1.isEmbedded
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                            _iterator3["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                                _state.label = 9;
                            case 9:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 10:
                                return [
                                    3,
                                    13
                                ];
                            case 11:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 13:
                                this.parsingContext.unidentifiedValuesBuffer.splice(depth, 1);
                                this.parsingContext.literalStack.splice(depth, 1);
                                this.parsingContext.jsonLiteralStack.splice(depth, 1);
                                _state.label = 14;
                            case 14:
                                // Flush graphs at this level
                                graphBuffer = this.parsingContext.unidentifiedGraphsBuffer[depth];
                                if (graphBuffer) {
                                    _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                    try {
                                        for(_iterator4 = subjects[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                            subject1 = _step4.value;
                                            // A @graph statement at the root without @id relates to the default graph,
                                            // unless there are top-level properties,
                                            // others relate to blank nodes.
                                            graph1 = depth === 1 && subject1.termType === 'BlankNode' && !this.parsingContext.topLevelProperties ? this.util.getDefaultGraph() : subject1;
                                            this.parsingContext.emittedStack[depth] = true;
                                            _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                            try {
                                                for(_iterator5 = graphBuffer[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                                    bufferedValue2 = _step5.value;
                                                    this.parsingContext.emitQuad(depth, this.util.dataFactory.quad(bufferedValue2.subject, bufferedValue2.predicate, bufferedValue2.object, graph1));
                                                }
                                            } catch (err) {
                                                _didIteratorError5 = true;
                                                _iteratorError5 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                                        _iterator5["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError5) {
                                                        throw _iteratorError5;
                                                    }
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                                _iterator4["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }
                                    this.parsingContext.unidentifiedGraphsBuffer.splice(depth, 1);
                                }
                                // Push unhandled annotations up the stack as nested annotations
                                annotationsBuffer = this.parsingContext.annotationsBuffer[depth];
                                if (annotationsBuffer) {
                                    // Throw an error if we reach the top, and still have annotations
                                    if (annotationsBuffer.length > 0 && depth === 1) this.parsingContext.emitError(new $auQ3n.ErrorCoded("Annotations can not be made on top-level nodes", $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                                    // Pass the annotations buffer up one level in the stack
                                    annotationsBufferParent = this.parsingContext.getAnnotationsBufferSafe(depth - 1);
                                    _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                                    try {
                                        for(_iterator6 = annotationsBuffer[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                            annotation = _step6.value;
                                            annotationsBufferParent.push(annotation);
                                        }
                                    } catch (err) {
                                        _didIteratorError6 = true;
                                        _iteratorError6 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                                                _iterator6["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError6) {
                                                throw _iteratorError6;
                                            }
                                        }
                                    }
                                    delete this.parsingContext.annotationsBuffer[depth];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "validateKey",
            value: /**
     * Check if at least one {@link IEntryHandler} validates the entry to true.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth A depth.
     * @param {boolean} inProperty If the current depth is part of a valid property node.
     * @return {Promise<{ valid: boolean, property: boolean }>} A promise resolving to true or false.
     */ function validateKey(keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entryHandler, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = JsonLdParser.ENTRY_HANDLERS[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                entryHandler = _step.value;
                                return [
                                    4,
                                    entryHandler.validate(this.parsingContext, this.util, keys, depth, inProperty)
                                ];
                            case 3:
                                if (_state.sent()) return [
                                    2,
                                    {
                                        valid: true,
                                        property: inProperty || entryHandler.isPropertyHandler()
                                    }
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    {
                                        valid: false,
                                        property: false
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Attach all required listeners to the JSON parser.
     *
     * This should only be called once.
     */ key: "attachJsonParserListeners",
            value: function attachJsonParserListeners() {
                var _this = this;
                // Listen to json parser events
                this.jsonParser.onValue = function(value) {
                    var depth = _this.jsonParser.stack.length;
                    var keys = new Array(depth + 1).fill(0).map(function(v, i) {
                        return i === depth ? _this.jsonParser.key : _this.jsonParser.stack[i].key;
                    });
                    if (!_this.isParsingContextInner(depth)) {
                        var valueJobCb = function() {
                            return _this.newOnValueJob(keys, value, depth, true);
                        };
                        if (!_this.parsingContext.streamingProfile && !_this.parsingContext.contextTree.getContext(keys.slice(0, -1))) {
                            // If an out-of-order context is allowed,
                            // we have to buffer everything.
                            // We store jobs for @context's and @type's separately,
                            // because at the end, we have to process them first.
                            // We also handle @type because these *could* introduce a type-scoped context.
                            if (keys[depth] === '@context') {
                                var jobs = _this.contextJobs[depth];
                                if (!jobs) jobs = _this.contextJobs[depth] = [];
                                jobs.push(valueJobCb);
                            } else _this.contextAwaitingJobs.push({
                                job: valueJobCb,
                                keys: keys,
                                depth: depth
                            });
                        } else // Make sure that our value jobs are chained synchronously
                        _this.lastOnValueJob = _this.lastOnValueJob.then(valueJobCb);
                        // Execute all buffered jobs on deeper levels
                        if (!_this.parsingContext.streamingProfile && depth === 0) _this.lastOnValueJob = _this.lastOnValueJob.then(function() {
                            return _this.executeBufferedJobs();
                        });
                    }
                };
                this.jsonParser.onError = function(error) {
                    _this.emit('error', error);
                };
            }
        },
        {
            /**
     * Check if the parser is currently parsing an element that is part of an @context entry.
     * @param {number} depth A depth.
     * @return {boolean} A boolean.
     */ key: "isParsingContextInner",
            value: function isParsingContextInner(depth) {
                for(var i = depth; i > 0; i--){
                    if (this.jsonParser.stack[i - 1].key === '@context') return true;
                }
                return false;
            }
        },
        {
            key: "executeBufferedJobs",
            value: /**
     * Execute all buffered jobs.
     * @return {Promise<void>} A promise resolving if all jobs are finished.
     */ function executeBufferedJobs() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, jobs, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, job, err, err, contextAwaitingJobs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, job1, _tmp, _tmp1, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, job2, applicableTypeJobs, applicableTypeJobIds, i, typeJob, sortedTypeJobs, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, typeJob1, err, sortedApplicableTypeJobIds, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, jobId, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator = this.contextJobs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    11
                                ];
                                jobs = _step.value;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!jobs) return [
                                    3,
                                    10
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator1 = jobs[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    7
                                ];
                                job = _step1.value;
                                return [
                                    4,
                                    job()
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                // Clear the keyword cache.
                                this.parsingContext.unaliasedKeywordCacheStack.splice(0);
                                contextAwaitingJobs = [];
                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                _state.label = 15;
                            case 15:
                                _state.trys.push([
                                    15,
                                    23,
                                    24,
                                    25
                                ]);
                                _iterator2 = this.contextAwaitingJobs[Symbol.iterator]();
                                _state.label = 16;
                            case 16:
                                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                    3,
                                    22
                                ];
                                job1 = _step2.value;
                                return [
                                    4,
                                    this.util.unaliasKeyword(job1.keys[job1.depth], job1.keys, job1.depth, true)
                                ];
                            case 17:
                                _tmp = _state.sent() === '@type';
                                if (_tmp) return [
                                    3,
                                    20
                                ];
                                _tmp1 = typeof job1.keys[job1.depth] === 'number';
                                if (!_tmp1) return [
                                    3,
                                    19
                                ];
                                return [
                                    4,
                                    this.util.unaliasKeyword(job1.keys[job1.depth - 1], job1.keys, job1.depth - 1, true)
                                ];
                            case 18:
                                _tmp1 = _state.sent() === '@type';
                                _state.label = 19;
                            case 19:
                                _tmp = _tmp1;
                                _state.label = 20;
                            case 20:
                                if (_tmp) // Remove @type from keys, because we want it to apply to parent later on
                                this.typeJobs.push({
                                    job: job1.job,
                                    keys: job1.keys.slice(0, job1.keys.length - 1)
                                });
                                else contextAwaitingJobs.push(job1);
                                _state.label = 21;
                            case 21:
                                _iteratorNormalCompletion2 = true;
                                return [
                                    3,
                                    16
                                ];
                            case 22:
                                return [
                                    3,
                                    25
                                ];
                            case 23:
                                err = _state.sent();
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                                return [
                                    3,
                                    25
                                ];
                            case 24:
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                        _iterator2["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 25:
                                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                _state.label = 26;
                            case 26:
                                _state.trys.push([
                                    26,
                                    40,
                                    41,
                                    42
                                ]);
                                _iterator3 = contextAwaitingJobs[Symbol.iterator]();
                                _state.label = 27;
                            case 27:
                                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                    3,
                                    39
                                ];
                                job2 = _step3.value;
                                if (!(this.typeJobs.length > 0)) return [
                                    3,
                                    36
                                ];
                                // First collect all applicable type jobs
                                applicableTypeJobs = [];
                                applicableTypeJobIds = [];
                                for(i = 0; i < this.typeJobs.length; i++){
                                    typeJob = this.typeJobs[i];
                                    if ($aalae.Util.isPrefixArray(typeJob.keys, job2.keys)) {
                                        applicableTypeJobs.push(typeJob);
                                        applicableTypeJobIds.push(i);
                                    }
                                }
                                // Next, sort the jobs from short to long key length (to ensure types higher up in the tree to be handled first)
                                sortedTypeJobs = applicableTypeJobs.sort(function(job1, job2) {
                                    return job1.keys.length - job2.keys.length;
                                });
                                _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                _state.label = 28;
                            case 28:
                                _state.trys.push([
                                    28,
                                    33,
                                    34,
                                    35
                                ]);
                                _iterator4 = sortedTypeJobs[Symbol.iterator]();
                                _state.label = 29;
                            case 29:
                                if (!!(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done)) return [
                                    3,
                                    32
                                ];
                                typeJob1 = _step4.value;
                                return [
                                    4,
                                    typeJob1.job()
                                ];
                            case 30:
                                _state.sent();
                                _state.label = 31;
                            case 31:
                                _iteratorNormalCompletion4 = true;
                                return [
                                    3,
                                    29
                                ];
                            case 32:
                                return [
                                    3,
                                    35
                                ];
                            case 33:
                                err = _state.sent();
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                                return [
                                    3,
                                    35
                                ];
                            case 34:
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                        _iterator4["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 35:
                                // Remove the executed type jobs
                                // Sort first, so we can efficiently splice
                                sortedApplicableTypeJobIds = applicableTypeJobIds.sort().reverse();
                                _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                try {
                                    for(_iterator5 = sortedApplicableTypeJobIds[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                        jobId = _step5.value;
                                        this.typeJobs.splice(jobId, 1);
                                    }
                                } catch (err) {
                                    _didIteratorError5 = true;
                                    _iteratorError5 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                            _iterator5["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError5) {
                                            throw _iteratorError5;
                                        }
                                    }
                                }
                                _state.label = 36;
                            case 36:
                                return [
                                    4,
                                    job2.job()
                                ];
                            case 37:
                                _state.sent();
                                _state.label = 38;
                            case 38:
                                _iteratorNormalCompletion3 = true;
                                return [
                                    3,
                                    27
                                ];
                            case 39:
                                return [
                                    3,
                                    42
                                ];
                            case 40:
                                err = _state.sent();
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                                return [
                                    3,
                                    42
                                ];
                            case 41:
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                        _iterator3["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 42:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "fromHttpResponse",
            value: /**
     * Construct a JsonLdParser from the given HTTP response.
     *
     * This will throw an error if no valid JSON response is received
     * (application/ld+json, application/json, or something+json).
     *
     * For raw JSON responses, exactly one link header pointing to a JSON-LD context is required.
     *
     * This method is not responsible for handling redirects.
     *
     * @param baseIRI The URI of the received response.
     * @param mediaType The received content type.
     * @param headers Optional HTTP headers.
     * @param options Optional parser options.
     */ function fromHttpResponse(baseIRI, mediaType, headers, options) {
                var context;
                var wellKnownMediaTypes = [
                    'application/activity+json'
                ];
                if (options && options.wellKnownMediaTypes) wellKnownMediaTypes = options.wellKnownMediaTypes;
                // Special cases when receiving something else than the JSON-LD media type or the wellKnownMediaTypes
                if (mediaType !== 'application/ld+json' && !wellKnownMediaTypes.includes(mediaType)) {
                    // Only accept JSON or JSON extension types
                    if (mediaType !== 'application/json' && !mediaType.endsWith('+json')) throw new $auQ3n.ErrorCoded("Unsupported JSON-LD media type ".concat(mediaType), $auQ3n.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                    // We need exactly one JSON-LD context in the link header
                    if (headers && headers.has('Link')) headers.forEach(function(value, key) {
                        if (key === 'link') {
                            var linkHeader = (0, $fdIar.parse)(value);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = linkHeader.get('rel', 'http://www.w3.org/ns/json-ld#context')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var link = _step.value;
                                    if (context) throw new $auQ3n.ErrorCoded('Multiple JSON-LD context link headers were found on ' + baseIRI, $auQ3n.ERROR_CODES.MULTIPLE_CONTEXT_LINK_HEADERS);
                                    context = link.uri;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    });
                    if (!context && !(options === null || options === void 0 ? void 0 : options.ignoreMissingContextLinkHeader)) throw new $auQ3n.ErrorCoded("Missing context link header for media type ".concat(mediaType, " on ").concat(baseIRI), $auQ3n.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                }
                // Check if the streaming profile is present
                var streamingProfile;
                if (headers && headers.has('Content-Type')) {
                    var contentType = headers.get('Content-Type');
                    var match = /; *profile=([^"]*)/.exec(contentType);
                    if (match && match[1] === 'http://www.w3.org/ns/json-ld#streaming') streamingProfile = true;
                }
                return new JsonLdParser(Object.assign({
                    baseIRI: baseIRI,
                    context: context,
                    streamingProfile: streamingProfile
                }, options ? options : {}));
            }
        }
    ]);
    return JsonLdParser;
}($gwoF0.Transform);
$77973d69b4baa447$var$JsonLdParser.DEFAULT_PROCESSING_MODE = '1.1';
$77973d69b4baa447$var$JsonLdParser.ENTRY_HANDLERS = [
    new $b6Fqk.EntryHandlerArrayValue(),
    new $2sPh7.EntryHandlerKeywordContext(),
    new $7rf23.EntryHandlerKeywordId(),
    new $efKCv.EntryHandlerKeywordIncluded(),
    new $6OtFe.EntryHandlerKeywordGraph(),
    new $5cma4.EntryHandlerKeywordNest(),
    new $9qUmR.EntryHandlerKeywordType(),
    new $ilpEq.EntryHandlerKeywordValue(),
    new $aiMM8.EntryHandlerKeywordAnnotation(),
    new $dkxPt.EntryHandlerContainer(),
    new $3zt6j.EntryHandlerKeywordUnknownFallback(),
    new $5Torg.EntryHandlerPredicate(),
    new $3YuF6.EntryHandlerInvalidFallback()
];
module.exports.JsonLdParser = $77973d69b4baa447$var$JsonLdParser;

});
parcelRegister("auQ3n", function(module, exports) {
"use strict";
var $7a451577f14e0b3a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a451577f14e0b3a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7a451577f14e0b3a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7a451577f14e0b3a$var$__exportStar((parcelRequire("tFtXx")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("1gDxA")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("ipLXS")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("1CXDb")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("3cpYB")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("fNvEs")), module.exports);

$7a451577f14e0b3a$var$__exportStar((parcelRequire("8PI5O")), module.exports);

});
parcelRegister("tFtXx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $1gDxA = parcelRequire("1gDxA");

var $ipLXS = parcelRequire("ipLXS");

var $fNvEs = parcelRequire("fNvEs");

var $8PI5O = parcelRequire("8PI5O");
/**
 * Parses JSON-LD contexts.
 */ var $0592e30d4af63dfd$var$ContextParser = /*#__PURE__*/ function() {
    function ContextParser(options) {
        (0, $jGAMp._)(this, ContextParser);
        options = options || {};
        this.documentLoader = options.documentLoader || new $ipLXS.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
    (0, $byiyg._)(ContextParser, [
        {
            /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ key: "idifyReverseTerms",
            value: function idifyReverseTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (value['@reverse'] && !value['@id']) {
                                if (typeof value['@reverse'] !== 'string' || $8PI5O.Util.isValidKeyword(value['@reverse'])) throw new $1gDxA.ErrorCoded("Invalid @reverse value, must be absolute IRI or blank node: '".concat(value['@reverse'], "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                value = context[key] = Object.assign(Object.assign({}, value), {
                                    '@id': value['@reverse']
                                });
                                value['@id'] = value['@reverse'];
                                if ($8PI5O.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                                else value['@reverse'] = true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return context;
            }
        },
        {
            /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ key: "expandPrefixedTerms",
            value: function expandPrefixedTerms(context, expandContentTypeToBase, keys) {
                var contextRaw = context.getContextRaw();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys || Object.keys(contextRaw))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Only expand allowed keys
                        if ($8PI5O.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$8PI5O.Util.isReservedInternalKeyword(key)) {
                            // Error if we try to alias a keyword to something else.
                            var keyValue = contextRaw[key];
                            if ($8PI5O.Util.isPotentialKeyword(key) && $8PI5O.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                                if (key !== '@type' || (0, $3KZcf._)(contextRaw[key]) === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $1gDxA.ErrorCoded("Keywords can not be aliased to something else.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $1gDxA.ERROR_CODES.KEYWORD_REDEFINITION);
                            }
                            // Error if we try to alias to an illegal keyword
                            if ($8PI5O.Util.ALIAS_RANGE_BLACKLIST.indexOf($8PI5O.Util.getContextValueId(keyValue)) >= 0) throw new $1gDxA.ErrorCoded("Aliasing to certain keywords is not allowed.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $1gDxA.ERROR_CODES.INVALID_KEYWORD_ALIAS);
                            // Error if this term was marked as prefix as well
                            if (keyValue && $8PI5O.Util.isPotentialKeyword($8PI5O.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $1gDxA.ErrorCoded("Tried to use keyword aliases as prefix: '".concat(key, "': '").concat(JSON.stringify(keyValue), "'"), $1gDxA.ERROR_CODES.INVALID_TERM_DEFINITION);
                            // Loop because prefixes might be nested
                            while($8PI5O.Util.isPrefixValue(contextRaw[key])){
                                var value = contextRaw[key];
                                var changed = false;
                                if (typeof value === 'string') {
                                    contextRaw[key] = context.expandTerm(value, true);
                                    changed = changed || value !== contextRaw[key];
                                } else {
                                    var id = value['@id'];
                                    var type = value['@type'];
                                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                                    var canAddIdEntry = !('@prefix' in value) || $8PI5O.Util.isValidIri(key);
                                    if ('@id' in value) // Use @id value for expansion
                                    {
                                        if (id !== undefined && id !== null && typeof id === 'string') {
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': context.expandTerm(id, true)
                                            });
                                            changed = changed || id !== contextRaw[key]['@id'];
                                        }
                                    } else if (!$8PI5O.Util.isPotentialKeyword(key) && canAddIdEntry) {
                                        // Add an explicit @id value based on the expanded key value
                                        var newId = context.expandTerm(key, true);
                                        if (newId !== key) {
                                            // Don't set @id if expansion failed
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': newId
                                            });
                                            changed = true;
                                        }
                                    }
                                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                                        // First check @vocab, then fallback to @base
                                        var expandedType = context.expandTerm(type, true);
                                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                                        if (expandedType !== type) {
                                            changed = true;
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@type': expandedType
                                            });
                                        }
                                    }
                                }
                                if (!changed) break;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ key: "normalize",
            value: function normalize(context, param) {
                var processingMode = param.processingMode, normalizeLanguageTags = param.normalizeLanguageTags;
                // Lowercase language keys in 1.0
                if (normalizeLanguageTags || processingMode === 1.0) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
                            else {
                                var value = context[key];
                                if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                    if (typeof value['@language'] === 'string') {
                                        var lowercase = value['@language'].toLowerCase();
                                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                                            '@language': lowercase
                                        });
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ key: "containersToHash",
            value: function containersToHash(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                                '@container': (0, $cqEAj._)({}, value['@container'], true)
                            });
                            else if (Array.isArray(value['@container'])) {
                                var newValue = {};
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = value['@container'][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var containerValue = _step1.value;
                                        newValue[containerValue] = true;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                context[key] = Object.assign(Object.assign({}, value), {
                                    '@container': newValue
                                });
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ key: "applyScopedProtected",
            value: function applyScopedProtected(context, param, expandOptions) {
                var processingMode = param.processingMode;
                if (processingMode && processingMode >= 1.1) {
                    if (context['@protected']) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var key = _step.value;
                                if ($8PI5O.Util.isReservedInternalKeyword(key)) continue;
                                if (!$8PI5O.Util.isPotentialKeyword(key) && !$8PI5O.Util.isTermProtected(context, key)) {
                                    var value = context[key];
                                    if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                        if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                                        context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@protected': true
                                        });
                                    } else {
                                        // Convert string-based term values to object-based values with @protected: true
                                        context[key] = {
                                            '@id': value,
                                            '@protected': true
                                        };
                                        if ($8PI5O.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@prefix': true
                                        });
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        delete context['@protected'];
                    }
                }
            }
        },
        {
            /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ key: "validateKeywordRedefinitions",
            value: function validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if ($8PI5O.Util.isTermProtected(contextBefore, key)) {
                            // The entry in the context before will always be in object-mode
                            // If the new entry is in string-mode, convert it to object-mode
                            // before checking if it is identical.
                            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                                '@id': contextAfter[key],
                                '@protected': true
                            };
                            else // We modify this deliberately,
                            // as we need it for the value comparison (they must be identical modulo '@protected')),
                            // and for the fact that this new value will override the first one.
                            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                                '@protected': true
                            });
                            // Error if they are not identical
                            if (!$8PI5O.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $1gDxA.ErrorCoded("Attempted to override the protected keyword ".concat(key, " from ").concat(JSON.stringify($8PI5O.Util.getContextValueId(contextBefore[key])), " to ").concat(JSON.stringify($8PI5O.Util.getContextValueId(contextAfter[key]))), $1gDxA.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ key: "validate",
            value: function validate(context, param) {
                var processingMode = param.processingMode;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Ignore reserved internal keywords.
                        if ($8PI5O.Util.isReservedInternalKeyword(key)) continue;
                        // Do not allow empty term
                        if (key === '') throw new $1gDxA.ErrorCoded("The empty term is not allowed, got: '".concat(key, "': '").concat(JSON.stringify(context[key]), "'"), $1gDxA.ERROR_CODES.INVALID_TERM_DEFINITION);
                        var value = context[key];
                        var valueType = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
                        // First check if the key is a keyword
                        if ($8PI5O.Util.isPotentialKeyword(key)) {
                            switch(key.substr(1)){
                                case 'vocab':
                                    if (value !== null && valueType !== 'string') throw new $1gDxA.ErrorCoded("Found an invalid @vocab IRI: ".concat(value), $1gDxA.ERROR_CODES.INVALID_VOCAB_MAPPING);
                                    break;
                                case 'base':
                                    if (value !== null && valueType !== 'string') throw new $1gDxA.ErrorCoded("Found an invalid @base IRI: ".concat(context[key]), $1gDxA.ERROR_CODES.INVALID_BASE_IRI);
                                    break;
                                case 'language':
                                    if (value !== null) ContextParser.validateLanguage(value, true, $1gDxA.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                                    break;
                                case 'version':
                                    if (value !== null && valueType !== 'number') throw new $1gDxA.ErrorCoded("Found an invalid @version number: ".concat(value), $1gDxA.ERROR_CODES.INVALID_VERSION_VALUE);
                                    break;
                                case 'direction':
                                    if (value !== null) ContextParser.validateDirection(value, true);
                                    break;
                                case 'propagate':
                                    if (processingMode === 1.0) throw new $1gDxA.ErrorCoded("Found an illegal @propagate keyword: ".concat(value), $1gDxA.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                    if (value !== null && valueType !== 'boolean') throw new $1gDxA.ErrorCoded("Found an invalid @propagate value: ".concat(value), $1gDxA.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                                    break;
                            }
                            // Don't allow keywords to be overridden
                            if ($8PI5O.Util.isValidKeyword(key) && $8PI5O.Util.isValidKeyword($8PI5O.Util.getContextValueId(value))) throw new $1gDxA.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat($8PI5O.Util.getContextValueId(value), "'"), $1gDxA.ERROR_CODES.KEYWORD_REDEFINITION);
                            continue;
                        }
                        // Otherwise, consider the key a term
                        if (value !== null) switch(valueType){
                            case 'string':
                                if ($8PI5O.Util.getPrefix(value, context) === key) throw new $1gDxA.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                if ($8PI5O.Util.isValidIriWeak(key)) {
                                    if (value === '@type') throw new $1gDxA.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(value, "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($8PI5O.Util.isValidIri(value) && value !== new $fNvEs.JsonLdContextNormalized(context).expandTerm(key)) throw new $1gDxA.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(value, "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                break;
                            case 'object':
                                if (!$8PI5O.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $1gDxA.ErrorCoded("Missing @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Object.keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var objectKey = _step1.value;
                                        var objectValue = value[objectKey];
                                        if (!objectValue) continue;
                                        switch(objectKey){
                                            case '@id':
                                                if ($8PI5O.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $1gDxA.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($8PI5O.Util.isValidIriWeak(key)) {
                                                    if (objectValue === '@type') throw new $1gDxA.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                                    else if ($8PI5O.Util.isValidIri(objectValue) && objectValue !== new $fNvEs.JsonLdContextNormalized(context).expandTerm(key)) throw new $1gDxA.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                                }
                                                if (typeof objectValue !== 'string') throw new $1gDxA.ErrorCoded("Detected non-string @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($8PI5O.Util.getPrefix(objectValue, context) === key) throw new $1gDxA.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                                break;
                                            case '@type':
                                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $1gDxA.ErrorCoded("@container: @type only allows @type: @id or @vocab, but got: '".concat(key, "': '").concat(objectValue, "'"), $1gDxA.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (typeof objectValue !== 'string') throw new $1gDxA.ErrorCoded("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"), $1gDxA.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$8PI5O.Util.isValidIri(objectValue))) throw new $1gDxA.ErrorCoded("A context @type must be an absolute IRI, found: '".concat(key, "': '").concat(objectValue, "'"), $1gDxA.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                break;
                                            case '@reverse':
                                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $1gDxA.ErrorCoded("Found non-matching @id and @reverse term values in '".concat(key, "':'").concat(objectValue, "' and '").concat(value['@id'], "'"), $1gDxA.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                if ('@nest' in value) throw new $1gDxA.ErrorCoded("@nest is not allowed in the reverse property '".concat(key, "'"), $1gDxA.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                break;
                                            case '@container':
                                                if (processingMode === 1.0) {
                                                    if (Object.keys(objectValue).length > 1 || $8PI5O.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $1gDxA.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(Object.keys(objectValue), "') in 1.0, must be only one of ").concat($8PI5O.Util.CONTAINERS_1_0.join(', ')), $1gDxA.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                }
                                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(var _iterator2 = Object.keys(objectValue)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        var containerValue = _step2.value;
                                                        if (containerValue === '@list' && value['@reverse']) throw new $1gDxA.ErrorCoded("Term value can not be @container: @list and @reverse at the same time on '".concat(key, "'"), $1gDxA.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                        if ($8PI5O.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $1gDxA.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(containerValue, "'), must be one of ").concat($8PI5O.Util.CONTAINERS.join(', ')), $1gDxA.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                            _iterator2["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                                break;
                                            case '@language':
                                                ContextParser.validateLanguage(objectValue, true, $1gDxA.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                                break;
                                            case '@direction':
                                                ContextParser.validateDirection(objectValue, true);
                                                break;
                                            case '@prefix':
                                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $1gDxA.ErrorCoded("Found an invalid term @prefix boolean in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_PREFIX_VALUE);
                                                if (!('@id' in value) && !$8PI5O.Util.isValidIri(key)) throw new $1gDxA.ErrorCoded("Invalid @prefix definition for '".concat(key, "' ('").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@index':
                                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $1gDxA.ErrorCoded("Attempt to add illegal key to value object: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@nest':
                                                if ($8PI5O.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $1gDxA.ErrorCoded("Found an invalid term @nest value in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_NEST_VALUE);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new $1gDxA.ErrorCoded("Found an invalid term value: '".concat(key, "': '").concat(value, "'"), $1gDxA.ERROR_CODES.INVALID_TERM_DEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ key: "applyBaseEntry",
            value: function applyBaseEntry(context, options, inheritFromParent) {
                // In some special cases, this can be a string, so ignore those.
                if (typeof context === 'string') return context;
                // Give priority to @base in the parent context
                if (inheritFromParent && !('@base' in context) && options.parentContext && (0, $3KZcf._)(options.parentContext) === 'object' && '@base' in options.parentContext) {
                    context['@base'] = options.parentContext['@base'];
                    if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
                }
                // Override the base IRI if provided.
                if (options.baseIRI && !options.external) {
                    if (!('@base' in context)) {
                        // The context base is the document base
                        context['@base'] = options.baseIRI;
                        context['@__baseDocument'] = true;
                    } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$8PI5O.Util.isValidIri(context['@base'])) // The context base is relative to the document base
                    context['@base'] = (0, $hDpjF.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
                }
                return context;
            }
        },
        {
            /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ key: "normalizeContextIri",
            value: function normalizeContextIri(contextIri, baseIRI) {
                if (!$8PI5O.Util.isValidIri(contextIri)) try {
                    contextIri = (0, $hDpjF.resolve)(contextIri, baseIRI);
                } catch (_a) {
                    throw new Error("Invalid context IRI: ".concat(contextIri));
                }
                // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
                if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
                return contextIri;
            }
        },
        {
            key: "parseInnerContexts",
            value: /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ function parseInnerContexts(context, options, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, value, parentContext, e, _, _tmp, _tmp1, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    11,
                                    12
                                ]);
                                _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(context))[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    9
                                ];
                                key = _step.value;
                                value = context[key];
                                if (!(value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object')) return [
                                    3,
                                    8
                                ];
                                if (!('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts)) return [
                                    3,
                                    8
                                ];
                                if (!this.validateContext) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                parentContext = Object.assign(Object.assign({}, context), (0, $cqEAj._)({}, key, Object.assign({}, context[key])));
                                delete parentContext[key]['@context'];
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        parentContext: parentContext,
                                        ignoreProtection: true,
                                        ignoreRemoteScopedContexts: true,
                                        ignoreScopedContexts: true
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                throw new $1gDxA.ErrorCoded(e.message, $1gDxA.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                            case 6:
                                _ = Object.assign;
                                _tmp = [
                                    Object.assign({}, value)
                                ];
                                _tmp1 = {};
                                _1 = '@context';
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        minimalProcessing: true,
                                        ignoreRemoteScopedContexts: true,
                                        parentContext: context
                                    }))
                                ];
                            case 7:
                                context[key] = _.apply(Object, _tmp.concat([
                                    (_tmp1[_1] = _state.sent().getContextRaw(), _tmp1)
                                ]));
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    context
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parse",
            value: function parse(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(context) {
                    var _this, options, // These options are only for internal use on recursive calls and should not be used by
                    // libraries consuming this function
                    internalOptions, baseIRI, parentContext, external, _options_processingMode, processingMode, normalizeLanguageTags, ignoreProtection, minimalProcessing, remoteContexts, contextIri, overriddenLoad, parsedStringContext, _, _1, contextIris, contexts, reducedContexts, importContext, newContext, keys, overlappingKeys, key, newContextWrapped;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, internalOptions = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                                baseIRI = options.baseIRI, parentContext = options.parentContext, external = options.external, _options_processingMode = options.processingMode, processingMode = _options_processingMode === void 0 ? ContextParser.DEFAULT_PROCESSING_MODE : _options_processingMode, normalizeLanguageTags = options.normalizeLanguageTags, ignoreProtection = options.ignoreProtection, minimalProcessing = options.minimalProcessing;
                                remoteContexts = options.remoteContexts || {};
                                // Avoid remote context overflows
                                if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $1gDxA.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $1gDxA.ERROR_CODES.CONTEXT_OVERFLOW);
                                if (!(context === null || context === undefined)) return [
                                    3,
                                    1
                                ];
                                // Don't allow context nullification and there are protected terms
                                if (!ignoreProtection && parentContext && $8PI5O.Util.hasProtectedTerms(parentContext)) throw new $1gDxA.ErrorCoded('Illegal context nullification when terms are protected', $1gDxA.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
                                // Context that are explicitly set to null are empty.
                                return [
                                    2,
                                    new $fNvEs.JsonLdContextNormalized(this.applyBaseEntry({}, options, false))
                                ];
                            case 1:
                                if (!(typeof context === 'string')) return [
                                    3,
                                    4
                                ];
                                contextIri = this.normalizeContextIri(context, baseIRI);
                                overriddenLoad = this.getOverriddenLoad(contextIri, options);
                                if (overriddenLoad) return [
                                    2,
                                    new $fNvEs.JsonLdContextNormalized(overriddenLoad)
                                ];
                                _1 = (_ = this).parse;
                                return [
                                    4,
                                    this.load(contextIri)
                                ];
                            case 2:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent(),
                                        Object.assign(Object.assign({}, options), {
                                            baseIRI: contextIri,
                                            external: true,
                                            remoteContexts: Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIri, true))
                                        })
                                    ])
                                ];
                            case 3:
                                parsedStringContext = _state.sent();
                                this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
                                return [
                                    2,
                                    parsedStringContext
                                ];
                            case 4:
                                if (!Array.isArray(context)) return [
                                    3,
                                    7
                                ];
                                // As a performance consideration, first load all external contexts in parallel.
                                contextIris = [];
                                return [
                                    4,
                                    Promise.all(context.map(function(subContext, i) {
                                        if (typeof subContext === 'string') {
                                            var contextIri = _this.normalizeContextIri(subContext, baseIRI);
                                            contextIris[i] = contextIri;
                                            var overriddenLoad = _this.getOverriddenLoad(contextIri, options);
                                            if (overriddenLoad) return overriddenLoad;
                                            return _this.load(contextIri);
                                        } else return subContext;
                                    }))
                                ];
                            case 5:
                                contexts = _state.sent();
                                // Don't apply inheritance logic on minimal processing
                                if (minimalProcessing) return [
                                    2,
                                    new $fNvEs.JsonLdContextNormalized(contexts)
                                ];
                                return [
                                    4,
                                    contexts.reduce(function(accContextPromise, contextEntry, i) {
                                        return accContextPromise.then(function(accContext) {
                                            return _this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                                                baseIRI: contextIris[i] || options.baseIRI,
                                                external: !!contextIris[i] || options.external,
                                                parentContext: accContext.getContextRaw(),
                                                remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIris[i], true)) : remoteContexts
                                            }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                                            {
                                                skipValidation: i < contexts.length - 1
                                            });
                                        });
                                    }, Promise.resolve(new $fNvEs.JsonLdContextNormalized(parentContext || {})))
                                ];
                            case 6:
                                reducedContexts = _state.sent();
                                // Override the base IRI if provided.
                                this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
                                return [
                                    2,
                                    reducedContexts
                                ];
                            case 7:
                                if (!((typeof context === "undefined" ? "undefined" : (0, $3KZcf._)(context)) === 'object')) return [
                                    3,
                                    14
                                ];
                                if (!('@context' in context)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.parse(context['@context'], options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                // Make a deep clone of the given context, to avoid modifying it.
                                context = Object.assign({}, context);
                                // According to the JSON-LD spec, @base must be ignored from external contexts.
                                if (external) delete context['@base'];
                                // Override the base IRI if provided.
                                this.applyBaseEntry(context, options, true);
                                // Hashify container entries
                                // Do this before protected term validation as that influences term format
                                this.containersToHash(context);
                                // Don't perform any other modifications if only minimal processing is needed.
                                if (minimalProcessing) return [
                                    2,
                                    new $fNvEs.JsonLdContextNormalized(context)
                                ];
                                // In JSON-LD 1.1, load @import'ed context prior to processing.
                                importContext = {};
                                if (!('@import' in context)) return [
                                    3,
                                    12
                                ];
                                if (!(processingMode >= 1.1)) return [
                                    3,
                                    11
                                ];
                                // Only accept string values
                                if (typeof context['@import'] !== 'string') throw new $1gDxA.ErrorCoded('An @import value must be a string, but got ' + (0, $3KZcf._)(context['@import']), $1gDxA.ERROR_CODES.INVALID_IMPORT_VALUE);
                                return [
                                    4,
                                    this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI))
                                ];
                            case 10:
                                // Load context
                                importContext = _state.sent();
                                delete context['@import'];
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                throw new $1gDxA.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $1gDxA.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                            case 12:
                                this.applyScopedProtected(importContext, {
                                    processingMode: processingMode
                                }, $fNvEs.defaultExpandOptions);
                                newContext = Object.assign(importContext, context);
                                // Handle terms (before protection checks)
                                this.idifyReverseTerms(newContext);
                                this.normalize(newContext, {
                                    processingMode: processingMode,
                                    normalizeLanguageTags: normalizeLanguageTags
                                });
                                this.applyScopedProtected(newContext, {
                                    processingMode: processingMode
                                }, $fNvEs.defaultExpandOptions);
                                keys = Object.keys(newContext);
                                overlappingKeys = [];
                                if ((typeof parentContext === "undefined" ? "undefined" : (0, $3KZcf._)(parentContext)) === 'object') {
                                    // Merge different parts of the final context in order
                                    for(var key in parentContext)if (key in newContext) overlappingKeys.push(key);
                                    else newContext[key] = parentContext[key];
                                }
                                // Parse inner contexts with minimal processing
                                return [
                                    4,
                                    this.parseInnerContexts(newContext, options, keys)
                                ];
                            case 13:
                                _state.sent();
                                newContextWrapped = new $fNvEs.JsonLdContextNormalized(newContext);
                                // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
                                if ((newContext && newContext['@version'] || ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                                    if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                                    else if ($8PI5O.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                                    newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
                                }
                                this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
                                // In JSON-LD 1.1, check if we are not redefining any protected keywords
                                if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $fNvEs.defaultExpandOptions, overlappingKeys);
                                if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                                    processingMode: processingMode
                                });
                                return [
                                    2,
                                    newContextWrapped
                                ];
                            case 14:
                                throw new $1gDxA.ErrorCoded("Tried parsing a context that is not a string, array or object, but got ".concat(context), $1gDxA.ERROR_CODES.INVALID_LOCAL_CONTEXT);
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "load",
            value: /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cached, document, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // First try to retrieve the context from cache
                                cached = this.documentCache[url];
                                if (cached) return [
                                    2,
                                    cached
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.documentLoader.load(url)
                                ];
                            case 2:
                                document = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                throw new $1gDxA.ErrorCoded("Failed to load remote context ".concat(url, ": ").concat(e.message), $1gDxA.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
                            case 4:
                                // Validate the context
                                if (!('@context' in document)) throw new $1gDxA.ErrorCoded("Missing @context in remote context at ".concat(url), $1gDxA.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                return [
                                    2,
                                    this.documentCache[url] = document['@context']
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ key: "getOverriddenLoad",
            value: function getOverriddenLoad(url, options) {
                if (url in (options.remoteContexts || {})) {
                    if (options.ignoreRemoteScopedContexts) return url;
                    else throw new $1gDxA.ErrorCoded('Detected a cyclic context inclusion of ' + url, $1gDxA.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
                }
                return null;
            }
        },
        {
            key: "loadImportContext",
            value: /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ function loadImportContext(importContextIri) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var importContext;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.load(importContextIri)
                                ];
                            case 1:
                                importContext = _state.sent();
                                // Require the context to be a non-array object
                                if ((typeof importContext === "undefined" ? "undefined" : (0, $3KZcf._)(importContext)) !== 'object' || Array.isArray(importContext)) throw new $1gDxA.ErrorCoded('An imported context must be a single object: ' + importContextIri, $1gDxA.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                // Error if the context contains another @import
                                if ('@import' in importContext) throw new $1gDxA.ErrorCoded('An imported context can not import another context: ' + importContextIri, $1gDxA.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                importContext = Object.assign({}, importContext);
                                // Containers have to be converted into hash values the same way as for the importing context
                                // Otherwise context validation will fail for container values
                                this.containersToHash(importContext);
                                return [
                                    2,
                                    importContext
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "validateLanguage",
            value: /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateLanguage(value, strictRange, errorCode) {
                if (typeof value !== 'string') throw new $1gDxA.ErrorCoded("The value of an '@language' must be a string, got '".concat(JSON.stringify(value), "'"), errorCode);
                if (!$8PI5O.Util.REGEX_LANGUAGE_TAG.test(value)) {
                    if (strictRange) throw new $1gDxA.ErrorCoded("The value of an '@language' must be a valid language tag, got '".concat(JSON.stringify(value), "'"), errorCode);
                    else return false;
                }
                return true;
            }
        },
        {
            key: "validateDirection",
            value: /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateDirection(value, strictValues) {
                if (typeof value !== 'string') throw new $1gDxA.ErrorCoded("The value of an '@direction' must be a string, got '".concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_BASE_DIRECTION);
                if (!$8PI5O.Util.REGEX_DIRECTION_TAG.test(value)) {
                    if (strictValues) throw new $1gDxA.ErrorCoded("The value of an '@direction' must be 'ltr' or 'rtl', got '".concat(JSON.stringify(value), "'"), $1gDxA.ERROR_CODES.INVALID_BASE_DIRECTION);
                    else return false;
                }
                return true;
            }
        }
    ]);
    return ContextParser;
}();
$0592e30d4af63dfd$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $0592e30d4af63dfd$var$ContextParser;

});
parcelRegister("1gDxA", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ var $0ec5f5073cba8884$var$ErrorCoded = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ErrorCoded, Error1);
    function ErrorCoded(message, code) {
        (0, $jGAMp._)(this, ErrorCoded);
        var _this;
        _this = (0, $kzDuW._)(this, ErrorCoded, [
            message
        ]);
        _this.code = code;
        return _this;
    }
    return ErrorCoded;
}((0, $8AW3P._)(Error));
module.exports.ErrorCoded = $0ec5f5073cba8884$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $0ec5f5073cba8884$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($0ec5f5073cba8884$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("ipLXS", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $1gDxA = parcelRequire("1gDxA");

var $fdIar = parcelRequire("fdIar");

var $hDpjF = parcelRequire("hDpjF");
/**
 * Loads documents via the fetch API.
 */ var $d67fc49aa801b146$var$FetchDocumentLoader = /*#__PURE__*/ function() {
    function FetchDocumentLoader(fetcher) {
        (0, $jGAMp._)(this, FetchDocumentLoader);
        this.fetcher = fetcher;
    }
    (0, $byiyg._)(FetchDocumentLoader, [
        {
            key: "load",
            value: function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var response, mediaType, colonPos, alternateUrl;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (this.fetcher || fetch)(url, {
                                        headers: new Headers({
                                            accept: 'application/ld+json'
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!(response.ok && response.headers)) return [
                                    3,
                                    5
                                ];
                                mediaType = response.headers.get('Content-Type');
                                if (mediaType) {
                                    colonPos = mediaType.indexOf(';');
                                    if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
                                }
                                if (!(mediaType === 'application/ld+json')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                // Return JSON-LD if proper content type was returned
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                // Check for alternate link for a non-JSON-LD response
                                if (response.headers.has('Link')) {
                                    ;
                                    response.headers.forEach(function(value, key) {
                                        if (key === 'link') {
                                            var linkHeader = (0, $fdIar.parse)(value);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = linkHeader.get('type', 'application/ld+json')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var link = _step.value;
                                                    if (link.rel === 'alternate') {
                                                        if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                                        alternateUrl = (0, $hDpjF.resolve)(link.uri, url);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                    if (alternateUrl) return [
                                        2,
                                        this.load(alternateUrl)
                                    ];
                                }
                                throw new $1gDxA.ErrorCoded("Unsupported JSON-LD media type ".concat(mediaType), $1gDxA.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error(response.statusText || "Status code: ".concat(response.status));
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return FetchDocumentLoader;
}();
module.exports.FetchDocumentLoader = $d67fc49aa801b146$var$FetchDocumentLoader;

});

parcelRegister("fNvEs", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $1gDxA = parcelRequire("1gDxA");

var $8PI5O = parcelRequire("8PI5O");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ var $b803fbf2a12d4ee6$var$JsonLdContextNormalized = /*#__PURE__*/ function() {
    function JsonLdContextNormalized(contextRaw) {
        (0, $jGAMp._)(this, JsonLdContextNormalized);
        this.contextRaw = contextRaw;
    }
    (0, $byiyg._)(JsonLdContextNormalized, [
        {
            /**
     * @return The raw inner context.
     */ key: "getContextRaw",
            value: function getContextRaw() {
                return this.contextRaw;
            }
        },
        {
            /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ key: "expandTerm",
            value: function expandTerm(term, expandVocab) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultExpandOptions;
                var contextValue = this.contextRaw[term];
                // Immediately return if the term was disabled in the context
                if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
                // Check the @id
                var validIriMapping = true;
                if (contextValue && expandVocab) {
                    var value = $8PI5O.Util.getContextValueId(contextValue);
                    if (value && value !== term) {
                        if (typeof value !== 'string' || !$8PI5O.Util.isValidIri(value) && !$8PI5O.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                        {
                            if (!$8PI5O.Util.isPotentialKeyword(value)) validIriMapping = false;
                        } else return value;
                    }
                }
                // Check if the term is prefixed
                var prefix = $8PI5O.Util.getPrefix(term, this.contextRaw);
                var vocab = this.contextRaw['@vocab'];
                var vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
                var base = this.contextRaw['@base'];
                var potentialKeyword = $8PI5O.Util.isPotentialKeyword(term);
                if (prefix) {
                    var contextPrefixValue = this.contextRaw[prefix];
                    var value1 = $8PI5O.Util.getContextValueId(contextPrefixValue);
                    if (value1) {
                        if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                            // If we have a simple term definition,
                            // check the last character of the prefix to determine whether or not it is a prefix.
                            // Validate that prefix ends with gen-delim character, unless @prefix is true
                            if (!$8PI5O.Util.isSimpleTermDefinitionPrefix(value1, options)) // Treat the term as an absolute IRI
                            return term;
                        } else {
                            // If we have an expanded term definition, default to @prefix: false
                            if (value1[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                            return term;
                        }
                        return value1 + term.substr(prefix.length + 1);
                    }
                } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$8PI5O.Util.isCompactIri(term)) {
                    if (vocabRelative) {
                        if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $hDpjF.resolve)(vocab, base) : '') + term;
                        else throw new $1gDxA.ErrorCoded("Relative vocab expansion for term '".concat(term, "' with vocab '").concat(vocab, "' is not allowed."), $1gDxA.ERROR_CODES.INVALID_VOCAB_MAPPING);
                    } else return vocab + term;
                } else if (!expandVocab && base && !potentialKeyword && !$8PI5O.Util.isCompactIri(term)) return (0, $hDpjF.resolve)(term, base);
                // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
                if (validIriMapping) return term;
                else throw new $1gDxA.ErrorCoded("Invalid IRI mapping found for context entry '".concat(term, "': '").concat(JSON.stringify(contextValue), "'"), $1gDxA.ERROR_CODES.INVALID_IRI_MAPPING);
            }
        },
        {
            /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ key: "compactIri",
            value: function compactIri(iri, vocab) {
                // Try @vocab compacting
                if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
                // Try @base compacting
                if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
                // Loop over all terms in the context
                // This will try to prefix as short as possible.
                // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
                var shortestPrefixing = {
                    prefix: '',
                    suffix: iri
                };
                for(var key in this.contextRaw){
                    var value = this.contextRaw[key];
                    if (value && !$8PI5O.Util.isPotentialKeyword(key)) {
                        var contextIri = $8PI5O.Util.getContextValueId(value);
                        if (iri.startsWith(contextIri)) {
                            var suffix = iri.substr(contextIri.length);
                            if (!suffix) {
                                if (vocab) // Immediately return on compacted alias
                                return key;
                            } else if (suffix.length < shortestPrefixing.suffix.length) {
                                // Overwrite the shortest prefix
                                shortestPrefixing.prefix = key;
                                shortestPrefixing.suffix = suffix;
                            }
                        }
                    }
                }
                // Return the shortest prefix
                if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
                return iri;
            }
        }
    ]);
    return JsonLdContextNormalized;
}();
module.exports.JsonLdContextNormalized = $b803fbf2a12d4ee6$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("8PI5O", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
var $66e54a079420667c$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "isCompactIri",
            value: /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ function isCompactIri(term) {
                return term.indexOf(':') > 0 && !(term && term[0] === '#');
            }
        },
        {
            key: "getPrefix",
            value: /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ function getPrefix(term, context) {
                // Do not consider relative IRIs starting with a hash as compact IRIs
                if (term && term[0] === '#') return null;
                var separatorPos = term.indexOf(':');
                if (separatorPos >= 0) {
                    // Suffix can not begin with two slashes
                    if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
                    var prefix = term.substr(0, separatorPos);
                    // Prefix can not be an underscore (this is a blank node)
                    if (prefix === '_') return null;
                    // Prefix must match a term in the active context
                    if (context[prefix]) return prefix;
                }
                return null;
            }
        },
        {
            key: "getContextValueId",
            value: /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ function getContextValueId(contextValue) {
                if (contextValue === null || typeof contextValue === 'string') return contextValue;
                var id = contextValue['@id'];
                return id ? id : null;
            }
        },
        {
            key: "isSimpleTermDefinitionPrefix",
            value: /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ function isSimpleTermDefinitionPrefix(value, options) {
                return !Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || Util.isPrefixIriEndingWithGenDelim(value)));
            }
        },
        {
            key: "isPotentialKeyword",
            value: /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ function isPotentialKeyword(keyword) {
                return typeof keyword === 'string' && Util.KEYWORD_REGEX.test(keyword);
            }
        },
        {
            key: "isPrefixIriEndingWithGenDelim",
            value: /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ function isPrefixIriEndingWithGenDelim(prefixIri) {
                return Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
            }
        },
        {
            key: "isPrefixValue",
            value: /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ function isPrefixValue(value) {
                return value && (typeof value === 'string' || value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object');
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Boolean(iri && Util.IRI_REGEX.test(iri));
            }
        },
        {
            key: "isValidIriWeak",
            value: /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIriWeak(iri) {
                return !!iri && iri[0] !== ':' && Util.IRI_REGEX_WEAK.test(iri);
            }
        },
        {
            key: "isValidKeyword",
            value: /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ function isValidKeyword(keyword) {
                return Util.VALID_KEYWORDS[keyword];
            }
        },
        {
            key: "isTermProtected",
            value: /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ function isTermProtected(context, key) {
                var value = context[key];
                return !(typeof value === 'string') && value && value['@protected'];
            }
        },
        {
            key: "hasProtectedTerms",
            value: /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ function hasProtectedTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (Util.isTermProtected(context, key)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isReservedInternalKeyword",
            value: /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ function isReservedInternalKeyword(key) {
                return key.startsWith('@__');
            }
        },
        {
            key: "deepEqual",
            value: /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ function deepEqual(object1, object2) {
                var _this = this;
                var objKeys1 = Object.keys(object1);
                var objKeys2 = Object.keys(object2);
                if (objKeys1.length !== objKeys2.length) return false;
                return objKeys1.every(function(key) {
                    var value1 = object1[key];
                    var value2 = object2[key];
                    return value1 === value2 || value1 !== null && value2 !== null && (typeof value1 === "undefined" ? "undefined" : (0, $3KZcf._)(value1)) === "object" && (typeof value2 === "undefined" ? "undefined" : (0, $3KZcf._)(value2)) === "object" && _this.deepEqual(value1, value2);
                });
            }
        }
    ]);
    return Util;
}();
// Regex for valid IRIs
$66e54a079420667c$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$66e54a079420667c$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$66e54a079420667c$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$66e54a079420667c$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$66e54a079420667c$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$66e54a079420667c$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$66e54a079420667c$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$66e54a079420667c$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$66e54a079420667c$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$66e54a079420667c$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$66e54a079420667c$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$66e54a079420667c$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $66e54a079420667c$var$Util;

});



parcelRegister("1CXDb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3cpYB", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("gwoF0", function(module, exports) {
'use strict';

var $5gfuN = parcelRequire("5gfuN");

var $5U9yC = parcelRequire("5U9yC");
var $c072c38820eeb4a7$var$originalDestroy = $5gfuN.Readable.destroy;
module.exports = $5gfuN.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5gfuN._uint8ArrayToBuffer;
module.exports._isUint8Array = $5gfuN._isUint8Array;
module.exports.isDisturbed = $5gfuN.isDisturbed;
module.exports.isErrored = $5gfuN.isErrored;
module.exports.isReadable = $5gfuN.isReadable;
module.exports.Readable = $5gfuN.Readable;
module.exports.Writable = $5gfuN.Writable;
module.exports.Duplex = $5gfuN.Duplex;
module.exports.Transform = $5gfuN.Transform;
module.exports.PassThrough = $5gfuN.PassThrough;
module.exports.addAbortSignal = $5gfuN.addAbortSignal;
module.exports.finished = $5gfuN.finished;
module.exports.destroy = $5gfuN.destroy;
module.exports.destroy = $c072c38820eeb4a7$var$originalDestroy;
module.exports.pipeline = $5gfuN.pipeline;
module.exports.compose = $5gfuN.compose;
Object.defineProperty($5gfuN, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $5U9yC;
    }
});
module.exports.Stream = $5gfuN.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("5gfuN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $cD2dd = parcelRequire("cD2dd");
var $3d4a777f6b2263d1$require$Buffer = $cD2dd.Buffer;

var $a9uB3 = parcelRequire("a9uB3");
/* replacement end */ var $3d4a777f6b2263d1$var$ObjectDefineProperty = $a9uB3.ObjectDefineProperty, $3d4a777f6b2263d1$var$ObjectKeys = $a9uB3.ObjectKeys, $3d4a777f6b2263d1$var$ReflectApply = $a9uB3.ReflectApply;

var $dYwD5 = parcelRequire("dYwD5");
var $3d4a777f6b2263d1$var$_require_promisify = $dYwD5.promisify, $3d4a777f6b2263d1$var$customPromisify = $3d4a777f6b2263d1$var$_require_promisify.custom;

var $eS49T = parcelRequire("eS49T");
var $3d4a777f6b2263d1$var$streamReturningOperators = $eS49T.streamReturningOperators, $3d4a777f6b2263d1$var$promiseReturningOperators = $eS49T.promiseReturningOperators;

var $VLMLy = parcelRequire("VLMLy");
var $3d4a777f6b2263d1$var$ERR_ILLEGAL_CONSTRUCTOR = $VLMLy.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $jWf80 = parcelRequire("jWf80");

var $cSeDy = parcelRequire("cSeDy");
var $3d4a777f6b2263d1$var$setDefaultHighWaterMark = $cSeDy.setDefaultHighWaterMark, $3d4a777f6b2263d1$var$getDefaultHighWaterMark = $cSeDy.getDefaultHighWaterMark;

var $7SXXk = parcelRequire("7SXXk");
var $3d4a777f6b2263d1$require$pipeline = $7SXXk.pipeline;

var $krXgd = parcelRequire("krXgd");
var $3d4a777f6b2263d1$require$destroyer = $krXgd.destroyer;

var $4BKIq = parcelRequire("4BKIq");
var $3d4a777f6b2263d1$var$internalBuffer = {};

var $5U9yC = parcelRequire("5U9yC");

var $31UQg = parcelRequire("31UQg");

var $3d4a777f6b2263d1$var$Stream = module.exports = (parcelRequire("j71El")).Stream;
$3d4a777f6b2263d1$var$Stream.isDestroyed = $31UQg.isDestroyed;
$3d4a777f6b2263d1$var$Stream.isDisturbed = $31UQg.isDisturbed;
$3d4a777f6b2263d1$var$Stream.isErrored = $31UQg.isErrored;
$3d4a777f6b2263d1$var$Stream.isReadable = $31UQg.isReadable;
$3d4a777f6b2263d1$var$Stream.isWritable = $31UQg.isWritable;

$3d4a777f6b2263d1$var$Stream.Readable = (parcelRequire("9ebsS"));
var $3d4a777f6b2263d1$var$_iteratorNormalCompletion = true, $3d4a777f6b2263d1$var$_didIteratorError = false, $3d4a777f6b2263d1$var$_iteratorError = undefined;
try {
    for(var $3d4a777f6b2263d1$var$_iterator = $3d4a777f6b2263d1$var$ObjectKeys($3d4a777f6b2263d1$var$streamReturningOperators)[Symbol.iterator](), $3d4a777f6b2263d1$var$_step; !($3d4a777f6b2263d1$var$_iteratorNormalCompletion = ($3d4a777f6b2263d1$var$_step = $3d4a777f6b2263d1$var$_iterator.next()).done); $3d4a777f6b2263d1$var$_iteratorNormalCompletion = true){
        var $3d4a777f6b2263d1$var$key = $3d4a777f6b2263d1$var$_step.value;
        var $3d4a777f6b2263d1$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $3d4a777f6b2263d1$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3d4a777f6b2263d1$var$Stream.Readable.from($3d4a777f6b2263d1$var$ReflectApply($3d4a777f6b2263d1$var$op, this, args));
        };
        var $3d4a777f6b2263d1$var$op = $3d4a777f6b2263d1$var$streamReturningOperators[$3d4a777f6b2263d1$var$key];
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$fn, 'name', {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$op.name
        });
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$fn, 'length', {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$op.length
        });
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$Stream.Readable.prototype, $3d4a777f6b2263d1$var$key, {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3d4a777f6b2263d1$var$_didIteratorError = true;
    $3d4a777f6b2263d1$var$_iteratorError = err;
} finally{
    try {
        if (!$3d4a777f6b2263d1$var$_iteratorNormalCompletion && $3d4a777f6b2263d1$var$_iterator["return"] != null) {
            $3d4a777f6b2263d1$var$_iterator["return"]();
        }
    } finally{
        if ($3d4a777f6b2263d1$var$_didIteratorError) {
            throw $3d4a777f6b2263d1$var$_iteratorError;
        }
    }
}
var $3d4a777f6b2263d1$var$_iteratorNormalCompletion1 = true, $3d4a777f6b2263d1$var$_didIteratorError1 = false, $3d4a777f6b2263d1$var$_iteratorError1 = undefined;
try {
    for(var $3d4a777f6b2263d1$var$_iterator1 = $3d4a777f6b2263d1$var$ObjectKeys($3d4a777f6b2263d1$var$promiseReturningOperators)[Symbol.iterator](), $3d4a777f6b2263d1$var$_step1; !($3d4a777f6b2263d1$var$_iteratorNormalCompletion1 = ($3d4a777f6b2263d1$var$_step1 = $3d4a777f6b2263d1$var$_iterator1.next()).done); $3d4a777f6b2263d1$var$_iteratorNormalCompletion1 = true){
        var $3d4a777f6b2263d1$var$key1 = $3d4a777f6b2263d1$var$_step1.value;
        var $3d4a777f6b2263d1$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $3d4a777f6b2263d1$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $3d4a777f6b2263d1$var$ReflectApply($3d4a777f6b2263d1$var$op1, this, args);
        };
        var $3d4a777f6b2263d1$var$op1 = $3d4a777f6b2263d1$var$promiseReturningOperators[$3d4a777f6b2263d1$var$key1];
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$fn1, 'name', {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$op1.name
        });
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$fn1, 'length', {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$op1.length
        });
        $3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$Stream.Readable.prototype, $3d4a777f6b2263d1$var$key1, {
            __proto__: null,
            value: $3d4a777f6b2263d1$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $3d4a777f6b2263d1$var$_didIteratorError1 = true;
    $3d4a777f6b2263d1$var$_iteratorError1 = err;
} finally{
    try {
        if (!$3d4a777f6b2263d1$var$_iteratorNormalCompletion1 && $3d4a777f6b2263d1$var$_iterator1["return"] != null) {
            $3d4a777f6b2263d1$var$_iterator1["return"]();
        }
    } finally{
        if ($3d4a777f6b2263d1$var$_didIteratorError1) {
            throw $3d4a777f6b2263d1$var$_iteratorError1;
        }
    }
}

$3d4a777f6b2263d1$var$Stream.Writable = (parcelRequire("9LaP5"));

$3d4a777f6b2263d1$var$Stream.Duplex = (parcelRequire("hyHPp"));

$3d4a777f6b2263d1$var$Stream.Transform = (parcelRequire("kIaoS"));

$3d4a777f6b2263d1$var$Stream.PassThrough = (parcelRequire("d054b"));
$3d4a777f6b2263d1$var$Stream.pipeline = $3d4a777f6b2263d1$require$pipeline;

var $7yGpj = parcelRequire("7yGpj");
var $3d4a777f6b2263d1$require$addAbortSignal = $7yGpj.addAbortSignal;
$3d4a777f6b2263d1$var$Stream.addAbortSignal = $3d4a777f6b2263d1$require$addAbortSignal;
$3d4a777f6b2263d1$var$Stream.finished = $4BKIq;
$3d4a777f6b2263d1$var$Stream.destroy = $3d4a777f6b2263d1$require$destroyer;
$3d4a777f6b2263d1$var$Stream.compose = $jWf80;
$3d4a777f6b2263d1$var$Stream.setDefaultHighWaterMark = $3d4a777f6b2263d1$var$setDefaultHighWaterMark;
$3d4a777f6b2263d1$var$Stream.getDefaultHighWaterMark = $3d4a777f6b2263d1$var$getDefaultHighWaterMark;
$3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $5U9yC;
    }
});
$3d4a777f6b2263d1$var$ObjectDefineProperty($3d4a777f6b2263d1$require$pipeline, $3d4a777f6b2263d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5U9yC.pipeline;
    }
});
$3d4a777f6b2263d1$var$ObjectDefineProperty($4BKIq, $3d4a777f6b2263d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5U9yC.finished;
    }
});
// Backwards-compat with node 0.4.x
$3d4a777f6b2263d1$var$Stream.Stream = $3d4a777f6b2263d1$var$Stream;
$3d4a777f6b2263d1$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$3d4a777f6b2263d1$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $3d4a777f6b2263d1$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("cD2dd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $931ad7dab8bda2f6$export$a143d493d941bafc; }, function (v) { return $931ad7dab8bda2f6$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $931ad7dab8bda2f6$export$f99ded8fe4b79145; }, function (v) { return $931ad7dab8bda2f6$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $931ad7dab8bda2f6$export$a143d493d941bafc;
var $931ad7dab8bda2f6$export$e4cf37d7f6fb9e0a;
var $931ad7dab8bda2f6$export$f99ded8fe4b79145;
var $931ad7dab8bda2f6$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $931ad7dab8bda2f6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$931ad7dab8bda2f6$export$a143d493d941bafc = $931ad7dab8bda2f6$var$Buffer;
$931ad7dab8bda2f6$export$e4cf37d7f6fb9e0a = $931ad7dab8bda2f6$var$SlowBuffer;
$931ad7dab8bda2f6$export$f99ded8fe4b79145 = 50;
var $931ad7dab8bda2f6$var$K_MAX_LENGTH = 0x7fffffff;
$931ad7dab8bda2f6$export$599f31c3813fae4d = $931ad7dab8bda2f6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $931ad7dab8bda2f6$var$Buffer.TYPED_ARRAY_SUPPORT = $931ad7dab8bda2f6$var$typedArraySupport();
if (!$931ad7dab8bda2f6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $931ad7dab8bda2f6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($931ad7dab8bda2f6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($931ad7dab8bda2f6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $931ad7dab8bda2f6$var$createBuffer(length) {
    if (length > $931ad7dab8bda2f6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $931ad7dab8bda2f6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $931ad7dab8bda2f6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $931ad7dab8bda2f6$var$allocUnsafe(arg);
    }
    return $931ad7dab8bda2f6$var$from(arg, encodingOrOffset, length);
}
$931ad7dab8bda2f6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $931ad7dab8bda2f6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $931ad7dab8bda2f6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $931ad7dab8bda2f6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($931ad7dab8bda2f6$var$isInstance(value, ArrayBuffer) || value && $931ad7dab8bda2f6$var$isInstance(value.buffer, ArrayBuffer)) return $931ad7dab8bda2f6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($931ad7dab8bda2f6$var$isInstance(value, SharedArrayBuffer) || value && $931ad7dab8bda2f6$var$isInstance(value.buffer, SharedArrayBuffer))) return $931ad7dab8bda2f6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $931ad7dab8bda2f6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $931ad7dab8bda2f6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $931ad7dab8bda2f6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $931ad7dab8bda2f6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $931ad7dab8bda2f6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($931ad7dab8bda2f6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($931ad7dab8bda2f6$var$Buffer, Uint8Array);
function $931ad7dab8bda2f6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $931ad7dab8bda2f6$var$alloc(size, fill, encoding) {
    $931ad7dab8bda2f6$var$assertSize(size);
    if (size <= 0) return $931ad7dab8bda2f6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $931ad7dab8bda2f6$var$createBuffer(size).fill(fill, encoding) : $931ad7dab8bda2f6$var$createBuffer(size).fill(fill);
    return $931ad7dab8bda2f6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $931ad7dab8bda2f6$var$Buffer.alloc = function(size, fill, encoding) {
    return $931ad7dab8bda2f6$var$alloc(size, fill, encoding);
};
function $931ad7dab8bda2f6$var$allocUnsafe(size) {
    $931ad7dab8bda2f6$var$assertSize(size);
    return $931ad7dab8bda2f6$var$createBuffer(size < 0 ? 0 : $931ad7dab8bda2f6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $931ad7dab8bda2f6$var$Buffer.allocUnsafe = function(size) {
    return $931ad7dab8bda2f6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $931ad7dab8bda2f6$var$Buffer.allocUnsafeSlow = function(size) {
    return $931ad7dab8bda2f6$var$allocUnsafe(size);
};
function $931ad7dab8bda2f6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$931ad7dab8bda2f6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $931ad7dab8bda2f6$var$byteLength(string, encoding) | 0;
    var buf = $931ad7dab8bda2f6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $931ad7dab8bda2f6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $931ad7dab8bda2f6$var$checked(array.length) | 0;
    var buf = $931ad7dab8bda2f6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $931ad7dab8bda2f6$var$fromArrayView(arrayView) {
    if ($931ad7dab8bda2f6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $931ad7dab8bda2f6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $931ad7dab8bda2f6$var$fromArrayLike(arrayView);
}
function $931ad7dab8bda2f6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $931ad7dab8bda2f6$var$Buffer.prototype);
    return buf;
}
function $931ad7dab8bda2f6$var$fromObject(obj) {
    if ($931ad7dab8bda2f6$var$Buffer.isBuffer(obj)) {
        var len = $931ad7dab8bda2f6$var$checked(obj.length) | 0;
        var buf = $931ad7dab8bda2f6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $931ad7dab8bda2f6$var$numberIsNaN(obj.length)) return $931ad7dab8bda2f6$var$createBuffer(0);
        return $931ad7dab8bda2f6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $931ad7dab8bda2f6$var$fromArrayLike(obj.data);
}
function $931ad7dab8bda2f6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $931ad7dab8bda2f6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $931ad7dab8bda2f6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $931ad7dab8bda2f6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $931ad7dab8bda2f6$var$Buffer.alloc(+length);
}
$931ad7dab8bda2f6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $931ad7dab8bda2f6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$931ad7dab8bda2f6$var$Buffer.compare = function compare(a, b) {
    if ($931ad7dab8bda2f6$var$isInstance(a, Uint8Array)) a = $931ad7dab8bda2f6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($931ad7dab8bda2f6$var$isInstance(b, Uint8Array)) b = $931ad7dab8bda2f6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(a) || !$931ad7dab8bda2f6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$931ad7dab8bda2f6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$931ad7dab8bda2f6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $931ad7dab8bda2f6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $931ad7dab8bda2f6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($931ad7dab8bda2f6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(buf)) buf = $931ad7dab8bda2f6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $931ad7dab8bda2f6$var$byteLength(string, encoding) {
    if ($931ad7dab8bda2f6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $931ad7dab8bda2f6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $931ad7dab8bda2f6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $931ad7dab8bda2f6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $931ad7dab8bda2f6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$931ad7dab8bda2f6$var$Buffer.byteLength = $931ad7dab8bda2f6$var$byteLength;
function $931ad7dab8bda2f6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $931ad7dab8bda2f6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $931ad7dab8bda2f6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $931ad7dab8bda2f6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $931ad7dab8bda2f6$var$latin1Slice(this, start, end);
        case 'base64':
            return $931ad7dab8bda2f6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $931ad7dab8bda2f6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$931ad7dab8bda2f6$var$Buffer.prototype._isBuffer = true;
function $931ad7dab8bda2f6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$931ad7dab8bda2f6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$931ad7dab8bda2f6$var$swap(this, i, i + 1);
    return this;
};
$931ad7dab8bda2f6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $931ad7dab8bda2f6$var$swap(this, i, i + 3);
        $931ad7dab8bda2f6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$931ad7dab8bda2f6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $931ad7dab8bda2f6$var$swap(this, i, i + 7);
        $931ad7dab8bda2f6$var$swap(this, i + 1, i + 6);
        $931ad7dab8bda2f6$var$swap(this, i + 2, i + 5);
        $931ad7dab8bda2f6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$931ad7dab8bda2f6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $931ad7dab8bda2f6$var$utf8Slice(this, 0, length);
    return $931ad7dab8bda2f6$var$slowToString.apply(this, arguments);
};
$931ad7dab8bda2f6$var$Buffer.prototype.toLocaleString = $931ad7dab8bda2f6$var$Buffer.prototype.toString;
$931ad7dab8bda2f6$var$Buffer.prototype.equals = function equals(b) {
    if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $931ad7dab8bda2f6$var$Buffer.compare(this, b) === 0;
};
$931ad7dab8bda2f6$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $931ad7dab8bda2f6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($931ad7dab8bda2f6$var$customInspectSymbol) $931ad7dab8bda2f6$var$Buffer.prototype[$931ad7dab8bda2f6$var$customInspectSymbol] = $931ad7dab8bda2f6$var$Buffer.prototype.inspect;
$931ad7dab8bda2f6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($931ad7dab8bda2f6$var$isInstance(target, Uint8Array)) target = $931ad7dab8bda2f6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $931ad7dab8bda2f6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($931ad7dab8bda2f6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $931ad7dab8bda2f6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($931ad7dab8bda2f6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $931ad7dab8bda2f6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $931ad7dab8bda2f6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $931ad7dab8bda2f6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$931ad7dab8bda2f6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$931ad7dab8bda2f6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $931ad7dab8bda2f6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$931ad7dab8bda2f6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $931ad7dab8bda2f6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $931ad7dab8bda2f6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($931ad7dab8bda2f6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $931ad7dab8bda2f6$var$utf8Write(buf, string, offset, length) {
    return $931ad7dab8bda2f6$var$blitBuffer($931ad7dab8bda2f6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $931ad7dab8bda2f6$var$asciiWrite(buf, string, offset, length) {
    return $931ad7dab8bda2f6$var$blitBuffer($931ad7dab8bda2f6$var$asciiToBytes(string), buf, offset, length);
}
function $931ad7dab8bda2f6$var$base64Write(buf, string, offset, length) {
    return $931ad7dab8bda2f6$var$blitBuffer($931ad7dab8bda2f6$var$base64ToBytes(string), buf, offset, length);
}
function $931ad7dab8bda2f6$var$ucs2Write(buf, string, offset, length) {
    return $931ad7dab8bda2f6$var$blitBuffer($931ad7dab8bda2f6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$931ad7dab8bda2f6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $931ad7dab8bda2f6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $931ad7dab8bda2f6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $931ad7dab8bda2f6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $931ad7dab8bda2f6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $931ad7dab8bda2f6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$931ad7dab8bda2f6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $931ad7dab8bda2f6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $931ad7dab8bda2f6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $931ad7dab8bda2f6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $931ad7dab8bda2f6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $931ad7dab8bda2f6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $931ad7dab8bda2f6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $931ad7dab8bda2f6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $931ad7dab8bda2f6$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $931ad7dab8bda2f6$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $931ad7dab8bda2f6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $931ad7dab8bda2f6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $931ad7dab8bda2f6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$931ad7dab8bda2f6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $931ad7dab8bda2f6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $931ad7dab8bda2f6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$931ad7dab8bda2f6$var$Buffer.prototype.readUintLE = $931ad7dab8bda2f6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUintBE = $931ad7dab8bda2f6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUint8 = $931ad7dab8bda2f6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUint16LE = $931ad7dab8bda2f6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUint16BE = $931ad7dab8bda2f6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUint32LE = $931ad7dab8bda2f6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readUint32BE = $931ad7dab8bda2f6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$931ad7dab8bda2f6$var$Buffer.prototype.readBigUInt64LE = $931ad7dab8bda2f6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $931ad7dab8bda2f6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $931ad7dab8bda2f6$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$931ad7dab8bda2f6$var$Buffer.prototype.readBigUInt64BE = $931ad7dab8bda2f6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $931ad7dab8bda2f6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $931ad7dab8bda2f6$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$931ad7dab8bda2f6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$931ad7dab8bda2f6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$931ad7dab8bda2f6$var$Buffer.prototype.readBigInt64LE = $931ad7dab8bda2f6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $931ad7dab8bda2f6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $931ad7dab8bda2f6$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$931ad7dab8bda2f6$var$Buffer.prototype.readBigInt64BE = $931ad7dab8bda2f6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $931ad7dab8bda2f6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $931ad7dab8bda2f6$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$931ad7dab8bda2f6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$931ad7dab8bda2f6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$931ad7dab8bda2f6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$931ad7dab8bda2f6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $931ad7dab8bda2f6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$931ad7dab8bda2f6$var$Buffer.prototype.writeUintLE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $931ad7dab8bda2f6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUintBE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $931ad7dab8bda2f6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUint8 = $931ad7dab8bda2f6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUint16LE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUint16BE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUint32LE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeUint32BE = $931ad7dab8bda2f6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $931ad7dab8bda2f6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $931ad7dab8bda2f6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $931ad7dab8bda2f6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $931ad7dab8bda2f6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$931ad7dab8bda2f6$var$Buffer.prototype.writeBigUInt64LE = $931ad7dab8bda2f6$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $931ad7dab8bda2f6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$931ad7dab8bda2f6$var$Buffer.prototype.writeBigUInt64BE = $931ad7dab8bda2f6$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $931ad7dab8bda2f6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$931ad7dab8bda2f6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $931ad7dab8bda2f6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $931ad7dab8bda2f6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeBigInt64LE = $931ad7dab8bda2f6$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $931ad7dab8bda2f6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$931ad7dab8bda2f6$var$Buffer.prototype.writeBigInt64BE = $931ad7dab8bda2f6$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $931ad7dab8bda2f6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $931ad7dab8bda2f6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $931ad7dab8bda2f6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$931ad7dab8bda2f6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $931ad7dab8bda2f6$var$writeFloat(this, value, offset, true, noAssert);
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $931ad7dab8bda2f6$var$writeFloat(this, value, offset, false, noAssert);
};
function $931ad7dab8bda2f6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $931ad7dab8bda2f6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$931ad7dab8bda2f6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $931ad7dab8bda2f6$var$writeDouble(this, value, offset, true, noAssert);
};
$931ad7dab8bda2f6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $931ad7dab8bda2f6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$931ad7dab8bda2f6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$931ad7dab8bda2f6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$931ad7dab8bda2f6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$931ad7dab8bda2f6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $931ad7dab8bda2f6$var$Buffer.isBuffer(val) ? val : $931ad7dab8bda2f6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $931ad7dab8bda2f6$var$errors = {};
function $931ad7dab8bda2f6$var$E(sym, getMessage, Base) {
    $931ad7dab8bda2f6$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$931ad7dab8bda2f6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$931ad7dab8bda2f6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$931ad7dab8bda2f6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $931ad7dab8bda2f6$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $931ad7dab8bda2f6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $931ad7dab8bda2f6$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $931ad7dab8bda2f6$var$checkBounds(buf, offset, byteLength) {
    $931ad7dab8bda2f6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $931ad7dab8bda2f6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $931ad7dab8bda2f6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $931ad7dab8bda2f6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $931ad7dab8bda2f6$var$checkBounds(buf, offset, byteLength);
}
function $931ad7dab8bda2f6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $931ad7dab8bda2f6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $931ad7dab8bda2f6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $931ad7dab8bda2f6$var$validateNumber(value, type);
        throw new $931ad7dab8bda2f6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $931ad7dab8bda2f6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $931ad7dab8bda2f6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $931ad7dab8bda2f6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $931ad7dab8bda2f6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($931ad7dab8bda2f6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $931ad7dab8bda2f6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $931ad7dab8bda2f6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $931ad7dab8bda2f6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $931ad7dab8bda2f6$var$base64ToBytes(str) {
    return $abUaD.toByteArray($931ad7dab8bda2f6$var$base64clean(str));
}
function $931ad7dab8bda2f6$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $931ad7dab8bda2f6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $931ad7dab8bda2f6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $931ad7dab8bda2f6$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $931ad7dab8bda2f6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $931ad7dab8bda2f6$var$BufferBigIntNotDefined : fn;
}
function $931ad7dab8bda2f6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("a9uB3", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $76427a81a550508c$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $76427a81a550508c$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("dYwD5", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $cD2dd = parcelRequire("cD2dd");

var $7JWwW = parcelRequire("7JWwW");
var $a2ca30799de95548$var$format = $7JWwW.format, $a2ca30799de95548$var$inspect = $7JWwW.inspect;

var $VLMLy = parcelRequire("VLMLy");
var $a2ca30799de95548$var$ERR_INVALID_ARG_TYPE = $VLMLy.codes.ERR_INVALID_ARG_TYPE;

var $a9uB3 = parcelRequire("a9uB3");
var $a2ca30799de95548$var$kResistStopPropagation = $a9uB3.kResistStopPropagation, $a2ca30799de95548$var$AggregateError = $a9uB3.AggregateError, $a2ca30799de95548$var$SymbolDispose = $a9uB3.SymbolDispose;

var $a2ca30799de95548$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $a2ca30799de95548$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $a2ca30799de95548$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $a2ca30799de95548$var$Blob = globalThis.Blob || $cD2dd.Blob;
/* eslint-disable indent */ var $a2ca30799de95548$var$isBlob = typeof $a2ca30799de95548$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $a2ca30799de95548$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $a2ca30799de95548$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $a2ca30799de95548$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $a2ca30799de95548$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $a2ca30799de95548$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $a2ca30799de95548$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $a2ca30799de95548$var$format,
    inspect: $a2ca30799de95548$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $a2ca30799de95548$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $a2ca30799de95548$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $a2ca30799de95548$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $a2ca30799de95548$var$validateAbortSignal(signal, 'signal');
        $a2ca30799de95548$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $a2ca30799de95548$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $a2ca30799de95548$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $a2ca30799de95548$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $a2ca30799de95548$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $a2ca30799de95548$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("7JWwW", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("VLMLy", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $7JWwW = parcelRequire("7JWwW");
var $0ada643341f2f6f4$var$format = $7JWwW.format, $0ada643341f2f6f4$var$inspect = $7JWwW.inspect;

var $a9uB3 = parcelRequire("a9uB3");
var $0ada643341f2f6f4$var$CustomAggregateError = $a9uB3.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $0ada643341f2f6f4$var$AggregateError = globalThis.AggregateError || $0ada643341f2f6f4$var$CustomAggregateError;
var $0ada643341f2f6f4$var$kIsNodeError = Symbol('kIsNodeError');
var $0ada643341f2f6f4$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $0ada643341f2f6f4$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $0ada643341f2f6f4$var$nodeInternalPrefix = '__node_internal_';
var $0ada643341f2f6f4$var$codes = {};
function $0ada643341f2f6f4$var$assert(value, message) {
    if (!value) throw new $0ada643341f2f6f4$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $0ada643341f2f6f4$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $0ada643341f2f6f4$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $0ada643341f2f6f4$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $0ada643341f2f6f4$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $0ada643341f2f6f4$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $0ada643341f2f6f4$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $0ada643341f2f6f4$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$0ada643341f2f6f4$var$kIsNodeError] = true;
    $0ada643341f2f6f4$var$codes[code] = NodeError;
}
function $0ada643341f2f6f4$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $0ada643341f2f6f4$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $0ada643341f2f6f4$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $0ada643341f2f6f4$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $0ada643341f2f6f4$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $0ada643341f2f6f4$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$0ada643341f2f6f4$var$E('ERR_ASSERTION', '%s', Error);
$0ada643341f2f6f4$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $0ada643341f2f6f4$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $0ada643341f2f6f4$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($0ada643341f2f6f4$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($0ada643341f2f6f4$var$classRegExp.test(value)) instances.push(value);
            else {
                $0ada643341f2f6f4$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $0ada643341f2f6f4$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $0ada643341f2f6f4$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$0ada643341f2f6f4$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $0ada643341f2f6f4$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$0ada643341f2f6f4$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$0ada643341f2f6f4$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $0ada643341f2f6f4$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$0ada643341f2f6f4$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $0ada643341f2f6f4$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $0ada643341f2f6f4$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $0ada643341f2f6f4$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $0ada643341f2f6f4$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$0ada643341f2f6f4$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$0ada643341f2f6f4$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$0ada643341f2f6f4$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$0ada643341f2f6f4$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$0ada643341f2f6f4$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $0ada643341f2f6f4$var$AbortError,
    aggregateTwoErrors: $0ada643341f2f6f4$var$hideStackFrames($0ada643341f2f6f4$var$aggregateTwoErrors),
    hideStackFrames: $0ada643341f2f6f4$var$hideStackFrames,
    codes: $0ada643341f2f6f4$var$codes
};

});


parcelRegister("eS49T", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $ad3955a73c99fb1f$export$42af8c323be37587; }, function (v) { return $ad3955a73c99fb1f$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $ad3955a73c99fb1f$export$f405f72c701dad87; }, function (v) { return $ad3955a73c99fb1f$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $ad3955a73c99fb1f$export$42af8c323be37587;
var $ad3955a73c99fb1f$export$f405f72c701dad87;
'use strict';

var $ad3955a73c99fb1f$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $VLMLy = parcelRequire("VLMLy");
var $ad3955a73c99fb1f$var$_require_codes = $VLMLy.codes, $ad3955a73c99fb1f$var$ERR_INVALID_ARG_VALUE = $ad3955a73c99fb1f$var$_require_codes.ERR_INVALID_ARG_VALUE, $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE = $ad3955a73c99fb1f$var$_require_codes.ERR_INVALID_ARG_TYPE, $ad3955a73c99fb1f$var$ERR_MISSING_ARGS = $ad3955a73c99fb1f$var$_require_codes.ERR_MISSING_ARGS, $ad3955a73c99fb1f$var$ERR_OUT_OF_RANGE = $ad3955a73c99fb1f$var$_require_codes.ERR_OUT_OF_RANGE, $ad3955a73c99fb1f$var$AbortError = $VLMLy.AbortError;

var $bk4OI = parcelRequire("bk4OI");
var $ad3955a73c99fb1f$var$validateAbortSignal = $bk4OI.validateAbortSignal, $ad3955a73c99fb1f$var$validateInteger = $bk4OI.validateInteger, $ad3955a73c99fb1f$var$validateObject = $bk4OI.validateObject;

var $ad3955a73c99fb1f$var$kWeakHandler = (parcelRequire("a9uB3")).Symbol('kWeak');

var $ad3955a73c99fb1f$var$kResistStopPropagation = (parcelRequire("a9uB3")).Symbol('kResistStopPropagation');

var $4BKIq = parcelRequire("4BKIq");
var $ad3955a73c99fb1f$require$finished = $4BKIq.finished;

var $jWf80 = parcelRequire("jWf80");

var $7yGpj = parcelRequire("7yGpj");
var $ad3955a73c99fb1f$require$addAbortSignalNoValidate = $7yGpj.addAbortSignalNoValidate;

var $31UQg = parcelRequire("31UQg");
var $ad3955a73c99fb1f$var$isWritable = $31UQg.isWritable, $ad3955a73c99fb1f$var$isNodeStream = $31UQg.isNodeStream;

var $ad3955a73c99fb1f$require$deprecate = (parcelRequire("dYwD5")).deprecate;

var $ad3955a73c99fb1f$var$ArrayPrototypePush = (parcelRequire("a9uB3")).ArrayPrototypePush, $ad3955a73c99fb1f$var$Boolean = (parcelRequire("a9uB3")).Boolean, $ad3955a73c99fb1f$var$MathFloor = (parcelRequire("a9uB3")).MathFloor, $ad3955a73c99fb1f$var$Number = (parcelRequire("a9uB3")).Number, $ad3955a73c99fb1f$var$NumberIsNaN = (parcelRequire("a9uB3")).NumberIsNaN, $ad3955a73c99fb1f$var$Promise = (parcelRequire("a9uB3")).Promise, $ad3955a73c99fb1f$var$PromiseReject = (parcelRequire("a9uB3")).PromiseReject, $ad3955a73c99fb1f$var$PromiseResolve = (parcelRequire("a9uB3")).PromiseResolve, $ad3955a73c99fb1f$var$PromisePrototypeThen = (parcelRequire("a9uB3")).PromisePrototypeThen, $ad3955a73c99fb1f$var$Symbol = (parcelRequire("a9uB3")).Symbol;
var $ad3955a73c99fb1f$var$kEmpty = $ad3955a73c99fb1f$var$Symbol('kEmpty');
var $ad3955a73c99fb1f$var$kEof = $ad3955a73c99fb1f$var$Symbol('kEof');
function $ad3955a73c99fb1f$var$compose(stream, options) {
    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
    if ($ad3955a73c99fb1f$var$isNodeStream(stream) && !$ad3955a73c99fb1f$var$isWritable(stream)) throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $jWf80(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $ad3955a73c99fb1f$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $ad3955a73c99fb1f$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $ad3955a73c99fb1f$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $ad3955a73c99fb1f$var$MathFloor(options.highWaterMark);
    $ad3955a73c99fb1f$var$validateInteger(concurrency, 'options.concurrency', 1);
    $ad3955a73c99fb1f$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $ad3955a73c99fb1f$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $ad3955a73c99fb1f$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $ad3955a73c99fb1f$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $ad3955a73c99fb1f$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $ad3955a73c99fb1f$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($ad3955a73c99fb1f$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $ad3955a73c99fb1f$var$PromiseReject(err1);
                                $ad3955a73c99fb1f$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("dYwD5")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($ad3955a73c99fb1f$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $ad3955a73c99fb1f$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                        if (!(val !== $ad3955a73c99fb1f$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $ad3955a73c99fb1f$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ad3955a73c99fb1f$var$asIndexedPairs(options) {
    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $ad3955a73c99fb1f$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ad3955a73c99fb1f$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ad3955a73c99fb1f$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $ad3955a73c99fb1f$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $ad3955a73c99fb1f$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $ad3955a73c99fb1f$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ad3955a73c99fb1f$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $ad3955a73c99fb1f$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $ad3955a73c99fb1f$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ad3955a73c99fb1f$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $ad3955a73c99fb1f$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $ad3955a73c99fb1f$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $ad3955a73c99fb1f$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $ad3955a73c99fb1f$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($ad3955a73c99fb1f$var$ERR_MISSING_ARGS);
function $ad3955a73c99fb1f$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $ad3955a73c99fb1f$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $ad3955a73c99fb1f$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $ad3955a73c99fb1f$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $ad3955a73c99fb1f$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $ad3955a73c99fb1f$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $ad3955a73c99fb1f$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $ad3955a73c99fb1f$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ad3955a73c99fb1f$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $ad3955a73c99fb1f$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $ad3955a73c99fb1f$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $ad3955a73c99fb1f$var$flatMap(fn, options) {
    var values = $ad3955a73c99fb1f$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $ad3955a73c99fb1f$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $ad3955a73c99fb1f$var$Number(number);
    if ($ad3955a73c99fb1f$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $ad3955a73c99fb1f$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $ad3955a73c99fb1f$var$drop(number, options) {
    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ad3955a73c99fb1f$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ad3955a73c99fb1f$var$take(number, options) {
    if (options != null) $ad3955a73c99fb1f$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ad3955a73c99fb1f$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ad3955a73c99fb1f$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $ad3955a73c99fb1f$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$ad3955a73c99fb1f$export$42af8c323be37587 = {
    asIndexedPairs: $ad3955a73c99fb1f$require$deprecate($ad3955a73c99fb1f$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $ad3955a73c99fb1f$var$drop,
    filter: $ad3955a73c99fb1f$var$filter,
    flatMap: $ad3955a73c99fb1f$var$flatMap,
    map: $ad3955a73c99fb1f$var$map,
    take: $ad3955a73c99fb1f$var$take,
    compose: $ad3955a73c99fb1f$var$compose
};
$ad3955a73c99fb1f$export$f405f72c701dad87 = {
    every: $ad3955a73c99fb1f$var$every,
    forEach: $ad3955a73c99fb1f$var$forEach,
    reduce: $ad3955a73c99fb1f$var$reduce,
    toArray: $ad3955a73c99fb1f$var$toArray,
    some: $ad3955a73c99fb1f$var$some,
    find: $ad3955a73c99fb1f$var$find
};

});
parcelRegister("bk4OI", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $83e54c8aceaf820a$var$ArrayIsArray = $a9uB3.ArrayIsArray, $83e54c8aceaf820a$var$ArrayPrototypeIncludes = $a9uB3.ArrayPrototypeIncludes, $83e54c8aceaf820a$var$ArrayPrototypeJoin = $a9uB3.ArrayPrototypeJoin, $83e54c8aceaf820a$var$ArrayPrototypeMap = $a9uB3.ArrayPrototypeMap, $83e54c8aceaf820a$var$NumberIsInteger = $a9uB3.NumberIsInteger, $83e54c8aceaf820a$var$NumberIsNaN = $a9uB3.NumberIsNaN, $83e54c8aceaf820a$var$NumberMAX_SAFE_INTEGER = $a9uB3.NumberMAX_SAFE_INTEGER, $83e54c8aceaf820a$var$NumberMIN_SAFE_INTEGER = $a9uB3.NumberMIN_SAFE_INTEGER, $83e54c8aceaf820a$var$NumberParseInt = $a9uB3.NumberParseInt, $83e54c8aceaf820a$var$ObjectPrototypeHasOwnProperty = $a9uB3.ObjectPrototypeHasOwnProperty, $83e54c8aceaf820a$var$RegExpPrototypeExec = $a9uB3.RegExpPrototypeExec, $83e54c8aceaf820a$var$String = $a9uB3.String, $83e54c8aceaf820a$var$StringPrototypeToUpperCase = $a9uB3.StringPrototypeToUpperCase, $83e54c8aceaf820a$var$StringPrototypeTrim = $a9uB3.StringPrototypeTrim;

var $VLMLy = parcelRequire("VLMLy");
var $83e54c8aceaf820a$var$hideStackFrames = $VLMLy.hideStackFrames, $83e54c8aceaf820a$var$_require_codes = $VLMLy.codes, $83e54c8aceaf820a$var$ERR_SOCKET_BAD_PORT = $83e54c8aceaf820a$var$_require_codes.ERR_SOCKET_BAD_PORT, $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE = $83e54c8aceaf820a$var$_require_codes.ERR_INVALID_ARG_TYPE, $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE = $83e54c8aceaf820a$var$_require_codes.ERR_INVALID_ARG_VALUE, $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE = $83e54c8aceaf820a$var$_require_codes.ERR_OUT_OF_RANGE, $83e54c8aceaf820a$var$ERR_UNKNOWN_SIGNAL = $83e54c8aceaf820a$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $dYwD5 = parcelRequire("dYwD5");
var $83e54c8aceaf820a$require$normalizeEncoding = $dYwD5.normalizeEncoding;

var $dYwD5 = parcelRequire("dYwD5");
var $83e54c8aceaf820a$require$_require_types = $dYwD5.types;
var $83e54c8aceaf820a$var$isAsyncFunction = $83e54c8aceaf820a$require$_require_types.isAsyncFunction, $83e54c8aceaf820a$var$isArrayBufferView = $83e54c8aceaf820a$require$_require_types.isArrayBufferView;
var $83e54c8aceaf820a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $83e54c8aceaf820a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $83e54c8aceaf820a$var$isUint32(value) {
    return value === value >>> 0;
}
var $83e54c8aceaf820a$var$octalReg = /^[0-7]+$/;
var $83e54c8aceaf820a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $83e54c8aceaf820a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($83e54c8aceaf820a$var$RegExpPrototypeExec($83e54c8aceaf820a$var$octalReg, value) === null) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE(name, value, $83e54c8aceaf820a$var$modeDesc);
        value = $83e54c8aceaf820a$var$NumberParseInt(value, 8);
    }
    $83e54c8aceaf820a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $83e54c8aceaf820a$var$validateInteger = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $83e54c8aceaf820a$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $83e54c8aceaf820a$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$83e54c8aceaf820a$var$NumberIsInteger(value)) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $83e54c8aceaf820a$var$validateInt32 = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$83e54c8aceaf820a$var$NumberIsInteger(value)) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $83e54c8aceaf820a$var$validateUint32 = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$83e54c8aceaf820a$var$NumberIsInteger(value)) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $83e54c8aceaf820a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $83e54c8aceaf820a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $83e54c8aceaf820a$var$NumberIsNaN(value)) throw new $83e54c8aceaf820a$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $83e54c8aceaf820a$var$validateOneOf = $83e54c8aceaf820a$var$hideStackFrames(function(value, name, oneOf) {
    if (!$83e54c8aceaf820a$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $83e54c8aceaf820a$var$ArrayPrototypeJoin($83e54c8aceaf820a$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $83e54c8aceaf820a$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $83e54c8aceaf820a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $83e54c8aceaf820a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$83e54c8aceaf820a$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $83e54c8aceaf820a$var$validateObject = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $83e54c8aceaf820a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $83e54c8aceaf820a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $83e54c8aceaf820a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $83e54c8aceaf820a$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $83e54c8aceaf820a$var$validateDictionary = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $83e54c8aceaf820a$var$validateArray = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$83e54c8aceaf820a$var$ArrayIsArray(value)) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $83e54c8aceaf820a$var$validateStringArray(value, name) {
    $83e54c8aceaf820a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$83e54c8aceaf820a$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $83e54c8aceaf820a$var$validateBooleanArray(value, name) {
    $83e54c8aceaf820a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$83e54c8aceaf820a$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $83e54c8aceaf820a$var$validateAbortSignalArray(value, name) {
    $83e54c8aceaf820a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $83e54c8aceaf820a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $83e54c8aceaf820a$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $83e54c8aceaf820a$var$validateString(signal, name);
    if ($83e54c8aceaf820a$var$signals[signal] === undefined) {
        if ($83e54c8aceaf820a$var$signals[$83e54c8aceaf820a$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $83e54c8aceaf820a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $83e54c8aceaf820a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $83e54c8aceaf820a$var$validateBuffer = $83e54c8aceaf820a$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$83e54c8aceaf820a$var$isArrayBufferView(buffer)) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $83e54c8aceaf820a$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $83e54c8aceaf820a$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $83e54c8aceaf820a$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $83e54c8aceaf820a$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $83e54c8aceaf820a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $83e54c8aceaf820a$var$validateAbortSignal = $83e54c8aceaf820a$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $83e54c8aceaf820a$var$validateFunction = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $83e54c8aceaf820a$var$validatePlainFunction = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $83e54c8aceaf820a$var$isAsyncFunction(value)) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $83e54c8aceaf820a$var$validateUndefined = $83e54c8aceaf820a$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $83e54c8aceaf820a$var$validateUnion(value, name, union) {
    if (!$83e54c8aceaf820a$var$ArrayPrototypeIncludes(union, value)) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_TYPE(name, "('".concat($83e54c8aceaf820a$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $83e54c8aceaf820a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $83e54c8aceaf820a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$83e54c8aceaf820a$var$RegExpPrototypeExec($83e54c8aceaf820a$var$linkValueRegExp, value)) throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $83e54c8aceaf820a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $83e54c8aceaf820a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($83e54c8aceaf820a$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $83e54c8aceaf820a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $83e54c8aceaf820a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $83e54c8aceaf820a$var$isInt32,
    isUint32: $83e54c8aceaf820a$var$isUint32,
    parseFileMode: $83e54c8aceaf820a$var$parseFileMode,
    validateArray: $83e54c8aceaf820a$var$validateArray,
    validateStringArray: $83e54c8aceaf820a$var$validateStringArray,
    validateBooleanArray: $83e54c8aceaf820a$var$validateBooleanArray,
    validateAbortSignalArray: $83e54c8aceaf820a$var$validateAbortSignalArray,
    validateBoolean: $83e54c8aceaf820a$var$validateBoolean,
    validateBuffer: $83e54c8aceaf820a$var$validateBuffer,
    validateDictionary: $83e54c8aceaf820a$var$validateDictionary,
    validateEncoding: $83e54c8aceaf820a$var$validateEncoding,
    validateFunction: $83e54c8aceaf820a$var$validateFunction,
    validateInt32: $83e54c8aceaf820a$var$validateInt32,
    validateInteger: $83e54c8aceaf820a$var$validateInteger,
    validateNumber: $83e54c8aceaf820a$var$validateNumber,
    validateObject: $83e54c8aceaf820a$var$validateObject,
    validateOneOf: $83e54c8aceaf820a$var$validateOneOf,
    validatePlainFunction: $83e54c8aceaf820a$var$validatePlainFunction,
    validatePort: $83e54c8aceaf820a$var$validatePort,
    validateSignalName: $83e54c8aceaf820a$var$validateSignalName,
    validateString: $83e54c8aceaf820a$var$validateString,
    validateUint32: $83e54c8aceaf820a$var$validateUint32,
    validateUndefined: $83e54c8aceaf820a$var$validateUndefined,
    validateUnion: $83e54c8aceaf820a$var$validateUnion,
    validateAbortSignal: $83e54c8aceaf820a$var$validateAbortSignal,
    validateLinkHeaderValue: $83e54c8aceaf820a$var$validateLinkHeaderValue
};

});

parcelRegister("4BKIq", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $VLMLy = parcelRequire("VLMLy");
/* replacement end */ var $35aedad6bdf47c5b$var$AbortError = $VLMLy.AbortError, $35aedad6bdf47c5b$var$codes = $VLMLy.codes;
var $35aedad6bdf47c5b$var$ERR_INVALID_ARG_TYPE = $35aedad6bdf47c5b$var$codes.ERR_INVALID_ARG_TYPE, $35aedad6bdf47c5b$var$ERR_STREAM_PREMATURE_CLOSE = $35aedad6bdf47c5b$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $35aedad6bdf47c5b$var$kEmptyObject = (parcelRequire("dYwD5")).kEmptyObject, $35aedad6bdf47c5b$var$once = (parcelRequire("dYwD5")).once;

var $bk4OI = parcelRequire("bk4OI");
var $35aedad6bdf47c5b$var$validateAbortSignal = $bk4OI.validateAbortSignal, $35aedad6bdf47c5b$var$validateFunction = $bk4OI.validateFunction, $35aedad6bdf47c5b$var$validateObject = $bk4OI.validateObject, $35aedad6bdf47c5b$var$validateBoolean = $bk4OI.validateBoolean;

var $a9uB3 = parcelRequire("a9uB3");
var $35aedad6bdf47c5b$var$Promise = $a9uB3.Promise, $35aedad6bdf47c5b$var$PromisePrototypeThen = $a9uB3.PromisePrototypeThen, $35aedad6bdf47c5b$var$SymbolDispose = $a9uB3.SymbolDispose;

var $31UQg = parcelRequire("31UQg");
var $35aedad6bdf47c5b$var$isClosed = $31UQg.isClosed, $35aedad6bdf47c5b$var$isReadable = $31UQg.isReadable, $35aedad6bdf47c5b$var$isReadableNodeStream = $31UQg.isReadableNodeStream, $35aedad6bdf47c5b$var$isReadableStream = $31UQg.isReadableStream, $35aedad6bdf47c5b$var$isReadableFinished = $31UQg.isReadableFinished, $35aedad6bdf47c5b$var$isReadableErrored = $31UQg.isReadableErrored, $35aedad6bdf47c5b$var$isWritable = $31UQg.isWritable, $35aedad6bdf47c5b$var$isWritableNodeStream = $31UQg.isWritableNodeStream, $35aedad6bdf47c5b$var$isWritableStream = $31UQg.isWritableStream, $35aedad6bdf47c5b$var$isWritableFinished = $31UQg.isWritableFinished, $35aedad6bdf47c5b$var$isWritableErrored = $31UQg.isWritableErrored, $35aedad6bdf47c5b$var$isNodeStream = $31UQg.isNodeStream, $35aedad6bdf47c5b$var$_willEmitClose = $31UQg.willEmitClose, $35aedad6bdf47c5b$var$kIsClosedPromise = $31UQg.kIsClosedPromise;
var $35aedad6bdf47c5b$var$addAbortListener;
function $35aedad6bdf47c5b$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $35aedad6bdf47c5b$var$nop = function() {};

function $35aedad6bdf47c5b$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $35aedad6bdf47c5b$var$kEmptyObject;
    } else if (options == null) options = $35aedad6bdf47c5b$var$kEmptyObject;
    else $35aedad6bdf47c5b$var$validateObject(options, 'options');
    $35aedad6bdf47c5b$var$validateFunction(callback, 'callback');
    $35aedad6bdf47c5b$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $35aedad6bdf47c5b$var$once(callback);
    if ($35aedad6bdf47c5b$var$isReadableStream(stream) || $35aedad6bdf47c5b$var$isWritableStream(stream)) return $35aedad6bdf47c5b$var$eosWeb(stream, options, callback);
    if (!$35aedad6bdf47c5b$var$isNodeStream(stream)) throw new $35aedad6bdf47c5b$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $35aedad6bdf47c5b$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $35aedad6bdf47c5b$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $35aedad6bdf47c5b$var$_willEmitClose(stream) && $35aedad6bdf47c5b$var$isReadableNodeStream(stream) === readable && $35aedad6bdf47c5b$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $35aedad6bdf47c5b$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $35aedad6bdf47c5b$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $35aedad6bdf47c5b$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $35aedad6bdf47c5b$var$isWritableErrored(stream) || $35aedad6bdf47c5b$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $35aedad6bdf47c5b$var$isReadableNodeStream(stream, true)) {
            if (!$35aedad6bdf47c5b$var$isReadableFinished(stream, false)) return callback.call(stream, new $35aedad6bdf47c5b$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$35aedad6bdf47c5b$var$isWritableFinished(stream, false)) return callback.call(stream, new $35aedad6bdf47c5b$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $35aedad6bdf47c5b$var$isWritableErrored(stream) || $35aedad6bdf47c5b$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($35aedad6bdf47c5b$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $35aedad6bdf47c5b$var$isReadable(stream)) && (writableFinished || $35aedad6bdf47c5b$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $35aedad6bdf47c5b$var$isWritable(stream)) && (readableFinished || $35aedad6bdf47c5b$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $35aedad6bdf47c5b$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $35aedad6bdf47c5b$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $35aedad6bdf47c5b$var$addAbortListener = $35aedad6bdf47c5b$var$addAbortListener || (parcelRequire("dYwD5")).addAbortListener;
            var disposable = $35aedad6bdf47c5b$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $35aedad6bdf47c5b$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$35aedad6bdf47c5b$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $35aedad6bdf47c5b$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $35aedad6bdf47c5b$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $35aedad6bdf47c5b$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $35aedad6bdf47c5b$var$addAbortListener = $35aedad6bdf47c5b$var$addAbortListener || (parcelRequire("dYwD5")).addAbortListener;
            var disposable = $35aedad6bdf47c5b$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $35aedad6bdf47c5b$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$35aedad6bdf47c5b$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $35aedad6bdf47c5b$var$PromisePrototypeThen(stream[$35aedad6bdf47c5b$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $35aedad6bdf47c5b$var$nop;
}
function $35aedad6bdf47c5b$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $35aedad6bdf47c5b$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $35aedad6bdf47c5b$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $35aedad6bdf47c5b$var$Promise(function(resolve, reject) {
        var cleanup = $35aedad6bdf47c5b$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $35aedad6bdf47c5b$var$eos;
module.exports.finished = $35aedad6bdf47c5b$var$finished;

});
parcelRegister("31UQg", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $234d8eb4ecc7775f$var$SymbolAsyncIterator = $a9uB3.SymbolAsyncIterator, $234d8eb4ecc7775f$var$SymbolIterator = $a9uB3.SymbolIterator, $234d8eb4ecc7775f$var$SymbolFor = $a9uB3.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $234d8eb4ecc7775f$var$kIsDestroyed = $234d8eb4ecc7775f$var$SymbolFor('nodejs.stream.destroyed');
var $234d8eb4ecc7775f$var$kIsErrored = $234d8eb4ecc7775f$var$SymbolFor('nodejs.stream.errored');
var $234d8eb4ecc7775f$var$kIsReadable = $234d8eb4ecc7775f$var$SymbolFor('nodejs.stream.readable');
var $234d8eb4ecc7775f$var$kIsWritable = $234d8eb4ecc7775f$var$SymbolFor('nodejs.stream.writable');
var $234d8eb4ecc7775f$var$kIsDisturbed = $234d8eb4ecc7775f$var$SymbolFor('nodejs.stream.disturbed');
var $234d8eb4ecc7775f$var$kIsClosedPromise = $234d8eb4ecc7775f$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $234d8eb4ecc7775f$var$kControllerErrorFunction = $234d8eb4ecc7775f$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $234d8eb4ecc7775f$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $234d8eb4ecc7775f$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $234d8eb4ecc7775f$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $234d8eb4ecc7775f$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $234d8eb4ecc7775f$var$isReadableStream(obj) {
    return !!(obj && !$234d8eb4ecc7775f$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $234d8eb4ecc7775f$var$isWritableStream(obj) {
    return !!(obj && !$234d8eb4ecc7775f$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $234d8eb4ecc7775f$var$isTransformStream(obj) {
    return !!(obj && !$234d8eb4ecc7775f$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $234d8eb4ecc7775f$var$isWebStream(obj) {
    return $234d8eb4ecc7775f$var$isReadableStream(obj) || $234d8eb4ecc7775f$var$isWritableStream(obj) || $234d8eb4ecc7775f$var$isTransformStream(obj);
}
function $234d8eb4ecc7775f$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$234d8eb4ecc7775f$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$234d8eb4ecc7775f$var$SymbolIterator] === 'function';
    return typeof obj[$234d8eb4ecc7775f$var$SymbolAsyncIterator] === 'function' || typeof obj[$234d8eb4ecc7775f$var$SymbolIterator] === 'function';
}
function $234d8eb4ecc7775f$var$isDestroyed(stream) {
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$234d8eb4ecc7775f$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $234d8eb4ecc7775f$var$isWritableEnded(stream) {
    if (!$234d8eb4ecc7775f$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $234d8eb4ecc7775f$var$isWritableFinished(stream, strict) {
    if (!$234d8eb4ecc7775f$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $234d8eb4ecc7775f$var$isReadableEnded(stream) {
    if (!$234d8eb4ecc7775f$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $234d8eb4ecc7775f$var$isReadableFinished(stream, strict) {
    if (!$234d8eb4ecc7775f$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $234d8eb4ecc7775f$var$isReadable(stream) {
    if (stream && stream[$234d8eb4ecc7775f$var$kIsReadable] != null) return stream[$234d8eb4ecc7775f$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($234d8eb4ecc7775f$var$isDestroyed(stream)) return false;
    return $234d8eb4ecc7775f$var$isReadableNodeStream(stream) && stream.readable && !$234d8eb4ecc7775f$var$isReadableFinished(stream);
}
function $234d8eb4ecc7775f$var$isWritable(stream) {
    if (stream && stream[$234d8eb4ecc7775f$var$kIsWritable] != null) return stream[$234d8eb4ecc7775f$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($234d8eb4ecc7775f$var$isDestroyed(stream)) return false;
    return $234d8eb4ecc7775f$var$isWritableNodeStream(stream) && stream.writable && !$234d8eb4ecc7775f$var$isWritableEnded(stream);
}
function $234d8eb4ecc7775f$var$isFinished(stream, opts) {
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    if ($234d8eb4ecc7775f$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $234d8eb4ecc7775f$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $234d8eb4ecc7775f$var$isWritable(stream)) return false;
    return true;
}
function $234d8eb4ecc7775f$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $234d8eb4ecc7775f$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $234d8eb4ecc7775f$var$isClosed(stream) {
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $234d8eb4ecc7775f$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $234d8eb4ecc7775f$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $234d8eb4ecc7775f$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $234d8eb4ecc7775f$var$isOutgoingMessage(stream);
}
function $234d8eb4ecc7775f$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $234d8eb4ecc7775f$var$willEmitClose(stream) {
    if (!$234d8eb4ecc7775f$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $234d8eb4ecc7775f$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $234d8eb4ecc7775f$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$234d8eb4ecc7775f$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $234d8eb4ecc7775f$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$234d8eb4ecc7775f$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $234d8eb4ecc7775f$var$isDestroyed,
    kIsDestroyed: $234d8eb4ecc7775f$var$kIsDestroyed,
    isDisturbed: $234d8eb4ecc7775f$var$isDisturbed,
    kIsDisturbed: $234d8eb4ecc7775f$var$kIsDisturbed,
    isErrored: $234d8eb4ecc7775f$var$isErrored,
    kIsErrored: $234d8eb4ecc7775f$var$kIsErrored,
    isReadable: $234d8eb4ecc7775f$var$isReadable,
    kIsReadable: $234d8eb4ecc7775f$var$kIsReadable,
    kIsClosedPromise: $234d8eb4ecc7775f$var$kIsClosedPromise,
    kControllerErrorFunction: $234d8eb4ecc7775f$var$kControllerErrorFunction,
    kIsWritable: $234d8eb4ecc7775f$var$kIsWritable,
    isClosed: $234d8eb4ecc7775f$var$isClosed,
    isDuplexNodeStream: $234d8eb4ecc7775f$var$isDuplexNodeStream,
    isFinished: $234d8eb4ecc7775f$var$isFinished,
    isIterable: $234d8eb4ecc7775f$var$isIterable,
    isReadableNodeStream: $234d8eb4ecc7775f$var$isReadableNodeStream,
    isReadableStream: $234d8eb4ecc7775f$var$isReadableStream,
    isReadableEnded: $234d8eb4ecc7775f$var$isReadableEnded,
    isReadableFinished: $234d8eb4ecc7775f$var$isReadableFinished,
    isReadableErrored: $234d8eb4ecc7775f$var$isReadableErrored,
    isNodeStream: $234d8eb4ecc7775f$var$isNodeStream,
    isWebStream: $234d8eb4ecc7775f$var$isWebStream,
    isWritable: $234d8eb4ecc7775f$var$isWritable,
    isWritableNodeStream: $234d8eb4ecc7775f$var$isWritableNodeStream,
    isWritableStream: $234d8eb4ecc7775f$var$isWritableStream,
    isWritableEnded: $234d8eb4ecc7775f$var$isWritableEnded,
    isWritableFinished: $234d8eb4ecc7775f$var$isWritableFinished,
    isWritableErrored: $234d8eb4ecc7775f$var$isWritableErrored,
    isServerRequest: $234d8eb4ecc7775f$var$isServerRequest,
    isServerResponse: $234d8eb4ecc7775f$var$isServerResponse,
    willEmitClose: $234d8eb4ecc7775f$var$willEmitClose,
    isTransformStream: $234d8eb4ecc7775f$var$isTransformStream
};

});


parcelRegister("jWf80", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $7SXXk = parcelRequire("7SXXk");
var $e83f2b3f34098eb1$require$pipeline = $7SXXk.pipeline;

var $hyHPp = parcelRequire("hyHPp");

var $krXgd = parcelRequire("krXgd");
var $e83f2b3f34098eb1$require$destroyer = $krXgd.destroyer;

var $31UQg = parcelRequire("31UQg");
var $e83f2b3f34098eb1$var$isNodeStream = $31UQg.isNodeStream, $e83f2b3f34098eb1$var$isReadable = $31UQg.isReadable, $e83f2b3f34098eb1$var$isWritable = $31UQg.isWritable, $e83f2b3f34098eb1$var$isWebStream = $31UQg.isWebStream, $e83f2b3f34098eb1$var$isTransformStream = $31UQg.isTransformStream, $e83f2b3f34098eb1$var$isWritableStream = $31UQg.isWritableStream, $e83f2b3f34098eb1$var$isReadableStream = $31UQg.isReadableStream;

var $VLMLy = parcelRequire("VLMLy");
var $e83f2b3f34098eb1$var$AbortError = $VLMLy.AbortError, $e83f2b3f34098eb1$var$_require_codes = $VLMLy.codes, $e83f2b3f34098eb1$var$ERR_INVALID_ARG_VALUE = $e83f2b3f34098eb1$var$_require_codes.ERR_INVALID_ARG_VALUE, $e83f2b3f34098eb1$var$ERR_MISSING_ARGS = $e83f2b3f34098eb1$var$_require_codes.ERR_MISSING_ARGS;

var $4BKIq = parcelRequire("4BKIq");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $e83f2b3f34098eb1$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $hyHPp.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $hyHPp.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $hyHPp.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$e83f2b3f34098eb1$var$isNodeStream(streams[n]) && !$e83f2b3f34098eb1$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($e83f2b3f34098eb1$var$isReadable(streams[n]) || $e83f2b3f34098eb1$var$isReadableStream(streams[n]) || $e83f2b3f34098eb1$var$isTransformStream(streams[n]))) throw new $e83f2b3f34098eb1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($e83f2b3f34098eb1$var$isWritable(streams[n]) || $e83f2b3f34098eb1$var$isWritableStream(streams[n]) || $e83f2b3f34098eb1$var$isTransformStream(streams[n]))) throw new $e83f2b3f34098eb1$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $e83f2b3f34098eb1$require$pipeline(streams, onfinished);
    var writable = !!($e83f2b3f34098eb1$var$isWritable(head) || $e83f2b3f34098eb1$var$isWritableStream(head) || $e83f2b3f34098eb1$var$isTransformStream(head));
    var readable = !!($e83f2b3f34098eb1$var$isReadable(tail) || $e83f2b3f34098eb1$var$isReadableStream(tail) || $e83f2b3f34098eb1$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $hyHPp({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($e83f2b3f34098eb1$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($e83f2b3f34098eb1$var$isWebStream(head)) {
            var writable1 = $e83f2b3f34098eb1$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $e83f2b3f34098eb1$var$isTransformStream(tail) ? tail.readable : tail;
        $4BKIq(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($e83f2b3f34098eb1$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($e83f2b3f34098eb1$var$isWebStream(tail)) {
            var readable1 = $e83f2b3f34098eb1$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $e83f2b3f34098eb1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($e83f2b3f34098eb1$var$isNodeStream(tail)) $e83f2b3f34098eb1$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("7SXXk", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $5bdc1584cca1683e$var$ArrayIsArray = $a9uB3.ArrayIsArray, $5bdc1584cca1683e$var$Promise = $a9uB3.Promise, $5bdc1584cca1683e$var$SymbolAsyncIterator = $a9uB3.SymbolAsyncIterator, $5bdc1584cca1683e$var$SymbolDispose = $a9uB3.SymbolDispose;

var $4BKIq = parcelRequire("4BKIq");

var $5bdc1584cca1683e$require$once = (parcelRequire("dYwD5")).once;

var $krXgd = parcelRequire("krXgd");

var $hyHPp = parcelRequire("hyHPp");

var $VLMLy = parcelRequire("VLMLy");
var $5bdc1584cca1683e$var$aggregateTwoErrors = $VLMLy.aggregateTwoErrors, $5bdc1584cca1683e$var$_require_codes = $VLMLy.codes, $5bdc1584cca1683e$var$ERR_INVALID_ARG_TYPE = $5bdc1584cca1683e$var$_require_codes.ERR_INVALID_ARG_TYPE, $5bdc1584cca1683e$var$ERR_INVALID_RETURN_VALUE = $5bdc1584cca1683e$var$_require_codes.ERR_INVALID_RETURN_VALUE, $5bdc1584cca1683e$var$ERR_MISSING_ARGS = $5bdc1584cca1683e$var$_require_codes.ERR_MISSING_ARGS, $5bdc1584cca1683e$var$ERR_STREAM_DESTROYED = $5bdc1584cca1683e$var$_require_codes.ERR_STREAM_DESTROYED, $5bdc1584cca1683e$var$ERR_STREAM_PREMATURE_CLOSE = $5bdc1584cca1683e$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $5bdc1584cca1683e$var$AbortError = $VLMLy.AbortError;

var $bk4OI = parcelRequire("bk4OI");
var $5bdc1584cca1683e$var$validateFunction = $bk4OI.validateFunction, $5bdc1584cca1683e$var$validateAbortSignal = $bk4OI.validateAbortSignal;

var $31UQg = parcelRequire("31UQg");
var $5bdc1584cca1683e$var$isIterable = $31UQg.isIterable, $5bdc1584cca1683e$var$isReadable = $31UQg.isReadable, $5bdc1584cca1683e$var$isReadableNodeStream = $31UQg.isReadableNodeStream, $5bdc1584cca1683e$var$isNodeStream = $31UQg.isNodeStream, $5bdc1584cca1683e$var$isTransformStream = $31UQg.isTransformStream, $5bdc1584cca1683e$var$isWebStream = $31UQg.isWebStream, $5bdc1584cca1683e$var$isReadableStream = $31UQg.isReadableStream, $5bdc1584cca1683e$var$isReadableFinished = $31UQg.isReadableFinished;

var $5bdc1584cca1683e$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $5bdc1584cca1683e$var$PassThrough;
var $5bdc1584cca1683e$var$Readable;
var $5bdc1584cca1683e$var$addAbortListener;
function $5bdc1584cca1683e$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $4BKIq(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $krXgd.destroyer(stream, err || new $5bdc1584cca1683e$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $5bdc1584cca1683e$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $5bdc1584cca1683e$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $5bdc1584cca1683e$var$makeAsyncIterable(val) {
    if ($5bdc1584cca1683e$var$isIterable(val)) return val;
    else if ($5bdc1584cca1683e$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $5bdc1584cca1683e$var$fromReadable(val);
    throw new $5bdc1584cca1683e$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $5bdc1584cca1683e$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$5bdc1584cca1683e$var$Readable) $5bdc1584cca1683e$var$Readable = (parcelRequire("9ebsS"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($5bdc1584cca1683e$var$Readable.prototype[$5bdc1584cca1683e$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $5bdc1584cca1683e$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $5bdc1584cca1683e$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $4BKIq(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $5bdc1584cca1683e$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $5bdc1584cca1683e$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($5bdc1584cca1683e$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $5bdc1584cca1683e$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $5bdc1584cca1683e$var$pipelineImpl(streams, $5bdc1584cca1683e$require$once($5bdc1584cca1683e$var$popCallback(streams)));
}


function $5bdc1584cca1683e$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($5bdc1584cca1683e$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $5bdc1584cca1683e$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($5bdc1584cca1683e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($5bdc1584cca1683e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$5bdc1584cca1683e$var$isIterable(ret)) throw new $5bdc1584cca1683e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($5bdc1584cca1683e$var$isIterable(stream) || $5bdc1584cca1683e$var$isReadableNodeStream(stream) || $5bdc1584cca1683e$var$isTransformStream(stream)) ret = stream;
            else ret = $hyHPp.from(stream);
        } else if (typeof stream === 'function') {
            if ($5bdc1584cca1683e$var$isTransformStream(ret)) {
                var _ret;
                ret = $5bdc1584cca1683e$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $5bdc1584cca1683e$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$5bdc1584cca1683e$var$isIterable(ret, true)) throw new $5bdc1584cca1683e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$5bdc1584cca1683e$var$PassThrough) $5bdc1584cca1683e$var$PassThrough = (parcelRequire("d054b"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $5bdc1584cca1683e$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($5bdc1584cca1683e$var$isIterable(ret, true)) {
                    finishCount++;
                    $5bdc1584cca1683e$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($5bdc1584cca1683e$var$isReadableStream(ret) || $5bdc1584cca1683e$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $5bdc1584cca1683e$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $5bdc1584cca1683e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $5bdc1584cca1683e$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($5bdc1584cca1683e$var$isNodeStream(stream)) {
            if ($5bdc1584cca1683e$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $5bdc1584cca1683e$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($5bdc1584cca1683e$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($5bdc1584cca1683e$var$isTransformStream(ret) || $5bdc1584cca1683e$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $5bdc1584cca1683e$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($5bdc1584cca1683e$var$isIterable(ret)) {
                finishCount++;
                $5bdc1584cca1683e$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $5bdc1584cca1683e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($5bdc1584cca1683e$var$isWebStream(stream)) {
            if ($5bdc1584cca1683e$var$isReadableNodeStream(ret)) {
                finishCount++;
                $5bdc1584cca1683e$var$pumpToWeb($5bdc1584cca1683e$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($5bdc1584cca1683e$var$isReadableStream(ret) || $5bdc1584cca1683e$var$isIterable(ret)) {
                finishCount++;
                $5bdc1584cca1683e$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($5bdc1584cca1683e$var$isTransformStream(ret)) {
                finishCount++;
                $5bdc1584cca1683e$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $5bdc1584cca1683e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $hyHPp.from(stream);
    };
    if (streams.length === 1 && $5bdc1584cca1683e$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5bdc1584cca1683e$var$ERR_MISSING_ARGS('streams');
    var ac = new $5bdc1584cca1683e$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $5bdc1584cca1683e$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $5bdc1584cca1683e$var$AbortError());
    }
    $5bdc1584cca1683e$var$addAbortListener = $5bdc1584cca1683e$var$addAbortListener || (parcelRequire("dYwD5")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $5bdc1584cca1683e$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$5bdc1584cca1683e$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $5bdc1584cca1683e$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $5bdc1584cca1683e$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($5bdc1584cca1683e$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $4BKIq(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $4BKIq(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $5bdc1584cca1683e$var$pipelineImpl,
    pipeline: $5bdc1584cca1683e$var$pipeline
};

});
parcelRegister("krXgd", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $VLMLy = parcelRequire("VLMLy");
/* replacement end */ var $ee344c2b5289d6d8$var$aggregateTwoErrors = $VLMLy.aggregateTwoErrors, $ee344c2b5289d6d8$var$ERR_MULTIPLE_CALLBACK = $VLMLy.codes.ERR_MULTIPLE_CALLBACK, $ee344c2b5289d6d8$var$AbortError = $VLMLy.AbortError;

var $a9uB3 = parcelRequire("a9uB3");
var $ee344c2b5289d6d8$require$Symbol = $a9uB3.Symbol;

var $31UQg = parcelRequire("31UQg");
var $ee344c2b5289d6d8$var$kIsDestroyed = $31UQg.kIsDestroyed, $ee344c2b5289d6d8$var$isDestroyed = $31UQg.isDestroyed, $ee344c2b5289d6d8$var$isFinished = $31UQg.isFinished, $ee344c2b5289d6d8$var$isServerRequest = $31UQg.isServerRequest;
var $ee344c2b5289d6d8$var$kDestroy = $ee344c2b5289d6d8$require$Symbol('kDestroy');
var $ee344c2b5289d6d8$var$kConstruct = $ee344c2b5289d6d8$require$Symbol('kConstruct');
function $ee344c2b5289d6d8$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $ee344c2b5289d6d8$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $ee344c2b5289d6d8$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($ee344c2b5289d6d8$var$kDestroy, function(er) {
        $ee344c2b5289d6d8$var$_destroy(this, $ee344c2b5289d6d8$var$aggregateTwoErrors(er, err), cb);
    });
    else $ee344c2b5289d6d8$var$_destroy(this, err, cb);
    return this;
}
function $ee344c2b5289d6d8$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $ee344c2b5289d6d8$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $ee344c2b5289d6d8$var$emitErrorCloseNT(self, err) {
    $ee344c2b5289d6d8$var$emitErrorNT(self, err);
    $ee344c2b5289d6d8$var$emitCloseNT(self);
}
function $ee344c2b5289d6d8$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $ee344c2b5289d6d8$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $ee344c2b5289d6d8$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $ee344c2b5289d6d8$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitErrorNT, stream, err);
        else $ee344c2b5289d6d8$var$emitErrorNT(stream, err);
    }
}
function $ee344c2b5289d6d8$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($ee344c2b5289d6d8$var$kConstruct, cb);
    if (stream.listenerCount($ee344c2b5289d6d8$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($ee344c2b5289d6d8$var$constructNT, stream);
}
function $ee344c2b5289d6d8$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $ee344c2b5289d6d8$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $ee344c2b5289d6d8$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($ee344c2b5289d6d8$var$kDestroy, err);
        else if (err) $ee344c2b5289d6d8$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $ee344c2b5289d6d8$var$emitConstructNT(stream) {
    stream.emit($ee344c2b5289d6d8$var$kConstruct);
}
function $ee344c2b5289d6d8$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $ee344c2b5289d6d8$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $ee344c2b5289d6d8$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $ee344c2b5289d6d8$var$destroyer(stream, err) {
    if (!stream || $ee344c2b5289d6d8$var$isDestroyed(stream)) return;
    if (!err && !$ee344c2b5289d6d8$var$isFinished(stream)) err = new $ee344c2b5289d6d8$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($ee344c2b5289d6d8$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($ee344c2b5289d6d8$var$isRequest(stream)) stream.abort();
    else if ($ee344c2b5289d6d8$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($ee344c2b5289d6d8$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$ee344c2b5289d6d8$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $ee344c2b5289d6d8$var$construct,
    destroyer: $ee344c2b5289d6d8$var$destroyer,
    destroy: $ee344c2b5289d6d8$var$destroy,
    undestroy: $ee344c2b5289d6d8$var$undestroy,
    errorOrDestroy: $ee344c2b5289d6d8$var$errorOrDestroy
};

});

parcelRegister("hyHPp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $cc879bfb5b207e18$var$ObjectDefineProperties = $a9uB3.ObjectDefineProperties, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor = $a9uB3.ObjectGetOwnPropertyDescriptor, $cc879bfb5b207e18$var$ObjectKeys = $a9uB3.ObjectKeys, $cc879bfb5b207e18$var$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf;
module.exports = $cc879bfb5b207e18$var$Duplex;

var $9ebsS = parcelRequire("9ebsS");

var $9LaP5 = parcelRequire("9LaP5");
$cc879bfb5b207e18$var$ObjectSetPrototypeOf($cc879bfb5b207e18$var$Duplex.prototype, $9ebsS.prototype);
$cc879bfb5b207e18$var$ObjectSetPrototypeOf($cc879bfb5b207e18$var$Duplex, $9ebsS);
{
    var $cc879bfb5b207e18$var$keys = $cc879bfb5b207e18$var$ObjectKeys($9LaP5.prototype);
    // Allow the keys array to be GC'ed.
    for(var $cc879bfb5b207e18$var$i = 0; $cc879bfb5b207e18$var$i < $cc879bfb5b207e18$var$keys.length; $cc879bfb5b207e18$var$i++){
        var $cc879bfb5b207e18$var$method = $cc879bfb5b207e18$var$keys[$cc879bfb5b207e18$var$i];
        if (!$cc879bfb5b207e18$var$Duplex.prototype[$cc879bfb5b207e18$var$method]) $cc879bfb5b207e18$var$Duplex.prototype[$cc879bfb5b207e18$var$method] = $9LaP5.prototype[$cc879bfb5b207e18$var$method];
    }
}function $cc879bfb5b207e18$var$Duplex(options) {
    if (!(this instanceof $cc879bfb5b207e18$var$Duplex)) return new $cc879bfb5b207e18$var$Duplex(options);
    $9ebsS.call(this, options);
    $9LaP5.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$cc879bfb5b207e18$var$ObjectDefineProperties($cc879bfb5b207e18$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $cc879bfb5b207e18$var$ObjectGetOwnPropertyDescriptor($9LaP5.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $cc879bfb5b207e18$var$webStreamsAdapters;
// Lazy to avoid circular references
function $cc879bfb5b207e18$var$lazyWebStreams() {
    if ($cc879bfb5b207e18$var$webStreamsAdapters === undefined) $cc879bfb5b207e18$var$webStreamsAdapters = {};
    return $cc879bfb5b207e18$var$webStreamsAdapters;
}
$cc879bfb5b207e18$var$Duplex.fromWeb = function(pair, options) {
    return $cc879bfb5b207e18$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$cc879bfb5b207e18$var$Duplex.toWeb = function(duplex) {
    return $cc879bfb5b207e18$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $cc879bfb5b207e18$var$duplexify;

$cc879bfb5b207e18$var$Duplex.from = function(body) {
    if (!$cc879bfb5b207e18$var$duplexify) $cc879bfb5b207e18$var$duplexify = (parcelRequire("cHT5A"));
    return $cc879bfb5b207e18$var$duplexify(body, 'body');
};

});
parcelRegister("9ebsS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a9uB3 = parcelRequire("a9uB3");
/* replacement end */ var $6b7e5081696ebef9$var$ArrayPrototypeIndexOf = $a9uB3.ArrayPrototypeIndexOf, $6b7e5081696ebef9$var$NumberIsInteger = $a9uB3.NumberIsInteger, $6b7e5081696ebef9$var$NumberIsNaN = $a9uB3.NumberIsNaN, $6b7e5081696ebef9$var$NumberParseInt = $a9uB3.NumberParseInt, $6b7e5081696ebef9$var$ObjectDefineProperties = $a9uB3.ObjectDefineProperties, $6b7e5081696ebef9$var$ObjectKeys = $a9uB3.ObjectKeys, $6b7e5081696ebef9$var$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf, $6b7e5081696ebef9$var$Promise = $a9uB3.Promise, $6b7e5081696ebef9$var$SafeSet = $a9uB3.SafeSet, $6b7e5081696ebef9$var$SymbolAsyncDispose = $a9uB3.SymbolAsyncDispose, $6b7e5081696ebef9$var$SymbolAsyncIterator = $a9uB3.SymbolAsyncIterator, $6b7e5081696ebef9$var$Symbol = $a9uB3.Symbol;
module.exports = $6b7e5081696ebef9$var$Readable;
$6b7e5081696ebef9$var$Readable.ReadableState = $6b7e5081696ebef9$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $6b7e5081696ebef9$var$EE = $bBoAO.EventEmitter;

var $j71El = parcelRequire("j71El");
var $6b7e5081696ebef9$var$Stream = $j71El.Stream, $6b7e5081696ebef9$var$prependListener = $j71El.prependListener;

var $cD2dd = parcelRequire("cD2dd");
var $6b7e5081696ebef9$require$Buffer = $cD2dd.Buffer;

var $7yGpj = parcelRequire("7yGpj");
var $6b7e5081696ebef9$require$addAbortSignal = $7yGpj.addAbortSignal;

var $4BKIq = parcelRequire("4BKIq");

var $6b7e5081696ebef9$var$debug = (parcelRequire("dYwD5")).debuglog('stream', function(fn) {
    $6b7e5081696ebef9$var$debug = fn;
});

var $7Q48T = parcelRequire("7Q48T");

var $krXgd = parcelRequire("krXgd");

var $cSeDy = parcelRequire("cSeDy");
var $6b7e5081696ebef9$var$getHighWaterMark = $cSeDy.getHighWaterMark, $6b7e5081696ebef9$var$getDefaultHighWaterMark = $cSeDy.getDefaultHighWaterMark;

var $VLMLy = parcelRequire("VLMLy");
var $6b7e5081696ebef9$var$aggregateTwoErrors = $VLMLy.aggregateTwoErrors, $6b7e5081696ebef9$var$_require_codes = $VLMLy.codes, $6b7e5081696ebef9$var$ERR_INVALID_ARG_TYPE = $6b7e5081696ebef9$var$_require_codes.ERR_INVALID_ARG_TYPE, $6b7e5081696ebef9$var$ERR_METHOD_NOT_IMPLEMENTED = $6b7e5081696ebef9$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $6b7e5081696ebef9$var$ERR_OUT_OF_RANGE = $6b7e5081696ebef9$var$_require_codes.ERR_OUT_OF_RANGE, $6b7e5081696ebef9$var$ERR_STREAM_PUSH_AFTER_EOF = $6b7e5081696ebef9$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $6b7e5081696ebef9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $6b7e5081696ebef9$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $6b7e5081696ebef9$var$AbortError = $VLMLy.AbortError;

var $bk4OI = parcelRequire("bk4OI");
var $6b7e5081696ebef9$require$validateObject = $bk4OI.validateObject;
var $6b7e5081696ebef9$var$kPaused = $6b7e5081696ebef9$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $6b7e5081696ebef9$require$StringDecoder = $3Jf7C.StringDecoder;

var $5PMSw = parcelRequire("5PMSw");
$6b7e5081696ebef9$var$ObjectSetPrototypeOf($6b7e5081696ebef9$var$Readable.prototype, $6b7e5081696ebef9$var$Stream.prototype);
$6b7e5081696ebef9$var$ObjectSetPrototypeOf($6b7e5081696ebef9$var$Readable, $6b7e5081696ebef9$var$Stream);
var $6b7e5081696ebef9$var$nop = function() {};
var $6b7e5081696ebef9$var$errorOrDestroy = $krXgd.errorOrDestroy;
var $6b7e5081696ebef9$var$kObjectMode = 1;
var $6b7e5081696ebef9$var$kEnded = 2;
var $6b7e5081696ebef9$var$kEndEmitted = 4;
var $6b7e5081696ebef9$var$kReading = 8;
var $6b7e5081696ebef9$var$kConstructed = 16;
var $6b7e5081696ebef9$var$kSync = 32;
var $6b7e5081696ebef9$var$kNeedReadable = 64;
var $6b7e5081696ebef9$var$kEmittedReadable = 128;
var $6b7e5081696ebef9$var$kReadableListening = 256;
var $6b7e5081696ebef9$var$kResumeScheduled = 512;
var $6b7e5081696ebef9$var$kErrorEmitted = 1024;
var $6b7e5081696ebef9$var$kEmitClose = 2048;
var $6b7e5081696ebef9$var$kAutoDestroy = 4096;
var $6b7e5081696ebef9$var$kDestroyed = 8192;
var $6b7e5081696ebef9$var$kClosed = 16384;
var $6b7e5081696ebef9$var$kCloseEmitted = 32768;
var $6b7e5081696ebef9$var$kMultiAwaitDrain = 65536;
var $6b7e5081696ebef9$var$kReadingMore = 131072;
var $6b7e5081696ebef9$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $6b7e5081696ebef9$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$6b7e5081696ebef9$var$ObjectDefineProperties($6b7e5081696ebef9$var$ReadableState.prototype, {
    objectMode: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kObjectMode),
    ended: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kEnded),
    endEmitted: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kEndEmitted),
    reading: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kNeedReadable),
    emittedReadable: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kEmittedReadable),
    readableListening: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kReadableListening),
    resumeScheduled: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kErrorEmitted),
    emitClose: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kEmitClose),
    autoDestroy: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kCloseEmitted),
    multiAwaitDrain: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kReadingMore),
    dataEmitted: $6b7e5081696ebef9$var$makeBitMapDescriptor($6b7e5081696ebef9$var$kDataEmitted)
});

function $6b7e5081696ebef9$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hyHPp"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $6b7e5081696ebef9$var$kEmitClose | $6b7e5081696ebef9$var$kAutoDestroy | $6b7e5081696ebef9$var$kConstructed | $6b7e5081696ebef9$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $6b7e5081696ebef9$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $6b7e5081696ebef9$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $6b7e5081696ebef9$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $6b7e5081696ebef9$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $7Q48T();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$6b7e5081696ebef9$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$6b7e5081696ebef9$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$6b7e5081696ebef9$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $6b7e5081696ebef9$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $6b7e5081696ebef9$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $6b7e5081696ebef9$var$Readable)) return new $6b7e5081696ebef9$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("hyHPp"));
    this._readableState = new $6b7e5081696ebef9$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $6b7e5081696ebef9$require$addAbortSignal(options.signal, this);
    }
    $6b7e5081696ebef9$var$Stream.call(this, options);
    $krXgd.construct(this, function() {
        if (_this._readableState.needReadable) $6b7e5081696ebef9$var$maybeReadMore(_this, _this._readableState);
    });
}
$6b7e5081696ebef9$var$Readable.prototype.destroy = $krXgd.destroy;
$6b7e5081696ebef9$var$Readable.prototype._undestroy = $krXgd.undestroy;
$6b7e5081696ebef9$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$6b7e5081696ebef9$var$Readable.prototype[$6b7e5081696ebef9$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$6b7e5081696ebef9$var$Readable.prototype[$6b7e5081696ebef9$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $6b7e5081696ebef9$var$AbortError();
        this.destroy(error);
    }
    return new $6b7e5081696ebef9$var$Promise(function(resolve, reject) {
        return $4BKIq(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$6b7e5081696ebef9$var$Readable.prototype.push = function(chunk, encoding) {
    return $6b7e5081696ebef9$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$6b7e5081696ebef9$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $6b7e5081696ebef9$var$readableAddChunk(this, chunk, encoding, true);
};
function $6b7e5081696ebef9$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $6b7e5081696ebef9$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $6b7e5081696ebef9$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $6b7e5081696ebef9$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $6b7e5081696ebef9$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $6b7e5081696ebef9$require$Buffer) encoding = '';
        else if ($6b7e5081696ebef9$var$Stream._isUint8Array(chunk)) {
            chunk = $6b7e5081696ebef9$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $6b7e5081696ebef9$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $6b7e5081696ebef9$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$6b7e5081696ebef9$var$kReading;
        $6b7e5081696ebef9$var$onEofChunk(stream, state);
    } else if ((state.state & $6b7e5081696ebef9$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $6b7e5081696ebef9$var$kEndEmitted) !== 0) $6b7e5081696ebef9$var$errorOrDestroy(stream, new $6b7e5081696ebef9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $6b7e5081696ebef9$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $6b7e5081696ebef9$var$errorOrDestroy(stream, new $6b7e5081696ebef9$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$6b7e5081696ebef9$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $6b7e5081696ebef9$var$addChunk(stream, state, chunk, false);
                else $6b7e5081696ebef9$var$maybeReadMore(stream, state);
            } else $6b7e5081696ebef9$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$6b7e5081696ebef9$var$kReading;
        $6b7e5081696ebef9$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $6b7e5081696ebef9$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $6b7e5081696ebef9$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $6b7e5081696ebef9$var$kNeedReadable) !== 0) $6b7e5081696ebef9$var$emitReadable(stream);
    }
    $6b7e5081696ebef9$var$maybeReadMore(stream, state);
}
$6b7e5081696ebef9$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$6b7e5081696ebef9$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$6b7e5081696ebef9$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $6b7e5081696ebef9$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$6b7e5081696ebef9$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $6b7e5081696ebef9$var$MAX_HWM = 0x40000000;
function $6b7e5081696ebef9$var$computeNewHighWaterMark(n) {
    if (n > $6b7e5081696ebef9$var$MAX_HWM) throw new $6b7e5081696ebef9$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6b7e5081696ebef9$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $6b7e5081696ebef9$var$kObjectMode) !== 0) return 1;
    if ($6b7e5081696ebef9$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$6b7e5081696ebef9$var$Readable.prototype.read = function(n) {
    $6b7e5081696ebef9$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$6b7e5081696ebef9$var$NumberIsInteger(n)) n = $6b7e5081696ebef9$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $6b7e5081696ebef9$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$6b7e5081696ebef9$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $6b7e5081696ebef9$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $6b7e5081696ebef9$var$endReadable(this);
        else $6b7e5081696ebef9$var$emitReadable(this);
        return null;
    }
    n = $6b7e5081696ebef9$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $6b7e5081696ebef9$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $6b7e5081696ebef9$var$kNeedReadable) !== 0;
    $6b7e5081696ebef9$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $6b7e5081696ebef9$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $6b7e5081696ebef9$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $6b7e5081696ebef9$var$debug('do read');
        state.state |= $6b7e5081696ebef9$var$kReading | $6b7e5081696ebef9$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $6b7e5081696ebef9$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $6b7e5081696ebef9$var$errorOrDestroy(this, err);
        }
        state.state &= ~$6b7e5081696ebef9$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $6b7e5081696ebef9$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $6b7e5081696ebef9$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $6b7e5081696ebef9$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $6b7e5081696ebef9$var$onEofChunk(stream, state) {
    $6b7e5081696ebef9$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $6b7e5081696ebef9$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $6b7e5081696ebef9$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $6b7e5081696ebef9$var$emitReadable(stream) {
    var state = stream._readableState;
    $6b7e5081696ebef9$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $6b7e5081696ebef9$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($6b7e5081696ebef9$var$emitReadable_, stream);
    }
}
function $6b7e5081696ebef9$var$emitReadable_(stream) {
    var state = stream._readableState;
    $6b7e5081696ebef9$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $6b7e5081696ebef9$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $6b7e5081696ebef9$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($6b7e5081696ebef9$var$maybeReadMore_, stream, state);
    }
}
function $6b7e5081696ebef9$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $6b7e5081696ebef9$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$6b7e5081696ebef9$var$Readable.prototype._read = function(n) {
    throw new $6b7e5081696ebef9$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$6b7e5081696ebef9$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $6b7e5081696ebef9$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $6b7e5081696ebef9$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $6b7e5081696ebef9$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $6b7e5081696ebef9$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $6b7e5081696ebef9$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $6b7e5081696ebef9$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $6b7e5081696ebef9$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $6b7e5081696ebef9$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $6b7e5081696ebef9$var$debug('ondata');
        var ret = dest.write(chunk);
        $6b7e5081696ebef9$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $6b7e5081696ebef9$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $6b7e5081696ebef9$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $6b7e5081696ebef9$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $6b7e5081696ebef9$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $6b7e5081696ebef9$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $6b7e5081696ebef9$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $6b7e5081696ebef9$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $6b7e5081696ebef9$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $6b7e5081696ebef9$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$6b7e5081696ebef9$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $6b7e5081696ebef9$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$6b7e5081696ebef9$var$Readable.prototype.on = function(ev, fn) {
    var res = $6b7e5081696ebef9$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $6b7e5081696ebef9$var$debug('on readable', state.length, state.reading);
            if (state.length) $6b7e5081696ebef9$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($6b7e5081696ebef9$var$nReadingNextTick, this);
        }
    }
    return res;
};
$6b7e5081696ebef9$var$Readable.prototype.addListener = $6b7e5081696ebef9$var$Readable.prototype.on;
$6b7e5081696ebef9$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $6b7e5081696ebef9$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($6b7e5081696ebef9$var$updateReadableListening, this);
    return res;
};
$6b7e5081696ebef9$var$Readable.prototype.off = $6b7e5081696ebef9$var$Readable.prototype.removeListener;
$6b7e5081696ebef9$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $6b7e5081696ebef9$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($6b7e5081696ebef9$var$updateReadableListening, this);
    return res;
};
function $6b7e5081696ebef9$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$6b7e5081696ebef9$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $6b7e5081696ebef9$var$nReadingNextTick(self) {
    $6b7e5081696ebef9$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$6b7e5081696ebef9$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $6b7e5081696ebef9$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $6b7e5081696ebef9$var$resume(this, state);
    }
    state[$6b7e5081696ebef9$var$kPaused] = false;
    return this;
};
function $6b7e5081696ebef9$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($6b7e5081696ebef9$var$resume_, stream, state);
    }
}
function $6b7e5081696ebef9$var$resume_(stream, state) {
    $6b7e5081696ebef9$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $6b7e5081696ebef9$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$6b7e5081696ebef9$var$Readable.prototype.pause = function() {
    $6b7e5081696ebef9$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $6b7e5081696ebef9$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$6b7e5081696ebef9$var$kPaused] = true;
    return this;
};
function $6b7e5081696ebef9$var$flow(stream) {
    var state = stream._readableState;
    $6b7e5081696ebef9$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$6b7e5081696ebef9$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $6b7e5081696ebef9$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $6b7e5081696ebef9$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$6b7e5081696ebef9$var$Readable.prototype[$6b7e5081696ebef9$var$SymbolAsyncIterator] = function() {
    return $6b7e5081696ebef9$var$streamToAsyncIterator(this);
};
$6b7e5081696ebef9$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $6b7e5081696ebef9$require$validateObject(options, 'options');
    return $6b7e5081696ebef9$var$streamToAsyncIterator(this, options);
};
function $6b7e5081696ebef9$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $6b7e5081696ebef9$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $6b7e5081696ebef9$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $6b7e5081696ebef9$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $6b7e5081696ebef9$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $6b7e5081696ebef9$var$nop;
                    stream.on('readable', next);
                    cleanup = $4BKIq(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $6b7e5081696ebef9$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $6b7e5081696ebef9$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $6b7e5081696ebef9$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $6b7e5081696ebef9$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $krXgd.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$6b7e5081696ebef9$var$ObjectDefineProperties($6b7e5081696ebef9$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$6b7e5081696ebef9$var$ObjectDefineProperties($6b7e5081696ebef9$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$6b7e5081696ebef9$var$kPaused] !== false;
        },
        set: function(value) {
            this[$6b7e5081696ebef9$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$6b7e5081696ebef9$var$Readable._fromList = $6b7e5081696ebef9$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6b7e5081696ebef9$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $6b7e5081696ebef9$var$endReadable(stream) {
    var state = stream._readableState;
    $6b7e5081696ebef9$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($6b7e5081696ebef9$var$endReadableNT, state, stream);
    }
}
function $6b7e5081696ebef9$var$endReadableNT(state, stream) {
    $6b7e5081696ebef9$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($6b7e5081696ebef9$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $6b7e5081696ebef9$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$6b7e5081696ebef9$var$Readable.from = function(iterable, opts) {
    return $5PMSw($6b7e5081696ebef9$var$Readable, iterable, opts);
};
var $6b7e5081696ebef9$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6b7e5081696ebef9$var$lazyWebStreams() {
    if ($6b7e5081696ebef9$var$webStreamsAdapters === undefined) $6b7e5081696ebef9$var$webStreamsAdapters = {};
    return $6b7e5081696ebef9$var$webStreamsAdapters;
}
$6b7e5081696ebef9$var$Readable.fromWeb = function(readableStream, options) {
    return $6b7e5081696ebef9$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$6b7e5081696ebef9$var$Readable.toWeb = function(streamReadable, options) {
    return $6b7e5081696ebef9$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$6b7e5081696ebef9$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $6b7e5081696ebef9$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $krXgd.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("j71El", function(module, exports) {
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $de9ff3581b52d1b9$var$ArrayIsArray = $a9uB3.ArrayIsArray, $de9ff3581b52d1b9$var$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $de9ff3581b52d1b9$var$EE = $bBoAO.EventEmitter;
function $de9ff3581b52d1b9$var$Stream(opts) {
    $de9ff3581b52d1b9$var$EE.call(this, opts);
}
$de9ff3581b52d1b9$var$ObjectSetPrototypeOf($de9ff3581b52d1b9$var$Stream.prototype, $de9ff3581b52d1b9$var$EE.prototype);
$de9ff3581b52d1b9$var$ObjectSetPrototypeOf($de9ff3581b52d1b9$var$Stream, $de9ff3581b52d1b9$var$EE);
$de9ff3581b52d1b9$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($de9ff3581b52d1b9$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $de9ff3581b52d1b9$var$prependListener(source, 'error', onerror);
    $de9ff3581b52d1b9$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $de9ff3581b52d1b9$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($de9ff3581b52d1b9$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $de9ff3581b52d1b9$var$Stream,
    prependListener: $de9ff3581b52d1b9$var$prependListener
};

});

parcelRegister("7yGpj", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $580c9a8dd5e25f99$export$e2db56ee53255a0; }, function (v) { return $580c9a8dd5e25f99$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $580c9a8dd5e25f99$export$11956e9313f43de0; }, function (v) { return $580c9a8dd5e25f99$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $580c9a8dd5e25f99$export$e2db56ee53255a0;
var $580c9a8dd5e25f99$export$11956e9313f43de0;
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $580c9a8dd5e25f99$require$SymbolDispose = $a9uB3.SymbolDispose;

var $VLMLy = parcelRequire("VLMLy");
var $580c9a8dd5e25f99$var$AbortError = $VLMLy.AbortError, $580c9a8dd5e25f99$var$codes = $VLMLy.codes;

var $31UQg = parcelRequire("31UQg");
var $580c9a8dd5e25f99$var$isNodeStream = $31UQg.isNodeStream, $580c9a8dd5e25f99$var$isWebStream = $31UQg.isWebStream, $580c9a8dd5e25f99$var$kControllerErrorFunction = $31UQg.kControllerErrorFunction;

var $4BKIq = parcelRequire("4BKIq");
var $580c9a8dd5e25f99$var$ERR_INVALID_ARG_TYPE = $580c9a8dd5e25f99$var$codes.ERR_INVALID_ARG_TYPE;
var $580c9a8dd5e25f99$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $580c9a8dd5e25f99$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $580c9a8dd5e25f99$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$580c9a8dd5e25f99$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $580c9a8dd5e25f99$var$validateAbortSignal(signal, 'signal');
    if (!$580c9a8dd5e25f99$var$isNodeStream(stream) && !$580c9a8dd5e25f99$var$isWebStream(stream)) throw new $580c9a8dd5e25f99$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $580c9a8dd5e25f99$export$11956e9313f43de0(signal, stream);
};

$580c9a8dd5e25f99$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $580c9a8dd5e25f99$var$isNodeStream(stream) ? function() {
        stream.destroy(new $580c9a8dd5e25f99$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$580c9a8dd5e25f99$var$kControllerErrorFunction](new $580c9a8dd5e25f99$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $580c9a8dd5e25f99$var$addAbortListener = $580c9a8dd5e25f99$var$addAbortListener || (parcelRequire("dYwD5")).addAbortListener;
        var disposable = $580c9a8dd5e25f99$var$addAbortListener(signal, onAbort);
        $4BKIq(stream, disposable[$580c9a8dd5e25f99$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("7Q48T", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $5b509a532872decd$var$StringPrototypeSlice = $a9uB3.StringPrototypeSlice, $5b509a532872decd$var$SymbolIterator = $a9uB3.SymbolIterator, $5b509a532872decd$var$TypedArrayPrototypeSet = $a9uB3.TypedArrayPrototypeSet, $5b509a532872decd$var$Uint8Array = $a9uB3.Uint8Array;

var $cD2dd = parcelRequire("cD2dd");
var $5b509a532872decd$require$Buffer = $cD2dd.Buffer;

var $dYwD5 = parcelRequire("dYwD5");
var $5b509a532872decd$require$inspect = $dYwD5.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $5b509a532872decd$require$Buffer.alloc(0);
                var ret = $5b509a532872decd$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $5b509a532872decd$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $5b509a532872decd$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $5b509a532872decd$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $5b509a532872decd$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $5b509a532872decd$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $5b509a532872decd$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $5b509a532872decd$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $5b509a532872decd$var$TypedArrayPrototypeSet(ret, new $5b509a532872decd$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $5b509a532872decd$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cSeDy", function(module, exports) {
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $95f5e1c6415f61d6$var$MathFloor = $a9uB3.MathFloor, $95f5e1c6415f61d6$var$NumberIsInteger = $a9uB3.NumberIsInteger;

var $bk4OI = parcelRequire("bk4OI");
var $95f5e1c6415f61d6$require$validateInteger = $bk4OI.validateInteger;

var $95f5e1c6415f61d6$var$ERR_INVALID_ARG_VALUE = (parcelRequire("VLMLy")).codes.ERR_INVALID_ARG_VALUE;
var $95f5e1c6415f61d6$var$defaultHighWaterMarkBytes = 16384;
var $95f5e1c6415f61d6$var$defaultHighWaterMarkObjectMode = 16;
function $95f5e1c6415f61d6$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $95f5e1c6415f61d6$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $95f5e1c6415f61d6$var$defaultHighWaterMarkObjectMode : $95f5e1c6415f61d6$var$defaultHighWaterMarkBytes;
}
function $95f5e1c6415f61d6$var$setDefaultHighWaterMark(objectMode, value) {
    $95f5e1c6415f61d6$require$validateInteger(value, 'value', 0);
    if (objectMode) $95f5e1c6415f61d6$var$defaultHighWaterMarkObjectMode = value;
    else $95f5e1c6415f61d6$var$defaultHighWaterMarkBytes = value;
}
function $95f5e1c6415f61d6$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $95f5e1c6415f61d6$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$95f5e1c6415f61d6$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $95f5e1c6415f61d6$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $95f5e1c6415f61d6$var$MathFloor(hwm);
    }
    // Default value
    return $95f5e1c6415f61d6$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $95f5e1c6415f61d6$var$getHighWaterMark,
    getDefaultHighWaterMark: $95f5e1c6415f61d6$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $95f5e1c6415f61d6$var$setDefaultHighWaterMark
};

});

parcelRegister("5PMSw", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a9uB3 = parcelRequire("a9uB3");
/* replacement end */ var $43f7a16bf874c8be$var$PromisePrototypeThen = $a9uB3.PromisePrototypeThen, $43f7a16bf874c8be$var$SymbolAsyncIterator = $a9uB3.SymbolAsyncIterator, $43f7a16bf874c8be$var$SymbolIterator = $a9uB3.SymbolIterator;

var $cD2dd = parcelRequire("cD2dd");
var $43f7a16bf874c8be$require$Buffer = $cD2dd.Buffer;

var $VLMLy = parcelRequire("VLMLy");
var $43f7a16bf874c8be$require$_require_codes = $VLMLy.codes;
var $43f7a16bf874c8be$var$ERR_INVALID_ARG_TYPE = $43f7a16bf874c8be$require$_require_codes.ERR_INVALID_ARG_TYPE, $43f7a16bf874c8be$var$ERR_STREAM_NULL_VALUES = $43f7a16bf874c8be$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $43f7a16bf874c8be$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $43f7a16bf874c8be$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$43f7a16bf874c8be$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$43f7a16bf874c8be$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$43f7a16bf874c8be$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$43f7a16bf874c8be$var$SymbolIterator]();
    } else throw new $43f7a16bf874c8be$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $43f7a16bf874c8be$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $43f7a16bf874c8be$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $43f7a16bf874c8be$var$from;

});


parcelRegister("9LaP5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a9uB3 = parcelRequire("a9uB3");
/* replacement end */ var $71b0e610a0f8817f$var$ArrayPrototypeSlice = $a9uB3.ArrayPrototypeSlice, $71b0e610a0f8817f$var$Error = $a9uB3.Error, $71b0e610a0f8817f$var$FunctionPrototypeSymbolHasInstance = $a9uB3.FunctionPrototypeSymbolHasInstance, $71b0e610a0f8817f$var$ObjectDefineProperty = $a9uB3.ObjectDefineProperty, $71b0e610a0f8817f$var$ObjectDefineProperties = $a9uB3.ObjectDefineProperties, $71b0e610a0f8817f$var$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf, $71b0e610a0f8817f$var$StringPrototypeToLowerCase = $a9uB3.StringPrototypeToLowerCase, $71b0e610a0f8817f$var$Symbol = $a9uB3.Symbol, $71b0e610a0f8817f$var$SymbolHasInstance = $a9uB3.SymbolHasInstance;
module.exports = $71b0e610a0f8817f$var$Writable;
$71b0e610a0f8817f$var$Writable.WritableState = $71b0e610a0f8817f$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $71b0e610a0f8817f$var$EE = $bBoAO.EventEmitter;

var $j71El = parcelRequire("j71El");
var $71b0e610a0f8817f$require$Stream = $j71El.Stream;

var $cD2dd = parcelRequire("cD2dd");
var $71b0e610a0f8817f$require$Buffer = $cD2dd.Buffer;

var $krXgd = parcelRequire("krXgd");

var $7yGpj = parcelRequire("7yGpj");
var $71b0e610a0f8817f$require$addAbortSignal = $7yGpj.addAbortSignal;

var $cSeDy = parcelRequire("cSeDy");
var $71b0e610a0f8817f$var$getHighWaterMark = $cSeDy.getHighWaterMark, $71b0e610a0f8817f$var$getDefaultHighWaterMark = $cSeDy.getDefaultHighWaterMark;

var $VLMLy = parcelRequire("VLMLy");
var $71b0e610a0f8817f$require$_require_codes = $VLMLy.codes;
var $71b0e610a0f8817f$var$ERR_INVALID_ARG_TYPE = $71b0e610a0f8817f$require$_require_codes.ERR_INVALID_ARG_TYPE, $71b0e610a0f8817f$var$ERR_METHOD_NOT_IMPLEMENTED = $71b0e610a0f8817f$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $71b0e610a0f8817f$var$ERR_MULTIPLE_CALLBACK = $71b0e610a0f8817f$require$_require_codes.ERR_MULTIPLE_CALLBACK, $71b0e610a0f8817f$var$ERR_STREAM_CANNOT_PIPE = $71b0e610a0f8817f$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED = $71b0e610a0f8817f$require$_require_codes.ERR_STREAM_DESTROYED, $71b0e610a0f8817f$var$ERR_STREAM_ALREADY_FINISHED = $71b0e610a0f8817f$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $71b0e610a0f8817f$var$ERR_STREAM_NULL_VALUES = $71b0e610a0f8817f$require$_require_codes.ERR_STREAM_NULL_VALUES, $71b0e610a0f8817f$var$ERR_STREAM_WRITE_AFTER_END = $71b0e610a0f8817f$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $71b0e610a0f8817f$var$ERR_UNKNOWN_ENCODING = $71b0e610a0f8817f$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $71b0e610a0f8817f$var$errorOrDestroy = $krXgd.errorOrDestroy;
$71b0e610a0f8817f$var$ObjectSetPrototypeOf($71b0e610a0f8817f$var$Writable.prototype, $71b0e610a0f8817f$require$Stream.prototype);
$71b0e610a0f8817f$var$ObjectSetPrototypeOf($71b0e610a0f8817f$var$Writable, $71b0e610a0f8817f$require$Stream);
function $71b0e610a0f8817f$var$nop() {}
var $71b0e610a0f8817f$var$kOnFinished = $71b0e610a0f8817f$var$Symbol('kOnFinished');

function $71b0e610a0f8817f$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hyHPp"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $71b0e610a0f8817f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $71b0e610a0f8817f$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $71b0e610a0f8817f$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $71b0e610a0f8817f$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$71b0e610a0f8817f$var$kOnFinished] = [];
}
function $71b0e610a0f8817f$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$71b0e610a0f8817f$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $71b0e610a0f8817f$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$71b0e610a0f8817f$var$ObjectDefineProperty($71b0e610a0f8817f$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $71b0e610a0f8817f$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("hyHPp"));
    if (!isDuplex && !$71b0e610a0f8817f$var$FunctionPrototypeSymbolHasInstance($71b0e610a0f8817f$var$Writable, this)) return new $71b0e610a0f8817f$var$Writable(options);
    this._writableState = new $71b0e610a0f8817f$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $71b0e610a0f8817f$require$addAbortSignal(options.signal, this);
    }
    $71b0e610a0f8817f$require$Stream.call(this, options);
    $krXgd.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $71b0e610a0f8817f$var$clearBuffer(_this, state);
        $71b0e610a0f8817f$var$finishMaybe(_this, state);
    });
}
$71b0e610a0f8817f$var$ObjectDefineProperty($71b0e610a0f8817f$var$Writable, $71b0e610a0f8817f$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($71b0e610a0f8817f$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $71b0e610a0f8817f$var$Writable) return false;
        return object && object._writableState instanceof $71b0e610a0f8817f$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$71b0e610a0f8817f$var$Writable.prototype.pipe = function() {
    $71b0e610a0f8817f$var$errorOrDestroy(this, new $71b0e610a0f8817f$var$ERR_STREAM_CANNOT_PIPE());
};
function $71b0e610a0f8817f$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$71b0e610a0f8817f$require$Buffer.isEncoding(encoding)) throw new $71b0e610a0f8817f$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $71b0e610a0f8817f$var$nop;
    }
    if (chunk === null) throw new $71b0e610a0f8817f$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $71b0e610a0f8817f$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $71b0e610a0f8817f$require$Buffer) encoding = 'buffer';
        else if ($71b0e610a0f8817f$require$Stream._isUint8Array(chunk)) {
            chunk = $71b0e610a0f8817f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $71b0e610a0f8817f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $71b0e610a0f8817f$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $71b0e610a0f8817f$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $71b0e610a0f8817f$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$71b0e610a0f8817f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $71b0e610a0f8817f$var$_write(this, chunk, encoding, cb) === true;
};
$71b0e610a0f8817f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$71b0e610a0f8817f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $71b0e610a0f8817f$var$clearBuffer(this, state);
    }
};
$71b0e610a0f8817f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $71b0e610a0f8817f$var$StringPrototypeToLowerCase(encoding);
    if (!$71b0e610a0f8817f$require$Buffer.isEncoding(encoding)) throw new $71b0e610a0f8817f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $71b0e610a0f8817f$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $71b0e610a0f8817f$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $71b0e610a0f8817f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $71b0e610a0f8817f$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $71b0e610a0f8817f$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $71b0e610a0f8817f$var$errorOrDestroy(stream, er);
}
function $71b0e610a0f8817f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $71b0e610a0f8817f$var$errorOrDestroy(stream, new $71b0e610a0f8817f$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($71b0e610a0f8817f$var$onwriteError, stream, state, er, cb);
        else $71b0e610a0f8817f$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $71b0e610a0f8817f$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($71b0e610a0f8817f$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $71b0e610a0f8817f$var$afterWrite(stream, state, 1, cb);
    }
}
function $71b0e610a0f8817f$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $71b0e610a0f8817f$var$afterWrite(stream, state, count, cb);
}
function $71b0e610a0f8817f$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $71b0e610a0f8817f$var$errorBuffer(state);
    $71b0e610a0f8817f$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $71b0e610a0f8817f$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$71b0e610a0f8817f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED('end'));
    }
    $71b0e610a0f8817f$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $71b0e610a0f8817f$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $71b0e610a0f8817f$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $71b0e610a0f8817f$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $71b0e610a0f8817f$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $71b0e610a0f8817f$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $71b0e610a0f8817f$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $71b0e610a0f8817f$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$71b0e610a0f8817f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $71b0e610a0f8817f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$71b0e610a0f8817f$var$Writable.prototype._writev = null;
$71b0e610a0f8817f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $71b0e610a0f8817f$var$_write(this, chunk, encoding);
        if (ret instanceof $71b0e610a0f8817f$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $71b0e610a0f8817f$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $71b0e610a0f8817f$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $71b0e610a0f8817f$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$71b0e610a0f8817f$var$kOnFinished].push(cb);
    }
    return this;
};
function $71b0e610a0f8817f$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $71b0e610a0f8817f$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $71b0e610a0f8817f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $71b0e610a0f8817f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$71b0e610a0f8817f$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $71b0e610a0f8817f$var$errorOrDestroy(stream, err, state.sync);
        } else if ($71b0e610a0f8817f$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($71b0e610a0f8817f$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $71b0e610a0f8817f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $71b0e610a0f8817f$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $71b0e610a0f8817f$var$finishMaybe(stream, state, sync) {
    if ($71b0e610a0f8817f$var$needFinish(state)) {
        $71b0e610a0f8817f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($71b0e610a0f8817f$var$needFinish(state)) $71b0e610a0f8817f$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($71b0e610a0f8817f$var$needFinish(state)) {
                state.pendingcb++;
                $71b0e610a0f8817f$var$finish(stream, state);
            }
        }
    }
}
function $71b0e610a0f8817f$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$71b0e610a0f8817f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$71b0e610a0f8817f$var$ObjectDefineProperties($71b0e610a0f8817f$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $71b0e610a0f8817f$var$destroy = $krXgd.destroy;
$71b0e610a0f8817f$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$71b0e610a0f8817f$var$kOnFinished].length)) $2Qkr5.nextTick($71b0e610a0f8817f$var$errorBuffer, state);
    $71b0e610a0f8817f$var$destroy.call(this, err, cb);
    return this;
};
$71b0e610a0f8817f$var$Writable.prototype._undestroy = $krXgd.undestroy;
$71b0e610a0f8817f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$71b0e610a0f8817f$var$Writable.prototype[$71b0e610a0f8817f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $71b0e610a0f8817f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $71b0e610a0f8817f$var$lazyWebStreams() {
    if ($71b0e610a0f8817f$var$webStreamsAdapters === undefined) $71b0e610a0f8817f$var$webStreamsAdapters = {};
    return $71b0e610a0f8817f$var$webStreamsAdapters;
}
$71b0e610a0f8817f$var$Writable.fromWeb = function(writableStream, options) {
    return $71b0e610a0f8817f$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$71b0e610a0f8817f$var$Writable.toWeb = function(streamWritable) {
    return $71b0e610a0f8817f$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("cHT5A", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $cD2dd = parcelRequire("cD2dd");

var $31UQg = parcelRequire("31UQg");
var $94043bba3b47030a$var$isReadable = $31UQg.isReadable, $94043bba3b47030a$var$isWritable = $31UQg.isWritable, $94043bba3b47030a$var$isIterable = $31UQg.isIterable, $94043bba3b47030a$var$isNodeStream = $31UQg.isNodeStream, $94043bba3b47030a$var$isReadableNodeStream = $31UQg.isReadableNodeStream, $94043bba3b47030a$var$isWritableNodeStream = $31UQg.isWritableNodeStream, $94043bba3b47030a$var$isDuplexNodeStream = $31UQg.isDuplexNodeStream, $94043bba3b47030a$var$isReadableStream = $31UQg.isReadableStream, $94043bba3b47030a$var$isWritableStream = $31UQg.isWritableStream;

var $4BKIq = parcelRequire("4BKIq");

var $VLMLy = parcelRequire("VLMLy");
var $94043bba3b47030a$var$AbortError = $VLMLy.AbortError, $94043bba3b47030a$var$_require_codes = $VLMLy.codes, $94043bba3b47030a$var$ERR_INVALID_ARG_TYPE = $94043bba3b47030a$var$_require_codes.ERR_INVALID_ARG_TYPE, $94043bba3b47030a$var$ERR_INVALID_RETURN_VALUE = $94043bba3b47030a$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $krXgd = parcelRequire("krXgd");
var $94043bba3b47030a$require$destroyer = $krXgd.destroyer;

var $hyHPp = parcelRequire("hyHPp");

var $9ebsS = parcelRequire("9ebsS");

var $9LaP5 = parcelRequire("9LaP5");

var $dYwD5 = parcelRequire("dYwD5");
var $94043bba3b47030a$require$createDeferredPromise = $dYwD5.createDeferredPromise;

var $5PMSw = parcelRequire("5PMSw");
var $94043bba3b47030a$var$Blob = globalThis.Blob || $cD2dd.Blob;
var $94043bba3b47030a$var$isBlob = typeof $94043bba3b47030a$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $94043bba3b47030a$var$Blob;
} : function isBlob(b) {
    return false;
};

var $94043bba3b47030a$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $a9uB3 = parcelRequire("a9uB3");
var $94043bba3b47030a$require$FunctionPrototypeCall = $a9uB3.FunctionPrototypeCall;
// This is needed for pre node 17.
var $94043bba3b47030a$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($hyHPp);
module.exports = function duplexify(body, name) {
    if ($94043bba3b47030a$var$isDuplexNodeStream(body)) return body;
    if ($94043bba3b47030a$var$isReadableNodeStream(body)) return $94043bba3b47030a$var$_duplexify({
        readable: body
    });
    if ($94043bba3b47030a$var$isWritableNodeStream(body)) return $94043bba3b47030a$var$_duplexify({
        writable: body
    });
    if ($94043bba3b47030a$var$isNodeStream(body)) return $94043bba3b47030a$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($94043bba3b47030a$var$isReadableStream(body)) return $94043bba3b47030a$var$_duplexify({
        readable: $9ebsS.fromWeb(body)
    });
    if ($94043bba3b47030a$var$isWritableStream(body)) return $94043bba3b47030a$var$_duplexify({
        writable: $9LaP5.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $94043bba3b47030a$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($94043bba3b47030a$var$isIterable(value)) return $5PMSw($94043bba3b47030a$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $94043bba3b47030a$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $94043bba3b47030a$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $94043bba3b47030a$require$destroyer(d, err);
            });
            return d = new $94043bba3b47030a$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $94043bba3b47030a$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($94043bba3b47030a$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($94043bba3b47030a$var$isIterable(body)) return $5PMSw($94043bba3b47030a$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($94043bba3b47030a$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $94043bba3b47030a$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $94043bba3b47030a$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $94043bba3b47030a$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $94043bba3b47030a$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $94043bba3b47030a$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $94043bba3b47030a$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $94043bba3b47030a$require$destroyer(d1, err);
        });
        return d1 = new $94043bba3b47030a$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $94043bba3b47030a$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $94043bba3b47030a$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $94043bba3b47030a$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $94043bba3b47030a$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $94043bba3b47030a$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $94043bba3b47030a$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $94043bba3b47030a$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $9ebsS.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$94043bba3b47030a$var$isReadable(r);
    var writable = !!$94043bba3b47030a$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $94043bba3b47030a$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $4BKIq(w, function(err) {
            writable = false;
            if (err) $94043bba3b47030a$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $4BKIq(r, function(err) {
            readable = false;
            if (err) $94043bba3b47030a$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $94043bba3b47030a$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $94043bba3b47030a$require$destroyer(w, err);
            $94043bba3b47030a$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("d054b", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $976f3486ef6841b9$require$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf;
module.exports = $976f3486ef6841b9$var$PassThrough;

var $kIaoS = parcelRequire("kIaoS");
$976f3486ef6841b9$require$ObjectSetPrototypeOf($976f3486ef6841b9$var$PassThrough.prototype, $kIaoS.prototype);
$976f3486ef6841b9$require$ObjectSetPrototypeOf($976f3486ef6841b9$var$PassThrough, $kIaoS);
function $976f3486ef6841b9$var$PassThrough(options) {
    if (!(this instanceof $976f3486ef6841b9$var$PassThrough)) return new $976f3486ef6841b9$var$PassThrough(options);
    $kIaoS.call(this, options);
}
$976f3486ef6841b9$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("kIaoS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $f13ffbf8263b5538$var$ObjectSetPrototypeOf = $a9uB3.ObjectSetPrototypeOf, $f13ffbf8263b5538$var$Symbol = $a9uB3.Symbol;
module.exports = $f13ffbf8263b5538$var$Transform;

var $f13ffbf8263b5538$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("VLMLy")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $hyHPp = parcelRequire("hyHPp");

var $cSeDy = parcelRequire("cSeDy");
var $f13ffbf8263b5538$require$getHighWaterMark = $cSeDy.getHighWaterMark;
$f13ffbf8263b5538$var$ObjectSetPrototypeOf($f13ffbf8263b5538$var$Transform.prototype, $hyHPp.prototype);
$f13ffbf8263b5538$var$ObjectSetPrototypeOf($f13ffbf8263b5538$var$Transform, $hyHPp);
var $f13ffbf8263b5538$var$kCallback = $f13ffbf8263b5538$var$Symbol('kCallback');
function $f13ffbf8263b5538$var$Transform(options) {
    if (!(this instanceof $f13ffbf8263b5538$var$Transform)) return new $f13ffbf8263b5538$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $f13ffbf8263b5538$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $hyHPp.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$f13ffbf8263b5538$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $f13ffbf8263b5538$var$prefinish);
}
function $f13ffbf8263b5538$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $f13ffbf8263b5538$var$prefinish() {
    if (this._final !== $f13ffbf8263b5538$var$_final) $f13ffbf8263b5538$var$_final.call(this);
}
$f13ffbf8263b5538$var$Transform.prototype._final = $f13ffbf8263b5538$var$_final;
$f13ffbf8263b5538$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $f13ffbf8263b5538$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$f13ffbf8263b5538$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$f13ffbf8263b5538$var$kCallback] = callback;
    });
};
$f13ffbf8263b5538$var$Transform.prototype._read = function() {
    if (this[$f13ffbf8263b5538$var$kCallback]) {
        var callback = this[$f13ffbf8263b5538$var$kCallback];
        this[$f13ffbf8263b5538$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("5U9yC", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a9uB3 = parcelRequire("a9uB3");
var $44c99895777df1b6$var$ArrayPrototypePop = $a9uB3.ArrayPrototypePop, $44c99895777df1b6$var$Promise = $a9uB3.Promise;

var $31UQg = parcelRequire("31UQg");
var $44c99895777df1b6$var$isIterable = $31UQg.isIterable, $44c99895777df1b6$var$isNodeStream = $31UQg.isNodeStream, $44c99895777df1b6$var$isWebStream = $31UQg.isWebStream;

var $7SXXk = parcelRequire("7SXXk");
var $44c99895777df1b6$var$pl = $7SXXk.pipelineImpl;

var $4BKIq = parcelRequire("4BKIq");
var $44c99895777df1b6$require$finished = $4BKIq.finished;
parcelRequire("5gfuN");
function $44c99895777df1b6$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $44c99895777df1b6$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$44c99895777df1b6$var$isNodeStream(lastArg) && !$44c99895777df1b6$var$isIterable(lastArg) && !$44c99895777df1b6$var$isWebStream(lastArg)) {
            var options = $44c99895777df1b6$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $44c99895777df1b6$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $44c99895777df1b6$require$finished,
    pipeline: $44c99895777df1b6$var$pipeline
};

});



parcelRegister("b6Fqk", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerArrayValue = void 0;

var $aalae = parcelRequire("aalae");

var $auQ3n = parcelRequire("auQ3n");
/**
 * Handles values that are part of an array.
 */ var $8160632489136aaf$var$EntryHandlerArrayValue = /*#__PURE__*/ function() {
    function EntryHandlerArrayValue() {
        (0, $jGAMp._)(this, EntryHandlerArrayValue);
    }
    (0, $byiyg._)(EntryHandlerArrayValue, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return false;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.test(parsingContext, util, null, keys, depth)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            typeof keys[depth] === 'number'
                        ];
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var parentKey, listRootKey, listRootDepth, i, keyOption, values, _, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, object, err, i1, parentContext, values1, _1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, object1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    util.unaliasKeywordParent(keys, depth)
                                ];
                            case 1:
                                parentKey = _state.sent();
                                if (!(parentKey === '@list')) return [
                                    3,
                                    14
                                ];
                                // Our value is part of an array
                                // Determine the list root key
                                listRootKey = null;
                                listRootDepth = 0;
                                for(i = depth - 2; i > 0; i--){
                                    keyOption = keys[i];
                                    if (typeof keyOption === 'string' || typeof keyOption === 'number') {
                                        listRootDepth = i;
                                        listRootKey = keyOption;
                                        break;
                                    }
                                }
                                if (!(listRootKey !== null)) return [
                                    3,
                                    13
                                ];
                                _ = util.valueToTerm;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 2:
                                return [
                                    4,
                                    _.apply(util, [
                                        _state.sent(),
                                        listRootKey,
                                        value,
                                        depth,
                                        keys
                                    ])
                                ];
                            case 3:
                                values = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = values[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                object = _step.value;
                                return [
                                    4,
                                    this.handleListElement(parsingContext, util, object, value, depth, keys.slice(0, listRootDepth), listRootDepth)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                if (!(values.length === 0)) return [
                                    3,
                                    13
                                ];
                                return [
                                    4,
                                    this.handleListElement(parsingContext, util, null, value, depth, keys.slice(0, listRootDepth), listRootDepth)
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                return [
                                    3,
                                    36
                                ];
                            case 14:
                                if (!(parentKey === '@set')) return [
                                    3,
                                    16
                                ];
                                // Our value is part of a set, so we just add it to the parent-parent
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, -2), value, depth - 2, false)
                                ];
                            case 15:
                                _state.sent();
                                return [
                                    3,
                                    36
                                ];
                            case 16:
                                if (!(parentKey !== undefined && parentKey !== '@type')) return [
                                    3,
                                    36
                                ];
                                i1 = depth - 1;
                                _state.label = 17;
                            case 17:
                                if (!(i1 > 0)) return [
                                    3,
                                    20
                                ];
                                if (!(typeof keys[i1] !== 'number')) return [
                                    3,
                                    19
                                ];
                                return [
                                    4,
                                    util.unaliasKeyword(keys[i1], keys, i1)
                                ];
                            case 18:
                                parentKey = _state.sent();
                                return [
                                    3,
                                    20
                                ];
                            case 19:
                                i1--;
                                return [
                                    3,
                                    17
                                ];
                            case 20:
                                return [
                                    4,
                                    parsingContext.getContext(keys.slice(0, -1))
                                ];
                            case 21:
                                parentContext = _state.sent();
                                if (!('@list' in $aalae.Util.getContextValueContainer(parentContext, parentKey))) return [
                                    3,
                                    34
                                ];
                                // Our value is part of an array
                                // Emit the given objects as list elements
                                parsingContext.emittedStack[depth + 1] = true; // Ensure the creation of bnodes for empty nodes
                                _1 = util.valueToTerm;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 22:
                                return [
                                    4,
                                    _1.apply(util, [
                                        _state.sent(),
                                        parentKey,
                                        value,
                                        depth,
                                        keys
                                    ])
                                ];
                            case 23:
                                values1 = _state.sent();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 24;
                            case 24:
                                _state.trys.push([
                                    24,
                                    29,
                                    30,
                                    31
                                ]);
                                _iterator1 = values1[Symbol.iterator]();
                                _state.label = 25;
                            case 25:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    28
                                ];
                                object1 = _step1.value;
                                return [
                                    4,
                                    this.handleListElement(parsingContext, util, object1, value, depth, keys.slice(0, -1), depth - 1)
                                ];
                            case 26:
                                _state.sent();
                                _state.label = 27;
                            case 27:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    25
                                ];
                            case 28:
                                return [
                                    3,
                                    31
                                ];
                            case 29:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    31
                                ];
                            case 30:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 31:
                                if (!(values1.length === 0)) return [
                                    3,
                                    33
                                ];
                                return [
                                    4,
                                    this.handleListElement(parsingContext, util, null, value, depth, keys.slice(0, -1), depth - 1)
                                ];
                            case 32:
                                _state.sent();
                                _state.label = 33;
                            case 33:
                                return [
                                    3,
                                    36
                                ];
                            case 34:
                                // Copy the stack values up one level so that the next job can access them.
                                parsingContext.shiftStack(depth, 1);
                                // Execute the job one level higher
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, -1), value, depth - 1, false)
                                ];
                            case 35:
                                _state.sent();
                                // Remove any defined contexts at this level to avoid it to propagate to the next array element.
                                parsingContext.contextTree.removeContext(keys.slice(0, -1));
                                _state.label = 36;
                            case 36:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "handleListElement",
            value: function handleListElement(parsingContext, util, value, valueOriginal, depth, listRootKeys, listRootDepth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var listPointer, _tmp, linkTerm, newLinkTerm;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Buffer our value as an RDF list using the listRootKey as predicate
                                listPointer = parsingContext.listPointerStack[depth];
                                _tmp = valueOriginal !== null;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    util.unaliasKeywords(valueOriginal, listRootKeys, depth)
                                ];
                            case 1:
                                _tmp = _state.sent()['@value'] !== null;
                                _state.label = 2;
                            case 2:
                                if (_tmp) {
                                    if (!listPointer || !listPointer.value) {
                                        linkTerm = util.dataFactory.blankNode();
                                        listPointer = {
                                            value: linkTerm,
                                            listRootDepth: listRootDepth,
                                            listId: linkTerm
                                        };
                                    } else {
                                        // rdf:rest links are always emitted before the next element,
                                        // as the blank node identifier is only created at that point.
                                        // Because of this reason, the final rdf:nil is emitted when the stack depth is decreased.
                                        newLinkTerm = util.dataFactory.blankNode();
                                        parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.value, util.rdfRest, newLinkTerm, util.getDefaultGraph()));
                                        // Update the list pointer for the next element
                                        listPointer.value = newLinkTerm;
                                    }
                                    // Emit a list element for the current value
                                    // Omit rdf:first if the value is invalid
                                    if (value) parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.value, util.rdfFirst, value, util.getDefaultGraph()));
                                } else // A falsy list element if found.
                                // Mark it as an rdf:nil list until another valid list element comes in
                                if (!listPointer) listPointer = {
                                    listRootDepth: listRootDepth,
                                    listId: util.rdfNil
                                };
                                parsingContext.listPointerStack[depth] = listPointer;
                                // Error if an annotation was defined
                                if (parsingContext.rdfstar && parsingContext.annotationsBuffer[depth]) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal annotation inside a list", $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerArrayValue;
}();
module.exports.EntryHandlerArrayValue = $8160632489136aaf$var$EntryHandlerArrayValue;

});
parcelRegister("aalae", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $2ej16 = parcelRequire("2ej16");

var $dkxPt = parcelRequire("dkxPt");

var $gaVQ0 = parcelRequire("gaVQ0");
/**
 * Utility functions and methods.
 */ var $766b414e22cb612f$var$Util = /*#__PURE__*/ function() {
    function Util(options) {
        (0, $jGAMp._)(this, Util);
        this.parsingContext = options.parsingContext;
        this.dataFactory = options.dataFactory || new $2ej16.DataFactory();
        this.rdfFirst = this.dataFactory.namedNode(Util.RDF + 'first');
        this.rdfRest = this.dataFactory.namedNode(Util.RDF + 'rest');
        this.rdfNil = this.dataFactory.namedNode(Util.RDF + 'nil');
        this.rdfType = this.dataFactory.namedNode(Util.RDF + 'type');
        this.rdfJson = this.dataFactory.namedNode(Util.RDF + 'JSON');
    }
    (0, $byiyg._)(Util, [
        {
            key: "validateValueIndexes",
            value: /**
     * Make sure that @id-@index pairs are equal over all array values.
     * Reject otherwise.
     * @param {any[]} value An array value.
     * @return {Promise<void>} A promise rejecting if conflicts are present.
     */ function validateValueIndexes(value) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var indexHashes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, id, index, existingIndexValue;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (this.parsingContext.validateValueIndexes) {
                            indexHashes = {};
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = value[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    entry = _step.value;
                                    if (entry && (typeof entry === "undefined" ? "undefined" : (0, $3KZcf._)(entry)) === 'object') {
                                        id = entry['@id'];
                                        index = entry['@index'];
                                        if (id && index) {
                                            existingIndexValue = indexHashes[id];
                                            if (existingIndexValue && existingIndexValue !== index) throw new $auQ3n.ErrorCoded("Conflicting @index value for ".concat(id), $auQ3n.ERROR_CODES.CONFLICTING_INDEXES);
                                            indexHashes[id] = index;
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "valueToTerm",
            value: /**
     * Convert a given JSON value to an RDF term.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param value A JSON value.
     * @param {number} depth The depth the value is at.
     * @param {string[]} keys The path of keys.
     * @return {Promise<RDF.Term[]>} An RDF term array.
     */ function valueToTerm(context, key, value, depth, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var type, _, _1, _tmp, val, valueLanguage, valueDirection, valueType, valueIndex, subValue, typeTerm, listValue, _2, _3, _4, _5, graphContainerEntries, valueId, valueTerm, _6, _7, _8, _9, _tmp1, _10, _11, _12, _13, _tmp2, _14, _15, _16, _17, _tmp3;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Skip further processing if we have an @type: @json
                                if (Util.getContextValueType(context, key) === '@json') return [
                                    2,
                                    [
                                        this.dataFactory.literal(this.valueToJsonString(value), this.rdfJson)
                                    ]
                                ];
                                type = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
                                switch(type){
                                    case 'object':
                                        return [
                                            3,
                                            1
                                        ];
                                    case 'string':
                                        return [
                                            3,
                                            26
                                        ];
                                    case 'boolean':
                                        return [
                                            3,
                                            28
                                        ];
                                    case 'number':
                                        return [
                                            3,
                                            30
                                        ];
                                }
                                return [
                                    3,
                                    32
                                ];
                            case 1:
                                // Skip if we have a null or undefined object
                                if (value === null || value === undefined) return [
                                    2,
                                    []
                                ];
                                if (!Array.isArray(value)) return [
                                    3,
                                    3
                                ];
                                // We handle arrays at value level so we can emit earlier, so this is handled already when we get here.
                                // Empty context-based lists are emitted at this place, because our streaming algorithm doesn't detect those.
                                if ('@list' in Util.getContextValueContainer(context, key)) {
                                    if (value.length === 0) return [
                                        2,
                                        [
                                            this.rdfNil
                                        ]
                                    ];
                                    else return [
                                        2,
                                        this.parsingContext.idStack[depth + 1] || []
                                    ];
                                }
                                return [
                                    4,
                                    this.validateValueIndexes(value)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    []
                                ];
                            case 3:
                                return [
                                    4,
                                    this.getContextSelfOrPropertyScoped(context, key)
                                ];
                            case 4:
                                // Handle property-scoped contexts
                                context = _state.sent();
                                if (!('@context' in value)) return [
                                    3,
                                    7
                                ];
                                _1 = (_ = this.parsingContext).parseContext;
                                _tmp = [
                                    value['@context']
                                ];
                                return [
                                    4,
                                    this.parsingContext.getContext(keys, 0)
                                ];
                            case 5:
                                return [
                                    4,
                                    _1.apply(_, _tmp.concat([
                                        _state.sent().getContextRaw()
                                    ]))
                                ];
                            case 6:
                                context = _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    4,
                                    this.unaliasKeywords(value, keys, depth, context)
                                ];
                            case 8:
                                // In all other cases, we have a hash
                                value = _state.sent(); // Un-alias potential keywords in this hash
                                if (!('@value' in value)) return [
                                    3,
                                    11
                                ];
                                for(key in value){
                                    subValue = value[key];
                                    switch(key){
                                        case '@value':
                                            val = subValue;
                                            break;
                                        case '@language':
                                            valueLanguage = subValue;
                                            break;
                                        case '@direction':
                                            valueDirection = subValue;
                                            break;
                                        case '@type':
                                            valueType = subValue;
                                            break;
                                        case '@index':
                                            valueIndex = subValue;
                                            break;
                                        case '@annotation':
                                            break;
                                        default:
                                            throw new $auQ3n.ErrorCoded("Unknown value entry '".concat(key, "' in @value: ").concat(JSON.stringify(value)), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT);
                                    }
                                }
                                return [
                                    4,
                                    this.unaliasKeyword(valueType, keys, depth, true, context)
                                ];
                            case 9:
                                // Skip further processing if we have an @type: @json
                                if (_state.sent() === '@json') return [
                                    2,
                                    [
                                        this.dataFactory.literal(this.valueToJsonString(val), this.rdfJson)
                                    ]
                                ];
                                // Validate @value
                                if (val === null) return [
                                    2,
                                    []
                                ];
                                if ((typeof val === "undefined" ? "undefined" : (0, $3KZcf._)(val)) === 'object') throw new $auQ3n.ErrorCoded("The value of an '@value' can not be an object, got '".concat(JSON.stringify(val), "'"), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT_VALUE);
                                // Validate @index
                                if (this.parsingContext.validateValueIndexes && valueIndex && typeof valueIndex !== 'string') throw new $auQ3n.ErrorCoded("The value of an '@index' must be a string, got '".concat(JSON.stringify(valueIndex), "'"), $auQ3n.ERROR_CODES.INVALID_INDEX_VALUE);
                                // Validate @language and @direction
                                if (valueLanguage) {
                                    if (typeof val !== 'string') throw new $auQ3n.ErrorCoded("When an '@language' is set, the value of '@value' must be a string, got '".concat(JSON.stringify(val), "'"), $auQ3n.ERROR_CODES.INVALID_LANGUAGE_TAGGED_VALUE);
                                    if (!$auQ3n.ContextParser.validateLanguage(valueLanguage, this.parsingContext.strictValues, $auQ3n.ERROR_CODES.INVALID_LANGUAGE_TAGGED_STRING)) return [
                                        2,
                                        []
                                    ];
                                    // Language tags are always normalized to lowercase in 1.0.
                                    if (this.parsingContext.normalizeLanguageTags || this.parsingContext.activeProcessingMode === 1.0) valueLanguage = valueLanguage.toLowerCase();
                                }
                                if (valueDirection) {
                                    if (typeof val !== 'string') throw new Error("When an '@direction' is set, the value of '@value' must be a string, got '".concat(JSON.stringify(val), "'"));
                                    if (!$auQ3n.ContextParser.validateDirection(valueDirection, this.parsingContext.strictValues)) return [
                                        2,
                                        []
                                    ];
                                }
                                // Check @language and @direction
                                if (valueLanguage && valueDirection && this.parsingContext.rdfDirection) {
                                    if (valueType) throw new $auQ3n.ErrorCoded("Can not have '@language', '@direction' and '@type' in a value: '".concat(JSON.stringify(value), "'"), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT);
                                    return [
                                        2,
                                        this.nullableTermToArray(this.createLanguageDirectionLiteral(depth, val, valueLanguage, valueDirection))
                                    ];
                                } else if (valueLanguage) {
                                    if (valueType) throw new $auQ3n.ErrorCoded("Can not have both '@language' and '@type' in a value: '".concat(JSON.stringify(value), "'"), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT);
                                    return [
                                        2,
                                        [
                                            this.dataFactory.literal(val, valueLanguage)
                                        ]
                                    ];
                                } else if (valueDirection && this.parsingContext.rdfDirection) {
                                    if (valueType) throw new $auQ3n.ErrorCoded("Can not have both '@direction' and '@type' in a value: '".concat(JSON.stringify(value), "'"), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT);
                                    return [
                                        2,
                                        this.nullableTermToArray(this.createLanguageDirectionLiteral(depth, val, valueLanguage, valueDirection))
                                    ];
                                } else if (valueType) {
                                    if (typeof valueType !== 'string') throw new $auQ3n.ErrorCoded("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"), $auQ3n.ERROR_CODES.INVALID_TYPED_VALUE);
                                    typeTerm = this.createVocabOrBaseTerm(context, valueType);
                                    if (!typeTerm) throw new $auQ3n.ErrorCoded("Invalid '@type' value, got '".concat(JSON.stringify(valueType), "'"), $auQ3n.ERROR_CODES.INVALID_TYPED_VALUE);
                                    if (typeTerm.termType !== 'NamedNode') throw new $auQ3n.ErrorCoded("Illegal value type (".concat(typeTerm.termType, "): ").concat(valueType), $auQ3n.ERROR_CODES.INVALID_TYPED_VALUE);
                                    return [
                                        2,
                                        [
                                            this.dataFactory.literal(val, typeTerm)
                                        ]
                                    ];
                                }
                                return [
                                    4,
                                    this.valueToTerm(new $auQ3n.JsonLdContextNormalized({}), key, val, depth, keys)
                                ];
                            case 10:
                                // We don't pass the context, because context-based things like @language should be ignored
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 11:
                                if (!('@set' in value)) return [
                                    3,
                                    12
                                ];
                                // No other entries are allow in this value
                                if (Object.keys(value).length > 1) throw new $auQ3n.ErrorCoded("Found illegal neighbouring entries next to @set for key: '".concat(key, "'"), $auQ3n.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT);
                                // No need to do anything here, this is handled at the deeper level.
                                return [
                                    2,
                                    []
                                ];
                            case 12:
                                if (!('@list' in value)) return [
                                    3,
                                    17
                                ];
                                // No other entries are allowed in this value
                                if (Object.keys(value).length > 1) throw new $auQ3n.ErrorCoded("Found illegal neighbouring entries next to @list for key: '".concat(key, "'"), $auQ3n.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT);
                                listValue = value["@list"];
                                if (!Array.isArray(listValue)) return [
                                    3,
                                    13
                                ];
                                if (listValue.length === 0) return [
                                    2,
                                    [
                                        this.rdfNil
                                    ]
                                ];
                                else return [
                                    2,
                                    this.parsingContext.idStack[depth + 1] || []
                                ];
                                return [
                                    3,
                                    16
                                ];
                            case 13:
                                _3 = (_2 = this).valueToTerm;
                                return [
                                    4,
                                    this.parsingContext.getContext(keys)
                                ];
                            case 14:
                                return [
                                    4,
                                    _3.apply(_2, [
                                        _state.sent(),
                                        key,
                                        listValue,
                                        depth - 1,
                                        keys.slice(0, -1)
                                    ])
                                ];
                            case 15:
                                // We only have a single list element here, so emit this directly as single element
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 16:
                                return [
                                    3,
                                    26
                                ];
                            case 17:
                                if (!('@reverse' in value && typeof value['@reverse'] === 'boolean')) return [
                                    3,
                                    18
                                ];
                                // We handle reverse properties at value level so we can emit earlier,
                                // so this is handled already when we get here.
                                return [
                                    2,
                                    []
                                ];
                            case 18:
                                _4 = '@graph';
                                _5 = Util.getContextValueContainer;
                                return [
                                    4,
                                    this.parsingContext.getContext(keys)
                                ];
                            case 19:
                                if (!(_4 in _5.apply(Util, [
                                    _state.sent(),
                                    key
                                ]))) return [
                                    3,
                                    20
                                ];
                                // We are processing a graph container
                                graphContainerEntries = this.parsingContext.graphContainerTermStack[depth + 1];
                                return [
                                    2,
                                    graphContainerEntries ? Object.values(graphContainerEntries) : [
                                        this.dataFactory.blankNode()
                                    ]
                                ];
                            case 20:
                                if (!("@id" in value)) return [
                                    3,
                                    25
                                ];
                                if (!(Object.keys(value).length > 1)) return [
                                    3,
                                    22
                                ];
                                return [
                                    4,
                                    this.parsingContext.getContext(keys, 0)
                                ];
                            case 21:
                                context = _state.sent();
                                _state.label = 22;
                            case 22:
                                if (!('@context' in value)) return [
                                    3,
                                    24
                                ];
                                return [
                                    4,
                                    this.parsingContext.parseContext(value['@context'], context.getContextRaw())
                                ];
                            case 23:
                                context = _state.sent();
                                _state.label = 24;
                            case 24:
                                if (value["@type"] === '@vocab') return [
                                    2,
                                    this.nullableTermToArray(this.createVocabOrBaseTerm(context, value["@id"]))
                                ];
                                else {
                                    valueId = value["@id"];
                                    ;
                                    if ((typeof valueId === "undefined" ? "undefined" : (0, $3KZcf._)(valueId)) === 'object') {
                                        if (this.parsingContext.rdfstar) valueTerm = this.parsingContext.idStack[depth + 1][0];
                                        else throw new $auQ3n.ErrorCoded("Found illegal @id '".concat(value, "'"), $auQ3n.ERROR_CODES.INVALID_ID_VALUE);
                                    } else valueTerm = this.resourceToTerm(context, valueId);
                                    return [
                                        2,
                                        this.nullableTermToArray(valueTerm)
                                    ];
                                }
                                return [
                                    3,
                                    26
                                ];
                            case 25:
                                // Only make a blank node if at least one triple was emitted at the value's level.
                                if (this.parsingContext.emittedStack[depth + 1] || value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && Object.keys(value).length === 0) return [
                                    2,
                                    this.parsingContext.idStack[depth + 1] || (this.parsingContext.idStack[depth + 1] = [
                                        this.dataFactory.blankNode()
                                    ])
                                ];
                                else return [
                                    2,
                                    []
                                ];
                                _state.label = 26;
                            case 26:
                                _7 = (_6 = this).nullableTermToArray;
                                _9 = (_8 = this).stringValueToTerm;
                                _tmp1 = [
                                    depth
                                ];
                                return [
                                    4,
                                    this.getContextSelfOrPropertyScoped(context, key)
                                ];
                            case 27:
                                return [
                                    2,
                                    _7.apply(_6, [
                                        _9.apply(_8, _tmp1.concat([
                                            _state.sent(),
                                            key,
                                            value,
                                            null
                                        ]))
                                    ])
                                ];
                            case 28:
                                _11 = (_10 = this).nullableTermToArray;
                                _13 = (_12 = this).stringValueToTerm;
                                _tmp2 = [
                                    depth
                                ];
                                return [
                                    4,
                                    this.getContextSelfOrPropertyScoped(context, key)
                                ];
                            case 29:
                                return [
                                    2,
                                    _11.apply(_10, [
                                        _13.apply(_12, _tmp2.concat([
                                            _state.sent(),
                                            key,
                                            Boolean(value).toString(),
                                            this.dataFactory.namedNode(Util.XSD_BOOLEAN)
                                        ]))
                                    ])
                                ];
                            case 30:
                                _15 = (_14 = this).nullableTermToArray;
                                _17 = (_16 = this).stringValueToTerm;
                                _tmp3 = [
                                    depth
                                ];
                                return [
                                    4,
                                    this.getContextSelfOrPropertyScoped(context, key)
                                ];
                            case 31:
                                return [
                                    2,
                                    _15.apply(_14, [
                                        _17.apply(_16, _tmp3.concat([
                                            _state.sent(),
                                            key,
                                            value,
                                            this.dataFactory.namedNode(value % 1 === 0 && value < 1e21 ? Util.XSD_INTEGER : Util.XSD_DOUBLE)
                                        ]))
                                    ])
                                ];
                            case 32:
                                this.parsingContext.emitError(new Error("Could not determine the RDF type of a ".concat(type)));
                                return [
                                    2,
                                    []
                                ];
                            case 33:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getContextSelfOrPropertyScoped",
            value: /**
     * If the context defines a property-scoped context for the given key,
     * that context will be returned.
     * Otherwise, the given context will be returned as-is.
     *
     * This should be used for valueToTerm cases that are not objects.
     * @param context A context.
     * @param key A JSON key.
     */ function getContextSelfOrPropertyScoped(context, key) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var contextKeyEntry;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contextKeyEntry = context.getContextRaw()[key];
                                if (!(contextKeyEntry && (typeof contextKeyEntry === "undefined" ? "undefined" : (0, $3KZcf._)(contextKeyEntry)) === 'object' && '@context' in contextKeyEntry)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.parsingContext.parseContext(contextKeyEntry, context.getContextRaw(), true)
                                ];
                            case 1:
                                context = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    context
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * If the given term is null, return an empty array, otherwise return an array with the single given term.
     * @param term A term.
     */ key: "nullableTermToArray",
            value: function nullableTermToArray(term) {
                return term ? [
                    term
                ] : [];
            }
        },
        {
            /**
     * Convert a given JSON key to an RDF predicate term,
     * based on @vocab.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node.
     */ key: "predicateToTerm",
            value: function predicateToTerm(context, key) {
                var expanded = context.expandTerm(key, true, this.parsingContext.getExpandOptions());
                // Immediately return if the predicate was disabled in the context
                if (!expanded) return null;
                // Check if the predicate is a blank node
                if (expanded[0] === '_' && expanded[1] === ':') {
                    if (this.parsingContext.produceGeneralizedRdf) return this.dataFactory.blankNode(expanded.substr(2));
                    else return null;
                }
                // Check if the predicate is a valid IRI
                if (Util.isValidIri(expanded)) return this.dataFactory.namedNode(expanded);
                else {
                    if (expanded && this.parsingContext.strictValues) this.parsingContext.emitError(new $auQ3n.ErrorCoded("Invalid predicate IRI: ".concat(expanded), $auQ3n.ERROR_CODES.INVALID_IRI_MAPPING));
                    else return null;
                }
                return null;
            }
        },
        {
            /**
     * Convert a given JSON key to an RDF resource term or blank node,
     * based on @base.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */ key: "resourceToTerm",
            value: function resourceToTerm(context, key) {
                if (key.startsWith('_:')) return this.dataFactory.blankNode(key.substr(2));
                var iri = context.expandTerm(key, false, this.parsingContext.getExpandOptions());
                if (!Util.isValidIri(iri)) {
                    if (iri && this.parsingContext.strictValues) this.parsingContext.emitError(new Error("Invalid resource IRI: ".concat(iri)));
                    else return null;
                }
                return this.dataFactory.namedNode(iri);
            }
        },
        {
            /**
     * Convert a given JSON key to an RDF resource term.
     * It will do this based on the @vocab,
     * and fallback to @base.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */ key: "createVocabOrBaseTerm",
            value: function createVocabOrBaseTerm(context, key) {
                if (key.startsWith('_:')) return this.dataFactory.blankNode(key.substr(2));
                var expandOptions = this.parsingContext.getExpandOptions();
                var expanded = context.expandTerm(key, true, expandOptions);
                if (expanded === key) expanded = context.expandTerm(key, false, expandOptions);
                if (!Util.isValidIri(expanded)) {
                    if (expanded && this.parsingContext.strictValues && !expanded.startsWith('@')) this.parsingContext.emitError(new Error("Invalid term IRI: ".concat(expanded)));
                    else return null;
                }
                return this.dataFactory.namedNode(expanded);
            }
        },
        {
            /**
     * Ensure that the given value becomes a string.
     * @param {string | number} value A string or number.
     * @param {NamedNode} datatype The intended datatype.
     * @return {string} The returned string.
     */ key: "intToString",
            value: function intToString(value, datatype) {
                if (typeof value === 'number') {
                    if (Number.isFinite(value)) {
                        var isInteger = value % 1 === 0;
                        if (isInteger && (!datatype || datatype.value !== Util.XSD_DOUBLE)) return Number(value).toString();
                        else return value.toExponential(15).replace(/(\d)0*e\+?/, '$1E');
                    } else return value > 0 ? 'INF' : '-INF';
                } else return value;
            }
        },
        {
            /**
     * Convert a given JSON string value to an RDF term.
     * @param {number} depth The current stack depth.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param {string} value A JSON value.
     * @param {NamedNode} defaultDatatype The default datatype for the given value.
     * @return {RDF.Term} An RDF term or null.
     */ key: "stringValueToTerm",
            value: function stringValueToTerm(depth, context, key, value, defaultDatatype) {
                // Check the datatype from the context
                var contextType = Util.getContextValueType(context, key);
                if (contextType) {
                    if (contextType === '@id') {
                        if (!defaultDatatype) return this.resourceToTerm(context, this.intToString(value, defaultDatatype));
                    } else if (contextType === '@vocab') {
                        if (!defaultDatatype) return this.createVocabOrBaseTerm(context, this.intToString(value, defaultDatatype));
                    } else defaultDatatype = this.dataFactory.namedNode(contextType);
                }
                // If we don't find such a datatype, check the language from the context
                if (!defaultDatatype) {
                    var contextLanguage = Util.getContextValueLanguage(context, key);
                    var contextDirection = Util.getContextValueDirection(context, key);
                    if (contextDirection && this.parsingContext.rdfDirection) return this.createLanguageDirectionLiteral(depth, this.intToString(value, defaultDatatype), contextLanguage, contextDirection);
                    else return this.dataFactory.literal(this.intToString(value, defaultDatatype), contextLanguage);
                }
                // If all else fails, make a literal based on the default content type
                return this.dataFactory.literal(this.intToString(value, defaultDatatype), defaultDatatype);
            }
        },
        {
            /**
     * Create a literal for the given value with the given language and direction.
     * Auxiliary quads may be emitted.
     * @param {number} depth The current stack depth.
     * @param {string} value A string value.
     * @param {string} language A language tag.
     * @param {string} direction A direction.
     * @return {Term} An RDF term.
     */ key: "createLanguageDirectionLiteral",
            value: function createLanguageDirectionLiteral(depth, value, language, direction) {
                if (this.parsingContext.rdfDirection === 'i18n-datatype') {
                    // Create a datatyped literal, by encoding the language and direction into https://www.w3.org/ns/i18n#.
                    if (!language) language = '';
                    return this.dataFactory.literal(value, this.dataFactory.namedNode("https://www.w3.org/ns/i18n#".concat(language, "_").concat(direction)));
                } else {
                    // Reify the literal.
                    var valueNode = this.dataFactory.blankNode();
                    var graph = this.getDefaultGraph();
                    this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode(Util.RDF + 'value'), this.dataFactory.literal(value), graph));
                    if (language) this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode(Util.RDF + 'language'), this.dataFactory.literal(language), graph));
                    this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode(Util.RDF + 'direction'), this.dataFactory.literal(direction), graph));
                    return valueNode;
                }
            }
        },
        {
            /**
     * Stringify the given JSON object to a canonical JSON string.
     * @param value Any valid JSON value.
     * @return {string} A canonical JSON string.
     */ key: "valueToJsonString",
            value: function valueToJsonString(value) {
                return $gaVQ0(value);
            }
        },
        {
            key: "unaliasKeyword",
            value: /**
     * If the key is not a keyword, try to check if it is an alias for a keyword,
     * and if so, un-alias it.
     * @param {string} key A key, can be falsy.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth to
     * @param {boolean} disableCache If the cache should be disabled
     * @param {JsonLdContextNormalized} context A context to unalias with,
     *                                           will fallback to retrieving the context for the given keys.
     * @return {Promise<string>} A promise resolving to the key itself, or another key.
     */ function unaliasKeyword(key, keys, depth, disableCache, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cachedUnaliasedKeyword, _tmp, unliased;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Numbers can not be an alias
                                if (Number.isInteger(key)) return [
                                    2,
                                    key
                                ];
                                // Try to grab from cache if it was already un-aliased before.
                                if (!disableCache) {
                                    cachedUnaliasedKeyword = this.parsingContext.unaliasedKeywordCacheStack[depth];
                                    if (cachedUnaliasedKeyword) return [
                                        2,
                                        cachedUnaliasedKeyword
                                    ];
                                }
                                if (!!$auQ3n.Util.isPotentialKeyword(key)) return [
                                    3,
                                    3
                                ];
                                _tmp = context;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.parsingContext.getContext(keys)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                context = _tmp;
                                unliased = context.getContextRaw()[key];
                                if (unliased && (typeof unliased === "undefined" ? "undefined" : (0, $3KZcf._)(unliased)) === 'object') unliased = unliased['@id'];
                                if ($auQ3n.Util.isValidKeyword(unliased)) key = unliased;
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    disableCache ? key : this.parsingContext.unaliasedKeywordCacheStack[depth] = key
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "unaliasKeywordParent",
            value: /**
     * Unalias the keyword of the parent.
     * This adds a safety check if no parent exist.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @return {Promise<any>} A promise resolving to the parent key, or another key.
     */ function unaliasKeywordParent(keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.unaliasKeyword(depth > 0 && keys[depth - 1], keys, depth - 1)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "unaliasKeywords",
            value: /**
     * Un-alias all keywords in the given hash.
     * @param {{[p: string]: any}} hash A hash object.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth.
     * @param {JsonLdContextNormalized} context A context to unalias with,
     *                                           will fallback to retrieving the context for the given keys.
     * @return {Promise<{[p: string]: any}>} A promise resolving to the new hash.
     */ function unaliasKeywords(hash, keys, depth, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var newHash, _tmp, _tmp1, _i, key;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                newHash = {};
                                _tmp = [];
                                for(_tmp1 in hash)_tmp.push(_tmp1);
                                _i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(_i < _tmp.length)) return [
                                    3,
                                    4
                                ];
                                key = _tmp[_i];
                                return [
                                    4,
                                    this.unaliasKeyword(key, keys, depth + 1, true, context)
                                ];
                            case 2:
                                newHash[_state.sent()] = hash[key];
                                _state.label = 3;
                            case 3:
                                _i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    newHash
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "isLiteral",
            value: /**
     * Check if we are processing a literal (including JSON literals) at the given depth.
     * This will also check higher levels,
     * because if a parent is a literal,
     * then the deeper levels are definitely a literal as well.
     * @param {any[]} keys The keys.
     * @param {number} depth The depth.
     * @return {boolean} If we are processing a literal.
     */ function isLiteral(keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var i;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = depth;
                                _state.label = 1;
                            case 1:
                                if (!(i >= 0)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.unaliasKeyword(keys[i], keys, i)
                                ];
                            case 2:
                                if (_state.sent() === '@annotation') // Literals may have annotations, which require processing of inner nodes.
                                return [
                                    2,
                                    false
                                ];
                                if (this.parsingContext.literalStack[i] || this.parsingContext.jsonLiteralStack[i]) return [
                                    2,
                                    true
                                ];
                                _state.label = 3;
                            case 3:
                                i--;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getDepthOffsetGraph",
            value: /**
     * Check how many parents should be skipped for checking the @graph for the given node.
     *
     * @param {number} depth The depth of the node.
     * @param {any[]} keys An array of keys.
     * @return {number} The graph depth offset.
     */ function getDepthOffsetGraph(depth, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var i, containers;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = depth - 1;
                                _state.label = 1;
                            case 1:
                                if (!(i > 0)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.unaliasKeyword(keys[i], keys, i)
                                ];
                            case 2:
                                if (!(_state.sent() === '@graph')) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    $dkxPt.EntryHandlerContainer.getContainerHandler(this.parsingContext, keys, i)
                                ];
                            case 3:
                                containers = _state.sent().containers;
                                if ($dkxPt.EntryHandlerContainer.isComplexGraphContainer(containers)) return [
                                    2,
                                    -1
                                ];
                                return [
                                    2,
                                    depth - i - 1
                                ];
                            case 4:
                                i--;
                                return [
                                    3,
                                    1
                                ];
                            case 5:
                                return [
                                    2,
                                    -1
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Check if the given subject is of a valid type.
     * This should be called when applying @reverse'd properties.
     * @param {Term} subject A subject.
     */ key: "validateReverseSubject",
            value: function validateReverseSubject(subject) {
                if (subject.termType === 'Literal') throw new $auQ3n.ErrorCoded("Found illegal literal in subject position: ".concat(subject.value), $auQ3n.ERROR_CODES.INVALID_REVERSE_PROPERTY_VALUE);
            }
        },
        {
            /**
     * Get the default graph.
     * @return {Term} An RDF term.
     */ key: "getDefaultGraph",
            value: function getDefaultGraph() {
                return this.parsingContext.defaultGraph || this.dataFactory.defaultGraph();
            }
        },
        {
            key: "getGraphContainerValue",
            value: /**
     * Get the current graph, while taking into account a graph that can be defined via @container: @graph.
     * If not within a graph container, the default graph will be returned.
     * @param keys The current keys.
     * @param depth The current depth.
     */ function getGraphContainerValue(keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var graph, _ref, containers, depthContainer, graphContainerIndex, entry, graphId, keyUnaliased, _, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Default to default graph
                                graph = this.getDefaultGraph();
                                return [
                                    4,
                                    $dkxPt.EntryHandlerContainer.getContainerHandler(this.parsingContext, keys, depth)
                                ];
                            case 1:
                                _ref = _state.sent(), containers = _ref.containers, depthContainer = _ref.depth;
                                if (!('@graph' in containers)) return [
                                    3,
                                    6
                                ];
                                // Get the graph from the stack.
                                graphContainerIndex = $dkxPt.EntryHandlerContainer.getContainerGraphIndex(containers, depthContainer, keys);
                                entry = this.parsingContext.graphContainerTermStack[depthContainer];
                                graph = entry ? entry[graphContainerIndex] : null;
                                if (!!graph) return [
                                    3,
                                    6
                                ];
                                graphId = null;
                                if (!('@id' in containers)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.getContainerKey(keys[depthContainer], keys, depthContainer)
                                ];
                            case 2:
                                keyUnaliased = _state.sent();
                                if (!(keyUnaliased !== null)) return [
                                    3,
                                    5
                                ];
                                _1 = (_ = this).resourceToTerm;
                                return [
                                    4,
                                    this.parsingContext.getContext(keys)
                                ];
                            case 3:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent(),
                                        keyUnaliased
                                    ])
                                ];
                            case 4:
                                graphId = _state.sent();
                                _state.label = 5;
                            case 5:
                                if (!graphId) graphId = this.dataFactory.blankNode();
                                if (!this.parsingContext.graphContainerTermStack[depthContainer]) this.parsingContext.graphContainerTermStack[depthContainer] = {};
                                graph = this.parsingContext.graphContainerTermStack[depthContainer][graphContainerIndex] = graphId;
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    graph
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getPropertiesDepth",
            value: /**
     * Get the properties depth for retrieving properties.
     *
     * Typically, the properties depth will be identical to the given depth.
     *
     * The following exceptions apply:
     * * When the parent is @reverse, the depth is decremented by one.
     * * When @nest parents are found, the depth is decremented by the number of @nest parents.
     * If in combination with the exceptions above an intermediary array is discovered,
     * the depth is also decremented by this number of arrays.
     *
     * @param keys The current key chain.
     * @param depth The current depth.
     */ function getPropertiesDepth(keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var lastValidDepth, i, parentKey;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                lastValidDepth = depth;
                                i = depth - 1;
                                _state.label = 1;
                            case 1:
                                if (!(i > 0)) return [
                                    3,
                                    4
                                ];
                                if (!(typeof keys[i] !== 'number')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.unaliasKeyword(keys[i], keys, i)
                                ];
                            case 2:
                                parentKey = _state.sent();
                                if (parentKey === '@reverse') return [
                                    2,
                                    i
                                ];
                                else if (parentKey === '@nest') lastValidDepth = i;
                                else return [
                                    2,
                                    lastValidDepth
                                ];
                                _state.label = 3;
                            case 3:
                                i--;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    lastValidDepth
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getContainerKey",
            value: /**
     * Get the key for the current container entry.
     * @param key A key, can be falsy.
     * @param keys The key chain.
     * @param depth The current depth to get the key from.
     * @return Promise resolving to the key.
     *         Null will be returned for @none entries, with aliasing taken into account.
     */ function getContainerKey(key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var keyUnaliased;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.unaliasKeyword(key, keys, depth)
                                ];
                            case 1:
                                keyUnaliased = _state.sent();
                                return [
                                    2,
                                    keyUnaliased === '@none' ? null : keyUnaliased
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Check if no reverse properties are present in embedded nodes.
     * @param key The current key.
     * @param reverse If a reverse property is active.
     * @param isEmbedded If we're in an embedded node.
     */ key: "validateReverseInEmbeddedNode",
            value: function validateReverseInEmbeddedNode(key, reverse, isEmbedded) {
                if (isEmbedded && reverse && !this.parsingContext.rdfstarReverseInEmbedded) throw new $auQ3n.ErrorCoded("Illegal reverse property in embedded node in ".concat(key), $auQ3n.ERROR_CODES.INVALID_EMBEDDED_NODE);
            }
        },
        {
            /**
     * Emit a quad, with checks.
     * @param depth The current depth.
     * @param subject S
     * @param predicate P
     * @param object O
     * @param graph G
     * @param reverse If a reverse property is active.
     * @param isEmbedded If we're in an embedded node.
     */ key: "emitQuadChecked",
            value: function emitQuadChecked(depth, subject, predicate, object, graph, reverse, isEmbedded) {
                // Create a quad
                var quad;
                if (reverse) {
                    this.validateReverseSubject(object);
                    quad = this.dataFactory.quad(object, predicate, subject, graph);
                } else quad = this.dataFactory.quad(subject, predicate, object, graph);
                // Emit the quad, unless it was created in an embedded node
                if (isEmbedded) {
                    // Embedded nodes don't inherit the active graph
                    if (quad.graph.termType !== 'DefaultGraph') quad = this.dataFactory.quad(quad.subject, quad.predicate, quad.object);
                    // Multiple embedded nodes are not allowed
                    if (this.parsingContext.idStack[depth - 1]) throw new $auQ3n.ErrorCoded("Illegal multiple properties in an embedded node", $auQ3n.ERROR_CODES.INVALID_EMBEDDED_NODE);
                    this.parsingContext.idStack[depth - 1] = [
                        quad
                    ];
                } else this.parsingContext.emitQuad(depth, quad);
                // Flush annotations
                var annotationsBuffer = this.parsingContext.annotationsBuffer[depth];
                if (annotationsBuffer) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = annotationsBuffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var annotation = _step.value;
                            this.emitAnnotation(depth, quad, annotation);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    delete this.parsingContext.annotationsBuffer[depth];
                }
            }
        },
        {
            // This is a separate function to enable recursion
            key: "emitAnnotation",
            value: function emitAnnotation(depth, quad, annotation) {
                // Construct annotation quad
                var annotationQuad;
                if (annotation.reverse) {
                    this.validateReverseSubject(annotation.object);
                    annotationQuad = this.dataFactory.quad(annotation.object, annotation.predicate, quad);
                } else annotationQuad = this.dataFactory.quad(quad, annotation.predicate, annotation.object);
                // Emit annotated quad
                this.parsingContext.emitQuad(depth, annotationQuad);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Also emit nested annotations
                    for(var _iterator = annotation.nestedAnnotations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var nestedAnnotation = _step.value;
                        this.emitAnnotation(depth, annotationQuad, nestedAnnotation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "getContextValue",
            value: /**
     * Helper function to get the value of a context entry,
     * or fallback to a certain value.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} contextKey A pre-defined JSON-LD key in context entries.
     * @param {string} key A context entry key.
     * @param {string} fallback A fallback value for when the given contextKey
     *                          could not be found in the value with the given key.
     * @return {string} The value of the given contextKey in the entry behind key in the given context,
     *                  or the given fallback value.
     */ function getContextValue(context, contextKey, key, fallback) {
                var entry = context.getContextRaw()[key];
                if (!entry) return fallback;
                var type = entry[contextKey];
                return type === undefined ? fallback : type;
            }
        },
        {
            key: "getContextValueContainer",
            value: /**
     * Get the container type of the given key in the context.
     *
     * Should any context-scoping bugs should occur related to this in the future,
     * it may be required to increase the offset from the depth at which the context is retrieved by one (to 2).
     * This is because containers act 2 levels deep.
     *
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The container type.
     */ function getContextValueContainer(context, key) {
                return Util.getContextValue(context, '@container', key, {
                    '@set': true
                });
            }
        },
        {
            key: "getContextValueType",
            value: /**
     * Get the value type of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ function getContextValueType(context, key) {
                var valueType = Util.getContextValue(context, '@type', key, null);
                if (valueType === '@none') return null;
                return valueType;
            }
        },
        {
            key: "getContextValueLanguage",
            value: /**
     * Get the language of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ function getContextValueLanguage(context, key) {
                return Util.getContextValue(context, '@language', key, context.getContextRaw()['@language'] || null);
            }
        },
        {
            key: "getContextValueDirection",
            value: /**
     * Get the direction of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ function getContextValueDirection(context, key) {
                return Util.getContextValue(context, '@direction', key, context.getContextRaw()['@direction'] || null);
            }
        },
        {
            key: "isContextValueReverse",
            value: /**
     * Check if the given key in the context is a reversed property.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {boolean} If the context value has a @reverse key.
     */ function isContextValueReverse(context, key) {
                return !!Util.getContextValue(context, '@reverse', key, null);
            }
        },
        {
            key: "getContextValueIndex",
            value: /**
     * Get the @index of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The index.
     */ function getContextValueIndex(context, key) {
                return Util.getContextValue(context, '@index', key, context.getContextRaw()['@index'] || null);
            }
        },
        {
            key: "isPropertyReverse",
            value: /**
     * Check if the given key refers to a reversed property.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The property key.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property must be reversed.
     */ function isPropertyReverse(context, key, parentKey) {
                // '!==' is needed because reversed properties in a @reverse container should cancel each other out.
                return parentKey === '@reverse' !== Util.isContextValueReverse(context, key);
            }
        },
        {
            key: "isPropertyInEmbeddedNode",
            value: /**
     * Check if the given key exists inside an embedded node as direct child.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property is embedded.
     */ function isPropertyInEmbeddedNode(parentKey) {
                return parentKey === '@id';
            }
        },
        {
            key: "isPropertyInAnnotationObject",
            value: /**
     * Check if the given key exists inside an annotation object as direct child.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property is an annotation.
     */ function isPropertyInAnnotationObject(parentKey) {
                return parentKey === '@annotation';
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return iri !== null && $auQ3n.Util.isValidIri(iri);
            }
        },
        {
            key: "isPrefixArray",
            value: /**
     * Check if the given first array (needle) is a prefix of the given second array (haystack).
     * @param needle An array to check if it is a prefix.
     * @param haystack An array to look in.
     */ function isPrefixArray(needle, haystack) {
                if (needle.length > haystack.length) return false;
                for(var i = 0; i < needle.length; i++){
                    if (needle[i] !== haystack[i]) return false;
                }
                return true;
            }
        }
    ]);
    return Util;
}();
$766b414e22cb612f$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$766b414e22cb612f$var$Util.XSD_BOOLEAN = $766b414e22cb612f$var$Util.XSD + 'boolean';
$766b414e22cb612f$var$Util.XSD_INTEGER = $766b414e22cb612f$var$Util.XSD + 'integer';
$766b414e22cb612f$var$Util.XSD_DOUBLE = $766b414e22cb612f$var$Util.XSD + 'double';
$766b414e22cb612f$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
module.exports.Util = $766b414e22cb612f$var$Util;

});
parcelRegister("dkxPt", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerContainer = void 0;

var $6WvAL = parcelRequire("6WvAL");

var $7FUc0 = parcelRequire("7FUc0");

var $eoLCV = parcelRequire("eoLCV");

var $hQ7XJ = parcelRequire("hQ7XJ");

var $aalae = parcelRequire("aalae");
/**
 * Handles values that are part of a container type (like @index),
 * as specified by {@link IContainerHandler}.
 */ var $9b476262688e506a$var$EntryHandlerContainer = /*#__PURE__*/ function() {
    function EntryHandlerContainer() {
        (0, $jGAMp._)(this, EntryHandlerContainer);
    }
    (0, $byiyg._)(EntryHandlerContainer, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return false;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.test(parsingContext, util, null, keys, depth)
                                ];
                            case 1:
                                return [
                                    2,
                                    !!_state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var containers, _, _1, containerName;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = $aalae.Util).getContextValueContainer;
                                return [
                                    4,
                                    parsingContext.getContext(keys, 2)
                                ];
                            case 1:
                                containers = _1.apply(_, [
                                    _state.sent(),
                                    keys[depth - 1]
                                ]);
                                for(var containerName in EntryHandlerContainer.CONTAINER_HANDLERS){
                                    if (containers[containerName]) return [
                                        2,
                                        {
                                            containers: containers,
                                            handler: EntryHandlerContainer.CONTAINER_HANDLERS[containerName]
                                        }
                                    ];
                                }
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth, testResult) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            testResult.handler.handle(testResult.containers, parsingContext, util, keys, value, depth)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "isSimpleGraphContainer",
            value: /**
     * Check fit the given container is a simple @graph container.
     * Concretely, it will check if no @index or @id is active as well.
     * @param containers A container hash.
     */ function isSimpleGraphContainer(containers) {
                return '@graph' in containers && ('@set' in containers && Object.keys(containers).length === 2 || Object.keys(containers).length === 1);
            }
        },
        {
            key: "isComplexGraphContainer",
            value: /**
     * Check fit the given container is a complex @graph container.
     * Concretely, it will check if @index or @id is active as well next to @graph.
     * @param containers A container hash.
     */ function isComplexGraphContainer(containers) {
                return '@graph' in containers && ('@set' in containers && Object.keys(containers).length > 2 || !('@set' in containers) && Object.keys(containers).length > 1);
            }
        },
        {
            key: "getContainerGraphIndex",
            value: /**
     * Create an graph container index that can be used for identifying a graph term inside the graphContainerTermStack.
     * @param containers The applicable containers.
     * @param depth The container depth.
     * @param keys The array of keys.
     * @return The graph index.
     */ function getContainerGraphIndex(containers, depth, keys) {
                var isSimpleGraphContainer = EntryHandlerContainer.isSimpleGraphContainer(containers);
                var index = '';
                for(var i = depth; i < keys.length; i++){
                    if (!isSimpleGraphContainer || typeof keys[i] === 'number') index += ':' + keys[i];
                    // Only allow a second 'real' key if in a non-simple graph container.
                    if (!isSimpleGraphContainer && typeof keys[i] !== 'number') isSimpleGraphContainer = true;
                }
                return index;
            }
        },
        {
            key: "getContainerHandler",
            value: /**
     * Return the applicable container type at the given depth.
     *
     * This will ignore any arrays in the key chain.
     *
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {any[]} keys The array of keys.
     * @param {number} depth The current depth.
     * @return {Promise<{ containers: {[typeName: string]: boolean}, depth: number, fallback: boolean }>}
     *          All applicable containers for the given depth,
     *          the `depth` of the container root (can change when arrays are in the key chain),
     *          and the `fallback` flag that indicates if the default container type was returned
     *            (i.e., no dedicated container type is defined).
     */ function getContainerHandler(parsingContext, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var fallback, checkGraphContainer, context, i, containersSelf, containersParent, graphContainer, containerHandleName;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fallback = {
                                    containers: {
                                        '@set': true
                                    },
                                    depth: depth,
                                    fallback: true
                                };
                                // A flag that is enabled when @graph container should be tested in next iteration
                                checkGraphContainer = false;
                                return [
                                    4,
                                    parsingContext.getContext(keys, 2)
                                ];
                            case 1:
                                context = _state.sent();
                                for(i = depth - 1; i >= 0; i--)if (typeof keys[i] !== 'number') {
                                    // @graph containers without any other types are one level less deep, and require special handling
                                    containersSelf = $aalae.Util.getContextValue(context, '@container', keys[i], false);
                                    if (containersSelf && EntryHandlerContainer.isSimpleGraphContainer(containersSelf)) return [
                                        2,
                                        {
                                            containers: containersSelf,
                                            depth: i + 1,
                                            fallback: false
                                        }
                                    ];
                                    containersParent = $aalae.Util.getContextValue(context, '@container', keys[i - 1], false);
                                    if (!containersParent) {
                                        if (checkGraphContainer) // Return false if we were already expecting a @graph-@id of @graph-@index container
                                        return [
                                            2,
                                            fallback
                                        ];
                                        // Check parent-parent, we may be in a @graph-@id of @graph-@index container, which have two levels
                                        checkGraphContainer = true;
                                    } else {
                                        // We had an invalid container next iteration, so we now have to check if we were in an @graph container
                                        graphContainer = '@graph' in containersParent;
                                        // We're in a regular container
                                        for(var containerHandleName in EntryHandlerContainer.CONTAINER_HANDLERS)if (containersParent[containerHandleName]) {
                                            if (graphContainer) {
                                                // Only accept graph containers if their combined handlers can handle them.
                                                if (EntryHandlerContainer.CONTAINER_HANDLERS[containerHandleName].canCombineWithGraph()) return [
                                                    2,
                                                    {
                                                        containers: containersParent,
                                                        depth: i,
                                                        fallback: false
                                                    }
                                                ];
                                                else return [
                                                    2,
                                                    fallback
                                                ];
                                            } else {
                                                // Only accept if we were not expecting a @graph-@id of @graph-@index container
                                                if (checkGraphContainer) return [
                                                    2,
                                                    fallback
                                                ];
                                                else return [
                                                    2,
                                                    {
                                                        containers: containersParent,
                                                        depth: i,
                                                        fallback: false
                                                    }
                                                ];
                                            }
                                        }
                                        // Fail if no valid container handlers were found
                                        return [
                                            2,
                                            fallback
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    fallback
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isBufferableContainerHandler",
            value: /**
     * Check if we are handling a value at the given depth
     * that is part of something that should be handled as a container,
     * AND if this container should be buffered, so that it can be handled by a dedicated container handler.
     *
     * For instance, any container with @graph will NOT be buffered.
     *
     * This will ignore any arrays in the key chain.
     *
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {any[]} keys The array of keys.
     * @param {number} depth The current depth.
     * @return {Promise<boolean>} If we are in the scope of a container handler.
     */ function isBufferableContainerHandler(parsingContext, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var handler;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    EntryHandlerContainer.getContainerHandler(parsingContext, keys, depth)
                                ];
                            case 1:
                                handler = _state.sent();
                                return [
                                    2,
                                    !handler.fallback && !('@graph' in handler.containers)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerContainer;
}();
$9b476262688e506a$var$EntryHandlerContainer.CONTAINER_HANDLERS = {
    '@id': new $6WvAL.ContainerHandlerIdentifier(),
    '@index': new $7FUc0.ContainerHandlerIndex(),
    '@language': new $eoLCV.ContainerHandlerLanguage(),
    '@type': new $hQ7XJ.ContainerHandlerType()
};
module.exports.EntryHandlerContainer = $9b476262688e506a$var$EntryHandlerContainer;

});
parcelRegister("6WvAL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerIdentifier = void 0;
/**
 * Container handler for @id.
 *
 * It assumes that the current key is the identifier of the current value.
 * This will add this value to the parent node.
 */ var $50e0aa60d436f7f7$var$ContainerHandlerIdentifier = /*#__PURE__*/ function() {
    function ContainerHandlerIdentifier() {
        (0, $jGAMp._)(this, ContainerHandlerIdentifier);
    }
    (0, $byiyg._)(ContainerHandlerIdentifier, [
        {
            key: "canCombineWithGraph",
            value: function canCombineWithGraph() {
                return true;
            }
        },
        {
            key: "handle",
            value: function handle(containers, parsingContext, util, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var id, keyUnaliased, maybeId, _tmp, _, ids;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(parsingContext.emittedStack[depth + 1] && parsingContext.idStack[depth + 1])) return [
                                    3,
                                    1
                                ];
                                // Use the existing identifier
                                id = parsingContext.idStack[depth + 1][0];
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    util.getContainerKey(keys[depth], keys, depth)
                                ];
                            case 2:
                                keyUnaliased = _state.sent();
                                if (!(keyUnaliased !== null)) return [
                                    3,
                                    5
                                ];
                                _ = util.resourceToTerm;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 3:
                                return [
                                    4,
                                    _.apply(util, [
                                        _state.sent(),
                                        keys[depth]
                                    ])
                                ];
                            case 4:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _tmp = util.dataFactory.blankNode();
                                _state.label = 6;
                            case 6:
                                maybeId = _tmp;
                                // Do nothing if the id is invalid
                                if (!maybeId) {
                                    parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
                                    return [
                                        2
                                    ];
                                }
                                id = maybeId;
                                // Insert the id into the stack so that buffered children can make us of it.
                                parsingContext.idStack[depth + 1] = [
                                    id
                                ];
                                _state.label = 7;
                            case 7:
                                // Insert the id into the stack so that parents can make use of it.
                                // Insert it as an array because multiple id container entries may exist
                                ids = parsingContext.idStack[depth];
                                if (!ids) ids = parsingContext.idStack[depth] = [];
                                // Only insert the term if it does not exist yet in the array.
                                if (!ids.some(function(term) {
                                    return term.equals(id);
                                })) ids.push(id);
                                return [
                                    4,
                                    parsingContext.handlePendingContainerFlushBuffers()
                                ];
                            case 8:
                                // Flush any pending flush buffers
                                if (!_state.sent()) parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContainerHandlerIdentifier;
}();
module.exports.ContainerHandlerIdentifier = $50e0aa60d436f7f7$var$ContainerHandlerIdentifier;

});

parcelRegister("7FUc0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerIndex = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $5Torg = parcelRequire("5Torg");

var $aalae = parcelRequire("aalae");
/**
 * Container handler for @index.
 *
 * This will ignore the current key and add this entry to the parent node.
 */ var $5967f36e18a0b882$var$ContainerHandlerIndex = /*#__PURE__*/ function() {
    function ContainerHandlerIndex() {
        (0, $jGAMp._)(this, ContainerHandlerIndex);
    }
    (0, $byiyg._)(ContainerHandlerIndex, [
        {
            key: "canCombineWithGraph",
            value: function canCombineWithGraph() {
                return true;
            }
        },
        {
            key: "handle",
            value: function handle(containers, parsingContext, util, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var graphContainer, context, indexKey, indexPropertyRaw, id, indexProperty, indexValues, _, _tmp, _iteratorNormalCompletion, _didIteratorError, _iteratorError, graphId, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, indexValue, _iterator1, _step1, indexValue1, err, depthOffset;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!Array.isArray(value)) return [
                                    3,
                                    15
                                ];
                                graphContainer = '@graph' in containers;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                context = _state.sent();
                                indexKey = keys[depth - 1];
                                indexPropertyRaw = $aalae.Util.getContextValueIndex(context, indexKey);
                                if (!indexPropertyRaw) return [
                                    3,
                                    12
                                ];
                                // Validate the @index value
                                if ($auQ3n.Util.isPotentialKeyword(indexPropertyRaw)) throw new $auQ3n.ErrorCoded("Keywords can not be used as @index value, got: ".concat(indexPropertyRaw), $auQ3n.ERROR_CODES.INVALID_TERM_DEFINITION);
                                if (typeof indexPropertyRaw !== 'string') throw new $auQ3n.ErrorCoded("@index values must be strings, got: ".concat(indexPropertyRaw), $auQ3n.ERROR_CODES.INVALID_TERM_DEFINITION);
                                // When @index is used, values must be node values, unless @type: @id is defined in the context
                                if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object') {
                                    // Error if we don't have @type: @id
                                    if ($aalae.Util.getContextValueType(context, indexKey) !== '@id') throw new $auQ3n.ErrorCoded("Property-based index containers require nodes as values or strings with @type: @id, but got: ".concat(value), $auQ3n.ERROR_CODES.INVALID_VALUE_OBJECT);
                                    // Add an @id to the stack, so our expanded @index value can make use of it
                                    id = util.resourceToTerm(context, value);
                                    if (id) parsingContext.idStack[depth + 1] = [
                                        id
                                    ];
                                }
                                // Expand the @index value
                                indexProperty = util.createVocabOrBaseTerm(context, indexPropertyRaw);
                                if (!indexProperty) return [
                                    3,
                                    12
                                ];
                                _ = util.valueToTerm;
                                _tmp = [
                                    context,
                                    indexPropertyRaw
                                ];
                                return [
                                    4,
                                    util.getContainerKey(keys[depth], keys, depth)
                                ];
                            case 2:
                                return [
                                    4,
                                    _.apply(util, _tmp.concat([
                                        _state.sent(),
                                        depth,
                                        keys
                                    ]))
                                ];
                            case 3:
                                indexValues = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!graphContainer) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    util.getGraphContainerValue(keys, depth + 1)
                                ];
                            case 4:
                                graphId = _state.sent();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator = indexValues[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        indexValue = _step.value;
                                        parsingContext.emitQuad(depth, util.dataFactory.quad(graphId, indexProperty, indexValue, util.getDefaultGraph()));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    3,
                                    12
                                ];
                            case 5:
                                _state.trys.push([
                                    5,
                                    10,
                                    11,
                                    12
                                ]);
                                _iterator1 = indexValues[Symbol.iterator]();
                                _state.label = 6;
                            case 6:
                                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    9
                                ];
                                indexValue1 = _step1.value;
                                return [
                                    4,
                                    $5Torg.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth + 1, indexProperty, indexValue1, false, false, false)
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    6
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                depthOffset = graphContainer ? 2 : 1;
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, keys.length - depthOffset), value, depth - depthOffset, true)
                                ];
                            case 13:
                                _state.sent();
                                // Flush any pending flush buffers
                                return [
                                    4,
                                    parsingContext.handlePendingContainerFlushBuffers()
                                ];
                            case 14:
                                _state.sent();
                                _state.label = 15;
                            case 15:
                                parsingContext.emittedStack[depth] = false; // We have emitted a level higher
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContainerHandlerIndex;
}();
module.exports.ContainerHandlerIndex = $5967f36e18a0b882$var$ContainerHandlerIndex;

});
parcelRegister("5Torg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerPredicate = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $aalae = parcelRequire("aalae");
/**
 * Interprets keys as predicates.
 * The most common case in JSON-LD processing.
 */ var $44a50bd040f9864c$var$EntryHandlerPredicate = /*#__PURE__*/ function() {
    function EntryHandlerPredicate() {
        (0, $jGAMp._)(this, EntryHandlerPredicate);
    }
    (0, $byiyg._)(EntryHandlerPredicate, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return true;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var key, context, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                key = keys[depth];
                                if (!key) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                context = _state.sent();
                                _tmp = !parsingContext.jsonLiteralStack[depth];
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    util.predicateToTerm(context, keys[depth])
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                if (_tmp) {
                                    // If this valid predicate is of type @json, mark it so in the stack so that no deeper handling of nodes occurs.
                                    if ($aalae.Util.getContextValueType(context, key) === '@json') parsingContext.jsonLiteralStack[depth + 1] = true;
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            keys[depth]
                        ];
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth, testResult) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var keyOriginal, context, predicate, objects, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, object, parentKey, reverse, parentDepthOffset, isEmbedded, isAnnotation, listValueContainer, listPointer, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keyOriginal = keys[depth];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                context = _state.sent();
                                return [
                                    4,
                                    util.predicateToTerm(context, key)
                                ];
                            case 2:
                                predicate = _state.sent();
                                if (!predicate) return [
                                    3,
                                    15
                                ];
                                return [
                                    4,
                                    util.valueToTerm(context, key, value, depth, keys)
                                ];
                            case 3:
                                objects = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!objects.length) return [
                                    3,
                                    15
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    13,
                                    14,
                                    15
                                ]);
                                _iterator = objects[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    12
                                ];
                                object = _step.value;
                                return [
                                    4,
                                    util.unaliasKeywordParent(keys, depth)
                                ];
                            case 6:
                                parentKey = _state.sent();
                                reverse = $aalae.Util.isPropertyReverse(context, keyOriginal, parentKey);
                                parentDepthOffset = 0;
                                _state.label = 7;
                            case 7:
                                if (!(parentKey === '@reverse' || typeof parentKey === 'number')) return [
                                    3,
                                    9
                                ];
                                // Check parent of parent when checking while we're in an array or in @reverse
                                if (typeof parentKey === 'number') parentDepthOffset++;
                                else depth--;
                                return [
                                    4,
                                    util.unaliasKeywordParent(keys, depth - parentDepthOffset)
                                ];
                            case 8:
                                parentKey = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 9:
                                isEmbedded = $aalae.Util.isPropertyInEmbeddedNode(parentKey);
                                util.validateReverseInEmbeddedNode(key, reverse, isEmbedded);
                                isAnnotation = $aalae.Util.isPropertyInAnnotationObject(parentKey);
                                if (value) {
                                    // Special case if our term was defined as an @list, but does not occur in an array,
                                    // In that case we just emit it as an RDF list with a single element.
                                    listValueContainer = '@list' in $aalae.Util.getContextValueContainer(context, key);
                                    if (listValueContainer || value['@list']) {
                                        if ((listValueContainer && !Array.isArray(value) && !value['@list'] || value['@list'] && !Array.isArray(value['@list'])) && object !== util.rdfNil) {
                                            listPointer = util.dataFactory.blankNode();
                                            parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfRest, util.rdfNil, util.getDefaultGraph()));
                                            parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfFirst, object, util.getDefaultGraph()));
                                            object = listPointer;
                                        }
                                        // Lists are not allowed in @reverse'd properties
                                        if (reverse && !parsingContext.allowSubjectList) throw new $auQ3n.ErrorCoded("Found illegal list value in subject position at ".concat(key), $auQ3n.ERROR_CODES.INVALID_REVERSE_PROPERTY_VALUE);
                                    }
                                }
                                return [
                                    4,
                                    EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, predicate, object, reverse, isEmbedded, isAnnotation)
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 12:
                                return [
                                    3,
                                    15
                                ];
                            case 13:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "handlePredicateObject",
            value: /**
     * Handle the given predicate-object by either emitting it,
     * or by placing it in the appropriate stack for later emission when no @graph and/or @id has been defined.
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {Util} util A utility instance.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @param {Term} predicate The predicate.
     * @param {Term} object The object.
     * @param {boolean} reverse If the property is reversed.
     * @param {boolean} isEmbedded If the property exists in an embedded node as direct child.
     * @param {boolean} isAnnotation If the property exists in an annotation object.
     * @return {Promise<void>} A promise resolving when handling is done.
     */ function handlePredicateObject(parsingContext, util, keys, depth, predicate, object, reverse, isEmbedded, isAnnotation) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var depthProperties, depthOffsetGraph, depthPropertiesGraph, subjects, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, subject, atGraph, graphs, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, graph, graph1, err, i, annotationsBuffer, newAnnotation, i1, existingAnnotation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    util.getPropertiesDepth(keys, depth)
                                ];
                            case 1:
                                depthProperties = _state.sent();
                                return [
                                    4,
                                    util.getDepthOffsetGraph(depth, keys)
                                ];
                            case 2:
                                depthOffsetGraph = _state.sent();
                                depthPropertiesGraph = depth - depthOffsetGraph;
                                subjects = parsingContext.idStack[depthProperties];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!(subjects && !isAnnotation)) return [
                                    3,
                                    12
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = subjects[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                subject = _step.value;
                                // Check if we're in a @graph context
                                atGraph = depthOffsetGraph >= 0;
                                if (!atGraph) return [
                                    3,
                                    5
                                ];
                                graphs = parsingContext.idStack[depthPropertiesGraph - 1];
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (graphs) try {
                                    for(_iterator1 = graphs[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        graph = _step1.value;
                                        // Emit our quad if graph @id is known
                                        util.emitQuadChecked(depth, subject, predicate, object, graph, reverse, isEmbedded);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                else // Buffer our triple if graph @id is not known yet.
                                if (reverse) {
                                    util.validateReverseSubject(object);
                                    parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                                        subject: object,
                                        predicate: predicate,
                                        object: subject,
                                        isEmbedded: isEmbedded
                                    });
                                } else parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                                    subject: subject,
                                    predicate: predicate,
                                    object: object,
                                    isEmbedded: isEmbedded
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    util.getGraphContainerValue(keys, depthProperties)
                                ];
                            case 6:
                                graph1 = _state.sent();
                                util.emitQuadChecked(depth, subject, predicate, object, graph1, reverse, isEmbedded);
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    3,
                                    19
                                ];
                            case 12:
                                // Buffer until our @id becomes known, or we go up the stack
                                if (reverse) util.validateReverseSubject(object);
                                if (!isAnnotation) return [
                                    3,
                                    18
                                ];
                                if (!parsingContext.rdfstar) return [
                                    3,
                                    17
                                ];
                                // Error if an @id was defined
                                if (parsingContext.idStack[depth]) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal @id inside an annotation: ".concat(parsingContext.idStack[depth][0].value), $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                                i = 0;
                                _state.label = 13;
                            case 13:
                                if (!(i < depth)) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    util.unaliasKeyword(keys[i], keys, i)
                                ];
                            case 14:
                                if (_state.sent() === '@id') parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal annotation inside an embedded node", $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                                _state.label = 15;
                            case 15:
                                i++;
                                return [
                                    3,
                                    13
                                ];
                            case 16:
                                // Store new annotation in the buffer
                                annotationsBuffer = parsingContext.getAnnotationsBufferSafe(depthProperties);
                                newAnnotation = {
                                    predicate: predicate,
                                    object: object,
                                    reverse: reverse,
                                    nestedAnnotations: [],
                                    depth: depthProperties
                                };
                                annotationsBuffer.push(newAnnotation);
                                // Check in the buffer if any annotations were defined at a deeper depth,
                                // if so, they are considered nested annotations.
                                for(i1 = annotationsBuffer.length - 2; i1 >= 0; i1--){
                                    // We iterate in reverse order, to enable easy item removal from the back.
                                    existingAnnotation = annotationsBuffer[i1];
                                    if (existingAnnotation.depth > depthProperties) {
                                        newAnnotation.nestedAnnotations.push(existingAnnotation);
                                        annotationsBuffer.splice(i1, 1);
                                    }
                                }
                                _state.label = 17;
                            case 17:
                                return [
                                    3,
                                    19
                                ];
                            case 18:
                                parsingContext.getUnidentifiedValueBufferSafe(depthProperties).push({
                                    predicate: predicate,
                                    object: object,
                                    reverse: reverse,
                                    isEmbedded: isEmbedded
                                });
                                _state.label = 19;
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerPredicate;
}();
module.exports.EntryHandlerPredicate = $44a50bd040f9864c$var$EntryHandlerPredicate;

});


parcelRegister("eoLCV", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerLanguage = void 0;

var $auQ3n = parcelRequire("auQ3n");
/**
 * Container handler for @language.
 *
 * It assumes that the current key is the language of the current value.
 * This will add this value to the parent node.
 */ var $a7b84049b65513d5$var$ContainerHandlerLanguage = /*#__PURE__*/ function() {
    function ContainerHandlerLanguage() {
        (0, $jGAMp._)(this, ContainerHandlerLanguage);
    }
    (0, $byiyg._)(ContainerHandlerLanguage, [
        {
            key: "canCombineWithGraph",
            value: function canCombineWithGraph() {
                return false;
            }
        },
        {
            key: "handle",
            value: function handle(containers, parsingContext, util, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var language;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    util.getContainerKey(keys[depth], keys, depth)
                                ];
                            case 1:
                                language = _state.sent();
                                if (Array.isArray(value)) // No type-checking needed, will be handled on each value when this handler is called recursively.
                                value = value.map(function(subValue) {
                                    return {
                                        '@value': subValue,
                                        '@language': language
                                    };
                                });
                                else {
                                    if (typeof value !== 'string') throw new $auQ3n.ErrorCoded("Got invalid language map value, got '".concat(JSON.stringify(value), "', but expected string"), $auQ3n.ERROR_CODES.INVALID_LANGUAGE_MAP_VALUE);
                                    value = {
                                        '@value': value,
                                        '@language': language
                                    };
                                }
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), value, depth - 1, true)
                                ];
                            case 2:
                                _state.sent();
                                parsingContext.emittedStack[depth] = false; // We have emitted a level higher
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContainerHandlerLanguage;
}();
module.exports.ContainerHandlerLanguage = $a7b84049b65513d5$var$ContainerHandlerLanguage;

});

parcelRegister("hQ7XJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerType = void 0;

var $5Torg = parcelRequire("5Torg");

var $aalae = parcelRequire("aalae");
/**
 * Container handler for @type.
 *
 * This will add this entry to the parent node, and use the current key as an rdf:type value.
 */ var $cfcd78270359e57f$var$ContainerHandlerType = /*#__PURE__*/ function() {
    function ContainerHandlerType() {
        (0, $jGAMp._)(this, ContainerHandlerType);
    }
    (0, $byiyg._)(ContainerHandlerType, [
        {
            key: "canCombineWithGraph",
            value: function canCombineWithGraph() {
                return false;
            }
        },
        {
            key: "handle",
            value: function handle(containers, parsingContext, util, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var context, containerTypeType, id, _tmp, subValue, entryHasIdentifier, keyOriginal, type, _tmp1, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!Array.isArray(value)) return [
                                    3,
                                    18
                                ];
                                if (!(typeof value === 'string')) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                context = _state.sent();
                                containerTypeType = $aalae.Util.getContextValueType(context, keys[depth - 1]);
                                if (!(containerTypeType === '@vocab')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    util.createVocabOrBaseTerm(context, value)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    util.resourceToTerm(context, value)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                id = _tmp;
                                if (!id) return [
                                    3,
                                    7
                                ];
                                // Handle the value of this node as @id, which will also cause the predicate from above to be emitted.
                                subValue = {
                                    '@id': id.termType === 'NamedNode' ? id.value : value
                                };
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), subValue, depth - 1, true)
                                ];
                            case 6:
                                _state.sent();
                                // Set the id in the stack so it can be used for the rdf:type handling later on
                                parsingContext.idStack[depth + 1] = [
                                    id
                                ];
                                _state.label = 7;
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                // Other values are handled by handling them as a proper job
                                // Check needed for cases where entries don't have an explicit @id
                                entryHasIdentifier = !!parsingContext.idStack[depth + 1];
                                // Handle the value of this node, which will also cause the predicate from above to be emitted.
                                if (!entryHasIdentifier) delete parsingContext.idStack[depth]; // Force new (blank node) identifier
                                return [
                                    4,
                                    parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), value, depth - 1, true)
                                ];
                            case 9:
                                _state.sent();
                                if (!entryHasIdentifier) parsingContext.idStack[depth + 1] = parsingContext.idStack[depth]; // Copy the id to the child node, for @type
                                _state.label = 10;
                            case 10:
                                return [
                                    4,
                                    util.getContainerKey(keys[depth], keys, depth)
                                ];
                            case 11:
                                keyOriginal = _state.sent();
                                if (!(keyOriginal !== null)) return [
                                    3,
                                    13
                                ];
                                _ = util.createVocabOrBaseTerm;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 12:
                                _tmp1 = _.apply(util, [
                                    _state.sent(),
                                    keyOriginal
                                ]);
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                _tmp1 = null;
                                _state.label = 14;
                            case 14:
                                type = _tmp1;
                                if (!type) return [
                                    3,
                                    16
                                ];
                                // Push the type to the stack using the rdf:type predicate
                                return [
                                    4,
                                    $5Torg.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth + 1, util.rdfType, type, false, false, false)
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                // Flush any pending flush buffers
                                return [
                                    4,
                                    parsingContext.handlePendingContainerFlushBuffers()
                                ];
                            case 17:
                                _state.sent();
                                _state.label = 18;
                            case 18:
                                parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContainerHandlerType;
}();
module.exports.ContainerHandlerType = $cfcd78270359e57f$var$ContainerHandlerType;

});


parcelRegister("gaVQ0", function(module, exports) {
/* jshint esversion: 6 */ /* jslint node: true */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';
module.exports = function serialize(object) {
    if (object === null || (typeof object === "undefined" ? "undefined" : (0, $3KZcf._)(object)) !== 'object' || object.toJSON != null) return JSON.stringify(object);
    if (Array.isArray(object)) return '[' + object.reduce(function(t, cv, ci) {
        var comma = ci === 0 ? '' : ',';
        var value = cv === undefined || (typeof cv === "undefined" ? "undefined" : (0, $3KZcf._)(cv)) === 'symbol' ? null : cv;
        return t + comma + serialize(value);
    }, '') + ']';
    return '{' + Object.keys(object).sort().reduce(function(t, cv, ci) {
        if (object[cv] === undefined || (0, $3KZcf._)(object[cv]) === 'symbol') return t;
        var comma = t.length === 0 ? '' : ',';
        return t + comma + serialize(cv) + ':' + serialize(object[cv]);
    }, '') + '}';
};

});



parcelRegister("3YuF6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerInvalidFallback = void 0;
/**
 * A catch-all for properties, that will either emit an error or ignore,
 * depending on whether or not the `strictValues` property is set.
 */ var $2e4ec28a981ef131$var$EntryHandlerInvalidFallback = /*#__PURE__*/ function() {
    function EntryHandlerInvalidFallback() {
        (0, $jGAMp._)(this, EntryHandlerInvalidFallback);
    }
    (0, $byiyg._)(EntryHandlerInvalidFallback, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return false;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        parsingContext.emittedStack[depth] = false;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return EntryHandlerInvalidFallback;
}();
module.exports.EntryHandlerInvalidFallback = $2e4ec28a981ef131$var$EntryHandlerInvalidFallback;

});

parcelRegister("2sPh7", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordContext = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @context entries.
 */ var $1cb5f87a4e684f9d$var$EntryHandlerKeywordContext = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordContext, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordContext() {
        (0, $jGAMp._)(this, EntryHandlerKeywordContext);
        return (0, $kzDuW._)(this, EntryHandlerKeywordContext, [
            '@context'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordContext, [
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return false;
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var parentContext, context, _, _tmp, _1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Error if an out-of-order context was found when support is not enabled.
                                if (parsingContext.streamingProfile && (parsingContext.processingStack[depth] || parsingContext.processingType[depth] || parsingContext.idStack[depth] !== undefined)) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an out-of-order context, while streaming is enabled.(disable `streamingProfile`)", $auQ3n.ERROR_CODES.INVALID_STREAMING_KEY_ORDER));
                                // Find the parent context to inherit from.
                                // We actually request a context for the current depth (with fallback to parent)
                                // because we want to take into account any property-scoped contexts that are defined for this depth.
                                parentContext = parsingContext.getContext(keys);
                                _ = parsingContext.parseContext;
                                _tmp = [
                                    value
                                ];
                                return [
                                    4,
                                    parentContext
                                ];
                            case 1:
                                context = _.apply(parsingContext, _tmp.concat([
                                    _state.sent().getContextRaw()
                                ]));
                                parsingContext.contextTree.setContext(keys.slice(0, -1), context);
                                parsingContext.emitContext(value);
                                _1 = parsingContext.validateContext;
                                return [
                                    4,
                                    context
                                ];
                            case 2:
                                return [
                                    4,
                                    _1.apply(parsingContext, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordContext;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordContext = $1cb5f87a4e684f9d$var$EntryHandlerKeywordContext;

});
parcelRegister("5bfy6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeyword = void 0;
/**
 * An abstract keyword entry handler.
 */ var $3c5a0a8ff50dabdf$var$EntryHandlerKeyword = /*#__PURE__*/ function() {
    function EntryHandlerKeyword(keyword) {
        (0, $jGAMp._)(this, EntryHandlerKeyword);
        this.keyword = keyword;
    }
    (0, $byiyg._)(EntryHandlerKeyword, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return false;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            key === this.keyword
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return EntryHandlerKeyword;
}();
module.exports.EntryHandlerKeyword = $3c5a0a8ff50dabdf$var$EntryHandlerKeyword;

});


parcelRegister("6OtFe", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordGraph = void 0;

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @graph entries.
 */ var $4f5e6c3d47af7e7b$var$EntryHandlerKeywordGraph = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordGraph, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordGraph() {
        (0, $jGAMp._)(this, EntryHandlerKeywordGraph);
        return (0, $kzDuW._)(this, EntryHandlerKeywordGraph, [
            '@graph'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordGraph, [
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // The current identifier identifies a graph for the deeper level.
                        parsingContext.graphStack[depth + 1] = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordGraph;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordGraph = $4f5e6c3d47af7e7b$var$EntryHandlerKeywordGraph;

});

parcelRegister("7rf23", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordId = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @id entries.
 */ var $56a6b710ec67e21e$var$EntryHandlerKeywordId = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordId, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordId() {
        (0, $jGAMp._)(this, EntryHandlerKeywordId);
        return (0, $kzDuW._)(this, EntryHandlerKeywordId, [
            '@id'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordId, [
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return false;
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var valueKeys, depthProperties, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, annotation, _, _1, _2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof value !== 'string') {
                                    // JSON-LD-star allows @id object values
                                    if (parsingContext.rdfstar && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                        valueKeys = Object.keys(value);
                                        if (valueKeys.length === 1 && valueKeys[0] === '@id') parsingContext.emitError(new $auQ3n.ErrorCoded("Invalid embedded node without property with @id ".concat(value['@id']), $auQ3n.ERROR_CODES.INVALID_EMBEDDED_NODE));
                                    } else parsingContext.emitError(new $auQ3n.ErrorCoded("Found illegal @id '".concat(value, "'"), $auQ3n.ERROR_CODES.INVALID_ID_VALUE));
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    util.getPropertiesDepth(keys, depth)
                                ];
                            case 1:
                                depthProperties = _state.sent();
                                // Error if an @id for this node already existed.
                                if (parsingContext.idStack[depthProperties] !== undefined) {
                                    if (parsingContext.idStack[depthProperties][0].listHead) // Error if an @list was already defined for this node
                                    parsingContext.emitError(new $auQ3n.ErrorCoded("Found illegal neighbouring entries next to @list for key: '".concat(keys[depth - 1], "'"), $auQ3n.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT));
                                    else // Otherwise, the previous id was just because of an @id entry.
                                    parsingContext.emitError(new $auQ3n.ErrorCoded("Found duplicate @ids '".concat(parsingContext.idStack[depthProperties][0].value, "' and '").concat(value, "'"), $auQ3n.ERROR_CODES.COLLIDING_KEYWORDS));
                                }
                                // Error if an annotation was defined
                                if (parsingContext.rdfstar && parsingContext.annotationsBuffer[depth]) {
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = parsingContext.annotationsBuffer[depth][Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            annotation = _step.value;
                                            if (annotation.depth === depth) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal @id inside an annotation: ".concat(value), $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                // Save our @id on the stack
                                _ = parsingContext.idStack;
                                _1 = util.nullableTermToArray;
                                _2 = util.resourceToTerm;
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 2:
                                return [
                                    4,
                                    _2.apply(util, [
                                        _state.sent(),
                                        value
                                    ])
                                ];
                            case 3:
                                _[depthProperties] = _1.apply(util, [
                                    _state.sent()
                                ]);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordId;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordId = $56a6b710ec67e21e$var$EntryHandlerKeywordId;

});

parcelRegister("efKCv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordIncluded = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @included entries.
 */ var $a606a12a6b18ab42$var$EntryHandlerKeywordIncluded = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordIncluded, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordIncluded() {
        (0, $jGAMp._)(this, EntryHandlerKeywordIncluded);
        return (0, $kzDuW._)(this, EntryHandlerKeywordIncluded, [
            '@included'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordIncluded, [
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var valueUnliased, _, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object') parsingContext.emitError(new $auQ3n.ErrorCoded("Found illegal @included '".concat(value, "'"), $auQ3n.ERROR_CODES.INVALID_INCLUDED_VALUE));
                                _ = util.unaliasKeywords;
                                _tmp = [
                                    value,
                                    keys,
                                    depth
                                ];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                return [
                                    4,
                                    _.apply(util, _tmp.concat([
                                        _state.sent()
                                    ]))
                                ];
                            case 2:
                                valueUnliased = _state.sent();
                                if ('@value' in valueUnliased) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal @included @value node '".concat(JSON.stringify(value), "'"), $auQ3n.ERROR_CODES.INVALID_INCLUDED_VALUE));
                                if ('@list' in valueUnliased) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an illegal @included @list node '".concat(JSON.stringify(value), "'"), $auQ3n.ERROR_CODES.INVALID_INCLUDED_VALUE));
                                parsingContext.emittedStack[depth] = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordIncluded;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordIncluded = $a606a12a6b18ab42$var$EntryHandlerKeywordIncluded;

});

parcelRegister("5cma4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordNest = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @nest entries.
 */ var $3c8f43895f753967$var$EntryHandlerKeywordNest = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordNest, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordNest() {
        (0, $jGAMp._)(this, EntryHandlerKeywordNest);
        return (0, $kzDuW._)(this, EntryHandlerKeywordNest, [
            '@nest'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordNest, [
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object') parsingContext.emitError(new $auQ3n.ErrorCoded("Found invalid @nest entry for '".concat(key, "': '").concat(value, "'"), $auQ3n.ERROR_CODES.INVALID_NEST_VALUE));
                                _ = '@value';
                                _1 = util.unaliasKeywords;
                                _tmp = [
                                    value,
                                    keys,
                                    depth
                                ];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(util, _tmp.concat([
                                        _state.sent()
                                    ]))
                                ];
                            case 2:
                                if (_ in _state.sent()) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an invalid @value node for '".concat(key, "'"), $auQ3n.ERROR_CODES.INVALID_NEST_VALUE));
                                parsingContext.emittedStack[depth] = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordNest;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordNest = $3c8f43895f753967$var$EntryHandlerKeywordNest;

});

parcelRegister("9qUmR", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordType = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $aalae = parcelRequire("aalae");

var $5Torg = parcelRequire("5Torg");

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @graph entries.
 */ var $6de24438336f4a2c$var$EntryHandlerKeywordType = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordType, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordType() {
        (0, $jGAMp._)(this, EntryHandlerKeywordType);
        return (0, $kzDuW._)(this, EntryHandlerKeywordType, [
            '@type'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordType, [
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return false;
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var keyOriginal, context, predicate, parentKey, reverse, isEmbedded, isAnnotation, elements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, type, err, scopedContext, hasTypedScopedContext, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator1, _step1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keyOriginal = keys[depth];
                                return [
                                    4,
                                    parsingContext.getContext(keys)
                                ];
                            case 1:
                                context = _state.sent();
                                predicate = util.rdfType;
                                return [
                                    4,
                                    util.unaliasKeywordParent(keys, depth)
                                ];
                            case 2:
                                parentKey = _state.sent();
                                reverse = $aalae.Util.isPropertyReverse(context, keyOriginal, parentKey);
                                isEmbedded = $aalae.Util.isPropertyInEmbeddedNode(parentKey);
                                util.validateReverseInEmbeddedNode(key, reverse, isEmbedded);
                                isAnnotation = $aalae.Util.isPropertyInAnnotationObject(parentKey);
                                // Handle multiple values if the value is an array
                                elements = Array.isArray(value) ? value : [
                                    value
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = elements[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                element = _step.value;
                                if (typeof element !== 'string') parsingContext.emitError(new $auQ3n.ErrorCoded("Found illegal @type '".concat(element, "'"), $auQ3n.ERROR_CODES.INVALID_TYPE_VALUE));
                                type = util.createVocabOrBaseTerm(context, element);
                                if (!type) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    $5Torg.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, predicate, type, reverse, isEmbedded, isAnnotation)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                // Collect type-scoped contexts if they exist
                                scopedContext = Promise.resolve(context);
                                hasTypedScopedContext = false;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    _loop = function() {
                                        var element = _step1.value;
                                        var typeContext = $aalae.Util.getContextValue(context, '@context', element, null);
                                        if (typeContext) {
                                            hasTypedScopedContext = true;
                                            scopedContext = scopedContext.then(function(c) {
                                                return parsingContext.parseContext(typeContext, c.getContextRaw());
                                            });
                                        }
                                    };
                                    for(_iterator1 = elements.sort()[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                // Error if an out-of-order type-scoped context was found when support is not enabled.
                                if (parsingContext.streamingProfile && (hasTypedScopedContext || !parsingContext.streamingProfileAllowOutOfOrderPlainType) && (parsingContext.processingStack[depth] || parsingContext.idStack[depth])) parsingContext.emitError(new $auQ3n.ErrorCoded("Found an out-of-order type-scoped context, while streaming is enabled.(disable `streamingProfile`)", $auQ3n.ERROR_CODES.INVALID_STREAMING_KEY_ORDER));
                                // If at least least one type-scoped context applies, set them in the tree.
                                if (hasTypedScopedContext) {
                                    // Do not propagate by default
                                    scopedContext = scopedContext.then(function(c) {
                                        // Set the original context at this depth as a fallback
                                        // This is needed when a context was already defined at the given depth,
                                        // and this context needs to remain accessible from child nodes when propagation is disabled.
                                        if (c.getContextRaw()['@propagate'] !== true) return new $auQ3n.JsonLdContextNormalized(Object.assign(Object.assign({}, c.getContextRaw()), {
                                            '@propagate': false,
                                            '@__propagateFallback': context.getContextRaw()
                                        }));
                                        return c;
                                    });
                                    // Set the new context in the context tree
                                    parsingContext.contextTree.setContext(keys.slice(0, keys.length - 1), scopedContext);
                                }
                                // Flag that type has been processed at this depth
                                parsingContext.processingType[depth] = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordType;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordType = $6de24438336f4a2c$var$EntryHandlerKeywordType;

});

parcelRegister("3zt6j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordUnknownFallback = void 0;

var $auQ3n = parcelRequire("auQ3n");
/**
 * A catch-all for keywords, that will either emit an error or ignore,
 * depending on whether or not the `strictValues` property is set.
 */ var $299b36c901d0bf36$var$EntryHandlerKeywordUnknownFallback = /*#__PURE__*/ function() {
    function EntryHandlerKeywordUnknownFallback() {
        (0, $jGAMp._)(this, EntryHandlerKeywordUnknownFallback);
    }
    (0, $byiyg._)(EntryHandlerKeywordUnknownFallback, [
        {
            key: "isPropertyHandler",
            value: function isPropertyHandler() {
                return false;
            }
        },
        {
            key: "isStackProcessor",
            value: function isStackProcessor() {
                return true;
            }
        },
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var key;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    util.unaliasKeyword(keys[depth], keys, depth)
                                ];
                            case 1:
                                key = _state.sent();
                                if ($auQ3n.Util.isPotentialKeyword(key)) {
                                    // Don't emit anything inside free-floating lists
                                    if (!inProperty) {
                                        if (key === '@list') return [
                                            2,
                                            false
                                        ];
                                    }
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            $auQ3n.Util.isPotentialKeyword(key)
                        ];
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var keywordType;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        keywordType = EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES[key];
                        if (keywordType !== undefined) {
                            if (keywordType && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== keywordType.type) parsingContext.emitError(new $auQ3n.ErrorCoded("Invalid value type for '".concat(key, "' with value '").concat(value, "'"), keywordType.errorCode));
                        } else if (parsingContext.strictValues) parsingContext.emitError(new Error("Unknown keyword '".concat(key, "' with value '").concat(value, "'")));
                        parsingContext.emittedStack[depth] = false;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordUnknownFallback;
}();
$299b36c901d0bf36$var$EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES = {
    '@index': {
        type: 'string',
        errorCode: $auQ3n.ERROR_CODES.INVALID_INDEX_VALUE
    },
    '@list': null,
    '@reverse': {
        type: 'object',
        errorCode: $auQ3n.ERROR_CODES.INVALID_REVERSE_VALUE
    },
    '@set': null,
    '@value': null
};
module.exports.EntryHandlerKeywordUnknownFallback = $299b36c901d0bf36$var$EntryHandlerKeywordUnknownFallback;

});

parcelRegister("ilpEq", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordValue = void 0;

var $5bfy6 = parcelRequire("5bfy6");
/**
 * Handles @value entries.
 */ var $d5ae15e66d14b81b$var$EntryHandlerKeywordValue = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordValue, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordValue() {
        (0, $jGAMp._)(this, EntryHandlerKeywordValue);
        return (0, $kzDuW._)(this, EntryHandlerKeywordValue, [
            '@value'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordValue, [
        {
            key: "validate",
            value: function validate(parsingContext, util, keys, depth, inProperty) {
                var _this = this;
                var _this1 = this, _superprop_get_validate = function() {
                    return (0, $fXhL4._)((0, $hxFDX._)(EntryHandlerKeywordValue.prototype), "validate", _this);
                };
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var key, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // If this is @value, mark it so in the stack so that no deeper handling of nodes occurs.
                                key = keys[depth];
                                _tmp = key && !parsingContext.literalStack[depth];
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.test(parsingContext, util, key, keys, depth)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (_tmp) parsingContext.literalStack[depth] = true;
                                return [
                                    2,
                                    _superprop_get_validate().call(_this1, parsingContext, util, keys, depth, inProperty)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "test",
            value: function test(parsingContext, util, key, keys, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    util.unaliasKeyword(keys[depth], keys.slice(0, keys.length - 1), depth - 1, true)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent() === '@value'
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // If the value is valid, indicate that we are processing a literal.
                        // The actual value will be determined at the parent level when the @value is part of an object,
                        // because we may want to take into account additional entries such as @language.
                        // See {@link Util.valueToTerm}
                        // Indicate that we are processing a literal, and that no later predicates should be parsed at this depth.
                        parsingContext.literalStack[depth] = true;
                        // Void any buffers that we may have accumulated up until now
                        delete parsingContext.unidentifiedValuesBuffer[depth];
                        delete parsingContext.unidentifiedGraphsBuffer[depth];
                        // Indicate that we have not emitted at this depth
                        parsingContext.emittedStack[depth] = false;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return EntryHandlerKeywordValue;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordValue = $d5ae15e66d14b81b$var$EntryHandlerKeywordValue;

});

parcelRegister("aA3b4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsingContext = void 0;

var $auQ3n = parcelRequire("auQ3n");

var $1gDxA = parcelRequire("1gDxA");

var $7wrqQ = parcelRequire("7wrqQ");

var $agzTm = parcelRequire("agzTm");
/**
 * Data holder for parsing information.
 */ var $7b3fbb2f9447a359$var$ParsingContext = /*#__PURE__*/ function() {
    function ParsingContext(options) {
        var _this = this;
        (0, $jGAMp._)(this, ParsingContext);
        // Initialize settings
        this.contextParser = new $auQ3n.ContextParser({
            documentLoader: options.documentLoader,
            skipValidation: options.skipContextValidation
        });
        this.streamingProfile = !!options.streamingProfile;
        this.baseIRI = options.baseIRI;
        this.produceGeneralizedRdf = !!options.produceGeneralizedRdf;
        this.allowSubjectList = !!options.allowSubjectList;
        this.processingMode = options.processingMode || $agzTm.JsonLdParser.DEFAULT_PROCESSING_MODE;
        this.strictValues = !!options.strictValues;
        this.validateValueIndexes = !!options.validateValueIndexes;
        this.defaultGraph = options.defaultGraph;
        this.rdfDirection = options.rdfDirection;
        this.normalizeLanguageTags = options.normalizeLanguageTags;
        this.streamingProfileAllowOutOfOrderPlainType = options.streamingProfileAllowOutOfOrderPlainType;
        this.rdfstar = options.rdfstar !== false;
        this.rdfstarReverseInEmbedded = options.rdfstarReverseInEmbedded;
        this.topLevelProperties = false;
        this.activeProcessingMode = parseFloat(this.processingMode);
        // Initialize stacks
        this.processingStack = [];
        this.processingType = [];
        this.emittedStack = [];
        this.idStack = [];
        this.graphStack = [];
        this.graphContainerTermStack = [];
        this.listPointerStack = [];
        this.contextTree = new $7wrqQ.ContextTree();
        this.literalStack = [];
        this.validationStack = [];
        this.unaliasedKeywordCacheStack = [];
        this.jsonLiteralStack = [];
        this.unidentifiedValuesBuffer = [];
        this.unidentifiedGraphsBuffer = [];
        this.annotationsBuffer = [];
        this.pendingContainerFlushBuffers = [];
        this.parser = options.parser;
        if (options.context) {
            this.rootContext = this.parseContext(options.context);
            this.rootContext.then(function(context) {
                return _this.validateContext(context);
            });
        } else this.rootContext = Promise.resolve(new $auQ3n.JsonLdContextNormalized(this.baseIRI ? {
            '@base': this.baseIRI,
            '@__baseDocument': true
        } : {}));
    }
    (0, $byiyg._)(ParsingContext, [
        {
            key: "parseContext",
            value: /**
     * Parse the given context with the configured options.
     * @param {JsonLdContext} context A context to parse.
     * @param {JsonLdContextNormalized} parentContext An optional parent context.
     * @param {boolean} ignoreProtection If @protected term checks should be ignored.
     * @return {Promise<JsonLdContextNormalized>} A promise resolving to the parsed context.
     */ function parseContext(context, parentContext, ignoreProtection) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.contextParser.parse(context, {
                                baseIRI: this.baseIRI,
                                ignoreProtection: ignoreProtection,
                                normalizeLanguageTags: this.normalizeLanguageTags,
                                parentContext: parentContext,
                                processingMode: this.activeProcessingMode
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
     * Check if the given context is valid.
     * If not, an error will be thrown.
     * @param {JsonLdContextNormalized} context A context.
     */ key: "validateContext",
            value: function validateContext(context) {
                var activeVersion = context.getContextRaw()['@version'];
                if (activeVersion) {
                    if (this.activeProcessingMode && activeVersion > this.activeProcessingMode) throw new $1gDxA.ErrorCoded("Unsupported JSON-LD version '".concat(activeVersion, "' under active processing mode ").concat(this.activeProcessingMode, "."), $1gDxA.ERROR_CODES.PROCESSING_MODE_CONFLICT);
                    else {
                        if (this.activeProcessingMode && activeVersion < this.activeProcessingMode) throw new $1gDxA.ErrorCoded("Invalid JSON-LD version ".concat(activeVersion, " under active processing mode ").concat(this.activeProcessingMode, "."), $1gDxA.ERROR_CODES.INVALID_VERSION_VALUE);
                        this.activeProcessingMode = activeVersion;
                    }
                }
            }
        },
        {
            key: "getContext",
            value: /**
     * Get the context at the given path.
     * @param {keys} keys The path of keys to get the context at.
     * @param {number} offset The path offset, defaults to 1.
     * @return {Promise<JsonLdContextNormalized>} A promise resolving to a context.
     */ function getContext(keys) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var keysOriginal, contextData, context, contextRaw, i, key, contextKeyEntry, scopedContext, propagate;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keysOriginal = keys;
                                // Ignore array keys at the end
                                while(typeof keys[keys.length - 1] === 'number')keys = keys.slice(0, keys.length - 1);
                                // Handle offset on keys
                                if (offset) keys = keys.slice(0, -offset);
                                return [
                                    4,
                                    this.getContextPropagationAware(keys)
                                ];
                            case 1:
                                contextData = _state.sent();
                                context = contextData.context;
                                // Process property-scoped contexts (high-to-low)
                                contextRaw = context.getContextRaw();
                                i = contextData.depth;
                                _state.label = 2;
                            case 2:
                                if (!(i < keysOriginal.length - offset)) return [
                                    3,
                                    5
                                ];
                                key = keysOriginal[i];
                                contextKeyEntry = contextRaw[key];
                                if (!(contextKeyEntry && (typeof contextKeyEntry === "undefined" ? "undefined" : (0, $3KZcf._)(contextKeyEntry)) === 'object' && '@context' in contextKeyEntry)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.parseContext(contextKeyEntry, contextRaw, true)
                                ];
                            case 3:
                                scopedContext = _state.sent().getContextRaw();
                                propagate = !(key in scopedContext) || scopedContext[key]['@context']['@propagate']; // Propagation is true by default
                                if (propagate !== false || i === keysOriginal.length - 1 - offset) {
                                    contextRaw = Object.assign({}, scopedContext);
                                    // Clean up final context
                                    delete contextRaw['@propagate'];
                                    contextRaw[key] = Object.assign({}, contextRaw[key]);
                                    if ('@id' in contextKeyEntry) contextRaw[key]['@id'] = contextKeyEntry['@id'];
                                    delete contextRaw[key]['@context'];
                                    if (propagate !== false) this.contextTree.setContext(keysOriginal.slice(0, i + offset), Promise.resolve(new $auQ3n.JsonLdContextNormalized(contextRaw)));
                                }
                                _state.label = 4;
                            case 4:
                                i++;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2,
                                    new $auQ3n.JsonLdContextNormalized(contextRaw)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getContextPropagationAware",
            value: /**
     * Get the context at the given path.
     * Non-propagating contexts will be skipped,
     * unless the context at that exact depth is retrieved.
     *
     * This ONLY takes into account context propagation logic,
     * so this should usually not be called directly,
     * call {@link #getContext} instead.
     *
     * @param keys The path of keys to get the context at.
     * @return {Promise<{ context: JsonLdContextNormalized, depth: number }>} A context and its depth.
     */ function getContextPropagationAware(keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var originalDepth, contextData, hasApplicablePropertyScopedContext, _tmp, _tmp1, lastKey, lastKeyValue;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                originalDepth = keys.length;
                                contextData = null;
                                _state.label = 1;
                            case 1:
                                hasApplicablePropertyScopedContext = false;
                                if (!(contextData && '@__propagateFallback' in contextData.context.getContextRaw())) return [
                                    3,
                                    2
                                ];
                                // If a propagation fallback context has been set,
                                // fallback to that context and retry for the same depth.
                                contextData.context = new $auQ3n.JsonLdContextNormalized(contextData.context.getContextRaw()['@__propagateFallback']);
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                if (contextData) // If we had a previous iteration, jump to the parent of context depth.
                                // We must do this because once we get here, last context had propagation disabled,
                                // so we check its first parent instead.
                                keys = keys.slice(0, contextData.depth - 1);
                                return [
                                    4,
                                    this.contextTree.getContext(keys)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                if (_tmp) return [
                                    3,
                                    5
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    this.rootContext
                                ];
                            case 4:
                                _tmp = (_tmp1.context = _state.sent(), _tmp1.depth = 0, _tmp1);
                                _state.label = 5;
                            case 5:
                                contextData = _tmp;
                                _state.label = 6;
                            case 6:
                                // Allow non-propagating contexts to propagate one level deeper
                                // if it defines a property-scoped context that is applicable for the current key.
                                // @see https://w3c.github.io/json-ld-api/tests/toRdf-manifest#tc012
                                lastKey = keys[keys.length - 1];
                                if (lastKey in contextData.context.getContextRaw()) {
                                    lastKeyValue = contextData.context.getContextRaw()[lastKey];
                                    if (lastKeyValue && (typeof lastKeyValue === "undefined" ? "undefined" : (0, $3KZcf._)(lastKeyValue)) === 'object' && '@context' in lastKeyValue) hasApplicablePropertyScopedContext = true;
                                }
                                _state.label = 7;
                            case 7:
                                if (contextData.depth > 0 // Root context has a special case
                                 && contextData.context.getContextRaw()['@propagate'] === false // Stop loop if propagation is true
                                 && contextData.depth !== originalDepth // Stop loop if requesting exact depth of non-propagating
                                 && !hasApplicablePropertyScopedContext) return [
                                    3,
                                    1
                                ];
                                _state.label = 8;
                            case 8:
                                // Special case for root context that does not allow propagation.
                                // Fallback to empty context in that case.
                                if (contextData.depth === 0 && contextData.context.getContextRaw()['@propagate'] === false && contextData.depth !== originalDepth) contextData.context = new $auQ3n.JsonLdContextNormalized({});
                                return [
                                    2,
                                    contextData
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "newOnValueJob",
            value: /**
     * Start a new job for parsing the given value.
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @param {boolean} lastDepthCheck If the lastDepth check should be done for buffer draining.
     * @return {Promise<void>} A promise resolving when the job is done.
     */ function newOnValueJob(keys, value, depth, lastDepthCheck) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.parser.newOnValueJob(keys, value, depth, lastDepthCheck)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "handlePendingContainerFlushBuffers",
            value: /**
     * Flush the pending container flush buffers
     * @return {boolean} If any pending buffers were flushed.
     */ function handlePendingContainerFlushBuffers() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pendingFlushBuffer, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this.pendingContainerFlushBuffers.length > 0)) return [
                                    3,
                                    9
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = this.pendingContainerFlushBuffers[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                pendingFlushBuffer = _step.value;
                                return [
                                    4,
                                    this.parser.flushBuffer(pendingFlushBuffer.depth, pendingFlushBuffer.keys)
                                ];
                            case 3:
                                _state.sent();
                                this.parser.flushStacks(pendingFlushBuffer.depth);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                this.pendingContainerFlushBuffers.splice(0, this.pendingContainerFlushBuffers.length);
                                return [
                                    2,
                                    true
                                ];
                            case 9:
                                return [
                                    2,
                                    false
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Emit the given quad into the output stream.
     * @param {number} depth The depth the quad was generated at.
     * @param {Quad} quad A quad to emit.
     */ key: "emitQuad",
            value: function emitQuad(depth, quad) {
                if (depth === 1) this.topLevelProperties = true;
                this.parser.push(quad);
            }
        },
        {
            /**
     * Emit the given error into the output stream.
     * @param {Error} error An error to emit.
     */ key: "emitError",
            value: function emitError(error) {
                this.parser.emit('error', error);
            }
        },
        {
            /**
     * Emit the given context into the output stream under the 'context' event.
     * @param {JsonLdContext} context A context to emit.
     */ key: "emitContext",
            value: function emitContext(context) {
                this.parser.emit('context', context);
            }
        },
        {
            /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedValuesBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedValuesBuffer}.
     */ key: "getUnidentifiedValueBufferSafe",
            value: function getUnidentifiedValueBufferSafe(depth) {
                var buffer = this.unidentifiedValuesBuffer[depth];
                if (!buffer) {
                    buffer = [];
                    this.unidentifiedValuesBuffer[depth] = buffer;
                }
                return buffer;
            }
        },
        {
            /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedGraphsBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedGraphsBuffer}.
     */ key: "getUnidentifiedGraphBufferSafe",
            value: function getUnidentifiedGraphBufferSafe(depth) {
                var buffer = this.unidentifiedGraphsBuffer[depth];
                if (!buffer) {
                    buffer = [];
                    this.unidentifiedGraphsBuffer[depth] = buffer;
                }
                return buffer;
            }
        },
        {
            /**
     * Safely get or create the depth value of {@link ParsingContext.annotationsBuffer}.
     * @param {number} depth A depth.
     * @return {} An element of {@link ParsingContext.annotationsBuffer}.
     */ key: "getAnnotationsBufferSafe",
            value: function getAnnotationsBufferSafe(depth) {
                var buffer = this.annotationsBuffer[depth];
                if (!buffer) {
                    buffer = [];
                    this.annotationsBuffer[depth] = buffer;
                }
                return buffer;
            }
        },
        {
            /**
     * @return IExpandOptions The expand options for the active processing mode.
     */ key: "getExpandOptions",
            value: function getExpandOptions() {
                return ParsingContext.EXPAND_OPTIONS[this.activeProcessingMode];
            }
        },
        {
            /**
     * Shift the stack at the given offset to the given depth.
     *
     * This will override anything in the stack at `depth`,
     * and this will remove anything at `depth + depthOffset`
     *
     * @param depth The target depth.
     * @param depthOffset The origin depth, relative to `depth`.
     */ key: "shiftStack",
            value: function shiftStack(depth, depthOffset) {
                // Copy the id stack value up one level so that the next job can access the id.
                var deeperIdStack = this.idStack[depth + depthOffset];
                if (deeperIdStack) {
                    this.idStack[depth] = deeperIdStack;
                    this.emittedStack[depth] = true;
                    delete this.idStack[depth + depthOffset];
                }
                // Shorten key stack
                if (this.pendingContainerFlushBuffers.length) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.pendingContainerFlushBuffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var buffer = _step.value;
                            if (buffer.depth >= depth + depthOffset) {
                                buffer.depth -= depthOffset;
                                buffer.keys.splice(depth, depthOffset);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // Splice stacks
                if (this.unidentifiedValuesBuffer[depth + depthOffset]) {
                    this.unidentifiedValuesBuffer[depth] = this.unidentifiedValuesBuffer[depth + depthOffset];
                    delete this.unidentifiedValuesBuffer[depth + depthOffset];
                }
                if (this.annotationsBuffer[depth + depthOffset - 1]) {
                    if (!this.annotationsBuffer[depth - 1]) this.annotationsBuffer[depth - 1] = [];
                    this.annotationsBuffer[depth - 1] = (0, $7WNf6._)(this.annotationsBuffer[depth - 1]).concat((0, $7WNf6._)(this.annotationsBuffer[depth + depthOffset - 1]));
                    delete this.annotationsBuffer[depth + depthOffset - 1];
                }
            // TODO: also do the same for other stacks
            }
        }
    ]);
    return ParsingContext;
}();
$7b3fbb2f9447a359$var$ParsingContext.EXPAND_OPTIONS = {
    1.0: {
        allowPrefixForcing: false,
        allowPrefixNonGenDelims: false,
        allowVocabRelativeToBase: false
    },
    1.1: {
        allowPrefixForcing: true,
        allowPrefixNonGenDelims: false,
        allowVocabRelativeToBase: true
    }
};
module.exports.ParsingContext = $7b3fbb2f9447a359$var$ParsingContext;

});
parcelRegister("7wrqQ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $1UYmo = parcelRequire("1UYmo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextTree = void 0;
/**
 * A tree structure that holds all contexts,
 * based on their position in the JSON object.
 *
 * Positions are identified by a path of keys.
 */ var $57a0ccf6b82c4025$var$ContextTree = /*#__PURE__*/ function() {
    function ContextTree() {
        (0, $jGAMp._)(this, ContextTree);
        this.subTrees = {};
    }
    (0, $byiyg._)(ContextTree, [
        {
            key: "getContext",
            value: function getContext(keys) {
                if (keys.length > 0) {
                    var _keys = (0, $1UYmo._)(keys), head = _keys[0], tail = _keys.slice(1);
                    var subTree = this.subTrees[head];
                    if (subTree) {
                        var subContext = subTree.getContext(tail);
                        if (subContext) return subContext.then(function(param) {
                            var context = param.context, depth = param.depth;
                            return {
                                context: context,
                                depth: depth + 1
                            };
                        });
                    }
                }
                return this.context ? this.context.then(function(context) {
                    return {
                        context: context,
                        depth: 0
                    };
                }) : null;
            }
        },
        {
            key: "setContext",
            value: function setContext(keys, context) {
                if (keys.length === 0) this.context = context;
                else {
                    var _keys = (0, $1UYmo._)(keys), head = _keys[0], tail = _keys.slice(1);
                    var subTree = this.subTrees[head];
                    if (!subTree) subTree = this.subTrees[head] = new ContextTree();
                    subTree.setContext(tail, context);
                }
            }
        },
        {
            key: "removeContext",
            value: function removeContext(path) {
                this.setContext(path, null);
            }
        }
    ]);
    return ContextTree;
}();
module.exports.ContextTree = $57a0ccf6b82c4025$var$ContextTree;

});


parcelRegister("aiMM8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordAnnotation = void 0;

var $5bfy6 = parcelRequire("5bfy6");

var $auQ3n = parcelRequire("auQ3n");
/**
 * Handles @annotation entries.
 */ var $78016b9820b37d27$var$EntryHandlerKeywordAnnotation = /*#__PURE__*/ function(_EntryHandlerKeyword_1_EntryHandlerKeyword) {
    (0, $i3fW3._)(EntryHandlerKeywordAnnotation, _EntryHandlerKeyword_1_EntryHandlerKeyword);
    function EntryHandlerKeywordAnnotation() {
        (0, $jGAMp._)(this, EntryHandlerKeywordAnnotation);
        return (0, $kzDuW._)(this, EntryHandlerKeywordAnnotation, [
            '@annotation'
        ]);
    }
    (0, $byiyg._)(EntryHandlerKeywordAnnotation, [
        {
            key: "handle",
            value: function handle(parsingContext, util, key, keys, value, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        // Validate value
                        if (typeof value === 'string' || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && value['@value']) parsingContext.emitError(new $auQ3n.ErrorCoded("Found illegal annotation value: ".concat(JSON.stringify(value)), $auQ3n.ERROR_CODES.INVALID_ANNOTATION));
                        return [
                            2
                        ];
                    });
                // Rest of the processing is done as regular nodes
                })();
            }
        }
    ]);
    return EntryHandlerKeywordAnnotation;
}($5bfy6.EntryHandlerKeyword);
module.exports.EntryHandlerKeywordAnnotation = $78016b9820b37d27$var$EntryHandlerKeywordAnnotation;

});



parcelRegister("97kIC", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DocumentLoaderMediated = void 0;

var $2terW = parcelRequire("2terW");

var $99iqU = parcelRequire("99iqU");

var $WtjUC = parcelRequire("WtjUC");
/**
 * A JSON-LD document loader that fetches over an HTTP bus using a given mediator.
 */ var $6a34d6c95ea8e670$var$DocumentLoaderMediated = /*#__PURE__*/ function(_jsonld_context_parser_1_FetchDocumentLoader) {
    (0, $i3fW3._)(DocumentLoaderMediated, _jsonld_context_parser_1_FetchDocumentLoader);
    function DocumentLoaderMediated(mediatorHttp, context) {
        (0, $jGAMp._)(this, DocumentLoaderMediated);
        var _this;
        _this = (0, $kzDuW._)(this, DocumentLoaderMediated, [
            DocumentLoaderMediated.createFetcher(mediatorHttp, context)
        ]);
        _this.mediatorHttp = mediatorHttp;
        _this.context = context;
        return _this;
    }
    (0, $byiyg._)(DocumentLoaderMediated, null, [
        {
            key: "createFetcher",
            value: function createFetcher(mediatorHttp, context) {
                return function(url, init) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var response;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        mediatorHttp.mediate({
                                            input: url,
                                            init: init,
                                            context: context
                                        })
                                    ];
                                case 1:
                                    response = _state.sent();
                                    response.json = function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _ = JSON.parse;
                                                        return [
                                                            4,
                                                            (0, $99iqU.stringify)($2terW.ActorHttp.toNodeReadable(response.body))
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _.apply(JSON, [
                                                                _state.sent()
                                                            ])
                                                        ];
                                                }
                                            });
                                        })();
                                    };
                                    return [
                                        2,
                                        response
                                    ];
                            }
                        });
                    })();
                };
            }
        }
    ]);
    return DocumentLoaderMediated;
}($WtjUC.FetchDocumentLoader);
module.exports.DocumentLoaderMediated = $6a34d6c95ea8e670$var$DocumentLoaderMediated;

});
parcelRegister("WtjUC", function(module, exports) {
"use strict";
var $0afc2944a9bb2507$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0afc2944a9bb2507$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0afc2944a9bb2507$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0afc2944a9bb2507$var$__exportStar((parcelRequire("cUrBQ")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("5bfwT")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("fSxXr")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("kHWAP")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("6DCVI")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("4GVne")), module.exports);

$0afc2944a9bb2507$var$__exportStar((parcelRequire("eTO1i")), module.exports);

});
parcelRegister("cUrBQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;
parcelRequire("8TS2u");

var $hDpjF = parcelRequire("hDpjF");

var $5bfwT = parcelRequire("5bfwT");

var $fSxXr = parcelRequire("fSxXr");

var $4GVne = parcelRequire("4GVne");

var $eTO1i = parcelRequire("eTO1i");
/**
 * Parses JSON-LD contexts.
 */ var $966021a573605ddf$var$ContextParser = /*#__PURE__*/ function() {
    function ContextParser(options) {
        (0, $jGAMp._)(this, ContextParser);
        options = options || {};
        this.documentLoader = options.documentLoader || new $fSxXr.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
    (0, $byiyg._)(ContextParser, [
        {
            /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ key: "idifyReverseTerms",
            value: function idifyReverseTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (value['@reverse'] && !value['@id']) {
                                if (typeof value['@reverse'] !== 'string' || $eTO1i.Util.isValidKeyword(value['@reverse'])) throw new $5bfwT.ErrorCoded("Invalid @reverse value, must be absolute IRI or blank node: '".concat(value['@reverse'], "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                value = context[key] = Object.assign(Object.assign({}, value), {
                                    '@id': value['@reverse']
                                });
                                value['@id'] = value['@reverse'];
                                if ($eTO1i.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                                else value['@reverse'] = true;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return context;
            }
        },
        {
            /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ key: "expandPrefixedTerms",
            value: function expandPrefixedTerms(context, expandContentTypeToBase, keys) {
                var contextRaw = context.getContextRaw();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys || Object.keys(contextRaw))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Only expand allowed keys
                        if ($eTO1i.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$eTO1i.Util.isReservedInternalKeyword(key)) {
                            // Error if we try to alias a keyword to something else.
                            var keyValue = contextRaw[key];
                            if ($eTO1i.Util.isPotentialKeyword(key) && $eTO1i.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                                if (key !== '@type' || (0, $3KZcf._)(contextRaw[key]) === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $5bfwT.ErrorCoded("Keywords can not be aliased to something else.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $5bfwT.ERROR_CODES.KEYWORD_REDEFINITION);
                            }
                            // Error if we try to alias to an illegal keyword
                            if ($eTO1i.Util.ALIAS_RANGE_BLACKLIST.indexOf($eTO1i.Util.getContextValueId(keyValue)) >= 0) throw new $5bfwT.ErrorCoded("Aliasing to certain keywords is not allowed.\nTried mapping ".concat(key, " to ").concat(JSON.stringify(keyValue)), $5bfwT.ERROR_CODES.INVALID_KEYWORD_ALIAS);
                            // Error if this term was marked as prefix as well
                            if (keyValue && $eTO1i.Util.isPotentialKeyword($eTO1i.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $5bfwT.ErrorCoded("Tried to use keyword aliases as prefix: '".concat(key, "': '").concat(JSON.stringify(keyValue), "'"), $5bfwT.ERROR_CODES.INVALID_TERM_DEFINITION);
                            // Loop because prefixes might be nested
                            while($eTO1i.Util.isPrefixValue(contextRaw[key])){
                                var value = contextRaw[key];
                                var changed = false;
                                if (typeof value === 'string') {
                                    contextRaw[key] = context.expandTerm(value, true);
                                    changed = changed || value !== contextRaw[key];
                                } else {
                                    var id = value['@id'];
                                    var type = value['@type'];
                                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                                    var canAddIdEntry = !('@prefix' in value) || $eTO1i.Util.isValidIri(key);
                                    if ('@id' in value) // Use @id value for expansion
                                    {
                                        if (id !== undefined && id !== null && typeof id === 'string') {
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': context.expandTerm(id, true)
                                            });
                                            changed = changed || id !== contextRaw[key]['@id'];
                                        }
                                    } else if (!$eTO1i.Util.isPotentialKeyword(key) && canAddIdEntry) {
                                        // Add an explicit @id value based on the expanded key value
                                        var newId = context.expandTerm(key, true);
                                        if (newId !== key) {
                                            // Don't set @id if expansion failed
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@id': newId
                                            });
                                            changed = true;
                                        }
                                    }
                                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                                        // First check @vocab, then fallback to @base
                                        var expandedType = context.expandTerm(type, true);
                                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                                        if (expandedType !== type) {
                                            changed = true;
                                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                                '@type': expandedType
                                            });
                                        }
                                    }
                                }
                                if (!changed) break;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ key: "normalize",
            value: function normalize(context, param) {
                var processingMode = param.processingMode, normalizeLanguageTags = param.normalizeLanguageTags;
                // Lowercase language keys in 1.0
                if (normalizeLanguageTags || processingMode === 1.0) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
                            else {
                                var value = context[key];
                                if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                    if (typeof value['@language'] === 'string') {
                                        var lowercase = value['@language'].toLowerCase();
                                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                                            '@language': lowercase
                                        });
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ key: "containersToHash",
            value: function containersToHash(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var value = context[key];
                        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                            if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                                '@container': (0, $cqEAj._)({}, value['@container'], true)
                            });
                            else if (Array.isArray(value['@container'])) {
                                var newValue = {};
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = value['@container'][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var containerValue = _step1.value;
                                        newValue[containerValue] = true;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                context[key] = Object.assign(Object.assign({}, value), {
                                    '@container': newValue
                                });
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ key: "applyScopedProtected",
            value: function applyScopedProtected(context, param, expandOptions) {
                var processingMode = param.processingMode;
                if (processingMode && processingMode >= 1.1) {
                    if (context['@protected']) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var key = _step.value;
                                if ($eTO1i.Util.isReservedInternalKeyword(key)) continue;
                                if (!$eTO1i.Util.isPotentialKeyword(key) && !$eTO1i.Util.isTermProtected(context, key)) {
                                    var value = context[key];
                                    if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object') {
                                        if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                                        context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@protected': true
                                        });
                                    } else {
                                        // Convert string-based term values to object-based values with @protected: true
                                        context[key] = {
                                            '@id': value,
                                            '@protected': true
                                        };
                                        if ($eTO1i.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                            '@prefix': true
                                        });
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        delete context['@protected'];
                    }
                }
            }
        },
        {
            /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ key: "validateKeywordRedefinitions",
            value: function validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if ($eTO1i.Util.isTermProtected(contextBefore, key)) {
                            // The entry in the context before will always be in object-mode
                            // If the new entry is in string-mode, convert it to object-mode
                            // before checking if it is identical.
                            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                                '@id': contextAfter[key],
                                '@protected': true
                            };
                            else // We modify this deliberately,
                            // as we need it for the value comparison (they must be identical modulo '@protected')),
                            // and for the fact that this new value will override the first one.
                            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                                '@protected': true
                            });
                            // Error if they are not identical
                            if (!$eTO1i.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $5bfwT.ErrorCoded("Attempted to override the protected keyword ".concat(key, " from ").concat(JSON.stringify($eTO1i.Util.getContextValueId(contextBefore[key])), " to ").concat(JSON.stringify($eTO1i.Util.getContextValueId(contextAfter[key]))), $5bfwT.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ key: "validate",
            value: function validate(context, param) {
                var processingMode = param.processingMode;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Ignore reserved internal keywords.
                        if ($eTO1i.Util.isReservedInternalKeyword(key)) continue;
                        // Do not allow empty term
                        if (key === '') throw new $5bfwT.ErrorCoded("The empty term is not allowed, got: '".concat(key, "': '").concat(JSON.stringify(context[key]), "'"), $5bfwT.ERROR_CODES.INVALID_TERM_DEFINITION);
                        var value = context[key];
                        var valueType = typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value);
                        // First check if the key is a keyword
                        if ($eTO1i.Util.isPotentialKeyword(key)) {
                            switch(key.substr(1)){
                                case 'vocab':
                                    if (value !== null && valueType !== 'string') throw new $5bfwT.ErrorCoded("Found an invalid @vocab IRI: ".concat(value), $5bfwT.ERROR_CODES.INVALID_VOCAB_MAPPING);
                                    break;
                                case 'base':
                                    if (value !== null && valueType !== 'string') throw new $5bfwT.ErrorCoded("Found an invalid @base IRI: ".concat(context[key]), $5bfwT.ERROR_CODES.INVALID_BASE_IRI);
                                    break;
                                case 'language':
                                    if (value !== null) ContextParser.validateLanguage(value, true, $5bfwT.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                                    break;
                                case 'version':
                                    if (value !== null && valueType !== 'number') throw new $5bfwT.ErrorCoded("Found an invalid @version number: ".concat(value), $5bfwT.ERROR_CODES.INVALID_VERSION_VALUE);
                                    break;
                                case 'direction':
                                    if (value !== null) ContextParser.validateDirection(value, true);
                                    break;
                                case 'propagate':
                                    if (processingMode === 1.0) throw new $5bfwT.ErrorCoded("Found an illegal @propagate keyword: ".concat(value), $5bfwT.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                    if (value !== null && valueType !== 'boolean') throw new $5bfwT.ErrorCoded("Found an invalid @propagate value: ".concat(value), $5bfwT.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                                    break;
                            }
                            // Don't allow keywords to be overridden
                            if ($eTO1i.Util.isValidKeyword(key) && $eTO1i.Util.isValidKeyword($eTO1i.Util.getContextValueId(value))) throw new $5bfwT.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat($eTO1i.Util.getContextValueId(value), "'"), $5bfwT.ERROR_CODES.KEYWORD_REDEFINITION);
                            continue;
                        }
                        // Otherwise, consider the key a term
                        if (value !== null) switch(valueType){
                            case 'string':
                                if ($eTO1i.Util.getPrefix(value, context) === key) throw new $5bfwT.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                if ($eTO1i.Util.isValidIriWeak(key)) {
                                    if (value === '@type') throw new $5bfwT.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(value, "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($eTO1i.Util.isValidIri(value) && value !== new $4GVne.JsonLdContextNormalized(context).expandTerm(key)) throw new $5bfwT.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(value, "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                break;
                            case 'object':
                                if (!$eTO1i.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $5bfwT.ErrorCoded("Missing @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Object.keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var objectKey = _step1.value;
                                        var objectValue = value[objectKey];
                                        if (!objectValue) continue;
                                        switch(objectKey){
                                            case '@id':
                                                if ($eTO1i.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $5bfwT.ErrorCoded("Illegal keyword alias in term value, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($eTO1i.Util.isValidIriWeak(key)) {
                                                    if (objectValue === '@type') throw new $5bfwT.ErrorCoded("IRIs can not be mapped to @type, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                                    else if ($eTO1i.Util.isValidIri(objectValue) && objectValue !== new $4GVne.JsonLdContextNormalized(context).expandTerm(key)) throw new $5bfwT.ErrorCoded("IRIs can not be mapped to other IRIs, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                                }
                                                if (typeof objectValue !== 'string') throw new $5bfwT.ErrorCoded("Detected non-string @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
                                                if ($eTO1i.Util.getPrefix(objectValue, context) === key) throw new $5bfwT.ErrorCoded("Detected cyclical IRI mapping in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                                break;
                                            case '@type':
                                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $5bfwT.ErrorCoded("@container: @type only allows @type: @id or @vocab, but got: '".concat(key, "': '").concat(objectValue, "'"), $5bfwT.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (typeof objectValue !== 'string') throw new $5bfwT.ErrorCoded("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"), $5bfwT.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$eTO1i.Util.isValidIri(objectValue))) throw new $5bfwT.ErrorCoded("A context @type must be an absolute IRI, found: '".concat(key, "': '").concat(objectValue, "'"), $5bfwT.ERROR_CODES.INVALID_TYPE_MAPPING);
                                                break;
                                            case '@reverse':
                                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $5bfwT.ErrorCoded("Found non-matching @id and @reverse term values in '".concat(key, "':'").concat(objectValue, "' and '").concat(value['@id'], "'"), $5bfwT.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                if ('@nest' in value) throw new $5bfwT.ErrorCoded("@nest is not allowed in the reverse property '".concat(key, "'"), $5bfwT.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                break;
                                            case '@container':
                                                if (processingMode === 1.0) {
                                                    if (Object.keys(objectValue).length > 1 || $eTO1i.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $5bfwT.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(Object.keys(objectValue), "') in 1.0, must be only one of ").concat($eTO1i.Util.CONTAINERS_1_0.join(', ')), $5bfwT.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                }
                                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(var _iterator2 = Object.keys(objectValue)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                        var containerValue = _step2.value;
                                                        if (containerValue === '@list' && value['@reverse']) throw new $5bfwT.ErrorCoded("Term value can not be @container: @list and @reverse at the same time on '".concat(key, "'"), $5bfwT.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                                        if ($eTO1i.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $5bfwT.ErrorCoded("Invalid term @container for '".concat(key, "' ('").concat(containerValue, "'), must be one of ").concat($eTO1i.Util.CONTAINERS.join(', ')), $5bfwT.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                                            _iterator2["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                                break;
                                            case '@language':
                                                ContextParser.validateLanguage(objectValue, true, $5bfwT.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                                break;
                                            case '@direction':
                                                ContextParser.validateDirection(objectValue, true);
                                                break;
                                            case '@prefix':
                                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $5bfwT.ErrorCoded("Found an invalid term @prefix boolean in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_PREFIX_VALUE);
                                                if (!('@id' in value) && !$eTO1i.Util.isValidIri(key)) throw new $5bfwT.ErrorCoded("Invalid @prefix definition for '".concat(key, "' ('").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@index':
                                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $5bfwT.ErrorCoded("Attempt to add illegal key to value object: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_TERM_DEFINITION);
                                                break;
                                            case '@nest':
                                                if ($eTO1i.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $5bfwT.ErrorCoded("Found an invalid term @nest value in: '".concat(key, "': '").concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_NEST_VALUE);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new $5bfwT.ErrorCoded("Found an invalid term value: '".concat(key, "': '").concat(value, "'"), $5bfwT.ERROR_CODES.INVALID_TERM_DEFINITION);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ key: "applyBaseEntry",
            value: function applyBaseEntry(context, options, inheritFromParent) {
                // In some special cases, this can be a string, so ignore those.
                if (typeof context === 'string') return context;
                // Give priority to @base in the parent context
                if (inheritFromParent && !('@base' in context) && options.parentContext && (0, $3KZcf._)(options.parentContext) === 'object' && '@base' in options.parentContext) {
                    context['@base'] = options.parentContext['@base'];
                    if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
                }
                // Override the base IRI if provided.
                if (options.baseIRI && !options.external) {
                    if (!('@base' in context)) {
                        // The context base is the document base
                        context['@base'] = options.baseIRI;
                        context['@__baseDocument'] = true;
                    } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$eTO1i.Util.isValidIri(context['@base'])) // The context base is relative to the document base
                    context['@base'] = (0, $hDpjF.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
                }
                return context;
            }
        },
        {
            /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ key: "normalizeContextIri",
            value: function normalizeContextIri(contextIri, baseIRI) {
                if (!$eTO1i.Util.isValidIri(contextIri)) try {
                    contextIri = (0, $hDpjF.resolve)(contextIri, baseIRI);
                } catch (_a) {
                    throw new Error("Invalid context IRI: ".concat(contextIri));
                }
                // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
                if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
                return contextIri;
            }
        },
        {
            key: "parseInnerContexts",
            value: /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ function parseInnerContexts(context, options, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, value, parentContext, e, _, _tmp, _tmp1, _1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    11,
                                    12
                                ]);
                                _iterator = (keys !== null && keys !== void 0 ? keys : Object.keys(context))[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    9
                                ];
                                key = _step.value;
                                value = context[key];
                                if (!(value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object')) return [
                                    3,
                                    8
                                ];
                                if (!('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts)) return [
                                    3,
                                    8
                                ];
                                if (!this.validateContext) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                parentContext = Object.assign(Object.assign({}, context), (0, $cqEAj._)({}, key, Object.assign({}, context[key])));
                                delete parentContext[key]['@context'];
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        parentContext: parentContext,
                                        ignoreProtection: true,
                                        ignoreRemoteScopedContexts: true,
                                        ignoreScopedContexts: true
                                    }))
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                throw new $5bfwT.ErrorCoded(e.message, $5bfwT.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                            case 6:
                                _ = Object.assign;
                                _tmp = [
                                    Object.assign({}, value)
                                ];
                                _tmp1 = {};
                                _1 = '@context';
                                return [
                                    4,
                                    this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                                        external: false,
                                        minimalProcessing: true,
                                        ignoreRemoteScopedContexts: true,
                                        parentContext: context
                                    }))
                                ];
                            case 7:
                                context[key] = _.apply(Object, _tmp.concat([
                                    (_tmp1[_1] = _state.sent().getContextRaw(), _tmp1)
                                ]));
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    context
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parse",
            value: function parse(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(context) {
                    var _this, options, // These options are only for internal use on recursive calls and should not be used by
                    // libraries consuming this function
                    internalOptions, baseIRI, parentContext, external, _options_processingMode, processingMode, normalizeLanguageTags, ignoreProtection, minimalProcessing, remoteContexts, contextIri, overriddenLoad, parsedStringContext, _, _1, contextIris, contexts, reducedContexts, importContext, newContext, keys, overlappingKeys, key, newContextWrapped;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, internalOptions = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                                baseIRI = options.baseIRI, parentContext = options.parentContext, external = options.external, _options_processingMode = options.processingMode, processingMode = _options_processingMode === void 0 ? ContextParser.DEFAULT_PROCESSING_MODE : _options_processingMode, normalizeLanguageTags = options.normalizeLanguageTags, ignoreProtection = options.ignoreProtection, minimalProcessing = options.minimalProcessing;
                                remoteContexts = options.remoteContexts || {};
                                // Avoid remote context overflows
                                if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $5bfwT.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $5bfwT.ERROR_CODES.CONTEXT_OVERFLOW);
                                if (!(context === null || context === undefined)) return [
                                    3,
                                    1
                                ];
                                // Don't allow context nullification and there are protected terms
                                if (!ignoreProtection && parentContext && $eTO1i.Util.hasProtectedTerms(parentContext)) throw new $5bfwT.ErrorCoded('Illegal context nullification when terms are protected', $5bfwT.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
                                // Context that are explicitly set to null are empty.
                                return [
                                    2,
                                    new $4GVne.JsonLdContextNormalized(this.applyBaseEntry({}, options, false))
                                ];
                            case 1:
                                if (!(typeof context === 'string')) return [
                                    3,
                                    4
                                ];
                                contextIri = this.normalizeContextIri(context, baseIRI);
                                overriddenLoad = this.getOverriddenLoad(contextIri, options);
                                if (overriddenLoad) return [
                                    2,
                                    new $4GVne.JsonLdContextNormalized(overriddenLoad)
                                ];
                                _1 = (_ = this).parse;
                                return [
                                    4,
                                    this.load(contextIri)
                                ];
                            case 2:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent(),
                                        Object.assign(Object.assign({}, options), {
                                            baseIRI: contextIri,
                                            external: true,
                                            remoteContexts: Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIri, true))
                                        })
                                    ])
                                ];
                            case 3:
                                parsedStringContext = _state.sent();
                                this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
                                return [
                                    2,
                                    parsedStringContext
                                ];
                            case 4:
                                if (!Array.isArray(context)) return [
                                    3,
                                    7
                                ];
                                // As a performance consideration, first load all external contexts in parallel.
                                contextIris = [];
                                return [
                                    4,
                                    Promise.all(context.map(function(subContext, i) {
                                        if (typeof subContext === 'string') {
                                            var contextIri = _this.normalizeContextIri(subContext, baseIRI);
                                            contextIris[i] = contextIri;
                                            var overriddenLoad = _this.getOverriddenLoad(contextIri, options);
                                            if (overriddenLoad) return overriddenLoad;
                                            return _this.load(contextIri);
                                        } else return subContext;
                                    }))
                                ];
                            case 5:
                                contexts = _state.sent();
                                // Don't apply inheritance logic on minimal processing
                                if (minimalProcessing) return [
                                    2,
                                    new $4GVne.JsonLdContextNormalized(contexts)
                                ];
                                return [
                                    4,
                                    contexts.reduce(function(accContextPromise, contextEntry, i) {
                                        return accContextPromise.then(function(accContext) {
                                            return _this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                                                baseIRI: contextIris[i] || options.baseIRI,
                                                external: !!contextIris[i] || options.external,
                                                parentContext: accContext.getContextRaw(),
                                                remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), (0, $cqEAj._)({}, contextIris[i], true)) : remoteContexts
                                            }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                                            {
                                                skipValidation: i < contexts.length - 1
                                            });
                                        });
                                    }, Promise.resolve(new $4GVne.JsonLdContextNormalized(parentContext || {})))
                                ];
                            case 6:
                                reducedContexts = _state.sent();
                                // Override the base IRI if provided.
                                this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
                                return [
                                    2,
                                    reducedContexts
                                ];
                            case 7:
                                if (!((typeof context === "undefined" ? "undefined" : (0, $3KZcf._)(context)) === 'object')) return [
                                    3,
                                    14
                                ];
                                if (!('@context' in context)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.parse(context['@context'], options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                // Make a deep clone of the given context, to avoid modifying it.
                                context = Object.assign({}, context);
                                // According to the JSON-LD spec, @base must be ignored from external contexts.
                                if (external) delete context['@base'];
                                // Override the base IRI if provided.
                                this.applyBaseEntry(context, options, true);
                                // Hashify container entries
                                // Do this before protected term validation as that influences term format
                                this.containersToHash(context);
                                // Don't perform any other modifications if only minimal processing is needed.
                                if (minimalProcessing) return [
                                    2,
                                    new $4GVne.JsonLdContextNormalized(context)
                                ];
                                // In JSON-LD 1.1, load @import'ed context prior to processing.
                                importContext = {};
                                if (!('@import' in context)) return [
                                    3,
                                    12
                                ];
                                if (!(processingMode >= 1.1)) return [
                                    3,
                                    11
                                ];
                                // Only accept string values
                                if (typeof context['@import'] !== 'string') throw new $5bfwT.ErrorCoded('An @import value must be a string, but got ' + (0, $3KZcf._)(context['@import']), $5bfwT.ERROR_CODES.INVALID_IMPORT_VALUE);
                                return [
                                    4,
                                    this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI))
                                ];
                            case 10:
                                // Load context
                                importContext = _state.sent();
                                delete context['@import'];
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                throw new $5bfwT.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $5bfwT.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                            case 12:
                                this.applyScopedProtected(importContext, {
                                    processingMode: processingMode
                                }, $4GVne.defaultExpandOptions);
                                newContext = Object.assign(importContext, context);
                                // Handle terms (before protection checks)
                                this.idifyReverseTerms(newContext);
                                this.normalize(newContext, {
                                    processingMode: processingMode,
                                    normalizeLanguageTags: normalizeLanguageTags
                                });
                                this.applyScopedProtected(newContext, {
                                    processingMode: processingMode
                                }, $4GVne.defaultExpandOptions);
                                keys = Object.keys(newContext);
                                overlappingKeys = [];
                                if ((typeof parentContext === "undefined" ? "undefined" : (0, $3KZcf._)(parentContext)) === 'object') {
                                    // Merge different parts of the final context in order
                                    for(var key in parentContext)if (key in newContext) overlappingKeys.push(key);
                                    else newContext[key] = parentContext[key];
                                }
                                // Parse inner contexts with minimal processing
                                return [
                                    4,
                                    this.parseInnerContexts(newContext, options, keys)
                                ];
                            case 13:
                                _state.sent();
                                newContextWrapped = new $4GVne.JsonLdContextNormalized(newContext);
                                // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
                                if ((newContext && newContext['@version'] || ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                                    if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                                    else if ($eTO1i.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                                    newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
                                }
                                this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
                                // In JSON-LD 1.1, check if we are not redefining any protected keywords
                                if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $4GVne.defaultExpandOptions, overlappingKeys);
                                if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                                    processingMode: processingMode
                                });
                                return [
                                    2,
                                    newContextWrapped
                                ];
                            case 14:
                                throw new $5bfwT.ErrorCoded("Tried parsing a context that is not a string, array or object, but got ".concat(context), $5bfwT.ERROR_CODES.INVALID_LOCAL_CONTEXT);
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "load",
            value: /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var cached, document, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // First try to retrieve the context from cache
                                cached = this.documentCache[url];
                                if (cached) return [
                                    2,
                                    cached
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.documentLoader.load(url)
                                ];
                            case 2:
                                document = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                throw new $5bfwT.ErrorCoded("Failed to load remote context ".concat(url, ": ").concat(e.message), $5bfwT.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
                            case 4:
                                // Validate the context
                                if (!('@context' in document)) throw new $5bfwT.ErrorCoded("Missing @context in remote context at ".concat(url), $5bfwT.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                return [
                                    2,
                                    this.documentCache[url] = document['@context']
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ key: "getOverriddenLoad",
            value: function getOverriddenLoad(url, options) {
                if (url in (options.remoteContexts || {})) {
                    if (options.ignoreRemoteScopedContexts) return url;
                    else throw new $5bfwT.ErrorCoded('Detected a cyclic context inclusion of ' + url, $5bfwT.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
                }
                return null;
            }
        },
        {
            key: "loadImportContext",
            value: /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ function loadImportContext(importContextIri) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var importContext;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.load(importContextIri)
                                ];
                            case 1:
                                importContext = _state.sent();
                                // Require the context to be a non-array object
                                if ((typeof importContext === "undefined" ? "undefined" : (0, $3KZcf._)(importContext)) !== 'object' || Array.isArray(importContext)) throw new $5bfwT.ErrorCoded('An imported context must be a single object: ' + importContextIri, $5bfwT.ERROR_CODES.INVALID_REMOTE_CONTEXT);
                                // Error if the context contains another @import
                                if ('@import' in importContext) throw new $5bfwT.ErrorCoded('An imported context can not import another context: ' + importContextIri, $5bfwT.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                                importContext = Object.assign({}, importContext);
                                // Containers have to be converted into hash values the same way as for the importing context
                                // Otherwise context validation will fail for container values
                                this.containersToHash(importContext);
                                return [
                                    2,
                                    importContext
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "validateLanguage",
            value: /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateLanguage(value, strictRange, errorCode) {
                if (typeof value !== 'string') throw new $5bfwT.ErrorCoded("The value of an '@language' must be a string, got '".concat(JSON.stringify(value), "'"), errorCode);
                if (!$eTO1i.Util.REGEX_LANGUAGE_TAG.test(value)) {
                    if (strictRange) throw new $5bfwT.ErrorCoded("The value of an '@language' must be a valid language tag, got '".concat(JSON.stringify(value), "'"), errorCode);
                    else return false;
                }
                return true;
            }
        },
        {
            key: "validateDirection",
            value: /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ function validateDirection(value, strictValues) {
                if (typeof value !== 'string') throw new $5bfwT.ErrorCoded("The value of an '@direction' must be a string, got '".concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_BASE_DIRECTION);
                if (!$eTO1i.Util.REGEX_DIRECTION_TAG.test(value)) {
                    if (strictValues) throw new $5bfwT.ErrorCoded("The value of an '@direction' must be 'ltr' or 'rtl', got '".concat(JSON.stringify(value), "'"), $5bfwT.ERROR_CODES.INVALID_BASE_DIRECTION);
                    else return false;
                }
                return true;
            }
        }
    ]);
    return ContextParser;
}();
$966021a573605ddf$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $966021a573605ddf$var$ContextParser;

});
parcelRegister("8TS2u", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
(function(self1) {
    var irrelevant = function(exports) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis !== 'undefined' && globalThis || typeof self1 !== 'undefined' && self1 || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function next() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports.DOMException = g.DOMException;
        try {
            new exports.DOMException();
        } catch (err) {
            exports.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && (0, $3KZcf._)(init.headers) === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports.Headers = Headers;
        exports.Request = Request;
        exports.Response = Response;
        exports.fetch = fetch;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
})(typeof self !== 'undefined' ? self : undefined);

});

parcelRegister("5bfwT", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $8AW3P = parcelRequire("8AW3P");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ var $3c5a06a9724b4880$var$ErrorCoded = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(ErrorCoded, Error1);
    function ErrorCoded(message, code) {
        (0, $jGAMp._)(this, ErrorCoded);
        var _this;
        _this = (0, $kzDuW._)(this, ErrorCoded, [
            message
        ]);
        _this.code = code;
        return _this;
    }
    return ErrorCoded;
}((0, $8AW3P._)(Error));
module.exports.ErrorCoded = $3c5a06a9724b4880$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $3c5a06a9724b4880$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($3c5a06a9724b4880$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("fSxXr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;
parcelRequire("8TS2u");

var $5bfwT = parcelRequire("5bfwT");

var $fdIar = parcelRequire("fdIar");

var $hDpjF = parcelRequire("hDpjF");
/**
 * Loads documents via the fetch API.
 */ var $b8f63d737500f801$var$FetchDocumentLoader = /*#__PURE__*/ function() {
    function FetchDocumentLoader(fetcher) {
        (0, $jGAMp._)(this, FetchDocumentLoader);
        this.fetcher = fetcher;
    }
    (0, $byiyg._)(FetchDocumentLoader, [
        {
            key: "load",
            value: function load(url) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var response, mediaType, colonPos, alternateUrl;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (this.fetcher || fetch)(url, {
                                        headers: new Headers({
                                            accept: 'application/ld+json'
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!(response.ok && response.headers)) return [
                                    3,
                                    5
                                ];
                                mediaType = response.headers.get('Content-Type');
                                if (mediaType) {
                                    colonPos = mediaType.indexOf(';');
                                    if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
                                }
                                if (!(mediaType === 'application/ld+json')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                // Return JSON-LD if proper content type was returned
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                // Check for alternate link for a non-JSON-LD response
                                if (response.headers.has('Link')) {
                                    ;
                                    response.headers.forEach(function(value, key) {
                                        if (key === 'link') {
                                            var linkHeader = (0, $fdIar.parse)(value);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = linkHeader.get('type', 'application/ld+json')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var link = _step.value;
                                                    if (link.rel === 'alternate') {
                                                        if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                                        alternateUrl = (0, $hDpjF.resolve)(link.uri, url);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                    if (alternateUrl) return [
                                        2,
                                        this.load(alternateUrl)
                                    ];
                                }
                                throw new $5bfwT.ErrorCoded("Unsupported JSON-LD media type ".concat(mediaType), $5bfwT.ERROR_CODES.LOADING_DOCUMENT_FAILED);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error(response.statusText || "Status code: ".concat(response.status));
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return FetchDocumentLoader;
}();
module.exports.FetchDocumentLoader = $b8f63d737500f801$var$FetchDocumentLoader;

});

parcelRegister("4GVne", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $hDpjF = parcelRequire("hDpjF");

var $5bfwT = parcelRequire("5bfwT");

var $eTO1i = parcelRequire("eTO1i");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ var $36a796e9d5fc01fa$var$JsonLdContextNormalized = /*#__PURE__*/ function() {
    function JsonLdContextNormalized(contextRaw) {
        (0, $jGAMp._)(this, JsonLdContextNormalized);
        this.contextRaw = contextRaw;
    }
    (0, $byiyg._)(JsonLdContextNormalized, [
        {
            /**
     * @return The raw inner context.
     */ key: "getContextRaw",
            value: function getContextRaw() {
                return this.contextRaw;
            }
        },
        {
            /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ key: "expandTerm",
            value: function expandTerm(term, expandVocab) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultExpandOptions;
                var contextValue = this.contextRaw[term];
                // Immediately return if the term was disabled in the context
                if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
                // Check the @id
                var validIriMapping = true;
                if (contextValue && expandVocab) {
                    var value = $eTO1i.Util.getContextValueId(contextValue);
                    if (value && value !== term) {
                        if (typeof value !== 'string' || !$eTO1i.Util.isValidIri(value) && !$eTO1i.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                        {
                            if (!$eTO1i.Util.isPotentialKeyword(value)) validIriMapping = false;
                        } else return value;
                    }
                }
                // Check if the term is prefixed
                var prefix = $eTO1i.Util.getPrefix(term, this.contextRaw);
                var vocab = this.contextRaw['@vocab'];
                var vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
                var base = this.contextRaw['@base'];
                var potentialKeyword = $eTO1i.Util.isPotentialKeyword(term);
                if (prefix) {
                    var contextPrefixValue = this.contextRaw[prefix];
                    var value1 = $eTO1i.Util.getContextValueId(contextPrefixValue);
                    if (value1) {
                        if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                            // If we have a simple term definition,
                            // check the last character of the prefix to determine whether or not it is a prefix.
                            // Validate that prefix ends with gen-delim character, unless @prefix is true
                            if (!$eTO1i.Util.isSimpleTermDefinitionPrefix(value1, options)) // Treat the term as an absolute IRI
                            return term;
                        } else {
                            // If we have an expanded term definition, default to @prefix: false
                            if (value1[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                            return term;
                        }
                        return value1 + term.substr(prefix.length + 1);
                    }
                } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$eTO1i.Util.isCompactIri(term)) {
                    if (vocabRelative) {
                        if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $hDpjF.resolve)(vocab, base) : '') + term;
                        else throw new $5bfwT.ErrorCoded("Relative vocab expansion for term '".concat(term, "' with vocab '").concat(vocab, "' is not allowed."), $5bfwT.ERROR_CODES.INVALID_VOCAB_MAPPING);
                    } else return vocab + term;
                } else if (!expandVocab && base && !potentialKeyword && !$eTO1i.Util.isCompactIri(term)) return (0, $hDpjF.resolve)(term, base);
                // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
                if (validIriMapping) return term;
                else throw new $5bfwT.ErrorCoded("Invalid IRI mapping found for context entry '".concat(term, "': '").concat(JSON.stringify(contextValue), "'"), $5bfwT.ERROR_CODES.INVALID_IRI_MAPPING);
            }
        },
        {
            /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ key: "compactIri",
            value: function compactIri(iri, vocab) {
                // Try @vocab compacting
                if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
                // Try @base compacting
                if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
                // Loop over all terms in the context
                // This will try to prefix as short as possible.
                // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
                var shortestPrefixing = {
                    prefix: '',
                    suffix: iri
                };
                for(var key in this.contextRaw){
                    var value = this.contextRaw[key];
                    if (value && !$eTO1i.Util.isPotentialKeyword(key)) {
                        var contextIri = $eTO1i.Util.getContextValueId(value);
                        if (iri.startsWith(contextIri)) {
                            var suffix = iri.substr(contextIri.length);
                            if (!suffix) {
                                if (vocab) // Immediately return on compacted alias
                                return key;
                            } else if (suffix.length < shortestPrefixing.suffix.length) {
                                // Overwrite the shortest prefix
                                shortestPrefixing.prefix = key;
                                shortestPrefixing.suffix = suffix;
                            }
                        }
                    }
                }
                // Return the shortest prefix
                if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
                return iri;
            }
        }
    ]);
    return JsonLdContextNormalized;
}();
module.exports.JsonLdContextNormalized = $36a796e9d5fc01fa$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("eTO1i", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
var $ad8d00a6c90f1203$var$Util = /*#__PURE__*/ function() {
    function Util() {
        (0, $jGAMp._)(this, Util);
    }
    (0, $byiyg._)(Util, null, [
        {
            key: "isCompactIri",
            value: /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ function isCompactIri(term) {
                return term.indexOf(':') > 0 && !(term && term[0] === '#');
            }
        },
        {
            key: "getPrefix",
            value: /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ function getPrefix(term, context) {
                // Do not consider relative IRIs starting with a hash as compact IRIs
                if (term && term[0] === '#') return null;
                var separatorPos = term.indexOf(':');
                if (separatorPos >= 0) {
                    // Suffix can not begin with two slashes
                    if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
                    var prefix = term.substr(0, separatorPos);
                    // Prefix can not be an underscore (this is a blank node)
                    if (prefix === '_') return null;
                    // Prefix must match a term in the active context
                    if (context[prefix]) return prefix;
                }
                return null;
            }
        },
        {
            key: "getContextValueId",
            value: /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ function getContextValueId(contextValue) {
                if (contextValue === null || typeof contextValue === 'string') return contextValue;
                var id = contextValue['@id'];
                return id ? id : null;
            }
        },
        {
            key: "isSimpleTermDefinitionPrefix",
            value: /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ function isSimpleTermDefinitionPrefix(value, options) {
                return !Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || Util.isPrefixIriEndingWithGenDelim(value)));
            }
        },
        {
            key: "isPotentialKeyword",
            value: /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ function isPotentialKeyword(keyword) {
                return typeof keyword === 'string' && Util.KEYWORD_REGEX.test(keyword);
            }
        },
        {
            key: "isPrefixIriEndingWithGenDelim",
            value: /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ function isPrefixIriEndingWithGenDelim(prefixIri) {
                return Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
            }
        },
        {
            key: "isPrefixValue",
            value: /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ function isPrefixValue(value) {
                return value && (typeof value === 'string' || value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object');
            }
        },
        {
            key: "isValidIri",
            value: /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIri(iri) {
                return Boolean(iri && Util.IRI_REGEX.test(iri));
            }
        },
        {
            key: "isValidIriWeak",
            value: /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ function isValidIriWeak(iri) {
                return !!iri && iri[0] !== ':' && Util.IRI_REGEX_WEAK.test(iri);
            }
        },
        {
            key: "isValidKeyword",
            value: /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ function isValidKeyword(keyword) {
                return Util.VALID_KEYWORDS[keyword];
            }
        },
        {
            key: "isTermProtected",
            value: /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ function isTermProtected(context, key) {
                var value = context[key];
                return !(typeof value === 'string') && value && value['@protected'];
            }
        },
        {
            key: "hasProtectedTerms",
            value: /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ function hasProtectedTerms(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(context)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (Util.isTermProtected(context, key)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isReservedInternalKeyword",
            value: /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ function isReservedInternalKeyword(key) {
                return key.startsWith('@__');
            }
        },
        {
            key: "deepEqual",
            value: /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ function deepEqual(object1, object2) {
                var _this = this;
                var objKeys1 = Object.keys(object1);
                var objKeys2 = Object.keys(object2);
                if (objKeys1.length !== objKeys2.length) return false;
                return objKeys1.every(function(key) {
                    var value1 = object1[key];
                    var value2 = object2[key];
                    return value1 === value2 || value1 !== null && value2 !== null && (typeof value1 === "undefined" ? "undefined" : (0, $3KZcf._)(value1)) === "object" && (typeof value2 === "undefined" ? "undefined" : (0, $3KZcf._)(value2)) === "object" && _this.deepEqual(value1, value2);
                });
            }
        }
    ]);
    return Util;
}();
// Regex for valid IRIs
$ad8d00a6c90f1203$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$ad8d00a6c90f1203$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$ad8d00a6c90f1203$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$ad8d00a6c90f1203$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$ad8d00a6c90f1203$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$ad8d00a6c90f1203$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$ad8d00a6c90f1203$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$ad8d00a6c90f1203$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$ad8d00a6c90f1203$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$ad8d00a6c90f1203$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$ad8d00a6c90f1203$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$ad8d00a6c90f1203$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $ad8d00a6c90f1203$var$Util;

});



parcelRegister("kHWAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6DCVI", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("8Mtih", function(module, exports) {
"use strict";
var $6649878f5ee51b6b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6649878f5ee51b6b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6649878f5ee51b6b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6649878f5ee51b6b$var$__exportStar((parcelRequire("7alr1")), module.exports);

$6649878f5ee51b6b$var$__exportStar((parcelRequire("b7JcJ")), module.exports);

});
parcelRegister("7alr1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaPatchSparqlUpdate = void 0;

var $f3FhC = parcelRequire("f3FhC");

var $kNNoa = parcelRequire("kNNoa");

var $b7JcJ = parcelRequire("b7JcJ");
/**
 * A comunica Patch SPARQL Update RDF Update Hypermedia Actor.
 */ var $537a1816a849856a$var$ActorRdfUpdateHypermediaPatchSparqlUpdate = /*#__PURE__*/ function(_bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia) {
    (0, $i3fW3._)(ActorRdfUpdateHypermediaPatchSparqlUpdate, _bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia);
    function ActorRdfUpdateHypermediaPatchSparqlUpdate(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateHypermediaPatchSparqlUpdate);
        return (0, $kzDuW._)(this, ActorRdfUpdateHypermediaPatchSparqlUpdate, [
            args,
            'patchSparqlUpdate'
        ]);
    }
    (0, $byiyg._)(ActorRdfUpdateHypermediaPatchSparqlUpdate, [
        {
            key: "testMetadata",
            value: function testMetadata(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.forceDestinationType && !action.metadata.patchSparqlUpdate) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not detect a destination with 'application/sparql-update' as 'Accept-Patch' header."))
                        ];
                        if (!action.forceDestinationType && !action.exists) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only patch a destination that already exists."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        this.logInfo(action.context, "Identified as patchSparqlUpdate destination: ".concat(action.url));
                        return [
                            2,
                            {
                                destination: new $b7JcJ.QuadDestinationPatchSparqlUpdate(action.url, action.context, this.mediatorHttp)
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfUpdateHypermediaPatchSparqlUpdate;
}($f3FhC.ActorRdfUpdateHypermedia);
module.exports.ActorRdfUpdateHypermediaPatchSparqlUpdate = $537a1816a849856a$var$ActorRdfUpdateHypermediaPatchSparqlUpdate;

});
parcelRegister("f3FhC", function(module, exports) {
"use strict";
var $af6728ce1bef8c05$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $af6728ce1bef8c05$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $af6728ce1bef8c05$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$af6728ce1bef8c05$var$__exportStar((parcelRequire("1InXp")), module.exports);

});
parcelRegister("1InXp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermedia = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for rdf-update-hypermedia events.
 *
 * Actor types:
 * * Input:  IActionRdfUpdateHypermedia:      The metadata in the document.
 * * Test:   <none>
 * * Output: IActorRdfUpdateHypermediaOutput: An RDF destination.
 *
 * @see IActionRdfUpdateHypermedia
 * @see IActorRdfUpdateHypermediaOutput
 */ var $13fc7bee33b506f1$var$ActorRdfUpdateHypermedia = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorRdfUpdateHypermedia, _core_1_Actor);
    function ActorRdfUpdateHypermedia(args, destinationType) {
        (0, $jGAMp._)(this, ActorRdfUpdateHypermedia);
        var _this;
        _this = (0, $kzDuW._)(this, ActorRdfUpdateHypermedia, [
            args
        ]);
        _this.destinationType = destinationType;
        return _this;
    }
    (0, $byiyg._)(ActorRdfUpdateHypermedia, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.forceDestinationType && this.destinationType !== action.forceDestinationType) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " is not able to handle destination type ").concat(action.forceDestinationType, "."))
                        ];
                        return [
                            2,
                            this.testMetadata(action)
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfUpdateHypermedia;
}($kNNoa.Actor);
module.exports.ActorRdfUpdateHypermedia = $13fc7bee33b506f1$var$ActorRdfUpdateHypermedia;

});


parcelRegister("b7JcJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationPatchSparqlUpdate = void 0;

var $2terW = parcelRequire("2terW");

var $aafx9 = parcelRequire("aafx9");

var $3veIK = parcelRequire("3veIK");

var $1Cx9n = parcelRequire("1Cx9n");
/**
 * A quad destination that represents a resource that is patchable via SPARQL Update.
 */ var $819369c84c7d2e4f$var$QuadDestinationPatchSparqlUpdate = /*#__PURE__*/ function() {
    function QuadDestinationPatchSparqlUpdate(url, context, mediatorHttp) {
        (0, $jGAMp._)(this, QuadDestinationPatchSparqlUpdate);
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
    }
    (0, $byiyg._)(QuadDestinationPatchSparqlUpdate, [
        {
            key: "update",
            value: function update(quadStreams) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var queryStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Create combined query stream with quads to insert and delete
                                queryStream = this.createCombinedQuadsQuery(quadStreams.insert, quadStreams["delete"]);
                                return [
                                    4,
                                    this.wrapSparqlUpdateRequest(queryStream)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createCombinedQuadsQuery",
            value: function createCombinedQuadsQuery(quadsToInsert, quadsToDelete) {
                return new $aafx9.ArrayIterator([], {
                    autoStart: false
                }).append(this.createQuadsQuery('DELETE', quadsToDelete)).append(quadsToDelete && quadsToInsert ? [
                    ' ;\n'
                ] : []).append(this.createQuadsQuery('INSERT', quadsToInsert));
            }
        },
        {
            key: "createQuadsQuery",
            value: function createQuadsQuery(type, quads) {
                if (!quads) return new $aafx9.ArrayIterator([], {
                    autoStart: false
                });
                // Wrap triples in DATA block
                return quads.map(function(quad) {
                    var stringQuad = "".concat((0, $3veIK.termToString)(quad.subject), " ").concat((0, $3veIK.termToString)(quad.predicate), " ").concat((0, $3veIK.termToString)(quad.object), " .");
                    if (quad.graph.termType === 'DefaultGraph') stringQuad = "  ".concat(stringQuad, "\n");
                    else stringQuad = "  GRAPH ".concat((0, $3veIK.termToString)(quad.graph), " { ").concat(stringQuad, " }\n");
                    return stringQuad;
                }).prepend([
                    "".concat(type, " DATA {\n")
                ]).append([
                    '}'
                ]);
            }
        },
        {
            key: "wrapSparqlUpdateRequest",
            value: function wrapSparqlUpdateRequest(queryStream) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var readable, headers, httpResponse;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                readable = new $1Cx9n.Readable();
                                readable.wrap(queryStream);
                                // Send data in PUT request
                                headers = new Headers({
                                    'content-type': 'application/sparql-update'
                                });
                                return [
                                    4,
                                    this.mediatorHttp.mediate({
                                        context: this.context,
                                        init: {
                                            headers: headers,
                                            method: 'PATCH',
                                            body: $2terW.ActorHttp.toWebReadableStream(readable)
                                        },
                                        input: this.url
                                    })
                                ];
                            case 1:
                                httpResponse = _state.sent();
                                return [
                                    4,
                                    (0, $2terW.validateAndCloseHttpResponse)(this.url, httpResponse)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteGraphs",
            value: function deleteGraphs(_graphs, _requireExistence, _dropGraphs) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error("Patch-based SPARQL Update destinations don't support named graphs");
                    });
                })();
            }
        },
        {
            key: "createGraphs",
            value: function createGraphs(_graphs, _requireNonExistence) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error("Patch-based SPARQL Update destinations don't support named graphs");
                    });
                })();
            }
        }
    ]);
    return QuadDestinationPatchSparqlUpdate;
}();
module.exports.QuadDestinationPatchSparqlUpdate = $819369c84c7d2e4f$var$QuadDestinationPatchSparqlUpdate;

});
parcelRegister("1Cx9n", function(module, exports) {
'use strict';

var $lnO7E = parcelRequire("lnO7E");

var $2VyQ7 = parcelRequire("2VyQ7");
var $12e30e054ab1d3c3$var$originalDestroy = $lnO7E.Readable.destroy;
module.exports = $lnO7E.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $lnO7E._uint8ArrayToBuffer;
module.exports._isUint8Array = $lnO7E._isUint8Array;
module.exports.isDisturbed = $lnO7E.isDisturbed;
module.exports.isErrored = $lnO7E.isErrored;
module.exports.isReadable = $lnO7E.isReadable;
module.exports.Readable = $lnO7E.Readable;
module.exports.Writable = $lnO7E.Writable;
module.exports.Duplex = $lnO7E.Duplex;
module.exports.Transform = $lnO7E.Transform;
module.exports.PassThrough = $lnO7E.PassThrough;
module.exports.addAbortSignal = $lnO7E.addAbortSignal;
module.exports.finished = $lnO7E.finished;
module.exports.destroy = $lnO7E.destroy;
module.exports.destroy = $12e30e054ab1d3c3$var$originalDestroy;
module.exports.pipeline = $lnO7E.pipeline;
module.exports.compose = $lnO7E.compose;
Object.defineProperty($lnO7E, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $2VyQ7;
    }
});
module.exports.Stream = $lnO7E.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("lnO7E", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $2P1XW = parcelRequire("2P1XW");
var $f912a03ca49a8a1d$require$Buffer = $2P1XW.Buffer;

var $492qd = parcelRequire("492qd");
/* replacement end */ var $f912a03ca49a8a1d$var$ObjectDefineProperty = $492qd.ObjectDefineProperty, $f912a03ca49a8a1d$var$ObjectKeys = $492qd.ObjectKeys, $f912a03ca49a8a1d$var$ReflectApply = $492qd.ReflectApply;

var $i2eun = parcelRequire("i2eun");
var $f912a03ca49a8a1d$var$_require_promisify = $i2eun.promisify, $f912a03ca49a8a1d$var$customPromisify = $f912a03ca49a8a1d$var$_require_promisify.custom;

var $gakAs = parcelRequire("gakAs");
var $f912a03ca49a8a1d$var$streamReturningOperators = $gakAs.streamReturningOperators, $f912a03ca49a8a1d$var$promiseReturningOperators = $gakAs.promiseReturningOperators;

var $j63nd = parcelRequire("j63nd");
var $f912a03ca49a8a1d$var$ERR_ILLEGAL_CONSTRUCTOR = $j63nd.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $j5AX8 = parcelRequire("j5AX8");

var $cdB5t = parcelRequire("cdB5t");
var $f912a03ca49a8a1d$var$setDefaultHighWaterMark = $cdB5t.setDefaultHighWaterMark, $f912a03ca49a8a1d$var$getDefaultHighWaterMark = $cdB5t.getDefaultHighWaterMark;

var $cqclD = parcelRequire("cqclD");
var $f912a03ca49a8a1d$require$pipeline = $cqclD.pipeline;

var $kKCEf = parcelRequire("kKCEf");
var $f912a03ca49a8a1d$require$destroyer = $kKCEf.destroyer;

var $32wt8 = parcelRequire("32wt8");
var $f912a03ca49a8a1d$var$internalBuffer = {};

var $2VyQ7 = parcelRequire("2VyQ7");

var $buMDs = parcelRequire("buMDs");

var $f912a03ca49a8a1d$var$Stream = module.exports = (parcelRequire("lDfEi")).Stream;
$f912a03ca49a8a1d$var$Stream.isDestroyed = $buMDs.isDestroyed;
$f912a03ca49a8a1d$var$Stream.isDisturbed = $buMDs.isDisturbed;
$f912a03ca49a8a1d$var$Stream.isErrored = $buMDs.isErrored;
$f912a03ca49a8a1d$var$Stream.isReadable = $buMDs.isReadable;
$f912a03ca49a8a1d$var$Stream.isWritable = $buMDs.isWritable;

$f912a03ca49a8a1d$var$Stream.Readable = (parcelRequire("ciPy6"));
var $f912a03ca49a8a1d$var$_iteratorNormalCompletion = true, $f912a03ca49a8a1d$var$_didIteratorError = false, $f912a03ca49a8a1d$var$_iteratorError = undefined;
try {
    for(var $f912a03ca49a8a1d$var$_iterator = $f912a03ca49a8a1d$var$ObjectKeys($f912a03ca49a8a1d$var$streamReturningOperators)[Symbol.iterator](), $f912a03ca49a8a1d$var$_step; !($f912a03ca49a8a1d$var$_iteratorNormalCompletion = ($f912a03ca49a8a1d$var$_step = $f912a03ca49a8a1d$var$_iterator.next()).done); $f912a03ca49a8a1d$var$_iteratorNormalCompletion = true){
        var $f912a03ca49a8a1d$var$key = $f912a03ca49a8a1d$var$_step.value;
        var $f912a03ca49a8a1d$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $f912a03ca49a8a1d$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $f912a03ca49a8a1d$var$Stream.Readable.from($f912a03ca49a8a1d$var$ReflectApply($f912a03ca49a8a1d$var$op, this, args));
        };
        var $f912a03ca49a8a1d$var$op = $f912a03ca49a8a1d$var$streamReturningOperators[$f912a03ca49a8a1d$var$key];
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$fn, 'name', {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$op.name
        });
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$fn, 'length', {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$op.length
        });
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$Stream.Readable.prototype, $f912a03ca49a8a1d$var$key, {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $f912a03ca49a8a1d$var$_didIteratorError = true;
    $f912a03ca49a8a1d$var$_iteratorError = err;
} finally{
    try {
        if (!$f912a03ca49a8a1d$var$_iteratorNormalCompletion && $f912a03ca49a8a1d$var$_iterator["return"] != null) {
            $f912a03ca49a8a1d$var$_iterator["return"]();
        }
    } finally{
        if ($f912a03ca49a8a1d$var$_didIteratorError) {
            throw $f912a03ca49a8a1d$var$_iteratorError;
        }
    }
}
var $f912a03ca49a8a1d$var$_iteratorNormalCompletion1 = true, $f912a03ca49a8a1d$var$_didIteratorError1 = false, $f912a03ca49a8a1d$var$_iteratorError1 = undefined;
try {
    for(var $f912a03ca49a8a1d$var$_iterator1 = $f912a03ca49a8a1d$var$ObjectKeys($f912a03ca49a8a1d$var$promiseReturningOperators)[Symbol.iterator](), $f912a03ca49a8a1d$var$_step1; !($f912a03ca49a8a1d$var$_iteratorNormalCompletion1 = ($f912a03ca49a8a1d$var$_step1 = $f912a03ca49a8a1d$var$_iterator1.next()).done); $f912a03ca49a8a1d$var$_iteratorNormalCompletion1 = true){
        var $f912a03ca49a8a1d$var$key1 = $f912a03ca49a8a1d$var$_step1.value;
        var $f912a03ca49a8a1d$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $f912a03ca49a8a1d$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $f912a03ca49a8a1d$var$ReflectApply($f912a03ca49a8a1d$var$op1, this, args);
        };
        var $f912a03ca49a8a1d$var$op1 = $f912a03ca49a8a1d$var$promiseReturningOperators[$f912a03ca49a8a1d$var$key1];
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$fn1, 'name', {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$op1.name
        });
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$fn1, 'length', {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$op1.length
        });
        $f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$Stream.Readable.prototype, $f912a03ca49a8a1d$var$key1, {
            __proto__: null,
            value: $f912a03ca49a8a1d$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $f912a03ca49a8a1d$var$_didIteratorError1 = true;
    $f912a03ca49a8a1d$var$_iteratorError1 = err;
} finally{
    try {
        if (!$f912a03ca49a8a1d$var$_iteratorNormalCompletion1 && $f912a03ca49a8a1d$var$_iterator1["return"] != null) {
            $f912a03ca49a8a1d$var$_iterator1["return"]();
        }
    } finally{
        if ($f912a03ca49a8a1d$var$_didIteratorError1) {
            throw $f912a03ca49a8a1d$var$_iteratorError1;
        }
    }
}

$f912a03ca49a8a1d$var$Stream.Writable = (parcelRequire("5HHkr"));

$f912a03ca49a8a1d$var$Stream.Duplex = (parcelRequire("6M6ea"));

$f912a03ca49a8a1d$var$Stream.Transform = (parcelRequire("aa0uq"));

$f912a03ca49a8a1d$var$Stream.PassThrough = (parcelRequire("bMmEU"));
$f912a03ca49a8a1d$var$Stream.pipeline = $f912a03ca49a8a1d$require$pipeline;

var $1xKKt = parcelRequire("1xKKt");
var $f912a03ca49a8a1d$require$addAbortSignal = $1xKKt.addAbortSignal;
$f912a03ca49a8a1d$var$Stream.addAbortSignal = $f912a03ca49a8a1d$require$addAbortSignal;
$f912a03ca49a8a1d$var$Stream.finished = $32wt8;
$f912a03ca49a8a1d$var$Stream.destroy = $f912a03ca49a8a1d$require$destroyer;
$f912a03ca49a8a1d$var$Stream.compose = $j5AX8;
$f912a03ca49a8a1d$var$Stream.setDefaultHighWaterMark = $f912a03ca49a8a1d$var$setDefaultHighWaterMark;
$f912a03ca49a8a1d$var$Stream.getDefaultHighWaterMark = $f912a03ca49a8a1d$var$getDefaultHighWaterMark;
$f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $2VyQ7;
    }
});
$f912a03ca49a8a1d$var$ObjectDefineProperty($f912a03ca49a8a1d$require$pipeline, $f912a03ca49a8a1d$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2VyQ7.pipeline;
    }
});
$f912a03ca49a8a1d$var$ObjectDefineProperty($32wt8, $f912a03ca49a8a1d$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2VyQ7.finished;
    }
});
// Backwards-compat with node 0.4.x
$f912a03ca49a8a1d$var$Stream.Stream = $f912a03ca49a8a1d$var$Stream;
$f912a03ca49a8a1d$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$f912a03ca49a8a1d$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $f912a03ca49a8a1d$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("2P1XW", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $20e1de903f33300b$export$a143d493d941bafc; }, function (v) { return $20e1de903f33300b$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $20e1de903f33300b$export$f99ded8fe4b79145; }, function (v) { return $20e1de903f33300b$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $20e1de903f33300b$export$a143d493d941bafc;
var $20e1de903f33300b$export$e4cf37d7f6fb9e0a;
var $20e1de903f33300b$export$f99ded8fe4b79145;
var $20e1de903f33300b$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $20e1de903f33300b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$20e1de903f33300b$export$a143d493d941bafc = $20e1de903f33300b$var$Buffer;
$20e1de903f33300b$export$e4cf37d7f6fb9e0a = $20e1de903f33300b$var$SlowBuffer;
$20e1de903f33300b$export$f99ded8fe4b79145 = 50;
var $20e1de903f33300b$var$K_MAX_LENGTH = 0x7fffffff;
$20e1de903f33300b$export$599f31c3813fae4d = $20e1de903f33300b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $20e1de903f33300b$var$Buffer.TYPED_ARRAY_SUPPORT = $20e1de903f33300b$var$typedArraySupport();
if (!$20e1de903f33300b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $20e1de903f33300b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($20e1de903f33300b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$20e1de903f33300b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($20e1de903f33300b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$20e1de903f33300b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $20e1de903f33300b$var$createBuffer(length) {
    if (length > $20e1de903f33300b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $20e1de903f33300b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $20e1de903f33300b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $20e1de903f33300b$var$allocUnsafe(arg);
    }
    return $20e1de903f33300b$var$from(arg, encodingOrOffset, length);
}
$20e1de903f33300b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $20e1de903f33300b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $20e1de903f33300b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $20e1de903f33300b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($20e1de903f33300b$var$isInstance(value, ArrayBuffer) || value && $20e1de903f33300b$var$isInstance(value.buffer, ArrayBuffer)) return $20e1de903f33300b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($20e1de903f33300b$var$isInstance(value, SharedArrayBuffer) || value && $20e1de903f33300b$var$isInstance(value.buffer, SharedArrayBuffer))) return $20e1de903f33300b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $20e1de903f33300b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $20e1de903f33300b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $20e1de903f33300b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $20e1de903f33300b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $20e1de903f33300b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($20e1de903f33300b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($20e1de903f33300b$var$Buffer, Uint8Array);
function $20e1de903f33300b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $20e1de903f33300b$var$alloc(size, fill, encoding) {
    $20e1de903f33300b$var$assertSize(size);
    if (size <= 0) return $20e1de903f33300b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $20e1de903f33300b$var$createBuffer(size).fill(fill, encoding) : $20e1de903f33300b$var$createBuffer(size).fill(fill);
    return $20e1de903f33300b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $20e1de903f33300b$var$Buffer.alloc = function(size, fill, encoding) {
    return $20e1de903f33300b$var$alloc(size, fill, encoding);
};
function $20e1de903f33300b$var$allocUnsafe(size) {
    $20e1de903f33300b$var$assertSize(size);
    return $20e1de903f33300b$var$createBuffer(size < 0 ? 0 : $20e1de903f33300b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $20e1de903f33300b$var$Buffer.allocUnsafe = function(size) {
    return $20e1de903f33300b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $20e1de903f33300b$var$Buffer.allocUnsafeSlow = function(size) {
    return $20e1de903f33300b$var$allocUnsafe(size);
};
function $20e1de903f33300b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$20e1de903f33300b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $20e1de903f33300b$var$byteLength(string, encoding) | 0;
    var buf = $20e1de903f33300b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $20e1de903f33300b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $20e1de903f33300b$var$checked(array.length) | 0;
    var buf = $20e1de903f33300b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $20e1de903f33300b$var$fromArrayView(arrayView) {
    if ($20e1de903f33300b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $20e1de903f33300b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $20e1de903f33300b$var$fromArrayLike(arrayView);
}
function $20e1de903f33300b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $20e1de903f33300b$var$Buffer.prototype);
    return buf;
}
function $20e1de903f33300b$var$fromObject(obj) {
    if ($20e1de903f33300b$var$Buffer.isBuffer(obj)) {
        var len = $20e1de903f33300b$var$checked(obj.length) | 0;
        var buf = $20e1de903f33300b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $20e1de903f33300b$var$numberIsNaN(obj.length)) return $20e1de903f33300b$var$createBuffer(0);
        return $20e1de903f33300b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $20e1de903f33300b$var$fromArrayLike(obj.data);
}
function $20e1de903f33300b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $20e1de903f33300b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $20e1de903f33300b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $20e1de903f33300b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $20e1de903f33300b$var$Buffer.alloc(+length);
}
$20e1de903f33300b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $20e1de903f33300b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$20e1de903f33300b$var$Buffer.compare = function compare(a, b) {
    if ($20e1de903f33300b$var$isInstance(a, Uint8Array)) a = $20e1de903f33300b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($20e1de903f33300b$var$isInstance(b, Uint8Array)) b = $20e1de903f33300b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$20e1de903f33300b$var$Buffer.isBuffer(a) || !$20e1de903f33300b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$20e1de903f33300b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$20e1de903f33300b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $20e1de903f33300b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $20e1de903f33300b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($20e1de903f33300b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$20e1de903f33300b$var$Buffer.isBuffer(buf)) buf = $20e1de903f33300b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$20e1de903f33300b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $20e1de903f33300b$var$byteLength(string, encoding) {
    if ($20e1de903f33300b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $20e1de903f33300b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $20e1de903f33300b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $20e1de903f33300b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $20e1de903f33300b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$20e1de903f33300b$var$Buffer.byteLength = $20e1de903f33300b$var$byteLength;
function $20e1de903f33300b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $20e1de903f33300b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $20e1de903f33300b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $20e1de903f33300b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $20e1de903f33300b$var$latin1Slice(this, start, end);
        case 'base64':
            return $20e1de903f33300b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $20e1de903f33300b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$20e1de903f33300b$var$Buffer.prototype._isBuffer = true;
function $20e1de903f33300b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$20e1de903f33300b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$20e1de903f33300b$var$swap(this, i, i + 1);
    return this;
};
$20e1de903f33300b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $20e1de903f33300b$var$swap(this, i, i + 3);
        $20e1de903f33300b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$20e1de903f33300b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $20e1de903f33300b$var$swap(this, i, i + 7);
        $20e1de903f33300b$var$swap(this, i + 1, i + 6);
        $20e1de903f33300b$var$swap(this, i + 2, i + 5);
        $20e1de903f33300b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$20e1de903f33300b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $20e1de903f33300b$var$utf8Slice(this, 0, length);
    return $20e1de903f33300b$var$slowToString.apply(this, arguments);
};
$20e1de903f33300b$var$Buffer.prototype.toLocaleString = $20e1de903f33300b$var$Buffer.prototype.toString;
$20e1de903f33300b$var$Buffer.prototype.equals = function equals(b) {
    if (!$20e1de903f33300b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $20e1de903f33300b$var$Buffer.compare(this, b) === 0;
};
$20e1de903f33300b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $20e1de903f33300b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($20e1de903f33300b$var$customInspectSymbol) $20e1de903f33300b$var$Buffer.prototype[$20e1de903f33300b$var$customInspectSymbol] = $20e1de903f33300b$var$Buffer.prototype.inspect;
$20e1de903f33300b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($20e1de903f33300b$var$isInstance(target, Uint8Array)) target = $20e1de903f33300b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$20e1de903f33300b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $20e1de903f33300b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($20e1de903f33300b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $20e1de903f33300b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($20e1de903f33300b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $20e1de903f33300b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $20e1de903f33300b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $20e1de903f33300b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$20e1de903f33300b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$20e1de903f33300b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $20e1de903f33300b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$20e1de903f33300b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $20e1de903f33300b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $20e1de903f33300b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($20e1de903f33300b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $20e1de903f33300b$var$utf8Write(buf, string, offset, length) {
    return $20e1de903f33300b$var$blitBuffer($20e1de903f33300b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $20e1de903f33300b$var$asciiWrite(buf, string, offset, length) {
    return $20e1de903f33300b$var$blitBuffer($20e1de903f33300b$var$asciiToBytes(string), buf, offset, length);
}
function $20e1de903f33300b$var$base64Write(buf, string, offset, length) {
    return $20e1de903f33300b$var$blitBuffer($20e1de903f33300b$var$base64ToBytes(string), buf, offset, length);
}
function $20e1de903f33300b$var$ucs2Write(buf, string, offset, length) {
    return $20e1de903f33300b$var$blitBuffer($20e1de903f33300b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$20e1de903f33300b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $20e1de903f33300b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $20e1de903f33300b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $20e1de903f33300b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $20e1de903f33300b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $20e1de903f33300b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$20e1de903f33300b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $20e1de903f33300b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $20e1de903f33300b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $20e1de903f33300b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $20e1de903f33300b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $20e1de903f33300b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $20e1de903f33300b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $20e1de903f33300b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $20e1de903f33300b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $20e1de903f33300b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $20e1de903f33300b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $20e1de903f33300b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $20e1de903f33300b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$20e1de903f33300b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $20e1de903f33300b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $20e1de903f33300b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$20e1de903f33300b$var$Buffer.prototype.readUintLE = $20e1de903f33300b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$20e1de903f33300b$var$Buffer.prototype.readUintBE = $20e1de903f33300b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$20e1de903f33300b$var$Buffer.prototype.readUint8 = $20e1de903f33300b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$20e1de903f33300b$var$Buffer.prototype.readUint16LE = $20e1de903f33300b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$20e1de903f33300b$var$Buffer.prototype.readUint16BE = $20e1de903f33300b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$20e1de903f33300b$var$Buffer.prototype.readUint32LE = $20e1de903f33300b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$20e1de903f33300b$var$Buffer.prototype.readUint32BE = $20e1de903f33300b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$20e1de903f33300b$var$Buffer.prototype.readBigUInt64LE = $20e1de903f33300b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $20e1de903f33300b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $20e1de903f33300b$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$20e1de903f33300b$var$Buffer.prototype.readBigUInt64BE = $20e1de903f33300b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $20e1de903f33300b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $20e1de903f33300b$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$20e1de903f33300b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$20e1de903f33300b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$20e1de903f33300b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$20e1de903f33300b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$20e1de903f33300b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$20e1de903f33300b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$20e1de903f33300b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$20e1de903f33300b$var$Buffer.prototype.readBigInt64LE = $20e1de903f33300b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $20e1de903f33300b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $20e1de903f33300b$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$20e1de903f33300b$var$Buffer.prototype.readBigInt64BE = $20e1de903f33300b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $20e1de903f33300b$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $20e1de903f33300b$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$20e1de903f33300b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$20e1de903f33300b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$20e1de903f33300b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$20e1de903f33300b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $20e1de903f33300b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$20e1de903f33300b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$20e1de903f33300b$var$Buffer.prototype.writeUintLE = $20e1de903f33300b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $20e1de903f33300b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$20e1de903f33300b$var$Buffer.prototype.writeUintBE = $20e1de903f33300b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $20e1de903f33300b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$20e1de903f33300b$var$Buffer.prototype.writeUint8 = $20e1de903f33300b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$20e1de903f33300b$var$Buffer.prototype.writeUint16LE = $20e1de903f33300b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$20e1de903f33300b$var$Buffer.prototype.writeUint16BE = $20e1de903f33300b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$20e1de903f33300b$var$Buffer.prototype.writeUint32LE = $20e1de903f33300b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$20e1de903f33300b$var$Buffer.prototype.writeUint32BE = $20e1de903f33300b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $20e1de903f33300b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $20e1de903f33300b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $20e1de903f33300b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $20e1de903f33300b$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$20e1de903f33300b$var$Buffer.prototype.writeBigUInt64LE = $20e1de903f33300b$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $20e1de903f33300b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$20e1de903f33300b$var$Buffer.prototype.writeBigUInt64BE = $20e1de903f33300b$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $20e1de903f33300b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$20e1de903f33300b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $20e1de903f33300b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$20e1de903f33300b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $20e1de903f33300b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$20e1de903f33300b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$20e1de903f33300b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$20e1de903f33300b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$20e1de903f33300b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$20e1de903f33300b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$20e1de903f33300b$var$Buffer.prototype.writeBigInt64LE = $20e1de903f33300b$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $20e1de903f33300b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$20e1de903f33300b$var$Buffer.prototype.writeBigInt64BE = $20e1de903f33300b$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $20e1de903f33300b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $20e1de903f33300b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $20e1de903f33300b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$20e1de903f33300b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $20e1de903f33300b$var$writeFloat(this, value, offset, true, noAssert);
};
$20e1de903f33300b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $20e1de903f33300b$var$writeFloat(this, value, offset, false, noAssert);
};
function $20e1de903f33300b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $20e1de903f33300b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$20e1de903f33300b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $20e1de903f33300b$var$writeDouble(this, value, offset, true, noAssert);
};
$20e1de903f33300b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $20e1de903f33300b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$20e1de903f33300b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$20e1de903f33300b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$20e1de903f33300b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$20e1de903f33300b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $20e1de903f33300b$var$Buffer.isBuffer(val) ? val : $20e1de903f33300b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $20e1de903f33300b$var$errors = {};
function $20e1de903f33300b$var$E(sym, getMessage, Base) {
    $20e1de903f33300b$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$20e1de903f33300b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$20e1de903f33300b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$20e1de903f33300b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $20e1de903f33300b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $20e1de903f33300b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $20e1de903f33300b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $20e1de903f33300b$var$checkBounds(buf, offset, byteLength) {
    $20e1de903f33300b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $20e1de903f33300b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $20e1de903f33300b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $20e1de903f33300b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $20e1de903f33300b$var$checkBounds(buf, offset, byteLength);
}
function $20e1de903f33300b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $20e1de903f33300b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $20e1de903f33300b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $20e1de903f33300b$var$validateNumber(value, type);
        throw new $20e1de903f33300b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $20e1de903f33300b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $20e1de903f33300b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $20e1de903f33300b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $20e1de903f33300b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($20e1de903f33300b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $20e1de903f33300b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $20e1de903f33300b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $20e1de903f33300b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $20e1de903f33300b$var$base64ToBytes(str) {
    return $abUaD.toByteArray($20e1de903f33300b$var$base64clean(str));
}
function $20e1de903f33300b$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $20e1de903f33300b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $20e1de903f33300b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $20e1de903f33300b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $20e1de903f33300b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $20e1de903f33300b$var$BufferBigIntNotDefined : fn;
}
function $20e1de903f33300b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("492qd", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $3049e1a024edbf89$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $3049e1a024edbf89$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("i2eun", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2P1XW = parcelRequire("2P1XW");

var $cyxjM = parcelRequire("cyxjM");
var $036369ebb89d2a1d$var$format = $cyxjM.format, $036369ebb89d2a1d$var$inspect = $cyxjM.inspect;

var $j63nd = parcelRequire("j63nd");
var $036369ebb89d2a1d$var$ERR_INVALID_ARG_TYPE = $j63nd.codes.ERR_INVALID_ARG_TYPE;

var $492qd = parcelRequire("492qd");
var $036369ebb89d2a1d$var$kResistStopPropagation = $492qd.kResistStopPropagation, $036369ebb89d2a1d$var$AggregateError = $492qd.AggregateError, $036369ebb89d2a1d$var$SymbolDispose = $492qd.SymbolDispose;

var $036369ebb89d2a1d$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $036369ebb89d2a1d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $036369ebb89d2a1d$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $036369ebb89d2a1d$var$Blob = globalThis.Blob || $2P1XW.Blob;
/* eslint-disable indent */ var $036369ebb89d2a1d$var$isBlob = typeof $036369ebb89d2a1d$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $036369ebb89d2a1d$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $036369ebb89d2a1d$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $036369ebb89d2a1d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $036369ebb89d2a1d$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $036369ebb89d2a1d$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $036369ebb89d2a1d$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $036369ebb89d2a1d$var$format,
    inspect: $036369ebb89d2a1d$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $036369ebb89d2a1d$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $036369ebb89d2a1d$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $036369ebb89d2a1d$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $036369ebb89d2a1d$var$validateAbortSignal(signal, 'signal');
        $036369ebb89d2a1d$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $036369ebb89d2a1d$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $036369ebb89d2a1d$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $036369ebb89d2a1d$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $036369ebb89d2a1d$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $036369ebb89d2a1d$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("cyxjM", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("j63nd", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $cyxjM = parcelRequire("cyxjM");
var $de7131bc4a0fce01$var$format = $cyxjM.format, $de7131bc4a0fce01$var$inspect = $cyxjM.inspect;

var $492qd = parcelRequire("492qd");
var $de7131bc4a0fce01$var$CustomAggregateError = $492qd.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $de7131bc4a0fce01$var$AggregateError = globalThis.AggregateError || $de7131bc4a0fce01$var$CustomAggregateError;
var $de7131bc4a0fce01$var$kIsNodeError = Symbol('kIsNodeError');
var $de7131bc4a0fce01$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $de7131bc4a0fce01$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $de7131bc4a0fce01$var$nodeInternalPrefix = '__node_internal_';
var $de7131bc4a0fce01$var$codes = {};
function $de7131bc4a0fce01$var$assert(value, message) {
    if (!value) throw new $de7131bc4a0fce01$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $de7131bc4a0fce01$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $de7131bc4a0fce01$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $de7131bc4a0fce01$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $de7131bc4a0fce01$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $de7131bc4a0fce01$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $de7131bc4a0fce01$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $de7131bc4a0fce01$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$de7131bc4a0fce01$var$kIsNodeError] = true;
    $de7131bc4a0fce01$var$codes[code] = NodeError;
}
function $de7131bc4a0fce01$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $de7131bc4a0fce01$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $de7131bc4a0fce01$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $de7131bc4a0fce01$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $de7131bc4a0fce01$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $de7131bc4a0fce01$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$de7131bc4a0fce01$var$E('ERR_ASSERTION', '%s', Error);
$de7131bc4a0fce01$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $de7131bc4a0fce01$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $de7131bc4a0fce01$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($de7131bc4a0fce01$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($de7131bc4a0fce01$var$classRegExp.test(value)) instances.push(value);
            else {
                $de7131bc4a0fce01$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $de7131bc4a0fce01$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $de7131bc4a0fce01$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$de7131bc4a0fce01$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $de7131bc4a0fce01$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$de7131bc4a0fce01$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$de7131bc4a0fce01$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $de7131bc4a0fce01$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$de7131bc4a0fce01$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $de7131bc4a0fce01$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $de7131bc4a0fce01$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $de7131bc4a0fce01$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $de7131bc4a0fce01$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$de7131bc4a0fce01$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$de7131bc4a0fce01$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$de7131bc4a0fce01$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$de7131bc4a0fce01$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$de7131bc4a0fce01$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $de7131bc4a0fce01$var$AbortError,
    aggregateTwoErrors: $de7131bc4a0fce01$var$hideStackFrames($de7131bc4a0fce01$var$aggregateTwoErrors),
    hideStackFrames: $de7131bc4a0fce01$var$hideStackFrames,
    codes: $de7131bc4a0fce01$var$codes
};

});


parcelRegister("gakAs", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $bc4d8ca6afaa24f4$export$42af8c323be37587; }, function (v) { return $bc4d8ca6afaa24f4$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $bc4d8ca6afaa24f4$export$f405f72c701dad87; }, function (v) { return $bc4d8ca6afaa24f4$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $bc4d8ca6afaa24f4$export$42af8c323be37587;
var $bc4d8ca6afaa24f4$export$f405f72c701dad87;
'use strict';

var $bc4d8ca6afaa24f4$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $j63nd = parcelRequire("j63nd");
var $bc4d8ca6afaa24f4$var$_require_codes = $j63nd.codes, $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_VALUE = $bc4d8ca6afaa24f4$var$_require_codes.ERR_INVALID_ARG_VALUE, $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE = $bc4d8ca6afaa24f4$var$_require_codes.ERR_INVALID_ARG_TYPE, $bc4d8ca6afaa24f4$var$ERR_MISSING_ARGS = $bc4d8ca6afaa24f4$var$_require_codes.ERR_MISSING_ARGS, $bc4d8ca6afaa24f4$var$ERR_OUT_OF_RANGE = $bc4d8ca6afaa24f4$var$_require_codes.ERR_OUT_OF_RANGE, $bc4d8ca6afaa24f4$var$AbortError = $j63nd.AbortError;

var $dCJgJ = parcelRequire("dCJgJ");
var $bc4d8ca6afaa24f4$var$validateAbortSignal = $dCJgJ.validateAbortSignal, $bc4d8ca6afaa24f4$var$validateInteger = $dCJgJ.validateInteger, $bc4d8ca6afaa24f4$var$validateObject = $dCJgJ.validateObject;

var $bc4d8ca6afaa24f4$var$kWeakHandler = (parcelRequire("492qd")).Symbol('kWeak');

var $bc4d8ca6afaa24f4$var$kResistStopPropagation = (parcelRequire("492qd")).Symbol('kResistStopPropagation');

var $32wt8 = parcelRequire("32wt8");
var $bc4d8ca6afaa24f4$require$finished = $32wt8.finished;

var $j5AX8 = parcelRequire("j5AX8");

var $1xKKt = parcelRequire("1xKKt");
var $bc4d8ca6afaa24f4$require$addAbortSignalNoValidate = $1xKKt.addAbortSignalNoValidate;

var $buMDs = parcelRequire("buMDs");
var $bc4d8ca6afaa24f4$var$isWritable = $buMDs.isWritable, $bc4d8ca6afaa24f4$var$isNodeStream = $buMDs.isNodeStream;

var $bc4d8ca6afaa24f4$require$deprecate = (parcelRequire("i2eun")).deprecate;

var $bc4d8ca6afaa24f4$var$ArrayPrototypePush = (parcelRequire("492qd")).ArrayPrototypePush, $bc4d8ca6afaa24f4$var$Boolean = (parcelRequire("492qd")).Boolean, $bc4d8ca6afaa24f4$var$MathFloor = (parcelRequire("492qd")).MathFloor, $bc4d8ca6afaa24f4$var$Number = (parcelRequire("492qd")).Number, $bc4d8ca6afaa24f4$var$NumberIsNaN = (parcelRequire("492qd")).NumberIsNaN, $bc4d8ca6afaa24f4$var$Promise = (parcelRequire("492qd")).Promise, $bc4d8ca6afaa24f4$var$PromiseReject = (parcelRequire("492qd")).PromiseReject, $bc4d8ca6afaa24f4$var$PromiseResolve = (parcelRequire("492qd")).PromiseResolve, $bc4d8ca6afaa24f4$var$PromisePrototypeThen = (parcelRequire("492qd")).PromisePrototypeThen, $bc4d8ca6afaa24f4$var$Symbol = (parcelRequire("492qd")).Symbol;
var $bc4d8ca6afaa24f4$var$kEmpty = $bc4d8ca6afaa24f4$var$Symbol('kEmpty');
var $bc4d8ca6afaa24f4$var$kEof = $bc4d8ca6afaa24f4$var$Symbol('kEof');
function $bc4d8ca6afaa24f4$var$compose(stream, options) {
    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
    if ($bc4d8ca6afaa24f4$var$isNodeStream(stream) && !$bc4d8ca6afaa24f4$var$isWritable(stream)) throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $j5AX8(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $bc4d8ca6afaa24f4$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $bc4d8ca6afaa24f4$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $bc4d8ca6afaa24f4$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $bc4d8ca6afaa24f4$var$MathFloor(options.highWaterMark);
    $bc4d8ca6afaa24f4$var$validateInteger(concurrency, 'options.concurrency', 1);
    $bc4d8ca6afaa24f4$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $bc4d8ca6afaa24f4$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $bc4d8ca6afaa24f4$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $bc4d8ca6afaa24f4$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $bc4d8ca6afaa24f4$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $bc4d8ca6afaa24f4$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($bc4d8ca6afaa24f4$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $bc4d8ca6afaa24f4$var$PromiseReject(err1);
                                $bc4d8ca6afaa24f4$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("i2eun")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($bc4d8ca6afaa24f4$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $bc4d8ca6afaa24f4$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                        if (!(val !== $bc4d8ca6afaa24f4$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $bc4d8ca6afaa24f4$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$asIndexedPairs(options) {
    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bc4d8ca6afaa24f4$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $bc4d8ca6afaa24f4$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bc4d8ca6afaa24f4$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $bc4d8ca6afaa24f4$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bc4d8ca6afaa24f4$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $bc4d8ca6afaa24f4$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $bc4d8ca6afaa24f4$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $bc4d8ca6afaa24f4$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($bc4d8ca6afaa24f4$var$ERR_MISSING_ARGS);
function $bc4d8ca6afaa24f4$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $bc4d8ca6afaa24f4$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $bc4d8ca6afaa24f4$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $bc4d8ca6afaa24f4$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $bc4d8ca6afaa24f4$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $bc4d8ca6afaa24f4$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $bc4d8ca6afaa24f4$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $bc4d8ca6afaa24f4$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $bc4d8ca6afaa24f4$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $bc4d8ca6afaa24f4$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$flatMap(fn, options) {
    var values = $bc4d8ca6afaa24f4$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $bc4d8ca6afaa24f4$var$Number(number);
    if ($bc4d8ca6afaa24f4$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $bc4d8ca6afaa24f4$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $bc4d8ca6afaa24f4$var$drop(number, options) {
    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
    number = $bc4d8ca6afaa24f4$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bc4d8ca6afaa24f4$var$take(number, options) {
    if (options != null) $bc4d8ca6afaa24f4$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bc4d8ca6afaa24f4$var$validateAbortSignal(options.signal, 'options.signal');
    number = $bc4d8ca6afaa24f4$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $bc4d8ca6afaa24f4$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$bc4d8ca6afaa24f4$export$42af8c323be37587 = {
    asIndexedPairs: $bc4d8ca6afaa24f4$require$deprecate($bc4d8ca6afaa24f4$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $bc4d8ca6afaa24f4$var$drop,
    filter: $bc4d8ca6afaa24f4$var$filter,
    flatMap: $bc4d8ca6afaa24f4$var$flatMap,
    map: $bc4d8ca6afaa24f4$var$map,
    take: $bc4d8ca6afaa24f4$var$take,
    compose: $bc4d8ca6afaa24f4$var$compose
};
$bc4d8ca6afaa24f4$export$f405f72c701dad87 = {
    every: $bc4d8ca6afaa24f4$var$every,
    forEach: $bc4d8ca6afaa24f4$var$forEach,
    reduce: $bc4d8ca6afaa24f4$var$reduce,
    toArray: $bc4d8ca6afaa24f4$var$toArray,
    some: $bc4d8ca6afaa24f4$var$some,
    find: $bc4d8ca6afaa24f4$var$find
};

});
parcelRegister("dCJgJ", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $492qd = parcelRequire("492qd");
var $9eb1f06e49d3544a$var$ArrayIsArray = $492qd.ArrayIsArray, $9eb1f06e49d3544a$var$ArrayPrototypeIncludes = $492qd.ArrayPrototypeIncludes, $9eb1f06e49d3544a$var$ArrayPrototypeJoin = $492qd.ArrayPrototypeJoin, $9eb1f06e49d3544a$var$ArrayPrototypeMap = $492qd.ArrayPrototypeMap, $9eb1f06e49d3544a$var$NumberIsInteger = $492qd.NumberIsInteger, $9eb1f06e49d3544a$var$NumberIsNaN = $492qd.NumberIsNaN, $9eb1f06e49d3544a$var$NumberMAX_SAFE_INTEGER = $492qd.NumberMAX_SAFE_INTEGER, $9eb1f06e49d3544a$var$NumberMIN_SAFE_INTEGER = $492qd.NumberMIN_SAFE_INTEGER, $9eb1f06e49d3544a$var$NumberParseInt = $492qd.NumberParseInt, $9eb1f06e49d3544a$var$ObjectPrototypeHasOwnProperty = $492qd.ObjectPrototypeHasOwnProperty, $9eb1f06e49d3544a$var$RegExpPrototypeExec = $492qd.RegExpPrototypeExec, $9eb1f06e49d3544a$var$String = $492qd.String, $9eb1f06e49d3544a$var$StringPrototypeToUpperCase = $492qd.StringPrototypeToUpperCase, $9eb1f06e49d3544a$var$StringPrototypeTrim = $492qd.StringPrototypeTrim;

var $j63nd = parcelRequire("j63nd");
var $9eb1f06e49d3544a$var$hideStackFrames = $j63nd.hideStackFrames, $9eb1f06e49d3544a$var$_require_codes = $j63nd.codes, $9eb1f06e49d3544a$var$ERR_SOCKET_BAD_PORT = $9eb1f06e49d3544a$var$_require_codes.ERR_SOCKET_BAD_PORT, $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE = $9eb1f06e49d3544a$var$_require_codes.ERR_INVALID_ARG_TYPE, $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE = $9eb1f06e49d3544a$var$_require_codes.ERR_INVALID_ARG_VALUE, $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE = $9eb1f06e49d3544a$var$_require_codes.ERR_OUT_OF_RANGE, $9eb1f06e49d3544a$var$ERR_UNKNOWN_SIGNAL = $9eb1f06e49d3544a$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $i2eun = parcelRequire("i2eun");
var $9eb1f06e49d3544a$require$normalizeEncoding = $i2eun.normalizeEncoding;

var $i2eun = parcelRequire("i2eun");
var $9eb1f06e49d3544a$require$_require_types = $i2eun.types;
var $9eb1f06e49d3544a$var$isAsyncFunction = $9eb1f06e49d3544a$require$_require_types.isAsyncFunction, $9eb1f06e49d3544a$var$isArrayBufferView = $9eb1f06e49d3544a$require$_require_types.isArrayBufferView;
var $9eb1f06e49d3544a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9eb1f06e49d3544a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9eb1f06e49d3544a$var$isUint32(value) {
    return value === value >>> 0;
}
var $9eb1f06e49d3544a$var$octalReg = /^[0-7]+$/;
var $9eb1f06e49d3544a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $9eb1f06e49d3544a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($9eb1f06e49d3544a$var$RegExpPrototypeExec($9eb1f06e49d3544a$var$octalReg, value) === null) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE(name, value, $9eb1f06e49d3544a$var$modeDesc);
        value = $9eb1f06e49d3544a$var$NumberParseInt(value, 8);
    }
    $9eb1f06e49d3544a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $9eb1f06e49d3544a$var$validateInteger = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $9eb1f06e49d3544a$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $9eb1f06e49d3544a$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9eb1f06e49d3544a$var$NumberIsInteger(value)) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $9eb1f06e49d3544a$var$validateInt32 = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9eb1f06e49d3544a$var$NumberIsInteger(value)) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $9eb1f06e49d3544a$var$validateUint32 = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9eb1f06e49d3544a$var$NumberIsInteger(value)) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $9eb1f06e49d3544a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $9eb1f06e49d3544a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $9eb1f06e49d3544a$var$NumberIsNaN(value)) throw new $9eb1f06e49d3544a$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $9eb1f06e49d3544a$var$validateOneOf = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name, oneOf) {
    if (!$9eb1f06e49d3544a$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $9eb1f06e49d3544a$var$ArrayPrototypeJoin($9eb1f06e49d3544a$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $9eb1f06e49d3544a$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $9eb1f06e49d3544a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $9eb1f06e49d3544a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$9eb1f06e49d3544a$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $9eb1f06e49d3544a$var$validateObject = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $9eb1f06e49d3544a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $9eb1f06e49d3544a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $9eb1f06e49d3544a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $9eb1f06e49d3544a$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $9eb1f06e49d3544a$var$validateDictionary = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $9eb1f06e49d3544a$var$validateArray = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$9eb1f06e49d3544a$var$ArrayIsArray(value)) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $9eb1f06e49d3544a$var$validateStringArray(value, name) {
    $9eb1f06e49d3544a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$9eb1f06e49d3544a$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $9eb1f06e49d3544a$var$validateBooleanArray(value, name) {
    $9eb1f06e49d3544a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$9eb1f06e49d3544a$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $9eb1f06e49d3544a$var$validateAbortSignalArray(value, name) {
    $9eb1f06e49d3544a$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $9eb1f06e49d3544a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $9eb1f06e49d3544a$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $9eb1f06e49d3544a$var$validateString(signal, name);
    if ($9eb1f06e49d3544a$var$signals[signal] === undefined) {
        if ($9eb1f06e49d3544a$var$signals[$9eb1f06e49d3544a$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $9eb1f06e49d3544a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $9eb1f06e49d3544a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $9eb1f06e49d3544a$var$validateBuffer = $9eb1f06e49d3544a$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$9eb1f06e49d3544a$var$isArrayBufferView(buffer)) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $9eb1f06e49d3544a$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $9eb1f06e49d3544a$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $9eb1f06e49d3544a$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $9eb1f06e49d3544a$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $9eb1f06e49d3544a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $9eb1f06e49d3544a$var$validateAbortSignal = $9eb1f06e49d3544a$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $9eb1f06e49d3544a$var$validateFunction = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $9eb1f06e49d3544a$var$validatePlainFunction = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $9eb1f06e49d3544a$var$isAsyncFunction(value)) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $9eb1f06e49d3544a$var$validateUndefined = $9eb1f06e49d3544a$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $9eb1f06e49d3544a$var$validateUnion(value, name, union) {
    if (!$9eb1f06e49d3544a$var$ArrayPrototypeIncludes(union, value)) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_TYPE(name, "('".concat($9eb1f06e49d3544a$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $9eb1f06e49d3544a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $9eb1f06e49d3544a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$9eb1f06e49d3544a$var$RegExpPrototypeExec($9eb1f06e49d3544a$var$linkValueRegExp, value)) throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $9eb1f06e49d3544a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $9eb1f06e49d3544a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($9eb1f06e49d3544a$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $9eb1f06e49d3544a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $9eb1f06e49d3544a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $9eb1f06e49d3544a$var$isInt32,
    isUint32: $9eb1f06e49d3544a$var$isUint32,
    parseFileMode: $9eb1f06e49d3544a$var$parseFileMode,
    validateArray: $9eb1f06e49d3544a$var$validateArray,
    validateStringArray: $9eb1f06e49d3544a$var$validateStringArray,
    validateBooleanArray: $9eb1f06e49d3544a$var$validateBooleanArray,
    validateAbortSignalArray: $9eb1f06e49d3544a$var$validateAbortSignalArray,
    validateBoolean: $9eb1f06e49d3544a$var$validateBoolean,
    validateBuffer: $9eb1f06e49d3544a$var$validateBuffer,
    validateDictionary: $9eb1f06e49d3544a$var$validateDictionary,
    validateEncoding: $9eb1f06e49d3544a$var$validateEncoding,
    validateFunction: $9eb1f06e49d3544a$var$validateFunction,
    validateInt32: $9eb1f06e49d3544a$var$validateInt32,
    validateInteger: $9eb1f06e49d3544a$var$validateInteger,
    validateNumber: $9eb1f06e49d3544a$var$validateNumber,
    validateObject: $9eb1f06e49d3544a$var$validateObject,
    validateOneOf: $9eb1f06e49d3544a$var$validateOneOf,
    validatePlainFunction: $9eb1f06e49d3544a$var$validatePlainFunction,
    validatePort: $9eb1f06e49d3544a$var$validatePort,
    validateSignalName: $9eb1f06e49d3544a$var$validateSignalName,
    validateString: $9eb1f06e49d3544a$var$validateString,
    validateUint32: $9eb1f06e49d3544a$var$validateUint32,
    validateUndefined: $9eb1f06e49d3544a$var$validateUndefined,
    validateUnion: $9eb1f06e49d3544a$var$validateUnion,
    validateAbortSignal: $9eb1f06e49d3544a$var$validateAbortSignal,
    validateLinkHeaderValue: $9eb1f06e49d3544a$var$validateLinkHeaderValue
};

});

parcelRegister("32wt8", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $j63nd = parcelRequire("j63nd");
/* replacement end */ var $236abea77530222c$var$AbortError = $j63nd.AbortError, $236abea77530222c$var$codes = $j63nd.codes;
var $236abea77530222c$var$ERR_INVALID_ARG_TYPE = $236abea77530222c$var$codes.ERR_INVALID_ARG_TYPE, $236abea77530222c$var$ERR_STREAM_PREMATURE_CLOSE = $236abea77530222c$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $236abea77530222c$var$kEmptyObject = (parcelRequire("i2eun")).kEmptyObject, $236abea77530222c$var$once = (parcelRequire("i2eun")).once;

var $dCJgJ = parcelRequire("dCJgJ");
var $236abea77530222c$var$validateAbortSignal = $dCJgJ.validateAbortSignal, $236abea77530222c$var$validateFunction = $dCJgJ.validateFunction, $236abea77530222c$var$validateObject = $dCJgJ.validateObject, $236abea77530222c$var$validateBoolean = $dCJgJ.validateBoolean;

var $492qd = parcelRequire("492qd");
var $236abea77530222c$var$Promise = $492qd.Promise, $236abea77530222c$var$PromisePrototypeThen = $492qd.PromisePrototypeThen, $236abea77530222c$var$SymbolDispose = $492qd.SymbolDispose;

var $buMDs = parcelRequire("buMDs");
var $236abea77530222c$var$isClosed = $buMDs.isClosed, $236abea77530222c$var$isReadable = $buMDs.isReadable, $236abea77530222c$var$isReadableNodeStream = $buMDs.isReadableNodeStream, $236abea77530222c$var$isReadableStream = $buMDs.isReadableStream, $236abea77530222c$var$isReadableFinished = $buMDs.isReadableFinished, $236abea77530222c$var$isReadableErrored = $buMDs.isReadableErrored, $236abea77530222c$var$isWritable = $buMDs.isWritable, $236abea77530222c$var$isWritableNodeStream = $buMDs.isWritableNodeStream, $236abea77530222c$var$isWritableStream = $buMDs.isWritableStream, $236abea77530222c$var$isWritableFinished = $buMDs.isWritableFinished, $236abea77530222c$var$isWritableErrored = $buMDs.isWritableErrored, $236abea77530222c$var$isNodeStream = $buMDs.isNodeStream, $236abea77530222c$var$_willEmitClose = $buMDs.willEmitClose, $236abea77530222c$var$kIsClosedPromise = $buMDs.kIsClosedPromise;
var $236abea77530222c$var$addAbortListener;
function $236abea77530222c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $236abea77530222c$var$nop = function() {};

function $236abea77530222c$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $236abea77530222c$var$kEmptyObject;
    } else if (options == null) options = $236abea77530222c$var$kEmptyObject;
    else $236abea77530222c$var$validateObject(options, 'options');
    $236abea77530222c$var$validateFunction(callback, 'callback');
    $236abea77530222c$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $236abea77530222c$var$once(callback);
    if ($236abea77530222c$var$isReadableStream(stream) || $236abea77530222c$var$isWritableStream(stream)) return $236abea77530222c$var$eosWeb(stream, options, callback);
    if (!$236abea77530222c$var$isNodeStream(stream)) throw new $236abea77530222c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $236abea77530222c$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $236abea77530222c$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $236abea77530222c$var$_willEmitClose(stream) && $236abea77530222c$var$isReadableNodeStream(stream) === readable && $236abea77530222c$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $236abea77530222c$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $236abea77530222c$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $236abea77530222c$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $236abea77530222c$var$isWritableErrored(stream) || $236abea77530222c$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $236abea77530222c$var$isReadableNodeStream(stream, true)) {
            if (!$236abea77530222c$var$isReadableFinished(stream, false)) return callback.call(stream, new $236abea77530222c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$236abea77530222c$var$isWritableFinished(stream, false)) return callback.call(stream, new $236abea77530222c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $236abea77530222c$var$isWritableErrored(stream) || $236abea77530222c$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($236abea77530222c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $236abea77530222c$var$isReadable(stream)) && (writableFinished || $236abea77530222c$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $236abea77530222c$var$isWritable(stream)) && (readableFinished || $236abea77530222c$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $236abea77530222c$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $236abea77530222c$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $236abea77530222c$var$addAbortListener = $236abea77530222c$var$addAbortListener || (parcelRequire("i2eun")).addAbortListener;
            var disposable = $236abea77530222c$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $236abea77530222c$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$236abea77530222c$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $236abea77530222c$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $236abea77530222c$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $236abea77530222c$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $236abea77530222c$var$addAbortListener = $236abea77530222c$var$addAbortListener || (parcelRequire("i2eun")).addAbortListener;
            var disposable = $236abea77530222c$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $236abea77530222c$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$236abea77530222c$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $236abea77530222c$var$PromisePrototypeThen(stream[$236abea77530222c$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $236abea77530222c$var$nop;
}
function $236abea77530222c$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $236abea77530222c$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $236abea77530222c$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $236abea77530222c$var$Promise(function(resolve, reject) {
        var cleanup = $236abea77530222c$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $236abea77530222c$var$eos;
module.exports.finished = $236abea77530222c$var$finished;

});
parcelRegister("buMDs", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $492qd = parcelRequire("492qd");
var $85e8390b5708a6de$var$SymbolAsyncIterator = $492qd.SymbolAsyncIterator, $85e8390b5708a6de$var$SymbolIterator = $492qd.SymbolIterator, $85e8390b5708a6de$var$SymbolFor = $492qd.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $85e8390b5708a6de$var$kIsDestroyed = $85e8390b5708a6de$var$SymbolFor('nodejs.stream.destroyed');
var $85e8390b5708a6de$var$kIsErrored = $85e8390b5708a6de$var$SymbolFor('nodejs.stream.errored');
var $85e8390b5708a6de$var$kIsReadable = $85e8390b5708a6de$var$SymbolFor('nodejs.stream.readable');
var $85e8390b5708a6de$var$kIsWritable = $85e8390b5708a6de$var$SymbolFor('nodejs.stream.writable');
var $85e8390b5708a6de$var$kIsDisturbed = $85e8390b5708a6de$var$SymbolFor('nodejs.stream.disturbed');
var $85e8390b5708a6de$var$kIsClosedPromise = $85e8390b5708a6de$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $85e8390b5708a6de$var$kControllerErrorFunction = $85e8390b5708a6de$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $85e8390b5708a6de$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $85e8390b5708a6de$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $85e8390b5708a6de$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $85e8390b5708a6de$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $85e8390b5708a6de$var$isReadableStream(obj) {
    return !!(obj && !$85e8390b5708a6de$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $85e8390b5708a6de$var$isWritableStream(obj) {
    return !!(obj && !$85e8390b5708a6de$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $85e8390b5708a6de$var$isTransformStream(obj) {
    return !!(obj && !$85e8390b5708a6de$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $85e8390b5708a6de$var$isWebStream(obj) {
    return $85e8390b5708a6de$var$isReadableStream(obj) || $85e8390b5708a6de$var$isWritableStream(obj) || $85e8390b5708a6de$var$isTransformStream(obj);
}
function $85e8390b5708a6de$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$85e8390b5708a6de$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$85e8390b5708a6de$var$SymbolIterator] === 'function';
    return typeof obj[$85e8390b5708a6de$var$SymbolAsyncIterator] === 'function' || typeof obj[$85e8390b5708a6de$var$SymbolIterator] === 'function';
}
function $85e8390b5708a6de$var$isDestroyed(stream) {
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$85e8390b5708a6de$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $85e8390b5708a6de$var$isWritableEnded(stream) {
    if (!$85e8390b5708a6de$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $85e8390b5708a6de$var$isWritableFinished(stream, strict) {
    if (!$85e8390b5708a6de$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $85e8390b5708a6de$var$isReadableEnded(stream) {
    if (!$85e8390b5708a6de$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $85e8390b5708a6de$var$isReadableFinished(stream, strict) {
    if (!$85e8390b5708a6de$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $85e8390b5708a6de$var$isReadable(stream) {
    if (stream && stream[$85e8390b5708a6de$var$kIsReadable] != null) return stream[$85e8390b5708a6de$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($85e8390b5708a6de$var$isDestroyed(stream)) return false;
    return $85e8390b5708a6de$var$isReadableNodeStream(stream) && stream.readable && !$85e8390b5708a6de$var$isReadableFinished(stream);
}
function $85e8390b5708a6de$var$isWritable(stream) {
    if (stream && stream[$85e8390b5708a6de$var$kIsWritable] != null) return stream[$85e8390b5708a6de$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($85e8390b5708a6de$var$isDestroyed(stream)) return false;
    return $85e8390b5708a6de$var$isWritableNodeStream(stream) && stream.writable && !$85e8390b5708a6de$var$isWritableEnded(stream);
}
function $85e8390b5708a6de$var$isFinished(stream, opts) {
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    if ($85e8390b5708a6de$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $85e8390b5708a6de$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $85e8390b5708a6de$var$isWritable(stream)) return false;
    return true;
}
function $85e8390b5708a6de$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $85e8390b5708a6de$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $85e8390b5708a6de$var$isClosed(stream) {
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $85e8390b5708a6de$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $85e8390b5708a6de$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $85e8390b5708a6de$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $85e8390b5708a6de$var$isOutgoingMessage(stream);
}
function $85e8390b5708a6de$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $85e8390b5708a6de$var$willEmitClose(stream) {
    if (!$85e8390b5708a6de$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $85e8390b5708a6de$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $85e8390b5708a6de$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$85e8390b5708a6de$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $85e8390b5708a6de$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$85e8390b5708a6de$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $85e8390b5708a6de$var$isDestroyed,
    kIsDestroyed: $85e8390b5708a6de$var$kIsDestroyed,
    isDisturbed: $85e8390b5708a6de$var$isDisturbed,
    kIsDisturbed: $85e8390b5708a6de$var$kIsDisturbed,
    isErrored: $85e8390b5708a6de$var$isErrored,
    kIsErrored: $85e8390b5708a6de$var$kIsErrored,
    isReadable: $85e8390b5708a6de$var$isReadable,
    kIsReadable: $85e8390b5708a6de$var$kIsReadable,
    kIsClosedPromise: $85e8390b5708a6de$var$kIsClosedPromise,
    kControllerErrorFunction: $85e8390b5708a6de$var$kControllerErrorFunction,
    kIsWritable: $85e8390b5708a6de$var$kIsWritable,
    isClosed: $85e8390b5708a6de$var$isClosed,
    isDuplexNodeStream: $85e8390b5708a6de$var$isDuplexNodeStream,
    isFinished: $85e8390b5708a6de$var$isFinished,
    isIterable: $85e8390b5708a6de$var$isIterable,
    isReadableNodeStream: $85e8390b5708a6de$var$isReadableNodeStream,
    isReadableStream: $85e8390b5708a6de$var$isReadableStream,
    isReadableEnded: $85e8390b5708a6de$var$isReadableEnded,
    isReadableFinished: $85e8390b5708a6de$var$isReadableFinished,
    isReadableErrored: $85e8390b5708a6de$var$isReadableErrored,
    isNodeStream: $85e8390b5708a6de$var$isNodeStream,
    isWebStream: $85e8390b5708a6de$var$isWebStream,
    isWritable: $85e8390b5708a6de$var$isWritable,
    isWritableNodeStream: $85e8390b5708a6de$var$isWritableNodeStream,
    isWritableStream: $85e8390b5708a6de$var$isWritableStream,
    isWritableEnded: $85e8390b5708a6de$var$isWritableEnded,
    isWritableFinished: $85e8390b5708a6de$var$isWritableFinished,
    isWritableErrored: $85e8390b5708a6de$var$isWritableErrored,
    isServerRequest: $85e8390b5708a6de$var$isServerRequest,
    isServerResponse: $85e8390b5708a6de$var$isServerResponse,
    willEmitClose: $85e8390b5708a6de$var$willEmitClose,
    isTransformStream: $85e8390b5708a6de$var$isTransformStream
};

});


parcelRegister("j5AX8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $cqclD = parcelRequire("cqclD");
var $de5b25fe361b0ccd$require$pipeline = $cqclD.pipeline;

var $6M6ea = parcelRequire("6M6ea");

var $kKCEf = parcelRequire("kKCEf");
var $de5b25fe361b0ccd$require$destroyer = $kKCEf.destroyer;

var $buMDs = parcelRequire("buMDs");
var $de5b25fe361b0ccd$var$isNodeStream = $buMDs.isNodeStream, $de5b25fe361b0ccd$var$isReadable = $buMDs.isReadable, $de5b25fe361b0ccd$var$isWritable = $buMDs.isWritable, $de5b25fe361b0ccd$var$isWebStream = $buMDs.isWebStream, $de5b25fe361b0ccd$var$isTransformStream = $buMDs.isTransformStream, $de5b25fe361b0ccd$var$isWritableStream = $buMDs.isWritableStream, $de5b25fe361b0ccd$var$isReadableStream = $buMDs.isReadableStream;

var $j63nd = parcelRequire("j63nd");
var $de5b25fe361b0ccd$var$AbortError = $j63nd.AbortError, $de5b25fe361b0ccd$var$_require_codes = $j63nd.codes, $de5b25fe361b0ccd$var$ERR_INVALID_ARG_VALUE = $de5b25fe361b0ccd$var$_require_codes.ERR_INVALID_ARG_VALUE, $de5b25fe361b0ccd$var$ERR_MISSING_ARGS = $de5b25fe361b0ccd$var$_require_codes.ERR_MISSING_ARGS;

var $32wt8 = parcelRequire("32wt8");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $de5b25fe361b0ccd$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $6M6ea.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $6M6ea.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $6M6ea.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$de5b25fe361b0ccd$var$isNodeStream(streams[n]) && !$de5b25fe361b0ccd$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($de5b25fe361b0ccd$var$isReadable(streams[n]) || $de5b25fe361b0ccd$var$isReadableStream(streams[n]) || $de5b25fe361b0ccd$var$isTransformStream(streams[n]))) throw new $de5b25fe361b0ccd$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($de5b25fe361b0ccd$var$isWritable(streams[n]) || $de5b25fe361b0ccd$var$isWritableStream(streams[n]) || $de5b25fe361b0ccd$var$isTransformStream(streams[n]))) throw new $de5b25fe361b0ccd$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $de5b25fe361b0ccd$require$pipeline(streams, onfinished);
    var writable = !!($de5b25fe361b0ccd$var$isWritable(head) || $de5b25fe361b0ccd$var$isWritableStream(head) || $de5b25fe361b0ccd$var$isTransformStream(head));
    var readable = !!($de5b25fe361b0ccd$var$isReadable(tail) || $de5b25fe361b0ccd$var$isReadableStream(tail) || $de5b25fe361b0ccd$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $6M6ea({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($de5b25fe361b0ccd$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($de5b25fe361b0ccd$var$isWebStream(head)) {
            var writable1 = $de5b25fe361b0ccd$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $de5b25fe361b0ccd$var$isTransformStream(tail) ? tail.readable : tail;
        $32wt8(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($de5b25fe361b0ccd$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($de5b25fe361b0ccd$var$isWebStream(tail)) {
            var readable1 = $de5b25fe361b0ccd$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $de5b25fe361b0ccd$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($de5b25fe361b0ccd$var$isNodeStream(tail)) $de5b25fe361b0ccd$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("cqclD", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $492qd = parcelRequire("492qd");
var $90b17dc51ea83956$var$ArrayIsArray = $492qd.ArrayIsArray, $90b17dc51ea83956$var$Promise = $492qd.Promise, $90b17dc51ea83956$var$SymbolAsyncIterator = $492qd.SymbolAsyncIterator, $90b17dc51ea83956$var$SymbolDispose = $492qd.SymbolDispose;

var $32wt8 = parcelRequire("32wt8");

var $90b17dc51ea83956$require$once = (parcelRequire("i2eun")).once;

var $kKCEf = parcelRequire("kKCEf");

var $6M6ea = parcelRequire("6M6ea");

var $j63nd = parcelRequire("j63nd");
var $90b17dc51ea83956$var$aggregateTwoErrors = $j63nd.aggregateTwoErrors, $90b17dc51ea83956$var$_require_codes = $j63nd.codes, $90b17dc51ea83956$var$ERR_INVALID_ARG_TYPE = $90b17dc51ea83956$var$_require_codes.ERR_INVALID_ARG_TYPE, $90b17dc51ea83956$var$ERR_INVALID_RETURN_VALUE = $90b17dc51ea83956$var$_require_codes.ERR_INVALID_RETURN_VALUE, $90b17dc51ea83956$var$ERR_MISSING_ARGS = $90b17dc51ea83956$var$_require_codes.ERR_MISSING_ARGS, $90b17dc51ea83956$var$ERR_STREAM_DESTROYED = $90b17dc51ea83956$var$_require_codes.ERR_STREAM_DESTROYED, $90b17dc51ea83956$var$ERR_STREAM_PREMATURE_CLOSE = $90b17dc51ea83956$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $90b17dc51ea83956$var$AbortError = $j63nd.AbortError;

var $dCJgJ = parcelRequire("dCJgJ");
var $90b17dc51ea83956$var$validateFunction = $dCJgJ.validateFunction, $90b17dc51ea83956$var$validateAbortSignal = $dCJgJ.validateAbortSignal;

var $buMDs = parcelRequire("buMDs");
var $90b17dc51ea83956$var$isIterable = $buMDs.isIterable, $90b17dc51ea83956$var$isReadable = $buMDs.isReadable, $90b17dc51ea83956$var$isReadableNodeStream = $buMDs.isReadableNodeStream, $90b17dc51ea83956$var$isNodeStream = $buMDs.isNodeStream, $90b17dc51ea83956$var$isTransformStream = $buMDs.isTransformStream, $90b17dc51ea83956$var$isWebStream = $buMDs.isWebStream, $90b17dc51ea83956$var$isReadableStream = $buMDs.isReadableStream, $90b17dc51ea83956$var$isReadableFinished = $buMDs.isReadableFinished;

var $90b17dc51ea83956$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $90b17dc51ea83956$var$PassThrough;
var $90b17dc51ea83956$var$Readable;
var $90b17dc51ea83956$var$addAbortListener;
function $90b17dc51ea83956$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $32wt8(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $kKCEf.destroyer(stream, err || new $90b17dc51ea83956$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $90b17dc51ea83956$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $90b17dc51ea83956$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $90b17dc51ea83956$var$makeAsyncIterable(val) {
    if ($90b17dc51ea83956$var$isIterable(val)) return val;
    else if ($90b17dc51ea83956$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $90b17dc51ea83956$var$fromReadable(val);
    throw new $90b17dc51ea83956$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $90b17dc51ea83956$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$90b17dc51ea83956$var$Readable) $90b17dc51ea83956$var$Readable = (parcelRequire("ciPy6"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($90b17dc51ea83956$var$Readable.prototype[$90b17dc51ea83956$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $90b17dc51ea83956$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $90b17dc51ea83956$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $32wt8(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $90b17dc51ea83956$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $90b17dc51ea83956$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($90b17dc51ea83956$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $90b17dc51ea83956$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $90b17dc51ea83956$var$pipelineImpl(streams, $90b17dc51ea83956$require$once($90b17dc51ea83956$var$popCallback(streams)));
}


function $90b17dc51ea83956$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($90b17dc51ea83956$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $90b17dc51ea83956$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($90b17dc51ea83956$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($90b17dc51ea83956$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$90b17dc51ea83956$var$isIterable(ret)) throw new $90b17dc51ea83956$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($90b17dc51ea83956$var$isIterable(stream) || $90b17dc51ea83956$var$isReadableNodeStream(stream) || $90b17dc51ea83956$var$isTransformStream(stream)) ret = stream;
            else ret = $6M6ea.from(stream);
        } else if (typeof stream === 'function') {
            if ($90b17dc51ea83956$var$isTransformStream(ret)) {
                var _ret;
                ret = $90b17dc51ea83956$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $90b17dc51ea83956$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$90b17dc51ea83956$var$isIterable(ret, true)) throw new $90b17dc51ea83956$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$90b17dc51ea83956$var$PassThrough) $90b17dc51ea83956$var$PassThrough = (parcelRequire("bMmEU"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $90b17dc51ea83956$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($90b17dc51ea83956$var$isIterable(ret, true)) {
                    finishCount++;
                    $90b17dc51ea83956$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($90b17dc51ea83956$var$isReadableStream(ret) || $90b17dc51ea83956$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $90b17dc51ea83956$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $90b17dc51ea83956$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $90b17dc51ea83956$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($90b17dc51ea83956$var$isNodeStream(stream)) {
            if ($90b17dc51ea83956$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $90b17dc51ea83956$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($90b17dc51ea83956$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($90b17dc51ea83956$var$isTransformStream(ret) || $90b17dc51ea83956$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $90b17dc51ea83956$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($90b17dc51ea83956$var$isIterable(ret)) {
                finishCount++;
                $90b17dc51ea83956$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $90b17dc51ea83956$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($90b17dc51ea83956$var$isWebStream(stream)) {
            if ($90b17dc51ea83956$var$isReadableNodeStream(ret)) {
                finishCount++;
                $90b17dc51ea83956$var$pumpToWeb($90b17dc51ea83956$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($90b17dc51ea83956$var$isReadableStream(ret) || $90b17dc51ea83956$var$isIterable(ret)) {
                finishCount++;
                $90b17dc51ea83956$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($90b17dc51ea83956$var$isTransformStream(ret)) {
                finishCount++;
                $90b17dc51ea83956$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $90b17dc51ea83956$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $6M6ea.from(stream);
    };
    if (streams.length === 1 && $90b17dc51ea83956$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90b17dc51ea83956$var$ERR_MISSING_ARGS('streams');
    var ac = new $90b17dc51ea83956$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $90b17dc51ea83956$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $90b17dc51ea83956$var$AbortError());
    }
    $90b17dc51ea83956$var$addAbortListener = $90b17dc51ea83956$var$addAbortListener || (parcelRequire("i2eun")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $90b17dc51ea83956$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$90b17dc51ea83956$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $90b17dc51ea83956$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $90b17dc51ea83956$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($90b17dc51ea83956$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $32wt8(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $32wt8(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $90b17dc51ea83956$var$pipelineImpl,
    pipeline: $90b17dc51ea83956$var$pipeline
};

});
parcelRegister("kKCEf", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $j63nd = parcelRequire("j63nd");
/* replacement end */ var $f1b6153d559fda9f$var$aggregateTwoErrors = $j63nd.aggregateTwoErrors, $f1b6153d559fda9f$var$ERR_MULTIPLE_CALLBACK = $j63nd.codes.ERR_MULTIPLE_CALLBACK, $f1b6153d559fda9f$var$AbortError = $j63nd.AbortError;

var $492qd = parcelRequire("492qd");
var $f1b6153d559fda9f$require$Symbol = $492qd.Symbol;

var $buMDs = parcelRequire("buMDs");
var $f1b6153d559fda9f$var$kIsDestroyed = $buMDs.kIsDestroyed, $f1b6153d559fda9f$var$isDestroyed = $buMDs.isDestroyed, $f1b6153d559fda9f$var$isFinished = $buMDs.isFinished, $f1b6153d559fda9f$var$isServerRequest = $buMDs.isServerRequest;
var $f1b6153d559fda9f$var$kDestroy = $f1b6153d559fda9f$require$Symbol('kDestroy');
var $f1b6153d559fda9f$var$kConstruct = $f1b6153d559fda9f$require$Symbol('kConstruct');
function $f1b6153d559fda9f$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $f1b6153d559fda9f$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $f1b6153d559fda9f$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($f1b6153d559fda9f$var$kDestroy, function(er) {
        $f1b6153d559fda9f$var$_destroy(this, $f1b6153d559fda9f$var$aggregateTwoErrors(er, err), cb);
    });
    else $f1b6153d559fda9f$var$_destroy(this, err, cb);
    return this;
}
function $f1b6153d559fda9f$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $f1b6153d559fda9f$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($f1b6153d559fda9f$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($f1b6153d559fda9f$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $f1b6153d559fda9f$var$emitErrorCloseNT(self, err) {
    $f1b6153d559fda9f$var$emitErrorNT(self, err);
    $f1b6153d559fda9f$var$emitCloseNT(self);
}
function $f1b6153d559fda9f$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $f1b6153d559fda9f$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $f1b6153d559fda9f$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $f1b6153d559fda9f$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($f1b6153d559fda9f$var$emitErrorNT, stream, err);
        else $f1b6153d559fda9f$var$emitErrorNT(stream, err);
    }
}
function $f1b6153d559fda9f$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($f1b6153d559fda9f$var$kConstruct, cb);
    if (stream.listenerCount($f1b6153d559fda9f$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($f1b6153d559fda9f$var$constructNT, stream);
}
function $f1b6153d559fda9f$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $f1b6153d559fda9f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $f1b6153d559fda9f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($f1b6153d559fda9f$var$kDestroy, err);
        else if (err) $f1b6153d559fda9f$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($f1b6153d559fda9f$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $f1b6153d559fda9f$var$emitConstructNT(stream) {
    stream.emit($f1b6153d559fda9f$var$kConstruct);
}
function $f1b6153d559fda9f$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $f1b6153d559fda9f$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $f1b6153d559fda9f$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($f1b6153d559fda9f$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $f1b6153d559fda9f$var$destroyer(stream, err) {
    if (!stream || $f1b6153d559fda9f$var$isDestroyed(stream)) return;
    if (!err && !$f1b6153d559fda9f$var$isFinished(stream)) err = new $f1b6153d559fda9f$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($f1b6153d559fda9f$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($f1b6153d559fda9f$var$isRequest(stream)) stream.abort();
    else if ($f1b6153d559fda9f$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($f1b6153d559fda9f$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($f1b6153d559fda9f$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$f1b6153d559fda9f$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $f1b6153d559fda9f$var$construct,
    destroyer: $f1b6153d559fda9f$var$destroyer,
    destroy: $f1b6153d559fda9f$var$destroy,
    undestroy: $f1b6153d559fda9f$var$undestroy,
    errorOrDestroy: $f1b6153d559fda9f$var$errorOrDestroy
};

});

parcelRegister("6M6ea", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $492qd = parcelRequire("492qd");
var $4eec0e72d65654bd$var$ObjectDefineProperties = $492qd.ObjectDefineProperties, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor = $492qd.ObjectGetOwnPropertyDescriptor, $4eec0e72d65654bd$var$ObjectKeys = $492qd.ObjectKeys, $4eec0e72d65654bd$var$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf;
module.exports = $4eec0e72d65654bd$var$Duplex;

var $ciPy6 = parcelRequire("ciPy6");

var $5HHkr = parcelRequire("5HHkr");
$4eec0e72d65654bd$var$ObjectSetPrototypeOf($4eec0e72d65654bd$var$Duplex.prototype, $ciPy6.prototype);
$4eec0e72d65654bd$var$ObjectSetPrototypeOf($4eec0e72d65654bd$var$Duplex, $ciPy6);
{
    var $4eec0e72d65654bd$var$keys = $4eec0e72d65654bd$var$ObjectKeys($5HHkr.prototype);
    // Allow the keys array to be GC'ed.
    for(var $4eec0e72d65654bd$var$i = 0; $4eec0e72d65654bd$var$i < $4eec0e72d65654bd$var$keys.length; $4eec0e72d65654bd$var$i++){
        var $4eec0e72d65654bd$var$method = $4eec0e72d65654bd$var$keys[$4eec0e72d65654bd$var$i];
        if (!$4eec0e72d65654bd$var$Duplex.prototype[$4eec0e72d65654bd$var$method]) $4eec0e72d65654bd$var$Duplex.prototype[$4eec0e72d65654bd$var$method] = $5HHkr.prototype[$4eec0e72d65654bd$var$method];
    }
}function $4eec0e72d65654bd$var$Duplex(options) {
    if (!(this instanceof $4eec0e72d65654bd$var$Duplex)) return new $4eec0e72d65654bd$var$Duplex(options);
    $ciPy6.call(this, options);
    $5HHkr.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$4eec0e72d65654bd$var$ObjectDefineProperties($4eec0e72d65654bd$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $4eec0e72d65654bd$var$ObjectGetOwnPropertyDescriptor($5HHkr.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $4eec0e72d65654bd$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4eec0e72d65654bd$var$lazyWebStreams() {
    if ($4eec0e72d65654bd$var$webStreamsAdapters === undefined) $4eec0e72d65654bd$var$webStreamsAdapters = {};
    return $4eec0e72d65654bd$var$webStreamsAdapters;
}
$4eec0e72d65654bd$var$Duplex.fromWeb = function(pair, options) {
    return $4eec0e72d65654bd$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$4eec0e72d65654bd$var$Duplex.toWeb = function(duplex) {
    return $4eec0e72d65654bd$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $4eec0e72d65654bd$var$duplexify;

$4eec0e72d65654bd$var$Duplex.from = function(body) {
    if (!$4eec0e72d65654bd$var$duplexify) $4eec0e72d65654bd$var$duplexify = (parcelRequire("rigBT"));
    return $4eec0e72d65654bd$var$duplexify(body, 'body');
};

});
parcelRegister("ciPy6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $492qd = parcelRequire("492qd");
/* replacement end */ var $8f4f2705a5cd4e89$var$ArrayPrototypeIndexOf = $492qd.ArrayPrototypeIndexOf, $8f4f2705a5cd4e89$var$NumberIsInteger = $492qd.NumberIsInteger, $8f4f2705a5cd4e89$var$NumberIsNaN = $492qd.NumberIsNaN, $8f4f2705a5cd4e89$var$NumberParseInt = $492qd.NumberParseInt, $8f4f2705a5cd4e89$var$ObjectDefineProperties = $492qd.ObjectDefineProperties, $8f4f2705a5cd4e89$var$ObjectKeys = $492qd.ObjectKeys, $8f4f2705a5cd4e89$var$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf, $8f4f2705a5cd4e89$var$Promise = $492qd.Promise, $8f4f2705a5cd4e89$var$SafeSet = $492qd.SafeSet, $8f4f2705a5cd4e89$var$SymbolAsyncDispose = $492qd.SymbolAsyncDispose, $8f4f2705a5cd4e89$var$SymbolAsyncIterator = $492qd.SymbolAsyncIterator, $8f4f2705a5cd4e89$var$Symbol = $492qd.Symbol;
module.exports = $8f4f2705a5cd4e89$var$Readable;
$8f4f2705a5cd4e89$var$Readable.ReadableState = $8f4f2705a5cd4e89$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $8f4f2705a5cd4e89$var$EE = $bBoAO.EventEmitter;

var $lDfEi = parcelRequire("lDfEi");
var $8f4f2705a5cd4e89$var$Stream = $lDfEi.Stream, $8f4f2705a5cd4e89$var$prependListener = $lDfEi.prependListener;

var $2P1XW = parcelRequire("2P1XW");
var $8f4f2705a5cd4e89$require$Buffer = $2P1XW.Buffer;

var $1xKKt = parcelRequire("1xKKt");
var $8f4f2705a5cd4e89$require$addAbortSignal = $1xKKt.addAbortSignal;

var $32wt8 = parcelRequire("32wt8");

var $8f4f2705a5cd4e89$var$debug = (parcelRequire("i2eun")).debuglog('stream', function(fn) {
    $8f4f2705a5cd4e89$var$debug = fn;
});

var $3tXV7 = parcelRequire("3tXV7");

var $kKCEf = parcelRequire("kKCEf");

var $cdB5t = parcelRequire("cdB5t");
var $8f4f2705a5cd4e89$var$getHighWaterMark = $cdB5t.getHighWaterMark, $8f4f2705a5cd4e89$var$getDefaultHighWaterMark = $cdB5t.getDefaultHighWaterMark;

var $j63nd = parcelRequire("j63nd");
var $8f4f2705a5cd4e89$var$aggregateTwoErrors = $j63nd.aggregateTwoErrors, $8f4f2705a5cd4e89$var$_require_codes = $j63nd.codes, $8f4f2705a5cd4e89$var$ERR_INVALID_ARG_TYPE = $8f4f2705a5cd4e89$var$_require_codes.ERR_INVALID_ARG_TYPE, $8f4f2705a5cd4e89$var$ERR_METHOD_NOT_IMPLEMENTED = $8f4f2705a5cd4e89$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $8f4f2705a5cd4e89$var$ERR_OUT_OF_RANGE = $8f4f2705a5cd4e89$var$_require_codes.ERR_OUT_OF_RANGE, $8f4f2705a5cd4e89$var$ERR_STREAM_PUSH_AFTER_EOF = $8f4f2705a5cd4e89$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $8f4f2705a5cd4e89$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $8f4f2705a5cd4e89$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $8f4f2705a5cd4e89$var$AbortError = $j63nd.AbortError;

var $dCJgJ = parcelRequire("dCJgJ");
var $8f4f2705a5cd4e89$require$validateObject = $dCJgJ.validateObject;
var $8f4f2705a5cd4e89$var$kPaused = $8f4f2705a5cd4e89$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $8f4f2705a5cd4e89$require$StringDecoder = $3Jf7C.StringDecoder;

var $8M20o = parcelRequire("8M20o");
$8f4f2705a5cd4e89$var$ObjectSetPrototypeOf($8f4f2705a5cd4e89$var$Readable.prototype, $8f4f2705a5cd4e89$var$Stream.prototype);
$8f4f2705a5cd4e89$var$ObjectSetPrototypeOf($8f4f2705a5cd4e89$var$Readable, $8f4f2705a5cd4e89$var$Stream);
var $8f4f2705a5cd4e89$var$nop = function() {};
var $8f4f2705a5cd4e89$var$errorOrDestroy = $kKCEf.errorOrDestroy;
var $8f4f2705a5cd4e89$var$kObjectMode = 1;
var $8f4f2705a5cd4e89$var$kEnded = 2;
var $8f4f2705a5cd4e89$var$kEndEmitted = 4;
var $8f4f2705a5cd4e89$var$kReading = 8;
var $8f4f2705a5cd4e89$var$kConstructed = 16;
var $8f4f2705a5cd4e89$var$kSync = 32;
var $8f4f2705a5cd4e89$var$kNeedReadable = 64;
var $8f4f2705a5cd4e89$var$kEmittedReadable = 128;
var $8f4f2705a5cd4e89$var$kReadableListening = 256;
var $8f4f2705a5cd4e89$var$kResumeScheduled = 512;
var $8f4f2705a5cd4e89$var$kErrorEmitted = 1024;
var $8f4f2705a5cd4e89$var$kEmitClose = 2048;
var $8f4f2705a5cd4e89$var$kAutoDestroy = 4096;
var $8f4f2705a5cd4e89$var$kDestroyed = 8192;
var $8f4f2705a5cd4e89$var$kClosed = 16384;
var $8f4f2705a5cd4e89$var$kCloseEmitted = 32768;
var $8f4f2705a5cd4e89$var$kMultiAwaitDrain = 65536;
var $8f4f2705a5cd4e89$var$kReadingMore = 131072;
var $8f4f2705a5cd4e89$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8f4f2705a5cd4e89$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8f4f2705a5cd4e89$var$ObjectDefineProperties($8f4f2705a5cd4e89$var$ReadableState.prototype, {
    objectMode: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kObjectMode),
    ended: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kEnded),
    endEmitted: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kEndEmitted),
    reading: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kNeedReadable),
    emittedReadable: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kEmittedReadable),
    readableListening: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kReadableListening),
    resumeScheduled: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kErrorEmitted),
    emitClose: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kEmitClose),
    autoDestroy: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kCloseEmitted),
    multiAwaitDrain: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kReadingMore),
    dataEmitted: $8f4f2705a5cd4e89$var$makeBitMapDescriptor($8f4f2705a5cd4e89$var$kDataEmitted)
});

function $8f4f2705a5cd4e89$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("6M6ea"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8f4f2705a5cd4e89$var$kEmitClose | $8f4f2705a5cd4e89$var$kAutoDestroy | $8f4f2705a5cd4e89$var$kConstructed | $8f4f2705a5cd4e89$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8f4f2705a5cd4e89$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8f4f2705a5cd4e89$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8f4f2705a5cd4e89$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8f4f2705a5cd4e89$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $3tXV7();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8f4f2705a5cd4e89$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8f4f2705a5cd4e89$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8f4f2705a5cd4e89$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8f4f2705a5cd4e89$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8f4f2705a5cd4e89$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $8f4f2705a5cd4e89$var$Readable)) return new $8f4f2705a5cd4e89$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("6M6ea"));
    this._readableState = new $8f4f2705a5cd4e89$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8f4f2705a5cd4e89$require$addAbortSignal(options.signal, this);
    }
    $8f4f2705a5cd4e89$var$Stream.call(this, options);
    $kKCEf.construct(this, function() {
        if (_this._readableState.needReadable) $8f4f2705a5cd4e89$var$maybeReadMore(_this, _this._readableState);
    });
}
$8f4f2705a5cd4e89$var$Readable.prototype.destroy = $kKCEf.destroy;
$8f4f2705a5cd4e89$var$Readable.prototype._undestroy = $kKCEf.undestroy;
$8f4f2705a5cd4e89$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8f4f2705a5cd4e89$var$Readable.prototype[$8f4f2705a5cd4e89$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8f4f2705a5cd4e89$var$Readable.prototype[$8f4f2705a5cd4e89$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8f4f2705a5cd4e89$var$AbortError();
        this.destroy(error);
    }
    return new $8f4f2705a5cd4e89$var$Promise(function(resolve, reject) {
        return $32wt8(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8f4f2705a5cd4e89$var$Readable.prototype.push = function(chunk, encoding) {
    return $8f4f2705a5cd4e89$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8f4f2705a5cd4e89$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8f4f2705a5cd4e89$var$readableAddChunk(this, chunk, encoding, true);
};
function $8f4f2705a5cd4e89$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8f4f2705a5cd4e89$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $8f4f2705a5cd4e89$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8f4f2705a5cd4e89$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8f4f2705a5cd4e89$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8f4f2705a5cd4e89$require$Buffer) encoding = '';
        else if ($8f4f2705a5cd4e89$var$Stream._isUint8Array(chunk)) {
            chunk = $8f4f2705a5cd4e89$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8f4f2705a5cd4e89$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8f4f2705a5cd4e89$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8f4f2705a5cd4e89$var$kReading;
        $8f4f2705a5cd4e89$var$onEofChunk(stream, state);
    } else if ((state.state & $8f4f2705a5cd4e89$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8f4f2705a5cd4e89$var$kEndEmitted) !== 0) $8f4f2705a5cd4e89$var$errorOrDestroy(stream, new $8f4f2705a5cd4e89$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8f4f2705a5cd4e89$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8f4f2705a5cd4e89$var$errorOrDestroy(stream, new $8f4f2705a5cd4e89$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8f4f2705a5cd4e89$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8f4f2705a5cd4e89$var$addChunk(stream, state, chunk, false);
                else $8f4f2705a5cd4e89$var$maybeReadMore(stream, state);
            } else $8f4f2705a5cd4e89$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8f4f2705a5cd4e89$var$kReading;
        $8f4f2705a5cd4e89$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8f4f2705a5cd4e89$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8f4f2705a5cd4e89$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8f4f2705a5cd4e89$var$kNeedReadable) !== 0) $8f4f2705a5cd4e89$var$emitReadable(stream);
    }
    $8f4f2705a5cd4e89$var$maybeReadMore(stream, state);
}
$8f4f2705a5cd4e89$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$8f4f2705a5cd4e89$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8f4f2705a5cd4e89$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $8f4f2705a5cd4e89$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$8f4f2705a5cd4e89$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $8f4f2705a5cd4e89$var$MAX_HWM = 0x40000000;
function $8f4f2705a5cd4e89$var$computeNewHighWaterMark(n) {
    if (n > $8f4f2705a5cd4e89$var$MAX_HWM) throw new $8f4f2705a5cd4e89$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8f4f2705a5cd4e89$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8f4f2705a5cd4e89$var$kObjectMode) !== 0) return 1;
    if ($8f4f2705a5cd4e89$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8f4f2705a5cd4e89$var$Readable.prototype.read = function(n) {
    $8f4f2705a5cd4e89$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8f4f2705a5cd4e89$var$NumberIsInteger(n)) n = $8f4f2705a5cd4e89$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8f4f2705a5cd4e89$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8f4f2705a5cd4e89$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8f4f2705a5cd4e89$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8f4f2705a5cd4e89$var$endReadable(this);
        else $8f4f2705a5cd4e89$var$emitReadable(this);
        return null;
    }
    n = $8f4f2705a5cd4e89$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8f4f2705a5cd4e89$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $8f4f2705a5cd4e89$var$kNeedReadable) !== 0;
    $8f4f2705a5cd4e89$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8f4f2705a5cd4e89$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8f4f2705a5cd4e89$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8f4f2705a5cd4e89$var$debug('do read');
        state.state |= $8f4f2705a5cd4e89$var$kReading | $8f4f2705a5cd4e89$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8f4f2705a5cd4e89$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8f4f2705a5cd4e89$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8f4f2705a5cd4e89$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8f4f2705a5cd4e89$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8f4f2705a5cd4e89$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8f4f2705a5cd4e89$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8f4f2705a5cd4e89$var$onEofChunk(stream, state) {
    $8f4f2705a5cd4e89$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8f4f2705a5cd4e89$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8f4f2705a5cd4e89$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8f4f2705a5cd4e89$var$emitReadable(stream) {
    var state = stream._readableState;
    $8f4f2705a5cd4e89$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8f4f2705a5cd4e89$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($8f4f2705a5cd4e89$var$emitReadable_, stream);
    }
}
function $8f4f2705a5cd4e89$var$emitReadable_(stream) {
    var state = stream._readableState;
    $8f4f2705a5cd4e89$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8f4f2705a5cd4e89$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8f4f2705a5cd4e89$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($8f4f2705a5cd4e89$var$maybeReadMore_, stream, state);
    }
}
function $8f4f2705a5cd4e89$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $8f4f2705a5cd4e89$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8f4f2705a5cd4e89$var$Readable.prototype._read = function(n) {
    throw new $8f4f2705a5cd4e89$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8f4f2705a5cd4e89$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8f4f2705a5cd4e89$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8f4f2705a5cd4e89$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8f4f2705a5cd4e89$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8f4f2705a5cd4e89$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $8f4f2705a5cd4e89$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8f4f2705a5cd4e89$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8f4f2705a5cd4e89$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8f4f2705a5cd4e89$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8f4f2705a5cd4e89$var$debug('ondata');
        var ret = dest.write(chunk);
        $8f4f2705a5cd4e89$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8f4f2705a5cd4e89$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8f4f2705a5cd4e89$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8f4f2705a5cd4e89$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8f4f2705a5cd4e89$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8f4f2705a5cd4e89$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8f4f2705a5cd4e89$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8f4f2705a5cd4e89$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8f4f2705a5cd4e89$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8f4f2705a5cd4e89$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8f4f2705a5cd4e89$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $8f4f2705a5cd4e89$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8f4f2705a5cd4e89$var$Readable.prototype.on = function(ev, fn) {
    var res = $8f4f2705a5cd4e89$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8f4f2705a5cd4e89$var$debug('on readable', state.length, state.reading);
            if (state.length) $8f4f2705a5cd4e89$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($8f4f2705a5cd4e89$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8f4f2705a5cd4e89$var$Readable.prototype.addListener = $8f4f2705a5cd4e89$var$Readable.prototype.on;
$8f4f2705a5cd4e89$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8f4f2705a5cd4e89$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8f4f2705a5cd4e89$var$updateReadableListening, this);
    return res;
};
$8f4f2705a5cd4e89$var$Readable.prototype.off = $8f4f2705a5cd4e89$var$Readable.prototype.removeListener;
$8f4f2705a5cd4e89$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8f4f2705a5cd4e89$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8f4f2705a5cd4e89$var$updateReadableListening, this);
    return res;
};
function $8f4f2705a5cd4e89$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8f4f2705a5cd4e89$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8f4f2705a5cd4e89$var$nReadingNextTick(self) {
    $8f4f2705a5cd4e89$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8f4f2705a5cd4e89$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8f4f2705a5cd4e89$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8f4f2705a5cd4e89$var$resume(this, state);
    }
    state[$8f4f2705a5cd4e89$var$kPaused] = false;
    return this;
};
function $8f4f2705a5cd4e89$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($8f4f2705a5cd4e89$var$resume_, stream, state);
    }
}
function $8f4f2705a5cd4e89$var$resume_(stream, state) {
    $8f4f2705a5cd4e89$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8f4f2705a5cd4e89$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8f4f2705a5cd4e89$var$Readable.prototype.pause = function() {
    $8f4f2705a5cd4e89$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8f4f2705a5cd4e89$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8f4f2705a5cd4e89$var$kPaused] = true;
    return this;
};
function $8f4f2705a5cd4e89$var$flow(stream) {
    var state = stream._readableState;
    $8f4f2705a5cd4e89$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8f4f2705a5cd4e89$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $8f4f2705a5cd4e89$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $8f4f2705a5cd4e89$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8f4f2705a5cd4e89$var$Readable.prototype[$8f4f2705a5cd4e89$var$SymbolAsyncIterator] = function() {
    return $8f4f2705a5cd4e89$var$streamToAsyncIterator(this);
};
$8f4f2705a5cd4e89$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8f4f2705a5cd4e89$require$validateObject(options, 'options');
    return $8f4f2705a5cd4e89$var$streamToAsyncIterator(this, options);
};
function $8f4f2705a5cd4e89$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8f4f2705a5cd4e89$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $8f4f2705a5cd4e89$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $8f4f2705a5cd4e89$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $8f4f2705a5cd4e89$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $8f4f2705a5cd4e89$var$nop;
                    stream.on('readable', next);
                    cleanup = $32wt8(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $8f4f2705a5cd4e89$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $8f4f2705a5cd4e89$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $8f4f2705a5cd4e89$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $8f4f2705a5cd4e89$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $kKCEf.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8f4f2705a5cd4e89$var$ObjectDefineProperties($8f4f2705a5cd4e89$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8f4f2705a5cd4e89$var$ObjectDefineProperties($8f4f2705a5cd4e89$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$8f4f2705a5cd4e89$var$kPaused] !== false;
        },
        set: function(value) {
            this[$8f4f2705a5cd4e89$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8f4f2705a5cd4e89$var$Readable._fromList = $8f4f2705a5cd4e89$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8f4f2705a5cd4e89$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8f4f2705a5cd4e89$var$endReadable(stream) {
    var state = stream._readableState;
    $8f4f2705a5cd4e89$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($8f4f2705a5cd4e89$var$endReadableNT, state, stream);
    }
}
function $8f4f2705a5cd4e89$var$endReadableNT(state, stream) {
    $8f4f2705a5cd4e89$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($8f4f2705a5cd4e89$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8f4f2705a5cd4e89$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8f4f2705a5cd4e89$var$Readable.from = function(iterable, opts) {
    return $8M20o($8f4f2705a5cd4e89$var$Readable, iterable, opts);
};
var $8f4f2705a5cd4e89$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8f4f2705a5cd4e89$var$lazyWebStreams() {
    if ($8f4f2705a5cd4e89$var$webStreamsAdapters === undefined) $8f4f2705a5cd4e89$var$webStreamsAdapters = {};
    return $8f4f2705a5cd4e89$var$webStreamsAdapters;
}
$8f4f2705a5cd4e89$var$Readable.fromWeb = function(readableStream, options) {
    return $8f4f2705a5cd4e89$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8f4f2705a5cd4e89$var$Readable.toWeb = function(streamReadable, options) {
    return $8f4f2705a5cd4e89$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8f4f2705a5cd4e89$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8f4f2705a5cd4e89$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $kKCEf.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("lDfEi", function(module, exports) {
'use strict';

var $492qd = parcelRequire("492qd");
var $fbf9610521d0af38$var$ArrayIsArray = $492qd.ArrayIsArray, $fbf9610521d0af38$var$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $fbf9610521d0af38$var$EE = $bBoAO.EventEmitter;
function $fbf9610521d0af38$var$Stream(opts) {
    $fbf9610521d0af38$var$EE.call(this, opts);
}
$fbf9610521d0af38$var$ObjectSetPrototypeOf($fbf9610521d0af38$var$Stream.prototype, $fbf9610521d0af38$var$EE.prototype);
$fbf9610521d0af38$var$ObjectSetPrototypeOf($fbf9610521d0af38$var$Stream, $fbf9610521d0af38$var$EE);
$fbf9610521d0af38$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($fbf9610521d0af38$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $fbf9610521d0af38$var$prependListener(source, 'error', onerror);
    $fbf9610521d0af38$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $fbf9610521d0af38$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($fbf9610521d0af38$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $fbf9610521d0af38$var$Stream,
    prependListener: $fbf9610521d0af38$var$prependListener
};

});

parcelRegister("1xKKt", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $11fd22c9dfc97ed2$export$e2db56ee53255a0; }, function (v) { return $11fd22c9dfc97ed2$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $11fd22c9dfc97ed2$export$11956e9313f43de0; }, function (v) { return $11fd22c9dfc97ed2$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $11fd22c9dfc97ed2$export$e2db56ee53255a0;
var $11fd22c9dfc97ed2$export$11956e9313f43de0;
'use strict';

var $492qd = parcelRequire("492qd");
var $11fd22c9dfc97ed2$require$SymbolDispose = $492qd.SymbolDispose;

var $j63nd = parcelRequire("j63nd");
var $11fd22c9dfc97ed2$var$AbortError = $j63nd.AbortError, $11fd22c9dfc97ed2$var$codes = $j63nd.codes;

var $buMDs = parcelRequire("buMDs");
var $11fd22c9dfc97ed2$var$isNodeStream = $buMDs.isNodeStream, $11fd22c9dfc97ed2$var$isWebStream = $buMDs.isWebStream, $11fd22c9dfc97ed2$var$kControllerErrorFunction = $buMDs.kControllerErrorFunction;

var $32wt8 = parcelRequire("32wt8");
var $11fd22c9dfc97ed2$var$ERR_INVALID_ARG_TYPE = $11fd22c9dfc97ed2$var$codes.ERR_INVALID_ARG_TYPE;
var $11fd22c9dfc97ed2$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $11fd22c9dfc97ed2$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $11fd22c9dfc97ed2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$11fd22c9dfc97ed2$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $11fd22c9dfc97ed2$var$validateAbortSignal(signal, 'signal');
    if (!$11fd22c9dfc97ed2$var$isNodeStream(stream) && !$11fd22c9dfc97ed2$var$isWebStream(stream)) throw new $11fd22c9dfc97ed2$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $11fd22c9dfc97ed2$export$11956e9313f43de0(signal, stream);
};

$11fd22c9dfc97ed2$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $11fd22c9dfc97ed2$var$isNodeStream(stream) ? function() {
        stream.destroy(new $11fd22c9dfc97ed2$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$11fd22c9dfc97ed2$var$kControllerErrorFunction](new $11fd22c9dfc97ed2$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $11fd22c9dfc97ed2$var$addAbortListener = $11fd22c9dfc97ed2$var$addAbortListener || (parcelRequire("i2eun")).addAbortListener;
        var disposable = $11fd22c9dfc97ed2$var$addAbortListener(signal, onAbort);
        $32wt8(stream, disposable[$11fd22c9dfc97ed2$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("3tXV7", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $492qd = parcelRequire("492qd");
var $28928f7318637bb5$var$StringPrototypeSlice = $492qd.StringPrototypeSlice, $28928f7318637bb5$var$SymbolIterator = $492qd.SymbolIterator, $28928f7318637bb5$var$TypedArrayPrototypeSet = $492qd.TypedArrayPrototypeSet, $28928f7318637bb5$var$Uint8Array = $492qd.Uint8Array;

var $2P1XW = parcelRequire("2P1XW");
var $28928f7318637bb5$require$Buffer = $2P1XW.Buffer;

var $i2eun = parcelRequire("i2eun");
var $28928f7318637bb5$require$inspect = $i2eun.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $28928f7318637bb5$require$Buffer.alloc(0);
                var ret = $28928f7318637bb5$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $28928f7318637bb5$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $28928f7318637bb5$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $28928f7318637bb5$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $28928f7318637bb5$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $28928f7318637bb5$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $28928f7318637bb5$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $28928f7318637bb5$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $28928f7318637bb5$var$TypedArrayPrototypeSet(ret, new $28928f7318637bb5$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $28928f7318637bb5$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cdB5t", function(module, exports) {
'use strict';

var $492qd = parcelRequire("492qd");
var $8e5377b175a72cb1$var$MathFloor = $492qd.MathFloor, $8e5377b175a72cb1$var$NumberIsInteger = $492qd.NumberIsInteger;

var $dCJgJ = parcelRequire("dCJgJ");
var $8e5377b175a72cb1$require$validateInteger = $dCJgJ.validateInteger;

var $8e5377b175a72cb1$var$ERR_INVALID_ARG_VALUE = (parcelRequire("j63nd")).codes.ERR_INVALID_ARG_VALUE;
var $8e5377b175a72cb1$var$defaultHighWaterMarkBytes = 16384;
var $8e5377b175a72cb1$var$defaultHighWaterMarkObjectMode = 16;
function $8e5377b175a72cb1$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $8e5377b175a72cb1$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $8e5377b175a72cb1$var$defaultHighWaterMarkObjectMode : $8e5377b175a72cb1$var$defaultHighWaterMarkBytes;
}
function $8e5377b175a72cb1$var$setDefaultHighWaterMark(objectMode, value) {
    $8e5377b175a72cb1$require$validateInteger(value, 'value', 0);
    if (objectMode) $8e5377b175a72cb1$var$defaultHighWaterMarkObjectMode = value;
    else $8e5377b175a72cb1$var$defaultHighWaterMarkBytes = value;
}
function $8e5377b175a72cb1$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $8e5377b175a72cb1$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$8e5377b175a72cb1$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $8e5377b175a72cb1$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $8e5377b175a72cb1$var$MathFloor(hwm);
    }
    // Default value
    return $8e5377b175a72cb1$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $8e5377b175a72cb1$var$getHighWaterMark,
    getDefaultHighWaterMark: $8e5377b175a72cb1$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $8e5377b175a72cb1$var$setDefaultHighWaterMark
};

});

parcelRegister("8M20o", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $492qd = parcelRequire("492qd");
/* replacement end */ var $66345ca30fb45631$var$PromisePrototypeThen = $492qd.PromisePrototypeThen, $66345ca30fb45631$var$SymbolAsyncIterator = $492qd.SymbolAsyncIterator, $66345ca30fb45631$var$SymbolIterator = $492qd.SymbolIterator;

var $2P1XW = parcelRequire("2P1XW");
var $66345ca30fb45631$require$Buffer = $2P1XW.Buffer;

var $j63nd = parcelRequire("j63nd");
var $66345ca30fb45631$require$_require_codes = $j63nd.codes;
var $66345ca30fb45631$var$ERR_INVALID_ARG_TYPE = $66345ca30fb45631$require$_require_codes.ERR_INVALID_ARG_TYPE, $66345ca30fb45631$var$ERR_STREAM_NULL_VALUES = $66345ca30fb45631$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $66345ca30fb45631$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $66345ca30fb45631$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$66345ca30fb45631$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$66345ca30fb45631$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$66345ca30fb45631$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$66345ca30fb45631$var$SymbolIterator]();
    } else throw new $66345ca30fb45631$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $66345ca30fb45631$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $66345ca30fb45631$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $66345ca30fb45631$var$from;

});


parcelRegister("5HHkr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $492qd = parcelRequire("492qd");
/* replacement end */ var $427294144014447e$var$ArrayPrototypeSlice = $492qd.ArrayPrototypeSlice, $427294144014447e$var$Error = $492qd.Error, $427294144014447e$var$FunctionPrototypeSymbolHasInstance = $492qd.FunctionPrototypeSymbolHasInstance, $427294144014447e$var$ObjectDefineProperty = $492qd.ObjectDefineProperty, $427294144014447e$var$ObjectDefineProperties = $492qd.ObjectDefineProperties, $427294144014447e$var$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf, $427294144014447e$var$StringPrototypeToLowerCase = $492qd.StringPrototypeToLowerCase, $427294144014447e$var$Symbol = $492qd.Symbol, $427294144014447e$var$SymbolHasInstance = $492qd.SymbolHasInstance;
module.exports = $427294144014447e$var$Writable;
$427294144014447e$var$Writable.WritableState = $427294144014447e$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $427294144014447e$var$EE = $bBoAO.EventEmitter;

var $lDfEi = parcelRequire("lDfEi");
var $427294144014447e$require$Stream = $lDfEi.Stream;

var $2P1XW = parcelRequire("2P1XW");
var $427294144014447e$require$Buffer = $2P1XW.Buffer;

var $kKCEf = parcelRequire("kKCEf");

var $1xKKt = parcelRequire("1xKKt");
var $427294144014447e$require$addAbortSignal = $1xKKt.addAbortSignal;

var $cdB5t = parcelRequire("cdB5t");
var $427294144014447e$var$getHighWaterMark = $cdB5t.getHighWaterMark, $427294144014447e$var$getDefaultHighWaterMark = $cdB5t.getDefaultHighWaterMark;

var $j63nd = parcelRequire("j63nd");
var $427294144014447e$require$_require_codes = $j63nd.codes;
var $427294144014447e$var$ERR_INVALID_ARG_TYPE = $427294144014447e$require$_require_codes.ERR_INVALID_ARG_TYPE, $427294144014447e$var$ERR_METHOD_NOT_IMPLEMENTED = $427294144014447e$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $427294144014447e$var$ERR_MULTIPLE_CALLBACK = $427294144014447e$require$_require_codes.ERR_MULTIPLE_CALLBACK, $427294144014447e$var$ERR_STREAM_CANNOT_PIPE = $427294144014447e$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $427294144014447e$var$ERR_STREAM_DESTROYED = $427294144014447e$require$_require_codes.ERR_STREAM_DESTROYED, $427294144014447e$var$ERR_STREAM_ALREADY_FINISHED = $427294144014447e$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $427294144014447e$var$ERR_STREAM_NULL_VALUES = $427294144014447e$require$_require_codes.ERR_STREAM_NULL_VALUES, $427294144014447e$var$ERR_STREAM_WRITE_AFTER_END = $427294144014447e$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $427294144014447e$var$ERR_UNKNOWN_ENCODING = $427294144014447e$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $427294144014447e$var$errorOrDestroy = $kKCEf.errorOrDestroy;
$427294144014447e$var$ObjectSetPrototypeOf($427294144014447e$var$Writable.prototype, $427294144014447e$require$Stream.prototype);
$427294144014447e$var$ObjectSetPrototypeOf($427294144014447e$var$Writable, $427294144014447e$require$Stream);
function $427294144014447e$var$nop() {}
var $427294144014447e$var$kOnFinished = $427294144014447e$var$Symbol('kOnFinished');

function $427294144014447e$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("6M6ea"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $427294144014447e$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $427294144014447e$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $427294144014447e$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $427294144014447e$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$427294144014447e$var$kOnFinished] = [];
}
function $427294144014447e$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$427294144014447e$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $427294144014447e$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$427294144014447e$var$ObjectDefineProperty($427294144014447e$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $427294144014447e$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("6M6ea"));
    if (!isDuplex && !$427294144014447e$var$FunctionPrototypeSymbolHasInstance($427294144014447e$var$Writable, this)) return new $427294144014447e$var$Writable(options);
    this._writableState = new $427294144014447e$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $427294144014447e$require$addAbortSignal(options.signal, this);
    }
    $427294144014447e$require$Stream.call(this, options);
    $kKCEf.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $427294144014447e$var$clearBuffer(_this, state);
        $427294144014447e$var$finishMaybe(_this, state);
    });
}
$427294144014447e$var$ObjectDefineProperty($427294144014447e$var$Writable, $427294144014447e$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($427294144014447e$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $427294144014447e$var$Writable) return false;
        return object && object._writableState instanceof $427294144014447e$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$427294144014447e$var$Writable.prototype.pipe = function() {
    $427294144014447e$var$errorOrDestroy(this, new $427294144014447e$var$ERR_STREAM_CANNOT_PIPE());
};
function $427294144014447e$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$427294144014447e$require$Buffer.isEncoding(encoding)) throw new $427294144014447e$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $427294144014447e$var$nop;
    }
    if (chunk === null) throw new $427294144014447e$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $427294144014447e$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $427294144014447e$require$Buffer) encoding = 'buffer';
        else if ($427294144014447e$require$Stream._isUint8Array(chunk)) {
            chunk = $427294144014447e$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $427294144014447e$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $427294144014447e$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $427294144014447e$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $427294144014447e$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $427294144014447e$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$427294144014447e$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $427294144014447e$var$_write(this, chunk, encoding, cb) === true;
};
$427294144014447e$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$427294144014447e$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $427294144014447e$var$clearBuffer(this, state);
    }
};
$427294144014447e$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $427294144014447e$var$StringPrototypeToLowerCase(encoding);
    if (!$427294144014447e$require$Buffer.isEncoding(encoding)) throw new $427294144014447e$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $427294144014447e$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $427294144014447e$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $427294144014447e$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $427294144014447e$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $427294144014447e$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $427294144014447e$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $427294144014447e$var$errorOrDestroy(stream, er);
}
function $427294144014447e$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $427294144014447e$var$errorOrDestroy(stream, new $427294144014447e$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($427294144014447e$var$onwriteError, stream, state, er, cb);
        else $427294144014447e$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $427294144014447e$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($427294144014447e$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $427294144014447e$var$afterWrite(stream, state, 1, cb);
    }
}
function $427294144014447e$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $427294144014447e$var$afterWrite(stream, state, count, cb);
}
function $427294144014447e$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $427294144014447e$var$errorBuffer(state);
    $427294144014447e$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $427294144014447e$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $427294144014447e$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$427294144014447e$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $427294144014447e$var$ERR_STREAM_DESTROYED('end'));
    }
    $427294144014447e$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $427294144014447e$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $427294144014447e$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $427294144014447e$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $427294144014447e$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $427294144014447e$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $427294144014447e$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $427294144014447e$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$427294144014447e$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $427294144014447e$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$427294144014447e$var$Writable.prototype._writev = null;
$427294144014447e$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $427294144014447e$var$_write(this, chunk, encoding);
        if (ret instanceof $427294144014447e$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $427294144014447e$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $427294144014447e$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $427294144014447e$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$427294144014447e$var$kOnFinished].push(cb);
    }
    return this;
};
function $427294144014447e$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $427294144014447e$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $427294144014447e$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $427294144014447e$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$427294144014447e$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $427294144014447e$var$errorOrDestroy(stream, err, state.sync);
        } else if ($427294144014447e$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($427294144014447e$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $427294144014447e$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $427294144014447e$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $427294144014447e$var$finishMaybe(stream, state, sync) {
    if ($427294144014447e$var$needFinish(state)) {
        $427294144014447e$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($427294144014447e$var$needFinish(state)) $427294144014447e$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($427294144014447e$var$needFinish(state)) {
                state.pendingcb++;
                $427294144014447e$var$finish(stream, state);
            }
        }
    }
}
function $427294144014447e$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$427294144014447e$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$427294144014447e$var$ObjectDefineProperties($427294144014447e$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $427294144014447e$var$destroy = $kKCEf.destroy;
$427294144014447e$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$427294144014447e$var$kOnFinished].length)) $2Qkr5.nextTick($427294144014447e$var$errorBuffer, state);
    $427294144014447e$var$destroy.call(this, err, cb);
    return this;
};
$427294144014447e$var$Writable.prototype._undestroy = $kKCEf.undestroy;
$427294144014447e$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$427294144014447e$var$Writable.prototype[$427294144014447e$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $427294144014447e$var$webStreamsAdapters;
// Lazy to avoid circular references
function $427294144014447e$var$lazyWebStreams() {
    if ($427294144014447e$var$webStreamsAdapters === undefined) $427294144014447e$var$webStreamsAdapters = {};
    return $427294144014447e$var$webStreamsAdapters;
}
$427294144014447e$var$Writable.fromWeb = function(writableStream, options) {
    return $427294144014447e$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$427294144014447e$var$Writable.toWeb = function(streamWritable) {
    return $427294144014447e$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("rigBT", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $2P1XW = parcelRequire("2P1XW");

var $buMDs = parcelRequire("buMDs");
var $0520b12867030d3b$var$isReadable = $buMDs.isReadable, $0520b12867030d3b$var$isWritable = $buMDs.isWritable, $0520b12867030d3b$var$isIterable = $buMDs.isIterable, $0520b12867030d3b$var$isNodeStream = $buMDs.isNodeStream, $0520b12867030d3b$var$isReadableNodeStream = $buMDs.isReadableNodeStream, $0520b12867030d3b$var$isWritableNodeStream = $buMDs.isWritableNodeStream, $0520b12867030d3b$var$isDuplexNodeStream = $buMDs.isDuplexNodeStream, $0520b12867030d3b$var$isReadableStream = $buMDs.isReadableStream, $0520b12867030d3b$var$isWritableStream = $buMDs.isWritableStream;

var $32wt8 = parcelRequire("32wt8");

var $j63nd = parcelRequire("j63nd");
var $0520b12867030d3b$var$AbortError = $j63nd.AbortError, $0520b12867030d3b$var$_require_codes = $j63nd.codes, $0520b12867030d3b$var$ERR_INVALID_ARG_TYPE = $0520b12867030d3b$var$_require_codes.ERR_INVALID_ARG_TYPE, $0520b12867030d3b$var$ERR_INVALID_RETURN_VALUE = $0520b12867030d3b$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $kKCEf = parcelRequire("kKCEf");
var $0520b12867030d3b$require$destroyer = $kKCEf.destroyer;

var $6M6ea = parcelRequire("6M6ea");

var $ciPy6 = parcelRequire("ciPy6");

var $5HHkr = parcelRequire("5HHkr");

var $i2eun = parcelRequire("i2eun");
var $0520b12867030d3b$require$createDeferredPromise = $i2eun.createDeferredPromise;

var $8M20o = parcelRequire("8M20o");
var $0520b12867030d3b$var$Blob = globalThis.Blob || $2P1XW.Blob;
var $0520b12867030d3b$var$isBlob = typeof $0520b12867030d3b$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $0520b12867030d3b$var$Blob;
} : function isBlob(b) {
    return false;
};

var $0520b12867030d3b$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $492qd = parcelRequire("492qd");
var $0520b12867030d3b$require$FunctionPrototypeCall = $492qd.FunctionPrototypeCall;
// This is needed for pre node 17.
var $0520b12867030d3b$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($6M6ea);
module.exports = function duplexify(body, name) {
    if ($0520b12867030d3b$var$isDuplexNodeStream(body)) return body;
    if ($0520b12867030d3b$var$isReadableNodeStream(body)) return $0520b12867030d3b$var$_duplexify({
        readable: body
    });
    if ($0520b12867030d3b$var$isWritableNodeStream(body)) return $0520b12867030d3b$var$_duplexify({
        writable: body
    });
    if ($0520b12867030d3b$var$isNodeStream(body)) return $0520b12867030d3b$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($0520b12867030d3b$var$isReadableStream(body)) return $0520b12867030d3b$var$_duplexify({
        readable: $ciPy6.fromWeb(body)
    });
    if ($0520b12867030d3b$var$isWritableStream(body)) return $0520b12867030d3b$var$_duplexify({
        writable: $5HHkr.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $0520b12867030d3b$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($0520b12867030d3b$var$isIterable(value)) return $8M20o($0520b12867030d3b$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $0520b12867030d3b$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $0520b12867030d3b$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $0520b12867030d3b$require$destroyer(d, err);
            });
            return d = new $0520b12867030d3b$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $0520b12867030d3b$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($0520b12867030d3b$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($0520b12867030d3b$var$isIterable(body)) return $8M20o($0520b12867030d3b$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($0520b12867030d3b$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $0520b12867030d3b$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $0520b12867030d3b$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $0520b12867030d3b$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $0520b12867030d3b$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $0520b12867030d3b$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $0520b12867030d3b$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $0520b12867030d3b$require$destroyer(d1, err);
        });
        return d1 = new $0520b12867030d3b$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $0520b12867030d3b$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $0520b12867030d3b$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $0520b12867030d3b$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $0520b12867030d3b$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $0520b12867030d3b$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $0520b12867030d3b$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $0520b12867030d3b$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $ciPy6.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$0520b12867030d3b$var$isReadable(r);
    var writable = !!$0520b12867030d3b$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $0520b12867030d3b$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $32wt8(w, function(err) {
            writable = false;
            if (err) $0520b12867030d3b$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $32wt8(r, function(err) {
            readable = false;
            if (err) $0520b12867030d3b$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $0520b12867030d3b$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $0520b12867030d3b$require$destroyer(w, err);
            $0520b12867030d3b$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("bMmEU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $492qd = parcelRequire("492qd");
var $8935c0fba55d2f13$require$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf;
module.exports = $8935c0fba55d2f13$var$PassThrough;

var $aa0uq = parcelRequire("aa0uq");
$8935c0fba55d2f13$require$ObjectSetPrototypeOf($8935c0fba55d2f13$var$PassThrough.prototype, $aa0uq.prototype);
$8935c0fba55d2f13$require$ObjectSetPrototypeOf($8935c0fba55d2f13$var$PassThrough, $aa0uq);
function $8935c0fba55d2f13$var$PassThrough(options) {
    if (!(this instanceof $8935c0fba55d2f13$var$PassThrough)) return new $8935c0fba55d2f13$var$PassThrough(options);
    $aa0uq.call(this, options);
}
$8935c0fba55d2f13$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("aa0uq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $492qd = parcelRequire("492qd");
var $765b37cecf6cabaa$var$ObjectSetPrototypeOf = $492qd.ObjectSetPrototypeOf, $765b37cecf6cabaa$var$Symbol = $492qd.Symbol;
module.exports = $765b37cecf6cabaa$var$Transform;

var $765b37cecf6cabaa$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("j63nd")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $6M6ea = parcelRequire("6M6ea");

var $cdB5t = parcelRequire("cdB5t");
var $765b37cecf6cabaa$require$getHighWaterMark = $cdB5t.getHighWaterMark;
$765b37cecf6cabaa$var$ObjectSetPrototypeOf($765b37cecf6cabaa$var$Transform.prototype, $6M6ea.prototype);
$765b37cecf6cabaa$var$ObjectSetPrototypeOf($765b37cecf6cabaa$var$Transform, $6M6ea);
var $765b37cecf6cabaa$var$kCallback = $765b37cecf6cabaa$var$Symbol('kCallback');
function $765b37cecf6cabaa$var$Transform(options) {
    if (!(this instanceof $765b37cecf6cabaa$var$Transform)) return new $765b37cecf6cabaa$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $765b37cecf6cabaa$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $6M6ea.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$765b37cecf6cabaa$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $765b37cecf6cabaa$var$prefinish);
}
function $765b37cecf6cabaa$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $765b37cecf6cabaa$var$prefinish() {
    if (this._final !== $765b37cecf6cabaa$var$_final) $765b37cecf6cabaa$var$_final.call(this);
}
$765b37cecf6cabaa$var$Transform.prototype._final = $765b37cecf6cabaa$var$_final;
$765b37cecf6cabaa$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $765b37cecf6cabaa$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$765b37cecf6cabaa$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$765b37cecf6cabaa$var$kCallback] = callback;
    });
};
$765b37cecf6cabaa$var$Transform.prototype._read = function() {
    if (this[$765b37cecf6cabaa$var$kCallback]) {
        var callback = this[$765b37cecf6cabaa$var$kCallback];
        this[$765b37cecf6cabaa$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2VyQ7", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $492qd = parcelRequire("492qd");
var $221bee15d52dd2d3$var$ArrayPrototypePop = $492qd.ArrayPrototypePop, $221bee15d52dd2d3$var$Promise = $492qd.Promise;

var $buMDs = parcelRequire("buMDs");
var $221bee15d52dd2d3$var$isIterable = $buMDs.isIterable, $221bee15d52dd2d3$var$isNodeStream = $buMDs.isNodeStream, $221bee15d52dd2d3$var$isWebStream = $buMDs.isWebStream;

var $cqclD = parcelRequire("cqclD");
var $221bee15d52dd2d3$var$pl = $cqclD.pipelineImpl;

var $32wt8 = parcelRequire("32wt8");
var $221bee15d52dd2d3$require$finished = $32wt8.finished;
parcelRequire("lnO7E");
function $221bee15d52dd2d3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $221bee15d52dd2d3$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$221bee15d52dd2d3$var$isNodeStream(lastArg) && !$221bee15d52dd2d3$var$isIterable(lastArg) && !$221bee15d52dd2d3$var$isWebStream(lastArg)) {
            var options = $221bee15d52dd2d3$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $221bee15d52dd2d3$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $221bee15d52dd2d3$require$finished,
    pipeline: $221bee15d52dd2d3$var$pipeline
};

});






parcelRegister("4ecIx", function(module, exports) {
"use strict";
var $3142559f1d66eb29$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3142559f1d66eb29$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3142559f1d66eb29$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3142559f1d66eb29$var$__exportStar((parcelRequire("7xaT7")), module.exports);

$3142559f1d66eb29$var$__exportStar((parcelRequire("9AbKp")), module.exports);

});
parcelRegister("7xaT7", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaPutLdp = void 0;

var $f3FhC = parcelRequire("f3FhC");

var $kNNoa = parcelRequire("kNNoa");

var $9AbKp = parcelRequire("9AbKp");
/**
 * A comunica Post LDP RDF Update Hypermedia Actor.
 */ var $57c40fa073670943$var$ActorRdfUpdateHypermediaPutLdp = /*#__PURE__*/ function(_bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia) {
    (0, $i3fW3._)(ActorRdfUpdateHypermediaPutLdp, _bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia);
    function ActorRdfUpdateHypermediaPutLdp(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateHypermediaPutLdp);
        return (0, $kzDuW._)(this, ActorRdfUpdateHypermediaPutLdp, [
            args,
            'putLdp'
        ]);
    }
    (0, $byiyg._)(ActorRdfUpdateHypermediaPutLdp, [
        {
            key: "testMetadata",
            value: function testMetadata(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.forceDestinationType) {
                            if (!action.metadata.allowHttpMethods || !action.metadata.allowHttpMethods.includes('PUT')) return [
                                2,
                                (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not detect a destination with 'Allow: PUT' header."))
                            ];
                            if (action.exists) return [
                                2,
                                (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only put on a destination that does not already exists."))
                            ];
                        }
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        this.logInfo(action.context, "Identified as putLdp destination: ".concat(action.url));
                        return [
                            2,
                            {
                                destination: new $9AbKp.QuadDestinationPutLdp(action.url, action.context, action.metadata.putAccepted || [], this.mediatorHttp, this.mediatorRdfSerializeMediatypes, this.mediatorRdfSerialize)
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfUpdateHypermediaPutLdp;
}($f3FhC.ActorRdfUpdateHypermedia);
module.exports.ActorRdfUpdateHypermediaPutLdp = $57c40fa073670943$var$ActorRdfUpdateHypermediaPutLdp;

});
parcelRegister("9AbKp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationPutLdp = void 0;

var $2terW = parcelRequire("2terW");
/**
 * A quad destination that represents a resource that can be PUT.
 */ var $6fa096adf609d438$var$QuadDestinationPutLdp = /*#__PURE__*/ function() {
    function QuadDestinationPutLdp(url, context, mediaTypes, mediatorHttp, mediatorRdfSerializeMediatypes, mediatorRdfSerialize) {
        (0, $jGAMp._)(this, QuadDestinationPutLdp);
        this.url = url;
        this.context = context;
        this.mediaTypes = mediaTypes;
        this.mediatorHttp = mediatorHttp;
        this.mediatorRdfSerializeMediatypes = mediatorRdfSerializeMediatypes;
        this.mediatorRdfSerialize = mediatorRdfSerialize;
    }
    (0, $byiyg._)(QuadDestinationPutLdp, [
        {
            key: "update",
            value: function update(quadStreams) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (quadStreams["delete"]) throw new Error("Put-based LDP destinations don't support deletions");
                                if (!quadStreams.insert) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.wrapRdfUpdateRequest('INSERT', quadStreams.insert)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "wrapRdfUpdateRequest",
            value: function wrapRdfUpdateRequest(type, quads) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var mediaTypes, availableMediaTypes, mediaType, _ref, data, headers, httpResponse;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorRdfSerializeMediatypes.mediate({
                                        context: this.context,
                                        mediaTypes: true
                                    })
                                ];
                            case 1:
                                mediaTypes = _state.sent().mediaTypes;
                                availableMediaTypes = this.mediaTypes.filter(function(mediaType) {
                                    return mediaType in mediaTypes;
                                });
                                // Fallback to our own preferred media type
                                mediaType = availableMediaTypes.length > 0 ? availableMediaTypes[0] : Object.keys(mediaTypes).sort(function(typeA, typeB) {
                                    return mediaTypes[typeB] - mediaTypes[typeA];
                                })[0];
                                return [
                                    4,
                                    this.mediatorRdfSerialize.mediate({
                                        context: this.context,
                                        handle: {
                                            quadStream: quads,
                                            context: this.context
                                        },
                                        handleMediaType: mediaType
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), data = _ref.handle.data;
                                // Send data in (LDP) PUT request
                                headers = new Headers({
                                    'content-type': mediaType
                                });
                                return [
                                    4,
                                    this.mediatorHttp.mediate({
                                        context: this.context,
                                        init: {
                                            headers: headers,
                                            method: 'PUT',
                                            body: $2terW.ActorHttp.toWebReadableStream(data)
                                        },
                                        input: this.url
                                    })
                                ];
                            case 3:
                                httpResponse = _state.sent();
                                return [
                                    4,
                                    (0, $2terW.validateAndCloseHttpResponse)(this.url, httpResponse)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteGraphs",
            value: function deleteGraphs(_graphs, _requireExistence, _dropGraphs) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error("Put-based LDP destinations don't support named graphs");
                    });
                })();
            }
        },
        {
            key: "createGraphs",
            value: function createGraphs(_graphs, _requireNonExistence) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        throw new Error("Put-based LDP destinations don't support named graphs");
                    });
                })();
            }
        }
    ]);
    return QuadDestinationPutLdp;
}();
module.exports.QuadDestinationPutLdp = $6fa096adf609d438$var$QuadDestinationPutLdp;

});



parcelRegister("3eiUy", function(module, exports) {
"use strict";
var $25a159478c313391$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $25a159478c313391$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $25a159478c313391$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$25a159478c313391$var$__exportStar((parcelRequire("5ohpm")), module.exports);

$25a159478c313391$var$__exportStar((parcelRequire("9p6bX")), module.exports);

});
parcelRegister("5ohpm", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaSparql = void 0;

var $f3FhC = parcelRequire("f3FhC");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $9p6bX = parcelRequire("9p6bX");
/**
 * A comunica SPARQL RDF Update Hypermedia Actor.
 */ var $3eccb2832660d987$var$ActorRdfUpdateHypermediaSparql = /*#__PURE__*/ function(_bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia) {
    (0, $i3fW3._)(ActorRdfUpdateHypermediaSparql, _bus_rdf_update_hypermedia_1_ActorRdfUpdateHypermedia);
    function ActorRdfUpdateHypermediaSparql(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateHypermediaSparql);
        return (0, $kzDuW._)(this, ActorRdfUpdateHypermediaSparql, [
            args,
            'sparql'
        ]);
    }
    (0, $byiyg._)(ActorRdfUpdateHypermediaSparql, [
        {
            key: "testMetadata",
            value: function testMetadata(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.forceDestinationType && !action.metadata.sparqlService && !(this.checkUrlSuffixSparql && (action.url.endsWith('/sparql') || action.url.endsWith('/sparql/'))) && !(this.checkUrlSuffixUpdate && (action.url.endsWith('/update') || action.url.endsWith('/update/')))) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not detect a SPARQL service description or URL ending on /sparql or /update."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        this.logInfo(action.context, "Identified as sparql destination: ".concat(action.url));
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        return [
                            2,
                            {
                                destination: new $9p6bX.QuadDestinationSparql(action.metadata.sparqlService || action.url, action.context, this.mediatorHttp, dataFactory)
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfUpdateHypermediaSparql;
}($f3FhC.ActorRdfUpdateHypermedia);
module.exports.ActorRdfUpdateHypermediaSparql = $3eccb2832660d987$var$ActorRdfUpdateHypermediaSparql;

});
parcelRegister("9p6bX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationSparql = void 0;

var $99iqU = parcelRequire("99iqU");

var $aafx9 = parcelRequire("aafx9");

var $8MpqH = parcelRequire("8MpqH");

var $3veIK = parcelRequire("3veIK");
/**
 * A quad destination that represents an LDP resource.
 */ var $6d8b406ec9a8ade9$var$QuadDestinationSparql = /*#__PURE__*/ function() {
    function QuadDestinationSparql(url, context, mediatorHttp, dataFactory) {
        var _this = this;
        (0, $jGAMp._)(this, QuadDestinationSparql);
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
        this.endpointFetcher = new $8MpqH.SparqlEndpointFetcher({
            fetch: function(input, init) {
                return _this.mediatorHttp.mediate({
                    input: input,
                    init: init,
                    context: _this.context
                });
            },
            prefixVariableQuestionMark: true,
            dataFactory: dataFactory
        });
    }
    (0, $byiyg._)(QuadDestinationSparql, [
        {
            key: "update",
            value: function update(quadStreams) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var queryStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Create combined query stream with quads to insert and delete
                                queryStream = this.createCombinedQuadsQuery(quadStreams.insert, quadStreams["delete"]);
                                return [
                                    4,
                                    this.wrapSparqlUpdateRequest(queryStream)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createCombinedQuadsQuery",
            value: function createCombinedQuadsQuery(quadsToInsert, quadsToDelete) {
                return new $aafx9.ArrayIterator([], {
                    autoStart: false
                }).append(this.createQuadsQuery('DELETE', quadsToDelete)).append(quadsToDelete && quadsToInsert ? [
                    ' ;\n'
                ] : []).append(this.createQuadsQuery('INSERT', quadsToInsert));
            }
        },
        {
            key: "createQuadsQuery",
            value: function createQuadsQuery(type, quads) {
                if (!quads) return new $aafx9.ArrayIterator([], {
                    autoStart: false
                });
                return quads.map(function(quad) {
                    var stringQuad = "".concat((0, $3veIK.termToString)(quad.subject), " ").concat((0, $3veIK.termToString)(quad.predicate), " ").concat((0, $3veIK.termToString)(quad.object), " .");
                    if (quad.graph.termType === 'DefaultGraph') stringQuad = "  ".concat(stringQuad, "\n");
                    else stringQuad = "  GRAPH ".concat((0, $3veIK.termToString)(quad.graph), " { ").concat(stringQuad, " }\n");
                    return stringQuad;
                }).prepend([
                    "".concat(type, " DATA {\n")
                ]).append([
                    '}'
                ]);
            }
        },
        {
            key: "wrapSparqlUpdateRequest",
            value: function wrapSparqlUpdateRequest(queryStream) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var query;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $99iqU.stringify)(queryStream)
                                ];
                            case 1:
                                query = _state.sent();
                                // Send update query to endpoint
                                return [
                                    4,
                                    this.endpointFetcher.fetchUpdate(this.url, query)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteGraphs",
            value: function deleteGraphs(graphsIn, requireExistence, dropGraphs) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var graphs, queries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, graph, graphValue;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                graphs = Array.isArray(graphsIn) ? graphsIn : [
                                    graphsIn
                                ];
                                queries = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = graphs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        graph = _step.value;
                                        graphValue = void 0;
                                        if (typeof graph === 'string') graphValue = graph;
                                        else if (graph.termType === 'DefaultGraph') graphValue = 'DEFAULT';
                                        else graphValue = "GRAPH <".concat(graph.value, ">");
                                        queries.push("".concat(dropGraphs ? 'DROP' : 'CLEAR', " ").concat(requireExistence ? '' : 'SILENT ').concat(graphValue));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    this.endpointFetcher.fetchUpdate(this.url, queries.join('; '))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createGraphs",
            value: function createGraphs(graphs, requireNonExistence) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var queries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, graph;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queries = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = graphs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        graph = _step.value;
                                        queries.push("CREATE".concat(requireNonExistence ? '' : ' SILENT', " GRAPH <").concat(graph.value, ">"));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    this.endpointFetcher.fetchUpdate(this.url, queries.join('; '))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return QuadDestinationSparql;
}();
module.exports.QuadDestinationSparql = $6d8b406ec9a8ade9$var$QuadDestinationSparql;

});
parcelRegister("8MpqH", function(module, exports) {
"use strict";
var $6646883c69869cb2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6646883c69869cb2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6646883c69869cb2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6646883c69869cb2$var$__exportStar((parcelRequire("6WxLw")), module.exports);

});
parcelRegister("6WxLw", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $014df93173677616$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlEndpointFetcher = void 0;

var $fUgD9 = parcelRequire("fUgD9");
parcelRequire("29pVS");
var $7dmRm = parcelRequire("7dmRm");

var $2dfGl = parcelRequire("2dfGl");

var $2h2ox = parcelRequire("2h2ox");

var $ia9U2 = parcelRequire("ia9U2");

var $jcvYk = parcelRequire("jcvYk");

var $dwDuJ = parcelRequire("dwDuJ");
/**
 * A SparqlEndpointFetcher can send queries to SPARQL endpoints,
 * and retrieve and parse the results.
 */ var $014df93173677616$var$SparqlEndpointFetcher = /*#__PURE__*/ function() {
    function SparqlEndpointFetcher(args) {
        var _this = this;
        (0, $jGAMp._)(this, SparqlEndpointFetcher);
        var _a, _b, _c;
        this.method = (_a = args === null || args === void 0 ? void 0 : args.method) !== null && _a !== void 0 ? _a : 'POST';
        this.timeout = args === null || args === void 0 ? void 0 : args.timeout;
        this.additionalUrlParams = (_b = args === null || args === void 0 ? void 0 : args.additionalUrlParams) !== null && _b !== void 0 ? _b : new URLSearchParams();
        this.defaultHeaders = (_c = args === null || args === void 0 ? void 0 : args.defaultHeaders) !== null && _c !== void 0 ? _c : new Headers();
        this.fetchCb = args === null || args === void 0 ? void 0 : args.fetch;
        this.sparqlJsonParser = new $ia9U2.SparqlJsonParser(args);
        this.sparqlXmlParser = new $jcvYk.SparqlXmlParser(args);
        var _obj;
        this.sparqlParsers = (_obj = {}, (0, $cqEAj._)(_obj, SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON, {
            parseBooleanStream: function(sparqlResponseStream) {
                return _this.sparqlJsonParser.parseJsonBooleanStream(sparqlResponseStream);
            },
            parseResultsStream: function(sparqlResponseStream) {
                return _this.sparqlJsonParser.parseJsonResultsStream(sparqlResponseStream);
            }
        }), (0, $cqEAj._)(_obj, SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML, {
            parseBooleanStream: function(sparqlResponseStream) {
                return _this.sparqlXmlParser.parseXmlBooleanStream(sparqlResponseStream);
            },
            parseResultsStream: function(sparqlResponseStream) {
                return _this.sparqlXmlParser.parseXmlResultsStream(sparqlResponseStream);
            }
        }), _obj);
    }
    (0, $byiyg._)(SparqlEndpointFetcher, [
        {
            /**
     * Get the query type of the given query.
     *
     * This will parse the query and thrown an exception on syntax errors.
     *
     * @param {string} query A query.
     * @return {'SELECT' | 'ASK' | 'CONSTRUCT' | 'UNKNOWN'} The query type.
     */ key: "getQueryType",
            value: function getQueryType(query) {
                var parsedQuery = new $2h2ox.Parser({
                    sparqlStar: true
                }).parse(query);
                if (parsedQuery.type === 'query') return parsedQuery.queryType === 'DESCRIBE' ? 'CONSTRUCT' : parsedQuery.queryType;
                return 'UNKNOWN';
            }
        },
        {
            /**
     * Get the query type of the given update query.
     *
     * This will parse the update query and thrown an exception on syntax errors.
     *
     * @param {string} query An update query.
     * @return {'UNKNOWN' | UpdateTypes} The included update operations.
     */ key: "getUpdateTypes",
            value: function getUpdateTypes(query) {
                var parsedQuery = new $2h2ox.Parser({
                    sparqlStar: true
                }).parse(query);
                if (parsedQuery.type === 'update') {
                    var operations = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = parsedQuery.updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var update = _step.value;
                            if ('type' in update) operations[update.type] = true;
                            else operations[update.updateType] = true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return operations;
                }
                return 'UNKNOWN';
            }
        },
        {
            /**
     * Send a SELECT query to the given endpoint URL and return the resulting bindings stream.
     * @see IBindings
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<NodeJS.ReadableStream>} A stream of {@link IBindings}.
     */ key: "fetchBindings",
            value: function fetchBindings(endpoint, query) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, contentType, responseStream, parser;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_SPARQL)
                                ];
                            case 1:
                                _ref = (0, $32TW8._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), contentType = _ref[0], responseStream = _ref[1];
                                parser = this.sparqlParsers[contentType];
                                if (!parser) throw new Error("Unknown SPARQL results content type: ".concat(contentType));
                                return [
                                    2,
                                    parser.parseResultsStream(responseStream)
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Send an ASK query to the given endpoint URL and return a promise resolving to the boolean answer.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<boolean>} A boolean resolving to the answer.
     */ key: "fetchAsk",
            value: function fetchAsk(endpoint, query) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, contentType, responseStream, parser;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_SPARQL)
                                ];
                            case 1:
                                _ref = (0, $32TW8._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), contentType = _ref[0], responseStream = _ref[1];
                                parser = this.sparqlParsers[contentType];
                                if (!parser) throw new Error("Unknown SPARQL results content type: ".concat(contentType));
                                return [
                                    2,
                                    parser.parseBooleanStream(responseStream)
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Send a CONSTRUCT/DESCRIBE query to the given endpoint URL and return the resulting triple stream.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<Stream>} A stream of triples.
     */ key: "fetchTriples",
            value: function fetchTriples(endpoint, query) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, contentType, responseStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_TURTLE)
                                ];
                            case 1:
                                _ref = (0, $32TW8._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), contentType = _ref[0], responseStream = _ref[1];
                                return [
                                    2,
                                    responseStream.pipe(new $7dmRm.default({
                                        format: contentType
                                    }))
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Send an update query to the given endpoint URL using POST.
     *
     * @param {string} endpoint     A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query        A SPARQL query string.
     */ key: "fetchUpdate",
            value: function fetchUpdate(endpoint, query) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var abortController, defaultHeadersRaw, init;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                abortController = new AbortController();
                                defaultHeadersRaw = {};
                                // Headers object does not have other means to iterate it according to the typings
                                // eslint-disable-next-line unicorn/no-array-for-each
                                this.defaultHeaders.forEach(function(value, key) {
                                    defaultHeadersRaw[key] = value;
                                });
                                init = {
                                    method: 'POST',
                                    headers: Object.assign(Object.assign({}, defaultHeadersRaw), {
                                        'content-type': 'application/sparql-update'
                                    }),
                                    body: query,
                                    signal: abortController.signal
                                };
                                return [
                                    4,
                                    this.handleFetchCall(endpoint, init, {
                                        ignoreBody: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                abortController.abort();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Send a query to the given endpoint URL and return the resulting stream.
     *
     * This will only accept responses with the application/sparql-results+json content type.
     *
     * @param {string} endpoint     A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query        A SPARQL query string.
     * @param {string} acceptHeader The HTTP accept to use.
     * @return {Promise<[string, NodeJS.ReadableStream]>} The content type and SPARQL endpoint response stream.
     */ key: "fetchRawStream",
            value: function fetchRawStream(endpoint, query, acceptHeader) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var url, body, headers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        url = this.method === 'POST' ? endpoint : "".concat(endpoint, "?query=").concat(encodeURIComponent(query));
                        headers = new Headers(this.defaultHeaders);
                        headers.append('Accept', acceptHeader);
                        if (this.method === 'POST') {
                            headers.append('Content-Type', 'application/x-www-form-urlencoded');
                            body = new URLSearchParams();
                            body.set('query', query);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = this.additionalUrlParams.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                    body.set(key, value);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            headers.append('Content-Length', body.toString().length.toString());
                        } else if (this.additionalUrlParams.toString().length > 0) url += "&".concat(this.additionalUrlParams.toString());
                        return [
                            2,
                            this.handleFetchCall(url, {
                                headers: headers,
                                method: this.method,
                                body: body
                            })
                        ];
                    });
                });
            }
        },
        {
            /**
     * Helper function to generalize internal fetch calls.
     *
     * @param {string}      url     The URL to call.
     * @param {RequestInit} init    Options to pass along to the fetch call.
     * @param {any}         options Other specific fetch options.
     * @return {Promise<[string, NodeJS.ReadableStream]>} The content type and SPARQL endpoint response stream.
     */ key: "handleFetchCall",
            value: function handleFetchCall(url, init, options) {
                return $014df93173677616$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, _c, timeout, responseStream, controller, httpResponse, simpleUrl, bodyString, _tmp, contentType;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.timeout) {
                                    controller = new AbortController();
                                    init.signal = controller.signal;
                                    timeout = setTimeout(function() {
                                        return controller.abort();
                                    }, this.timeout);
                                }
                                return [
                                    4,
                                    ((_a = this.fetchCb) !== null && _a !== void 0 ? _a : fetch)(url, init)
                                ];
                            case 1:
                                httpResponse = _state.sent();
                                clearTimeout(timeout);
                                // Handle response body
                                if (!(options === null || options === void 0 ? void 0 : options.ignoreBody) && httpResponse.body) // Wrap WhatWG readable stream into a Node.js readable stream
                                // If the body already is a Node.js stream (in the case of node-fetch), don't do explicit conversion.
                                responseStream = $fUgD9(httpResponse.body) ? httpResponse.body : (0, $2dfGl.readableFromWeb)(httpResponse.body);
                                if (!(!httpResponse.ok || !responseStream && !(options === null || options === void 0 ? void 0 : options.ignoreBody))) return [
                                    3,
                                    5
                                ];
                                simpleUrl = url.split('?').at(0);
                                if (!responseStream) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $dwDuJ(responseStream)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp = 'empty response';
                                _state.label = 4;
                            case 4:
                                bodyString = _tmp;
                                throw new Error("Invalid SPARQL endpoint response from ".concat(simpleUrl, " (HTTP status ").concat(httpResponse.status, "):\n").concat(bodyString));
                            case 5:
                                // Determine the content type
                                contentType = (_c = (_b = httpResponse.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.split(';').at(0)) !== null && _c !== void 0 ? _c : '';
                                return [
                                    2,
                                    [
                                        contentType,
                                        responseStream
                                    ]
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return SparqlEndpointFetcher;
}();
module.exports.SparqlEndpointFetcher = $014df93173677616$var$SparqlEndpointFetcher;
$014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON = 'application/sparql-results+json';
$014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML = 'application/sparql-results+xml';
$014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_TURTLE = 'text/turtle';
$014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL = "".concat($014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON, ";q=1.0,").concat($014df93173677616$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML, ";q=0.7");

});
parcelRegister("jcvYk", function(module, exports) {
"use strict";
var $dfa7f04d02936d0d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfa7f04d02936d0d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dfa7f04d02936d0d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dfa7f04d02936d0d$var$__exportStar((parcelRequire("46uiE")), module.exports);

});
parcelRegister("46uiE", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlXmlParser = void 0;

var $2ej16 = parcelRequire("2ej16");

var $6R7JQ = parcelRequire("6R7JQ");

var $fclRp = parcelRequire("fclRp");
/**
 * Parser for the SPARQL Query Results XML format.
 * @see https://www.w3.org/TR/rdf-sparql-XMLres/
 */ var $2fcf39e5fc5b8626$var$SparqlXmlParser = /*#__PURE__*/ function() {
    function SparqlXmlParser(settings) {
        (0, $jGAMp._)(this, SparqlXmlParser);
        settings = settings || {};
        this.dataFactory = settings.dataFactory || new $2ej16.DataFactory();
        this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
    }
    (0, $byiyg._)(SparqlXmlParser, [
        {
            /**
     * Convert a SPARQL XML bindings response stream to a stream of bindings objects.
     *
     * The bindings stream will emit a 'variables' event that will contain
     * the array of variables (as RDF.Variable[]), as defined in the response head.
     *
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */ key: "parseXmlResultsStream",
            value: function parseXmlResultsStream(sparqlResponseStream) {
                var _this = this;
                var errorListener = function(error) {
                    return resultStream.emit('error', error);
                };
                sparqlResponseStream.on('error', errorListener);
                var parser = new $6R7JQ.SaxesParser();
                var stack = [];
                var variablesFound = false;
                var resultsFound = false;
                var variables = [];
                var currentBindings = {};
                var currentBindingName = '';
                var currentBindingType = '';
                var currentBindingAnnotation;
                var currentText = '';
                var currentQuotedTriples = [];
                parser.on("error", errorListener);
                parser.on("opentag", function(tag) {
                    if (tag.name === "variable" && _this.stackEquals(stack, [
                        'sparql',
                        'head'
                    ])) variables.push(_this.dataFactory.variable(tag.attributes.name));
                    else if (tag.name === "results" && _this.stackEquals(stack, [
                        'sparql'
                    ])) resultsFound = true;
                    else if (tag.name === 'result' && _this.stackEquals(stack, [
                        'sparql',
                        'results'
                    ])) currentBindings = {};
                    else if (tag.name === 'binding' && _this.stackEquals(stack, [
                        'sparql',
                        'results',
                        'result'
                    ])) {
                        currentBindingName = tag.attributes.name || '';
                        currentBindingType = '';
                        currentBindingAnnotation = '';
                        currentText = '';
                        currentQuotedTriples = [];
                    } else if (tag.name === 'triple' && _this.stackBeginsWith(stack, [
                        'sparql',
                        'results',
                        'result'
                    ])) currentQuotedTriples.push({
                        components: {}
                    });
                    else if (stack[stack.length - 1] === 'triple' && _this.stackBeginsWith(stack, [
                        'sparql',
                        'results',
                        'result',
                        'binding'
                    ])) {
                        currentBindingType = '';
                        currentBindingAnnotation = '';
                        currentText = '';
                        if (![
                            'subject',
                            'predicate',
                            'object'
                        ].includes(tag.name)) errorListener(new Error("Illegal quoted triple component '".concat(tag.name, "' found on line ").concat(parser.line + 1)));
                        else currentQuotedTriples[currentQuotedTriples.length - 1].currentComponent = tag.name;
                    } else if (_this.stackBeginsWith(stack, [
                        'sparql',
                        'results',
                        'result',
                        'binding'
                    ])) {
                        currentBindingType = tag.name;
                        if ('xml:lang' in tag.attributes) currentBindingAnnotation = tag.attributes['xml:lang'];
                        else if ('datatype' in tag.attributes) currentBindingAnnotation = _this.dataFactory.namedNode(tag.attributes.datatype);
                        else currentBindingAnnotation = undefined;
                    }
                    stack.push(tag.name);
                });
                parser.on("closetag", function(tag) {
                    if (_this.stackEquals(stack, [
                        'sparql',
                        'head'
                    ])) {
                        resultStream.emit("variables", variables);
                        variablesFound = true;
                    }
                    if (_this.stackEquals(stack, [
                        'sparql',
                        'results',
                        'result'
                    ])) resultStream.push(currentBindings);
                    if (_this.stackBeginsWith(stack, [
                        'sparql',
                        'results',
                        'result',
                        'binding'
                    ])) {
                        // Determine current RDF term value
                        var term;
                        if (!currentBindingName && currentBindingType) errorListener(new Error("Terms should have a name on line ".concat(parser.line + 1)));
                        else if (currentBindingType === 'uri') term = _this.dataFactory.namedNode(currentText);
                        else if (currentBindingType === 'bnode') term = _this.dataFactory.blankNode(currentText);
                        else if (currentBindingType === 'literal') term = _this.dataFactory.literal(currentText, currentBindingAnnotation);
                        else if (stack[stack.length - 1] === 'triple') {
                            var currentQuotedTriple = currentQuotedTriples.pop();
                            if (currentQuotedTriple && currentQuotedTriple.components.subject && currentQuotedTriple.components.predicate && currentQuotedTriple.components.object) term = _this.dataFactory.quad(currentQuotedTriple.components.subject, currentQuotedTriple.components.predicate, currentQuotedTriple.components.object);
                            else errorListener(new Error("Incomplete quoted triple on line ".concat(parser.line + 1)));
                        } else if (currentBindingType) errorListener(new Error("Invalid term type '".concat(currentBindingType, "' on line ").concat(parser.line + 1)));
                        if (term) {
                            if (currentQuotedTriples.length > 0) {
                                // If we're in a quoted triple, store the term inside the active quoted triple
                                var currentQuotedTriple1 = currentQuotedTriples[currentQuotedTriples.length - 1];
                                if (currentQuotedTriple1.components[currentQuotedTriple1.currentComponent]) errorListener(new Error("The ".concat(currentQuotedTriple1.currentComponent, " in a quoted triple on line ").concat(parser.line + 1, " was already defined before")));
                                currentQuotedTriple1.components[currentQuotedTriple1.currentComponent] = term;
                            } else {
                                // Store the value in the current bindings object
                                var key = _this.prefixVariableQuestionMark ? '?' + currentBindingName : currentBindingName;
                                currentBindings[key] = term;
                            }
                        }
                        currentBindingType = undefined;
                    }
                    stack.pop();
                });
                parser.on("text", function(text) {
                    if (_this.stackBeginsWith(stack, [
                        'sparql',
                        'results',
                        'result',
                        'binding'
                    ]) && stack[stack.length - 1] === currentBindingType) currentText = text;
                });
                var resultStream = sparqlResponseStream.on("end", function(_) {
                    if (!resultsFound) resultStream.emit("error", new Error("No valid SPARQL query results were found."));
                    else if (!variablesFound) resultStream.emit('variables', []);
                }).pipe(new $fclRp.Transform({
                    objectMode: true,
                    transform: function(chunk, encoding, callback) {
                        parser.write(chunk);
                        callback();
                    }
                }));
                return resultStream;
            }
        },
        {
            /**
     * Convert a SPARQL XML boolean response stream to a promise resolving to a boolean.
     * This will reject if the given response was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
     * @return {Promise<boolean>} The response boolean.
     */ key: "parseXmlBooleanStream",
            value: function parseXmlBooleanStream(sparqlResponseStream) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    var parser = new $6R7JQ.SaxesParser();
                    var stack = [];
                    parser.on("error", reject);
                    parser.on("opentag", function(tag) {
                        stack.push(tag.name);
                    });
                    parser.on("closetag", function(_) {
                        stack.pop();
                    });
                    parser.on("text", function(text) {
                        if (_this.stackEquals(stack, [
                            'sparql',
                            'boolean'
                        ])) resolve(text === 'true');
                    });
                    sparqlResponseStream.on('error', reject).on('data', function(d) {
                        return parser.write(d);
                    }).on('end', function() {
                        return reject(new Error('No valid ASK response was found.'));
                    });
                });
            }
        },
        {
            key: "stackEquals",
            value: function stackEquals(a, b) {
                return a.length === b.length && a.every(function(v, i) {
                    return b[i] === v;
                });
            }
        },
        {
            key: "stackBeginsWith",
            value: function stackBeginsWith(a, b) {
                return a.length >= b.length && b.every(function(v, i) {
                    return a[i] === v;
                });
            }
        }
    ]);
    return SparqlXmlParser;
}();
module.exports.SparqlXmlParser = $2fcf39e5fc5b8626$var$SparqlXmlParser;

});
parcelRegister("fclRp", function(module, exports) {
'use strict';

var $lD8jD = parcelRequire("lD8jD");

var $4agPn = parcelRequire("4agPn");
var $b108ef031688dc14$var$originalDestroy = $lD8jD.Readable.destroy;
module.exports = $lD8jD.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $lD8jD._uint8ArrayToBuffer;
module.exports._isUint8Array = $lD8jD._isUint8Array;
module.exports.isDisturbed = $lD8jD.isDisturbed;
module.exports.isErrored = $lD8jD.isErrored;
module.exports.isReadable = $lD8jD.isReadable;
module.exports.Readable = $lD8jD.Readable;
module.exports.Writable = $lD8jD.Writable;
module.exports.Duplex = $lD8jD.Duplex;
module.exports.Transform = $lD8jD.Transform;
module.exports.PassThrough = $lD8jD.PassThrough;
module.exports.addAbortSignal = $lD8jD.addAbortSignal;
module.exports.finished = $lD8jD.finished;
module.exports.destroy = $lD8jD.destroy;
module.exports.destroy = $b108ef031688dc14$var$originalDestroy;
module.exports.pipeline = $lD8jD.pipeline;
module.exports.compose = $lD8jD.compose;
Object.defineProperty($lD8jD, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $4agPn;
    }
});
module.exports.Stream = $lD8jD.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("lD8jD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $e5850 = parcelRequire("e5850");
var $fbf3b0d3fa907f03$require$Buffer = $e5850.Buffer;

var $fN3IN = parcelRequire("fN3IN");
/* replacement end */ var $fbf3b0d3fa907f03$var$ObjectDefineProperty = $fN3IN.ObjectDefineProperty, $fbf3b0d3fa907f03$var$ObjectKeys = $fN3IN.ObjectKeys, $fbf3b0d3fa907f03$var$ReflectApply = $fN3IN.ReflectApply;

var $jWxAN = parcelRequire("jWxAN");
var $fbf3b0d3fa907f03$var$_require_promisify = $jWxAN.promisify, $fbf3b0d3fa907f03$var$customPromisify = $fbf3b0d3fa907f03$var$_require_promisify.custom;

var $lUNAK = parcelRequire("lUNAK");
var $fbf3b0d3fa907f03$var$streamReturningOperators = $lUNAK.streamReturningOperators, $fbf3b0d3fa907f03$var$promiseReturningOperators = $lUNAK.promiseReturningOperators;

var $8vCMS = parcelRequire("8vCMS");
var $fbf3b0d3fa907f03$var$ERR_ILLEGAL_CONSTRUCTOR = $8vCMS.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $a4wMu = parcelRequire("a4wMu");

var $9nn9z = parcelRequire("9nn9z");
var $fbf3b0d3fa907f03$var$setDefaultHighWaterMark = $9nn9z.setDefaultHighWaterMark, $fbf3b0d3fa907f03$var$getDefaultHighWaterMark = $9nn9z.getDefaultHighWaterMark;

var $iCAnx = parcelRequire("iCAnx");
var $fbf3b0d3fa907f03$require$pipeline = $iCAnx.pipeline;

var $6EWHH = parcelRequire("6EWHH");
var $fbf3b0d3fa907f03$require$destroyer = $6EWHH.destroyer;

var $9OOy8 = parcelRequire("9OOy8");
var $fbf3b0d3fa907f03$var$internalBuffer = {};

var $4agPn = parcelRequire("4agPn");

var $dx7Nw = parcelRequire("dx7Nw");

var $fbf3b0d3fa907f03$var$Stream = module.exports = (parcelRequire("6nELQ")).Stream;
$fbf3b0d3fa907f03$var$Stream.isDestroyed = $dx7Nw.isDestroyed;
$fbf3b0d3fa907f03$var$Stream.isDisturbed = $dx7Nw.isDisturbed;
$fbf3b0d3fa907f03$var$Stream.isErrored = $dx7Nw.isErrored;
$fbf3b0d3fa907f03$var$Stream.isReadable = $dx7Nw.isReadable;
$fbf3b0d3fa907f03$var$Stream.isWritable = $dx7Nw.isWritable;

$fbf3b0d3fa907f03$var$Stream.Readable = (parcelRequire("7GKfE"));
var $fbf3b0d3fa907f03$var$_iteratorNormalCompletion = true, $fbf3b0d3fa907f03$var$_didIteratorError = false, $fbf3b0d3fa907f03$var$_iteratorError = undefined;
try {
    for(var $fbf3b0d3fa907f03$var$_iterator = $fbf3b0d3fa907f03$var$ObjectKeys($fbf3b0d3fa907f03$var$streamReturningOperators)[Symbol.iterator](), $fbf3b0d3fa907f03$var$_step; !($fbf3b0d3fa907f03$var$_iteratorNormalCompletion = ($fbf3b0d3fa907f03$var$_step = $fbf3b0d3fa907f03$var$_iterator.next()).done); $fbf3b0d3fa907f03$var$_iteratorNormalCompletion = true){
        var $fbf3b0d3fa907f03$var$key = $fbf3b0d3fa907f03$var$_step.value;
        var $fbf3b0d3fa907f03$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $fbf3b0d3fa907f03$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $fbf3b0d3fa907f03$var$Stream.Readable.from($fbf3b0d3fa907f03$var$ReflectApply($fbf3b0d3fa907f03$var$op, this, args));
        };
        var $fbf3b0d3fa907f03$var$op = $fbf3b0d3fa907f03$var$streamReturningOperators[$fbf3b0d3fa907f03$var$key];
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$fn, 'name', {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$op.name
        });
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$fn, 'length', {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$op.length
        });
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$Stream.Readable.prototype, $fbf3b0d3fa907f03$var$key, {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $fbf3b0d3fa907f03$var$_didIteratorError = true;
    $fbf3b0d3fa907f03$var$_iteratorError = err;
} finally{
    try {
        if (!$fbf3b0d3fa907f03$var$_iteratorNormalCompletion && $fbf3b0d3fa907f03$var$_iterator["return"] != null) {
            $fbf3b0d3fa907f03$var$_iterator["return"]();
        }
    } finally{
        if ($fbf3b0d3fa907f03$var$_didIteratorError) {
            throw $fbf3b0d3fa907f03$var$_iteratorError;
        }
    }
}
var $fbf3b0d3fa907f03$var$_iteratorNormalCompletion1 = true, $fbf3b0d3fa907f03$var$_didIteratorError1 = false, $fbf3b0d3fa907f03$var$_iteratorError1 = undefined;
try {
    for(var $fbf3b0d3fa907f03$var$_iterator1 = $fbf3b0d3fa907f03$var$ObjectKeys($fbf3b0d3fa907f03$var$promiseReturningOperators)[Symbol.iterator](), $fbf3b0d3fa907f03$var$_step1; !($fbf3b0d3fa907f03$var$_iteratorNormalCompletion1 = ($fbf3b0d3fa907f03$var$_step1 = $fbf3b0d3fa907f03$var$_iterator1.next()).done); $fbf3b0d3fa907f03$var$_iteratorNormalCompletion1 = true){
        var $fbf3b0d3fa907f03$var$key1 = $fbf3b0d3fa907f03$var$_step1.value;
        var $fbf3b0d3fa907f03$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $fbf3b0d3fa907f03$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $fbf3b0d3fa907f03$var$ReflectApply($fbf3b0d3fa907f03$var$op1, this, args);
        };
        var $fbf3b0d3fa907f03$var$op1 = $fbf3b0d3fa907f03$var$promiseReturningOperators[$fbf3b0d3fa907f03$var$key1];
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$fn1, 'name', {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$op1.name
        });
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$fn1, 'length', {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$op1.length
        });
        $fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$Stream.Readable.prototype, $fbf3b0d3fa907f03$var$key1, {
            __proto__: null,
            value: $fbf3b0d3fa907f03$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $fbf3b0d3fa907f03$var$_didIteratorError1 = true;
    $fbf3b0d3fa907f03$var$_iteratorError1 = err;
} finally{
    try {
        if (!$fbf3b0d3fa907f03$var$_iteratorNormalCompletion1 && $fbf3b0d3fa907f03$var$_iterator1["return"] != null) {
            $fbf3b0d3fa907f03$var$_iterator1["return"]();
        }
    } finally{
        if ($fbf3b0d3fa907f03$var$_didIteratorError1) {
            throw $fbf3b0d3fa907f03$var$_iteratorError1;
        }
    }
}

$fbf3b0d3fa907f03$var$Stream.Writable = (parcelRequire("3Ho76"));

$fbf3b0d3fa907f03$var$Stream.Duplex = (parcelRequire("ekGFq"));

$fbf3b0d3fa907f03$var$Stream.Transform = (parcelRequire("bXhyq"));

$fbf3b0d3fa907f03$var$Stream.PassThrough = (parcelRequire("ks2yT"));
$fbf3b0d3fa907f03$var$Stream.pipeline = $fbf3b0d3fa907f03$require$pipeline;

var $a5OCj = parcelRequire("a5OCj");
var $fbf3b0d3fa907f03$require$addAbortSignal = $a5OCj.addAbortSignal;
$fbf3b0d3fa907f03$var$Stream.addAbortSignal = $fbf3b0d3fa907f03$require$addAbortSignal;
$fbf3b0d3fa907f03$var$Stream.finished = $9OOy8;
$fbf3b0d3fa907f03$var$Stream.destroy = $fbf3b0d3fa907f03$require$destroyer;
$fbf3b0d3fa907f03$var$Stream.compose = $a4wMu;
$fbf3b0d3fa907f03$var$Stream.setDefaultHighWaterMark = $fbf3b0d3fa907f03$var$setDefaultHighWaterMark;
$fbf3b0d3fa907f03$var$Stream.getDefaultHighWaterMark = $fbf3b0d3fa907f03$var$getDefaultHighWaterMark;
$fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $4agPn;
    }
});
$fbf3b0d3fa907f03$var$ObjectDefineProperty($fbf3b0d3fa907f03$require$pipeline, $fbf3b0d3fa907f03$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $4agPn.pipeline;
    }
});
$fbf3b0d3fa907f03$var$ObjectDefineProperty($9OOy8, $fbf3b0d3fa907f03$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $4agPn.finished;
    }
});
// Backwards-compat with node 0.4.x
$fbf3b0d3fa907f03$var$Stream.Stream = $fbf3b0d3fa907f03$var$Stream;
$fbf3b0d3fa907f03$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$fbf3b0d3fa907f03$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $fbf3b0d3fa907f03$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("e5850", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a407ccc8aa2b4ece$export$a143d493d941bafc; }, function (v) { return $a407ccc8aa2b4ece$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a407ccc8aa2b4ece$export$f99ded8fe4b79145; }, function (v) { return $a407ccc8aa2b4ece$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $a407ccc8aa2b4ece$export$a143d493d941bafc;
var $a407ccc8aa2b4ece$export$e4cf37d7f6fb9e0a;
var $a407ccc8aa2b4ece$export$f99ded8fe4b79145;
var $a407ccc8aa2b4ece$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $a407ccc8aa2b4ece$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a407ccc8aa2b4ece$export$a143d493d941bafc = $a407ccc8aa2b4ece$var$Buffer;
$a407ccc8aa2b4ece$export$e4cf37d7f6fb9e0a = $a407ccc8aa2b4ece$var$SlowBuffer;
$a407ccc8aa2b4ece$export$f99ded8fe4b79145 = 50;
var $a407ccc8aa2b4ece$var$K_MAX_LENGTH = 0x7fffffff;
$a407ccc8aa2b4ece$export$599f31c3813fae4d = $a407ccc8aa2b4ece$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a407ccc8aa2b4ece$var$Buffer.TYPED_ARRAY_SUPPORT = $a407ccc8aa2b4ece$var$typedArraySupport();
if (!$a407ccc8aa2b4ece$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a407ccc8aa2b4ece$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a407ccc8aa2b4ece$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a407ccc8aa2b4ece$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a407ccc8aa2b4ece$var$createBuffer(length) {
    if (length > $a407ccc8aa2b4ece$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a407ccc8aa2b4ece$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a407ccc8aa2b4ece$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a407ccc8aa2b4ece$var$allocUnsafe(arg);
    }
    return $a407ccc8aa2b4ece$var$from(arg, encodingOrOffset, length);
}
$a407ccc8aa2b4ece$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a407ccc8aa2b4ece$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a407ccc8aa2b4ece$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a407ccc8aa2b4ece$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($a407ccc8aa2b4ece$var$isInstance(value, ArrayBuffer) || value && $a407ccc8aa2b4ece$var$isInstance(value.buffer, ArrayBuffer)) return $a407ccc8aa2b4ece$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a407ccc8aa2b4ece$var$isInstance(value, SharedArrayBuffer) || value && $a407ccc8aa2b4ece$var$isInstance(value.buffer, SharedArrayBuffer))) return $a407ccc8aa2b4ece$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a407ccc8aa2b4ece$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a407ccc8aa2b4ece$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a407ccc8aa2b4ece$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a407ccc8aa2b4ece$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a407ccc8aa2b4ece$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a407ccc8aa2b4ece$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a407ccc8aa2b4ece$var$Buffer, Uint8Array);
function $a407ccc8aa2b4ece$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a407ccc8aa2b4ece$var$alloc(size, fill, encoding) {
    $a407ccc8aa2b4ece$var$assertSize(size);
    if (size <= 0) return $a407ccc8aa2b4ece$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a407ccc8aa2b4ece$var$createBuffer(size).fill(fill, encoding) : $a407ccc8aa2b4ece$var$createBuffer(size).fill(fill);
    return $a407ccc8aa2b4ece$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a407ccc8aa2b4ece$var$Buffer.alloc = function(size, fill, encoding) {
    return $a407ccc8aa2b4ece$var$alloc(size, fill, encoding);
};
function $a407ccc8aa2b4ece$var$allocUnsafe(size) {
    $a407ccc8aa2b4ece$var$assertSize(size);
    return $a407ccc8aa2b4ece$var$createBuffer(size < 0 ? 0 : $a407ccc8aa2b4ece$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a407ccc8aa2b4ece$var$Buffer.allocUnsafe = function(size) {
    return $a407ccc8aa2b4ece$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a407ccc8aa2b4ece$var$Buffer.allocUnsafeSlow = function(size) {
    return $a407ccc8aa2b4ece$var$allocUnsafe(size);
};
function $a407ccc8aa2b4ece$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a407ccc8aa2b4ece$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $a407ccc8aa2b4ece$var$byteLength(string, encoding) | 0;
    var buf = $a407ccc8aa2b4ece$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a407ccc8aa2b4ece$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a407ccc8aa2b4ece$var$checked(array.length) | 0;
    var buf = $a407ccc8aa2b4ece$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a407ccc8aa2b4ece$var$fromArrayView(arrayView) {
    if ($a407ccc8aa2b4ece$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a407ccc8aa2b4ece$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a407ccc8aa2b4ece$var$fromArrayLike(arrayView);
}
function $a407ccc8aa2b4ece$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a407ccc8aa2b4ece$var$Buffer.prototype);
    return buf;
}
function $a407ccc8aa2b4ece$var$fromObject(obj) {
    if ($a407ccc8aa2b4ece$var$Buffer.isBuffer(obj)) {
        var len = $a407ccc8aa2b4ece$var$checked(obj.length) | 0;
        var buf = $a407ccc8aa2b4ece$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a407ccc8aa2b4ece$var$numberIsNaN(obj.length)) return $a407ccc8aa2b4ece$var$createBuffer(0);
        return $a407ccc8aa2b4ece$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a407ccc8aa2b4ece$var$fromArrayLike(obj.data);
}
function $a407ccc8aa2b4ece$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a407ccc8aa2b4ece$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a407ccc8aa2b4ece$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a407ccc8aa2b4ece$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a407ccc8aa2b4ece$var$Buffer.alloc(+length);
}
$a407ccc8aa2b4ece$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a407ccc8aa2b4ece$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a407ccc8aa2b4ece$var$Buffer.compare = function compare(a, b) {
    if ($a407ccc8aa2b4ece$var$isInstance(a, Uint8Array)) a = $a407ccc8aa2b4ece$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a407ccc8aa2b4ece$var$isInstance(b, Uint8Array)) b = $a407ccc8aa2b4ece$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(a) || !$a407ccc8aa2b4ece$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a407ccc8aa2b4ece$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a407ccc8aa2b4ece$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a407ccc8aa2b4ece$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a407ccc8aa2b4ece$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a407ccc8aa2b4ece$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(buf)) buf = $a407ccc8aa2b4ece$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a407ccc8aa2b4ece$var$byteLength(string, encoding) {
    if ($a407ccc8aa2b4ece$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a407ccc8aa2b4ece$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a407ccc8aa2b4ece$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a407ccc8aa2b4ece$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a407ccc8aa2b4ece$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a407ccc8aa2b4ece$var$Buffer.byteLength = $a407ccc8aa2b4ece$var$byteLength;
function $a407ccc8aa2b4ece$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a407ccc8aa2b4ece$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a407ccc8aa2b4ece$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a407ccc8aa2b4ece$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a407ccc8aa2b4ece$var$latin1Slice(this, start, end);
        case 'base64':
            return $a407ccc8aa2b4ece$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a407ccc8aa2b4ece$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a407ccc8aa2b4ece$var$Buffer.prototype._isBuffer = true;
function $a407ccc8aa2b4ece$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$a407ccc8aa2b4ece$var$swap(this, i, i + 1);
    return this;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $a407ccc8aa2b4ece$var$swap(this, i, i + 3);
        $a407ccc8aa2b4ece$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $a407ccc8aa2b4ece$var$swap(this, i, i + 7);
        $a407ccc8aa2b4ece$var$swap(this, i + 1, i + 6);
        $a407ccc8aa2b4ece$var$swap(this, i + 2, i + 5);
        $a407ccc8aa2b4ece$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a407ccc8aa2b4ece$var$utf8Slice(this, 0, length);
    return $a407ccc8aa2b4ece$var$slowToString.apply(this, arguments);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.toLocaleString = $a407ccc8aa2b4ece$var$Buffer.prototype.toString;
$a407ccc8aa2b4ece$var$Buffer.prototype.equals = function equals(b) {
    if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a407ccc8aa2b4ece$var$Buffer.compare(this, b) === 0;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $a407ccc8aa2b4ece$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a407ccc8aa2b4ece$var$customInspectSymbol) $a407ccc8aa2b4ece$var$Buffer.prototype[$a407ccc8aa2b4ece$var$customInspectSymbol] = $a407ccc8aa2b4ece$var$Buffer.prototype.inspect;
$a407ccc8aa2b4ece$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a407ccc8aa2b4ece$var$isInstance(target, Uint8Array)) target = $a407ccc8aa2b4ece$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a407ccc8aa2b4ece$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a407ccc8aa2b4ece$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a407ccc8aa2b4ece$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a407ccc8aa2b4ece$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a407ccc8aa2b4ece$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a407ccc8aa2b4ece$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a407ccc8aa2b4ece$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a407ccc8aa2b4ece$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a407ccc8aa2b4ece$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a407ccc8aa2b4ece$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a407ccc8aa2b4ece$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a407ccc8aa2b4ece$var$utf8Write(buf, string, offset, length) {
    return $a407ccc8aa2b4ece$var$blitBuffer($a407ccc8aa2b4ece$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a407ccc8aa2b4ece$var$asciiWrite(buf, string, offset, length) {
    return $a407ccc8aa2b4ece$var$blitBuffer($a407ccc8aa2b4ece$var$asciiToBytes(string), buf, offset, length);
}
function $a407ccc8aa2b4ece$var$base64Write(buf, string, offset, length) {
    return $a407ccc8aa2b4ece$var$blitBuffer($a407ccc8aa2b4ece$var$base64ToBytes(string), buf, offset, length);
}
function $a407ccc8aa2b4ece$var$ucs2Write(buf, string, offset, length) {
    return $a407ccc8aa2b4ece$var$blitBuffer($a407ccc8aa2b4ece$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a407ccc8aa2b4ece$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a407ccc8aa2b4ece$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a407ccc8aa2b4ece$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a407ccc8aa2b4ece$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a407ccc8aa2b4ece$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a407ccc8aa2b4ece$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a407ccc8aa2b4ece$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a407ccc8aa2b4ece$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $a407ccc8aa2b4ece$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a407ccc8aa2b4ece$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a407ccc8aa2b4ece$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a407ccc8aa2b4ece$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a407ccc8aa2b4ece$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a407ccc8aa2b4ece$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a407ccc8aa2b4ece$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a407ccc8aa2b4ece$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a407ccc8aa2b4ece$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $a407ccc8aa2b4ece$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a407ccc8aa2b4ece$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a407ccc8aa2b4ece$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a407ccc8aa2b4ece$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a407ccc8aa2b4ece$var$Buffer.prototype.readUintLE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUintBE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUint8 = $a407ccc8aa2b4ece$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUint16LE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUint16BE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUint32LE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readUint32BE = $a407ccc8aa2b4ece$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readBigUInt64LE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a407ccc8aa2b4ece$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a407ccc8aa2b4ece$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a407ccc8aa2b4ece$var$Buffer.prototype.readBigUInt64BE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a407ccc8aa2b4ece$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a407ccc8aa2b4ece$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a407ccc8aa2b4ece$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readBigInt64LE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a407ccc8aa2b4ece$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a407ccc8aa2b4ece$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$a407ccc8aa2b4ece$var$Buffer.prototype.readBigInt64BE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a407ccc8aa2b4ece$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a407ccc8aa2b4ece$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$a407ccc8aa2b4ece$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $a407ccc8aa2b4ece$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUintLE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a407ccc8aa2b4ece$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUintBE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a407ccc8aa2b4ece$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUint8 = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUint16LE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUint16BE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUint32LE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeUint32BE = $a407ccc8aa2b4ece$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a407ccc8aa2b4ece$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a407ccc8aa2b4ece$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a407ccc8aa2b4ece$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a407ccc8aa2b4ece$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.writeBigUInt64LE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a407ccc8aa2b4ece$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a407ccc8aa2b4ece$var$Buffer.prototype.writeBigUInt64BE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a407ccc8aa2b4ece$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a407ccc8aa2b4ece$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a407ccc8aa2b4ece$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a407ccc8aa2b4ece$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeBigInt64LE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a407ccc8aa2b4ece$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a407ccc8aa2b4ece$var$Buffer.prototype.writeBigInt64BE = $a407ccc8aa2b4ece$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a407ccc8aa2b4ece$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a407ccc8aa2b4ece$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a407ccc8aa2b4ece$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a407ccc8aa2b4ece$var$writeFloat(this, value, offset, true, noAssert);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a407ccc8aa2b4ece$var$writeFloat(this, value, offset, false, noAssert);
};
function $a407ccc8aa2b4ece$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a407ccc8aa2b4ece$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a407ccc8aa2b4ece$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a407ccc8aa2b4ece$var$writeDouble(this, value, offset, true, noAssert);
};
$a407ccc8aa2b4ece$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a407ccc8aa2b4ece$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a407ccc8aa2b4ece$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a407ccc8aa2b4ece$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a407ccc8aa2b4ece$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a407ccc8aa2b4ece$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a407ccc8aa2b4ece$var$Buffer.isBuffer(val) ? val : $a407ccc8aa2b4ece$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $a407ccc8aa2b4ece$var$errors = {};
function $a407ccc8aa2b4ece$var$E(sym, getMessage, Base) {
    $a407ccc8aa2b4ece$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$a407ccc8aa2b4ece$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a407ccc8aa2b4ece$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$a407ccc8aa2b4ece$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $a407ccc8aa2b4ece$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $a407ccc8aa2b4ece$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $a407ccc8aa2b4ece$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $a407ccc8aa2b4ece$var$checkBounds(buf, offset, byteLength) {
    $a407ccc8aa2b4ece$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a407ccc8aa2b4ece$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a407ccc8aa2b4ece$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $a407ccc8aa2b4ece$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a407ccc8aa2b4ece$var$checkBounds(buf, offset, byteLength);
}
function $a407ccc8aa2b4ece$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a407ccc8aa2b4ece$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a407ccc8aa2b4ece$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a407ccc8aa2b4ece$var$validateNumber(value, type);
        throw new $a407ccc8aa2b4ece$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a407ccc8aa2b4ece$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a407ccc8aa2b4ece$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $a407ccc8aa2b4ece$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a407ccc8aa2b4ece$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a407ccc8aa2b4ece$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a407ccc8aa2b4ece$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a407ccc8aa2b4ece$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a407ccc8aa2b4ece$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a407ccc8aa2b4ece$var$base64ToBytes(str) {
    return $abUaD.toByteArray($a407ccc8aa2b4ece$var$base64clean(str));
}
function $a407ccc8aa2b4ece$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a407ccc8aa2b4ece$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a407ccc8aa2b4ece$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a407ccc8aa2b4ece$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a407ccc8aa2b4ece$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a407ccc8aa2b4ece$var$BufferBigIntNotDefined : fn;
}
function $a407ccc8aa2b4ece$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("fN3IN", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $b7ee51a080cb3a85$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $b7ee51a080cb3a85$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("jWxAN", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $e5850 = parcelRequire("e5850");

var $fvPTh = parcelRequire("fvPTh");
var $e84d7de0ea193233$var$format = $fvPTh.format, $e84d7de0ea193233$var$inspect = $fvPTh.inspect;

var $8vCMS = parcelRequire("8vCMS");
var $e84d7de0ea193233$var$ERR_INVALID_ARG_TYPE = $8vCMS.codes.ERR_INVALID_ARG_TYPE;

var $fN3IN = parcelRequire("fN3IN");
var $e84d7de0ea193233$var$kResistStopPropagation = $fN3IN.kResistStopPropagation, $e84d7de0ea193233$var$AggregateError = $fN3IN.AggregateError, $e84d7de0ea193233$var$SymbolDispose = $fN3IN.SymbolDispose;

var $e84d7de0ea193233$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $e84d7de0ea193233$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $e84d7de0ea193233$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $e84d7de0ea193233$var$Blob = globalThis.Blob || $e5850.Blob;
/* eslint-disable indent */ var $e84d7de0ea193233$var$isBlob = typeof $e84d7de0ea193233$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $e84d7de0ea193233$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $e84d7de0ea193233$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $e84d7de0ea193233$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $e84d7de0ea193233$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $e84d7de0ea193233$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $e84d7de0ea193233$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $e84d7de0ea193233$var$format,
    inspect: $e84d7de0ea193233$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $e84d7de0ea193233$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $e84d7de0ea193233$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $e84d7de0ea193233$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $e84d7de0ea193233$var$validateAbortSignal(signal, 'signal');
        $e84d7de0ea193233$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $e84d7de0ea193233$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $e84d7de0ea193233$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $e84d7de0ea193233$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $e84d7de0ea193233$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $e84d7de0ea193233$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("fvPTh", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("8vCMS", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $fvPTh = parcelRequire("fvPTh");
var $631f4e520891a8bf$var$format = $fvPTh.format, $631f4e520891a8bf$var$inspect = $fvPTh.inspect;

var $fN3IN = parcelRequire("fN3IN");
var $631f4e520891a8bf$var$CustomAggregateError = $fN3IN.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $631f4e520891a8bf$var$AggregateError = globalThis.AggregateError || $631f4e520891a8bf$var$CustomAggregateError;
var $631f4e520891a8bf$var$kIsNodeError = Symbol('kIsNodeError');
var $631f4e520891a8bf$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $631f4e520891a8bf$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $631f4e520891a8bf$var$nodeInternalPrefix = '__node_internal_';
var $631f4e520891a8bf$var$codes = {};
function $631f4e520891a8bf$var$assert(value, message) {
    if (!value) throw new $631f4e520891a8bf$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $631f4e520891a8bf$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $631f4e520891a8bf$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $631f4e520891a8bf$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $631f4e520891a8bf$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $631f4e520891a8bf$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $631f4e520891a8bf$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $631f4e520891a8bf$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$631f4e520891a8bf$var$kIsNodeError] = true;
    $631f4e520891a8bf$var$codes[code] = NodeError;
}
function $631f4e520891a8bf$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $631f4e520891a8bf$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $631f4e520891a8bf$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $631f4e520891a8bf$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $631f4e520891a8bf$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $631f4e520891a8bf$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$631f4e520891a8bf$var$E('ERR_ASSERTION', '%s', Error);
$631f4e520891a8bf$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $631f4e520891a8bf$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $631f4e520891a8bf$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($631f4e520891a8bf$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($631f4e520891a8bf$var$classRegExp.test(value)) instances.push(value);
            else {
                $631f4e520891a8bf$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $631f4e520891a8bf$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $631f4e520891a8bf$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$631f4e520891a8bf$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $631f4e520891a8bf$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$631f4e520891a8bf$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$631f4e520891a8bf$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $631f4e520891a8bf$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$631f4e520891a8bf$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $631f4e520891a8bf$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $631f4e520891a8bf$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $631f4e520891a8bf$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $631f4e520891a8bf$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$631f4e520891a8bf$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$631f4e520891a8bf$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$631f4e520891a8bf$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$631f4e520891a8bf$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$631f4e520891a8bf$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $631f4e520891a8bf$var$AbortError,
    aggregateTwoErrors: $631f4e520891a8bf$var$hideStackFrames($631f4e520891a8bf$var$aggregateTwoErrors),
    hideStackFrames: $631f4e520891a8bf$var$hideStackFrames,
    codes: $631f4e520891a8bf$var$codes
};

});


parcelRegister("lUNAK", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $ff454bcbb0aeda16$export$42af8c323be37587; }, function (v) { return $ff454bcbb0aeda16$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $ff454bcbb0aeda16$export$f405f72c701dad87; }, function (v) { return $ff454bcbb0aeda16$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $ff454bcbb0aeda16$export$42af8c323be37587;
var $ff454bcbb0aeda16$export$f405f72c701dad87;
'use strict';

var $ff454bcbb0aeda16$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $8vCMS = parcelRequire("8vCMS");
var $ff454bcbb0aeda16$var$_require_codes = $8vCMS.codes, $ff454bcbb0aeda16$var$ERR_INVALID_ARG_VALUE = $ff454bcbb0aeda16$var$_require_codes.ERR_INVALID_ARG_VALUE, $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE = $ff454bcbb0aeda16$var$_require_codes.ERR_INVALID_ARG_TYPE, $ff454bcbb0aeda16$var$ERR_MISSING_ARGS = $ff454bcbb0aeda16$var$_require_codes.ERR_MISSING_ARGS, $ff454bcbb0aeda16$var$ERR_OUT_OF_RANGE = $ff454bcbb0aeda16$var$_require_codes.ERR_OUT_OF_RANGE, $ff454bcbb0aeda16$var$AbortError = $8vCMS.AbortError;

var $5tEK7 = parcelRequire("5tEK7");
var $ff454bcbb0aeda16$var$validateAbortSignal = $5tEK7.validateAbortSignal, $ff454bcbb0aeda16$var$validateInteger = $5tEK7.validateInteger, $ff454bcbb0aeda16$var$validateObject = $5tEK7.validateObject;

var $ff454bcbb0aeda16$var$kWeakHandler = (parcelRequire("fN3IN")).Symbol('kWeak');

var $ff454bcbb0aeda16$var$kResistStopPropagation = (parcelRequire("fN3IN")).Symbol('kResistStopPropagation');

var $9OOy8 = parcelRequire("9OOy8");
var $ff454bcbb0aeda16$require$finished = $9OOy8.finished;

var $a4wMu = parcelRequire("a4wMu");

var $a5OCj = parcelRequire("a5OCj");
var $ff454bcbb0aeda16$require$addAbortSignalNoValidate = $a5OCj.addAbortSignalNoValidate;

var $dx7Nw = parcelRequire("dx7Nw");
var $ff454bcbb0aeda16$var$isWritable = $dx7Nw.isWritable, $ff454bcbb0aeda16$var$isNodeStream = $dx7Nw.isNodeStream;

var $ff454bcbb0aeda16$require$deprecate = (parcelRequire("jWxAN")).deprecate;

var $ff454bcbb0aeda16$var$ArrayPrototypePush = (parcelRequire("fN3IN")).ArrayPrototypePush, $ff454bcbb0aeda16$var$Boolean = (parcelRequire("fN3IN")).Boolean, $ff454bcbb0aeda16$var$MathFloor = (parcelRequire("fN3IN")).MathFloor, $ff454bcbb0aeda16$var$Number = (parcelRequire("fN3IN")).Number, $ff454bcbb0aeda16$var$NumberIsNaN = (parcelRequire("fN3IN")).NumberIsNaN, $ff454bcbb0aeda16$var$Promise = (parcelRequire("fN3IN")).Promise, $ff454bcbb0aeda16$var$PromiseReject = (parcelRequire("fN3IN")).PromiseReject, $ff454bcbb0aeda16$var$PromiseResolve = (parcelRequire("fN3IN")).PromiseResolve, $ff454bcbb0aeda16$var$PromisePrototypeThen = (parcelRequire("fN3IN")).PromisePrototypeThen, $ff454bcbb0aeda16$var$Symbol = (parcelRequire("fN3IN")).Symbol;
var $ff454bcbb0aeda16$var$kEmpty = $ff454bcbb0aeda16$var$Symbol('kEmpty');
var $ff454bcbb0aeda16$var$kEof = $ff454bcbb0aeda16$var$Symbol('kEof');
function $ff454bcbb0aeda16$var$compose(stream, options) {
    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
    if ($ff454bcbb0aeda16$var$isNodeStream(stream) && !$ff454bcbb0aeda16$var$isWritable(stream)) throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $a4wMu(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $ff454bcbb0aeda16$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $ff454bcbb0aeda16$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $ff454bcbb0aeda16$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $ff454bcbb0aeda16$var$MathFloor(options.highWaterMark);
    $ff454bcbb0aeda16$var$validateInteger(concurrency, 'options.concurrency', 1);
    $ff454bcbb0aeda16$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $ff454bcbb0aeda16$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $ff454bcbb0aeda16$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $ff454bcbb0aeda16$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $ff454bcbb0aeda16$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $ff454bcbb0aeda16$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($ff454bcbb0aeda16$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $ff454bcbb0aeda16$var$PromiseReject(err1);
                                $ff454bcbb0aeda16$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("jWxAN")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($ff454bcbb0aeda16$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $ff454bcbb0aeda16$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                        if (!(val !== $ff454bcbb0aeda16$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $ff454bcbb0aeda16$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ff454bcbb0aeda16$var$asIndexedPairs(options) {
    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $ff454bcbb0aeda16$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ff454bcbb0aeda16$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ff454bcbb0aeda16$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $ff454bcbb0aeda16$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $ff454bcbb0aeda16$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $ff454bcbb0aeda16$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ff454bcbb0aeda16$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $ff454bcbb0aeda16$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $ff454bcbb0aeda16$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ff454bcbb0aeda16$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $ff454bcbb0aeda16$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $ff454bcbb0aeda16$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $ff454bcbb0aeda16$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $ff454bcbb0aeda16$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($ff454bcbb0aeda16$var$ERR_MISSING_ARGS);
function $ff454bcbb0aeda16$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $ff454bcbb0aeda16$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $ff454bcbb0aeda16$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $ff454bcbb0aeda16$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $ff454bcbb0aeda16$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $ff454bcbb0aeda16$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $ff454bcbb0aeda16$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $ff454bcbb0aeda16$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ff454bcbb0aeda16$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $ff454bcbb0aeda16$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $ff454bcbb0aeda16$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $ff454bcbb0aeda16$var$flatMap(fn, options) {
    var values = $ff454bcbb0aeda16$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $ff454bcbb0aeda16$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $ff454bcbb0aeda16$var$Number(number);
    if ($ff454bcbb0aeda16$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $ff454bcbb0aeda16$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $ff454bcbb0aeda16$var$drop(number, options) {
    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ff454bcbb0aeda16$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ff454bcbb0aeda16$var$take(number, options) {
    if (options != null) $ff454bcbb0aeda16$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ff454bcbb0aeda16$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ff454bcbb0aeda16$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $ff454bcbb0aeda16$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$ff454bcbb0aeda16$export$42af8c323be37587 = {
    asIndexedPairs: $ff454bcbb0aeda16$require$deprecate($ff454bcbb0aeda16$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $ff454bcbb0aeda16$var$drop,
    filter: $ff454bcbb0aeda16$var$filter,
    flatMap: $ff454bcbb0aeda16$var$flatMap,
    map: $ff454bcbb0aeda16$var$map,
    take: $ff454bcbb0aeda16$var$take,
    compose: $ff454bcbb0aeda16$var$compose
};
$ff454bcbb0aeda16$export$f405f72c701dad87 = {
    every: $ff454bcbb0aeda16$var$every,
    forEach: $ff454bcbb0aeda16$var$forEach,
    reduce: $ff454bcbb0aeda16$var$reduce,
    toArray: $ff454bcbb0aeda16$var$toArray,
    some: $ff454bcbb0aeda16$var$some,
    find: $ff454bcbb0aeda16$var$find
};

});
parcelRegister("5tEK7", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $3fcf43d9540f93c6$var$ArrayIsArray = $fN3IN.ArrayIsArray, $3fcf43d9540f93c6$var$ArrayPrototypeIncludes = $fN3IN.ArrayPrototypeIncludes, $3fcf43d9540f93c6$var$ArrayPrototypeJoin = $fN3IN.ArrayPrototypeJoin, $3fcf43d9540f93c6$var$ArrayPrototypeMap = $fN3IN.ArrayPrototypeMap, $3fcf43d9540f93c6$var$NumberIsInteger = $fN3IN.NumberIsInteger, $3fcf43d9540f93c6$var$NumberIsNaN = $fN3IN.NumberIsNaN, $3fcf43d9540f93c6$var$NumberMAX_SAFE_INTEGER = $fN3IN.NumberMAX_SAFE_INTEGER, $3fcf43d9540f93c6$var$NumberMIN_SAFE_INTEGER = $fN3IN.NumberMIN_SAFE_INTEGER, $3fcf43d9540f93c6$var$NumberParseInt = $fN3IN.NumberParseInt, $3fcf43d9540f93c6$var$ObjectPrototypeHasOwnProperty = $fN3IN.ObjectPrototypeHasOwnProperty, $3fcf43d9540f93c6$var$RegExpPrototypeExec = $fN3IN.RegExpPrototypeExec, $3fcf43d9540f93c6$var$String = $fN3IN.String, $3fcf43d9540f93c6$var$StringPrototypeToUpperCase = $fN3IN.StringPrototypeToUpperCase, $3fcf43d9540f93c6$var$StringPrototypeTrim = $fN3IN.StringPrototypeTrim;

var $8vCMS = parcelRequire("8vCMS");
var $3fcf43d9540f93c6$var$hideStackFrames = $8vCMS.hideStackFrames, $3fcf43d9540f93c6$var$_require_codes = $8vCMS.codes, $3fcf43d9540f93c6$var$ERR_SOCKET_BAD_PORT = $3fcf43d9540f93c6$var$_require_codes.ERR_SOCKET_BAD_PORT, $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE = $3fcf43d9540f93c6$var$_require_codes.ERR_INVALID_ARG_TYPE, $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE = $3fcf43d9540f93c6$var$_require_codes.ERR_INVALID_ARG_VALUE, $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE = $3fcf43d9540f93c6$var$_require_codes.ERR_OUT_OF_RANGE, $3fcf43d9540f93c6$var$ERR_UNKNOWN_SIGNAL = $3fcf43d9540f93c6$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $jWxAN = parcelRequire("jWxAN");
var $3fcf43d9540f93c6$require$normalizeEncoding = $jWxAN.normalizeEncoding;

var $jWxAN = parcelRequire("jWxAN");
var $3fcf43d9540f93c6$require$_require_types = $jWxAN.types;
var $3fcf43d9540f93c6$var$isAsyncFunction = $3fcf43d9540f93c6$require$_require_types.isAsyncFunction, $3fcf43d9540f93c6$var$isArrayBufferView = $3fcf43d9540f93c6$require$_require_types.isArrayBufferView;
var $3fcf43d9540f93c6$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $3fcf43d9540f93c6$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $3fcf43d9540f93c6$var$isUint32(value) {
    return value === value >>> 0;
}
var $3fcf43d9540f93c6$var$octalReg = /^[0-7]+$/;
var $3fcf43d9540f93c6$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $3fcf43d9540f93c6$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($3fcf43d9540f93c6$var$RegExpPrototypeExec($3fcf43d9540f93c6$var$octalReg, value) === null) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE(name, value, $3fcf43d9540f93c6$var$modeDesc);
        value = $3fcf43d9540f93c6$var$NumberParseInt(value, 8);
    }
    $3fcf43d9540f93c6$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $3fcf43d9540f93c6$var$validateInteger = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $3fcf43d9540f93c6$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $3fcf43d9540f93c6$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$3fcf43d9540f93c6$var$NumberIsInteger(value)) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $3fcf43d9540f93c6$var$validateInt32 = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$3fcf43d9540f93c6$var$NumberIsInteger(value)) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $3fcf43d9540f93c6$var$validateUint32 = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$3fcf43d9540f93c6$var$NumberIsInteger(value)) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $3fcf43d9540f93c6$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $3fcf43d9540f93c6$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $3fcf43d9540f93c6$var$NumberIsNaN(value)) throw new $3fcf43d9540f93c6$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $3fcf43d9540f93c6$var$validateOneOf = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name, oneOf) {
    if (!$3fcf43d9540f93c6$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $3fcf43d9540f93c6$var$ArrayPrototypeJoin($3fcf43d9540f93c6$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $3fcf43d9540f93c6$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $3fcf43d9540f93c6$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $3fcf43d9540f93c6$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$3fcf43d9540f93c6$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $3fcf43d9540f93c6$var$validateObject = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $3fcf43d9540f93c6$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $3fcf43d9540f93c6$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $3fcf43d9540f93c6$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $3fcf43d9540f93c6$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $3fcf43d9540f93c6$var$validateDictionary = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $3fcf43d9540f93c6$var$validateArray = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$3fcf43d9540f93c6$var$ArrayIsArray(value)) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $3fcf43d9540f93c6$var$validateStringArray(value, name) {
    $3fcf43d9540f93c6$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$3fcf43d9540f93c6$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $3fcf43d9540f93c6$var$validateBooleanArray(value, name) {
    $3fcf43d9540f93c6$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$3fcf43d9540f93c6$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $3fcf43d9540f93c6$var$validateAbortSignalArray(value, name) {
    $3fcf43d9540f93c6$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $3fcf43d9540f93c6$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $3fcf43d9540f93c6$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $3fcf43d9540f93c6$var$validateString(signal, name);
    if ($3fcf43d9540f93c6$var$signals[signal] === undefined) {
        if ($3fcf43d9540f93c6$var$signals[$3fcf43d9540f93c6$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $3fcf43d9540f93c6$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $3fcf43d9540f93c6$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $3fcf43d9540f93c6$var$validateBuffer = $3fcf43d9540f93c6$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$3fcf43d9540f93c6$var$isArrayBufferView(buffer)) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $3fcf43d9540f93c6$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $3fcf43d9540f93c6$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $3fcf43d9540f93c6$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $3fcf43d9540f93c6$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $3fcf43d9540f93c6$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $3fcf43d9540f93c6$var$validateAbortSignal = $3fcf43d9540f93c6$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $3fcf43d9540f93c6$var$validateFunction = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $3fcf43d9540f93c6$var$validatePlainFunction = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $3fcf43d9540f93c6$var$isAsyncFunction(value)) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $3fcf43d9540f93c6$var$validateUndefined = $3fcf43d9540f93c6$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $3fcf43d9540f93c6$var$validateUnion(value, name, union) {
    if (!$3fcf43d9540f93c6$var$ArrayPrototypeIncludes(union, value)) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_TYPE(name, "('".concat($3fcf43d9540f93c6$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $3fcf43d9540f93c6$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $3fcf43d9540f93c6$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$3fcf43d9540f93c6$var$RegExpPrototypeExec($3fcf43d9540f93c6$var$linkValueRegExp, value)) throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $3fcf43d9540f93c6$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $3fcf43d9540f93c6$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($3fcf43d9540f93c6$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $3fcf43d9540f93c6$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $3fcf43d9540f93c6$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $3fcf43d9540f93c6$var$isInt32,
    isUint32: $3fcf43d9540f93c6$var$isUint32,
    parseFileMode: $3fcf43d9540f93c6$var$parseFileMode,
    validateArray: $3fcf43d9540f93c6$var$validateArray,
    validateStringArray: $3fcf43d9540f93c6$var$validateStringArray,
    validateBooleanArray: $3fcf43d9540f93c6$var$validateBooleanArray,
    validateAbortSignalArray: $3fcf43d9540f93c6$var$validateAbortSignalArray,
    validateBoolean: $3fcf43d9540f93c6$var$validateBoolean,
    validateBuffer: $3fcf43d9540f93c6$var$validateBuffer,
    validateDictionary: $3fcf43d9540f93c6$var$validateDictionary,
    validateEncoding: $3fcf43d9540f93c6$var$validateEncoding,
    validateFunction: $3fcf43d9540f93c6$var$validateFunction,
    validateInt32: $3fcf43d9540f93c6$var$validateInt32,
    validateInteger: $3fcf43d9540f93c6$var$validateInteger,
    validateNumber: $3fcf43d9540f93c6$var$validateNumber,
    validateObject: $3fcf43d9540f93c6$var$validateObject,
    validateOneOf: $3fcf43d9540f93c6$var$validateOneOf,
    validatePlainFunction: $3fcf43d9540f93c6$var$validatePlainFunction,
    validatePort: $3fcf43d9540f93c6$var$validatePort,
    validateSignalName: $3fcf43d9540f93c6$var$validateSignalName,
    validateString: $3fcf43d9540f93c6$var$validateString,
    validateUint32: $3fcf43d9540f93c6$var$validateUint32,
    validateUndefined: $3fcf43d9540f93c6$var$validateUndefined,
    validateUnion: $3fcf43d9540f93c6$var$validateUnion,
    validateAbortSignal: $3fcf43d9540f93c6$var$validateAbortSignal,
    validateLinkHeaderValue: $3fcf43d9540f93c6$var$validateLinkHeaderValue
};

});

parcelRegister("9OOy8", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8vCMS = parcelRequire("8vCMS");
/* replacement end */ var $725ffea2bf0e50b4$var$AbortError = $8vCMS.AbortError, $725ffea2bf0e50b4$var$codes = $8vCMS.codes;
var $725ffea2bf0e50b4$var$ERR_INVALID_ARG_TYPE = $725ffea2bf0e50b4$var$codes.ERR_INVALID_ARG_TYPE, $725ffea2bf0e50b4$var$ERR_STREAM_PREMATURE_CLOSE = $725ffea2bf0e50b4$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $725ffea2bf0e50b4$var$kEmptyObject = (parcelRequire("jWxAN")).kEmptyObject, $725ffea2bf0e50b4$var$once = (parcelRequire("jWxAN")).once;

var $5tEK7 = parcelRequire("5tEK7");
var $725ffea2bf0e50b4$var$validateAbortSignal = $5tEK7.validateAbortSignal, $725ffea2bf0e50b4$var$validateFunction = $5tEK7.validateFunction, $725ffea2bf0e50b4$var$validateObject = $5tEK7.validateObject, $725ffea2bf0e50b4$var$validateBoolean = $5tEK7.validateBoolean;

var $fN3IN = parcelRequire("fN3IN");
var $725ffea2bf0e50b4$var$Promise = $fN3IN.Promise, $725ffea2bf0e50b4$var$PromisePrototypeThen = $fN3IN.PromisePrototypeThen, $725ffea2bf0e50b4$var$SymbolDispose = $fN3IN.SymbolDispose;

var $dx7Nw = parcelRequire("dx7Nw");
var $725ffea2bf0e50b4$var$isClosed = $dx7Nw.isClosed, $725ffea2bf0e50b4$var$isReadable = $dx7Nw.isReadable, $725ffea2bf0e50b4$var$isReadableNodeStream = $dx7Nw.isReadableNodeStream, $725ffea2bf0e50b4$var$isReadableStream = $dx7Nw.isReadableStream, $725ffea2bf0e50b4$var$isReadableFinished = $dx7Nw.isReadableFinished, $725ffea2bf0e50b4$var$isReadableErrored = $dx7Nw.isReadableErrored, $725ffea2bf0e50b4$var$isWritable = $dx7Nw.isWritable, $725ffea2bf0e50b4$var$isWritableNodeStream = $dx7Nw.isWritableNodeStream, $725ffea2bf0e50b4$var$isWritableStream = $dx7Nw.isWritableStream, $725ffea2bf0e50b4$var$isWritableFinished = $dx7Nw.isWritableFinished, $725ffea2bf0e50b4$var$isWritableErrored = $dx7Nw.isWritableErrored, $725ffea2bf0e50b4$var$isNodeStream = $dx7Nw.isNodeStream, $725ffea2bf0e50b4$var$_willEmitClose = $dx7Nw.willEmitClose, $725ffea2bf0e50b4$var$kIsClosedPromise = $dx7Nw.kIsClosedPromise;
var $725ffea2bf0e50b4$var$addAbortListener;
function $725ffea2bf0e50b4$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $725ffea2bf0e50b4$var$nop = function() {};

function $725ffea2bf0e50b4$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $725ffea2bf0e50b4$var$kEmptyObject;
    } else if (options == null) options = $725ffea2bf0e50b4$var$kEmptyObject;
    else $725ffea2bf0e50b4$var$validateObject(options, 'options');
    $725ffea2bf0e50b4$var$validateFunction(callback, 'callback');
    $725ffea2bf0e50b4$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $725ffea2bf0e50b4$var$once(callback);
    if ($725ffea2bf0e50b4$var$isReadableStream(stream) || $725ffea2bf0e50b4$var$isWritableStream(stream)) return $725ffea2bf0e50b4$var$eosWeb(stream, options, callback);
    if (!$725ffea2bf0e50b4$var$isNodeStream(stream)) throw new $725ffea2bf0e50b4$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $725ffea2bf0e50b4$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $725ffea2bf0e50b4$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $725ffea2bf0e50b4$var$_willEmitClose(stream) && $725ffea2bf0e50b4$var$isReadableNodeStream(stream) === readable && $725ffea2bf0e50b4$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $725ffea2bf0e50b4$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $725ffea2bf0e50b4$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $725ffea2bf0e50b4$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $725ffea2bf0e50b4$var$isWritableErrored(stream) || $725ffea2bf0e50b4$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $725ffea2bf0e50b4$var$isReadableNodeStream(stream, true)) {
            if (!$725ffea2bf0e50b4$var$isReadableFinished(stream, false)) return callback.call(stream, new $725ffea2bf0e50b4$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$725ffea2bf0e50b4$var$isWritableFinished(stream, false)) return callback.call(stream, new $725ffea2bf0e50b4$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $725ffea2bf0e50b4$var$isWritableErrored(stream) || $725ffea2bf0e50b4$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($725ffea2bf0e50b4$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $725ffea2bf0e50b4$var$isReadable(stream)) && (writableFinished || $725ffea2bf0e50b4$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $725ffea2bf0e50b4$var$isWritable(stream)) && (readableFinished || $725ffea2bf0e50b4$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $725ffea2bf0e50b4$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $725ffea2bf0e50b4$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $725ffea2bf0e50b4$var$addAbortListener = $725ffea2bf0e50b4$var$addAbortListener || (parcelRequire("jWxAN")).addAbortListener;
            var disposable = $725ffea2bf0e50b4$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $725ffea2bf0e50b4$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$725ffea2bf0e50b4$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $725ffea2bf0e50b4$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $725ffea2bf0e50b4$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $725ffea2bf0e50b4$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $725ffea2bf0e50b4$var$addAbortListener = $725ffea2bf0e50b4$var$addAbortListener || (parcelRequire("jWxAN")).addAbortListener;
            var disposable = $725ffea2bf0e50b4$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $725ffea2bf0e50b4$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$725ffea2bf0e50b4$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $725ffea2bf0e50b4$var$PromisePrototypeThen(stream[$725ffea2bf0e50b4$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $725ffea2bf0e50b4$var$nop;
}
function $725ffea2bf0e50b4$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $725ffea2bf0e50b4$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $725ffea2bf0e50b4$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $725ffea2bf0e50b4$var$Promise(function(resolve, reject) {
        var cleanup = $725ffea2bf0e50b4$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $725ffea2bf0e50b4$var$eos;
module.exports.finished = $725ffea2bf0e50b4$var$finished;

});
parcelRegister("dx7Nw", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $9da467e9fa905463$var$SymbolAsyncIterator = $fN3IN.SymbolAsyncIterator, $9da467e9fa905463$var$SymbolIterator = $fN3IN.SymbolIterator, $9da467e9fa905463$var$SymbolFor = $fN3IN.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $9da467e9fa905463$var$kIsDestroyed = $9da467e9fa905463$var$SymbolFor('nodejs.stream.destroyed');
var $9da467e9fa905463$var$kIsErrored = $9da467e9fa905463$var$SymbolFor('nodejs.stream.errored');
var $9da467e9fa905463$var$kIsReadable = $9da467e9fa905463$var$SymbolFor('nodejs.stream.readable');
var $9da467e9fa905463$var$kIsWritable = $9da467e9fa905463$var$SymbolFor('nodejs.stream.writable');
var $9da467e9fa905463$var$kIsDisturbed = $9da467e9fa905463$var$SymbolFor('nodejs.stream.disturbed');
var $9da467e9fa905463$var$kIsClosedPromise = $9da467e9fa905463$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $9da467e9fa905463$var$kControllerErrorFunction = $9da467e9fa905463$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $9da467e9fa905463$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9da467e9fa905463$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9da467e9fa905463$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $9da467e9fa905463$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $9da467e9fa905463$var$isReadableStream(obj) {
    return !!(obj && !$9da467e9fa905463$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $9da467e9fa905463$var$isWritableStream(obj) {
    return !!(obj && !$9da467e9fa905463$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $9da467e9fa905463$var$isTransformStream(obj) {
    return !!(obj && !$9da467e9fa905463$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $9da467e9fa905463$var$isWebStream(obj) {
    return $9da467e9fa905463$var$isReadableStream(obj) || $9da467e9fa905463$var$isWritableStream(obj) || $9da467e9fa905463$var$isTransformStream(obj);
}
function $9da467e9fa905463$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9da467e9fa905463$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$9da467e9fa905463$var$SymbolIterator] === 'function';
    return typeof obj[$9da467e9fa905463$var$SymbolAsyncIterator] === 'function' || typeof obj[$9da467e9fa905463$var$SymbolIterator] === 'function';
}
function $9da467e9fa905463$var$isDestroyed(stream) {
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$9da467e9fa905463$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9da467e9fa905463$var$isWritableEnded(stream) {
    if (!$9da467e9fa905463$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9da467e9fa905463$var$isWritableFinished(stream, strict) {
    if (!$9da467e9fa905463$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9da467e9fa905463$var$isReadableEnded(stream) {
    if (!$9da467e9fa905463$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9da467e9fa905463$var$isReadableFinished(stream, strict) {
    if (!$9da467e9fa905463$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9da467e9fa905463$var$isReadable(stream) {
    if (stream && stream[$9da467e9fa905463$var$kIsReadable] != null) return stream[$9da467e9fa905463$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($9da467e9fa905463$var$isDestroyed(stream)) return false;
    return $9da467e9fa905463$var$isReadableNodeStream(stream) && stream.readable && !$9da467e9fa905463$var$isReadableFinished(stream);
}
function $9da467e9fa905463$var$isWritable(stream) {
    if (stream && stream[$9da467e9fa905463$var$kIsWritable] != null) return stream[$9da467e9fa905463$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($9da467e9fa905463$var$isDestroyed(stream)) return false;
    return $9da467e9fa905463$var$isWritableNodeStream(stream) && stream.writable && !$9da467e9fa905463$var$isWritableEnded(stream);
}
function $9da467e9fa905463$var$isFinished(stream, opts) {
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    if ($9da467e9fa905463$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9da467e9fa905463$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9da467e9fa905463$var$isWritable(stream)) return false;
    return true;
}
function $9da467e9fa905463$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9da467e9fa905463$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9da467e9fa905463$var$isClosed(stream) {
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $9da467e9fa905463$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9da467e9fa905463$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $9da467e9fa905463$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $9da467e9fa905463$var$isOutgoingMessage(stream);
}
function $9da467e9fa905463$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9da467e9fa905463$var$willEmitClose(stream) {
    if (!$9da467e9fa905463$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $9da467e9fa905463$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9da467e9fa905463$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9da467e9fa905463$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9da467e9fa905463$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9da467e9fa905463$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9da467e9fa905463$var$isDestroyed,
    kIsDestroyed: $9da467e9fa905463$var$kIsDestroyed,
    isDisturbed: $9da467e9fa905463$var$isDisturbed,
    kIsDisturbed: $9da467e9fa905463$var$kIsDisturbed,
    isErrored: $9da467e9fa905463$var$isErrored,
    kIsErrored: $9da467e9fa905463$var$kIsErrored,
    isReadable: $9da467e9fa905463$var$isReadable,
    kIsReadable: $9da467e9fa905463$var$kIsReadable,
    kIsClosedPromise: $9da467e9fa905463$var$kIsClosedPromise,
    kControllerErrorFunction: $9da467e9fa905463$var$kControllerErrorFunction,
    kIsWritable: $9da467e9fa905463$var$kIsWritable,
    isClosed: $9da467e9fa905463$var$isClosed,
    isDuplexNodeStream: $9da467e9fa905463$var$isDuplexNodeStream,
    isFinished: $9da467e9fa905463$var$isFinished,
    isIterable: $9da467e9fa905463$var$isIterable,
    isReadableNodeStream: $9da467e9fa905463$var$isReadableNodeStream,
    isReadableStream: $9da467e9fa905463$var$isReadableStream,
    isReadableEnded: $9da467e9fa905463$var$isReadableEnded,
    isReadableFinished: $9da467e9fa905463$var$isReadableFinished,
    isReadableErrored: $9da467e9fa905463$var$isReadableErrored,
    isNodeStream: $9da467e9fa905463$var$isNodeStream,
    isWebStream: $9da467e9fa905463$var$isWebStream,
    isWritable: $9da467e9fa905463$var$isWritable,
    isWritableNodeStream: $9da467e9fa905463$var$isWritableNodeStream,
    isWritableStream: $9da467e9fa905463$var$isWritableStream,
    isWritableEnded: $9da467e9fa905463$var$isWritableEnded,
    isWritableFinished: $9da467e9fa905463$var$isWritableFinished,
    isWritableErrored: $9da467e9fa905463$var$isWritableErrored,
    isServerRequest: $9da467e9fa905463$var$isServerRequest,
    isServerResponse: $9da467e9fa905463$var$isServerResponse,
    willEmitClose: $9da467e9fa905463$var$willEmitClose,
    isTransformStream: $9da467e9fa905463$var$isTransformStream
};

});


parcelRegister("a4wMu", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $iCAnx = parcelRequire("iCAnx");
var $7553b4c0a8d9b455$require$pipeline = $iCAnx.pipeline;

var $ekGFq = parcelRequire("ekGFq");

var $6EWHH = parcelRequire("6EWHH");
var $7553b4c0a8d9b455$require$destroyer = $6EWHH.destroyer;

var $dx7Nw = parcelRequire("dx7Nw");
var $7553b4c0a8d9b455$var$isNodeStream = $dx7Nw.isNodeStream, $7553b4c0a8d9b455$var$isReadable = $dx7Nw.isReadable, $7553b4c0a8d9b455$var$isWritable = $dx7Nw.isWritable, $7553b4c0a8d9b455$var$isWebStream = $dx7Nw.isWebStream, $7553b4c0a8d9b455$var$isTransformStream = $dx7Nw.isTransformStream, $7553b4c0a8d9b455$var$isWritableStream = $dx7Nw.isWritableStream, $7553b4c0a8d9b455$var$isReadableStream = $dx7Nw.isReadableStream;

var $8vCMS = parcelRequire("8vCMS");
var $7553b4c0a8d9b455$var$AbortError = $8vCMS.AbortError, $7553b4c0a8d9b455$var$_require_codes = $8vCMS.codes, $7553b4c0a8d9b455$var$ERR_INVALID_ARG_VALUE = $7553b4c0a8d9b455$var$_require_codes.ERR_INVALID_ARG_VALUE, $7553b4c0a8d9b455$var$ERR_MISSING_ARGS = $7553b4c0a8d9b455$var$_require_codes.ERR_MISSING_ARGS;

var $9OOy8 = parcelRequire("9OOy8");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $7553b4c0a8d9b455$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $ekGFq.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $ekGFq.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $ekGFq.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$7553b4c0a8d9b455$var$isNodeStream(streams[n]) && !$7553b4c0a8d9b455$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($7553b4c0a8d9b455$var$isReadable(streams[n]) || $7553b4c0a8d9b455$var$isReadableStream(streams[n]) || $7553b4c0a8d9b455$var$isTransformStream(streams[n]))) throw new $7553b4c0a8d9b455$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($7553b4c0a8d9b455$var$isWritable(streams[n]) || $7553b4c0a8d9b455$var$isWritableStream(streams[n]) || $7553b4c0a8d9b455$var$isTransformStream(streams[n]))) throw new $7553b4c0a8d9b455$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $7553b4c0a8d9b455$require$pipeline(streams, onfinished);
    var writable = !!($7553b4c0a8d9b455$var$isWritable(head) || $7553b4c0a8d9b455$var$isWritableStream(head) || $7553b4c0a8d9b455$var$isTransformStream(head));
    var readable = !!($7553b4c0a8d9b455$var$isReadable(tail) || $7553b4c0a8d9b455$var$isReadableStream(tail) || $7553b4c0a8d9b455$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ekGFq({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($7553b4c0a8d9b455$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($7553b4c0a8d9b455$var$isWebStream(head)) {
            var writable1 = $7553b4c0a8d9b455$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $7553b4c0a8d9b455$var$isTransformStream(tail) ? tail.readable : tail;
        $9OOy8(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($7553b4c0a8d9b455$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($7553b4c0a8d9b455$var$isWebStream(tail)) {
            var readable1 = $7553b4c0a8d9b455$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $7553b4c0a8d9b455$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($7553b4c0a8d9b455$var$isNodeStream(tail)) $7553b4c0a8d9b455$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("iCAnx", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $d8e7fea9c0933bb2$var$ArrayIsArray = $fN3IN.ArrayIsArray, $d8e7fea9c0933bb2$var$Promise = $fN3IN.Promise, $d8e7fea9c0933bb2$var$SymbolAsyncIterator = $fN3IN.SymbolAsyncIterator, $d8e7fea9c0933bb2$var$SymbolDispose = $fN3IN.SymbolDispose;

var $9OOy8 = parcelRequire("9OOy8");

var $d8e7fea9c0933bb2$require$once = (parcelRequire("jWxAN")).once;

var $6EWHH = parcelRequire("6EWHH");

var $ekGFq = parcelRequire("ekGFq");

var $8vCMS = parcelRequire("8vCMS");
var $d8e7fea9c0933bb2$var$aggregateTwoErrors = $8vCMS.aggregateTwoErrors, $d8e7fea9c0933bb2$var$_require_codes = $8vCMS.codes, $d8e7fea9c0933bb2$var$ERR_INVALID_ARG_TYPE = $d8e7fea9c0933bb2$var$_require_codes.ERR_INVALID_ARG_TYPE, $d8e7fea9c0933bb2$var$ERR_INVALID_RETURN_VALUE = $d8e7fea9c0933bb2$var$_require_codes.ERR_INVALID_RETURN_VALUE, $d8e7fea9c0933bb2$var$ERR_MISSING_ARGS = $d8e7fea9c0933bb2$var$_require_codes.ERR_MISSING_ARGS, $d8e7fea9c0933bb2$var$ERR_STREAM_DESTROYED = $d8e7fea9c0933bb2$var$_require_codes.ERR_STREAM_DESTROYED, $d8e7fea9c0933bb2$var$ERR_STREAM_PREMATURE_CLOSE = $d8e7fea9c0933bb2$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $d8e7fea9c0933bb2$var$AbortError = $8vCMS.AbortError;

var $5tEK7 = parcelRequire("5tEK7");
var $d8e7fea9c0933bb2$var$validateFunction = $5tEK7.validateFunction, $d8e7fea9c0933bb2$var$validateAbortSignal = $5tEK7.validateAbortSignal;

var $dx7Nw = parcelRequire("dx7Nw");
var $d8e7fea9c0933bb2$var$isIterable = $dx7Nw.isIterable, $d8e7fea9c0933bb2$var$isReadable = $dx7Nw.isReadable, $d8e7fea9c0933bb2$var$isReadableNodeStream = $dx7Nw.isReadableNodeStream, $d8e7fea9c0933bb2$var$isNodeStream = $dx7Nw.isNodeStream, $d8e7fea9c0933bb2$var$isTransformStream = $dx7Nw.isTransformStream, $d8e7fea9c0933bb2$var$isWebStream = $dx7Nw.isWebStream, $d8e7fea9c0933bb2$var$isReadableStream = $dx7Nw.isReadableStream, $d8e7fea9c0933bb2$var$isReadableFinished = $dx7Nw.isReadableFinished;

var $d8e7fea9c0933bb2$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $d8e7fea9c0933bb2$var$PassThrough;
var $d8e7fea9c0933bb2$var$Readable;
var $d8e7fea9c0933bb2$var$addAbortListener;
function $d8e7fea9c0933bb2$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $9OOy8(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $6EWHH.destroyer(stream, err || new $d8e7fea9c0933bb2$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $d8e7fea9c0933bb2$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $d8e7fea9c0933bb2$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $d8e7fea9c0933bb2$var$makeAsyncIterable(val) {
    if ($d8e7fea9c0933bb2$var$isIterable(val)) return val;
    else if ($d8e7fea9c0933bb2$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $d8e7fea9c0933bb2$var$fromReadable(val);
    throw new $d8e7fea9c0933bb2$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $d8e7fea9c0933bb2$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$d8e7fea9c0933bb2$var$Readable) $d8e7fea9c0933bb2$var$Readable = (parcelRequire("7GKfE"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($d8e7fea9c0933bb2$var$Readable.prototype[$d8e7fea9c0933bb2$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $d8e7fea9c0933bb2$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $d8e7fea9c0933bb2$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $9OOy8(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $d8e7fea9c0933bb2$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $d8e7fea9c0933bb2$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($d8e7fea9c0933bb2$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $d8e7fea9c0933bb2$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $d8e7fea9c0933bb2$var$pipelineImpl(streams, $d8e7fea9c0933bb2$require$once($d8e7fea9c0933bb2$var$popCallback(streams)));
}


function $d8e7fea9c0933bb2$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($d8e7fea9c0933bb2$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $d8e7fea9c0933bb2$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($d8e7fea9c0933bb2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($d8e7fea9c0933bb2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$d8e7fea9c0933bb2$var$isIterable(ret)) throw new $d8e7fea9c0933bb2$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($d8e7fea9c0933bb2$var$isIterable(stream) || $d8e7fea9c0933bb2$var$isReadableNodeStream(stream) || $d8e7fea9c0933bb2$var$isTransformStream(stream)) ret = stream;
            else ret = $ekGFq.from(stream);
        } else if (typeof stream === 'function') {
            if ($d8e7fea9c0933bb2$var$isTransformStream(ret)) {
                var _ret;
                ret = $d8e7fea9c0933bb2$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $d8e7fea9c0933bb2$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$d8e7fea9c0933bb2$var$isIterable(ret, true)) throw new $d8e7fea9c0933bb2$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$d8e7fea9c0933bb2$var$PassThrough) $d8e7fea9c0933bb2$var$PassThrough = (parcelRequire("ks2yT"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $d8e7fea9c0933bb2$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($d8e7fea9c0933bb2$var$isIterable(ret, true)) {
                    finishCount++;
                    $d8e7fea9c0933bb2$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($d8e7fea9c0933bb2$var$isReadableStream(ret) || $d8e7fea9c0933bb2$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $d8e7fea9c0933bb2$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $d8e7fea9c0933bb2$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $d8e7fea9c0933bb2$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($d8e7fea9c0933bb2$var$isNodeStream(stream)) {
            if ($d8e7fea9c0933bb2$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $d8e7fea9c0933bb2$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($d8e7fea9c0933bb2$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($d8e7fea9c0933bb2$var$isTransformStream(ret) || $d8e7fea9c0933bb2$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $d8e7fea9c0933bb2$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($d8e7fea9c0933bb2$var$isIterable(ret)) {
                finishCount++;
                $d8e7fea9c0933bb2$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $d8e7fea9c0933bb2$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($d8e7fea9c0933bb2$var$isWebStream(stream)) {
            if ($d8e7fea9c0933bb2$var$isReadableNodeStream(ret)) {
                finishCount++;
                $d8e7fea9c0933bb2$var$pumpToWeb($d8e7fea9c0933bb2$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($d8e7fea9c0933bb2$var$isReadableStream(ret) || $d8e7fea9c0933bb2$var$isIterable(ret)) {
                finishCount++;
                $d8e7fea9c0933bb2$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($d8e7fea9c0933bb2$var$isTransformStream(ret)) {
                finishCount++;
                $d8e7fea9c0933bb2$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $d8e7fea9c0933bb2$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $ekGFq.from(stream);
    };
    if (streams.length === 1 && $d8e7fea9c0933bb2$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $d8e7fea9c0933bb2$var$ERR_MISSING_ARGS('streams');
    var ac = new $d8e7fea9c0933bb2$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $d8e7fea9c0933bb2$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $d8e7fea9c0933bb2$var$AbortError());
    }
    $d8e7fea9c0933bb2$var$addAbortListener = $d8e7fea9c0933bb2$var$addAbortListener || (parcelRequire("jWxAN")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $d8e7fea9c0933bb2$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$d8e7fea9c0933bb2$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $d8e7fea9c0933bb2$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $d8e7fea9c0933bb2$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($d8e7fea9c0933bb2$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $9OOy8(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $9OOy8(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $d8e7fea9c0933bb2$var$pipelineImpl,
    pipeline: $d8e7fea9c0933bb2$var$pipeline
};

});
parcelRegister("6EWHH", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8vCMS = parcelRequire("8vCMS");
/* replacement end */ var $4d9403dc7ca509b4$var$aggregateTwoErrors = $8vCMS.aggregateTwoErrors, $4d9403dc7ca509b4$var$ERR_MULTIPLE_CALLBACK = $8vCMS.codes.ERR_MULTIPLE_CALLBACK, $4d9403dc7ca509b4$var$AbortError = $8vCMS.AbortError;

var $fN3IN = parcelRequire("fN3IN");
var $4d9403dc7ca509b4$require$Symbol = $fN3IN.Symbol;

var $dx7Nw = parcelRequire("dx7Nw");
var $4d9403dc7ca509b4$var$kIsDestroyed = $dx7Nw.kIsDestroyed, $4d9403dc7ca509b4$var$isDestroyed = $dx7Nw.isDestroyed, $4d9403dc7ca509b4$var$isFinished = $dx7Nw.isFinished, $4d9403dc7ca509b4$var$isServerRequest = $dx7Nw.isServerRequest;
var $4d9403dc7ca509b4$var$kDestroy = $4d9403dc7ca509b4$require$Symbol('kDestroy');
var $4d9403dc7ca509b4$var$kConstruct = $4d9403dc7ca509b4$require$Symbol('kConstruct');
function $4d9403dc7ca509b4$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $4d9403dc7ca509b4$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $4d9403dc7ca509b4$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($4d9403dc7ca509b4$var$kDestroy, function(er) {
        $4d9403dc7ca509b4$var$_destroy(this, $4d9403dc7ca509b4$var$aggregateTwoErrors(er, err), cb);
    });
    else $4d9403dc7ca509b4$var$_destroy(this, err, cb);
    return this;
}
function $4d9403dc7ca509b4$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $4d9403dc7ca509b4$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $4d9403dc7ca509b4$var$emitErrorCloseNT(self, err) {
    $4d9403dc7ca509b4$var$emitErrorNT(self, err);
    $4d9403dc7ca509b4$var$emitCloseNT(self);
}
function $4d9403dc7ca509b4$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $4d9403dc7ca509b4$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $4d9403dc7ca509b4$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $4d9403dc7ca509b4$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitErrorNT, stream, err);
        else $4d9403dc7ca509b4$var$emitErrorNT(stream, err);
    }
}
function $4d9403dc7ca509b4$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($4d9403dc7ca509b4$var$kConstruct, cb);
    if (stream.listenerCount($4d9403dc7ca509b4$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($4d9403dc7ca509b4$var$constructNT, stream);
}
function $4d9403dc7ca509b4$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $4d9403dc7ca509b4$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $4d9403dc7ca509b4$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($4d9403dc7ca509b4$var$kDestroy, err);
        else if (err) $4d9403dc7ca509b4$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $4d9403dc7ca509b4$var$emitConstructNT(stream) {
    stream.emit($4d9403dc7ca509b4$var$kConstruct);
}
function $4d9403dc7ca509b4$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $4d9403dc7ca509b4$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $4d9403dc7ca509b4$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $4d9403dc7ca509b4$var$destroyer(stream, err) {
    if (!stream || $4d9403dc7ca509b4$var$isDestroyed(stream)) return;
    if (!err && !$4d9403dc7ca509b4$var$isFinished(stream)) err = new $4d9403dc7ca509b4$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($4d9403dc7ca509b4$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($4d9403dc7ca509b4$var$isRequest(stream)) stream.abort();
    else if ($4d9403dc7ca509b4$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($4d9403dc7ca509b4$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$4d9403dc7ca509b4$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $4d9403dc7ca509b4$var$construct,
    destroyer: $4d9403dc7ca509b4$var$destroyer,
    destroy: $4d9403dc7ca509b4$var$destroy,
    undestroy: $4d9403dc7ca509b4$var$undestroy,
    errorOrDestroy: $4d9403dc7ca509b4$var$errorOrDestroy
};

});

parcelRegister("ekGFq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $a6f407c1eaeb1155$var$ObjectDefineProperties = $fN3IN.ObjectDefineProperties, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor = $fN3IN.ObjectGetOwnPropertyDescriptor, $a6f407c1eaeb1155$var$ObjectKeys = $fN3IN.ObjectKeys, $a6f407c1eaeb1155$var$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf;
module.exports = $a6f407c1eaeb1155$var$Duplex;

var $7GKfE = parcelRequire("7GKfE");

var $3Ho76 = parcelRequire("3Ho76");
$a6f407c1eaeb1155$var$ObjectSetPrototypeOf($a6f407c1eaeb1155$var$Duplex.prototype, $7GKfE.prototype);
$a6f407c1eaeb1155$var$ObjectSetPrototypeOf($a6f407c1eaeb1155$var$Duplex, $7GKfE);
{
    var $a6f407c1eaeb1155$var$keys = $a6f407c1eaeb1155$var$ObjectKeys($3Ho76.prototype);
    // Allow the keys array to be GC'ed.
    for(var $a6f407c1eaeb1155$var$i = 0; $a6f407c1eaeb1155$var$i < $a6f407c1eaeb1155$var$keys.length; $a6f407c1eaeb1155$var$i++){
        var $a6f407c1eaeb1155$var$method = $a6f407c1eaeb1155$var$keys[$a6f407c1eaeb1155$var$i];
        if (!$a6f407c1eaeb1155$var$Duplex.prototype[$a6f407c1eaeb1155$var$method]) $a6f407c1eaeb1155$var$Duplex.prototype[$a6f407c1eaeb1155$var$method] = $3Ho76.prototype[$a6f407c1eaeb1155$var$method];
    }
}function $a6f407c1eaeb1155$var$Duplex(options) {
    if (!(this instanceof $a6f407c1eaeb1155$var$Duplex)) return new $a6f407c1eaeb1155$var$Duplex(options);
    $7GKfE.call(this, options);
    $3Ho76.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$a6f407c1eaeb1155$var$ObjectDefineProperties($a6f407c1eaeb1155$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $a6f407c1eaeb1155$var$ObjectGetOwnPropertyDescriptor($3Ho76.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $a6f407c1eaeb1155$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a6f407c1eaeb1155$var$lazyWebStreams() {
    if ($a6f407c1eaeb1155$var$webStreamsAdapters === undefined) $a6f407c1eaeb1155$var$webStreamsAdapters = {};
    return $a6f407c1eaeb1155$var$webStreamsAdapters;
}
$a6f407c1eaeb1155$var$Duplex.fromWeb = function(pair, options) {
    return $a6f407c1eaeb1155$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$a6f407c1eaeb1155$var$Duplex.toWeb = function(duplex) {
    return $a6f407c1eaeb1155$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $a6f407c1eaeb1155$var$duplexify;

$a6f407c1eaeb1155$var$Duplex.from = function(body) {
    if (!$a6f407c1eaeb1155$var$duplexify) $a6f407c1eaeb1155$var$duplexify = (parcelRequire("hzEEW"));
    return $a6f407c1eaeb1155$var$duplexify(body, 'body');
};

});
parcelRegister("7GKfE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fN3IN = parcelRequire("fN3IN");
/* replacement end */ var $59905534e47345de$var$ArrayPrototypeIndexOf = $fN3IN.ArrayPrototypeIndexOf, $59905534e47345de$var$NumberIsInteger = $fN3IN.NumberIsInteger, $59905534e47345de$var$NumberIsNaN = $fN3IN.NumberIsNaN, $59905534e47345de$var$NumberParseInt = $fN3IN.NumberParseInt, $59905534e47345de$var$ObjectDefineProperties = $fN3IN.ObjectDefineProperties, $59905534e47345de$var$ObjectKeys = $fN3IN.ObjectKeys, $59905534e47345de$var$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf, $59905534e47345de$var$Promise = $fN3IN.Promise, $59905534e47345de$var$SafeSet = $fN3IN.SafeSet, $59905534e47345de$var$SymbolAsyncDispose = $fN3IN.SymbolAsyncDispose, $59905534e47345de$var$SymbolAsyncIterator = $fN3IN.SymbolAsyncIterator, $59905534e47345de$var$Symbol = $fN3IN.Symbol;
module.exports = $59905534e47345de$var$Readable;
$59905534e47345de$var$Readable.ReadableState = $59905534e47345de$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $59905534e47345de$var$EE = $bBoAO.EventEmitter;

var $6nELQ = parcelRequire("6nELQ");
var $59905534e47345de$var$Stream = $6nELQ.Stream, $59905534e47345de$var$prependListener = $6nELQ.prependListener;

var $e5850 = parcelRequire("e5850");
var $59905534e47345de$require$Buffer = $e5850.Buffer;

var $a5OCj = parcelRequire("a5OCj");
var $59905534e47345de$require$addAbortSignal = $a5OCj.addAbortSignal;

var $9OOy8 = parcelRequire("9OOy8");

var $59905534e47345de$var$debug = (parcelRequire("jWxAN")).debuglog('stream', function(fn) {
    $59905534e47345de$var$debug = fn;
});

var $68jkU = parcelRequire("68jkU");

var $6EWHH = parcelRequire("6EWHH");

var $9nn9z = parcelRequire("9nn9z");
var $59905534e47345de$var$getHighWaterMark = $9nn9z.getHighWaterMark, $59905534e47345de$var$getDefaultHighWaterMark = $9nn9z.getDefaultHighWaterMark;

var $8vCMS = parcelRequire("8vCMS");
var $59905534e47345de$var$aggregateTwoErrors = $8vCMS.aggregateTwoErrors, $59905534e47345de$var$_require_codes = $8vCMS.codes, $59905534e47345de$var$ERR_INVALID_ARG_TYPE = $59905534e47345de$var$_require_codes.ERR_INVALID_ARG_TYPE, $59905534e47345de$var$ERR_METHOD_NOT_IMPLEMENTED = $59905534e47345de$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $59905534e47345de$var$ERR_OUT_OF_RANGE = $59905534e47345de$var$_require_codes.ERR_OUT_OF_RANGE, $59905534e47345de$var$ERR_STREAM_PUSH_AFTER_EOF = $59905534e47345de$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $59905534e47345de$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $59905534e47345de$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $59905534e47345de$var$AbortError = $8vCMS.AbortError;

var $5tEK7 = parcelRequire("5tEK7");
var $59905534e47345de$require$validateObject = $5tEK7.validateObject;
var $59905534e47345de$var$kPaused = $59905534e47345de$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $59905534e47345de$require$StringDecoder = $3Jf7C.StringDecoder;

var $byQZU = parcelRequire("byQZU");
$59905534e47345de$var$ObjectSetPrototypeOf($59905534e47345de$var$Readable.prototype, $59905534e47345de$var$Stream.prototype);
$59905534e47345de$var$ObjectSetPrototypeOf($59905534e47345de$var$Readable, $59905534e47345de$var$Stream);
var $59905534e47345de$var$nop = function() {};
var $59905534e47345de$var$errorOrDestroy = $6EWHH.errorOrDestroy;
var $59905534e47345de$var$kObjectMode = 1;
var $59905534e47345de$var$kEnded = 2;
var $59905534e47345de$var$kEndEmitted = 4;
var $59905534e47345de$var$kReading = 8;
var $59905534e47345de$var$kConstructed = 16;
var $59905534e47345de$var$kSync = 32;
var $59905534e47345de$var$kNeedReadable = 64;
var $59905534e47345de$var$kEmittedReadable = 128;
var $59905534e47345de$var$kReadableListening = 256;
var $59905534e47345de$var$kResumeScheduled = 512;
var $59905534e47345de$var$kErrorEmitted = 1024;
var $59905534e47345de$var$kEmitClose = 2048;
var $59905534e47345de$var$kAutoDestroy = 4096;
var $59905534e47345de$var$kDestroyed = 8192;
var $59905534e47345de$var$kClosed = 16384;
var $59905534e47345de$var$kCloseEmitted = 32768;
var $59905534e47345de$var$kMultiAwaitDrain = 65536;
var $59905534e47345de$var$kReadingMore = 131072;
var $59905534e47345de$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $59905534e47345de$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$59905534e47345de$var$ObjectDefineProperties($59905534e47345de$var$ReadableState.prototype, {
    objectMode: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kObjectMode),
    ended: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kEnded),
    endEmitted: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kEndEmitted),
    reading: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kNeedReadable),
    emittedReadable: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kEmittedReadable),
    readableListening: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kReadableListening),
    resumeScheduled: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kErrorEmitted),
    emitClose: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kEmitClose),
    autoDestroy: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kCloseEmitted),
    multiAwaitDrain: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kReadingMore),
    dataEmitted: $59905534e47345de$var$makeBitMapDescriptor($59905534e47345de$var$kDataEmitted)
});

function $59905534e47345de$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("ekGFq"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $59905534e47345de$var$kEmitClose | $59905534e47345de$var$kAutoDestroy | $59905534e47345de$var$kConstructed | $59905534e47345de$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $59905534e47345de$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $59905534e47345de$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $59905534e47345de$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $59905534e47345de$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $68jkU();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$59905534e47345de$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$59905534e47345de$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$59905534e47345de$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $59905534e47345de$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $59905534e47345de$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $59905534e47345de$var$Readable)) return new $59905534e47345de$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("ekGFq"));
    this._readableState = new $59905534e47345de$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $59905534e47345de$require$addAbortSignal(options.signal, this);
    }
    $59905534e47345de$var$Stream.call(this, options);
    $6EWHH.construct(this, function() {
        if (_this._readableState.needReadable) $59905534e47345de$var$maybeReadMore(_this, _this._readableState);
    });
}
$59905534e47345de$var$Readable.prototype.destroy = $6EWHH.destroy;
$59905534e47345de$var$Readable.prototype._undestroy = $6EWHH.undestroy;
$59905534e47345de$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$59905534e47345de$var$Readable.prototype[$59905534e47345de$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$59905534e47345de$var$Readable.prototype[$59905534e47345de$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $59905534e47345de$var$AbortError();
        this.destroy(error);
    }
    return new $59905534e47345de$var$Promise(function(resolve, reject) {
        return $9OOy8(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$59905534e47345de$var$Readable.prototype.push = function(chunk, encoding) {
    return $59905534e47345de$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$59905534e47345de$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $59905534e47345de$var$readableAddChunk(this, chunk, encoding, true);
};
function $59905534e47345de$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $59905534e47345de$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $59905534e47345de$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $59905534e47345de$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $59905534e47345de$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $59905534e47345de$require$Buffer) encoding = '';
        else if ($59905534e47345de$var$Stream._isUint8Array(chunk)) {
            chunk = $59905534e47345de$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $59905534e47345de$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $59905534e47345de$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$59905534e47345de$var$kReading;
        $59905534e47345de$var$onEofChunk(stream, state);
    } else if ((state.state & $59905534e47345de$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $59905534e47345de$var$kEndEmitted) !== 0) $59905534e47345de$var$errorOrDestroy(stream, new $59905534e47345de$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $59905534e47345de$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $59905534e47345de$var$errorOrDestroy(stream, new $59905534e47345de$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$59905534e47345de$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $59905534e47345de$var$addChunk(stream, state, chunk, false);
                else $59905534e47345de$var$maybeReadMore(stream, state);
            } else $59905534e47345de$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$59905534e47345de$var$kReading;
        $59905534e47345de$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $59905534e47345de$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $59905534e47345de$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $59905534e47345de$var$kNeedReadable) !== 0) $59905534e47345de$var$emitReadable(stream);
    }
    $59905534e47345de$var$maybeReadMore(stream, state);
}
$59905534e47345de$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$59905534e47345de$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$59905534e47345de$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $59905534e47345de$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$59905534e47345de$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $59905534e47345de$var$MAX_HWM = 0x40000000;
function $59905534e47345de$var$computeNewHighWaterMark(n) {
    if (n > $59905534e47345de$var$MAX_HWM) throw new $59905534e47345de$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $59905534e47345de$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $59905534e47345de$var$kObjectMode) !== 0) return 1;
    if ($59905534e47345de$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$59905534e47345de$var$Readable.prototype.read = function(n) {
    $59905534e47345de$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$59905534e47345de$var$NumberIsInteger(n)) n = $59905534e47345de$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $59905534e47345de$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$59905534e47345de$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $59905534e47345de$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $59905534e47345de$var$endReadable(this);
        else $59905534e47345de$var$emitReadable(this);
        return null;
    }
    n = $59905534e47345de$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $59905534e47345de$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $59905534e47345de$var$kNeedReadable) !== 0;
    $59905534e47345de$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $59905534e47345de$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $59905534e47345de$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $59905534e47345de$var$debug('do read');
        state.state |= $59905534e47345de$var$kReading | $59905534e47345de$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $59905534e47345de$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $59905534e47345de$var$errorOrDestroy(this, err);
        }
        state.state &= ~$59905534e47345de$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $59905534e47345de$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $59905534e47345de$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $59905534e47345de$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $59905534e47345de$var$onEofChunk(stream, state) {
    $59905534e47345de$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $59905534e47345de$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $59905534e47345de$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $59905534e47345de$var$emitReadable(stream) {
    var state = stream._readableState;
    $59905534e47345de$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $59905534e47345de$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($59905534e47345de$var$emitReadable_, stream);
    }
}
function $59905534e47345de$var$emitReadable_(stream) {
    var state = stream._readableState;
    $59905534e47345de$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $59905534e47345de$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $59905534e47345de$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($59905534e47345de$var$maybeReadMore_, stream, state);
    }
}
function $59905534e47345de$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $59905534e47345de$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$59905534e47345de$var$Readable.prototype._read = function(n) {
    throw new $59905534e47345de$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$59905534e47345de$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $59905534e47345de$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $59905534e47345de$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $59905534e47345de$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $59905534e47345de$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $59905534e47345de$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $59905534e47345de$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $59905534e47345de$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $59905534e47345de$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $59905534e47345de$var$debug('ondata');
        var ret = dest.write(chunk);
        $59905534e47345de$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $59905534e47345de$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $59905534e47345de$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $59905534e47345de$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $59905534e47345de$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $59905534e47345de$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $59905534e47345de$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $59905534e47345de$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $59905534e47345de$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $59905534e47345de$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$59905534e47345de$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $59905534e47345de$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$59905534e47345de$var$Readable.prototype.on = function(ev, fn) {
    var res = $59905534e47345de$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $59905534e47345de$var$debug('on readable', state.length, state.reading);
            if (state.length) $59905534e47345de$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($59905534e47345de$var$nReadingNextTick, this);
        }
    }
    return res;
};
$59905534e47345de$var$Readable.prototype.addListener = $59905534e47345de$var$Readable.prototype.on;
$59905534e47345de$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $59905534e47345de$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($59905534e47345de$var$updateReadableListening, this);
    return res;
};
$59905534e47345de$var$Readable.prototype.off = $59905534e47345de$var$Readable.prototype.removeListener;
$59905534e47345de$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $59905534e47345de$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($59905534e47345de$var$updateReadableListening, this);
    return res;
};
function $59905534e47345de$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$59905534e47345de$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $59905534e47345de$var$nReadingNextTick(self) {
    $59905534e47345de$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$59905534e47345de$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $59905534e47345de$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $59905534e47345de$var$resume(this, state);
    }
    state[$59905534e47345de$var$kPaused] = false;
    return this;
};
function $59905534e47345de$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($59905534e47345de$var$resume_, stream, state);
    }
}
function $59905534e47345de$var$resume_(stream, state) {
    $59905534e47345de$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $59905534e47345de$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$59905534e47345de$var$Readable.prototype.pause = function() {
    $59905534e47345de$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $59905534e47345de$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$59905534e47345de$var$kPaused] = true;
    return this;
};
function $59905534e47345de$var$flow(stream) {
    var state = stream._readableState;
    $59905534e47345de$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$59905534e47345de$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $59905534e47345de$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $59905534e47345de$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$59905534e47345de$var$Readable.prototype[$59905534e47345de$var$SymbolAsyncIterator] = function() {
    return $59905534e47345de$var$streamToAsyncIterator(this);
};
$59905534e47345de$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $59905534e47345de$require$validateObject(options, 'options');
    return $59905534e47345de$var$streamToAsyncIterator(this, options);
};
function $59905534e47345de$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $59905534e47345de$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $59905534e47345de$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $59905534e47345de$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $59905534e47345de$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $59905534e47345de$var$nop;
                    stream.on('readable', next);
                    cleanup = $9OOy8(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $59905534e47345de$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $59905534e47345de$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $59905534e47345de$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $59905534e47345de$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $6EWHH.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$59905534e47345de$var$ObjectDefineProperties($59905534e47345de$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$59905534e47345de$var$ObjectDefineProperties($59905534e47345de$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$59905534e47345de$var$kPaused] !== false;
        },
        set: function(value) {
            this[$59905534e47345de$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$59905534e47345de$var$Readable._fromList = $59905534e47345de$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $59905534e47345de$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $59905534e47345de$var$endReadable(stream) {
    var state = stream._readableState;
    $59905534e47345de$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($59905534e47345de$var$endReadableNT, state, stream);
    }
}
function $59905534e47345de$var$endReadableNT(state, stream) {
    $59905534e47345de$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($59905534e47345de$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $59905534e47345de$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$59905534e47345de$var$Readable.from = function(iterable, opts) {
    return $byQZU($59905534e47345de$var$Readable, iterable, opts);
};
var $59905534e47345de$var$webStreamsAdapters;
// Lazy to avoid circular references
function $59905534e47345de$var$lazyWebStreams() {
    if ($59905534e47345de$var$webStreamsAdapters === undefined) $59905534e47345de$var$webStreamsAdapters = {};
    return $59905534e47345de$var$webStreamsAdapters;
}
$59905534e47345de$var$Readable.fromWeb = function(readableStream, options) {
    return $59905534e47345de$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$59905534e47345de$var$Readable.toWeb = function(streamReadable, options) {
    return $59905534e47345de$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$59905534e47345de$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $59905534e47345de$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $6EWHH.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("6nELQ", function(module, exports) {
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $4a548447166de459$var$ArrayIsArray = $fN3IN.ArrayIsArray, $4a548447166de459$var$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $4a548447166de459$var$EE = $bBoAO.EventEmitter;
function $4a548447166de459$var$Stream(opts) {
    $4a548447166de459$var$EE.call(this, opts);
}
$4a548447166de459$var$ObjectSetPrototypeOf($4a548447166de459$var$Stream.prototype, $4a548447166de459$var$EE.prototype);
$4a548447166de459$var$ObjectSetPrototypeOf($4a548447166de459$var$Stream, $4a548447166de459$var$EE);
$4a548447166de459$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($4a548447166de459$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $4a548447166de459$var$prependListener(source, 'error', onerror);
    $4a548447166de459$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $4a548447166de459$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($4a548447166de459$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $4a548447166de459$var$Stream,
    prependListener: $4a548447166de459$var$prependListener
};

});

parcelRegister("a5OCj", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $7591a27e004d769f$export$e2db56ee53255a0; }, function (v) { return $7591a27e004d769f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $7591a27e004d769f$export$11956e9313f43de0; }, function (v) { return $7591a27e004d769f$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $7591a27e004d769f$export$e2db56ee53255a0;
var $7591a27e004d769f$export$11956e9313f43de0;
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $7591a27e004d769f$require$SymbolDispose = $fN3IN.SymbolDispose;

var $8vCMS = parcelRequire("8vCMS");
var $7591a27e004d769f$var$AbortError = $8vCMS.AbortError, $7591a27e004d769f$var$codes = $8vCMS.codes;

var $dx7Nw = parcelRequire("dx7Nw");
var $7591a27e004d769f$var$isNodeStream = $dx7Nw.isNodeStream, $7591a27e004d769f$var$isWebStream = $dx7Nw.isWebStream, $7591a27e004d769f$var$kControllerErrorFunction = $dx7Nw.kControllerErrorFunction;

var $9OOy8 = parcelRequire("9OOy8");
var $7591a27e004d769f$var$ERR_INVALID_ARG_TYPE = $7591a27e004d769f$var$codes.ERR_INVALID_ARG_TYPE;
var $7591a27e004d769f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $7591a27e004d769f$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $7591a27e004d769f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$7591a27e004d769f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $7591a27e004d769f$var$validateAbortSignal(signal, 'signal');
    if (!$7591a27e004d769f$var$isNodeStream(stream) && !$7591a27e004d769f$var$isWebStream(stream)) throw new $7591a27e004d769f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $7591a27e004d769f$export$11956e9313f43de0(signal, stream);
};

$7591a27e004d769f$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $7591a27e004d769f$var$isNodeStream(stream) ? function() {
        stream.destroy(new $7591a27e004d769f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$7591a27e004d769f$var$kControllerErrorFunction](new $7591a27e004d769f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $7591a27e004d769f$var$addAbortListener = $7591a27e004d769f$var$addAbortListener || (parcelRequire("jWxAN")).addAbortListener;
        var disposable = $7591a27e004d769f$var$addAbortListener(signal, onAbort);
        $9OOy8(stream, disposable[$7591a27e004d769f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("68jkU", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $47727d321b27a845$var$StringPrototypeSlice = $fN3IN.StringPrototypeSlice, $47727d321b27a845$var$SymbolIterator = $fN3IN.SymbolIterator, $47727d321b27a845$var$TypedArrayPrototypeSet = $fN3IN.TypedArrayPrototypeSet, $47727d321b27a845$var$Uint8Array = $fN3IN.Uint8Array;

var $e5850 = parcelRequire("e5850");
var $47727d321b27a845$require$Buffer = $e5850.Buffer;

var $jWxAN = parcelRequire("jWxAN");
var $47727d321b27a845$require$inspect = $jWxAN.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47727d321b27a845$require$Buffer.alloc(0);
                var ret = $47727d321b27a845$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47727d321b27a845$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $47727d321b27a845$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $47727d321b27a845$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $47727d321b27a845$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47727d321b27a845$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $47727d321b27a845$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $47727d321b27a845$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $47727d321b27a845$var$TypedArrayPrototypeSet(ret, new $47727d321b27a845$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $47727d321b27a845$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("9nn9z", function(module, exports) {
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $6d3838cd768c63ea$var$MathFloor = $fN3IN.MathFloor, $6d3838cd768c63ea$var$NumberIsInteger = $fN3IN.NumberIsInteger;

var $5tEK7 = parcelRequire("5tEK7");
var $6d3838cd768c63ea$require$validateInteger = $5tEK7.validateInteger;

var $6d3838cd768c63ea$var$ERR_INVALID_ARG_VALUE = (parcelRequire("8vCMS")).codes.ERR_INVALID_ARG_VALUE;
var $6d3838cd768c63ea$var$defaultHighWaterMarkBytes = 16384;
var $6d3838cd768c63ea$var$defaultHighWaterMarkObjectMode = 16;
function $6d3838cd768c63ea$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $6d3838cd768c63ea$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $6d3838cd768c63ea$var$defaultHighWaterMarkObjectMode : $6d3838cd768c63ea$var$defaultHighWaterMarkBytes;
}
function $6d3838cd768c63ea$var$setDefaultHighWaterMark(objectMode, value) {
    $6d3838cd768c63ea$require$validateInteger(value, 'value', 0);
    if (objectMode) $6d3838cd768c63ea$var$defaultHighWaterMarkObjectMode = value;
    else $6d3838cd768c63ea$var$defaultHighWaterMarkBytes = value;
}
function $6d3838cd768c63ea$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $6d3838cd768c63ea$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$6d3838cd768c63ea$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $6d3838cd768c63ea$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $6d3838cd768c63ea$var$MathFloor(hwm);
    }
    // Default value
    return $6d3838cd768c63ea$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $6d3838cd768c63ea$var$getHighWaterMark,
    getDefaultHighWaterMark: $6d3838cd768c63ea$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $6d3838cd768c63ea$var$setDefaultHighWaterMark
};

});

parcelRegister("byQZU", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fN3IN = parcelRequire("fN3IN");
/* replacement end */ var $022c106efa41af04$var$PromisePrototypeThen = $fN3IN.PromisePrototypeThen, $022c106efa41af04$var$SymbolAsyncIterator = $fN3IN.SymbolAsyncIterator, $022c106efa41af04$var$SymbolIterator = $fN3IN.SymbolIterator;

var $e5850 = parcelRequire("e5850");
var $022c106efa41af04$require$Buffer = $e5850.Buffer;

var $8vCMS = parcelRequire("8vCMS");
var $022c106efa41af04$require$_require_codes = $8vCMS.codes;
var $022c106efa41af04$var$ERR_INVALID_ARG_TYPE = $022c106efa41af04$require$_require_codes.ERR_INVALID_ARG_TYPE, $022c106efa41af04$var$ERR_STREAM_NULL_VALUES = $022c106efa41af04$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $022c106efa41af04$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $022c106efa41af04$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$022c106efa41af04$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$022c106efa41af04$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$022c106efa41af04$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$022c106efa41af04$var$SymbolIterator]();
    } else throw new $022c106efa41af04$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $022c106efa41af04$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $022c106efa41af04$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $022c106efa41af04$var$from;

});


parcelRegister("3Ho76", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $fN3IN = parcelRequire("fN3IN");
/* replacement end */ var $2b1817ae6c52f478$var$ArrayPrototypeSlice = $fN3IN.ArrayPrototypeSlice, $2b1817ae6c52f478$var$Error = $fN3IN.Error, $2b1817ae6c52f478$var$FunctionPrototypeSymbolHasInstance = $fN3IN.FunctionPrototypeSymbolHasInstance, $2b1817ae6c52f478$var$ObjectDefineProperty = $fN3IN.ObjectDefineProperty, $2b1817ae6c52f478$var$ObjectDefineProperties = $fN3IN.ObjectDefineProperties, $2b1817ae6c52f478$var$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf, $2b1817ae6c52f478$var$StringPrototypeToLowerCase = $fN3IN.StringPrototypeToLowerCase, $2b1817ae6c52f478$var$Symbol = $fN3IN.Symbol, $2b1817ae6c52f478$var$SymbolHasInstance = $fN3IN.SymbolHasInstance;
module.exports = $2b1817ae6c52f478$var$Writable;
$2b1817ae6c52f478$var$Writable.WritableState = $2b1817ae6c52f478$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $2b1817ae6c52f478$var$EE = $bBoAO.EventEmitter;

var $6nELQ = parcelRequire("6nELQ");
var $2b1817ae6c52f478$require$Stream = $6nELQ.Stream;

var $e5850 = parcelRequire("e5850");
var $2b1817ae6c52f478$require$Buffer = $e5850.Buffer;

var $6EWHH = parcelRequire("6EWHH");

var $a5OCj = parcelRequire("a5OCj");
var $2b1817ae6c52f478$require$addAbortSignal = $a5OCj.addAbortSignal;

var $9nn9z = parcelRequire("9nn9z");
var $2b1817ae6c52f478$var$getHighWaterMark = $9nn9z.getHighWaterMark, $2b1817ae6c52f478$var$getDefaultHighWaterMark = $9nn9z.getDefaultHighWaterMark;

var $8vCMS = parcelRequire("8vCMS");
var $2b1817ae6c52f478$require$_require_codes = $8vCMS.codes;
var $2b1817ae6c52f478$var$ERR_INVALID_ARG_TYPE = $2b1817ae6c52f478$require$_require_codes.ERR_INVALID_ARG_TYPE, $2b1817ae6c52f478$var$ERR_METHOD_NOT_IMPLEMENTED = $2b1817ae6c52f478$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $2b1817ae6c52f478$var$ERR_MULTIPLE_CALLBACK = $2b1817ae6c52f478$require$_require_codes.ERR_MULTIPLE_CALLBACK, $2b1817ae6c52f478$var$ERR_STREAM_CANNOT_PIPE = $2b1817ae6c52f478$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED = $2b1817ae6c52f478$require$_require_codes.ERR_STREAM_DESTROYED, $2b1817ae6c52f478$var$ERR_STREAM_ALREADY_FINISHED = $2b1817ae6c52f478$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $2b1817ae6c52f478$var$ERR_STREAM_NULL_VALUES = $2b1817ae6c52f478$require$_require_codes.ERR_STREAM_NULL_VALUES, $2b1817ae6c52f478$var$ERR_STREAM_WRITE_AFTER_END = $2b1817ae6c52f478$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $2b1817ae6c52f478$var$ERR_UNKNOWN_ENCODING = $2b1817ae6c52f478$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $2b1817ae6c52f478$var$errorOrDestroy = $6EWHH.errorOrDestroy;
$2b1817ae6c52f478$var$ObjectSetPrototypeOf($2b1817ae6c52f478$var$Writable.prototype, $2b1817ae6c52f478$require$Stream.prototype);
$2b1817ae6c52f478$var$ObjectSetPrototypeOf($2b1817ae6c52f478$var$Writable, $2b1817ae6c52f478$require$Stream);
function $2b1817ae6c52f478$var$nop() {}
var $2b1817ae6c52f478$var$kOnFinished = $2b1817ae6c52f478$var$Symbol('kOnFinished');

function $2b1817ae6c52f478$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("ekGFq"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $2b1817ae6c52f478$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $2b1817ae6c52f478$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $2b1817ae6c52f478$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $2b1817ae6c52f478$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$2b1817ae6c52f478$var$kOnFinished] = [];
}
function $2b1817ae6c52f478$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$2b1817ae6c52f478$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $2b1817ae6c52f478$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$2b1817ae6c52f478$var$ObjectDefineProperty($2b1817ae6c52f478$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $2b1817ae6c52f478$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("ekGFq"));
    if (!isDuplex && !$2b1817ae6c52f478$var$FunctionPrototypeSymbolHasInstance($2b1817ae6c52f478$var$Writable, this)) return new $2b1817ae6c52f478$var$Writable(options);
    this._writableState = new $2b1817ae6c52f478$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $2b1817ae6c52f478$require$addAbortSignal(options.signal, this);
    }
    $2b1817ae6c52f478$require$Stream.call(this, options);
    $6EWHH.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $2b1817ae6c52f478$var$clearBuffer(_this, state);
        $2b1817ae6c52f478$var$finishMaybe(_this, state);
    });
}
$2b1817ae6c52f478$var$ObjectDefineProperty($2b1817ae6c52f478$var$Writable, $2b1817ae6c52f478$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($2b1817ae6c52f478$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $2b1817ae6c52f478$var$Writable) return false;
        return object && object._writableState instanceof $2b1817ae6c52f478$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$2b1817ae6c52f478$var$Writable.prototype.pipe = function() {
    $2b1817ae6c52f478$var$errorOrDestroy(this, new $2b1817ae6c52f478$var$ERR_STREAM_CANNOT_PIPE());
};
function $2b1817ae6c52f478$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$2b1817ae6c52f478$require$Buffer.isEncoding(encoding)) throw new $2b1817ae6c52f478$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $2b1817ae6c52f478$var$nop;
    }
    if (chunk === null) throw new $2b1817ae6c52f478$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $2b1817ae6c52f478$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $2b1817ae6c52f478$require$Buffer) encoding = 'buffer';
        else if ($2b1817ae6c52f478$require$Stream._isUint8Array(chunk)) {
            chunk = $2b1817ae6c52f478$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $2b1817ae6c52f478$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $2b1817ae6c52f478$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $2b1817ae6c52f478$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $2b1817ae6c52f478$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$2b1817ae6c52f478$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $2b1817ae6c52f478$var$_write(this, chunk, encoding, cb) === true;
};
$2b1817ae6c52f478$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2b1817ae6c52f478$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $2b1817ae6c52f478$var$clearBuffer(this, state);
    }
};
$2b1817ae6c52f478$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $2b1817ae6c52f478$var$StringPrototypeToLowerCase(encoding);
    if (!$2b1817ae6c52f478$require$Buffer.isEncoding(encoding)) throw new $2b1817ae6c52f478$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2b1817ae6c52f478$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $2b1817ae6c52f478$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $2b1817ae6c52f478$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2b1817ae6c52f478$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $2b1817ae6c52f478$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $2b1817ae6c52f478$var$errorOrDestroy(stream, er);
}
function $2b1817ae6c52f478$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $2b1817ae6c52f478$var$errorOrDestroy(stream, new $2b1817ae6c52f478$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($2b1817ae6c52f478$var$onwriteError, stream, state, er, cb);
        else $2b1817ae6c52f478$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $2b1817ae6c52f478$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($2b1817ae6c52f478$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $2b1817ae6c52f478$var$afterWrite(stream, state, 1, cb);
    }
}
function $2b1817ae6c52f478$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $2b1817ae6c52f478$var$afterWrite(stream, state, count, cb);
}
function $2b1817ae6c52f478$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $2b1817ae6c52f478$var$errorBuffer(state);
    $2b1817ae6c52f478$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $2b1817ae6c52f478$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$2b1817ae6c52f478$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED('end'));
    }
    $2b1817ae6c52f478$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $2b1817ae6c52f478$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $2b1817ae6c52f478$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $2b1817ae6c52f478$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $2b1817ae6c52f478$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $2b1817ae6c52f478$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $2b1817ae6c52f478$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $2b1817ae6c52f478$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$2b1817ae6c52f478$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $2b1817ae6c52f478$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$2b1817ae6c52f478$var$Writable.prototype._writev = null;
$2b1817ae6c52f478$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $2b1817ae6c52f478$var$_write(this, chunk, encoding);
        if (ret instanceof $2b1817ae6c52f478$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $2b1817ae6c52f478$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $2b1817ae6c52f478$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $2b1817ae6c52f478$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$2b1817ae6c52f478$var$kOnFinished].push(cb);
    }
    return this;
};
function $2b1817ae6c52f478$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $2b1817ae6c52f478$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $2b1817ae6c52f478$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $2b1817ae6c52f478$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$2b1817ae6c52f478$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $2b1817ae6c52f478$var$errorOrDestroy(stream, err, state.sync);
        } else if ($2b1817ae6c52f478$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($2b1817ae6c52f478$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $2b1817ae6c52f478$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $2b1817ae6c52f478$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2b1817ae6c52f478$var$finishMaybe(stream, state, sync) {
    if ($2b1817ae6c52f478$var$needFinish(state)) {
        $2b1817ae6c52f478$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($2b1817ae6c52f478$var$needFinish(state)) $2b1817ae6c52f478$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($2b1817ae6c52f478$var$needFinish(state)) {
                state.pendingcb++;
                $2b1817ae6c52f478$var$finish(stream, state);
            }
        }
    }
}
function $2b1817ae6c52f478$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$2b1817ae6c52f478$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$2b1817ae6c52f478$var$ObjectDefineProperties($2b1817ae6c52f478$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $2b1817ae6c52f478$var$destroy = $6EWHH.destroy;
$2b1817ae6c52f478$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$2b1817ae6c52f478$var$kOnFinished].length)) $2Qkr5.nextTick($2b1817ae6c52f478$var$errorBuffer, state);
    $2b1817ae6c52f478$var$destroy.call(this, err, cb);
    return this;
};
$2b1817ae6c52f478$var$Writable.prototype._undestroy = $6EWHH.undestroy;
$2b1817ae6c52f478$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$2b1817ae6c52f478$var$Writable.prototype[$2b1817ae6c52f478$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $2b1817ae6c52f478$var$webStreamsAdapters;
// Lazy to avoid circular references
function $2b1817ae6c52f478$var$lazyWebStreams() {
    if ($2b1817ae6c52f478$var$webStreamsAdapters === undefined) $2b1817ae6c52f478$var$webStreamsAdapters = {};
    return $2b1817ae6c52f478$var$webStreamsAdapters;
}
$2b1817ae6c52f478$var$Writable.fromWeb = function(writableStream, options) {
    return $2b1817ae6c52f478$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$2b1817ae6c52f478$var$Writable.toWeb = function(streamWritable) {
    return $2b1817ae6c52f478$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hzEEW", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $e5850 = parcelRequire("e5850");

var $dx7Nw = parcelRequire("dx7Nw");
var $ccb53ea2ef946709$var$isReadable = $dx7Nw.isReadable, $ccb53ea2ef946709$var$isWritable = $dx7Nw.isWritable, $ccb53ea2ef946709$var$isIterable = $dx7Nw.isIterable, $ccb53ea2ef946709$var$isNodeStream = $dx7Nw.isNodeStream, $ccb53ea2ef946709$var$isReadableNodeStream = $dx7Nw.isReadableNodeStream, $ccb53ea2ef946709$var$isWritableNodeStream = $dx7Nw.isWritableNodeStream, $ccb53ea2ef946709$var$isDuplexNodeStream = $dx7Nw.isDuplexNodeStream, $ccb53ea2ef946709$var$isReadableStream = $dx7Nw.isReadableStream, $ccb53ea2ef946709$var$isWritableStream = $dx7Nw.isWritableStream;

var $9OOy8 = parcelRequire("9OOy8");

var $8vCMS = parcelRequire("8vCMS");
var $ccb53ea2ef946709$var$AbortError = $8vCMS.AbortError, $ccb53ea2ef946709$var$_require_codes = $8vCMS.codes, $ccb53ea2ef946709$var$ERR_INVALID_ARG_TYPE = $ccb53ea2ef946709$var$_require_codes.ERR_INVALID_ARG_TYPE, $ccb53ea2ef946709$var$ERR_INVALID_RETURN_VALUE = $ccb53ea2ef946709$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $6EWHH = parcelRequire("6EWHH");
var $ccb53ea2ef946709$require$destroyer = $6EWHH.destroyer;

var $ekGFq = parcelRequire("ekGFq");

var $7GKfE = parcelRequire("7GKfE");

var $3Ho76 = parcelRequire("3Ho76");

var $jWxAN = parcelRequire("jWxAN");
var $ccb53ea2ef946709$require$createDeferredPromise = $jWxAN.createDeferredPromise;

var $byQZU = parcelRequire("byQZU");
var $ccb53ea2ef946709$var$Blob = globalThis.Blob || $e5850.Blob;
var $ccb53ea2ef946709$var$isBlob = typeof $ccb53ea2ef946709$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $ccb53ea2ef946709$var$Blob;
} : function isBlob(b) {
    return false;
};

var $ccb53ea2ef946709$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $fN3IN = parcelRequire("fN3IN");
var $ccb53ea2ef946709$require$FunctionPrototypeCall = $fN3IN.FunctionPrototypeCall;
// This is needed for pre node 17.
var $ccb53ea2ef946709$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($ekGFq);
module.exports = function duplexify(body, name) {
    if ($ccb53ea2ef946709$var$isDuplexNodeStream(body)) return body;
    if ($ccb53ea2ef946709$var$isReadableNodeStream(body)) return $ccb53ea2ef946709$var$_duplexify({
        readable: body
    });
    if ($ccb53ea2ef946709$var$isWritableNodeStream(body)) return $ccb53ea2ef946709$var$_duplexify({
        writable: body
    });
    if ($ccb53ea2ef946709$var$isNodeStream(body)) return $ccb53ea2ef946709$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($ccb53ea2ef946709$var$isReadableStream(body)) return $ccb53ea2ef946709$var$_duplexify({
        readable: $7GKfE.fromWeb(body)
    });
    if ($ccb53ea2ef946709$var$isWritableStream(body)) return $ccb53ea2ef946709$var$_duplexify({
        writable: $3Ho76.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $ccb53ea2ef946709$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($ccb53ea2ef946709$var$isIterable(value)) return $byQZU($ccb53ea2ef946709$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $ccb53ea2ef946709$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $ccb53ea2ef946709$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $ccb53ea2ef946709$require$destroyer(d, err);
            });
            return d = new $ccb53ea2ef946709$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $ccb53ea2ef946709$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($ccb53ea2ef946709$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($ccb53ea2ef946709$var$isIterable(body)) return $byQZU($ccb53ea2ef946709$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($ccb53ea2ef946709$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $ccb53ea2ef946709$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $ccb53ea2ef946709$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $ccb53ea2ef946709$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $ccb53ea2ef946709$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $ccb53ea2ef946709$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $ccb53ea2ef946709$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $ccb53ea2ef946709$require$destroyer(d1, err);
        });
        return d1 = new $ccb53ea2ef946709$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $ccb53ea2ef946709$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $ccb53ea2ef946709$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $ccb53ea2ef946709$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $ccb53ea2ef946709$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $ccb53ea2ef946709$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $ccb53ea2ef946709$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $ccb53ea2ef946709$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $7GKfE.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$ccb53ea2ef946709$var$isReadable(r);
    var writable = !!$ccb53ea2ef946709$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ccb53ea2ef946709$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $9OOy8(w, function(err) {
            writable = false;
            if (err) $ccb53ea2ef946709$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $9OOy8(r, function(err) {
            readable = false;
            if (err) $ccb53ea2ef946709$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ccb53ea2ef946709$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $ccb53ea2ef946709$require$destroyer(w, err);
            $ccb53ea2ef946709$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("ks2yT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $ee3868e93be8e15f$require$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf;
module.exports = $ee3868e93be8e15f$var$PassThrough;

var $bXhyq = parcelRequire("bXhyq");
$ee3868e93be8e15f$require$ObjectSetPrototypeOf($ee3868e93be8e15f$var$PassThrough.prototype, $bXhyq.prototype);
$ee3868e93be8e15f$require$ObjectSetPrototypeOf($ee3868e93be8e15f$var$PassThrough, $bXhyq);
function $ee3868e93be8e15f$var$PassThrough(options) {
    if (!(this instanceof $ee3868e93be8e15f$var$PassThrough)) return new $ee3868e93be8e15f$var$PassThrough(options);
    $bXhyq.call(this, options);
}
$ee3868e93be8e15f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("bXhyq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $8b42d2524a3755f5$var$ObjectSetPrototypeOf = $fN3IN.ObjectSetPrototypeOf, $8b42d2524a3755f5$var$Symbol = $fN3IN.Symbol;
module.exports = $8b42d2524a3755f5$var$Transform;

var $8b42d2524a3755f5$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("8vCMS")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $ekGFq = parcelRequire("ekGFq");

var $9nn9z = parcelRequire("9nn9z");
var $8b42d2524a3755f5$require$getHighWaterMark = $9nn9z.getHighWaterMark;
$8b42d2524a3755f5$var$ObjectSetPrototypeOf($8b42d2524a3755f5$var$Transform.prototype, $ekGFq.prototype);
$8b42d2524a3755f5$var$ObjectSetPrototypeOf($8b42d2524a3755f5$var$Transform, $ekGFq);
var $8b42d2524a3755f5$var$kCallback = $8b42d2524a3755f5$var$Symbol('kCallback');
function $8b42d2524a3755f5$var$Transform(options) {
    if (!(this instanceof $8b42d2524a3755f5$var$Transform)) return new $8b42d2524a3755f5$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $8b42d2524a3755f5$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $ekGFq.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8b42d2524a3755f5$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8b42d2524a3755f5$var$prefinish);
}
function $8b42d2524a3755f5$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8b42d2524a3755f5$var$prefinish() {
    if (this._final !== $8b42d2524a3755f5$var$_final) $8b42d2524a3755f5$var$_final.call(this);
}
$8b42d2524a3755f5$var$Transform.prototype._final = $8b42d2524a3755f5$var$_final;
$8b42d2524a3755f5$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8b42d2524a3755f5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8b42d2524a3755f5$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$8b42d2524a3755f5$var$kCallback] = callback;
    });
};
$8b42d2524a3755f5$var$Transform.prototype._read = function() {
    if (this[$8b42d2524a3755f5$var$kCallback]) {
        var callback = this[$8b42d2524a3755f5$var$kCallback];
        this[$8b42d2524a3755f5$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("4agPn", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $fN3IN = parcelRequire("fN3IN");
var $3085263bbdf2daaa$var$ArrayPrototypePop = $fN3IN.ArrayPrototypePop, $3085263bbdf2daaa$var$Promise = $fN3IN.Promise;

var $dx7Nw = parcelRequire("dx7Nw");
var $3085263bbdf2daaa$var$isIterable = $dx7Nw.isIterable, $3085263bbdf2daaa$var$isNodeStream = $dx7Nw.isNodeStream, $3085263bbdf2daaa$var$isWebStream = $dx7Nw.isWebStream;

var $iCAnx = parcelRequire("iCAnx");
var $3085263bbdf2daaa$var$pl = $iCAnx.pipelineImpl;

var $9OOy8 = parcelRequire("9OOy8");
var $3085263bbdf2daaa$require$finished = $9OOy8.finished;
parcelRequire("lD8jD");
function $3085263bbdf2daaa$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $3085263bbdf2daaa$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$3085263bbdf2daaa$var$isNodeStream(lastArg) && !$3085263bbdf2daaa$var$isIterable(lastArg) && !$3085263bbdf2daaa$var$isWebStream(lastArg)) {
            var options = $3085263bbdf2daaa$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $3085263bbdf2daaa$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $3085263bbdf2daaa$require$finished,
    pipeline: $3085263bbdf2daaa$var$pipeline
};

});





parcelRegister("dwDuJ", function(module, exports) {

var $74L1W = parcelRequire("74L1W");
module.exports = function(stream, enc, cb) {
    if (typeof enc === 'function') {
        cb = enc;
        enc = null;
    }
    var str = '';
    var p = new $74L1W(function(resolve, reject) {
        stream.on('data', function(data) {
            str += typeof enc === 'string' ? data.toString(enc) : data.toString();
        });
        stream.on('end', function() {
            resolve(str);
        });
        stream.on('error', reject);
    });
    if (cb) p.then(function(str) {
        cb(null, str);
    }, cb);
    return p;
};

});
parcelRegister("74L1W", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
(function() {
    var root;
    if ((typeof window === "undefined" ? "undefined" : (0, $3KZcf._)(window)) === 'object' && window) root = window;
    else root = $parcel$global;
    if (module.exports) module.exports = root.Promise ? root.Promise : Promise;
    else if (!root.Promise) root.Promise = Promise;
    // Use polyfill for setImmediate for performance gains
    var asap = root.setImmediate || function(fn) {
        setTimeout(fn, 1);
    };
    // Polyfill for Function.prototype.bind
    function bind(fn, thisArg) {
        return function() {
            fn.apply(thisArg, arguments);
        };
    }
    var isArray = Array.isArray || function(value) {
        return Object.prototype.toString.call(value) === "[object Array]";
    };
    function Promise(fn) {
        if ((0, $3KZcf._)(this) !== 'object') throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = null;
        this._value = null;
        this._deferreds = [];
        doResolve(fn, bind(resolve, this), bind(reject, this));
    }
    function handle(deferred) {
        var me = this;
        if (this._state === null) {
            this._deferreds.push(deferred);
            return;
        }
        asap(function() {
            var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
            if (cb === null) {
                (me._state ? deferred.resolve : deferred.reject)(me._value);
                return;
            }
            var ret;
            try {
                ret = cb(me._value);
            } catch (e) {
                deferred.reject(e);
                return;
            }
            deferred.resolve(ret);
        });
    }
    function resolve(newValue) {
        try {
            if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
            if (newValue && ((typeof newValue === "undefined" ? "undefined" : (0, $3KZcf._)(newValue)) === 'object' || typeof newValue === 'function')) {
                var then = newValue.then;
                if (typeof then === 'function') {
                    doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
                    return;
                }
            }
            this._state = true;
            this._value = newValue;
            finale.call(this);
        } catch (e) {
            reject.call(this, e);
        }
    }
    function reject(newValue) {
        this._state = false;
        this._value = newValue;
        finale.call(this);
    }
    function finale() {
        for(var i = 0, len = this._deferreds.length; i < len; i++)handle.call(this, this._deferreds[i]);
        this._deferreds = null;
    }
    function Handler(onFulfilled, onRejected, resolve, reject) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.resolve = resolve;
        this.reject = reject;
    }
    /**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */ function doResolve(fn, onFulfilled, onRejected) {
        var done = false;
        try {
            fn(function(value) {
                if (done) return;
                done = true;
                onFulfilled(value);
            }, function(reason) {
                if (done) return;
                done = true;
                onRejected(reason);
            });
        } catch (ex) {
            if (done) return;
            done = true;
            onRejected(ex);
        }
    }
    Promise.prototype['catch'] = function(onRejected) {
        return this.then(null, onRejected);
    };
    Promise.prototype.then = function(onFulfilled, onRejected) {
        var me = this;
        return new Promise(function(resolve, reject) {
            handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
        });
    };
    Promise.all = function() {
        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
        return new Promise(function(resolve, reject) {
            if (args.length === 0) return resolve([]);
            var remaining = args.length;
            function res(i, val) {
                try {
                    if (val && ((typeof val === "undefined" ? "undefined" : (0, $3KZcf._)(val)) === 'object' || typeof val === 'function')) {
                        var then = val.then;
                        if (typeof then === 'function') {
                            then.call(val, function(val) {
                                res(i, val);
                            }, reject);
                            return;
                        }
                    }
                    args[i] = val;
                    if (--remaining === 0) resolve(args);
                } catch (ex) {
                    reject(ex);
                }
            }
            for(var i = 0; i < args.length; i++)res(i, args[i]);
        });
    };
    Promise.resolve = function(value) {
        if (value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && value.constructor === Promise) return value;
        return new Promise(function(resolve) {
            resolve(value);
        });
    };
    Promise.reject = function(value) {
        return new Promise(function(resolve, reject) {
            reject(value);
        });
    };
    Promise.race = function(values) {
        return new Promise(function(resolve, reject) {
            for(var i = 0, len = values.length; i < len; i++)values[i].then(resolve, reject);
        });
    };
})();

});







parcelRegister("kmuTt", function(module, exports) {
"use strict";
var $ed2dd38d19080967$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ed2dd38d19080967$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ed2dd38d19080967$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ed2dd38d19080967$var$__exportStar((parcelRequire("irJeK")), module.exports);

});
parcelRegister("irJeK", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationAsk = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Ask Query Operation Actor.
 */ var $d6ddd6b3f4fc7511$var$ActorQueryOperationAsk = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationAsk, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationAsk(args) {
        (0, $jGAMp._)(this, ActorQueryOperationAsk);
        return (0, $kzDuW._)(this, ActorQueryOperationAsk, [
            args,
            'ask'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationAsk, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _state.sent();
                                bindingsStream = (0, $2n9RU.getSafeBindings)(output).bindingsStream;
                                return [
                                    2,
                                    {
                                        type: 'boolean',
                                        execute: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                bindingsStream.take(1).toArray()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                _state.sent().length === 1
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationAsk;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationAsk = $d6ddd6b3f4fc7511$var$ActorQueryOperationAsk;

});


parcelRegister("k2U1r", function(module, exports) {
"use strict";
var $e97f73635b97fc19$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e97f73635b97fc19$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e97f73635b97fc19$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e97f73635b97fc19$var$__exportStar((parcelRequire("aplhf")), module.exports);

});
parcelRegister("aplhf", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationBgpJoin = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL BGP operations by rewriting it as a join operator.
 */ var $793cbe679e2a71d2$var$ActorQueryOperationBgpJoin = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationBgpJoin, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationBgpJoin(args) {
        (0, $jGAMp._)(this, ActorQueryOperationBgpJoin);
        return (0, $kzDuW._)(this, ActorQueryOperationBgpJoin, [
            args,
            'bgp'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationBgpJoin, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        return [
                            2,
                            this.mediatorQueryOperation.mediate({
                                operation: algebraFactory.createJoin(operation.patterns),
                                context: context
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationBgpJoin;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationBgpJoin = $793cbe679e2a71d2$var$ActorQueryOperationBgpJoin;

});


parcelRegister("9i17A", function(module, exports) {
"use strict";
var $6c36aa2f83d8e0e9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c36aa2f83d8e0e9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6c36aa2f83d8e0e9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6c36aa2f83d8e0e9$var$__exportStar((parcelRequire("vxSsR")), module.exports);

$6c36aa2f83d8e0e9$var$__exportStar((parcelRequire("6EkDV")), module.exports);

});
parcelRegister("vxSsR", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationConstruct = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");

var $6EkDV = parcelRequire("6EkDV");
/**
 * A comunica Construct Query Operation Actor.
 */ var $05ed2cb908576551$var$ActorQueryOperationConstruct = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationConstruct, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationConstruct(args) {
        (0, $jGAMp._)(this, ActorQueryOperationConstruct);
        return (0, $kzDuW._)(this, ActorQueryOperationConstruct, [
            args,
            'construct'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationConstruct, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, variables, operation, output, _, quadStream, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                // Apply a projection on our CONSTRUCT variables first, as the query may contain other variables as well.
                                variables = ActorQueryOperationConstruct.getVariables(operationOriginal.template);
                                operation = {
                                    type: $hSHd8.Algebra.types.PROJECT,
                                    input: operationOriginal.input,
                                    variables: variables
                                };
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                // Construct triples using the result based on the pattern.
                                // If it's a DESCRIBE query don't apply the blank node localisation.
                                quadStream = new $6EkDV.BindingsToQuadsIterator(dataFactory, operationOriginal.template, output.bindingsStream);
                                // Let the final metadata contain the estimated number of triples
                                metadata = function() {
                                    return output.metadata().then(function(meta) {
                                        return (0, $emQHU._)((0, $iT0je._)({}, meta), {
                                            order: undefined,
                                            cardinality: {
                                                type: meta.cardinality.type,
                                                value: meta.cardinality.value * operationOriginal.template.length
                                            },
                                            availableOrders: undefined
                                        });
                                    });
                                };
                                return [
                                    2,
                                    {
                                        metadata: metadata,
                                        quadStream: quadStream,
                                        type: 'quads'
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "getVariables",
            value: /**
     * Find all variables in a list of triple patterns.
     * @param {Algebra.Pattern[]} patterns An array of triple patterns.
     * @return {RDF.Variable[]} The variables in the triple patterns.
     */ function getVariables(patterns) {
                return (0, $ilNtL.uniqTerms)([].concat.apply([], patterns.map(function(pattern) {
                    return (0, $ilNtL.getVariables)((0, $ilNtL.getTermsNested)(pattern));
                })));
            }
        }
    ]);
    return ActorQueryOperationConstruct;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationConstruct = $05ed2cb908576551$var$ActorQueryOperationConstruct;

});
parcelRegister("6EkDV", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsToQuadsIterator = void 0;

var $aafx9 = parcelRequire("aafx9");

var $ilNtL = parcelRequire("ilNtL");
/**
 * Transforms a bindings stream into a quad stream given a quad template.
 *
 * This conforms to the SPARQL 1.1 spec on constructing triples:
 * https://www.w3.org/TR/sparql11-query/#rConstructTriples
 */ var $4d767dc8530415bd$var$BindingsToQuadsIterator = /*#__PURE__*/ function(_asynciterator_1_MultiTransformIterator) {
    (0, $i3fW3._)(BindingsToQuadsIterator, _asynciterator_1_MultiTransformIterator);
    function BindingsToQuadsIterator(dataFactory, template, bindingsStream) {
        (0, $jGAMp._)(this, BindingsToQuadsIterator);
        var _this;
        _this = (0, $kzDuW._)(this, BindingsToQuadsIterator, [
            bindingsStream,
            {
                autoStart: false
            }
        ]);
        _this.dataFactory = dataFactory;
        _this.template = template;
        _this.blankNodeCounter = 0;
        return _this;
    }
    (0, $byiyg._)(BindingsToQuadsIterator, [
        {
            /**
     * Convert the given template to a list of quads based on the given bindings.
     * @param {Bindings}    bindings           A bindings object.
     * @param {RDF.Quad[]}  template           A list of quad patterns.
     * @param               blankNodeCounter   A counter value for the blank node.
     * @return {RDF.Quad[]}                    A list of quads.
     */ key: "bindTemplate",
            value: function bindTemplate(bindings, template, blankNodeCounter) {
                var quads = template// Make sure the multiple instantiations of the template contain different blank nodes, as required by SPARQL 1.1.
                .map(BindingsToQuadsIterator.localizeQuad.bind(null, this.dataFactory, blankNodeCounter))// Bind variables to bound terms
                .map(function(x) {
                    return BindingsToQuadsIterator.bindQuad.bind(null, bindings)(x);
                })// Remove quads that contained unbound terms, i.e., variables.
                .filter(Boolean);
                return quads;
            }
        },
        {
            key: "_createTransformer",
            value: function _createTransformer(bindings) {
                return new $aafx9.ArrayIterator(this.bindTemplate(bindings, this.template, this.blankNodeCounter++), {
                    autoStart: false
                });
            }
        }
    ], [
        {
            key: "bindTerm",
            value: /**
     * Bind the given term.
     * If the term is a variable and the variable is bound in the bindings object,
     * return the bindings value.
     * If the term is a variable and the variable is not bound in the bindings object,
     * a falsy value is returned..
     * Otherwise, the term itself is returned.
     * @param {Bindings}  bindings A bindings object.
     * @param {RDF.Term}  term     An RDF term.
     * @return {RDF.Term}          If the given term is not a variable, the term itself is returned.
     *                             If the given term is a variable, then the bound term is returned,
     *                             or a falsy value if it did not exist in the bindings.
     */ function bindTerm(bindings, term) {
                if (term.termType === 'Variable') return bindings.get(term);
                return term;
            }
        },
        {
            key: "bindQuad",
            value: /**
     * Bind the given quad pattern.
     * If one of the terms was a variable AND is not bound in the bindings,
     * a falsy value will be returned.
     * @param {Bindings} bindings A bindings object.
     * @param {RDF.Quad} pattern  An RDF quad.
     * @return {RDF.Quad}         A bound RDF quad or undefined.
     */ function bindQuad(bindings, pattern) {
                try {
                    return (0, $ilNtL.mapTermsNested)(pattern, function(term) {
                        var boundTerm = BindingsToQuadsIterator.bindTerm(bindings, term);
                        if (!boundTerm) throw new Error('Unbound term');
                        return boundTerm;
                    });
                } catch (e) {
                // Do nothing
                }
            }
        },
        {
            key: "localizeBlankNode",
            value: /**
     * Convert a blank node to a unique blank node in the given context.
     * If the given term is not a blank node, the term itself will be returned.
     * @param dataFactory The data factory.
     * @param             blankNodeCounter A counter value for the blank node.
     * @param {RDF.Term}  term             The term that should be localized.
     * @return {RDF.Term}                  A term.
     */ function localizeBlankNode(dataFactory, blankNodeCounter, term) {
                if (term.termType === 'BlankNode') return dataFactory.blankNode("".concat(term.value).concat(blankNodeCounter));
                return term;
            }
        },
        {
            key: "localizeQuad",
            value: /**
     * Convert the given quad to a quad that only contains unique blank nodes.
     * @param dataFactory The data factory.
     * @param            blankNodeCounter A counter value for the blank node.
     * @param {RDF.BaseQuad} pattern          The pattern that should be localized.
     * @return {RDF.BaseQuad}                 A quad.
     */ function localizeQuad(dataFactory, blankNodeCounter, pattern) {
                return (0, $ilNtL.mapTermsNested)(pattern, function(term) {
                    return BindingsToQuadsIterator.localizeBlankNode(dataFactory, blankNodeCounter, term);
                });
            }
        }
    ]);
    return BindingsToQuadsIterator;
}($aafx9.MultiTransformIterator);
module.exports.BindingsToQuadsIterator = $4d767dc8530415bd$var$BindingsToQuadsIterator;

});



parcelRegister("byR0v", function(module, exports) {
"use strict";
var $86abfcc98ac0bbd1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $86abfcc98ac0bbd1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $86abfcc98ac0bbd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$86abfcc98ac0bbd1$var$__exportStar((parcelRequire("cEIxX")), module.exports);

});
parcelRegister("cEIxX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationDistinctIdentity = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $202QA = parcelRequire("202QA");
/**
 * A comunica Distinct Identity Query Operation Actor.
 */ var $936bc688fe3ced70$var$ActorQueryOperationDistinctIdentity = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationDistinctIdentity, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationDistinctIdentity(args) {
        (0, $jGAMp._)(this, ActorQueryOperationDistinctIdentity);
        return (0, $kzDuW._)(this, ActorQueryOperationDistinctIdentity, [
            args,
            'distinct'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationDistinctIdentity, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output, outputQuads, quadStream, _, _1, outputBindings, variables, bindingsStream, _2, _3;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _state.sent();
                                if (!(output.type === 'quads')) return [
                                    3,
                                    3
                                ];
                                outputQuads = (0, $2n9RU.getSafeQuads)(output);
                                _1 = (_ = outputQuads.quadStream).filter;
                                return [
                                    4,
                                    this.newIdentityFilterQuads()
                                ];
                            case 2:
                                quadStream = _1.apply(_, [
                                    _state.sent()
                                ]);
                                return [
                                    2,
                                    {
                                        type: 'quads',
                                        quadStream: quadStream,
                                        metadata: outputQuads.metadata
                                    }
                                ];
                            case 3:
                                outputBindings = (0, $2n9RU.getSafeBindings)(output);
                                return [
                                    4,
                                    outputBindings.metadata()
                                ];
                            case 4:
                                variables = _state.sent().variables.map(function(v) {
                                    return v.variable;
                                });
                                _3 = (_2 = outputBindings.bindingsStream).filter;
                                return [
                                    4,
                                    this.newIdentityFilter(variables)
                                ];
                            case 5:
                                bindingsStream = _3.apply(_2, [
                                    _state.sent()
                                ]);
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: outputBindings.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "newIdentityFilter",
            value: /**
     * Create a new distinct filter function.
     * This will maintain an internal Identity datastructure so that every bindings object only returns true once.
     * @param variables The variables to take into account while hashing.
     * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
     */ function newIdentityFilter(variables) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var identities;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        identities = {};
                        return [
                            2,
                            function(bindings) {
                                var identity = variables.map(function(v) {
                                    return $202QA.termToString(bindings.get(v));
                                }).join('-');
                                return !(identity in identities) && (identities[identity] = true);
                            }
                        ];
                    });
                })();
            }
        },
        {
            key: "newIdentityFilterQuads",
            value: /**
     * Create a new distinct filter function to Identity quads.
     * This will maintain an internal Identity datastructure so that every quad object only returns true once.
     * @return {(quad: RDF.Quad) => boolean} A distinct filter for quads.
     */ function newIdentityFilterQuads() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var identities;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        identities = {};
                        return [
                            2,
                            function(quad) {
                                var identity = Object.values($202QA.quadToStringQuad(quad)).join(' ');
                                return !(identity in identities) && (identities[identity] = true);
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorQueryOperationDistinctIdentity;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationDistinctIdentity = $936bc688fe3ced70$var$ActorQueryOperationDistinctIdentity;

});
parcelRegister("202QA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $iJpup = parcelRequire("iJpup");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function get() {
        return $iJpup.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function get() {
        return $iJpup.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function get() {
        return $iJpup.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function get() {
        return $iJpup.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function get() {
        return $iJpup.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function get() {
        return $iJpup.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function get() {
        return $iJpup.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function get() {
        return $iJpup.termToString;
    }
});

});
parcelRegister("iJpup", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $da3033a0916664ab$var$termToString;
module.exports.getLiteralValue = $da3033a0916664ab$var$getLiteralValue;
module.exports.getLiteralType = $da3033a0916664ab$var$getLiteralType;
module.exports.getLiteralLanguage = $da3033a0916664ab$var$getLiteralLanguage;
module.exports.getLiteralDirection = $da3033a0916664ab$var$getLiteralDirection;
module.exports.stringToTerm = $da3033a0916664ab$var$stringToTerm;
module.exports.quadToStringQuad = $da3033a0916664ab$var$quadToStringQuad;
module.exports.stringQuadToQuad = $da3033a0916664ab$var$stringQuadToQuad;

var $6mXoT = parcelRequire("6mXoT");
var $da3033a0916664ab$var$FACTORY = new $6mXoT.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $da3033a0916664ab$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            var literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return "<<".concat($da3033a0916664ab$var$termToString(term.subject), " ").concat($da3033a0916664ab$var$termToString(term.predicate), " ").concat($da3033a0916664ab$var$termToString(term.object)).concat(term.graph.termType === 'DefaultGraph' ? '' : ' ' + $da3033a0916664ab$var$termToString(term.graph), ">>");
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $da3033a0916664ab$var$getLiteralValue(literalValue) {
    var match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $da3033a0916664ab$var$getLiteralType(literalValue) {
    var match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $da3033a0916664ab$var$getLiteralLanguage(literalValue) {
    var match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        var ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        var doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $da3033a0916664ab$var$getLiteralDirection(literalValue) {
    var doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        var direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $da3033a0916664ab$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $da3033a0916664ab$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error("Missing 'variable()' method on the given DataFactory");
            return dataFactory.variable(value.substr(1));
        case '"':
            var language = $da3033a0916664ab$var$getLiteralLanguage(value);
            var direction = $da3033a0916664ab$var$getLiteralDirection(value);
            var type = dataFactory.namedNode($da3033a0916664ab$var$getLiteralType(value));
            return dataFactory.literal($da3033a0916664ab$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                var terms = value.slice(2, -2).trim();
                var stringTerms = [];
                var ignoreTags = 0;
                var lastIndex = 0;
                var inQuote = false;
                for(var i = 0; i < terms.length; i++){
                    var _char = terms[i];
                    if (_char === '<') ignoreTags++;
                    if (_char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (_char === '"') {
                        var escaped = false;
                        var j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (_char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map(function(term) {
                    return term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term;
                });
                return dataFactory.quad($da3033a0916664ab$var$stringToTerm(stringTerms[0]), $da3033a0916664ab$var$stringToTerm(stringTerms[1]), $da3033a0916664ab$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $da3033a0916664ab$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $da3033a0916664ab$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $da3033a0916664ab$var$termToString(q.subject),
        predicate: $da3033a0916664ab$var$termToString(q.predicate),
        object: $da3033a0916664ab$var$termToString(q.object),
        graph: $da3033a0916664ab$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $da3033a0916664ab$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $da3033a0916664ab$var$FACTORY;
    return dataFactory.quad($da3033a0916664ab$var$stringToTerm(stringQuad.subject, dataFactory), $da3033a0916664ab$var$stringToTerm(stringQuad.predicate, dataFactory), $da3033a0916664ab$var$stringToTerm(stringQuad.object, dataFactory), $da3033a0916664ab$var$stringToTerm(stringQuad.graph, dataFactory));
}

});
parcelRegister("6mXoT", function(module, exports) {
"use strict";
var $4a32dfddaa1f262c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a32dfddaa1f262c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4a32dfddaa1f262c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("ioaEb")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("d5uto")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("1A5iu")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("4m9Tt")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("dvHH5")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("bfzMK")), module.exports);

$4a32dfddaa1f262c$var$__exportStar((parcelRequire("kap7X")), module.exports);

});
parcelRegister("ioaEb", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ var $d632ba2be09b3788$var$BlankNode = /*#__PURE__*/ function() {
    function BlankNode(value) {
        (0, $jGAMp._)(this, BlankNode);
        this.termType = 'BlankNode';
        this.value = value;
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNode;
}();
module.exports.BlankNode = $d632ba2be09b3788$var$BlankNode;

});

parcelRegister("d5uto", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $ioaEb = parcelRequire("ioaEb");

var $1A5iu = parcelRequire("1A5iu");

var $4m9Tt = parcelRequire("4m9Tt");

var $dvHH5 = parcelRequire("dvHH5");

var $bfzMK = parcelRequire("bfzMK");

var $kap7X = parcelRequire("kap7X");
var $9873614dc81910f9$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ var $9873614dc81910f9$var$DataFactory = /*#__PURE__*/ function() {
    function DataFactory(options) {
        (0, $jGAMp._)(this, DataFactory);
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || "df_".concat($9873614dc81910f9$var$dataFactoryCounter++, "_");
    }
    (0, $byiyg._)(DataFactory, [
        {
            /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ key: "namedNode",
            value: function namedNode(value) {
                return new $dvHH5.NamedNode(value);
            }
        },
        {
            /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ key: "blankNode",
            value: function blankNode(value) {
                return new $ioaEb.BlankNode(value || "".concat(this.blankNodePrefix).concat(this.blankNodeCounter++));
            }
        },
        {
            /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ key: "literal",
            value: function literal(value, languageOrDatatype) {
                return new $4m9Tt.Literal(value, languageOrDatatype);
            }
        },
        {
            /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ key: "variable",
            value: function variable(value) {
                return new $kap7X.Variable(value);
            }
        },
        {
            /**
     * @return An instance of DefaultGraph.
     */ key: "defaultGraph",
            value: function defaultGraph() {
                return $1A5iu.DefaultGraph.INSTANCE;
            }
        },
        {
            /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ key: "quad",
            value: function quad(subject, predicate, object, graph) {
                return new $bfzMK.Quad(subject, predicate, object, graph || this.defaultGraph());
            }
        },
        {
            /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ key: "fromTerm",
            value: function fromTerm(original) {
                // TODO: remove nasty any casts when this TS bug has been fixed:
                //  https://github.com/microsoft/TypeScript/issues/26933
                switch(original.termType){
                    case 'NamedNode':
                        return this.namedNode(original.value);
                    case 'BlankNode':
                        return this.blankNode(original.value);
                    case 'Literal':
                        if (original.language) return this.literal(original.value, original.language);
                        if (!original.datatype.equals($4m9Tt.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                        return this.literal(original.value);
                    case 'Variable':
                        return this.variable(original.value);
                    case 'DefaultGraph':
                        return this.defaultGraph();
                    case 'Quad':
                        return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
                }
            }
        },
        {
            /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ key: "fromQuad",
            value: function fromQuad(original) {
                return this.fromTerm(original);
            }
        },
        {
            /**
     * Reset the internal blank node counter.
     */ key: "resetBlankNodeCounter",
            value: function resetBlankNodeCounter() {
                this.blankNodeCounter = 0;
            }
        }
    ]);
    return DataFactory;
}();
module.exports.DataFactory = $9873614dc81910f9$var$DataFactory;

});
parcelRegister("1A5iu", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $126d432e134254c3$var$DefaultGraph = /*#__PURE__*/ function() {
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        this.termType = 'DefaultGraph';
        this.value = '';
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'DefaultGraph';
            }
        }
    ]);
    return DefaultGraph;
}();
module.exports.DefaultGraph = $126d432e134254c3$var$DefaultGraph;
$126d432e134254c3$var$DefaultGraph.INSTANCE = new $126d432e134254c3$var$DefaultGraph();

});

parcelRegister("4m9Tt", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $dvHH5 = parcelRequire("dvHH5");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ var $32c0e42d264dd08b$var$Literal = /*#__PURE__*/ function() {
    function Literal(value, languageOrDatatype) {
        (0, $jGAMp._)(this, Literal);
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = Literal.XSD_STRING;
            this.direction = '';
        }
    }
    (0, $byiyg._)(Literal, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
            }
        }
    ]);
    return Literal;
}();
module.exports.Literal = $32c0e42d264dd08b$var$Literal;
$32c0e42d264dd08b$var$Literal.RDF_LANGUAGE_STRING = new $dvHH5.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$32c0e42d264dd08b$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $dvHH5.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$32c0e42d264dd08b$var$Literal.XSD_STRING = new $dvHH5.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("dvHH5", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ var $9d60105212a8b52d$var$NamedNode = /*#__PURE__*/ function() {
    function NamedNode(value) {
        (0, $jGAMp._)(this, NamedNode);
        this.termType = 'NamedNode';
        this.value = value;
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'NamedNode' && other.value === this.value;
            }
        }
    ]);
    return NamedNode;
}();
module.exports.NamedNode = $9d60105212a8b52d$var$NamedNode;

});


parcelRegister("bfzMK", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $830cdaa7b0779151$var$Quad = /*#__PURE__*/ function() {
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "equals",
            value: function equals(other) {
                // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
                return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
            }
        }
    ]);
    return Quad;
}();
module.exports.Quad = $830cdaa7b0779151$var$Quad;

});

parcelRegister("kap7X", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ var $eae83b92524737f8$var$Variable = /*#__PURE__*/ function() {
    function Variable(value) {
        (0, $jGAMp._)(this, Variable);
        this.termType = 'Variable';
        this.value = value;
    }
    (0, $byiyg._)(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Variable' && other.value === this.value;
            }
        }
    ]);
    return Variable;
}();
module.exports.Variable = $eae83b92524737f8$var$Variable;

});







parcelRegister("83WaN", function(module, exports) {
"use strict";
var $0183cd54a73c9ed7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0183cd54a73c9ed7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0183cd54a73c9ed7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0183cd54a73c9ed7$var$__exportStar((parcelRequire("e1Kmp")), module.exports);

});
parcelRegister("e1Kmp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationExtend = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $aduX6 = parcelRequire("aduX6");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Extend Query Operation Actor.
 *
 * See https://www.w3.org/TR/sparql11-query/#sparqlAlgebra;
 */ var $a3651ee12adf9ab2$var$ActorQueryOperationExtend = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationExtend, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationExtend(args) {
        (0, $jGAMp._)(this, ActorQueryOperationExtend);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationExtend, [
            args,
            'extend'
        ]);
        _this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationExtend, [
        {
            key: "testOperation",
            value: function testOperation() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, expression, input, variable, output, _, evaluator, transform, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                expression = operation.expression, input = operation.input, variable = operation.variable;
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    output.metadata()
                                ];
                            case 2:
                                // Throw if the variable has already been bound
                                if (_state.sent().variables.some(function(innerVariable) {
                                    return innerVariable.variable.equals(variable);
                                })) throw new Error("Illegal binding to variable '".concat(variable.value, "' that has already been bound"));
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expression,
                                        context: context
                                    })
                                ];
                            case 3:
                                evaluator = _state.sent();
                                // Transform the stream by extending each Bindings with the expression result
                                transform = function(bindings, next, push) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var result, extended, error;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        evaluator.evaluate(bindings)
                                                    ];
                                                case 1:
                                                    result = _state.sent();
                                                    // Extend operation is undefined when the key already exists
                                                    // We just override it here.
                                                    extended = bindings.set(variable, result);
                                                    push(extended);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    error = _state.sent();
                                                    if ((0, $aduX6.isExpressionError)(error)) {
                                                        // Errors silently don't actually extend according to the spec
                                                        push(bindings);
                                                        // But let's warn anyway
                                                        this.logWarn(context, "Expression error for extend operation (".concat(error.message, ")") + "with bindings '".concat((0, $itFzw.bindingsToString)(bindings), "'"));
                                                    } else bindingsStream.emit('error', error);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 3:
                                                    next();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                };
                                // eslint-disable-next-line ts/no-misused-promises
                                bindingsStream = output.bindingsStream.transform({
                                    autoStart: false,
                                    transform: transform
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var outputMetadata;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                output.metadata()
                                                            ];
                                                        case 1:
                                                            outputMetadata = _state.sent();
                                                            return [
                                                                2,
                                                                (0, $emQHU._)((0, $iT0je._)({}, outputMetadata), {
                                                                    variables: (0, $7WNf6._)(outputMetadata.variables).concat([
                                                                        {
                                                                            variable: variable,
                                                                            canBeUndef: false
                                                                        }
                                                                    ])
                                                                })
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationExtend;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationExtend = $a3651ee12adf9ab2$var$ActorQueryOperationExtend;

});


parcelRegister("8s53N", function(module, exports) {
"use strict";
var $6274dd1b787534ce$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6274dd1b787534ce$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6274dd1b787534ce$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6274dd1b787534ce$var$__exportStar((parcelRequire("5L6x4")), module.exports);

});
parcelRegister("5L6x4", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationFilter = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $aduX6 = parcelRequire("aduX6");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Filter Sparqlee Query Operation Actor.
 */ var $431668b6bf085662$var$ActorQueryOperationFilter = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationFilter, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationFilter(args) {
        (0, $jGAMp._)(this, ActorQueryOperationFilter);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationFilter, [
            args,
            'filter'
        ]);
        _this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationFilter, [
        {
            key: "testOperation",
            value: function testOperation() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, outputRaw, output, evaluator, transform, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                outputRaw = _state.sent();
                                output = (0, $2n9RU.getSafeBindings)(outputRaw);
                                (0, $2n9RU.validateQueryOutput)(output, 'bindings');
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: operation.expression,
                                        context: context
                                    })
                                ];
                            case 2:
                                evaluator = _state.sent();
                                transform = function(item, next, push) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var result, error;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        evaluator.evaluateAsEBV(item)
                                                    ];
                                                case 1:
                                                    result = _state.sent();
                                                    if (result) push(item);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    error = _state.sent();
                                                    // We ignore all Expression errors.
                                                    // Other errors (likely programming mistakes) are still propagated.
                                                    //
                                                    // > Specifically, FILTERs eliminate any solutions that,
                                                    // > when substituted into the expression, either result in
                                                    // > an effective boolean value of false or produce an error.
                                                    // > ...
                                                    // > These errors have no effect outside of FILTER evaluation.
                                                    // https://www.w3.org/TR/sparql11-query/#expressions
                                                    if ((0, $aduX6.isExpressionError)(error)) // In many cases, this is a user error, where the user should manually cast the variable to a string.
                                                    // In order to help users debug this, we should report these errors via the logger as warnings.
                                                    this.logWarn(context, 'Error occurred while filtering.', function() {
                                                        return {
                                                            error: error,
                                                            bindings: (0, $itFzw.bindingsToString)(item)
                                                        };
                                                    });
                                                    else bindingsStream.emit('error', error);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 3:
                                                    next();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                };
                                // eslint-disable-next-line ts/no-misused-promises
                                bindingsStream = output.bindingsStream.transform({
                                    transform: transform,
                                    autoStart: false
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: output.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationFilter;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationFilter = $431668b6bf085662$var$ActorQueryOperationFilter;

});


parcelRegister("7fBtz", function(module, exports) {
"use strict";
var $5477011356aa16ac$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5477011356aa16ac$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5477011356aa16ac$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5477011356aa16ac$var$__exportStar((parcelRequire("42kr6")), module.exports);

});
parcelRegister("42kr6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationFromQuad = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica From Query Operation Actor.
 */ var $2f07338a54ec0d6e$var$ActorQueryOperationFromQuad = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationFromQuad, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationFromQuad(args) {
        (0, $jGAMp._)(this, ActorQueryOperationFromQuad);
        return (0, $kzDuW._)(this, ActorQueryOperationFromQuad, [
            args,
            'from'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationFromQuad, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = ActorQueryOperationFromQuad.createOperation(algebraFactory, operationOriginal);
                        return [
                            2,
                            this.mediatorQueryOperation.mediate({
                                operation: operation,
                                context: context
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "copyOperation",
            value: /**
     * Create a deep copy of the given operation.
     * @param {Operation} operation An operation.
     * @param {(subOperation: Operation) => Operation} recursiveCb A callback for recursive operation calls.
     * @return {Operation} The copied operation.
     */ function copyOperation(operation, recursiveCb) {
                var copiedOperation = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(operation)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (Array.isArray(operation[key]) && key !== 'template') {
                            // We exclude the 'template' entry, as we don't want to modify the template value of construct operations
                            if (key === 'variables') copiedOperation[key] = operation[key];
                            else copiedOperation[key] = operation[key].map(recursiveCb);
                        } else if (ActorQueryOperationFromQuad.ALGEBRA_TYPES.includes(operation[key].type)) copiedOperation[key] = recursiveCb(operation[key]);
                        else copiedOperation[key] = operation[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return copiedOperation;
            }
        },
        {
            key: "applyOperationDefaultGraph",
            value: /**
     * Recursively transform the given operation to use the given graphs as default graph
     * This will (possibly) create a new operation and not modify the given operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation} operation An operation.
     * @param {RDF.Term[]} defaultGraphs Graph terms.
     * @return {Operation} A new operation.
     */ function applyOperationDefaultGraph(algebraFactory, operation, defaultGraphs) {
                var _this = this;
                // If the operation is a BGP or Path, change the graph.
                if (operation.type === 'bgp' && operation.patterns.length > 0 || operation.type === 'path' || operation.type === 'pattern') {
                    if (operation.type === 'bgp') return ActorQueryOperationFromQuad.joinOperations(algebraFactory, operation.patterns.map(function(pattern) {
                        if (pattern.graph.termType !== 'DefaultGraph') return algebraFactory.createBgp([
                            pattern
                        ]);
                        var bgps = defaultGraphs.map(function(graph) {
                            return algebraFactory.createBgp([
                                Object.assign(algebraFactory.createPattern(pattern.subject, pattern.predicate, pattern.object, graph), {
                                    metadata: pattern.metadata
                                })
                            ]);
                        });
                        return ActorQueryOperationFromQuad.unionOperations(algebraFactory, bgps);
                    }));
                    if (operation.graph.termType !== 'DefaultGraph') return operation;
                    var paths = defaultGraphs.map(function(graph) {
                        if (operation.type === 'path') return algebraFactory.createPath(operation.subject, operation.predicate, operation.object, graph);
                        return Object.assign(algebraFactory.createPattern(operation.subject, operation.predicate, operation.object, graph), {
                            metadata: operation.metadata
                        });
                    });
                    return ActorQueryOperationFromQuad.unionOperations(algebraFactory, paths);
                }
                return ActorQueryOperationFromQuad.copyOperation(operation, function(subOperation) {
                    return _this.applyOperationDefaultGraph(algebraFactory, subOperation, defaultGraphs);
                });
            }
        },
        {
            key: "applyOperationNamedGraph",
            value: /**
     * Recursively transform the given operation to use the given graphs as named graph
     * This will (possibly) create a new operation and not modify the given operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation} operation An operation.
     * @param {RDF.Term[]} namedGraphs Graph terms.
     * @param {RDF.Term[]} defaultGraphs Default graph terms.
     * @return {Operation} A new operation.
     */ function applyOperationNamedGraph(algebraFactory, operation, namedGraphs, defaultGraphs) {
                var _this = this;
                // If the operation is a BGP or Path, change the graph.
                if (operation.type === 'bgp' && operation.patterns.length > 0 || operation.type === 'path' || operation.type === 'pattern') {
                    var patternGraph = operation.type === 'bgp' ? operation.patterns[0].graph : operation.graph;
                    if (patternGraph.termType === 'DefaultGraph') // SPARQL spec (8.2) describes that when FROM NAMED's are used without a FROM, the default graph must be empty.
                    // The FROMs are transformed before this step to a named node, so this will not apply to this case anymore.
                    return {
                        type: $hSHd8.Algebra.types.BGP,
                        patterns: []
                    };
                    if (patternGraph.termType === 'Variable') {
                        if (namedGraphs.length === 1) {
                            var graph = namedGraphs[0];
                            // If the pattern graph is a variable, replace the graph and bind the variable using VALUES
                            var bindings = {};
                            bindings["?".concat(patternGraph.value)] = graph;
                            var values = algebraFactory.createValues([
                                patternGraph
                            ], [
                                bindings
                            ]);
                            var pattern;
                            if (operation.type === 'bgp') pattern = algebraFactory.createBgp(operation.patterns.map(function(pat) {
                                return algebraFactory.createPattern(pat.subject, pat.predicate, pat.object, graph);
                            }));
                            else if (operation.type === 'path') pattern = algebraFactory.createPath(operation.subject, operation.predicate, operation.object, graph);
                            else pattern = algebraFactory.createPattern(operation.subject, operation.predicate, operation.object, graph);
                            return algebraFactory.createJoin([
                                values,
                                pattern
                            ]);
                        }
                        // If the pattern graph is a variable, take the union of the pattern applied to each available named graph
                        return ActorQueryOperationFromQuad.unionOperations(algebraFactory, namedGraphs.map(function(graph) {
                            return ActorQueryOperationFromQuad.applyOperationNamedGraph(algebraFactory, operation, [
                                graph
                            ], defaultGraphs);
                        }));
                    }
                    // The pattern's graph is defined (including the default graphs)
                    var isNamedGraphAvailable = (0, $7WNf6._)(namedGraphs).concat((0, $7WNf6._)(defaultGraphs)).some(function(namedGraph) {
                        return namedGraph.equals(patternGraph);
                    });
                    if (isNamedGraphAvailable) // Return the pattern as-is if the pattern's graph was selected in a FROM NAMED
                    return operation;
                    // No-op if the pattern's graph was not selected in a FROM NAMED.
                    return {
                        type: $hSHd8.Algebra.types.BGP,
                        patterns: []
                    };
                }
                return ActorQueryOperationFromQuad.copyOperation(operation, function(subOperation) {
                    return _this.applyOperationNamedGraph(algebraFactory, subOperation, namedGraphs, defaultGraphs);
                });
            }
        },
        {
            key: "joinOperations",
            value: /**
     * Transform the given array of operations into a join operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation[]} operations An array of operations, must contain at least one operation.
     * @return {Join} A join operation.
     */ function joinOperations(algebraFactory, operations) {
                if (operations.length === 1) return operations[0];
                if (operations.length > 1) return algebraFactory.createJoin(operations);
                throw new Error('A join can only be applied on at least one operation');
            }
        },
        {
            key: "unionOperations",
            value: /**
     * Transform the given array of operations into a union operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation[]} operations An array of operations, must contain at least one operation.
     * @return {Union} A union operation.
     */ function unionOperations(algebraFactory, operations) {
                if (operations.length === 1) return operations[0];
                if (operations.length > 1) return algebraFactory.createUnion(operations);
                throw new Error('A union can only be applied on at least one operation');
            }
        },
        {
            key: "createOperation",
            value: /**
     * Transform an operation based on the default and named graphs in the pattern.
     *
     * FROM sets the default graph.
     * If multiple are available, take the union of the operation for all of them at quad-pattern level.
     *
     * FROM NAMED indicates which named graphs are available.
     * This will rewrite the query so that only triples from the given named graphs can be selected.
     *
     * @package
     * @param algebraFactory The algebra factory.
     * @param {From} pattern A from operation.
     * @return {Operation} The transformed operation.
     */ function createOperation(algebraFactory, pattern) {
                var operation = pattern.input;
                if (pattern["default"].length > 0) operation = ActorQueryOperationFromQuad.applyOperationDefaultGraph(algebraFactory, operation, pattern["default"]);
                if (pattern.named.length > 0 || pattern["default"].length > 0) operation = ActorQueryOperationFromQuad.applyOperationNamedGraph(algebraFactory, operation, pattern.named, pattern["default"]);
                return operation;
            }
        }
    ]);
    return ActorQueryOperationFromQuad;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationFromQuad = $2f07338a54ec0d6e$var$ActorQueryOperationFromQuad;
$2f07338a54ec0d6e$var$ActorQueryOperationFromQuad.ALGEBRA_TYPES = Object.keys($hSHd8.Algebra.types).map(function(key) {
    return $hSHd8.Algebra.types[key];
});

});


parcelRegister("bmdx4", function(module, exports) {
"use strict";
var $844c3f08f5f8369d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $844c3f08f5f8369d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $844c3f08f5f8369d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$844c3f08f5f8369d$var$__exportStar((parcelRequire("5StfT")), module.exports);

});
parcelRegister("5StfT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationProject = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $ck9FR = parcelRequire("ck9FR");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Project Query Operation Actor.
 */ var $4478b069e9711772$var$ActorQueryOperationProject = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationProject, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationProject(args) {
        (0, $jGAMp._)(this, ActorQueryOperationProject);
        return (0, $kzDuW._)(this, ActorQueryOperationProject, [
            args,
            'project'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationProject, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, output, _, outputMetadata, variablesOutputIndexed, variablesOperation, variablesOperationIndexed, deleteVariables, variablesOutput, bindingsStream, blankNodeCounter;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    output.metadata()
                                ];
                            case 2:
                                outputMetadata = _state.sent();
                                variablesOutputIndexed = Object.fromEntries(outputMetadata.variables.map(function(entry) {
                                    return [
                                        entry.variable.value,
                                        entry
                                    ];
                                }));
                                variablesOperation = operation.variables.map(function(v) {
                                    return {
                                        variable: v,
                                        canBeUndef: false
                                    };
                                });
                                variablesOperationIndexed = Object.fromEntries(variablesOperation.map(function(entry) {
                                    return [
                                        entry.variable.value,
                                        entry
                                    ];
                                }));
                                // Find all variables that should be deleted from the input stream.
                                deleteVariables = outputMetadata.variables.filter(function(variable) {
                                    return !(variable.variable.value in variablesOperationIndexed);
                                });
                                // Determine if variables can be undef
                                variablesOutput = variablesOperation.map(function(variable) {
                                    return {
                                        variable: variable.variable,
                                        canBeUndef: !(variable.variable.value in variablesOutputIndexed) || variablesOutputIndexed[variable.variable.value].canBeUndef
                                    };
                                });
                                // Make sure the project variables are the only variables that are present in the bindings.
                                bindingsStream = deleteVariables.length === 0 ? output.bindingsStream : output.bindingsStream.map(function(bindings) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = deleteVariables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var deleteVariable = _step.value;
                                            bindings = bindings["delete"](deleteVariable.variable);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return bindings;
                                });
                                // Make sure that blank nodes with same labels are not reused over different bindings, as required by SPARQL 1.1.
                                // Required for the BNODE() function: https://www.w3.org/TR/sparql11-query/#func-bnode
                                // When we have a scoped blank node, make sure the skolemized value is maintained.
                                blankNodeCounter = 0;
                                bindingsStream = bindingsStream.map(function(bindings) {
                                    blankNodeCounter++;
                                    var scopedBlankNodesCache = new Map();
                                    return bindings.map(function(term) {
                                        if (term instanceof $ck9FR.BlankNodeBindingsScoped) {
                                            var scopedBlankNode = scopedBlankNodesCache.get(term.value);
                                            if (!scopedBlankNode) {
                                                scopedBlankNode = dataFactory.blankNode("".concat(term.value).concat(blankNodeCounter));
                                                scopedBlankNodesCache.set(term.value, scopedBlankNode);
                                            }
                                            return scopedBlankNode;
                                        }
                                        return term;
                                    });
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    return [
                                                        2,
                                                        (0, $emQHU._)((0, $iT0je._)({}, outputMetadata), {
                                                            variables: variablesOutput
                                                        })
                                                    ];
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationProject;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationProject = $4478b069e9711772$var$ActorQueryOperationProject;

});


parcelRegister("4Gx0x", function(module, exports) {
"use strict";
var $3694b04d043545cd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3694b04d043545cd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3694b04d043545cd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3694b04d043545cd$var$__exportStar((parcelRequire("2S2S6")), module.exports);

});
parcelRegister("2S2S6", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationReducedHash = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $g79wS = parcelRequire("g79wS");
/**
 * A comunica Reduced Hash Query Operation Actor.
 */ var $2172da2fed2fc45b$var$ActorQueryOperationReducedHash = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationReducedHash, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationReducedHash(args) {
        (0, $jGAMp._)(this, ActorQueryOperationReducedHash);
        return (0, $kzDuW._)(this, ActorQueryOperationReducedHash, [
            args,
            'reduced'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationReducedHash, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output, _, variables, bindingsStream, _1, _2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    output.metadata()
                                ];
                            case 2:
                                variables = _state.sent().variables.map(function(v) {
                                    return v.variable;
                                });
                                _2 = (_1 = output.bindingsStream).filter;
                                return [
                                    4,
                                    this.newHashFilter(context, variables)
                                ];
                            case 3:
                                bindingsStream = _2.apply(_1, [
                                    _state.sent()
                                ]);
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: output.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "newHashFilter",
            value: /**
     * Create a new distinct filter function.
     * This will maintain an internal hash datastructure so that every bindings object only returns true once.
     * @param context The action context.
     * @param variables The variables to take into account while hashing.
     * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
     */ function newHashFilter(context, variables) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var hashFunction, hashes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorHashBindings.mediate({
                                        context: context
                                    })
                                ];
                            case 1:
                                hashFunction = _state.sent().hashFunction;
                                hashes = new $g79wS.LRUCache({
                                    max: this.cacheSize
                                });
                                return [
                                    2,
                                    function(bindings) {
                                        var hash = hashFunction(bindings, variables);
                                        if (hashes.has(hash)) return false;
                                        hashes.set(hash, true);
                                        return true;
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationReducedHash;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationReducedHash = $2172da2fed2fc45b$var$ActorQueryOperationReducedHash;

});
parcelRegister("g79wS", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $bbb4b11d70ef0ebe$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $bbb4b11d70ef0ebe$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $bbb4b11d70ef0ebe$var$warned = new Set();
/* c8 ignore start */ var $bbb4b11d70ef0ebe$var$PROCESS = {};
/* c8 ignore start */ var $bbb4b11d70ef0ebe$var$emitWarning = function(msg, type, code, fn) {
    typeof $bbb4b11d70ef0ebe$var$PROCESS.emitWarning === 'function' ? $bbb4b11d70ef0ebe$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $bbb4b11d70ef0ebe$var$AC = globalThis.AbortController;
var $bbb4b11d70ef0ebe$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $bbb4b11d70ef0ebe$var$AC === 'undefined') {
    var $bbb4b11d70ef0ebe$var$_PROCESS_env;
    //@ts-ignore
    $bbb4b11d70ef0ebe$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $bbb4b11d70ef0ebe$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $bbb4b11d70ef0ebe$var$AS());
            $bbb4b11d70ef0ebe$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $bbb4b11d70ef0ebe$var$printACPolyfillWarning = (($bbb4b11d70ef0ebe$var$_PROCESS_env = $bbb4b11d70ef0ebe$var$PROCESS.env) === null || $bbb4b11d70ef0ebe$var$_PROCESS_env === void 0 ? void 0 : $bbb4b11d70ef0ebe$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $bbb4b11d70ef0ebe$var$warnACPolyfill = function() {
        if (!$bbb4b11d70ef0ebe$var$printACPolyfillWarning) return;
        $bbb4b11d70ef0ebe$var$printACPolyfillWarning = false;
        $bbb4b11d70ef0ebe$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $bbb4b11d70ef0ebe$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $bbb4b11d70ef0ebe$var$shouldWarn = function(code) {
    return !$bbb4b11d70ef0ebe$var$warned.has(code);
};
var $bbb4b11d70ef0ebe$var$TYPE = Symbol('type');
var $bbb4b11d70ef0ebe$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $bbb4b11d70ef0ebe$var$getUintArray = function(max) {
    return !$bbb4b11d70ef0ebe$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $bbb4b11d70ef0ebe$var$ZeroArray : null;
};
/* c8 ignore stop */ var $bbb4b11d70ef0ebe$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $bbb4b11d70ef0ebe$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $bbb4b11d70ef0ebe$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $bbb4b11d70ef0ebe$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $bbb4b11d70ef0ebe$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $bbb4b11d70ef0ebe$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $bbb4b11d70ef0ebe$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$bbb4b11d70ef0ebe$var$_max = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_maxSize = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_dispose = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$bbb4b11d70ef0ebe$var$_size = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_keyMap = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_keyList = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_valList = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_next = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_prev = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_head = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_tail = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_free = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_disposed = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_sizes = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_starts = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_ttls = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$bbb4b11d70ef0ebe$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $bbb4b11d70ef0ebe$var$_isStale = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_requireSize = /*#__PURE__*/ new WeakMap(), $bbb4b11d70ef0ebe$var$_indexes = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_rindexes = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_evict = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_connect = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_delete = /*#__PURE__*/ new WeakSet(), $bbb4b11d70ef0ebe$var$_clear = /*#__PURE__*/ new WeakSet();
var $bbb4b11d70ef0ebe$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_indexes);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_rindexes);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_isValidIndex);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_evict);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_backgroundFetch);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_connect);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_moveToTail);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_delete);
        (0, $bA8rW._)(this, $bbb4b11d70ef0ebe$var$_clear);
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $bbb4b11d70ef0ebe$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$bbb4b11d70ef0ebe$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $bbb4b11d70ef0ebe$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_max, max);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, 0);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, 0);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_free, $bbb4b11d70ef0ebe$var$Stack.create(max));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_size, 0);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_hasDispose, !!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_dispose));
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize) !== 0) {
                if (!$bbb4b11d70ef0ebe$var$isPosInt((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$bbb4b11d70ef0ebe$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_initializeSizeTracking, $bbb4b11d70ef0ebe$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $bbb4b11d70ef0ebe$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$bbb4b11d70ef0ebe$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_initializeTTLTracking, $bbb4b11d70ef0ebe$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max) && !(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($bbb4b11d70ef0ebe$var$shouldWarn(code)) {
                $bbb4b11d70ef0ebe$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $bbb4b11d70ef0ebe$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i],
                                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i],
                                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($bbb4b11d70ef0ebe$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes)) entry.size = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $bbb4b11d70ef0ebe$var$perf.now() - (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes)) entry.size = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $bbb4b11d70ef0ebe$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) === 0 ? (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail) : (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).length !== 0 ? (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).pop() : (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max) ? (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_evict, $bbb4b11d70ef0ebe$var$evict).call(this, false) : (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size);
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail)] = index;
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[index] = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail);
                    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, index);
                    (0, $3cNKp._)(this, $bbb4b11d70ef0ebe$var$_size).value++;
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_moveToTail, $bbb4b11d70ef0ebe$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $bbb4b11d70ef0ebe$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $bbb4b11d70ef0ebe$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls)) (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_initializeTTLTracking, $bbb4b11d70ef0ebe$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $bbb4b11d70ef0ebe$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size)){
                        var val = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head)];
                        (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_evict, $bbb4b11d70ef0ebe$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $bbb4b11d70ef0ebe$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_backgroundFetch, $bbb4b11d70ef0ebe$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_moveToTail, $bbb4b11d70ef0ebe$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_backgroundFetch, $bbb4b11d70ef0ebe$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_moveToTail, $bbb4b11d70ef0ebe$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_clear, $bbb4b11d70ef0ebe$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_starts),
                    ttls: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_ttls),
                    sizes: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_keyList),
                    valList: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_valList),
                    next: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_next),
                    prev: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $bbb4b11d70ef0ebe$var$_backgroundFetch, $bbb4b11d70ef0ebe$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $bbb4b11d70ef0ebe$var$_moveToTail, $bbb4b11d70ef0ebe$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $bbb4b11d70ef0ebe$var$_indexes, $bbb4b11d70ef0ebe$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $bbb4b11d70ef0ebe$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $bbb4b11d70ef0ebe$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $bbb4b11d70ef0ebe$var$ZeroArray((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max));
    var starts = new $bbb4b11d70ef0ebe$var$ZeroArray((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max));
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_ttls, ttls);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_starts, starts);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $bbb4b11d70ef0ebe$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $bbb4b11d70ef0ebe$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(_this1, (0, $el4bI._)(_this1, $bbb4b11d70ef0ebe$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $bbb4b11d70ef0ebe$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $bbb4b11d70ef0ebe$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $bbb4b11d70ef0ebe$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $bbb4b11d70ef0ebe$var$ZeroArray((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_max));
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_sizes, sizes);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize, (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$bbb4b11d70ef0ebe$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$bbb4b11d70ef0ebe$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $bbb4b11d70ef0ebe$var$_evict, $bbb4b11d70ef0ebe$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize, (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_calculatedSize);
        }
    });
}
function $bbb4b11d70ef0ebe$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isValidIndex, $bbb4b11d70ef0ebe$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $bbb4b11d70ef0ebe$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isValidIndex, $bbb4b11d70ef0ebe$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $bbb4b11d70ef0ebe$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[index]) === index;
}
function $bbb4b11d70ef0ebe$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head);
    var k = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[head];
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose) || (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $bbb4b11d70ef0ebe$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) === 1) {
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, 0));
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[head]);
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $bbb4b11d70ef0ebe$var$_size).value--;
    return head;
}
function $bbb4b11d70ef0ebe$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $bbb4b11d70ef0ebe$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $bbb4b11d70ef0ebe$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $bbb4b11d70ef0ebe$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $bbb4b11d70ef0ebe$var$_delete, $bbb4b11d70ef0ebe$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $bbb4b11d70ef0ebe$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $bbb4b11d70ef0ebe$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index] = bf;
    return bf;
}
function $bbb4b11d70ef0ebe$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $bbb4b11d70ef0ebe$var$AC;
}
function $bbb4b11d70ef0ebe$var$connect(p, n) {
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[n] = p;
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[p] = n;
}
function $bbb4b11d70ef0ebe$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail)) {
        if (index === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head)) (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[index]);
        else (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_connect, $bbb4b11d70ef0ebe$var$connect).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[index], (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[index]);
        (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_connect, $bbb4b11d70ef0ebe$var$connect).call(this, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail), index);
        (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, index);
    }
}
function $bbb4b11d70ef0ebe$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_size) === 1) (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_clear, $bbb4b11d70ef0ebe$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose) || (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $bbb4b11d70ef0ebe$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_tail)) (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_head)) (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[index];
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[pi] = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_next)[index];
                    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[ni] = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $bbb4b11d70ef0ebe$var$_size).value--;
                (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $bbb4b11d70ef0ebe$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $bbb4b11d70ef0ebe$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_rindexes, $bbb4b11d70ef0ebe$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $bbb4b11d70ef0ebe$var$_isBackgroundFetch, $bbb4b11d70ef0ebe$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList)[index];
                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $bbb4b11d70ef0ebe$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyMap).clear();
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts)) {
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_ttls).fill(0);
        (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes)) (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_head, 0);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_tail, 0);
    (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_free).length = 0;
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $bbb4b11d70ef0ebe$var$_size, 0);
    if ((0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_hasDisposeAfter) && (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $bbb4b11d70ef0ebe$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $bbb4b11d70ef0ebe$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});



parcelRegister("7IPXV", function(module, exports) {
"use strict";
var $59f4f3c116e79e46$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59f4f3c116e79e46$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $59f4f3c116e79e46$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$59f4f3c116e79e46$var$__exportStar((parcelRequire("hRKn1")), module.exports);

});
parcelRegister("hRKn1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationSlice = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Slice Query Operation Actor.
 */ var $d01b5b12484d9bf7$var$ActorQueryOperationSlice = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationSlice, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationSlice(args) {
        (0, $jGAMp._)(this, ActorQueryOperationSlice);
        return (0, $kzDuW._)(this, ActorQueryOperationSlice, [
            args,
            'slice'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationSlice, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output, bindingsStream, quadStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Add limit indicator to the context, which can be used for query planning
                                // eslint-disable-next-line unicorn/explicit-length-check
                                if (operation.length) context = context.set($9nBhR.KeysQueryOperation.limitIndicator, operation.length);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _state.sent();
                                if (output.type === 'bindings') {
                                    bindingsStream = this.sliceStream(output.bindingsStream, operation);
                                    return [
                                        2,
                                        {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: this.sliceMetadata(output, operation)
                                        }
                                    ];
                                }
                                if (output.type === 'quads') {
                                    quadStream = this.sliceStream(output.quadStream, operation);
                                    return [
                                        2,
                                        {
                                            type: 'quads',
                                            quadStream: quadStream,
                                            metadata: this.sliceMetadata(output, operation)
                                        }
                                    ];
                                }
                                // In all other cases, return the result as-is.
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Slice the stream based on the pattern values
            key: "sliceStream",
            value: function sliceStream(stream, pattern) {
                // eslint-disable-next-line unicorn/explicit-length-check
                var hasLength = Boolean(pattern.length) || pattern.length === 0;
                var start = pattern.start;
                var end = hasLength ? pattern.start + pattern.length - 1 : Number.POSITIVE_INFINITY;
                return stream.transform({
                    offset: start,
                    limit: Math.max(end - start + 1, 0),
                    autoStart: false
                });
            }
        },
        {
            // If we find metadata, apply slicing on the total number of items
            key: "sliceMetadata",
            value: function sliceMetadata(output, pattern) {
                // eslint-disable-next-line unicorn/explicit-length-check
                var hasLength = Boolean(pattern.length) || pattern.length === 0;
                return function() {
                    return output.metadata().then(function(subMetadata) {
                        var cardinality = (0, $iT0je._)({}, subMetadata.cardinality);
                        if (Number.isFinite(cardinality.value)) {
                            cardinality.value = Math.max(0, cardinality.value - pattern.start);
                            if (hasLength) cardinality.value = Math.min(cardinality.value, pattern.length);
                        }
                        return (0, $emQHU._)((0, $iT0je._)({}, subMetadata), {
                            cardinality: cardinality
                        });
                    });
                };
            }
        }
    ]);
    return ActorQueryOperationSlice;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationSlice = $d01b5b12484d9bf7$var$ActorQueryOperationSlice;

});


parcelRegister("b0tz5", function(module, exports) {
"use strict";
var $8036a0c3eb47785e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8036a0c3eb47785e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8036a0c3eb47785e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8036a0c3eb47785e$var$__exportStar((parcelRequire("33ST8")), module.exports);

});
parcelRegister("33ST8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUnion = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica Union Query Operation Actor.
 */ var $23ac3a9125ad076e$var$ActorQueryOperationUnion = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationUnion, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationUnion(args) {
        (0, $jGAMp._)(this, ActorQueryOperationUnion);
        return (0, $kzDuW._)(this, ActorQueryOperationUnion, [
            args,
            'union'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationUnion, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, outputsRaw, outputType, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, output, outputs, bindingsStream, metadata, outputs1, quadStream, metadata1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    Promise.all(operation.input.map(function(subOperation) {
                                        return _this.mediatorQueryOperation.mediate({
                                            operation: subOperation,
                                            context: context
                                        });
                                    }))
                                ];
                            case 1:
                                outputsRaw = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = outputsRaw[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        output = _step.value;
                                        if (outputType === undefined) outputType = output.type;
                                        else if (outputType !== output.type) throw new Error("Unable to union ".concat(outputType, " and ").concat(output.type));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                // Handle bindings
                                if (outputType === 'bindings' || operation.input.length === 0) {
                                    outputs = outputsRaw.map($2n9RU.getSafeBindings);
                                    bindingsStream = new $aafx9.UnionIterator(outputs.map(function(output) {
                                        return output.bindingsStream;
                                    }), {
                                        autoStart: false
                                    });
                                    metadata = function() {
                                        return Promise.all(outputs.map(function(output) {
                                            return output.metadata();
                                        })).then(function(subMeta) {
                                            return ActorQueryOperationUnion.unionMetadata(subMeta, true, context, _this.mediatorRdfMetadataAccumulate);
                                        });
                                    };
                                    return [
                                        2,
                                        {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: metadata
                                        }
                                    ];
                                }
                                // Handle quads
                                if (outputType === 'quads') {
                                    outputs1 = outputsRaw.map($2n9RU.getSafeQuads);
                                    quadStream = new $aafx9.UnionIterator(outputs1.map(function(output) {
                                        return output.quadStream;
                                    }), {
                                        autoStart: false
                                    });
                                    metadata1 = function() {
                                        return Promise.all(outputs1.map(function(output) {
                                            return output.metadata();
                                        })).then(function(subMeta) {
                                            return ActorQueryOperationUnion.unionMetadata(subMeta, false, context, _this.mediatorRdfMetadataAccumulate);
                                        });
                                    };
                                    return [
                                        2,
                                        {
                                            type: 'quads',
                                            quadStream: quadStream,
                                            metadata: metadata1
                                        }
                                    ];
                                }
                                // Throw otherwise
                                throw new Error("Unable to union ".concat(outputType));
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "unionVariables",
            value: /**
     * Takes the union of the given double array variables.
     * Uniqueness is guaranteed.
     * @param {string[][]} variables Double array of variables to take the union of.
     * @return {string[]} The union of the given variables.
     */ function unionVariables(variables) {
                var variablesIndexed = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var variablesA = _step.value;
                        try {
                            for(var _iterator1 = variablesA[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var variable = _step1.value;
                                if (!variablesIndexed[variable.variable.value]) variablesIndexed[variable.variable.value] = {
                                    variable: variable.variable,
                                    canBeUndef: variable.canBeUndef,
                                    occurrences: 0
                                };
                                var entry = variablesIndexed[variable.variable.value];
                                entry.canBeUndef = entry.canBeUndef || variable.canBeUndef;
                                entry.occurrences++;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return Object.values(variablesIndexed).map(function(entry) {
                    return entry.occurrences === variables.length ? {
                        variable: entry.variable,
                        canBeUndef: entry.canBeUndef
                    } : {
                        variable: entry.variable,
                        canBeUndef: true
                    };
                });
            }
        },
        {
            key: "unionMetadata",
            value: /**
     * Takes the union of the given metadata array.
     * It will ensure that the cardinality metadata value is properly calculated.
     * @param {{[p: string]: any}[]} metadatas Array of metadata.
     * @param bindings If the union of the variables field should also be taken.
     * @param context The action context
     * @param mediatorRdfMetadataAccumulate Mediator for metadata accumulation
     * @return {{[p: string]: any}} Union of the metadata.
     */ function unionMetadata(metadatas, bindings, context, mediatorRdfMetadataAccumulate) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var accumulatedMetadata, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, appendingMetadata, _tmp, err, invalidateListener, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, metadata, variables;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    mediatorRdfMetadataAccumulate.mediate({
                                        mode: 'initialize',
                                        context: context
                                    })
                                ];
                            case 1:
                                accumulatedMetadata = _state.sent().metadata;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = metadatas[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                appendingMetadata = _step.value;
                                _tmp = [
                                    {},
                                    appendingMetadata
                                ];
                                return [
                                    4,
                                    mediatorRdfMetadataAccumulate.mediate({
                                        mode: 'append',
                                        accumulatedMetadata: accumulatedMetadata,
                                        appendingMetadata: appendingMetadata,
                                        context: context
                                    })
                                ];
                            case 4:
                                accumulatedMetadata = (0, $iT0je._).apply(void 0, _tmp.concat([
                                    _state.sent().metadata
                                ]));
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                // Create new metadata state
                                accumulatedMetadata.state = new $jZbVy.MetadataValidationState();
                                // Propagate metadata invalidations
                                invalidateListener = function() {
                                    return accumulatedMetadata.state.invalidate();
                                };
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = metadatas[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        metadata = _step1.value;
                                        metadata.state.addInvalidateListener(invalidateListener);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                // Union variables
                                if (bindings) {
                                    variables = metadatas.map(function(metadata) {
                                        return metadata.variables;
                                    });
                                    accumulatedMetadata.variables = ActorQueryOperationUnion.unionVariables(variables);
                                }
                                return [
                                    2,
                                    accumulatedMetadata
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ActorQueryOperationUnion;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationUnion = $23ac3a9125ad076e$var$ActorQueryOperationUnion;

});


parcelRegister("lnTNW", function(module, exports) {
"use strict";
var $f917089487143c3e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f917089487143c3e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f917089487143c3e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f917089487143c3e$var$__exportStar((parcelRequire("3JsBu")), module.exports);

});
parcelRegister("3JsBu", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathAlt = void 0;

var $jilFY = parcelRequire("jilFY");

var $b0tz5 = parcelRequire("b0tz5");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path Alt Query Operation Actor.
 */ var $2b7bc323f178cbaf$var$ActorQueryOperationPathAlt = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathAlt, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathAlt(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathAlt);
        return (0, $kzDuW._)(this, ActorQueryOperationPathAlt, [
            args,
            $hSHd8.Algebra.types.ALT
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathAlt, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, predicate, subOperations, bindingsStream, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                predicate = operation.predicate;
                                return [
                                    4,
                                    Promise.all(predicate.input.map(function(subPredicate) {
                                        return _this.mediatorQueryOperation.mediate({
                                            context: context,
                                            operation: algebraFactory.createPath(operation.subject, subPredicate, operation.object, operation.graph)
                                        });
                                    }))
                                ];
                            case 1:
                                subOperations = _state.sent().map($2n9RU.getSafeBindings);
                                bindingsStream = new $aafx9.UnionIterator(subOperations.map(function(op) {
                                    return op.bindingsStream;
                                }), {
                                    autoStart: false
                                });
                                metadata = function() {
                                    return Promise.all(subOperations.map(function(output) {
                                        return output.metadata();
                                    })).then(function(subMeta) {
                                        return $b0tz5.ActorQueryOperationUnion.unionMetadata(subMeta, true, context, _this.mediatorRdfMetadataAccumulate);
                                    });
                                };
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathAlt;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathAlt = $2b7bc323f178cbaf$var$ActorQueryOperationPathAlt;

});
parcelRegister("jilFY", function(module, exports) {
"use strict";
var $e0c0832a4e62f7ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e0c0832a4e62f7ae$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e0c0832a4e62f7ae$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e0c0832a4e62f7ae$var$__exportStar((parcelRequire("bX5pQ")), module.exports);

$e0c0832a4e62f7ae$var$__exportStar((parcelRequire("2nBLR")), module.exports);

});
parcelRegister("bX5pQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractPath = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");

var $hSHd8 = parcelRequire("hSHd8");

var $2nBLR = parcelRequire("2nBLR");
/**
 * An abstract actor that handles Path operations.
 *
 * Provides multiple helper functions used by the Path operation actors.
 */ var $8b3967e2562e622e$var$ActorAbstractPath = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorAbstractPath, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorAbstractPath(args, predicateType) {
        (0, $jGAMp._)(this, ActorAbstractPath);
        var _this;
        _this = (0, $kzDuW._)(this, ActorAbstractPath, [
            args,
            'path'
        ]);
        _this.predicateType = predicateType;
        return _this;
    }
    (0, $byiyg._)(ActorAbstractPath, [
        {
            key: "testOperation",
            value: function testOperation(operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (operation.predicate.type !== this.predicateType) return [
                            2,
                            (0, $kNNoa.failTest)("This Actor only supports ".concat(this.predicateType, " Path operations."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            // Generates a variable that does not yet occur in the path
            key: "generateVariable",
            value: function generateVariable(dataFactory, path, name) {
                if (!name) return this.generateVariable(dataFactory, path, 'b');
                // Path predicates can't contain variables
                if (path && (path.subject.value === name || path.object.value === name)) return this.generateVariable(dataFactory, path, "".concat(name, "b"));
                return dataFactory.variable(name);
            }
        },
        {
            key: "isPathArbitraryLengthDistinct",
            value: // Such connectivity matching does not introduce duplicates (it does not incorporate any count of the number
            // of ways the connection can be made) even if the repeated path itself would otherwise result in duplicates.
            // https://www.w3.org/TR/sparql11-query/#propertypaths
            function isPathArbitraryLengthDistinct(algebraFactory, context, path) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _tmp, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!context.get($9nBhR.KeysQueryOperation.isPathArbitraryLengthDistinctKey)) return [
                                    3,
                                    2
                                ];
                                context = context.set($9nBhR.KeysQueryOperation.isPathArbitraryLengthDistinctKey, true);
                                _tmp = {
                                    context: context
                                };
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: algebraFactory.createDistinct(path),
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.operation = _.apply(void 0, [
                                        _state.sent()
                                    ]), _tmp)
                                ];
                            case 2:
                                context = context.set($9nBhR.KeysQueryOperation.isPathArbitraryLengthDistinctKey, false);
                                return [
                                    2,
                                    {
                                        context: context,
                                        operation: undefined
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "predicateStarGraphVariable",
            value: function predicateStarGraphVariable(subject, object, predicate, graph, context, algebraFactory, bindingsFactory) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, sources, predVar, findGraphs, results, _, passedGraphs, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                sources = this.getPathSources(predicate);
                                // TODO: refactor this with an iterator just like PathVariableObjectIterator so we handle backpressure correctly
                                // Construct path to obtain all graphs where subject exists
                                predVar = this.generateVariable(algebraFactory.dataFactory, algebraFactory.createPath(subject, predicate, object, graph));
                                findGraphs = algebraFactory.createUnion([
                                    this.assignPatternSources(algebraFactory, algebraFactory.createPattern(subject, predVar, object, graph), sources),
                                    this.assignPatternSources(algebraFactory, algebraFactory.createPattern(object, predVar, subject, graph), sources)
                                ]);
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: findGraphs
                                    })
                                ];
                            case 1:
                                results = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                passedGraphs = new Set();
                                bindingsStream = new $aafx9.MultiTransformIterator(results.bindingsStream, {
                                    multiTransform: function(bindings) {
                                        // Extract the graph and start a predicate* search starting from subject in each graph
                                        var graphValue = bindings.get(graph);
                                        if (passedGraphs.has(graphValue.value)) return new $aafx9.EmptyIterator();
                                        passedGraphs.add(graphValue.value);
                                        return new $aafx9.TransformIterator(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var it;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            it = new $aafx9.BufferedIterator();
                                                            return [
                                                                4,
                                                                this.getObjectsPredicateStar(algebraFactory, subject, predicate, graphValue, context, {}, it, {
                                                                    count: 0
                                                                })
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                2,
                                                                it.map(function(item) {
                                                                    return bindingsFactory.bindings([
                                                                        [
                                                                            object,
                                                                            item
                                                                        ],
                                                                        [
                                                                            graph,
                                                                            graphValue
                                                                        ]
                                                                    ]);
                                                                })
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        }, {
                                            maxBufferSize: 128
                                        });
                                    },
                                    autoStart: false
                                });
                                return [
                                    2,
                                    {
                                        bindingsStream: bindingsStream,
                                        metadata: results.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getObjectsPredicateStarEval",
            value: /**
     * Returns an iterator with Bindings of the query subject predicate* ?o or subject predicate+ ?o
     * If graph is a variable, it will also be in those bindings
     * @param {Term} subject Term of where we start the predicate* search.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Variable} object Variable of the zeroOrMore-query.
     * @param {Term} graph The graph in which we search for the pattern. (Possibly a variable)
     * @param {ActionContext} context The context to pass to sub-opertations
     * @param emitFirstSubject If the path operation is predicate*, otherwise it is predicate+.
     * @param algebraFactory The algebra factory.
     * @param bindingsFactory The data factory.
     * @return {Promise<AsyncIterator<Bindings>} Iterator to where all bindings of query should have been pushed.
     */ function getObjectsPredicateStarEval(subject, predicate, object, graph, context, emitFirstSubject, algebraFactory, bindingsFactory) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var it, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (graph.termType === 'Variable') return [
                            2,
                            this.predicateStarGraphVariable(subject, object, predicate, graph, context, algebraFactory, bindingsFactory)
                        ];
                        it = new $2nBLR.PathVariableObjectIterator(algebraFactory, subject, predicate, graph, context, this.mediatorQueryOperation, emitFirstSubject);
                        bindingsStream = it.map(function(item) {
                            return bindingsFactory.bindings([
                                [
                                    object,
                                    item
                                ]
                            ]);
                        });
                        return [
                            2,
                            {
                                bindingsStream: bindingsStream,
                                metadata: function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var metadata;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            it.getProperty('metadata', function(metadataInner) {
                                                                return resolve(metadataInner());
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    metadata = _state.sent();
                                                    // Increment cardinality by one, because we always have at least one result once we reach this stage.
                                                    // See the transformation above where we push a single binding.
                                                    metadata.cardinality.value++;
                                                    return [
                                                        2,
                                                        metadata
                                                    ];
                                            }
                                        });
                                    })();
                                }
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getObjectsPredicateStar",
            value: /**
     * Pushes all terms to iterator `it` that are a solution of object predicate* ?o.
     * @param algebraFactory The algebra factory.
     * @param {Term} object Term of where we start the predicate* search.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Term} graph The graph in which we search for the pattern.
     * @param {ActionContext} context
     * @param {Record<string, Term>} termHashes Remembers the objects we've already searched for.
     * @param {BufferedIterator<Term>} it Iterator to push terms to.
     * @param {any} counter Counts how many searches are in progress to close it when needed (when counter == 0).
     * @return {Promise<IPathResultStream['metadata']>} The results metadata.
     */ function getObjectsPredicateStar(algebraFactory, object, predicate, graph, context, termHashes, it, counter) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, termString, thisVariable, path, results, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                termString = (0, $gQYIc.termToString)(object);
                                if (termHashes[termString]) return [
                                    2
                                ];
                                it._push(object);
                                termHashes[termString] = object;
                                counter.count++;
                                thisVariable = this.generateVariable(algebraFactory.dataFactory);
                                path = algebraFactory.createPath(object, predicate, thisVariable, graph);
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: path,
                                        context: context
                                    })
                                ];
                            case 1:
                                results = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                // TODO: fixme
                                // eslint-disable-next-line ts/no-misused-promises
                                results.bindingsStream.on('data', function(bindings) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var result;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    result = bindings.get(thisVariable);
                                                    return [
                                                        4,
                                                        this.getObjectsPredicateStar(algebraFactory, result, predicate, graph, context, termHashes, it, counter)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                });
                                results.bindingsStream.on('end', function() {
                                    if (--counter.count === 0) it.close();
                                });
                                return [
                                    2,
                                    results.metadata
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSubjectAndObjectBindingsPredicateStar",
            value: /**
     * Pushes all terms to iterator `it` that are a solution of ?s predicate* ?o.
     * @param {string} subjectVar String representation of subjectVariable
     * @param {string} objectVar String representation of objectVariable
     * @param {Term} subjectVal Term of where we start the predicate* search.
     * @param {Term} objectVal Found solution for an object, start for the new step.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Term} graph The graph in which we search for the pattern.
     * @param {ActionContext} context
     * @param {{[id: string]: Promise<Term[]>}} termHashesGlobal
     * Remembers solutions for when objectVal is already been calculated, can be reused when same objectVal occurs
     * @param {{[id: string]: Term}} termHashesCurrentSubject
     * Remembers the pairs we've already searched for, can stop searching if so.
     * @param {BufferedIterator<Bindings>} it Iterator to push terms to.
     * @param {any} counter Counts how many searches are in progress to close it when needed (when counter == 0).
     * @param algebraFactory The algebra factory.
     * @param bindingsFactory The bindings factory.
     * @return {Promise<void>} All solutions of query should have been pushed to it by then.
     */ // Let the iterator `it` emit all bindings of size 2, with subjectStringVariable as value subjectVal
            // and objectStringVariable as value all nodes reachable through predicate* beginning at objectVal
            function getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, objectVal, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, termString, objects, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, object, err, promise;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                termString = (0, $gQYIc.termToString)(objectVal) + (0, $gQYIc.termToString)(graph);
                                // If this combination of subject and object already done, return nothing
                                if (termHashesCurrentSubject[termString]) return [
                                    2
                                ];
                                counter.count++;
                                termHashesCurrentSubject[termString] = true;
                                it._push(bindingsFactory.bindings([
                                    [
                                        subjectVar,
                                        subjectVal
                                    ],
                                    [
                                        objectVar,
                                        objectVal
                                    ]
                                ]));
                                if (!(termString in termHashesGlobal)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    termHashesGlobal[termString]
                                ];
                            case 1:
                                objects = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = objects[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                object = _step.value;
                                return [
                                    4,
                                    this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, object, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                if (--counter.count === 0) it.close();
                                return [
                                    2
                                ];
                            case 10:
                                // Construct promise to calculate all reachable nodes from this object
                                // TODO: fixme
                                // eslint-disable-next-line no-async-promise-executor,ts/no-misused-promises
                                promise = new Promise(function(resolve, reject) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var _this, objectsArray, thisVariable, path, results, _;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _this = this;
                                                    objectsArray = [];
                                                    // Construct path that leads us one step through predicate
                                                    thisVariable = this.generateVariable(algebraFactory.dataFactory);
                                                    path = algebraFactory.createPath(objectVal, predicate, thisVariable, graph);
                                                    _ = (0, $2n9RU.getSafeBindings);
                                                    return [
                                                        4,
                                                        this.mediatorQueryOperation.mediate({
                                                            operation: path,
                                                            context: context
                                                        })
                                                    ];
                                                case 1:
                                                    results = _.apply(void 0, [
                                                        _state.sent()
                                                    ]);
                                                    // Recursive call on all neighbours
                                                    // TODO: fixme
                                                    // eslint-disable-next-line ts/no-misused-promises
                                                    results.bindingsStream.on('data', function(bindings) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                            var result;
                                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        result = bindings.get(thisVariable);
                                                                        objectsArray.push(result);
                                                                        return [
                                                                            4,
                                                                            this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, result, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        }).call(_this);
                                                    });
                                                    results.bindingsStream.on('error', reject);
                                                    results.bindingsStream.on('end', function() {
                                                        if (--counter.count === 0) it.close();
                                                        resolve(objectsArray);
                                                    });
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                });
                                // Set it in the termHashesGlobal when this object occurs again they can wait for this promise
                                termHashesGlobal[termString] = promise;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Find all sources recursively contained in the given path operation.
     * @param operation
     */ key: "getPathSources",
            value: function getPathSources(operation) {
                var _this = this;
                switch(operation.type){
                    case $hSHd8.Algebra.types.ALT:
                    case $hSHd8.Algebra.types.SEQ:
                        return operation.input.flatMap(function(subOp) {
                            return _this.getPathSources(subOp);
                        });
                    case $hSHd8.Algebra.types.INV:
                    case $hSHd8.Algebra.types.ONE_OR_MORE_PATH:
                    case $hSHd8.Algebra.types.ZERO_OR_MORE_PATH:
                    case $hSHd8.Algebra.types.ZERO_OR_ONE_PATH:
                        return this.getPathSources(operation.path);
                    case $hSHd8.Algebra.types.LINK:
                    case $hSHd8.Algebra.types.NPS:
                        {
                            var source = (0, $2n9RU.getOperationSource)(operation);
                            if (!source) throw new Error("Could not find a required source on a link path operation");
                            return [
                                source
                            ];
                        }
                }
            }
        },
        {
            key: "assignPatternSources",
            value: function assignPatternSources(algebraFactory, pattern, sources) {
                if (sources.length === 0) throw new Error("Attempted to assign zero sources to a pattern during property path handling");
                if (sources.length === 1) return (0, $2n9RU.assignOperationSource)(pattern, sources[0]);
                return algebraFactory.createUnion(sources.map(function(source) {
                    return (0, $2n9RU.assignOperationSource)(pattern, source);
                }), true);
            }
        }
    ]);
    return ActorAbstractPath;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorAbstractPath = $8b3967e2562e622e$var$ActorAbstractPath;

});
parcelRegister("2nBLR", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PathVariableObjectIterator = void 0;

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");
/**
 * An iterator that implements the multi-length property path operation (* and +)
 * for a fixed subject and predicate, and a variable object.
 */ var $1bbb074aefccc90e$var$PathVariableObjectIterator = /*#__PURE__*/ function(_asynciterator_1_BufferedIterator) {
    (0, $i3fW3._)(PathVariableObjectIterator, _asynciterator_1_BufferedIterator);
    function PathVariableObjectIterator(algebraFactory, subject, predicate, graph, context, mediatorQueryOperation, emitFirstSubject) {
        var maxRunningOperations = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 16;
        (0, $jGAMp._)(this, PathVariableObjectIterator);
        var _this;
        _this = (0, $kzDuW._)(this, PathVariableObjectIterator, [
            {
                autoStart: false
            }
        ]);
        _this.algebraFactory = algebraFactory;
        _this.subject = subject;
        _this.predicate = predicate;
        _this.graph = graph;
        _this.context = context;
        _this.mediatorQueryOperation = mediatorQueryOperation;
        _this.maxRunningOperations = maxRunningOperations;
        _this.termHashes = new Map();
        _this.runningOperations = [];
        _this.pendingOperations = [];
        _this.started = false;
        // Push the subject as starting point
        _this._push(_this.subject, emitFirstSubject);
        return _this;
    }
    (0, $byiyg._)(PathVariableObjectIterator, [
        {
            key: "getProperty",
            value: function getProperty(propertyName, callback) {
                var _this = this;
                // Kickstart iterator when metadata is requested
                if (!this.started && propertyName === 'metadata') this.startNextOperation(false)["catch"](function(error) {
                    return _this.emit('error', error);
                });
                return (0, $fXhL4._)((0, $hxFDX._)(PathVariableObjectIterator.prototype), "getProperty", this).call(this, propertyName, callback);
            }
        },
        {
            key: "_end",
            value: function _end(destroy) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Close all running iterators
                    for(var _iterator = this.runningOperations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var it = _step.value;
                        it.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                (0, $fXhL4._)((0, $hxFDX._)(PathVariableObjectIterator.prototype), "_end", this).call(this, destroy);
            }
        },
        {
            key: "_push",
            value: function _push(item) {
                var pushAsResult = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var termString;
                if (pushAsResult) {
                    // Don't push if this subject was already found
                    termString = (0, $gQYIc.termToString)(item);
                    if (this.termHashes.has(termString)) return false;
                }
                // Add a pending path operation for this item
                var variable = this.algebraFactory.dataFactory.variable('b');
                this.pendingOperations.push({
                    variable: variable,
                    operation: this.algebraFactory.createPath(item, this.predicate, variable, this.graph)
                });
                // Otherwise, push the subject
                if (termString) {
                    this.termHashes.set(termString, item);
                    (0, $fXhL4._)((0, $hxFDX._)(PathVariableObjectIterator.prototype), "_push", this).call(this, item);
                }
                return true;
            }
        },
        {
            key: "startNextOperation",
            value: function startNextOperation(fillBuffer) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, pendingOperation, results, _, runningOperation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.started = true;
                                pendingOperation = this.pendingOperations.pop();
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: pendingOperation.operation,
                                        context: this.context
                                    })
                                ];
                            case 1:
                                results = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                runningOperation = results.bindingsStream.map(function(bindings) {
                                    return bindings.get(pendingOperation.variable);
                                });
                                if (!runningOperation.done) {
                                    this.runningOperations.push(runningOperation);
                                    runningOperation.on('error', function(error) {
                                        return _this.destroy(error);
                                    });
                                    runningOperation.on('readable', function() {
                                        if (fillBuffer) _this._fillBufferAsync();
                                        _this.readable = true;
                                    });
                                    runningOperation.on('end', function() {
                                        _this.runningOperations.splice(_this.runningOperations.indexOf(runningOperation), 1);
                                        if (fillBuffer) _this._fillBufferAsync();
                                        _this.readable = true;
                                    });
                                }
                                if (!this.getProperty('metadata')) this.setProperty('metadata', results.metadata);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_read",
            value: function _read(count, done) {
                var _this = this;
                // eslint-disable-next-line ts/no-this-alias
                var self = this;
                (function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var lastCount, item, pushSucceeded, i;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(self.runningOperations.length < self.maxRunningOperations)) return [
                                        3,
                                        2
                                    ];
                                    if (self.pendingOperations.length === 0) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        self.startNextOperation(true)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        0
                                    ];
                                case 2:
                                    // Try to read `count` items (based on UnionIterator)
                                    lastCount = 0;
                                    pushSucceeded = true;
                                    // eslint-disable-next-line no-cond-assign
                                    while(!pushSucceeded || lastCount !== (lastCount = count)){
                                        pushSucceeded = true;
                                        // Prioritize the operations that have been added first
                                        for(i = 0; i < self.runningOperations.length && count > 0; i++)// eslint-disable-next-line no-cond-assign
                                        if ((item = self.runningOperations[i].read()) !== null) {
                                            if (self._push(item)) count--;
                                            else pushSucceeded = false;
                                        }
                                    }
                                    // Close if everything has been read
                                    self.closeIfNeeded();
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                })().then(function() {
                    done();
                }, function(error) {
                    return _this.destroy(error);
                });
            }
        },
        {
            key: "closeIfNeeded",
            value: function closeIfNeeded() {
                if (this.runningOperations.length === 0 && this.pendingOperations.length === 0) this.close();
            }
        }
    ]);
    return PathVariableObjectIterator;
}($aafx9.BufferedIterator);
module.exports.PathVariableObjectIterator = $1bbb074aefccc90e$var$PathVariableObjectIterator;

});





parcelRegister("1sViH", function(module, exports) {
"use strict";
var $1114daac2bb9768c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1114daac2bb9768c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1114daac2bb9768c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1114daac2bb9768c$var$__exportStar((parcelRequire("agPYX")), module.exports);

});
parcelRegister("agPYX", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathInv = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path Inv Query Operation Actor.
 */ var $77a3b8982ab7bc17$var$ActorQueryOperationPathInv = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathInv, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathInv(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathInv);
        return (0, $kzDuW._)(this, ActorQueryOperationPathInv, [
            args,
            $hSHd8.Algebra.types.INV
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathInv, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, predicate, invPath;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        predicate = operation.predicate;
                        invPath = algebraFactory.createPath(operation.object, predicate.path, operation.subject, operation.graph);
                        return [
                            2,
                            this.mediatorQueryOperation.mediate({
                                operation: invPath,
                                context: context
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathInv;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathInv = $77a3b8982ab7bc17$var$ActorQueryOperationPathInv;

});


parcelRegister("f0mIM", function(module, exports) {
"use strict";
var $aec87b17d8ed7021$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aec87b17d8ed7021$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aec87b17d8ed7021$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aec87b17d8ed7021$var$__exportStar((parcelRequire("8I6yg")), module.exports);

});
parcelRegister("8I6yg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathLink = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path Link Query Operation Actor.
 */ var $657783d4a932ec42$var$ActorQueryOperationPathLink = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathLink, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathLink(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathLink);
        return (0, $kzDuW._)(this, ActorQueryOperationPathLink, [
            args,
            $hSHd8.Algebra.types.LINK
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathLink, [
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, predicate, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        predicate = operationOriginal.predicate;
                        operation = Object.assign(algebraFactory.createPattern(operationOriginal.subject, predicate.iri, operationOriginal.object, operationOriginal.graph), {
                            metadata: predicate.metadata
                        });
                        return [
                            2,
                            this.mediatorQueryOperation.mediate({
                                operation: operation,
                                context: context
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathLink;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathLink = $657783d4a932ec42$var$ActorQueryOperationPathLink;

});


parcelRegister("fGvp1", function(module, exports) {
"use strict";
var $b6b32329a7ed3d1d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b6b32329a7ed3d1d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b6b32329a7ed3d1d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b6b32329a7ed3d1d$var$__exportStar((parcelRequire("eCaKE")), module.exports);

});
parcelRegister("eCaKE", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathNps = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path Nps Query Operation Actor.
 */ var $aa3cf448cfd7dbc2$var$ActorQueryOperationPathNps = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathNps, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathNps(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathNps);
        return (0, $kzDuW._)(this, ActorQueryOperationPathNps, [
            args,
            $hSHd8.Algebra.types.NPS
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathNps, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, predicate, blank, pattern, output, _, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                predicate = operation.predicate;
                                blank = this.generateVariable(dataFactory, operation);
                                pattern = Object.assign(algebraFactory.createPattern(operation.subject, blank, operation.object, operation.graph), {
                                    metadata: predicate.metadata
                                });
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: pattern,
                                        context: context
                                    })
                                ];
                            case 1:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                // Remove the generated blank nodes from the bindings
                                bindingsStream = output.bindingsStream.map(function(bindings) {
                                    return predicate.iris.some(function(iri) {
                                        return iri.equals(bindings.get(blank));
                                    }) ? null : bindings["delete"](blank);
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: output.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathNps;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathNps = $aa3cf448cfd7dbc2$var$ActorQueryOperationPathNps;

});


parcelRegister("ll55X", function(module, exports) {
"use strict";
var $f88f82e7e775ef3b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f88f82e7e775ef3b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f88f82e7e775ef3b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f88f82e7e775ef3b$var$__exportStar((parcelRequire("aRz1H")), module.exports);

});
parcelRegister("aRz1H", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationClear = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL clear operations.
 */ var $7e8a062364295567$var$ActorQueryOperationClear = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationClear, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationClear(args) {
        (0, $jGAMp._)(this, ActorQueryOperationClear);
        return (0, $kzDuW._)(this, ActorQueryOperationClear, [
            args,
            'clear'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationClear, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, graphs, execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                if (operation.source === 'DEFAULT') graphs = dataFactory.defaultGraph();
                                else if (typeof operation.source === 'string') graphs = operation.source;
                                else graphs = [
                                    operation.source
                                ];
                                return [
                                    4,
                                    this.mediatorUpdateQuads.mediate({
                                        deleteGraphs: {
                                            graphs: graphs,
                                            requireExistence: !operation.silent,
                                            dropGraphs: false
                                        },
                                        context: context
                                    })
                                ];
                            case 1:
                                execute = _state.sent().execute;
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: execute
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationClear;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationClear = $7e8a062364295567$var$ActorQueryOperationClear;

});


parcelRegister("i2UmV", function(module, exports) {
"use strict";
var $d234238ae4b13992$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d234238ae4b13992$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d234238ae4b13992$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d234238ae4b13992$var$__exportStar((parcelRequire("03fJS")), module.exports);

});
parcelRegister("03fJS", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUpdateCompositeUpdate = void 0;

var $dng5S = parcelRequire("dng5S");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Update CompositeUpdate Query Operation Actor.
 */ var $009c7d5f562fa229$var$ActorQueryOperationUpdateCompositeUpdate = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationUpdateCompositeUpdate, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationUpdateCompositeUpdate(args) {
        (0, $jGAMp._)(this, ActorQueryOperationUpdateCompositeUpdate);
        return (0, $kzDuW._)(this, ActorQueryOperationUpdateCompositeUpdate, [
            args,
            'compositeupdate'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationUpdateCompositeUpdate, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        execute = function() {
                            return function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, operation, subResult, _, err;
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    7,
                                                    8,
                                                    9
                                                ]);
                                                _iterator = operationOriginal.updates[Symbol.iterator]();
                                                _state.label = 2;
                                            case 2:
                                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                    3,
                                                    6
                                                ];
                                                operation = _step.value;
                                                _ = (0, $2n9RU.getSafeVoid);
                                                return [
                                                    4,
                                                    this.mediatorQueryOperation.mediate({
                                                        operation: operation,
                                                        context: context
                                                    })
                                                ];
                                            case 3:
                                                subResult = _.apply(void 0, [
                                                    _state.sent()
                                                ]);
                                                return [
                                                    4,
                                                    subResult.execute()
                                                ];
                                            case 4:
                                                _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                _iteratorNormalCompletion = true;
                                                return [
                                                    3,
                                                    2
                                                ];
                                            case 6:
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 7:
                                                err = _state.sent();
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 8:
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                                return [
                                                    7
                                                ];
                                            case 9:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }).call(_this);
                            }();
                        };
                        return [
                            2,
                            {
                                type: 'void',
                                execute: execute
                            }
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationUpdateCompositeUpdate;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationUpdateCompositeUpdate = $009c7d5f562fa229$var$ActorQueryOperationUpdateCompositeUpdate;

});


parcelRegister("98dBy", function(module, exports) {
"use strict";
var $6a5f6a0185fa1c77$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6a5f6a0185fa1c77$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6a5f6a0185fa1c77$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6a5f6a0185fa1c77$var$__exportStar((parcelRequire("hAEjl")), module.exports);

});
parcelRegister("hAEjl", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationCreate = void 0;

var $dng5S = parcelRequire("dng5S");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor that
 * handles SPARQL create operations.
 */ var $cce5115f6442a83f$var$ActorQueryOperationCreate = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationCreate, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationCreate(args) {
        (0, $jGAMp._)(this, ActorQueryOperationCreate);
        return (0, $kzDuW._)(this, ActorQueryOperationCreate, [
            args,
            'create'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationCreate, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorUpdateQuads.mediate({
                                        createGraphs: {
                                            graphs: [
                                                operation.source
                                            ],
                                            requireNonExistence: !operation.silent
                                        },
                                        context: context
                                    })
                                ];
                            case 1:
                                execute = _state.sent().execute;
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: execute
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationCreate;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationCreate = $cce5115f6442a83f$var$ActorQueryOperationCreate;

});


parcelRegister("f9vSY", function(module, exports) {
"use strict";
var $b0806e20cd6be132$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b0806e20cd6be132$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b0806e20cd6be132$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b0806e20cd6be132$var$__exportStar((parcelRequire("iI6ve")), module.exports);

});
parcelRegister("iI6ve", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationDrop = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL drop operations.
 */ var $d9f16157ac16a25a$var$ActorQueryOperationDrop = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationDrop, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationDrop(args) {
        (0, $jGAMp._)(this, ActorQueryOperationDrop);
        return (0, $kzDuW._)(this, ActorQueryOperationDrop, [
            args,
            'drop'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationDrop, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, graphs, execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                if (operation.source === 'DEFAULT') graphs = dataFactory.defaultGraph();
                                else if (typeof operation.source === 'string') graphs = operation.source;
                                else graphs = [
                                    operation.source
                                ];
                                return [
                                    4,
                                    this.mediatorUpdateQuads.mediate({
                                        deleteGraphs: {
                                            graphs: graphs,
                                            requireExistence: !operation.silent,
                                            dropGraphs: true
                                        },
                                        context: context
                                    })
                                ];
                            case 1:
                                execute = _state.sent().execute;
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: execute
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationDrop;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationDrop = $d9f16157ac16a25a$var$ActorQueryOperationDrop;

});


parcelRegister("guyUf", function(module, exports) {
"use strict";
var $c01a8659c900e4c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c01a8659c900e4c6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c01a8659c900e4c6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c01a8659c900e4c6$var$__exportStar((parcelRequire("iQ2zr")), module.exports);

});
parcelRegister("iQ2zr", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationLoad = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL load operations.
 */ var $db6f13c6a486fad5$var$ActorQueryOperationLoad = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationLoad, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationLoad(args) {
        (0, $jGAMp._)(this, ActorQueryOperationLoad);
        return (0, $kzDuW._)(this, ActorQueryOperationLoad, [
            args,
            'load'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationLoad, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, subContext, querySource, output, _, quadStream, execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                // Determine query source
                                subContext = context;
                                if (operation.silent) subContext = subContext.set($9nBhR.KeysInitQuery.lenient, true);
                                return [
                                    4,
                                    this.mediatorQuerySourceIdentify.mediate({
                                        querySourceUnidentified: {
                                            value: operation.source.value
                                        },
                                        context: subContext
                                    })
                                ];
                            case 1:
                                querySource = _state.sent().querySource;
                                _ = (0, $2n9RU.getSafeQuads);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: algebraFactory.createConstruct((0, $2n9RU.assignOperationSource)(algebraFactory.createPattern(dataFactory.variable('s'), dataFactory.variable('p'), dataFactory.variable('o')), querySource), [
                                            algebraFactory.createPattern(dataFactory.variable('s'), dataFactory.variable('p'), dataFactory.variable('o'))
                                        ]),
                                        context: subContext
                                    })
                                ];
                            case 2:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                // Determine quad stream to insert
                                quadStream = output.quadStream;
                                if (operation.destination) quadStream = quadStream.map(function(quad) {
                                    return dataFactory.quad(quad.subject, quad.predicate, quad.object, operation.destination);
                                });
                                return [
                                    4,
                                    this.mediatorUpdateQuads.mediate({
                                        quadStreamInsert: quadStream,
                                        context: context
                                    })
                                ];
                            case 3:
                                execute = _state.sent().execute;
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: execute
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationLoad;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationLoad = $db6f13c6a486fad5$var$ActorQueryOperationLoad;

});


parcelRegister("fD2Tn", function(module, exports) {
"use strict";
var $b60cbdd8dedae55a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b60cbdd8dedae55a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b60cbdd8dedae55a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b60cbdd8dedae55a$var$__exportStar((parcelRequire("72nAa")), module.exports);

});
parcelRegister("72nAa", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationJoin = void 0;

var $dng5S = parcelRequire("dng5S");

var $17TpP = parcelRequire("17TpP");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $2ej16 = parcelRequire("2ej16");
/**
 * A comunica Join Query Operation Actor.
 */ var $51fb034279dcffb8$var$ActorQueryOperationJoin = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationJoin, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationJoin(args) {
        (0, $jGAMp._)(this, ActorQueryOperationJoin);
        return (0, $kzDuW._)(this, ActorQueryOperationJoin, [
            args,
            'join'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationJoin, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, entries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    Promise.all(operationOriginal.input.map(function(subOperation) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            this.mediatorQueryOperation.mediate({
                                                                operation: subOperation,
                                                                context: context
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.output = _state.sent(), _tmp.operation = subOperation, _tmp)
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 1:
                                entries = _state.sent().map(function(param) {
                                    var output = param.output, operation = param.operation;
                                    return {
                                        output: (0, $2n9RU.getSafeBindings)(output),
                                        operation: operation
                                    };
                                });
                                return [
                                    4,
                                    Promise.all(entries.map(function(entry) {
                                        return entry.output.metadata();
                                    }))
                                ];
                            case 2:
                                // Return immediately if one of the join entries has cardinality zero, to avoid actor testing overhead.
                                if (_state.sent().some(function(entry) {
                                    return entry.cardinality.value === 0 && entry.cardinality.type === 'exact';
                                })) {
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = entries[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            entry = _step.value;
                                            entry.output.bindingsStream.close();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                _iterator["return"]();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return [
                                        2,
                                        {
                                            bindingsStream: new $aafx9.ArrayIterator([], {
                                                autoStart: false
                                            }),
                                            metadata: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    var _tmp, _, _1, _tmp1;
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _tmp = {
                                                                    state: new $jZbVy.MetadataValidationState(),
                                                                    cardinality: {
                                                                        type: 'exact',
                                                                        value: 0
                                                                    }
                                                                };
                                                                _1 = (_ = $17TpP.ActorRdfJoin).joinVariables;
                                                                _tmp1 = [
                                                                    new $2ej16.DataFactory()
                                                                ];
                                                                return [
                                                                    4,
                                                                    $17TpP.ActorRdfJoin.getMetadatas(entries)
                                                                ];
                                                            case 1:
                                                                return [
                                                                    2,
                                                                    (_tmp.variables = _1.apply(_, _tmp1.concat([
                                                                        _state.sent()
                                                                    ])), _tmp)
                                                                ];
                                                        }
                                                    });
                                                })();
                                            },
                                            type: 'bindings'
                                        }
                                    ];
                                }
                                return [
                                    2,
                                    this.mediatorJoin.mediate({
                                        type: 'inner',
                                        entries: entries,
                                        context: context
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationJoin;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationJoin = $51fb034279dcffb8$var$ActorQueryOperationJoin;

});


parcelRegister("hXK5w", function(module, exports) {
"use strict";
var $d13bb27634931c41$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d13bb27634931c41$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d13bb27634931c41$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d13bb27634931c41$var$__exportStar((parcelRequire("lyK5D")), module.exports);

});
parcelRegister("lyK5D", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationLeftJoin = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $aduX6 = parcelRequire("aduX6");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica LeftJoin Query Operation Actor.
 */ var $fb208672bf9b0c4c$var$ActorQueryOperationLeftJoin = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationLeftJoin, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationLeftJoin(args) {
        (0, $jGAMp._)(this, ActorQueryOperationLeftJoin);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationLeftJoin, [
            args,
            'leftjoin'
        ]);
        _this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationLeftJoin, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, entries, joined, rightMetadata, expressionVariables, evaluator, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    Promise.all(operationOriginal.input.map(function(subOperation) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            this.mediatorQueryOperation.mediate({
                                                                operation: subOperation,
                                                                context: context
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.output = _state.sent(), _tmp.operation = subOperation, _tmp)
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 1:
                                entries = _state.sent().map(function(param) {
                                    var output = param.output, operation = param.operation;
                                    return {
                                        output: (0, $2n9RU.getSafeBindings)(output),
                                        operation: operation
                                    };
                                });
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: 'optional',
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 2:
                                joined = _state.sent();
                                if (!operationOriginal.expression) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    entries[1].output.metadata()
                                ];
                            case 3:
                                rightMetadata = _state.sent();
                                expressionVariables = rightMetadata.variables;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: operationOriginal.expression,
                                        context: context
                                    })
                                ];
                            case 4:
                                evaluator = _state.sent();
                                bindingsStream = joined.bindingsStream.transform({
                                    autoStart: false,
                                    // eslint-disable-next-line ts/no-misused-promises
                                    transform: function(bindings, done, push) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var result, error;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        // If variables of the right-hand entry are missing, we skip expression evaluation
                                                        if (!expressionVariables.every(function(variable) {
                                                            return bindings.has(variable.variable.value);
                                                        })) {
                                                            push(bindings);
                                                            return [
                                                                2,
                                                                done()
                                                            ];
                                                        }
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            evaluator.evaluateAsEBV(bindings)
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        if (result) push(bindings);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        error = _state.sent();
                                                        // We ignore all Expression errors.
                                                        // Other errors (likely programming mistakes) are still propagated.
                                                        // Left Join is defined in terms of Filter (https://www.w3.org/TR/sparql11-query/#defn_algJoin),
                                                        // and Filter requires this (https://www.w3.org/TR/sparql11-query/#expressions).
                                                        if ((0, $aduX6.isExpressionError)(error)) // In many cases, this is a user error, where the user should manually cast the variable to a string.
                                                        // In order to help users debug this, we should report these errors via the logger as warnings.
                                                        this.logWarn(context, 'Error occurred while filtering.', function() {
                                                            return {
                                                                error: error,
                                                                bindings: (0, $itFzw.bindingsToString)(bindings)
                                                            };
                                                        });
                                                        else bindingsStream.emit('error', error);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        done();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }
                                });
                                joined.bindingsStream = bindingsStream;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    joined
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationLeftJoin;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationLeftJoin = $fb208672bf9b0c4c$var$ActorQueryOperationLeftJoin;

});


parcelRegister("7HHhd", function(module, exports) {
"use strict";
var $59be1e6b35022780$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59be1e6b35022780$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $59be1e6b35022780$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$59be1e6b35022780$var$__exportStar((parcelRequire("cL2pI")), module.exports);

});
parcelRegister("cL2pI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationMinus = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");
/**
 * A comunica Minus Query Operation Actor.
 */ var $949bbf2979792847$var$ActorQueryOperationMinus = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationMinus, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationMinus(args) {
        (0, $jGAMp._)(this, ActorQueryOperationMinus);
        return (0, $kzDuW._)(this, ActorQueryOperationMinus, [
            args,
            'minus'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationMinus, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, entries;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    Promise.all(operationOriginal.input.map(function(subOperation) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            this.mediatorQueryOperation.mediate({
                                                                operation: subOperation,
                                                                context: context
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.output = _state.sent(), _tmp.operation = subOperation, _tmp)
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 1:
                                entries = _state.sent().map(function(param) {
                                    var output = param.output, operation = param.operation;
                                    return {
                                        output: (0, $2n9RU.getSafeBindings)(output),
                                        operation: operation
                                    };
                                });
                                return [
                                    2,
                                    this.mediatorJoin.mediate({
                                        type: 'minus',
                                        entries: entries,
                                        context: context
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationMinus;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationMinus = $949bbf2979792847$var$ActorQueryOperationMinus;

});


parcelRegister("ka5nq", function(module, exports) {
"use strict";
var $ead8e98c5b1c1e1c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ead8e98c5b1c1e1c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ead8e98c5b1c1e1c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ead8e98c5b1c1e1c$var$__exportStar((parcelRequire("coX5l")), module.exports);

});
parcelRegister("coX5l", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathSeq = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path Seq Query Operation Actor.
 */ var $90758f0638335005$var$ActorQueryOperationPathSeq = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathSeq, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathSeq(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathSeq);
        return (0, $kzDuW._)(this, ActorQueryOperationPathSeq, [
            args,
            $hSHd8.Algebra.types.SEQ
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathSeq, [
        {
            key: "runOperation",
            value: function runOperation(operationOriginal, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, predicate, joiner, generatedVariableNames, entries, join, _, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                predicate = operationOriginal.predicate;
                                joiner = operationOriginal.subject;
                                generatedVariableNames = [];
                                return [
                                    4,
                                    Promise.all(predicate.input.map(function(subPredicate, i) {
                                        var nextJoiner = i === predicate.input.length - 1 ? operationOriginal.object : _this.generateVariable(dataFactory, operationOriginal, "b".concat(i));
                                        var operation = algebraFactory.createPath(joiner, subPredicate, nextJoiner, operationOriginal.graph);
                                        var output = _this.mediatorQueryOperation.mediate({
                                            context: context,
                                            operation: operation
                                        });
                                        joiner = nextJoiner;
                                        if (i < predicate.input.length - 1) generatedVariableNames.push(nextJoiner);
                                        return {
                                            output: output,
                                            operation: operation
                                        };
                                    }).map(function(param) {
                                        var output = param.output, operation = param.operation;
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp, _;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        _ = (0, $2n9RU.getSafeBindings);
                                                        return [
                                                            4,
                                                            output
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.output = _.apply(void 0, [
                                                                _state.sent()
                                                            ]), _tmp.operation = operation, _tmp)
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 1:
                                entries = _state.sent();
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: 'inner',
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 2:
                                join = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                // Remove the generated variable from the bindings
                                bindingsStream = join.bindingsStream.transform({
                                    transform: function(item, next, push) {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = generatedVariableNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var generatedVariableName = _step.value;
                                                item = item["delete"](generatedVariableName);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                    _iterator["return"]();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        push(item);
                                        next();
                                    }
                                });
                                // Remove the generated variable from the list of variables
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var joinMetadata, variables;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                join.metadata()
                                                            ];
                                                        case 1:
                                                            joinMetadata = _state.sent();
                                                            variables = joinMetadata.variables.filter(function(variable) {
                                                                return !generatedVariableNames.some(function(generatedVariableName) {
                                                                    return generatedVariableName.value === variable.variable.value;
                                                                });
                                                            });
                                                            return [
                                                                2,
                                                                (0, $emQHU._)((0, $iT0je._)({}, joinMetadata), {
                                                                    variables: variables
                                                                })
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathSeq;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathSeq = $90758f0638335005$var$ActorQueryOperationPathSeq;

});


parcelRegister("9Z4Pv", function(module, exports) {
"use strict";
var $744d8ea04b733564$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $744d8ea04b733564$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $744d8ea04b733564$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$744d8ea04b733564$var$__exportStar((parcelRequire("jHSAA")), module.exports);

});
parcelRegister("jHSAA", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiSmallest = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A Multi Smallest RDF Join Actor.
 * It accepts 3 or more streams, joins the smallest two, and joins the result with the remaining streams.
 */ var $e58c60ba6033b065$var$ActorRdfJoinMultiSmallest = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMultiSmallest, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMultiSmallest(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMultiSmallest);
        return (0, $kzDuW._)(this, ActorRdfJoinMultiSmallest, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'multi-smallest',
                limitEntries: 3,
                limitEntriesMin: true,
                canHandleUndefs: true,
                isLeaf: false
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMultiSmallest, [
        {
            key: "sortJoinEntries",
            value: /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ function sortJoinEntries(entries, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorJoinEntriesSort.mediate({
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().entries
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, entries, smallestEntry1, smallestEntry2, firstEntry, _tmp, _, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                // Determine the two smallest streams by sorting (e.g. via cardinality)
                                entries = sideData.sortedEntries;
                                smallestEntry1 = entries[0];
                                smallestEntry2 = entries[1];
                                entries.splice(0, 2);
                                _tmp = {};
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: action.type,
                                        entries: [
                                            smallestEntry1,
                                            smallestEntry2
                                        ],
                                        context: action.context
                                    })
                                ];
                            case 1:
                                firstEntry = (_tmp.output = _.apply(void 0, [
                                    _state.sent()
                                ]), _tmp.operation = algebraFactory.createJoin([
                                    smallestEntry1.operation,
                                    smallestEntry2.operation
                                ], false), _tmp);
                                entries.push(firstEntry);
                                _tmp1 = {};
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: action.type,
                                        entries: entries,
                                        context: action.context
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (_tmp1.result = _state.sent(), _tmp1)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, sortedEntries, requestInitialTimes, requestItemTimes;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                metadatas = sideData.metadatas;
                                metadatas = (0, $7WNf6._)(metadatas);
                                return [
                                    4,
                                    this.sortJoinEntries(action.entries.map(function(entry, i) {
                                        return (0, $emQHU._)((0, $iT0je._)({}, entry), {
                                            metadata: metadatas[i]
                                        });
                                    }), action.context)
                                ];
                            case 1:
                                sortedEntries = _state.sent();
                                metadatas = sortedEntries.map(function(entry) {
                                    return entry.metadata;
                                });
                                requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                                requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)({
                                        iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value * metadatas.slice(2).reduce(function(acc, metadata) {
                                            return acc * metadata.cardinality.value;
                                        }, 1),
                                        persistedItems: 0,
                                        blockingItems: 0,
                                        requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1] + metadatas.slice(2).reduce(function(sum, metadata, i) {
                                            return sum + requestInitialTimes.slice(2)[i] + metadata.cardinality.value * requestItemTimes.slice(2)[i];
                                        }, 0)
                                    }, (0, $emQHU._)((0, $iT0je._)({}, sideData), {
                                        sortedEntries: sortedEntries
                                    }))
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfJoinMultiSmallest;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMultiSmallest = $e58c60ba6033b065$var$ActorRdfJoinMultiSmallest;

});


parcelRegister("cBRQZ", function(module, exports) {
"use strict";
var $92e2b6eea9332c96$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92e2b6eea9332c96$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $92e2b6eea9332c96$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$92e2b6eea9332c96$var$__exportStar((parcelRequire("f5MuZ")), module.exports);

$92e2b6eea9332c96$var$__exportStar((parcelRequire("9WE2q")), module.exports);

});
parcelRegister("f5MuZ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryMax = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $kNNoa = parcelRequire("kNNoa");

var $9WE2q = parcelRequire("9WE2q");
/**
 * A comunica Max Expression Evaluator Aggregate Actor.
 */ var $afccf17d682ddf3b$var$ActorBindingsAggregatorFactoryMax = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryMax, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryMax(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryMax);
        var _this;
        _this = (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryMax, [
            args
        ]);
        _this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryMax, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'max') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'max\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var expr, context, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                expr = param.expr, context = param.context;
                                _1 = (_ = $9WE2q.MaxAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                _tmp = [
                                    void 0,
                                    _state.sent(),
                                    expr.distinct
                                ];
                                return [
                                    4,
                                    this.mediatorTermComparatorFactory.mediate({
                                        context: context
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryMax;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryMax = $afccf17d682ddf3b$var$ActorBindingsAggregatorFactoryMax;

});
parcelRegister("9WE2q", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MaxAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");
var $73d896920dd8c0b2$var$MaxAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(MaxAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function MaxAggregator(evaluator, distinct, orderByEvaluator, throwError) {
        (0, $jGAMp._)(this, MaxAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, MaxAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.orderByEvaluator = orderByEvaluator;
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(MaxAggregator, [
        {
            key: "putTerm",
            value: function putTerm(term) {
                if (term.termType !== 'Literal') throw new Error("Term with value ".concat(term.value, " has type ").concat(term.termType, " and is not a literal"));
                if (this.state === undefined) this.state = term;
                else if (this.orderByEvaluator.orderTypes(this.state, term) === -1) this.state = term;
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return this.state;
            }
        }
    ]);
    return MaxAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.MaxAggregator = $73d896920dd8c0b2$var$MaxAggregator;

});



parcelRegister("cFis2", function(module, exports) {
"use strict";
var $9387a0644d467f27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9387a0644d467f27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9387a0644d467f27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9387a0644d467f27$var$__exportStar((parcelRequire("e3Pb9")), module.exports);

$9387a0644d467f27$var$__exportStar((parcelRequire("2Vsbf")), module.exports);

});
parcelRegister("e3Pb9", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryMin = void 0;

var $gaR6U = parcelRequire("gaR6U");

var $kNNoa = parcelRequire("kNNoa");

var $2Vsbf = parcelRequire("2Vsbf");
/**
 * A comunica Min Expression Evaluator Aggregate Actor.
 */ var $a3c90b8d1ad2cc08$var$ActorBindingsAggregatorFactoryMin = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory) {
    (0, $i3fW3._)(ActorBindingsAggregatorFactoryMin, _bus_bindings_aggregator_factory_1_ActorBindingsAggregatorFactory);
    function ActorBindingsAggregatorFactoryMin(args) {
        (0, $jGAMp._)(this, ActorBindingsAggregatorFactoryMin);
        var _this;
        _this = (0, $kzDuW._)(this, ActorBindingsAggregatorFactoryMin, [
            args
        ]);
        _this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorBindingsAggregatorFactoryMin, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.expr.aggregator !== 'min') return [
                            2,
                            (0, $kNNoa.failTest)('This actor only supports the \'min\' aggregator.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, expr, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context, expr = param.expr;
                                _1 = (_ = $2Vsbf.MinAggregator).bind;
                                return [
                                    4,
                                    this.mediatorExpressionEvaluatorFactory.mediate({
                                        algExpr: expr.expression,
                                        context: context
                                    })
                                ];
                            case 1:
                                _tmp = [
                                    void 0,
                                    _state.sent(),
                                    expr.distinct
                                ];
                                return [
                                    4,
                                    this.mediatorTermComparatorFactory.mediate({
                                        context: context
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorBindingsAggregatorFactoryMin;
}($gaR6U.ActorBindingsAggregatorFactory);
module.exports.ActorBindingsAggregatorFactoryMin = $a3c90b8d1ad2cc08$var$ActorBindingsAggregatorFactoryMin;

});
parcelRegister("2Vsbf", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MinAggregator = void 0;

var $gaR6U = parcelRequire("gaR6U");
var $2216c3af2cdf2653$var$MinAggregator = /*#__PURE__*/ function(_bus_bindings_aggregator_factory_1_AggregateEvaluator) {
    (0, $i3fW3._)(MinAggregator, _bus_bindings_aggregator_factory_1_AggregateEvaluator);
    function MinAggregator(evaluator, distinct, orderByEvaluator, throwError) {
        (0, $jGAMp._)(this, MinAggregator);
        var _this;
        _this = (0, $kzDuW._)(this, MinAggregator, [
            evaluator,
            distinct,
            throwError
        ]);
        _this.orderByEvaluator = orderByEvaluator;
        _this.state = undefined;
        return _this;
    }
    (0, $byiyg._)(MinAggregator, [
        {
            key: "putTerm",
            value: function putTerm(term) {
                if (term.termType !== 'Literal') throw new Error("Term with value ".concat(term.value, " has type ").concat(term.termType, " and is not a literal"));
                if (this.state === undefined) this.state = term;
                else if (this.orderByEvaluator.orderTypes(this.state, term) === 1) this.state = term;
            }
        },
        {
            key: "termResult",
            value: function termResult() {
                if (this.state === undefined) return this.emptyValue();
                return this.state;
            }
        }
    ]);
    return MinAggregator;
}($gaR6U.AggregateEvaluator);
module.exports.MinAggregator = $2216c3af2cdf2653$var$MinAggregator;

});



parcelRegister("4EKee", function(module, exports) {
"use strict";
var $363ec1dd425772eb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $363ec1dd425772eb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $363ec1dd425772eb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$363ec1dd425772eb$var$__exportStar((parcelRequire("gjW8H")), module.exports);

});
parcelRegister("gjW8H", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationOrderBy = void 0;

var $dng5S = parcelRequire("dng5S");

var $kNNoa = parcelRequire("kNNoa");

var $aduX6 = parcelRequire("aduX6");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");

var $eOu2T = parcelRequire("eOu2T");
/**
 * A comunica OrderBy Query Operation Actor.
 */ var $be1b84ed6d7c7d5c$var$ActorQueryOperationOrderBy = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationOrderBy, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationOrderBy(args) {
        (0, $jGAMp._)(this, ActorQueryOperationOrderBy);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationOrderBy, [
            args,
            'orderby'
        ]);
        var _args_window;
        _this.window = (_args_window = args.window) !== null && _args_window !== void 0 ? _args_window : Number.POSITIVE_INFINITY;
        _this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        _this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationOrderBy, [
        {
            key: "testOperation",
            value: function testOperation() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, _loop, outputRaw, output, options, bindingsStream, orderByEvaluator, i;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function(i) {
                                    var expr, isAscending, evaluator, transform, transformedStream, sortedStream;
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                expr = operation.expressions[i];
                                                isAscending = _this.isAscending(expr);
                                                expr = _this.extractSortExpression(expr);
                                                return [
                                                    4,
                                                    _this.mediatorExpressionEvaluatorFactory.mediate({
                                                        algExpr: expr,
                                                        context: context
                                                    })
                                                ];
                                            case 1:
                                                evaluator = _state.sent();
                                                transform = function(bindings, next, push) {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                        var result, error;
                                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    _state.trys.push([
                                                                        0,
                                                                        2,
                                                                        ,
                                                                        3
                                                                    ]);
                                                                    return [
                                                                        4,
                                                                        evaluator.evaluate(bindings)
                                                                    ];
                                                                case 1:
                                                                    result = _state.sent();
                                                                    push({
                                                                        bindings: bindings,
                                                                        result: result
                                                                    });
                                                                    return [
                                                                        3,
                                                                        3
                                                                    ];
                                                                case 2:
                                                                    error = _state.sent();
                                                                    // We ignore all Expression errors.
                                                                    // Other errors (likely programming mistakes) are still propagated.
                                                                    // I can't recall where this is defined in the spec.
                                                                    if (!(0, $aduX6.isExpressionError)(error)) bindingsStream.emit('error', error);
                                                                    push({
                                                                        bindings: bindings,
                                                                        result: undefined
                                                                    });
                                                                    return [
                                                                        3,
                                                                        3
                                                                    ];
                                                                case 3:
                                                                    next();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                };
                                                // eslint-disable-next-line ts/no-misused-promises
                                                transformedStream = bindingsStream.transform({
                                                    transform: transform
                                                });
                                                // Sort the annoted stream
                                                sortedStream = new $eOu2T.SortIterator(transformedStream, function(left, right) {
                                                    var compare = orderByEvaluator.orderTypes(left.result, right.result);
                                                    if (!isAscending) compare *= -1;
                                                    return compare;
                                                }, options);
                                                // Remove the annotation
                                                bindingsStream = sortedStream.map(function(param) {
                                                    var bindings = param.bindings;
                                                    return bindings;
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.input,
                                        context: context
                                    })
                                ];
                            case 1:
                                outputRaw = _state.sent();
                                output = (0, $2n9RU.getSafeBindings)(outputRaw);
                                options = {
                                    window: this.window
                                };
                                bindingsStream = output.bindingsStream;
                                return [
                                    4,
                                    this.mediatorTermComparatorFactory.mediate({
                                        context: context
                                    })
                                ];
                            case 2:
                                orderByEvaluator = _state.sent();
                                i = operation.expressions.length - 1;
                                _state.label = 3;
                            case 3:
                                if (!(i >= 0)) return [
                                    3,
                                    6
                                ];
                                _this = this;
                                return [
                                    5,
                                    (0, $9N5UN.__values)(_loop(i))
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                i--;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: output.metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Remove descending operator if necessary
            key: "extractSortExpression",
            value: function extractSortExpression(expr) {
                var expressionType = expr.expressionType, operator = expr.operator;
                if (expressionType !== $hSHd8.Algebra.expressionTypes.OPERATOR) return expr;
                return operator === 'desc' ? expr.args[0] : expr;
            }
        },
        {
            key: "isAscending",
            value: function isAscending(expr) {
                var expressionType = expr.expressionType, operator = expr.operator;
                if (expressionType !== $hSHd8.Algebra.expressionTypes.OPERATOR) return true;
                return operator !== 'desc';
            }
        }
    ]);
    return ActorQueryOperationOrderBy;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationOrderBy = $be1b84ed6d7c7d5c$var$ActorQueryOperationOrderBy;

});
parcelRegister("eOu2T", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SortIterator = void 0;

var $aafx9 = parcelRequire("aafx9");
// Based on https://github.com/LinkedDataFragments/Client.js/blob/master/lib/sparql/SortIterator.js
var $ac8d0a9ee6ca0b67$var$SortIterator = /*#__PURE__*/ function(_asynciterator_1_TransformIterator) {
    (0, $i3fW3._)(SortIterator, _asynciterator_1_TransformIterator);
    function SortIterator(source, sort, options) {
        (0, $jGAMp._)(this, SortIterator);
        var _this;
        _this = (0, $kzDuW._)(this, SortIterator, [
            source,
            options
        ]);
        // The `window` parameter indicates the length of the sliding window to apply sorting
        var window = options && options.window;
        _this.windowLength = Number.isFinite(window) && window > 0 ? window : Number.POSITIVE_INFINITY;
        _this.sort = sort;
        _this.sorted = [];
        return _this;
    }
    (0, $byiyg._)(SortIterator, [
        {
            // Reads the smallest item in the current sorting window
            key: "_read",
            value: function _read(count, done) {
                var item;
                var length = this.sorted.length;
                // Try to read items until we reach the desired window length
                while(length !== this.windowLength){
                    item = this.source.read();
                    if (item === null) break;
                    // Insert the item in the sorted window (smallest last)
                    var left = 0;
                    var right = length - 1;
                    var mid = void 0;
                    var order = void 0;
                    while(left <= right){
                        mid = Math.trunc((left + right) / 2);
                        order = this.sort(item, this.sorted[mid]);
                        if (order < 0) left = mid + 1;
                        else if (order > 0) right = mid - 1;
                        else {
                            left = mid;
                            right = -1;
                        }
                    }
                    this.sorted.splice(left, 0, item);
                    length++;
                }
                // Push the smallest item in the window
                if (length === this.windowLength) this._push(this.sorted.pop());
                done();
            }
        },
        {
            // Flushes remaining data after the source has ended
            key: "_flush",
            value: function _flush(done) {
                var length = this.sorted.length;
                while(length--)this._push(this.sorted.pop());
                done();
            }
        }
    ]);
    return SortIterator;
}($aafx9.TransformIterator);
module.exports.SortIterator = $ac8d0a9ee6ca0b67$var$SortIterator;

});



parcelRegister("j3xeS", function(module, exports) {
"use strict";
var $ddf814b8ca2e50b3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddf814b8ca2e50b3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ddf814b8ca2e50b3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ddf814b8ca2e50b3$var$__exportStar((parcelRequire("g48MI")), module.exports);

});
parcelRegister("g48MI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationFilterPushdown = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Filter Pushdown Optimize Query Operation Actor.
 */ var $bb23d5848976ee69$var$ActorOptimizeQueryOperationFilterPushdown = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationFilterPushdown, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationFilterPushdown(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationFilterPushdown);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationFilterPushdown, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationFilterPushdown, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation, self, sources, sourceShapes, _, repeat, iterations;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                operation = action.operation;
                                // eslint-disable-next-line ts/no-this-alias
                                self = this;
                                // Split conjunctive filters into nested filters
                                if (this.splitConjunctive) operation = $hSHd8.Util.mapOperation(operation, {
                                    filter: function(op, factory) {
                                        // Split conjunctive filters into separate filters
                                        if (op.expression.expressionType === $hSHd8.Algebra.expressionTypes.OPERATOR && op.expression.operator === '&&') {
                                            self.logDebug(action.context, "Split conjunctive filter into ".concat(op.expression.args.length, " nested filters"));
                                            return {
                                                recurse: true,
                                                result: op.expression.args.reduce(function(operation, expression) {
                                                    return factory.createFilter(operation, expression);
                                                }, op.input)
                                            };
                                        }
                                        return {
                                            recurse: true,
                                            result: op
                                        };
                                    }
                                }, algebraFactory);
                                // Collect selector shapes of all operations
                                sources = this.getSources(operation);
                                _ = Map.bind;
                                return [
                                    4,
                                    Promise.all(sources.map(function(source) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var _tmp;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = [
                                                            source
                                                        ];
                                                        return [
                                                            4,
                                                            source.source.getSelectorShape(action.context)
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _tmp.concat([
                                                                _state.sent()
                                                            ])
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 1:
                                sourceShapes = new (_.apply(Map, [
                                    void 0,
                                    _state.sent()
                                ]));
                                // Push down all filters
                                // We loop until no more filters can be pushed down.
                                repeat = true;
                                iterations = 0;
                                while(repeat && iterations < this.maxIterations){
                                    repeat = false;
                                    operation = $hSHd8.Util.mapOperation(operation, {
                                        filter: function(op, factory) {
                                            // Check if the filter must be pushed down
                                            if (!self.shouldAttemptPushDown(op, sources, sourceShapes)) return {
                                                recurse: true,
                                                result: op
                                            };
                                            // For all filter expressions in the operation,
                                            // we attempt to push them down as deep as possible into the algebra.
                                            var variables = self.getExpressionVariables(op.expression);
                                            var _self_filterPushdown = (0, $32TW8._)(self.filterPushdown(op.expression, variables, op.input, factory, action.context), 2), isModified = _self_filterPushdown[0], result = _self_filterPushdown[1];
                                            if (isModified) repeat = true;
                                            return {
                                                recurse: true,
                                                result: result
                                            };
                                        }
                                    });
                                    iterations++;
                                }
                                if (iterations > 1) self.logDebug(action.context, "Pushed down filters in ".concat(iterations, " iterations"));
                                // Merge nested filters into conjunctive filters
                                if (this.mergeConjunctive) operation = $hSHd8.Util.mapOperation(operation, {
                                    filter: function(op, factory) {
                                        if (op.input.type === $hSHd8.Algebra.types.FILTER) {
                                            var _self_getNestedFilterExpressions = self.getNestedFilterExpressions(op), nestedExpressions = _self_getNestedFilterExpressions.nestedExpressions, input = _self_getNestedFilterExpressions.input;
                                            self.logDebug(action.context, "Merge ".concat(nestedExpressions.length, " nested filters into conjunctive filter"));
                                            return {
                                                recurse: true,
                                                result: factory.createFilter(input, nestedExpressions.slice(1).reduce(function(previous, current) {
                                                    return factory.createOperatorExpression('&&', [
                                                        previous,
                                                        current
                                                    ]);
                                                }, nestedExpressions[0]))
                                            };
                                        }
                                        return {
                                            recurse: true,
                                            result: op
                                        };
                                    }
                                });
                                return [
                                    2,
                                    {
                                        operation: operation,
                                        context: action.context
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Check if the given filter operation must be attempted to push down, based on the following criteria:
     * - Always push down if aggressive mode is enabled
     * - Push down if the filter is extremely selective
     * - Push down if federated and at least one accepts the filter
     * @param operation The filter operation
     * @param sources The query sources in the operation
     * @param sourceShapes A mapping of sources to selector shapes.
     */ key: "shouldAttemptPushDown",
            value: function shouldAttemptPushDown(operation, sources, sourceShapes) {
                // Always push down if aggressive mode is enabled
                if (this.aggressivePushdown) return true;
                // Push down if the filter is extremely selective
                var expression = operation.expression;
                if (expression.expressionType === $hSHd8.Algebra.expressionTypes.OPERATOR && expression.operator === '=' && (expression.args[0].expressionType === 'term' && expression.args[0].term.termType !== 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType === 'Variable' || expression.args[0].expressionType === 'term' && expression.args[0].term.termType === 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType !== 'Variable')) return true;
                // Push down if federated and at least one accepts the filter
                if (sources.some(function(source) {
                    return (0, $2n9RU.doesShapeAcceptOperation)(sourceShapes.get(source), operation);
                })) return true;
                // Don't push down in all other cases
                return false;
            }
        },
        {
            /**
     * Collected all sources that are defined within the given operation of children recursively.
     * @param operation An operation.
     */ key: "getSources",
            value: function getSources(operation) {
                var sources = new Set();
                var sourceAdder = function(subOperation) {
                    var src = (0, $2n9RU.getOperationSource)(subOperation);
                    if (src) sources.add(src);
                    return false;
                };
                var _obj;
                $hSHd8.Util.recurseOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATTERN, sourceAdder), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.LINK, sourceAdder), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.NPS, sourceAdder), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.SERVICE, sourceAdder), _obj));
                return (0, $7WNf6._)(sources);
            }
        },
        {
            /**
     * Get all variables inside the given expression.
     * @param expression An expression.
     * @return An array of variables, or undefined if the expression is unsupported for pushdown.
     */ key: "getExpressionVariables",
            value: function getExpressionVariables(expression) {
                var _this = this;
                switch(expression.expressionType){
                    case $hSHd8.Algebra.expressionTypes.AGGREGATE:
                    case $hSHd8.Algebra.expressionTypes.WILDCARD:
                        throw new Error("Getting expression variables is not supported for ".concat(expression.expressionType));
                    case $hSHd8.Algebra.expressionTypes.EXISTENCE:
                        return $hSHd8.Util.inScopeVariables(expression.input);
                    case $hSHd8.Algebra.expressionTypes.NAMED:
                        return [];
                    case $hSHd8.Algebra.expressionTypes.OPERATOR:
                        return (0, $ilNtL.uniqTerms)(expression.args.flatMap(function(arg) {
                            return _this.getExpressionVariables(arg);
                        }));
                    case $hSHd8.Algebra.expressionTypes.TERM:
                        if (expression.term.termType === 'Variable') return [
                            expression.term
                        ];
                        return [];
                }
            }
        },
        {
            key: "getOverlappingOperations",
            value: function getOverlappingOperations(operation, expressionVariables) {
                var fullyOverlapping = [];
                var partiallyOverlapping = [];
                var notOverlapping = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = operation.input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        var inputVariables = $hSHd8.Util.inScopeVariables(input);
                        if (this.variablesSubSetOf(expressionVariables, inputVariables)) fullyOverlapping.push(input);
                        else if (this.variablesIntersect(expressionVariables, inputVariables)) partiallyOverlapping.push(input);
                        else notOverlapping.push(input);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    fullyOverlapping: fullyOverlapping,
                    partiallyOverlapping: partiallyOverlapping,
                    notOverlapping: notOverlapping
                };
            }
        },
        {
            /**
     * Recursively push down the given expression into the given operation if possible.
     * Different operators have different semantics for choosing whether or not to push down,
     * and how this pushdown is done.
     * For every passed operator, it is checked whether or not the filter will have any effect on the operation.
     * If not, the filter is voided.
     * @param expression An expression to push down.
     * @param expressionVariables The variables inside the given expression.
     * @param operation The operation to push down into.
     * @param factory An algebra factory.
     * @param context The action context.
     * @return A tuple indicating if the operation was modified and the modified operation.
     */ key: "filterPushdown",
            value: function filterPushdown(expression, expressionVariables, operation, factory, context) {
                var _this = this;
                // Void false expressions
                if (this.isExpressionFalse(expression)) return [
                    true,
                    factory.createUnion([])
                ];
                // Don't push down (NOT) EXISTS
                if (expression.type === $hSHd8.Algebra.types.EXPRESSION && expression.expressionType === $hSHd8.Algebra.expressionTypes.EXISTENCE) return [
                    false,
                    factory.createFilter(operation, expression)
                ];
                switch(operation.type){
                    case $hSHd8.Algebra.types.EXTEND:
                        // Pass if the variable is not part of the expression
                        if (!this.variablesIntersect([
                            operation.variable
                        ], expressionVariables)) return [
                            true,
                            factory.createExtend(this.filterPushdown(expression, expressionVariables, operation.input, factory, context)[1], operation.variable, operation.expression)
                        ];
                        return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                    case $hSHd8.Algebra.types.FILTER:
                        {
                            // Always pass
                            var _this_filterPushdown = (0, $32TW8._)(this.filterPushdown(expression, expressionVariables, operation.input, factory, context), 2), isModified = _this_filterPushdown[0], result = _this_filterPushdown[1];
                            return [
                                isModified,
                                factory.createFilter(result, operation.expression)
                            ];
                        }
                    case $hSHd8.Algebra.types.JOIN:
                        {
                            var _joins;
                            // Don't push down for empty join
                            if (operation.input.length === 0) return [
                                false,
                                factory.createFilter(operation, expression)
                            ];
                            // Determine overlapping operations
                            var _this_getOverlappingOperations = this.getOverlappingOperations(operation, expressionVariables), fullyOverlapping = _this_getOverlappingOperations.fullyOverlapping, partiallyOverlapping = _this_getOverlappingOperations.partiallyOverlapping, notOverlapping = _this_getOverlappingOperations.notOverlapping;
                            var joins = [];
                            var isModified1 = false;
                            if (fullyOverlapping.length > 0) {
                                isModified1 = true;
                                joins.push(factory.createJoin(fullyOverlapping.map(function(input) {
                                    return _this.filterPushdown(expression, expressionVariables, input, factory, context)[1];
                                })));
                            }
                            if (partiallyOverlapping.length > 0) joins.push(factory.createFilter(factory.createJoin(partiallyOverlapping, false), expression));
                            if (notOverlapping.length > 0) (_joins = joins).push.apply(_joins, (0, $7WNf6._)(notOverlapping));
                            if (joins.length > 1) isModified1 = true;
                            if (isModified1) this.logDebug(context, "Push down filter across join entries with ".concat(fullyOverlapping.length, " fully overlapping, ").concat(partiallyOverlapping.length, " partially overlapping, and ").concat(notOverlapping.length, " not overlapping"));
                            return [
                                isModified1,
                                joins.length === 1 ? joins[0] : factory.createJoin(joins)
                            ];
                        }
                    case $hSHd8.Algebra.types.NOP:
                        return [
                            true,
                            operation
                        ];
                    case $hSHd8.Algebra.types.PROJECT:
                        // Push down if variables overlap
                        if (this.variablesIntersect(operation.variables, expressionVariables)) return [
                            true,
                            factory.createProject(this.filterPushdown(expression, expressionVariables, operation.input, factory, context)[1], operation.variables)
                        ];
                        // Void expression otherwise
                        return [
                            true,
                            operation
                        ];
                    case $hSHd8.Algebra.types.UNION:
                        {
                            var _unions;
                            // Determine overlapping operations
                            var _this_getOverlappingOperations1 = this.getOverlappingOperations(operation, expressionVariables), fullyOverlapping1 = _this_getOverlappingOperations1.fullyOverlapping, partiallyOverlapping1 = _this_getOverlappingOperations1.partiallyOverlapping, notOverlapping1 = _this_getOverlappingOperations1.notOverlapping;
                            var unions = [];
                            var isModified2 = false;
                            if (fullyOverlapping1.length > 0) {
                                isModified2 = true;
                                unions.push(factory.createUnion(fullyOverlapping1.map(function(input) {
                                    return _this.filterPushdown(expression, expressionVariables, input, factory, context)[1];
                                })));
                            }
                            if (partiallyOverlapping1.length > 0) unions.push(factory.createFilter(factory.createUnion(partiallyOverlapping1, false), expression));
                            if (notOverlapping1.length > 0) (_unions = unions).push.apply(_unions, (0, $7WNf6._)(notOverlapping1));
                            if (unions.length > 1) isModified2 = true;
                            if (isModified2) this.logDebug(context, "Push down filter across union entries with ".concat(fullyOverlapping1.length, " fully overlapping, ").concat(partiallyOverlapping1.length, " partially overlapping, and ").concat(notOverlapping1.length, " not overlapping"));
                            return [
                                isModified2,
                                unions.length === 1 ? unions[0] : factory.createUnion(unions)
                            ];
                        }
                    case $hSHd8.Algebra.types.VALUES:
                        // Only keep filter if it overlaps with the variables
                        if (this.variablesIntersect(operation.variables, expressionVariables)) return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                        return [
                            true,
                            operation
                        ];
                    case $hSHd8.Algebra.types.LEFT_JOIN:
                        if (this.pushIntoLeftJoins) {
                            var rightVariables = $hSHd8.Util.inScopeVariables(operation.input[1]);
                            if (!this.variablesIntersect(expressionVariables, rightVariables)) {
                                // If filter *only* applies to left entry of optional, push it down into that.
                                this.logDebug(context, "Push down filter into left join");
                                return [
                                    true,
                                    factory.createLeftJoin(this.filterPushdown(expression, expressionVariables, operation.input[0], factory, context)[1], operation.input[1], operation.expression)
                                ];
                            }
                        }
                        // Don't push down in all other cases
                        return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                    case $hSHd8.Algebra.types.PATTERN:
                        if (this.pushEqualityIntoPatterns) {
                            // Try to push simple FILTER(?s = <iri>) expressions into the pattern
                            var pushableResult = this.getEqualityExpressionPushableIntoPattern(expression);
                            if (pushableResult) {
                                var isModified3 = false;
                                var originalMetadata = operation.metadata;
                                operation = (0, $ilNtL.mapTermsNested)(operation, function(value) {
                                    if (value.equals(pushableResult.variable)) {
                                        isModified3 = true;
                                        return pushableResult.term;
                                    }
                                    return value;
                                });
                                operation.type = $hSHd8.Algebra.types.PATTERN;
                                operation.metadata = originalMetadata;
                                if (isModified3) {
                                    this.logDebug(context, "Push down filter into pattern for ?".concat(pushableResult.variable.value));
                                    return [
                                        true,
                                        factory.createJoin([
                                            operation,
                                            factory.createValues([
                                                pushableResult.variable
                                            ], [
                                                (0, $cqEAj._)({}, "?".concat(pushableResult.variable.value), pushableResult.term)
                                            ])
                                        ])
                                    ];
                                }
                            }
                        }
                        // Don't push down in all other cases
                        return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                    case $hSHd8.Algebra.types.PATH:
                        if (this.pushEqualityIntoPatterns) {
                            // Try to push simple FILTER(?s = <iri>) expressions into the path
                            var pushableResult1 = this.getEqualityExpressionPushableIntoPattern(expression);
                            if (pushableResult1 && (operation.subject.equals(pushableResult1.variable) || operation.object.equals(pushableResult1.variable))) {
                                this.logDebug(context, "Push down filter into path for ?".concat(pushableResult1.variable.value));
                                var originalMetadata1 = operation.metadata;
                                operation = factory.createPath(operation.subject.equals(pushableResult1.variable) ? pushableResult1.term : operation.subject, operation.predicate, operation.object.equals(pushableResult1.variable) ? pushableResult1.term : operation.object);
                                operation.metadata = originalMetadata1;
                                return [
                                    true,
                                    factory.createJoin([
                                        operation,
                                        factory.createValues([
                                            pushableResult1.variable
                                        ], [
                                            (0, $cqEAj._)({}, "?".concat(pushableResult1.variable.value), pushableResult1.term)
                                        ])
                                    ])
                                ];
                            }
                        }
                        // Don't push down in all other cases
                        return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                    case $hSHd8.Algebra.types.MINUS:
                    case $hSHd8.Algebra.types.ALT:
                    case $hSHd8.Algebra.types.ASK:
                    case $hSHd8.Algebra.types.BGP:
                    case $hSHd8.Algebra.types.CONSTRUCT:
                    case $hSHd8.Algebra.types.DESCRIBE:
                    case $hSHd8.Algebra.types.DISTINCT:
                    case $hSHd8.Algebra.types.EXPRESSION:
                    case $hSHd8.Algebra.types.FROM:
                    case $hSHd8.Algebra.types.GRAPH:
                    case $hSHd8.Algebra.types.GROUP:
                    case $hSHd8.Algebra.types.INV:
                    case $hSHd8.Algebra.types.LINK:
                    case $hSHd8.Algebra.types.NPS:
                    case $hSHd8.Algebra.types.ONE_OR_MORE_PATH:
                    case $hSHd8.Algebra.types.ORDER_BY:
                    case $hSHd8.Algebra.types.REDUCED:
                    case $hSHd8.Algebra.types.SEQ:
                    case $hSHd8.Algebra.types.SERVICE:
                    case $hSHd8.Algebra.types.SLICE:
                    case $hSHd8.Algebra.types.ZERO_OR_MORE_PATH:
                    case $hSHd8.Algebra.types.ZERO_OR_ONE_PATH:
                    case $hSHd8.Algebra.types.COMPOSITE_UPDATE:
                    case $hSHd8.Algebra.types.DELETE_INSERT:
                    case $hSHd8.Algebra.types.LOAD:
                    case $hSHd8.Algebra.types.CLEAR:
                    case $hSHd8.Algebra.types.CREATE:
                    case $hSHd8.Algebra.types.DROP:
                    case $hSHd8.Algebra.types.ADD:
                    case $hSHd8.Algebra.types.MOVE:
                    case $hSHd8.Algebra.types.COPY:
                        // Operations that do not support pushing down
                        // Left-join and minus might be possible to support in the future.
                        return [
                            false,
                            factory.createFilter(operation, expression)
                        ];
                }
            }
        },
        {
            /**
     * Check if the given expression is a simple equals operation with one variable and one non-literal
     * (or literal with canonical lexical form) term that can be pushed into a pattern.
     * @param expression The current expression.
     * @return The variable and term to fill into the pattern, or undefined.
     */ key: "getEqualityExpressionPushableIntoPattern",
            value: function getEqualityExpressionPushableIntoPattern(expression) {
                if (expression.expressionType === $hSHd8.Algebra.expressionTypes.OPERATOR && expression.operator === '=') {
                    if (expression.args[0].expressionType === 'term' && expression.args[0].term.termType !== 'Variable' && (expression.args[0].term.termType !== 'Literal' || this.isLiteralWithCanonicalLexicalForm(expression.args[0].term)) && expression.args[1].expressionType === 'term' && expression.args[1].term.termType === 'Variable') return {
                        variable: expression.args[1].term,
                        term: expression.args[0].term
                    };
                    if (expression.args[0].expressionType === 'term' && expression.args[0].term.termType === 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType !== 'Variable' && (expression.args[1].term.termType !== 'Literal' || this.isLiteralWithCanonicalLexicalForm(expression.args[1].term))) return {
                        variable: expression.args[0].term,
                        term: expression.args[1].term
                    };
                }
            }
        },
        {
            /**
     * Check if the given term is a literal with datatype that where all values
     * can only have one possible lexical representation.
     * In other words, no variants of values exist that should be considered equal.
     * For example: "01"^xsd:number and "1"^xsd:number will return false.
     * @param term An RDF term.
     * @protected
     */ key: "isLiteralWithCanonicalLexicalForm",
            value: function isLiteralWithCanonicalLexicalForm(term) {
                if (term.termType === 'Literal') switch(term.datatype.value){
                    case 'http://www.w3.org/2001/XMLSchema#string':
                    case 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString':
                    case 'http://www.w3.org/2001/XMLSchema#normalizedString':
                    case 'http://www.w3.org/2001/XMLSchema#anyURI':
                    case 'http://www.w3.org/2001/XMLSchema#base64Binary':
                    case 'http://www.w3.org/2001/XMLSchema#language':
                    case 'http://www.w3.org/2001/XMLSchema#Name':
                    case 'http://www.w3.org/2001/XMLSchema#NCName':
                    case 'http://www.w3.org/2001/XMLSchema#NMTOKEN':
                    case 'http://www.w3.org/2001/XMLSchema#token':
                    case 'http://www.w3.org/2001/XMLSchema#hexBinary':
                        return true;
                }
                return false;
            }
        },
        {
            /**
     * Check if there is an overlap between the two given lists of variables.
     * @param varsA A list of variables.
     * @param varsB A list of variables.
     */ key: "variablesIntersect",
            value: function variablesIntersect(varsA, varsB) {
                return varsA.some(function(varA) {
                    return varsB.some(function(varB) {
                        return varA.equals(varB);
                    });
                });
            }
        },
        {
            /**
     * Check if all variables from the first list are included in the second list.
     * The second list may contain other variables as well.
     * @param varsNeedles A list of variables to search for.
     * @param varsHaystack A list of variables to search in.
     */ key: "variablesSubSetOf",
            value: function variablesSubSetOf(varsNeedles, varsHaystack) {
                return varsNeedles.length <= varsHaystack.length && varsNeedles.every(function(varA) {
                    return varsHaystack.some(function(varB) {
                        return varA.equals(varB);
                    });
                });
            }
        },
        {
            /**
     * Check if an expression is simply 'false'.
     * @param expression An expression.
     */ key: "isExpressionFalse",
            value: function isExpressionFalse(expression) {
                return expression.term && expression.term.termType === 'Literal' && expression.term.value === 'false';
            }
        },
        {
            /**
     * Get all directly nested filter expressions.
     * As soon as a non-filter is found, it is returned as the input field.
     * @param op A filter expression.
     */ key: "getNestedFilterExpressions",
            value: function getNestedFilterExpressions(op) {
                if (op.input.type === $hSHd8.Algebra.types.FILTER) {
                    var childData = this.getNestedFilterExpressions(op.input);
                    return {
                        nestedExpressions: [
                            op.expression
                        ].concat((0, $7WNf6._)(childData.nestedExpressions)),
                        input: childData.input
                    };
                }
                return {
                    nestedExpressions: [
                        op.expression
                    ],
                    input: op.input
                };
            }
        }
    ]);
    return ActorOptimizeQueryOperationFilterPushdown;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationFilterPushdown = $bb23d5848976ee69$var$ActorOptimizeQueryOperationFilterPushdown;

});


parcelRegister("62lD4", function(module, exports) {
"use strict";
var $4653b513ba3b4cdb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4653b513ba3b4cdb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4653b513ba3b4cdb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4653b513ba3b4cdb$var$__exportStar((parcelRequire("gHYVj")), module.exports);

$4653b513ba3b4cdb$var$__exportStar((parcelRequire("9EK5f")), module.exports);

});
parcelRegister("gHYVj", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceHttp = void 0;

var $9EK5f = parcelRequire("9EK5f");
/**
 * The browser variant of {@link ActorDereferenceHttp}.
 */ var $c29feb9bafe2bc17$var$ActorDereferenceHttp = /*#__PURE__*/ function(_ActorDereferenceHttpBase_1_ActorDereferenceHttpBase) {
    (0, $i3fW3._)(ActorDereferenceHttp, _ActorDereferenceHttpBase_1_ActorDereferenceHttpBase);
    function ActorDereferenceHttp() {
        (0, $jGAMp._)(this, ActorDereferenceHttp);
        return (0, $kzDuW._)(this, ActorDereferenceHttp, arguments);
    }
    (0, $byiyg._)(ActorDereferenceHttp, [
        {
            key: "getMaxAcceptHeaderLength",
            value: function getMaxAcceptHeaderLength() {
                return this.maxAcceptHeaderLengthBrowser;
            }
        }
    ]);
    return ActorDereferenceHttp;
}($9EK5f.ActorDereferenceHttpBase);
module.exports.ActorDereferenceHttp = $c29feb9bafe2bc17$var$ActorDereferenceHttp;

});
parcelRegister("9EK5f", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceHttpBase = module.exports.mediaTypesToAcceptString = void 0;

var $9wyYb = parcelRequire("9wyYb");

var $2terW = parcelRequire("2terW");

var $kNNoa = parcelRequire("kNNoa");

var $99iqU = parcelRequire("99iqU");

var $hDpjF = parcelRequire("hDpjF");
var $707b98b76eead7f8$var$REGEX_MEDIATYPE = RegExp("^[^ ;]*", "u");
function $707b98b76eead7f8$var$mediaTypesToAcceptString(mediaTypes, maxLength) {
    var wildcard = '*/*;q=0.1';
    var parts = [];
    var sortedMediaTypes = Object.entries(mediaTypes).map(function(param) {
        var _param = (0, $32TW8._)(param, 2), mediaType = _param[0], priority = _param[1];
        return {
            mediaType: mediaType,
            priority: priority
        };
    }).sort(function(left, right) {
        return right.priority === left.priority ? left.mediaType.localeCompare(right.mediaType) : right.priority - left.priority;
    });
    // Take into account the ',' characters joining each type
    var partsLength = sortedMediaTypes.length - 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sortedMediaTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, mediaType = _step_value.mediaType, priority = _step_value.priority;
            var part = mediaType + (priority === 1 ? '' : ";q=".concat(priority.toFixed(3).replace(RegExp("0*$", "u"), '')));
            if (partsLength + part.length > maxLength) {
                while(partsLength + wildcard.length > maxLength){
                    var _parts_pop;
                    var last = (_parts_pop = parts.pop()) !== null && _parts_pop !== void 0 ? _parts_pop : '';
                    // Don't forget the ','
                    partsLength -= last.length + 1;
                }
                parts.push(wildcard);
                break;
            }
            parts.push(part);
            partsLength += part.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parts.length === 0 ? '*/*' : parts.join(',');
}
module.exports.mediaTypesToAcceptString = $707b98b76eead7f8$var$mediaTypesToAcceptString;
/**
 * An actor that listens on the 'dereference' bus.
 *
 * It resolves the URL using the HTTP bus using an accept header compiled from the available media types.
 */ var $707b98b76eead7f8$var$ActorDereferenceHttpBase = /*#__PURE__*/ function(_bus_dereference_1_ActorDereference) {
    (0, $i3fW3._)(ActorDereferenceHttpBase, _bus_dereference_1_ActorDereference);
    function ActorDereferenceHttpBase(args) {
        (0, $jGAMp._)(this, ActorDereferenceHttpBase);
        return (0, $kzDuW._)(this, ActorDereferenceHttpBase, [
            args
        ]);
    }
    (0, $byiyg._)(ActorDereferenceHttpBase, [
        {
            key: "test",
            value: function test(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var url;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        url = param.url;
                        if (!RegExp("^https?:", "u").test(url)) return [
                            2,
                            (0, $kNNoa.failTest)("Cannot retrieve ".concat(url, " because it is not an HTTP(S) URL."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_mediaTypes, _REGEX_MEDIATYPE_exec, exists, headers, _ref, _, _tmp, httpResponse, requestTimeStart, error, url, requestTime, bodyString, _tmp1, _$error, _httpResponse_headers_get, mediaType;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                exists = true;
                                // Append any custom passed headers
                                headers = new Headers(action.headers);
                                // Resolve HTTP URL using appropriate accept header
                                _ = headers.append;
                                _tmp = [
                                    'Accept'
                                ];
                                return [
                                    4,
                                    (_action_mediaTypes = action.mediaTypes) === null || _action_mediaTypes === void 0 ? void 0 : _action_mediaTypes.call(action)
                                ];
                            case 1:
                                _.apply(headers, _tmp.concat([
                                    $707b98b76eead7f8$var$mediaTypesToAcceptString.apply(void 0, [
                                        (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : {},
                                        this.getMaxAcceptHeaderLength()
                                    ])
                                ]));
                                requestTimeStart = Date.now();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.mediatorHttp.mediate({
                                        context: action.context,
                                        init: {
                                            headers: headers,
                                            method: action.method
                                        },
                                        input: action.url
                                    })
                                ];
                            case 3:
                                httpResponse = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                return [
                                    2,
                                    this.handleDereferenceErrors(action, error)
                                ];
                            case 5:
                                // The response URL can be relative to the given URL
                                url = (0, $hDpjF.resolve)(httpResponse.url, action.url);
                                requestTime = Date.now() - requestTimeStart;
                                if (!(httpResponse.status !== 200)) return [
                                    3,
                                    9
                                ];
                                exists = false;
                                if (!httpResponse.body) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    (0, $99iqU.stringify)($2terW.ActorHttp.toNodeReadable(httpResponse.body))
                                ];
                            case 6:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _tmp1 = 'empty response';
                                _state.label = 8;
                            case 8:
                                bodyString = _tmp1;
                                if (!action.acceptErrors) {
                                    _$error = new Error("Could not retrieve ".concat(action.url, " (HTTP status ").concat(httpResponse.status, "):\n").concat(bodyString));
                                    return [
                                        2,
                                        this.handleDereferenceErrors(action, _$error, httpResponse.headers, requestTime)
                                    ];
                                }
                                _state.label = 9;
                            case 9:
                                mediaType = (_REGEX_MEDIATYPE_exec = $707b98b76eead7f8$var$REGEX_MEDIATYPE.exec((_httpResponse_headers_get = httpResponse.headers.get('content-type')) !== null && _httpResponse_headers_get !== void 0 ? _httpResponse_headers_get : '')) === null || _REGEX_MEDIATYPE_exec === void 0 ? void 0 : _REGEX_MEDIATYPE_exec[0];
                                // Return the parsed quad stream and whether or not only triples are supported
                                return [
                                    2,
                                    {
                                        url: url,
                                        data: exists ? $2terW.ActorHttp.toNodeReadable(httpResponse.body) : (0, $9wyYb.emptyReadable)(),
                                        exists: exists,
                                        requestTime: requestTime,
                                        headers: httpResponse.headers,
                                        mediaType: mediaType === 'text/plain' ? undefined : mediaType
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorDereferenceHttpBase;
}($9wyYb.ActorDereference);
module.exports.ActorDereferenceHttpBase = $707b98b76eead7f8$var$ActorDereferenceHttpBase;

});



parcelRegister("5Y3qE", function(module, exports) {
"use strict";
var $4585373db7181ab0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4585373db7181ab0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4585373db7181ab0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4585373db7181ab0$var$__exportStar((parcelRequire("6CaJ2")), module.exports);

$4585373db7181ab0$var$__exportStar((parcelRequire("dkyUI")), module.exports);

});
parcelRegister("6CaJ2", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpProxy = void 0;

var $2terW = parcelRequire("2terW");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Proxy Http Actor.
 */ var $4d0e9c85ab72710a$var$ActorHttpProxy = /*#__PURE__*/ function(_bus_http_1_ActorHttp) {
    (0, $i3fW3._)(ActorHttpProxy, _bus_http_1_ActorHttp);
    function ActorHttpProxy(args) {
        (0, $jGAMp._)(this, ActorHttpProxy);
        return (0, $kzDuW._)(this, ActorHttpProxy, [
            args
        ]);
    }
    (0, $byiyg._)(ActorHttpProxy, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var proxyHandler;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                proxyHandler = action.context.get($9nBhR.KeysHttpProxy.httpProxyHandler);
                                if (!proxyHandler) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not find a proxy handler in the context."))
                                ];
                                return [
                                    4,
                                    proxyHandler.getProxy(action)
                                ];
                            case 1:
                                if (!_state.sent()) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not determine a proxy for the given request."))
                                ];
                                return [
                                    2,
                                    (0, $kNNoa.passTest)({
                                        time: Number.POSITIVE_INFINITY
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var requestedUrl, proxyHandler, output, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestedUrl = typeof action.input === 'string' ? action.input : action.input.url;
                                proxyHandler = action.context.get($9nBhR.KeysHttpProxy.httpProxyHandler);
                                _1 = (_ = this.mediatorHttp).mediate;
                                _tmp = [
                                    {}
                                ];
                                return [
                                    4,
                                    proxyHandler.getProxy(action)
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, [
                                        (0, $emQHU._).apply(void 0, [
                                            (0, $iT0je._).apply(void 0, _tmp.concat([
                                                _state.sent()
                                            ])),
                                            {
                                                context: action.context["delete"]($9nBhR.KeysHttpProxy.httpProxyHandler)
                                            }
                                        ])
                                    ])
                                ];
                            case 2:
                                output = _state.sent();
                                // Modify the response URL
                                // use defineProperty to allow modification of unmodifiable objects
                                Object.defineProperty(output, 'url', {
                                    configurable: true,
                                    enumerable: true,
                                    get: function() {
                                        var _output_headers_get;
                                        return (_output_headers_get = output.headers.get('x-final-url')) !== null && _output_headers_get !== void 0 ? _output_headers_get : requestedUrl;
                                    }
                                });
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorHttpProxy;
}($2terW.ActorHttp);
module.exports.ActorHttpProxy = $4d0e9c85ab72710a$var$ActorHttpProxy;

});

parcelRegister("dkyUI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyHandlerStatic = void 0;
/**
 * A proxy handler that prefixes all URLs with a given string.
 */ var $9b4839bde32fe0cd$var$ProxyHandlerStatic = /*#__PURE__*/ function() {
    function ProxyHandlerStatic(prefixUrl) {
        (0, $jGAMp._)(this, ProxyHandlerStatic);
        this.prefixUrl = prefixUrl;
    }
    (0, $byiyg._)(ProxyHandlerStatic, [
        {
            key: "getProxy",
            value: function getProxy(request) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                init: request.init,
                                input: this.modifyInput(request.input)
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "modifyInput",
            value: function modifyInput(input) {
                if (typeof input === 'string') return this.prefixUrl + input;
                return new Request(this.prefixUrl + input.url, input);
            }
        }
    ]);
    return ProxyHandlerStatic;
}();
module.exports.ProxyHandlerStatic = $9b4839bde32fe0cd$var$ProxyHandlerStatic;

});


parcelRegister("hk1Et", function(module, exports) {
"use strict";
var $c9c595f5f20447e9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9c595f5f20447e9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c9c595f5f20447e9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c9c595f5f20447e9$var$__exportStar((parcelRequire("jCCV8")), module.exports);

});
parcelRegister("jCCV8", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessQuerySourceIdentify = void 0;

var $9sIz8 = parcelRequire("9sIz8");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $9tTS7 = parcelRequire("9tTS7");
/**
 * A comunica Query Source Identify Context Preprocess Actor.
 */ var $e48fc1bb92279087$var$ActorContextPreprocessQuerySourceIdentify = /*#__PURE__*/ function(_bus_context_preprocess_1_ActorContextPreprocess) {
    (0, $i3fW3._)(ActorContextPreprocessQuerySourceIdentify, _bus_context_preprocess_1_ActorContextPreprocess);
    function ActorContextPreprocessQuerySourceIdentify(args) {
        (0, $jGAMp._)(this, ActorContextPreprocessQuerySourceIdentify);
        var _this;
        _this = (0, $kzDuW._)(this, ActorContextPreprocessQuerySourceIdentify, [
            args
        ]);
        _this.cache = _this.cacheSize ? new $9tTS7.LRUCache({
            max: _this.cacheSize
        }) : undefined;
        var cache = _this.cache;
        if (cache) _this.httpInvalidator.addInvalidateListener(function(param) {
            var url = param.url;
            return url ? cache["delete"](url) : cache.clear();
        });
        return _this;
    }
    (0, $byiyg._)(ActorContextPreprocessQuerySourceIdentify, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, context, querySourcesUnidentified, querySourcesUnidentifiedExpanded, querySources, statisticDereferenceLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, querySource;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                context = action.context;
                                if (!context.has($9nBhR.KeysInitQuery.querySourcesUnidentified)) return [
                                    3,
                                    3
                                ];
                                querySourcesUnidentified = action.context.get($9nBhR.KeysInitQuery.querySourcesUnidentified);
                                return [
                                    4,
                                    Promise.all(querySourcesUnidentified.map(function(querySource) {
                                        return _this.expandSource(querySource);
                                    }))
                                ];
                            case 1:
                                querySourcesUnidentifiedExpanded = _state.sent();
                                return [
                                    4,
                                    Promise.all(querySourcesUnidentifiedExpanded.map(function(querySourceUnidentified) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    this.identifySource(querySourceUnidentified, action.context)
                                                ];
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 2:
                                querySources = _state.sent();
                                // When identifying sources in preprocess actor, we record this as a dereference seed document event
                                statisticDereferenceLinks = action.context.get($9nBhR.KeysStatistics.dereferencedLinks);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (statisticDereferenceLinks) try {
                                    for(_iterator = querySources[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        querySource = _step.value;
                                        statisticDereferenceLinks.updateStatistic({
                                            url: querySource.source.referenceValue,
                                            metadata: {
                                                seed: true
                                            }
                                        }, querySource.source);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                context = action.context["delete"]($9nBhR.KeysInitQuery.querySourcesUnidentified).set($9nBhR.KeysQueryOperation.querySources, querySources);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    {
                                        context: context
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "expandSource",
            value: function expandSource(querySource) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _querySource_context, _tmp, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof querySource === 'string' || 'match' in querySource) return [
                                    2,
                                    {
                                        value: querySource
                                    }
                                ];
                                _tmp = [
                                    (0, $iT0je._)({}, querySource)
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    this.mediatorContextPreprocess.mediate({
                                        context: $kNNoa.ActionContext.ensureActionContext((_querySource_context = querySource.context) !== null && _querySource_context !== void 0 ? _querySource_context : {})
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (0, $emQHU._).apply(void 0, _tmp.concat([
                                        (_tmp1.context = _state.sent().context, _tmp1)
                                    ]))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "identifySource",
            value: function identifySource(querySourceUnidentified, context) {
                var sourcePromise;
                // Try to read from cache
                // Only sources based on string values (e.g. URLs) are supported!
                if (typeof querySourceUnidentified.value === 'string' && this.cache) sourcePromise = this.cache.get(querySourceUnidentified.value);
                // If not in cache, identify the source
                if (!sourcePromise) {
                    sourcePromise = this.mediatorQuerySourceIdentify.mediate({
                        querySourceUnidentified: querySourceUnidentified,
                        context: context
                    }).then(function(param) {
                        var querySource = param.querySource;
                        return querySource;
                    });
                    // Set in cache
                    if (typeof querySourceUnidentified.value === 'string' && this.cache) this.cache.set(querySourceUnidentified.value, sourcePromise);
                }
                return sourcePromise;
            }
        }
    ]);
    return ActorContextPreprocessQuerySourceIdentify;
}($9sIz8.ActorContextPreprocess);
module.exports.ActorContextPreprocessQuerySourceIdentify = $e48fc1bb92279087$var$ActorContextPreprocessQuerySourceIdentify;

});
parcelRegister("9tTS7", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $6e7229751bd94ff2$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $6e7229751bd94ff2$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $6e7229751bd94ff2$var$warned = new Set();
/* c8 ignore start */ var $6e7229751bd94ff2$var$PROCESS = {};
/* c8 ignore start */ var $6e7229751bd94ff2$var$emitWarning = function(msg, type, code, fn) {
    typeof $6e7229751bd94ff2$var$PROCESS.emitWarning === 'function' ? $6e7229751bd94ff2$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $6e7229751bd94ff2$var$AC = globalThis.AbortController;
var $6e7229751bd94ff2$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $6e7229751bd94ff2$var$AC === 'undefined') {
    var $6e7229751bd94ff2$var$_PROCESS_env;
    //@ts-ignore
    $6e7229751bd94ff2$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $6e7229751bd94ff2$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $6e7229751bd94ff2$var$AS());
            $6e7229751bd94ff2$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $6e7229751bd94ff2$var$printACPolyfillWarning = (($6e7229751bd94ff2$var$_PROCESS_env = $6e7229751bd94ff2$var$PROCESS.env) === null || $6e7229751bd94ff2$var$_PROCESS_env === void 0 ? void 0 : $6e7229751bd94ff2$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $6e7229751bd94ff2$var$warnACPolyfill = function() {
        if (!$6e7229751bd94ff2$var$printACPolyfillWarning) return;
        $6e7229751bd94ff2$var$printACPolyfillWarning = false;
        $6e7229751bd94ff2$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $6e7229751bd94ff2$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $6e7229751bd94ff2$var$shouldWarn = function(code) {
    return !$6e7229751bd94ff2$var$warned.has(code);
};
var $6e7229751bd94ff2$var$TYPE = Symbol('type');
var $6e7229751bd94ff2$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $6e7229751bd94ff2$var$getUintArray = function(max) {
    return !$6e7229751bd94ff2$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $6e7229751bd94ff2$var$ZeroArray : null;
};
/* c8 ignore stop */ var $6e7229751bd94ff2$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $6e7229751bd94ff2$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $6e7229751bd94ff2$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $6e7229751bd94ff2$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $6e7229751bd94ff2$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $6e7229751bd94ff2$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $6e7229751bd94ff2$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$6e7229751bd94ff2$var$_max = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_maxSize = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_dispose = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$6e7229751bd94ff2$var$_size = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_keyMap = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_keyList = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_valList = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_next = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_prev = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_head = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_tail = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_free = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_disposed = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_sizes = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_starts = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_ttls = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$6e7229751bd94ff2$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $6e7229751bd94ff2$var$_isStale = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_requireSize = /*#__PURE__*/ new WeakMap(), $6e7229751bd94ff2$var$_indexes = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_rindexes = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_evict = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_connect = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_delete = /*#__PURE__*/ new WeakSet(), $6e7229751bd94ff2$var$_clear = /*#__PURE__*/ new WeakSet();
var $6e7229751bd94ff2$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_indexes);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_rindexes);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_isValidIndex);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_evict);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_backgroundFetch);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_connect);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_moveToTail);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_delete);
        (0, $bA8rW._)(this, $6e7229751bd94ff2$var$_clear);
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $6e7229751bd94ff2$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$6e7229751bd94ff2$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $6e7229751bd94ff2$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_max, max);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, 0);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, 0);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_free, $6e7229751bd94ff2$var$Stack.create(max));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_size, 0);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_hasDispose, !!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_dispose));
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize) !== 0) {
                if (!$6e7229751bd94ff2$var$isPosInt((0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$6e7229751bd94ff2$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_initializeSizeTracking, $6e7229751bd94ff2$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $6e7229751bd94ff2$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$6e7229751bd94ff2$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_initializeTTLTracking, $6e7229751bd94ff2$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $6e7229751bd94ff2$var$_max) && !(0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($6e7229751bd94ff2$var$shouldWarn(code)) {
                $6e7229751bd94ff2$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $6e7229751bd94ff2$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i],
                                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i],
                                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($6e7229751bd94ff2$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes)) entry.size = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $6e7229751bd94ff2$var$perf.now() - (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes)) entry.size = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $6e7229751bd94ff2$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) === 0 ? (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail) : (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).length !== 0 ? (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).pop() : (0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_max) ? (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_evict, $6e7229751bd94ff2$var$evict).call(this, false) : (0, $el4bI._)(this, $6e7229751bd94ff2$var$_size);
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[(0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail)] = index;
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[index] = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail);
                    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, index);
                    (0, $3cNKp._)(this, $6e7229751bd94ff2$var$_size).value++;
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_moveToTail, $6e7229751bd94ff2$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $6e7229751bd94ff2$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $6e7229751bd94ff2$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls)) (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_initializeTTLTracking, $6e7229751bd94ff2$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $6e7229751bd94ff2$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $6e7229751bd94ff2$var$_size)){
                        var val = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[(0, $el4bI._)(this, $6e7229751bd94ff2$var$_head)];
                        (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_evict, $6e7229751bd94ff2$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $6e7229751bd94ff2$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $6e7229751bd94ff2$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_backgroundFetch, $6e7229751bd94ff2$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_moveToTail, $6e7229751bd94ff2$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_backgroundFetch, $6e7229751bd94ff2$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_moveToTail, $6e7229751bd94ff2$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_clear, $6e7229751bd94ff2$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_starts),
                    ttls: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_ttls),
                    sizes: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_keyList),
                    valList: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_valList),
                    next: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_next),
                    prev: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $6e7229751bd94ff2$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $6e7229751bd94ff2$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $6e7229751bd94ff2$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $6e7229751bd94ff2$var$_backgroundFetch, $6e7229751bd94ff2$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $6e7229751bd94ff2$var$_moveToTail, $6e7229751bd94ff2$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $6e7229751bd94ff2$var$_indexes, $6e7229751bd94ff2$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $6e7229751bd94ff2$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $6e7229751bd94ff2$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $6e7229751bd94ff2$var$ZeroArray((0, $el4bI._)(this, $6e7229751bd94ff2$var$_max));
    var starts = new $6e7229751bd94ff2$var$ZeroArray((0, $el4bI._)(this, $6e7229751bd94ff2$var$_max));
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_ttls, ttls);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_starts, starts);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $6e7229751bd94ff2$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $6e7229751bd94ff2$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(_this1, (0, $el4bI._)(_this1, $6e7229751bd94ff2$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $6e7229751bd94ff2$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $6e7229751bd94ff2$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $6e7229751bd94ff2$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $6e7229751bd94ff2$var$ZeroArray((0, $el4bI._)(this, $6e7229751bd94ff2$var$_max));
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_sizes, sizes);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $6e7229751bd94ff2$var$_calculatedSize, (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$6e7229751bd94ff2$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$6e7229751bd94ff2$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $6e7229751bd94ff2$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $6e7229751bd94ff2$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $6e7229751bd94ff2$var$_evict, $6e7229751bd94ff2$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $6e7229751bd94ff2$var$_calculatedSize, (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_calculatedSize);
        }
    });
}
function $6e7229751bd94ff2$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isValidIndex, $6e7229751bd94ff2$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $6e7229751bd94ff2$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isValidIndex, $6e7229751bd94ff2$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $6e7229751bd94ff2$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $6e7229751bd94ff2$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get((0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[index]) === index;
}
function $6e7229751bd94ff2$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_head);
    var k = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[head];
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose) || (0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $6e7229751bd94ff2$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) === 1) {
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, 0));
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[head]);
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $6e7229751bd94ff2$var$_size).value--;
    return head;
}
function $6e7229751bd94ff2$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $6e7229751bd94ff2$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $6e7229751bd94ff2$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $6e7229751bd94ff2$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $6e7229751bd94ff2$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $6e7229751bd94ff2$var$_delete, $6e7229751bd94ff2$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $6e7229751bd94ff2$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $6e7229751bd94ff2$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index] = bf;
    return bf;
}
function $6e7229751bd94ff2$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $6e7229751bd94ff2$var$AC;
}
function $6e7229751bd94ff2$var$connect(p, n) {
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[n] = p;
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[p] = n;
}
function $6e7229751bd94ff2$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail)) {
        if (index === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_head)) (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[index]);
        else (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_connect, $6e7229751bd94ff2$var$connect).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[index], (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[index]);
        (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_connect, $6e7229751bd94ff2$var$connect).call(this, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail), index);
        (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, index);
    }
}
function $6e7229751bd94ff2$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_size) === 1) (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_clear, $6e7229751bd94ff2$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose) || (0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $6e7229751bd94ff2$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_tail)) (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $6e7229751bd94ff2$var$_head)) (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[index];
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[pi] = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_next)[index];
                    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[ni] = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $6e7229751bd94ff2$var$_size).value--;
                (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $6e7229751bd94ff2$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $6e7229751bd94ff2$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_rindexes, $6e7229751bd94ff2$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $6e7229751bd94ff2$var$_isBackgroundFetch, $6e7229751bd94ff2$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList)[index];
                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $6e7229751bd94ff2$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyMap).clear();
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts)) {
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_ttls).fill(0);
        (0, $el4bI._)(this, $6e7229751bd94ff2$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes)) (0, $el4bI._)(this, $6e7229751bd94ff2$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_head, 0);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_tail, 0);
    (0, $el4bI._)(this, $6e7229751bd94ff2$var$_free).length = 0;
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $6e7229751bd94ff2$var$_size, 0);
    if ((0, $el4bI._)(this, $6e7229751bd94ff2$var$_hasDisposeAfter) && (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $6e7229751bd94ff2$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $6e7229751bd94ff2$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});



parcelRegister("6Y0p7", function(module, exports) {
"use strict";
var $5128a8ed2b6b9a9d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5128a8ed2b6b9a9d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5128a8ed2b6b9a9d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5128a8ed2b6b9a9d$var$__exportStar((parcelRequire("2oowH")), module.exports);

});
parcelRegister("2oowH", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsHypermedia = void 0;

var $8UQh4 = parcelRequire("8UQh4");

var $kNNoa = parcelRequire("kNNoa");

var $6feGO = parcelRequire("6feGO");
/**
 * A comunica Hypermedia RDF Update Quads Actor.
 */ var $1be0d91ca6aacd3e$var$ActorRdfUpdateQuadsHypermedia = /*#__PURE__*/ function(_bus_rdf_update_quads_1_ActorRdfUpdateQuadsDestination) {
    (0, $i3fW3._)(ActorRdfUpdateQuadsHypermedia, _bus_rdf_update_quads_1_ActorRdfUpdateQuadsDestination);
    function ActorRdfUpdateQuadsHypermedia(args) {
        (0, $jGAMp._)(this, ActorRdfUpdateQuadsHypermedia);
        var _this;
        _this = (0, $kzDuW._)(this, ActorRdfUpdateQuadsHypermedia, [
            args
        ]);
        _this.cache = _this.cacheSize ? new $6feGO.LRUCache({
            max: _this.cacheSize
        }) : undefined;
        var cache = _this.cache;
        if (cache) _this.httpInvalidator.addInvalidateListener(function(param) {
            var url = param.url;
            return url ? cache["delete"](url) : cache.clear();
        });
        return _this;
    }
    (0, $byiyg._)(ActorRdfUpdateQuadsHypermedia, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var url;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        url = (0, $8UQh4.getContextDestinationUrl)((0, $8UQh4.getContextDestination)(action.context));
                        if (!url) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only update quads against a single destination URL."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getDestination",
            value: function getDestination(context) {
                var _this = this;
                var dataDestination = (0, $8UQh4.getContextDestination)(context);
                var url = (0, $8UQh4.getContextDestinationUrl)(dataDestination);
                // Try to read from cache
                if (this.cache && this.cache.has(url)) return this.cache.get(url);
                // Otherwise, call mediators
                var ret = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var metadata, exists, _dereferenceRdfOutput_metadata, dereferenceRdfOutput, rdfMetadataOuput, e, destination;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        this.mediatorDereferenceRdf.mediate({
                                            context: context,
                                            url: url,
                                            acceptErrors: true
                                        })
                                    ];
                                case 1:
                                    dereferenceRdfOutput = _state.sent();
                                    exists = dereferenceRdfOutput.exists;
                                    url = dereferenceRdfOutput.url;
                                    return [
                                        4,
                                        this.mediatorMetadata.mediate({
                                            context: context,
                                            url: url,
                                            quads: dereferenceRdfOutput.data,
                                            triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
                                        })
                                    ];
                                case 2:
                                    rdfMetadataOuput = _state.sent();
                                    return [
                                        4,
                                        this.mediatorMetadataExtract.mediate({
                                            context: context,
                                            url: url,
                                            metadata: rdfMetadataOuput.metadata,
                                            headers: dereferenceRdfOutput.headers,
                                            requestTime: dereferenceRdfOutput.requestTime
                                        })
                                    ];
                                case 3:
                                    metadata = _state.sent().metadata;
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    metadata = {};
                                    exists = false;
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        4,
                                        this.mediatorRdfUpdateHypermedia.mediate({
                                            context: context,
                                            url: url,
                                            metadata: metadata,
                                            exists: exists,
                                            forceDestinationType: (0, $8UQh4.getDataDestinationType)(dataDestination)
                                        })
                                    ];
                                case 6:
                                    destination = _state.sent().destination;
                                    return [
                                        2,
                                        destination
                                    ];
                            }
                        });
                    }).call(_this);
                }();
                if (this.cache) this.cache.set(url, ret);
                return ret;
            }
        }
    ]);
    return ActorRdfUpdateQuadsHypermedia;
}($8UQh4.ActorRdfUpdateQuadsDestination);
module.exports.ActorRdfUpdateQuadsHypermedia = $1be0d91ca6aacd3e$var$ActorRdfUpdateQuadsHypermedia;

});
parcelRegister("6feGO", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $48bf89d38dbd834a$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $48bf89d38dbd834a$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $48bf89d38dbd834a$var$warned = new Set();
/* c8 ignore start */ var $48bf89d38dbd834a$var$PROCESS = {};
/* c8 ignore start */ var $48bf89d38dbd834a$var$emitWarning = function(msg, type, code, fn) {
    typeof $48bf89d38dbd834a$var$PROCESS.emitWarning === 'function' ? $48bf89d38dbd834a$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $48bf89d38dbd834a$var$AC = globalThis.AbortController;
var $48bf89d38dbd834a$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $48bf89d38dbd834a$var$AC === 'undefined') {
    var $48bf89d38dbd834a$var$_PROCESS_env;
    //@ts-ignore
    $48bf89d38dbd834a$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $48bf89d38dbd834a$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $48bf89d38dbd834a$var$AS());
            $48bf89d38dbd834a$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $48bf89d38dbd834a$var$printACPolyfillWarning = (($48bf89d38dbd834a$var$_PROCESS_env = $48bf89d38dbd834a$var$PROCESS.env) === null || $48bf89d38dbd834a$var$_PROCESS_env === void 0 ? void 0 : $48bf89d38dbd834a$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $48bf89d38dbd834a$var$warnACPolyfill = function() {
        if (!$48bf89d38dbd834a$var$printACPolyfillWarning) return;
        $48bf89d38dbd834a$var$printACPolyfillWarning = false;
        $48bf89d38dbd834a$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $48bf89d38dbd834a$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $48bf89d38dbd834a$var$shouldWarn = function(code) {
    return !$48bf89d38dbd834a$var$warned.has(code);
};
var $48bf89d38dbd834a$var$TYPE = Symbol('type');
var $48bf89d38dbd834a$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $48bf89d38dbd834a$var$getUintArray = function(max) {
    return !$48bf89d38dbd834a$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $48bf89d38dbd834a$var$ZeroArray : null;
};
/* c8 ignore stop */ var $48bf89d38dbd834a$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $48bf89d38dbd834a$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $48bf89d38dbd834a$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $48bf89d38dbd834a$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $48bf89d38dbd834a$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $48bf89d38dbd834a$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $48bf89d38dbd834a$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$48bf89d38dbd834a$var$_max = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_maxSize = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_dispose = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$48bf89d38dbd834a$var$_size = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_keyMap = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_keyList = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_valList = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_next = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_prev = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_head = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_tail = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_free = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_disposed = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_sizes = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_starts = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_ttls = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$48bf89d38dbd834a$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $48bf89d38dbd834a$var$_isStale = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_requireSize = /*#__PURE__*/ new WeakMap(), $48bf89d38dbd834a$var$_indexes = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_rindexes = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_evict = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_connect = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_delete = /*#__PURE__*/ new WeakSet(), $48bf89d38dbd834a$var$_clear = /*#__PURE__*/ new WeakSet();
var $48bf89d38dbd834a$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_indexes);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_rindexes);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_isValidIndex);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_evict);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_backgroundFetch);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_connect);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_moveToTail);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_delete);
        (0, $bA8rW._)(this, $48bf89d38dbd834a$var$_clear);
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $48bf89d38dbd834a$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$48bf89d38dbd834a$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $48bf89d38dbd834a$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_max, max);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, 0);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, 0);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_free, $48bf89d38dbd834a$var$Stack.create(max));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_size, 0);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_hasDispose, !!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_dispose));
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize) !== 0) {
                if (!$48bf89d38dbd834a$var$isPosInt((0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$48bf89d38dbd834a$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_initializeSizeTracking, $48bf89d38dbd834a$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $48bf89d38dbd834a$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$48bf89d38dbd834a$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_initializeTTLTracking, $48bf89d38dbd834a$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $48bf89d38dbd834a$var$_max) && !(0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($48bf89d38dbd834a$var$shouldWarn(code)) {
                $48bf89d38dbd834a$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $48bf89d38dbd834a$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i],
                                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i],
                                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($48bf89d38dbd834a$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes)) entry.size = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $48bf89d38dbd834a$var$perf.now() - (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes)) entry.size = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $48bf89d38dbd834a$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) === 0 ? (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail) : (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).length !== 0 ? (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).pop() : (0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_max) ? (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_evict, $48bf89d38dbd834a$var$evict).call(this, false) : (0, $el4bI._)(this, $48bf89d38dbd834a$var$_size);
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[(0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail)] = index;
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[index] = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail);
                    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, index);
                    (0, $3cNKp._)(this, $48bf89d38dbd834a$var$_size).value++;
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_moveToTail, $48bf89d38dbd834a$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $48bf89d38dbd834a$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $48bf89d38dbd834a$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls)) (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_initializeTTLTracking, $48bf89d38dbd834a$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $48bf89d38dbd834a$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $48bf89d38dbd834a$var$_size)){
                        var val = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[(0, $el4bI._)(this, $48bf89d38dbd834a$var$_head)];
                        (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_evict, $48bf89d38dbd834a$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $48bf89d38dbd834a$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $48bf89d38dbd834a$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_backgroundFetch, $48bf89d38dbd834a$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_moveToTail, $48bf89d38dbd834a$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_backgroundFetch, $48bf89d38dbd834a$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_moveToTail, $48bf89d38dbd834a$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_clear, $48bf89d38dbd834a$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_starts),
                    ttls: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_ttls),
                    sizes: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_keyList),
                    valList: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_valList),
                    next: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_next),
                    prev: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $48bf89d38dbd834a$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $48bf89d38dbd834a$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $48bf89d38dbd834a$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $48bf89d38dbd834a$var$_backgroundFetch, $48bf89d38dbd834a$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $48bf89d38dbd834a$var$_moveToTail, $48bf89d38dbd834a$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $48bf89d38dbd834a$var$_indexes, $48bf89d38dbd834a$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $48bf89d38dbd834a$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $48bf89d38dbd834a$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $48bf89d38dbd834a$var$ZeroArray((0, $el4bI._)(this, $48bf89d38dbd834a$var$_max));
    var starts = new $48bf89d38dbd834a$var$ZeroArray((0, $el4bI._)(this, $48bf89d38dbd834a$var$_max));
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_ttls, ttls);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_starts, starts);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $48bf89d38dbd834a$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $48bf89d38dbd834a$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(_this1, (0, $el4bI._)(_this1, $48bf89d38dbd834a$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $48bf89d38dbd834a$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $48bf89d38dbd834a$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $48bf89d38dbd834a$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $48bf89d38dbd834a$var$ZeroArray((0, $el4bI._)(this, $48bf89d38dbd834a$var$_max));
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_sizes, sizes);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $48bf89d38dbd834a$var$_calculatedSize, (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$48bf89d38dbd834a$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$48bf89d38dbd834a$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $48bf89d38dbd834a$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $48bf89d38dbd834a$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $48bf89d38dbd834a$var$_evict, $48bf89d38dbd834a$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $48bf89d38dbd834a$var$_calculatedSize, (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_calculatedSize);
        }
    });
}
function $48bf89d38dbd834a$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isValidIndex, $48bf89d38dbd834a$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $48bf89d38dbd834a$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isValidIndex, $48bf89d38dbd834a$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $48bf89d38dbd834a$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $48bf89d38dbd834a$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get((0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[index]) === index;
}
function $48bf89d38dbd834a$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_head);
    var k = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[head];
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose) || (0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $48bf89d38dbd834a$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) === 1) {
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, 0));
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[head]);
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $48bf89d38dbd834a$var$_size).value--;
    return head;
}
function $48bf89d38dbd834a$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $48bf89d38dbd834a$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $48bf89d38dbd834a$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $48bf89d38dbd834a$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $48bf89d38dbd834a$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $48bf89d38dbd834a$var$_delete, $48bf89d38dbd834a$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $48bf89d38dbd834a$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $48bf89d38dbd834a$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index] = bf;
    return bf;
}
function $48bf89d38dbd834a$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $48bf89d38dbd834a$var$AC;
}
function $48bf89d38dbd834a$var$connect(p, n) {
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[n] = p;
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[p] = n;
}
function $48bf89d38dbd834a$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail)) {
        if (index === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_head)) (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[index]);
        else (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_connect, $48bf89d38dbd834a$var$connect).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[index], (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[index]);
        (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_connect, $48bf89d38dbd834a$var$connect).call(this, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail), index);
        (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, index);
    }
}
function $48bf89d38dbd834a$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_size) === 1) (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_clear, $48bf89d38dbd834a$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose) || (0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $48bf89d38dbd834a$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_tail)) (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $48bf89d38dbd834a$var$_head)) (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[index];
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[pi] = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_next)[index];
                    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[ni] = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $48bf89d38dbd834a$var$_size).value--;
                (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $48bf89d38dbd834a$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $48bf89d38dbd834a$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_rindexes, $48bf89d38dbd834a$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $48bf89d38dbd834a$var$_isBackgroundFetch, $48bf89d38dbd834a$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList)[index];
                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $48bf89d38dbd834a$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyMap).clear();
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts)) {
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_ttls).fill(0);
        (0, $el4bI._)(this, $48bf89d38dbd834a$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes)) (0, $el4bI._)(this, $48bf89d38dbd834a$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_head, 0);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_tail, 0);
    (0, $el4bI._)(this, $48bf89d38dbd834a$var$_free).length = 0;
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $48bf89d38dbd834a$var$_size, 0);
    if ((0, $el4bI._)(this, $48bf89d38dbd834a$var$_hasDisposeAfter) && (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $48bf89d38dbd834a$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $48bf89d38dbd834a$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});



parcelRegister("caezk", function(module, exports) {
"use strict";
var $8db1b8466eba0355$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8db1b8466eba0355$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8db1b8466eba0355$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8db1b8466eba0355$var$__exportStar((parcelRequire("buBin")), module.exports);

$8db1b8466eba0355$var$__exportStar((parcelRequire("cxpC1")), module.exports);

});
parcelRegister("buBin", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserverHttp = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * Observes HTTP actions, and maintains a counter of the number of requests.
 */ var $85df6d28585dd1fa$var$ActionObserverHttp = /*#__PURE__*/ function(_core_1_ActionObserver) {
    (0, $i3fW3._)(ActionObserverHttp, _core_1_ActionObserver);
    function ActionObserverHttp(args) {
        (0, $jGAMp._)(this, ActionObserverHttp);
        var _this;
        _this = (0, $kzDuW._)(this, ActionObserverHttp, [
            args
        ]);
        _this.requests = 0;
        _this.bus.subscribeObserver(_this);
        _this.httpInvalidator.addInvalidateListener(function() {
            _this.requests = 0;
        });
        return _this;
    }
    (0, $byiyg._)(ActionObserverHttp, [
        {
            /* eslint-enable max-len */ key: "onRun",
            value: function onRun(actor, _action, _output) {
                if (this.observedActors.includes(actor.name)) this.requests++;
            }
        }
    ]);
    return ActionObserverHttp;
}($kNNoa.ActionObserver);
module.exports.ActionObserverHttp = $85df6d28585dd1fa$var$ActionObserverHttp;

});

parcelRegister("cxpC1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlJson = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $kNNoa = parcelRequire("kNNoa");

var $aafx9 = parcelRequire("aafx9");

var $8wP57 = parcelRequire("8wP57");
/**
 * A comunica sparql-results+xml Serialize Actor.
 */ var $920c6f2b3219ed52$var$ActorQueryResultSerializeSparqlJson = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeSparqlJson, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeSparqlJson(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeSparqlJson);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeSparqlJson, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeSparqlJson, [
        {
            key: "testHandleChecked",
            value: function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'boolean'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams or booleans.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, data, head, metadata, end, resultStream, first;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                data = new $8wP57.Readable();
                                // Write head
                                head = {};
                                if (!(action.type === 'bindings')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    action.metadata()
                                ];
                            case 1:
                                metadata = _state.sent();
                                if (metadata.variables.length > 0) head.vars = metadata.variables.map(function(variable) {
                                    return variable.variable.value;
                                });
                                _state.label = 2;
                            case 2:
                                data.push('{"head": '.concat(JSON.stringify(head), ",\n"));
                                if (action.type === 'bindings') {
                                    end = function end(cb) {
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        cb()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    };
                                    resultStream = action.bindingsStream;
                                    data.push('"results": { "bindings": [\n');
                                    first = true;
                                    // Write bindings
                                    data.wrap(// JSON SPARQL results spec does not allow unbound variables and blank node bindings
                                    (0, $aafx9.wrap)(resultStream).map(function(bindings) {
                                        var res = "".concat(first ? '' : ',\n').concat(JSON.stringify(Object.fromEntries((0, $7WNf6._)(bindings).map(function(param) {
                                            var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                            return [
                                                key.value,
                                                ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value)
                                            ];
                                        }))));
                                        first = false;
                                        return res;
                                    }).append((0, $aafx9.wrap)(end(function() {
                                        return "\n]}".concat(_this.emitMetadata ? ',\n"metadata": { "httpRequests": '.concat(_this.httpObserver.requests, " }") : '', "}\n");
                                    }))));
                                } else data.wrap((0, $aafx9.wrap)(action.execute().then(function(value) {
                                    return [
                                        '"boolean":'.concat(value, "\n}\n")
                                    ];
                                })));
                                return [
                                    2,
                                    {
                                        data: data
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "bindingToJsonBindings",
            value: /* eslint-enable max-len */ /**
     * Converts an RDF term to its JSON representation.
     * @param {RDF.Term} value An RDF term.
     * @return {any} A JSON object.
     */ function bindingToJsonBindings(value) {
                if (value.termType === 'Literal') {
                    var literal = value;
                    var jsonValue = {
                        value: literal.value,
                        type: 'literal'
                    };
                    var language = literal.language, datatype = literal.datatype;
                    if (language) jsonValue['xml:lang'] = language;
                    else if (datatype && datatype.value !== 'http://www.w3.org/2001/XMLSchema#string') jsonValue.datatype = datatype.value;
                    return jsonValue;
                }
                if (value.termType === 'BlankNode') return {
                    value: value.value,
                    type: 'bnode'
                };
                if (value.termType === 'Quad') return {
                    value: {
                        subject: ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.subject),
                        predicate: ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.predicate),
                        object: ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.object)
                    },
                    type: 'triple'
                };
                return {
                    value: value.value,
                    type: 'uri'
                };
            }
        }
    ]);
    return ActorQueryResultSerializeSparqlJson;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeSparqlJson = $920c6f2b3219ed52$var$ActorQueryResultSerializeSparqlJson;

});
parcelRegister("8wP57", function(module, exports) {
'use strict';

var $eVq7Q = parcelRequire("eVq7Q");

var $4eMD9 = parcelRequire("4eMD9");
var $6358efa069f91a01$var$originalDestroy = $eVq7Q.Readable.destroy;
module.exports = $eVq7Q.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $eVq7Q._uint8ArrayToBuffer;
module.exports._isUint8Array = $eVq7Q._isUint8Array;
module.exports.isDisturbed = $eVq7Q.isDisturbed;
module.exports.isErrored = $eVq7Q.isErrored;
module.exports.isReadable = $eVq7Q.isReadable;
module.exports.Readable = $eVq7Q.Readable;
module.exports.Writable = $eVq7Q.Writable;
module.exports.Duplex = $eVq7Q.Duplex;
module.exports.Transform = $eVq7Q.Transform;
module.exports.PassThrough = $eVq7Q.PassThrough;
module.exports.addAbortSignal = $eVq7Q.addAbortSignal;
module.exports.finished = $eVq7Q.finished;
module.exports.destroy = $eVq7Q.destroy;
module.exports.destroy = $6358efa069f91a01$var$originalDestroy;
module.exports.pipeline = $eVq7Q.pipeline;
module.exports.compose = $eVq7Q.compose;
Object.defineProperty($eVq7Q, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $4eMD9;
    }
});
module.exports.Stream = $eVq7Q.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("eVq7Q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $efY7W = parcelRequire("efY7W");
var $addaa78d83dee442$require$Buffer = $efY7W.Buffer;

var $bevD6 = parcelRequire("bevD6");
/* replacement end */ var $addaa78d83dee442$var$ObjectDefineProperty = $bevD6.ObjectDefineProperty, $addaa78d83dee442$var$ObjectKeys = $bevD6.ObjectKeys, $addaa78d83dee442$var$ReflectApply = $bevD6.ReflectApply;

var $4IlY3 = parcelRequire("4IlY3");
var $addaa78d83dee442$var$_require_promisify = $4IlY3.promisify, $addaa78d83dee442$var$customPromisify = $addaa78d83dee442$var$_require_promisify.custom;

var $brAao = parcelRequire("brAao");
var $addaa78d83dee442$var$streamReturningOperators = $brAao.streamReturningOperators, $addaa78d83dee442$var$promiseReturningOperators = $brAao.promiseReturningOperators;

var $bXN8a = parcelRequire("bXN8a");
var $addaa78d83dee442$var$ERR_ILLEGAL_CONSTRUCTOR = $bXN8a.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $76haz = parcelRequire("76haz");

var $l9bFC = parcelRequire("l9bFC");
var $addaa78d83dee442$var$setDefaultHighWaterMark = $l9bFC.setDefaultHighWaterMark, $addaa78d83dee442$var$getDefaultHighWaterMark = $l9bFC.getDefaultHighWaterMark;

var $1cPA2 = parcelRequire("1cPA2");
var $addaa78d83dee442$require$pipeline = $1cPA2.pipeline;

var $6dqF3 = parcelRequire("6dqF3");
var $addaa78d83dee442$require$destroyer = $6dqF3.destroyer;

var $4LEgK = parcelRequire("4LEgK");
var $addaa78d83dee442$var$internalBuffer = {};

var $4eMD9 = parcelRequire("4eMD9");

var $l3TFC = parcelRequire("l3TFC");

var $addaa78d83dee442$var$Stream = module.exports = (parcelRequire("46v1I")).Stream;
$addaa78d83dee442$var$Stream.isDestroyed = $l3TFC.isDestroyed;
$addaa78d83dee442$var$Stream.isDisturbed = $l3TFC.isDisturbed;
$addaa78d83dee442$var$Stream.isErrored = $l3TFC.isErrored;
$addaa78d83dee442$var$Stream.isReadable = $l3TFC.isReadable;
$addaa78d83dee442$var$Stream.isWritable = $l3TFC.isWritable;

$addaa78d83dee442$var$Stream.Readable = (parcelRequire("bZnyC"));
var $addaa78d83dee442$var$_iteratorNormalCompletion = true, $addaa78d83dee442$var$_didIteratorError = false, $addaa78d83dee442$var$_iteratorError = undefined;
try {
    for(var $addaa78d83dee442$var$_iterator = $addaa78d83dee442$var$ObjectKeys($addaa78d83dee442$var$streamReturningOperators)[Symbol.iterator](), $addaa78d83dee442$var$_step; !($addaa78d83dee442$var$_iteratorNormalCompletion = ($addaa78d83dee442$var$_step = $addaa78d83dee442$var$_iterator.next()).done); $addaa78d83dee442$var$_iteratorNormalCompletion = true){
        var $addaa78d83dee442$var$key = $addaa78d83dee442$var$_step.value;
        var $addaa78d83dee442$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $addaa78d83dee442$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $addaa78d83dee442$var$Stream.Readable.from($addaa78d83dee442$var$ReflectApply($addaa78d83dee442$var$op, this, args));
        };
        var $addaa78d83dee442$var$op = $addaa78d83dee442$var$streamReturningOperators[$addaa78d83dee442$var$key];
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$fn, 'name', {
            __proto__: null,
            value: $addaa78d83dee442$var$op.name
        });
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$fn, 'length', {
            __proto__: null,
            value: $addaa78d83dee442$var$op.length
        });
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$Stream.Readable.prototype, $addaa78d83dee442$var$key, {
            __proto__: null,
            value: $addaa78d83dee442$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $addaa78d83dee442$var$_didIteratorError = true;
    $addaa78d83dee442$var$_iteratorError = err;
} finally{
    try {
        if (!$addaa78d83dee442$var$_iteratorNormalCompletion && $addaa78d83dee442$var$_iterator["return"] != null) {
            $addaa78d83dee442$var$_iterator["return"]();
        }
    } finally{
        if ($addaa78d83dee442$var$_didIteratorError) {
            throw $addaa78d83dee442$var$_iteratorError;
        }
    }
}
var $addaa78d83dee442$var$_iteratorNormalCompletion1 = true, $addaa78d83dee442$var$_didIteratorError1 = false, $addaa78d83dee442$var$_iteratorError1 = undefined;
try {
    for(var $addaa78d83dee442$var$_iterator1 = $addaa78d83dee442$var$ObjectKeys($addaa78d83dee442$var$promiseReturningOperators)[Symbol.iterator](), $addaa78d83dee442$var$_step1; !($addaa78d83dee442$var$_iteratorNormalCompletion1 = ($addaa78d83dee442$var$_step1 = $addaa78d83dee442$var$_iterator1.next()).done); $addaa78d83dee442$var$_iteratorNormalCompletion1 = true){
        var $addaa78d83dee442$var$key1 = $addaa78d83dee442$var$_step1.value;
        var $addaa78d83dee442$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $addaa78d83dee442$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $addaa78d83dee442$var$ReflectApply($addaa78d83dee442$var$op1, this, args);
        };
        var $addaa78d83dee442$var$op1 = $addaa78d83dee442$var$promiseReturningOperators[$addaa78d83dee442$var$key1];
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$fn1, 'name', {
            __proto__: null,
            value: $addaa78d83dee442$var$op1.name
        });
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$fn1, 'length', {
            __proto__: null,
            value: $addaa78d83dee442$var$op1.length
        });
        $addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$Stream.Readable.prototype, $addaa78d83dee442$var$key1, {
            __proto__: null,
            value: $addaa78d83dee442$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $addaa78d83dee442$var$_didIteratorError1 = true;
    $addaa78d83dee442$var$_iteratorError1 = err;
} finally{
    try {
        if (!$addaa78d83dee442$var$_iteratorNormalCompletion1 && $addaa78d83dee442$var$_iterator1["return"] != null) {
            $addaa78d83dee442$var$_iterator1["return"]();
        }
    } finally{
        if ($addaa78d83dee442$var$_didIteratorError1) {
            throw $addaa78d83dee442$var$_iteratorError1;
        }
    }
}

$addaa78d83dee442$var$Stream.Writable = (parcelRequire("cE7Uu"));

$addaa78d83dee442$var$Stream.Duplex = (parcelRequire("igMe9"));

$addaa78d83dee442$var$Stream.Transform = (parcelRequire("bHII3"));

$addaa78d83dee442$var$Stream.PassThrough = (parcelRequire("5XSOL"));
$addaa78d83dee442$var$Stream.pipeline = $addaa78d83dee442$require$pipeline;

var $3Ra6D = parcelRequire("3Ra6D");
var $addaa78d83dee442$require$addAbortSignal = $3Ra6D.addAbortSignal;
$addaa78d83dee442$var$Stream.addAbortSignal = $addaa78d83dee442$require$addAbortSignal;
$addaa78d83dee442$var$Stream.finished = $4LEgK;
$addaa78d83dee442$var$Stream.destroy = $addaa78d83dee442$require$destroyer;
$addaa78d83dee442$var$Stream.compose = $76haz;
$addaa78d83dee442$var$Stream.setDefaultHighWaterMark = $addaa78d83dee442$var$setDefaultHighWaterMark;
$addaa78d83dee442$var$Stream.getDefaultHighWaterMark = $addaa78d83dee442$var$getDefaultHighWaterMark;
$addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $4eMD9;
    }
});
$addaa78d83dee442$var$ObjectDefineProperty($addaa78d83dee442$require$pipeline, $addaa78d83dee442$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $4eMD9.pipeline;
    }
});
$addaa78d83dee442$var$ObjectDefineProperty($4LEgK, $addaa78d83dee442$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $4eMD9.finished;
    }
});
// Backwards-compat with node 0.4.x
$addaa78d83dee442$var$Stream.Stream = $addaa78d83dee442$var$Stream;
$addaa78d83dee442$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$addaa78d83dee442$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $addaa78d83dee442$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("efY7W", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a6111b5e02ce275d$export$a143d493d941bafc; }, function (v) { return $a6111b5e02ce275d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a6111b5e02ce275d$export$f99ded8fe4b79145; }, function (v) { return $a6111b5e02ce275d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $a6111b5e02ce275d$export$a143d493d941bafc;
var $a6111b5e02ce275d$export$e4cf37d7f6fb9e0a;
var $a6111b5e02ce275d$export$f99ded8fe4b79145;
var $a6111b5e02ce275d$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $a6111b5e02ce275d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a6111b5e02ce275d$export$a143d493d941bafc = $a6111b5e02ce275d$var$Buffer;
$a6111b5e02ce275d$export$e4cf37d7f6fb9e0a = $a6111b5e02ce275d$var$SlowBuffer;
$a6111b5e02ce275d$export$f99ded8fe4b79145 = 50;
var $a6111b5e02ce275d$var$K_MAX_LENGTH = 0x7fffffff;
$a6111b5e02ce275d$export$599f31c3813fae4d = $a6111b5e02ce275d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a6111b5e02ce275d$var$Buffer.TYPED_ARRAY_SUPPORT = $a6111b5e02ce275d$var$typedArraySupport();
if (!$a6111b5e02ce275d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a6111b5e02ce275d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a6111b5e02ce275d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$a6111b5e02ce275d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a6111b5e02ce275d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$a6111b5e02ce275d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a6111b5e02ce275d$var$createBuffer(length) {
    if (length > $a6111b5e02ce275d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a6111b5e02ce275d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a6111b5e02ce275d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a6111b5e02ce275d$var$allocUnsafe(arg);
    }
    return $a6111b5e02ce275d$var$from(arg, encodingOrOffset, length);
}
$a6111b5e02ce275d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a6111b5e02ce275d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a6111b5e02ce275d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a6111b5e02ce275d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($a6111b5e02ce275d$var$isInstance(value, ArrayBuffer) || value && $a6111b5e02ce275d$var$isInstance(value.buffer, ArrayBuffer)) return $a6111b5e02ce275d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a6111b5e02ce275d$var$isInstance(value, SharedArrayBuffer) || value && $a6111b5e02ce275d$var$isInstance(value.buffer, SharedArrayBuffer))) return $a6111b5e02ce275d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a6111b5e02ce275d$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a6111b5e02ce275d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a6111b5e02ce275d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a6111b5e02ce275d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a6111b5e02ce275d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a6111b5e02ce275d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a6111b5e02ce275d$var$Buffer, Uint8Array);
function $a6111b5e02ce275d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a6111b5e02ce275d$var$alloc(size, fill, encoding) {
    $a6111b5e02ce275d$var$assertSize(size);
    if (size <= 0) return $a6111b5e02ce275d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a6111b5e02ce275d$var$createBuffer(size).fill(fill, encoding) : $a6111b5e02ce275d$var$createBuffer(size).fill(fill);
    return $a6111b5e02ce275d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a6111b5e02ce275d$var$Buffer.alloc = function(size, fill, encoding) {
    return $a6111b5e02ce275d$var$alloc(size, fill, encoding);
};
function $a6111b5e02ce275d$var$allocUnsafe(size) {
    $a6111b5e02ce275d$var$assertSize(size);
    return $a6111b5e02ce275d$var$createBuffer(size < 0 ? 0 : $a6111b5e02ce275d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a6111b5e02ce275d$var$Buffer.allocUnsafe = function(size) {
    return $a6111b5e02ce275d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a6111b5e02ce275d$var$Buffer.allocUnsafeSlow = function(size) {
    return $a6111b5e02ce275d$var$allocUnsafe(size);
};
function $a6111b5e02ce275d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a6111b5e02ce275d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $a6111b5e02ce275d$var$byteLength(string, encoding) | 0;
    var buf = $a6111b5e02ce275d$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a6111b5e02ce275d$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a6111b5e02ce275d$var$checked(array.length) | 0;
    var buf = $a6111b5e02ce275d$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a6111b5e02ce275d$var$fromArrayView(arrayView) {
    if ($a6111b5e02ce275d$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a6111b5e02ce275d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a6111b5e02ce275d$var$fromArrayLike(arrayView);
}
function $a6111b5e02ce275d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a6111b5e02ce275d$var$Buffer.prototype);
    return buf;
}
function $a6111b5e02ce275d$var$fromObject(obj) {
    if ($a6111b5e02ce275d$var$Buffer.isBuffer(obj)) {
        var len = $a6111b5e02ce275d$var$checked(obj.length) | 0;
        var buf = $a6111b5e02ce275d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a6111b5e02ce275d$var$numberIsNaN(obj.length)) return $a6111b5e02ce275d$var$createBuffer(0);
        return $a6111b5e02ce275d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a6111b5e02ce275d$var$fromArrayLike(obj.data);
}
function $a6111b5e02ce275d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a6111b5e02ce275d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a6111b5e02ce275d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a6111b5e02ce275d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a6111b5e02ce275d$var$Buffer.alloc(+length);
}
$a6111b5e02ce275d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a6111b5e02ce275d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a6111b5e02ce275d$var$Buffer.compare = function compare(a, b) {
    if ($a6111b5e02ce275d$var$isInstance(a, Uint8Array)) a = $a6111b5e02ce275d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a6111b5e02ce275d$var$isInstance(b, Uint8Array)) b = $a6111b5e02ce275d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a6111b5e02ce275d$var$Buffer.isBuffer(a) || !$a6111b5e02ce275d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a6111b5e02ce275d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a6111b5e02ce275d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a6111b5e02ce275d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a6111b5e02ce275d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a6111b5e02ce275d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a6111b5e02ce275d$var$Buffer.isBuffer(buf)) buf = $a6111b5e02ce275d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a6111b5e02ce275d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a6111b5e02ce275d$var$byteLength(string, encoding) {
    if ($a6111b5e02ce275d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a6111b5e02ce275d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a6111b5e02ce275d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a6111b5e02ce275d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a6111b5e02ce275d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a6111b5e02ce275d$var$Buffer.byteLength = $a6111b5e02ce275d$var$byteLength;
function $a6111b5e02ce275d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a6111b5e02ce275d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a6111b5e02ce275d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a6111b5e02ce275d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a6111b5e02ce275d$var$latin1Slice(this, start, end);
        case 'base64':
            return $a6111b5e02ce275d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a6111b5e02ce275d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a6111b5e02ce275d$var$Buffer.prototype._isBuffer = true;
function $a6111b5e02ce275d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a6111b5e02ce275d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$a6111b5e02ce275d$var$swap(this, i, i + 1);
    return this;
};
$a6111b5e02ce275d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $a6111b5e02ce275d$var$swap(this, i, i + 3);
        $a6111b5e02ce275d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a6111b5e02ce275d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $a6111b5e02ce275d$var$swap(this, i, i + 7);
        $a6111b5e02ce275d$var$swap(this, i + 1, i + 6);
        $a6111b5e02ce275d$var$swap(this, i + 2, i + 5);
        $a6111b5e02ce275d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a6111b5e02ce275d$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a6111b5e02ce275d$var$utf8Slice(this, 0, length);
    return $a6111b5e02ce275d$var$slowToString.apply(this, arguments);
};
$a6111b5e02ce275d$var$Buffer.prototype.toLocaleString = $a6111b5e02ce275d$var$Buffer.prototype.toString;
$a6111b5e02ce275d$var$Buffer.prototype.equals = function equals(b) {
    if (!$a6111b5e02ce275d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a6111b5e02ce275d$var$Buffer.compare(this, b) === 0;
};
$a6111b5e02ce275d$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $a6111b5e02ce275d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a6111b5e02ce275d$var$customInspectSymbol) $a6111b5e02ce275d$var$Buffer.prototype[$a6111b5e02ce275d$var$customInspectSymbol] = $a6111b5e02ce275d$var$Buffer.prototype.inspect;
$a6111b5e02ce275d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a6111b5e02ce275d$var$isInstance(target, Uint8Array)) target = $a6111b5e02ce275d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a6111b5e02ce275d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a6111b5e02ce275d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a6111b5e02ce275d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a6111b5e02ce275d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a6111b5e02ce275d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a6111b5e02ce275d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a6111b5e02ce275d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a6111b5e02ce275d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a6111b5e02ce275d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a6111b5e02ce275d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a6111b5e02ce275d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a6111b5e02ce275d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a6111b5e02ce275d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a6111b5e02ce275d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a6111b5e02ce275d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a6111b5e02ce275d$var$utf8Write(buf, string, offset, length) {
    return $a6111b5e02ce275d$var$blitBuffer($a6111b5e02ce275d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a6111b5e02ce275d$var$asciiWrite(buf, string, offset, length) {
    return $a6111b5e02ce275d$var$blitBuffer($a6111b5e02ce275d$var$asciiToBytes(string), buf, offset, length);
}
function $a6111b5e02ce275d$var$base64Write(buf, string, offset, length) {
    return $a6111b5e02ce275d$var$blitBuffer($a6111b5e02ce275d$var$base64ToBytes(string), buf, offset, length);
}
function $a6111b5e02ce275d$var$ucs2Write(buf, string, offset, length) {
    return $a6111b5e02ce275d$var$blitBuffer($a6111b5e02ce275d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a6111b5e02ce275d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a6111b5e02ce275d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a6111b5e02ce275d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a6111b5e02ce275d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a6111b5e02ce275d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a6111b5e02ce275d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a6111b5e02ce275d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a6111b5e02ce275d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $a6111b5e02ce275d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a6111b5e02ce275d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a6111b5e02ce275d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a6111b5e02ce275d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a6111b5e02ce275d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a6111b5e02ce275d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a6111b5e02ce275d$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a6111b5e02ce275d$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a6111b5e02ce275d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $a6111b5e02ce275d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a6111b5e02ce275d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a6111b5e02ce275d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a6111b5e02ce275d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a6111b5e02ce275d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a6111b5e02ce275d$var$Buffer.prototype.readUintLE = $a6111b5e02ce275d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readUintBE = $a6111b5e02ce275d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readUint8 = $a6111b5e02ce275d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a6111b5e02ce275d$var$Buffer.prototype.readUint16LE = $a6111b5e02ce275d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a6111b5e02ce275d$var$Buffer.prototype.readUint16BE = $a6111b5e02ce275d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a6111b5e02ce275d$var$Buffer.prototype.readUint32LE = $a6111b5e02ce275d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a6111b5e02ce275d$var$Buffer.prototype.readUint32BE = $a6111b5e02ce275d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a6111b5e02ce275d$var$Buffer.prototype.readBigUInt64LE = $a6111b5e02ce275d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a6111b5e02ce275d$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a6111b5e02ce275d$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a6111b5e02ce275d$var$Buffer.prototype.readBigUInt64BE = $a6111b5e02ce275d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a6111b5e02ce275d$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a6111b5e02ce275d$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a6111b5e02ce275d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a6111b5e02ce275d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6111b5e02ce275d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a6111b5e02ce275d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a6111b5e02ce275d$var$Buffer.prototype.readBigInt64LE = $a6111b5e02ce275d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a6111b5e02ce275d$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a6111b5e02ce275d$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$a6111b5e02ce275d$var$Buffer.prototype.readBigInt64BE = $a6111b5e02ce275d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a6111b5e02ce275d$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a6111b5e02ce275d$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$a6111b5e02ce275d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$a6111b5e02ce275d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$a6111b5e02ce275d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$a6111b5e02ce275d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $a6111b5e02ce275d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a6111b5e02ce275d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a6111b5e02ce275d$var$Buffer.prototype.writeUintLE = $a6111b5e02ce275d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6111b5e02ce275d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUintBE = $a6111b5e02ce275d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6111b5e02ce275d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUint8 = $a6111b5e02ce275d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUint16LE = $a6111b5e02ce275d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUint16BE = $a6111b5e02ce275d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUint32LE = $a6111b5e02ce275d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeUint32BE = $a6111b5e02ce275d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a6111b5e02ce275d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a6111b5e02ce275d$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a6111b5e02ce275d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a6111b5e02ce275d$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a6111b5e02ce275d$var$Buffer.prototype.writeBigUInt64LE = $a6111b5e02ce275d$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a6111b5e02ce275d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a6111b5e02ce275d$var$Buffer.prototype.writeBigUInt64BE = $a6111b5e02ce275d$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a6111b5e02ce275d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a6111b5e02ce275d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a6111b5e02ce275d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a6111b5e02ce275d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a6111b5e02ce275d$var$Buffer.prototype.writeBigInt64LE = $a6111b5e02ce275d$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a6111b5e02ce275d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a6111b5e02ce275d$var$Buffer.prototype.writeBigInt64BE = $a6111b5e02ce275d$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a6111b5e02ce275d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a6111b5e02ce275d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a6111b5e02ce275d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a6111b5e02ce275d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a6111b5e02ce275d$var$writeFloat(this, value, offset, true, noAssert);
};
$a6111b5e02ce275d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a6111b5e02ce275d$var$writeFloat(this, value, offset, false, noAssert);
};
function $a6111b5e02ce275d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6111b5e02ce275d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a6111b5e02ce275d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a6111b5e02ce275d$var$writeDouble(this, value, offset, true, noAssert);
};
$a6111b5e02ce275d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a6111b5e02ce275d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a6111b5e02ce275d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a6111b5e02ce275d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a6111b5e02ce275d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a6111b5e02ce275d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a6111b5e02ce275d$var$Buffer.isBuffer(val) ? val : $a6111b5e02ce275d$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $a6111b5e02ce275d$var$errors = {};
function $a6111b5e02ce275d$var$E(sym, getMessage, Base) {
    $a6111b5e02ce275d$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$a6111b5e02ce275d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a6111b5e02ce275d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$a6111b5e02ce275d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $a6111b5e02ce275d$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $a6111b5e02ce275d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $a6111b5e02ce275d$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $a6111b5e02ce275d$var$checkBounds(buf, offset, byteLength) {
    $a6111b5e02ce275d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a6111b5e02ce275d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a6111b5e02ce275d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $a6111b5e02ce275d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a6111b5e02ce275d$var$checkBounds(buf, offset, byteLength);
}
function $a6111b5e02ce275d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a6111b5e02ce275d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a6111b5e02ce275d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a6111b5e02ce275d$var$validateNumber(value, type);
        throw new $a6111b5e02ce275d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a6111b5e02ce275d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a6111b5e02ce275d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $a6111b5e02ce275d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a6111b5e02ce275d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a6111b5e02ce275d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a6111b5e02ce275d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a6111b5e02ce275d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a6111b5e02ce275d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a6111b5e02ce275d$var$base64ToBytes(str) {
    return $abUaD.toByteArray($a6111b5e02ce275d$var$base64clean(str));
}
function $a6111b5e02ce275d$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a6111b5e02ce275d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a6111b5e02ce275d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a6111b5e02ce275d$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a6111b5e02ce275d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a6111b5e02ce275d$var$BufferBigIntNotDefined : fn;
}
function $a6111b5e02ce275d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("bevD6", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $82d98984c29730ed$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $82d98984c29730ed$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("4IlY3", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $efY7W = parcelRequire("efY7W");

var $29GOE = parcelRequire("29GOE");
var $36ec4fcc4c8e9651$var$format = $29GOE.format, $36ec4fcc4c8e9651$var$inspect = $29GOE.inspect;

var $bXN8a = parcelRequire("bXN8a");
var $36ec4fcc4c8e9651$var$ERR_INVALID_ARG_TYPE = $bXN8a.codes.ERR_INVALID_ARG_TYPE;

var $bevD6 = parcelRequire("bevD6");
var $36ec4fcc4c8e9651$var$kResistStopPropagation = $bevD6.kResistStopPropagation, $36ec4fcc4c8e9651$var$AggregateError = $bevD6.AggregateError, $36ec4fcc4c8e9651$var$SymbolDispose = $bevD6.SymbolDispose;

var $36ec4fcc4c8e9651$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $36ec4fcc4c8e9651$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $36ec4fcc4c8e9651$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $36ec4fcc4c8e9651$var$Blob = globalThis.Blob || $efY7W.Blob;
/* eslint-disable indent */ var $36ec4fcc4c8e9651$var$isBlob = typeof $36ec4fcc4c8e9651$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $36ec4fcc4c8e9651$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $36ec4fcc4c8e9651$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $36ec4fcc4c8e9651$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $36ec4fcc4c8e9651$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $36ec4fcc4c8e9651$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $36ec4fcc4c8e9651$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $36ec4fcc4c8e9651$var$format,
    inspect: $36ec4fcc4c8e9651$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $36ec4fcc4c8e9651$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $36ec4fcc4c8e9651$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $36ec4fcc4c8e9651$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $36ec4fcc4c8e9651$var$validateAbortSignal(signal, 'signal');
        $36ec4fcc4c8e9651$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $36ec4fcc4c8e9651$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $36ec4fcc4c8e9651$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $36ec4fcc4c8e9651$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $36ec4fcc4c8e9651$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $36ec4fcc4c8e9651$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("29GOE", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("bXN8a", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $29GOE = parcelRequire("29GOE");
var $8b5b50bcd2b3f453$var$format = $29GOE.format, $8b5b50bcd2b3f453$var$inspect = $29GOE.inspect;

var $bevD6 = parcelRequire("bevD6");
var $8b5b50bcd2b3f453$var$CustomAggregateError = $bevD6.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $8b5b50bcd2b3f453$var$AggregateError = globalThis.AggregateError || $8b5b50bcd2b3f453$var$CustomAggregateError;
var $8b5b50bcd2b3f453$var$kIsNodeError = Symbol('kIsNodeError');
var $8b5b50bcd2b3f453$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $8b5b50bcd2b3f453$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $8b5b50bcd2b3f453$var$nodeInternalPrefix = '__node_internal_';
var $8b5b50bcd2b3f453$var$codes = {};
function $8b5b50bcd2b3f453$var$assert(value, message) {
    if (!value) throw new $8b5b50bcd2b3f453$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $8b5b50bcd2b3f453$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $8b5b50bcd2b3f453$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $8b5b50bcd2b3f453$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $8b5b50bcd2b3f453$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $8b5b50bcd2b3f453$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $8b5b50bcd2b3f453$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $8b5b50bcd2b3f453$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$8b5b50bcd2b3f453$var$kIsNodeError] = true;
    $8b5b50bcd2b3f453$var$codes[code] = NodeError;
}
function $8b5b50bcd2b3f453$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $8b5b50bcd2b3f453$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $8b5b50bcd2b3f453$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $8b5b50bcd2b3f453$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $8b5b50bcd2b3f453$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $8b5b50bcd2b3f453$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$8b5b50bcd2b3f453$var$E('ERR_ASSERTION', '%s', Error);
$8b5b50bcd2b3f453$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $8b5b50bcd2b3f453$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $8b5b50bcd2b3f453$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($8b5b50bcd2b3f453$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($8b5b50bcd2b3f453$var$classRegExp.test(value)) instances.push(value);
            else {
                $8b5b50bcd2b3f453$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $8b5b50bcd2b3f453$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $8b5b50bcd2b3f453$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$8b5b50bcd2b3f453$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $8b5b50bcd2b3f453$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$8b5b50bcd2b3f453$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$8b5b50bcd2b3f453$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $8b5b50bcd2b3f453$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$8b5b50bcd2b3f453$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $8b5b50bcd2b3f453$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $8b5b50bcd2b3f453$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $8b5b50bcd2b3f453$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $8b5b50bcd2b3f453$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$8b5b50bcd2b3f453$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$8b5b50bcd2b3f453$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$8b5b50bcd2b3f453$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$8b5b50bcd2b3f453$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $8b5b50bcd2b3f453$var$AbortError,
    aggregateTwoErrors: $8b5b50bcd2b3f453$var$hideStackFrames($8b5b50bcd2b3f453$var$aggregateTwoErrors),
    hideStackFrames: $8b5b50bcd2b3f453$var$hideStackFrames,
    codes: $8b5b50bcd2b3f453$var$codes
};

});


parcelRegister("brAao", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $854e4540efbe05ef$export$42af8c323be37587; }, function (v) { return $854e4540efbe05ef$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $854e4540efbe05ef$export$f405f72c701dad87; }, function (v) { return $854e4540efbe05ef$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $854e4540efbe05ef$export$42af8c323be37587;
var $854e4540efbe05ef$export$f405f72c701dad87;
'use strict';

var $854e4540efbe05ef$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $bXN8a = parcelRequire("bXN8a");
var $854e4540efbe05ef$var$_require_codes = $bXN8a.codes, $854e4540efbe05ef$var$ERR_INVALID_ARG_VALUE = $854e4540efbe05ef$var$_require_codes.ERR_INVALID_ARG_VALUE, $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE = $854e4540efbe05ef$var$_require_codes.ERR_INVALID_ARG_TYPE, $854e4540efbe05ef$var$ERR_MISSING_ARGS = $854e4540efbe05ef$var$_require_codes.ERR_MISSING_ARGS, $854e4540efbe05ef$var$ERR_OUT_OF_RANGE = $854e4540efbe05ef$var$_require_codes.ERR_OUT_OF_RANGE, $854e4540efbe05ef$var$AbortError = $bXN8a.AbortError;

var $l5smG = parcelRequire("l5smG");
var $854e4540efbe05ef$var$validateAbortSignal = $l5smG.validateAbortSignal, $854e4540efbe05ef$var$validateInteger = $l5smG.validateInteger, $854e4540efbe05ef$var$validateObject = $l5smG.validateObject;

var $854e4540efbe05ef$var$kWeakHandler = (parcelRequire("bevD6")).Symbol('kWeak');

var $854e4540efbe05ef$var$kResistStopPropagation = (parcelRequire("bevD6")).Symbol('kResistStopPropagation');

var $4LEgK = parcelRequire("4LEgK");
var $854e4540efbe05ef$require$finished = $4LEgK.finished;

var $76haz = parcelRequire("76haz");

var $3Ra6D = parcelRequire("3Ra6D");
var $854e4540efbe05ef$require$addAbortSignalNoValidate = $3Ra6D.addAbortSignalNoValidate;

var $l3TFC = parcelRequire("l3TFC");
var $854e4540efbe05ef$var$isWritable = $l3TFC.isWritable, $854e4540efbe05ef$var$isNodeStream = $l3TFC.isNodeStream;

var $854e4540efbe05ef$require$deprecate = (parcelRequire("4IlY3")).deprecate;

var $854e4540efbe05ef$var$ArrayPrototypePush = (parcelRequire("bevD6")).ArrayPrototypePush, $854e4540efbe05ef$var$Boolean = (parcelRequire("bevD6")).Boolean, $854e4540efbe05ef$var$MathFloor = (parcelRequire("bevD6")).MathFloor, $854e4540efbe05ef$var$Number = (parcelRequire("bevD6")).Number, $854e4540efbe05ef$var$NumberIsNaN = (parcelRequire("bevD6")).NumberIsNaN, $854e4540efbe05ef$var$Promise = (parcelRequire("bevD6")).Promise, $854e4540efbe05ef$var$PromiseReject = (parcelRequire("bevD6")).PromiseReject, $854e4540efbe05ef$var$PromiseResolve = (parcelRequire("bevD6")).PromiseResolve, $854e4540efbe05ef$var$PromisePrototypeThen = (parcelRequire("bevD6")).PromisePrototypeThen, $854e4540efbe05ef$var$Symbol = (parcelRequire("bevD6")).Symbol;
var $854e4540efbe05ef$var$kEmpty = $854e4540efbe05ef$var$Symbol('kEmpty');
var $854e4540efbe05ef$var$kEof = $854e4540efbe05ef$var$Symbol('kEof');
function $854e4540efbe05ef$var$compose(stream, options) {
    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
    if ($854e4540efbe05ef$var$isNodeStream(stream) && !$854e4540efbe05ef$var$isWritable(stream)) throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $76haz(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $854e4540efbe05ef$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $854e4540efbe05ef$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $854e4540efbe05ef$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $854e4540efbe05ef$var$MathFloor(options.highWaterMark);
    $854e4540efbe05ef$var$validateInteger(concurrency, 'options.concurrency', 1);
    $854e4540efbe05ef$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $854e4540efbe05ef$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $854e4540efbe05ef$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $854e4540efbe05ef$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $854e4540efbe05ef$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $854e4540efbe05ef$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $854e4540efbe05ef$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($854e4540efbe05ef$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $854e4540efbe05ef$var$PromiseReject(err1);
                                $854e4540efbe05ef$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("4IlY3")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($854e4540efbe05ef$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $854e4540efbe05ef$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $854e4540efbe05ef$var$AbortError();
                        if (!(val !== $854e4540efbe05ef$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $854e4540efbe05ef$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $854e4540efbe05ef$var$asIndexedPairs(options) {
    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $854e4540efbe05ef$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $854e4540efbe05ef$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($854e4540efbe05ef$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $854e4540efbe05ef$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $854e4540efbe05ef$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $854e4540efbe05ef$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($854e4540efbe05ef$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $854e4540efbe05ef$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $854e4540efbe05ef$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($854e4540efbe05ef$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $854e4540efbe05ef$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $854e4540efbe05ef$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $854e4540efbe05ef$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $854e4540efbe05ef$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($854e4540efbe05ef$var$ERR_MISSING_ARGS);
function $854e4540efbe05ef$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $854e4540efbe05ef$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $854e4540efbe05ef$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $854e4540efbe05ef$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $854e4540efbe05ef$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $854e4540efbe05ef$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $854e4540efbe05ef$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $854e4540efbe05ef$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $854e4540efbe05ef$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $854e4540efbe05ef$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $854e4540efbe05ef$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $854e4540efbe05ef$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $854e4540efbe05ef$var$flatMap(fn, options) {
    var values = $854e4540efbe05ef$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $854e4540efbe05ef$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $854e4540efbe05ef$var$Number(number);
    if ($854e4540efbe05ef$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $854e4540efbe05ef$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $854e4540efbe05ef$var$drop(number, options) {
    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
    number = $854e4540efbe05ef$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $854e4540efbe05ef$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $854e4540efbe05ef$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $854e4540efbe05ef$var$take(number, options) {
    if (options != null) $854e4540efbe05ef$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $854e4540efbe05ef$var$validateAbortSignal(options.signal, 'options.signal');
    number = $854e4540efbe05ef$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $854e4540efbe05ef$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $854e4540efbe05ef$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$854e4540efbe05ef$export$42af8c323be37587 = {
    asIndexedPairs: $854e4540efbe05ef$require$deprecate($854e4540efbe05ef$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $854e4540efbe05ef$var$drop,
    filter: $854e4540efbe05ef$var$filter,
    flatMap: $854e4540efbe05ef$var$flatMap,
    map: $854e4540efbe05ef$var$map,
    take: $854e4540efbe05ef$var$take,
    compose: $854e4540efbe05ef$var$compose
};
$854e4540efbe05ef$export$f405f72c701dad87 = {
    every: $854e4540efbe05ef$var$every,
    forEach: $854e4540efbe05ef$var$forEach,
    reduce: $854e4540efbe05ef$var$reduce,
    toArray: $854e4540efbe05ef$var$toArray,
    some: $854e4540efbe05ef$var$some,
    find: $854e4540efbe05ef$var$find
};

});
parcelRegister("l5smG", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $f5a011413772555f$var$ArrayIsArray = $bevD6.ArrayIsArray, $f5a011413772555f$var$ArrayPrototypeIncludes = $bevD6.ArrayPrototypeIncludes, $f5a011413772555f$var$ArrayPrototypeJoin = $bevD6.ArrayPrototypeJoin, $f5a011413772555f$var$ArrayPrototypeMap = $bevD6.ArrayPrototypeMap, $f5a011413772555f$var$NumberIsInteger = $bevD6.NumberIsInteger, $f5a011413772555f$var$NumberIsNaN = $bevD6.NumberIsNaN, $f5a011413772555f$var$NumberMAX_SAFE_INTEGER = $bevD6.NumberMAX_SAFE_INTEGER, $f5a011413772555f$var$NumberMIN_SAFE_INTEGER = $bevD6.NumberMIN_SAFE_INTEGER, $f5a011413772555f$var$NumberParseInt = $bevD6.NumberParseInt, $f5a011413772555f$var$ObjectPrototypeHasOwnProperty = $bevD6.ObjectPrototypeHasOwnProperty, $f5a011413772555f$var$RegExpPrototypeExec = $bevD6.RegExpPrototypeExec, $f5a011413772555f$var$String = $bevD6.String, $f5a011413772555f$var$StringPrototypeToUpperCase = $bevD6.StringPrototypeToUpperCase, $f5a011413772555f$var$StringPrototypeTrim = $bevD6.StringPrototypeTrim;

var $bXN8a = parcelRequire("bXN8a");
var $f5a011413772555f$var$hideStackFrames = $bXN8a.hideStackFrames, $f5a011413772555f$var$_require_codes = $bXN8a.codes, $f5a011413772555f$var$ERR_SOCKET_BAD_PORT = $f5a011413772555f$var$_require_codes.ERR_SOCKET_BAD_PORT, $f5a011413772555f$var$ERR_INVALID_ARG_TYPE = $f5a011413772555f$var$_require_codes.ERR_INVALID_ARG_TYPE, $f5a011413772555f$var$ERR_INVALID_ARG_VALUE = $f5a011413772555f$var$_require_codes.ERR_INVALID_ARG_VALUE, $f5a011413772555f$var$ERR_OUT_OF_RANGE = $f5a011413772555f$var$_require_codes.ERR_OUT_OF_RANGE, $f5a011413772555f$var$ERR_UNKNOWN_SIGNAL = $f5a011413772555f$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $4IlY3 = parcelRequire("4IlY3");
var $f5a011413772555f$require$normalizeEncoding = $4IlY3.normalizeEncoding;

var $4IlY3 = parcelRequire("4IlY3");
var $f5a011413772555f$require$_require_types = $4IlY3.types;
var $f5a011413772555f$var$isAsyncFunction = $f5a011413772555f$require$_require_types.isAsyncFunction, $f5a011413772555f$var$isArrayBufferView = $f5a011413772555f$require$_require_types.isArrayBufferView;
var $f5a011413772555f$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f5a011413772555f$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f5a011413772555f$var$isUint32(value) {
    return value === value >>> 0;
}
var $f5a011413772555f$var$octalReg = /^[0-7]+$/;
var $f5a011413772555f$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $f5a011413772555f$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($f5a011413772555f$var$RegExpPrototypeExec($f5a011413772555f$var$octalReg, value) === null) throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE(name, value, $f5a011413772555f$var$modeDesc);
        value = $f5a011413772555f$var$NumberParseInt(value, 8);
    }
    $f5a011413772555f$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $f5a011413772555f$var$validateInteger = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f5a011413772555f$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $f5a011413772555f$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f5a011413772555f$var$NumberIsInteger(value)) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $f5a011413772555f$var$validateInt32 = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f5a011413772555f$var$NumberIsInteger(value)) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $f5a011413772555f$var$validateUint32 = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f5a011413772555f$var$NumberIsInteger(value)) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $f5a011413772555f$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $f5a011413772555f$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $f5a011413772555f$var$NumberIsNaN(value)) throw new $f5a011413772555f$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $f5a011413772555f$var$validateOneOf = $f5a011413772555f$var$hideStackFrames(function(value, name, oneOf) {
    if (!$f5a011413772555f$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $f5a011413772555f$var$ArrayPrototypeJoin($f5a011413772555f$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $f5a011413772555f$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $f5a011413772555f$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $f5a011413772555f$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$f5a011413772555f$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $f5a011413772555f$var$validateObject = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $f5a011413772555f$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $f5a011413772555f$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $f5a011413772555f$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $f5a011413772555f$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $f5a011413772555f$var$validateDictionary = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $f5a011413772555f$var$validateArray = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$f5a011413772555f$var$ArrayIsArray(value)) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $f5a011413772555f$var$validateStringArray(value, name) {
    $f5a011413772555f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$f5a011413772555f$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $f5a011413772555f$var$validateBooleanArray(value, name) {
    $f5a011413772555f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$f5a011413772555f$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $f5a011413772555f$var$validateAbortSignalArray(value, name) {
    $f5a011413772555f$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $f5a011413772555f$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $f5a011413772555f$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $f5a011413772555f$var$validateString(signal, name);
    if ($f5a011413772555f$var$signals[signal] === undefined) {
        if ($f5a011413772555f$var$signals[$f5a011413772555f$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $f5a011413772555f$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $f5a011413772555f$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $f5a011413772555f$var$validateBuffer = $f5a011413772555f$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$f5a011413772555f$var$isArrayBufferView(buffer)) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $f5a011413772555f$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $f5a011413772555f$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $f5a011413772555f$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $f5a011413772555f$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $f5a011413772555f$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $f5a011413772555f$var$validateAbortSignal = $f5a011413772555f$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $f5a011413772555f$var$validateFunction = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $f5a011413772555f$var$validatePlainFunction = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $f5a011413772555f$var$isAsyncFunction(value)) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $f5a011413772555f$var$validateUndefined = $f5a011413772555f$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $f5a011413772555f$var$validateUnion(value, name, union) {
    if (!$f5a011413772555f$var$ArrayPrototypeIncludes(union, value)) throw new $f5a011413772555f$var$ERR_INVALID_ARG_TYPE(name, "('".concat($f5a011413772555f$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $f5a011413772555f$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $f5a011413772555f$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$f5a011413772555f$var$RegExpPrototypeExec($f5a011413772555f$var$linkValueRegExp, value)) throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $f5a011413772555f$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $f5a011413772555f$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($f5a011413772555f$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $f5a011413772555f$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $f5a011413772555f$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $f5a011413772555f$var$isInt32,
    isUint32: $f5a011413772555f$var$isUint32,
    parseFileMode: $f5a011413772555f$var$parseFileMode,
    validateArray: $f5a011413772555f$var$validateArray,
    validateStringArray: $f5a011413772555f$var$validateStringArray,
    validateBooleanArray: $f5a011413772555f$var$validateBooleanArray,
    validateAbortSignalArray: $f5a011413772555f$var$validateAbortSignalArray,
    validateBoolean: $f5a011413772555f$var$validateBoolean,
    validateBuffer: $f5a011413772555f$var$validateBuffer,
    validateDictionary: $f5a011413772555f$var$validateDictionary,
    validateEncoding: $f5a011413772555f$var$validateEncoding,
    validateFunction: $f5a011413772555f$var$validateFunction,
    validateInt32: $f5a011413772555f$var$validateInt32,
    validateInteger: $f5a011413772555f$var$validateInteger,
    validateNumber: $f5a011413772555f$var$validateNumber,
    validateObject: $f5a011413772555f$var$validateObject,
    validateOneOf: $f5a011413772555f$var$validateOneOf,
    validatePlainFunction: $f5a011413772555f$var$validatePlainFunction,
    validatePort: $f5a011413772555f$var$validatePort,
    validateSignalName: $f5a011413772555f$var$validateSignalName,
    validateString: $f5a011413772555f$var$validateString,
    validateUint32: $f5a011413772555f$var$validateUint32,
    validateUndefined: $f5a011413772555f$var$validateUndefined,
    validateUnion: $f5a011413772555f$var$validateUnion,
    validateAbortSignal: $f5a011413772555f$var$validateAbortSignal,
    validateLinkHeaderValue: $f5a011413772555f$var$validateLinkHeaderValue
};

});

parcelRegister("4LEgK", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bXN8a = parcelRequire("bXN8a");
/* replacement end */ var $378ac9d6a46d21a8$var$AbortError = $bXN8a.AbortError, $378ac9d6a46d21a8$var$codes = $bXN8a.codes;
var $378ac9d6a46d21a8$var$ERR_INVALID_ARG_TYPE = $378ac9d6a46d21a8$var$codes.ERR_INVALID_ARG_TYPE, $378ac9d6a46d21a8$var$ERR_STREAM_PREMATURE_CLOSE = $378ac9d6a46d21a8$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $378ac9d6a46d21a8$var$kEmptyObject = (parcelRequire("4IlY3")).kEmptyObject, $378ac9d6a46d21a8$var$once = (parcelRequire("4IlY3")).once;

var $l5smG = parcelRequire("l5smG");
var $378ac9d6a46d21a8$var$validateAbortSignal = $l5smG.validateAbortSignal, $378ac9d6a46d21a8$var$validateFunction = $l5smG.validateFunction, $378ac9d6a46d21a8$var$validateObject = $l5smG.validateObject, $378ac9d6a46d21a8$var$validateBoolean = $l5smG.validateBoolean;

var $bevD6 = parcelRequire("bevD6");
var $378ac9d6a46d21a8$var$Promise = $bevD6.Promise, $378ac9d6a46d21a8$var$PromisePrototypeThen = $bevD6.PromisePrototypeThen, $378ac9d6a46d21a8$var$SymbolDispose = $bevD6.SymbolDispose;

var $l3TFC = parcelRequire("l3TFC");
var $378ac9d6a46d21a8$var$isClosed = $l3TFC.isClosed, $378ac9d6a46d21a8$var$isReadable = $l3TFC.isReadable, $378ac9d6a46d21a8$var$isReadableNodeStream = $l3TFC.isReadableNodeStream, $378ac9d6a46d21a8$var$isReadableStream = $l3TFC.isReadableStream, $378ac9d6a46d21a8$var$isReadableFinished = $l3TFC.isReadableFinished, $378ac9d6a46d21a8$var$isReadableErrored = $l3TFC.isReadableErrored, $378ac9d6a46d21a8$var$isWritable = $l3TFC.isWritable, $378ac9d6a46d21a8$var$isWritableNodeStream = $l3TFC.isWritableNodeStream, $378ac9d6a46d21a8$var$isWritableStream = $l3TFC.isWritableStream, $378ac9d6a46d21a8$var$isWritableFinished = $l3TFC.isWritableFinished, $378ac9d6a46d21a8$var$isWritableErrored = $l3TFC.isWritableErrored, $378ac9d6a46d21a8$var$isNodeStream = $l3TFC.isNodeStream, $378ac9d6a46d21a8$var$_willEmitClose = $l3TFC.willEmitClose, $378ac9d6a46d21a8$var$kIsClosedPromise = $l3TFC.kIsClosedPromise;
var $378ac9d6a46d21a8$var$addAbortListener;
function $378ac9d6a46d21a8$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $378ac9d6a46d21a8$var$nop = function() {};

function $378ac9d6a46d21a8$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $378ac9d6a46d21a8$var$kEmptyObject;
    } else if (options == null) options = $378ac9d6a46d21a8$var$kEmptyObject;
    else $378ac9d6a46d21a8$var$validateObject(options, 'options');
    $378ac9d6a46d21a8$var$validateFunction(callback, 'callback');
    $378ac9d6a46d21a8$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $378ac9d6a46d21a8$var$once(callback);
    if ($378ac9d6a46d21a8$var$isReadableStream(stream) || $378ac9d6a46d21a8$var$isWritableStream(stream)) return $378ac9d6a46d21a8$var$eosWeb(stream, options, callback);
    if (!$378ac9d6a46d21a8$var$isNodeStream(stream)) throw new $378ac9d6a46d21a8$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $378ac9d6a46d21a8$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $378ac9d6a46d21a8$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $378ac9d6a46d21a8$var$_willEmitClose(stream) && $378ac9d6a46d21a8$var$isReadableNodeStream(stream) === readable && $378ac9d6a46d21a8$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $378ac9d6a46d21a8$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $378ac9d6a46d21a8$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $378ac9d6a46d21a8$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $378ac9d6a46d21a8$var$isWritableErrored(stream) || $378ac9d6a46d21a8$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $378ac9d6a46d21a8$var$isReadableNodeStream(stream, true)) {
            if (!$378ac9d6a46d21a8$var$isReadableFinished(stream, false)) return callback.call(stream, new $378ac9d6a46d21a8$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$378ac9d6a46d21a8$var$isWritableFinished(stream, false)) return callback.call(stream, new $378ac9d6a46d21a8$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $378ac9d6a46d21a8$var$isWritableErrored(stream) || $378ac9d6a46d21a8$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($378ac9d6a46d21a8$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $378ac9d6a46d21a8$var$isReadable(stream)) && (writableFinished || $378ac9d6a46d21a8$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $378ac9d6a46d21a8$var$isWritable(stream)) && (readableFinished || $378ac9d6a46d21a8$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $378ac9d6a46d21a8$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $378ac9d6a46d21a8$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $378ac9d6a46d21a8$var$addAbortListener = $378ac9d6a46d21a8$var$addAbortListener || (parcelRequire("4IlY3")).addAbortListener;
            var disposable = $378ac9d6a46d21a8$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $378ac9d6a46d21a8$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$378ac9d6a46d21a8$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $378ac9d6a46d21a8$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $378ac9d6a46d21a8$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $378ac9d6a46d21a8$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $378ac9d6a46d21a8$var$addAbortListener = $378ac9d6a46d21a8$var$addAbortListener || (parcelRequire("4IlY3")).addAbortListener;
            var disposable = $378ac9d6a46d21a8$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $378ac9d6a46d21a8$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$378ac9d6a46d21a8$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $378ac9d6a46d21a8$var$PromisePrototypeThen(stream[$378ac9d6a46d21a8$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $378ac9d6a46d21a8$var$nop;
}
function $378ac9d6a46d21a8$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $378ac9d6a46d21a8$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $378ac9d6a46d21a8$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $378ac9d6a46d21a8$var$Promise(function(resolve, reject) {
        var cleanup = $378ac9d6a46d21a8$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $378ac9d6a46d21a8$var$eos;
module.exports.finished = $378ac9d6a46d21a8$var$finished;

});
parcelRegister("l3TFC", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $f5550fb986ad5952$var$SymbolAsyncIterator = $bevD6.SymbolAsyncIterator, $f5550fb986ad5952$var$SymbolIterator = $bevD6.SymbolIterator, $f5550fb986ad5952$var$SymbolFor = $bevD6.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $f5550fb986ad5952$var$kIsDestroyed = $f5550fb986ad5952$var$SymbolFor('nodejs.stream.destroyed');
var $f5550fb986ad5952$var$kIsErrored = $f5550fb986ad5952$var$SymbolFor('nodejs.stream.errored');
var $f5550fb986ad5952$var$kIsReadable = $f5550fb986ad5952$var$SymbolFor('nodejs.stream.readable');
var $f5550fb986ad5952$var$kIsWritable = $f5550fb986ad5952$var$SymbolFor('nodejs.stream.writable');
var $f5550fb986ad5952$var$kIsDisturbed = $f5550fb986ad5952$var$SymbolFor('nodejs.stream.disturbed');
var $f5550fb986ad5952$var$kIsClosedPromise = $f5550fb986ad5952$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $f5550fb986ad5952$var$kControllerErrorFunction = $f5550fb986ad5952$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $f5550fb986ad5952$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $f5550fb986ad5952$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $f5550fb986ad5952$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $f5550fb986ad5952$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $f5550fb986ad5952$var$isReadableStream(obj) {
    return !!(obj && !$f5550fb986ad5952$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $f5550fb986ad5952$var$isWritableStream(obj) {
    return !!(obj && !$f5550fb986ad5952$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $f5550fb986ad5952$var$isTransformStream(obj) {
    return !!(obj && !$f5550fb986ad5952$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $f5550fb986ad5952$var$isWebStream(obj) {
    return $f5550fb986ad5952$var$isReadableStream(obj) || $f5550fb986ad5952$var$isWritableStream(obj) || $f5550fb986ad5952$var$isTransformStream(obj);
}
function $f5550fb986ad5952$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$f5550fb986ad5952$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$f5550fb986ad5952$var$SymbolIterator] === 'function';
    return typeof obj[$f5550fb986ad5952$var$SymbolAsyncIterator] === 'function' || typeof obj[$f5550fb986ad5952$var$SymbolIterator] === 'function';
}
function $f5550fb986ad5952$var$isDestroyed(stream) {
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$f5550fb986ad5952$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $f5550fb986ad5952$var$isWritableEnded(stream) {
    if (!$f5550fb986ad5952$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $f5550fb986ad5952$var$isWritableFinished(stream, strict) {
    if (!$f5550fb986ad5952$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $f5550fb986ad5952$var$isReadableEnded(stream) {
    if (!$f5550fb986ad5952$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $f5550fb986ad5952$var$isReadableFinished(stream, strict) {
    if (!$f5550fb986ad5952$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $f5550fb986ad5952$var$isReadable(stream) {
    if (stream && stream[$f5550fb986ad5952$var$kIsReadable] != null) return stream[$f5550fb986ad5952$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($f5550fb986ad5952$var$isDestroyed(stream)) return false;
    return $f5550fb986ad5952$var$isReadableNodeStream(stream) && stream.readable && !$f5550fb986ad5952$var$isReadableFinished(stream);
}
function $f5550fb986ad5952$var$isWritable(stream) {
    if (stream && stream[$f5550fb986ad5952$var$kIsWritable] != null) return stream[$f5550fb986ad5952$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($f5550fb986ad5952$var$isDestroyed(stream)) return false;
    return $f5550fb986ad5952$var$isWritableNodeStream(stream) && stream.writable && !$f5550fb986ad5952$var$isWritableEnded(stream);
}
function $f5550fb986ad5952$var$isFinished(stream, opts) {
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    if ($f5550fb986ad5952$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $f5550fb986ad5952$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $f5550fb986ad5952$var$isWritable(stream)) return false;
    return true;
}
function $f5550fb986ad5952$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $f5550fb986ad5952$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $f5550fb986ad5952$var$isClosed(stream) {
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $f5550fb986ad5952$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $f5550fb986ad5952$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $f5550fb986ad5952$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $f5550fb986ad5952$var$isOutgoingMessage(stream);
}
function $f5550fb986ad5952$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $f5550fb986ad5952$var$willEmitClose(stream) {
    if (!$f5550fb986ad5952$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $f5550fb986ad5952$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $f5550fb986ad5952$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$f5550fb986ad5952$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $f5550fb986ad5952$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$f5550fb986ad5952$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $f5550fb986ad5952$var$isDestroyed,
    kIsDestroyed: $f5550fb986ad5952$var$kIsDestroyed,
    isDisturbed: $f5550fb986ad5952$var$isDisturbed,
    kIsDisturbed: $f5550fb986ad5952$var$kIsDisturbed,
    isErrored: $f5550fb986ad5952$var$isErrored,
    kIsErrored: $f5550fb986ad5952$var$kIsErrored,
    isReadable: $f5550fb986ad5952$var$isReadable,
    kIsReadable: $f5550fb986ad5952$var$kIsReadable,
    kIsClosedPromise: $f5550fb986ad5952$var$kIsClosedPromise,
    kControllerErrorFunction: $f5550fb986ad5952$var$kControllerErrorFunction,
    kIsWritable: $f5550fb986ad5952$var$kIsWritable,
    isClosed: $f5550fb986ad5952$var$isClosed,
    isDuplexNodeStream: $f5550fb986ad5952$var$isDuplexNodeStream,
    isFinished: $f5550fb986ad5952$var$isFinished,
    isIterable: $f5550fb986ad5952$var$isIterable,
    isReadableNodeStream: $f5550fb986ad5952$var$isReadableNodeStream,
    isReadableStream: $f5550fb986ad5952$var$isReadableStream,
    isReadableEnded: $f5550fb986ad5952$var$isReadableEnded,
    isReadableFinished: $f5550fb986ad5952$var$isReadableFinished,
    isReadableErrored: $f5550fb986ad5952$var$isReadableErrored,
    isNodeStream: $f5550fb986ad5952$var$isNodeStream,
    isWebStream: $f5550fb986ad5952$var$isWebStream,
    isWritable: $f5550fb986ad5952$var$isWritable,
    isWritableNodeStream: $f5550fb986ad5952$var$isWritableNodeStream,
    isWritableStream: $f5550fb986ad5952$var$isWritableStream,
    isWritableEnded: $f5550fb986ad5952$var$isWritableEnded,
    isWritableFinished: $f5550fb986ad5952$var$isWritableFinished,
    isWritableErrored: $f5550fb986ad5952$var$isWritableErrored,
    isServerRequest: $f5550fb986ad5952$var$isServerRequest,
    isServerResponse: $f5550fb986ad5952$var$isServerResponse,
    willEmitClose: $f5550fb986ad5952$var$willEmitClose,
    isTransformStream: $f5550fb986ad5952$var$isTransformStream
};

});


parcelRegister("76haz", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $1cPA2 = parcelRequire("1cPA2");
var $52b6696f5a9572b8$require$pipeline = $1cPA2.pipeline;

var $igMe9 = parcelRequire("igMe9");

var $6dqF3 = parcelRequire("6dqF3");
var $52b6696f5a9572b8$require$destroyer = $6dqF3.destroyer;

var $l3TFC = parcelRequire("l3TFC");
var $52b6696f5a9572b8$var$isNodeStream = $l3TFC.isNodeStream, $52b6696f5a9572b8$var$isReadable = $l3TFC.isReadable, $52b6696f5a9572b8$var$isWritable = $l3TFC.isWritable, $52b6696f5a9572b8$var$isWebStream = $l3TFC.isWebStream, $52b6696f5a9572b8$var$isTransformStream = $l3TFC.isTransformStream, $52b6696f5a9572b8$var$isWritableStream = $l3TFC.isWritableStream, $52b6696f5a9572b8$var$isReadableStream = $l3TFC.isReadableStream;

var $bXN8a = parcelRequire("bXN8a");
var $52b6696f5a9572b8$var$AbortError = $bXN8a.AbortError, $52b6696f5a9572b8$var$_require_codes = $bXN8a.codes, $52b6696f5a9572b8$var$ERR_INVALID_ARG_VALUE = $52b6696f5a9572b8$var$_require_codes.ERR_INVALID_ARG_VALUE, $52b6696f5a9572b8$var$ERR_MISSING_ARGS = $52b6696f5a9572b8$var$_require_codes.ERR_MISSING_ARGS;

var $4LEgK = parcelRequire("4LEgK");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $52b6696f5a9572b8$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $igMe9.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $igMe9.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $igMe9.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$52b6696f5a9572b8$var$isNodeStream(streams[n]) && !$52b6696f5a9572b8$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($52b6696f5a9572b8$var$isReadable(streams[n]) || $52b6696f5a9572b8$var$isReadableStream(streams[n]) || $52b6696f5a9572b8$var$isTransformStream(streams[n]))) throw new $52b6696f5a9572b8$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($52b6696f5a9572b8$var$isWritable(streams[n]) || $52b6696f5a9572b8$var$isWritableStream(streams[n]) || $52b6696f5a9572b8$var$isTransformStream(streams[n]))) throw new $52b6696f5a9572b8$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $52b6696f5a9572b8$require$pipeline(streams, onfinished);
    var writable = !!($52b6696f5a9572b8$var$isWritable(head) || $52b6696f5a9572b8$var$isWritableStream(head) || $52b6696f5a9572b8$var$isTransformStream(head));
    var readable = !!($52b6696f5a9572b8$var$isReadable(tail) || $52b6696f5a9572b8$var$isReadableStream(tail) || $52b6696f5a9572b8$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $igMe9({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($52b6696f5a9572b8$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($52b6696f5a9572b8$var$isWebStream(head)) {
            var writable1 = $52b6696f5a9572b8$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $52b6696f5a9572b8$var$isTransformStream(tail) ? tail.readable : tail;
        $4LEgK(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($52b6696f5a9572b8$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($52b6696f5a9572b8$var$isWebStream(tail)) {
            var readable1 = $52b6696f5a9572b8$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $52b6696f5a9572b8$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($52b6696f5a9572b8$var$isNodeStream(tail)) $52b6696f5a9572b8$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("1cPA2", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $0e0eec3289e12026$var$ArrayIsArray = $bevD6.ArrayIsArray, $0e0eec3289e12026$var$Promise = $bevD6.Promise, $0e0eec3289e12026$var$SymbolAsyncIterator = $bevD6.SymbolAsyncIterator, $0e0eec3289e12026$var$SymbolDispose = $bevD6.SymbolDispose;

var $4LEgK = parcelRequire("4LEgK");

var $0e0eec3289e12026$require$once = (parcelRequire("4IlY3")).once;

var $6dqF3 = parcelRequire("6dqF3");

var $igMe9 = parcelRequire("igMe9");

var $bXN8a = parcelRequire("bXN8a");
var $0e0eec3289e12026$var$aggregateTwoErrors = $bXN8a.aggregateTwoErrors, $0e0eec3289e12026$var$_require_codes = $bXN8a.codes, $0e0eec3289e12026$var$ERR_INVALID_ARG_TYPE = $0e0eec3289e12026$var$_require_codes.ERR_INVALID_ARG_TYPE, $0e0eec3289e12026$var$ERR_INVALID_RETURN_VALUE = $0e0eec3289e12026$var$_require_codes.ERR_INVALID_RETURN_VALUE, $0e0eec3289e12026$var$ERR_MISSING_ARGS = $0e0eec3289e12026$var$_require_codes.ERR_MISSING_ARGS, $0e0eec3289e12026$var$ERR_STREAM_DESTROYED = $0e0eec3289e12026$var$_require_codes.ERR_STREAM_DESTROYED, $0e0eec3289e12026$var$ERR_STREAM_PREMATURE_CLOSE = $0e0eec3289e12026$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $0e0eec3289e12026$var$AbortError = $bXN8a.AbortError;

var $l5smG = parcelRequire("l5smG");
var $0e0eec3289e12026$var$validateFunction = $l5smG.validateFunction, $0e0eec3289e12026$var$validateAbortSignal = $l5smG.validateAbortSignal;

var $l3TFC = parcelRequire("l3TFC");
var $0e0eec3289e12026$var$isIterable = $l3TFC.isIterable, $0e0eec3289e12026$var$isReadable = $l3TFC.isReadable, $0e0eec3289e12026$var$isReadableNodeStream = $l3TFC.isReadableNodeStream, $0e0eec3289e12026$var$isNodeStream = $l3TFC.isNodeStream, $0e0eec3289e12026$var$isTransformStream = $l3TFC.isTransformStream, $0e0eec3289e12026$var$isWebStream = $l3TFC.isWebStream, $0e0eec3289e12026$var$isReadableStream = $l3TFC.isReadableStream, $0e0eec3289e12026$var$isReadableFinished = $l3TFC.isReadableFinished;

var $0e0eec3289e12026$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $0e0eec3289e12026$var$PassThrough;
var $0e0eec3289e12026$var$Readable;
var $0e0eec3289e12026$var$addAbortListener;
function $0e0eec3289e12026$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $4LEgK(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $6dqF3.destroyer(stream, err || new $0e0eec3289e12026$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $0e0eec3289e12026$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $0e0eec3289e12026$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $0e0eec3289e12026$var$makeAsyncIterable(val) {
    if ($0e0eec3289e12026$var$isIterable(val)) return val;
    else if ($0e0eec3289e12026$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $0e0eec3289e12026$var$fromReadable(val);
    throw new $0e0eec3289e12026$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $0e0eec3289e12026$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$0e0eec3289e12026$var$Readable) $0e0eec3289e12026$var$Readable = (parcelRequire("bZnyC"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($0e0eec3289e12026$var$Readable.prototype[$0e0eec3289e12026$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0e0eec3289e12026$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $0e0eec3289e12026$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $4LEgK(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $0e0eec3289e12026$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0e0eec3289e12026$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($0e0eec3289e12026$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0e0eec3289e12026$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $0e0eec3289e12026$var$pipelineImpl(streams, $0e0eec3289e12026$require$once($0e0eec3289e12026$var$popCallback(streams)));
}


function $0e0eec3289e12026$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($0e0eec3289e12026$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $0e0eec3289e12026$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($0e0eec3289e12026$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($0e0eec3289e12026$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$0e0eec3289e12026$var$isIterable(ret)) throw new $0e0eec3289e12026$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($0e0eec3289e12026$var$isIterable(stream) || $0e0eec3289e12026$var$isReadableNodeStream(stream) || $0e0eec3289e12026$var$isTransformStream(stream)) ret = stream;
            else ret = $igMe9.from(stream);
        } else if (typeof stream === 'function') {
            if ($0e0eec3289e12026$var$isTransformStream(ret)) {
                var _ret;
                ret = $0e0eec3289e12026$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $0e0eec3289e12026$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$0e0eec3289e12026$var$isIterable(ret, true)) throw new $0e0eec3289e12026$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$0e0eec3289e12026$var$PassThrough) $0e0eec3289e12026$var$PassThrough = (parcelRequire("5XSOL"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $0e0eec3289e12026$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($0e0eec3289e12026$var$isIterable(ret, true)) {
                    finishCount++;
                    $0e0eec3289e12026$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($0e0eec3289e12026$var$isReadableStream(ret) || $0e0eec3289e12026$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $0e0eec3289e12026$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $0e0eec3289e12026$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $0e0eec3289e12026$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($0e0eec3289e12026$var$isNodeStream(stream)) {
            if ($0e0eec3289e12026$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $0e0eec3289e12026$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($0e0eec3289e12026$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($0e0eec3289e12026$var$isTransformStream(ret) || $0e0eec3289e12026$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $0e0eec3289e12026$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($0e0eec3289e12026$var$isIterable(ret)) {
                finishCount++;
                $0e0eec3289e12026$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $0e0eec3289e12026$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($0e0eec3289e12026$var$isWebStream(stream)) {
            if ($0e0eec3289e12026$var$isReadableNodeStream(ret)) {
                finishCount++;
                $0e0eec3289e12026$var$pumpToWeb($0e0eec3289e12026$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($0e0eec3289e12026$var$isReadableStream(ret) || $0e0eec3289e12026$var$isIterable(ret)) {
                finishCount++;
                $0e0eec3289e12026$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($0e0eec3289e12026$var$isTransformStream(ret)) {
                finishCount++;
                $0e0eec3289e12026$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $0e0eec3289e12026$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $igMe9.from(stream);
    };
    if (streams.length === 1 && $0e0eec3289e12026$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $0e0eec3289e12026$var$ERR_MISSING_ARGS('streams');
    var ac = new $0e0eec3289e12026$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $0e0eec3289e12026$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $0e0eec3289e12026$var$AbortError());
    }
    $0e0eec3289e12026$var$addAbortListener = $0e0eec3289e12026$var$addAbortListener || (parcelRequire("4IlY3")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $0e0eec3289e12026$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$0e0eec3289e12026$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $0e0eec3289e12026$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $0e0eec3289e12026$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($0e0eec3289e12026$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $4LEgK(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $4LEgK(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $0e0eec3289e12026$var$pipelineImpl,
    pipeline: $0e0eec3289e12026$var$pipeline
};

});
parcelRegister("6dqF3", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bXN8a = parcelRequire("bXN8a");
/* replacement end */ var $4868a353f6808a91$var$aggregateTwoErrors = $bXN8a.aggregateTwoErrors, $4868a353f6808a91$var$ERR_MULTIPLE_CALLBACK = $bXN8a.codes.ERR_MULTIPLE_CALLBACK, $4868a353f6808a91$var$AbortError = $bXN8a.AbortError;

var $bevD6 = parcelRequire("bevD6");
var $4868a353f6808a91$require$Symbol = $bevD6.Symbol;

var $l3TFC = parcelRequire("l3TFC");
var $4868a353f6808a91$var$kIsDestroyed = $l3TFC.kIsDestroyed, $4868a353f6808a91$var$isDestroyed = $l3TFC.isDestroyed, $4868a353f6808a91$var$isFinished = $l3TFC.isFinished, $4868a353f6808a91$var$isServerRequest = $l3TFC.isServerRequest;
var $4868a353f6808a91$var$kDestroy = $4868a353f6808a91$require$Symbol('kDestroy');
var $4868a353f6808a91$var$kConstruct = $4868a353f6808a91$require$Symbol('kConstruct');
function $4868a353f6808a91$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $4868a353f6808a91$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $4868a353f6808a91$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($4868a353f6808a91$var$kDestroy, function(er) {
        $4868a353f6808a91$var$_destroy(this, $4868a353f6808a91$var$aggregateTwoErrors(er, err), cb);
    });
    else $4868a353f6808a91$var$_destroy(this, err, cb);
    return this;
}
function $4868a353f6808a91$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $4868a353f6808a91$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($4868a353f6808a91$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($4868a353f6808a91$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $4868a353f6808a91$var$emitErrorCloseNT(self, err) {
    $4868a353f6808a91$var$emitErrorNT(self, err);
    $4868a353f6808a91$var$emitCloseNT(self);
}
function $4868a353f6808a91$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $4868a353f6808a91$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $4868a353f6808a91$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $4868a353f6808a91$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($4868a353f6808a91$var$emitErrorNT, stream, err);
        else $4868a353f6808a91$var$emitErrorNT(stream, err);
    }
}
function $4868a353f6808a91$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($4868a353f6808a91$var$kConstruct, cb);
    if (stream.listenerCount($4868a353f6808a91$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($4868a353f6808a91$var$constructNT, stream);
}
function $4868a353f6808a91$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $4868a353f6808a91$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $4868a353f6808a91$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($4868a353f6808a91$var$kDestroy, err);
        else if (err) $4868a353f6808a91$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($4868a353f6808a91$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $4868a353f6808a91$var$emitConstructNT(stream) {
    stream.emit($4868a353f6808a91$var$kConstruct);
}
function $4868a353f6808a91$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $4868a353f6808a91$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $4868a353f6808a91$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($4868a353f6808a91$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $4868a353f6808a91$var$destroyer(stream, err) {
    if (!stream || $4868a353f6808a91$var$isDestroyed(stream)) return;
    if (!err && !$4868a353f6808a91$var$isFinished(stream)) err = new $4868a353f6808a91$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($4868a353f6808a91$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($4868a353f6808a91$var$isRequest(stream)) stream.abort();
    else if ($4868a353f6808a91$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($4868a353f6808a91$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($4868a353f6808a91$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$4868a353f6808a91$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $4868a353f6808a91$var$construct,
    destroyer: $4868a353f6808a91$var$destroyer,
    destroy: $4868a353f6808a91$var$destroy,
    undestroy: $4868a353f6808a91$var$undestroy,
    errorOrDestroy: $4868a353f6808a91$var$errorOrDestroy
};

});

parcelRegister("igMe9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $d4cf218ca4c0f6dc$var$ObjectDefineProperties = $bevD6.ObjectDefineProperties, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor = $bevD6.ObjectGetOwnPropertyDescriptor, $d4cf218ca4c0f6dc$var$ObjectKeys = $bevD6.ObjectKeys, $d4cf218ca4c0f6dc$var$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf;
module.exports = $d4cf218ca4c0f6dc$var$Duplex;

var $bZnyC = parcelRequire("bZnyC");

var $cE7Uu = parcelRequire("cE7Uu");
$d4cf218ca4c0f6dc$var$ObjectSetPrototypeOf($d4cf218ca4c0f6dc$var$Duplex.prototype, $bZnyC.prototype);
$d4cf218ca4c0f6dc$var$ObjectSetPrototypeOf($d4cf218ca4c0f6dc$var$Duplex, $bZnyC);
{
    var $d4cf218ca4c0f6dc$var$keys = $d4cf218ca4c0f6dc$var$ObjectKeys($cE7Uu.prototype);
    // Allow the keys array to be GC'ed.
    for(var $d4cf218ca4c0f6dc$var$i = 0; $d4cf218ca4c0f6dc$var$i < $d4cf218ca4c0f6dc$var$keys.length; $d4cf218ca4c0f6dc$var$i++){
        var $d4cf218ca4c0f6dc$var$method = $d4cf218ca4c0f6dc$var$keys[$d4cf218ca4c0f6dc$var$i];
        if (!$d4cf218ca4c0f6dc$var$Duplex.prototype[$d4cf218ca4c0f6dc$var$method]) $d4cf218ca4c0f6dc$var$Duplex.prototype[$d4cf218ca4c0f6dc$var$method] = $cE7Uu.prototype[$d4cf218ca4c0f6dc$var$method];
    }
}function $d4cf218ca4c0f6dc$var$Duplex(options) {
    if (!(this instanceof $d4cf218ca4c0f6dc$var$Duplex)) return new $d4cf218ca4c0f6dc$var$Duplex(options);
    $bZnyC.call(this, options);
    $cE7Uu.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$d4cf218ca4c0f6dc$var$ObjectDefineProperties($d4cf218ca4c0f6dc$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $d4cf218ca4c0f6dc$var$ObjectGetOwnPropertyDescriptor($cE7Uu.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $d4cf218ca4c0f6dc$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d4cf218ca4c0f6dc$var$lazyWebStreams() {
    if ($d4cf218ca4c0f6dc$var$webStreamsAdapters === undefined) $d4cf218ca4c0f6dc$var$webStreamsAdapters = {};
    return $d4cf218ca4c0f6dc$var$webStreamsAdapters;
}
$d4cf218ca4c0f6dc$var$Duplex.fromWeb = function(pair, options) {
    return $d4cf218ca4c0f6dc$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$d4cf218ca4c0f6dc$var$Duplex.toWeb = function(duplex) {
    return $d4cf218ca4c0f6dc$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $d4cf218ca4c0f6dc$var$duplexify;

$d4cf218ca4c0f6dc$var$Duplex.from = function(body) {
    if (!$d4cf218ca4c0f6dc$var$duplexify) $d4cf218ca4c0f6dc$var$duplexify = (parcelRequire("gVmX7"));
    return $d4cf218ca4c0f6dc$var$duplexify(body, 'body');
};

});
parcelRegister("bZnyC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bevD6 = parcelRequire("bevD6");
/* replacement end */ var $8ba7aa3d2ab79a2f$var$ArrayPrototypeIndexOf = $bevD6.ArrayPrototypeIndexOf, $8ba7aa3d2ab79a2f$var$NumberIsInteger = $bevD6.NumberIsInteger, $8ba7aa3d2ab79a2f$var$NumberIsNaN = $bevD6.NumberIsNaN, $8ba7aa3d2ab79a2f$var$NumberParseInt = $bevD6.NumberParseInt, $8ba7aa3d2ab79a2f$var$ObjectDefineProperties = $bevD6.ObjectDefineProperties, $8ba7aa3d2ab79a2f$var$ObjectKeys = $bevD6.ObjectKeys, $8ba7aa3d2ab79a2f$var$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf, $8ba7aa3d2ab79a2f$var$Promise = $bevD6.Promise, $8ba7aa3d2ab79a2f$var$SafeSet = $bevD6.SafeSet, $8ba7aa3d2ab79a2f$var$SymbolAsyncDispose = $bevD6.SymbolAsyncDispose, $8ba7aa3d2ab79a2f$var$SymbolAsyncIterator = $bevD6.SymbolAsyncIterator, $8ba7aa3d2ab79a2f$var$Symbol = $bevD6.Symbol;
module.exports = $8ba7aa3d2ab79a2f$var$Readable;
$8ba7aa3d2ab79a2f$var$Readable.ReadableState = $8ba7aa3d2ab79a2f$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $8ba7aa3d2ab79a2f$var$EE = $bBoAO.EventEmitter;

var $46v1I = parcelRequire("46v1I");
var $8ba7aa3d2ab79a2f$var$Stream = $46v1I.Stream, $8ba7aa3d2ab79a2f$var$prependListener = $46v1I.prependListener;

var $efY7W = parcelRequire("efY7W");
var $8ba7aa3d2ab79a2f$require$Buffer = $efY7W.Buffer;

var $3Ra6D = parcelRequire("3Ra6D");
var $8ba7aa3d2ab79a2f$require$addAbortSignal = $3Ra6D.addAbortSignal;

var $4LEgK = parcelRequire("4LEgK");

var $8ba7aa3d2ab79a2f$var$debug = (parcelRequire("4IlY3")).debuglog('stream', function(fn) {
    $8ba7aa3d2ab79a2f$var$debug = fn;
});

var $02WqQ = parcelRequire("02WqQ");

var $6dqF3 = parcelRequire("6dqF3");

var $l9bFC = parcelRequire("l9bFC");
var $8ba7aa3d2ab79a2f$var$getHighWaterMark = $l9bFC.getHighWaterMark, $8ba7aa3d2ab79a2f$var$getDefaultHighWaterMark = $l9bFC.getDefaultHighWaterMark;

var $bXN8a = parcelRequire("bXN8a");
var $8ba7aa3d2ab79a2f$var$aggregateTwoErrors = $bXN8a.aggregateTwoErrors, $8ba7aa3d2ab79a2f$var$_require_codes = $bXN8a.codes, $8ba7aa3d2ab79a2f$var$ERR_INVALID_ARG_TYPE = $8ba7aa3d2ab79a2f$var$_require_codes.ERR_INVALID_ARG_TYPE, $8ba7aa3d2ab79a2f$var$ERR_METHOD_NOT_IMPLEMENTED = $8ba7aa3d2ab79a2f$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $8ba7aa3d2ab79a2f$var$ERR_OUT_OF_RANGE = $8ba7aa3d2ab79a2f$var$_require_codes.ERR_OUT_OF_RANGE, $8ba7aa3d2ab79a2f$var$ERR_STREAM_PUSH_AFTER_EOF = $8ba7aa3d2ab79a2f$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $8ba7aa3d2ab79a2f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $8ba7aa3d2ab79a2f$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $8ba7aa3d2ab79a2f$var$AbortError = $bXN8a.AbortError;

var $l5smG = parcelRequire("l5smG");
var $8ba7aa3d2ab79a2f$require$validateObject = $l5smG.validateObject;
var $8ba7aa3d2ab79a2f$var$kPaused = $8ba7aa3d2ab79a2f$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $8ba7aa3d2ab79a2f$require$StringDecoder = $3Jf7C.StringDecoder;

var $lhhRP = parcelRequire("lhhRP");
$8ba7aa3d2ab79a2f$var$ObjectSetPrototypeOf($8ba7aa3d2ab79a2f$var$Readable.prototype, $8ba7aa3d2ab79a2f$var$Stream.prototype);
$8ba7aa3d2ab79a2f$var$ObjectSetPrototypeOf($8ba7aa3d2ab79a2f$var$Readable, $8ba7aa3d2ab79a2f$var$Stream);
var $8ba7aa3d2ab79a2f$var$nop = function() {};
var $8ba7aa3d2ab79a2f$var$errorOrDestroy = $6dqF3.errorOrDestroy;
var $8ba7aa3d2ab79a2f$var$kObjectMode = 1;
var $8ba7aa3d2ab79a2f$var$kEnded = 2;
var $8ba7aa3d2ab79a2f$var$kEndEmitted = 4;
var $8ba7aa3d2ab79a2f$var$kReading = 8;
var $8ba7aa3d2ab79a2f$var$kConstructed = 16;
var $8ba7aa3d2ab79a2f$var$kSync = 32;
var $8ba7aa3d2ab79a2f$var$kNeedReadable = 64;
var $8ba7aa3d2ab79a2f$var$kEmittedReadable = 128;
var $8ba7aa3d2ab79a2f$var$kReadableListening = 256;
var $8ba7aa3d2ab79a2f$var$kResumeScheduled = 512;
var $8ba7aa3d2ab79a2f$var$kErrorEmitted = 1024;
var $8ba7aa3d2ab79a2f$var$kEmitClose = 2048;
var $8ba7aa3d2ab79a2f$var$kAutoDestroy = 4096;
var $8ba7aa3d2ab79a2f$var$kDestroyed = 8192;
var $8ba7aa3d2ab79a2f$var$kClosed = 16384;
var $8ba7aa3d2ab79a2f$var$kCloseEmitted = 32768;
var $8ba7aa3d2ab79a2f$var$kMultiAwaitDrain = 65536;
var $8ba7aa3d2ab79a2f$var$kReadingMore = 131072;
var $8ba7aa3d2ab79a2f$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8ba7aa3d2ab79a2f$var$ObjectDefineProperties($8ba7aa3d2ab79a2f$var$ReadableState.prototype, {
    objectMode: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kObjectMode),
    ended: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kEnded),
    endEmitted: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kEndEmitted),
    reading: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kNeedReadable),
    emittedReadable: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kEmittedReadable),
    readableListening: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kReadableListening),
    resumeScheduled: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kErrorEmitted),
    emitClose: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kEmitClose),
    autoDestroy: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kCloseEmitted),
    multiAwaitDrain: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kReadingMore),
    dataEmitted: $8ba7aa3d2ab79a2f$var$makeBitMapDescriptor($8ba7aa3d2ab79a2f$var$kDataEmitted)
});

function $8ba7aa3d2ab79a2f$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("igMe9"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8ba7aa3d2ab79a2f$var$kEmitClose | $8ba7aa3d2ab79a2f$var$kAutoDestroy | $8ba7aa3d2ab79a2f$var$kConstructed | $8ba7aa3d2ab79a2f$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8ba7aa3d2ab79a2f$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8ba7aa3d2ab79a2f$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8ba7aa3d2ab79a2f$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8ba7aa3d2ab79a2f$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $02WqQ();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8ba7aa3d2ab79a2f$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8ba7aa3d2ab79a2f$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8ba7aa3d2ab79a2f$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8ba7aa3d2ab79a2f$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8ba7aa3d2ab79a2f$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $8ba7aa3d2ab79a2f$var$Readable)) return new $8ba7aa3d2ab79a2f$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("igMe9"));
    this._readableState = new $8ba7aa3d2ab79a2f$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8ba7aa3d2ab79a2f$require$addAbortSignal(options.signal, this);
    }
    $8ba7aa3d2ab79a2f$var$Stream.call(this, options);
    $6dqF3.construct(this, function() {
        if (_this._readableState.needReadable) $8ba7aa3d2ab79a2f$var$maybeReadMore(_this, _this._readableState);
    });
}
$8ba7aa3d2ab79a2f$var$Readable.prototype.destroy = $6dqF3.destroy;
$8ba7aa3d2ab79a2f$var$Readable.prototype._undestroy = $6dqF3.undestroy;
$8ba7aa3d2ab79a2f$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8ba7aa3d2ab79a2f$var$Readable.prototype[$8ba7aa3d2ab79a2f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8ba7aa3d2ab79a2f$var$Readable.prototype[$8ba7aa3d2ab79a2f$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8ba7aa3d2ab79a2f$var$AbortError();
        this.destroy(error);
    }
    return new $8ba7aa3d2ab79a2f$var$Promise(function(resolve, reject) {
        return $4LEgK(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8ba7aa3d2ab79a2f$var$Readable.prototype.push = function(chunk, encoding) {
    return $8ba7aa3d2ab79a2f$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8ba7aa3d2ab79a2f$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8ba7aa3d2ab79a2f$var$readableAddChunk(this, chunk, encoding, true);
};
function $8ba7aa3d2ab79a2f$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8ba7aa3d2ab79a2f$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $8ba7aa3d2ab79a2f$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8ba7aa3d2ab79a2f$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8ba7aa3d2ab79a2f$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8ba7aa3d2ab79a2f$require$Buffer) encoding = '';
        else if ($8ba7aa3d2ab79a2f$var$Stream._isUint8Array(chunk)) {
            chunk = $8ba7aa3d2ab79a2f$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8ba7aa3d2ab79a2f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8ba7aa3d2ab79a2f$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8ba7aa3d2ab79a2f$var$kReading;
        $8ba7aa3d2ab79a2f$var$onEofChunk(stream, state);
    } else if ((state.state & $8ba7aa3d2ab79a2f$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8ba7aa3d2ab79a2f$var$kEndEmitted) !== 0) $8ba7aa3d2ab79a2f$var$errorOrDestroy(stream, new $8ba7aa3d2ab79a2f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8ba7aa3d2ab79a2f$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8ba7aa3d2ab79a2f$var$errorOrDestroy(stream, new $8ba7aa3d2ab79a2f$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8ba7aa3d2ab79a2f$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8ba7aa3d2ab79a2f$var$addChunk(stream, state, chunk, false);
                else $8ba7aa3d2ab79a2f$var$maybeReadMore(stream, state);
            } else $8ba7aa3d2ab79a2f$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8ba7aa3d2ab79a2f$var$kReading;
        $8ba7aa3d2ab79a2f$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8ba7aa3d2ab79a2f$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8ba7aa3d2ab79a2f$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8ba7aa3d2ab79a2f$var$kNeedReadable) !== 0) $8ba7aa3d2ab79a2f$var$emitReadable(stream);
    }
    $8ba7aa3d2ab79a2f$var$maybeReadMore(stream, state);
}
$8ba7aa3d2ab79a2f$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$8ba7aa3d2ab79a2f$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8ba7aa3d2ab79a2f$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $8ba7aa3d2ab79a2f$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$8ba7aa3d2ab79a2f$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $8ba7aa3d2ab79a2f$var$MAX_HWM = 0x40000000;
function $8ba7aa3d2ab79a2f$var$computeNewHighWaterMark(n) {
    if (n > $8ba7aa3d2ab79a2f$var$MAX_HWM) throw new $8ba7aa3d2ab79a2f$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8ba7aa3d2ab79a2f$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8ba7aa3d2ab79a2f$var$kObjectMode) !== 0) return 1;
    if ($8ba7aa3d2ab79a2f$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8ba7aa3d2ab79a2f$var$Readable.prototype.read = function(n) {
    $8ba7aa3d2ab79a2f$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8ba7aa3d2ab79a2f$var$NumberIsInteger(n)) n = $8ba7aa3d2ab79a2f$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8ba7aa3d2ab79a2f$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8ba7aa3d2ab79a2f$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8ba7aa3d2ab79a2f$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8ba7aa3d2ab79a2f$var$endReadable(this);
        else $8ba7aa3d2ab79a2f$var$emitReadable(this);
        return null;
    }
    n = $8ba7aa3d2ab79a2f$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8ba7aa3d2ab79a2f$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $8ba7aa3d2ab79a2f$var$kNeedReadable) !== 0;
    $8ba7aa3d2ab79a2f$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8ba7aa3d2ab79a2f$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8ba7aa3d2ab79a2f$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8ba7aa3d2ab79a2f$var$debug('do read');
        state.state |= $8ba7aa3d2ab79a2f$var$kReading | $8ba7aa3d2ab79a2f$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8ba7aa3d2ab79a2f$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8ba7aa3d2ab79a2f$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8ba7aa3d2ab79a2f$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8ba7aa3d2ab79a2f$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8ba7aa3d2ab79a2f$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8ba7aa3d2ab79a2f$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8ba7aa3d2ab79a2f$var$onEofChunk(stream, state) {
    $8ba7aa3d2ab79a2f$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8ba7aa3d2ab79a2f$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8ba7aa3d2ab79a2f$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8ba7aa3d2ab79a2f$var$emitReadable(stream) {
    var state = stream._readableState;
    $8ba7aa3d2ab79a2f$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8ba7aa3d2ab79a2f$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$emitReadable_, stream);
    }
}
function $8ba7aa3d2ab79a2f$var$emitReadable_(stream) {
    var state = stream._readableState;
    $8ba7aa3d2ab79a2f$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8ba7aa3d2ab79a2f$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8ba7aa3d2ab79a2f$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$maybeReadMore_, stream, state);
    }
}
function $8ba7aa3d2ab79a2f$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $8ba7aa3d2ab79a2f$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8ba7aa3d2ab79a2f$var$Readable.prototype._read = function(n) {
    throw new $8ba7aa3d2ab79a2f$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8ba7aa3d2ab79a2f$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8ba7aa3d2ab79a2f$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8ba7aa3d2ab79a2f$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8ba7aa3d2ab79a2f$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8ba7aa3d2ab79a2f$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $8ba7aa3d2ab79a2f$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8ba7aa3d2ab79a2f$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8ba7aa3d2ab79a2f$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8ba7aa3d2ab79a2f$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8ba7aa3d2ab79a2f$var$debug('ondata');
        var ret = dest.write(chunk);
        $8ba7aa3d2ab79a2f$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8ba7aa3d2ab79a2f$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8ba7aa3d2ab79a2f$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8ba7aa3d2ab79a2f$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8ba7aa3d2ab79a2f$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8ba7aa3d2ab79a2f$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8ba7aa3d2ab79a2f$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8ba7aa3d2ab79a2f$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8ba7aa3d2ab79a2f$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8ba7aa3d2ab79a2f$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8ba7aa3d2ab79a2f$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $8ba7aa3d2ab79a2f$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8ba7aa3d2ab79a2f$var$Readable.prototype.on = function(ev, fn) {
    var res = $8ba7aa3d2ab79a2f$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8ba7aa3d2ab79a2f$var$debug('on readable', state.length, state.reading);
            if (state.length) $8ba7aa3d2ab79a2f$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8ba7aa3d2ab79a2f$var$Readable.prototype.addListener = $8ba7aa3d2ab79a2f$var$Readable.prototype.on;
$8ba7aa3d2ab79a2f$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8ba7aa3d2ab79a2f$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$updateReadableListening, this);
    return res;
};
$8ba7aa3d2ab79a2f$var$Readable.prototype.off = $8ba7aa3d2ab79a2f$var$Readable.prototype.removeListener;
$8ba7aa3d2ab79a2f$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8ba7aa3d2ab79a2f$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$updateReadableListening, this);
    return res;
};
function $8ba7aa3d2ab79a2f$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8ba7aa3d2ab79a2f$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8ba7aa3d2ab79a2f$var$nReadingNextTick(self) {
    $8ba7aa3d2ab79a2f$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8ba7aa3d2ab79a2f$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8ba7aa3d2ab79a2f$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8ba7aa3d2ab79a2f$var$resume(this, state);
    }
    state[$8ba7aa3d2ab79a2f$var$kPaused] = false;
    return this;
};
function $8ba7aa3d2ab79a2f$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$resume_, stream, state);
    }
}
function $8ba7aa3d2ab79a2f$var$resume_(stream, state) {
    $8ba7aa3d2ab79a2f$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8ba7aa3d2ab79a2f$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8ba7aa3d2ab79a2f$var$Readable.prototype.pause = function() {
    $8ba7aa3d2ab79a2f$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8ba7aa3d2ab79a2f$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8ba7aa3d2ab79a2f$var$kPaused] = true;
    return this;
};
function $8ba7aa3d2ab79a2f$var$flow(stream) {
    var state = stream._readableState;
    $8ba7aa3d2ab79a2f$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8ba7aa3d2ab79a2f$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $8ba7aa3d2ab79a2f$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $8ba7aa3d2ab79a2f$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8ba7aa3d2ab79a2f$var$Readable.prototype[$8ba7aa3d2ab79a2f$var$SymbolAsyncIterator] = function() {
    return $8ba7aa3d2ab79a2f$var$streamToAsyncIterator(this);
};
$8ba7aa3d2ab79a2f$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8ba7aa3d2ab79a2f$require$validateObject(options, 'options');
    return $8ba7aa3d2ab79a2f$var$streamToAsyncIterator(this, options);
};
function $8ba7aa3d2ab79a2f$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8ba7aa3d2ab79a2f$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $8ba7aa3d2ab79a2f$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $8ba7aa3d2ab79a2f$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $8ba7aa3d2ab79a2f$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $8ba7aa3d2ab79a2f$var$nop;
                    stream.on('readable', next);
                    cleanup = $4LEgK(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $8ba7aa3d2ab79a2f$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $8ba7aa3d2ab79a2f$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $8ba7aa3d2ab79a2f$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $8ba7aa3d2ab79a2f$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $6dqF3.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8ba7aa3d2ab79a2f$var$ObjectDefineProperties($8ba7aa3d2ab79a2f$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8ba7aa3d2ab79a2f$var$ObjectDefineProperties($8ba7aa3d2ab79a2f$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$8ba7aa3d2ab79a2f$var$kPaused] !== false;
        },
        set: function(value) {
            this[$8ba7aa3d2ab79a2f$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8ba7aa3d2ab79a2f$var$Readable._fromList = $8ba7aa3d2ab79a2f$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8ba7aa3d2ab79a2f$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8ba7aa3d2ab79a2f$var$endReadable(stream) {
    var state = stream._readableState;
    $8ba7aa3d2ab79a2f$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$endReadableNT, state, stream);
    }
}
function $8ba7aa3d2ab79a2f$var$endReadableNT(state, stream) {
    $8ba7aa3d2ab79a2f$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($8ba7aa3d2ab79a2f$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8ba7aa3d2ab79a2f$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8ba7aa3d2ab79a2f$var$Readable.from = function(iterable, opts) {
    return $lhhRP($8ba7aa3d2ab79a2f$var$Readable, iterable, opts);
};
var $8ba7aa3d2ab79a2f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8ba7aa3d2ab79a2f$var$lazyWebStreams() {
    if ($8ba7aa3d2ab79a2f$var$webStreamsAdapters === undefined) $8ba7aa3d2ab79a2f$var$webStreamsAdapters = {};
    return $8ba7aa3d2ab79a2f$var$webStreamsAdapters;
}
$8ba7aa3d2ab79a2f$var$Readable.fromWeb = function(readableStream, options) {
    return $8ba7aa3d2ab79a2f$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8ba7aa3d2ab79a2f$var$Readable.toWeb = function(streamReadable, options) {
    return $8ba7aa3d2ab79a2f$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8ba7aa3d2ab79a2f$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8ba7aa3d2ab79a2f$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $6dqF3.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("46v1I", function(module, exports) {
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $2fcfca34832494e0$var$ArrayIsArray = $bevD6.ArrayIsArray, $2fcfca34832494e0$var$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $2fcfca34832494e0$var$EE = $bBoAO.EventEmitter;
function $2fcfca34832494e0$var$Stream(opts) {
    $2fcfca34832494e0$var$EE.call(this, opts);
}
$2fcfca34832494e0$var$ObjectSetPrototypeOf($2fcfca34832494e0$var$Stream.prototype, $2fcfca34832494e0$var$EE.prototype);
$2fcfca34832494e0$var$ObjectSetPrototypeOf($2fcfca34832494e0$var$Stream, $2fcfca34832494e0$var$EE);
$2fcfca34832494e0$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($2fcfca34832494e0$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $2fcfca34832494e0$var$prependListener(source, 'error', onerror);
    $2fcfca34832494e0$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $2fcfca34832494e0$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($2fcfca34832494e0$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $2fcfca34832494e0$var$Stream,
    prependListener: $2fcfca34832494e0$var$prependListener
};

});

parcelRegister("3Ra6D", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $2cee29346214eb4c$export$e2db56ee53255a0; }, function (v) { return $2cee29346214eb4c$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $2cee29346214eb4c$export$11956e9313f43de0; }, function (v) { return $2cee29346214eb4c$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $2cee29346214eb4c$export$e2db56ee53255a0;
var $2cee29346214eb4c$export$11956e9313f43de0;
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $2cee29346214eb4c$require$SymbolDispose = $bevD6.SymbolDispose;

var $bXN8a = parcelRequire("bXN8a");
var $2cee29346214eb4c$var$AbortError = $bXN8a.AbortError, $2cee29346214eb4c$var$codes = $bXN8a.codes;

var $l3TFC = parcelRequire("l3TFC");
var $2cee29346214eb4c$var$isNodeStream = $l3TFC.isNodeStream, $2cee29346214eb4c$var$isWebStream = $l3TFC.isWebStream, $2cee29346214eb4c$var$kControllerErrorFunction = $l3TFC.kControllerErrorFunction;

var $4LEgK = parcelRequire("4LEgK");
var $2cee29346214eb4c$var$ERR_INVALID_ARG_TYPE = $2cee29346214eb4c$var$codes.ERR_INVALID_ARG_TYPE;
var $2cee29346214eb4c$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $2cee29346214eb4c$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $2cee29346214eb4c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$2cee29346214eb4c$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $2cee29346214eb4c$var$validateAbortSignal(signal, 'signal');
    if (!$2cee29346214eb4c$var$isNodeStream(stream) && !$2cee29346214eb4c$var$isWebStream(stream)) throw new $2cee29346214eb4c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $2cee29346214eb4c$export$11956e9313f43de0(signal, stream);
};

$2cee29346214eb4c$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $2cee29346214eb4c$var$isNodeStream(stream) ? function() {
        stream.destroy(new $2cee29346214eb4c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$2cee29346214eb4c$var$kControllerErrorFunction](new $2cee29346214eb4c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $2cee29346214eb4c$var$addAbortListener = $2cee29346214eb4c$var$addAbortListener || (parcelRequire("4IlY3")).addAbortListener;
        var disposable = $2cee29346214eb4c$var$addAbortListener(signal, onAbort);
        $4LEgK(stream, disposable[$2cee29346214eb4c$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("02WqQ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $008d83607d353ca9$var$StringPrototypeSlice = $bevD6.StringPrototypeSlice, $008d83607d353ca9$var$SymbolIterator = $bevD6.SymbolIterator, $008d83607d353ca9$var$TypedArrayPrototypeSet = $bevD6.TypedArrayPrototypeSet, $008d83607d353ca9$var$Uint8Array = $bevD6.Uint8Array;

var $efY7W = parcelRequire("efY7W");
var $008d83607d353ca9$require$Buffer = $efY7W.Buffer;

var $4IlY3 = parcelRequire("4IlY3");
var $008d83607d353ca9$require$inspect = $4IlY3.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $008d83607d353ca9$require$Buffer.alloc(0);
                var ret = $008d83607d353ca9$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $008d83607d353ca9$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $008d83607d353ca9$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $008d83607d353ca9$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $008d83607d353ca9$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $008d83607d353ca9$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $008d83607d353ca9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $008d83607d353ca9$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $008d83607d353ca9$var$TypedArrayPrototypeSet(ret, new $008d83607d353ca9$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $008d83607d353ca9$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("l9bFC", function(module, exports) {
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $f6537db4bfc68c76$var$MathFloor = $bevD6.MathFloor, $f6537db4bfc68c76$var$NumberIsInteger = $bevD6.NumberIsInteger;

var $l5smG = parcelRequire("l5smG");
var $f6537db4bfc68c76$require$validateInteger = $l5smG.validateInteger;

var $f6537db4bfc68c76$var$ERR_INVALID_ARG_VALUE = (parcelRequire("bXN8a")).codes.ERR_INVALID_ARG_VALUE;
var $f6537db4bfc68c76$var$defaultHighWaterMarkBytes = 16384;
var $f6537db4bfc68c76$var$defaultHighWaterMarkObjectMode = 16;
function $f6537db4bfc68c76$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f6537db4bfc68c76$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f6537db4bfc68c76$var$defaultHighWaterMarkObjectMode : $f6537db4bfc68c76$var$defaultHighWaterMarkBytes;
}
function $f6537db4bfc68c76$var$setDefaultHighWaterMark(objectMode, value) {
    $f6537db4bfc68c76$require$validateInteger(value, 'value', 0);
    if (objectMode) $f6537db4bfc68c76$var$defaultHighWaterMarkObjectMode = value;
    else $f6537db4bfc68c76$var$defaultHighWaterMarkBytes = value;
}
function $f6537db4bfc68c76$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $f6537db4bfc68c76$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f6537db4bfc68c76$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $f6537db4bfc68c76$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f6537db4bfc68c76$var$MathFloor(hwm);
    }
    // Default value
    return $f6537db4bfc68c76$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f6537db4bfc68c76$var$getHighWaterMark,
    getDefaultHighWaterMark: $f6537db4bfc68c76$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f6537db4bfc68c76$var$setDefaultHighWaterMark
};

});

parcelRegister("lhhRP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bevD6 = parcelRequire("bevD6");
/* replacement end */ var $f7d90b8eafcf92a6$var$PromisePrototypeThen = $bevD6.PromisePrototypeThen, $f7d90b8eafcf92a6$var$SymbolAsyncIterator = $bevD6.SymbolAsyncIterator, $f7d90b8eafcf92a6$var$SymbolIterator = $bevD6.SymbolIterator;

var $efY7W = parcelRequire("efY7W");
var $f7d90b8eafcf92a6$require$Buffer = $efY7W.Buffer;

var $bXN8a = parcelRequire("bXN8a");
var $f7d90b8eafcf92a6$require$_require_codes = $bXN8a.codes;
var $f7d90b8eafcf92a6$var$ERR_INVALID_ARG_TYPE = $f7d90b8eafcf92a6$require$_require_codes.ERR_INVALID_ARG_TYPE, $f7d90b8eafcf92a6$var$ERR_STREAM_NULL_VALUES = $f7d90b8eafcf92a6$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $f7d90b8eafcf92a6$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $f7d90b8eafcf92a6$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$f7d90b8eafcf92a6$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$f7d90b8eafcf92a6$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$f7d90b8eafcf92a6$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$f7d90b8eafcf92a6$var$SymbolIterator]();
    } else throw new $f7d90b8eafcf92a6$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $f7d90b8eafcf92a6$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $f7d90b8eafcf92a6$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $f7d90b8eafcf92a6$var$from;

});


parcelRegister("cE7Uu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $bevD6 = parcelRequire("bevD6");
/* replacement end */ var $934f5b42fac7c58b$var$ArrayPrototypeSlice = $bevD6.ArrayPrototypeSlice, $934f5b42fac7c58b$var$Error = $bevD6.Error, $934f5b42fac7c58b$var$FunctionPrototypeSymbolHasInstance = $bevD6.FunctionPrototypeSymbolHasInstance, $934f5b42fac7c58b$var$ObjectDefineProperty = $bevD6.ObjectDefineProperty, $934f5b42fac7c58b$var$ObjectDefineProperties = $bevD6.ObjectDefineProperties, $934f5b42fac7c58b$var$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf, $934f5b42fac7c58b$var$StringPrototypeToLowerCase = $bevD6.StringPrototypeToLowerCase, $934f5b42fac7c58b$var$Symbol = $bevD6.Symbol, $934f5b42fac7c58b$var$SymbolHasInstance = $bevD6.SymbolHasInstance;
module.exports = $934f5b42fac7c58b$var$Writable;
$934f5b42fac7c58b$var$Writable.WritableState = $934f5b42fac7c58b$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $934f5b42fac7c58b$var$EE = $bBoAO.EventEmitter;

var $46v1I = parcelRequire("46v1I");
var $934f5b42fac7c58b$require$Stream = $46v1I.Stream;

var $efY7W = parcelRequire("efY7W");
var $934f5b42fac7c58b$require$Buffer = $efY7W.Buffer;

var $6dqF3 = parcelRequire("6dqF3");

var $3Ra6D = parcelRequire("3Ra6D");
var $934f5b42fac7c58b$require$addAbortSignal = $3Ra6D.addAbortSignal;

var $l9bFC = parcelRequire("l9bFC");
var $934f5b42fac7c58b$var$getHighWaterMark = $l9bFC.getHighWaterMark, $934f5b42fac7c58b$var$getDefaultHighWaterMark = $l9bFC.getDefaultHighWaterMark;

var $bXN8a = parcelRequire("bXN8a");
var $934f5b42fac7c58b$require$_require_codes = $bXN8a.codes;
var $934f5b42fac7c58b$var$ERR_INVALID_ARG_TYPE = $934f5b42fac7c58b$require$_require_codes.ERR_INVALID_ARG_TYPE, $934f5b42fac7c58b$var$ERR_METHOD_NOT_IMPLEMENTED = $934f5b42fac7c58b$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $934f5b42fac7c58b$var$ERR_MULTIPLE_CALLBACK = $934f5b42fac7c58b$require$_require_codes.ERR_MULTIPLE_CALLBACK, $934f5b42fac7c58b$var$ERR_STREAM_CANNOT_PIPE = $934f5b42fac7c58b$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED = $934f5b42fac7c58b$require$_require_codes.ERR_STREAM_DESTROYED, $934f5b42fac7c58b$var$ERR_STREAM_ALREADY_FINISHED = $934f5b42fac7c58b$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $934f5b42fac7c58b$var$ERR_STREAM_NULL_VALUES = $934f5b42fac7c58b$require$_require_codes.ERR_STREAM_NULL_VALUES, $934f5b42fac7c58b$var$ERR_STREAM_WRITE_AFTER_END = $934f5b42fac7c58b$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $934f5b42fac7c58b$var$ERR_UNKNOWN_ENCODING = $934f5b42fac7c58b$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $934f5b42fac7c58b$var$errorOrDestroy = $6dqF3.errorOrDestroy;
$934f5b42fac7c58b$var$ObjectSetPrototypeOf($934f5b42fac7c58b$var$Writable.prototype, $934f5b42fac7c58b$require$Stream.prototype);
$934f5b42fac7c58b$var$ObjectSetPrototypeOf($934f5b42fac7c58b$var$Writable, $934f5b42fac7c58b$require$Stream);
function $934f5b42fac7c58b$var$nop() {}
var $934f5b42fac7c58b$var$kOnFinished = $934f5b42fac7c58b$var$Symbol('kOnFinished');

function $934f5b42fac7c58b$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("igMe9"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $934f5b42fac7c58b$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $934f5b42fac7c58b$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $934f5b42fac7c58b$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $934f5b42fac7c58b$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$934f5b42fac7c58b$var$kOnFinished] = [];
}
function $934f5b42fac7c58b$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$934f5b42fac7c58b$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $934f5b42fac7c58b$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$934f5b42fac7c58b$var$ObjectDefineProperty($934f5b42fac7c58b$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $934f5b42fac7c58b$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("igMe9"));
    if (!isDuplex && !$934f5b42fac7c58b$var$FunctionPrototypeSymbolHasInstance($934f5b42fac7c58b$var$Writable, this)) return new $934f5b42fac7c58b$var$Writable(options);
    this._writableState = new $934f5b42fac7c58b$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $934f5b42fac7c58b$require$addAbortSignal(options.signal, this);
    }
    $934f5b42fac7c58b$require$Stream.call(this, options);
    $6dqF3.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $934f5b42fac7c58b$var$clearBuffer(_this, state);
        $934f5b42fac7c58b$var$finishMaybe(_this, state);
    });
}
$934f5b42fac7c58b$var$ObjectDefineProperty($934f5b42fac7c58b$var$Writable, $934f5b42fac7c58b$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($934f5b42fac7c58b$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $934f5b42fac7c58b$var$Writable) return false;
        return object && object._writableState instanceof $934f5b42fac7c58b$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$934f5b42fac7c58b$var$Writable.prototype.pipe = function() {
    $934f5b42fac7c58b$var$errorOrDestroy(this, new $934f5b42fac7c58b$var$ERR_STREAM_CANNOT_PIPE());
};
function $934f5b42fac7c58b$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$934f5b42fac7c58b$require$Buffer.isEncoding(encoding)) throw new $934f5b42fac7c58b$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $934f5b42fac7c58b$var$nop;
    }
    if (chunk === null) throw new $934f5b42fac7c58b$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $934f5b42fac7c58b$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $934f5b42fac7c58b$require$Buffer) encoding = 'buffer';
        else if ($934f5b42fac7c58b$require$Stream._isUint8Array(chunk)) {
            chunk = $934f5b42fac7c58b$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $934f5b42fac7c58b$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $934f5b42fac7c58b$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $934f5b42fac7c58b$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $934f5b42fac7c58b$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$934f5b42fac7c58b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $934f5b42fac7c58b$var$_write(this, chunk, encoding, cb) === true;
};
$934f5b42fac7c58b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$934f5b42fac7c58b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $934f5b42fac7c58b$var$clearBuffer(this, state);
    }
};
$934f5b42fac7c58b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $934f5b42fac7c58b$var$StringPrototypeToLowerCase(encoding);
    if (!$934f5b42fac7c58b$require$Buffer.isEncoding(encoding)) throw new $934f5b42fac7c58b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $934f5b42fac7c58b$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $934f5b42fac7c58b$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $934f5b42fac7c58b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $934f5b42fac7c58b$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $934f5b42fac7c58b$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $934f5b42fac7c58b$var$errorOrDestroy(stream, er);
}
function $934f5b42fac7c58b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $934f5b42fac7c58b$var$errorOrDestroy(stream, new $934f5b42fac7c58b$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($934f5b42fac7c58b$var$onwriteError, stream, state, er, cb);
        else $934f5b42fac7c58b$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $934f5b42fac7c58b$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($934f5b42fac7c58b$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $934f5b42fac7c58b$var$afterWrite(stream, state, 1, cb);
    }
}
function $934f5b42fac7c58b$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $934f5b42fac7c58b$var$afterWrite(stream, state, count, cb);
}
function $934f5b42fac7c58b$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $934f5b42fac7c58b$var$errorBuffer(state);
    $934f5b42fac7c58b$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $934f5b42fac7c58b$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$934f5b42fac7c58b$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED('end'));
    }
    $934f5b42fac7c58b$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $934f5b42fac7c58b$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $934f5b42fac7c58b$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $934f5b42fac7c58b$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $934f5b42fac7c58b$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $934f5b42fac7c58b$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $934f5b42fac7c58b$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $934f5b42fac7c58b$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$934f5b42fac7c58b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $934f5b42fac7c58b$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$934f5b42fac7c58b$var$Writable.prototype._writev = null;
$934f5b42fac7c58b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $934f5b42fac7c58b$var$_write(this, chunk, encoding);
        if (ret instanceof $934f5b42fac7c58b$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $934f5b42fac7c58b$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $934f5b42fac7c58b$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $934f5b42fac7c58b$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$934f5b42fac7c58b$var$kOnFinished].push(cb);
    }
    return this;
};
function $934f5b42fac7c58b$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $934f5b42fac7c58b$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $934f5b42fac7c58b$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $934f5b42fac7c58b$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$934f5b42fac7c58b$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $934f5b42fac7c58b$var$errorOrDestroy(stream, err, state.sync);
        } else if ($934f5b42fac7c58b$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($934f5b42fac7c58b$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $934f5b42fac7c58b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $934f5b42fac7c58b$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $934f5b42fac7c58b$var$finishMaybe(stream, state, sync) {
    if ($934f5b42fac7c58b$var$needFinish(state)) {
        $934f5b42fac7c58b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($934f5b42fac7c58b$var$needFinish(state)) $934f5b42fac7c58b$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($934f5b42fac7c58b$var$needFinish(state)) {
                state.pendingcb++;
                $934f5b42fac7c58b$var$finish(stream, state);
            }
        }
    }
}
function $934f5b42fac7c58b$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$934f5b42fac7c58b$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$934f5b42fac7c58b$var$ObjectDefineProperties($934f5b42fac7c58b$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $934f5b42fac7c58b$var$destroy = $6dqF3.destroy;
$934f5b42fac7c58b$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$934f5b42fac7c58b$var$kOnFinished].length)) $2Qkr5.nextTick($934f5b42fac7c58b$var$errorBuffer, state);
    $934f5b42fac7c58b$var$destroy.call(this, err, cb);
    return this;
};
$934f5b42fac7c58b$var$Writable.prototype._undestroy = $6dqF3.undestroy;
$934f5b42fac7c58b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$934f5b42fac7c58b$var$Writable.prototype[$934f5b42fac7c58b$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $934f5b42fac7c58b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $934f5b42fac7c58b$var$lazyWebStreams() {
    if ($934f5b42fac7c58b$var$webStreamsAdapters === undefined) $934f5b42fac7c58b$var$webStreamsAdapters = {};
    return $934f5b42fac7c58b$var$webStreamsAdapters;
}
$934f5b42fac7c58b$var$Writable.fromWeb = function(writableStream, options) {
    return $934f5b42fac7c58b$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$934f5b42fac7c58b$var$Writable.toWeb = function(streamWritable) {
    return $934f5b42fac7c58b$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("gVmX7", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $efY7W = parcelRequire("efY7W");

var $l3TFC = parcelRequire("l3TFC");
var $c523c61f5595f3e3$var$isReadable = $l3TFC.isReadable, $c523c61f5595f3e3$var$isWritable = $l3TFC.isWritable, $c523c61f5595f3e3$var$isIterable = $l3TFC.isIterable, $c523c61f5595f3e3$var$isNodeStream = $l3TFC.isNodeStream, $c523c61f5595f3e3$var$isReadableNodeStream = $l3TFC.isReadableNodeStream, $c523c61f5595f3e3$var$isWritableNodeStream = $l3TFC.isWritableNodeStream, $c523c61f5595f3e3$var$isDuplexNodeStream = $l3TFC.isDuplexNodeStream, $c523c61f5595f3e3$var$isReadableStream = $l3TFC.isReadableStream, $c523c61f5595f3e3$var$isWritableStream = $l3TFC.isWritableStream;

var $4LEgK = parcelRequire("4LEgK");

var $bXN8a = parcelRequire("bXN8a");
var $c523c61f5595f3e3$var$AbortError = $bXN8a.AbortError, $c523c61f5595f3e3$var$_require_codes = $bXN8a.codes, $c523c61f5595f3e3$var$ERR_INVALID_ARG_TYPE = $c523c61f5595f3e3$var$_require_codes.ERR_INVALID_ARG_TYPE, $c523c61f5595f3e3$var$ERR_INVALID_RETURN_VALUE = $c523c61f5595f3e3$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $6dqF3 = parcelRequire("6dqF3");
var $c523c61f5595f3e3$require$destroyer = $6dqF3.destroyer;

var $igMe9 = parcelRequire("igMe9");

var $bZnyC = parcelRequire("bZnyC");

var $cE7Uu = parcelRequire("cE7Uu");

var $4IlY3 = parcelRequire("4IlY3");
var $c523c61f5595f3e3$require$createDeferredPromise = $4IlY3.createDeferredPromise;

var $lhhRP = parcelRequire("lhhRP");
var $c523c61f5595f3e3$var$Blob = globalThis.Blob || $efY7W.Blob;
var $c523c61f5595f3e3$var$isBlob = typeof $c523c61f5595f3e3$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $c523c61f5595f3e3$var$Blob;
} : function isBlob(b) {
    return false;
};

var $c523c61f5595f3e3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $bevD6 = parcelRequire("bevD6");
var $c523c61f5595f3e3$require$FunctionPrototypeCall = $bevD6.FunctionPrototypeCall;
// This is needed for pre node 17.
var $c523c61f5595f3e3$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($igMe9);
module.exports = function duplexify(body, name) {
    if ($c523c61f5595f3e3$var$isDuplexNodeStream(body)) return body;
    if ($c523c61f5595f3e3$var$isReadableNodeStream(body)) return $c523c61f5595f3e3$var$_duplexify({
        readable: body
    });
    if ($c523c61f5595f3e3$var$isWritableNodeStream(body)) return $c523c61f5595f3e3$var$_duplexify({
        writable: body
    });
    if ($c523c61f5595f3e3$var$isNodeStream(body)) return $c523c61f5595f3e3$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($c523c61f5595f3e3$var$isReadableStream(body)) return $c523c61f5595f3e3$var$_duplexify({
        readable: $bZnyC.fromWeb(body)
    });
    if ($c523c61f5595f3e3$var$isWritableStream(body)) return $c523c61f5595f3e3$var$_duplexify({
        writable: $cE7Uu.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $c523c61f5595f3e3$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($c523c61f5595f3e3$var$isIterable(value)) return $lhhRP($c523c61f5595f3e3$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $c523c61f5595f3e3$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $c523c61f5595f3e3$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $c523c61f5595f3e3$require$destroyer(d, err);
            });
            return d = new $c523c61f5595f3e3$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $c523c61f5595f3e3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($c523c61f5595f3e3$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($c523c61f5595f3e3$var$isIterable(body)) return $lhhRP($c523c61f5595f3e3$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($c523c61f5595f3e3$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $c523c61f5595f3e3$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $c523c61f5595f3e3$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $c523c61f5595f3e3$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $c523c61f5595f3e3$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $c523c61f5595f3e3$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $c523c61f5595f3e3$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $c523c61f5595f3e3$require$destroyer(d1, err);
        });
        return d1 = new $c523c61f5595f3e3$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $c523c61f5595f3e3$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $c523c61f5595f3e3$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $c523c61f5595f3e3$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $c523c61f5595f3e3$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $c523c61f5595f3e3$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $c523c61f5595f3e3$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $c523c61f5595f3e3$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $bZnyC.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$c523c61f5595f3e3$var$isReadable(r);
    var writable = !!$c523c61f5595f3e3$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $c523c61f5595f3e3$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $4LEgK(w, function(err) {
            writable = false;
            if (err) $c523c61f5595f3e3$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $4LEgK(r, function(err) {
            readable = false;
            if (err) $c523c61f5595f3e3$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $c523c61f5595f3e3$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $c523c61f5595f3e3$require$destroyer(w, err);
            $c523c61f5595f3e3$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("5XSOL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $457cfc1ceb0c5267$require$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf;
module.exports = $457cfc1ceb0c5267$var$PassThrough;

var $bHII3 = parcelRequire("bHII3");
$457cfc1ceb0c5267$require$ObjectSetPrototypeOf($457cfc1ceb0c5267$var$PassThrough.prototype, $bHII3.prototype);
$457cfc1ceb0c5267$require$ObjectSetPrototypeOf($457cfc1ceb0c5267$var$PassThrough, $bHII3);
function $457cfc1ceb0c5267$var$PassThrough(options) {
    if (!(this instanceof $457cfc1ceb0c5267$var$PassThrough)) return new $457cfc1ceb0c5267$var$PassThrough(options);
    $bHII3.call(this, options);
}
$457cfc1ceb0c5267$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("bHII3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $885664421c8eec88$var$ObjectSetPrototypeOf = $bevD6.ObjectSetPrototypeOf, $885664421c8eec88$var$Symbol = $bevD6.Symbol;
module.exports = $885664421c8eec88$var$Transform;

var $885664421c8eec88$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("bXN8a")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $igMe9 = parcelRequire("igMe9");

var $l9bFC = parcelRequire("l9bFC");
var $885664421c8eec88$require$getHighWaterMark = $l9bFC.getHighWaterMark;
$885664421c8eec88$var$ObjectSetPrototypeOf($885664421c8eec88$var$Transform.prototype, $igMe9.prototype);
$885664421c8eec88$var$ObjectSetPrototypeOf($885664421c8eec88$var$Transform, $igMe9);
var $885664421c8eec88$var$kCallback = $885664421c8eec88$var$Symbol('kCallback');
function $885664421c8eec88$var$Transform(options) {
    if (!(this instanceof $885664421c8eec88$var$Transform)) return new $885664421c8eec88$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $885664421c8eec88$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $igMe9.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$885664421c8eec88$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $885664421c8eec88$var$prefinish);
}
function $885664421c8eec88$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $885664421c8eec88$var$prefinish() {
    if (this._final !== $885664421c8eec88$var$_final) $885664421c8eec88$var$_final.call(this);
}
$885664421c8eec88$var$Transform.prototype._final = $885664421c8eec88$var$_final;
$885664421c8eec88$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $885664421c8eec88$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$885664421c8eec88$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$885664421c8eec88$var$kCallback] = callback;
    });
};
$885664421c8eec88$var$Transform.prototype._read = function() {
    if (this[$885664421c8eec88$var$kCallback]) {
        var callback = this[$885664421c8eec88$var$kCallback];
        this[$885664421c8eec88$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("4eMD9", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $bevD6 = parcelRequire("bevD6");
var $315e313bfa56ef95$var$ArrayPrototypePop = $bevD6.ArrayPrototypePop, $315e313bfa56ef95$var$Promise = $bevD6.Promise;

var $l3TFC = parcelRequire("l3TFC");
var $315e313bfa56ef95$var$isIterable = $l3TFC.isIterable, $315e313bfa56ef95$var$isNodeStream = $l3TFC.isNodeStream, $315e313bfa56ef95$var$isWebStream = $l3TFC.isWebStream;

var $1cPA2 = parcelRequire("1cPA2");
var $315e313bfa56ef95$var$pl = $1cPA2.pipelineImpl;

var $4LEgK = parcelRequire("4LEgK");
var $315e313bfa56ef95$require$finished = $4LEgK.finished;
parcelRequire("eVq7Q");
function $315e313bfa56ef95$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $315e313bfa56ef95$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$315e313bfa56ef95$var$isNodeStream(lastArg) && !$315e313bfa56ef95$var$isIterable(lastArg) && !$315e313bfa56ef95$var$isWebStream(lastArg)) {
            var options = $315e313bfa56ef95$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $315e313bfa56ef95$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $315e313bfa56ef95$require$finished,
    pipeline: $315e313bfa56ef95$var$pipeline
};

});





parcelRegister("9CR5Y", function(module, exports) {
"use strict";
var $7020d946258208d7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7020d946258208d7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7020d946258208d7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7020d946258208d7$var$__exportStar((parcelRequire("fuRM4")), module.exports);

$7020d946258208d7$var$__exportStar((parcelRequire("3jGsy")), module.exports);

});
parcelRegister("fuRM4", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserverHttp = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * Observes HTTP actions, and maintains a counter of the number of requests.
 */ var $b4835ed47bf9398e$var$ActionObserverHttp = /*#__PURE__*/ function(_core_1_ActionObserver) {
    (0, $i3fW3._)(ActionObserverHttp, _core_1_ActionObserver);
    function ActionObserverHttp(args) {
        (0, $jGAMp._)(this, ActionObserverHttp);
        var _this;
        _this = (0, $kzDuW._)(this, ActionObserverHttp, [
            args
        ]);
        _this.requests = 0;
        _this.bus.subscribeObserver(_this);
        _this.httpInvalidator.addInvalidateListener(function() {
            _this.requests = 0;
        });
        return _this;
    }
    (0, $byiyg._)(ActionObserverHttp, [
        {
            /* eslint-enable max-len */ key: "onRun",
            value: function onRun(actor, _action, _output) {
                if (this.observedActors.includes(actor.name)) this.requests++;
            }
        }
    ]);
    return ActionObserverHttp;
}($kNNoa.ActionObserver);
module.exports.ActionObserverHttp = $b4835ed47bf9398e$var$ActionObserverHttp;

});

parcelRegister("3jGsy", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeStats = void 0;

var $cqzMF = parcelRequire("cqzMF");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $aafx9 = parcelRequire("aafx9");

var $16k9K = parcelRequire("16k9K");
/**
 * Serializes SPARQL results for testing and debugging.
 */ var $26a4150920e0e9dc$var$ActorQueryResultSerializeStats = /*#__PURE__*/ function(_bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes) {
    (0, $i3fW3._)(ActorQueryResultSerializeStats, _bus_query_result_serialize_1_ActorQueryResultSerializeFixedMediaTypes);
    function ActorQueryResultSerializeStats(args) {
        (0, $jGAMp._)(this, ActorQueryResultSerializeStats);
        return (0, $kzDuW._)(this, ActorQueryResultSerializeStats, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryResultSerializeStats, [
        {
            key: "testHandleChecked",
            value: /* eslint-enable max-len */ function testHandleChecked(action, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (![
                            'bindings',
                            'quads'
                        ].includes(action.type)) return [
                            2,
                            (0, $kNNoa.failTest)('This actor can only handle bindings streams or quad streams.')
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "pushHeader",
            value: function pushHeader(data) {
                var header = [
                    'Result',
                    'Delay (ms)',
                    'HTTP requests'
                ].join(',');
                data.push("".concat(header, "\n"));
            }
        },
        {
            key: "createStat",
            value: function createStat(startTime, result) {
                var row = [
                    result,
                    this.delay(startTime),
                    this.httpObserver.requests
                ].join(',');
                return "".concat(row, "\n");
            }
        },
        {
            key: "createSpecialLine",
            value: function createSpecialLine(label, startTime) {
                var line = [
                    label,
                    this.delay(startTime),
                    this.httpObserver.requests
                ].join(',');
                return "".concat(line, "\n");
            }
        },
        {
            key: "runHandle",
            value: function runHandle(action, _mediaType, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, data, resultStream, startTime, result, stream;
                    function end(cb) {
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        cb()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        data = new $16k9K.Readable();
                        resultStream = action.type === 'bindings' ? action.bindingsStream : action.quadStream;
                        startTime = action.context.getSafe($9nBhR.KeysInitQuery.queryTimestampHighResolution);
                        result = 1;
                        stream = (0, $aafx9.wrap)(resultStream).map(function() {
                            return _this.createStat(startTime, result++);
                        }).prepend([
                            this.createSpecialLine('PLANNING', startTime)
                        ]).append((0, $aafx9.wrap)(end(function() {
                            return _this.createSpecialLine('TOTAL', startTime);
                        })));
                        this.pushHeader(data);
                        data.wrap(stream);
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "now",
            value: function now() {
                return performance.now();
            }
        },
        {
            key: "delay",
            value: function delay(startTime) {
                return this.now() - startTime;
            }
        }
    ]);
    return ActorQueryResultSerializeStats;
}($cqzMF.ActorQueryResultSerializeFixedMediaTypes);
module.exports.ActorQueryResultSerializeStats = $26a4150920e0e9dc$var$ActorQueryResultSerializeStats;

});
parcelRegister("16k9K", function(module, exports) {
'use strict';

var $17TJM = parcelRequire("17TJM");

var $2RiDF = parcelRequire("2RiDF");
var $0cd5fc924fc4dc51$var$originalDestroy = $17TJM.Readable.destroy;
module.exports = $17TJM.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $17TJM._uint8ArrayToBuffer;
module.exports._isUint8Array = $17TJM._isUint8Array;
module.exports.isDisturbed = $17TJM.isDisturbed;
module.exports.isErrored = $17TJM.isErrored;
module.exports.isReadable = $17TJM.isReadable;
module.exports.Readable = $17TJM.Readable;
module.exports.Writable = $17TJM.Writable;
module.exports.Duplex = $17TJM.Duplex;
module.exports.Transform = $17TJM.Transform;
module.exports.PassThrough = $17TJM.PassThrough;
module.exports.addAbortSignal = $17TJM.addAbortSignal;
module.exports.finished = $17TJM.finished;
module.exports.destroy = $17TJM.destroy;
module.exports.destroy = $0cd5fc924fc4dc51$var$originalDestroy;
module.exports.pipeline = $17TJM.pipeline;
module.exports.compose = $17TJM.compose;
Object.defineProperty($17TJM, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $2RiDF;
    }
});
module.exports.Stream = $17TJM.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("17TJM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $8lo7h = parcelRequire("8lo7h");
var $0d21ae2e1b0d85a5$require$Buffer = $8lo7h.Buffer;

var $a0D5I = parcelRequire("a0D5I");
/* replacement end */ var $0d21ae2e1b0d85a5$var$ObjectDefineProperty = $a0D5I.ObjectDefineProperty, $0d21ae2e1b0d85a5$var$ObjectKeys = $a0D5I.ObjectKeys, $0d21ae2e1b0d85a5$var$ReflectApply = $a0D5I.ReflectApply;

var $4IP8j = parcelRequire("4IP8j");
var $0d21ae2e1b0d85a5$var$_require_promisify = $4IP8j.promisify, $0d21ae2e1b0d85a5$var$customPromisify = $0d21ae2e1b0d85a5$var$_require_promisify.custom;

var $fxq6M = parcelRequire("fxq6M");
var $0d21ae2e1b0d85a5$var$streamReturningOperators = $fxq6M.streamReturningOperators, $0d21ae2e1b0d85a5$var$promiseReturningOperators = $fxq6M.promiseReturningOperators;

var $kQgvZ = parcelRequire("kQgvZ");
var $0d21ae2e1b0d85a5$var$ERR_ILLEGAL_CONSTRUCTOR = $kQgvZ.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $aI7xs = parcelRequire("aI7xs");

var $eCV4g = parcelRequire("eCV4g");
var $0d21ae2e1b0d85a5$var$setDefaultHighWaterMark = $eCV4g.setDefaultHighWaterMark, $0d21ae2e1b0d85a5$var$getDefaultHighWaterMark = $eCV4g.getDefaultHighWaterMark;

var $6WtEZ = parcelRequire("6WtEZ");
var $0d21ae2e1b0d85a5$require$pipeline = $6WtEZ.pipeline;

var $32GkH = parcelRequire("32GkH");
var $0d21ae2e1b0d85a5$require$destroyer = $32GkH.destroyer;

var $bIKWZ = parcelRequire("bIKWZ");
var $0d21ae2e1b0d85a5$var$internalBuffer = {};

var $2RiDF = parcelRequire("2RiDF");

var $468KT = parcelRequire("468KT");

var $0d21ae2e1b0d85a5$var$Stream = module.exports = (parcelRequire("7tuPk")).Stream;
$0d21ae2e1b0d85a5$var$Stream.isDestroyed = $468KT.isDestroyed;
$0d21ae2e1b0d85a5$var$Stream.isDisturbed = $468KT.isDisturbed;
$0d21ae2e1b0d85a5$var$Stream.isErrored = $468KT.isErrored;
$0d21ae2e1b0d85a5$var$Stream.isReadable = $468KT.isReadable;
$0d21ae2e1b0d85a5$var$Stream.isWritable = $468KT.isWritable;

$0d21ae2e1b0d85a5$var$Stream.Readable = (parcelRequire("1yLBO"));
var $0d21ae2e1b0d85a5$var$_iteratorNormalCompletion = true, $0d21ae2e1b0d85a5$var$_didIteratorError = false, $0d21ae2e1b0d85a5$var$_iteratorError = undefined;
try {
    for(var $0d21ae2e1b0d85a5$var$_iterator = $0d21ae2e1b0d85a5$var$ObjectKeys($0d21ae2e1b0d85a5$var$streamReturningOperators)[Symbol.iterator](), $0d21ae2e1b0d85a5$var$_step; !($0d21ae2e1b0d85a5$var$_iteratorNormalCompletion = ($0d21ae2e1b0d85a5$var$_step = $0d21ae2e1b0d85a5$var$_iterator.next()).done); $0d21ae2e1b0d85a5$var$_iteratorNormalCompletion = true){
        var $0d21ae2e1b0d85a5$var$key = $0d21ae2e1b0d85a5$var$_step.value;
        var $0d21ae2e1b0d85a5$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $0d21ae2e1b0d85a5$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0d21ae2e1b0d85a5$var$Stream.Readable.from($0d21ae2e1b0d85a5$var$ReflectApply($0d21ae2e1b0d85a5$var$op, this, args));
        };
        var $0d21ae2e1b0d85a5$var$op = $0d21ae2e1b0d85a5$var$streamReturningOperators[$0d21ae2e1b0d85a5$var$key];
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$fn, 'name', {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$op.name
        });
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$fn, 'length', {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$op.length
        });
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$Stream.Readable.prototype, $0d21ae2e1b0d85a5$var$key, {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0d21ae2e1b0d85a5$var$_didIteratorError = true;
    $0d21ae2e1b0d85a5$var$_iteratorError = err;
} finally{
    try {
        if (!$0d21ae2e1b0d85a5$var$_iteratorNormalCompletion && $0d21ae2e1b0d85a5$var$_iterator["return"] != null) {
            $0d21ae2e1b0d85a5$var$_iterator["return"]();
        }
    } finally{
        if ($0d21ae2e1b0d85a5$var$_didIteratorError) {
            throw $0d21ae2e1b0d85a5$var$_iteratorError;
        }
    }
}
var $0d21ae2e1b0d85a5$var$_iteratorNormalCompletion1 = true, $0d21ae2e1b0d85a5$var$_didIteratorError1 = false, $0d21ae2e1b0d85a5$var$_iteratorError1 = undefined;
try {
    for(var $0d21ae2e1b0d85a5$var$_iterator1 = $0d21ae2e1b0d85a5$var$ObjectKeys($0d21ae2e1b0d85a5$var$promiseReturningOperators)[Symbol.iterator](), $0d21ae2e1b0d85a5$var$_step1; !($0d21ae2e1b0d85a5$var$_iteratorNormalCompletion1 = ($0d21ae2e1b0d85a5$var$_step1 = $0d21ae2e1b0d85a5$var$_iterator1.next()).done); $0d21ae2e1b0d85a5$var$_iteratorNormalCompletion1 = true){
        var $0d21ae2e1b0d85a5$var$key1 = $0d21ae2e1b0d85a5$var$_step1.value;
        var $0d21ae2e1b0d85a5$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $0d21ae2e1b0d85a5$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0d21ae2e1b0d85a5$var$ReflectApply($0d21ae2e1b0d85a5$var$op1, this, args);
        };
        var $0d21ae2e1b0d85a5$var$op1 = $0d21ae2e1b0d85a5$var$promiseReturningOperators[$0d21ae2e1b0d85a5$var$key1];
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$fn1, 'name', {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$op1.name
        });
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$fn1, 'length', {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$op1.length
        });
        $0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$Stream.Readable.prototype, $0d21ae2e1b0d85a5$var$key1, {
            __proto__: null,
            value: $0d21ae2e1b0d85a5$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0d21ae2e1b0d85a5$var$_didIteratorError1 = true;
    $0d21ae2e1b0d85a5$var$_iteratorError1 = err;
} finally{
    try {
        if (!$0d21ae2e1b0d85a5$var$_iteratorNormalCompletion1 && $0d21ae2e1b0d85a5$var$_iterator1["return"] != null) {
            $0d21ae2e1b0d85a5$var$_iterator1["return"]();
        }
    } finally{
        if ($0d21ae2e1b0d85a5$var$_didIteratorError1) {
            throw $0d21ae2e1b0d85a5$var$_iteratorError1;
        }
    }
}

$0d21ae2e1b0d85a5$var$Stream.Writable = (parcelRequire("jBLP2"));

$0d21ae2e1b0d85a5$var$Stream.Duplex = (parcelRequire("lws7Y"));

$0d21ae2e1b0d85a5$var$Stream.Transform = (parcelRequire("9YyJs"));

$0d21ae2e1b0d85a5$var$Stream.PassThrough = (parcelRequire("jrjUz"));
$0d21ae2e1b0d85a5$var$Stream.pipeline = $0d21ae2e1b0d85a5$require$pipeline;

var $hnuyc = parcelRequire("hnuyc");
var $0d21ae2e1b0d85a5$require$addAbortSignal = $hnuyc.addAbortSignal;
$0d21ae2e1b0d85a5$var$Stream.addAbortSignal = $0d21ae2e1b0d85a5$require$addAbortSignal;
$0d21ae2e1b0d85a5$var$Stream.finished = $bIKWZ;
$0d21ae2e1b0d85a5$var$Stream.destroy = $0d21ae2e1b0d85a5$require$destroyer;
$0d21ae2e1b0d85a5$var$Stream.compose = $aI7xs;
$0d21ae2e1b0d85a5$var$Stream.setDefaultHighWaterMark = $0d21ae2e1b0d85a5$var$setDefaultHighWaterMark;
$0d21ae2e1b0d85a5$var$Stream.getDefaultHighWaterMark = $0d21ae2e1b0d85a5$var$getDefaultHighWaterMark;
$0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $2RiDF;
    }
});
$0d21ae2e1b0d85a5$var$ObjectDefineProperty($0d21ae2e1b0d85a5$require$pipeline, $0d21ae2e1b0d85a5$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2RiDF.pipeline;
    }
});
$0d21ae2e1b0d85a5$var$ObjectDefineProperty($bIKWZ, $0d21ae2e1b0d85a5$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $2RiDF.finished;
    }
});
// Backwards-compat with node 0.4.x
$0d21ae2e1b0d85a5$var$Stream.Stream = $0d21ae2e1b0d85a5$var$Stream;
$0d21ae2e1b0d85a5$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$0d21ae2e1b0d85a5$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $0d21ae2e1b0d85a5$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("8lo7h", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6132fded22868769$export$a143d493d941bafc; }, function (v) { return $6132fded22868769$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6132fded22868769$export$f99ded8fe4b79145; }, function (v) { return $6132fded22868769$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $6132fded22868769$export$a143d493d941bafc;
var $6132fded22868769$export$e4cf37d7f6fb9e0a;
var $6132fded22868769$export$f99ded8fe4b79145;
var $6132fded22868769$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $6132fded22868769$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6132fded22868769$export$a143d493d941bafc = $6132fded22868769$var$Buffer;
$6132fded22868769$export$e4cf37d7f6fb9e0a = $6132fded22868769$var$SlowBuffer;
$6132fded22868769$export$f99ded8fe4b79145 = 50;
var $6132fded22868769$var$K_MAX_LENGTH = 0x7fffffff;
$6132fded22868769$export$599f31c3813fae4d = $6132fded22868769$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6132fded22868769$var$Buffer.TYPED_ARRAY_SUPPORT = $6132fded22868769$var$typedArraySupport();
if (!$6132fded22868769$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6132fded22868769$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6132fded22868769$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$6132fded22868769$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6132fded22868769$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$6132fded22868769$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6132fded22868769$var$createBuffer(length) {
    if (length > $6132fded22868769$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6132fded22868769$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6132fded22868769$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6132fded22868769$var$allocUnsafe(arg);
    }
    return $6132fded22868769$var$from(arg, encodingOrOffset, length);
}
$6132fded22868769$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6132fded22868769$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6132fded22868769$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6132fded22868769$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($6132fded22868769$var$isInstance(value, ArrayBuffer) || value && $6132fded22868769$var$isInstance(value.buffer, ArrayBuffer)) return $6132fded22868769$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6132fded22868769$var$isInstance(value, SharedArrayBuffer) || value && $6132fded22868769$var$isInstance(value.buffer, SharedArrayBuffer))) return $6132fded22868769$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6132fded22868769$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6132fded22868769$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6132fded22868769$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6132fded22868769$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6132fded22868769$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6132fded22868769$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6132fded22868769$var$Buffer, Uint8Array);
function $6132fded22868769$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6132fded22868769$var$alloc(size, fill, encoding) {
    $6132fded22868769$var$assertSize(size);
    if (size <= 0) return $6132fded22868769$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6132fded22868769$var$createBuffer(size).fill(fill, encoding) : $6132fded22868769$var$createBuffer(size).fill(fill);
    return $6132fded22868769$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6132fded22868769$var$Buffer.alloc = function(size, fill, encoding) {
    return $6132fded22868769$var$alloc(size, fill, encoding);
};
function $6132fded22868769$var$allocUnsafe(size) {
    $6132fded22868769$var$assertSize(size);
    return $6132fded22868769$var$createBuffer(size < 0 ? 0 : $6132fded22868769$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6132fded22868769$var$Buffer.allocUnsafe = function(size) {
    return $6132fded22868769$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6132fded22868769$var$Buffer.allocUnsafeSlow = function(size) {
    return $6132fded22868769$var$allocUnsafe(size);
};
function $6132fded22868769$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6132fded22868769$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6132fded22868769$var$byteLength(string, encoding) | 0;
    var buf = $6132fded22868769$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6132fded22868769$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6132fded22868769$var$checked(array.length) | 0;
    var buf = $6132fded22868769$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6132fded22868769$var$fromArrayView(arrayView) {
    if ($6132fded22868769$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6132fded22868769$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6132fded22868769$var$fromArrayLike(arrayView);
}
function $6132fded22868769$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6132fded22868769$var$Buffer.prototype);
    return buf;
}
function $6132fded22868769$var$fromObject(obj) {
    if ($6132fded22868769$var$Buffer.isBuffer(obj)) {
        var len = $6132fded22868769$var$checked(obj.length) | 0;
        var buf = $6132fded22868769$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6132fded22868769$var$numberIsNaN(obj.length)) return $6132fded22868769$var$createBuffer(0);
        return $6132fded22868769$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6132fded22868769$var$fromArrayLike(obj.data);
}
function $6132fded22868769$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6132fded22868769$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6132fded22868769$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6132fded22868769$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6132fded22868769$var$Buffer.alloc(+length);
}
$6132fded22868769$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6132fded22868769$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6132fded22868769$var$Buffer.compare = function compare(a, b) {
    if ($6132fded22868769$var$isInstance(a, Uint8Array)) a = $6132fded22868769$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6132fded22868769$var$isInstance(b, Uint8Array)) b = $6132fded22868769$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6132fded22868769$var$Buffer.isBuffer(a) || !$6132fded22868769$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6132fded22868769$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6132fded22868769$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6132fded22868769$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6132fded22868769$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6132fded22868769$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6132fded22868769$var$Buffer.isBuffer(buf)) buf = $6132fded22868769$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6132fded22868769$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6132fded22868769$var$byteLength(string, encoding) {
    if ($6132fded22868769$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6132fded22868769$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6132fded22868769$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6132fded22868769$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6132fded22868769$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6132fded22868769$var$Buffer.byteLength = $6132fded22868769$var$byteLength;
function $6132fded22868769$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6132fded22868769$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6132fded22868769$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6132fded22868769$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6132fded22868769$var$latin1Slice(this, start, end);
        case 'base64':
            return $6132fded22868769$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6132fded22868769$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6132fded22868769$var$Buffer.prototype._isBuffer = true;
function $6132fded22868769$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6132fded22868769$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6132fded22868769$var$swap(this, i, i + 1);
    return this;
};
$6132fded22868769$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6132fded22868769$var$swap(this, i, i + 3);
        $6132fded22868769$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6132fded22868769$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6132fded22868769$var$swap(this, i, i + 7);
        $6132fded22868769$var$swap(this, i + 1, i + 6);
        $6132fded22868769$var$swap(this, i + 2, i + 5);
        $6132fded22868769$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6132fded22868769$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6132fded22868769$var$utf8Slice(this, 0, length);
    return $6132fded22868769$var$slowToString.apply(this, arguments);
};
$6132fded22868769$var$Buffer.prototype.toLocaleString = $6132fded22868769$var$Buffer.prototype.toString;
$6132fded22868769$var$Buffer.prototype.equals = function equals(b) {
    if (!$6132fded22868769$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6132fded22868769$var$Buffer.compare(this, b) === 0;
};
$6132fded22868769$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6132fded22868769$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6132fded22868769$var$customInspectSymbol) $6132fded22868769$var$Buffer.prototype[$6132fded22868769$var$customInspectSymbol] = $6132fded22868769$var$Buffer.prototype.inspect;
$6132fded22868769$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6132fded22868769$var$isInstance(target, Uint8Array)) target = $6132fded22868769$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6132fded22868769$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6132fded22868769$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6132fded22868769$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6132fded22868769$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6132fded22868769$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6132fded22868769$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6132fded22868769$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6132fded22868769$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6132fded22868769$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6132fded22868769$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6132fded22868769$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6132fded22868769$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6132fded22868769$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6132fded22868769$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6132fded22868769$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6132fded22868769$var$utf8Write(buf, string, offset, length) {
    return $6132fded22868769$var$blitBuffer($6132fded22868769$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6132fded22868769$var$asciiWrite(buf, string, offset, length) {
    return $6132fded22868769$var$blitBuffer($6132fded22868769$var$asciiToBytes(string), buf, offset, length);
}
function $6132fded22868769$var$base64Write(buf, string, offset, length) {
    return $6132fded22868769$var$blitBuffer($6132fded22868769$var$base64ToBytes(string), buf, offset, length);
}
function $6132fded22868769$var$ucs2Write(buf, string, offset, length) {
    return $6132fded22868769$var$blitBuffer($6132fded22868769$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6132fded22868769$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6132fded22868769$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6132fded22868769$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6132fded22868769$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6132fded22868769$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6132fded22868769$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6132fded22868769$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6132fded22868769$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $6132fded22868769$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6132fded22868769$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6132fded22868769$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6132fded22868769$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6132fded22868769$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6132fded22868769$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6132fded22868769$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6132fded22868769$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6132fded22868769$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6132fded22868769$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6132fded22868769$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6132fded22868769$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6132fded22868769$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6132fded22868769$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6132fded22868769$var$Buffer.prototype.readUintLE = $6132fded22868769$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6132fded22868769$var$Buffer.prototype.readUintBE = $6132fded22868769$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6132fded22868769$var$Buffer.prototype.readUint8 = $6132fded22868769$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6132fded22868769$var$Buffer.prototype.readUint16LE = $6132fded22868769$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6132fded22868769$var$Buffer.prototype.readUint16BE = $6132fded22868769$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6132fded22868769$var$Buffer.prototype.readUint32LE = $6132fded22868769$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6132fded22868769$var$Buffer.prototype.readUint32BE = $6132fded22868769$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6132fded22868769$var$Buffer.prototype.readBigUInt64LE = $6132fded22868769$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6132fded22868769$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6132fded22868769$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6132fded22868769$var$Buffer.prototype.readBigUInt64BE = $6132fded22868769$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6132fded22868769$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6132fded22868769$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6132fded22868769$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6132fded22868769$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6132fded22868769$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6132fded22868769$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6132fded22868769$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6132fded22868769$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6132fded22868769$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6132fded22868769$var$Buffer.prototype.readBigInt64LE = $6132fded22868769$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6132fded22868769$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6132fded22868769$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6132fded22868769$var$Buffer.prototype.readBigInt64BE = $6132fded22868769$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6132fded22868769$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6132fded22868769$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6132fded22868769$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$6132fded22868769$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$6132fded22868769$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$6132fded22868769$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $6132fded22868769$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6132fded22868769$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6132fded22868769$var$Buffer.prototype.writeUintLE = $6132fded22868769$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6132fded22868769$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6132fded22868769$var$Buffer.prototype.writeUintBE = $6132fded22868769$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6132fded22868769$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6132fded22868769$var$Buffer.prototype.writeUint8 = $6132fded22868769$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6132fded22868769$var$Buffer.prototype.writeUint16LE = $6132fded22868769$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6132fded22868769$var$Buffer.prototype.writeUint16BE = $6132fded22868769$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6132fded22868769$var$Buffer.prototype.writeUint32LE = $6132fded22868769$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6132fded22868769$var$Buffer.prototype.writeUint32BE = $6132fded22868769$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6132fded22868769$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6132fded22868769$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6132fded22868769$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6132fded22868769$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6132fded22868769$var$Buffer.prototype.writeBigUInt64LE = $6132fded22868769$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6132fded22868769$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6132fded22868769$var$Buffer.prototype.writeBigUInt64BE = $6132fded22868769$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6132fded22868769$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6132fded22868769$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6132fded22868769$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6132fded22868769$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6132fded22868769$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6132fded22868769$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6132fded22868769$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6132fded22868769$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6132fded22868769$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6132fded22868769$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6132fded22868769$var$Buffer.prototype.writeBigInt64LE = $6132fded22868769$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6132fded22868769$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6132fded22868769$var$Buffer.prototype.writeBigInt64BE = $6132fded22868769$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6132fded22868769$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6132fded22868769$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6132fded22868769$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6132fded22868769$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6132fded22868769$var$writeFloat(this, value, offset, true, noAssert);
};
$6132fded22868769$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6132fded22868769$var$writeFloat(this, value, offset, false, noAssert);
};
function $6132fded22868769$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6132fded22868769$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6132fded22868769$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6132fded22868769$var$writeDouble(this, value, offset, true, noAssert);
};
$6132fded22868769$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6132fded22868769$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6132fded22868769$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6132fded22868769$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6132fded22868769$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6132fded22868769$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6132fded22868769$var$Buffer.isBuffer(val) ? val : $6132fded22868769$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6132fded22868769$var$errors = {};
function $6132fded22868769$var$E(sym, getMessage, Base) {
    $6132fded22868769$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6132fded22868769$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6132fded22868769$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$6132fded22868769$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6132fded22868769$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6132fded22868769$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6132fded22868769$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6132fded22868769$var$checkBounds(buf, offset, byteLength) {
    $6132fded22868769$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6132fded22868769$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6132fded22868769$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6132fded22868769$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6132fded22868769$var$checkBounds(buf, offset, byteLength);
}
function $6132fded22868769$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6132fded22868769$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6132fded22868769$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6132fded22868769$var$validateNumber(value, type);
        throw new $6132fded22868769$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6132fded22868769$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6132fded22868769$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6132fded22868769$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6132fded22868769$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6132fded22868769$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6132fded22868769$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6132fded22868769$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6132fded22868769$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6132fded22868769$var$base64ToBytes(str) {
    return $abUaD.toByteArray($6132fded22868769$var$base64clean(str));
}
function $6132fded22868769$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6132fded22868769$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6132fded22868769$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6132fded22868769$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6132fded22868769$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6132fded22868769$var$BufferBigIntNotDefined : fn;
}
function $6132fded22868769$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("a0D5I", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $74983a2e8e34e554$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $74983a2e8e34e554$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("4IP8j", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $8lo7h = parcelRequire("8lo7h");

var $ajIUO = parcelRequire("ajIUO");
var $3702ef718c222058$var$format = $ajIUO.format, $3702ef718c222058$var$inspect = $ajIUO.inspect;

var $kQgvZ = parcelRequire("kQgvZ");
var $3702ef718c222058$var$ERR_INVALID_ARG_TYPE = $kQgvZ.codes.ERR_INVALID_ARG_TYPE;

var $a0D5I = parcelRequire("a0D5I");
var $3702ef718c222058$var$kResistStopPropagation = $a0D5I.kResistStopPropagation, $3702ef718c222058$var$AggregateError = $a0D5I.AggregateError, $3702ef718c222058$var$SymbolDispose = $a0D5I.SymbolDispose;

var $3702ef718c222058$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $3702ef718c222058$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $3702ef718c222058$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $3702ef718c222058$var$Blob = globalThis.Blob || $8lo7h.Blob;
/* eslint-disable indent */ var $3702ef718c222058$var$isBlob = typeof $3702ef718c222058$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $3702ef718c222058$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $3702ef718c222058$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $3702ef718c222058$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $3702ef718c222058$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $3702ef718c222058$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $3702ef718c222058$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $3702ef718c222058$var$format,
    inspect: $3702ef718c222058$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $3702ef718c222058$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $3702ef718c222058$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $3702ef718c222058$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $3702ef718c222058$var$validateAbortSignal(signal, 'signal');
        $3702ef718c222058$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $3702ef718c222058$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $3702ef718c222058$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $3702ef718c222058$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $3702ef718c222058$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $3702ef718c222058$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("ajIUO", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("kQgvZ", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $ajIUO = parcelRequire("ajIUO");
var $f2c579829c804259$var$format = $ajIUO.format, $f2c579829c804259$var$inspect = $ajIUO.inspect;

var $a0D5I = parcelRequire("a0D5I");
var $f2c579829c804259$var$CustomAggregateError = $a0D5I.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $f2c579829c804259$var$AggregateError = globalThis.AggregateError || $f2c579829c804259$var$CustomAggregateError;
var $f2c579829c804259$var$kIsNodeError = Symbol('kIsNodeError');
var $f2c579829c804259$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $f2c579829c804259$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $f2c579829c804259$var$nodeInternalPrefix = '__node_internal_';
var $f2c579829c804259$var$codes = {};
function $f2c579829c804259$var$assert(value, message) {
    if (!value) throw new $f2c579829c804259$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $f2c579829c804259$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $f2c579829c804259$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $f2c579829c804259$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $f2c579829c804259$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $f2c579829c804259$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $f2c579829c804259$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $f2c579829c804259$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$f2c579829c804259$var$kIsNodeError] = true;
    $f2c579829c804259$var$codes[code] = NodeError;
}
function $f2c579829c804259$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $f2c579829c804259$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $f2c579829c804259$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $f2c579829c804259$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $f2c579829c804259$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $f2c579829c804259$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$f2c579829c804259$var$E('ERR_ASSERTION', '%s', Error);
$f2c579829c804259$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $f2c579829c804259$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $f2c579829c804259$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($f2c579829c804259$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($f2c579829c804259$var$classRegExp.test(value)) instances.push(value);
            else {
                $f2c579829c804259$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $f2c579829c804259$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $f2c579829c804259$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$f2c579829c804259$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $f2c579829c804259$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$f2c579829c804259$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$f2c579829c804259$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $f2c579829c804259$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$f2c579829c804259$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $f2c579829c804259$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $f2c579829c804259$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $f2c579829c804259$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $f2c579829c804259$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$f2c579829c804259$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$f2c579829c804259$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$f2c579829c804259$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$f2c579829c804259$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$f2c579829c804259$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$f2c579829c804259$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$f2c579829c804259$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$f2c579829c804259$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$f2c579829c804259$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$f2c579829c804259$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$f2c579829c804259$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $f2c579829c804259$var$AbortError,
    aggregateTwoErrors: $f2c579829c804259$var$hideStackFrames($f2c579829c804259$var$aggregateTwoErrors),
    hideStackFrames: $f2c579829c804259$var$hideStackFrames,
    codes: $f2c579829c804259$var$codes
};

});


parcelRegister("fxq6M", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $b4fe30a3d4b76150$export$42af8c323be37587; }, function (v) { return $b4fe30a3d4b76150$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $b4fe30a3d4b76150$export$f405f72c701dad87; }, function (v) { return $b4fe30a3d4b76150$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $b4fe30a3d4b76150$export$42af8c323be37587;
var $b4fe30a3d4b76150$export$f405f72c701dad87;
'use strict';

var $b4fe30a3d4b76150$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $kQgvZ = parcelRequire("kQgvZ");
var $b4fe30a3d4b76150$var$_require_codes = $kQgvZ.codes, $b4fe30a3d4b76150$var$ERR_INVALID_ARG_VALUE = $b4fe30a3d4b76150$var$_require_codes.ERR_INVALID_ARG_VALUE, $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE = $b4fe30a3d4b76150$var$_require_codes.ERR_INVALID_ARG_TYPE, $b4fe30a3d4b76150$var$ERR_MISSING_ARGS = $b4fe30a3d4b76150$var$_require_codes.ERR_MISSING_ARGS, $b4fe30a3d4b76150$var$ERR_OUT_OF_RANGE = $b4fe30a3d4b76150$var$_require_codes.ERR_OUT_OF_RANGE, $b4fe30a3d4b76150$var$AbortError = $kQgvZ.AbortError;

var $cf1oN = parcelRequire("cf1oN");
var $b4fe30a3d4b76150$var$validateAbortSignal = $cf1oN.validateAbortSignal, $b4fe30a3d4b76150$var$validateInteger = $cf1oN.validateInteger, $b4fe30a3d4b76150$var$validateObject = $cf1oN.validateObject;

var $b4fe30a3d4b76150$var$kWeakHandler = (parcelRequire("a0D5I")).Symbol('kWeak');

var $b4fe30a3d4b76150$var$kResistStopPropagation = (parcelRequire("a0D5I")).Symbol('kResistStopPropagation');

var $bIKWZ = parcelRequire("bIKWZ");
var $b4fe30a3d4b76150$require$finished = $bIKWZ.finished;

var $aI7xs = parcelRequire("aI7xs");

var $hnuyc = parcelRequire("hnuyc");
var $b4fe30a3d4b76150$require$addAbortSignalNoValidate = $hnuyc.addAbortSignalNoValidate;

var $468KT = parcelRequire("468KT");
var $b4fe30a3d4b76150$var$isWritable = $468KT.isWritable, $b4fe30a3d4b76150$var$isNodeStream = $468KT.isNodeStream;

var $b4fe30a3d4b76150$require$deprecate = (parcelRequire("4IP8j")).deprecate;

var $b4fe30a3d4b76150$var$ArrayPrototypePush = (parcelRequire("a0D5I")).ArrayPrototypePush, $b4fe30a3d4b76150$var$Boolean = (parcelRequire("a0D5I")).Boolean, $b4fe30a3d4b76150$var$MathFloor = (parcelRequire("a0D5I")).MathFloor, $b4fe30a3d4b76150$var$Number = (parcelRequire("a0D5I")).Number, $b4fe30a3d4b76150$var$NumberIsNaN = (parcelRequire("a0D5I")).NumberIsNaN, $b4fe30a3d4b76150$var$Promise = (parcelRequire("a0D5I")).Promise, $b4fe30a3d4b76150$var$PromiseReject = (parcelRequire("a0D5I")).PromiseReject, $b4fe30a3d4b76150$var$PromiseResolve = (parcelRequire("a0D5I")).PromiseResolve, $b4fe30a3d4b76150$var$PromisePrototypeThen = (parcelRequire("a0D5I")).PromisePrototypeThen, $b4fe30a3d4b76150$var$Symbol = (parcelRequire("a0D5I")).Symbol;
var $b4fe30a3d4b76150$var$kEmpty = $b4fe30a3d4b76150$var$Symbol('kEmpty');
var $b4fe30a3d4b76150$var$kEof = $b4fe30a3d4b76150$var$Symbol('kEof');
function $b4fe30a3d4b76150$var$compose(stream, options) {
    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
    if ($b4fe30a3d4b76150$var$isNodeStream(stream) && !$b4fe30a3d4b76150$var$isWritable(stream)) throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $aI7xs(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $b4fe30a3d4b76150$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $b4fe30a3d4b76150$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $b4fe30a3d4b76150$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $b4fe30a3d4b76150$var$MathFloor(options.highWaterMark);
    $b4fe30a3d4b76150$var$validateInteger(concurrency, 'options.concurrency', 1);
    $b4fe30a3d4b76150$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $b4fe30a3d4b76150$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $b4fe30a3d4b76150$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $b4fe30a3d4b76150$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $b4fe30a3d4b76150$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $b4fe30a3d4b76150$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($b4fe30a3d4b76150$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $b4fe30a3d4b76150$var$PromiseReject(err1);
                                $b4fe30a3d4b76150$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("4IP8j")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($b4fe30a3d4b76150$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $b4fe30a3d4b76150$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                        if (!(val !== $b4fe30a3d4b76150$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $b4fe30a3d4b76150$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b4fe30a3d4b76150$var$asIndexedPairs(options) {
    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $b4fe30a3d4b76150$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b4fe30a3d4b76150$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b4fe30a3d4b76150$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $b4fe30a3d4b76150$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $b4fe30a3d4b76150$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $b4fe30a3d4b76150$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b4fe30a3d4b76150$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $b4fe30a3d4b76150$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $b4fe30a3d4b76150$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($b4fe30a3d4b76150$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $b4fe30a3d4b76150$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $b4fe30a3d4b76150$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $b4fe30a3d4b76150$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $b4fe30a3d4b76150$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($b4fe30a3d4b76150$var$ERR_MISSING_ARGS);
function $b4fe30a3d4b76150$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $b4fe30a3d4b76150$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $b4fe30a3d4b76150$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $b4fe30a3d4b76150$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $b4fe30a3d4b76150$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $b4fe30a3d4b76150$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $b4fe30a3d4b76150$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $b4fe30a3d4b76150$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $b4fe30a3d4b76150$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $b4fe30a3d4b76150$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $b4fe30a3d4b76150$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $b4fe30a3d4b76150$var$flatMap(fn, options) {
    var values = $b4fe30a3d4b76150$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $b4fe30a3d4b76150$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $b4fe30a3d4b76150$var$Number(number);
    if ($b4fe30a3d4b76150$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $b4fe30a3d4b76150$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $b4fe30a3d4b76150$var$drop(number, options) {
    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
    number = $b4fe30a3d4b76150$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $b4fe30a3d4b76150$var$take(number, options) {
    if (options != null) $b4fe30a3d4b76150$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b4fe30a3d4b76150$var$validateAbortSignal(options.signal, 'options.signal');
    number = $b4fe30a3d4b76150$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $b4fe30a3d4b76150$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$b4fe30a3d4b76150$export$42af8c323be37587 = {
    asIndexedPairs: $b4fe30a3d4b76150$require$deprecate($b4fe30a3d4b76150$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $b4fe30a3d4b76150$var$drop,
    filter: $b4fe30a3d4b76150$var$filter,
    flatMap: $b4fe30a3d4b76150$var$flatMap,
    map: $b4fe30a3d4b76150$var$map,
    take: $b4fe30a3d4b76150$var$take,
    compose: $b4fe30a3d4b76150$var$compose
};
$b4fe30a3d4b76150$export$f405f72c701dad87 = {
    every: $b4fe30a3d4b76150$var$every,
    forEach: $b4fe30a3d4b76150$var$forEach,
    reduce: $b4fe30a3d4b76150$var$reduce,
    toArray: $b4fe30a3d4b76150$var$toArray,
    some: $b4fe30a3d4b76150$var$some,
    find: $b4fe30a3d4b76150$var$find
};

});
parcelRegister("cf1oN", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $8e97f8906e690193$var$ArrayIsArray = $a0D5I.ArrayIsArray, $8e97f8906e690193$var$ArrayPrototypeIncludes = $a0D5I.ArrayPrototypeIncludes, $8e97f8906e690193$var$ArrayPrototypeJoin = $a0D5I.ArrayPrototypeJoin, $8e97f8906e690193$var$ArrayPrototypeMap = $a0D5I.ArrayPrototypeMap, $8e97f8906e690193$var$NumberIsInteger = $a0D5I.NumberIsInteger, $8e97f8906e690193$var$NumberIsNaN = $a0D5I.NumberIsNaN, $8e97f8906e690193$var$NumberMAX_SAFE_INTEGER = $a0D5I.NumberMAX_SAFE_INTEGER, $8e97f8906e690193$var$NumberMIN_SAFE_INTEGER = $a0D5I.NumberMIN_SAFE_INTEGER, $8e97f8906e690193$var$NumberParseInt = $a0D5I.NumberParseInt, $8e97f8906e690193$var$ObjectPrototypeHasOwnProperty = $a0D5I.ObjectPrototypeHasOwnProperty, $8e97f8906e690193$var$RegExpPrototypeExec = $a0D5I.RegExpPrototypeExec, $8e97f8906e690193$var$String = $a0D5I.String, $8e97f8906e690193$var$StringPrototypeToUpperCase = $a0D5I.StringPrototypeToUpperCase, $8e97f8906e690193$var$StringPrototypeTrim = $a0D5I.StringPrototypeTrim;

var $kQgvZ = parcelRequire("kQgvZ");
var $8e97f8906e690193$var$hideStackFrames = $kQgvZ.hideStackFrames, $8e97f8906e690193$var$_require_codes = $kQgvZ.codes, $8e97f8906e690193$var$ERR_SOCKET_BAD_PORT = $8e97f8906e690193$var$_require_codes.ERR_SOCKET_BAD_PORT, $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE = $8e97f8906e690193$var$_require_codes.ERR_INVALID_ARG_TYPE, $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE = $8e97f8906e690193$var$_require_codes.ERR_INVALID_ARG_VALUE, $8e97f8906e690193$var$ERR_OUT_OF_RANGE = $8e97f8906e690193$var$_require_codes.ERR_OUT_OF_RANGE, $8e97f8906e690193$var$ERR_UNKNOWN_SIGNAL = $8e97f8906e690193$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $4IP8j = parcelRequire("4IP8j");
var $8e97f8906e690193$require$normalizeEncoding = $4IP8j.normalizeEncoding;

var $4IP8j = parcelRequire("4IP8j");
var $8e97f8906e690193$require$_require_types = $4IP8j.types;
var $8e97f8906e690193$var$isAsyncFunction = $8e97f8906e690193$require$_require_types.isAsyncFunction, $8e97f8906e690193$var$isArrayBufferView = $8e97f8906e690193$require$_require_types.isArrayBufferView;
var $8e97f8906e690193$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8e97f8906e690193$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8e97f8906e690193$var$isUint32(value) {
    return value === value >>> 0;
}
var $8e97f8906e690193$var$octalReg = /^[0-7]+$/;
var $8e97f8906e690193$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $8e97f8906e690193$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($8e97f8906e690193$var$RegExpPrototypeExec($8e97f8906e690193$var$octalReg, value) === null) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE(name, value, $8e97f8906e690193$var$modeDesc);
        value = $8e97f8906e690193$var$NumberParseInt(value, 8);
    }
    $8e97f8906e690193$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $8e97f8906e690193$var$validateInteger = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $8e97f8906e690193$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $8e97f8906e690193$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e97f8906e690193$var$NumberIsInteger(value)) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $8e97f8906e690193$var$validateInt32 = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e97f8906e690193$var$NumberIsInteger(value)) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $8e97f8906e690193$var$validateUint32 = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e97f8906e690193$var$NumberIsInteger(value)) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $8e97f8906e690193$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $8e97f8906e690193$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $8e97f8906e690193$var$NumberIsNaN(value)) throw new $8e97f8906e690193$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $8e97f8906e690193$var$validateOneOf = $8e97f8906e690193$var$hideStackFrames(function(value, name, oneOf) {
    if (!$8e97f8906e690193$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $8e97f8906e690193$var$ArrayPrototypeJoin($8e97f8906e690193$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $8e97f8906e690193$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $8e97f8906e690193$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $8e97f8906e690193$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$8e97f8906e690193$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $8e97f8906e690193$var$validateObject = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $8e97f8906e690193$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $8e97f8906e690193$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $8e97f8906e690193$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $8e97f8906e690193$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $8e97f8906e690193$var$validateDictionary = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $8e97f8906e690193$var$validateArray = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$8e97f8906e690193$var$ArrayIsArray(value)) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $8e97f8906e690193$var$validateStringArray(value, name) {
    $8e97f8906e690193$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$8e97f8906e690193$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $8e97f8906e690193$var$validateBooleanArray(value, name) {
    $8e97f8906e690193$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$8e97f8906e690193$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $8e97f8906e690193$var$validateAbortSignalArray(value, name) {
    $8e97f8906e690193$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $8e97f8906e690193$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $8e97f8906e690193$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $8e97f8906e690193$var$validateString(signal, name);
    if ($8e97f8906e690193$var$signals[signal] === undefined) {
        if ($8e97f8906e690193$var$signals[$8e97f8906e690193$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $8e97f8906e690193$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $8e97f8906e690193$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $8e97f8906e690193$var$validateBuffer = $8e97f8906e690193$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$8e97f8906e690193$var$isArrayBufferView(buffer)) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $8e97f8906e690193$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $8e97f8906e690193$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $8e97f8906e690193$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $8e97f8906e690193$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $8e97f8906e690193$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $8e97f8906e690193$var$validateAbortSignal = $8e97f8906e690193$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $8e97f8906e690193$var$validateFunction = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $8e97f8906e690193$var$validatePlainFunction = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $8e97f8906e690193$var$isAsyncFunction(value)) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $8e97f8906e690193$var$validateUndefined = $8e97f8906e690193$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $8e97f8906e690193$var$validateUnion(value, name, union) {
    if (!$8e97f8906e690193$var$ArrayPrototypeIncludes(union, value)) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_TYPE(name, "('".concat($8e97f8906e690193$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $8e97f8906e690193$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $8e97f8906e690193$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$8e97f8906e690193$var$RegExpPrototypeExec($8e97f8906e690193$var$linkValueRegExp, value)) throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $8e97f8906e690193$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $8e97f8906e690193$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($8e97f8906e690193$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $8e97f8906e690193$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $8e97f8906e690193$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $8e97f8906e690193$var$isInt32,
    isUint32: $8e97f8906e690193$var$isUint32,
    parseFileMode: $8e97f8906e690193$var$parseFileMode,
    validateArray: $8e97f8906e690193$var$validateArray,
    validateStringArray: $8e97f8906e690193$var$validateStringArray,
    validateBooleanArray: $8e97f8906e690193$var$validateBooleanArray,
    validateAbortSignalArray: $8e97f8906e690193$var$validateAbortSignalArray,
    validateBoolean: $8e97f8906e690193$var$validateBoolean,
    validateBuffer: $8e97f8906e690193$var$validateBuffer,
    validateDictionary: $8e97f8906e690193$var$validateDictionary,
    validateEncoding: $8e97f8906e690193$var$validateEncoding,
    validateFunction: $8e97f8906e690193$var$validateFunction,
    validateInt32: $8e97f8906e690193$var$validateInt32,
    validateInteger: $8e97f8906e690193$var$validateInteger,
    validateNumber: $8e97f8906e690193$var$validateNumber,
    validateObject: $8e97f8906e690193$var$validateObject,
    validateOneOf: $8e97f8906e690193$var$validateOneOf,
    validatePlainFunction: $8e97f8906e690193$var$validatePlainFunction,
    validatePort: $8e97f8906e690193$var$validatePort,
    validateSignalName: $8e97f8906e690193$var$validateSignalName,
    validateString: $8e97f8906e690193$var$validateString,
    validateUint32: $8e97f8906e690193$var$validateUint32,
    validateUndefined: $8e97f8906e690193$var$validateUndefined,
    validateUnion: $8e97f8906e690193$var$validateUnion,
    validateAbortSignal: $8e97f8906e690193$var$validateAbortSignal,
    validateLinkHeaderValue: $8e97f8906e690193$var$validateLinkHeaderValue
};

});

parcelRegister("bIKWZ", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kQgvZ = parcelRequire("kQgvZ");
/* replacement end */ var $88883925b331637d$var$AbortError = $kQgvZ.AbortError, $88883925b331637d$var$codes = $kQgvZ.codes;
var $88883925b331637d$var$ERR_INVALID_ARG_TYPE = $88883925b331637d$var$codes.ERR_INVALID_ARG_TYPE, $88883925b331637d$var$ERR_STREAM_PREMATURE_CLOSE = $88883925b331637d$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $88883925b331637d$var$kEmptyObject = (parcelRequire("4IP8j")).kEmptyObject, $88883925b331637d$var$once = (parcelRequire("4IP8j")).once;

var $cf1oN = parcelRequire("cf1oN");
var $88883925b331637d$var$validateAbortSignal = $cf1oN.validateAbortSignal, $88883925b331637d$var$validateFunction = $cf1oN.validateFunction, $88883925b331637d$var$validateObject = $cf1oN.validateObject, $88883925b331637d$var$validateBoolean = $cf1oN.validateBoolean;

var $a0D5I = parcelRequire("a0D5I");
var $88883925b331637d$var$Promise = $a0D5I.Promise, $88883925b331637d$var$PromisePrototypeThen = $a0D5I.PromisePrototypeThen, $88883925b331637d$var$SymbolDispose = $a0D5I.SymbolDispose;

var $468KT = parcelRequire("468KT");
var $88883925b331637d$var$isClosed = $468KT.isClosed, $88883925b331637d$var$isReadable = $468KT.isReadable, $88883925b331637d$var$isReadableNodeStream = $468KT.isReadableNodeStream, $88883925b331637d$var$isReadableStream = $468KT.isReadableStream, $88883925b331637d$var$isReadableFinished = $468KT.isReadableFinished, $88883925b331637d$var$isReadableErrored = $468KT.isReadableErrored, $88883925b331637d$var$isWritable = $468KT.isWritable, $88883925b331637d$var$isWritableNodeStream = $468KT.isWritableNodeStream, $88883925b331637d$var$isWritableStream = $468KT.isWritableStream, $88883925b331637d$var$isWritableFinished = $468KT.isWritableFinished, $88883925b331637d$var$isWritableErrored = $468KT.isWritableErrored, $88883925b331637d$var$isNodeStream = $468KT.isNodeStream, $88883925b331637d$var$_willEmitClose = $468KT.willEmitClose, $88883925b331637d$var$kIsClosedPromise = $468KT.kIsClosedPromise;
var $88883925b331637d$var$addAbortListener;
function $88883925b331637d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $88883925b331637d$var$nop = function() {};

function $88883925b331637d$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $88883925b331637d$var$kEmptyObject;
    } else if (options == null) options = $88883925b331637d$var$kEmptyObject;
    else $88883925b331637d$var$validateObject(options, 'options');
    $88883925b331637d$var$validateFunction(callback, 'callback');
    $88883925b331637d$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $88883925b331637d$var$once(callback);
    if ($88883925b331637d$var$isReadableStream(stream) || $88883925b331637d$var$isWritableStream(stream)) return $88883925b331637d$var$eosWeb(stream, options, callback);
    if (!$88883925b331637d$var$isNodeStream(stream)) throw new $88883925b331637d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $88883925b331637d$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $88883925b331637d$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $88883925b331637d$var$_willEmitClose(stream) && $88883925b331637d$var$isReadableNodeStream(stream) === readable && $88883925b331637d$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $88883925b331637d$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $88883925b331637d$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $88883925b331637d$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $88883925b331637d$var$isWritableErrored(stream) || $88883925b331637d$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $88883925b331637d$var$isReadableNodeStream(stream, true)) {
            if (!$88883925b331637d$var$isReadableFinished(stream, false)) return callback.call(stream, new $88883925b331637d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$88883925b331637d$var$isWritableFinished(stream, false)) return callback.call(stream, new $88883925b331637d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $88883925b331637d$var$isWritableErrored(stream) || $88883925b331637d$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($88883925b331637d$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $88883925b331637d$var$isReadable(stream)) && (writableFinished || $88883925b331637d$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $88883925b331637d$var$isWritable(stream)) && (readableFinished || $88883925b331637d$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $88883925b331637d$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $88883925b331637d$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $88883925b331637d$var$addAbortListener = $88883925b331637d$var$addAbortListener || (parcelRequire("4IP8j")).addAbortListener;
            var disposable = $88883925b331637d$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $88883925b331637d$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$88883925b331637d$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $88883925b331637d$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $88883925b331637d$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $88883925b331637d$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $88883925b331637d$var$addAbortListener = $88883925b331637d$var$addAbortListener || (parcelRequire("4IP8j")).addAbortListener;
            var disposable = $88883925b331637d$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $88883925b331637d$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$88883925b331637d$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $88883925b331637d$var$PromisePrototypeThen(stream[$88883925b331637d$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $88883925b331637d$var$nop;
}
function $88883925b331637d$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $88883925b331637d$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $88883925b331637d$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $88883925b331637d$var$Promise(function(resolve, reject) {
        var cleanup = $88883925b331637d$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $88883925b331637d$var$eos;
module.exports.finished = $88883925b331637d$var$finished;

});
parcelRegister("468KT", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $2fbe8399637d1bad$var$SymbolAsyncIterator = $a0D5I.SymbolAsyncIterator, $2fbe8399637d1bad$var$SymbolIterator = $a0D5I.SymbolIterator, $2fbe8399637d1bad$var$SymbolFor = $a0D5I.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $2fbe8399637d1bad$var$kIsDestroyed = $2fbe8399637d1bad$var$SymbolFor('nodejs.stream.destroyed');
var $2fbe8399637d1bad$var$kIsErrored = $2fbe8399637d1bad$var$SymbolFor('nodejs.stream.errored');
var $2fbe8399637d1bad$var$kIsReadable = $2fbe8399637d1bad$var$SymbolFor('nodejs.stream.readable');
var $2fbe8399637d1bad$var$kIsWritable = $2fbe8399637d1bad$var$SymbolFor('nodejs.stream.writable');
var $2fbe8399637d1bad$var$kIsDisturbed = $2fbe8399637d1bad$var$SymbolFor('nodejs.stream.disturbed');
var $2fbe8399637d1bad$var$kIsClosedPromise = $2fbe8399637d1bad$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $2fbe8399637d1bad$var$kControllerErrorFunction = $2fbe8399637d1bad$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $2fbe8399637d1bad$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $2fbe8399637d1bad$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $2fbe8399637d1bad$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $2fbe8399637d1bad$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $2fbe8399637d1bad$var$isReadableStream(obj) {
    return !!(obj && !$2fbe8399637d1bad$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $2fbe8399637d1bad$var$isWritableStream(obj) {
    return !!(obj && !$2fbe8399637d1bad$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $2fbe8399637d1bad$var$isTransformStream(obj) {
    return !!(obj && !$2fbe8399637d1bad$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $2fbe8399637d1bad$var$isWebStream(obj) {
    return $2fbe8399637d1bad$var$isReadableStream(obj) || $2fbe8399637d1bad$var$isWritableStream(obj) || $2fbe8399637d1bad$var$isTransformStream(obj);
}
function $2fbe8399637d1bad$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$2fbe8399637d1bad$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$2fbe8399637d1bad$var$SymbolIterator] === 'function';
    return typeof obj[$2fbe8399637d1bad$var$SymbolAsyncIterator] === 'function' || typeof obj[$2fbe8399637d1bad$var$SymbolIterator] === 'function';
}
function $2fbe8399637d1bad$var$isDestroyed(stream) {
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$2fbe8399637d1bad$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $2fbe8399637d1bad$var$isWritableEnded(stream) {
    if (!$2fbe8399637d1bad$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $2fbe8399637d1bad$var$isWritableFinished(stream, strict) {
    if (!$2fbe8399637d1bad$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $2fbe8399637d1bad$var$isReadableEnded(stream) {
    if (!$2fbe8399637d1bad$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $2fbe8399637d1bad$var$isReadableFinished(stream, strict) {
    if (!$2fbe8399637d1bad$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $2fbe8399637d1bad$var$isReadable(stream) {
    if (stream && stream[$2fbe8399637d1bad$var$kIsReadable] != null) return stream[$2fbe8399637d1bad$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($2fbe8399637d1bad$var$isDestroyed(stream)) return false;
    return $2fbe8399637d1bad$var$isReadableNodeStream(stream) && stream.readable && !$2fbe8399637d1bad$var$isReadableFinished(stream);
}
function $2fbe8399637d1bad$var$isWritable(stream) {
    if (stream && stream[$2fbe8399637d1bad$var$kIsWritable] != null) return stream[$2fbe8399637d1bad$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($2fbe8399637d1bad$var$isDestroyed(stream)) return false;
    return $2fbe8399637d1bad$var$isWritableNodeStream(stream) && stream.writable && !$2fbe8399637d1bad$var$isWritableEnded(stream);
}
function $2fbe8399637d1bad$var$isFinished(stream, opts) {
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    if ($2fbe8399637d1bad$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $2fbe8399637d1bad$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $2fbe8399637d1bad$var$isWritable(stream)) return false;
    return true;
}
function $2fbe8399637d1bad$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $2fbe8399637d1bad$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $2fbe8399637d1bad$var$isClosed(stream) {
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $2fbe8399637d1bad$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $2fbe8399637d1bad$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $2fbe8399637d1bad$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $2fbe8399637d1bad$var$isOutgoingMessage(stream);
}
function $2fbe8399637d1bad$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $2fbe8399637d1bad$var$willEmitClose(stream) {
    if (!$2fbe8399637d1bad$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $2fbe8399637d1bad$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $2fbe8399637d1bad$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$2fbe8399637d1bad$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $2fbe8399637d1bad$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$2fbe8399637d1bad$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $2fbe8399637d1bad$var$isDestroyed,
    kIsDestroyed: $2fbe8399637d1bad$var$kIsDestroyed,
    isDisturbed: $2fbe8399637d1bad$var$isDisturbed,
    kIsDisturbed: $2fbe8399637d1bad$var$kIsDisturbed,
    isErrored: $2fbe8399637d1bad$var$isErrored,
    kIsErrored: $2fbe8399637d1bad$var$kIsErrored,
    isReadable: $2fbe8399637d1bad$var$isReadable,
    kIsReadable: $2fbe8399637d1bad$var$kIsReadable,
    kIsClosedPromise: $2fbe8399637d1bad$var$kIsClosedPromise,
    kControllerErrorFunction: $2fbe8399637d1bad$var$kControllerErrorFunction,
    kIsWritable: $2fbe8399637d1bad$var$kIsWritable,
    isClosed: $2fbe8399637d1bad$var$isClosed,
    isDuplexNodeStream: $2fbe8399637d1bad$var$isDuplexNodeStream,
    isFinished: $2fbe8399637d1bad$var$isFinished,
    isIterable: $2fbe8399637d1bad$var$isIterable,
    isReadableNodeStream: $2fbe8399637d1bad$var$isReadableNodeStream,
    isReadableStream: $2fbe8399637d1bad$var$isReadableStream,
    isReadableEnded: $2fbe8399637d1bad$var$isReadableEnded,
    isReadableFinished: $2fbe8399637d1bad$var$isReadableFinished,
    isReadableErrored: $2fbe8399637d1bad$var$isReadableErrored,
    isNodeStream: $2fbe8399637d1bad$var$isNodeStream,
    isWebStream: $2fbe8399637d1bad$var$isWebStream,
    isWritable: $2fbe8399637d1bad$var$isWritable,
    isWritableNodeStream: $2fbe8399637d1bad$var$isWritableNodeStream,
    isWritableStream: $2fbe8399637d1bad$var$isWritableStream,
    isWritableEnded: $2fbe8399637d1bad$var$isWritableEnded,
    isWritableFinished: $2fbe8399637d1bad$var$isWritableFinished,
    isWritableErrored: $2fbe8399637d1bad$var$isWritableErrored,
    isServerRequest: $2fbe8399637d1bad$var$isServerRequest,
    isServerResponse: $2fbe8399637d1bad$var$isServerResponse,
    willEmitClose: $2fbe8399637d1bad$var$willEmitClose,
    isTransformStream: $2fbe8399637d1bad$var$isTransformStream
};

});


parcelRegister("aI7xs", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $6WtEZ = parcelRequire("6WtEZ");
var $7cc3dc7630c4f846$require$pipeline = $6WtEZ.pipeline;

var $lws7Y = parcelRequire("lws7Y");

var $32GkH = parcelRequire("32GkH");
var $7cc3dc7630c4f846$require$destroyer = $32GkH.destroyer;

var $468KT = parcelRequire("468KT");
var $7cc3dc7630c4f846$var$isNodeStream = $468KT.isNodeStream, $7cc3dc7630c4f846$var$isReadable = $468KT.isReadable, $7cc3dc7630c4f846$var$isWritable = $468KT.isWritable, $7cc3dc7630c4f846$var$isWebStream = $468KT.isWebStream, $7cc3dc7630c4f846$var$isTransformStream = $468KT.isTransformStream, $7cc3dc7630c4f846$var$isWritableStream = $468KT.isWritableStream, $7cc3dc7630c4f846$var$isReadableStream = $468KT.isReadableStream;

var $kQgvZ = parcelRequire("kQgvZ");
var $7cc3dc7630c4f846$var$AbortError = $kQgvZ.AbortError, $7cc3dc7630c4f846$var$_require_codes = $kQgvZ.codes, $7cc3dc7630c4f846$var$ERR_INVALID_ARG_VALUE = $7cc3dc7630c4f846$var$_require_codes.ERR_INVALID_ARG_VALUE, $7cc3dc7630c4f846$var$ERR_MISSING_ARGS = $7cc3dc7630c4f846$var$_require_codes.ERR_MISSING_ARGS;

var $bIKWZ = parcelRequire("bIKWZ");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $7cc3dc7630c4f846$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $lws7Y.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $lws7Y.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $lws7Y.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$7cc3dc7630c4f846$var$isNodeStream(streams[n]) && !$7cc3dc7630c4f846$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($7cc3dc7630c4f846$var$isReadable(streams[n]) || $7cc3dc7630c4f846$var$isReadableStream(streams[n]) || $7cc3dc7630c4f846$var$isTransformStream(streams[n]))) throw new $7cc3dc7630c4f846$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($7cc3dc7630c4f846$var$isWritable(streams[n]) || $7cc3dc7630c4f846$var$isWritableStream(streams[n]) || $7cc3dc7630c4f846$var$isTransformStream(streams[n]))) throw new $7cc3dc7630c4f846$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $7cc3dc7630c4f846$require$pipeline(streams, onfinished);
    var writable = !!($7cc3dc7630c4f846$var$isWritable(head) || $7cc3dc7630c4f846$var$isWritableStream(head) || $7cc3dc7630c4f846$var$isTransformStream(head));
    var readable = !!($7cc3dc7630c4f846$var$isReadable(tail) || $7cc3dc7630c4f846$var$isReadableStream(tail) || $7cc3dc7630c4f846$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $lws7Y({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($7cc3dc7630c4f846$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($7cc3dc7630c4f846$var$isWebStream(head)) {
            var writable1 = $7cc3dc7630c4f846$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $7cc3dc7630c4f846$var$isTransformStream(tail) ? tail.readable : tail;
        $bIKWZ(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($7cc3dc7630c4f846$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($7cc3dc7630c4f846$var$isWebStream(tail)) {
            var readable1 = $7cc3dc7630c4f846$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $7cc3dc7630c4f846$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($7cc3dc7630c4f846$var$isNodeStream(tail)) $7cc3dc7630c4f846$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("6WtEZ", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $50df2ac0ccbe5cf3$var$ArrayIsArray = $a0D5I.ArrayIsArray, $50df2ac0ccbe5cf3$var$Promise = $a0D5I.Promise, $50df2ac0ccbe5cf3$var$SymbolAsyncIterator = $a0D5I.SymbolAsyncIterator, $50df2ac0ccbe5cf3$var$SymbolDispose = $a0D5I.SymbolDispose;

var $bIKWZ = parcelRequire("bIKWZ");

var $50df2ac0ccbe5cf3$require$once = (parcelRequire("4IP8j")).once;

var $32GkH = parcelRequire("32GkH");

var $lws7Y = parcelRequire("lws7Y");

var $kQgvZ = parcelRequire("kQgvZ");
var $50df2ac0ccbe5cf3$var$aggregateTwoErrors = $kQgvZ.aggregateTwoErrors, $50df2ac0ccbe5cf3$var$_require_codes = $kQgvZ.codes, $50df2ac0ccbe5cf3$var$ERR_INVALID_ARG_TYPE = $50df2ac0ccbe5cf3$var$_require_codes.ERR_INVALID_ARG_TYPE, $50df2ac0ccbe5cf3$var$ERR_INVALID_RETURN_VALUE = $50df2ac0ccbe5cf3$var$_require_codes.ERR_INVALID_RETURN_VALUE, $50df2ac0ccbe5cf3$var$ERR_MISSING_ARGS = $50df2ac0ccbe5cf3$var$_require_codes.ERR_MISSING_ARGS, $50df2ac0ccbe5cf3$var$ERR_STREAM_DESTROYED = $50df2ac0ccbe5cf3$var$_require_codes.ERR_STREAM_DESTROYED, $50df2ac0ccbe5cf3$var$ERR_STREAM_PREMATURE_CLOSE = $50df2ac0ccbe5cf3$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $50df2ac0ccbe5cf3$var$AbortError = $kQgvZ.AbortError;

var $cf1oN = parcelRequire("cf1oN");
var $50df2ac0ccbe5cf3$var$validateFunction = $cf1oN.validateFunction, $50df2ac0ccbe5cf3$var$validateAbortSignal = $cf1oN.validateAbortSignal;

var $468KT = parcelRequire("468KT");
var $50df2ac0ccbe5cf3$var$isIterable = $468KT.isIterable, $50df2ac0ccbe5cf3$var$isReadable = $468KT.isReadable, $50df2ac0ccbe5cf3$var$isReadableNodeStream = $468KT.isReadableNodeStream, $50df2ac0ccbe5cf3$var$isNodeStream = $468KT.isNodeStream, $50df2ac0ccbe5cf3$var$isTransformStream = $468KT.isTransformStream, $50df2ac0ccbe5cf3$var$isWebStream = $468KT.isWebStream, $50df2ac0ccbe5cf3$var$isReadableStream = $468KT.isReadableStream, $50df2ac0ccbe5cf3$var$isReadableFinished = $468KT.isReadableFinished;

var $50df2ac0ccbe5cf3$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $50df2ac0ccbe5cf3$var$PassThrough;
var $50df2ac0ccbe5cf3$var$Readable;
var $50df2ac0ccbe5cf3$var$addAbortListener;
function $50df2ac0ccbe5cf3$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $bIKWZ(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $32GkH.destroyer(stream, err || new $50df2ac0ccbe5cf3$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $50df2ac0ccbe5cf3$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $50df2ac0ccbe5cf3$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $50df2ac0ccbe5cf3$var$makeAsyncIterable(val) {
    if ($50df2ac0ccbe5cf3$var$isIterable(val)) return val;
    else if ($50df2ac0ccbe5cf3$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $50df2ac0ccbe5cf3$var$fromReadable(val);
    throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $50df2ac0ccbe5cf3$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$50df2ac0ccbe5cf3$var$Readable) $50df2ac0ccbe5cf3$var$Readable = (parcelRequire("1yLBO"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($50df2ac0ccbe5cf3$var$Readable.prototype[$50df2ac0ccbe5cf3$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $50df2ac0ccbe5cf3$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $50df2ac0ccbe5cf3$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $bIKWZ(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $50df2ac0ccbe5cf3$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $50df2ac0ccbe5cf3$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($50df2ac0ccbe5cf3$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $50df2ac0ccbe5cf3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $50df2ac0ccbe5cf3$var$pipelineImpl(streams, $50df2ac0ccbe5cf3$require$once($50df2ac0ccbe5cf3$var$popCallback(streams)));
}


function $50df2ac0ccbe5cf3$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($50df2ac0ccbe5cf3$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $50df2ac0ccbe5cf3$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($50df2ac0ccbe5cf3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($50df2ac0ccbe5cf3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$50df2ac0ccbe5cf3$var$isIterable(ret)) throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($50df2ac0ccbe5cf3$var$isIterable(stream) || $50df2ac0ccbe5cf3$var$isReadableNodeStream(stream) || $50df2ac0ccbe5cf3$var$isTransformStream(stream)) ret = stream;
            else ret = $lws7Y.from(stream);
        } else if (typeof stream === 'function') {
            if ($50df2ac0ccbe5cf3$var$isTransformStream(ret)) {
                var _ret;
                ret = $50df2ac0ccbe5cf3$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $50df2ac0ccbe5cf3$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$50df2ac0ccbe5cf3$var$isIterable(ret, true)) throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$50df2ac0ccbe5cf3$var$PassThrough) $50df2ac0ccbe5cf3$var$PassThrough = (parcelRequire("jrjUz"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $50df2ac0ccbe5cf3$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($50df2ac0ccbe5cf3$var$isIterable(ret, true)) {
                    finishCount++;
                    $50df2ac0ccbe5cf3$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($50df2ac0ccbe5cf3$var$isReadableStream(ret) || $50df2ac0ccbe5cf3$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $50df2ac0ccbe5cf3$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $50df2ac0ccbe5cf3$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($50df2ac0ccbe5cf3$var$isNodeStream(stream)) {
            if ($50df2ac0ccbe5cf3$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $50df2ac0ccbe5cf3$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($50df2ac0ccbe5cf3$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($50df2ac0ccbe5cf3$var$isTransformStream(ret) || $50df2ac0ccbe5cf3$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $50df2ac0ccbe5cf3$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($50df2ac0ccbe5cf3$var$isIterable(ret)) {
                finishCount++;
                $50df2ac0ccbe5cf3$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($50df2ac0ccbe5cf3$var$isWebStream(stream)) {
            if ($50df2ac0ccbe5cf3$var$isReadableNodeStream(ret)) {
                finishCount++;
                $50df2ac0ccbe5cf3$var$pumpToWeb($50df2ac0ccbe5cf3$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($50df2ac0ccbe5cf3$var$isReadableStream(ret) || $50df2ac0ccbe5cf3$var$isIterable(ret)) {
                finishCount++;
                $50df2ac0ccbe5cf3$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($50df2ac0ccbe5cf3$var$isTransformStream(ret)) {
                finishCount++;
                $50df2ac0ccbe5cf3$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $50df2ac0ccbe5cf3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $lws7Y.from(stream);
    };
    if (streams.length === 1 && $50df2ac0ccbe5cf3$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $50df2ac0ccbe5cf3$var$ERR_MISSING_ARGS('streams');
    var ac = new $50df2ac0ccbe5cf3$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $50df2ac0ccbe5cf3$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $50df2ac0ccbe5cf3$var$AbortError());
    }
    $50df2ac0ccbe5cf3$var$addAbortListener = $50df2ac0ccbe5cf3$var$addAbortListener || (parcelRequire("4IP8j")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $50df2ac0ccbe5cf3$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$50df2ac0ccbe5cf3$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $50df2ac0ccbe5cf3$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $50df2ac0ccbe5cf3$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($50df2ac0ccbe5cf3$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $bIKWZ(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $bIKWZ(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $50df2ac0ccbe5cf3$var$pipelineImpl,
    pipeline: $50df2ac0ccbe5cf3$var$pipeline
};

});
parcelRegister("32GkH", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $kQgvZ = parcelRequire("kQgvZ");
/* replacement end */ var $2372656a1e43c9a9$var$aggregateTwoErrors = $kQgvZ.aggregateTwoErrors, $2372656a1e43c9a9$var$ERR_MULTIPLE_CALLBACK = $kQgvZ.codes.ERR_MULTIPLE_CALLBACK, $2372656a1e43c9a9$var$AbortError = $kQgvZ.AbortError;

var $a0D5I = parcelRequire("a0D5I");
var $2372656a1e43c9a9$require$Symbol = $a0D5I.Symbol;

var $468KT = parcelRequire("468KT");
var $2372656a1e43c9a9$var$kIsDestroyed = $468KT.kIsDestroyed, $2372656a1e43c9a9$var$isDestroyed = $468KT.isDestroyed, $2372656a1e43c9a9$var$isFinished = $468KT.isFinished, $2372656a1e43c9a9$var$isServerRequest = $468KT.isServerRequest;
var $2372656a1e43c9a9$var$kDestroy = $2372656a1e43c9a9$require$Symbol('kDestroy');
var $2372656a1e43c9a9$var$kConstruct = $2372656a1e43c9a9$require$Symbol('kConstruct');
function $2372656a1e43c9a9$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $2372656a1e43c9a9$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $2372656a1e43c9a9$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($2372656a1e43c9a9$var$kDestroy, function(er) {
        $2372656a1e43c9a9$var$_destroy(this, $2372656a1e43c9a9$var$aggregateTwoErrors(er, err), cb);
    });
    else $2372656a1e43c9a9$var$_destroy(this, err, cb);
    return this;
}
function $2372656a1e43c9a9$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $2372656a1e43c9a9$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($2372656a1e43c9a9$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($2372656a1e43c9a9$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $2372656a1e43c9a9$var$emitErrorCloseNT(self, err) {
    $2372656a1e43c9a9$var$emitErrorNT(self, err);
    $2372656a1e43c9a9$var$emitCloseNT(self);
}
function $2372656a1e43c9a9$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $2372656a1e43c9a9$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $2372656a1e43c9a9$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $2372656a1e43c9a9$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($2372656a1e43c9a9$var$emitErrorNT, stream, err);
        else $2372656a1e43c9a9$var$emitErrorNT(stream, err);
    }
}
function $2372656a1e43c9a9$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($2372656a1e43c9a9$var$kConstruct, cb);
    if (stream.listenerCount($2372656a1e43c9a9$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($2372656a1e43c9a9$var$constructNT, stream);
}
function $2372656a1e43c9a9$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $2372656a1e43c9a9$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $2372656a1e43c9a9$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($2372656a1e43c9a9$var$kDestroy, err);
        else if (err) $2372656a1e43c9a9$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($2372656a1e43c9a9$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $2372656a1e43c9a9$var$emitConstructNT(stream) {
    stream.emit($2372656a1e43c9a9$var$kConstruct);
}
function $2372656a1e43c9a9$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $2372656a1e43c9a9$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $2372656a1e43c9a9$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($2372656a1e43c9a9$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $2372656a1e43c9a9$var$destroyer(stream, err) {
    if (!stream || $2372656a1e43c9a9$var$isDestroyed(stream)) return;
    if (!err && !$2372656a1e43c9a9$var$isFinished(stream)) err = new $2372656a1e43c9a9$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($2372656a1e43c9a9$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($2372656a1e43c9a9$var$isRequest(stream)) stream.abort();
    else if ($2372656a1e43c9a9$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($2372656a1e43c9a9$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($2372656a1e43c9a9$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$2372656a1e43c9a9$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $2372656a1e43c9a9$var$construct,
    destroyer: $2372656a1e43c9a9$var$destroyer,
    destroy: $2372656a1e43c9a9$var$destroy,
    undestroy: $2372656a1e43c9a9$var$undestroy,
    errorOrDestroy: $2372656a1e43c9a9$var$errorOrDestroy
};

});

parcelRegister("lws7Y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $fab267b14e2ce3c1$var$ObjectDefineProperties = $a0D5I.ObjectDefineProperties, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor = $a0D5I.ObjectGetOwnPropertyDescriptor, $fab267b14e2ce3c1$var$ObjectKeys = $a0D5I.ObjectKeys, $fab267b14e2ce3c1$var$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf;
module.exports = $fab267b14e2ce3c1$var$Duplex;

var $1yLBO = parcelRequire("1yLBO");

var $jBLP2 = parcelRequire("jBLP2");
$fab267b14e2ce3c1$var$ObjectSetPrototypeOf($fab267b14e2ce3c1$var$Duplex.prototype, $1yLBO.prototype);
$fab267b14e2ce3c1$var$ObjectSetPrototypeOf($fab267b14e2ce3c1$var$Duplex, $1yLBO);
{
    var $fab267b14e2ce3c1$var$keys = $fab267b14e2ce3c1$var$ObjectKeys($jBLP2.prototype);
    // Allow the keys array to be GC'ed.
    for(var $fab267b14e2ce3c1$var$i = 0; $fab267b14e2ce3c1$var$i < $fab267b14e2ce3c1$var$keys.length; $fab267b14e2ce3c1$var$i++){
        var $fab267b14e2ce3c1$var$method = $fab267b14e2ce3c1$var$keys[$fab267b14e2ce3c1$var$i];
        if (!$fab267b14e2ce3c1$var$Duplex.prototype[$fab267b14e2ce3c1$var$method]) $fab267b14e2ce3c1$var$Duplex.prototype[$fab267b14e2ce3c1$var$method] = $jBLP2.prototype[$fab267b14e2ce3c1$var$method];
    }
}function $fab267b14e2ce3c1$var$Duplex(options) {
    if (!(this instanceof $fab267b14e2ce3c1$var$Duplex)) return new $fab267b14e2ce3c1$var$Duplex(options);
    $1yLBO.call(this, options);
    $jBLP2.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$fab267b14e2ce3c1$var$ObjectDefineProperties($fab267b14e2ce3c1$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $fab267b14e2ce3c1$var$ObjectGetOwnPropertyDescriptor($jBLP2.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $fab267b14e2ce3c1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $fab267b14e2ce3c1$var$lazyWebStreams() {
    if ($fab267b14e2ce3c1$var$webStreamsAdapters === undefined) $fab267b14e2ce3c1$var$webStreamsAdapters = {};
    return $fab267b14e2ce3c1$var$webStreamsAdapters;
}
$fab267b14e2ce3c1$var$Duplex.fromWeb = function(pair, options) {
    return $fab267b14e2ce3c1$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$fab267b14e2ce3c1$var$Duplex.toWeb = function(duplex) {
    return $fab267b14e2ce3c1$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $fab267b14e2ce3c1$var$duplexify;

$fab267b14e2ce3c1$var$Duplex.from = function(body) {
    if (!$fab267b14e2ce3c1$var$duplexify) $fab267b14e2ce3c1$var$duplexify = (parcelRequire("blC1I"));
    return $fab267b14e2ce3c1$var$duplexify(body, 'body');
};

});
parcelRegister("1yLBO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a0D5I = parcelRequire("a0D5I");
/* replacement end */ var $122de591840aaf04$var$ArrayPrototypeIndexOf = $a0D5I.ArrayPrototypeIndexOf, $122de591840aaf04$var$NumberIsInteger = $a0D5I.NumberIsInteger, $122de591840aaf04$var$NumberIsNaN = $a0D5I.NumberIsNaN, $122de591840aaf04$var$NumberParseInt = $a0D5I.NumberParseInt, $122de591840aaf04$var$ObjectDefineProperties = $a0D5I.ObjectDefineProperties, $122de591840aaf04$var$ObjectKeys = $a0D5I.ObjectKeys, $122de591840aaf04$var$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf, $122de591840aaf04$var$Promise = $a0D5I.Promise, $122de591840aaf04$var$SafeSet = $a0D5I.SafeSet, $122de591840aaf04$var$SymbolAsyncDispose = $a0D5I.SymbolAsyncDispose, $122de591840aaf04$var$SymbolAsyncIterator = $a0D5I.SymbolAsyncIterator, $122de591840aaf04$var$Symbol = $a0D5I.Symbol;
module.exports = $122de591840aaf04$var$Readable;
$122de591840aaf04$var$Readable.ReadableState = $122de591840aaf04$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $122de591840aaf04$var$EE = $bBoAO.EventEmitter;

var $7tuPk = parcelRequire("7tuPk");
var $122de591840aaf04$var$Stream = $7tuPk.Stream, $122de591840aaf04$var$prependListener = $7tuPk.prependListener;

var $8lo7h = parcelRequire("8lo7h");
var $122de591840aaf04$require$Buffer = $8lo7h.Buffer;

var $hnuyc = parcelRequire("hnuyc");
var $122de591840aaf04$require$addAbortSignal = $hnuyc.addAbortSignal;

var $bIKWZ = parcelRequire("bIKWZ");

var $122de591840aaf04$var$debug = (parcelRequire("4IP8j")).debuglog('stream', function(fn) {
    $122de591840aaf04$var$debug = fn;
});

var $bxNkX = parcelRequire("bxNkX");

var $32GkH = parcelRequire("32GkH");

var $eCV4g = parcelRequire("eCV4g");
var $122de591840aaf04$var$getHighWaterMark = $eCV4g.getHighWaterMark, $122de591840aaf04$var$getDefaultHighWaterMark = $eCV4g.getDefaultHighWaterMark;

var $kQgvZ = parcelRequire("kQgvZ");
var $122de591840aaf04$var$aggregateTwoErrors = $kQgvZ.aggregateTwoErrors, $122de591840aaf04$var$_require_codes = $kQgvZ.codes, $122de591840aaf04$var$ERR_INVALID_ARG_TYPE = $122de591840aaf04$var$_require_codes.ERR_INVALID_ARG_TYPE, $122de591840aaf04$var$ERR_METHOD_NOT_IMPLEMENTED = $122de591840aaf04$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $122de591840aaf04$var$ERR_OUT_OF_RANGE = $122de591840aaf04$var$_require_codes.ERR_OUT_OF_RANGE, $122de591840aaf04$var$ERR_STREAM_PUSH_AFTER_EOF = $122de591840aaf04$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $122de591840aaf04$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $122de591840aaf04$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $122de591840aaf04$var$AbortError = $kQgvZ.AbortError;

var $cf1oN = parcelRequire("cf1oN");
var $122de591840aaf04$require$validateObject = $cf1oN.validateObject;
var $122de591840aaf04$var$kPaused = $122de591840aaf04$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $122de591840aaf04$require$StringDecoder = $3Jf7C.StringDecoder;

var $9O7nY = parcelRequire("9O7nY");
$122de591840aaf04$var$ObjectSetPrototypeOf($122de591840aaf04$var$Readable.prototype, $122de591840aaf04$var$Stream.prototype);
$122de591840aaf04$var$ObjectSetPrototypeOf($122de591840aaf04$var$Readable, $122de591840aaf04$var$Stream);
var $122de591840aaf04$var$nop = function() {};
var $122de591840aaf04$var$errorOrDestroy = $32GkH.errorOrDestroy;
var $122de591840aaf04$var$kObjectMode = 1;
var $122de591840aaf04$var$kEnded = 2;
var $122de591840aaf04$var$kEndEmitted = 4;
var $122de591840aaf04$var$kReading = 8;
var $122de591840aaf04$var$kConstructed = 16;
var $122de591840aaf04$var$kSync = 32;
var $122de591840aaf04$var$kNeedReadable = 64;
var $122de591840aaf04$var$kEmittedReadable = 128;
var $122de591840aaf04$var$kReadableListening = 256;
var $122de591840aaf04$var$kResumeScheduled = 512;
var $122de591840aaf04$var$kErrorEmitted = 1024;
var $122de591840aaf04$var$kEmitClose = 2048;
var $122de591840aaf04$var$kAutoDestroy = 4096;
var $122de591840aaf04$var$kDestroyed = 8192;
var $122de591840aaf04$var$kClosed = 16384;
var $122de591840aaf04$var$kCloseEmitted = 32768;
var $122de591840aaf04$var$kMultiAwaitDrain = 65536;
var $122de591840aaf04$var$kReadingMore = 131072;
var $122de591840aaf04$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $122de591840aaf04$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$122de591840aaf04$var$ObjectDefineProperties($122de591840aaf04$var$ReadableState.prototype, {
    objectMode: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kObjectMode),
    ended: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kEnded),
    endEmitted: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kEndEmitted),
    reading: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kNeedReadable),
    emittedReadable: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kEmittedReadable),
    readableListening: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kReadableListening),
    resumeScheduled: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kErrorEmitted),
    emitClose: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kEmitClose),
    autoDestroy: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kCloseEmitted),
    multiAwaitDrain: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kReadingMore),
    dataEmitted: $122de591840aaf04$var$makeBitMapDescriptor($122de591840aaf04$var$kDataEmitted)
});

function $122de591840aaf04$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("lws7Y"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $122de591840aaf04$var$kEmitClose | $122de591840aaf04$var$kAutoDestroy | $122de591840aaf04$var$kConstructed | $122de591840aaf04$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $122de591840aaf04$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $122de591840aaf04$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $122de591840aaf04$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $122de591840aaf04$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $bxNkX();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$122de591840aaf04$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$122de591840aaf04$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$122de591840aaf04$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $122de591840aaf04$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $122de591840aaf04$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $122de591840aaf04$var$Readable)) return new $122de591840aaf04$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("lws7Y"));
    this._readableState = new $122de591840aaf04$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $122de591840aaf04$require$addAbortSignal(options.signal, this);
    }
    $122de591840aaf04$var$Stream.call(this, options);
    $32GkH.construct(this, function() {
        if (_this._readableState.needReadable) $122de591840aaf04$var$maybeReadMore(_this, _this._readableState);
    });
}
$122de591840aaf04$var$Readable.prototype.destroy = $32GkH.destroy;
$122de591840aaf04$var$Readable.prototype._undestroy = $32GkH.undestroy;
$122de591840aaf04$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$122de591840aaf04$var$Readable.prototype[$122de591840aaf04$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$122de591840aaf04$var$Readable.prototype[$122de591840aaf04$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $122de591840aaf04$var$AbortError();
        this.destroy(error);
    }
    return new $122de591840aaf04$var$Promise(function(resolve, reject) {
        return $bIKWZ(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$122de591840aaf04$var$Readable.prototype.push = function(chunk, encoding) {
    return $122de591840aaf04$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$122de591840aaf04$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $122de591840aaf04$var$readableAddChunk(this, chunk, encoding, true);
};
function $122de591840aaf04$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $122de591840aaf04$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $122de591840aaf04$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $122de591840aaf04$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $122de591840aaf04$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $122de591840aaf04$require$Buffer) encoding = '';
        else if ($122de591840aaf04$var$Stream._isUint8Array(chunk)) {
            chunk = $122de591840aaf04$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $122de591840aaf04$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $122de591840aaf04$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$122de591840aaf04$var$kReading;
        $122de591840aaf04$var$onEofChunk(stream, state);
    } else if ((state.state & $122de591840aaf04$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $122de591840aaf04$var$kEndEmitted) !== 0) $122de591840aaf04$var$errorOrDestroy(stream, new $122de591840aaf04$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $122de591840aaf04$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $122de591840aaf04$var$errorOrDestroy(stream, new $122de591840aaf04$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$122de591840aaf04$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $122de591840aaf04$var$addChunk(stream, state, chunk, false);
                else $122de591840aaf04$var$maybeReadMore(stream, state);
            } else $122de591840aaf04$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$122de591840aaf04$var$kReading;
        $122de591840aaf04$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $122de591840aaf04$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $122de591840aaf04$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $122de591840aaf04$var$kNeedReadable) !== 0) $122de591840aaf04$var$emitReadable(stream);
    }
    $122de591840aaf04$var$maybeReadMore(stream, state);
}
$122de591840aaf04$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$122de591840aaf04$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$122de591840aaf04$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $122de591840aaf04$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$122de591840aaf04$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $122de591840aaf04$var$MAX_HWM = 0x40000000;
function $122de591840aaf04$var$computeNewHighWaterMark(n) {
    if (n > $122de591840aaf04$var$MAX_HWM) throw new $122de591840aaf04$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $122de591840aaf04$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $122de591840aaf04$var$kObjectMode) !== 0) return 1;
    if ($122de591840aaf04$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$122de591840aaf04$var$Readable.prototype.read = function(n) {
    $122de591840aaf04$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$122de591840aaf04$var$NumberIsInteger(n)) n = $122de591840aaf04$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $122de591840aaf04$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$122de591840aaf04$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $122de591840aaf04$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $122de591840aaf04$var$endReadable(this);
        else $122de591840aaf04$var$emitReadable(this);
        return null;
    }
    n = $122de591840aaf04$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $122de591840aaf04$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $122de591840aaf04$var$kNeedReadable) !== 0;
    $122de591840aaf04$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $122de591840aaf04$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $122de591840aaf04$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $122de591840aaf04$var$debug('do read');
        state.state |= $122de591840aaf04$var$kReading | $122de591840aaf04$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $122de591840aaf04$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $122de591840aaf04$var$errorOrDestroy(this, err);
        }
        state.state &= ~$122de591840aaf04$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $122de591840aaf04$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $122de591840aaf04$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $122de591840aaf04$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $122de591840aaf04$var$onEofChunk(stream, state) {
    $122de591840aaf04$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $122de591840aaf04$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $122de591840aaf04$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $122de591840aaf04$var$emitReadable(stream) {
    var state = stream._readableState;
    $122de591840aaf04$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $122de591840aaf04$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($122de591840aaf04$var$emitReadable_, stream);
    }
}
function $122de591840aaf04$var$emitReadable_(stream) {
    var state = stream._readableState;
    $122de591840aaf04$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $122de591840aaf04$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $122de591840aaf04$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($122de591840aaf04$var$maybeReadMore_, stream, state);
    }
}
function $122de591840aaf04$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $122de591840aaf04$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$122de591840aaf04$var$Readable.prototype._read = function(n) {
    throw new $122de591840aaf04$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$122de591840aaf04$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $122de591840aaf04$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $122de591840aaf04$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $122de591840aaf04$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $122de591840aaf04$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $122de591840aaf04$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $122de591840aaf04$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $122de591840aaf04$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $122de591840aaf04$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $122de591840aaf04$var$debug('ondata');
        var ret = dest.write(chunk);
        $122de591840aaf04$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $122de591840aaf04$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $122de591840aaf04$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $122de591840aaf04$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $122de591840aaf04$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $122de591840aaf04$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $122de591840aaf04$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $122de591840aaf04$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $122de591840aaf04$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $122de591840aaf04$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$122de591840aaf04$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $122de591840aaf04$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$122de591840aaf04$var$Readable.prototype.on = function(ev, fn) {
    var res = $122de591840aaf04$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $122de591840aaf04$var$debug('on readable', state.length, state.reading);
            if (state.length) $122de591840aaf04$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($122de591840aaf04$var$nReadingNextTick, this);
        }
    }
    return res;
};
$122de591840aaf04$var$Readable.prototype.addListener = $122de591840aaf04$var$Readable.prototype.on;
$122de591840aaf04$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $122de591840aaf04$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($122de591840aaf04$var$updateReadableListening, this);
    return res;
};
$122de591840aaf04$var$Readable.prototype.off = $122de591840aaf04$var$Readable.prototype.removeListener;
$122de591840aaf04$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $122de591840aaf04$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($122de591840aaf04$var$updateReadableListening, this);
    return res;
};
function $122de591840aaf04$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$122de591840aaf04$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $122de591840aaf04$var$nReadingNextTick(self) {
    $122de591840aaf04$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$122de591840aaf04$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $122de591840aaf04$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $122de591840aaf04$var$resume(this, state);
    }
    state[$122de591840aaf04$var$kPaused] = false;
    return this;
};
function $122de591840aaf04$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($122de591840aaf04$var$resume_, stream, state);
    }
}
function $122de591840aaf04$var$resume_(stream, state) {
    $122de591840aaf04$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $122de591840aaf04$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$122de591840aaf04$var$Readable.prototype.pause = function() {
    $122de591840aaf04$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $122de591840aaf04$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$122de591840aaf04$var$kPaused] = true;
    return this;
};
function $122de591840aaf04$var$flow(stream) {
    var state = stream._readableState;
    $122de591840aaf04$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$122de591840aaf04$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $122de591840aaf04$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $122de591840aaf04$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$122de591840aaf04$var$Readable.prototype[$122de591840aaf04$var$SymbolAsyncIterator] = function() {
    return $122de591840aaf04$var$streamToAsyncIterator(this);
};
$122de591840aaf04$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $122de591840aaf04$require$validateObject(options, 'options');
    return $122de591840aaf04$var$streamToAsyncIterator(this, options);
};
function $122de591840aaf04$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $122de591840aaf04$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $122de591840aaf04$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $122de591840aaf04$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $122de591840aaf04$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $122de591840aaf04$var$nop;
                    stream.on('readable', next);
                    cleanup = $bIKWZ(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $122de591840aaf04$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $122de591840aaf04$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $122de591840aaf04$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $122de591840aaf04$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $32GkH.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$122de591840aaf04$var$ObjectDefineProperties($122de591840aaf04$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$122de591840aaf04$var$ObjectDefineProperties($122de591840aaf04$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$122de591840aaf04$var$kPaused] !== false;
        },
        set: function(value) {
            this[$122de591840aaf04$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$122de591840aaf04$var$Readable._fromList = $122de591840aaf04$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $122de591840aaf04$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $122de591840aaf04$var$endReadable(stream) {
    var state = stream._readableState;
    $122de591840aaf04$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($122de591840aaf04$var$endReadableNT, state, stream);
    }
}
function $122de591840aaf04$var$endReadableNT(state, stream) {
    $122de591840aaf04$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($122de591840aaf04$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $122de591840aaf04$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$122de591840aaf04$var$Readable.from = function(iterable, opts) {
    return $9O7nY($122de591840aaf04$var$Readable, iterable, opts);
};
var $122de591840aaf04$var$webStreamsAdapters;
// Lazy to avoid circular references
function $122de591840aaf04$var$lazyWebStreams() {
    if ($122de591840aaf04$var$webStreamsAdapters === undefined) $122de591840aaf04$var$webStreamsAdapters = {};
    return $122de591840aaf04$var$webStreamsAdapters;
}
$122de591840aaf04$var$Readable.fromWeb = function(readableStream, options) {
    return $122de591840aaf04$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$122de591840aaf04$var$Readable.toWeb = function(streamReadable, options) {
    return $122de591840aaf04$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$122de591840aaf04$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $122de591840aaf04$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $32GkH.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("7tuPk", function(module, exports) {
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $57132766fae5b137$var$ArrayIsArray = $a0D5I.ArrayIsArray, $57132766fae5b137$var$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $57132766fae5b137$var$EE = $bBoAO.EventEmitter;
function $57132766fae5b137$var$Stream(opts) {
    $57132766fae5b137$var$EE.call(this, opts);
}
$57132766fae5b137$var$ObjectSetPrototypeOf($57132766fae5b137$var$Stream.prototype, $57132766fae5b137$var$EE.prototype);
$57132766fae5b137$var$ObjectSetPrototypeOf($57132766fae5b137$var$Stream, $57132766fae5b137$var$EE);
$57132766fae5b137$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($57132766fae5b137$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $57132766fae5b137$var$prependListener(source, 'error', onerror);
    $57132766fae5b137$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $57132766fae5b137$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($57132766fae5b137$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $57132766fae5b137$var$Stream,
    prependListener: $57132766fae5b137$var$prependListener
};

});

parcelRegister("hnuyc", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $ca6c485cc91b45e3$export$e2db56ee53255a0; }, function (v) { return $ca6c485cc91b45e3$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $ca6c485cc91b45e3$export$11956e9313f43de0; }, function (v) { return $ca6c485cc91b45e3$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $ca6c485cc91b45e3$export$e2db56ee53255a0;
var $ca6c485cc91b45e3$export$11956e9313f43de0;
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $ca6c485cc91b45e3$require$SymbolDispose = $a0D5I.SymbolDispose;

var $kQgvZ = parcelRequire("kQgvZ");
var $ca6c485cc91b45e3$var$AbortError = $kQgvZ.AbortError, $ca6c485cc91b45e3$var$codes = $kQgvZ.codes;

var $468KT = parcelRequire("468KT");
var $ca6c485cc91b45e3$var$isNodeStream = $468KT.isNodeStream, $ca6c485cc91b45e3$var$isWebStream = $468KT.isWebStream, $ca6c485cc91b45e3$var$kControllerErrorFunction = $468KT.kControllerErrorFunction;

var $bIKWZ = parcelRequire("bIKWZ");
var $ca6c485cc91b45e3$var$ERR_INVALID_ARG_TYPE = $ca6c485cc91b45e3$var$codes.ERR_INVALID_ARG_TYPE;
var $ca6c485cc91b45e3$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $ca6c485cc91b45e3$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $ca6c485cc91b45e3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$ca6c485cc91b45e3$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $ca6c485cc91b45e3$var$validateAbortSignal(signal, 'signal');
    if (!$ca6c485cc91b45e3$var$isNodeStream(stream) && !$ca6c485cc91b45e3$var$isWebStream(stream)) throw new $ca6c485cc91b45e3$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $ca6c485cc91b45e3$export$11956e9313f43de0(signal, stream);
};

$ca6c485cc91b45e3$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $ca6c485cc91b45e3$var$isNodeStream(stream) ? function() {
        stream.destroy(new $ca6c485cc91b45e3$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$ca6c485cc91b45e3$var$kControllerErrorFunction](new $ca6c485cc91b45e3$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $ca6c485cc91b45e3$var$addAbortListener = $ca6c485cc91b45e3$var$addAbortListener || (parcelRequire("4IP8j")).addAbortListener;
        var disposable = $ca6c485cc91b45e3$var$addAbortListener(signal, onAbort);
        $bIKWZ(stream, disposable[$ca6c485cc91b45e3$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("bxNkX", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $86790c163e3addc1$var$StringPrototypeSlice = $a0D5I.StringPrototypeSlice, $86790c163e3addc1$var$SymbolIterator = $a0D5I.SymbolIterator, $86790c163e3addc1$var$TypedArrayPrototypeSet = $a0D5I.TypedArrayPrototypeSet, $86790c163e3addc1$var$Uint8Array = $a0D5I.Uint8Array;

var $8lo7h = parcelRequire("8lo7h");
var $86790c163e3addc1$require$Buffer = $8lo7h.Buffer;

var $4IP8j = parcelRequire("4IP8j");
var $86790c163e3addc1$require$inspect = $4IP8j.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $86790c163e3addc1$require$Buffer.alloc(0);
                var ret = $86790c163e3addc1$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $86790c163e3addc1$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $86790c163e3addc1$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $86790c163e3addc1$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $86790c163e3addc1$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $86790c163e3addc1$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $86790c163e3addc1$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $86790c163e3addc1$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $86790c163e3addc1$var$TypedArrayPrototypeSet(ret, new $86790c163e3addc1$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $86790c163e3addc1$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("eCV4g", function(module, exports) {
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $aa60e1bfb747efa9$var$MathFloor = $a0D5I.MathFloor, $aa60e1bfb747efa9$var$NumberIsInteger = $a0D5I.NumberIsInteger;

var $cf1oN = parcelRequire("cf1oN");
var $aa60e1bfb747efa9$require$validateInteger = $cf1oN.validateInteger;

var $aa60e1bfb747efa9$var$ERR_INVALID_ARG_VALUE = (parcelRequire("kQgvZ")).codes.ERR_INVALID_ARG_VALUE;
var $aa60e1bfb747efa9$var$defaultHighWaterMarkBytes = 16384;
var $aa60e1bfb747efa9$var$defaultHighWaterMarkObjectMode = 16;
function $aa60e1bfb747efa9$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $aa60e1bfb747efa9$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $aa60e1bfb747efa9$var$defaultHighWaterMarkObjectMode : $aa60e1bfb747efa9$var$defaultHighWaterMarkBytes;
}
function $aa60e1bfb747efa9$var$setDefaultHighWaterMark(objectMode, value) {
    $aa60e1bfb747efa9$require$validateInteger(value, 'value', 0);
    if (objectMode) $aa60e1bfb747efa9$var$defaultHighWaterMarkObjectMode = value;
    else $aa60e1bfb747efa9$var$defaultHighWaterMarkBytes = value;
}
function $aa60e1bfb747efa9$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $aa60e1bfb747efa9$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$aa60e1bfb747efa9$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $aa60e1bfb747efa9$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $aa60e1bfb747efa9$var$MathFloor(hwm);
    }
    // Default value
    return $aa60e1bfb747efa9$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $aa60e1bfb747efa9$var$getHighWaterMark,
    getDefaultHighWaterMark: $aa60e1bfb747efa9$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $aa60e1bfb747efa9$var$setDefaultHighWaterMark
};

});

parcelRegister("9O7nY", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a0D5I = parcelRequire("a0D5I");
/* replacement end */ var $723e83361a68e06d$var$PromisePrototypeThen = $a0D5I.PromisePrototypeThen, $723e83361a68e06d$var$SymbolAsyncIterator = $a0D5I.SymbolAsyncIterator, $723e83361a68e06d$var$SymbolIterator = $a0D5I.SymbolIterator;

var $8lo7h = parcelRequire("8lo7h");
var $723e83361a68e06d$require$Buffer = $8lo7h.Buffer;

var $kQgvZ = parcelRequire("kQgvZ");
var $723e83361a68e06d$require$_require_codes = $kQgvZ.codes;
var $723e83361a68e06d$var$ERR_INVALID_ARG_TYPE = $723e83361a68e06d$require$_require_codes.ERR_INVALID_ARG_TYPE, $723e83361a68e06d$var$ERR_STREAM_NULL_VALUES = $723e83361a68e06d$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $723e83361a68e06d$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $723e83361a68e06d$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$723e83361a68e06d$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$723e83361a68e06d$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$723e83361a68e06d$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$723e83361a68e06d$var$SymbolIterator]();
    } else throw new $723e83361a68e06d$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $723e83361a68e06d$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $723e83361a68e06d$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $723e83361a68e06d$var$from;

});


parcelRegister("jBLP2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $a0D5I = parcelRequire("a0D5I");
/* replacement end */ var $e46691871d63375b$var$ArrayPrototypeSlice = $a0D5I.ArrayPrototypeSlice, $e46691871d63375b$var$Error = $a0D5I.Error, $e46691871d63375b$var$FunctionPrototypeSymbolHasInstance = $a0D5I.FunctionPrototypeSymbolHasInstance, $e46691871d63375b$var$ObjectDefineProperty = $a0D5I.ObjectDefineProperty, $e46691871d63375b$var$ObjectDefineProperties = $a0D5I.ObjectDefineProperties, $e46691871d63375b$var$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf, $e46691871d63375b$var$StringPrototypeToLowerCase = $a0D5I.StringPrototypeToLowerCase, $e46691871d63375b$var$Symbol = $a0D5I.Symbol, $e46691871d63375b$var$SymbolHasInstance = $a0D5I.SymbolHasInstance;
module.exports = $e46691871d63375b$var$Writable;
$e46691871d63375b$var$Writable.WritableState = $e46691871d63375b$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $e46691871d63375b$var$EE = $bBoAO.EventEmitter;

var $7tuPk = parcelRequire("7tuPk");
var $e46691871d63375b$require$Stream = $7tuPk.Stream;

var $8lo7h = parcelRequire("8lo7h");
var $e46691871d63375b$require$Buffer = $8lo7h.Buffer;

var $32GkH = parcelRequire("32GkH");

var $hnuyc = parcelRequire("hnuyc");
var $e46691871d63375b$require$addAbortSignal = $hnuyc.addAbortSignal;

var $eCV4g = parcelRequire("eCV4g");
var $e46691871d63375b$var$getHighWaterMark = $eCV4g.getHighWaterMark, $e46691871d63375b$var$getDefaultHighWaterMark = $eCV4g.getDefaultHighWaterMark;

var $kQgvZ = parcelRequire("kQgvZ");
var $e46691871d63375b$require$_require_codes = $kQgvZ.codes;
var $e46691871d63375b$var$ERR_INVALID_ARG_TYPE = $e46691871d63375b$require$_require_codes.ERR_INVALID_ARG_TYPE, $e46691871d63375b$var$ERR_METHOD_NOT_IMPLEMENTED = $e46691871d63375b$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $e46691871d63375b$var$ERR_MULTIPLE_CALLBACK = $e46691871d63375b$require$_require_codes.ERR_MULTIPLE_CALLBACK, $e46691871d63375b$var$ERR_STREAM_CANNOT_PIPE = $e46691871d63375b$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $e46691871d63375b$var$ERR_STREAM_DESTROYED = $e46691871d63375b$require$_require_codes.ERR_STREAM_DESTROYED, $e46691871d63375b$var$ERR_STREAM_ALREADY_FINISHED = $e46691871d63375b$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $e46691871d63375b$var$ERR_STREAM_NULL_VALUES = $e46691871d63375b$require$_require_codes.ERR_STREAM_NULL_VALUES, $e46691871d63375b$var$ERR_STREAM_WRITE_AFTER_END = $e46691871d63375b$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $e46691871d63375b$var$ERR_UNKNOWN_ENCODING = $e46691871d63375b$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $e46691871d63375b$var$errorOrDestroy = $32GkH.errorOrDestroy;
$e46691871d63375b$var$ObjectSetPrototypeOf($e46691871d63375b$var$Writable.prototype, $e46691871d63375b$require$Stream.prototype);
$e46691871d63375b$var$ObjectSetPrototypeOf($e46691871d63375b$var$Writable, $e46691871d63375b$require$Stream);
function $e46691871d63375b$var$nop() {}
var $e46691871d63375b$var$kOnFinished = $e46691871d63375b$var$Symbol('kOnFinished');

function $e46691871d63375b$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("lws7Y"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $e46691871d63375b$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $e46691871d63375b$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $e46691871d63375b$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $e46691871d63375b$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$e46691871d63375b$var$kOnFinished] = [];
}
function $e46691871d63375b$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$e46691871d63375b$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $e46691871d63375b$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$e46691871d63375b$var$ObjectDefineProperty($e46691871d63375b$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $e46691871d63375b$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("lws7Y"));
    if (!isDuplex && !$e46691871d63375b$var$FunctionPrototypeSymbolHasInstance($e46691871d63375b$var$Writable, this)) return new $e46691871d63375b$var$Writable(options);
    this._writableState = new $e46691871d63375b$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $e46691871d63375b$require$addAbortSignal(options.signal, this);
    }
    $e46691871d63375b$require$Stream.call(this, options);
    $32GkH.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $e46691871d63375b$var$clearBuffer(_this, state);
        $e46691871d63375b$var$finishMaybe(_this, state);
    });
}
$e46691871d63375b$var$ObjectDefineProperty($e46691871d63375b$var$Writable, $e46691871d63375b$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($e46691871d63375b$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $e46691871d63375b$var$Writable) return false;
        return object && object._writableState instanceof $e46691871d63375b$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$e46691871d63375b$var$Writable.prototype.pipe = function() {
    $e46691871d63375b$var$errorOrDestroy(this, new $e46691871d63375b$var$ERR_STREAM_CANNOT_PIPE());
};
function $e46691871d63375b$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$e46691871d63375b$require$Buffer.isEncoding(encoding)) throw new $e46691871d63375b$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $e46691871d63375b$var$nop;
    }
    if (chunk === null) throw new $e46691871d63375b$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $e46691871d63375b$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $e46691871d63375b$require$Buffer) encoding = 'buffer';
        else if ($e46691871d63375b$require$Stream._isUint8Array(chunk)) {
            chunk = $e46691871d63375b$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $e46691871d63375b$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $e46691871d63375b$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $e46691871d63375b$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $e46691871d63375b$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $e46691871d63375b$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$e46691871d63375b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $e46691871d63375b$var$_write(this, chunk, encoding, cb) === true;
};
$e46691871d63375b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$e46691871d63375b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $e46691871d63375b$var$clearBuffer(this, state);
    }
};
$e46691871d63375b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $e46691871d63375b$var$StringPrototypeToLowerCase(encoding);
    if (!$e46691871d63375b$require$Buffer.isEncoding(encoding)) throw new $e46691871d63375b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $e46691871d63375b$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $e46691871d63375b$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $e46691871d63375b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $e46691871d63375b$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $e46691871d63375b$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $e46691871d63375b$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $e46691871d63375b$var$errorOrDestroy(stream, er);
}
function $e46691871d63375b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $e46691871d63375b$var$errorOrDestroy(stream, new $e46691871d63375b$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($e46691871d63375b$var$onwriteError, stream, state, er, cb);
        else $e46691871d63375b$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $e46691871d63375b$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($e46691871d63375b$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $e46691871d63375b$var$afterWrite(stream, state, 1, cb);
    }
}
function $e46691871d63375b$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $e46691871d63375b$var$afterWrite(stream, state, count, cb);
}
function $e46691871d63375b$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $e46691871d63375b$var$errorBuffer(state);
    $e46691871d63375b$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $e46691871d63375b$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $e46691871d63375b$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$e46691871d63375b$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $e46691871d63375b$var$ERR_STREAM_DESTROYED('end'));
    }
    $e46691871d63375b$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $e46691871d63375b$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $e46691871d63375b$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $e46691871d63375b$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $e46691871d63375b$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $e46691871d63375b$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $e46691871d63375b$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $e46691871d63375b$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$e46691871d63375b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $e46691871d63375b$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$e46691871d63375b$var$Writable.prototype._writev = null;
$e46691871d63375b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $e46691871d63375b$var$_write(this, chunk, encoding);
        if (ret instanceof $e46691871d63375b$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $e46691871d63375b$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $e46691871d63375b$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $e46691871d63375b$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$e46691871d63375b$var$kOnFinished].push(cb);
    }
    return this;
};
function $e46691871d63375b$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $e46691871d63375b$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $e46691871d63375b$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $e46691871d63375b$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$e46691871d63375b$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $e46691871d63375b$var$errorOrDestroy(stream, err, state.sync);
        } else if ($e46691871d63375b$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($e46691871d63375b$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $e46691871d63375b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $e46691871d63375b$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $e46691871d63375b$var$finishMaybe(stream, state, sync) {
    if ($e46691871d63375b$var$needFinish(state)) {
        $e46691871d63375b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($e46691871d63375b$var$needFinish(state)) $e46691871d63375b$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($e46691871d63375b$var$needFinish(state)) {
                state.pendingcb++;
                $e46691871d63375b$var$finish(stream, state);
            }
        }
    }
}
function $e46691871d63375b$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$e46691871d63375b$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$e46691871d63375b$var$ObjectDefineProperties($e46691871d63375b$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $e46691871d63375b$var$destroy = $32GkH.destroy;
$e46691871d63375b$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$e46691871d63375b$var$kOnFinished].length)) $2Qkr5.nextTick($e46691871d63375b$var$errorBuffer, state);
    $e46691871d63375b$var$destroy.call(this, err, cb);
    return this;
};
$e46691871d63375b$var$Writable.prototype._undestroy = $32GkH.undestroy;
$e46691871d63375b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$e46691871d63375b$var$Writable.prototype[$e46691871d63375b$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $e46691871d63375b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $e46691871d63375b$var$lazyWebStreams() {
    if ($e46691871d63375b$var$webStreamsAdapters === undefined) $e46691871d63375b$var$webStreamsAdapters = {};
    return $e46691871d63375b$var$webStreamsAdapters;
}
$e46691871d63375b$var$Writable.fromWeb = function(writableStream, options) {
    return $e46691871d63375b$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$e46691871d63375b$var$Writable.toWeb = function(streamWritable) {
    return $e46691871d63375b$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("blC1I", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $8lo7h = parcelRequire("8lo7h");

var $468KT = parcelRequire("468KT");
var $842f27333d1ed61d$var$isReadable = $468KT.isReadable, $842f27333d1ed61d$var$isWritable = $468KT.isWritable, $842f27333d1ed61d$var$isIterable = $468KT.isIterable, $842f27333d1ed61d$var$isNodeStream = $468KT.isNodeStream, $842f27333d1ed61d$var$isReadableNodeStream = $468KT.isReadableNodeStream, $842f27333d1ed61d$var$isWritableNodeStream = $468KT.isWritableNodeStream, $842f27333d1ed61d$var$isDuplexNodeStream = $468KT.isDuplexNodeStream, $842f27333d1ed61d$var$isReadableStream = $468KT.isReadableStream, $842f27333d1ed61d$var$isWritableStream = $468KT.isWritableStream;

var $bIKWZ = parcelRequire("bIKWZ");

var $kQgvZ = parcelRequire("kQgvZ");
var $842f27333d1ed61d$var$AbortError = $kQgvZ.AbortError, $842f27333d1ed61d$var$_require_codes = $kQgvZ.codes, $842f27333d1ed61d$var$ERR_INVALID_ARG_TYPE = $842f27333d1ed61d$var$_require_codes.ERR_INVALID_ARG_TYPE, $842f27333d1ed61d$var$ERR_INVALID_RETURN_VALUE = $842f27333d1ed61d$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $32GkH = parcelRequire("32GkH");
var $842f27333d1ed61d$require$destroyer = $32GkH.destroyer;

var $lws7Y = parcelRequire("lws7Y");

var $1yLBO = parcelRequire("1yLBO");

var $jBLP2 = parcelRequire("jBLP2");

var $4IP8j = parcelRequire("4IP8j");
var $842f27333d1ed61d$require$createDeferredPromise = $4IP8j.createDeferredPromise;

var $9O7nY = parcelRequire("9O7nY");
var $842f27333d1ed61d$var$Blob = globalThis.Blob || $8lo7h.Blob;
var $842f27333d1ed61d$var$isBlob = typeof $842f27333d1ed61d$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $842f27333d1ed61d$var$Blob;
} : function isBlob(b) {
    return false;
};

var $842f27333d1ed61d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $a0D5I = parcelRequire("a0D5I");
var $842f27333d1ed61d$require$FunctionPrototypeCall = $a0D5I.FunctionPrototypeCall;
// This is needed for pre node 17.
var $842f27333d1ed61d$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($lws7Y);
module.exports = function duplexify(body, name) {
    if ($842f27333d1ed61d$var$isDuplexNodeStream(body)) return body;
    if ($842f27333d1ed61d$var$isReadableNodeStream(body)) return $842f27333d1ed61d$var$_duplexify({
        readable: body
    });
    if ($842f27333d1ed61d$var$isWritableNodeStream(body)) return $842f27333d1ed61d$var$_duplexify({
        writable: body
    });
    if ($842f27333d1ed61d$var$isNodeStream(body)) return $842f27333d1ed61d$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($842f27333d1ed61d$var$isReadableStream(body)) return $842f27333d1ed61d$var$_duplexify({
        readable: $1yLBO.fromWeb(body)
    });
    if ($842f27333d1ed61d$var$isWritableStream(body)) return $842f27333d1ed61d$var$_duplexify({
        writable: $jBLP2.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $842f27333d1ed61d$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($842f27333d1ed61d$var$isIterable(value)) return $9O7nY($842f27333d1ed61d$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $842f27333d1ed61d$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $842f27333d1ed61d$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $842f27333d1ed61d$require$destroyer(d, err);
            });
            return d = new $842f27333d1ed61d$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $842f27333d1ed61d$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($842f27333d1ed61d$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($842f27333d1ed61d$var$isIterable(body)) return $9O7nY($842f27333d1ed61d$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($842f27333d1ed61d$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $842f27333d1ed61d$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $842f27333d1ed61d$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $842f27333d1ed61d$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $842f27333d1ed61d$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $842f27333d1ed61d$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $842f27333d1ed61d$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $842f27333d1ed61d$require$destroyer(d1, err);
        });
        return d1 = new $842f27333d1ed61d$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $842f27333d1ed61d$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $842f27333d1ed61d$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $842f27333d1ed61d$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $842f27333d1ed61d$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $842f27333d1ed61d$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $842f27333d1ed61d$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $842f27333d1ed61d$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $1yLBO.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$842f27333d1ed61d$var$isReadable(r);
    var writable = !!$842f27333d1ed61d$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $842f27333d1ed61d$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $bIKWZ(w, function(err) {
            writable = false;
            if (err) $842f27333d1ed61d$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $bIKWZ(r, function(err) {
            readable = false;
            if (err) $842f27333d1ed61d$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $842f27333d1ed61d$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $842f27333d1ed61d$require$destroyer(w, err);
            $842f27333d1ed61d$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("jrjUz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $e26ffbf4e05b97ce$require$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf;
module.exports = $e26ffbf4e05b97ce$var$PassThrough;

var $9YyJs = parcelRequire("9YyJs");
$e26ffbf4e05b97ce$require$ObjectSetPrototypeOf($e26ffbf4e05b97ce$var$PassThrough.prototype, $9YyJs.prototype);
$e26ffbf4e05b97ce$require$ObjectSetPrototypeOf($e26ffbf4e05b97ce$var$PassThrough, $9YyJs);
function $e26ffbf4e05b97ce$var$PassThrough(options) {
    if (!(this instanceof $e26ffbf4e05b97ce$var$PassThrough)) return new $e26ffbf4e05b97ce$var$PassThrough(options);
    $9YyJs.call(this, options);
}
$e26ffbf4e05b97ce$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("9YyJs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $7434a8c12e3de61c$var$ObjectSetPrototypeOf = $a0D5I.ObjectSetPrototypeOf, $7434a8c12e3de61c$var$Symbol = $a0D5I.Symbol;
module.exports = $7434a8c12e3de61c$var$Transform;

var $7434a8c12e3de61c$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("kQgvZ")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $lws7Y = parcelRequire("lws7Y");

var $eCV4g = parcelRequire("eCV4g");
var $7434a8c12e3de61c$require$getHighWaterMark = $eCV4g.getHighWaterMark;
$7434a8c12e3de61c$var$ObjectSetPrototypeOf($7434a8c12e3de61c$var$Transform.prototype, $lws7Y.prototype);
$7434a8c12e3de61c$var$ObjectSetPrototypeOf($7434a8c12e3de61c$var$Transform, $lws7Y);
var $7434a8c12e3de61c$var$kCallback = $7434a8c12e3de61c$var$Symbol('kCallback');
function $7434a8c12e3de61c$var$Transform(options) {
    if (!(this instanceof $7434a8c12e3de61c$var$Transform)) return new $7434a8c12e3de61c$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $7434a8c12e3de61c$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $lws7Y.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$7434a8c12e3de61c$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $7434a8c12e3de61c$var$prefinish);
}
function $7434a8c12e3de61c$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $7434a8c12e3de61c$var$prefinish() {
    if (this._final !== $7434a8c12e3de61c$var$_final) $7434a8c12e3de61c$var$_final.call(this);
}
$7434a8c12e3de61c$var$Transform.prototype._final = $7434a8c12e3de61c$var$_final;
$7434a8c12e3de61c$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $7434a8c12e3de61c$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$7434a8c12e3de61c$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$7434a8c12e3de61c$var$kCallback] = callback;
    });
};
$7434a8c12e3de61c$var$Transform.prototype._read = function() {
    if (this[$7434a8c12e3de61c$var$kCallback]) {
        var callback = this[$7434a8c12e3de61c$var$kCallback];
        this[$7434a8c12e3de61c$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2RiDF", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $a0D5I = parcelRequire("a0D5I");
var $214efd47f895df00$var$ArrayPrototypePop = $a0D5I.ArrayPrototypePop, $214efd47f895df00$var$Promise = $a0D5I.Promise;

var $468KT = parcelRequire("468KT");
var $214efd47f895df00$var$isIterable = $468KT.isIterable, $214efd47f895df00$var$isNodeStream = $468KT.isNodeStream, $214efd47f895df00$var$isWebStream = $468KT.isWebStream;

var $6WtEZ = parcelRequire("6WtEZ");
var $214efd47f895df00$var$pl = $6WtEZ.pipelineImpl;

var $bIKWZ = parcelRequire("bIKWZ");
var $214efd47f895df00$require$finished = $bIKWZ.finished;
parcelRequire("17TJM");
function $214efd47f895df00$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $214efd47f895df00$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$214efd47f895df00$var$isNodeStream(lastArg) && !$214efd47f895df00$var$isIterable(lastArg) && !$214efd47f895df00$var$isWebStream(lastArg)) {
            var options = $214efd47f895df00$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $214efd47f895df00$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $214efd47f895df00$require$finished,
    pipeline: $214efd47f895df00$var$pipeline
};

});





parcelRegister("uCkRL", function(module, exports) {
"use strict";
var $05c08a19481f1f3a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $05c08a19481f1f3a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $05c08a19481f1f3a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$05c08a19481f1f3a$var$__exportStar((parcelRequire("9FvMd")), module.exports);

$05c08a19481f1f3a$var$__exportStar((parcelRequire("5oiV5")), module.exports);

});
parcelRegister("9FvMd", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaQpf = void 0;

var $cutHr = parcelRequire("cutHr");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $hSHd8 = parcelRequire("hSHd8");

var $5oiV5 = parcelRequire("5oiV5");
/**
 * A comunica QPF Query Source Identify Hypermedia Actor.
 */ var $70a09792b20002de$var$ActorQuerySourceIdentifyHypermediaQpf = /*#__PURE__*/ function(_bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyHypermediaQpf, _bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia);
    function ActorQuerySourceIdentifyHypermediaQpf(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyHypermediaQpf);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifyHypermediaQpf, [
            args,
            'qpf'
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyHypermediaQpf, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.forceSourceType && action.forceSourceType !== 'qpf' && action.forceSourceType !== 'brtpf') return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " is not able to handle source type ").concat(action.forceSourceType, "."))
                        ];
                        return [
                            2,
                            this.testMetadata(action)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "testMetadata",
            value: function testMetadata(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var searchForm;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.createSource(action.url, action.metadata, action.context, action.forceSourceType === 'brtpf')
                                ];
                            case 1:
                                searchForm = _state.sent().searchForm;
                                if (!searchForm) return [
                                    2,
                                    (0, $kNNoa.failTest)('Illegal state: found no TPF/QPF search form anymore in metadata.')
                                ];
                                if (action.handledDatasets && action.handledDatasets[searchForm.dataset]) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only be applied for the first page of a QPF dataset."))
                                ];
                                return [
                                    2,
                                    (0, $kNNoa.passTest)({
                                        filterFactor: 1
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: /**
     * Look for the search form
     * @param {IActionRdfResolveHypermedia} action the metadata to look for the form.
     * @return {Promise<IActorRdfResolveHypermediaOutput>} A promise resolving to a hypermedia form.
     */ function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var source;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.logInfo(action.context, "Identified as qpf source: ".concat(action.url));
                                return [
                                    4,
                                    this.createSource(action.url, action.metadata, action.context, action.forceSourceType === 'brtpf', action.quads)
                                ];
                            case 1:
                                source = _state.sent();
                                return [
                                    2,
                                    {
                                        source: source,
                                        dataset: source.searchForm.dataset
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createSource",
            value: function createSource(url, metadata, context, bindingsRestricted, quads) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                _1 = (_ = $5oiV5.QuerySourceQpf).bind;
                                _tmp = [
                                    void 0,
                                    this.mediatorMetadata,
                                    this.mediatorMetadataExtract,
                                    this.mediatorDereferenceRdf,
                                    dataFactory,
                                    algebraFactory
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent(),
                                        this.subjectUri,
                                        this.predicateUri,
                                        this.objectUri,
                                        this.graphUri,
                                        url,
                                        metadata,
                                        bindingsRestricted,
                                        quads
                                    ])))
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyHypermediaQpf;
}($cutHr.ActorQuerySourceIdentifyHypermedia);
module.exports.ActorQuerySourceIdentifyHypermediaQpf = $70a09792b20002de$var$ActorQuerySourceIdentifyHypermediaQpf;

});
parcelRegister("cutHr", function(module, exports) {
"use strict";
var $917f532243dd2445$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $917f532243dd2445$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $917f532243dd2445$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$917f532243dd2445$var$__exportStar((parcelRequire("bq5Tx")), module.exports);

});
parcelRegister("bq5Tx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermedia = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for query-source-identify-hypermedia events.
 *
 * Actor types:
 * * Input:  IActionQuerySourceIdentifyHypermedia:      The metadata in the document and a query operation.
 * * Test:   <none>
 * * Output: IActorQuerySourceIdentifyHypermediaOutput: A query source.
 *
 * @see IActionQuerySourceIdentifyHypermedia
 * @see IActorQuerySourceIdentifyHypermediaOutput
 */ var $8506b202c44ea8f4$var$ActorQuerySourceIdentifyHypermedia = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyHypermedia, _core_1_Actor);
    function ActorQuerySourceIdentifyHypermedia(args, sourceType) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyHypermedia);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQuerySourceIdentifyHypermedia, [
            args
        ]);
        _this.sourceType = sourceType;
        return _this;
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyHypermedia, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.forceSourceType && this.sourceType !== action.forceSourceType) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " is not able to handle source type ").concat(action.forceSourceType, "."))
                        ];
                        return [
                            2,
                            this.testMetadata(action)
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyHypermedia;
}($kNNoa.Actor);
module.exports.ActorQuerySourceIdentifyHypermedia = $8506b202c44ea8f4$var$ActorQuerySourceIdentifyHypermedia;

});


parcelRegister("5oiV5", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceQpf = void 0;

var $eznfg = parcelRequire("eznfg");

var $9nBhR = parcelRequire("9nBhR");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");

var $3veIK = parcelRequire("3veIK");

var $ilNtL = parcelRequire("ilNtL");
var $3ecddebc09c30e75$var$QuerySourceQpf = /*#__PURE__*/ function() {
    function QuerySourceQpf(mediatorMetadata, mediatorMetadataExtract, mediatorDereferenceRdf, dataFactory, algebraFactory, bindingsFactory, subjectUri, predicateUri, objectUri, graphUri, url, metadata, bindingsRestricted, initialQuads) {
        (0, $jGAMp._)(this, QuerySourceQpf);
        this.referenceValue = url;
        this.mediatorMetadata = mediatorMetadata;
        this.mediatorMetadataExtract = mediatorMetadataExtract;
        this.mediatorDereferenceRdf = mediatorDereferenceRdf;
        this.dataFactory = dataFactory;
        this.algebraFactory = algebraFactory;
        this.bindingsFactory = bindingsFactory;
        this.subjectUri = subjectUri;
        this.predicateUri = predicateUri;
        this.objectUri = objectUri;
        this.graphUri = graphUri;
        this.url = url;
        this.bindingsRestricted = bindingsRestricted;
        this.cachedQuads = {};
        this.searchForm = this.getSearchForm(metadata);
        this.defaultGraph = metadata.defaultGraph ? this.dataFactory.namedNode(metadata.defaultGraph) : undefined;
        if (initialQuads) {
            var wrappedQuads = (0, $aafx9.wrap)(initialQuads);
            if (this.defaultGraph) wrappedQuads = this.reverseMapQuadsToDefaultGraph(wrappedQuads);
            metadata = (0, $emQHU._)((0, $iT0je._)({}, metadata), {
                state: new $jZbVy.MetadataValidationState()
            });
            wrappedQuads.setProperty('metadata', metadata);
            this.cacheQuads(wrappedQuads, this.dataFactory.variable(''), this.dataFactory.variable(''), this.dataFactory.variable(''), this.dataFactory.variable(''));
        }
        this.selectorShape = this.bindingsRestricted ? {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o'),
                this.dataFactory.variable('g')
            ],
            filterBindings: true
        } : {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o'),
                this.dataFactory.variable('g')
            ]
        };
    }
    (0, $byiyg._)(QuerySourceQpf, [
        {
            key: "getSelectorShape",
            value: function getSelectorShape() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.selectorShape
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryBindings",
            value: function queryBindings(operation, context, options) {
                if (operation.type !== 'pattern') throw new Error("Attempted to pass non-pattern operation '".concat(operation.type, "' to QuerySourceQpf"));
                var unionDefaultGraph = Boolean(context.get($9nBhR.KeysQueryOperation.unionDefaultGraph));
                // Create an async iterator from the matched quad stream
                var it = this.match(operation.subject, operation.predicate, operation.object, operation.graph, unionDefaultGraph, context, options);
                it = (0, $eznfg.filterMatchingQuotedQuads)(operation, it);
                return (0, $eznfg.quadsToBindings)(it, operation, this.dataFactory, this.bindingsFactory, unionDefaultGraph);
            }
        },
        {
            /**
     * Get a first QPF search form.
     * @param {{[p: string]: any}} metadata A metadata object.
     * @return {ISearchForm} A search form, or null if none could be found.
     */ key: "getSearchForm",
            value: function getSearchForm(metadata) {
                if (!metadata.searchForms || !metadata.searchForms.values) return;
                // Find a quad pattern or triple pattern search form
                var searchForms = metadata.searchForms;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = searchForms.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var searchForm = _step.value;
                        if (this.graphUri && this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && this.graphUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 4) return searchForm;
                        if (this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 3) return searchForm;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Create a QPF fragment IRI for the given quad pattern.
     * @param {ISearchForm} searchForm A search form.
     * @param {Term} subject A term.
     * @param {Term} predicate A term.
     * @param {Term} object A term.
     * @param {Term} graph A term.
     * @return {string} A URI.
     */ key: "createFragmentUri",
            value: function createFragmentUri(searchForm, subject, predicate, object, graph) {
                var entries = {};
                var input = [
                    {
                        uri: this.subjectUri,
                        term: subject
                    },
                    {
                        uri: this.predicateUri,
                        term: predicate
                    },
                    {
                        uri: this.objectUri,
                        term: object
                    },
                    {
                        uri: this.graphUri,
                        term: graph
                    }
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        // If bindingsRestricted, also pass variables, so the server knows how to bind values.
                        if (entry.uri && (this.bindingsRestricted || entry.term.termType !== 'Variable' && (entry.term.termType !== 'Quad' || (0, $ilNtL.everyTermsNested)(entry.term, function(value) {
                            return value.termType !== 'Variable';
                        })))) entries[entry.uri] = (0, $gQYIc.termToString)(entry.term);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return searchForm.getUri(entries);
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph, unionDefaultGraph, context, options) {
                var _this = this;
                // If we are querying the default graph,
                // and the source has an overridden value for the default graph (such as QPF can provide),
                // we override the graph parameter with that value.
                var modifiedGraph = false;
                if (graph.termType === 'DefaultGraph') {
                    if (this.defaultGraph) {
                        modifiedGraph = true;
                        graph = this.defaultGraph;
                    } else if (Object.keys(this.searchForm.mappings).length === 4 && !this.defaultGraph) {
                        // If the sd:defaultGraph is not declared on a QPF endpoint
                        if (unionDefaultGraph) // With union-default-graph, take union of graphs.
                        graph = this.dataFactory.variable('g');
                        else {
                            // Without union-default-graph, the default graph must be empty.
                            var quads = new $aafx9.ArrayIterator([], {
                                autoStart: false
                            });
                            quads.setProperty('metadata', {
                                state: new $jZbVy.MetadataValidationState(),
                                requestTime: 0,
                                cardinality: {
                                    type: 'exact',
                                    value: 0
                                },
                                first: null,
                                next: null,
                                last: null
                            });
                            return quads;
                        }
                    } else if (Object.keys(this.searchForm.mappings).length === 3) // If have a TPF endpoint, set graph to variable so we could get the cached triples
                    graph = this.dataFactory.variable('g');
                }
                // Try to emit from cache (skip if filtering bindings)
                if (!(options === null || options === void 0 ? void 0 : options.filterBindings)) {
                    var cached = this.getCachedQuads(subject, predicate, object, graph);
                    if (cached) return cached;
                }
                // Kickstart metadata collection, because the quads iterator is lazy
                // eslint-disable-next-line ts/no-this-alias
                var self = this;
                var quads1;
                var dataStreamPromise = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var _dereferenceRdfOutput_metadata, url, dereferenceRdfOutput, rdfMetadataOuput, metadata;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    url = self.createFragmentUri(self.searchForm, subject, predicate, object, graph);
                                    if (!(options === null || options === void 0 ? void 0 : options.filterBindings)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        self.getBindingsRestrictedLink(subject, predicate, object, graph, url, options.filterBindings)
                                    ];
                                case 1:
                                    url = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        self.mediatorDereferenceRdf.mediate({
                                            context: context,
                                            url: url
                                        })
                                    ];
                                case 3:
                                    dereferenceRdfOutput = _state.sent();
                                    url = dereferenceRdfOutput.url;
                                    return [
                                        4,
                                        self.mediatorMetadata.mediate({
                                            context: context,
                                            url: url,
                                            quads: dereferenceRdfOutput.data,
                                            triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
                                        })
                                    ];
                                case 4:
                                    rdfMetadataOuput = _state.sent();
                                    return [
                                        4,
                                        self.mediatorMetadataExtract.mediate({
                                            context: context,
                                            url: url,
                                            metadata: rdfMetadataOuput.metadata,
                                            requestTime: dereferenceRdfOutput.requestTime
                                        })
                                    ];
                                case 5:
                                    metadata = _state.sent().metadata;
                                    quads1.setProperty('metadata', (0, $emQHU._)((0, $iT0je._)({}, metadata), {
                                        state: new $jZbVy.MetadataValidationState(),
                                        subsetOf: self.url
                                    }));
                                    // While we could resolve this before metadata extraction, we do it afterwards to ensure metadata emission
                                    // before the end event is emitted.
                                    return [
                                        2,
                                        rdfMetadataOuput.data
                                    ];
                            }
                        });
                    })();
                }();
                quads1 = new $aafx9.TransformIterator(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var dataStream, actualDefaultGraph, filteredOutput;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        dataStreamPromise
                                    ];
                                case 1:
                                    dataStream = _state.sent();
                                    // The server is free to send any data in its response (such as metadata),
                                    // including quads that do not match the given matter.
                                    // Therefore, we have to filter away all non-matching quads here.
                                    actualDefaultGraph = this.dataFactory.defaultGraph();
                                    filteredOutput = (0, $aafx9.wrap)(dataStream).transform({
                                        filter: function(quad) {
                                            if ((0, $ilNtL.matchPattern)(quad, subject, predicate, object, graph)) return true;
                                            // Special case: if we are querying in the default graph, and we had an overridden default graph,
                                            // also accept that incoming triples may be defined in the actual default graph
                                            return modifiedGraph && (0, $ilNtL.matchPattern)(quad, subject, predicate, object, actualDefaultGraph);
                                        }
                                    });
                                    if (modifiedGraph || graph.termType === 'Variable') // Reverse-map the overridden default graph back to the actual default graph
                                    filteredOutput = this.reverseMapQuadsToDefaultGraph(filteredOutput);
                                    return [
                                        2,
                                        filteredOutput
                                    ];
                            }
                        });
                    }).call(_this);
                }, {
                    autoStart: false
                });
                // Skip cache if filtering bindings
                if (options === null || options === void 0 ? void 0 : options.filterBindings) return quads1;
                this.cacheQuads(quads1, subject, predicate, object, graph);
                return this.getCachedQuads(subject, predicate, object, graph);
            }
        },
        {
            key: "getBindingsRestrictedLink",
            value: /**
     * If we add bindings for brTPF, append it to the URL.
     * We have to hardcode this because brTPF doesn't expose a URL template for passing bindings.
     * @param subject The subject.
     * @param predicate The predicate.
     * @param object The object.
     * @param graph The graph.
     * @param url The original QPF URL.
     * @param filterBindings The bindings to restrict with.
     * @param filterBindings.bindings The bindings stream.
     * @param filterBindings.metadata The bindings metadata.
     * @protected
     */ function getBindingsRestrictedLink(subject, predicate, object, graph, url, filterBindings) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var values, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, binding, value, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, variable, term, err, valuesUrl;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Determine values
                                values = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                return [
                                    4,
                                    filterBindings.bindings.toArray()
                                ];
                            case 2:
                                _iterator = _state.sent()[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                binding = _step.value;
                                value = [
                                    '('
                                ];
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = filterBindings.metadata.variables[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        variable = _step1.value;
                                        term = binding.get(variable.variable);
                                        value.push(term ? (0, $3veIK.termToString)(term) : 'UNDEF');
                                        value.push(' ');
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                value.push(')');
                                values.push(value.join(''));
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                if (values.length === 0) // This is a hack to force an empty result page,
                                // because the brTPF server returns a server error when passing 0 bindings.
                                values.push('(<ex:comunica:unknown>)');
                                // Append to URL (brTPF uses the SPARQL VALUES syntax, without the VALUES prefix)
                                valuesUrl = encodeURIComponent("(".concat(filterBindings.metadata.variables.map(function(variable) {
                                    return "?".concat(variable.variable.value);
                                }).join(' '), ") { ").concat(values.join(' '), " }"));
                                return [
                                    2,
                                    "".concat(url, "&values=").concat(valuesUrl)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reverseMapQuadsToDefaultGraph",
            value: function reverseMapQuadsToDefaultGraph(quads) {
                var _this = this;
                var actualDefaultGraph = this.dataFactory.defaultGraph();
                return quads.map(function(quad) {
                    return (0, $ilNtL.mapTerms)(quad, function(term, key) {
                        return key === 'graph' && term.equals(_this.defaultGraph) ? actualDefaultGraph : term;
                    });
                });
            }
        },
        {
            key: "getPatternId",
            value: function getPatternId(subject, predicate, object, graph) {
                return JSON.stringify({
                    s: subject.termType === 'Variable' ? '' : $3ecddebc09c30e75$var$_termToString(subject),
                    p: predicate.termType === 'Variable' ? '' : $3ecddebc09c30e75$var$_termToString(predicate),
                    o: object.termType === 'Variable' ? '' : $3ecddebc09c30e75$var$_termToString(object),
                    g: graph.termType === 'Variable' ? '' : $3ecddebc09c30e75$var$_termToString(graph)
                });
            }
        },
        {
            key: "cacheQuads",
            value: function cacheQuads(quads, subject, predicate, object, graph) {
                var patternId = this.getPatternId(subject, predicate, object, graph);
                this.cachedQuads[patternId] = quads.clone();
            }
        },
        {
            key: "getCachedQuads",
            value: function getCachedQuads(subject, predicate, object, graph) {
                var patternId = this.getPatternId(subject, predicate, object, graph);
                var quads = this.cachedQuads[patternId];
                if (quads) return quads.clone();
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(_operation, _context) {
                throw new Error('queryQuads is not implemented in QuerySourceQpf');
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(_operation, _context) {
                throw new Error('queryBoolean is not implemented in QuerySourceQpf');
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(_operation, _context) {
                throw new Error('queryVoid is not implemented in QuerySourceQpf');
            }
        }
    ]);
    return QuerySourceQpf;
}();
module.exports.QuerySourceQpf = $3ecddebc09c30e75$var$QuerySourceQpf;
function $3ecddebc09c30e75$var$_termToString(term) {
    return term.termType === 'DefaultGraph' ? // Any character that cannot be present in a URL will do
    '|' : (0, $gQYIc.termToString)(term);
}

});
parcelRegister("eznfg", function(module, exports) {
"use strict";
var $a9b65d96c0e72f8f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9b65d96c0e72f8f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9b65d96c0e72f8f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9b65d96c0e72f8f$var$__exportStar((parcelRequire("h3Hcj")), module.exports);

$a9b65d96c0e72f8f$var$__exportStar((parcelRequire("8sVZn")), module.exports);

});
parcelRegister("h3Hcj", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentify = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for query-source-identify events.
 *
 * Actor types:
 * * Input:  IActionQuerySourceIdentify:      An unidentified query source.
 * * Test:   <none>
 * * Output: IActorQuerySourceIdentifyOutput: An identified query source.
 *
 * @see IActionQuerySourceIdentify
 * @see IActorQuerySourceIdentifyOutput
 */ var $c6b4399ce721a4df$var$ActorQuerySourceIdentify = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorQuerySourceIdentify, _core_1_Actor);
    function ActorQuerySourceIdentify(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentify);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentify, [
            args
        ]);
    }
    return ActorQuerySourceIdentify;
}($kNNoa.Actor);
module.exports.ActorQuerySourceIdentify = $c6b4399ce721a4df$var$ActorQuerySourceIdentify;

});

parcelRegister("8sVZn", function(module, exports) {

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterMatchingQuotedQuads = module.exports.quadsOrderToBindingsOrder = module.exports.quadsMetadataToBindingsMetadata = module.exports.setMetadata = module.exports.getDuplicateElementLinks = module.exports.getVariables = module.exports.isTermVariable = module.exports.quadsToBindings = void 0;

var $kQuvF = parcelRequire("kQuvF");

var $jZbVy = parcelRequire("jZbVy");

var $gQYIc = parcelRequire("gQYIc");

var $ilNtL = parcelRequire("ilNtL");

var $6NEcM = parcelRequire("6NEcM");
/**
 * Convert an iterator of quads to an iterator of bindings.
 * @param quads The quads to convert.
 * @param pattern The pattern to get variables from to determine bindings.
 *                All quads are also assumed to match the pattern.
 * @param dataFactory The data factory.
 * @param bindingsFactory The factory for creating bindings.
 * @param unionDefaultGraph If union default graph mode is enabled.
 *                          If true, variable graphs will match all graphs, including the default graph.
 *                          If false, variable graphs will only match named graphs, and not the default graph.
 */ function $629deba0c0a8afb0$var$quadsToBindings(quads, pattern, dataFactory, bindingsFactory, unionDefaultGraph) {
    var variables = $629deba0c0a8afb0$var$getVariables(pattern);
    // If non-default-graph triples need to be filtered out
    var filterNonDefaultQuads = pattern.graph.termType === 'Variable' && !unionDefaultGraph;
    // Detect duplicate variables in the pattern
    var duplicateElementLinks = $629deba0c0a8afb0$var$getDuplicateElementLinks(pattern);
    // Convenience datastructure for mapping quad elements to variables
    var elementVariables = (0, $ilNtL.reduceTermsNested)(pattern, function(acc, term, keys) {
        if (term.termType === 'Variable') acc[keys.join('_')] = term.value;
        return acc;
    }, {});
    // Optionally filter, and construct bindings
    var filteredOutput = quads;
    // SPARQL query semantics allow graph variables to only match with named graphs, excluding the default graph
    // But this is not the case when using union default graph semantics
    if (filterNonDefaultQuads) filteredOutput = filteredOutput.filter(function(quad) {
        return quad.graph.termType !== 'DefaultGraph';
    });
    // If there are duplicate variables in the search pattern,
    // make sure that we filter out the triples that don't have equal values for those triple elements,
    // as the rdf-resolve-quad-pattern bus ignores variable names.
    if (duplicateElementLinks) filteredOutput = filteredOutput.filter(function(quad) {
        for(var keyLeft in duplicateElementLinks){
            var keysLeft = keyLeft.split('_');
            var valueLeft = (0, $ilNtL.getValueNestedPath)(quad, keysLeft);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = duplicateElementLinks[keyLeft][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var keysRight = _step.value;
                    if (!valueLeft.equals((0, $ilNtL.getValueNestedPath)(quad, keysRight))) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return true;
    });
    // Wrap it in a ClosableIterator, so we can propagate destroy calls
    var it = new $kQuvF.ClosableIterator(filteredOutput.map(function(quad) {
        return bindingsFactory.bindings(Object.keys(elementVariables).map(function(key) {
            var keys = key.split('_');
            var variable = elementVariables[key];
            var term = (0, $ilNtL.getValueNestedPath)(quad, keys);
            return [
                dataFactory.variable(variable),
                term
            ];
        }));
    }), {
        onClose: function() {
            return quads.destroy();
        }
    });
    // Set the metadata property
    $629deba0c0a8afb0$var$setMetadata(dataFactory, it, quads, elementVariables, variables, filterNonDefaultQuads || Boolean(duplicateElementLinks));
    return it;
}
module.exports.quadsToBindings = $629deba0c0a8afb0$var$quadsToBindings;
/**
 * Check if a term is a variable.
 * @param {RDF.Term} term An RDF term.
 * @return {any} If the term is a variable or blank node.
 */ function $629deba0c0a8afb0$var$isTermVariable(term) {
    return term.termType === 'Variable';
}
module.exports.isTermVariable = $629deba0c0a8afb0$var$isTermVariable;
/**
 * Get all variables in the given pattern.
 * No duplicates are returned.
 * @param {RDF.BaseQuad} pattern A quad pattern.
 */ function $629deba0c0a8afb0$var$getVariables(pattern) {
    return (0, $ilNtL.uniqTerms)((0, $ilNtL.getTermsNested)(pattern).filter($629deba0c0a8afb0$var$isTermVariable));
}
module.exports.getVariables = $629deba0c0a8afb0$var$getVariables;
/**
 * A helper function to find a hash with quad elements that have duplicate variables.
 *
 * @param {RDF.Quad} pattern A quad pattern.
 *
 * @return {{[p: string]: string[]}} If no equal variable names are present in the four terms, this returns undefined.
 *                                   Otherwise, this maps quad elements paths (['subject'], ['predicate'], ['object'],
 *                                   ['graph'])
 *                                   to the list of quad elements it shares a variable name with.
 *                                   For quoted triples, paths such as ['subject', 'object'] may occur.
 *                                   If no links for a certain element exist, this element will
 *                                   not be included in the hash.
 *                                   Note 1: Quad elements will never have a link to themselves.
 *                                           So this can never occur: { subject: [[ 'subject']] },
 *                                           instead 'null' would be returned.
 *                                   Note 2: Links only exist in one direction,
 *                                           this means that { subject: [[ 'predicate']], predicate: [[ 'subject' ]] }
 *                                           will not occur, instead only { subject: [[ 'predicate']] }
 *                                           will be returned.
 *                                   Note 3: Keys can also be paths, but they are delimited by '_', such as:
 *                                           { subject_object_subject: [[ 'predicate']] }
 */ function $629deba0c0a8afb0$var$getDuplicateElementLinks(pattern) {
    // Collect a variable to quad elements mapping.
    var variableElements = {};
    var duplicateVariables = false;
    (0, $ilNtL.forEachTermsNested)(pattern, function(value, keys) {
        if (value.termType === 'Variable') {
            var val = (0, $gQYIc.termToString)(value);
            var length = (variableElements[val] || (variableElements[val] = [])).push(keys);
            duplicateVariables = duplicateVariables || length > 1;
        }
    });
    if (!duplicateVariables) return;
    // Collect quad element to elements with equal variables mapping.
    var duplicateElementLinks = {};
    for(var variable in variableElements){
        var elements = variableElements[variable];
        var remainingElements = elements.slice(1);
        // Only store the elements that have at least one equal element.
        if (remainingElements.length > 0) duplicateElementLinks[elements[0].join('_')] = remainingElements;
    }
    return duplicateElementLinks;
}
module.exports.getDuplicateElementLinks = $629deba0c0a8afb0$var$getDuplicateElementLinks;
/**
 * Set the metadata of the bindings stream derived from the metadata of the quads stream.
 * @param dataFactory The data factory.
 * @param {BindingsStream} bindings The bindings stream that will receive the metadata property.
 * @param {AsyncIterator<Quad>} quads The quads stream that is guaranteed to emit the metadata property.
 * @param elementVariables Mapping of quad term name to variable name.
 * @param variables Variables to include in the metadata
 * @param forceEstimateCardinality Set the cardinality to estimate
 * @return {() => Promise<{[p: string]: any}>} A lazy promise behind a callback resolving to a metadata object.
 */ function $629deba0c0a8afb0$var$setMetadata(dataFactory, bindings, quads, elementVariables, variables, forceEstimateCardinality) {
    var getMetadataCb = function(metadataRaw) {
        if (forceEstimateCardinality) metadataRaw.cardinality.type = 'estimate';
        bindings.setProperty('metadata', $629deba0c0a8afb0$var$quadsMetadataToBindingsMetadata(dataFactory, (0, $jZbVy.validateMetadataQuads)(metadataRaw), elementVariables, variables));
        // Propagate metadata invalidations
        if (metadataRaw.state) metadataRaw.state.addInvalidateListener(function() {
            $629deba0c0a8afb0$var$setMetadata(dataFactory, bindings, quads, elementVariables, variables, forceEstimateCardinality);
        });
    };
    var metadata = quads.getProperty('metadata');
    if (metadata) // This is to enforce sync metadata setting, because AsyncIterator will always call it async,
    // even if the property was already defined.
    getMetadataCb(metadata);
    else quads.getProperty('metadata', getMetadataCb);
}
module.exports.setMetadata = $629deba0c0a8afb0$var$setMetadata;
/**
 * Convert the metadata of quads to the metadata of bindings.
 * @param dataFactory The data factory.
 * @param metadataQuads Quads metadata.
 * @param elementVariables A mapping from quad elements to variables.
 * @param variables The variables in the bindings.
 */ function $629deba0c0a8afb0$var$quadsMetadataToBindingsMetadata(dataFactory, metadataQuads, elementVariables, variables) {
    return (0, $emQHU._)((0, $iT0je._)({}, metadataQuads), {
        order: metadataQuads.order ? $629deba0c0a8afb0$var$quadsOrderToBindingsOrder(dataFactory, metadataQuads.order, elementVariables) : undefined,
        availableOrders: metadataQuads.availableOrders ? metadataQuads.availableOrders.map(function(orderDef) {
            return {
                cost: orderDef.cost,
                terms: $629deba0c0a8afb0$var$quadsOrderToBindingsOrder(dataFactory, orderDef.terms, elementVariables)
            };
        }) : undefined,
        variables: variables.map(function(variable) {
            return {
                variable: variable,
                canBeUndef: false
            };
        })
    });
}
module.exports.quadsMetadataToBindingsMetadata = $629deba0c0a8afb0$var$quadsMetadataToBindingsMetadata;
/**
 * Convert the quads order metadata element to a bindings order metadata element.
 * @param dataFactory The data factory.
 * @param quadsOrder Quads order.
 * @param elementVariables A mapping from quad elements to variables.
 */ function $629deba0c0a8afb0$var$quadsOrderToBindingsOrder(dataFactory, quadsOrder, elementVariables) {
    var mappedVariables = {};
    return quadsOrder.map(function(entry) {
        // Omit entries that do not map to a variable
        var variableName = elementVariables[entry.term];
        if (!variableName) // eslint-disable-next-line array-callback-return
        return;
        // Omit entries that have been mapped already
        if (mappedVariables[variableName]) // eslint-disable-next-line array-callback-return
        return;
        mappedVariables[variableName] = true;
        return {
            term: dataFactory.variable(variableName),
            direction: entry.direction
        };
    }).filter(Boolean);
}
module.exports.quadsOrderToBindingsOrder = $629deba0c0a8afb0$var$quadsOrderToBindingsOrder;
/**
 * Perform post-match-filtering if the source does not support quoted triple filtering,
 * but we have a variable inside a quoted triple.
 * @param pattern The current quad pattern operation.
 * @param it The iterator to filter.
 */ function $629deba0c0a8afb0$var$filterMatchingQuotedQuads(pattern, it) {
    if ((0, $ilNtL.someTerms)(pattern, function(term) {
        return term.termType === 'Quad';
    })) it = it.filter(function(quad) {
        return (0, $6NEcM.matchPatternMappings)(quad, pattern);
    });
    return it;
}
module.exports.filterMatchingQuotedQuads = $629deba0c0a8afb0$var$filterMatchingQuotedQuads;

});





parcelRegister("lFMRA", function(module, exports) {
"use strict";
var $fc735486f510d407$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fc735486f510d407$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fc735486f510d407$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fc735486f510d407$var$__exportStar((parcelRequire("idTr1")), module.exports);

$fc735486f510d407$var$__exportStar((parcelRequire("ilDBD")), module.exports);

});
parcelRegister("idTr1", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaSparql = void 0;

var $cutHr = parcelRequire("cutHr");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $hSHd8 = parcelRequire("hSHd8");

var $ilDBD = parcelRequire("ilDBD");
/**
 * A comunica SPARQL Query Source Identify Hypermedia Actor.
 */ var $d4447119f3252299$var$ActorQuerySourceIdentifyHypermediaSparql = /*#__PURE__*/ function(_bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyHypermediaSparql, _bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia);
    function ActorQuerySourceIdentifyHypermediaSparql(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyHypermediaSparql);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifyHypermediaSparql, [
            args,
            'sparql'
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyHypermediaSparql, [
        {
            key: "testMetadata",
            value: function testMetadata(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!action.forceSourceType && !this.forceSourceType && !action.metadata.sparqlService && !(this.checkUrlSuffix && (action.url.endsWith('/sparql') || action.url.endsWith('/sparql/')))) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " could not detect a SPARQL service description or URL ending on /sparql."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                filterFactor: 1
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_context_get, dataFactory, algebraFactory, isSingularSource, _action_forceSourceType, source, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.logInfo(action.context, "Identified ".concat(action.url, " as sparql source with service URL: ").concat(action.metadata.sparqlService || action.url));
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                isSingularSource = ((_action_context_get = action.context.get($9nBhR.KeysQueryOperation.querySources)) === null || _action_context_get === void 0 ? void 0 : _action_context_get.length) === 1;
                                _1 = (_ = $ilDBD.QuerySourceSparql).bind;
                                _tmp = [
                                    void 0,
                                    ((_action_forceSourceType = action.forceSourceType) !== null && _action_forceSourceType !== void 0 ? _action_forceSourceType : this.forceSourceType) ? action.url : action.metadata.sparqlService || action.url,
                                    action.context,
                                    this.mediatorHttp,
                                    this.bindMethod,
                                    dataFactory,
                                    algebraFactory
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                source = new (_1.apply(_, _tmp.concat([
                                    _state.sent(),
                                    this.forceHttpGet,
                                    this.cacheSize,
                                    this.countTimeout,
                                    // Cardinalities can be infinity when we're querying just a single source.
                                    this.cardinalityCountQueries && !isSingularSource,
                                    this.cardinalityEstimateConstruction,
                                    action.metadata.defaultGraph,
                                    action.metadata.unionDefaultGraph,
                                    action.metadata.datasets
                                ])));
                                return [
                                    2,
                                    {
                                        source: source
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyHypermediaSparql;
}($cutHr.ActorQuerySourceIdentifyHypermedia);
module.exports.ActorQuerySourceIdentifyHypermediaSparql = $d4447119f3252299$var$ActorQuerySourceIdentifyHypermediaSparql;

});
parcelRegister("ilDBD", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceSparql = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $8MpqH = parcelRequire("8MpqH");

var $h8bIc = parcelRequire("h8bIc");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");
var $d5b8e91432de9716$var$QuerySourceSparql = /*#__PURE__*/ function() {
    function QuerySourceSparql(url, context, mediatorHttp, bindMethod, dataFactory, algebraFactory, bindingsFactory, forceHttpGet, cacheSize, countTimeout, cardinalityCountQueries, cardinalityEstimateConstruction, defaultGraph, unionDefaultGraph, datasets) {
        var _this = this;
        (0, $jGAMp._)(this, QuerySourceSparql);
        this.referenceValue = url;
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
        this.bindMethod = bindMethod;
        this.dataFactory = dataFactory;
        this.algebraFactory = algebraFactory;
        this.bindingsFactory = bindingsFactory;
        this.endpointFetcher = new $8MpqH.SparqlEndpointFetcher({
            method: forceHttpGet ? 'GET' : 'POST',
            fetch: function(input, init) {
                return _this.mediatorHttp.mediate({
                    input: input,
                    init: init,
                    context: _this.lastSourceContext
                });
            },
            prefixVariableQuestionMark: true,
            dataFactory: dataFactory
        });
        this.cache = cacheSize > 0 ? new $h8bIc.LRUCache({
            max: cacheSize
        }) : undefined;
        this.countTimeout = countTimeout;
        this.cardinalityCountQueries = cardinalityCountQueries;
        this.cardinalityEstimateConstruction = cardinalityEstimateConstruction;
        this.defaultGraph = defaultGraph;
        this.unionDefaultGraph = unionDefaultGraph !== null && unionDefaultGraph !== void 0 ? unionDefaultGraph : false;
        this.datasets = datasets;
    }
    (0, $byiyg._)(QuerySourceSparql, [
        {
            key: "getSelectorShape",
            value: function getSelectorShape() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            QuerySourceSparql.SELECTOR_SHAPE
                        ];
                    });
                })();
            }
        },
        {
            key: "queryBindings",
            value: function queryBindings(operationIn, context, options) {
                var _this = this;
                // If bindings are passed, modify the operations
                var operationPromise;
                if (options === null || options === void 0 ? void 0 : options.joinBindings) operationPromise = QuerySourceSparql.addBindingsToOperation(this.algebraFactory, this.bindMethod, operationIn, options.joinBindings);
                else operationPromise = Promise.resolve(operationIn);
                var bindings = new $aafx9.TransformIterator(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var operation, variables, queryString, queryFormat, selectQuery, undefVariables;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        operationPromise
                                    ];
                                case 1:
                                    operation = _state.sent();
                                    variables = $hSHd8.Util.inScopeVariables(operation);
                                    queryString = context.get($9nBhR.KeysInitQuery.queryString);
                                    queryFormat = context.getSafe($9nBhR.KeysInitQuery.queryFormat);
                                    selectQuery = !(options === null || options === void 0 ? void 0 : options.joinBindings) && queryString && queryFormat.language === 'sparql' ? queryString : QuerySourceSparql.operationToSelectQuery(this.algebraFactory, operation, variables);
                                    undefVariables = QuerySourceSparql.getOperationUndefs(operation);
                                    return [
                                        2,
                                        this.queryBindingsRemote(this.url, selectQuery, variables, context, undefVariables)
                                    ];
                            }
                        });
                    }).call(_this);
                }, {
                    autoStart: false
                });
                this.attachMetadata(bindings, context, operationPromise);
                return bindings;
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(operation, context) {
                this.lastSourceContext = this.context.merge(context);
                var _context_get;
                var rawStream = this.endpointFetcher.fetchTriples(this.url, (_context_get = context.get($9nBhR.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : QuerySourceSparql.operationToQuery(operation));
                this.lastSourceContext = undefined;
                var quads = (0, $aafx9.wrap)(rawStream, {
                    autoStart: false,
                    maxBufferSize: Number.POSITIVE_INFINITY
                });
                this.attachMetadata(quads, context, Promise.resolve(operation.input));
                return quads;
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(operation, context) {
                this.lastSourceContext = this.context.merge(context);
                var _context_get;
                var promise = this.endpointFetcher.fetchAsk(this.url, (_context_get = context.get($9nBhR.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : QuerySourceSparql.operationToQuery(operation));
                this.lastSourceContext = undefined;
                return promise;
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(operation, context) {
                this.lastSourceContext = this.context.merge(context);
                var _context_get;
                var promise = this.endpointFetcher.fetchUpdate(this.url, (_context_get = context.get($9nBhR.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : QuerySourceSparql.operationToQuery(operation));
                this.lastSourceContext = undefined;
                return promise;
            }
        },
        {
            key: "attachMetadata",
            value: function attachMetadata(target, context, operationPromise) {
                var _this = this;
                // Emit metadata containing the estimated count
                var variablesCount = [];
                // eslint-disable-next-line no-async-promise-executor,ts/no-misused-promises
                new Promise(function(resolve, reject) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var _this, _this_cache, operation, variablesScoped, countQuery, undefVariables, cachedCardinality, localEstimate, _this_cache1, timeoutHandler, varCount, bindingsStream, error;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        ,
                                        7
                                    ]);
                                    return [
                                        4,
                                        operationPromise
                                    ];
                                case 2:
                                    operation = _state.sent();
                                    variablesScoped = $hSHd8.Util.inScopeVariables(operation);
                                    countQuery = this.operationToNormalizedCountQuery(operation);
                                    undefVariables = QuerySourceSparql.getOperationUndefs(operation);
                                    variablesCount = variablesScoped.map(function(variable) {
                                        return {
                                            variable: variable,
                                            canBeUndef: undefVariables.some(function(undefVariable) {
                                                return undefVariable.equals(variable);
                                            })
                                        };
                                    });
                                    cachedCardinality = (_this_cache = this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.get(countQuery);
                                    if (cachedCardinality) return [
                                        2,
                                        resolve(cachedCardinality)
                                    ];
                                    if (!this.cardinalityEstimateConstruction) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        this.estimateOperationCardinality(operation)
                                    ];
                                case 3:
                                    localEstimate = _state.sent();
                                    if (Number.isFinite(localEstimate.value)) {
                                        ;
                                        (_this_cache1 = this.cache) === null || _this_cache1 === void 0 ? void 0 : _this_cache1.set(countQuery, localEstimate);
                                        return [
                                            2,
                                            resolve(localEstimate)
                                        ];
                                    }
                                    _state.label = 4;
                                case 4:
                                    // Don't send count queries if disabled.
                                    if (!this.cardinalityCountQueries) return [
                                        2,
                                        resolve({
                                            type: 'estimate',
                                            value: Number.POSITIVE_INFINITY,
                                            dataset: this.url
                                        })
                                    ];
                                    timeoutHandler = setTimeout(function() {
                                        return resolve({
                                            type: 'estimate',
                                            value: Number.POSITIVE_INFINITY,
                                            dataset: _this.url
                                        });
                                    }, this.countTimeout);
                                    varCount = this.dataFactory.variable('count');
                                    return [
                                        4,
                                        this.queryBindingsRemote(this.url, countQuery, [
                                            varCount
                                        ], context, [])
                                    ];
                                case 5:
                                    bindingsStream = _state.sent();
                                    bindingsStream.on('data', function(bindings) {
                                        clearTimeout(timeoutHandler);
                                        var count = bindings.get(varCount);
                                        var cardinality = {
                                            type: 'estimate',
                                            value: Number.POSITIVE_INFINITY,
                                            dataset: _this.url
                                        };
                                        if (count) {
                                            var cardinalityValue = Number.parseInt(count.value, 10);
                                            if (!Number.isNaN(cardinalityValue)) {
                                                var _this_cache;
                                                cardinality.type = 'exact';
                                                cardinality.value = cardinalityValue;
                                                (_this_cache = _this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.set(countQuery, cardinality);
                                            }
                                        }
                                        return resolve(cardinality);
                                    });
                                    bindingsStream.on('error', function() {
                                        clearTimeout(timeoutHandler);
                                        resolve({
                                            type: 'estimate',
                                            value: Number.POSITIVE_INFINITY,
                                            dataset: _this.url
                                        });
                                    });
                                    bindingsStream.on('end', function() {
                                        clearTimeout(timeoutHandler);
                                        resolve({
                                            type: 'estimate',
                                            value: Number.POSITIVE_INFINITY,
                                            dataset: _this.url
                                        });
                                    });
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    error = _state.sent();
                                    return [
                                        2,
                                        reject(error)
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }).then(function(cardinality) {
                    target.setProperty('metadata', {
                        state: new $jZbVy.MetadataValidationState(),
                        cardinality: cardinality,
                        variables: variablesCount
                    });
                })["catch"](function() {
                    return target.setProperty('metadata', {
                        state: new $jZbVy.MetadataValidationState(),
                        cardinality: {
                            type: 'estimate',
                            value: Number.POSITIVE_INFINITY,
                            dataset: _this.url
                        },
                        variables: variablesCount
                    });
                });
            }
        },
        {
            /**
     * Convert an algebra operation into a query string, and if the operation is a simple triple pattern,
     * then also replace any variables with s, p, and o to increase the chance of cache hits.
     * @param {Algebra.Operation} operation The operation to convert into a query string.
     * @returns {string} Query string for a COUNT query over the operation.
     */ key: "operationToNormalizedCountQuery",
            value: function operationToNormalizedCountQuery(operation) {
                var normalizedOperation = operation.type === $hSHd8.Algebra.types.PATTERN ? this.algebraFactory.createPattern(operation.subject.termType === 'Variable' ? this.dataFactory.variable('s') : operation.subject, operation.predicate.termType === 'Variable' ? this.dataFactory.variable('p') : operation.predicate, operation.object.termType === 'Variable' ? this.dataFactory.variable('o') : operation.object) : operation;
                var operationString = QuerySourceSparql.operationToCountQuery(this.dataFactory, this.algebraFactory, normalizedOperation);
                return operationString;
            }
        },
        {
            key: "estimateOperationCardinality",
            value: /**
     * Performs local cardinality estimation for the specified SPARQL algebra operation, which should
     * result in better estimation performance at the expense of accuracy.
     * @param {Algebra.Operation} operation A query operation.
     */ function estimateOperationCardinality(operation) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataset;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        dataset = {
                            getCardinality: function(operation) {
                                var _this_cache;
                                var queryString = _this.operationToNormalizedCountQuery(operation);
                                var cachedCardinality = (_this_cache = _this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.get(queryString);
                                if (cachedCardinality) return cachedCardinality;
                                if (_this.datasets) {
                                    var cardinalities = _this.datasets.filter(function(ds) {
                                        return _this.unionDefaultGraph || _this.defaultGraph && ds.uri.endsWith(_this.defaultGraph);
                                    }).map(function(ds) {
                                        return (0, $2n9RU.estimateCardinality)(operation, ds);
                                    });
                                    var cardinality = {
                                        type: cardinalities.some(function(card) {
                                            return card.type === 'estimate';
                                        }) ? 'estimate' : 'exact',
                                        value: cardinalities.length > 0 ? cardinalities.reduce(function(acc, card) {
                                            return acc + card.value;
                                        }, 0) : 0,
                                        dataset: _this.url
                                    };
                                    return cardinality;
                                }
                            },
                            source: this.url,
                            uri: this.url
                        };
                        return [
                            2,
                            (0, $2n9RU.estimateCardinality)(operation, dataset)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryBindingsRemote",
            value: /**
     * Send a SPARQL query to a SPARQL endpoint and retrieve its bindings as a stream.
     * @param {string} endpoint A SPARQL endpoint URL.
     * @param {string} query A SPARQL query string.
     * @param {RDF.Variable[]} variables The expected variables.
     * @param {IActionContext} context The source context.
     * @param undefVariables Variables that may have undefs.
     * @return {BindingsStream} A stream of bindings.
     */ function queryBindingsRemote(endpoint, query, variables, context, undefVariables) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, undefVariablesIndex, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, undefVariable, rawStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                // Index undef variables
                                undefVariablesIndex = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = undefVariables[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        undefVariable = _step.value;
                                        undefVariablesIndex.add(undefVariable.value);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.lastSourceContext = this.context.merge(context);
                                return [
                                    4,
                                    this.endpointFetcher.fetchBindings(endpoint, query)
                                ];
                            case 1:
                                rawStream = _state.sent();
                                this.lastSourceContext = undefined;
                                return [
                                    2,
                                    (0, $aafx9.wrap)(rawStream, {
                                        autoStart: false,
                                        maxBufferSize: Number.POSITIVE_INFINITY
                                    }).map(function(rawData) {
                                        return _this.bindingsFactory.bindings(variables.map(function(variable) {
                                            var _core_1_Actor_getContextLogger;
                                            var value = rawData["?".concat(variable.value)];
                                            if (!undefVariablesIndex.has(variable.value) && !value) (_core_1_Actor_getContextLogger = $kNNoa.Actor.getContextLogger(_this.context)) === null || _core_1_Actor_getContextLogger === void 0 ? void 0 : _core_1_Actor_getContextLogger.warn("The endpoint ".concat(endpoint, " failed to provide a binding for ").concat(variable.value, "."));
                                            return [
                                                variable,
                                                value
                                            ];
                                        }).filter(function(param) {
                                            var _param = (0, $32TW8._)(param, 2), _ = _param[0], v = _param[1];
                                            return Boolean(v);
                                        }));
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "QuerySourceSparql(".concat(this.url, ")");
            }
        }
    ], [
        {
            key: "addBindingsToOperation",
            value: /**
     * Create an operation that includes the bindings from the given bindings stream.
     * @param algebraFactory The algebra factory.
     * @param bindMethod A method for adding bindings to an operation.
     * @param operation The operation to bind to.
     * @param addBindings The bindings to add.
     * @param addBindings.bindings The bindings stream.
     * @param addBindings.metadata The bindings metadata.
     */ function addBindingsToOperation(algebraFactory, bindMethod, operation, addBindings) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var bindings;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    addBindings.bindings.toArray()
                                ];
                            case 1:
                                bindings = _state.sent();
                                switch(bindMethod){
                                    case 'values':
                                        return [
                                            2,
                                            algebraFactory.createJoin([
                                                algebraFactory.createValues(addBindings.metadata.variables.map(function(v) {
                                                    return v.variable;
                                                }), bindings.map(function(binding) {
                                                    return Object.fromEntries((0, $7WNf6._)(binding).map(function(param) {
                                                        var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                                        return [
                                                            "?".concat(key.value),
                                                            value
                                                        ];
                                                    }));
                                                })),
                                                operation
                                            ], false)
                                        ];
                                    case 'union':
                                        throw new Error('Not implemented yet: "union" case');
                                    case 'filter':
                                        throw new Error('Not implemented yet: "filter" case');
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "operationToSelectQuery",
            value: /**
     * Convert an operation to a select query for this pattern.
     * @param algebraFactory The algebra factory.
     * @param {Algebra.Operation} operation A query operation.
     * @param {RDF.Variable[]} variables The variables in scope for the operation.
     * @return {string} A select query string.
     */ function operationToSelectQuery(algebraFactory, operation, variables) {
                return QuerySourceSparql.operationToQuery(algebraFactory.createProject(operation, variables));
            }
        },
        {
            key: "operationToCountQuery",
            value: /**
     * Convert an operation to a count query for the number of matching triples for this pattern.
     * @param dataFactory The data factory.
     * @param algebraFactory The algebra factory.
     * @param {Algebra.Operation} operation A query operation.
     * @return {string} A count query string.
     */ function operationToCountQuery(dataFactory, algebraFactory, operation) {
                return QuerySourceSparql.operationToQuery(algebraFactory.createProject(algebraFactory.createExtend(algebraFactory.createGroup(operation, [], [
                    algebraFactory.createBoundAggregate(dataFactory.variable('var0'), 'count', algebraFactory.createWildcardExpression(), false)
                ]), dataFactory.variable('count'), algebraFactory.createTermExpression(dataFactory.variable('var0'))), [
                    dataFactory.variable('count')
                ]));
            }
        },
        {
            key: "operationToQuery",
            value: /**
     * Convert an operation to a query for this pattern.
     * @param {Algebra.Operation} operation A query operation.
     * @return {string} A query string.
     */ function operationToQuery(operation) {
                return (0, $hSHd8.toSparql)(operation, {
                    sparqlStar: true
                });
            }
        },
        {
            key: "getOperationUndefs",
            value: /**
     * Check if the given operation may produce undefined values.
     * @param operation
     */ function getOperationUndefs(operation) {
                var variables = [];
                $hSHd8.Util.recurseOperation(operation, {
                    leftjoin: function(subOperation) {
                        var left = $hSHd8.Util.inScopeVariables(subOperation.input[0]);
                        var right = $hSHd8.Util.inScopeVariables(subOperation.input[1]);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop = function() {
                                var varRight = _step.value;
                                if (!left.some(function(varLeft) {
                                    return varLeft.equals(varRight);
                                })) variables.push(varRight);
                            };
                            for(var _iterator = right[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return false;
                    },
                    values: function(values) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop = function() {
                                var variable = _step.value;
                                if (values.bindings.some(function(bindings) {
                                    return !("?".concat(variable.value) in bindings);
                                })) variables.push(variable);
                            };
                            for(var _iterator = values.variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return false;
                    },
                    union: function(union) {
                        // Determine variables in scope of the union branches that are not occurring in every branch
                        var scopedVariables = union.input.map($hSHd8.Util.inScopeVariables);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop = function() {
                                var variable = _step.value;
                                if (!scopedVariables.every(function(input) {
                                    return input.some(function(inputVar) {
                                        return inputVar.equals(variable);
                                    });
                                })) variables.push(variable);
                            };
                            for(var _iterator = (0, $ilNtL.uniqTerms)(scopedVariables.flat())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return true;
                    }
                });
                return (0, $ilNtL.uniqTerms)(variables);
            }
        }
    ]);
    return QuerySourceSparql;
}();
module.exports.QuerySourceSparql = $d5b8e91432de9716$var$QuerySourceSparql;
$d5b8e91432de9716$var$QuerySourceSparql.SELECTOR_SHAPE = {
    type: 'disjunction',
    children: [
        {
            type: 'operation',
            operation: {
                operationType: 'wildcard'
            },
            joinBindings: true
        }
    ]
};

});
parcelRegister("h8bIc", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $c78c44be4e9e7aab$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $c78c44be4e9e7aab$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $c78c44be4e9e7aab$var$warned = new Set();
/* c8 ignore start */ var $c78c44be4e9e7aab$var$PROCESS = {};
/* c8 ignore start */ var $c78c44be4e9e7aab$var$emitWarning = function(msg, type, code, fn) {
    typeof $c78c44be4e9e7aab$var$PROCESS.emitWarning === 'function' ? $c78c44be4e9e7aab$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $c78c44be4e9e7aab$var$AC = globalThis.AbortController;
var $c78c44be4e9e7aab$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $c78c44be4e9e7aab$var$AC === 'undefined') {
    var $c78c44be4e9e7aab$var$_PROCESS_env;
    //@ts-ignore
    $c78c44be4e9e7aab$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $c78c44be4e9e7aab$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $c78c44be4e9e7aab$var$AS());
            $c78c44be4e9e7aab$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $c78c44be4e9e7aab$var$printACPolyfillWarning = (($c78c44be4e9e7aab$var$_PROCESS_env = $c78c44be4e9e7aab$var$PROCESS.env) === null || $c78c44be4e9e7aab$var$_PROCESS_env === void 0 ? void 0 : $c78c44be4e9e7aab$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $c78c44be4e9e7aab$var$warnACPolyfill = function() {
        if (!$c78c44be4e9e7aab$var$printACPolyfillWarning) return;
        $c78c44be4e9e7aab$var$printACPolyfillWarning = false;
        $c78c44be4e9e7aab$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $c78c44be4e9e7aab$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $c78c44be4e9e7aab$var$shouldWarn = function(code) {
    return !$c78c44be4e9e7aab$var$warned.has(code);
};
var $c78c44be4e9e7aab$var$TYPE = Symbol('type');
var $c78c44be4e9e7aab$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $c78c44be4e9e7aab$var$getUintArray = function(max) {
    return !$c78c44be4e9e7aab$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $c78c44be4e9e7aab$var$ZeroArray : null;
};
/* c8 ignore stop */ var $c78c44be4e9e7aab$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $c78c44be4e9e7aab$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $c78c44be4e9e7aab$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $c78c44be4e9e7aab$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $c78c44be4e9e7aab$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $c78c44be4e9e7aab$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $c78c44be4e9e7aab$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$c78c44be4e9e7aab$var$_max = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_maxSize = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_dispose = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$c78c44be4e9e7aab$var$_size = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_keyMap = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_keyList = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_valList = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_next = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_prev = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_head = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_tail = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_free = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_disposed = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_sizes = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_starts = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_ttls = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$c78c44be4e9e7aab$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $c78c44be4e9e7aab$var$_isStale = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_requireSize = /*#__PURE__*/ new WeakMap(), $c78c44be4e9e7aab$var$_indexes = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_rindexes = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_evict = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_connect = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_delete = /*#__PURE__*/ new WeakSet(), $c78c44be4e9e7aab$var$_clear = /*#__PURE__*/ new WeakSet();
var $c78c44be4e9e7aab$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_indexes);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_rindexes);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_isValidIndex);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_evict);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_backgroundFetch);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_connect);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_moveToTail);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_delete);
        (0, $bA8rW._)(this, $c78c44be4e9e7aab$var$_clear);
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $c78c44be4e9e7aab$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$c78c44be4e9e7aab$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $c78c44be4e9e7aab$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_max, max);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, 0);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, 0);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_free, $c78c44be4e9e7aab$var$Stack.create(max));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_size, 0);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_hasDispose, !!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_dispose));
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize) !== 0) {
                if (!$c78c44be4e9e7aab$var$isPosInt((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$c78c44be4e9e7aab$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_initializeSizeTracking, $c78c44be4e9e7aab$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $c78c44be4e9e7aab$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$c78c44be4e9e7aab$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_initializeTTLTracking, $c78c44be4e9e7aab$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max) && !(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($c78c44be4e9e7aab$var$shouldWarn(code)) {
                $c78c44be4e9e7aab$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $c78c44be4e9e7aab$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i],
                                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i],
                                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($c78c44be4e9e7aab$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes)) entry.size = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $c78c44be4e9e7aab$var$perf.now() - (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes)) entry.size = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $c78c44be4e9e7aab$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) === 0 ? (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail) : (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).length !== 0 ? (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).pop() : (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max) ? (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_evict, $c78c44be4e9e7aab$var$evict).call(this, false) : (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size);
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail)] = index;
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[index] = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail);
                    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, index);
                    (0, $3cNKp._)(this, $c78c44be4e9e7aab$var$_size).value++;
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_moveToTail, $c78c44be4e9e7aab$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $c78c44be4e9e7aab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $c78c44be4e9e7aab$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls)) (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_initializeTTLTracking, $c78c44be4e9e7aab$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $c78c44be4e9e7aab$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size)){
                        var val = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head)];
                        (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_evict, $c78c44be4e9e7aab$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $c78c44be4e9e7aab$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_backgroundFetch, $c78c44be4e9e7aab$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_moveToTail, $c78c44be4e9e7aab$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_backgroundFetch, $c78c44be4e9e7aab$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_moveToTail, $c78c44be4e9e7aab$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_clear, $c78c44be4e9e7aab$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_starts),
                    ttls: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_ttls),
                    sizes: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_keyList),
                    valList: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_valList),
                    next: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_next),
                    prev: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $c78c44be4e9e7aab$var$_backgroundFetch, $c78c44be4e9e7aab$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $c78c44be4e9e7aab$var$_moveToTail, $c78c44be4e9e7aab$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $c78c44be4e9e7aab$var$_indexes, $c78c44be4e9e7aab$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $c78c44be4e9e7aab$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $c78c44be4e9e7aab$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $c78c44be4e9e7aab$var$ZeroArray((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max));
    var starts = new $c78c44be4e9e7aab$var$ZeroArray((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max));
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_ttls, ttls);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_starts, starts);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c78c44be4e9e7aab$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $c78c44be4e9e7aab$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(_this1, (0, $el4bI._)(_this1, $c78c44be4e9e7aab$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $c78c44be4e9e7aab$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $c78c44be4e9e7aab$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $c78c44be4e9e7aab$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $c78c44be4e9e7aab$var$ZeroArray((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_max));
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_sizes, sizes);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $c78c44be4e9e7aab$var$_calculatedSize, (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$c78c44be4e9e7aab$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$c78c44be4e9e7aab$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $c78c44be4e9e7aab$var$_evict, $c78c44be4e9e7aab$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $c78c44be4e9e7aab$var$_calculatedSize, (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_calculatedSize);
        }
    });
}
function $c78c44be4e9e7aab$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isValidIndex, $c78c44be4e9e7aab$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $c78c44be4e9e7aab$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isValidIndex, $c78c44be4e9e7aab$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $c78c44be4e9e7aab$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[index]) === index;
}
function $c78c44be4e9e7aab$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head);
    var k = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[head];
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose) || (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $c78c44be4e9e7aab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) === 1) {
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, 0));
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[head]);
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $c78c44be4e9e7aab$var$_size).value--;
    return head;
}
function $c78c44be4e9e7aab$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $c78c44be4e9e7aab$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $c78c44be4e9e7aab$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $c78c44be4e9e7aab$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $c78c44be4e9e7aab$var$_delete, $c78c44be4e9e7aab$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $c78c44be4e9e7aab$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $c78c44be4e9e7aab$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index] = bf;
    return bf;
}
function $c78c44be4e9e7aab$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $c78c44be4e9e7aab$var$AC;
}
function $c78c44be4e9e7aab$var$connect(p, n) {
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[n] = p;
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[p] = n;
}
function $c78c44be4e9e7aab$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail)) {
        if (index === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head)) (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[index]);
        else (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_connect, $c78c44be4e9e7aab$var$connect).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[index], (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[index]);
        (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_connect, $c78c44be4e9e7aab$var$connect).call(this, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail), index);
        (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, index);
    }
}
function $c78c44be4e9e7aab$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_size) === 1) (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_clear, $c78c44be4e9e7aab$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose) || (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $c78c44be4e9e7aab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_tail)) (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_head)) (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[index];
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[pi] = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_next)[index];
                    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[ni] = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $c78c44be4e9e7aab$var$_size).value--;
                (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $c78c44be4e9e7aab$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $c78c44be4e9e7aab$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_rindexes, $c78c44be4e9e7aab$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $c78c44be4e9e7aab$var$_isBackgroundFetch, $c78c44be4e9e7aab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList)[index];
                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $c78c44be4e9e7aab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyMap).clear();
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts)) {
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_ttls).fill(0);
        (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes)) (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_head, 0);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_tail, 0);
    (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_free).length = 0;
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $c78c44be4e9e7aab$var$_size, 0);
    if ((0, $el4bI._)(this, $c78c44be4e9e7aab$var$_hasDisposeAfter) && (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $c78c44be4e9e7aab$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $c78c44be4e9e7aab$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});




parcelRegister("drZeA", function(module, exports) {
"use strict";
var $9cad4bd7b49f9672$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cad4bd7b49f9672$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9cad4bd7b49f9672$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9cad4bd7b49f9672$var$__exportStar((parcelRequire("krlcC")), module.exports);

});
parcelRegister("krlcC", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaNone = void 0;

var $hbGDL = parcelRequire("hbGDL");

var $cutHr = parcelRequire("cutHr");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $kAqAk = parcelRequire("kAqAk");
/**
 * A comunica None Query Source Identify Hypermedia Actor.
 */ var $ee16c6a0dd6e9b66$var$ActorQuerySourceIdentifyHypermediaNone = /*#__PURE__*/ function(_bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyHypermediaNone, _bus_query_source_identify_hypermedia_1_ActorQuerySourceIdentifyHypermedia);
    function ActorQuerySourceIdentifyHypermediaNone(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyHypermediaNone);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifyHypermediaNone, [
            args,
            'file'
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyHypermediaNone, [
        {
            key: "testMetadata",
            value: function testMetadata(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                filterFactor: 0
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, source, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.logInfo(action.context, "Identified as file source: ".concat(action.url));
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                _1 = (_ = $hbGDL.QuerySourceRdfJs).bind;
                                return [
                                    4,
                                    (0, $kAqAk.storeStream)(action.quads)
                                ];
                            case 1:
                                _tmp = [
                                    void 0,
                                    _state.sent(),
                                    dataFactory
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 2:
                                source = new (_1.apply(_, _tmp.concat([
                                    _state.sent()
                                ])));
                                source.toString = function() {
                                    return "QuerySourceRdfJs(".concat(action.url, ")");
                                };
                                source.referenceValue = action.url;
                                return [
                                    2,
                                    {
                                        source: source
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyHypermediaNone;
}($cutHr.ActorQuerySourceIdentifyHypermedia);
module.exports.ActorQuerySourceIdentifyHypermediaNone = $ee16c6a0dd6e9b66$var$ActorQuerySourceIdentifyHypermediaNone;

});
parcelRegister("hbGDL", function(module, exports) {
"use strict";
var $c8348a40bdddb6cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8348a40bdddb6cb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c8348a40bdddb6cb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c8348a40bdddb6cb$var$__exportStar((parcelRequire("lD1Je")), module.exports);

$c8348a40bdddb6cb$var$__exportStar((parcelRequire("kANr9")), module.exports);

$c8348a40bdddb6cb$var$__exportStar((parcelRequire("3TQfI")), module.exports);

});
parcelRegister("lD1Je", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyRdfJs = void 0;

var $eznfg = parcelRequire("eznfg");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $3TQfI = parcelRequire("3TQfI");
/**
 * A comunica RDFJS Query Source Identify Actor.
 */ var $fbee94b932454898$var$ActorQuerySourceIdentifyRdfJs = /*#__PURE__*/ function(_bus_query_source_identify_1_ActorQuerySourceIdentify) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyRdfJs, _bus_query_source_identify_1_ActorQuerySourceIdentify);
    function ActorQuerySourceIdentifyRdfJs(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyRdfJs);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifyRdfJs, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyRdfJs, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var source;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        source = action.querySourceUnidentified;
                        if (source.type !== undefined && source.type !== 'rdfjs') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " requires a single query source with rdfjs type to be present in the context."))
                        ];
                        if (typeof source.value === 'string' || !('match' in source.value)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " received an invalid rdfjs query source."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, _action_querySourceUnidentified_context, _tmp, _tmp1, _, _1, _tmp2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                _tmp = {};
                                _tmp1 = {};
                                _1 = (_ = $3TQfI.QuerySourceRdfJs).bind;
                                _tmp2 = [
                                    void 0,
                                    action.querySourceUnidentified.value,
                                    dataFactory
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.querySource = (_tmp1.source = new (_1.apply(_, _tmp2.concat([
                                        _state.sent()
                                    ]))), _tmp1.context = (_action_querySourceUnidentified_context = action.querySourceUnidentified.context) !== null && _action_querySourceUnidentified_context !== void 0 ? _action_querySourceUnidentified_context : new $kNNoa.ActionContext(), _tmp1), _tmp)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyRdfJs;
}($eznfg.ActorQuerySourceIdentify);
module.exports.ActorQuerySourceIdentifyRdfJs = $fbee94b932454898$var$ActorQuerySourceIdentifyRdfJs;

});
parcelRegister("3TQfI", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceRdfJs = void 0;

var $eznfg = parcelRequire("eznfg");

var $9nBhR = parcelRequire("9nBhR");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");

var $ilNtL = parcelRequire("ilNtL");

var $hSHd8 = parcelRequire("hSHd8");
var $2d6f0a69e6307533$var$QuerySourceRdfJs = /*#__PURE__*/ function() {
    function QuerySourceRdfJs(source, dataFactory, bindingsFactory) {
        (0, $jGAMp._)(this, QuerySourceRdfJs);
        this.source = source;
        this.referenceValue = source;
        this.dataFactory = dataFactory;
        this.bindingsFactory = bindingsFactory;
        var AF = new $hSHd8.Factory(this.dataFactory);
        this.selectorShape = {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: AF.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o')
            ]
        };
        this.dummyDefaultGraph = this.dataFactory.variable('__comunica:defaultGraph');
    }
    (0, $byiyg._)(QuerySourceRdfJs, [
        {
            key: "getSelectorShape",
            value: function getSelectorShape() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.selectorShape
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "queryBindings",
            value: function queryBindings(operation, context) {
                var _this = this;
                var _this_source_features;
                if (operation.type !== 'pattern') throw new Error("Attempted to pass non-pattern operation '".concat(operation.type, "' to QuerySourceRdfJs"));
                // Check if we're running in union default graph mode
                var unionDefaultGraph = Boolean(context.get($9nBhR.KeysQueryOperation.unionDefaultGraph));
                if (operation.graph.termType === 'DefaultGraph' && unionDefaultGraph) operation.graph = this.dummyDefaultGraph;
                // Get bindings directly if the source allows it
                // This will be more efficient, as it avoids the intermediary quads translation and representation.
                if (this.source.matchBindings) {
                    var rawStream = this.source.matchBindings(this.bindingsFactory, operation.subject, operation.predicate, operation.object, operation.graph);
                    var it = rawStream instanceof $aafx9.AsyncIterator ? rawStream : (0, $aafx9.wrap)(rawStream, {
                        autoStart: false
                    });
                    // Check if non-default-graph triples need to be filtered out.
                    // SPARQL query semantics allow graph variables to only match with named graphs, excluding the default graph
                    // But this is not the case when using union default graph semantics
                    var forceEstimateCardinality = false;
                    if (operation.graph.termType === 'Variable' && !unionDefaultGraph) {
                        forceEstimateCardinality = true;
                        var variable = operation.graph;
                        it = it.filter(function(bindings) {
                            return bindings.get(variable).termType !== 'DefaultGraph';
                        });
                    }
                    // Remove bindings to the dummy __comunica:defaultGraph variable if needed
                    if (operation.graph.equals(this.dummyDefaultGraph)) {
                        it = it.map(function(bindings) {
                            return bindings["delete"](_this.dummyDefaultGraph);
                        });
                        // Restore graph for determining variable metadata
                        operation.graph = this.dataFactory.defaultGraph();
                    }
                    // Determine metadata
                    if (!it.getProperty('metadata')) {
                        var variables = (0, $eznfg.getVariables)(operation).map(function(variable) {
                            return {
                                variable: variable,
                                canBeUndef: false
                            };
                        });
                        this.setMetadata(it, operation, context, forceEstimateCardinality, {
                            variables: variables
                        })["catch"](function(error) {
                            return it.destroy(error);
                        });
                    }
                    return it;
                }
                // Check if the source supports quoted triple filtering
                var quotedTripleFiltering = Boolean((_this_source_features = this.source.features) === null || _this_source_features === void 0 ? void 0 : _this_source_features.quotedTripleFiltering);
                // Create an async iterator from the matched quad stream
                var rawStream1 = this.source.match(QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering));
                var it1 = rawStream1 instanceof $aafx9.AsyncIterator ? rawStream1 : (0, $aafx9.wrap)(rawStream1, {
                    autoStart: false
                });
                // Perform post-match-filtering if the source does not support quoted triple filtering.
                if (!quotedTripleFiltering) it1 = (0, $eznfg.filterMatchingQuotedQuads)(operation, it1);
                // Determine metadata
                if (!it1.getProperty('metadata')) this.setMetadata(it1, operation, context)["catch"](function(error) {
                    return it1.destroy(error);
                });
                // Restore graph for determining variable metadata
                if (operation.graph.equals(this.dummyDefaultGraph)) operation.graph = this.dataFactory.defaultGraph();
                return (0, $eznfg.quadsToBindings)(it1, operation, this.dataFactory, this.bindingsFactory, Boolean(context.get($9nBhR.KeysQueryOperation.unionDefaultGraph)));
            }
        },
        {
            key: "setMetadata",
            value: function setMetadata(_0, _1, _2) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(it, operation, context) {
                    var _this, forceEstimateCardinality, extraMetadata, _this_source_features, quotedTripleFiltering, unionDefaultGraph, cardinality, i, wouldRequirePostFiltering;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                forceEstimateCardinality = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false, extraMetadata = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                                // Check if the source supports quoted triple filtering
                                quotedTripleFiltering = Boolean((_this_source_features = this.source.features) === null || _this_source_features === void 0 ? void 0 : _this_source_features.quotedTripleFiltering);
                                // Check if we're running in union default graph mode
                                unionDefaultGraph = Boolean(context.get($9nBhR.KeysQueryOperation.unionDefaultGraph));
                                if (operation.graph.termType === 'DefaultGraph' && unionDefaultGraph) operation.graph = this.dummyDefaultGraph;
                                if (!this.source.countQuads) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.source.countQuads(QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering))
                                ];
                            case 1:
                                // If the source provides a dedicated method for determining cardinality, use that.
                                cardinality = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                // Otherwise, fallback to a sub-optimal alternative where we just call match again to count the quads.
                                // WARNING: we can NOT reuse the original data stream here,
                                // because we may lose data elements due to things happening async.
                                i = 0;
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        var matches = _this.source.match(QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering));
                                        matches.on('error', reject);
                                        matches.on('end', function() {
                                            return resolve(i);
                                        });
                                        matches.on('data', function() {
                                            return i++;
                                        });
                                    })
                                ];
                            case 3:
                                cardinality = _state.sent();
                                _state.label = 4;
                            case 4:
                                // If `match` would require filtering afterwards, our count will be an over-estimate.
                                wouldRequirePostFiltering = !quotedTripleFiltering && (0, $ilNtL.someTerms)(operation, function(term) {
                                    return term.termType === 'Quad';
                                }) || QuerySourceRdfJs.hasDuplicateVariables(operation);
                                it.setProperty('metadata', (0, $iT0je._)({
                                    state: new $jZbVy.MetadataValidationState(),
                                    cardinality: {
                                        type: wouldRequirePostFiltering || forceEstimateCardinality ? 'estimate' : 'exact',
                                        value: cardinality
                                    },
                                    // Force requestTime to zero, since this will be free for future calls, as we're fully indexed at this stage.
                                    requestTime: 0
                                }, extraMetadata));
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(_operation, _context) {
                throw new Error('queryQuads is not implemented in QuerySourceRdfJs');
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(_operation, _context) {
                throw new Error('queryBoolean is not implemented in QuerySourceRdfJs');
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(_operation, _context) {
                throw new Error('queryVoid is not implemented in QuerySourceRdfJs');
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "QuerySourceRdfJs(".concat(this.source.constructor.name, ")");
            }
        }
    ], [
        {
            key: "nullifyVariables",
            value: function nullifyVariables(term, quotedTripleFiltering) {
                return !term || term.termType === 'Variable' || !quotedTripleFiltering && term.termType === 'Quad' && (0, $ilNtL.someTermsNested)(term, function(value) {
                    return value.termType === 'Variable';
                }) ? undefined : term;
            }
        },
        {
            key: "hasDuplicateVariables",
            value: function hasDuplicateVariables(pattern) {
                var variables = (0, $ilNtL.filterTermsNested)(pattern, function(term) {
                    return term.termType === 'Variable';
                });
                return variables.length > 1 && (0, $ilNtL.uniqTerms)(variables).length < variables.length;
            }
        }
    ]);
    return QuerySourceRdfJs;
}();
module.exports.QuerySourceRdfJs = $2d6f0a69e6307533$var$QuerySourceRdfJs;

});


parcelRegister("kANr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("kAqAk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStream = $efcbcaa79787e371$var$storeStream;

var $hCU88 = parcelRequire("hCU88");
/**
 * Import all quads in the given stream into a new RDF store.
 *
 * The whole stream will be consumed for this,
 * and the promise will resolve once the stream's end event is emitted.
 *
 * @param {Stream<Q extends BaseQuad>} stream An RDF stream containing the quads to import into the store.
 * @return {Promise<Store<Q extends BaseQuad>>} A promise resolving to an RDF store.
 */ function $efcbcaa79787e371$var$storeStream(stream) {
    var store = $hCU88.RdfStore.createDefault();
    return new Promise(function(resolve, reject) {
        return store["import"](stream).on('error', reject).once('end', function() {
            return resolve(store);
        });
    });
}

});
parcelRegister("hCU88", function(module, exports) {
"use strict";
var $cd518692259409ff$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd518692259409ff$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd518692259409ff$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd518692259409ff$var$__exportStar((parcelRequire("kc2cE")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("4J2KA")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("ctYJR")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("b7OH2")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("iBswZ")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("izGEL")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("jOL5J")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("75SyU")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("d6idF")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("cX0Zg")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("7Glct")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("6z0Kq")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("e3uKE")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("hdfVO")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("3eNQy")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("djUsB")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("1wE43")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("1piaa")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("4rUME")), module.exports);

$cd518692259409ff$var$__exportStar((parcelRequire("3YJjz")), module.exports);

});
parcelRegister("kc2cE", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DatasetCoreWrapper = void 0;

var $3YJjz = parcelRequire("3YJjz");
/**
 * A DatasetCoreWrapper exposes an RdfStore inside an RDF.DatasetCore.
 */ var $eb36a31a3643843f$var$DatasetCoreWrapper = /*#__PURE__*/ function() {
    function DatasetCoreWrapper(store) {
        (0, $jGAMp._)(this, DatasetCoreWrapper);
        this.store = store;
    }
    (0, $byiyg._)(DatasetCoreWrapper, [
        {
            key: "size",
            get: function get() {
                return this.store.size;
            }
        },
        {
            key: "add",
            value: function add(quad) {
                this.store.addQuad(quad);
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(quad) {
                this.store.removeQuad(quad);
                return this;
            }
        },
        {
            key: "has",
            value: function has(quad) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // eslint-disable-next-line no-unreachable-loop
                    for(var _iterator = this.store.readQuads(quad.subject, quad.predicate, quad.object, quad.graph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var result = _step.value;
                        return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                var newStore = new $3YJjz.RdfStore(this.store.options);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.store.readQuads(subject, predicate, object, graph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quad = _step.value;
                        newStore.addQuad(quad);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new DatasetCoreWrapper(newStore);
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return this.store.readQuads();
            }
        }
    ]);
    return DatasetCoreWrapper;
}();
module.exports.DatasetCoreWrapper = $eb36a31a3643843f$var$DatasetCoreWrapper;

});
parcelRegister("3YJjz", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStore = void 0;

var $aafx9 = parcelRequire("aafx9");

var $a2toU = parcelRequire("a2toU");

var $krcR9 = parcelRequire("krcR9");

var $kc2cE = parcelRequire("kc2cE");

var $iBswZ = parcelRequire("iBswZ");

var $jOL5J = parcelRequire("jOL5J");

var $6z0Kq = parcelRequire("6z0Kq");

var $1piaa = parcelRequire("1piaa");
/**
 * An RDF store allows quads to be stored and fetched, based on one or more customizable indexes.
 */ var $2e5a204173b8338b$var$RdfStore = /*#__PURE__*/ function() {
    function RdfStore(options) {
        (0, $jGAMp._)(this, RdfStore);
        this.features = {
            quotedTripleFiltering: true
        };
        this._size = 0;
        this.options = options;
        this.dataFactory = options.dataFactory;
        this.dictionary = options.dictionary;
        this.indexesWrapped = RdfStore.constructIndexesWrapped(options);
        this.indexesWrappedComponentOrders = this.indexesWrapped.map(function(indexThis) {
            return indexThis.componentOrder;
        });
    }
    (0, $byiyg._)(RdfStore, [
        {
            key: "size",
            get: /**
     * The number of quads in this store.
     */ function get() {
                return this._size;
            }
        },
        {
            /**
     * Add a quad to the store.
     * @param quad An RDF quad.
     * @return boolean If the quad was not yet present in the index.
     */ key: "addQuad",
            value: function addQuad(quad) {
                var quadEncoded = [
                    this.dictionary.encode(quad.subject),
                    this.dictionary.encode(quad.predicate),
                    this.dictionary.encode(quad.object),
                    this.dictionary.encode(quad.graph)
                ];
                var newQuad = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.indexesWrapped[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var indexWrapped = _step.value;
                        // Before sending the quad to the index, make sure its components are ordered corresponding to the index's order.
                        newQuad = indexWrapped.index.set((0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, quadEncoded), true);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (newQuad) {
                    this._size++;
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Remove a quad from the store.
     * @param quad An RDF quad.
     * @return boolean If the quad was present in the index.
     */ key: "removeQuad",
            value: function removeQuad(quad) {
                var quadEncoded = [
                    this.dictionary.encodeOptional(quad.subject),
                    this.dictionary.encodeOptional(quad.predicate),
                    this.dictionary.encodeOptional(quad.object),
                    this.dictionary.encodeOptional(quad.graph)
                ];
                // We can quickly return false if the quad is not present in the dictionary
                // eslint-disable-next-line unicorn/no-useless-undefined
                if (quadEncoded.includes(undefined)) return false;
                var wasPresent = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.indexesWrapped[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var indexWrapped = _step.value;
                        // Before sending the quad to the index, make sure its components are ordered corresponding to the index's order.
                        wasPresent = indexWrapped.index.remove((0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, quadEncoded));
                        if (!wasPresent) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (wasPresent) {
                    this._size--;
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Removes all streamed quads.
     * @param stream A stream of quads
     */ key: "remove",
            value: function remove(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    return _this.removeQuad(quad);
                });
                return stream;
            }
        },
        {
            /**
     * All quads matching the pattern will be removed.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ key: "removeMatches",
            value: function removeMatches(subject, predicate, object, graph) {
                return this.remove(this.match(subject, predicate, object, graph));
            }
        },
        {
            /**
     * Deletes the given named graph.
     * @param graph The graph term or string to match.
     */ key: "deleteGraph",
            value: function deleteGraph(graph) {
                if (typeof graph === 'string') graph = this.dataFactory.namedNode(graph);
                return this.removeMatches(undefined, undefined, undefined, graph);
            }
        },
        {
            /**
     * Import the given stream of quads into the store.
     * @param stream A stream of RDF quads.
     */ key: "import",
            value: function _import(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    return _this.addQuad(quad);
                });
                return stream;
            }
        },
        {
            key: "readQuads",
            value: /**
     * Returns a generator producing all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ function readQuads(subject, predicate, object, graph) {
                var indexesSupportQuotedPatterns, _ref, quadComponents, requireQuotedTripleFiltering, indexWrapped, quadComponentsOrdered, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, decomposedQuad, quad, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Check if our dictionary and our indexes have quoted pattern support
                            indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every(function(wrapped) {
                                return wrapped.index.features.quotedTripleFiltering;
                            });
                            // Construct a quad pattern array
                            _ref = (0, $32TW8._)((0, $1piaa.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns), 2), quadComponents = _ref[0], requireQuotedTripleFiltering = _ref[1];
                            // Determine the best index for this pattern
                            indexWrapped = this.indexesWrapped[(0, $1piaa.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
                            // Re-order the quad pattern based on this best index's component order
                            quadComponentsOrdered = (0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                9,
                                10,
                                11
                            ]);
                            _iterator = indexWrapped.index.find(quadComponentsOrdered)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                8
                            ];
                            decomposedQuad = _step.value;
                            // De-order the resulting quad components into the normal SPOG order for quad creation.
                            quad = this.dataFactory.quad(decomposedQuad[indexWrapped.componentOrderInverse.subject], decomposedQuad[indexWrapped.componentOrderInverse.predicate], decomposedQuad[indexWrapped.componentOrderInverse.object], decomposedQuad[indexWrapped.componentOrderInverse.graph]);
                            if (!requireQuotedTripleFiltering) return [
                                3,
                                5
                            ];
                            if (!(0, $krcR9.matchPattern)(quad, subject, predicate, object, graph)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                quad
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            return [
                                4,
                                quad
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 8:
                            return [
                                3,
                                11
                            ];
                        case 9:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                11
                            ];
                        case 10:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 11:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Returns an array containing all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ key: "getQuads",
            value: function getQuads(subject, predicate, object, graph) {
                return (0, $7WNf6._)(this.readQuads(subject, predicate, object, graph));
            }
        },
        {
            /**
     * Returns a stream that produces all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ key: "match",
            value: function match(subject, predicate, object, graph) {
                return (0, $aafx9.wrap)(this.readQuads(subject, predicate, object, graph));
            }
        },
        {
            key: "readBindings",
            value: /**
     * Returns a generator producing all quads matching the pattern.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ function readBindings(bindingsFactory, subject, predicate, object, graph) {
                var indexesSupportQuotedPatterns, _ref, quadComponents, requireQuotedTripleFiltering, indexWrapped, quadComponentsOrdered, ids, terms, variableIndexes, i, shouldFilterIndexes, filterIndexes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, decomposedQuadEncoded, skipBinding, checkForBindingConflicts, bindingsEntries, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _this, _loop, _iterator1, _step1, _ret, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Check if our dictionary and our indexes have quoted pattern support
                            indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every(function(wrapped) {
                                return wrapped.index.features.quotedTripleFiltering;
                            });
                            // Construct a quad pattern array
                            _ref = (0, $32TW8._)((0, $1piaa.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns), 2), quadComponents = _ref[0], requireQuotedTripleFiltering = _ref[1];
                            // Determine the best index for this pattern
                            indexWrapped = this.indexesWrapped[(0, $1piaa.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
                            // Re-order the quad pattern based on this best index's component order
                            quadComponentsOrdered = (0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
                            ids = (0, $1piaa.encodeOptionalTerms)(quadComponentsOrdered, this.dictionary);
                            // Abort if any of the terms does not exist in the dictionary
                            if (!ids) return [
                                2
                            ];
                            // Collect variables to bind
                            terms = (0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, [
                                subject,
                                predicate,
                                object,
                                graph
                            ]);
                            variableIndexes = [];
                            for(i = 0; i < terms.length; i++)if (terms[i].termType === 'Variable' || terms[i].termType === 'Quad') variableIndexes.push(i);
                            // Check if we need to do post-filtering for overlapping variables
                            shouldFilterIndexes = false;
                            filterIndexes = terms.map(function(variable, i) {
                                var equalVariables = [];
                                for(var j = i + 1; j < terms.length; j++)if (variable.equals(terms[j])) {
                                    equalVariables.push(j);
                                    shouldFilterIndexes = true;
                                }
                                return equalVariables;
                            });
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = indexWrapped.index.findEncoded(ids, quadComponentsOrdered)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            decomposedQuadEncoded = _step.value;
                            skipBinding = false;
                            checkForBindingConflicts = false;
                            bindingsEntries = [];
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                _loop = function() {
                                    var i = _step1.value;
                                    // If we had overlapping variables, potentially exclude this binding if values for variable are unequal
                                    if (shouldFilterIndexes) {
                                        var filterI = filterIndexes[i];
                                        if (filterI) {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = filterI[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var j = _step.value;
                                                    if (decomposedQuadEncoded[i] !== decomposedQuadEncoded[j]) {
                                                        skipBinding = true;
                                                        break;
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                        _iterator["return"]();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                        if (skipBinding) return "break";
                                    }
                                    var decodedTerm = _this.dictionary.decode(decomposedQuadEncoded[i]);
                                    // Handle quoted triples
                                    // TODO: it may be possible to implement a more efficient of findEncoded if requireQuotedTripleFiltering is
                                    //  false that would return bindings instead of quads. The following could then be skipped.
                                    //  variableIndexes would also need to be changed to check requireQuotedTripleFiltering (see readQuads).
                                    if (terms[i].termType === 'Quad') {
                                        if (decodedTerm.termType === 'Quad') {
                                            // If the term is a quad, it may also contain nested variables,
                                            // so we need to extract those additional bindings.
                                            var additionalBindings = (0, $krcR9.matchPatternMappings)(decodedTerm, terms[i], {
                                                returnMappings: true
                                            });
                                            if (additionalBindings) {
                                                checkForBindingConflicts = true;
                                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                                try {
                                                    var _this1, _loop = function() {
                                                        var _step_value = (0, $32TW8._)(_step2.value, 2), key = _step_value[0], value = _step_value[1];
                                                        var variable = _this1.dataFactory.variable(key);
                                                        if (bindingsEntries.some(function(entry) {
                                                            return entry[0].equals(variable) && !entry[1].equals(value);
                                                        })) {
                                                            // Skip this binding if we find conflicting variable bindings
                                                            skipBinding = true;
                                                            return "break";
                                                        }
                                                        bindingsEntries.push([
                                                            variable,
                                                            value
                                                        ]);
                                                    };
                                                    for(var _iterator1 = Object.entries(additionalBindings)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                        var _ret = (_this1 = _this, _loop());
                                                        if (_ret === "break") break;
                                                    }
                                                } catch (err) {
                                                    _didIteratorError1 = true;
                                                    _iteratorError1 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                                            _iterator1["return"]();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError1) {
                                                            throw _iteratorError1;
                                                        }
                                                    }
                                                }
                                                return "continue";
                                            }
                                        }
                                        skipBinding = true;
                                        return "break";
                                    }
                                    // If for the current bindings object, we previously found a quoted quad term that bound variables within it,
                                    // make sure that later bindings to this variable from other terms don't conflict.
                                    if (checkForBindingConflicts && bindingsEntries.some(function(entry) {
                                        return entry[0].equals(terms[i]) && !entry[1].equals(decodedTerm);
                                    })) {
                                        // Skip this binding if we find conflicting variable bindings
                                        skipBinding = true;
                                        return "break";
                                    }
                                    bindingsEntries.push([
                                        terms[i],
                                        decodedTerm
                                    ]);
                                };
                                for(_iterator1 = variableIndexes[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    _ret = (_this = this, _loop());
                                    if (_ret === "break") break;
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            if (!!skipBinding) return [
                                3,
                                4
                            ];
                            // Create and yield the bindings object
                            return [
                                4,
                                bindingsFactory.bindings(bindingsEntries)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Returns an array containing all bindings matching the pattern.
     * @param bindingsFactory The factory that will be used to create bindings.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ key: "getBindings",
            value: function getBindings(bindingsFactory, subject, predicate, object, graph) {
                return (0, $7WNf6._)(this.readBindings(bindingsFactory, subject, predicate, object, graph));
            }
        },
        {
            /**
     * Returns a stream that produces all quads matching the pattern.
     * @param bindingsFactory The factory that will be used to create bindings.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ key: "matchBindings",
            value: function matchBindings(bindingsFactory, subject, predicate, object, graph) {
                return (0, $aafx9.wrap)(this.readBindings(bindingsFactory, subject, predicate, object, graph));
            }
        },
        {
            /**
     * Returns the exact cardinality of the quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ key: "countQuads",
            value: function countQuads(subject, predicate, object, graph) {
                // Check if our dictionary and our indexes have quoted pattern support
                var indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every(function(wrapped) {
                    return wrapped.index.features.quotedTripleFiltering;
                });
                // Construct a quad pattern array
                var _ref = (0, $32TW8._)((0, $1piaa.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns), 1), quadComponents = _ref[0];
                // Optimize all-variables pattern
                if (quadComponents.every(function(quadComponent) {
                    return quadComponent === undefined;
                })) return this.size;
                // Determine the best index for this pattern
                var indexWrapped = this.indexesWrapped[(0, $1piaa.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
                // Re-order the quad pattern based on this best index's component order
                var quadComponentsOrdered = (0, $1piaa.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
                // Call the best index's count method.
                return indexWrapped.index.count(quadComponentsOrdered);
            }
        },
        {
            /**
     * Wrap this store inside a DatasetCore interface.
     * Any mutations in either this store or the wrapper will propagate to each other.
     */ key: "asDataset",
            value: function asDataset() {
                return new $kc2cE.DatasetCoreWrapper(this);
            }
        }
    ], [
        {
            key: "createDefault",
            value: /**
     * Create an RDF store with default settings.
     * Concretely, this store stores triples in GSPO, GPOS, and GOSP order,
     * and makes use of in-memory number dictionary encoding.
     */ function createDefault() {
                return new RdfStore({
                    indexCombinations: RdfStore.DEFAULT_INDEX_COMBINATIONS,
                    indexConstructor: function(subOptions) {
                        return new $6z0Kq.RdfStoreIndexNestedMapQuoted(subOptions);
                    },
                    dictionary: new $jOL5J.TermDictionaryQuotedIndexed(new $iBswZ.TermDictionaryNumberRecordFullTerms()),
                    dataFactory: new $a2toU.DataFactory()
                });
            }
        },
        {
            key: "constructIndexesWrapped",
            value: /**
     * Internal helper to create index objects.
     * @param options The RDF store options object.
     */ function constructIndexesWrapped(options) {
                var indexes = [];
                if (options.indexCombinations.length === 0) throw new Error('At least one index combination is required');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = options.indexCombinations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var componentOrder = _step.value;
                        if (!RdfStore.isCombinationValid(componentOrder)) throw new Error("Invalid index combination: ".concat(componentOrder));
                        indexes.push({
                            index: options.indexConstructor(options),
                            componentOrder: componentOrder,
                            componentOrderInverse: Object.fromEntries(componentOrder.map(function(value, key) {
                                return [
                                    value,
                                    key
                                ];
                            }))
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return indexes;
            }
        },
        {
            key: "isCombinationValid",
            value: /**
     * Check if a given quad term order is valid.
     * @param combination A quad term order.
     */ function isCombinationValid(combination) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $krcR9.QUAD_TERM_NAMES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var quadTermName = _step.value;
                        if (!combination.includes(quadTermName)) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return combination.length === 4;
            }
        }
    ]);
    return RdfStore;
}();
module.exports.RdfStore = $2e5a204173b8338b$var$RdfStore;
$2e5a204173b8338b$var$RdfStore.DEFAULT_INDEX_COMBINATIONS = [
    [
        'graph',
        'subject',
        'predicate',
        'object'
    ],
    [
        'graph',
        'predicate',
        'object',
        'subject'
    ],
    [
        'graph',
        'object',
        'subject',
        'predicate'
    ]
];

});
parcelRegister("a2toU", function(module, exports) {
"use strict";
var $74f0e5aaaf2d15d2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $74f0e5aaaf2d15d2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $74f0e5aaaf2d15d2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("4zFPh")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("7LTH3")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("cRKTN")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("6kEEO")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("euKvm")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("jIks3")), module.exports);

$74f0e5aaaf2d15d2$var$__exportStar((parcelRequire("4ihxq")), module.exports);

});
parcelRegister("4zFPh", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ var $354ae01ac40070b6$var$BlankNode = /*#__PURE__*/ function() {
    function BlankNode(value) {
        (0, $jGAMp._)(this, BlankNode);
        this.termType = 'BlankNode';
        this.value = value;
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNode;
}();
module.exports.BlankNode = $354ae01ac40070b6$var$BlankNode;

});

parcelRegister("7LTH3", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $4zFPh = parcelRequire("4zFPh");

var $cRKTN = parcelRequire("cRKTN");

var $6kEEO = parcelRequire("6kEEO");

var $euKvm = parcelRequire("euKvm");

var $jIks3 = parcelRequire("jIks3");

var $4ihxq = parcelRequire("4ihxq");
var $5a881fc0e5486ca5$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ var $5a881fc0e5486ca5$var$DataFactory = /*#__PURE__*/ function() {
    function DataFactory(options) {
        (0, $jGAMp._)(this, DataFactory);
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || "df_".concat($5a881fc0e5486ca5$var$dataFactoryCounter++, "_");
    }
    (0, $byiyg._)(DataFactory, [
        {
            /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ key: "namedNode",
            value: function namedNode(value) {
                return new $euKvm.NamedNode(value);
            }
        },
        {
            /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ key: "blankNode",
            value: function blankNode(value) {
                return new $4zFPh.BlankNode(value || "".concat(this.blankNodePrefix).concat(this.blankNodeCounter++));
            }
        },
        {
            /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ key: "literal",
            value: function literal(value, languageOrDatatype) {
                return new $6kEEO.Literal(value, languageOrDatatype);
            }
        },
        {
            /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ key: "variable",
            value: function variable(value) {
                return new $4ihxq.Variable(value);
            }
        },
        {
            /**
     * @return An instance of DefaultGraph.
     */ key: "defaultGraph",
            value: function defaultGraph() {
                return $cRKTN.DefaultGraph.INSTANCE;
            }
        },
        {
            /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ key: "quad",
            value: function quad(subject, predicate, object, graph) {
                return new $jIks3.Quad(subject, predicate, object, graph || this.defaultGraph());
            }
        },
        {
            /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ key: "fromTerm",
            value: function fromTerm(original) {
                // TODO: remove nasty any casts when this TS bug has been fixed:
                //  https://github.com/microsoft/TypeScript/issues/26933
                switch(original.termType){
                    case 'NamedNode':
                        return this.namedNode(original.value);
                    case 'BlankNode':
                        return this.blankNode(original.value);
                    case 'Literal':
                        if (original.language) return this.literal(original.value, original.language);
                        if (!original.datatype.equals($6kEEO.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                        return this.literal(original.value);
                    case 'Variable':
                        return this.variable(original.value);
                    case 'DefaultGraph':
                        return this.defaultGraph();
                    case 'Quad':
                        return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
                }
            }
        },
        {
            /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ key: "fromQuad",
            value: function fromQuad(original) {
                return this.fromTerm(original);
            }
        },
        {
            /**
     * Reset the internal blank node counter.
     */ key: "resetBlankNodeCounter",
            value: function resetBlankNodeCounter() {
                this.blankNodeCounter = 0;
            }
        }
    ]);
    return DataFactory;
}();
module.exports.DataFactory = $5a881fc0e5486ca5$var$DataFactory;

});
parcelRegister("cRKTN", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $95ded06d65b5468b$var$DefaultGraph = /*#__PURE__*/ function() {
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        this.termType = 'DefaultGraph';
        this.value = '';
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'DefaultGraph';
            }
        }
    ]);
    return DefaultGraph;
}();
module.exports.DefaultGraph = $95ded06d65b5468b$var$DefaultGraph;
$95ded06d65b5468b$var$DefaultGraph.INSTANCE = new $95ded06d65b5468b$var$DefaultGraph();

});

parcelRegister("6kEEO", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $euKvm = parcelRequire("euKvm");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ var $49c425ff11c7c1fa$var$Literal = /*#__PURE__*/ function() {
    function Literal(value, languageOrDatatype) {
        (0, $jGAMp._)(this, Literal);
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = Literal.XSD_STRING;
            this.direction = '';
        }
    }
    (0, $byiyg._)(Literal, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
            }
        }
    ]);
    return Literal;
}();
module.exports.Literal = $49c425ff11c7c1fa$var$Literal;
$49c425ff11c7c1fa$var$Literal.RDF_LANGUAGE_STRING = new $euKvm.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$49c425ff11c7c1fa$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $euKvm.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$49c425ff11c7c1fa$var$Literal.XSD_STRING = new $euKvm.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("euKvm", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ var $a8d7f0ef37297e8e$var$NamedNode = /*#__PURE__*/ function() {
    function NamedNode(value) {
        (0, $jGAMp._)(this, NamedNode);
        this.termType = 'NamedNode';
        this.value = value;
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'NamedNode' && other.value === this.value;
            }
        }
    ]);
    return NamedNode;
}();
module.exports.NamedNode = $a8d7f0ef37297e8e$var$NamedNode;

});


parcelRegister("jIks3", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $e5a1fd9d936f3c8a$var$Quad = /*#__PURE__*/ function() {
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "equals",
            value: function equals(other) {
                // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
                return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
            }
        }
    ]);
    return Quad;
}();
module.exports.Quad = $e5a1fd9d936f3c8a$var$Quad;

});

parcelRegister("4ihxq", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ var $3206728c583fc67a$var$Variable = /*#__PURE__*/ function() {
    function Variable(value) {
        (0, $jGAMp._)(this, Variable);
        this.termType = 'Variable';
        this.value = value;
    }
    (0, $byiyg._)(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Variable' && other.value === this.value;
            }
        }
    ]);
    return Variable;
}();
module.exports.Variable = $3206728c583fc67a$var$Variable;

});



parcelRegister("krcR9", function(module, exports) {
"use strict";
var $ee104d3ee12545fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee104d3ee12545fc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee104d3ee12545fc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ee104d3ee12545fc$var$__exportStar((parcelRequire("fd4zH")), module.exports);

$ee104d3ee12545fc$var$__exportStar((parcelRequire("lDy2v")), module.exports);

});
parcelRegister("fd4zH", function(module, exports) {

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;
module.exports.getTerms = $b12b9e5ff5288cdb$var$getTerms;
module.exports.getTermsNested = $b12b9e5ff5288cdb$var$getTermsNested;
module.exports.getNamedTerms = $b12b9e5ff5288cdb$var$getNamedTerms;
module.exports.collectNamedTerms = $b12b9e5ff5288cdb$var$collectNamedTerms;
module.exports.forEachTerms = $b12b9e5ff5288cdb$var$forEachTerms;
module.exports.forEachTermsNested = $b12b9e5ff5288cdb$var$forEachTermsNested;
module.exports.filterTerms = $b12b9e5ff5288cdb$var$filterTerms;
module.exports.filterTermsNested = $b12b9e5ff5288cdb$var$filterTermsNested;
module.exports.filterQuadTermNames = $b12b9e5ff5288cdb$var$filterQuadTermNames;
module.exports.filterQuadTermNamesNested = $b12b9e5ff5288cdb$var$filterQuadTermNamesNested;
module.exports.mapTerms = $b12b9e5ff5288cdb$var$mapTerms;
module.exports.mapTermsNested = $b12b9e5ff5288cdb$var$mapTermsNested;
module.exports.reduceTerms = $b12b9e5ff5288cdb$var$reduceTerms;
module.exports.reduceTermsNested = $b12b9e5ff5288cdb$var$reduceTermsNested;
module.exports.everyTerms = $b12b9e5ff5288cdb$var$everyTerms;
module.exports.everyTermsNested = $b12b9e5ff5288cdb$var$everyTermsNested;
module.exports.someTerms = $b12b9e5ff5288cdb$var$someTerms;
module.exports.someTermsNested = $b12b9e5ff5288cdb$var$someTermsNested;
module.exports.getValueNestedPath = $b12b9e5ff5288cdb$var$getValueNestedPath;
module.exports.matchTerm = $b12b9e5ff5288cdb$var$matchTerm;
module.exports.matchPattern = $b12b9e5ff5288cdb$var$matchPattern;
module.exports.matchPatternComplete = $b12b9e5ff5288cdb$var$matchPatternComplete;
module.exports.matchPatternMappings = $b12b9e5ff5288cdb$var$matchPatternMappings;

var $a2toU = parcelRequire("a2toU");
var $b12b9e5ff5288cdb$var$DF = new $a2toU.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $b12b9e5ff5288cdb$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $b12b9e5ff5288cdb$var$getTermsNested(quad, ignoreDefaultGraph) {
    var terms = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $b12b9e5ff5288cdb$var$getTerms(quad, ignoreDefaultGraph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var term = _step.value;
            if (term.termType === 'Quad') $b12b9e5ff5288cdb$var$getTermsNested(term, ignoreDefaultGraph).forEach(function(subTerm) {
                return terms.push(subTerm);
            });
            else terms.push(term);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return terms;
}
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $b12b9e5ff5288cdb$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $b12b9e5ff5288cdb$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    var elements = {};
    namedTerms.forEach(function(namedTerm) {
        return elements[namedTerm.key] = namedTerm.value;
    });
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $b12b9e5ff5288cdb$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $b12b9e5ff5288cdb$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $b12b9e5ff5288cdb$var$forEachTermsNested(quad, cb) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (quad.subject.termType === 'Quad') $b12b9e5ff5288cdb$var$forEachTermsNested(quad.subject, cb, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else cb(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') $b12b9e5ff5288cdb$var$forEachTermsNested(quad.predicate, cb, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else cb(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') $b12b9e5ff5288cdb$var$forEachTermsNested(quad.object, cb, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else cb(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') $b12b9e5ff5288cdb$var$forEachTermsNested(quad.graph, cb, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else cb(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
}
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $b12b9e5ff5288cdb$var$filterTerms(quad, filter) {
    var terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $b12b9e5ff5288cdb$var$filterTermsNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var terms = [];
    if (quad.subject.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterTermsNested(quad.subject, filter, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))));
    else if (filter(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterTermsNested(quad.predicate, filter, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))));
    else if (filter(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterTermsNested(quad.object, filter, (0, $7WNf6._)(keys).concat([
        'object'
    ]))));
    else if (filter(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterTermsNested(quad.graph, filter, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))));
    else if (filter(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))) terms.push(quad.graph);
    return terms;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $b12b9e5ff5288cdb$var$filterQuadTermNames(quad, filter) {
    var names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $b12b9e5ff5288cdb$var$filterQuadTermNamesNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var names = [];
    var keysS = (0, $7WNf6._)(keys).concat([
        'subject'
    ]);
    if (quad.subject.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterQuadTermNamesNested(quad.subject, filter, keysS)));
    else if (filter(quad.subject, keysS)) names.push(keysS);
    var keysP = (0, $7WNf6._)(keys).concat([
        'predicate'
    ]);
    if (quad.predicate.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)));
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    var keysO = (0, $7WNf6._)(keys).concat([
        'object'
    ]);
    if (quad.object.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterQuadTermNamesNested(quad.object, filter, keysO)));
    else if (filter(quad.object, keysO)) names.push(keysO);
    var keysG = (0, $7WNf6._)(keys).concat([
        'graph'
    ]);
    if (quad.graph.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($b12b9e5ff5288cdb$var$filterQuadTermNamesNested(quad.graph, filter, keysG)));
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $b12b9e5ff5288cdb$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $b12b9e5ff5288cdb$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $b12b9e5ff5288cdb$var$mapTermsNested(quad, mapper, dataFactory) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return (dataFactory || $b12b9e5ff5288cdb$var$DF).quad(quad.subject.termType === 'Quad' ? $b12b9e5ff5288cdb$var$mapTermsNested(quad.subject, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : mapper(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ])), quad.predicate.termType === 'Quad' ? $b12b9e5ff5288cdb$var$mapTermsNested(quad.predicate, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : mapper(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])), quad.object.termType === 'Quad' ? $b12b9e5ff5288cdb$var$mapTermsNested(quad.object, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : mapper(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ])), quad.graph.termType === 'Quad' ? $b12b9e5ff5288cdb$var$mapTermsNested(quad.graph, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : mapper(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $b12b9e5ff5288cdb$var$reduceTerms(quad, reducer, initialValue) {
    var value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $b12b9e5ff5288cdb$var$reduceTermsNested(quad, reducer, initialValue) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var value = initialValue;
    if (quad.subject.termType === 'Quad') value = $b12b9e5ff5288cdb$var$reduceTermsNested(quad.subject, reducer, value, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else value = reducer(value, quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') value = $b12b9e5ff5288cdb$var$reduceTermsNested(quad.predicate, reducer, value, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else value = reducer(value, quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') value = $b12b9e5ff5288cdb$var$reduceTermsNested(quad.object, reducer, value, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else value = reducer(value, quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') value = $b12b9e5ff5288cdb$var$reduceTermsNested(quad.graph, reducer, value, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else value = reducer(value, quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    return value;
}
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $b12b9e5ff5288cdb$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $b12b9e5ff5288cdb$var$everyTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $b12b9e5ff5288cdb$var$everyTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) && (quad.predicate.termType === 'Quad' ? $b12b9e5ff5288cdb$var$everyTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) && (quad.object.termType === 'Quad' ? $b12b9e5ff5288cdb$var$everyTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) && (quad.graph.termType === 'Quad' ? $b12b9e5ff5288cdb$var$everyTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $b12b9e5ff5288cdb$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $b12b9e5ff5288cdb$var$someTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $b12b9e5ff5288cdb$var$someTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) || (quad.predicate.termType === 'Quad' ? $b12b9e5ff5288cdb$var$someTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) || (quad.object.termType === 'Quad' ? $b12b9e5ff5288cdb$var$someTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) || (quad.graph.termType === 'Quad' ? $b12b9e5ff5288cdb$var$someTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $b12b9e5ff5288cdb$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $b12b9e5ff5288cdb$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error("Tried to get ".concat(keys[0], " from term of type ").concat(term.termType));
}
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $b12b9e5ff5288cdb$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $b12b9e5ff5288cdb$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $b12b9e5ff5288cdb$var$matchPattern(quad, subject, predicate, object, graph) {
    return $b12b9e5ff5288cdb$var$matchTerm(quad.subject, subject) && $b12b9e5ff5288cdb$var$matchTerm(quad.predicate, predicate) && $b12b9e5ff5288cdb$var$matchTerm(quad.object, object) && $b12b9e5ff5288cdb$var$matchTerm(quad.graph, graph);
}
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $b12b9e5ff5288cdb$var$matchPatternComplete(quad, pattern) {
    return $b12b9e5ff5288cdb$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
function $b12b9e5ff5288cdb$var$matchPatternMappings(quad, pattern) {
    var opt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var map = {};
    function match(_pattern, _quad) {
        return $b12b9e5ff5288cdb$var$everyTerms(_pattern, function(t1, key) {
            var _a, _b;
            var t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}

});

parcelRegister("lDy2v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TERM_TYPES = void 0;
module.exports.uniqTerms = $0410a3b1881d0d75$var$uniqTerms;
module.exports.getTermsOfType = $0410a3b1881d0d75$var$getTermsOfType;
module.exports.getNamedNodes = $0410a3b1881d0d75$var$getNamedNodes;
module.exports.getBlankNodes = $0410a3b1881d0d75$var$getBlankNodes;
module.exports.getLiterals = $0410a3b1881d0d75$var$getLiterals;
module.exports.getVariables = $0410a3b1881d0d75$var$getVariables;
module.exports.getDefaultGraphs = $0410a3b1881d0d75$var$getDefaultGraphs;
module.exports.getQuads = $0410a3b1881d0d75$var$getQuads;

var $jqHHT = parcelRequire("jqHHT");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $0410a3b1881d0d75$var$uniqTerms(terms) {
    var hash = {};
    return terms.filter(function(term) {
        var termString = (0, $jqHHT.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $0410a3b1881d0d75$var$getTermsOfType(terms, termType) {
    return terms.filter(function(term) {
        return term.termType === termType;
    });
}
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $0410a3b1881d0d75$var$getNamedNodes(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'NamedNode');
}
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $0410a3b1881d0d75$var$getBlankNodes(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'BlankNode');
}
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $0410a3b1881d0d75$var$getLiterals(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'Literal');
}
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $0410a3b1881d0d75$var$getVariables(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'Variable');
}
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $0410a3b1881d0d75$var$getDefaultGraphs(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'DefaultGraph');
}
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $0410a3b1881d0d75$var$getQuads(terms) {
    return $0410a3b1881d0d75$var$getTermsOfType(terms, 'Quad');
}

});
parcelRegister("jqHHT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $lDTZK = parcelRequire("lDTZK");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function get() {
        return $lDTZK.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function get() {
        return $lDTZK.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function get() {
        return $lDTZK.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function get() {
        return $lDTZK.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function get() {
        return $lDTZK.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function get() {
        return $lDTZK.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function get() {
        return $lDTZK.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function get() {
        return $lDTZK.termToString;
    }
});

});
parcelRegister("lDTZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $fc18acea52cc436c$var$termToString;
module.exports.getLiteralValue = $fc18acea52cc436c$var$getLiteralValue;
module.exports.getLiteralType = $fc18acea52cc436c$var$getLiteralType;
module.exports.getLiteralLanguage = $fc18acea52cc436c$var$getLiteralLanguage;
module.exports.getLiteralDirection = $fc18acea52cc436c$var$getLiteralDirection;
module.exports.stringToTerm = $fc18acea52cc436c$var$stringToTerm;
module.exports.quadToStringQuad = $fc18acea52cc436c$var$quadToStringQuad;
module.exports.stringQuadToQuad = $fc18acea52cc436c$var$stringQuadToQuad;

var $a2toU = parcelRequire("a2toU");
var $fc18acea52cc436c$var$FACTORY = new $a2toU.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $fc18acea52cc436c$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            var literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return "<<".concat($fc18acea52cc436c$var$termToString(term.subject), " ").concat($fc18acea52cc436c$var$termToString(term.predicate), " ").concat($fc18acea52cc436c$var$termToString(term.object)).concat(term.graph.termType === 'DefaultGraph' ? '' : ' ' + $fc18acea52cc436c$var$termToString(term.graph), ">>");
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $fc18acea52cc436c$var$getLiteralValue(literalValue) {
    var match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $fc18acea52cc436c$var$getLiteralType(literalValue) {
    var match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $fc18acea52cc436c$var$getLiteralLanguage(literalValue) {
    var match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        var ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        var doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $fc18acea52cc436c$var$getLiteralDirection(literalValue) {
    var doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        var direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $fc18acea52cc436c$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $fc18acea52cc436c$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error("Missing 'variable()' method on the given DataFactory");
            return dataFactory.variable(value.substr(1));
        case '"':
            var language = $fc18acea52cc436c$var$getLiteralLanguage(value);
            var direction = $fc18acea52cc436c$var$getLiteralDirection(value);
            var type = dataFactory.namedNode($fc18acea52cc436c$var$getLiteralType(value));
            return dataFactory.literal($fc18acea52cc436c$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                var terms = value.slice(2, -2).trim();
                var stringTerms = [];
                var ignoreTags = 0;
                var lastIndex = 0;
                var inQuote = false;
                for(var i = 0; i < terms.length; i++){
                    var _char = terms[i];
                    if (_char === '<') ignoreTags++;
                    if (_char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (_char === '"') {
                        var escaped = false;
                        var j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (_char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map(function(term) {
                    return term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term;
                });
                return dataFactory.quad($fc18acea52cc436c$var$stringToTerm(stringTerms[0]), $fc18acea52cc436c$var$stringToTerm(stringTerms[1]), $fc18acea52cc436c$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $fc18acea52cc436c$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $fc18acea52cc436c$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $fc18acea52cc436c$var$termToString(q.subject),
        predicate: $fc18acea52cc436c$var$termToString(q.predicate),
        object: $fc18acea52cc436c$var$termToString(q.object),
        graph: $fc18acea52cc436c$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $fc18acea52cc436c$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $fc18acea52cc436c$var$FACTORY;
    return dataFactory.quad($fc18acea52cc436c$var$stringToTerm(stringQuad.subject, dataFactory), $fc18acea52cc436c$var$stringToTerm(stringQuad.predicate, dataFactory), $fc18acea52cc436c$var$stringToTerm(stringQuad.object, dataFactory), $fc18acea52cc436c$var$stringToTerm(stringQuad.graph, dataFactory));
}

});




parcelRegister("iBswZ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberRecordFullTerms = void 0;

var $a2toU = parcelRequire("a2toU");

var $jqHHT = parcelRequire("jqHHT");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Record.
 * The reverse dictionary will store full RDF term objects,
 * resulting in slightly better query performance at the cost of slightly higher memory usage.
 */ var $d8b1d06705ca042d$var$TermDictionaryNumberRecordFullTerms = /*#__PURE__*/ function() {
    function TermDictionaryNumberRecordFullTerms() {
        var dataFactory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryNumberRecordFullTerms);
        this.lastId = 0;
        this.dictionary = {};
        this.reverseDictionary = {};
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryNumberRecordFullTerms, [
        {
            key: "encode",
            value: function encode(term) {
                var key = (0, $jqHHT.termToString)(term);
                var encoded = this.dictionary[key];
                if (encoded === undefined) {
                    encoded = this.lastId++;
                    this.dictionary[key] = encoded;
                    this.reverseDictionary[encoded] = term;
                }
                return encoded;
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                var key = (0, $jqHHT.termToString)(term);
                return this.dictionary[key];
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                var string = this.reverseDictionary[encoding];
                if (string === undefined) throw new Error("The value ".concat(encoding, " is not present in this dictionary"));
                return string;
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = Object.keys(this.reverseDictionary)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            key = _step.value;
                            return [
                                4,
                                Number.parseInt(key, 10)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                throw new Error('findQuotedTriples is not supported');
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                throw new Error('findQuotedTriplesEncoded is not supported');
            }
        }
    ]);
    return TermDictionaryNumberRecordFullTerms;
}();
module.exports.TermDictionaryNumberRecordFullTerms = $d8b1d06705ca042d$var$TermDictionaryNumberRecordFullTerms;

});

parcelRegister("jOL5J", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuotedIndexed = void 0;

var $a2toU = parcelRequire("a2toU");

var $7Glct = parcelRequire("7Glct");

var $1piaa = parcelRequire("1piaa");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms are stored in a regular dictionary.
 * Quoted triples are stored separately using an index, which is backed the same dictionary.
 *
 * Finding quoted triples is done through indexed lookups.
 */ var $e6d73735388c8c61$var$TermDictionaryQuotedIndexed = /*#__PURE__*/ function() {
    function TermDictionaryQuotedIndexed(rawTermDictionary) {
        var dataFactory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryQuotedIndexed);
        this.quotedTriplesDictionary = [];
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = rawTermDictionary;
        var subIndexOpts = {
            // Not required
            indexCombinations: [],
            // Not required
            indexConstructor: undefined,
            dictionary: this,
            dataFactory: dataFactory
        };
        this.quotedTriplesReverseDictionaries = [
            new $7Glct.RdfStoreIndexNestedMap(subIndexOpts),
            new $7Glct.RdfStoreIndexNestedMap(subIndexOpts),
            new $7Glct.RdfStoreIndexNestedMap(subIndexOpts)
        ];
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryQuotedIndexed, [
        {
            key: "encode",
            value: function encode(term) {
                if (term.termType === 'Quad') return this.encodeQuotedTriple(term, false);
                return this.plainTermDictionary.encode(term);
            }
        },
        {
            key: "encodeQuotedTriple",
            value: function encodeQuotedTriple(quad, optional) {
                // Only quoted triples are supported
                if (quad.graph.termType !== 'DefaultGraph') throw new Error('Encoding of quoted quads outside of the default graph is not allowed');
                // Check if the quad was already encoded
                var encodedTripleOptional = (0, $1piaa.encodeOptionalTerms)([
                    quad.subject,
                    quad.predicate,
                    quad.object,
                    quad.graph
                ], this);
                var id = encodedTripleOptional && encodedTripleOptional.every(function(encoded) {
                    return encoded !== undefined;
                }) ? this.quotedTriplesReverseDictionaries[0].getEncoded(encodedTripleOptional) : undefined;
                // Return the encoding if we found one
                if (id !== undefined || optional) // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                return id === undefined ? undefined : TermDictionaryQuotedIndexed.BITMASK | id;
                // If the quad was not encoded yet, add a new entry for it in the dictionary.
                var encodedTriple = [
                    this.encode(quad.subject),
                    this.encode(quad.predicate),
                    this.encode(quad.object)
                ];
                var encodingBase = this.quotedTriplesDictionary.length + 1;
                this.quotedTriplesDictionary.push(encodedTriple);
                var encodedGraph = this.encode(this.dataFactory.defaultGraph());
                this.quotedTriplesReverseDictionaries[0].set([
                    encodedTriple[0],
                    encodedTriple[1],
                    encodedTriple[2],
                    encodedGraph
                ], encodingBase);
                this.quotedTriplesReverseDictionaries[1].set([
                    encodedTriple[1],
                    encodedTriple[2],
                    encodedTriple[0],
                    encodedGraph
                ], encodingBase);
                this.quotedTriplesReverseDictionaries[2].set([
                    encodedTriple[2],
                    encodedTriple[0],
                    encodedTriple[1],
                    encodedGraph
                ], encodingBase);
                // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                return TermDictionaryQuotedIndexed.BITMASK | encodingBase;
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                if (term.termType === 'Quad') return this.encodeQuotedTriple(term, true);
                return this.plainTermDictionary.encodeOptional(term);
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                if (TermDictionaryQuotedIndexed.BITMASK & encoding) {
                    // Term comes from the quoted triples dictionary
                    var encodingBase = (~TermDictionaryQuotedIndexed.BITMASK & encoding) - 1;
                    if (encodingBase >= this.quotedTriplesDictionary.length) throw new Error("The value ".concat(encoding, " is not present in the quoted triples range of the dictionary"));
                    var encodedTerms = this.quotedTriplesDictionary[encodingBase];
                    return this.dataFactory.quad(this.decode(encodedTerms[0]), this.decode(encodedTerms[1]), this.decode(encodedTerms[2]));
                }
                // Term comes from the plain terms dictionary
                return this.plainTermDictionary.decode(encoding);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, encoding, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, encoding1, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.plainTermDictionary.encodings()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            encoding = _step.value;
                            return [
                                4,
                                encoding
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 9;
                        case 9:
                            _state.trys.push([
                                9,
                                14,
                                15,
                                16
                            ]);
                            _iterator1 = this.quotedTriplesDictionary.keys()[Symbol.iterator]();
                            _state.label = 10;
                        case 10:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                13
                            ];
                            encoding1 = _step1.value;
                            return [
                                4,
                                TermDictionaryQuotedIndexed.BITMASK | 1 + encoding1
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                10
                            ];
                        case 13:
                            return [
                                3,
                                16
                            ];
                        case 14:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                16
                            ];
                        case 15:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 16:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, termEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.findQuotedTriplesEncoded(quotedTriplePattern)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            termEncoded = _step.value;
                            return [
                                4,
                                this.decode(termEncoded)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                var _ref, patternIn, requireQuotedTripleFiltering, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, termS, _iterator1, _step1, termP, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator2, _step2, termO, _iterator3, _step3, termG, pattern, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, termEncoded, err, pattern1, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, termEncoded1, err, pattern2, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, termEncoded2, err, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ref = (0, $32TW8._)((0, $1piaa.quadToPattern)(quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph, true), 2), patternIn = _ref[0], requireQuotedTripleFiltering = _ref[1];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                48,
                                49,
                                50
                            ]);
                            _iterator = this.patternToIterable(patternIn[0])[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion1 = (_step = _iterator.next()).done)) return [
                                3,
                                47
                            ];
                            termS = _step.value;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                44,
                                45,
                                46
                            ]);
                            _iterator1 = this.patternToIterable(patternIn[1])[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                3,
                                43
                            ];
                            termP = _step1.value;
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined, _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                40,
                                41,
                                42
                            ]);
                            _iterator2 = this.patternToIterable(patternIn[2])[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion3 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                39
                            ];
                            termO = _step2.value;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                36,
                                37,
                                38
                            ]);
                            _iterator3 = this.patternToIterable(patternIn[3])[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion2 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                35
                            ];
                            termG = _step3.value;
                            if (!(termS && termP || !termP && !termO)) return [
                                3,
                                17
                            ];
                            // SPO
                            pattern = [
                                termS,
                                termP,
                                termO,
                                termG
                            ];
                            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                            _state.label = 9;
                        case 9:
                            _state.trys.push([
                                9,
                                14,
                                15,
                                16
                            ]);
                            _iterator4 = this.quotedTriplesReverseDictionaries[0].findEncoded(pattern, patternIn)[Symbol.iterator]();
                            _state.label = 10;
                        case 10:
                            if (!!(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done)) return [
                                3,
                                13
                            ];
                            termEncoded = _step4.value;
                            return [
                                4,
                                TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[0].getEncoded(termEncoded)
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _iteratorNormalCompletion4 = true;
                            return [
                                3,
                                10
                            ];
                        case 13:
                            return [
                                3,
                                16
                            ];
                        case 14:
                            err = _state.sent();
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                            return [
                                3,
                                16
                            ];
                        case 15:
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                    _iterator4["return"]();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                            return [
                                7
                            ];
                        case 16:
                            return [
                                3,
                                34
                            ];
                        case 17:
                            if (!(!termS && termP)) return [
                                3,
                                26
                            ];
                            // POS
                            pattern1 = [
                                termP,
                                termO,
                                termS,
                                termG
                            ];
                            _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                            _state.label = 18;
                        case 18:
                            _state.trys.push([
                                18,
                                23,
                                24,
                                25
                            ]);
                            _iterator5 = this.quotedTriplesReverseDictionaries[1].findEncoded(pattern1, patternIn)[Symbol.iterator]();
                            _state.label = 19;
                        case 19:
                            if (!!(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done)) return [
                                3,
                                22
                            ];
                            termEncoded1 = _step5.value;
                            return [
                                4,
                                TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[1].getEncoded(termEncoded1)
                            ];
                        case 20:
                            _state.sent();
                            _state.label = 21;
                        case 21:
                            _iteratorNormalCompletion5 = true;
                            return [
                                3,
                                19
                            ];
                        case 22:
                            return [
                                3,
                                25
                            ];
                        case 23:
                            err = _state.sent();
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                            return [
                                3,
                                25
                            ];
                        case 24:
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                    _iterator5["return"]();
                                }
                            } finally{
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                            return [
                                7
                            ];
                        case 25:
                            return [
                                3,
                                34
                            ];
                        case 26:
                            // OSP
                            pattern2 = [
                                termO,
                                termS,
                                termP,
                                termG
                            ];
                            _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                            _state.label = 27;
                        case 27:
                            _state.trys.push([
                                27,
                                32,
                                33,
                                34
                            ]);
                            _iterator6 = this.quotedTriplesReverseDictionaries[2].findEncoded(pattern2, patternIn)[Symbol.iterator]();
                            _state.label = 28;
                        case 28:
                            if (!!(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done)) return [
                                3,
                                31
                            ];
                            termEncoded2 = _step6.value;
                            return [
                                4,
                                TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[2].getEncoded(termEncoded2)
                            ];
                        case 29:
                            _state.sent();
                            _state.label = 30;
                        case 30:
                            _iteratorNormalCompletion6 = true;
                            return [
                                3,
                                28
                            ];
                        case 31:
                            return [
                                3,
                                34
                            ];
                        case 32:
                            err = _state.sent();
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                            return [
                                3,
                                34
                            ];
                        case 33:
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                                    _iterator6["return"]();
                                }
                            } finally{
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                            return [
                                7
                            ];
                        case 34:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                8
                            ];
                        case 35:
                            return [
                                3,
                                38
                            ];
                        case 36:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                38
                            ];
                        case 37:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 38:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                6
                            ];
                        case 39:
                            return [
                                3,
                                42
                            ];
                        case 40:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                42
                            ];
                        case 41:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 42:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 43:
                            return [
                                3,
                                46
                            ];
                        case 44:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                46
                            ];
                        case 45:
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 46:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                2
                            ];
                        case 47:
                            return [
                                3,
                                50
                            ];
                        case 48:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                50
                            ];
                        case 49:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 50:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "patternToIterable",
            value: /**
     * Helper function to convert a term to an iterator over encoded terms.
     * @param patternTerm A term.
     * @protected
     */ function patternToIterable(patternTerm) {
                var enc;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((patternTerm === null || patternTerm === void 0 ? void 0 : patternTerm.termType) === 'Quad')) return [
                                3,
                                2
                            ];
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findQuotedTriplesEncoded(patternTerm))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                        case 2:
                            if (!(patternTerm === undefined)) return [
                                3,
                                4
                            ];
                            // eslint-disable-next-line unicorn/no-useless-undefined
                            return [
                                4,
                                undefined
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                        case 4:
                            // Defined terms indicate a precise match
                            enc = this.encodeOptional(patternTerm);
                            if (enc === undefined) return [
                                2
                            ];
                            return [
                                4,
                                enc
                            ];
                        case 5:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return TermDictionaryQuotedIndexed;
}();
module.exports.TermDictionaryQuotedIndexed = $e6d73735388c8c61$var$TermDictionaryQuotedIndexed;
$e6d73735388c8c61$var$TermDictionaryQuotedIndexed.BITMASK = -2147483648;

});
parcelRegister("7Glct", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMap = void 0;

var $1piaa = parcelRequire("1piaa");
/**
 * An RDF store index that is implemented using nested Maps.
 */ var $597ce68b3c6f8004$var$RdfStoreIndexNestedMap = /*#__PURE__*/ function() {
    function RdfStoreIndexNestedMap(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedMap);
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedMap = new Map();
    }
    (0, $byiyg._)(RdfStoreIndexNestedMap, [
        {
            key: "set",
            value: function set(terms, value) {
                var map0 = this.nestedMap;
                var map1 = map0.get(terms[0]);
                if (!map1) {
                    map1 = new Map();
                    map0.set(terms[0], map1);
                }
                var map2 = map1.get(terms[1]);
                if (!map2) {
                    map2 = new Map();
                    map1.set(terms[1], map2);
                }
                var map3 = map2.get(terms[2]);
                if (!map3) {
                    map3 = new Map();
                    map2.set(terms[2], map3);
                }
                var contained = map3.has(terms[3]);
                if (!contained) map3.set(terms[3], value);
                return !contained;
            }
        },
        {
            key: "remove",
            value: function remove(terms) {
                var map0 = this.nestedMap;
                var map1 = map0.get(terms[0]);
                if (!map1) return false;
                var map2 = map1.get(terms[1]);
                if (!map2) return false;
                var map3 = map2.get(terms[2]);
                if (!map3) return false;
                var ret = map3["delete"](terms[3]);
                // Clean up intermediate maps
                if (ret && map3.size === 0) {
                    map2["delete"](terms[2]);
                    if (map2.size === 0) {
                        map1["delete"](terms[1]);
                        if (map1.size === 0) map0["delete"](terms[0]);
                    }
                }
                return ret;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var encoded = (0, $1piaa.encodeOptionalTerms)(key, this.dictionary);
                // eslint-disable-next-line unicorn/no-useless-undefined
                if (!encoded || encoded.includes(undefined)) return undefined;
                return this.getEncoded(encoded);
            }
        },
        {
            key: "getEncoded",
            value: function getEncoded(ids) {
                var map1 = this.nestedMap.get(ids[0]);
                if (!map1) return undefined;
                var map2 = map1.get(ids[1]);
                if (!map2) return undefined;
                var map3 = map2.get(ids[2]);
                if (!map3) return undefined;
                return map3.get(ids[3]);
            }
        },
        {
            key: "find",
            value: function find(terms) {
                var ids, _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, partialQuad0, partialQuad1, partialQuad2, partialQuad3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                            if (!ids) return [
                                2
                            ];
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            map0 = this.nestedMap;
                            map0Keys = id0 !== undefined ? map0.has(id0) ? [
                                id0
                            ] : [] : map0.keys();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0.get(key1);
                            partialQuad0 = term0 || this.dictionary.decode(key1);
                            map1Keys = id1 !== undefined ? map1.has(id1) ? [
                                id1
                            ] : [] : map1.keys();
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1.get(key2);
                            partialQuad1 = term1 || this.dictionary.decode(key2);
                            map2Keys = id2 !== undefined ? map2.has(id2) ? [
                                id2
                            ] : [] : map2.keys();
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2.get(key3);
                            partialQuad2 = term2 || this.dictionary.decode(key3);
                            map3Keys = id3 !== undefined ? map3.has(id3) ? [
                                id3
                            ] : [] : map3.keys();
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            partialQuad3 = term3 || this.dictionary.decode(key4);
                            return [
                                4,
                                [
                                    partialQuad0,
                                    partialQuad1,
                                    partialQuad2,
                                    partialQuad3
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findEncoded",
            value: // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
            function findEncoded(ids, terms) {
                var _ids, id0, id1, id2, id3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            map0 = this.nestedMap;
                            map0Keys = id0 !== undefined ? map0.has(id0) ? [
                                id0
                            ] : [] : map0.keys();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0.get(key1);
                            map1Keys = id1 !== undefined ? map1.has(id1) ? [
                                id1
                            ] : [] : map1.keys();
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1.get(key2);
                            map2Keys = id2 !== undefined ? map2.has(id2) ? [
                                id2
                            ] : [] : map2.keys();
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2.get(key3);
                            map3Keys = id3 !== undefined ? map3.has(id3) ? [
                                id3
                            ] : [] : map3.keys();
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            return [
                                4,
                                [
                                    key1,
                                    key2,
                                    key3,
                                    key4
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "count",
            value: function count(terms) {
                var count = 0;
                var ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                if (!ids) return 0;
                var id0 = ids[0];
                var id1 = ids[1];
                var id2 = ids[2];
                var id3 = ids[3];
                var map1;
                var map2;
                var map3;
                var map0 = this.nestedMap;
                var map0Keys = id0 !== undefined ? map0.has(id0) ? [
                    id0
                ] : [] : map0.keys();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = map0Keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        map1 = map0.get(key1);
                        var map1Keys = id1 !== undefined ? map1.has(id1) ? [
                            id1
                        ] : [] : map1.keys();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = map1Keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var key2 = _step1.value;
                                map2 = map1.get(key2);
                                var map2Keys = id2 !== undefined ? map2.has(id2) ? [
                                    id2
                                ] : [] : map2.keys();
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = map2Keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var key3 = _step2.value;
                                        map3 = map2.get(key3);
                                        if (id3 !== undefined) {
                                            if (map3.has(id3)) count++;
                                        } else count += map3.size;
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedMap;
}();
module.exports.RdfStoreIndexNestedMap = $597ce68b3c6f8004$var$RdfStoreIndexNestedMap;

});
parcelRegister("1piaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QUAD_TERM_NAMES_INVERSE = void 0;
module.exports.getBestIndex = $1066370f59692308$var$getBestIndex;
module.exports.getComponentOrderScore = $1066370f59692308$var$getComponentOrderScore;
module.exports.orderQuadComponents = $1066370f59692308$var$orderQuadComponents;
module.exports.encodeOptionalTerms = $1066370f59692308$var$encodeOptionalTerms;
module.exports.quadToPattern = $1066370f59692308$var$quadToPattern;
module.exports.quadHasVariables = $1066370f59692308$var$quadHasVariables;
module.exports.arePatternsQuoted = $1066370f59692308$var$arePatternsQuoted;

var $krcR9 = parcelRequire("krcR9");
module.exports.QUAD_TERM_NAMES_INVERSE = Object.fromEntries($krcR9.QUAD_TERM_NAMES.map(function(value, key) {
    return [
        value,
        key
    ];
}));
/**
 * Determine the best suitable order's index among the given orders for the given quad pattern.
 * @param componentOrders Possible orders of quad components.
 * @param quadPattern A quad pattern.
 */ function $1066370f59692308$var$getBestIndex(componentOrders, quadPattern) {
    if (componentOrders.length === 1 || quadPattern.every(function(term) {
        return term !== undefined;
    })) return 0;
    // Determine the quad component names for which we require a defined lookup
    var definedQuadComponentNames = [];
    for(var quadComponentId = 0; quadComponentId < $krcR9.QUAD_TERM_NAMES.length; quadComponentId++)if (quadPattern[quadComponentId]) definedQuadComponentNames.push($krcR9.QUAD_TERM_NAMES[quadComponentId]);
    // Score indexes by how well they match to the index
    var scoredIndexes = componentOrders.map(function(componentOrder, index) {
        var score = $1066370f59692308$var$getComponentOrderScore(componentOrder, definedQuadComponentNames);
        return {
            score: score,
            index: index
        };
    });
    // Sort the indexes, and pick the first one
    return scoredIndexes.sort(function(scoredLeft, scoredRight) {
        return scoredRight.score - scoredLeft.score;
    })[0].index;
}
/**
 * Determine the score of the given partial component order in the given component order.
 * @param componentOrder A quad component order.
 * @param partialComponentOrder A partial quad component order that originates from a quad pattern.
 */ function $1066370f59692308$var$getComponentOrderScore(componentOrder, partialComponentOrder) {
    return componentOrder.map(function(order, i) {
        return partialComponentOrder.includes(order) ? componentOrder.length - i : 0;
    }).reduce(function(acc, add) {
        return acc + add;
    }, 0);
}
/**
 * Order a quad pattern's terms based on the given component order.
 * @param desiredComponentOrder The desired order of components.
 * @param quadPattern A quad pattern.
 */ function $1066370f59692308$var$orderQuadComponents(desiredComponentOrder, quadPattern) {
    return desiredComponentOrder.map(function(desiredComponent) {
        var desiredComponentIndex = module.exports.QUAD_TERM_NAMES_INVERSE[desiredComponent];
        return quadPattern[desiredComponentIndex];
    });
}
/**
 * Encode the given array of quad terms.
 * @param terms Non-encoded quad terms.
 * @param dictionary A dictionary
 * @return array An array of encoded terms.
 * The array will be undefined if at least one of the patterns does not occur within the dictionary.
 */ function $1066370f59692308$var$encodeOptionalTerms(terms, dictionary) {
    var encodedTerms = terms.map(function(term) {
        if (term) {
            if (term.termType === 'Quad' && $1066370f59692308$var$quadHasVariables(term)) return;
            var encodedTerm = dictionary.encodeOptional(term);
            if (encodedTerm === undefined) return 'none';
            return encodedTerm;
        }
        return term;
    });
    if (encodedTerms.includes('none')) return undefined;
    return encodedTerms;
}
/**
 * Convert a quad patter to a `QuadPatternTerms` type.
 * @param subject The subject.
 * @param predicate The predicate.
 * @param object The object.
 * @param graph The graph.
 * @param quotedPatterns If the index supports quoted triple filtering.
 * @return Tuple A tuple of QuadPatternTerms
 *               and a boolean indicating if post-filtering will be needed on quoted triples.
 *               This boolean can only be true if `quotedPatterns` is false, and a quoted triple pattern was present.
 */ function $1066370f59692308$var$quadToPattern(subject, predicate, object, graph, quotedPatterns) {
    var requireQuotedTripleFiltering = false;
    var quadPatternTerms = [
        subject || undefined,
        predicate || undefined,
        object || undefined,
        graph || undefined
    ].map(function(term) {
        if (term) {
            if (term.termType === 'Variable') return;
            if (term.termType === 'Quad') {
                if (quotedPatterns) return term;
                requireQuotedTripleFiltering = true;
                return;
            }
        }
        return term;
    });
    return [
        quadPatternTerms,
        requireQuotedTripleFiltering
    ];
}
/**
 * Check if the given quad contains variables, even in deeply nested quoted triples.
 * @param currentTerm The quad pattern term.
 */ function $1066370f59692308$var$quadHasVariables(currentTerm) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $krcR9.QUAD_TERM_NAMES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            var subTerm = currentTerm[component];
            if (subTerm.termType === 'Variable' || subTerm.termType === 'Quad' && $1066370f59692308$var$quadHasVariables(subTerm)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Create a boolean array indicating which terms are quoted triple patterns.
 * @param terms An array of terms.
 */ function $1066370f59692308$var$arePatternsQuoted(terms) {
    return terms.map(function(term) {
        return (term === null || term === void 0 ? void 0 : term.termType) === 'Quad' && $1066370f59692308$var$quadHasVariables(term);
    });
}

});



parcelRegister("6z0Kq", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapQuoted = void 0;

var $1piaa = parcelRequire("1piaa");

var $7Glct = parcelRequire("7Glct");
/**
 * An RDF store index that is implemented using nested Maps with optimized quoted triple support.
 */ var $4c76977a85cca183$var$RdfStoreIndexNestedMapQuoted = /*#__PURE__*/ function(_RdfStoreIndexNestedMap_1_RdfStoreIndexNestedMap) {
    (0, $i3fW3._)(RdfStoreIndexNestedMapQuoted, _RdfStoreIndexNestedMap_1_RdfStoreIndexNestedMap);
    function RdfStoreIndexNestedMapQuoted(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedMapQuoted);
        var _this;
        _this = (0, $kzDuW._)(this, RdfStoreIndexNestedMapQuoted, [
            options
        ]);
        _this.features = {
            quotedTripleFiltering: true
        };
        return _this;
    }
    (0, $byiyg._)(RdfStoreIndexNestedMapQuoted, [
        {
            key: "getQuotedPatternKeys",
            value: function getQuotedPatternKeys(map, term) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, quotedTripleEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.dictionary.findQuotedTriplesEncoded(term)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            quotedTripleEncoded = _step.value;
                            if (!map.has(quotedTripleEncoded)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                quotedTripleEncoded
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "find",
            value: function find(terms) {
                var ids, _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, _ref, quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3, partialQuad0, partialQuad1, partialQuad2, partialQuad3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                            if (!ids) return [
                                2
                            ];
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                            map0 = this.nestedMap;
                            map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
                                id0
                            ] : [] : map0.keys();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0.get(key1);
                            partialQuad0 = !quotedTerm0 && term0 ? term0 : this.dictionary.decode(key1);
                            map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                                id1
                            ] : [] : map1.keys();
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1.get(key2);
                            partialQuad1 = !quotedTerm1 && term1 ? term1 : this.dictionary.decode(key2);
                            map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                                id2
                            ] : [] : map2.keys();
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2.get(key3);
                            partialQuad2 = !quotedTerm2 && term2 ? term2 : this.dictionary.decode(key3);
                            map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : map3.has(id3) ? [
                                id3
                            ] : [] : map3.keys();
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            partialQuad3 = !quotedTerm3 && term3 ? term3 : this.dictionary.decode(key4);
                            return [
                                4,
                                [
                                    partialQuad0,
                                    partialQuad1,
                                    partialQuad2,
                                    partialQuad3
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findEncoded",
            value: // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
            function findEncoded(ids, terms) {
                var _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, _ref, quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                            map0 = this.nestedMap;
                            map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
                                id0
                            ] : [] : map0.keys();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0.get(key1);
                            map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                                id1
                            ] : [] : map1.keys();
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1.get(key2);
                            map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                                id2
                            ] : [] : map2.keys();
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2.get(key3);
                            map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : map3.has(id3) ? [
                                id3
                            ] : [] : map3.keys();
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            return [
                                4,
                                [
                                    Number.parseInt(key1, 10),
                                    Number.parseInt(key2, 10),
                                    Number.parseInt(key3, 10),
                                    Number.parseInt(key4, 10)
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "count",
            value: function count(terms) {
                var count = 0;
                var ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                if (!ids) return 0;
                var _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                var _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                var _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                var map1;
                var map2;
                var map3;
                var map0 = this.nestedMap;
                var map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
                    id0
                ] : [] : map0.keys();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = map0Keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        map1 = map0.get(key1);
                        var map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                            id1
                        ] : [] : map1.keys();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = map1Keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var key2 = _step1.value;
                                map2 = map1.get(key2);
                                var map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                                    id2
                                ] : [] : map2.keys();
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = map2Keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var key3 = _step2.value;
                                        map3 = map2.get(key3);
                                        if (term3 !== undefined) {
                                            if (quotedTerm3) count += (0, $7WNf6._)(this.getQuotedPatternKeys(map3, term3)).length;
                                            else if (map3.has(id3)) count++;
                                        } else count += map3.size;
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedMapQuoted;
}($7Glct.RdfStoreIndexNestedMap);
module.exports.RdfStoreIndexNestedMapQuoted = $4c76977a85cca183$var$RdfStoreIndexNestedMapQuoted;

});



parcelRegister("4J2KA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ctYJR", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberMap = void 0;

var $a2toU = parcelRequire("a2toU");

var $jqHHT = parcelRequire("jqHHT");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Map.
 */ var $91674eea34c597a5$var$TermDictionaryNumberMap = /*#__PURE__*/ function() {
    function TermDictionaryNumberMap() {
        var dataFactory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryNumberMap);
        this.lastId = 0;
        this.dictionary = new Map();
        this.reverseDictionary = new Map();
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryNumberMap, [
        {
            key: "encode",
            value: function encode(term) {
                var key = (0, $jqHHT.termToString)(term);
                var encoded = this.dictionary.get(key);
                if (encoded === undefined) {
                    encoded = this.lastId++;
                    this.dictionary.set(key, encoded);
                    this.reverseDictionary.set(encoded, key);
                }
                return encoded;
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                var key = (0, $jqHHT.termToString)(term);
                return this.dictionary.get(key);
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                var string = this.reverseDictionary.get(encoding);
                if (string === undefined) throw new Error("The value ".concat(encoding, " is not present in this dictionary"));
                return (0, $jqHHT.stringToTerm)(string, this.dataFactory);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                return this.reverseDictionary.keys();
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                throw new Error('findQuotedTriples is not supported');
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                throw new Error('findQuotedTriplesEncoded is not supported');
            }
        }
    ]);
    return TermDictionaryNumberMap;
}();
module.exports.TermDictionaryNumberMap = $91674eea34c597a5$var$TermDictionaryNumberMap;

});

parcelRegister("b7OH2", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberRecord = void 0;

var $a2toU = parcelRequire("a2toU");

var $jqHHT = parcelRequire("jqHHT");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Record.
 */ var $8197abc2737030c9$var$TermDictionaryNumberRecord = /*#__PURE__*/ function() {
    function TermDictionaryNumberRecord() {
        var dataFactory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryNumberRecord);
        this.lastId = 0;
        this.dictionary = {};
        this.reverseDictionary = {};
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryNumberRecord, [
        {
            key: "encode",
            value: function encode(term) {
                var key = (0, $jqHHT.termToString)(term);
                var encoded = this.dictionary[key];
                if (encoded === undefined) {
                    encoded = this.lastId++;
                    this.dictionary[key] = encoded;
                    this.reverseDictionary[encoded] = key;
                }
                return encoded;
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                var key = (0, $jqHHT.termToString)(term);
                return this.dictionary[key];
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                var string = this.reverseDictionary[encoding];
                if (string === undefined) throw new Error("The value ".concat(encoding, " is not present in this dictionary"));
                return (0, $jqHHT.stringToTerm)(string, this.dataFactory);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = Object.keys(this.reverseDictionary)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            key = _step.value;
                            return [
                                4,
                                Number.parseInt(key, 10)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                throw new Error('findQuotedTriples is not supported');
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                throw new Error('findQuotedTriplesEncoded is not supported');
            }
        }
    ]);
    return TermDictionaryNumberRecord;
}();
module.exports.TermDictionaryNumberRecord = $8197abc2737030c9$var$TermDictionaryNumberRecord;

});

parcelRegister("izGEL", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuoted = void 0;

var $a2toU = parcelRequire("a2toU");

var $krcR9 = parcelRequire("krcR9");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms and quoted triples are stored in separate dictionaries.
 *
 * Finding quoted triples is done by iterating over all quoted triples, and filtering by the matching ones.
 */ var $d85c9594acf0a04f$var$TermDictionaryQuoted = /*#__PURE__*/ function() {
    function TermDictionaryQuoted(plainTermDictionary, quotedTriplesDictionary) {
        var dataFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryQuoted);
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = plainTermDictionary;
        this.quotedTriplesDictionary = quotedTriplesDictionary;
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryQuoted, [
        {
            key: "encode",
            value: function encode(term) {
                if (term.termType === 'Quad') // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                return TermDictionaryQuoted.BITMASK | 1 + this.quotedTriplesDictionary.encode(term);
                return this.plainTermDictionary.encode(term);
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                if (term.termType === 'Quad') {
                    var encoding = this.quotedTriplesDictionary.encodeOptional(term);
                    if (encoding === undefined) return encoding;
                    // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                    return TermDictionaryQuoted.BITMASK | 1 + encoding;
                }
                return this.plainTermDictionary.encodeOptional(term);
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                if (TermDictionaryQuoted.BITMASK & encoding) {
                    // Term comes from the quoted triples dictionary
                    var encodingBase = (~TermDictionaryQuoted.BITMASK & encoding) - 1;
                    return this.quotedTriplesDictionary.decode(encodingBase);
                }
                // Term comes from the plain terms dictionary
                return this.plainTermDictionary.decode(encoding);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, encoding, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, encoding1, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.plainTermDictionary.encodings()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            encoding = _step.value;
                            return [
                                4,
                                encoding
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 9;
                        case 9:
                            _state.trys.push([
                                9,
                                14,
                                15,
                                16
                            ]);
                            _iterator1 = this.quotedTriplesDictionary.encodings()[Symbol.iterator]();
                            _state.label = 10;
                        case 10:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                13
                            ];
                            encoding1 = _step1.value;
                            return [
                                4,
                                TermDictionaryQuoted.BITMASK | 1 + encoding1
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                10
                            ];
                        case 13:
                            return [
                                3,
                                16
                            ];
                        case 14:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                16
                            ];
                        case 15:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 16:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, termEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.findQuotedTriplesEncoded(quotedTriplePattern)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            termEncoded = _step.value;
                            return [
                                4,
                                this.decode(termEncoded)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, encodedQuotedTriple, quotedTriple, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.quotedTriplesDictionary.encodings()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            encodedQuotedTriple = _step.value;
                            encodedQuotedTriple = TermDictionaryQuoted.BITMASK | 1 + encodedQuotedTriple;
                            quotedTriple = this.decode(encodedQuotedTriple);
                            if (!(0, $krcR9.matchPattern)(quotedTriple, quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                encodedQuotedTriple
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return TermDictionaryQuoted;
}();
module.exports.TermDictionaryQuoted = $d85c9594acf0a04f$var$TermDictionaryQuoted;
$d85c9594acf0a04f$var$TermDictionaryQuoted.BITMASK = -2147483648;

});

parcelRegister("75SyU", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuotedReferential = void 0;

var $a2toU = parcelRequire("a2toU");

var $krcR9 = parcelRequire("krcR9");

var $1piaa = parcelRequire("1piaa");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms and quoted triples are stored in separate dictionaries,
 * but quoted triples are encoded using encodings from the plain term dictionary.
 *
 * Finding quoted triples is done by iterating over all quoted triples, and filtering by the matching ones.
 */ var $52a352e9f0614032$var$TermDictionaryQuotedReferential = /*#__PURE__*/ function() {
    function TermDictionaryQuotedReferential(plainTermDictionary) {
        var dataFactory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionaryQuotedReferential);
        this.quotedTriplesDictionary = [];
        this.quotedTriplesReverseDictionary = {};
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = plainTermDictionary;
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionaryQuotedReferential, [
        {
            key: "encode",
            value: function encode(term) {
                if (term.termType === 'Quad') return this.encodeQuotedTriple(term, false);
                return this.plainTermDictionary.encode(term);
            }
        },
        {
            key: "encodeQuotedTriple",
            value: function encodeQuotedTriple(quad, optional) {
                var _this;
                // Only quoted triples are supported
                if (quad.graph.termType !== 'DefaultGraph') throw new Error('Encoding of quoted quads outside of the default graph is not allowed');
                // Check if the quad was already encoded
                var encodedTripleOptional = (_this = (0, $1piaa.encodeOptionalTerms)([
                    quad.subject,
                    quad.predicate,
                    quad.object,
                    undefined
                ], this)) === null || _this === void 0 ? void 0 : _this.slice(0, 3);
                var id = encodedTripleOptional && encodedTripleOptional.every(function(encoded) {
                    return encoded !== undefined;
                }) ? this.quotedTriplesReverseDictionary[encodedTripleOptional.join(TermDictionaryQuotedReferential.SEPARATOR)] : undefined;
                // Return the encoding if we found one
                if (id !== undefined || optional) // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                return id === undefined ? undefined : TermDictionaryQuotedReferential.BITMASK | id;
                // If the quad was not encoded yet, add a new entry for it in the dictionary.
                var encodedTriple = [
                    this.encode(quad.subject),
                    this.encode(quad.predicate),
                    this.encode(quad.object)
                ];
                var encodingBase = this.quotedTriplesDictionary.length + 1;
                this.quotedTriplesDictionary.push(encodedTriple);
                this.quotedTriplesReverseDictionary[encodedTriple.join(TermDictionaryQuotedReferential.SEPARATOR)] = encodingBase;
                // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
                return TermDictionaryQuotedReferential.BITMASK | encodingBase;
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                if (term.termType === 'Quad') return this.encodeQuotedTriple(term, true);
                return this.plainTermDictionary.encodeOptional(term);
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                if (TermDictionaryQuotedReferential.BITMASK & encoding) {
                    // Term comes from the quoted triples dictionary
                    var encodingBase = (~TermDictionaryQuotedReferential.BITMASK & encoding) - 1;
                    if (encodingBase >= this.quotedTriplesDictionary.length) throw new Error("The value ".concat(encoding, " is not present in the quoted triples range of the dictionary"));
                    var encodedTerms = this.quotedTriplesDictionary[encodingBase];
                    return this.dataFactory.quad(this.decode(encodedTerms[0]), this.decode(encodedTerms[1]), this.decode(encodedTerms[2]));
                }
                // Term comes from the plain terms dictionary
                return this.plainTermDictionary.decode(encoding);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, encoding, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, encoding1, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.plainTermDictionary.encodings()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            encoding = _step.value;
                            return [
                                4,
                                encoding
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 9;
                        case 9:
                            _state.trys.push([
                                9,
                                14,
                                15,
                                16
                            ]);
                            _iterator1 = this.quotedTriplesDictionary.keys()[Symbol.iterator]();
                            _state.label = 10;
                        case 10:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                13
                            ];
                            encoding1 = _step1.value;
                            return [
                                4,
                                TermDictionaryQuotedReferential.BITMASK | 1 + encoding1
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                10
                            ];
                        case 13:
                            return [
                                3,
                                16
                            ];
                        case 14:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                16
                            ];
                        case 15:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 16:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, termEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.findQuotedTriplesEncoded(quotedTriplePattern)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            termEncoded = _step.value;
                            return [
                                4,
                                this.decode(termEncoded)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, encodedQuotedTriple, quotedTriple, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.quotedTriplesDictionary.keys()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            encodedQuotedTriple = _step.value;
                            encodedQuotedTriple = TermDictionaryQuotedReferential.BITMASK | 1 + encodedQuotedTriple;
                            quotedTriple = this.decode(encodedQuotedTriple);
                            if (!(0, $krcR9.matchPattern)(quotedTriple, quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                encodedQuotedTriple
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return TermDictionaryQuotedReferential;
}();
module.exports.TermDictionaryQuotedReferential = $52a352e9f0614032$var$TermDictionaryQuotedReferential;
$52a352e9f0614032$var$TermDictionaryQuotedReferential.BITMASK = -2147483648;
$52a352e9f0614032$var$TermDictionaryQuotedReferential.SEPARATOR = '_';

});

parcelRegister("d6idF", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionarySymbol = void 0;

var $a2toU = parcelRequire("a2toU");

var $jqHHT = parcelRequire("jqHHT");
/**
 * A term dictionary that encodes and decodes using symbols.
 */ var $9899f7e937a54758$var$TermDictionarySymbol = /*#__PURE__*/ function() {
    function TermDictionarySymbol() {
        var dataFactory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $a2toU.DataFactory();
        (0, $jGAMp._)(this, TermDictionarySymbol);
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
    (0, $byiyg._)(TermDictionarySymbol, [
        {
            key: "encode",
            value: function encode(term) {
                return Symbol["for"]("rdf::".concat((0, $jqHHT.termToString)(term)));
            }
        },
        {
            key: "encodeOptional",
            value: function encodeOptional(term) {
                return this.encode(term);
            }
        },
        {
            key: "decode",
            value: function decode(encoding) {
                var string = Symbol.keyFor(encoding);
                if (string === undefined) throw new Error("The value ".concat(String(encoding), " is not present in this dictionary"));
                return (0, $jqHHT.stringToTerm)(string.slice(5), this.dataFactory);
            }
        },
        {
            key: "encodings",
            value: function encodings() {
                throw new Error('encodings is not supported');
            }
        },
        {
            key: "findQuotedTriples",
            value: function findQuotedTriples(quotedTriplePattern) {
                throw new Error('findQuotedTriples is not supported');
            }
        },
        {
            key: "findQuotedTriplesEncoded",
            value: function findQuotedTriplesEncoded(quotedTriplePattern) {
                throw new Error('findQuotedTriplesEncoded is not supported');
            }
        }
    ]);
    return TermDictionarySymbol;
}();
module.exports.TermDictionarySymbol = $9899f7e937a54758$var$TermDictionarySymbol;

});

parcelRegister("cX0Zg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e3uKE", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapRecursive = void 0;

var $1piaa = parcelRequire("1piaa");
/**
 * An RDF store index that is implemented using nested Maps,
 * and finds quads components via recursive methods calls.
 */ var $a3b9331afbd83cbd$var$RdfStoreIndexNestedMapRecursive = /*#__PURE__*/ function() {
    function RdfStoreIndexNestedMapRecursive(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedMapRecursive);
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedMap = new Map();
    }
    (0, $byiyg._)(RdfStoreIndexNestedMapRecursive, [
        {
            key: "set",
            value: function set(terms, value) {
                var map = this.nestedMap;
                var contained = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = terms.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], term = _step_value[1];
                        var mapActual = map;
                        var nextMap = mapActual.get(term);
                        if (!nextMap) {
                            nextMap = i === terms.length - 1 ? value : new Map();
                            mapActual.set(term, nextMap);
                        } else if (i === terms.length - 1) contained = true;
                        map = nextMap;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !contained;
            }
        },
        {
            key: "remove",
            value: function remove(terms) {
                var map0 = this.nestedMap;
                var map1 = map0.get(terms[0]);
                if (!map1) return false;
                var map2 = map1.get(terms[1]);
                if (!map2) return false;
                var map3 = map2.get(terms[2]);
                if (!map3) return false;
                var ret = map3["delete"](terms[3]);
                // Clean up intermediate maps
                if (ret && map3.size === 0) {
                    map2["delete"](terms[2]);
                    if (map2.size === 0) {
                        map1["delete"](terms[1]);
                        if (map1.size === 0) map0["delete"](terms[0]);
                    }
                }
                return ret;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var encoded = (0, $1piaa.encodeOptionalTerms)(key, this.dictionary);
                // eslint-disable-next-line unicorn/no-useless-undefined
                if (!encoded || encoded.includes(undefined)) return undefined;
                return this.getEncoded(encoded);
            }
        },
        {
            key: "getEncoded",
            value: function getEncoded(ids) {
                var map1 = this.nestedMap.get(ids[0]);
                if (!map1) return undefined;
                var map2 = map1.get(ids[1]);
                if (!map2) return undefined;
                var map3 = map2.get(ids[2]);
                if (!map3) return undefined;
                return map3.get(ids[3]);
            }
        },
        {
            key: "find",
            value: function find(terms) {
                var ids, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, termsEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                            if (!ids) return [
                                2
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.findEncoded(ids, terms)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            termsEncoded = _step.value;
                            return [
                                4,
                                [
                                    ids[0] !== undefined ? terms[0] : this.dictionary.decode(termsEncoded[0]),
                                    ids[1] !== undefined ? terms[1] : this.dictionary.decode(termsEncoded[1]),
                                    ids[2] !== undefined ? terms[2] : this.dictionary.decode(termsEncoded[2]),
                                    ids[3] !== undefined ? terms[3] : this.dictionary.decode(termsEncoded[3])
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findEncoded",
            value: function findEncoded(ids, terms) {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInner(0, ids, terms, this.nestedMap, []))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            }
        },
        {
            key: "findEncodedInner",
            value: function findEncodedInner(index, ids, terms, map, partialQuad) {
                var id, currentTerm, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, subMap, err, encodedTerm, subMap1;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(index === ids.length)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $7WNf6._)(partialQuad)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                13
                            ];
                        case 2:
                            id = ids[index];
                            currentTerm = terms[index];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!!currentTerm) return [
                                3,
                                11
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = map.entries()[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], subMap = _step_value[1];
                            partialQuad[index] = key;
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInner(index + 1, ids, terms, subMap, partialQuad))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                3,
                                13
                            ];
                        case 11:
                            // If the current term is defined, find one matching map for the current term.
                            encodedTerm = id;
                            if (!(encodedTerm !== undefined)) return [
                                3,
                                13
                            ];
                            subMap1 = map.get(encodedTerm);
                            if (!subMap1) return [
                                3,
                                13
                            ];
                            partialQuad[index] = id;
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInner(index + 1, ids, terms, subMap1, partialQuad))
                            ];
                        case 12:
                            _state.sent();
                            _state.label = 13;
                        case 13:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "count",
            value: function count(terms) {
                return this.countInner(0, terms, this.nestedMap);
            }
        },
        {
            key: "countInner",
            value: function countInner(index, terms, map) {
                var currentTerm = terms[index];
                var count = 0;
                // If current term is undefined, iterate over all terms at this level.
                if (!currentTerm) {
                    if (index === terms.length - 1) return map.size;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = map.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var subMap = _step.value;
                            count += this.countInner(index + 1, terms, subMap);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    // If the current term is defined, find one matching map for the current term.
                    var encodedTerm = this.dictionary.encodeOptional(currentTerm);
                    if (encodedTerm !== undefined) {
                        if (index === terms.length - 1) {
                            if (map.has(encodedTerm)) return 1;
                            return 0;
                        }
                        var subMap1 = map.get(encodedTerm);
                        if (subMap1) count += this.countInner(index + 1, terms, subMap1);
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedMapRecursive;
}();
module.exports.RdfStoreIndexNestedMapRecursive = $a3b9331afbd83cbd$var$RdfStoreIndexNestedMapRecursive;

});

parcelRegister("hdfVO", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapRecursiveQuoted = void 0;

var $1piaa = parcelRequire("1piaa");

var $e3uKE = parcelRequire("e3uKE");
/**
 * An RDF store index that is implemented using nested Maps,
 * and finds quads components via recursive methods calls
 * with optimized quoted triple support.
 */ var $c880023def22db5e$var$RdfStoreIndexNestedMapRecursiveQuoted = /*#__PURE__*/ function(_RdfStoreIndexNestedMapRecursive_1_RdfStoreIndexNestedMapRecursive) {
    (0, $i3fW3._)(RdfStoreIndexNestedMapRecursiveQuoted, _RdfStoreIndexNestedMapRecursive_1_RdfStoreIndexNestedMapRecursive);
    function RdfStoreIndexNestedMapRecursiveQuoted(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedMapRecursiveQuoted);
        var _this;
        _this = (0, $kzDuW._)(this, RdfStoreIndexNestedMapRecursiveQuoted, [
            options
        ]);
        _this.features = {
            quotedTripleFiltering: true
        };
        return _this;
    }
    (0, $byiyg._)(RdfStoreIndexNestedMapRecursiveQuoted, [
        {
            key: "findEncoded",
            value: function findEncoded(ids, terms) {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInnerQuoted(0, ids, terms, (0, $1piaa.arePatternsQuoted)(terms), this.nestedMap, []))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            }
        },
        {
            key: "findEncodedInnerQuoted",
            value: function findEncodedInnerQuoted(index, ids, terms, isQuotedPattern, map, partialQuad) {
                var id, currentTerm, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, subMap, err, quotedTriplesEncoded, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, quotedTripleEncoded, subMap1, err, encodedTerm, subMap2;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(index === ids.length)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $7WNf6._)(partialQuad)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                22
                            ];
                        case 2:
                            id = ids[index];
                            currentTerm = terms[index];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!!currentTerm) return [
                                3,
                                11
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = map.entries()[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], subMap = _step_value[1];
                            partialQuad[index] = key;
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap, partialQuad))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                3,
                                22
                            ];
                        case 11:
                            if (!isQuotedPattern[index]) return [
                                3,
                                20
                            ];
                            quotedTriplesEncoded = this.dictionary.findQuotedTriplesEncoded(currentTerm);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 12;
                        case 12:
                            _state.trys.push([
                                12,
                                17,
                                18,
                                19
                            ]);
                            _iterator1 = quotedTriplesEncoded[Symbol.iterator]();
                            _state.label = 13;
                        case 13:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                16
                            ];
                            quotedTripleEncoded = _step1.value;
                            subMap1 = map.get(quotedTripleEncoded);
                            if (!subMap1) return [
                                3,
                                15
                            ];
                            partialQuad[index] = quotedTripleEncoded;
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap1, partialQuad))
                            ];
                        case 14:
                            _state.sent();
                            _state.label = 15;
                        case 15:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                13
                            ];
                        case 16:
                            return [
                                3,
                                19
                            ];
                        case 17:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                19
                            ];
                        case 18:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            // If the current term is defined, find one matching map for the current term.
                            encodedTerm = id;
                            if (!(encodedTerm !== undefined)) return [
                                3,
                                22
                            ];
                            subMap2 = map.get(encodedTerm);
                            if (!subMap2) return [
                                3,
                                22
                            ];
                            partialQuad[index] = id;
                            return [
                                5,
                                (0, $9N5UN.__values)(this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap2, partialQuad))
                            ];
                        case 21:
                            _state.sent();
                            _state.label = 22;
                        case 22:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "countInner",
            value: function countInner(index, terms, map) {
                var currentTerm = terms[index];
                var count = 0;
                // If current term is undefined, iterate over all terms at this level.
                if (!currentTerm) {
                    if (index === terms.length - 1) return map.size;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = map.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var subMap = _step.value;
                            count += this.countInner(index + 1, terms, subMap);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if (currentTerm.termType === 'Quad' && (0, $1piaa.quadHasVariables)(currentTerm)) {
                    var quotedTriplesEncoded = this.dictionary.findQuotedTriplesEncoded(currentTerm);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // Below, we perform a type of inner (hash) join between quotedTriplesEncoded and map (with hash on map)
                        for(var _iterator1 = quotedTriplesEncoded[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var quotedTripleEncoded = _step1.value;
                            if (index === terms.length - 1) {
                                if (map.has(quotedTripleEncoded)) count++;
                            } else {
                                var subMap1 = map.get(quotedTripleEncoded);
                                if (subMap1) count += this.countInner(index + 1, terms, subMap1);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else {
                    // If the current term is defined, find one matching map for the current term.
                    var encodedTerm = this.dictionary.encodeOptional(currentTerm);
                    if (encodedTerm !== undefined) {
                        if (index === terms.length - 1) {
                            if (map.has(encodedTerm)) return 1;
                            return 0;
                        }
                        var subMap2 = map.get(encodedTerm);
                        if (subMap2) count += this.countInner(index + 1, terms, subMap2);
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedMapRecursiveQuoted;
}($e3uKE.RdfStoreIndexNestedMapRecursive);
module.exports.RdfStoreIndexNestedMapRecursiveQuoted = $c880023def22db5e$var$RdfStoreIndexNestedMapRecursiveQuoted;

});

parcelRegister("3eNQy", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedRecord = void 0;

var $1piaa = parcelRequire("1piaa");
/**
 * An RDF store index that is implemented using nested records.
 */ var $25b9586507609017$var$RdfStoreIndexNestedRecord = /*#__PURE__*/ function() {
    function RdfStoreIndexNestedRecord(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedRecord);
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedRecords = {};
    }
    (0, $byiyg._)(RdfStoreIndexNestedRecord, [
        {
            key: "set",
            value: function set(terms, value) {
                var map0 = this.nestedRecords;
                var map1 = map0[terms[0]] || (map0[terms[0]] = {});
                var map2 = map1[terms[1]] || (map1[terms[1]] = {});
                var map3 = map2[terms[2]] || (map2[terms[2]] = {});
                if (map3[terms[3]]) return false;
                map3[terms[3]] = value;
                return true;
            }
        },
        {
            key: "remove",
            value: function remove(terms) {
                var map0 = this.nestedRecords;
                var map1 = map0[terms[0]];
                if (!map1) return false;
                var map2 = map1[terms[1]];
                if (!map2) return false;
                var map3 = map2[terms[2]];
                if (!map3) return false;
                if (!map3[terms[3]]) return false;
                delete map3[terms[3]];
                // Clean up intermediate maps
                if (Object.keys(map3).length === 0) {
                    delete map2[terms[2]];
                    if (Object.keys(map2).length === 0) {
                        delete map1[terms[1]];
                        if (Object.keys(map1).length === 0) delete map0[terms[0]];
                    }
                }
                return true;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var encoded = (0, $1piaa.encodeOptionalTerms)(key, this.dictionary);
                // eslint-disable-next-line unicorn/no-useless-undefined
                if (!encoded || encoded.includes(undefined)) return undefined;
                return this.getEncoded(encoded);
            }
        },
        {
            key: "getEncoded",
            value: function getEncoded(ids) {
                var _this_nestedRecords_ids__ids__ids_, _this_nestedRecords_ids__ids_, _this_nestedRecords_ids_;
                return (_this_nestedRecords_ids_ = this.nestedRecords[ids[0]]) === null || _this_nestedRecords_ids_ === void 0 ? void 0 : (_this_nestedRecords_ids__ids_ = _this_nestedRecords_ids_[ids[1]]) === null || _this_nestedRecords_ids__ids_ === void 0 ? void 0 : (_this_nestedRecords_ids__ids__ids_ = _this_nestedRecords_ids__ids_[ids[2]]) === null || _this_nestedRecords_ids__ids__ids_ === void 0 ? void 0 : _this_nestedRecords_ids__ids__ids_[ids[3]];
            }
        },
        {
            key: "find",
            value: function find(terms) {
                var ids, _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, partialQuad0, partialQuad1, partialQuad2, partialQuad3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                            if (!ids) return [
                                2
                            ];
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            map0 = this.nestedRecords;
                            map0Keys = id0 !== undefined ? id0 in map0 ? [
                                id0
                            ] : [] : Object.keys(map0);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0[key1];
                            partialQuad0 = term0 || this.dictionary.decode(Number.parseInt(key1, 10));
                            map1Keys = id1 !== undefined ? id1 in map1 ? [
                                id1
                            ] : [] : Object.keys(map1);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1[key2];
                            partialQuad1 = term1 || this.dictionary.decode(Number.parseInt(key2, 10));
                            map2Keys = id2 !== undefined ? id2 in map2 ? [
                                id2
                            ] : [] : Object.keys(map2);
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2[key3];
                            partialQuad2 = term2 || this.dictionary.decode(Number.parseInt(key3, 10));
                            map3Keys = id3 !== undefined ? id3 in map3 ? [
                                id3
                            ] : [] : Object.keys(map3);
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            partialQuad3 = term3 || this.dictionary.decode(Number.parseInt(key4, 10));
                            return [
                                4,
                                [
                                    partialQuad0,
                                    partialQuad1,
                                    partialQuad2,
                                    partialQuad3
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findEncoded",
            value: // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
            function findEncoded(ids, terms) {
                var _ids, id0, id1, id2, id3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            map0 = this.nestedRecords;
                            map0Keys = id0 !== undefined ? id0 in map0 ? [
                                id0
                            ] : [] : Object.keys(map0);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0[key1];
                            map1Keys = id1 !== undefined ? id1 in map1 ? [
                                id1
                            ] : [] : Object.keys(map1);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1[key2];
                            map2Keys = id2 !== undefined ? id2 in map2 ? [
                                id2
                            ] : [] : Object.keys(map2);
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2[key3];
                            map3Keys = id3 !== undefined ? id3 in map3 ? [
                                id3
                            ] : [] : Object.keys(map3);
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            return [
                                4,
                                [
                                    Number.parseInt(key1, 10),
                                    Number.parseInt(key2, 10),
                                    Number.parseInt(key3, 10),
                                    Number.parseInt(key4, 10)
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "count",
            value: function count(terms) {
                var count = 0;
                var ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                if (!ids) return 0;
                var id0 = ids[0];
                var id1 = ids[1];
                var id2 = ids[2];
                var id3 = ids[3];
                var map1;
                var map2;
                var map3;
                var map0 = this.nestedRecords;
                var map0Keys = id0 !== undefined ? id0 in map0 ? [
                    id0
                ] : [] : Object.keys(map0);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = map0Keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        map1 = map0[key1];
                        var map1Keys = id1 !== undefined ? id1 in map1 ? [
                            id1
                        ] : [] : Object.keys(map1);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = map1Keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var key2 = _step1.value;
                                map2 = map1[key2];
                                var map2Keys = id2 !== undefined ? id2 in map2 ? [
                                    id2
                                ] : [] : Object.keys(map2);
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = map2Keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var key3 = _step2.value;
                                        map3 = map2[key3];
                                        if (id3 !== undefined) {
                                            if (id3 in map3) count++;
                                        } else count += Object.keys(map3).length;
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedRecord;
}();
module.exports.RdfStoreIndexNestedRecord = $25b9586507609017$var$RdfStoreIndexNestedRecord;

});

parcelRegister("djUsB", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedRecordQuoted = void 0;

var $1piaa = parcelRequire("1piaa");

var $3eNQy = parcelRequire("3eNQy");
/**
 * An RDF store index that is implemented using nested records with optimized quoted triple support.
 */ var $9b28d8880127061d$var$RdfStoreIndexNestedRecordQuoted = /*#__PURE__*/ function(_RdfStoreIndexNestedRecord_1_RdfStoreIndexNestedRecord) {
    (0, $i3fW3._)(RdfStoreIndexNestedRecordQuoted, _RdfStoreIndexNestedRecord_1_RdfStoreIndexNestedRecord);
    function RdfStoreIndexNestedRecordQuoted(options) {
        (0, $jGAMp._)(this, RdfStoreIndexNestedRecordQuoted);
        var _this;
        _this = (0, $kzDuW._)(this, RdfStoreIndexNestedRecordQuoted, [
            options
        ]);
        _this.features = {
            quotedTripleFiltering: true
        };
        return _this;
    }
    (0, $byiyg._)(RdfStoreIndexNestedRecordQuoted, [
        {
            key: "getQuotedPatternKeys",
            value: function getQuotedPatternKeys(map, term) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, quotedTripleEncoded, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.dictionary.findQuotedTriplesEncoded(term)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            quotedTripleEncoded = _step.value;
                            if (!(quotedTripleEncoded in map)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                quotedTripleEncoded
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "find",
            value: function find(terms) {
                var ids, _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, _ref, quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3, partialQuad0, partialQuad1, partialQuad2, partialQuad3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                            if (!ids) return [
                                2
                            ];
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                            map0 = this.nestedRecords;
                            map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
                                id0
                            ] : [] : Object.keys(map0);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0[key1];
                            partialQuad0 = !quotedTerm0 && term0 ? term0 : this.dictionary.decode(Number.parseInt(key1, 10));
                            map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                                id1
                            ] : [] : Object.keys(map1);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1[key2];
                            partialQuad1 = !quotedTerm1 && term1 ? term1 : this.dictionary.decode(Number.parseInt(key2, 10));
                            map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                                id2
                            ] : [] : Object.keys(map2);
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2[key3];
                            partialQuad2 = !quotedTerm2 && term2 ? term2 : this.dictionary.decode(Number.parseInt(key3, 10));
                            map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : id3 in map3 ? [
                                id3
                            ] : [] : Object.keys(map3);
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            partialQuad3 = !quotedTerm3 && term3 ? term3 : this.dictionary.decode(Number.parseInt(key4, 10));
                            return [
                                4,
                                [
                                    partialQuad0,
                                    partialQuad1,
                                    partialQuad2,
                                    partialQuad3
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "findEncoded",
            value: // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
            function findEncoded(ids, terms) {
                var _ids, id0, id1, id2, id3, _terms, term0, term1, term2, term3, _ref, quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3, map1, map2, map3, map0, map0Keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key1, map1Keys, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key2, map2Keys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key3, map3Keys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key4, err, err, err, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                            _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                            _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                            map0 = this.nestedRecords;
                            map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
                                id0
                            ] : [] : Object.keys(map0);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                24,
                                25,
                                26
                            ]);
                            _iterator = map0Keys[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                23
                            ];
                            key1 = _step.value;
                            map1 = map0[key1];
                            map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                                id1
                            ] : [] : Object.keys(map1);
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                20,
                                21,
                                22
                            ]);
                            _iterator1 = map1Keys[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                19
                            ];
                            key2 = _step1.value;
                            map2 = map1[key2];
                            map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                                id2
                            ] : [] : Object.keys(map2);
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                16,
                                17,
                                18
                            ]);
                            _iterator2 = map2Keys[Symbol.iterator]();
                            _state.label = 6;
                        case 6:
                            if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                3,
                                15
                            ];
                            key3 = _step2.value;
                            map3 = map2[key3];
                            map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : id3 in map3 ? [
                                id3
                            ] : [] : Object.keys(map3);
                            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            _state.label = 7;
                        case 7:
                            _state.trys.push([
                                7,
                                12,
                                13,
                                14
                            ]);
                            _iterator3 = map3Keys[Symbol.iterator]();
                            _state.label = 8;
                        case 8:
                            if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                3,
                                11
                            ];
                            key4 = _step3.value;
                            return [
                                4,
                                [
                                    Number.parseInt(key1, 10),
                                    Number.parseInt(key2, 10),
                                    Number.parseInt(key3, 10),
                                    Number.parseInt(key4, 10)
                                ]
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            _iteratorNormalCompletion3 = true;
                            return [
                                3,
                                8
                            ];
                        case 11:
                            return [
                                3,
                                14
                            ];
                        case 12:
                            err = _state.sent();
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                            return [
                                3,
                                14
                            ];
                        case 13:
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                                    _iterator3["return"]();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                            return [
                                7
                            ];
                        case 14:
                            _iteratorNormalCompletion2 = true;
                            return [
                                3,
                                6
                            ];
                        case 15:
                            return [
                                3,
                                18
                            ];
                        case 16:
                            err = _state.sent();
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                            return [
                                3,
                                18
                            ];
                        case 17:
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                    _iterator2["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                            return [
                                7
                            ];
                        case 18:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                4
                            ];
                        case 19:
                            return [
                                3,
                                22
                            ];
                        case 20:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                22
                            ];
                        case 21:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 22:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 23:
                            return [
                                3,
                                26
                            ];
                        case 24:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                26
                            ];
                        case 25:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 26:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "count",
            value: function count(terms) {
                var count = 0;
                var ids = (0, $1piaa.encodeOptionalTerms)(terms, this.dictionary);
                if (!ids) return 0;
                var _ids = (0, $32TW8._)(ids, 4), id0 = _ids[0], id1 = _ids[1], id2 = _ids[2], id3 = _ids[3];
                var _terms = (0, $32TW8._)(terms, 4), term0 = _terms[0], term1 = _terms[1], term2 = _terms[2], term3 = _terms[3];
                var _ref = (0, $32TW8._)((0, $1piaa.arePatternsQuoted)(terms), 4), quotedTerm0 = _ref[0], quotedTerm1 = _ref[1], quotedTerm2 = _ref[2], quotedTerm3 = _ref[3];
                var map1;
                var map2;
                var map3;
                var map0 = this.nestedRecords;
                var map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
                    id0
                ] : [] : Object.keys(map0);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = map0Keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        map1 = map0[key1];
                        var map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                            id1
                        ] : [] : Object.keys(map1);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = map1Keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var key2 = _step1.value;
                                map2 = map1[key2];
                                var map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                                    id2
                                ] : [] : Object.keys(map2);
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = map2Keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var key3 = _step2.value;
                                        map3 = map2[key3];
                                        if (term3 !== undefined) {
                                            if (quotedTerm3) count += (0, $7WNf6._)(this.getQuotedPatternKeys(map3, term3)).length;
                                            else if (id3 in map3) count++;
                                        } else count += Object.keys(map3).length;
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        }
    ]);
    return RdfStoreIndexNestedRecordQuoted;
}($3eNQy.RdfStoreIndexNestedRecord);
module.exports.RdfStoreIndexNestedRecordQuoted = $9b28d8880127061d$var$RdfStoreIndexNestedRecordQuoted;

});

parcelRegister("1wE43", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4rUME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("7YkOv", function(module, exports) {
"use strict";
var $5cde482c2b7878db$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5cde482c2b7878db$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5cde482c2b7878db$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5cde482c2b7878db$var$__exportStar((parcelRequire("b0gUv")), module.exports);

});
parcelRegister("b0gUv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorExpressionEvaluatorFactoryDefault = void 0;

var $3v0Ql = parcelRequire("3v0Ql");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $aduX6 = parcelRequire("aduX6");

var $2SxGa = parcelRequire("2SxGa");

var $99asJ = parcelRequire("99asJ");
/**
 * A comunica Default Expression Evaluator Factory Actor.
 */ var $802ccfd886165c8b$var$ActorExpressionEvaluatorFactoryDefault = /*#__PURE__*/ function(_bus_expression_evaluator_factory_1_ActorExpressionEvaluatorFactory) {
    (0, $i3fW3._)(ActorExpressionEvaluatorFactoryDefault, _bus_expression_evaluator_factory_1_ActorExpressionEvaluatorFactory);
    function ActorExpressionEvaluatorFactoryDefault(args) {
        (0, $jGAMp._)(this, ActorExpressionEvaluatorFactoryDefault);
        return (0, $kzDuW._)(this, ActorExpressionEvaluatorFactoryDefault, [
            args
        ]);
    }
    (0, $byiyg._)(ActorExpressionEvaluatorFactoryDefault, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var fullContext, _, _1, _tmp;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fullContext = (0, $aduX6.prepareEvaluatorActionContext)(action.context);
                                _1 = (_ = $99asJ.ExpressionEvaluator).bind;
                                _tmp = [
                                    void 0,
                                    fullContext
                                ];
                                return [
                                    4,
                                    new $2SxGa.AlgebraTransformer(fullContext, this.mediatorFunctionFactory).transformAlgebra(action.algExpr)
                                ];
                            case 1:
                                _tmp = _tmp.concat([
                                    _state.sent(),
                                    this.mediatorFunctionFactory,
                                    this.mediatorQueryOperation
                                ]);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, action.context.getSafe($9nBhR.KeysInitQuery.dataFactory))
                                ];
                            case 2:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorExpressionEvaluatorFactoryDefault;
}($3v0Ql.ActorExpressionEvaluatorFactory);
module.exports.ActorExpressionEvaluatorFactoryDefault = $802ccfd886165c8b$var$ActorExpressionEvaluatorFactoryDefault;

});
parcelRegister("3v0Ql", function(module, exports) {
"use strict";
var $28c4ebc7fa738e12$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $28c4ebc7fa738e12$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $28c4ebc7fa738e12$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$28c4ebc7fa738e12$var$__exportStar((parcelRequire("8ZRCD")), module.exports);

});
parcelRegister("8ZRCD", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorExpressionEvaluatorFactory = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for utils-expression-evaluator-factory events.
 *
 * Actor types:
 * * Input:  IActionExpressionEvaluatorFactory: The Query Operation and Function factory mediators.
 * * Test:   <none>
 * * Output: IActorExpressionEvaluatorFactoryOutput: TODO: fill in.
 *
 * @see IActionExpressionEvaluatorFactory
 * @see IActorExpressionEvaluatorFactoryOutput
 */ var $68cd9d742b404c96$var$ActorExpressionEvaluatorFactory = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorExpressionEvaluatorFactory, _core_1_Actor);
    function ActorExpressionEvaluatorFactory(args) {
        (0, $jGAMp._)(this, ActorExpressionEvaluatorFactory);
        var _this;
        _this = (0, $kzDuW._)(this, ActorExpressionEvaluatorFactory, [
            args
        ]);
        _this.mediatorQueryOperation = args.mediatorQueryOperation;
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        _this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
        return _this;
    }
    return ActorExpressionEvaluatorFactory;
}($kNNoa.Actor);
module.exports.ActorExpressionEvaluatorFactory = $68cd9d742b404c96$var$ActorExpressionEvaluatorFactory;

});


parcelRegister("2SxGa", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AlgebraTransformer = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $aduX6 = parcelRequire("aduX6");

var $hSHd8 = parcelRequire("hSHd8");
var $218abfe7b438b919$var$AlgebraTransformer = /*#__PURE__*/ function(_ExprEval_TermTransformer) {
    (0, $i3fW3._)(AlgebraTransformer, _ExprEval_TermTransformer);
    function AlgebraTransformer(context, mediatorFunctionFactory) {
        (0, $jGAMp._)(this, AlgebraTransformer);
        var _this;
        _this = (0, $kzDuW._)(this, AlgebraTransformer, [
            context.getSafe($9nBhR.KeysExpressionEvaluator.superTypeProvider)
        ]);
        _this.context = context;
        _this.mediatorFunctionFactory = mediatorFunctionFactory;
        return _this;
    }
    (0, $byiyg._)(AlgebraTransformer, [
        {
            key: "transformAlgebra",
            value: function transformAlgebra(expr) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var types, _;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                types = $hSHd8.Algebra.expressionTypes;
                                _ = expr.expressionType;
                                switch(_){
                                    case types.TERM:
                                        return [
                                            3,
                                            1
                                        ];
                                    case types.OPERATOR:
                                        return [
                                            3,
                                            2
                                        ];
                                    case types.NAMED:
                                        return [
                                            3,
                                            4
                                        ];
                                    case types.EXISTENCE:
                                        return [
                                            3,
                                            6
                                        ];
                                    case types.AGGREGATE:
                                        return [
                                            3,
                                            7
                                        ];
                                    case types.WILDCARD:
                                        return [
                                            3,
                                            8
                                        ];
                                }
                                return [
                                    3,
                                    9
                                ];
                            case 1:
                                return [
                                    2,
                                    this.transformTerm(expr)
                                ];
                            case 2:
                                return [
                                    4,
                                    this.transformOperator(expr)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    4,
                                    this.transformNamed(expr)
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                return [
                                    2,
                                    AlgebraTransformer.transformExistence(expr)
                                ];
                            case 7:
                                return [
                                    2,
                                    AlgebraTransformer.transformAggregate(expr)
                                ];
                            case 8:
                                return [
                                    2,
                                    AlgebraTransformer.transformWildcard(expr)
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOperator",
            value: function getOperator(operator, expr) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, operatorFunc, operatorArgs;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: operator,
                                        arguments: expr.args,
                                        context: this.context
                                    })
                                ];
                            case 1:
                                operatorFunc = _state.sent();
                                return [
                                    4,
                                    Promise.all(expr.args.map(function(arg) {
                                        return _this.transformAlgebra(arg);
                                    }))
                                ];
                            case 2:
                                operatorArgs = _state.sent();
                                if (!operatorFunc.checkArity(operatorArgs)) throw new $aduX6.InvalidArity(operatorArgs, operator);
                                return [
                                    2,
                                    new $aduX6.Operator(operator, operatorArgs, operatorFunc.apply)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "transformOperator",
            value: function transformOperator(expr) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.getOperator(expr.operator.toLowerCase(), expr)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "transformNamed",
            value: function transformNamed(expr) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            this.getOperator(expr.name.value, expr)
                        ];
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "transformWildcard",
            value: function transformWildcard(term) {
                return new $aduX6.NamedNode(term.wildcard.value);
            }
        },
        {
            key: "transformAggregate",
            value: function transformAggregate(expr) {
                var name = expr.aggregator;
                return new $aduX6.Aggregate(name, expr);
            }
        },
        {
            key: "transformExistence",
            value: function transformExistence(expr) {
                return new $aduX6.Existence(expr);
            }
        }
    ]);
    return AlgebraTransformer;
}($aduX6.TermTransformer);
module.exports.AlgebraTransformer = $218abfe7b438b919$var$AlgebraTransformer;

});

parcelRegister("99asJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionEvaluator = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $5XhaY = parcelRequire("5XhaY");
var $6a8d11f4f80369fb$var$ExpressionEvaluator = /*#__PURE__*/ function() {
    function ExpressionEvaluator(context, expr, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory) {
        (0, $jGAMp._)(this, ExpressionEvaluator);
        this.context = context;
        this.expr = expr;
        this.mediatorFunctionFactory = mediatorFunctionFactory;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.bindingsFactory = bindingsFactory;
        this.internalEvaluator = new $5XhaY.InternalEvaluator(context, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory);
    }
    (0, $byiyg._)(ExpressionEvaluator, [
        {
            key: "evaluate",
            value: function evaluate(mapping) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var result;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.internalEvaluator.evaluatorExpressionEvaluation(this.expr, mapping)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.toRDF(this.context.getSafe($9nBhR.KeysInitQuery.dataFactory))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "evaluateAsEBV",
            value: function evaluateAsEBV(mapping) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var result;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.internalEvaluator.evaluatorExpressionEvaluation(this.expr, mapping)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.coerceEBV()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "evaluateAsEvaluatorExpression",
            value: function evaluateAsEvaluatorExpression(mapping) {
                return this.evaluatorExpressionEvaluation(this.expr, mapping);
            }
        },
        {
            key: "evaluatorExpressionEvaluation",
            value: function evaluatorExpressionEvaluation(expr, mapping) {
                return this.internalEvaluator.evaluatorExpressionEvaluation(expr, mapping);
            }
        }
    ]);
    return ExpressionEvaluator;
}();
module.exports.ExpressionEvaluator = $6a8d11f4f80369fb$var$ExpressionEvaluator;

});
parcelRegister("5XhaY", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternalEvaluator = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $gIvya = parcelRequire("gIvya");

var $aduX6 = parcelRequire("aduX6");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");

var $2SxGa = parcelRequire("2SxGa");
/**
 * This class provides evaluation functionality to already transformed expressions.
 */ var $455fc93a02909cad$var$InternalEvaluator = /*#__PURE__*/ function() {
    function InternalEvaluator(context, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory) {
        var _this = this;
        (0, $jGAMp._)(this, InternalEvaluator);
        this.context = context;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.bindingsFactory = bindingsFactory;
        var _obj;
        this.subEvaluators = (_obj = {}, (0, $cqEAj._)(_obj, $gIvya.ExpressionType.Term, function(expr, _mapping) {
            return _this.term(expr);
        }), (0, $cqEAj._)(_obj, $gIvya.ExpressionType.Variable, function(expr, mapping) {
            return _this.variable(expr, mapping);
        }), (0, $cqEAj._)(_obj, $gIvya.ExpressionType.Operator, function(expr, mapping) {
            return _this.evalFunction(expr, mapping);
        }), (0, $cqEAj._)(_obj, $gIvya.ExpressionType.Existence, function(expr, mapping) {
            return _this.evalExistence(expr, mapping);
        }), (0, $cqEAj._)(_obj, $gIvya.ExpressionType.Aggregate, function(_expr, _mapping) {
            return _this.evalAggregate();
        }), _obj);
        this.transformer = new $2SxGa.AlgebraTransformer(context, mediatorFunctionFactory);
    }
    (0, $byiyg._)(InternalEvaluator, [
        {
            key: "evaluatorExpressionEvaluation",
            value: function evaluatorExpressionEvaluation(expr, mapping) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var evaluator;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        evaluator = this.subEvaluators[expr.expressionType];
                        return [
                            2,
                            evaluator.bind(this)(expr, mapping)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "term",
            value: function term(expr) {
                return expr;
            }
        },
        {
            key: "variable",
            value: function variable(expr, mapping) {
                var term = mapping.get($aduX6.expressionToVar(this.context.getSafe($9nBhR.KeysInitQuery.dataFactory), expr));
                if (!term) throw new $aduX6.UnboundVariableError(expr.name, mapping);
                return this.transformer.transformRDFTermUnsafe(term);
            }
        },
        {
            key: "evalFunction",
            value: function evalFunction(expr, mapping) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            expr.apply({
                                args: expr.args,
                                mapping: mapping,
                                exprEval: this
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "evalExistence",
            value: function evalExistence(expr, mapping) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation, outputRaw, output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = this.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                operation = (0, $2n9RU.materializeOperation)(expr.expression.input, mapping, algebraFactory, this.bindingsFactory);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation,
                                        context: this.context
                                    })
                                ];
                            case 1:
                                outputRaw = _state.sent();
                                output = (0, $2n9RU.getSafeBindings)(outputRaw);
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        output.bindingsStream.on('end', function() {
                                            resolve(false);
                                        });
                                        output.bindingsStream.on('error', reject);
                                        output.bindingsStream.on('data', function() {
                                            output.bindingsStream.close();
                                            resolve(true);
                                        });
                                    }).then(function(exists) {
                                        return expr.expression.not ? !exists : exists;
                                    }).then(function(exists) {
                                        return new $aduX6.BooleanLiteral(exists);
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "evalAggregate",
            value: function evalAggregate() {
                throw new $aduX6.NoAggregator();
            }
        }
    ]);
    return InternalEvaluator;
}();
module.exports.InternalEvaluator = $455fc93a02909cad$var$InternalEvaluator;

});




parcelRegister("fGm4T", function(module, exports) {
"use strict";
var $b6abe77b975ddd8a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b6abe77b975ddd8a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b6abe77b975ddd8a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b6abe77b975ddd8a$var$__exportStar((parcelRequire("7pIXG")), module.exports);

});
parcelRegister("7pIXG", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationGroup = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $4llUo = parcelRequire("4llUo");
/**
 * A comunica Group Query Operation Actor.
 */ var $565dbeaa365a94ac$var$ActorQueryOperationGroup = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationGroup, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationGroup(args) {
        (0, $jGAMp._)(this, ActorQueryOperationGroup);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationGroup, [
            args,
            'group'
        ]);
        _this.mediatorBindingsAggregatorFactory = args.mediatorBindingsAggregatorFactory;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationGroup, [
        {
            key: "testOperation",
            value: function testOperation() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, bindingsFactory, input, aggregates, outputRaw, output, variables, variablesInner, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                // Get result stream for the input query
                                input = operation.input, aggregates = operation.aggregates;
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: input,
                                        context: context
                                    })
                                ];
                            case 2:
                                outputRaw = _state.sent();
                                output = (0, $2n9RU.getSafeBindings)(outputRaw);
                                // The variables in scope are the variables on which we group, i.e. pattern.variables.
                                // For 'GROUP BY ?x, ?z', this is [?x, ?z], for 'GROUP by expr(?x) as ?e' this is [?e].
                                // But also in scope are the variables defined by the aggregations, since GROUP has to handle this.
                                variables = (0, $7WNf6._)(operation.variables).concat((0, $7WNf6._)(aggregates.map(function(agg) {
                                    return agg.variable;
                                }))).map(function(variable) {
                                    return {
                                        variable: variable,
                                        canBeUndef: false
                                    };
                                });
                                return [
                                    4,
                                    output.metadata()
                                ];
                            case 3:
                                variablesInner = _state.sent().variables.map(function(v) {
                                    return v.variable;
                                });
                                // Wrap a new promise inside an iterator that completes when the stream has ended or when an error occurs
                                bindingsStream = new $aafx9.TransformIterator(function() {
                                    return new Promise(function(resolve, reject) {
                                        var groups = new $4llUo.GroupsState(operation, _this.mediatorBindingsAggregatorFactory, context, bindingsFactory, variablesInner);
                                        // Phase 2: Collect aggregator results
                                        // We can only return when the binding stream ends, when that happens
                                        // we return the identified groups. Which are nothing more than Bindings
                                        // of the grouping variables merged with the aggregate variables
                                        // eslint-disable-next-line ts/no-misused-promises
                                        output.bindingsStream.on('end', function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var bindingsStreamInner, _, _1, error;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _state.trys.push([
                                                                0,
                                                                2,
                                                                ,
                                                                3
                                                            ]);
                                                            _1 = (_ = $aafx9.ArrayIterator).bind;
                                                            return [
                                                                4,
                                                                groups.collectResults()
                                                            ];
                                                        case 1:
                                                            bindingsStreamInner = new (_1.apply(_, [
                                                                void 0,
                                                                _state.sent(),
                                                                {
                                                                    autoStart: false
                                                                }
                                                            ]));
                                                            resolve(bindingsStreamInner);
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 2:
                                                            error = _state.sent();
                                                            reject(error);
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 3:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        // Make sure to propagate any errors in the binding stream
                                        output.bindingsStream.on('error', reject);
                                        // Phase 1: Consume the stream, identify the groups and populate the aggregators.
                                        // We need to bind this after the 'error' and 'end' listeners to avoid the
                                        // stream having ended before those listeners are bound.
                                        output.bindingsStream.on('data', function(bindings) {
                                            groups.consumeBindings(bindings)["catch"](reject);
                                        });
                                    });
                                }, {
                                    autoStart: false
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                output.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: variables
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationGroup;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationGroup = $565dbeaa365a94ac$var$ActorQueryOperationGroup;

});
parcelRegister("4llUo", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GroupsState = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $itFzw = parcelRequire("itFzw");
/**
 * A state manager for the groups constructed by consuming the bindings-stream.
 */ var $329a1e2795ea18f9$var$GroupsState = /*#__PURE__*/ function() {
    function GroupsState(pattern, mediatorBindingsAggregatorFactory, context, bindingsFactory, variables) {
        (0, $jGAMp._)(this, GroupsState);
        this.pattern = pattern;
        this.mediatorBindingsAggregatorFactory = mediatorBindingsAggregatorFactory;
        this.context = context;
        this.bindingsFactory = bindingsFactory;
        this.variables = variables;
        this.groups = new Map();
        this.groupsInitializer = new Map();
        this.groupVariables = new Set(this.pattern.variables.map(function(x) {
            return x.value;
        }));
        this.waitCounter = 1;
        this.resultHasBeenCalled = false;
    }
    (0, $byiyg._)(GroupsState, [
        {
            /**
     * - Consumes a stream binding
     * - Find the corresponding group and create one if need be
     * - Feeds the binding to the group's aggregators
     *
     * @param {Bindings} bindings - The Bindings to consume
     */ key: "consumeBindings",
            value: function consumeBindings(bindings) {
                var _this = this;
                var check = this.resultCheck();
                if (check) return check;
                // We increment the counter and decrement him when put action is performed.
                this.waitCounter++;
                // Select the bindings on which we group
                var grouper = bindings.filter(function(_, variable) {
                    return _this.groupVariables.has(variable.value);
                });
                var groupHash = this.hashBindings(grouper);
                // First member of group -> create new group
                var groupInitializer = this.groupsInitializer.get(groupHash);
                var res;
                if (groupInitializer) {
                    var groupInitializerDefined = groupInitializer;
                    res = (function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var group;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            groupInitializerDefined
                                        ];
                                    case 1:
                                        group = _state.sent();
                                        return [
                                            4,
                                            Promise.all(this.pattern.aggregates.map(function(aggregate) {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    var variable;
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                // Distinct handling is done in the aggregator.
                                                                variable = aggregate.variable.value;
                                                                return [
                                                                    4,
                                                                    group.aggregators[variable].putBindings(bindings)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                })();
                                            }))
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    })().then(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this.subtractWaitCounterAndCollect()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    });
                } else {
                    // Initialize state for all aggregators for new group
                    groupInitializer = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var _this, aggregators, group;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        aggregators = {};
                                        return [
                                            4,
                                            Promise.all(this.pattern.aggregates.map(function(aggregate) {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    var key;
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                key = aggregate.variable.value;
                                                                return [
                                                                    4,
                                                                    this.mediatorBindingsAggregatorFactory.mediate({
                                                                        expr: aggregate,
                                                                        context: this.context
                                                                    })
                                                                ];
                                                            case 1:
                                                                aggregators[key] = _state.sent();
                                                                return [
                                                                    4,
                                                                    aggregators[key].putBindings(bindings)
                                                                ];
                                                            case 2:
                                                                _state.sent();
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }))
                                        ];
                                    case 1:
                                        _state.sent();
                                        group = {
                                            aggregators: aggregators,
                                            bindings: grouper
                                        };
                                        this.groups.set(groupHash, group);
                                        return [
                                            4,
                                            this.subtractWaitCounterAndCollect()
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2,
                                            group
                                        ];
                                }
                            });
                        }).call(_this);
                    }();
                    this.groupsInitializer.set(groupHash, groupInitializer);
                    res = groupInitializer;
                }
                return res;
            }
        },
        {
            key: "subtractWaitCounterAndCollect",
            value: function subtractWaitCounterAndCollect() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(--this.waitCounter === 0)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.handleResultCollection()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "handleResultCollection",
            value: function handleResultCollection() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, rows, single;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = this.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    Promise.all((0, $7WNf6._)(this.groups).map(function(param) {
                                        var _param = (0, $32TW8._)(param, 2), _ = _param[0], group = _param[1];
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var groupBindings, aggregators, returnBindings, _tmp, _tmp1, _i, variable, value;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        groupBindings = group.bindings, aggregators = group.aggregators;
                                                        // Collect aggregator bindings
                                                        // If the aggregate errorred, the result will be undefined
                                                        returnBindings = groupBindings;
                                                        _tmp = [];
                                                        for(_tmp1 in aggregators)_tmp.push(_tmp1);
                                                        _i = 0;
                                                        _state.label = 1;
                                                    case 1:
                                                        if (!(_i < _tmp.length)) return [
                                                            3,
                                                            4
                                                        ];
                                                        variable = _tmp[_i];
                                                        return [
                                                            4,
                                                            aggregators[variable].result()
                                                        ];
                                                    case 2:
                                                        value = _state.sent();
                                                        if (value) // Filter undefined
                                                        returnBindings = returnBindings.set(dataFactory.variable(variable), value);
                                                        _state.label = 3;
                                                    case 3:
                                                        _i++;
                                                        return [
                                                            3,
                                                            1
                                                        ];
                                                    case 4:
                                                        // Merge grouping bindings and aggregator bindings
                                                        return [
                                                            2,
                                                            returnBindings
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 1:
                                rows = _state.sent();
                                if (!(rows.length === 0 && this.groupVariables.size === 0)) return [
                                    3,
                                    3
                                ];
                                single = [];
                                return [
                                    4,
                                    Promise.all(this.pattern.aggregates.map(function(aggregate) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var key, aggregator, value;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        key = aggregate.variable;
                                                        return [
                                                            4,
                                                            this.mediatorBindingsAggregatorFactory.mediate({
                                                                expr: aggregate,
                                                                context: this.context
                                                            })
                                                        ];
                                                    case 1:
                                                        aggregator = _state.sent();
                                                        return [
                                                            4,
                                                            aggregator.result()
                                                        ];
                                                    case 2:
                                                        value = _state.sent();
                                                        if (value !== undefined) single.push([
                                                            key,
                                                            value
                                                        ]);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                rows = [
                                    this.bindingsFactory.bindings(single)
                                ];
                                _state.label = 3;
                            case 3:
                                this.waitResolver(rows);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "resultCheck",
            value: function resultCheck() {
                if (this.resultHasBeenCalled) return Promise.reject(new Error('Calling any function after calling collectResult is invalid.'));
            }
        },
        {
            key: "collectResults",
            value: /**
     * Collect the result of the final state. This returns a Bindings per group,
     * and a (possibly empty) Bindings in case no Bindings have been consumed yet.
     * You can only call this method once, after calling this method,
     * calling any function on this will result in an error being thrown.
     */ function collectResults() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, check, res;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                check = this.resultCheck();
                                if (check) return [
                                    2,
                                    check
                                ];
                                this.resultHasBeenCalled = true;
                                res = new Promise(function(resolve) {
                                    _this.waitResolver = resolve;
                                });
                                return [
                                    4,
                                    this.subtractWaitCounterAndCollect()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * @param {Bindings} bindings - Bindings to hash
     */ key: "hashBindings",
            value: function hashBindings(bindings) {
                return (0, $itFzw.bindingsToCompactString)(bindings, this.variables);
            }
        }
    ]);
    return GroupsState;
}();
module.exports.GroupsState = $329a1e2795ea18f9$var$GroupsState;

});



parcelRegister("dlhfj", function(module, exports) {
"use strict";
var $9b6a9d39a5489937$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b6a9d39a5489937$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9b6a9d39a5489937$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9b6a9d39a5489937$var$__exportStar((parcelRequire("edt2N")), module.exports);

});
parcelRegister("edt2N", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationNop = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation)
 * actor that handles SPARQL nop operations.
 */ var $a598cf260fdff7ca$var$ActorQueryOperationNop = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationNop, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationNop(args) {
        (0, $jGAMp._)(this, ActorQueryOperationNop);
        return (0, $kzDuW._)(this, ActorQueryOperationNop, [
            args,
            'nop'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationNop, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, bindingsFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                return [
                                    2,
                                    {
                                        bindingsStream: new $aafx9.SingletonIterator(bindingsFactory.bindings()),
                                        metadata: function() {
                                            return Promise.resolve({
                                                state: new $jZbVy.MetadataValidationState(),
                                                cardinality: {
                                                    type: 'exact',
                                                    value: 1
                                                },
                                                variables: []
                                            });
                                        },
                                        type: 'bindings'
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationNop;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationNop = $a598cf260fdff7ca$var$ActorQueryOperationNop;

});


parcelRegister("3Ixgm", function(module, exports) {
"use strict";
var $2b4f4878574b9e04$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b4f4878574b9e04$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b4f4878574b9e04$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2b4f4878574b9e04$var$__exportStar((parcelRequire("k04Q5")), module.exports);

});
parcelRegister("k04Q5", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationService = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica Service Query Operation Actor.
 * It unwraps the SERVICE operation and executes it on the given source.
 */ var $e8f78fae01d0d75d$var$ActorQueryOperationService = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationService, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationService(args) {
        (0, $jGAMp._)(this, ActorQueryOperationService);
        return (0, $kzDuW._)(this, ActorQueryOperationService, [
            args,
            'service'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationService, [
        {
            key: "testOperation",
            value: function testOperation(operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (operation.name.termType !== 'NamedNode') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only query services by IRI, while a ").concat(operation.name.termType, " was given."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var querySource, output, _, error, dataFactory, bindingsFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorQuerySourceIdentify.mediate({
                                        querySourceUnidentified: {
                                            value: operation.name.value,
                                            type: this.forceSparqlEndpoint ? 'sparql' : undefined
                                        },
                                        context: context
                                    })
                                ];
                            case 1:
                                querySource = _state.sent().querySource;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    8
                                ]);
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: (0, $2n9RU.assignOperationSource)(operation.input, querySource),
                                        context: context
                                    })
                                ];
                            case 3:
                                output = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    8
                                ];
                            case 4:
                                error = _state.sent();
                                if (!operation.silent) return [
                                    3,
                                    6
                                ];
                                // Emit a single empty binding
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 5:
                                bindingsFactory = _state.sent();
                                output = {
                                    bindingsStream: new $aafx9.SingletonIterator(bindingsFactory.bindings()),
                                    type: 'bindings',
                                    metadata: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    {
                                                        state: new $jZbVy.MetadataValidationState(),
                                                        cardinality: {
                                                            type: 'exact',
                                                            value: 1
                                                        },
                                                        variables: []
                                                    }
                                                ];
                                            });
                                        })();
                                    }
                                };
                                this.logWarn(context, "An error occurred when executing a SERVICE clause: ".concat(error.message));
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw error;
                            case 7:
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationService;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationService = $e8f78fae01d0d75d$var$ActorQueryOperationService;

});


parcelRegister("4bQXf", function(module, exports) {
"use strict";
var $30d1442c89f96582$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30d1442c89f96582$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30d1442c89f96582$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$30d1442c89f96582$var$__exportStar((parcelRequire("hULiv")), module.exports);

});
parcelRegister("hULiv", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationValues = void 0;

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica Values Query Operation Actor.
 */ var $d0ac5af23e4d67ed$var$ActorQueryOperationValues = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTyped) {
    (0, $i3fW3._)(ActorQueryOperationValues, _bus_query_operation_1_ActorQueryOperationTyped);
    function ActorQueryOperationValues(args) {
        (0, $jGAMp._)(this, ActorQueryOperationValues);
        return (0, $kzDuW._)(this, ActorQueryOperationValues, [
            args,
            'values'
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationValues, [
        {
            key: "testOperation",
            value: function testOperation(_operation, _context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, bindingsFactory, bindingsStream, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                bindingsStream = new $aafx9.ArrayIterator(operation.bindings.map(function(x) {
                                    return bindingsFactory.bindings(Object.entries(x).map(function(param) {
                                        var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                                        return [
                                            dataFactory.variable(key.slice(1)),
                                            value
                                        ];
                                    }));
                                }));
                                metadata = function() {
                                    return Promise.resolve({
                                        state: new $jZbVy.MetadataValidationState(),
                                        cardinality: {
                                            type: 'exact',
                                            value: operation.bindings.length
                                        },
                                        variables: operation.variables.map(function(variable) {
                                            return {
                                                variable: variable,
                                                canBeUndef: operation.bindings.some(function(bindings) {
                                                    return !("?".concat(variable.value) in bindings);
                                                })
                                            };
                                        })
                                    });
                                };
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationValues;
}($dng5S.ActorQueryOperationTyped);
module.exports.ActorQueryOperationValues = $d0ac5af23e4d67ed$var$ActorQueryOperationValues;

});


parcelRegister("8EvRI", function(module, exports) {
"use strict";
var $64cac6eee58e8de3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64cac6eee58e8de3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $64cac6eee58e8de3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$64cac6eee58e8de3$var$__exportStar((parcelRequire("32Wo0")), module.exports);

});
parcelRegister("32Wo0", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathOneOrMore = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path OneOrMore Query Operation Actor.
 */ var $237ed94721f77abf$var$ActorQueryOperationPathOneOrMore = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathOneOrMore, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathOneOrMore(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathOneOrMore);
        return (0, $kzDuW._)(this, ActorQueryOperationPathOneOrMore, [
            args,
            $hSHd8.Algebra.types.ONE_OR_MORE_PATH
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathOneOrMore, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, bindingsFactory, distinct, predicate, objectVar, starEval, variables, single, results, _, subjectVar, objectVar1, termHashes, bindingsStream, variables1, variable, results1, _1, bindingsStream1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                return [
                                    4,
                                    this.isPathArbitraryLengthDistinct(algebraFactory, context, operation)
                                ];
                            case 2:
                                distinct = _state.sent();
                                if (distinct.operation) return [
                                    2,
                                    distinct.operation
                                ];
                                context = distinct.context;
                                predicate = operation.predicate;
                                if (!(operation.subject.termType !== 'Variable' && operation.object.termType === 'Variable')) return [
                                    3,
                                    4
                                ];
                                objectVar = operation.object;
                                return [
                                    4,
                                    this.getObjectsPredicateStarEval(operation.subject, predicate.path, objectVar, operation.graph, context, false, algebraFactory, bindingsFactory)
                                ];
                            case 3:
                                starEval = _state.sent();
                                variables = (operation.graph.termType === 'Variable' ? [
                                    objectVar,
                                    operation.graph
                                ] : [
                                    objectVar
                                ]).map(function(variable) {
                                    return {
                                        variable: variable,
                                        canBeUndef: false
                                    };
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: starEval.bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                starEval.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: variables
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                            case 4:
                                if (!(operation.subject.termType === 'Variable' && operation.object.termType === 'Variable')) return [
                                    3,
                                    6
                                ];
                                // Get all the results of subjects with same predicate, but once, then fill in first variable for those
                                single = algebraFactory.createDistinct(algebraFactory.createPath(operation.subject, operation.predicate.path, operation.object, operation.graph));
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: single
                                    })
                                ];
                            case 5:
                                results = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                subjectVar = operation.subject;
                                objectVar1 = operation.object;
                                termHashes = {};
                                bindingsStream = new $aafx9.MultiTransformIterator(results.bindingsStream, {
                                    multiTransform: function(bindings) {
                                        var subject = bindings.get(subjectVar);
                                        var object = bindings.get(objectVar1);
                                        var graph = operation.graph.termType === 'Variable' ? bindings.get(operation.graph) : operation.graph;
                                        return new $aafx9.TransformIterator(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var it;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            it = new $aafx9.BufferedIterator();
                                                            return [
                                                                4,
                                                                this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar1, subject, object, predicate.path, graph, context, termHashes, {}, it, {
                                                                    count: 0
                                                                }, algebraFactory, bindingsFactory)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                2,
                                                                it.map(function(item) {
                                                                    if (operation.graph.termType === 'Variable') item = item.set(operation.graph, graph);
                                                                    return item;
                                                                })
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        }, {
                                            autoStart: false,
                                            maxBufferSize: 128
                                        });
                                    },
                                    autoStart: false
                                });
                                variables1 = (operation.graph.termType === 'Variable' ? [
                                    subjectVar,
                                    objectVar1,
                                    operation.graph
                                ] : [
                                    subjectVar,
                                    objectVar1
                                ]).map(function(variable) {
                                    return {
                                        variable: variable,
                                        canBeUndef: false
                                    };
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                results.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: variables1
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                            case 6:
                                if (operation.subject.termType === 'Variable' && operation.object.termType !== 'Variable') return [
                                    2,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: algebraFactory.createPath(operation.object, algebraFactory.createOneOrMorePath(algebraFactory.createInv(predicate.path)), operation.subject, operation.graph)
                                    })
                                ];
                                // If (!sVar && !oVar)
                                variable = this.generateVariable(dataFactory);
                                _1 = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: algebraFactory.createPath(operation.subject, predicate, variable, operation.graph)
                                    })
                                ];
                            case 7:
                                results1 = _1.apply(void 0, [
                                    _state.sent()
                                ]);
                                bindingsStream1 = results1.bindingsStream.map(function(item) {
                                    if (operation.object.equals(item.get(variable))) return operation.graph.termType === 'Variable' ? bindingsFactory.bindings([
                                        [
                                            operation.graph,
                                            item.get(operation.graph)
                                        ]
                                    ]) : bindingsFactory.bindings();
                                    return null;
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream1,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                results1.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: (operation.graph.termType === 'Variable' ? [
                                                                            operation.graph
                                                                        ] : []).map(function(variable) {
                                                                            return {
                                                                                variable: variable,
                                                                                canBeUndef: false
                                                                            };
                                                                        })
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathOneOrMore;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathOneOrMore = $237ed94721f77abf$var$ActorQueryOperationPathOneOrMore;

});


parcelRegister("9tmiu", function(module, exports) {
"use strict";
var $6e581e45c2c685da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e581e45c2c685da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e581e45c2c685da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e581e45c2c685da$var$__exportStar((parcelRequire("6jYaT")), module.exports);

});
parcelRegister("6jYaT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathZeroOrMore = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $gQYIc = parcelRequire("gQYIc");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path ZeroOrMore Query Operation Actor.
 */ var $49a331dade640214$var$ActorQueryOperationPathZeroOrMore = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathZeroOrMore, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathZeroOrMore(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathZeroOrMore);
        return (0, $kzDuW._)(this, ActorQueryOperationPathZeroOrMore, [
            args,
            $hSHd8.Algebra.types.ZERO_OR_MORE_PATH
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathZeroOrMore, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, bindingsFactory, distinct, predicate, sources, sVar, oVar, predVar, single, results, _, subjectVar, objectVar, entities, termHashes, bindingsStream, variables, variable, starEval, bindingsStream1, subject, value, pred, starEval1, variables1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                return [
                                    4,
                                    this.isPathArbitraryLengthDistinct(algebraFactory, context, operation)
                                ];
                            case 2:
                                distinct = _state.sent();
                                if (distinct.operation) return [
                                    2,
                                    distinct.operation
                                ];
                                context = distinct.context;
                                predicate = operation.predicate;
                                sources = this.getPathSources(predicate);
                                sVar = operation.subject.termType === 'Variable';
                                oVar = operation.object.termType === 'Variable';
                                if (!(operation.subject.termType === 'Variable' && operation.object.termType === 'Variable')) return [
                                    3,
                                    4
                                ];
                                // Query ?s ?p ?o, to get all possible namedNodes in de the db
                                predVar = this.generateVariable(dataFactory, operation);
                                single = this.assignPatternSources(algebraFactory, algebraFactory.createPattern(operation.subject, predVar, operation.object, operation.graph), sources);
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: single
                                    })
                                ];
                            case 3:
                                results = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                subjectVar = operation.subject;
                                objectVar = operation.object;
                                // Set with all namedNodes we have already started a predicate* search from
                                entities = new Set();
                                termHashes = {};
                                bindingsStream = new $aafx9.MultiTransformIterator(results.bindingsStream, {
                                    multiTransform: function(bindings) {
                                        // Get the subject and object of the triples (?s ?p ?o) and extract graph if it was a variable
                                        var subject = bindings.get(subjectVar);
                                        var object = bindings.get(objectVar);
                                        var graph = operation.graph.termType === 'Variable' ? bindings.get(operation.graph) : operation.graph;
                                        // Make a hash of namedNode + graph to remember from where we already started a search
                                        var subjectGraphHash = (0, $gQYIc.termToString)(subject) + (0, $gQYIc.termToString)(graph);
                                        var objectGraphHash = (0, $gQYIc.termToString)(object) + (0, $gQYIc.termToString)(graph);
                                        return new $aafx9.TransformIterator(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var it, counter;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            // If no new namedNodes in this triple, return nothing
                                                            if (entities.has(subjectGraphHash) && entities.has(objectGraphHash)) return [
                                                                2,
                                                                new $aafx9.EmptyIterator()
                                                            ];
                                                            // Set up an iterator to which getSubjectAndObjectBindingsPredicateStar will push solutions
                                                            it = new $aafx9.BufferedIterator();
                                                            counter = {
                                                                count: 0
                                                            };
                                                            if (!!entities.has(subjectGraphHash)) return [
                                                                3,
                                                                2
                                                            ];
                                                            entities.add(subjectGraphHash);
                                                            return [
                                                                4,
                                                                this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subject, subject, predicate.path, graph, context, termHashes, {}, it, counter, algebraFactory, bindingsFactory)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            _state.label = 2;
                                                        case 2:
                                                            if (!!entities.has(objectGraphHash)) return [
                                                                3,
                                                                4
                                                            ];
                                                            entities.add(objectGraphHash);
                                                            return [
                                                                4,
                                                                this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, object, object, predicate.path, graph, context, termHashes, {}, it, counter, algebraFactory, bindingsFactory)
                                                            ];
                                                        case 3:
                                                            _state.sent();
                                                            _state.label = 4;
                                                        case 4:
                                                            return [
                                                                2,
                                                                it.map(function(item) {
                                                                    // If the graph was a variable, fill in it's binding (we got it from the ?s ?p ?o binding)
                                                                    if (operation.graph.termType === 'Variable') item = item.set(operation.graph, graph);
                                                                    return item;
                                                                })
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        }, {
                                            autoStart: false,
                                            maxBufferSize: 128
                                        });
                                    },
                                    autoStart: false
                                });
                                variables = (operation.graph.termType === 'Variable' ? [
                                    subjectVar,
                                    operation.object,
                                    operation.graph
                                ] : [
                                    subjectVar,
                                    operation.object
                                ]).map(function(variable) {
                                    return {
                                        variable: variable,
                                        canBeUndef: false
                                    };
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                results.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: variables
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                            case 4:
                                if (!(!sVar && !oVar)) return [
                                    3,
                                    6
                                ];
                                variable = this.generateVariable(dataFactory);
                                return [
                                    4,
                                    this.getObjectsPredicateStarEval(operation.subject, predicate.path, variable, operation.graph, context, true, algebraFactory, bindingsFactory)
                                ];
                            case 5:
                                starEval = _state.sent();
                                bindingsStream1 = starEval.bindingsStream.map(function(item) {
                                    if (operation.object.equals(item.get(variable))) return operation.graph.termType === 'Variable' ? bindingsFactory.bindings([
                                        [
                                            operation.graph,
                                            item.get(operation.graph)
                                        ]
                                    ]) : bindingsFactory.bindings();
                                    return null;
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream1,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                starEval.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: (operation.graph.termType === 'Variable' ? [
                                                                            operation.graph
                                                                        ] : []).map(function(variable) {
                                                                            return {
                                                                                variable: variable,
                                                                                canBeUndef: false
                                                                            };
                                                                        })
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                            case 6:
                                // If (sVar || oVar)
                                subject = sVar ? operation.object : operation.subject;
                                value = sVar ? operation.subject : operation.object;
                                pred = sVar ? algebraFactory.createInv(predicate.path) : predicate.path;
                                return [
                                    4,
                                    this.getObjectsPredicateStarEval(subject, pred, value, operation.graph, context, true, algebraFactory, bindingsFactory)
                                ];
                            case 7:
                                starEval1 = _state.sent();
                                variables1 = (operation.graph.termType === 'Variable' ? [
                                    value,
                                    operation.graph
                                ] : [
                                    value
                                ]).map(function(variable) {
                                    return {
                                        variable: variable,
                                        canBeUndef: false
                                    };
                                });
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: starEval1.bindingsStream,
                                        metadata: function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                var _tmp;
                                                return (0, $9N5UN.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _tmp = [
                                                                {}
                                                            ];
                                                            return [
                                                                4,
                                                                starEval1.metadata()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                (0, $emQHU._).apply(void 0, [
                                                                    (0, $iT0je._).apply(void 0, _tmp.concat([
                                                                        _state.sent()
                                                                    ])),
                                                                    {
                                                                        variables: variables1
                                                                    }
                                                                ])
                                                            ];
                                                    }
                                                });
                                            })();
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathZeroOrMore;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathZeroOrMore = $49a331dade640214$var$ActorQueryOperationPathZeroOrMore;

});


parcelRegister("hYELP", function(module, exports) {
"use strict";
var $d167aa72818c85c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d167aa72818c85c7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d167aa72818c85c7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d167aa72818c85c7$var$__exportStar((parcelRequire("gtb6B")), module.exports);

});
parcelRegister("gtb6B", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathZeroOrOne = void 0;

var $jilFY = parcelRequire("jilFY");

var $9nBhR = parcelRequire("9nBhR");

var $itFzw = parcelRequire("itFzw");

var $jZbVy = parcelRequire("jZbVy");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Path ZeroOrOne Query Operation Actor.
 */ var $bfd7f81cc984742e$var$ActorQueryOperationPathZeroOrOne = /*#__PURE__*/ function(_actor_abstract_path_1_ActorAbstractPath) {
    (0, $i3fW3._)(ActorQueryOperationPathZeroOrOne, _actor_abstract_path_1_ActorAbstractPath);
    function ActorQueryOperationPathZeroOrOne(args) {
        (0, $jGAMp._)(this, ActorQueryOperationPathZeroOrOne);
        return (0, $kzDuW._)(this, ActorQueryOperationPathZeroOrOne, [
            args,
            $hSHd8.Algebra.types.ZERO_OR_ONE_PATH
        ]);
    }
    (0, $byiyg._)(ActorQueryOperationPathZeroOrOne, [
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, bindingsFactory, predicate, sources, extra, distinct, bindingsOne, _, bindingsStream, varP, bindingsZero, _1, metadata;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                predicate = operation.predicate;
                                sources = this.getPathSources(predicate);
                                extra = [];
                                // Both subject and object non-variables
                                if (operation.subject.termType !== 'Variable' && operation.object.termType !== 'Variable' && operation.subject.equals(operation.object)) return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: new $aafx9.SingletonIterator(bindingsFactory.bindings()),
                                        metadata: function() {
                                            return Promise.resolve({
                                                state: new $jZbVy.MetadataValidationState(),
                                                cardinality: {
                                                    type: 'exact',
                                                    value: 1
                                                },
                                                variables: []
                                            });
                                        }
                                    }
                                ];
                                return [
                                    4,
                                    this.isPathArbitraryLengthDistinct(algebraFactory, context, operation)
                                ];
                            case 2:
                                distinct = _state.sent();
                                if (distinct.operation) return [
                                    2,
                                    distinct.operation
                                ];
                                context = distinct.context;
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: algebraFactory.createPath(operation.subject, predicate.path, operation.object, operation.graph)
                                    })
                                ];
                            case 3:
                                bindingsOne = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                if (!(operation.subject.termType === 'Variable' && operation.object.termType === 'Variable')) return [
                                    3,
                                    5
                                ];
                                // Both subject and object are variables
                                // To determine the "Zero" part, we
                                // query ?s ?p ?o. FILTER ?s = ?0, to get all possible namedNodes in de the db
                                varP = this.generateVariable(dataFactory, operation);
                                _1 = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: algebraFactory.createFilter(this.assignPatternSources(algebraFactory, algebraFactory.createPattern(operation.subject, varP, operation.object, operation.graph), sources), algebraFactory.createOperatorExpression('=', [
                                            algebraFactory.createTermExpression(operation.subject),
                                            algebraFactory.createTermExpression(operation.object)
                                        ]))
                                    })
                                ];
                            case 4:
                                bindingsZero = _1.apply(void 0, [
                                    _state.sent()
                                ]).bindingsStream.map(function(bindings) {
                                    return bindings["delete"](varP);
                                });
                                bindingsStream = new $aafx9.UnionIterator([
                                    bindingsZero,
                                    bindingsOne.bindingsStream
                                ], {
                                    autoStart: false
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                // If subject or object is not a variable, then determining the "Zero" part is simple.
                                if (operation.subject.termType === 'Variable') extra.push(bindingsFactory.bindings([
                                    [
                                        operation.subject,
                                        operation.object
                                    ]
                                ]));
                                if (operation.object.termType === 'Variable') extra.push(bindingsFactory.bindings([
                                    [
                                        operation.object,
                                        operation.subject
                                    ]
                                ]));
                                bindingsStream = bindingsOne.bindingsStream.prepend(extra);
                                _state.label = 6;
                            case 6:
                                metadata = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var innerMetadata;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        bindingsOne.metadata()
                                                    ];
                                                case 1:
                                                    innerMetadata = _state.sent();
                                                    return [
                                                        2,
                                                        (0, $emQHU._)((0, $iT0je._)({}, innerMetadata), {
                                                            cardinality: (0, $emQHU._)((0, $iT0je._)({}, innerMetadata.cardinality), {
                                                                // Add one to cardinality because we allow *ZERO* or more.
                                                                value: innerMetadata.cardinality.value + 1
                                                            })
                                                        })
                                                    ];
                                            }
                                        });
                                    })();
                                };
                                return [
                                    2,
                                    {
                                        type: 'bindings',
                                        bindingsStream: bindingsStream,
                                        metadata: metadata
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationPathZeroOrOne;
}($jilFY.ActorAbstractPath);
module.exports.ActorQueryOperationPathZeroOrOne = $bfd7f81cc984742e$var$ActorQueryOperationPathZeroOrOne;

});


parcelRegister("chNTI", function(module, exports) {
"use strict";
var $8f1dc73376443a61$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8f1dc73376443a61$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8f1dc73376443a61$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8f1dc73376443a61$var$__exportStar((parcelRequire("cowdN")), module.exports);

});
parcelRegister("cowdN", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUpdateDeleteInsert = void 0;

var $9i17A = parcelRequire("9i17A");

var $dng5S = parcelRequire("dng5S");

var $9nBhR = parcelRequire("9nBhR");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica Update DeleteInsert Query Operation Actor.
 */ var $9060b87255e0a80f$var$ActorQueryOperationUpdateDeleteInsert = /*#__PURE__*/ function(_bus_query_operation_1_ActorQueryOperationTypedMediated) {
    (0, $i3fW3._)(ActorQueryOperationUpdateDeleteInsert, _bus_query_operation_1_ActorQueryOperationTypedMediated);
    function ActorQueryOperationUpdateDeleteInsert(args) {
        (0, $jGAMp._)(this, ActorQueryOperationUpdateDeleteInsert);
        var _this;
        _this = (0, $kzDuW._)(this, ActorQueryOperationUpdateDeleteInsert, [
            args,
            'deleteinsert'
        ]);
        _this.blankNodeCounter = 0;
        return _this;
    }
    (0, $byiyg._)(ActorQueryOperationUpdateDeleteInsert, [
        {
            key: "testOperation",
            value: function testOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2n9RU.testReadOnly)(context)
                        ];
                    });
                })();
            }
        },
        {
            key: "runOperation",
            value: function runOperation(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, bindingsFactory, whereBindings, _tmp, _, quadStreamInsert, quadStreamDelete, execute;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                if (!operation.where) return [
                                    3,
                                    3
                                ];
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        operation: operation.where,
                                        context: context
                                    })
                                ];
                            case 2:
                                _tmp = _.apply(void 0, [
                                    _state.sent()
                                ]).bindingsStream;
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp = new $aafx9.ArrayIterator([
                                    bindingsFactory.bindings()
                                ], {
                                    autoStart: false
                                });
                                _state.label = 4;
                            case 4:
                                whereBindings = _tmp;
                                if (operation.insert) {
                                    // Localize blank nodes in pattern, to avoid clashes across different INSERT/DELETE calls
                                    quadStreamInsert = new $9i17A.BindingsToQuadsIterator(dataFactory, operation.insert.map($9i17A.BindingsToQuadsIterator.localizeQuad.bind(null, dataFactory, this.blankNodeCounter)), whereBindings.clone());
                                    this.blankNodeCounter++;
                                }
                                if (operation["delete"]) {
                                    // Localize blank nodes in pattern, to avoid clashes across different INSERT/DELETE calls
                                    quadStreamDelete = new $9i17A.BindingsToQuadsIterator(dataFactory, operation["delete"].map($9i17A.BindingsToQuadsIterator.localizeQuad.bind(null, dataFactory, this.blankNodeCounter)), whereBindings.clone());
                                    this.blankNodeCounter++;
                                }
                                return [
                                    4,
                                    this.mediatorUpdateQuads.mediate({
                                        quadStreamInsert: quadStreamInsert,
                                        quadStreamDelete: quadStreamDelete,
                                        context: context
                                    })
                                ];
                            case 5:
                                execute = _state.sent().execute;
                                return [
                                    2,
                                    {
                                        type: 'void',
                                        execute: execute
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryOperationUpdateDeleteInsert;
}($dng5S.ActorQueryOperationTypedMediated);
module.exports.ActorQueryOperationUpdateDeleteInsert = $9060b87255e0a80f$var$ActorQueryOperationUpdateDeleteInsert;

});


parcelRegister("kCebH", function(module, exports) {
"use strict";
var $f0225ca71b9a4c40$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0225ca71b9a4c40$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0225ca71b9a4c40$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0225ca71b9a4c40$var$__exportStar((parcelRequire("8Vssx")), module.exports);

});
parcelRegister("8Vssx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessSequential = void 0;

var $1FnZ2 = parcelRequire("1FnZ2");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Sequential Query Process Actor.
 */ var $67f9b902666bdcad$var$ActorQueryProcessSequential = /*#__PURE__*/ function(_bus_query_process_1_ActorQueryProcess) {
    (0, $i3fW3._)(ActorQueryProcessSequential, _bus_query_process_1_ActorQueryProcess);
    function ActorQueryProcessSequential(args) {
        (0, $jGAMp._)(this, ActorQueryProcessSequential);
        return (0, $kzDuW._)(this, ActorQueryProcessSequential, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryProcessSequential, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_context_get;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if ((_action_context_get = action.context.get($9nBhR.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $kNNoa.ActionContextKey('explain'))) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " is not able to explain queries."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, operation, context, ref, output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.parse(action.query, action.context)
                                ];
                            case 1:
                                _ref = _state.sent(), operation = _ref.operation, context = _ref.context;
                                return [
                                    4,
                                    this.optimize(operation, context)
                                ];
                            case 2:
                                ref = _state.sent(), operation = ref.operation, context = ref.context, ref;
                                return [
                                    4,
                                    this.evaluate(operation, context)
                                ];
                            case 3:
                                output = _state.sent();
                                return [
                                    2,
                                    {
                                        result: output
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "parse",
            value: function parse(query, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var operation, baseIRI, queryFormat, queryParseOutput, dataFactory, algebraFactory, bindingsFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorContextPreprocess.mediate({
                                        context: context,
                                        initialize: true
                                    })
                                ];
                            case 1:
                                // Pre-processing the context
                                context = _state.sent().context;
                                if (!(typeof query === 'string')) return [
                                    3,
                                    3
                                ];
                                // Save the original query string in the context
                                context = context.set($9nBhR.KeysInitQuery.queryString, query);
                                baseIRI = context.get($9nBhR.KeysInitQuery.baseIRI);
                                queryFormat = context.get($9nBhR.KeysInitQuery.queryFormat);
                                return [
                                    4,
                                    this.mediatorQueryParse.mediate({
                                        context: context,
                                        query: query,
                                        queryFormat: queryFormat,
                                        baseIRI: baseIRI
                                    })
                                ];
                            case 2:
                                queryParseOutput = _state.sent();
                                operation = queryParseOutput.operation;
                                // Update the baseIRI in the context if the query modified it.
                                if (queryParseOutput.baseIRI) context = context.set($9nBhR.KeysInitQuery.baseIRI, queryParseOutput.baseIRI);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                operation = query;
                                _state.label = 4;
                            case 4:
                                if (!context.has($9nBhR.KeysInitQuery.initialBindings)) return [
                                    3,
                                    6
                                ];
                                dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory)
                                ];
                            case 5:
                                bindingsFactory = _state.sent();
                                operation = (0, $2n9RU.materializeOperation)(operation, context.get($9nBhR.KeysInitQuery.initialBindings), algebraFactory, bindingsFactory, {
                                    strictTargetVariables: true
                                });
                                // Delete the query string from the context, since our initial query might have changed
                                context = context["delete"]($9nBhR.KeysInitQuery.queryString);
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    {
                                        operation: operation,
                                        context: context
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "optimize",
            value: function optimize(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var ref;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Save initial query in context
                                context = context.set($9nBhR.KeysInitQuery.query, operation);
                                return [
                                    4,
                                    this.mediatorOptimizeQueryOperation.mediate({
                                        context: context,
                                        operation: operation
                                    })
                                ];
                            case 1:
                                ref = _state.sent(), operation = ref.operation, context = ref.context, ref;
                                // Save original query in context
                                context = context.set($9nBhR.KeysInitQuery.query, operation);
                                return [
                                    2,
                                    {
                                        operation: operation,
                                        context: context
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "evaluate",
            value: function evaluate(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var output;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorQueryOperation.mediate({
                                        context: context,
                                        operation: operation
                                    })
                                ];
                            case 1:
                                output = _state.sent();
                                output.context = context;
                                return [
                                    2,
                                    output
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryProcessSequential;
}($1FnZ2.ActorQueryProcess);
module.exports.ActorQueryProcessSequential = $67f9b902666bdcad$var$ActorQueryProcessSequential;

});
parcelRegister("1FnZ2", function(module, exports) {
"use strict";
var $136c39674252fc99$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $136c39674252fc99$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $136c39674252fc99$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$136c39674252fc99$var$__exportStar((parcelRequire("16AKN")), module.exports);

});
parcelRegister("16AKN", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcess = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for query-process events.
 *
 * Actor types:
 * * Input:  IActionQueryProcess:      The input query to process.
 * * Test:   <none>
 * * Output: IActorQueryProcessOutput: Output of the query processing.
 *
 * @see IActionQueryProcess
 * @see IActorQueryProcessOutput
 */ var $0ce2dc876dc6b8a5$var$ActorQueryProcess = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorQueryProcess, _core_1_Actor);
    function ActorQueryProcess(args) {
        (0, $jGAMp._)(this, ActorQueryProcess);
        return (0, $kzDuW._)(this, ActorQueryProcess, [
            args
        ]);
    }
    return ActorQueryProcess;
}($kNNoa.Actor);
module.exports.ActorQueryProcess = $0ce2dc876dc6b8a5$var$ActorQueryProcess;

});




parcelRegister("1RsAr", function(module, exports) {
"use strict";
var $15b0ea6ac322a7c5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $15b0ea6ac322a7c5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $15b0ea6ac322a7c5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$15b0ea6ac322a7c5$var$__exportStar((parcelRequire("bhvgi")), module.exports);

$15b0ea6ac322a7c5$var$__exportStar((parcelRequire("gWtsz")), module.exports);

});
parcelRegister("bhvgi", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermedia = void 0;

var $eznfg = parcelRequire("eznfg");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $gWtsz = parcelRequire("gWtsz");
/**
 * A comunica Hypermedia Query Source Identify Actor.
 */ var $8369882e530a9904$var$ActorQuerySourceIdentifyHypermedia = /*#__PURE__*/ function(_bus_query_source_identify_1_ActorQuerySourceIdentify) {
    (0, $i3fW3._)(ActorQuerySourceIdentifyHypermedia, _bus_query_source_identify_1_ActorQuerySourceIdentify);
    function ActorQuerySourceIdentifyHypermedia(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifyHypermedia);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifyHypermedia, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifyHypermedia, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (typeof action.querySourceUnidentified.value !== 'string') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " requires a single query source with a URL value to be present in the context."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, _action_querySourceUnidentified_context, dataFactory, _action_querySourceUnidentified_context1, _tmp, _tmp1, _, _1, _tmp2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                _tmp = {};
                                _tmp1 = {};
                                _1 = (_ = $gWtsz.QuerySourceHypermedia).bind;
                                _tmp2 = [
                                    void 0,
                                    this.cacheSize,
                                    action.querySourceUnidentified.value,
                                    action.querySourceUnidentified.type,
                                    this.maxIterators,
                                    this.aggregateTraversalStore && Boolean((_action_querySourceUnidentified_context = action.querySourceUnidentified.context) === null || _action_querySourceUnidentified_context === void 0 ? void 0 : _action_querySourceUnidentified_context.get($9nBhR.KeysQuerySourceIdentify.traverse)),
                                    {
                                        mediatorMetadata: this.mediatorMetadata,
                                        mediatorMetadataExtract: this.mediatorMetadataExtract,
                                        mediatorMetadataAccumulate: this.mediatorMetadataAccumulate,
                                        mediatorDereferenceRdf: this.mediatorDereferenceRdf,
                                        mediatorQuerySourceIdentifyHypermedia: this.mediatorQuerySourceIdentifyHypermedia,
                                        mediatorRdfResolveHypermediaLinks: this.mediatorRdfResolveHypermediaLinks,
                                        mediatorRdfResolveHypermediaLinksQueue: this.mediatorRdfResolveHypermediaLinksQueue
                                    },
                                    function(warningMessage) {
                                        return _this.logWarn(action.context, warningMessage);
                                    },
                                    dataFactory
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.querySource = (_tmp1.source = new (_1.apply(_, _tmp2.concat([
                                        _state.sent()
                                    ]))), _tmp1.context = (_action_querySourceUnidentified_context1 = action.querySourceUnidentified.context) !== null && _action_querySourceUnidentified_context1 !== void 0 ? _action_querySourceUnidentified_context1 : new $kNNoa.ActionContext(), _tmp1), _tmp)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQuerySourceIdentifyHypermedia;
}($eznfg.ActorQuerySourceIdentify);
module.exports.ActorQuerySourceIdentifyHypermedia = $8369882e530a9904$var$ActorQuerySourceIdentifyHypermedia;

});
parcelRegister("gWtsz", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceHypermedia = void 0;

var $hbGDL = parcelRequire("hbGDL");

var $9nBhR = parcelRequire("9nBhR");

var $aafx9 = parcelRequire("aafx9");

var $aB33x = parcelRequire("aB33x");

var $bwPrQ = parcelRequire("bwPrQ");

var $hSHd8 = parcelRequire("hSHd8");

var $bfxWp = parcelRequire("bfxWp");

var $9xl7d = parcelRequire("9xl7d");
var $c558ea3d4a9c7e8e$var$QuerySourceHypermedia = /*#__PURE__*/ function() {
    function QuerySourceHypermedia(cacheSize, firstUrl, forceSourceType, maxIterators, aggregateStore, mediators, logWarning, dataFactory, bindingsFactory) {
        (0, $jGAMp._)(this, QuerySourceHypermedia);
        this.referenceValue = firstUrl;
        this.cacheSize = cacheSize;
        this.firstUrl = firstUrl;
        this.forceSourceType = forceSourceType;
        this.maxIterators = maxIterators;
        this.mediators = mediators;
        this.aggregateStore = aggregateStore;
        this.logWarning = logWarning;
        this.dataFactory = dataFactory;
        this.bindingsFactory = bindingsFactory;
        this.sourcesState = new $aB33x.LRUCache({
            max: this.cacheSize
        });
    }
    (0, $byiyg._)(QuerySourceHypermedia, [
        {
            key: "getSelectorShape",
            value: function getSelectorShape(context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var source;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getSourceCached({
                                        url: this.firstUrl
                                    }, {}, context, this.getAggregateStore(context))
                                ];
                            case 1:
                                source = _state.sent();
                                return [
                                    2,
                                    source.source.getSelectorShape(context)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "queryBindings",
            value: function queryBindings(operation, context, options) {
                var _this = this;
                // Optimized match with aggregated store if enabled and started.
                var aggregatedStore = this.getAggregateStore(context);
                if (aggregatedStore && operation.type === 'pattern' && aggregatedStore.started) return new $hbGDL.QuerySourceRdfJs(aggregatedStore, context.getSafe($9nBhR.KeysInitQuery.dataFactory), this.bindingsFactory).queryBindings(operation, context);
                // Initialize the sources state on first call
                if (this.sourcesState.size === 0) this.getSourceCached({
                    url: this.firstUrl
                }, {}, context, aggregatedStore)["catch"](function(error) {
                    return it.destroy(error);
                });
                var dataFactory = context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                var algebraFactory = new $hSHd8.Factory(dataFactory);
                var it = new $bfxWp.MediatedLinkedRdfSourcesAsyncRdfIterator(this.cacheSize, operation, options, context, this.forceSourceType, this.firstUrl, this.maxIterators, function(link, handledDatasets) {
                    return _this.getSourceCached(link, handledDatasets, context, aggregatedStore);
                }, aggregatedStore, this.mediators.mediatorMetadataAccumulate, this.mediators.mediatorRdfResolveHypermediaLinks, this.mediators.mediatorRdfResolveHypermediaLinksQueue, dataFactory, algebraFactory);
                if (aggregatedStore) {
                    aggregatedStore.started = true;
                    // Kickstart this iterator when derived iterators are created from the aggregatedStore,
                    // otherwise the traversal process will not start if this iterator is not the first one to be consumed.
                    var listener = function() {
                        return it.kickstart();
                    };
                    aggregatedStore.addIteratorCreatedListener(listener);
                    it.on('end', function() {
                        return aggregatedStore.removeIteratorCreatedListener(listener);
                    });
                }
                return it;
            }
        },
        {
            key: "queryQuads",
            value: function queryQuads(operation, context) {
                var _this = this;
                return new $aafx9.TransformIterator(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                        var source;
                        return (0, $9N5UN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.getSourceCached({
                                            url: this.firstUrl
                                        }, {}, context, this.getAggregateStore(context))
                                    ];
                                case 1:
                                    source = _state.sent();
                                    return [
                                        2,
                                        source.source.queryQuads(operation, context)
                                    ];
                            }
                        });
                    }).call(_this);
                });
            }
        },
        {
            key: "queryBoolean",
            value: function queryBoolean(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var source;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getSourceCached({
                                        url: this.firstUrl
                                    }, {}, context, this.getAggregateStore(context))
                                ];
                            case 1:
                                source = _state.sent();
                                return [
                                    4,
                                    source.source.queryBoolean(operation, context)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "queryVoid",
            value: function queryVoid(operation, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var source;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getSourceCached({
                                        url: this.firstUrl
                                    }, {}, context, this.getAggregateStore(context))
                                ];
                            case 1:
                                source = _state.sent();
                                return [
                                    4,
                                    source.source.queryVoid(operation, context)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSource",
            value: /**
     * Resolve a source for the given URL.
     * @param link A source link.
     * @param handledDatasets A hash of dataset identifiers that have already been handled.
     * @param context The action context.
     * @param aggregatedStore An optional aggregated store.
     */ function getSource(link, handledDatasets, context, aggregatedStore) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _context_get, url, quads, metadata, _dereferenceRdfOutput_metadata, dereferenceRdfOutput, rdfMetadataOutput, error, _ref, source, dataset;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Include context entries from link
                                if (link.context) context = context.merge(link.context);
                                // Get the RDF representation of the given document
                                url = link.url;
                                if (!(this.forceSourceType === 'sparql' && ((_context_get = context.get($9nBhR.KeysQueryOperation.querySources)) === null || _context_get === void 0 ? void 0 : _context_get.length) === 1)) return [
                                    3,
                                    2
                                ];
                                // Skip metadata extraction if we're querying over just a single SPARQL endpoint.
                                quads = new $bwPrQ.Readable();
                                quads.read = function() {
                                    return null;
                                };
                                return [
                                    4,
                                    this.mediators.mediatorMetadataAccumulate.mediate({
                                        context: context,
                                        mode: 'initialize'
                                    })
                                ];
                            case 1:
                                metadata = _state.sent().metadata;
                                return [
                                    3,
                                    10
                                ];
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    ,
                                    10
                                ]);
                                return [
                                    4,
                                    this.mediators.mediatorDereferenceRdf.mediate({
                                        context: context,
                                        url: url
                                    })
                                ];
                            case 3:
                                dereferenceRdfOutput = _state.sent();
                                url = dereferenceRdfOutput.url;
                                return [
                                    4,
                                    this.mediators.mediatorMetadata.mediate({
                                        context: context,
                                        url: url,
                                        quads: dereferenceRdfOutput.data,
                                        triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
                                    })
                                ];
                            case 4:
                                rdfMetadataOutput = _state.sent();
                                rdfMetadataOutput.data.on('error', function() {
                                // Silence errors in the data stream,
                                // as they will be emitted again in the metadata stream,
                                // and will result in a promise rejection anyways.
                                // If we don't do this, we end up with an unhandled error message
                                });
                                return [
                                    4,
                                    this.mediators.mediatorMetadataExtract.mediate({
                                        context: context,
                                        url: url,
                                        // The problem appears to be conflicting metadata keys here
                                        metadata: rdfMetadataOutput.metadata,
                                        headers: dereferenceRdfOutput.headers,
                                        requestTime: dereferenceRdfOutput.requestTime
                                    })
                                ];
                            case 5:
                                metadata = _state.sent().metadata;
                                quads = rdfMetadataOutput.data;
                                if (!link.transform) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    link.transform(quads)
                                ];
                            case 6:
                                quads = _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                error = _state.sent();
                                // Make sure that dereference errors are only emitted once an actor really needs the read quads
                                // This allows SPARQL endpoints that error on service description fetching to still be source-forcible
                                quads = new $bwPrQ.Readable();
                                quads.read = function() {
                                    setTimeout(function() {
                                        return quads.emit('error', error);
                                    });
                                    return null;
                                };
                                return [
                                    4,
                                    this.mediators.mediatorMetadataAccumulate.mediate({
                                        context: context,
                                        mode: 'initialize'
                                    })
                                ];
                            case 9:
                                metadata = _state.sent().metadata;
                                // Log as warning, because the quads above may not always be consumed (e.g. for SPARQL endpoints),
                                // so the user would not be notified of something going wrong otherwise.
                                this.logWarning("Metadata extraction for ".concat(url, " failed: ").concat(error.message));
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                // Aggregate all discovered quads into a store.
                                aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore.setBaseMetadata(metadata, false);
                                aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore.containedSources.add(link.url);
                                aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore["import"](quads);
                                return [
                                    4,
                                    this.mediators.mediatorQuerySourceIdentifyHypermedia.mediate({
                                        context: context,
                                        forceSourceType: link.url === this.firstUrl ? this.forceSourceType : undefined,
                                        handledDatasets: handledDatasets,
                                        metadata: metadata,
                                        quads: quads,
                                        url: url
                                    })
                                ];
                            case 11:
                                _ref = _state.sent(), source = _ref.source, dataset = _ref.dataset;
                                if (dataset) // Mark the dataset as applied
                                // This is needed to make sure that things like QPF search forms are only applied once,
                                // and next page links are followed after that.
                                handledDatasets[dataset] = true;
                                return [
                                    2,
                                    {
                                        link: link,
                                        source: source,
                                        metadata: metadata,
                                        handledDatasets: handledDatasets
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Resolve a source for the given URL.
     * This will first try to retrieve the source from cache.
     * @param link A source ILink.
     * @param handledDatasets A hash of dataset identifiers that have already been handled.
     * @param context The action context.
     * @param aggregatedStore An optional aggregated store.
     */ key: "getSourceCached",
            value: function getSourceCached(link, handledDatasets, context, aggregatedStore) {
                var source = this.sourcesState.get(link.url);
                if (source) return source;
                source = this.getSource(link, handledDatasets, context, aggregatedStore);
                if (link.url === this.firstUrl || aggregatedStore === undefined) this.sourcesState.set(link.url, source);
                return source;
            }
        },
        {
            key: "getAggregateStore",
            value: function getAggregateStore(context) {
                var _this = this;
                var aggregatedStore;
                if (this.aggregateStore) {
                    var aggregatedStores = context.get($9nBhR.KeysQuerySourceIdentify.hypermediaSourcesAggregatedStores);
                    if (aggregatedStores) {
                        aggregatedStore = aggregatedStores.get(this.firstUrl);
                        if (!aggregatedStore) {
                            aggregatedStore = new $9xl7d.StreamingStoreMetadata(undefined, function(accumulatedMetadata, appendingMetadata) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    this.mediators.mediatorMetadataAccumulate.mediate({
                                                        mode: 'append',
                                                        accumulatedMetadata: accumulatedMetadata,
                                                        appendingMetadata: appendingMetadata,
                                                        context: context
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent().metadata
                                                ];
                                        }
                                    });
                                }).call(_this);
                            });
                            aggregatedStores.set(this.firstUrl, aggregatedStore);
                        }
                        return aggregatedStore;
                    }
                }
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "QuerySourceHypermedia(".concat(this.firstUrl, ")");
            }
        }
    ]);
    return QuerySourceHypermedia;
}();
module.exports.QuerySourceHypermedia = $c558ea3d4a9c7e8e$var$QuerySourceHypermedia;

});
parcelRegister("aB33x", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $7b6fbaf78221d996$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $el4bI = parcelRequire("el4bI");

var $hsOXY = parcelRequire("hsOXY");

var $FPkD9 = parcelRequire("FPkD9");

var $3cNKp = parcelRequire("3cNKp");

var $dZ0wD = parcelRequire("dZ0wD");

var $bA8rW = parcelRequire("bA8rW");

var $iRvUI = parcelRequire("iRvUI");

var $dqGf9 = parcelRequire("dqGf9");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");

var $9N5UN = parcelRequire("9N5UN");
var $7b6fbaf78221d996$var$perf = (typeof performance === "undefined" ? "undefined" : (0, $3KZcf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var $7b6fbaf78221d996$var$warned = new Set();
/* c8 ignore start */ var $7b6fbaf78221d996$var$PROCESS = {};
/* c8 ignore start */ var $7b6fbaf78221d996$var$emitWarning = function(msg, type, code, fn) {
    typeof $7b6fbaf78221d996$var$PROCESS.emitWarning === 'function' ? $7b6fbaf78221d996$var$PROCESS.emitWarning(msg, type, code, fn) : console.error("[".concat(code, "] ").concat(type, ": ").concat(msg));
};
var $7b6fbaf78221d996$var$AC = globalThis.AbortController;
var $7b6fbaf78221d996$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $7b6fbaf78221d996$var$AC === 'undefined') {
    var $7b6fbaf78221d996$var$_PROCESS_env;
    //@ts-ignore
    $7b6fbaf78221d996$var$AS = /*#__PURE__*/ function() {
        "use strict";
        function AbortSignal() {
            (0, $jGAMp._)(this, AbortSignal);
            (0, $cqEAj._)(this, "onabort", void 0);
            (0, $cqEAj._)(this, "_onabort", []);
            (0, $cqEAj._)(this, "reason", void 0);
            (0, $cqEAj._)(this, "aborted", false);
        }
        (0, $byiyg._)(AbortSignal, [
            {
                key: "addEventListener",
                value: function addEventListener(_, fn) {
                    this._onabort.push(fn);
                }
            }
        ]);
        return AbortSignal;
    }();
    //@ts-ignore
    $7b6fbaf78221d996$var$AC = /*#__PURE__*/ function() {
        "use strict";
        function AbortController() {
            (0, $jGAMp._)(this, AbortController);
            (0, $cqEAj._)(this, "signal", new $7b6fbaf78221d996$var$AS());
            $7b6fbaf78221d996$var$warnACPolyfill();
        }
        (0, $byiyg._)(AbortController, [
            {
                key: "abort",
                value: function abort(reason) {
                    var _this_signal_onabort, _this_signal;
                    if (this.signal.aborted) return;
                    //@ts-ignore
                    this.signal.reason = reason;
                    //@ts-ignore
                    this.signal.aborted = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        //@ts-ignore
                        for(var _iterator = this.signal._onabort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var fn = _step.value;
                            fn(reason);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
                }
            }
        ]);
        return AbortController;
    }();
    var $7b6fbaf78221d996$var$printACPolyfillWarning = (($7b6fbaf78221d996$var$_PROCESS_env = $7b6fbaf78221d996$var$PROCESS.env) === null || $7b6fbaf78221d996$var$_PROCESS_env === void 0 ? void 0 : $7b6fbaf78221d996$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    var $7b6fbaf78221d996$var$warnACPolyfill = function() {
        if (!$7b6fbaf78221d996$var$printACPolyfillWarning) return;
        $7b6fbaf78221d996$var$printACPolyfillWarning = false;
        $7b6fbaf78221d996$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', $7b6fbaf78221d996$var$warnACPolyfill);
    };
}
/* c8 ignore stop */ var $7b6fbaf78221d996$var$shouldWarn = function(code) {
    return !$7b6fbaf78221d996$var$warned.has(code);
};
var $7b6fbaf78221d996$var$TYPE = Symbol('type');
var $7b6fbaf78221d996$var$isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
var $7b6fbaf78221d996$var$getUintArray = function(max) {
    return !$7b6fbaf78221d996$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $7b6fbaf78221d996$var$ZeroArray : null;
};
/* c8 ignore stop */ var $7b6fbaf78221d996$var$ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $i3fW3._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, $jGAMp._)(this, ZeroArray);
        var _this;
        _this = (0, $kzDuW._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, $8AW3P._)(Array));
var $7b6fbaf78221d996$var$Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max, HeapCls) {
        (0, $jGAMp._)(this, Stack);
        (0, $cqEAj._)(this, "heap", void 0);
        (0, $cqEAj._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $iRvUI._)(Stack, Stack, $7b6fbaf78221d996$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    (0, $byiyg._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ], [
        {
            key: "create",
            value: function create(max) {
                var HeapCls = $7b6fbaf78221d996$var$getUintArray(max);
                if (!HeapCls) return [];
                (0, $dqGf9._)(Stack, Stack, $7b6fbaf78221d996$var$_constructing, true);
                var s = new Stack(max, HeapCls);
                (0, $dqGf9._)(Stack, Stack, $7b6fbaf78221d996$var$_constructing, false);
                return s;
            }
        }
    ]);
    return Stack;
}();
// private constructor
var $7b6fbaf78221d996$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$7b6fbaf78221d996$var$_max = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_maxSize = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_dispose = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$7b6fbaf78221d996$var$_size = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_keyMap = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_keyList = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_valList = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_next = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_prev = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_head = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_tail = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_free = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_disposed = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_sizes = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_starts = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_ttls = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$7b6fbaf78221d996$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $7b6fbaf78221d996$var$_isStale = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_requireSize = /*#__PURE__*/ new WeakMap(), $7b6fbaf78221d996$var$_indexes = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_rindexes = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_evict = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_connect = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_delete = /*#__PURE__*/ new WeakSet(), $7b6fbaf78221d996$var$_clear = /*#__PURE__*/ new WeakSet();
var $7b6fbaf78221d996$export$182500e6725aad9a = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(options) {
        (0, $jGAMp._)(this, LRUCache);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_initializeTTLTracking);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_initializeSizeTracking);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_indexes);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_rindexes);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_isValidIndex);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_evict);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_backgroundFetch);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_connect);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_moveToTail);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_delete);
        (0, $bA8rW._)(this, $7b6fbaf78221d996$var$_clear);
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $cqEAj._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $cqEAj._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $cqEAj._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $cqEAj._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $cqEAj._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $cqEAj._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $cqEAj._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $cqEAj._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $cqEAj._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $cqEAj._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $cqEAj._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $cqEAj._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $cqEAj._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $cqEAj._)(this, "ignoreFetchAbort", void 0);
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_updateItemAge, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_statusTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_setItemTTL, {
            writable: true,
            value: function() {}
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_isStale, {
            writable: true,
            value: function() {
                return false;
            }
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_removeItemSize, {
            writable: true,
            value: function(_i) {}
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_addItemSize, {
            writable: true,
            value: function(_i, _s, _st) {}
        });
        (0, $hsOXY._)(this, $7b6fbaf78221d996$var$_requireSize, {
            writable: true,
            value: function(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $cqEAj._)(this, Symbol.toStringTag, 'LRUCache');
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, memoMethod = options.memoMethod, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        if (max !== 0 && !$7b6fbaf78221d996$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? $7b6fbaf78221d996$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_max, max);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_fetchMethod, fetchMethod);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_hasFetchMethod, !!fetchMethod);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_keyMap, new Map());
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_keyList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_valList, new Array(max).fill(undefined));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_next, new UintArray(max));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_prev, new UintArray(max));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, 0);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, 0);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_free, $7b6fbaf78221d996$var$Stack.create(max));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_size, 0);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_disposeAfter, disposeAfter);
            (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_disposed, []);
        } else {
            (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_disposeAfter, undefined);
            (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_disposed, undefined);
        }
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_hasDispose, !!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_dispose));
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter, !!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize) !== 0) {
                if (!$7b6fbaf78221d996$var$isPosInt((0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$7b6fbaf78221d996$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_initializeSizeTracking, $7b6fbaf78221d996$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $7b6fbaf78221d996$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$7b6fbaf78221d996$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_initializeTTLTracking, $7b6fbaf78221d996$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_max) === 0 && this.ttl === 0 && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $el4bI._)(this, $7b6fbaf78221d996$var$_max) && !(0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize)) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if ($7b6fbaf78221d996$var$shouldWarn(code)) {
                $7b6fbaf78221d996$var$warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $7b6fbaf78221d996$var$emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    (0, $byiyg._)(LRUCache, [
        {
            key: "max",
            get: // Protected read-only members
            /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_max);
            }
        },
        {
            key: "maxSize",
            get: /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_maxSize);
            }
        },
        {
            key: "calculatedSize",
            get: /**
     * The total computed size of items in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_calculatedSize);
            }
        },
        {
            key: "size",
            get: /**
     * The number of items stored in the cache (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_size);
            }
        },
        {
            key: "fetchMethod",
            get: /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_fetchMethod);
            }
        },
        {
            key: "memoMethod",
            get: function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_memoMethod);
            }
        },
        {
            key: "dispose",
            get: /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_dispose);
            }
        },
        {
            key: "disposeAfter",
            get: /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ function get() {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposeAfter);
            }
        },
        {
            /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).has(key) ? Infinity : 0;
            }
        },
        {
            key: "entries",
            value: /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i],
                                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!((0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i] !== undefined && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i] !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i],
                                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, k, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            k = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i];
                            if (!(k !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                k
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, v, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                            if (!(v !== undefined && !(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ key: "find",
            value: function find(fn) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i], this)) return this.get((0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, i)) {
                            (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i], 'expire');
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ key: "info",
            value: function info(key) {
                var i = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(key);
                if (i === undefined) return undefined;
                var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                var value = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                if (value === undefined) return undefined;
                var entry = {
                    value: value
                };
                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts)) {
                    var ttl = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls)[i];
                    var start = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts)[i];
                    if (ttl && start) {
                        var remain = ttl - ($7b6fbaf78221d996$var$perf.now() - start);
                        entry.ttl = remain;
                        entry.start = Date.now();
                    }
                }
                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes)) entry.size = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes)[i];
                return entry;
            }
        },
        {
            /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(this, {
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[i];
                        var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[i];
                        var value = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
                        if (value === undefined || key === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts)) {
                            entry.ttl = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls)[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = $7b6fbaf78221d996$var$perf.now() - (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts)[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes)) entry.size = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes)[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset, so that
                            // we get the intended remaining TTL, no matter how long it's
                            // been on ice.
                            //
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = $7b6fbaf78221d996$var$perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ key: "set",
            value: function set(k, v) {
                var setOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
                if (v === undefined) {
                    this["delete"](k);
                    return this;
                }
                var _setOptions_ttl = setOptions.ttl, ttl = _setOptions_ttl === void 0 ? this.ttl : _setOptions_ttl, start = setOptions.start, _setOptions_noDisposeOnSet = setOptions.noDisposeOnSet, noDisposeOnSet = _setOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _setOptions_noDisposeOnSet, _setOptions_sizeCalculation = setOptions.sizeCalculation, sizeCalculation = _setOptions_sizeCalculation === void 0 ? this.sizeCalculation : _setOptions_sizeCalculation, status = setOptions.status;
                var _setOptions_noUpdateTTL = setOptions.noUpdateTTL, noUpdateTTL = _setOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _setOptions_noUpdateTTL;
                var size = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case something is there already.
                    (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(this, k, 'set');
                    return this;
                }
                var index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) === 0 ? undefined : (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
                if (index === undefined) {
                    // addition
                    index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) === 0 ? (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail) : (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).length !== 0 ? (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).pop() : (0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_max) ? (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_evict, $7b6fbaf78221d996$var$evict).call(this, false) : (0, $el4bI._)(this, $7b6fbaf78221d996$var$_size);
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[index] = k;
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index] = v;
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).set(k, index);
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[(0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail)] = index;
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[index] = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail);
                    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, index);
                    (0, $3cNKp._)(this, $7b6fbaf78221d996$var$_size).value++;
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_addItemSize).call(this, index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_moveToTail, $7b6fbaf78221d996$var$moveToTail).call(this, index);
                    var oldVal = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                    if (v !== oldVal) {
                        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, oldVal)) {
                            oldVal.__abortController.abort(new Error('replaced'));
                            var s = oldVal.__staleWhileFetching;
                            if (s !== undefined && !noDisposeOnSet) {
                                var _$_class_private_field_get;
                                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $7b6fbaf78221d996$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                                    s,
                                    k,
                                    'set'
                                ]);
                            }
                        } else if (!noDisposeOnSet) {
                            var _$_class_private_field_get1;
                            if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose)) (_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $7b6fbaf78221d996$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                            if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_removeItemSize).call(this, index);
                        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_addItemSize).call(this, index, size, status);
                        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index] = v;
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && !(0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls)) (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_initializeTTLTracking, $7b6fbaf78221d996$var$initializeTTLTracking).call(this);
                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls)) {
                    if (!noUpdateTTL) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_setItemTTL).call(this, index, ttl, start);
                    if (status) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_statusTTL).call(this, status, index);
                }
                if (!noDisposeOnSet && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) {
                    var _this6;
                    var dt = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed);
                    var task;
                    while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $el4bI._)(_ref2 = _this5 = this, $7b6fbaf78221d996$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : (_this6 = _this4).call.apply(_this6, [
                        _this5
                    ].concat((0, $7WNf6._)(task)));
                }
                return this;
            }
        },
        {
            /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ key: "pop",
            value: function pop() {
                var _this, _this1, _ref;
                try {
                    while((0, $el4bI._)(this, $7b6fbaf78221d996$var$_size)){
                        var val = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[(0, $el4bI._)(this, $7b6fbaf78221d996$var$_head)];
                        (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_evict, $7b6fbaf78221d996$var$evict).call(this, true);
                        if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, val)) {
                            if (val.__staleWhileFetching) return val.__staleWhileFetching;
                        } else if (val !== undefined) return val;
                    }
                } finally{
                    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) {
                        var _this2;
                        var dt = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed);
                        var task;
                        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $el4bI._)(_ref = _this1 = this, $7b6fbaf78221d996$var$_disposeAfter)) === null || _this === void 0 ? void 0 : (_this2 = _this).call.apply(_this2, [
                            _this1
                        ].concat((0, $7WNf6._)(task)));
                    }
                }
            }
        },
        {
            /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ key: "has",
            value: function has(k) {
                var hasOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _hasOptions_updateAgeOnHas = hasOptions.updateAgeOnHas, updateAgeOnHas = _hasOptions_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _hasOptions_updateAgeOnHas, status = hasOptions.status;
                var index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
                if (index !== undefined) {
                    var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                    if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
                    if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, index)) {
                        if (updateAgeOnHas) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_updateItemAge).call(this, index);
                        if (status) {
                            status.has = 'hit';
                            (0, $el4bI._)(this, $7b6fbaf78221d996$var$_statusTTL).call(this, status, index);
                        }
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_statusTTL).call(this, status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ key: "peek",
            value: function peek(k) {
                var peekOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _peekOptions_allowStale = peekOptions.allowStale, allowStale = _peekOptions_allowStale === void 0 ? this.allowStale : _peekOptions_allowStale;
                var index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
                if (index === undefined || !allowStale && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, index)) return;
                var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                // either stale and allowed, or forcing a refresh of non-stale value
                return (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            }
        },
        {
            key: "fetch",
            value: function fetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, _fetchOptions_allowStale, // get options
                    allowStale, _fetchOptions_updateAgeOnGet, updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet, noDeleteOnStaleGet, _fetchOptions_ttl, // set options
                    ttl, _fetchOptions_noDisposeOnSet, noDisposeOnSet, _fetchOptions_size, size, _fetchOptions_sizeCalculation, sizeCalculation, _fetchOptions_noUpdateTTL, noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection, // fetch exclusive options
                    noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection, allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort, ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort, allowStaleOnFetchAbort, context, _fetchOptions_forceRefresh, forceRefresh, status, signal, options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _fetchOptions_allowStale = fetchOptions.allowStale, allowStale = _fetchOptions_allowStale === void 0 ? this.allowStale : _fetchOptions_allowStale, _fetchOptions_updateAgeOnGet = fetchOptions.updateAgeOnGet, updateAgeOnGet = _fetchOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _fetchOptions_updateAgeOnGet, _fetchOptions_noDeleteOnStaleGet = fetchOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _fetchOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _fetchOptions_noDeleteOnStaleGet, _fetchOptions_ttl = fetchOptions.ttl, ttl = _fetchOptions_ttl === void 0 ? this.ttl : _fetchOptions_ttl, _fetchOptions_noDisposeOnSet = fetchOptions.noDisposeOnSet, noDisposeOnSet = _fetchOptions_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _fetchOptions_noDisposeOnSet, _fetchOptions_size = fetchOptions.size, size = _fetchOptions_size === void 0 ? 0 : _fetchOptions_size, _fetchOptions_sizeCalculation = fetchOptions.sizeCalculation, sizeCalculation = _fetchOptions_sizeCalculation === void 0 ? this.sizeCalculation : _fetchOptions_sizeCalculation, _fetchOptions_noUpdateTTL = fetchOptions.noUpdateTTL, noUpdateTTL = _fetchOptions_noUpdateTTL === void 0 ? this.noUpdateTTL : _fetchOptions_noUpdateTTL, _fetchOptions_noDeleteOnFetchRejection = fetchOptions.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _fetchOptions_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _fetchOptions_noDeleteOnFetchRejection, _fetchOptions_allowStaleOnFetchRejection = fetchOptions.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _fetchOptions_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _fetchOptions_allowStaleOnFetchRejection, _fetchOptions_ignoreFetchAbort = fetchOptions.ignoreFetchAbort, ignoreFetchAbort = _fetchOptions_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _fetchOptions_ignoreFetchAbort, _fetchOptions_allowStaleOnFetchAbort = fetchOptions.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _fetchOptions_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _fetchOptions_allowStaleOnFetchAbort, context = fetchOptions.context, _fetchOptions_forceRefresh = fetchOptions.forceRefresh, forceRefresh = _fetchOptions_forceRefresh === void 0 ? false : _fetchOptions_forceRefresh, status = fetchOptions.status, signal = fetchOptions.signal;
                        if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasFetchMethod)) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_backgroundFetch, $7b6fbaf78221d996$var$backgroundFetch).call(this, k, index, options, context);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                            if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_moveToTail, $7b6fbaf78221d996$var$moveToTail).call(this, index);
                                if (updateAgeOnGet) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_updateItemAge).call(this, index);
                                if (status) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_statusTTL).call(this, status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_backgroundFetch, $7b6fbaf78221d996$var$backgroundFetch).call(this, k, index, options, context);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "forceFetch",
            value: function forceFetch(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(k) {
                    var fetchOptions, v;
                    var _arguments = arguments;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    this.fetch(k, fetchOptions)
                                ];
                            case 1:
                                v = _state.sent();
                                if (v === undefined) throw new Error('fetch() returned undefined');
                                return [
                                    2,
                                    v
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "memo",
            value: function memo(k) {
                var memoOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var memoMethod = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_memoMethod);
                if (!memoMethod) throw new Error('no memoMethod provided to constructor');
                var context = memoOptions.context, forceRefresh = memoOptions.forceRefresh, options = (0, $g79Gh._)(memoOptions, [
                    "context",
                    "forceRefresh"
                ]);
                var v = this.get(k, options);
                if (!forceRefresh && v !== undefined) return v;
                var vv = memoMethod(k, v, {
                    options: options,
                    context: context
                });
                this.set(k, vv, options);
                return vv;
            }
        },
        {
            /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ key: "get",
            value: function get(k) {
                var getOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _getOptions_allowStale = getOptions.allowStale, allowStale = _getOptions_allowStale === void 0 ? this.allowStale : _getOptions_allowStale, _getOptions_updateAgeOnGet = getOptions.updateAgeOnGet, updateAgeOnGet = _getOptions_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _getOptions_updateAgeOnGet, _getOptions_noDeleteOnStaleGet = getOptions.noDeleteOnStaleGet, noDeleteOnStaleGet = _getOptions_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _getOptions_noDeleteOnStaleGet, status = getOptions.status;
                var index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
                if (index !== undefined) {
                    var value = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                    var fetching = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, value);
                    if (status) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_statusTTL).call(this, status, index);
                    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(this, k, 'expire');
                            if (status && allowStale) status.returnedStale = true;
                            return allowStale ? value : undefined;
                        } else {
                            if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_moveToTail, $7b6fbaf78221d996$var$moveToTail).call(this, index);
                        if (updateAgeOnGet) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_updateItemAge).call(this, index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ key: "delete",
            value: function _delete1(k) {
                return (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(this, k, 'delete');
            }
        },
        {
            /**
     * Clear the cache entirely, throwing away all values.
     */ key: "clear",
            value: function clear1() {
                return (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_clear, $7b6fbaf78221d996$var$clear).call(this, 'delete');
            }
        }
    ], [
        {
            key: "unsafeExposeInternals",
            value: /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ function unsafeExposeInternals(c) {
                return {
                    // properties
                    starts: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_starts),
                    ttls: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_ttls),
                    sizes: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_sizes),
                    keyMap: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_keyMap),
                    keyList: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_keyList),
                    valList: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_valList),
                    next: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_next),
                    prev: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_prev),
                    get head () {
                        return (0, $el4bI._)(c, $7b6fbaf78221d996$var$_head);
                    },
                    get tail () {
                        return (0, $el4bI._)(c, $7b6fbaf78221d996$var$_tail);
                    },
                    free: (0, $el4bI._)(c, $7b6fbaf78221d996$var$_free),
                    // methods
                    isBackgroundFetch: function(p) {
                        return (0, $dZ0wD._)(c, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(c, p);
                    },
                    backgroundFetch: function(k, index, options, context) {
                        return (0, $dZ0wD._)(c, $7b6fbaf78221d996$var$_backgroundFetch, $7b6fbaf78221d996$var$backgroundFetch).call(c, k, index, options, context);
                    },
                    moveToTail: function(index) {
                        return (0, $dZ0wD._)(c, $7b6fbaf78221d996$var$_moveToTail, $7b6fbaf78221d996$var$moveToTail).call(c, index);
                    },
                    indexes: function(options) {
                        return (0, $dZ0wD._)(c, $7b6fbaf78221d996$var$_indexes, $7b6fbaf78221d996$var$indexes).call(c, options);
                    },
                    rindexes: function(options) {
                        return (0, $dZ0wD._)(c, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(c, options);
                    },
                    isStale: function(index) {
                        return (0, $el4bI._)(c, $7b6fbaf78221d996$var$_isStale).call(c, index);
                    }
                };
            }
        }
    ]);
    return LRUCache;
}();
function $7b6fbaf78221d996$var$initializeTTLTracking() {
    var _this = this;
    var _this1 = this;
    var ttls = new $7b6fbaf78221d996$var$ZeroArray((0, $el4bI._)(this, $7b6fbaf78221d996$var$_max));
    var starts = new $7b6fbaf78221d996$var$ZeroArray((0, $el4bI._)(this, $7b6fbaf78221d996$var$_max));
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_ttls, ttls);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_starts, starts);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_setItemTTL, function(index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7b6fbaf78221d996$var$perf.now();
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && _this1.ttlAutopurge) {
            var t = setTimeout(function() {
                if ((0, $el4bI._)(_this1, $7b6fbaf78221d996$var$_isStale).call(_this1, index)) (0, $dZ0wD._)(_this1, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(_this1, (0, $el4bI._)(_this1, $7b6fbaf78221d996$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_updateItemAge, function(index) {
        starts[index] = ttls[index] !== 0 ? $7b6fbaf78221d996$var$perf.now() : 0;
    });
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_statusTTL, function(status, index) {
        if (ttls[index]) {
            var ttl = ttls[index];
            var start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            var age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    var cachedNow = 0;
    var getNow = function() {
        var n = $7b6fbaf78221d996$var$perf.now();
        if (_this.ttlResolution > 0) {
            cachedNow = n;
            var t = setTimeout(function() {
                return cachedNow = 0;
            }, _this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = function(key) {
        var index = (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_keyMap).get(key);
        if (index === undefined) return 0;
        var ttl = ttls[index];
        var start = starts[index];
        if (!ttl || !start) return Infinity;
        var age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_isStale, function(index) {
        var s = starts[index];
        var t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $7b6fbaf78221d996$var$initializeSizeTracking() {
    var _this = this;
    var sizes = new $7b6fbaf78221d996$var$ZeroArray((0, $el4bI._)(this, $7b6fbaf78221d996$var$_max));
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_sizes, sizes);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_removeItemSize, function(index) {
        (0, $FPkD9._)(_this, $7b6fbaf78221d996$var$_calculatedSize, (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_requireSize, function(k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $dZ0wD._)(_this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(_this, v)) return 0;
        if (!$7b6fbaf78221d996$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$7b6fbaf78221d996$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_addItemSize, function(index, size, status) {
        sizes[index] = size;
        if ((0, $el4bI._)(_this, $7b6fbaf78221d996$var$_maxSize)) {
            var maxSize = (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_maxSize) - sizes[index];
            while((0, $el4bI._)(_this, $7b6fbaf78221d996$var$_calculatedSize) > maxSize)(0, $dZ0wD._)(_this, $7b6fbaf78221d996$var$_evict, $7b6fbaf78221d996$var$evict).call(_this, true);
        }
        (0, $FPkD9._)(_this, $7b6fbaf78221d996$var$_calculatedSize, (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_calculatedSize);
        }
    });
}
function $7b6fbaf78221d996$var$indexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isValidIndex, $7b6fbaf78221d996$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_head)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $7b6fbaf78221d996$var$rindexes() {
    var _ref, _ref_allowStale, allowStale, i;
    var _arguments = arguments;
    return (0, $9N5UN.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_size)) return [
                    3,
                    5
                ];
                i = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_head);
                _state.label = 1;
            case 1:
                if (!(0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isValidIndex, $7b6fbaf78221d996$var$isValidIndex).call(this, i)) return [
                    3,
                    5
                ];
                if (!(allowStale || !(0, $el4bI._)(this, $7b6fbaf78221d996$var$_isStale).call(this, i))) return [
                    3,
                    3
                ];
                return [
                    4,
                    i
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                if (i === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail)) return [
                    3,
                    5
                ];
                else i = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[i];
                _state.label = 4;
            case 4:
                return [
                    3,
                    1
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function $7b6fbaf78221d996$var$isValidIndex(index) {
    return index !== undefined && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get((0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[index]) === index;
}
function $7b6fbaf78221d996$var$evict(free) {
    var _this, _this1, _ref;
    var head = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_head);
    var k = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[head];
    var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[head];
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasFetchMethod) && (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose) || (0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) {
        var _$_class_private_field_get;
        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $7b6fbaf78221d996$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[head] = undefined;
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[head] = undefined;
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).push(head);
    }
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) === 1) {
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, 0));
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).length = 0;
    } else (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[head]);
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap)["delete"](k);
    (0, $3cNKp._)(this, $7b6fbaf78221d996$var$_size).value--;
    return head;
}
function $7b6fbaf78221d996$var$backgroundFetch(k, index, options, context) {
    var _this = this;
    var _this1 = this;
    var _this2, _this3, _ref;
    var v = index === undefined ? undefined : (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
    if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v)) return v;
    var ac = new $7b6fbaf78221d996$var$AC();
    var signal = options.signal;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function() {
        return ac.abort(signal.reason);
    }, {
        signal: ac.signal
    });
    var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    var cb = function(v) {
        var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var aborted = ac.signal.aborted;
        var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        var bf = p;
        if ((0, $el4bI._)(_this1, $7b6fbaf78221d996$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $el4bI._)(_this1, $7b6fbaf78221d996$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $dZ0wD._)(_this1, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(_this1, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                _this1.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    var eb = function(er) {
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    var fetchFail = function(er) {
        var aborted = ac.signal.aborted;
        var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        var noDelete = allowStale || options.noDeleteOnFetchRejection;
        var bf = p;
        if ((0, $el4bI._)(_this, $7b6fbaf78221d996$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            var del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $dZ0wD._)(_this, $7b6fbaf78221d996$var$_delete, $7b6fbaf78221d996$var$__delete).call(_this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $el4bI._)(_this, $7b6fbaf78221d996$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    var pcall = function(res, rej) {
        var fmp = (_this2 = (0, $el4bI._)(_ref = _this3 = _this, $7b6fbaf78221d996$var$_fetchMethod)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then(function(v) {
            return res(v === undefined ? undefined : v);
        }, rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', function() {
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = function(v) {
                    return cb(v, true);
                };
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    var p = new Promise(pcall).then(cb, eb);
    var bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $emQHU._)((0, $iT0je._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
    } else (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index] = bf;
    return bf;
}
function $7b6fbaf78221d996$var$isBackgroundFetch(p) {
    if (!(0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasFetchMethod)) return false;
    var b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $7b6fbaf78221d996$var$AC;
}
function $7b6fbaf78221d996$var$connect(p, n) {
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[n] = p;
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[p] = n;
}
function $7b6fbaf78221d996$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail)) {
        if (index === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_head)) (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[index]);
        else (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_connect, $7b6fbaf78221d996$var$connect).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[index], (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[index]);
        (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_connect, $7b6fbaf78221d996$var$connect).call(this, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail), index);
        (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, index);
    }
}
function $7b6fbaf78221d996$var$__delete(k, reason) {
    var _$_class_private_field_get;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var deleted = false;
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) !== 0) {
        var index = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_size) === 1) (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_clear, $7b6fbaf78221d996$var$clear).call(this, reason);
            else {
                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_removeItemSize).call(this, index);
                var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
                if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose) || (0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) {
                    var _$_class_private_field_get1;
                    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $7b6fbaf78221d996$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) (_$_class_private_field_get1 = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap)["delete"](k);
                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[index] = undefined;
                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index] = undefined;
                if (index === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_tail)) (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[index]);
                else if (index === (0, $el4bI._)(this, $7b6fbaf78221d996$var$_head)) (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[index]);
                else {
                    var pi = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[index];
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[pi] = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[index];
                    var ni = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_next)[index];
                    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[ni] = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_prev)[index];
                }
                (0, $3cNKp._)(this, $7b6fbaf78221d996$var$_size).value--;
                (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).push(index);
            }
        }
    }
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter) && ((_$_class_private_field_get = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.length)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $7b6fbaf78221d996$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
    return deleted;
}
function $7b6fbaf78221d996$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_rindexes, $7b6fbaf78221d996$var$rindexes).call(this, {
            allowStale: true
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var v = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList)[index];
            if ((0, $dZ0wD._)(this, $7b6fbaf78221d996$var$_isBackgroundFetch, $7b6fbaf78221d996$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
            else {
                var _$_class_private_field_get;
                var k = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList)[index];
                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDispose)) (_this = (0, $el4bI._)(_ref = _this1 = this, $7b6fbaf78221d996$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter)) (_$_class_private_field_get = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyMap).clear();
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_valList).fill(undefined);
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_keyList).fill(undefined);
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts)) {
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_ttls).fill(0);
        (0, $el4bI._)(this, $7b6fbaf78221d996$var$_starts).fill(0);
    }
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes)) (0, $el4bI._)(this, $7b6fbaf78221d996$var$_sizes).fill(0);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_head, 0);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_tail, 0);
    (0, $el4bI._)(this, $7b6fbaf78221d996$var$_free).length = 0;
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_calculatedSize, 0);
    (0, $FPkD9._)(this, $7b6fbaf78221d996$var$_size, 0);
    if ((0, $el4bI._)(this, $7b6fbaf78221d996$var$_hasDisposeAfter) && (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed)) {
        var _this4;
        var dt = (0, $el4bI._)(this, $7b6fbaf78221d996$var$_disposed);
        var task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $el4bI._)(_ref1 = _this3 = this, $7b6fbaf78221d996$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : (_this4 = _this2).call.apply(_this4, [
            _this3
        ].concat((0, $7WNf6._)(task)));
    }
}

});

parcelRegister("bwPrQ", function(module, exports) {
'use strict';

var $20TSl = parcelRequire("20TSl");

var $8LJvk = parcelRequire("8LJvk");
var $864a97683bfddd34$var$originalDestroy = $20TSl.Readable.destroy;
module.exports = $20TSl.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $20TSl._uint8ArrayToBuffer;
module.exports._isUint8Array = $20TSl._isUint8Array;
module.exports.isDisturbed = $20TSl.isDisturbed;
module.exports.isErrored = $20TSl.isErrored;
module.exports.isReadable = $20TSl.isReadable;
module.exports.Readable = $20TSl.Readable;
module.exports.Writable = $20TSl.Writable;
module.exports.Duplex = $20TSl.Duplex;
module.exports.Transform = $20TSl.Transform;
module.exports.PassThrough = $20TSl.PassThrough;
module.exports.addAbortSignal = $20TSl.addAbortSignal;
module.exports.finished = $20TSl.finished;
module.exports.destroy = $20TSl.destroy;
module.exports.destroy = $864a97683bfddd34$var$originalDestroy;
module.exports.pipeline = $20TSl.pipeline;
module.exports.compose = $20TSl.compose;
Object.defineProperty($20TSl, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $8LJvk;
    }
});
module.exports.Stream = $20TSl.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("20TSl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $bMvJO = parcelRequire("bMvJO");
var $1776ec941510a79c$require$Buffer = $bMvJO.Buffer;

var $lBvnk = parcelRequire("lBvnk");
/* replacement end */ var $1776ec941510a79c$var$ObjectDefineProperty = $lBvnk.ObjectDefineProperty, $1776ec941510a79c$var$ObjectKeys = $lBvnk.ObjectKeys, $1776ec941510a79c$var$ReflectApply = $lBvnk.ReflectApply;

var $kscRZ = parcelRequire("kscRZ");
var $1776ec941510a79c$var$_require_promisify = $kscRZ.promisify, $1776ec941510a79c$var$customPromisify = $1776ec941510a79c$var$_require_promisify.custom;

var $8rg6E = parcelRequire("8rg6E");
var $1776ec941510a79c$var$streamReturningOperators = $8rg6E.streamReturningOperators, $1776ec941510a79c$var$promiseReturningOperators = $8rg6E.promiseReturningOperators;

var $3Fpho = parcelRequire("3Fpho");
var $1776ec941510a79c$var$ERR_ILLEGAL_CONSTRUCTOR = $3Fpho.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $6ooOy = parcelRequire("6ooOy");

var $7rwXa = parcelRequire("7rwXa");
var $1776ec941510a79c$var$setDefaultHighWaterMark = $7rwXa.setDefaultHighWaterMark, $1776ec941510a79c$var$getDefaultHighWaterMark = $7rwXa.getDefaultHighWaterMark;

var $hC1T5 = parcelRequire("hC1T5");
var $1776ec941510a79c$require$pipeline = $hC1T5.pipeline;

var $axhPV = parcelRequire("axhPV");
var $1776ec941510a79c$require$destroyer = $axhPV.destroyer;

var $1Jum0 = parcelRequire("1Jum0");
var $1776ec941510a79c$var$internalBuffer = {};

var $8LJvk = parcelRequire("8LJvk");

var $khkpJ = parcelRequire("khkpJ");

var $1776ec941510a79c$var$Stream = module.exports = (parcelRequire("i7NB2")).Stream;
$1776ec941510a79c$var$Stream.isDestroyed = $khkpJ.isDestroyed;
$1776ec941510a79c$var$Stream.isDisturbed = $khkpJ.isDisturbed;
$1776ec941510a79c$var$Stream.isErrored = $khkpJ.isErrored;
$1776ec941510a79c$var$Stream.isReadable = $khkpJ.isReadable;
$1776ec941510a79c$var$Stream.isWritable = $khkpJ.isWritable;

$1776ec941510a79c$var$Stream.Readable = (parcelRequire("jj8ac"));
var $1776ec941510a79c$var$_iteratorNormalCompletion = true, $1776ec941510a79c$var$_didIteratorError = false, $1776ec941510a79c$var$_iteratorError = undefined;
try {
    for(var $1776ec941510a79c$var$_iterator = $1776ec941510a79c$var$ObjectKeys($1776ec941510a79c$var$streamReturningOperators)[Symbol.iterator](), $1776ec941510a79c$var$_step; !($1776ec941510a79c$var$_iteratorNormalCompletion = ($1776ec941510a79c$var$_step = $1776ec941510a79c$var$_iterator.next()).done); $1776ec941510a79c$var$_iteratorNormalCompletion = true){
        var $1776ec941510a79c$var$key = $1776ec941510a79c$var$_step.value;
        var $1776ec941510a79c$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $1776ec941510a79c$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $1776ec941510a79c$var$Stream.Readable.from($1776ec941510a79c$var$ReflectApply($1776ec941510a79c$var$op, this, args));
        };
        var $1776ec941510a79c$var$op = $1776ec941510a79c$var$streamReturningOperators[$1776ec941510a79c$var$key];
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$fn, 'name', {
            __proto__: null,
            value: $1776ec941510a79c$var$op.name
        });
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$fn, 'length', {
            __proto__: null,
            value: $1776ec941510a79c$var$op.length
        });
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$Stream.Readable.prototype, $1776ec941510a79c$var$key, {
            __proto__: null,
            value: $1776ec941510a79c$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $1776ec941510a79c$var$_didIteratorError = true;
    $1776ec941510a79c$var$_iteratorError = err;
} finally{
    try {
        if (!$1776ec941510a79c$var$_iteratorNormalCompletion && $1776ec941510a79c$var$_iterator["return"] != null) {
            $1776ec941510a79c$var$_iterator["return"]();
        }
    } finally{
        if ($1776ec941510a79c$var$_didIteratorError) {
            throw $1776ec941510a79c$var$_iteratorError;
        }
    }
}
var $1776ec941510a79c$var$_iteratorNormalCompletion1 = true, $1776ec941510a79c$var$_didIteratorError1 = false, $1776ec941510a79c$var$_iteratorError1 = undefined;
try {
    for(var $1776ec941510a79c$var$_iterator1 = $1776ec941510a79c$var$ObjectKeys($1776ec941510a79c$var$promiseReturningOperators)[Symbol.iterator](), $1776ec941510a79c$var$_step1; !($1776ec941510a79c$var$_iteratorNormalCompletion1 = ($1776ec941510a79c$var$_step1 = $1776ec941510a79c$var$_iterator1.next()).done); $1776ec941510a79c$var$_iteratorNormalCompletion1 = true){
        var $1776ec941510a79c$var$key1 = $1776ec941510a79c$var$_step1.value;
        var $1776ec941510a79c$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $1776ec941510a79c$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $1776ec941510a79c$var$ReflectApply($1776ec941510a79c$var$op1, this, args);
        };
        var $1776ec941510a79c$var$op1 = $1776ec941510a79c$var$promiseReturningOperators[$1776ec941510a79c$var$key1];
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$fn1, 'name', {
            __proto__: null,
            value: $1776ec941510a79c$var$op1.name
        });
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$fn1, 'length', {
            __proto__: null,
            value: $1776ec941510a79c$var$op1.length
        });
        $1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$Stream.Readable.prototype, $1776ec941510a79c$var$key1, {
            __proto__: null,
            value: $1776ec941510a79c$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $1776ec941510a79c$var$_didIteratorError1 = true;
    $1776ec941510a79c$var$_iteratorError1 = err;
} finally{
    try {
        if (!$1776ec941510a79c$var$_iteratorNormalCompletion1 && $1776ec941510a79c$var$_iterator1["return"] != null) {
            $1776ec941510a79c$var$_iterator1["return"]();
        }
    } finally{
        if ($1776ec941510a79c$var$_didIteratorError1) {
            throw $1776ec941510a79c$var$_iteratorError1;
        }
    }
}

$1776ec941510a79c$var$Stream.Writable = (parcelRequire("179U2"));

$1776ec941510a79c$var$Stream.Duplex = (parcelRequire("026ih"));

$1776ec941510a79c$var$Stream.Transform = (parcelRequire("j7LFv"));

$1776ec941510a79c$var$Stream.PassThrough = (parcelRequire("2Pt9T"));
$1776ec941510a79c$var$Stream.pipeline = $1776ec941510a79c$require$pipeline;

var $loAsg = parcelRequire("loAsg");
var $1776ec941510a79c$require$addAbortSignal = $loAsg.addAbortSignal;
$1776ec941510a79c$var$Stream.addAbortSignal = $1776ec941510a79c$require$addAbortSignal;
$1776ec941510a79c$var$Stream.finished = $1Jum0;
$1776ec941510a79c$var$Stream.destroy = $1776ec941510a79c$require$destroyer;
$1776ec941510a79c$var$Stream.compose = $6ooOy;
$1776ec941510a79c$var$Stream.setDefaultHighWaterMark = $1776ec941510a79c$var$setDefaultHighWaterMark;
$1776ec941510a79c$var$Stream.getDefaultHighWaterMark = $1776ec941510a79c$var$getDefaultHighWaterMark;
$1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $8LJvk;
    }
});
$1776ec941510a79c$var$ObjectDefineProperty($1776ec941510a79c$require$pipeline, $1776ec941510a79c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $8LJvk.pipeline;
    }
});
$1776ec941510a79c$var$ObjectDefineProperty($1Jum0, $1776ec941510a79c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $8LJvk.finished;
    }
});
// Backwards-compat with node 0.4.x
$1776ec941510a79c$var$Stream.Stream = $1776ec941510a79c$var$Stream;
$1776ec941510a79c$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$1776ec941510a79c$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $1776ec941510a79c$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("bMvJO", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $893ccbe34513b8fb$export$a143d493d941bafc; }, function (v) { return $893ccbe34513b8fb$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $893ccbe34513b8fb$export$f99ded8fe4b79145; }, function (v) { return $893ccbe34513b8fb$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $893ccbe34513b8fb$export$a143d493d941bafc;
var $893ccbe34513b8fb$export$e4cf37d7f6fb9e0a;
var $893ccbe34513b8fb$export$f99ded8fe4b79145;
var $893ccbe34513b8fb$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $893ccbe34513b8fb$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$893ccbe34513b8fb$export$a143d493d941bafc = $893ccbe34513b8fb$var$Buffer;
$893ccbe34513b8fb$export$e4cf37d7f6fb9e0a = $893ccbe34513b8fb$var$SlowBuffer;
$893ccbe34513b8fb$export$f99ded8fe4b79145 = 50;
var $893ccbe34513b8fb$var$K_MAX_LENGTH = 0x7fffffff;
$893ccbe34513b8fb$export$599f31c3813fae4d = $893ccbe34513b8fb$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $893ccbe34513b8fb$var$Buffer.TYPED_ARRAY_SUPPORT = $893ccbe34513b8fb$var$typedArraySupport();
if (!$893ccbe34513b8fb$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $893ccbe34513b8fb$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($893ccbe34513b8fb$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$893ccbe34513b8fb$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($893ccbe34513b8fb$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$893ccbe34513b8fb$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $893ccbe34513b8fb$var$createBuffer(length) {
    if (length > $893ccbe34513b8fb$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $893ccbe34513b8fb$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $893ccbe34513b8fb$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $893ccbe34513b8fb$var$allocUnsafe(arg);
    }
    return $893ccbe34513b8fb$var$from(arg, encodingOrOffset, length);
}
$893ccbe34513b8fb$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $893ccbe34513b8fb$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $893ccbe34513b8fb$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $893ccbe34513b8fb$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($893ccbe34513b8fb$var$isInstance(value, ArrayBuffer) || value && $893ccbe34513b8fb$var$isInstance(value.buffer, ArrayBuffer)) return $893ccbe34513b8fb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($893ccbe34513b8fb$var$isInstance(value, SharedArrayBuffer) || value && $893ccbe34513b8fb$var$isInstance(value.buffer, SharedArrayBuffer))) return $893ccbe34513b8fb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $893ccbe34513b8fb$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $893ccbe34513b8fb$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $893ccbe34513b8fb$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $893ccbe34513b8fb$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $893ccbe34513b8fb$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($893ccbe34513b8fb$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($893ccbe34513b8fb$var$Buffer, Uint8Array);
function $893ccbe34513b8fb$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $893ccbe34513b8fb$var$alloc(size, fill, encoding) {
    $893ccbe34513b8fb$var$assertSize(size);
    if (size <= 0) return $893ccbe34513b8fb$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $893ccbe34513b8fb$var$createBuffer(size).fill(fill, encoding) : $893ccbe34513b8fb$var$createBuffer(size).fill(fill);
    return $893ccbe34513b8fb$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $893ccbe34513b8fb$var$Buffer.alloc = function(size, fill, encoding) {
    return $893ccbe34513b8fb$var$alloc(size, fill, encoding);
};
function $893ccbe34513b8fb$var$allocUnsafe(size) {
    $893ccbe34513b8fb$var$assertSize(size);
    return $893ccbe34513b8fb$var$createBuffer(size < 0 ? 0 : $893ccbe34513b8fb$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $893ccbe34513b8fb$var$Buffer.allocUnsafe = function(size) {
    return $893ccbe34513b8fb$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $893ccbe34513b8fb$var$Buffer.allocUnsafeSlow = function(size) {
    return $893ccbe34513b8fb$var$allocUnsafe(size);
};
function $893ccbe34513b8fb$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$893ccbe34513b8fb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $893ccbe34513b8fb$var$byteLength(string, encoding) | 0;
    var buf = $893ccbe34513b8fb$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $893ccbe34513b8fb$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $893ccbe34513b8fb$var$checked(array.length) | 0;
    var buf = $893ccbe34513b8fb$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $893ccbe34513b8fb$var$fromArrayView(arrayView) {
    if ($893ccbe34513b8fb$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $893ccbe34513b8fb$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $893ccbe34513b8fb$var$fromArrayLike(arrayView);
}
function $893ccbe34513b8fb$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $893ccbe34513b8fb$var$Buffer.prototype);
    return buf;
}
function $893ccbe34513b8fb$var$fromObject(obj) {
    if ($893ccbe34513b8fb$var$Buffer.isBuffer(obj)) {
        var len = $893ccbe34513b8fb$var$checked(obj.length) | 0;
        var buf = $893ccbe34513b8fb$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $893ccbe34513b8fb$var$numberIsNaN(obj.length)) return $893ccbe34513b8fb$var$createBuffer(0);
        return $893ccbe34513b8fb$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $893ccbe34513b8fb$var$fromArrayLike(obj.data);
}
function $893ccbe34513b8fb$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $893ccbe34513b8fb$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $893ccbe34513b8fb$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $893ccbe34513b8fb$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $893ccbe34513b8fb$var$Buffer.alloc(+length);
}
$893ccbe34513b8fb$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $893ccbe34513b8fb$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$893ccbe34513b8fb$var$Buffer.compare = function compare(a, b) {
    if ($893ccbe34513b8fb$var$isInstance(a, Uint8Array)) a = $893ccbe34513b8fb$var$Buffer.from(a, a.offset, a.byteLength);
    if ($893ccbe34513b8fb$var$isInstance(b, Uint8Array)) b = $893ccbe34513b8fb$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$893ccbe34513b8fb$var$Buffer.isBuffer(a) || !$893ccbe34513b8fb$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$893ccbe34513b8fb$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$893ccbe34513b8fb$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $893ccbe34513b8fb$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $893ccbe34513b8fb$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($893ccbe34513b8fb$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$893ccbe34513b8fb$var$Buffer.isBuffer(buf)) buf = $893ccbe34513b8fb$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$893ccbe34513b8fb$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $893ccbe34513b8fb$var$byteLength(string, encoding) {
    if ($893ccbe34513b8fb$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $893ccbe34513b8fb$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $893ccbe34513b8fb$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $893ccbe34513b8fb$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $893ccbe34513b8fb$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$893ccbe34513b8fb$var$Buffer.byteLength = $893ccbe34513b8fb$var$byteLength;
function $893ccbe34513b8fb$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $893ccbe34513b8fb$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $893ccbe34513b8fb$var$utf8Slice(this, start, end);
        case 'ascii':
            return $893ccbe34513b8fb$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $893ccbe34513b8fb$var$latin1Slice(this, start, end);
        case 'base64':
            return $893ccbe34513b8fb$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $893ccbe34513b8fb$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$893ccbe34513b8fb$var$Buffer.prototype._isBuffer = true;
function $893ccbe34513b8fb$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$893ccbe34513b8fb$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$893ccbe34513b8fb$var$swap(this, i, i + 1);
    return this;
};
$893ccbe34513b8fb$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $893ccbe34513b8fb$var$swap(this, i, i + 3);
        $893ccbe34513b8fb$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$893ccbe34513b8fb$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $893ccbe34513b8fb$var$swap(this, i, i + 7);
        $893ccbe34513b8fb$var$swap(this, i + 1, i + 6);
        $893ccbe34513b8fb$var$swap(this, i + 2, i + 5);
        $893ccbe34513b8fb$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$893ccbe34513b8fb$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $893ccbe34513b8fb$var$utf8Slice(this, 0, length);
    return $893ccbe34513b8fb$var$slowToString.apply(this, arguments);
};
$893ccbe34513b8fb$var$Buffer.prototype.toLocaleString = $893ccbe34513b8fb$var$Buffer.prototype.toString;
$893ccbe34513b8fb$var$Buffer.prototype.equals = function equals(b) {
    if (!$893ccbe34513b8fb$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $893ccbe34513b8fb$var$Buffer.compare(this, b) === 0;
};
$893ccbe34513b8fb$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $893ccbe34513b8fb$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($893ccbe34513b8fb$var$customInspectSymbol) $893ccbe34513b8fb$var$Buffer.prototype[$893ccbe34513b8fb$var$customInspectSymbol] = $893ccbe34513b8fb$var$Buffer.prototype.inspect;
$893ccbe34513b8fb$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($893ccbe34513b8fb$var$isInstance(target, Uint8Array)) target = $893ccbe34513b8fb$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$893ccbe34513b8fb$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $893ccbe34513b8fb$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($893ccbe34513b8fb$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $893ccbe34513b8fb$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($893ccbe34513b8fb$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $893ccbe34513b8fb$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $893ccbe34513b8fb$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $893ccbe34513b8fb$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$893ccbe34513b8fb$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$893ccbe34513b8fb$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $893ccbe34513b8fb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$893ccbe34513b8fb$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $893ccbe34513b8fb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $893ccbe34513b8fb$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($893ccbe34513b8fb$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $893ccbe34513b8fb$var$utf8Write(buf, string, offset, length) {
    return $893ccbe34513b8fb$var$blitBuffer($893ccbe34513b8fb$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $893ccbe34513b8fb$var$asciiWrite(buf, string, offset, length) {
    return $893ccbe34513b8fb$var$blitBuffer($893ccbe34513b8fb$var$asciiToBytes(string), buf, offset, length);
}
function $893ccbe34513b8fb$var$base64Write(buf, string, offset, length) {
    return $893ccbe34513b8fb$var$blitBuffer($893ccbe34513b8fb$var$base64ToBytes(string), buf, offset, length);
}
function $893ccbe34513b8fb$var$ucs2Write(buf, string, offset, length) {
    return $893ccbe34513b8fb$var$blitBuffer($893ccbe34513b8fb$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$893ccbe34513b8fb$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $893ccbe34513b8fb$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $893ccbe34513b8fb$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $893ccbe34513b8fb$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $893ccbe34513b8fb$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $893ccbe34513b8fb$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$893ccbe34513b8fb$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $893ccbe34513b8fb$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $893ccbe34513b8fb$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $893ccbe34513b8fb$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $893ccbe34513b8fb$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $893ccbe34513b8fb$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $893ccbe34513b8fb$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $893ccbe34513b8fb$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $893ccbe34513b8fb$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $893ccbe34513b8fb$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $893ccbe34513b8fb$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $893ccbe34513b8fb$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $893ccbe34513b8fb$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$893ccbe34513b8fb$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $893ccbe34513b8fb$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $893ccbe34513b8fb$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$893ccbe34513b8fb$var$Buffer.prototype.readUintLE = $893ccbe34513b8fb$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readUintBE = $893ccbe34513b8fb$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readUint8 = $893ccbe34513b8fb$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$893ccbe34513b8fb$var$Buffer.prototype.readUint16LE = $893ccbe34513b8fb$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$893ccbe34513b8fb$var$Buffer.prototype.readUint16BE = $893ccbe34513b8fb$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$893ccbe34513b8fb$var$Buffer.prototype.readUint32LE = $893ccbe34513b8fb$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$893ccbe34513b8fb$var$Buffer.prototype.readUint32BE = $893ccbe34513b8fb$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$893ccbe34513b8fb$var$Buffer.prototype.readBigUInt64LE = $893ccbe34513b8fb$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $893ccbe34513b8fb$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $893ccbe34513b8fb$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$893ccbe34513b8fb$var$Buffer.prototype.readBigUInt64BE = $893ccbe34513b8fb$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $893ccbe34513b8fb$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $893ccbe34513b8fb$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$893ccbe34513b8fb$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$893ccbe34513b8fb$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$893ccbe34513b8fb$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$893ccbe34513b8fb$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$893ccbe34513b8fb$var$Buffer.prototype.readBigInt64LE = $893ccbe34513b8fb$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $893ccbe34513b8fb$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $893ccbe34513b8fb$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$893ccbe34513b8fb$var$Buffer.prototype.readBigInt64BE = $893ccbe34513b8fb$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $893ccbe34513b8fb$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $893ccbe34513b8fb$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$893ccbe34513b8fb$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$893ccbe34513b8fb$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$893ccbe34513b8fb$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$893ccbe34513b8fb$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $893ccbe34513b8fb$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$893ccbe34513b8fb$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$893ccbe34513b8fb$var$Buffer.prototype.writeUintLE = $893ccbe34513b8fb$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $893ccbe34513b8fb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUintBE = $893ccbe34513b8fb$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $893ccbe34513b8fb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUint8 = $893ccbe34513b8fb$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUint16LE = $893ccbe34513b8fb$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUint16BE = $893ccbe34513b8fb$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUint32LE = $893ccbe34513b8fb$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeUint32BE = $893ccbe34513b8fb$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $893ccbe34513b8fb$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $893ccbe34513b8fb$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $893ccbe34513b8fb$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $893ccbe34513b8fb$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$893ccbe34513b8fb$var$Buffer.prototype.writeBigUInt64LE = $893ccbe34513b8fb$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $893ccbe34513b8fb$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$893ccbe34513b8fb$var$Buffer.prototype.writeBigUInt64BE = $893ccbe34513b8fb$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $893ccbe34513b8fb$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$893ccbe34513b8fb$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $893ccbe34513b8fb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $893ccbe34513b8fb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$893ccbe34513b8fb$var$Buffer.prototype.writeBigInt64LE = $893ccbe34513b8fb$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $893ccbe34513b8fb$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$893ccbe34513b8fb$var$Buffer.prototype.writeBigInt64BE = $893ccbe34513b8fb$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $893ccbe34513b8fb$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $893ccbe34513b8fb$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $893ccbe34513b8fb$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$893ccbe34513b8fb$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $893ccbe34513b8fb$var$writeFloat(this, value, offset, true, noAssert);
};
$893ccbe34513b8fb$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $893ccbe34513b8fb$var$writeFloat(this, value, offset, false, noAssert);
};
function $893ccbe34513b8fb$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $893ccbe34513b8fb$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$893ccbe34513b8fb$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $893ccbe34513b8fb$var$writeDouble(this, value, offset, true, noAssert);
};
$893ccbe34513b8fb$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $893ccbe34513b8fb$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$893ccbe34513b8fb$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$893ccbe34513b8fb$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$893ccbe34513b8fb$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$893ccbe34513b8fb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $893ccbe34513b8fb$var$Buffer.isBuffer(val) ? val : $893ccbe34513b8fb$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $893ccbe34513b8fb$var$errors = {};
function $893ccbe34513b8fb$var$E(sym, getMessage, Base) {
    $893ccbe34513b8fb$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$893ccbe34513b8fb$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$893ccbe34513b8fb$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$893ccbe34513b8fb$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $893ccbe34513b8fb$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $893ccbe34513b8fb$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $893ccbe34513b8fb$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $893ccbe34513b8fb$var$checkBounds(buf, offset, byteLength) {
    $893ccbe34513b8fb$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $893ccbe34513b8fb$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $893ccbe34513b8fb$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $893ccbe34513b8fb$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $893ccbe34513b8fb$var$checkBounds(buf, offset, byteLength);
}
function $893ccbe34513b8fb$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $893ccbe34513b8fb$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $893ccbe34513b8fb$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $893ccbe34513b8fb$var$validateNumber(value, type);
        throw new $893ccbe34513b8fb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $893ccbe34513b8fb$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $893ccbe34513b8fb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $893ccbe34513b8fb$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $893ccbe34513b8fb$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($893ccbe34513b8fb$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $893ccbe34513b8fb$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $893ccbe34513b8fb$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $893ccbe34513b8fb$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $893ccbe34513b8fb$var$base64ToBytes(str) {
    return $abUaD.toByteArray($893ccbe34513b8fb$var$base64clean(str));
}
function $893ccbe34513b8fb$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $893ccbe34513b8fb$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $893ccbe34513b8fb$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $893ccbe34513b8fb$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $893ccbe34513b8fb$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $893ccbe34513b8fb$var$BufferBigIntNotDefined : fn;
}
function $893ccbe34513b8fb$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("lBvnk", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $fba5642095fb0b04$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $fba5642095fb0b04$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("kscRZ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $bMvJO = parcelRequire("bMvJO");

var $bz0ls = parcelRequire("bz0ls");
var $ee4067dde9b1601e$var$format = $bz0ls.format, $ee4067dde9b1601e$var$inspect = $bz0ls.inspect;

var $3Fpho = parcelRequire("3Fpho");
var $ee4067dde9b1601e$var$ERR_INVALID_ARG_TYPE = $3Fpho.codes.ERR_INVALID_ARG_TYPE;

var $lBvnk = parcelRequire("lBvnk");
var $ee4067dde9b1601e$var$kResistStopPropagation = $lBvnk.kResistStopPropagation, $ee4067dde9b1601e$var$AggregateError = $lBvnk.AggregateError, $ee4067dde9b1601e$var$SymbolDispose = $lBvnk.SymbolDispose;

var $ee4067dde9b1601e$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $ee4067dde9b1601e$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $ee4067dde9b1601e$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $ee4067dde9b1601e$var$Blob = globalThis.Blob || $bMvJO.Blob;
/* eslint-disable indent */ var $ee4067dde9b1601e$var$isBlob = typeof $ee4067dde9b1601e$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ee4067dde9b1601e$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $ee4067dde9b1601e$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $ee4067dde9b1601e$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $ee4067dde9b1601e$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $ee4067dde9b1601e$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ee4067dde9b1601e$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $ee4067dde9b1601e$var$format,
    inspect: $ee4067dde9b1601e$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $ee4067dde9b1601e$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ee4067dde9b1601e$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ee4067dde9b1601e$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ee4067dde9b1601e$var$validateAbortSignal(signal, 'signal');
        $ee4067dde9b1601e$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $ee4067dde9b1601e$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $ee4067dde9b1601e$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $ee4067dde9b1601e$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $ee4067dde9b1601e$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $ee4067dde9b1601e$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("bz0ls", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("3Fpho", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $bz0ls = parcelRequire("bz0ls");
var $2ab8cf6fd526cc6c$var$format = $bz0ls.format, $2ab8cf6fd526cc6c$var$inspect = $bz0ls.inspect;

var $lBvnk = parcelRequire("lBvnk");
var $2ab8cf6fd526cc6c$var$CustomAggregateError = $lBvnk.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $2ab8cf6fd526cc6c$var$AggregateError = globalThis.AggregateError || $2ab8cf6fd526cc6c$var$CustomAggregateError;
var $2ab8cf6fd526cc6c$var$kIsNodeError = Symbol('kIsNodeError');
var $2ab8cf6fd526cc6c$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $2ab8cf6fd526cc6c$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $2ab8cf6fd526cc6c$var$nodeInternalPrefix = '__node_internal_';
var $2ab8cf6fd526cc6c$var$codes = {};
function $2ab8cf6fd526cc6c$var$assert(value, message) {
    if (!value) throw new $2ab8cf6fd526cc6c$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $2ab8cf6fd526cc6c$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $2ab8cf6fd526cc6c$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $2ab8cf6fd526cc6c$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $2ab8cf6fd526cc6c$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $2ab8cf6fd526cc6c$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $2ab8cf6fd526cc6c$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $2ab8cf6fd526cc6c$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$2ab8cf6fd526cc6c$var$kIsNodeError] = true;
    $2ab8cf6fd526cc6c$var$codes[code] = NodeError;
}
function $2ab8cf6fd526cc6c$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $2ab8cf6fd526cc6c$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $2ab8cf6fd526cc6c$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $2ab8cf6fd526cc6c$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $2ab8cf6fd526cc6c$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $2ab8cf6fd526cc6c$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$2ab8cf6fd526cc6c$var$E('ERR_ASSERTION', '%s', Error);
$2ab8cf6fd526cc6c$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $2ab8cf6fd526cc6c$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $2ab8cf6fd526cc6c$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($2ab8cf6fd526cc6c$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($2ab8cf6fd526cc6c$var$classRegExp.test(value)) instances.push(value);
            else {
                $2ab8cf6fd526cc6c$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $2ab8cf6fd526cc6c$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $2ab8cf6fd526cc6c$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$2ab8cf6fd526cc6c$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $2ab8cf6fd526cc6c$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$2ab8cf6fd526cc6c$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$2ab8cf6fd526cc6c$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $2ab8cf6fd526cc6c$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$2ab8cf6fd526cc6c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $2ab8cf6fd526cc6c$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $2ab8cf6fd526cc6c$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $2ab8cf6fd526cc6c$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $2ab8cf6fd526cc6c$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$2ab8cf6fd526cc6c$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$2ab8cf6fd526cc6c$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$2ab8cf6fd526cc6c$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$2ab8cf6fd526cc6c$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $2ab8cf6fd526cc6c$var$AbortError,
    aggregateTwoErrors: $2ab8cf6fd526cc6c$var$hideStackFrames($2ab8cf6fd526cc6c$var$aggregateTwoErrors),
    hideStackFrames: $2ab8cf6fd526cc6c$var$hideStackFrames,
    codes: $2ab8cf6fd526cc6c$var$codes
};

});


parcelRegister("8rg6E", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $624d56be1aa154c7$export$42af8c323be37587; }, function (v) { return $624d56be1aa154c7$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $624d56be1aa154c7$export$f405f72c701dad87; }, function (v) { return $624d56be1aa154c7$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $624d56be1aa154c7$export$42af8c323be37587;
var $624d56be1aa154c7$export$f405f72c701dad87;
'use strict';

var $624d56be1aa154c7$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $3Fpho = parcelRequire("3Fpho");
var $624d56be1aa154c7$var$_require_codes = $3Fpho.codes, $624d56be1aa154c7$var$ERR_INVALID_ARG_VALUE = $624d56be1aa154c7$var$_require_codes.ERR_INVALID_ARG_VALUE, $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE = $624d56be1aa154c7$var$_require_codes.ERR_INVALID_ARG_TYPE, $624d56be1aa154c7$var$ERR_MISSING_ARGS = $624d56be1aa154c7$var$_require_codes.ERR_MISSING_ARGS, $624d56be1aa154c7$var$ERR_OUT_OF_RANGE = $624d56be1aa154c7$var$_require_codes.ERR_OUT_OF_RANGE, $624d56be1aa154c7$var$AbortError = $3Fpho.AbortError;

var $3CG1b = parcelRequire("3CG1b");
var $624d56be1aa154c7$var$validateAbortSignal = $3CG1b.validateAbortSignal, $624d56be1aa154c7$var$validateInteger = $3CG1b.validateInteger, $624d56be1aa154c7$var$validateObject = $3CG1b.validateObject;

var $624d56be1aa154c7$var$kWeakHandler = (parcelRequire("lBvnk")).Symbol('kWeak');

var $624d56be1aa154c7$var$kResistStopPropagation = (parcelRequire("lBvnk")).Symbol('kResistStopPropagation');

var $1Jum0 = parcelRequire("1Jum0");
var $624d56be1aa154c7$require$finished = $1Jum0.finished;

var $6ooOy = parcelRequire("6ooOy");

var $loAsg = parcelRequire("loAsg");
var $624d56be1aa154c7$require$addAbortSignalNoValidate = $loAsg.addAbortSignalNoValidate;

var $khkpJ = parcelRequire("khkpJ");
var $624d56be1aa154c7$var$isWritable = $khkpJ.isWritable, $624d56be1aa154c7$var$isNodeStream = $khkpJ.isNodeStream;

var $624d56be1aa154c7$require$deprecate = (parcelRequire("kscRZ")).deprecate;

var $624d56be1aa154c7$var$ArrayPrototypePush = (parcelRequire("lBvnk")).ArrayPrototypePush, $624d56be1aa154c7$var$Boolean = (parcelRequire("lBvnk")).Boolean, $624d56be1aa154c7$var$MathFloor = (parcelRequire("lBvnk")).MathFloor, $624d56be1aa154c7$var$Number = (parcelRequire("lBvnk")).Number, $624d56be1aa154c7$var$NumberIsNaN = (parcelRequire("lBvnk")).NumberIsNaN, $624d56be1aa154c7$var$Promise = (parcelRequire("lBvnk")).Promise, $624d56be1aa154c7$var$PromiseReject = (parcelRequire("lBvnk")).PromiseReject, $624d56be1aa154c7$var$PromiseResolve = (parcelRequire("lBvnk")).PromiseResolve, $624d56be1aa154c7$var$PromisePrototypeThen = (parcelRequire("lBvnk")).PromisePrototypeThen, $624d56be1aa154c7$var$Symbol = (parcelRequire("lBvnk")).Symbol;
var $624d56be1aa154c7$var$kEmpty = $624d56be1aa154c7$var$Symbol('kEmpty');
var $624d56be1aa154c7$var$kEof = $624d56be1aa154c7$var$Symbol('kEof');
function $624d56be1aa154c7$var$compose(stream, options) {
    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
    if ($624d56be1aa154c7$var$isNodeStream(stream) && !$624d56be1aa154c7$var$isWritable(stream)) throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $6ooOy(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $624d56be1aa154c7$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $624d56be1aa154c7$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $624d56be1aa154c7$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $624d56be1aa154c7$var$MathFloor(options.highWaterMark);
    $624d56be1aa154c7$var$validateInteger(concurrency, 'options.concurrency', 1);
    $624d56be1aa154c7$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $624d56be1aa154c7$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $624d56be1aa154c7$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $624d56be1aa154c7$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $624d56be1aa154c7$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $624d56be1aa154c7$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $624d56be1aa154c7$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($624d56be1aa154c7$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $624d56be1aa154c7$var$PromiseReject(err1);
                                $624d56be1aa154c7$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("kscRZ")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($624d56be1aa154c7$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $624d56be1aa154c7$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $624d56be1aa154c7$var$AbortError();
                        if (!(val !== $624d56be1aa154c7$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $624d56be1aa154c7$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $624d56be1aa154c7$var$asIndexedPairs(options) {
    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $624d56be1aa154c7$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $624d56be1aa154c7$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($624d56be1aa154c7$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $624d56be1aa154c7$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $624d56be1aa154c7$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $624d56be1aa154c7$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($624d56be1aa154c7$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $624d56be1aa154c7$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $624d56be1aa154c7$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($624d56be1aa154c7$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $624d56be1aa154c7$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $624d56be1aa154c7$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $624d56be1aa154c7$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $624d56be1aa154c7$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($624d56be1aa154c7$var$ERR_MISSING_ARGS);
function $624d56be1aa154c7$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $624d56be1aa154c7$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $624d56be1aa154c7$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $624d56be1aa154c7$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $624d56be1aa154c7$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $624d56be1aa154c7$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $624d56be1aa154c7$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $624d56be1aa154c7$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $624d56be1aa154c7$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $624d56be1aa154c7$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $624d56be1aa154c7$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $624d56be1aa154c7$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $624d56be1aa154c7$var$flatMap(fn, options) {
    var values = $624d56be1aa154c7$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $624d56be1aa154c7$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $624d56be1aa154c7$var$Number(number);
    if ($624d56be1aa154c7$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $624d56be1aa154c7$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $624d56be1aa154c7$var$drop(number, options) {
    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
    number = $624d56be1aa154c7$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $624d56be1aa154c7$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $624d56be1aa154c7$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $624d56be1aa154c7$var$take(number, options) {
    if (options != null) $624d56be1aa154c7$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $624d56be1aa154c7$var$validateAbortSignal(options.signal, 'options.signal');
    number = $624d56be1aa154c7$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $624d56be1aa154c7$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $624d56be1aa154c7$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$624d56be1aa154c7$export$42af8c323be37587 = {
    asIndexedPairs: $624d56be1aa154c7$require$deprecate($624d56be1aa154c7$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $624d56be1aa154c7$var$drop,
    filter: $624d56be1aa154c7$var$filter,
    flatMap: $624d56be1aa154c7$var$flatMap,
    map: $624d56be1aa154c7$var$map,
    take: $624d56be1aa154c7$var$take,
    compose: $624d56be1aa154c7$var$compose
};
$624d56be1aa154c7$export$f405f72c701dad87 = {
    every: $624d56be1aa154c7$var$every,
    forEach: $624d56be1aa154c7$var$forEach,
    reduce: $624d56be1aa154c7$var$reduce,
    toArray: $624d56be1aa154c7$var$toArray,
    some: $624d56be1aa154c7$var$some,
    find: $624d56be1aa154c7$var$find
};

});
parcelRegister("3CG1b", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $2a3583a647ed4191$var$ArrayIsArray = $lBvnk.ArrayIsArray, $2a3583a647ed4191$var$ArrayPrototypeIncludes = $lBvnk.ArrayPrototypeIncludes, $2a3583a647ed4191$var$ArrayPrototypeJoin = $lBvnk.ArrayPrototypeJoin, $2a3583a647ed4191$var$ArrayPrototypeMap = $lBvnk.ArrayPrototypeMap, $2a3583a647ed4191$var$NumberIsInteger = $lBvnk.NumberIsInteger, $2a3583a647ed4191$var$NumberIsNaN = $lBvnk.NumberIsNaN, $2a3583a647ed4191$var$NumberMAX_SAFE_INTEGER = $lBvnk.NumberMAX_SAFE_INTEGER, $2a3583a647ed4191$var$NumberMIN_SAFE_INTEGER = $lBvnk.NumberMIN_SAFE_INTEGER, $2a3583a647ed4191$var$NumberParseInt = $lBvnk.NumberParseInt, $2a3583a647ed4191$var$ObjectPrototypeHasOwnProperty = $lBvnk.ObjectPrototypeHasOwnProperty, $2a3583a647ed4191$var$RegExpPrototypeExec = $lBvnk.RegExpPrototypeExec, $2a3583a647ed4191$var$String = $lBvnk.String, $2a3583a647ed4191$var$StringPrototypeToUpperCase = $lBvnk.StringPrototypeToUpperCase, $2a3583a647ed4191$var$StringPrototypeTrim = $lBvnk.StringPrototypeTrim;

var $3Fpho = parcelRequire("3Fpho");
var $2a3583a647ed4191$var$hideStackFrames = $3Fpho.hideStackFrames, $2a3583a647ed4191$var$_require_codes = $3Fpho.codes, $2a3583a647ed4191$var$ERR_SOCKET_BAD_PORT = $2a3583a647ed4191$var$_require_codes.ERR_SOCKET_BAD_PORT, $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE = $2a3583a647ed4191$var$_require_codes.ERR_INVALID_ARG_TYPE, $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE = $2a3583a647ed4191$var$_require_codes.ERR_INVALID_ARG_VALUE, $2a3583a647ed4191$var$ERR_OUT_OF_RANGE = $2a3583a647ed4191$var$_require_codes.ERR_OUT_OF_RANGE, $2a3583a647ed4191$var$ERR_UNKNOWN_SIGNAL = $2a3583a647ed4191$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $kscRZ = parcelRequire("kscRZ");
var $2a3583a647ed4191$require$normalizeEncoding = $kscRZ.normalizeEncoding;

var $kscRZ = parcelRequire("kscRZ");
var $2a3583a647ed4191$require$_require_types = $kscRZ.types;
var $2a3583a647ed4191$var$isAsyncFunction = $2a3583a647ed4191$require$_require_types.isAsyncFunction, $2a3583a647ed4191$var$isArrayBufferView = $2a3583a647ed4191$require$_require_types.isArrayBufferView;
var $2a3583a647ed4191$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2a3583a647ed4191$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $2a3583a647ed4191$var$isUint32(value) {
    return value === value >>> 0;
}
var $2a3583a647ed4191$var$octalReg = /^[0-7]+$/;
var $2a3583a647ed4191$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $2a3583a647ed4191$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($2a3583a647ed4191$var$RegExpPrototypeExec($2a3583a647ed4191$var$octalReg, value) === null) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE(name, value, $2a3583a647ed4191$var$modeDesc);
        value = $2a3583a647ed4191$var$NumberParseInt(value, 8);
    }
    $2a3583a647ed4191$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $2a3583a647ed4191$var$validateInteger = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2a3583a647ed4191$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $2a3583a647ed4191$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2a3583a647ed4191$var$NumberIsInteger(value)) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $2a3583a647ed4191$var$validateInt32 = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2a3583a647ed4191$var$NumberIsInteger(value)) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $2a3583a647ed4191$var$validateUint32 = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$2a3583a647ed4191$var$NumberIsInteger(value)) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $2a3583a647ed4191$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $2a3583a647ed4191$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $2a3583a647ed4191$var$NumberIsNaN(value)) throw new $2a3583a647ed4191$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $2a3583a647ed4191$var$validateOneOf = $2a3583a647ed4191$var$hideStackFrames(function(value, name, oneOf) {
    if (!$2a3583a647ed4191$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $2a3583a647ed4191$var$ArrayPrototypeJoin($2a3583a647ed4191$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $2a3583a647ed4191$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $2a3583a647ed4191$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $2a3583a647ed4191$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$2a3583a647ed4191$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $2a3583a647ed4191$var$validateObject = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $2a3583a647ed4191$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $2a3583a647ed4191$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $2a3583a647ed4191$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $2a3583a647ed4191$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $2a3583a647ed4191$var$validateDictionary = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $2a3583a647ed4191$var$validateArray = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$2a3583a647ed4191$var$ArrayIsArray(value)) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $2a3583a647ed4191$var$validateStringArray(value, name) {
    $2a3583a647ed4191$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2a3583a647ed4191$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $2a3583a647ed4191$var$validateBooleanArray(value, name) {
    $2a3583a647ed4191$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$2a3583a647ed4191$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $2a3583a647ed4191$var$validateAbortSignalArray(value, name) {
    $2a3583a647ed4191$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $2a3583a647ed4191$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $2a3583a647ed4191$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $2a3583a647ed4191$var$validateString(signal, name);
    if ($2a3583a647ed4191$var$signals[signal] === undefined) {
        if ($2a3583a647ed4191$var$signals[$2a3583a647ed4191$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $2a3583a647ed4191$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $2a3583a647ed4191$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $2a3583a647ed4191$var$validateBuffer = $2a3583a647ed4191$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$2a3583a647ed4191$var$isArrayBufferView(buffer)) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $2a3583a647ed4191$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $2a3583a647ed4191$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $2a3583a647ed4191$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $2a3583a647ed4191$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $2a3583a647ed4191$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $2a3583a647ed4191$var$validateAbortSignal = $2a3583a647ed4191$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $2a3583a647ed4191$var$validateFunction = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $2a3583a647ed4191$var$validatePlainFunction = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $2a3583a647ed4191$var$isAsyncFunction(value)) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $2a3583a647ed4191$var$validateUndefined = $2a3583a647ed4191$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $2a3583a647ed4191$var$validateUnion(value, name, union) {
    if (!$2a3583a647ed4191$var$ArrayPrototypeIncludes(union, value)) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_TYPE(name, "('".concat($2a3583a647ed4191$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $2a3583a647ed4191$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $2a3583a647ed4191$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$2a3583a647ed4191$var$RegExpPrototypeExec($2a3583a647ed4191$var$linkValueRegExp, value)) throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $2a3583a647ed4191$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $2a3583a647ed4191$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($2a3583a647ed4191$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $2a3583a647ed4191$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $2a3583a647ed4191$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $2a3583a647ed4191$var$isInt32,
    isUint32: $2a3583a647ed4191$var$isUint32,
    parseFileMode: $2a3583a647ed4191$var$parseFileMode,
    validateArray: $2a3583a647ed4191$var$validateArray,
    validateStringArray: $2a3583a647ed4191$var$validateStringArray,
    validateBooleanArray: $2a3583a647ed4191$var$validateBooleanArray,
    validateAbortSignalArray: $2a3583a647ed4191$var$validateAbortSignalArray,
    validateBoolean: $2a3583a647ed4191$var$validateBoolean,
    validateBuffer: $2a3583a647ed4191$var$validateBuffer,
    validateDictionary: $2a3583a647ed4191$var$validateDictionary,
    validateEncoding: $2a3583a647ed4191$var$validateEncoding,
    validateFunction: $2a3583a647ed4191$var$validateFunction,
    validateInt32: $2a3583a647ed4191$var$validateInt32,
    validateInteger: $2a3583a647ed4191$var$validateInteger,
    validateNumber: $2a3583a647ed4191$var$validateNumber,
    validateObject: $2a3583a647ed4191$var$validateObject,
    validateOneOf: $2a3583a647ed4191$var$validateOneOf,
    validatePlainFunction: $2a3583a647ed4191$var$validatePlainFunction,
    validatePort: $2a3583a647ed4191$var$validatePort,
    validateSignalName: $2a3583a647ed4191$var$validateSignalName,
    validateString: $2a3583a647ed4191$var$validateString,
    validateUint32: $2a3583a647ed4191$var$validateUint32,
    validateUndefined: $2a3583a647ed4191$var$validateUndefined,
    validateUnion: $2a3583a647ed4191$var$validateUnion,
    validateAbortSignal: $2a3583a647ed4191$var$validateAbortSignal,
    validateLinkHeaderValue: $2a3583a647ed4191$var$validateLinkHeaderValue
};

});

parcelRegister("1Jum0", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3Fpho = parcelRequire("3Fpho");
/* replacement end */ var $14318a15f5f91f22$var$AbortError = $3Fpho.AbortError, $14318a15f5f91f22$var$codes = $3Fpho.codes;
var $14318a15f5f91f22$var$ERR_INVALID_ARG_TYPE = $14318a15f5f91f22$var$codes.ERR_INVALID_ARG_TYPE, $14318a15f5f91f22$var$ERR_STREAM_PREMATURE_CLOSE = $14318a15f5f91f22$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $14318a15f5f91f22$var$kEmptyObject = (parcelRequire("kscRZ")).kEmptyObject, $14318a15f5f91f22$var$once = (parcelRequire("kscRZ")).once;

var $3CG1b = parcelRequire("3CG1b");
var $14318a15f5f91f22$var$validateAbortSignal = $3CG1b.validateAbortSignal, $14318a15f5f91f22$var$validateFunction = $3CG1b.validateFunction, $14318a15f5f91f22$var$validateObject = $3CG1b.validateObject, $14318a15f5f91f22$var$validateBoolean = $3CG1b.validateBoolean;

var $lBvnk = parcelRequire("lBvnk");
var $14318a15f5f91f22$var$Promise = $lBvnk.Promise, $14318a15f5f91f22$var$PromisePrototypeThen = $lBvnk.PromisePrototypeThen, $14318a15f5f91f22$var$SymbolDispose = $lBvnk.SymbolDispose;

var $khkpJ = parcelRequire("khkpJ");
var $14318a15f5f91f22$var$isClosed = $khkpJ.isClosed, $14318a15f5f91f22$var$isReadable = $khkpJ.isReadable, $14318a15f5f91f22$var$isReadableNodeStream = $khkpJ.isReadableNodeStream, $14318a15f5f91f22$var$isReadableStream = $khkpJ.isReadableStream, $14318a15f5f91f22$var$isReadableFinished = $khkpJ.isReadableFinished, $14318a15f5f91f22$var$isReadableErrored = $khkpJ.isReadableErrored, $14318a15f5f91f22$var$isWritable = $khkpJ.isWritable, $14318a15f5f91f22$var$isWritableNodeStream = $khkpJ.isWritableNodeStream, $14318a15f5f91f22$var$isWritableStream = $khkpJ.isWritableStream, $14318a15f5f91f22$var$isWritableFinished = $khkpJ.isWritableFinished, $14318a15f5f91f22$var$isWritableErrored = $khkpJ.isWritableErrored, $14318a15f5f91f22$var$isNodeStream = $khkpJ.isNodeStream, $14318a15f5f91f22$var$_willEmitClose = $khkpJ.willEmitClose, $14318a15f5f91f22$var$kIsClosedPromise = $khkpJ.kIsClosedPromise;
var $14318a15f5f91f22$var$addAbortListener;
function $14318a15f5f91f22$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $14318a15f5f91f22$var$nop = function() {};

function $14318a15f5f91f22$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $14318a15f5f91f22$var$kEmptyObject;
    } else if (options == null) options = $14318a15f5f91f22$var$kEmptyObject;
    else $14318a15f5f91f22$var$validateObject(options, 'options');
    $14318a15f5f91f22$var$validateFunction(callback, 'callback');
    $14318a15f5f91f22$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $14318a15f5f91f22$var$once(callback);
    if ($14318a15f5f91f22$var$isReadableStream(stream) || $14318a15f5f91f22$var$isWritableStream(stream)) return $14318a15f5f91f22$var$eosWeb(stream, options, callback);
    if (!$14318a15f5f91f22$var$isNodeStream(stream)) throw new $14318a15f5f91f22$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $14318a15f5f91f22$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $14318a15f5f91f22$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $14318a15f5f91f22$var$_willEmitClose(stream) && $14318a15f5f91f22$var$isReadableNodeStream(stream) === readable && $14318a15f5f91f22$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $14318a15f5f91f22$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $14318a15f5f91f22$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $14318a15f5f91f22$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $14318a15f5f91f22$var$isWritableErrored(stream) || $14318a15f5f91f22$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $14318a15f5f91f22$var$isReadableNodeStream(stream, true)) {
            if (!$14318a15f5f91f22$var$isReadableFinished(stream, false)) return callback.call(stream, new $14318a15f5f91f22$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$14318a15f5f91f22$var$isWritableFinished(stream, false)) return callback.call(stream, new $14318a15f5f91f22$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $14318a15f5f91f22$var$isWritableErrored(stream) || $14318a15f5f91f22$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($14318a15f5f91f22$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $14318a15f5f91f22$var$isReadable(stream)) && (writableFinished || $14318a15f5f91f22$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $14318a15f5f91f22$var$isWritable(stream)) && (readableFinished || $14318a15f5f91f22$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $14318a15f5f91f22$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $14318a15f5f91f22$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $14318a15f5f91f22$var$addAbortListener = $14318a15f5f91f22$var$addAbortListener || (parcelRequire("kscRZ")).addAbortListener;
            var disposable = $14318a15f5f91f22$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $14318a15f5f91f22$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$14318a15f5f91f22$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $14318a15f5f91f22$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $14318a15f5f91f22$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $14318a15f5f91f22$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $14318a15f5f91f22$var$addAbortListener = $14318a15f5f91f22$var$addAbortListener || (parcelRequire("kscRZ")).addAbortListener;
            var disposable = $14318a15f5f91f22$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $14318a15f5f91f22$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$14318a15f5f91f22$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $14318a15f5f91f22$var$PromisePrototypeThen(stream[$14318a15f5f91f22$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $14318a15f5f91f22$var$nop;
}
function $14318a15f5f91f22$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $14318a15f5f91f22$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $14318a15f5f91f22$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $14318a15f5f91f22$var$Promise(function(resolve, reject) {
        var cleanup = $14318a15f5f91f22$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $14318a15f5f91f22$var$eos;
module.exports.finished = $14318a15f5f91f22$var$finished;

});
parcelRegister("khkpJ", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $ec353afb3d7fd10d$var$SymbolAsyncIterator = $lBvnk.SymbolAsyncIterator, $ec353afb3d7fd10d$var$SymbolIterator = $lBvnk.SymbolIterator, $ec353afb3d7fd10d$var$SymbolFor = $lBvnk.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $ec353afb3d7fd10d$var$kIsDestroyed = $ec353afb3d7fd10d$var$SymbolFor('nodejs.stream.destroyed');
var $ec353afb3d7fd10d$var$kIsErrored = $ec353afb3d7fd10d$var$SymbolFor('nodejs.stream.errored');
var $ec353afb3d7fd10d$var$kIsReadable = $ec353afb3d7fd10d$var$SymbolFor('nodejs.stream.readable');
var $ec353afb3d7fd10d$var$kIsWritable = $ec353afb3d7fd10d$var$SymbolFor('nodejs.stream.writable');
var $ec353afb3d7fd10d$var$kIsDisturbed = $ec353afb3d7fd10d$var$SymbolFor('nodejs.stream.disturbed');
var $ec353afb3d7fd10d$var$kIsClosedPromise = $ec353afb3d7fd10d$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $ec353afb3d7fd10d$var$kControllerErrorFunction = $ec353afb3d7fd10d$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $ec353afb3d7fd10d$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $ec353afb3d7fd10d$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $ec353afb3d7fd10d$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $ec353afb3d7fd10d$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $ec353afb3d7fd10d$var$isReadableStream(obj) {
    return !!(obj && !$ec353afb3d7fd10d$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $ec353afb3d7fd10d$var$isWritableStream(obj) {
    return !!(obj && !$ec353afb3d7fd10d$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $ec353afb3d7fd10d$var$isTransformStream(obj) {
    return !!(obj && !$ec353afb3d7fd10d$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $ec353afb3d7fd10d$var$isWebStream(obj) {
    return $ec353afb3d7fd10d$var$isReadableStream(obj) || $ec353afb3d7fd10d$var$isWritableStream(obj) || $ec353afb3d7fd10d$var$isTransformStream(obj);
}
function $ec353afb3d7fd10d$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$ec353afb3d7fd10d$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$ec353afb3d7fd10d$var$SymbolIterator] === 'function';
    return typeof obj[$ec353afb3d7fd10d$var$SymbolAsyncIterator] === 'function' || typeof obj[$ec353afb3d7fd10d$var$SymbolIterator] === 'function';
}
function $ec353afb3d7fd10d$var$isDestroyed(stream) {
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$ec353afb3d7fd10d$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $ec353afb3d7fd10d$var$isWritableEnded(stream) {
    if (!$ec353afb3d7fd10d$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $ec353afb3d7fd10d$var$isWritableFinished(stream, strict) {
    if (!$ec353afb3d7fd10d$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $ec353afb3d7fd10d$var$isReadableEnded(stream) {
    if (!$ec353afb3d7fd10d$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $ec353afb3d7fd10d$var$isReadableFinished(stream, strict) {
    if (!$ec353afb3d7fd10d$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $ec353afb3d7fd10d$var$isReadable(stream) {
    if (stream && stream[$ec353afb3d7fd10d$var$kIsReadable] != null) return stream[$ec353afb3d7fd10d$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($ec353afb3d7fd10d$var$isDestroyed(stream)) return false;
    return $ec353afb3d7fd10d$var$isReadableNodeStream(stream) && stream.readable && !$ec353afb3d7fd10d$var$isReadableFinished(stream);
}
function $ec353afb3d7fd10d$var$isWritable(stream) {
    if (stream && stream[$ec353afb3d7fd10d$var$kIsWritable] != null) return stream[$ec353afb3d7fd10d$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($ec353afb3d7fd10d$var$isDestroyed(stream)) return false;
    return $ec353afb3d7fd10d$var$isWritableNodeStream(stream) && stream.writable && !$ec353afb3d7fd10d$var$isWritableEnded(stream);
}
function $ec353afb3d7fd10d$var$isFinished(stream, opts) {
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    if ($ec353afb3d7fd10d$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $ec353afb3d7fd10d$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $ec353afb3d7fd10d$var$isWritable(stream)) return false;
    return true;
}
function $ec353afb3d7fd10d$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $ec353afb3d7fd10d$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $ec353afb3d7fd10d$var$isClosed(stream) {
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $ec353afb3d7fd10d$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $ec353afb3d7fd10d$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $ec353afb3d7fd10d$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $ec353afb3d7fd10d$var$isOutgoingMessage(stream);
}
function $ec353afb3d7fd10d$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $ec353afb3d7fd10d$var$willEmitClose(stream) {
    if (!$ec353afb3d7fd10d$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $ec353afb3d7fd10d$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $ec353afb3d7fd10d$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$ec353afb3d7fd10d$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $ec353afb3d7fd10d$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$ec353afb3d7fd10d$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $ec353afb3d7fd10d$var$isDestroyed,
    kIsDestroyed: $ec353afb3d7fd10d$var$kIsDestroyed,
    isDisturbed: $ec353afb3d7fd10d$var$isDisturbed,
    kIsDisturbed: $ec353afb3d7fd10d$var$kIsDisturbed,
    isErrored: $ec353afb3d7fd10d$var$isErrored,
    kIsErrored: $ec353afb3d7fd10d$var$kIsErrored,
    isReadable: $ec353afb3d7fd10d$var$isReadable,
    kIsReadable: $ec353afb3d7fd10d$var$kIsReadable,
    kIsClosedPromise: $ec353afb3d7fd10d$var$kIsClosedPromise,
    kControllerErrorFunction: $ec353afb3d7fd10d$var$kControllerErrorFunction,
    kIsWritable: $ec353afb3d7fd10d$var$kIsWritable,
    isClosed: $ec353afb3d7fd10d$var$isClosed,
    isDuplexNodeStream: $ec353afb3d7fd10d$var$isDuplexNodeStream,
    isFinished: $ec353afb3d7fd10d$var$isFinished,
    isIterable: $ec353afb3d7fd10d$var$isIterable,
    isReadableNodeStream: $ec353afb3d7fd10d$var$isReadableNodeStream,
    isReadableStream: $ec353afb3d7fd10d$var$isReadableStream,
    isReadableEnded: $ec353afb3d7fd10d$var$isReadableEnded,
    isReadableFinished: $ec353afb3d7fd10d$var$isReadableFinished,
    isReadableErrored: $ec353afb3d7fd10d$var$isReadableErrored,
    isNodeStream: $ec353afb3d7fd10d$var$isNodeStream,
    isWebStream: $ec353afb3d7fd10d$var$isWebStream,
    isWritable: $ec353afb3d7fd10d$var$isWritable,
    isWritableNodeStream: $ec353afb3d7fd10d$var$isWritableNodeStream,
    isWritableStream: $ec353afb3d7fd10d$var$isWritableStream,
    isWritableEnded: $ec353afb3d7fd10d$var$isWritableEnded,
    isWritableFinished: $ec353afb3d7fd10d$var$isWritableFinished,
    isWritableErrored: $ec353afb3d7fd10d$var$isWritableErrored,
    isServerRequest: $ec353afb3d7fd10d$var$isServerRequest,
    isServerResponse: $ec353afb3d7fd10d$var$isServerResponse,
    willEmitClose: $ec353afb3d7fd10d$var$willEmitClose,
    isTransformStream: $ec353afb3d7fd10d$var$isTransformStream
};

});


parcelRegister("6ooOy", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hC1T5 = parcelRequire("hC1T5");
var $4a783b96386b3d35$require$pipeline = $hC1T5.pipeline;

var $026ih = parcelRequire("026ih");

var $axhPV = parcelRequire("axhPV");
var $4a783b96386b3d35$require$destroyer = $axhPV.destroyer;

var $khkpJ = parcelRequire("khkpJ");
var $4a783b96386b3d35$var$isNodeStream = $khkpJ.isNodeStream, $4a783b96386b3d35$var$isReadable = $khkpJ.isReadable, $4a783b96386b3d35$var$isWritable = $khkpJ.isWritable, $4a783b96386b3d35$var$isWebStream = $khkpJ.isWebStream, $4a783b96386b3d35$var$isTransformStream = $khkpJ.isTransformStream, $4a783b96386b3d35$var$isWritableStream = $khkpJ.isWritableStream, $4a783b96386b3d35$var$isReadableStream = $khkpJ.isReadableStream;

var $3Fpho = parcelRequire("3Fpho");
var $4a783b96386b3d35$var$AbortError = $3Fpho.AbortError, $4a783b96386b3d35$var$_require_codes = $3Fpho.codes, $4a783b96386b3d35$var$ERR_INVALID_ARG_VALUE = $4a783b96386b3d35$var$_require_codes.ERR_INVALID_ARG_VALUE, $4a783b96386b3d35$var$ERR_MISSING_ARGS = $4a783b96386b3d35$var$_require_codes.ERR_MISSING_ARGS;

var $1Jum0 = parcelRequire("1Jum0");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $4a783b96386b3d35$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $026ih.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $026ih.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $026ih.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$4a783b96386b3d35$var$isNodeStream(streams[n]) && !$4a783b96386b3d35$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($4a783b96386b3d35$var$isReadable(streams[n]) || $4a783b96386b3d35$var$isReadableStream(streams[n]) || $4a783b96386b3d35$var$isTransformStream(streams[n]))) throw new $4a783b96386b3d35$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($4a783b96386b3d35$var$isWritable(streams[n]) || $4a783b96386b3d35$var$isWritableStream(streams[n]) || $4a783b96386b3d35$var$isTransformStream(streams[n]))) throw new $4a783b96386b3d35$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $4a783b96386b3d35$require$pipeline(streams, onfinished);
    var writable = !!($4a783b96386b3d35$var$isWritable(head) || $4a783b96386b3d35$var$isWritableStream(head) || $4a783b96386b3d35$var$isTransformStream(head));
    var readable = !!($4a783b96386b3d35$var$isReadable(tail) || $4a783b96386b3d35$var$isReadableStream(tail) || $4a783b96386b3d35$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $026ih({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($4a783b96386b3d35$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($4a783b96386b3d35$var$isWebStream(head)) {
            var writable1 = $4a783b96386b3d35$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $4a783b96386b3d35$var$isTransformStream(tail) ? tail.readable : tail;
        $1Jum0(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($4a783b96386b3d35$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($4a783b96386b3d35$var$isWebStream(tail)) {
            var readable1 = $4a783b96386b3d35$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $4a783b96386b3d35$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($4a783b96386b3d35$var$isNodeStream(tail)) $4a783b96386b3d35$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("hC1T5", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $cd27731a6f3b6127$var$ArrayIsArray = $lBvnk.ArrayIsArray, $cd27731a6f3b6127$var$Promise = $lBvnk.Promise, $cd27731a6f3b6127$var$SymbolAsyncIterator = $lBvnk.SymbolAsyncIterator, $cd27731a6f3b6127$var$SymbolDispose = $lBvnk.SymbolDispose;

var $1Jum0 = parcelRequire("1Jum0");

var $cd27731a6f3b6127$require$once = (parcelRequire("kscRZ")).once;

var $axhPV = parcelRequire("axhPV");

var $026ih = parcelRequire("026ih");

var $3Fpho = parcelRequire("3Fpho");
var $cd27731a6f3b6127$var$aggregateTwoErrors = $3Fpho.aggregateTwoErrors, $cd27731a6f3b6127$var$_require_codes = $3Fpho.codes, $cd27731a6f3b6127$var$ERR_INVALID_ARG_TYPE = $cd27731a6f3b6127$var$_require_codes.ERR_INVALID_ARG_TYPE, $cd27731a6f3b6127$var$ERR_INVALID_RETURN_VALUE = $cd27731a6f3b6127$var$_require_codes.ERR_INVALID_RETURN_VALUE, $cd27731a6f3b6127$var$ERR_MISSING_ARGS = $cd27731a6f3b6127$var$_require_codes.ERR_MISSING_ARGS, $cd27731a6f3b6127$var$ERR_STREAM_DESTROYED = $cd27731a6f3b6127$var$_require_codes.ERR_STREAM_DESTROYED, $cd27731a6f3b6127$var$ERR_STREAM_PREMATURE_CLOSE = $cd27731a6f3b6127$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $cd27731a6f3b6127$var$AbortError = $3Fpho.AbortError;

var $3CG1b = parcelRequire("3CG1b");
var $cd27731a6f3b6127$var$validateFunction = $3CG1b.validateFunction, $cd27731a6f3b6127$var$validateAbortSignal = $3CG1b.validateAbortSignal;

var $khkpJ = parcelRequire("khkpJ");
var $cd27731a6f3b6127$var$isIterable = $khkpJ.isIterable, $cd27731a6f3b6127$var$isReadable = $khkpJ.isReadable, $cd27731a6f3b6127$var$isReadableNodeStream = $khkpJ.isReadableNodeStream, $cd27731a6f3b6127$var$isNodeStream = $khkpJ.isNodeStream, $cd27731a6f3b6127$var$isTransformStream = $khkpJ.isTransformStream, $cd27731a6f3b6127$var$isWebStream = $khkpJ.isWebStream, $cd27731a6f3b6127$var$isReadableStream = $khkpJ.isReadableStream, $cd27731a6f3b6127$var$isReadableFinished = $khkpJ.isReadableFinished;

var $cd27731a6f3b6127$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $cd27731a6f3b6127$var$PassThrough;
var $cd27731a6f3b6127$var$Readable;
var $cd27731a6f3b6127$var$addAbortListener;
function $cd27731a6f3b6127$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $1Jum0(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $axhPV.destroyer(stream, err || new $cd27731a6f3b6127$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $cd27731a6f3b6127$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $cd27731a6f3b6127$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $cd27731a6f3b6127$var$makeAsyncIterable(val) {
    if ($cd27731a6f3b6127$var$isIterable(val)) return val;
    else if ($cd27731a6f3b6127$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $cd27731a6f3b6127$var$fromReadable(val);
    throw new $cd27731a6f3b6127$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $cd27731a6f3b6127$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$cd27731a6f3b6127$var$Readable) $cd27731a6f3b6127$var$Readable = (parcelRequire("jj8ac"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($cd27731a6f3b6127$var$Readable.prototype[$cd27731a6f3b6127$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $cd27731a6f3b6127$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $cd27731a6f3b6127$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $1Jum0(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $cd27731a6f3b6127$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $cd27731a6f3b6127$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($cd27731a6f3b6127$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $cd27731a6f3b6127$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $cd27731a6f3b6127$var$pipelineImpl(streams, $cd27731a6f3b6127$require$once($cd27731a6f3b6127$var$popCallback(streams)));
}


function $cd27731a6f3b6127$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($cd27731a6f3b6127$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $cd27731a6f3b6127$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($cd27731a6f3b6127$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($cd27731a6f3b6127$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$cd27731a6f3b6127$var$isIterable(ret)) throw new $cd27731a6f3b6127$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($cd27731a6f3b6127$var$isIterable(stream) || $cd27731a6f3b6127$var$isReadableNodeStream(stream) || $cd27731a6f3b6127$var$isTransformStream(stream)) ret = stream;
            else ret = $026ih.from(stream);
        } else if (typeof stream === 'function') {
            if ($cd27731a6f3b6127$var$isTransformStream(ret)) {
                var _ret;
                ret = $cd27731a6f3b6127$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $cd27731a6f3b6127$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$cd27731a6f3b6127$var$isIterable(ret, true)) throw new $cd27731a6f3b6127$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$cd27731a6f3b6127$var$PassThrough) $cd27731a6f3b6127$var$PassThrough = (parcelRequire("2Pt9T"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $cd27731a6f3b6127$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($cd27731a6f3b6127$var$isIterable(ret, true)) {
                    finishCount++;
                    $cd27731a6f3b6127$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($cd27731a6f3b6127$var$isReadableStream(ret) || $cd27731a6f3b6127$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $cd27731a6f3b6127$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $cd27731a6f3b6127$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $cd27731a6f3b6127$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($cd27731a6f3b6127$var$isNodeStream(stream)) {
            if ($cd27731a6f3b6127$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $cd27731a6f3b6127$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($cd27731a6f3b6127$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($cd27731a6f3b6127$var$isTransformStream(ret) || $cd27731a6f3b6127$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $cd27731a6f3b6127$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($cd27731a6f3b6127$var$isIterable(ret)) {
                finishCount++;
                $cd27731a6f3b6127$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $cd27731a6f3b6127$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($cd27731a6f3b6127$var$isWebStream(stream)) {
            if ($cd27731a6f3b6127$var$isReadableNodeStream(ret)) {
                finishCount++;
                $cd27731a6f3b6127$var$pumpToWeb($cd27731a6f3b6127$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($cd27731a6f3b6127$var$isReadableStream(ret) || $cd27731a6f3b6127$var$isIterable(ret)) {
                finishCount++;
                $cd27731a6f3b6127$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($cd27731a6f3b6127$var$isTransformStream(ret)) {
                finishCount++;
                $cd27731a6f3b6127$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $cd27731a6f3b6127$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $026ih.from(stream);
    };
    if (streams.length === 1 && $cd27731a6f3b6127$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $cd27731a6f3b6127$var$ERR_MISSING_ARGS('streams');
    var ac = new $cd27731a6f3b6127$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $cd27731a6f3b6127$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $cd27731a6f3b6127$var$AbortError());
    }
    $cd27731a6f3b6127$var$addAbortListener = $cd27731a6f3b6127$var$addAbortListener || (parcelRequire("kscRZ")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $cd27731a6f3b6127$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$cd27731a6f3b6127$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $cd27731a6f3b6127$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $cd27731a6f3b6127$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($cd27731a6f3b6127$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $1Jum0(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $1Jum0(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $cd27731a6f3b6127$var$pipelineImpl,
    pipeline: $cd27731a6f3b6127$var$pipeline
};

});
parcelRegister("axhPV", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $3Fpho = parcelRequire("3Fpho");
/* replacement end */ var $7abad26f25ec73bc$var$aggregateTwoErrors = $3Fpho.aggregateTwoErrors, $7abad26f25ec73bc$var$ERR_MULTIPLE_CALLBACK = $3Fpho.codes.ERR_MULTIPLE_CALLBACK, $7abad26f25ec73bc$var$AbortError = $3Fpho.AbortError;

var $lBvnk = parcelRequire("lBvnk");
var $7abad26f25ec73bc$require$Symbol = $lBvnk.Symbol;

var $khkpJ = parcelRequire("khkpJ");
var $7abad26f25ec73bc$var$kIsDestroyed = $khkpJ.kIsDestroyed, $7abad26f25ec73bc$var$isDestroyed = $khkpJ.isDestroyed, $7abad26f25ec73bc$var$isFinished = $khkpJ.isFinished, $7abad26f25ec73bc$var$isServerRequest = $khkpJ.isServerRequest;
var $7abad26f25ec73bc$var$kDestroy = $7abad26f25ec73bc$require$Symbol('kDestroy');
var $7abad26f25ec73bc$var$kConstruct = $7abad26f25ec73bc$require$Symbol('kConstruct');
function $7abad26f25ec73bc$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $7abad26f25ec73bc$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $7abad26f25ec73bc$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($7abad26f25ec73bc$var$kDestroy, function(er) {
        $7abad26f25ec73bc$var$_destroy(this, $7abad26f25ec73bc$var$aggregateTwoErrors(er, err), cb);
    });
    else $7abad26f25ec73bc$var$_destroy(this, err, cb);
    return this;
}
function $7abad26f25ec73bc$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $7abad26f25ec73bc$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($7abad26f25ec73bc$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($7abad26f25ec73bc$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $7abad26f25ec73bc$var$emitErrorCloseNT(self, err) {
    $7abad26f25ec73bc$var$emitErrorNT(self, err);
    $7abad26f25ec73bc$var$emitCloseNT(self);
}
function $7abad26f25ec73bc$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $7abad26f25ec73bc$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $7abad26f25ec73bc$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $7abad26f25ec73bc$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($7abad26f25ec73bc$var$emitErrorNT, stream, err);
        else $7abad26f25ec73bc$var$emitErrorNT(stream, err);
    }
}
function $7abad26f25ec73bc$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($7abad26f25ec73bc$var$kConstruct, cb);
    if (stream.listenerCount($7abad26f25ec73bc$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($7abad26f25ec73bc$var$constructNT, stream);
}
function $7abad26f25ec73bc$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $7abad26f25ec73bc$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $7abad26f25ec73bc$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($7abad26f25ec73bc$var$kDestroy, err);
        else if (err) $7abad26f25ec73bc$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($7abad26f25ec73bc$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $7abad26f25ec73bc$var$emitConstructNT(stream) {
    stream.emit($7abad26f25ec73bc$var$kConstruct);
}
function $7abad26f25ec73bc$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $7abad26f25ec73bc$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $7abad26f25ec73bc$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($7abad26f25ec73bc$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $7abad26f25ec73bc$var$destroyer(stream, err) {
    if (!stream || $7abad26f25ec73bc$var$isDestroyed(stream)) return;
    if (!err && !$7abad26f25ec73bc$var$isFinished(stream)) err = new $7abad26f25ec73bc$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($7abad26f25ec73bc$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($7abad26f25ec73bc$var$isRequest(stream)) stream.abort();
    else if ($7abad26f25ec73bc$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($7abad26f25ec73bc$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($7abad26f25ec73bc$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$7abad26f25ec73bc$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $7abad26f25ec73bc$var$construct,
    destroyer: $7abad26f25ec73bc$var$destroyer,
    destroy: $7abad26f25ec73bc$var$destroy,
    undestroy: $7abad26f25ec73bc$var$undestroy,
    errorOrDestroy: $7abad26f25ec73bc$var$errorOrDestroy
};

});

parcelRegister("026ih", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $006511d40160e273$var$ObjectDefineProperties = $lBvnk.ObjectDefineProperties, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor = $lBvnk.ObjectGetOwnPropertyDescriptor, $006511d40160e273$var$ObjectKeys = $lBvnk.ObjectKeys, $006511d40160e273$var$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf;
module.exports = $006511d40160e273$var$Duplex;

var $jj8ac = parcelRequire("jj8ac");

var $179U2 = parcelRequire("179U2");
$006511d40160e273$var$ObjectSetPrototypeOf($006511d40160e273$var$Duplex.prototype, $jj8ac.prototype);
$006511d40160e273$var$ObjectSetPrototypeOf($006511d40160e273$var$Duplex, $jj8ac);
{
    var $006511d40160e273$var$keys = $006511d40160e273$var$ObjectKeys($179U2.prototype);
    // Allow the keys array to be GC'ed.
    for(var $006511d40160e273$var$i = 0; $006511d40160e273$var$i < $006511d40160e273$var$keys.length; $006511d40160e273$var$i++){
        var $006511d40160e273$var$method = $006511d40160e273$var$keys[$006511d40160e273$var$i];
        if (!$006511d40160e273$var$Duplex.prototype[$006511d40160e273$var$method]) $006511d40160e273$var$Duplex.prototype[$006511d40160e273$var$method] = $179U2.prototype[$006511d40160e273$var$method];
    }
}function $006511d40160e273$var$Duplex(options) {
    if (!(this instanceof $006511d40160e273$var$Duplex)) return new $006511d40160e273$var$Duplex(options);
    $jj8ac.call(this, options);
    $179U2.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$006511d40160e273$var$ObjectDefineProperties($006511d40160e273$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $006511d40160e273$var$ObjectGetOwnPropertyDescriptor($179U2.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $006511d40160e273$var$webStreamsAdapters;
// Lazy to avoid circular references
function $006511d40160e273$var$lazyWebStreams() {
    if ($006511d40160e273$var$webStreamsAdapters === undefined) $006511d40160e273$var$webStreamsAdapters = {};
    return $006511d40160e273$var$webStreamsAdapters;
}
$006511d40160e273$var$Duplex.fromWeb = function(pair, options) {
    return $006511d40160e273$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$006511d40160e273$var$Duplex.toWeb = function(duplex) {
    return $006511d40160e273$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $006511d40160e273$var$duplexify;

$006511d40160e273$var$Duplex.from = function(body) {
    if (!$006511d40160e273$var$duplexify) $006511d40160e273$var$duplexify = (parcelRequire("fdHf6"));
    return $006511d40160e273$var$duplexify(body, 'body');
};

});
parcelRegister("jj8ac", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lBvnk = parcelRequire("lBvnk");
/* replacement end */ var $e0e61fc5b95b906d$var$ArrayPrototypeIndexOf = $lBvnk.ArrayPrototypeIndexOf, $e0e61fc5b95b906d$var$NumberIsInteger = $lBvnk.NumberIsInteger, $e0e61fc5b95b906d$var$NumberIsNaN = $lBvnk.NumberIsNaN, $e0e61fc5b95b906d$var$NumberParseInt = $lBvnk.NumberParseInt, $e0e61fc5b95b906d$var$ObjectDefineProperties = $lBvnk.ObjectDefineProperties, $e0e61fc5b95b906d$var$ObjectKeys = $lBvnk.ObjectKeys, $e0e61fc5b95b906d$var$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf, $e0e61fc5b95b906d$var$Promise = $lBvnk.Promise, $e0e61fc5b95b906d$var$SafeSet = $lBvnk.SafeSet, $e0e61fc5b95b906d$var$SymbolAsyncDispose = $lBvnk.SymbolAsyncDispose, $e0e61fc5b95b906d$var$SymbolAsyncIterator = $lBvnk.SymbolAsyncIterator, $e0e61fc5b95b906d$var$Symbol = $lBvnk.Symbol;
module.exports = $e0e61fc5b95b906d$var$Readable;
$e0e61fc5b95b906d$var$Readable.ReadableState = $e0e61fc5b95b906d$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $e0e61fc5b95b906d$var$EE = $bBoAO.EventEmitter;

var $i7NB2 = parcelRequire("i7NB2");
var $e0e61fc5b95b906d$var$Stream = $i7NB2.Stream, $e0e61fc5b95b906d$var$prependListener = $i7NB2.prependListener;

var $bMvJO = parcelRequire("bMvJO");
var $e0e61fc5b95b906d$require$Buffer = $bMvJO.Buffer;

var $loAsg = parcelRequire("loAsg");
var $e0e61fc5b95b906d$require$addAbortSignal = $loAsg.addAbortSignal;

var $1Jum0 = parcelRequire("1Jum0");

var $e0e61fc5b95b906d$var$debug = (parcelRequire("kscRZ")).debuglog('stream', function(fn) {
    $e0e61fc5b95b906d$var$debug = fn;
});

var $jb8rK = parcelRequire("jb8rK");

var $axhPV = parcelRequire("axhPV");

var $7rwXa = parcelRequire("7rwXa");
var $e0e61fc5b95b906d$var$getHighWaterMark = $7rwXa.getHighWaterMark, $e0e61fc5b95b906d$var$getDefaultHighWaterMark = $7rwXa.getDefaultHighWaterMark;

var $3Fpho = parcelRequire("3Fpho");
var $e0e61fc5b95b906d$var$aggregateTwoErrors = $3Fpho.aggregateTwoErrors, $e0e61fc5b95b906d$var$_require_codes = $3Fpho.codes, $e0e61fc5b95b906d$var$ERR_INVALID_ARG_TYPE = $e0e61fc5b95b906d$var$_require_codes.ERR_INVALID_ARG_TYPE, $e0e61fc5b95b906d$var$ERR_METHOD_NOT_IMPLEMENTED = $e0e61fc5b95b906d$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $e0e61fc5b95b906d$var$ERR_OUT_OF_RANGE = $e0e61fc5b95b906d$var$_require_codes.ERR_OUT_OF_RANGE, $e0e61fc5b95b906d$var$ERR_STREAM_PUSH_AFTER_EOF = $e0e61fc5b95b906d$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $e0e61fc5b95b906d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $e0e61fc5b95b906d$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $e0e61fc5b95b906d$var$AbortError = $3Fpho.AbortError;

var $3CG1b = parcelRequire("3CG1b");
var $e0e61fc5b95b906d$require$validateObject = $3CG1b.validateObject;
var $e0e61fc5b95b906d$var$kPaused = $e0e61fc5b95b906d$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $e0e61fc5b95b906d$require$StringDecoder = $3Jf7C.StringDecoder;

var $fuaV7 = parcelRequire("fuaV7");
$e0e61fc5b95b906d$var$ObjectSetPrototypeOf($e0e61fc5b95b906d$var$Readable.prototype, $e0e61fc5b95b906d$var$Stream.prototype);
$e0e61fc5b95b906d$var$ObjectSetPrototypeOf($e0e61fc5b95b906d$var$Readable, $e0e61fc5b95b906d$var$Stream);
var $e0e61fc5b95b906d$var$nop = function() {};
var $e0e61fc5b95b906d$var$errorOrDestroy = $axhPV.errorOrDestroy;
var $e0e61fc5b95b906d$var$kObjectMode = 1;
var $e0e61fc5b95b906d$var$kEnded = 2;
var $e0e61fc5b95b906d$var$kEndEmitted = 4;
var $e0e61fc5b95b906d$var$kReading = 8;
var $e0e61fc5b95b906d$var$kConstructed = 16;
var $e0e61fc5b95b906d$var$kSync = 32;
var $e0e61fc5b95b906d$var$kNeedReadable = 64;
var $e0e61fc5b95b906d$var$kEmittedReadable = 128;
var $e0e61fc5b95b906d$var$kReadableListening = 256;
var $e0e61fc5b95b906d$var$kResumeScheduled = 512;
var $e0e61fc5b95b906d$var$kErrorEmitted = 1024;
var $e0e61fc5b95b906d$var$kEmitClose = 2048;
var $e0e61fc5b95b906d$var$kAutoDestroy = 4096;
var $e0e61fc5b95b906d$var$kDestroyed = 8192;
var $e0e61fc5b95b906d$var$kClosed = 16384;
var $e0e61fc5b95b906d$var$kCloseEmitted = 32768;
var $e0e61fc5b95b906d$var$kMultiAwaitDrain = 65536;
var $e0e61fc5b95b906d$var$kReadingMore = 131072;
var $e0e61fc5b95b906d$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $e0e61fc5b95b906d$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$e0e61fc5b95b906d$var$ObjectDefineProperties($e0e61fc5b95b906d$var$ReadableState.prototype, {
    objectMode: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kObjectMode),
    ended: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kEnded),
    endEmitted: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kEndEmitted),
    reading: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kNeedReadable),
    emittedReadable: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kEmittedReadable),
    readableListening: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kReadableListening),
    resumeScheduled: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kErrorEmitted),
    emitClose: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kEmitClose),
    autoDestroy: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kCloseEmitted),
    multiAwaitDrain: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kReadingMore),
    dataEmitted: $e0e61fc5b95b906d$var$makeBitMapDescriptor($e0e61fc5b95b906d$var$kDataEmitted)
});

function $e0e61fc5b95b906d$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("026ih"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $e0e61fc5b95b906d$var$kEmitClose | $e0e61fc5b95b906d$var$kAutoDestroy | $e0e61fc5b95b906d$var$kConstructed | $e0e61fc5b95b906d$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $e0e61fc5b95b906d$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $e0e61fc5b95b906d$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $e0e61fc5b95b906d$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $e0e61fc5b95b906d$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $jb8rK();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$e0e61fc5b95b906d$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$e0e61fc5b95b906d$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$e0e61fc5b95b906d$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $e0e61fc5b95b906d$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $e0e61fc5b95b906d$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $e0e61fc5b95b906d$var$Readable)) return new $e0e61fc5b95b906d$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("026ih"));
    this._readableState = new $e0e61fc5b95b906d$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $e0e61fc5b95b906d$require$addAbortSignal(options.signal, this);
    }
    $e0e61fc5b95b906d$var$Stream.call(this, options);
    $axhPV.construct(this, function() {
        if (_this._readableState.needReadable) $e0e61fc5b95b906d$var$maybeReadMore(_this, _this._readableState);
    });
}
$e0e61fc5b95b906d$var$Readable.prototype.destroy = $axhPV.destroy;
$e0e61fc5b95b906d$var$Readable.prototype._undestroy = $axhPV.undestroy;
$e0e61fc5b95b906d$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$e0e61fc5b95b906d$var$Readable.prototype[$e0e61fc5b95b906d$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$e0e61fc5b95b906d$var$Readable.prototype[$e0e61fc5b95b906d$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $e0e61fc5b95b906d$var$AbortError();
        this.destroy(error);
    }
    return new $e0e61fc5b95b906d$var$Promise(function(resolve, reject) {
        return $1Jum0(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$e0e61fc5b95b906d$var$Readable.prototype.push = function(chunk, encoding) {
    return $e0e61fc5b95b906d$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$e0e61fc5b95b906d$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $e0e61fc5b95b906d$var$readableAddChunk(this, chunk, encoding, true);
};
function $e0e61fc5b95b906d$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $e0e61fc5b95b906d$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $e0e61fc5b95b906d$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $e0e61fc5b95b906d$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $e0e61fc5b95b906d$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $e0e61fc5b95b906d$require$Buffer) encoding = '';
        else if ($e0e61fc5b95b906d$var$Stream._isUint8Array(chunk)) {
            chunk = $e0e61fc5b95b906d$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $e0e61fc5b95b906d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $e0e61fc5b95b906d$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$e0e61fc5b95b906d$var$kReading;
        $e0e61fc5b95b906d$var$onEofChunk(stream, state);
    } else if ((state.state & $e0e61fc5b95b906d$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $e0e61fc5b95b906d$var$kEndEmitted) !== 0) $e0e61fc5b95b906d$var$errorOrDestroy(stream, new $e0e61fc5b95b906d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $e0e61fc5b95b906d$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $e0e61fc5b95b906d$var$errorOrDestroy(stream, new $e0e61fc5b95b906d$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$e0e61fc5b95b906d$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $e0e61fc5b95b906d$var$addChunk(stream, state, chunk, false);
                else $e0e61fc5b95b906d$var$maybeReadMore(stream, state);
            } else $e0e61fc5b95b906d$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$e0e61fc5b95b906d$var$kReading;
        $e0e61fc5b95b906d$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $e0e61fc5b95b906d$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $e0e61fc5b95b906d$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $e0e61fc5b95b906d$var$kNeedReadable) !== 0) $e0e61fc5b95b906d$var$emitReadable(stream);
    }
    $e0e61fc5b95b906d$var$maybeReadMore(stream, state);
}
$e0e61fc5b95b906d$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$e0e61fc5b95b906d$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$e0e61fc5b95b906d$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $e0e61fc5b95b906d$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$e0e61fc5b95b906d$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $e0e61fc5b95b906d$var$MAX_HWM = 0x40000000;
function $e0e61fc5b95b906d$var$computeNewHighWaterMark(n) {
    if (n > $e0e61fc5b95b906d$var$MAX_HWM) throw new $e0e61fc5b95b906d$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e0e61fc5b95b906d$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $e0e61fc5b95b906d$var$kObjectMode) !== 0) return 1;
    if ($e0e61fc5b95b906d$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$e0e61fc5b95b906d$var$Readable.prototype.read = function(n) {
    $e0e61fc5b95b906d$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$e0e61fc5b95b906d$var$NumberIsInteger(n)) n = $e0e61fc5b95b906d$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $e0e61fc5b95b906d$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$e0e61fc5b95b906d$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $e0e61fc5b95b906d$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $e0e61fc5b95b906d$var$endReadable(this);
        else $e0e61fc5b95b906d$var$emitReadable(this);
        return null;
    }
    n = $e0e61fc5b95b906d$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $e0e61fc5b95b906d$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $e0e61fc5b95b906d$var$kNeedReadable) !== 0;
    $e0e61fc5b95b906d$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $e0e61fc5b95b906d$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $e0e61fc5b95b906d$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $e0e61fc5b95b906d$var$debug('do read');
        state.state |= $e0e61fc5b95b906d$var$kReading | $e0e61fc5b95b906d$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $e0e61fc5b95b906d$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $e0e61fc5b95b906d$var$errorOrDestroy(this, err);
        }
        state.state &= ~$e0e61fc5b95b906d$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $e0e61fc5b95b906d$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $e0e61fc5b95b906d$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $e0e61fc5b95b906d$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $e0e61fc5b95b906d$var$onEofChunk(stream, state) {
    $e0e61fc5b95b906d$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $e0e61fc5b95b906d$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $e0e61fc5b95b906d$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $e0e61fc5b95b906d$var$emitReadable(stream) {
    var state = stream._readableState;
    $e0e61fc5b95b906d$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $e0e61fc5b95b906d$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($e0e61fc5b95b906d$var$emitReadable_, stream);
    }
}
function $e0e61fc5b95b906d$var$emitReadable_(stream) {
    var state = stream._readableState;
    $e0e61fc5b95b906d$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $e0e61fc5b95b906d$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $e0e61fc5b95b906d$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($e0e61fc5b95b906d$var$maybeReadMore_, stream, state);
    }
}
function $e0e61fc5b95b906d$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $e0e61fc5b95b906d$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$e0e61fc5b95b906d$var$Readable.prototype._read = function(n) {
    throw new $e0e61fc5b95b906d$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$e0e61fc5b95b906d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $e0e61fc5b95b906d$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $e0e61fc5b95b906d$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $e0e61fc5b95b906d$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $e0e61fc5b95b906d$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $e0e61fc5b95b906d$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $e0e61fc5b95b906d$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $e0e61fc5b95b906d$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $e0e61fc5b95b906d$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $e0e61fc5b95b906d$var$debug('ondata');
        var ret = dest.write(chunk);
        $e0e61fc5b95b906d$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $e0e61fc5b95b906d$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $e0e61fc5b95b906d$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $e0e61fc5b95b906d$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $e0e61fc5b95b906d$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $e0e61fc5b95b906d$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $e0e61fc5b95b906d$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $e0e61fc5b95b906d$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $e0e61fc5b95b906d$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $e0e61fc5b95b906d$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$e0e61fc5b95b906d$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $e0e61fc5b95b906d$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$e0e61fc5b95b906d$var$Readable.prototype.on = function(ev, fn) {
    var res = $e0e61fc5b95b906d$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $e0e61fc5b95b906d$var$debug('on readable', state.length, state.reading);
            if (state.length) $e0e61fc5b95b906d$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($e0e61fc5b95b906d$var$nReadingNextTick, this);
        }
    }
    return res;
};
$e0e61fc5b95b906d$var$Readable.prototype.addListener = $e0e61fc5b95b906d$var$Readable.prototype.on;
$e0e61fc5b95b906d$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $e0e61fc5b95b906d$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($e0e61fc5b95b906d$var$updateReadableListening, this);
    return res;
};
$e0e61fc5b95b906d$var$Readable.prototype.off = $e0e61fc5b95b906d$var$Readable.prototype.removeListener;
$e0e61fc5b95b906d$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $e0e61fc5b95b906d$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($e0e61fc5b95b906d$var$updateReadableListening, this);
    return res;
};
function $e0e61fc5b95b906d$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$e0e61fc5b95b906d$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $e0e61fc5b95b906d$var$nReadingNextTick(self) {
    $e0e61fc5b95b906d$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$e0e61fc5b95b906d$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $e0e61fc5b95b906d$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $e0e61fc5b95b906d$var$resume(this, state);
    }
    state[$e0e61fc5b95b906d$var$kPaused] = false;
    return this;
};
function $e0e61fc5b95b906d$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($e0e61fc5b95b906d$var$resume_, stream, state);
    }
}
function $e0e61fc5b95b906d$var$resume_(stream, state) {
    $e0e61fc5b95b906d$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $e0e61fc5b95b906d$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$e0e61fc5b95b906d$var$Readable.prototype.pause = function() {
    $e0e61fc5b95b906d$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $e0e61fc5b95b906d$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$e0e61fc5b95b906d$var$kPaused] = true;
    return this;
};
function $e0e61fc5b95b906d$var$flow(stream) {
    var state = stream._readableState;
    $e0e61fc5b95b906d$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$e0e61fc5b95b906d$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $e0e61fc5b95b906d$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $e0e61fc5b95b906d$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$e0e61fc5b95b906d$var$Readable.prototype[$e0e61fc5b95b906d$var$SymbolAsyncIterator] = function() {
    return $e0e61fc5b95b906d$var$streamToAsyncIterator(this);
};
$e0e61fc5b95b906d$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $e0e61fc5b95b906d$require$validateObject(options, 'options');
    return $e0e61fc5b95b906d$var$streamToAsyncIterator(this, options);
};
function $e0e61fc5b95b906d$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $e0e61fc5b95b906d$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $e0e61fc5b95b906d$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $e0e61fc5b95b906d$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $e0e61fc5b95b906d$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $e0e61fc5b95b906d$var$nop;
                    stream.on('readable', next);
                    cleanup = $1Jum0(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $e0e61fc5b95b906d$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $e0e61fc5b95b906d$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $e0e61fc5b95b906d$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $e0e61fc5b95b906d$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $axhPV.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$e0e61fc5b95b906d$var$ObjectDefineProperties($e0e61fc5b95b906d$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$e0e61fc5b95b906d$var$ObjectDefineProperties($e0e61fc5b95b906d$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$e0e61fc5b95b906d$var$kPaused] !== false;
        },
        set: function(value) {
            this[$e0e61fc5b95b906d$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$e0e61fc5b95b906d$var$Readable._fromList = $e0e61fc5b95b906d$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e0e61fc5b95b906d$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $e0e61fc5b95b906d$var$endReadable(stream) {
    var state = stream._readableState;
    $e0e61fc5b95b906d$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($e0e61fc5b95b906d$var$endReadableNT, state, stream);
    }
}
function $e0e61fc5b95b906d$var$endReadableNT(state, stream) {
    $e0e61fc5b95b906d$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($e0e61fc5b95b906d$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $e0e61fc5b95b906d$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$e0e61fc5b95b906d$var$Readable.from = function(iterable, opts) {
    return $fuaV7($e0e61fc5b95b906d$var$Readable, iterable, opts);
};
var $e0e61fc5b95b906d$var$webStreamsAdapters;
// Lazy to avoid circular references
function $e0e61fc5b95b906d$var$lazyWebStreams() {
    if ($e0e61fc5b95b906d$var$webStreamsAdapters === undefined) $e0e61fc5b95b906d$var$webStreamsAdapters = {};
    return $e0e61fc5b95b906d$var$webStreamsAdapters;
}
$e0e61fc5b95b906d$var$Readable.fromWeb = function(readableStream, options) {
    return $e0e61fc5b95b906d$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$e0e61fc5b95b906d$var$Readable.toWeb = function(streamReadable, options) {
    return $e0e61fc5b95b906d$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$e0e61fc5b95b906d$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $e0e61fc5b95b906d$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $axhPV.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("i7NB2", function(module, exports) {
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $d31f5a46a3c44098$var$ArrayIsArray = $lBvnk.ArrayIsArray, $d31f5a46a3c44098$var$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $d31f5a46a3c44098$var$EE = $bBoAO.EventEmitter;
function $d31f5a46a3c44098$var$Stream(opts) {
    $d31f5a46a3c44098$var$EE.call(this, opts);
}
$d31f5a46a3c44098$var$ObjectSetPrototypeOf($d31f5a46a3c44098$var$Stream.prototype, $d31f5a46a3c44098$var$EE.prototype);
$d31f5a46a3c44098$var$ObjectSetPrototypeOf($d31f5a46a3c44098$var$Stream, $d31f5a46a3c44098$var$EE);
$d31f5a46a3c44098$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d31f5a46a3c44098$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $d31f5a46a3c44098$var$prependListener(source, 'error', onerror);
    $d31f5a46a3c44098$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $d31f5a46a3c44098$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($d31f5a46a3c44098$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $d31f5a46a3c44098$var$Stream,
    prependListener: $d31f5a46a3c44098$var$prependListener
};

});

parcelRegister("loAsg", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $f9381e0a1bd3199f$export$e2db56ee53255a0; }, function (v) { return $f9381e0a1bd3199f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $f9381e0a1bd3199f$export$11956e9313f43de0; }, function (v) { return $f9381e0a1bd3199f$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $f9381e0a1bd3199f$export$e2db56ee53255a0;
var $f9381e0a1bd3199f$export$11956e9313f43de0;
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $f9381e0a1bd3199f$require$SymbolDispose = $lBvnk.SymbolDispose;

var $3Fpho = parcelRequire("3Fpho");
var $f9381e0a1bd3199f$var$AbortError = $3Fpho.AbortError, $f9381e0a1bd3199f$var$codes = $3Fpho.codes;

var $khkpJ = parcelRequire("khkpJ");
var $f9381e0a1bd3199f$var$isNodeStream = $khkpJ.isNodeStream, $f9381e0a1bd3199f$var$isWebStream = $khkpJ.isWebStream, $f9381e0a1bd3199f$var$kControllerErrorFunction = $khkpJ.kControllerErrorFunction;

var $1Jum0 = parcelRequire("1Jum0");
var $f9381e0a1bd3199f$var$ERR_INVALID_ARG_TYPE = $f9381e0a1bd3199f$var$codes.ERR_INVALID_ARG_TYPE;
var $f9381e0a1bd3199f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $f9381e0a1bd3199f$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $f9381e0a1bd3199f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$f9381e0a1bd3199f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $f9381e0a1bd3199f$var$validateAbortSignal(signal, 'signal');
    if (!$f9381e0a1bd3199f$var$isNodeStream(stream) && !$f9381e0a1bd3199f$var$isWebStream(stream)) throw new $f9381e0a1bd3199f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $f9381e0a1bd3199f$export$11956e9313f43de0(signal, stream);
};

$f9381e0a1bd3199f$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $f9381e0a1bd3199f$var$isNodeStream(stream) ? function() {
        stream.destroy(new $f9381e0a1bd3199f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$f9381e0a1bd3199f$var$kControllerErrorFunction](new $f9381e0a1bd3199f$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $f9381e0a1bd3199f$var$addAbortListener = $f9381e0a1bd3199f$var$addAbortListener || (parcelRequire("kscRZ")).addAbortListener;
        var disposable = $f9381e0a1bd3199f$var$addAbortListener(signal, onAbort);
        $1Jum0(stream, disposable[$f9381e0a1bd3199f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("jb8rK", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $df6598af8ae73093$var$StringPrototypeSlice = $lBvnk.StringPrototypeSlice, $df6598af8ae73093$var$SymbolIterator = $lBvnk.SymbolIterator, $df6598af8ae73093$var$TypedArrayPrototypeSet = $lBvnk.TypedArrayPrototypeSet, $df6598af8ae73093$var$Uint8Array = $lBvnk.Uint8Array;

var $bMvJO = parcelRequire("bMvJO");
var $df6598af8ae73093$require$Buffer = $bMvJO.Buffer;

var $kscRZ = parcelRequire("kscRZ");
var $df6598af8ae73093$require$inspect = $kscRZ.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $df6598af8ae73093$require$Buffer.alloc(0);
                var ret = $df6598af8ae73093$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $df6598af8ae73093$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $df6598af8ae73093$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $df6598af8ae73093$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $df6598af8ae73093$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $df6598af8ae73093$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $df6598af8ae73093$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $df6598af8ae73093$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $df6598af8ae73093$var$TypedArrayPrototypeSet(ret, new $df6598af8ae73093$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $df6598af8ae73093$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("7rwXa", function(module, exports) {
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $56b49ddfbfcb3ade$var$MathFloor = $lBvnk.MathFloor, $56b49ddfbfcb3ade$var$NumberIsInteger = $lBvnk.NumberIsInteger;

var $3CG1b = parcelRequire("3CG1b");
var $56b49ddfbfcb3ade$require$validateInteger = $3CG1b.validateInteger;

var $56b49ddfbfcb3ade$var$ERR_INVALID_ARG_VALUE = (parcelRequire("3Fpho")).codes.ERR_INVALID_ARG_VALUE;
var $56b49ddfbfcb3ade$var$defaultHighWaterMarkBytes = 16384;
var $56b49ddfbfcb3ade$var$defaultHighWaterMarkObjectMode = 16;
function $56b49ddfbfcb3ade$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $56b49ddfbfcb3ade$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $56b49ddfbfcb3ade$var$defaultHighWaterMarkObjectMode : $56b49ddfbfcb3ade$var$defaultHighWaterMarkBytes;
}
function $56b49ddfbfcb3ade$var$setDefaultHighWaterMark(objectMode, value) {
    $56b49ddfbfcb3ade$require$validateInteger(value, 'value', 0);
    if (objectMode) $56b49ddfbfcb3ade$var$defaultHighWaterMarkObjectMode = value;
    else $56b49ddfbfcb3ade$var$defaultHighWaterMarkBytes = value;
}
function $56b49ddfbfcb3ade$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $56b49ddfbfcb3ade$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$56b49ddfbfcb3ade$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $56b49ddfbfcb3ade$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $56b49ddfbfcb3ade$var$MathFloor(hwm);
    }
    // Default value
    return $56b49ddfbfcb3ade$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $56b49ddfbfcb3ade$var$getHighWaterMark,
    getDefaultHighWaterMark: $56b49ddfbfcb3ade$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $56b49ddfbfcb3ade$var$setDefaultHighWaterMark
};

});

parcelRegister("fuaV7", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lBvnk = parcelRequire("lBvnk");
/* replacement end */ var $b46220e97c495ae5$var$PromisePrototypeThen = $lBvnk.PromisePrototypeThen, $b46220e97c495ae5$var$SymbolAsyncIterator = $lBvnk.SymbolAsyncIterator, $b46220e97c495ae5$var$SymbolIterator = $lBvnk.SymbolIterator;

var $bMvJO = parcelRequire("bMvJO");
var $b46220e97c495ae5$require$Buffer = $bMvJO.Buffer;

var $3Fpho = parcelRequire("3Fpho");
var $b46220e97c495ae5$require$_require_codes = $3Fpho.codes;
var $b46220e97c495ae5$var$ERR_INVALID_ARG_TYPE = $b46220e97c495ae5$require$_require_codes.ERR_INVALID_ARG_TYPE, $b46220e97c495ae5$var$ERR_STREAM_NULL_VALUES = $b46220e97c495ae5$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $b46220e97c495ae5$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $b46220e97c495ae5$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$b46220e97c495ae5$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$b46220e97c495ae5$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$b46220e97c495ae5$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$b46220e97c495ae5$var$SymbolIterator]();
    } else throw new $b46220e97c495ae5$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $b46220e97c495ae5$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $b46220e97c495ae5$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $b46220e97c495ae5$var$from;

});


parcelRegister("179U2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lBvnk = parcelRequire("lBvnk");
/* replacement end */ var $0cfe2065abd4e37d$var$ArrayPrototypeSlice = $lBvnk.ArrayPrototypeSlice, $0cfe2065abd4e37d$var$Error = $lBvnk.Error, $0cfe2065abd4e37d$var$FunctionPrototypeSymbolHasInstance = $lBvnk.FunctionPrototypeSymbolHasInstance, $0cfe2065abd4e37d$var$ObjectDefineProperty = $lBvnk.ObjectDefineProperty, $0cfe2065abd4e37d$var$ObjectDefineProperties = $lBvnk.ObjectDefineProperties, $0cfe2065abd4e37d$var$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf, $0cfe2065abd4e37d$var$StringPrototypeToLowerCase = $lBvnk.StringPrototypeToLowerCase, $0cfe2065abd4e37d$var$Symbol = $lBvnk.Symbol, $0cfe2065abd4e37d$var$SymbolHasInstance = $lBvnk.SymbolHasInstance;
module.exports = $0cfe2065abd4e37d$var$Writable;
$0cfe2065abd4e37d$var$Writable.WritableState = $0cfe2065abd4e37d$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $0cfe2065abd4e37d$var$EE = $bBoAO.EventEmitter;

var $i7NB2 = parcelRequire("i7NB2");
var $0cfe2065abd4e37d$require$Stream = $i7NB2.Stream;

var $bMvJO = parcelRequire("bMvJO");
var $0cfe2065abd4e37d$require$Buffer = $bMvJO.Buffer;

var $axhPV = parcelRequire("axhPV");

var $loAsg = parcelRequire("loAsg");
var $0cfe2065abd4e37d$require$addAbortSignal = $loAsg.addAbortSignal;

var $7rwXa = parcelRequire("7rwXa");
var $0cfe2065abd4e37d$var$getHighWaterMark = $7rwXa.getHighWaterMark, $0cfe2065abd4e37d$var$getDefaultHighWaterMark = $7rwXa.getDefaultHighWaterMark;

var $3Fpho = parcelRequire("3Fpho");
var $0cfe2065abd4e37d$require$_require_codes = $3Fpho.codes;
var $0cfe2065abd4e37d$var$ERR_INVALID_ARG_TYPE = $0cfe2065abd4e37d$require$_require_codes.ERR_INVALID_ARG_TYPE, $0cfe2065abd4e37d$var$ERR_METHOD_NOT_IMPLEMENTED = $0cfe2065abd4e37d$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $0cfe2065abd4e37d$var$ERR_MULTIPLE_CALLBACK = $0cfe2065abd4e37d$require$_require_codes.ERR_MULTIPLE_CALLBACK, $0cfe2065abd4e37d$var$ERR_STREAM_CANNOT_PIPE = $0cfe2065abd4e37d$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED = $0cfe2065abd4e37d$require$_require_codes.ERR_STREAM_DESTROYED, $0cfe2065abd4e37d$var$ERR_STREAM_ALREADY_FINISHED = $0cfe2065abd4e37d$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $0cfe2065abd4e37d$var$ERR_STREAM_NULL_VALUES = $0cfe2065abd4e37d$require$_require_codes.ERR_STREAM_NULL_VALUES, $0cfe2065abd4e37d$var$ERR_STREAM_WRITE_AFTER_END = $0cfe2065abd4e37d$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $0cfe2065abd4e37d$var$ERR_UNKNOWN_ENCODING = $0cfe2065abd4e37d$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $0cfe2065abd4e37d$var$errorOrDestroy = $axhPV.errorOrDestroy;
$0cfe2065abd4e37d$var$ObjectSetPrototypeOf($0cfe2065abd4e37d$var$Writable.prototype, $0cfe2065abd4e37d$require$Stream.prototype);
$0cfe2065abd4e37d$var$ObjectSetPrototypeOf($0cfe2065abd4e37d$var$Writable, $0cfe2065abd4e37d$require$Stream);
function $0cfe2065abd4e37d$var$nop() {}
var $0cfe2065abd4e37d$var$kOnFinished = $0cfe2065abd4e37d$var$Symbol('kOnFinished');

function $0cfe2065abd4e37d$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("026ih"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $0cfe2065abd4e37d$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $0cfe2065abd4e37d$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $0cfe2065abd4e37d$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $0cfe2065abd4e37d$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$0cfe2065abd4e37d$var$kOnFinished] = [];
}
function $0cfe2065abd4e37d$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$0cfe2065abd4e37d$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $0cfe2065abd4e37d$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$0cfe2065abd4e37d$var$ObjectDefineProperty($0cfe2065abd4e37d$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $0cfe2065abd4e37d$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("026ih"));
    if (!isDuplex && !$0cfe2065abd4e37d$var$FunctionPrototypeSymbolHasInstance($0cfe2065abd4e37d$var$Writable, this)) return new $0cfe2065abd4e37d$var$Writable(options);
    this._writableState = new $0cfe2065abd4e37d$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $0cfe2065abd4e37d$require$addAbortSignal(options.signal, this);
    }
    $0cfe2065abd4e37d$require$Stream.call(this, options);
    $axhPV.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $0cfe2065abd4e37d$var$clearBuffer(_this, state);
        $0cfe2065abd4e37d$var$finishMaybe(_this, state);
    });
}
$0cfe2065abd4e37d$var$ObjectDefineProperty($0cfe2065abd4e37d$var$Writable, $0cfe2065abd4e37d$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($0cfe2065abd4e37d$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $0cfe2065abd4e37d$var$Writable) return false;
        return object && object._writableState instanceof $0cfe2065abd4e37d$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$0cfe2065abd4e37d$var$Writable.prototype.pipe = function() {
    $0cfe2065abd4e37d$var$errorOrDestroy(this, new $0cfe2065abd4e37d$var$ERR_STREAM_CANNOT_PIPE());
};
function $0cfe2065abd4e37d$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$0cfe2065abd4e37d$require$Buffer.isEncoding(encoding)) throw new $0cfe2065abd4e37d$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $0cfe2065abd4e37d$var$nop;
    }
    if (chunk === null) throw new $0cfe2065abd4e37d$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $0cfe2065abd4e37d$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $0cfe2065abd4e37d$require$Buffer) encoding = 'buffer';
        else if ($0cfe2065abd4e37d$require$Stream._isUint8Array(chunk)) {
            chunk = $0cfe2065abd4e37d$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $0cfe2065abd4e37d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $0cfe2065abd4e37d$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $0cfe2065abd4e37d$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $0cfe2065abd4e37d$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$0cfe2065abd4e37d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $0cfe2065abd4e37d$var$_write(this, chunk, encoding, cb) === true;
};
$0cfe2065abd4e37d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$0cfe2065abd4e37d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $0cfe2065abd4e37d$var$clearBuffer(this, state);
    }
};
$0cfe2065abd4e37d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $0cfe2065abd4e37d$var$StringPrototypeToLowerCase(encoding);
    if (!$0cfe2065abd4e37d$require$Buffer.isEncoding(encoding)) throw new $0cfe2065abd4e37d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $0cfe2065abd4e37d$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $0cfe2065abd4e37d$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $0cfe2065abd4e37d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $0cfe2065abd4e37d$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $0cfe2065abd4e37d$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $0cfe2065abd4e37d$var$errorOrDestroy(stream, er);
}
function $0cfe2065abd4e37d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $0cfe2065abd4e37d$var$errorOrDestroy(stream, new $0cfe2065abd4e37d$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($0cfe2065abd4e37d$var$onwriteError, stream, state, er, cb);
        else $0cfe2065abd4e37d$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $0cfe2065abd4e37d$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($0cfe2065abd4e37d$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $0cfe2065abd4e37d$var$afterWrite(stream, state, 1, cb);
    }
}
function $0cfe2065abd4e37d$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $0cfe2065abd4e37d$var$afterWrite(stream, state, count, cb);
}
function $0cfe2065abd4e37d$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $0cfe2065abd4e37d$var$errorBuffer(state);
    $0cfe2065abd4e37d$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $0cfe2065abd4e37d$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$0cfe2065abd4e37d$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED('end'));
    }
    $0cfe2065abd4e37d$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $0cfe2065abd4e37d$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $0cfe2065abd4e37d$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $0cfe2065abd4e37d$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $0cfe2065abd4e37d$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $0cfe2065abd4e37d$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $0cfe2065abd4e37d$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $0cfe2065abd4e37d$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$0cfe2065abd4e37d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $0cfe2065abd4e37d$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$0cfe2065abd4e37d$var$Writable.prototype._writev = null;
$0cfe2065abd4e37d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $0cfe2065abd4e37d$var$_write(this, chunk, encoding);
        if (ret instanceof $0cfe2065abd4e37d$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $0cfe2065abd4e37d$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $0cfe2065abd4e37d$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $0cfe2065abd4e37d$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$0cfe2065abd4e37d$var$kOnFinished].push(cb);
    }
    return this;
};
function $0cfe2065abd4e37d$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $0cfe2065abd4e37d$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $0cfe2065abd4e37d$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $0cfe2065abd4e37d$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$0cfe2065abd4e37d$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $0cfe2065abd4e37d$var$errorOrDestroy(stream, err, state.sync);
        } else if ($0cfe2065abd4e37d$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($0cfe2065abd4e37d$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $0cfe2065abd4e37d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $0cfe2065abd4e37d$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $0cfe2065abd4e37d$var$finishMaybe(stream, state, sync) {
    if ($0cfe2065abd4e37d$var$needFinish(state)) {
        $0cfe2065abd4e37d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($0cfe2065abd4e37d$var$needFinish(state)) $0cfe2065abd4e37d$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($0cfe2065abd4e37d$var$needFinish(state)) {
                state.pendingcb++;
                $0cfe2065abd4e37d$var$finish(stream, state);
            }
        }
    }
}
function $0cfe2065abd4e37d$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$0cfe2065abd4e37d$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$0cfe2065abd4e37d$var$ObjectDefineProperties($0cfe2065abd4e37d$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $0cfe2065abd4e37d$var$destroy = $axhPV.destroy;
$0cfe2065abd4e37d$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$0cfe2065abd4e37d$var$kOnFinished].length)) $2Qkr5.nextTick($0cfe2065abd4e37d$var$errorBuffer, state);
    $0cfe2065abd4e37d$var$destroy.call(this, err, cb);
    return this;
};
$0cfe2065abd4e37d$var$Writable.prototype._undestroy = $axhPV.undestroy;
$0cfe2065abd4e37d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$0cfe2065abd4e37d$var$Writable.prototype[$0cfe2065abd4e37d$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $0cfe2065abd4e37d$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0cfe2065abd4e37d$var$lazyWebStreams() {
    if ($0cfe2065abd4e37d$var$webStreamsAdapters === undefined) $0cfe2065abd4e37d$var$webStreamsAdapters = {};
    return $0cfe2065abd4e37d$var$webStreamsAdapters;
}
$0cfe2065abd4e37d$var$Writable.fromWeb = function(writableStream, options) {
    return $0cfe2065abd4e37d$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$0cfe2065abd4e37d$var$Writable.toWeb = function(streamWritable) {
    return $0cfe2065abd4e37d$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("fdHf6", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $bMvJO = parcelRequire("bMvJO");

var $khkpJ = parcelRequire("khkpJ");
var $b1499cffe0f1f08d$var$isReadable = $khkpJ.isReadable, $b1499cffe0f1f08d$var$isWritable = $khkpJ.isWritable, $b1499cffe0f1f08d$var$isIterable = $khkpJ.isIterable, $b1499cffe0f1f08d$var$isNodeStream = $khkpJ.isNodeStream, $b1499cffe0f1f08d$var$isReadableNodeStream = $khkpJ.isReadableNodeStream, $b1499cffe0f1f08d$var$isWritableNodeStream = $khkpJ.isWritableNodeStream, $b1499cffe0f1f08d$var$isDuplexNodeStream = $khkpJ.isDuplexNodeStream, $b1499cffe0f1f08d$var$isReadableStream = $khkpJ.isReadableStream, $b1499cffe0f1f08d$var$isWritableStream = $khkpJ.isWritableStream;

var $1Jum0 = parcelRequire("1Jum0");

var $3Fpho = parcelRequire("3Fpho");
var $b1499cffe0f1f08d$var$AbortError = $3Fpho.AbortError, $b1499cffe0f1f08d$var$_require_codes = $3Fpho.codes, $b1499cffe0f1f08d$var$ERR_INVALID_ARG_TYPE = $b1499cffe0f1f08d$var$_require_codes.ERR_INVALID_ARG_TYPE, $b1499cffe0f1f08d$var$ERR_INVALID_RETURN_VALUE = $b1499cffe0f1f08d$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $axhPV = parcelRequire("axhPV");
var $b1499cffe0f1f08d$require$destroyer = $axhPV.destroyer;

var $026ih = parcelRequire("026ih");

var $jj8ac = parcelRequire("jj8ac");

var $179U2 = parcelRequire("179U2");

var $kscRZ = parcelRequire("kscRZ");
var $b1499cffe0f1f08d$require$createDeferredPromise = $kscRZ.createDeferredPromise;

var $fuaV7 = parcelRequire("fuaV7");
var $b1499cffe0f1f08d$var$Blob = globalThis.Blob || $bMvJO.Blob;
var $b1499cffe0f1f08d$var$isBlob = typeof $b1499cffe0f1f08d$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $b1499cffe0f1f08d$var$Blob;
} : function isBlob(b) {
    return false;
};

var $b1499cffe0f1f08d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $lBvnk = parcelRequire("lBvnk");
var $b1499cffe0f1f08d$require$FunctionPrototypeCall = $lBvnk.FunctionPrototypeCall;
// This is needed for pre node 17.
var $b1499cffe0f1f08d$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($026ih);
module.exports = function duplexify(body, name) {
    if ($b1499cffe0f1f08d$var$isDuplexNodeStream(body)) return body;
    if ($b1499cffe0f1f08d$var$isReadableNodeStream(body)) return $b1499cffe0f1f08d$var$_duplexify({
        readable: body
    });
    if ($b1499cffe0f1f08d$var$isWritableNodeStream(body)) return $b1499cffe0f1f08d$var$_duplexify({
        writable: body
    });
    if ($b1499cffe0f1f08d$var$isNodeStream(body)) return $b1499cffe0f1f08d$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($b1499cffe0f1f08d$var$isReadableStream(body)) return $b1499cffe0f1f08d$var$_duplexify({
        readable: $jj8ac.fromWeb(body)
    });
    if ($b1499cffe0f1f08d$var$isWritableStream(body)) return $b1499cffe0f1f08d$var$_duplexify({
        writable: $179U2.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $b1499cffe0f1f08d$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($b1499cffe0f1f08d$var$isIterable(value)) return $fuaV7($b1499cffe0f1f08d$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $b1499cffe0f1f08d$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $b1499cffe0f1f08d$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $b1499cffe0f1f08d$require$destroyer(d, err);
            });
            return d = new $b1499cffe0f1f08d$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $b1499cffe0f1f08d$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($b1499cffe0f1f08d$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($b1499cffe0f1f08d$var$isIterable(body)) return $fuaV7($b1499cffe0f1f08d$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($b1499cffe0f1f08d$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $b1499cffe0f1f08d$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $b1499cffe0f1f08d$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $b1499cffe0f1f08d$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $b1499cffe0f1f08d$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $b1499cffe0f1f08d$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $b1499cffe0f1f08d$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $b1499cffe0f1f08d$require$destroyer(d1, err);
        });
        return d1 = new $b1499cffe0f1f08d$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $b1499cffe0f1f08d$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $b1499cffe0f1f08d$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $b1499cffe0f1f08d$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $b1499cffe0f1f08d$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $b1499cffe0f1f08d$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $b1499cffe0f1f08d$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $b1499cffe0f1f08d$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $jj8ac.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$b1499cffe0f1f08d$var$isReadable(r);
    var writable = !!$b1499cffe0f1f08d$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $b1499cffe0f1f08d$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $1Jum0(w, function(err) {
            writable = false;
            if (err) $b1499cffe0f1f08d$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $1Jum0(r, function(err) {
            readable = false;
            if (err) $b1499cffe0f1f08d$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $b1499cffe0f1f08d$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $b1499cffe0f1f08d$require$destroyer(w, err);
            $b1499cffe0f1f08d$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2Pt9T", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $20f6f67fa5b5c452$require$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf;
module.exports = $20f6f67fa5b5c452$var$PassThrough;

var $j7LFv = parcelRequire("j7LFv");
$20f6f67fa5b5c452$require$ObjectSetPrototypeOf($20f6f67fa5b5c452$var$PassThrough.prototype, $j7LFv.prototype);
$20f6f67fa5b5c452$require$ObjectSetPrototypeOf($20f6f67fa5b5c452$var$PassThrough, $j7LFv);
function $20f6f67fa5b5c452$var$PassThrough(options) {
    if (!(this instanceof $20f6f67fa5b5c452$var$PassThrough)) return new $20f6f67fa5b5c452$var$PassThrough(options);
    $j7LFv.call(this, options);
}
$20f6f67fa5b5c452$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("j7LFv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $dec3a5bc6e464b9b$var$ObjectSetPrototypeOf = $lBvnk.ObjectSetPrototypeOf, $dec3a5bc6e464b9b$var$Symbol = $lBvnk.Symbol;
module.exports = $dec3a5bc6e464b9b$var$Transform;

var $dec3a5bc6e464b9b$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("3Fpho")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $026ih = parcelRequire("026ih");

var $7rwXa = parcelRequire("7rwXa");
var $dec3a5bc6e464b9b$require$getHighWaterMark = $7rwXa.getHighWaterMark;
$dec3a5bc6e464b9b$var$ObjectSetPrototypeOf($dec3a5bc6e464b9b$var$Transform.prototype, $026ih.prototype);
$dec3a5bc6e464b9b$var$ObjectSetPrototypeOf($dec3a5bc6e464b9b$var$Transform, $026ih);
var $dec3a5bc6e464b9b$var$kCallback = $dec3a5bc6e464b9b$var$Symbol('kCallback');
function $dec3a5bc6e464b9b$var$Transform(options) {
    if (!(this instanceof $dec3a5bc6e464b9b$var$Transform)) return new $dec3a5bc6e464b9b$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $dec3a5bc6e464b9b$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $026ih.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$dec3a5bc6e464b9b$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $dec3a5bc6e464b9b$var$prefinish);
}
function $dec3a5bc6e464b9b$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $dec3a5bc6e464b9b$var$prefinish() {
    if (this._final !== $dec3a5bc6e464b9b$var$_final) $dec3a5bc6e464b9b$var$_final.call(this);
}
$dec3a5bc6e464b9b$var$Transform.prototype._final = $dec3a5bc6e464b9b$var$_final;
$dec3a5bc6e464b9b$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $dec3a5bc6e464b9b$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$dec3a5bc6e464b9b$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$dec3a5bc6e464b9b$var$kCallback] = callback;
    });
};
$dec3a5bc6e464b9b$var$Transform.prototype._read = function() {
    if (this[$dec3a5bc6e464b9b$var$kCallback]) {
        var callback = this[$dec3a5bc6e464b9b$var$kCallback];
        this[$dec3a5bc6e464b9b$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("8LJvk", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lBvnk = parcelRequire("lBvnk");
var $662602b8c2ab9345$var$ArrayPrototypePop = $lBvnk.ArrayPrototypePop, $662602b8c2ab9345$var$Promise = $lBvnk.Promise;

var $khkpJ = parcelRequire("khkpJ");
var $662602b8c2ab9345$var$isIterable = $khkpJ.isIterable, $662602b8c2ab9345$var$isNodeStream = $khkpJ.isNodeStream, $662602b8c2ab9345$var$isWebStream = $khkpJ.isWebStream;

var $hC1T5 = parcelRequire("hC1T5");
var $662602b8c2ab9345$var$pl = $hC1T5.pipelineImpl;

var $1Jum0 = parcelRequire("1Jum0");
var $662602b8c2ab9345$require$finished = $1Jum0.finished;
parcelRequire("20TSl");
function $662602b8c2ab9345$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $662602b8c2ab9345$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$662602b8c2ab9345$var$isNodeStream(lastArg) && !$662602b8c2ab9345$var$isIterable(lastArg) && !$662602b8c2ab9345$var$isWebStream(lastArg)) {
            var options = $662602b8c2ab9345$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $662602b8c2ab9345$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $662602b8c2ab9345$require$finished,
    pipeline: $662602b8c2ab9345$var$pipeline
};

});



parcelRegister("bfxWp", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatedLinkedRdfSourcesAsyncRdfIterator = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $2D5Bj = parcelRequire("2D5Bj");
/**
 * An quad iterator that can iterate over consecutive RDF sources
 * that are determined using the rdf-resolve-hypermedia-links bus.
 *
 * @see LinkedRdfSourcesAsyncRdfIterator
 */ var $830b6c6eabcc37ee$var$MediatedLinkedRdfSourcesAsyncRdfIterator = /*#__PURE__*/ function(_LinkedRdfSourcesAsyncRdfIterator_1_LinkedRdfSourcesAsyncRdfIterator) {
    (0, $i3fW3._)(MediatedLinkedRdfSourcesAsyncRdfIterator, _LinkedRdfSourcesAsyncRdfIterator_1_LinkedRdfSourcesAsyncRdfIterator);
    function MediatedLinkedRdfSourcesAsyncRdfIterator(cacheSize, operation, queryBindingsOptions, context, forceSourceType, firstUrl, maxIterators, sourceStateGetter, aggregatedStore, mediatorMetadataAccumulate, mediatorRdfResolveHypermediaLinks, mediatorRdfResolveHypermediaLinksQueue, dataFactory, algebraFactory) {
        (0, $jGAMp._)(this, MediatedLinkedRdfSourcesAsyncRdfIterator);
        var _this;
        _this = (0, $kzDuW._)(this, MediatedLinkedRdfSourcesAsyncRdfIterator, [
            cacheSize,
            operation,
            queryBindingsOptions,
            context,
            firstUrl,
            maxIterators,
            sourceStateGetter,
            // Buffersize must be infinite for an aggregated store because it must keep filling until there are no more
            // derived iterators in the aggregated store.
            aggregatedStore ? {
                maxBufferSize: Number.POSITIVE_INFINITY
            } : undefined
        ]);
        _this.wasForcefullyClosed = false;
        _this.forceSourceType = forceSourceType;
        _this.mediatorMetadataAccumulate = mediatorMetadataAccumulate;
        _this.mediatorRdfResolveHypermediaLinks = mediatorRdfResolveHypermediaLinks;
        _this.mediatorRdfResolveHypermediaLinksQueue = mediatorRdfResolveHypermediaLinksQueue;
        _this.handledUrls = (0, $cqEAj._)({}, firstUrl, true);
        _this.aggregatedStore = aggregatedStore;
        _this.dataFactory = dataFactory;
        _this.algebraFactory = algebraFactory;
        return _this;
    }
    (0, $byiyg._)(MediatedLinkedRdfSourcesAsyncRdfIterator, [
        {
            // Mark the aggregated store as ended once we trigger the closing or destroying of this iterator.
            // We don't override _end, because that would mean that we have to wait
            // until the buffer of this iterator must be fully consumed, which will not always be the case.
            key: "close",
            value: function close() {
                var _this = this;
                if (!this.aggregatedStore) {
                    (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "close", this).call(this);
                    return;
                }
                this.getLinkQueue().then(function(linkQueue) {
                    if (_this.isCloseable(linkQueue, false)) {
                        // Wait a tick before ending the aggregatedStore, to ensure that pending match() calls to it have started.
                        if (_this.aggregatedStore) setTimeout(function() {
                            return _this.aggregatedStore.end();
                        });
                        (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "close", _this).call(_this);
                    } else _this.wasForcefullyClosed = true;
                })["catch"](function(error) {
                    return (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "destroy", _this).call(_this, error);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy(cause) {
                var _this = this;
                if (!this.aggregatedStore) {
                    (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "destroy", this).call(this, cause);
                    return;
                }
                this.getLinkQueue().then(function(linkQueue) {
                    if (cause !== null && cause !== void 0 ? cause : _this.isCloseable(linkQueue, false)) {
                        // Wait a tick before ending the aggregatedStore, to ensure that pending match() calls to it have started.
                        if (_this.aggregatedStore) setTimeout(function() {
                            return _this.aggregatedStore.end();
                        });
                        (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "destroy", _this).call(_this, cause);
                    } else _this.wasForcefullyClosed = true;
                })["catch"](function(error) {
                    return (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "destroy", _this).call(_this, error);
                });
            }
        },
        {
            key: "isCloseable",
            value: function isCloseable(linkQueue, requireQueueEmpty) {
                return (requireQueueEmpty ? linkQueue.isEmpty() : this.wasForcefullyClosed || linkQueue.isEmpty()) && !this.areIteratorsRunning();
            }
        },
        {
            key: "canStartNewIterator",
            value: function canStartNewIterator() {
                // Also allow sub-iterators to be started if the aggregated store has at least one running iterator.
                // We need this because there are cases where these running iterators will be consumed before this linked iterator.
                return !this.wasForcefullyClosed && // eslint-disable-next-line ts/prefer-nullish-coalescing
                this.aggregatedStore && this.aggregatedStore.hasRunningIterators() || (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "canStartNewIterator", this).call(this);
            }
        },
        {
            key: "canStartNewIteratorConsiderReadable",
            value: function canStartNewIteratorConsiderReadable() {
                return !this.aggregatedStore;
            }
        },
        {
            key: "isRunning",
            value: function isRunning() {
                // Same as above
                // eslint-disable-next-line ts/prefer-nullish-coalescing
                return this.aggregatedStore && this.aggregatedStore.hasRunningIterators() || !this.done;
            }
        },
        {
            key: "getLinkQueue",
            value: function getLinkQueue() {
                if (!this.linkQueue) this.linkQueue = this.mediatorRdfResolveHypermediaLinksQueue.mediate({
                    firstUrl: this.firstUrl,
                    context: this.context
                }).then(function(result) {
                    return result.linkQueue;
                });
                return this.linkQueue;
            }
        },
        {
            key: "getSourceLinks",
            value: function getSourceLinks(metadata, startSource) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, links, traversalTracker, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, link, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.mediatorRdfResolveHypermediaLinks.mediate({
                                        context: this.context,
                                        metadata: metadata
                                    })
                                ];
                            case 2:
                                links = _state.sent().links;
                                // Update discovery event statistic if available
                                traversalTracker = this.context.get($9nBhR.KeysStatistics.discoveredLinks);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (traversalTracker) try {
                                    for(_iterator = links[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        link = _step.value;
                                        traversalTracker.updateStatistic({
                                            url: link.url,
                                            metadata: (0, $iT0je._)({}, link.metadata)
                                        }, startSource.link);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                // Filter URLs to avoid cyclic next-page loops
                                return [
                                    2,
                                    links.filter(function(link) {
                                        if (_this.handledUrls[link.url]) return false;
                                        _this.handledUrls[link.url] = true;
                                        return true;
                                    })
                                ];
                            case 3:
                                e = _state.sent();
                                // No next URLs may be available, for example when we've reached the end of a Hydra next-page sequence.
                                return [
                                    2,
                                    []
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "startIterator",
            value: function startIterator(startSource) {
                var _this = this;
                if (this.aggregatedStore && !this.aggregatedStore.containedSources.has(startSource.link.url)) {
                    var // A source that has been cached due to earlier query executions may not be part of the aggregated store yet.
                    // In that case, we add all quads from that source to the aggregated store.
                    _this_aggregatedStore;
                    (_this_aggregatedStore = this.aggregatedStore) === null || _this_aggregatedStore === void 0 ? void 0 : _this_aggregatedStore.containedSources.add(startSource.link.url);
                    var stream = startSource.source.queryBindings(this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g')), this.context.set($9nBhR.KeysQueryOperation.unionDefaultGraph, true)).map(function(bindings) {
                        return _this.dataFactory.quad(bindings.get('s'), bindings.get('p'), bindings.get('o'), bindings.get('g'));
                    });
                    this.aggregatedStore["import"](stream).on('end', function() {
                        (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "startIterator", _this).call(_this, startSource);
                    });
                } else (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "startIterator", this).call(this, startSource);
            }
        },
        {
            key: "accumulateMetadata",
            value: function accumulateMetadata(accumulatedMetadata, appendingMetadata) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorMetadataAccumulate.mediate({
                                        mode: 'append',
                                        accumulatedMetadata: accumulatedMetadata,
                                        appendingMetadata: appendingMetadata,
                                        context: this.context
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().metadata
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateMetadata",
            value: function updateMetadata(metadataNew) {
                var _this_aggregatedStore;
                (0, $fXhL4._)((0, $hxFDX._)(MediatedLinkedRdfSourcesAsyncRdfIterator.prototype), "updateMetadata", this).call(this, metadataNew);
                (_this_aggregatedStore = this.aggregatedStore) === null || _this_aggregatedStore === void 0 ? void 0 : _this_aggregatedStore.setBaseMetadata(metadataNew, true);
            }
        }
    ]);
    return MediatedLinkedRdfSourcesAsyncRdfIterator;
}($2D5Bj.LinkedRdfSourcesAsyncRdfIterator);
module.exports.MediatedLinkedRdfSourcesAsyncRdfIterator = $830b6c6eabcc37ee$var$MediatedLinkedRdfSourcesAsyncRdfIterator;

});
parcelRegister("2D5Bj", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkedRdfSourcesAsyncRdfIterator = void 0;

var $9nBhR = parcelRequire("9nBhR");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");
var $1ea3917a0b958d21$var$LinkedRdfSourcesAsyncRdfIterator = /*#__PURE__*/ function(_asynciterator_1_BufferedIterator) {
    (0, $i3fW3._)(LinkedRdfSourcesAsyncRdfIterator, _asynciterator_1_BufferedIterator);
    function LinkedRdfSourcesAsyncRdfIterator(cacheSize, operation, queryBindingsOptions, context, firstUrl, maxIterators, sourceStateGetter, options) {
        (0, $jGAMp._)(this, LinkedRdfSourcesAsyncRdfIterator);
        var _this;
        _this = (0, $kzDuW._)(this, LinkedRdfSourcesAsyncRdfIterator, [
            (0, $iT0je._)({
                autoStart: false
            }, options)
        ]);
        _this.started = false;
        _this.currentIterators = [];
        _this.iteratorsPendingCreation = 0;
        _this.iteratorsPendingTermination = 0;
        // eslint-disable-next-line unicorn/no-useless-undefined
        _this.accumulatedMetadata = Promise.resolve(undefined);
        _this._reading = false;
        _this.cacheSize = cacheSize;
        _this.operation = operation;
        _this.queryBindingsOptions = queryBindingsOptions;
        _this.context = context;
        _this.firstUrl = firstUrl;
        _this.maxIterators = maxIterators;
        _this.sourceStateGetter = sourceStateGetter;
        if (_this.maxIterators <= 0) throw new Error("LinkedRdfSourcesAsyncRdfIterator.maxIterators must be larger than zero, but got ".concat(_this.maxIterators));
        return _this;
    }
    (0, $byiyg._)(LinkedRdfSourcesAsyncRdfIterator, [
        {
            /**
     * Start filling the buffer of this iterator.
     */ key: "kickstart",
            value: function kickstart() {
                if (!this.started) this._fillBufferAsync();
            }
        },
        {
            key: "getProperty",
            value: function getProperty(propertyName, callback) {
                var _this = this;
                if (propertyName === 'metadata' && !this.started) {
                    // If the iterator has not started yet, forcefully fetch the metadata from the source without starting the
                    // iterator. This way, we keep the iterator lazy.
                    if (!this.preflightMetadata) this.preflightMetadata = new Promise(function(resolve, reject) {
                        _this.sourceStateGetter({
                            url: _this.firstUrl
                        }, {}).then(function(sourceState) {
                            // Don't pass query options, as we don't want to consume any passed iterators
                            var bindingsStream = sourceState.source.queryBindings(_this.operation, _this.context);
                            bindingsStream.getProperty('metadata', function(metadata) {
                                metadata.state = new $jZbVy.MetadataValidationState();
                                bindingsStream.destroy();
                                _this.accumulateMetadata(sourceState.metadata, metadata).then(function(accumulatedMetadata) {
                                    // Also merge fields that were not explicitly accumulated
                                    var returnMetadata = (0, $iT0je._)({}, sourceState.metadata, metadata, accumulatedMetadata);
                                    resolve(returnMetadata);
                                })["catch"](function() {
                                    resolve((0, $emQHU._)((0, $iT0je._)({}, sourceState.metadata), {
                                        state: new $jZbVy.MetadataValidationState()
                                    }));
                                });
                            });
                        })["catch"](reject);
                    });
                    this.preflightMetadata.then(function(metadata) {
                        return _this.setProperty('metadata', metadata);
                    })["catch"](function(e) {
                        return _this.emit('error', e);
                    });
                }
                return (0, $fXhL4._)((0, $hxFDX._)(LinkedRdfSourcesAsyncRdfIterator.prototype), "getProperty", this).call(this, propertyName, callback);
            }
        },
        {
            key: "_end",
            value: function _end(destroy) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Close all running iterators
                    for(var _iterator = this.currentIterators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var it = _step.value;
                        it.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                (0, $fXhL4._)((0, $hxFDX._)(LinkedRdfSourcesAsyncRdfIterator.prototype), "_end", this).call(this, destroy);
            }
        },
        {
            key: "_read",
            value: function _read(count, done) {
                var _this = this;
                if (this.started) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Read from all current iterators
                        for(var _iterator = this.currentIterators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var iterator = _step.value;
                            while(count > 0){
                                var read = iterator.read();
                                if (read === null) break;
                                else {
                                    count--;
                                    this._push(read);
                                }
                            }
                            if (count <= 0) break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Schedule new iterators if needed
                    if (count >= 0 && this.canStartNewIterator()) // We can safely ignore skip catching the error, since we are guaranteed to have
                    // successfully got the source for this.firstUrl before.
                    // eslint-disable-next-line ts/no-floating-promises
                    this.sourceStateGetter({
                        url: this.firstUrl
                    }, {}).then(function(sourceState) {
                        _this.startIteratorsForNextUrls(sourceState.handledDatasets, false);
                        done();
                    });
                    else done();
                } else {
                    // The first time this is called, prepare the first source
                    this.started = true;
                    // Await the source to be set, and start the source iterator
                    this.sourceStateGetter({
                        url: this.firstUrl
                    }, {}).then(function(sourceState) {
                        _this.startIterator(sourceState);
                        done();
                    })["catch"](function(error) {
                        return setTimeout(function() {
                            return _this.destroy(error);
                        });
                    });
                }
            }
        },
        {
            key: "canStartNewIterator",
            value: function canStartNewIterator() {
                return this.currentIterators.length + this.iteratorsPendingCreation + this.iteratorsPendingTermination < this.maxIterators && (!this.canStartNewIteratorConsiderReadable() || !this.readable);
            }
        },
        {
            key: "canStartNewIteratorConsiderReadable",
            value: function canStartNewIteratorConsiderReadable() {
                return true;
            }
        },
        {
            key: "areIteratorsRunning",
            value: function areIteratorsRunning() {
                return this.currentIterators.length + this.iteratorsPendingCreation + this.iteratorsPendingTermination > 0;
            }
        },
        {
            /**
     * Start a new iterator for the given source.
     * Once the iterator is done, it will either determine a new source, or it will close the linked iterator.
     * @param {ISourceState} startSource The start source state.
     */ key: "startIterator",
            value: function startIterator(startSource) {
                var _this = this;
                // Delegate the quad pattern query to the given source
                try {
                    var iterator = startSource.source.queryBindings(this.operation, this.context, this.queryBindingsOptions);
                    this.currentIterators.push(iterator);
                    var receivedEndEvent = false;
                    var receivedMetadata = false;
                    // Attach readers to the newly created iterator
                    iterator._destination = this;
                    iterator.on('error', function(error) {
                        return _this.destroy(error);
                    });
                    iterator.on('readable', function() {
                        return _this._fillBuffer();
                    });
                    iterator.on('end', function() {
                        _this.currentIterators.splice(_this.currentIterators.indexOf(iterator), 1);
                        // Indicate that this iterator still needs to flush its next-links.
                        // Without this, the linked iterator could sometimes be closed before next-links are obtained.
                        receivedEndEvent = true;
                        if (!receivedMetadata) _this.iteratorsPendingTermination++;
                        // If the metadata was already received, handle the next URL in the queue
                        if (receivedMetadata) _this.startIteratorsForNextUrls(startSource.handledDatasets, true);
                    });
                    // Listen for the metadata of the source
                    // The metadata property is guaranteed to be set
                    iterator.getProperty('metadata', function(metadata) {
                        // Accumulate the metadata object
                        _this.accumulatedMetadata = _this.accumulatedMetadata.then(function(previousMetadata) {
                            return (function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        if (!previousMetadata) previousMetadata = startSource.metadata;
                                        return [
                                            2,
                                            this.accumulateMetadata(previousMetadata, metadata)
                                        ];
                                    });
                                }).call(_this);
                            })().then(function(accumulatedMetadata) {
                                // Also merge fields that were not explicitly accumulated
                                var returnMetadata = (0, $iT0je._)({}, startSource.metadata, metadata, accumulatedMetadata);
                                // Create new metadata state
                                returnMetadata.state = new $jZbVy.MetadataValidationState();
                                // Emit metadata, and invalidate any metadata that was set before
                                _this.updateMetadata(returnMetadata);
                                // Invalidate any preflight metadata
                                if (_this.preflightMetadata) _this.preflightMetadata.then(function(metadataIn) {
                                    return metadataIn.state.invalidate();
                                })["catch"](function() {
                                // Ignore errors
                                });
                                // Determine next urls, which will eventually become a next-next source.
                                _this.getSourceLinks(returnMetadata, startSource).then(function(nextUrls) {
                                    return Promise.all(nextUrls);
                                }).then(function(nextUrls) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var linkQueue, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, nextUrl;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        this.getLinkQueue()
                                                    ];
                                                case 1:
                                                    linkQueue = _state.sent();
                                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                    try {
                                                        for(_iterator = nextUrls[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                            nextUrl = _step.value;
                                                            linkQueue.push(nextUrl, startSource.link);
                                                        }
                                                    } catch (err) {
                                                        _didIteratorError = true;
                                                        _iteratorError = err;
                                                    } finally{
                                                        try {
                                                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                                                _iterator["return"]();
                                                            }
                                                        } finally{
                                                            if (_didIteratorError) {
                                                                throw _iteratorError;
                                                            }
                                                        }
                                                    }
                                                    receivedMetadata = true;
                                                    if (receivedEndEvent) this.iteratorsPendingTermination--;
                                                    this.startIteratorsForNextUrls(startSource.handledDatasets, true);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                })["catch"](function(error) {
                                    return _this.destroy(error);
                                });
                                return returnMetadata;
                            });
                        })["catch"](function(error) {
                            _this.destroy(error);
                            return {};
                        });
                    });
                } catch (syncError) {
                    this.destroy(syncError);
                }
            }
        },
        {
            key: "updateMetadata",
            value: function updateMetadata(metadataNew) {
                var metadataToInvalidate = this.getProperty('metadata');
                this.setProperty('metadata', metadataNew);
                metadataToInvalidate === null || metadataToInvalidate === void 0 ? void 0 : metadataToInvalidate.state.invalidate();
            }
        },
        {
            key: "isRunning",
            value: function isRunning() {
                return !this.done;
            }
        },
        {
            /**
     * Check if a next URL is in the queue.
     * If yes, start a new iterator.
     * If no, close this iterator.
     * @param handledDatasets
     * @param canClose
     */ key: "startIteratorsForNextUrls",
            value: function startIteratorsForNextUrls(handledDatasets, canClose) {
                var _this = this;
                this.getLinkQueue().then(function(linkQueue) {
                    // Create as many new iterators as possible
                    while(_this.canStartNewIterator() && _this.isRunning()){
                        var nextLink = linkQueue.pop();
                        if (nextLink) {
                            _this.iteratorsPendingCreation++;
                            _this.sourceStateGetter(nextLink, handledDatasets).then(function(nextSourceState) {
                                // If we find a statistic tracking dereference events we emit the relevant data
                                var statisticDereferenceLinks = _this.context.get($9nBhR.KeysStatistics.dereferencedLinks);
                                if (statisticDereferenceLinks) statisticDereferenceLinks.updateStatistic({
                                    url: nextSourceState.link.url,
                                    metadata: (0, $iT0je._)({}, nextSourceState.metadata, nextSourceState.link.metadata)
                                }, nextSourceState.source);
                                _this.iteratorsPendingCreation--;
                                _this.startIterator(nextSourceState);
                            })["catch"](function(error) {
                                return _this.emit('error', error);
                            });
                        } else break;
                    }
                    // Close, only if no other iterators are still running
                    if (canClose && _this.isCloseable(linkQueue, true)) _this.close();
                })["catch"](function(error) {
                    return _this.destroy(error);
                });
            }
        },
        {
            key: "isCloseable",
            value: function isCloseable(linkQueue, _requireQueueEmpty) {
                return linkQueue.isEmpty() && !this.areIteratorsRunning();
            }
        }
    ]);
    return LinkedRdfSourcesAsyncRdfIterator;
}($aafx9.BufferedIterator);
module.exports.LinkedRdfSourcesAsyncRdfIterator = $1ea3917a0b958d21$var$LinkedRdfSourcesAsyncRdfIterator;

});


parcelRegister("9xl7d", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingStoreMetadata = void 0;

var $kQuvF = parcelRequire("kQuvF");

var $jZbVy = parcelRequire("jZbVy");

var $2N5kn = parcelRequire("2N5kn");
/**
 * A StreamingStore that returns an AsyncIterator with a valid MetadataQuads property.
 */ var $6f179338ae264473$var$StreamingStoreMetadata = /*#__PURE__*/ function(_rdf_streaming_store_1_StreamingStore) {
    (0, $i3fW3._)(StreamingStoreMetadata, _rdf_streaming_store_1_StreamingStore);
    function StreamingStoreMetadata(store, metadataAccumulator) {
        (0, $jGAMp._)(this, StreamingStoreMetadata);
        var _this;
        _this = (0, $kzDuW._)(this, StreamingStoreMetadata, [
            store
        ]);
        _this.started = false;
        _this.containedSources = new Set();
        _this.runningIterators = new Set();
        _this.iteratorCreatedListeners = new Set();
        _this.baseMetadata = {
            state: new $jZbVy.MetadataValidationState(),
            cardinality: {
                type: 'exact',
                value: 0
            },
            variables: []
        };
        _this.metadataAccumulator = metadataAccumulator;
        return _this;
    }
    (0, $byiyg._)(StreamingStoreMetadata, [
        {
            key: "import",
            value: function _import(stream) {
                if (!this.ended) (0, $fXhL4._)((0, $hxFDX._)(StreamingStoreMetadata.prototype), "import", this).call(this, stream);
                return stream;
            }
        },
        {
            key: "hasRunningIterators",
            value: function hasRunningIterators() {
                return this.runningIterators.size > 0;
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                var _this = this;
                // Wrap the raw stream in an AsyncIterator
                var rawStream = (0, $fXhL4._)((0, $hxFDX._)(StreamingStoreMetadata.prototype), "match", this).call(this, subject, predicate, object, graph);
                var iterator = new $kQuvF.ClosableTransformIterator(rawStream, {
                    autoStart: false,
                    onClose: function() {
                        // Running iterators are deleted once closed or destroyed
                        _this.runningIterators["delete"](iterator);
                    }
                });
                // Expose the metadata property containing the cardinality
                var count = this.getStore().countQuads(subject, predicate, object, graph);
                var metadata = {
                    state: new $jZbVy.MetadataValidationState(),
                    cardinality: {
                        type: 'estimate',
                        value: count
                    }
                };
                iterator.setProperty('metadata', metadata);
                iterator.setProperty('lastCount', count);
                // Every time a new quad is pushed into the iterator, update the metadata
                rawStream.on('quad', function() {
                    iterator.setProperty('lastCount', ++count);
                    _this.updateMetadataState(iterator, count);
                });
                // Store all running iterators until they close or are destroyed
                this.runningIterators.add(iterator);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Invoke creation listeners
                    for(var _iterator = this.iteratorCreatedListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return iterator;
            }
        },
        {
            key: "setBaseMetadata",
            value: function setBaseMetadata(metadata, updateStates) {
                this.baseMetadata = (0, $iT0je._)({}, metadata);
                this.baseMetadata.cardinality = {
                    type: 'exact',
                    value: 0
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (updateStates) try {
                    for(var _iterator = this.runningIterators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var iterator = _step.value;
                        var count = iterator.getProperty('lastCount');
                        this.updateMetadataState(iterator, count);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "updateMetadataState",
            value: function updateMetadataState(iterator, count) {
                // Append the given cardinality to the base metadata
                var metadataNew = {
                    state: new $jZbVy.MetadataValidationState(),
                    cardinality: {
                        type: 'estimate',
                        value: count
                    },
                    variables: []
                };
                this.metadataAccumulator(this.baseMetadata, metadataNew).then(function(accumulatedMetadata) {
                    accumulatedMetadata.state = new $jZbVy.MetadataValidationState();
                    // Set the new metadata, and invalidate the previous state
                    var metadataToInvalidate = iterator.getProperty('metadata');
                    iterator.setProperty('metadata', accumulatedMetadata);
                    metadataToInvalidate === null || metadataToInvalidate === void 0 ? void 0 : metadataToInvalidate.state.invalidate();
                })["catch"](function() {
                // Void errors
                });
            }
        },
        {
            key: "addIteratorCreatedListener",
            value: function addIteratorCreatedListener(listener) {
                this.iteratorCreatedListeners.add(listener);
            }
        },
        {
            key: "removeIteratorCreatedListener",
            value: function removeIteratorCreatedListener(listener) {
                this.iteratorCreatedListeners["delete"](listener);
            }
        }
    ]);
    return StreamingStoreMetadata;
}($2N5kn.StreamingStore);
module.exports.StreamingStoreMetadata = $6f179338ae264473$var$StreamingStoreMetadata;

});
parcelRegister("2N5kn", function(module, exports) {
"use strict";
var $20844a56629bd2ca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $20844a56629bd2ca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $20844a56629bd2ca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$20844a56629bd2ca$var$__exportStar((parcelRequire("hAd2u")), module.exports);

$20844a56629bd2ca$var$__exportStar((parcelRequire("kJQ6J")), module.exports);

});
parcelRegister("hAd2u", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingStreamsIndex = void 0;

var $lhX5B = parcelRequire("lhX5B");

var $bGEF0 = parcelRequire("bGEF0");
/**
 * A PendingStreamsIndex stores pending streams indexed by the quad pattern they have been created for.
 */ var $cccfe9caa0ca9463$var$PendingStreamsIndex = /*#__PURE__*/ function() {
    function PendingStreamsIndex() {
        (0, $jGAMp._)(this, PendingStreamsIndex);
        this.indexedStreams = new Map();
        this.allStreams = [];
    }
    (0, $byiyg._)(PendingStreamsIndex, [
        {
            key: "termToString",
            value: function termToString(term) {
                return term && term.termType !== 'Variable' ? (0, $lhX5B.termToString)(term) : PendingStreamsIndex.ID_VARIABLE;
            }
        },
        {
            /**
     * Add a new pending stream for the given quad pattern.
     * @param pendingStream A pending stream.
     * @param subject A term.
     * @param predicate A term.
     * @param object A term.
     * @param graph A term.
     */ key: "addPatternListener",
            value: function addPatternListener(pendingStream, subject, predicate, object, graph) {
                // Append to list of pendingStreams
                this.allStreams.push(pendingStream);
                // Append to index of pendingStreams
                var key = "".concat(this.termToString(subject)).concat(PendingStreamsIndex.ID_SEPARATOR).concat(this.termToString(predicate)).concat(PendingStreamsIndex.ID_SEPARATOR).concat(this.termToString(object)).concat(PendingStreamsIndex.ID_SEPARATOR).concat(this.termToString(graph));
                var existingListeners = this.indexedStreams.get(key);
                if (!existingListeners) {
                    existingListeners = [];
                    this.indexedStreams.set(key, existingListeners);
                }
                existingListeners.push(pendingStream);
            }
        },
        {
            /**
     * Find all the pending streams from which their quad pattern match the given quad.
     * @param quad The quad to match patterns to.
     */ key: "getPendingStreamsForQuad",
            value: function getPendingStreamsForQuad(quad) {
                // Determine the combinations of quad patterns to look up
                var keys = [
                    (0, $bGEF0.getTerms)(quad).map(function(term) {
                        return (0, $lhX5B.termToString)(term);
                    })
                ];
                for(var i = 0; i < $bGEF0.QUAD_TERM_NAMES.length; i++){
                    var keysOld = keys;
                    keys = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = keysOld[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            keys.push(key);
                            var keyModified = (0, $7WNf6._)(key);
                            keyModified[i] = PendingStreamsIndex.ID_VARIABLE;
                            keys.push(keyModified);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // Fetch the pendingStreams for the quad pattern combinations
                var pendingStreams = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var key1 = _step1.value;
                        var _pendingStreams;
                        var found = this.indexedStreams.get(key1.join(PendingStreamsIndex.ID_SEPARATOR));
                        if (found) (_pendingStreams = pendingStreams).push.apply(_pendingStreams, (0, $7WNf6._)(found));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return pendingStreams;
            }
        }
    ]);
    return PendingStreamsIndex;
}();
$cccfe9caa0ca9463$var$PendingStreamsIndex.ID_VARIABLE = '?';
$cccfe9caa0ca9463$var$PendingStreamsIndex.ID_SEPARATOR = ':';
module.exports.PendingStreamsIndex = $cccfe9caa0ca9463$var$PendingStreamsIndex;

});
parcelRegister("lhX5B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $99LyL = parcelRequire("99LyL");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function get() {
        return $99LyL.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function get() {
        return $99LyL.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function get() {
        return $99LyL.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function get() {
        return $99LyL.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function get() {
        return $99LyL.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function get() {
        return $99LyL.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function get() {
        return $99LyL.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function get() {
        return $99LyL.termToString;
    }
});

});
parcelRegister("99LyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $6aa9d8b154286e6e$var$termToString;
module.exports.getLiteralValue = $6aa9d8b154286e6e$var$getLiteralValue;
module.exports.getLiteralType = $6aa9d8b154286e6e$var$getLiteralType;
module.exports.getLiteralLanguage = $6aa9d8b154286e6e$var$getLiteralLanguage;
module.exports.getLiteralDirection = $6aa9d8b154286e6e$var$getLiteralDirection;
module.exports.stringToTerm = $6aa9d8b154286e6e$var$stringToTerm;
module.exports.quadToStringQuad = $6aa9d8b154286e6e$var$quadToStringQuad;
module.exports.stringQuadToQuad = $6aa9d8b154286e6e$var$stringQuadToQuad;

var $1lgsf = parcelRequire("1lgsf");
var $6aa9d8b154286e6e$var$FACTORY = new $1lgsf.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $6aa9d8b154286e6e$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            var literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return "<<".concat($6aa9d8b154286e6e$var$termToString(term.subject), " ").concat($6aa9d8b154286e6e$var$termToString(term.predicate), " ").concat($6aa9d8b154286e6e$var$termToString(term.object)).concat(term.graph.termType === 'DefaultGraph' ? '' : ' ' + $6aa9d8b154286e6e$var$termToString(term.graph), ">>");
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $6aa9d8b154286e6e$var$getLiteralValue(literalValue) {
    var match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $6aa9d8b154286e6e$var$getLiteralType(literalValue) {
    var match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $6aa9d8b154286e6e$var$getLiteralLanguage(literalValue) {
    var match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        var ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        var doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $6aa9d8b154286e6e$var$getLiteralDirection(literalValue) {
    var doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        var direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $6aa9d8b154286e6e$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $6aa9d8b154286e6e$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error("Missing 'variable()' method on the given DataFactory");
            return dataFactory.variable(value.substr(1));
        case '"':
            var language = $6aa9d8b154286e6e$var$getLiteralLanguage(value);
            var direction = $6aa9d8b154286e6e$var$getLiteralDirection(value);
            var type = dataFactory.namedNode($6aa9d8b154286e6e$var$getLiteralType(value));
            return dataFactory.literal($6aa9d8b154286e6e$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                var terms = value.slice(2, -2).trim();
                var stringTerms = [];
                var ignoreTags = 0;
                var lastIndex = 0;
                var inQuote = false;
                for(var i = 0; i < terms.length; i++){
                    var _char = terms[i];
                    if (_char === '<') ignoreTags++;
                    if (_char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (_char === '"') {
                        var escaped = false;
                        var j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (_char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map(function(term) {
                    return term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term;
                });
                return dataFactory.quad($6aa9d8b154286e6e$var$stringToTerm(stringTerms[0]), $6aa9d8b154286e6e$var$stringToTerm(stringTerms[1]), $6aa9d8b154286e6e$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $6aa9d8b154286e6e$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $6aa9d8b154286e6e$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $6aa9d8b154286e6e$var$termToString(q.subject),
        predicate: $6aa9d8b154286e6e$var$termToString(q.predicate),
        object: $6aa9d8b154286e6e$var$termToString(q.object),
        graph: $6aa9d8b154286e6e$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $6aa9d8b154286e6e$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $6aa9d8b154286e6e$var$FACTORY;
    return dataFactory.quad($6aa9d8b154286e6e$var$stringToTerm(stringQuad.subject, dataFactory), $6aa9d8b154286e6e$var$stringToTerm(stringQuad.predicate, dataFactory), $6aa9d8b154286e6e$var$stringToTerm(stringQuad.object, dataFactory), $6aa9d8b154286e6e$var$stringToTerm(stringQuad.graph, dataFactory));
}

});
parcelRegister("1lgsf", function(module, exports) {
"use strict";
var $0fa48420b46c3ca3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0fa48420b46c3ca3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0fa48420b46c3ca3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("3xrVj")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("bY0y4")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("bwtzJ")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("wetiH")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("mrFd7")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("eUn5a")), module.exports);

$0fa48420b46c3ca3$var$__exportStar((parcelRequire("3e6Ge")), module.exports);

});
parcelRegister("3xrVj", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ var $293a1d2c24923713$var$BlankNode = /*#__PURE__*/ function() {
    function BlankNode(value) {
        (0, $jGAMp._)(this, BlankNode);
        this.termType = 'BlankNode';
        this.value = value;
    }
    (0, $byiyg._)(BlankNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'BlankNode' && other.value === this.value;
            }
        }
    ]);
    return BlankNode;
}();
module.exports.BlankNode = $293a1d2c24923713$var$BlankNode;

});

parcelRegister("bY0y4", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $3xrVj = parcelRequire("3xrVj");

var $bwtzJ = parcelRequire("bwtzJ");

var $wetiH = parcelRequire("wetiH");

var $mrFd7 = parcelRequire("mrFd7");

var $eUn5a = parcelRequire("eUn5a");

var $3e6Ge = parcelRequire("3e6Ge");
var $8b65b93b6f5c14c7$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ var $8b65b93b6f5c14c7$var$DataFactory = /*#__PURE__*/ function() {
    function DataFactory(options) {
        (0, $jGAMp._)(this, DataFactory);
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || "df_".concat($8b65b93b6f5c14c7$var$dataFactoryCounter++, "_");
    }
    (0, $byiyg._)(DataFactory, [
        {
            /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ key: "namedNode",
            value: function namedNode(value) {
                return new $mrFd7.NamedNode(value);
            }
        },
        {
            /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ key: "blankNode",
            value: function blankNode(value) {
                return new $3xrVj.BlankNode(value || "".concat(this.blankNodePrefix).concat(this.blankNodeCounter++));
            }
        },
        {
            /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ key: "literal",
            value: function literal(value, languageOrDatatype) {
                return new $wetiH.Literal(value, languageOrDatatype);
            }
        },
        {
            /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ key: "variable",
            value: function variable(value) {
                return new $3e6Ge.Variable(value);
            }
        },
        {
            /**
     * @return An instance of DefaultGraph.
     */ key: "defaultGraph",
            value: function defaultGraph() {
                return $bwtzJ.DefaultGraph.INSTANCE;
            }
        },
        {
            /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ key: "quad",
            value: function quad(subject, predicate, object, graph) {
                return new $eUn5a.Quad(subject, predicate, object, graph || this.defaultGraph());
            }
        },
        {
            /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ key: "fromTerm",
            value: function fromTerm(original) {
                // TODO: remove nasty any casts when this TS bug has been fixed:
                //  https://github.com/microsoft/TypeScript/issues/26933
                switch(original.termType){
                    case 'NamedNode':
                        return this.namedNode(original.value);
                    case 'BlankNode':
                        return this.blankNode(original.value);
                    case 'Literal':
                        if (original.language) return this.literal(original.value, original.language);
                        if (!original.datatype.equals($wetiH.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                        return this.literal(original.value);
                    case 'Variable':
                        return this.variable(original.value);
                    case 'DefaultGraph':
                        return this.defaultGraph();
                    case 'Quad':
                        return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
                }
            }
        },
        {
            /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ key: "fromQuad",
            value: function fromQuad(original) {
                return this.fromTerm(original);
            }
        },
        {
            /**
     * Reset the internal blank node counter.
     */ key: "resetBlankNodeCounter",
            value: function resetBlankNodeCounter() {
                this.blankNodeCounter = 0;
            }
        }
    ]);
    return DataFactory;
}();
module.exports.DataFactory = $8b65b93b6f5c14c7$var$DataFactory;

});
parcelRegister("bwtzJ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $86399feaa1ee90ca$var$DefaultGraph = /*#__PURE__*/ function() {
    function DefaultGraph() {
        (0, $jGAMp._)(this, DefaultGraph);
        this.termType = 'DefaultGraph';
        this.value = '';
    }
    (0, $byiyg._)(DefaultGraph, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'DefaultGraph';
            }
        }
    ]);
    return DefaultGraph;
}();
module.exports.DefaultGraph = $86399feaa1ee90ca$var$DefaultGraph;
$86399feaa1ee90ca$var$DefaultGraph.INSTANCE = new $86399feaa1ee90ca$var$DefaultGraph();

});

parcelRegister("wetiH", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $mrFd7 = parcelRequire("mrFd7");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ var $060e3707a03722d8$var$Literal = /*#__PURE__*/ function() {
    function Literal(value, languageOrDatatype) {
        (0, $jGAMp._)(this, Literal);
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = Literal.XSD_STRING;
            this.direction = '';
        }
    }
    (0, $byiyg._)(Literal, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
            }
        }
    ]);
    return Literal;
}();
module.exports.Literal = $060e3707a03722d8$var$Literal;
$060e3707a03722d8$var$Literal.RDF_LANGUAGE_STRING = new $mrFd7.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$060e3707a03722d8$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $mrFd7.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$060e3707a03722d8$var$Literal.XSD_STRING = new $mrFd7.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("mrFd7", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ var $0437839ef4d754fb$var$NamedNode = /*#__PURE__*/ function() {
    function NamedNode(value) {
        (0, $jGAMp._)(this, NamedNode);
        this.termType = 'NamedNode';
        this.value = value;
    }
    (0, $byiyg._)(NamedNode, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'NamedNode' && other.value === this.value;
            }
        }
    ]);
    return NamedNode;
}();
module.exports.NamedNode = $0437839ef4d754fb$var$NamedNode;

});


parcelRegister("eUn5a", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ var $ada8334ca75e6dad$var$Quad = /*#__PURE__*/ function() {
    function Quad(subject, predicate, object, graph) {
        (0, $jGAMp._)(this, Quad);
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    (0, $byiyg._)(Quad, [
        {
            key: "equals",
            value: function equals(other) {
                // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
                return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
            }
        }
    ]);
    return Quad;
}();
module.exports.Quad = $ada8334ca75e6dad$var$Quad;

});

parcelRegister("3e6Ge", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ var $2597dc759e6c894f$var$Variable = /*#__PURE__*/ function() {
    function Variable(value) {
        (0, $jGAMp._)(this, Variable);
        this.termType = 'Variable';
        this.value = value;
    }
    (0, $byiyg._)(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                return !!other && other.termType === 'Variable' && other.value === this.value;
            }
        }
    ]);
    return Variable;
}();
module.exports.Variable = $2597dc759e6c894f$var$Variable;

});





parcelRegister("bGEF0", function(module, exports) {
"use strict";
var $88232847396a9f65$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88232847396a9f65$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88232847396a9f65$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$88232847396a9f65$var$__exportStar((parcelRequire("7IEJc")), module.exports);

$88232847396a9f65$var$__exportStar((parcelRequire("8SByV")), module.exports);

});
parcelRegister("7IEJc", function(module, exports) {

var $7WNf6 = parcelRequire("7WNf6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;
module.exports.getTerms = $59ec3c2e42020545$var$getTerms;
module.exports.getTermsNested = $59ec3c2e42020545$var$getTermsNested;
module.exports.getNamedTerms = $59ec3c2e42020545$var$getNamedTerms;
module.exports.collectNamedTerms = $59ec3c2e42020545$var$collectNamedTerms;
module.exports.forEachTerms = $59ec3c2e42020545$var$forEachTerms;
module.exports.forEachTermsNested = $59ec3c2e42020545$var$forEachTermsNested;
module.exports.filterTerms = $59ec3c2e42020545$var$filterTerms;
module.exports.filterTermsNested = $59ec3c2e42020545$var$filterTermsNested;
module.exports.filterQuadTermNames = $59ec3c2e42020545$var$filterQuadTermNames;
module.exports.filterQuadTermNamesNested = $59ec3c2e42020545$var$filterQuadTermNamesNested;
module.exports.mapTerms = $59ec3c2e42020545$var$mapTerms;
module.exports.mapTermsNested = $59ec3c2e42020545$var$mapTermsNested;
module.exports.reduceTerms = $59ec3c2e42020545$var$reduceTerms;
module.exports.reduceTermsNested = $59ec3c2e42020545$var$reduceTermsNested;
module.exports.everyTerms = $59ec3c2e42020545$var$everyTerms;
module.exports.everyTermsNested = $59ec3c2e42020545$var$everyTermsNested;
module.exports.someTerms = $59ec3c2e42020545$var$someTerms;
module.exports.someTermsNested = $59ec3c2e42020545$var$someTermsNested;
module.exports.getValueNestedPath = $59ec3c2e42020545$var$getValueNestedPath;
module.exports.matchTerm = $59ec3c2e42020545$var$matchTerm;
module.exports.matchPattern = $59ec3c2e42020545$var$matchPattern;
module.exports.matchPatternComplete = $59ec3c2e42020545$var$matchPatternComplete;
module.exports.matchPatternMappings = $59ec3c2e42020545$var$matchPatternMappings;

var $1lgsf = parcelRequire("1lgsf");
var $59ec3c2e42020545$var$DF = new $1lgsf.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $59ec3c2e42020545$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $59ec3c2e42020545$var$getTermsNested(quad, ignoreDefaultGraph) {
    var terms = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $59ec3c2e42020545$var$getTerms(quad, ignoreDefaultGraph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var term = _step.value;
            if (term.termType === 'Quad') $59ec3c2e42020545$var$getTermsNested(term, ignoreDefaultGraph).forEach(function(subTerm) {
                return terms.push(subTerm);
            });
            else terms.push(term);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return terms;
}
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $59ec3c2e42020545$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $59ec3c2e42020545$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    var elements = {};
    namedTerms.forEach(function(namedTerm) {
        return elements[namedTerm.key] = namedTerm.value;
    });
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $59ec3c2e42020545$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $59ec3c2e42020545$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $59ec3c2e42020545$var$forEachTermsNested(quad, cb) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (quad.subject.termType === 'Quad') $59ec3c2e42020545$var$forEachTermsNested(quad.subject, cb, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else cb(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') $59ec3c2e42020545$var$forEachTermsNested(quad.predicate, cb, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else cb(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') $59ec3c2e42020545$var$forEachTermsNested(quad.object, cb, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else cb(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') $59ec3c2e42020545$var$forEachTermsNested(quad.graph, cb, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else cb(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
}
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $59ec3c2e42020545$var$filterTerms(quad, filter) {
    var terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $59ec3c2e42020545$var$filterTermsNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var terms = [];
    if (quad.subject.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterTermsNested(quad.subject, filter, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))));
    else if (filter(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterTermsNested(quad.predicate, filter, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))));
    else if (filter(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterTermsNested(quad.object, filter, (0, $7WNf6._)(keys).concat([
        'object'
    ]))));
    else if (filter(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = (0, $7WNf6._)(terms).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterTermsNested(quad.graph, filter, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))));
    else if (filter(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]))) terms.push(quad.graph);
    return terms;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $59ec3c2e42020545$var$filterQuadTermNames(quad, filter) {
    var names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $59ec3c2e42020545$var$filterQuadTermNamesNested(quad, filter) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var names = [];
    var keysS = (0, $7WNf6._)(keys).concat([
        'subject'
    ]);
    if (quad.subject.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterQuadTermNamesNested(quad.subject, filter, keysS)));
    else if (filter(quad.subject, keysS)) names.push(keysS);
    var keysP = (0, $7WNf6._)(keys).concat([
        'predicate'
    ]);
    if (quad.predicate.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)));
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    var keysO = (0, $7WNf6._)(keys).concat([
        'object'
    ]);
    if (quad.object.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterQuadTermNamesNested(quad.object, filter, keysO)));
    else if (filter(quad.object, keysO)) names.push(keysO);
    var keysG = (0, $7WNf6._)(keys).concat([
        'graph'
    ]);
    if (quad.graph.termType === 'Quad') names = (0, $7WNf6._)(names).concat((0, $7WNf6._)($59ec3c2e42020545$var$filterQuadTermNamesNested(quad.graph, filter, keysG)));
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $59ec3c2e42020545$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $59ec3c2e42020545$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $59ec3c2e42020545$var$mapTermsNested(quad, mapper, dataFactory) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return (dataFactory || $59ec3c2e42020545$var$DF).quad(quad.subject.termType === 'Quad' ? $59ec3c2e42020545$var$mapTermsNested(quad.subject, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : mapper(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ])), quad.predicate.termType === 'Quad' ? $59ec3c2e42020545$var$mapTermsNested(quad.predicate, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : mapper(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])), quad.object.termType === 'Quad' ? $59ec3c2e42020545$var$mapTermsNested(quad.object, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : mapper(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ])), quad.graph.termType === 'Quad' ? $59ec3c2e42020545$var$mapTermsNested(quad.graph, mapper, dataFactory, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : mapper(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $59ec3c2e42020545$var$reduceTerms(quad, reducer, initialValue) {
    var value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $59ec3c2e42020545$var$reduceTermsNested(quad, reducer, initialValue) {
    var keys = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var value = initialValue;
    if (quad.subject.termType === 'Quad') value = $59ec3c2e42020545$var$reduceTermsNested(quad.subject, reducer, value, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    else value = reducer(value, quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]));
    if (quad.predicate.termType === 'Quad') value = $59ec3c2e42020545$var$reduceTermsNested(quad.predicate, reducer, value, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    else value = reducer(value, quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]));
    if (quad.object.termType === 'Quad') value = $59ec3c2e42020545$var$reduceTermsNested(quad.object, reducer, value, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    else value = reducer(value, quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]));
    if (quad.graph.termType === 'Quad') value = $59ec3c2e42020545$var$reduceTermsNested(quad.graph, reducer, value, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    else value = reducer(value, quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ]));
    return value;
}
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $59ec3c2e42020545$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $59ec3c2e42020545$var$everyTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $59ec3c2e42020545$var$everyTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) && (quad.predicate.termType === 'Quad' ? $59ec3c2e42020545$var$everyTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) && (quad.object.termType === 'Quad' ? $59ec3c2e42020545$var$everyTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) && (quad.graph.termType === 'Quad' ? $59ec3c2e42020545$var$everyTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $59ec3c2e42020545$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $59ec3c2e42020545$var$someTermsNested(quad, checker) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return (quad.subject.termType === 'Quad' ? $59ec3c2e42020545$var$someTermsNested(quad.subject, checker, (0, $7WNf6._)(keys).concat([
        'subject'
    ])) : checker(quad.subject, (0, $7WNf6._)(keys).concat([
        'subject'
    ]))) || (quad.predicate.termType === 'Quad' ? $59ec3c2e42020545$var$someTermsNested(quad.predicate, checker, (0, $7WNf6._)(keys).concat([
        'predicate'
    ])) : checker(quad.predicate, (0, $7WNf6._)(keys).concat([
        'predicate'
    ]))) || (quad.object.termType === 'Quad' ? $59ec3c2e42020545$var$someTermsNested(quad.object, checker, (0, $7WNf6._)(keys).concat([
        'object'
    ])) : checker(quad.object, (0, $7WNf6._)(keys).concat([
        'object'
    ]))) || (quad.graph.termType === 'Quad' ? $59ec3c2e42020545$var$someTermsNested(quad.graph, checker, (0, $7WNf6._)(keys).concat([
        'graph'
    ])) : checker(quad.graph, (0, $7WNf6._)(keys).concat([
        'graph'
    ])));
}
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $59ec3c2e42020545$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $59ec3c2e42020545$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error("Tried to get ".concat(keys[0], " from term of type ").concat(term.termType));
}
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $59ec3c2e42020545$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $59ec3c2e42020545$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $59ec3c2e42020545$var$matchPattern(quad, subject, predicate, object, graph) {
    return $59ec3c2e42020545$var$matchTerm(quad.subject, subject) && $59ec3c2e42020545$var$matchTerm(quad.predicate, predicate) && $59ec3c2e42020545$var$matchTerm(quad.object, object) && $59ec3c2e42020545$var$matchTerm(quad.graph, graph);
}
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $59ec3c2e42020545$var$matchPatternComplete(quad, pattern) {
    return $59ec3c2e42020545$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
function $59ec3c2e42020545$var$matchPatternMappings(quad, pattern) {
    var opt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var map = {};
    function match(_pattern, _quad) {
        return $59ec3c2e42020545$var$everyTerms(_pattern, function(t1, key) {
            var _a, _b;
            var t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}

});

parcelRegister("8SByV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TERM_TYPES = void 0;
module.exports.uniqTerms = $677080f7baca1593$var$uniqTerms;
module.exports.getTermsOfType = $677080f7baca1593$var$getTermsOfType;
module.exports.getNamedNodes = $677080f7baca1593$var$getNamedNodes;
module.exports.getBlankNodes = $677080f7baca1593$var$getBlankNodes;
module.exports.getLiterals = $677080f7baca1593$var$getLiterals;
module.exports.getVariables = $677080f7baca1593$var$getVariables;
module.exports.getDefaultGraphs = $677080f7baca1593$var$getDefaultGraphs;
module.exports.getQuads = $677080f7baca1593$var$getQuads;

var $lhX5B = parcelRequire("lhX5B");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $677080f7baca1593$var$uniqTerms(terms) {
    var hash = {};
    return terms.filter(function(term) {
        var termString = (0, $lhX5B.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $677080f7baca1593$var$getTermsOfType(terms, termType) {
    return terms.filter(function(term) {
        return term.termType === termType;
    });
}
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $677080f7baca1593$var$getNamedNodes(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'NamedNode');
}
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $677080f7baca1593$var$getBlankNodes(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'BlankNode');
}
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $677080f7baca1593$var$getLiterals(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'Literal');
}
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $677080f7baca1593$var$getVariables(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'Variable');
}
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $677080f7baca1593$var$getDefaultGraphs(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'DefaultGraph');
}
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $677080f7baca1593$var$getQuads(terms) {
    return $677080f7baca1593$var$getTermsOfType(terms, 'Quad');
}

});



parcelRegister("kJQ6J", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
var $f1906e192820637c$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $f1906e192820637c$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f1906e192820637c$var$__await ? (this.v = v, this) : new $f1906e192820637c$var$__await(v);
};
var $f1906e192820637c$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f1906e192820637c$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingStore = void 0;
parcelRequire("29pVS");
var $6rfrN = parcelRequire("6rfrN");

var $kQs19 = parcelRequire("kQs19");

var $hAd2u = parcelRequire("hAd2u");
/**
 * A StreamingStore allows data lookup and insertion to happen in parallel.
 * Concretely, this means that `match()` calls happening before `import()` calls, will still consider those triples that
 * are inserted later, which is done by keeping the response streams of `match()` open.
 * Only when the `end()` method is invoked, all response streams will close, and the StreamingStore will be considered
 * immutable.
 *
 * WARNING: `end()` MUST be called at some point, otherwise all `match` streams will remain unended.
 */ var $f1906e192820637c$var$StreamingStore = /*#__PURE__*/ function() {
    function StreamingStore() {
        var store = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $6rfrN.default();
        (0, $jGAMp._)(this, StreamingStore);
        this.pendingStreams = new $hAd2u.PendingStreamsIndex();
        this.ended = false;
        this.listeners = [];
        this.store = store;
    }
    (0, $byiyg._)(StreamingStore, [
        {
            key: "addEndListener",
            value: function addEndListener(listener) {
                this.listeners.push(listener);
            }
        },
        {
            key: "emitEndEvent",
            value: function emitEndEvent() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasEnded",
            value: function hasEnded() {
                return this.ended;
            }
        },
        {
            /**
     * Mark this store as ended.
     *
     * This will make sure that all running and future `match` calls will end,
     * and all next `import` calls to this store will throw an error.
     * It will run all the listeners added with `addEndListener`.
     */ key: "end",
            value: function end() {
                this.ended = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Mark all pendingStreams as ended.
                    for(var _iterator = this.pendingStreams.allStreams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pendingStream = _step.value;
                        pendingStream.push(null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.emitEndEvent();
            }
        },
        {
            key: "importToListeners",
            value: function importToListeners(stream) {
                var _this = this;
                stream.on('data', function(quad) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!_this.ended && !_this.store.countQuads(quad.subject, quad.predicate, quad.object, quad.graph)) try {
                        for(var _iterator = _this.pendingStreams.getPendingStreamsForQuad(quad)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pendingStream = _step.value;
                            /**
                     * The pendingStream emits 'quad' events even before it is initialized.
                     * This allows us to detect when matching quads are added to the store,
                     * without having to consume the stream returned by the `match` method.
                     */ pendingStream.emit('quad', quad);
                            if (pendingStream.isInitialized) pendingStream.push(quad);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "import",
            value: function _import(stream) {
                if (this.ended) throw new Error('Attempted to import into an ended StreamingStore');
                this.importToListeners(stream);
                return this.store["import"](stream);
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                var storeResult = this.store.match(subject, predicate, object, graph);
                var stream = storeResult;
                // If the store hasn't ended yet, also create a new pendingStream
                if (!this.ended) {
                    // The new pendingStream remains open, until the store is ended.
                    var pendingStream = new $kQs19.PassThrough({
                        objectMode: true
                    });
                    this.pendingStreams.addPatternListener(pendingStream, subject, predicate, object, graph);
                    stream = $kQs19.Readable.from(StreamingStore.concatStreams([
                        storeResult,
                        pendingStream
                    ]));
                    pendingStream.on('quad', function(quad) {
                        stream.emit('quad', quad);
                    });
                    stream._pipeSource = storeResult;
                    // This is an ugly hack to annotate pendingStream with the isInitialized once the store stream started being read.
                    // This is necessary to avoid duplicate quads cases where match() is called but not yet read, an import is done,
                    // and only then the match() stream is read.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    var readOld = storeResult._read;
                    storeResult._read = function(size) {
                        pendingStream.isInitialized = true;
                        readOld.call(storeResult, size);
                    };
                }
                return stream;
            }
        },
        {
            /**
     * The internal store with all imported quads.
     */ key: "getStore",
            value: function getStore() {
                return this.store;
            }
        }
    ], [
        {
            key: "concatStreams",
            value: function concatStreams(readables) {
                return $f1906e192820637c$var$__asyncGenerator(this, arguments, function concatStreams_1() {
                    var _a, e_1, _b, _c, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, readable, _d, readable_1, readable_1_1, chunk, e_1_1, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    20,
                                    21,
                                    22
                                ]);
                                _iterator = readables[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    19
                                ];
                                readable = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    12,
                                    13,
                                    18
                                ]);
                                _d = true, readable_1 = (e_1 = void 0, $f1906e192820637c$var$__asyncValues(readable));
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    $f1906e192820637c$var$__await(readable_1.next())
                                ];
                            case 5:
                                if (!(readable_1_1 = _state.sent(), _a = readable_1_1.done, !_a)) return [
                                    3,
                                    11
                                ];
                                _c = readable_1_1.value;
                                _d = false;
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    ,
                                    9,
                                    10
                                ]);
                                chunk = _c;
                                return [
                                    4,
                                    $f1906e192820637c$var$__await(chunk)
                                ];
                            case 7:
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                _d = true;
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    3,
                                    4
                                ];
                            case 11:
                                return [
                                    3,
                                    18
                                ];
                            case 12:
                                e_1_1 = _state.sent();
                                e_1 = {
                                    error: e_1_1
                                };
                                return [
                                    3,
                                    18
                                ];
                            case 13:
                                _state.trys.push([
                                    13,
                                    ,
                                    16,
                                    17
                                ]);
                                if (!(!_d && !_a && (_b = readable_1["return"]))) return [
                                    3,
                                    15
                                ];
                                return [
                                    4,
                                    $f1906e192820637c$var$__await(_b.call(readable_1))
                                ];
                            case 14:
                                _state.sent();
                                _state.label = 15;
                            case 15:
                                return [
                                    3,
                                    17
                                ];
                            case 16:
                                if (e_1) throw e_1.error;
                                return [
                                    7
                                ];
                            case 17:
                                return [
                                    7
                                ];
                            case 18:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 19:
                                return [
                                    3,
                                    22
                                ];
                            case 20:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    22
                                ];
                            case 21:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 22:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StreamingStore;
}();
module.exports.StreamingStore = $f1906e192820637c$var$StreamingStore;

});
parcelRegister("kQs19", function(module, exports) {
'use strict';

var $1lybP = parcelRequire("1lybP");

var $5gGPu = parcelRequire("5gGPu");
var $f2ce65a977bf49ea$var$originalDestroy = $1lybP.Readable.destroy;
module.exports = $1lybP.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $1lybP._uint8ArrayToBuffer;
module.exports._isUint8Array = $1lybP._isUint8Array;
module.exports.isDisturbed = $1lybP.isDisturbed;
module.exports.isErrored = $1lybP.isErrored;
module.exports.isReadable = $1lybP.isReadable;
module.exports.Readable = $1lybP.Readable;
module.exports.Writable = $1lybP.Writable;
module.exports.Duplex = $1lybP.Duplex;
module.exports.Transform = $1lybP.Transform;
module.exports.PassThrough = $1lybP.PassThrough;
module.exports.addAbortSignal = $1lybP.addAbortSignal;
module.exports.finished = $1lybP.finished;
module.exports.destroy = $1lybP.destroy;
module.exports.destroy = $f2ce65a977bf49ea$var$originalDestroy;
module.exports.pipeline = $1lybP.pipeline;
module.exports.compose = $1lybP.compose;
Object.defineProperty($1lybP, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $5gGPu;
    }
});
module.exports.Stream = $1lybP.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("1lybP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $hXCcT = parcelRequire("hXCcT");
var $0fb245fd9cd2f8df$require$Buffer = $hXCcT.Buffer;

var $lD0c5 = parcelRequire("lD0c5");
/* replacement end */ var $0fb245fd9cd2f8df$var$ObjectDefineProperty = $lD0c5.ObjectDefineProperty, $0fb245fd9cd2f8df$var$ObjectKeys = $lD0c5.ObjectKeys, $0fb245fd9cd2f8df$var$ReflectApply = $lD0c5.ReflectApply;

var $2QqeP = parcelRequire("2QqeP");
var $0fb245fd9cd2f8df$var$_require_promisify = $2QqeP.promisify, $0fb245fd9cd2f8df$var$customPromisify = $0fb245fd9cd2f8df$var$_require_promisify.custom;

var $g4LhN = parcelRequire("g4LhN");
var $0fb245fd9cd2f8df$var$streamReturningOperators = $g4LhN.streamReturningOperators, $0fb245fd9cd2f8df$var$promiseReturningOperators = $g4LhN.promiseReturningOperators;

var $4qHMP = parcelRequire("4qHMP");
var $0fb245fd9cd2f8df$var$ERR_ILLEGAL_CONSTRUCTOR = $4qHMP.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $43KfJ = parcelRequire("43KfJ");

var $6w72j = parcelRequire("6w72j");
var $0fb245fd9cd2f8df$var$setDefaultHighWaterMark = $6w72j.setDefaultHighWaterMark, $0fb245fd9cd2f8df$var$getDefaultHighWaterMark = $6w72j.getDefaultHighWaterMark;

var $fBe60 = parcelRequire("fBe60");
var $0fb245fd9cd2f8df$require$pipeline = $fBe60.pipeline;

var $68GSU = parcelRequire("68GSU");
var $0fb245fd9cd2f8df$require$destroyer = $68GSU.destroyer;

var $g0l3g = parcelRequire("g0l3g");
var $0fb245fd9cd2f8df$var$internalBuffer = {};

var $5gGPu = parcelRequire("5gGPu");

var $772Et = parcelRequire("772Et");

var $0fb245fd9cd2f8df$var$Stream = module.exports = (parcelRequire("eXLnR")).Stream;
$0fb245fd9cd2f8df$var$Stream.isDestroyed = $772Et.isDestroyed;
$0fb245fd9cd2f8df$var$Stream.isDisturbed = $772Et.isDisturbed;
$0fb245fd9cd2f8df$var$Stream.isErrored = $772Et.isErrored;
$0fb245fd9cd2f8df$var$Stream.isReadable = $772Et.isReadable;
$0fb245fd9cd2f8df$var$Stream.isWritable = $772Et.isWritable;

$0fb245fd9cd2f8df$var$Stream.Readable = (parcelRequire("77zC0"));
var $0fb245fd9cd2f8df$var$_iteratorNormalCompletion = true, $0fb245fd9cd2f8df$var$_didIteratorError = false, $0fb245fd9cd2f8df$var$_iteratorError = undefined;
try {
    for(var $0fb245fd9cd2f8df$var$_iterator = $0fb245fd9cd2f8df$var$ObjectKeys($0fb245fd9cd2f8df$var$streamReturningOperators)[Symbol.iterator](), $0fb245fd9cd2f8df$var$_step; !($0fb245fd9cd2f8df$var$_iteratorNormalCompletion = ($0fb245fd9cd2f8df$var$_step = $0fb245fd9cd2f8df$var$_iterator.next()).done); $0fb245fd9cd2f8df$var$_iteratorNormalCompletion = true){
        var $0fb245fd9cd2f8df$var$key = $0fb245fd9cd2f8df$var$_step.value;
        var $0fb245fd9cd2f8df$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $0fb245fd9cd2f8df$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0fb245fd9cd2f8df$var$Stream.Readable.from($0fb245fd9cd2f8df$var$ReflectApply($0fb245fd9cd2f8df$var$op, this, args));
        };
        var $0fb245fd9cd2f8df$var$op = $0fb245fd9cd2f8df$var$streamReturningOperators[$0fb245fd9cd2f8df$var$key];
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$fn, 'name', {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$op.name
        });
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$fn, 'length', {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$op.length
        });
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$Stream.Readable.prototype, $0fb245fd9cd2f8df$var$key, {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0fb245fd9cd2f8df$var$_didIteratorError = true;
    $0fb245fd9cd2f8df$var$_iteratorError = err;
} finally{
    try {
        if (!$0fb245fd9cd2f8df$var$_iteratorNormalCompletion && $0fb245fd9cd2f8df$var$_iterator["return"] != null) {
            $0fb245fd9cd2f8df$var$_iterator["return"]();
        }
    } finally{
        if ($0fb245fd9cd2f8df$var$_didIteratorError) {
            throw $0fb245fd9cd2f8df$var$_iteratorError;
        }
    }
}
var $0fb245fd9cd2f8df$var$_iteratorNormalCompletion1 = true, $0fb245fd9cd2f8df$var$_didIteratorError1 = false, $0fb245fd9cd2f8df$var$_iteratorError1 = undefined;
try {
    for(var $0fb245fd9cd2f8df$var$_iterator1 = $0fb245fd9cd2f8df$var$ObjectKeys($0fb245fd9cd2f8df$var$promiseReturningOperators)[Symbol.iterator](), $0fb245fd9cd2f8df$var$_step1; !($0fb245fd9cd2f8df$var$_iteratorNormalCompletion1 = ($0fb245fd9cd2f8df$var$_step1 = $0fb245fd9cd2f8df$var$_iterator1.next()).done); $0fb245fd9cd2f8df$var$_iteratorNormalCompletion1 = true){
        var $0fb245fd9cd2f8df$var$key1 = $0fb245fd9cd2f8df$var$_step1.value;
        var $0fb245fd9cd2f8df$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $0fb245fd9cd2f8df$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $0fb245fd9cd2f8df$var$ReflectApply($0fb245fd9cd2f8df$var$op1, this, args);
        };
        var $0fb245fd9cd2f8df$var$op1 = $0fb245fd9cd2f8df$var$promiseReturningOperators[$0fb245fd9cd2f8df$var$key1];
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$fn1, 'name', {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$op1.name
        });
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$fn1, 'length', {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$op1.length
        });
        $0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$Stream.Readable.prototype, $0fb245fd9cd2f8df$var$key1, {
            __proto__: null,
            value: $0fb245fd9cd2f8df$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $0fb245fd9cd2f8df$var$_didIteratorError1 = true;
    $0fb245fd9cd2f8df$var$_iteratorError1 = err;
} finally{
    try {
        if (!$0fb245fd9cd2f8df$var$_iteratorNormalCompletion1 && $0fb245fd9cd2f8df$var$_iterator1["return"] != null) {
            $0fb245fd9cd2f8df$var$_iterator1["return"]();
        }
    } finally{
        if ($0fb245fd9cd2f8df$var$_didIteratorError1) {
            throw $0fb245fd9cd2f8df$var$_iteratorError1;
        }
    }
}

$0fb245fd9cd2f8df$var$Stream.Writable = (parcelRequire("evyZp"));

$0fb245fd9cd2f8df$var$Stream.Duplex = (parcelRequire("bysq0"));

$0fb245fd9cd2f8df$var$Stream.Transform = (parcelRequire("8uxPL"));

$0fb245fd9cd2f8df$var$Stream.PassThrough = (parcelRequire("hHMZs"));
$0fb245fd9cd2f8df$var$Stream.pipeline = $0fb245fd9cd2f8df$require$pipeline;

var $6nuWS = parcelRequire("6nuWS");
var $0fb245fd9cd2f8df$require$addAbortSignal = $6nuWS.addAbortSignal;
$0fb245fd9cd2f8df$var$Stream.addAbortSignal = $0fb245fd9cd2f8df$require$addAbortSignal;
$0fb245fd9cd2f8df$var$Stream.finished = $g0l3g;
$0fb245fd9cd2f8df$var$Stream.destroy = $0fb245fd9cd2f8df$require$destroyer;
$0fb245fd9cd2f8df$var$Stream.compose = $43KfJ;
$0fb245fd9cd2f8df$var$Stream.setDefaultHighWaterMark = $0fb245fd9cd2f8df$var$setDefaultHighWaterMark;
$0fb245fd9cd2f8df$var$Stream.getDefaultHighWaterMark = $0fb245fd9cd2f8df$var$getDefaultHighWaterMark;
$0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $5gGPu;
    }
});
$0fb245fd9cd2f8df$var$ObjectDefineProperty($0fb245fd9cd2f8df$require$pipeline, $0fb245fd9cd2f8df$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5gGPu.pipeline;
    }
});
$0fb245fd9cd2f8df$var$ObjectDefineProperty($g0l3g, $0fb245fd9cd2f8df$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $5gGPu.finished;
    }
});
// Backwards-compat with node 0.4.x
$0fb245fd9cd2f8df$var$Stream.Stream = $0fb245fd9cd2f8df$var$Stream;
$0fb245fd9cd2f8df$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$0fb245fd9cd2f8df$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $0fb245fd9cd2f8df$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("hXCcT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d13595762d8b0ab6$export$a143d493d941bafc; }, function (v) { return $d13595762d8b0ab6$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d13595762d8b0ab6$export$f99ded8fe4b79145; }, function (v) { return $d13595762d8b0ab6$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $d13595762d8b0ab6$export$a143d493d941bafc;
var $d13595762d8b0ab6$export$e4cf37d7f6fb9e0a;
var $d13595762d8b0ab6$export$f99ded8fe4b79145;
var $d13595762d8b0ab6$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $d13595762d8b0ab6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d13595762d8b0ab6$export$a143d493d941bafc = $d13595762d8b0ab6$var$Buffer;
$d13595762d8b0ab6$export$e4cf37d7f6fb9e0a = $d13595762d8b0ab6$var$SlowBuffer;
$d13595762d8b0ab6$export$f99ded8fe4b79145 = 50;
var $d13595762d8b0ab6$var$K_MAX_LENGTH = 0x7fffffff;
$d13595762d8b0ab6$export$599f31c3813fae4d = $d13595762d8b0ab6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d13595762d8b0ab6$var$Buffer.TYPED_ARRAY_SUPPORT = $d13595762d8b0ab6$var$typedArraySupport();
if (!$d13595762d8b0ab6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d13595762d8b0ab6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d13595762d8b0ab6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$d13595762d8b0ab6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d13595762d8b0ab6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$d13595762d8b0ab6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d13595762d8b0ab6$var$createBuffer(length) {
    if (length > $d13595762d8b0ab6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d13595762d8b0ab6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d13595762d8b0ab6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d13595762d8b0ab6$var$allocUnsafe(arg);
    }
    return $d13595762d8b0ab6$var$from(arg, encodingOrOffset, length);
}
$d13595762d8b0ab6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d13595762d8b0ab6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d13595762d8b0ab6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d13595762d8b0ab6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($d13595762d8b0ab6$var$isInstance(value, ArrayBuffer) || value && $d13595762d8b0ab6$var$isInstance(value.buffer, ArrayBuffer)) return $d13595762d8b0ab6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d13595762d8b0ab6$var$isInstance(value, SharedArrayBuffer) || value && $d13595762d8b0ab6$var$isInstance(value.buffer, SharedArrayBuffer))) return $d13595762d8b0ab6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d13595762d8b0ab6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d13595762d8b0ab6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d13595762d8b0ab6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d13595762d8b0ab6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d13595762d8b0ab6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d13595762d8b0ab6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d13595762d8b0ab6$var$Buffer, Uint8Array);
function $d13595762d8b0ab6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d13595762d8b0ab6$var$alloc(size, fill, encoding) {
    $d13595762d8b0ab6$var$assertSize(size);
    if (size <= 0) return $d13595762d8b0ab6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d13595762d8b0ab6$var$createBuffer(size).fill(fill, encoding) : $d13595762d8b0ab6$var$createBuffer(size).fill(fill);
    return $d13595762d8b0ab6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d13595762d8b0ab6$var$Buffer.alloc = function(size, fill, encoding) {
    return $d13595762d8b0ab6$var$alloc(size, fill, encoding);
};
function $d13595762d8b0ab6$var$allocUnsafe(size) {
    $d13595762d8b0ab6$var$assertSize(size);
    return $d13595762d8b0ab6$var$createBuffer(size < 0 ? 0 : $d13595762d8b0ab6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d13595762d8b0ab6$var$Buffer.allocUnsafe = function(size) {
    return $d13595762d8b0ab6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d13595762d8b0ab6$var$Buffer.allocUnsafeSlow = function(size) {
    return $d13595762d8b0ab6$var$allocUnsafe(size);
};
function $d13595762d8b0ab6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d13595762d8b0ab6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d13595762d8b0ab6$var$byteLength(string, encoding) | 0;
    var buf = $d13595762d8b0ab6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d13595762d8b0ab6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d13595762d8b0ab6$var$checked(array.length) | 0;
    var buf = $d13595762d8b0ab6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d13595762d8b0ab6$var$fromArrayView(arrayView) {
    if ($d13595762d8b0ab6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d13595762d8b0ab6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d13595762d8b0ab6$var$fromArrayLike(arrayView);
}
function $d13595762d8b0ab6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d13595762d8b0ab6$var$Buffer.prototype);
    return buf;
}
function $d13595762d8b0ab6$var$fromObject(obj) {
    if ($d13595762d8b0ab6$var$Buffer.isBuffer(obj)) {
        var len = $d13595762d8b0ab6$var$checked(obj.length) | 0;
        var buf = $d13595762d8b0ab6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d13595762d8b0ab6$var$numberIsNaN(obj.length)) return $d13595762d8b0ab6$var$createBuffer(0);
        return $d13595762d8b0ab6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d13595762d8b0ab6$var$fromArrayLike(obj.data);
}
function $d13595762d8b0ab6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d13595762d8b0ab6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d13595762d8b0ab6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d13595762d8b0ab6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d13595762d8b0ab6$var$Buffer.alloc(+length);
}
$d13595762d8b0ab6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d13595762d8b0ab6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d13595762d8b0ab6$var$Buffer.compare = function compare(a, b) {
    if ($d13595762d8b0ab6$var$isInstance(a, Uint8Array)) a = $d13595762d8b0ab6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d13595762d8b0ab6$var$isInstance(b, Uint8Array)) b = $d13595762d8b0ab6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d13595762d8b0ab6$var$Buffer.isBuffer(a) || !$d13595762d8b0ab6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d13595762d8b0ab6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d13595762d8b0ab6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d13595762d8b0ab6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d13595762d8b0ab6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d13595762d8b0ab6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d13595762d8b0ab6$var$Buffer.isBuffer(buf)) buf = $d13595762d8b0ab6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d13595762d8b0ab6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d13595762d8b0ab6$var$byteLength(string, encoding) {
    if ($d13595762d8b0ab6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d13595762d8b0ab6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d13595762d8b0ab6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d13595762d8b0ab6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d13595762d8b0ab6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d13595762d8b0ab6$var$Buffer.byteLength = $d13595762d8b0ab6$var$byteLength;
function $d13595762d8b0ab6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d13595762d8b0ab6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d13595762d8b0ab6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d13595762d8b0ab6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d13595762d8b0ab6$var$latin1Slice(this, start, end);
        case 'base64':
            return $d13595762d8b0ab6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d13595762d8b0ab6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d13595762d8b0ab6$var$Buffer.prototype._isBuffer = true;
function $d13595762d8b0ab6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d13595762d8b0ab6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d13595762d8b0ab6$var$swap(this, i, i + 1);
    return this;
};
$d13595762d8b0ab6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d13595762d8b0ab6$var$swap(this, i, i + 3);
        $d13595762d8b0ab6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d13595762d8b0ab6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d13595762d8b0ab6$var$swap(this, i, i + 7);
        $d13595762d8b0ab6$var$swap(this, i + 1, i + 6);
        $d13595762d8b0ab6$var$swap(this, i + 2, i + 5);
        $d13595762d8b0ab6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d13595762d8b0ab6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d13595762d8b0ab6$var$utf8Slice(this, 0, length);
    return $d13595762d8b0ab6$var$slowToString.apply(this, arguments);
};
$d13595762d8b0ab6$var$Buffer.prototype.toLocaleString = $d13595762d8b0ab6$var$Buffer.prototype.toString;
$d13595762d8b0ab6$var$Buffer.prototype.equals = function equals(b) {
    if (!$d13595762d8b0ab6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d13595762d8b0ab6$var$Buffer.compare(this, b) === 0;
};
$d13595762d8b0ab6$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d13595762d8b0ab6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d13595762d8b0ab6$var$customInspectSymbol) $d13595762d8b0ab6$var$Buffer.prototype[$d13595762d8b0ab6$var$customInspectSymbol] = $d13595762d8b0ab6$var$Buffer.prototype.inspect;
$d13595762d8b0ab6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d13595762d8b0ab6$var$isInstance(target, Uint8Array)) target = $d13595762d8b0ab6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d13595762d8b0ab6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d13595762d8b0ab6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d13595762d8b0ab6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d13595762d8b0ab6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d13595762d8b0ab6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d13595762d8b0ab6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d13595762d8b0ab6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d13595762d8b0ab6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d13595762d8b0ab6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d13595762d8b0ab6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d13595762d8b0ab6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d13595762d8b0ab6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d13595762d8b0ab6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d13595762d8b0ab6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d13595762d8b0ab6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d13595762d8b0ab6$var$utf8Write(buf, string, offset, length) {
    return $d13595762d8b0ab6$var$blitBuffer($d13595762d8b0ab6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d13595762d8b0ab6$var$asciiWrite(buf, string, offset, length) {
    return $d13595762d8b0ab6$var$blitBuffer($d13595762d8b0ab6$var$asciiToBytes(string), buf, offset, length);
}
function $d13595762d8b0ab6$var$base64Write(buf, string, offset, length) {
    return $d13595762d8b0ab6$var$blitBuffer($d13595762d8b0ab6$var$base64ToBytes(string), buf, offset, length);
}
function $d13595762d8b0ab6$var$ucs2Write(buf, string, offset, length) {
    return $d13595762d8b0ab6$var$blitBuffer($d13595762d8b0ab6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d13595762d8b0ab6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d13595762d8b0ab6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d13595762d8b0ab6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d13595762d8b0ab6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d13595762d8b0ab6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d13595762d8b0ab6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d13595762d8b0ab6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d13595762d8b0ab6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $d13595762d8b0ab6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d13595762d8b0ab6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d13595762d8b0ab6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d13595762d8b0ab6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d13595762d8b0ab6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d13595762d8b0ab6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d13595762d8b0ab6$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d13595762d8b0ab6$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d13595762d8b0ab6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d13595762d8b0ab6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d13595762d8b0ab6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d13595762d8b0ab6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d13595762d8b0ab6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d13595762d8b0ab6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d13595762d8b0ab6$var$Buffer.prototype.readUintLE = $d13595762d8b0ab6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readUintBE = $d13595762d8b0ab6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readUint8 = $d13595762d8b0ab6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d13595762d8b0ab6$var$Buffer.prototype.readUint16LE = $d13595762d8b0ab6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d13595762d8b0ab6$var$Buffer.prototype.readUint16BE = $d13595762d8b0ab6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d13595762d8b0ab6$var$Buffer.prototype.readUint32LE = $d13595762d8b0ab6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d13595762d8b0ab6$var$Buffer.prototype.readUint32BE = $d13595762d8b0ab6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d13595762d8b0ab6$var$Buffer.prototype.readBigUInt64LE = $d13595762d8b0ab6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d13595762d8b0ab6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d13595762d8b0ab6$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d13595762d8b0ab6$var$Buffer.prototype.readBigUInt64BE = $d13595762d8b0ab6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d13595762d8b0ab6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d13595762d8b0ab6$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d13595762d8b0ab6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d13595762d8b0ab6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d13595762d8b0ab6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d13595762d8b0ab6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d13595762d8b0ab6$var$Buffer.prototype.readBigInt64LE = $d13595762d8b0ab6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d13595762d8b0ab6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d13595762d8b0ab6$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$d13595762d8b0ab6$var$Buffer.prototype.readBigInt64BE = $d13595762d8b0ab6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d13595762d8b0ab6$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d13595762d8b0ab6$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$d13595762d8b0ab6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$d13595762d8b0ab6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$d13595762d8b0ab6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$d13595762d8b0ab6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $d13595762d8b0ab6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d13595762d8b0ab6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d13595762d8b0ab6$var$Buffer.prototype.writeUintLE = $d13595762d8b0ab6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d13595762d8b0ab6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUintBE = $d13595762d8b0ab6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d13595762d8b0ab6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUint8 = $d13595762d8b0ab6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUint16LE = $d13595762d8b0ab6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUint16BE = $d13595762d8b0ab6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUint32LE = $d13595762d8b0ab6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeUint32BE = $d13595762d8b0ab6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d13595762d8b0ab6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d13595762d8b0ab6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d13595762d8b0ab6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d13595762d8b0ab6$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d13595762d8b0ab6$var$Buffer.prototype.writeBigUInt64LE = $d13595762d8b0ab6$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d13595762d8b0ab6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d13595762d8b0ab6$var$Buffer.prototype.writeBigUInt64BE = $d13595762d8b0ab6$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d13595762d8b0ab6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d13595762d8b0ab6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d13595762d8b0ab6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d13595762d8b0ab6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d13595762d8b0ab6$var$Buffer.prototype.writeBigInt64LE = $d13595762d8b0ab6$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d13595762d8b0ab6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d13595762d8b0ab6$var$Buffer.prototype.writeBigInt64BE = $d13595762d8b0ab6$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d13595762d8b0ab6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d13595762d8b0ab6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d13595762d8b0ab6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d13595762d8b0ab6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d13595762d8b0ab6$var$writeFloat(this, value, offset, true, noAssert);
};
$d13595762d8b0ab6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d13595762d8b0ab6$var$writeFloat(this, value, offset, false, noAssert);
};
function $d13595762d8b0ab6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d13595762d8b0ab6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d13595762d8b0ab6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d13595762d8b0ab6$var$writeDouble(this, value, offset, true, noAssert);
};
$d13595762d8b0ab6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d13595762d8b0ab6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d13595762d8b0ab6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d13595762d8b0ab6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d13595762d8b0ab6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d13595762d8b0ab6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d13595762d8b0ab6$var$Buffer.isBuffer(val) ? val : $d13595762d8b0ab6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $d13595762d8b0ab6$var$errors = {};
function $d13595762d8b0ab6$var$E(sym, getMessage, Base) {
    $d13595762d8b0ab6$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$d13595762d8b0ab6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d13595762d8b0ab6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$d13595762d8b0ab6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d13595762d8b0ab6$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $d13595762d8b0ab6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $d13595762d8b0ab6$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $d13595762d8b0ab6$var$checkBounds(buf, offset, byteLength) {
    $d13595762d8b0ab6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d13595762d8b0ab6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d13595762d8b0ab6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $d13595762d8b0ab6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d13595762d8b0ab6$var$checkBounds(buf, offset, byteLength);
}
function $d13595762d8b0ab6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d13595762d8b0ab6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d13595762d8b0ab6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d13595762d8b0ab6$var$validateNumber(value, type);
        throw new $d13595762d8b0ab6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d13595762d8b0ab6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d13595762d8b0ab6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $d13595762d8b0ab6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d13595762d8b0ab6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d13595762d8b0ab6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d13595762d8b0ab6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d13595762d8b0ab6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d13595762d8b0ab6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d13595762d8b0ab6$var$base64ToBytes(str) {
    return $abUaD.toByteArray($d13595762d8b0ab6$var$base64clean(str));
}
function $d13595762d8b0ab6$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d13595762d8b0ab6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d13595762d8b0ab6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d13595762d8b0ab6$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d13595762d8b0ab6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d13595762d8b0ab6$var$BufferBigIntNotDefined : fn;
}
function $d13595762d8b0ab6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("lD0c5", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $fbed63feddcb4e33$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $fbed63feddcb4e33$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("2QqeP", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $hXCcT = parcelRequire("hXCcT");

var $fWerx = parcelRequire("fWerx");
var $2124ca7579f31878$var$format = $fWerx.format, $2124ca7579f31878$var$inspect = $fWerx.inspect;

var $4qHMP = parcelRequire("4qHMP");
var $2124ca7579f31878$var$ERR_INVALID_ARG_TYPE = $4qHMP.codes.ERR_INVALID_ARG_TYPE;

var $lD0c5 = parcelRequire("lD0c5");
var $2124ca7579f31878$var$kResistStopPropagation = $lD0c5.kResistStopPropagation, $2124ca7579f31878$var$AggregateError = $lD0c5.AggregateError, $2124ca7579f31878$var$SymbolDispose = $lD0c5.SymbolDispose;

var $2124ca7579f31878$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $2124ca7579f31878$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $2124ca7579f31878$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $2124ca7579f31878$var$Blob = globalThis.Blob || $hXCcT.Blob;
/* eslint-disable indent */ var $2124ca7579f31878$var$isBlob = typeof $2124ca7579f31878$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $2124ca7579f31878$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $2124ca7579f31878$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $2124ca7579f31878$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $2124ca7579f31878$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $2124ca7579f31878$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $2124ca7579f31878$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $2124ca7579f31878$var$format,
    inspect: $2124ca7579f31878$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $2124ca7579f31878$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $2124ca7579f31878$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $2124ca7579f31878$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $2124ca7579f31878$var$validateAbortSignal(signal, 'signal');
        $2124ca7579f31878$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $2124ca7579f31878$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $2124ca7579f31878$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $2124ca7579f31878$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $2124ca7579f31878$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $2124ca7579f31878$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("fWerx", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("4qHMP", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $fWerx = parcelRequire("fWerx");
var $339b8e40ce118a1b$var$format = $fWerx.format, $339b8e40ce118a1b$var$inspect = $fWerx.inspect;

var $lD0c5 = parcelRequire("lD0c5");
var $339b8e40ce118a1b$var$CustomAggregateError = $lD0c5.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $339b8e40ce118a1b$var$AggregateError = globalThis.AggregateError || $339b8e40ce118a1b$var$CustomAggregateError;
var $339b8e40ce118a1b$var$kIsNodeError = Symbol('kIsNodeError');
var $339b8e40ce118a1b$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $339b8e40ce118a1b$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $339b8e40ce118a1b$var$nodeInternalPrefix = '__node_internal_';
var $339b8e40ce118a1b$var$codes = {};
function $339b8e40ce118a1b$var$assert(value, message) {
    if (!value) throw new $339b8e40ce118a1b$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $339b8e40ce118a1b$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $339b8e40ce118a1b$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $339b8e40ce118a1b$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $339b8e40ce118a1b$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $339b8e40ce118a1b$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $339b8e40ce118a1b$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $339b8e40ce118a1b$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$339b8e40ce118a1b$var$kIsNodeError] = true;
    $339b8e40ce118a1b$var$codes[code] = NodeError;
}
function $339b8e40ce118a1b$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $339b8e40ce118a1b$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $339b8e40ce118a1b$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $339b8e40ce118a1b$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $339b8e40ce118a1b$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $339b8e40ce118a1b$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$339b8e40ce118a1b$var$E('ERR_ASSERTION', '%s', Error);
$339b8e40ce118a1b$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $339b8e40ce118a1b$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $339b8e40ce118a1b$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($339b8e40ce118a1b$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($339b8e40ce118a1b$var$classRegExp.test(value)) instances.push(value);
            else {
                $339b8e40ce118a1b$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $339b8e40ce118a1b$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $339b8e40ce118a1b$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$339b8e40ce118a1b$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $339b8e40ce118a1b$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$339b8e40ce118a1b$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$339b8e40ce118a1b$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $339b8e40ce118a1b$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$339b8e40ce118a1b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $339b8e40ce118a1b$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $339b8e40ce118a1b$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $339b8e40ce118a1b$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $339b8e40ce118a1b$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$339b8e40ce118a1b$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$339b8e40ce118a1b$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$339b8e40ce118a1b$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$339b8e40ce118a1b$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$339b8e40ce118a1b$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $339b8e40ce118a1b$var$AbortError,
    aggregateTwoErrors: $339b8e40ce118a1b$var$hideStackFrames($339b8e40ce118a1b$var$aggregateTwoErrors),
    hideStackFrames: $339b8e40ce118a1b$var$hideStackFrames,
    codes: $339b8e40ce118a1b$var$codes
};

});


parcelRegister("g4LhN", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $bb41b314080f6386$export$42af8c323be37587; }, function (v) { return $bb41b314080f6386$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $bb41b314080f6386$export$f405f72c701dad87; }, function (v) { return $bb41b314080f6386$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $bb41b314080f6386$export$42af8c323be37587;
var $bb41b314080f6386$export$f405f72c701dad87;
'use strict';

var $bb41b314080f6386$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $4qHMP = parcelRequire("4qHMP");
var $bb41b314080f6386$var$_require_codes = $4qHMP.codes, $bb41b314080f6386$var$ERR_INVALID_ARG_VALUE = $bb41b314080f6386$var$_require_codes.ERR_INVALID_ARG_VALUE, $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE = $bb41b314080f6386$var$_require_codes.ERR_INVALID_ARG_TYPE, $bb41b314080f6386$var$ERR_MISSING_ARGS = $bb41b314080f6386$var$_require_codes.ERR_MISSING_ARGS, $bb41b314080f6386$var$ERR_OUT_OF_RANGE = $bb41b314080f6386$var$_require_codes.ERR_OUT_OF_RANGE, $bb41b314080f6386$var$AbortError = $4qHMP.AbortError;

var $eZpbD = parcelRequire("eZpbD");
var $bb41b314080f6386$var$validateAbortSignal = $eZpbD.validateAbortSignal, $bb41b314080f6386$var$validateInteger = $eZpbD.validateInteger, $bb41b314080f6386$var$validateObject = $eZpbD.validateObject;

var $bb41b314080f6386$var$kWeakHandler = (parcelRequire("lD0c5")).Symbol('kWeak');

var $bb41b314080f6386$var$kResistStopPropagation = (parcelRequire("lD0c5")).Symbol('kResistStopPropagation');

var $g0l3g = parcelRequire("g0l3g");
var $bb41b314080f6386$require$finished = $g0l3g.finished;

var $43KfJ = parcelRequire("43KfJ");

var $6nuWS = parcelRequire("6nuWS");
var $bb41b314080f6386$require$addAbortSignalNoValidate = $6nuWS.addAbortSignalNoValidate;

var $772Et = parcelRequire("772Et");
var $bb41b314080f6386$var$isWritable = $772Et.isWritable, $bb41b314080f6386$var$isNodeStream = $772Et.isNodeStream;

var $bb41b314080f6386$require$deprecate = (parcelRequire("2QqeP")).deprecate;

var $bb41b314080f6386$var$ArrayPrototypePush = (parcelRequire("lD0c5")).ArrayPrototypePush, $bb41b314080f6386$var$Boolean = (parcelRequire("lD0c5")).Boolean, $bb41b314080f6386$var$MathFloor = (parcelRequire("lD0c5")).MathFloor, $bb41b314080f6386$var$Number = (parcelRequire("lD0c5")).Number, $bb41b314080f6386$var$NumberIsNaN = (parcelRequire("lD0c5")).NumberIsNaN, $bb41b314080f6386$var$Promise = (parcelRequire("lD0c5")).Promise, $bb41b314080f6386$var$PromiseReject = (parcelRequire("lD0c5")).PromiseReject, $bb41b314080f6386$var$PromiseResolve = (parcelRequire("lD0c5")).PromiseResolve, $bb41b314080f6386$var$PromisePrototypeThen = (parcelRequire("lD0c5")).PromisePrototypeThen, $bb41b314080f6386$var$Symbol = (parcelRequire("lD0c5")).Symbol;
var $bb41b314080f6386$var$kEmpty = $bb41b314080f6386$var$Symbol('kEmpty');
var $bb41b314080f6386$var$kEof = $bb41b314080f6386$var$Symbol('kEof');
function $bb41b314080f6386$var$compose(stream, options) {
    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
    if ($bb41b314080f6386$var$isNodeStream(stream) && !$bb41b314080f6386$var$isWritable(stream)) throw new $bb41b314080f6386$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $43KfJ(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $bb41b314080f6386$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $bb41b314080f6386$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $bb41b314080f6386$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $bb41b314080f6386$var$MathFloor(options.highWaterMark);
    $bb41b314080f6386$var$validateInteger(concurrency, 'options.concurrency', 1);
    $bb41b314080f6386$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $bb41b314080f6386$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $bb41b314080f6386$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $bb41b314080f6386$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $bb41b314080f6386$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $bb41b314080f6386$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $bb41b314080f6386$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($bb41b314080f6386$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $bb41b314080f6386$var$PromiseReject(err1);
                                $bb41b314080f6386$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("2QqeP")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($bb41b314080f6386$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $bb41b314080f6386$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $bb41b314080f6386$var$AbortError();
                        if (!(val !== $bb41b314080f6386$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $bb41b314080f6386$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bb41b314080f6386$var$asIndexedPairs(options) {
    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $bb41b314080f6386$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bb41b314080f6386$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bb41b314080f6386$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $bb41b314080f6386$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $bb41b314080f6386$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $bb41b314080f6386$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bb41b314080f6386$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $bb41b314080f6386$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $bb41b314080f6386$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($bb41b314080f6386$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $bb41b314080f6386$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $bb41b314080f6386$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $bb41b314080f6386$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $bb41b314080f6386$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($bb41b314080f6386$var$ERR_MISSING_ARGS);
function $bb41b314080f6386$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $bb41b314080f6386$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $bb41b314080f6386$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $bb41b314080f6386$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $bb41b314080f6386$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $bb41b314080f6386$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $bb41b314080f6386$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $bb41b314080f6386$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $bb41b314080f6386$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $bb41b314080f6386$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $bb41b314080f6386$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $bb41b314080f6386$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $bb41b314080f6386$var$flatMap(fn, options) {
    var values = $bb41b314080f6386$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $bb41b314080f6386$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $bb41b314080f6386$var$Number(number);
    if ($bb41b314080f6386$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $bb41b314080f6386$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $bb41b314080f6386$var$drop(number, options) {
    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
    number = $bb41b314080f6386$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $bb41b314080f6386$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $bb41b314080f6386$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $bb41b314080f6386$var$take(number, options) {
    if (options != null) $bb41b314080f6386$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $bb41b314080f6386$var$validateAbortSignal(options.signal, 'options.signal');
    number = $bb41b314080f6386$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $bb41b314080f6386$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $bb41b314080f6386$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$bb41b314080f6386$export$42af8c323be37587 = {
    asIndexedPairs: $bb41b314080f6386$require$deprecate($bb41b314080f6386$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $bb41b314080f6386$var$drop,
    filter: $bb41b314080f6386$var$filter,
    flatMap: $bb41b314080f6386$var$flatMap,
    map: $bb41b314080f6386$var$map,
    take: $bb41b314080f6386$var$take,
    compose: $bb41b314080f6386$var$compose
};
$bb41b314080f6386$export$f405f72c701dad87 = {
    every: $bb41b314080f6386$var$every,
    forEach: $bb41b314080f6386$var$forEach,
    reduce: $bb41b314080f6386$var$reduce,
    toArray: $bb41b314080f6386$var$toArray,
    some: $bb41b314080f6386$var$some,
    find: $bb41b314080f6386$var$find
};

});
parcelRegister("eZpbD", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $ae9a4cbb15574441$var$ArrayIsArray = $lD0c5.ArrayIsArray, $ae9a4cbb15574441$var$ArrayPrototypeIncludes = $lD0c5.ArrayPrototypeIncludes, $ae9a4cbb15574441$var$ArrayPrototypeJoin = $lD0c5.ArrayPrototypeJoin, $ae9a4cbb15574441$var$ArrayPrototypeMap = $lD0c5.ArrayPrototypeMap, $ae9a4cbb15574441$var$NumberIsInteger = $lD0c5.NumberIsInteger, $ae9a4cbb15574441$var$NumberIsNaN = $lD0c5.NumberIsNaN, $ae9a4cbb15574441$var$NumberMAX_SAFE_INTEGER = $lD0c5.NumberMAX_SAFE_INTEGER, $ae9a4cbb15574441$var$NumberMIN_SAFE_INTEGER = $lD0c5.NumberMIN_SAFE_INTEGER, $ae9a4cbb15574441$var$NumberParseInt = $lD0c5.NumberParseInt, $ae9a4cbb15574441$var$ObjectPrototypeHasOwnProperty = $lD0c5.ObjectPrototypeHasOwnProperty, $ae9a4cbb15574441$var$RegExpPrototypeExec = $lD0c5.RegExpPrototypeExec, $ae9a4cbb15574441$var$String = $lD0c5.String, $ae9a4cbb15574441$var$StringPrototypeToUpperCase = $lD0c5.StringPrototypeToUpperCase, $ae9a4cbb15574441$var$StringPrototypeTrim = $lD0c5.StringPrototypeTrim;

var $4qHMP = parcelRequire("4qHMP");
var $ae9a4cbb15574441$var$hideStackFrames = $4qHMP.hideStackFrames, $ae9a4cbb15574441$var$_require_codes = $4qHMP.codes, $ae9a4cbb15574441$var$ERR_SOCKET_BAD_PORT = $ae9a4cbb15574441$var$_require_codes.ERR_SOCKET_BAD_PORT, $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE = $ae9a4cbb15574441$var$_require_codes.ERR_INVALID_ARG_TYPE, $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE = $ae9a4cbb15574441$var$_require_codes.ERR_INVALID_ARG_VALUE, $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE = $ae9a4cbb15574441$var$_require_codes.ERR_OUT_OF_RANGE, $ae9a4cbb15574441$var$ERR_UNKNOWN_SIGNAL = $ae9a4cbb15574441$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $2QqeP = parcelRequire("2QqeP");
var $ae9a4cbb15574441$require$normalizeEncoding = $2QqeP.normalizeEncoding;

var $2QqeP = parcelRequire("2QqeP");
var $ae9a4cbb15574441$require$_require_types = $2QqeP.types;
var $ae9a4cbb15574441$var$isAsyncFunction = $ae9a4cbb15574441$require$_require_types.isAsyncFunction, $ae9a4cbb15574441$var$isArrayBufferView = $ae9a4cbb15574441$require$_require_types.isArrayBufferView;
var $ae9a4cbb15574441$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $ae9a4cbb15574441$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $ae9a4cbb15574441$var$isUint32(value) {
    return value === value >>> 0;
}
var $ae9a4cbb15574441$var$octalReg = /^[0-7]+$/;
var $ae9a4cbb15574441$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $ae9a4cbb15574441$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($ae9a4cbb15574441$var$RegExpPrototypeExec($ae9a4cbb15574441$var$octalReg, value) === null) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE(name, value, $ae9a4cbb15574441$var$modeDesc);
        value = $ae9a4cbb15574441$var$NumberParseInt(value, 8);
    }
    $ae9a4cbb15574441$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $ae9a4cbb15574441$var$validateInteger = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ae9a4cbb15574441$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $ae9a4cbb15574441$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ae9a4cbb15574441$var$NumberIsInteger(value)) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $ae9a4cbb15574441$var$validateInt32 = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ae9a4cbb15574441$var$NumberIsInteger(value)) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $ae9a4cbb15574441$var$validateUint32 = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ae9a4cbb15574441$var$NumberIsInteger(value)) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $ae9a4cbb15574441$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $ae9a4cbb15574441$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $ae9a4cbb15574441$var$NumberIsNaN(value)) throw new $ae9a4cbb15574441$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $ae9a4cbb15574441$var$validateOneOf = $ae9a4cbb15574441$var$hideStackFrames(function(value, name, oneOf) {
    if (!$ae9a4cbb15574441$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $ae9a4cbb15574441$var$ArrayPrototypeJoin($ae9a4cbb15574441$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $ae9a4cbb15574441$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $ae9a4cbb15574441$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $ae9a4cbb15574441$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$ae9a4cbb15574441$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $ae9a4cbb15574441$var$validateObject = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $ae9a4cbb15574441$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $ae9a4cbb15574441$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $ae9a4cbb15574441$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $ae9a4cbb15574441$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $ae9a4cbb15574441$var$validateDictionary = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $ae9a4cbb15574441$var$validateArray = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$ae9a4cbb15574441$var$ArrayIsArray(value)) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $ae9a4cbb15574441$var$validateStringArray(value, name) {
    $ae9a4cbb15574441$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$ae9a4cbb15574441$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $ae9a4cbb15574441$var$validateBooleanArray(value, name) {
    $ae9a4cbb15574441$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$ae9a4cbb15574441$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $ae9a4cbb15574441$var$validateAbortSignalArray(value, name) {
    $ae9a4cbb15574441$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $ae9a4cbb15574441$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $ae9a4cbb15574441$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $ae9a4cbb15574441$var$validateString(signal, name);
    if ($ae9a4cbb15574441$var$signals[signal] === undefined) {
        if ($ae9a4cbb15574441$var$signals[$ae9a4cbb15574441$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $ae9a4cbb15574441$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $ae9a4cbb15574441$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $ae9a4cbb15574441$var$validateBuffer = $ae9a4cbb15574441$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$ae9a4cbb15574441$var$isArrayBufferView(buffer)) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $ae9a4cbb15574441$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $ae9a4cbb15574441$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $ae9a4cbb15574441$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $ae9a4cbb15574441$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $ae9a4cbb15574441$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $ae9a4cbb15574441$var$validateAbortSignal = $ae9a4cbb15574441$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $ae9a4cbb15574441$var$validateFunction = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $ae9a4cbb15574441$var$validatePlainFunction = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $ae9a4cbb15574441$var$isAsyncFunction(value)) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $ae9a4cbb15574441$var$validateUndefined = $ae9a4cbb15574441$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $ae9a4cbb15574441$var$validateUnion(value, name, union) {
    if (!$ae9a4cbb15574441$var$ArrayPrototypeIncludes(union, value)) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_TYPE(name, "('".concat($ae9a4cbb15574441$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $ae9a4cbb15574441$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $ae9a4cbb15574441$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$ae9a4cbb15574441$var$RegExpPrototypeExec($ae9a4cbb15574441$var$linkValueRegExp, value)) throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $ae9a4cbb15574441$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $ae9a4cbb15574441$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($ae9a4cbb15574441$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $ae9a4cbb15574441$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $ae9a4cbb15574441$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $ae9a4cbb15574441$var$isInt32,
    isUint32: $ae9a4cbb15574441$var$isUint32,
    parseFileMode: $ae9a4cbb15574441$var$parseFileMode,
    validateArray: $ae9a4cbb15574441$var$validateArray,
    validateStringArray: $ae9a4cbb15574441$var$validateStringArray,
    validateBooleanArray: $ae9a4cbb15574441$var$validateBooleanArray,
    validateAbortSignalArray: $ae9a4cbb15574441$var$validateAbortSignalArray,
    validateBoolean: $ae9a4cbb15574441$var$validateBoolean,
    validateBuffer: $ae9a4cbb15574441$var$validateBuffer,
    validateDictionary: $ae9a4cbb15574441$var$validateDictionary,
    validateEncoding: $ae9a4cbb15574441$var$validateEncoding,
    validateFunction: $ae9a4cbb15574441$var$validateFunction,
    validateInt32: $ae9a4cbb15574441$var$validateInt32,
    validateInteger: $ae9a4cbb15574441$var$validateInteger,
    validateNumber: $ae9a4cbb15574441$var$validateNumber,
    validateObject: $ae9a4cbb15574441$var$validateObject,
    validateOneOf: $ae9a4cbb15574441$var$validateOneOf,
    validatePlainFunction: $ae9a4cbb15574441$var$validatePlainFunction,
    validatePort: $ae9a4cbb15574441$var$validatePort,
    validateSignalName: $ae9a4cbb15574441$var$validateSignalName,
    validateString: $ae9a4cbb15574441$var$validateString,
    validateUint32: $ae9a4cbb15574441$var$validateUint32,
    validateUndefined: $ae9a4cbb15574441$var$validateUndefined,
    validateUnion: $ae9a4cbb15574441$var$validateUnion,
    validateAbortSignal: $ae9a4cbb15574441$var$validateAbortSignal,
    validateLinkHeaderValue: $ae9a4cbb15574441$var$validateLinkHeaderValue
};

});

parcelRegister("g0l3g", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4qHMP = parcelRequire("4qHMP");
/* replacement end */ var $ba6cf9da3fea96cf$var$AbortError = $4qHMP.AbortError, $ba6cf9da3fea96cf$var$codes = $4qHMP.codes;
var $ba6cf9da3fea96cf$var$ERR_INVALID_ARG_TYPE = $ba6cf9da3fea96cf$var$codes.ERR_INVALID_ARG_TYPE, $ba6cf9da3fea96cf$var$ERR_STREAM_PREMATURE_CLOSE = $ba6cf9da3fea96cf$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $ba6cf9da3fea96cf$var$kEmptyObject = (parcelRequire("2QqeP")).kEmptyObject, $ba6cf9da3fea96cf$var$once = (parcelRequire("2QqeP")).once;

var $eZpbD = parcelRequire("eZpbD");
var $ba6cf9da3fea96cf$var$validateAbortSignal = $eZpbD.validateAbortSignal, $ba6cf9da3fea96cf$var$validateFunction = $eZpbD.validateFunction, $ba6cf9da3fea96cf$var$validateObject = $eZpbD.validateObject, $ba6cf9da3fea96cf$var$validateBoolean = $eZpbD.validateBoolean;

var $lD0c5 = parcelRequire("lD0c5");
var $ba6cf9da3fea96cf$var$Promise = $lD0c5.Promise, $ba6cf9da3fea96cf$var$PromisePrototypeThen = $lD0c5.PromisePrototypeThen, $ba6cf9da3fea96cf$var$SymbolDispose = $lD0c5.SymbolDispose;

var $772Et = parcelRequire("772Et");
var $ba6cf9da3fea96cf$var$isClosed = $772Et.isClosed, $ba6cf9da3fea96cf$var$isReadable = $772Et.isReadable, $ba6cf9da3fea96cf$var$isReadableNodeStream = $772Et.isReadableNodeStream, $ba6cf9da3fea96cf$var$isReadableStream = $772Et.isReadableStream, $ba6cf9da3fea96cf$var$isReadableFinished = $772Et.isReadableFinished, $ba6cf9da3fea96cf$var$isReadableErrored = $772Et.isReadableErrored, $ba6cf9da3fea96cf$var$isWritable = $772Et.isWritable, $ba6cf9da3fea96cf$var$isWritableNodeStream = $772Et.isWritableNodeStream, $ba6cf9da3fea96cf$var$isWritableStream = $772Et.isWritableStream, $ba6cf9da3fea96cf$var$isWritableFinished = $772Et.isWritableFinished, $ba6cf9da3fea96cf$var$isWritableErrored = $772Et.isWritableErrored, $ba6cf9da3fea96cf$var$isNodeStream = $772Et.isNodeStream, $ba6cf9da3fea96cf$var$_willEmitClose = $772Et.willEmitClose, $ba6cf9da3fea96cf$var$kIsClosedPromise = $772Et.kIsClosedPromise;
var $ba6cf9da3fea96cf$var$addAbortListener;
function $ba6cf9da3fea96cf$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $ba6cf9da3fea96cf$var$nop = function() {};

function $ba6cf9da3fea96cf$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $ba6cf9da3fea96cf$var$kEmptyObject;
    } else if (options == null) options = $ba6cf9da3fea96cf$var$kEmptyObject;
    else $ba6cf9da3fea96cf$var$validateObject(options, 'options');
    $ba6cf9da3fea96cf$var$validateFunction(callback, 'callback');
    $ba6cf9da3fea96cf$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $ba6cf9da3fea96cf$var$once(callback);
    if ($ba6cf9da3fea96cf$var$isReadableStream(stream) || $ba6cf9da3fea96cf$var$isWritableStream(stream)) return $ba6cf9da3fea96cf$var$eosWeb(stream, options, callback);
    if (!$ba6cf9da3fea96cf$var$isNodeStream(stream)) throw new $ba6cf9da3fea96cf$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $ba6cf9da3fea96cf$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $ba6cf9da3fea96cf$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $ba6cf9da3fea96cf$var$_willEmitClose(stream) && $ba6cf9da3fea96cf$var$isReadableNodeStream(stream) === readable && $ba6cf9da3fea96cf$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $ba6cf9da3fea96cf$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $ba6cf9da3fea96cf$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $ba6cf9da3fea96cf$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $ba6cf9da3fea96cf$var$isWritableErrored(stream) || $ba6cf9da3fea96cf$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $ba6cf9da3fea96cf$var$isReadableNodeStream(stream, true)) {
            if (!$ba6cf9da3fea96cf$var$isReadableFinished(stream, false)) return callback.call(stream, new $ba6cf9da3fea96cf$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$ba6cf9da3fea96cf$var$isWritableFinished(stream, false)) return callback.call(stream, new $ba6cf9da3fea96cf$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $ba6cf9da3fea96cf$var$isWritableErrored(stream) || $ba6cf9da3fea96cf$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($ba6cf9da3fea96cf$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $ba6cf9da3fea96cf$var$isReadable(stream)) && (writableFinished || $ba6cf9da3fea96cf$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $ba6cf9da3fea96cf$var$isWritable(stream)) && (readableFinished || $ba6cf9da3fea96cf$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $ba6cf9da3fea96cf$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $ba6cf9da3fea96cf$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $ba6cf9da3fea96cf$var$addAbortListener = $ba6cf9da3fea96cf$var$addAbortListener || (parcelRequire("2QqeP")).addAbortListener;
            var disposable = $ba6cf9da3fea96cf$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $ba6cf9da3fea96cf$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$ba6cf9da3fea96cf$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $ba6cf9da3fea96cf$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $ba6cf9da3fea96cf$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $ba6cf9da3fea96cf$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $ba6cf9da3fea96cf$var$addAbortListener = $ba6cf9da3fea96cf$var$addAbortListener || (parcelRequire("2QqeP")).addAbortListener;
            var disposable = $ba6cf9da3fea96cf$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $ba6cf9da3fea96cf$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$ba6cf9da3fea96cf$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $ba6cf9da3fea96cf$var$PromisePrototypeThen(stream[$ba6cf9da3fea96cf$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $ba6cf9da3fea96cf$var$nop;
}
function $ba6cf9da3fea96cf$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $ba6cf9da3fea96cf$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $ba6cf9da3fea96cf$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $ba6cf9da3fea96cf$var$Promise(function(resolve, reject) {
        var cleanup = $ba6cf9da3fea96cf$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $ba6cf9da3fea96cf$var$eos;
module.exports.finished = $ba6cf9da3fea96cf$var$finished;

});
parcelRegister("772Et", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $52db3e775132b578$var$SymbolAsyncIterator = $lD0c5.SymbolAsyncIterator, $52db3e775132b578$var$SymbolIterator = $lD0c5.SymbolIterator, $52db3e775132b578$var$SymbolFor = $lD0c5.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $52db3e775132b578$var$kIsDestroyed = $52db3e775132b578$var$SymbolFor('nodejs.stream.destroyed');
var $52db3e775132b578$var$kIsErrored = $52db3e775132b578$var$SymbolFor('nodejs.stream.errored');
var $52db3e775132b578$var$kIsReadable = $52db3e775132b578$var$SymbolFor('nodejs.stream.readable');
var $52db3e775132b578$var$kIsWritable = $52db3e775132b578$var$SymbolFor('nodejs.stream.writable');
var $52db3e775132b578$var$kIsDisturbed = $52db3e775132b578$var$SymbolFor('nodejs.stream.disturbed');
var $52db3e775132b578$var$kIsClosedPromise = $52db3e775132b578$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $52db3e775132b578$var$kControllerErrorFunction = $52db3e775132b578$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $52db3e775132b578$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $52db3e775132b578$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $52db3e775132b578$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $52db3e775132b578$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $52db3e775132b578$var$isReadableStream(obj) {
    return !!(obj && !$52db3e775132b578$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $52db3e775132b578$var$isWritableStream(obj) {
    return !!(obj && !$52db3e775132b578$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $52db3e775132b578$var$isTransformStream(obj) {
    return !!(obj && !$52db3e775132b578$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $52db3e775132b578$var$isWebStream(obj) {
    return $52db3e775132b578$var$isReadableStream(obj) || $52db3e775132b578$var$isWritableStream(obj) || $52db3e775132b578$var$isTransformStream(obj);
}
function $52db3e775132b578$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$52db3e775132b578$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$52db3e775132b578$var$SymbolIterator] === 'function';
    return typeof obj[$52db3e775132b578$var$SymbolAsyncIterator] === 'function' || typeof obj[$52db3e775132b578$var$SymbolIterator] === 'function';
}
function $52db3e775132b578$var$isDestroyed(stream) {
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$52db3e775132b578$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $52db3e775132b578$var$isWritableEnded(stream) {
    if (!$52db3e775132b578$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $52db3e775132b578$var$isWritableFinished(stream, strict) {
    if (!$52db3e775132b578$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $52db3e775132b578$var$isReadableEnded(stream) {
    if (!$52db3e775132b578$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $52db3e775132b578$var$isReadableFinished(stream, strict) {
    if (!$52db3e775132b578$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $52db3e775132b578$var$isReadable(stream) {
    if (stream && stream[$52db3e775132b578$var$kIsReadable] != null) return stream[$52db3e775132b578$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($52db3e775132b578$var$isDestroyed(stream)) return false;
    return $52db3e775132b578$var$isReadableNodeStream(stream) && stream.readable && !$52db3e775132b578$var$isReadableFinished(stream);
}
function $52db3e775132b578$var$isWritable(stream) {
    if (stream && stream[$52db3e775132b578$var$kIsWritable] != null) return stream[$52db3e775132b578$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($52db3e775132b578$var$isDestroyed(stream)) return false;
    return $52db3e775132b578$var$isWritableNodeStream(stream) && stream.writable && !$52db3e775132b578$var$isWritableEnded(stream);
}
function $52db3e775132b578$var$isFinished(stream, opts) {
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    if ($52db3e775132b578$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $52db3e775132b578$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $52db3e775132b578$var$isWritable(stream)) return false;
    return true;
}
function $52db3e775132b578$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $52db3e775132b578$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $52db3e775132b578$var$isClosed(stream) {
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $52db3e775132b578$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $52db3e775132b578$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $52db3e775132b578$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $52db3e775132b578$var$isOutgoingMessage(stream);
}
function $52db3e775132b578$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $52db3e775132b578$var$willEmitClose(stream) {
    if (!$52db3e775132b578$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $52db3e775132b578$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $52db3e775132b578$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$52db3e775132b578$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $52db3e775132b578$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$52db3e775132b578$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $52db3e775132b578$var$isDestroyed,
    kIsDestroyed: $52db3e775132b578$var$kIsDestroyed,
    isDisturbed: $52db3e775132b578$var$isDisturbed,
    kIsDisturbed: $52db3e775132b578$var$kIsDisturbed,
    isErrored: $52db3e775132b578$var$isErrored,
    kIsErrored: $52db3e775132b578$var$kIsErrored,
    isReadable: $52db3e775132b578$var$isReadable,
    kIsReadable: $52db3e775132b578$var$kIsReadable,
    kIsClosedPromise: $52db3e775132b578$var$kIsClosedPromise,
    kControllerErrorFunction: $52db3e775132b578$var$kControllerErrorFunction,
    kIsWritable: $52db3e775132b578$var$kIsWritable,
    isClosed: $52db3e775132b578$var$isClosed,
    isDuplexNodeStream: $52db3e775132b578$var$isDuplexNodeStream,
    isFinished: $52db3e775132b578$var$isFinished,
    isIterable: $52db3e775132b578$var$isIterable,
    isReadableNodeStream: $52db3e775132b578$var$isReadableNodeStream,
    isReadableStream: $52db3e775132b578$var$isReadableStream,
    isReadableEnded: $52db3e775132b578$var$isReadableEnded,
    isReadableFinished: $52db3e775132b578$var$isReadableFinished,
    isReadableErrored: $52db3e775132b578$var$isReadableErrored,
    isNodeStream: $52db3e775132b578$var$isNodeStream,
    isWebStream: $52db3e775132b578$var$isWebStream,
    isWritable: $52db3e775132b578$var$isWritable,
    isWritableNodeStream: $52db3e775132b578$var$isWritableNodeStream,
    isWritableStream: $52db3e775132b578$var$isWritableStream,
    isWritableEnded: $52db3e775132b578$var$isWritableEnded,
    isWritableFinished: $52db3e775132b578$var$isWritableFinished,
    isWritableErrored: $52db3e775132b578$var$isWritableErrored,
    isServerRequest: $52db3e775132b578$var$isServerRequest,
    isServerResponse: $52db3e775132b578$var$isServerResponse,
    willEmitClose: $52db3e775132b578$var$willEmitClose,
    isTransformStream: $52db3e775132b578$var$isTransformStream
};

});


parcelRegister("43KfJ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $fBe60 = parcelRequire("fBe60");
var $2f4b521474906e48$require$pipeline = $fBe60.pipeline;

var $bysq0 = parcelRequire("bysq0");

var $68GSU = parcelRequire("68GSU");
var $2f4b521474906e48$require$destroyer = $68GSU.destroyer;

var $772Et = parcelRequire("772Et");
var $2f4b521474906e48$var$isNodeStream = $772Et.isNodeStream, $2f4b521474906e48$var$isReadable = $772Et.isReadable, $2f4b521474906e48$var$isWritable = $772Et.isWritable, $2f4b521474906e48$var$isWebStream = $772Et.isWebStream, $2f4b521474906e48$var$isTransformStream = $772Et.isTransformStream, $2f4b521474906e48$var$isWritableStream = $772Et.isWritableStream, $2f4b521474906e48$var$isReadableStream = $772Et.isReadableStream;

var $4qHMP = parcelRequire("4qHMP");
var $2f4b521474906e48$var$AbortError = $4qHMP.AbortError, $2f4b521474906e48$var$_require_codes = $4qHMP.codes, $2f4b521474906e48$var$ERR_INVALID_ARG_VALUE = $2f4b521474906e48$var$_require_codes.ERR_INVALID_ARG_VALUE, $2f4b521474906e48$var$ERR_MISSING_ARGS = $2f4b521474906e48$var$_require_codes.ERR_MISSING_ARGS;

var $g0l3g = parcelRequire("g0l3g");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $2f4b521474906e48$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $bysq0.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $bysq0.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $bysq0.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$2f4b521474906e48$var$isNodeStream(streams[n]) && !$2f4b521474906e48$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($2f4b521474906e48$var$isReadable(streams[n]) || $2f4b521474906e48$var$isReadableStream(streams[n]) || $2f4b521474906e48$var$isTransformStream(streams[n]))) throw new $2f4b521474906e48$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($2f4b521474906e48$var$isWritable(streams[n]) || $2f4b521474906e48$var$isWritableStream(streams[n]) || $2f4b521474906e48$var$isTransformStream(streams[n]))) throw new $2f4b521474906e48$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $2f4b521474906e48$require$pipeline(streams, onfinished);
    var writable = !!($2f4b521474906e48$var$isWritable(head) || $2f4b521474906e48$var$isWritableStream(head) || $2f4b521474906e48$var$isTransformStream(head));
    var readable = !!($2f4b521474906e48$var$isReadable(tail) || $2f4b521474906e48$var$isReadableStream(tail) || $2f4b521474906e48$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $bysq0({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($2f4b521474906e48$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($2f4b521474906e48$var$isWebStream(head)) {
            var writable1 = $2f4b521474906e48$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $2f4b521474906e48$var$isTransformStream(tail) ? tail.readable : tail;
        $g0l3g(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($2f4b521474906e48$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($2f4b521474906e48$var$isWebStream(tail)) {
            var readable1 = $2f4b521474906e48$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2f4b521474906e48$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($2f4b521474906e48$var$isNodeStream(tail)) $2f4b521474906e48$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("fBe60", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $b5b53ee2e2491f36$var$ArrayIsArray = $lD0c5.ArrayIsArray, $b5b53ee2e2491f36$var$Promise = $lD0c5.Promise, $b5b53ee2e2491f36$var$SymbolAsyncIterator = $lD0c5.SymbolAsyncIterator, $b5b53ee2e2491f36$var$SymbolDispose = $lD0c5.SymbolDispose;

var $g0l3g = parcelRequire("g0l3g");

var $b5b53ee2e2491f36$require$once = (parcelRequire("2QqeP")).once;

var $68GSU = parcelRequire("68GSU");

var $bysq0 = parcelRequire("bysq0");

var $4qHMP = parcelRequire("4qHMP");
var $b5b53ee2e2491f36$var$aggregateTwoErrors = $4qHMP.aggregateTwoErrors, $b5b53ee2e2491f36$var$_require_codes = $4qHMP.codes, $b5b53ee2e2491f36$var$ERR_INVALID_ARG_TYPE = $b5b53ee2e2491f36$var$_require_codes.ERR_INVALID_ARG_TYPE, $b5b53ee2e2491f36$var$ERR_INVALID_RETURN_VALUE = $b5b53ee2e2491f36$var$_require_codes.ERR_INVALID_RETURN_VALUE, $b5b53ee2e2491f36$var$ERR_MISSING_ARGS = $b5b53ee2e2491f36$var$_require_codes.ERR_MISSING_ARGS, $b5b53ee2e2491f36$var$ERR_STREAM_DESTROYED = $b5b53ee2e2491f36$var$_require_codes.ERR_STREAM_DESTROYED, $b5b53ee2e2491f36$var$ERR_STREAM_PREMATURE_CLOSE = $b5b53ee2e2491f36$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $b5b53ee2e2491f36$var$AbortError = $4qHMP.AbortError;

var $eZpbD = parcelRequire("eZpbD");
var $b5b53ee2e2491f36$var$validateFunction = $eZpbD.validateFunction, $b5b53ee2e2491f36$var$validateAbortSignal = $eZpbD.validateAbortSignal;

var $772Et = parcelRequire("772Et");
var $b5b53ee2e2491f36$var$isIterable = $772Et.isIterable, $b5b53ee2e2491f36$var$isReadable = $772Et.isReadable, $b5b53ee2e2491f36$var$isReadableNodeStream = $772Et.isReadableNodeStream, $b5b53ee2e2491f36$var$isNodeStream = $772Et.isNodeStream, $b5b53ee2e2491f36$var$isTransformStream = $772Et.isTransformStream, $b5b53ee2e2491f36$var$isWebStream = $772Et.isWebStream, $b5b53ee2e2491f36$var$isReadableStream = $772Et.isReadableStream, $b5b53ee2e2491f36$var$isReadableFinished = $772Et.isReadableFinished;

var $b5b53ee2e2491f36$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $b5b53ee2e2491f36$var$PassThrough;
var $b5b53ee2e2491f36$var$Readable;
var $b5b53ee2e2491f36$var$addAbortListener;
function $b5b53ee2e2491f36$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $g0l3g(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $68GSU.destroyer(stream, err || new $b5b53ee2e2491f36$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $b5b53ee2e2491f36$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $b5b53ee2e2491f36$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $b5b53ee2e2491f36$var$makeAsyncIterable(val) {
    if ($b5b53ee2e2491f36$var$isIterable(val)) return val;
    else if ($b5b53ee2e2491f36$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $b5b53ee2e2491f36$var$fromReadable(val);
    throw new $b5b53ee2e2491f36$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $b5b53ee2e2491f36$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$b5b53ee2e2491f36$var$Readable) $b5b53ee2e2491f36$var$Readable = (parcelRequire("77zC0"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($b5b53ee2e2491f36$var$Readable.prototype[$b5b53ee2e2491f36$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $b5b53ee2e2491f36$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $b5b53ee2e2491f36$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $g0l3g(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $b5b53ee2e2491f36$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $b5b53ee2e2491f36$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($b5b53ee2e2491f36$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $b5b53ee2e2491f36$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $b5b53ee2e2491f36$var$pipelineImpl(streams, $b5b53ee2e2491f36$require$once($b5b53ee2e2491f36$var$popCallback(streams)));
}


function $b5b53ee2e2491f36$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($b5b53ee2e2491f36$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $b5b53ee2e2491f36$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($b5b53ee2e2491f36$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($b5b53ee2e2491f36$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$b5b53ee2e2491f36$var$isIterable(ret)) throw new $b5b53ee2e2491f36$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($b5b53ee2e2491f36$var$isIterable(stream) || $b5b53ee2e2491f36$var$isReadableNodeStream(stream) || $b5b53ee2e2491f36$var$isTransformStream(stream)) ret = stream;
            else ret = $bysq0.from(stream);
        } else if (typeof stream === 'function') {
            if ($b5b53ee2e2491f36$var$isTransformStream(ret)) {
                var _ret;
                ret = $b5b53ee2e2491f36$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $b5b53ee2e2491f36$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$b5b53ee2e2491f36$var$isIterable(ret, true)) throw new $b5b53ee2e2491f36$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$b5b53ee2e2491f36$var$PassThrough) $b5b53ee2e2491f36$var$PassThrough = (parcelRequire("hHMZs"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $b5b53ee2e2491f36$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($b5b53ee2e2491f36$var$isIterable(ret, true)) {
                    finishCount++;
                    $b5b53ee2e2491f36$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($b5b53ee2e2491f36$var$isReadableStream(ret) || $b5b53ee2e2491f36$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $b5b53ee2e2491f36$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $b5b53ee2e2491f36$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $b5b53ee2e2491f36$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($b5b53ee2e2491f36$var$isNodeStream(stream)) {
            if ($b5b53ee2e2491f36$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $b5b53ee2e2491f36$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($b5b53ee2e2491f36$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($b5b53ee2e2491f36$var$isTransformStream(ret) || $b5b53ee2e2491f36$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $b5b53ee2e2491f36$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($b5b53ee2e2491f36$var$isIterable(ret)) {
                finishCount++;
                $b5b53ee2e2491f36$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $b5b53ee2e2491f36$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($b5b53ee2e2491f36$var$isWebStream(stream)) {
            if ($b5b53ee2e2491f36$var$isReadableNodeStream(ret)) {
                finishCount++;
                $b5b53ee2e2491f36$var$pumpToWeb($b5b53ee2e2491f36$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($b5b53ee2e2491f36$var$isReadableStream(ret) || $b5b53ee2e2491f36$var$isIterable(ret)) {
                finishCount++;
                $b5b53ee2e2491f36$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($b5b53ee2e2491f36$var$isTransformStream(ret)) {
                finishCount++;
                $b5b53ee2e2491f36$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $b5b53ee2e2491f36$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $bysq0.from(stream);
    };
    if (streams.length === 1 && $b5b53ee2e2491f36$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b5b53ee2e2491f36$var$ERR_MISSING_ARGS('streams');
    var ac = new $b5b53ee2e2491f36$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $b5b53ee2e2491f36$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $b5b53ee2e2491f36$var$AbortError());
    }
    $b5b53ee2e2491f36$var$addAbortListener = $b5b53ee2e2491f36$var$addAbortListener || (parcelRequire("2QqeP")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $b5b53ee2e2491f36$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$b5b53ee2e2491f36$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $b5b53ee2e2491f36$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $b5b53ee2e2491f36$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($b5b53ee2e2491f36$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $g0l3g(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $g0l3g(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $b5b53ee2e2491f36$var$pipelineImpl,
    pipeline: $b5b53ee2e2491f36$var$pipeline
};

});
parcelRegister("68GSU", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4qHMP = parcelRequire("4qHMP");
/* replacement end */ var $4784c16ec8bdc6f9$var$aggregateTwoErrors = $4qHMP.aggregateTwoErrors, $4784c16ec8bdc6f9$var$ERR_MULTIPLE_CALLBACK = $4qHMP.codes.ERR_MULTIPLE_CALLBACK, $4784c16ec8bdc6f9$var$AbortError = $4qHMP.AbortError;

var $lD0c5 = parcelRequire("lD0c5");
var $4784c16ec8bdc6f9$require$Symbol = $lD0c5.Symbol;

var $772Et = parcelRequire("772Et");
var $4784c16ec8bdc6f9$var$kIsDestroyed = $772Et.kIsDestroyed, $4784c16ec8bdc6f9$var$isDestroyed = $772Et.isDestroyed, $4784c16ec8bdc6f9$var$isFinished = $772Et.isFinished, $4784c16ec8bdc6f9$var$isServerRequest = $772Et.isServerRequest;
var $4784c16ec8bdc6f9$var$kDestroy = $4784c16ec8bdc6f9$require$Symbol('kDestroy');
var $4784c16ec8bdc6f9$var$kConstruct = $4784c16ec8bdc6f9$require$Symbol('kConstruct');
function $4784c16ec8bdc6f9$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $4784c16ec8bdc6f9$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $4784c16ec8bdc6f9$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($4784c16ec8bdc6f9$var$kDestroy, function(er) {
        $4784c16ec8bdc6f9$var$_destroy(this, $4784c16ec8bdc6f9$var$aggregateTwoErrors(er, err), cb);
    });
    else $4784c16ec8bdc6f9$var$_destroy(this, err, cb);
    return this;
}
function $4784c16ec8bdc6f9$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $4784c16ec8bdc6f9$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $4784c16ec8bdc6f9$var$emitErrorCloseNT(self, err) {
    $4784c16ec8bdc6f9$var$emitErrorNT(self, err);
    $4784c16ec8bdc6f9$var$emitCloseNT(self);
}
function $4784c16ec8bdc6f9$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $4784c16ec8bdc6f9$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $4784c16ec8bdc6f9$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $4784c16ec8bdc6f9$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitErrorNT, stream, err);
        else $4784c16ec8bdc6f9$var$emitErrorNT(stream, err);
    }
}
function $4784c16ec8bdc6f9$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($4784c16ec8bdc6f9$var$kConstruct, cb);
    if (stream.listenerCount($4784c16ec8bdc6f9$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($4784c16ec8bdc6f9$var$constructNT, stream);
}
function $4784c16ec8bdc6f9$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $4784c16ec8bdc6f9$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $4784c16ec8bdc6f9$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($4784c16ec8bdc6f9$var$kDestroy, err);
        else if (err) $4784c16ec8bdc6f9$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $4784c16ec8bdc6f9$var$emitConstructNT(stream) {
    stream.emit($4784c16ec8bdc6f9$var$kConstruct);
}
function $4784c16ec8bdc6f9$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $4784c16ec8bdc6f9$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $4784c16ec8bdc6f9$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $4784c16ec8bdc6f9$var$destroyer(stream, err) {
    if (!stream || $4784c16ec8bdc6f9$var$isDestroyed(stream)) return;
    if (!err && !$4784c16ec8bdc6f9$var$isFinished(stream)) err = new $4784c16ec8bdc6f9$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($4784c16ec8bdc6f9$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($4784c16ec8bdc6f9$var$isRequest(stream)) stream.abort();
    else if ($4784c16ec8bdc6f9$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($4784c16ec8bdc6f9$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$4784c16ec8bdc6f9$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $4784c16ec8bdc6f9$var$construct,
    destroyer: $4784c16ec8bdc6f9$var$destroyer,
    destroy: $4784c16ec8bdc6f9$var$destroy,
    undestroy: $4784c16ec8bdc6f9$var$undestroy,
    errorOrDestroy: $4784c16ec8bdc6f9$var$errorOrDestroy
};

});

parcelRegister("bysq0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $8698ea05159fbd02$var$ObjectDefineProperties = $lD0c5.ObjectDefineProperties, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor = $lD0c5.ObjectGetOwnPropertyDescriptor, $8698ea05159fbd02$var$ObjectKeys = $lD0c5.ObjectKeys, $8698ea05159fbd02$var$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf;
module.exports = $8698ea05159fbd02$var$Duplex;

var $77zC0 = parcelRequire("77zC0");

var $evyZp = parcelRequire("evyZp");
$8698ea05159fbd02$var$ObjectSetPrototypeOf($8698ea05159fbd02$var$Duplex.prototype, $77zC0.prototype);
$8698ea05159fbd02$var$ObjectSetPrototypeOf($8698ea05159fbd02$var$Duplex, $77zC0);
{
    var $8698ea05159fbd02$var$keys = $8698ea05159fbd02$var$ObjectKeys($evyZp.prototype);
    // Allow the keys array to be GC'ed.
    for(var $8698ea05159fbd02$var$i = 0; $8698ea05159fbd02$var$i < $8698ea05159fbd02$var$keys.length; $8698ea05159fbd02$var$i++){
        var $8698ea05159fbd02$var$method = $8698ea05159fbd02$var$keys[$8698ea05159fbd02$var$i];
        if (!$8698ea05159fbd02$var$Duplex.prototype[$8698ea05159fbd02$var$method]) $8698ea05159fbd02$var$Duplex.prototype[$8698ea05159fbd02$var$method] = $evyZp.prototype[$8698ea05159fbd02$var$method];
    }
}function $8698ea05159fbd02$var$Duplex(options) {
    if (!(this instanceof $8698ea05159fbd02$var$Duplex)) return new $8698ea05159fbd02$var$Duplex(options);
    $77zC0.call(this, options);
    $evyZp.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$8698ea05159fbd02$var$ObjectDefineProperties($8698ea05159fbd02$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $8698ea05159fbd02$var$ObjectGetOwnPropertyDescriptor($evyZp.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $8698ea05159fbd02$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8698ea05159fbd02$var$lazyWebStreams() {
    if ($8698ea05159fbd02$var$webStreamsAdapters === undefined) $8698ea05159fbd02$var$webStreamsAdapters = {};
    return $8698ea05159fbd02$var$webStreamsAdapters;
}
$8698ea05159fbd02$var$Duplex.fromWeb = function(pair, options) {
    return $8698ea05159fbd02$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$8698ea05159fbd02$var$Duplex.toWeb = function(duplex) {
    return $8698ea05159fbd02$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $8698ea05159fbd02$var$duplexify;

$8698ea05159fbd02$var$Duplex.from = function(body) {
    if (!$8698ea05159fbd02$var$duplexify) $8698ea05159fbd02$var$duplexify = (parcelRequire("bjhOR"));
    return $8698ea05159fbd02$var$duplexify(body, 'body');
};

});
parcelRegister("77zC0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lD0c5 = parcelRequire("lD0c5");
/* replacement end */ var $52f4cfa60ee593c4$var$ArrayPrototypeIndexOf = $lD0c5.ArrayPrototypeIndexOf, $52f4cfa60ee593c4$var$NumberIsInteger = $lD0c5.NumberIsInteger, $52f4cfa60ee593c4$var$NumberIsNaN = $lD0c5.NumberIsNaN, $52f4cfa60ee593c4$var$NumberParseInt = $lD0c5.NumberParseInt, $52f4cfa60ee593c4$var$ObjectDefineProperties = $lD0c5.ObjectDefineProperties, $52f4cfa60ee593c4$var$ObjectKeys = $lD0c5.ObjectKeys, $52f4cfa60ee593c4$var$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf, $52f4cfa60ee593c4$var$Promise = $lD0c5.Promise, $52f4cfa60ee593c4$var$SafeSet = $lD0c5.SafeSet, $52f4cfa60ee593c4$var$SymbolAsyncDispose = $lD0c5.SymbolAsyncDispose, $52f4cfa60ee593c4$var$SymbolAsyncIterator = $lD0c5.SymbolAsyncIterator, $52f4cfa60ee593c4$var$Symbol = $lD0c5.Symbol;
module.exports = $52f4cfa60ee593c4$var$Readable;
$52f4cfa60ee593c4$var$Readable.ReadableState = $52f4cfa60ee593c4$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $52f4cfa60ee593c4$var$EE = $bBoAO.EventEmitter;

var $eXLnR = parcelRequire("eXLnR");
var $52f4cfa60ee593c4$var$Stream = $eXLnR.Stream, $52f4cfa60ee593c4$var$prependListener = $eXLnR.prependListener;

var $hXCcT = parcelRequire("hXCcT");
var $52f4cfa60ee593c4$require$Buffer = $hXCcT.Buffer;

var $6nuWS = parcelRequire("6nuWS");
var $52f4cfa60ee593c4$require$addAbortSignal = $6nuWS.addAbortSignal;

var $g0l3g = parcelRequire("g0l3g");

var $52f4cfa60ee593c4$var$debug = (parcelRequire("2QqeP")).debuglog('stream', function(fn) {
    $52f4cfa60ee593c4$var$debug = fn;
});

var $8fs7c = parcelRequire("8fs7c");

var $68GSU = parcelRequire("68GSU");

var $6w72j = parcelRequire("6w72j");
var $52f4cfa60ee593c4$var$getHighWaterMark = $6w72j.getHighWaterMark, $52f4cfa60ee593c4$var$getDefaultHighWaterMark = $6w72j.getDefaultHighWaterMark;

var $4qHMP = parcelRequire("4qHMP");
var $52f4cfa60ee593c4$var$aggregateTwoErrors = $4qHMP.aggregateTwoErrors, $52f4cfa60ee593c4$var$_require_codes = $4qHMP.codes, $52f4cfa60ee593c4$var$ERR_INVALID_ARG_TYPE = $52f4cfa60ee593c4$var$_require_codes.ERR_INVALID_ARG_TYPE, $52f4cfa60ee593c4$var$ERR_METHOD_NOT_IMPLEMENTED = $52f4cfa60ee593c4$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $52f4cfa60ee593c4$var$ERR_OUT_OF_RANGE = $52f4cfa60ee593c4$var$_require_codes.ERR_OUT_OF_RANGE, $52f4cfa60ee593c4$var$ERR_STREAM_PUSH_AFTER_EOF = $52f4cfa60ee593c4$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $52f4cfa60ee593c4$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $52f4cfa60ee593c4$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $52f4cfa60ee593c4$var$AbortError = $4qHMP.AbortError;

var $eZpbD = parcelRequire("eZpbD");
var $52f4cfa60ee593c4$require$validateObject = $eZpbD.validateObject;
var $52f4cfa60ee593c4$var$kPaused = $52f4cfa60ee593c4$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $52f4cfa60ee593c4$require$StringDecoder = $3Jf7C.StringDecoder;

var $bI8P3 = parcelRequire("bI8P3");
$52f4cfa60ee593c4$var$ObjectSetPrototypeOf($52f4cfa60ee593c4$var$Readable.prototype, $52f4cfa60ee593c4$var$Stream.prototype);
$52f4cfa60ee593c4$var$ObjectSetPrototypeOf($52f4cfa60ee593c4$var$Readable, $52f4cfa60ee593c4$var$Stream);
var $52f4cfa60ee593c4$var$nop = function() {};
var $52f4cfa60ee593c4$var$errorOrDestroy = $68GSU.errorOrDestroy;
var $52f4cfa60ee593c4$var$kObjectMode = 1;
var $52f4cfa60ee593c4$var$kEnded = 2;
var $52f4cfa60ee593c4$var$kEndEmitted = 4;
var $52f4cfa60ee593c4$var$kReading = 8;
var $52f4cfa60ee593c4$var$kConstructed = 16;
var $52f4cfa60ee593c4$var$kSync = 32;
var $52f4cfa60ee593c4$var$kNeedReadable = 64;
var $52f4cfa60ee593c4$var$kEmittedReadable = 128;
var $52f4cfa60ee593c4$var$kReadableListening = 256;
var $52f4cfa60ee593c4$var$kResumeScheduled = 512;
var $52f4cfa60ee593c4$var$kErrorEmitted = 1024;
var $52f4cfa60ee593c4$var$kEmitClose = 2048;
var $52f4cfa60ee593c4$var$kAutoDestroy = 4096;
var $52f4cfa60ee593c4$var$kDestroyed = 8192;
var $52f4cfa60ee593c4$var$kClosed = 16384;
var $52f4cfa60ee593c4$var$kCloseEmitted = 32768;
var $52f4cfa60ee593c4$var$kMultiAwaitDrain = 65536;
var $52f4cfa60ee593c4$var$kReadingMore = 131072;
var $52f4cfa60ee593c4$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $52f4cfa60ee593c4$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$52f4cfa60ee593c4$var$ObjectDefineProperties($52f4cfa60ee593c4$var$ReadableState.prototype, {
    objectMode: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kObjectMode),
    ended: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kEnded),
    endEmitted: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kEndEmitted),
    reading: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kNeedReadable),
    emittedReadable: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kEmittedReadable),
    readableListening: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kReadableListening),
    resumeScheduled: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kErrorEmitted),
    emitClose: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kEmitClose),
    autoDestroy: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kCloseEmitted),
    multiAwaitDrain: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kReadingMore),
    dataEmitted: $52f4cfa60ee593c4$var$makeBitMapDescriptor($52f4cfa60ee593c4$var$kDataEmitted)
});

function $52f4cfa60ee593c4$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("bysq0"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $52f4cfa60ee593c4$var$kEmitClose | $52f4cfa60ee593c4$var$kAutoDestroy | $52f4cfa60ee593c4$var$kConstructed | $52f4cfa60ee593c4$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $52f4cfa60ee593c4$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $52f4cfa60ee593c4$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $52f4cfa60ee593c4$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $52f4cfa60ee593c4$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $8fs7c();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$52f4cfa60ee593c4$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$52f4cfa60ee593c4$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$52f4cfa60ee593c4$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $52f4cfa60ee593c4$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $52f4cfa60ee593c4$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $52f4cfa60ee593c4$var$Readable)) return new $52f4cfa60ee593c4$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("bysq0"));
    this._readableState = new $52f4cfa60ee593c4$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $52f4cfa60ee593c4$require$addAbortSignal(options.signal, this);
    }
    $52f4cfa60ee593c4$var$Stream.call(this, options);
    $68GSU.construct(this, function() {
        if (_this._readableState.needReadable) $52f4cfa60ee593c4$var$maybeReadMore(_this, _this._readableState);
    });
}
$52f4cfa60ee593c4$var$Readable.prototype.destroy = $68GSU.destroy;
$52f4cfa60ee593c4$var$Readable.prototype._undestroy = $68GSU.undestroy;
$52f4cfa60ee593c4$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$52f4cfa60ee593c4$var$Readable.prototype[$52f4cfa60ee593c4$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$52f4cfa60ee593c4$var$Readable.prototype[$52f4cfa60ee593c4$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $52f4cfa60ee593c4$var$AbortError();
        this.destroy(error);
    }
    return new $52f4cfa60ee593c4$var$Promise(function(resolve, reject) {
        return $g0l3g(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$52f4cfa60ee593c4$var$Readable.prototype.push = function(chunk, encoding) {
    return $52f4cfa60ee593c4$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$52f4cfa60ee593c4$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $52f4cfa60ee593c4$var$readableAddChunk(this, chunk, encoding, true);
};
function $52f4cfa60ee593c4$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $52f4cfa60ee593c4$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $52f4cfa60ee593c4$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $52f4cfa60ee593c4$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $52f4cfa60ee593c4$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $52f4cfa60ee593c4$require$Buffer) encoding = '';
        else if ($52f4cfa60ee593c4$var$Stream._isUint8Array(chunk)) {
            chunk = $52f4cfa60ee593c4$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $52f4cfa60ee593c4$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $52f4cfa60ee593c4$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$52f4cfa60ee593c4$var$kReading;
        $52f4cfa60ee593c4$var$onEofChunk(stream, state);
    } else if ((state.state & $52f4cfa60ee593c4$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $52f4cfa60ee593c4$var$kEndEmitted) !== 0) $52f4cfa60ee593c4$var$errorOrDestroy(stream, new $52f4cfa60ee593c4$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $52f4cfa60ee593c4$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $52f4cfa60ee593c4$var$errorOrDestroy(stream, new $52f4cfa60ee593c4$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$52f4cfa60ee593c4$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $52f4cfa60ee593c4$var$addChunk(stream, state, chunk, false);
                else $52f4cfa60ee593c4$var$maybeReadMore(stream, state);
            } else $52f4cfa60ee593c4$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$52f4cfa60ee593c4$var$kReading;
        $52f4cfa60ee593c4$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $52f4cfa60ee593c4$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $52f4cfa60ee593c4$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $52f4cfa60ee593c4$var$kNeedReadable) !== 0) $52f4cfa60ee593c4$var$emitReadable(stream);
    }
    $52f4cfa60ee593c4$var$maybeReadMore(stream, state);
}
$52f4cfa60ee593c4$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$52f4cfa60ee593c4$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$52f4cfa60ee593c4$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $52f4cfa60ee593c4$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$52f4cfa60ee593c4$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $52f4cfa60ee593c4$var$MAX_HWM = 0x40000000;
function $52f4cfa60ee593c4$var$computeNewHighWaterMark(n) {
    if (n > $52f4cfa60ee593c4$var$MAX_HWM) throw new $52f4cfa60ee593c4$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $52f4cfa60ee593c4$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $52f4cfa60ee593c4$var$kObjectMode) !== 0) return 1;
    if ($52f4cfa60ee593c4$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$52f4cfa60ee593c4$var$Readable.prototype.read = function(n) {
    $52f4cfa60ee593c4$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$52f4cfa60ee593c4$var$NumberIsInteger(n)) n = $52f4cfa60ee593c4$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $52f4cfa60ee593c4$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$52f4cfa60ee593c4$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $52f4cfa60ee593c4$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $52f4cfa60ee593c4$var$endReadable(this);
        else $52f4cfa60ee593c4$var$emitReadable(this);
        return null;
    }
    n = $52f4cfa60ee593c4$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $52f4cfa60ee593c4$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $52f4cfa60ee593c4$var$kNeedReadable) !== 0;
    $52f4cfa60ee593c4$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $52f4cfa60ee593c4$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $52f4cfa60ee593c4$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $52f4cfa60ee593c4$var$debug('do read');
        state.state |= $52f4cfa60ee593c4$var$kReading | $52f4cfa60ee593c4$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $52f4cfa60ee593c4$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $52f4cfa60ee593c4$var$errorOrDestroy(this, err);
        }
        state.state &= ~$52f4cfa60ee593c4$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $52f4cfa60ee593c4$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $52f4cfa60ee593c4$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $52f4cfa60ee593c4$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $52f4cfa60ee593c4$var$onEofChunk(stream, state) {
    $52f4cfa60ee593c4$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $52f4cfa60ee593c4$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $52f4cfa60ee593c4$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $52f4cfa60ee593c4$var$emitReadable(stream) {
    var state = stream._readableState;
    $52f4cfa60ee593c4$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $52f4cfa60ee593c4$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($52f4cfa60ee593c4$var$emitReadable_, stream);
    }
}
function $52f4cfa60ee593c4$var$emitReadable_(stream) {
    var state = stream._readableState;
    $52f4cfa60ee593c4$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $52f4cfa60ee593c4$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $52f4cfa60ee593c4$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($52f4cfa60ee593c4$var$maybeReadMore_, stream, state);
    }
}
function $52f4cfa60ee593c4$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $52f4cfa60ee593c4$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$52f4cfa60ee593c4$var$Readable.prototype._read = function(n) {
    throw new $52f4cfa60ee593c4$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$52f4cfa60ee593c4$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $52f4cfa60ee593c4$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $52f4cfa60ee593c4$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $52f4cfa60ee593c4$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $52f4cfa60ee593c4$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $52f4cfa60ee593c4$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $52f4cfa60ee593c4$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $52f4cfa60ee593c4$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $52f4cfa60ee593c4$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $52f4cfa60ee593c4$var$debug('ondata');
        var ret = dest.write(chunk);
        $52f4cfa60ee593c4$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $52f4cfa60ee593c4$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $52f4cfa60ee593c4$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $52f4cfa60ee593c4$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $52f4cfa60ee593c4$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $52f4cfa60ee593c4$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $52f4cfa60ee593c4$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $52f4cfa60ee593c4$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $52f4cfa60ee593c4$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $52f4cfa60ee593c4$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$52f4cfa60ee593c4$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $52f4cfa60ee593c4$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$52f4cfa60ee593c4$var$Readable.prototype.on = function(ev, fn) {
    var res = $52f4cfa60ee593c4$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $52f4cfa60ee593c4$var$debug('on readable', state.length, state.reading);
            if (state.length) $52f4cfa60ee593c4$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($52f4cfa60ee593c4$var$nReadingNextTick, this);
        }
    }
    return res;
};
$52f4cfa60ee593c4$var$Readable.prototype.addListener = $52f4cfa60ee593c4$var$Readable.prototype.on;
$52f4cfa60ee593c4$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $52f4cfa60ee593c4$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($52f4cfa60ee593c4$var$updateReadableListening, this);
    return res;
};
$52f4cfa60ee593c4$var$Readable.prototype.off = $52f4cfa60ee593c4$var$Readable.prototype.removeListener;
$52f4cfa60ee593c4$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $52f4cfa60ee593c4$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($52f4cfa60ee593c4$var$updateReadableListening, this);
    return res;
};
function $52f4cfa60ee593c4$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$52f4cfa60ee593c4$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $52f4cfa60ee593c4$var$nReadingNextTick(self) {
    $52f4cfa60ee593c4$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$52f4cfa60ee593c4$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $52f4cfa60ee593c4$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $52f4cfa60ee593c4$var$resume(this, state);
    }
    state[$52f4cfa60ee593c4$var$kPaused] = false;
    return this;
};
function $52f4cfa60ee593c4$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($52f4cfa60ee593c4$var$resume_, stream, state);
    }
}
function $52f4cfa60ee593c4$var$resume_(stream, state) {
    $52f4cfa60ee593c4$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $52f4cfa60ee593c4$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$52f4cfa60ee593c4$var$Readable.prototype.pause = function() {
    $52f4cfa60ee593c4$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $52f4cfa60ee593c4$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$52f4cfa60ee593c4$var$kPaused] = true;
    return this;
};
function $52f4cfa60ee593c4$var$flow(stream) {
    var state = stream._readableState;
    $52f4cfa60ee593c4$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$52f4cfa60ee593c4$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $52f4cfa60ee593c4$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $52f4cfa60ee593c4$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$52f4cfa60ee593c4$var$Readable.prototype[$52f4cfa60ee593c4$var$SymbolAsyncIterator] = function() {
    return $52f4cfa60ee593c4$var$streamToAsyncIterator(this);
};
$52f4cfa60ee593c4$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $52f4cfa60ee593c4$require$validateObject(options, 'options');
    return $52f4cfa60ee593c4$var$streamToAsyncIterator(this, options);
};
function $52f4cfa60ee593c4$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $52f4cfa60ee593c4$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $52f4cfa60ee593c4$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $52f4cfa60ee593c4$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $52f4cfa60ee593c4$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $52f4cfa60ee593c4$var$nop;
                    stream.on('readable', next);
                    cleanup = $g0l3g(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $52f4cfa60ee593c4$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $52f4cfa60ee593c4$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $52f4cfa60ee593c4$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $52f4cfa60ee593c4$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $68GSU.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$52f4cfa60ee593c4$var$ObjectDefineProperties($52f4cfa60ee593c4$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$52f4cfa60ee593c4$var$ObjectDefineProperties($52f4cfa60ee593c4$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$52f4cfa60ee593c4$var$kPaused] !== false;
        },
        set: function(value) {
            this[$52f4cfa60ee593c4$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$52f4cfa60ee593c4$var$Readable._fromList = $52f4cfa60ee593c4$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $52f4cfa60ee593c4$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $52f4cfa60ee593c4$var$endReadable(stream) {
    var state = stream._readableState;
    $52f4cfa60ee593c4$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($52f4cfa60ee593c4$var$endReadableNT, state, stream);
    }
}
function $52f4cfa60ee593c4$var$endReadableNT(state, stream) {
    $52f4cfa60ee593c4$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($52f4cfa60ee593c4$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $52f4cfa60ee593c4$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$52f4cfa60ee593c4$var$Readable.from = function(iterable, opts) {
    return $bI8P3($52f4cfa60ee593c4$var$Readable, iterable, opts);
};
var $52f4cfa60ee593c4$var$webStreamsAdapters;
// Lazy to avoid circular references
function $52f4cfa60ee593c4$var$lazyWebStreams() {
    if ($52f4cfa60ee593c4$var$webStreamsAdapters === undefined) $52f4cfa60ee593c4$var$webStreamsAdapters = {};
    return $52f4cfa60ee593c4$var$webStreamsAdapters;
}
$52f4cfa60ee593c4$var$Readable.fromWeb = function(readableStream, options) {
    return $52f4cfa60ee593c4$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$52f4cfa60ee593c4$var$Readable.toWeb = function(streamReadable, options) {
    return $52f4cfa60ee593c4$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$52f4cfa60ee593c4$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $52f4cfa60ee593c4$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $68GSU.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("eXLnR", function(module, exports) {
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $ae4b54cedd80d497$var$ArrayIsArray = $lD0c5.ArrayIsArray, $ae4b54cedd80d497$var$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $ae4b54cedd80d497$var$EE = $bBoAO.EventEmitter;
function $ae4b54cedd80d497$var$Stream(opts) {
    $ae4b54cedd80d497$var$EE.call(this, opts);
}
$ae4b54cedd80d497$var$ObjectSetPrototypeOf($ae4b54cedd80d497$var$Stream.prototype, $ae4b54cedd80d497$var$EE.prototype);
$ae4b54cedd80d497$var$ObjectSetPrototypeOf($ae4b54cedd80d497$var$Stream, $ae4b54cedd80d497$var$EE);
$ae4b54cedd80d497$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($ae4b54cedd80d497$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $ae4b54cedd80d497$var$prependListener(source, 'error', onerror);
    $ae4b54cedd80d497$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $ae4b54cedd80d497$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($ae4b54cedd80d497$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $ae4b54cedd80d497$var$Stream,
    prependListener: $ae4b54cedd80d497$var$prependListener
};

});

parcelRegister("6nuWS", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $4a4ce5cba5818929$export$e2db56ee53255a0; }, function (v) { return $4a4ce5cba5818929$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $4a4ce5cba5818929$export$11956e9313f43de0; }, function (v) { return $4a4ce5cba5818929$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $4a4ce5cba5818929$export$e2db56ee53255a0;
var $4a4ce5cba5818929$export$11956e9313f43de0;
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $4a4ce5cba5818929$require$SymbolDispose = $lD0c5.SymbolDispose;

var $4qHMP = parcelRequire("4qHMP");
var $4a4ce5cba5818929$var$AbortError = $4qHMP.AbortError, $4a4ce5cba5818929$var$codes = $4qHMP.codes;

var $772Et = parcelRequire("772Et");
var $4a4ce5cba5818929$var$isNodeStream = $772Et.isNodeStream, $4a4ce5cba5818929$var$isWebStream = $772Et.isWebStream, $4a4ce5cba5818929$var$kControllerErrorFunction = $772Et.kControllerErrorFunction;

var $g0l3g = parcelRequire("g0l3g");
var $4a4ce5cba5818929$var$ERR_INVALID_ARG_TYPE = $4a4ce5cba5818929$var$codes.ERR_INVALID_ARG_TYPE;
var $4a4ce5cba5818929$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $4a4ce5cba5818929$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $4a4ce5cba5818929$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$4a4ce5cba5818929$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $4a4ce5cba5818929$var$validateAbortSignal(signal, 'signal');
    if (!$4a4ce5cba5818929$var$isNodeStream(stream) && !$4a4ce5cba5818929$var$isWebStream(stream)) throw new $4a4ce5cba5818929$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $4a4ce5cba5818929$export$11956e9313f43de0(signal, stream);
};

$4a4ce5cba5818929$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $4a4ce5cba5818929$var$isNodeStream(stream) ? function() {
        stream.destroy(new $4a4ce5cba5818929$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$4a4ce5cba5818929$var$kControllerErrorFunction](new $4a4ce5cba5818929$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $4a4ce5cba5818929$var$addAbortListener = $4a4ce5cba5818929$var$addAbortListener || (parcelRequire("2QqeP")).addAbortListener;
        var disposable = $4a4ce5cba5818929$var$addAbortListener(signal, onAbort);
        $g0l3g(stream, disposable[$4a4ce5cba5818929$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("8fs7c", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $601588876e523cc7$var$StringPrototypeSlice = $lD0c5.StringPrototypeSlice, $601588876e523cc7$var$SymbolIterator = $lD0c5.SymbolIterator, $601588876e523cc7$var$TypedArrayPrototypeSet = $lD0c5.TypedArrayPrototypeSet, $601588876e523cc7$var$Uint8Array = $lD0c5.Uint8Array;

var $hXCcT = parcelRequire("hXCcT");
var $601588876e523cc7$require$Buffer = $hXCcT.Buffer;

var $2QqeP = parcelRequire("2QqeP");
var $601588876e523cc7$require$inspect = $2QqeP.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $601588876e523cc7$require$Buffer.alloc(0);
                var ret = $601588876e523cc7$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $601588876e523cc7$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $601588876e523cc7$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $601588876e523cc7$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $601588876e523cc7$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $601588876e523cc7$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $601588876e523cc7$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $601588876e523cc7$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $601588876e523cc7$var$TypedArrayPrototypeSet(ret, new $601588876e523cc7$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $601588876e523cc7$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("6w72j", function(module, exports) {
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $4beb3083d5a98709$var$MathFloor = $lD0c5.MathFloor, $4beb3083d5a98709$var$NumberIsInteger = $lD0c5.NumberIsInteger;

var $eZpbD = parcelRequire("eZpbD");
var $4beb3083d5a98709$require$validateInteger = $eZpbD.validateInteger;

var $4beb3083d5a98709$var$ERR_INVALID_ARG_VALUE = (parcelRequire("4qHMP")).codes.ERR_INVALID_ARG_VALUE;
var $4beb3083d5a98709$var$defaultHighWaterMarkBytes = 16384;
var $4beb3083d5a98709$var$defaultHighWaterMarkObjectMode = 16;
function $4beb3083d5a98709$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $4beb3083d5a98709$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $4beb3083d5a98709$var$defaultHighWaterMarkObjectMode : $4beb3083d5a98709$var$defaultHighWaterMarkBytes;
}
function $4beb3083d5a98709$var$setDefaultHighWaterMark(objectMode, value) {
    $4beb3083d5a98709$require$validateInteger(value, 'value', 0);
    if (objectMode) $4beb3083d5a98709$var$defaultHighWaterMarkObjectMode = value;
    else $4beb3083d5a98709$var$defaultHighWaterMarkBytes = value;
}
function $4beb3083d5a98709$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $4beb3083d5a98709$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$4beb3083d5a98709$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $4beb3083d5a98709$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $4beb3083d5a98709$var$MathFloor(hwm);
    }
    // Default value
    return $4beb3083d5a98709$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $4beb3083d5a98709$var$getHighWaterMark,
    getDefaultHighWaterMark: $4beb3083d5a98709$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $4beb3083d5a98709$var$setDefaultHighWaterMark
};

});

parcelRegister("bI8P3", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lD0c5 = parcelRequire("lD0c5");
/* replacement end */ var $886aa5bcba6a58a9$var$PromisePrototypeThen = $lD0c5.PromisePrototypeThen, $886aa5bcba6a58a9$var$SymbolAsyncIterator = $lD0c5.SymbolAsyncIterator, $886aa5bcba6a58a9$var$SymbolIterator = $lD0c5.SymbolIterator;

var $hXCcT = parcelRequire("hXCcT");
var $886aa5bcba6a58a9$require$Buffer = $hXCcT.Buffer;

var $4qHMP = parcelRequire("4qHMP");
var $886aa5bcba6a58a9$require$_require_codes = $4qHMP.codes;
var $886aa5bcba6a58a9$var$ERR_INVALID_ARG_TYPE = $886aa5bcba6a58a9$require$_require_codes.ERR_INVALID_ARG_TYPE, $886aa5bcba6a58a9$var$ERR_STREAM_NULL_VALUES = $886aa5bcba6a58a9$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $886aa5bcba6a58a9$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $886aa5bcba6a58a9$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$886aa5bcba6a58a9$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$886aa5bcba6a58a9$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$886aa5bcba6a58a9$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$886aa5bcba6a58a9$var$SymbolIterator]();
    } else throw new $886aa5bcba6a58a9$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $886aa5bcba6a58a9$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $886aa5bcba6a58a9$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $886aa5bcba6a58a9$var$from;

});


parcelRegister("evyZp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $lD0c5 = parcelRequire("lD0c5");
/* replacement end */ var $a8ff1a1c84e43ad7$var$ArrayPrototypeSlice = $lD0c5.ArrayPrototypeSlice, $a8ff1a1c84e43ad7$var$Error = $lD0c5.Error, $a8ff1a1c84e43ad7$var$FunctionPrototypeSymbolHasInstance = $lD0c5.FunctionPrototypeSymbolHasInstance, $a8ff1a1c84e43ad7$var$ObjectDefineProperty = $lD0c5.ObjectDefineProperty, $a8ff1a1c84e43ad7$var$ObjectDefineProperties = $lD0c5.ObjectDefineProperties, $a8ff1a1c84e43ad7$var$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf, $a8ff1a1c84e43ad7$var$StringPrototypeToLowerCase = $lD0c5.StringPrototypeToLowerCase, $a8ff1a1c84e43ad7$var$Symbol = $lD0c5.Symbol, $a8ff1a1c84e43ad7$var$SymbolHasInstance = $lD0c5.SymbolHasInstance;
module.exports = $a8ff1a1c84e43ad7$var$Writable;
$a8ff1a1c84e43ad7$var$Writable.WritableState = $a8ff1a1c84e43ad7$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $a8ff1a1c84e43ad7$var$EE = $bBoAO.EventEmitter;

var $eXLnR = parcelRequire("eXLnR");
var $a8ff1a1c84e43ad7$require$Stream = $eXLnR.Stream;

var $hXCcT = parcelRequire("hXCcT");
var $a8ff1a1c84e43ad7$require$Buffer = $hXCcT.Buffer;

var $68GSU = parcelRequire("68GSU");

var $6nuWS = parcelRequire("6nuWS");
var $a8ff1a1c84e43ad7$require$addAbortSignal = $6nuWS.addAbortSignal;

var $6w72j = parcelRequire("6w72j");
var $a8ff1a1c84e43ad7$var$getHighWaterMark = $6w72j.getHighWaterMark, $a8ff1a1c84e43ad7$var$getDefaultHighWaterMark = $6w72j.getDefaultHighWaterMark;

var $4qHMP = parcelRequire("4qHMP");
var $a8ff1a1c84e43ad7$require$_require_codes = $4qHMP.codes;
var $a8ff1a1c84e43ad7$var$ERR_INVALID_ARG_TYPE = $a8ff1a1c84e43ad7$require$_require_codes.ERR_INVALID_ARG_TYPE, $a8ff1a1c84e43ad7$var$ERR_METHOD_NOT_IMPLEMENTED = $a8ff1a1c84e43ad7$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $a8ff1a1c84e43ad7$var$ERR_MULTIPLE_CALLBACK = $a8ff1a1c84e43ad7$require$_require_codes.ERR_MULTIPLE_CALLBACK, $a8ff1a1c84e43ad7$var$ERR_STREAM_CANNOT_PIPE = $a8ff1a1c84e43ad7$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED = $a8ff1a1c84e43ad7$require$_require_codes.ERR_STREAM_DESTROYED, $a8ff1a1c84e43ad7$var$ERR_STREAM_ALREADY_FINISHED = $a8ff1a1c84e43ad7$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $a8ff1a1c84e43ad7$var$ERR_STREAM_NULL_VALUES = $a8ff1a1c84e43ad7$require$_require_codes.ERR_STREAM_NULL_VALUES, $a8ff1a1c84e43ad7$var$ERR_STREAM_WRITE_AFTER_END = $a8ff1a1c84e43ad7$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $a8ff1a1c84e43ad7$var$ERR_UNKNOWN_ENCODING = $a8ff1a1c84e43ad7$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $a8ff1a1c84e43ad7$var$errorOrDestroy = $68GSU.errorOrDestroy;
$a8ff1a1c84e43ad7$var$ObjectSetPrototypeOf($a8ff1a1c84e43ad7$var$Writable.prototype, $a8ff1a1c84e43ad7$require$Stream.prototype);
$a8ff1a1c84e43ad7$var$ObjectSetPrototypeOf($a8ff1a1c84e43ad7$var$Writable, $a8ff1a1c84e43ad7$require$Stream);
function $a8ff1a1c84e43ad7$var$nop() {}
var $a8ff1a1c84e43ad7$var$kOnFinished = $a8ff1a1c84e43ad7$var$Symbol('kOnFinished');

function $a8ff1a1c84e43ad7$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("bysq0"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a8ff1a1c84e43ad7$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a8ff1a1c84e43ad7$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a8ff1a1c84e43ad7$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a8ff1a1c84e43ad7$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a8ff1a1c84e43ad7$var$kOnFinished] = [];
}
function $a8ff1a1c84e43ad7$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a8ff1a1c84e43ad7$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a8ff1a1c84e43ad7$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a8ff1a1c84e43ad7$var$ObjectDefineProperty($a8ff1a1c84e43ad7$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a8ff1a1c84e43ad7$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("bysq0"));
    if (!isDuplex && !$a8ff1a1c84e43ad7$var$FunctionPrototypeSymbolHasInstance($a8ff1a1c84e43ad7$var$Writable, this)) return new $a8ff1a1c84e43ad7$var$Writable(options);
    this._writableState = new $a8ff1a1c84e43ad7$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a8ff1a1c84e43ad7$require$addAbortSignal(options.signal, this);
    }
    $a8ff1a1c84e43ad7$require$Stream.call(this, options);
    $68GSU.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $a8ff1a1c84e43ad7$var$clearBuffer(_this, state);
        $a8ff1a1c84e43ad7$var$finishMaybe(_this, state);
    });
}
$a8ff1a1c84e43ad7$var$ObjectDefineProperty($a8ff1a1c84e43ad7$var$Writable, $a8ff1a1c84e43ad7$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($a8ff1a1c84e43ad7$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a8ff1a1c84e43ad7$var$Writable) return false;
        return object && object._writableState instanceof $a8ff1a1c84e43ad7$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a8ff1a1c84e43ad7$var$Writable.prototype.pipe = function() {
    $a8ff1a1c84e43ad7$var$errorOrDestroy(this, new $a8ff1a1c84e43ad7$var$ERR_STREAM_CANNOT_PIPE());
};
function $a8ff1a1c84e43ad7$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a8ff1a1c84e43ad7$require$Buffer.isEncoding(encoding)) throw new $a8ff1a1c84e43ad7$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a8ff1a1c84e43ad7$var$nop;
    }
    if (chunk === null) throw new $a8ff1a1c84e43ad7$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a8ff1a1c84e43ad7$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a8ff1a1c84e43ad7$require$Buffer) encoding = 'buffer';
        else if ($a8ff1a1c84e43ad7$require$Stream._isUint8Array(chunk)) {
            chunk = $a8ff1a1c84e43ad7$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a8ff1a1c84e43ad7$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $a8ff1a1c84e43ad7$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $a8ff1a1c84e43ad7$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a8ff1a1c84e43ad7$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a8ff1a1c84e43ad7$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a8ff1a1c84e43ad7$var$_write(this, chunk, encoding, cb) === true;
};
$a8ff1a1c84e43ad7$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a8ff1a1c84e43ad7$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a8ff1a1c84e43ad7$var$clearBuffer(this, state);
    }
};
$a8ff1a1c84e43ad7$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a8ff1a1c84e43ad7$var$StringPrototypeToLowerCase(encoding);
    if (!$a8ff1a1c84e43ad7$require$Buffer.isEncoding(encoding)) throw new $a8ff1a1c84e43ad7$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a8ff1a1c84e43ad7$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a8ff1a1c84e43ad7$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a8ff1a1c84e43ad7$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a8ff1a1c84e43ad7$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a8ff1a1c84e43ad7$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a8ff1a1c84e43ad7$var$errorOrDestroy(stream, er);
}
function $a8ff1a1c84e43ad7$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $a8ff1a1c84e43ad7$var$errorOrDestroy(stream, new $a8ff1a1c84e43ad7$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($a8ff1a1c84e43ad7$var$onwriteError, stream, state, er, cb);
        else $a8ff1a1c84e43ad7$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a8ff1a1c84e43ad7$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($a8ff1a1c84e43ad7$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a8ff1a1c84e43ad7$var$afterWrite(stream, state, 1, cb);
    }
}
function $a8ff1a1c84e43ad7$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $a8ff1a1c84e43ad7$var$afterWrite(stream, state, count, cb);
}
function $a8ff1a1c84e43ad7$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a8ff1a1c84e43ad7$var$errorBuffer(state);
    $a8ff1a1c84e43ad7$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a8ff1a1c84e43ad7$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$a8ff1a1c84e43ad7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED('end'));
    }
    $a8ff1a1c84e43ad7$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a8ff1a1c84e43ad7$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $a8ff1a1c84e43ad7$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $a8ff1a1c84e43ad7$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a8ff1a1c84e43ad7$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a8ff1a1c84e43ad7$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $a8ff1a1c84e43ad7$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a8ff1a1c84e43ad7$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a8ff1a1c84e43ad7$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a8ff1a1c84e43ad7$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a8ff1a1c84e43ad7$var$Writable.prototype._writev = null;
$a8ff1a1c84e43ad7$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $a8ff1a1c84e43ad7$var$_write(this, chunk, encoding);
        if (ret instanceof $a8ff1a1c84e43ad7$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a8ff1a1c84e43ad7$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a8ff1a1c84e43ad7$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a8ff1a1c84e43ad7$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$a8ff1a1c84e43ad7$var$kOnFinished].push(cb);
    }
    return this;
};
function $a8ff1a1c84e43ad7$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a8ff1a1c84e43ad7$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $a8ff1a1c84e43ad7$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a8ff1a1c84e43ad7$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$a8ff1a1c84e43ad7$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a8ff1a1c84e43ad7$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a8ff1a1c84e43ad7$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($a8ff1a1c84e43ad7$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a8ff1a1c84e43ad7$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a8ff1a1c84e43ad7$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a8ff1a1c84e43ad7$var$finishMaybe(stream, state, sync) {
    if ($a8ff1a1c84e43ad7$var$needFinish(state)) {
        $a8ff1a1c84e43ad7$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($a8ff1a1c84e43ad7$var$needFinish(state)) $a8ff1a1c84e43ad7$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a8ff1a1c84e43ad7$var$needFinish(state)) {
                state.pendingcb++;
                $a8ff1a1c84e43ad7$var$finish(stream, state);
            }
        }
    }
}
function $a8ff1a1c84e43ad7$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$a8ff1a1c84e43ad7$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a8ff1a1c84e43ad7$var$ObjectDefineProperties($a8ff1a1c84e43ad7$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $a8ff1a1c84e43ad7$var$destroy = $68GSU.destroy;
$a8ff1a1c84e43ad7$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a8ff1a1c84e43ad7$var$kOnFinished].length)) $2Qkr5.nextTick($a8ff1a1c84e43ad7$var$errorBuffer, state);
    $a8ff1a1c84e43ad7$var$destroy.call(this, err, cb);
    return this;
};
$a8ff1a1c84e43ad7$var$Writable.prototype._undestroy = $68GSU.undestroy;
$a8ff1a1c84e43ad7$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a8ff1a1c84e43ad7$var$Writable.prototype[$a8ff1a1c84e43ad7$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $a8ff1a1c84e43ad7$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a8ff1a1c84e43ad7$var$lazyWebStreams() {
    if ($a8ff1a1c84e43ad7$var$webStreamsAdapters === undefined) $a8ff1a1c84e43ad7$var$webStreamsAdapters = {};
    return $a8ff1a1c84e43ad7$var$webStreamsAdapters;
}
$a8ff1a1c84e43ad7$var$Writable.fromWeb = function(writableStream, options) {
    return $a8ff1a1c84e43ad7$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a8ff1a1c84e43ad7$var$Writable.toWeb = function(streamWritable) {
    return $a8ff1a1c84e43ad7$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("bjhOR", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $hXCcT = parcelRequire("hXCcT");

var $772Et = parcelRequire("772Et");
var $83bf4a975cba0fe9$var$isReadable = $772Et.isReadable, $83bf4a975cba0fe9$var$isWritable = $772Et.isWritable, $83bf4a975cba0fe9$var$isIterable = $772Et.isIterable, $83bf4a975cba0fe9$var$isNodeStream = $772Et.isNodeStream, $83bf4a975cba0fe9$var$isReadableNodeStream = $772Et.isReadableNodeStream, $83bf4a975cba0fe9$var$isWritableNodeStream = $772Et.isWritableNodeStream, $83bf4a975cba0fe9$var$isDuplexNodeStream = $772Et.isDuplexNodeStream, $83bf4a975cba0fe9$var$isReadableStream = $772Et.isReadableStream, $83bf4a975cba0fe9$var$isWritableStream = $772Et.isWritableStream;

var $g0l3g = parcelRequire("g0l3g");

var $4qHMP = parcelRequire("4qHMP");
var $83bf4a975cba0fe9$var$AbortError = $4qHMP.AbortError, $83bf4a975cba0fe9$var$_require_codes = $4qHMP.codes, $83bf4a975cba0fe9$var$ERR_INVALID_ARG_TYPE = $83bf4a975cba0fe9$var$_require_codes.ERR_INVALID_ARG_TYPE, $83bf4a975cba0fe9$var$ERR_INVALID_RETURN_VALUE = $83bf4a975cba0fe9$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $68GSU = parcelRequire("68GSU");
var $83bf4a975cba0fe9$require$destroyer = $68GSU.destroyer;

var $bysq0 = parcelRequire("bysq0");

var $77zC0 = parcelRequire("77zC0");

var $evyZp = parcelRequire("evyZp");

var $2QqeP = parcelRequire("2QqeP");
var $83bf4a975cba0fe9$require$createDeferredPromise = $2QqeP.createDeferredPromise;

var $bI8P3 = parcelRequire("bI8P3");
var $83bf4a975cba0fe9$var$Blob = globalThis.Blob || $hXCcT.Blob;
var $83bf4a975cba0fe9$var$isBlob = typeof $83bf4a975cba0fe9$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $83bf4a975cba0fe9$var$Blob;
} : function isBlob(b) {
    return false;
};

var $83bf4a975cba0fe9$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $lD0c5 = parcelRequire("lD0c5");
var $83bf4a975cba0fe9$require$FunctionPrototypeCall = $lD0c5.FunctionPrototypeCall;
// This is needed for pre node 17.
var $83bf4a975cba0fe9$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($bysq0);
module.exports = function duplexify(body, name) {
    if ($83bf4a975cba0fe9$var$isDuplexNodeStream(body)) return body;
    if ($83bf4a975cba0fe9$var$isReadableNodeStream(body)) return $83bf4a975cba0fe9$var$_duplexify({
        readable: body
    });
    if ($83bf4a975cba0fe9$var$isWritableNodeStream(body)) return $83bf4a975cba0fe9$var$_duplexify({
        writable: body
    });
    if ($83bf4a975cba0fe9$var$isNodeStream(body)) return $83bf4a975cba0fe9$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($83bf4a975cba0fe9$var$isReadableStream(body)) return $83bf4a975cba0fe9$var$_duplexify({
        readable: $77zC0.fromWeb(body)
    });
    if ($83bf4a975cba0fe9$var$isWritableStream(body)) return $83bf4a975cba0fe9$var$_duplexify({
        writable: $evyZp.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $83bf4a975cba0fe9$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($83bf4a975cba0fe9$var$isIterable(value)) return $bI8P3($83bf4a975cba0fe9$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $83bf4a975cba0fe9$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $83bf4a975cba0fe9$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $83bf4a975cba0fe9$require$destroyer(d, err);
            });
            return d = new $83bf4a975cba0fe9$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $83bf4a975cba0fe9$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($83bf4a975cba0fe9$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($83bf4a975cba0fe9$var$isIterable(body)) return $bI8P3($83bf4a975cba0fe9$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($83bf4a975cba0fe9$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $83bf4a975cba0fe9$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $83bf4a975cba0fe9$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $83bf4a975cba0fe9$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $83bf4a975cba0fe9$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $83bf4a975cba0fe9$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $83bf4a975cba0fe9$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $83bf4a975cba0fe9$require$destroyer(d1, err);
        });
        return d1 = new $83bf4a975cba0fe9$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $83bf4a975cba0fe9$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $83bf4a975cba0fe9$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $83bf4a975cba0fe9$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $83bf4a975cba0fe9$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $83bf4a975cba0fe9$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $83bf4a975cba0fe9$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $83bf4a975cba0fe9$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $77zC0.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$83bf4a975cba0fe9$var$isReadable(r);
    var writable = !!$83bf4a975cba0fe9$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $83bf4a975cba0fe9$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $g0l3g(w, function(err) {
            writable = false;
            if (err) $83bf4a975cba0fe9$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $g0l3g(r, function(err) {
            readable = false;
            if (err) $83bf4a975cba0fe9$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $83bf4a975cba0fe9$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $83bf4a975cba0fe9$require$destroyer(w, err);
            $83bf4a975cba0fe9$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("hHMZs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $ce3c74439dc4a320$require$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf;
module.exports = $ce3c74439dc4a320$var$PassThrough;

var $8uxPL = parcelRequire("8uxPL");
$ce3c74439dc4a320$require$ObjectSetPrototypeOf($ce3c74439dc4a320$var$PassThrough.prototype, $8uxPL.prototype);
$ce3c74439dc4a320$require$ObjectSetPrototypeOf($ce3c74439dc4a320$var$PassThrough, $8uxPL);
function $ce3c74439dc4a320$var$PassThrough(options) {
    if (!(this instanceof $ce3c74439dc4a320$var$PassThrough)) return new $ce3c74439dc4a320$var$PassThrough(options);
    $8uxPL.call(this, options);
}
$ce3c74439dc4a320$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("8uxPL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $62eb5ec1d5c7938b$var$ObjectSetPrototypeOf = $lD0c5.ObjectSetPrototypeOf, $62eb5ec1d5c7938b$var$Symbol = $lD0c5.Symbol;
module.exports = $62eb5ec1d5c7938b$var$Transform;

var $62eb5ec1d5c7938b$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("4qHMP")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $bysq0 = parcelRequire("bysq0");

var $6w72j = parcelRequire("6w72j");
var $62eb5ec1d5c7938b$require$getHighWaterMark = $6w72j.getHighWaterMark;
$62eb5ec1d5c7938b$var$ObjectSetPrototypeOf($62eb5ec1d5c7938b$var$Transform.prototype, $bysq0.prototype);
$62eb5ec1d5c7938b$var$ObjectSetPrototypeOf($62eb5ec1d5c7938b$var$Transform, $bysq0);
var $62eb5ec1d5c7938b$var$kCallback = $62eb5ec1d5c7938b$var$Symbol('kCallback');
function $62eb5ec1d5c7938b$var$Transform(options) {
    if (!(this instanceof $62eb5ec1d5c7938b$var$Transform)) return new $62eb5ec1d5c7938b$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $62eb5ec1d5c7938b$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $bysq0.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$62eb5ec1d5c7938b$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $62eb5ec1d5c7938b$var$prefinish);
}
function $62eb5ec1d5c7938b$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $62eb5ec1d5c7938b$var$prefinish() {
    if (this._final !== $62eb5ec1d5c7938b$var$_final) $62eb5ec1d5c7938b$var$_final.call(this);
}
$62eb5ec1d5c7938b$var$Transform.prototype._final = $62eb5ec1d5c7938b$var$_final;
$62eb5ec1d5c7938b$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $62eb5ec1d5c7938b$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$62eb5ec1d5c7938b$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$62eb5ec1d5c7938b$var$kCallback] = callback;
    });
};
$62eb5ec1d5c7938b$var$Transform.prototype._read = function() {
    if (this[$62eb5ec1d5c7938b$var$kCallback]) {
        var callback = this[$62eb5ec1d5c7938b$var$kCallback];
        this[$62eb5ec1d5c7938b$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("5gGPu", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $lD0c5 = parcelRequire("lD0c5");
var $3d5fab64358fb49b$var$ArrayPrototypePop = $lD0c5.ArrayPrototypePop, $3d5fab64358fb49b$var$Promise = $lD0c5.Promise;

var $772Et = parcelRequire("772Et");
var $3d5fab64358fb49b$var$isIterable = $772Et.isIterable, $3d5fab64358fb49b$var$isNodeStream = $772Et.isNodeStream, $3d5fab64358fb49b$var$isWebStream = $772Et.isWebStream;

var $fBe60 = parcelRequire("fBe60");
var $3d5fab64358fb49b$var$pl = $fBe60.pipelineImpl;

var $g0l3g = parcelRequire("g0l3g");
var $3d5fab64358fb49b$require$finished = $g0l3g.finished;
parcelRequire("1lybP");
function $3d5fab64358fb49b$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $3d5fab64358fb49b$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$3d5fab64358fb49b$var$isNodeStream(lastArg) && !$3d5fab64358fb49b$var$isIterable(lastArg) && !$3d5fab64358fb49b$var$isWebStream(lastArg)) {
            var options = $3d5fab64358fb49b$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $3d5fab64358fb49b$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $3d5fab64358fb49b$require$finished,
    pipeline: $3d5fab64358fb49b$var$pipeline
};

});









parcelRegister("9VryK", function(module, exports) {
"use strict";
var $739ed0a8e7828c27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $739ed0a8e7828c27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $739ed0a8e7828c27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$739ed0a8e7828c27$var$__exportStar((parcelRequire("4kFsz")), module.exports);

});
parcelRegister("4kFsz", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinNone = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $jZbVy = parcelRequire("jZbVy");

var $aafx9 = parcelRequire("aafx9");
/**
 * A comunica None RDF Join Actor.
 */ var $327930baa8d9d5a3$var$ActorRdfJoinNone = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinNone, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinNone(args) {
        (0, $jGAMp._)(this, ActorRdfJoinNone);
        return (0, $kzDuW._)(this, ActorRdfJoinNone, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'none',
                limitEntries: 0
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinNone, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Allow joining of one or zero streams
                                if (action.entries.length > 0) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only join zero entries"))
                                ];
                                return [
                                    4,
                                    this.getJoinCoefficients(action, undefined)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, bindingsFactory;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                return [
                                    2,
                                    {
                                        result: {
                                            bindingsStream: new $aafx9.ArrayIterator([
                                                bindingsFactory.bindings()
                                            ], {
                                                autoStart: false
                                            }),
                                            metadata: function() {
                                                return Promise.resolve({
                                                    state: new $jZbVy.MetadataValidationState(),
                                                    cardinality: {
                                                        type: 'exact',
                                                        value: 1
                                                    },
                                                    variables: []
                                                });
                                            },
                                            type: 'bindings'
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestWithSideData)({
                                iterations: 0,
                                persistedItems: 0,
                                blockingItems: 0,
                                requestTime: 0
                            }, sideData)
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorRdfJoinNone;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinNone = $327930baa8d9d5a3$var$ActorRdfJoinNone;

});


parcelRegister("b7XJQ", function(module, exports) {
"use strict";
var $819eaffa187c539c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $819eaffa187c539c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $819eaffa187c539c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$819eaffa187c539c$var$__exportStar((parcelRequire("egPUU")), module.exports);

});
parcelRegister("egPUU", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalBind = void 0;

var $hka6L = parcelRequire("hka6L");

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Optional Bind RDF Join Actor.
 */ var $a63ad4e713490446$var$ActorRdfJoinOptionalBind = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinOptionalBind, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinOptionalBind(args) {
        (0, $jGAMp._)(this, ActorRdfJoinOptionalBind);
        return (0, $kzDuW._)(this, ActorRdfJoinOptionalBind, [
            args,
            {
                logicalType: 'optional',
                physicalName: 'bind',
                limitEntries: 2,
                canHandleUndefs: true,
                isLeaf: false,
                requiresVariableOverlap: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinOptionalBind, [
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, bindingsFactory, subContext, _, _1, _tmp, _2, _3, _tmp1, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                // Close the right stream, since we don't need that one
                                action.entries[1].output.bindingsStream.close();
                                _1 = (_ = action.context).set;
                                _tmp = [
                                    $9nBhR.KeysQueryOperation.joinLeftMetadata
                                ];
                                return [
                                    4,
                                    action.entries[0].output.metadata()
                                ];
                            case 2:
                                _3 = (_2 = _1.apply(_, _tmp.concat([
                                    _state.sent()
                                ]))).set;
                                _tmp1 = [
                                    $9nBhR.KeysQueryOperation.joinRightMetadatas
                                ];
                                return [
                                    4,
                                    action.entries[1].output.metadata()
                                ];
                            case 3:
                                subContext = _3.apply(_2, _tmp1.concat([
                                    [
                                        _state.sent()
                                    ]
                                ]));
                                bindingsStream = $hka6L.ActorRdfJoinMultiBind.createBindStream(this.bindOrder, action.entries[0].output.bindingsStream, [
                                    action.entries[1].operation
                                ], function(operations, operationBindings) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var operation, output, _;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // Send the materialized patterns to the mediator for recursive join evaluation.
                                                    // Length of operations will always be 1
                                                    operation = operations[0];
                                                    _ = (0, $2n9RU.getSafeBindings);
                                                    return [
                                                        4,
                                                        this.mediatorQueryOperation.mediate({
                                                            operation: operation,
                                                            context: subContext === null || subContext === void 0 ? void 0 : subContext.set($9nBhR.KeysQueryOperation.joinBindings, operationBindings)
                                                        })
                                                    ];
                                                case 1:
                                                    output = _.apply(void 0, [
                                                        _state.sent()
                                                    ]);
                                                    return [
                                                        2,
                                                        output.bindingsStream
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                }, true, algebraFactory, bindingsFactory);
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                                    var _, _1, _tmp;
                                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _1 = (_ = this).constructResultMetadata;
                                                                _tmp = [
                                                                    action.entries
                                                                ];
                                                                return [
                                                                    4,
                                                                    $17TpP.ActorRdfJoin.getMetadatas(action.entries)
                                                                ];
                                                            case 1:
                                                                return [
                                                                    4,
                                                                    _1.apply(_, _tmp.concat([
                                                                        _state.sent(),
                                                                        action.context,
                                                                        {},
                                                                        true
                                                                    ]))
                                                                ];
                                                            case 2:
                                                                return [
                                                                    2,
                                                                    _state.sent()
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var metadatas, requestInitialTimes, requestItemTimes, selectivity;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                metadatas = sideData.metadatas;
                                requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                                requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                                // Reject binding on some operation types
                                if (action.entries[1].operation.type === $hSHd8.Algebra.types.EXTEND || action.entries[1].operation.type === $hSHd8.Algebra.types.GROUP) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not bind on Extend and Group operations"))
                                ];
                                return [
                                    4,
                                    this.mediatorJoinSelectivity.mediate({
                                        entries: action.entries,
                                        context: action.context
                                    })
                                ];
                            case 1:
                                selectivity = _state.sent().selectivity * this.selectivityModifier;
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)({
                                        iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value * selectivity,
                                        persistedItems: 0,
                                        blockingItems: 0,
                                        requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * (requestItemTimes[0] + requestInitialTimes[1] + selectivity * metadatas[1].cardinality.value * requestItemTimes[1])
                                    }, sideData)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfJoinOptionalBind;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinOptionalBind = $a63ad4e713490446$var$ActorRdfJoinOptionalBind;

});
parcelRegister("hka6L", function(module, exports) {
"use strict";
var $c9cc252da893ba7e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9cc252da893ba7e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c9cc252da893ba7e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c9cc252da893ba7e$var$__exportStar((parcelRequire("g43CM")), module.exports);

});
parcelRegister("g43CM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiBind = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Multi-way Bind RDF Join Actor.
 */ var $bb1fd4d3948527e4$var$ActorRdfJoinMultiBind = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMultiBind, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMultiBind(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMultiBind);
        return (0, $kzDuW._)(this, ActorRdfJoinMultiBind, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'bind',
                canHandleUndefs: true,
                isLeaf: false
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMultiBind, [
        {
            key: "getOutput",
            value: function getOutput(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, bindingsFactory, entries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, element, smallestStream, remainingEntries, subContext, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)
                                ];
                            case 1:
                                bindingsFactory = _state.sent();
                                entries = sideData.entriesSorted;
                                this.logDebug(action.context, 'First entry for Bind Join: ', function() {
                                    return {
                                        entry: entries[0].operation,
                                        cardinality: entries[0].metadata.cardinality,
                                        order: entries[0].metadata.order,
                                        availableOrders: entries[0].metadata.availableOrders
                                    };
                                });
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // Close the non-smallest streams
                                    for(_iterator = entries.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], element = _step_value[1];
                                        if (i !== 0) element.output.bindingsStream.close();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                // Take the stream with the lowest cardinality
                                smallestStream = entries[0].output;
                                remainingEntries = (0, $7WNf6._)(entries);
                                remainingEntries.splice(0, 1);
                                // Bind the remaining patterns for each binding in the stream
                                subContext = action.context.set($9nBhR.KeysQueryOperation.joinLeftMetadata, entries[0].metadata).set($9nBhR.KeysQueryOperation.joinRightMetadatas, remainingEntries.map(function(entry) {
                                    return entry.metadata;
                                }));
                                bindingsStream = ActorRdfJoinMultiBind.createBindStream(this.bindOrder, smallestStream.bindingsStream, remainingEntries.map(function(entry) {
                                    return entry.operation;
                                }), function(operations, operationBindings) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                        var operation, output, _;
                                        return (0, $9N5UN.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    // Send the materialized patterns to the mediator for recursive join evaluation.
                                                    operation = operations.length === 1 ? operations[0] : // Flattening should only take place if none of the input operations have associated metadata
                                                    algebraFactory.createJoin(operations, operations.every(function(op) {
                                                        return !op.metadata;
                                                    }));
                                                    _ = (0, $2n9RU.getSafeBindings);
                                                    return [
                                                        4,
                                                        this.mediatorQueryOperation.mediate({
                                                            operation: operation,
                                                            context: subContext === null || subContext === void 0 ? void 0 : subContext.set($9nBhR.KeysQueryOperation.joinBindings, operationBindings)
                                                        })
                                                    ];
                                                case 1:
                                                    output = _.apply(void 0, [
                                                        _state.sent()
                                                    ]);
                                                    return [
                                                        2,
                                                        output.bindingsStream
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                }, false, algebraFactory, bindingsFactory);
                                return [
                                    2,
                                    {
                                        result: {
                                            type: 'bindings',
                                            bindingsStream: bindingsStream,
                                            metadata: function() {
                                                return _this.constructResultMetadata(entries, entries.map(function(entry) {
                                                    return entry.metadata;
                                                }), action.context);
                                            }
                                        },
                                        physicalPlanMetadata: {
                                            bindIndex: sideData.entriesUnsorted.indexOf(entries[0]),
                                            bindOperation: entries[0].operation,
                                            bindOperationCardinality: entries[0].metadata.cardinality,
                                            bindOrder: this.bindOrder
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "canBindWithOperation",
            value: function canBindWithOperation(operation) {
                var valid = true;
                var _obj;
                $hSHd8.Util.recurseOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.EXTEND, function() {
                    valid = false;
                    return false;
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.GROUP, function() {
                    valid = false;
                    return false;
                }), _obj));
                return valid;
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, _Math, metadatas, entriesUnsorted, entriesTest, entriesSorted, requestInitialTimes, requestItemTimes, remainingEntries, remainingRequestInitialTimes, remainingRequestItemTimes, isRemoteAccess, selectivities, cardinalityRemaining, receiveInitialCostRemaining, receiveItemCostRemaining;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                metadatas = sideData.metadatas;
                                // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
                                entriesUnsorted = action.entries.map(function(entry, i) {
                                    return (0, $emQHU._)((0, $iT0je._)({}, entry), {
                                        metadata: metadatas[i]
                                    });
                                });
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.sortJoinEntries(this.mediatorJoinEntriesSort, entriesUnsorted, action.context)
                                ];
                            case 1:
                                entriesTest = _state.sent();
                                if (entriesTest.isFailed()) return [
                                    2,
                                    entriesTest
                                ];
                                entriesSorted = entriesTest.get();
                                metadatas = entriesSorted.map(function(entry) {
                                    return entry.metadata;
                                });
                                requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                                requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                                // Determine first stream and remaining ones
                                remainingEntries = (0, $7WNf6._)(entriesSorted);
                                remainingRequestInitialTimes = (0, $7WNf6._)(requestInitialTimes);
                                remainingRequestItemTimes = (0, $7WNf6._)(requestItemTimes);
                                remainingEntries.splice(0, 1);
                                remainingRequestInitialTimes.splice(0, 1);
                                remainingRequestItemTimes.splice(0, 1);
                                // Reject binding on some operation types
                                if (remainingEntries.some(function(entry) {
                                    return !_this.canBindWithOperation(entry.operation);
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not bind on Extend and Group operations"))
                                ];
                                // Reject binding on modified operations, since using the output directly would be significantly more efficient.
                                if (remainingEntries.some(function(entry) {
                                    return entry.operationModified;
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not be used over remaining entries with modified operations"))
                                ];
                                // Only run this actor if the smallest stream is significantly smaller than the largest stream.
                                // We must use Math.max, because the last metadata is not necessarily the biggest, but it's the least preferred.
                                // If join entries are produced locally, we increase the possibility of doing this bind join, as it's cheap.
                                isRemoteAccess = requestItemTimes.some(function(time) {
                                    return time > 0;
                                });
                                if (metadatas[0].cardinality.value * this.minMaxCardinalityRatio / (isRemoteAccess ? 1 : 3) > (_Math = Math).max.apply(_Math, (0, $7WNf6._)(metadatas.map(function(metadata) {
                                    return metadata.cardinality.value;
                                })))) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only run if the smallest stream is much smaller than largest stream"))
                                ];
                                return [
                                    4,
                                    Promise.all(remainingEntries.map(function(entry) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.mediatorJoinSelectivity.mediate({
                                                                entries: [
                                                                    entriesSorted[0],
                                                                    entry
                                                                ],
                                                                context: action.context
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent().selectivity * this.selectivityModifier
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 2:
                                selectivities = _state.sent();
                                // Determine coefficients for remaining entries
                                cardinalityRemaining = remainingEntries.map(function(entry, i) {
                                    return entry.metadata.cardinality.value * selectivities[i];
                                }).reduce(function(sum, element) {
                                    return sum + element;
                                }, 0);
                                receiveInitialCostRemaining = remainingRequestInitialTimes.reduce(function(sum, element) {
                                    return sum + element;
                                }, 0);
                                receiveItemCostRemaining = remainingRequestItemTimes.reduce(function(sum, element) {
                                    return sum + element;
                                }, 0);
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)({
                                        iterations: metadatas[0].cardinality.value * cardinalityRemaining,
                                        persistedItems: 0,
                                        blockingItems: 0,
                                        requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * (requestItemTimes[0] + receiveInitialCostRemaining + cardinalityRemaining * receiveItemCostRemaining)
                                    }, (0, $emQHU._)((0, $iT0je._)({}, sideData), {
                                        entriesUnsorted: entriesUnsorted,
                                        entriesSorted: entriesSorted
                                    }))
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "createBindStream",
            value: /**
     * Create a new bindings stream that takes every binding of the base stream
     * and binds it to the remaining patterns, evaluates those patterns, and emits all their bindings.
     *
     * @param bindOrder The order in which elements should be bound.
     * @param baseStream The base stream.
     * @param operations The operations to bind with each binding of the base stream.
     * @param operationBinder A callback to retrieve the bindings stream of bound operations.
     * @param optional If the original bindings should be emitted when the resulting bindings stream is empty.
     * @return {BindingsStream}
     */ function createBindStream(bindOrder, baseStream, operations, operationBinder, optional, algebraFactory, bindingsFactory) {
                // Enable auto-start on sub-bindings during depth-first binding for best performance.
                var autoStartSubBindings = bindOrder === 'depth-first';
                // Create bindings function
                var binder = function(bindings) {
                    // We don't bind the filter because filters are always handled last,
                    // and we need to avoid binding filters of sub-queries, which are to be handled first. (see spec test bind10)
                    var subOperations = operations.map(function(operation) {
                        return (0, $2n9RU.materializeOperation)(operation, bindings, algebraFactory, bindingsFactory, {
                            bindFilter: true
                        });
                    });
                    var bindingsMerger = function(subBindings) {
                        return subBindings.merge(bindings);
                    };
                    return new $aafx9.TransformIterator(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            operationBinder(subOperations, bindings)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent().transform({
                                                map: bindingsMerger
                                            })
                                        ];
                                }
                            });
                        })();
                    }, {
                        maxBufferSize: 128,
                        autoStart: autoStartSubBindings
                    });
                };
                // Create an iterator that binds elements from the base stream in different orders
                switch(bindOrder){
                    case 'depth-first':
                        return new $aafx9.MultiTransformIterator(baseStream, {
                            autoStart: false,
                            multiTransform: binder,
                            optional: optional
                        });
                    case 'breadth-first':
                        return new $aafx9.UnionIterator(baseStream.transform({
                            map: binder,
                            optional: optional
                        }), {
                            autoStart: false
                        });
                    default:
                        // eslint-disable-next-line ts/restrict-template-expressions
                        throw new Error("Received request for unknown bind order: ".concat(bindOrder));
                }
            }
        }
    ]);
    return ActorRdfJoinMultiBind;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMultiBind = $bb1fd4d3948527e4$var$ActorRdfJoinMultiBind;

});




parcelRegister("7l09z", function(module, exports) {
"use strict";
var $557a9cff8b26aad4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $557a9cff8b26aad4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $557a9cff8b26aad4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$557a9cff8b26aad4$var$__exportStar((parcelRequire("dB2jL")), module.exports);

});
parcelRegister("dB2jL", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorTermComparatorFactoryExpressionEvaluator = void 0;

var $5XhaY = parcelRequire("5XhaY");

var $4Ej7Q = parcelRequire("4Ej7Q");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $aduX6 = parcelRequire("aduX6");

var $7LjCY = parcelRequire("7LjCY");
/**
 * A comunica Expression Evaluator Based Term Comparator Factory Actor.
 */ var $9e60874f73c137be$var$ActorTermComparatorFactoryExpressionEvaluator = /*#__PURE__*/ function(_bus_term_comparator_factory_1_ActorTermComparatorFactory) {
    (0, $i3fW3._)(ActorTermComparatorFactoryExpressionEvaluator, _bus_term_comparator_factory_1_ActorTermComparatorFactory);
    function ActorTermComparatorFactoryExpressionEvaluator() {
        (0, $jGAMp._)(this, ActorTermComparatorFactoryExpressionEvaluator);
        return (0, $kzDuW._)(this, ActorTermComparatorFactoryExpressionEvaluator, arguments);
    }
    (0, $byiyg._)(ActorTermComparatorFactoryExpressionEvaluator, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: /**
     * Context item superTypeProvider can be expected here
     * @param context IActionTermComparatorFactory
     * @param context.context IActionContext
     */ function run(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(param) {
                    var context, _, _1, _2, _3, _tmp, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = param.context;
                                context = $aduX6.prepareEvaluatorActionContext(context);
                                _1 = (_ = $7LjCY.TermComparatorExpressionEvaluator).bind;
                                _3 = (_2 = $5XhaY.InternalEvaluator).bind;
                                _tmp = [
                                    void 0,
                                    context,
                                    this.mediatorFunctionFactory,
                                    this.mediatorQueryOperation
                                ];
                                return [
                                    4,
                                    $itFzw.BindingsFactory.create(this.mediatorMergeBindingsContext, context, context.getSafe($9nBhR.KeysInitQuery.dataFactory))
                                ];
                            case 1:
                                _tmp1 = [
                                    void 0,
                                    new (_3.apply(_2, _tmp.concat([
                                        _state.sent()
                                    ])))
                                ];
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.EQUAL,
                                        context: context,
                                        requireTermExpression: true
                                    })
                                ];
                            case 2:
                                _tmp1 = _tmp1.concat([
                                    _state.sent()
                                ]);
                                return [
                                    4,
                                    this.mediatorFunctionFactory.mediate({
                                        functionName: $aduX6.SparqlOperator.LT,
                                        context: context,
                                        requireTermExpression: true
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    new (_1.apply(_, _tmp1.concat([
                                        _state.sent()
                                    ])))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return ActorTermComparatorFactoryExpressionEvaluator;
}($4Ej7Q.ActorTermComparatorFactory);
module.exports.ActorTermComparatorFactoryExpressionEvaluator = $9e60874f73c137be$var$ActorTermComparatorFactoryExpressionEvaluator;

});
parcelRegister("4Ej7Q", function(module, exports) {
"use strict";
var $3629bbc87382a849$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3629bbc87382a849$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3629bbc87382a849$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3629bbc87382a849$var$__exportStar((parcelRequire("9w3iO")), module.exports);

});
parcelRegister("9w3iO", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorTermComparatorFactory = void 0;

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica actor for term-comparator-factory events.
 *
 * Actor types:
 * * Input:  IActionTermComparatorFactory: the Query Operation Mediator and Function Factory Mediator.
 * * Test:   <none>
 * * Output: IActorTermComparatorFactoryOutput: An object that can order RDF terms.
 *
 * @see IActionTermComparatorFactory
 * @see IActorTermComparatorFactoryOutput
 */ var $6ed9aa02e75d8e45$var$ActorTermComparatorFactory = /*#__PURE__*/ function(_core_1_Actor) {
    (0, $i3fW3._)(ActorTermComparatorFactory, _core_1_Actor);
    function ActorTermComparatorFactory(args) {
        (0, $jGAMp._)(this, ActorTermComparatorFactory);
        var _this;
        _this = (0, $kzDuW._)(this, ActorTermComparatorFactory, [
            args
        ]);
        _this.mediatorQueryOperation = args.mediatorQueryOperation;
        _this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        _this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
        return _this;
    }
    return ActorTermComparatorFactory;
}($kNNoa.Actor);
module.exports.ActorTermComparatorFactory = $6ed9aa02e75d8e45$var$ActorTermComparatorFactory;

});


parcelRegister("7LjCY", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermComparatorExpressionEvaluator = void 0;
var $5a6c25d69252ce9b$var$TermComparatorExpressionEvaluator = /*#__PURE__*/ function() {
    function TermComparatorExpressionEvaluator(internalEvaluator, equalityFunction, lessThanFunction) {
        (0, $jGAMp._)(this, TermComparatorExpressionEvaluator);
        this.internalEvaluator = internalEvaluator;
        this.equalityFunction = equalityFunction;
        this.lessThanFunction = lessThanFunction;
        // SPARQL specifies that blankNode < namedNode < literal. Sparql star expands with < quads and we say < defaultGraph
        this._TERM_ORDERING_PRIORITY = {
            Variable: 0,
            BlankNode: 1,
            NamedNode: 2,
            Literal: 3,
            Quad: 4,
            DefaultGraph: 5
        };
    }
    (0, $byiyg._)(TermComparatorExpressionEvaluator, [
        {
            // Determine the relative numerical order of the two given terms.
            // In accordance with https://www.w3.org/TR/sparql11-query/#modOrderBy
            key: "orderTypes",
            value: function orderTypes(termA, termB) {
                // Check if terms are the same by reference
                if (termA === termB) return 0;
                // We handle undefined that is lower than everything else.
                if (termA === undefined) return -1;
                if (termB === undefined) return 1;
                //
                if (termA.termType !== termB.termType) return this._TERM_ORDERING_PRIORITY[termA.termType] < this._TERM_ORDERING_PRIORITY[termB.termType] ? -1 : 1;
                // Check exact term equality
                if (termA.equals(termB)) return 0;
                // Handle quoted triples
                if (termA.termType === 'Quad' && termB.termType === 'Quad') {
                    var orderSubject = this.orderTypes(termA.subject, termB.subject);
                    if (orderSubject !== 0) return orderSubject;
                    var orderPredicate = this.orderTypes(termA.predicate, termB.predicate);
                    if (orderPredicate !== 0) return orderPredicate;
                    var orderObject = this.orderTypes(termA.object, termB.object);
                    if (orderObject !== 0) return orderObject;
                    return this.orderTypes(termA.graph, termB.graph);
                }
                // Handle literals
                if (termA.termType === 'Literal') return this.orderLiteralTypes(termA, termB);
                return this.comparePrimitives(termA.value, termB.value);
            }
        },
        {
            key: "orderLiteralTypes",
            value: function orderLiteralTypes(litA, litB) {
                var myLitA = this.internalEvaluator.transformer.transformLiteral(litA);
                var myLitB = this.internalEvaluator.transformer.transformLiteral(litB);
                try {
                    if (this.equalityFunction.applyOnTerms([
                        myLitA,
                        myLitB
                    ], this.internalEvaluator).typedValue) return 0;
                    if (this.lessThanFunction.applyOnTerms([
                        myLitA,
                        myLitB
                    ], this.internalEvaluator).typedValue) return -1;
                    return 1;
                } catch (e) {
                    // Fallback to string-based comparison
                    var compareType = this.comparePrimitives(myLitA.dataType, myLitB.dataType);
                    if (compareType !== 0) return compareType;
                    return this.comparePrimitives(myLitA.str(), myLitB.str());
                }
            }
        },
        {
            key: "comparePrimitives",
            value: function comparePrimitives(valueA, valueB) {
                return valueA === valueB ? 0 : valueA < valueB ? -1 : 1;
            }
        }
    ]);
    return TermComparatorExpressionEvaluator;
}();
module.exports.TermComparatorExpressionEvaluator = $5a6c25d69252ce9b$var$TermComparatorExpressionEvaluator;

});



parcelRegister("cCj0z", function(module, exports) {
"use strict";
var $92f7c7461d007b6c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92f7c7461d007b6c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $92f7c7461d007b6c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$92f7c7461d007b6c$var$__exportStar((parcelRequire("276SU")), module.exports);

});
parcelRegister("276SU", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiSmallestFilterBindings = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $itFzw = parcelRequire("itFzw");

var $kQuvF = parcelRequire("kQuvF");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Inner Multi Smallest Filter Bindings RDF Join Actor.
 */ var $18a1935db7664d4a$var$ActorRdfJoinMultiSmallestFilterBindings = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMultiSmallestFilterBindings, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMultiSmallestFilterBindings(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMultiSmallestFilterBindings);
        return (0, $kzDuW._)(this, ActorRdfJoinMultiSmallestFilterBindings, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'multi-smallest-filter-bindings',
                limitEntries: 2,
                limitEntriesMin: true,
                isLeaf: false
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMultiSmallestFilterBindings, [
        {
            key: "sortJoinEntries",
            value: /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ function sortJoinEntries(entries, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, entriesSorted, first, second, secondIndex, secondSharedVariables, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, remaining;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.mediatorJoinEntriesSort.mediate({
                                        entries: entries,
                                        context: context
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), entriesSorted = _ref.entries;
                                // Prioritize entries with modified operations, so these are not re-executed
                                entriesSorted = entriesSorted.sort(function(entryLeft, entryRight) {
                                    if (entryLeft.operationModified && !entryRight.operationModified) return -1;
                                    return 0;
                                });
                                first = entriesSorted.splice(0, 1)[0];
                                secondIndex = -1;
                                secondSharedVariables = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    _loop = function() {
                                        var _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], entry = _step_value[1];
                                        var sharedVariables = first.metadata.variables.filter(function(variableFirst) {
                                            return entry.metadata.variables.some(function(variableSecond) {
                                                return variableFirst.variable.equals(variableSecond.variable);
                                            });
                                        }).length;
                                        if (!second || sharedVariables > secondSharedVariables || sharedVariables === secondSharedVariables && (entry.metadata.variables.length < second.metadata.variables.length || entry.metadata.variables.length === second.metadata.variables.length && entry.metadata.cardinality.value < second.metadata.cardinality.value)) {
                                            second = entry;
                                            secondIndex = i;
                                            secondSharedVariables = sharedVariables;
                                        }
                                    };
                                    for(_iterator = entriesSorted.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (secondSharedVariables === 0) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only join with common variables"))
                                ];
                                remaining = entriesSorted;
                                remaining.splice(secondIndex, 1);
                                return [
                                    2,
                                    (0, $kNNoa.passTest)({
                                        first: first,
                                        second: second,
                                        remaining: remaining
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, entriesUnsorted, _getOrThrow, first, secondIn, remainingIn, smallestStream1, commonVariables, hashes, smallestStream1Projected, chunkedStreams, sourceWrapper, secondStream, second, joinedEntry, _tmp, _, remaining, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.getEntriesWithMetadatas((0, $7WNf6._)(action.entries))
                                ];
                            case 1:
                                entriesUnsorted = _state.sent();
                                return [
                                    4,
                                    this.sortJoinEntries(entriesUnsorted, action.context)
                                ];
                            case 2:
                                _getOrThrow = _state.sent().getOrThrow(), first = _getOrThrow.first, secondIn = _getOrThrow.second, remainingIn = _getOrThrow.remaining;
                                // Clone first stream, because we will use it twice
                                smallestStream1 = first.output.bindingsStream;
                                first.output.bindingsStream = smallestStream1.clone();
                                // Project the first stream on common variables, and filter out duplicates
                                // The common variables array is guaranteed to be non-empty, due to the way the test of this actor is implemented.
                                commonVariables = first.metadata.variables.filter(function(variableFirst) {
                                    return secondIn.metadata.variables.some(function(variableSecond) {
                                        return variableFirst.variable.equals(variableSecond.variable);
                                    });
                                });
                                hashes = {};
                                smallestStream1Projected = smallestStream1.clone().map(function(binding) {
                                    return binding.filter(function(value, key) {
                                        return commonVariables.some(function(commonVariable) {
                                            return commonVariable.variable.equals(key);
                                        });
                                    });
                                }).filter(function(binding) {
                                    var hash = (0, $itFzw.bindingsToString)(binding);
                                    return !(hash in hashes) && (hashes[hash] = true);
                                });
                                // Slice the first stream into chunks according to the block size, so we avoid blocking too long.
                                chunkedStreams = new $kQuvF.ChunkedIterator(smallestStream1Projected, this.blockSize, {
                                    autoStart: false
                                });
                                // Push down bindings of first stream when querying for second stream
                                sourceWrapper = (0, $2n9RU.getOperationSource)(secondIn.operation);
                                secondStream = new $aafx9.UnionIterator(chunkedStreams.map(function(chunk) {
                                    return sourceWrapper.source.queryBindings(secondIn.operation, sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context, {
                                        filterBindings: {
                                            bindings: chunk,
                                            metadata: first.metadata
                                        }
                                    });
                                }));
                                second = {
                                    output: {
                                        type: 'bindings',
                                        bindingsStream: secondStream,
                                        metadata: secondIn.output.metadata
                                    },
                                    operation: secondIn.operation,
                                    operationModified: true
                                };
                                // Destroy the unused original second stream
                                secondIn.output.bindingsStream.destroy();
                                _tmp = {};
                                _ = (0, $2n9RU.getSafeBindings);
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: action.type,
                                        entries: [
                                            first,
                                            second
                                        ],
                                        context: action.context.set($9nBhR.KeysRdfJoin.lastPhysicalJoin, this.physicalName)
                                    })
                                ];
                            case 3:
                                joinedEntry = (_tmp.output = _.apply(void 0, [
                                    _state.sent()
                                ]), _tmp.operation = algebraFactory.createJoin([
                                    first.operation,
                                    second.operation
                                ], false), _tmp.operationModified = true, _tmp);
                                // And then join the result with the remaining streams
                                remaining = remainingIn;
                                remaining.unshift(joinedEntry);
                                _tmp1 = {};
                                return [
                                    4,
                                    this.mediatorJoin.mediate({
                                        type: action.type,
                                        entries: remaining,
                                        context: action.context
                                    })
                                ];
                            case 4:
                                return [
                                    2,
                                    (_tmp1.result = _state.sent(), _tmp1.physicalPlanMetadata = {
                                        firstIndex: entriesUnsorted.indexOf(first),
                                        secondIndex: entriesUnsorted.indexOf(secondIn)
                                    }, _tmp1)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, metadatas, sortedResult, _sortedResult_get, first, second, remaining, sourceWrapper, testingOperation, selectorShape, requestInitialTimes, requestItemTimes, selectivity, cardinalityRemaining;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                metadatas = sideData.metadatas;
                                // Avoid infinite recursion
                                if (action.context.get($9nBhR.KeysRdfJoin.lastPhysicalJoin) === this.physicalName) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not be called recursively"))
                                ];
                                metadatas = (0, $7WNf6._)(metadatas);
                                return [
                                    4,
                                    this.sortJoinEntries(action.entries.map(function(entry, i) {
                                        return (0, $emQHU._)((0, $iT0je._)({}, entry), {
                                            metadata: metadatas[i]
                                        });
                                    }), action.context)
                                ];
                            case 1:
                                sortedResult = _state.sent();
                                if (sortedResult.isFailed()) return [
                                    2,
                                    sortedResult
                                ];
                                _sortedResult_get = sortedResult.get(), first = _sortedResult_get.first, second = _sortedResult_get.second, remaining = _sortedResult_get.remaining;
                                // Only pass if the second entry accepts filterBindings
                                sourceWrapper = (0, $2n9RU.getOperationSource)(second.operation);
                                if (!sourceWrapper) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only process if entries[1] has a source"))
                                ];
                                testingOperation = second.operation;
                                return [
                                    4,
                                    sourceWrapper.source.getSelectorShape(action.context)
                                ];
                            case 2:
                                selectorShape = _state.sent();
                                if (!(0, $2n9RU.doesShapeAcceptOperation)(selectorShape, testingOperation, {
                                    filterBindings: true
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can only process if entries[1] accept filterBindings"))
                                ];
                                // Determine cost coefficients
                                metadatas = [
                                    first.metadata,
                                    second.metadata
                                ].concat((0, $7WNf6._)(remaining.map(function(remain) {
                                    return remain.metadata;
                                })));
                                requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                                requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                                return [
                                    4,
                                    this.mediatorJoinSelectivity.mediate({
                                        entries: [
                                            first,
                                            second
                                        ],
                                        context: action.context
                                    })
                                ];
                            case 3:
                                selectivity = _state.sent().selectivity;
                                cardinalityRemaining = remaining.reduce(function(mul, remain) {
                                    return mul * remain.metadata.cardinality.value * _this.selectivityModifier;
                                }, 1);
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)({
                                        iterations: selectivity * this.selectivityModifier * second.metadata.cardinality.value * cardinalityRemaining,
                                        persistedItems: first.metadata.cardinality.value,
                                        blockingItems: first.metadata.cardinality.value,
                                        requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + cardinalityRemaining * requestItemTimes[1]
                                    }, sideData)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorRdfJoinMultiSmallestFilterBindings;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMultiSmallestFilterBindings = $18a1935db7664d4a$var$ActorRdfJoinMultiSmallestFilterBindings;

});


parcelRegister("1FmL4", function(module, exports) {
"use strict";
var $136b46160129b869$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $136b46160129b869$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $136b46160129b869$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$136b46160129b869$var$__exportStar((parcelRequire("gkCyQ")), module.exports);

});
parcelRegister("gkCyQ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainLogical = void 0;

var $1FnZ2 = parcelRequire("1FnZ2");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Explain Logical Query Process Actor.
 */ var $be3c6cfdd2ca6150$var$ActorQueryProcessExplainLogical = /*#__PURE__*/ function(_bus_query_process_1_ActorQueryProcess) {
    (0, $i3fW3._)(ActorQueryProcessExplainLogical, _bus_query_process_1_ActorQueryProcess);
    function ActorQueryProcessExplainLogical(args) {
        (0, $jGAMp._)(this, ActorQueryProcessExplainLogical);
        return (0, $kzDuW._)(this, ActorQueryProcessExplainLogical, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryProcessExplainLogical, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_context_get;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (((_action_context_get = action.context.get($9nBhR.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $kNNoa.ActionContextKey('explain'))) !== 'logical') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only explain in 'logical' mode."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, operation, context, ref;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.queryProcessor.parse(action.query, action.context)
                                ];
                            case 1:
                                _ref = _state.sent(), operation = _ref.operation, context = _ref.context;
                                return [
                                    4,
                                    this.queryProcessor.optimize(operation, context)
                                ];
                            case 2:
                                ref = _state.sent(), operation = ref.operation, context = ref.context, ref;
                                return [
                                    2,
                                    {
                                        result: {
                                            explain: true,
                                            type: 'logical',
                                            data: operation
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryProcessExplainLogical;
}($1FnZ2.ActorQueryProcess);
module.exports.ActorQueryProcessExplainLogical = $be3c6cfdd2ca6150$var$ActorQueryProcessExplainLogical;

});


parcelRegister("lrzg1", function(module, exports) {
"use strict";
var $f9c777f49787a560$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f9c777f49787a560$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f9c777f49787a560$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f9c777f49787a560$var$__exportStar((parcelRequire("ix8PU")), module.exports);

});
parcelRegister("ix8PU", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainParsed = void 0;

var $1FnZ2 = parcelRequire("1FnZ2");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
/**
 * A comunica Explain Parsed Query Process Actor.
 */ var $d7e229c17e12ef9f$var$ActorQueryProcessExplainParsed = /*#__PURE__*/ function(_bus_query_process_1_ActorQueryProcess) {
    (0, $i3fW3._)(ActorQueryProcessExplainParsed, _bus_query_process_1_ActorQueryProcess);
    function ActorQueryProcessExplainParsed(args) {
        (0, $jGAMp._)(this, ActorQueryProcessExplainParsed);
        return (0, $kzDuW._)(this, ActorQueryProcessExplainParsed, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryProcessExplainParsed, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_context_get;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (((_action_context_get = action.context.get($9nBhR.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $kNNoa.ActionContextKey('explain'))) !== 'parsed') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only explain in 'parsed' mode."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.queryProcessor.parse(action.query, action.context)
                                ];
                            case 1:
                                operation = _state.sent().operation;
                                return [
                                    2,
                                    {
                                        result: {
                                            explain: true,
                                            type: 'parsed',
                                            data: operation
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryProcessExplainParsed;
}($1FnZ2.ActorQueryProcess);
module.exports.ActorQueryProcessExplainParsed = $d7e229c17e12ef9f$var$ActorQueryProcessExplainParsed;

});


parcelRegister("kF7FR", function(module, exports) {
"use strict";
var $f0ad96e7554ad2c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0ad96e7554ad2c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0ad96e7554ad2c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0ad96e7554ad2c8$var$__exportStar((parcelRequire("6b0lg")), module.exports);

$f0ad96e7554ad2c8$var$__exportStar((parcelRequire("8TmDg")), module.exports);

});
parcelRegister("6b0lg", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainPhysical = void 0;

var $1FnZ2 = parcelRequire("1FnZ2");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $8TmDg = parcelRequire("8TmDg");
/**
 * A comunica Explain Physical Query Process Actor.
 */ var $47f409145366a2d5$var$ActorQueryProcessExplainPhysical = /*#__PURE__*/ function(_bus_query_process_1_ActorQueryProcess) {
    (0, $i3fW3._)(ActorQueryProcessExplainPhysical, _bus_query_process_1_ActorQueryProcess);
    function ActorQueryProcessExplainPhysical(args) {
        (0, $jGAMp._)(this, ActorQueryProcessExplainPhysical);
        return (0, $kzDuW._)(this, ActorQueryProcessExplainPhysical, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQueryProcessExplainPhysical, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _action_context_get, mode;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        mode = (_action_context_get = action.context.get($9nBhR.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $kNNoa.ActionContextKey('explain'));
                        if (mode !== 'physical' && mode !== 'physical-json') return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only explain in 'physical' or 'physical-json' mode."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, operation, context, ref, physicalQueryPlanLogger, output, _, _action_context_get, mode;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.queryProcessor.parse(action.query, action.context)
                                ];
                            case 1:
                                _ref = _state.sent(), operation = _ref.operation, context = _ref.context;
                                return [
                                    4,
                                    this.queryProcessor.optimize(operation, context)
                                ];
                            case 2:
                                ref = _state.sent(), operation = ref.operation, context = ref.context, ref;
                                // If we need a physical query plan, store a physical query plan logger in the context, and collect it after exec
                                physicalQueryPlanLogger = new $8TmDg.MemoryPhysicalQueryPlanLogger();
                                context = context.set($9nBhR.KeysInitQuery.physicalQueryPlanLogger, physicalQueryPlanLogger);
                                return [
                                    4,
                                    this.queryProcessor.evaluate(operation, context)
                                ];
                            case 3:
                                output = _state.sent();
                                _ = output.type;
                                switch(_){
                                    case 'bindings':
                                        return [
                                            3,
                                            4
                                        ];
                                    case 'quads':
                                        return [
                                            3,
                                            6
                                        ];
                                    case 'boolean':
                                        return [
                                            3,
                                            8
                                        ];
                                    case 'void':
                                        return [
                                            3,
                                            10
                                        ];
                                }
                                return [
                                    3,
                                    12
                                ];
                            case 4:
                                return [
                                    4,
                                    output.bindingsStream.toArray()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                return [
                                    4,
                                    output.quadStream.toArray()
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 8:
                                return [
                                    4,
                                    output.execute()
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                return [
                                    4,
                                    output.execute()
                                ];
                            case 11:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 12:
                                mode = (_action_context_get = action.context.get($9nBhR.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.getSafe(new $kNNoa.ActionContextKey('explain'));
                                return [
                                    2,
                                    {
                                        result: {
                                            explain: true,
                                            type: mode,
                                            data: mode === 'physical' ? physicalQueryPlanLogger.toCompactString() : physicalQueryPlanLogger.toJson()
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ActorQueryProcessExplainPhysical;
}($1FnZ2.ActorQueryProcess);
module.exports.ActorQueryProcessExplainPhysical = $47f409145366a2d5$var$ActorQueryProcessExplainPhysical;

});
parcelRegister("8TmDg", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numberToString = module.exports.MemoryPhysicalQueryPlanLogger = void 0;

var $gQYIc = parcelRequire("gQYIc");
/**
 * A physical query plan logger that stores everything in memory.
 */ var $67950415d8dc888f$var$MemoryPhysicalQueryPlanLogger = /*#__PURE__*/ function() {
    function MemoryPhysicalQueryPlanLogger() {
        (0, $jGAMp._)(this, MemoryPhysicalQueryPlanLogger);
        this.planNodes = new Map();
    }
    (0, $byiyg._)(MemoryPhysicalQueryPlanLogger, [
        {
            key: "logOperation",
            value: function logOperation(logicalOperator, physicalOperator, node, parentNode, actor, metadata) {
                var planNode = {
                    actor: actor,
                    logicalOperator: logicalOperator,
                    physicalOperator: physicalOperator,
                    rawNode: node,
                    children: [],
                    metadata: metadata
                };
                this.planNodes.set(node, planNode);
                if (this.rootNode) {
                    if (!parentNode) throw new Error("Detected more than one parent-less node");
                    var planParentNode = this.planNodes.get(parentNode);
                    if (!planParentNode) throw new Error("Could not find parent node");
                    planParentNode.children.push(planNode);
                } else {
                    if (parentNode) throw new Error("No root node has been set yet, while a parent is being referenced");
                    this.rootNode = planNode;
                }
            }
        },
        {
            key: "stashChildren",
            value: function stashChildren(node, filter) {
                var planNode = this.planNodes.get(node);
                if (!planNode) throw new Error("Could not find plan node");
                planNode.children = filter ? planNode.children.filter(filter) : [];
            }
        },
        {
            key: "unstashChild",
            value: function unstashChild(node, parentNode) {
                var planNode = this.planNodes.get(node);
                if (planNode) {
                    var planParentNode = this.planNodes.get(parentNode);
                    if (!planParentNode) throw new Error("Could not find plan parent node");
                    planParentNode.children.push(planNode);
                }
            }
        },
        {
            key: "appendMetadata",
            value: function appendMetadata(node, metadata) {
                var planNode = this.planNodes.get(node);
                if (planNode) planNode.metadata = (0, $iT0je._)({}, planNode.metadata, metadata);
            }
        },
        {
            key: "toJson",
            value: function toJson() {
                return this.rootNode ? this.planNodeToJson(this.rootNode) : {};
            }
        },
        {
            key: "planNodeToJson",
            value: function planNodeToJson(node) {
                var _this = this;
                var data = (0, $iT0je._)({
                    logical: node.logicalOperator,
                    physical: node.physicalOperator
                }, this.getLogicalMetadata(node.rawNode), this.compactMetadata(node.metadata));
                if (node.children.length > 0) data.children = node.children.map(function(child) {
                    return _this.planNodeToJson(child);
                });
                // Special case: compact children for bind joins.
                if (data.physical === 'bind' && data.children) {
                    // Group children by query plan format
                    var childrenGrouped = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = data.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var child = _step.value;
                            var _child_children;
                            var _child_children_at;
                            var lastSubChild = (_child_children_at = (_child_children = child.children) === null || _child_children === void 0 ? void 0 : _child_children.at(-1)) !== null && _child_children_at !== void 0 ? _child_children_at : child;
                            var key = this.getPlanHash(lastSubChild).join(',');
                            if (!childrenGrouped[key]) childrenGrouped[key] = [];
                            childrenGrouped[key].push(child);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Compact query plan occurrences
                    var childrenCompact = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Object.values(childrenGrouped)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var children = _step1.value;
                            childrenCompact.push({
                                occurrences: children.length,
                                firstOccurrence: children[0]
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // Replace children with compacted representation
                    data.childrenCompact = childrenCompact;
                    delete data.children;
                }
                return data;
            }
        },
        {
            key: "getPlanHash",
            value: function getPlanHash(node) {
                var _this = this;
                var entries = [
                    "".concat(node.logical, "-").concat(node.physical)
                ];
                if (node.children) entries = (0, $7WNf6._)(entries).concat((0, $7WNf6._)(node.children.flatMap(function(child) {
                    return _this.getPlanHash(child);
                })));
                else if (node.childrenCompact) entries = (0, $7WNf6._)(entries).concat((0, $7WNf6._)(node.childrenCompact.flatMap(function(child) {
                    return _this.getPlanHash(child.firstOccurrence);
                })));
                return entries;
            }
        },
        {
            key: "compactMetadata",
            value: function compactMetadata(metadata) {
                var _this = this;
                return Object.fromEntries(Object.entries(metadata).map(function(param) {
                    var _param = (0, $32TW8._)(param, 2), key = _param[0], value = _param[1];
                    return [
                        key,
                        _this.compactMetadataValue(value)
                    ];
                }));
            }
        },
        {
            key: "compactMetadataValue",
            value: function compactMetadataValue(value) {
                return value && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && 'termType' in value ? this.getLogicalMetadata(value) : value;
            }
        },
        {
            key: "getLogicalMetadata",
            value: function getLogicalMetadata(rawNode) {
                var data = {};
                if ('type' in rawNode) {
                    var _operation_metadata;
                    var operation = rawNode;
                    if ((_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? void 0 : _operation_metadata.scopedSource) data.source = operation.metadata.scopedSource.source.toString();
                    // eslint-disable-next-line ts/switch-exhaustiveness-check
                    switch(operation.type){
                        case 'pattern':
                            data.pattern = this.quadToString(operation);
                            break;
                        case 'project':
                            data.variables = operation.variables.map(function(variable) {
                                return variable.value;
                            });
                            break;
                    }
                }
                return data;
            }
        },
        {
            key: "quadToString",
            value: function quadToString(quad) {
                return "".concat((0, $gQYIc.termToString)(quad.subject), " ").concat((0, $gQYIc.termToString)(quad.predicate), " ").concat((0, $gQYIc.termToString)(quad.object)).concat(quad.graph.termType === 'DefaultGraph' ? '' : " ".concat((0, $gQYIc.termToString)(quad.graph)));
            }
        },
        {
            key: "toCompactString",
            value: function toCompactString() {
                var node = this.toJson();
                var lines = [];
                var sources = new Map();
                if ('logical' in node) this.nodeToCompactString(lines, sources, '', node);
                else lines.push('Empty');
                if (sources.size > 0) {
                    lines.push('');
                    lines.push('sources:');
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = sources.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                            lines.push("  ".concat(id, ": ").concat(key));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return lines.join('\n');
            }
        },
        {
            key: "nodeToCompactString",
            value: function nodeToCompactString(lines, sources, indent, node, metadata) {
                var sourceId;
                if (node.source) {
                    sourceId = sources.get(node.source);
                    if (sourceId === undefined) {
                        sourceId = sources.size;
                        sources.set(node.source, sourceId);
                    }
                }
                lines.push("".concat(indent).concat(node.logical).concat(node.physical ? "(".concat(node.physical, ")") : '').concat(node.pattern ? " (".concat(node.pattern, ")") : '').concat(node.variables ? " (".concat(node.variables.join(','), ")") : '').concat(node.bindOperation ? " bindOperation:(".concat(node.bindOperation.pattern, ") bindCardEst:").concat(node.bindOperationCardinality.type === 'estimate' ? '~' : '').concat($67950415d8dc888f$var$numberToString(node.bindOperationCardinality.value)) : '').concat(node.cardinality ? " cardEst:".concat(node.cardinality.type === 'estimate' ? '~' : '').concat($67950415d8dc888f$var$numberToString(node.cardinality.value)) : '').concat(node.source ? " src:".concat(sourceId) : '').concat(node.cardinalityReal ? " cardReal:".concat(node.cardinalityReal) : '').concat(node.timeSelf ? " timeSelf:".concat($67950415d8dc888f$var$numberToString(node.timeSelf), "ms") : '').concat(node.timeLife ? " timeLife:".concat($67950415d8dc888f$var$numberToString(node.timeLife), "ms") : '').concat(metadata ? " ".concat(metadata) : ''));
                var _node_children;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ((_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this.nodeToCompactString(lines, sources, "".concat(indent, "  "), child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _node_childrenCompact;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = ((_node_childrenCompact = node.childrenCompact) !== null && _node_childrenCompact !== void 0 ? _node_childrenCompact : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var child1 = _step1.value;
                        this.nodeToCompactString(lines, sources, "".concat(indent, "  "), child1.firstOccurrence, "compacted-occurrences:".concat(child1.occurrences));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    ]);
    return MemoryPhysicalQueryPlanLogger;
}();
module.exports.MemoryPhysicalQueryPlanLogger = $67950415d8dc888f$var$MemoryPhysicalQueryPlanLogger;
function $67950415d8dc888f$var$numberToString(value) {
    return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3
    });
}
module.exports.numberToString = $67950415d8dc888f$var$numberToString;

});



parcelRegister("7cuef", function(module, exports) {
"use strict";
var $53e11a34e8c17706$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $53e11a34e8c17706$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $53e11a34e8c17706$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$53e11a34e8c17706$var$__exportStar((parcelRequire("lWSje")), module.exports);

});
parcelRegister("lWSje", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationPruneEmptySourceOperations = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Prune Empty Source Operations Optimize Query Operation Actor.
 */ var $ffa924672990bbef$var$ActorOptimizeQueryOperationPruneEmptySourceOperations = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationPruneEmptySourceOperations, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationPruneEmptySourceOperations(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationPruneEmptySourceOperations);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationPruneEmptySourceOperations, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationPruneEmptySourceOperations, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if ((0, $2n9RU.getOperationSource)(action.operation)) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " does not work with top-level operation sources."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, operation, collectedOperations, self, _obj, emptyOperations, _obj1, _obj2;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                operation = action.operation;
                                // Collect all operations with source types
                                // Only consider unions of patterns or alts of links, since these are created during exhaustive source assignment.
                                collectedOperations = [];
                                // eslint-disable-next-line ts/no-this-alias
                                self = this;
                                $hSHd8.Util.recurseOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.UNION, function(subOperation) {
                                    self.collectMultiOperationInputs(subOperation.input, collectedOperations, $hSHd8.Algebra.types.PATTERN);
                                    return true;
                                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.ALT, function(subOperation) {
                                    self.collectMultiOperationInputs(subOperation.input, collectedOperations, $hSHd8.Algebra.types.LINK);
                                    return false;
                                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.SERVICE, function() {
                                    return false;
                                }), _obj));
                                // Determine in an async manner whether or not these sources return non-empty results
                                emptyOperations = new Set();
                                return [
                                    4,
                                    Promise.all(collectedOperations.map(function(collectedOperation) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            var checkOperation;
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        checkOperation = collectedOperation.type === 'link' ? algebraFactory.createPattern(dataFactory.variable('s'), collectedOperation.iri, dataFactory.variable('o')) : collectedOperation;
                                                        return [
                                                            4,
                                                            this.hasSourceResults(algebraFactory, (0, $2n9RU.getOperationSource)(collectedOperation), checkOperation, action.context)
                                                        ];
                                                    case 1:
                                                        if (!_state.sent()) emptyOperations.add(collectedOperation);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                // Only perform next mapping if we have at least one empty operation
                                if (emptyOperations.size > 0) {
                                    this.logDebug(action.context, "Pruning ".concat(emptyOperations.size, " source-specific operations"));
                                    ;
                                    // Rewrite operations by removing the empty children
                                    operation = $hSHd8.Util.mapOperation(operation, (_obj1 = {}, (0, $cqEAj._)(_obj1, $hSHd8.Algebra.types.UNION, function(subOperation, factory) {
                                        return self.mapMultiOperation(subOperation, emptyOperations, function(children) {
                                            return factory.createUnion(children);
                                        });
                                    }), (0, $cqEAj._)(_obj1, $hSHd8.Algebra.types.ALT, function(subOperation, factory) {
                                        return self.mapMultiOperation(subOperation, emptyOperations, function(children) {
                                            return factory.createAlt(children);
                                        });
                                    }), _obj1), algebraFactory);
                                    ;
                                    // Identify and remove operations that have become empty now due to missing variables
                                    operation = $hSHd8.Util.mapOperation(operation, (_obj2 = {}, (0, $cqEAj._)(_obj2, $hSHd8.Algebra.types.PROJECT, function(subOperation, factory) {
                                        // Remove projections that have become empty now due to missing variables
                                        if (ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation)) return {
                                            recurse: false,
                                            result: factory.createUnion([])
                                        };
                                        return {
                                            recurse: true,
                                            result: subOperation
                                        };
                                    }), (0, $cqEAj._)(_obj2, $hSHd8.Algebra.types.LEFT_JOIN, function(subOperation) {
                                        // Remove left joins with empty right operation
                                        if (ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation.input[1])) return {
                                            recurse: true,
                                            result: subOperation.input[0]
                                        };
                                        return {
                                            recurse: true,
                                            result: subOperation
                                        };
                                    }), _obj2), algebraFactory);
                                }
                                return [
                                    2,
                                    {
                                        operation: operation,
                                        context: action.context
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "collectMultiOperationInputs",
            value: function collectMultiOperationInputs(inputs, collectedOperations, inputType) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        if ((0, $2n9RU.getOperationSource)(input) && input.type === inputType) collectedOperations.push(input);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "mapMultiOperation",
            value: function mapMultiOperation(operation, emptyOperations, multiOperationFactory) {
                // Determine which operations return non-empty results
                var nonEmptyInputs = operation.input.filter(function(input) {
                    return !emptyOperations.has(input);
                });
                // Remove empty operations
                if (nonEmptyInputs.length === operation.input.length) return {
                    result: operation,
                    recurse: true
                };
                if (nonEmptyInputs.length === 0) return {
                    result: multiOperationFactory([]),
                    recurse: false
                };
                if (nonEmptyInputs.length === 1) return {
                    result: nonEmptyInputs[0],
                    recurse: true
                };
                return {
                    result: multiOperationFactory(nonEmptyInputs),
                    recurse: true
                };
            }
        },
        {
            key: "hasSourceResults",
            value: /**
     * Check if the given query operation will produce at least one result in the given source.
     * @param algebraFactory The algebra factory.
     * @param source A query source.
     * @param input A query operation.
     * @param context The query context.
     */ function hasSourceResults(algebraFactory, source, input, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _source_context, _source_context_get, askOperation, _, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Traversal sources should never be considered empty at optimization time.
                                if ((_source_context_get = (_source_context = source.context) === null || _source_context === void 0 ? void 0 : _source_context.get($9nBhR.KeysQuerySourceIdentify.traverse)) !== null && _source_context_get !== void 0 ? _source_context_get : context.get($9nBhR.KeysQuerySourceIdentify.traverse)) return [
                                    2,
                                    true
                                ];
                                if (!this.useAskIfSupported) return [
                                    3,
                                    2
                                ];
                                askOperation = algebraFactory.createAsk(input);
                                _ = (0, $2n9RU.doesShapeAcceptOperation);
                                return [
                                    4,
                                    source.source.getSelectorShape(context)
                                ];
                            case 1:
                                if (_.apply(void 0, [
                                    _state.sent(),
                                    askOperation
                                ])) return [
                                    2,
                                    source.source.queryBoolean(askOperation, context)
                                ];
                                _state.label = 2;
                            case 2:
                                // Send the operation as-is and check the response cardinality
                                bindingsStream = source.source.queryBindings(input, context);
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        bindingsStream.on('error', reject);
                                        bindingsStream.getProperty('metadata', function(metadata) {
                                            bindingsStream.destroy();
                                            resolve(metadata.cardinality.value > 0);
                                        });
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "hasEmptyOperation",
            value: function hasEmptyOperation(operation) {
                // If union (or alt) is empty, consider it empty (`Array.every` on an empty array always returns true)
                // But if we find a union with multiple children,
                // *all* of the children must be empty before the full operation is considered empty.
                var emptyOperation = false;
                var _obj;
                $hSHd8.Util.recurseOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.UNION, function(subOperation) {
                    if (subOperation.input.every(function(subSubOperation) {
                        return ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subSubOperation);
                    })) emptyOperation = true;
                    return false;
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.ALT, function(subOperation) {
                    if (subOperation.input.length === 0) emptyOperation = true;
                    return false;
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.LEFT_JOIN, function(subOperation) {
                    // Only recurse into left part of left-join
                    if (ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation.input[0])) emptyOperation = true;
                    return false;
                }), _obj));
                return emptyOperation;
            }
        }
    ]);
    return ActorOptimizeQueryOperationPruneEmptySourceOperations;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationPruneEmptySourceOperations = $ffa924672990bbef$var$ActorOptimizeQueryOperationPruneEmptySourceOperations;

});


parcelRegister("kcGj8", function(module, exports) {
"use strict";
var $eb55bf136b055d9a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb55bf136b055d9a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eb55bf136b055d9a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$eb55bf136b055d9a$var$__exportStar((parcelRequire("5Accq")), module.exports);

});
parcelRegister("5Accq", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpRetry = void 0;

var $2terW = parcelRequire("2terW");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");
var $4109c7197578d6f6$var$ActorHttpRetry = /*#__PURE__*/ function(_bus_http_1_ActorHttp) {
    (0, $i3fW3._)(ActorHttpRetry, _bus_http_1_ActorHttp);
    function ActorHttpRetry(args) {
        (0, $jGAMp._)(this, ActorHttpRetry);
        var _this;
        _this = (0, $kzDuW._)(this, ActorHttpRetry, [
            args
        ]);
        _this.activeDelays = {};
        _this.httpInvalidator = args.httpInvalidator;
        _this.httpInvalidator.addInvalidateListener(function(action) {
            return _this.handleHttpInvalidateEvent(action);
        });
        _this.mediatorHttp = args.mediatorHttp;
        return _this;
    }
    (0, $byiyg._)(ActorHttpRetry, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var retryCount;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.context.has(ActorHttpRetry.keyWrapped)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only wrap a request once"))
                        ];
                        retryCount = action.context.get($9nBhR.KeysHttp.httpRetryCount);
                        if (!retryCount || retryCount < 1) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " requires a retry count greater than zero to function"))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                time: 0
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, _loop, _this1, url, attemptLimit, _action_context_get, retryDelayFallback, retryDelayLimit, retryStatusCodes, attempt, _ret;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function(attempt) {
                                    var retryDelay, response, retryAfterHeader, retryAfter;
                                    return (0, $9N5UN.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                retryDelay = url.host in _this.activeDelays ? _this.activeDelays[url.host].date.getTime() - Date.now() : retryDelayFallback;
                                                if (!(retryDelayLimit && retryDelay > retryDelayLimit)) return [
                                                    3,
                                                    1
                                                ];
                                                _this.logWarn(action.context, 'Requested delay exceeds the limit', function() {
                                                    return {
                                                        url: url.href,
                                                        delay: retryDelay,
                                                        delayDate: _this1.activeDelays[url.host].date.toISOString(),
                                                        delayLimit: retryDelayLimit,
                                                        currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                    };
                                                });
                                                return [
                                                    2,
                                                    "break"
                                                ];
                                            case 1:
                                                if (!(retryDelay > 0 && attempt > 1)) return [
                                                    3,
                                                    3
                                                ];
                                                _this.logDebug(action.context, 'Delaying request', function() {
                                                    return {
                                                        url: url.href,
                                                        delay: retryDelay,
                                                        currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                    };
                                                });
                                                return [
                                                    4,
                                                    ActorHttpRetry.sleep(retryDelay)
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    4,
                                                    _this.mediatorHttp.mediate((0, $emQHU._)((0, $iT0je._)({}, action), {
                                                        context: action.context.set(ActorHttpRetry.keyWrapped, true)
                                                    }))
                                                ];
                                            case 4:
                                                response = _state.sent();
                                                if (response.ok) return [
                                                    2,
                                                    {
                                                        v: response
                                                    }
                                                ];
                                                if (retryStatusCodes && retryStatusCodes.includes(response.status)) {
                                                    _this.logDebug(action.context, 'Status code in force retry list, forcing retry', function() {
                                                        return {
                                                            url: url.href,
                                                            status: response.status,
                                                            statusText: response.statusText,
                                                            currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                        };
                                                    });
                                                    return [
                                                        2,
                                                        "continue"
                                                    ];
                                                }
                                                if (response.status === 504) {
                                                    // When the server is acting as a proxy and the source times it, it makes sense to retry
                                                    // with the hope that the source server replies within the timeout
                                                    _this.logDebug(action.context, 'Received proxy timeout', function() {
                                                        return {
                                                            url: url.href,
                                                            status: response.status,
                                                            statusText: response.statusText,
                                                            currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                        };
                                                    });
                                                    return [
                                                        2,
                                                        "continue"
                                                    ];
                                                }
                                                if (// Status codes 429 (Too Many Requests) and 503 (Temporarily Unavailable) can have Retry-After
                                                response.status === 429 || response.status === 503 || // DBPedia SPARQL endpoint uses 405 instead of 429 and sends a Retry-After with it to indicate rate limits
                                                response.status === 405 && response.headers.has('retry-after')) {
                                                    retryAfterHeader = response.headers.get('retry-after');
                                                    if (retryAfterHeader) {
                                                        retryAfter = ActorHttpRetry.parseRetryAfterHeader(retryAfterHeader);
                                                        if (retryAfter) {
                                                            // Clear any previous clean-up timers for the host
                                                            if (url.host in _this.activeDelays) clearTimeout(_this.activeDelays[url.host].timeout);
                                                            // Record the current host-specific active delay, and add a clean-up timer for this new delay
                                                            _this.activeDelays[url.host] = {
                                                                date: retryAfter,
                                                                timeout: setTimeout(function() {
                                                                    return delete _this1.activeDelays[url.host];
                                                                }, retryAfter.getTime() - Date.now())
                                                            };
                                                        } else _this.logDebug(action.context, 'Invalid Retry-After header value from server', function() {
                                                            return {
                                                                url: url.href,
                                                                status: response.status,
                                                                statusText: response.statusText,
                                                                retryAfterHeader: retryAfterHeader,
                                                                currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                            };
                                                        });
                                                    }
                                                    _this.logDebug(action.context, 'Server temporarily unavailable', function() {
                                                        return {
                                                            url: url.href,
                                                            status: response.status,
                                                            statusText: response.statusText,
                                                            currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                        };
                                                    });
                                                    return [
                                                        2,
                                                        "continue"
                                                    ];
                                                }
                                                if (response.status >= 400 && response.status < 500) {
                                                    // When the server reports a missing document, insufficient permissions, bad request or other error
                                                    // in the 400 range except for the rate limit, it makes sense to skip further retries.
                                                    // Sending the same, potentially invalid request for missing or inaccessible resources is unlikely to succeed.
                                                    _this.logDebug(action.context, 'Server reported client-side error', function() {
                                                        return {
                                                            url: url.href,
                                                            status: response.status,
                                                            statusText: response.statusText,
                                                            currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                        };
                                                    });
                                                    return [
                                                        2,
                                                        "break"
                                                    ];
                                                }
                                                if (response.status >= 500 && response.status < 600) {
                                                    // When a server-side error is encountered, it will likely not be fixable client-side,
                                                    // and sending the same request again will most likely result in the same server-side failure.
                                                    // Therefore, it makes sense not to retry on such errors at all.
                                                    _this.logDebug(action.context, 'Server-side error encountered, terminating', function() {
                                                        return {
                                                            url: url.href,
                                                            status: response.status,
                                                            statusText: response.statusText,
                                                            currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                        };
                                                    });
                                                    return [
                                                        2,
                                                        "break"
                                                    ];
                                                }
                                                // Error codes not specifically handled should be logged as-is for user to notice
                                                _this.logDebug(action.context, 'Request failed', function() {
                                                    return {
                                                        url: url.href,
                                                        status: response.status,
                                                        statusText: response.statusText,
                                                        currentAttempt: "".concat(attempt, " / ").concat(attemptLimit)
                                                    };
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _this1 = this;
                                url = $2terW.ActorHttp.getInputUrl(action.input);
                                // Attempt once + the number of retries specified by the user
                                attemptLimit = action.context.getSafe($9nBhR.KeysHttp.httpRetryCount) + 1;
                                retryDelayFallback = (_action_context_get = action.context.get($9nBhR.KeysHttp.httpRetryDelayFallback)) !== null && _action_context_get !== void 0 ? _action_context_get : 0;
                                retryDelayLimit = action.context.get($9nBhR.KeysHttp.httpRetryDelayLimit);
                                retryStatusCodes = action.context.get($9nBhR.KeysHttp.httpRetryStatusCodes);
                                attempt = 1;
                                _state.label = 1;
                            case 1:
                                if (!(attempt <= attemptLimit)) return [
                                    3,
                                    4
                                ];
                                _this = this;
                                return [
                                    5,
                                    (0, $9N5UN.__values)(_loop(attempt))
                                ];
                            case 2:
                                _ret = _state.sent();
                                if ((0, $3KZcf._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                if (_ret === "break") return [
                                    3,
                                    4
                                ];
                                _state.label = 3;
                            case 3:
                                attempt++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                throw new Error("Request failed: ".concat(url.href));
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Handles HTTP cache invalidation events.
     * @param {IActionHttpInvalidate} action The invalidation action
     */ key: "handleHttpInvalidateEvent",
            value: function handleHttpInvalidateEvent(action) {
                var invalidatedHost = action.url ? new URL(action.url).host : undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this.activeDelays)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var host = _step.value;
                        if (!invalidatedHost || host === invalidatedHost) {
                            clearTimeout(this.activeDelays[host].timeout);
                            delete this.activeDelays[host];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "sleep",
            value: /**
     * Sleeps for the specified amount of time, using a timeout
     * @param {number} ms The amount of milliseconds to sleep
     */ function sleep(ms) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(ms > 0)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, ms);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseRetryAfterHeader",
            value: /**
     * Parses a Retry-After HTTP header value following the specification:
     * https://httpwg.org/specs/rfc9110.html#field.retry-after
     * @param {string} retryAfter The raw header value as string
     * @returns The parsed Date object, or undefined in case of invalid header value
     */ function parseRetryAfterHeader(retryAfter) {
                if (ActorHttpRetry.numberRegex.test(retryAfter)) return new Date(Date.now() + Number.parseInt(retryAfter, 10) * 1000);
                if (ActorHttpRetry.dateRegex.test(retryAfter)) return new Date(retryAfter);
            }
        }
    ]);
    return ActorHttpRetry;
}($2terW.ActorHttp);
module.exports.ActorHttpRetry = $4109c7197578d6f6$var$ActorHttpRetry;
// Expression that matches dates expressed in the HTTP Date header format
// eslint-disable-next-line max-len
$4109c7197578d6f6$var$ActorHttpRetry.dateRegex = RegExp("^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), [0-9]{2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) [0-9]{4} [0-9]{2}:[0-9]{2}:[0-9]{2} GMT$", "u");
// Expression that matches numeric values of Retry-After
$4109c7197578d6f6$var$ActorHttpRetry.numberRegex = RegExp("^[0-9]+$", "u");
// Context key to indicate that the actor has already wrapped the given request
$4109c7197578d6f6$var$ActorHttpRetry.keyWrapped = new $kNNoa.ActionContextKey('urn:comunica:actor-http-retry#wrapped');

});


parcelRegister("49KPC", function(module, exports) {
"use strict";
var $306c547564858f35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $306c547564858f35$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $306c547564858f35$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$306c547564858f35$var$__exportStar((parcelRequire("bvoFx")), module.exports);

});
parcelRegister("bvoFx", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpLimitRate = void 0;

var $2terW = parcelRequire("2terW");

var $kNNoa = parcelRequire("kNNoa");
var $8605b9b77c0b959a$var$ActorHttpLimitRate = /*#__PURE__*/ function(_bus_http_1_ActorHttp) {
    (0, $i3fW3._)(ActorHttpLimitRate, _bus_http_1_ActorHttp);
    function ActorHttpLimitRate(args) {
        (0, $jGAMp._)(this, ActorHttpLimitRate);
        var _this;
        _this = (0, $kzDuW._)(this, ActorHttpLimitRate, [
            args
        ]);
        _this.mediatorHttp = args.mediatorHttp;
        _this.httpInvalidator = args.httpInvalidator;
        _this.httpInvalidator.addInvalidateListener(function(action) {
            return _this.handleHttpInvalidateEvent(action);
        });
        _this.correctionMultiplier = args.correctionMultiplier;
        _this.failureMultiplier = args.failureMultiplier;
        _this.limitByDefault = args.limitByDefault;
        _this.allowOverlap = args.allowOverlap;
        _this.hostData = new Map();
        return _this;
    }
    (0, $byiyg._)(ActorHttpLimitRate, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.context.has(ActorHttpLimitRate.keyWrapped)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " can only wrap a request once"))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTest)({
                                time: 0
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, requestUrl, requestHostData, currentTimestamp, currentRequestDelay, registerCompletedRequest, response, error;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                requestUrl = $2terW.ActorHttp.getInputUrl(action.input);
                                requestHostData = this.hostData.get(requestUrl.host);
                                if (!requestHostData) {
                                    requestHostData = {
                                        latestRequestTimestamp: 0,
                                        rateLimited: this.limitByDefault,
                                        requestInterval: Number.NEGATIVE_INFINITY
                                    };
                                    this.hostData.set(requestUrl.host, requestHostData);
                                }
                                currentTimestamp = Date.now();
                                currentRequestDelay = 0;
                                if (requestHostData.rateLimited) currentRequestDelay = Math.max(0, requestHostData.latestRequestTimestamp + requestHostData.requestInterval - currentTimestamp);
                                // Update the latest request timestamp before waiting, so that further requests will be delayed correctly.
                                // When overlap is disallowed, the timestamp is set to the expected despatch time of the current request,
                                // which will help smooth out request bursts by spacing them out evently. With overlap allowed, however,
                                // the timestamp is set to current time, which will result in overlapping requests and prevent smoothing.
                                requestHostData.latestRequestTimestamp = currentTimestamp + (this.allowOverlap ? 0 : 1) * currentRequestDelay;
                                if (!(currentRequestDelay > 0)) return [
                                    3,
                                    2
                                ];
                                this.logDebug(action.context, 'Delaying request', function() {
                                    return {
                                        url: requestUrl.href,
                                        requestInterval: requestHostData.requestInterval,
                                        currentDelay: currentRequestDelay
                                    };
                                });
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, currentRequestDelay);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                registerCompletedRequest = function(success) {
                                    var requestDuration = (success ? 1 : _this.failureMultiplier) * (Date.now() - currentTimestamp - currentRequestDelay);
                                    if (requestHostData.requestInterval < 0) requestHostData.requestInterval = Math.round(requestDuration * _this.correctionMultiplier);
                                    else requestHostData.requestInterval += Math.round(_this.correctionMultiplier * (requestDuration - requestHostData.requestInterval));
                                    if (!success && !requestHostData.rateLimited) {
                                        _this.logDebug(action.context, 'Marking host as rate-limited', function() {
                                            return {
                                                host: requestUrl.host
                                            };
                                        });
                                        requestHostData.rateLimited = true;
                                    }
                                };
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.mediatorHttp.mediate((0, $emQHU._)((0, $iT0je._)({}, action), {
                                        context: action.context.set(ActorHttpLimitRate.keyWrapped, true)
                                    }))
                                ];
                            case 4:
                                response = _state.sent();
                                registerCompletedRequest(response.ok);
                                return [
                                    2,
                                    response
                                ];
                            case 5:
                                error = _state.sent();
                                registerCompletedRequest(false);
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Handles HTTP cache invalidation events.
     * @param {IActionHttpInvalidate} action The invalidation action
     */ key: "handleHttpInvalidateEvent",
            value: function handleHttpInvalidateEvent(action) {
                if (action.url) {
                    var invalidatedHost = new URL(action.url).host;
                    this.hostData["delete"](invalidatedHost);
                } else this.hostData.clear();
            }
        }
    ]);
    return ActorHttpLimitRate;
}($2terW.ActorHttp);
module.exports.ActorHttpLimitRate = $8605b9b77c0b959a$var$ActorHttpLimitRate;
// Context key to indicate that the actor has already wrapped the given request
$8605b9b77c0b959a$var$ActorHttpLimitRate.keyWrapped = new $kNNoa.ActionContextKey('urn:comunica:actor-http-limit-rate#wrapped');

});


parcelRegister("bg8LU", function(module, exports) {
"use strict";
var $8327fe32f2042245$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8327fe32f2042245$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8327fe32f2042245$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8327fe32f2042245$var$__exportStar((parcelRequire("3iNIW")), module.exports);

});
parcelRegister("3iNIW", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifySerialized = void 0;

var $eznfg = parcelRequire("eznfg");

var $kNNoa = parcelRequire("kNNoa");

var $kAqAk = parcelRequire("kAqAk");

var $VB1LN = parcelRequire("VB1LN");
/**
 * A comunica Serialized Query Source Identify Actor.
 */ var $26799fa30dbda11f$var$ActorQuerySourceIdentifySerialized = /*#__PURE__*/ function(_bus_query_source_identify_1_ActorQuerySourceIdentify) {
    (0, $i3fW3._)(ActorQuerySourceIdentifySerialized, _bus_query_source_identify_1_ActorQuerySourceIdentify);
    function ActorQuerySourceIdentifySerialized(args) {
        (0, $jGAMp._)(this, ActorQuerySourceIdentifySerialized);
        return (0, $kzDuW._)(this, ActorQuerySourceIdentifySerialized, [
            args
        ]);
    }
    (0, $byiyg._)(ActorQuerySourceIdentifySerialized, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (!this.isStringSource(action.querySourceUnidentified)) return [
                            2,
                            (0, $kNNoa.failTest)("".concat(this.name, " requires a single query source with serialized type to be present in the context."))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _, _1, _tmp, _tmp1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = this.mediatorQuerySourceIdentify).mediate;
                                _tmp = {};
                                _tmp1 = {
                                    type: 'rdfjs'
                                };
                                return [
                                    4,
                                    this.getRdfSource(action.context, action.querySourceUnidentified)
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, [
                                        (_tmp.querySourceUnidentified = (_tmp1.value = _state.sent(), _tmp1.context = action.querySourceUnidentified.context, _tmp1), _tmp.context = action.context, _tmp)
                                    ])
                                ];
                            case 2:
                                // Delegate source identification to the same bus again, by converting the string into an RDF/JS source
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getRdfSource",
            value: /**
     * Parses the string data source through the RDF parse bus, returning the RDF source.
     * @param context The run action context
     * @param source The source from the run action context
     * @returns Parsed RDF source that can be passed to quad pattern resolve mediator as an RDF/JS source
     */ function getRdfSource(context, source) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var textStream, parseAction, parseResult;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                textStream = new $VB1LN.Readable({
                                    objectMode: true
                                });
                                /* istanbul ignore next */ textStream._read = function() {
                                // Do nothing
                                };
                                textStream.push(source.value);
                                textStream.push(null);
                                parseAction = {
                                    context: context,
                                    handle: {
                                        metadata: {
                                            baseIRI: source.baseIRI
                                        },
                                        data: textStream,
                                        context: context
                                    },
                                    handleMediaType: source.mediaType
                                };
                                return [
                                    4,
                                    this.mediatorRdfParse.mediate(parseAction)
                                ];
                            case 1:
                                parseResult = _state.sent();
                                return [
                                    4,
                                    (0, $kAqAk.storeStream)(parseResult.handle.data)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "isStringSource",
            value: function isStringSource(source) {
                if (!('type' in source)) {
                    if (!(typeof source.value === 'string')) return false;
                    return 'mediaType' in source;
                }
                return source.type === 'serialized';
            }
        }
    ]);
    return ActorQuerySourceIdentifySerialized;
}($eznfg.ActorQuerySourceIdentify);
module.exports.ActorQuerySourceIdentifySerialized = $26799fa30dbda11f$var$ActorQuerySourceIdentifySerialized;

});
parcelRegister("VB1LN", function(module, exports) {
'use strict';

var $axoyE = parcelRequire("axoyE");

var $cI9Iq = parcelRequire("cI9Iq");
var $0ad20be2a36c9f85$var$originalDestroy = $axoyE.Readable.destroy;
module.exports = $axoyE.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $axoyE._uint8ArrayToBuffer;
module.exports._isUint8Array = $axoyE._isUint8Array;
module.exports.isDisturbed = $axoyE.isDisturbed;
module.exports.isErrored = $axoyE.isErrored;
module.exports.isReadable = $axoyE.isReadable;
module.exports.Readable = $axoyE.Readable;
module.exports.Writable = $axoyE.Writable;
module.exports.Duplex = $axoyE.Duplex;
module.exports.Transform = $axoyE.Transform;
module.exports.PassThrough = $axoyE.PassThrough;
module.exports.addAbortSignal = $axoyE.addAbortSignal;
module.exports.finished = $axoyE.finished;
module.exports.destroy = $axoyE.destroy;
module.exports.destroy = $0ad20be2a36c9f85$var$originalDestroy;
module.exports.pipeline = $axoyE.pipeline;
module.exports.compose = $axoyE.compose;
Object.defineProperty($axoyE, 'promises', {
    configurable: true,
    enumerable: true,
    get: function() {
        return $cI9Iq;
    }
});
module.exports.Stream = $axoyE.Stream;
// Allow default importing
module.exports["default"] = module.exports;

});
parcelRegister("axoyE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $1he7j = parcelRequire("1he7j");
var $7ac0091e7ac5996a$require$Buffer = $1he7j.Buffer;

var $4eV73 = parcelRequire("4eV73");
/* replacement end */ var $7ac0091e7ac5996a$var$ObjectDefineProperty = $4eV73.ObjectDefineProperty, $7ac0091e7ac5996a$var$ObjectKeys = $4eV73.ObjectKeys, $7ac0091e7ac5996a$var$ReflectApply = $4eV73.ReflectApply;

var $7mxb7 = parcelRequire("7mxb7");
var $7ac0091e7ac5996a$var$_require_promisify = $7mxb7.promisify, $7ac0091e7ac5996a$var$customPromisify = $7ac0091e7ac5996a$var$_require_promisify.custom;

var $hm6J1 = parcelRequire("hm6J1");
var $7ac0091e7ac5996a$var$streamReturningOperators = $hm6J1.streamReturningOperators, $7ac0091e7ac5996a$var$promiseReturningOperators = $hm6J1.promiseReturningOperators;

var $8DZ5K = parcelRequire("8DZ5K");
var $7ac0091e7ac5996a$var$ERR_ILLEGAL_CONSTRUCTOR = $8DZ5K.codes.ERR_ILLEGAL_CONSTRUCTOR;

var $byOAZ = parcelRequire("byOAZ");

var $l767L = parcelRequire("l767L");
var $7ac0091e7ac5996a$var$setDefaultHighWaterMark = $l767L.setDefaultHighWaterMark, $7ac0091e7ac5996a$var$getDefaultHighWaterMark = $l767L.getDefaultHighWaterMark;

var $aILEd = parcelRequire("aILEd");
var $7ac0091e7ac5996a$require$pipeline = $aILEd.pipeline;

var $1frHX = parcelRequire("1frHX");
var $7ac0091e7ac5996a$require$destroyer = $1frHX.destroyer;

var $kAgPS = parcelRequire("kAgPS");
var $7ac0091e7ac5996a$var$internalBuffer = {};

var $cI9Iq = parcelRequire("cI9Iq");

var $2gPtE = parcelRequire("2gPtE");

var $7ac0091e7ac5996a$var$Stream = module.exports = (parcelRequire("5Ze7g")).Stream;
$7ac0091e7ac5996a$var$Stream.isDestroyed = $2gPtE.isDestroyed;
$7ac0091e7ac5996a$var$Stream.isDisturbed = $2gPtE.isDisturbed;
$7ac0091e7ac5996a$var$Stream.isErrored = $2gPtE.isErrored;
$7ac0091e7ac5996a$var$Stream.isReadable = $2gPtE.isReadable;
$7ac0091e7ac5996a$var$Stream.isWritable = $2gPtE.isWritable;

$7ac0091e7ac5996a$var$Stream.Readable = (parcelRequire("4jNps"));
var $7ac0091e7ac5996a$var$_iteratorNormalCompletion = true, $7ac0091e7ac5996a$var$_didIteratorError = false, $7ac0091e7ac5996a$var$_iteratorError = undefined;
try {
    for(var $7ac0091e7ac5996a$var$_iterator = $7ac0091e7ac5996a$var$ObjectKeys($7ac0091e7ac5996a$var$streamReturningOperators)[Symbol.iterator](), $7ac0091e7ac5996a$var$_step; !($7ac0091e7ac5996a$var$_iteratorNormalCompletion = ($7ac0091e7ac5996a$var$_step = $7ac0091e7ac5996a$var$_iterator.next()).done); $7ac0091e7ac5996a$var$_iteratorNormalCompletion = true){
        var $7ac0091e7ac5996a$var$key = $7ac0091e7ac5996a$var$_step.value;
        var $7ac0091e7ac5996a$var$fn = function fn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn ? this.constructor : void 0) throw $7ac0091e7ac5996a$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7ac0091e7ac5996a$var$Stream.Readable.from($7ac0091e7ac5996a$var$ReflectApply($7ac0091e7ac5996a$var$op, this, args));
        };
        var $7ac0091e7ac5996a$var$op = $7ac0091e7ac5996a$var$streamReturningOperators[$7ac0091e7ac5996a$var$key];
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$fn, 'name', {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$op.name
        });
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$fn, 'length', {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$op.length
        });
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$Stream.Readable.prototype, $7ac0091e7ac5996a$var$key, {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$fn,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7ac0091e7ac5996a$var$_didIteratorError = true;
    $7ac0091e7ac5996a$var$_iteratorError = err;
} finally{
    try {
        if (!$7ac0091e7ac5996a$var$_iteratorNormalCompletion && $7ac0091e7ac5996a$var$_iterator["return"] != null) {
            $7ac0091e7ac5996a$var$_iterator["return"]();
        }
    } finally{
        if ($7ac0091e7ac5996a$var$_didIteratorError) {
            throw $7ac0091e7ac5996a$var$_iteratorError;
        }
    }
}
var $7ac0091e7ac5996a$var$_iteratorNormalCompletion1 = true, $7ac0091e7ac5996a$var$_didIteratorError1 = false, $7ac0091e7ac5996a$var$_iteratorError1 = undefined;
try {
    for(var $7ac0091e7ac5996a$var$_iterator1 = $7ac0091e7ac5996a$var$ObjectKeys($7ac0091e7ac5996a$var$promiseReturningOperators)[Symbol.iterator](), $7ac0091e7ac5996a$var$_step1; !($7ac0091e7ac5996a$var$_iteratorNormalCompletion1 = ($7ac0091e7ac5996a$var$_step1 = $7ac0091e7ac5996a$var$_iterator1.next()).done); $7ac0091e7ac5996a$var$_iteratorNormalCompletion1 = true){
        var $7ac0091e7ac5996a$var$key1 = $7ac0091e7ac5996a$var$_step1.value;
        var $7ac0091e7ac5996a$var$fn1 = function fn1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (this instanceof fn1 ? this.constructor : void 0) throw $7ac0091e7ac5996a$var$ERR_ILLEGAL_CONSTRUCTOR();
            return $7ac0091e7ac5996a$var$ReflectApply($7ac0091e7ac5996a$var$op1, this, args);
        };
        var $7ac0091e7ac5996a$var$op1 = $7ac0091e7ac5996a$var$promiseReturningOperators[$7ac0091e7ac5996a$var$key1];
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$fn1, 'name', {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$op1.name
        });
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$fn1, 'length', {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$op1.length
        });
        $7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$Stream.Readable.prototype, $7ac0091e7ac5996a$var$key1, {
            __proto__: null,
            value: $7ac0091e7ac5996a$var$fn1,
            enumerable: false,
            configurable: true,
            writable: true
        });
    }
} catch (err) {
    $7ac0091e7ac5996a$var$_didIteratorError1 = true;
    $7ac0091e7ac5996a$var$_iteratorError1 = err;
} finally{
    try {
        if (!$7ac0091e7ac5996a$var$_iteratorNormalCompletion1 && $7ac0091e7ac5996a$var$_iterator1["return"] != null) {
            $7ac0091e7ac5996a$var$_iterator1["return"]();
        }
    } finally{
        if ($7ac0091e7ac5996a$var$_didIteratorError1) {
            throw $7ac0091e7ac5996a$var$_iteratorError1;
        }
    }
}

$7ac0091e7ac5996a$var$Stream.Writable = (parcelRequire("2VGBJ"));

$7ac0091e7ac5996a$var$Stream.Duplex = (parcelRequire("1HP2L"));

$7ac0091e7ac5996a$var$Stream.Transform = (parcelRequire("fGBRz"));

$7ac0091e7ac5996a$var$Stream.PassThrough = (parcelRequire("4AOZp"));
$7ac0091e7ac5996a$var$Stream.pipeline = $7ac0091e7ac5996a$require$pipeline;

var $jYKwv = parcelRequire("jYKwv");
var $7ac0091e7ac5996a$require$addAbortSignal = $jYKwv.addAbortSignal;
$7ac0091e7ac5996a$var$Stream.addAbortSignal = $7ac0091e7ac5996a$require$addAbortSignal;
$7ac0091e7ac5996a$var$Stream.finished = $kAgPS;
$7ac0091e7ac5996a$var$Stream.destroy = $7ac0091e7ac5996a$require$destroyer;
$7ac0091e7ac5996a$var$Stream.compose = $byOAZ;
$7ac0091e7ac5996a$var$Stream.setDefaultHighWaterMark = $7ac0091e7ac5996a$var$setDefaultHighWaterMark;
$7ac0091e7ac5996a$var$Stream.getDefaultHighWaterMark = $7ac0091e7ac5996a$var$getDefaultHighWaterMark;
$7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get: function() {
        return $cI9Iq;
    }
});
$7ac0091e7ac5996a$var$ObjectDefineProperty($7ac0091e7ac5996a$require$pipeline, $7ac0091e7ac5996a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $cI9Iq.pipeline;
    }
});
$7ac0091e7ac5996a$var$ObjectDefineProperty($kAgPS, $7ac0091e7ac5996a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get: function() {
        return $cI9Iq.finished;
    }
});
// Backwards-compat with node 0.4.x
$7ac0091e7ac5996a$var$Stream.Stream = $7ac0091e7ac5996a$var$Stream;
$7ac0091e7ac5996a$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$7ac0091e7ac5996a$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $7ac0091e7ac5996a$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("1he7j", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $0ee2544bf0b24316$export$a143d493d941bafc; }, function (v) { return $0ee2544bf0b24316$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $0ee2544bf0b24316$export$f99ded8fe4b79145; }, function (v) { return $0ee2544bf0b24316$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");
var $0ee2544bf0b24316$export$a143d493d941bafc;
var $0ee2544bf0b24316$export$e4cf37d7f6fb9e0a;
var $0ee2544bf0b24316$export$f99ded8fe4b79145;
var $0ee2544bf0b24316$export$599f31c3813fae4d;
'use strict';

var $abUaD = parcelRequire("abUaD");

var $6cq2P = parcelRequire("6cq2P");
var $0ee2544bf0b24316$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0ee2544bf0b24316$export$a143d493d941bafc = $0ee2544bf0b24316$var$Buffer;
$0ee2544bf0b24316$export$e4cf37d7f6fb9e0a = $0ee2544bf0b24316$var$SlowBuffer;
$0ee2544bf0b24316$export$f99ded8fe4b79145 = 50;
var $0ee2544bf0b24316$var$K_MAX_LENGTH = 0x7fffffff;
$0ee2544bf0b24316$export$599f31c3813fae4d = $0ee2544bf0b24316$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0ee2544bf0b24316$var$Buffer.TYPED_ARRAY_SUPPORT = $0ee2544bf0b24316$var$typedArraySupport();
if (!$0ee2544bf0b24316$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0ee2544bf0b24316$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0ee2544bf0b24316$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$0ee2544bf0b24316$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0ee2544bf0b24316$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$0ee2544bf0b24316$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0ee2544bf0b24316$var$createBuffer(length) {
    if (length > $0ee2544bf0b24316$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0ee2544bf0b24316$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0ee2544bf0b24316$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0ee2544bf0b24316$var$allocUnsafe(arg);
    }
    return $0ee2544bf0b24316$var$from(arg, encodingOrOffset, length);
}
$0ee2544bf0b24316$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0ee2544bf0b24316$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0ee2544bf0b24316$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0ee2544bf0b24316$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
    if ($0ee2544bf0b24316$var$isInstance(value, ArrayBuffer) || value && $0ee2544bf0b24316$var$isInstance(value.buffer, ArrayBuffer)) return $0ee2544bf0b24316$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0ee2544bf0b24316$var$isInstance(value, SharedArrayBuffer) || value && $0ee2544bf0b24316$var$isInstance(value.buffer, SharedArrayBuffer))) return $0ee2544bf0b24316$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0ee2544bf0b24316$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $0ee2544bf0b24316$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0ee2544bf0b24316$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0ee2544bf0b24316$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0ee2544bf0b24316$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0ee2544bf0b24316$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0ee2544bf0b24316$var$Buffer, Uint8Array);
function $0ee2544bf0b24316$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0ee2544bf0b24316$var$alloc(size, fill, encoding) {
    $0ee2544bf0b24316$var$assertSize(size);
    if (size <= 0) return $0ee2544bf0b24316$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0ee2544bf0b24316$var$createBuffer(size).fill(fill, encoding) : $0ee2544bf0b24316$var$createBuffer(size).fill(fill);
    return $0ee2544bf0b24316$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0ee2544bf0b24316$var$Buffer.alloc = function(size, fill, encoding) {
    return $0ee2544bf0b24316$var$alloc(size, fill, encoding);
};
function $0ee2544bf0b24316$var$allocUnsafe(size) {
    $0ee2544bf0b24316$var$assertSize(size);
    return $0ee2544bf0b24316$var$createBuffer(size < 0 ? 0 : $0ee2544bf0b24316$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0ee2544bf0b24316$var$Buffer.allocUnsafe = function(size) {
    return $0ee2544bf0b24316$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0ee2544bf0b24316$var$Buffer.allocUnsafeSlow = function(size) {
    return $0ee2544bf0b24316$var$allocUnsafe(size);
};
function $0ee2544bf0b24316$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0ee2544bf0b24316$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $0ee2544bf0b24316$var$byteLength(string, encoding) | 0;
    var buf = $0ee2544bf0b24316$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0ee2544bf0b24316$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $0ee2544bf0b24316$var$checked(array.length) | 0;
    var buf = $0ee2544bf0b24316$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0ee2544bf0b24316$var$fromArrayView(arrayView) {
    if ($0ee2544bf0b24316$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $0ee2544bf0b24316$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0ee2544bf0b24316$var$fromArrayLike(arrayView);
}
function $0ee2544bf0b24316$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0ee2544bf0b24316$var$Buffer.prototype);
    return buf;
}
function $0ee2544bf0b24316$var$fromObject(obj) {
    if ($0ee2544bf0b24316$var$Buffer.isBuffer(obj)) {
        var len = $0ee2544bf0b24316$var$checked(obj.length) | 0;
        var buf = $0ee2544bf0b24316$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0ee2544bf0b24316$var$numberIsNaN(obj.length)) return $0ee2544bf0b24316$var$createBuffer(0);
        return $0ee2544bf0b24316$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0ee2544bf0b24316$var$fromArrayLike(obj.data);
}
function $0ee2544bf0b24316$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0ee2544bf0b24316$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0ee2544bf0b24316$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0ee2544bf0b24316$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0ee2544bf0b24316$var$Buffer.alloc(+length);
}
$0ee2544bf0b24316$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0ee2544bf0b24316$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0ee2544bf0b24316$var$Buffer.compare = function compare(a, b) {
    if ($0ee2544bf0b24316$var$isInstance(a, Uint8Array)) a = $0ee2544bf0b24316$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0ee2544bf0b24316$var$isInstance(b, Uint8Array)) b = $0ee2544bf0b24316$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0ee2544bf0b24316$var$Buffer.isBuffer(a) || !$0ee2544bf0b24316$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0ee2544bf0b24316$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0ee2544bf0b24316$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0ee2544bf0b24316$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $0ee2544bf0b24316$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($0ee2544bf0b24316$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0ee2544bf0b24316$var$Buffer.isBuffer(buf)) buf = $0ee2544bf0b24316$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0ee2544bf0b24316$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0ee2544bf0b24316$var$byteLength(string, encoding) {
    if ($0ee2544bf0b24316$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0ee2544bf0b24316$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $3KZcf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0ee2544bf0b24316$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0ee2544bf0b24316$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0ee2544bf0b24316$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0ee2544bf0b24316$var$Buffer.byteLength = $0ee2544bf0b24316$var$byteLength;
function $0ee2544bf0b24316$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0ee2544bf0b24316$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0ee2544bf0b24316$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0ee2544bf0b24316$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0ee2544bf0b24316$var$latin1Slice(this, start, end);
        case 'base64':
            return $0ee2544bf0b24316$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0ee2544bf0b24316$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0ee2544bf0b24316$var$Buffer.prototype._isBuffer = true;
function $0ee2544bf0b24316$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0ee2544bf0b24316$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$0ee2544bf0b24316$var$swap(this, i, i + 1);
    return this;
};
$0ee2544bf0b24316$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $0ee2544bf0b24316$var$swap(this, i, i + 3);
        $0ee2544bf0b24316$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0ee2544bf0b24316$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $0ee2544bf0b24316$var$swap(this, i, i + 7);
        $0ee2544bf0b24316$var$swap(this, i + 1, i + 6);
        $0ee2544bf0b24316$var$swap(this, i + 2, i + 5);
        $0ee2544bf0b24316$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0ee2544bf0b24316$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0ee2544bf0b24316$var$utf8Slice(this, 0, length);
    return $0ee2544bf0b24316$var$slowToString.apply(this, arguments);
};
$0ee2544bf0b24316$var$Buffer.prototype.toLocaleString = $0ee2544bf0b24316$var$Buffer.prototype.toString;
$0ee2544bf0b24316$var$Buffer.prototype.equals = function equals(b) {
    if (!$0ee2544bf0b24316$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0ee2544bf0b24316$var$Buffer.compare(this, b) === 0;
};
$0ee2544bf0b24316$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $0ee2544bf0b24316$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0ee2544bf0b24316$var$customInspectSymbol) $0ee2544bf0b24316$var$Buffer.prototype[$0ee2544bf0b24316$var$customInspectSymbol] = $0ee2544bf0b24316$var$Buffer.prototype.inspect;
$0ee2544bf0b24316$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0ee2544bf0b24316$var$isInstance(target, Uint8Array)) target = $0ee2544bf0b24316$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0ee2544bf0b24316$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $3KZcf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0ee2544bf0b24316$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0ee2544bf0b24316$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0ee2544bf0b24316$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0ee2544bf0b24316$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0ee2544bf0b24316$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0ee2544bf0b24316$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0ee2544bf0b24316$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0ee2544bf0b24316$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0ee2544bf0b24316$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0ee2544bf0b24316$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0ee2544bf0b24316$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0ee2544bf0b24316$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0ee2544bf0b24316$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0ee2544bf0b24316$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0ee2544bf0b24316$var$utf8Write(buf, string, offset, length) {
    return $0ee2544bf0b24316$var$blitBuffer($0ee2544bf0b24316$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0ee2544bf0b24316$var$asciiWrite(buf, string, offset, length) {
    return $0ee2544bf0b24316$var$blitBuffer($0ee2544bf0b24316$var$asciiToBytes(string), buf, offset, length);
}
function $0ee2544bf0b24316$var$base64Write(buf, string, offset, length) {
    return $0ee2544bf0b24316$var$blitBuffer($0ee2544bf0b24316$var$base64ToBytes(string), buf, offset, length);
}
function $0ee2544bf0b24316$var$ucs2Write(buf, string, offset, length) {
    return $0ee2544bf0b24316$var$blitBuffer($0ee2544bf0b24316$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0ee2544bf0b24316$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0ee2544bf0b24316$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0ee2544bf0b24316$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0ee2544bf0b24316$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0ee2544bf0b24316$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0ee2544bf0b24316$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0ee2544bf0b24316$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0ee2544bf0b24316$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $abUaD.fromByteArray(buf);
    else return $abUaD.fromByteArray(buf.slice(start, end));
}
function $0ee2544bf0b24316$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0ee2544bf0b24316$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $0ee2544bf0b24316$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0ee2544bf0b24316$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $0ee2544bf0b24316$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0ee2544bf0b24316$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0ee2544bf0b24316$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0ee2544bf0b24316$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0ee2544bf0b24316$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $0ee2544bf0b24316$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0ee2544bf0b24316$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0ee2544bf0b24316$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0ee2544bf0b24316$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0ee2544bf0b24316$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0ee2544bf0b24316$var$Buffer.prototype.readUintLE = $0ee2544bf0b24316$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readUintBE = $0ee2544bf0b24316$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readUint8 = $0ee2544bf0b24316$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0ee2544bf0b24316$var$Buffer.prototype.readUint16LE = $0ee2544bf0b24316$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0ee2544bf0b24316$var$Buffer.prototype.readUint16BE = $0ee2544bf0b24316$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0ee2544bf0b24316$var$Buffer.prototype.readUint32LE = $0ee2544bf0b24316$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0ee2544bf0b24316$var$Buffer.prototype.readUint32BE = $0ee2544bf0b24316$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0ee2544bf0b24316$var$Buffer.prototype.readBigUInt64LE = $0ee2544bf0b24316$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0ee2544bf0b24316$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0ee2544bf0b24316$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0ee2544bf0b24316$var$Buffer.prototype.readBigUInt64BE = $0ee2544bf0b24316$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0ee2544bf0b24316$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0ee2544bf0b24316$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0ee2544bf0b24316$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0ee2544bf0b24316$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0ee2544bf0b24316$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0ee2544bf0b24316$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0ee2544bf0b24316$var$Buffer.prototype.readBigInt64LE = $0ee2544bf0b24316$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0ee2544bf0b24316$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0ee2544bf0b24316$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$0ee2544bf0b24316$var$Buffer.prototype.readBigInt64BE = $0ee2544bf0b24316$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0ee2544bf0b24316$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $0ee2544bf0b24316$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$0ee2544bf0b24316$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, true, 23, 4);
};
$0ee2544bf0b24316$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 4, this.length);
    return $6cq2P.read(this, offset, false, 23, 4);
};
$0ee2544bf0b24316$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, true, 52, 8);
};
$0ee2544bf0b24316$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkOffset(offset, 8, this.length);
    return $6cq2P.read(this, offset, false, 52, 8);
};
function $0ee2544bf0b24316$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0ee2544bf0b24316$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0ee2544bf0b24316$var$Buffer.prototype.writeUintLE = $0ee2544bf0b24316$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0ee2544bf0b24316$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUintBE = $0ee2544bf0b24316$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0ee2544bf0b24316$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUint8 = $0ee2544bf0b24316$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUint16LE = $0ee2544bf0b24316$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUint16BE = $0ee2544bf0b24316$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUint32LE = $0ee2544bf0b24316$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeUint32BE = $0ee2544bf0b24316$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0ee2544bf0b24316$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0ee2544bf0b24316$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0ee2544bf0b24316$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0ee2544bf0b24316$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0ee2544bf0b24316$var$Buffer.prototype.writeBigUInt64LE = $0ee2544bf0b24316$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0ee2544bf0b24316$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0ee2544bf0b24316$var$Buffer.prototype.writeBigUInt64BE = $0ee2544bf0b24316$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0ee2544bf0b24316$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0ee2544bf0b24316$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0ee2544bf0b24316$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0ee2544bf0b24316$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0ee2544bf0b24316$var$Buffer.prototype.writeBigInt64LE = $0ee2544bf0b24316$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0ee2544bf0b24316$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0ee2544bf0b24316$var$Buffer.prototype.writeBigInt64BE = $0ee2544bf0b24316$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $0ee2544bf0b24316$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0ee2544bf0b24316$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0ee2544bf0b24316$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0ee2544bf0b24316$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0ee2544bf0b24316$var$writeFloat(this, value, offset, true, noAssert);
};
$0ee2544bf0b24316$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0ee2544bf0b24316$var$writeFloat(this, value, offset, false, noAssert);
};
function $0ee2544bf0b24316$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0ee2544bf0b24316$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $6cq2P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0ee2544bf0b24316$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0ee2544bf0b24316$var$writeDouble(this, value, offset, true, noAssert);
};
$0ee2544bf0b24316$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0ee2544bf0b24316$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0ee2544bf0b24316$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0ee2544bf0b24316$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0ee2544bf0b24316$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0ee2544bf0b24316$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $0ee2544bf0b24316$var$Buffer.isBuffer(val) ? val : $0ee2544bf0b24316$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $0ee2544bf0b24316$var$errors = {};
function $0ee2544bf0b24316$var$E(sym, getMessage, Base) {
    $0ee2544bf0b24316$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            (0, $jGAMp._)(this, NodeError);
            var _this;
            _this = (0, $kzDuW._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$0ee2544bf0b24316$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0ee2544bf0b24316$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual));
}, TypeError);
$0ee2544bf0b24316$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $0ee2544bf0b24316$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $0ee2544bf0b24316$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $0ee2544bf0b24316$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $0ee2544bf0b24316$var$checkBounds(buf, offset, byteLength) {
    $0ee2544bf0b24316$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0ee2544bf0b24316$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0ee2544bf0b24316$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $3KZcf._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $0ee2544bf0b24316$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0ee2544bf0b24316$var$checkBounds(buf, offset, byteLength);
}
function $0ee2544bf0b24316$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0ee2544bf0b24316$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0ee2544bf0b24316$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0ee2544bf0b24316$var$validateNumber(value, type);
        throw new $0ee2544bf0b24316$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0ee2544bf0b24316$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0ee2544bf0b24316$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $0ee2544bf0b24316$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0ee2544bf0b24316$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0ee2544bf0b24316$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0ee2544bf0b24316$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0ee2544bf0b24316$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0ee2544bf0b24316$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0ee2544bf0b24316$var$base64ToBytes(str) {
    return $abUaD.toByteArray($0ee2544bf0b24316$var$base64clean(str));
}
function $0ee2544bf0b24316$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0ee2544bf0b24316$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0ee2544bf0b24316$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $0ee2544bf0b24316$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0ee2544bf0b24316$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0ee2544bf0b24316$var$BufferBigIntNotDefined : fn;
}
function $0ee2544bf0b24316$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("4eV73", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
var $3164c5a35ae560a0$var$AggregateError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AggregateError, Error1);
    function AggregateError(errors) {
        (0, $jGAMp._)(this, AggregateError);
        var _this;
        if (!Array.isArray(errors)) throw new TypeError("Expected input to be an Array, got ".concat(typeof errors === "undefined" ? "undefined" : (0, $3KZcf._)(errors)));
        var message = '';
        for(var i = 0; i < errors.length; i++)message += "    ".concat(errors[i].stack, "\n");
        _this = (0, $kzDuW._)(this, AggregateError, [
            message
        ]);
        _this.name = 'AggregateError';
        _this.errors = errors;
        return _this;
    }
    return AggregateError;
}((0, $8AW3P._)(Error));
module.exports = {
    AggregateError: $3164c5a35ae560a0$var$AggregateError,
    ArrayIsArray: function(self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes: function(self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf: function(self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin: function(self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap: function(self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop: function(self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush: function(self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall: function(fn, thisArgs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var _fn;
        return (_fn = fn).call.apply(_fn, [
            thisArgs
        ].concat((0, $7WNf6._)(args)));
    },
    FunctionPrototypeSymbolHasInstance: function(self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties: function(self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty: function(self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor: function(self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys: function(obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf: function(target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch: function(self, fn) {
        return self["catch"](fn);
    },
    PromisePrototypeThen: function(self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject: function(err) {
        return Promise.reject(err);
    },
    PromiseResolve: function(val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest: function(self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice: function(self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase: function(self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase: function(self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim: function(self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol["for"],
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet: function(self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("7mxb7", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $1he7j = parcelRequire("1he7j");

var $gftKN = parcelRequire("gftKN");
var $55c452ff785ff74d$var$format = $gftKN.format, $55c452ff785ff74d$var$inspect = $gftKN.inspect;

var $8DZ5K = parcelRequire("8DZ5K");
var $55c452ff785ff74d$var$ERR_INVALID_ARG_TYPE = $8DZ5K.codes.ERR_INVALID_ARG_TYPE;

var $4eV73 = parcelRequire("4eV73");
var $55c452ff785ff74d$var$kResistStopPropagation = $4eV73.kResistStopPropagation, $55c452ff785ff74d$var$AggregateError = $4eV73.AggregateError, $55c452ff785ff74d$var$SymbolDispose = $4eV73.SymbolDispose;

var $55c452ff785ff74d$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("6an3P")).AbortSignal;

var $55c452ff785ff74d$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $55c452ff785ff74d$var$AsyncFunction = Object.getPrototypeOf(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    })();
}).constructor;
var $55c452ff785ff74d$var$Blob = globalThis.Blob || $1he7j.Blob;
/* eslint-disable indent */ var $55c452ff785ff74d$var$isBlob = typeof $55c452ff785ff74d$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $55c452ff785ff74d$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ var $55c452ff785ff74d$var$validateAbortSignal = function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $55c452ff785ff74d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
var $55c452ff785ff74d$var$validateFunction = function(value, name) {
    if (typeof value !== 'function') throw new $55c452ff785ff74d$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $55c452ff785ff74d$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once: function(callback) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function createDeferredPromise() {
        var resolve;
        var reject;
        // eslint-disable-next-line promise/param-names
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify: function(fn) {
        return new Promise(function(resolve, reject) {
            fn(function(err) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (err) return reject(err);
                return resolve.apply(void 0, (0, $7WNf6._)(args));
            });
        });
    },
    debuglog: function() {
        return function() {};
    },
    format: $55c452ff785ff74d$var$format,
    inspect: $55c452ff785ff74d$var$inspect,
    types: {
        isAsyncFunction: function(fn) {
            return fn instanceof $55c452ff785ff74d$var$AsyncFunction;
        },
        isArrayBufferView: function(arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $55c452ff785ff74d$var$isBlob,
    deprecate: function(fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("bBoAO")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $55c452ff785ff74d$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $55c452ff785ff74d$var$validateAbortSignal(signal, 'signal');
        $55c452ff785ff74d$var$validateFunction(listener, 'listener');
        var removeEventListener;
        if (signal.aborted) queueMicrotask(function() {
            return listener();
        });
        else {
            signal.addEventListener('abort', listener, (0, $cqEAj._)({
                __proto__: null,
                once: true
            }, $55c452ff785ff74d$var$kResistStopPropagation, true));
            removeEventListener = function() {
                signal.removeEventListener('abort', listener);
            };
        }
        return (0, $cqEAj._)({
            __proto__: null
        }, $55c452ff785ff74d$var$SymbolDispose, function() {
            var _removeEventListener;
            (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
        });
    },
    AbortSignalAny: $55c452ff785ff74d$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        var ac = new $55c452ff785ff74d$var$AbortController();
        var abort = function() {
            return ac.abort();
        };
        signals.forEach(function(signal) {
            $55c452ff785ff74d$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', function() {
            signals.forEach(function(signal) {
                return signal.removeEventListener('abort', abort);
            });
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol["for"]('nodejs.util.promisify.custom');

});
parcelRegister("gftKN", function(module, exports) {

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format: function(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $32TW8._)(_tmp, 2), _unused = _tmp1[0], type = _tmp1[1];
            var replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && (typeof replacement === "undefined" ? "undefined" : (0, $3KZcf._)(replacement)) === 'object') {
                var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return "".concat(ctor, " {}").trim();
            } else return replacement.toString();
        });
    },
    inspect: function(value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return '"'.concat(value, '"');
                    else if (!value.includes('`') && !value.includes('${')) return "`".concat(value, "`");
                }
                return "'".concat(value, "'");
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return "".concat(String(value), "n");
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("8DZ5K", function(module, exports) {

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $8AW3P = parcelRequire("8AW3P");
'use strict';

var $gftKN = parcelRequire("gftKN");
var $64b15ac68a7a884f$var$format = $gftKN.format, $64b15ac68a7a884f$var$inspect = $gftKN.inspect;

var $4eV73 = parcelRequire("4eV73");
var $64b15ac68a7a884f$var$CustomAggregateError = $4eV73.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ var $64b15ac68a7a884f$var$AggregateError = globalThis.AggregateError || $64b15ac68a7a884f$var$CustomAggregateError;
var $64b15ac68a7a884f$var$kIsNodeError = Symbol('kIsNodeError');
var $64b15ac68a7a884f$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
var $64b15ac68a7a884f$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
var $64b15ac68a7a884f$var$nodeInternalPrefix = '__node_internal_';
var $64b15ac68a7a884f$var$codes = {};
function $64b15ac68a7a884f$var$assert(value, message) {
    if (!value) throw new $64b15ac68a7a884f$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $64b15ac68a7a884f$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
function $64b15ac68a7a884f$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $64b15ac68a7a884f$var$assert(msg.length <= args.length, // Default options do not count.
        "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(msg.length, ")."));
        return msg.apply(void 0, (0, $7WNf6._)(args));
    }
    var expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $64b15ac68a7a884f$var$assert(expectedLength === args.length, "Code: ".concat(key, "; The provided arguments length (").concat(args.length, ") does not match the required ones (").concat(expectedLength, ")."));
    if (args.length === 0) return msg;
    return $64b15ac68a7a884f$var$format.apply(void 0, [
        msg
    ].concat((0, $7WNf6._)(args)));
}
function $64b15ac68a7a884f$var$E(code, message, Base) {
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(Base) {
        (0, $i3fW3._)(NodeError, Base);
        function NodeError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $jGAMp._)(this, NodeError);
            return (0, $kzDuW._)(this, NodeError, [
                $64b15ac68a7a884f$var$getMessage(code, message, args)
            ]);
        }
        (0, $byiyg._)(NodeError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value: function() {
                return "".concat(this.name, " [").concat(code, "]: ").concat(this.message);
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$64b15ac68a7a884f$var$kIsNodeError] = true;
    $64b15ac68a7a884f$var$codes[code] = NodeError;
}
function $64b15ac68a7a884f$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    var hidden = $64b15ac68a7a884f$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $64b15ac68a7a884f$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        var err = new $64b15ac68a7a884f$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
var $64b15ac68a7a884f$var$AbortError = /*#__PURE__*/ function(Error1) {
    (0, $i3fW3._)(AbortError, Error1);
    function AbortError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'The operation was aborted', options = arguments.length > 1 ? arguments[1] : void 0;
        (0, $jGAMp._)(this, AbortError);
        var _this;
        if (options !== undefined && (typeof options === "undefined" ? "undefined" : (0, $3KZcf._)(options)) !== 'object') throw new $64b15ac68a7a884f$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        _this = (0, $kzDuW._)(this, AbortError, [
            message,
            options
        ]);
        _this.code = 'ABORT_ERR';
        _this.name = 'AbortError';
        return _this;
    }
    return AbortError;
}((0, $8AW3P._)(Error));
$64b15ac68a7a884f$var$E('ERR_ASSERTION', '%s', Error);
$64b15ac68a7a884f$var$E('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    $64b15ac68a7a884f$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    var msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += "".concat(name, " ");
    else msg += '"'.concat(name, '" ').concat(name.includes('.') ? 'property' : 'argument', " ");
    msg += 'must be ';
    var types = [];
    var instances = [];
    var other = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = expected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            $64b15ac68a7a884f$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
            if ($64b15ac68a7a884f$var$kTypes.includes(value)) types.push(value.toLowerCase());
            else if ($64b15ac68a7a884f$var$classRegExp.test(value)) instances.push(value);
            else {
                $64b15ac68a7a884f$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
                other.push(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        var pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += "of type ".concat(types[0]);
                break;
            case 2:
                msg += "one of type ".concat(types[0], " or ").concat(types[1]);
                break;
            default:
                {
                    var last = types.pop();
                    msg += "one of type ".concat(types.join(', '), ", or ").concat(last);
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += "an instance of ".concat(instances[0]);
                break;
            case 2:
                msg += "an instance of ".concat(instances[0], " or ").concat(instances[1]);
                break;
            default:
                {
                    var last1 = instances.pop();
                    msg += "an instance of ".concat(instances.join(', '), ", or ").concat(last1);
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += "".concat(other[0]);
            break;
        case 2:
            msg += "one of ".concat(other[0], " or ").concat(other[1]);
            break;
        default:
            {
                var last2 = other.pop();
                msg += "one of ".concat(other.join(', '), ", or ").concat(last2);
            }
    }
    if (actual == null) msg += ". Received ".concat(actual);
    else if (typeof actual === 'function' && actual.name) msg += ". Received function ".concat(actual.name);
    else if ((typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual)) === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += ". Received an instance of ".concat(actual.constructor.name);
        else {
            var inspected = $64b15ac68a7a884f$var$inspect(actual, {
                depth: -1
            });
            msg += ". Received ".concat(inspected);
        }
    } else {
        var inspected1 = $64b15ac68a7a884f$var$inspect(actual, {
            colors: false
        });
        if (inspected1.length > 25) inspected1 = "".concat(inspected1.slice(0, 25), "...");
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $3KZcf._)(actual), " (").concat(inspected1, ")");
    }
    return msg;
}, TypeError);
$64b15ac68a7a884f$var$E('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'is invalid';
    var inspected = $64b15ac68a7a884f$var$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    var type = name.includes('.') ? 'property' : 'argument';
    return "The ".concat(type, " '").concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
$64b15ac68a7a884f$var$E('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var _value$constructor;
    var type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? "instance of ".concat(value.constructor.name) : "type ".concat(typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
$64b15ac68a7a884f$var$E('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $64b15ac68a7a884f$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg;
    var len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map(function(a) {
        return '"'.concat(a, '"');
    }).join(' or ');
    switch(len){
        case 1:
            msg += "The ".concat(args[0], " argument");
            break;
        case 2:
            msg += "The ".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            {
                var last = args.pop();
                msg += "The ".concat(args.join(', '), ", and ").concat(last, " arguments");
            }
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$64b15ac68a7a884f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    $64b15ac68a7a884f$var$assert(range, 'Missing "range" argument');
    var received;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $64b15ac68a7a884f$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'bigint') {
        received = String(input);
        var limit = Math.pow(BigInt(2), BigInt(32));
        if (input > limit || input < -limit) received = $64b15ac68a7a884f$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $64b15ac68a7a884f$var$inspect(input);
    return 'The value of "'.concat(str, '" is out of range. It must be ').concat(range, ". Received ").concat(received);
}, RangeError);
$64b15ac68a7a884f$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$64b15ac68a7a884f$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$64b15ac68a7a884f$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$64b15ac68a7a884f$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$64b15ac68a7a884f$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $64b15ac68a7a884f$var$AbortError,
    aggregateTwoErrors: $64b15ac68a7a884f$var$hideStackFrames($64b15ac68a7a884f$var$aggregateTwoErrors),
    hideStackFrames: $64b15ac68a7a884f$var$hideStackFrames,
    codes: $64b15ac68a7a884f$var$codes
};

});


parcelRegister("hm6J1", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $ca29b53801b04c36$export$42af8c323be37587; }, function (v) { return $ca29b53801b04c36$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $ca29b53801b04c36$export$f405f72c701dad87; }, function (v) { return $ca29b53801b04c36$export$f405f72c701dad87 = v; });

var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");
var $ca29b53801b04c36$export$42af8c323be37587;
var $ca29b53801b04c36$export$f405f72c701dad87;
'use strict';

var $ca29b53801b04c36$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $8DZ5K = parcelRequire("8DZ5K");
var $ca29b53801b04c36$var$_require_codes = $8DZ5K.codes, $ca29b53801b04c36$var$ERR_INVALID_ARG_VALUE = $ca29b53801b04c36$var$_require_codes.ERR_INVALID_ARG_VALUE, $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE = $ca29b53801b04c36$var$_require_codes.ERR_INVALID_ARG_TYPE, $ca29b53801b04c36$var$ERR_MISSING_ARGS = $ca29b53801b04c36$var$_require_codes.ERR_MISSING_ARGS, $ca29b53801b04c36$var$ERR_OUT_OF_RANGE = $ca29b53801b04c36$var$_require_codes.ERR_OUT_OF_RANGE, $ca29b53801b04c36$var$AbortError = $8DZ5K.AbortError;

var $9vo7f = parcelRequire("9vo7f");
var $ca29b53801b04c36$var$validateAbortSignal = $9vo7f.validateAbortSignal, $ca29b53801b04c36$var$validateInteger = $9vo7f.validateInteger, $ca29b53801b04c36$var$validateObject = $9vo7f.validateObject;

var $ca29b53801b04c36$var$kWeakHandler = (parcelRequire("4eV73")).Symbol('kWeak');

var $ca29b53801b04c36$var$kResistStopPropagation = (parcelRequire("4eV73")).Symbol('kResistStopPropagation');

var $kAgPS = parcelRequire("kAgPS");
var $ca29b53801b04c36$require$finished = $kAgPS.finished;

var $byOAZ = parcelRequire("byOAZ");

var $jYKwv = parcelRequire("jYKwv");
var $ca29b53801b04c36$require$addAbortSignalNoValidate = $jYKwv.addAbortSignalNoValidate;

var $2gPtE = parcelRequire("2gPtE");
var $ca29b53801b04c36$var$isWritable = $2gPtE.isWritable, $ca29b53801b04c36$var$isNodeStream = $2gPtE.isNodeStream;

var $ca29b53801b04c36$require$deprecate = (parcelRequire("7mxb7")).deprecate;

var $ca29b53801b04c36$var$ArrayPrototypePush = (parcelRequire("4eV73")).ArrayPrototypePush, $ca29b53801b04c36$var$Boolean = (parcelRequire("4eV73")).Boolean, $ca29b53801b04c36$var$MathFloor = (parcelRequire("4eV73")).MathFloor, $ca29b53801b04c36$var$Number = (parcelRequire("4eV73")).Number, $ca29b53801b04c36$var$NumberIsNaN = (parcelRequire("4eV73")).NumberIsNaN, $ca29b53801b04c36$var$Promise = (parcelRequire("4eV73")).Promise, $ca29b53801b04c36$var$PromiseReject = (parcelRequire("4eV73")).PromiseReject, $ca29b53801b04c36$var$PromiseResolve = (parcelRequire("4eV73")).PromiseResolve, $ca29b53801b04c36$var$PromisePrototypeThen = (parcelRequire("4eV73")).PromisePrototypeThen, $ca29b53801b04c36$var$Symbol = (parcelRequire("4eV73")).Symbol;
var $ca29b53801b04c36$var$kEmpty = $ca29b53801b04c36$var$Symbol('kEmpty');
var $ca29b53801b04c36$var$kEof = $ca29b53801b04c36$var$Symbol('kEof');
function $ca29b53801b04c36$var$compose(stream, options) {
    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
    if ($ca29b53801b04c36$var$isNodeStream(stream) && !$ca29b53801b04c36$var$isWritable(stream)) throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    var composedStream = $byOAZ(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $ca29b53801b04c36$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $ca29b53801b04c36$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
    var concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $ca29b53801b04c36$var$MathFloor(options.concurrency);
    var highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $ca29b53801b04c36$var$MathFloor(options.highWaterMark);
    $ca29b53801b04c36$var$validateInteger(concurrency, 'options.concurrency', 1);
    $ca29b53801b04c36$var$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (function map() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var signal, stream, queue, signalOpt, next, resume, done, cnt, val;
            function onCatch() {
                done = true;
                afterItemProcessed();
            }
            function afterItemProcessed() {
                cnt -= 1;
                maybeResume();
            }
            function maybeResume() {
                if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                    resume();
                    resume = null;
                }
            }
            function pump() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err, err1, val1;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    14,
                                    15,
                                    16
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $bq7J2._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                val = _value;
                                if (done) return [
                                    2
                                ];
                                if (signal.aborted) throw new $ca29b53801b04c36$var$AbortError();
                                try {
                                    val = fn(val, signalOpt);
                                    if (val === $ca29b53801b04c36$var$kEmpty) return [
                                        3,
                                        5
                                    ];
                                    val = $ca29b53801b04c36$var$PromiseResolve(val);
                                } catch (err) {
                                    val = $ca29b53801b04c36$var$PromiseReject(err);
                                }
                                cnt += 1;
                                $ca29b53801b04c36$var$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                                queue.push(val);
                                if (next) {
                                    next();
                                    next = null;
                                }
                                if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new $ca29b53801b04c36$var$Promise(function(resolve) {
                                        resume = resolve;
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator["return"]()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                queue.push($ca29b53801b04c36$var$kEof);
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err1 = _state.sent();
                                val1 = $ca29b53801b04c36$var$PromiseReject(err1);
                                $ca29b53801b04c36$var$PromisePrototypeThen(val1, afterItemProcessed, onCatch);
                                queue.push(val1);
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                done = true;
                                if (next) {
                                    next();
                                    next = null;
                                }
                                return [
                                    7
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signal = (parcelRequire("7mxb7")).AbortSignalAny([
                            options === null || options === undefined ? undefined : options.signal
                        ].filter($ca29b53801b04c36$var$Boolean));
                        stream = this;
                        queue = [];
                        signalOpt = {
                            signal: signal
                        };
                        done = false;
                        cnt = 0;
                        pump();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(queue.length > 0)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, $iw20L._)(queue[0])
                        ];
                    case 4:
                        val = _state.sent();
                        if (val === $ca29b53801b04c36$var$kEof) return [
                            2
                        ];
                        if (signal.aborted) throw new $ca29b53801b04c36$var$AbortError();
                        if (!(val !== $ca29b53801b04c36$var$kEmpty)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            val
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        queue.shift();
                        maybeResume();
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            4,
                            (0, $iw20L._)(new $ca29b53801b04c36$var$Promise(function(resolve) {
                                next = resolve;
                            }))
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        done = true;
                        if (resume) {
                            resume();
                            resume = null;
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ca29b53801b04c36$var$asIndexedPairs(options) {
    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
    return (function asIndexedPairs() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var index, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $ca29b53801b04c36$var$AbortError({
                            cause: options.signal.reason
                        });
                        return [
                            4,
                            [
                                index++,
                                val
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ca29b53801b04c36$var$some(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ca29b53801b04c36$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    return [
                        2,
                        true
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    }).call(this);
}
function $ca29b53801b04c36$var$every(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    return [
                        4,
                        $ca29b53801b04c36$var$some.call(this, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                return (0, $9N5UN.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fn.apply(void 0, (0, $7WNf6._)(args))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                !_state.sent()
                                            ];
                                    }
                                });
                            })();
                        }, options)
                    ];
                case 1:
                    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
                    return [
                        2,
                        !_state.sent()
                    ];
            }
        });
    }).call(this);
}
function $ca29b53801b04c36$var$find(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ca29b53801b04c36$var$filter.call(this, fn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    result = _value;
                    return [
                        2,
                        result
                    ];
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    }).call(this);
}
function $ca29b53801b04c36$var$forEach(fn, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, unused, err;
        function forEachFn(value, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fn(value, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                $ca29b53801b04c36$var$kEmpty
                            ];
                    }
                });
            })();
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof fn !== 'function') throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE('fn', [
                        'Function',
                        'AsyncFunction'
                    ], fn);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)($ca29b53801b04c36$var$map.call(this, forEachFn, options));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    unused = _value;
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $ca29b53801b04c36$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    function filterFn(value, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fn(value, options)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            value
                        ];
                        return [
                            2,
                            $ca29b53801b04c36$var$kEmpty
                        ];
                }
            });
        })();
    }
    return $ca29b53801b04c36$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var $ca29b53801b04c36$var$ReduceAwareErrMissingArgs = /*#__PURE__*/ function(ERR_MISSING_ARGS) {
    (0, $i3fW3._)(ReduceAwareErrMissingArgs, ERR_MISSING_ARGS);
    function ReduceAwareErrMissingArgs() {
        (0, $jGAMp._)(this, ReduceAwareErrMissingArgs);
        var _this;
        _this = (0, $kzDuW._)(this, ReduceAwareErrMissingArgs, [
            'reduce'
        ]);
        _this.message = 'Reduce of an empty stream requires an initial value';
        return _this;
    }
    return ReduceAwareErrMissingArgs;
}($ca29b53801b04c36$var$ERR_MISSING_ARGS);
function $ca29b53801b04c36$var$reduce(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(reducer, initialValue, options) {
        var _options$signal2, hasInitialValue, _$err, ac, signal, _obj, opts, gotAnyItemFromStream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value, _options$signal3, err;
        var _arguments = arguments;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof reducer !== 'function') throw new $ca29b53801b04c36$var$ERR_INVALID_ARG_TYPE('reducer', [
                        'Function',
                        'AsyncFunction'
                    ], reducer);
                    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
                    hasInitialValue = _arguments.length > 1;
                    if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) return [
                        3,
                        2
                    ];
                    _$err = new $ca29b53801b04c36$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    this.once('error', function() {}) // The error is already propagated
                    ;
                    return [
                        4,
                        $ca29b53801b04c36$require$finished(this.destroy(_$err))
                    ];
                case 1:
                    _state.sent();
                    throw _$err;
                case 2:
                    ac = new $ca29b53801b04c36$var$AbortController();
                    signal = ac.signal;
                    if (options !== null && options !== undefined && options.signal) {
                        ;
                        opts = (_obj = {
                            once: true
                        }, (0, $cqEAj._)(_obj, $ca29b53801b04c36$var$kWeakHandler, this), (0, $cqEAj._)(_obj, $ca29b53801b04c36$var$kResistStopPropagation, true), _obj);
                        options.signal.addEventListener('abort', function() {
                            return ac.abort();
                        }, opts);
                    }
                    gotAnyItemFromStream = false;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        18,
                        19
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        11,
                        12,
                        17
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    value = _value;
                    gotAnyItemFromStream = true;
                    if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $ca29b53801b04c36$var$AbortError();
                    if (!!hasInitialValue) return [
                        3,
                        7
                    ];
                    initialValue = value;
                    hasInitialValue = true;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        reducer(initialValue, value, {
                            signal: signal
                        })
                    ];
                case 8:
                    initialValue = _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    if (!gotAnyItemFromStream && !hasInitialValue) throw new $ca29b53801b04c36$var$ReduceAwareErrMissingArgs();
                    return [
                        3,
                        19
                    ];
                case 18:
                    ac.abort();
                    return [
                        7
                    ];
                case 19:
                    return [
                        2,
                        initialValue
                    ];
            }
        });
    }).apply(this, arguments);
}
function $ca29b53801b04c36$var$toArray(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal4, err;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
                    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
                    result = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, $bq7J2._)(this);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    val = _value;
                    if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $ca29b53801b04c36$var$AbortError(undefined, {
                        cause: options.signal.reason
                    });
                    $ca29b53801b04c36$var$ArrayPrototypePush(result, val);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).call(this);
}
function $ca29b53801b04c36$var$flatMap(fn, options) {
    var values = $ca29b53801b04c36$var$map.call(this, fn, options);
    return (function flatMap() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(values);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        return [
                            5,
                            (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)(val)))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    }).call(this);
}
function $ca29b53801b04c36$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $ca29b53801b04c36$var$Number(number);
    if ($ca29b53801b04c36$var$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $ca29b53801b04c36$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $ca29b53801b04c36$var$drop(number, options) {
    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ca29b53801b04c36$var$toIntegerOrInfinity(number);
    return (function drop() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal5, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal6, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $ca29b53801b04c36$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            6
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $ca29b53801b04c36$var$AbortError();
                        if (!(number-- <= 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
function $ca29b53801b04c36$var$take(number, options) {
    if (options != null) $ca29b53801b04c36$var$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $ca29b53801b04c36$var$validateAbortSignal(options.signal, 'options.signal');
    number = $ca29b53801b04c36$var$toIntegerOrInfinity(number);
    return (function take() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _options$signal7, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, val, _options$signal8, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $ca29b53801b04c36$var$AbortError();
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            14
                        ]);
                        _iterator = (0, $bq7J2._)(this);
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $iw20L._)(_iterator.next())
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            7
                        ];
                        _value = _step.value;
                        val = _value;
                        if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $ca29b53801b04c36$var$AbortError();
                        if (!(number-- > 0)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            val
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // Don't get another item from iterator in case we reached the end
                        if (number <= 0) return [
                            2
                        ];
                        _state.label = 6;
                    case 6:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 7:
                        return [
                            3,
                            14
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            14
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            ,
                            12,
                            13
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            (0, $iw20L._)(_iterator["return"]())
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    }).call(this);
}
$ca29b53801b04c36$export$42af8c323be37587 = {
    asIndexedPairs: $ca29b53801b04c36$require$deprecate($ca29b53801b04c36$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $ca29b53801b04c36$var$drop,
    filter: $ca29b53801b04c36$var$filter,
    flatMap: $ca29b53801b04c36$var$flatMap,
    map: $ca29b53801b04c36$var$map,
    take: $ca29b53801b04c36$var$take,
    compose: $ca29b53801b04c36$var$compose
};
$ca29b53801b04c36$export$f405f72c701dad87 = {
    every: $ca29b53801b04c36$var$every,
    forEach: $ca29b53801b04c36$var$forEach,
    reduce: $ca29b53801b04c36$var$reduce,
    toArray: $ca29b53801b04c36$var$toArray,
    some: $ca29b53801b04c36$var$some,
    find: $ca29b53801b04c36$var$find
};

});
parcelRegister("9vo7f", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 
var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $6eb9b73e8366afe9$var$ArrayIsArray = $4eV73.ArrayIsArray, $6eb9b73e8366afe9$var$ArrayPrototypeIncludes = $4eV73.ArrayPrototypeIncludes, $6eb9b73e8366afe9$var$ArrayPrototypeJoin = $4eV73.ArrayPrototypeJoin, $6eb9b73e8366afe9$var$ArrayPrototypeMap = $4eV73.ArrayPrototypeMap, $6eb9b73e8366afe9$var$NumberIsInteger = $4eV73.NumberIsInteger, $6eb9b73e8366afe9$var$NumberIsNaN = $4eV73.NumberIsNaN, $6eb9b73e8366afe9$var$NumberMAX_SAFE_INTEGER = $4eV73.NumberMAX_SAFE_INTEGER, $6eb9b73e8366afe9$var$NumberMIN_SAFE_INTEGER = $4eV73.NumberMIN_SAFE_INTEGER, $6eb9b73e8366afe9$var$NumberParseInt = $4eV73.NumberParseInt, $6eb9b73e8366afe9$var$ObjectPrototypeHasOwnProperty = $4eV73.ObjectPrototypeHasOwnProperty, $6eb9b73e8366afe9$var$RegExpPrototypeExec = $4eV73.RegExpPrototypeExec, $6eb9b73e8366afe9$var$String = $4eV73.String, $6eb9b73e8366afe9$var$StringPrototypeToUpperCase = $4eV73.StringPrototypeToUpperCase, $6eb9b73e8366afe9$var$StringPrototypeTrim = $4eV73.StringPrototypeTrim;

var $8DZ5K = parcelRequire("8DZ5K");
var $6eb9b73e8366afe9$var$hideStackFrames = $8DZ5K.hideStackFrames, $6eb9b73e8366afe9$var$_require_codes = $8DZ5K.codes, $6eb9b73e8366afe9$var$ERR_SOCKET_BAD_PORT = $6eb9b73e8366afe9$var$_require_codes.ERR_SOCKET_BAD_PORT, $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE = $6eb9b73e8366afe9$var$_require_codes.ERR_INVALID_ARG_TYPE, $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE = $6eb9b73e8366afe9$var$_require_codes.ERR_INVALID_ARG_VALUE, $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE = $6eb9b73e8366afe9$var$_require_codes.ERR_OUT_OF_RANGE, $6eb9b73e8366afe9$var$ERR_UNKNOWN_SIGNAL = $6eb9b73e8366afe9$var$_require_codes.ERR_UNKNOWN_SIGNAL;

var $7mxb7 = parcelRequire("7mxb7");
var $6eb9b73e8366afe9$require$normalizeEncoding = $7mxb7.normalizeEncoding;

var $7mxb7 = parcelRequire("7mxb7");
var $6eb9b73e8366afe9$require$_require_types = $7mxb7.types;
var $6eb9b73e8366afe9$var$isAsyncFunction = $6eb9b73e8366afe9$require$_require_types.isAsyncFunction, $6eb9b73e8366afe9$var$isArrayBufferView = $6eb9b73e8366afe9$require$_require_types.isArrayBufferView;
var $6eb9b73e8366afe9$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6eb9b73e8366afe9$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6eb9b73e8366afe9$var$isUint32(value) {
    return value === value >>> 0;
}
var $6eb9b73e8366afe9$var$octalReg = /^[0-7]+$/;
var $6eb9b73e8366afe9$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $6eb9b73e8366afe9$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($6eb9b73e8366afe9$var$RegExpPrototypeExec($6eb9b73e8366afe9$var$octalReg, value) === null) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE(name, value, $6eb9b73e8366afe9$var$modeDesc);
        value = $6eb9b73e8366afe9$var$NumberParseInt(value, 8);
    }
    $6eb9b73e8366afe9$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ var $6eb9b73e8366afe9$var$validateInteger = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $6eb9b73e8366afe9$var$NumberMIN_SAFE_INTEGER, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $6eb9b73e8366afe9$var$NumberMAX_SAFE_INTEGER;
    if (typeof value !== 'number') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6eb9b73e8366afe9$var$NumberIsInteger(value)) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ var $6eb9b73e8366afe9$var$validateInt32 = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6eb9b73e8366afe9$var$NumberIsInteger(value)) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ var $6eb9b73e8366afe9$var$validateUint32 = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    var positive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof value !== 'number') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6eb9b73e8366afe9$var$NumberIsInteger(value)) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    var min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    var max = 4294967295;
    if (value < min || value > max) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, ">= ".concat(min, " && <= ").concat(max), value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $6eb9b73e8366afe9$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $6eb9b73e8366afe9$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $6eb9b73e8366afe9$var$NumberIsNaN(value)) throw new $6eb9b73e8366afe9$var$ERR_OUT_OF_RANGE(name, "".concat(min != null ? ">= ".concat(min) : '').concat(min != null && max != null ? ' && ' : '').concat(max != null ? "<= ".concat(max) : ''), value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ var $6eb9b73e8366afe9$var$validateOneOf = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name, oneOf) {
    if (!$6eb9b73e8366afe9$var$ArrayPrototypeIncludes(oneOf, value)) {
        var allowed = $6eb9b73e8366afe9$var$ArrayPrototypeJoin($6eb9b73e8366afe9$var$ArrayPrototypeMap(oneOf, function(v) {
            return typeof v === 'string' ? "'".concat(v, "'") : $6eb9b73e8366afe9$var$String(v);
        }), ', ');
        var reason = 'must be one of: ' + allowed;
        throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $6eb9b73e8366afe9$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $6eb9b73e8366afe9$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$6eb9b73e8366afe9$var$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ var $6eb9b73e8366afe9$var$validateObject = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var allowArray = $6eb9b73e8366afe9$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    var allowFunction = $6eb9b73e8366afe9$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    var nullable = $6eb9b73e8366afe9$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $6eb9b73e8366afe9$var$ArrayIsArray(value) || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ var $6eb9b73e8366afe9$var$validateDictionary = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    if (value != null && (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) !== 'object' && typeof value !== 'function') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ var $6eb9b73e8366afe9$var$validateArray = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    var minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!$6eb9b73e8366afe9$var$ArrayIsArray(value)) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        var reason = "must be longer than ".concat(minLength);
        throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $6eb9b73e8366afe9$var$validateStringArray(value, name) {
    $6eb9b73e8366afe9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$6eb9b73e8366afe9$var$validateString(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $6eb9b73e8366afe9$var$validateBooleanArray(value, name) {
    $6eb9b73e8366afe9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++)$6eb9b73e8366afe9$var$validateBoolean(value[i], "".concat(name, "[").concat(i, "]"));
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $6eb9b73e8366afe9$var$validateAbortSignalArray(value, name) {
    $6eb9b73e8366afe9$var$validateArray(value, name);
    for(var i = 0; i < value.length; i++){
        var signal = value[i];
        var indexedName = "".concat(name, "[").concat(i, "]");
        if (signal == null) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $6eb9b73e8366afe9$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $6eb9b73e8366afe9$var$validateSignalName(signal) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'signal';
    $6eb9b73e8366afe9$var$validateString(signal, name);
    if ($6eb9b73e8366afe9$var$signals[signal] === undefined) {
        if ($6eb9b73e8366afe9$var$signals[$6eb9b73e8366afe9$var$StringPrototypeToUpperCase(signal)] !== undefined) throw new $6eb9b73e8366afe9$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $6eb9b73e8366afe9$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ var $6eb9b73e8366afe9$var$validateBuffer = $6eb9b73e8366afe9$var$hideStackFrames(function(buffer) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'buffer';
    if (!$6eb9b73e8366afe9$var$isArrayBufferView(buffer)) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $6eb9b73e8366afe9$var$validateEncoding(data, encoding) {
    var normalizedEncoding = $6eb9b73e8366afe9$require$normalizeEncoding(encoding);
    var length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE('encoding', encoding, "is invalid for data of length ".concat(length));
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $6eb9b73e8366afe9$var$validatePort(port) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Port', allowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $6eb9b73e8366afe9$var$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $6eb9b73e8366afe9$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ var $6eb9b73e8366afe9$var$validateAbortSignal = $6eb9b73e8366afe9$var$hideStackFrames(function(signal, name) {
    if (signal !== undefined && (signal === null || (typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal))) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ var $6eb9b73e8366afe9$var$validateFunction = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function') throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ var $6eb9b73e8366afe9$var$validatePlainFunction = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    if (typeof value !== 'function' || $6eb9b73e8366afe9$var$isAsyncFunction(value)) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ var $6eb9b73e8366afe9$var$validateUndefined = $6eb9b73e8366afe9$var$hideStackFrames(function(value, name) {
    if (value !== undefined) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $6eb9b73e8366afe9$var$validateUnion(value, name, union) {
    if (!$6eb9b73e8366afe9$var$ArrayPrototypeIncludes(union, value)) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_TYPE(name, "('".concat($6eb9b73e8366afe9$var$ArrayPrototypeJoin(union, '|'), "')"), value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ var $6eb9b73e8366afe9$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $6eb9b73e8366afe9$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$6eb9b73e8366afe9$var$RegExpPrototypeExec($6eb9b73e8366afe9$var$linkValueRegExp, value)) throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $6eb9b73e8366afe9$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $6eb9b73e8366afe9$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($6eb9b73e8366afe9$var$ArrayIsArray(hints)) {
        var hintsLength = hints.length;
        var result = '';
        if (hintsLength === 0) return result;
        for(var i = 0; i < hintsLength; i++){
            var link = hints[i];
            $6eb9b73e8366afe9$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $6eb9b73e8366afe9$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $6eb9b73e8366afe9$var$isInt32,
    isUint32: $6eb9b73e8366afe9$var$isUint32,
    parseFileMode: $6eb9b73e8366afe9$var$parseFileMode,
    validateArray: $6eb9b73e8366afe9$var$validateArray,
    validateStringArray: $6eb9b73e8366afe9$var$validateStringArray,
    validateBooleanArray: $6eb9b73e8366afe9$var$validateBooleanArray,
    validateAbortSignalArray: $6eb9b73e8366afe9$var$validateAbortSignalArray,
    validateBoolean: $6eb9b73e8366afe9$var$validateBoolean,
    validateBuffer: $6eb9b73e8366afe9$var$validateBuffer,
    validateDictionary: $6eb9b73e8366afe9$var$validateDictionary,
    validateEncoding: $6eb9b73e8366afe9$var$validateEncoding,
    validateFunction: $6eb9b73e8366afe9$var$validateFunction,
    validateInt32: $6eb9b73e8366afe9$var$validateInt32,
    validateInteger: $6eb9b73e8366afe9$var$validateInteger,
    validateNumber: $6eb9b73e8366afe9$var$validateNumber,
    validateObject: $6eb9b73e8366afe9$var$validateObject,
    validateOneOf: $6eb9b73e8366afe9$var$validateOneOf,
    validatePlainFunction: $6eb9b73e8366afe9$var$validatePlainFunction,
    validatePort: $6eb9b73e8366afe9$var$validatePort,
    validateSignalName: $6eb9b73e8366afe9$var$validateSignalName,
    validateString: $6eb9b73e8366afe9$var$validateString,
    validateUint32: $6eb9b73e8366afe9$var$validateUint32,
    validateUndefined: $6eb9b73e8366afe9$var$validateUndefined,
    validateUnion: $6eb9b73e8366afe9$var$validateUnion,
    validateAbortSignal: $6eb9b73e8366afe9$var$validateAbortSignal,
    validateLinkHeaderValue: $6eb9b73e8366afe9$var$validateLinkHeaderValue
};

});

parcelRegister("kAgPS", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8DZ5K = parcelRequire("8DZ5K");
/* replacement end */ var $efc43aad211c5e87$var$AbortError = $8DZ5K.AbortError, $efc43aad211c5e87$var$codes = $8DZ5K.codes;
var $efc43aad211c5e87$var$ERR_INVALID_ARG_TYPE = $efc43aad211c5e87$var$codes.ERR_INVALID_ARG_TYPE, $efc43aad211c5e87$var$ERR_STREAM_PREMATURE_CLOSE = $efc43aad211c5e87$var$codes.ERR_STREAM_PREMATURE_CLOSE;

var $efc43aad211c5e87$var$kEmptyObject = (parcelRequire("7mxb7")).kEmptyObject, $efc43aad211c5e87$var$once = (parcelRequire("7mxb7")).once;

var $9vo7f = parcelRequire("9vo7f");
var $efc43aad211c5e87$var$validateAbortSignal = $9vo7f.validateAbortSignal, $efc43aad211c5e87$var$validateFunction = $9vo7f.validateFunction, $efc43aad211c5e87$var$validateObject = $9vo7f.validateObject, $efc43aad211c5e87$var$validateBoolean = $9vo7f.validateBoolean;

var $4eV73 = parcelRequire("4eV73");
var $efc43aad211c5e87$var$Promise = $4eV73.Promise, $efc43aad211c5e87$var$PromisePrototypeThen = $4eV73.PromisePrototypeThen, $efc43aad211c5e87$var$SymbolDispose = $4eV73.SymbolDispose;

var $2gPtE = parcelRequire("2gPtE");
var $efc43aad211c5e87$var$isClosed = $2gPtE.isClosed, $efc43aad211c5e87$var$isReadable = $2gPtE.isReadable, $efc43aad211c5e87$var$isReadableNodeStream = $2gPtE.isReadableNodeStream, $efc43aad211c5e87$var$isReadableStream = $2gPtE.isReadableStream, $efc43aad211c5e87$var$isReadableFinished = $2gPtE.isReadableFinished, $efc43aad211c5e87$var$isReadableErrored = $2gPtE.isReadableErrored, $efc43aad211c5e87$var$isWritable = $2gPtE.isWritable, $efc43aad211c5e87$var$isWritableNodeStream = $2gPtE.isWritableNodeStream, $efc43aad211c5e87$var$isWritableStream = $2gPtE.isWritableStream, $efc43aad211c5e87$var$isWritableFinished = $2gPtE.isWritableFinished, $efc43aad211c5e87$var$isWritableErrored = $2gPtE.isWritableErrored, $efc43aad211c5e87$var$isNodeStream = $2gPtE.isNodeStream, $efc43aad211c5e87$var$_willEmitClose = $2gPtE.willEmitClose, $efc43aad211c5e87$var$kIsClosedPromise = $2gPtE.kIsClosedPromise;
var $efc43aad211c5e87$var$addAbortListener;
function $efc43aad211c5e87$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
var $efc43aad211c5e87$var$nop = function() {};

function $efc43aad211c5e87$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $efc43aad211c5e87$var$kEmptyObject;
    } else if (options == null) options = $efc43aad211c5e87$var$kEmptyObject;
    else $efc43aad211c5e87$var$validateObject(options, 'options');
    $efc43aad211c5e87$var$validateFunction(callback, 'callback');
    $efc43aad211c5e87$var$validateAbortSignal(options.signal, 'options.signal');
    callback = $efc43aad211c5e87$var$once(callback);
    if ($efc43aad211c5e87$var$isReadableStream(stream) || $efc43aad211c5e87$var$isWritableStream(stream)) return $efc43aad211c5e87$var$eosWeb(stream, options, callback);
    if (!$efc43aad211c5e87$var$isNodeStream(stream)) throw new $efc43aad211c5e87$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    var readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $efc43aad211c5e87$var$isReadableNodeStream(stream);
    var writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $efc43aad211c5e87$var$isWritableNodeStream(stream);
    var wState = stream._writableState;
    var rState = stream._readableState;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    var willEmitClose = $efc43aad211c5e87$var$_willEmitClose(stream) && $efc43aad211c5e87$var$isReadableNodeStream(stream) === readable && $efc43aad211c5e87$var$isWritableNodeStream(stream) === writable;
    var writableFinished = $efc43aad211c5e87$var$isWritableFinished(stream, false);
    var onfinish = function() {
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    var readableFinished = $efc43aad211c5e87$var$isReadableFinished(stream, false);
    var onend = function() {
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var closed = $efc43aad211c5e87$var$isClosed(stream);
    var onclose = function() {
        closed = true;
        var errored = $efc43aad211c5e87$var$isWritableErrored(stream) || $efc43aad211c5e87$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $efc43aad211c5e87$var$isReadableNodeStream(stream, true)) {
            if (!$efc43aad211c5e87$var$isReadableFinished(stream, false)) return callback.call(stream, new $efc43aad211c5e87$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$efc43aad211c5e87$var$isWritableFinished(stream, false)) return callback.call(stream, new $efc43aad211c5e87$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    var onclosed = function() {
        closed = true;
        var errored = $efc43aad211c5e87$var$isWritableErrored(stream) || $efc43aad211c5e87$var$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    var onrequest = function() {
        stream.req.on('finish', onfinish);
    };
    if ($efc43aad211c5e87$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $2Qkr5.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $2Qkr5.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $efc43aad211c5e87$var$isReadable(stream)) && (writableFinished || $efc43aad211c5e87$var$isWritable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $efc43aad211c5e87$var$isWritable(stream)) && (readableFinished || $efc43aad211c5e87$var$isReadable(stream) === false)) $2Qkr5.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $2Qkr5.nextTick(onclosed);
    var cleanup = function() {
        callback = $efc43aad211c5e87$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        var abort = function() {
            // Keep it because cleanup removes it.
            var endCallback = callback;
            cleanup();
            endCallback.call(stream, new $efc43aad211c5e87$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $efc43aad211c5e87$var$addAbortListener = $efc43aad211c5e87$var$addAbortListener || (parcelRequire("7mxb7")).addAbortListener;
            var disposable = $efc43aad211c5e87$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $efc43aad211c5e87$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$efc43aad211c5e87$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $efc43aad211c5e87$var$eosWeb(stream, options, callback) {
    var isAborted = false;
    var abort = $efc43aad211c5e87$var$nop;
    if (options.signal) {
        abort = function() {
            isAborted = true;
            callback.call(stream, new $efc43aad211c5e87$var$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $2Qkr5.nextTick(abort);
        else {
            $efc43aad211c5e87$var$addAbortListener = $efc43aad211c5e87$var$addAbortListener || (parcelRequire("7mxb7")).addAbortListener;
            var disposable = $efc43aad211c5e87$var$addAbortListener(options.signal, abort);
            var originalCallback = callback;
            callback = $efc43aad211c5e87$var$once(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                disposable[$efc43aad211c5e87$var$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    var resolverFn = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!isAborted) $2Qkr5.nextTick(function() {
            return callback.apply(stream, args);
        });
    };
    $efc43aad211c5e87$var$PromisePrototypeThen(stream[$efc43aad211c5e87$var$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $efc43aad211c5e87$var$nop;
}
function $efc43aad211c5e87$var$finished(stream, opts) {
    var _opts;
    var autoCleanup = false;
    if (opts === null) opts = $efc43aad211c5e87$var$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $efc43aad211c5e87$var$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $efc43aad211c5e87$var$Promise(function(resolve, reject) {
        var cleanup = $efc43aad211c5e87$var$eos(stream, opts, function(err) {
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $efc43aad211c5e87$var$eos;
module.exports.finished = $efc43aad211c5e87$var$finished;

});
parcelRegister("2gPtE", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $1a7501b9b15199b0$var$SymbolAsyncIterator = $4eV73.SymbolAsyncIterator, $1a7501b9b15199b0$var$SymbolIterator = $4eV73.SymbolIterator, $1a7501b9b15199b0$var$SymbolFor = $4eV73.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
var $1a7501b9b15199b0$var$kIsDestroyed = $1a7501b9b15199b0$var$SymbolFor('nodejs.stream.destroyed');
var $1a7501b9b15199b0$var$kIsErrored = $1a7501b9b15199b0$var$SymbolFor('nodejs.stream.errored');
var $1a7501b9b15199b0$var$kIsReadable = $1a7501b9b15199b0$var$SymbolFor('nodejs.stream.readable');
var $1a7501b9b15199b0$var$kIsWritable = $1a7501b9b15199b0$var$SymbolFor('nodejs.stream.writable');
var $1a7501b9b15199b0$var$kIsDisturbed = $1a7501b9b15199b0$var$SymbolFor('nodejs.stream.disturbed');
var $1a7501b9b15199b0$var$kIsClosedPromise = $1a7501b9b15199b0$var$SymbolFor('nodejs.webstream.isClosedPromise');
var $1a7501b9b15199b0$var$kControllerErrorFunction = $1a7501b9b15199b0$var$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $1a7501b9b15199b0$var$isReadableNodeStream(obj) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $1a7501b9b15199b0$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $1a7501b9b15199b0$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $1a7501b9b15199b0$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $1a7501b9b15199b0$var$isReadableStream(obj) {
    return !!(obj && !$1a7501b9b15199b0$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $1a7501b9b15199b0$var$isWritableStream(obj) {
    return !!(obj && !$1a7501b9b15199b0$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $1a7501b9b15199b0$var$isTransformStream(obj) {
    return !!(obj && !$1a7501b9b15199b0$var$isNodeStream(obj) && (0, $3KZcf._)(obj.readable) === 'object' && (0, $3KZcf._)(obj.writable) === 'object');
}
function $1a7501b9b15199b0$var$isWebStream(obj) {
    return $1a7501b9b15199b0$var$isReadableStream(obj) || $1a7501b9b15199b0$var$isWritableStream(obj) || $1a7501b9b15199b0$var$isTransformStream(obj);
}
function $1a7501b9b15199b0$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$1a7501b9b15199b0$var$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$1a7501b9b15199b0$var$SymbolIterator] === 'function';
    return typeof obj[$1a7501b9b15199b0$var$SymbolAsyncIterator] === 'function' || typeof obj[$1a7501b9b15199b0$var$SymbolIterator] === 'function';
}
function $1a7501b9b15199b0$var$isDestroyed(stream) {
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !!(stream.destroyed || stream[$1a7501b9b15199b0$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $1a7501b9b15199b0$var$isWritableEnded(stream) {
    if (!$1a7501b9b15199b0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $1a7501b9b15199b0$var$isWritableFinished(stream, strict) {
    if (!$1a7501b9b15199b0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    var wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $1a7501b9b15199b0$var$isReadableEnded(stream) {
    if (!$1a7501b9b15199b0$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    var rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $1a7501b9b15199b0$var$isReadableFinished(stream, strict) {
    if (!$1a7501b9b15199b0$var$isReadableNodeStream(stream)) return null;
    var rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $1a7501b9b15199b0$var$isReadable(stream) {
    if (stream && stream[$1a7501b9b15199b0$var$kIsReadable] != null) return stream[$1a7501b9b15199b0$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($1a7501b9b15199b0$var$isDestroyed(stream)) return false;
    return $1a7501b9b15199b0$var$isReadableNodeStream(stream) && stream.readable && !$1a7501b9b15199b0$var$isReadableFinished(stream);
}
function $1a7501b9b15199b0$var$isWritable(stream) {
    if (stream && stream[$1a7501b9b15199b0$var$kIsWritable] != null) return stream[$1a7501b9b15199b0$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($1a7501b9b15199b0$var$isDestroyed(stream)) return false;
    return $1a7501b9b15199b0$var$isWritableNodeStream(stream) && stream.writable && !$1a7501b9b15199b0$var$isWritableEnded(stream);
}
function $1a7501b9b15199b0$var$isFinished(stream, opts) {
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    if ($1a7501b9b15199b0$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $1a7501b9b15199b0$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $1a7501b9b15199b0$var$isWritable(stream)) return false;
    return true;
}
function $1a7501b9b15199b0$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $1a7501b9b15199b0$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $1a7501b9b15199b0$var$isClosed(stream) {
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    var wState = stream._writableState;
    var rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $1a7501b9b15199b0$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $1a7501b9b15199b0$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $1a7501b9b15199b0$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $1a7501b9b15199b0$var$isOutgoingMessage(stream);
}
function $1a7501b9b15199b0$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $1a7501b9b15199b0$var$willEmitClose(stream) {
    if (!$1a7501b9b15199b0$var$isNodeStream(stream)) return null;
    var wState = stream._writableState;
    var rState = stream._readableState;
    var state = wState || rState;
    return !state && $1a7501b9b15199b0$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $1a7501b9b15199b0$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$1a7501b9b15199b0$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $1a7501b9b15199b0$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$1a7501b9b15199b0$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $1a7501b9b15199b0$var$isDestroyed,
    kIsDestroyed: $1a7501b9b15199b0$var$kIsDestroyed,
    isDisturbed: $1a7501b9b15199b0$var$isDisturbed,
    kIsDisturbed: $1a7501b9b15199b0$var$kIsDisturbed,
    isErrored: $1a7501b9b15199b0$var$isErrored,
    kIsErrored: $1a7501b9b15199b0$var$kIsErrored,
    isReadable: $1a7501b9b15199b0$var$isReadable,
    kIsReadable: $1a7501b9b15199b0$var$kIsReadable,
    kIsClosedPromise: $1a7501b9b15199b0$var$kIsClosedPromise,
    kControllerErrorFunction: $1a7501b9b15199b0$var$kControllerErrorFunction,
    kIsWritable: $1a7501b9b15199b0$var$kIsWritable,
    isClosed: $1a7501b9b15199b0$var$isClosed,
    isDuplexNodeStream: $1a7501b9b15199b0$var$isDuplexNodeStream,
    isFinished: $1a7501b9b15199b0$var$isFinished,
    isIterable: $1a7501b9b15199b0$var$isIterable,
    isReadableNodeStream: $1a7501b9b15199b0$var$isReadableNodeStream,
    isReadableStream: $1a7501b9b15199b0$var$isReadableStream,
    isReadableEnded: $1a7501b9b15199b0$var$isReadableEnded,
    isReadableFinished: $1a7501b9b15199b0$var$isReadableFinished,
    isReadableErrored: $1a7501b9b15199b0$var$isReadableErrored,
    isNodeStream: $1a7501b9b15199b0$var$isNodeStream,
    isWebStream: $1a7501b9b15199b0$var$isWebStream,
    isWritable: $1a7501b9b15199b0$var$isWritable,
    isWritableNodeStream: $1a7501b9b15199b0$var$isWritableNodeStream,
    isWritableStream: $1a7501b9b15199b0$var$isWritableStream,
    isWritableEnded: $1a7501b9b15199b0$var$isWritableEnded,
    isWritableFinished: $1a7501b9b15199b0$var$isWritableFinished,
    isWritableErrored: $1a7501b9b15199b0$var$isWritableErrored,
    isServerRequest: $1a7501b9b15199b0$var$isServerRequest,
    isServerResponse: $1a7501b9b15199b0$var$isServerResponse,
    willEmitClose: $1a7501b9b15199b0$var$willEmitClose,
    isTransformStream: $1a7501b9b15199b0$var$isTransformStream
};

});


parcelRegister("byOAZ", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $aILEd = parcelRequire("aILEd");
var $86aa1def54bd9d92$require$pipeline = $aILEd.pipeline;

var $1HP2L = parcelRequire("1HP2L");

var $1frHX = parcelRequire("1frHX");
var $86aa1def54bd9d92$require$destroyer = $1frHX.destroyer;

var $2gPtE = parcelRequire("2gPtE");
var $86aa1def54bd9d92$var$isNodeStream = $2gPtE.isNodeStream, $86aa1def54bd9d92$var$isReadable = $2gPtE.isReadable, $86aa1def54bd9d92$var$isWritable = $2gPtE.isWritable, $86aa1def54bd9d92$var$isWebStream = $2gPtE.isWebStream, $86aa1def54bd9d92$var$isTransformStream = $2gPtE.isTransformStream, $86aa1def54bd9d92$var$isWritableStream = $2gPtE.isWritableStream, $86aa1def54bd9d92$var$isReadableStream = $2gPtE.isReadableStream;

var $8DZ5K = parcelRequire("8DZ5K");
var $86aa1def54bd9d92$var$AbortError = $8DZ5K.AbortError, $86aa1def54bd9d92$var$_require_codes = $8DZ5K.codes, $86aa1def54bd9d92$var$ERR_INVALID_ARG_VALUE = $86aa1def54bd9d92$var$_require_codes.ERR_INVALID_ARG_VALUE, $86aa1def54bd9d92$var$ERR_MISSING_ARGS = $86aa1def54bd9d92$var$_require_codes.ERR_MISSING_ARGS;

var $kAgPS = parcelRequire("kAgPS");
module.exports = function compose() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    if (streams.length === 0) throw new $86aa1def54bd9d92$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1HP2L.from(streams[0]);
    var orgStreams = (0, $7WNf6._)(streams);
    if (typeof streams[0] === 'function') streams[0] = $1HP2L.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        var idx = streams.length - 1;
        streams[idx] = $1HP2L.from(streams[idx]);
    }
    for(var n = 0; n < streams.length; ++n){
        if (!$86aa1def54bd9d92$var$isNodeStream(streams[n]) && !$86aa1def54bd9d92$var$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($86aa1def54bd9d92$var$isReadable(streams[n]) || $86aa1def54bd9d92$var$isReadableStream(streams[n]) || $86aa1def54bd9d92$var$isTransformStream(streams[n]))) throw new $86aa1def54bd9d92$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
        if (n > 0 && !($86aa1def54bd9d92$var$isWritable(streams[n]) || $86aa1def54bd9d92$var$isWritableStream(streams[n]) || $86aa1def54bd9d92$var$isTransformStream(streams[n]))) throw new $86aa1def54bd9d92$var$ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    var head = streams[0];
    var tail = $86aa1def54bd9d92$require$pipeline(streams, onfinished);
    var writable = !!($86aa1def54bd9d92$var$isWritable(head) || $86aa1def54bd9d92$var$isWritableStream(head) || $86aa1def54bd9d92$var$isTransformStream(head));
    var readable = !!($86aa1def54bd9d92$var$isReadable(tail) || $86aa1def54bd9d92$var$isReadableStream(tail) || $86aa1def54bd9d92$var$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1HP2L({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($86aa1def54bd9d92$var$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    var cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($86aa1def54bd9d92$var$isWebStream(head)) {
            var writable1 = $86aa1def54bd9d92$var$isTransformStream(head) ? head.writable : head;
            var writer = writable1.getWriter();
            d._write = function(chunk, encoding, callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.write(chunk)["catch"](function() {});
                                callback();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            d._final = function(callback) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    writer.ready
                                ];
                            case 1:
                                _state.sent();
                                writer.close()["catch"](function() {});
                                onfinish = callback;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                callback(err);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
        var toRead = $86aa1def54bd9d92$var$isTransformStream(tail) ? tail.readable : tail;
        $kAgPS(toRead, function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($86aa1def54bd9d92$var$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    var cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    var buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($86aa1def54bd9d92$var$isWebStream(tail)) {
            var readable1 = $86aa1def54bd9d92$var$isTransformStream(tail) ? tail.readable : tail;
            var reader = readable1.getReader();
            d._read = function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _ref, value, done, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!true) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    reader.read()
                                ];
                            case 2:
                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                if (!d.push(value)) return [
                                    2
                                ];
                                if (done) {
                                    d.push(null);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    3,
                                    0
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $86aa1def54bd9d92$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($86aa1def54bd9d92$var$isNodeStream(tail)) $86aa1def54bd9d92$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("aILEd", function(module, exports) {
/* replacement start */ 
var $d5YHV = parcelRequire("d5YHV");

var $bq7J2 = parcelRequire("bq7J2");

var $b8tVf = parcelRequire("b8tVf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $7ce2f946ca974158$var$ArrayIsArray = $4eV73.ArrayIsArray, $7ce2f946ca974158$var$Promise = $4eV73.Promise, $7ce2f946ca974158$var$SymbolAsyncIterator = $4eV73.SymbolAsyncIterator, $7ce2f946ca974158$var$SymbolDispose = $4eV73.SymbolDispose;

var $kAgPS = parcelRequire("kAgPS");

var $7ce2f946ca974158$require$once = (parcelRequire("7mxb7")).once;

var $1frHX = parcelRequire("1frHX");

var $1HP2L = parcelRequire("1HP2L");

var $8DZ5K = parcelRequire("8DZ5K");
var $7ce2f946ca974158$var$aggregateTwoErrors = $8DZ5K.aggregateTwoErrors, $7ce2f946ca974158$var$_require_codes = $8DZ5K.codes, $7ce2f946ca974158$var$ERR_INVALID_ARG_TYPE = $7ce2f946ca974158$var$_require_codes.ERR_INVALID_ARG_TYPE, $7ce2f946ca974158$var$ERR_INVALID_RETURN_VALUE = $7ce2f946ca974158$var$_require_codes.ERR_INVALID_RETURN_VALUE, $7ce2f946ca974158$var$ERR_MISSING_ARGS = $7ce2f946ca974158$var$_require_codes.ERR_MISSING_ARGS, $7ce2f946ca974158$var$ERR_STREAM_DESTROYED = $7ce2f946ca974158$var$_require_codes.ERR_STREAM_DESTROYED, $7ce2f946ca974158$var$ERR_STREAM_PREMATURE_CLOSE = $7ce2f946ca974158$var$_require_codes.ERR_STREAM_PREMATURE_CLOSE, $7ce2f946ca974158$var$AbortError = $8DZ5K.AbortError;

var $9vo7f = parcelRequire("9vo7f");
var $7ce2f946ca974158$var$validateFunction = $9vo7f.validateFunction, $7ce2f946ca974158$var$validateAbortSignal = $9vo7f.validateAbortSignal;

var $2gPtE = parcelRequire("2gPtE");
var $7ce2f946ca974158$var$isIterable = $2gPtE.isIterable, $7ce2f946ca974158$var$isReadable = $2gPtE.isReadable, $7ce2f946ca974158$var$isReadableNodeStream = $2gPtE.isReadableNodeStream, $7ce2f946ca974158$var$isNodeStream = $2gPtE.isNodeStream, $7ce2f946ca974158$var$isTransformStream = $2gPtE.isTransformStream, $7ce2f946ca974158$var$isWebStream = $2gPtE.isWebStream, $7ce2f946ca974158$var$isReadableStream = $2gPtE.isReadableStream, $7ce2f946ca974158$var$isReadableFinished = $2gPtE.isReadableFinished;

var $7ce2f946ca974158$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;
var $7ce2f946ca974158$var$PassThrough;
var $7ce2f946ca974158$var$Readable;
var $7ce2f946ca974158$var$addAbortListener;
function $7ce2f946ca974158$var$destroyer(stream, reading, writing) {
    var finished = false;
    stream.on('close', function() {
        finished = true;
    });
    var cleanup = $kAgPS(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        finished = !err;
    });
    return {
        destroy: function(err) {
            if (finished) return;
            finished = true;
            $1frHX.destroyer(stream, err || new $7ce2f946ca974158$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $7ce2f946ca974158$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $7ce2f946ca974158$var$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $7ce2f946ca974158$var$makeAsyncIterable(val) {
    if ($7ce2f946ca974158$var$isIterable(val)) return val;
    else if ($7ce2f946ca974158$var$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $7ce2f946ca974158$var$fromReadable(val);
    throw new $7ce2f946ca974158$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

function $7ce2f946ca974158$var$fromReadable(val) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7ce2f946ca974158$var$Readable) $7ce2f946ca974158$var$Readable = (parcelRequire("4jNps"));
                    return [
                        5,
                        (0, $9N5UN.__values)((0, $d5YHV._)((0, $bq7J2._)($7ce2f946ca974158$var$Readable.prototype[$7ce2f946ca974158$var$SymbolAsyncIterator].call(val))))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7ce2f946ca974158$var$pumpToNode(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(iterable, writable, finish, param) {
        var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    onresolve = null;
                    resume = function(err) {
                        if (err) error = err;
                        if (onresolve) {
                            var callback = onresolve;
                            onresolve = null;
                            callback();
                        }
                    };
                    wait = function() {
                        return new $7ce2f946ca974158$var$Promise(function(resolve, reject) {
                            if (error) reject(error);
                            else onresolve = function() {
                                if (error) reject(error);
                                else resolve();
                            };
                        });
                    };
                    writable.on('drain', resume);
                    cleanup = $kAgPS(writable, {
                        readable: false
                    }, resume);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    if (!writable.writableNeedDrain) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $bq7J2._)(iterable);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!!writable.write(chunk)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        wait()
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!end) return [
                        3,
                        18
                    ];
                    writable.end();
                    return [
                        4,
                        wait()
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    finish();
                    return [
                        3,
                        21
                    ];
                case 19:
                    err1 = _state.sent();
                    finish(error !== err1 ? $7ce2f946ca974158$var$aggregateTwoErrors(error, err1) : err1);
                    return [
                        3,
                        21
                    ];
                case 20:
                    cleanup();
                    writable.off('drain', resume);
                    return [
                        7
                    ];
                case 21:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7ce2f946ca974158$var$pumpToWeb(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function(readable, writable, finish, param) {
        var end, writer, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err, err1, err2;
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = param.end;
                    if ($7ce2f946ca974158$var$isTransformStream(writable)) writable = writable.writable;
                    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
                    writer = writable.getWriter();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        18,
                        ,
                        23
                    ]);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $bq7J2._)(readable);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        writer.ready
                    ];
                case 5:
                    _state.sent();
                    writer.write(chunk)["catch"](function() {});
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        4,
                        writer.ready
                    ];
                case 15:
                    _state.sent();
                    if (!end) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        writer.close()
                    ];
                case 16:
                    _state.sent();
                    _state.label = 17;
                case 17:
                    finish();
                    return [
                        3,
                        23
                    ];
                case 18:
                    err1 = _state.sent();
                    _state.label = 19;
                case 19:
                    _state.trys.push([
                        19,
                        21,
                        ,
                        22
                    ]);
                    return [
                        4,
                        writer.abort(err1)
                    ];
                case 20:
                    _state.sent();
                    finish(err1);
                    return [
                        3,
                        22
                    ];
                case 21:
                    err2 = _state.sent();
                    finish(err2);
                    return [
                        3,
                        22
                    ];
                case 22:
                    return [
                        3,
                        23
                    ];
                case 23:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7ce2f946ca974158$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return $7ce2f946ca974158$var$pipelineImpl(streams, $7ce2f946ca974158$require$once($7ce2f946ca974158$var$popCallback(streams)));
}


function $7ce2f946ca974158$var$pipelineImpl(streams, callback, opts) {
    var _loop = function(i) {
        var stream = streams[i];
        var reading = i < streams.length - 1;
        var writing = i > 0;
        var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        var isLastStream = i === streams.length - 1;
        if ($7ce2f946ca974158$var$isNodeStream(stream)) {
            var onError = // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            };
            if (end) {
                var _destroyer = $7ce2f946ca974158$var$destroyer(stream, reading, writing), destroy = _destroyer.destroy, cleanup = _destroyer.cleanup;
                destroys.push(destroy);
                if ($7ce2f946ca974158$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            stream.on('error', onError);
            if ($7ce2f946ca974158$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(function() {
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$7ce2f946ca974158$var$isIterable(ret)) throw new $7ce2f946ca974158$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($7ce2f946ca974158$var$isIterable(stream) || $7ce2f946ca974158$var$isReadableNodeStream(stream) || $7ce2f946ca974158$var$isTransformStream(stream)) ret = stream;
            else ret = $1HP2L.from(stream);
        } else if (typeof stream === 'function') {
            if ($7ce2f946ca974158$var$isTransformStream(ret)) {
                var _ret;
                ret = $7ce2f946ca974158$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $7ce2f946ca974158$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$7ce2f946ca974158$var$isIterable(ret, true)) throw new $7ce2f946ca974158$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
            } else {
                var _ret2;
                if (!$7ce2f946ca974158$var$PassThrough) $7ce2f946ca974158$var$PassThrough = (parcelRequire("4AOZp"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                var pt = new $7ce2f946ca974158$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, function(val) {
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $2Qkr5.nextTick(finish);
                    }, function(err) {
                        pt.destroy(err);
                        $2Qkr5.nextTick(finish, err);
                    });
                } else if ($7ce2f946ca974158$var$isIterable(ret, true)) {
                    finishCount++;
                    $7ce2f946ca974158$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($7ce2f946ca974158$var$isReadableStream(ret) || $7ce2f946ca974158$var$isTransformStream(ret)) {
                    var toRead = ret.readable || ret;
                    finishCount++;
                    $7ce2f946ca974158$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $7ce2f946ca974158$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                var _destroyer1 = $7ce2f946ca974158$var$destroyer(ret, false, true), destroy1 = _destroyer1.destroy, cleanup1 = _destroyer1.cleanup;
                destroys.push(destroy1);
                if (isLastStream) lastStreamCleanup.push(cleanup1);
            }
        } else if ($7ce2f946ca974158$var$isNodeStream(stream)) {
            if ($7ce2f946ca974158$var$isReadableNodeStream(ret)) {
                finishCount += 2;
                var cleanup2 = $7ce2f946ca974158$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($7ce2f946ca974158$var$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup2);
            } else if ($7ce2f946ca974158$var$isTransformStream(ret) || $7ce2f946ca974158$var$isReadableStream(ret)) {
                var toRead1 = ret.readable || ret;
                finishCount++;
                $7ce2f946ca974158$var$pumpToNode(toRead1, stream, finish, {
                    end: end
                });
            } else if ($7ce2f946ca974158$var$isIterable(ret)) {
                finishCount++;
                $7ce2f946ca974158$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $7ce2f946ca974158$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($7ce2f946ca974158$var$isWebStream(stream)) {
            if ($7ce2f946ca974158$var$isReadableNodeStream(ret)) {
                finishCount++;
                $7ce2f946ca974158$var$pumpToWeb($7ce2f946ca974158$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($7ce2f946ca974158$var$isReadableStream(ret) || $7ce2f946ca974158$var$isIterable(ret)) {
                finishCount++;
                $7ce2f946ca974158$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($7ce2f946ca974158$var$isTransformStream(ret)) {
                finishCount++;
                $7ce2f946ca974158$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $7ce2f946ca974158$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1HP2L.from(stream);
    };
    if (streams.length === 1 && $7ce2f946ca974158$var$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7ce2f946ca974158$var$ERR_MISSING_ARGS('streams');
    var ac = new $7ce2f946ca974158$var$AbortController();
    var signal = ac.signal;
    var outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    var lastStreamCleanup = [];
    $7ce2f946ca974158$var$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $7ce2f946ca974158$var$AbortError());
    }
    $7ce2f946ca974158$var$addAbortListener = $7ce2f946ca974158$var$addAbortListener || (parcelRequire("7mxb7")).addAbortListener;
    var disposable;
    if (outerSignal) disposable = $7ce2f946ca974158$var$addAbortListener(outerSignal, abort);
    var error;
    var value;
    var destroys = [];
    var finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, _final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !_final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$7ce2f946ca974158$var$SymbolDispose]();
        ac.abort();
        if (_final) {
            if (!error) lastStreamCleanup.forEach(function(fn) {
                return fn();
            });
            $2Qkr5.nextTick(callback, error, value);
        }
    }
    var ret;
    for(var i = 0; i < streams.length; i++)_loop(i);
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $2Qkr5.nextTick(abort);
    return ret;
}
function $7ce2f946ca974158$var$pipe(src, dst, finish, param) {
    var end = param.end;
    var ended = false;
    dst.on('close', function() {
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $7ce2f946ca974158$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        var endFn = // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        };
        if ($7ce2f946ca974158$var$isReadableFinished(src)) // End the destination if the source has already ended.
        $2Qkr5.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $kAgPS(src, {
        readable: true,
        writable: false
    }, function(err) {
        var rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $kAgPS(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $7ce2f946ca974158$var$pipelineImpl,
    pipeline: $7ce2f946ca974158$var$pipeline
};

});
parcelRegister("1frHX", function(module, exports) {
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $8DZ5K = parcelRequire("8DZ5K");
/* replacement end */ var $0e8caf6444837138$var$aggregateTwoErrors = $8DZ5K.aggregateTwoErrors, $0e8caf6444837138$var$ERR_MULTIPLE_CALLBACK = $8DZ5K.codes.ERR_MULTIPLE_CALLBACK, $0e8caf6444837138$var$AbortError = $8DZ5K.AbortError;

var $4eV73 = parcelRequire("4eV73");
var $0e8caf6444837138$require$Symbol = $4eV73.Symbol;

var $2gPtE = parcelRequire("2gPtE");
var $0e8caf6444837138$var$kIsDestroyed = $2gPtE.kIsDestroyed, $0e8caf6444837138$var$isDestroyed = $2gPtE.isDestroyed, $0e8caf6444837138$var$isFinished = $2gPtE.isFinished, $0e8caf6444837138$var$isServerRequest = $2gPtE.isServerRequest;
var $0e8caf6444837138$var$kDestroy = $0e8caf6444837138$require$Symbol('kDestroy');
var $0e8caf6444837138$var$kConstruct = $0e8caf6444837138$require$Symbol('kConstruct');
function $0e8caf6444837138$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $0e8caf6444837138$var$destroy(err, cb) {
    var r = this._readableState;
    var w = this._writableState;
    // With duplex streams we use the writable side for state.
    var s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $0e8caf6444837138$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($0e8caf6444837138$var$kDestroy, function(er) {
        $0e8caf6444837138$var$_destroy(this, $0e8caf6444837138$var$aggregateTwoErrors(er, err), cb);
    });
    else $0e8caf6444837138$var$_destroy(this, err, cb);
    return this;
}
function $0e8caf6444837138$var$_destroy(self, err, cb) {
    var called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        var r = self._readableState;
        var w = self._writableState;
        $0e8caf6444837138$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $2Qkr5.nextTick($0e8caf6444837138$var$emitErrorCloseNT, self, err);
        else $2Qkr5.nextTick($0e8caf6444837138$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $0e8caf6444837138$var$emitErrorCloseNT(self, err) {
    $0e8caf6444837138$var$emitErrorNT(self, err);
    $0e8caf6444837138$var$emitCloseNT(self);
}
function $0e8caf6444837138$var$emitCloseNT(self) {
    var r = self._readableState;
    var w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $0e8caf6444837138$var$emitErrorNT(self, err) {
    var r = self._readableState;
    var w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $0e8caf6444837138$var$undestroy() {
    var r = this._readableState;
    var w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $0e8caf6444837138$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var r = stream._readableState;
    var w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $2Qkr5.nextTick($0e8caf6444837138$var$emitErrorNT, stream, err);
        else $0e8caf6444837138$var$emitErrorNT(stream, err);
    }
}
function $0e8caf6444837138$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    var r = stream._readableState;
    var w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($0e8caf6444837138$var$kConstruct, cb);
    if (stream.listenerCount($0e8caf6444837138$var$kConstruct) > 1) // Duplex
    return;
    $2Qkr5.nextTick($0e8caf6444837138$var$constructNT, stream);
}
function $0e8caf6444837138$var$constructNT(stream) {
    var called = false;
    function onConstruct(err) {
        if (called) {
            $0e8caf6444837138$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $0e8caf6444837138$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        var r = stream._readableState;
        var w = stream._writableState;
        var s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($0e8caf6444837138$var$kDestroy, err);
        else if (err) $0e8caf6444837138$var$errorOrDestroy(stream, err, true);
        else $2Qkr5.nextTick($0e8caf6444837138$var$emitConstructNT, stream);
    }
    try {
        stream._construct(function(err) {
            $2Qkr5.nextTick(onConstruct, err);
        });
    } catch (err) {
        $2Qkr5.nextTick(onConstruct, err);
    }
}
function $0e8caf6444837138$var$emitConstructNT(stream) {
    stream.emit($0e8caf6444837138$var$kConstruct);
}
function $0e8caf6444837138$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $0e8caf6444837138$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $0e8caf6444837138$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $2Qkr5.nextTick($0e8caf6444837138$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $0e8caf6444837138$var$destroyer(stream, err) {
    if (!stream || $0e8caf6444837138$var$isDestroyed(stream)) return;
    if (!err && !$0e8caf6444837138$var$isFinished(stream)) err = new $0e8caf6444837138$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($0e8caf6444837138$var$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($0e8caf6444837138$var$isRequest(stream)) stream.abort();
    else if ($0e8caf6444837138$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $2Qkr5.nextTick($0e8caf6444837138$var$emitErrorCloseLegacy, stream, err);
    else $2Qkr5.nextTick($0e8caf6444837138$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$0e8caf6444837138$var$kIsDestroyed] = true;
}
module.exports = {
    construct: $0e8caf6444837138$var$construct,
    destroyer: $0e8caf6444837138$var$destroyer,
    destroy: $0e8caf6444837138$var$destroy,
    undestroy: $0e8caf6444837138$var$undestroy,
    errorOrDestroy: $0e8caf6444837138$var$errorOrDestroy
};

});

parcelRegister("1HP2L", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $iT0je = parcelRequire("iT0je");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $13e166c37b2f4758$var$ObjectDefineProperties = $4eV73.ObjectDefineProperties, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor = $4eV73.ObjectGetOwnPropertyDescriptor, $13e166c37b2f4758$var$ObjectKeys = $4eV73.ObjectKeys, $13e166c37b2f4758$var$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf;
module.exports = $13e166c37b2f4758$var$Duplex;

var $4jNps = parcelRequire("4jNps");

var $2VGBJ = parcelRequire("2VGBJ");
$13e166c37b2f4758$var$ObjectSetPrototypeOf($13e166c37b2f4758$var$Duplex.prototype, $4jNps.prototype);
$13e166c37b2f4758$var$ObjectSetPrototypeOf($13e166c37b2f4758$var$Duplex, $4jNps);
{
    var $13e166c37b2f4758$var$keys = $13e166c37b2f4758$var$ObjectKeys($2VGBJ.prototype);
    // Allow the keys array to be GC'ed.
    for(var $13e166c37b2f4758$var$i = 0; $13e166c37b2f4758$var$i < $13e166c37b2f4758$var$keys.length; $13e166c37b2f4758$var$i++){
        var $13e166c37b2f4758$var$method = $13e166c37b2f4758$var$keys[$13e166c37b2f4758$var$i];
        if (!$13e166c37b2f4758$var$Duplex.prototype[$13e166c37b2f4758$var$method]) $13e166c37b2f4758$var$Duplex.prototype[$13e166c37b2f4758$var$method] = $2VGBJ.prototype[$13e166c37b2f4758$var$method];
    }
}function $13e166c37b2f4758$var$Duplex(options) {
    if (!(this instanceof $13e166c37b2f4758$var$Duplex)) return new $13e166c37b2f4758$var$Duplex(options);
    $4jNps.call(this, options);
    $2VGBJ.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$13e166c37b2f4758$var$ObjectDefineProperties($13e166c37b2f4758$var$Duplex.prototype, {
    writable: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writable')),
    writableHighWaterMark: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableObjectMode')),
    writableBuffer: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableBuffer')),
    writableLength: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableLength')),
    writableFinished: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableFinished')),
    writableCorked: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableCorked')),
    writableEnded: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableEnded')),
    writableNeedDrain: (0, $iT0je._)({
        __proto__: null
    }, $13e166c37b2f4758$var$ObjectGetOwnPropertyDescriptor($2VGBJ.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
var $13e166c37b2f4758$var$webStreamsAdapters;
// Lazy to avoid circular references
function $13e166c37b2f4758$var$lazyWebStreams() {
    if ($13e166c37b2f4758$var$webStreamsAdapters === undefined) $13e166c37b2f4758$var$webStreamsAdapters = {};
    return $13e166c37b2f4758$var$webStreamsAdapters;
}
$13e166c37b2f4758$var$Duplex.fromWeb = function(pair, options) {
    return $13e166c37b2f4758$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$13e166c37b2f4758$var$Duplex.toWeb = function(duplex) {
    return $13e166c37b2f4758$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
var $13e166c37b2f4758$var$duplexify;

$13e166c37b2f4758$var$Duplex.from = function(body) {
    if (!$13e166c37b2f4758$var$duplexify) $13e166c37b2f4758$var$duplexify = (parcelRequire("66jzT"));
    return $13e166c37b2f4758$var$duplexify(body, 'body');
};

});
parcelRegister("4jNps", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $iw20L = parcelRequire("iw20L");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4eV73 = parcelRequire("4eV73");
/* replacement end */ var $324f437bde7bc4e9$var$ArrayPrototypeIndexOf = $4eV73.ArrayPrototypeIndexOf, $324f437bde7bc4e9$var$NumberIsInteger = $4eV73.NumberIsInteger, $324f437bde7bc4e9$var$NumberIsNaN = $4eV73.NumberIsNaN, $324f437bde7bc4e9$var$NumberParseInt = $4eV73.NumberParseInt, $324f437bde7bc4e9$var$ObjectDefineProperties = $4eV73.ObjectDefineProperties, $324f437bde7bc4e9$var$ObjectKeys = $4eV73.ObjectKeys, $324f437bde7bc4e9$var$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf, $324f437bde7bc4e9$var$Promise = $4eV73.Promise, $324f437bde7bc4e9$var$SafeSet = $4eV73.SafeSet, $324f437bde7bc4e9$var$SymbolAsyncDispose = $4eV73.SymbolAsyncDispose, $324f437bde7bc4e9$var$SymbolAsyncIterator = $4eV73.SymbolAsyncIterator, $324f437bde7bc4e9$var$Symbol = $4eV73.Symbol;
module.exports = $324f437bde7bc4e9$var$Readable;
$324f437bde7bc4e9$var$Readable.ReadableState = $324f437bde7bc4e9$var$ReadableState;

var $bBoAO = parcelRequire("bBoAO");
var $324f437bde7bc4e9$var$EE = $bBoAO.EventEmitter;

var $5Ze7g = parcelRequire("5Ze7g");
var $324f437bde7bc4e9$var$Stream = $5Ze7g.Stream, $324f437bde7bc4e9$var$prependListener = $5Ze7g.prependListener;

var $1he7j = parcelRequire("1he7j");
var $324f437bde7bc4e9$require$Buffer = $1he7j.Buffer;

var $jYKwv = parcelRequire("jYKwv");
var $324f437bde7bc4e9$require$addAbortSignal = $jYKwv.addAbortSignal;

var $kAgPS = parcelRequire("kAgPS");

var $324f437bde7bc4e9$var$debug = (parcelRequire("7mxb7")).debuglog('stream', function(fn) {
    $324f437bde7bc4e9$var$debug = fn;
});

var $gdrcQ = parcelRequire("gdrcQ");

var $1frHX = parcelRequire("1frHX");

var $l767L = parcelRequire("l767L");
var $324f437bde7bc4e9$var$getHighWaterMark = $l767L.getHighWaterMark, $324f437bde7bc4e9$var$getDefaultHighWaterMark = $l767L.getDefaultHighWaterMark;

var $8DZ5K = parcelRequire("8DZ5K");
var $324f437bde7bc4e9$var$aggregateTwoErrors = $8DZ5K.aggregateTwoErrors, $324f437bde7bc4e9$var$_require_codes = $8DZ5K.codes, $324f437bde7bc4e9$var$ERR_INVALID_ARG_TYPE = $324f437bde7bc4e9$var$_require_codes.ERR_INVALID_ARG_TYPE, $324f437bde7bc4e9$var$ERR_METHOD_NOT_IMPLEMENTED = $324f437bde7bc4e9$var$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $324f437bde7bc4e9$var$ERR_OUT_OF_RANGE = $324f437bde7bc4e9$var$_require_codes.ERR_OUT_OF_RANGE, $324f437bde7bc4e9$var$ERR_STREAM_PUSH_AFTER_EOF = $324f437bde7bc4e9$var$_require_codes.ERR_STREAM_PUSH_AFTER_EOF, $324f437bde7bc4e9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $324f437bde7bc4e9$var$_require_codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, $324f437bde7bc4e9$var$AbortError = $8DZ5K.AbortError;

var $9vo7f = parcelRequire("9vo7f");
var $324f437bde7bc4e9$require$validateObject = $9vo7f.validateObject;
var $324f437bde7bc4e9$var$kPaused = $324f437bde7bc4e9$var$Symbol('kPaused');

var $3Jf7C = parcelRequire("3Jf7C");
var $324f437bde7bc4e9$require$StringDecoder = $3Jf7C.StringDecoder;

var $8iWwS = parcelRequire("8iWwS");
$324f437bde7bc4e9$var$ObjectSetPrototypeOf($324f437bde7bc4e9$var$Readable.prototype, $324f437bde7bc4e9$var$Stream.prototype);
$324f437bde7bc4e9$var$ObjectSetPrototypeOf($324f437bde7bc4e9$var$Readable, $324f437bde7bc4e9$var$Stream);
var $324f437bde7bc4e9$var$nop = function() {};
var $324f437bde7bc4e9$var$errorOrDestroy = $1frHX.errorOrDestroy;
var $324f437bde7bc4e9$var$kObjectMode = 1;
var $324f437bde7bc4e9$var$kEnded = 2;
var $324f437bde7bc4e9$var$kEndEmitted = 4;
var $324f437bde7bc4e9$var$kReading = 8;
var $324f437bde7bc4e9$var$kConstructed = 16;
var $324f437bde7bc4e9$var$kSync = 32;
var $324f437bde7bc4e9$var$kNeedReadable = 64;
var $324f437bde7bc4e9$var$kEmittedReadable = 128;
var $324f437bde7bc4e9$var$kReadableListening = 256;
var $324f437bde7bc4e9$var$kResumeScheduled = 512;
var $324f437bde7bc4e9$var$kErrorEmitted = 1024;
var $324f437bde7bc4e9$var$kEmitClose = 2048;
var $324f437bde7bc4e9$var$kAutoDestroy = 4096;
var $324f437bde7bc4e9$var$kDestroyed = 8192;
var $324f437bde7bc4e9$var$kClosed = 16384;
var $324f437bde7bc4e9$var$kCloseEmitted = 32768;
var $324f437bde7bc4e9$var$kMultiAwaitDrain = 65536;
var $324f437bde7bc4e9$var$kReadingMore = 131072;
var $324f437bde7bc4e9$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $324f437bde7bc4e9$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get: function() {
            return (this.state & bit) !== 0;
        },
        set: function(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$324f437bde7bc4e9$var$ObjectDefineProperties($324f437bde7bc4e9$var$ReadableState.prototype, {
    objectMode: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kObjectMode),
    ended: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kEnded),
    endEmitted: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kEndEmitted),
    reading: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kNeedReadable),
    emittedReadable: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kEmittedReadable),
    readableListening: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kReadableListening),
    resumeScheduled: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kErrorEmitted),
    emitClose: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kEmitClose),
    autoDestroy: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kCloseEmitted),
    multiAwaitDrain: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kReadingMore),
    dataEmitted: $324f437bde7bc4e9$var$makeBitMapDescriptor($324f437bde7bc4e9$var$kDataEmitted)
});

function $324f437bde7bc4e9$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1HP2L"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $324f437bde7bc4e9$var$kEmitClose | $324f437bde7bc4e9$var$kAutoDestroy | $324f437bde7bc4e9$var$kConstructed | $324f437bde7bc4e9$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $324f437bde7bc4e9$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $324f437bde7bc4e9$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $324f437bde7bc4e9$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $324f437bde7bc4e9$var$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $gdrcQ();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$324f437bde7bc4e9$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$324f437bde7bc4e9$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$324f437bde7bc4e9$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $324f437bde7bc4e9$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $324f437bde7bc4e9$var$Readable(options) {
    var _this = this;
    if (!(this instanceof $324f437bde7bc4e9$var$Readable)) return new $324f437bde7bc4e9$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("1HP2L"));
    this._readableState = new $324f437bde7bc4e9$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $324f437bde7bc4e9$require$addAbortSignal(options.signal, this);
    }
    $324f437bde7bc4e9$var$Stream.call(this, options);
    $1frHX.construct(this, function() {
        if (_this._readableState.needReadable) $324f437bde7bc4e9$var$maybeReadMore(_this, _this._readableState);
    });
}
$324f437bde7bc4e9$var$Readable.prototype.destroy = $1frHX.destroy;
$324f437bde7bc4e9$var$Readable.prototype._undestroy = $1frHX.undestroy;
$324f437bde7bc4e9$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$324f437bde7bc4e9$var$Readable.prototype[$324f437bde7bc4e9$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$324f437bde7bc4e9$var$Readable.prototype[$324f437bde7bc4e9$var$SymbolAsyncDispose] = function() {
    var _this = this;
    var error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $324f437bde7bc4e9$var$AbortError();
        this.destroy(error);
    }
    return new $324f437bde7bc4e9$var$Promise(function(resolve, reject) {
        return $kAgPS(_this, function(err) {
            return err && err !== error ? reject(err) : resolve(null);
        });
    });
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$324f437bde7bc4e9$var$Readable.prototype.push = function(chunk, encoding) {
    return $324f437bde7bc4e9$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$324f437bde7bc4e9$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $324f437bde7bc4e9$var$readableAddChunk(this, chunk, encoding, true);
};
function $324f437bde7bc4e9$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $324f437bde7bc4e9$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    var err;
    if ((state.state & $324f437bde7bc4e9$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $324f437bde7bc4e9$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $324f437bde7bc4e9$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $324f437bde7bc4e9$require$Buffer) encoding = '';
        else if ($324f437bde7bc4e9$var$Stream._isUint8Array(chunk)) {
            chunk = $324f437bde7bc4e9$var$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $324f437bde7bc4e9$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $324f437bde7bc4e9$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$324f437bde7bc4e9$var$kReading;
        $324f437bde7bc4e9$var$onEofChunk(stream, state);
    } else if ((state.state & $324f437bde7bc4e9$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $324f437bde7bc4e9$var$kEndEmitted) !== 0) $324f437bde7bc4e9$var$errorOrDestroy(stream, new $324f437bde7bc4e9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $324f437bde7bc4e9$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $324f437bde7bc4e9$var$errorOrDestroy(stream, new $324f437bde7bc4e9$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$324f437bde7bc4e9$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $324f437bde7bc4e9$var$addChunk(stream, state, chunk, false);
                else $324f437bde7bc4e9$var$maybeReadMore(stream, state);
            } else $324f437bde7bc4e9$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$324f437bde7bc4e9$var$kReading;
        $324f437bde7bc4e9$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $324f437bde7bc4e9$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $324f437bde7bc4e9$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $324f437bde7bc4e9$var$kNeedReadable) !== 0) $324f437bde7bc4e9$var$emitReadable(stream);
    }
    $324f437bde7bc4e9$var$maybeReadMore(stream, state);
}
$324f437bde7bc4e9$var$Readable.prototype.isPaused = function() {
    var state = this._readableState;
    return state[$324f437bde7bc4e9$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$324f437bde7bc4e9$var$Readable.prototype.setEncoding = function(enc) {
    var decoder = new $324f437bde7bc4e9$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    var buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    var content = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffer[$324f437bde7bc4e9$var$Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            content += decoder.write(data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
var $324f437bde7bc4e9$var$MAX_HWM = 0x40000000;
function $324f437bde7bc4e9$var$computeNewHighWaterMark(n) {
    if (n > $324f437bde7bc4e9$var$MAX_HWM) throw new $324f437bde7bc4e9$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $324f437bde7bc4e9$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $324f437bde7bc4e9$var$kObjectMode) !== 0) return 1;
    if ($324f437bde7bc4e9$var$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$324f437bde7bc4e9$var$Readable.prototype.read = function(n) {
    $324f437bde7bc4e9$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$324f437bde7bc4e9$var$NumberIsInteger(n)) n = $324f437bde7bc4e9$var$NumberParseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $324f437bde7bc4e9$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$324f437bde7bc4e9$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $324f437bde7bc4e9$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $324f437bde7bc4e9$var$endReadable(this);
        else $324f437bde7bc4e9$var$emitReadable(this);
        return null;
    }
    n = $324f437bde7bc4e9$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $324f437bde7bc4e9$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = (state.state & $324f437bde7bc4e9$var$kNeedReadable) !== 0;
    $324f437bde7bc4e9$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $324f437bde7bc4e9$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $324f437bde7bc4e9$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $324f437bde7bc4e9$var$debug('do read');
        state.state |= $324f437bde7bc4e9$var$kReading | $324f437bde7bc4e9$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $324f437bde7bc4e9$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $324f437bde7bc4e9$var$errorOrDestroy(this, err);
        }
        state.state &= ~$324f437bde7bc4e9$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $324f437bde7bc4e9$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $324f437bde7bc4e9$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $324f437bde7bc4e9$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $324f437bde7bc4e9$var$onEofChunk(stream, state) {
    $324f437bde7bc4e9$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $324f437bde7bc4e9$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $324f437bde7bc4e9$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $324f437bde7bc4e9$var$emitReadable(stream) {
    var state = stream._readableState;
    $324f437bde7bc4e9$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $324f437bde7bc4e9$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2Qkr5.nextTick($324f437bde7bc4e9$var$emitReadable_, stream);
    }
}
function $324f437bde7bc4e9$var$emitReadable_(stream) {
    var state = stream._readableState;
    $324f437bde7bc4e9$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $324f437bde7bc4e9$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $324f437bde7bc4e9$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $2Qkr5.nextTick($324f437bde7bc4e9$var$maybeReadMore_, stream, state);
    }
}
function $324f437bde7bc4e9$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $324f437bde7bc4e9$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$324f437bde7bc4e9$var$Readable.prototype._read = function(n) {
    throw new $324f437bde7bc4e9$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$324f437bde7bc4e9$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $324f437bde7bc4e9$var$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $324f437bde7bc4e9$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2Qkr5.stdout && dest !== $2Qkr5.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2Qkr5.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $324f437bde7bc4e9$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $324f437bde7bc4e9$var$debug('onend');
        dest.end();
    }
    var ondrain;
    var cleanedUp = false;
    function cleanup() {
        $324f437bde7bc4e9$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $324f437bde7bc4e9$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $324f437bde7bc4e9$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $324f437bde7bc4e9$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $324f437bde7bc4e9$var$debug('ondata');
        var ret = dest.write(chunk);
        $324f437bde7bc4e9$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $324f437bde7bc4e9$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            var s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $324f437bde7bc4e9$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $324f437bde7bc4e9$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $324f437bde7bc4e9$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $324f437bde7bc4e9$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $324f437bde7bc4e9$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $324f437bde7bc4e9$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $324f437bde7bc4e9$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $324f437bde7bc4e9$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters["delete"](dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$324f437bde7bc4e9$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(var i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    var index = $324f437bde7bc4e9$var$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$324f437bde7bc4e9$var$Readable.prototype.on = function(ev, fn) {
    var res = $324f437bde7bc4e9$var$Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $324f437bde7bc4e9$var$debug('on readable', state.length, state.reading);
            if (state.length) $324f437bde7bc4e9$var$emitReadable(this);
            else if (!state.reading) $2Qkr5.nextTick($324f437bde7bc4e9$var$nReadingNextTick, this);
        }
    }
    return res;
};
$324f437bde7bc4e9$var$Readable.prototype.addListener = $324f437bde7bc4e9$var$Readable.prototype.on;
$324f437bde7bc4e9$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $324f437bde7bc4e9$var$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($324f437bde7bc4e9$var$updateReadableListening, this);
    return res;
};
$324f437bde7bc4e9$var$Readable.prototype.off = $324f437bde7bc4e9$var$Readable.prototype.removeListener;
$324f437bde7bc4e9$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $324f437bde7bc4e9$var$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2Qkr5.nextTick($324f437bde7bc4e9$var$updateReadableListening, this);
    return res;
};
function $324f437bde7bc4e9$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$324f437bde7bc4e9$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $324f437bde7bc4e9$var$nReadingNextTick(self) {
    $324f437bde7bc4e9$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$324f437bde7bc4e9$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $324f437bde7bc4e9$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $324f437bde7bc4e9$var$resume(this, state);
    }
    state[$324f437bde7bc4e9$var$kPaused] = false;
    return this;
};
function $324f437bde7bc4e9$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2Qkr5.nextTick($324f437bde7bc4e9$var$resume_, stream, state);
    }
}
function $324f437bde7bc4e9$var$resume_(stream, state) {
    $324f437bde7bc4e9$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $324f437bde7bc4e9$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$324f437bde7bc4e9$var$Readable.prototype.pause = function() {
    $324f437bde7bc4e9$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $324f437bde7bc4e9$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$324f437bde7bc4e9$var$kPaused] = true;
    return this;
};
function $324f437bde7bc4e9$var$flow(stream) {
    var state = stream._readableState;
    $324f437bde7bc4e9$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$324f437bde7bc4e9$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', function(chunk) {
        if (!_this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', function() {
        _this.push(null);
    });
    stream.on('error', function(err) {
        $324f437bde7bc4e9$var$errorOrDestroy(_this, err);
    });
    stream.on('close', function() {
        _this.destroy();
    });
    stream.on('destroy', function() {
        _this.destroy();
    });
    this._read = function() {
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    var streamKeys = $324f437bde7bc4e9$var$ObjectKeys(stream);
    for(var j = 1; j < streamKeys.length; j++){
        var i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$324f437bde7bc4e9$var$Readable.prototype[$324f437bde7bc4e9$var$SymbolAsyncIterator] = function() {
    return $324f437bde7bc4e9$var$streamToAsyncIterator(this);
};
$324f437bde7bc4e9$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $324f437bde7bc4e9$require$validateObject(options, 'options');
    return $324f437bde7bc4e9$var$streamToAsyncIterator(this, options);
};
function $324f437bde7bc4e9$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $324f437bde7bc4e9$var$Readable.wrap(stream, {
        objectMode: true
    });
    var iter = $324f437bde7bc4e9$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
function $324f437bde7bc4e9$var$createAsyncIterator(stream, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
        var callback, error, cleanup, chunk, err;
        function next(resolve) {
            if (this === stream) {
                callback();
                callback = $324f437bde7bc4e9$var$nop;
            } else callback = resolve;
        }
        return (0, $9N5UN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callback = $324f437bde7bc4e9$var$nop;
                    stream.on('readable', next);
                    cleanup = $kAgPS(stream, {
                        writable: false
                    }, function(err) {
                        error = err ? $324f437bde7bc4e9$var$aggregateTwoErrors(error, err) : null;
                        callback();
                        callback = $324f437bde7bc4e9$var$nop;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        12
                    ]);
                    _state.label = 2;
                case 2:
                    if (!true) return [
                        3,
                        9
                    ];
                    chunk = stream.destroyed ? null : stream.read();
                    if (!(chunk !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        chunk
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!error) return [
                        3,
                        5
                    ];
                    throw error;
                case 5:
                    if (!(error === null)) return [
                        3,
                        6
                    ];
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        (0, $iw20L._)(new $324f437bde7bc4e9$var$Promise(next))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    error = $324f437bde7bc4e9$var$aggregateTwoErrors(error, err);
                    throw error;
                case 11:
                    if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $1frHX.destroyer(stream, null);
                    else {
                        stream.off('readable', next);
                        cleanup();
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$324f437bde7bc4e9$var$ObjectDefineProperties($324f437bde7bc4e9$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get: function() {
            var r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set: function(val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get: function() {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set: function(value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$324f437bde7bc4e9$var$ObjectDefineProperties($324f437bde7bc4e9$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get: function() {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get: function() {
            return this[$324f437bde7bc4e9$var$kPaused] !== false;
        },
        set: function(value) {
            this[$324f437bde7bc4e9$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$324f437bde7bc4e9$var$Readable._fromList = $324f437bde7bc4e9$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $324f437bde7bc4e9$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $324f437bde7bc4e9$var$endReadable(stream) {
    var state = stream._readableState;
    $324f437bde7bc4e9$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2Qkr5.nextTick($324f437bde7bc4e9$var$endReadableNT, state, stream);
    }
}
function $324f437bde7bc4e9$var$endReadableNT(state, stream) {
    $324f437bde7bc4e9$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $2Qkr5.nextTick($324f437bde7bc4e9$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            var wState = stream._writableState;
            var autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $324f437bde7bc4e9$var$endWritableNT(stream) {
    var writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$324f437bde7bc4e9$var$Readable.from = function(iterable, opts) {
    return $8iWwS($324f437bde7bc4e9$var$Readable, iterable, opts);
};
var $324f437bde7bc4e9$var$webStreamsAdapters;
// Lazy to avoid circular references
function $324f437bde7bc4e9$var$lazyWebStreams() {
    if ($324f437bde7bc4e9$var$webStreamsAdapters === undefined) $324f437bde7bc4e9$var$webStreamsAdapters = {};
    return $324f437bde7bc4e9$var$webStreamsAdapters;
}
$324f437bde7bc4e9$var$Readable.fromWeb = function(readableStream, options) {
    return $324f437bde7bc4e9$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$324f437bde7bc4e9$var$Readable.toWeb = function(streamReadable, options) {
    return $324f437bde7bc4e9$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$324f437bde7bc4e9$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $324f437bde7bc4e9$var$Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy: function(err, callback) {
            $1frHX.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("5Ze7g", function(module, exports) {
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $45bd9973480c8a4a$var$ArrayIsArray = $4eV73.ArrayIsArray, $45bd9973480c8a4a$var$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf;

var $bBoAO = parcelRequire("bBoAO");
var $45bd9973480c8a4a$var$EE = $bBoAO.EventEmitter;
function $45bd9973480c8a4a$var$Stream(opts) {
    $45bd9973480c8a4a$var$EE.call(this, opts);
}
$45bd9973480c8a4a$var$ObjectSetPrototypeOf($45bd9973480c8a4a$var$Stream.prototype, $45bd9973480c8a4a$var$EE.prototype);
$45bd9973480c8a4a$var$ObjectSetPrototypeOf($45bd9973480c8a4a$var$Stream, $45bd9973480c8a4a$var$EE);
$45bd9973480c8a4a$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($45bd9973480c8a4a$var$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $45bd9973480c8a4a$var$prependListener(source, 'error', onerror);
    $45bd9973480c8a4a$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $45bd9973480c8a4a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($45bd9973480c8a4a$var$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $45bd9973480c8a4a$var$Stream,
    prependListener: $45bd9973480c8a4a$var$prependListener
};

});

parcelRegister("jYKwv", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $e8b7b57731c9865c$export$e2db56ee53255a0; }, function (v) { return $e8b7b57731c9865c$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $e8b7b57731c9865c$export$11956e9313f43de0; }, function (v) { return $e8b7b57731c9865c$export$11956e9313f43de0 = v; });

var $3KZcf = parcelRequire("3KZcf");
var $e8b7b57731c9865c$export$e2db56ee53255a0;
var $e8b7b57731c9865c$export$11956e9313f43de0;
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $e8b7b57731c9865c$require$SymbolDispose = $4eV73.SymbolDispose;

var $8DZ5K = parcelRequire("8DZ5K");
var $e8b7b57731c9865c$var$AbortError = $8DZ5K.AbortError, $e8b7b57731c9865c$var$codes = $8DZ5K.codes;

var $2gPtE = parcelRequire("2gPtE");
var $e8b7b57731c9865c$var$isNodeStream = $2gPtE.isNodeStream, $e8b7b57731c9865c$var$isWebStream = $2gPtE.isWebStream, $e8b7b57731c9865c$var$kControllerErrorFunction = $2gPtE.kControllerErrorFunction;

var $kAgPS = parcelRequire("kAgPS");
var $e8b7b57731c9865c$var$ERR_INVALID_ARG_TYPE = $e8b7b57731c9865c$var$codes.ERR_INVALID_ARG_TYPE;
var $e8b7b57731c9865c$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
var $e8b7b57731c9865c$var$validateAbortSignal = function(signal, name) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) throw new $e8b7b57731c9865c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$e8b7b57731c9865c$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $e8b7b57731c9865c$var$validateAbortSignal(signal, 'signal');
    if (!$e8b7b57731c9865c$var$isNodeStream(stream) && !$e8b7b57731c9865c$var$isWebStream(stream)) throw new $e8b7b57731c9865c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $e8b7b57731c9865c$export$11956e9313f43de0(signal, stream);
};

$e8b7b57731c9865c$export$11956e9313f43de0 = function(signal, stream) {
    if ((typeof signal === "undefined" ? "undefined" : (0, $3KZcf._)(signal)) !== 'object' || !('aborted' in signal)) return stream;
    var onAbort = $e8b7b57731c9865c$var$isNodeStream(stream) ? function() {
        stream.destroy(new $e8b7b57731c9865c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    } : function() {
        stream[$e8b7b57731c9865c$var$kControllerErrorFunction](new $e8b7b57731c9865c$var$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $e8b7b57731c9865c$var$addAbortListener = $e8b7b57731c9865c$var$addAbortListener || (parcelRequire("7mxb7")).addAbortListener;
        var disposable = $e8b7b57731c9865c$var$addAbortListener(signal, onAbort);
        $kAgPS(stream, disposable[$e8b7b57731c9865c$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("gdrcQ", function(module, exports) {

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $bce2f6d2ac607911$var$StringPrototypeSlice = $4eV73.StringPrototypeSlice, $bce2f6d2ac607911$var$SymbolIterator = $4eV73.SymbolIterator, $bce2f6d2ac607911$var$TypedArrayPrototypeSet = $4eV73.TypedArrayPrototypeSet, $bce2f6d2ac607911$var$Uint8Array = $4eV73.Uint8Array;

var $1he7j = parcelRequire("1he7j");
var $bce2f6d2ac607911$require$Buffer = $1he7j.Buffer;

var $7mxb7 = parcelRequire("7mxb7");
var $bce2f6d2ac607911$require$inspect = $7mxb7.inspect;
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        (0, $jGAMp._)(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    (0, $byiyg._)(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while((p = p.next) !== null)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $bce2f6d2ac607911$require$Buffer.alloc(0);
                var ret = $bce2f6d2ac607911$require$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $bce2f6d2ac607911$var$TypedArrayPrototypeSet(ret, p.data, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes or characters from the buffered data.
            key: "consume",
            value: function consume(n, hasStrings) {
                var data = this.head.data;
                if (n < data.length) {
                    // `slice` is the same for buffers and strings.
                    var slice = data.slice(0, n);
                    this.head.data = data.slice(n);
                    return slice;
                }
                if (n === data.length) // First chunk is a perfect match.
                return this.shift();
                // Result spans more than one buffer.
                return hasStrings ? this._getString(n) : this._getBuffer(n);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: $bce2f6d2ac607911$var$SymbolIterator,
            value: function value() {
                var p;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            p = this.head;
                            _state.label = 1;
                        case 1:
                            if (!p) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                p.data
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            p = p.next;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            // Consumes a specified amount of characters from the buffered data.
            key: "_getString",
            value: function _getString(n) {
                var ret = '';
                var p = this.head;
                var c = 0;
                do {
                    var str = p.data;
                    if (n > str.length) {
                        ret += str;
                        n -= str.length;
                    } else {
                        if (n === str.length) {
                            ret += str;
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            ret += $bce2f6d2ac607911$var$StringPrototypeSlice(str, 0, n);
                            this.head = p;
                            p.data = $bce2f6d2ac607911$var$StringPrototypeSlice(str, n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Consumes a specified amount of bytes from the buffered data.
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $bce2f6d2ac607911$require$Buffer.allocUnsafe(n);
                var retLen = n;
                var p = this.head;
                var c = 0;
                do {
                    var buf = p.data;
                    if (n > buf.length) {
                        $bce2f6d2ac607911$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                        n -= buf.length;
                    } else {
                        if (n === buf.length) {
                            $bce2f6d2ac607911$var$TypedArrayPrototypeSet(ret, buf, retLen - n);
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            $bce2f6d2ac607911$var$TypedArrayPrototypeSet(ret, new $bce2f6d2ac607911$var$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                            this.head = p;
                            p.data = buf.slice(n);
                        }
                        break;
                    }
                    ++c;
                }while ((p = p.next) !== null);
                this.length -= c;
                return ret;
            }
        },
        {
            // Make sure the linked list only shows the minimal necessary information.
            key: Symbol["for"]('nodejs.util.inspect.custom'),
            value: function value(_, options) {
                return $bce2f6d2ac607911$require$inspect(this, (0, $emQHU._)((0, $iT0je._)({}, options), {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("l767L", function(module, exports) {
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $f5ef0091433eeb78$var$MathFloor = $4eV73.MathFloor, $f5ef0091433eeb78$var$NumberIsInteger = $4eV73.NumberIsInteger;

var $9vo7f = parcelRequire("9vo7f");
var $f5ef0091433eeb78$require$validateInteger = $9vo7f.validateInteger;

var $f5ef0091433eeb78$var$ERR_INVALID_ARG_VALUE = (parcelRequire("8DZ5K")).codes.ERR_INVALID_ARG_VALUE;
var $f5ef0091433eeb78$var$defaultHighWaterMarkBytes = 16384;
var $f5ef0091433eeb78$var$defaultHighWaterMarkObjectMode = 16;
function $f5ef0091433eeb78$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f5ef0091433eeb78$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f5ef0091433eeb78$var$defaultHighWaterMarkObjectMode : $f5ef0091433eeb78$var$defaultHighWaterMarkBytes;
}
function $f5ef0091433eeb78$var$setDefaultHighWaterMark(objectMode, value) {
    $f5ef0091433eeb78$require$validateInteger(value, 'value', 0);
    if (objectMode) $f5ef0091433eeb78$var$defaultHighWaterMarkObjectMode = value;
    else $f5ef0091433eeb78$var$defaultHighWaterMarkBytes = value;
}
function $f5ef0091433eeb78$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $f5ef0091433eeb78$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f5ef0091433eeb78$var$NumberIsInteger(hwm) || hwm < 0) {
            var name = isDuplex ? "options.".concat(duplexKey) : 'options.highWaterMark';
            throw new $f5ef0091433eeb78$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f5ef0091433eeb78$var$MathFloor(hwm);
    }
    // Default value
    return $f5ef0091433eeb78$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f5ef0091433eeb78$var$getHighWaterMark,
    getDefaultHighWaterMark: $f5ef0091433eeb78$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f5ef0091433eeb78$var$setDefaultHighWaterMark
};

});

parcelRegister("8iWwS", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4eV73 = parcelRequire("4eV73");
/* replacement end */ var $60bd67d7c5cb3f13$var$PromisePrototypeThen = $4eV73.PromisePrototypeThen, $60bd67d7c5cb3f13$var$SymbolAsyncIterator = $4eV73.SymbolAsyncIterator, $60bd67d7c5cb3f13$var$SymbolIterator = $4eV73.SymbolIterator;

var $1he7j = parcelRequire("1he7j");
var $60bd67d7c5cb3f13$require$Buffer = $1he7j.Buffer;

var $8DZ5K = parcelRequire("8DZ5K");
var $60bd67d7c5cb3f13$require$_require_codes = $8DZ5K.codes;
var $60bd67d7c5cb3f13$var$ERR_INVALID_ARG_TYPE = $60bd67d7c5cb3f13$require$_require_codes.ERR_INVALID_ARG_TYPE, $60bd67d7c5cb3f13$var$ERR_STREAM_NULL_VALUES = $60bd67d7c5cb3f13$require$_require_codes.ERR_STREAM_NULL_VALUES;
function $60bd67d7c5cb3f13$var$from(Readable, iterable, opts) {
    var iterator;
    if (typeof iterable === 'string' || iterable instanceof $60bd67d7c5cb3f13$require$Buffer) return new Readable((0, $emQHU._)((0, $iT0je._)({
        objectMode: true
    }, opts), {
        read: function() {
            this.push(iterable);
            this.push(null);
        }
    }));
    var isAsync;
    if (iterable && iterable[$60bd67d7c5cb3f13$var$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$60bd67d7c5cb3f13$var$SymbolAsyncIterator]();
    } else if (iterable && iterable[$60bd67d7c5cb3f13$var$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$60bd67d7c5cb3f13$var$SymbolIterator]();
    } else throw new $60bd67d7c5cb3f13$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    var readable = new Readable((0, $iT0je._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    var reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $60bd67d7c5cb3f13$var$PromisePrototypeThen(close(error), function() {
            return $2Qkr5.nextTick(cb, error);
        }, // nextTick is here in case cb throws
        function(e) {
            return $2Qkr5.nextTick(cb, e || error);
        });
    };
    function close(error) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var hadError, hasThrow, _ref, value, done, value1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hadError = error !== undefined && error !== null;
                        hasThrow = typeof iterator["throw"] === 'function';
                        if (!(hadError && hasThrow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            iterator["throw"](error)
                        ];
                    case 1:
                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                        return [
                            4,
                            value
                        ];
                    case 2:
                        _state.sent();
                        if (done) return [
                            2
                        ];
                        _state.label = 3;
                    case 3:
                        if (!(typeof iterator["return"] === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            iterator["return"]()
                        ];
                    case 4:
                        value1 = _state.sent().value;
                        return [
                            4,
                            value1
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function next() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _ref, value, done, _tmp, res, _tmp1, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        if (!isAsync) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            iterator.next()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = iterator.next();
                        _state.label = 3;
                    case 3:
                        _ref = _tmp, value = _ref.value, done = _ref.done;
                        if (!done) return [
                            3,
                            4
                        ];
                        readable.push(null);
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(value && typeof value.then === 'function')) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            value
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = value;
                        _state.label = 7;
                    case 7:
                        res = _tmp1;
                        if (res === null) {
                            reading = false;
                            throw new $60bd67d7c5cb3f13$var$ERR_STREAM_NULL_VALUES();
                        } else if (readable.push(res)) return [
                            3,
                            11
                        ];
                        else reading = false;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        err = _state.sent();
                        readable.destroy(err);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        return [
                            3,
                            0
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return readable;
}
module.exports = $60bd67d7c5cb3f13$var$from;

});


parcelRegister("2VGBJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $2Qkr5 = parcelRequire("2Qkr5");

var $4eV73 = parcelRequire("4eV73");
/* replacement end */ var $2221f4a3943ea44f$var$ArrayPrototypeSlice = $4eV73.ArrayPrototypeSlice, $2221f4a3943ea44f$var$Error = $4eV73.Error, $2221f4a3943ea44f$var$FunctionPrototypeSymbolHasInstance = $4eV73.FunctionPrototypeSymbolHasInstance, $2221f4a3943ea44f$var$ObjectDefineProperty = $4eV73.ObjectDefineProperty, $2221f4a3943ea44f$var$ObjectDefineProperties = $4eV73.ObjectDefineProperties, $2221f4a3943ea44f$var$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf, $2221f4a3943ea44f$var$StringPrototypeToLowerCase = $4eV73.StringPrototypeToLowerCase, $2221f4a3943ea44f$var$Symbol = $4eV73.Symbol, $2221f4a3943ea44f$var$SymbolHasInstance = $4eV73.SymbolHasInstance;
module.exports = $2221f4a3943ea44f$var$Writable;
$2221f4a3943ea44f$var$Writable.WritableState = $2221f4a3943ea44f$var$WritableState;

var $bBoAO = parcelRequire("bBoAO");
var $2221f4a3943ea44f$var$EE = $bBoAO.EventEmitter;

var $5Ze7g = parcelRequire("5Ze7g");
var $2221f4a3943ea44f$require$Stream = $5Ze7g.Stream;

var $1he7j = parcelRequire("1he7j");
var $2221f4a3943ea44f$require$Buffer = $1he7j.Buffer;

var $1frHX = parcelRequire("1frHX");

var $jYKwv = parcelRequire("jYKwv");
var $2221f4a3943ea44f$require$addAbortSignal = $jYKwv.addAbortSignal;

var $l767L = parcelRequire("l767L");
var $2221f4a3943ea44f$var$getHighWaterMark = $l767L.getHighWaterMark, $2221f4a3943ea44f$var$getDefaultHighWaterMark = $l767L.getDefaultHighWaterMark;

var $8DZ5K = parcelRequire("8DZ5K");
var $2221f4a3943ea44f$require$_require_codes = $8DZ5K.codes;
var $2221f4a3943ea44f$var$ERR_INVALID_ARG_TYPE = $2221f4a3943ea44f$require$_require_codes.ERR_INVALID_ARG_TYPE, $2221f4a3943ea44f$var$ERR_METHOD_NOT_IMPLEMENTED = $2221f4a3943ea44f$require$_require_codes.ERR_METHOD_NOT_IMPLEMENTED, $2221f4a3943ea44f$var$ERR_MULTIPLE_CALLBACK = $2221f4a3943ea44f$require$_require_codes.ERR_MULTIPLE_CALLBACK, $2221f4a3943ea44f$var$ERR_STREAM_CANNOT_PIPE = $2221f4a3943ea44f$require$_require_codes.ERR_STREAM_CANNOT_PIPE, $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED = $2221f4a3943ea44f$require$_require_codes.ERR_STREAM_DESTROYED, $2221f4a3943ea44f$var$ERR_STREAM_ALREADY_FINISHED = $2221f4a3943ea44f$require$_require_codes.ERR_STREAM_ALREADY_FINISHED, $2221f4a3943ea44f$var$ERR_STREAM_NULL_VALUES = $2221f4a3943ea44f$require$_require_codes.ERR_STREAM_NULL_VALUES, $2221f4a3943ea44f$var$ERR_STREAM_WRITE_AFTER_END = $2221f4a3943ea44f$require$_require_codes.ERR_STREAM_WRITE_AFTER_END, $2221f4a3943ea44f$var$ERR_UNKNOWN_ENCODING = $2221f4a3943ea44f$require$_require_codes.ERR_UNKNOWN_ENCODING;
var $2221f4a3943ea44f$var$errorOrDestroy = $1frHX.errorOrDestroy;
$2221f4a3943ea44f$var$ObjectSetPrototypeOf($2221f4a3943ea44f$var$Writable.prototype, $2221f4a3943ea44f$require$Stream.prototype);
$2221f4a3943ea44f$var$ObjectSetPrototypeOf($2221f4a3943ea44f$var$Writable, $2221f4a3943ea44f$require$Stream);
function $2221f4a3943ea44f$var$nop() {}
var $2221f4a3943ea44f$var$kOnFinished = $2221f4a3943ea44f$var$Symbol('kOnFinished');

function $2221f4a3943ea44f$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1HP2L"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $2221f4a3943ea44f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $2221f4a3943ea44f$var$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $2221f4a3943ea44f$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $2221f4a3943ea44f$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$2221f4a3943ea44f$var$kOnFinished] = [];
}
function $2221f4a3943ea44f$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$2221f4a3943ea44f$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $2221f4a3943ea44f$var$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$2221f4a3943ea44f$var$ObjectDefineProperty($2221f4a3943ea44f$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get: function() {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $2221f4a3943ea44f$var$Writable(options) {
    var _this = this;
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    var isDuplex = this instanceof (parcelRequire("1HP2L"));
    if (!isDuplex && !$2221f4a3943ea44f$var$FunctionPrototypeSymbolHasInstance($2221f4a3943ea44f$var$Writable, this)) return new $2221f4a3943ea44f$var$Writable(options);
    this._writableState = new $2221f4a3943ea44f$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $2221f4a3943ea44f$require$addAbortSignal(options.signal, this);
    }
    $2221f4a3943ea44f$require$Stream.call(this, options);
    $1frHX.construct(this, function() {
        var state = _this._writableState;
        if (!state.writing) $2221f4a3943ea44f$var$clearBuffer(_this, state);
        $2221f4a3943ea44f$var$finishMaybe(_this, state);
    });
}
$2221f4a3943ea44f$var$ObjectDefineProperty($2221f4a3943ea44f$var$Writable, $2221f4a3943ea44f$var$SymbolHasInstance, {
    __proto__: null,
    value: function value(object) {
        if ($2221f4a3943ea44f$var$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $2221f4a3943ea44f$var$Writable) return false;
        return object && object._writableState instanceof $2221f4a3943ea44f$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$2221f4a3943ea44f$var$Writable.prototype.pipe = function() {
    $2221f4a3943ea44f$var$errorOrDestroy(this, new $2221f4a3943ea44f$var$ERR_STREAM_CANNOT_PIPE());
};
function $2221f4a3943ea44f$var$_write(stream, chunk, encoding, cb) {
    var state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$2221f4a3943ea44f$require$Buffer.isEncoding(encoding)) throw new $2221f4a3943ea44f$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $2221f4a3943ea44f$var$nop;
    }
    if (chunk === null) throw new $2221f4a3943ea44f$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $2221f4a3943ea44f$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $2221f4a3943ea44f$require$Buffer) encoding = 'buffer';
        else if ($2221f4a3943ea44f$require$Stream._isUint8Array(chunk)) {
            chunk = $2221f4a3943ea44f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $2221f4a3943ea44f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    var err;
    if (state.ending) err = new $2221f4a3943ea44f$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $2Qkr5.nextTick(cb, err);
        $2221f4a3943ea44f$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $2221f4a3943ea44f$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$2221f4a3943ea44f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $2221f4a3943ea44f$var$_write(this, chunk, encoding, cb) === true;
};
$2221f4a3943ea44f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2221f4a3943ea44f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $2221f4a3943ea44f$var$clearBuffer(this, state);
    }
};
$2221f4a3943ea44f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $2221f4a3943ea44f$var$StringPrototypeToLowerCase(encoding);
    if (!$2221f4a3943ea44f$require$Buffer.isEncoding(encoding)) throw new $2221f4a3943ea44f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2221f4a3943ea44f$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    var ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $2221f4a3943ea44f$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $2221f4a3943ea44f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2221f4a3943ea44f$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $2221f4a3943ea44f$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $2221f4a3943ea44f$var$errorOrDestroy(stream, er);
}
function $2221f4a3943ea44f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') {
        $2221f4a3943ea44f$var$errorOrDestroy(stream, new $2221f4a3943ea44f$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $2Qkr5.nextTick($2221f4a3943ea44f$var$onwriteError, stream, state, er, cb);
        else $2221f4a3943ea44f$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $2221f4a3943ea44f$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $2Qkr5.nextTick($2221f4a3943ea44f$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $2221f4a3943ea44f$var$afterWrite(stream, state, 1, cb);
    }
}
function $2221f4a3943ea44f$var$afterWriteTick(param) {
    var stream = param.stream, state = param.state, count = param.count, cb = param.cb;
    state.afterWriteTickInfo = null;
    return $2221f4a3943ea44f$var$afterWrite(stream, state, count, cb);
}
function $2221f4a3943ea44f$var$afterWrite(stream, state, count, cb) {
    var needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $2221f4a3943ea44f$var$errorBuffer(state);
    $2221f4a3943ea44f$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $2221f4a3943ea44f$var$errorBuffer(state) {
    if (state.writing) return;
    for(var n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        var _state_buffered_n = state.buffered[n], chunk = _state_buffered_n.chunk, callback = _state_buffered_n.callback;
        var len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED('write'));
    }
    var onfinishCallbacks = state[$2221f4a3943ea44f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED('end'));
    }
    $2221f4a3943ea44f$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $2221f4a3943ea44f$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    var buffered = state.buffered, bufferedIndex = state.bufferedIndex, objectMode = state.objectMode;
    var bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    var i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        var callback = state.allNoop ? $2221f4a3943ea44f$var$nop : function(err) {
            for(var n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        var chunks = state.allNoop && i === 0 ? buffered : $2221f4a3943ea44f$var$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $2221f4a3943ea44f$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $2221f4a3943ea44f$var$resetBuffer(state);
    } else {
        do {
            var _buffered_i = buffered[i], chunk = _buffered_i.chunk, encoding = _buffered_i.encoding, callback1 = _buffered_i.callback;
            buffered[i++] = null;
            var len = objectMode ? 1 : chunk.length;
            $2221f4a3943ea44f$var$doWrite(stream, state, false, len, chunk, encoding, callback1);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $2221f4a3943ea44f$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$2221f4a3943ea44f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $2221f4a3943ea44f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$2221f4a3943ea44f$var$Writable.prototype._writev = null;
$2221f4a3943ea44f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    var err;
    if (chunk !== null && chunk !== undefined) {
        var ret = $2221f4a3943ea44f$var$_write(this, chunk, encoding);
        if (ret instanceof $2221f4a3943ea44f$var$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $2221f4a3943ea44f$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $2221f4a3943ea44f$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $2221f4a3943ea44f$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $2Qkr5.nextTick(cb, err);
        else state[$2221f4a3943ea44f$var$kOnFinished].push(cb);
    }
    return this;
};
function $2221f4a3943ea44f$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $2221f4a3943ea44f$var$callFinal(stream, state) {
    var called = false;
    function onFinish(err) {
        if (called) {
            $2221f4a3943ea44f$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $2221f4a3943ea44f$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            var onfinishCallbacks = state[$2221f4a3943ea44f$var$kOnFinished].splice(0);
            for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $2221f4a3943ea44f$var$errorOrDestroy(stream, err, state.sync);
        } else if ($2221f4a3943ea44f$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $2Qkr5.nextTick($2221f4a3943ea44f$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $2221f4a3943ea44f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $2221f4a3943ea44f$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2221f4a3943ea44f$var$finishMaybe(stream, state, sync) {
    if ($2221f4a3943ea44f$var$needFinish(state)) {
        $2221f4a3943ea44f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $2Qkr5.nextTick(function(stream, state) {
                    if ($2221f4a3943ea44f$var$needFinish(state)) $2221f4a3943ea44f$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($2221f4a3943ea44f$var$needFinish(state)) {
                state.pendingcb++;
                $2221f4a3943ea44f$var$finish(stream, state);
            }
        }
    }
}
function $2221f4a3943ea44f$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    var onfinishCallbacks = state[$2221f4a3943ea44f$var$kOnFinished].splice(0);
    for(var i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        var rState = stream._readableState;
        var autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$2221f4a3943ea44f$var$ObjectDefineProperties($2221f4a3943ea44f$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set: function(value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get: function() {
            var w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set: function(val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get: function() {
            var wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get: function() {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get: function() {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function get() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
var $2221f4a3943ea44f$var$destroy = $1frHX.destroy;
$2221f4a3943ea44f$var$Writable.prototype.destroy = function(err, cb) {
    var state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$2221f4a3943ea44f$var$kOnFinished].length)) $2Qkr5.nextTick($2221f4a3943ea44f$var$errorBuffer, state);
    $2221f4a3943ea44f$var$destroy.call(this, err, cb);
    return this;
};
$2221f4a3943ea44f$var$Writable.prototype._undestroy = $1frHX.undestroy;
$2221f4a3943ea44f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$2221f4a3943ea44f$var$Writable.prototype[$2221f4a3943ea44f$var$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
var $2221f4a3943ea44f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $2221f4a3943ea44f$var$lazyWebStreams() {
    if ($2221f4a3943ea44f$var$webStreamsAdapters === undefined) $2221f4a3943ea44f$var$webStreamsAdapters = {};
    return $2221f4a3943ea44f$var$webStreamsAdapters;
}
$2221f4a3943ea44f$var$Writable.fromWeb = function(writableStream, options) {
    return $2221f4a3943ea44f$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$2221f4a3943ea44f$var$Writable.toWeb = function(streamWritable) {
    return $2221f4a3943ea44f$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("66jzT", function(module, exports) {
/* replacement start */ 
var $b8tVf = parcelRequire("b8tVf");

var $iw20L = parcelRequire("iw20L");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $i3fW3 = parcelRequire("i3fW3");

var $3KZcf = parcelRequire("3KZcf");

var $75utm = parcelRequire("75utm");

var $9N5UN = parcelRequire("9N5UN");

var $2Qkr5 = parcelRequire("2Qkr5");
'use strict';

var $1he7j = parcelRequire("1he7j");

var $2gPtE = parcelRequire("2gPtE");
var $47127d655ae4ae3e$var$isReadable = $2gPtE.isReadable, $47127d655ae4ae3e$var$isWritable = $2gPtE.isWritable, $47127d655ae4ae3e$var$isIterable = $2gPtE.isIterable, $47127d655ae4ae3e$var$isNodeStream = $2gPtE.isNodeStream, $47127d655ae4ae3e$var$isReadableNodeStream = $2gPtE.isReadableNodeStream, $47127d655ae4ae3e$var$isWritableNodeStream = $2gPtE.isWritableNodeStream, $47127d655ae4ae3e$var$isDuplexNodeStream = $2gPtE.isDuplexNodeStream, $47127d655ae4ae3e$var$isReadableStream = $2gPtE.isReadableStream, $47127d655ae4ae3e$var$isWritableStream = $2gPtE.isWritableStream;

var $kAgPS = parcelRequire("kAgPS");

var $8DZ5K = parcelRequire("8DZ5K");
var $47127d655ae4ae3e$var$AbortError = $8DZ5K.AbortError, $47127d655ae4ae3e$var$_require_codes = $8DZ5K.codes, $47127d655ae4ae3e$var$ERR_INVALID_ARG_TYPE = $47127d655ae4ae3e$var$_require_codes.ERR_INVALID_ARG_TYPE, $47127d655ae4ae3e$var$ERR_INVALID_RETURN_VALUE = $47127d655ae4ae3e$var$_require_codes.ERR_INVALID_RETURN_VALUE;

var $1frHX = parcelRequire("1frHX");
var $47127d655ae4ae3e$require$destroyer = $1frHX.destroyer;

var $1HP2L = parcelRequire("1HP2L");

var $4jNps = parcelRequire("4jNps");

var $2VGBJ = parcelRequire("2VGBJ");

var $7mxb7 = parcelRequire("7mxb7");
var $47127d655ae4ae3e$require$createDeferredPromise = $7mxb7.createDeferredPromise;

var $8iWwS = parcelRequire("8iWwS");
var $47127d655ae4ae3e$var$Blob = globalThis.Blob || $1he7j.Blob;
var $47127d655ae4ae3e$var$isBlob = typeof $47127d655ae4ae3e$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $47127d655ae4ae3e$var$Blob;
} : function isBlob(b) {
    return false;
};

var $47127d655ae4ae3e$var$AbortController = globalThis.AbortController || (parcelRequire("6an3P")).AbortController;

var $4eV73 = parcelRequire("4eV73");
var $47127d655ae4ae3e$require$FunctionPrototypeCall = $4eV73.FunctionPrototypeCall;
// This is needed for pre node 17.
var $47127d655ae4ae3e$var$Duplexify = /*#__PURE__*/ function(Duplex) {
    "use strict";
    (0, $i3fW3._)(Duplexify, Duplex);
    function Duplexify(options) {
        (0, $jGAMp._)(this, Duplexify);
        var _this;
        _this = (0, $kzDuW._)(this, Duplexify, [
            options
        ]);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            _this._readableState.readable = false;
            _this._readableState.ended = true;
            _this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            _this._writableState.writable = false;
            _this._writableState.ending = true;
            _this._writableState.ended = true;
            _this._writableState.finished = true;
        }
        return _this;
    }
    return Duplexify;
}($1HP2L);
module.exports = function duplexify(body, name) {
    if ($47127d655ae4ae3e$var$isDuplexNodeStream(body)) return body;
    if ($47127d655ae4ae3e$var$isReadableNodeStream(body)) return $47127d655ae4ae3e$var$_duplexify({
        readable: body
    });
    if ($47127d655ae4ae3e$var$isWritableNodeStream(body)) return $47127d655ae4ae3e$var$_duplexify({
        writable: body
    });
    if ($47127d655ae4ae3e$var$isNodeStream(body)) return $47127d655ae4ae3e$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($47127d655ae4ae3e$var$isReadableStream(body)) return $47127d655ae4ae3e$var$_duplexify({
        readable: $4jNps.fromWeb(body)
    });
    if ($47127d655ae4ae3e$var$isWritableStream(body)) return $47127d655ae4ae3e$var$_duplexify({
        writable: $2VGBJ.fromWeb(body)
    });
    if (typeof body === 'function') {
        var _fromAsyncGen = $47127d655ae4ae3e$var$fromAsyncGen(body), value = _fromAsyncGen.value, write = _fromAsyncGen.write, _final = _fromAsyncGen["final"], destroy = _fromAsyncGen.destroy;
        if ($47127d655ae4ae3e$var$isIterable(value)) return $8iWwS($47127d655ae4ae3e$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: _final,
            destroy: destroy
        });
        var then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            var d;
            var promise = $47127d655ae4ae3e$require$FunctionPrototypeCall(then, value, function(val) {
                if (val != null) throw new $47127d655ae4ae3e$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, function(err) {
                $47127d655ae4ae3e$require$destroyer(d, err);
            });
            return d = new $47127d655ae4ae3e$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final: function(cb) {
                    _final(function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            var err;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            promise
                                        ];
                                    case 1:
                                        _state.sent();
                                        $2Qkr5.nextTick(cb, null);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        $2Qkr5.nextTick(cb, err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                },
                destroy: destroy
            });
        }
        throw new $47127d655ae4ae3e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($47127d655ae4ae3e$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($47127d655ae4ae3e$var$isIterable(body)) return $8iWwS($47127d655ae4ae3e$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($47127d655ae4ae3e$var$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $47127d655ae4ae3e$var$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $47127d655ae4ae3e$var$Duplexify.fromWeb(body);
    if ((0, $3KZcf._)(body === null || body === undefined ? undefined : body.writable) === 'object' || (0, $3KZcf._)(body === null || body === undefined ? undefined : body.readable) === 'object') {
        var readable = body !== null && body !== undefined && body.readable ? $47127d655ae4ae3e$var$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        var writable = body !== null && body !== undefined && body.writable ? $47127d655ae4ae3e$var$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $47127d655ae4ae3e$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    var then1 = body === null || body === undefined ? undefined : body.then;
    if (typeof then1 === 'function') {
        var d1;
        $47127d655ae4ae3e$require$FunctionPrototypeCall(then1, body, function(val) {
            if (val != null) d1.push(val);
            d1.push(null);
        }, function(err) {
            $47127d655ae4ae3e$require$destroyer(d1, err);
        });
        return d1 = new $47127d655ae4ae3e$var$Duplexify({
            objectMode: true,
            writable: false,
            read: function() {}
        });
    }
    throw new $47127d655ae4ae3e$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $47127d655ae4ae3e$var$fromAsyncGen(fn) {
    var _createDeferredPromise = $47127d655ae4ae3e$require$createDeferredPromise(), promise = _createDeferredPromise.promise, resolve = _createDeferredPromise.resolve;
    var ac = new $47127d655ae4ae3e$var$AbortController();
    var signal = ac.signal;
    var value = fn(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $75utm._)(function() {
            var _promise, _ref, chunk, done, cb, ref;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!true) return [
                            3,
                            3
                        ];
                        _promise = promise;
                        promise = null;
                        return [
                            4,
                            (0, $iw20L._)(_promise)
                        ];
                    case 1:
                        _ref = _state.sent(), chunk = _ref.chunk, done = _ref.done, cb = _ref.cb;
                        $2Qkr5.nextTick(cb);
                        if (done) return [
                            2
                        ];
                        if (signal.aborted) throw new $47127d655ae4ae3e$var$AbortError(undefined, {
                            cause: signal.reason
                        });
                        ref = $47127d655ae4ae3e$require$createDeferredPromise(), promise = ref.promise, resolve = ref.resolve, ref;
                        return [
                            4,
                            chunk
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }(), {
        signal: signal
    });
    return {
        value: value,
        write: function(chunk, encoding, cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final: function(cb) {
            var _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy: function(err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $47127d655ae4ae3e$var$_duplexify(pair) {
    var r = pair.readable && typeof pair.readable.read !== 'function' ? $4jNps.wrap(pair.readable) : pair.readable;
    var w = pair.writable;
    var readable = !!$47127d655ae4ae3e$var$isReadable(r);
    var writable = !!$47127d655ae4ae3e$var$isWritable(w);
    var ondrain;
    var onfinish;
    var onreadable;
    var onclose;
    var d;
    function onfinished(err) {
        var cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $47127d655ae4ae3e$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $kAgPS(w, function(err) {
            writable = false;
            if (err) $47127d655ae4ae3e$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                var cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                var cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $kAgPS(r, function(err) {
            readable = false;
            if (err) $47127d655ae4ae3e$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                var cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                var buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $47127d655ae4ae3e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $47127d655ae4ae3e$require$destroyer(w, err);
            $47127d655ae4ae3e$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("4AOZp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $358213a77ad34b18$require$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf;
module.exports = $358213a77ad34b18$var$PassThrough;

var $fGBRz = parcelRequire("fGBRz");
$358213a77ad34b18$require$ObjectSetPrototypeOf($358213a77ad34b18$var$PassThrough.prototype, $fGBRz.prototype);
$358213a77ad34b18$require$ObjectSetPrototypeOf($358213a77ad34b18$var$PassThrough, $fGBRz);
function $358213a77ad34b18$var$PassThrough(options) {
    if (!(this instanceof $358213a77ad34b18$var$PassThrough)) return new $358213a77ad34b18$var$PassThrough(options);
    $fGBRz.call(this, options);
}
$358213a77ad34b18$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("fGBRz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $b6b8260f9d621915$var$ObjectSetPrototypeOf = $4eV73.ObjectSetPrototypeOf, $b6b8260f9d621915$var$Symbol = $4eV73.Symbol;
module.exports = $b6b8260f9d621915$var$Transform;

var $b6b8260f9d621915$var$ERR_METHOD_NOT_IMPLEMENTED = (parcelRequire("8DZ5K")).codes.ERR_METHOD_NOT_IMPLEMENTED;

var $1HP2L = parcelRequire("1HP2L");

var $l767L = parcelRequire("l767L");
var $b6b8260f9d621915$require$getHighWaterMark = $l767L.getHighWaterMark;
$b6b8260f9d621915$var$ObjectSetPrototypeOf($b6b8260f9d621915$var$Transform.prototype, $1HP2L.prototype);
$b6b8260f9d621915$var$ObjectSetPrototypeOf($b6b8260f9d621915$var$Transform, $1HP2L);
var $b6b8260f9d621915$var$kCallback = $b6b8260f9d621915$var$Symbol('kCallback');
function $b6b8260f9d621915$var$Transform(options) {
    if (!(this instanceof $b6b8260f9d621915$var$Transform)) return new $b6b8260f9d621915$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    var readableHighWaterMark = options ? $b6b8260f9d621915$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $emQHU._)((0, $iT0je._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1HP2L.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$b6b8260f9d621915$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $b6b8260f9d621915$var$prefinish);
}
function $b6b8260f9d621915$var$_final(cb) {
    var _this = this;
    if (typeof this._flush === 'function' && !this.destroyed) this._flush(function(er, data) {
        if (er) {
            if (cb) cb(er);
            else _this.destroy(er);
            return;
        }
        if (data != null) _this.push(data);
        _this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $b6b8260f9d621915$var$prefinish() {
    if (this._final !== $b6b8260f9d621915$var$_final) $b6b8260f9d621915$var$_final.call(this);
}
$b6b8260f9d621915$var$Transform.prototype._final = $b6b8260f9d621915$var$_final;
$b6b8260f9d621915$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $b6b8260f9d621915$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$b6b8260f9d621915$var$Transform.prototype._write = function(chunk, encoding, callback) {
    var _this = this;
    var rState = this._readableState;
    var wState = this._writableState;
    var length = rState.length;
    this._transform(chunk, encoding, function(err, val) {
        if (err) {
            callback(err);
            return;
        }
        if (val != null) _this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else _this[$b6b8260f9d621915$var$kCallback] = callback;
    });
};
$b6b8260f9d621915$var$Transform.prototype._read = function() {
    if (this[$b6b8260f9d621915$var$kCallback]) {
        var callback = this[$b6b8260f9d621915$var$kCallback];
        this[$b6b8260f9d621915$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("cI9Iq", function(module, exports) {

var $3KZcf = parcelRequire("3KZcf");
'use strict';

var $4eV73 = parcelRequire("4eV73");
var $941121647101792d$var$ArrayPrototypePop = $4eV73.ArrayPrototypePop, $941121647101792d$var$Promise = $4eV73.Promise;

var $2gPtE = parcelRequire("2gPtE");
var $941121647101792d$var$isIterable = $2gPtE.isIterable, $941121647101792d$var$isNodeStream = $2gPtE.isNodeStream, $941121647101792d$var$isWebStream = $2gPtE.isWebStream;

var $aILEd = parcelRequire("aILEd");
var $941121647101792d$var$pl = $aILEd.pipelineImpl;

var $kAgPS = parcelRequire("kAgPS");
var $941121647101792d$require$finished = $kAgPS.finished;
parcelRequire("axoyE");
function $941121647101792d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    return new $941121647101792d$var$Promise(function(resolve, reject) {
        var signal;
        var end;
        var lastArg = streams[streams.length - 1];
        if (lastArg && (typeof lastArg === "undefined" ? "undefined" : (0, $3KZcf._)(lastArg)) === 'object' && !$941121647101792d$var$isNodeStream(lastArg) && !$941121647101792d$var$isIterable(lastArg) && !$941121647101792d$var$isWebStream(lastArg)) {
            var options = $941121647101792d$var$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $941121647101792d$var$pl(streams, function(err, value) {
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $941121647101792d$require$finished,
    pipeline: $941121647101792d$var$pipeline
};

});





parcelRegister("k91fE", function(module, exports) {
"use strict";
var $eaa59e68849f46cd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eaa59e68849f46cd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eaa59e68849f46cd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$eaa59e68849f46cd$var$__exportStar((parcelRequire("lj9Ou")), module.exports);

});
parcelRegister("lj9Ou", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiBindSource = void 0;

var $17TpP = parcelRequire("17TpP");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $kQuvF = parcelRequire("kQuvF");

var $2n9RU = parcelRequire("2n9RU");

var $aafx9 = parcelRequire("aafx9");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Inner Multi Bind Source RDF Join Actor.
 */ var $f832fc0f45c10232$var$ActorRdfJoinMultiBindSource = /*#__PURE__*/ function(_bus_rdf_join_1_ActorRdfJoin) {
    (0, $i3fW3._)(ActorRdfJoinMultiBindSource, _bus_rdf_join_1_ActorRdfJoin);
    function ActorRdfJoinMultiBindSource(args) {
        (0, $jGAMp._)(this, ActorRdfJoinMultiBindSource);
        return (0, $kzDuW._)(this, ActorRdfJoinMultiBindSource, [
            args,
            {
                logicalType: 'inner',
                physicalName: 'bind-source',
                canHandleUndefs: true
            }
        ]);
    }
    (0, $byiyg._)(ActorRdfJoinMultiBindSource, [
        {
            key: "getOutput",
            value: function getOutput(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, dataFactory, algebraFactory, entries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, element, smallestStream, smallestMetadata, remainingEntries, sourceWrapper, operation, chunkedStreams, bindingsStream;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        _this = this;
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
                        entries = sideData.entriesSorted;
                        this.logDebug(action.context, 'First entry for Bind Join Source: ', function() {
                            return {
                                entry: entries[0].operation,
                                cardinality: entries[0].metadata.cardinality,
                                order: entries[0].metadata.order,
                                availableOrders: entries[0].metadata.availableOrders
                            };
                        });
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // Close the non-smallest streams
                            for(_iterator = entries.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $32TW8._)(_step.value, 2), i = _step_value[0], element = _step_value[1];
                                if (i !== 0) element.output.bindingsStream.close();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Take the stream with the lowest cardinality
                        smallestStream = entries[0].output;
                        smallestMetadata = entries[0].metadata;
                        remainingEntries = (0, $7WNf6._)(entries);
                        remainingEntries.splice(0, 1);
                        // Get source for remaining entries (guaranteed thanks to prior check in getJoinCoefficients())
                        sourceWrapper = (0, $2n9RU.getOperationSource)(remainingEntries[0].operation);
                        // Determine the operation to pass
                        operation = this.createOperationFromEntries(algebraFactory, remainingEntries);
                        // Slice the smallest stream into chunks according to the block size, so we avoid blocking too long.
                        chunkedStreams = new $kQuvF.ChunkedIterator(smallestStream.bindingsStream, this.blockSize, {
                            autoStart: false
                        });
                        // For each chunk, pass the query and the bindings to the source for execution
                        bindingsStream = new $aafx9.UnionIterator(chunkedStreams.map(function(chunk) {
                            return sourceWrapper.source.queryBindings(operation, sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context, {
                                joinBindings: {
                                    bindings: chunk,
                                    metadata: smallestMetadata
                                }
                            });
                        }));
                        return [
                            2,
                            {
                                result: {
                                    type: 'bindings',
                                    bindingsStream: bindingsStream,
                                    metadata: function() {
                                        return _this.constructResultMetadata(entries, entries.map(function(entry) {
                                            return entry.metadata;
                                        }), action.context);
                                    }
                                },
                                physicalPlanMetadata: {
                                    bindIndex: sideData.entriesUnsorted.indexOf(entries[0])
                                }
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "sortJoinEntries",
            value: function sortJoinEntries(entries, context) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var entriesTest;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $17TpP.ActorRdfJoin.sortJoinEntries(this.mediatorJoinEntriesSort, entries, context)
                                ];
                            case 1:
                                entriesTest = _state.sent();
                                if (entriesTest.isFailed()) return [
                                    2,
                                    entriesTest
                                ];
                                entries = entriesTest.get();
                                // Prioritize entries with modified operations, so these are not re-executed
                                entries = entries.sort(function(entryLeft, entryRight) {
                                    if (entryLeft.operationModified && !entryRight.operationModified) return -1;
                                    return 0;
                                });
                                return [
                                    2,
                                    (0, $kNNoa.passTest)(entries)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getJoinCoefficients",
            value: function getJoinCoefficients(action, sideData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _this, metadatas, dataFactory, algebraFactory, entriesUnsorted, entriesTest, entriesSorted, requestInitialTimes, requestItemTimes, remainingEntries, remainingRequestInitialTimes, remainingRequestItemTimes, sources, sourceWrapper, testingOperation, selectorShape, selectivities, cardinalityRemaining;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                metadatas = sideData.metadatas;
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
                                entriesUnsorted = action.entries.map(function(entry, i) {
                                    return (0, $emQHU._)((0, $iT0je._)({}, entry), {
                                        metadata: metadatas[i]
                                    });
                                });
                                return [
                                    4,
                                    this.sortJoinEntries(entriesUnsorted, action.context)
                                ];
                            case 1:
                                entriesTest = _state.sent();
                                if (entriesTest.isFailed()) return [
                                    2,
                                    entriesTest
                                ];
                                entriesSorted = entriesTest.get();
                                metadatas = entriesSorted.map(function(entry) {
                                    return entry.metadata;
                                });
                                requestInitialTimes = $17TpP.ActorRdfJoin.getRequestInitialTimes(metadatas);
                                requestItemTimes = $17TpP.ActorRdfJoin.getRequestItemTimes(metadatas);
                                // Determine first stream and remaining ones
                                remainingEntries = (0, $7WNf6._)(entriesSorted);
                                remainingRequestInitialTimes = (0, $7WNf6._)(requestInitialTimes);
                                remainingRequestItemTimes = (0, $7WNf6._)(requestItemTimes);
                                remainingEntries.splice(0, 1);
                                remainingRequestInitialTimes.splice(0, 1);
                                remainingRequestItemTimes.splice(0, 1);
                                // Reject binding on operations without sources
                                sources = remainingEntries.map(function(entry) {
                                    return (0, $2n9RU.getOperationSource)(entry.operation);
                                });
                                if (sources.some(function(source) {
                                    return !source;
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not bind on remaining operations without source annotation"))
                                ];
                                // Reject binding on operations with un-equal sources
                                if (sources.some(function(source) {
                                    return source !== sources[0];
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " can not bind on remaining operations with non-equal source annotation"))
                                ];
                                // Reject if the source can not handle bindings
                                sourceWrapper = sources[0];
                                testingOperation = this.createOperationFromEntries(algebraFactory, remainingEntries);
                                return [
                                    4,
                                    sourceWrapper.source.getSelectorShape(action.context)
                                ];
                            case 2:
                                selectorShape = _state.sent();
                                if (!(0, $2n9RU.doesShapeAcceptOperation)(selectorShape, testingOperation, {
                                    joinBindings: true
                                })) return [
                                    2,
                                    (0, $kNNoa.failTest)("Actor ".concat(this.name, " detected a source that can not handle passing down join bindings"))
                                ];
                                return [
                                    4,
                                    Promise.all(remainingEntries.map(function(entry) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                                            return (0, $9N5UN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.mediatorJoinSelectivity.mediate({
                                                                entries: [
                                                                    entriesSorted[0],
                                                                    entry
                                                                ],
                                                                context: action.context
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent().selectivity * this.selectivityModifier
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }))
                                ];
                            case 3:
                                selectivities = _state.sent();
                                // Determine coefficients for remaining entries
                                cardinalityRemaining = remainingEntries.map(function(entry, i) {
                                    return entry.metadata.cardinality.value * selectivities[i];
                                }).reduce(function(sum, element) {
                                    return sum + element;
                                }, 0);
                                return [
                                    2,
                                    (0, $kNNoa.passTestWithSideData)({
                                        iterations: 1,
                                        persistedItems: metadatas[0].cardinality.value,
                                        blockingItems: metadatas[0].cardinality.value,
                                        requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + cardinalityRemaining * requestItemTimes[1]
                                    }, (0, $emQHU._)((0, $iT0je._)({}, sideData), {
                                        entriesUnsorted: entriesUnsorted,
                                        entriesSorted: entriesSorted
                                    }))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createOperationFromEntries",
            value: function createOperationFromEntries(algebraFactory, remainingEntries) {
                if (remainingEntries.length === 1) return remainingEntries[0].operation;
                return algebraFactory.createJoin(remainingEntries.map(function(entry) {
                    return entry.operation;
                }), true);
            }
        }
    ]);
    return ActorRdfJoinMultiBindSource;
}($17TpP.ActorRdfJoin);
module.exports.ActorRdfJoinMultiBindSource = $f832fc0f45c10232$var$ActorRdfJoinMultiBindSource;

});


parcelRegister("ifXoQ", function(module, exports) {
"use strict";
var $d4a7b43f598d48ef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d4a7b43f598d48ef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d4a7b43f598d48ef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d4a7b43f598d48ef$var$__exportStar((parcelRequire("4J9Os")), module.exports);

});
parcelRegister("4J9Os", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationJoinConnected = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Join Connected Optimize Query Operation Actor.
 */ var $3712fa06b456db9b$var$ActorOptimizeQueryOperationJoinConnected = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationJoinConnected, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationJoinConnected() {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationJoinConnected);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationJoinConnected, arguments);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationJoinConnected, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, {
                            join: function(op, factory) {
                                return {
                                    recurse: false,
                                    result: ActorOptimizeQueryOperationJoinConnected.cluster(op, factory)
                                };
                            }
                        }, algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "cluster",
            value: /**
     * Iteratively cluster join entries based on their overlapping variables.
     * @param op A join operation.
     * @param factory An algebra factory.
     */ function cluster(op, factory) {
                // Initialize each entry to be in a separate cluster
                var initialClusters = op.input.map(function(subOp) {
                    return {
                        inScopeVariables: Object.fromEntries($hSHd8.Util.inScopeVariables(subOp).map(function(variable) {
                            return [
                                variable.value,
                                true
                            ];
                        })),
                        entries: [
                            subOp
                        ]
                    };
                });
                // Iteratively merge clusters until they don't change anymore
                var oldClusters;
                var newClusters = initialClusters;
                do {
                    oldClusters = newClusters;
                    newClusters = ActorOptimizeQueryOperationJoinConnected.clusterIteration(oldClusters);
                }while (oldClusters.length !== newClusters.length);
                // Create new join operation of latest clusters
                var subJoins = newClusters.map(function(cluster) {
                    return cluster.entries.length === 1 ? cluster.entries[0] : factory.createJoin(cluster.entries);
                });
                return subJoins.length === 1 ? subJoins[0] : factory.createJoin(subJoins, false);
            }
        },
        {
            key: "clusterIteration",
            value: /**
     * Perform a single clustering iteration.
     * Clusters will be joined if they have overlapping variables.
     * @param oldCluster
     */ function clusterIteration(oldCluster) {
                var newClusters = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = oldCluster[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        // Try to add entry to a join cluster
                        var joined = false;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = newClusters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var newEntry = _step1.value;
                                if (ActorOptimizeQueryOperationJoinConnected.haveOverlappingVariables(entry.inScopeVariables, newEntry.inScopeVariables)) {
                                    newEntry.entries = (0, $7WNf6._)(newEntry.entries).concat((0, $7WNf6._)(entry.entries));
                                    newEntry.inScopeVariables = (0, $iT0je._)({}, newEntry.inScopeVariables, entry.inScopeVariables);
                                    joined = true;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        // If none was found, create new cluster
                        if (!joined) newClusters.push({
                            inScopeVariables: entry.inScopeVariables,
                            entries: entry.entries
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newClusters;
            }
        },
        {
            key: "haveOverlappingVariables",
            value: /**
     * Check if the two given variable objects are overlapping.
     * @param variablesA A variables objects.
     * @param variablesB A variables objects.
     */ function haveOverlappingVariables(variablesA, variablesB) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(variablesA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var variableA = _step.value;
                        if (variablesB[variableA]) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        }
    ]);
    return ActorOptimizeQueryOperationJoinConnected;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationJoinConnected = $3712fa06b456db9b$var$ActorOptimizeQueryOperationJoinConnected;

});


parcelRegister("b79U3", function(module, exports) {
"use strict";
var $817807b63f5c6a73$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $817807b63f5c6a73$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $817807b63f5c6a73$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$817807b63f5c6a73$var$__exportStar((parcelRequire("2QXhM")), module.exports);

});
parcelRegister("2QXhM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationBgpToJoin = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica BGP to Join Optimize Query Operation Actor.
 */ var $213e6cffd27328c1$var$ActorOptimizeQueryOperationBgpToJoin = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationBgpToJoin, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationBgpToJoin() {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationBgpToJoin);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationBgpToJoin, arguments);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationBgpToJoin, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, {
                            bgp: function(op, factory) {
                                return {
                                    recurse: false,
                                    result: factory.createJoin(op.patterns)
                                };
                            }
                        }, algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationBgpToJoin;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationBgpToJoin = $213e6cffd27328c1$var$ActorOptimizeQueryOperationBgpToJoin;

});


parcelRegister("2FQJB", function(module, exports) {
"use strict";
var $1f28511be1d6e8c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1f28511be1d6e8c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1f28511be1d6e8c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1f28511be1d6e8c8$var$__exportStar((parcelRequire("h2aMo")), module.exports);

});
parcelRegister("h2aMo", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationJoinBgp = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Join BGP Optimize Query Operation Actor.
 */ var $c66afc271d449e9a$var$ActorOptimizeQueryOperationJoinBgp = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationJoinBgp, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationJoinBgp() {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationJoinBgp);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationJoinBgp, arguments);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationJoinBgp, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operation = $hSHd8.Util.mapOperation(action.operation, {
                            join: function(op, factory) {
                                if (op.input.every(function(subInput) {
                                    return subInput.type === 'bgp';
                                })) return {
                                    recurse: false,
                                    result: factory.createBgp(op.input.flatMap(function(subInput) {
                                        return subInput.patterns;
                                    }))
                                };
                                return {
                                    recurse: false,
                                    result: op
                                };
                            }
                        }, algebraFactory);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationJoinBgp;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationJoinBgp = $c66afc271d449e9a$var$ActorOptimizeQueryOperationJoinBgp;

});


parcelRegister("gBbJY", function(module, exports) {
"use strict";
var $c1593572e0b1d21a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c1593572e0b1d21a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c1593572e0b1d21a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c1593572e0b1d21a$var$__exportStar((parcelRequire("hV0OT")), module.exports);

});
parcelRegister("hV0OT", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $cqEAj = parcelRequire("cqEAj");

var $i3fW3 = parcelRequire("i3fW3");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationAssignSourcesExhaustive = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $8UQh4 = parcelRequire("8UQh4");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $2n9RU = parcelRequire("2n9RU");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Assign Sources Exhaustive Optimize Query Operation Actor.
 */ var $d0b8655bf7ad0cc2$var$ActorOptimizeQueryOperationAssignSourcesExhaustive = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationAssignSourcesExhaustive, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationAssignSourcesExhaustive(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationAssignSourcesExhaustive);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationAssignSourcesExhaustive, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationAssignSourcesExhaustive, [
        {
            key: "test",
            value: function test(_action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $kNNoa.passTestVoid)()
                        ];
                    });
                })();
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, _action_context_get, sources, sourceWrapper, destination, shape, e;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                                algebraFactory = new $hSHd8.Factory(dataFactory);
                                sources = (_action_context_get = action.context.get($9nBhR.KeysQueryOperation.querySources)) !== null && _action_context_get !== void 0 ? _action_context_get : [];
                                if (sources.length === 0) return [
                                    2,
                                    {
                                        operation: action.operation,
                                        context: action.context
                                    }
                                ];
                                if (!(sources.length === 1)) return [
                                    3,
                                    4
                                ];
                                sourceWrapper = sources[0];
                                destination = action.context.get($9nBhR.KeysRdfUpdateQuads.destination);
                                if (!(!destination || sourceWrapper.source.referenceValue === (0, $8UQh4.getDataDestinationValue)(destination))) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    sourceWrapper.source.getSelectorShape(action.context)
                                ];
                            case 2:
                                shape = _state.sent();
                                if ((0, $2n9RU.doesShapeAcceptOperation)(shape, action.operation)) return [
                                    2,
                                    {
                                        operation: (0, $2n9RU.assignOperationSource)(action.operation, sourceWrapper),
                                        context: action.context
                                    }
                                ];
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    {
                                        operation: this.assignExhaustive(algebraFactory, action.operation, sources),
                                        // We only keep queryString in the context if we only have a single source that accepts the full operation.
                                        // In that case, the queryString can be sent to the source as-is.
                                        context: action.context["delete"]($9nBhR.KeysInitQuery.queryString)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Assign the given sources to the leaves in the given query operation.
     * Leaves will be wrapped in a union operation and duplicated for every source.
     * The input operation will not be modified.
     * @param algebraFactory The algebra factory.
     * @param operation The input operation.
     * @param sources The sources to assign.
     */ key: "assignExhaustive",
            value: function assignExhaustive(algebraFactory, operation, sources) {
                // eslint-disable-next-line ts/no-this-alias
                var self = this;
                var _obj;
                return $hSHd8.Util.mapOperation(operation, (_obj = {}, (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.PATTERN, function(subOperation, factory) {
                    if (sources.length === 1) return {
                        result: (0, $2n9RU.assignOperationSource)(subOperation, sources[0]),
                        recurse: false
                    };
                    return {
                        result: factory.createUnion(sources.map(function(source) {
                            return (0, $2n9RU.assignOperationSource)(subOperation, source);
                        })),
                        recurse: false
                    };
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.LINK, function(subOperation, factory) {
                    if (sources.length === 1) return {
                        result: (0, $2n9RU.assignOperationSource)(subOperation, sources[0]),
                        recurse: false
                    };
                    return {
                        result: factory.createAlt(sources.map(function(source) {
                            return (0, $2n9RU.assignOperationSource)(subOperation, source);
                        })),
                        recurse: false
                    };
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.NPS, function(subOperation, factory) {
                    if (sources.length === 1) return {
                        result: (0, $2n9RU.assignOperationSource)(subOperation, sources[0]),
                        recurse: false
                    };
                    return {
                        result: factory.createAlt(sources.map(function(source) {
                            return (0, $2n9RU.assignOperationSource)(subOperation, source);
                        })),
                        recurse: false
                    };
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.SERVICE, function(subOperation) {
                    return {
                        result: subOperation,
                        recurse: false
                    };
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.CONSTRUCT, function(subOperation, factory) {
                    return {
                        result: factory.createConstruct(self.assignExhaustive(algebraFactory, subOperation.input, sources), subOperation.template),
                        recurse: false
                    };
                }), (0, $cqEAj._)(_obj, $hSHd8.Algebra.types.DELETE_INSERT, function(subOperation, factory) {
                    return {
                        result: factory.createDeleteInsert(subOperation["delete"], subOperation.insert, subOperation.where ? self.assignExhaustive(algebraFactory, subOperation.where, sources) : undefined),
                        recurse: false
                    };
                }), _obj), algebraFactory);
            }
        }
    ]);
    return ActorOptimizeQueryOperationAssignSourcesExhaustive;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationAssignSourcesExhaustive = $d0b8655bf7ad0cc2$var$ActorOptimizeQueryOperationAssignSourcesExhaustive;

});


parcelRegister("aA2cu", function(module, exports) {
"use strict";
var $7b3ef922d39bebe0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7b3ef922d39bebe0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7b3ef922d39bebe0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7b3ef922d39bebe0$var$__exportStar((parcelRequire("6HxPM")), module.exports);

});
parcelRegister("6HxPM", function(module, exports) {

var $b8tVf = parcelRequire("b8tVf");

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $i3fW3 = parcelRequire("i3fW3");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationDescribeToConstructsSubject = void 0;

var $1GbiV = parcelRequire("1GbiV");

var $9nBhR = parcelRequire("9nBhR");

var $kNNoa = parcelRequire("kNNoa");

var $hSHd8 = parcelRequire("hSHd8");
/**
 * A comunica Describe To Constructs Subject Optimize Query Operation Actor.
 */ var $4e1100fb2e186682$var$ActorOptimizeQueryOperationDescribeToConstructsSubject = /*#__PURE__*/ function(_bus_optimize_query_operation_1_ActorOptimizeQueryOperation) {
    (0, $i3fW3._)(ActorOptimizeQueryOperationDescribeToConstructsSubject, _bus_optimize_query_operation_1_ActorOptimizeQueryOperation);
    function ActorOptimizeQueryOperationDescribeToConstructsSubject(args) {
        (0, $jGAMp._)(this, ActorOptimizeQueryOperationDescribeToConstructsSubject);
        return (0, $kzDuW._)(this, ActorOptimizeQueryOperationDescribeToConstructsSubject, [
            args
        ]);
    }
    (0, $byiyg._)(ActorOptimizeQueryOperationDescribeToConstructsSubject, [
        {
            key: "test",
            value: function test(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        if (action.operation.type !== $hSHd8.Algebra.types.DESCRIBE) return [
                            2,
                            (0, $kNNoa.failTest)("Actor ".concat(this.name, " only supports describe operations, but got ").concat(action.operation.type))
                        ];
                        return [
                            2,
                            (0, $kNNoa.passTest)(true)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "run",
            value: function run(action) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var dataFactory, algebraFactory, operationOriginal, operations, variablePatterns, operation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        dataFactory = action.context.getSafe($9nBhR.KeysInitQuery.dataFactory);
                        algebraFactory = new $hSHd8.Factory(dataFactory);
                        operationOriginal = action.operation;
                        // Create separate construct queries for all non-variable terms
                        operations = operationOriginal.terms.filter(function(term) {
                            return term.termType !== 'Variable';
                        }).map(function(term) {
                            // Transform each term to a separate construct operation with S ?p ?o patterns (BGP) for all terms
                            var patterns = [
                                dataFactory.quad(term, dataFactory.variable('__predicate'), dataFactory.variable('__object'))
                            ];
                            // eslint-disable-next-line unicorn/no-array-for-each
                            patterns.forEach(function(templatePattern) {
                                return templatePattern.type = 'pattern';
                            });
                            var templateOperation = {
                                type: $hSHd8.Algebra.types.BGP,
                                patterns: patterns
                            };
                            // Create a construct query
                            return {
                                input: templateOperation,
                                template: patterns,
                                type: 'construct'
                            };
                        });
                        // If we have variables in the term list,
                        // create one separate construct operation to determine these variables using the input pattern.
                        if (operations.length !== operationOriginal.terms.length) {
                            variablePatterns = [];
                            operationOriginal.terms.filter(function(term) {
                                return term.termType === 'Variable';
                            })// eslint-disable-next-line unicorn/no-array-for-each
                            .forEach(function(term, i) {
                                // Transform each term to an S ?p ?o pattern in a non-conflicting way
                                var patterns = [
                                    dataFactory.quad(term, dataFactory.variable("__predicate".concat(i)), dataFactory.variable("__object".concat(i)))
                                ];
                                // eslint-disable-next-line unicorn/no-array-for-each
                                patterns.forEach(function(templatePattern) {
                                    return templatePattern.type = 'pattern';
                                });
                                variablePatterns = (0, $7WNf6._)(variablePatterns).concat((0, $7WNf6._)(patterns));
                            });
                            // Add a single construct for the variables
                            // This requires a join between the input pattern and our variable patterns that form a simple BGP
                            operations.push({
                                input: {
                                    type: $hSHd8.Algebra.types.JOIN,
                                    input: [
                                        operationOriginal.input,
                                        {
                                            type: $hSHd8.Algebra.types.BGP,
                                            patterns: variablePatterns
                                        }
                                    ]
                                },
                                template: variablePatterns,
                                type: $hSHd8.Algebra.types.CONSTRUCT
                            });
                        }
                        // Union the construct operations
                        operation = algebraFactory.createUnion(operations, false);
                        return [
                            2,
                            {
                                operation: operation,
                                context: action.context
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return ActorOptimizeQueryOperationDescribeToConstructsSubject;
}($1GbiV.ActorOptimizeQueryOperation);
module.exports.ActorOptimizeQueryOperationDescribeToConstructsSubject = $4e1100fb2e186682$var$ActorOptimizeQueryOperationDescribeToConstructsSubject;

});






parcelRegister("5u2PY", function(module, exports) {

$parcel$export(module.exports, "VRButton", function () { return $3fe1f48843ac4c86$export$da3cdac99155b982; });
/**
 * A utility class for creating a button that allows to initiate
 * immersive VR sessions based on WebXR. The button can be created
 * with a factory method and then appended ot the website's DOM.
 *
 * ```js
 * document.body.appendChild( VRButton.createButton( renderer ) );
 * ```
 *
 * @hideconstructor
 * @three_import import { VRButton } from 'three/addons/webxr/VRButton.js';
 */ 
var $b8tVf = parcelRequire("b8tVf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
var $3fe1f48843ac4c86$export$da3cdac99155b982 = /*#__PURE__*/ function() {
    "use strict";
    function VRButton() {
        (0, $jGAMp._)(this, VRButton);
    }
    (0, $byiyg._)(VRButton, null, [
        {
            key: "createButton",
            value: /**
	 * Constructs a new VR button.
	 *
	 * @param {WebGLRenderer|WebGPURenderer} renderer - The renderer.
	 * @param {XRSessionInit} [sessionInit] - The a configuration object for the AR session.
	 * @return {HTMLElement} The button or an error message if `immersive-ar` isn't supported.
	 */ function createButton(renderer) {
                var sessionInit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var button = document.createElement('button');
                function showEnterVR() {
                    var currentSession = null;
                    function onSessionStarted(session) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        session.addEventListener('end', onSessionEnded);
                                        return [
                                            4,
                                            renderer.xr.setSession(session)
                                        ];
                                    case 1:
                                        _state.sent();
                                        button.textContent = 'EXIT VR';
                                        currentSession = session;
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                    function onSessionEnded() {
                        currentSession.removeEventListener('end', onSessionEnded);
                        button.textContent = 'ENTER VR';
                        currentSession = null;
                    }
                    //
                    button.style.display = '';
                    button.style.cursor = 'pointer';
                    button.style.left = 'calc(50% - 50px)';
                    button.style.width = '100px';
                    button.textContent = 'ENTER VR';
                    // WebXR's requestReferenceSpace only works if the corresponding feature
                    // was requested at session creation time. For simplicity, just ask for
                    // the interesting ones as optional features, but be aware that the
                    // requestReferenceSpace call will fail if it turns out to be unavailable.
                    // ('local' is always available for immersive sessions and doesn't need to
                    // be requested separately.)
                    var sessionOptions = (0, $emQHU._)((0, $iT0je._)({}, sessionInit), {
                        optionalFeatures: [
                            'local-floor',
                            'bounded-floor',
                            'layers'
                        ].concat((0, $7WNf6._)(sessionInit.optionalFeatures || []))
                    });
                    button.onmouseenter = function() {
                        button.style.opacity = '1.0';
                    };
                    button.onmouseleave = function() {
                        button.style.opacity = '0.5';
                    };
                    button.onclick = function() {
                        if (currentSession === null) navigator.xr.requestSession('immersive-vr', sessionOptions).then(onSessionStarted);
                        else {
                            currentSession.end();
                            if (navigator.xr.offerSession !== undefined) navigator.xr.offerSession('immersive-vr', sessionOptions).then(onSessionStarted)["catch"](function(err) {
                                console.warn(err);
                            });
                        }
                    };
                    if (navigator.xr.offerSession !== undefined) navigator.xr.offerSession('immersive-vr', sessionOptions).then(onSessionStarted)["catch"](function(err) {
                        console.warn(err);
                    });
                }
                function disableButton() {
                    button.style.display = '';
                    button.style.cursor = 'auto';
                    button.style.left = 'calc(50% - 75px)';
                    button.style.width = '150px';
                    button.onmouseenter = null;
                    button.onmouseleave = null;
                    button.onclick = null;
                }
                function showWebXRNotFound() {
                    disableButton();
                    button.textContent = 'VR NOT SUPPORTED';
                }
                function showVRNotAllowed(exception) {
                    disableButton();
                    console.warn('Exception when trying to call xr.isSessionSupported', exception);
                    button.textContent = 'VR NOT ALLOWED';
                }
                function stylizeElement(element) {
                    element.style.position = 'absolute';
                    element.style.bottom = '20px';
                    element.style.padding = '12px 6px';
                    element.style.border = '1px solid #fff';
                    element.style.borderRadius = '4px';
                    element.style.background = 'rgba(0,0,0,0.1)';
                    element.style.color = '#fff';
                    element.style.font = 'normal 13px sans-serif';
                    element.style.textAlign = 'center';
                    element.style.opacity = '0.5';
                    element.style.outline = 'none';
                    element.style.zIndex = '999';
                }
                if ('xr' in navigator) {
                    button.id = 'VRButton';
                    button.style.display = 'none';
                    stylizeElement(button);
                    navigator.xr.isSessionSupported('immersive-vr').then(function(supported) {
                        supported ? showEnterVR() : showWebXRNotFound();
                        if (supported && VRButton.xrSessionIsGranted) button.click();
                    })["catch"](showVRNotAllowed);
                    return button;
                } else {
                    var message = document.createElement('a');
                    if (window.isSecureContext === false) {
                        message.href = document.location.href.replace(/^http:/, 'https:');
                        message.innerHTML = 'WEBXR NEEDS HTTPS'; // TODO Improve message
                    } else {
                        message.href = 'https://immersiveweb.dev/';
                        message.innerHTML = 'WEBXR NOT AVAILABLE';
                    }
                    message.style.left = 'calc(50% - 90px)';
                    message.style.width = '180px';
                    message.style.textDecoration = 'none';
                    stylizeElement(message);
                    return message;
                }
            }
        },
        {
            key: "registerSessionGrantedListener",
            value: /**
	 * Registers a `sessiongranted` event listener. When a session is granted, the {@link VRButton#xrSessionIsGranted}
	 * flag will evaluate to `true`. This method is automatically called by the module itself so there
	 * should be no need to use it on app level.
	 */ function registerSessionGrantedListener() {
                if (typeof navigator !== 'undefined' && 'xr' in navigator) {
                    // WebXRViewer (based on Firefox) has a bug where addEventListener
                    // throws a silent exception and aborts execution entirely.
                    if (/WebXRViewer\//i.test(navigator.userAgent)) return;
                    navigator.xr.addEventListener('sessiongranted', function() {
                        VRButton.xrSessionIsGranted = true;
                    });
                }
            }
        }
    ]);
    return VRButton;
}();
/**
 * Whether a XR session has been granted or not.
 *
 * @static
 * @type {boolean}
 * @default false
 */ $3fe1f48843ac4c86$export$da3cdac99155b982.xrSessionIsGranted = false;
$3fe1f48843ac4c86$export$da3cdac99155b982.registerSessionGrantedListener();

});

parcelRegister("fF3Ps", function(module, exports) {

$parcel$export(module.exports, "stringToColor", function () { return $366c6c47120763bb$export$bdfef6425db7c64; });
$parcel$export(module.exports, "resetNodePositions", function () { return $366c6c47120763bb$export$eac60472a578ea83; });
$parcel$export(module.exports, "includes", function () { return $366c6c47120763bb$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "getOrientation", function () { return $366c6c47120763bb$export$67689507e8404821; });
$parcel$export(module.exports, "updateUrlParams", function () { return $366c6c47120763bb$export$9036647601a217a6; });
$parcel$export(module.exports, "parseUrlParams", function () { return $366c6c47120763bb$export$6ed5c7767576092d; });
/**
 * Cache of already-seen strings → colours
 */ 
var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");
var $366c6c47120763bb$var$colors = {};
function $366c6c47120763bb$export$bdfef6425db7c64(str) {
    if ($366c6c47120763bb$var$colors[str]) return $366c6c47120763bb$var$colors[str];
    /* ── 1. hash the string ─────────────────────────────────────────── */ var hash = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ch = _step.value;
            hash = (hash << 5) - hash + ch.charCodeAt(0);
            hash |= 0 // keep it 32-bit
            ;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hash = Math.abs(hash);
    /* ── 2. map hash → H, S, L ──────────────────────────────────────── */ var h = hash % 360 // 0-359
    ;
    var s = 60 + (hash >> 8) % 30 // 60-89 %
    ;
    var l = 60 + (hash >> 16) % 20 // 60-79 %
    ;
    /* ── 3. convert to HEX ──────────────────────────────────────────── */ var color = $366c6c47120763bb$var$hslToHex(h, s, l);
    $366c6c47120763bb$var$colors[str] = color;
    return color;
}
/* helper ───────────────────────────────────────────────────────────── */ function $366c6c47120763bb$var$hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function(n) {
        return Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))))).toString(16).padStart(2, '0');
    };
    return "#".concat(f(0)).concat(f(8)).concat(f(4));
}
function $366c6c47120763bb$export$eac60472a578ea83(nodes) {
    return nodes.map(function(_param) {
        var x = _param.x, y = _param.y, z = _param.z, vx = _param.vx, vy = _param.vy, vz = _param.vz, fx = _param.fx, fy = _param.fy, fz = _param.fz, rest = (0, $g79Gh._)(_param, [
            "x",
            "y",
            "z",
            "vx",
            "vy",
            "vz",
            "fx",
            "fy",
            "fz"
        ]);
        return (0, $emQHU._)((0, $iT0je._)({}, rest), {
            x: undefined,
            y: undefined,
            z: undefined,
            vx: undefined,
            vy: undefined,
            vz: undefined,
            fx: undefined,
            fy: undefined,
            fz: undefined
        });
    });
}
function $366c6c47120763bb$export$ee2e0f811dca1807(base, term) {
    base = base.toLowerCase();
    var terms = term.toLowerCase().split(' ');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = terms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if (!base.includes(t)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $366c6c47120763bb$export$67689507e8404821() {
    // fall back to innerWidth / innerHeight
    return window.innerWidth > window.innerHeight ? 'horizontal' : 'vertical';
}
function $366c6c47120763bb$export$cc04a752b5936342(query) {
    return encodeURIComponent(btoa(query));
}
function $366c6c47120763bb$export$4423c011ee421091(encoded) {
    try {
        return atob(decodeURIComponent(encoded));
    } catch (error) {
        console.warn('Failed to decode SPARQL query from URL:', error);
        return '';
    }
}
function $366c6c47120763bb$export$9036647601a217a6(params) {
    var url = new URL(window.location.href);
    // Handle mode parameter
    if (params.mode) url.searchParams.set('mode', params.mode);
    // Handle search parameters (normal mode)
    if (params.mode === 'normal' || !params.mode) {
        if (params.search) url.searchParams.set('search', params.search);
        else url.searchParams["delete"]('search');
        // Clear SPARQL parameters when in normal mode
        url.searchParams["delete"]('sparql');
        url.searchParams["delete"]('preset');
    }
    // Handle SPARQL parameters
    if (params.mode === 'sparql') {
        if (params.sparqlQuery) url.searchParams.set('sparql', $366c6c47120763bb$export$cc04a752b5936342(params.sparqlQuery));
        else url.searchParams["delete"]('sparql');
        if (params.sparqlPreset) url.searchParams.set('preset', params.sparqlPreset);
        else url.searchParams["delete"]('preset');
        // Clear search parameter when in SPARQL mode
        url.searchParams["delete"]('search');
    }
    // Handle common parameters
    if (params.id) url.searchParams.set('id', params.id);
    else if (params.id === null) url.searchParams["delete"]('id');
    if (params.view) url.searchParams.set('view', params.view);
    else if (params.view === null) url.searchParams["delete"]('view');
    if (params.title) url.searchParams.set('title', params.title);
    else if (params.title === null) url.searchParams["delete"]('title');
    history.replaceState({}, '', url);
}
function $366c6c47120763bb$export$6ed5c7767576092d() {
    var params = new URLSearchParams(window.location.search);
    var mode = params.get('mode') || 'normal';
    var search = params.get('search');
    var encodedSparql = params.get('sparql');
    var sparqlPreset = params.get('preset');
    var id = params.get('id');
    var view = params.get('view');
    var title = params.get('title');
    var sparqlQuery = '';
    if (encodedSparql) sparqlQuery = $366c6c47120763bb$export$4423c011ee421091(encodedSparql);
    return {
        mode: mode,
        search: search,
        sparqlQuery: sparqlQuery,
        sparqlPreset: sparqlPreset,
        id: id,
        view: view,
        title: title
    };
}

});

parcelRegister("jiXdb", function(module, exports) {

$parcel$export(module.exports, "CSS2DObject", function () { return $e0dda0f21ae2128f$export$936f75e6792bf2dc; });
$parcel$export(module.exports, "CSS2DRenderer", function () { return $e0dda0f21ae2128f$export$508520281a983506; });

var $kzDuW = parcelRequire("kzDuW");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $fXhL4 = parcelRequire("fXhL4");

var $hxFDX = parcelRequire("hxFDX");

var $i3fW3 = parcelRequire("i3fW3");
parcelRequire("lGUYa");
var $dRnj4 = parcelRequire("dRnj4");
var $dRnj4 = parcelRequire("dRnj4");
/**
 * The only type of 3D object that is supported by {@link CSS2DRenderer}.
 *
 * @augments Object3D
 * @three_import import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
 */ var $e0dda0f21ae2128f$export$936f75e6792bf2dc = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $i3fW3._)(CSS2DObject, Object3D);
    function CSS2DObject() {
        var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.createElement('div');
        (0, $jGAMp._)(this, CSS2DObject);
        var _this;
        _this = (0, $kzDuW._)(this, CSS2DObject);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ _this.isCSS2DObject = true;
        /**
		 * The DOM element which defines the appearance of this 3D object.
		 *
		 * @type {DOMElement}
		 * @readonly
		 * @default true
		 */ _this.element = element;
        _this.element.style.position = 'absolute';
        _this.element.style.userSelect = 'none';
        _this.element.setAttribute('draggable', false);
        /**
		 * The 3D objects center point.
		 * `( 0, 0 )` is the lower left, `( 1, 1 )` is the top right.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ _this.center = new (0, $dRnj4.Vector2)(0.5, 0.5);
        _this.addEventListener('removed', function() {
            this.traverse(function(object) {
                if (object.element instanceof object.element.ownerDocument.defaultView.Element && object.element.parentNode !== null) object.element.remove();
            });
        });
        return _this;
    }
    (0, $byiyg._)(CSS2DObject, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $fXhL4._)((0, $hxFDX._)(CSS2DObject.prototype), "copy", this).call(this, source, recursive);
                this.element = source.element.cloneNode(true);
                this.center = source.center;
                return this;
            }
        }
    ]);
    return CSS2DObject;
}((0, $dRnj4.Object3D));
//
var $e0dda0f21ae2128f$var$_vector = new (0, $dRnj4.Vector3)();
var $e0dda0f21ae2128f$var$_viewMatrix = new (0, $dRnj4.Matrix4)();
var $e0dda0f21ae2128f$var$_viewProjectionMatrix = new (0, $dRnj4.Matrix4)();
var $e0dda0f21ae2128f$var$_a = new (0, $dRnj4.Vector3)();
var $e0dda0f21ae2128f$var$_b = new (0, $dRnj4.Vector3)();
/**
 * This renderer is a simplified version of {@link CSS3DRenderer}. The only transformation that is
 * supported is translation.
 *
 * The renderer is very useful if you want to combine HTML based labels with 3D objects. Here too,
 * the respective DOM elements are wrapped into an instance of {@link CSS2DObject} and added to the
 * scene graph. All other types of renderable 3D objects (like meshes or point clouds) are ignored.
 *
 * `CSS2DRenderer` only supports 100% browser and display zoom.
 *
 * @three_import import { CSS2DRenderer } from 'three/addons/renderers/CSS2DRenderer.js';
 */ var $e0dda0f21ae2128f$export$508520281a983506 = function CSS2DRenderer() {
    "use strict";
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0, $jGAMp._)(this, CSS2DRenderer);
    var getDistanceToSquared = function getDistanceToSquared(object1, object2) {
        $e0dda0f21ae2128f$var$_a.setFromMatrixPosition(object1.matrixWorld);
        $e0dda0f21ae2128f$var$_b.setFromMatrixPosition(object2.matrixWorld);
        return $e0dda0f21ae2128f$var$_a.distanceToSquared($e0dda0f21ae2128f$var$_b);
    };
    var filterAndFlatten = function filterAndFlatten(scene) {
        var result = [];
        scene.traverseVisible(function(object) {
            if (object.isCSS2DObject) result.push(object);
        });
        return result;
    };
    var zOrder = function zOrder(scene) {
        var sorted = filterAndFlatten(scene).sort(function(a, b) {
            if (a.renderOrder !== b.renderOrder) return b.renderOrder - a.renderOrder;
            var distanceA = cache.objects.get(a).distanceToCameraSquared;
            var distanceB = cache.objects.get(b).distanceToCameraSquared;
            return distanceA - distanceB;
        });
        var zMax = sorted.length;
        for(var i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
    };
    var _this = this;
    var _width, _height;
    var _widthHalf, _heightHalf;
    var cache = {
        objects: new WeakMap()
    };
    var domElement = parameters.element !== undefined ? parameters.element : document.createElement('div');
    domElement.style.overflow = 'hidden';
    /**
		 * The DOM where the renderer appends its child-elements.
		 *
		 * @type {DOMElement}
		 */ this.domElement = domElement;
    /**
		 * Returns an object containing the width and height of the renderer.
		 *
		 * @return {{width:number,height:number}} The size of the renderer.
		 */ this.getSize = function() {
        return {
            width: _width,
            height: _height
        };
    };
    /**
		 * Renders the given scene using the given camera.
		 *
		 * @param {Object3D} scene - A scene or any other type of 3D object.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        $e0dda0f21ae2128f$var$_viewMatrix.copy(camera.matrixWorldInverse);
        $e0dda0f21ae2128f$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $e0dda0f21ae2128f$var$_viewMatrix);
        renderObject(scene, scene, camera);
        zOrder(scene);
    };
    /**
		 * Resizes the renderer to the given width and height.
		 *
		 * @param {number} width - The width of the renderer.
		 * @param {number} height - The height of the renderer.
		 */ this.setSize = function(width, height) {
        _width = width;
        _height = height;
        _widthHalf = _width / 2;
        _heightHalf = _height / 2;
        domElement.style.width = width + 'px';
        domElement.style.height = height + 'px';
    };
    function hideObject(object) {
        if (object.isCSS2DObject) object.element.style.display = 'none';
        for(var i = 0, l = object.children.length; i < l; i++)hideObject(object.children[i]);
    }
    function renderObject(object, scene, camera) {
        if (object.visible === false) {
            hideObject(object);
            return;
        }
        if (object.isCSS2DObject) {
            $e0dda0f21ae2128f$var$_vector.setFromMatrixPosition(object.matrixWorld);
            $e0dda0f21ae2128f$var$_vector.applyMatrix4($e0dda0f21ae2128f$var$_viewProjectionMatrix);
            var visible = $e0dda0f21ae2128f$var$_vector.z >= -1 && $e0dda0f21ae2128f$var$_vector.z <= 1 && object.layers.test(camera.layers) === true;
            var element = object.element;
            element.style.display = visible === true ? '' : 'none';
            if (visible === true) {
                object.onBeforeRender(_this, scene, camera);
                element.style.transform = 'translate(' + -100 * object.center.x + '%,' + -100 * object.center.y + '%)' + 'translate(' + ($e0dda0f21ae2128f$var$_vector.x * _widthHalf + _widthHalf) + 'px,' + (-$e0dda0f21ae2128f$var$_vector.y * _heightHalf + _heightHalf) + 'px)';
                if (element.parentNode !== domElement) domElement.appendChild(element);
                object.onAfterRender(_this, scene, camera);
            }
            var objectData = {
                distanceToCameraSquared: getDistanceToSquared(camera, object)
            };
            cache.objects.set(object, objectData);
        }
        for(var i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
    }
};

});


parcelRegister("g1RiW", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bab61685f1e04f14$export$b3890eb0ae9dca99; });
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");
var $bab61685f1e04f14$var$_hoisted_1 = {
    ref: "nodes"
};
var $bab61685f1e04f14$var$_hoisted_2 = {
    ref: "links"
};
var $bab61685f1e04f14$var$_hoisted_3 = {
    ref: "graph",
    id: "graph"
};
var $bab61685f1e04f14$var$_hoisted_4 = {
    "class": "d-flex justify-space-between align-start mb-2"
};
var $bab61685f1e04f14$var$_hoisted_5 = {
    "class": "pa-0 ma-0",
    style: {
        "list-style": "none"
    }
};
var $bab61685f1e04f14$var$_hoisted_6 = {
    key: 0,
    "class": "mt-2"
};
var $bab61685f1e04f14$var$_hoisted_7 = {
    "class": "mb-3"
};
var $bab61685f1e04f14$var$_hoisted_8 = {
    "class": "mt-2",
    style: {
        "font-family": "'Courier New', monospace",
        "font-size": "0.9em"
    }
};
var $bab61685f1e04f14$var$_hoisted_9 = {
    "class": "d-flex justify-space-between mt-3"
};
var $bab61685f1e04f14$var$_hoisted_10 = {
    "class": "pa-2"
};
var $bab61685f1e04f14$var$_hoisted_11 = {
    "class": "d-flex justify-space-between align-start mb-2"
};
var $bab61685f1e04f14$var$_hoisted_12 = {
    "class": "pa-0 ma-0",
    style: {
        "list-style": "none",
        "font-size": "small"
    }
};
var $bab61685f1e04f14$var$_hoisted_13 = {
    key: 0,
    "class": "mt-2"
};
function $bab61685f1e04f14$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _this = this;
    var _component_v_chip = (0, $bu8yf.resolveComponent)("v-chip");
    var _component_v_app_bar_title = (0, $bu8yf.resolveComponent)("v-app-bar-title");
    var _component_v_spacer = (0, $bu8yf.resolveComponent)("v-spacer");
    var _component_v_text_field = (0, $bu8yf.resolveComponent)("v-text-field");
    var _component_v_btn = (0, $bu8yf.resolveComponent)("v-btn");
    var _component_v_btn_toggle = (0, $bu8yf.resolveComponent)("v-btn-toggle");
    var _component_v_list_item = (0, $bu8yf.resolveComponent)("v-list-item");
    var _component_v_radio = (0, $bu8yf.resolveComponent)("v-radio");
    var _component_v_radio_group = (0, $bu8yf.resolveComponent)("v-radio-group");
    var _component_v_list = (0, $bu8yf.resolveComponent)("v-list");
    var _component_v_menu = (0, $bu8yf.resolveComponent)("v-menu");
    var _component_v_app_bar = (0, $bu8yf.resolveComponent)("v-app-bar");
    var _component_v_card_title = (0, $bu8yf.resolveComponent)("v-card-title");
    var _component_v_card_subtitle = (0, $bu8yf.resolveComponent)("v-card-subtitle");
    var _component_v_card_item = (0, $bu8yf.resolveComponent)("v-card-item");
    var _component_v_card_text = (0, $bu8yf.resolveComponent)("v-card-text");
    var _component_v_card_actions = (0, $bu8yf.resolveComponent)("v-card-actions");
    var _component_v_card = (0, $bu8yf.resolveComponent)("v-card");
    var _component_pane = (0, $bu8yf.resolveComponent)("pane");
    var _component_v_icon = (0, $bu8yf.resolveComponent)("v-icon");
    var _component_v_select = (0, $bu8yf.resolveComponent)("v-select");
    var _component_v_textarea = (0, $bu8yf.resolveComponent)("v-textarea");
    var _component_v_alert_title = (0, $bu8yf.resolveComponent)("v-alert-title");
    var _component_v_alert = (0, $bu8yf.resolveComponent)("v-alert");
    var _component_v_divider = (0, $bu8yf.resolveComponent)("v-divider");
    var _component_v_virtual_scroll = (0, $bu8yf.resolveComponent)("v-virtual-scroll");
    var _component_splitpanes = (0, $bu8yf.resolveComponent)("splitpanes");
    var _component_v_main = (0, $bu8yf.resolveComponent)("v-main");
    var _component_v_layout = (0, $bu8yf.resolveComponent)("v-layout");
    var _component_v_dialog = (0, $bu8yf.resolveComponent)("v-dialog");
    return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)((0, $bu8yf.Fragment), null, [
        (0, $bu8yf.createVNode)(_component_v_card, {
            "class": "mx-auto"
        }, {
            "default": (0, $bu8yf.withCtx)(function() {
                return [
                    (0, $bu8yf.createVNode)(_component_v_layout, {
                        "class": "d-flex flex-column",
                        style: {
                            height: "100vh"
                        }
                    }, {
                        "default": (0, $bu8yf.withCtx)(function() {
                            return [
                                (0, $bu8yf.createVNode)(_component_v_app_bar, {
                                    density: "compact",
                                    "class": "flex-shrink-0"
                                }, {
                                    prepend: (0, $bu8yf.withCtx)(function() {
                                        return _cache[13] || (_cache[13] = []);
                                    }),
                                    append: (0, $bu8yf.withCtx)(function() {
                                        return [
                                            (0, $bu8yf.createVNode)(_component_v_btn_toggle, {
                                                modelValue: $data.searchMode,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function($event) {
                                                    return $data.searchMode = $event;
                                                }),
                                                density: "compact",
                                                variant: "outlined",
                                                mandatory: "",
                                                "class": "mr-2"
                                            }, {
                                                "default": (0, $bu8yf.withCtx)(function() {
                                                    return [
                                                        (0, $bu8yf.createVNode)(_component_v_btn, {
                                                            value: "normal",
                                                            size: "small",
                                                            icon: "mdi-magnify"
                                                        }),
                                                        (0, $bu8yf.createVNode)(_component_v_btn, {
                                                            value: "sparql",
                                                            size: "small",
                                                            icon: "mdi-database-search"
                                                        })
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, [
                                                "modelValue"
                                            ]),
                                            (0, $bu8yf.createVNode)(_component_v_menu, null, {
                                                activator: (0, $bu8yf.withCtx)(function(param) {
                                                    var props = param.props;
                                                    return [
                                                        (0, $bu8yf.createVNode)(_component_v_btn, (0, $bu8yf.mergeProps)({
                                                            icon: "mdi-dots-vertical"
                                                        }, props), null, 16)
                                                    ];
                                                }),
                                                "default": (0, $bu8yf.withCtx)(function() {
                                                    return [
                                                        (0, $bu8yf.createVNode)(_component_v_list, {
                                                            density: "compact"
                                                        }, {
                                                            "default": (0, $bu8yf.withCtx)(function() {
                                                                return [
                                                                    (0, $bu8yf.createVNode)(_component_v_list_item, {
                                                                        title: "Beschreibung",
                                                                        "prepend-icon": "mdi-information-outline",
                                                                        onClick: _cache[2] || (_cache[2] = function($event) {
                                                                            return $data.open.description = true;
                                                                        })
                                                                    }),
                                                                    (0, $bu8yf.createVNode)(_component_v_list_item, {
                                                                        title: $data.settings.title ? 'Titel im Graph ausblenden' : 'Titel im Graph zeigen',
                                                                        "prepend-icon": $data.settings.title ? 'mdi-vector-polyline-minus' : 'mdi-vector-polyline-plus',
                                                                        onClick: $options.toggleTitle
                                                                    }, null, 8, [
                                                                        "title",
                                                                        "prepend-icon",
                                                                        "onClick"
                                                                    ]),
                                                                    (0, $bu8yf.createVNode)(_component_v_list_item, {
                                                                        title: $data.settings.darkMode ? 'Light Mode aktivieren' : 'Dark Mode aktivieren',
                                                                        "prepend-icon": $data.settings.darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night',
                                                                        onClick: $options.toggleTheme
                                                                    }, null, 8, [
                                                                        "title",
                                                                        "prepend-icon",
                                                                        "onClick"
                                                                    ]),
                                                                    (0, $bu8yf.createVNode)(_component_v_list_item, {
                                                                        title: "Darstellung:",
                                                                        "prepend-icon": "mdi-information-outline"
                                                                    }),
                                                                    (0, $bu8yf.createVNode)(_component_v_list_item, null, {
                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                            return [
                                                                                (0, $bu8yf.createVNode)(_component_v_radio_group, {
                                                                                    modelValue: $data.split,
                                                                                    "onUpdate:modelValue": [
                                                                                        _cache[3] || (_cache[3] = function($event) {
                                                                                            return $data.split = $event;
                                                                                        }),
                                                                                        $options.handleSplitChange
                                                                                    ],
                                                                                    "class": "pl-13 pt-0",
                                                                                    density: "compact"
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        return [
                                                                                            (0, $bu8yf.createVNode)(_component_v_radio, {
                                                                                                label: "Graph",
                                                                                                value: "graph"
                                                                                            }),
                                                                                            (0, $bu8yf.createVNode)(_component_v_radio, {
                                                                                                label: "Beides",
                                                                                                value: "both"
                                                                                            }),
                                                                                            (0, $bu8yf.createVNode)(_component_v_radio, {
                                                                                                label: "Liste",
                                                                                                value: "list"
                                                                                            })
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }, 8, [
                                                                                    "modelValue",
                                                                                    "onUpdate:modelValue"
                                                                                ])
                                                                            ];
                                                                        }),
                                                                        _: 1
                                                                    })
                                                                ];
                                                            }),
                                                            _: 1
                                                        })
                                                    ];
                                                }),
                                                _: 1
                                            })
                                        ];
                                    }),
                                    "default": (0, $bu8yf.withCtx)(function() {
                                        return [
                                            (0, $bu8yf.createVNode)(_component_v_app_bar_title, null, {
                                                "default": (0, $bu8yf.withCtx)(function() {
                                                    return [
                                                        _cache[15] || (_cache[15] = (0, $bu8yf.createTextVNode)(" OER-Graph (", -1)),
                                                        (0, $bu8yf.createElementVNode)("span", $bab61685f1e04f14$var$_hoisted_1, "0", 512),
                                                        _cache[16] || (_cache[16] = (0, $bu8yf.createTextVNode)("/", -1)),
                                                        (0, $bu8yf.createElementVNode)("span", $bab61685f1e04f14$var$_hoisted_2, "0", 512),
                                                        _cache[17] || (_cache[17] = (0, $bu8yf.createTextVNode)(") ", -1)),
                                                        $data.sparqlFilters.active ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_chip, {
                                                            key: 0,
                                                            color: "accent",
                                                            size: "small",
                                                            "class": "ml-2"
                                                        }, {
                                                            "default": (0, $bu8yf.withCtx)(function() {
                                                                return _cache[14] || (_cache[14] = [
                                                                    (0, $bu8yf.createTextVNode)(" SPARQL Filtered ", -1)
                                                                ]);
                                                            }),
                                                            _: 1,
                                                            __: [
                                                                14
                                                            ]
                                                        })) : (0, $bu8yf.createCommentVNode)("", true)
                                                    ];
                                                }),
                                                _: 1,
                                                __: [
                                                    15,
                                                    16,
                                                    17
                                                ]
                                            }),
                                            (0, $bu8yf.createVNode)(_component_v_spacer),
                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(_component_v_text_field, {
                                                loading: $data.search.loading,
                                                modelValue: $data.search.text,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function($event) {
                                                    return $data.search.text = $event;
                                                }),
                                                "append-inner-icon": "mdi-magnify",
                                                density: "compact",
                                                label: "Suche",
                                                variant: "outlined",
                                                "hide-details": "",
                                                "single-line": "",
                                                "onClick:appendInner": $options.handleSearch,
                                                onKeyup: (0, $kiZwI.withKeys)($options.handleSearch, [
                                                    "enter"
                                                ])
                                            }, null, 8, [
                                                "loading",
                                                "modelValue",
                                                "onClick:appendInner",
                                                "onKeyup"
                                            ]), [
                                                [
                                                    (0, $kiZwI.vShow),
                                                    $data.searchMode === 'normal'
                                                ]
                                            ]),
                                            (0, $bu8yf.createVNode)(_component_v_spacer)
                                        ];
                                    }),
                                    _: 1
                                }),
                                (0, $bu8yf.createVNode)(_component_v_main, {
                                    "class": "flex-grow-1 overflow-hidden"
                                }, {
                                    "default": (0, $bu8yf.withCtx)(function() {
                                        return [
                                            (0, $bu8yf.createVNode)(_component_splitpanes, {
                                                horizontal: $data.orientation !== 'horizontal',
                                                "class": "default-theme",
                                                style: {
                                                    "max-height": "calc(100vh - 48px)"
                                                }
                                            }, {
                                                "default": (0, $bu8yf.withCtx)(function() {
                                                    return [
                                                        (0, $bu8yf.createVNode)(_component_pane, {
                                                            size: $data.split === 'graph' ? 100 : $data.split === 'both' ? 70 : 0
                                                        }, {
                                                            "default": (0, $bu8yf.withCtx)(function() {
                                                                return [
                                                                    (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_3, null, 512),
                                                                    (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(_component_v_card, {
                                                                        "class": "info-card mx-auto",
                                                                        style: {
                                                                            overflow: "auto",
                                                                            "max-width": "344px"
                                                                        },
                                                                        hover: ""
                                                                    }, {
                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                            return [
                                                                                (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                    icon: "mdi-close",
                                                                                    variant: "text",
                                                                                    size: "small",
                                                                                    "class": "position-absolute top-0 right-0 mt-1 mr-1",
                                                                                    "aria-label": "Close",
                                                                                    onClick: _cache[4] || (_cache[4] = function($event) {
                                                                                        return $data.article.show = false;
                                                                                    })
                                                                                }),
                                                                                (0, $bu8yf.createVNode)(_component_v_card_item, {
                                                                                    style: {
                                                                                        "margin-top": "1rem"
                                                                                    }
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        var _$data_article_content, _$data_article_content1;
                                                                                        return [
                                                                                            (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_4, [
                                                                                                (0, $bu8yf.createVNode)(_component_v_card_title, {
                                                                                                    "class": "no-ellipsis pa-0",
                                                                                                    style: {
                                                                                                        flex: "1",
                                                                                                        "min-width": "0",
                                                                                                        "word-break": "break-word",
                                                                                                        "line-height": "1.2"
                                                                                                    }
                                                                                                }, {
                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                        var _$data_article_content;
                                                                                                        return [
                                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.title), 1)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 1
                                                                                                }),
                                                                                                (0, $bu8yf.createVNode)(_component_v_chip, {
                                                                                                    size: "small",
                                                                                                    color: "primary",
                                                                                                    variant: "outlined",
                                                                                                    "class": "ml-2",
                                                                                                    style: {
                                                                                                        "font-family": "monospace",
                                                                                                        "flex-shrink": "0",
                                                                                                        cursor: "pointer"
                                                                                                    },
                                                                                                    onClick: _cache[5] || (_cache[5] = function($event) {
                                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content2;
                                                                                                        return $options.copyIdToClipboard($data.searchMode === 'sparql' && ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.originalId) ? (_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.originalId : (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.id, $event);
                                                                                                    }),
                                                                                                    title: "Click to copy ID"
                                                                                                }, {
                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content2;
                                                                                                        return [
                                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)($data.searchMode === "sparql" && ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.originalId) ? (_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.originalId : (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.id), 1)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 1
                                                                                                })
                                                                                            ]),
                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(_component_v_card_subtitle, null, {
                                                                                                "default": (0, $bu8yf.withCtx)(function() {
                                                                                                    var _$data_article_content, _$data_article_content1, _$data_article_content2, _$data_article_content3, _$data_article_content4;
                                                                                                    return [
                                                                                                        (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.authors) + " ", 1),
                                                                                                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, "-", 512), [
                                                                                                            [
                                                                                                                (0, $kiZwI.vShow),
                                                                                                                ((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.authors) && ((_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.affiliation)
                                                                                                            ]
                                                                                                        ]),
                                                                                                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, [
                                                                                                            _cache[18] || (_cache[18] = (0, $bu8yf.createTextVNode)(" (", -1)),
                                                                                                            (0, $bu8yf.createElementVNode)("i", null, (0, $d8jBh.toDisplayString)((_$data_article_content3 = $data.article.content) === null || _$data_article_content3 === void 0 ? void 0 : _$data_article_content3.affiliation), 1),
                                                                                                            _cache[19] || (_cache[19] = (0, $bu8yf.createTextVNode)(") ", -1))
                                                                                                        ], 512), [
                                                                                                            [
                                                                                                                (0, $kiZwI.vShow),
                                                                                                                (_$data_article_content4 = $data.article.content) === null || _$data_article_content4 === void 0 ? void 0 : _$data_article_content4.affiliation
                                                                                                            ]
                                                                                                        ])
                                                                                                    ];
                                                                                                }),
                                                                                                _: 1
                                                                                            }, 512), [
                                                                                                [
                                                                                                    (0, $kiZwI.vShow),
                                                                                                    ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.authors) || ((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.affiliation)
                                                                                                ]
                                                                                            ])
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }),
                                                                                (0, $bu8yf.createVNode)(_component_v_card_text, {
                                                                                    style: {
                                                                                        "max-height": "400px",
                                                                                        overflow: "auto"
                                                                                    }
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content_tag, _$data_article_content2, _$data_article_content3, _$data_article_content4, _$data_article_content5, _$data_article_content6, _$data_article_content7, _$data_article_content8, _$data_article_content9;
                                                                                        return [
                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.summary) + " ", 1),
                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("ul", $bab61685f1e04f14$var$_hoisted_5, [
                                                                                                ((0, $bu8yf.openBlock)(true), (0, $bu8yf.createElementBlock)((0, $bu8yf.Fragment), null, (0, $bu8yf.renderList)(((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.tag) || [], function(tag) {
                                                                                                    return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("li", null, (0, $d8jBh.toDisplayString)(tag), 1);
                                                                                                }), 256))
                                                                                            ], 512), [
                                                                                                [
                                                                                                    (0, $kiZwI.vShow),
                                                                                                    (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : (_$data_article_content_tag = _$data_article_content2.tag) === null || _$data_article_content_tag === void 0 ? void 0 : _$data_article_content_tag.length
                                                                                                ]
                                                                                            ]),
                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, "Typ: " + (0, $d8jBh.toDisplayString)((_$data_article_content3 = $data.article.content) === null || _$data_article_content3 === void 0 ? void 0 : _$data_article_content3.type) + " / " + (0, $d8jBh.toDisplayString)((_$data_article_content4 = $data.article.content) === null || _$data_article_content4 === void 0 ? void 0 : _$data_article_content4.file), 513), [
                                                                                                [
                                                                                                    (0, $kiZwI.vShow),
                                                                                                    ((_$data_article_content5 = $data.article.content) === null || _$data_article_content5 === void 0 ? void 0 : _$data_article_content5.type) || ((_$data_article_content6 = $data.article.content) === null || _$data_article_content6 === void 0 ? void 0 : _$data_article_content6.file)
                                                                                                ]
                                                                                            ]),
                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                                                                                                style: {
                                                                                                    display: "block"
                                                                                                }
                                                                                            }, " Lizenz: " + (0, $d8jBh.toDisplayString)((_$data_article_content7 = $data.article.content) === null || _$data_article_content7 === void 0 ? void 0 : _$data_article_content7.license), 513), [
                                                                                                [
                                                                                                    (0, $kiZwI.vShow),
                                                                                                    (_$data_article_content8 = $data.article.content) === null || _$data_article_content8 === void 0 ? void 0 : _$data_article_content8.license
                                                                                                ]
                                                                                            ]),
                                                                                            $data.searchMode === 'sparql' && ((_$data_article_content9 = $data.article.content) === null || _$data_article_content9 === void 0 ? void 0 : _$data_article_content9.sparqlData) ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("div", $bab61685f1e04f14$var$_hoisted_6, [
                                                                                                ((0, $bu8yf.openBlock)(true), (0, $bu8yf.createElementBlock)((0, $bu8yf.Fragment), null, (0, $bu8yf.renderList)($options.getAdditionalSparqlFields($data.article.content.sparqlData), function(value, key) {
                                                                                                    return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("div", {
                                                                                                        key: key,
                                                                                                        "class": "mb-1"
                                                                                                    }, [
                                                                                                        (0, $bu8yf.createElementVNode)("strong", null, (0, $d8jBh.toDisplayString)($options.formatFieldName(key)) + ":", 1),
                                                                                                        (0, $bu8yf.createTextVNode)(" " + (0, $d8jBh.toDisplayString)($options.formatFieldValue(value)), 1)
                                                                                                    ]);
                                                                                                }), 128))
                                                                                            ])) : (0, $bu8yf.createCommentVNode)("", true)
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }),
                                                                                (0, $bu8yf.createVNode)(_component_v_card_actions, {
                                                                                    "class": "pt-0"
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        return [
                                                                                            (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                color: "teal-accent-4",
                                                                                                text: "Download",
                                                                                                variant: "text",
                                                                                                onClick: _cache[6] || (_cache[6] = function($event) {
                                                                                                    var _$data_article_content;
                                                                                                    return $options.load((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.id);
                                                                                                })
                                                                                            }),
                                                                                            (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                color: "teal-accent-4",
                                                                                                text: "Erweitern",
                                                                                                variant: "text",
                                                                                                onClick: _cache[7] || (_cache[7] = function($event) {
                                                                                                    return $options.loadConnections($data.article.content);
                                                                                                })
                                                                                            })
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                })
                                                                            ];
                                                                        }),
                                                                        _: 1
                                                                    }, 512), [
                                                                        [
                                                                            (0, $kiZwI.vShow),
                                                                            $data.article.show && _this.split === 'graph'
                                                                        ]
                                                                    ])
                                                                ];
                                                            }),
                                                            _: 1
                                                        }, 8, [
                                                            "size"
                                                        ]),
                                                        (0, $bu8yf.createVNode)(_component_pane, {
                                                            size: $data.split === 'graph' ? 0 : $data.split === 'both' ? 30 : 100,
                                                            style: (0, $d8jBh.normalizeStyle)({
                                                                backgroundColor: $data.settings.darkMode ? 'black' : 'white'
                                                            })
                                                        }, {
                                                            "default": (0, $bu8yf.withCtx)(function() {
                                                                return [
                                                                    $data.split !== 'graph' && $data.searchMode === 'sparql' ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_card, {
                                                                        key: 0,
                                                                        "class": "ma-2 mb-0",
                                                                        style: (0, $d8jBh.normalizeStyle)({
                                                                            backgroundColor: $data.settings.darkMode ? '#1e1e1e' : '#f5f5f5',
                                                                            border: $data.settings.darkMode ? '1px solid #333' : '1px solid #ddd'
                                                                        })
                                                                    }, {
                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                            return [
                                                                                (0, $bu8yf.createVNode)(_component_v_card_title, {
                                                                                    "class": "pb-2"
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        return [
                                                                                            (0, $bu8yf.createVNode)(_component_v_icon, {
                                                                                                color: "accent",
                                                                                                "class": "mr-2"
                                                                                            }, {
                                                                                                "default": (0, $bu8yf.withCtx)(function() {
                                                                                                    return _cache[20] || (_cache[20] = [
                                                                                                        (0, $bu8yf.createTextVNode)("mdi-database-search", -1)
                                                                                                    ]);
                                                                                                }),
                                                                                                _: 1,
                                                                                                __: [
                                                                                                    20
                                                                                                ]
                                                                                            }),
                                                                                            _cache[22] || (_cache[22] = (0, $bu8yf.createTextVNode)(" SPARQL Query Interface ", -1)),
                                                                                            (0, $bu8yf.createVNode)(_component_v_spacer),
                                                                                            $data.sparqlFilters.active ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_chip, {
                                                                                                key: 0,
                                                                                                color: "accent",
                                                                                                size: "small"
                                                                                            }, {
                                                                                                "default": (0, $bu8yf.withCtx)(function() {
                                                                                                    return _cache[21] || (_cache[21] = [
                                                                                                        (0, $bu8yf.createTextVNode)(" Active Filter ", -1)
                                                                                                    ]);
                                                                                                }),
                                                                                                _: 1,
                                                                                                __: [
                                                                                                    21
                                                                                                ]
                                                                                            })) : (0, $bu8yf.createCommentVNode)("", true)
                                                                                        ];
                                                                                    }),
                                                                                    _: 1,
                                                                                    __: [
                                                                                        22
                                                                                    ]
                                                                                }),
                                                                                (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(_component_v_card_text, {
                                                                                    "class": "pt-0"
                                                                                }, {
                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                        return [
                                                                                            (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_7, [
                                                                                                (0, $bu8yf.createVNode)(_component_v_select, {
                                                                                                    modelValue: $data.selectedPresetQuery,
                                                                                                    "onUpdate:modelValue": [
                                                                                                        _cache[8] || (_cache[8] = function($event) {
                                                                                                            return $data.selectedPresetQuery = $event;
                                                                                                        }),
                                                                                                        $options.loadPresetQueryByKey
                                                                                                    ],
                                                                                                    items: $data.sparqlQueries,
                                                                                                    "item-title": "name",
                                                                                                    "item-value": "key",
                                                                                                    label: "Select a predefined query",
                                                                                                    "prepend-icon": "mdi-database-search",
                                                                                                    variant: "outlined",
                                                                                                    density: "compact",
                                                                                                    clearable: "",
                                                                                                    "class": "mb-2"
                                                                                                }, null, 8, [
                                                                                                    "modelValue",
                                                                                                    "items",
                                                                                                    "onUpdate:modelValue"
                                                                                                ])
                                                                                            ]),
                                                                                            (0, $bu8yf.createVNode)(_component_v_textarea, {
                                                                                                modelValue: $data.customSparqlQuery,
                                                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = function($event) {
                                                                                                    return $data.customSparqlQuery = $event;
                                                                                                }),
                                                                                                label: "Custom SPARQL Query",
                                                                                                placeholder: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:creator ?creator .\n} LIMIT 50",
                                                                                                rows: "8",
                                                                                                variant: "outlined",
                                                                                                style: (0, $d8jBh.normalizeStyle)({
                                                                                                    fontFamily: 'Courier New, monospace',
                                                                                                    backgroundColor: $data.settings.darkMode ? '#2d2d2d' : '#ffffff'
                                                                                                }),
                                                                                                "hide-details": "",
                                                                                                density: "compact"
                                                                                            }, null, 8, [
                                                                                                "modelValue",
                                                                                                "style"
                                                                                            ]),
                                                                                            $data.sparqlFilters.error ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_alert, {
                                                                                                key: 0,
                                                                                                type: "error",
                                                                                                variant: "tonal",
                                                                                                closable: "",
                                                                                                "class": "mt-3",
                                                                                                "onClick:close": _cache[10] || (_cache[10] = function($event) {
                                                                                                    return $data.sparqlFilters.error = null;
                                                                                                })
                                                                                            }, {
                                                                                                "default": (0, $bu8yf.withCtx)(function() {
                                                                                                    return [
                                                                                                        (0, $bu8yf.createVNode)(_component_v_alert_title, null, {
                                                                                                            "default": (0, $bu8yf.withCtx)(function() {
                                                                                                                return [
                                                                                                                    (0, $bu8yf.createVNode)(_component_v_icon, {
                                                                                                                        "class": "mr-2"
                                                                                                                    }, {
                                                                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                                                                            return _cache[23] || (_cache[23] = [
                                                                                                                                (0, $bu8yf.createTextVNode)("mdi-alert-circle", -1)
                                                                                                                            ]);
                                                                                                                        }),
                                                                                                                        _: 1,
                                                                                                                        __: [
                                                                                                                            23
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    _cache[24] || (_cache[24] = (0, $bu8yf.createTextVNode)(" Query Execution Failed ", -1))
                                                                                                                ];
                                                                                                            }),
                                                                                                            _: 1,
                                                                                                            __: [
                                                                                                                24
                                                                                                            ]
                                                                                                        }),
                                                                                                        (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_8, (0, $d8jBh.toDisplayString)($data.sparqlFilters.error), 1)
                                                                                                    ];
                                                                                                }),
                                                                                                _: 1
                                                                                            })) : (0, $bu8yf.createCommentVNode)("", true),
                                                                                            (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_9, [
                                                                                                (0, $bu8yf.createElementVNode)("div", null, [
                                                                                                    (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                        onClick: $options.executeCustomSparqlQuery,
                                                                                                        loading: $data.sparqlFilters.loading,
                                                                                                        disabled: $data.sparqlFilters.loading,
                                                                                                        color: "accent",
                                                                                                        variant: "elevated",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-play"
                                                                                                    }, {
                                                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                                                            return _cache[25] || (_cache[25] = [
                                                                                                                (0, $bu8yf.createTextVNode)(" Execute Query ", -1)
                                                                                                            ]);
                                                                                                        }),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            25
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick",
                                                                                                        "loading",
                                                                                                        "disabled"
                                                                                                    ]),
                                                                                                    $data.sparqlFilters.loading ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_btn, {
                                                                                                        key: 0,
                                                                                                        onClick: $options.stopSparqlQuery,
                                                                                                        color: "warning",
                                                                                                        variant: "elevated",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-stop",
                                                                                                        "class": "ml-2"
                                                                                                    }, {
                                                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                                                            return _cache[26] || (_cache[26] = [
                                                                                                                (0, $bu8yf.createTextVNode)(" Stop Query ", -1)
                                                                                                            ]);
                                                                                                        }),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            26
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick"
                                                                                                    ])) : (0, $bu8yf.createCommentVNode)("", true),
                                                                                                    $data.sparqlFilters.active && !$data.sparqlFilters.loading ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_btn, {
                                                                                                        key: 1,
                                                                                                        onClick: $options.clearSparqlFilters,
                                                                                                        color: "error",
                                                                                                        variant: "outlined",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-close",
                                                                                                        "class": "ml-2"
                                                                                                    }, {
                                                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                                                            return _cache[27] || (_cache[27] = [
                                                                                                                (0, $bu8yf.createTextVNode)(" Clear Filter ", -1)
                                                                                                            ]);
                                                                                                        }),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            27
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick"
                                                                                                    ])) : (0, $bu8yf.createCommentVNode)("", true)
                                                                                                ]),
                                                                                                (0, $bu8yf.createElementVNode)("div", null, [
                                                                                                    (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                        onClick: $options.toggleSparqlInterface,
                                                                                                        variant: "text",
                                                                                                        size: "small",
                                                                                                        icon: $data.showSparqlInterface ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                                                                    }, null, 8, [
                                                                                                        "onClick",
                                                                                                        "icon"
                                                                                                    ])
                                                                                                ])
                                                                                            ])
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }, 512), [
                                                                                    [
                                                                                        (0, $kiZwI.vShow),
                                                                                        $data.showSparqlInterface
                                                                                    ]
                                                                                ])
                                                                            ];
                                                                        }),
                                                                        _: 1
                                                                    }, 8, [
                                                                        "style"
                                                                    ])) : (0, $bu8yf.createCommentVNode)("", true),
                                                                    ((0, $bu8yf.openBlock)(), (0, $bu8yf.createBlock)(_component_v_virtual_scroll, {
                                                                        key: $data.version,
                                                                        ref: "list",
                                                                        items: $options.visibleNodes,
                                                                        height: $data.split !== 'graph' ? $data.searchMode === 'sparql' ? $data.showSparqlInterface ? 'calc(100vh - 350px)' : 'calc(100vh - 120px)' : 'calc(100vh - 48px)' : 'calc(100vh - 48px)'
                                                                    }, {
                                                                        "default": (0, $bu8yf.withCtx)(function(param) {
                                                                            var item = param.item;
                                                                            return [
                                                                                (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_10, [
                                                                                    (0, $bu8yf.createVNode)(_component_v_card, {
                                                                                        "class": (0, $d8jBh.normalizeClass)([
                                                                                            "mx-auto",
                                                                                            {
                                                                                                'border-accent': $data.searchMode === 'sparql' ? item.id === _this.activeSparqlId : item.id === _this.activeId
                                                                                            }
                                                                                        ]),
                                                                                        style: (0, $d8jBh.normalizeStyle)(($data.searchMode === 'sparql' ? item.id === _this.activeSparqlId : item.id === _this.activeId) ? 'border: 2px solid orange' : ''),
                                                                                        hover: "",
                                                                                        onClick: function($event) {
                                                                                            return $options.showArticle(item);
                                                                                        }
                                                                                    }, {
                                                                                        "default": (0, $bu8yf.withCtx)(function() {
                                                                                            return [
                                                                                                (0, $bu8yf.createVNode)(_component_v_card_item, {
                                                                                                    style: {
                                                                                                        "margin-top": "1rem"
                                                                                                    }
                                                                                                }, {
                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                        return [
                                                                                                            (0, $bu8yf.createElementVNode)("div", $bab61685f1e04f14$var$_hoisted_11, [
                                                                                                                (0, $bu8yf.createVNode)(_component_v_card_title, {
                                                                                                                    "class": "no-ellipsis pa-0",
                                                                                                                    style: {
                                                                                                                        flex: "1",
                                                                                                                        "min-width": "0",
                                                                                                                        "word-break": "break-word",
                                                                                                                        "line-height": "1.2"
                                                                                                                    }
                                                                                                                }, {
                                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                                        return [
                                                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)(item.title), 1)
                                                                                                                        ];
                                                                                                                    }),
                                                                                                                    _: 2
                                                                                                                }, 1024),
                                                                                                                (0, $bu8yf.createVNode)(_component_v_chip, {
                                                                                                                    size: "small",
                                                                                                                    color: "primary",
                                                                                                                    variant: "outlined",
                                                                                                                    "class": "ml-2",
                                                                                                                    style: {
                                                                                                                        "font-family": "monospace",
                                                                                                                        "flex-shrink": "0",
                                                                                                                        cursor: "pointer"
                                                                                                                    },
                                                                                                                    onClick: function($event) {
                                                                                                                        return $options.copyIdToClipboard($data.searchMode === 'sparql' && item.originalId ? item.originalId : item.id, $event);
                                                                                                                    },
                                                                                                                    title: "Click to copy ID"
                                                                                                                }, {
                                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                                        return [
                                                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)($data.searchMode === "sparql" && item.originalId ? item.originalId : item.id), 1)
                                                                                                                        ];
                                                                                                                    }),
                                                                                                                    _: 2
                                                                                                                }, 1032, [
                                                                                                                    "onClick"
                                                                                                                ])
                                                                                                            ]),
                                                                                                            (0, $bu8yf.createVNode)(_component_v_card_subtitle, null, {
                                                                                                                "default": (0, $bu8yf.withCtx)(function() {
                                                                                                                    return [
                                                                                                                        (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)(item.authors) + " ", 1),
                                                                                                                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, "-", 512), [
                                                                                                                            [
                                                                                                                                (0, $kiZwI.vShow),
                                                                                                                                item.authors && item.affiliation
                                                                                                                            ]
                                                                                                                        ]),
                                                                                                                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, [
                                                                                                                            _cache[28] || (_cache[28] = (0, $bu8yf.createTextVNode)(" (", -1)),
                                                                                                                            (0, $bu8yf.createElementVNode)("i", null, (0, $d8jBh.toDisplayString)(item.affiliation), 1),
                                                                                                                            _cache[29] || (_cache[29] = (0, $bu8yf.createTextVNode)(") ", -1))
                                                                                                                        ], 512), [
                                                                                                                            [
                                                                                                                                (0, $kiZwI.vShow),
                                                                                                                                item.affiliation
                                                                                                                            ]
                                                                                                                        ])
                                                                                                                    ];
                                                                                                                }),
                                                                                                                _: 2
                                                                                                            }, 1024)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 2
                                                                                                }, 1024),
                                                                                                (0, $bu8yf.createVNode)(_component_v_card_text, null, {
                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                        var _item_tag;
                                                                                                        return [
                                                                                                            (0, $bu8yf.createTextVNode)((0, $d8jBh.toDisplayString)(item.summary) + " ", 1),
                                                                                                            (0, $bu8yf.createVNode)(_component_v_divider, {
                                                                                                                "class": "my-2"
                                                                                                            }),
                                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("ul", $bab61685f1e04f14$var$_hoisted_12, [
                                                                                                                ((0, $bu8yf.openBlock)(true), (0, $bu8yf.createElementBlock)((0, $bu8yf.Fragment), null, (0, $bu8yf.renderList)(item.tag || [], function(tag) {
                                                                                                                    return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("li", null, (0, $d8jBh.toDisplayString)(tag), 1);
                                                                                                                }), 256))
                                                                                                            ], 512), [
                                                                                                                [
                                                                                                                    (0, $kiZwI.vShow),
                                                                                                                    (_item_tag = item.tag) === null || _item_tag === void 0 ? void 0 : _item_tag.length
                                                                                                                ]
                                                                                                            ]),
                                                                                                            (0, $bu8yf.createVNode)(_component_v_divider, {
                                                                                                                "class": "my-2"
                                                                                                            }),
                                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", null, "Typ: " + (0, $d8jBh.toDisplayString)(item.type) + " / " + (0, $d8jBh.toDisplayString)(item.file), 513), [
                                                                                                                [
                                                                                                                    (0, $kiZwI.vShow),
                                                                                                                    item.type || item.file
                                                                                                                ]
                                                                                                            ]),
                                                                                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", null, "Lizenz: " + (0, $d8jBh.toDisplayString)(item === null || item === void 0 ? void 0 : item.license), 513), [
                                                                                                                [
                                                                                                                    (0, $kiZwI.vShow),
                                                                                                                    item === null || item === void 0 ? void 0 : item.license
                                                                                                                ]
                                                                                                            ]),
                                                                                                            $data.searchMode === 'sparql' && item.sparqlData ? ((0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("div", $bab61685f1e04f14$var$_hoisted_13, [
                                                                                                                ((0, $bu8yf.openBlock)(true), (0, $bu8yf.createElementBlock)((0, $bu8yf.Fragment), null, (0, $bu8yf.renderList)($options.getAdditionalSparqlFields(item.sparqlData), function(value, key) {
                                                                                                                    return (0, $bu8yf.openBlock)(), (0, $bu8yf.createElementBlock)("div", {
                                                                                                                        key: key,
                                                                                                                        "class": "mb-1"
                                                                                                                    }, [
                                                                                                                        (0, $bu8yf.createElementVNode)("strong", null, (0, $d8jBh.toDisplayString)($options.formatFieldName(key)) + ":", 1),
                                                                                                                        (0, $bu8yf.createTextVNode)(" " + (0, $d8jBh.toDisplayString)($options.formatFieldValue(value)), 1)
                                                                                                                    ]);
                                                                                                                }), 128))
                                                                                                            ])) : (0, $bu8yf.createCommentVNode)("", true)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 2
                                                                                                }, 1024),
                                                                                                (0, $bu8yf.createVNode)(_component_v_card_actions, {
                                                                                                    "class": "pt-0"
                                                                                                }, {
                                                                                                    "default": (0, $bu8yf.withCtx)(function() {
                                                                                                        return [
                                                                                                            (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                                color: "teal-accent-4",
                                                                                                                text: "Download",
                                                                                                                variant: "text",
                                                                                                                onClick: (0, $kiZwI.withModifiers)(function($event) {
                                                                                                                    return $options.load($data.searchMode === 'sparql' && item.originalId ? item.originalId : item.id);
                                                                                                                }, [
                                                                                                                    "stop"
                                                                                                                ])
                                                                                                            }, null, 8, [
                                                                                                                "onClick"
                                                                                                            ]),
                                                                                                            (0, $bu8yf.createVNode)(_component_v_btn, {
                                                                                                                color: "teal-accent-4",
                                                                                                                text: "Erweitern",
                                                                                                                variant: "text",
                                                                                                                onClick: (0, $kiZwI.withModifiers)(function($event) {
                                                                                                                    return $options.loadConnections(item);
                                                                                                                }, [
                                                                                                                    "stop"
                                                                                                                ])
                                                                                                            }, null, 8, [
                                                                                                                "onClick"
                                                                                                            ])
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 2
                                                                                                }, 1024)
                                                                                            ];
                                                                                        }),
                                                                                        _: 2
                                                                                    }, 1032, [
                                                                                        "class",
                                                                                        "style",
                                                                                        "onClick"
                                                                                    ])
                                                                                ])
                                                                            ];
                                                                        }),
                                                                        _: 1
                                                                    }, 8, [
                                                                        "items",
                                                                        "height"
                                                                    ]))
                                                                ];
                                                            }),
                                                            _: 1
                                                        }, 8, [
                                                            "size",
                                                            "style"
                                                        ])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, [
                                                "horizontal"
                                            ])
                                        ];
                                    }),
                                    _: 1
                                })
                            ];
                        }),
                        _: 1
                    })
                ];
            }),
            _: 1
        }),
        (0, $bu8yf.createVNode)(_component_v_dialog, {
            modelValue: $data.open.description,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = function($event) {
                return $data.open.description = $event;
            }),
            width: "auto"
        }, {
            "default": (0, $bu8yf.withCtx)(function() {
                return [
                    (0, $bu8yf.createVNode)(_component_v_card, {
                        "max-width": "800",
                        "prepend-icon": "mdi-information-outline",
                        title: "Beschreibung"
                    }, {
                        actions: (0, $bu8yf.withCtx)(function() {
                            return [
                                (0, $bu8yf.createVNode)(_component_v_btn, {
                                    "class": "ms-auto",
                                    text: "Ok",
                                    onClick: _cache[11] || (_cache[11] = function($event) {
                                        return $data.open.description = false;
                                    })
                                })
                            ];
                        }),
                        "default": (0, $bu8yf.withCtx)(function() {
                            return [
                                (0, $bu8yf.createVNode)(_component_v_card_text, null, {
                                    "default": (0, $bu8yf.withCtx)(function() {
                                        return _cache[30] || (_cache[30] = [
                                            (0, $bu8yf.createTextVNode)(" Diese Karte zeigt das ", -1),
                                            (0, $bu8yf.createElementVNode)("i", null, "Netzwerk", -1),
                                            (0, $bu8yf.createTextVNode)(" aller OER-Inhalte des s\xe4chsischen OPAL-Systems. Jeder ", -1),
                                            (0, $bu8yf.createElementVNode)("i", null, "Knoten", -1),
                                            (0, $bu8yf.createTextVNode)(" stellt einen OER-Inhalt dar und jede Kante eine \xc4hnlichkeitsbeziehung zwischen den Beitr\xe4gen. ", -1),
                                            (0, $bu8yf.createElementVNode)("br", null, null, -1),
                                            (0, $bu8yf.createElementVNode)("br", null, null, -1),
                                            (0, $bu8yf.createElementVNode)("strong", null, "SPARQL-Filter:", -1),
                                            (0, $bu8yf.createTextVNode)(" Verwenden Sie die SPARQL-Abfrage-Oberfl\xe4che, um die angezeigten Inhalte zu filtern und spezifische Lernressourcen zu finden. ", -1)
                                        ]);
                                    }),
                                    _: 1,
                                    __: [
                                        30
                                    ]
                                })
                            ];
                        }),
                        _: 1
                    })
                ];
            }),
            _: 1
        }, 8, [
            "modelValue"
        ])
    ], 64);
}

});

parcelRegister("20gUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1758b3964aef51db$export$2e2bcd8739ae039; });
var $1758b3964aef51db$var$NOOP = function() {};
var $1758b3964aef51db$export$2e2bcd8739ae039 = function(script) {};

});


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $kiZwI = parcelRequire("kiZwI");
// Composables

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");
// Composables
// Utilities

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Composables

var $iT0je = parcelRequire("iT0je");
// Composables
// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
function $f1963cd898950c2d$export$fa3cd679bf7c4ed(source, fn) {
    var scope;
    function start() {
        scope = (0, $hXmfK.effectScope)();
        scope.run(function() {
            return fn.length ? fn(function() {
                scope === null || scope === void 0 ? void 0 : scope.stop();
                start();
            }) : fn();
        });
    }
    (0, $hXmfK.watch)(source, function(active) {
        if (active && !scope) start();
        else if (!active) {
            scope === null || scope === void 0 ? void 0 : scope.stop();
            scope = undefined;
        }
    }, {
        immediate: true
    });
    (0, $hXmfK.onScopeDispose)(function() {
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");
var $10db88b646d64b14$export$13a6ee1b6d6a0cfd = typeof window !== 'undefined';
var $10db88b646d64b14$export$8cb82f5817a92ac4 = $10db88b646d64b14$export$13a6ee1b6d6a0cfd && 'IntersectionObserver' in window;
var $10db88b646d64b14$export$a5f9edc0876666e5 = $10db88b646d64b14$export$13a6ee1b6d6a0cfd && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0);
var $10db88b646d64b14$export$c0654247a3e5665d = $10db88b646d64b14$export$13a6ee1b6d6a0cfd && 'EyeDropper' in window;
var $10db88b646d64b14$export$622094c5d6c3013b = $10db88b646d64b14$export$13a6ee1b6d6a0cfd && 'matchMedia' in window && typeof window.matchMedia === 'function';


function $31779689cfd5da50$var$_classPrivateFieldInitSpec(e, t, a) {
    $31779689cfd5da50$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $31779689cfd5da50$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $31779689cfd5da50$var$_classPrivateFieldSet(s, a, r) {
    return s.set($31779689cfd5da50$var$_assertClassBrand(s, a), r), r;
}
function $31779689cfd5da50$var$_classPrivateFieldGet(s, a) {
    return s.get($31779689cfd5da50$var$_assertClassBrand(s, a));
}
function $31779689cfd5da50$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $31779689cfd5da50$export$2516322ffbb7f3fb(obj, path, fallback) {
    var last = path.length - 1;
    if (last < 0) return obj === undefined ? fallback : obj;
    for(var i = 0; i < last; i++){
        if (obj == null) return fallback;
        obj = obj[path[i]];
    }
    if (obj == null) return fallback;
    return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function $31779689cfd5da50$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) // If the values are Date, compare them as timestamps
    return false;
    if (a !== Object(a) || b !== Object(b)) // If the values aren't objects, they were already checked for equality
    return false;
    var props = Object.keys(a);
    if (props.length !== Object.keys(b).length) // Different number of props, don't bother to check
    return false;
    return props.every(function(p) {
        return $31779689cfd5da50$export$9cb4719e2e525b7a(a[p], b[p]);
    });
}
function $31779689cfd5da50$export$f5474208cafa7b66(obj, path, fallback) {
    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
    if (obj == null || !path || typeof path !== 'string') return fallback;
    if (obj[path] !== undefined) return obj[path];
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    return $31779689cfd5da50$export$2516322ffbb7f3fb(obj, path.split('.'), fallback);
}
function $31779689cfd5da50$export$655f0e681f1365dc(item, property, fallback) {
    if (property === true) return item === undefined ? fallback : item;
    if (property == null || typeof property === 'boolean') return fallback;
    if (item !== Object(item)) {
        if (typeof property !== 'function') return fallback;
        var value = property(item, fallback);
        return typeof value === 'undefined' ? fallback : value;
    }
    if (typeof property === 'string') return $31779689cfd5da50$export$f5474208cafa7b66(item, property, fallback);
    if (Array.isArray(property)) return $31779689cfd5da50$export$2516322ffbb7f3fb(item, property, fallback);
    if (typeof property !== 'function') return fallback;
    var value1 = property(item, fallback);
    return typeof value1 === 'undefined' ? fallback : value1;
}
function $31779689cfd5da50$export$d372f2f3c4d1b8e5(length) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.from({
        length: length
    }, function(v, k) {
        return start + k;
    });
}
function $31779689cfd5da50$export$9b544f58430fc883(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
    var index = Number(window.getComputedStyle(el).getPropertyValue('z-index'));
    if (!index) return $31779689cfd5da50$export$9b544f58430fc883(el.parentNode);
    return index;
}
function $31779689cfd5da50$export$286ad215293a0860(str) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
    if (str == null || str === '') return undefined;
    var num = Number(str);
    if (isNaN(num)) return String(str);
    else if (!isFinite(num)) return undefined;
    else return "".concat(num).concat(unit);
}
function $31779689cfd5da50$export$a6cdc56e425d0d0a(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : (0, $3KZcf._)(obj)) === 'object' && !Array.isArray(obj);
}
function $31779689cfd5da50$export$53b83ca8eaab0383(obj) {
    var proto;
    return obj !== null && (typeof obj === "undefined" ? "undefined" : (0, $3KZcf._)(obj)) === 'object' && ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto === null);
}
function $31779689cfd5da50$export$2bffc57ac06742e2(obj) {
    if (obj && '$el' in obj) {
        var el = obj.$el;
        if ((el === null || el === void 0 ? void 0 : el.nodeType) === Node.TEXT_NODE) // Multi-root component, use the first element
        return el.nextElementSibling;
        return el;
    }
    return obj;
}
var $31779689cfd5da50$export$6d3e562ac77a9517 = Object.freeze({
    enter: 13,
    tab: 9,
    "delete": 46,
    esc: 27,
    space: 32,
    up: 38,
    down: 40,
    left: 37,
    right: 39,
    end: 35,
    home: 36,
    del: 46,
    backspace: 8,
    insert: 45,
    pageup: 33,
    pagedown: 34,
    shift: 16
});
var $31779689cfd5da50$export$4f79075d7446a261 = Object.freeze({
    enter: 'Enter',
    tab: 'Tab',
    "delete": 'Delete',
    esc: 'Escape',
    space: 'Space',
    up: 'ArrowUp',
    down: 'ArrowDown',
    left: 'ArrowLeft',
    right: 'ArrowRight',
    end: 'End',
    home: 'Home',
    del: 'Delete',
    backspace: 'Backspace',
    insert: 'Insert',
    pageup: 'PageUp',
    pagedown: 'PageDown',
    shift: 'Shift'
});
function $31779689cfd5da50$export$ed97f33186d4b816(o) {
    return Object.keys(o);
}
function $31779689cfd5da50$export$a4f4bb6b1453fff5(obj, key) {
    return key.every(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $31779689cfd5da50$export$357523c63a2253b9(obj, paths) {
    var found = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (Object.prototype.hasOwnProperty.call(obj, key)) found[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return found;
}
function $31779689cfd5da50$export$b25139123a794551(obj, paths, exclude) {
    var _loop = function(key) {
        if (paths.some(function(path) {
            return path instanceof RegExp ? path.test(key) : path === key;
        }) && !(exclude === null || exclude === void 0 ? void 0 : exclude.some(function(path) {
            return path === key;
        }))) found[key] = obj[key];
        else rest[key] = obj[key];
    };
    var found = Object.create(null);
    var rest = Object.create(null);
    for(var key in obj)_loop(key);
    return [
        found,
        rest
    ];
}
function $31779689cfd5da50$export$30a06c8d3562193f(obj, exclude) {
    var clone = (0, $iT0je._)({}, obj);
    exclude.forEach(function(prop) {
        return delete clone[prop];
    });
    return clone;
}
var $31779689cfd5da50$var$onRE = /^on[^a-z]/;
var $31779689cfd5da50$export$1a2d97de39ecbb75 = function(key) {
    return $31779689cfd5da50$var$onRE.test(key);
};
var $31779689cfd5da50$var$bubblingEvents = [
    'onAfterscriptexecute',
    'onAnimationcancel',
    'onAnimationend',
    'onAnimationiteration',
    'onAnimationstart',
    'onAuxclick',
    'onBeforeinput',
    'onBeforescriptexecute',
    'onChange',
    'onClick',
    'onCompositionend',
    'onCompositionstart',
    'onCompositionupdate',
    'onContextmenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onFocusin',
    'onFocusout',
    'onFullscreenchange',
    'onFullscreenerror',
    'onGesturechange',
    'onGestureend',
    'onGesturestart',
    'onGotpointercapture',
    'onInput',
    'onKeydown',
    'onKeypress',
    'onKeyup',
    'onLostpointercapture',
    'onMousedown',
    'onMousemove',
    'onMouseout',
    'onMouseover',
    'onMouseup',
    'onMousewheel',
    'onPaste',
    'onPointercancel',
    'onPointerdown',
    'onPointerenter',
    'onPointerleave',
    'onPointermove',
    'onPointerout',
    'onPointerover',
    'onPointerup',
    'onReset',
    'onSelect',
    'onSubmit',
    'onTouchcancel',
    'onTouchend',
    'onTouchmove',
    'onTouchstart',
    'onTransitioncancel',
    'onTransitionend',
    'onTransitionrun',
    'onTransitionstart',
    'onWheel'
];
var $31779689cfd5da50$var$compositionIgnoreKeys = [
    'ArrowUp',
    'ArrowDown',
    'ArrowRight',
    'ArrowLeft',
    'Enter',
    'Escape',
    'Tab',
    ' '
];
function $31779689cfd5da50$export$af97bfee12e57e9c(e) {
    return e.isComposing && $31779689cfd5da50$var$compositionIgnoreKeys.includes(e.key);
}
function $31779689cfd5da50$export$c46dde8a23cbfcf2(attrs) {
    var _pickWithRest = (0, $32TW8._)($31779689cfd5da50$export$b25139123a794551(attrs, [
        $31779689cfd5da50$var$onRE
    ]), 2), events = _pickWithRest[0], props = _pickWithRest[1];
    var inputEvents = $31779689cfd5da50$export$30a06c8d3562193f(events, $31779689cfd5da50$var$bubblingEvents);
    var _pickWithRest1 = (0, $32TW8._)($31779689cfd5da50$export$b25139123a794551(props, [
        'class',
        'style',
        'id',
        /^data-/
    ]), 2), rootAttrs = _pickWithRest1[0], inputAttrs = _pickWithRest1[1];
    Object.assign(rootAttrs, events);
    Object.assign(inputAttrs, inputEvents);
    return [
        rootAttrs,
        inputAttrs
    ];
}
function $31779689cfd5da50$export$c60e0e71ff2ff066(a, b) {
    var diff = [];
    for(var i = 0; i < b.length; i++)if (!a.includes(b[i])) diff.push(b[i]);
    return diff;
}
function $31779689cfd5da50$export$76411cac38121ecb(v) {
    return v == null ? [] : Array.isArray(v) ? v : [
        v
    ];
}
function $31779689cfd5da50$export$3f6f640afaf1ec43(value, search, item) {
    return value != null && search != null && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}
function $31779689cfd5da50$export$61fc7d43ac8f84b0(fn, delay) {
    var timeoutId = 0;
    var wrap = function wrap() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return fn.apply(void 0, (0, $7WNf6._)(args));
        }, (0, $hXmfK.unref)(delay));
    };
    wrap.clear = function() {
        clearTimeout(timeoutId);
    };
    wrap.immediate = fn;
    return wrap;
}
function $31779689cfd5da50$export$de363e709c412c8a(fn, limit) {
    var throttling = false;
    return function() {
        if (!throttling) {
            throttling = true;
            setTimeout(function() {
                return throttling = false;
            }, limit);
            return fn.apply(void 0, arguments);
        }
    };
}
function $31779689cfd5da50$export$7d15b64cf5a3a4c4(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.max(min, Math.min(max, value));
}
function $31779689cfd5da50$export$1ecb455da4aa739b(value) {
    var trimmedStr = value.toString().trim();
    return trimmedStr.includes('.') ? trimmedStr.length - trimmedStr.indexOf('.') - 1 : 0;
}
function $31779689cfd5da50$export$23a07ddfce9fad49(str, length) {
    var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return str + char.repeat(Math.max(0, length - str.length));
}
function $31779689cfd5da50$export$36cf564d487b5178(str, length) {
    var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return char.repeat(Math.max(0, length - str.length)) + str;
}
function $31779689cfd5da50$export$5f7ec48d69707ddd(str) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var chunked = [];
    var index = 0;
    while(index < str.length){
        chunked.push(str.substr(index, size));
        index += size;
    }
    return chunked;
}
function $31779689cfd5da50$export$f922ebe57f2c36e8(array) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Array.from({
        length: Math.ceil(array.length / size)
    }, function(v, i) {
        return array.slice(i * size, i * size + size);
    });
}
function $31779689cfd5da50$export$dfc82bc1332b0cba(bytes) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    if (bytes < base) return "".concat(bytes, " B");
    var prefix = base === 1024 ? [
        'Ki',
        'Mi',
        'Gi'
    ] : [
        'k',
        'M',
        'G'
    ];
    var unit = -1;
    while(Math.abs(bytes) >= base && unit < prefix.length - 1){
        bytes /= base;
        ++unit;
    }
    return "".concat(bytes.toFixed(1), " ").concat(prefix[unit], "B");
}
function $31779689cfd5da50$export$dd702b3c8240390c() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var arrayFn = arguments.length > 2 ? arguments[2] : undefined;
    var out = {};
    for(var key in source)out[key] = source[key];
    for(var key1 in target){
        var sourceProperty = source[key1];
        var targetProperty = target[key1];
        // Only continue deep merging if
        // both properties are plain objects
        if ($31779689cfd5da50$export$53b83ca8eaab0383(sourceProperty) && $31779689cfd5da50$export$53b83ca8eaab0383(targetProperty)) {
            out[key1] = $31779689cfd5da50$export$dd702b3c8240390c(sourceProperty, targetProperty, arrayFn);
            continue;
        }
        if (arrayFn && Array.isArray(sourceProperty) && Array.isArray(targetProperty)) {
            out[key1] = arrayFn(sourceProperty, targetProperty);
            continue;
        }
        out[key1] = targetProperty;
    }
    return out;
}
function $31779689cfd5da50$export$c556ee00a0535018(nodes) {
    return nodes.map(function(node) {
        if (node.type === (0, $bu8yf.Fragment)) return $31779689cfd5da50$export$c556ee00a0535018(node.children);
        else return node;
    }).flat();
}
function $31779689cfd5da50$export$73bda83cddbc7187() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if ($31779689cfd5da50$export$73bda83cddbc7187.cache.has(str)) return $31779689cfd5da50$export$73bda83cddbc7187.cache.get(str);
    var kebab = str.replace(/[^a-z]/gi, '-').replace(/\B([A-Z])/g, '-$1').toLowerCase();
    $31779689cfd5da50$export$73bda83cddbc7187.cache.set(str, kebab);
    return kebab;
}
$31779689cfd5da50$export$73bda83cddbc7187.cache = new Map();
function $31779689cfd5da50$export$424fe43b65f39668(key, vnode) {
    if (!vnode || (typeof vnode === "undefined" ? "undefined" : (0, $3KZcf._)(vnode)) !== 'object') return [];
    if (Array.isArray(vnode)) return vnode.map(function(child) {
        return $31779689cfd5da50$export$424fe43b65f39668(key, child);
    }).flat(1);
    else if (vnode.suspense) return $31779689cfd5da50$export$424fe43b65f39668(key, vnode.ssContent);
    else if (Array.isArray(vnode.children)) return vnode.children.map(function(child) {
        return $31779689cfd5da50$export$424fe43b65f39668(key, child);
    }).flat(1);
    else if (vnode.component) {
        if (Object.getOwnPropertySymbols(vnode.component.provides).includes(key)) return [
            vnode.component
        ];
        else if (vnode.component.subTree) return $31779689cfd5da50$export$424fe43b65f39668(key, vnode.component.subTree).flat(1);
    }
    return [];
}
var $31779689cfd5da50$var$_arr = /*#__PURE__*/ new WeakMap();
var $31779689cfd5da50$var$_pointer = /*#__PURE__*/ new WeakMap();
var $31779689cfd5da50$export$5900cd5f89b9a13a = /*#__PURE__*/ function() {
    "use strict";
    function CircularBuffer(size) {
        (0, $jGAMp._)(this, CircularBuffer);
        $31779689cfd5da50$var$_classPrivateFieldInitSpec(this, $31779689cfd5da50$var$_arr, []);
        $31779689cfd5da50$var$_classPrivateFieldInitSpec(this, $31779689cfd5da50$var$_pointer, 0);
        this.size = size;
    }
    (0, $byiyg._)(CircularBuffer, [
        {
            key: "isFull",
            get: function get() {
                return $31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_arr, this).length === this.size;
            }
        },
        {
            key: "push",
            value: function push(val) {
                $31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_arr, this)[$31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_pointer, this)] = val;
                $31779689cfd5da50$var$_classPrivateFieldSet($31779689cfd5da50$var$_pointer, this, ($31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_pointer, this) + 1) % this.size);
            }
        },
        {
            key: "values",
            value: function values() {
                return $31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_arr, this).slice($31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_pointer, this)).concat($31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_arr, this).slice(0, $31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_pointer, this)));
            }
        },
        {
            key: "clear",
            value: function clear() {
                $31779689cfd5da50$var$_classPrivateFieldGet($31779689cfd5da50$var$_arr, this).length = 0;
                $31779689cfd5da50$var$_classPrivateFieldSet($31779689cfd5da50$var$_pointer, this, 0);
            }
        }
    ]);
    return CircularBuffer;
}();
function $31779689cfd5da50$export$36195c8aa1517e04(e) {
    if ('touches' in e) return {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY
    };
    return {
        clientX: e.clientX,
        clientY: e.clientY
    };
}
function $31779689cfd5da50$export$fe6a5b56d01db4f5(getter) {
    var _loop = function(key) {
        obj[key] = (0, $hXmfK.toRef)(function() {
            return refs[key];
        });
    };
    var refs = (0, $hXmfK.reactive)({});
    (0, $bu8yf.watchEffect)(function() {
        var base = getter();
        for(var key in base)refs[key] = base[key];
    }, {
        flush: 'sync'
    });
    var obj = {};
    for(var key in refs)_loop(key);
    return obj;
}
function $31779689cfd5da50$export$ee2e0f811dca1807(arr, val) {
    return arr.includes(val);
}
function $31779689cfd5da50$export$a0305a8c6cff19c8(propName) {
    return propName[2].toLowerCase() + propName.slice(3);
}
var $31779689cfd5da50$export$cefab237a347bf23 = function() {
    return [
        Function,
        Array
    ];
};
function $31779689cfd5da50$export$1f08a0593c4a067d(props, name) {
    name = 'on' + (0, $d8jBh.capitalize)(name);
    return !!(props[name] || props["".concat(name, "Once")] || props["".concat(name, "Capture")] || props["".concat(name, "OnceCapture")] || props["".concat(name, "CaptureOnce")]);
}
function $31779689cfd5da50$export$293b251ea77dc2b7(handler) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (Array.isArray(handler)) try {
        for(var _iterator = handler[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var h = _step.value;
            h.apply(void 0, (0, $7WNf6._)(args));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (typeof handler === 'function') handler.apply(void 0, (0, $7WNf6._)(args));
}
function $31779689cfd5da50$export$aea49dace3f6ca76(el) {
    var filterByTabIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var targets = [
        'button',
        '[href]',
        'input:not([type="hidden"])',
        'select',
        'textarea',
        '[tabindex]'
    ].map(function(s) {
        return "".concat(s).concat(filterByTabIndex ? ':not([tabindex="-1"])' : '', ":not([disabled])");
    }).join(', ');
    return (0, $7WNf6._)(el.querySelectorAll(targets));
}
function $31779689cfd5da50$export$4109ed81edd7716d(elements, location, condition) {
    var _el;
    var idx = elements.indexOf(document.activeElement);
    var inc = location === 'next' ? 1 : -1;
    var _condition;
    do {
        idx += inc;
        _el = elements[idx];
    }while ((!_el || _el.offsetParent == null || !((_condition = condition === null || condition === void 0 ? void 0 : condition(_el)) !== null && _condition !== void 0 ? _condition : true)) && idx < elements.length && idx >= 0);
    return _el;
}
function $31779689cfd5da50$export$da2eafa20d5ebba(el, location) {
    var _focusable_, _focusable_1, _focusable_at, _focusable_location;
    var focusable = $31779689cfd5da50$export$aea49dace3f6ca76(el);
    if (location == null) {
        if (el === document.activeElement || !el.contains(document.activeElement)) (_focusable_ = focusable[0]) === null || _focusable_ === void 0 ? void 0 : _focusable_.focus();
    } else if (location === 'first') (_focusable_1 = focusable[0]) === null || _focusable_1 === void 0 ? void 0 : _focusable_1.focus();
    else if (location === 'last') (_focusable_at = focusable.at(-1)) === null || _focusable_at === void 0 ? void 0 : _focusable_at.focus();
    else if (typeof location === 'number') (_focusable_location = focusable[location]) === null || _focusable_location === void 0 ? void 0 : _focusable_location.focus();
    else {
        var _el = $31779689cfd5da50$export$4109ed81edd7716d(focusable, location);
        if (_el) _el.focus();
        else $31779689cfd5da50$export$da2eafa20d5ebba(el, location === 'next' ? 'first' : 'last');
    }
}
function $31779689cfd5da50$export$dd1bc94b04021eeb(val) {
    return val === null || val === undefined || typeof val === 'string' && val.trim() === '';
}
function $31779689cfd5da50$export$8793edee2d425525() {}
function $31779689cfd5da50$export$b06a2f5618961e1e(el, selector) {
    var supportsSelector = (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && typeof CSS !== 'undefined' && typeof CSS.supports !== 'undefined' && CSS.supports("selector(".concat(selector, ")"));
    if (!supportsSelector) return null;
    try {
        return !!el && el.matches(selector);
    } catch (err) {
        return null;
    }
}
function $31779689cfd5da50$export$9fc41f261330971f(vnodes) {
    return vnodes.some(function(child) {
        if (!(0, $bu8yf.isVNode)(child)) return true;
        if (child.type === (0, $bu8yf.Comment)) return false;
        return child.type !== (0, $bu8yf.Fragment) || $31779689cfd5da50$export$9fc41f261330971f(child.children);
    }) ? vnodes : null;
}
function $31779689cfd5da50$export$4abee4c34694ada1(slot, props, fallback) {
    var _slot;
    // TODO: check if slot returns elements: #18308
    return (_slot = slot === null || slot === void 0 ? void 0 : slot(props)) !== null && _slot !== void 0 ? _slot : fallback === null || fallback === void 0 ? void 0 : fallback(props);
}
function $31779689cfd5da50$export$260e5c0943f31606(timeout, cb) {
    if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) || timeout === 0) {
        cb();
        return function() {};
    }
    var timeoutId = window.setTimeout(cb, timeout);
    return function() {
        return window.clearTimeout(timeoutId);
    };
}
function $31779689cfd5da50$export$4430641350aec15f(event, targetDiv) {
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var divRect = targetDiv.getBoundingClientRect();
    var divLeft = divRect.left;
    var divTop = divRect.top;
    var divRight = divRect.right;
    var divBottom = divRect.bottom;
    return mouseX >= divLeft && mouseX <= divRight && mouseY >= divTop && mouseY <= divBottom;
}
function $31779689cfd5da50$export$fc38e812d383221() {
    var el = (0, $hXmfK.shallowRef)();
    var fn = function(target) {
        el.value = target;
    };
    Object.defineProperty(fn, 'value', {
        enumerable: true,
        get: function() {
            return el.value;
        },
        set: function(val) {
            return el.value = val;
        }
    });
    Object.defineProperty(fn, 'el', {
        enumerable: true,
        get: function() {
            return $31779689cfd5da50$export$2bffc57ac06742e2(el.value);
        }
    });
    return fn;
}
function $31779689cfd5da50$export$d9d503bf19df5a70(e) {
    var isPrintableChar = e.key.length === 1;
    var noModifier = !e.ctrlKey && !e.metaKey && !e.altKey;
    return isPrintableChar && noModifier;
}
function $31779689cfd5da50$export$c3825b437cbdea5c(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'bigint';
}
function $31779689cfd5da50$export$211de94a4ac98986(sign) {
    return '\\^$*+?.()|{}[]'.includes(sign) ? "\\".concat(sign) : sign;
}
function $31779689cfd5da50$export$ee2b54e92bdbaa0c(text, decimalDigitsLimit, decimalSeparator) {
    var onlyValidCharacters = new RegExp("[\\d\\-".concat($31779689cfd5da50$export$211de94a4ac98986(decimalSeparator), "]"));
    var cleanText = text.split('').filter(function(x) {
        return onlyValidCharacters.test(x);
    }).filter(function(x, i, all) {
        return i === 0 && /[-]/.test(x) || // sign allowed at the start
        x === decimalSeparator && i === all.indexOf(x) || // decimal separator allowed only once
        /\d/.test(x);
    }).join('');
    if (decimalDigitsLimit === 0) return cleanText.split(decimalSeparator)[0];
    var decimalPart = new RegExp("".concat($31779689cfd5da50$export$211de94a4ac98986(decimalSeparator), "\\d"));
    if (decimalDigitsLimit !== null && decimalPart.test(cleanText)) {
        var parts = cleanText.split(decimalSeparator);
        return [
            parts[0],
            parts[1].substring(0, decimalDigitsLimit)
        ].join(decimalSeparator);
    }
    return cleanText;
}
function $31779689cfd5da50$export$32263599c7ddd4ae(props) {
    var out = {};
    for(var prop in props)out[(0, $d8jBh.camelize)(prop)] = props[prop];
    return out;
}
function $31779689cfd5da50$export$bdca1cff95cf548c(props) {
    var booleanAttributes = [
        'checked',
        'disabled'
    ];
    return Object.fromEntries(Object.entries(props).filter(function(_ref) {
        var _$_ref = (0, $32TW8._)(_ref, 2), key = _$_ref[0], v = _$_ref[1];
        return booleanAttributes.includes(key) ? !!v : v !== undefined;
    }));
}


function $f4cc842872cc2659$export$f13e630aa3915748(name, message) {
    var vm = (0, $bu8yf.getCurrentInstance)();
    if (!vm) throw new Error("[Vuetify] ".concat(name, " ").concat(message || 'must be called from inside a setup function'));
    return vm;
}
function $f4cc842872cc2659$export$8adb83c1b7a9d7ae() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'composables';
    var vm = $f4cc842872cc2659$export$f13e630aa3915748(name).type;
    return (0, $31779689cfd5da50$export$73bda83cddbc7187)((vm === null || vm === void 0 ? void 0 : vm.aliasName) || (vm === null || vm === void 0 ? void 0 : vm.name));
}


function $26380e0ff495e5a4$export$6f3ae48335514a2(props, prop, defaultValue) {
    var transformIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function(v) {
        return v;
    };
    var transformOut = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function(v) {
        return v;
    };
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useProxiedModel');
    var internal = (0, $hXmfK.ref)(props[prop] !== undefined ? props[prop] : defaultValue);
    var kebabProp = (0, $31779689cfd5da50$export$73bda83cddbc7187)(prop);
    var checkKebab = kebabProp !== prop;
    var isControlled = checkKebab ? (0, $hXmfK.computed)(function() {
        var _vm_vnode_props, _vm_vnode_props1, _vm_vnode_props2, _vm_vnode_props3;
        props[prop];
        return !!((((_vm_vnode_props = vm.vnode.props) === null || _vm_vnode_props === void 0 ? void 0 : _vm_vnode_props.hasOwnProperty(prop)) || ((_vm_vnode_props1 = vm.vnode.props) === null || _vm_vnode_props1 === void 0 ? void 0 : _vm_vnode_props1.hasOwnProperty(kebabProp))) && (((_vm_vnode_props2 = vm.vnode.props) === null || _vm_vnode_props2 === void 0 ? void 0 : _vm_vnode_props2.hasOwnProperty("onUpdate:".concat(prop))) || ((_vm_vnode_props3 = vm.vnode.props) === null || _vm_vnode_props3 === void 0 ? void 0 : _vm_vnode_props3.hasOwnProperty("onUpdate:".concat(kebabProp)))));
    }) : (0, $hXmfK.computed)(function() {
        var _vm_vnode_props, _vm_vnode_props1;
        props[prop];
        return !!(((_vm_vnode_props = vm.vnode.props) === null || _vm_vnode_props === void 0 ? void 0 : _vm_vnode_props.hasOwnProperty(prop)) && ((_vm_vnode_props1 = vm.vnode.props) === null || _vm_vnode_props1 === void 0 ? void 0 : _vm_vnode_props1.hasOwnProperty("onUpdate:".concat(prop))));
    });
    (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
        return !isControlled.value;
    }, function() {
        (0, $hXmfK.watch)(function() {
            return props[prop];
        }, function(val) {
            internal.value = val;
        });
    });
    var model = (0, $hXmfK.computed)({
        get: function() {
            var externalValue = props[prop];
            return transformIn(isControlled.value ? externalValue : internal.value);
        },
        set: function(internalValue) {
            var newValue = transformOut(internalValue);
            var value = (0, $hXmfK.toRaw)(isControlled.value ? props[prop] : internal.value);
            if (value === newValue || transformIn(value) === internalValue) return;
            internal.value = newValue;
            vm === null || vm === void 0 ? void 0 : vm.emit("update:".concat(prop), newValue);
        }
    });
    Object.defineProperty(model, 'externalValue', {
        get: function() {
            return isControlled.value ? props[prop] : internal.value;
        }
    });
    return model;
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
/* eslint-disable no-console */ // Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
function $b0e141e3fccca32c$export$222ba5e7254f2402(message) {
    (0, $bu8yf.warn)("Vuetify: ".concat(message));
}
function $b0e141e3fccca32c$export$bf36f23bad3e1069(message) {
    (0, $bu8yf.warn)("Vuetify error: ".concat(message));
}
function $b0e141e3fccca32c$export$b680e6b2c82f8c2f(original, replacement) {
    replacement = Array.isArray(replacement) ? replacement.slice(0, -1).map(function(s) {
        return "'".concat(s, "'");
    }).join(', ') + " or '".concat(replacement.at(-1), "'") : "'".concat(replacement, "'");
    (0, $bu8yf.warn)("[Vuetify UPGRADE] '".concat(original, "' is deprecated, use ").concat(replacement, " instead."));
}
function $b0e141e3fccca32c$export$64074568ee7deb5d(original, replacement) {
// warn(`[Vuetify BREAKING] '${original}' has been removed, use '${replacement}' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide`)
}
function $b0e141e3fccca32c$export$714b9f069b251186(original) {
// warn(`[Vuetify REMOVED] '${original}' has been removed. You can safely omit it.`)
}


var $d47a103ec44b72e5$export$2e2bcd8739ae039 = {
    badge: 'Badge',
    open: 'Open',
    close: 'Close',
    dismiss: 'Dismiss',
    confirmEdit: {
        ok: 'OK',
        cancel: 'Cancel'
    },
    dataIterator: {
        noResultsText: 'No matching records found',
        loadingText: 'Loading items...'
    },
    dataTable: {
        itemsPerPageText: 'Rows per page:',
        ariaLabel: {
            sortDescending: 'Sorted descending.',
            sortAscending: 'Sorted ascending.',
            sortNone: 'Not sorted.',
            activateNone: 'Activate to remove sorting.',
            activateDescending: 'Activate to sort descending.',
            activateAscending: 'Activate to sort ascending.'
        },
        sortBy: 'Sort by'
    },
    dataFooter: {
        itemsPerPageText: 'Items per page:',
        itemsPerPageAll: 'All',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        firstPage: 'First page',
        lastPage: 'Last page',
        pageText: '{0}-{1} of {2}'
    },
    dateRangeInput: {
        divider: 'to'
    },
    datePicker: {
        itemsSelected: '{0} selected',
        range: {
            title: 'Select dates',
            header: 'Enter dates'
        },
        title: 'Select date',
        header: 'Enter date',
        input: {
            placeholder: 'Enter date'
        }
    },
    noDataText: 'No data available',
    carousel: {
        prev: 'Previous visual',
        next: 'Next visual',
        ariaLabel: {
            delimiter: 'Carousel slide {0} of {1}'
        }
    },
    calendar: {
        moreEvents: '{0} more',
        today: 'Today'
    },
    input: {
        clear: 'Clear {0}',
        prependAction: '{0} prepended action',
        appendAction: '{0} appended action',
        otp: 'Please enter OTP character {0}'
    },
    fileInput: {
        counter: '{0} files',
        counterSize: '{0} files ({1} in total)'
    },
    fileUpload: {
        title: 'Drag and drop files here',
        divider: 'or',
        browse: 'Browse Files'
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
        title: 'Select Time'
    },
    pagination: {
        ariaLabel: {
            root: 'Pagination Navigation',
            next: 'Next page',
            previous: 'Previous page',
            page: 'Go to page {0}',
            currentPage: 'Page {0}, Current page',
            first: 'First page',
            last: 'Last page'
        }
    },
    stepper: {
        next: 'Next',
        prev: 'Previous'
    },
    rating: {
        ariaLabel: {
            item: 'Rating {0} of {1}'
        }
    },
    loading: 'Loading...',
    infiniteScroll: {
        loadMore: 'Load more',
        empty: 'No more'
    },
    rules: {
        required: 'This field is required',
        email: 'Please enter a valid email',
        number: 'This field can only contain numbers',
        integer: 'This field can only contain integer values',
        capital: 'This field can only contain uppercase letters',
        maxLength: 'You must enter a maximum of {0} characters',
        minLength: 'You must enter a minimum of {0} characters',
        strictLength: 'The length of the entered field is invalid',
        exclude: 'The {0} character is not allowed',
        notEmpty: 'Please choose at least one value',
        pattern: 'Invalid format'
    },
    hotkey: {
        then: 'then',
        ctrl: 'Ctrl',
        command: 'Command',
        space: 'Space',
        shift: 'Shift',
        alt: 'Alt',
        enter: 'Enter',
        escape: 'Escape',
        upArrow: 'Up Arrow',
        downArrow: 'Down Arrow',
        leftArrow: 'Left Arrow',
        rightArrow: 'Right Arrow',
        backspace: 'Backspace',
        option: 'Option',
        plus: 'plus',
        shortcut: 'Keyboard shortcut: {0}'
    }
};


var $2e957be83eecb216$var$LANG_PREFIX = '$vuetify.';
var $2e957be83eecb216$var$replace = function(str, params) {
    return str.replace(/\{(\d+)\}/g, function(match, index) {
        return String(params[Number(index)]);
    });
};
var $2e957be83eecb216$var$createTranslateFunction = function(current, fallback, messages) {
    return function createTranslateFunction(key) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
        if (!key.startsWith($2e957be83eecb216$var$LANG_PREFIX)) return $2e957be83eecb216$var$replace(key, params);
        var shortKey = key.replace($2e957be83eecb216$var$LANG_PREFIX, '');
        var currentLocale = current.value && messages.value[current.value];
        var fallbackLocale = fallback.value && messages.value[fallback.value];
        var str = (0, $31779689cfd5da50$export$f5474208cafa7b66)(currentLocale, shortKey, null);
        if (!str) {
            (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('Translation key "'.concat(key, '" not found in "').concat(current.value, '", trying fallback locale'));
            str = (0, $31779689cfd5da50$export$f5474208cafa7b66)(fallbackLocale, shortKey, null);
        }
        if (!str) {
            (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)('Translation key "'.concat(key, '" not found in fallback'));
            str = key;
        }
        if (typeof str !== 'string') {
            (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)('Translation key "'.concat(key, '" has a non-string value'));
            str = key;
        }
        return $2e957be83eecb216$var$replace(str, params);
    };
};
function $2e957be83eecb216$var$createNumberFunction(current, fallback) {
    return function(value, options) {
        var numberFormat = new Intl.NumberFormat([
            current.value,
            fallback.value
        ], options);
        return numberFormat.format(value);
    };
}
function $2e957be83eecb216$var$inferDecimalSeparator(current, fallback) {
    var format = $2e957be83eecb216$var$createNumberFunction(current, fallback);
    return format(0.1).includes(',') ? ',' : '.';
}
function $2e957be83eecb216$var$useProvided(props, prop, provided) {
    var _props_prop;
    var internal = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, prop, (_props_prop = props[prop]) !== null && _props_prop !== void 0 ? _props_prop : provided.value);
    var _props_prop1;
    // TODO: Remove when defaultValue works
    internal.value = (_props_prop1 = props[prop]) !== null && _props_prop1 !== void 0 ? _props_prop1 : provided.value;
    (0, $hXmfK.watch)(provided, function(v) {
        if (props[prop] == null) internal.value = provided.value;
    });
    return internal;
}
function $2e957be83eecb216$var$createProvideFunction(state) {
    return function(props) {
        var current = $2e957be83eecb216$var$useProvided(props, 'locale', state.current);
        var fallback = $2e957be83eecb216$var$useProvided(props, 'fallback', state.fallback);
        var messages = $2e957be83eecb216$var$useProvided(props, 'messages', state.messages);
        return {
            name: 'vuetify',
            current: current,
            fallback: fallback,
            messages: messages,
            decimalSeparator: (0, $hXmfK.toRef)(function() {
                return $2e957be83eecb216$var$inferDecimalSeparator(current, fallback);
            }),
            t: $2e957be83eecb216$var$createTranslateFunction(current, fallback, messages),
            n: $2e957be83eecb216$var$createNumberFunction(current, fallback),
            provide: $2e957be83eecb216$var$createProvideFunction({
                current: current,
                fallback: fallback,
                messages: messages
            })
        };
    };
}
function $2e957be83eecb216$export$237d5ea61ba0121d(options) {
    var _options_locale;
    var current = (0, $hXmfK.shallowRef)((_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : 'en');
    var _options_fallback;
    var fallback = (0, $hXmfK.shallowRef)((_options_fallback = options === null || options === void 0 ? void 0 : options.fallback) !== null && _options_fallback !== void 0 ? _options_fallback : 'en');
    var messages = (0, $hXmfK.ref)((0, $iT0je._)({
        en: (0, $d47a103ec44b72e5$export$2e2bcd8739ae039)
    }, options === null || options === void 0 ? void 0 : options.messages));
    return {
        name: 'vuetify',
        current: current,
        fallback: fallback,
        messages: messages,
        decimalSeparator: (0, $hXmfK.toRef)(function() {
            var _options_decimalSeparator;
            return (_options_decimalSeparator = options === null || options === void 0 ? void 0 : options.decimalSeparator) !== null && _options_decimalSeparator !== void 0 ? _options_decimalSeparator : $2e957be83eecb216$var$inferDecimalSeparator(current, fallback);
        }),
        t: $2e957be83eecb216$var$createTranslateFunction(current, fallback, messages),
        n: $2e957be83eecb216$var$createNumberFunction(current, fallback),
        provide: $2e957be83eecb216$var$createProvideFunction({
            current: current,
            fallback: fallback,
            messages: messages
        })
    };
}


var $b4c1f4104dc86d4b$export$36c469862c41ebd3 = Symbol["for"]('vuetify:locale');
function $b4c1f4104dc86d4b$var$isLocaleInstance(obj) {
    return obj.name != null;
}
function $b4c1f4104dc86d4b$export$9af58f1cfd1fbeb4(options) {
    var i18n = (options === null || options === void 0 ? void 0 : options.adapter) && $b4c1f4104dc86d4b$var$isLocaleInstance(options === null || options === void 0 ? void 0 : options.adapter) ? options === null || options === void 0 ? void 0 : options.adapter : (0, $2e957be83eecb216$export$237d5ea61ba0121d)(options);
    var rtl = $b4c1f4104dc86d4b$export$c160809e625ae6e9(i18n, options);
    return (0, $iT0je._)({}, i18n, rtl);
}
function $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7() {
    var locale = (0, $bu8yf.inject)($b4c1f4104dc86d4b$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    return locale;
}
function $b4c1f4104dc86d4b$export$4e518c250eba4aac(props) {
    var locale = (0, $bu8yf.inject)($b4c1f4104dc86d4b$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    var i18n = locale.provide(props);
    var rtl = $b4c1f4104dc86d4b$export$10d7c3ce240853fd(i18n, locale.rtl, props);
    var data = (0, $iT0je._)({}, i18n, rtl);
    (0, $bu8yf.provide)($b4c1f4104dc86d4b$export$36c469862c41ebd3, data);
    return data;
}
var $b4c1f4104dc86d4b$export$c982f8cf16d318ef = Symbol["for"]('vuetify:rtl');
function $b4c1f4104dc86d4b$var$genDefaults() {
    return {
        af: false,
        ar: true,
        bg: false,
        ca: false,
        ckb: false,
        cs: false,
        de: false,
        el: false,
        en: false,
        es: false,
        et: false,
        fa: true,
        fi: false,
        fr: false,
        hr: false,
        hu: false,
        he: true,
        id: false,
        it: false,
        ja: false,
        km: false,
        ko: false,
        lv: false,
        lt: false,
        nl: false,
        no: false,
        pl: false,
        pt: false,
        ro: false,
        ru: false,
        sk: false,
        sl: false,
        srCyrl: false,
        srLatn: false,
        sv: false,
        th: false,
        tr: false,
        az: false,
        uk: false,
        vi: false,
        zhHans: false,
        zhHant: false
    };
}
function $b4c1f4104dc86d4b$export$c160809e625ae6e9(i18n, options) {
    var _options_rtl;
    var rtl = (0, $hXmfK.ref)((_options_rtl = options === null || options === void 0 ? void 0 : options.rtl) !== null && _options_rtl !== void 0 ? _options_rtl : $b4c1f4104dc86d4b$var$genDefaults());
    var isRtl = (0, $hXmfK.computed)(function() {
        var _rtl_value_i18n_current_value;
        return (_rtl_value_i18n_current_value = rtl.value[i18n.current.value]) !== null && _rtl_value_i18n_current_value !== void 0 ? _rtl_value_i18n_current_value : false;
    });
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $hXmfK.toRef)(function() {
            return "v-locale--is-".concat(isRtl.value ? 'rtl' : 'ltr');
        })
    };
}
function $b4c1f4104dc86d4b$export$10d7c3ce240853fd(locale, rtl, props) {
    var isRtl = (0, $hXmfK.computed)(function() {
        var _props_rtl, _ref;
        return (_ref = (_props_rtl = props.rtl) !== null && _props_rtl !== void 0 ? _props_rtl : rtl.value[locale.current.value]) !== null && _ref !== void 0 ? _ref : false;
    });
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $hXmfK.toRef)(function() {
            return "v-locale--is-".concat(isRtl.value ? 'rtl' : 'ltr');
        })
    };
}
function $b4c1f4104dc86d4b$export$b2dd014b6c321cb() {
    var locale = (0, $bu8yf.inject)($b4c1f4104dc86d4b$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected rtl instance');
    return {
        isRtl: locale.isRtl,
        rtlClasses: locale.rtlClasses
    };
}


parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

// Utilities

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");

var $32TW8 = parcelRequire("32TW8");

function $8a55d3bfc30f1a08$var$weekInfo(locale) {
    // https://simplelocalize.io/data/locales/
    // then `new Intl.Locale(...).getWeekInfo()`
    var code = locale.slice(-2).toUpperCase();
    switch(true){
        case locale === 'GB-alt-variant':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        case locale === '001':
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case "AG AS BD BR BS BT BW BZ CA CO DM DO ET GT GU HK HN ID IL IN JM JP KE\n    KH KR LA MH MM MO MT MX MZ NI NP PA PE PH PK PR PY SA SG SV TH TT TW UM US\n    VE VI WS YE ZA ZW".includes(code):
            return {
                firstDay: 0,
                firstWeekSize: 1
            };
        case "AI AL AM AR AU AZ BA BM BN BY CL CM CN CR CY EC GE HR KG KZ LB LK LV\n    MD ME MK MN MY NZ RO RS SI TJ TM TR UA UY UZ VN XK".includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case "AD AN AT AX BE BG CH CZ DE DK EE ES FI FJ FO FR GB GF GP GR HU IE IS\n    IT LI LT LU MC MQ NL NO PL RE RU SE SK SM VA".includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 4
            };
        case "AE AF BH DJ DZ EG IQ IR JO KW LY OM QA SD SY".includes(code):
            return {
                firstDay: 6,
                firstWeekSize: 1
            };
        case code === 'MV':
            return {
                firstDay: 5,
                firstWeekSize: 1
            };
        case code === 'PT':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        default:
            return null;
    }
}
function $8a55d3bfc30f1a08$var$getWeekArray(date, locale, firstDayOfWeek) {
    var _weekInfo;
    var weeks = [];
    var currentWeek = [];
    var firstDayOfMonth = $8a55d3bfc30f1a08$var$startOfMonth(date);
    var lastDayOfMonth = $8a55d3bfc30f1a08$var$endOfMonth(date);
    var _ref;
    var first = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $8a55d3bfc30f1a08$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    var firstDayWeekIndex = (firstDayOfMonth.getDay() - first + 7) % 7;
    var lastDayWeekIndex = (lastDayOfMonth.getDay() - first + 7) % 7;
    for(var i = 0; i < firstDayWeekIndex; i++){
        var adjacentDay = new Date(firstDayOfMonth);
        adjacentDay.setDate(adjacentDay.getDate() - (firstDayWeekIndex - i));
        currentWeek.push(adjacentDay);
    }
    for(var i1 = 1; i1 <= lastDayOfMonth.getDate(); i1++){
        var day = new Date(date.getFullYear(), date.getMonth(), i1);
        // Add the day to the current week
        currentWeek.push(day);
        // If the current week has 7 days, add it to the weeks array and start a new week
        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }
    for(var i2 = 1; i2 < 7 - lastDayWeekIndex; i2++){
        var adjacentDay1 = new Date(lastDayOfMonth);
        adjacentDay1.setDate(adjacentDay1.getDate() + i2);
        currentWeek.push(adjacentDay1);
    }
    if (currentWeek.length > 0) weeks.push(currentWeek);
    return weeks;
}
function $8a55d3bfc30f1a08$var$startOfWeek(date, locale, firstDayOfWeek) {
    var _weekInfo;
    var _ref;
    var day = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $8a55d3bfc30f1a08$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    var d = new Date(date);
    while(d.getDay() !== day)d.setDate(d.getDate() - 1);
    return d;
}
function $8a55d3bfc30f1a08$var$endOfWeek(date, locale) {
    var _weekInfo;
    var d = new Date(date);
    var _weekInfo_firstDay;
    var lastDay = (((_weekInfo_firstDay = (_weekInfo = $8a55d3bfc30f1a08$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _weekInfo_firstDay !== void 0 ? _weekInfo_firstDay : 0) + 6) % 7;
    while(d.getDay() !== lastDay)d.setDate(d.getDate() + 1);
    return d;
}
function $8a55d3bfc30f1a08$var$startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
function $8a55d3bfc30f1a08$var$endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
function $8a55d3bfc30f1a08$var$parseLocalDate(value) {
    var parts = value.split('-').map(Number);
    // new Date() uses local time zone when passing individual date component values
    return new Date(parts[0], parts[1] - 1, parts[2]);
}
var $8a55d3bfc30f1a08$var$_YYYMMDD = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function $8a55d3bfc30f1a08$var$date(value) {
    if (value == null) return new Date();
    if (value instanceof Date) return value;
    if (typeof value === 'string') {
        var parsed;
        if ($8a55d3bfc30f1a08$var$_YYYMMDD.test(value)) return $8a55d3bfc30f1a08$var$parseLocalDate(value);
        else parsed = Date.parse(value);
        if (!isNaN(parsed)) return new Date(parsed);
    }
    return null;
}
var $8a55d3bfc30f1a08$var$sundayJanuarySecond2000 = new Date(2000, 0, 2);
function $8a55d3bfc30f1a08$var$getWeekdays(locale, firstDayOfWeek, weekdayFormat) {
    var _weekInfo;
    var _ref;
    var daysFromSunday = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $8a55d3bfc30f1a08$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    return (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(7).map(function(i) {
        var weekday = new Date($8a55d3bfc30f1a08$var$sundayJanuarySecond2000);
        weekday.setDate($8a55d3bfc30f1a08$var$sundayJanuarySecond2000.getDate() + daysFromSunday + i);
        return new Intl.DateTimeFormat(locale, {
            weekday: weekdayFormat !== null && weekdayFormat !== void 0 ? weekdayFormat : 'narrow'
        }).format(weekday);
    });
}
function $8a55d3bfc30f1a08$var$format(value, formatString, locale, formats) {
    var _date;
    var newDate = (_date = $8a55d3bfc30f1a08$var$date(value)) !== null && _date !== void 0 ? _date : new Date();
    var customFormat = formats === null || formats === void 0 ? void 0 : formats[formatString];
    if (typeof customFormat === 'function') return customFormat(newDate, formatString, locale);
    var options = {};
    switch(formatString){
        case 'fullDate':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'fullDateWithWeekday':
            options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'normalDate':
            var day = newDate.getDate();
            var month = new Intl.DateTimeFormat(locale, {
                month: 'long'
            }).format(newDate);
            return "".concat(day, " ").concat(month);
        case 'normalDateWithWeekday':
            options = {
                weekday: 'short',
                day: 'numeric',
                month: 'short'
            };
            break;
        case 'shortDate':
            options = {
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'year':
            options = {
                year: 'numeric'
            };
            break;
        case 'month':
            options = {
                month: 'long'
            };
            break;
        case 'monthShort':
            options = {
                month: 'short'
            };
            break;
        case 'monthAndYear':
            options = {
                month: 'long',
                year: 'numeric'
            };
            break;
        case 'monthAndDate':
            options = {
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'weekday':
            options = {
                weekday: 'long'
            };
            break;
        case 'weekdayShort':
            options = {
                weekday: 'short'
            };
            break;
        case 'dayOfMonth':
            return new Intl.NumberFormat(locale).format(newDate.getDate());
        case 'hours12h':
            options = {
                hour: 'numeric',
                hour12: true
            };
            break;
        case 'hours24h':
            options = {
                hour: 'numeric',
                hour12: false
            };
            break;
        case 'minutes':
            options = {
                minute: 'numeric'
            };
            break;
        case 'seconds':
            options = {
                second: 'numeric'
            };
            break;
        case 'fullTime':
            options = {
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullTime12h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullTime24h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'fullDateTime':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullDateTime12h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullDateTime24h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'keyboardDate':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            break;
        case 'keyboardDateTime':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric'
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime12h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime24h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        default:
            options = customFormat !== null && customFormat !== void 0 ? customFormat : {
                timeZone: 'UTC',
                timeZoneName: 'short'
            };
    }
    return new Intl.DateTimeFormat(locale, options).format(newDate);
}
function $8a55d3bfc30f1a08$var$toISO(adapter, value) {
    var date = adapter.toJsDate(value);
    var year = date.getFullYear();
    var month = (0, $31779689cfd5da50$export$36cf564d487b5178)(String(date.getMonth() + 1), 2, '0');
    var day = (0, $31779689cfd5da50$export$36cf564d487b5178)(String(date.getDate()), 2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $8a55d3bfc30f1a08$var$parseISO(value) {
    var _value_split_map = (0, $32TW8._)(value.split('-').map(Number), 3), year = _value_split_map[0], month = _value_split_map[1], day = _value_split_map[2];
    return new Date(year, month - 1, day);
}
function $8a55d3bfc30f1a08$var$addMinutes(date, amount) {
    var d = new Date(date);
    d.setMinutes(d.getMinutes() + amount);
    return d;
}
function $8a55d3bfc30f1a08$var$addHours(date, amount) {
    var d = new Date(date);
    d.setHours(d.getHours() + amount);
    return d;
}
function $8a55d3bfc30f1a08$var$addDays(date, amount) {
    var d = new Date(date);
    d.setDate(d.getDate() + amount);
    return d;
}
function $8a55d3bfc30f1a08$var$addWeeks(date, amount) {
    var d = new Date(date);
    d.setDate(d.getDate() + amount * 7);
    return d;
}
function $8a55d3bfc30f1a08$var$addMonths(date, amount) {
    var d = new Date(date);
    d.setDate(1);
    d.setMonth(d.getMonth() + amount);
    return d;
}
function $8a55d3bfc30f1a08$var$getYear(date) {
    return date.getFullYear();
}
function $8a55d3bfc30f1a08$var$getMonth(date) {
    return date.getMonth();
}
function $8a55d3bfc30f1a08$var$getWeek(date, locale, firstDayOfWeek, firstWeekMinSize) {
    var weekInfoFromLocale = $8a55d3bfc30f1a08$var$weekInfo(locale);
    var _ref;
    var weekStart = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : weekInfoFromLocale === null || weekInfoFromLocale === void 0 ? void 0 : weekInfoFromLocale.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    var _ref1;
    var minWeekSize = (_ref1 = firstWeekMinSize !== null && firstWeekMinSize !== void 0 ? firstWeekMinSize : weekInfoFromLocale === null || weekInfoFromLocale === void 0 ? void 0 : weekInfoFromLocale.firstWeekSize) !== null && _ref1 !== void 0 ? _ref1 : 1;
    function firstWeekSize(year) {
        var yearStart = new Date(year, 0, 1);
        return 7 - $8a55d3bfc30f1a08$var$getDiff(yearStart, $8a55d3bfc30f1a08$var$startOfWeek(yearStart, locale, weekStart), 'days');
    }
    var year = $8a55d3bfc30f1a08$var$getYear(date);
    var currentWeekEnd = $8a55d3bfc30f1a08$var$addDays($8a55d3bfc30f1a08$var$startOfWeek(date, locale, weekStart), 6);
    if (year < $8a55d3bfc30f1a08$var$getYear(currentWeekEnd) && firstWeekSize(year + 1) >= minWeekSize) year++;
    var yearStart = new Date(year, 0, 1);
    var size = firstWeekSize(year);
    var d1w1 = size >= minWeekSize ? $8a55d3bfc30f1a08$var$addDays(yearStart, size - 7) : $8a55d3bfc30f1a08$var$addDays(yearStart, size);
    return 1 + $8a55d3bfc30f1a08$var$getDiff($8a55d3bfc30f1a08$var$endOfDay(date), $8a55d3bfc30f1a08$var$startOfDay(d1w1), 'weeks');
}
function $8a55d3bfc30f1a08$var$getDate(date) {
    return date.getDate();
}
function $8a55d3bfc30f1a08$var$getNextMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}
function $8a55d3bfc30f1a08$var$getPreviousMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}
function $8a55d3bfc30f1a08$var$getHours(date) {
    return date.getHours();
}
function $8a55d3bfc30f1a08$var$getMinutes(date) {
    return date.getMinutes();
}
function $8a55d3bfc30f1a08$var$startOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
}
function $8a55d3bfc30f1a08$var$endOfYear(date) {
    return new Date(date.getFullYear(), 11, 31);
}
function $8a55d3bfc30f1a08$var$isWithinRange(date, range) {
    return $8a55d3bfc30f1a08$var$isAfter(date, range[0]) && $8a55d3bfc30f1a08$var$isBefore(date, range[1]);
}
function $8a55d3bfc30f1a08$var$isValid(date) {
    var d = new Date(date);
    return d instanceof Date && !isNaN(d.getTime());
}
function $8a55d3bfc30f1a08$var$isAfter(date, comparing) {
    return date.getTime() > comparing.getTime();
}
function $8a55d3bfc30f1a08$var$isAfterDay(date, comparing) {
    return $8a55d3bfc30f1a08$var$isAfter($8a55d3bfc30f1a08$var$startOfDay(date), $8a55d3bfc30f1a08$var$startOfDay(comparing));
}
function $8a55d3bfc30f1a08$var$isBefore(date, comparing) {
    return date.getTime() < comparing.getTime();
}
function $8a55d3bfc30f1a08$var$isEqual(date, comparing) {
    return date.getTime() === comparing.getTime();
}
function $8a55d3bfc30f1a08$var$isSameDay(date, comparing) {
    return date.getDate() === comparing.getDate() && date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $8a55d3bfc30f1a08$var$isSameMonth(date, comparing) {
    return date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $8a55d3bfc30f1a08$var$isSameYear(date, comparing) {
    return date.getFullYear() === comparing.getFullYear();
}
function $8a55d3bfc30f1a08$var$getDiff(date, comparing, unit) {
    var d = new Date(date);
    var c = new Date(comparing);
    switch(unit){
        case 'years':
            return d.getFullYear() - c.getFullYear();
        case 'quarters':
            return Math.floor((d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12) / 4);
        case 'months':
            return d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12;
        case 'weeks':
            return Math.floor((d.getTime() - c.getTime()) / 604800000);
        case 'days':
            return Math.floor((d.getTime() - c.getTime()) / 86400000);
        case 'hours':
            return Math.floor((d.getTime() - c.getTime()) / 3600000);
        case 'minutes':
            return Math.floor((d.getTime() - c.getTime()) / 60000);
        case 'seconds':
            return Math.floor((d.getTime() - c.getTime()) / 1000);
        default:
            return d.getTime() - c.getTime();
    }
}
function $8a55d3bfc30f1a08$var$setHours(date, count) {
    var d = new Date(date);
    d.setHours(count);
    return d;
}
function $8a55d3bfc30f1a08$var$setMinutes(date, count) {
    var d = new Date(date);
    d.setMinutes(count);
    return d;
}
function $8a55d3bfc30f1a08$var$setMonth(date, count) {
    var d = new Date(date);
    d.setMonth(count);
    return d;
}
function $8a55d3bfc30f1a08$var$setDate(date, day) {
    var d = new Date(date);
    d.setDate(day);
    return d;
}
function $8a55d3bfc30f1a08$var$setYear(date, year) {
    var d = new Date(date);
    d.setFullYear(year);
    return d;
}
function $8a55d3bfc30f1a08$var$startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}
function $8a55d3bfc30f1a08$var$endOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}
var $8a55d3bfc30f1a08$export$de9f337e316457b5 = /*#__PURE__*/ function() {
    "use strict";
    function VuetifyDateAdapter(options) {
        (0, $jGAMp._)(this, VuetifyDateAdapter);
        this.locale = options.locale;
        this.formats = options.formats;
    }
    (0, $byiyg._)(VuetifyDateAdapter, [
        {
            key: "date",
            value: function date1(value) {
                return $8a55d3bfc30f1a08$var$date(value);
            }
        },
        {
            key: "toJsDate",
            value: function toJsDate(date) {
                return date;
            }
        },
        {
            key: "toISO",
            value: function toISO1(date) {
                return $8a55d3bfc30f1a08$var$toISO(this, date);
            }
        },
        {
            key: "parseISO",
            value: function parseISO1(date) {
                return $8a55d3bfc30f1a08$var$parseISO(date);
            }
        },
        {
            key: "addMinutes",
            value: function addMinutes1(date, amount) {
                return $8a55d3bfc30f1a08$var$addMinutes(date, amount);
            }
        },
        {
            key: "addHours",
            value: function addHours1(date, amount) {
                return $8a55d3bfc30f1a08$var$addHours(date, amount);
            }
        },
        {
            key: "addDays",
            value: function addDays1(date, amount) {
                return $8a55d3bfc30f1a08$var$addDays(date, amount);
            }
        },
        {
            key: "addWeeks",
            value: function addWeeks1(date, amount) {
                return $8a55d3bfc30f1a08$var$addWeeks(date, amount);
            }
        },
        {
            key: "addMonths",
            value: function addMonths1(date, amount) {
                return $8a55d3bfc30f1a08$var$addMonths(date, amount);
            }
        },
        {
            key: "getWeekArray",
            value: function getWeekArray1(date, firstDayOfWeek) {
                var firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
                return $8a55d3bfc30f1a08$var$getWeekArray(date, this.locale, firstDay);
            }
        },
        {
            key: "startOfWeek",
            value: function startOfWeek1(date, firstDayOfWeek) {
                var firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
                return $8a55d3bfc30f1a08$var$startOfWeek(date, this.locale, firstDay);
            }
        },
        {
            key: "endOfWeek",
            value: function endOfWeek1(date) {
                return $8a55d3bfc30f1a08$var$endOfWeek(date, this.locale);
            }
        },
        {
            key: "startOfMonth",
            value: function startOfMonth1(date) {
                return $8a55d3bfc30f1a08$var$startOfMonth(date);
            }
        },
        {
            key: "endOfMonth",
            value: function endOfMonth1(date) {
                return $8a55d3bfc30f1a08$var$endOfMonth(date);
            }
        },
        {
            key: "format",
            value: function format1(date, formatString) {
                return $8a55d3bfc30f1a08$var$format(date, formatString, this.locale, this.formats);
            }
        },
        {
            key: "isEqual",
            value: function isEqual1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isEqual(date, comparing);
            }
        },
        {
            key: "isValid",
            value: function isValid1(date) {
                return $8a55d3bfc30f1a08$var$isValid(date);
            }
        },
        {
            key: "isWithinRange",
            value: function isWithinRange1(date, range) {
                return $8a55d3bfc30f1a08$var$isWithinRange(date, range);
            }
        },
        {
            key: "isAfter",
            value: function isAfter1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isAfter(date, comparing);
            }
        },
        {
            key: "isAfterDay",
            value: function isAfterDay1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isAfterDay(date, comparing);
            }
        },
        {
            key: "isBefore",
            value: function isBefore(date, comparing) {
                return !$8a55d3bfc30f1a08$var$isAfter(date, comparing) && !$8a55d3bfc30f1a08$var$isEqual(date, comparing);
            }
        },
        {
            key: "isSameDay",
            value: function isSameDay1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isSameDay(date, comparing);
            }
        },
        {
            key: "isSameMonth",
            value: function isSameMonth1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isSameMonth(date, comparing);
            }
        },
        {
            key: "isSameYear",
            value: function isSameYear1(date, comparing) {
                return $8a55d3bfc30f1a08$var$isSameYear(date, comparing);
            }
        },
        {
            key: "setMinutes",
            value: function setMinutes1(date, count) {
                return $8a55d3bfc30f1a08$var$setMinutes(date, count);
            }
        },
        {
            key: "setHours",
            value: function setHours1(date, count) {
                return $8a55d3bfc30f1a08$var$setHours(date, count);
            }
        },
        {
            key: "setMonth",
            value: function setMonth1(date, count) {
                return $8a55d3bfc30f1a08$var$setMonth(date, count);
            }
        },
        {
            key: "setDate",
            value: function setDate1(date, day) {
                return $8a55d3bfc30f1a08$var$setDate(date, day);
            }
        },
        {
            key: "setYear",
            value: function setYear1(date, year) {
                return $8a55d3bfc30f1a08$var$setYear(date, year);
            }
        },
        {
            key: "getDiff",
            value: function getDiff1(date, comparing, unit) {
                return $8a55d3bfc30f1a08$var$getDiff(date, comparing, unit);
            }
        },
        {
            key: "getWeekdays",
            value: function getWeekdays1(firstDayOfWeek, weekdayFormat) {
                var firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
                return $8a55d3bfc30f1a08$var$getWeekdays(this.locale, firstDay, weekdayFormat);
            }
        },
        {
            key: "getYear",
            value: function getYear1(date) {
                return $8a55d3bfc30f1a08$var$getYear(date);
            }
        },
        {
            key: "getMonth",
            value: function getMonth1(date) {
                return $8a55d3bfc30f1a08$var$getMonth(date);
            }
        },
        {
            key: "getWeek",
            value: function getWeek1(date, firstDayOfWeek, firstWeekMinSize) {
                var firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
                return $8a55d3bfc30f1a08$var$getWeek(date, this.locale, firstDay, firstWeekMinSize);
            }
        },
        {
            key: "getDate",
            value: function getDate1(date) {
                return $8a55d3bfc30f1a08$var$getDate(date);
            }
        },
        {
            key: "getNextMonth",
            value: function getNextMonth1(date) {
                return $8a55d3bfc30f1a08$var$getNextMonth(date);
            }
        },
        {
            key: "getPreviousMonth",
            value: function getPreviousMonth1(date) {
                return $8a55d3bfc30f1a08$var$getPreviousMonth(date);
            }
        },
        {
            key: "getHours",
            value: function getHours1(date) {
                return $8a55d3bfc30f1a08$var$getHours(date);
            }
        },
        {
            key: "getMinutes",
            value: function getMinutes1(date) {
                return $8a55d3bfc30f1a08$var$getMinutes(date);
            }
        },
        {
            key: "startOfDay",
            value: function startOfDay1(date) {
                return $8a55d3bfc30f1a08$var$startOfDay(date);
            }
        },
        {
            key: "endOfDay",
            value: function endOfDay1(date) {
                return $8a55d3bfc30f1a08$var$endOfDay(date);
            }
        },
        {
            key: "startOfYear",
            value: function startOfYear1(date) {
                return $8a55d3bfc30f1a08$var$startOfYear(date);
            }
        },
        {
            key: "endOfYear",
            value: function endOfYear1(date) {
                return $8a55d3bfc30f1a08$var$endOfYear(date);
            }
        }
    ]);
    return VuetifyDateAdapter;
}();


var $ff9e087639c00a2b$export$f5446553d2f72d7;
var $ff9e087639c00a2b$export$ee409445cb0eea8f = Symbol["for"]('vuetify:date-options');
var $ff9e087639c00a2b$export$77c3d555e2fd633c = Symbol["for"]('vuetify:date-adapter');
function $ff9e087639c00a2b$export$e029667a62135fd0(options, locale) {
    var _options = (0, $31779689cfd5da50$export$dd702b3c8240390c)({
        adapter: (0, $8a55d3bfc30f1a08$export$de9f337e316457b5),
        locale: {
            af: 'af-ZA',
            // ar: '', # not the same value for all variants
            bg: 'bg-BG',
            ca: 'ca-ES',
            ckb: '',
            cs: 'cs-CZ',
            de: 'de-DE',
            el: 'el-GR',
            en: 'en-US',
            // es: '', # not the same value for all variants
            et: 'et-EE',
            fa: 'fa-IR',
            fi: 'fi-FI',
            // fr: '', #not the same value for all variants
            hr: 'hr-HR',
            hu: 'hu-HU',
            he: 'he-IL',
            id: 'id-ID',
            it: 'it-IT',
            ja: 'ja-JP',
            ko: 'ko-KR',
            lv: 'lv-LV',
            lt: 'lt-LT',
            nl: 'nl-NL',
            no: 'no-NO',
            pl: 'pl-PL',
            pt: 'pt-PT',
            ro: 'ro-RO',
            ru: 'ru-RU',
            sk: 'sk-SK',
            sl: 'sl-SI',
            srCyrl: 'sr-SP',
            srLatn: 'sr-SP',
            sv: 'sv-SE',
            th: 'th-TH',
            tr: 'tr-TR',
            az: 'az-AZ',
            uk: 'uk-UA',
            vi: 'vi-VN',
            zhHans: 'zh-CN',
            zhHant: 'zh-TW'
        }
    }, options);
    return {
        options: _options,
        instance: $ff9e087639c00a2b$var$createInstance(_options, locale)
    };
}
function $ff9e087639c00a2b$export$788d03e430c3bd7a(adapter, start, stop) {
    var diff = adapter.getDiff(adapter.endOfDay(stop !== null && stop !== void 0 ? stop : start), adapter.startOfDay(start), 'days');
    var datesInRange = [
        start
    ];
    for(var i = 1; i < diff; i++){
        var nextDate = adapter.addDays(start, i);
        datesInRange.push(nextDate);
    }
    if (stop) datesInRange.push(adapter.endOfDay(stop));
    return datesInRange;
}
function $ff9e087639c00a2b$var$createInstance(options, locale) {
    var _options_locale_locale_current_value;
    var instance = (0, $hXmfK.reactive)(typeof options.adapter === 'function' ? new options.adapter({
        locale: (_options_locale_locale_current_value = options.locale[locale.current.value]) !== null && _options_locale_locale_current_value !== void 0 ? _options_locale_locale_current_value : locale.current.value,
        formats: options.formats
    }) : options.adapter);
    (0, $hXmfK.watch)(locale.current, function(value) {
        var _options_locale_value, _ref;
        instance.locale = (_ref = (_options_locale_value = options.locale[value]) !== null && _options_locale_value !== void 0 ? _options_locale_value : value) !== null && _ref !== void 0 ? _ref : instance.locale;
    });
    return instance;
}
function $ff9e087639c00a2b$export$e51e224239492327() {
    var options = (0, $bu8yf.inject)($ff9e087639c00a2b$export$ee409445cb0eea8f);
    if (!options) throw new Error('[Vuetify] Could not find injected date options');
    var locale = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)();
    return $ff9e087639c00a2b$var$createInstance(options, locale);
}


// Utilities

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


// Utilities

function $4cdb69896ffd1ee6$export$af450d6d100990eb(key) {
    var vm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$f13e630aa3915748)('injectSelf');
    var provides = vm.provides;
    if (provides && key in provides) // TS doesn't allow symbol as index type
    return provides[key];
    return undefined;
}


var $90060d7a7e173b81$export$84318fce2211c0fd = Symbol["for"]('vuetify:defaults');
function $90060d7a7e173b81$export$e149fd47ce43e254(options) {
    return (0, $hXmfK.ref)(options);
}
function $90060d7a7e173b81$export$def078ca8538d812() {
    var defaults = (0, $bu8yf.inject)($90060d7a7e173b81$export$84318fce2211c0fd);
    if (!defaults) throw new Error('[Vuetify] Could not find defaults instance');
    return defaults;
}
function $90060d7a7e173b81$export$31ed9bd1c7c3a7ee(defaults, options) {
    var injectedDefaults = $90060d7a7e173b81$export$def078ca8538d812();
    var providedDefaults = (0, $hXmfK.ref)(defaults);
    var newDefaults = (0, $hXmfK.computed)(function() {
        var disabled = (0, $hXmfK.unref)(options === null || options === void 0 ? void 0 : options.disabled);
        if (disabled) return injectedDefaults.value;
        var scoped = (0, $hXmfK.unref)(options === null || options === void 0 ? void 0 : options.scoped);
        var reset = (0, $hXmfK.unref)(options === null || options === void 0 ? void 0 : options.reset);
        var root = (0, $hXmfK.unref)(options === null || options === void 0 ? void 0 : options.root);
        if (providedDefaults.value == null && !(scoped || reset || root)) return injectedDefaults.value;
        var properties = (0, $31779689cfd5da50$export$dd702b3c8240390c)(providedDefaults.value, {
            prev: injectedDefaults.value
        });
        if (scoped) return properties;
        if (reset || root) {
            var len = Number(reset || Infinity);
            for(var i = 0; i <= len; i++){
                if (!properties || !('prev' in properties)) break;
                properties = properties.prev;
            }
            if (properties && typeof root === 'string' && root in properties) properties = (0, $31779689cfd5da50$export$dd702b3c8240390c)((0, $31779689cfd5da50$export$dd702b3c8240390c)(properties, {
                prev: properties
            }), properties[root]);
            return properties;
        }
        return properties.prev ? (0, $31779689cfd5da50$export$dd702b3c8240390c)(properties.prev, properties) : properties;
    });
    (0, $bu8yf.provide)($90060d7a7e173b81$export$84318fce2211c0fd, newDefaults);
    return newDefaults;
}
function $90060d7a7e173b81$var$propIsDefined(vnode, prop) {
    return vnode.props && (typeof vnode.props[prop] !== 'undefined' || typeof vnode.props[(0, $31779689cfd5da50$export$73bda83cddbc7187)(prop)] !== 'undefined');
}
function $90060d7a7e173b81$export$c8b014c4fb5d670b() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var name = arguments.length > 1 ? arguments[1] : undefined;
    var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $90060d7a7e173b81$export$def078ca8538d812();
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useDefaults');
    var _ref;
    name = (_ref = name !== null && name !== void 0 ? name : vm.type.name) !== null && _ref !== void 0 ? _ref : vm.type.__name;
    if (!name) throw new Error('[Vuetify] Could not determine component name');
    var componentDefaults = (0, $hXmfK.computed)(function() {
        var _defaults_value;
        var _props__as;
        return (_defaults_value = defaults.value) === null || _defaults_value === void 0 ? void 0 : _defaults_value[(_props__as = props._as) !== null && _props__as !== void 0 ? _props__as : name];
    });
    var _props = new Proxy(props, {
        get: function(target, prop) {
            var _componentDefaults_value, _componentDefaults_value1, _defaults_value_global, _defaults_value;
            var propValue = Reflect.get(target, prop);
            if (prop === 'class' || prop === 'style') return [
                (_componentDefaults_value = componentDefaults.value) === null || _componentDefaults_value === void 0 ? void 0 : _componentDefaults_value[prop],
                propValue
            ].filter(function(v) {
                return v != null;
            });
            if ($90060d7a7e173b81$var$propIsDefined(vm.vnode, prop)) return propValue;
            var _componentDefault = (_componentDefaults_value1 = componentDefaults.value) === null || _componentDefaults_value1 === void 0 ? void 0 : _componentDefaults_value1[prop];
            if (_componentDefault !== undefined) return _componentDefault;
            var _globalDefault = (_defaults_value = defaults.value) === null || _defaults_value === void 0 ? void 0 : (_defaults_value_global = _defaults_value.global) === null || _defaults_value_global === void 0 ? void 0 : _defaults_value_global[prop];
            if (_globalDefault !== undefined) return _globalDefault;
            return propValue;
        }
    });
    var _subcomponentDefaults = (0, $hXmfK.shallowRef)();
    (0, $bu8yf.watchEffect)(function() {
        if (componentDefaults.value) {
            var subComponents = Object.entries(componentDefaults.value).filter(function(_ref) {
                var _$_ref = (0, $32TW8._)(_ref, 1), key = _$_ref[0];
                return key.startsWith(key[0].toUpperCase());
            });
            _subcomponentDefaults.value = subComponents.length ? Object.fromEntries(subComponents) : undefined;
        } else _subcomponentDefaults.value = undefined;
    });
    function provideSubDefaults() {
        var injected = (0, $4cdb69896ffd1ee6$export$af450d6d100990eb)($90060d7a7e173b81$export$84318fce2211c0fd, vm);
        (0, $bu8yf.provide)($90060d7a7e173b81$export$84318fce2211c0fd, (0, $hXmfK.computed)(function() {
            var _injected_value;
            return _subcomponentDefaults.value ? (0, $31779689cfd5da50$export$dd702b3c8240390c)((_injected_value = injected === null || injected === void 0 ? void 0 : injected.value) !== null && _injected_value !== void 0 ? _injected_value : {}, _subcomponentDefaults.value) : injected === null || injected === void 0 ? void 0 : injected.value;
        }));
    }
    return {
        props: _props,
        provideSubDefaults: provideSubDefaults
    };
}
function $90060d7a7e173b81$export$8a73fd45e606bcfb() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var name = arguments.length > 1 ? arguments[1] : undefined;
    var _internalUseDefaults = $90060d7a7e173b81$export$c8b014c4fb5d670b(props, name), _props = _internalUseDefaults.props, provideSubDefaults = _internalUseDefaults.provideSubDefaults;
    provideSubDefaults();
    return _props;
}


// Utilities

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Types
// eslint-disable-line vue/prefer-import-from-vue
/**
 * Creates a factory function for props definitions.
 * This is used to define props in a composable then override
 * default values in an implementing component.
 *
 * @example Simplified signature
 * (props: Props) => (defaults?: Record<keyof props, any>) => Props
 *
 * @example Usage
 * const makeProps = propsFactory({
 *   foo: String,
 * })
 *
 * defineComponent({
 *   props: {
 *     ...makeProps({
 *       foo: 'a',
 *     }),
 *   },
 *   setup (props) {
 *     // would be "string | undefined", now "string" because a default has been provided
 *     props.foo
 *   },
 * }
 */ 
var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $3KZcf = parcelRequire("3KZcf");
function $0085e3529ef855a2$export$d5c63d7e6e58d2df(props, source) {
    return function(defaults) {
        return Object.keys(props).reduce(function(obj, prop) {
            var isObjectDefinition = (0, $3KZcf._)(props[prop]) === 'object' && props[prop] != null && !Array.isArray(props[prop]);
            var definition = isObjectDefinition ? props[prop] : {
                type: props[prop]
            };
            if (defaults && prop in defaults) obj[prop] = (0, $emQHU._)((0, $iT0je._)({}, definition), {
                "default": defaults[prop]
            });
            else obj[prop] = definition;
            if (source && !obj[prop].source) obj[prop].source = source;
            return obj;
        }, {});
    };
} /**
 * Like `Partial<T>` but doesn't care what the value is
 */  // Copied from Vue



var $a7414385605a88b0$export$d07517a676ce386f = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
]; // no xs
var $a7414385605a88b0$export$9a65027cbda1c19 = Symbol["for"]('vuetify:display');
var $a7414385605a88b0$var$defaultDisplayOptions = {
    mobileBreakpoint: 'lg',
    thresholds: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2560
    }
};
var $a7414385605a88b0$var$parseDisplayOptions = function parseDisplayOptions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $a7414385605a88b0$var$defaultDisplayOptions;
    return (0, $31779689cfd5da50$export$dd702b3c8240390c)($a7414385605a88b0$var$defaultDisplayOptions, options);
};
function $a7414385605a88b0$var$getClientWidth(ssr) {
    return (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerWidth : (typeof ssr === "undefined" ? "undefined" : (0, $3KZcf._)(ssr)) === 'object' && ssr.clientWidth || 0;
}
function $a7414385605a88b0$var$getClientHeight(ssr) {
    return (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerHeight : (typeof ssr === "undefined" ? "undefined" : (0, $3KZcf._)(ssr)) === 'object' && ssr.clientHeight || 0;
}
function $a7414385605a88b0$var$getPlatform(ssr) {
    var userAgent = (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && !ssr ? window.navigator.userAgent : 'ssr';
    function match(regexp) {
        return Boolean(userAgent.match(regexp));
    }
    var android = match(/android/i);
    var ios = match(/iphone|ipad|ipod/i);
    var cordova = match(/cordova/i);
    var electron = match(/electron/i);
    var chrome = match(/chrome/i);
    var edge = match(/edge/i);
    var firefox = match(/firefox/i);
    var opera = match(/opera/i);
    var win = match(/win/i);
    var mac = match(/mac/i);
    var linux = match(/linux/i);
    return {
        android: android,
        ios: ios,
        cordova: cordova,
        electron: electron,
        chrome: chrome,
        edge: edge,
        firefox: firefox,
        opera: opera,
        win: win,
        mac: mac,
        linux: linux,
        touch: (0, $10db88b646d64b14$export$a5f9edc0876666e5),
        ssr: userAgent === 'ssr'
    };
}
function $a7414385605a88b0$export$630b3f7014e81311(options, ssr) {
    var _parseDisplayOptions = $a7414385605a88b0$var$parseDisplayOptions(options), thresholds = _parseDisplayOptions.thresholds, mobileBreakpoint = _parseDisplayOptions.mobileBreakpoint;
    var height = (0, $hXmfK.shallowRef)($a7414385605a88b0$var$getClientHeight(ssr));
    var platform = (0, $hXmfK.shallowRef)($a7414385605a88b0$var$getPlatform(ssr));
    var state = (0, $hXmfK.reactive)({});
    var width = (0, $hXmfK.shallowRef)($a7414385605a88b0$var$getClientWidth(ssr));
    function updateSize() {
        height.value = $a7414385605a88b0$var$getClientHeight();
        width.value = $a7414385605a88b0$var$getClientWidth();
    }
    function update() {
        updateSize();
        platform.value = $a7414385605a88b0$var$getPlatform();
    }
    // eslint-disable-next-line max-statements
    (0, $bu8yf.watchEffect)(function() {
        var xs = width.value < thresholds.sm;
        var sm = width.value < thresholds.md && !xs;
        var md = width.value < thresholds.lg && !(sm || xs);
        var lg = width.value < thresholds.xl && !(md || sm || xs);
        var xl = width.value < thresholds.xxl && !(lg || md || sm || xs);
        var xxl = width.value >= thresholds.xxl;
        var name = xs ? 'xs' : sm ? 'sm' : md ? 'md' : lg ? 'lg' : xl ? 'xl' : 'xxl';
        var breakpointValue = typeof mobileBreakpoint === 'number' ? mobileBreakpoint : thresholds[mobileBreakpoint];
        var mobile = width.value < breakpointValue;
        state.xs = xs;
        state.sm = sm;
        state.md = md;
        state.lg = lg;
        state.xl = xl;
        state.xxl = xxl;
        state.smAndUp = !xs;
        state.mdAndUp = !(xs || sm);
        state.lgAndUp = !(xs || sm || md);
        state.xlAndUp = !(xs || sm || md || lg);
        state.smAndDown = !(md || lg || xl || xxl);
        state.mdAndDown = !(lg || xl || xxl);
        state.lgAndDown = !(xl || xxl);
        state.xlAndDown = !xxl;
        state.name = name;
        state.height = height.value;
        state.width = width.value;
        state.mobile = mobile;
        state.mobileBreakpoint = mobileBreakpoint;
        state.platform = platform.value;
        state.thresholds = thresholds;
    });
    if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) {
        window.addEventListener('resize', updateSize, {
            passive: true
        });
        (0, $hXmfK.onScopeDispose)(function() {
            window.removeEventListener('resize', updateSize);
        }, true);
    }
    return (0, $emQHU._)((0, $iT0je._)({}, (0, $hXmfK.toRefs)(state)), {
        update: update,
        ssr: !!ssr
    });
}
var $a7414385605a88b0$export$d0badecb383b472a = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    mobile: {
        type: Boolean,
        "default": false
    },
    mobileBreakpoint: [
        Number,
        String
    ]
}, 'display');
function $a7414385605a88b0$export$8406b7efc286d284() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        mobile: null
    };
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var display = (0, $bu8yf.inject)($a7414385605a88b0$export$9a65027cbda1c19);
    if (!display) throw new Error('Could not find Vuetify display injection');
    var mobile = (0, $hXmfK.computed)(function() {
        if (props.mobile) return true;
        else if (typeof props.mobileBreakpoint === 'number') return display.width.value < props.mobileBreakpoint;
        else if (props.mobileBreakpoint) return display.width.value < display.thresholds.value[props.mobileBreakpoint];
        else if (props.mobile === null) return display.mobile.value;
        else return false;
    });
    var displayClasses = (0, $hXmfK.toRef)(function() {
        if (!name) return {};
        return (0, $cqEAj._)({}, "".concat(name, "--mobile"), mobile.value);
    });
    return (0, $emQHU._)((0, $iT0je._)({}, display), {
        displayClasses: displayClasses,
        mobile: mobile
    });
}


// Utilities

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");


var $c2a741a9f897c45c$export$b6ccca179d0dbca4 = Symbol["for"]('vuetify:goto');
function $c2a741a9f897c45c$var$genDefaults() {
    return {
        container: undefined,
        duration: 300,
        layout: false,
        offset: 0,
        easing: 'easeInOutCubic',
        patterns: {
            linear: function(t) {
                return t;
            },
            easeInQuad: function(t) {
                return Math.pow(t, 2);
            },
            easeOutQuad: function(t) {
                return t * (2 - t);
            },
            easeInOutQuad: function(t) {
                return t < 0.5 ? 2 * Math.pow(t, 2) : -1 + (4 - 2 * t) * t;
            },
            easeInCubic: function(t) {
                return Math.pow(t, 3);
            },
            easeOutCubic: function(t) {
                return Math.pow(--t, 3) + 1;
            },
            easeInOutCubic: function(t) {
                return t < 0.5 ? 4 * Math.pow(t, 3) : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            },
            easeInQuart: function(t) {
                return Math.pow(t, 4);
            },
            easeOutQuart: function(t) {
                return 1 - Math.pow(--t, 4);
            },
            easeInOutQuart: function(t) {
                return t < 0.5 ? 8 * Math.pow(t, 4) : 1 - 8 * Math.pow(--t, 4);
            },
            easeInQuint: function(t) {
                return Math.pow(t, 5);
            },
            easeOutQuint: function(t) {
                return 1 + Math.pow(--t, 5);
            },
            easeInOutQuint: function(t) {
                return t < 0.5 ? 16 * Math.pow(t, 5) : 1 + 16 * Math.pow(--t, 5);
            }
        }
    };
}
function $c2a741a9f897c45c$var$getContainer(el) {
    var _getTarget;
    return (_getTarget = $c2a741a9f897c45c$var$getTarget(el)) !== null && _getTarget !== void 0 ? _getTarget : document.scrollingElement || document.body;
}
function $c2a741a9f897c45c$var$getTarget(el) {
    return typeof el === 'string' ? document.querySelector(el) : (0, $31779689cfd5da50$export$2bffc57ac06742e2)(el);
}
function $c2a741a9f897c45c$var$getOffset(target, horizontal, rtl) {
    if (typeof target === 'number') return horizontal && rtl ? -target : target;
    var el = $c2a741a9f897c45c$var$getTarget(target);
    var totalOffset = 0;
    while(el){
        totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
        el = el.offsetParent;
    }
    return totalOffset;
}
function $c2a741a9f897c45c$export$68787d8a6f2b811a(options, locale) {
    return {
        rtl: locale.isRtl,
        options: (0, $31779689cfd5da50$export$dd702b3c8240390c)($c2a741a9f897c45c$var$genDefaults(), options)
    };
}
function $c2a741a9f897c45c$export$3f99968195accfaf(_target, _options, horizontal, goTo) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
        var property, _goTo_options, options, rtl, _ref, target, container, ease, targetLocation, styles, layoutOffset, _container_property, startLocation, startTime;
        return (0, $9N5UN.__generator)(this, function(_state) {
            property = horizontal ? 'scrollLeft' : 'scrollTop';
            options = (0, $31779689cfd5da50$export$dd702b3c8240390c)((_goTo_options = goTo === null || goTo === void 0 ? void 0 : goTo.options) !== null && _goTo_options !== void 0 ? _goTo_options : $c2a741a9f897c45c$var$genDefaults(), _options);
            rtl = goTo === null || goTo === void 0 ? void 0 : goTo.rtl.value;
            target = (_ref = typeof _target === 'number' ? _target : $c2a741a9f897c45c$var$getTarget(_target)) !== null && _ref !== void 0 ? _ref : 0;
            container = options.container === 'parent' && target instanceof HTMLElement ? target.parentElement : $c2a741a9f897c45c$var$getContainer(options.container);
            ease = typeof options.easing === 'function' ? options.easing : options.patterns[options.easing];
            if (!ease) throw new TypeError('Easing function "'.concat(options.easing, '" not found.'));
            if (typeof target === 'number') targetLocation = $c2a741a9f897c45c$var$getOffset(target, horizontal, rtl);
            else {
                targetLocation = $c2a741a9f897c45c$var$getOffset(target, horizontal, rtl) - $c2a741a9f897c45c$var$getOffset(container, horizontal, rtl);
                if (options.layout) {
                    styles = window.getComputedStyle(target);
                    layoutOffset = styles.getPropertyValue('--v-layout-top');
                    if (layoutOffset) targetLocation -= parseInt(layoutOffset, 10);
                }
            }
            targetLocation += options.offset;
            targetLocation = $c2a741a9f897c45c$var$clampTarget(container, targetLocation, !!rtl, !!horizontal);
            startLocation = (_container_property = container[property]) !== null && _container_property !== void 0 ? _container_property : 0;
            if (targetLocation === startLocation) return [
                2,
                Promise.resolve(targetLocation)
            ];
            startTime = performance.now();
            return [
                2,
                new Promise(function(resolve) {
                    return requestAnimationFrame(function step(currentTime) {
                        var timeElapsed = currentTime - startTime;
                        var progress = timeElapsed / options.duration;
                        var location = Math.floor(startLocation + (targetLocation - startLocation) * ease((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(progress, 0, 1)));
                        container[property] = location;
                        // Allow for some jitter if target time has elapsed
                        if (progress >= 1 && Math.abs(location - container[property]) < 10) return resolve(targetLocation);
                        else if (progress > 2) {
                            // The target might not be reachable
                            (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('Scroll target is not reachable');
                            return resolve(container[property]);
                        }
                        requestAnimationFrame(step);
                    });
                })
            ];
        });
    })();
}
function $c2a741a9f897c45c$export$427b5df65b729c6() {
    var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var goToInstance = (0, $bu8yf.inject)($c2a741a9f897c45c$export$b6ccca179d0dbca4);
    var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
    if (!goToInstance) throw new Error('[Vuetify] Could not find injected goto instance');
    var goTo = (0, $emQHU._)((0, $iT0je._)({}, goToInstance), {
        // can be set via VLocaleProvider
        rtl: (0, $hXmfK.toRef)(function() {
            return goToInstance.rtl.value || isRtl.value;
        })
    });
    function go(target, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                return [
                    2,
                    $c2a741a9f897c45c$export$3f99968195accfaf(target, (0, $31779689cfd5da50$export$dd702b3c8240390c)(_options, options), false, goTo)
                ];
            });
        })();
    }
    go.horizontal = function(target, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                return [
                    2,
                    $c2a741a9f897c45c$export$3f99968195accfaf(target, (0, $31779689cfd5da50$export$dd702b3c8240390c)(_options, options), true, goTo)
                ];
            });
        })();
    };
    return go;
}
/**
 * Clamp target value to achieve a smooth scroll animation
 * when the value goes outside the scroll container size
 */ function $c2a741a9f897c45c$var$clampTarget(container, value, rtl, horizontal) {
    var scrollWidth = container.scrollWidth, scrollHeight = container.scrollHeight;
    var _ref = (0, $32TW8._)(container === document.scrollingElement ? [
        window.innerWidth,
        window.innerHeight
    ] : [
        container.offsetWidth,
        container.offsetHeight
    ], 2), containerWidth = _ref[0], containerHeight = _ref[1];
    var min;
    var max;
    if (horizontal) {
        if (rtl) {
            min = -(scrollWidth - containerWidth);
            max = 0;
        } else {
            min = 0;
            max = scrollWidth - containerWidth;
        }
    } else {
        min = 0;
        max = scrollHeight + -containerHeight;
    }
    return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(value, min, max);
}



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
// Composables

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
// Types
var $298432464b906a1d$export$9af93bb9e9126a2 = {
    collapse: 'mdi-chevron-up',
    complete: 'mdi-check',
    cancel: 'mdi-close-circle',
    close: 'mdi-close',
    "delete": 'mdi-close-circle',
    // delete (e.g. v-chip close)
    clear: 'mdi-close-circle',
    success: 'mdi-check-circle',
    info: 'mdi-information',
    warning: 'mdi-alert-circle',
    error: 'mdi-close-circle',
    prev: 'mdi-chevron-left',
    next: 'mdi-chevron-right',
    checkboxOn: 'mdi-checkbox-marked',
    checkboxOff: 'mdi-checkbox-blank-outline',
    checkboxIndeterminate: 'mdi-minus-box',
    delimiter: 'mdi-circle',
    // for carousel
    sortAsc: 'mdi-arrow-up',
    sortDesc: 'mdi-arrow-down',
    expand: 'mdi-chevron-down',
    menu: 'mdi-menu',
    subgroup: 'mdi-menu-down',
    dropdown: 'mdi-menu-down',
    radioOn: 'mdi-radiobox-marked',
    radioOff: 'mdi-radiobox-blank',
    edit: 'mdi-pencil',
    ratingEmpty: 'mdi-star-outline',
    ratingFull: 'mdi-star',
    ratingHalf: 'mdi-star-half-full',
    loading: 'mdi-cached',
    first: 'mdi-page-first',
    last: 'mdi-page-last',
    unfold: 'mdi-unfold-more-horizontal',
    file: 'mdi-paperclip',
    plus: 'mdi-plus',
    minus: 'mdi-minus',
    calendar: 'mdi-calendar',
    treeviewCollapse: 'mdi-menu-down',
    treeviewExpand: 'mdi-menu-right',
    eyeDropper: 'mdi-eyedropper',
    upload: 'mdi-cloud-upload',
    color: 'mdi-palette',
    command: 'mdi-apple-keyboard-command',
    ctrl: 'mdi-apple-keyboard-control',
    space: 'mdi-keyboard-space',
    shift: 'mdi-apple-keyboard-shift',
    alt: 'mdi-apple-keyboard-option',
    enter: 'mdi-keyboard-return',
    arrowup: 'mdi-arrow-up',
    arrowdown: 'mdi-arrow-down',
    arrowleft: 'mdi-arrow-left',
    arrowright: 'mdi-arrow-right',
    backspace: 'mdi-backspace'
};
var $298432464b906a1d$export$179238ba74376e8c = {
    // Not using mergeProps here, functional components merge props by default (?)
    component: function(props) {
        return (0, $bu8yf.h)((0, $0192db7efcc99bb9$export$87ef10dabc6ea763), (0, $emQHU._)((0, $iT0je._)({}, props), {
            "class": 'mdi'
        }));
    }
};


// Composables

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");



function $87e73a4a4b645892$export$afa64b67e5a01c3b(options) {
    var _options__setup;
    options._setup = (_options__setup = options._setup) !== null && _options__setup !== void 0 ? _options__setup : options.setup;
    if (!options.name) {
        (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('The component is missing an explicit name, unable to generate default prop value');
        return options;
    }
    if (options._setup) {
        var _options_props;
        options.props = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((_options_props = options.props) !== null && _options_props !== void 0 ? _options_props : {}, options.name)();
        var propKeys = Object.keys(options.props).filter(function(key) {
            return key !== 'class' && key !== 'style';
        });
        options.filterProps = function filterProps(props) {
            return (0, $31779689cfd5da50$export$357523c63a2253b9)(props, propKeys);
        };
        options.props._as = String;
        options.setup = function setup(props, ctx) {
            var defaults = (0, $90060d7a7e173b81$export$def078ca8538d812)();
            // Skip props proxy if defaults are not provided
            if (!defaults.value) return options._setup(props, ctx);
            var _props__as;
            var _internalUseDefaults = (0, $90060d7a7e173b81$export$c8b014c4fb5d670b)(props, (_props__as = props._as) !== null && _props__as !== void 0 ? _props__as : options.name, defaults), _props = _internalUseDefaults.props, provideSubDefaults = _internalUseDefaults.provideSubDefaults;
            var setupBindings = options._setup(_props, ctx);
            provideSubDefaults();
            return setupBindings;
        };
    }
    return options;
}
function $87e73a4a4b645892$export$6925fd0bc332cf90() {
    var exposeDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function(options) {
        return (exposeDefaults ? $87e73a4a4b645892$export$afa64b67e5a01c3b : (0, $bu8yf.defineComponent))(options);
    };
}
function $87e73a4a4b645892$export$c5e8501a3a1b4e53(props, render) {
    render.props = props;
    return render;
} // Adds a filterProps method to the component options
 // https://github.com/vuejs/core/pull/10557
 // not a vue Component


var $0192db7efcc99bb9$export$84527c6e3556c23f = [
    String,
    Function,
    Object,
    Array
];
var $0192db7efcc99bb9$export$d477c077e2856eb1 = Symbol["for"]('vuetify:icons');
var $0192db7efcc99bb9$export$bae2637a732731e2 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    icon: {
        type: $0192db7efcc99bb9$export$84527c6e3556c23f
    },
    // Could not remove this and use makeTagProps, types complained because it is not required
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        required: true
    }
}, 'icon');
var $0192db7efcc99bb9$export$151a4e51f3246587 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VComponentIcon',
    props: $0192db7efcc99bb9$export$bae2637a732731e2(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        return function() {
            var Icon = props.icon;
            return (0, $bu8yf.createVNode)(props.tag, null, {
                "default": function() {
                    var _slots_default;
                    return [
                        props.icon ? (0, $bu8yf.createVNode)(Icon, null, null) : (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        };
    }
});
var $0192db7efcc99bb9$export$4cc49047f32a5a44 = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VSvgIcon',
    inheritAttrs: false,
    props: $0192db7efcc99bb9$export$bae2637a732731e2(),
    setup: function(props, _ref2) {
        var attrs = _ref2.attrs;
        return function() {
            return (0, $bu8yf.createVNode)(props.tag, (0, $bu8yf.mergeProps)(attrs, {
                style: null
            }), {
                "default": function() {
                    return [
                        (0, $bu8yf.createElementVNode)("svg", {
                            "class": "v-icon__svg",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            role: "img",
                            "aria-hidden": "true"
                        }, [
                            Array.isArray(props.icon) ? props.icon.map(function(path) {
                                return Array.isArray(path) ? (0, $bu8yf.createElementVNode)("path", {
                                    d: path[0],
                                    "fill-opacity": path[1]
                                }, null) : (0, $bu8yf.createElementVNode)("path", {
                                    d: path
                                }, null);
                            }) : (0, $bu8yf.createElementVNode)("path", {
                                d: props.icon
                            }, null)
                        ])
                    ];
                }
            });
        };
    }
});
var $0192db7efcc99bb9$export$d478d4439906e556 = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VLigatureIcon',
    props: $0192db7efcc99bb9$export$bae2637a732731e2(),
    setup: function(props) {
        return function() {
            return (0, $bu8yf.createVNode)(props.tag, null, {
                "default": function() {
                    return [
                        props.icon
                    ];
                }
            });
        };
    }
});
var $0192db7efcc99bb9$export$87ef10dabc6ea763 = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VClassIcon',
    props: $0192db7efcc99bb9$export$bae2637a732731e2(),
    setup: function(props) {
        return function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)(props.icon)
            }, null);
        };
    }
});
function $0192db7efcc99bb9$var$genDefaults() {
    return {
        svg: {
            component: $0192db7efcc99bb9$export$4cc49047f32a5a44
        },
        "class": {
            component: $0192db7efcc99bb9$export$87ef10dabc6ea763
        }
    };
}
function $0192db7efcc99bb9$export$f8761611413a374e(options) {
    var sets = $0192db7efcc99bb9$var$genDefaults();
    var _options_defaultSet;
    var defaultSet = (_options_defaultSet = options === null || options === void 0 ? void 0 : options.defaultSet) !== null && _options_defaultSet !== void 0 ? _options_defaultSet : 'mdi';
    if (defaultSet === 'mdi' && !sets.mdi) sets.mdi = (0, $298432464b906a1d$export$179238ba74376e8c);
    return (0, $31779689cfd5da50$export$dd702b3c8240390c)({
        defaultSet: defaultSet,
        sets: sets,
        aliases: (0, $emQHU._)((0, $iT0je._)({}, (0, $298432464b906a1d$export$9af93bb9e9126a2)), {
            /* eslint-disable max-len */ vuetify: [
                'M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z',
                [
                    'M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z',
                    0.6
                ]
            ],
            'vuetify-outline': 'svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z',
            'vuetify-play': [
                'm6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z',
                [
                    'M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z',
                    0.6
                ]
            ]
        })
    }, options);
}
var $0192db7efcc99bb9$export$27cb60208885277b = function(props) {
    var icons = (0, $bu8yf.inject)($0192db7efcc99bb9$export$d477c077e2856eb1);
    if (!icons) throw new Error('Missing Vuetify Icons provide!');
    var iconData = (0, $hXmfK.computed)(function() {
        var iconAlias = (0, $hXmfK.toValue)(props);
        if (!iconAlias) return {
            component: $0192db7efcc99bb9$export$151a4e51f3246587
        };
        var icon = iconAlias;
        if (typeof icon === 'string') {
            var _icons_aliases;
            icon = icon.trim();
            if (icon.startsWith('$')) icon = (_icons_aliases = icons.aliases) === null || _icons_aliases === void 0 ? void 0 : _icons_aliases[icon.slice(1)];
        }
        if (!icon) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('Could not find aliased icon "'.concat(iconAlias, '"'));
        if (Array.isArray(icon)) return {
            component: $0192db7efcc99bb9$export$4cc49047f32a5a44,
            icon: icon
        };
        else if (typeof icon !== 'string') return {
            component: $0192db7efcc99bb9$export$151a4e51f3246587,
            icon: icon
        };
        var iconSetName = Object.keys(icons.sets).find(function(setName) {
            return typeof icon === 'string' && icon.startsWith("".concat(setName, ":"));
        });
        var iconName = iconSetName ? icon.slice(iconSetName.length + 1) : icon;
        var iconSet = icons.sets[iconSetName !== null && iconSetName !== void 0 ? iconSetName : icons.defaultSet];
        return {
            component: iconSet.component,
            icon: iconName
        };
    });
    return {
        iconData: iconData
    };
};



// Utilities

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Utilities

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
/**
 * WCAG 3.0 APCA perceptual contrast algorithm from https://github.com/Myndex/SAPC-APCA
 * @licence https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 * @see https://www.w3.org/WAI/GL/task-forces/silver/wiki/Visual_Contrast_of_Text_Subgroup
 */ // Types
// MAGICAL NUMBERS
// sRGB Conversion to Relative Luminance (Y)
// Transfer Curve (aka "Gamma") for sRGB linearization
// Simple power curve vs piecewise described in docs
// Essentially, 2.4 best models actual display
// characteristics in combination with the total method
var $c649c9ddddb8f9d7$var$mainTRC = 2.4;
var $c649c9ddddb8f9d7$var$Rco = 0.2126729; // sRGB Red Coefficient (from matrix)
var $c649c9ddddb8f9d7$var$Gco = 0.7151522; // sRGB Green Coefficient (from matrix)
var $c649c9ddddb8f9d7$var$Bco = 0.0721750; // sRGB Blue Coefficient (from matrix)
// For Finding Raw SAPC Contrast from Relative Luminance (Y)
// Constants for SAPC Power Curve Exponents
// One pair for normal text, and one for reverse
// These are the "beating heart" of SAPC
var $c649c9ddddb8f9d7$var$normBG = 0.55;
var $c649c9ddddb8f9d7$var$normTXT = 0.58;
var $c649c9ddddb8f9d7$var$revTXT = 0.57;
var $c649c9ddddb8f9d7$var$revBG = 0.62;
// For Clamping and Scaling Values
var $c649c9ddddb8f9d7$var$blkThrs = 0.03; // Level that triggers the soft black clamp
var $c649c9ddddb8f9d7$var$blkClmp = 1.45; // Exponent for the soft black clamp curve
var $c649c9ddddb8f9d7$var$deltaYmin = 0.0005; // Lint trap
var $c649c9ddddb8f9d7$var$scaleBoW = 1.25; // Scaling for dark text on light
var $c649c9ddddb8f9d7$var$scaleWoB = 1.25; // Scaling for light text on dark
var $c649c9ddddb8f9d7$var$loConThresh = 0.078; // Threshold for new simple offset scale
var $c649c9ddddb8f9d7$var$loConFactor = 12.82051282051282; // = 1/0.078,
var $c649c9ddddb8f9d7$var$loConOffset = 0.06; // The simple offset
var $c649c9ddddb8f9d7$var$loClip = 0.001; // Output clip (lint trap #2)
function $c649c9ddddb8f9d7$export$31c9349e1a210963(text, background) {
    // Linearize sRGB
    var Rtxt = Math.pow(text.r / 255, $c649c9ddddb8f9d7$var$mainTRC);
    var Gtxt = Math.pow(text.g / 255, $c649c9ddddb8f9d7$var$mainTRC);
    var Btxt = Math.pow(text.b / 255, $c649c9ddddb8f9d7$var$mainTRC);
    var Rbg = Math.pow(background.r / 255, $c649c9ddddb8f9d7$var$mainTRC);
    var Gbg = Math.pow(background.g / 255, $c649c9ddddb8f9d7$var$mainTRC);
    var Bbg = Math.pow(background.b / 255, $c649c9ddddb8f9d7$var$mainTRC);
    // Apply the standard coefficients and sum to Y
    var Ytxt = Rtxt * $c649c9ddddb8f9d7$var$Rco + Gtxt * $c649c9ddddb8f9d7$var$Gco + Btxt * $c649c9ddddb8f9d7$var$Bco;
    var Ybg = Rbg * $c649c9ddddb8f9d7$var$Rco + Gbg * $c649c9ddddb8f9d7$var$Gco + Bbg * $c649c9ddddb8f9d7$var$Bco;
    // Soft clamp Y when near black.
    // Now clamping all colors to prevent crossover errors
    if (Ytxt <= $c649c9ddddb8f9d7$var$blkThrs) Ytxt += Math.pow($c649c9ddddb8f9d7$var$blkThrs - Ytxt, $c649c9ddddb8f9d7$var$blkClmp);
    if (Ybg <= $c649c9ddddb8f9d7$var$blkThrs) Ybg += Math.pow($c649c9ddddb8f9d7$var$blkThrs - Ybg, $c649c9ddddb8f9d7$var$blkClmp);
    // Return 0 Early for extremely low ∆Y (lint trap #1)
    if (Math.abs(Ybg - Ytxt) < $c649c9ddddb8f9d7$var$deltaYmin) return 0.0;
    // SAPC CONTRAST
    var outputContrast; // For weighted final values
    if (Ybg > Ytxt) {
        // For normal polarity, black text on white
        // Calculate the SAPC contrast value and scale
        var SAPC = (Math.pow(Ybg, $c649c9ddddb8f9d7$var$normBG) - Math.pow(Ytxt, $c649c9ddddb8f9d7$var$normTXT)) * $c649c9ddddb8f9d7$var$scaleBoW;
        // NEW! SAPC SmoothScale™
        // Low Contrast Smooth Scale Rollout to prevent polarity reversal
        // and also a low clip for very low contrasts (lint trap #2)
        // much of this is for very low contrasts, less than 10
        // therefore for most reversing needs, only loConOffset is important
        outputContrast = SAPC < $c649c9ddddb8f9d7$var$loClip ? 0.0 : SAPC < $c649c9ddddb8f9d7$var$loConThresh ? SAPC - SAPC * $c649c9ddddb8f9d7$var$loConFactor * $c649c9ddddb8f9d7$var$loConOffset : SAPC - $c649c9ddddb8f9d7$var$loConOffset;
    } else {
        // For reverse polarity, light text on dark
        // WoB should always return negative value.
        var SAPC1 = (Math.pow(Ybg, $c649c9ddddb8f9d7$var$revBG) - Math.pow(Ytxt, $c649c9ddddb8f9d7$var$revTXT)) * $c649c9ddddb8f9d7$var$scaleWoB;
        outputContrast = SAPC1 > -$c649c9ddddb8f9d7$var$loClip ? 0.0 : SAPC1 > -$c649c9ddddb8f9d7$var$loConThresh ? SAPC1 - SAPC1 * $c649c9ddddb8f9d7$var$loConFactor * $c649c9ddddb8f9d7$var$loConOffset : SAPC1 + $c649c9ddddb8f9d7$var$loConOffset;
    }
    return outputContrast * 100;
}




// Types
var $4a5eded43d88f277$var$delta = 0.20689655172413793; // 6÷29
var $4a5eded43d88f277$var$cielabForwardTransform = function(t) {
    return t > Math.pow($4a5eded43d88f277$var$delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow($4a5eded43d88f277$var$delta, 2)) + 4 / 29;
};
var $4a5eded43d88f277$var$cielabReverseTransform = function(t) {
    return t > $4a5eded43d88f277$var$delta ? Math.pow(t, 3) : 3 * Math.pow($4a5eded43d88f277$var$delta, 2) * (t - 4 / 29);
};
function $4a5eded43d88f277$export$33c70ec5bb47f0fb(xyz) {
    var transform = $4a5eded43d88f277$var$cielabForwardTransform;
    var transformedY = transform(xyz[1]);
    return [
        116 * transformedY - 16,
        500 * (transform(xyz[0] / 0.95047) - transformedY),
        200 * (transformedY - transform(xyz[2] / 1.08883))
    ];
}
function $4a5eded43d88f277$export$22e8438d63a97037(lab) {
    var transform = $4a5eded43d88f277$var$cielabReverseTransform;
    var Ln = (lab[0] + 16) / 116;
    return [
        transform(Ln + lab[1] / 500) * 0.95047,
        transform(Ln),
        transform(Ln - lab[2] / 200) * 1.08883
    ];
}


// Utilities

// For converting XYZ to sRGB
var $011557b123421069$var$srgbForwardMatrix = [
    [
        3.2406,
        -1.5372,
        -0.4986
    ],
    [
        -0.9689,
        1.8758,
        0.0415
    ],
    [
        0.0557,
        -0.204,
        1.0570
    ]
];
// Forward gamma adjust
var $011557b123421069$var$srgbForwardTransform = function(C) {
    return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
};
// For converting sRGB to XYZ
var $011557b123421069$var$srgbReverseMatrix = [
    [
        0.4124,
        0.3576,
        0.1805
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.0193,
        0.1192,
        0.9505
    ]
];
// Reverse gamma adjust
var $011557b123421069$var$srgbReverseTransform = function(C) {
    return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
};
function $011557b123421069$export$33c70ec5bb47f0fb(xyz) {
    var rgb = Array(3);
    var transform = $011557b123421069$var$srgbForwardTransform;
    var matrix = $011557b123421069$var$srgbForwardMatrix;
    // Matrix transform, then gamma adjustment
    for(var i = 0; i < 3; ++i)// Rescale back to [0, 255]
    rgb[i] = Math.round((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2]
    };
}
function $011557b123421069$export$22e8438d63a97037(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var xyz = [
        0,
        0,
        0
    ];
    var transform = $011557b123421069$var$srgbReverseTransform;
    var matrix = $011557b123421069$var$srgbReverseMatrix;
    // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
    r = transform(r / 255);
    g = transform(g / 255);
    b = transform(b / 255);
    // Matrix color space transform
    for(var i = 0; i < 3; ++i)xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
    return xyz;
}


function $7eae58fcc02fc7e9$export$773f39ab8b9369ea(color) {
    return !!color && /^(#|var\(--|(rgb|hsl)a?\()/.test(color);
}
function $7eae58fcc02fc7e9$export$d546aa95bdefc037(color) {
    return $7eae58fcc02fc7e9$export$773f39ab8b9369ea(color) && !/^((rgb|hsl)a?\()?var\(--/.test(color);
}
var $7eae58fcc02fc7e9$var$cssColorRe = RegExp("^(?<fn>(?:rgb|hsl)a?)\\((?<values>.+)\\)");
var $7eae58fcc02fc7e9$var$mappers = {
    rgb: function(r, g, b, a) {
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    },
    rgba: function(r, g, b, a) {
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    },
    hsl: function(h, s, l, a) {
        return $7eae58fcc02fc7e9$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        });
    },
    hsla: function(h, s, l, a) {
        return $7eae58fcc02fc7e9$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        });
    },
    hsv: function(h, s, v, a) {
        return $7eae58fcc02fc7e9$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        });
    },
    hsva: function(h, s, v, a) {
        return $7eae58fcc02fc7e9$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        });
    }
};
function $7eae58fcc02fc7e9$export$6e865ea70d7724f(color) {
    if (typeof color === 'number') {
        if (isNaN(color) || color < 0 || color > 0xFFFFFF) // int can't have opacity
        (0, $b0e141e3fccca32c$export$222ba5e7254f2402)("'".concat(color, "' is not a valid hex color"));
        return {
            r: (color & 0xFF0000) >> 16,
            g: (color & 0xFF00) >> 8,
            b: color & 0xFF
        };
    } else if (typeof color === 'string' && $7eae58fcc02fc7e9$var$cssColorRe.test(color)) {
        var _mappers;
        var groups = color.match($7eae58fcc02fc7e9$var$cssColorRe).groups;
        var fn = groups.fn, values = groups.values;
        var realValues = values.split(/,\s*|\s*\/\s*|\s+/).map(function(v, i) {
            if (v.endsWith('%') || // unitless slv are %
            i > 0 && i < 3 && [
                'hsl',
                'hsla',
                'hsv',
                'hsva'
            ].includes(fn)) return parseFloat(v) / 100;
            else return parseFloat(v);
        });
        return (_mappers = $7eae58fcc02fc7e9$var$mappers)[fn].apply(_mappers, (0, $7WNf6._)(realValues));
    } else if (typeof color === 'string') {
        var hex = color.startsWith('#') ? color.slice(1) : color;
        if ([
            3,
            4
        ].includes(hex.length)) hex = hex.split('').map(function(char) {
            return char + char;
        }).join('');
        else if (![
            6,
            8
        ].includes(hex.length)) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)("'".concat(color, "' is not a valid hex(a) color"));
        var int = parseInt(hex, 16);
        if (isNaN(int) || int < 0 || int > 0xFFFFFFFF) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)("'".concat(color, "' is not a valid hex(a) color"));
        return $7eae58fcc02fc7e9$export$a0c6ffd8592ca32(hex);
    } else if ((typeof color === "undefined" ? "undefined" : (0, $3KZcf._)(color)) === 'object') {
        if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(color, [
            'r',
            'g',
            'b'
        ])) return color;
        else if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'l'
        ])) return $7eae58fcc02fc7e9$export$61dbc3014460e6c3($7eae58fcc02fc7e9$export$8917074272868d95(color));
        else if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'v'
        ])) return $7eae58fcc02fc7e9$export$61dbc3014460e6c3(color);
    }
    throw new TypeError("Invalid color: ".concat(color == null ? color : String(color) || color.constructor.name, "\nExpected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number"));
}
function $7eae58fcc02fc7e9$export$2b8e7f0534b33198(color) {
    return (color.r << 16) + (color.g << 8) + color.b;
}
function $7eae58fcc02fc7e9$export$8400161f82277749(color, colors, currentTheme) {
    var _color_toString_trim_replace_split = (0, $32TW8._)(color.toString().trim().replace('-', '').split(' ', 2), 2), colorName = _color_toString_trim_replace_split[0], colorModifier = _color_toString_trim_replace_split[1];
    var hexColor = '';
    if (colorName && colorName in colors) {
        if (colorModifier && colorModifier in colors[colorName]) hexColor = colors[colorName][colorModifier];
        else if ('base' in colors[colorName]) hexColor = colors[colorName].base;
    } else if (colorName && colorName in currentTheme) hexColor = currentTheme[colorName];
    return hexColor;
}
function $7eae58fcc02fc7e9$export$61dbc3014460e6c3(hsva) {
    var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
    var f = function(n) {
        var k = (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    var rgb = [
        f(5),
        f(3),
        f(1)
    ].map(function(v) {
        return Math.round(v * 255);
    });
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        a: a
    };
}
function $7eae58fcc02fc7e9$export$7d768da925875d05(hsla) {
    return $7eae58fcc02fc7e9$export$61dbc3014460e6c3($7eae58fcc02fc7e9$export$8917074272868d95(hsla));
}
function $7eae58fcc02fc7e9$export$62bb88c9baab039f(rgba) {
    if (!rgba) return {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    };
    var r = rgba.r / 255;
    var g = rgba.g / 255;
    var b = rgba.b / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    if (max !== min) {
        if (max === r) h = 60 * (0 + (g - b) / (max - min));
        else if (max === g) h = 60 * (2 + (b - r) / (max - min));
        else if (max === b) h = 60 * (4 + (r - g) / (max - min));
    }
    if (h < 0) h = h + 360;
    var s = max === 0 ? 0 : (max - min) / max;
    var hsv = [
        h,
        s,
        max
    ];
    return {
        h: hsv[0],
        s: hsv[1],
        v: hsv[2],
        a: rgba.a
    };
}
function $7eae58fcc02fc7e9$export$f24257e859bd61bb(hsva) {
    var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
    var l = v - v * s / 2;
    var sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
    return {
        h: h,
        s: sprime,
        l: l,
        a: a
    };
}
function $7eae58fcc02fc7e9$export$8917074272868d95(hsl) {
    var h = hsl.h, s = hsl.s, l = hsl.l, a = hsl.a;
    var v = l + s * Math.min(l, 1 - l);
    var sprime = v === 0 ? 0 : 2 - 2 * l / v;
    return {
        h: h,
        s: sprime,
        v: v,
        a: a
    };
}
function $7eae58fcc02fc7e9$export$db9c9368f923228e(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b, a = _ref.a;
    return a === undefined ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
function $7eae58fcc02fc7e9$export$25aeffa982c279d7(hsva) {
    return $7eae58fcc02fc7e9$export$db9c9368f923228e($7eae58fcc02fc7e9$export$61dbc3014460e6c3(hsva));
}
function $7eae58fcc02fc7e9$var$toHex(v) {
    var h = Math.round(v).toString(16);
    return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
}
function $7eae58fcc02fc7e9$export$bf61bc94b2104040(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "#".concat([
        $7eae58fcc02fc7e9$var$toHex(r),
        $7eae58fcc02fc7e9$var$toHex(g),
        $7eae58fcc02fc7e9$var$toHex(b),
        a !== undefined ? $7eae58fcc02fc7e9$var$toHex(Math.round(a * 255)) : ''
    ].join(''));
}
function $7eae58fcc02fc7e9$export$a0c6ffd8592ca32(hex) {
    hex = $7eae58fcc02fc7e9$export$103711ef09c6edec(hex);
    var _chunk_map = (0, $32TW8._)((0, $31779689cfd5da50$export$5f7ec48d69707ddd)(hex, 2).map(function(c) {
        return parseInt(c, 16);
    }), 4), r = _chunk_map[0], g = _chunk_map[1], b = _chunk_map[2], a = _chunk_map[3];
    a = a === undefined ? a : a / 255;
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $7eae58fcc02fc7e9$export$4e9396b641d87477(hex) {
    var rgb = $7eae58fcc02fc7e9$export$a0c6ffd8592ca32(hex);
    return $7eae58fcc02fc7e9$export$62bb88c9baab039f(rgb);
}
function $7eae58fcc02fc7e9$export$883c749ec82cf1f2(hsva) {
    return $7eae58fcc02fc7e9$export$bf61bc94b2104040($7eae58fcc02fc7e9$export$61dbc3014460e6c3(hsva));
}
function $7eae58fcc02fc7e9$export$103711ef09c6edec(hex) {
    if (hex.startsWith('#')) hex = hex.slice(1);
    hex = hex.replace(/([^0-9a-f])/gi, 'F');
    if (hex.length === 3 || hex.length === 4) hex = hex.split('').map(function(x) {
        return x + x;
    }).join('');
    if (hex.length !== 6) hex = (0, $31779689cfd5da50$export$23a07ddfce9fad49)((0, $31779689cfd5da50$export$23a07ddfce9fad49)(hex, 6), 8, 'F');
    return hex;
}
function $7eae58fcc02fc7e9$export$1089ae7f4d02cd2e(gradient, colors, currentTheme) {
    return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, function(x) {
        return $7eae58fcc02fc7e9$export$8400161f82277749(x, colors, currentTheme) || x;
    }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, function(x) {
        return 'rgba(' + Object.values($7eae58fcc02fc7e9$export$a0c6ffd8592ca32($7eae58fcc02fc7e9$export$103711ef09c6edec(x.replace(/rgba\(/, '')))).slice(0, 3).join(',');
    });
}
function $7eae58fcc02fc7e9$export$c0816ed86df316af(value, amount) {
    var lab = $4a5eded43d88f277$export$33c70ec5bb47f0fb($011557b123421069$export$22e8438d63a97037(value));
    lab[0] = lab[0] + amount * 10;
    return $011557b123421069$export$33c70ec5bb47f0fb($4a5eded43d88f277$export$22e8438d63a97037(lab));
}
function $7eae58fcc02fc7e9$export$4b073707ff63303(value, amount) {
    var lab = $4a5eded43d88f277$export$33c70ec5bb47f0fb($011557b123421069$export$22e8438d63a97037(value));
    lab[0] = lab[0] - amount * 10;
    return $011557b123421069$export$33c70ec5bb47f0fb($4a5eded43d88f277$export$22e8438d63a97037(lab));
}
function $7eae58fcc02fc7e9$export$606ef4b19aeb1c9c(color) {
    var rgb = $7eae58fcc02fc7e9$export$6e865ea70d7724f(color);
    return $011557b123421069$export$22e8438d63a97037(rgb)[1];
}
function $7eae58fcc02fc7e9$export$850ce485a60d103b(first, second) {
    var l1 = $7eae58fcc02fc7e9$export$606ef4b19aeb1c9c(first);
    var l2 = $7eae58fcc02fc7e9$export$606ef4b19aeb1c9c(second);
    var light = Math.max(l1, l2);
    var dark = Math.min(l1, l2);
    return (light + 0.05) / (dark + 0.05);
}
function $7eae58fcc02fc7e9$export$27d3ce2b326d356d(color) {
    var blackContrast = Math.abs((0, $c649c9ddddb8f9d7$export$31c9349e1a210963)($7eae58fcc02fc7e9$export$6e865ea70d7724f(0), $7eae58fcc02fc7e9$export$6e865ea70d7724f(color)));
    var whiteContrast = Math.abs((0, $c649c9ddddb8f9d7$export$31c9349e1a210963)($7eae58fcc02fc7e9$export$6e865ea70d7724f(0xffffff), $7eae58fcc02fc7e9$export$6e865ea70d7724f(color)));
    // TODO: warn about poor color selections
    // const contrastAsText = Math.abs(APCAcontrast(colorVal, colorToInt(theme.colors.background)))
    // const minContrast = Math.max(blackContrast, whiteContrast)
    // if (minContrast < 60) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast (${minContrast.toFixed()}%)`)
    // } else if (contrastAsText < 60 && !['background', 'surface'].includes(color)) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast as text (${contrastAsText.toFixed()}%)`)
    // }
    // Prefer white text if both have an acceptable contrast ratio
    return whiteContrast > Math.min(blackContrast, 50) ? '#fff' : '#000';
}


var $d8647489982f8a06$export$607927b8ce46d117 = Symbol["for"]('vuetify:theme');
var $d8647489982f8a06$export$d0fc5ddd543b4149 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    theme: String
}, 'theme');
function $d8647489982f8a06$var$genDefaults() {
    return {
        defaultTheme: 'light',
        prefix: 'v-',
        variations: {
            colors: [],
            lighten: 0,
            darken: 0
        },
        themes: {
            light: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    'surface-bright': '#FFFFFF',
                    'surface-light': '#EEEEEE',
                    'surface-variant': '#424242',
                    'on-surface-variant': '#EEEEEE',
                    primary: '#1867C0',
                    'primary-darken-1': '#1F5592',
                    secondary: '#48A9A6',
                    'secondary-darken-1': '#018786',
                    error: '#B00020',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#000000',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 0.87,
                    'medium-emphasis-opacity': 0.60,
                    'disabled-opacity': 0.38,
                    'idle-opacity': 0.04,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.12,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#EEEEEE',
                    'theme-on-kbd': '#000000',
                    'theme-code': '#F5F5F5',
                    'theme-on-code': '#000000'
                }
            },
            dark: {
                dark: true,
                colors: {
                    background: '#121212',
                    surface: '#212121',
                    'surface-bright': '#ccbfd6',
                    'surface-light': '#424242',
                    'surface-variant': '#c8c8c8',
                    'on-surface-variant': '#000000',
                    primary: '#2196F3',
                    'primary-darken-1': '#277CC1',
                    secondary: '#54B6B2',
                    'secondary-darken-1': '#48A9A6',
                    error: '#CF6679',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#FFFFFF',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 1,
                    'medium-emphasis-opacity': 0.70,
                    'disabled-opacity': 0.50,
                    'idle-opacity': 0.10,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.16,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#424242',
                    'theme-on-kbd': '#FFFFFF',
                    'theme-code': '#343434',
                    'theme-on-code': '#CCCCCC'
                }
            }
        },
        stylesheetId: 'vuetify-theme-stylesheet',
        scoped: false,
        unimportant: false,
        utilities: true
    };
}
function $d8647489982f8a06$var$parseThemeOptions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d8647489982f8a06$var$genDefaults();
    var defaults = $d8647489982f8a06$var$genDefaults();
    if (!options) return (0, $emQHU._)((0, $iT0je._)({}, defaults), {
        isDisabled: true
    });
    var themes = {};
    var _options_themes;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries((_options_themes = options.themes) !== null && _options_themes !== void 0 ? _options_themes : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], theme = _step_value[1];
            var _defaults_themes, _defaults_themes1;
            var defaultTheme = theme.dark || key === 'dark' ? (_defaults_themes = defaults.themes) === null || _defaults_themes === void 0 ? void 0 : _defaults_themes.dark : (_defaults_themes1 = defaults.themes) === null || _defaults_themes1 === void 0 ? void 0 : _defaults_themes1.light;
            themes[key] = (0, $31779689cfd5da50$export$dd702b3c8240390c)(defaultTheme, theme);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $31779689cfd5da50$export$dd702b3c8240390c)(defaults, (0, $emQHU._)((0, $iT0je._)({}, options), {
        themes: themes
    }));
}
function $d8647489982f8a06$var$createCssClass(lines, selector, content, scope) {
    var _lines;
    (_lines = lines).push.apply(_lines, [
        "".concat($d8647489982f8a06$var$getScopedSelector(selector, scope), " {\n")
    ].concat((0, $7WNf6._)(content.map(function(line) {
        return "  ".concat(line, ";\n");
    })), [
        '}\n'
    ]));
}
function $d8647489982f8a06$var$genCssVariables(theme, prefix) {
    var lightOverlay = theme.dark ? 2 : 1;
    var darkOverlay = theme.dark ? 1 : 2;
    var variables = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(theme.colors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var rgb = (0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(value);
            variables.push("--".concat(prefix, "theme-").concat(key, ": ").concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b));
            if (!key.startsWith('on-')) variables.push("--".concat(prefix, "theme-").concat(key, "-overlay-multiplier: ").concat((0, $7eae58fcc02fc7e9$export$606ef4b19aeb1c9c)(value) > 0.18 ? lightOverlay : darkOverlay));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.entries(theme.variables)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $32TW8._)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
            var color = typeof value1 === 'string' && value1.startsWith('#') ? (0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(value1) : undefined;
            var rgb1 = color ? "".concat(color.r, ", ").concat(color.g, ", ").concat(color.b) : undefined;
            variables.push("--".concat(prefix).concat(key1, ": ").concat(rgb1 !== null && rgb1 !== void 0 ? rgb1 : value1));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return variables;
}
function $d8647489982f8a06$var$genVariation(name, color, variations) {
    var object = {};
    if (variations) for(var _i = 0, _iter = [
        'lighten',
        'darken'
    ]; _i < _iter.length; _i++){
        var variation = _iter[_i];
        var fn = variation === 'lighten' ? (0, $7eae58fcc02fc7e9$export$c0816ed86df316af) : (0, $7eae58fcc02fc7e9$export$4b073707ff63303);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(variations[variation], 1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var amount = _step.value;
                object["".concat(name, "-").concat(variation, "-").concat(amount)] = (0, $7eae58fcc02fc7e9$export$bf61bc94b2104040)(fn((0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(color), amount));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return object;
}
function $d8647489982f8a06$var$genVariations(colors, variations) {
    if (!variations) return {};
    var variationColors = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = variations.colors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var color = colors[name];
            if (!color) continue;
            variationColors = (0, $iT0je._)({}, variationColors, $d8647489982f8a06$var$genVariation(name, color, variations));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return variationColors;
}
function $d8647489982f8a06$var$genOnColors(colors) {
    var onColors = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(colors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var color = _step.value;
            if (color.startsWith('on-') || colors["on-".concat(color)]) continue;
            var onColor = "on-".concat(color);
            var colorVal = (0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(colors[color]);
            onColors[onColor] = (0, $7eae58fcc02fc7e9$export$27d3ce2b326d356d)(colorVal);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return onColors;
}
function $d8647489982f8a06$var$getScopedSelector(selector, scope) {
    if (!scope) return selector;
    var scopeSelector = ":where(".concat(scope, ")");
    return selector === ':root' ? scopeSelector : "".concat(scopeSelector, " ").concat(selector);
}
function $d8647489982f8a06$var$upsertStyles(id, cspNonce, styles) {
    var styleEl = $d8647489982f8a06$var$getOrCreateStyleElement(id, cspNonce);
    if (!styleEl) return;
    styleEl.innerHTML = styles;
}
function $d8647489982f8a06$var$getOrCreateStyleElement(id, cspNonce) {
    if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) return null;
    var style = document.getElementById(id);
    if (!style) {
        style = document.createElement('style');
        style.id = id;
        style.type = 'text/css';
        if (cspNonce) style.setAttribute('nonce', cspNonce);
        document.head.appendChild(style);
    }
    return style;
}
function $d8647489982f8a06$export$25d302a5b900a763(options) {
    var parsedOptions = $d8647489982f8a06$var$parseThemeOptions(options);
    var _name = (0, $hXmfK.shallowRef)(parsedOptions.defaultTheme);
    var themes = (0, $hXmfK.ref)(parsedOptions.themes);
    var systemName = (0, $hXmfK.shallowRef)('light');
    var name = (0, $hXmfK.computed)({
        get: function() {
            return _name.value === 'system' ? systemName.value : _name.value;
        },
        set: function(val) {
            _name.value = val;
        }
    });
    var computedThemes = (0, $hXmfK.computed)(function() {
        var acc = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(themes.value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $32TW8._)(_step.value, 2), name = _step_value[0], original = _step_value[1];
                var colors = (0, $iT0je._)({}, original.colors, $d8647489982f8a06$var$genVariations(original.colors, parsedOptions.variations));
                acc[name] = (0, $emQHU._)((0, $iT0je._)({}, original), {
                    colors: (0, $iT0je._)({}, colors, $d8647489982f8a06$var$genOnColors(colors))
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return acc;
    });
    var current = (0, $hXmfK.toRef)(function() {
        return computedThemes.value[name.value];
    });
    var styles = (0, $hXmfK.computed)(function() {
        var _current_value;
        var lines = [];
        var important = parsedOptions.unimportant ? '' : ' !important';
        var scoped = parsedOptions.scoped ? parsedOptions.prefix : '';
        if ((_current_value = current.value) === null || _current_value === void 0 ? void 0 : _current_value.dark) $d8647489982f8a06$var$createCssClass(lines, ':root', [
            'color-scheme: dark'
        ], parsedOptions.scope);
        $d8647489982f8a06$var$createCssClass(lines, ':root', $d8647489982f8a06$var$genCssVariables(current.value, parsedOptions.prefix), parsedOptions.scope);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(computedThemes.value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $32TW8._)(_step.value, 2), themeName = _step_value[0], theme = _step_value[1];
                $d8647489982f8a06$var$createCssClass(lines, ".".concat(parsedOptions.prefix, "theme--").concat(themeName), [
                    "color-scheme: ".concat(theme.dark ? 'dark' : 'normal')
                ].concat((0, $7WNf6._)($d8647489982f8a06$var$genCssVariables(theme, parsedOptions.prefix))), parsedOptions.scope);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (parsedOptions.utilities) {
            var _lines;
            var bgLines = [];
            var fgLines = [];
            var colors = new Set(Object.values(computedThemes.value).flatMap(function(theme) {
                return Object.keys(theme.colors);
            }));
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = colors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    if (key.startsWith('on-')) $d8647489982f8a06$var$createCssClass(fgLines, ".".concat(key), [
                        "color: rgb(var(--".concat(parsedOptions.prefix, "theme-").concat(key, "))").concat(important)
                    ], parsedOptions.scope);
                    else {
                        $d8647489982f8a06$var$createCssClass(bgLines, ".".concat(scoped, "bg-").concat(key), [
                            "--".concat(parsedOptions.prefix, "theme-overlay-multiplier: var(--").concat(parsedOptions.prefix, "theme-").concat(key, "-overlay-multiplier)"),
                            "background-color: rgb(var(--".concat(parsedOptions.prefix, "theme-").concat(key, "))").concat(important),
                            "color: rgb(var(--".concat(parsedOptions.prefix, "theme-on-").concat(key, "))").concat(important)
                        ], parsedOptions.scope);
                        $d8647489982f8a06$var$createCssClass(fgLines, ".".concat(scoped, "text-").concat(key), [
                            "color: rgb(var(--".concat(parsedOptions.prefix, "theme-").concat(key, "))").concat(important)
                        ], parsedOptions.scope);
                        $d8647489982f8a06$var$createCssClass(fgLines, ".".concat(scoped, "border-").concat(key), [
                            "--".concat(parsedOptions.prefix, "border-color: var(--").concat(parsedOptions.prefix, "theme-").concat(key, ")")
                        ], parsedOptions.scope);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            (_lines = lines).push.apply(_lines, (0, $7WNf6._)(bgLines).concat((0, $7WNf6._)(fgLines)));
        }
        return lines.map(function(str, i) {
            return i === 0 ? str : "    ".concat(str);
        }).join('');
    });
    var themeClasses = (0, $hXmfK.toRef)(function() {
        return parsedOptions.isDisabled ? undefined : "".concat(parsedOptions.prefix, "theme--").concat(name.value);
    });
    var themeNames = (0, $hXmfK.toRef)(function() {
        return Object.keys(computedThemes.value);
    });
    if (0, $10db88b646d64b14$export$622094c5d6c3013b) {
        var updateSystemName = function updateSystemName() {
            systemName.value = media.matches ? 'dark' : 'light';
        };
        var media = window.matchMedia('(prefers-color-scheme: dark)');
        updateSystemName();
        media.addEventListener('change', updateSystemName, {
            passive: true
        });
        if ((0, $hXmfK.getCurrentScope)()) (0, $hXmfK.onScopeDispose)(function() {
            media.removeEventListener('change', updateSystemName);
        });
    }
    function install(app) {
        if (parsedOptions.isDisabled) return;
        var head = app._context.provides.usehead;
        if (head) {
            var getHead = function getHead() {
                return {
                    style: [
                        {
                            textContent: styles.value,
                            id: parsedOptions.stylesheetId,
                            nonce: parsedOptions.cspNonce || false
                        }
                    ]
                };
            };
            if (head.push) {
                var entry = head.push(getHead);
                if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) (0, $hXmfK.watch)(styles, function() {
                    entry.patch(getHead);
                });
            } else if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) {
                head.addHeadObjs((0, $hXmfK.toRef)(getHead));
                (0, $bu8yf.watchEffect)(function() {
                    return head.updateDOM();
                });
            } else head.addHeadObjs(getHead());
        } else {
            var updateStyles = function updateStyles() {
                $d8647489982f8a06$var$upsertStyles(parsedOptions.stylesheetId, parsedOptions.cspNonce, styles.value);
            };
            if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) (0, $hXmfK.watch)(styles, updateStyles, {
                immediate: true
            });
            else updateStyles();
        }
    }
    function change(themeName) {
        if (!themeNames.value.includes(themeName)) {
            (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('Theme "'.concat(themeName, '" not found on the Vuetify theme instance'));
            return;
        }
        name.value = themeName;
    }
    function cycle() {
        var themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeNames.value;
        var currentIndex = themeArray.indexOf(name.value);
        var nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % themeArray.length;
        change(themeArray[nextIndex]);
    }
    function toggle() {
        var themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'light',
            'dark'
        ];
        cycle(themeArray);
    }
    var globalName = new Proxy(name, {
        get: function(target, prop) {
            return Reflect.get(target, prop);
        },
        set: function(target, prop, val) {
            if (prop === 'value') (0, $b0e141e3fccca32c$export$b680e6b2c82f8c2f)("theme.global.name.value = ".concat(val), "theme.change('".concat(val, "')"));
            return Reflect.set(target, prop, val);
        }
    });
    return {
        install: install,
        change: change,
        cycle: cycle,
        toggle: toggle,
        isDisabled: parsedOptions.isDisabled,
        name: name,
        themes: themes,
        current: current,
        computedThemes: computedThemes,
        prefix: parsedOptions.prefix,
        themeClasses: themeClasses,
        styles: styles,
        global: {
            name: globalName,
            current: current
        }
    };
}
function $d8647489982f8a06$export$307b27329074e447(props) {
    (0, $f4cc842872cc2659$export$f13e630aa3915748)('provideTheme');
    var theme = (0, $bu8yf.inject)($d8647489982f8a06$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    var name = (0, $hXmfK.toRef)(function() {
        var _props_theme;
        return (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : theme.name.value;
    });
    var current = (0, $hXmfK.toRef)(function() {
        return theme.themes.value[name.value];
    });
    var themeClasses = (0, $hXmfK.toRef)(function() {
        return theme.isDisabled ? undefined : "".concat(theme.prefix, "theme--").concat(name.value);
    });
    var newTheme = (0, $emQHU._)((0, $iT0je._)({}, theme), {
        name: name,
        current: current,
        themeClasses: themeClasses
    });
    (0, $bu8yf.provide)($d8647489982f8a06$export$607927b8ce46d117, newTheme);
    return newTheme;
}
function $d8647489982f8a06$export$93d4e7f90805808f() {
    (0, $f4cc842872cc2659$export$f13e630aa3915748)('useTheme');
    var theme = (0, $bu8yf.inject)($d8647489982f8a06$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    return theme;
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");



function $26ea8d1be9e46d91$export$ef34132de12b844b() {
    var vuetify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var blueprint = vuetify.blueprint, rest = (0, $g79Gh._)(vuetify, [
        "blueprint"
    ]);
    var options = (0, $31779689cfd5da50$export$dd702b3c8240390c)(blueprint, rest);
    var _options_aliases = options.aliases, aliases = _options_aliases === void 0 ? {} : _options_aliases, _options_components = options.components, components = _options_components === void 0 ? {} : _options_components, _options_directives = options.directives, directives = _options_directives === void 0 ? {} : _options_directives;
    var scope = (0, $hXmfK.effectScope)();
    return scope.run(function() {
        var install = function install(app) {
            for(var key in directives)app.directive(key, directives[key]);
            for(var key1 in components)app.component(key1, components[key1]);
            for(var key2 in aliases)app.component(key2, (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)((0, $emQHU._)((0, $iT0je._)({}, aliases[key2]), {
                name: key2,
                aliasName: aliases[key2].name
            })));
            var appScope = (0, $hXmfK.effectScope)();
            appScope.run(function() {
                theme.install(app);
            });
            app.onUnmount(function() {
                return appScope.stop();
            });
            app.provide((0, $90060d7a7e173b81$export$84318fce2211c0fd), defaults);
            app.provide((0, $a7414385605a88b0$export$9a65027cbda1c19), display);
            app.provide((0, $d8647489982f8a06$export$607927b8ce46d117), theme);
            app.provide((0, $0192db7efcc99bb9$export$d477c077e2856eb1), icons);
            app.provide((0, $b4c1f4104dc86d4b$export$36c469862c41ebd3), locale);
            app.provide((0, $ff9e087639c00a2b$export$ee409445cb0eea8f), date.options);
            app.provide((0, $ff9e087639c00a2b$export$77c3d555e2fd633c), date.instance);
            app.provide((0, $c2a741a9f897c45c$export$b6ccca179d0dbca4), goTo);
            if ((0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && options.ssr) {
                if (app.$nuxt) app.$nuxt.hook('app:suspense:resolve', function() {
                    display.update();
                });
                else {
                    var mount = app.mount;
                    app.mount = function() {
                        var vm = mount.apply(void 0, arguments);
                        (0, $bu8yf.nextTick)(function() {
                            return display.update();
                        });
                        app.mount = mount;
                        return vm;
                    };
                }
            }
            if (typeof __VUE_OPTIONS_API__ !== 'boolean' || __VUE_OPTIONS_API__) app.mixin({
                computed: {
                    $vuetify: function() {
                        return (0, $hXmfK.reactive)({
                            defaults: $26ea8d1be9e46d91$var$inject.call(this, (0, $90060d7a7e173b81$export$84318fce2211c0fd)),
                            display: $26ea8d1be9e46d91$var$inject.call(this, (0, $a7414385605a88b0$export$9a65027cbda1c19)),
                            theme: $26ea8d1be9e46d91$var$inject.call(this, (0, $d8647489982f8a06$export$607927b8ce46d117)),
                            icons: $26ea8d1be9e46d91$var$inject.call(this, (0, $0192db7efcc99bb9$export$d477c077e2856eb1)),
                            locale: $26ea8d1be9e46d91$var$inject.call(this, (0, $b4c1f4104dc86d4b$export$36c469862c41ebd3)),
                            date: $26ea8d1be9e46d91$var$inject.call(this, (0, $ff9e087639c00a2b$export$77c3d555e2fd633c))
                        });
                    }
                }
            });
        };
        var unmount = function unmount() {
            scope.stop();
        };
        var defaults = (0, $90060d7a7e173b81$export$e149fd47ce43e254)(options.defaults);
        var display = (0, $a7414385605a88b0$export$630b3f7014e81311)(options.display, options.ssr);
        var theme = (0, $d8647489982f8a06$export$25d302a5b900a763)(options.theme);
        var icons = (0, $0192db7efcc99bb9$export$f8761611413a374e)(options.icons);
        var locale = (0, $b4c1f4104dc86d4b$export$9af58f1cfd1fbeb4)(options.locale);
        var date = (0, $ff9e087639c00a2b$export$e029667a62135fd0)(options.date, locale);
        var goTo = (0, $c2a741a9f897c45c$export$68787d8a6f2b811a)(options.goTo, locale);
        return {
            install: install,
            unmount: unmount,
            defaults: defaults,
            display: display,
            theme: theme,
            icons: icons,
            locale: locale,
            date: date,
            goTo: goTo
        };
    });
}
var $26ea8d1be9e46d91$export$83d89fbfd8236492 = "3.9.2";
$26ea8d1be9e46d91$export$ef34132de12b844b.version = $26ea8d1be9e46d91$export$83d89fbfd8236492;
// Vue's inject() can only be used in setup
function $26ea8d1be9e46d91$var$inject(key) {
    var _vm_parent, _vm_vnode_appContext;
    var vm = this.$;
    var _vm_parent_provides;
    var provides = (_vm_parent_provides = (_vm_parent = vm.parent) === null || _vm_parent === void 0 ? void 0 : _vm_parent.provides) !== null && _vm_parent_provides !== void 0 ? _vm_parent_provides : (_vm_vnode_appContext = vm.vnode.appContext) === null || _vm_vnode_appContext === void 0 ? void 0 : _vm_vnode_appContext.provides;
    if (provides && key in provides) return provides[key];
}



var $fca2e0606619333d$exports = {};
var $5ab959b8b067cf4d$exports = {};

$parcel$export($5ab959b8b067cf4d$exports, "VApp", function () { return $d35fa18c82598d8d$export$60414d50d930f930; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

// Utilities

var $2b50544a76f0a26e$export$d271552babda0448 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    "class": [
        String,
        Array,
        Object
    ],
    style: {
        type: [
            String,
            Array,
            Object
        ],
        "default": null
    }
}, 'component');


// Composables

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");


function $0a5bdd4f835cefd8$export$683480f191c0e3ea(callback) {
    var box = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'content';
    var resizeRef = (0, $31779689cfd5da50$export$fc38e812d383221)();
    var contentRect = (0, $hXmfK.ref)();
    if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) {
        var observer = new ResizeObserver(function(entries) {
            callback === null || callback === void 0 ? void 0 : callback(entries, observer);
            if (!entries.length) return;
            if (box === 'content') contentRect.value = entries[0].contentRect;
            else contentRect.value = entries[0].target.getBoundingClientRect();
        });
        (0, $bu8yf.onBeforeUnmount)(function() {
            observer.disconnect();
        });
        (0, $hXmfK.watch)(function() {
            return resizeRef.el;
        }, function(newValue, oldValue) {
            if (oldValue) {
                observer.unobserve(oldValue);
                contentRect.value = undefined;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        resizeRef: resizeRef,
        contentRect: (0, $hXmfK.readonly)(contentRect)
    };
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $39e98ff3447d557e$export$6c0af7fe4dd9b19b = Symbol["for"]('vuetify:layout');
var $39e98ff3447d557e$export$e8f59a037946a8c0 = Symbol["for"]('vuetify:layout-item');
var $39e98ff3447d557e$var$ROOT_ZINDEX = 1000;
var $39e98ff3447d557e$export$f0037fcffb4e2081 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    overlaps: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    fullHeight: Boolean
}, 'layout');
var $39e98ff3447d557e$export$d42abac634ace931 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    name: {
        type: String
    },
    order: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    absolute: Boolean
}, 'layout-item');
function $39e98ff3447d557e$export$f47430f7ffdcc134() {
    var layout = (0, $bu8yf.inject)($39e98ff3447d557e$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    return {
        getLayoutItem: layout.getLayoutItem,
        mainRect: layout.mainRect,
        mainStyles: layout.mainStyles
    };
}
function $39e98ff3447d557e$export$e2f4c0dffffc8723(options) {
    var layout = (0, $bu8yf.inject)($39e98ff3447d557e$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    var _options_id;
    var id = (_options_id = options.id) !== null && _options_id !== void 0 ? _options_id : "layout-item-".concat((0, $bu8yf.useId)());
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useLayoutItem');
    (0, $bu8yf.provide)($39e98ff3447d557e$export$e8f59a037946a8c0, {
        id: id
    });
    var isKeptAlive = (0, $hXmfK.shallowRef)(false);
    (0, $bu8yf.onDeactivated)(function() {
        return isKeptAlive.value = true;
    });
    (0, $bu8yf.onActivated)(function() {
        return isKeptAlive.value = false;
    });
    var _layout_register = layout.register(vm, (0, $emQHU._)((0, $iT0je._)({}, options), {
        active: (0, $hXmfK.computed)(function() {
            return isKeptAlive.value ? false : options.active.value;
        }),
        id: id
    })), layoutItemStyles = _layout_register.layoutItemStyles, layoutItemScrimStyles = _layout_register.layoutItemScrimStyles;
    (0, $bu8yf.onBeforeUnmount)(function() {
        return layout.unregister(id);
    });
    return {
        layoutItemStyles: layoutItemStyles,
        layoutRect: layout.layoutRect,
        layoutItemScrimStyles: layoutItemScrimStyles
    };
}
var $39e98ff3447d557e$var$generateLayers = function(layout, positions, layoutSizes, activeItems) {
    var previousLayer = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    };
    var layers = [
        {
            id: '',
            layer: (0, $iT0je._)({}, previousLayer)
        }
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layout[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            var position = positions.get(id);
            var amount = layoutSizes.get(id);
            var active = activeItems.get(id);
            if (!position || !amount || !active) continue;
            var layer = (0, $emQHU._)((0, $iT0je._)({}, previousLayer), (0, $cqEAj._)({}, position.value, parseInt(previousLayer[position.value], 10) + (active.value ? parseInt(amount.value, 10) : 0)));
            layers.push({
                id: id,
                layer: layer
            });
            previousLayer = layer;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return layers;
};
function $39e98ff3447d557e$export$3dd437ade36ede40(props) {
    var parentLayout = (0, $bu8yf.inject)($39e98ff3447d557e$export$6c0af7fe4dd9b19b, null);
    var rootZIndex = (0, $hXmfK.computed)(function() {
        return parentLayout ? parentLayout.rootZIndex.value - 100 : $39e98ff3447d557e$var$ROOT_ZINDEX;
    });
    var registered = (0, $hXmfK.ref)([]);
    var positions = (0, $hXmfK.reactive)(new Map());
    var layoutSizes = (0, $hXmfK.reactive)(new Map());
    var priorities = (0, $hXmfK.reactive)(new Map());
    var activeItems = (0, $hXmfK.reactive)(new Map());
    var disabledTransitions = (0, $hXmfK.reactive)(new Map());
    var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), resizeRef = _useResizeObserver.resizeRef, layoutRect = _useResizeObserver.contentRect;
    var computedOverlaps = (0, $hXmfK.computed)(function() {
        var map = new Map();
        var _props_overlaps;
        var overlaps = (_props_overlaps = props.overlaps) !== null && _props_overlaps !== void 0 ? _props_overlaps : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = overlaps.filter(function(item) {
                return item.includes(':');
            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var overlap = _step.value;
                var _overlap_split = (0, $32TW8._)(overlap.split(':'), 2), top = _overlap_split[0], bottom = _overlap_split[1];
                if (!registered.value.includes(top) || !registered.value.includes(bottom)) continue;
                var topPosition = positions.get(top);
                var bottomPosition = positions.get(bottom);
                var topAmount = layoutSizes.get(top);
                var bottomAmount = layoutSizes.get(bottom);
                if (!topPosition || !bottomPosition || !topAmount || !bottomAmount) continue;
                map.set(bottom, {
                    position: topPosition.value,
                    amount: parseInt(topAmount.value, 10)
                });
                map.set(top, {
                    position: bottomPosition.value,
                    amount: -parseInt(bottomAmount.value, 10)
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return map;
    });
    var layers = (0, $hXmfK.computed)(function() {
        var uniquePriorities = (0, $7WNf6._)(new Set((0, $7WNf6._)(priorities.values()).map(function(p) {
            return p.value;
        }))).sort(function(a, b) {
            return a - b;
        });
        var layout = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var p = _step.value;
                var _layout;
                var items = registered.value.filter(function(id) {
                    var _priorities_get;
                    return ((_priorities_get = priorities.get(id)) === null || _priorities_get === void 0 ? void 0 : _priorities_get.value) === p;
                });
                (_layout = layout).push.apply(_layout, (0, $7WNf6._)(items));
            };
            for(var _iterator = uniquePriorities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $39e98ff3447d557e$var$generateLayers(layout, positions, layoutSizes, activeItems);
    });
    var transitionsEnabled = (0, $hXmfK.computed)(function() {
        return !Array.from(disabledTransitions.values()).some(function(ref) {
            return ref.value;
        });
    });
    var mainRect = (0, $hXmfK.computed)(function() {
        return layers.value[layers.value.length - 1].layer;
    });
    var mainStyles = (0, $hXmfK.toRef)(function() {
        return (0, $iT0je._)({
            '--v-layout-left': (0, $31779689cfd5da50$export$286ad215293a0860)(mainRect.value.left),
            '--v-layout-right': (0, $31779689cfd5da50$export$286ad215293a0860)(mainRect.value.right),
            '--v-layout-top': (0, $31779689cfd5da50$export$286ad215293a0860)(mainRect.value.top),
            '--v-layout-bottom': (0, $31779689cfd5da50$export$286ad215293a0860)(mainRect.value.bottom)
        }, transitionsEnabled.value ? undefined : {
            transition: 'none'
        });
    });
    var items = (0, $hXmfK.computed)(function() {
        return layers.value.slice(1).map(function(_ref, index) {
            var id = _ref.id;
            var layer = layers.value[index].layer;
            var size = layoutSizes.get(id);
            var position = positions.get(id);
            return (0, $emQHU._)((0, $iT0je._)({
                id: id
            }, layer), {
                size: Number(size.value),
                position: position.value
            });
        });
    });
    var getLayoutItem = function(id) {
        return items.value.find(function(item) {
            return item.id === id;
        });
    };
    var rootVm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('createLayout');
    var isMounted = (0, $hXmfK.shallowRef)(false);
    (0, $bu8yf.onMounted)(function() {
        isMounted.value = true;
    });
    (0, $bu8yf.provide)($39e98ff3447d557e$export$6c0af7fe4dd9b19b, {
        register: function(vm, _ref2) {
            var id = _ref2.id, order = _ref2.order, position = _ref2.position, layoutSize = _ref2.layoutSize, elementSize = _ref2.elementSize, active = _ref2.active, disableTransitions = _ref2.disableTransitions, absolute = _ref2.absolute;
            priorities.set(id, order);
            positions.set(id, position);
            layoutSizes.set(id, layoutSize);
            activeItems.set(id, active);
            disableTransitions && disabledTransitions.set(id, disableTransitions);
            var instances = (0, $31779689cfd5da50$export$424fe43b65f39668)($39e98ff3447d557e$export$e8f59a037946a8c0, rootVm === null || rootVm === void 0 ? void 0 : rootVm.vnode);
            var instanceIndex = instances.indexOf(vm);
            if (instanceIndex > -1) registered.value.splice(instanceIndex, 0, id);
            else registered.value.push(id);
            var index = (0, $hXmfK.computed)(function() {
                return items.value.findIndex(function(i) {
                    return i.id === id;
                });
            });
            var zIndex = (0, $hXmfK.computed)(function() {
                return rootZIndex.value + layers.value.length * 2 - index.value * 2;
            });
            var layoutItemStyles = (0, $hXmfK.computed)(function() {
                var isHorizontal = position.value === 'left' || position.value === 'right';
                var isOppositeHorizontal = position.value === 'right';
                var isOppositeVertical = position.value === 'bottom';
                var _elementSize_value;
                var size = (_elementSize_value = elementSize.value) !== null && _elementSize_value !== void 0 ? _elementSize_value : layoutSize.value;
                var unit = size === 0 ? '%' : 'px';
                var _obj;
                var styles = (0, $iT0je._)((_obj = {}, (0, $cqEAj._)(_obj, position.value, 0), (0, $cqEAj._)(_obj, "zIndex", zIndex.value), (0, $cqEAj._)(_obj, "transform", "translate".concat(isHorizontal ? 'X' : 'Y', "(").concat((active.value ? 0 : -(size === 0 ? 100 : size)) * (isOppositeHorizontal || isOppositeVertical ? -1 : 1)).concat(unit, ")")), (0, $cqEAj._)(_obj, "position", absolute.value || rootZIndex.value !== $39e98ff3447d557e$var$ROOT_ZINDEX ? 'absolute' : 'fixed'), _obj), transitionsEnabled.value ? undefined : {
                    transition: 'none'
                });
                if (!isMounted.value) return styles;
                var item = items.value[index.value];
                if (!item) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('[Vuetify] Could not find layout item "'.concat(id, '"'));
                var overlap = computedOverlaps.value.get(id);
                if (overlap) item[overlap.position] += overlap.amount;
                return (0, $emQHU._)((0, $iT0je._)({}, styles), {
                    height: isHorizontal ? "calc(100% - ".concat(item.top, "px - ").concat(item.bottom, "px)") : elementSize.value ? "".concat(elementSize.value, "px") : undefined,
                    left: isOppositeHorizontal ? undefined : "".concat(item.left, "px"),
                    right: isOppositeHorizontal ? "".concat(item.right, "px") : undefined,
                    top: position.value !== 'bottom' ? "".concat(item.top, "px") : undefined,
                    bottom: position.value !== 'top' ? "".concat(item.bottom, "px") : undefined,
                    width: !isHorizontal ? "calc(100% - ".concat(item.left, "px - ").concat(item.right, "px)") : elementSize.value ? "".concat(elementSize.value, "px") : undefined
                });
            });
            var layoutItemScrimStyles = (0, $hXmfK.computed)(function() {
                return {
                    zIndex: zIndex.value - 1
                };
            });
            return {
                layoutItemStyles: layoutItemStyles,
                layoutItemScrimStyles: layoutItemScrimStyles,
                zIndex: zIndex
            };
        },
        unregister: function(id) {
            priorities["delete"](id);
            positions["delete"](id);
            layoutSizes["delete"](id);
            activeItems["delete"](id);
            disabledTransitions["delete"](id);
            registered.value = registered.value.filter(function(v) {
                return v !== id;
            });
        },
        mainRect: mainRect,
        mainStyles: mainStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        rootZIndex: rootZIndex
    });
    var layoutClasses = (0, $hXmfK.toRef)(function() {
        return [
            'v-layout',
            {
                'v-layout--full-height': props.fullHeight
            }
        ];
    });
    var layoutStyles = (0, $hXmfK.toRef)(function() {
        return {
            zIndex: parentLayout ? rootZIndex.value : undefined,
            position: parentLayout ? 'relative' : undefined,
            overflow: parentLayout ? 'hidden' : undefined
        };
    });
    return {
        layoutClasses: layoutClasses,
        layoutStyles: layoutStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        layoutRef: resizeRef
    };
}




// Utilities

function $f6b888dae9ed8adc$export$e25bb1e5b53cbdff(render) {
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useRender');
    vm.render = render;
}


var $d35fa18c82598d8d$export$4d0e7713f668e677 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $39e98ff3447d557e$export$f0037fcffb4e2081)({
    fullHeight: true
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VApp');
var $d35fa18c82598d8d$export$60414d50d930f930 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VApp',
    props: $d35fa18c82598d8d$export$4d0e7713f668e677(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var theme = (0, $d8647489982f8a06$export$307b27329074e447)(props);
        var _createLayout = (0, $39e98ff3447d557e$export$3dd437ade36ede40)(props), layoutClasses = _createLayout.layoutClasses, getLayoutItem = _createLayout.getLayoutItem, items = _createLayout.items, layoutRef = _createLayout.layoutRef;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                ref: layoutRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-application',
                    theme.themeClasses.value,
                    layoutClasses.value,
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-application__wrap"
                }, [
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ])
            ]);
        });
        return {
            getLayoutItem: getLayoutItem,
            items: items,
            theme: theme
        };
    }
});




var $5633c39a49672970$exports = {};

$parcel$export($5633c39a49672970$exports, "VAppBar", function () { return $963ccfba89c549b5$export$2fbc8fb55736252a; });
$parcel$export($5633c39a49672970$exports, "VAppBarNavIcon", function () { return $23c0aeb902f05449$export$692fce24359c3843; });
$parcel$export($5633c39a49672970$exports, "VAppBarTitle", function () { return $2cc7bd3b55073ce8$export$657ba4c199549e9b; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

// Utilities

var $ff78e1b0ace7b26a$export$1e45edda911c93db = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        "default": 'div'
    }
}, 'tag');



var $f849e9bc71871807$export$6afad7cb17124872 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    text: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VToolbarTitle');
var $f849e9bc71871807$export$deaeca9428bfc9a4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VToolbarTitle',
    props: $f849e9bc71871807$export$6afad7cb17124872(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasText = !!(slots["default"] || slots.text || props.text);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-toolbar-title',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        hasText && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-toolbar-title__placeholder"
                        }, [
                            slots.text ? slots.text() : props.text,
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ])
                    ];
                }
            });
        });
        return {};
    }
});


var $01a421c271ad0485$exports = {};

$parcel$export($01a421c271ad0485$exports, "VFabTransition", function () { return $01a421c271ad0485$export$e41ac6a607c71844; });
$parcel$export($01a421c271ad0485$exports, "VDialogBottomTransition", function () { return $01a421c271ad0485$export$bc7471894fc4ecf0; });
$parcel$export($01a421c271ad0485$exports, "VDialogTopTransition", function () { return $01a421c271ad0485$export$32d110114067327f; });
$parcel$export($01a421c271ad0485$exports, "VFadeTransition", function () { return $01a421c271ad0485$export$13ce8c44634b158c; });
$parcel$export($01a421c271ad0485$exports, "VScaleTransition", function () { return $01a421c271ad0485$export$5d9397de61546474; });
$parcel$export($01a421c271ad0485$exports, "VScrollXTransition", function () { return $01a421c271ad0485$export$ec1a91eaaf33fc1a; });
$parcel$export($01a421c271ad0485$exports, "VScrollXReverseTransition", function () { return $01a421c271ad0485$export$1c31b47261d53f89; });
$parcel$export($01a421c271ad0485$exports, "VScrollYTransition", function () { return $01a421c271ad0485$export$727e6b700671cc9c; });
$parcel$export($01a421c271ad0485$exports, "VScrollYReverseTransition", function () { return $01a421c271ad0485$export$65ab0ce785466dae; });
$parcel$export($01a421c271ad0485$exports, "VSlideXTransition", function () { return $01a421c271ad0485$export$6997cd6ab1645575; });
$parcel$export($01a421c271ad0485$exports, "VSlideXReverseTransition", function () { return $01a421c271ad0485$export$cb28325bdb6e20c2; });
$parcel$export($01a421c271ad0485$exports, "VSlideYTransition", function () { return $01a421c271ad0485$export$5d9f875feb4d9ee6; });
$parcel$export($01a421c271ad0485$exports, "VSlideYReverseTransition", function () { return $01a421c271ad0485$export$f24f0bc0b4f2bbd2; });
$parcel$export($01a421c271ad0485$exports, "VExpandTransition", function () { return $01a421c271ad0485$export$1cd1e8deb97d798d; });
$parcel$export($01a421c271ad0485$exports, "VExpandXTransition", function () { return $01a421c271ad0485$export$d54edbcba7869f36; });
$parcel$export($01a421c271ad0485$exports, "VDialogTransition", function () { return $b2974c952e31c38b$export$9778a08df954f36c; });
// Utilities

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");

var $b7e654279c50d284$export$e5b7ff1a0fbdc00e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    group: Boolean,
    hideOnLeave: Boolean,
    leaveAbsolute: Boolean,
    mode: String,
    origin: String
}, 'transition');
function $b7e654279c50d284$export$a21bd7b30fd40589(name, origin, mode) {
    return (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
        name: name,
        props: $b7e654279c50d284$export$e5b7ff1a0fbdc00e({
            mode: mode,
            origin: origin
        }),
        setup: function(props, _ref) {
            var slots = _ref.slots;
            var functions = {
                onBeforeEnter: function(el) {
                    if (props.origin) el.style.transformOrigin = props.origin;
                },
                onLeave: function(el) {
                    if (props.leaveAbsolute) {
                        var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
                        el._transitionInitialStyles = {
                            position: el.style.position,
                            top: el.style.top,
                            left: el.style.left,
                            width: el.style.width,
                            height: el.style.height
                        };
                        el.style.position = 'absolute';
                        el.style.top = "".concat(offsetTop, "px");
                        el.style.left = "".concat(offsetLeft, "px");
                        el.style.width = "".concat(offsetWidth, "px");
                        el.style.height = "".concat(offsetHeight, "px");
                    }
                    if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                },
                onAfterLeave: function(el) {
                    if (props.leaveAbsolute && (el === null || el === void 0 ? void 0 : el._transitionInitialStyles)) {
                        var _el__transitionInitialStyles = el._transitionInitialStyles, position = _el__transitionInitialStyles.position, top = _el__transitionInitialStyles.top, left = _el__transitionInitialStyles.left, width = _el__transitionInitialStyles.width, height = _el__transitionInitialStyles.height;
                        delete el._transitionInitialStyles;
                        el.style.position = position || '';
                        el.style.top = top || '';
                        el.style.left = left || '';
                        el.style.width = width || '';
                        el.style.height = height || '';
                    }
                }
            };
            return function() {
                var tag = props.group ? (0, $kiZwI.TransitionGroup) : (0, $kiZwI.Transition);
                return (0, $bu8yf.h)(tag, (0, $iT0je._)({
                    name: props.disabled ? '' : name,
                    css: !props.disabled
                }, props.group ? undefined : {
                    mode: props.mode
                }, props.disabled ? {} : functions), slots["default"]);
            };
        }
    });
}
function $b7e654279c50d284$export$1b9d9cdc486aa921(name, functions) {
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
    return (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
        name: name,
        props: {
            mode: {
                type: String,
                "default": mode
            },
            disabled: Boolean,
            group: Boolean
        },
        setup: function(props, _ref2) {
            var slots = _ref2.slots;
            var tag = props.group ? (0, $kiZwI.TransitionGroup) : (0, $kiZwI.Transition);
            return function() {
                return (0, $bu8yf.h)(tag, (0, $iT0je._)({
                    name: props.disabled ? '' : name,
                    css: !props.disabled
                }, props.disabled ? {} : functions), slots["default"]);
            };
        }
    });
}


// Utilities

var $cqEAj = parcelRequire("cqEAj");
parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
function $63aca316fc409972$export$2e2bcd8739ae039() {
    var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var sizeProperty = x ? 'width' : 'height';
    var offsetProperty = (0, $d8jBh.camelize)("offset-".concat(sizeProperty));
    return {
        onBeforeEnter: function(el) {
            el._parent = el.parentNode;
            el._initialStyle = (0, $cqEAj._)({
                transition: el.style.transition,
                overflow: el.style.overflow
            }, sizeProperty, el.style[sizeProperty]);
        },
        onEnter: function(el) {
            var initialStyle = el._initialStyle;
            if (!initialStyle) return;
            el.style.setProperty('transition', 'none', 'important');
            // Hide overflow to account for collapsed margins in the calculated height
            el.style.overflow = 'hidden';
            var offset = "".concat(el[offsetProperty], "px");
            el.style[sizeProperty] = '0';
            el.offsetHeight; // force reflow
            el.style.transition = initialStyle.transition;
            if (expandedParentClass && el._parent) el._parent.classList.add(expandedParentClass);
            requestAnimationFrame(function() {
                el.style[sizeProperty] = offset;
            });
        },
        onAfterEnter: resetStyles,
        onEnterCancelled: resetStyles,
        onLeave: function(el) {
            el._initialStyle = (0, $cqEAj._)({
                transition: '',
                overflow: el.style.overflow
            }, sizeProperty, el.style[sizeProperty]);
            el.style.overflow = 'hidden';
            el.style[sizeProperty] = "".concat(el[offsetProperty], "px");
            el.offsetHeight; // force reflow
            requestAnimationFrame(function() {
                return el.style[sizeProperty] = '0';
            });
        },
        onAfterLeave: onAfterLeave,
        onLeaveCancelled: onAfterLeave
    };
    function onAfterLeave(el) {
        if (expandedParentClass && el._parent) el._parent.classList.remove(expandedParentClass);
        resetStyles(el);
    }
    function resetStyles(el) {
        if (!el._initialStyle) return;
        var size = el._initialStyle[sizeProperty];
        el.style.overflow = el._initialStyle.overflow;
        if (size != null) el.style[sizeProperty] = size;
        delete el._initialStyle;
    }
}


// Utilities

var $b8tVf = parcelRequire("b8tVf");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");
var $7c499b58bf668c0e$export$bf86e2ccec972a06 = 'cubic-bezier(0.4, 0, 0.2, 1)';
var $7c499b58bf668c0e$export$749971f7490e97da = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Entering
var $7c499b58bf668c0e$export$7b997795cd9fbbcb = 'cubic-bezier(0.4, 0, 1, 1)'; // Leaving

// Utilities

var $jGAMp = parcelRequire("jGAMp");

var $byiyg = parcelRequire("byiyg");
var $a9f6a424a63666a1$export$e71c4d32a2263218 = /*#__PURE__*/ function() {
    "use strict";
    function Box(_ref) {
        (0, $jGAMp._)(this, Box);
        var x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    (0, $byiyg._)(Box, [
        {
            key: "top",
            get: function get() {
                return this.y;
            }
        },
        {
            key: "bottom",
            get: function get() {
                return this.y + this.height;
            }
        },
        {
            key: "left",
            get: function get() {
                return this.x;
            }
        },
        {
            key: "right",
            get: function get() {
                return this.x + this.width;
            }
        }
    ]);
    return Box;
}();
function $a9f6a424a63666a1$export$f63a1e5ecde5e3c4(a, b) {
    return {
        x: {
            before: Math.max(0, b.left - a.left),
            after: Math.max(0, a.right - b.right)
        },
        y: {
            before: Math.max(0, b.top - a.top),
            after: Math.max(0, a.bottom - b.bottom)
        }
    };
}
function $a9f6a424a63666a1$export$abd662d1b0b39d49(target) {
    if (Array.isArray(target)) return new $a9f6a424a63666a1$export$e71c4d32a2263218({
        x: target[0],
        y: target[1],
        width: 0,
        height: 0
    });
    else return target.getBoundingClientRect();
}
function $a9f6a424a63666a1$export$6f532722e5bcfbac(el) {
    if (el === document.documentElement) {
        if (!visualViewport) return new $a9f6a424a63666a1$export$e71c4d32a2263218({
            x: 0,
            y: 0,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        });
        else return new $a9f6a424a63666a1$export$e71c4d32a2263218({
            x: visualViewport.scale > 1 ? 0 : visualViewport.offsetLeft,
            y: visualViewport.scale > 1 ? 0 : visualViewport.offsetTop,
            width: visualViewport.width * visualViewport.scale,
            height: visualViewport.height * visualViewport.scale
        });
    } else {
        var rect = el.getBoundingClientRect();
        return new $a9f6a424a63666a1$export$e71c4d32a2263218({
            x: rect.x,
            y: rect.y,
            width: el.clientWidth,
            height: el.clientHeight
        });
    }
}


function $4256e79b4dc20ac3$export$38c5b68336448fc8(el) {
    var rect = el.getBoundingClientRect();
    var style = getComputedStyle(el);
    var tx = style.transform;
    if (tx) {
        var ta, sx, sy, dx, dy;
        if (tx.startsWith('matrix3d(')) {
            ta = tx.slice(9, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[5]);
            dx = Number(ta[12]);
            dy = Number(ta[13]);
        } else if (tx.startsWith('matrix(')) {
            ta = tx.slice(7, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[3]);
            dx = Number(ta[4]);
            dy = Number(ta[5]);
        } else return new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)(rect);
        var to = style.transformOrigin;
        var x = rect.x - dx - (1 - sx) * parseFloat(to);
        var y = rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(' ') + 1));
        var w = sx ? rect.width / sx : el.offsetWidth + 1;
        var h = sy ? rect.height / sy : el.offsetHeight + 1;
        return new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)({
            x: x,
            y: y,
            width: w,
            height: h
        });
    } else return new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)(rect);
}
function $4256e79b4dc20ac3$export$e3607ec2d7a891c4(el, keyframes, options) {
    if (typeof el.animate === 'undefined') return {
        finished: Promise.resolve()
    };
    var animation;
    try {
        animation = el.animate(keyframes, options);
    } catch (err) {
        return {
            finished: Promise.resolve()
        };
    }
    if (typeof animation.finished === 'undefined') animation.finished = new Promise(function(resolve) {
        animation.onfinish = function() {
            resolve(animation);
        };
    });
    return animation;
}



var $b2974c952e31c38b$export$4284bdd72239dfb4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    target: [
        Object,
        Array
    ]
}, 'v-dialog-transition');
var $b2974c952e31c38b$var$saved = new WeakMap();
var $b2974c952e31c38b$export$9778a08df954f36c = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDialogTransition',
    props: $b2974c952e31c38b$export$4284bdd72239dfb4(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var functions = {
            onBeforeEnter: function(el) {
                el.style.pointerEvents = 'none';
                el.style.visibility = 'hidden';
            },
            onEnter: function(el, done) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _getChildren, dimensions, x, y, sx, sy, speed, animation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return requestAnimationFrame(resolve);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return requestAnimationFrame(resolve);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                el.style.visibility = '';
                                dimensions = $b2974c952e31c38b$var$getDimensions(props.target, el);
                                x = dimensions.x, y = dimensions.y, sx = dimensions.sx, sy = dimensions.sy, speed = dimensions.speed;
                                $b2974c952e31c38b$var$saved.set(el, dimensions);
                                animation = (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(el, [
                                    {
                                        transform: "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(sx, ", ").concat(sy, ")"),
                                        opacity: 0
                                    },
                                    {}
                                ], {
                                    duration: 225 * speed,
                                    easing: (0, $7c499b58bf668c0e$export$749971f7490e97da)
                                });
                                (_getChildren = $b2974c952e31c38b$var$getChildren(el)) === null || _getChildren === void 0 ? void 0 : _getChildren.forEach(function(el) {
                                    (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(el, [
                                        {
                                            opacity: 0
                                        },
                                        {
                                            opacity: 0,
                                            offset: 0.33
                                        },
                                        {}
                                    ], {
                                        duration: 225 * 2 * speed,
                                        easing: (0, $7c499b58bf668c0e$export$bf86e2ccec972a06)
                                    });
                                });
                                animation.finished.then(function() {
                                    return done();
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAfterEnter: function(el) {
                el.style.removeProperty('pointer-events');
            },
            onBeforeLeave: function(el) {
                el.style.pointerEvents = 'none';
            },
            onLeave: function(el, done) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _getChildren, dimensions, x, y, sx, sy, speed, animation;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return requestAnimationFrame(resolve);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                if (!$b2974c952e31c38b$var$saved.has(el) || Array.isArray(props.target) || props.target.offsetParent || props.target.getClientRects().length) dimensions = $b2974c952e31c38b$var$getDimensions(props.target, el);
                                else dimensions = $b2974c952e31c38b$var$saved.get(el);
                                x = dimensions.x, y = dimensions.y, sx = dimensions.sx, sy = dimensions.sy, speed = dimensions.speed;
                                animation = (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(el, [
                                    {},
                                    {
                                        transform: "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(sx, ", ").concat(sy, ")"),
                                        opacity: 0
                                    }
                                ], {
                                    duration: 125 * speed,
                                    easing: (0, $7c499b58bf668c0e$export$7b997795cd9fbbcb)
                                });
                                animation.finished.then(function() {
                                    return done();
                                });
                                (_getChildren = $b2974c952e31c38b$var$getChildren(el)) === null || _getChildren === void 0 ? void 0 : _getChildren.forEach(function(el) {
                                    (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(el, [
                                        {},
                                        {
                                            opacity: 0,
                                            offset: 0.2
                                        },
                                        {
                                            opacity: 0
                                        }
                                    ], {
                                        duration: 125 * 2 * speed,
                                        easing: (0, $7c499b58bf668c0e$export$bf86e2ccec972a06)
                                    });
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAfterLeave: function(el) {
                el.style.removeProperty('pointer-events');
            }
        };
        return function() {
            return props.target ? (0, $bu8yf.createVNode)((0, $kiZwI.Transition), (0, $bu8yf.mergeProps)({
                name: "dialog-transition"
            }, functions, {
                css: false
            }), slots) : (0, $bu8yf.createVNode)((0, $kiZwI.Transition), {
                name: "dialog-transition"
            }, slots);
        };
    }
});
/** Animatable children (card, sheet, list) */ function $b2974c952e31c38b$var$getChildren(el) {
    var _el_querySelector;
    var els = (_el_querySelector = el.querySelector(':scope > .v-card, :scope > .v-sheet, :scope > .v-list')) === null || _el_querySelector === void 0 ? void 0 : _el_querySelector.children;
    return els && (0, $7WNf6._)(els);
}
function $b2974c952e31c38b$var$getDimensions(target, el) {
    var targetBox = (0, $a9f6a424a63666a1$export$abd662d1b0b39d49)(target);
    var elBox = (0, $4256e79b4dc20ac3$export$38c5b68336448fc8)(el);
    var _getComputedStyle_transformOrigin_split_map = (0, $32TW8._)(getComputedStyle(el).transformOrigin.split(' ').map(function(v) {
        return parseFloat(v);
    }), 2), originX = _getComputedStyle_transformOrigin_split_map[0], originY = _getComputedStyle_transformOrigin_split_map[1];
    var _getComputedStyle_getPropertyValue_split = (0, $32TW8._)(getComputedStyle(el).getPropertyValue('--v-overlay-anchor-origin').split(' '), 2), anchorSide = _getComputedStyle_getPropertyValue_split[0], anchorOffset = _getComputedStyle_getPropertyValue_split[1];
    var offsetX = targetBox.left + targetBox.width / 2;
    if (anchorSide === 'left' || anchorOffset === 'left') offsetX -= targetBox.width / 2;
    else if (anchorSide === 'right' || anchorOffset === 'right') offsetX += targetBox.width / 2;
    var offsetY = targetBox.top + targetBox.height / 2;
    if (anchorSide === 'top' || anchorOffset === 'top') offsetY -= targetBox.height / 2;
    else if (anchorSide === 'bottom' || anchorOffset === 'bottom') offsetY += targetBox.height / 2;
    var tsx = targetBox.width / elBox.width;
    var tsy = targetBox.height / elBox.height;
    var maxs = Math.max(1, tsx, tsy);
    var sx = tsx / maxs || 0;
    var sy = tsy / maxs || 0;
    // Animate elements larger than 12% of the screen area up to 1.5x slower
    var asa = elBox.width * elBox.height / (window.innerWidth * window.innerHeight);
    var speed = asa > 0.12 ? Math.min(1.5, (asa - 0.12) * 10 + 1) : 1;
    return {
        x: offsetX - (originX + elBox.left),
        y: offsetY - (originY + elBox.top),
        sx: sx,
        sy: sy,
        speed: speed
    };
}


var $01a421c271ad0485$export$e41ac6a607c71844 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('fab-transition', 'center center', 'out-in');
var $01a421c271ad0485$export$bc7471894fc4ecf0 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('dialog-bottom-transition');
var $01a421c271ad0485$export$32d110114067327f = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('dialog-top-transition');
var $01a421c271ad0485$export$13ce8c44634b158c = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('fade-transition');
var $01a421c271ad0485$export$5d9397de61546474 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('scale-transition');
var $01a421c271ad0485$export$ec1a91eaaf33fc1a = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('scroll-x-transition');
var $01a421c271ad0485$export$1c31b47261d53f89 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('scroll-x-reverse-transition');
var $01a421c271ad0485$export$727e6b700671cc9c = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('scroll-y-transition');
var $01a421c271ad0485$export$65ab0ce785466dae = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('scroll-y-reverse-transition');
var $01a421c271ad0485$export$6997cd6ab1645575 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('slide-x-transition');
var $01a421c271ad0485$export$cb28325bdb6e20c2 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('slide-x-reverse-transition');
var $01a421c271ad0485$export$5d9f875feb4d9ee6 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('slide-y-transition');
var $01a421c271ad0485$export$f24f0bc0b4f2bbd2 = (0, $b7e654279c50d284$export$a21bd7b30fd40589)('slide-y-reverse-transition');
var $01a421c271ad0485$export$1cd1e8deb97d798d = (0, $b7e654279c50d284$export$1b9d9cdc486aa921)('expand-transition', (0, $63aca316fc409972$export$2e2bcd8739ae039)());
var $01a421c271ad0485$export$d54edbcba7869f36 = (0, $b7e654279c50d284$export$1b9d9cdc486aa921)('expand-x-transition', (0, $63aca316fc409972$export$2e2bcd8739ae039)('', true));


// Composables

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $35431446b86815ea$export$deb03e83a53b330e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    defaults: Object,
    disabled: Boolean,
    reset: [
        Number,
        String
    ],
    root: [
        Boolean,
        String
    ],
    scoped: Boolean
}, 'VDefaultsProvider');
var $35431446b86815ea$export$ee4fab30a254e5ee = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)(false)({
    name: 'VDefaultsProvider',
    props: $35431446b86815ea$export$deb03e83a53b330e(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _toRefs = (0, $hXmfK.toRefs)(props), defaults = _toRefs.defaults, disabled = _toRefs.disabled, reset = _toRefs.reset, root = _toRefs.root, scoped = _toRefs.scoped;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)(defaults, {
            reset: reset,
            root: root,
            scoped: scoped,
            disabled: disabled
        });
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
        };
    }
});



var $iT0je = parcelRequire("iT0je");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $ff2612ddfc292b98$export$f37f46640cc8dd75 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    height: [
        Number,
        String
    ],
    maxHeight: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    minHeight: [
        Number,
        String
    ],
    minWidth: [
        Number,
        String
    ],
    width: [
        Number,
        String
    ]
}, 'dimension');
function $ff2612ddfc292b98$export$2b21de4fc4968be5(props) {
    var dimensionStyles = (0, $hXmfK.computed)(function() {
        var styles = {};
        var height = (0, $31779689cfd5da50$export$286ad215293a0860)(props.height);
        var maxHeight = (0, $31779689cfd5da50$export$286ad215293a0860)(props.maxHeight);
        var maxWidth = (0, $31779689cfd5da50$export$286ad215293a0860)(props.maxWidth);
        var minHeight = (0, $31779689cfd5da50$export$286ad215293a0860)(props.minHeight);
        var minWidth = (0, $31779689cfd5da50$export$286ad215293a0860)(props.minWidth);
        var width = (0, $31779689cfd5da50$export$286ad215293a0860)(props.width);
        if (height != null) styles.height = height;
        if (maxHeight != null) styles.maxHeight = maxHeight;
        if (maxWidth != null) styles.maxWidth = maxWidth;
        if (minHeight != null) styles.minHeight = minHeight;
        if (minWidth != null) styles.minWidth = minWidth;
        if (width != null) styles.width = width;
        return styles;
    });
    return {
        dimensionStyles: dimensionStyles
    };
}



function $67b06dceb60f0bed$export$745903863ef9867b(props) {
    return {
        aspectStyles: (0, $hXmfK.computed)(function() {
            var ratio = Number(props.aspectRatio);
            return ratio ? {
                paddingBottom: String(1 / ratio * 100) + '%'
            } : undefined;
        })
    };
}
var $67b06dceb60f0bed$export$7e0413dfe71e96cc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    aspectRatio: [
        String,
        Number
    ],
    contentClass: null,
    inline: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)()), 'VResponsive');
var $67b06dceb60f0bed$export$fede2db8a3499569 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VResponsive',
    props: $67b06dceb60f0bed$export$7e0413dfe71e96cc(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var aspectStyles = $67b06dceb60f0bed$export$745903863ef9867b(props).aspectStyles;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_additional;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-responsive',
                    {
                        'v-responsive--inline': props.inline
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-responsive__sizer",
                    style: (0, $d8jBh.normalizeStyle)(aspectStyles.value)
                }, null),
                (_slots_additional = slots.additional) === null || _slots_additional === void 0 ? void 0 : _slots_additional.call(slots),
                slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-responsive__content',
                        props.contentClass
                    ])
                }, [
                    slots["default"]()
                ])
            ]);
        });
        return {};
    }
});


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

function $1f80711f67f81e35$export$5aadd9c0606af5c2(colors) {
    return (0, $31779689cfd5da50$export$fe6a5b56d01db4f5)(function() {
        var _colors = (0, $hXmfK.toValue)(colors);
        var classes = [];
        var styles = {};
        if (_colors.background) {
            if ((0, $7eae58fcc02fc7e9$export$773f39ab8b9369ea)(_colors.background)) {
                styles.backgroundColor = _colors.background;
                if (!_colors.text && (0, $7eae58fcc02fc7e9$export$d546aa95bdefc037)(_colors.background)) {
                    var backgroundColor = (0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(_colors.background);
                    if (backgroundColor.a == null || backgroundColor.a === 1) {
                        var textColor = (0, $7eae58fcc02fc7e9$export$27d3ce2b326d356d)(backgroundColor);
                        styles.color = textColor;
                        styles.caretColor = textColor;
                    }
                }
            } else classes.push("bg-".concat(_colors.background));
        }
        if (_colors.text) {
            if ((0, $7eae58fcc02fc7e9$export$773f39ab8b9369ea)(_colors.text)) {
                styles.color = _colors.text;
                styles.caretColor = _colors.text;
            } else classes.push("text-".concat(_colors.text));
        }
        return {
            colorClasses: classes,
            colorStyles: styles
        };
    });
}
function $1f80711f67f81e35$export$2eb7f8f6c72160ec(color) {
    var _useColor = $1f80711f67f81e35$export$5aadd9c0606af5c2(function() {
        return {
            text: (0, $hXmfK.toValue)(color)
        };
    }), textColorClasses = _useColor.colorClasses, textColorStyles = _useColor.colorStyles;
    return {
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles
    };
}
function $1f80711f67f81e35$export$de4733d8105ed3f2(color) {
    var _useColor = $1f80711f67f81e35$export$5aadd9c0606af5c2(function() {
        return {
            background: (0, $hXmfK.toValue)(color)
        };
    }), backgroundColorClasses = _useColor.colorClasses, backgroundColorStyles = _useColor.colorStyles;
    return {
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles
    };
}



// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $96532e4c9abc507c$export$7bbc36c81a352d50 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    rounded: {
        type: [
            Boolean,
            Number,
            String
        ],
        "default": undefined
    },
    tile: Boolean
}, 'rounded');
function $96532e4c9abc507c$export$36c3a2ea94409e5e(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var roundedClasses = (0, $hXmfK.computed)(function() {
        var rounded = (0, $hXmfK.isRef)(props) ? props.value : props.rounded;
        var tile = (0, $hXmfK.isRef)(props) ? props.value : props.tile;
        var classes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (rounded === true || rounded === '') classes.push("".concat(name, "--rounded"));
        else if (typeof rounded === 'string' || rounded === 0) try {
            for(var _iterator = String(rounded).split(' ')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                classes.push("rounded-".concat(value));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else if (tile || rounded === false) classes.push('rounded-0');
        return classes;
    });
    return {
        roundedClasses: roundedClasses
    };
}


// Utilities

var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");

var $7a70676d07761412$export$e5b7ff1a0fbdc00e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    transition: {
        type: null,
        "default": 'fade-transition',
        validator: function(val) {
            return val !== true;
        }
    }
}, 'transition');
var $7a70676d07761412$export$dee7d6ab6955c95e = function(props, _ref) {
    var slots = _ref.slots;
    var transition = props.transition, disabled = props.disabled, group = props.group, rest = (0, $g79Gh._)(props, [
        "transition",
        "disabled",
        "group"
    ]);
    var _$_ref = (0, $31779689cfd5da50$export$a6cdc56e425d0d0a)(transition) ? transition : {}, _ref_component = _$_ref.component, component = _ref_component === void 0 ? group ? (0, $kiZwI.TransitionGroup) : (0, $kiZwI.Transition) : _ref_component, customProps = (0, $g79Gh._)(_$_ref, [
        "component"
    ]);
    var transitionProps;
    if ((0, $31779689cfd5da50$export$a6cdc56e425d0d0a)(transition)) transitionProps = (0, $bu8yf.mergeProps)(customProps, (0, $31779689cfd5da50$export$bdca1cff95cf548c)({
        disabled: disabled,
        group: group
    }), rest);
    else transitionProps = (0, $bu8yf.mergeProps)({
        name: disabled || !transition ? '' : transition
    }, rest);
    return (0, $bu8yf.h)(component, transitionProps, slots);
};


// Utilities

var $3KZcf = parcelRequire("3KZcf");

function $f77d117b08c9abf5$var$mounted(el, binding) {
    if (!(0, $10db88b646d64b14$export$8cb82f5817a92ac4)) return;
    var modifiers = binding.modifiers || {};
    var value = binding.value;
    var _ref = (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' ? value : {
        handler: value,
        options: {}
    }, handler = _ref.handler, options = _ref.options;
    var observer = new IntersectionObserver(function() {
        var _el__observe;
        var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var observer = arguments.length > 1 ? arguments[1] : undefined;
        var _observe = (_el__observe = el._observe) === null || _el__observe === void 0 ? void 0 : _el__observe[binding.instance.$.uid];
        if (!_observe) return; // Just in case, should never fire
        var isIntersecting = entries.some(function(entry) {
            return entry.isIntersecting;
        });
        // If is not quiet or has already been
        // initted, invoke the user callback
        if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) handler(isIntersecting, entries, observer);
        if (isIntersecting && modifiers.once) $f77d117b08c9abf5$var$unmounted(el, binding);
        else _observe.init = true;
    }, options);
    el._observe = Object(el._observe);
    el._observe[binding.instance.$.uid] = {
        init: false,
        observer: observer
    };
    observer.observe(el);
}
function $f77d117b08c9abf5$var$unmounted(el, binding) {
    var _el__observe;
    var observe = (_el__observe = el._observe) === null || _el__observe === void 0 ? void 0 : _el__observe[binding.instance.$.uid];
    if (!observe) return;
    observe.observer.unobserve(el);
    delete el._observe[binding.instance.$.uid];
}
var $f77d117b08c9abf5$export$56a6b724e0c8deeb = {
    mounted: $f77d117b08c9abf5$var$mounted,
    unmounted: $f77d117b08c9abf5$var$unmounted
};
var $f77d117b08c9abf5$export$2e2bcd8739ae039 = $f77d117b08c9abf5$export$56a6b724e0c8deeb;



var $3fbd965354b26cae$export$aeeda8cb473ca4b4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    absolute: Boolean,
    alt: String,
    cover: Boolean,
    color: String,
    draggable: {
        type: [
            Boolean,
            String
        ],
        "default": undefined
    },
    eager: Boolean,
    gradient: String,
    lazySrc: String,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        "default": function() {
            return {
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            };
        }
    },
    sizes: String,
    src: {
        type: [
            String,
            Object
        ],
        "default": ''
    },
    crossorigin: String,
    referrerpolicy: String,
    srcset: String,
    position: String
}, (0, $67b06dceb60f0bed$export$7e0413dfe71e96cc)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)()), 'VImg');
var $3fbd965354b26cae$export$126ec614c536f27c = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VImg',
    directives: {
        vIntersect: (0, $f77d117b08c9abf5$export$2e2bcd8739ae039)
    },
    props: $3fbd965354b26cae$export$aeeda8cb473ca4b4(),
    emits: {
        loadstart: function(value) {
            return true;
        },
        load: function(value) {
            return true;
        },
        error: function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('VImg');
        var currentSrc = (0, $hXmfK.shallowRef)(''); // Set from srcset
        var image = (0, $hXmfK.ref)();
        var state = (0, $hXmfK.shallowRef)(props.eager ? 'loading' : 'idle');
        var naturalWidth = (0, $hXmfK.shallowRef)();
        var naturalHeight = (0, $hXmfK.shallowRef)();
        var normalisedSrc = (0, $hXmfK.computed)(function() {
            return props.src && (0, $3KZcf._)(props.src) === 'object' ? {
                src: props.src.src,
                srcset: props.srcset || props.src.srcset,
                lazySrc: props.lazySrc || props.src.lazySrc,
                aspect: Number(props.aspectRatio || props.src.aspect || 0)
            } : {
                src: props.src,
                srcset: props.srcset,
                lazySrc: props.lazySrc,
                aspect: Number(props.aspectRatio || 0)
            };
        });
        var aspectRatio = (0, $hXmfK.computed)(function() {
            return normalisedSrc.value.aspect || naturalWidth.value / naturalHeight.value || 0;
        });
        (0, $hXmfK.watch)(function() {
            return props.src;
        }, function() {
            init(state.value !== 'idle');
        });
        (0, $hXmfK.watch)(aspectRatio, function(val, oldVal) {
            if (!val && oldVal && image.value) pollForSize(image.value);
        });
        // TODO: getSrc when window width changes
        (0, $bu8yf.onBeforeMount)(function() {
            return init();
        });
        function init(isIntersecting) {
            if (props.eager && isIntersecting) return;
            if ((0, $10db88b646d64b14$export$8cb82f5817a92ac4) && !isIntersecting && !props.eager) return;
            state.value = 'loading';
            if (normalisedSrc.value.lazySrc) {
                var lazyImg = new Image();
                lazyImg.src = normalisedSrc.value.lazySrc;
                pollForSize(lazyImg, null);
            }
            if (!normalisedSrc.value.src) return;
            (0, $bu8yf.nextTick)(function() {
                var _image_value;
                emit('loadstart', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
                setTimeout(function() {
                    var _image_value;
                    if (vm.isUnmounted) return;
                    if ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.complete) {
                        if (!image.value.naturalWidth) onError();
                        if (state.value === 'error') return;
                        if (!aspectRatio.value) pollForSize(image.value, null);
                        if (state.value === 'loading') onLoad();
                    } else {
                        if (!aspectRatio.value) pollForSize(image.value);
                        getSrc();
                    }
                });
            });
        }
        function onLoad() {
            var _image_value;
            if (vm.isUnmounted) return;
            getSrc();
            pollForSize(image.value);
            state.value = 'loaded';
            emit('load', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
        }
        function onError() {
            var _image_value;
            if (vm.isUnmounted) return;
            state.value = 'error';
            emit('error', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
        }
        function getSrc() {
            var img = image.value;
            if (img) currentSrc.value = img.currentSrc || img.src;
        }
        var timer = -1;
        (0, $bu8yf.onBeforeUnmount)(function() {
            clearTimeout(timer);
        });
        function pollForSize(img) {
            var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
            var poll = function() {
                clearTimeout(timer);
                if (vm.isUnmounted) return;
                var imgHeight = img.naturalHeight, imgWidth = img.naturalWidth;
                if (imgHeight || imgWidth) {
                    naturalWidth.value = imgWidth;
                    naturalHeight.value = imgHeight;
                } else if (!img.complete && state.value === 'loading' && timeout != null) timer = window.setTimeout(poll, timeout);
                else if (img.currentSrc.endsWith('.svg') || img.currentSrc.startsWith('data:image/svg+xml')) {
                    naturalWidth.value = 1;
                    naturalHeight.value = 1;
                }
            };
            poll();
        }
        var containClasses = (0, $hXmfK.toRef)(function() {
            return {
                'v-img__img--cover': props.cover,
                'v-img__img--contain': !props.cover
            };
        });
        var __image = function() {
            var _slots_sources;
            if (!normalisedSrc.value.src || state.value === 'idle') return null;
            var img = (0, $bu8yf.createElementVNode)("img", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-img__img',
                    containClasses.value
                ]),
                style: {
                    objectPosition: props.position
                },
                crossorigin: props.crossorigin,
                src: normalisedSrc.value.src,
                srcset: normalisedSrc.value.srcset,
                alt: props.alt,
                referrerpolicy: props.referrerpolicy,
                draggable: props.draggable,
                sizes: props.sizes,
                ref: image,
                onLoad: onLoad,
                onError: onError
            }, null);
            var sources = (_slots_sources = slots.sources) === null || _slots_sources === void 0 ? void 0 : _slots_sources.call(slots);
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition,
                appear: true
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.withDirectives)(sources ? (0, $bu8yf.createElementVNode)("picture", {
                            "class": "v-img__picture"
                        }, [
                            sources,
                            img
                        ]) : img, [
                            [
                                (0, $kiZwI.vShow),
                                state.value === 'loaded'
                            ]
                        ])
                    ];
                }
            });
        };
        var __preloadImage = function() {
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition
            }, {
                "default": function() {
                    return [
                        normalisedSrc.value.lazySrc && state.value !== 'loaded' && (0, $bu8yf.createElementVNode)("img", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-img__img',
                                'v-img__img--preload',
                                containClasses.value
                            ]),
                            style: {
                                objectPosition: props.position
                            },
                            crossorigin: props.crossorigin,
                            src: normalisedSrc.value.lazySrc,
                            alt: props.alt,
                            referrerpolicy: props.referrerpolicy,
                            draggable: props.draggable
                        }, null)
                    ];
                }
            });
        };
        var __placeholder = function() {
            if (!slots.placeholder) return null;
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition,
                appear: true
            }, {
                "default": function() {
                    return [
                        (state.value === 'loading' || state.value === 'error' && !slots.error) && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-img__placeholder"
                        }, [
                            slots.placeholder()
                        ])
                    ];
                }
            });
        };
        var __error = function() {
            if (!slots.error) return null;
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition,
                appear: true
            }, {
                "default": function() {
                    return [
                        state.value === 'error' && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-img__error"
                        }, [
                            slots.error()
                        ])
                    ];
                }
            });
        };
        var __gradient = function() {
            if (!props.gradient) return null;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-img__gradient",
                style: {
                    backgroundImage: "linear-gradient(".concat(props.gradient, ")")
                }
            }, null);
        };
        var isBooted = (0, $hXmfK.shallowRef)(false);
        {
            var stop = (0, $hXmfK.watch)(aspectRatio, function(val) {
                if (val) {
                    // Doesn't work with nextTick, idk why
                    requestAnimationFrame(function() {
                        requestAnimationFrame(function() {
                            isBooted.value = true;
                        });
                    });
                    stop();
                }
            });
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var responsiveProps = (0, $67b06dceb60f0bed$export$fede2db8a3499569).filterProps(props);
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)((0, $67b06dceb60f0bed$export$fede2db8a3499569), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-img',
                    {
                        'v-img--absolute': props.absolute,
                        'v-img--booting': !isBooted.value
                    },
                    backgroundColorClasses.value,
                    roundedClasses.value,
                    props["class"]
                ],
                style: [
                    {
                        width: (0, $31779689cfd5da50$export$286ad215293a0860)(props.width === 'auto' ? naturalWidth.value : props.width)
                    },
                    backgroundColorStyles.value,
                    props.style
                ]
            }, responsiveProps, {
                aspectRatio: aspectRatio.value,
                "aria-label": props.alt,
                role: props.alt ? 'img' : undefined
            }), {
                additional: function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)(__image, null, null),
                        (0, $bu8yf.createVNode)(__preloadImage, null, null),
                        (0, $bu8yf.createVNode)(__gradient, null, null),
                        (0, $bu8yf.createVNode)(__placeholder, null, null),
                        (0, $bu8yf.createVNode)(__error, null, null)
                    ]);
                },
                "default": slots["default"]
            }), [
                [
                    (0, $f77d117b08c9abf5$export$2e2bcd8739ae039),
                    {
                        handler: init,
                        options: props.options
                    },
                    null,
                    {
                        once: true
                    }
                ]
            ]);
        });
        return {
            currentSrc: currentSrc,
            image: image,
            state: state,
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight
        };
    }
});


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $e0e369362aaf75e2$export$70b8b174e7d601ce = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    border: [
        Boolean,
        Number,
        String
    ]
}, 'border');
function $e0e369362aaf75e2$export$6185a16c7b2926fb(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var borderClasses = (0, $hXmfK.computed)(function() {
        var border = props.border;
        if (border === true || border === '') return "".concat(name, "--border");
        else if (typeof border === 'string' || border === 0) return String(border).split(' ').map(function(v) {
            return "border-".concat(v);
        });
        return [];
    });
    return {
        borderClasses: borderClasses
    };
}





// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $753fdc0f0b894251$export$858059d20a48304b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    elevation: {
        type: [
            Number,
            String
        ],
        validator: function(v) {
            var value = parseInt(v);
            return !isNaN(value) && value >= 0 && // Material Design has a maximum elevation of 24
            // https://material.io/design/environment/elevation.html#default-elevations
            value <= 24;
        }
    }
}, 'elevation');
function $753fdc0f0b894251$export$617be03f9f20f78c(props) {
    var elevationClasses = (0, $hXmfK.toRef)(function() {
        var elevation = (0, $hXmfK.isRef)(props) ? props.value : props.elevation;
        if (elevation == null) return [];
        return [
            "elevation-".concat(elevation)
        ];
    });
    return {
        elevationClasses: elevationClasses
    };
}







var $43b5cfb0203dfbd6$var$allowedDensities = [
    null,
    'prominent',
    'default',
    'comfortable',
    'compact'
];
var $43b5cfb0203dfbd6$export$bdd0e6e03d2a507e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    absolute: Boolean,
    collapse: Boolean,
    color: String,
    density: {
        type: String,
        "default": 'default',
        validator: function(v) {
            return $43b5cfb0203dfbd6$var$allowedDensities.includes(v);
        }
    },
    extended: {
        type: Boolean,
        "default": null
    },
    extensionHeight: {
        type: [
            Number,
            String
        ],
        "default": 48
    },
    flat: Boolean,
    floating: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        "default": 64
    },
    image: String,
    title: String
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'header'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VToolbar');
var $43b5cfb0203dfbd6$export$42c906c84e26a6d1 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VToolbar',
    props: $43b5cfb0203dfbd6$export$bdd0e6e03d2a507e(),
    setup: function(props, _ref) {
        var _slots_extension;
        var slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var isExtended = (0, $hXmfK.shallowRef)(props.extended === null ? !!((_slots_extension = slots.extension) === null || _slots_extension === void 0 ? void 0 : _slots_extension.call(slots)) : props.extended);
        var contentHeight = (0, $hXmfK.computed)(function() {
            return parseInt(Number(props.height) + (props.density === 'prominent' ? Number(props.height) : 0) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0), 10);
        });
        var extensionHeight = (0, $hXmfK.computed)(function() {
            return isExtended.value ? parseInt(Number(props.extensionHeight) + (props.density === 'prominent' ? Number(props.extensionHeight) : 0) - (props.density === 'comfortable' ? 4 : 0) - (props.density === 'compact' ? 8 : 0), 10) : 0;
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                variant: 'text'
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_extension;
            var hasTitle = !!(props.title || slots.title);
            var hasImage = !!(slots.image || props.image);
            var extension = (_slots_extension = slots.extension) === null || _slots_extension === void 0 ? void 0 : _slots_extension.call(slots);
            isExtended.value = props.extended === null ? !!extension : props.extended;
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-toolbar',
                    (0, $cqEAj._)({
                        'v-toolbar--absolute': props.absolute,
                        'v-toolbar--collapse': props.collapse,
                        'v-toolbar--flat': props.flat,
                        'v-toolbar--floating': props.floating
                    }, "v-toolbar--density-".concat(props.density), true),
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        hasImage && (0, $bu8yf.createElementVNode)("div", {
                            key: "image",
                            "class": "v-toolbar__image"
                        }, [
                            !slots.image ? (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                                key: "image-img",
                                cover: true,
                                src: props.image
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "image-defaults",
                                disabled: !props.image,
                                defaults: {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: {
                                VTabs: {
                                    height: (0, $31779689cfd5da50$export$286ad215293a0860)(contentHeight.value)
                                }
                            }
                        }, {
                            "default": function() {
                                var _slots_prepend, _slots_default, _slots_append;
                                return [
                                    (0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-toolbar__content",
                                        style: {
                                            height: (0, $31779689cfd5da50$export$286ad215293a0860)(contentHeight.value)
                                        }
                                    }, [
                                        slots.prepend && (0, $bu8yf.createElementVNode)("div", {
                                            "class": "v-toolbar__prepend"
                                        }, [
                                            (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots)
                                        ]),
                                        hasTitle && (0, $bu8yf.createVNode)((0, $f849e9bc71871807$export$deaeca9428bfc9a4), {
                                            key: "title",
                                            text: props.title
                                        }, {
                                            text: slots.title
                                        }),
                                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                                        slots.append && (0, $bu8yf.createElementVNode)("div", {
                                            "class": "v-toolbar__append"
                                        }, [
                                            (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                                        ])
                                    ])
                                ];
                            }
                        }),
                        (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: {
                                VTabs: {
                                    height: (0, $31779689cfd5da50$export$286ad215293a0860)(extensionHeight.value)
                                }
                            }
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$1cd1e8deb97d798d), null, {
                                        "default": function() {
                                            return [
                                                isExtended.value && (0, $bu8yf.createElementVNode)("div", {
                                                    "class": "v-toolbar__extension",
                                                    style: {
                                                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(extensionHeight.value)
                                                    }
                                                }, [
                                                    extension
                                                ])
                                            ];
                                        }
                                    })
                                ];
                            }
                        })
                    ];
                }
            });
        });
        return {
            contentHeight: contentHeight,
            extensionHeight: extensionHeight
        };
    }
});




// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $2deea3fe3686e58e$export$ada6e0f640b9c21f = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    scrollTarget: {
        type: String
    },
    scrollThreshold: {
        type: [
            String,
            Number
        ],
        "default": 300
    }
}, 'scroll');
function $2deea3fe3686e58e$export$d928051c8cd740b(props) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var canScroll = args.canScroll;
    var previousScroll = 0;
    var previousScrollHeight = 0;
    var target = (0, $hXmfK.ref)(null);
    var currentScroll = (0, $hXmfK.shallowRef)(0);
    var savedScroll = (0, $hXmfK.shallowRef)(0);
    var currentThreshold = (0, $hXmfK.shallowRef)(0);
    var isScrollActive = (0, $hXmfK.shallowRef)(false);
    var isScrollingUp = (0, $hXmfK.shallowRef)(false);
    var scrollThreshold = (0, $hXmfK.computed)(function() {
        return Number(props.scrollThreshold);
    });
    /**
   * 1: at top
   * 0: at threshold
   */ var scrollRatio = (0, $hXmfK.computed)(function() {
        return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)((scrollThreshold.value - currentScroll.value) / scrollThreshold.value || 0);
    });
    var onScroll = function() {
        var targetEl = target.value;
        if (!targetEl || canScroll && !canScroll.value) return;
        previousScroll = currentScroll.value;
        currentScroll.value = 'window' in targetEl ? targetEl.pageYOffset : targetEl.scrollTop;
        var currentScrollHeight = targetEl instanceof Window ? document.documentElement.scrollHeight : targetEl.scrollHeight;
        if (previousScrollHeight !== currentScrollHeight) {
            previousScrollHeight = currentScrollHeight;
            return;
        }
        isScrollingUp.value = currentScroll.value < previousScroll;
        currentThreshold.value = Math.abs(currentScroll.value - scrollThreshold.value);
    };
    (0, $hXmfK.watch)(isScrollingUp, function() {
        savedScroll.value = savedScroll.value || currentScroll.value;
    });
    (0, $hXmfK.watch)(isScrollActive, function() {
        savedScroll.value = 0;
    });
    (0, $bu8yf.onMounted)(function() {
        (0, $hXmfK.watch)(function() {
            return props.scrollTarget;
        }, function(scrollTarget) {
            var _target_value;
            var newTarget = scrollTarget ? document.querySelector(scrollTarget) : window;
            if (!newTarget) {
                (0, $b0e141e3fccca32c$export$222ba5e7254f2402)("Unable to locate element with identifier ".concat(scrollTarget));
                return;
            }
            if (newTarget === target.value) return;
            (_target_value = target.value) === null || _target_value === void 0 ? void 0 : _target_value.removeEventListener('scroll', onScroll);
            target.value = newTarget;
            target.value.addEventListener('scroll', onScroll, {
                passive: true
            });
        }, {
            immediate: true
        });
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        var _target_value;
        (_target_value = target.value) === null || _target_value === void 0 ? void 0 : _target_value.removeEventListener('scroll', onScroll);
    });
    // Do we need this? If yes - seems that
    // there's no need to expose onScroll
    canScroll && (0, $hXmfK.watch)(canScroll, onScroll, {
        immediate: true
    });
    return {
        scrollThreshold: scrollThreshold,
        currentScroll: currentScroll,
        currentThreshold: currentThreshold,
        isScrollActive: isScrollActive,
        scrollRatio: scrollRatio,
        // required only for testing
        // probably can be removed
        // later (2 chars chlng)
        isScrollingUp: isScrollingUp,
        savedScroll: savedScroll
    };
}


// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");
function $1ffa1d7831d0ed24$export$f385cca8ac2b2f35() {
    var isBooted = (0, $hXmfK.shallowRef)(false);
    (0, $bu8yf.onMounted)(function() {
        window.requestAnimationFrame(function() {
            isBooted.value = true;
        });
    });
    var ssrBootStyles = (0, $hXmfK.toRef)(function() {
        return !isBooted.value ? {
            transition: 'none !important'
        } : undefined;
    });
    return {
        ssrBootStyles: ssrBootStyles,
        isBooted: (0, $hXmfK.readonly)(isBooted)
    };
}




var $963ccfba89c549b5$export$46ee10ae454fcfcd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    scrollBehavior: String,
    modelValue: {
        type: Boolean,
        "default": true
    },
    location: {
        type: String,
        "default": 'top',
        validator: function(value) {
            return [
                'top',
                'bottom'
            ].includes(value);
        }
    }
}, (0, $43b5cfb0203dfbd6$export$bdd0e6e03d2a507e)(), (0, $39e98ff3447d557e$export$d42abac634ace931)(), (0, $2deea3fe3686e58e$export$ada6e0f640b9c21f)()), {
    height: {
        type: [
            Number,
            String
        ],
        "default": 64
    }
}), 'VAppBar');
var $963ccfba89c549b5$export$2fbc8fb55736252a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAppBar',
    props: $963ccfba89c549b5$export$46ee10ae454fcfcd(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var vToolbarRef = (0, $hXmfK.ref)();
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var scrollBehavior = (0, $hXmfK.computed)(function() {
            var _props_scrollBehavior;
            var _props_scrollBehavior_split;
            var behavior = new Set((_props_scrollBehavior_split = (_props_scrollBehavior = props.scrollBehavior) === null || _props_scrollBehavior === void 0 ? void 0 : _props_scrollBehavior.split(' ')) !== null && _props_scrollBehavior_split !== void 0 ? _props_scrollBehavior_split : []);
            return {
                hide: behavior.has('hide'),
                fullyHide: behavior.has('fully-hide'),
                inverted: behavior.has('inverted'),
                collapse: behavior.has('collapse'),
                elevate: behavior.has('elevate'),
                fadeImage: behavior.has('fade-image')
            };
        });
        var canScroll = (0, $hXmfK.computed)(function() {
            var behavior = scrollBehavior.value;
            return behavior.hide || behavior.fullyHide || behavior.inverted || behavior.collapse || behavior.elevate || behavior.fadeImage || // behavior.shrink ||
            !isActive.value;
        });
        var _useScroll = (0, $2deea3fe3686e58e$export$d928051c8cd740b)(props, {
            canScroll: canScroll
        }), currentScroll = _useScroll.currentScroll, scrollThreshold = _useScroll.scrollThreshold, isScrollingUp = _useScroll.isScrollingUp, scrollRatio = _useScroll.scrollRatio;
        var canHide = (0, $hXmfK.toRef)(function() {
            return scrollBehavior.value.hide || scrollBehavior.value.fullyHide;
        });
        var isCollapsed = (0, $hXmfK.computed)(function() {
            return props.collapse || scrollBehavior.value.collapse && (scrollBehavior.value.inverted ? scrollRatio.value > 0 : scrollRatio.value === 0);
        });
        var isFlat = (0, $hXmfK.computed)(function() {
            return props.flat || scrollBehavior.value.fullyHide && !isActive.value || scrollBehavior.value.elevate && (scrollBehavior.value.inverted ? currentScroll.value > 0 : currentScroll.value === 0);
        });
        var opacity = (0, $hXmfK.computed)(function() {
            return scrollBehavior.value.fadeImage ? scrollBehavior.value.inverted ? 1 - scrollRatio.value : scrollRatio.value : undefined;
        });
        var height = (0, $hXmfK.computed)(function() {
            var _vToolbarRef_value, _vToolbarRef_value1;
            if (scrollBehavior.value.hide && scrollBehavior.value.inverted) return 0;
            var _vToolbarRef_value_contentHeight;
            var height = (_vToolbarRef_value_contentHeight = (_vToolbarRef_value = vToolbarRef.value) === null || _vToolbarRef_value === void 0 ? void 0 : _vToolbarRef_value.contentHeight) !== null && _vToolbarRef_value_contentHeight !== void 0 ? _vToolbarRef_value_contentHeight : 0;
            var _vToolbarRef_value_extensionHeight;
            var extensionHeight = (_vToolbarRef_value_extensionHeight = (_vToolbarRef_value1 = vToolbarRef.value) === null || _vToolbarRef_value1 === void 0 ? void 0 : _vToolbarRef_value1.extensionHeight) !== null && _vToolbarRef_value_extensionHeight !== void 0 ? _vToolbarRef_value_extensionHeight : 0;
            if (!canHide.value) return height + extensionHeight;
            return currentScroll.value < scrollThreshold.value || scrollBehavior.value.fullyHide ? height + extensionHeight : height;
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return !!props.scrollBehavior;
        }, function() {
            (0, $bu8yf.watchEffect)(function() {
                if (canHide.value) {
                    if (scrollBehavior.value.inverted) isActive.value = currentScroll.value > scrollThreshold.value;
                    else isActive.value = isScrollingUp.value || currentScroll.value < scrollThreshold.value;
                } else isActive.value = true;
            });
        });
        var ssrBootStyles = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().ssrBootStyles;
        var layoutItemStyles = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $hXmfK.computed)(function() {
                return parseInt(props.order, 10);
            }),
            position: (0, $hXmfK.toRef)(function() {
                return props.location;
            }),
            layoutSize: height,
            elementSize: (0, $hXmfK.shallowRef)(undefined),
            active: isActive,
            absolute: (0, $hXmfK.toRef)(function() {
                return props.absolute;
            })
        }).layoutItemStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var toolbarProps = (0, $43b5cfb0203dfbd6$export$42c906c84e26a6d1).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $43b5cfb0203dfbd6$export$42c906c84e26a6d1), (0, $bu8yf.mergeProps)({
                ref: vToolbarRef,
                "class": [
                    'v-app-bar',
                    {
                        'v-app-bar--bottom': props.location === 'bottom'
                    },
                    props["class"]
                ],
                style: [
                    (0, $iT0je._)((0, $emQHU._)((0, $iT0je._)({}, layoutItemStyles.value), {
                        '--v-toolbar-image-opacity': opacity.value,
                        height: undefined
                    }), ssrBootStyles.value),
                    props.style
                ]
            }, toolbarProps, {
                collapse: isCollapsed.value,
                flat: isFlat.value
            }), slots);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");

var $iT0je = parcelRequire("iT0je");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");




// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $ee636d54b7237d8b$var$allowedDensities = [
    null,
    'default',
    'comfortable',
    'compact'
];
var $ee636d54b7237d8b$export$aac8956235d563cb = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    density: {
        type: String,
        "default": 'default',
        validator: function(v) {
            return $ee636d54b7237d8b$var$allowedDensities.includes(v);
        }
    }
}, 'density');
function $ee636d54b7237d8b$export$29e89a97ff256b5f(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var densityClasses = (0, $hXmfK.toRef)(function() {
        return "".concat(name, "--density-").concat(props.density);
    });
    return {
        densityClasses: densityClasses
    };
}







var $cqEAj = parcelRequire("cqEAj");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");


var $b8cfc08eef1ed28f$export$2f93f3a46970d4f0 = [
    'elevated',
    'flat',
    'tonal',
    'outlined',
    'text',
    'plain'
];
function $b8cfc08eef1ed28f$export$e27cd265ed232373(isClickable, name) {
    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
        isClickable && (0, $bu8yf.createElementVNode)("span", {
            key: "overlay",
            "class": (0, $d8jBh.normalizeClass)("".concat(name, "__overlay"))
        }, null),
        (0, $bu8yf.createElementVNode)("span", {
            key: "underlay",
            "class": (0, $d8jBh.normalizeClass)("".concat(name, "__underlay"))
        }, null)
    ]);
}
var $b8cfc08eef1ed28f$export$7c4064f4acce0348 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    color: String,
    variant: {
        type: String,
        "default": 'elevated',
        validator: function(v) {
            return $b8cfc08eef1ed28f$export$2f93f3a46970d4f0.includes(v);
        }
    }
}, 'variant');
function $b8cfc08eef1ed28f$export$36ef81613f8f20fc(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var variantClasses = (0, $hXmfK.toRef)(function() {
        var variant = (0, $hXmfK.toValue)(props).variant;
        return "".concat(name, "--variant-").concat(variant);
    });
    var _useColor = (0, $1f80711f67f81e35$export$5aadd9c0606af5c2)(function() {
        var _toValue = (0, $hXmfK.toValue)(props), variant = _toValue.variant, color = _toValue.color;
        return (0, $cqEAj._)({}, [
            'elevated',
            'flat'
        ].includes(variant) ? 'background' : 'text', color);
    }), colorClasses = _useColor.colorClasses, colorStyles = _useColor.colorStyles;
    return {
        colorClasses: colorClasses,
        colorStyles: colorStyles,
        variantClasses: variantClasses
    };
}



var $1ab0621309dbac8d$export$3294be1f7b2d41ce = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    baseColor: String,
    divided: Boolean,
    direction: {
        type: String,
        "default": 'horizontal'
    }
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)()), 'VBtnGroup');
var $1ab0621309dbac8d$export$9901e555ac223efb = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBtnGroup',
    props: $1ab0621309dbac8d$export$3294be1f7b2d41ce(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                height: (0, $hXmfK.toRef)(function() {
                    return props.direction === 'horizontal' ? 'auto' : null;
                }),
                baseColor: (0, $hXmfK.toRef)(function() {
                    return props.baseColor;
                }),
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                flat: true,
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-btn-group',
                    "v-btn-group--".concat(props.direction),
                    {
                        'v-btn-group--divided': props.divided
                    },
                    themeClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, slots);
        });
    }
});


// Composables

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $073309bf395585eb$export$fa4c05b3520340e6 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    modelValue: {
        type: null,
        "default": undefined
    },
    multiple: Boolean,
    mandatory: [
        Boolean,
        String
    ],
    max: Number,
    selectedClass: String,
    disabled: Boolean
}, 'group');
var $073309bf395585eb$export$e9e3b570044587e8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    value: null,
    disabled: Boolean,
    selectedClass: String
}, 'group-item');
function $073309bf395585eb$export$eebde8160f061c26(props, injectKey) {
    var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useGroupItem');
    if (!vm) throw new Error('[Vuetify] useGroupItem composable must be used inside a component setup function');
    var id = (0, $bu8yf.useId)();
    (0, $bu8yf.provide)(Symbol["for"]("".concat(injectKey.description, ":id")), id);
    var group = (0, $bu8yf.inject)(injectKey, null);
    if (!group) {
        if (!required) return group;
        throw new Error("[Vuetify] Could not find useGroup injection with symbol ".concat(injectKey.description));
    }
    var value = (0, $hXmfK.toRef)(function() {
        return props.value;
    });
    var disabled = (0, $hXmfK.computed)(function() {
        return !!(group.disabled.value || props.disabled);
    });
    group.register({
        id: id,
        value: value,
        disabled: disabled
    }, vm);
    (0, $bu8yf.onBeforeUnmount)(function() {
        group.unregister(id);
    });
    var isSelected = (0, $hXmfK.computed)(function() {
        return group.isSelected(id);
    });
    var isFirst = (0, $hXmfK.computed)(function() {
        return group.items.value[0].id === id;
    });
    var isLast = (0, $hXmfK.computed)(function() {
        return group.items.value[group.items.value.length - 1].id === id;
    });
    var selectedClass = (0, $hXmfK.computed)(function() {
        return isSelected.value && [
            group.selectedClass.value,
            props.selectedClass
        ];
    });
    (0, $hXmfK.watch)(isSelected, function(value) {
        vm.emit('group:selected', {
            value: value
        });
    }, {
        flush: 'sync'
    });
    return {
        id: id,
        isSelected: isSelected,
        isFirst: isFirst,
        isLast: isLast,
        toggle: function() {
            return group.select(id, !isSelected.value);
        },
        select: function(value) {
            return group.select(id, value);
        },
        selectedClass: selectedClass,
        value: value,
        disabled: disabled,
        group: group
    };
}
function $073309bf395585eb$export$bfb6a372146ddc96(props, injectKey) {
    var isUnmounted = false;
    var items = (0, $hXmfK.reactive)([]);
    var selected = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', [], function(v) {
        if (v == null) return [];
        return $073309bf395585eb$var$getIds(items, (0, $31779689cfd5da50$export$76411cac38121ecb)(v));
    }, function(v) {
        var arr = $073309bf395585eb$var$getValues(items, v);
        return props.multiple ? arr : arr[0];
    });
    var groupVm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useGroup');
    function register(item, vm) {
        // Is there a better way to fix this typing?
        var unwrapped = item;
        var key = Symbol["for"]("".concat(injectKey.description, ":id"));
        var children = (0, $31779689cfd5da50$export$424fe43b65f39668)(key, groupVm === null || groupVm === void 0 ? void 0 : groupVm.vnode);
        var index = children.indexOf(vm);
        if ((0, $hXmfK.unref)(unwrapped.value) == null) {
            unwrapped.value = index;
            unwrapped.useIndexAsValue = true;
        }
        if (index > -1) items.splice(index, 0, unwrapped);
        else items.push(unwrapped);
    }
    function unregister(id) {
        if (isUnmounted) return;
        // TODO: re-evaluate this line's importance in the future
        // should we only modify the model if mandatory is set.
        // selected.value = selected.value.filter(v => v !== id)
        forceMandatoryValue();
        var index = items.findIndex(function(item) {
            return item.id === id;
        });
        items.splice(index, 1);
    }
    // If mandatory and nothing is selected, then select first non-disabled item
    function forceMandatoryValue() {
        var item = items.find(function(item) {
            return !item.disabled;
        });
        if (item && props.mandatory === 'force' && !selected.value.length) selected.value = [
            item.id
        ];
    }
    (0, $bu8yf.onMounted)(function() {
        forceMandatoryValue();
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        isUnmounted = true;
    });
    (0, $bu8yf.onUpdated)(function() {
        // #19655 update the items that use the index as the value.
        for(var i = 0; i < items.length; i++)if (items[i].useIndexAsValue) items[i].value = i;
    });
    function select(id, value) {
        var item = items.find(function(item) {
            return item.id === id;
        });
        if (value && (item === null || item === void 0 ? void 0 : item.disabled)) return;
        if (props.multiple) {
            var internalValue = selected.value.slice();
            var index = internalValue.findIndex(function(v) {
                return v === id;
            });
            var isSelected = ~index;
            value = value !== null && value !== void 0 ? value : !isSelected;
            // We can't remove value if group is
            // mandatory, value already exists,
            // and it is the only value
            if (isSelected && props.mandatory && internalValue.length <= 1) return;
            // We can't add value if it would
            // cause max limit to be exceeded
            if (!isSelected && props.max != null && internalValue.length + 1 > props.max) return;
            if (index < 0 && value) internalValue.push(id);
            else if (index >= 0 && !value) internalValue.splice(index, 1);
            selected.value = internalValue;
        } else {
            var isSelected1 = selected.value.includes(id);
            if (props.mandatory && isSelected1) return;
            if (!isSelected1 && !value) return;
            selected.value = (value !== null && value !== void 0 ? value : !isSelected1) ? [
                id
            ] : [];
        }
    }
    function step(offset) {
        // getting an offset from selected value obviously won't work with multiple values
        if (props.multiple) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('This method is not supported when using "multiple" prop');
        if (!selected.value.length) {
            var item = items.find(function(item) {
                return !item.disabled;
            });
            item && (selected.value = [
                item.id
            ]);
        } else {
            var currentId = selected.value[0];
            var currentIndex = items.findIndex(function(i) {
                return i.id === currentId;
            });
            var newIndex = (currentIndex + offset) % items.length;
            var newItem = items[newIndex];
            while(newItem.disabled && newIndex !== currentIndex){
                newIndex = (newIndex + offset) % items.length;
                newItem = items[newIndex];
            }
            if (newItem.disabled) return;
            selected.value = [
                items[newIndex].id
            ];
        }
    }
    var state = {
        register: register,
        unregister: unregister,
        selected: selected,
        select: select,
        disabled: (0, $hXmfK.toRef)(function() {
            return props.disabled;
        }),
        prev: function() {
            return step(items.length - 1);
        },
        next: function() {
            return step(1);
        },
        isSelected: function(id) {
            return selected.value.includes(id);
        },
        selectedClass: (0, $hXmfK.toRef)(function() {
            return props.selectedClass;
        }),
        items: (0, $hXmfK.toRef)(function() {
            return items;
        }),
        getItemIndex: function(value) {
            return $073309bf395585eb$var$getItemIndex(items, value);
        }
    };
    (0, $bu8yf.provide)(injectKey, state);
    return state;
}
function $073309bf395585eb$var$getItemIndex(items, value) {
    var ids = $073309bf395585eb$var$getIds(items, [
        value
    ]);
    if (!ids.length) return -1;
    return items.findIndex(function(item) {
        return item.id === ids[0];
    });
}
function $073309bf395585eb$var$getIds(items, modelValue) {
    var ids = [];
    modelValue.forEach(function(value) {
        var item = items.find(function(item) {
            return (0, $31779689cfd5da50$export$9cb4719e2e525b7a)(value, item.value);
        });
        var itemByIndex = items[value];
        if ((item === null || item === void 0 ? void 0 : item.value) != null) ids.push(item.id);
        else if (itemByIndex === null || itemByIndex === void 0 ? void 0 : itemByIndex.useIndexAsValue) ids.push(itemByIndex.id);
    });
    return ids;
}
function $073309bf395585eb$var$getValues(items, ids) {
    var values = [];
    ids.forEach(function(id) {
        var itemIndex = items.findIndex(function(item) {
            return item.id === id;
        });
        if (~itemIndex) {
            var item = items[itemIndex];
            values.push(item.value != null ? item.value : itemIndex);
        }
    });
    return values;
}



var $03c8359f84f50d85$export$7ccf67e9366faa19 = Symbol["for"]('vuetify:v-btn-toggle');
var $03c8359f84f50d85$export$4be96eb43616f3ac = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $1ab0621309dbac8d$export$3294be1f7b2d41ce)(), (0, $073309bf395585eb$export$fa4c05b3520340e6)()), 'VBtnToggle');
var $03c8359f84f50d85$export$2097e77d7f4058c7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBtnToggle',
    props: $03c8359f84f50d85$export$4be96eb43616f3ac(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useGroup = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, $03c8359f84f50d85$export$7ccf67e9366faa19), isSelected = _useGroup.isSelected, next = _useGroup.next, prev = _useGroup.prev, select = _useGroup.select, selected = _useGroup.selected;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var btnGroupProps = (0, $1ab0621309dbac8d$export$9901e555ac223efb).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $1ab0621309dbac8d$export$9901e555ac223efb), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-btn-toggle',
                    props["class"]
                ]
            }, btnGroupProps, {
                style: props.style
            }), {
                "default": function() {
                    var _slots_default;
                    return [
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            next: next,
                            prev: prev,
                            select: select,
                            selected: selected
                        })
                    ];
                }
            });
        });
        return {
            next: next,
            prev: prev,
            select: select
        };
    }
});




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");




// Utilities

var $4d4c8d49e200475b$var$predefinedSizes = [
    'x-small',
    'small',
    'default',
    'large',
    'x-large'
];
var $4d4c8d49e200475b$export$c7a32fb00df3ff20 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    size: {
        type: [
            String,
            Number
        ],
        "default": 'default'
    }
}, 'size');
function $4d4c8d49e200475b$export$1ab7ae714698c4b8(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    return (0, $31779689cfd5da50$export$fe6a5b56d01db4f5)(function() {
        var size = props.size;
        var sizeClasses;
        var sizeStyles;
        if ((0, $31779689cfd5da50$export$ee2e0f811dca1807)($4d4c8d49e200475b$var$predefinedSizes, size)) sizeClasses = "".concat(name, "--size-").concat(size);
        else if (size) sizeStyles = {
            width: (0, $31779689cfd5da50$export$286ad215293a0860)(size),
            height: (0, $31779689cfd5da50$export$286ad215293a0860)(size)
        };
        return {
            sizeClasses: sizeClasses,
            sizeStyles: sizeStyles
        };
    });
}





var $f7a1be8330d12953$export$7248a8743d8f7621 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    disabled: Boolean,
    start: Boolean,
    end: Boolean,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    opacity: [
        String,
        Number
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'i'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VIcon');
var $f7a1be8330d12953$export$a7d30c6ec4d2d61e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VIcon',
    props: $f7a1be8330d12953$export$7248a8743d8f7621(),
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var slotIcon = (0, $hXmfK.shallowRef)();
        var themeClasses = (0, $d8647489982f8a06$export$93d4e7f90805808f)().themeClasses;
        var iconData = (0, $0192db7efcc99bb9$export$27cb60208885277b)(function() {
            return slotIcon.value || props.icon;
        }).iconData;
        var sizeClasses = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props).sizeClasses;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default, _flattenFragments_filter_;
            var slotValue = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
            if (slotValue) slotIcon.value = (_flattenFragments_filter_ = (0, $31779689cfd5da50$export$c556ee00a0535018)(slotValue).filter(function(node) {
                return node.type === (0, $bu8yf.Text) && node.children && typeof node.children === 'string';
            })[0]) === null || _flattenFragments_filter_ === void 0 ? void 0 : _flattenFragments_filter_.children;
            var hasClick = !!(attrs.onClick || attrs.onClickOnce);
            return (0, $bu8yf.createVNode)(iconData.value.component, {
                tag: props.tag,
                icon: iconData.value.icon,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-icon',
                    'notranslate',
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    {
                        'v-icon--clickable': hasClick,
                        'v-icon--disabled': props.disabled,
                        'v-icon--start': props.start,
                        'v-icon--end': props.end
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-icon-opacity': props.opacity
                    },
                    !sizeClasses.value ? {
                        fontSize: (0, $31779689cfd5da50$export$286ad215293a0860)(props.size),
                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.size),
                        width: (0, $31779689cfd5da50$export$286ad215293a0860)(props.size)
                    } : undefined,
                    textColorStyles.value,
                    props.style
                ]),
                role: hasClick ? 'button' : undefined,
                "aria-hidden": !hasClick,
                tabindex: hasClick ? props.disabled ? -1 : 0 : undefined
            }, {
                "default": function() {
                    return [
                        slotValue
                    ];
                }
            });
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");



// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

function $017d27f86fb94b2b$export$a7395f9832c00176(callback, options) {
    var intersectionRef = (0, $hXmfK.ref)();
    var isIntersecting = (0, $hXmfK.shallowRef)(false);
    if (0, $10db88b646d64b14$export$8cb82f5817a92ac4) {
        var observer = new IntersectionObserver(function(entries) {
            callback === null || callback === void 0 ? void 0 : callback(entries, observer);
            isIntersecting.value = !!entries.find(function(entry) {
                return entry.isIntersecting;
            });
        }, options);
        (0, $hXmfK.onScopeDispose)(function() {
            observer.disconnect();
        });
        (0, $hXmfK.watch)(intersectionRef, function(newValue, oldValue) {
            if (oldValue) {
                observer.unobserve(oldValue);
                isIntersecting.value = false;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        intersectionRef: intersectionRef,
        isIntersecting: isIntersecting
    };
}







var $14d6ceaaee1fb579$export$ffe0c85d1e4bac48 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    bgColor: String,
    color: String,
    indeterminate: [
        Boolean,
        String
    ],
    modelValue: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    rotate: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    width: {
        type: [
            Number,
            String
        ],
        "default": 4
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'div'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VProgressCircular');
var $14d6ceaaee1fb579$export$2b4afd8de42c0c21 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VProgressCircular',
    props: $14d6ceaaee1fb579$export$ffe0c85d1e4bac48(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var MAGIC_RADIUS_CONSTANT = 20;
        var CIRCUMFERENCE = 2 * Math.PI * MAGIC_RADIUS_CONSTANT;
        var root = (0, $hXmfK.ref)();
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useSize = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props), sizeClasses = _useSize.sizeClasses, sizeStyles = _useSize.sizeStyles;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var _useTextColor1 = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.bgColor;
        }), underlayColorClasses = _useTextColor1.textColorClasses, underlayColorStyles = _useTextColor1.textColorStyles;
        var _useIntersectionObserver = (0, $017d27f86fb94b2b$export$a7395f9832c00176)(), intersectionRef = _useIntersectionObserver.intersectionRef, isIntersecting = _useIntersectionObserver.isIntersecting;
        var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), resizeRef = _useResizeObserver.resizeRef, contentRect = _useResizeObserver.contentRect;
        var normalizedValue = (0, $hXmfK.toRef)(function() {
            return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(parseFloat(props.modelValue), 0, 100);
        });
        var width = (0, $hXmfK.toRef)(function() {
            return Number(props.width);
        });
        var size = (0, $hXmfK.toRef)(function() {
            // Get size from element if size prop value is small, large etc
            return sizeStyles.value ? Number(props.size) : contentRect.value ? contentRect.value.width : Math.max(width.value, 32);
        });
        var diameter = (0, $hXmfK.toRef)(function() {
            return MAGIC_RADIUS_CONSTANT / (1 - width.value / size.value) * 2;
        });
        var strokeWidth = (0, $hXmfK.toRef)(function() {
            return width.value / size.value * diameter.value;
        });
        var strokeDashOffset = (0, $hXmfK.toRef)(function() {
            return (0, $31779689cfd5da50$export$286ad215293a0860)((100 - normalizedValue.value) / 100 * CIRCUMFERENCE);
        });
        (0, $bu8yf.watchEffect)(function() {
            intersectionRef.value = root.value;
            resizeRef.value = root.value;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                ref: root,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-progress-circular',
                    {
                        'v-progress-circular--indeterminate': !!props.indeterminate,
                        'v-progress-circular--visible': isIntersecting.value,
                        'v-progress-circular--disable-shrink': props.indeterminate === 'disable-shrink'
                    },
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    sizeStyles.value,
                    textColorStyles.value,
                    props.style
                ]),
                role: "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.createElementVNode)("svg", {
                            style: {
                                transform: "rotate(calc(-90deg + ".concat(Number(props.rotate), "deg))")
                            },
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 ".concat(diameter.value, " ").concat(diameter.value)
                        }, [
                            (0, $bu8yf.createElementVNode)("circle", {
                                "class": (0, $d8jBh.normalizeClass)([
                                    'v-progress-circular__underlay',
                                    underlayColorClasses.value
                                ]),
                                style: (0, $d8jBh.normalizeStyle)(underlayColorStyles.value),
                                fill: "transparent",
                                cx: "50%",
                                cy: "50%",
                                r: MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": 0
                            }, null),
                            (0, $bu8yf.createElementVNode)("circle", {
                                "class": "v-progress-circular__overlay",
                                fill: "transparent",
                                cx: "50%",
                                cy: "50%",
                                r: MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": strokeDashOffset.value
                            }, null)
                        ]),
                        slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-progress-circular__content"
                        }, [
                            slots["default"]({
                                value: normalizedValue.value
                            })
                        ])
                    ];
                }
            });
        });
        return {};
    }
});










var $cqEAj = parcelRequire("cqEAj");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");





// Composables

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
// Utilities

var $32TW8 = parcelRequire("32TW8");

var $a9eac1600b361ada$var$block = [
    'top',
    'bottom'
];
var $a9eac1600b361ada$var$inline = [
    'start',
    'end',
    'left',
    'right'
];
function $a9eac1600b361ada$export$49d416a6d8a07bbb(anchor, isRtl) {
    var _anchor_split = (0, $32TW8._)(anchor.split(' '), 2), side = _anchor_split[0], align = _anchor_split[1];
    if (!align) align = (0, $31779689cfd5da50$export$ee2e0f811dca1807)($a9eac1600b361ada$var$block, side) ? 'start' : (0, $31779689cfd5da50$export$ee2e0f811dca1807)($a9eac1600b361ada$var$inline, side) ? 'top' : 'center';
    return {
        side: $a9eac1600b361ada$export$b56cedd93dedafd4(side, isRtl),
        align: $a9eac1600b361ada$export$b56cedd93dedafd4(align, isRtl)
    };
}
function $a9eac1600b361ada$export$b56cedd93dedafd4(str, isRtl) {
    if (str === 'start') return isRtl ? 'right' : 'left';
    if (str === 'end') return isRtl ? 'left' : 'right';
    return str;
}
function $a9eac1600b361ada$export$1bbdb13cd7175683(anchor) {
    return {
        side: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.side],
        align: anchor.align
    };
}
function $a9eac1600b361ada$export$ae4fe0e90a9c983d(anchor) {
    return {
        side: anchor.side,
        align: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.align]
    };
}
function $a9eac1600b361ada$export$af41802054d9b2a8(anchor) {
    return {
        side: anchor.align,
        align: anchor.side
    };
}
function $a9eac1600b361ada$export$8a3a0724d206787a(anchor) {
    return (0, $31779689cfd5da50$export$ee2e0f811dca1807)($a9eac1600b361ada$var$block, anchor.side) ? 'y' : 'x';
}


var $1f28bc3af840aa00$var$oppositeMap = {
    center: 'center',
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $1f28bc3af840aa00$export$2831add577f947cb = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    location: String
}, 'location');
function $1f28bc3af840aa00$export$45d76561a5302f2b(props) {
    var opposite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var offset = arguments.length > 2 ? arguments[2] : undefined;
    var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
    var locationStyles = (0, $hXmfK.computed)(function() {
        var getOffset = function getOffset(side) {
            return offset ? offset(side) : 0;
        };
        if (!props.location) return {};
        var _parseAnchor = (0, $a9eac1600b361ada$export$49d416a6d8a07bbb)(props.location.split(' ').length > 1 ? props.location : "".concat(props.location, " center"), isRtl.value), side = _parseAnchor.side, align = _parseAnchor.align;
        var styles = {};
        if (side !== 'center') {
            if (opposite) styles[$1f28bc3af840aa00$var$oppositeMap[side]] = "calc(100% - ".concat(getOffset(side), "px)");
            else styles[side] = 0;
        }
        if (align !== 'center') {
            if (opposite) styles[$1f28bc3af840aa00$var$oppositeMap[align]] = "calc(100% - ".concat(getOffset(align), "px)");
            else styles[align] = 0;
        } else {
            if (side === 'center') styles.top = styles.left = '50%';
            else styles[({
                top: 'left',
                bottom: 'left',
                left: 'top',
                right: 'top'
            })[side]] = '50%';
            styles.transform = ({
                top: 'translateX(-50%)',
                bottom: 'translateX(-50%)',
                left: 'translateY(-50%)',
                right: 'translateY(-50%)',
                center: 'translate(-50%, -50%)'
            })[side];
        }
        return styles;
    });
    return {
        locationStyles: locationStyles
    };
}







var $b435191c768336fc$export$1d0642f81c4ed710 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    absolute: Boolean,
    active: {
        type: Boolean,
        "default": true
    },
    bgColor: String,
    bgOpacity: [
        Number,
        String
    ],
    bufferValue: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    bufferColor: String,
    bufferOpacity: [
        Number,
        String
    ],
    clickable: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        "default": 4
    },
    indeterminate: Boolean,
    max: {
        type: [
            Number,
            String
        ],
        "default": 100
    },
    modelValue: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    opacity: [
        Number,
        String
    ],
    reverse: Boolean,
    stream: Boolean,
    striped: Boolean,
    roundedBar: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)({
    location: 'top'
}), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VProgressLinear');
var $b435191c768336fc$export$86b13ad59f1a1627 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VProgressLinear',
    props: $b435191c768336fc$export$1d0642f81c4ed710(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var _window_matchMedia, _window;
        var slots = _ref.slots;
        var progress = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)(), isRtl = _useRtl.isRtl, rtlClasses = _useRtl.rtlClasses;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor || props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var _useBackgroundColor1 = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bufferColor || props.bgColor || props.color;
        }), bufferColorClasses = _useBackgroundColor1.backgroundColorClasses, bufferColorStyles = _useBackgroundColor1.backgroundColorStyles;
        var _useBackgroundColor2 = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), barColorClasses = _useBackgroundColor2.backgroundColorClasses, barColorStyles = _useBackgroundColor2.backgroundColorStyles;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useIntersectionObserver = (0, $017d27f86fb94b2b$export$a7395f9832c00176)(), intersectionRef = _useIntersectionObserver.intersectionRef, isIntersecting = _useIntersectionObserver.isIntersecting;
        var max = (0, $hXmfK.computed)(function() {
            return parseFloat(props.max);
        });
        var height = (0, $hXmfK.computed)(function() {
            return parseFloat(props.height);
        });
        var normalizedBuffer = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(parseFloat(props.bufferValue) / max.value * 100, 0, 100);
        });
        var normalizedValue = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(parseFloat(progress.value) / max.value * 100, 0, 100);
        });
        var isReversed = (0, $hXmfK.computed)(function() {
            return isRtl.value !== props.reverse;
        });
        var transition = (0, $hXmfK.computed)(function() {
            return props.indeterminate ? 'fade-transition' : 'slide-x-transition';
        });
        var isForcedColorsModeActive = (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && ((_window_matchMedia = (_window = window).matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, '(forced-colors: active)').matches);
        function handleClick(e) {
            if (!intersectionRef.value) return;
            var _intersectionRef_value_getBoundingClientRect = intersectionRef.value.getBoundingClientRect(), left = _intersectionRef_value_getBoundingClientRect.left, right = _intersectionRef_value_getBoundingClientRect.right, width = _intersectionRef_value_getBoundingClientRect.width;
            var value = isReversed.value ? width - e.clientX + (right - width) : e.clientX - left;
            progress.value = Math.round(value / width * max.value);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                ref: intersectionRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-progress-linear',
                    {
                        'v-progress-linear--absolute': props.absolute,
                        'v-progress-linear--active': props.active && isIntersecting.value,
                        'v-progress-linear--reverse': isReversed.value,
                        'v-progress-linear--rounded': props.rounded,
                        'v-progress-linear--rounded-bar': props.roundedBar,
                        'v-progress-linear--striped': props.striped
                    },
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    (0, $iT0je._)({
                        bottom: props.location === 'bottom' ? 0 : undefined,
                        top: props.location === 'top' ? 0 : undefined,
                        height: props.active ? (0, $31779689cfd5da50$export$286ad215293a0860)(height.value) : 0,
                        '--v-progress-linear-height': (0, $31779689cfd5da50$export$286ad215293a0860)(height.value)
                    }, props.absolute ? locationStyles.value : {}),
                    props.style
                ]),
                role: "progressbar",
                "aria-hidden": props.active ? 'false' : 'true',
                "aria-valuemin": "0",
                "aria-valuemax": props.max,
                "aria-valuenow": props.indeterminate ? undefined : Math.min(parseFloat(progress.value), max.value),
                onClick: props.clickable && handleClick
            }, {
                "default": function() {
                    var _obj;
                    return [
                        props.stream && (0, $bu8yf.createElementVNode)("div", {
                            key: "stream",
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-progress-linear__stream',
                                textColorClasses.value
                            ]),
                            style: (0, $emQHU._)((0, $iT0je._)({}, textColorStyles.value), (_obj = {}, (0, $cqEAj._)(_obj, isReversed.value ? 'left' : 'right', (0, $31779689cfd5da50$export$286ad215293a0860)(-height.value)), (0, $cqEAj._)(_obj, "borderTop", "".concat((0, $31779689cfd5da50$export$286ad215293a0860)(height.value / 2), " dotted")), (0, $cqEAj._)(_obj, "opacity", parseFloat(props.bufferOpacity)), (0, $cqEAj._)(_obj, "top", "calc(50% - ".concat((0, $31779689cfd5da50$export$286ad215293a0860)(height.value / 4), ")")), (0, $cqEAj._)(_obj, "width", (0, $31779689cfd5da50$export$286ad215293a0860)(100 - normalizedBuffer.value, '%')), (0, $cqEAj._)(_obj, '--v-progress-linear-stream-to', (0, $31779689cfd5da50$export$286ad215293a0860)(height.value * (isReversed.value ? 1 : -1))), _obj))
                        }, null),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-progress-linear__background',
                                !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                            ]),
                            style: (0, $d8jBh.normalizeStyle)([
                                backgroundColorStyles.value,
                                {
                                    opacity: parseFloat(props.bgOpacity),
                                    width: props.stream ? 0 : undefined
                                }
                            ])
                        }, null),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-progress-linear__buffer',
                                !isForcedColorsModeActive ? bufferColorClasses.value : undefined
                            ]),
                            style: (0, $d8jBh.normalizeStyle)([
                                bufferColorStyles.value,
                                {
                                    opacity: parseFloat(props.bufferOpacity),
                                    width: (0, $31779689cfd5da50$export$286ad215293a0860)(normalizedBuffer.value, '%')
                                }
                            ])
                        }, null),
                        (0, $bu8yf.createVNode)((0, $kiZwI.Transition), {
                            name: transition.value
                        }, {
                            "default": function() {
                                return [
                                    !props.indeterminate ? (0, $bu8yf.createElementVNode)("div", {
                                        "class": (0, $d8jBh.normalizeClass)([
                                            'v-progress-linear__determinate',
                                            !isForcedColorsModeActive ? barColorClasses.value : undefined
                                        ]),
                                        style: (0, $d8jBh.normalizeStyle)([
                                            barColorStyles.value,
                                            {
                                                width: (0, $31779689cfd5da50$export$286ad215293a0860)(normalizedValue.value, '%')
                                            }
                                        ])
                                    }, null) : (0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-progress-linear__indeterminate"
                                    }, [
                                        [
                                            'long',
                                            'short'
                                        ].map(function(bar) {
                                            return (0, $bu8yf.createElementVNode)("div", {
                                                key: bar,
                                                "class": (0, $d8jBh.normalizeClass)([
                                                    'v-progress-linear__indeterminate',
                                                    bar,
                                                    !isForcedColorsModeActive ? barColorClasses.value : undefined
                                                ]),
                                                style: (0, $d8jBh.normalizeStyle)(barColorStyles.value)
                                            }, null);
                                        })
                                    ])
                                ];
                            }
                        }),
                        slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-progress-linear__content"
                        }, [
                            slots["default"]({
                                value: normalizedValue.value,
                                buffer: normalizedBuffer.value
                            })
                        ])
                    ];
                }
            });
        });
        return {};
    }
});



var $de59c43ac78c3e7a$export$149f04e0cba4dbc1 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    loading: [
        Boolean,
        String
    ]
}, 'loader');
function $de59c43ac78c3e7a$export$14095de704efe3f9(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var loaderClasses = (0, $hXmfK.toRef)(function() {
        return (0, $cqEAj._)({}, "".concat(name, "--loading"), props.loading);
    });
    return {
        loaderClasses: loaderClasses
    };
}
function $de59c43ac78c3e7a$export$9a5d46a3538da529(props, _ref) {
    var _slots_default;
    var slots = _ref.slots;
    return (0, $bu8yf.createElementVNode)("div", {
        "class": (0, $d8jBh.normalizeClass)("".concat(props.name, "__loader"))
    }, [
        ((_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
            color: props.color,
            isActive: props.active
        })) || (0, $bu8yf.createVNode)((0, $b435191c768336fc$export$86b13ad59f1a1627), {
            absolute: props.absolute,
            active: props.active,
            color: props.color,
            height: "2",
            indeterminate: true
        }, null)
    ]);
}



// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $e95b1c16d66c4c43$var$positionValues = [
    'static',
    'relative',
    'fixed',
    'absolute',
    'sticky'
];
var $e95b1c16d66c4c43$export$f84374c9369ae887 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    position: {
        type: String,
        validator: /* istanbul ignore next */ function(v) {
            return $e95b1c16d66c4c43$var$positionValues.includes(v);
        }
    }
}, 'position');
function $e95b1c16d66c4c43$export$8169801eda3f797f(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var positionClasses = (0, $hXmfK.toRef)(function() {
        return props.position ? "".concat(name, "--").concat(props.position) : undefined;
    });
    return {
        positionClasses: positionClasses
    };
}



// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

function $f0fd6b0b61967e91$export$3f79f0b98112cf57() {
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useRoute');
    return (0, $hXmfK.computed)(function() {
        var _vm_proxy;
        return vm === null || vm === void 0 ? void 0 : (_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : _vm_proxy.$route;
    });
}
function $f0fd6b0b61967e91$export$9a302a45f65d0572() {
    var _getCurrentInstance_proxy, _getCurrentInstance;
    return (_getCurrentInstance = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useRouter')) === null || _getCurrentInstance === void 0 ? void 0 : (_getCurrentInstance_proxy = _getCurrentInstance.proxy) === null || _getCurrentInstance_proxy === void 0 ? void 0 : _getCurrentInstance_proxy.$router;
}
function $f0fd6b0b61967e91$export$dcf14c9974fe2767(props, attrs) {
    var _link_value, _link_value1;
    var RouterLink = (0, $bu8yf.resolveDynamicComponent)('RouterLink');
    var isLink = (0, $hXmfK.toRef)(function() {
        return !!(props.href || props.to);
    });
    var isClickable = (0, $hXmfK.computed)(function() {
        return (isLink === null || isLink === void 0 ? void 0 : isLink.value) || (0, $31779689cfd5da50$export$1f08a0593c4a067d)(attrs, 'click') || (0, $31779689cfd5da50$export$1f08a0593c4a067d)(props, 'click');
    });
    if (typeof RouterLink === 'string' || !('useLink' in RouterLink)) {
        var href = (0, $hXmfK.toRef)(function() {
            return props.href;
        });
        return {
            isLink: isLink,
            isClickable: isClickable,
            href: href,
            linkProps: (0, $hXmfK.reactive)({
                href: href
            })
        };
    }
    // vue-router useLink `to` prop needs to be reactive and useLink will crash if undefined
    var routerLink = RouterLink.useLink({
        to: (0, $hXmfK.toRef)(function() {
            return props.to || '';
        }),
        replace: (0, $hXmfK.toRef)(function() {
            return props.replace;
        })
    });
    // Actual link needs to be undefined when to prop is not used
    var link = (0, $hXmfK.computed)(function() {
        return props.to ? routerLink : undefined;
    });
    var route = $f0fd6b0b61967e91$export$3f79f0b98112cf57();
    var isActive = (0, $hXmfK.computed)(function() {
        var _link_value_isActive, _link_value_isExactActive, _link_value_isExactActive1;
        if (!link.value) return false;
        var _link_value_isActive_value;
        if (!props.exact) return (_link_value_isActive_value = (_link_value_isActive = link.value.isActive) === null || _link_value_isActive === void 0 ? void 0 : _link_value_isActive.value) !== null && _link_value_isActive_value !== void 0 ? _link_value_isActive_value : false;
        var _link_value_isExactActive_value;
        if (!route.value) return (_link_value_isExactActive_value = (_link_value_isExactActive = link.value.isExactActive) === null || _link_value_isExactActive === void 0 ? void 0 : _link_value_isExactActive.value) !== null && _link_value_isExactActive_value !== void 0 ? _link_value_isExactActive_value : false;
        return ((_link_value_isExactActive1 = link.value.isExactActive) === null || _link_value_isExactActive1 === void 0 ? void 0 : _link_value_isExactActive1.value) && (0, $31779689cfd5da50$export$9cb4719e2e525b7a)(link.value.route.value.query, route.value.query);
    });
    var href1 = (0, $hXmfK.computed)(function() {
        var _link_value;
        return props.to ? (_link_value = link.value) === null || _link_value === void 0 ? void 0 : _link_value.route.value.href : props.href;
    });
    return {
        isLink: isLink,
        isClickable: isClickable,
        isActive: isActive,
        route: (_link_value = link.value) === null || _link_value === void 0 ? void 0 : _link_value.route,
        navigate: (_link_value1 = link.value) === null || _link_value1 === void 0 ? void 0 : _link_value1.navigate,
        href: href1,
        linkProps: (0, $hXmfK.reactive)({
            href: href1,
            'aria-current': (0, $hXmfK.toRef)(function() {
                return isActive.value ? 'page' : undefined;
            })
        })
    };
}
var $f0fd6b0b61967e91$export$78d5db5e8f9b041d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    href: String,
    replace: Boolean,
    to: [
        String,
        Object
    ],
    exact: Boolean
}, 'router');
var $f0fd6b0b61967e91$var$inTransition = false;
function $f0fd6b0b61967e91$export$a519bdc484beda0(router, cb) {
    var popped = false;
    var removeBefore;
    var removeAfter;
    if ((0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && (router === null || router === void 0 ? void 0 : router.beforeEach)) {
        (0, $bu8yf.nextTick)(function() {
            window.addEventListener('popstate', onPopstate);
            removeBefore = router.beforeEach(function(to, from, next) {
                if (!$f0fd6b0b61967e91$var$inTransition) setTimeout(function() {
                    return popped ? cb(next) : next();
                });
                else popped ? cb(next) : next();
                $f0fd6b0b61967e91$var$inTransition = true;
            });
            removeAfter = router === null || router === void 0 ? void 0 : router.afterEach(function() {
                $f0fd6b0b61967e91$var$inTransition = false;
            });
        });
        (0, $hXmfK.onScopeDispose)(function() {
            window.removeEventListener('popstate', onPopstate);
            removeBefore === null || removeBefore === void 0 ? void 0 : removeBefore();
            removeAfter === null || removeAfter === void 0 ? void 0 : removeAfter();
        });
    }
    function onPopstate(e) {
        var _e_state;
        if ((_e_state = e.state) === null || _e_state === void 0 ? void 0 : _e_state.replaced) return;
        popped = true;
        setTimeout(function() {
            return popped = false;
        });
    }
}


// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");
function $e610dfb4f349ac2d$export$549d64cb44cfc0cc(link, select) {
    (0, $hXmfK.watch)(function() {
        var _link_isActive;
        return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
    }, function(isActive) {
        if (link.isLink.value && isActive != null && select) (0, $bu8yf.nextTick)(function() {
            select(isActive);
        });
    }, {
        immediate: true
    });
}






// Styles


var $df056000f2fe99f7$var$stopSymbol = Symbol('rippleStop');
var $df056000f2fe99f7$var$DELAY_RIPPLE = 80;
function $df056000f2fe99f7$var$transform(el, value) {
    el.style.transform = value;
    el.style.webkitTransform = value;
}
function $df056000f2fe99f7$var$isTouchEvent(e) {
    return e.constructor.name === 'TouchEvent';
}
function $df056000f2fe99f7$var$isKeyboardEvent(e) {
    return e.constructor.name === 'KeyboardEvent';
}
var $df056000f2fe99f7$var$calculate = function calculate(e, el) {
    var _el__ripple;
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var localX = 0;
    var localY = 0;
    if (!$df056000f2fe99f7$var$isKeyboardEvent(e)) {
        var offset = el.getBoundingClientRect();
        var target = $df056000f2fe99f7$var$isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
        localX = target.clientX - offset.left;
        localY = target.clientY - offset.top;
    }
    var radius = 0;
    var scale = 0.3;
    if ((_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.circle) {
        scale = 0.15;
        radius = el.clientWidth / 2;
        radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
    } else radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
    var centerX = "".concat((el.clientWidth - radius * 2) / 2, "px");
    var centerY = "".concat((el.clientHeight - radius * 2) / 2, "px");
    var x = value.center ? centerX : "".concat(localX - radius, "px");
    var y = value.center ? centerY : "".concat(localY - radius, "px");
    return {
        radius: radius,
        scale: scale,
        x: x,
        y: y,
        centerX: centerX,
        centerY: centerY
    };
};
var $df056000f2fe99f7$var$ripples = {
    /* eslint-disable max-statements */ show: function(e, el) {
        var _el__ripple;
        var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!(el === null || el === void 0 ? void 0 : (_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.enabled)) return;
        var container = document.createElement('span');
        var animation = document.createElement('span');
        container.appendChild(animation);
        container.className = 'v-ripple__container';
        if (value["class"]) container.className += " ".concat(value["class"]);
        var _calculate = $df056000f2fe99f7$var$calculate(e, el, value), radius = _calculate.radius, scale = _calculate.scale, x = _calculate.x, y = _calculate.y, centerX = _calculate.centerX, centerY = _calculate.centerY;
        var size = "".concat(radius * 2, "px");
        animation.className = 'v-ripple__animation';
        animation.style.width = size;
        animation.style.height = size;
        el.appendChild(container);
        var computed = window.getComputedStyle(el);
        if (computed && computed.position === 'static') {
            el.style.position = 'relative';
            el.dataset.previousPosition = 'static';
        }
        animation.classList.add('v-ripple__animation--enter');
        animation.classList.add('v-ripple__animation--visible');
        $df056000f2fe99f7$var$transform(animation, "translate(".concat(x, ", ").concat(y, ") scale3d(").concat(scale, ",").concat(scale, ",").concat(scale, ")"));
        animation.dataset.activated = String(performance.now());
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                animation.classList.remove('v-ripple__animation--enter');
                animation.classList.add('v-ripple__animation--in');
                $df056000f2fe99f7$var$transform(animation, "translate(".concat(centerX, ", ").concat(centerY, ") scale3d(1,1,1)"));
            });
        });
    },
    hide: function(el) {
        var _el__ripple;
        if (!(el === null || el === void 0 ? void 0 : (_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.enabled)) return;
        var ripples = el.getElementsByClassName('v-ripple__animation');
        if (ripples.length === 0) return;
        var animation = ripples[ripples.length - 1];
        if (animation.dataset.isHiding) return;
        else animation.dataset.isHiding = 'true';
        var diff = performance.now() - Number(animation.dataset.activated);
        var delay = Math.max(250 - diff, 0);
        setTimeout(function() {
            animation.classList.remove('v-ripple__animation--in');
            animation.classList.add('v-ripple__animation--out');
            setTimeout(function() {
                var _animation_parentNode;
                var ripples = el.getElementsByClassName('v-ripple__animation');
                if (ripples.length === 1 && el.dataset.previousPosition) {
                    el.style.position = el.dataset.previousPosition;
                    delete el.dataset.previousPosition;
                }
                if (((_animation_parentNode = animation.parentNode) === null || _animation_parentNode === void 0 ? void 0 : _animation_parentNode.parentNode) === el) el.removeChild(animation.parentNode);
            }, 300);
        }, delay);
    }
};
function $df056000f2fe99f7$var$isRippleEnabled(value) {
    return typeof value === 'undefined' || !!value;
}
function $df056000f2fe99f7$var$rippleShow(e) {
    var value = {};
    var element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple) || element._ripple.touched || e[$df056000f2fe99f7$var$stopSymbol]) return;
    // Don't allow the event to trigger ripples on any other elements
    e[$df056000f2fe99f7$var$stopSymbol] = true;
    if ($df056000f2fe99f7$var$isTouchEvent(e)) {
        element._ripple.touched = true;
        element._ripple.isTouch = true;
    } else {
        // It's possible for touch events to fire
        // as mouse events on Android/iOS, this
        // will skip the event call if it has
        // already been registered as touch
        if (element._ripple.isTouch) return;
    }
    value.center = element._ripple.centered || $df056000f2fe99f7$var$isKeyboardEvent(e);
    if (element._ripple["class"]) value["class"] = element._ripple["class"];
    if ($df056000f2fe99f7$var$isTouchEvent(e)) {
        // already queued that shows or hides the ripple
        if (element._ripple.showTimerCommit) return;
        element._ripple.showTimerCommit = function() {
            $df056000f2fe99f7$var$ripples.show(e, element, value);
        };
        element._ripple.showTimer = window.setTimeout(function() {
            var _element__ripple;
            if (element === null || element === void 0 ? void 0 : (_element__ripple = element._ripple) === null || _element__ripple === void 0 ? void 0 : _element__ripple.showTimerCommit) {
                element._ripple.showTimerCommit();
                element._ripple.showTimerCommit = null;
            }
        }, $df056000f2fe99f7$var$DELAY_RIPPLE);
    } else $df056000f2fe99f7$var$ripples.show(e, element, value);
}
function $df056000f2fe99f7$var$rippleStop(e) {
    e[$df056000f2fe99f7$var$stopSymbol] = true;
}
function $df056000f2fe99f7$var$rippleHide(e) {
    var element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple)) return;
    window.clearTimeout(element._ripple.showTimer);
    // The touch interaction occurs before the show timer is triggered.
    // We still want to show ripple effect.
    if (e.type === 'touchend' && element._ripple.showTimerCommit) {
        element._ripple.showTimerCommit();
        element._ripple.showTimerCommit = null;
        // re-queue ripple hiding
        element._ripple.showTimer = window.setTimeout(function() {
            $df056000f2fe99f7$var$rippleHide(e);
        });
        return;
    }
    window.setTimeout(function() {
        if (element._ripple) element._ripple.touched = false;
    });
    $df056000f2fe99f7$var$ripples.hide(element);
}
function $df056000f2fe99f7$var$rippleCancelShow(e) {
    var element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple)) return;
    if (element._ripple.showTimerCommit) element._ripple.showTimerCommit = null;
    window.clearTimeout(element._ripple.showTimer);
}
var $df056000f2fe99f7$var$keyboardRipple = false;
function $df056000f2fe99f7$var$keyboardRippleShow(e, keys) {
    if (!$df056000f2fe99f7$var$keyboardRipple && keys.includes(e.key)) {
        $df056000f2fe99f7$var$keyboardRipple = true;
        $df056000f2fe99f7$var$rippleShow(e);
    }
}
function $df056000f2fe99f7$var$keyboardRippleHide(e) {
    $df056000f2fe99f7$var$keyboardRipple = false;
    $df056000f2fe99f7$var$rippleHide(e);
}
function $df056000f2fe99f7$var$focusRippleHide(e) {
    if ($df056000f2fe99f7$var$keyboardRipple) {
        $df056000f2fe99f7$var$keyboardRipple = false;
        $df056000f2fe99f7$var$rippleHide(e);
    }
}
function $df056000f2fe99f7$var$updateRipple(el, binding, wasEnabled) {
    var value = binding.value, modifiers = binding.modifiers;
    var enabled = $df056000f2fe99f7$var$isRippleEnabled(value);
    if (!enabled) $df056000f2fe99f7$var$ripples.hide(el);
    var _el__ripple;
    el._ripple = (_el__ripple = el._ripple) !== null && _el__ripple !== void 0 ? _el__ripple : {};
    el._ripple.enabled = enabled;
    el._ripple.centered = modifiers.center;
    el._ripple.circle = modifiers.circle;
    var bindingValue = (0, $31779689cfd5da50$export$a6cdc56e425d0d0a)(value) ? value : {};
    if (bindingValue["class"]) el._ripple["class"] = bindingValue["class"];
    var _bindingValue_keys;
    var allowedKeys = (_bindingValue_keys = bindingValue.keys) !== null && _bindingValue_keys !== void 0 ? _bindingValue_keys : [
        'Enter',
        'Space'
    ];
    el._ripple.keyDownHandler = function(e) {
        return $df056000f2fe99f7$var$keyboardRippleShow(e, allowedKeys);
    };
    if (enabled && !wasEnabled) {
        if (modifiers.stop) {
            el.addEventListener('touchstart', $df056000f2fe99f7$var$rippleStop, {
                passive: true
            });
            el.addEventListener('mousedown', $df056000f2fe99f7$var$rippleStop);
            return;
        }
        el.addEventListener('touchstart', $df056000f2fe99f7$var$rippleShow, {
            passive: true
        });
        el.addEventListener('touchend', $df056000f2fe99f7$var$rippleHide, {
            passive: true
        });
        el.addEventListener('touchmove', $df056000f2fe99f7$var$rippleCancelShow, {
            passive: true
        });
        el.addEventListener('touchcancel', $df056000f2fe99f7$var$rippleHide);
        el.addEventListener('mousedown', $df056000f2fe99f7$var$rippleShow);
        el.addEventListener('mouseup', $df056000f2fe99f7$var$rippleHide);
        el.addEventListener('mouseleave', $df056000f2fe99f7$var$rippleHide);
        el.addEventListener('keydown', function(e) {
            return $df056000f2fe99f7$var$keyboardRippleShow(e, allowedKeys);
        });
        el.addEventListener('keyup', $df056000f2fe99f7$var$keyboardRippleHide);
        el.addEventListener('blur', $df056000f2fe99f7$var$focusRippleHide);
        // Anchor tags can be dragged, causes other hides to fail - #1537
        el.addEventListener('dragstart', $df056000f2fe99f7$var$rippleHide, {
            passive: true
        });
    } else if (!enabled && wasEnabled) $df056000f2fe99f7$var$removeListeners(el);
}
function $df056000f2fe99f7$var$removeListeners(el) {
    var _el__ripple;
    el.removeEventListener('mousedown', $df056000f2fe99f7$var$rippleShow);
    el.removeEventListener('touchstart', $df056000f2fe99f7$var$rippleShow);
    el.removeEventListener('touchend', $df056000f2fe99f7$var$rippleHide);
    el.removeEventListener('touchmove', $df056000f2fe99f7$var$rippleCancelShow);
    el.removeEventListener('touchcancel', $df056000f2fe99f7$var$rippleHide);
    el.removeEventListener('mouseup', $df056000f2fe99f7$var$rippleHide);
    el.removeEventListener('mouseleave', $df056000f2fe99f7$var$rippleHide);
    if ((_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.keyDownHandler) el.removeEventListener('keydown', el._ripple.keyDownHandler);
    el.removeEventListener('keyup', $df056000f2fe99f7$var$keyboardRippleHide);
    el.removeEventListener('dragstart', $df056000f2fe99f7$var$rippleHide);
    el.removeEventListener('blur', $df056000f2fe99f7$var$focusRippleHide);
}
function $df056000f2fe99f7$var$mounted(el, binding) {
    $df056000f2fe99f7$var$updateRipple(el, binding, false);
}
function $df056000f2fe99f7$var$unmounted(el) {
    $df056000f2fe99f7$var$removeListeners(el);
    delete el._ripple;
}
function $df056000f2fe99f7$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    var wasEnabled = $df056000f2fe99f7$var$isRippleEnabled(binding.oldValue);
    $df056000f2fe99f7$var$updateRipple(el, binding, wasEnabled);
}
var $df056000f2fe99f7$export$9e9146f7e027fdaa = {
    mounted: $df056000f2fe99f7$var$mounted,
    unmounted: $df056000f2fe99f7$var$unmounted,
    updated: $df056000f2fe99f7$var$updated
};
var $df056000f2fe99f7$export$2e2bcd8739ae039 = $df056000f2fe99f7$export$9e9146f7e027fdaa;



var $9603829334ed7471$export$64daea74540bd34d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    active: {
        type: Boolean,
        "default": undefined
    },
    activeColor: String,
    baseColor: String,
    symbol: {
        type: null,
        "default": (0, $03c8359f84f50d85$export$7ccf67e9366faa19)
    },
    flat: Boolean,
    icon: [
        Boolean,
        String,
        Function,
        Object
    ],
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    block: Boolean,
    readonly: Boolean,
    slim: Boolean,
    stacked: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    }
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $073309bf395585eb$export$e9e3b570044587e8)(), (0, $de59c43ac78c3e7a$export$149f04e0cba4dbc1)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $f0fd6b0b61967e91$export$78d5db5e8f9b041d)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'button'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'elevated'
})), 'VBtn');
var $9603829334ed7471$export$657f28cf887b91a6 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBtn',
    props: $9603829334ed7471$export$64daea74540bd34d(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var loaderClasses = (0, $de59c43ac78c3e7a$export$14095de704efe3f9)(props).loaderClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useSize = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props), sizeClasses = _useSize.sizeClasses, sizeStyles = _useSize.sizeStyles;
        var group = (0, $073309bf395585eb$export$eebde8160f061c26)(props, props.symbol, false);
        var link = (0, $f0fd6b0b61967e91$export$dcf14c9974fe2767)(props, attrs);
        var isActive = (0, $hXmfK.computed)(function() {
            var _link_isActive;
            if (props.active !== undefined) return props.active;
            if (link.isLink.value) return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
            return group === null || group === void 0 ? void 0 : group.isSelected.value;
        });
        var color = (0, $hXmfK.toRef)(function() {
            var _props_activeColor;
            return isActive.value ? (_props_activeColor = props.activeColor) !== null && _props_activeColor !== void 0 ? _props_activeColor : props.color : props.color;
        });
        var variantProps = (0, $hXmfK.computed)(function() {
            var _link_isActive, _link_isActive1;
            var showColor = (group === null || group === void 0 ? void 0 : group.isSelected.value) && (!link.isLink.value || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value)) || !group || ((_link_isActive1 = link.isActive) === null || _link_isActive1 === void 0 ? void 0 : _link_isActive1.value);
            var _color_value;
            return {
                color: showColor ? (_color_value = color.value) !== null && _color_value !== void 0 ? _color_value : props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(variantProps), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var isDisabled = (0, $hXmfK.computed)(function() {
            return (group === null || group === void 0 ? void 0 : group.disabled.value) || props.disabled;
        });
        var isElevated = (0, $hXmfK.toRef)(function() {
            return props.variant === 'elevated' && !(props.disabled || props.flat || props.border);
        });
        var valueAttr = (0, $hXmfK.computed)(function() {
            if (props.value === undefined || (0, $3KZcf._)(props.value) === 'symbol') return undefined;
            return Object(props.value) === props.value ? JSON.stringify(props.value, null, 0) : props.value;
        });
        function onClick(e) {
            var _link_navigate;
            if (isDisabled.value || link.isLink.value && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || attrs.target === '_blank')) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            group === null || group === void 0 ? void 0 : group.toggle();
        }
        (0, $e610dfb4f349ac2d$export$549d64cb44cfc0cc)(link, group === null || group === void 0 ? void 0 : group.select);
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var Tag = link.isLink.value ? 'a' : props.tag;
            var hasPrepend = !!(props.prependIcon || slots.prepend);
            var hasAppend = !!(props.appendIcon || slots.append);
            var hasIcon = !!(props.icon && props.icon !== true);
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(Tag, (0, $bu8yf.mergeProps)({
                type: Tag === 'a' ? undefined : 'button',
                "class": [
                    'v-btn',
                    group === null || group === void 0 ? void 0 : group.selectedClass.value,
                    {
                        'v-btn--active': isActive.value,
                        'v-btn--block': props.block,
                        'v-btn--disabled': isDisabled.value,
                        'v-btn--elevated': isElevated.value,
                        'v-btn--flat': props.flat,
                        'v-btn--icon': !!props.icon,
                        'v-btn--loading': props.loading,
                        'v-btn--readonly': props.readonly,
                        'v-btn--slim': props.slim,
                        'v-btn--stacked': props.stacked
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props["class"]
                ],
                style: [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    sizeStyles.value,
                    props.style
                ],
                "aria-busy": props.loading ? true : undefined,
                disabled: isDisabled.value || undefined,
                tabindex: props.loading || props.readonly ? -1 : undefined,
                onClick: onClick,
                value: valueAttr.value
            }, link.linkProps), {
                "default": function() {
                    var _slots_loader;
                    var _slots_loader1;
                    return [
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(true, 'v-btn'),
                        !props.icon && hasPrepend && (0, $bu8yf.createElementVNode)("span", {
                            key: "prepend",
                            "class": "v-btn__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "prepend-icon",
                                icon: props.prependIcon
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !props.prependIcon,
                                defaults: {
                                    VIcon: {
                                        icon: props.prependIcon
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $bu8yf.createElementVNode)("span", {
                            "class": "v-btn__content",
                            "data-no-activator": ""
                        }, [
                            !slots["default"] && hasIcon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "content-icon",
                                icon: props.icon
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "content-defaults",
                                disabled: !hasIcon,
                                defaults: {
                                    VIcon: {
                                        icon: props.icon
                                    }
                                }
                            }, {
                                "default": function() {
                                    var _slots_default;
                                    var _slots_default1;
                                    return [
                                        (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $d8jBh.toDisplayString)(props.text)
                                    ];
                                }
                            })
                        ]),
                        !props.icon && hasAppend && (0, $bu8yf.createElementVNode)("span", {
                            key: "append",
                            "class": "v-btn__append"
                        }, [
                            !slots.append ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "append-icon",
                                icon: props.appendIcon
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "append-defaults",
                                disabled: !props.appendIcon,
                                defaults: {
                                    VIcon: {
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        !!props.loading && (0, $bu8yf.createElementVNode)("span", {
                            key: "loader",
                            "class": "v-btn__loader"
                        }, [
                            (_slots_loader1 = (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots)) !== null && _slots_loader1 !== void 0 ? _slots_loader1 : (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                                color: typeof props.loading === 'boolean' ? undefined : props.loading,
                                indeterminate: true,
                                width: "2"
                            }, null)
                        ])
                    ];
                }
            }), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    !isDisabled.value && props.ripple,
                    '',
                    {
                        center: !!props.icon
                    }
                ]
            ]);
        });
        return {
            group: group
        };
    }
});



var $23c0aeb902f05449$export$d185179e2c3c040b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $9603829334ed7471$export$64daea74540bd34d)({
    icon: '$menu',
    variant: 'text'
})), 'VAppBarNavIcon');
var $23c0aeb902f05449$export$692fce24359c3843 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAppBarNavIcon',
    props: $23c0aeb902f05449$export$d185179e2c3c040b(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)(props, {
                "class": [
                    'v-app-bar-nav-icon'
                ]
            }), slots);
        });
        return {};
    }
});


parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $2cc7bd3b55073ce8$export$657ba4c199549e9b = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAppBarTitle',
    props: (0, $f849e9bc71871807$export$6afad7cb17124872)(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $f849e9bc71871807$export$deaeca9428bfc9a4), (0, $bu8yf.mergeProps)(props, {
                "class": "v-app-bar-title"
            }), slots);
        });
        return {};
    }
});




var $2397b8a0edf5de7c$exports = {};

$parcel$export($2397b8a0edf5de7c$exports, "VAlert", function () { return $c8ad5c6686c397ef$export$8eebf457c668f05a; });
$parcel$export($2397b8a0edf5de7c$exports, "VAlertTitle", function () { return $25a5a53d95dae65f$export$628ef577672e443a; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");

// Utilities
// Composables

var $iT0je = parcelRequire("iT0je");

parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
var $bu8yf = parcelRequire("bu8yf");

function $f99f72eb23daee55$export$b3680ae2c271b9f3(klass) {
    var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    var name = arguments.length > 2 ? arguments[2] : undefined;
    return (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
        name: name !== null && name !== void 0 ? name : (0, $d8jBh.capitalize)((0, $d8jBh.camelize)(klass.replace(/__/g, '-'))),
        props: (0, $iT0je._)({
            tag: {
                type: String,
                "default": tag
            }
        }, (0, $2b50544a76f0a26e$export$d271552babda0448)()),
        setup: function(props, _ref) {
            var slots = _ref.slots;
            return function() {
                var _slots_default;
                return (0, $bu8yf.h)(props.tag, {
                    "class": [
                        klass,
                        props["class"]
                    ],
                    style: props.style
                }, (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
            };
        }
    });
}


var $25a5a53d95dae65f$export$628ef577672e443a = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-alert-title');











// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $10e4d42c07e401b6$export$32a89e97443766e5 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    iconSize: [
        Number,
        String
    ],
    iconSizes: {
        type: Array,
        "default": function() {
            return [
                [
                    'x-small',
                    10
                ],
                [
                    'small',
                    16
                ],
                [
                    'default',
                    24
                ],
                [
                    'large',
                    28
                ],
                [
                    'x-large',
                    32
                ]
            ];
        }
    }
}, 'iconSize');
function $10e4d42c07e401b6$export$d456a6cf49d1aad6(props, fallback) {
    var iconSize = (0, $hXmfK.computed)(function() {
        var iconSizeMap = new Map(props.iconSizes);
        var _props_iconSize, _ref;
        var _iconSize = (_ref = (_props_iconSize = props.iconSize) !== null && _props_iconSize !== void 0 ? _props_iconSize : fallback()) !== null && _ref !== void 0 ? _ref : 'default';
        return iconSizeMap.has(_iconSize) ? iconSizeMap.get(_iconSize) : _iconSize;
    });
    return {
        iconSize: iconSize
    };
}











var $c8ad5c6686c397ef$var$allowedTypes = [
    'success',
    'info',
    'warning',
    'error'
];
var $c8ad5c6686c397ef$export$d79b2456dccb8959 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    border: {
        type: [
            Boolean,
            String
        ],
        validator: function(val) {
            return typeof val === 'boolean' || [
                'top',
                'end',
                'bottom',
                'start'
            ].includes(val);
        }
    },
    borderColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$close'
    },
    closeLabel: {
        type: String,
        "default": '$vuetify.close'
    },
    icon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        "default": null
    },
    modelValue: {
        type: Boolean,
        "default": true
    },
    prominent: Boolean,
    title: String,
    text: String,
    type: {
        type: String,
        validator: function(val) {
            return $c8ad5c6686c397ef$var$allowedTypes.includes(val);
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $10e4d42c07e401b6$export$32a89e97443766e5)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'flat'
})), 'VAlert');
var $c8ad5c6686c397ef$export$8eebf457c668f05a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAlert',
    props: $c8ad5c6686c397ef$export$d79b2456dccb8959(),
    emits: {
        'click:close': function(e) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var icon = (0, $hXmfK.toRef)(function() {
            if (props.icon === false) return undefined;
            if (!props.type) return props.icon;
            var _props_icon;
            return (_props_icon = props.icon) !== null && _props_icon !== void 0 ? _props_icon : "$".concat(props.type);
        });
        var iconSize = (0, $10e4d42c07e401b6$export$d456a6cf49d1aad6)(props, function() {
            return props.prominent ? 44 : 28;
        }).iconSize;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(function() {
            var _props_color;
            return {
                color: (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.type,
                variant: props.variant
            };
        }), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.borderColor;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var closeProps = (0, $hXmfK.toRef)(function() {
            return {
                'aria-label': t(props.closeLabel),
                onClick: function(e) {
                    isActive.value = false;
                    emit('click:close', e);
                }
            };
        });
        return function() {
            var hasPrepend = !!(slots.prepend || icon.value);
            var hasTitle = !!(slots.title || props.title);
            var hasClose = !!(slots.close || props.closable);
            var iconProps = {
                density: props.density,
                icon: icon.value,
                size: iconSize.value
            };
            return isActive.value && (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-alert',
                    props.border && (0, $cqEAj._)({
                        'v-alert--border': !!props.border
                    }, "v-alert--border-".concat(props.border === true ? 'start' : props.border), true),
                    {
                        'v-alert--prominent': props.prominent
                    },
                    themeClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                role: "alert"
            }, {
                "default": function() {
                    var _slots_text, _slots_default;
                    var _slots_text1;
                    return [
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(false, 'v-alert'),
                        props.border && (0, $bu8yf.createElementVNode)("div", {
                            key: "border",
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-alert__border',
                                textColorClasses.value
                            ]),
                            style: (0, $d8jBh.normalizeStyle)(textColorStyles.value)
                        }, null),
                        hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                            key: "prepend",
                            "class": "v-alert__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), (0, $bu8yf.mergeProps)({
                                key: "prepend-icon"
                            }, iconProps), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !icon.value,
                                defaults: {
                                    VIcon: (0, $iT0je._)({}, iconProps)
                                }
                            }, slots.prepend)
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-alert__content"
                        }, [
                            hasTitle && (0, $bu8yf.createVNode)((0, $25a5a53d95dae65f$export$628ef577672e443a), {
                                key: "title"
                            }, {
                                "default": function() {
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                                    ];
                                }
                            }),
                            (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text,
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.append && (0, $bu8yf.createElementVNode)("div", {
                            key: "append",
                            "class": "v-alert__append"
                        }, [
                            slots.append()
                        ]),
                        hasClose && (0, $bu8yf.createElementVNode)("div", {
                            key: "close",
                            "class": "v-alert__close"
                        }, [
                            !slots.close ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                key: "close-btn",
                                icon: props.closeIcon,
                                size: "x-small",
                                variant: "text"
                            }, closeProps.value), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "close-defaults",
                                defaults: {
                                    VBtn: {
                                        icon: props.closeIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                }
                            }, {
                                "default": function() {
                                    var _slots_close;
                                    return [
                                        (_slots_close = slots.close) === null || _slots_close === void 0 ? void 0 : _slots_close.call(slots, {
                                            props: closeProps.value
                                        })
                                    ];
                                }
                            })
                        ])
                    ];
                }
            });
        };
    }
});





var $15eb18a00c80d90b$exports = {};

$parcel$export($15eb18a00c80d90b$exports, "VAutocomplete", function () { return $49d350329fe17d0a$export$4fa8d945b1b14087; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");














var $1991d2d9d165718c$export$c5e97f606ca9e65c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    start: Boolean,
    end: Boolean,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    image: String,
    text: String
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'flat'
})), 'VAvatar');
var $1991d2d9d165718c$export$dbee61bc703cd5ff = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAvatar',
    props: $1991d2d9d165718c$export$c5e97f606ca9e65c(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(props), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useSize = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props), sizeClasses = _useSize.sizeClasses, sizeStyles = _useSize.sizeStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-avatar',
                    {
                        'v-avatar--start': props.start,
                        'v-avatar--end': props.end
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    colorStyles.value,
                    sizeStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        !slots["default"] ? props.image ? (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                            key: "image",
                            src: props.image,
                            alt: "",
                            cover: true
                        }, null) : props.icon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "icon",
                            icon: props.icon
                        }, null) : props.text : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            key: "content-defaults",
                            defaults: {
                                VImg: {
                                    cover: true,
                                    src: props.image
                                },
                                VIcon: {
                                    icon: props.icon
                                }
                            }
                        }, {
                            "default": function() {
                                return [
                                    slots["default"]()
                                ];
                            }
                        }),
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(false, 'v-avatar')
                    ];
                }
            });
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $6c6f579f4011d0f0$export$87bbab332de32d3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    text: String,
    onClick: (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VLabel');
var $6c6f579f4011d0f0$export$90281af35207eb21 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VLabel',
    props: $6c6f579f4011d0f0$export$87bbab332de32d3(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("label", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-label',
                    {
                        'v-label--clickable': !!props.onClick
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                onClick: props.onClick
            }, [
                props.text,
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");








var $12549b94af1799f2$export$dc483627378c8c37 = Symbol["for"]('vuetify:selection-control-group');
var $12549b94af1799f2$export$f6307c62fd1b0ce3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    disabled: {
        type: Boolean,
        "default": null
    },
    defaultsTarget: String,
    error: Boolean,
    id: String,
    inline: Boolean,
    falseIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    trueIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    multiple: {
        type: Boolean,
        "default": null
    },
    name: String,
    readonly: {
        type: Boolean,
        "default": null
    },
    modelValue: null,
    type: String,
    valueComparator: {
        type: Function,
        "default": (0, $31779689cfd5da50$export$9cb4719e2e525b7a)
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'SelectionControlGroup');
var $12549b94af1799f2$export$859877846b10e869 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, $12549b94af1799f2$export$f6307c62fd1b0ce3({
    defaultsTarget: 'VSelectionControl'
})), 'VSelectionControlGroup');
var $12549b94af1799f2$export$fbaa479cb0704980 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSelectionControlGroup',
    props: $12549b94af1799f2$export$859877846b10e869(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var modelValue = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.toRef)(function() {
            return props.id || "v-selection-control-group-".concat(uid);
        });
        var name = (0, $hXmfK.toRef)(function() {
            return props.name || id.value;
        });
        var updateHandlers = new Set();
        (0, $bu8yf.provide)($12549b94af1799f2$export$dc483627378c8c37, {
            modelValue: modelValue,
            forceUpdate: function() {
                updateHandlers.forEach(function(fn) {
                    return fn();
                });
            },
            onForceUpdate: function(cb) {
                updateHandlers.add(cb);
                (0, $hXmfK.onScopeDispose)(function() {
                    updateHandlers["delete"](cb);
                });
            }
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)((0, $cqEAj._)({}, props.defaultsTarget, {
            color: (0, $hXmfK.toRef)(function() {
                return props.color;
            }),
            disabled: (0, $hXmfK.toRef)(function() {
                return props.disabled;
            }),
            density: (0, $hXmfK.toRef)(function() {
                return props.density;
            }),
            error: (0, $hXmfK.toRef)(function() {
                return props.error;
            }),
            inline: (0, $hXmfK.toRef)(function() {
                return props.inline;
            }),
            modelValue: modelValue,
            multiple: (0, $hXmfK.toRef)(function() {
                return !!props.multiple || props.multiple == null && Array.isArray(modelValue.value);
            }),
            name: name,
            falseIcon: (0, $hXmfK.toRef)(function() {
                return props.falseIcon;
            }),
            trueIcon: (0, $hXmfK.toRef)(function() {
                return props.trueIcon;
            }),
            readonly: (0, $hXmfK.toRef)(function() {
                return props.readonly;
            }),
            ripple: (0, $hXmfK.toRef)(function() {
                return props.ripple;
            }),
            type: (0, $hXmfK.toRef)(function() {
                return props.type;
            }),
            valueComparator: (0, $hXmfK.toRef)(function() {
                return props.valueComparator;
            })
        }));
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-selection-control-group',
                    {
                        'v-selection-control-group--inline': props.inline
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                role: props.type === 'radio' ? 'radiogroup' : undefined
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});








var $1fb46ce89e6b4a77$export$a15300eeb449da9c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    label: String,
    baseColor: String,
    trueValue: null,
    falseValue: null,
    value: null
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $12549b94af1799f2$export$f6307c62fd1b0ce3)()), 'VSelectionControl');
function $1fb46ce89e6b4a77$export$d7418bbd9b6d5f0c(props) {
    var group = (0, $bu8yf.inject)((0, $12549b94af1799f2$export$dc483627378c8c37), undefined);
    var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
    var modelValue = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
    var trueValue = (0, $hXmfK.computed)(function() {
        return props.trueValue !== undefined ? props.trueValue : props.value !== undefined ? props.value : true;
    });
    var falseValue = (0, $hXmfK.computed)(function() {
        return props.falseValue !== undefined ? props.falseValue : false;
    });
    var isMultiple = (0, $hXmfK.computed)(function() {
        return !!props.multiple || props.multiple == null && Array.isArray(modelValue.value);
    });
    var model = (0, $hXmfK.computed)({
        get: function() {
            var val = group ? group.modelValue.value : modelValue.value;
            return isMultiple.value ? (0, $31779689cfd5da50$export$76411cac38121ecb)(val).some(function(v) {
                return props.valueComparator(v, trueValue.value);
            }) : props.valueComparator(val, trueValue.value);
        },
        set: function(val) {
            if (props.readonly) return;
            var currentValue = val ? trueValue.value : falseValue.value;
            var newVal = currentValue;
            if (isMultiple.value) newVal = val ? (0, $7WNf6._)((0, $31779689cfd5da50$export$76411cac38121ecb)(modelValue.value)).concat([
                currentValue
            ]) : (0, $31779689cfd5da50$export$76411cac38121ecb)(modelValue.value).filter(function(item) {
                return !props.valueComparator(item, trueValue.value);
            });
            if (group) group.modelValue.value = newVal;
            else modelValue.value = newVal;
        }
    });
    var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
        if (props.error || props.disabled) return undefined;
        return model.value ? props.color : props.baseColor;
    }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
    var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
        return model.value && !props.error && !props.disabled ? props.color : props.baseColor;
    }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
    var icon = (0, $hXmfK.computed)(function() {
        return model.value ? props.trueIcon : props.falseIcon;
    });
    return {
        group: group,
        densityClasses: densityClasses,
        trueValue: trueValue,
        falseValue: falseValue,
        model: model,
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles,
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles,
        icon: icon
    };
}
var $1fb46ce89e6b4a77$export$ada18d63da74fb09 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSelectionControl',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    inheritAttrs: false,
    props: $1fb46ce89e6b4a77$export$a15300eeb449da9c(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var _useSelectionControl = $1fb46ce89e6b4a77$export$d7418bbd9b6d5f0c(props), group = _useSelectionControl.group, densityClasses = _useSelectionControl.densityClasses, icon = _useSelectionControl.icon, model = _useSelectionControl.model, textColorClasses = _useSelectionControl.textColorClasses, textColorStyles = _useSelectionControl.textColorStyles, backgroundColorClasses = _useSelectionControl.backgroundColorClasses, backgroundColorStyles = _useSelectionControl.backgroundColorStyles, trueValue = _useSelectionControl.trueValue;
        var uid = (0, $bu8yf.useId)();
        var isFocused = (0, $hXmfK.shallowRef)(false);
        var isFocusVisible = (0, $hXmfK.shallowRef)(false);
        var input = (0, $hXmfK.ref)();
        var id = (0, $hXmfK.toRef)(function() {
            return props.id || "input-".concat(uid);
        });
        var isInteractive = (0, $hXmfK.toRef)(function() {
            return !props.disabled && !props.readonly;
        });
        group === null || group === void 0 ? void 0 : group.onForceUpdate(function() {
            if (input.value) input.value.checked = model.value;
        });
        function onFocus(e) {
            if (!isInteractive.value) return;
            isFocused.value = true;
            if ((0, $31779689cfd5da50$export$b06a2f5618961e1e)(e.target, ':focus-visible') !== false) isFocusVisible.value = true;
        }
        function onBlur() {
            isFocused.value = false;
            isFocusVisible.value = false;
        }
        function onClickLabel(e) {
            e.stopPropagation();
        }
        function onInput(e) {
            if (!isInteractive.value) {
                if (input.value) // model value is not updated when input is not interactive
                // but the internal checked state of the input is still updated,
                // so here it's value is restored
                input.value.checked = model.value;
                return;
            }
            if (props.readonly && group) (0, $bu8yf.nextTick)(function() {
                return group.forceUpdate();
            });
            model.value = e.target.checked;
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default, _slots_input;
            var label = slots.label ? slots.label({
                label: props.label,
                props: {
                    "for": id.value
                }
            }) : props.label;
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], inputAttrs = _filterInputAttrs[1];
            var inputNode = (0, $bu8yf.createElementVNode)("input", (0, $bu8yf.mergeProps)({
                ref: input,
                checked: model.value,
                disabled: !!props.disabled,
                id: id.value,
                onBlur: onBlur,
                onFocus: onFocus,
                onInput: onInput,
                "aria-disabled": !!props.disabled,
                "aria-label": props.label,
                type: props.type,
                value: trueValue.value,
                name: props.name,
                "aria-checked": props.type === 'checkbox' ? model.value : undefined
            }, inputAttrs), null);
            var _slots_input1;
            return (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                "class": [
                    'v-selection-control',
                    {
                        'v-selection-control--dirty': model.value,
                        'v-selection-control--disabled': props.disabled,
                        'v-selection-control--error': props.error,
                        'v-selection-control--focused': isFocused.value,
                        'v-selection-control--focus-visible': isFocusVisible.value,
                        'v-selection-control--inline': props.inline
                    },
                    densityClasses.value,
                    props["class"]
                ]
            }, rootAttrs, {
                style: props.style
            }), [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-selection-control__wrapper',
                        textColorClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(textColorStyles.value)
                }, [
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                        backgroundColorClasses: backgroundColorClasses,
                        backgroundColorStyles: backgroundColorStyles
                    }),
                    (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                        "class": (0, $d8jBh.normalizeClass)([
                            'v-selection-control__input'
                        ])
                    }, [
                        (_slots_input1 = (_slots_input = slots.input) === null || _slots_input === void 0 ? void 0 : _slots_input.call(slots, {
                            model: model,
                            textColorClasses: textColorClasses,
                            textColorStyles: textColorStyles,
                            backgroundColorClasses: backgroundColorClasses,
                            backgroundColorStyles: backgroundColorStyles,
                            inputNode: inputNode,
                            icon: icon.value,
                            props: {
                                onFocus: onFocus,
                                onBlur: onBlur,
                                id: id.value
                            }
                        })) !== null && _slots_input1 !== void 0 ? _slots_input1 : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            icon.value && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "icon",
                                icon: icon.value
                            }, null),
                            inputNode
                        ])
                    ]), [
                        [
                            (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                            !props.disabled && !props.readonly && props.ripple,
                            null,
                            {
                                center: true,
                                circle: true
                            }
                        ]
                    ])
                ]),
                label && (0, $bu8yf.createVNode)((0, $6c6f579f4011d0f0$export$90281af35207eb21), {
                    "for": id.value,
                    onClick: onClickLabel
                }, {
                    "default": function() {
                        return [
                            label
                        ];
                    }
                })
            ]);
        });
        return {
            isFocused: isFocused,
            input: input
        };
    }
});





var $941cc86b1aae9176$export$b10b3450c190da23 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    indeterminate: Boolean,
    indeterminateIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$checkboxIndeterminate'
    }
}, (0, $1fb46ce89e6b4a77$export$a15300eeb449da9c)({
    falseIcon: '$checkboxOff',
    trueIcon: '$checkboxOn'
})), 'VCheckboxBtn');
var $941cc86b1aae9176$export$2c5503cb3c38fdb6 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCheckboxBtn',
    props: $941cc86b1aae9176$export$b10b3450c190da23(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:indeterminate': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var indeterminate = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'indeterminate');
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        function onChange(v) {
            if (indeterminate.value) indeterminate.value = false;
        }
        var falseIcon = (0, $hXmfK.toRef)(function() {
            return indeterminate.value ? props.indeterminateIcon : props.falseIcon;
        });
        var trueIcon = (0, $hXmfK.toRef)(function() {
            return indeterminate.value ? props.indeterminateIcon : props.trueIcon;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var controlProps = (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $1fb46ce89e6b4a77$export$ada18d63da74fb09).filterProps(props), [
                'modelValue'
            ]);
            return (0, $bu8yf.createVNode)((0, $1fb46ce89e6b4a77$export$ada18d63da74fb09), (0, $bu8yf.mergeProps)(controlProps, {
                modelValue: model.value,
                "onUpdate:modelValue": [
                    function($event) {
                        return model.value = $event;
                    },
                    onChange
                ],
                "class": [
                    'v-checkbox-btn',
                    props["class"]
                ],
                style: props.style,
                type: "checkbox",
                falseIcon: falseIcon.value,
                trueIcon: trueIcon.value,
                "aria-checked": indeterminate.value ? 'mixed' : undefined
            }), slots);
        });
        return {};
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");











function $6e3804b4d49f22c2$export$72671e4b692fd502(_ref) {
    var selectedElement = _ref.selectedElement, containerElement = _ref.containerElement, isRtl = _ref.isRtl, isHorizontal = _ref.isHorizontal;
    var containerSize = $6e3804b4d49f22c2$export$e474b82ad079053b(isHorizontal, containerElement);
    var scrollPosition = $6e3804b4d49f22c2$export$3abe133d5501edeb(isHorizontal, isRtl, containerElement);
    var childrenSize = $6e3804b4d49f22c2$export$e474b82ad079053b(isHorizontal, selectedElement);
    var childrenStartPosition = $6e3804b4d49f22c2$export$456611cab2a1cf25(isHorizontal, selectedElement);
    var additionalOffset = childrenSize * 0.4;
    if (scrollPosition > childrenStartPosition) return childrenStartPosition - additionalOffset;
    else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) return childrenStartPosition - containerSize + childrenSize + additionalOffset;
    return scrollPosition;
}
function $6e3804b4d49f22c2$export$1d9da49cc5a9a084(_ref2) {
    var selectedElement = _ref2.selectedElement, containerElement = _ref2.containerElement, isHorizontal = _ref2.isHorizontal;
    var containerOffsetSize = $6e3804b4d49f22c2$export$e474b82ad079053b(isHorizontal, containerElement);
    var childrenOffsetPosition = $6e3804b4d49f22c2$export$456611cab2a1cf25(isHorizontal, selectedElement);
    var childrenOffsetSize = $6e3804b4d49f22c2$export$e474b82ad079053b(isHorizontal, selectedElement);
    return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
}
function $6e3804b4d49f22c2$export$d9d87c520f59b2d3(isHorizontal, element) {
    var key = isHorizontal ? 'scrollWidth' : 'scrollHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $6e3804b4d49f22c2$export$1feb45891927fcb4(isHorizontal, element) {
    var key = isHorizontal ? 'clientWidth' : 'clientHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $6e3804b4d49f22c2$export$3abe133d5501edeb(isHorizontal, rtl, element) {
    if (!element) return 0;
    var scrollLeft = element.scrollLeft, offsetWidth = element.offsetWidth, scrollWidth = element.scrollWidth;
    if (isHorizontal) return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
    return element.scrollTop;
}
function $6e3804b4d49f22c2$export$e474b82ad079053b(isHorizontal, element) {
    var key = isHorizontal ? 'offsetWidth' : 'offsetHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $6e3804b4d49f22c2$export$456611cab2a1cf25(isHorizontal, element) {
    var key = isHorizontal ? 'offsetLeft' : 'offsetTop';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}



var $a8d82cf1ac6b41e1$export$f8d4255bddd9d04c = Symbol["for"]('vuetify:v-slide-group');
var $a8d82cf1ac6b41e1$export$8d9f6ad26ccf07ca = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    centerActive: Boolean,
    contentClass: null,
    direction: {
        type: String,
        "default": 'horizontal'
    },
    symbol: {
        type: null,
        "default": $a8d82cf1ac6b41e1$export$f8d4255bddd9d04c
    },
    nextIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$next'
    },
    prevIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$prev'
    },
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: function(v) {
            return typeof v === 'boolean' || [
                'always',
                'desktop',
                'mobile'
            ].includes(v);
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $a7414385605a88b0$export$d0badecb383b472a)({
    mobile: null
}), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $073309bf395585eb$export$fa4c05b3520340e6)({
    selectedClass: 'v-slide-group-item--active'
})), 'VSlideGroup');
var $a8d82cf1ac6b41e1$export$f3e025e558a486a4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSlideGroup',
    props: $a8d82cf1ac6b41e1$export$8d9f6ad26ccf07ca(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var group = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, props.symbol);
        var isOverflowing = (0, $hXmfK.shallowRef)(false);
        var scrollOffset = (0, $hXmfK.shallowRef)(0);
        var containerSize = (0, $hXmfK.shallowRef)(0);
        var contentSize = (0, $hXmfK.shallowRef)(0);
        var isHorizontal = (0, $hXmfK.computed)(function() {
            return props.direction === 'horizontal';
        });
        var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), containerRef = _useResizeObserver.resizeRef, containerRect = _useResizeObserver.contentRect;
        var _useResizeObserver1 = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), contentRef = _useResizeObserver1.resizeRef, contentRect = _useResizeObserver1.contentRect;
        var goTo = (0, $c2a741a9f897c45c$export$427b5df65b729c6)();
        var goToOptions = (0, $hXmfK.computed)(function() {
            return {
                container: containerRef.el,
                duration: 200,
                easing: 'easeOutQuart'
            };
        });
        var firstSelectedIndex = (0, $hXmfK.computed)(function() {
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex(function(item) {
                return item.id === group.selected.value[0];
            });
        });
        var lastSelectedIndex = (0, $hXmfK.computed)(function() {
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex(function(item) {
                return item.id === group.selected.value[group.selected.value.length - 1];
            });
        });
        if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) {
            var frame = -1;
            (0, $hXmfK.watch)(function() {
                return [
                    group.selected.value,
                    containerRect.value,
                    contentRect.value,
                    isHorizontal.value
                ];
            }, function() {
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(function() {
                    if (containerRect.value && contentRect.value) {
                        var sizeProperty = isHorizontal.value ? 'width' : 'height';
                        containerSize.value = containerRect.value[sizeProperty];
                        contentSize.value = contentRect.value[sizeProperty];
                        isOverflowing.value = containerSize.value + 1 < contentSize.value;
                    }
                    if (firstSelectedIndex.value >= 0 && contentRef.el) {
                        // TODO: Is this too naive? Should we store element references in group composable?
                        var selectedElement = contentRef.el.children[lastSelectedIndex.value];
                        scrollToChildren(selectedElement, props.centerActive);
                    }
                });
            });
        }
        var isFocused = (0, $hXmfK.shallowRef)(false);
        function scrollToChildren(children, center) {
            var target = 0;
            if (center) target = (0, $6e3804b4d49f22c2$export$1d9da49cc5a9a084)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                selectedElement: children
            });
            else target = (0, $6e3804b4d49f22c2$export$72671e4b692fd502)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                isRtl: isRtl.value,
                selectedElement: children
            });
            scrollToPosition(target);
        }
        function scrollToPosition(newPosition) {
            if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) || !containerRef.el) return;
            var offsetSize = (0, $6e3804b4d49f22c2$export$e474b82ad079053b)(isHorizontal.value, containerRef.el);
            var scrollPosition = (0, $6e3804b4d49f22c2$export$3abe133d5501edeb)(isHorizontal.value, isRtl.value, containerRef.el);
            var scrollSize = (0, $6e3804b4d49f22c2$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            if (scrollSize <= offsetSize || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
            Math.abs(newPosition - scrollPosition) < 16) return;
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                var _containerRef_el = containerRef.el, scrollWidth = _containerRef_el.scrollWidth, containerWidth = _containerRef_el.offsetWidth;
                newPosition = scrollWidth - containerWidth - newPosition;
            }
            if (isHorizontal.value) goTo.horizontal(newPosition, goToOptions.value);
            else goTo(newPosition, goToOptions.value);
        }
        function onScroll(e) {
            var _e_target = e.target, scrollTop = _e_target.scrollTop, scrollLeft = _e_target.scrollLeft;
            scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
        }
        function onFocusin(e) {
            isFocused.value = true;
            if (!isOverflowing.value || !contentRef.el) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Focused element is likely to be the root of an item, so a
                // breadth-first search will probably find it in the first iteration
                for(var _iterator = e.composedPath()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var el = _step.value;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = contentRef.el.children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var item = _step1.value;
                            if (item === el) {
                                scrollToChildren(item);
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        // Affix clicks produce onFocus that we have to ignore to avoid extra scrollToChildren
        var ignoreFocusEvent = false;
        function onFocus(e) {
            var _contentRef_el;
            if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && ((_contentRef_el = contentRef.el) === null || _contentRef_el === void 0 ? void 0 : _contentRef_el.contains(e.relatedTarget)))) focus();
            ignoreFocusEvent = false;
        }
        function onFocusAffixes() {
            ignoreFocusEvent = true;
        }
        function onKeydown(e) {
            if (!contentRef.el) return;
            function toFocus(location) {
                e.preventDefault();
                focus(location);
            }
            if (isHorizontal.value) {
                if (e.key === 'ArrowRight') toFocus(isRtl.value ? 'prev' : 'next');
                else if (e.key === 'ArrowLeft') toFocus(isRtl.value ? 'next' : 'prev');
            } else {
                if (e.key === 'ArrowDown') toFocus('next');
                else if (e.key === 'ArrowUp') toFocus('prev');
            }
            if (e.key === 'Home') toFocus('first');
            else if (e.key === 'End') toFocus('last');
        }
        function getSiblingElement(el, location) {
            if (!el) return undefined;
            var sibling = el;
            do sibling = sibling === null || sibling === void 0 ? void 0 : sibling[location === 'next' ? 'nextElementSibling' : 'previousElementSibling'];
            while (sibling === null || sibling === void 0 ? void 0 : sibling.hasAttribute('disabled'));
            return sibling;
        }
        function focus(location) {
            if (!contentRef.el) return;
            var el;
            if (!location) {
                var focusable = (0, $31779689cfd5da50$export$aea49dace3f6ca76)(contentRef.el);
                el = focusable[0];
            } else if (location === 'next') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('first');
            } else if (location === 'prev') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('last');
            } else if (location === 'first') {
                el = contentRef.el.firstElementChild;
                if (el === null || el === void 0 ? void 0 : el.hasAttribute('disabled')) el = getSiblingElement(el, 'next');
            } else if (location === 'last') {
                el = contentRef.el.lastElementChild;
                if (el === null || el === void 0 ? void 0 : el.hasAttribute('disabled')) el = getSiblingElement(el, 'prev');
            }
            if (el) el.focus({
                preventScroll: true
            });
        }
        function scrollTo(location) {
            var direction = isHorizontal.value && isRtl.value ? -1 : 1;
            var offsetStep = (location === 'prev' ? -direction : direction) * containerSize.value;
            var newPosition = scrollOffset.value + offsetStep;
            // TODO: improve it
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                var _containerRef_el = containerRef.el, scrollWidth = _containerRef_el.scrollWidth, containerWidth = _containerRef_el.offsetWidth;
                newPosition += scrollWidth - containerWidth;
            }
            scrollToPosition(newPosition);
        }
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                next: group.next,
                prev: group.prev,
                select: group.select,
                isSelected: group.isSelected
            };
        });
        var hasAffixes = (0, $hXmfK.computed)(function() {
            switch(props.showArrows){
                // Always show arrows on desktop & mobile
                case 'always':
                    return true;
                // Always show arrows on desktop
                case 'desktop':
                    return !mobile.value;
                // Show arrows on mobile when overflowing.
                // This matches the default 2.2 behavior
                case true:
                    return isOverflowing.value || Math.abs(scrollOffset.value) > 0;
                // Always show on mobile
                case 'mobile':
                    return mobile.value || isOverflowing.value || Math.abs(scrollOffset.value) > 0;
                // https://material.io/components/tabs#scrollable-tabs
                // Always show arrows when
                // overflowed on desktop
                default:
                    return !mobile.value && (isOverflowing.value || Math.abs(scrollOffset.value) > 0);
            }
        });
        var hasPrev = (0, $hXmfK.computed)(function() {
            // 1 pixel in reserve, may be lost after rounding
            return Math.abs(scrollOffset.value) > 1;
        });
        var hasNext = (0, $hXmfK.computed)(function() {
            if (!containerRef.value) return false;
            var scrollSize = (0, $6e3804b4d49f22c2$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            var clientSize = (0, $6e3804b4d49f22c2$export$1feb45891927fcb4)(isHorizontal.value, containerRef.el);
            var scrollSizeMax = scrollSize - clientSize;
            // 1 pixel in reserve, may be lost after rounding
            return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-slide-group',
                    {
                        'v-slide-group--vertical': !isHorizontal.value,
                        'v-slide-group--has-affixes': hasAffixes.value,
                        'v-slide-group--is-overflowing': isOverflowing.value
                    },
                    displayClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                tabindex: isFocused.value || group.selected.value.length ? -1 : 0,
                onFocus: onFocus
            }, {
                "default": function() {
                    var _slots_prev, _slots_default, _slots_next;
                    var _slots_prev1, _slots_next1;
                    return [
                        hasAffixes.value && (0, $bu8yf.createElementVNode)("div", {
                            key: "prev",
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-slide-group__prev',
                                {
                                    'v-slide-group__prev--disabled': !hasPrev.value
                                }
                            ]),
                            onMousedown: onFocusAffixes,
                            onClick: function() {
                                return hasPrev.value && scrollTo('prev');
                            }
                        }, [
                            (_slots_prev1 = (_slots_prev = slots.prev) === null || _slots_prev === void 0 ? void 0 : _slots_prev.call(slots, slotProps.value)) !== null && _slots_prev1 !== void 0 ? _slots_prev1 : (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$13ce8c44634b158c), null, {
                                "default": function() {
                                    return [
                                        (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                            icon: isRtl.value ? props.nextIcon : props.prevIcon
                                        }, null)
                                    ];
                                }
                            })
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            key: "container",
                            ref: containerRef,
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-slide-group__container',
                                props.contentClass
                            ]),
                            onScroll: onScroll
                        }, [
                            (0, $bu8yf.createElementVNode)("div", {
                                ref: contentRef,
                                "class": "v-slide-group__content",
                                onFocusin: onFocusin,
                                onFocusout: onFocusout,
                                onKeydown: onKeydown
                            }, [
                                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                            ])
                        ]),
                        hasAffixes.value && (0, $bu8yf.createElementVNode)("div", {
                            key: "next",
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-slide-group__next',
                                {
                                    'v-slide-group__next--disabled': !hasNext.value
                                }
                            ]),
                            onMousedown: onFocusAffixes,
                            onClick: function() {
                                return hasNext.value && scrollTo('next');
                            }
                        }, [
                            (_slots_next1 = (_slots_next = slots.next) === null || _slots_next === void 0 ? void 0 : _slots_next.call(slots, slotProps.value)) !== null && _slots_next1 !== void 0 ? _slots_next1 : (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$13ce8c44634b158c), null, {
                                "default": function() {
                                    return [
                                        (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                            icon: isRtl.value ? props.prevIcon : props.nextIcon
                                        }, null)
                                    ];
                                }
                            })
                        ])
                    ];
                }
            });
        });
        return {
            selected: group.selected,
            scrollTo: scrollTo,
            scrollOffset: scrollOffset,
            focus: focus,
            hasPrev: hasPrev,
            hasNext: hasNext
        };
    }
});









var $5e689c9fe943db2c$export$74b52ffc27c1a17c = Symbol["for"]('vuetify:v-chip-group');
var $5e689c9fe943db2c$export$66871af2e011e6cd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    baseColor: String,
    column: Boolean,
    filter: Boolean,
    valueComparator: {
        type: Function,
        "default": (0, $31779689cfd5da50$export$9cb4719e2e525b7a)
    }
}, (0, $a8d82cf1ac6b41e1$export$8d9f6ad26ccf07ca)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $073309bf395585eb$export$fa4c05b3520340e6)({
    selectedClass: 'v-chip--selected'
}), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'tonal'
})), 'VChipGroup');
var $5e689c9fe943db2c$export$d38779cb67beb087 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VChipGroup',
    props: $5e689c9fe943db2c$export$66871af2e011e6cd(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useGroup = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, $5e689c9fe943db2c$export$74b52ffc27c1a17c), isSelected = _useGroup.isSelected, select = _useGroup.select, next = _useGroup.next, prev = _useGroup.prev, selected = _useGroup.selected;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VChip: {
                baseColor: (0, $hXmfK.toRef)(function() {
                    return props.baseColor;
                }),
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                disabled: (0, $hXmfK.toRef)(function() {
                    return props.disabled;
                }),
                filter: (0, $hXmfK.toRef)(function() {
                    return props.filter;
                }),
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var slideGroupProps = (0, $a8d82cf1ac6b41e1$export$f3e025e558a486a4).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $a8d82cf1ac6b41e1$export$f3e025e558a486a4), (0, $bu8yf.mergeProps)(slideGroupProps, {
                "class": [
                    'v-chip-group',
                    {
                        'v-chip-group--column': props.column
                    },
                    themeClasses.value,
                    props["class"]
                ],
                style: props.style
            }), {
                "default": function() {
                    var _slots_default;
                    return [
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ];
                }
            });
        });
        return {};
    }
});




















var $2f12dac67cff7cbd$export$5b6b76de0aa76ecc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    activeClass: String,
    appendAvatar: String,
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    baseColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$delete'
    },
    closeLabel: {
        type: String,
        "default": '$vuetify.close'
    },
    draggable: Boolean,
    filter: Boolean,
    filterIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$complete'
    },
    label: Boolean,
    link: {
        type: Boolean,
        "default": undefined
    },
    pill: Boolean,
    prependAvatar: String,
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    modelValue: {
        type: Boolean,
        "default": true
    },
    onClick: (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    onClickOnce: (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $073309bf395585eb$export$e9e3b570044587e8)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $f0fd6b0b61967e91$export$78d5db5e8f9b041d)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'span'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'tonal'
})), 'VChip');
var $2f12dac67cff7cbd$export$1b5fab12cd17b4fb = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VChip',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $2f12dac67cff7cbd$export$5b6b76de0aa76ecc(),
    emits: {
        'click:close': function(e) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        'group:selected': function(val) {
            return true;
        },
        click: function(e) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var sizeClasses = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props).sizeClasses;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var group = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $5e689c9fe943db2c$export$74b52ffc27c1a17c), false);
        var link = (0, $f0fd6b0b61967e91$export$dcf14c9974fe2767)(props, attrs);
        var isLink = (0, $hXmfK.toRef)(function() {
            return props.link !== false && link.isLink.value;
        });
        var isClickable = (0, $hXmfK.computed)(function() {
            return !props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value);
        });
        var closeProps = (0, $hXmfK.toRef)(function() {
            return {
                'aria-label': t(props.closeLabel),
                disabled: props.disabled,
                onClick: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    isActive.value = false;
                    emit('click:close', e);
                }
            };
        });
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(function() {
            var showColor = !group || group.isSelected.value;
            var _props_color;
            return {
                color: showColor ? (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.baseColor : props.baseColor,
                variant: props.variant
            };
        }), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        function onClick(e) {
            var _link_navigate;
            emit('click', e);
            if (!isClickable.value) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            group === null || group === void 0 ? void 0 : group.toggle();
        }
        function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }
        return function() {
            var _link_isActive;
            var Tag = link.isLink.value ? 'a' : props.tag;
            var hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
            var hasAppend = !!(hasAppendMedia || slots.append);
            var hasClose = !!(slots.close || props.closable);
            var hasFilter = !!(slots.filter || props.filter) && group;
            var hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
            var hasPrepend = !!(hasPrependMedia || slots.prepend);
            return isActive.value && (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(Tag, (0, $bu8yf.mergeProps)({
                "class": [
                    'v-chip',
                    (0, $cqEAj._)({
                        'v-chip--disabled': props.disabled,
                        'v-chip--label': props.label,
                        'v-chip--link': isClickable.value,
                        'v-chip--filter': hasFilter,
                        'v-chip--pill': props.pill
                    }, "".concat(props.activeClass), props.activeClass && ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value)),
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    group === null || group === void 0 ? void 0 : group.selectedClass.value,
                    props["class"]
                ],
                style: [
                    colorStyles.value,
                    props.style
                ],
                disabled: props.disabled || undefined,
                draggable: props.draggable,
                tabindex: isClickable.value ? 0 : undefined,
                onClick: onClick,
                onKeydown: isClickable.value && !isLink.value && onKeyDown
            }, link.linkProps), {
                "default": function() {
                    var _slots_default;
                    var _slots_default1;
                    return [
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(isClickable.value, 'v-chip'),
                        hasFilter && (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$d54edbcba7869f36), {
                            key: "filter"
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-chip__filter"
                                    }, [
                                        !slots.filter ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                            key: "filter-icon",
                                            icon: props.filterIcon
                                        }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                            key: "filter-defaults",
                                            disabled: !props.filterIcon,
                                            defaults: {
                                                VIcon: {
                                                    icon: props.filterIcon
                                                }
                                            }
                                        }, slots.filter)
                                    ]), [
                                        [
                                            (0, $kiZwI.vShow),
                                            group.isSelected.value
                                        ]
                                    ])
                                ];
                            }
                        }),
                        hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                            key: "prepend",
                            "class": "v-chip__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                    key: "prepend-icon",
                                    icon: props.prependIcon,
                                    start: true
                                }, null),
                                props.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                    key: "prepend-avatar",
                                    image: props.prependAvatar,
                                    start: true
                                }, null)
                            ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !hasPrependMedia,
                                defaults: {
                                    VAvatar: {
                                        image: props.prependAvatar,
                                        start: true
                                    },
                                    VIcon: {
                                        icon: props.prependIcon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-chip__content",
                            "data-no-activator": ""
                        }, [
                            (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                isSelected: group === null || group === void 0 ? void 0 : group.isSelected.value,
                                selectedClass: group === null || group === void 0 ? void 0 : group.selectedClass.value,
                                select: group === null || group === void 0 ? void 0 : group.select,
                                toggle: group === null || group === void 0 ? void 0 : group.toggle,
                                value: group === null || group === void 0 ? void 0 : group.value.value,
                                disabled: props.disabled
                            })) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $d8jBh.toDisplayString)(props.text)
                        ]),
                        hasAppend && (0, $bu8yf.createElementVNode)("div", {
                            key: "append",
                            "class": "v-chip__append"
                        }, [
                            !slots.append ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.appendIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                    key: "append-icon",
                                    end: true,
                                    icon: props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                    key: "append-avatar",
                                    end: true,
                                    image: props.appendAvatar
                                }, null)
                            ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "append-defaults",
                                disabled: !hasAppendMedia,
                                defaults: {
                                    VAvatar: {
                                        end: true,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        end: true,
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        hasClose && (0, $bu8yf.createElementVNode)("button", (0, $bu8yf.mergeProps)({
                            key: "close",
                            "class": "v-chip__close",
                            type: "button",
                            "data-testid": "close-chip"
                        }, closeProps.value), [
                            !slots.close ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "close-icon",
                                icon: props.closeIcon,
                                size: "x-small"
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "close-defaults",
                                defaults: {
                                    VIcon: {
                                        icon: props.closeIcon,
                                        size: 'x-small'
                                    }
                                }
                            }, slots.close)
                        ])
                    ];
                }
            }), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    isClickable.value && props.ripple,
                    null
                ]
            ]);
        };
    }
});




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");





var $d0feee08e552461a$export$1c23c63c3209ac98 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    inset: Boolean,
    length: [
        Number,
        String
    ],
    opacity: [
        Number,
        String
    ],
    thickness: [
        Number,
        String
    ],
    vertical: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VDivider');
var $d0feee08e552461a$export$a2636a5d9a866ca1 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDivider',
    props: $d0feee08e552461a$export$1c23c63c3209ac98(),
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var dividerStyles = (0, $hXmfK.computed)(function() {
            var styles = {};
            if (props.length) styles[props.vertical ? 'height' : 'width'] = (0, $31779689cfd5da50$export$286ad215293a0860)(props.length);
            if (props.thickness) styles[props.vertical ? 'borderRightWidth' : 'borderTopWidth'] = (0, $31779689cfd5da50$export$286ad215293a0860)(props.thickness);
            return styles;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var divider = (0, $bu8yf.createElementVNode)("hr", {
                "class": (0, $d8jBh.normalizeClass)([
                    {
                        'v-divider': true,
                        'v-divider--inset': props.inset,
                        'v-divider--vertical': props.vertical
                    },
                    themeClasses.value,
                    textColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dividerStyles.value,
                    textColorStyles.value,
                    {
                        '--v-border-opacity': props.opacity
                    },
                    props.style
                ]),
                "aria-orientation": !attrs.role || attrs.role === 'separator' ? props.vertical ? 'vertical' : 'horizontal' : undefined,
                role: "".concat(attrs.role || 'separator')
            }, null);
            if (!slots["default"]) return divider;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-divider__wrapper',
                    {
                        'v-divider__wrapper--vertical': props.vertical,
                        'v-divider__wrapper--inset': props.inset
                    }
                ])
            }, [
                divider,
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-divider__content"
                }, [
                    slots["default"]()
                ]),
                divider
            ]);
        });
        return {};
    }
});




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $bfe43f6d06fb8da1$export$48075a67713cd8aa = Symbol["for"]('vuetify:depth');
function $bfe43f6d06fb8da1$export$ea435a089f01433c(hasPrepend) {
    var parent = (0, $bu8yf.inject)($bfe43f6d06fb8da1$export$48075a67713cd8aa, (0, $hXmfK.shallowRef)(-1));
    var depth = (0, $hXmfK.computed)(function() {
        return parent.value + 1 + ((hasPrepend === null || hasPrepend === void 0 ? void 0 : hasPrepend.value) ? 1 : 0);
    });
    (0, $bu8yf.provide)($bfe43f6d06fb8da1$export$48075a67713cd8aa, depth);
    return depth;
}
var $bfe43f6d06fb8da1$export$f69297c4748e8734 = Symbol["for"]('vuetify:list');
function $bfe43f6d06fb8da1$export$5897d8d7c7a3d871() {
    var filterable = (arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        filterable: false
    }).filterable;
    var parent = (0, $bu8yf.inject)($bfe43f6d06fb8da1$export$f69297c4748e8734, {
        filterable: false,
        hasPrepend: (0, $hXmfK.shallowRef)(false),
        updateHasPrepend: function() {
            return null;
        }
    });
    var data = {
        filterable: parent.filterable || filterable,
        hasPrepend: (0, $hXmfK.shallowRef)(false),
        updateHasPrepend: function(value) {
            if (value) data.hasPrepend.value = value;
        }
    };
    (0, $bu8yf.provide)($bfe43f6d06fb8da1$export$f69297c4748e8734, data);
    return parent;
}
function $bfe43f6d06fb8da1$export$f9763ecd339e95eb() {
    return (0, $bu8yf.inject)($bfe43f6d06fb8da1$export$f69297c4748e8734, null);
}




// Composables

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
/* eslint-disable sonarjs/no-identical-functions */ // Utilities

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $a588e0bec2dfe310$export$9387f2baf58fc090 = function(mandatory) {
    var strategy = {
        activate: function(_ref) {
            var id = _ref.id, value = _ref.value, activated = _ref.activated;
            id = (0, $hXmfK.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value && activated.size === 1 && activated.has(id)) return activated;
            if (value) activated.add(id);
            else activated["delete"](id);
            return activated;
        },
        "in": function(v, children, parents) {
            var set = new Set();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (v != null) try {
                for(var _iterator = (0, $31779689cfd5da50$export$76411cac38121ecb)(v)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    set = strategy.activate({
                        id: id,
                        value: true,
                        activated: new Set(set),
                        children: children,
                        parents: parents
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return set;
        },
        out: function(v) {
            return Array.from(v);
        }
    };
    return strategy;
};
var $a588e0bec2dfe310$export$5b58acd5140059d7 = function(mandatory) {
    var parentStrategy = $a588e0bec2dfe310$export$9387f2baf58fc090(mandatory);
    var strategy = {
        activate: function(_ref2) {
            var activated = _ref2.activated, id = _ref2.id, rest = (0, $g79Gh._)(_ref2, [
                "activated",
                "id"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            var singleSelected = activated.has(id) ? new Set([
                id
            ]) : new Set();
            return parentStrategy.activate((0, $emQHU._)((0, $iT0je._)({}, rest), {
                id: id,
                activated: singleSelected
            }));
        },
        "in": function(v, children, parents) {
            var set = new Set();
            if (v != null) {
                var arr = (0, $31779689cfd5da50$export$76411cac38121ecb)(v);
                if (arr.length) set = parentStrategy["in"](arr.slice(0, 1), children, parents);
            }
            return set;
        },
        out: function(v, children, parents) {
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
var $a588e0bec2dfe310$export$86506b87e5d93888 = function(mandatory) {
    var parentStrategy = $a588e0bec2dfe310$export$9387f2baf58fc090(mandatory);
    var strategy = {
        activate: function(_ref3) {
            var id = _ref3.id, activated = _ref3.activated, children = _ref3.children, rest = (0, $g79Gh._)(_ref3, [
                "id",
                "activated",
                "children"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate((0, $iT0je._)({
                id: id,
                activated: activated,
                children: children
            }, rest));
        },
        "in": parentStrategy["in"],
        out: parentStrategy.out
    };
    return strategy;
};
var $a588e0bec2dfe310$export$910c1ade9a9231fc = function(mandatory) {
    var parentStrategy = $a588e0bec2dfe310$export$5b58acd5140059d7(mandatory);
    var strategy = {
        activate: function(_ref4) {
            var id = _ref4.id, activated = _ref4.activated, children = _ref4.children, rest = (0, $g79Gh._)(_ref4, [
                "id",
                "activated",
                "children"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate((0, $iT0je._)({
                id: id,
                activated: activated,
                children: children
            }, rest));
        },
        "in": parentStrategy["in"],
        out: parentStrategy.out
    };
    return strategy;
};


var $e393c84de428ca33$export$7a4693cebcd37a8a = {
    open: function(_ref) {
        var id = _ref.id, value = _ref.value, opened = _ref.opened, parents = _ref.parents;
        if (value) {
            var newOpened = new Set();
            newOpened.add(id);
            var parent = parents.get(id);
            while(parent != null){
                newOpened.add(parent);
                parent = parents.get(parent);
            }
            return newOpened;
        } else {
            opened["delete"](id);
            return opened;
        }
    },
    select: function() {
        return null;
    }
};
var $e393c84de428ca33$export$3e2f656d3630f9a4 = {
    open: function(_ref2) {
        var id = _ref2.id, value = _ref2.value, opened = _ref2.opened, parents = _ref2.parents;
        if (value) {
            var parent = parents.get(id);
            opened.add(id);
            while(parent != null && parent !== id){
                opened.add(parent);
                parent = parents.get(parent);
            }
            return opened;
        } else opened["delete"](id);
        return opened;
    },
    select: function() {
        return null;
    }
};
var $e393c84de428ca33$export$d7952eef3b24cbdf = {
    open: $e393c84de428ca33$export$3e2f656d3630f9a4.open,
    select: function(_ref3) {
        var id = _ref3.id, value = _ref3.value, opened = _ref3.opened, parents = _ref3.parents;
        if (!value) return opened;
        var path = [];
        var parent = parents.get(id);
        while(parent != null){
            path.push(parent);
            parent = parents.get(parent);
        }
        return new Set(path);
    }
};


/* eslint-disable sonarjs/no-identical-functions */ // Utilities

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $73c77ad133ba18aa$export$ed77aaa4426be279 = function(mandatory) {
    var strategy = {
        select: function(_ref) {
            var id = _ref.id, value = _ref.value, selected = _ref.selected;
            id = (0, $hXmfK.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value) {
                var on = Array.from(selected.entries()).reduce(function(arr, _ref2) {
                    var _$_ref2 = (0, $32TW8._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 1 && on[0] === id) return selected;
            }
            selected.set(id, value ? 'on' : 'off');
            return selected;
        },
        "in": function(v, children, parents, disabled) {
            var map = new Map();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (v || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    strategy.select({
                        id: id,
                        value: true,
                        selected: map,
                        children: children,
                        parents: parents,
                        disabled: disabled
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return map;
        },
        out: function(v) {
            var arr = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = v.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (value === 'on') arr.push(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return arr;
        }
    };
    return strategy;
};
var $73c77ad133ba18aa$export$628b10e27c96fc1f = function(mandatory) {
    var parentStrategy = $73c77ad133ba18aa$export$ed77aaa4426be279(mandatory);
    var strategy = {
        select: function(_ref3) {
            var selected = _ref3.selected, id = _ref3.id, rest = (0, $g79Gh._)(_ref3, [
                "selected",
                "id"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            var singleSelected = selected.has(id) ? new Map([
                [
                    id,
                    selected.get(id)
                ]
            ]) : new Map();
            return parentStrategy.select((0, $emQHU._)((0, $iT0je._)({}, rest), {
                id: id,
                selected: singleSelected
            }));
        },
        "in": function(v, children, parents, disabled) {
            if (v === null || v === void 0 ? void 0 : v.length) return parentStrategy["in"](v.slice(0, 1), children, parents, disabled);
            return new Map();
        },
        out: function(v, children, parents) {
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
var $73c77ad133ba18aa$export$8c4b1b6128aa22d2 = function(mandatory) {
    var parentStrategy = $73c77ad133ba18aa$export$ed77aaa4426be279(mandatory);
    var strategy = {
        select: function(_ref4) {
            var id = _ref4.id, selected = _ref4.selected, children = _ref4.children, rest = (0, $g79Gh._)(_ref4, [
                "id",
                "selected",
                "children"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select((0, $iT0je._)({
                id: id,
                selected: selected,
                children: children
            }, rest));
        },
        "in": parentStrategy["in"],
        out: parentStrategy.out
    };
    return strategy;
};
var $73c77ad133ba18aa$export$e37e092494950e24 = function(mandatory) {
    var parentStrategy = $73c77ad133ba18aa$export$628b10e27c96fc1f(mandatory);
    var strategy = {
        select: function(_ref5) {
            var id = _ref5.id, selected = _ref5.selected, children = _ref5.children, rest = (0, $g79Gh._)(_ref5, [
                "id",
                "selected",
                "children"
            ]);
            id = (0, $hXmfK.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select((0, $iT0je._)({
                id: id,
                selected: selected,
                children: children
            }, rest));
        },
        "in": parentStrategy["in"],
        out: parentStrategy.out
    };
    return strategy;
};
var $73c77ad133ba18aa$export$f0c808686d74df5b = function(mandatory) {
    var strategy = {
        select: function(_ref6) {
            var id = _ref6.id, value = _ref6.value, selected = _ref6.selected, children = _ref6.children, parents = _ref6.parents, disabled = _ref6.disabled;
            id = (0, $hXmfK.toRaw)(id);
            var original = new Map(selected);
            var items = [
                id
            ];
            while(items.length){
                var _items;
                var item = items.shift();
                if (!disabled.has(item)) selected.set((0, $hXmfK.toRaw)(item), value ? 'on' : 'off');
                if (children.has(item)) (_items = items).push.apply(_items, (0, $7WNf6._)(children.get(item)));
            }
            var parent = (0, $hXmfK.toRaw)(parents.get(id));
            while(parent){
                var everySelected = true;
                var noneSelected = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children.get(parent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var cid = (0, $hXmfK.toRaw)(child);
                        if (disabled.has(cid)) continue;
                        if (selected.get(cid) !== 'on') everySelected = false;
                        if (selected.has(cid) && selected.get(cid) !== 'off') noneSelected = false;
                        if (!everySelected && !noneSelected) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                selected.set(parent, everySelected ? 'on' : noneSelected ? 'off' : 'indeterminate');
                parent = (0, $hXmfK.toRaw)(parents.get(parent));
            }
            // If mandatory and planned deselect results in no selected
            // items then we can't do it, so return original state
            if (mandatory && !value) {
                var on = Array.from(selected.entries()).reduce(function(arr, _ref7) {
                    var _$_ref7 = (0, $32TW8._)(_ref7, 2), key = _$_ref7[0], value = _$_ref7[1];
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 0) return original;
            }
            return selected;
        },
        "in": function(v, children, parents, disabled) {
            var map = new Map();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (v || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    map = strategy.select({
                        id: id,
                        value: true,
                        selected: map,
                        children: children,
                        parents: parents,
                        disabled: disabled
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return map;
        },
        out: function(v, children) {
            var arr = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = v.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (value === 'on' && !children.has(key)) arr.push(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return arr;
        }
    };
    return strategy;
};
var $73c77ad133ba18aa$export$5b6c8d1edcea7d04 = function(mandatory) {
    var parentStrategy = $73c77ad133ba18aa$export$f0c808686d74df5b(mandatory);
    var strategy = {
        select: parentStrategy.select,
        "in": parentStrategy["in"],
        out: function(v, children, parents) {
            var arr = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = v.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (value === 'on') {
                        if (parents.has(key)) {
                            var parent = parents.get(key);
                            if (v.get(parent) === 'on') continue;
                        }
                        arr.push(key);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return arr;
        }
    };
    return strategy;
};



var $07c648e7cb7675c5$export$f92820fd04593012 = Symbol["for"]('vuetify:nested');
var $07c648e7cb7675c5$export$ac77f7834a1bdcdb = {
    id: (0, $hXmfK.shallowRef)(),
    root: {
        register: function() {
            return null;
        },
        unregister: function() {
            return null;
        },
        children: (0, $hXmfK.ref)(new Map()),
        parents: (0, $hXmfK.ref)(new Map()),
        disabled: (0, $hXmfK.ref)(new Set()),
        open: function() {
            return null;
        },
        openOnSelect: function() {
            return null;
        },
        activate: function() {
            return null;
        },
        select: function() {
            return null;
        },
        activatable: (0, $hXmfK.ref)(false),
        selectable: (0, $hXmfK.ref)(false),
        opened: (0, $hXmfK.ref)(new Set()),
        activated: (0, $hXmfK.ref)(new Set()),
        selected: (0, $hXmfK.ref)(new Map()),
        selectedValues: (0, $hXmfK.ref)([]),
        getPath: function() {
            return [];
        }
    }
};
var $07c648e7cb7675c5$export$d902bc556a68188 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    activatable: Boolean,
    selectable: Boolean,
    activeStrategy: [
        String,
        Function,
        Object
    ],
    selectStrategy: [
        String,
        Function,
        Object
    ],
    openStrategy: [
        String,
        Object
    ],
    opened: null,
    activated: null,
    selected: null,
    mandatory: Boolean
}, 'nested');
var $07c648e7cb7675c5$export$3fe10dd37d604a36 = function(props) {
    var getPath = function getPath(id) {
        var path = [];
        var parent = (0, $hXmfK.toRaw)(id);
        while(parent != null){
            path.unshift(parent);
            parent = parents.value.get(parent);
        }
        return path;
    };
    var isUnmounted = false;
    var children = (0, $hXmfK.shallowRef)(new Map());
    var parents = (0, $hXmfK.shallowRef)(new Map());
    var disabled = (0, $hXmfK.shallowRef)(new Set());
    var opened = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'opened', props.opened, function(v) {
        return new Set(Array.isArray(v) ? v.map(function(i) {
            return (0, $hXmfK.toRaw)(i);
        }) : v);
    }, function(v) {
        return (0, $7WNf6._)(v.values());
    });
    var activeStrategy = (0, $hXmfK.computed)(function() {
        if ((0, $3KZcf._)(props.activeStrategy) === 'object') return props.activeStrategy;
        if (typeof props.activeStrategy === 'function') return props.activeStrategy(props.mandatory);
        switch(props.activeStrategy){
            case 'leaf':
                return (0, $a588e0bec2dfe310$export$86506b87e5d93888)(props.mandatory);
            case 'single-leaf':
                return (0, $a588e0bec2dfe310$export$910c1ade9a9231fc)(props.mandatory);
            case 'independent':
                return (0, $a588e0bec2dfe310$export$9387f2baf58fc090)(props.mandatory);
            case 'single-independent':
            default:
                return (0, $a588e0bec2dfe310$export$5b58acd5140059d7)(props.mandatory);
        }
    });
    var selectStrategy = (0, $hXmfK.computed)(function() {
        if ((0, $3KZcf._)(props.selectStrategy) === 'object') return props.selectStrategy;
        if (typeof props.selectStrategy === 'function') return props.selectStrategy(props.mandatory);
        switch(props.selectStrategy){
            case 'single-leaf':
                return (0, $73c77ad133ba18aa$export$e37e092494950e24)(props.mandatory);
            case 'leaf':
                return (0, $73c77ad133ba18aa$export$8c4b1b6128aa22d2)(props.mandatory);
            case 'independent':
                return (0, $73c77ad133ba18aa$export$ed77aaa4426be279)(props.mandatory);
            case 'single-independent':
                return (0, $73c77ad133ba18aa$export$628b10e27c96fc1f)(props.mandatory);
            case 'trunk':
                return (0, $73c77ad133ba18aa$export$5b6c8d1edcea7d04)(props.mandatory);
            case 'classic':
            default:
                return (0, $73c77ad133ba18aa$export$f0c808686d74df5b)(props.mandatory);
        }
    });
    var openStrategy = (0, $hXmfK.computed)(function() {
        if ((0, $3KZcf._)(props.openStrategy) === 'object') return props.openStrategy;
        switch(props.openStrategy){
            case 'list':
                return 0, $e393c84de428ca33$export$d7952eef3b24cbdf;
            case 'single':
                return 0, $e393c84de428ca33$export$7a4693cebcd37a8a;
            case 'multiple':
            default:
                return 0, $e393c84de428ca33$export$3e2f656d3630f9a4;
        }
    });
    var activated = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'activated', props.activated, function(v) {
        return activeStrategy.value["in"](v, children.value, parents.value);
    }, function(v) {
        return activeStrategy.value.out(v, children.value, parents.value);
    });
    var selected = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'selected', props.selected, function(v) {
        return selectStrategy.value["in"](v, children.value, parents.value, disabled.value);
    }, function(v) {
        return selectStrategy.value.out(v, children.value, parents.value);
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        isUnmounted = true;
    });
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('nested');
    var nodeIds = new Set();
    var nested = {
        id: (0, $hXmfK.shallowRef)(),
        root: {
            opened: opened,
            activatable: (0, $hXmfK.toRef)(function() {
                return props.activatable;
            }),
            selectable: (0, $hXmfK.toRef)(function() {
                return props.selectable;
            }),
            activated: activated,
            selected: selected,
            selectedValues: (0, $hXmfK.computed)(function() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selected.value.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $32TW8._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (value === 'on') arr.push(key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }),
            register: function(id, parentId, isDisabled, isGroup) {
                if (nodeIds.has(id)) {
                    var path = getPath(id).map(String).join(' -> ');
                    var newPath = getPath(parentId).concat(id).map(String).join(' -> ');
                    (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)("Multiple nodes with the same ID\n	".concat(path, "\n	").concat(newPath));
                    return;
                } else nodeIds.add(id);
                parentId && id !== parentId && parents.value.set(id, parentId);
                isDisabled && disabled.value.add(id);
                isGroup && children.value.set(id, []);
                if (parentId != null) children.value.set(parentId, (0, $7WNf6._)(children.value.get(parentId) || []).concat([
                    id
                ]));
            },
            unregister: function(id) {
                if (isUnmounted) return;
                nodeIds["delete"](id);
                children.value["delete"](id);
                disabled.value["delete"](id);
                var parent = parents.value.get(id);
                if (parent) {
                    var _children_value_get;
                    var list = (_children_value_get = children.value.get(parent)) !== null && _children_value_get !== void 0 ? _children_value_get : [];
                    children.value.set(parent, list.filter(function(child) {
                        return child !== id;
                    }));
                }
                parents.value["delete"](id);
            },
            open: function(id, value, event) {
                vm.emit('click:open', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                var newOpened = openStrategy.value.open({
                    id: id,
                    value: value,
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            openOnSelect: function(id, value, event) {
                var newOpened = openStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            select: function(id, value, event) {
                vm.emit('click:select', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                var newSelected = selectStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    children: children.value,
                    parents: parents.value,
                    disabled: disabled.value,
                    event: event
                });
                newSelected && (selected.value = newSelected);
                nested.root.openOnSelect(id, value, event);
            },
            activate: function(id, value, event) {
                if (!props.activatable) return nested.root.select(id, true, event);
                vm.emit('click:activate', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                var newActivated = activeStrategy.value.activate({
                    id: id,
                    value: value,
                    activated: new Set(activated.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                if (newActivated.size !== activated.value.size) activated.value = newActivated;
                else {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = newActivated[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$value = _step.value;
                            if (!activated.value.has(_$value)) {
                                activated.value = newActivated;
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = activated.value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _$value1 = _step1.value;
                            if (!newActivated.has(_$value1)) {
                                activated.value = newActivated;
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            },
            children: children,
            parents: parents,
            disabled: disabled,
            getPath: getPath
        }
    };
    (0, $bu8yf.provide)($07c648e7cb7675c5$export$f92820fd04593012, nested);
    return nested.root;
};
var $07c648e7cb7675c5$export$5d8af1afc0bf0f02 = function(id, isDisabled, isGroup) {
    var parent = (0, $bu8yf.inject)($07c648e7cb7675c5$export$f92820fd04593012, $07c648e7cb7675c5$export$ac77f7834a1bdcdb);
    var uidSymbol = Symbol('nested item');
    var computedId = (0, $hXmfK.computed)(function() {
        var _toRaw;
        return (_toRaw = (0, $hXmfK.toRaw)((0, $hXmfK.toValue)(id))) !== null && _toRaw !== void 0 ? _toRaw : uidSymbol;
    });
    var item = (0, $emQHU._)((0, $iT0je._)({}, parent), {
        id: computedId,
        open: function(open, e) {
            return parent.root.open(computedId.value, open, e);
        },
        openOnSelect: function(open, e) {
            return parent.root.openOnSelect(computedId.value, open, e);
        },
        isOpen: (0, $hXmfK.computed)(function() {
            return parent.root.opened.value.has(computedId.value);
        }),
        parent: (0, $hXmfK.computed)(function() {
            return parent.root.parents.value.get(computedId.value);
        }),
        activate: function(activated, e) {
            return parent.root.activate(computedId.value, activated, e);
        },
        isActivated: (0, $hXmfK.computed)(function() {
            return parent.root.activated.value.has(computedId.value);
        }),
        select: function(selected, e) {
            return parent.root.select(computedId.value, selected, e);
        },
        isSelected: (0, $hXmfK.computed)(function() {
            return parent.root.selected.value.get(computedId.value) === 'on';
        }),
        isIndeterminate: (0, $hXmfK.computed)(function() {
            return parent.root.selected.value.get(computedId.value) === 'indeterminate';
        }),
        isLeaf: (0, $hXmfK.computed)(function() {
            return !parent.root.children.value.get(computedId.value);
        }),
        isGroupActivator: parent.isGroupActivator
    });
    (0, $bu8yf.onBeforeMount)(function() {
        if (!parent.isGroupActivator) parent.root.register(computedId.value, parent.id.value, (0, $hXmfK.toValue)(isDisabled), isGroup);
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        if (!parent.isGroupActivator) parent.root.unregister(computedId.value);
    });
    isGroup && (0, $bu8yf.provide)($07c648e7cb7675c5$export$f92820fd04593012, item);
    return item;
};
var $07c648e7cb7675c5$export$8ce11cb83a582280 = function() {
    var parent = (0, $bu8yf.inject)($07c648e7cb7675c5$export$f92820fd04593012, $07c648e7cb7675c5$export$ac77f7834a1bdcdb);
    (0, $bu8yf.provide)($07c648e7cb7675c5$export$f92820fd04593012, (0, $emQHU._)((0, $iT0je._)({}, parent), {
        isGroupActivator: true
    }));
};






var $0891b6ffb0402c20$var$VListGroupActivator = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VListGroupActivator',
    setup: function(_, _ref) {
        var slots = _ref.slots;
        (0, $07c648e7cb7675c5$export$8ce11cb83a582280)();
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
        };
    }
});
var $0891b6ffb0402c20$export$4ba1284b16a5c704 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    /* @deprecated */ activeColor: String,
    baseColor: String,
    color: String,
    collapseIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$collapse'
    },
    disabled: Boolean,
    expandIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$expand'
    },
    rawId: [
        String,
        Number
    ],
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    fluid: Boolean,
    subgroup: Boolean,
    title: String,
    value: null
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VListGroup');
var $0891b6ffb0402c20$export$22fc03a43764dcc7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListGroup',
    props: $0891b6ffb0402c20$export$4ba1284b16a5c704(),
    setup: function(props, _ref2) {
        var slots = _ref2.slots;
        var _useNestedItem = (0, $07c648e7cb7675c5$export$5d8af1afc0bf0f02)(function() {
            return props.value;
        }, function() {
            return props.disabled;
        }, true), isOpen = _useNestedItem.isOpen, open = _useNestedItem.open, _id = _useNestedItem.id;
        var id = (0, $hXmfK.computed)(function() {
            var _props_rawId;
            return "v-list-group--id-".concat(String((_props_rawId = props.rawId) !== null && _props_rawId !== void 0 ? _props_rawId : _id.value));
        });
        var list = (0, $bfe43f6d06fb8da1$export$f9763ecd339e95eb)();
        var isBooted = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().isBooted;
        function onClick(e) {
            var _e_target;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.tagName)) return;
            open(!isOpen.value, e);
        }
        var activatorProps = (0, $hXmfK.computed)(function() {
            return {
                onClick: onClick,
                "class": 'v-list-group__header',
                id: id.value
            };
        });
        var toggleIcon = (0, $hXmfK.computed)(function() {
            return isOpen.value ? props.collapseIcon : props.expandIcon;
        });
        var activatorDefaults = (0, $hXmfK.computed)(function() {
            return {
                VListItem: {
                    activeColor: props.activeColor,
                    baseColor: props.baseColor,
                    color: props.color,
                    prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
                    appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
                    title: props.title,
                    value: props.value
                }
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list-group',
                    {
                        'v-list-group--prepend': list === null || list === void 0 ? void 0 : list.hasPrepend.value,
                        'v-list-group--fluid': props.fluid,
                        'v-list-group--subgroup': props.subgroup,
                        'v-list-group--open': isOpen.value
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    return [
                        slots.activator && (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: activatorDefaults.value
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.createVNode)($0891b6ffb0402c20$var$VListGroupActivator, null, {
                                        "default": function() {
                                            return [
                                                slots.activator({
                                                    props: activatorProps.value,
                                                    isOpen: isOpen.value
                                                })
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                            transition: {
                                component: (0, $01a421c271ad0485$export$1cd1e8deb97d798d)
                            },
                            disabled: !isBooted.value
                        }, {
                            "default": function() {
                                var _slots_default;
                                return [
                                    (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-list-group__items",
                                        role: "group",
                                        "aria-labelledby": id.value
                                    }, [
                                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                    ]), [
                                        [
                                            (0, $kiZwI.vShow),
                                            isOpen.value
                                        ]
                                    ])
                                ];
                            }
                        })
                    ];
                }
            });
        });
        return {
            isOpen: isOpen
        };
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $2f4a1b6bf70174ce$export$5fec5a0bd8520c4b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    opacity: [
        Number,
        String
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VListItemSubtitle');
var $2f4a1b6bf70174ce$export$822b84d77d050116 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListItemSubtitle',
    props: $2f4a1b6bf70174ce$export$5fec5a0bd8520c4b(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list-item-subtitle',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-list-item-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});


// Utilities

var $9189b661f3080a91$export$d3fcc52550436b5b = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-list-item-title');




















var $d199497309ad1f0e$export$b1024b817bbb948b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    active: {
        type: Boolean,
        "default": undefined
    },
    activeClass: String,
    /* @deprecated */ activeColor: String,
    appendAvatar: String,
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    baseColor: String,
    disabled: Boolean,
    lines: [
        Boolean,
        String
    ],
    link: {
        type: Boolean,
        "default": undefined
    },
    nav: Boolean,
    prependAvatar: String,
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    slim: Boolean,
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    value: null,
    onClick: (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    onClickOnce: (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $f0fd6b0b61967e91$export$78d5db5e8f9b041d)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VListItem');
var $d199497309ad1f0e$export$a6ee5a73ee56a146 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListItem',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $d199497309ad1f0e$export$b1024b817bbb948b(),
    emits: {
        click: function(e) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit;
        var link = (0, $f0fd6b0b61967e91$export$dcf14c9974fe2767)(props, attrs);
        var id = (0, $hXmfK.computed)(function() {
            return props.value === undefined ? link.href.value : props.value;
        });
        var _useNestedItem = (0, $07c648e7cb7675c5$export$5d8af1afc0bf0f02)(id, function() {
            return props.disabled;
        }, false), activate = _useNestedItem.activate, isActivated = _useNestedItem.isActivated, select = _useNestedItem.select, isOpen = _useNestedItem.isOpen, isSelected = _useNestedItem.isSelected, isIndeterminate = _useNestedItem.isIndeterminate, isGroupActivator = _useNestedItem.isGroupActivator, root = _useNestedItem.root, parent = _useNestedItem.parent, openOnSelect = _useNestedItem.openOnSelect, uid = _useNestedItem.id;
        var list = (0, $bfe43f6d06fb8da1$export$f9763ecd339e95eb)();
        var isActive = (0, $hXmfK.computed)(function() {
            var _link_isActive;
            return props.active !== false && (props.active || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value) || (root.activatable.value ? isActivated.value : isSelected.value));
        });
        var isLink = (0, $hXmfK.toRef)(function() {
            return props.link !== false && link.isLink.value;
        });
        var isSelectable = (0, $hXmfK.computed)(function() {
            return !!list && (root.selectable.value || root.activatable.value || props.value != null);
        });
        var isClickable = (0, $hXmfK.computed)(function() {
            return !props.disabled && props.link !== false && (props.link || link.isClickable.value || isSelectable.value);
        });
        var roundedProps = (0, $hXmfK.toRef)(function() {
            return props.rounded || props.nav;
        });
        var color = (0, $hXmfK.toRef)(function() {
            var _props_color;
            return (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.activeColor;
        });
        var variantProps = (0, $hXmfK.toRef)(function() {
            var _color_value;
            return {
                color: isActive.value ? (_color_value = color.value) !== null && _color_value !== void 0 ? _color_value : props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        // useNestedItem doesn't call register until beforeMount,
        // so this can't be an immediate watcher as we don't know parent yet
        (0, $hXmfK.watch)(function() {
            var _link_isActive;
            return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
        }, function(val) {
            if (!val) return;
            handleActiveLink();
        });
        (0, $bu8yf.onBeforeMount)(function() {
            var _link_isActive;
            if ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value) handleActiveLink();
        });
        function handleActiveLink() {
            if (parent.value != null) root.open(parent.value, true);
            openOnSelect(true);
        }
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(variantProps), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(roundedProps).roundedClasses;
        var lineClasses = (0, $hXmfK.toRef)(function() {
            return props.lines ? "v-list-item--".concat(props.lines, "-line") : undefined;
        });
        var rippleOptions = (0, $hXmfK.toRef)(function() {
            return props.ripple !== undefined && !!props.ripple && (list === null || list === void 0 ? void 0 : list.filterable) ? {
                keys: [
                    'Enter'
                ]
            } : props.ripple;
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                isActive: isActive.value,
                select: select,
                isOpen: isOpen.value,
                isSelected: isSelected.value,
                isIndeterminate: isIndeterminate.value
            };
        });
        function onClick(e) {
            var _e_target, _link_navigate;
            emit('click', e);
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.tagName)) return;
            if (!isClickable.value) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            if (isGroupActivator) return;
            if (root.activatable.value) activate(!isActivated.value, e);
            else if (root.selectable.value) select(!isSelected.value, e);
            else if (props.value != null) select(!isSelected.value, e);
        }
        function onKeyDown(e) {
            var target = e.target;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(target.tagName)) return;
            if (e.key === 'Enter' || e.key === ' ' && !(list === null || list === void 0 ? void 0 : list.filterable)) {
                e.preventDefault();
                e.stopPropagation();
                e.target.dispatchEvent(new MouseEvent('click', e));
            }
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var Tag = isLink.value ? 'a' : props.tag;
            var hasTitle = slots.title || props.title != null;
            var hasSubtitle = slots.subtitle || props.subtitle != null;
            var hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            var hasAppend = !!(hasAppendMedia || slots.append);
            var hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            var hasPrepend = !!(hasPrependMedia || slots.prepend);
            list === null || list === void 0 ? void 0 : list.updateHasPrepend(hasPrepend);
            if (props.activeColor) (0, $b0e141e3fccca32c$export$b680e6b2c82f8c2f)('active-color', [
                'color',
                'base-color'
            ]);
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(Tag, (0, $bu8yf.mergeProps)({
                "class": [
                    'v-list-item',
                    (0, $cqEAj._)({
                        'v-list-item--active': isActive.value,
                        'v-list-item--disabled': props.disabled,
                        'v-list-item--link': isClickable.value,
                        'v-list-item--nav': props.nav,
                        'v-list-item--prepend': !hasPrepend && (list === null || list === void 0 ? void 0 : list.hasPrepend.value),
                        'v-list-item--slim': props.slim
                    }, "".concat(props.activeClass), props.activeClass && isActive.value),
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props["class"]
                ],
                style: [
                    colorStyles.value,
                    dimensionStyles.value,
                    props.style
                ],
                tabindex: isClickable.value ? list ? -2 : 0 : undefined,
                "aria-selected": isSelectable.value ? root.activatable.value ? isActivated.value : root.selectable.value ? isSelected.value : isActive.value : undefined,
                onClick: onClick,
                onKeydown: isClickable.value && !isLink.value && onKeyDown
            }, link.linkProps), {
                "default": function() {
                    var _slots_default;
                    return [
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(isClickable.value || isActive.value, 'v-list-item'),
                        hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                            key: "prepend",
                            "class": "v-list-item__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                    key: "prepend-avatar",
                                    density: props.density,
                                    image: props.prependAvatar
                                }, null),
                                props.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                    key: "prepend-icon",
                                    density: props.density,
                                    icon: props.prependIcon
                                }, null)
                            ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !hasPrependMedia,
                                defaults: {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.prependAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.prependIcon
                                    },
                                    VListItemAction: {
                                        start: true
                                    }
                                }
                            }, {
                                "default": function() {
                                    var _slots_prepend;
                                    return [
                                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps.value)
                                    ];
                                }
                            }),
                            (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-list-item__content",
                            "data-no-activator": ""
                        }, [
                            hasTitle && (0, $bu8yf.createVNode)((0, $9189b661f3080a91$export$d3fcc52550436b5b), {
                                key: "title"
                            }, {
                                "default": function() {
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, {
                                            title: props.title
                                        })) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $d8jBh.toDisplayString)(props.title)
                                    ];
                                }
                            }),
                            hasSubtitle && (0, $bu8yf.createVNode)((0, $2f4a1b6bf70174ce$export$822b84d77d050116), {
                                key: "subtitle"
                            }, {
                                "default": function() {
                                    var _slots_subtitle;
                                    var _slots_subtitle1;
                                    return [
                                        (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, {
                                            subtitle: props.subtitle
                                        })) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : (0, $d8jBh.toDisplayString)(props.subtitle)
                                    ];
                                }
                            }),
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                        ]),
                        hasAppend && (0, $bu8yf.createElementVNode)("div", {
                            key: "append",
                            "class": "v-list-item__append"
                        }, [
                            !slots.append ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.appendIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                    key: "append-icon",
                                    density: props.density,
                                    icon: props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                    key: "append-avatar",
                                    density: props.density,
                                    image: props.appendAvatar
                                }, null)
                            ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "append-defaults",
                                disabled: !hasAppendMedia,
                                defaults: {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.appendIcon
                                    },
                                    VListItemAction: {
                                        end: true
                                    }
                                }
                            }, {
                                "default": function() {
                                    var _slots_append;
                                    return [
                                        (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, slotProps.value)
                                    ];
                                }
                            }),
                            (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ])
                    ];
                }
            }), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    isClickable.value && rippleOptions.value
                ]
            ]);
        });
        return {
            activate: activate,
            isActivated: isActivated,
            isGroupActivator: isGroupActivator,
            isSelected: isSelected,
            list: list,
            select: select,
            root: root,
            id: uid,
            link: link
        };
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $c18be527f2406595$export$c27aa42ccb7a1e64 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    inset: Boolean,
    sticky: Boolean,
    title: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VListSubheader');
var $c18be527f2406595$export$70c4aba7bf48e22a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListSubheader',
    props: $c18be527f2406595$export$c27aa42ccb7a1e64(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasText = !!(slots["default"] || props.title);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list-subheader',
                    {
                        'v-list-subheader--inset': props.inset,
                        'v-list-subheader--sticky': props.sticky
                    },
                    textColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        textColorStyles: textColorStyles
                    },
                    props.style
                ])
            }, {
                "default": function() {
                    var _slots_default;
                    var _slots_default1;
                    return [
                        hasText && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-list-subheader__text"
                        }, [
                            (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.title
                        ])
                    ];
                }
            });
        });
        return {};
    }
});





var $1b6748d59bc31b78$export$ee17920dc327659a = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    items: Array,
    returnObject: Boolean
}, 'VListChildren');
var $1b6748d59bc31b78$export$c0f3d26dd5c4f15a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListChildren',
    props: $1b6748d59bc31b78$export$ee17920dc327659a(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $bfe43f6d06fb8da1$export$5897d8d7c7a3d871)();
        return function() {
            var _slots_default, _props_items;
            var _slots_default1;
            return (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.map(function(_ref2) {
                var _slots_divider, _slots_subheader;
                var children = _ref2.children, itemProps = _ref2.props, type = _ref2.type, item = _ref2.raw;
                var _slots_divider1;
                if (type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                    props: itemProps
                })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), itemProps, null);
                var _slots_subheader1;
                if (type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                    props: itemProps
                })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $bu8yf.createVNode)((0, $c18be527f2406595$export$70c4aba7bf48e22a), itemProps, null);
                var slotsWithItem = {
                    subtitle: slots.subtitle ? function(slotProps) {
                        var _slots_subtitle;
                        return (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    prepend: slots.prepend ? function(slotProps) {
                        var _slots_prepend;
                        return (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    append: slots.append ? function(slotProps) {
                        var _slots_append;
                        return (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    title: slots.title ? function(slotProps) {
                        var _slots_title;
                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined
                };
                var listGroupProps = (0, $0891b6ffb0402c20$export$22fc03a43764dcc7).filterProps(itemProps);
                return children ? (0, $bu8yf.createVNode)((0, $0891b6ffb0402c20$export$22fc03a43764dcc7), (0, $bu8yf.mergeProps)(listGroupProps, {
                    value: props.returnObject ? item : itemProps === null || itemProps === void 0 ? void 0 : itemProps.value,
                    rawId: itemProps === null || itemProps === void 0 ? void 0 : itemProps.value
                }), {
                    activator: function(_ref3) {
                        var activatorProps = _ref3.props;
                        var listItemProps = (0, $emQHU._)((0, $iT0je._)({}, itemProps, activatorProps), {
                            value: props.returnObject ? item : itemProps.value
                        });
                        return slots.header ? slots.header({
                            props: listItemProps
                        }) : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), listItemProps, slotsWithItem);
                    },
                    "default": function() {
                        return (0, $bu8yf.createVNode)($1b6748d59bc31b78$export$c0f3d26dd5c4f15a, {
                            items: children,
                            returnObject: props.returnObject
                        }, slots);
                    }
                }) : slots.item ? slots.item({
                    props: itemProps
                }) : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), (0, $bu8yf.mergeProps)(itemProps, {
                    value: props.returnObject ? item : itemProps.value
                }), slotsWithItem);
            });
        };
    }
});











// Utilities

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $52b7ed45bf07e834$export$899bb842e69e7bd4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    itemTitle: {
        type: [
            String,
            Array,
            Function
        ],
        "default": 'title'
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        "default": 'value'
    },
    itemChildren: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        "default": 'children'
    },
    itemProps: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        "default": 'props'
    },
    itemType: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        "default": 'type'
    },
    returnObject: Boolean,
    valueComparator: Function
}, 'list-items');
var $52b7ed45bf07e834$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $52b7ed45bf07e834$export$ef3b10464ff5e4ec(props, item) {
    var title = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemTitle, item);
    var value = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue, title);
    var children = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemChildren);
    var itemProps = props.itemProps === true ? (typeof item === "undefined" ? "undefined" : (0, $3KZcf._)(item)) === 'object' && item != null && !Array.isArray(item) ? 'children' in item ? (0, $31779689cfd5da50$export$30a06c8d3562193f)(item, [
        'children'
    ]) : item : undefined : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemProps);
    var type = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$52b7ed45bf07e834$var$itemTypes.has(type)) type = 'item';
    var _props = (0, $iT0je._)({
        title: title,
        value: value
    }, itemProps);
    var _props_title;
    return {
        type: type,
        title: String((_props_title = _props.title) !== null && _props_title !== void 0 ? _props_title : ''),
        value: _props.value,
        props: _props,
        children: type === 'item' && Array.isArray(children) ? $52b7ed45bf07e834$export$f8e983a9ac6ba971(props, children) : undefined,
        raw: item
    };
}
$52b7ed45bf07e834$export$ef3b10464ff5e4ec.neededProps = [
    'itemTitle',
    'itemValue',
    'itemChildren',
    'itemProps',
    'itemType'
];
function $52b7ed45bf07e834$export$f8e983a9ac6ba971(props, items) {
    // avoid reactive access in the loop
    var _props = (0, $31779689cfd5da50$export$357523c63a2253b9)(props, $52b7ed45bf07e834$export$ef3b10464ff5e4ec.neededProps);
    var array = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            array.push($52b7ed45bf07e834$export$ef3b10464ff5e4ec(_props, item));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return array;
}
function $52b7ed45bf07e834$export$7bfdd97581ca93c(props) {
    var items = (0, $hXmfK.computed)(function() {
        return $52b7ed45bf07e834$export$f8e983a9ac6ba971(props, props.items);
    });
    var hasNullItem = (0, $hXmfK.computed)(function() {
        return items.value.some(function(item) {
            return item.value === null;
        });
    });
    var itemsMap = (0, $hXmfK.shallowRef)(new Map());
    var keylessItems = (0, $hXmfK.shallowRef)([]);
    (0, $bu8yf.watchEffect)(function() {
        var _items = items.value;
        var map = new Map();
        var keyless = [];
        for(var i = 0; i < _items.length; i++){
            var item = _items[i];
            if ((0, $31779689cfd5da50$export$c3825b437cbdea5c)(item.value) || item.value === null) {
                var values = map.get(item.value);
                if (!values) {
                    values = [];
                    map.set(item.value, values);
                }
                values.push(item);
            } else keyless.push(item);
        }
        itemsMap.value = map;
        keylessItems.value = keyless;
    });
    function transformIn(value) {
        // Cache unrefed values outside the loop,
        // proxy getters can be slow when you call them a billion times
        var _items = itemsMap.value;
        var _allItems = items.value;
        var _keylessItems = keylessItems.value;
        var _hasNullItem = hasNullItem.value;
        var _returnObject = props.returnObject;
        var hasValueComparator = !!props.valueComparator;
        var valueComparator = props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a);
        var _props = (0, $31779689cfd5da50$export$357523c63a2253b9)(props, $52b7ed45bf07e834$export$ef3b10464ff5e4ec.neededProps);
        var returnValue = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            main: for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                var _returnValue;
                // When the model value is null, return an InternalItem
                // based on null only if null is one of the items
                if (!_hasNullItem && v === null) continue;
                // String model value means value is a custom input value from combobox
                // Don't look up existing items if the model value is a string
                if (_returnObject && typeof v === 'string') {
                    returnValue.push($52b7ed45bf07e834$export$ef3b10464ff5e4ec(_props, v));
                    continue;
                }
                // Fast path, items with primitive values and no
                // custom valueComparator can use a constant-time
                // map lookup instead of searching the items array
                var fastItems = _items.get(v);
                // Slow path, always use valueComparator.
                // This is O(n^2) so we really don't want to
                // do it for more than a couple hundred items.
                if (hasValueComparator || !fastItems) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = (hasValueComparator ? _allItems : _keylessItems)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var item = _step1.value;
                            if (valueComparator(v, item.value)) {
                                returnValue.push(item);
                                continue main;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // Not an existing item, construct it from the model (#4000)
                    returnValue.push($52b7ed45bf07e834$export$ef3b10464ff5e4ec(_props, v));
                    continue;
                }
                (_returnValue = returnValue).push.apply(_returnValue, (0, $7WNf6._)(fastItems));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    function transformOut(value) {
        return props.returnObject ? value.map(function(_ref) {
            var raw = _ref.raw;
            return raw;
        }) : value.map(function(_ref2) {
            var _$value = _ref2.value;
            return _$value;
        });
    }
    return {
        items: items,
        transformIn: transformIn,
        transformOut: transformOut
    };
}








var $c46d6e9c2ddd50d5$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $c46d6e9c2ddd50d5$var$transformItem(props, item) {
    var title = (0, $31779689cfd5da50$export$c3825b437cbdea5c)(item) ? item : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemTitle);
    var value = (0, $31779689cfd5da50$export$c3825b437cbdea5c)(item) ? item : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue, undefined);
    var children = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemChildren);
    var itemProps = props.itemProps === true ? (0, $31779689cfd5da50$export$30a06c8d3562193f)(item, [
        'children'
    ]) : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemProps);
    var type = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$c46d6e9c2ddd50d5$var$itemTypes.has(type)) type = 'item';
    var _props = (0, $iT0je._)({
        title: title,
        value: value
    }, itemProps);
    return {
        type: type,
        title: _props.title,
        value: _props.value,
        props: _props,
        children: type === 'item' && children ? $c46d6e9c2ddd50d5$var$transformItems(props, children) : undefined,
        raw: item
    };
}
function $c46d6e9c2ddd50d5$var$transformItems(props, items) {
    var array = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            array.push($c46d6e9c2ddd50d5$var$transformItem(props, item));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return array;
}
function $c46d6e9c2ddd50d5$export$d0ca4790a6d27133(props) {
    var items = (0, $hXmfK.computed)(function() {
        return $c46d6e9c2ddd50d5$var$transformItems(props, props.items);
    });
    return {
        items: items
    };
}
var $c46d6e9c2ddd50d5$export$b385b2bc1ebed11d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    baseColor: String,
    /* @deprecated */ activeColor: String,
    activeClass: String,
    bgColor: String,
    disabled: Boolean,
    filterable: Boolean,
    expandIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    collapseIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    lines: {
        type: [
            Boolean,
            String
        ],
        "default": 'one'
    },
    slim: Boolean,
    nav: Boolean,
    'onClick:open': (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    'onClick:select': (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    'onUpdate:opened': (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $07c648e7cb7675c5$export$d902bc556a68188)({
    selectStrategy: 'single-leaf',
    openStrategy: 'list'
}), (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $52b7ed45bf07e834$export$899bb842e69e7bd4)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VList');
var $c46d6e9c2ddd50d5$export$3b010b0401837103 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VList',
    props: $c46d6e9c2ddd50d5$export$b385b2bc1ebed11d(),
    emits: {
        'update:selected': function(value) {
            return true;
        },
        'update:activated': function(value) {
            return true;
        },
        'update:opened': function(value) {
            return true;
        },
        'click:open': function(value) {
            return true;
        },
        'click:activate': function(value) {
            return true;
        },
        'click:select': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var items = $c46d6e9c2ddd50d5$export$d0ca4790a6d27133(props).items;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useNested = (0, $07c648e7cb7675c5$export$3fe10dd37d604a36)(props), children = _useNested.children, open = _useNested.open, parents = _useNested.parents, select = _useNested.select, getPath = _useNested.getPath;
        var lineClasses = (0, $hXmfK.toRef)(function() {
            return props.lines ? "v-list--".concat(props.lines, "-line") : undefined;
        });
        var activeColor = (0, $hXmfK.toRef)(function() {
            return props.activeColor;
        });
        var baseColor = (0, $hXmfK.toRef)(function() {
            return props.baseColor;
        });
        var color = (0, $hXmfK.toRef)(function() {
            return props.color;
        });
        (0, $bfe43f6d06fb8da1$export$5897d8d7c7a3d871)({
            filterable: props.filterable
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VListGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                expandIcon: (0, $hXmfK.toRef)(function() {
                    return props.expandIcon;
                }),
                collapseIcon: (0, $hXmfK.toRef)(function() {
                    return props.collapseIcon;
                })
            },
            VListItem: {
                activeClass: (0, $hXmfK.toRef)(function() {
                    return props.activeClass;
                }),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                disabled: (0, $hXmfK.toRef)(function() {
                    return props.disabled;
                }),
                lines: (0, $hXmfK.toRef)(function() {
                    return props.lines;
                }),
                nav: (0, $hXmfK.toRef)(function() {
                    return props.nav;
                }),
                slim: (0, $hXmfK.toRef)(function() {
                    return props.slim;
                }),
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        });
        var isFocused = (0, $hXmfK.shallowRef)(false);
        var contentRef = (0, $hXmfK.ref)();
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        function onFocus(e) {
            var _contentRef_value;
            if (!isFocused.value && !(e.relatedTarget && ((_contentRef_value = contentRef.value) === null || _contentRef_value === void 0 ? void 0 : _contentRef_value.contains(e.relatedTarget)))) focus();
        }
        function onKeydown(e) {
            var target = e.target;
            if (!contentRef.value || target.tagName === 'INPUT' && [
                'Home',
                'End'
            ].includes(e.key) || target.tagName === 'TEXTAREA') return;
            if (e.key === 'ArrowDown') focus('next');
            else if (e.key === 'ArrowUp') focus('prev');
            else if (e.key === 'Home') focus('first');
            else if (e.key === 'End') focus('last');
            else return;
            e.preventDefault();
        }
        function onMousedown(e) {
            isFocused.value = true;
        }
        function focus(location) {
            if (contentRef.value) return (0, $31779689cfd5da50$export$da2eafa20d5ebba)(contentRef.value, location);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                ref: contentRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list',
                    {
                        'v-list--disabled': props.disabled,
                        'v-list--nav': props.nav,
                        'v-list--slim': props.slim
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                tabindex: props.disabled ? -1 : 0,
                role: "listbox",
                "aria-activedescendant": undefined,
                onFocusin: onFocusin,
                onFocusout: onFocusout,
                onFocus: onFocus,
                onKeydown: onKeydown,
                onMousedown: onMousedown
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.createVNode)((0, $1b6748d59bc31b78$export$c0f3d26dd5c4f15a), {
                            items: items.value,
                            returnObject: props.returnObject
                        }, slots)
                    ];
                }
            });
        });
        return {
            open: open,
            select: select,
            focus: focus,
            children: children,
            parents: parents,
            getPath: getPath
        };
    }
});



var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");




var $iT0je = parcelRequire("iT0je");

var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");

// Composables

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Types
/** Convert a point in local space to viewport space */ function $8148e3aed5899e48$export$93ab817a3ebd510(point, offset) {
    return {
        x: point.x + offset.x,
        y: point.y + offset.y
    };
}
function $8148e3aed5899e48$export$c44b1fec6bb4bd91(point, offset) {
    return {
        x: point.x - offset.x,
        y: point.y - offset.y
    };
}
function $8148e3aed5899e48$export$622cea445a1c5b7d(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8148e3aed5899e48$export$461579dcc7f15045(anchor, box) {
    if (anchor.side === 'top' || anchor.side === 'bottom') {
        var side = anchor.side, align = anchor.align;
        var x = align === 'left' ? 0 : align === 'center' ? box.width / 2 : align === 'right' ? box.width : align;
        var y = side === 'top' ? 0 : side === 'bottom' ? box.height : side;
        return $8148e3aed5899e48$export$93ab817a3ebd510({
            x: x,
            y: y
        }, box);
    } else if (anchor.side === 'left' || anchor.side === 'right') {
        var side1 = anchor.side, align1 = anchor.align;
        var x1 = side1 === 'left' ? 0 : side1 === 'right' ? box.width : side1;
        var y1 = align1 === 'top' ? 0 : align1 === 'center' ? box.height / 2 : align1 === 'bottom' ? box.height : align1;
        return $8148e3aed5899e48$export$93ab817a3ebd510({
            x: x1,
            y: y1
        }, box);
    }
    return $8148e3aed5899e48$export$93ab817a3ebd510({
        x: box.width / 2,
        y: box.height / 2
    }, box);
}


function $84c2348fe514d5ac$export$cfa2225e87938781(el) {
    var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    while(el){
        if (includeHidden ? $84c2348fe514d5ac$var$isPotentiallyScrollable(el) : $84c2348fe514d5ac$export$4d450e1748530b6a(el)) return el;
        el = el.parentElement;
    }
    return document.scrollingElement;
}
function $84c2348fe514d5ac$export$94ed1c92c7beeb22(el, stopAt) {
    var elements = [];
    if (stopAt && el && !stopAt.contains(el)) return elements;
    while(el){
        if ($84c2348fe514d5ac$export$4d450e1748530b6a(el)) elements.push(el);
        if (el === stopAt) break;
        el = el.parentElement;
    }
    return elements;
}
function $84c2348fe514d5ac$export$4d450e1748530b6a(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    var style = window.getComputedStyle(el);
    return style.overflowY === 'scroll' || style.overflowY === 'auto' && el.scrollHeight > el.clientHeight;
}
function $84c2348fe514d5ac$var$isPotentiallyScrollable(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    var style = window.getComputedStyle(el);
    return [
        'scroll',
        'auto'
    ].includes(style.overflowY);
}

function $dce3fcb7cad39c43$export$a5b46f8533f8cf74(el) {
    while(el){
        if (window.getComputedStyle(el).position === 'fixed') return true;
        el = el.offsetParent;
    }
    return false;
}



var $e0b70b41941d1673$var$locationStrategies = {
    static: $e0b70b41941d1673$var$staticLocationStrategy,
    // specific viewport position, usually centered
    connected: $e0b70b41941d1673$var$connectedLocationStrategy // connected to a certain element
};
var $e0b70b41941d1673$export$4182dc895ddc707b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    locationStrategy: {
        type: [
            String,
            Function
        ],
        "default": 'static',
        validator: function(val) {
            return typeof val === 'function' || val in $e0b70b41941d1673$var$locationStrategies;
        }
    },
    location: {
        type: String,
        "default": 'bottom'
    },
    origin: {
        type: String,
        "default": 'auto'
    },
    offset: [
        Number,
        String,
        Array
    ]
}, 'VOverlay-location-strategies');
function $e0b70b41941d1673$export$ddfd163f9bbe3913(props, data) {
    var contentStyles = (0, $hXmfK.ref)({});
    var updateLocation = (0, $hXmfK.ref)();
    if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
        return !!(data.isActive.value && props.locationStrategy);
    }, function(reset) {
        var _visualViewport, _visualViewport1, _props_locationStrategy, _locationStrategies_props_locationStrategy;
        (0, $hXmfK.watch)(function() {
            return props.locationStrategy;
        }, reset);
        (0, $hXmfK.onScopeDispose)(function() {
            var _visualViewport, _visualViewport1;
            window.removeEventListener('resize', onResize);
            (_visualViewport = visualViewport) === null || _visualViewport === void 0 ? void 0 : _visualViewport.removeEventListener('resize', onVisualResize);
            (_visualViewport1 = visualViewport) === null || _visualViewport1 === void 0 ? void 0 : _visualViewport1.removeEventListener('scroll', onVisualScroll);
            updateLocation.value = undefined;
        });
        window.addEventListener('resize', onResize, {
            passive: true
        });
        (_visualViewport = visualViewport) === null || _visualViewport === void 0 ? void 0 : _visualViewport.addEventListener('resize', onVisualResize, {
            passive: true
        });
        (_visualViewport1 = visualViewport) === null || _visualViewport1 === void 0 ? void 0 : _visualViewport1.addEventListener('scroll', onVisualScroll, {
            passive: true
        });
        if (typeof props.locationStrategy === 'function') updateLocation.value = (_props_locationStrategy = props.locationStrategy(data, props, contentStyles)) === null || _props_locationStrategy === void 0 ? void 0 : _props_locationStrategy.updateLocation;
        else updateLocation.value = (_locationStrategies_props_locationStrategy = $e0b70b41941d1673$var$locationStrategies[props.locationStrategy](data, props, contentStyles)) === null || _locationStrategies_props_locationStrategy === void 0 ? void 0 : _locationStrategies_props_locationStrategy.updateLocation;
    });
    function onResize(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    function onVisualResize(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    function onVisualScroll(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    return {
        contentStyles: contentStyles,
        updateLocation: updateLocation
    };
}
function $e0b70b41941d1673$var$staticLocationStrategy() {
// TODO
}
/** Get size of element ignoring max-width/max-height */ function $e0b70b41941d1673$var$getIntrinsicSize(el, isRtl) {
    // const scrollables = new Map<Element, [number, number]>()
    // el.querySelectorAll('*').forEach(el => {
    //   const x = el.scrollLeft
    //   const y = el.scrollTop
    //   if (x || y) {
    //     scrollables.set(el, [x, y])
    //   }
    // })
    // const initialMaxWidth = el.style.maxWidth
    // const initialMaxHeight = el.style.maxHeight
    // el.style.removeProperty('max-width')
    // el.style.removeProperty('max-height')
    /* eslint-disable-next-line sonarjs/prefer-immediate-return */ var contentBox = (0, $4256e79b4dc20ac3$export$38c5b68336448fc8)(el);
    if (isRtl) contentBox.x += parseFloat(el.style.right || 0);
    else contentBox.x -= parseFloat(el.style.left || 0);
    contentBox.y -= parseFloat(el.style.top || 0);
    // el.style.maxWidth = initialMaxWidth
    // el.style.maxHeight = initialMaxHeight
    // scrollables.forEach((position, el) => {
    //   el.scrollTo(...position)
    // })
    return contentBox;
}
function $e0b70b41941d1673$var$connectedLocationStrategy(data, props, contentStyles) {
    var activatorFixed = Array.isArray(data.target.value) || (0, $dce3fcb7cad39c43$export$a5b46f8533f8cf74)(data.target.value);
    if (activatorFixed) Object.assign(contentStyles.value, (0, $cqEAj._)({
        position: 'fixed',
        top: 0
    }, data.isRtl.value ? 'right' : 'left', 0));
    var _destructComputed = (0, $31779689cfd5da50$export$fe6a5b56d01db4f5)(function() {
        var parsedAnchor = (0, $a9eac1600b361ada$export$49d416a6d8a07bbb)(props.location, data.isRtl.value);
        var parsedOrigin = props.origin === 'overlap' ? parsedAnchor : props.origin === 'auto' ? (0, $a9eac1600b361ada$export$1bbdb13cd7175683)(parsedAnchor) : (0, $a9eac1600b361ada$export$49d416a6d8a07bbb)(props.origin, data.isRtl.value);
        // Some combinations of props may produce an invalid origin
        if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === (0, $a9eac1600b361ada$export$ae4fe0e90a9c983d)(parsedOrigin).align) return {
            preferredAnchor: (0, $a9eac1600b361ada$export$af41802054d9b2a8)(parsedAnchor),
            preferredOrigin: (0, $a9eac1600b361ada$export$af41802054d9b2a8)(parsedOrigin)
        };
        else return {
            preferredAnchor: parsedAnchor,
            preferredOrigin: parsedOrigin
        };
    }), preferredAnchor = _destructComputed.preferredAnchor, preferredOrigin = _destructComputed.preferredOrigin;
    var _map = (0, $32TW8._)([
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight'
    ].map(function(key) {
        return (0, $hXmfK.computed)(function() {
            var val = parseFloat(props[key]);
            return isNaN(val) ? Infinity : val;
        });
    }), 4), minWidth = _map[0], minHeight = _map[1], maxWidth = _map[2], maxHeight = _map[3];
    var offset = (0, $hXmfK.computed)(function() {
        if (Array.isArray(props.offset)) return props.offset;
        if (typeof props.offset === 'string') {
            var offset = props.offset.split(' ').map(parseFloat);
            if (offset.length < 2) offset.push(0);
            return offset;
        }
        return typeof props.offset === 'number' ? [
            props.offset,
            0
        ] : [
            0,
            0
        ];
    });
    var observe = false;
    var lastFrame = -1;
    var flipped = new (0, $31779689cfd5da50$export$5900cd5f89b9a13a)(4);
    var observer = new ResizeObserver(function() {
        if (!observe) return;
        // Detect consecutive frames
        requestAnimationFrame(function(newTime) {
            if (newTime !== lastFrame) flipped.clear();
            requestAnimationFrame(function(newNewTime) {
                lastFrame = newNewTime;
            });
        });
        if (flipped.isFull) {
            var values = flipped.values();
            if ((0, $31779689cfd5da50$export$9cb4719e2e525b7a)(values.at(-1), values.at(-3)) && !(0, $31779689cfd5da50$export$9cb4719e2e525b7a)(values.at(-1), values.at(-2))) // Flipping is causing a container resize loop
            return;
        }
        var result = updateLocation();
        if (result) flipped.push(result.flipped);
    });
    (0, $hXmfK.watch)([
        data.target,
        data.contentEl
    ], function(_ref, _ref2) {
        var _$_ref = (0, $32TW8._)(_ref, 2), newTarget = _$_ref[0], newContentEl = _$_ref[1];
        var _$_ref2 = (0, $32TW8._)(_ref2, 2), oldTarget = _$_ref2[0], oldContentEl = _$_ref2[1];
        if (oldTarget && !Array.isArray(oldTarget)) observer.unobserve(oldTarget);
        if (newTarget && !Array.isArray(newTarget)) observer.observe(newTarget);
        if (oldContentEl) observer.unobserve(oldContentEl);
        if (newContentEl) observer.observe(newContentEl);
    }, {
        immediate: true
    });
    (0, $hXmfK.onScopeDispose)(function() {
        observer.disconnect();
    });
    var targetBox = new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    // eslint-disable-next-line max-statements
    function updateLocation() {
        var _loop = function() {
            if (resets++ > 10) {
                (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)('Infinite loop detected in connectedLocationStrategy');
                return "break";
            }
            var _checkOverflow = checkOverflow(placement), _x = _checkOverflow.x, _y = _checkOverflow.y, overflows = _checkOverflow.overflows;
            x += _x;
            y += _y;
            contentBox.x += _x;
            contentBox.y += _y;
            // flip
            {
                var axis = (0, $a9eac1600b361ada$export$8a3a0724d206787a)(placement.anchor);
                var hasOverflowX = overflows.x.before || overflows.x.after;
                var hasOverflowY = overflows.y.before || overflows.y.after;
                var reset = false;
                [
                    'x',
                    'y'
                ].forEach(function(key) {
                    if (key === 'x' && hasOverflowX && !flipped.x || key === 'y' && hasOverflowY && !flipped.y) {
                        var newPlacement = {
                            anchor: (0, $iT0je._)({}, placement.anchor),
                            origin: (0, $iT0je._)({}, placement.origin)
                        };
                        var flip = key === 'x' ? axis === 'y' ? (0, $a9eac1600b361ada$export$ae4fe0e90a9c983d) : (0, $a9eac1600b361ada$export$1bbdb13cd7175683) : axis === 'y' ? (0, $a9eac1600b361ada$export$1bbdb13cd7175683) : (0, $a9eac1600b361ada$export$ae4fe0e90a9c983d);
                        newPlacement.anchor = flip(newPlacement.anchor);
                        newPlacement.origin = flip(newPlacement.origin);
                        var _checkOverflow = checkOverflow(newPlacement), newOverflows = _checkOverflow.overflows;
                        if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
                            placement = newPlacement;
                            reset = flipped[key] = true;
                        }
                    }
                });
                if (reset) return "continue";
            }
            // shift
            if (overflows.x.before) {
                x += overflows.x.before;
                contentBox.x += overflows.x.before;
            }
            if (overflows.x.after) {
                x -= overflows.x.after;
                contentBox.x -= overflows.x.after;
            }
            if (overflows.y.before) {
                y += overflows.y.before;
                contentBox.y += overflows.y.before;
            }
            if (overflows.y.after) {
                y -= overflows.y.after;
                contentBox.y -= overflows.y.after;
            }
            // size
            {
                var overflows1 = (0, $a9f6a424a63666a1$export$f63a1e5ecde5e3c4)(contentBox, viewport);
                available.x = viewport.width - overflows1.x.before - overflows1.x.after;
                available.y = viewport.height - overflows1.y.before - overflows1.y.after;
                x += overflows1.x.before;
                contentBox.x += overflows1.x.before;
                y += overflows1.y.before;
                contentBox.y += overflows1.y.before;
            }
            return "break";
        };
        observe = false;
        requestAnimationFrame(function() {
            return observe = true;
        });
        if (!data.target.value || !data.contentEl.value) return;
        if (Array.isArray(data.target.value) || data.target.value.offsetParent || data.target.value.getClientRects().length) targetBox = (0, $a9f6a424a63666a1$export$abd662d1b0b39d49)(data.target.value);
         // Otherwise target element is hidden, use last known value
        var contentBox = $e0b70b41941d1673$var$getIntrinsicSize(data.contentEl.value, data.isRtl.value);
        var scrollParents = (0, $84c2348fe514d5ac$export$94ed1c92c7beeb22)(data.contentEl.value);
        var viewportMargin = 12;
        if (!scrollParents.length) {
            scrollParents.push(document.documentElement);
            if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
                contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-x') || 0);
                contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-y') || 0);
            }
        }
        var viewport = scrollParents.reduce(function(box, el) {
            var scrollBox = (0, $a9f6a424a63666a1$export$6f532722e5bcfbac)(el);
            if (box) return new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)({
                x: Math.max(box.left, scrollBox.left),
                y: Math.max(box.top, scrollBox.top),
                width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
                height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
            });
            return scrollBox;
        }, undefined);
        viewport.x += viewportMargin;
        viewport.y += viewportMargin;
        viewport.width -= viewportMargin * 2;
        viewport.height -= viewportMargin * 2;
        var placement = {
            anchor: preferredAnchor.value,
            origin: preferredOrigin.value
        };
        function checkOverflow(_placement) {
            var box = new (0, $a9f6a424a63666a1$export$e71c4d32a2263218)(contentBox);
            var targetPoint = (0, $8148e3aed5899e48$export$461579dcc7f15045)(_placement.anchor, targetBox);
            var contentPoint = (0, $8148e3aed5899e48$export$461579dcc7f15045)(_placement.origin, box);
            var _getOffset = (0, $8148e3aed5899e48$export$622cea445a1c5b7d)(targetPoint, contentPoint), x = _getOffset.x, y = _getOffset.y;
            switch(_placement.anchor.side){
                case 'top':
                    y -= offset.value[0];
                    break;
                case 'bottom':
                    y += offset.value[0];
                    break;
                case 'left':
                    x -= offset.value[0];
                    break;
                case 'right':
                    x += offset.value[0];
                    break;
            }
            switch(_placement.anchor.align){
                case 'top':
                    y -= offset.value[1];
                    break;
                case 'bottom':
                    y += offset.value[1];
                    break;
                case 'left':
                    x -= offset.value[1];
                    break;
                case 'right':
                    x += offset.value[1];
                    break;
            }
            box.x += x;
            box.y += y;
            box.width = Math.min(box.width, maxWidth.value);
            box.height = Math.min(box.height, maxHeight.value);
            var overflows = (0, $a9f6a424a63666a1$export$f63a1e5ecde5e3c4)(box, viewport);
            return {
                overflows: overflows,
                x: x,
                y: y
            };
        }
        var x = 0;
        var y = 0;
        var available = {
            x: 0,
            y: 0
        };
        var flipped = {
            x: false,
            y: false
        };
        var resets = -1;
        while(true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
        var axis = (0, $a9eac1600b361ada$export$8a3a0724d206787a)(placement.anchor);
        Object.assign(contentStyles.value, {
            '--v-overlay-anchor-origin': "".concat(placement.anchor.side, " ").concat(placement.anchor.align),
            transformOrigin: "".concat(placement.origin.side, " ").concat(placement.origin.align),
            // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
            top: (0, $31779689cfd5da50$export$286ad215293a0860)($e0b70b41941d1673$var$pixelRound(y)),
            left: data.isRtl.value ? undefined : (0, $31779689cfd5da50$export$286ad215293a0860)($e0b70b41941d1673$var$pixelRound(x)),
            right: data.isRtl.value ? (0, $31779689cfd5da50$export$286ad215293a0860)($e0b70b41941d1673$var$pixelRound(-x)) : undefined,
            minWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(axis === 'y' ? Math.min(minWidth.value, targetBox.width) : minWidth.value),
            maxWidth: (0, $31779689cfd5da50$export$286ad215293a0860)($e0b70b41941d1673$var$pixelCeil((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(available.x, minWidth.value === Infinity ? 0 : minWidth.value, maxWidth.value))),
            maxHeight: (0, $31779689cfd5da50$export$286ad215293a0860)($e0b70b41941d1673$var$pixelCeil((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(available.y, minHeight.value === Infinity ? 0 : minHeight.value, maxHeight.value)))
        });
        return {
            available: available,
            contentBox: contentBox,
            flipped: flipped
        };
    }
    (0, $hXmfK.watch)(function() {
        return [
            preferredAnchor.value,
            preferredOrigin.value,
            props.offset,
            props.minWidth,
            props.minHeight,
            props.maxWidth,
            props.maxHeight
        ];
    }, function() {
        return updateLocation();
    });
    (0, $bu8yf.nextTick)(function() {
        var result = updateLocation();
        // TODO: overflowing content should only require a single updateLocation call
        // Icky hack to make sure the content is positioned consistently
        if (!result) return;
        var available = result.available, contentBox = result.contentBox;
        if (contentBox.height > available.y) requestAnimationFrame(function() {
            updateLocation();
            requestAnimationFrame(function() {
                updateLocation();
            });
        });
    });
    return {
        updateLocation: updateLocation
    };
}
function $e0b70b41941d1673$var$pixelRound(val) {
    return Math.round(val * devicePixelRatio) / devicePixelRatio;
}
function $e0b70b41941d1673$var$pixelCeil(val) {
    return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
}


// Utilities

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $929b00ca98ddd93d$var$clean = true;
var $929b00ca98ddd93d$var$frames = [];
function $929b00ca98ddd93d$export$feb8bc9b30dfb99(cb) {
    if (!$929b00ca98ddd93d$var$clean || $929b00ca98ddd93d$var$frames.length) {
        $929b00ca98ddd93d$var$frames.push(cb);
        $929b00ca98ddd93d$var$run();
    } else {
        $929b00ca98ddd93d$var$clean = false;
        cb();
        $929b00ca98ddd93d$var$run();
    }
}
var $929b00ca98ddd93d$var$raf = -1;
function $929b00ca98ddd93d$var$run() {
    cancelAnimationFrame($929b00ca98ddd93d$var$raf);
    $929b00ca98ddd93d$var$raf = requestAnimationFrame(function() {
        var frame = $929b00ca98ddd93d$var$frames.shift();
        if (frame) frame();
        if ($929b00ca98ddd93d$var$frames.length) $929b00ca98ddd93d$var$run();
        else $929b00ca98ddd93d$var$clean = true;
    });
}



var $093192ffed1e6058$var$scrollStrategies = {
    none: null,
    close: $093192ffed1e6058$var$closeScrollStrategy,
    block: $093192ffed1e6058$var$blockScrollStrategy,
    reposition: $093192ffed1e6058$var$repositionScrollStrategy
};
var $093192ffed1e6058$export$5844d560a14f1eae = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    scrollStrategy: {
        type: [
            String,
            Function
        ],
        "default": 'block',
        validator: function(val) {
            return typeof val === 'function' || val in $093192ffed1e6058$var$scrollStrategies;
        }
    }
}, 'VOverlay-scroll-strategies');
function $093192ffed1e6058$export$a9bfea786f4e2928(props, data) {
    if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) return;
    var scope;
    (0, $bu8yf.watchEffect)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        scope === null || scope === void 0 ? void 0 : scope.stop();
                        if (!(data.isActive.value && props.scrollStrategy)) return [
                            2
                        ];
                        scope = (0, $hXmfK.effectScope)();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve);
                            })
                        ];
                    case 1:
                        _state.sent();
                        scope.active && scope.run(function() {
                            var _scrollStrategies_props_scrollStrategy;
                            if (typeof props.scrollStrategy === 'function') props.scrollStrategy(data, props, scope);
                            else (_scrollStrategies_props_scrollStrategy = $093192ffed1e6058$var$scrollStrategies[props.scrollStrategy]) === null || _scrollStrategies_props_scrollStrategy === void 0 ? void 0 : _scrollStrategies_props_scrollStrategy.call($093192ffed1e6058$var$scrollStrategies, data, props, scope);
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    });
    (0, $hXmfK.onScopeDispose)(function() {
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
}
function $093192ffed1e6058$var$closeScrollStrategy(data) {
    function onScroll(e) {
        data.isActive.value = false;
    }
    var _data_targetEl_value;
    $093192ffed1e6058$var$bindScroll((_data_targetEl_value = data.targetEl.value) !== null && _data_targetEl_value !== void 0 ? _data_targetEl_value : data.contentEl.value, onScroll);
}
function $093192ffed1e6058$var$blockScrollStrategy(data, props) {
    var _data_root_value;
    var offsetParent = (_data_root_value = data.root.value) === null || _data_root_value === void 0 ? void 0 : _data_root_value.offsetParent;
    var scrollElements = (0, $7WNf6._)(new Set((0, $7WNf6._)((0, $84c2348fe514d5ac$export$94ed1c92c7beeb22)(data.targetEl.value, props.contained ? offsetParent : undefined)).concat((0, $7WNf6._)((0, $84c2348fe514d5ac$export$94ed1c92c7beeb22)(data.contentEl.value, props.contained ? offsetParent : undefined))))).filter(function(el) {
        return !el.classList.contains('v-overlay-scroll-blocked');
    });
    var scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
    var scrollableParent = function(el) {
        return (0, $84c2348fe514d5ac$export$4d450e1748530b6a)(el) && el;
    }(offsetParent || document.documentElement);
    if (scrollableParent) data.root.value.classList.add('v-overlay--scroll-blocked');
    scrollElements.forEach(function(el, i) {
        el.style.setProperty('--v-body-scroll-x', (0, $31779689cfd5da50$export$286ad215293a0860)(-el.scrollLeft));
        el.style.setProperty('--v-body-scroll-y', (0, $31779689cfd5da50$export$286ad215293a0860)(-el.scrollTop));
        if (el !== document.documentElement) el.style.setProperty('--v-scrollbar-offset', (0, $31779689cfd5da50$export$286ad215293a0860)(scrollbarWidth));
        el.classList.add('v-overlay-scroll-blocked');
    });
    (0, $hXmfK.onScopeDispose)(function() {
        scrollElements.forEach(function(el, i) {
            var x = parseFloat(el.style.getPropertyValue('--v-body-scroll-x'));
            var y = parseFloat(el.style.getPropertyValue('--v-body-scroll-y'));
            var scrollBehavior = el.style.scrollBehavior;
            el.style.scrollBehavior = 'auto';
            el.style.removeProperty('--v-body-scroll-x');
            el.style.removeProperty('--v-body-scroll-y');
            el.style.removeProperty('--v-scrollbar-offset');
            el.classList.remove('v-overlay-scroll-blocked');
            el.scrollLeft = -x;
            el.scrollTop = -y;
            el.style.scrollBehavior = scrollBehavior;
        });
        if (scrollableParent) data.root.value.classList.remove('v-overlay--scroll-blocked');
    });
}
function $093192ffed1e6058$var$repositionScrollStrategy(data, props, scope) {
    var slow = false;
    var raf = -1;
    var ric = -1;
    function update(e) {
        (0, $929b00ca98ddd93d$export$feb8bc9b30dfb99)(function() {
            var _data_updateLocation_value, _data_updateLocation;
            var start = performance.now();
            (_data_updateLocation_value = (_data_updateLocation = data.updateLocation).value) === null || _data_updateLocation_value === void 0 ? void 0 : _data_updateLocation_value.call(_data_updateLocation, e);
            var time = performance.now() - start;
            slow = time / (1000 / 60) > 2;
        });
    }
    ric = (typeof requestIdleCallback === 'undefined' ? function(cb) {
        return cb();
    } : requestIdleCallback)(function() {
        scope.run(function() {
            var _data_targetEl_value;
            $093192ffed1e6058$var$bindScroll((_data_targetEl_value = data.targetEl.value) !== null && _data_targetEl_value !== void 0 ? _data_targetEl_value : data.contentEl.value, function(e) {
                if (slow) {
                    // If the position calculation is slow,
                    // defer updates until scrolling is finished.
                    // Browsers usually fire one scroll event per frame so
                    // we just wait until we've got two frames without an event
                    cancelAnimationFrame(raf);
                    raf = requestAnimationFrame(function() {
                        raf = requestAnimationFrame(function() {
                            update(e);
                        });
                    });
                } else update(e);
            });
        });
    });
    (0, $hXmfK.onScopeDispose)(function() {
        typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(ric);
        cancelAnimationFrame(raf);
    });
}
/** @private */ function $093192ffed1e6058$var$bindScroll(el, onScroll) {
    var scrollElements = [
        document
    ].concat((0, $7WNf6._)((0, $84c2348fe514d5ac$export$94ed1c92c7beeb22)(el)));
    scrollElements.forEach(function(el) {
        el.addEventListener('scroll', onScroll, {
            passive: true
        });
    });
    (0, $hXmfK.onScopeDispose)(function() {
        scrollElements.forEach(function(el) {
            el.removeEventListener('scroll', onScroll);
        });
    });
}


// Components

var $iT0je = parcelRequire("iT0je");
// Types
var $76bbdc0d2219a4a0$export$d60452ec716149a1 = Symbol["for"]('vuetify:v-menu');


// Utilities

var $993255c150474af1$export$1fd3611e92a5a94 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    closeDelay: [
        Number,
        String
    ],
    openDelay: [
        Number,
        String
    ]
}, 'delay');
function $993255c150474af1$export$69f38700ea0cb3b9(props, cb) {
    var clearDelay = function() {};
    function runDelay(isOpening) {
        clearDelay === null || clearDelay === void 0 ? void 0 : clearDelay();
        var delay = Number(isOpening ? props.openDelay : props.closeDelay);
        return new Promise(function(resolve) {
            clearDelay = (0, $31779689cfd5da50$export$260e5c0943f31606)(delay, function() {
                cb === null || cb === void 0 ? void 0 : cb(isOpening);
                resolve(isOpening);
            });
        });
    }
    function runOpenDelay() {
        return runDelay(true);
    }
    function runCloseDelay() {
        return runDelay(false);
    }
    return {
        clearDelay: clearDelay,
        runOpenDelay: runOpenDelay,
        runCloseDelay: runCloseDelay
    };
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Utilities

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $102874130e39911f$var$handlers = new WeakMap();
function $102874130e39911f$export$b89d4640a29d673a(el, props) {
    Object.keys(props).forEach(function(k) {
        if ((0, $31779689cfd5da50$export$1a2d97de39ecbb75)(k)) {
            var _this;
            var name = (0, $31779689cfd5da50$export$a0305a8c6cff19c8)(k);
            var handler = $102874130e39911f$var$handlers.get(el);
            if (props[k] == null) handler === null || handler === void 0 ? void 0 : handler.forEach(function(v) {
                var _v = (0, $32TW8._)(v, 2), n = _v[0], fn = _v[1];
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler["delete"](v);
                }
            });
            else if (!handler || !((_this = (0, $7WNf6._)(handler)) === null || _this === void 0 ? void 0 : _this.some(function(v) {
                return v[0] === name && v[1] === props[k];
            }))) {
                el.addEventListener(name, props[k]);
                var _handler = handler || new Set();
                _handler.add([
                    name,
                    props[k]
                ]);
                if (!$102874130e39911f$var$handlers.has(el)) $102874130e39911f$var$handlers.set(el, _handler);
            }
        } else if (props[k] == null) el.removeAttribute(k);
        else el.setAttribute(k, props[k]);
    });
}
function $102874130e39911f$export$58b6a9c1df4f180e(el, props) {
    Object.keys(props).forEach(function(k) {
        if ((0, $31779689cfd5da50$export$1a2d97de39ecbb75)(k)) {
            var name = (0, $31779689cfd5da50$export$a0305a8c6cff19c8)(k);
            var handler = $102874130e39911f$var$handlers.get(el);
            handler === null || handler === void 0 ? void 0 : handler.forEach(function(v) {
                var _v = (0, $32TW8._)(v, 2), n = _v[0], fn = _v[1];
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler["delete"](v);
                }
            });
        } else el.removeAttribute(k);
    });
}


var $e13daf3c801d57db$export$86105a8dfc563397 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    target: [
        String,
        Object
    ],
    activator: [
        String,
        Object
    ],
    activatorProps: {
        type: Object,
        "default": function() {
            return {};
        }
    },
    openOnClick: {
        type: Boolean,
        "default": undefined
    },
    openOnHover: Boolean,
    openOnFocus: {
        type: Boolean,
        "default": undefined
    },
    closeOnContentClick: Boolean
}, (0, $993255c150474af1$export$1fd3611e92a5a94)()), 'VOverlay-activator');
function $e13daf3c801d57db$export$c66a9a6f2d14727a(props, _ref) {
    var isActive = _ref.isActive, isTop = _ref.isTop, contentEl = _ref.contentEl;
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useActivator');
    var activatorEl = (0, $hXmfK.ref)();
    var isHovered = false;
    var isFocused = false;
    var firstEnter = true;
    var openOnFocus = (0, $hXmfK.computed)(function() {
        return props.openOnFocus || props.openOnFocus == null && props.openOnHover;
    });
    var openOnClick = (0, $hXmfK.computed)(function() {
        return props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value;
    });
    var _useDelay = (0, $993255c150474af1$export$69f38700ea0cb3b9)(props, function(value) {
        if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
            if (isActive.value !== value) firstEnter = true;
            isActive.value = value;
        }
    }), runOpenDelay = _useDelay.runOpenDelay, runCloseDelay = _useDelay.runCloseDelay;
    var cursorTarget = (0, $hXmfK.ref)();
    var availableEvents = {
        onClick: function(e) {
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            if (!isActive.value) cursorTarget.value = [
                e.clientX,
                e.clientY
            ];
            isActive.value = !isActive.value;
        },
        onMouseenter: function(e) {
            var _e_sourceCapabilities;
            if ((_e_sourceCapabilities = e.sourceCapabilities) === null || _e_sourceCapabilities === void 0 ? void 0 : _e_sourceCapabilities.firesTouchEvents) return;
            isHovered = true;
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onMouseleave: function(e) {
            isHovered = false;
            runCloseDelay();
        },
        onFocus: function(e) {
            if ((0, $31779689cfd5da50$export$b06a2f5618961e1e)(e.target, ':focus-visible') === false) return;
            isFocused = true;
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onBlur: function(e) {
            isFocused = false;
            e.stopPropagation();
            runCloseDelay();
        }
    };
    var activatorEvents = (0, $hXmfK.computed)(function() {
        var events = {};
        if (openOnClick.value) events.onClick = availableEvents.onClick;
        if (props.openOnHover) {
            events.onMouseenter = availableEvents.onMouseenter;
            events.onMouseleave = availableEvents.onMouseleave;
        }
        if (openOnFocus.value) {
            events.onFocus = availableEvents.onFocus;
            events.onBlur = availableEvents.onBlur;
        }
        return events;
    });
    var contentEvents = (0, $hXmfK.computed)(function() {
        var events = {};
        if (props.openOnHover) {
            events.onMouseenter = function() {
                isHovered = true;
                runOpenDelay();
            };
            events.onMouseleave = function() {
                isHovered = false;
                runCloseDelay();
            };
        }
        if (openOnFocus.value) {
            events.onFocusin = function() {
                isFocused = true;
                runOpenDelay();
            };
            events.onFocusout = function() {
                isFocused = false;
                runCloseDelay();
            };
        }
        if (props.closeOnContentClick) {
            var menu = (0, $bu8yf.inject)((0, $76bbdc0d2219a4a0$export$d60452ec716149a1), null);
            events.onClick = function() {
                isActive.value = false;
                menu === null || menu === void 0 ? void 0 : menu.closeParents();
            };
        }
        return events;
    });
    var scrimEvents = (0, $hXmfK.computed)(function() {
        var events = {};
        if (props.openOnHover) {
            events.onMouseenter = function() {
                if (firstEnter) {
                    isHovered = true;
                    firstEnter = false;
                    runOpenDelay();
                }
            };
            events.onMouseleave = function() {
                isHovered = false;
                runCloseDelay();
            };
        }
        return events;
    });
    (0, $hXmfK.watch)(isTop, function(val) {
        var _contentEl_value;
        if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered)) && !((_contentEl_value = contentEl.value) === null || _contentEl_value === void 0 ? void 0 : _contentEl_value.contains(document.activeElement))) isActive.value = false;
    });
    (0, $hXmfK.watch)(isActive, function(val) {
        if (!val) setTimeout(function() {
            cursorTarget.value = undefined;
        });
    }, {
        flush: 'post'
    });
    var activatorRef = (0, $31779689cfd5da50$export$fc38e812d383221)();
    (0, $bu8yf.watchEffect)(function() {
        if (!activatorRef.value) return;
        (0, $bu8yf.nextTick)(function() {
            activatorEl.value = activatorRef.el;
        });
    });
    var targetRef = (0, $31779689cfd5da50$export$fc38e812d383221)();
    var target = (0, $hXmfK.computed)(function() {
        if (props.target === 'cursor' && cursorTarget.value) return cursorTarget.value;
        if (targetRef.value) return targetRef.el;
        return $e13daf3c801d57db$var$getTarget(props.target, vm) || activatorEl.value;
    });
    var targetEl = (0, $hXmfK.computed)(function() {
        return Array.isArray(target.value) ? undefined : target.value;
    });
    var scope;
    (0, $hXmfK.watch)(function() {
        return !!props.activator;
    }, function(val) {
        if (val && (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) {
            scope = (0, $hXmfK.effectScope)();
            scope.run(function() {
                $e13daf3c801d57db$var$_useActivator(props, vm, {
                    activatorEl: activatorEl,
                    activatorEvents: activatorEvents
                });
            });
        } else if (scope) scope.stop();
    }, {
        flush: 'post',
        immediate: true
    });
    (0, $hXmfK.onScopeDispose)(function() {
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
    return {
        activatorEl: activatorEl,
        activatorRef: activatorRef,
        target: target,
        targetEl: targetEl,
        targetRef: targetRef,
        activatorEvents: activatorEvents,
        contentEvents: contentEvents,
        scrimEvents: scrimEvents
    };
}
function $e13daf3c801d57db$var$_useActivator(props, vm, _ref2) {
    var activatorEl = _ref2.activatorEl, activatorEvents = _ref2.activatorEvents;
    (0, $hXmfK.watch)(function() {
        return props.activator;
    }, function(val, oldVal) {
        if (oldVal && val !== oldVal) {
            var activator = getActivator(oldVal);
            activator && unbindActivatorProps(activator);
        }
        if (val) (0, $bu8yf.nextTick)(function() {
            return bindActivatorProps();
        });
    }, {
        immediate: true
    });
    (0, $hXmfK.watch)(function() {
        return props.activatorProps;
    }, function() {
        bindActivatorProps();
    });
    (0, $hXmfK.onScopeDispose)(function() {
        unbindActivatorProps();
    });
    function bindActivatorProps() {
        var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        var _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $102874130e39911f$export$b89d4640a29d673a)(el, (0, $bu8yf.mergeProps)(activatorEvents.value, _props));
    }
    function unbindActivatorProps() {
        var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        var _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $102874130e39911f$export$58b6a9c1df4f180e)(el, (0, $bu8yf.mergeProps)(activatorEvents.value, _props));
    }
    function getActivator() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props.activator;
        var activator = $e13daf3c801d57db$var$getTarget(selector, vm);
        // The activator should only be a valid element (Ignore comments and text nodes)
        activatorEl.value = (activator === null || activator === void 0 ? void 0 : activator.nodeType) === Node.ELEMENT_NODE ? activator : undefined;
        return activatorEl.value;
    }
}
function $e13daf3c801d57db$var$getTarget(selector, vm) {
    if (!selector) return;
    var target;
    if (selector === 'parent') {
        var _vm_proxy_$el, _vm_proxy;
        var el = vm === null || vm === void 0 ? void 0 : (_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : (_vm_proxy_$el = _vm_proxy.$el) === null || _vm_proxy_$el === void 0 ? void 0 : _vm_proxy_$el.parentNode;
        while(el === null || el === void 0 ? void 0 : el.hasAttribute('data-no-activator'))el = el.parentNode;
        target = el;
    } else if (typeof selector === 'string') // Selector
    target = document.querySelector(selector);
    else if ('$el' in selector) // Component (ref)
    target = selector.$el;
    else // HTMLElement | Element | [x, y]
    target = selector;
    return target;
}





// Composables

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

function $5e2188d9568ff520$export$5b8689c380bcb3d5() {
    if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) return (0, $hXmfK.shallowRef)(false);
    var ssr = (0, $a7414385605a88b0$export$8406b7efc286d284)().ssr;
    if (ssr) {
        var isMounted = (0, $hXmfK.shallowRef)(false);
        (0, $bu8yf.onMounted)(function() {
            isMounted.value = true;
        });
        return isMounted;
    } else return (0, $hXmfK.shallowRef)(true);
}


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $2a56e630d56c9097$export$3557c26df64490a4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    eager: Boolean
}, 'lazy');
function $2a56e630d56c9097$export$965f98646215a1bd(props, active) {
    var isBooted = (0, $hXmfK.shallowRef)(false);
    var hasContent = (0, $hXmfK.toRef)(function() {
        return isBooted.value || props.eager || active.value;
    });
    (0, $hXmfK.watch)(active, function() {
        return isBooted.value = true;
    });
    function onAfterLeave() {
        if (!props.eager) isBooted.value = false;
    }
    return {
        isBooted: isBooted,
        hasContent: hasContent,
        onAfterLeave: onAfterLeave
    };
}





// Utilities

var $cqEAj = parcelRequire("cqEAj");

function $11b601c8e67368ec$export$eeabe5cda932100d() {
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useScopeId');
    var scopeId = vm.vnode.scopeId;
    return {
        scopeId: scopeId ? (0, $cqEAj._)({}, scopeId, '') : undefined
    };
}


// Composables

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

var $6708ec152cef4976$var$StackSymbol = Symbol["for"]('vuetify:stack');
var $6708ec152cef4976$var$globalStack = (0, $hXmfK.reactive)([]);
function $6708ec152cef4976$export$df58951aab233134(isActive, zIndex, disableGlobalStack) {
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('useStack');
    var createStackEntry = !disableGlobalStack;
    var parent = (0, $bu8yf.inject)($6708ec152cef4976$var$StackSymbol, undefined);
    var stack = (0, $hXmfK.reactive)({
        activeChildren: new Set()
    });
    (0, $bu8yf.provide)($6708ec152cef4976$var$StackSymbol, stack);
    var _zIndex = (0, $hXmfK.shallowRef)(Number((0, $hXmfK.toValue)(zIndex)));
    (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(isActive, function() {
        var _globalStack_at;
        var lastZIndex = (_globalStack_at = $6708ec152cef4976$var$globalStack.at(-1)) === null || _globalStack_at === void 0 ? void 0 : _globalStack_at[1];
        _zIndex.value = lastZIndex ? lastZIndex + 10 : Number((0, $hXmfK.toValue)(zIndex));
        if (createStackEntry) $6708ec152cef4976$var$globalStack.push([
            vm.uid,
            _zIndex.value
        ]);
        parent === null || parent === void 0 ? void 0 : parent.activeChildren.add(vm.uid);
        (0, $hXmfK.onScopeDispose)(function() {
            if (createStackEntry) {
                var idx = (0, $hXmfK.toRaw)($6708ec152cef4976$var$globalStack).findIndex(function(v) {
                    return v[0] === vm.uid;
                });
                $6708ec152cef4976$var$globalStack.splice(idx, 1);
            }
            parent === null || parent === void 0 ? void 0 : parent.activeChildren["delete"](vm.uid);
        });
    });
    var globalTop = (0, $hXmfK.shallowRef)(true);
    if (createStackEntry) (0, $bu8yf.watchEffect)(function() {
        var _globalStack_at;
        var _isTop = ((_globalStack_at = $6708ec152cef4976$var$globalStack.at(-1)) === null || _globalStack_at === void 0 ? void 0 : _globalStack_at[0]) === vm.uid;
        setTimeout(function() {
            return globalTop.value = _isTop;
        });
    });
    var localTop = (0, $hXmfK.toRef)(function() {
        return !stack.activeChildren.size;
    });
    return {
        globalTop: (0, $hXmfK.readonly)(globalTop),
        localTop: localTop,
        stackStyles: (0, $hXmfK.toRef)(function() {
            return {
                zIndex: _zIndex.value
            };
        })
    };
}


// Utilities

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

function $8f00b86b63b14852$export$b6ab74bf6ad20b87(target) {
    var teleportTarget = (0, $hXmfK.computed)(function() {
        var _target = target();
        if (_target === true || !(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) return undefined;
        var targetElement = _target === false ? document.body : typeof _target === 'string' ? document.querySelector(_target) : _target;
        if (targetElement == null) {
            (0, $bu8yf.warn)("Unable to locate target ".concat(_target));
            return undefined;
        }
        var container = (0, $7WNf6._)(targetElement.children).find(function(el) {
            return el.matches('.v-overlay-container');
        });
        if (!container) {
            container = document.createElement('div');
            container.className = 'v-overlay-container';
            targetElement.appendChild(container);
        }
        return container;
    });
    return {
        teleportTarget: teleportTarget
    };
}





// Utilities

var $3KZcf = parcelRequire("3KZcf");
/**
 * Returns:
 *  - 'null' if the node is not attached to the DOM
 *  - the root node (HTMLDocument | ShadowRoot) otherwise
 */ function $55c0ae8808484c3c$export$3be35968ed281992(node) {
    /* istanbul ignore next */ if (typeof node.getRootNode !== 'function') {
        // Shadow DOM not supported (IE11), lets find the root of this node
        while(node.parentNode)node = node.parentNode;
        // The root parent is the document if the node is attached to the DOM
        if (node !== document) return null;
        return document;
    }
    var root = node.getRootNode();
    // The composed root node is the document if the node is attached to the DOM
    if (root !== document && root.getRootNode({
        composed: true
    }) !== document) return null;
    return root;
}


function $022086ec11d4df23$var$defaultConditional() {
    return true;
}
function $022086ec11d4df23$var$checkEvent(e, el, binding) {
    // The include element callbacks below can be expensive
    // so we should avoid calling them when we're not active.
    // Explicitly check for false to allow fallback compatibility
    // with non-toggleable components
    if (!e || $022086ec11d4df23$var$checkIsActive(e, binding) === false) return false;
    // If we're clicking inside the shadowroot, then the app root doesn't get the same
    // level of introspection as to _what_ we're clicking. We want to check to see if
    // our target is the shadowroot parent container, and if it is, ignore.
    var root = (0, $55c0ae8808484c3c$export$3be35968ed281992)(el);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false;
    // Check if additional elements were passed to be included in check
    // (click must be outside all included elements, if any)
    var elements = ((0, $3KZcf._)(binding.value) === 'object' && binding.value.include || function() {
        return [];
    })();
    // Add the root element for the component this directive was defined on
    elements.push(el);
    // Check if it's a click outside our elements, and then if our callback returns true.
    // Non-toggleable components should take action in their callback and return falsy.
    // Toggleable can return true if it wants to deactivate.
    // Note that, because we're in the capture phase, this callback will occur before
    // the bubbling click event on any outside elements.
    return !elements.some(function(el) {
        return el === null || el === void 0 ? void 0 : el.contains(e.target);
    });
}
function $022086ec11d4df23$var$checkIsActive(e, binding) {
    var isActive = (0, $3KZcf._)(binding.value) === 'object' && binding.value.closeConditional || $022086ec11d4df23$var$defaultConditional;
    return isActive(e);
}
function $022086ec11d4df23$var$directive(e, el, binding) {
    var handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
    // Clicks in the Shadow DOM change their target while using setTimeout, so the original target is saved here
    e.shadowTarget = e.target;
    el._clickOutside.lastMousedownWasOutside && $022086ec11d4df23$var$checkEvent(e, el, binding) && setTimeout(function() {
        $022086ec11d4df23$var$checkIsActive(e, binding) && handler && handler(e);
    }, 0);
}
function $022086ec11d4df23$var$handleShadow(el, callback) {
    var root = (0, $55c0ae8808484c3c$export$3be35968ed281992)(el);
    callback(document);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) callback(root);
}
var $022086ec11d4df23$export$c16e4f034c84cb3f = {
    // [data-app] may not be found
    // if using bind, inserted makes
    // sure that the root element is
    // available, iOS does not support
    // clicks on body
    mounted: function(el, binding) {
        var onClick = function(e) {
            return $022086ec11d4df23$var$directive(e, el, binding);
        };
        var onMousedown = function(e) {
            el._clickOutside.lastMousedownWasOutside = $022086ec11d4df23$var$checkEvent(e, el, binding);
        };
        $022086ec11d4df23$var$handleShadow(el, function(app) {
            app.addEventListener('click', onClick, true);
            app.addEventListener('mousedown', onMousedown, true);
        });
        if (!el._clickOutside) el._clickOutside = {
            lastMousedownWasOutside: false
        };
        el._clickOutside[binding.instance.$.uid] = {
            onClick: onClick,
            onMousedown: onMousedown
        };
    },
    beforeUnmount: function(el, binding) {
        if (!el._clickOutside) return;
        $022086ec11d4df23$var$handleShadow(el, function(app) {
            var _el__clickOutside;
            if (!app || !((_el__clickOutside = el._clickOutside) === null || _el__clickOutside === void 0 ? void 0 : _el__clickOutside[binding.instance.$.uid])) return;
            var _el__clickOutside_binding_instance_$_uid = el._clickOutside[binding.instance.$.uid], onClick = _el__clickOutside_binding_instance_$_uid.onClick, onMousedown = _el__clickOutside_binding_instance_$_uid.onMousedown;
            app.removeEventListener('click', onClick, true);
            app.removeEventListener('mousedown', onMousedown, true);
        });
        delete el._clickOutside[binding.instance.$.uid];
    }
};
var $022086ec11d4df23$export$2e2bcd8739ae039 = $022086ec11d4df23$export$c16e4f034c84cb3f;



function $7f198793a6132466$var$Scrim(props) {
    var modelValue = props.modelValue, color = props.color, rest = (0, $g79Gh._)(props, [
        "modelValue",
        "color"
    ]);
    return (0, $bu8yf.createVNode)((0, $kiZwI.Transition), {
        name: "fade-transition",
        appear: true
    }, {
        "default": function() {
            return [
                props.modelValue && (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                    "class": [
                        'v-overlay__scrim',
                        props.color.backgroundColorClasses.value
                    ],
                    style: props.color.backgroundColorStyles.value
                }, rest), null)
            ];
        }
    });
}
var $7f198793a6132466$export$357b25d59a7fb3fa = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    absolute: Boolean,
    attach: [
        Boolean,
        String,
        Object
    ],
    closeOnBack: {
        type: Boolean,
        "default": true
    },
    contained: Boolean,
    contentClass: null,
    contentProps: null,
    disabled: Boolean,
    opacity: [
        Number,
        String
    ],
    noClickAnimation: Boolean,
    modelValue: Boolean,
    persistent: Boolean,
    scrim: {
        type: [
            Boolean,
            String
        ],
        "default": true
    },
    zIndex: {
        type: [
            Number,
            String
        ],
        "default": 2000
    }
}, (0, $e13daf3c801d57db$export$86105a8dfc563397)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $2a56e630d56c9097$export$3557c26df64490a4)(), (0, $e0b70b41941d1673$export$4182dc895ddc707b)(), (0, $093192ffed1e6058$export$5844d560a14f1eae)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)()), 'VOverlay');
var $7f198793a6132466$export$32caf7e8170352aa = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VOverlay',
    directives: {
        vClickOutside: (0, $022086ec11d4df23$export$2e2bcd8739ae039)
    },
    inheritAttrs: false,
    props: (0, $iT0je._)({
        _disableGlobalStack: Boolean
    }, $7f198793a6132466$export$357b25d59a7fb3fa()),
    emits: {
        'click:outside': function(e) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        keydown: function(e) {
            return true;
        },
        afterEnter: function() {
            return true;
        },
        afterLeave: function() {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
        var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('VOverlay');
        var root = (0, $hXmfK.ref)();
        var scrimEl = (0, $hXmfK.ref)();
        var contentEl = (0, $hXmfK.ref)();
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var isActive = (0, $hXmfK.computed)({
            get: function() {
                return model.value;
            },
            set: function(v) {
                if (!(v && props.disabled)) model.value = v;
            }
        });
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)(), rtlClasses = _useRtl.rtlClasses, isRtl = _useRtl.isRtl;
        var _useLazy = (0, $2a56e630d56c9097$export$965f98646215a1bd)(props, isActive), hasContent = _useLazy.hasContent, _onAfterLeave = _useLazy.onAfterLeave;
        var scrimColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        var _useStack = (0, $6708ec152cef4976$export$df58951aab233134)(isActive, function() {
            return props.zIndex;
        }, props._disableGlobalStack), globalTop = _useStack.globalTop, localTop = _useStack.localTop, stackStyles = _useStack.stackStyles;
        var _useActivator = (0, $e13daf3c801d57db$export$c66a9a6f2d14727a)(props, {
            isActive: isActive,
            isTop: localTop,
            contentEl: contentEl
        }), activatorEl = _useActivator.activatorEl, activatorRef = _useActivator.activatorRef, target = _useActivator.target, targetEl = _useActivator.targetEl, targetRef = _useActivator.targetRef, activatorEvents = _useActivator.activatorEvents, contentEvents = _useActivator.contentEvents, scrimEvents = _useActivator.scrimEvents;
        var teleportTarget = (0, $8f00b86b63b14852$export$b6ab74bf6ad20b87)(function() {
            var _activatorEl_value, _vm_proxy_$el, _vm_proxy;
            var target = props.attach || props.contained;
            if (target) return target;
            var rootNode = (activatorEl === null || activatorEl === void 0 ? void 0 : (_activatorEl_value = activatorEl.value) === null || _activatorEl_value === void 0 ? void 0 : _activatorEl_value.getRootNode()) || ((_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : (_vm_proxy_$el = _vm_proxy.$el) === null || _vm_proxy_$el === void 0 ? void 0 : _vm_proxy_$el.getRootNode());
            if (rootNode instanceof ShadowRoot) return rootNode;
            return false;
        }).teleportTarget;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var isMounted = (0, $5e2188d9568ff520$export$5b8689c380bcb3d5)();
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        (0, $hXmfK.watch)(function() {
            return props.disabled;
        }, function(v) {
            if (v) isActive.value = false;
        });
        var _useLocationStrategies = (0, $e0b70b41941d1673$export$ddfd163f9bbe3913)(props, {
            isRtl: isRtl,
            contentEl: contentEl,
            target: target,
            isActive: isActive
        }), contentStyles = _useLocationStrategies.contentStyles, updateLocation = _useLocationStrategies.updateLocation;
        (0, $093192ffed1e6058$export$a9bfea786f4e2928)(props, {
            root: root,
            contentEl: contentEl,
            targetEl: targetEl,
            isActive: isActive,
            updateLocation: updateLocation
        });
        function onClickOutside(e) {
            emit('click:outside', e);
            if (!props.persistent) isActive.value = false;
            else animateClick();
        }
        function closeConditional(e) {
            return isActive.value && globalTop.value && // If using scrim, only close if clicking on it rather than anything opened on top
            (!props.scrim || e.target === scrimEl.value || e instanceof MouseEvent && e.shadowTarget === scrimEl.value);
        }
        (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && (0, $hXmfK.watch)(isActive, function(val) {
            if (val) window.addEventListener('keydown', onKeydown);
            else window.removeEventListener('keydown', onKeydown);
        }, {
            immediate: true
        });
        (0, $bu8yf.onBeforeUnmount)(function() {
            if (!(0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd)) return;
            window.removeEventListener('keydown', onKeydown);
        });
        function onKeydown(e) {
            if (e.key === 'Escape' && globalTop.value) {
                var _contentEl_value;
                if (!((_contentEl_value = contentEl.value) === null || _contentEl_value === void 0 ? void 0 : _contentEl_value.contains(document.activeElement))) emit('keydown', e);
                if (!props.persistent) {
                    var _contentEl_value1, _activatorEl_value;
                    isActive.value = false;
                    if ((_contentEl_value1 = contentEl.value) === null || _contentEl_value1 === void 0 ? void 0 : _contentEl_value1.contains(document.activeElement)) (_activatorEl_value = activatorEl.value) === null || _activatorEl_value === void 0 ? void 0 : _activatorEl_value.focus();
                } else animateClick();
            }
        }
        function onKeydownSelf(e) {
            if (e.key === 'Escape' && !globalTop.value) return;
            emit('keydown', e);
        }
        var router = (0, $f0fd6b0b61967e91$export$9a302a45f65d0572)();
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.closeOnBack;
        }, function() {
            (0, $f0fd6b0b61967e91$export$a519bdc484beda0)(router, function(next) {
                if (globalTop.value && isActive.value) {
                    next(false);
                    if (!props.persistent) isActive.value = false;
                    else animateClick();
                } else next();
            });
        });
        var top = (0, $hXmfK.ref)();
        (0, $hXmfK.watch)(function() {
            return isActive.value && (props.absolute || props.contained) && teleportTarget.value == null;
        }, function(val) {
            if (val) {
                var scrollParent = (0, $84c2348fe514d5ac$export$cfa2225e87938781)(root.value);
                if (scrollParent && scrollParent !== document.scrollingElement) top.value = scrollParent.scrollTop;
            }
        });
        // Add a quick "bounce" animation to the content
        function animateClick() {
            if (props.noClickAnimation) return;
            contentEl.value && (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(contentEl.value, [
                {
                    transformOrigin: 'center'
                },
                {
                    transform: 'scale(1.03)'
                },
                {
                    transformOrigin: 'center'
                }
            ], {
                duration: 150,
                easing: (0, $7c499b58bf668c0e$export$bf86e2ccec972a06)
            });
        }
        function onAfterEnter() {
            emit('afterEnter');
        }
        function onAfterLeave() {
            _onAfterLeave();
            emit('afterLeave');
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_activator;
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (_slots_activator = slots.activator) === null || _slots_activator === void 0 ? void 0 : _slots_activator.call(slots, {
                    isActive: isActive.value,
                    targetRef: targetRef,
                    props: (0, $bu8yf.mergeProps)({
                        ref: activatorRef
                    }, activatorEvents.value, props.activatorProps)
                }),
                isMounted.value && hasContent.value && (0, $bu8yf.createVNode)((0, $bu8yf.Teleport), {
                    disabled: !teleportTarget.value,
                    to: teleportTarget.value
                }, {
                    "default": function() {
                        return [
                            (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                                "class": [
                                    'v-overlay',
                                    {
                                        'v-overlay--absolute': props.absolute || props.contained,
                                        'v-overlay--active': isActive.value,
                                        'v-overlay--contained': props.contained
                                    },
                                    themeClasses.value,
                                    rtlClasses.value,
                                    props["class"]
                                ],
                                style: [
                                    stackStyles.value,
                                    {
                                        '--v-overlay-opacity': props.opacity,
                                        top: (0, $31779689cfd5da50$export$286ad215293a0860)(top.value)
                                    },
                                    props.style
                                ],
                                ref: root,
                                onKeydown: onKeydownSelf
                            }, scopeId, attrs), [
                                (0, $bu8yf.createVNode)($7f198793a6132466$var$Scrim, (0, $bu8yf.mergeProps)({
                                    color: scrimColor,
                                    modelValue: isActive.value && !!props.scrim,
                                    ref: scrimEl
                                }, scrimEvents.value), null),
                                (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                                    appear: true,
                                    persisted: true,
                                    transition: props.transition,
                                    target: target.value,
                                    onAfterEnter: onAfterEnter,
                                    onAfterLeave: onAfterLeave
                                }, {
                                    "default": function() {
                                        var _slots_default;
                                        return [
                                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                                                ref: contentEl,
                                                "class": [
                                                    'v-overlay__content',
                                                    props.contentClass
                                                ],
                                                style: [
                                                    dimensionStyles.value,
                                                    contentStyles.value
                                                ]
                                            }, contentEvents.value, props.contentProps), [
                                                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                                    isActive: isActive
                                                })
                                            ]), [
                                                [
                                                    (0, $kiZwI.vShow),
                                                    isActive.value
                                                ],
                                                [
                                                    (0, $022086ec11d4df23$export$2e2bcd8739ae039),
                                                    {
                                                        handler: onClickOutside,
                                                        closeConditional: closeConditional,
                                                        include: function() {
                                                            return [
                                                                activatorEl.value
                                                            ];
                                                        }
                                                    }
                                                ]
                                            ])
                                        ];
                                    }
                                })
                            ])
                        ];
                    }
                })
            ]);
        });
        return {
            activatorEl: activatorEl,
            scrimEl: scrimEl,
            target: target,
            animateClick: animateClick,
            contentEl: contentEl,
            globalTop: globalTop,
            localTop: localTop,
            updateLocation: updateLocation
        };
    }
});



// Types

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
var $8a23d01bbdbffa09$var$Refs = Symbol('Forwarded refs');
/** Omit properties starting with P */ /** Omit keyof $props from T */ function $8a23d01bbdbffa09$var$getDescriptor(obj, key) {
    var currentObj = obj;
    while(currentObj){
        var descriptor = Reflect.getOwnPropertyDescriptor(currentObj, key);
        if (descriptor) return descriptor;
        currentObj = Object.getPrototypeOf(currentObj);
    }
    return undefined;
}
function $8a23d01bbdbffa09$export$e091cd9ead0744b3(target) {
    for(var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)refs[_key - 1] = arguments[_key];
    target[$8a23d01bbdbffa09$var$Refs] = refs;
    return new Proxy(target, {
        get: function(target, key) {
            if (Reflect.has(target, key)) return Reflect.get(target, key);
            // Skip internal properties
            if ((typeof key === "undefined" ? "undefined" : (0, $3KZcf._)(key)) === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    if (ref.value && Reflect.has(ref.value, key)) {
                        var val = Reflect.get(ref.value, key);
                        return typeof val === 'function' ? val.bind(ref.value) : val;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        has: function(target, key) {
            if (Reflect.has(target, key)) return true;
            // Skip internal properties
            if ((typeof key === "undefined" ? "undefined" : (0, $3KZcf._)(key)) === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    if (ref.value && Reflect.has(ref.value, key)) return true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return false;
        },
        set: function(target, key, value) {
            if (Reflect.has(target, key)) return Reflect.set(target, key, value);
            // Skip internal properties
            if ((typeof key === "undefined" ? "undefined" : (0, $3KZcf._)(key)) === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    if (ref.value && Reflect.has(ref.value, key)) return Reflect.set(ref.value, key, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return false;
        },
        getOwnPropertyDescriptor: function(target, key) {
            var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
            if (descriptor) return descriptor;
            // Skip internal properties
            if ((typeof key === "undefined" ? "undefined" : (0, $3KZcf._)(key)) === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Check each ref's own properties
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    var _ref_value__;
                    if (!ref.value) continue;
                    var _getDescriptor;
                    var descriptor1 = (_getDescriptor = $8a23d01bbdbffa09$var$getDescriptor(ref.value, key)) !== null && _getDescriptor !== void 0 ? _getDescriptor : '_' in ref.value ? $8a23d01bbdbffa09$var$getDescriptor((_ref_value__ = ref.value._) === null || _ref_value__ === void 0 ? void 0 : _ref_value__.setupState, key) : undefined;
                    if (descriptor1) return descriptor1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                // Recursive search up each ref's prototype
                for(var _iterator1 = refs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var ref1 = _step1.value;
                    var childRefs = ref1.value && ref1.value[$8a23d01bbdbffa09$var$Refs];
                    if (!childRefs) continue;
                    var queue = childRefs.slice();
                    while(queue.length){
                        var _queue;
                        var ref2 = queue.shift();
                        var descriptor2 = $8a23d01bbdbffa09$var$getDescriptor(ref2.value, key);
                        if (descriptor2) return descriptor2;
                        var childRefs1 = ref2.value && ref2.value[$8a23d01bbdbffa09$var$Refs];
                        if (childRefs1) (_queue = queue).push.apply(_queue, (0, $7WNf6._)(childRefs1));
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return undefined;
        }
    });
}







var $7cf2e5a7271d5533$export$d914c5b32001cb2e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    // TODO
    // disableKeys: Boolean,
    id: String,
    submenu: Boolean,
    disableInitialFocus: Boolean
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $7f198793a6132466$export$357b25d59a7fb3fa)({
    closeDelay: 250,
    closeOnContentClick: true,
    locationStrategy: 'connected',
    location: undefined,
    openDelay: 300,
    scrim: false,
    scrollStrategy: 'reposition',
    transition: {
        component: (0, $b2974c952e31c38b$export$9778a08df954f36c)
    }
}), [
    'absolute'
])), 'VMenu');
var $7cf2e5a7271d5533$export$a347888d6b8f252a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VMenu',
    props: $7cf2e5a7271d5533$export$d914c5b32001cb2e(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.toRef)(function() {
            return props.id || "v-menu-".concat(uid);
        });
        var overlay = (0, $hXmfK.ref)();
        var parent = (0, $bu8yf.inject)((0, $76bbdc0d2219a4a0$export$d60452ec716149a1), null);
        var openChildren = (0, $hXmfK.shallowRef)(new Set());
        (0, $bu8yf.provide)((0, $76bbdc0d2219a4a0$export$d60452ec716149a1), {
            register: function() {
                openChildren.value.add(uid);
            },
            unregister: function() {
                openChildren.value["delete"](uid);
            },
            closeParents: function(e) {
                setTimeout(function() {
                    var _overlay_value;
                    if (!openChildren.value.size && !props.persistent && (e == null || ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && !(0, $31779689cfd5da50$export$4430641350aec15f)(e, overlay.value.contentEl))) {
                        isActive.value = false;
                        parent === null || parent === void 0 ? void 0 : parent.closeParents();
                    }
                }, 40);
            }
        });
        (0, $bu8yf.onBeforeUnmount)(function() {
            parent === null || parent === void 0 ? void 0 : parent.unregister();
            document.removeEventListener('focusin', onFocusIn);
        });
        (0, $bu8yf.onDeactivated)(function() {
            return isActive.value = false;
        });
        function onFocusIn(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var _overlay_value, // We're the topmost menu
                _overlay_value1, before, after, _focusable_, focusable;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            before = e.relatedTarget;
                            after = e.target;
                            return [
                                4,
                                (0, $bu8yf.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            if (isActive.value && before !== after && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && ((_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : _overlay_value1.globalTop) && // It isn't the document or the menu body
                            ![
                                document,
                                overlay.value.contentEl
                            ].includes(after) && // It isn't inside the menu body
                            !overlay.value.contentEl.contains(after)) {
                                ;
                                focusable = (0, $31779689cfd5da50$export$aea49dace3f6ca76)(overlay.value.contentEl);
                                (_focusable_ = focusable[0]) === null || _focusable_ === void 0 ? void 0 : _focusable_.focus();
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        (0, $hXmfK.watch)(isActive, function(val) {
            if (val) {
                parent === null || parent === void 0 ? void 0 : parent.register();
                if ((0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && !props.disableInitialFocus) document.addEventListener('focusin', onFocusIn, {
                    once: true
                });
            } else {
                parent === null || parent === void 0 ? void 0 : parent.unregister();
                if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) document.removeEventListener('focusin', onFocusIn);
            }
        }, {
            immediate: true
        });
        function onClickOutside(e) {
            parent === null || parent === void 0 ? void 0 : parent.closeParents(e);
        }
        function onKeydown(e) {
            if (props.disabled) return;
            if (e.key === 'Tab' || e.key === 'Enter' && !props.closeOnContentClick) {
                var _overlay_value;
                if (e.key === 'Enter' && (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement && !!e.target.closest('form'))) return;
                if (e.key === 'Enter') e.preventDefault();
                var nextElement = (0, $31779689cfd5da50$export$4109ed81edd7716d)((0, $31779689cfd5da50$export$aea49dace3f6ca76)((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl, false), e.shiftKey ? 'prev' : 'next', function(el) {
                    return el.tabIndex >= 0;
                });
                if (!nextElement) {
                    var _overlay_value_activatorEl, _overlay_value1;
                    isActive.value = false;
                    (_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : (_overlay_value_activatorEl = _overlay_value1.activatorEl) === null || _overlay_value_activatorEl === void 0 ? void 0 : _overlay_value_activatorEl.focus();
                }
            } else if (props.submenu && e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) {
                var _overlay_value_activatorEl1, _overlay_value2;
                isActive.value = false;
                (_overlay_value2 = overlay.value) === null || _overlay_value2 === void 0 ? void 0 : (_overlay_value_activatorEl1 = _overlay_value2.activatorEl) === null || _overlay_value_activatorEl1 === void 0 ? void 0 : _overlay_value_activatorEl1.focus();
            }
        }
        function onActivatorKeydown(e) {
            var _overlay_value;
            if (props.disabled) return;
            var el = (_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl;
            if (el && isActive.value) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $31779689cfd5da50$export$da2eafa20d5ebba)(el, 'next');
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $31779689cfd5da50$export$da2eafa20d5ebba)(el, 'prev');
                } else if (props.submenu) {
                    if (e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) isActive.value = false;
                    else if (e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight')) {
                        e.preventDefault();
                        (0, $31779689cfd5da50$export$da2eafa20d5ebba)(el, 'first');
                    }
                }
            } else if (props.submenu ? e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight') : [
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) {
                isActive.value = true;
                e.preventDefault();
                setTimeout(function() {
                    return setTimeout(function() {
                        return onActivatorKeydown(e);
                    });
                });
            }
        }
        var activatorProps = (0, $hXmfK.computed)(function() {
            return (0, $bu8yf.mergeProps)({
                'aria-haspopup': 'menu',
                'aria-expanded': String(isActive.value),
                'aria-controls': id.value,
                onKeydown: onActivatorKeydown
            }, props.activatorProps);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var overlayProps = (0, $7f198793a6132466$export$32caf7e8170352aa).filterProps(props);
            var _props_location;
            return (0, $bu8yf.createVNode)((0, $7f198793a6132466$export$32caf7e8170352aa), (0, $bu8yf.mergeProps)({
                ref: overlay,
                id: id.value,
                "class": [
                    'v-menu',
                    props["class"]
                ],
                style: props.style
            }, overlayProps, {
                modelValue: isActive.value,
                "onUpdate:modelValue": function($event) {
                    return isActive.value = $event;
                },
                absolute: true,
                activatorProps: activatorProps.value,
                location: (_props_location = props.location) !== null && _props_location !== void 0 ? _props_location : props.submenu ? 'end' : 'bottom',
                "onClick:outside": onClickOutside,
                onKeydown: onKeydown
            }, scopeId), {
                activator: slots.activator,
                "default": function _default() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        root: "VMenu"
                    }, {
                        "default": function() {
                            var _slots_default;
                            var _slots_default1;
                            return [
                                (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : (_slots_default = _slots_default1).call.apply(_slots_default, [
                                    slots
                                ].concat((0, $7WNf6._)(args)))
                            ];
                        }
                    });
                }
            });
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            id: id,
            \u03A8openChildren: openChildren
        }, overlay);
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");











var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");
var $kiZwI = parcelRequire("kiZwI");





var $7ba1fb3b216974cf$export$499a42a6fe2c0ed3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    active: Boolean,
    disabled: Boolean,
    max: [
        Number,
        String
    ],
    value: {
        type: [
            Number,
            String
        ],
        "default": 0
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $01a421c271ad0485$export$5d9f875feb4d9ee6)
    }
})), 'VCounter');
var $7ba1fb3b216974cf$export$45efeae449ff2094 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCounter',
    functional: true,
    props: $7ba1fb3b216974cf$export$499a42a6fe2c0ed3(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var counter = (0, $hXmfK.toRef)(function() {
            return props.max ? "".concat(props.value, " / ").concat(props.max) : String(props.value);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-counter',
                                {
                                    'text-error': props.max && !props.disabled && parseFloat(props.value) > parseFloat(props.max)
                                },
                                props["class"]
                            ]),
                            style: (0, $d8jBh.normalizeStyle)(props.style)
                        }, [
                            slots["default"] ? slots["default"]({
                                counter: counter.value,
                                max: props.max,
                                value: props.value
                            }) : counter.value
                        ]), [
                            [
                                (0, $kiZwI.vShow),
                                props.active
                            ]
                        ])
                    ];
                }
            });
        });
        return {};
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $9210a492c630ce0e$export$5951acb17a4319b2 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    floating: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VFieldLabel');
var $9210a492c630ce0e$export$1a74b2f7ba75e1db = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VFieldLabel',
    props: $9210a492c630ce0e$export$5951acb17a4319b2(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $6c6f579f4011d0f0$export$90281af35207eb21), {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-field-label',
                    {
                        'v-field-label--floating': props.floating
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, slots);
        });
        return {};
    }
});





var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");



function $2bf11e725e4cea2c$export$d08cb507a9c34d4b(props) {
    var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
    function InputIcon(_ref) {
        var name = _ref.name, color = _ref.color, attrs = (0, $g79Gh._)(_ref, [
            "name",
            "color"
        ]);
        var localeKey = {
            prepend: 'prependAction',
            prependInner: 'prependAction',
            append: 'appendAction',
            appendInner: 'appendAction',
            clear: 'clear'
        }[name];
        var listener = props["onClick:".concat(name)];
        function onKeydown(e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            e.stopPropagation();
            (0, $31779689cfd5da50$export$293b251ea77dc2b7)(listener, new PointerEvent('click', e));
        }
        var _props_label;
        var label = listener && localeKey ? t("$vuetify.input.".concat(localeKey), (_props_label = props.label) !== null && _props_label !== void 0 ? _props_label : '') : undefined;
        return (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), (0, $bu8yf.mergeProps)({
            icon: props["".concat(name, "Icon")],
            "aria-label": label,
            onClick: listener,
            onKeydown: onKeydown,
            color: color
        }, attrs), null);
    }
    return {
        InputIcon: InputIcon
    };
}




// Composables

var $cqEAj = parcelRequire("cqEAj");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $6f0e0973cbf83779$export$676d4e684e4b0e1e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    focused: Boolean,
    'onUpdate:focused': (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, 'focus');
function $6f0e0973cbf83779$export$f8168d8dd8fd66e6(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var isFocused = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'focused');
    var focusClasses = (0, $hXmfK.toRef)(function() {
        return (0, $cqEAj._)({}, "".concat(name, "--focused"), isFocused.value);
    });
    function focus() {
        isFocused.value = true;
    }
    function blur() {
        isFocused.value = false;
    }
    return {
        focusClasses: focusClasses,
        isFocused: isFocused,
        focus: focus,
        blur: blur
    };
}








var $88ed151c68066729$var$allowedVariants = [
    'underlined',
    'outlined',
    'filled',
    'solo',
    'solo-inverted',
    'solo-filled',
    'plain'
];
var $88ed151c68066729$export$1e13429dc53b9634 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    appendInnerIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    bgColor: String,
    clearable: Boolean,
    clearIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$clear'
    },
    active: Boolean,
    centerAffix: {
        type: Boolean,
        "default": undefined
    },
    color: String,
    baseColor: String,
    details: Boolean,
    dirty: Boolean,
    disabled: {
        type: Boolean,
        "default": null
    },
    glow: Boolean,
    error: Boolean,
    flat: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    label: String,
    persistentClear: Boolean,
    prependInnerIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    reverse: Boolean,
    singleLine: Boolean,
    variant: {
        type: String,
        "default": 'filled',
        validator: function(v) {
            return $88ed151c68066729$var$allowedVariants.includes(v);
        }
    },
    'onClick:clear': (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    'onClick:appendInner': (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    'onClick:prependInner': (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $de59c43ac78c3e7a$export$149f04e0cba4dbc1)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VField');
var $88ed151c68066729$export$3180fb4997e9f72d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VField',
    inheritAttrs: false,
    props: (0, $iT0je._)({
        id: String
    }, (0, $6f0e0973cbf83779$export$676d4e684e4b0e1e)(), $88ed151c68066729$export$1e13429dc53b9634()),
    emits: {
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var loaderClasses = (0, $de59c43ac78c3e7a$export$14095de704efe3f9)(props).loaderClasses;
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), focusClasses = _useFocus.focusClasses, isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var InputIcon = (0, $2bf11e725e4cea2c$export$d08cb507a9c34d4b)(props).InputIcon;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var isActive = (0, $hXmfK.toRef)(function() {
            return props.dirty || props.active;
        });
        var hasLabel = (0, $hXmfK.toRef)(function() {
            return !!(props.label || slots.label);
        });
        var hasFloatingLabel = (0, $hXmfK.toRef)(function() {
            return !props.singleLine && hasLabel.value;
        });
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.computed)(function() {
            return props.id || "input-".concat(uid);
        });
        var messagesId = (0, $hXmfK.toRef)(function() {
            return !props.details ? undefined : "".concat(id.value, "-messages");
        });
        var labelRef = (0, $hXmfK.ref)();
        var floatingLabelRef = (0, $hXmfK.ref)();
        var controlRef = (0, $hXmfK.ref)();
        var isPlainOrUnderlined = (0, $hXmfK.computed)(function() {
            return [
                'plain',
                'underlined'
            ].includes(props.variant);
        });
        var color = (0, $hXmfK.computed)(function() {
            return props.error || props.disabled ? undefined : isActive.value && isFocused.value ? props.color : props.baseColor;
        });
        var iconColor = (0, $hXmfK.computed)(function() {
            if (!props.iconColor || props.glow && !isFocused.value) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(color), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        (0, $hXmfK.watch)(isActive, function(val) {
            if (hasFloatingLabel.value) {
                var el = labelRef.value.$el;
                var targetEl = floatingLabelRef.value.$el;
                requestAnimationFrame(function() {
                    var rect = (0, $4256e79b4dc20ac3$export$38c5b68336448fc8)(el);
                    var targetRect = targetEl.getBoundingClientRect();
                    var x = targetRect.x - rect.x;
                    var y = targetRect.y - rect.y - (rect.height / 2 - targetRect.height / 2);
                    var targetWidth = targetRect.width / 0.75;
                    var width = Math.abs(targetWidth - rect.width) > 1 ? {
                        maxWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(targetWidth)
                    } : undefined;
                    var style = getComputedStyle(el);
                    var targetStyle = getComputedStyle(targetEl);
                    var duration = parseFloat(style.transitionDuration) * 1000 || 150;
                    var scale = parseFloat(targetStyle.getPropertyValue('--v-field-label-scale'));
                    var color = targetStyle.getPropertyValue('color');
                    el.style.visibility = 'visible';
                    targetEl.style.visibility = 'hidden';
                    (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(el, (0, $iT0je._)({
                        transform: "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")"),
                        color: color
                    }, width), {
                        duration: duration,
                        easing: (0, $7c499b58bf668c0e$export$bf86e2ccec972a06),
                        direction: val ? 'normal' : 'reverse'
                    }).finished.then(function() {
                        el.style.removeProperty('visibility');
                        targetEl.style.removeProperty('visibility');
                    });
                });
            }
        }, {
            flush: 'post'
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                isActive: isActive,
                isFocused: isFocused,
                controlRef: controlRef,
                blur: blur,
                focus: focus
            };
        });
        function onClick(e) {
            if (e.target !== document.activeElement) e.preventDefault();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_prependinner, _slots_default, _slots_appendinner;
            var isOutlined = props.variant === 'outlined';
            var hasPrepend = !!(slots['prepend-inner'] || props.prependInnerIcon);
            var hasClear = !!(props.clearable || slots.clear) && !props.disabled;
            var hasAppend = !!(slots['append-inner'] || props.appendInnerIcon || hasClear);
            var label = function() {
                return slots.label ? slots.label((0, $emQHU._)((0, $iT0je._)({}, slotProps.value), {
                    label: props.label,
                    props: {
                        "for": id.value
                    }
                })) : props.label;
            };
            var _props_centerAffix, _slots_default1;
            return (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                "class": [
                    'v-field',
                    (0, $cqEAj._)({
                        'v-field--active': isActive.value,
                        'v-field--appended': hasAppend,
                        'v-field--center-affix': (_props_centerAffix = props.centerAffix) !== null && _props_centerAffix !== void 0 ? _props_centerAffix : !isPlainOrUnderlined.value,
                        'v-field--disabled': props.disabled,
                        'v-field--dirty': props.dirty,
                        'v-field--error': props.error,
                        'v-field--glow': props.glow,
                        'v-field--flat': props.flat,
                        'v-field--has-background': !!props.bgColor,
                        'v-field--persistent-clear': props.persistentClear,
                        'v-field--prepended': hasPrepend,
                        'v-field--reverse': props.reverse,
                        'v-field--single-line': props.singleLine,
                        'v-field--no-label': !label()
                    }, "v-field--variant-".concat(props.variant), true),
                    themeClasses.value,
                    backgroundColorClasses.value,
                    focusClasses.value,
                    loaderClasses.value,
                    roundedClasses.value,
                    rtlClasses.value,
                    props["class"]
                ],
                style: [
                    backgroundColorStyles.value,
                    props.style
                ],
                onClick: onClick
            }, attrs), [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-field__overlay"
                }, null),
                (0, $bu8yf.createVNode)((0, $de59c43ac78c3e7a$export$9a5d46a3538da529), {
                    name: "v-field",
                    active: !!props.loading,
                    color: props.error ? 'error' : typeof props.loading === 'string' ? props.loading : props.color
                }, {
                    "default": slots.loader
                }),
                hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                    key: "prepend",
                    "class": "v-field__prepend-inner"
                }, [
                    props.prependInnerIcon && (0, $bu8yf.createVNode)(InputIcon, {
                        key: "prepend-icon",
                        name: "prependInner",
                        color: iconColor.value
                    }, null),
                    (_slots_prependinner = slots['prepend-inner']) === null || _slots_prependinner === void 0 ? void 0 : _slots_prependinner.call(slots, slotProps.value)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-field__field",
                    "data-no-activator": ""
                }, [
                    [
                        'filled',
                        'solo',
                        'solo-inverted',
                        'solo-filled'
                    ].includes(props.variant) && hasFloatingLabel.value && (0, $bu8yf.createVNode)((0, $9210a492c630ce0e$export$1a74b2f7ba75e1db), {
                        key: "floating-label",
                        ref: floatingLabelRef,
                        "class": (0, $d8jBh.normalizeClass)([
                            textColorClasses.value
                        ]),
                        floating: true,
                        "for": id.value,
                        "aria-hidden": !isActive.value,
                        style: (0, $d8jBh.normalizeStyle)(textColorStyles.value)
                    }, {
                        "default": function() {
                            return [
                                label()
                            ];
                        }
                    }),
                    hasLabel.value && (0, $bu8yf.createVNode)((0, $9210a492c630ce0e$export$1a74b2f7ba75e1db), {
                        key: "label",
                        ref: labelRef,
                        "for": id.value
                    }, {
                        "default": function() {
                            return [
                                label()
                            ];
                        }
                    }),
                    (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps.value), {
                        props: {
                            id: id.value,
                            "class": 'v-field__input',
                            'aria-describedby': messagesId.value
                        },
                        focus: focus,
                        blur: blur
                    }))) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $bu8yf.createElementVNode)("div", {
                        id: id.value,
                        "class": "v-field__input",
                        "aria-describedby": messagesId.value
                    }, null)
                ]),
                hasClear && (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$d54edbcba7869f36), {
                    key: "clear"
                }, {
                    "default": function() {
                        return [
                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                                "class": "v-field__clearable",
                                onMousedown: function(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }, [
                                (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                    defaults: {
                                        VIcon: {
                                            icon: props.clearIcon
                                        }
                                    }
                                }, {
                                    "default": function() {
                                        return [
                                            slots.clear ? slots.clear((0, $emQHU._)((0, $iT0je._)({}, slotProps.value), {
                                                props: {
                                                    onFocus: focus,
                                                    onBlur: blur,
                                                    onClick: props['onClick:clear'],
                                                    tabindex: -1
                                                }
                                            })) : (0, $bu8yf.createVNode)(InputIcon, {
                                                name: "clear",
                                                onFocus: focus,
                                                onBlur: blur,
                                                tabindex: -1
                                            }, null)
                                        ];
                                    }
                                })
                            ]), [
                                [
                                    (0, $kiZwI.vShow),
                                    props.dirty
                                ]
                            ])
                        ];
                    }
                }),
                hasAppend && (0, $bu8yf.createElementVNode)("div", {
                    key: "append",
                    "class": "v-field__append-inner"
                }, [
                    (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, slotProps.value),
                    props.appendInnerIcon && (0, $bu8yf.createVNode)(InputIcon, {
                        key: "append-icon",
                        name: "appendInner",
                        color: iconColor.value
                    }, null)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-field__outline',
                        textColorClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(textColorStyles.value)
                }, [
                    isOutlined && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-field__outline__start"
                        }, null),
                        hasFloatingLabel.value && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-field__outline__notch"
                        }, [
                            (0, $bu8yf.createVNode)((0, $9210a492c630ce0e$export$1a74b2f7ba75e1db), {
                                ref: floatingLabelRef,
                                floating: true,
                                "for": id.value,
                                "aria-hidden": !isActive.value
                            }, {
                                "default": function() {
                                    return [
                                        label()
                                    ];
                                }
                            })
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-field__outline__end"
                        }, null)
                    ]),
                    isPlainOrUnderlined.value && hasFloatingLabel.value && (0, $bu8yf.createVNode)((0, $9210a492c630ce0e$export$1a74b2f7ba75e1db), {
                        ref: floatingLabelRef,
                        floating: true,
                        "for": id.value,
                        "aria-hidden": !isActive.value
                    }, {
                        "default": function() {
                            return [
                                label()
                            ];
                        }
                    })
                ])
            ]);
        });
        return {
            controlRef: controlRef,
            fieldIconColor: iconColor
        };
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






var $536da37de9ff2b8b$export$79b8b232ea22263 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    active: Boolean,
    color: String,
    messages: {
        type: [
            Array,
            String
        ],
        "default": function() {
            return [];
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $01a421c271ad0485$export$5d9f875feb4d9ee6),
        leaveAbsolute: true,
        group: true
    }
})), 'VMessages');
var $536da37de9ff2b8b$export$31afdc787fe64f1d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VMessages',
    props: $536da37de9ff2b8b$export$79b8b232ea22263(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var messages = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$76411cac38121ecb)(props.messages);
        });
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: props.transition,
                tag: "div",
                "class": (0, $d8jBh.normalizeClass)([
                    'v-messages',
                    textColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    textColorStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        props.active && messages.value.map(function(message, i) {
                            return (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-messages__message",
                                key: "".concat(i, "-").concat(messages.value)
                            }, [
                                slots.message ? slots.message({
                                    message: message
                                }) : message
                            ]);
                        })
                    ];
                }
            });
        });
        return {};
    }
});








// Composables

var $b8tVf = parcelRequire("b8tVf");

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");

var $9N5UN = parcelRequire("9N5UN");

// Composables

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $04771d0544148a45$export$cf3347e5e7e1bef5 = Symbol["for"]('vuetify:form');
var $04771d0544148a45$export$be046af95b8d4645 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    fastFail: Boolean,
    readonly: Boolean,
    modelValue: {
        type: Boolean,
        "default": null
    },
    validateOn: {
        type: String,
        "default": 'input'
    }
}, 'form');
function $04771d0544148a45$export$f681a8129d2e9d28(props) {
    var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
    var isDisabled = (0, $hXmfK.toRef)(function() {
        return props.disabled;
    });
    var isReadonly = (0, $hXmfK.toRef)(function() {
        return props.readonly;
    });
    var isValidating = (0, $hXmfK.shallowRef)(false);
    var items = (0, $hXmfK.ref)([]);
    var errors = (0, $hXmfK.ref)([]);
    function validate() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var results, valid, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, itemErrorMessages, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        results = [];
                        valid = true;
                        errors.value = [];
                        isValidating.value = true;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = items.value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        item = _step.value;
                        return [
                            4,
                            item.validate()
                        ];
                    case 3:
                        itemErrorMessages = _state.sent();
                        if (itemErrorMessages.length > 0) {
                            valid = false;
                            results.push({
                                id: item.id,
                                errorMessages: itemErrorMessages
                            });
                        }
                        if (!valid && props.fastFail) return [
                            3,
                            5
                        ];
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        errors.value = results;
                        isValidating.value = false;
                        return [
                            2,
                            {
                                valid: valid,
                                errors: errors.value
                            }
                        ];
                }
            });
        })();
    }
    function reset() {
        items.value.forEach(function(item) {
            return item.reset();
        });
    }
    function resetValidation() {
        items.value.forEach(function(item) {
            return item.resetValidation();
        });
    }
    (0, $hXmfK.watch)(items, function() {
        var valid = 0;
        var invalid = 0;
        var results = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.isValid === false) {
                    invalid++;
                    results.push({
                        id: item.id,
                        errorMessages: item.errorMessages
                    });
                } else if (item.isValid === true) valid++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        errors.value = results;
        model.value = invalid > 0 ? false : valid === items.value.length ? true : null;
    }, {
        deep: true,
        flush: 'post'
    });
    (0, $bu8yf.provide)($04771d0544148a45$export$cf3347e5e7e1bef5, {
        register: function(_ref) {
            var id = _ref.id, vm = _ref.vm, _$validate = _ref.validate, _$reset = _ref.reset, _$resetValidation = _ref.resetValidation;
            if (items.value.some(function(item) {
                return item.id === id;
            })) (0, $b0e141e3fccca32c$export$222ba5e7254f2402)('Duplicate input name "'.concat(id, '"'));
            items.value.push({
                id: id,
                validate: _$validate,
                reset: _$reset,
                resetValidation: _$resetValidation,
                vm: (0, $hXmfK.markRaw)(vm),
                isValid: null,
                errorMessages: []
            });
        },
        unregister: function(id) {
            items.value = items.value.filter(function(item) {
                return item.id !== id;
            });
        },
        update: function(id, isValid, errorMessages) {
            var found = items.value.find(function(item) {
                return item.id === id;
            });
            if (!found) return;
            found.isValid = isValid;
            found.errorMessages = errorMessages;
        },
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validateOn: (0, $hXmfK.toRef)(function() {
            return props.validateOn;
        })
    });
    return {
        errors: errors,
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validate: validate,
        reset: reset,
        resetValidation: resetValidation
    };
}
function $04771d0544148a45$export$87c0cf8eb5a167e0(props) {
    var form = (0, $bu8yf.inject)($04771d0544148a45$export$cf3347e5e7e1bef5, null);
    return (0, $emQHU._)((0, $iT0je._)({}, form), {
        isReadonly: (0, $hXmfK.computed)(function() {
            var _props_readonly;
            return !!((_props_readonly = props === null || props === void 0 ? void 0 : props.readonly) !== null && _props_readonly !== void 0 ? _props_readonly : form === null || form === void 0 ? void 0 : form.isReadonly.value);
        }),
        isDisabled: (0, $hXmfK.computed)(function() {
            var _props_disabled;
            return !!((_props_disabled = props === null || props === void 0 ? void 0 : props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : form === null || form === void 0 ? void 0 : form.isDisabled.value);
        })
    });
}




// Utilities

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
function $8ff5f01c88e9e80b$export$826a84970f4c98e0(options, locale) {
    var t = locale.t;
    var aliases = (0, $iT0je._)({
        required: function(err) {
            return function(v) {
                // If the modifier .number is used, the 0 will be a number and it's a falsy value so we need to check for it
                return v === 0 || !!v || t(err || '$vuetify.rules.required');
            };
        },
        email: function(err) {
            return function(v) {
                return !v || typeof v === 'string' && /^.+@\S+\.\S+$/.test(v) || t(err || '$vuetify.rules.email');
            };
        },
        number: function(err) {
            return function(v) {
                return !!Number(v) || t(err || '$vuetify.rules.number');
            };
        },
        integer: function(err) {
            return function(v) {
                return /^[\d]*$/.test(v) || t(err || '$vuetify.rules.integer');
            };
        },
        capital: function(err) {
            return function(v) {
                return /^[A-Z]*$/.test(v) || t(err || '$vuetify.rules.capital');
            };
        },
        maxLength: function(len, err) {
            return function(v) {
                return !v || v.length <= len || t(err || '$vuetify.rules.maxLength', [
                    len
                ]);
            };
        },
        minLength: function(len, err) {
            return function(v) {
                return !v || v.length >= len || t(err || '$vuetify.rules.minLength', [
                    len
                ]);
            };
        },
        strictLength: function(len, err) {
            return function(v) {
                return !v || v.length === len || t(err || '$vuetify.rules.strictLength', [
                    len
                ]);
            };
        },
        exclude: function(forbiddenCharacters, err) {
            return function(v) {
                var error = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = forbiddenCharacters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var character = _step.value;
                        if (v.includes(character)) error = err || t('$vuetify.rules.exclude', character);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return error;
            };
        },
        notEmpty: function(err) {
            return function(v) {
                return v && v.length > 0 || t(err || '$vuetify.rules.notEmpty');
            };
        },
        pattern: function(pattern, err) {
            return function(v) {
                return !v || pattern.test(v) || t(err || '$vuetify.rules.pattern');
            };
        }
    }, options === null || options === void 0 ? void 0 : options.aliases);
    function resolveRules(fn) {
        return (0, $hXmfK.computed)(function() {
            return fn().map(function(rule) {
                var ruleName = null;
                var ruleParams = [
                    undefined
                ];
                if (Array.isArray(rule)) {
                    ruleName = rule[0];
                    ruleParams = rule.slice(1);
                } else if (typeof rule === 'string') ruleName = rule;
                if (ruleName !== null) {
                    var _aliases_ruleName;
                    var _aliases_ruleName1;
                    if (ruleName.startsWith('$')) ruleName = ruleName.slice(1);
                    return (_aliases_ruleName1 = aliases[ruleName]) === null || _aliases_ruleName1 === void 0 ? void 0 : (_aliases_ruleName = _aliases_ruleName1).call.apply(_aliases_ruleName, [
                        aliases
                    ].concat((0, $7WNf6._)(ruleParams)));
                } else return rule;
            });
        });
    }
    return resolveRules;
}
var $8ff5f01c88e9e80b$export$51fa63c9ca80112b = Symbol["for"]('vuetify:rules');
function $8ff5f01c88e9e80b$export$806b060f31753ef2(fn) {
    var resolveRules = (0, $bu8yf.inject)($8ff5f01c88e9e80b$export$51fa63c9ca80112b, null);
    if (!resolveRules) return (0, $hXmfK.toRef)(fn);
    return resolveRules(fn);
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $dfc9eccea4b997fa$export$42513dbc731a0133 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    disabled: {
        type: Boolean,
        "default": null
    },
    error: Boolean,
    errorMessages: {
        type: [
            Array,
            String
        ],
        "default": function() {
            return [];
        }
    },
    maxErrors: {
        type: [
            Number,
            String
        ],
        "default": 1
    },
    name: String,
    label: String,
    readonly: {
        type: Boolean,
        "default": null
    },
    rules: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    modelValue: null,
    validateOn: String,
    validationValue: null
}, (0, $6f0e0973cbf83779$export$676d4e684e4b0e1e)()), 'validation');
function $dfc9eccea4b997fa$export$87fe492f99f25a20(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f4cc842872cc2659$export$8adb83c1b7a9d7ae)();
    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $bu8yf.useId)();
    var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
    var validationModel = (0, $hXmfK.computed)(function() {
        return props.validationValue === undefined ? model.value : props.validationValue;
    });
    var form = (0, $04771d0544148a45$export$87c0cf8eb5a167e0)(props);
    var rules = (0, $8ff5f01c88e9e80b$export$806b060f31753ef2)(function() {
        return props.rules;
    });
    var internalErrorMessages = (0, $hXmfK.ref)([]);
    var isPristine = (0, $hXmfK.shallowRef)(true);
    var isDirty = (0, $hXmfK.computed)(function() {
        return !!((0, $31779689cfd5da50$export$76411cac38121ecb)(model.value === '' ? null : model.value).length || (0, $31779689cfd5da50$export$76411cac38121ecb)(validationModel.value === '' ? null : validationModel.value).length);
    });
    var errorMessages = (0, $hXmfK.computed)(function() {
        var _props_errorMessages;
        return ((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length) ? (0, $31779689cfd5da50$export$76411cac38121ecb)(props.errorMessages).concat(internalErrorMessages.value).slice(0, Math.max(0, Number(props.maxErrors))) : internalErrorMessages.value;
    });
    var validateOn = (0, $hXmfK.computed)(function() {
        var _form_validateOn;
        var _props_validateOn;
        var value = ((_props_validateOn = props.validateOn) !== null && _props_validateOn !== void 0 ? _props_validateOn : (_form_validateOn = form.validateOn) === null || _form_validateOn === void 0 ? void 0 : _form_validateOn.value) || 'input';
        if (value === 'lazy') value = 'input lazy';
        if (value === 'eager') value = 'input eager';
        var _value_split;
        var set = new Set((_value_split = value === null || value === void 0 ? void 0 : value.split(' ')) !== null && _value_split !== void 0 ? _value_split : []);
        return {
            input: set.has('input'),
            blur: set.has('blur') || set.has('input') || set.has('invalid-input'),
            invalidInput: set.has('invalid-input'),
            lazy: set.has('lazy'),
            eager: set.has('eager')
        };
    });
    var isValid = (0, $hXmfK.computed)(function() {
        var _props_errorMessages;
        if (props.error || ((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length)) return false;
        if (!props.rules.length) return true;
        if (isPristine.value) return internalErrorMessages.value.length || validateOn.value.lazy ? null : true;
        else return !internalErrorMessages.value.length;
    });
    var isValidating = (0, $hXmfK.shallowRef)(false);
    var validationClasses = (0, $hXmfK.computed)(function() {
        var _obj;
        return _obj = {}, (0, $cqEAj._)(_obj, "".concat(name, "--error"), isValid.value === false), (0, $cqEAj._)(_obj, "".concat(name, "--dirty"), isDirty.value), (0, $cqEAj._)(_obj, "".concat(name, "--disabled"), form.isDisabled.value), (0, $cqEAj._)(_obj, "".concat(name, "--readonly"), form.isReadonly.value), _obj;
    });
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('validation');
    var uid = (0, $hXmfK.computed)(function() {
        var _props_name;
        return (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : (0, $hXmfK.unref)(id);
    });
    (0, $bu8yf.onBeforeMount)(function() {
        var _form_register;
        (_form_register = form.register) === null || _form_register === void 0 ? void 0 : _form_register.call(form, {
            id: uid.value,
            vm: vm,
            validate: validate,
            reset: reset,
            resetValidation: resetValidation
        });
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        var _form_unregister;
        (_form_unregister = form.unregister) === null || _form_unregister === void 0 ? void 0 : _form_unregister.call(form, uid.value);
    });
    (0, $bu8yf.onMounted)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _form_update;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!validateOn.value.lazy) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validate(!validateOn.value.eager)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        (_form_update = form.update) === null || _form_update === void 0 ? void 0 : _form_update.call(form, uid.value, isValid.value, errorMessages.value);
                        return [
                            2
                        ];
                }
            });
        })();
    });
    (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
        return validateOn.value.input || validateOn.value.invalidInput && isValid.value === false;
    }, function() {
        (0, $hXmfK.watch)(validationModel, function() {
            if (validationModel.value != null) validate();
            else if (props.focused) {
                var unwatch = (0, $hXmfK.watch)(function() {
                    return props.focused;
                }, function(val) {
                    if (!val) validate();
                    unwatch();
                });
            }
        });
    });
    (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
        return validateOn.value.blur;
    }, function() {
        (0, $hXmfK.watch)(function() {
            return props.focused;
        }, function(val) {
            if (!val) validate();
        });
    });
    (0, $hXmfK.watch)([
        isValid,
        errorMessages
    ], function() {
        var _form_update;
        (_form_update = form.update) === null || _form_update === void 0 ? void 0 : _form_update.call(form, uid.value, isValid.value, errorMessages.value);
    });
    function reset() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        model.value = null;
                        return [
                            4,
                            (0, $bu8yf.nextTick)()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            resetValidation()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function resetValidation() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isPristine.value = true;
                        if (!!validateOn.value.lazy) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validate(!validateOn.value.eager)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        internalErrorMessages.value = [];
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function validate() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var silent, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
            var _arguments = arguments;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        silent = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                        results = [];
                        isValidating.value = true;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var rule, _props_maxErrors, handler, result;
                            return (0, $9N5UN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        rule = _step.value;
                                        if (results.length >= Number((_props_maxErrors = props.maxErrors) !== null && _props_maxErrors !== void 0 ? _props_maxErrors : 1)) return [
                                            2,
                                            "break"
                                        ];
                                        handler = typeof rule === 'function' ? rule : function() {
                                            return rule;
                                        };
                                        return [
                                            4,
                                            handler(validationModel.value)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result === true) return [
                                            2,
                                            "continue"
                                        ];
                                        if (result !== false && typeof result !== 'string') {
                                            // eslint-disable-next-line no-console
                                            console.warn("".concat(result, " is not a valid value. Rule functions must return boolean true or a string."));
                                            return [
                                                2,
                                                "continue"
                                            ];
                                        }
                                        results.push(result || '');
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = rules.value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            (0, $9N5UN.__values)(_loop())
                        ];
                    case 3:
                        _ret = _state.sent();
                        if (_ret === "break") return [
                            3,
                            5
                        ];
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        internalErrorMessages.value = results;
                        isValidating.value = false;
                        isPristine.value = silent;
                        return [
                            2,
                            internalErrorMessages.value
                        ];
                }
            });
        }).apply(this, arguments);
    }
    return {
        errorMessages: errorMessages,
        isDirty: isDirty,
        isDisabled: form.isDisabled,
        isReadonly: form.isReadonly,
        isPristine: isPristine,
        isValid: isValid,
        isValidating: isValidating,
        reset: reset,
        resetValidation: resetValidation,
        validate: validate,
        validationClasses: validationClasses
    };
}



var $b8b1b307f20fc3d6$export$525655a73981d616 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    id: String,
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    baseColor: String,
    centerAffix: {
        type: Boolean,
        "default": true
    },
    color: String,
    glow: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    hideDetails: [
        Boolean,
        String
    ],
    hideSpinButtons: Boolean,
    hint: String,
    persistentHint: Boolean,
    messages: {
        type: [
            Array,
            String
        ],
        "default": function() {
            return [];
        }
    },
    direction: {
        type: String,
        "default": 'horizontal',
        validator: function(v) {
            return [
                'horizontal',
                'vertical'
            ].includes(v);
        }
    },
    'onClick:prepend': (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    'onClick:append': (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), [
    'maxWidth',
    'minWidth',
    'width'
]), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $dfc9eccea4b997fa$export$42513dbc731a0133)()), 'VInput');
var $b8b1b307f20fc3d6$export$2aca538d9f87f6ac = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VInput',
    props: (0, $iT0je._)({}, $b8b1b307f20fc3d6$export$525655a73981d616()),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var InputIcon = (0, $2bf11e725e4cea2c$export$d08cb507a9c34d4b)(props).InputIcon;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.computed)(function() {
            return props.id || "input-".concat(uid);
        });
        var _useValidation = (0, $dfc9eccea4b997fa$export$87fe492f99f25a20)(props, 'v-input', id), errorMessages = _useValidation.errorMessages, isDirty = _useValidation.isDirty, isDisabled = _useValidation.isDisabled, isReadonly = _useValidation.isReadonly, isPristine = _useValidation.isPristine, isValid = _useValidation.isValid, isValidating = _useValidation.isValidating, reset = _useValidation.reset, resetValidation = _useValidation.resetValidation, validate = _useValidation.validate, validationClasses = _useValidation.validationClasses;
        var messages = (0, $hXmfK.computed)(function() {
            var _props_errorMessages;
            if (((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length) || !isPristine.value && errorMessages.value.length) return errorMessages.value;
            else if (props.hint && (props.persistentHint || props.focused)) return props.hint;
            else return props.messages;
        });
        var hasMessages = (0, $hXmfK.toRef)(function() {
            return messages.value.length > 0;
        });
        var hasDetails = (0, $hXmfK.toRef)(function() {
            return !props.hideDetails || props.hideDetails === 'auto' && (hasMessages.value || !!slots.details);
        });
        var messagesId = (0, $hXmfK.computed)(function() {
            return hasDetails.value ? "".concat(id.value, "-messages") : undefined;
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                id: id,
                messagesId: messagesId,
                isDirty: isDirty,
                isDisabled: isDisabled,
                isReadonly: isReadonly,
                isPristine: isPristine,
                isValid: isValid,
                isValidating: isValidating,
                hasDetails: hasDetails,
                reset: reset,
                resetValidation: resetValidation,
                validate: validate
            };
        });
        var color = (0, $hXmfK.toRef)(function() {
            return props.error || props.disabled ? undefined : props.focused ? props.color : props.baseColor;
        });
        var iconColor = (0, $hXmfK.toRef)(function() {
            if (!props.iconColor) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_prepend, _slots_default, _slots_append, _slots_details;
            var hasPrepend = !!(slots.prepend || props.prependIcon);
            var hasAppend = !!(slots.append || props.appendIcon);
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-input',
                    "v-input--".concat(props.direction),
                    {
                        'v-input--center-affix': props.centerAffix,
                        'v-input--focused': props.focused,
                        'v-input--glow': props.glow,
                        'v-input--hide-spin-buttons': props.hideSpinButtons
                    },
                    densityClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    validationClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                    key: "prepend",
                    "class": "v-input__prepend"
                }, [
                    (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps.value),
                    props.prependIcon && (0, $bu8yf.createVNode)(InputIcon, {
                        key: "prepend-icon",
                        name: "prepend",
                        color: iconColor.value
                    }, null)
                ]),
                slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-input__control"
                }, [
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                ]),
                hasAppend && (0, $bu8yf.createElementVNode)("div", {
                    key: "append",
                    "class": "v-input__append"
                }, [
                    props.appendIcon && (0, $bu8yf.createVNode)(InputIcon, {
                        key: "append-icon",
                        name: "append",
                        color: iconColor.value
                    }, null),
                    (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, slotProps.value)
                ]),
                hasDetails.value && (0, $bu8yf.createElementVNode)("div", {
                    id: messagesId.value,
                    "class": "v-input__details",
                    role: "alert",
                    "aria-live": "polite"
                }, [
                    (0, $bu8yf.createVNode)((0, $536da37de9ff2b8b$export$31afdc787fe64f1d), {
                        active: hasMessages.value,
                        messages: messages.value
                    }, {
                        message: slots.message
                    }),
                    (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps.value)
                ])
            ]);
        });
        return {
            reset: reset,
            resetValidation: resetValidation,
            validate: validate,
            isValid: isValid,
            errorMessages: errorMessages
        };
    }
});


function $c8dd3d88903cb8c3$export$a9c05560d717b4fe(props) {
    function onIntersect(isIntersecting, entries) {
        var _entries__target_focus, _entries__target;
        if (!props.autofocus || !isIntersecting) return;
        (_entries__target = entries[0].target) === null || _entries__target === void 0 ? void 0 : (_entries__target_focus = _entries__target.focus) === null || _entries__target_focus === void 0 ? void 0 : _entries__target_focus.call(_entries__target);
    }
    return {
        onIntersect: onIntersect
    };
}







var $9193e20196e963bf$var$activeTypes = [
    'color',
    'file',
    'time',
    'date',
    'datetime-local',
    'week',
    'month'
];
var $9193e20196e963bf$export$c9f7484641b0b190 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: [
        Number,
        Function
    ],
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    suffix: String,
    role: String,
    type: {
        type: String,
        "default": 'text'
    },
    modelModifiers: Object
}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $88ed151c68066729$export$1e13429dc53b9634)()), 'VTextField');
var $9193e20196e963bf$export$d591c92dea965c28 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTextField',
    directives: {
        vIntersect: (0, $f77d117b08c9abf5$export$2e2bcd8739ae039)
    },
    inheritAttrs: false,
    props: $9193e20196e963bf$export$c9f7484641b0b190(),
    emits: {
        'click:control': function(e) {
            return true;
        },
        'mousedown:control': function(e) {
            return true;
        },
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var onIntersect = (0, $c8dd3d88903cb8c3$export$a9c05560d717b4fe)(props).onIntersect;
        var counterValue = (0, $hXmfK.computed)(function() {
            var _model_value;
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : '').toString().length;
        });
        var max = (0, $hXmfK.computed)(function() {
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        var isPlainOrUnderlined = (0, $hXmfK.computed)(function() {
            return [
                'plain',
                'underlined'
            ].includes(props.variant);
        });
        var vInputRef = (0, $hXmfK.ref)();
        var vFieldRef = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)();
        var isActive = (0, $hXmfK.computed)(function() {
            return $9193e20196e963bf$var$activeTypes.includes(props.type) || props.persistentPlaceholder || isFocused.value || props.active;
        });
        function onFocus() {
            if (!isFocused.value) focus();
            (0, $bu8yf.nextTick)(function() {
                if (inputRef.value !== document.activeElement) (0, $bu8yf.nextTick)(function() {
                    var _inputRef_value;
                    return (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.focus();
                });
            });
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
            if (e.target === inputRef.value) return;
            onFocus();
            e.preventDefault();
        }
        function onControlClick(e) {
            emit('click:control', e);
        }
        function onClear(e, reset) {
            e.stopPropagation();
            onFocus();
            (0, $bu8yf.nextTick)(function() {
                model.value = null;
                reset();
                (0, $31779689cfd5da50$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            var _props_modelModifiers;
            var el = e.target;
            model.value = el.value;
            if (((_props_modelModifiers = props.modelModifiers) === null || _props_modelModifiers === void 0 ? void 0 : _props_modelModifiers.trim) && [
                'text',
                'search',
                'password',
                'tel',
                'url'
            ].includes(props.type)) {
                var caretPosition = [
                    el.selectionStart,
                    el.selectionEnd
                ];
                (0, $bu8yf.nextTick)(function() {
                    el.selectionStart = caretPosition[0];
                    el.selectionEnd = caretPosition[1];
                });
            }
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasCounter = !!(slots.counter || props.counter !== false && props.counter != null);
            var hasDetails = !!(hasCounter || slots.details);
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], inputAttrs = _filterInputAttrs[1];
            var _VInput_filterProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props), _ = _VInput_filterProps.modelValue, inputProps = (0, $g79Gh._)(_VInput_filterProps, [
                "modelValue"
            ]);
            var fieldProps = (0, $88ed151c68066729$export$3180fb4997e9f72d).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: vInputRef,
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": [
                    'v-text-field',
                    {
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props["class"]
                ],
                style: props.style
            }, rootAttrs, inputProps, {
                centerAffix: !isPlainOrUnderlined.value,
                focused: isFocused.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref2) {
                    var id = _ref2.id, isDisabled = _ref2.isDisabled, isDirty = _ref2.isDirty, isReadonly = _ref2.isReadonly, isValid = _ref2.isValid, hasDetails = _ref2.hasDetails, reset = _ref2.reset;
                    return (0, $bu8yf.createVNode)((0, $88ed151c68066729$export$3180fb4997e9f72d), (0, $bu8yf.mergeProps)({
                        ref: vFieldRef,
                        onMousedown: onControlMousedown,
                        onClick: onControlClick,
                        "onClick:clear": function(e) {
                            return onClear(e, reset);
                        },
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner'],
                        role: props.role
                    }, fieldProps, {
                        id: id.value,
                        active: isActive.value || isDirty.value,
                        dirty: isDirty.value || props.dirty,
                        disabled: isDisabled.value,
                        focused: isFocused.value,
                        details: hasDetails.value,
                        error: isValid.value === false
                    }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                        "default": function(_ref3) {
                            var _ref3_props = _ref3.props, fieldClass = _ref3_props["class"], slotProps = (0, $g79Gh._)(_ref3.props, [
                                "class"
                            ]);
                            var inputNode = (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("input", (0, $bu8yf.mergeProps)({
                                ref: inputRef,
                                value: model.value,
                                onInput: onInput,
                                autofocus: props.autofocus,
                                readonly: isReadonly.value,
                                disabled: isDisabled.value,
                                name: props.name,
                                placeholder: props.placeholder,
                                size: 1,
                                type: props.type,
                                onFocus: onFocus,
                                onBlur: blur
                            }, slotProps, inputAttrs), null), [
                                [
                                    (0, $f77d117b08c9abf5$export$2e2bcd8739ae039),
                                    {
                                        handler: onIntersect
                                    },
                                    null,
                                    {
                                        once: true
                                    }
                                ]
                            ]);
                            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.prefix && (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    (0, $bu8yf.createElementVNode)("span", {
                                        "class": "v-text-field__prefix__text"
                                    }, [
                                        props.prefix
                                    ])
                                ]),
                                slots["default"] ? (0, $bu8yf.createElementVNode)("div", {
                                    "class": (0, $d8jBh.normalizeClass)(fieldClass),
                                    "data-no-activator": ""
                                }, [
                                    slots["default"](),
                                    inputNode
                                ]) : (0, $bu8yf.cloneVNode)(inputNode, {
                                    "class": fieldClass
                                }),
                                props.suffix && (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    (0, $bu8yf.createElementVNode)("span", {
                                        "class": "v-text-field__suffix__text"
                                    }, [
                                        props.suffix
                                    ])
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? function(slotProps) {
                    var _slots_details;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            (0, $bu8yf.createElementVNode)("span", null, null),
                            (0, $bu8yf.createVNode)((0, $7ba1fb3b216974cf$export$45efeae449ff2094), {
                                active: props.persistentCounter || isFocused.value,
                                value: counterValue.value,
                                max: max.value,
                                disabled: props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");



var $9956e44cfc4d2c8d$export$aed5522ef094d4d0 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    renderless: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VVirtualScrollItem');
var $9956e44cfc4d2c8d$export$e996ecbe8aa756e9 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VVirtualScrollItem',
    inheritAttrs: false,
    props: $9956e44cfc4d2c8d$export$aed5522ef094d4d0(),
    emits: {
        'update:height': function(height) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(undefined, 'border'), resizeRef = _useResizeObserver.resizeRef, contentRect = _useResizeObserver.contentRect;
        (0, $hXmfK.watch)(function() {
            var _contentRect_value;
            return (_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height;
        }, function(height) {
            if (height != null) emit('update:height', height);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default, _slots_default1;
            return props.renderless ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                    itemRef: resizeRef
                })
            ]) : (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                ref: resizeRef,
                "class": [
                    'v-virtual-scroll__item',
                    props["class"]
                ],
                style: props.style
            }, attrs), [
                (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)
            ]);
        });
    }
});





// Composables


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $d8c2c78df0f65c65$var$UP = -1;
var $d8c2c78df0f65c65$var$DOWN = 1;
/** Determines how large each batch of items should be */ var $d8c2c78df0f65c65$var$BUFFER_PX = 100;
var $d8c2c78df0f65c65$export$7703b7ab4acf2c49 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    itemHeight: {
        type: [
            Number,
            String
        ],
        "default": null
    },
    itemKey: {
        type: [
            String,
            Array,
            Function
        ],
        "default": null
    },
    height: [
        Number,
        String
    ]
}, 'virtual');
function $d8c2c78df0f65c65$export$ebc1863da693699a(props, items) {
    var display = (0, $a7414385605a88b0$export$8406b7efc286d284)();
    var itemHeight = (0, $hXmfK.shallowRef)(0);
    (0, $bu8yf.watchEffect)(function() {
        itemHeight.value = parseFloat(props.itemHeight || 0);
    });
    var first = (0, $hXmfK.shallowRef)(0);
    var last = (0, $hXmfK.shallowRef)(Math.ceil(// Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)) || 1);
    var paddingTop = (0, $hXmfK.shallowRef)(0);
    var paddingBottom = (0, $hXmfK.shallowRef)(0);
    /** The scrollable element */ var containerRef = (0, $hXmfK.ref)();
    /** An element marking the top of the scrollable area,
   * used to add an offset if there's padding or other elements above the virtual list */ var markerRef = (0, $hXmfK.ref)();
    /** markerRef's offsetTop, lazily evaluated */ var markerOffset = 0;
    var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), resizeRef = _useResizeObserver.resizeRef, contentRect = _useResizeObserver.contentRect;
    (0, $bu8yf.watchEffect)(function() {
        resizeRef.value = containerRef.value;
    });
    var viewportHeight = (0, $hXmfK.computed)(function() {
        var _contentRect_value;
        return containerRef.value === document.documentElement ? display.height.value : ((_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height) || parseInt(props.height) || 0;
    });
    /** All static elements have been rendered and we have an assumed item height */ var hasInitialRender = (0, $hXmfK.computed)(function() {
        return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
    });
    var sizes = Array.from({
        length: items.value.length
    });
    var offsets = Array.from({
        length: items.value.length
    });
    var updateTime = (0, $hXmfK.shallowRef)(0);
    var targetScrollIndex = -1;
    function getSize(index) {
        return sizes[index] || itemHeight.value;
    }
    var updateOffsets = (0, $31779689cfd5da50$export$61fc7d43ac8f84b0)(function() {
        var start = performance.now();
        offsets[0] = 0;
        var length = items.value.length;
        for(var i = 1; i <= length - 1; i++)offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
        updateTime.value = Math.max(updateTime.value, performance.now() - start);
    }, updateTime);
    var unwatch = (0, $hXmfK.watch)(hasInitialRender, function(v) {
        if (!v) return;
        // First render is complete, update offsets and visible
        // items in case our assumed item height was incorrect
        unwatch();
        markerOffset = markerRef.value.offsetTop;
        updateOffsets.immediate();
        calculateVisibleItems();
        if (!~targetScrollIndex) return;
        (0, $bu8yf.nextTick)(function() {
            (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(function() {
                scrollToIndex(targetScrollIndex);
                targetScrollIndex = -1;
            });
        });
    });
    (0, $hXmfK.onScopeDispose)(function() {
        updateOffsets.clear();
    });
    function handleItemResize(index, height) {
        var prevHeight = sizes[index];
        var prevMinHeight = itemHeight.value;
        itemHeight.value = prevMinHeight ? Math.min(itemHeight.value, height) : height;
        if (prevHeight !== height || prevMinHeight !== itemHeight.value) {
            sizes[index] = height;
            updateOffsets();
        }
    }
    function calculateOffset(index) {
        index = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(index, 0, items.value.length - 1);
        var whole = Math.floor(index);
        var fraction = index % 1;
        var next = whole + 1;
        var wholeOffset = offsets[whole] || 0;
        var nextOffset = offsets[next] || wholeOffset;
        return wholeOffset + (nextOffset - wholeOffset) * fraction;
    }
    function calculateIndex(scrollTop) {
        return $d8c2c78df0f65c65$var$binaryClosest(offsets, scrollTop);
    }
    var lastScrollTop = 0;
    var scrollVelocity = 0;
    var lastScrollTime = 0;
    (0, $hXmfK.watch)(viewportHeight, function(val, oldVal) {
        if (oldVal) {
            calculateVisibleItems();
            if (val < oldVal) requestAnimationFrame(function() {
                scrollVelocity = 0;
                calculateVisibleItems();
            });
        }
    });
    var scrollTimeout = -1;
    function handleScroll() {
        if (!containerRef.value || !markerRef.value) return;
        var scrollTop = containerRef.value.scrollTop;
        var scrollTime = performance.now();
        var scrollDeltaT = scrollTime - lastScrollTime;
        if (scrollDeltaT > 500) {
            scrollVelocity = Math.sign(scrollTop - lastScrollTop);
            // Not super important, only update at the
            // start of a scroll sequence to avoid reflows
            markerOffset = markerRef.value.offsetTop;
        } else scrollVelocity = scrollTop - lastScrollTop;
        lastScrollTop = scrollTop;
        lastScrollTime = scrollTime;
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(handleScrollend, 500);
        calculateVisibleItems();
    }
    function handleScrollend() {
        if (!containerRef.value || !markerRef.value) return;
        scrollVelocity = 0;
        lastScrollTime = 0;
        window.clearTimeout(scrollTimeout);
        calculateVisibleItems();
    }
    var raf = -1;
    function calculateVisibleItems() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(_calculateVisibleItems);
    }
    function _calculateVisibleItems() {
        if (!containerRef.value || !viewportHeight.value || !itemHeight.value) return;
        var scrollTop = lastScrollTop - markerOffset;
        var direction = Math.sign(scrollVelocity);
        var startPx = Math.max(0, scrollTop - $d8c2c78df0f65c65$var$BUFFER_PX);
        var start = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(calculateIndex(startPx), 0, items.value.length);
        var endPx = scrollTop + viewportHeight.value + $d8c2c78df0f65c65$var$BUFFER_PX;
        var end = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(calculateIndex(endPx) + 1, start + 1, items.value.length);
        if (// Only update the side we're scrolling towards,
        // the other side will be updated incidentally
        (direction !== $d8c2c78df0f65c65$var$UP || start < first.value) && (direction !== $d8c2c78df0f65c65$var$DOWN || end > last.value)) {
            var topOverflow = calculateOffset(first.value) - calculateOffset(start);
            var bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
            var bufferOverflow = Math.max(topOverflow, bottomOverflow);
            if (bufferOverflow > $d8c2c78df0f65c65$var$BUFFER_PX) {
                first.value = start;
                last.value = end;
            } else {
                // Only update the side that's reached its limit if there's still buffer left
                if (start <= 0) first.value = start;
                if (end >= items.value.length) last.value = end;
            }
        }
        paddingTop.value = calculateOffset(first.value);
        paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
    }
    function scrollToIndex(index) {
        var offset = calculateOffset(index);
        if (!containerRef.value || index && !offset) targetScrollIndex = index;
        else containerRef.value.scrollTop = offset;
    }
    var computedItems = (0, $hXmfK.computed)(function() {
        return items.value.slice(first.value, last.value).map(function(item, index) {
            var _index = index + first.value;
            return {
                raw: item,
                index: _index,
                key: (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemKey, _index)
            };
        });
    });
    (0, $hXmfK.watch)(items, function() {
        sizes = Array.from({
            length: items.value.length
        });
        offsets = Array.from({
            length: items.value.length
        });
        updateOffsets.immediate();
        calculateVisibleItems();
    }, {
        deep: 1
    });
    return {
        calculateVisibleItems: calculateVisibleItems,
        containerRef: containerRef,
        markerRef: markerRef,
        computedItems: computedItems,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        scrollToIndex: scrollToIndex,
        handleScroll: handleScroll,
        handleScrollend: handleScrollend,
        handleItemResize: handleItemResize
    };
}
// https://gist.github.com/robertleeplummerjr/1cc657191d34ecd0a324
function $d8c2c78df0f65c65$var$binaryClosest(arr, val) {
    var high = arr.length - 1;
    var low = 0;
    var mid = 0;
    var item = null;
    var target = -1;
    if (arr[high] < val) return high;
    while(low <= high){
        mid = low + high >> 1;
        item = arr[mid];
        if (item > val) high = mid - 1;
        else if (item < val) {
            target = mid;
            low = mid + 1;
        } else if (item === val) return mid;
        else return low;
    }
    return target;
}



var $af9026073940257e$export$f8006e3167d3452e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    renderless: Boolean
}, (0, $d8c2c78df0f65c65$export$7703b7ab4acf2c49)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)()), 'VVirtualScroll');
var $af9026073940257e$export$bdb136bf2d9028a4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VVirtualScroll',
    props: $af9026073940257e$export$f8006e3167d3452e(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('VVirtualScroll');
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var _useVirtual = (0, $d8c2c78df0f65c65$export$ebc1863da693699a)(props, (0, $hXmfK.toRef)(function() {
            return props.items;
        })), calculateVisibleItems = _useVirtual.calculateVisibleItems, containerRef = _useVirtual.containerRef, markerRef = _useVirtual.markerRef, handleScroll = _useVirtual.handleScroll, handleScrollend = _useVirtual.handleScrollend, handleItemResize = _useVirtual.handleItemResize, scrollToIndex = _useVirtual.scrollToIndex, paddingTop = _useVirtual.paddingTop, paddingBottom = _useVirtual.paddingBottom, computedItems = _useVirtual.computedItems;
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.renderless;
        }, function() {
            var handleListeners = function handleListeners() {
                var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var method = add ? 'addEventListener' : 'removeEventListener';
                if (containerRef.value === document.documentElement) {
                    document[method]('scroll', handleScroll, {
                        passive: true
                    });
                    document[method]('scrollend', handleScrollend);
                } else {
                    var _containerRef_value, _containerRef_value1;
                    (_containerRef_value = containerRef.value) === null || _containerRef_value === void 0 ? void 0 : _containerRef_value[method]('scroll', handleScroll, {
                        passive: true
                    });
                    (_containerRef_value1 = containerRef.value) === null || _containerRef_value1 === void 0 ? void 0 : _containerRef_value1[method]('scrollend', handleScrollend);
                }
            };
            (0, $bu8yf.onMounted)(function() {
                containerRef.value = (0, $84c2348fe514d5ac$export$cfa2225e87938781)(vm.vnode.el, true);
                handleListeners(true);
            });
            (0, $hXmfK.onScopeDispose)(handleListeners);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var children = computedItems.value.map(function(item) {
                return (0, $bu8yf.createVNode)((0, $9956e44cfc4d2c8d$export$e996ecbe8aa756e9), {
                    key: item.key,
                    renderless: props.renderless,
                    "onUpdate:height": function(height) {
                        return handleItemResize(item.index, height);
                    }
                }, {
                    "default": function(slotProps) {
                        var _slots_default;
                        return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, (0, $iT0je._)({
                            item: item.raw,
                            index: item.index
                        }, slotProps));
                    }
                });
            });
            return props.renderless ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (0, $bu8yf.createElementVNode)("div", {
                    ref: markerRef,
                    "class": "v-virtual-scroll__spacer",
                    style: {
                        paddingTop: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingTop.value)
                    }
                }, null),
                children,
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-virtual-scroll__spacer",
                    style: {
                        paddingBottom: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, null)
            ]) : (0, $bu8yf.createElementVNode)("div", {
                ref: containerRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-virtual-scroll',
                    props["class"]
                ]),
                onScrollPassive: handleScroll,
                onScrollend: handleScrollend,
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    ref: markerRef,
                    "class": "v-virtual-scroll__container",
                    style: {
                        paddingTop: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingTop.value),
                        paddingBottom: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, [
                    children
                ])
            ]);
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});


// Utilities

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
function $1aaec02719422793$export$5081bf709ff6ca2c(listRef, textFieldRef) {
    var isScrolling = (0, $hXmfK.shallowRef)(false);
    var scrollTimeout;
    function onListScroll(e) {
        cancelAnimationFrame(scrollTimeout);
        isScrolling.value = true;
        scrollTimeout = requestAnimationFrame(function() {
            scrollTimeout = requestAnimationFrame(function() {
                isScrolling.value = false;
            });
        });
    }
    function finishScrolling() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                if (isScrolling.value) {
                                    var stop = (0, $hXmfK.watch)(isScrolling, function() {
                                        stop();
                                        resolve();
                                    });
                                } else resolve();
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function onListKeydown(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _textFieldRef_value, _listRef_value, el, children, top, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, bottom, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, child1;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e.key === 'Tab') (_textFieldRef_value = textFieldRef.value) === null || _textFieldRef_value === void 0 ? void 0 : _textFieldRef_value.focus();
                        if (![
                            'PageDown',
                            'PageUp',
                            'Home',
                            'End'
                        ].includes(e.key)) return [
                            2
                        ];
                        el = (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.$el;
                        if (!el) return [
                            2
                        ];
                        if (e.key === 'Home' || e.key === 'End') el.scrollTo({
                            top: e.key === 'Home' ? 0 : el.scrollHeight,
                            behavior: 'smooth'
                        });
                        return [
                            4,
                            finishScrolling()
                        ];
                    case 1:
                        _state.sent();
                        children = el.querySelectorAll(':scope > :not(.v-virtual-scroll__spacer)');
                        if (e.key === 'PageDown' || e.key === 'Home') {
                            top = el.getBoundingClientRect().top;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = children[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    child = _step.value;
                                    if (child.getBoundingClientRect().top >= top) {
                                        child.focus();
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        } else {
                            bottom = el.getBoundingClientRect().bottom;
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = (0, $7WNf6._)(children).reverse()[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    child1 = _step1.value;
                                    if (child1.getBoundingClientRect().bottom <= bottom) {
                                        child1.focus();
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                        _iterator1["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return {
        onScrollPassive: onListScroll,
        onKeydown: onListKeydown
    }; // typescript doesn't know about vue's event merging
}










var $416a51876874f600$export$c210933f6eecdb37 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    chips: Boolean,
    closableChips: Boolean,
    closeText: {
        type: String,
        "default": '$vuetify.close'
    },
    openText: {
        type: String,
        "default": '$vuetify.open'
    },
    eager: Boolean,
    hideNoData: Boolean,
    hideSelected: Boolean,
    listProps: {
        type: Object
    },
    menu: Boolean,
    menuIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$dropdown'
    },
    menuProps: {
        type: Object
    },
    multiple: Boolean,
    noDataText: {
        type: String,
        "default": '$vuetify.noDataText'
    },
    openOnClear: Boolean,
    itemColor: String,
    noAutoScroll: Boolean
}, (0, $52b7ed45bf07e834$export$899bb842e69e7bd4)({
    itemChildren: false
})), 'Select');
var $416a51876874f600$export$38d465e3bb404772 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, $416a51876874f600$export$c210933f6eecdb37(), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9193e20196e963bf$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $b2974c952e31c38b$export$9778a08df954f36c)
    }
})), 'VSelect');
var $416a51876874f600$export$1d8182ee812485f5 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSelect',
    props: $416a51876874f600$export$38d465e3bb404772(),
    emits: {
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        'update:menu': function(ue) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var vTextFieldRef = (0, $hXmfK.ref)();
        var vMenuRef = (0, $hXmfK.ref)();
        var vVirtualScrollRef = (0, $hXmfK.ref)();
        var _useItems = (0, $52b7ed45bf07e834$export$7bfdd97581ca93c)(props), items = _useItems.items, transformIn = _useItems.transformIn, transformOut = _useItems.transformOut;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', [], function(v) {
            return transformIn(v === null ? [
                null
            ] : (0, $31779689cfd5da50$export$76411cac38121ecb)(v));
        }, function(v) {
            var transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        var counterValue = (0, $hXmfK.computed)(function() {
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        var form = (0, $04771d0544148a45$export$87c0cf8eb5a167e0)(props);
        var selectedValues = (0, $hXmfK.computed)(function() {
            return model.value.map(function(selection) {
                return selection.value;
            });
        });
        var isFocused = (0, $hXmfK.shallowRef)(false);
        var keyboardLookupPrefix = '';
        var keyboardLookupIndex = -1;
        var keyboardLookupLastTime;
        var displayItems = (0, $hXmfK.computed)(function() {
            if (props.hideSelected) return items.value.filter(function(item) {
                return !model.value.some(function(s) {
                    return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(s, item);
                });
            });
            return items.value;
        });
        var menuDisabled = (0, $hXmfK.computed)(function() {
            return props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value;
        });
        var _menu = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'menu');
        var menu = (0, $hXmfK.computed)({
            get: function() {
                return _menu.value;
            },
            set: function(v) {
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        var label = (0, $hXmfK.toRef)(function() {
            return menu.value ? props.closeText : props.openText;
        });
        var computedMenuProps = (0, $hXmfK.computed)(function() {
            var _props_menuProps;
            return (0, $emQHU._)((0, $iT0je._)({}, props.menuProps), {
                activatorProps: (0, $emQHU._)((0, $iT0je._)({}, ((_props_menuProps = props.menuProps) === null || _props_menuProps === void 0 ? void 0 : _props_menuProps.activatorProps) || {}), {
                    'aria-haspopup': 'listbox' // Set aria-haspopup to 'listbox'
                })
            });
        });
        var listRef = (0, $hXmfK.ref)();
        var listEvents = (0, $1aaec02719422793$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            if ((0, $31779689cfd5da50$export$d9d503bf19df5a70)(e)) onKeydown(e);
        }
        function onKeydown(e) {
            var _listRef_value, _listRef_value1, _listRef_value2;
            if (!e.key || form.isReadonly.value) return;
            if ([
                'Enter',
                ' ',
                'ArrowDown',
                'ArrowUp',
                'Home',
                'End'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown',
                ' '
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape',
                'Tab'
            ].includes(e.key)) menu.value = false;
            if (e.key === 'Home') (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('first');
            else if (e.key === 'End') (_listRef_value1 = listRef.value) === null || _listRef_value1 === void 0 ? void 0 : _listRef_value1.focus('last');
            // html select hotkeys
            var KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds
            if (!(0, $31779689cfd5da50$export$d9d503bf19df5a70)(e)) return;
            var now = performance.now();
            if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                keyboardLookupPrefix = '';
                keyboardLookupIndex = -1;
            }
            keyboardLookupPrefix += e.key.toLowerCase();
            keyboardLookupLastTime = now;
            var items = displayItems.value;
            function findItem() {
                var result = findItemBase();
                if (result) return result;
                if (keyboardLookupPrefix.at(-1) === keyboardLookupPrefix.at(-2)) {
                    // No matches but we have a repeated letter, try the next item with that prefix
                    keyboardLookupPrefix = keyboardLookupPrefix.slice(0, -1);
                    result = findItemBase();
                    if (result) return result;
                }
                // Still nothing, wrap around to the top
                keyboardLookupIndex = -1;
                result = findItemBase();
                if (result) return result;
                // Still nothing, try just the new letter
                keyboardLookupPrefix = e.key.toLowerCase();
                return findItemBase();
            }
            function findItemBase() {
                for(var i = keyboardLookupIndex + 1; i < items.length; i++){
                    var _item = items[i];
                    if (_item.title.toLowerCase().startsWith(keyboardLookupPrefix)) return [
                        _item,
                        i
                    ];
                }
                return undefined;
            }
            var result = findItem();
            if (!result) return;
            var _result = (0, $32TW8._)(result, 2), item = _result[0], index = _result[1];
            keyboardLookupIndex = index;
            (_listRef_value2 = listRef.value) === null || _listRef_value2 === void 0 ? void 0 : _listRef_value2.focus(index);
            if (!props.multiple) model.value = [
                item
            ];
        }
        /** @param set - null means toggle */ function select(item) {
            var set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (item.props.disabled) return;
            if (props.multiple) {
                var index = model.value.findIndex(function(selection) {
                    return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(selection.value, item.value);
                });
                var add = set == null ? !~index : set;
                if (~index) {
                    var value = add ? (0, $7WNf6._)(model.value).concat([
                        item
                    ]) : (0, $7WNf6._)(model.value);
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = (0, $7WNf6._)(model.value).concat([
                    item
                ]);
            } else {
                var add1 = set !== false;
                model.value = add1 ? [
                    item
                ] : [];
                (0, $bu8yf.nextTick)(function() {
                    menu.value = false;
                });
            }
        }
        function onBlur(e) {
            var _listRef_value;
            if (!((_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.$el.contains(e.relatedTarget))) menu.value = false;
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            var _vTextFieldRef_value;
            if (isFocused.value) (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onModelUpdate(v) {
            if (v == null) model.value = [];
            else if ((0, $31779689cfd5da50$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $31779689cfd5da50$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                var item = items.value.find(function(item) {
                    return item.title === v;
                });
                if (item) select(item);
            } else if (vTextFieldRef.value) vTextFieldRef.value.value = '';
        }
        (0, $hXmfK.watch)(menu, function() {
            if (!props.hideSelected && menu.value && model.value.length) {
                var index = displayItems.value.findIndex(function(item) {
                    return model.value.some(function(s) {
                        return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(s.value, item.value);
                    });
                });
                (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && !props.noAutoScroll && window.requestAnimationFrame(function() {
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $hXmfK.watch)(function() {
            return props.items;
        }, function(newVal, oldVal) {
            if (menu.value) return;
            if (isFocused.value && props.hideNoData && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasChips = !!(props.chips || slots.chip);
            var hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            var isDirty = model.value.length > 0;
            var textFieldProps = (0, $9193e20196e963bf$export$d591c92dea965c28).filterProps(props);
            var placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? undefined : props.placeholder;
            var _obj;
            return (0, $bu8yf.createVNode)((0, $9193e20196e963bf$export$d591c92dea965c28), (0, $bu8yf.mergeProps)({
                ref: vTextFieldRef
            }, textFieldProps, {
                modelValue: model.value.map(function(v) {
                    return v.props.value;
                }).join(', '),
                "onUpdate:modelValue": onModelUpdate,
                focused: isFocused.value,
                "onUpdate:focused": function($event) {
                    return isFocused.value = $event;
                },
                validationValue: model.externalValue,
                counterValue: counterValue.value,
                dirty: isDirty,
                "class": [
                    'v-select',
                    (_obj = {
                        'v-select--active-menu': menu.value,
                        'v-select--chips': !!props.chips
                    }, (0, $cqEAj._)(_obj, "v-select--".concat(props.multiple ? 'multiple' : 'single'), true), (0, $cqEAj._)(_obj, 'v-select--selected', model.value.length), (0, $cqEAj._)(_obj, 'v-select--selection-slot', !!slots.selection), _obj),
                    props["class"]
                ],
                style: props.style,
                inputmode: "none",
                placeholder: placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                onBlur: onBlur,
                onKeydown: onKeydown,
                "aria-label": t(label.value),
                title: t(label.value)
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $7cf2e5a7271d5533$export$a347888d6b8f252a), (0, $bu8yf.mergeProps)({
                            ref: vMenuRef,
                            modelValue: menu.value,
                            "onUpdate:modelValue": function($event) {
                                return menu.value = $event;
                            },
                            activator: "parent",
                            contentClass: "v-select__content",
                            disabled: menuDisabled.value,
                            eager: props.eager,
                            maxHeight: 310,
                            openOnClick: false,
                            closeOnContentClick: false,
                            transition: props.transition,
                            onAfterEnter: onAfterEnter,
                            onAfterLeave: onAfterLeave
                        }, computedMenuProps.value), {
                            "default": function() {
                                var _props_itemColor;
                                return [
                                    hasList && (0, $bu8yf.createVNode)((0, $c46d6e9c2ddd50d5$export$3b010b0401837103), (0, $bu8yf.mergeProps)({
                                        ref: listRef,
                                        selected: selectedValues.value,
                                        selectStrategy: props.multiple ? 'independent' : 'single-independent',
                                        onMousedown: function(e) {
                                            return e.preventDefault();
                                        },
                                        onKeydown: onListKeydown,
                                        onFocusin: onFocusin,
                                        tabindex: "-1",
                                        "aria-live": "polite",
                                        "aria-label": "".concat(props.label, "-list"),
                                        color: (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        "default": function() {
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), {
                                                    key: "no-data",
                                                    title: t(props.noDataText)
                                                }, null)),
                                                (0, $bu8yf.createVNode)((0, $af9026073940257e$export$bdb136bf2d9028a4), {
                                                    ref: vVirtualScrollRef,
                                                    renderless: true,
                                                    items: displayItems.value,
                                                    itemKey: "value"
                                                }, {
                                                    "default": function(_ref2) {
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        var item = _ref2.item, index = _ref2.index, itemRef = _ref2.itemRef;
                                                        var camelizedProps = (0, $31779689cfd5da50$export$32263599c7ddd4ae)(item.props);
                                                        var itemProps = (0, $bu8yf.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            onClick: function() {
                                                                return select(item, null);
                                                            }
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "divider-".concat(index)
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $bu8yf.createVNode)((0, $c18be527f2406595$export$70c4aba7bf48e22a), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "subheader-".concat(index)
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), (0, $bu8yf.mergeProps)(itemProps, {
                                                            role: "option"
                                                        }), {
                                                            prepend: function(_ref3) {
                                                                var isSelected = _ref3.isSelected;
                                                                return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                                                        key: item.value,
                                                                        modelValue: isSelected,
                                                                        ripple: false,
                                                                        tabindex: "-1"
                                                                    }, null) : undefined,
                                                                    camelizedProps.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                                                        image: camelizedProps.prependAvatar
                                                                    }, null),
                                                                    camelizedProps.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                                        icon: camelizedProps.prependIcon
                                                                    }, null)
                                                                ]);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map(function(item, index) {
                            var onChipClose = function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            };
                            var slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown: function(e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown: function(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            var hasSlot = hasChips ? !!slots.chip : !!slots.selection;
                            var slotContent = hasSlot ? (0, $31779689cfd5da50$export$9fc41f261330971f)(hasChips ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $bu8yf.createElementVNode)("div", {
                                key: item.value,
                                "class": "v-select__selection"
                            }, [
                                hasChips ? !slots.chip ? (0, $bu8yf.createVNode)((0, $2f12dac67cff7cbd$export$1b5fab12cd17b4fb), (0, $bu8yf.mergeProps)({
                                    key: "chip",
                                    closable: props.closableChips,
                                    size: "small",
                                    text: item.title,
                                    disabled: item.props.disabled
                                }, slotProps), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                    key: "chip-defaults",
                                    defaults: {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    "default": function() {
                                        return [
                                            slotContent
                                        ];
                                    }
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-select__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $bu8yf.createElementVNode)("span", {
                                        "class": "v-select__selection-comma"
                                    }, [
                                        (0, $bu8yf.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    var _slots_appendinner;
                    var _slots_appendinner1, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_appendinner1 = slots['append-inner']) === null || _slots_appendinner1 === void 0 ? void 0 : (_slots_appendinner = _slots_appendinner1).call.apply(_slots_appendinner, [
                            slots
                        ].concat((0, $7WNf6._)(args))),
                        props.menuIcon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            "class": "v-select__menu-icon",
                            color: (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            icon: props.menuIcon
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            menu: menu,
            select: select
        }, vTextFieldRef);
    }
});






/* eslint-disable max-statements */ /* eslint-disable no-labels */ // Utilities

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

var $d8173a2b878f034f$export$3f6f640afaf1ec43 = function(value, query, item) {
    if (value == null || query == null) return -1;
    if (!query.length) return 0;
    value = value.toString().toLocaleLowerCase();
    query = query.toString().toLocaleLowerCase();
    var result = [];
    var idx = value.indexOf(query);
    while(~idx){
        result.push([
            idx,
            idx + query.length
        ]);
        idx = value.indexOf(query, idx + query.length);
    }
    return result.length ? result : -1;
};
function $d8173a2b878f034f$var$normaliseMatch(match, query) {
    if (match == null || typeof match === 'boolean' || match === -1) return;
    if (typeof match === 'number') return [
        [
            match,
            match + query.length
        ]
    ];
    if (Array.isArray(match[0])) return match;
    return [
        match
    ];
}
var $d8173a2b878f034f$export$a99bb5c4eecafb96 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    customFilter: Function,
    customKeyFilter: Object,
    filterKeys: [
        Array,
        String
    ],
    filterMode: {
        type: String,
        "default": 'intersection'
    },
    noFilter: Boolean
}, 'filter');
function $d8173a2b878f034f$export$16c4c0987c894b8c(items, query, options) {
    var array = [];
    var _options_default;
    // always ensure we fall back to a functioning filter
    var filter = (_options_default = options === null || options === void 0 ? void 0 : options["default"]) !== null && _options_default !== void 0 ? _options_default : $d8173a2b878f034f$export$3f6f640afaf1ec43;
    var keys = (options === null || options === void 0 ? void 0 : options.filterKeys) ? (0, $31779689cfd5da50$export$76411cac38121ecb)(options.filterKeys) : false;
    var _options_customKeyFilter;
    var customFiltersLength = Object.keys((_options_customKeyFilter = options === null || options === void 0 ? void 0 : options.customKeyFilter) !== null && _options_customKeyFilter !== void 0 ? _options_customKeyFilter : {}).length;
    if (!(items === null || items === void 0 ? void 0 : items.length)) return array;
    loop: for(var i = 0; i < items.length; i++){
        var _wrapInArray = (0, $32TW8._)((0, $31779689cfd5da50$export$76411cac38121ecb)(items[i]), 2), item = _wrapInArray[0], tmp = _wrapInArray[1], transformed = tmp === void 0 ? item : tmp;
        var customMatches = {};
        var defaultMatches = {};
        var match = -1;
        if ((query || customFiltersLength > 0) && !(options === null || options === void 0 ? void 0 : options.noFilter)) {
            if ((typeof item === "undefined" ? "undefined" : (0, $3KZcf._)(item)) === 'object') {
                if (item.type === 'divider' || item.type === 'subheader') continue;
                var filterKeys = keys || Object.keys(transformed);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = filterKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var _options_customKeyFilter1;
                        var value = (0, $31779689cfd5da50$export$655f0e681f1365dc)(transformed, key);
                        var keyFilter = options === null || options === void 0 ? void 0 : (_options_customKeyFilter1 = options.customKeyFilter) === null || _options_customKeyFilter1 === void 0 ? void 0 : _options_customKeyFilter1[key];
                        match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
                        if (match !== -1 && match !== false) {
                            if (keyFilter) customMatches[key] = $d8173a2b878f034f$var$normaliseMatch(match, query);
                            else defaultMatches[key] = $d8173a2b878f034f$var$normaliseMatch(match, query);
                        } else if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'every') continue loop;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                match = filter(item, query, item);
                if (match !== -1 && match !== false) defaultMatches.title = $d8173a2b878f034f$var$normaliseMatch(match, query);
            }
            var defaultMatchesLength = Object.keys(defaultMatches).length;
            var customMatchesLength = Object.keys(customMatches).length;
            if (!defaultMatchesLength && !customMatchesLength) continue;
            if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'union' && customMatchesLength !== customFiltersLength && !defaultMatchesLength) continue;
            if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'intersection' && (customMatchesLength !== customFiltersLength || !defaultMatchesLength)) continue;
        }
        array.push({
            index: i,
            matches: (0, $iT0je._)({}, defaultMatches, customMatches)
        });
    }
    return array;
}
function $d8173a2b878f034f$export$3274cf84b703fff(props, items, query, options) {
    var filteredItems = (0, $hXmfK.shallowRef)([]);
    var filteredMatches = (0, $hXmfK.shallowRef)(new Map());
    var transformedItems = (0, $hXmfK.computed)(function() {
        return (options === null || options === void 0 ? void 0 : options.transform) ? (0, $hXmfK.unref)(items).map(function(item) {
            return [
                item,
                options.transform(item)
            ];
        }) : (0, $hXmfK.unref)(items);
    });
    (0, $bu8yf.watchEffect)(function() {
        var _query = typeof query === 'function' ? query() : (0, $hXmfK.unref)(query);
        var strQuery = typeof _query !== 'string' && typeof _query !== 'number' ? '' : String(_query);
        var results = $d8173a2b878f034f$export$16c4c0987c894b8c(transformedItems.value, strQuery, {
            customKeyFilter: (0, $iT0je._)({}, props.customKeyFilter, (0, $hXmfK.unref)(options === null || options === void 0 ? void 0 : options.customKeyFilter)),
            "default": props.customFilter,
            filterKeys: props.filterKeys,
            filterMode: props.filterMode,
            noFilter: props.noFilter
        });
        var originalItems = (0, $hXmfK.unref)(items);
        var _filteredItems = [];
        var _filteredMatches = new Map();
        results.forEach(function(_ref) {
            var index = _ref.index, matches = _ref.matches;
            var item = originalItems[index];
            _filteredItems.push(item);
            _filteredMatches.set(item.value, matches);
        });
        filteredItems.value = _filteredItems;
        filteredMatches.value = _filteredMatches;
    });
    function getMatches(item) {
        return filteredMatches.value.get(item.value);
    }
    return {
        filteredItems: filteredItems,
        filteredMatches: filteredMatches,
        getMatches: getMatches
    };
}
function $d8173a2b878f034f$export$71650bdcd27abbc4(name, text, matches) {
    if (matches == null || !matches.length) return text;
    return matches.map(function(match, i) {
        var start = i === 0 ? 0 : matches[i - 1][1];
        var result = [
            (0, $bu8yf.createElementVNode)("span", {
                "class": (0, $d8jBh.normalizeClass)("".concat(name, "__unmask"))
            }, [
                text.slice(start, match[0])
            ]),
            (0, $bu8yf.createElementVNode)("span", {
                "class": (0, $d8jBh.normalizeClass)("".concat(name, "__mask"))
            }, [
                text.slice(match[0], match[1])
            ])
        ];
        if (i === matches.length - 1) result.push((0, $bu8yf.createElementVNode)("span", {
            "class": (0, $d8jBh.normalizeClass)("".concat(name, "__unmask"))
        }, [
            text.slice(match[1])
        ]));
        return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
            result
        ]);
    });
}









var $49d350329fe17d0a$export$22346519bf6a5f32 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: Boolean,
    search: String
}, (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $416a51876874f600$export$c210933f6eecdb37)(), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9193e20196e963bf$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: false
})), 'VAutocomplete');
var $49d350329fe17d0a$export$4fa8d945b1b14087 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VAutocomplete',
    props: $49d350329fe17d0a$export$22346519bf6a5f32(),
    emits: {
        'update:focused': function(focused) {
            return true;
        },
        'update:search': function(value) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        'update:menu': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var vTextFieldRef = (0, $hXmfK.ref)();
        var isFocused = (0, $hXmfK.shallowRef)(false);
        var isPristine = (0, $hXmfK.shallowRef)(true);
        var listHasFocus = (0, $hXmfK.shallowRef)(false);
        var vMenuRef = (0, $hXmfK.ref)();
        var vVirtualScrollRef = (0, $hXmfK.ref)();
        var selectionIndex = (0, $hXmfK.shallowRef)(-1);
        var _useItems = (0, $52b7ed45bf07e834$export$7bfdd97581ca93c)(props), items = _useItems.items, transformIn = _useItems.transformIn, transformOut = _useItems.transformOut;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            var _vTextFieldRef_value;
            return (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var search = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'search', '');
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', [], function(v) {
            return transformIn(v === null ? [
                null
            ] : (0, $31779689cfd5da50$export$76411cac38121ecb)(v));
        }, function(v) {
            var transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        var counterValue = (0, $hXmfK.computed)(function() {
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        var form = (0, $04771d0544148a45$export$87c0cf8eb5a167e0)(props);
        var _useFilter = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, items, function() {
            return isPristine.value ? '' : search.value;
        }), filteredItems = _useFilter.filteredItems, getMatches = _useFilter.getMatches;
        var displayItems = (0, $hXmfK.computed)(function() {
            if (props.hideSelected) return filteredItems.value.filter(function(filteredItem) {
                return !model.value.some(function(s) {
                    return s.value === filteredItem.value;
                });
            });
            return filteredItems.value;
        });
        var hasChips = (0, $hXmfK.computed)(function() {
            return !!(props.chips || slots.chip);
        });
        var hasSelectionSlot = (0, $hXmfK.computed)(function() {
            return hasChips.value || !!slots.selection;
        });
        var selectedValues = (0, $hXmfK.computed)(function() {
            return model.value.map(function(selection) {
                return selection.props.value;
            });
        });
        var highlightFirst = (0, $hXmfK.computed)(function() {
            var _displayItems_value_;
            var selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === ((_displayItems_value_ = displayItems.value[0]) === null || _displayItems_value_ === void 0 ? void 0 : _displayItems_value_.title);
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        var menuDisabled = (0, $hXmfK.computed)(function() {
            return props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value;
        });
        var _menu = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'menu');
        var menu = (0, $hXmfK.computed)({
            get: function() {
                return _menu.value;
            },
            set: function(v) {
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        var label = (0, $hXmfK.computed)(function() {
            return menu.value ? props.closeText : props.openText;
        });
        var listRef = (0, $hXmfK.ref)();
        var listEvents = (0, $1aaec02719422793$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
            search.value = '';
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            var _vTextFieldRef_value;
            if ((0, $31779689cfd5da50$export$d9d503bf19df5a70)(e) || e.key === 'Backspace') (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        function onKeydown(e) {
            var _vTextFieldRef_value, _listRef_value;
            if (form.isReadonly.value) return;
            var selectionStart = (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.selectionStart;
            var length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if (highlightFirst.value && [
                'Enter',
                'Tab'
            ].includes(e.key) && !model.value.some(function(_ref2) {
                var value = _ref2.value;
                return value === displayItems.value[0].value;
            })) select(displayItems.value[0]);
            if (e.key === 'ArrowDown' && highlightFirst.value) (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('next');
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    var originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                var prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    var _search_value, _vTextFieldRef_value1;
                    var _search_value_length;
                    var searchLength = (_search_value_length = (_search_value = search.value) === null || _search_value === void 0 ? void 0 : _search_value.length) !== null && _search_value_length !== void 0 ? _search_value_length : null;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value1 = vTextFieldRef.value) === null || _vTextFieldRef_value1 === void 0 ? void 0 : _vTextFieldRef_value1.setSelectionRange(searchLength, searchLength);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                var next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    var _vTextFieldRef_value2;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value2 = vTextFieldRef.value) === null || _vTextFieldRef_value2 === void 0 ? void 0 : _vTextFieldRef_value2.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $31779689cfd5da50$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onChange(e) {
            if ((0, $31779689cfd5da50$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $31779689cfd5da50$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                var item = items.value.find(function(item) {
                    return item.title === e.target.value;
                });
                if (item) select(item);
            }
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) {
                var _vTextFieldRef_value;
                isPristine.value = true;
                (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
            }
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(function() {
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onUpdateModelValue(v) {
            if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
        }
        var isSelecting = (0, $hXmfK.shallowRef)(false);
        /** @param set - null means toggle */ function select(item) {
            var set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                var index = model.value.findIndex(function(selection) {
                    return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(selection.value, item.value);
                });
                var add = set == null ? !~index : set;
                if (~index) {
                    var value = add ? (0, $7WNf6._)(model.value).concat([
                        item
                    ]) : (0, $7WNf6._)(model.value);
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = (0, $7WNf6._)(model.value).concat([
                    item
                ]);
                if (props.clearOnSelect) search.value = '';
            } else {
                var add1 = set !== false;
                model.value = add1 ? [
                    item
                ] : [];
                search.value = add1 && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $bu8yf.nextTick)(function() {
                    menu.value = false;
                    isPristine.value = true;
                });
            }
        }
        (0, $hXmfK.watch)(isFocused, function(val, oldVal) {
            if (val === oldVal) return;
            if (val) {
                var _model_value_at;
                isSelecting.value = true;
                var _model_value_at_props_title;
                search.value = props.multiple || hasSelectionSlot.value ? '' : String((_model_value_at_props_title = (_model_value_at = model.value.at(-1)) === null || _model_value_at === void 0 ? void 0 : _model_value_at.props.title) !== null && _model_value_at_props_title !== void 0 ? _model_value_at_props_title : '');
                isPristine.value = true;
                (0, $bu8yf.nextTick)(function() {
                    return isSelecting.value = false;
                });
            } else {
                if (!props.multiple && search.value == null) model.value = [];
                menu.value = false;
                if (props.multiple || hasSelectionSlot.value) search.value = '';
                selectionIndex.value = -1;
            }
        });
        (0, $hXmfK.watch)(search, function(val) {
            if (!isFocused.value || isSelecting.value) return;
            if (val) menu.value = true;
            isPristine.value = !val;
        });
        (0, $hXmfK.watch)(menu, function() {
            if (!props.hideSelected && menu.value && model.value.length) {
                var index = displayItems.value.findIndex(function(item) {
                    return model.value.some(function(s) {
                        return item.value === s.value;
                    });
                });
                (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(function() {
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $hXmfK.watch)(function() {
            return props.items;
        }, function(newVal, oldVal) {
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            var isDirty = model.value.length > 0;
            var textFieldProps = (0, $9193e20196e963bf$export$d591c92dea965c28).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $9193e20196e963bf$export$d591c92dea965c28), (0, $bu8yf.mergeProps)({
                ref: vTextFieldRef
            }, textFieldProps, {
                modelValue: search.value,
                "onUpdate:modelValue": [
                    function($event) {
                        return search.value = $event;
                    },
                    onUpdateModelValue
                ],
                focused: isFocused.value,
                "onUpdate:focused": function($event) {
                    return isFocused.value = $event;
                },
                validationValue: model.externalValue,
                counterValue: counterValue.value,
                dirty: isDirty,
                onChange: onChange,
                "class": [
                    'v-autocomplete',
                    "v-autocomplete--".concat(props.multiple ? 'multiple' : 'single'),
                    {
                        'v-autocomplete--active-menu': menu.value,
                        'v-autocomplete--chips': !!props.chips,
                        'v-autocomplete--selection-slot': !!hasSelectionSlot.value,
                        'v-autocomplete--selecting-index': selectionIndex.value > -1
                    },
                    props["class"]
                ],
                style: props.style,
                readonly: form.isReadonly.value,
                placeholder: isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                onKeydown: onKeydown
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $7cf2e5a7271d5533$export$a347888d6b8f252a), (0, $bu8yf.mergeProps)({
                            ref: vMenuRef,
                            modelValue: menu.value,
                            "onUpdate:modelValue": function($event) {
                                return menu.value = $event;
                            },
                            activator: "parent",
                            contentClass: "v-autocomplete__content",
                            disabled: menuDisabled.value,
                            eager: props.eager,
                            maxHeight: 310,
                            openOnClick: false,
                            closeOnContentClick: false,
                            transition: props.transition,
                            onAfterEnter: onAfterEnter,
                            onAfterLeave: onAfterLeave
                        }, props.menuProps), {
                            "default": function() {
                                var _props_itemColor;
                                return [
                                    hasList && (0, $bu8yf.createVNode)((0, $c46d6e9c2ddd50d5$export$3b010b0401837103), (0, $bu8yf.mergeProps)({
                                        ref: listRef,
                                        filterable: true,
                                        selected: selectedValues.value,
                                        selectStrategy: props.multiple ? 'independent' : 'single-independent',
                                        onMousedown: function(e) {
                                            return e.preventDefault();
                                        },
                                        onKeydown: onListKeydown,
                                        onFocusin: onFocusin,
                                        onFocusout: onFocusout,
                                        tabindex: "-1",
                                        "aria-live": "polite",
                                        color: (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        "default": function() {
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), {
                                                    key: "no-data",
                                                    title: t(props.noDataText)
                                                }, null)),
                                                (0, $bu8yf.createVNode)((0, $af9026073940257e$export$bdb136bf2d9028a4), {
                                                    ref: vVirtualScrollRef,
                                                    renderless: true,
                                                    items: displayItems.value,
                                                    itemKey: "value"
                                                }, {
                                                    "default": function(_ref3) {
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        var item = _ref3.item, index = _ref3.index, itemRef = _ref3.itemRef;
                                                        var itemProps = (0, $bu8yf.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            active: highlightFirst.value && index === 0 ? true : undefined,
                                                            onClick: function() {
                                                                return select(item, null);
                                                            }
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "divider-".concat(index)
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $bu8yf.createVNode)((0, $c18be527f2406595$export$70c4aba7bf48e22a), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "subheader-".concat(index)
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), (0, $bu8yf.mergeProps)(itemProps, {
                                                            role: "option"
                                                        }), {
                                                            prepend: function(_ref4) {
                                                                var isSelected = _ref4.isSelected;
                                                                return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                                                        key: item.value,
                                                                        modelValue: isSelected,
                                                                        ripple: false,
                                                                        tabindex: "-1"
                                                                    }, null) : undefined,
                                                                    item.props.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                                                        image: item.props.prependAvatar
                                                                    }, null),
                                                                    item.props.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                                        icon: item.props.prependIcon
                                                                    }, null)
                                                                ]);
                                                            },
                                                            title: function() {
                                                                var _getMatches;
                                                                return isPristine.value ? item.title : (0, $d8173a2b878f034f$export$71650bdcd27abbc4)('v-autocomplete', item.title, (_getMatches = getMatches(item)) === null || _getMatches === void 0 ? void 0 : _getMatches.title);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map(function(item, index) {
                            var onChipClose = function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            };
                            var slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown: function(e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown: function(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            var hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            var slotContent = hasSlot ? (0, $31779689cfd5da50$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $bu8yf.createElementVNode)("div", {
                                key: item.value,
                                "class": (0, $d8jBh.normalizeClass)([
                                    'v-autocomplete__selection',
                                    index === selectionIndex.value && [
                                        'v-autocomplete__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                style: (0, $d8jBh.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $bu8yf.createVNode)((0, $2f12dac67cff7cbd$export$1b5fab12cd17b4fb), (0, $bu8yf.mergeProps)({
                                    key: "chip",
                                    closable: props.closableChips,
                                    size: "small",
                                    text: item.title,
                                    disabled: item.props.disabled
                                }, slotProps), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                    key: "chip-defaults",
                                    defaults: {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    "default": function() {
                                        return [
                                            slotContent
                                        ];
                                    }
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-autocomplete__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $bu8yf.createElementVNode)("span", {
                                        "class": "v-autocomplete__selection-comma"
                                    }, [
                                        (0, $bu8yf.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    var _slots_appendinner;
                    var _slots_appendinner1, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_appendinner1 = slots['append-inner']) === null || _slots_appendinner1 === void 0 ? void 0 : (_slots_appendinner = _slots_appendinner1).call.apply(_slots_appendinner, [
                            slots
                        ].concat((0, $7WNf6._)(args))),
                        props.menuIcon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            "class": "v-autocomplete__menu-icon",
                            color: (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            icon: props.menuIcon,
                            onMousedown: onMousedownMenuIcon,
                            onClick: (0, $31779689cfd5da50$export$8793edee2d425525),
                            "aria-label": t(label.value),
                            title: t(label.value),
                            tabindex: "-1"
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $4979eba49805c59b$exports = {};

$parcel$export($4979eba49805c59b$exports, "VAvatar", function () { return $1991d2d9d165718c$export$dbee61bc703cd5ff; });



var $52328ff2d011bc50$exports = {};

$parcel$export($52328ff2d011bc50$exports, "VBadge", function () { return $2c4dad66630d30a6$export$756a89601026c160; });

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");













var $2c4dad66630d30a6$export$7cb2ab2d38a3d5cf = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    bordered: Boolean,
    color: String,
    content: [
        Number,
        String
    ],
    dot: Boolean,
    floating: Boolean,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    inline: Boolean,
    label: {
        type: String,
        "default": '$vuetify.badge'
    },
    max: [
        Number,
        String
    ],
    modelValue: {
        type: Boolean,
        "default": true
    },
    offsetX: [
        Number,
        String
    ],
    offsetY: [
        Number,
        String
    ],
    textColor: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)({
    location: 'top end'
}), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: 'scale-rotate-transition'
}), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)()), 'VBadge');
var $2c4dad66630d30a6$export$756a89601026c160 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBadge',
    inheritAttrs: false,
    props: $2c4dad66630d30a6$export$7cb2ab2d38a3d5cf(),
    setup: function(props, ctx) {
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.textColor;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var themeClasses = (0, $d8647489982f8a06$export$93d4e7f90805808f)().themeClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props, true, function(side) {
            var base = props.floating ? props.dot ? 2 : 4 : props.dot ? 8 : 12;
            var _props_offsetY, _props_offsetX;
            return base + ([
                'top',
                'bottom'
            ].includes(side) ? Number((_props_offsetY = props.offsetY) !== null && _props_offsetY !== void 0 ? _props_offsetY : 0) : [
                'left',
                'right'
            ].includes(side) ? Number((_props_offsetX = props.offsetX) !== null && _props_offsetX !== void 0 ? _props_offsetX : 0) : 0);
        }).locationStyles;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var value = Number(props.content);
            var content = !props.max || isNaN(value) ? props.content : value <= Number(props.max) ? value : "".concat(props.max, "+");
            var _pickWithRest = (0, $32TW8._)((0, $31779689cfd5da50$export$b25139123a794551)(ctx.attrs, [
                'aria-atomic',
                'aria-label',
                'aria-live',
                'role',
                'title'
            ]), 2), badgeAttrs = _pickWithRest[0], attrs = _pickWithRest[1];
            return (0, $bu8yf.createVNode)(props.tag, (0, $bu8yf.mergeProps)({
                "class": [
                    'v-badge',
                    {
                        'v-badge--bordered': props.bordered,
                        'v-badge--dot': props.dot,
                        'v-badge--floating': props.floating,
                        'v-badge--inline': props.inline
                    },
                    props["class"]
                ]
            }, attrs, {
                style: props.style
            }), {
                "default": function() {
                    var _ctx_slots_default, _ctx_slots;
                    return [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-badge__wrapper"
                        }, [
                            (_ctx_slots_default = (_ctx_slots = ctx.slots)["default"]) === null || _ctx_slots_default === void 0 ? void 0 : _ctx_slots_default.call(_ctx_slots),
                            (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                                transition: props.transition
                            }, {
                                "default": function() {
                                    var _ctx_slots_badge, _ctx_slots;
                                    return [
                                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("span", (0, $bu8yf.mergeProps)({
                                            "class": [
                                                'v-badge__badge',
                                                themeClasses.value,
                                                backgroundColorClasses.value,
                                                roundedClasses.value,
                                                textColorClasses.value
                                            ],
                                            style: [
                                                backgroundColorStyles.value,
                                                textColorStyles.value,
                                                dimensionStyles.value,
                                                props.inline ? {} : locationStyles.value
                                            ],
                                            "aria-atomic": "true",
                                            "aria-label": t(props.label, value),
                                            "aria-live": "polite",
                                            role: "status"
                                        }, badgeAttrs), [
                                            props.dot ? undefined : ctx.slots.badge ? (_ctx_slots_badge = (_ctx_slots = ctx.slots).badge) === null || _ctx_slots_badge === void 0 ? void 0 : _ctx_slots_badge.call(_ctx_slots) : props.icon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                icon: props.icon
                                            }, null) : content
                                        ]), [
                                            [
                                                (0, $kiZwI.vShow),
                                                props.modelValue
                                            ]
                                        ])
                                    ];
                                }
                            })
                        ])
                    ];
                }
            });
        });
        return {};
    }
});




var $897a5bcd8d4e6bbb$exports = {};

$parcel$export($897a5bcd8d4e6bbb$exports, "VBanner", function () { return $23f706902a8f95a1$export$c2d33ab72aac6785; });
$parcel$export($897a5bcd8d4e6bbb$exports, "VBannerActions", function () { return $b590457128abba0e$export$e69c7c0ca29b4fe6; });
$parcel$export($897a5bcd8d4e6bbb$exports, "VBannerText", function () { return $7f5d522ed3fc2a04$export$158eb3bfc74b118; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $b590457128abba0e$export$189027806d15462b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    density: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VBannerActions');
var $b590457128abba0e$export$e69c7c0ca29b4fe6 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBannerActions',
    props: $b590457128abba0e$export$189027806d15462b(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: props.color,
                density: props.density,
                slim: true,
                variant: 'text'
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-banner-actions',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});


// Utilities

var $7f5d522ed3fc2a04$export$158eb3bfc74b118 = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-banner-text');



















var $23f706902a8f95a1$export$292ce6c93f0af4a8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    avatar: String,
    bgColor: String,
    color: String,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    lines: String,
    stacked: Boolean,
    sticky: Boolean,
    text: String
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $a7414385605a88b0$export$d0badecb383b472a)({
    mobile: null
}), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VBanner');
var $23f706902a8f95a1$export$c2d33ab72aac6785 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBanner',
    props: $23f706902a8f95a1$export$292ce6c93f0af4a8(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var color = (0, $hXmfK.toRef)(function() {
            return props.color;
        });
        var density = (0, $hXmfK.toRef)(function() {
            return props.density;
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBannerActions: {
                color: color,
                density: density
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasText = !!(props.text || slots.text);
            var hasPrependMedia = !!(props.avatar || props.icon);
            var hasPrepend = !!(hasPrependMedia || slots.prepend);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-banner',
                    (0, $cqEAj._)({
                        'v-banner--stacked': props.stacked || mobile.value,
                        'v-banner--sticky': props.sticky
                    }, "v-banner--".concat(props.lines, "-line"), !!props.lines),
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    displayClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                role: "banner"
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                            key: "prepend",
                            "class": "v-banner__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                key: "prepend-avatar",
                                color: color.value,
                                density: density.value,
                                icon: props.icon,
                                image: props.avatar
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !hasPrependMedia,
                                defaults: {
                                    VAvatar: {
                                        color: color.value,
                                        density: density.value,
                                        icon: props.icon,
                                        image: props.avatar
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-banner__content"
                        }, [
                            hasText && (0, $bu8yf.createVNode)((0, $7f5d522ed3fc2a04$export$158eb3bfc74b118), {
                                key: "text"
                            }, {
                                "default": function() {
                                    var _slots_text;
                                    var _slots_text1;
                                    return [
                                        (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                                    ];
                                }
                            }),
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $bu8yf.createVNode)((0, $b590457128abba0e$export$e69c7c0ca29b4fe6), {
                            key: "actions"
                        }, slots.actions)
                    ];
                }
            });
        });
    }
});






var $65d444ec53767f82$exports = {};

$parcel$export($65d444ec53767f82$exports, "VBottomNavigation", function () { return $5a07d0cf326dcfe5$export$a78f8fd6d8f91925; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
















var $5a07d0cf326dcfe5$export$e625b1378c94739b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    baseColor: String,
    bgColor: String,
    color: String,
    grow: Boolean,
    mode: {
        type: String,
        validator: function(v) {
            return !v || [
                'horizontal',
                'shift'
            ].includes(v);
        }
    },
    height: {
        type: [
            Number,
            String
        ],
        "default": 56
    },
    active: {
        type: Boolean,
        "default": true
    }
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $39e98ff3447d557e$export$d42abac634ace931)({
    name: 'bottom-navigation'
}), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'header'
}), (0, $073309bf395585eb$export$fa4c05b3520340e6)({
    selectedClass: 'v-btn--selected'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VBottomNavigation');
var $5a07d0cf326dcfe5$export$a78f8fd6d8f91925 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBottomNavigation',
    props: $5a07d0cf326dcfe5$export$e625b1378c94739b(),
    emits: {
        'update:active': function(value) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$93d4e7f90805808f)().themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var ssrBootStyles = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().ssrBootStyles;
        var height = (0, $hXmfK.computed)(function() {
            return Number(props.height) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0);
        });
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'active', props.active);
        var layoutItemStyles = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $hXmfK.computed)(function() {
                return parseInt(props.order, 10);
            }),
            position: (0, $hXmfK.toRef)(function() {
                return 'bottom';
            }),
            layoutSize: (0, $hXmfK.toRef)(function() {
                return isActive.value ? height.value : 0;
            }),
            elementSize: height,
            active: isActive,
            absolute: (0, $hXmfK.toRef)(function() {
                return props.absolute;
            })
        }).layoutItemStyles;
        (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, (0, $03c8359f84f50d85$export$7ccf67e9366faa19));
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                baseColor: (0, $hXmfK.toRef)(function() {
                    return props.baseColor;
                }),
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                stacked: (0, $hXmfK.toRef)(function() {
                    return props.mode !== 'horizontal';
                }),
                variant: 'text'
            }
        }, {
            scoped: true
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-bottom-navigation',
                    {
                        'v-bottom-navigation--active': isActive.value,
                        'v-bottom-navigation--grow': props.grow,
                        'v-bottom-navigation--shift': props.mode === 'shift'
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    {
                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(height.value)
                    },
                    ssrBootStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-bottom-navigation__content"
                        }, [
                            slots["default"]()
                        ])
                    ];
                }
            });
        });
        return {};
    }
});




var $24af973892f628d7$exports = {};

$parcel$export($24af973892f628d7$exports, "VBottomSheet", function () { return $087219d35a0acf74$export$ffa2be562e251695; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");









var $e41bcf065f624dd0$export$1dd88499e1cfbb15 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    fullscreen: Boolean,
    retainFocus: {
        type: Boolean,
        "default": true
    },
    scrollable: Boolean
}, (0, $7f198793a6132466$export$357b25d59a7fb3fa)({
    origin: 'center center',
    scrollStrategy: 'block',
    transition: {
        component: (0, $b2974c952e31c38b$export$9778a08df954f36c)
    },
    zIndex: 2400
})), 'VDialog');
var $e41bcf065f624dd0$export$d399a452706dd20b = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDialog',
    props: $e41bcf065f624dd0$export$1dd88499e1cfbb15(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        afterEnter: function() {
            return true;
        },
        afterLeave: function() {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        var overlay = (0, $hXmfK.ref)();
        function onFocusin(e) {
            var _overlay_value, // We're the topmost dialog
            _overlay_value1;
            var before = e.relatedTarget;
            var after = e.target;
            if (before !== after && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && ((_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : _overlay_value1.globalTop) && // It isn't the document or the dialog body
            ![
                document,
                overlay.value.contentEl
            ].includes(after) && // It isn't inside the dialog body
            !overlay.value.contentEl.contains(after)) {
                var focusable = (0, $31779689cfd5da50$export$aea49dace3f6ca76)(overlay.value.contentEl);
                if (!focusable.length) return;
                var firstElement = focusable[0];
                var lastElement = focusable[focusable.length - 1];
                if (before === firstElement) lastElement.focus();
                else firstElement.focus();
            }
        }
        (0, $bu8yf.onBeforeUnmount)(function() {
            document.removeEventListener('focusin', onFocusin);
        });
        if (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) (0, $hXmfK.watch)(function() {
            return isActive.value && props.retainFocus;
        }, function(val) {
            val ? document.addEventListener('focusin', onFocusin) : document.removeEventListener('focusin', onFocusin);
        }, {
            immediate: true
        });
        function onAfterEnter() {
            var _overlay_value;
            emit('afterEnter');
            if ((props.scrim || props.retainFocus) && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && !overlay.value.contentEl.contains(document.activeElement)) overlay.value.contentEl.focus({
                preventScroll: true
            });
        }
        function onAfterLeave() {
            emit('afterLeave');
        }
        (0, $hXmfK.watch)(isActive, function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var _overlay_value_activatorEl;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!val) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $bu8yf.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            (_overlay_value_activatorEl = overlay.value.activatorEl) === null || _overlay_value_activatorEl === void 0 ? void 0 : _overlay_value_activatorEl.focus({
                                preventScroll: true
                            });
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var overlayProps = (0, $7f198793a6132466$export$32caf7e8170352aa).filterProps(props);
            var activatorProps = (0, $bu8yf.mergeProps)({
                'aria-haspopup': 'dialog'
            }, props.activatorProps);
            var contentProps = (0, $bu8yf.mergeProps)({
                tabindex: -1
            }, props.contentProps);
            return (0, $bu8yf.createVNode)((0, $7f198793a6132466$export$32caf7e8170352aa), (0, $bu8yf.mergeProps)({
                ref: overlay,
                "class": [
                    'v-dialog',
                    {
                        'v-dialog--fullscreen': props.fullscreen,
                        'v-dialog--scrollable': props.scrollable
                    },
                    props["class"]
                ],
                style: props.style
            }, overlayProps, {
                modelValue: isActive.value,
                "onUpdate:modelValue": function($event) {
                    return isActive.value = $event;
                },
                "aria-modal": "true",
                activatorProps: activatorProps,
                contentProps: contentProps,
                height: !props.fullscreen ? props.height : undefined,
                width: !props.fullscreen ? props.width : undefined,
                maxHeight: !props.fullscreen ? props.maxHeight : undefined,
                maxWidth: !props.fullscreen ? props.maxWidth : undefined,
                role: "dialog",
                onAfterEnter: onAfterEnter,
                onAfterLeave: onAfterLeave
            }, scopeId), {
                activator: slots.activator,
                "default": function _default() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        root: "VDialog"
                    }, {
                        "default": function() {
                            var _slots_default;
                            var _slots_default1;
                            return [
                                (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : (_slots_default = _slots_default1).call.apply(_slots_default, [
                                    slots
                                ].concat((0, $7WNf6._)(args)))
                            ];
                        }
                    });
                }
            });
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $087219d35a0acf74$export$157847aac9a791f2 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    inset: Boolean
}, (0, $e41bcf065f624dd0$export$1dd88499e1cfbb15)({
    transition: 'bottom-sheet-transition'
})), 'VBottomSheet');
var $087219d35a0acf74$export$ffa2be562e251695 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBottomSheet',
    props: $087219d35a0acf74$export$157847aac9a791f2(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var dialogProps = (0, $e41bcf065f624dd0$export$d399a452706dd20b).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $e41bcf065f624dd0$export$d399a452706dd20b), (0, $bu8yf.mergeProps)(dialogProps, {
                contentClass: [
                    'v-bottom-sheet__content',
                    props.contentClass
                ],
                modelValue: isActive.value,
                "onUpdate:modelValue": function($event) {
                    return isActive.value = $event;
                },
                "class": [
                    'v-bottom-sheet',
                    {
                        'v-bottom-sheet--inset': props.inset
                    },
                    props["class"]
                ],
                style: props.style
            }), slots);
        });
        return {};
    }
});




var $bf238f83c5b6cf03$exports = {};

$parcel$export($bf238f83c5b6cf03$exports, "VBreadcrumbs", function () { return $05cf2d9f4d22f0b9$export$4adad37ff360fc23; });
$parcel$export($bf238f83c5b6cf03$exports, "VBreadcrumbsItem", function () { return $d5b861b85d1c3740$export$df843ef038f9da80; });
$parcel$export($bf238f83c5b6cf03$exports, "VBreadcrumbsDivider", function () { return $661a407b123e816b$export$bfb57897322e706b; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $661a407b123e816b$export$b093c80cf91e2910 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    divider: [
        Number,
        String
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VBreadcrumbsDivider');
var $661a407b123e816b$export$bfb57897322e706b = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsDivider',
    props: $661a407b123e816b$export$b093c80cf91e2910(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            var _slots_default1;
            return (0, $bu8yf.createElementVNode)("li", {
                "aria-hidden": "true",
                "class": (0, $d8jBh.normalizeClass)([
                    'v-breadcrumbs-divider',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_slots_default1 = slots === null || slots === void 0 ? void 0 : (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.divider
            ]);
        });
        return {};
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");





var $d5b861b85d1c3740$export$339a9a46f2eb74a8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    active: Boolean,
    activeClass: String,
    activeColor: String,
    color: String,
    disabled: Boolean,
    title: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $f0fd6b0b61967e91$export$78d5db5e8f9b041d)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'li'
})), 'VBreadcrumbsItem');
var $d5b861b85d1c3740$export$df843ef038f9da80 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsItem',
    props: $d5b861b85d1c3740$export$339a9a46f2eb74a8(),
    setup: function(props, _ref) {
        var slots = _ref.slots, attrs = _ref.attrs;
        var link = (0, $f0fd6b0b61967e91$export$dcf14c9974fe2767)(props, attrs);
        var isActive = (0, $hXmfK.computed)(function() {
            var _link_isActive;
            return props.active || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value);
        });
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return isActive.value ? props.activeColor : props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-breadcrumbs-item',
                    (0, $cqEAj._)({
                        'v-breadcrumbs-item--active': isActive.value,
                        'v-breadcrumbs-item--disabled': props.disabled
                    }, "".concat(props.activeClass), isActive.value && props.activeClass),
                    textColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    textColorStyles.value,
                    props.style
                ]),
                "aria-current": isActive.value ? 'page' : undefined
            }, {
                "default": function() {
                    var _slots_default, _slots_default1;
                    var _slots_default2, _slots_default3;
                    return [
                        !link.isLink.value ? (_slots_default2 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default2 !== void 0 ? _slots_default2 : props.title : (0, $bu8yf.createElementVNode)("a", (0, $bu8yf.mergeProps)({
                            "class": "v-breadcrumbs-item--link",
                            onClick: link.navigate
                        }, link.linkProps), [
                            (_slots_default3 = (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)) !== null && _slots_default3 !== void 0 ? _slots_default3 : props.title
                        ])
                    ];
                }
            });
        });
        return {};
    }
});












var $05cf2d9f4d22f0b9$export$4c1cf1d12d4da1ac = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    activeClass: String,
    activeColor: String,
    bgColor: String,
    color: String,
    disabled: Boolean,
    divider: {
        type: String,
        "default": '/'
    },
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'ul'
})), 'VBreadcrumbs');
var $05cf2d9f4d22f0b9$export$4adad37ff360fc23 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbs',
    props: $05cf2d9f4d22f0b9$export$4c1cf1d12d4da1ac(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBreadcrumbsDivider: {
                divider: (0, $hXmfK.toRef)(function() {
                    return props.divider;
                })
            },
            VBreadcrumbsItem: {
                activeClass: (0, $hXmfK.toRef)(function() {
                    return props.activeClass;
                }),
                activeColor: (0, $hXmfK.toRef)(function() {
                    return props.activeColor;
                }),
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                disabled: (0, $hXmfK.toRef)(function() {
                    return props.disabled;
                })
            }
        });
        var items = (0, $hXmfK.computed)(function() {
            return props.items.map(function(item) {
                return typeof item === 'string' ? {
                    item: {
                        title: item
                    },
                    raw: item
                } : {
                    item: item,
                    raw: item
                };
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasPrepend = !!(slots.prepend || props.icon);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-breadcrumbs',
                    backgroundColorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        hasPrepend && (0, $bu8yf.createElementVNode)("li", {
                            key: "prepend",
                            "class": "v-breadcrumbs__prepend"
                        }, [
                            !slots.prepend ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                key: "prepend-icon",
                                start: true,
                                icon: props.icon
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "prepend-defaults",
                                disabled: !props.icon,
                                defaults: {
                                    VIcon: {
                                        icon: props.icon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        items.value.map(function(_ref2, index, array) {
                            var _slots_item;
                            var item = _ref2.item, raw = _ref2.raw;
                            var _slots_item1;
                            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                    item: item,
                                    index: index
                                })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $d5b861b85d1c3740$export$df843ef038f9da80), (0, $bu8yf.mergeProps)({
                                    key: index,
                                    disabled: index >= array.length - 1
                                }, typeof item === 'string' ? {
                                    title: item
                                } : item), {
                                    "default": slots.title ? function() {
                                        var _slots_title;
                                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, {
                                            item: item,
                                            index: index
                                        });
                                    } : undefined
                                }),
                                index < array.length - 1 && (0, $bu8yf.createVNode)((0, $661a407b123e816b$export$bfb57897322e706b), null, {
                                    "default": slots.divider ? function() {
                                        var _slots_divider;
                                        return (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                            item: raw,
                                            index: index
                                        });
                                    } : undefined
                                })
                            ]);
                        }),
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        });
        return {};
    }
});






var $aab197eaf2a6c67b$exports = {};

$parcel$export($aab197eaf2a6c67b$exports, "VBtn", function () { return $9603829334ed7471$export$657f28cf887b91a6; });



var $5539fa895c9b1aa3$exports = {};

$parcel$export($5539fa895c9b1aa3$exports, "VBtnGroup", function () { return $1ab0621309dbac8d$export$9901e555ac223efb; });



var $e52980d23d8008dd$exports = {};

$parcel$export($e52980d23d8008dd$exports, "VBtnToggle", function () { return $03c8359f84f50d85$export$2097e77d7f4058c7; });



var $e9af1a32ff162c08$exports = {};

$parcel$export($e9af1a32ff162c08$exports, "VCard", function () { return $110143facb36696d$export$f0844a5a421f3a0e; });
$parcel$export($e9af1a32ff162c08$exports, "VCardActions", function () { return $4cba90298c0aeb02$export$e69b3a0bf7ef1418; });
$parcel$export($e9af1a32ff162c08$exports, "VCardItem", function () { return $99622177538f3139$export$dd7f0ecce28a1ff6; });
$parcel$export($e9af1a32ff162c08$exports, "VCardSubtitle", function () { return $6ba5765c6a674628$export$acbd6c585934256e; });
$parcel$export($e9af1a32ff162c08$exports, "VCardText", function () { return $296aa274d25f53c2$export$e431c8b8253b7d00; });
$parcel$export($e9af1a32ff162c08$exports, "VCardTitle", function () { return $025c64581754c6c4$export$41a39a17ca7a66db; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $4cba90298c0aeb02$export$e69b3a0bf7ef1418 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCardActions',
    props: (0, $2b50544a76f0a26e$export$d271552babda0448)(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                slim: true,
                variant: 'text'
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-card-actions',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $6ba5765c6a674628$export$3b690aa7c7da0b30 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    opacity: [
        Number,
        String
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VCardSubtitle');
var $6ba5765c6a674628$export$acbd6c585934256e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCardSubtitle',
    props: $6ba5765c6a674628$export$3b690aa7c7da0b30(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-card-subtitle',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-card-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});


// Utilities

var $025c64581754c6c4$export$41a39a17ca7a66db = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-card-title');









var $99622177538f3139$export$778ce5b6f64b1823 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    appendAvatar: String,
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    prependAvatar: String,
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)()), 'VCardItem');
var $99622177538f3139$export$dd7f0ecce28a1ff6 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCardItem',
    props: $99622177538f3139$export$778ce5b6f64b1823(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            var hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            var hasPrepend = !!(hasPrependMedia || slots.prepend);
            var hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            var hasAppend = !!(hasAppendMedia || slots.append);
            var hasTitle = !!(props.title != null || slots.title);
            var hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-card-item',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                hasPrepend && (0, $bu8yf.createElementVNode)("div", {
                    key: "prepend",
                    "class": "v-card-item__prepend"
                }, [
                    !slots.prepend ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        props.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                            key: "prepend-avatar",
                            density: props.density,
                            image: props.prependAvatar
                        }, null),
                        props.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "prepend-icon",
                            density: props.density,
                            icon: props.prependIcon
                        }, null)
                    ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        key: "prepend-defaults",
                        disabled: !hasPrependMedia,
                        defaults: {
                            VAvatar: {
                                density: props.density,
                                image: props.prependAvatar
                            },
                            VIcon: {
                                density: props.density,
                                icon: props.prependIcon
                            }
                        }
                    }, slots.prepend)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-card-item__content"
                }, [
                    hasTitle && (0, $bu8yf.createVNode)((0, $025c64581754c6c4$export$41a39a17ca7a66db), {
                        key: "title"
                    }, {
                        "default": function() {
                            var _slots_title;
                            var _slots_title1;
                            return [
                                (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $d8jBh.toDisplayString)(props.title)
                            ];
                        }
                    }),
                    hasSubtitle && (0, $bu8yf.createVNode)((0, $6ba5765c6a674628$export$acbd6c585934256e), {
                        key: "subtitle"
                    }, {
                        "default": function() {
                            var _slots_subtitle;
                            var _slots_subtitle1;
                            return [
                                (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots)) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : (0, $d8jBh.toDisplayString)(props.subtitle)
                            ];
                        }
                    }),
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ]),
                hasAppend && (0, $bu8yf.createElementVNode)("div", {
                    key: "append",
                    "class": "v-card-item__append"
                }, [
                    !slots.append ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        props.appendIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "append-icon",
                            density: props.density,
                            icon: props.appendIcon
                        }, null),
                        props.appendAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                            key: "append-avatar",
                            density: props.density,
                            image: props.appendAvatar
                        }, null)
                    ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        key: "append-defaults",
                        disabled: !hasAppendMedia,
                        defaults: {
                            VAvatar: {
                                density: props.density,
                                image: props.appendAvatar
                            },
                            VIcon: {
                                density: props.density,
                                icon: props.appendIcon
                            }
                        }
                    }, slots.append)
                ])
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $296aa274d25f53c2$export$8962dbd2532ec6c4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    opacity: [
        Number,
        String
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VCardText');
var $296aa274d25f53c2$export$e431c8b8253b7d00 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCardText',
    props: $296aa274d25f53c2$export$8962dbd2532ec6c4(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-card-text',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-card-text-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});




















var $110143facb36696d$export$13f829be95cb0bf2 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    appendAvatar: String,
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    disabled: Boolean,
    flat: Boolean,
    hover: Boolean,
    image: String,
    link: {
        type: Boolean,
        "default": undefined
    },
    prependAvatar: String,
    prependIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        "default": undefined
    }
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $de59c43ac78c3e7a$export$149f04e0cba4dbc1)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $f0fd6b0b61967e91$export$78d5db5e8f9b041d)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'elevated'
})), 'VCard');
var $110143facb36696d$export$f0844a5a421f3a0e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCard',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $110143facb36696d$export$13f829be95cb0bf2(),
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(props), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var loaderClasses = (0, $de59c43ac78c3e7a$export$14095de704efe3f9)(props).loaderClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var link = (0, $f0fd6b0b61967e91$export$dcf14c9974fe2767)(props, attrs);
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var isLink = props.link !== false && link.isLink.value;
            var isClickable = !props.disabled && props.link !== false && (props.link || link.isClickable.value);
            var Tag = isLink ? 'a' : props.tag;
            var hasTitle = !!(slots.title || props.title != null);
            var hasSubtitle = !!(slots.subtitle || props.subtitle != null);
            var hasHeader = hasTitle || hasSubtitle;
            var hasAppend = !!(slots.append || props.appendAvatar || props.appendIcon);
            var hasPrepend = !!(slots.prepend || props.prependAvatar || props.prependIcon);
            var hasImage = !!(slots.image || props.image);
            var hasCardItem = hasHeader || hasPrepend || hasAppend;
            var hasText = !!(slots.text || props.text != null);
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(Tag, (0, $bu8yf.mergeProps)({
                "class": [
                    'v-card',
                    {
                        'v-card--disabled': props.disabled,
                        'v-card--flat': props.flat,
                        'v-card--hover': props.hover && !(props.disabled || props.flat),
                        'v-card--link': isClickable
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props["class"]
                ],
                style: [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ],
                onClick: isClickable && link.navigate,
                tabindex: props.disabled ? -1 : undefined
            }, link.linkProps), {
                "default": function() {
                    var _slots_default;
                    return [
                        hasImage && (0, $bu8yf.createElementVNode)("div", {
                            key: "image",
                            "class": "v-card__image"
                        }, [
                            !slots.image ? (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                                key: "image-img",
                                cover: true,
                                src: props.image
                            }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                key: "image-defaults",
                                disabled: !props.image,
                                defaults: {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $bu8yf.createVNode)((0, $de59c43ac78c3e7a$export$9a5d46a3538da529), {
                            name: "v-card",
                            active: !!props.loading,
                            color: typeof props.loading === 'boolean' ? undefined : props.loading
                        }, {
                            "default": slots.loader
                        }),
                        hasCardItem && (0, $bu8yf.createVNode)((0, $99622177538f3139$export$dd7f0ecce28a1ff6), {
                            key: "item",
                            prependAvatar: props.prependAvatar,
                            prependIcon: props.prependIcon,
                            title: props.title,
                            subtitle: props.subtitle,
                            appendAvatar: props.appendAvatar,
                            appendIcon: props.appendIcon
                        }, {
                            "default": slots.item,
                            prepend: slots.prepend,
                            title: slots.title,
                            subtitle: slots.subtitle,
                            append: slots.append
                        }),
                        hasText && (0, $bu8yf.createVNode)((0, $296aa274d25f53c2$export$e431c8b8253b7d00), {
                            key: "text"
                        }, {
                            "default": function() {
                                var _slots_text;
                                var _slots_text1;
                                return [
                                    (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                                ];
                            }
                        }),
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                        slots.actions && (0, $bu8yf.createVNode)((0, $4cba90298c0aeb02$export$e69b3a0bf7ef1418), null, {
                            "default": slots.actions
                        }),
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(isClickable, 'v-card')
                    ];
                }
            }), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    isClickable && props.ripple
                ]
            ]);
        });
        return {};
    }
});









var $74bbacfd6d54dd3f$exports = {};

$parcel$export($74bbacfd6d54dd3f$exports, "VCarousel", function () { return $d602b2eb912d500a$export$2ec2bd507cbf58ac; });
$parcel$export($74bbacfd6d54dd3f$exports, "VCarouselItem", function () { return $570bcd7cac14f84f$export$273c2e14a4f3f313; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");





var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







// Utilities

var $iT0je = parcelRequire("iT0je");

var $8a7faef3eb477187$var$handleGesture = function(wrapper) {
    var touchstartX = wrapper.touchstartX, touchendX = wrapper.touchendX, touchstartY = wrapper.touchstartY, touchendY = wrapper.touchendY;
    var dirRatio = 0.5;
    var minDistance = 16;
    wrapper.offsetX = touchendX - touchstartX;
    wrapper.offsetY = touchendY - touchstartY;
    if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
        wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
        wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
    }
    if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
        wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
        wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
    }
};
function $8a7faef3eb477187$var$touchstart(event, wrapper) {
    var _wrapper_start;
    var touch = event.changedTouches[0];
    wrapper.touchstartX = touch.clientX;
    wrapper.touchstartY = touch.clientY;
    (_wrapper_start = wrapper.start) === null || _wrapper_start === void 0 ? void 0 : _wrapper_start.call(wrapper, (0, $iT0je._)({
        originalEvent: event
    }, wrapper));
}
function $8a7faef3eb477187$var$touchend(event, wrapper) {
    var _wrapper_end;
    var touch = event.changedTouches[0];
    wrapper.touchendX = touch.clientX;
    wrapper.touchendY = touch.clientY;
    (_wrapper_end = wrapper.end) === null || _wrapper_end === void 0 ? void 0 : _wrapper_end.call(wrapper, (0, $iT0je._)({
        originalEvent: event
    }, wrapper));
    $8a7faef3eb477187$var$handleGesture(wrapper);
}
function $8a7faef3eb477187$var$touchmove(event, wrapper) {
    var _wrapper_move;
    var touch = event.changedTouches[0];
    wrapper.touchmoveX = touch.clientX;
    wrapper.touchmoveY = touch.clientY;
    (_wrapper_move = wrapper.move) === null || _wrapper_move === void 0 ? void 0 : _wrapper_move.call(wrapper, (0, $iT0je._)({
        originalEvent: event
    }, wrapper));
}
function $8a7faef3eb477187$var$createHandlers() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrapper = {
        touchstartX: 0,
        touchstartY: 0,
        touchendX: 0,
        touchendY: 0,
        touchmoveX: 0,
        touchmoveY: 0,
        offsetX: 0,
        offsetY: 0,
        left: value.left,
        right: value.right,
        up: value.up,
        down: value.down,
        start: value.start,
        move: value.move,
        end: value.end
    };
    return {
        touchstart: function(e) {
            return $8a7faef3eb477187$var$touchstart(e, wrapper);
        },
        touchend: function(e) {
            return $8a7faef3eb477187$var$touchend(e, wrapper);
        },
        touchmove: function(e) {
            return $8a7faef3eb477187$var$touchmove(e, wrapper);
        }
    };
}
function $8a7faef3eb477187$var$mounted(el, binding) {
    var _binding_instance;
    var value = binding.value;
    var target = (value === null || value === void 0 ? void 0 : value.parent) ? el.parentElement : el;
    var _value_options;
    var options = (_value_options = value === null || value === void 0 ? void 0 : value.options) !== null && _value_options !== void 0 ? _value_options : {
        passive: true
    };
    var uid = (_binding_instance = binding.instance) === null || _binding_instance === void 0 ? void 0 : _binding_instance.$.uid; // TODO: use custom uid generator
    if (!target || !uid) return;
    var handlers = $8a7faef3eb477187$var$createHandlers(binding.value);
    var _target__touchHandlers;
    target._touchHandlers = (_target__touchHandlers = target._touchHandlers) !== null && _target__touchHandlers !== void 0 ? _target__touchHandlers : Object.create(null);
    target._touchHandlers[uid] = handlers;
    (0, $31779689cfd5da50$export$ed97f33186d4b816)(handlers).forEach(function(eventName) {
        target.addEventListener(eventName, handlers[eventName], options);
    });
}
function $8a7faef3eb477187$var$unmounted(el, binding) {
    var _binding_value, _binding_instance;
    var target = ((_binding_value = binding.value) === null || _binding_value === void 0 ? void 0 : _binding_value.parent) ? el.parentElement : el;
    var uid = (_binding_instance = binding.instance) === null || _binding_instance === void 0 ? void 0 : _binding_instance.$.uid;
    if (!(target === null || target === void 0 ? void 0 : target._touchHandlers) || !uid) return;
    var handlers = target._touchHandlers[uid];
    (0, $31779689cfd5da50$export$ed97f33186d4b816)(handlers).forEach(function(eventName) {
        target.removeEventListener(eventName, handlers[eventName]);
    });
    delete target._touchHandlers[uid];
}
var $8a7faef3eb477187$export$746b04bbf92762fd = {
    mounted: $8a7faef3eb477187$var$mounted,
    unmounted: $8a7faef3eb477187$var$unmounted
};
var $8a7faef3eb477187$export$2e2bcd8739ae039 = $8a7faef3eb477187$export$746b04bbf92762fd;



var $ca166420585d5fdc$export$148085e3462a5c9b = Symbol["for"]('vuetify:v-window');
var $ca166420585d5fdc$export$73a02c283e349d7d = Symbol["for"]('vuetify:v-window-group');
var $ca166420585d5fdc$export$25b8cee22976996f = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    continuous: Boolean,
    nextIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        "default": '$next'
    },
    prevIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        "default": '$prev'
    },
    reverse: Boolean,
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: function(v) {
            return typeof v === 'boolean' || v === 'hover';
        }
    },
    verticalArrows: [
        Boolean,
        String
    ],
    touch: {
        type: [
            Object,
            Boolean
        ],
        "default": undefined
    },
    direction: {
        type: String,
        "default": 'horizontal'
    },
    modelValue: null,
    disabled: Boolean,
    selectedClass: {
        type: String,
        "default": 'v-window-item--active'
    },
    // TODO: mandatory should probably not be exposed but do this for now
    mandatory: {
        type: [
            Boolean,
            String
        ],
        "default": 'force'
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VWindow');
var $ca166420585d5fdc$export$7e91eb8d1b90c043 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VWindow',
    directives: {
        vTouch: (0, $8a7faef3eb477187$export$2e2bcd8739ae039)
    },
    props: $ca166420585d5fdc$export$25b8cee22976996f(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var group = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, $ca166420585d5fdc$export$73a02c283e349d7d);
        var rootRef = (0, $hXmfK.ref)();
        var isRtlReverse = (0, $hXmfK.computed)(function() {
            return isRtl.value ? !props.reverse : props.reverse;
        });
        var isReversed = (0, $hXmfK.shallowRef)(false);
        var transition = (0, $hXmfK.computed)(function() {
            var axis = props.direction === 'vertical' ? 'y' : 'x';
            var reverse = isRtlReverse.value ? !isReversed.value : isReversed.value;
            var direction = reverse ? '-reverse' : '';
            return "v-window-".concat(axis).concat(direction, "-transition");
        });
        var transitionCount = (0, $hXmfK.shallowRef)(0);
        var transitionHeight = (0, $hXmfK.ref)(undefined);
        var activeIndex = (0, $hXmfK.computed)(function() {
            return group.items.value.findIndex(function(item) {
                return group.selected.value.includes(item.id);
            });
        });
        (0, $hXmfK.watch)(activeIndex, function(newVal, oldVal) {
            var itemsLength = group.items.value.length;
            var lastIndex = itemsLength - 1;
            if (itemsLength <= 2) isReversed.value = newVal < oldVal;
            else if (newVal === lastIndex && oldVal === 0) isReversed.value = true;
            else if (newVal === 0 && oldVal === lastIndex) isReversed.value = false;
            else isReversed.value = newVal < oldVal;
        });
        (0, $bu8yf.provide)($ca166420585d5fdc$export$148085e3462a5c9b, {
            transition: transition,
            isReversed: isReversed,
            transitionCount: transitionCount,
            transitionHeight: transitionHeight,
            rootRef: rootRef
        });
        var canMoveBack = (0, $hXmfK.toRef)(function() {
            return props.continuous || activeIndex.value !== 0;
        });
        var canMoveForward = (0, $hXmfK.toRef)(function() {
            return props.continuous || activeIndex.value !== group.items.value.length - 1;
        });
        function prev() {
            canMoveBack.value && group.prev();
        }
        function next() {
            canMoveForward.value && group.next();
        }
        var arrows = (0, $hXmfK.computed)(function() {
            var arrows = [];
            var prevProps = {
                icon: isRtl.value ? props.nextIcon : props.prevIcon,
                "class": "v-window__".concat(isRtlReverse.value ? 'right' : 'left'),
                onClick: group.prev,
                'aria-label': t('$vuetify.carousel.prev')
            };
            arrows.push(canMoveBack.value ? slots.prev ? slots.prev({
                props: prevProps
            }) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), prevProps, null) : (0, $bu8yf.createElementVNode)("div", null, null));
            var nextProps = {
                icon: isRtl.value ? props.prevIcon : props.nextIcon,
                "class": "v-window__".concat(isRtlReverse.value ? 'left' : 'right'),
                onClick: group.next,
                'aria-label': t('$vuetify.carousel.next')
            };
            arrows.push(canMoveForward.value ? slots.next ? slots.next({
                props: nextProps
            }) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), nextProps, null) : (0, $bu8yf.createElementVNode)("div", null, null));
            return arrows;
        });
        var touchOptions = (0, $hXmfK.computed)(function() {
            if (props.touch === false) return props.touch;
            var options = {
                left: function() {
                    isRtlReverse.value ? prev() : next();
                },
                right: function() {
                    isRtlReverse.value ? next() : prev();
                },
                start: function(_ref2) {
                    var originalEvent = _ref2.originalEvent;
                    originalEvent.stopPropagation();
                }
            };
            return (0, $iT0je._)({}, options, props.touch === true ? {} : props.touch);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(props.tag, {
                ref: rootRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-window',
                    {
                        'v-window--show-arrows-on-hover': props.showArrows === 'hover',
                        'v-window--vertical-arrows': !!props.verticalArrows
                    },
                    themeClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_default, _slots_additional;
                    return [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-window__container",
                            style: {
                                height: transitionHeight.value
                            }
                        }, [
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                group: group
                            }),
                            props.showArrows !== false && (0, $bu8yf.createElementVNode)("div", {
                                "class": (0, $d8jBh.normalizeClass)([
                                    'v-window__controls',
                                    {
                                        'v-window__controls--left': props.verticalArrows === 'left' || props.verticalArrows === true
                                    },
                                    {
                                        'v-window__controls--right': props.verticalArrows === 'right'
                                    }
                                ])
                            }, [
                                arrows.value
                            ])
                        ]),
                        (_slots_additional = slots.additional) === null || _slots_additional === void 0 ? void 0 : _slots_additional.call(slots, {
                            group: group
                        })
                    ];
                }
            }), [
                [
                    (0, $8a7faef3eb477187$export$2e2bcd8739ae039),
                    touchOptions.value
                ]
            ]);
        });
        return {
            group: group
        };
    }
});






var $d602b2eb912d500a$export$6dfae5d31ad6b376 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    cycle: Boolean,
    delimiterIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$delimiter'
    },
    height: {
        type: [
            Number,
            String
        ],
        "default": 500
    },
    hideDelimiters: Boolean,
    hideDelimiterBackground: Boolean,
    interval: {
        type: [
            Number,
            String
        ],
        "default": 6000,
        validator: function(value) {
            return Number(value) > 0;
        }
    },
    progress: [
        Boolean,
        String
    ],
    verticalDelimiters: [
        Boolean,
        String
    ]
}, (0, $ca166420585d5fdc$export$25b8cee22976996f)({
    continuous: true,
    mandatory: 'force',
    showArrows: true
})), 'VCarousel');
var $d602b2eb912d500a$export$2ec2bd507cbf58ac = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCarousel',
    props: $d602b2eb912d500a$export$6dfae5d31ad6b376(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var windowRef = (0, $hXmfK.ref)();
        var slideTimeout = -1;
        (0, $hXmfK.watch)(model, restartTimeout);
        (0, $hXmfK.watch)(function() {
            return props.interval;
        }, restartTimeout);
        (0, $hXmfK.watch)(function() {
            return props.cycle;
        }, function(val) {
            if (val) restartTimeout();
            else window.clearTimeout(slideTimeout);
        });
        (0, $bu8yf.onMounted)(startTimeout);
        function startTimeout() {
            if (!props.cycle || !windowRef.value) return;
            slideTimeout = window.setTimeout(windowRef.value.group.next, Number(props.interval) > 0 ? Number(props.interval) : 6000);
        }
        function restartTimeout() {
            window.clearTimeout(slideTimeout);
            window.requestAnimationFrame(startTimeout);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var windowProps = (0, $ca166420585d5fdc$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $ca166420585d5fdc$export$7e91eb8d1b90c043), (0, $bu8yf.mergeProps)({
                ref: windowRef
            }, windowProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": [
                    'v-carousel',
                    {
                        'v-carousel--hide-delimiter-background': props.hideDelimiterBackground,
                        'v-carousel--vertical-delimiters': props.verticalDelimiters
                    },
                    props["class"]
                ],
                style: [
                    {
                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ]
            }), {
                "default": slots["default"],
                additional: function(_ref2) {
                    var group = _ref2.group;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        !props.hideDelimiters && (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-carousel__controls",
                            style: {
                                left: props.verticalDelimiters === 'left' && props.verticalDelimiters ? 0 : 'auto',
                                right: props.verticalDelimiters === 'right' ? 0 : 'auto'
                            }
                        }, [
                            group.items.value.length > 0 && (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                defaults: {
                                    VBtn: {
                                        color: props.color,
                                        icon: props.delimiterIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                },
                                scoped: true
                            }, {
                                "default": function() {
                                    return [
                                        group.items.value.map(function(item, index) {
                                            var _$props = {
                                                id: "carousel-item-".concat(item.id),
                                                'aria-label': t('$vuetify.carousel.ariaLabel.delimiter', index + 1, group.items.value.length),
                                                "class": [
                                                    'v-carousel__controls__item',
                                                    group.isSelected(item.id) && 'v-btn--active'
                                                ],
                                                onClick: function() {
                                                    return group.select(item.id, true);
                                                }
                                            };
                                            return slots.item ? slots.item({
                                                props: _$props,
                                                item: item
                                            }) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)(item, _$props), null);
                                        })
                                    ];
                                }
                            })
                        ]),
                        props.progress && (0, $bu8yf.createVNode)((0, $b435191c768336fc$export$86b13ad59f1a1627), {
                            absolute: true,
                            "class": "v-carousel__progress",
                            color: typeof props.progress === 'string' ? props.progress : undefined,
                            modelValue: (group.getItemIndex(model.value) + 1) / group.items.value.length * 100
                        }, null)
                    ]);
                },
                prev: slots.prev,
                next: slots.next
            });
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");








var $a77d8a325be2a9b0$export$7fb6acff7c00736c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    reverseTransition: {
        type: [
            Boolean,
            String
        ],
        "default": undefined
    },
    transition: {
        type: [
            Boolean,
            String
        ],
        "default": undefined
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $073309bf395585eb$export$e9e3b570044587e8)(), (0, $2a56e630d56c9097$export$3557c26df64490a4)()), 'VWindowItem');
var $a77d8a325be2a9b0$export$5dd5457a16e4a360 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VWindowItem',
    directives: {
        vTouch: (0, $8a7faef3eb477187$export$2e2bcd8739ae039)
    },
    props: $a77d8a325be2a9b0$export$7fb6acff7c00736c(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var window = (0, $bu8yf.inject)((0, $ca166420585d5fdc$export$148085e3462a5c9b));
        var groupItem = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $ca166420585d5fdc$export$73a02c283e349d7d));
        var isBooted = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().isBooted;
        if (!window || !groupItem) throw new Error('[Vuetify] VWindowItem must be used inside VWindow');
        var isTransitioning = (0, $hXmfK.shallowRef)(false);
        var hasTransition = (0, $hXmfK.computed)(function() {
            return isBooted.value && (window.isReversed.value ? props.reverseTransition !== false : props.transition !== false);
        });
        function onAfterTransition() {
            if (!isTransitioning.value || !window) return;
            // Finalize transition state.
            isTransitioning.value = false;
            if (window.transitionCount.value > 0) {
                window.transitionCount.value -= 1;
                // Remove container height if we are out of transition.
                if (window.transitionCount.value === 0) window.transitionHeight.value = undefined;
            }
        }
        function onBeforeTransition() {
            var _window_rootRef_value;
            if (isTransitioning.value || !window) return;
            // Initialize transition state here.
            isTransitioning.value = true;
            if (window.transitionCount.value === 0) // Set initial height for height transition.
            window.transitionHeight.value = (0, $31779689cfd5da50$export$286ad215293a0860)((_window_rootRef_value = window.rootRef.value) === null || _window_rootRef_value === void 0 ? void 0 : _window_rootRef_value.clientHeight);
            window.transitionCount.value += 1;
        }
        function onTransitionCancelled() {
            onAfterTransition(); // This should have the same path as normal transition end.
        }
        function onEnterTransition(el) {
            if (!isTransitioning.value) return;
            (0, $bu8yf.nextTick)(function() {
                // Do not set height if no transition or cancelled.
                if (!hasTransition.value || !isTransitioning.value || !window) return;
                // Set transition target height.
                window.transitionHeight.value = (0, $31779689cfd5da50$export$286ad215293a0860)(el.clientHeight);
            });
        }
        var transition = (0, $hXmfK.computed)(function() {
            var name = window.isReversed.value ? props.reverseTransition : props.transition;
            return !hasTransition.value ? false : {
                name: typeof name !== 'string' ? window.transition.value : name,
                onBeforeEnter: onBeforeTransition,
                onAfterEnter: onAfterTransition,
                onEnterCancelled: onTransitionCancelled,
                onBeforeLeave: onBeforeTransition,
                onAfterLeave: onAfterTransition,
                onLeaveCancelled: onTransitionCancelled,
                onEnter: onEnterTransition
            };
        });
        var hasContent = (0, $2a56e630d56c9097$export$965f98646215a1bd)(props, groupItem.isSelected).hasContent;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                transition: transition.value,
                disabled: !isBooted.value
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-window-item',
                                groupItem.selectedClass.value,
                                props["class"]
                            ]),
                            style: (0, $d8jBh.normalizeStyle)(props.style)
                        }, [
                            hasContent.value && ((_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots))
                        ]), [
                            [
                                (0, $kiZwI.vShow),
                                groupItem.isSelected.value
                            ]
                        ])
                    ];
                }
            });
        });
        return {
            groupItem: groupItem
        };
    }
});



var $570bcd7cac14f84f$export$c5a1ee6865246241 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $3fbd965354b26cae$export$aeeda8cb473ca4b4)(), (0, $a77d8a325be2a9b0$export$7fb6acff7c00736c)()), 'VCarouselItem');
var $570bcd7cac14f84f$export$273c2e14a4f3f313 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCarouselItem',
    inheritAttrs: false,
    props: $570bcd7cac14f84f$export$c5a1ee6865246241(),
    setup: function(props, _ref) {
        var slots = _ref.slots, attrs = _ref.attrs;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var imgProps = (0, $3fbd965354b26cae$export$126ec614c536f27c).filterProps(props);
            var windowItemProps = (0, $a77d8a325be2a9b0$export$5dd5457a16e4a360).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $a77d8a325be2a9b0$export$5dd5457a16e4a360), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-carousel-item',
                    props["class"]
                ]
            }, windowItemProps), {
                "default": function() {
                    return [
                        (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), (0, $bu8yf.mergeProps)(attrs, imgProps), slots)
                    ];
                }
            });
        });
    }
});




var $070025c56dc7037c$exports = {};

$parcel$export($070025c56dc7037c$exports, "VCheckbox", function () { return $42915af6ea7bf6af$export$12ceaa6dc3f28416; });
$parcel$export($070025c56dc7037c$exports, "VCheckboxBtn", function () { return $941cc86b1aae9176$export$2c5503cb3c38fdb6; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");







var $42915af6ea7bf6af$export$641547da5603a1c9 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $941cc86b1aae9176$export$b10b3450c190da23)(), [
    'inline'
])), 'VCheckbox');
var $42915af6ea7bf6af$export$12ceaa6dc3f28416 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCheckbox',
    inheritAttrs: false,
    props: $42915af6ea7bf6af$export$641547da5603a1c9(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:focused': function(focused) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var inputRef = (0, $hXmfK.ref)();
        var uid = (0, $bu8yf.useId)();
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], controlAttrs = _filterInputAttrs[1];
            var inputProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props);
            var checkboxProps = (0, $941cc86b1aae9176$export$2c5503cb3c38fdb6).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: inputRef,
                "class": [
                    'v-checkbox',
                    props["class"]
                ]
            }, rootAttrs, inputProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                id: props.id || "checkbox-".concat(uid),
                focused: isFocused.value,
                style: props.style
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref2) {
                    var id = _ref2.id, messagesId = _ref2.messagesId, isDisabled = _ref2.isDisabled, isReadonly = _ref2.isReadonly, isValid = _ref2.isValid;
                    return (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), (0, $bu8yf.mergeProps)(checkboxProps, {
                        id: id.value,
                        "aria-describedby": messagesId.value,
                        disabled: isDisabled.value,
                        readonly: isReadonly.value
                    }, controlAttrs, {
                        error: isValid.value === false,
                        modelValue: model.value,
                        "onUpdate:modelValue": function($event) {
                            return model.value = $event;
                        },
                        onFocus: focus,
                        onBlur: blur
                    }), slots);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, inputRef);
    }
});





var $880223cb91e739eb$exports = {};

$parcel$export($880223cb91e739eb$exports, "VChip", function () { return $2f12dac67cff7cbd$export$1b5fab12cd17b4fb; });



var $615c69d94f608698$exports = {};

$parcel$export($615c69d94f608698$exports, "VChipGroup", function () { return $5e689c9fe943db2c$export$d38779cb67beb087; });



var $68fe56eaeb99581b$exports = {};

$parcel$export($68fe56eaeb99581b$exports, "VCode", function () { return $68fe56eaeb99581b$export$34e1eb2aa2c1e4b2; });
// Styles


var $68fe56eaeb99581b$export$34e1eb2aa2c1e4b2 = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-code', 'code');


var $5846c2b0b14fb289$exports = {};

$parcel$export($5846c2b0b14fb289$exports, "VColorPicker", function () { return $f5b30e541bb65764$export$9359e1f82effabe6; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $f068250296a129b8$export$1d1a7b322d185d94 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: {
        type: Object
    },
    disabled: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        "default": 10
    },
    height: {
        type: [
            Number,
            String
        ],
        "default": 150
    },
    width: {
        type: [
            Number,
            String
        ],
        "default": 300
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VColorPickerCanvas');
var $f068250296a129b8$export$5142c1b9e4f0ab2e = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VColorPickerCanvas',
    props: $f068250296a129b8$export$1d1a7b322d185d94(),
    emits: {
        'update:color': function(color) {
            return true;
        },
        'update:position': function(hue) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        var isInteracting = (0, $hXmfK.shallowRef)(false);
        var canvasRef = (0, $hXmfK.ref)();
        var canvasWidth = (0, $hXmfK.shallowRef)(parseFloat(props.width));
        var canvasHeight = (0, $hXmfK.shallowRef)(parseFloat(props.height));
        var _dotPosition = (0, $hXmfK.ref)({
            x: 0,
            y: 0
        });
        var dotPosition = (0, $hXmfK.computed)({
            get: function() {
                return _dotPosition.value;
            },
            set: function(val) {
                var _props_color, _props_color1;
                if (!canvasRef.value) return;
                var x = val.x, y = val.y;
                _dotPosition.value = val;
                var _props_color_h, _props_color_a;
                emit('update:color', {
                    h: (_props_color_h = (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h) !== null && _props_color_h !== void 0 ? _props_color_h : 0,
                    s: (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(x, 0, canvasWidth.value) / canvasWidth.value,
                    v: 1 - (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(y, 0, canvasHeight.value) / canvasHeight.value,
                    a: (_props_color_a = (_props_color1 = props.color) === null || _props_color1 === void 0 ? void 0 : _props_color1.a) !== null && _props_color_a !== void 0 ? _props_color_a : 1
                });
            }
        });
        var dotStyles = (0, $hXmfK.computed)(function() {
            var _dotPosition_value = dotPosition.value, x = _dotPosition_value.x, y = _dotPosition_value.y;
            var radius = parseInt(props.dotSize, 10) / 2;
            return {
                width: (0, $31779689cfd5da50$export$286ad215293a0860)(props.dotSize),
                height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.dotSize),
                transform: "translate(".concat((0, $31779689cfd5da50$export$286ad215293a0860)(x - radius), ", ").concat((0, $31779689cfd5da50$export$286ad215293a0860)(y - radius), ")")
            };
        });
        var resizeRef = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(function(entries) {
            var _resizeRef_el;
            if (!((_resizeRef_el = resizeRef.el) === null || _resizeRef_el === void 0 ? void 0 : _resizeRef_el.offsetParent)) return;
            var _entries__contentRect = entries[0].contentRect, width = _entries__contentRect.width, height = _entries__contentRect.height;
            canvasWidth.value = width;
            canvasHeight.value = height;
        }).resizeRef;
        function updateDotPosition(x, y, rect) {
            var left = rect.left, top = rect.top, width = rect.width, height = rect.height;
            dotPosition.value = {
                x: (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(x - left, 0, width),
                y: (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(y - top, 0, height)
            };
        }
        function handleMouseDown(e) {
            if (e.type === 'mousedown') // Prevent text selection while dragging
            e.preventDefault();
            if (props.disabled) return;
            handleMouseMove(e);
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
            window.addEventListener('touchmove', handleMouseMove);
            window.addEventListener('touchend', handleMouseUp);
        }
        function handleMouseMove(e) {
            if (props.disabled || !canvasRef.value) return;
            isInteracting.value = true;
            var coords = (0, $31779689cfd5da50$export$36195c8aa1517e04)(e);
            updateDotPosition(coords.clientX, coords.clientY, canvasRef.value.getBoundingClientRect());
        }
        function handleMouseUp() {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', handleMouseMove);
            window.removeEventListener('touchend', handleMouseUp);
        }
        function updateCanvas() {
            var _props_color;
            if (!canvasRef.value) return;
            var canvas = canvasRef.value;
            var ctx = canvas.getContext('2d');
            if (!ctx) return;
            var saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
            saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white
            var _props_color_h;
            saturationGradient.addColorStop(1, "hsla(".concat((_props_color_h = (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h) !== null && _props_color_h !== void 0 ? _props_color_h : 0, ", 100%, 50%, 1)"));
            ctx.fillStyle = saturationGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            var valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            valueGradient.addColorStop(0, 'hsla(0, 0%, 0%, 0)'); // transparent
            valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black
            ctx.fillStyle = valueGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        (0, $hXmfK.watch)(function() {
            var _props_color;
            return (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h;
        }, updateCanvas, {
            immediate: true
        });
        (0, $hXmfK.watch)(function() {
            return [
                canvasWidth.value,
                canvasHeight.value
            ];
        }, function(newVal, oldVal) {
            updateCanvas();
            _dotPosition.value = {
                x: dotPosition.value.x * newVal[0] / oldVal[0],
                y: dotPosition.value.y * newVal[1] / oldVal[1]
            };
        }, {
            flush: 'post'
        });
        (0, $hXmfK.watch)(function() {
            return props.color;
        }, function() {
            if (isInteracting.value) {
                isInteracting.value = false;
                return;
            }
            _dotPosition.value = props.color ? {
                x: props.color.s * canvasWidth.value,
                y: (1 - props.color.v) * canvasHeight.value
            } : {
                x: 0,
                y: 0
            };
        }, {
            deep: true,
            immediate: true
        });
        (0, $bu8yf.onMounted)(function() {
            return updateCanvas();
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                ref: resizeRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-color-picker-canvas',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                onMousedown: handleMouseDown,
                onTouchstartPassive: handleMouseDown
            }, [
                (0, $bu8yf.createElementVNode)("canvas", {
                    ref: canvasRef,
                    width: canvasWidth.value,
                    height: canvasHeight.value
                }, null),
                props.color && (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-color-picker-canvas__dot',
                        {
                            'v-color-picker-canvas__dot--disabled': props.disabled
                        }
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(dotStyles.value)
                }, null)
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



// Utilities

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $3KZcf = parcelRequire("3KZcf");


var $bb05b83aabe1734e$var$_rgba_inputs;
function $bb05b83aabe1734e$var$stripAlpha(color, stripAlpha) {
    if (stripAlpha) {
        var a = color.a, rest = (0, $g79Gh._)(color, [
            "a"
        ]);
        return rest;
    }
    return color;
}
function $bb05b83aabe1734e$export$a5d74e2261ad8c75(color, input) {
    if (input == null || typeof input === 'string') {
        var hasA = color.a !== 1;
        if (input === null || input === void 0 ? void 0 : input.startsWith('rgb(')) {
            var _HSVtoRGB = (0, $7eae58fcc02fc7e9$export$61dbc3014460e6c3)(color), r = _HSVtoRGB.r, g = _HSVtoRGB.g, b = _HSVtoRGB.b, a = _HSVtoRGB.a;
            return "rgb(".concat(r, " ").concat(g, " ").concat(b) + (hasA ? " / ".concat(a, ")") : ')');
        } else if (input === null || input === void 0 ? void 0 : input.startsWith('hsl(')) {
            var _HSVtoHSL = (0, $7eae58fcc02fc7e9$export$f24257e859bd61bb)(color), h = _HSVtoHSL.h, s = _HSVtoHSL.s, l = _HSVtoHSL.l, a1 = _HSVtoHSL.a;
            return "hsl(".concat(h, " ").concat(Math.round(s * 100), " ").concat(Math.round(l * 100)) + (hasA ? " / ".concat(a1, ")") : ')');
        }
        var hex = (0, $7eae58fcc02fc7e9$export$883c749ec82cf1f2)(color);
        if (color.a === 1) return hex.slice(0, 7);
        else return hex;
    }
    if ((typeof input === "undefined" ? "undefined" : (0, $3KZcf._)(input)) === 'object') {
        var converted;
        if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(input, [
            'r',
            'g',
            'b'
        ])) converted = (0, $7eae58fcc02fc7e9$export$61dbc3014460e6c3)(color);
        else if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'l'
        ])) converted = (0, $7eae58fcc02fc7e9$export$f24257e859bd61bb)(color);
        else if ((0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'v'
        ])) converted = color;
        return $bb05b83aabe1734e$var$stripAlpha(converted, !(0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(input, [
            'a'
        ]) && color.a === 1);
    }
    return color;
}
function $bb05b83aabe1734e$export$7c6623716c246f1(color) {
    if (!color) return false;
    if (typeof color === 'string') return color.length > 7;
    if ((typeof color === "undefined" ? "undefined" : (0, $3KZcf._)(color)) === 'object') return (0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(color, [
        'a'
    ]) || (0, $31779689cfd5da50$export$a4f4bb6b1453fff5)(color, [
        'alpha'
    ]);
    return false;
}
var $bb05b83aabe1734e$export$8b018767dd6f3cea = {
    h: 0,
    s: 0,
    v: 0,
    a: 1
};
var $bb05b83aabe1734e$var$rgba = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'R',
            max: 255,
            step: 1,
            getValue: function(c) {
                return Math.round(c.r);
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    r: Number(v)
                });
            }
        },
        {
            label: 'G',
            max: 255,
            step: 1,
            getValue: function(c) {
                return Math.round(c.g);
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    g: Number(v)
                });
            }
        },
        {
            label: 'B',
            max: 255,
            step: 1,
            getValue: function(c) {
                return Math.round(c.b);
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    b: Number(v)
                });
            }
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: function(_ref) {
                var a = _ref.a;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    a: Number(v)
                });
            }
        }
    ],
    to: (0, $7eae58fcc02fc7e9$export$61dbc3014460e6c3),
    from: (0, $7eae58fcc02fc7e9$export$62bb88c9baab039f)
};
var $bb05b83aabe1734e$var$rgb = (0, $emQHU._)((0, $iT0je._)({}, $bb05b83aabe1734e$var$rgba), {
    inputs: ($bb05b83aabe1734e$var$_rgba_inputs = $bb05b83aabe1734e$var$rgba.inputs) === null || $bb05b83aabe1734e$var$_rgba_inputs === void 0 ? void 0 : $bb05b83aabe1734e$var$_rgba_inputs.slice(0, 3)
});
var $bb05b83aabe1734e$var$hsla = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'H',
            max: 360,
            step: 1,
            getValue: function(c) {
                return Math.round(c.h);
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    h: Number(v)
                });
            }
        },
        {
            label: 'S',
            max: 1,
            step: 0.01,
            getValue: function(c) {
                return Math.round(c.s * 100) / 100;
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    s: Number(v)
                });
            }
        },
        {
            label: 'L',
            max: 1,
            step: 0.01,
            getValue: function(c) {
                return Math.round(c.l * 100) / 100;
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    l: Number(v)
                });
            }
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: function(_ref2) {
                var a = _ref2.a;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: function(c, v) {
                return (0, $emQHU._)((0, $iT0je._)({}, c), {
                    a: Number(v)
                });
            }
        }
    ],
    to: (0, $7eae58fcc02fc7e9$export$f24257e859bd61bb),
    from: (0, $7eae58fcc02fc7e9$export$8917074272868d95)
};
var $bb05b83aabe1734e$var$hsl = (0, $emQHU._)((0, $iT0je._)({}, $bb05b83aabe1734e$var$hsla), {
    inputs: $bb05b83aabe1734e$var$hsla.inputs.slice(0, 3)
});
var $bb05b83aabe1734e$var$hexa = {
    inputProps: {
        type: 'text'
    },
    inputs: [
        {
            label: 'HEXA',
            getValue: function(c) {
                return c;
            },
            getColor: function(c, v) {
                return v;
            }
        }
    ],
    to: (0, $7eae58fcc02fc7e9$export$883c749ec82cf1f2),
    from: (0, $7eae58fcc02fc7e9$export$4e9396b641d87477)
};
var $bb05b83aabe1734e$var$hex = (0, $emQHU._)((0, $iT0je._)({}, $bb05b83aabe1734e$var$hexa), {
    inputs: [
        {
            label: 'HEX',
            getValue: function(c) {
                return c.slice(0, 7);
            },
            getColor: function(c, v) {
                return v;
            }
        }
    ]
});
var $bb05b83aabe1734e$export$4a6bdc0a840be00 = {
    rgb: $bb05b83aabe1734e$var$rgb,
    rgba: $bb05b83aabe1734e$var$rgba,
    hsl: $bb05b83aabe1734e$var$hsl,
    hsla: $bb05b83aabe1734e$var$hsla,
    hex: $bb05b83aabe1734e$var$hex,
    hexa: $bb05b83aabe1734e$var$hexa
};



var $1a0edc8a329a23f8$var$VColorPickerInput = function(_ref) {
    var label = _ref.label, rest = (0, $g79Gh._)(_ref, [
        "label"
    ]);
    return (0, $bu8yf.createElementVNode)("div", {
        "class": "v-color-picker-edit__input"
    }, [
        (0, $bu8yf.createElementVNode)("input", (0, $d8jBh.normalizeProps)((0, $bu8yf.guardReactiveProps)(rest)), null),
        (0, $bu8yf.createElementVNode)("span", null, [
            label
        ])
    ]);
};
var $1a0edc8a329a23f8$export$eb4aa077dbc110bc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: Object,
    disabled: Boolean,
    mode: {
        type: String,
        "default": 'rgba',
        validator: function(v) {
            return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00)).includes(v);
        }
    },
    modes: {
        type: Array,
        "default": function() {
            return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00));
        },
        validator: function(v) {
            return Array.isArray(v) && v.every(function(m) {
                return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00)).includes(m);
            });
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VColorPickerEdit');
var $1a0edc8a329a23f8$export$85684b51105c3c4c = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VColorPickerEdit',
    props: $1a0edc8a329a23f8$export$eb4aa077dbc110bc(),
    emits: {
        'update:color': function(color) {
            return true;
        },
        'update:mode': function(mode) {
            return true;
        }
    },
    setup: function(props, _ref2) {
        var emit = _ref2.emit;
        var enabledModes = (0, $hXmfK.computed)(function() {
            return props.modes.map(function(key) {
                return (0, $emQHU._)((0, $iT0je._)({}, (0, $bb05b83aabe1734e$export$4a6bdc0a840be00)[key]), {
                    name: key
                });
            });
        });
        var inputs = (0, $hXmfK.computed)(function() {
            var _mode_inputs;
            var mode = enabledModes.value.find(function(m) {
                return m.name === props.mode;
            });
            if (!mode) return [];
            var color = props.color ? mode.to(props.color) : null;
            return (_mode_inputs = mode.inputs) === null || _mode_inputs === void 0 ? void 0 : _mode_inputs.map(function(_ref3) {
                var getValue = _ref3.getValue, getColor = _ref3.getColor, inputProps = (0, $g79Gh._)(_ref3, [
                    "getValue",
                    "getColor"
                ]);
                return (0, $emQHU._)((0, $iT0je._)({}, mode.inputProps, inputProps), {
                    disabled: props.disabled,
                    value: color && getValue(color),
                    onChange: function(e) {
                        var target = e.target;
                        if (!target) return;
                        emit('update:color', mode.from(getColor(color !== null && color !== void 0 ? color : mode.to((0, $bb05b83aabe1734e$export$8b018767dd6f3cea)), target.value)));
                    }
                });
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _inputs_value;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-color-picker-edit',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_inputs_value = inputs.value) === null || _inputs_value === void 0 ? void 0 : _inputs_value.map(function(props) {
                    return (0, $bu8yf.createVNode)($1a0edc8a329a23f8$var$VColorPickerInput, props, null);
                }),
                enabledModes.value.length > 1 && (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    icon: "$unfold",
                    size: "x-small",
                    variant: "plain",
                    onClick: function() {
                        var mi = enabledModes.value.findIndex(function(m) {
                            return m.name === props.mode;
                        });
                        emit('update:mode', enabledModes.value[(mi + 1) % enabledModes.value.length].name);
                    }
                }, null)
            ]);
        });
        return {};
    }
});



var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");

/* eslint-disable max-statements */ // Composables

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");



parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $3437cd49f8163c66$export$79c7763ce3e7900b = Symbol["for"]('vuetify:v-slider');
function $3437cd49f8163c66$export$622cea445a1c5b7d(e, el, direction) {
    var vertical = direction === 'vertical';
    var rect = el.getBoundingClientRect();
    var touch = 'touches' in e ? e.touches[0] : e;
    return vertical ? touch.clientY - (rect.top + rect.height / 2) : touch.clientX - (rect.left + rect.width / 2);
}
function $3437cd49f8163c66$var$getPosition(e, position) {
    if ('touches' in e && e.touches.length) return e.touches[0][position];
    else if ('changedTouches' in e && e.changedTouches.length) return e.changedTouches[0][position];
    else return e[position];
}
var $3437cd49f8163c66$export$f4533040d074ed75 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    disabled: {
        type: Boolean,
        "default": null
    },
    error: Boolean,
    readonly: {
        type: Boolean,
        "default": null
    },
    max: {
        type: [
            Number,
            String
        ],
        "default": 100
    },
    min: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    step: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    thumbColor: String,
    thumbLabel: {
        type: [
            Boolean,
            String
        ],
        "default": undefined,
        validator: function(v) {
            return typeof v === 'boolean' || v === 'always';
        }
    },
    thumbSize: {
        type: [
            Number,
            String
        ],
        "default": 20
    },
    showTicks: {
        type: [
            Boolean,
            String
        ],
        "default": false,
        validator: function(v) {
            return typeof v === 'boolean' || v === 'always';
        }
    },
    ticks: {
        type: [
            Array,
            Object
        ]
    },
    tickSize: {
        type: [
            Number,
            String
        ],
        "default": 2
    },
    color: String,
    trackColor: String,
    trackFillColor: String,
    trackSize: {
        type: [
            Number,
            String
        ],
        "default": 4
    },
    direction: {
        type: String,
        "default": 'horizontal',
        validator: function(v) {
            return [
                'vertical',
                'horizontal'
            ].includes(v);
        }
    },
    reverse: Boolean
}, (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $753fdc0f0b894251$export$858059d20a48304b)({
    elevation: 2
})), {
    ripple: {
        type: Boolean,
        "default": true
    }
}), 'Slider');
var $3437cd49f8163c66$export$302911c449e17ea4 = function(props) {
    var roundValue = function roundValue(value) {
        value = parseFloat(value);
        if (step.value <= 0) return value;
        var clamped = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(value, min.value, max.value);
        var offset = min.value % step.value;
        var newValue = Math.round((clamped - offset) / step.value) * step.value + offset;
        if (clamped > newValue && newValue + step.value > max.value) newValue = max.value;
        return parseFloat(Math.min(newValue, max.value).toFixed(decimals.value));
    };
    var min = (0, $hXmfK.computed)(function() {
        return parseFloat(props.min);
    });
    var max = (0, $hXmfK.computed)(function() {
        return parseFloat(props.max);
    });
    var step = (0, $hXmfK.computed)(function() {
        return Number(props.step) > 0 ? parseFloat(props.step) : 0;
    });
    var decimals = (0, $hXmfK.computed)(function() {
        return Math.max((0, $31779689cfd5da50$export$1ecb455da4aa739b)(step.value), (0, $31779689cfd5da50$export$1ecb455da4aa739b)(min.value));
    });
    return {
        min: min,
        max: max,
        step: step,
        decimals: decimals,
        roundValue: roundValue
    };
};
var $3437cd49f8163c66$export$56b2c08e277f365 = function(_ref) {
    var parseMouseMove = function parseMouseMove(e) {
        var _trackContainerRef_value;
        var el = (_trackContainerRef_value = trackContainerRef.value) === null || _trackContainerRef_value === void 0 ? void 0 : _trackContainerRef_value.$el;
        if (!el) return;
        var vertical = props.direction === 'vertical';
        var start = vertical ? 'top' : 'left';
        var length = vertical ? 'height' : 'width';
        var position = vertical ? 'clientY' : 'clientX';
        var _el_getBoundingClientRect = el.getBoundingClientRect(), trackStart = _el_getBoundingClientRect[start], trackLength = _el_getBoundingClientRect[length];
        var clickOffset = $3437cd49f8163c66$var$getPosition(e, position);
        // It is possible for left to be NaN, force to number
        var clickPos = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)((clickOffset - trackStart - startOffset.value) / trackLength) || 0;
        if (vertical ? indexFromEnd.value : indexFromEnd.value !== isRtl.value) clickPos = 1 - clickPos;
        return roundValue(min.value + clickPos * (max.value - min.value));
    };
    var onMouseMove = function onMouseMove(e) {
        var value = parseMouseMove(e);
        if (value != null) onSliderMove({
            value: value
        });
    };
    var onSliderTouchstart = function onSliderTouchstart(e) {
        var _e_target;
        handleStart(e);
        window.addEventListener('touchmove', onMouseMove, moveListenerOptions);
        (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.addEventListener('touchend', onSliderTouchend, {
            passive: false
        });
    };
    var onSliderMousedown = function onSliderMousedown(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        handleStart(e);
        window.addEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.addEventListener('mouseup', onSliderMouseUp, {
            passive: false
        });
    };
    var props = _ref.props, steps = _ref.steps, onSliderStart = _ref.onSliderStart, onSliderMove = _ref.onSliderMove, onSliderEnd = _ref.onSliderEnd, getActiveThumb = _ref.getActiveThumb;
    var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
    var isReversed = (0, $hXmfK.toRef)(function() {
        return props.reverse;
    });
    var vertical = (0, $hXmfK.computed)(function() {
        return props.direction === 'vertical';
    });
    var indexFromEnd = (0, $hXmfK.computed)(function() {
        return vertical.value !== isReversed.value;
    });
    var min = steps.min, max = steps.max, step = steps.step, decimals = steps.decimals, roundValue = steps.roundValue;
    var thumbSize = (0, $hXmfK.computed)(function() {
        return parseInt(props.thumbSize, 10);
    });
    var tickSize = (0, $hXmfK.computed)(function() {
        return parseInt(props.tickSize, 10);
    });
    var trackSize = (0, $hXmfK.computed)(function() {
        return parseInt(props.trackSize, 10);
    });
    var numTicks = (0, $hXmfK.computed)(function() {
        return (max.value - min.value) / step.value;
    });
    var disabled = (0, $hXmfK.toRef)(function() {
        return props.disabled;
    });
    var thumbColor = (0, $hXmfK.computed)(function() {
        var _props_thumbColor;
        return props.error || props.disabled ? undefined : (_props_thumbColor = props.thumbColor) !== null && _props_thumbColor !== void 0 ? _props_thumbColor : props.color;
    });
    var trackColor = (0, $hXmfK.computed)(function() {
        var _props_trackColor;
        return props.error || props.disabled ? undefined : (_props_trackColor = props.trackColor) !== null && _props_trackColor !== void 0 ? _props_trackColor : props.color;
    });
    var trackFillColor = (0, $hXmfK.computed)(function() {
        var _props_trackFillColor;
        return props.error || props.disabled ? undefined : (_props_trackFillColor = props.trackFillColor) !== null && _props_trackFillColor !== void 0 ? _props_trackFillColor : props.color;
    });
    var mousePressed = (0, $hXmfK.shallowRef)(false);
    var startOffset = (0, $hXmfK.shallowRef)(0);
    var trackContainerRef = (0, $hXmfK.ref)();
    var activeThumbRef = (0, $hXmfK.ref)();
    var handleStop = function(e) {
        var value = parseMouseMove(e);
        if (value != null) onSliderEnd({
            value: value
        });
        mousePressed.value = false;
        startOffset.value = 0;
    };
    var handleStart = function(e) {
        var value = parseMouseMove(e);
        activeThumbRef.value = getActiveThumb(e);
        if (!activeThumbRef.value) return;
        mousePressed.value = true;
        if (activeThumbRef.value.contains(e.target)) startOffset.value = $3437cd49f8163c66$export$622cea445a1c5b7d(e, activeThumbRef.value, props.direction);
        else {
            startOffset.value = 0;
            if (value != null) onSliderMove({
                value: value
            });
        }
        if (value != null) onSliderStart({
            value: value
        });
        (0, $bu8yf.nextTick)(function() {
            var _activeThumbRef_value;
            return (_activeThumbRef_value = activeThumbRef.value) === null || _activeThumbRef_value === void 0 ? void 0 : _activeThumbRef_value.focus();
        });
    };
    var moveListenerOptions = {
        passive: true,
        capture: true
    };
    function onSliderMouseUp(e) {
        e.stopPropagation();
        e.preventDefault();
        handleStop(e);
        window.removeEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.removeEventListener('mouseup', onSliderMouseUp);
    }
    function onSliderTouchend(e) {
        var _e_target;
        handleStop(e);
        window.removeEventListener('touchmove', onMouseMove, moveListenerOptions);
        (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.removeEventListener('touchend', onSliderTouchend);
    }
    var position = function(val) {
        var percentage = (val - min.value) / (max.value - min.value) * 100;
        return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(isNaN(percentage) ? 0 : percentage, 0, 100);
    };
    var showTicks = (0, $hXmfK.toRef)(function() {
        return props.showTicks;
    });
    var parsedTicks = (0, $hXmfK.computed)(function() {
        if (!showTicks.value) return [];
        if (!props.ticks) return numTicks.value !== Infinity ? (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(numTicks.value + 1).map(function(t) {
            var value = min.value + t * step.value;
            return {
                value: value,
                position: position(value)
            };
        }) : [];
        if (Array.isArray(props.ticks)) return props.ticks.map(function(t) {
            return {
                value: t,
                position: position(t),
                label: t.toString()
            };
        });
        return Object.keys(props.ticks).map(function(key) {
            return {
                value: parseFloat(key),
                position: position(parseFloat(key)),
                label: props.ticks[key]
            };
        });
    });
    var hasLabels = (0, $hXmfK.computed)(function() {
        return parsedTicks.value.some(function(_ref2) {
            var label = _ref2.label;
            return !!label;
        });
    });
    var data = {
        activeThumbRef: activeThumbRef,
        color: (0, $hXmfK.toRef)(function() {
            return props.color;
        }),
        decimals: decimals,
        disabled: disabled,
        direction: (0, $hXmfK.toRef)(function() {
            return props.direction;
        }),
        elevation: (0, $hXmfK.toRef)(function() {
            return props.elevation;
        }),
        hasLabels: hasLabels,
        isReversed: isReversed,
        indexFromEnd: indexFromEnd,
        min: min,
        max: max,
        mousePressed: mousePressed,
        numTicks: numTicks,
        onSliderMousedown: onSliderMousedown,
        onSliderTouchstart: onSliderTouchstart,
        parsedTicks: parsedTicks,
        parseMouseMove: parseMouseMove,
        position: position,
        readonly: (0, $hXmfK.toRef)(function() {
            return props.readonly;
        }),
        rounded: (0, $hXmfK.toRef)(function() {
            return props.rounded;
        }),
        roundValue: roundValue,
        showTicks: showTicks,
        startOffset: startOffset,
        step: step,
        thumbSize: thumbSize,
        thumbColor: thumbColor,
        thumbLabel: (0, $hXmfK.toRef)(function() {
            return props.thumbLabel;
        }),
        ticks: (0, $hXmfK.toRef)(function() {
            return props.ticks;
        }),
        tickSize: tickSize,
        trackColor: trackColor,
        trackContainerRef: trackContainerRef,
        trackFillColor: trackFillColor,
        trackSize: trackSize,
        vertical: vertical
    };
    (0, $bu8yf.provide)($3437cd49f8163c66$export$79c7763ce3e7900b, data);
    return data;
};









var $337a930674f2b454$export$cc943e61932e6a97 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    focused: Boolean,
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    modelValue: {
        type: Number,
        required: true
    },
    position: {
        type: Number,
        required: true
    },
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    name: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VSliderThumb');
var $337a930674f2b454$export$64ccdeab5f3618a7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSliderThumb',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $337a930674f2b454$export$cc943e61932e6a97(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var slider = (0, $bu8yf.inject)((0, $3437cd49f8163c66$export$79c7763ce3e7900b));
        var _useRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)(), isRtl = _useRtl.isRtl, rtlClasses = _useRtl.rtlClasses;
        if (!slider) throw new Error('[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider');
        var min = slider.min, max = slider.max, thumbColor = slider.thumbColor, step = slider.step, disabled = slider.disabled, thumbSize = slider.thumbSize, thumbLabel = slider.thumbLabel, direction = slider.direction, isReversed = slider.isReversed, vertical = slider.vertical, readonly = slider.readonly, elevation = slider.elevation, mousePressed = slider.mousePressed, decimals = slider.decimals, indexFromEnd = slider.indexFromEnd;
        var elevationProps = (0, $hXmfK.computed)(function() {
            return !disabled.value ? elevation.value : undefined;
        });
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(elevationProps).elevationClasses;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(thumbColor), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var pageup = (0, $31779689cfd5da50$export$4f79075d7446a261).pageup, pagedown = (0, $31779689cfd5da50$export$4f79075d7446a261).pagedown, end = (0, $31779689cfd5da50$export$4f79075d7446a261).end, home = (0, $31779689cfd5da50$export$4f79075d7446a261).home, left = (0, $31779689cfd5da50$export$4f79075d7446a261).left, right = (0, $31779689cfd5da50$export$4f79075d7446a261).right, down = (0, $31779689cfd5da50$export$4f79075d7446a261).down, up = (0, $31779689cfd5da50$export$4f79075d7446a261).up;
        var relevantKeys = [
            pageup,
            pagedown,
            end,
            home,
            left,
            right,
            down,
            up
        ];
        var multipliers = (0, $hXmfK.computed)(function() {
            if (step.value) return [
                1,
                2,
                3
            ];
            else return [
                1,
                5,
                10
            ];
        });
        function parseKeydown(e, value) {
            if (!relevantKeys.includes(e.key)) return;
            e.preventDefault();
            var _step = step.value || 0.1;
            var steps = (max.value - min.value) / _step;
            if ([
                left,
                right,
                down,
                up
            ].includes(e.key)) {
                var increase = vertical.value ? [
                    isRtl.value ? left : right,
                    isReversed.value ? down : up
                ] : indexFromEnd.value !== isRtl.value ? [
                    left,
                    up
                ] : [
                    right,
                    up
                ];
                var direction = increase.includes(e.key) ? 1 : -1;
                var multiplier = e.shiftKey ? 2 : e.ctrlKey ? 1 : 0;
                if (direction === -1 && value === max.value && !multiplier && !Number.isInteger(steps)) value = value - steps % 1 * _step;
                else value = value + direction * _step * multipliers.value[multiplier];
            } else if (e.key === home) value = min.value;
            else if (e.key === end) value = max.value;
            else {
                var direction1 = e.key === pagedown ? 1 : -1;
                value = value - direction1 * _step * (steps > 100 ? steps / 10 : 10);
            }
            return Math.max(props.min, Math.min(props.max, value));
        }
        function onKeydown(e) {
            var newValue = parseKeydown(e, props.modelValue);
            newValue != null && emit('update:modelValue', newValue);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var positionPercentage = (0, $31779689cfd5da50$export$286ad215293a0860)(indexFromEnd.value ? 100 - props.position : props.position, '%');
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-slider-thumb',
                    {
                        'v-slider-thumb--focused': props.focused,
                        'v-slider-thumb--pressed': props.focused && mousePressed.value
                    },
                    props["class"],
                    rtlClasses.value
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-slider-thumb-position': positionPercentage,
                        '--v-slider-thumb-size': (0, $31779689cfd5da50$export$286ad215293a0860)(thumbSize.value)
                    },
                    props.style
                ]),
                role: "slider",
                tabindex: disabled.value ? -1 : 0,
                "aria-label": props.name,
                "aria-valuemin": min.value,
                "aria-valuemax": max.value,
                "aria-valuenow": props.modelValue,
                "aria-readonly": !!readonly.value,
                "aria-orientation": direction.value,
                onKeydown: !readonly.value ? onKeydown : undefined
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-thumb__surface',
                        textColorClasses.value,
                        elevationClasses.value
                    ]),
                    style: (0, $iT0je._)({}, textColorStyles.value)
                }, null),
                (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-thumb__ripple',
                        textColorClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(textColorStyles.value)
                }, null), [
                    [
                        (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                        props.ripple,
                        null,
                        {
                            circle: true,
                            center: true
                        }
                    ]
                ]),
                (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$5d9397de61546474), {
                    origin: "bottom center"
                }, {
                    "default": function() {
                        var _slots_thumblabel;
                        var _slots_thumblabel1;
                        return [
                            (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                                "class": "v-slider-thumb__label-container"
                            }, [
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": (0, $d8jBh.normalizeClass)([
                                        'v-slider-thumb__label',
                                        textColorClasses.value
                                    ])
                                }, [
                                    (0, $bu8yf.createElementVNode)("div", null, [
                                        (_slots_thumblabel1 = (_slots_thumblabel = slots['thumb-label']) === null || _slots_thumblabel === void 0 ? void 0 : _slots_thumblabel.call(slots, {
                                            modelValue: props.modelValue
                                        })) !== null && _slots_thumblabel1 !== void 0 ? _slots_thumblabel1 : props.modelValue.toFixed(step.value ? decimals.value : 1)
                                    ])
                                ])
                            ]), [
                                [
                                    (0, $kiZwI.vShow),
                                    thumbLabel.value && props.focused || thumbLabel.value === 'always'
                                ]
                            ])
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});



var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






var $351f7fdcc1227baa$export$ae787ca82c06929d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    start: {
        type: Number,
        required: true
    },
    stop: {
        type: Number,
        required: true
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VSliderTrack');
var $351f7fdcc1227baa$export$bf1154fbd075ef2 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSliderTrack',
    props: $351f7fdcc1227baa$export$ae787ca82c06929d(),
    emits: {},
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var slider = (0, $bu8yf.inject)((0, $3437cd49f8163c66$export$79c7763ce3e7900b));
        if (!slider) throw new Error('[Vuetify] v-slider-track must be inside v-slider or v-range-slider');
        var color = slider.color, parsedTicks = slider.parsedTicks, rounded = slider.rounded, showTicks = slider.showTicks, tickSize = slider.tickSize, trackColor = slider.trackColor, trackFillColor = slider.trackFillColor, trackSize = slider.trackSize, vertical = slider.vertical, min = slider.min, max = slider.max, indexFromEnd = slider.indexFromEnd;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(rounded).roundedClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(trackFillColor), trackFillColorClasses = _useBackgroundColor.backgroundColorClasses, trackFillColorStyles = _useBackgroundColor.backgroundColorStyles;
        var _useBackgroundColor1 = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(trackColor), trackColorClasses = _useBackgroundColor1.backgroundColorClasses, trackColorStyles = _useBackgroundColor1.backgroundColorStyles;
        var startDir = (0, $hXmfK.computed)(function() {
            return "inset-".concat(vertical.value ? 'block' : 'inline', "-").concat(indexFromEnd.value ? 'end' : 'start');
        });
        var endDir = (0, $hXmfK.computed)(function() {
            return vertical.value ? 'height' : 'width';
        });
        var backgroundStyles = (0, $hXmfK.computed)(function() {
            var _obj;
            return _obj = {}, (0, $cqEAj._)(_obj, startDir.value, '0%'), (0, $cqEAj._)(_obj, endDir.value, '100%'), _obj;
        });
        var trackFillWidth = (0, $hXmfK.computed)(function() {
            return props.stop - props.start;
        });
        var trackFillStyles = (0, $hXmfK.computed)(function() {
            var _obj;
            return _obj = {}, (0, $cqEAj._)(_obj, startDir.value, (0, $31779689cfd5da50$export$286ad215293a0860)(props.start, '%')), (0, $cqEAj._)(_obj, endDir.value, (0, $31779689cfd5da50$export$286ad215293a0860)(trackFillWidth.value, '%')), _obj;
        });
        var computedTicks = (0, $hXmfK.computed)(function() {
            if (!showTicks.value) return [];
            var ticks = vertical.value ? parsedTicks.value.slice().reverse() : parsedTicks.value;
            return ticks.map(function(tick, index) {
                var _slots_ticklabel;
                var directionValue = tick.value !== min.value && tick.value !== max.value ? (0, $31779689cfd5da50$export$286ad215293a0860)(tick.position, '%') : undefined;
                var _slots_ticklabel1;
                return (0, $bu8yf.createElementVNode)("div", {
                    key: tick.value,
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-track__tick',
                        {
                            'v-slider-track__tick--filled': tick.position >= props.start && tick.position <= props.stop,
                            'v-slider-track__tick--first': tick.value === min.value,
                            'v-slider-track__tick--last': tick.value === max.value
                        }
                    ]),
                    style: (0, $cqEAj._)({}, startDir.value, directionValue)
                }, [
                    (tick.label || slots['tick-label']) && (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-slider-track__tick-label"
                    }, [
                        (_slots_ticklabel1 = (_slots_ticklabel = slots['tick-label']) === null || _slots_ticklabel === void 0 ? void 0 : _slots_ticklabel.call(slots, {
                            tick: tick,
                            index: index
                        })) !== null && _slots_ticklabel1 !== void 0 ? _slots_ticklabel1 : tick.label
                    ])
                ]);
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-slider-track',
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-slider-track-size': (0, $31779689cfd5da50$export$286ad215293a0860)(trackSize.value),
                        '--v-slider-tick-size': (0, $31779689cfd5da50$export$286ad215293a0860)(tickSize.value)
                    },
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-track__background',
                        trackColorClasses.value,
                        {
                            'v-slider-track__background--opacity': !!color.value || !trackFillColor.value
                        }
                    ]),
                    style: (0, $iT0je._)({}, backgroundStyles.value, trackColorStyles.value)
                }, null),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-track__fill',
                        trackFillColorClasses.value
                    ]),
                    style: (0, $iT0je._)({}, trackFillStyles.value, trackFillColorStyles.value)
                }, null),
                showTicks.value && (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-slider-track__ticks',
                        {
                            'v-slider-track__ticks--always-show': showTicks.value === 'always'
                        }
                    ])
                }, [
                    computedTicks.value
                ])
            ]);
        });
        return {};
    }
});










var $4520edbc8ae6fc58$export$7eb22fe22e0c7b1b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({}, (0, $6f0e0973cbf83779$export$676d4e684e4b0e1e)(), (0, $3437cd49f8163c66$export$f4533040d074ed75)(), (0, $b8b1b307f20fc3d6$export$525655a73981d616)()), {
    modelValue: {
        type: [
            Number,
            String
        ],
        "default": 0
    }
}), 'VSlider');
var $4520edbc8ae6fc58$export$e0368715924ca04f = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSlider',
    props: $4520edbc8ae6fc58$export$7eb22fe22e0c7b1b(),
    emits: {
        'update:focused': function(value) {
            return true;
        },
        'update:modelValue': function(v) {
            return true;
        },
        start: function(value) {
            return true;
        },
        end: function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var thumbContainerRef = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)();
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var steps = (0, $3437cd49f8163c66$export$302911c449e17ea4)(props);
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', undefined, function(value) {
            return steps.roundValue(value == null ? steps.min.value : value);
        });
        var _useSlider = (0, $3437cd49f8163c66$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: function() {
                emit('start', model.value);
            },
            onSliderEnd: function(_ref2) {
                var value = _ref2.value;
                var roundedValue = roundValue(value);
                model.value = roundedValue;
                emit('end', roundedValue);
            },
            onSliderMove: function(_ref3) {
                var value = _ref3.value;
                return model.value = roundValue(value);
            },
            getActiveThumb: function() {
                var _thumbContainerRef_value;
                return (_thumbContainerRef_value = thumbContainerRef.value) === null || _thumbContainerRef_value === void 0 ? void 0 : _thumbContainerRef_value.$el;
            }
        }), min = _useSlider.min, max = _useSlider.max, mousePressed = _useSlider.mousePressed, roundValue = _useSlider.roundValue, onSliderMousedown = _useSlider.onSliderMousedown, onSliderTouchstart = _useSlider.onSliderTouchstart, trackContainerRef = _useSlider.trackContainerRef, position = _useSlider.position, hasLabels = _useSlider.hasLabels, readonly = _useSlider.readonly;
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var trackStop = (0, $hXmfK.computed)(function() {
            return position(model.value);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var inputProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props);
            var hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: inputRef,
                "class": [
                    'v-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': props.disabled
                    },
                    rtlClasses.value,
                    props["class"]
                ],
                style: props.style
            }, inputProps, {
                focused: isFocused.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                prepend: hasPrepend ? function(slotProps) {
                    var _slots_label, _slots_prepend;
                    var _slots_label1;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, slotProps)) !== null && _slots_label1 !== void 0 ? _slots_label1 : props.label ? (0, $bu8yf.createVNode)((0, $6c6f579f4011d0f0$export$90281af35207eb21), {
                            id: slotProps.id.value,
                            "class": "v-slider__label",
                            text: props.label
                        }, null) : undefined,
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined,
                "default": function(_ref4) {
                    var id = _ref4.id, messagesId = _ref4.messagesId;
                    return (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-slider__container",
                        onMousedown: !readonly.value ? onSliderMousedown : undefined,
                        onTouchstartPassive: !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $bu8yf.createElementVNode)("input", {
                            id: id.value,
                            name: props.name || id.value,
                            disabled: !!props.disabled,
                            readonly: !!props.readonly,
                            tabindex: "-1",
                            value: model.value
                        }, null),
                        (0, $bu8yf.createVNode)((0, $351f7fdcc1227baa$export$bf1154fbd075ef2), {
                            ref: trackContainerRef,
                            start: 0,
                            stop: trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $bu8yf.createVNode)((0, $337a930674f2b454$export$64ccdeab5f3618a7), {
                            ref: thumbContainerRef,
                            "aria-describedby": messagesId.value,
                            focused: isFocused.value,
                            min: min.value,
                            max: max.value,
                            modelValue: model.value,
                            "onUpdate:modelValue": function(v) {
                                return model.value = v;
                            },
                            position: trackStop.value,
                            elevation: props.elevation,
                            onFocus: focus,
                            onBlur: blur,
                            ripple: props.ripple,
                            name: props.name
                        }, {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            focus: function() {
                var _thumbContainerRef_value;
                return (_thumbContainerRef_value = thumbContainerRef.value) === null || _thumbContainerRef_value === void 0 ? void 0 : _thumbContainerRef_value.$el.focus();
            }
        }, inputRef);
    }
});





var $0055d21cca4ca049$export$fb8ae246551c1c5c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: {
        type: Object
    },
    disabled: Boolean,
    hideAlpha: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VColorPickerPreview');
var $0055d21cca4ca049$export$82b96236d6e48b4a = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VColorPickerPreview',
    props: $0055d21cca4ca049$export$fb8ae246551c1c5c(),
    emits: {
        'update:color': function(color) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        var abortController = new AbortController();
        (0, $bu8yf.onUnmounted)(function() {
            return abortController.abort();
        });
        function openEyeDropper() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var eyeDropper, result, colorHexValue, _props_color, e;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $10db88b646d64b14$export$c0654247a3e5665d) || props.disabled) return [
                                2
                            ];
                            eyeDropper = new window.EyeDropper();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                eyeDropper.open({
                                    signal: abortController.signal
                                })
                            ];
                        case 2:
                            result = _state.sent();
                            colorHexValue = (0, $7eae58fcc02fc7e9$export$62bb88c9baab039f)((0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(result.sRGBHex));
                            emit('update:color', (0, $iT0je._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $bb05b83aabe1734e$export$8b018767dd6f3cea), colorHexValue));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _props_color, _props_color1;
            var _props_color2, _props_color_a;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-color-picker-preview',
                    {
                        'v-color-picker-preview--hide-alpha': props.hideAlpha
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (0, $10db88b646d64b14$export$c0654247a3e5665d) && (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-color-picker-preview__eye-dropper",
                    key: "eyeDropper"
                }, [
                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        density: "comfortable",
                        disabled: props.disabled,
                        icon: "$eyeDropper",
                        variant: "plain",
                        onClick: openEyeDropper
                    }, null)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-color-picker-preview__dot"
                }, [
                    (0, $bu8yf.createElementVNode)("div", {
                        style: {
                            background: (0, $7eae58fcc02fc7e9$export$25aeffa982c279d7)((_props_color2 = props.color) !== null && _props_color2 !== void 0 ? _props_color2 : (0, $bb05b83aabe1734e$export$8b018767dd6f3cea))
                        }
                    }, null)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-color-picker-preview__sliders"
                }, [
                    (0, $bu8yf.createVNode)((0, $4520edbc8ae6fc58$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__hue",
                        modelValue: (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h,
                        "onUpdate:modelValue": function(h) {
                            var _props_color;
                            return emit('update:color', (0, $emQHU._)((0, $iT0je._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $bb05b83aabe1734e$export$8b018767dd6f3cea)), {
                                h: h
                            }));
                        },
                        step: 0,
                        min: 0,
                        max: 360,
                        disabled: props.disabled,
                        thumbSize: 14,
                        trackSize: 8,
                        trackFillColor: "white",
                        hideDetails: true
                    }, null),
                    !props.hideAlpha && (0, $bu8yf.createVNode)((0, $4520edbc8ae6fc58$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__alpha",
                        modelValue: (_props_color_a = (_props_color1 = props.color) === null || _props_color1 === void 0 ? void 0 : _props_color1.a) !== null && _props_color_a !== void 0 ? _props_color_a : 1,
                        "onUpdate:modelValue": function(a) {
                            var _props_color;
                            return emit('update:color', (0, $emQHU._)((0, $iT0je._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $bb05b83aabe1734e$export$8b018767dd6f3cea)), {
                                a: a
                            }));
                        },
                        step: 1 / 256,
                        min: 0,
                        max: 1,
                        disabled: props.disabled,
                        thumbSize: 14,
                        trackSize: 8,
                        trackFillColor: "white",
                        hideDetails: true
                    }, null)
                ])
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $00589589c2b185bc$export$a90204d1394caf30 = {
    base: '#f44336',
    lighten5: '#ffebee',
    lighten4: '#ffcdd2',
    lighten3: '#ef9a9a',
    lighten2: '#e57373',
    lighten1: '#ef5350',
    darken1: '#e53935',
    darken2: '#d32f2f',
    darken3: '#c62828',
    darken4: '#b71c1c',
    accent1: '#ff8a80',
    accent2: '#ff5252',
    accent3: '#ff1744',
    accent4: '#d50000'
};
var $00589589c2b185bc$export$47853bc718611763 = {
    base: '#e91e63',
    lighten5: '#fce4ec',
    lighten4: '#f8bbd0',
    lighten3: '#f48fb1',
    lighten2: '#f06292',
    lighten1: '#ec407a',
    darken1: '#d81b60',
    darken2: '#c2185b',
    darken3: '#ad1457',
    darken4: '#880e4f',
    accent1: '#ff80ab',
    accent2: '#ff4081',
    accent3: '#f50057',
    accent4: '#c51162'
};
var $00589589c2b185bc$export$e13cce2a2d16a9d4 = {
    base: '#9c27b0',
    lighten5: '#f3e5f5',
    lighten4: '#e1bee7',
    lighten3: '#ce93d8',
    lighten2: '#ba68c8',
    lighten1: '#ab47bc',
    darken1: '#8e24aa',
    darken2: '#7b1fa2',
    darken3: '#6a1b9a',
    darken4: '#4a148c',
    accent1: '#ea80fc',
    accent2: '#e040fb',
    accent3: '#d500f9',
    accent4: '#aa00ff'
};
var $00589589c2b185bc$export$51ef95b19086af57 = {
    base: '#673ab7',
    lighten5: '#ede7f6',
    lighten4: '#d1c4e9',
    lighten3: '#b39ddb',
    lighten2: '#9575cd',
    lighten1: '#7e57c2',
    darken1: '#5e35b1',
    darken2: '#512da8',
    darken3: '#4527a0',
    darken4: '#311b92',
    accent1: '#b388ff',
    accent2: '#7c4dff',
    accent3: '#651fff',
    accent4: '#6200ea'
};
var $00589589c2b185bc$export$3e6ccc7b8562d453 = {
    base: '#3f51b5',
    lighten5: '#e8eaf6',
    lighten4: '#c5cae9',
    lighten3: '#9fa8da',
    lighten2: '#7986cb',
    lighten1: '#5c6bc0',
    darken1: '#3949ab',
    darken2: '#303f9f',
    darken3: '#283593',
    darken4: '#1a237e',
    accent1: '#8c9eff',
    accent2: '#536dfe',
    accent3: '#3d5afe',
    accent4: '#304ffe'
};
var $00589589c2b185bc$export$2aa0182783e7e9de = {
    base: '#2196f3',
    lighten5: '#e3f2fd',
    lighten4: '#bbdefb',
    lighten3: '#90caf9',
    lighten2: '#64b5f6',
    lighten1: '#42a5f5',
    darken1: '#1e88e5',
    darken2: '#1976d2',
    darken3: '#1565c0',
    darken4: '#0d47a1',
    accent1: '#82b1ff',
    accent2: '#448aff',
    accent3: '#2979ff',
    accent4: '#2962ff'
};
var $00589589c2b185bc$export$7b0d29b70b435c21 = {
    base: '#03a9f4',
    lighten5: '#e1f5fe',
    lighten4: '#b3e5fc',
    lighten3: '#81d4fa',
    lighten2: '#4fc3f7',
    lighten1: '#29b6f6',
    darken1: '#039be5',
    darken2: '#0288d1',
    darken3: '#0277bd',
    darken4: '#01579b',
    accent1: '#80d8ff',
    accent2: '#40c4ff',
    accent3: '#00b0ff',
    accent4: '#0091ea'
};
var $00589589c2b185bc$export$7474046f446842ee = {
    base: '#00bcd4',
    lighten5: '#e0f7fa',
    lighten4: '#b2ebf2',
    lighten3: '#80deea',
    lighten2: '#4dd0e1',
    lighten1: '#26c6da',
    darken1: '#00acc1',
    darken2: '#0097a7',
    darken3: '#00838f',
    darken4: '#006064',
    accent1: '#84ffff',
    accent2: '#18ffff',
    accent3: '#00e5ff',
    accent4: '#00b8d4'
};
var $00589589c2b185bc$export$8bf7dff220b82b4a = {
    base: '#009688',
    lighten5: '#e0f2f1',
    lighten4: '#b2dfdb',
    lighten3: '#80cbc4',
    lighten2: '#4db6ac',
    lighten1: '#26a69a',
    darken1: '#00897b',
    darken2: '#00796b',
    darken3: '#00695c',
    darken4: '#004d40',
    accent1: '#a7ffeb',
    accent2: '#64ffda',
    accent3: '#1de9b6',
    accent4: '#00bfa5'
};
var $00589589c2b185bc$export$955a2ebd2fb142ae = {
    base: '#4caf50',
    lighten5: '#e8f5e9',
    lighten4: '#c8e6c9',
    lighten3: '#a5d6a7',
    lighten2: '#81c784',
    lighten1: '#66bb6a',
    darken1: '#43a047',
    darken2: '#388e3c',
    darken3: '#2e7d32',
    darken4: '#1b5e20',
    accent1: '#b9f6ca',
    accent2: '#69f0ae',
    accent3: '#00e676',
    accent4: '#00c853'
};
var $00589589c2b185bc$export$559a8c00376dc936 = {
    base: '#8bc34a',
    lighten5: '#f1f8e9',
    lighten4: '#dcedc8',
    lighten3: '#c5e1a5',
    lighten2: '#aed581',
    lighten1: '#9ccc65',
    darken1: '#7cb342',
    darken2: '#689f38',
    darken3: '#558b2f',
    darken4: '#33691e',
    accent1: '#ccff90',
    accent2: '#b2ff59',
    accent3: '#76ff03',
    accent4: '#64dd17'
};
var $00589589c2b185bc$export$221d31baf2636aad = {
    base: '#cddc39',
    lighten5: '#f9fbe7',
    lighten4: '#f0f4c3',
    lighten3: '#e6ee9c',
    lighten2: '#dce775',
    lighten1: '#d4e157',
    darken1: '#c0ca33',
    darken2: '#afb42b',
    darken3: '#9e9d24',
    darken4: '#827717',
    accent1: '#f4ff81',
    accent2: '#eeff41',
    accent3: '#c6ff00',
    accent4: '#aeea00'
};
var $00589589c2b185bc$export$594c5a8758200c32 = {
    base: '#ffeb3b',
    lighten5: '#fffde7',
    lighten4: '#fff9c4',
    lighten3: '#fff59d',
    lighten2: '#fff176',
    lighten1: '#ffee58',
    darken1: '#fdd835',
    darken2: '#fbc02d',
    darken3: '#f9a825',
    darken4: '#f57f17',
    accent1: '#ffff8d',
    accent2: '#ffff00',
    accent3: '#ffea00',
    accent4: '#ffd600'
};
var $00589589c2b185bc$export$7c1ecc66643fdbd6 = {
    base: '#ffc107',
    lighten5: '#fff8e1',
    lighten4: '#ffecb3',
    lighten3: '#ffe082',
    lighten2: '#ffd54f',
    lighten1: '#ffca28',
    darken1: '#ffb300',
    darken2: '#ffa000',
    darken3: '#ff8f00',
    darken4: '#ff6f00',
    accent1: '#ffe57f',
    accent2: '#ffd740',
    accent3: '#ffc400',
    accent4: '#ffab00'
};
var $00589589c2b185bc$export$ad766f34ace1cafd = {
    base: '#ff9800',
    lighten5: '#fff3e0',
    lighten4: '#ffe0b2',
    lighten3: '#ffcc80',
    lighten2: '#ffb74d',
    lighten1: '#ffa726',
    darken1: '#fb8c00',
    darken2: '#f57c00',
    darken3: '#ef6c00',
    darken4: '#e65100',
    accent1: '#ffd180',
    accent2: '#ffab40',
    accent3: '#ff9100',
    accent4: '#ff6d00'
};
var $00589589c2b185bc$export$1ceed3dd9ec11704 = {
    base: '#ff5722',
    lighten5: '#fbe9e7',
    lighten4: '#ffccbc',
    lighten3: '#ffab91',
    lighten2: '#ff8a65',
    lighten1: '#ff7043',
    darken1: '#f4511e',
    darken2: '#e64a19',
    darken3: '#d84315',
    darken4: '#bf360c',
    accent1: '#ff9e80',
    accent2: '#ff6e40',
    accent3: '#ff3d00',
    accent4: '#dd2c00'
};
var $00589589c2b185bc$export$b6e6178d3f565007 = {
    base: '#795548',
    lighten5: '#efebe9',
    lighten4: '#d7ccc8',
    lighten3: '#bcaaa4',
    lighten2: '#a1887f',
    lighten1: '#8d6e63',
    darken1: '#6d4c41',
    darken2: '#5d4037',
    darken3: '#4e342e',
    darken4: '#3e2723'
};
var $00589589c2b185bc$export$7c2da42d08c019c9 = {
    base: '#607d8b',
    lighten5: '#eceff1',
    lighten4: '#cfd8dc',
    lighten3: '#b0bec5',
    lighten2: '#90a4ae',
    lighten1: '#78909c',
    darken1: '#546e7a',
    darken2: '#455a64',
    darken3: '#37474f',
    darken4: '#263238'
};
var $00589589c2b185bc$export$e4c89085febbc618 = {
    base: '#9e9e9e',
    lighten5: '#fafafa',
    lighten4: '#f5f5f5',
    lighten3: '#eeeeee',
    lighten2: '#e0e0e0',
    lighten1: '#bdbdbd',
    darken1: '#757575',
    darken2: '#616161',
    darken3: '#424242',
    darken4: '#212121'
};
var $00589589c2b185bc$export$feb21b986204d651 = {
    black: '#000000',
    white: '#ffffff',
    transparent: '#ffffff00'
};
var $00589589c2b185bc$export$2e2bcd8739ae039 = {
    red: $00589589c2b185bc$export$a90204d1394caf30,
    pink: $00589589c2b185bc$export$47853bc718611763,
    purple: $00589589c2b185bc$export$e13cce2a2d16a9d4,
    deepPurple: $00589589c2b185bc$export$51ef95b19086af57,
    indigo: $00589589c2b185bc$export$3e6ccc7b8562d453,
    blue: $00589589c2b185bc$export$2aa0182783e7e9de,
    lightBlue: $00589589c2b185bc$export$7b0d29b70b435c21,
    cyan: $00589589c2b185bc$export$7474046f446842ee,
    teal: $00589589c2b185bc$export$8bf7dff220b82b4a,
    green: $00589589c2b185bc$export$955a2ebd2fb142ae,
    lightGreen: $00589589c2b185bc$export$559a8c00376dc936,
    lime: $00589589c2b185bc$export$221d31baf2636aad,
    yellow: $00589589c2b185bc$export$594c5a8758200c32,
    amber: $00589589c2b185bc$export$7c1ecc66643fdbd6,
    orange: $00589589c2b185bc$export$ad766f34ace1cafd,
    deepOrange: $00589589c2b185bc$export$1ceed3dd9ec11704,
    brown: $00589589c2b185bc$export$b6e6178d3f565007,
    blueGrey: $00589589c2b185bc$export$7c2da42d08c019c9,
    grey: $00589589c2b185bc$export$e4c89085febbc618,
    shades: $00589589c2b185bc$export$feb21b986204d651
};


var $35544e2f045c52d7$export$414641dc09963608 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    swatches: {
        type: Array,
        "default": function() {
            return $35544e2f045c52d7$var$parseDefaultColors((0, $00589589c2b185bc$export$2e2bcd8739ae039));
        }
    },
    disabled: Boolean,
    color: Object,
    maxHeight: [
        Number,
        String
    ]
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VColorPickerSwatches');
function $35544e2f045c52d7$var$parseDefaultColors(colors) {
    return Object.keys(colors).map(function(key) {
        var color = colors[key];
        return color.base ? [
            color.base,
            color.darken4,
            color.darken3,
            color.darken2,
            color.darken1,
            color.lighten1,
            color.lighten2,
            color.lighten3,
            color.lighten4,
            color.lighten5
        ] : [
            color.black,
            color.white,
            color.transparent
        ];
    });
}
var $35544e2f045c52d7$export$d9ba9354ad14b89d = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VColorPickerSwatches',
    props: $35544e2f045c52d7$export$414641dc09963608(),
    emits: {
        'update:color': function(color) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-color-picker-swatches',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        maxHeight: (0, $31779689cfd5da50$export$286ad215293a0860)(props.maxHeight)
                    },
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", null, [
                    props.swatches.map(function(swatch) {
                        return (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-color-picker-swatches__swatch"
                        }, [
                            swatch.map(function(color) {
                                var rgba = (0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(color);
                                var hsva = (0, $7eae58fcc02fc7e9$export$62bb88c9baab039f)(rgba);
                                var background = (0, $7eae58fcc02fc7e9$export$db9c9368f923228e)(rgba);
                                return (0, $bu8yf.createElementVNode)("div", {
                                    "class": "v-color-picker-swatches__color",
                                    onClick: function() {
                                        return hsva && emit('update:color', hsva);
                                    }
                                }, [
                                    (0, $bu8yf.createElementVNode)("div", {
                                        style: {
                                            background: background
                                        }
                                    }, [
                                        props.color && (0, $31779689cfd5da50$export$9cb4719e2e525b7a)(props.color, hsva) ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                            size: "x-small",
                                            icon: "$success",
                                            color: (0, $7eae58fcc02fc7e9$export$850ce485a60d103b)(color, '#FFFFFF') > 2 ? 'white' : 'black'
                                        }, null) : undefined
                                    ])
                                ]);
                            })
                        ]);
                    })
                ])
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

// Utilities

var $5bf89a040f4261cb$export$4a5fc38152ad5af8 = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-picker-title');




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");












var $f9317188edfebf2e$export$a0ee5621cbdcc362 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VSheet');
var $f9317188edfebf2e$export$d41b26ce18186ef0 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSheet',
    props: $f9317188edfebf2e$export$a0ee5621cbdcc362(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var locationStyles = (0, $1f28bc3af840aa00$export$45d76561a5302f2b)(props).locationStyles;
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-sheet',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});




var $3a810783e3364626$export$78d2911f7e2f59e2 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    bgColor: String,
    divided: Boolean,
    landscape: Boolean,
    title: String,
    hideHeader: Boolean
}, (0, $f9317188edfebf2e$export$a0ee5621cbdcc362)()), 'VPicker');
var $3a810783e3364626$export$37f35d9b6bd5d714 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VPicker',
    props: $3a810783e3364626$export$78d2911f7e2f59e2(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var sheetProps = (0, $f9317188edfebf2e$export$d41b26ce18186ef0).filterProps(props);
            var hasTitle = !!(props.title || slots.title);
            return (0, $bu8yf.createVNode)((0, $f9317188edfebf2e$export$d41b26ce18186ef0), (0, $bu8yf.mergeProps)(sheetProps, {
                color: props.bgColor,
                "class": [
                    'v-picker',
                    {
                        'v-picker--divided': props.divided,
                        'v-picker--landscape': props.landscape,
                        'v-picker--with-actions': !!slots.actions
                    },
                    props["class"]
                ],
                style: props.style
            }), {
                "default": function() {
                    var _slots_default;
                    return [
                        !props.hideHeader && (0, $bu8yf.createElementVNode)("div", {
                            key: "header",
                            "class": (0, $d8jBh.normalizeClass)([
                                backgroundColorClasses.value
                            ]),
                            style: (0, $d8jBh.normalizeStyle)([
                                backgroundColorStyles.value
                            ])
                        }, [
                            hasTitle && (0, $bu8yf.createVNode)((0, $5bf89a040f4261cb$export$4a5fc38152ad5af8), {
                                key: "picker-title"
                            }, {
                                "default": function() {
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                                    ];
                                }
                            }),
                            slots.header && (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-picker__header"
                            }, [
                                slots.header()
                            ])
                        ]),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-picker__body"
                        }, [
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: {
                                VBtn: {
                                    slim: true,
                                    variant: 'text'
                                }
                            }
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-picker__actions"
                                    }, [
                                        slots.actions()
                                    ])
                                ];
                            }
                        })
                    ];
                }
            });
        });
        return {};
    }
});







var $f5b30e541bb65764$export$27a13bb09ff7d1f7 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    canvasHeight: {
        type: [
            String,
            Number
        ],
        "default": 150
    },
    disabled: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        "default": 10
    },
    hideCanvas: Boolean,
    hideSliders: Boolean,
    hideInputs: Boolean,
    mode: {
        type: String,
        "default": 'rgba',
        validator: function(v) {
            return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00)).includes(v);
        }
    },
    modes: {
        type: Array,
        "default": function() {
            return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00));
        },
        validator: function(v) {
            return Array.isArray(v) && v.every(function(m) {
                return Object.keys((0, $bb05b83aabe1734e$export$4a6bdc0a840be00)).includes(m);
            });
        }
    },
    showSwatches: Boolean,
    swatches: Array,
    swatchesMaxHeight: {
        type: [
            Number,
            String
        ],
        "default": 150
    },
    modelValue: {
        type: [
            Object,
            String
        ]
    }
}, (0, $3a810783e3364626$export$78d2911f7e2f59e2)({
    hideHeader: true
})), 'VColorPicker');
var $f5b30e541bb65764$export$9359e1f82effabe6 = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VColorPicker',
    props: $f5b30e541bb65764$export$27a13bb09ff7d1f7(),
    emits: {
        'update:modelValue': function(color) {
            return true;
        },
        'update:mode': function(mode) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var mode = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'mode');
        var hue = (0, $hXmfK.ref)(null);
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', undefined, function(v) {
            if (v == null || v === '') return null;
            var c;
            try {
                c = (0, $7eae58fcc02fc7e9$export$62bb88c9baab039f)((0, $7eae58fcc02fc7e9$export$6e865ea70d7724f)(v));
            } catch (err) {
                (0, $b0e141e3fccca32c$export$222ba5e7254f2402)(err);
                return null;
            }
            return c;
        }, function(v) {
            if (!v) return null;
            return (0, $bb05b83aabe1734e$export$a5d74e2261ad8c75)(v, props.modelValue);
        });
        var currentColor = (0, $hXmfK.computed)(function() {
            var _hue_value;
            return model.value ? (0, $emQHU._)((0, $iT0je._)({}, model.value), {
                h: (_hue_value = hue.value) !== null && _hue_value !== void 0 ? _hue_value : model.value.h
            }) : null;
        });
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var externalChange = true;
        (0, $hXmfK.watch)(model, function(v) {
            if (!externalChange) {
                // prevent hue shift from rgb conversion inaccuracy
                externalChange = true;
                return;
            }
            if (!v) return;
            hue.value = v.h;
        }, {
            immediate: true
        });
        var updateColor = function(hsva) {
            externalChange = false;
            hue.value = hsva.h;
            model.value = hsva;
        };
        (0, $bu8yf.onBeforeMount)(function() {
            if (!props.modes.includes(mode.value)) mode.value = props.modes[0];
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VSlider: {
                color: undefined,
                trackColor: undefined,
                trackFillColor: undefined
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var pickerProps = (0, $3a810783e3364626$export$37f35d9b6bd5d714).filterProps(props);
            var _currentColor_value;
            return (0, $bu8yf.createVNode)((0, $3a810783e3364626$export$37f35d9b6bd5d714), (0, $bu8yf.mergeProps)(pickerProps, {
                "class": [
                    'v-color-picker',
                    rtlClasses.value,
                    props["class"]
                ],
                style: [
                    {
                        '--v-color-picker-color-hsv': (0, $7eae58fcc02fc7e9$export$25aeffa982c279d7)((0, $emQHU._)((0, $iT0je._)({}, (_currentColor_value = currentColor.value) !== null && _currentColor_value !== void 0 ? _currentColor_value : (0, $bb05b83aabe1734e$export$8b018767dd6f3cea)), {
                            a: 1
                        }))
                    },
                    props.style
                ]
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        !props.hideCanvas && (0, $bu8yf.createVNode)((0, $f068250296a129b8$export$5142c1b9e4f0ab2e), {
                            key: "canvas",
                            color: currentColor.value,
                            "onUpdate:color": updateColor,
                            disabled: props.disabled,
                            dotSize: props.dotSize,
                            width: props.width,
                            height: props.canvasHeight
                        }, null),
                        (!props.hideSliders || !props.hideInputs) && (0, $bu8yf.createElementVNode)("div", {
                            key: "controls",
                            "class": "v-color-picker__controls"
                        }, [
                            !props.hideSliders && (0, $bu8yf.createVNode)((0, $0055d21cca4ca049$export$82b96236d6e48b4a), {
                                key: "preview",
                                color: currentColor.value,
                                "onUpdate:color": updateColor,
                                hideAlpha: !mode.value.endsWith('a'),
                                disabled: props.disabled
                            }, null),
                            !props.hideInputs && (0, $bu8yf.createVNode)((0, $1a0edc8a329a23f8$export$85684b51105c3c4c), {
                                key: "edit",
                                modes: props.modes,
                                mode: mode.value,
                                "onUpdate:mode": function(m) {
                                    return mode.value = m;
                                },
                                color: currentColor.value,
                                "onUpdate:color": updateColor,
                                disabled: props.disabled
                            }, null)
                        ]),
                        props.showSwatches && (0, $bu8yf.createVNode)((0, $35544e2f045c52d7$export$d9ba9354ad14b89d), {
                            key: "swatches",
                            color: currentColor.value,
                            "onUpdate:color": updateColor,
                            maxHeight: props.swatchesMaxHeight,
                            swatches: props.swatches,
                            disabled: props.disabled
                        }, null)
                    ]);
                }
            }));
        });
        return {};
    }
});




var $2b9dfb6933d988f2$exports = {};

$parcel$export($2b9dfb6933d988f2$exports, "VCombobox", function () { return $745ddfdc6f794269$export$8bb5629127e0cc34; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");























var $745ddfdc6f794269$export$cdb4b7fe6cafd6c6 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: {
        type: Boolean,
        "default": true
    },
    delimiters: Array
}, (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $416a51876874f600$export$c210933f6eecdb37)({
    hideNoData: true,
    returnObject: true
}), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9193e20196e963bf$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: false
})), 'VCombobox');
var $745ddfdc6f794269$export$8bb5629127e0cc34 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCombobox',
    props: $745ddfdc6f794269$export$cdb4b7fe6cafd6c6(),
    emits: {
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        'update:search': function(value) {
            return true;
        },
        'update:menu': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var _model_value_;
        var emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var vTextFieldRef = (0, $hXmfK.ref)();
        var isFocused = (0, $hXmfK.shallowRef)(false);
        var isPristine = (0, $hXmfK.shallowRef)(true);
        var listHasFocus = (0, $hXmfK.shallowRef)(false);
        var vMenuRef = (0, $hXmfK.ref)();
        var vVirtualScrollRef = (0, $hXmfK.ref)();
        var selectionIndex = (0, $hXmfK.shallowRef)(-1);
        var cleared = false;
        var _useItems = (0, $52b7ed45bf07e834$export$7bfdd97581ca93c)(props), items = _useItems.items, transformIn = _useItems.transformIn, transformOut = _useItems.transformOut;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            var _vTextFieldRef_value;
            return (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', [], function(v) {
            return transformIn((0, $31779689cfd5da50$export$76411cac38121ecb)(v));
        }, function(v) {
            var transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        var form = (0, $04771d0544148a45$export$87c0cf8eb5a167e0)(props);
        var hasChips = (0, $hXmfK.computed)(function() {
            return !!(props.chips || slots.chip);
        });
        var hasSelectionSlot = (0, $hXmfK.computed)(function() {
            return hasChips.value || !!slots.selection;
        });
        var _model_value__title;
        var _search = (0, $hXmfK.shallowRef)(!props.multiple && !hasSelectionSlot.value ? (_model_value__title = (_model_value_ = model.value[0]) === null || _model_value_ === void 0 ? void 0 : _model_value_.title) !== null && _model_value__title !== void 0 ? _model_value__title : '' : '');
        var search = (0, $hXmfK.computed)({
            get: function() {
                return _search.value;
            },
            set: function(val) {
                var _props_delimiters;
                _search.value = val !== null && val !== void 0 ? val : '';
                if (!props.multiple && !hasSelectionSlot.value) {
                    model.value = [
                        (0, $52b7ed45bf07e834$export$ef3b10464ff5e4ec)(props, val)
                    ];
                    (0, $bu8yf.nextTick)(function() {
                        var _vVirtualScrollRef_value;
                        return (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(0);
                    });
                }
                if (val && props.multiple && ((_props_delimiters = props.delimiters) === null || _props_delimiters === void 0 ? void 0 : _props_delimiters.length)) {
                    var values = val.split(new RegExp("(?:".concat(props.delimiters.join('|'), ")+")));
                    if (values.length > 1) {
                        values.forEach(function(v) {
                            v = v.trim();
                            if (v) select((0, $52b7ed45bf07e834$export$ef3b10464ff5e4ec)(props, v));
                        });
                        _search.value = '';
                    }
                }
                if (!val) selectionIndex.value = -1;
                isPristine.value = !val;
            }
        });
        var counterValue = (0, $hXmfK.computed)(function() {
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : props.multiple ? model.value.length : search.value.length;
        });
        var _useFilter = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, items, function() {
            return isPristine.value ? '' : search.value;
        }), filteredItems = _useFilter.filteredItems, getMatches = _useFilter.getMatches;
        var displayItems = (0, $hXmfK.computed)(function() {
            if (props.hideSelected) return filteredItems.value.filter(function(filteredItem) {
                return !model.value.some(function(s) {
                    return s.value === filteredItem.value;
                });
            });
            return filteredItems.value;
        });
        var menuDisabled = (0, $hXmfK.computed)(function() {
            return props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value;
        });
        var _menu = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'menu');
        var menu = (0, $hXmfK.computed)({
            get: function() {
                return _menu.value;
            },
            set: function(v) {
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        var label = (0, $hXmfK.toRef)(function() {
            return menu.value ? props.closeText : props.openText;
        });
        (0, $hXmfK.watch)(_search, function(value) {
            if (cleared) // wait for clear to finish, VTextField sets _search to null
            // then search computed triggers and updates _search to ''
            (0, $bu8yf.nextTick)(function() {
                return cleared = false;
            });
            else if (isFocused.value && !menu.value) menu.value = true;
            emit('update:search', value);
        });
        (0, $hXmfK.watch)(model, function(value) {
            var _value_;
            var _value__title;
            if (!props.multiple && !hasSelectionSlot.value) _search.value = (_value__title = (_value_ = value[0]) === null || _value_ === void 0 ? void 0 : _value_.title) !== null && _value__title !== void 0 ? _value__title : '';
        });
        var selectedValues = (0, $hXmfK.computed)(function() {
            return model.value.map(function(selection) {
                return selection.value;
            });
        });
        var highlightFirst = (0, $hXmfK.computed)(function() {
            var _displayItems_value_;
            var selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === ((_displayItems_value_ = displayItems.value[0]) === null || _displayItems_value_ === void 0 ? void 0 : _displayItems_value_.title);
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        var listRef = (0, $hXmfK.ref)();
        var listEvents = (0, $1aaec02719422793$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            cleared = true;
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            var _vTextFieldRef_value;
            if ((0, $31779689cfd5da50$export$d9d503bf19df5a70)(e) || e.key === 'Backspace') (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        // eslint-disable-next-line complexity
        function onKeydown(e) {
            var _vTextFieldRef_value, _listRef_value;
            if ((0, $31779689cfd5da50$export$af97bfee12e57e9c)(e) || form.isReadonly.value) return;
            var selectionStart = (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.selectionStart;
            var length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if ([
                'Enter',
                'Escape',
                'Tab'
            ].includes(e.key)) {
                if (highlightFirst.value && [
                    'Enter',
                    'Tab'
                ].includes(e.key) && !model.value.some(function(_ref2) {
                    var value = _ref2.value;
                    return value === displayItems.value[0].value;
                })) select(filteredItems.value[0]);
                isPristine.value = true;
            }
            if (e.key === 'ArrowDown' && highlightFirst.value) (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('next');
            if (e.key === 'Enter' && search.value) {
                select((0, $52b7ed45bf07e834$export$ef3b10464ff5e4ec)(props, search.value));
                if (hasSelectionSlot.value) _search.value = '';
            }
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    var originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                var prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    var _vTextFieldRef_value1;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value1 = vTextFieldRef.value) === null || _vTextFieldRef_value1 === void 0 ? void 0 : _vTextFieldRef_value1.setSelectionRange(search.value.length, search.value.length);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                var next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    var _vTextFieldRef_value2;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value2 = vTextFieldRef.value) === null || _vTextFieldRef_value2 === void 0 ? void 0 : _vTextFieldRef_value2.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $31779689cfd5da50$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) {
                var _vTextFieldRef_value;
                isPristine.value = true;
                (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
            }
        }
        /** @param set - null means toggle */ function select(item) {
            var set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                var index = model.value.findIndex(function(selection) {
                    return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(selection.value, item.value);
                });
                var add = set == null ? !~index : set;
                if (~index) {
                    var value = add ? (0, $7WNf6._)(model.value).concat([
                        item
                    ]) : (0, $7WNf6._)(model.value);
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = (0, $7WNf6._)(model.value).concat([
                    item
                ]);
                if (props.clearOnSelect) search.value = '';
            } else {
                var add1 = set !== false;
                model.value = add1 ? [
                    item
                ] : [];
                _search.value = add1 && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $bu8yf.nextTick)(function() {
                    menu.value = false;
                    isPristine.value = true;
                });
            }
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(function() {
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onUpdateModelValue(v) {
            if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
        }
        (0, $hXmfK.watch)(isFocused, function(val, oldVal) {
            if (val || val === oldVal) return;
            selectionIndex.value = -1;
            menu.value = false;
            if (search.value) {
                if (props.multiple) {
                    select((0, $52b7ed45bf07e834$export$ef3b10464ff5e4ec)(props, search.value));
                    return;
                }
                if (!hasSelectionSlot.value) return;
                if (model.value.some(function(_ref3) {
                    var title = _ref3.title;
                    return title === search.value;
                })) _search.value = '';
                else select((0, $52b7ed45bf07e834$export$ef3b10464ff5e4ec)(props, search.value));
            }
        });
        (0, $hXmfK.watch)(menu, function() {
            if (!props.hideSelected && menu.value && model.value.length) {
                var index = displayItems.value.findIndex(function(item) {
                    return model.value.some(function(s) {
                        return (props.valueComparator || (0, $31779689cfd5da50$export$9cb4719e2e525b7a))(s.value, item.value);
                    });
                });
                (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(function() {
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $hXmfK.watch)(function() {
            return props.items;
        }, function(newVal, oldVal) {
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            var isDirty = model.value.length > 0;
            var textFieldProps = (0, $9193e20196e963bf$export$d591c92dea965c28).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $9193e20196e963bf$export$d591c92dea965c28), (0, $bu8yf.mergeProps)({
                ref: vTextFieldRef
            }, textFieldProps, {
                modelValue: search.value,
                "onUpdate:modelValue": [
                    function($event) {
                        return search.value = $event;
                    },
                    onUpdateModelValue
                ],
                focused: isFocused.value,
                "onUpdate:focused": function($event) {
                    return isFocused.value = $event;
                },
                validationValue: model.externalValue,
                counterValue: counterValue.value,
                dirty: isDirty,
                "class": [
                    'v-combobox',
                    (0, $cqEAj._)({
                        'v-combobox--active-menu': menu.value,
                        'v-combobox--chips': !!props.chips,
                        'v-combobox--selection-slot': !!hasSelectionSlot.value,
                        'v-combobox--selecting-index': selectionIndex.value > -1
                    }, "v-combobox--".concat(props.multiple ? 'multiple' : 'single'), true),
                    props["class"]
                ],
                style: props.style,
                readonly: form.isReadonly.value,
                placeholder: isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                onKeydown: onKeydown
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $7cf2e5a7271d5533$export$a347888d6b8f252a), (0, $bu8yf.mergeProps)({
                            ref: vMenuRef,
                            modelValue: menu.value,
                            "onUpdate:modelValue": function($event) {
                                return menu.value = $event;
                            },
                            activator: "parent",
                            contentClass: "v-combobox__content",
                            disabled: menuDisabled.value,
                            eager: props.eager,
                            maxHeight: 310,
                            openOnClick: false,
                            closeOnContentClick: false,
                            transition: props.transition,
                            onAfterEnter: onAfterEnter,
                            onAfterLeave: onAfterLeave
                        }, props.menuProps), {
                            "default": function() {
                                var _props_itemColor;
                                return [
                                    hasList && (0, $bu8yf.createVNode)((0, $c46d6e9c2ddd50d5$export$3b010b0401837103), (0, $bu8yf.mergeProps)({
                                        ref: listRef,
                                        filterable: true,
                                        selected: selectedValues.value,
                                        selectStrategy: props.multiple ? 'independent' : 'single-independent',
                                        onMousedown: function(e) {
                                            return e.preventDefault();
                                        },
                                        onKeydown: onListKeydown,
                                        onFocusin: onFocusin,
                                        onFocusout: onFocusout,
                                        tabindex: "-1",
                                        "aria-live": "polite",
                                        color: (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        "default": function() {
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), {
                                                    key: "no-data",
                                                    title: t(props.noDataText)
                                                }, null)),
                                                (0, $bu8yf.createVNode)((0, $af9026073940257e$export$bdb136bf2d9028a4), {
                                                    ref: vVirtualScrollRef,
                                                    renderless: true,
                                                    items: displayItems.value,
                                                    itemKey: "value"
                                                }, {
                                                    "default": function(_ref4) {
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        var item = _ref4.item, index = _ref4.index, itemRef = _ref4.itemRef;
                                                        var itemProps = (0, $bu8yf.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            active: highlightFirst.value && index === 0 ? true : undefined,
                                                            onClick: function() {
                                                                return select(item, null);
                                                            }
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "divider-".concat(index)
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $bu8yf.createVNode)((0, $c18be527f2406595$export$70c4aba7bf48e22a), (0, $bu8yf.mergeProps)(item.props, {
                                                            key: "subheader-".concat(index)
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), (0, $bu8yf.mergeProps)(itemProps, {
                                                            role: "option"
                                                        }), {
                                                            prepend: function(_ref5) {
                                                                var isSelected = _ref5.isSelected;
                                                                return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                                                        key: item.value,
                                                                        modelValue: isSelected,
                                                                        ripple: false,
                                                                        tabindex: "-1"
                                                                    }, null) : undefined,
                                                                    item.props.prependAvatar && (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                                                                        image: item.props.prependAvatar
                                                                    }, null),
                                                                    item.props.prependIcon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                                        icon: item.props.prependIcon
                                                                    }, null)
                                                                ]);
                                                            },
                                                            title: function() {
                                                                var _getMatches;
                                                                return isPristine.value ? item.title : (0, $d8173a2b878f034f$export$71650bdcd27abbc4)('v-combobox', item.title, (_getMatches = getMatches(item)) === null || _getMatches === void 0 ? void 0 : _getMatches.title);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map(function(item, index) {
                            var onChipClose = function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            };
                            var slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown: function(e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown: function(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            var hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            var slotContent = hasSlot ? (0, $31779689cfd5da50$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $bu8yf.createElementVNode)("div", {
                                key: item.value,
                                "class": (0, $d8jBh.normalizeClass)([
                                    'v-combobox__selection',
                                    index === selectionIndex.value && [
                                        'v-combobox__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                style: (0, $d8jBh.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $bu8yf.createVNode)((0, $2f12dac67cff7cbd$export$1b5fab12cd17b4fb), (0, $bu8yf.mergeProps)({
                                    key: "chip",
                                    closable: props.closableChips,
                                    size: "small",
                                    text: item.title,
                                    disabled: item.props.disabled
                                }, slotProps), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                    key: "chip-defaults",
                                    defaults: {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    "default": function() {
                                        return [
                                            slotContent
                                        ];
                                    }
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-combobox__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $bu8yf.createElementVNode)("span", {
                                        "class": "v-combobox__selection-comma"
                                    }, [
                                        (0, $bu8yf.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    var _slots_appendinner;
                    var _slots_appendinner1, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_appendinner1 = slots['append-inner']) === null || _slots_appendinner1 === void 0 ? void 0 : (_slots_appendinner = _slots_appendinner1).call.apply(_slots_appendinner, [
                            slots
                        ].concat((0, $7WNf6._)(args))),
                        (!props.hideNoData || props.items.length) && props.menuIcon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            "class": "v-combobox__menu-icon",
                            color: (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            icon: props.menuIcon,
                            onMousedown: onMousedownMenuIcon,
                            onClick: (0, $31779689cfd5da50$export$8793edee2d425525),
                            "aria-label": t(label.value),
                            title: t(label.value),
                            tabindex: "-1"
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            selectionIndex: selectionIndex,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $1abf0f082d2e9484$exports = {};

$parcel$export($1abf0f082d2e9484$exports, "VConfirmEdit", function () { return $a9d28186a8bc49fe$export$1bc4c6f1c359537; });
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");




var $a9d28186a8bc49fe$export$8432eef2b93cb2e1 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    modelValue: null,
    color: String,
    cancelText: {
        type: String,
        "default": '$vuetify.confirmEdit.cancel'
    },
    okText: {
        type: String,
        "default": '$vuetify.confirmEdit.ok'
    },
    disabled: {
        type: [
            Boolean,
            Array
        ],
        "default": undefined
    },
    hideActions: Boolean
}, 'VConfirmEdit');
var $a9d28186a8bc49fe$export$1bc4c6f1c359537 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VConfirmEdit',
    props: $a9d28186a8bc49fe$export$8432eef2b93cb2e1(),
    emits: {
        cancel: function() {
            return true;
        },
        save: function(value) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var internalModel = (0, $hXmfK.ref)();
        (0, $bu8yf.watchEffect)(function() {
            internalModel.value = structuredClone((0, $hXmfK.toRaw)(model.value));
        });
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var isPristine = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$9cb4719e2e525b7a)(model.value, internalModel.value);
        });
        function isActionDisabled(action) {
            if (typeof props.disabled === 'boolean') return props.disabled;
            if (Array.isArray(props.disabled)) return props.disabled.includes(action);
            return isPristine.value;
        }
        var isSaveDisabled = (0, $hXmfK.computed)(function() {
            return isActionDisabled('save');
        });
        var isCancelDisabled = (0, $hXmfK.computed)(function() {
            return isActionDisabled('cancel');
        });
        function save() {
            model.value = internalModel.value;
            emit('save', internalModel.value);
        }
        function cancel() {
            internalModel.value = structuredClone((0, $hXmfK.toRaw)(model.value));
            emit('cancel');
        }
        function actions(actionsProps) {
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                    disabled: isCancelDisabled.value,
                    variant: "text",
                    color: props.color,
                    onClick: cancel,
                    text: t(props.cancelText)
                }, actionsProps), null),
                (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                    disabled: isSaveDisabled.value,
                    variant: "text",
                    color: props.color,
                    onClick: save,
                    text: t(props.okText)
                }, actionsProps), null)
            ]);
        }
        var actionsUsed = false;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                    model: internalModel,
                    save: save,
                    cancel: cancel,
                    isPristine: isPristine.value,
                    get actions () {
                        actionsUsed = true;
                        return actions;
                    }
                }),
                !props.hideActions && !actionsUsed && actions()
            ]);
        });
        return {
            save: save,
            cancel: cancel,
            isPristine: isPristine
        };
    }
});




var $b28fb13f89d3a894$exports = {};

$parcel$export($b28fb13f89d3a894$exports, "VCounter", function () { return $7ba1fb3b216974cf$export$45efeae449ff2094; });



var $5ad6a7c2a950f11b$exports = {};

$parcel$export($5ad6a7c2a950f11b$exports, "VDataIterator", function () { return $c2b4881bfcde62d9$export$be5a6c7bb6e0c13d; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

// Composables

var $7WNf6 = parcelRequire("7WNf6");

parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

var $2f4785e6f46b655c$export$a6d4f3c269410395 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    expandOnClick: Boolean,
    showExpand: Boolean,
    expanded: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, 'DataTable-expand');
var $2f4785e6f46b655c$export$2583f5f5b5e13a84 = Symbol["for"]('vuetify:datatable:expanded');
function $2f4785e6f46b655c$export$6c2637d154b76687(props) {
    var expandOnClick = (0, $hXmfK.toRef)(function() {
        return props.expandOnClick;
    });
    var expanded = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'expanded', props.expanded, function(v) {
        return new Set(v);
    }, function(v) {
        return (0, $7WNf6._)(v.values());
    });
    function expand(item, value) {
        var newExpanded = new Set(expanded.value);
        if (!value) newExpanded["delete"](item.value);
        else newExpanded.add(item.value);
        expanded.value = newExpanded;
    }
    function isExpanded(item) {
        return expanded.value.has(item.value);
    }
    function toggleExpand(item) {
        expand(item, !isExpanded(item));
    }
    var data = {
        expand: expand,
        expanded: expanded,
        expandOnClick: expandOnClick,
        isExpanded: isExpanded,
        toggleExpand: toggleExpand
    };
    (0, $bu8yf.provide)($2f4785e6f46b655c$export$2583f5f5b5e13a84, data);
    return data;
}
function $2f4785e6f46b655c$export$7d3f3306ac4d54ef() {
    var data = (0, $bu8yf.inject)($2f4785e6f46b655c$export$2583f5f5b5e13a84);
    if (!data) throw new Error('foo');
    return data;
}


// Composables

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $4dfcff052151cced$export$406ee928c389045b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    groupBy: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, 'DataTable-group');
var $4dfcff052151cced$var$VDataTableGroupSymbol = Symbol["for"]('vuetify:data-table-group');
function $4dfcff052151cced$export$543cf685fafb29db(props) {
    var groupBy = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'groupBy');
    return {
        groupBy: groupBy
    };
}
function $4dfcff052151cced$export$93a5542df6d97bc8(options) {
    var disableSort = options.disableSort, groupBy = options.groupBy, sortBy = options.sortBy;
    var opened = (0, $hXmfK.ref)(new Set());
    var sortByWithGroups = (0, $hXmfK.computed)(function() {
        return groupBy.value.map(function(val) {
            var _val_order;
            return (0, $emQHU._)((0, $iT0je._)({}, val), {
                order: (_val_order = val.order) !== null && _val_order !== void 0 ? _val_order : false
            });
        }).concat((disableSort === null || disableSort === void 0 ? void 0 : disableSort.value) ? [] : sortBy.value);
    });
    function isGroupOpen(group) {
        return opened.value.has(group.id);
    }
    function toggleGroup(group) {
        var newOpened = new Set(opened.value);
        if (!isGroupOpen(group)) newOpened.add(group.id);
        else newOpened["delete"](group.id);
        opened.value = newOpened;
    }
    function extractRows(items) {
        function dive(group) {
            var _arr;
            var arr = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = group.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if ('type' in item && item.type === 'group') (_arr = arr).push.apply(_arr, (0, $7WNf6._)(dive(item)));
                    else arr.push(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return (0, $7WNf6._)(new Set(arr));
        }
        return dive({
            type: 'group',
            items: items,
            id: 'dummy',
            key: 'dummy',
            value: 'dummy',
            depth: 0
        });
    }
    // onBeforeMount(() => {
    //   for (const key of groupedItems.value.keys()) {
    //     opened.value.add(key)
    //   }
    // })
    var data = {
        sortByWithGroups: sortByWithGroups,
        toggleGroup: toggleGroup,
        opened: opened,
        groupBy: groupBy,
        extractRows: extractRows,
        isGroupOpen: isGroupOpen
    };
    (0, $bu8yf.provide)($4dfcff052151cced$var$VDataTableGroupSymbol, data);
    return data;
}
function $4dfcff052151cced$export$c4ec754551fa3ff4() {
    var data = (0, $bu8yf.inject)($4dfcff052151cced$var$VDataTableGroupSymbol);
    if (!data) throw new Error('Missing group!');
    return data;
}
function $4dfcff052151cced$var$groupItemsByProperty(items, groupBy) {
    if (!items.length) return [];
    var groups = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var value = (0, $31779689cfd5da50$export$f5474208cafa7b66)(item.raw, groupBy);
            if (!groups.has(value)) groups.set(value, []);
            groups.get(value).push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return groups;
}
function $4dfcff052151cced$var$groupItems(items, groupBy) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root';
    if (!groupBy.length) return [];
    var groupedItems = $4dfcff052151cced$var$groupItemsByProperty(items, groupBy[0]);
    var groups = [];
    var rest = groupBy.slice(1);
    groupedItems.forEach(function(items, value) {
        var key = groupBy[0];
        var id = "".concat(prefix, "_").concat(key, "_").concat(value);
        groups.push({
            depth: depth,
            id: id,
            key: key,
            value: value,
            items: rest.length ? $4dfcff052151cced$var$groupItems(items, rest, depth + 1, id) : items,
            type: 'group'
        });
    });
    return groups;
}
function $4dfcff052151cced$var$flattenItems(items, opened) {
    var flatItems = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            // TODO: make this better
            if ('type' in item && item.type === 'group') {
                var _flatItems;
                if (item.value != null) flatItems.push(item);
                if (opened.has(item.id) || item.value == null) (_flatItems = flatItems).push.apply(_flatItems, (0, $7WNf6._)($4dfcff052151cced$var$flattenItems(item.items, opened)));
            } else flatItems.push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return flatItems;
}
function $4dfcff052151cced$export$1d90b49b81ed368a(items, groupBy, opened) {
    var flatItems = (0, $hXmfK.computed)(function() {
        if (!groupBy.value.length) return items.value;
        var groupedItems = $4dfcff052151cced$var$groupItems(items.value, groupBy.value.map(function(item) {
            return item.key;
        }));
        return $4dfcff052151cced$var$flattenItems(groupedItems, opened.value);
    });
    return {
        flatItems: flatItems
    };
}


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

function $8457cdf7ca26e52e$export$b8ae39f344200a7d(_ref) {
    var page = _ref.page, itemsPerPage = _ref.itemsPerPage, sortBy = _ref.sortBy, groupBy = _ref.groupBy, search = _ref.search;
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('VDataTable');
    var options = function() {
        return {
            page: page.value,
            itemsPerPage: itemsPerPage.value,
            sortBy: sortBy.value,
            groupBy: groupBy.value,
            search: search.value
        };
    };
    var oldOptions = null;
    (0, $hXmfK.watch)(options, function(value) {
        if ((0, $31779689cfd5da50$export$9cb4719e2e525b7a)(oldOptions, value)) return;
        // Reset page when searching
        if (oldOptions && oldOptions.search !== value.search) page.value = 1;
        vm.emit('update:options', value);
        oldOptions = value;
    }, {
        deep: true,
        immediate: true
    });
}


// Composables

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $515a30edd8060cfd$export$a02e477b3b971dbd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    page: {
        type: [
            Number,
            String
        ],
        "default": 1
    },
    itemsPerPage: {
        type: [
            Number,
            String
        ],
        "default": 10
    }
}, 'DataTable-paginate');
var $515a30edd8060cfd$var$VDataTablePaginationSymbol = Symbol["for"]('vuetify:data-table-pagination');
function $515a30edd8060cfd$export$7f3155e3cda021fd(props) {
    var page = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'page', undefined, function(value) {
        return Number(value !== null && value !== void 0 ? value : 1);
    });
    var itemsPerPage = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'itemsPerPage', undefined, function(value) {
        return Number(value !== null && value !== void 0 ? value : 10);
    });
    return {
        page: page,
        itemsPerPage: itemsPerPage
    };
}
function $515a30edd8060cfd$export$5d615e9f3908e3a9(options) {
    var page = options.page, itemsPerPage = options.itemsPerPage, itemsLength = options.itemsLength;
    var startIndex = (0, $hXmfK.computed)(function() {
        if (itemsPerPage.value === -1) return 0;
        return itemsPerPage.value * (page.value - 1);
    });
    var stopIndex = (0, $hXmfK.computed)(function() {
        if (itemsPerPage.value === -1) return itemsLength.value;
        return Math.min(itemsLength.value, startIndex.value + itemsPerPage.value);
    });
    var pageCount = (0, $hXmfK.computed)(function() {
        if (itemsPerPage.value === -1 || itemsLength.value === 0) return 1;
        return Math.ceil(itemsLength.value / itemsPerPage.value);
    });
    // Don't run immediately, items may not have been loaded yet: #17966
    (0, $hXmfK.watch)([
        page,
        pageCount
    ], function() {
        if (page.value > pageCount.value) page.value = pageCount.value;
    });
    function setItemsPerPage(value) {
        itemsPerPage.value = value;
        page.value = 1;
    }
    function nextPage() {
        page.value = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(page.value + 1, 1, pageCount.value);
    }
    function prevPage() {
        page.value = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(page.value - 1, 1, pageCount.value);
    }
    function setPage(value) {
        page.value = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(value, 1, pageCount.value);
    }
    var data = {
        page: page,
        itemsPerPage: itemsPerPage,
        startIndex: startIndex,
        stopIndex: stopIndex,
        pageCount: pageCount,
        itemsLength: itemsLength,
        nextPage: nextPage,
        prevPage: prevPage,
        setPage: setPage,
        setItemsPerPage: setItemsPerPage
    };
    (0, $bu8yf.provide)($515a30edd8060cfd$var$VDataTablePaginationSymbol, data);
    return data;
}
function $515a30edd8060cfd$export$f80c710216eae131() {
    var data = (0, $bu8yf.inject)($515a30edd8060cfd$var$VDataTablePaginationSymbol);
    if (!data) throw new Error('Missing pagination!');
    return data;
}
function $515a30edd8060cfd$export$e196d5e55ca1e2d5(options) {
    var vm = (0, $f4cc842872cc2659$export$f13e630aa3915748)('usePaginatedItems');
    var items = options.items, startIndex = options.startIndex, stopIndex = options.stopIndex, itemsPerPage = options.itemsPerPage;
    var paginatedItems = (0, $hXmfK.computed)(function() {
        if (itemsPerPage.value <= 0) return items.value;
        return items.value.slice(startIndex.value, stopIndex.value);
    });
    (0, $hXmfK.watch)(paginatedItems, function(val) {
        vm.emit('update:currentItems', val);
    }, {
        immediate: true
    });
    return {
        paginatedItems: paginatedItems
    };
}


// Composables

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $3ee4b18c5d85bd4b$var$singleSelectStrategy = {
    showSelectAll: false,
    allSelected: function() {
        return [];
    },
    select: function(_ref) {
        var _items_;
        var items = _ref.items, value = _ref.value;
        return new Set(value ? [
            (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.value
        ] : []);
    },
    selectAll: function(_ref2) {
        var selected = _ref2.selected;
        return selected;
    }
};
var $3ee4b18c5d85bd4b$var$pageSelectStrategy = {
    showSelectAll: true,
    allSelected: function(_ref3) {
        var currentPage = _ref3.currentPage;
        return currentPage;
    },
    select: function(_ref4) {
        var items = _ref4.items, value = _ref4.value, selected = _ref4.selected;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (value) selected.add(item.value);
                else selected["delete"](item.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return selected;
    },
    selectAll: function(_ref5) {
        var value = _ref5.value, currentPage = _ref5.currentPage, selected = _ref5.selected;
        return $3ee4b18c5d85bd4b$var$pageSelectStrategy.select({
            items: currentPage,
            value: value,
            selected: selected
        });
    }
};
var $3ee4b18c5d85bd4b$var$allSelectStrategy = {
    showSelectAll: true,
    allSelected: function(_ref6) {
        var allItems = _ref6.allItems;
        return allItems;
    },
    select: function(_ref7) {
        var items = _ref7.items, value = _ref7.value, selected = _ref7.selected;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (value) selected.add(item.value);
                else selected["delete"](item.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return selected;
    },
    selectAll: function(_ref8) {
        var value = _ref8.value, allItems = _ref8.allItems, selected = _ref8.selected;
        return $3ee4b18c5d85bd4b$var$allSelectStrategy.select({
            items: allItems,
            value: value,
            selected: selected
        });
    }
};
var $3ee4b18c5d85bd4b$export$95e1272f163aea67 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    showSelect: Boolean,
    selectStrategy: {
        type: [
            String,
            Object
        ],
        "default": 'page'
    },
    modelValue: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    valueComparator: {
        type: Function,
        "default": (0, $31779689cfd5da50$export$9cb4719e2e525b7a)
    }
}, 'DataTable-select');
var $3ee4b18c5d85bd4b$export$d1c147632a3c0ba2 = Symbol["for"]('vuetify:data-table-selection');
function $3ee4b18c5d85bd4b$export$c7142f0d6d0f341b(props, _ref9) {
    var allItems = _ref9.allItems, currentPage = _ref9.currentPage;
    var selected = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, function(v) {
        return new Set((0, $31779689cfd5da50$export$76411cac38121ecb)(v).map(function(v) {
            var _allItems_value_find;
            var _allItems_value_find_value;
            return (_allItems_value_find_value = (_allItems_value_find = allItems.value.find(function(item) {
                return props.valueComparator(v, item.value);
            })) === null || _allItems_value_find === void 0 ? void 0 : _allItems_value_find.value) !== null && _allItems_value_find_value !== void 0 ? _allItems_value_find_value : v;
        }));
    }, function(v) {
        return (0, $7WNf6._)(v.values());
    });
    var allSelectable = (0, $hXmfK.computed)(function() {
        return allItems.value.filter(function(item) {
            return item.selectable;
        });
    });
    var currentPageSelectable = (0, $hXmfK.computed)(function() {
        return currentPage.value.filter(function(item) {
            return item.selectable;
        });
    });
    var selectStrategy = (0, $hXmfK.computed)(function() {
        if ((0, $3KZcf._)(props.selectStrategy) === 'object') return props.selectStrategy;
        switch(props.selectStrategy){
            case 'single':
                return $3ee4b18c5d85bd4b$var$singleSelectStrategy;
            case 'all':
                return $3ee4b18c5d85bd4b$var$allSelectStrategy;
            case 'page':
            default:
                return $3ee4b18c5d85bd4b$var$pageSelectStrategy;
        }
    });
    var lastSelectedIndex = (0, $hXmfK.shallowRef)(null);
    function isSelected(items) {
        return (0, $31779689cfd5da50$export$76411cac38121ecb)(items).every(function(item) {
            return selected.value.has(item.value);
        });
    }
    function isSomeSelected(items) {
        return (0, $31779689cfd5da50$export$76411cac38121ecb)(items).some(function(item) {
            return selected.value.has(item.value);
        });
    }
    function select(items, value) {
        var newSelected = selectStrategy.value.select({
            items: items,
            value: value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    function toggleSelect(item, index, event) {
        var items = [];
        index = index !== null && index !== void 0 ? index : currentPage.value.findIndex(function(i) {
            return i.value === item.value;
        });
        if (props.selectStrategy !== 'single' && (event === null || event === void 0 ? void 0 : event.shiftKey) && lastSelectedIndex.value !== null) {
            var _items;
            var _sort = (0, $32TW8._)([
                lastSelectedIndex.value,
                index
            ].sort(function(a, b) {
                return a - b;
            }), 2), start = _sort[0], end = _sort[1];
            (_items = items).push.apply(_items, (0, $7WNf6._)(currentPage.value.slice(start, end + 1).filter(function(item) {
                return item.selectable;
            })));
        } else {
            items.push(item);
            lastSelectedIndex.value = index;
        }
        select(items, !isSelected([
            item
        ]));
    }
    function selectAll(value) {
        var newSelected = selectStrategy.value.selectAll({
            value: value,
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    var someSelected = (0, $hXmfK.computed)(function() {
        return selected.value.size > 0;
    });
    var allSelected = (0, $hXmfK.computed)(function() {
        var items = selectStrategy.value.allSelected({
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value
        });
        return !!items.length && isSelected(items);
    });
    var showSelectAll = (0, $hXmfK.toRef)(function() {
        return selectStrategy.value.showSelectAll;
    });
    var data = {
        toggleSelect: toggleSelect,
        select: select,
        selectAll: selectAll,
        isSelected: isSelected,
        isSomeSelected: isSomeSelected,
        someSelected: someSelected,
        allSelected: allSelected,
        showSelectAll: showSelectAll,
        lastSelectedIndex: lastSelectedIndex,
        selectStrategy: selectStrategy
    };
    (0, $bu8yf.provide)($3ee4b18c5d85bd4b$export$d1c147632a3c0ba2, data);
    return data;
}
function $3ee4b18c5d85bd4b$export$a97c3cc4bf1da1ca() {
    var data = (0, $bu8yf.inject)($3ee4b18c5d85bd4b$export$d1c147632a3c0ba2);
    if (!data) throw new Error('Missing selection!');
    return data;
}


// Composables

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $d6b7304528d4da19$export$944604c1e22b4d13 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    sortBy: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    customKeySort: Object,
    multiSort: Boolean,
    mustSort: Boolean
}, 'DataTable-sort');
var $d6b7304528d4da19$var$VDataTableSortSymbol = Symbol["for"]('vuetify:data-table-sort');
function $d6b7304528d4da19$export$10463693a2093403(props) {
    var sortBy = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'sortBy');
    var mustSort = (0, $hXmfK.toRef)(function() {
        return props.mustSort;
    });
    var multiSort = (0, $hXmfK.toRef)(function() {
        return props.multiSort;
    });
    return {
        sortBy: sortBy,
        mustSort: mustSort,
        multiSort: multiSort
    };
}
function $d6b7304528d4da19$export$ea3d4520bd5f18b7(options) {
    var sortBy = options.sortBy, mustSort = options.mustSort, multiSort = options.multiSort, page = options.page;
    var toggleSort = function(column) {
        if (column.key == null) return;
        var _sortBy_value_map;
        var newSortBy = (_sortBy_value_map = sortBy.value.map(function(x) {
            return (0, $iT0je._)({}, x);
        })) !== null && _sortBy_value_map !== void 0 ? _sortBy_value_map : [];
        var item = newSortBy.find(function(x) {
            return x.key === column.key;
        });
        if (!item) {
            if (multiSort.value) newSortBy.push({
                key: column.key,
                order: 'asc'
            });
            else newSortBy = [
                {
                    key: column.key,
                    order: 'asc'
                }
            ];
        } else if (item.order === 'desc') {
            if (mustSort.value && newSortBy.length === 1) item.order = 'asc';
            else newSortBy = newSortBy.filter(function(x) {
                return x.key !== column.key;
            });
        } else item.order = 'desc';
        sortBy.value = newSortBy;
        if (page) page.value = 1;
    };
    function isSorted(column) {
        return !!sortBy.value.find(function(item) {
            return item.key === column.key;
        });
    }
    var data = {
        sortBy: sortBy,
        toggleSort: toggleSort,
        isSorted: isSorted
    };
    (0, $bu8yf.provide)($d6b7304528d4da19$var$VDataTableSortSymbol, data);
    return data;
}
function $d6b7304528d4da19$export$6292515ceca0b297() {
    var data = (0, $bu8yf.inject)($d6b7304528d4da19$var$VDataTableSortSymbol);
    if (!data) throw new Error('Missing sort!');
    return data;
}
function $d6b7304528d4da19$export$3e492f5677b6952c(props, items, sortBy, options) {
    var locale = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)();
    var sortedItems = (0, $hXmfK.computed)(function() {
        var _options_sortFunctions, _options_sortRawFunctions;
        if (!sortBy.value.length) return items.value;
        return $d6b7304528d4da19$export$6b06fb9375cf2225(items.value, sortBy.value, locale.current.value, {
            transform: options === null || options === void 0 ? void 0 : options.transform,
            sortFunctions: (0, $iT0je._)({}, props.customKeySort, options === null || options === void 0 ? void 0 : (_options_sortFunctions = options.sortFunctions) === null || _options_sortFunctions === void 0 ? void 0 : _options_sortFunctions.value),
            sortRawFunctions: options === null || options === void 0 ? void 0 : (_options_sortRawFunctions = options.sortRawFunctions) === null || _options_sortRawFunctions === void 0 ? void 0 : _options_sortRawFunctions.value
        });
    });
    return {
        sortedItems: sortedItems
    };
}
function $d6b7304528d4da19$export$6b06fb9375cf2225(items, sortByItems, locale, options) {
    var stringCollator = new Intl.Collator(locale, {
        sensitivity: 'accent',
        usage: 'sort'
    });
    var transformedItems = items.map(function(item) {
        return [
            item,
            (options === null || options === void 0 ? void 0 : options.transform) ? options.transform(item) : item
        ];
    });
    return transformedItems.sort(function(a, b) {
        for(var i = 0; i < sortByItems.length; i++){
            var _options_sortRawFunctions, _options_sortFunctions;
            var hasCustomResult = false;
            var sortKey = sortByItems[i].key;
            var _sortByItems_i_order;
            var sortOrder = (_sortByItems_i_order = sortByItems[i].order) !== null && _sortByItems_i_order !== void 0 ? _sortByItems_i_order : 'asc';
            if (sortOrder === false) continue;
            var sortA = (0, $31779689cfd5da50$export$f5474208cafa7b66)(a[1], sortKey);
            var sortB = (0, $31779689cfd5da50$export$f5474208cafa7b66)(b[1], sortKey);
            var sortARaw = a[0].raw;
            var sortBRaw = b[0].raw;
            if (sortOrder === 'desc') {
                var ref;
                ref = [
                    sortB,
                    sortA
                ], sortA = ref[0], sortB = ref[1], ref;
                var ref1;
                ref1 = [
                    sortBRaw,
                    sortARaw
                ], sortARaw = ref1[0], sortBRaw = ref1[1], ref1;
            }
            if (options === null || options === void 0 ? void 0 : (_options_sortRawFunctions = options.sortRawFunctions) === null || _options_sortRawFunctions === void 0 ? void 0 : _options_sortRawFunctions[sortKey]) {
                var customResult = options.sortRawFunctions[sortKey](sortARaw, sortBRaw);
                if (customResult == null) continue;
                hasCustomResult = true;
                if (customResult) return customResult;
            }
            if (options === null || options === void 0 ? void 0 : (_options_sortFunctions = options.sortFunctions) === null || _options_sortFunctions === void 0 ? void 0 : _options_sortFunctions[sortKey]) {
                var customResult1 = options.sortFunctions[sortKey](sortA, sortB);
                if (customResult1 == null) continue;
                hasCustomResult = true;
                if (customResult1) return customResult1;
            }
            if (hasCustomResult) continue;
            // Dates should be compared numerically
            if (sortA instanceof Date && sortB instanceof Date) {
                sortA = sortA.getTime();
                sortB = sortB.getTime();
            }
            var ref2;
            ref2 = (0, $32TW8._)([
                sortA,
                sortB
            ].map(function(s) {
                return s != null ? s.toString().toLocaleLowerCase() : s;
            }), 2), sortA = ref2[0], sortB = ref2[1], ref2;
            if (sortA !== sortB) {
                if ((0, $31779689cfd5da50$export$dd1bc94b04021eeb)(sortA) && (0, $31779689cfd5da50$export$dd1bc94b04021eeb)(sortB)) return 0;
                if ((0, $31779689cfd5da50$export$dd1bc94b04021eeb)(sortA)) return -1;
                if ((0, $31779689cfd5da50$export$dd1bc94b04021eeb)(sortB)) return 1;
                if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
                return stringCollator.compare(sortA, sortB);
            }
        }
        return 0;
    }).map(function(_ref) {
        var _$_ref = (0, $32TW8._)(_ref, 1), item = _$_ref[0];
        return item;
    });
}


// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $27251095980faa85$export$a384df6acd57afc3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        "default": 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        "default": null
    },
    returnObject: Boolean
}, 'DataIterator-items');
function $27251095980faa85$export$ef3b10464ff5e4ec(props, item) {
    var value = props.returnObject ? item : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue);
    var selectable = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    return {
        type: 'item',
        value: value,
        selectable: selectable,
        raw: item
    };
}
function $27251095980faa85$export$f8e983a9ac6ba971(props, items) {
    var array = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            array.push($27251095980faa85$export$ef3b10464ff5e4ec(props, item));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return array;
}
function $27251095980faa85$export$a0c659b63ecb3159(props) {
    var items = (0, $hXmfK.computed)(function() {
        return $27251095980faa85$export$f8e983a9ac6ba971(props, props.items);
    });
    return {
        items: items
    };
}









var $c2b4881bfcde62d9$export$aa9ffd475fbf48dc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    search: String,
    loading: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $27251095980faa85$export$a384df6acd57afc3)(), (0, $3ee4b18c5d85bd4b$export$95e1272f163aea67)(), (0, $d6b7304528d4da19$export$944604c1e22b4d13)(), (0, $515a30edd8060cfd$export$a02e477b3b971dbd)({
    itemsPerPage: 5
}), (0, $2f4785e6f46b655c$export$a6d4f3c269410395)(), (0, $4dfcff052151cced$export$406ee928c389045b)(), (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $01a421c271ad0485$export$13ce8c44634b158c),
        hideOnLeave: true
    }
})), 'VDataIterator');
var $c2b4881bfcde62d9$export$be5a6c7bb6e0c13d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataIterator',
    props: $c2b4881bfcde62d9$export$aa9ffd475fbf48dc(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:groupBy': function(value) {
            return true;
        },
        'update:page': function(value) {
            return true;
        },
        'update:itemsPerPage': function(value) {
            return true;
        },
        'update:sortBy': function(value) {
            return true;
        },
        'update:options': function(value) {
            return true;
        },
        'update:expanded': function(value) {
            return true;
        },
        'update:currentItems': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var groupBy = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'groupBy');
        var search = (0, $hXmfK.toRef)(function() {
            return props.search;
        });
        var items = (0, $27251095980faa85$export$a0c659b63ecb3159)(props).items;
        var filteredItems = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, items, search, {
            transform: function(item) {
                return item.raw;
            }
        }).filteredItems;
        var _createSort = (0, $d6b7304528d4da19$export$10463693a2093403)(props), sortBy = _createSort.sortBy, multiSort = _createSort.multiSort, mustSort = _createSort.mustSort;
        var _createPagination = (0, $515a30edd8060cfd$export$7f3155e3cda021fd)(props), page = _createPagination.page, itemsPerPage = _createPagination.itemsPerPage;
        var toggleSort = (0, $d6b7304528d4da19$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        }).toggleSort;
        var _provideGroupBy = (0, $4dfcff052151cced$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy
        }), sortByWithGroups = _provideGroupBy.sortByWithGroups, opened = _provideGroupBy.opened, extractRows = _provideGroupBy.extractRows, isGroupOpen = _provideGroupBy.isGroupOpen, toggleGroup = _provideGroupBy.toggleGroup;
        var sortedItems = (0, $d6b7304528d4da19$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: function(item) {
                return item.raw;
            }
        }).sortedItems;
        var flatItems = (0, $4dfcff052151cced$export$1d90b49b81ed368a)(sortedItems, groupBy, opened).flatItems;
        var itemsLength = (0, $hXmfK.toRef)(function() {
            return flatItems.value.length;
        });
        var _providePagination = (0, $515a30edd8060cfd$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        }), startIndex = _providePagination.startIndex, stopIndex = _providePagination.stopIndex, pageCount = _providePagination.pageCount, prevPage = _providePagination.prevPage, nextPage = _providePagination.nextPage, setItemsPerPage = _providePagination.setItemsPerPage, setPage = _providePagination.setPage;
        var paginatedItems = (0, $515a30edd8060cfd$export$e196d5e55ca1e2d5)({
            items: flatItems,
            startIndex: startIndex,
            stopIndex: stopIndex,
            itemsPerPage: itemsPerPage
        }).paginatedItems;
        var paginatedItemsWithoutGroups = (0, $hXmfK.computed)(function() {
            return extractRows(paginatedItems.value);
        });
        var _provideSelection = (0, $3ee4b18c5d85bd4b$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: paginatedItemsWithoutGroups
        }), isSelected = _provideSelection.isSelected, select = _provideSelection.select, selectAll = _provideSelection.selectAll, toggleSelect = _provideSelection.toggleSelect;
        var _provideExpanded = (0, $2f4785e6f46b655c$export$6c2637d154b76687)(props), isExpanded = _provideExpanded.isExpanded, toggleExpand = _provideExpanded.toggleExpand;
        (0, $8457cdf7ca26e52e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                setItemsPerPage: setItemsPerPage,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: paginatedItemsWithoutGroups.value,
                groupedItems: paginatedItems.value
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-data-iterator',
                    {
                        'v-data-iterator--loading': props.loading
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_header, _slots_footer;
                    return [
                        (_slots_header = slots.header) === null || _slots_header === void 0 ? void 0 : _slots_header.call(slots, slotProps.value),
                        (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                            transition: props.transition
                        }, {
                            "default": function() {
                                var _slots_nodata, _slots_default;
                                return [
                                    props.loading ? (0, $bu8yf.createVNode)((0, $de59c43ac78c3e7a$export$9a5d46a3538da529), {
                                        key: "loader",
                                        name: "v-data-iterator",
                                        active: true
                                    }, {
                                        "default": function(slotProps) {
                                            var _slots_loader;
                                            return (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots, slotProps);
                                        }
                                    }) : (0, $bu8yf.createElementVNode)("div", {
                                        key: "items"
                                    }, [
                                        !paginatedItems.value.length ? (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots) : (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                                    ])
                                ];
                            }
                        }),
                        (_slots_footer = slots.footer) === null || _slots_footer === void 0 ? void 0 : _slots_footer.call(slots, slotProps.value)
                    ];
                }
            });
        });
        return {};
    }
});




var $3c66f34f873743e2$exports = {};

$parcel$export($3c66f34f873743e2$exports, "VDataTable", function () { return $7e722994f167a33b$export$4cdfcef9678998c7; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableHeaders", function () { return $8d8a4ec5de2cb572$export$c619622075eadff7; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableFooter", function () { return $261836419047838d$export$3403786a0c6524a; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableRows", function () { return $7745832faab26163$export$e10d8e097873db4f; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableRow", function () { return $7246693592d1fa27$export$2c0f083ba8593d7; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableVirtual", function () { return $a7da6ec65d64ce0e$export$4134771f7c9e4b2; });
$parcel$export($3c66f34f873743e2$exports, "VDataTableServer", function () { return $8a9d5b31447cb359$export$ad1f17a300f73544; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");


var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");











// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");
function $4c6289283c626d6b$export$14a2d388602b1453() {
    var refs = (0, $hXmfK.ref)([]);
    (0, $bu8yf.onBeforeUpdate)(function() {
        return refs.value = [];
    });
    function updateRef(e, i) {
        refs.value[i] = e;
    }
    return {
        refs: refs,
        updateRef: updateRef
    };
}









var $5711626ff2a195b7$export$fc742cc11f540876 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    activeColor: String,
    start: {
        type: [
            Number,
            String
        ],
        "default": 1
    },
    modelValue: {
        type: Number,
        "default": function(props) {
            return props.start;
        }
    },
    disabled: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        "default": 1,
        validator: function(val) {
            return val % 1 === 0;
        }
    },
    totalVisible: [
        Number,
        String
    ],
    firstIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$first'
    },
    prevIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$prev'
    },
    nextIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$next'
    },
    lastIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$last'
    },
    ariaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.root'
    },
    pageAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.page'
    },
    currentPageAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.currentPage'
    },
    firstAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.first'
    },
    previousAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.previous'
    },
    nextAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.next'
    },
    lastAriaLabel: {
        type: String,
        "default": '$vuetify.pagination.ariaLabel.last'
    },
    ellipsis: {
        type: String,
        "default": '...'
    },
    showFirstLastPage: Boolean
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'nav'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VPagination');
var $5711626ff2a195b7$export$6353b480ae89e024 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VPagination',
    props: $5711626ff2a195b7$export$fc742cc11f540876(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        first: function(value) {
            return true;
        },
        prev: function(value) {
            return true;
        },
        next: function(value) {
            return true;
        },
        last: function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var page = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useLocale = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)(), t = _useLocale.t, n = _useLocale.n;
        var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var width = (0, $a7414385605a88b0$export$8406b7efc286d284)().width;
        var maxButtons = (0, $hXmfK.shallowRef)(-1);
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)(undefined, {
            scoped: true
        });
        var resizeRef = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(function(entries) {
            if (!entries.length) return;
            var _entries_ = entries[0], target = _entries_.target, contentRect = _entries_.contentRect;
            var firstItem = target.querySelector('.v-pagination__list > *');
            if (!firstItem) return;
            var totalWidth = contentRect.width;
            var itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(firstItem).marginRight) * 2;
            maxButtons.value = getMax(totalWidth, itemWidth);
        }).resizeRef;
        var length = (0, $hXmfK.computed)(function() {
            return parseInt(props.length, 10);
        });
        var start = (0, $hXmfK.computed)(function() {
            return parseInt(props.start, 10);
        });
        var totalVisible = (0, $hXmfK.computed)(function() {
            if (props.totalVisible != null) return parseInt(props.totalVisible, 10);
            else if (maxButtons.value >= 0) return maxButtons.value;
            return getMax(width.value, 58);
        });
        function getMax(totalWidth, itemWidth) {
            var minButtons = props.showFirstLastPage ? 5 : 3;
            return Math.max(0, Math.floor(// Round to two decimal places to avoid floating point errors
            Number(((totalWidth - itemWidth * minButtons) / itemWidth).toFixed(2))));
        }
        var range = (0, $hXmfK.computed)(function() {
            if (length.value <= 0 || isNaN(length.value) || length.value > Number.MAX_SAFE_INTEGER) return [];
            if (totalVisible.value <= 0) return [];
            else if (totalVisible.value === 1) return [
                page.value
            ];
            if (length.value <= totalVisible.value) return (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(length.value, start.value);
            var even = totalVisible.value % 2 === 0;
            var middle = even ? totalVisible.value / 2 : Math.floor(totalVisible.value / 2);
            var left = even ? middle : middle + 1;
            var right = length.value - middle;
            if (left - page.value >= 0) return (0, $7WNf6._)((0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(Math.max(1, totalVisible.value - 1), start.value)).concat([
                props.ellipsis,
                length.value
            ]);
            else if (page.value - right >= (even ? 1 : 0)) {
                var rangeLength = totalVisible.value - 1;
                var rangeStart = length.value - rangeLength + start.value;
                return [
                    start.value,
                    props.ellipsis
                ].concat((0, $7WNf6._)((0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(rangeLength, rangeStart)));
            } else {
                var rangeLength1 = Math.max(1, totalVisible.value - 2);
                var rangeStart1 = rangeLength1 === 1 ? page.value : page.value - Math.ceil(rangeLength1 / 2) + start.value;
                return [
                    start.value,
                    props.ellipsis
                ].concat((0, $7WNf6._)((0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(rangeLength1, rangeStart1)), [
                    props.ellipsis,
                    length.value
                ]);
            }
        });
        // TODO: 'first' | 'prev' | 'next' | 'last' does not work here?
        function setValue(e, value, event) {
            e.preventDefault();
            page.value = value;
            event && emit(event, value);
        }
        var _useRefs = (0, $4c6289283c626d6b$export$14a2d388602b1453)(), refs = _useRefs.refs, updateRef = _useRefs.updateRef;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VPaginationBtn: {
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                border: (0, $hXmfK.toRef)(function() {
                    return props.border;
                }),
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                size: (0, $hXmfK.toRef)(function() {
                    return props.size;
                }),
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                }),
                rounded: (0, $hXmfK.toRef)(function() {
                    return props.rounded;
                }),
                elevation: (0, $hXmfK.toRef)(function() {
                    return props.elevation;
                })
            }
        });
        var items = (0, $hXmfK.computed)(function() {
            return range.value.map(function(item, index) {
                var ref = function(e) {
                    return updateRef(e, index);
                };
                if (typeof item === 'string') return {
                    isActive: false,
                    key: "ellipsis-".concat(index),
                    page: item,
                    props: {
                        ref: ref,
                        ellipsis: true,
                        icon: true,
                        disabled: true
                    }
                };
                else {
                    var isActive = item === page.value;
                    return {
                        isActive: isActive,
                        key: item,
                        page: n(item),
                        props: {
                            ref: ref,
                            ellipsis: false,
                            icon: true,
                            disabled: !!props.disabled || Number(props.length) < 2,
                            color: isActive ? props.activeColor : props.color,
                            'aria-current': isActive,
                            'aria-label': t(isActive ? props.currentPageAriaLabel : props.pageAriaLabel, item),
                            onClick: function(e) {
                                return setValue(e, item);
                            }
                        }
                    };
                }
            });
        });
        var controls = (0, $hXmfK.computed)(function() {
            var prevDisabled = !!props.disabled || page.value <= start.value;
            var nextDisabled = !!props.disabled || page.value >= start.value + length.value - 1;
            return {
                first: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.lastIcon : props.firstIcon,
                    onClick: function(e) {
                        return setValue(e, start.value, 'first');
                    },
                    disabled: prevDisabled,
                    'aria-label': t(props.firstAriaLabel),
                    'aria-disabled': prevDisabled
                } : undefined,
                prev: {
                    icon: isRtl.value ? props.nextIcon : props.prevIcon,
                    onClick: function(e) {
                        return setValue(e, page.value - 1, 'prev');
                    },
                    disabled: prevDisabled,
                    'aria-label': t(props.previousAriaLabel),
                    'aria-disabled': prevDisabled
                },
                next: {
                    icon: isRtl.value ? props.prevIcon : props.nextIcon,
                    onClick: function(e) {
                        return setValue(e, page.value + 1, 'next');
                    },
                    disabled: nextDisabled,
                    'aria-label': t(props.nextAriaLabel),
                    'aria-disabled': nextDisabled
                },
                last: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.firstIcon : props.lastIcon,
                    onClick: function(e) {
                        return setValue(e, start.value + length.value - 1, 'last');
                    },
                    disabled: nextDisabled,
                    'aria-label': t(props.lastAriaLabel),
                    'aria-disabled': nextDisabled
                } : undefined
            };
        });
        function updateFocus() {
            var _refs_value_currentIndex;
            var currentIndex = page.value - start.value;
            (_refs_value_currentIndex = refs.value[currentIndex]) === null || _refs_value_currentIndex === void 0 ? void 0 : _refs_value_currentIndex.$el.focus();
        }
        function onKeydown(e) {
            if (e.key === (0, $31779689cfd5da50$export$4f79075d7446a261).left && !props.disabled && page.value > Number(props.start)) {
                page.value = page.value - 1;
                (0, $bu8yf.nextTick)(updateFocus);
            } else if (e.key === (0, $31779689cfd5da50$export$4f79075d7446a261).right && !props.disabled && page.value < start.value + length.value - 1) {
                page.value = page.value + 1;
                (0, $bu8yf.nextTick)(updateFocus);
            }
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                ref: resizeRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-pagination',
                    themeClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                role: "navigation",
                "aria-label": t(props.ariaLabel),
                onKeydown: onKeydown,
                "data-test": "v-pagination-root"
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.createElementVNode)("ul", {
                            "class": "v-pagination__list"
                        }, [
                            props.showFirstLastPage && (0, $bu8yf.createElementVNode)("li", {
                                key: "first",
                                "class": "v-pagination__first",
                                "data-test": "v-pagination-first"
                            }, [
                                slots.first ? slots.first(controls.value.first) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                    _as: "VPaginationBtn"
                                }, controls.value.first), null)
                            ]),
                            (0, $bu8yf.createElementVNode)("li", {
                                key: "prev",
                                "class": "v-pagination__prev",
                                "data-test": "v-pagination-prev"
                            }, [
                                slots.prev ? slots.prev(controls.value.prev) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                    _as: "VPaginationBtn"
                                }, controls.value.prev), null)
                            ]),
                            items.value.map(function(item, index) {
                                return (0, $bu8yf.createElementVNode)("li", {
                                    key: item.key,
                                    "class": (0, $d8jBh.normalizeClass)([
                                        'v-pagination__item',
                                        {
                                            'v-pagination__item--is-active': item.isActive
                                        }
                                    ]),
                                    "data-test": "v-pagination-item"
                                }, [
                                    slots.item ? slots.item(item) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                        _as: "VPaginationBtn"
                                    }, item.props), {
                                        "default": function() {
                                            return [
                                                item.page
                                            ];
                                        }
                                    })
                                ]);
                            }),
                            (0, $bu8yf.createElementVNode)("li", {
                                key: "next",
                                "class": "v-pagination__next",
                                "data-test": "v-pagination-next"
                            }, [
                                slots.next ? slots.next(controls.value.next) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                    _as: "VPaginationBtn"
                                }, controls.value.next), null)
                            ]),
                            props.showFirstLastPage && (0, $bu8yf.createElementVNode)("li", {
                                key: "last",
                                "class": "v-pagination__last",
                                "data-test": "v-pagination-last"
                            }, [
                                slots.last ? slots.last(controls.value.last) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                    _as: "VPaginationBtn"
                                }, controls.value.last), null)
                            ])
                        ])
                    ];
                }
            });
        });
        return {};
    }
});







var $261836419047838d$export$85788b26c9087beb = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    prevIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$prev'
    },
    nextIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$next'
    },
    firstIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$first'
    },
    lastIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$last'
    },
    itemsPerPageText: {
        type: String,
        "default": '$vuetify.dataFooter.itemsPerPageText'
    },
    pageText: {
        type: String,
        "default": '$vuetify.dataFooter.pageText'
    },
    firstPageLabel: {
        type: String,
        "default": '$vuetify.dataFooter.firstPage'
    },
    prevPageLabel: {
        type: String,
        "default": '$vuetify.dataFooter.prevPage'
    },
    nextPageLabel: {
        type: String,
        "default": '$vuetify.dataFooter.nextPage'
    },
    lastPageLabel: {
        type: String,
        "default": '$vuetify.dataFooter.lastPage'
    },
    itemsPerPageOptions: {
        type: Array,
        "default": function() {
            return [
                {
                    value: 10,
                    title: '10'
                },
                {
                    value: 25,
                    title: '25'
                },
                {
                    value: 50,
                    title: '50'
                },
                {
                    value: 100,
                    title: '100'
                },
                {
                    value: -1,
                    title: '$vuetify.dataFooter.itemsPerPageAll'
                }
            ];
        }
    },
    showCurrentPage: Boolean
}, 'VDataTableFooter');
var $261836419047838d$export$3403786a0c6524a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableFooter',
    props: $261836419047838d$export$85788b26c9087beb(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var _usePagination = (0, $515a30edd8060cfd$export$f80c710216eae131)(), page = _usePagination.page, pageCount = _usePagination.pageCount, startIndex = _usePagination.startIndex, stopIndex = _usePagination.stopIndex, itemsLength = _usePagination.itemsLength, itemsPerPage = _usePagination.itemsPerPage, setItemsPerPage = _usePagination.setItemsPerPage;
        var itemsPerPageOptions = (0, $hXmfK.computed)(function() {
            return props.itemsPerPageOptions.map(function(option) {
                if (typeof option === 'number') return {
                    value: option,
                    title: option === -1 ? t('$vuetify.dataFooter.itemsPerPageAll') : String(option)
                };
                return (0, $emQHU._)((0, $iT0je._)({}, option), {
                    title: !isNaN(Number(option.title)) ? option.title : t(option.title)
                });
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_prepend;
            var paginationProps = (0, $5711626ff2a195b7$export$6353b480ae89e024).filterProps(props);
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-data-table-footer"
            }, [
                (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-data-table-footer__items-per-page"
                }, [
                    (0, $bu8yf.createElementVNode)("span", {
                        "aria-label": t(props.itemsPerPageText)
                    }, [
                        t(props.itemsPerPageText)
                    ]),
                    (0, $bu8yf.createVNode)((0, $416a51876874f600$export$1d8182ee812485f5), {
                        items: itemsPerPageOptions.value,
                        modelValue: itemsPerPage.value,
                        "onUpdate:modelValue": function(v) {
                            return setItemsPerPage(Number(v));
                        },
                        density: "compact",
                        variant: "outlined",
                        hideDetails: true
                    }, null)
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-data-table-footer__info"
                }, [
                    (0, $bu8yf.createElementVNode)("div", null, [
                        t(props.pageText, !itemsLength.value ? 0 : startIndex.value + 1, stopIndex.value, itemsLength.value)
                    ])
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-data-table-footer__pagination"
                }, [
                    (0, $bu8yf.createVNode)((0, $5711626ff2a195b7$export$6353b480ae89e024), (0, $bu8yf.mergeProps)({
                        modelValue: page.value,
                        "onUpdate:modelValue": function($event) {
                            return page.value = $event;
                        },
                        density: "comfortable",
                        firstAriaLabel: props.firstPageLabel,
                        lastAriaLabel: props.lastPageLabel,
                        length: pageCount.value,
                        nextAriaLabel: props.nextPageLabel,
                        previousAriaLabel: props.prevPageLabel,
                        rounded: true,
                        showFirstLastPage: true,
                        totalVisible: props.showCurrentPage ? 1 : 0,
                        variant: "plain"
                    }, paginationProps), null)
                ])
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");

var $c81b0e7f5e23d2df$export$f5a6c4651f7652fe = (0, $87e73a4a4b645892$export$c5e8501a3a1b4e53)({
    align: {
        type: String,
        "default": 'start'
    },
    fixed: {
        type: [
            Boolean,
            String
        ],
        "default": false
    },
    fixedOffset: [
        Number,
        String
    ],
    fixedEndOffset: [
        Number,
        String
    ],
    height: [
        Number,
        String
    ],
    lastFixed: Boolean,
    firstFixedEnd: Boolean,
    noPadding: Boolean,
    tag: String,
    width: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    nowrap: Boolean
}, function(props, _ref) {
    var slots = _ref.slots;
    var _props_tag;
    var Tag = (_props_tag = props.tag) !== null && _props_tag !== void 0 ? _props_tag : 'td';
    var fixedSide = typeof props.fixed === 'string' ? props.fixed : props.fixed ? 'start' : 'none';
    return (0, $bu8yf.createVNode)(Tag, {
        "class": (0, $d8jBh.normalizeClass)([
            'v-data-table__td',
            {
                'v-data-table-column--fixed': fixedSide === 'start',
                'v-data-table-column--fixed-end': fixedSide === 'end',
                'v-data-table-column--last-fixed': props.lastFixed,
                'v-data-table-column--first-fixed-end': props.firstFixedEnd,
                'v-data-table-column--no-padding': props.noPadding,
                'v-data-table-column--nowrap': props.nowrap
            },
            "v-data-table-column--align-".concat(props.align)
        ]),
        style: {
            height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height),
            width: (0, $31779689cfd5da50$export$286ad215293a0860)(props.width),
            maxWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(props.maxWidth),
            left: fixedSide === 'start' ? (0, $31779689cfd5da50$export$286ad215293a0860)(props.fixedOffset || null) : undefined,
            right: fixedSide === 'end' ? (0, $31779689cfd5da50$export$286ad215293a0860)(props.fixedEndOffset || null) : undefined
        }
    }, {
        "default": function() {
            var _slots_default;
            return [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ];
        }
    });
});






// Utilities

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
var $bu8yf = parcelRequire("bu8yf");
var $hXmfK = parcelRequire("hXmfK");

var $8aa788cc88525700$export$9d1907f8d303b311 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    headers: Array
}, 'DataTable-header');
var $8aa788cc88525700$export$3ab916b4a7fa12ad = Symbol["for"]('vuetify:data-table-headers');
var $8aa788cc88525700$var$defaultHeader = {
    title: '',
    sortable: false
};
var $8aa788cc88525700$var$defaultActionHeader = (0, $emQHU._)((0, $iT0je._)({}, $8aa788cc88525700$var$defaultHeader), {
    width: 48
});
function $8aa788cc88525700$var$priorityQueue() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var queue = arr.map(function(element) {
        return {
            element: element,
            priority: 0
        };
    });
    return {
        enqueue: function(element, priority) {
            var added = false;
            for(var i = 0; i < queue.length; i++){
                var item = queue[i];
                if (item.priority > priority) {
                    queue.splice(i, 0, {
                        element: element,
                        priority: priority
                    });
                    added = true;
                    break;
                }
            }
            if (!added) queue.push({
                element: element,
                priority: priority
            });
        },
        size: function() {
            return queue.length;
        },
        count: function() {
            var count = 0;
            if (!queue.length) return 0;
            var whole = Math.floor(queue[0].priority);
            for(var i = 0; i < queue.length; i++)if (Math.floor(queue[i].priority) === whole) count += 1;
            return count;
        },
        dequeue: function() {
            return queue.shift();
        }
    };
}
function $8aa788cc88525700$var$extractLeaves(item) {
    var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (!item.children) columns.push(item);
    else try {
        for(var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            $8aa788cc88525700$var$extractLeaves(child, columns);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return columns;
}
function $8aa788cc88525700$var$extractKeys(headers) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.key) keys.add(item.key);
            if (item.children) $8aa788cc88525700$var$extractKeys(item.children, keys);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return keys;
}
function $8aa788cc88525700$var$getDefaultItem(item) {
    if (!item.key) return undefined;
    if (item.key === 'data-table-group') return $8aa788cc88525700$var$defaultHeader;
    if ([
        'data-table-expand',
        'data-table-select'
    ].includes(item.key)) return $8aa788cc88525700$var$defaultActionHeader;
    return undefined;
}
function $8aa788cc88525700$var$getDepth(item) {
    var _Math;
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item.children) return depth;
    return (_Math = Math).max.apply(_Math, [
        depth
    ].concat((0, $7WNf6._)(item.children.map(function(child) {
        return $8aa788cc88525700$var$getDepth(child, depth + 1);
    }))));
}
function $8aa788cc88525700$var$parseFixedColumns(items) {
    var seenFixed = false;
    function setFixed(item, side) {
        var _item_children;
        var parentFixedSide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
        if (!item) return;
        if (parentFixedSide !== 'none') item.fixed = parentFixedSide;
        // normalize to simplify logic below
        if (item.fixed === true) item.fixed = 'start';
        var orderedChildren = side === 'start' ? (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.toReversed() : item.children;
        if (item.fixed === side) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (orderedChildren) try {
                for(var _iterator = orderedChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    setFixed(child, side, side);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else {
                if (!seenFixed && side === 'start') item.lastFixed = true;
                else if (!seenFixed && side === 'end') item.firstFixedEnd = true;
                else if (isNaN(Number(item.width))) (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)("Multiple fixed columns should have a static width (key: ".concat(item.key, ")"));
                else item.minWidth = Math.max(Number(item.width) || 0, Number(item.minWidth) || 0);
                seenFixed = true;
            }
        } else {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (orderedChildren) try {
                for(var _iterator1 = orderedChildren[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var child1 = _step1.value;
                    setFixed(child1, side);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            else seenFixed = false;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items.toReversed()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            setFixed(item, 'start');
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = items[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            setFixed(item1, 'end');
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    function setFixedOffset(item) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (!item) return offset;
        if (item.children) {
            item.fixedOffset = offset;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    offset = setFixedOffset(child, offset);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if (item.fixed && item.fixed !== 'end') {
            item.fixedOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    var fixedOffset = 0;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var item2 = _step2.value;
            fixedOffset = setFixedOffset(item2, fixedOffset);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    function setFixedEndOffset(item) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (!item) return offset;
        if (item.children) {
            item.fixedEndOffset = offset;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    offset = setFixedEndOffset(child, offset);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if (item.fixed === 'end') {
            item.fixedEndOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    var fixedEndOffset = 0;
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = items.toReversed()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var item3 = _step3.value;
            fixedEndOffset = setFixedEndOffset(item3, fixedEndOffset);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
}
function $8aa788cc88525700$var$parse(items, maxDepth) {
    var headers = [];
    var currentDepth = 0;
    var queue = $8aa788cc88525700$var$priorityQueue(items);
    while(queue.size() > 0){
        var rowSize = queue.count();
        var row = [];
        var fraction = 1;
        while(rowSize > 0){
            var _queue_dequeue = queue.dequeue(), item = _queue_dequeue.element, priority = _queue_dequeue.priority;
            var diff = maxDepth - currentDepth - $8aa788cc88525700$var$getDepth(item);
            row.push((0, $emQHU._)((0, $iT0je._)({}, item), {
                rowspan: diff !== null && diff !== void 0 ? diff : 1,
                colspan: item.children ? $8aa788cc88525700$var$extractLeaves(item).length : 1
            }));
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (item.children) try {
                for(var _iterator = item.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    // This internally sorts items that are on the same priority "row"
                    var sort = priority % 1 + fraction / Math.pow(10, currentDepth + 2);
                    queue.enqueue(child, currentDepth + diff + sort);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            fraction += 1;
            rowSize -= 1;
        }
        currentDepth += 1;
        headers.push(row);
    }
    var columns = items.map(function(item) {
        return $8aa788cc88525700$var$extractLeaves(item);
    }).flat();
    return {
        columns: columns,
        headers: headers
    };
}
function $8aa788cc88525700$var$convertToInternalHeaders(items) {
    var internalHeaders = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var defaultItem = (0, $iT0je._)({}, $8aa788cc88525700$var$getDefaultItem(item), item);
            var _defaultItem_key;
            var key = (_defaultItem_key = defaultItem.key) !== null && _defaultItem_key !== void 0 ? _defaultItem_key : typeof defaultItem.value === 'string' ? defaultItem.value : null;
            var _defaultItem_value, _ref;
            var value = (_ref = (_defaultItem_value = defaultItem.value) !== null && _defaultItem_value !== void 0 ? _defaultItem_value : key) !== null && _ref !== void 0 ? _ref : null;
            var _defaultItem_sortable;
            var internalItem = (0, $emQHU._)((0, $iT0je._)({}, defaultItem), {
                key: key,
                value: value,
                sortable: (_defaultItem_sortable = defaultItem.sortable) !== null && _defaultItem_sortable !== void 0 ? _defaultItem_sortable : defaultItem.key != null || !!defaultItem.sort,
                children: defaultItem.children ? $8aa788cc88525700$var$convertToInternalHeaders(defaultItem.children) : undefined
            });
            internalHeaders.push(internalItem);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return internalHeaders;
}
function $8aa788cc88525700$export$197579c449ddabf4(props, options) {
    var headers = (0, $hXmfK.ref)([]);
    var columns = (0, $hXmfK.ref)([]);
    var sortFunctions = (0, $hXmfK.ref)({});
    var sortRawFunctions = (0, $hXmfK.ref)({});
    var filterFunctions = (0, $hXmfK.ref)({});
    (0, $bu8yf.watchEffect)(function() {
        var _Math;
        var _options_groupBy, _options_showSelect, _options_showExpand;
        var _props_items_;
        var _headers = props.headers || Object.keys((_props_items_ = props.items[0]) !== null && _props_items_ !== void 0 ? _props_items_ : {}).map(function(key) {
            return {
                key: key,
                title: (0, $d8jBh.capitalize)(key)
            };
        });
        var items = _headers.slice();
        var keys = $8aa788cc88525700$var$extractKeys(items);
        if ((options === null || options === void 0 ? void 0 : (_options_groupBy = options.groupBy) === null || _options_groupBy === void 0 ? void 0 : _options_groupBy.value.length) && !keys.has('data-table-group')) items.unshift({
            key: 'data-table-group',
            title: 'Group'
        });
        if ((options === null || options === void 0 ? void 0 : (_options_showSelect = options.showSelect) === null || _options_showSelect === void 0 ? void 0 : _options_showSelect.value) && !keys.has('data-table-select')) items.unshift({
            key: 'data-table-select'
        });
        if ((options === null || options === void 0 ? void 0 : (_options_showExpand = options.showExpand) === null || _options_showExpand === void 0 ? void 0 : _options_showExpand.value) && !keys.has('data-table-expand')) items.push({
            key: 'data-table-expand'
        });
        var internalHeaders = $8aa788cc88525700$var$convertToInternalHeaders(items);
        $8aa788cc88525700$var$parseFixedColumns(internalHeaders);
        var maxDepth = (_Math = Math).max.apply(_Math, (0, $7WNf6._)(internalHeaders.map(function(item) {
            return $8aa788cc88525700$var$getDepth(item);
        }))) + 1;
        var parsed = $8aa788cc88525700$var$parse(internalHeaders, maxDepth);
        headers.value = parsed.headers;
        columns.value = parsed.columns;
        var flatHeaders = parsed.headers.flat(1);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = flatHeaders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var header = _step.value;
                if (!header.key) continue;
                if (header.sortable) {
                    if (header.sort) sortFunctions.value[header.key] = header.sort;
                    if (header.sortRaw) sortRawFunctions.value[header.key] = header.sortRaw;
                }
                if (header.filter) filterFunctions.value[header.key] = header.filter;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    var data = {
        headers: headers,
        columns: columns,
        sortFunctions: sortFunctions,
        sortRawFunctions: sortRawFunctions,
        filterFunctions: filterFunctions
    };
    (0, $bu8yf.provide)($8aa788cc88525700$export$3ab916b4a7fa12ad, data);
    return data;
}
function $8aa788cc88525700$export$7032d2df28bea3c4() {
    var data = (0, $bu8yf.inject)($8aa788cc88525700$export$3ab916b4a7fa12ad);
    if (!data) throw new Error('Missing headers!');
    return data;
}










var $8d8a4ec5de2cb572$export$3e579cb6b57f22ae = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    disableSort: Boolean,
    fixedHeader: Boolean,
    multiSort: Boolean,
    sortAscIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$sortAsc'
    },
    sortDescIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$sortDesc'
    },
    headerProps: {
        type: Object
    },
    /** @deprecated */ sticky: Boolean
}, (0, $a7414385605a88b0$export$d0badecb383b472a)(), (0, $de59c43ac78c3e7a$export$149f04e0cba4dbc1)()), 'VDataTableHeaders');
var $8d8a4ec5de2cb572$export$c619622075eadff7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableHeaders',
    props: $8d8a4ec5de2cb572$export$3e579cb6b57f22ae(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var _useSort = (0, $d6b7304528d4da19$export$6292515ceca0b297)(), toggleSort = _useSort.toggleSort, sortBy = _useSort.sortBy, isSorted = _useSort.isSorted;
        var _useSelection = (0, $3ee4b18c5d85bd4b$export$a97c3cc4bf1da1ca)(), someSelected = _useSelection.someSelected, allSelected = _useSelection.allSelected, selectAll = _useSelection.selectAll, showSelectAll = _useSelection.showSelectAll;
        var _useHeaders = (0, $8aa788cc88525700$export$7032d2df28bea3c4)(), columns = _useHeaders.columns, headers = _useHeaders.headers;
        var loaderClasses = (0, $de59c43ac78c3e7a$export$14095de704efe3f9)(props).loaderClasses;
        function getFixedStyles(column, y) {
            if (!(props.sticky || props.fixedHeader) && !column.fixed) return undefined;
            var fixedSide = typeof column.fixed === 'string' ? column.fixed : column.fixed ? 'start' : 'none';
            return {
                position: 'sticky',
                left: fixedSide === 'start' ? (0, $31779689cfd5da50$export$286ad215293a0860)(column.fixedOffset) : undefined,
                right: fixedSide === 'end' ? (0, $31779689cfd5da50$export$286ad215293a0860)(column.fixedEndOffset) : undefined,
                top: props.sticky || props.fixedHeader ? "calc(var(--v-table-header-height) * ".concat(y, ")") : undefined
            };
        }
        function handleEnterKeyPress(event, column) {
            if (event.key === 'Enter' && !props.disableSort) toggleSort(column);
        }
        function getSortIcon(column) {
            var item = sortBy.value.find(function(item) {
                return item.key === column.key;
            });
            if (!item) return props.sortAscIcon;
            return item.order === 'asc' ? props.sortAscIcon : props.sortDescIcon;
        }
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                headers: headers.value,
                columns: columns.value,
                toggleSort: toggleSort,
                isSorted: isSorted,
                sortBy: sortBy.value,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                selectAll: selectAll,
                getSortIcon: getSortIcon
            };
        });
        var headerCellClasses = (0, $hXmfK.computed)(function() {
            return [
                'v-data-table__th',
                {
                    'v-data-table__th--sticky': props.sticky || props.fixedHeader
                },
                displayClasses.value,
                loaderClasses.value
            ];
        });
        var VDataTableHeaderCell = function(_ref2) {
            var column = _ref2.column, x = _ref2.x, y = _ref2.y;
            var noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
            var _props_headerProps, _column_headerProps;
            var headerProps = (0, $bu8yf.mergeProps)((_props_headerProps = props.headerProps) !== null && _props_headerProps !== void 0 ? _props_headerProps : {}, (_column_headerProps = column.headerProps) !== null && _column_headerProps !== void 0 ? _column_headerProps : {});
            return (0, $bu8yf.createVNode)((0, $c81b0e7f5e23d2df$export$f5a6c4651f7652fe), (0, $bu8yf.mergeProps)({
                tag: "th",
                align: column.align,
                "class": [
                    {
                        'v-data-table__th--sortable': column.sortable && !props.disableSort,
                        'v-data-table__th--sorted': isSorted(column),
                        'v-data-table__th--fixed': column.fixed
                    }
                ].concat((0, $7WNf6._)(headerCellClasses.value)),
                style: (0, $iT0je._)({
                    width: (0, $31779689cfd5da50$export$286ad215293a0860)(column.width),
                    minWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(column.minWidth),
                    maxWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(column.maxWidth)
                }, getFixedStyles(column, y)),
                colspan: column.colspan,
                rowspan: column.rowspan,
                fixed: column.fixed,
                nowrap: column.nowrap,
                lastFixed: column.lastFixed,
                firstFixedEnd: column.firstFixedEnd,
                noPadding: noPadding,
                tabindex: column.sortable ? 0 : undefined,
                onClick: column.sortable ? function() {
                    return toggleSort(column);
                } : undefined,
                onKeydown: column.sortable ? function(event) {
                    return handleEnterKeyPress(event, column);
                } : undefined
            }, headerProps), {
                "default": function() {
                    var _slots_headerdatatableselect;
                    var columnSlotName = "header.".concat(column.key);
                    var columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: getSortIcon
                    };
                    if (slots[columnSlotName]) return slots[columnSlotName](columnSlotProps);
                    var _slots_headerdatatableselect1;
                    if (column.key === 'data-table-select') return (_slots_headerdatatableselect1 = (_slots_headerdatatableselect = slots['header.data-table-select']) === null || _slots_headerdatatableselect === void 0 ? void 0 : _slots_headerdatatableselect.call(slots, columnSlotProps)) !== null && _slots_headerdatatableselect1 !== void 0 ? _slots_headerdatatableselect1 : showSelectAll.value && (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                        modelValue: allSelected.value,
                        indeterminate: someSelected.value && !allSelected.value,
                        "onUpdate:modelValue": selectAll
                    }, null);
                    return (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-data-table-header__content"
                    }, [
                        (0, $bu8yf.createElementVNode)("span", null, [
                            column.title
                        ]),
                        column.sortable && !props.disableSort && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "icon",
                            "class": "v-data-table-header__sort-icon",
                            icon: getSortIcon(column)
                        }, null),
                        props.multiSort && isSorted(column) && (0, $bu8yf.createElementVNode)("div", {
                            key: "badge",
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-data-table-header__sort-badge'
                            ].concat((0, $7WNf6._)(backgroundColorClasses.value))),
                            style: (0, $d8jBh.normalizeStyle)(backgroundColorStyles.value)
                        }, [
                            sortBy.value.findIndex(function(x) {
                                return x.key === column.key;
                            }) + 1
                        ])
                    ]);
                }
            });
        };
        var VDataTableMobileHeaderCell = function() {
            var displayItems = (0, $hXmfK.computed)(function() {
                return columns.value.filter(function(column) {
                    return (column === null || column === void 0 ? void 0 : column.sortable) && !props.disableSort;
                });
            });
            var appendIcon = (0, $hXmfK.computed)(function() {
                var showSelectColumn = columns.value.find(function(column) {
                    return column.key === 'data-table-select';
                });
                if (showSelectColumn == null) return;
                return allSelected.value ? '$checkboxOn' : someSelected.value ? '$checkboxIndeterminate' : '$checkboxOff';
            });
            return (0, $bu8yf.createVNode)((0, $c81b0e7f5e23d2df$export$f5a6c4651f7652fe), (0, $bu8yf.mergeProps)({
                tag: "th",
                "class": (0, $7WNf6._)(headerCellClasses.value),
                colspan: headers.value.length + 1
            }, props.headerProps), {
                "default": function() {
                    return [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-data-table-header__content"
                        }, [
                            (0, $bu8yf.createVNode)((0, $416a51876874f600$export$1d8182ee812485f5), {
                                chips: true,
                                "class": "v-data-table__td-sort-select",
                                clearable: true,
                                density: "default",
                                items: displayItems.value,
                                label: t('$vuetify.dataTable.sortBy'),
                                multiple: props.multiSort,
                                variant: "underlined",
                                "onClick:clear": function() {
                                    return sortBy.value = [];
                                },
                                appendIcon: appendIcon.value,
                                "onClick:append": function() {
                                    return selectAll(!allSelected.value);
                                }
                            }, (0, $emQHU._)((0, $iT0je._)({}, slots), {
                                chip: function(props) {
                                    var _props_item_raw;
                                    return (0, $bu8yf.createVNode)((0, $2f12dac67cff7cbd$export$1b5fab12cd17b4fb), {
                                        onClick: ((_props_item_raw = props.item.raw) === null || _props_item_raw === void 0 ? void 0 : _props_item_raw.sortable) ? function() {
                                            return toggleSort(props.item.raw);
                                        } : undefined,
                                        onMousedown: function(e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }, {
                                        "default": function() {
                                            return [
                                                props.item.title,
                                                (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                    "class": (0, $d8jBh.normalizeClass)([
                                                        'v-data-table__td-sort-icon',
                                                        isSorted(props.item.raw) && 'v-data-table__td-sort-icon-active'
                                                    ]),
                                                    icon: getSortIcon(props.item.raw),
                                                    size: "small"
                                                }, null)
                                            ];
                                        }
                                    });
                                }
                            }))
                        ])
                    ];
                }
            });
        };
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return mobile.value ? (0, $bu8yf.createElementVNode)("tr", null, [
                (0, $bu8yf.createVNode)(VDataTableMobileHeaderCell, null, null)
            ]) : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                slots.headers ? slots.headers(slotProps.value) : headers.value.map(function(row, y) {
                    return (0, $bu8yf.createElementVNode)("tr", null, [
                        row.map(function(column, x) {
                            return (0, $bu8yf.createVNode)(VDataTableHeaderCell, {
                                column: column,
                                x: x,
                                y: y
                            }, null);
                        })
                    ]);
                }),
                props.loading && (0, $bu8yf.createElementVNode)("tr", {
                    "class": "v-data-table-progress"
                }, [
                    (0, $bu8yf.createElementVNode)("th", {
                        colspan: columns.value.length
                    }, [
                        (0, $bu8yf.createVNode)((0, $de59c43ac78c3e7a$export$9a5d46a3538da529), {
                            name: "v-data-table-progress",
                            absolute: true,
                            active: true,
                            color: typeof props.loading === 'boolean' ? undefined : props.loading,
                            indeterminate: true
                        }, {
                            "default": slots.loader
                        })
                    ])
                ])
            ]);
        });
    }
});



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");







var $b5601e8c34f2623e$export$5943cc4bbec11c64 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    item: {
        type: Object,
        required: true
    }
}, 'VDataTableGroupHeaderRow');
var $b5601e8c34f2623e$export$386c218acab36b27 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableGroupHeaderRow',
    props: $b5601e8c34f2623e$export$5943cc4bbec11c64(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useGroupBy = (0, $4dfcff052151cced$export$c4ec754551fa3ff4)(), isGroupOpen = _useGroupBy.isGroupOpen, toggleGroup = _useGroupBy.toggleGroup, extractRows = _useGroupBy.extractRows;
        var _useSelection = (0, $3ee4b18c5d85bd4b$export$a97c3cc4bf1da1ca)(), isSelected = _useSelection.isSelected, isSomeSelected = _useSelection.isSomeSelected, select = _useSelection.select;
        var columns = (0, $8aa788cc88525700$export$7032d2df28bea3c4)().columns;
        var rows = (0, $hXmfK.computed)(function() {
            return extractRows([
                props.item
            ]);
        });
        return function() {
            return (0, $bu8yf.createElementVNode)("tr", {
                "class": "v-data-table-group-header-row",
                style: {
                    '--v-data-table-group-header-row-depth': props.item.depth
                }
            }, [
                columns.value.map(function(column) {
                    if (column.key === 'data-table-group') {
                        var _slots_datatablegroup;
                        var icon = isGroupOpen(props.item) ? '$expand' : '$next';
                        var onClick = function() {
                            return toggleGroup(props.item);
                        };
                        var _slots_datatablegroup1;
                        return (_slots_datatablegroup1 = (_slots_datatablegroup = slots['data-table-group']) === null || _slots_datatablegroup === void 0 ? void 0 : _slots_datatablegroup.call(slots, {
                            item: props.item,
                            count: rows.value.length,
                            props: {
                                icon: icon,
                                onClick: onClick
                            }
                        })) !== null && _slots_datatablegroup1 !== void 0 ? _slots_datatablegroup1 : (0, $bu8yf.createVNode)((0, $c81b0e7f5e23d2df$export$f5a6c4651f7652fe), {
                            "class": "v-data-table-group-header-row__column"
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                                        size: "small",
                                        variant: "text",
                                        icon: icon,
                                        onClick: onClick
                                    }, null),
                                    (0, $bu8yf.createElementVNode)("span", null, [
                                        props.item.value
                                    ]),
                                    (0, $bu8yf.createElementVNode)("span", null, [
                                        (0, $bu8yf.createTextVNode)("("),
                                        rows.value.length,
                                        (0, $bu8yf.createTextVNode)(")")
                                    ])
                                ];
                            }
                        });
                    }
                    if (column.key === 'data-table-select') {
                        var _slots_datatableselect;
                        var modelValue = isSelected(rows.value);
                        var indeterminate = isSomeSelected(rows.value) && !modelValue;
                        var selectGroup = function(v) {
                            return select(rows.value, v);
                        };
                        var _slots_datatableselect1;
                        return (_slots_datatableselect1 = (_slots_datatableselect = slots['data-table-select']) === null || _slots_datatableselect === void 0 ? void 0 : _slots_datatableselect.call(slots, {
                            props: {
                                modelValue: modelValue,
                                indeterminate: indeterminate,
                                'onUpdate:modelValue': selectGroup
                            }
                        })) !== null && _slots_datatableselect1 !== void 0 ? _slots_datatableselect1 : (0, $bu8yf.createElementVNode)("td", null, [
                            (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                modelValue: modelValue,
                                indeterminate: indeterminate,
                                "onUpdate:modelValue": selectGroup
                            }, null)
                        ]);
                    }
                    return (0, $bu8yf.createElementVNode)("td", null, null);
                })
            ]);
        };
    }
});



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");









var $7246693592d1fa27$export$5bf56072bb3f07fd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    index: Number,
    item: Object,
    cellProps: [
        Object,
        Function
    ],
    onClick: (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    onContextmenu: (0, $31779689cfd5da50$export$cefab237a347bf23)(),
    onDblclick: (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, (0, $a7414385605a88b0$export$d0badecb383b472a)()), 'VDataTableRow');
var $7246693592d1fa27$export$2c0f083ba8593d7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableRow',
    props: $7246693592d1fa27$export$5bf56072bb3f07fd(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props, 'v-data-table__tr'), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var _useSelection = (0, $3ee4b18c5d85bd4b$export$a97c3cc4bf1da1ca)(), isSelected = _useSelection.isSelected, toggleSelect = _useSelection.toggleSelect, someSelected = _useSelection.someSelected, allSelected = _useSelection.allSelected, selectAll = _useSelection.selectAll;
        var _useExpanded = (0, $2f4785e6f46b655c$export$7d3f3306ac4d54ef)(), isExpanded = _useExpanded.isExpanded, toggleExpand = _useExpanded.toggleExpand;
        var _useSort = (0, $d6b7304528d4da19$export$6292515ceca0b297)(), toggleSort = _useSort.toggleSort, sortBy = _useSort.sortBy, isSorted = _useSort.isSorted;
        var columns = (0, $8aa788cc88525700$export$7032d2df28bea3c4)().columns;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("tr", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-data-table__tr',
                    {
                        'v-data-table__tr--clickable': !!(props.onClick || props.onContextmenu || props.onDblclick)
                    },
                    displayClasses.value
                ]),
                onClick: props.onClick,
                onContextmenu: props.onContextmenu,
                onDblclick: props.onDblclick
            }, [
                props.item && columns.value.map(function(column, i) {
                    var item = props.item;
                    var slotName = "item.".concat(column.key);
                    var headerSlotName = "header.".concat(column.key);
                    var slotProps = {
                        index: props.index,
                        item: item.raw,
                        internalItem: item,
                        value: (0, $31779689cfd5da50$export$f5474208cafa7b66)(item.columns, column.key),
                        column: column,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand
                    };
                    var columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: function() {
                            return '';
                        }
                    };
                    var cellProps = typeof props.cellProps === 'function' ? props.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value,
                        column: column
                    }) : props.cellProps;
                    var columnCellProps = typeof column.cellProps === 'function' ? column.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value
                    }) : column.cellProps;
                    return (0, $bu8yf.createVNode)((0, $c81b0e7f5e23d2df$export$f5a6c4651f7652fe), (0, $bu8yf.mergeProps)({
                        align: column.align,
                        "class": {
                            'v-data-table__td--expanded-row': column.key === 'data-table-expand',
                            'v-data-table__td--select-row': column.key === 'data-table-select'
                        },
                        fixed: column.fixed,
                        fixedOffset: column.fixedOffset,
                        fixedEndOffset: column.fixedEndOffset,
                        lastFixed: column.lastFixed,
                        firstFixedEnd: column.firstFixedEnd,
                        maxWidth: !mobile.value ? column.maxWidth : undefined,
                        noPadding: column.key === 'data-table-select' || column.key === 'data-table-expand',
                        nowrap: column.nowrap,
                        width: !mobile.value ? column.width : undefined
                    }, cellProps, columnCellProps), {
                        "default": function() {
                            var _slots_itemdatatableselect, _slots_itemdatatableexpand, _slots_headerSlotName, _slots_slotName;
                            var _slots_itemdatatableselect1;
                            if (column.key === 'data-table-select') return (_slots_itemdatatableselect1 = (_slots_itemdatatableselect = slots['item.data-table-select']) === null || _slots_itemdatatableselect === void 0 ? void 0 : _slots_itemdatatableselect.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                                props: {
                                    disabled: !item.selectable,
                                    modelValue: isSelected([
                                        item
                                    ]),
                                    onClick: (0, $kiZwI.withModifiers)(function() {
                                        return toggleSelect(item);
                                    }, [
                                        'stop'
                                    ])
                                }
                            }))) !== null && _slots_itemdatatableselect1 !== void 0 ? _slots_itemdatatableselect1 : (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                disabled: !item.selectable,
                                modelValue: isSelected([
                                    item
                                ]),
                                onClick: (0, $kiZwI.withModifiers)(function(event) {
                                    return toggleSelect(item, props.index, event);
                                }, [
                                    'stop'
                                ])
                            }, null);
                            var _slots_itemdatatableexpand1;
                            if (column.key === 'data-table-expand') return (_slots_itemdatatableexpand1 = (_slots_itemdatatableexpand = slots['item.data-table-expand']) === null || _slots_itemdatatableexpand === void 0 ? void 0 : _slots_itemdatatableexpand.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                                props: {
                                    icon: isExpanded(item) ? '$collapse' : '$expand',
                                    size: 'small',
                                    variant: 'text',
                                    onClick: (0, $kiZwI.withModifiers)(function() {
                                        return toggleExpand(item);
                                    }, [
                                        'stop'
                                    ])
                                }
                            }))) !== null && _slots_itemdatatableexpand1 !== void 0 ? _slots_itemdatatableexpand1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                                icon: isExpanded(item) ? '$collapse' : '$expand',
                                size: "small",
                                variant: "text",
                                onClick: (0, $kiZwI.withModifiers)(function() {
                                    return toggleExpand(item);
                                }, [
                                    'stop'
                                ])
                            }, null);
                            if (slots[slotName] && !mobile.value) return slots[slotName](slotProps);
                            var displayValue = (0, $d8jBh.toDisplayString)(slotProps.value);
                            var _slots_headerSlotName1, _slots_slotName1;
                            return !mobile.value ? displayValue : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": "v-data-table__td-title"
                                }, [
                                    (_slots_headerSlotName1 = (_slots_headerSlotName = slots[headerSlotName]) === null || _slots_headerSlotName === void 0 ? void 0 : _slots_headerSlotName.call(slots, columnSlotProps)) !== null && _slots_headerSlotName1 !== void 0 ? _slots_headerSlotName1 : column.title
                                ]),
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": "v-data-table__td-value"
                                }, [
                                    (_slots_slotName1 = (_slots_slotName = slots[slotName]) === null || _slots_slotName === void 0 ? void 0 : _slots_slotName.call(slots, slotProps)) !== null && _slots_slotName1 !== void 0 ? _slots_slotName1 : displayValue
                                ])
                            ]);
                        }
                    });
                })
            ]);
        });
    }
});








// Utilities

function $a36a22ad1d3d1cf5$export$b5ac16d47f658674(attrs, suffix, getData) {
    return Object.keys(attrs).filter(function(key) {
        return (0, $31779689cfd5da50$export$1a2d97de39ecbb75)(key) && key.endsWith(suffix);
    }).reduce(function(acc, key) {
        acc[key.slice(0, -suffix.length)] = function(event) {
            return attrs[key](event, getData(event));
        };
        return acc;
    }, {});
}


var $7745832faab26163$export$d81faa32148e6046 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    loading: [
        Boolean,
        String
    ],
    loadingText: {
        type: String,
        "default": '$vuetify.dataIterator.loadingText'
    },
    hideNoData: Boolean,
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    noDataText: {
        type: String,
        "default": '$vuetify.noDataText'
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ]
}, (0, $a7414385605a88b0$export$d0badecb383b472a)()), 'VDataTableRows');
var $7745832faab26163$export$e10d8e097873db4f = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableRows',
    inheritAttrs: false,
    props: $7745832faab26163$export$d81faa32148e6046(),
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var columns = (0, $8aa788cc88525700$export$7032d2df28bea3c4)().columns;
        var _useExpanded = (0, $2f4785e6f46b655c$export$7d3f3306ac4d54ef)(), expandOnClick = _useExpanded.expandOnClick, toggleExpand = _useExpanded.toggleExpand, isExpanded = _useExpanded.isExpanded;
        var _useSelection = (0, $3ee4b18c5d85bd4b$export$a97c3cc4bf1da1ca)(), isSelected = _useSelection.isSelected, toggleSelect = _useSelection.toggleSelect;
        var _useGroupBy = (0, $4dfcff052151cced$export$c4ec754551fa3ff4)(), toggleGroup = _useGroupBy.toggleGroup, isGroupOpen = _useGroupBy.isGroupOpen;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var mobile = (0, $a7414385605a88b0$export$8406b7efc286d284)(props).mobile;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_loading, _slots_nodata;
            var _slots_loading1;
            if (props.loading && (!props.items.length || slots.loading)) return (0, $bu8yf.createElementVNode)("tr", {
                "class": "v-data-table-rows-loading",
                key: "loading"
            }, [
                (0, $bu8yf.createElementVNode)("td", {
                    colspan: columns.value.length
                }, [
                    (_slots_loading1 = (_slots_loading = slots.loading) === null || _slots_loading === void 0 ? void 0 : _slots_loading.call(slots)) !== null && _slots_loading1 !== void 0 ? _slots_loading1 : t(props.loadingText)
                ])
            ]);
            var _slots_nodata1;
            if (!props.loading && !props.items.length && !props.hideNoData) return (0, $bu8yf.createElementVNode)("tr", {
                "class": "v-data-table-rows-no-data",
                key: "no-data"
            }, [
                (0, $bu8yf.createElementVNode)("td", {
                    colspan: columns.value.length
                }, [
                    (_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : t(props.noDataText)
                ])
            ]);
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                props.items.map(function(item, index) {
                    var _slots_expandedrow;
                    if (item.type === 'group') {
                        var slotProps = {
                            index: index,
                            item: item,
                            columns: columns.value,
                            isExpanded: isExpanded,
                            toggleExpand: toggleExpand,
                            isSelected: isSelected,
                            toggleSelect: toggleSelect,
                            toggleGroup: toggleGroup,
                            isGroupOpen: isGroupOpen
                        };
                        return slots['group-header'] ? slots['group-header'](slotProps) : (0, $bu8yf.createVNode)((0, $b5601e8c34f2623e$export$386c218acab36b27), (0, $bu8yf.mergeProps)({
                            key: "group-header_".concat(item.id),
                            item: item
                        }, (0, $a36a22ad1d3d1cf5$export$b5ac16d47f658674)(attrs, ':group-header', function() {
                            return slotProps;
                        })), slots);
                    }
                    var slotProps1 = {
                        index: index,
                        item: item.raw,
                        internalItem: item,
                        columns: columns.value,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect
                    };
                    var _item_key;
                    var itemSlotProps = (0, $emQHU._)((0, $iT0je._)({}, slotProps1), {
                        props: (0, $bu8yf.mergeProps)({
                            key: "item_".concat((_item_key = item.key) !== null && _item_key !== void 0 ? _item_key : item.index),
                            onClick: expandOnClick.value ? function() {
                                toggleExpand(item);
                            } : undefined,
                            index: index,
                            item: item,
                            cellProps: props.cellProps,
                            mobile: mobile.value
                        }, (0, $a36a22ad1d3d1cf5$export$b5ac16d47f658674)(attrs, ':row', function() {
                            return slotProps1;
                        }), typeof props.rowProps === 'function' ? props.rowProps({
                            item: slotProps1.item,
                            index: slotProps1.index,
                            internalItem: slotProps1.internalItem
                        }) : props.rowProps)
                    });
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), {
                        key: itemSlotProps.props.key
                    }, [
                        slots.item ? slots.item(itemSlotProps) : (0, $bu8yf.createVNode)((0, $7246693592d1fa27$export$2c0f083ba8593d7), itemSlotProps.props, slots),
                        isExpanded(item) && ((_slots_expandedrow = slots['expanded-row']) === null || _slots_expandedrow === void 0 ? void 0 : _slots_expandedrow.call(slots, slotProps1))
                    ]);
                })
            ]);
        });
        return {};
    }
});




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






var $1abdccdd2ed5d604$export$ba5ebec34950c99a = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    fixedHeader: Boolean,
    fixedFooter: Boolean,
    height: [
        Number,
        String
    ],
    hover: Boolean,
    striped: {
        type: String,
        "default": null,
        validator: function(v) {
            return [
                'even',
                'odd'
            ].includes(v);
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VTable');
var $1abdccdd2ed5d604$export$95f18d4f6bf10502 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTable',
    props: $1abdccdd2ed5d604$export$ba5ebec34950c99a(),
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-table',
                    {
                        'v-table--fixed-height': !!props.height,
                        'v-table--fixed-header': props.fixedHeader,
                        'v-table--fixed-footer': props.fixedFooter,
                        'v-table--has-top': !!slots.top,
                        'v-table--has-bottom': !!slots.bottom,
                        'v-table--hover': props.hover,
                        'v-table--striped-even': props.striped === 'even',
                        'v-table--striped-odd': props.striped === 'odd'
                    },
                    themeClasses.value,
                    densityClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_top, _slots_wrapper, _slots_bottom;
                    return [
                        (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots),
                        slots["default"] ? (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-table__wrapper",
                            style: {
                                height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                            }
                        }, [
                            (0, $bu8yf.createElementVNode)("table", null, [
                                slots["default"]()
                            ])
                        ]) : (_slots_wrapper = slots.wrapper) === null || _slots_wrapper === void 0 ? void 0 : _slots_wrapper.call(slots),
                        (_slots_bottom = slots.bottom) === null || _slots_bottom === void 0 ? void 0 : _slots_bottom.call(slots)
                    ];
                }
            });
        });
        return {};
    }
});





// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $e20428f23bc266c4$export$6d88ad3df0986562 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        "default": 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        "default": null
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ],
    returnObject: Boolean
}, 'DataTable-items');
function $e20428f23bc266c4$export$ef3b10464ff5e4ec(props, item, index, columns) {
    var value = props.returnObject ? item : (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue);
    var selectable = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    var itemColumns = columns.reduce(function(obj, column) {
        if (column.key != null) obj[column.key] = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, column.value);
        return obj;
    }, {});
    return {
        type: 'item',
        key: props.returnObject ? (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue) : value,
        index: index,
        value: value,
        selectable: selectable,
        columns: itemColumns,
        raw: item
    };
}
function $e20428f23bc266c4$export$f8e983a9ac6ba971(props, items, columns) {
    return items.map(function(item, index) {
        return $e20428f23bc266c4$export$ef3b10464ff5e4ec(props, item, index, columns);
    });
}
function $e20428f23bc266c4$export$c7173575102352f3(props, columns) {
    var items = (0, $hXmfK.computed)(function() {
        return $e20428f23bc266c4$export$f8e983a9ac6ba971(props, props.items, columns.value);
    });
    return {
        items: items
    };
}









var $7e722994f167a33b$export$26a5caa325bbad53 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)({}, (0, $7745832faab26163$export$d81faa32148e6046)()), {
    hideDefaultBody: Boolean,
    hideDefaultFooter: Boolean,
    hideDefaultHeader: Boolean,
    width: [
        String,
        Number
    ],
    search: String
}), (0, $2f4785e6f46b655c$export$a6d4f3c269410395)(), (0, $4dfcff052151cced$export$406ee928c389045b)(), (0, $8aa788cc88525700$export$9d1907f8d303b311)(), (0, $e20428f23bc266c4$export$6d88ad3df0986562)(), (0, $3ee4b18c5d85bd4b$export$95e1272f163aea67)(), (0, $d6b7304528d4da19$export$944604c1e22b4d13)(), (0, $8d8a4ec5de2cb572$export$3e579cb6b57f22ae)(), (0, $1abdccdd2ed5d604$export$ba5ebec34950c99a)()), 'DataTable');
var $7e722994f167a33b$export$42ac5235dc91d9ce = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $515a30edd8060cfd$export$a02e477b3b971dbd)(), $7e722994f167a33b$export$26a5caa325bbad53(), (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)(), (0, $261836419047838d$export$85788b26c9087beb)()), 'VDataTable');
var $7e722994f167a33b$export$4cdfcef9678998c7 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTable',
    props: $7e722994f167a33b$export$42ac5235dc91d9ce(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:page': function(value) {
            return true;
        },
        'update:itemsPerPage': function(value) {
            return true;
        },
        'update:sortBy': function(value) {
            return true;
        },
        'update:options': function(value) {
            return true;
        },
        'update:groupBy': function(value) {
            return true;
        },
        'update:expanded': function(value) {
            return true;
        },
        'update:currentItems': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var groupBy = (0, $4dfcff052151cced$export$543cf685fafb29db)(props).groupBy;
        var _createSort = (0, $d6b7304528d4da19$export$10463693a2093403)(props), sortBy = _createSort.sortBy, multiSort = _createSort.multiSort, mustSort = _createSort.mustSort;
        var _createPagination = (0, $515a30edd8060cfd$export$7f3155e3cda021fd)(props), page = _createPagination.page, itemsPerPage = _createPagination.itemsPerPage;
        var disableSort = (0, $hXmfK.toRefs)(props).disableSort;
        var _createHeaders = (0, $8aa788cc88525700$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $hXmfK.toRef)(function() {
                return props.showSelect;
            }),
            showExpand: (0, $hXmfK.toRef)(function() {
                return props.showExpand;
            })
        }), columns = _createHeaders.columns, headers = _createHeaders.headers, sortFunctions = _createHeaders.sortFunctions, sortRawFunctions = _createHeaders.sortRawFunctions, filterFunctions = _createHeaders.filterFunctions;
        var items = (0, $e20428f23bc266c4$export$c7173575102352f3)(props, columns).items;
        var search = (0, $hXmfK.toRef)(function() {
            return props.search;
        });
        var filteredItems = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, items, search, {
            transform: function(item) {
                return item.columns;
            },
            customKeyFilter: filterFunctions
        }).filteredItems;
        var toggleSort = (0, $d6b7304528d4da19$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        }).toggleSort;
        var _provideGroupBy = (0, $4dfcff052151cced$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        }), sortByWithGroups = _provideGroupBy.sortByWithGroups, opened = _provideGroupBy.opened, extractRows = _provideGroupBy.extractRows, isGroupOpen = _provideGroupBy.isGroupOpen, toggleGroup = _provideGroupBy.toggleGroup;
        var sortedItems = (0, $d6b7304528d4da19$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: function(item) {
                return (0, $iT0je._)({}, item.raw, item.columns);
            },
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        }).sortedItems;
        var flatItems = (0, $4dfcff052151cced$export$1d90b49b81ed368a)(sortedItems, groupBy, opened).flatItems;
        var itemsLength = (0, $hXmfK.computed)(function() {
            return flatItems.value.length;
        });
        var _providePagination = (0, $515a30edd8060cfd$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        }), startIndex = _providePagination.startIndex, stopIndex = _providePagination.stopIndex, pageCount = _providePagination.pageCount, setItemsPerPage = _providePagination.setItemsPerPage;
        var paginatedItems = (0, $515a30edd8060cfd$export$e196d5e55ca1e2d5)({
            items: flatItems,
            startIndex: startIndex,
            stopIndex: stopIndex,
            itemsPerPage: itemsPerPage
        }).paginatedItems;
        var paginatedItemsWithoutGroups = (0, $hXmfK.computed)(function() {
            return extractRows(paginatedItems.value);
        });
        var _provideSelection = (0, $3ee4b18c5d85bd4b$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: paginatedItemsWithoutGroups
        }), isSelected = _provideSelection.isSelected, select = _provideSelection.select, selectAll = _provideSelection.selectAll, toggleSelect = _provideSelection.toggleSelect, someSelected = _provideSelection.someSelected, allSelected = _provideSelection.allSelected;
        var _provideExpanded = (0, $2f4785e6f46b655c$export$6c2637d154b76687)(props), isExpanded = _provideExpanded.isExpanded, toggleExpand = _provideExpanded.toggleExpand;
        (0, $8457cdf7ca26e52e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $hXmfK.toRef)(function() {
                    return props.hideNoData;
                }),
                noDataText: (0, $hXmfK.toRef)(function() {
                    return props.noDataText;
                }),
                loading: (0, $hXmfK.toRef)(function() {
                    return props.loading;
                }),
                loadingText: (0, $hXmfK.toRef)(function() {
                    return props.loadingText;
                })
            }
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: paginatedItemsWithoutGroups.value.map(function(item) {
                    return item.raw;
                }),
                internalItems: paginatedItemsWithoutGroups.value,
                groupedItems: paginatedItems.value,
                columns: columns.value,
                headers: headers.value
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var dataTableFooterProps = (0, $261836419047838d$export$3403786a0c6524a).filterProps(props);
            var dataTableHeadersProps = (0, $8d8a4ec5de2cb572$export$c619622075eadff7).filterProps(props);
            var dataTableRowsProps = (0, $7745832faab26163$export$e10d8e097873db4f).filterProps(props);
            var tableProps = (0, $1abdccdd2ed5d604$export$95f18d4f6bf10502).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $1abdccdd2ed5d604$export$95f18d4f6bf10502), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--show-select': props.showSelect,
                        'v-data-table--loading': props.loading
                    },
                    props["class"]
                ],
                style: props.style
            }, tableProps, {
                fixedHeader: props.fixedHeader || props.sticky
            }), {
                top: function() {
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                "default": function() {
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return slots["default"] ? slots["default"](slotProps.value) : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                        !props.hideDefaultHeader && (0, $bu8yf.createElementVNode)("thead", {
                            key: "thead"
                        }, [
                            (0, $bu8yf.createVNode)((0, $8d8a4ec5de2cb572$export$c619622075eadff7), dataTableHeadersProps, slots)
                        ]),
                        (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                        !props.hideDefaultBody && (0, $bu8yf.createElementVNode)("tbody", null, [
                            (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $bu8yf.createVNode)((0, $7745832faab26163$export$e10d8e097873db4f), (0, $bu8yf.mergeProps)(attrs, dataTableRowsProps, {
                                items: paginatedItems.value
                            }), slots),
                            (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value)
                        ]),
                        (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                        (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                    ]);
                },
                bottom: function() {
                    return slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), null, null),
                        (0, $bu8yf.createVNode)((0, $261836419047838d$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ]);
                }
            });
        });
        return {};
    }
});







var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

















var $a7da6ec65d64ce0e$export$56a6c8c912094255 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $7e722994f167a33b$export$26a5caa325bbad53)(), [
    'hideDefaultFooter'
]), (0, $4dfcff052151cced$export$406ee928c389045b)(), (0, $d8c2c78df0f65c65$export$7703b7ab4acf2c49)(), (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)()), 'VDataTableVirtual');
var $a7da6ec65d64ce0e$export$4134771f7c9e4b2 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableVirtual',
    props: $a7da6ec65d64ce0e$export$56a6c8c912094255(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:sortBy': function(value) {
            return true;
        },
        'update:options': function(value) {
            return true;
        },
        'update:groupBy': function(value) {
            return true;
        },
        'update:expanded': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var groupBy = (0, $4dfcff052151cced$export$543cf685fafb29db)(props).groupBy;
        var _createSort = (0, $d6b7304528d4da19$export$10463693a2093403)(props), sortBy = _createSort.sortBy, multiSort = _createSort.multiSort, mustSort = _createSort.mustSort;
        var disableSort = (0, $hXmfK.toRefs)(props).disableSort;
        var _createHeaders = (0, $8aa788cc88525700$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $hXmfK.toRef)(function() {
                return props.showSelect;
            }),
            showExpand: (0, $hXmfK.toRef)(function() {
                return props.showExpand;
            })
        }), columns = _createHeaders.columns, headers = _createHeaders.headers, filterFunctions = _createHeaders.filterFunctions, sortFunctions = _createHeaders.sortFunctions, sortRawFunctions = _createHeaders.sortRawFunctions;
        var items = (0, $e20428f23bc266c4$export$c7173575102352f3)(props, columns).items;
        var search = (0, $hXmfK.toRef)(function() {
            return props.search;
        });
        var filteredItems = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, items, search, {
            transform: function(item) {
                return item.columns;
            },
            customKeyFilter: filterFunctions
        }).filteredItems;
        var toggleSort = (0, $d6b7304528d4da19$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort
        }).toggleSort;
        var _provideGroupBy = (0, $4dfcff052151cced$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        }), sortByWithGroups = _provideGroupBy.sortByWithGroups, opened = _provideGroupBy.opened, extractRows = _provideGroupBy.extractRows, isGroupOpen = _provideGroupBy.isGroupOpen, toggleGroup = _provideGroupBy.toggleGroup;
        var sortedItems = (0, $d6b7304528d4da19$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: function(item) {
                return (0, $iT0je._)({}, item.raw, item.columns);
            },
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        }).sortedItems;
        var flatItems = (0, $4dfcff052151cced$export$1d90b49b81ed368a)(sortedItems, groupBy, opened).flatItems;
        var allItems = (0, $hXmfK.computed)(function() {
            return extractRows(flatItems.value);
        });
        var _provideSelection = (0, $3ee4b18c5d85bd4b$export$c7142f0d6d0f341b)(props, {
            allItems: allItems,
            currentPage: allItems
        }), isSelected = _provideSelection.isSelected, select = _provideSelection.select, selectAll = _provideSelection.selectAll, toggleSelect = _provideSelection.toggleSelect, someSelected = _provideSelection.someSelected, allSelected = _provideSelection.allSelected;
        var _provideExpanded = (0, $2f4785e6f46b655c$export$6c2637d154b76687)(props), isExpanded = _provideExpanded.isExpanded, toggleExpand = _provideExpanded.toggleExpand;
        var _useVirtual = (0, $d8c2c78df0f65c65$export$ebc1863da693699a)(props, flatItems), containerRef = _useVirtual.containerRef, markerRef = _useVirtual.markerRef, paddingTop = _useVirtual.paddingTop, paddingBottom = _useVirtual.paddingBottom, computedItems = _useVirtual.computedItems, handleItemResize = _useVirtual.handleItemResize, handleScroll = _useVirtual.handleScroll, handleScrollend = _useVirtual.handleScrollend, calculateVisibleItems = _useVirtual.calculateVisibleItems, scrollToIndex = _useVirtual.scrollToIndex;
        var displayItems = (0, $hXmfK.computed)(function() {
            return computedItems.value.map(function(item) {
                return item.raw;
            });
        });
        (0, $8457cdf7ca26e52e$export$b8ae39f344200a7d)({
            sortBy: sortBy,
            page: (0, $hXmfK.shallowRef)(1),
            itemsPerPage: (0, $hXmfK.shallowRef)(-1),
            groupBy: groupBy,
            search: search
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $hXmfK.toRef)(function() {
                    return props.hideNoData;
                }),
                noDataText: (0, $hXmfK.toRef)(function() {
                    return props.noDataText;
                }),
                loading: (0, $hXmfK.toRef)(function() {
                    return props.loading;
                }),
                loadingText: (0, $hXmfK.toRef)(function() {
                    return props.loadingText;
                })
            }
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                sortBy: sortBy.value,
                toggleSort: toggleSort,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: allItems.value.map(function(item) {
                    return item.raw;
                }),
                internalItems: allItems.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var dataTableHeadersProps = (0, $8d8a4ec5de2cb572$export$c619622075eadff7).filterProps(props);
            var dataTableRowsProps = (0, $7745832faab26163$export$e10d8e097873db4f).filterProps(props);
            var tableProps = (0, $1abdccdd2ed5d604$export$95f18d4f6bf10502).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $1abdccdd2ed5d604$export$95f18d4f6bf10502), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props["class"]
                ],
                style: props.style
            }, tableProps, {
                fixedHeader: props.fixedHeader || props.sticky
            }), {
                top: function() {
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                wrapper: function() {
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return (0, $bu8yf.createElementVNode)("div", {
                        ref: containerRef,
                        onScrollPassive: handleScroll,
                        onScrollend: handleScrollend,
                        "class": "v-table__wrapper",
                        style: {
                            height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                        }
                    }, [
                        (0, $bu8yf.createElementVNode)("table", null, [
                            (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                            !props.hideDefaultHeader && (0, $bu8yf.createElementVNode)("thead", {
                                key: "thead"
                            }, [
                                (0, $bu8yf.createVNode)((0, $8d8a4ec5de2cb572$export$c619622075eadff7), dataTableHeadersProps, slots)
                            ]),
                            (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                            !props.hideDefaultBody && (0, $bu8yf.createElementVNode)("tbody", {
                                key: "tbody"
                            }, [
                                (0, $bu8yf.createElementVNode)("tr", {
                                    ref: markerRef,
                                    style: {
                                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingTop.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $bu8yf.createElementVNode)("td", {
                                        colspan: columns.value.length,
                                        style: {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ]),
                                (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                                (0, $bu8yf.createVNode)((0, $7745832faab26163$export$e10d8e097873db4f), (0, $bu8yf.mergeProps)(attrs, dataTableRowsProps, {
                                    items: displayItems.value
                                }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                                    item: function(itemSlotProps) {
                                        return (0, $bu8yf.createVNode)((0, $9956e44cfc4d2c8d$export$e996ecbe8aa756e9), {
                                            key: itemSlotProps.internalItem.index,
                                            renderless: true,
                                            "onUpdate:height": function(height) {
                                                return handleItemResize(itemSlotProps.internalItem.index, height);
                                            }
                                        }, {
                                            "default": function(_ref2) {
                                                var _slots_item;
                                                var itemRef = _ref2.itemRef;
                                                var _slots_item1;
                                                return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, (0, $emQHU._)((0, $iT0je._)({}, itemSlotProps), {
                                                    itemRef: itemRef
                                                }))) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $7246693592d1fa27$export$2c0f083ba8593d7), (0, $bu8yf.mergeProps)(itemSlotProps.props, {
                                                    ref: itemRef,
                                                    key: itemSlotProps.internalItem.index,
                                                    index: itemSlotProps.internalItem.index
                                                }), slots);
                                            }
                                        });
                                    }
                                })),
                                (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value),
                                (0, $bu8yf.createElementVNode)("tr", {
                                    style: {
                                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(paddingBottom.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $bu8yf.createElementVNode)("td", {
                                        colspan: columns.value.length,
                                        style: {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ])
                            ]),
                            (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                            (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                        ])
                    ]);
                },
                bottom: function() {
                    var _slots_bottom;
                    return (_slots_bottom = slots.bottom) === null || _slots_bottom === void 0 ? void 0 : _slots_bottom.call(slots, slotProps.value);
                }
            });
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
















var $8a9d5b31447cb359$export$acc72a1badefcde3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    itemsLength: {
        type: [
            Number,
            String
        ],
        required: true
    }
}, (0, $515a30edd8060cfd$export$a02e477b3b971dbd)(), (0, $7e722994f167a33b$export$26a5caa325bbad53)(), (0, $261836419047838d$export$85788b26c9087beb)()), 'VDataTableServer');
var $8a9d5b31447cb359$export$ad1f17a300f73544 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDataTableServer',
    props: $8a9d5b31447cb359$export$acc72a1badefcde3(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        },
        'update:page': function(page) {
            return true;
        },
        'update:itemsPerPage': function(page) {
            return true;
        },
        'update:sortBy': function(sortBy) {
            return true;
        },
        'update:options': function(options) {
            return true;
        },
        'update:expanded': function(options) {
            return true;
        },
        'update:groupBy': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var groupBy = (0, $4dfcff052151cced$export$543cf685fafb29db)(props).groupBy;
        var _createSort = (0, $d6b7304528d4da19$export$10463693a2093403)(props), sortBy = _createSort.sortBy, multiSort = _createSort.multiSort, mustSort = _createSort.mustSort;
        var _createPagination = (0, $515a30edd8060cfd$export$7f3155e3cda021fd)(props), page = _createPagination.page, itemsPerPage = _createPagination.itemsPerPage;
        var disableSort = (0, $hXmfK.toRefs)(props).disableSort;
        var itemsLength = (0, $hXmfK.computed)(function() {
            return parseInt(props.itemsLength, 10);
        });
        var _createHeaders = (0, $8aa788cc88525700$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $hXmfK.toRef)(function() {
                return props.showSelect;
            }),
            showExpand: (0, $hXmfK.toRef)(function() {
                return props.showExpand;
            })
        }), columns = _createHeaders.columns, headers = _createHeaders.headers;
        var items = (0, $e20428f23bc266c4$export$c7173575102352f3)(props, columns).items;
        var toggleSort = (0, $d6b7304528d4da19$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        }).toggleSort;
        var _provideGroupBy = (0, $4dfcff052151cced$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        }), opened = _provideGroupBy.opened, isGroupOpen = _provideGroupBy.isGroupOpen, toggleGroup = _provideGroupBy.toggleGroup, extractRows = _provideGroupBy.extractRows;
        var _providePagination = (0, $515a30edd8060cfd$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        }), pageCount = _providePagination.pageCount, setItemsPerPage = _providePagination.setItemsPerPage;
        var flatItems = (0, $4dfcff052151cced$export$1d90b49b81ed368a)(items, groupBy, opened).flatItems;
        var _provideSelection = (0, $3ee4b18c5d85bd4b$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: items
        }), isSelected = _provideSelection.isSelected, select = _provideSelection.select, selectAll = _provideSelection.selectAll, toggleSelect = _provideSelection.toggleSelect, someSelected = _provideSelection.someSelected, allSelected = _provideSelection.allSelected;
        var _provideExpanded = (0, $2f4785e6f46b655c$export$6c2637d154b76687)(props), isExpanded = _provideExpanded.isExpanded, toggleExpand = _provideExpanded.toggleExpand;
        var itemsWithoutGroups = (0, $hXmfK.computed)(function() {
            return extractRows(items.value);
        });
        (0, $8457cdf7ca26e52e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: (0, $hXmfK.toRef)(function() {
                return props.search;
            })
        });
        (0, $bu8yf.provide)('v-data-table', {
            toggleSort: toggleSort,
            sortBy: sortBy
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $hXmfK.toRef)(function() {
                    return props.hideNoData;
                }),
                noDataText: (0, $hXmfK.toRef)(function() {
                    return props.noDataText;
                }),
                loading: (0, $hXmfK.toRef)(function() {
                    return props.loading;
                }),
                loadingText: (0, $hXmfK.toRef)(function() {
                    return props.loadingText;
                })
            }
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: itemsWithoutGroups.value.map(function(item) {
                    return item.raw;
                }),
                internalItems: itemsWithoutGroups.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var dataTableFooterProps = (0, $261836419047838d$export$3403786a0c6524a).filterProps(props);
            var dataTableHeadersProps = (0, $8d8a4ec5de2cb572$export$c619622075eadff7).filterProps(props);
            var dataTableRowsProps = (0, $7745832faab26163$export$e10d8e097873db4f).filterProps(props);
            var tableProps = (0, $1abdccdd2ed5d604$export$95f18d4f6bf10502).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $1abdccdd2ed5d604$export$95f18d4f6bf10502), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props["class"]
                ],
                style: props.style
            }, tableProps, {
                fixedHeader: props.fixedHeader || props.sticky
            }), {
                top: function() {
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                "default": function() {
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return slots["default"] ? slots["default"](slotProps.value) : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                        !props.hideDefaultHeader && (0, $bu8yf.createElementVNode)("thead", {
                            key: "thead",
                            "class": "v-data-table__thead",
                            role: "rowgroup"
                        }, [
                            (0, $bu8yf.createVNode)((0, $8d8a4ec5de2cb572$export$c619622075eadff7), dataTableHeadersProps, slots)
                        ]),
                        (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                        !props.hideDefaultBody && (0, $bu8yf.createElementVNode)("tbody", {
                            "class": "v-data-table__tbody",
                            role: "rowgroup"
                        }, [
                            (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $bu8yf.createVNode)((0, $7745832faab26163$export$e10d8e097873db4f), (0, $bu8yf.mergeProps)(attrs, dataTableRowsProps, {
                                items: flatItems.value
                            }), slots),
                            (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value)
                        ]),
                        (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                        (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                    ]);
                },
                bottom: function() {
                    return slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), null, null),
                        (0, $bu8yf.createVNode)((0, $261836419047838d$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ]);
                }
            });
        });
    }
});




var $bf27d80d3edc10c5$exports = {};

$parcel$export($bf27d80d3edc10c5$exports, "VDatePicker", function () { return $0da6153ded56cc86$export$a38ea195118a640d; });
$parcel$export($bf27d80d3edc10c5$exports, "VDatePickerControls", function () { return $2aec657b18722c39$export$12f65deebc2d352e; });
$parcel$export($bf27d80d3edc10c5$exports, "VDatePickerHeader", function () { return $a9e108a6d4ca5e0a$export$47b045316d89f8ff; });
$parcel$export($bf27d80d3edc10c5$exports, "VDatePickerMonth", function () { return $340e576ce57a3e47$export$7affb9b3ced7ba5e; });
$parcel$export($bf27d80d3edc10c5$exports, "VDatePickerMonths", function () { return $6a73379d8109234a$export$1d5c3cfa8e041a10; });
$parcel$export($bf27d80d3edc10c5$exports, "VDatePickerYears", function () { return $29e529379fc60941$export$3faa77515f7b0baa; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


// Styles


var $fcf55e69a53a0d0e$export$78e533170324578f = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-spacer', 'div', 'VSpacer');




var $2aec657b18722c39$export$48a55eee69fece84 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    active: {
        type: [
            String,
            Array
        ],
        "default": undefined
    },
    controlHeight: [
        Number,
        String
    ],
    disabled: {
        type: [
            Boolean,
            String,
            Array
        ],
        "default": null
    },
    nextIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$next'
    },
    prevIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$prev'
    },
    modeIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$subgroup'
    },
    text: String,
    viewMode: {
        type: String,
        "default": 'month'
    }
}, 'VDatePickerControls');
var $2aec657b18722c39$export$12f65deebc2d352e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePickerControls',
    props: $2aec657b18722c39$export$48a55eee69fece84(),
    emits: {
        'click:year': function() {
            return true;
        },
        'click:month': function() {
            return true;
        },
        'click:prev': function() {
            return true;
        },
        'click:next': function() {
            return true;
        },
        'click:text': function() {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        var disableMonth = (0, $hXmfK.computed)(function() {
            return Array.isArray(props.disabled) ? props.disabled.includes('text') : !!props.disabled;
        });
        var disableYear = (0, $hXmfK.computed)(function() {
            return Array.isArray(props.disabled) ? props.disabled.includes('mode') : !!props.disabled;
        });
        var disablePrev = (0, $hXmfK.computed)(function() {
            return Array.isArray(props.disabled) ? props.disabled.includes('prev') : !!props.disabled;
        });
        var disableNext = (0, $hXmfK.computed)(function() {
            return Array.isArray(props.disabled) ? props.disabled.includes('next') : !!props.disabled;
        });
        function onClickPrev() {
            emit('click:prev');
        }
        function onClickNext() {
            emit('click:next');
        }
        function onClickYear() {
            emit('click:year');
        }
        function onClickMonth() {
            emit('click:month');
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            // TODO: add slot support and scope defaults
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-date-picker-controls'
                ]),
                style: {
                    '--v-date-picker-controls-height': (0, $31779689cfd5da50$export$286ad215293a0860)(props.controlHeight)
                }
            }, [
                (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__month-btn",
                    "data-testid": "month-btn",
                    disabled: disableMonth.value,
                    text: props.text,
                    variant: "text",
                    rounded: true,
                    onClick: onClickMonth
                }, null),
                (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__mode-btn",
                    "data-testid": "year-btn",
                    disabled: disableYear.value,
                    density: "comfortable",
                    icon: props.modeIcon,
                    variant: "text",
                    onClick: onClickYear
                }, null),
                (0, $bu8yf.createVNode)((0, $fcf55e69a53a0d0e$export$78e533170324578f), null, null),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-date-picker-controls__month"
                }, [
                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        "data-testid": "prev-month",
                        disabled: disablePrev.value,
                        density: "comfortable",
                        icon: props.prevIcon,
                        variant: "text",
                        onClick: onClickPrev
                    }, null),
                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        "data-testid": "next-month",
                        disabled: disableNext.value,
                        icon: props.nextIcon,
                        density: "comfortable",
                        variant: "text",
                        onClick: onClickNext
                    }, null)
                ])
            ]);
        });
        return {};
    }
});


parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







var $a9e108a6d4ca5e0a$export$ad3160ece9498a06 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    appendIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    color: String,
    header: String,
    transition: String,
    onClick: (0, $31779689cfd5da50$export$cefab237a347bf23)()
}, 'VDatePickerHeader');
var $a9e108a6d4ca5e0a$export$47b045316d89f8ff = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePickerHeader',
    props: $a9e108a6d4ca5e0a$export$ad3160ece9498a06(),
    emits: {
        click: function() {
            return true;
        },
        'click:append': function() {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        function onClick() {
            emit('click');
        }
        function onClickAppend() {
            emit('click:append');
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasContent = !!(slots["default"] || props.header);
            var hasAppend = !!(slots.append || props.appendIcon);
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-date-picker-header',
                    {
                        'v-date-picker-header--clickable': !!props.onClick
                    },
                    backgroundColorClasses.value
                ]),
                style: (0, $d8jBh.normalizeStyle)(backgroundColorStyles.value),
                onClick: onClick
            }, [
                slots.prepend && (0, $bu8yf.createElementVNode)("div", {
                    key: "prepend",
                    "class": "v-date-picker-header__prepend"
                }, [
                    slots.prepend()
                ]),
                hasContent && (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                    key: "content",
                    name: props.transition
                }, {
                    "default": function() {
                        var _slots_default;
                        var _slots_default1;
                        return [
                            (0, $bu8yf.createElementVNode)("div", {
                                key: props.header,
                                "class": "v-date-picker-header__content"
                            }, [
                                (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.header
                            ])
                        ];
                    }
                }),
                hasAppend && (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-date-picker-header__append"
                }, [
                    !slots.append ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        key: "append-btn",
                        icon: props.appendIcon,
                        variant: "text",
                        onClick: onClickAppend
                    }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        key: "append-defaults",
                        disabled: !props.appendIcon,
                        defaults: {
                            VBtn: {
                                icon: props.appendIcon,
                                variant: 'text'
                            }
                        }
                    }, {
                        "default": function() {
                            var _slots_append;
                            return [
                                (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                            ];
                        }
                    })
                ])
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


// Composables


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");

var $8e52a942b51525e7$export$e6f7535869f26d31 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    allowedDates: [
        Array,
        Function
    ],
    disabled: {
        type: Boolean,
        "default": null
    },
    displayValue: null,
    modelValue: Array,
    month: [
        Number,
        String
    ],
    max: null,
    min: null,
    showAdjacentMonths: Boolean,
    year: [
        Number,
        String
    ],
    weekdays: {
        type: Array,
        "default": function() {
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
        }
    },
    weeksInMonth: {
        type: String,
        "default": 'dynamic'
    },
    firstDayOfWeek: {
        type: [
            Number,
            String
        ],
        "default": undefined
    },
    weekdayFormat: String
}, 'calendar');
function $8e52a942b51525e7$export$3ee915f8151bd4f1(props) {
    var adapter = (0, $ff9e087639c00a2b$export$e51e224239492327)();
    var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', [], function(v) {
        return (0, $31779689cfd5da50$export$76411cac38121ecb)(v).map(function(i) {
            return adapter.date(i);
        });
    });
    var displayValue = (0, $hXmfK.computed)(function() {
        if (props.displayValue) return adapter.date(props.displayValue);
        if (model.value.length > 0) return adapter.date(model.value[0]);
        if (props.min) return adapter.date(props.min);
        if (Array.isArray(props.allowedDates)) return adapter.date(props.allowedDates[0]);
        return adapter.date();
    });
    var year = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'year', undefined, function(v) {
        var value = v != null ? Number(v) : adapter.getYear(displayValue.value);
        return adapter.startOfYear(adapter.setYear(adapter.date(), value));
    }, function(v) {
        return adapter.getYear(v);
    });
    var month = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'month', undefined, function(v) {
        var value = v != null ? Number(v) : adapter.getMonth(displayValue.value);
        var date = adapter.setYear(adapter.startOfMonth(adapter.date()), adapter.getYear(year.value));
        return adapter.setMonth(date, value);
    }, function(v) {
        return adapter.getMonth(v);
    });
    var weekdayLabels = (0, $hXmfK.computed)(function() {
        var firstDayOfWeek = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
        return adapter.getWeekdays(props.firstDayOfWeek, props.weekdayFormat).filter(function(_, i) {
            return props.weekdays.includes((i + firstDayOfWeek) % 7);
        });
    });
    var weeksInMonth = (0, $hXmfK.computed)(function() {
        var weeks = adapter.getWeekArray(month.value, props.firstDayOfWeek);
        var days = weeks.flat();
        // Make sure there's always 6 weeks in month (6 * 7 days)
        // if weeksInMonth is 'static'
        var daysInMonth = 42;
        if (props.weeksInMonth === 'static' && days.length < daysInMonth) {
            var lastDay = days[days.length - 1];
            var week = [];
            for(var day = 1; day <= daysInMonth - days.length; day++){
                week.push(adapter.addDays(lastDay, day));
                if (day % 7 === 0) {
                    weeks.push(week);
                    week = [];
                }
            }
        }
        return weeks;
    });
    function genDays(days, today) {
        return days.filter(function(date) {
            return props.weekdays.includes(adapter.toJsDate(date).getDay());
        }).map(function(date, index) {
            var isoDate = adapter.toISO(date);
            var isAdjacent = !adapter.isSameMonth(date, month.value);
            var isStart = adapter.isSameDay(date, adapter.startOfMonth(month.value));
            var isEnd = adapter.isSameDay(date, adapter.endOfMonth(month.value));
            var isSame = adapter.isSameDay(date, month.value);
            var weekdaysCount = props.weekdays.length;
            return {
                date: date,
                formatted: adapter.format(date, 'keyboardDate'),
                isAdjacent: isAdjacent,
                isDisabled: isDisabled(date),
                isEnd: isEnd,
                isHidden: isAdjacent && !props.showAdjacentMonths,
                isSame: isSame,
                isSelected: model.value.some(function(value) {
                    return adapter.isSameDay(date, value);
                }),
                isStart: isStart,
                isToday: adapter.isSameDay(date, today),
                isWeekEnd: index % weekdaysCount === weekdaysCount - 1,
                isWeekStart: index % weekdaysCount === 0,
                isoDate: isoDate,
                localized: adapter.format(date, 'dayOfMonth'),
                month: adapter.getMonth(date),
                year: adapter.getYear(date)
            };
        });
    }
    var daysInWeek = (0, $hXmfK.computed)(function() {
        var lastDay = adapter.startOfWeek(displayValue.value, props.firstDayOfWeek);
        var week = [];
        for(var day = 0; day <= 6; day++)week.push(adapter.addDays(lastDay, day));
        var today = adapter.date();
        return genDays(week, today);
    });
    var daysInMonth = (0, $hXmfK.computed)(function() {
        var days = weeksInMonth.value.flat();
        var today = adapter.date();
        return genDays(days, today);
    });
    var weekNumbers = (0, $hXmfK.computed)(function() {
        return weeksInMonth.value.map(function(week) {
            return week.length ? adapter.getWeek(week[0], props.firstDayOfWeek) : null;
        });
    });
    function isDisabled(value) {
        if (props.disabled) return true;
        var date = adapter.date(value);
        if (props.min && adapter.isBefore(adapter.endOfDay(date), adapter.date(props.min))) return true;
        if (props.max && adapter.isAfter(date, adapter.date(props.max))) return true;
        if (Array.isArray(props.allowedDates) && props.allowedDates.length > 0) return !props.allowedDates.some(function(d) {
            return adapter.isSameDay(adapter.date(d), date);
        });
        if (typeof props.allowedDates === 'function') return !props.allowedDates(date);
        return false;
    }
    return {
        displayValue: displayValue,
        daysInMonth: daysInMonth,
        daysInWeek: daysInWeek,
        genDays: genDays,
        model: model,
        weeksInMonth: weeksInMonth,
        weekdayLabels: weekdayLabels,
        weekNumbers: weekNumbers
    };
}





var $340e576ce57a3e47$export$ca1dc982fe7d1325 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    hideWeekdays: Boolean,
    multiple: [
        Boolean,
        Number,
        String
    ],
    showWeek: Boolean,
    transition: {
        type: String,
        "default": 'picker-transition'
    },
    reverseTransition: {
        type: String,
        "default": 'picker-reverse-transition'
    }
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $8e52a942b51525e7$export$e6f7535869f26d31)(), [
    'displayValue'
])), 'VDatePickerMonth');
var $340e576ce57a3e47$export$7affb9b3ced7ba5e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonth',
    props: $340e576ce57a3e47$export$ca1dc982fe7d1325(),
    emits: {
        'update:modelValue': function(date) {
            return true;
        },
        'update:month': function(date) {
            return true;
        },
        'update:year': function(date) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var daysRef = (0, $hXmfK.ref)();
        var _useCalendar = (0, $8e52a942b51525e7$export$3ee915f8151bd4f1)(props), daysInMonth = _useCalendar.daysInMonth, model = _useCalendar.model, weekNumbers = _useCalendar.weekNumbers, weekdayLabels = _useCalendar.weekdayLabels;
        var adapter = (0, $ff9e087639c00a2b$export$e51e224239492327)();
        var rangeStart = (0, $hXmfK.shallowRef)();
        var rangeStop = (0, $hXmfK.shallowRef)();
        var isReverse = (0, $hXmfK.shallowRef)(false);
        var transition = (0, $hXmfK.toRef)(function() {
            return !isReverse.value ? props.transition : props.reverseTransition;
        });
        if (props.multiple === 'range' && model.value.length > 0) {
            rangeStart.value = model.value[0];
            if (model.value.length > 1) rangeStop.value = model.value[model.value.length - 1];
        }
        var atMax = (0, $hXmfK.computed)(function() {
            var max = [
                'number',
                'string'
            ].includes((0, $3KZcf._)(props.multiple)) ? Number(props.multiple) : Infinity;
            return model.value.length >= max;
        });
        (0, $hXmfK.watch)(daysInMonth, function(val, oldVal) {
            if (!oldVal) return;
            isReverse.value = adapter.isBefore(val[0].date, oldVal[0].date);
        });
        function onRangeClick(value) {
            var _value = adapter.startOfDay(value);
            if (model.value.length === 0) rangeStart.value = undefined;
            else if (model.value.length === 1) {
                rangeStart.value = model.value[0];
                rangeStop.value = undefined;
            }
            if (!rangeStart.value) {
                rangeStart.value = _value;
                model.value = [
                    rangeStart.value
                ];
            } else if (!rangeStop.value) {
                if (adapter.isSameDay(_value, rangeStart.value)) {
                    rangeStart.value = undefined;
                    model.value = [];
                    return;
                } else if (adapter.isBefore(_value, rangeStart.value)) {
                    rangeStop.value = adapter.endOfDay(rangeStart.value);
                    rangeStart.value = _value;
                } else rangeStop.value = adapter.endOfDay(_value);
                model.value = (0, $ff9e087639c00a2b$export$788d03e430c3bd7a)(adapter, rangeStart.value, rangeStop.value);
            } else {
                rangeStart.value = value;
                rangeStop.value = undefined;
                model.value = [
                    rangeStart.value
                ];
            }
        }
        function onMultipleClick(value) {
            var index = model.value.findIndex(function(selection) {
                return adapter.isSameDay(selection, value);
            });
            if (index === -1) model.value = (0, $7WNf6._)(model.value).concat([
                value
            ]);
            else {
                var _$value = (0, $7WNf6._)(model.value);
                _$value.splice(index, 1);
                model.value = _$value;
            }
        }
        function onClick(value) {
            if (props.multiple === 'range') onRangeClick(value);
            else if (props.multiple) onMultipleClick(value);
            else model.value = [
                value
            ];
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-date-picker-month",
                style: {
                    '--v-date-picker-days-in-week': props.weekdays.length
                }
            }, [
                props.showWeek && (0, $bu8yf.createElementVNode)("div", {
                    key: "weeks",
                    "class": "v-date-picker-month__weeks"
                }, [
                    !props.hideWeekdays && (0, $bu8yf.createElementVNode)("div", {
                        key: "hide-week-days",
                        "class": "v-date-picker-month__day"
                    }, [
                        (0, $bu8yf.createTextVNode)("\xA0")
                    ]),
                    weekNumbers.value.map(function(week) {
                        return (0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-date-picker-month__day',
                                'v-date-picker-month__day--adjacent'
                            ])
                        }, [
                            week
                        ]);
                    })
                ]),
                (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                    name: transition.value
                }, {
                    "default": function() {
                        var _daysInMonth_value__date;
                        return [
                            (0, $bu8yf.createElementVNode)("div", {
                                ref: daysRef,
                                key: (_daysInMonth_value__date = daysInMonth.value[0].date) === null || _daysInMonth_value__date === void 0 ? void 0 : _daysInMonth_value__date.toString(),
                                "class": "v-date-picker-month__days"
                            }, [
                                !props.hideWeekdays && weekdayLabels.value.map(function(weekDay) {
                                    return (0, $bu8yf.createElementVNode)("div", {
                                        "class": (0, $d8jBh.normalizeClass)([
                                            'v-date-picker-month__day',
                                            'v-date-picker-month__weekday'
                                        ])
                                    }, [
                                        weekDay
                                    ]);
                                }),
                                daysInMonth.value.map(function(item, i) {
                                    var _slots_day;
                                    var slotProps = {
                                        props: {
                                            "class": 'v-date-picker-month__day-btn',
                                            color: item.isSelected || item.isToday ? props.color : undefined,
                                            disabled: item.isDisabled,
                                            icon: true,
                                            ripple: false,
                                            text: item.localized,
                                            variant: item.isSelected ? 'flat' : item.isToday ? 'outlined' : 'text',
                                            onClick: function() {
                                                return onClick(item.date);
                                            }
                                        },
                                        item: item,
                                        i: i
                                    };
                                    if (atMax.value && !item.isSelected) item.isDisabled = true;
                                    var _slots_day1;
                                    return (0, $bu8yf.createElementVNode)("div", {
                                        "class": (0, $d8jBh.normalizeClass)([
                                            'v-date-picker-month__day',
                                            {
                                                'v-date-picker-month__day--adjacent': item.isAdjacent,
                                                'v-date-picker-month__day--hide-adjacent': item.isHidden,
                                                'v-date-picker-month__day--selected': item.isSelected,
                                                'v-date-picker-month__day--week-end': item.isWeekEnd,
                                                'v-date-picker-month__day--week-start': item.isWeekStart
                                            }
                                        ]),
                                        "data-v-date": !item.isDisabled ? item.isoDate : undefined
                                    }, [
                                        (props.showAdjacentMonths || !item.isAdjacent) && ((_slots_day1 = (_slots_day = slots.day) === null || _slots_day === void 0 ? void 0 : _slots_day.call(slots, slotProps)) !== null && _slots_day1 !== void 0 ? _slots_day1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), slotProps.props, null))
                                    ]);
                                })
                            ])
                        ];
                    }
                })
            ]);
        });
    }
});


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");





var $6a73379d8109234a$export$70df29ae6028d97b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    year: Number,
    allowedMonths: [
        Array,
        Function
    ]
}, 'VDatePickerMonths');
var $6a73379d8109234a$export$1d5c3cfa8e041a10 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonths',
    props: $6a73379d8109234a$export$70df29ae6028d97b(),
    emits: {
        'update:modelValue': function(date) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var adapter = (0, $ff9e087639c00a2b$export$e51e224239492327)();
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var months = (0, $hXmfK.computed)(function() {
            var date = adapter.startOfYear(adapter.date());
            if (props.year) date = adapter.setYear(date, props.year);
            return (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(12).map(function(i) {
                var text = adapter.format(date, 'monthShort');
                var isDisabled = !!(!isMonthAllowed(i) || props.min && adapter.isAfter(adapter.startOfMonth(adapter.date(props.min)), date) || props.max && adapter.isAfter(date, adapter.startOfMonth(adapter.date(props.max))));
                date = adapter.getNextMonth(date);
                return {
                    isDisabled: isDisabled,
                    text: text,
                    value: i
                };
            });
        });
        (0, $bu8yf.watchEffect)(function() {
            var _model_value;
            model.value = (_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : adapter.getMonth(adapter.date());
        });
        function isMonthAllowed(month) {
            if (Array.isArray(props.allowedMonths) && props.allowedMonths.length) return props.allowedMonths.includes(month);
            if (typeof props.allowedMonths === 'function') return props.allowedMonths(month);
            return true;
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-date-picker-months",
                style: {
                    height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-date-picker-months__content"
                }, [
                    months.value.map(function(month, i) {
                        var onClick = function onClick(i) {
                            if (model.value === i) {
                                emit('update:modelValue', model.value);
                                return;
                            }
                            model.value = i;
                        };
                        var _slots_month;
                        var btnProps = {
                            active: model.value === i,
                            color: model.value === i ? props.color : undefined,
                            disabled: month.isDisabled,
                            rounded: true,
                            text: month.text,
                            variant: model.value === month.value ? 'flat' : 'text',
                            onClick: function() {
                                return onClick(i);
                            }
                        };
                        var _slots_month1;
                        return (_slots_month1 = (_slots_month = slots.month) === null || _slots_month === void 0 ? void 0 : _slots_month.call(slots, {
                            month: month,
                            i: i,
                            props: btnProps
                        })) !== null && _slots_month1 !== void 0 ? _slots_month1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                            key: "month"
                        }, btnProps), null);
                    })
                ])
            ]);
        });
        return {};
    }
});



var $b8tVf = parcelRequire("b8tVf");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");





var $29e529379fc60941$export$2da6674e7b9ab464 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    allowedYears: [
        Array,
        Function
    ]
}, 'VDatePickerYears');
var $29e529379fc60941$export$3faa77515f7b0baa = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePickerYears',
    props: $29e529379fc60941$export$2da6674e7b9ab464(),
    emits: {
        'update:modelValue': function(year) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var adapter = (0, $ff9e087639c00a2b$export$e51e224239492327)();
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var years = (0, $hXmfK.computed)(function() {
            var year = adapter.getYear(adapter.date());
            var min = year - 100;
            var max = year + 52;
            if (props.min) min = adapter.getYear(adapter.date(props.min));
            if (props.max) max = adapter.getYear(adapter.date(props.max));
            var date = adapter.startOfYear(adapter.date());
            date = adapter.setYear(date, min);
            return (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(max - min + 1, min).map(function(i) {
                var text = adapter.format(date, 'year');
                date = adapter.setYear(date, adapter.getYear(date) + 1);
                return {
                    text: text,
                    value: i,
                    isDisabled: !isYearAllowed(i)
                };
            });
        });
        (0, $bu8yf.watchEffect)(function() {
            var _model_value;
            model.value = (_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : adapter.getYear(adapter.date());
        });
        var yearRef = (0, $31779689cfd5da50$export$fc38e812d383221)();
        (0, $bu8yf.onMounted)(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var _yearRef_el;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $bu8yf.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            (_yearRef_el = yearRef.el) === null || _yearRef_el === void 0 ? void 0 : _yearRef_el.focus();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        function isYearAllowed(year) {
            if (Array.isArray(props.allowedYears) && props.allowedYears.length) return props.allowedYears.includes(year);
            if (typeof props.allowedYears === 'function') return props.allowedYears(year);
            return true;
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-date-picker-years",
                style: {
                    height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-date-picker-years__content"
                }, [
                    years.value.map(function(year, i) {
                        var _slots_year;
                        var btnProps = {
                            ref: model.value === year.value ? yearRef : undefined,
                            active: model.value === year.value,
                            color: model.value === year.value ? props.color : undefined,
                            rounded: true,
                            text: year.text,
                            disabled: year.isDisabled,
                            variant: model.value === year.value ? 'flat' : 'text',
                            onClick: function() {
                                if (model.value === year.value) {
                                    emit('update:modelValue', model.value);
                                    return;
                                }
                                model.value = year.value;
                            }
                        };
                        var _slots_year1;
                        return (_slots_year1 = (_slots_year = slots.year) === null || _slots_year === void 0 ? void 0 : _slots_year.call(slots, {
                            year: year,
                            i: i,
                            props: btnProps
                        })) !== null && _slots_year1 !== void 0 ? _slots_year1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                            key: "month"
                        }, btnProps), null);
                    })
                ])
            ]);
        });
        return {};
    }
});









var $0da6153ded56cc86$export$d29cf0136caebe2c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    // TODO: implement in v3.5
    // calendarIcon: {
    //   type: String,
    //   default: '$calendar',
    // },
    // keyboardIcon: {
    //   type: String,
    //   default: '$edit',
    // },
    // inputMode: {
    //   type: String as PropType<'calendar' | 'keyboard'>,
    //   default: 'calendar',
    // },
    // inputText: {
    //   type: String,
    //   default: '$vuetify.datePicker.input.placeholder',
    // },
    // inputPlaceholder: {
    //   type: String,
    //   default: 'dd/mm/yyyy',
    // },
    header: {
        type: String,
        "default": '$vuetify.datePicker.header'
    },
    headerColor: String
}, (0, $2aec657b18722c39$export$48a55eee69fece84)(), (0, $340e576ce57a3e47$export$ca1dc982fe7d1325)({
    weeksInMonth: 'static'
}), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $6a73379d8109234a$export$70df29ae6028d97b)(), [
    'modelValue'
]), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $29e529379fc60941$export$2da6674e7b9ab464)(), [
    'modelValue'
]), (0, $3a810783e3364626$export$78d2911f7e2f59e2)({
    title: '$vuetify.datePicker.title'
})), {
    modelValue: null
}), 'VDatePicker');
var $0da6153ded56cc86$export$a38ea195118a640d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VDatePicker',
    props: $0da6153ded56cc86$export$d29cf0136caebe2c(),
    emits: {
        'update:modelValue': function(date) {
            return true;
        },
        'update:month': function(date) {
            return true;
        },
        'update:year': function(date) {
            return true;
        },
        // 'update:inputMode': (date: any) => true,
        'update:viewMode': function(date) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var adapter = (0, $ff9e087639c00a2b$export$e51e224239492327)();
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', undefined, function(v) {
            return (0, $31779689cfd5da50$export$76411cac38121ecb)(v).map(function(i) {
                return adapter.date(i);
            });
        }, function(v) {
            return props.multiple ? v : v[0];
        });
        var viewMode = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'viewMode');
        // const inputMode = useProxiedModel(props, 'inputMode')
        var minDate = (0, $hXmfK.computed)(function() {
            var date = adapter.date(props.min);
            return props.min && adapter.isValid(date) ? date : null;
        });
        var maxDate = (0, $hXmfK.computed)(function() {
            var date = adapter.date(props.max);
            return props.max && adapter.isValid(date) ? date : null;
        });
        var internal = (0, $hXmfK.computed)(function() {
            var _model_value;
            var today = adapter.date();
            var value = today;
            if ((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value[0]) value = adapter.date(model.value[0]);
            else if (minDate.value && adapter.isBefore(today, minDate.value)) value = minDate.value;
            else if (maxDate.value && adapter.isAfter(today, maxDate.value)) value = maxDate.value;
            return value && adapter.isValid(value) ? value : today;
        });
        var headerColor = (0, $hXmfK.toRef)(function() {
            var _props_headerColor;
            return (_props_headerColor = props.headerColor) !== null && _props_headerColor !== void 0 ? _props_headerColor : props.color;
        });
        var _month = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'month');
        var month = (0, $hXmfK.computed)({
            get: function() {
                var _month_value;
                return Number((_month_value = _month.value) !== null && _month_value !== void 0 ? _month_value : adapter.getMonth(adapter.startOfMonth(internal.value)));
            },
            set: function(v) {
                return _month.value = v;
            }
        });
        var _year = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'year');
        var year = (0, $hXmfK.computed)({
            get: function() {
                var _year_value;
                return Number((_year_value = _year.value) !== null && _year_value !== void 0 ? _year_value : adapter.getYear(adapter.startOfYear(adapter.setMonth(internal.value, month.value))));
            },
            set: function(v) {
                return _year.value = v;
            }
        });
        var isReversing = (0, $hXmfK.shallowRef)(false);
        var header = (0, $hXmfK.computed)(function() {
            if (props.multiple && model.value.length > 1) return t('$vuetify.datePicker.itemsSelected', model.value.length);
            return model.value[0] && adapter.isValid(model.value[0]) ? adapter.format(adapter.date(model.value[0]), 'normalDateWithWeekday') : t(props.header);
        });
        var text = (0, $hXmfK.computed)(function() {
            var date = adapter.date();
            date = adapter.setDate(date, 1);
            date = adapter.setMonth(date, month.value);
            date = adapter.setYear(date, year.value);
            return adapter.format(date, 'monthAndYear');
        });
        // const headerIcon = toRef(() => props.inputMode === 'calendar' ? props.keyboardIcon : props.calendarIcon)
        var headerTransition = (0, $hXmfK.toRef)(function() {
            return "date-picker-header".concat(isReversing.value ? '-reverse' : '', "-transition");
        });
        var disabled = (0, $hXmfK.computed)(function() {
            var _targets;
            if (props.disabled) return true;
            var targets = [];
            if (viewMode.value !== 'month') (_targets = targets).push.apply(_targets, [
                'prev',
                'next'
            ]);
            else {
                var _date = adapter.date();
                _date = adapter.startOfMonth(_date);
                _date = adapter.setMonth(_date, month.value);
                _date = adapter.setYear(_date, year.value);
                if (minDate.value) {
                    var date = adapter.addDays(adapter.startOfMonth(_date), -1);
                    adapter.isAfter(minDate.value, date) && targets.push('prev');
                }
                if (maxDate.value) {
                    var date1 = adapter.addDays(adapter.endOfMonth(_date), 1);
                    adapter.isAfter(date1, maxDate.value) && targets.push('next');
                }
            }
            return targets;
        });
        function isAllowedInRange(start, end) {
            var allowedDates = props.allowedDates;
            if (typeof allowedDates !== 'function') return true;
            var days = adapter.getDiff(end, start, 'days');
            for(var i = 0; i < days; i++){
                if (allowedDates(adapter.addDays(start, i))) return true;
            }
            return false;
        }
        function allowedYears(year) {
            if (typeof props.allowedDates === 'function') {
                var startOfYear = adapter.parseISO("".concat(year, "-01-01"));
                return isAllowedInRange(startOfYear, adapter.endOfYear(startOfYear));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = props.allowedDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var date = _step.value;
                        if (adapter.getYear(adapter.date(date)) === year) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
            return true;
        }
        function allowedMonths(month) {
            if (typeof props.allowedDates === 'function') {
                var monthTwoDigits = String(month + 1).padStart(2, '0');
                var startOfMonth = adapter.parseISO("".concat(year.value, "-").concat(monthTwoDigits, "-01"));
                return isAllowedInRange(startOfMonth, adapter.endOfMonth(startOfMonth));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = props.allowedDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var date = _step.value;
                        if (adapter.getYear(adapter.date(date)) === year.value && adapter.getMonth(adapter.date(date)) === month) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
            return true;
        }
        // function onClickAppend () {
        //   inputMode.value = inputMode.value === 'calendar' ? 'keyboard' : 'calendar'
        // }
        function onClickNext() {
            if (month.value < 11) month.value++;
            else {
                year.value++;
                month.value = 0;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickPrev() {
            if (month.value > 0) month.value--;
            else {
                year.value--;
                month.value = 11;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickDate() {
            viewMode.value = 'month';
        }
        function onClickMonth() {
            viewMode.value = viewMode.value === 'months' ? 'month' : 'months';
        }
        function onClickYear() {
            viewMode.value = viewMode.value === 'year' ? 'month' : 'year';
        }
        function onUpdateMonth() {
            if (viewMode.value === 'months') onClickMonth();
        }
        function onUpdateYear() {
            if (viewMode.value === 'year') onClickYear();
        }
        (0, $hXmfK.watch)(model, function(val, oldVal) {
            var arrBefore = (0, $31779689cfd5da50$export$76411cac38121ecb)(oldVal);
            var arrAfter = (0, $31779689cfd5da50$export$76411cac38121ecb)(val);
            if (!arrAfter.length) return;
            var before = adapter.date(arrBefore[arrBefore.length - 1]);
            var after = adapter.date(arrAfter[arrAfter.length - 1]);
            var newMonth = adapter.getMonth(after);
            var newYear = adapter.getYear(after);
            if (newMonth !== month.value) {
                month.value = newMonth;
                onUpdateMonth();
            }
            if (newYear !== year.value) {
                year.value = newYear;
                onUpdateYear();
            }
            isReversing.value = adapter.isBefore(before, after);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var pickerProps = (0, $3a810783e3364626$export$37f35d9b6bd5d714).filterProps(props);
            var datePickerControlsProps = (0, $2aec657b18722c39$export$12f65deebc2d352e).filterProps(props);
            var datePickerHeaderProps = (0, $a9e108a6d4ca5e0a$export$47b045316d89f8ff).filterProps(props);
            var datePickerMonthProps = (0, $340e576ce57a3e47$export$7affb9b3ced7ba5e).filterProps(props);
            var datePickerMonthsProps = (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $6a73379d8109234a$export$1d5c3cfa8e041a10).filterProps(props), [
                'modelValue'
            ]);
            var datePickerYearsProps = (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $29e529379fc60941$export$3faa77515f7b0baa).filterProps(props), [
                'modelValue'
            ]);
            var headerProps = {
                color: headerColor.value,
                header: header.value,
                transition: headerTransition.value
            };
            return (0, $bu8yf.createVNode)((0, $3a810783e3364626$export$37f35d9b6bd5d714), (0, $bu8yf.mergeProps)(pickerProps, {
                color: headerColor.value,
                "class": [
                    'v-date-picker',
                    "v-date-picker--".concat(viewMode.value),
                    {
                        'v-date-picker--show-week': props.showWeek
                    },
                    rtlClasses.value,
                    props["class"]
                ],
                style: props.style
            }), {
                title: function() {
                    var _slots_title;
                    var _slots_title1;
                    return (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-date-picker__title"
                    }, [
                        t(props.title)
                    ]);
                },
                header: function() {
                    return slots.header ? (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        defaults: {
                            VDatePickerHeader: (0, $iT0je._)({}, headerProps)
                        }
                    }, {
                        "default": function() {
                            var _slots_header;
                            return [
                                (_slots_header = slots.header) === null || _slots_header === void 0 ? void 0 : _slots_header.call(slots, headerProps)
                            ];
                        }
                    }) : (0, $bu8yf.createVNode)((0, $a9e108a6d4ca5e0a$export$47b045316d89f8ff), (0, $bu8yf.mergeProps)({
                        key: "header"
                    }, datePickerHeaderProps, headerProps, {
                        onClick: viewMode.value !== 'month' ? onClickDate : undefined
                    }), {
                        prepend: slots.prepend,
                        append: slots.append
                    });
                },
                "default": function() {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $2aec657b18722c39$export$12f65deebc2d352e), (0, $bu8yf.mergeProps)(datePickerControlsProps, {
                            disabled: disabled.value,
                            text: text.value,
                            "onClick:next": onClickNext,
                            "onClick:prev": onClickPrev,
                            "onClick:month": onClickMonth,
                            "onClick:year": onClickYear
                        }), null),
                        (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$13ce8c44634b158c), {
                            hideOnLeave: true
                        }, {
                            "default": function() {
                                return [
                                    viewMode.value === 'months' ? (0, $bu8yf.createVNode)((0, $6a73379d8109234a$export$1d5c3cfa8e041a10), (0, $bu8yf.mergeProps)({
                                        key: "date-picker-months"
                                    }, datePickerMonthsProps, {
                                        modelValue: month.value,
                                        "onUpdate:modelValue": [
                                            function($event) {
                                                return month.value = $event;
                                            },
                                            onUpdateMonth
                                        ],
                                        min: minDate.value,
                                        max: maxDate.value,
                                        year: year.value,
                                        allowedMonths: allowedMonths
                                    }), {
                                        month: slots.month
                                    }) : viewMode.value === 'year' ? (0, $bu8yf.createVNode)((0, $29e529379fc60941$export$3faa77515f7b0baa), (0, $bu8yf.mergeProps)({
                                        key: "date-picker-years"
                                    }, datePickerYearsProps, {
                                        modelValue: year.value,
                                        "onUpdate:modelValue": [
                                            function($event) {
                                                return year.value = $event;
                                            },
                                            onUpdateYear
                                        ],
                                        min: minDate.value,
                                        max: maxDate.value,
                                        allowedYears: allowedYears
                                    }), {
                                        year: slots.year
                                    }) : (0, $bu8yf.createVNode)((0, $340e576ce57a3e47$export$7affb9b3ced7ba5e), (0, $bu8yf.mergeProps)({
                                        key: "date-picker-month"
                                    }, datePickerMonthProps, {
                                        modelValue: model.value,
                                        "onUpdate:modelValue": function($event) {
                                            return model.value = $event;
                                        },
                                        month: month.value,
                                        "onUpdate:month": [
                                            function($event) {
                                                return month.value = $event;
                                            },
                                            onUpdateMonth
                                        ],
                                        year: year.value,
                                        "onUpdate:year": [
                                            function($event) {
                                                return year.value = $event;
                                            },
                                            onUpdateYear
                                        ],
                                        min: minDate.value,
                                        max: maxDate.value
                                    }), {
                                        day: slots.day
                                    })
                                ];
                            }
                        })
                    ]);
                },
                actions: slots.actions
            });
        });
        return {};
    }
});









var $6559b8d559736b2f$exports = {};

$parcel$export($6559b8d559736b2f$exports, "VDefaultsProvider", function () { return $35431446b86815ea$export$ee4fab30a254e5ee; });



var $d94b64461538f47b$exports = {};

$parcel$export($d94b64461538f47b$exports, "VDialog", function () { return $e41bcf065f624dd0$export$d399a452706dd20b; });



var $5cd0b1f7302d0bce$exports = {};

$parcel$export($5cd0b1f7302d0bce$exports, "VDivider", function () { return $d0feee08e552461a$export$a2636a5d9a866ca1; });



var $bc75dea749d815a9$exports = {};

$parcel$export($bc75dea749d815a9$exports, "VEmptyState", function () { return $283c90e401b8a35c$export$f18859191f4fd437; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");













var $283c90e401b8a35c$export$610881e0844abefd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    actionText: String,
    bgColor: String,
    color: String,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    image: String,
    justify: {
        type: String,
        "default": 'center'
    },
    headline: String,
    title: String,
    text: String,
    textWidth: {
        type: [
            Number,
            String
        ],
        "default": 500
    },
    href: String,
    to: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)({
    size: undefined
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VEmptyState');
var $283c90e401b8a35c$export$f18859191f4fd437 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VEmptyState',
    props: $283c90e401b8a35c$export$610881e0844abefd(),
    emits: {
        'click:action': function(e) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var displayClasses = (0, $a7414385605a88b0$export$8406b7efc286d284)().displayClasses;
        function onClickAction(e) {
            emit('click:action', e);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_headline, _slots_title, _slots_text;
            var hasActions = !!(slots.actions || props.actionText);
            var hasHeadline = !!(slots.headline || props.headline);
            var hasTitle = !!(slots.title || props.title);
            var hasText = !!(slots.text || props.text);
            var hasMedia = !!(slots.media || props.image || props.icon);
            var size = props.size || (props.image ? 200 : 96);
            var _slots_headline1, _slots_title1, _slots_text1, _props_color;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-empty-state',
                    (0, $cqEAj._)({}, "v-empty-state--".concat(props.justify), true),
                    themeClasses.value,
                    backgroundColorClasses.value,
                    displayClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasMedia && (0, $bu8yf.createElementVNode)("div", {
                    key: "media",
                    "class": "v-empty-state__media"
                }, [
                    !slots.media ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        props.image ? (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                            key: "image",
                            src: props.image,
                            height: size
                        }, null) : props.icon ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "icon",
                            color: props.color,
                            size: size,
                            icon: props.icon
                        }, null) : undefined
                    ]) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        key: "media-defaults",
                        defaults: {
                            VImg: {
                                src: props.image,
                                height: size
                            },
                            VIcon: {
                                size: size,
                                icon: props.icon
                            }
                        }
                    }, {
                        "default": function() {
                            return [
                                slots.media()
                            ];
                        }
                    })
                ]),
                hasHeadline && (0, $bu8yf.createElementVNode)("div", {
                    key: "headline",
                    "class": "v-empty-state__headline"
                }, [
                    (_slots_headline1 = (_slots_headline = slots.headline) === null || _slots_headline === void 0 ? void 0 : _slots_headline.call(slots)) !== null && _slots_headline1 !== void 0 ? _slots_headline1 : props.headline
                ]),
                hasTitle && (0, $bu8yf.createElementVNode)("div", {
                    key: "title",
                    "class": "v-empty-state__title"
                }, [
                    (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                ]),
                hasText && (0, $bu8yf.createElementVNode)("div", {
                    key: "text",
                    "class": "v-empty-state__text",
                    style: {
                        maxWidth: (0, $31779689cfd5da50$export$286ad215293a0860)(props.textWidth)
                    }
                }, [
                    (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                ]),
                slots["default"] && (0, $bu8yf.createElementVNode)("div", {
                    key: "content",
                    "class": "v-empty-state__content"
                }, [
                    slots["default"]()
                ]),
                hasActions && (0, $bu8yf.createElementVNode)("div", {
                    key: "actions",
                    "class": "v-empty-state__actions"
                }, [
                    (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        defaults: {
                            VBtn: {
                                "class": 'v-empty-state__action-btn',
                                color: (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : 'surface-variant',
                                href: props.href,
                                text: props.actionText,
                                to: props.to
                            }
                        }
                    }, {
                        "default": function() {
                            var _slots_actions;
                            var _slots_actions1;
                            return [
                                (_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, {
                                    props: {
                                        onClick: onClickAction
                                    }
                                })) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                                    onClick: onClickAction
                                }, null)
                            ];
                        }
                    })
                ])
            ]);
        });
        return {};
    }
});




var $0f31d19c1eb87c95$exports = {};

$parcel$export($0f31d19c1eb87c95$exports, "VExpansionPanels", function () { return $e9bbce08ae5a9fdf$export$1d655deb4215c753; });
$parcel$export($0f31d19c1eb87c95$exports, "VExpansionPanel", function () { return $ed6b0458437e2fd4$export$ee93fd2a8131fa1c; });
$parcel$export($0f31d19c1eb87c95$exports, "VExpansionPanelText", function () { return $bf8de8b787678fe9$export$98a17388a19b123f; });
$parcel$export($0f31d19c1eb87c95$exports, "VExpansionPanelTitle", function () { return $7a42a966d2a3b18d$export$4188f36ee8a3fb9e; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");

// Types
var $fda293b840236df4$export$d2f18f636bf00f54 = Symbol["for"]('vuetify:v-expansion-panel');



var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");





var $bf8de8b787678fe9$export$f3c5154392bfd2e6 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $2a56e630d56c9097$export$3557c26df64490a4)()), 'VExpansionPanelText');
var $bf8de8b787678fe9$export$98a17388a19b123f = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelText',
    props: $bf8de8b787678fe9$export$f3c5154392bfd2e6(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var expansionPanel = (0, $bu8yf.inject)((0, $fda293b840236df4$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
        var _useLazy = (0, $2a56e630d56c9097$export$965f98646215a1bd)(props, expansionPanel.isSelected), hasContent = _useLazy.hasContent, onAfterLeave = _useLazy.onAfterLeave;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$1cd1e8deb97d798d), {
                onAfterLeave: onAfterLeave
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-expansion-panel-text',
                                props["class"]
                            ]),
                            style: (0, $d8jBh.normalizeStyle)(props.style)
                        }, [
                            slots["default"] && hasContent.value && (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-expansion-panel-text__wrapper"
                            }, [
                                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                            ])
                        ]), [
                            [
                                (0, $kiZwI.vShow),
                                expansionPanel.isSelected.value
                            ]
                        ])
                    ];
                }
            });
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");









var $7a42a966d2a3b18d$export$85e1bc773c647163 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    expandIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$expand'
    },
    collapseIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$collapse'
    },
    hideActions: Boolean,
    focusable: Boolean,
    static: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": false
    },
    readonly: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)()), 'VExpansionPanelTitle');
var $7a42a966d2a3b18d$export$4188f36ee8a3fb9e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelTitle',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $7a42a966d2a3b18d$export$85e1bc773c647163(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var expansionPanel = (0, $bu8yf.inject)((0, $fda293b840236df4$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                collapseIcon: props.collapseIcon,
                disabled: expansionPanel.disabled.value,
                expanded: expansionPanel.isSelected.value,
                expandIcon: props.expandIcon,
                readonly: props.readonly
            };
        });
        var icon = (0, $hXmfK.toRef)(function() {
            return expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("button", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-expansion-panel-title',
                    {
                        'v-expansion-panel-title--active': expansionPanel.isSelected.value,
                        'v-expansion-panel-title--focusable': props.focusable,
                        'v-expansion-panel-title--static': props["static"]
                    },
                    backgroundColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                type: "button",
                tabindex: expansionPanel.disabled.value ? -1 : undefined,
                disabled: expansionPanel.disabled.value,
                "aria-expanded": expansionPanel.isSelected.value,
                onClick: !props.readonly ? expansionPanel.toggle : undefined
            }, [
                (0, $bu8yf.createElementVNode)("span", {
                    "class": "v-expansion-panel-title__overlay"
                }, null),
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value),
                !props.hideActions && (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    defaults: {
                        VIcon: {
                            icon: icon.value
                        }
                    }
                }, {
                    "default": function() {
                        var _slots_actions;
                        var _slots_actions1;
                        return [
                            (0, $bu8yf.createElementVNode)("span", {
                                "class": "v-expansion-panel-title__icon"
                            }, [
                                (_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, slotProps.value)) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), null, null)
                            ])
                        ];
                    }
                })
            ]), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    props.ripple
                ]
            ]);
        });
        return {};
    }
});









var $ed6b0458437e2fd4$export$957957cd07e373a6 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    title: String,
    text: String,
    bgColor: String
}, (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $073309bf395585eb$export$e9e3b570044587e8)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $7a42a966d2a3b18d$export$85e1bc773c647163)(), (0, $bf8de8b787678fe9$export$f3c5154392bfd2e6)()), 'VExpansionPanel');
var $ed6b0458437e2fd4$export$ee93fd2a8131fa1c = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanel',
    props: $ed6b0458437e2fd4$export$957957cd07e373a6(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var groupItem = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $fda293b840236df4$export$d2f18f636bf00f54));
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var isDisabled = (0, $hXmfK.toRef)(function() {
            return (groupItem === null || groupItem === void 0 ? void 0 : groupItem.disabled.value) || props.disabled;
        });
        var selectedIndices = (0, $hXmfK.computed)(function() {
            return groupItem.group.items.value.reduce(function(arr, item, index) {
                if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
                return arr;
            }, []);
        });
        var isBeforeSelected = (0, $hXmfK.computed)(function() {
            var index = groupItem.group.items.value.findIndex(function(item) {
                return item.id === groupItem.id;
            });
            return !groupItem.isSelected.value && selectedIndices.value.some(function(selectedIndex) {
                return selectedIndex - index === 1;
            });
        });
        var isAfterSelected = (0, $hXmfK.computed)(function() {
            var index = groupItem.group.items.value.findIndex(function(item) {
                return item.id === groupItem.id;
            });
            return !groupItem.isSelected.value && selectedIndices.value.some(function(selectedIndex) {
                return selectedIndex - index === -1;
            });
        });
        (0, $bu8yf.provide)((0, $fda293b840236df4$export$d2f18f636bf00f54), groupItem);
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasText = !!(slots.text || props.text);
            var hasTitle = !!(slots.title || props.title);
            var expansionPanelTitleProps = (0, $7a42a966d2a3b18d$export$4188f36ee8a3fb9e).filterProps(props);
            var expansionPanelTextProps = (0, $bf8de8b787678fe9$export$98a17388a19b123f).filterProps(props);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-expansion-panel',
                    {
                        'v-expansion-panel--active': groupItem.isSelected.value,
                        'v-expansion-panel--before-active': isBeforeSelected.value,
                        'v-expansion-panel--after-active': isAfterSelected.value,
                        'v-expansion-panel--disabled': isDisabled.value
                    },
                    roundedClasses.value,
                    backgroundColorClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-expansion-panel__shadow'
                            ].concat((0, $7WNf6._)(elevationClasses.value)))
                        }, null),
                        (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: {
                                VExpansionPanelTitle: (0, $iT0je._)({}, expansionPanelTitleProps),
                                VExpansionPanelText: (0, $iT0je._)({}, expansionPanelTextProps)
                            }
                        }, {
                            "default": function() {
                                var _slots_default;
                                return [
                                    hasTitle && (0, $bu8yf.createVNode)((0, $7a42a966d2a3b18d$export$4188f36ee8a3fb9e), {
                                        key: "title"
                                    }, {
                                        "default": function() {
                                            return [
                                                slots.title ? slots.title() : props.title
                                            ];
                                        }
                                    }),
                                    hasText && (0, $bu8yf.createVNode)((0, $bf8de8b787678fe9$export$98a17388a19b123f), {
                                        key: "text"
                                    }, {
                                        "default": function() {
                                            return [
                                                slots.text ? slots.text() : props.text
                                            ];
                                        }
                                    }),
                                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                ];
                            }
                        })
                    ];
                }
            });
        });
        return {
            groupItem: groupItem
        };
    }
});








var $e9bbce08ae5a9fdf$var$allowedVariants = [
    'default',
    'accordion',
    'inset',
    'popout'
];
var $e9bbce08ae5a9fdf$export$d02e8e924ebac11d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    flat: Boolean
}, (0, $073309bf395585eb$export$fa4c05b3520340e6)(), (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $ed6b0458437e2fd4$export$957957cd07e373a6)(), [
    'bgColor',
    'collapseIcon',
    'color',
    'eager',
    'elevation',
    'expandIcon',
    'focusable',
    'hideActions',
    'readonly',
    'ripple',
    'rounded',
    'tile',
    'static'
]), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), {
    variant: {
        type: String,
        "default": 'default',
        validator: function(v) {
            return $e9bbce08ae5a9fdf$var$allowedVariants.includes(v);
        }
    }
}), 'VExpansionPanels');
var $e9bbce08ae5a9fdf$export$1d655deb4215c753 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanels',
    props: $e9bbce08ae5a9fdf$export$d02e8e924ebac11d(),
    emits: {
        'update:modelValue': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useGroup = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, (0, $fda293b840236df4$export$d2f18f636bf00f54)), next = _useGroup.next, prev = _useGroup.prev;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var variantClass = (0, $hXmfK.toRef)(function() {
            return props.variant && "v-expansion-panels--variant-".concat(props.variant);
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VExpansionPanel: {
                bgColor: (0, $hXmfK.toRef)(function() {
                    return props.bgColor;
                }),
                collapseIcon: (0, $hXmfK.toRef)(function() {
                    return props.collapseIcon;
                }),
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                eager: (0, $hXmfK.toRef)(function() {
                    return props.eager;
                }),
                elevation: (0, $hXmfK.toRef)(function() {
                    return props.elevation;
                }),
                expandIcon: (0, $hXmfK.toRef)(function() {
                    return props.expandIcon;
                }),
                focusable: (0, $hXmfK.toRef)(function() {
                    return props.focusable;
                }),
                hideActions: (0, $hXmfK.toRef)(function() {
                    return props.hideActions;
                }),
                readonly: (0, $hXmfK.toRef)(function() {
                    return props.readonly;
                }),
                ripple: (0, $hXmfK.toRef)(function() {
                    return props.ripple;
                }),
                rounded: (0, $hXmfK.toRef)(function() {
                    return props.rounded;
                }),
                static: (0, $hXmfK.toRef)(function() {
                    return props["static"];
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-expansion-panels',
                    {
                        'v-expansion-panels--flat': props.flat,
                        'v-expansion-panels--tile': props.tile
                    },
                    themeClasses.value,
                    variantClass.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            prev: prev,
                            next: next
                        })
                    ];
                }
            });
        });
        return {
            next: next,
            prev: prev
        };
    }
});







var $1a2325ac52b4d6de$exports = {};

$parcel$export($1a2325ac52b4d6de$exports, "VFab", function () { return $23bfe072d517acaf$export$baad3d897c61ee66; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");









var $23bfe072d517acaf$export$7520e5745fcec8e3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    app: Boolean,
    appear: Boolean,
    extended: Boolean,
    layout: Boolean,
    offset: Boolean,
    modelValue: {
        type: Boolean,
        "default": true
    }
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9603829334ed7471$export$64daea74540bd34d)({
    active: true
}), [
    'location'
]), (0, $39e98ff3447d557e$export$d42abac634ace931)(), (0, $1f28bc3af840aa00$export$2831add577f947cb)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: 'fab-transition'
})), 'VFab');
var $23bfe072d517acaf$export$baad3d897c61ee66 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VFab',
    props: $23bfe072d517acaf$export$7520e5745fcec8e3(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var height = (0, $hXmfK.shallowRef)(56);
        var layoutItemStyles = (0, $hXmfK.ref)();
        var resizeRef = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(function(entries) {
            if (!entries.length) return;
            height.value = entries[0].target.clientHeight;
        }).resizeRef;
        var hasPosition = (0, $hXmfK.toRef)(function() {
            return props.app || props.absolute;
        });
        var position = (0, $hXmfK.computed)(function() {
            var _props_location;
            if (!hasPosition.value) return false;
            var _props_location_split_shift;
            return (_props_location_split_shift = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ').shift()) !== null && _props_location_split_shift !== void 0 ? _props_location_split_shift : 'bottom';
        });
        var orientation = (0, $hXmfK.computed)(function() {
            var _props_location;
            if (!hasPosition.value) return false;
            var _props_location_split_;
            return (_props_location_split_ = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ')[1]) !== null && _props_location_split_ !== void 0 ? _props_location_split_ : 'end';
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.app;
        }, function() {
            var layout = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $hXmfK.computed)(function() {
                    return parseInt(props.order, 10);
                }),
                position: position,
                layoutSize: (0, $hXmfK.computed)(function() {
                    return props.layout ? height.value + 24 : 0;
                }),
                elementSize: (0, $hXmfK.computed)(function() {
                    return height.value + 24;
                }),
                active: (0, $hXmfK.computed)(function() {
                    return props.app && model.value;
                }),
                absolute: (0, $hXmfK.toRef)(function() {
                    return props.absolute;
                })
            });
            (0, $bu8yf.watchEffect)(function() {
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        var vFabRef = (0, $hXmfK.ref)();
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var btnProps = (0, $9603829334ed7471$export$657f28cf887b91a6).filterProps(props);
            var _obj;
            return (0, $bu8yf.createElementVNode)("div", {
                ref: vFabRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-fab',
                    (_obj = {
                        'v-fab--absolute': props.absolute,
                        'v-fab--app': !!props.app,
                        'v-fab--extended': props.extended,
                        'v-fab--offset': props.offset
                    }, (0, $cqEAj._)(_obj, "v-fab--".concat(position.value), hasPosition.value), (0, $cqEAj._)(_obj, "v-fab--".concat(orientation.value), hasPosition.value), _obj),
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    props.app ? (0, $iT0je._)({}, layoutItemStyles.value) : {
                        height: props.absolute ? '100%' : 'inherit'
                    },
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-fab__container"
                }, [
                    (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                        appear: props.appear,
                        transition: props.transition
                    }, {
                        "default": function() {
                            return [
                                (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                                    ref: resizeRef
                                }, btnProps, {
                                    active: undefined,
                                    location: undefined
                                }), slots), [
                                    [
                                        (0, $kiZwI.vShow),
                                        props.active
                                    ]
                                ])
                            ];
                        }
                    })
                ])
            ]);
        });
        return {};
    }
});




var $f1d25c1d218def35$exports = {};

$parcel$export($f1d25c1d218def35$exports, "VField", function () { return $88ed151c68066729$export$3180fb4997e9f72d; });
$parcel$export($f1d25c1d218def35$exports, "VFieldLabel", function () { return $9210a492c630ce0e$export$1a74b2f7ba75e1db; });




var $95bb0bb2e9e14fb7$exports = {};

$parcel$export($95bb0bb2e9e14fb7$exports, "VFileInput", function () { return $c17c949d6e62dfea$export$1492afa4b6f123c9; });

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






// Types

var $b8tVf = parcelRequire("b8tVf");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
function $d40bf54237b08aa5$export$fffcc0a7404f3668() {
    function hasFilesOrFolders(e) {
        var _e_dataTransfer, _e_dataTransfer1;
        var _e_dataTransfer_items;
        var entries = (0, $7WNf6._)((_e_dataTransfer_items = (_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.items) !== null && _e_dataTransfer_items !== void 0 ? _e_dataTransfer_items : []).filter(function(x) {
            return x.kind === 'file';
        }).map(function(x) {
            return x.webkitGetAsEntry();
        }).filter(Boolean);
        var _e_dataTransfer_files;
        return entries.length > 0 || (0, $7WNf6._)((_e_dataTransfer_files = (_e_dataTransfer1 = e.dataTransfer) === null || _e_dataTransfer1 === void 0 ? void 0 : _e_dataTransfer1.files) !== null && _e_dataTransfer_files !== void 0 ? _e_dataTransfer_files : []).length > 0;
    }
    function handleDrop(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
            var _result, _e_dataTransfer, _e_dataTransfer1, result, _e_dataTransfer_items, entries, _e_dataTransfer_files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _result1, files, err;
            return (0, $9N5UN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        result = [];
                        entries = (0, $7WNf6._)((_e_dataTransfer_items = (_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.items) !== null && _e_dataTransfer_items !== void 0 ? _e_dataTransfer_items : []).filter(function(x) {
                            return x.kind === 'file';
                        }).map(function(x) {
                            return x.webkitGetAsEntry();
                        }).filter(Boolean);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!entries.length) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = entries[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        entry = _step.value;
                        return [
                            4,
                            $d40bf54237b08aa5$var$traverseFileTree(entry, $d40bf54237b08aa5$var$appendIfDirectory('.', entry))
                        ];
                    case 3:
                        files = _state.sent();
                        (_result1 = result).push.apply(_result1, (0, $7WNf6._)(files.map(function(x) {
                            return x.file;
                        })));
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        (_result = result).push.apply(_result, (0, $7WNf6._)((0, $7WNf6._)((_e_dataTransfer_files = (_e_dataTransfer1 = e.dataTransfer) === null || _e_dataTransfer1 === void 0 ? void 0 : _e_dataTransfer1.files) !== null && _e_dataTransfer_files !== void 0 ? _e_dataTransfer_files : [])));
                        _state.label = 10;
                    case 10:
                        return [
                            2,
                            result
                        ];
                }
            });
        })();
    }
    return {
        handleDrop: handleDrop,
        hasFilesOrFolders: hasFilesOrFolders
    };
}
function $d40bf54237b08aa5$var$traverseFileTree(item) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise(function(resolve, reject) {
        if (item.isFile) {
            var fileEntry = item;
            fileEntry.file(function(file) {
                return resolve([
                    {
                        file: file,
                        path: path
                    }
                ]);
            }, reject);
        } else if (item.isDirectory) {
            var directoryReader = item.createReader();
            directoryReader.readEntries(function(entries) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                    var _files, files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _, _1, _tmp, err;
                    return (0, $9N5UN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                files = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = entries[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                entry = _step.value;
                                _1 = (_ = (_files = files).push).apply;
                                _tmp = [
                                    _files
                                ];
                                return [
                                    4,
                                    $d40bf54237b08aa5$var$traverseFileTree(entry, $d40bf54237b08aa5$var$appendIfDirectory(path, entry))
                                ];
                            case 3:
                                _1.apply(_, _tmp.concat([
                                    (0, $7WNf6._).apply(void 0, [
                                        _state.sent()
                                    ])
                                ]));
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                resolve(files);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
        }
    });
}
function $d40bf54237b08aa5$var$appendIfDirectory(path, item) {
    return item.isDirectory ? "".concat(path, "/").concat(item.name) : path;
}







var $c17c949d6e62dfea$export$252244107ea9668e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)({
    chips: Boolean,
    counter: Boolean,
    counterSizeString: {
        type: String,
        "default": '$vuetify.fileInput.counterSize'
    },
    counterString: {
        type: String,
        "default": '$vuetify.fileInput.counter'
    },
    hideInput: Boolean,
    multiple: Boolean,
    showSize: {
        type: [
            Boolean,
            Number,
            String
        ],
        "default": false,
        validator: function(v) {
            return typeof v === 'boolean' || [
                1000,
                1024
            ].includes(Number(v));
        }
    }
}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)({
    prependIcon: '$file'
})), {
    modelValue: {
        type: [
            Array,
            Object
        ],
        "default": function(props) {
            return props.multiple ? [] : null;
        },
        validator: function(val) {
            return (0, $31779689cfd5da50$export$76411cac38121ecb)(val).every(function(v) {
                return v != null && (typeof v === "undefined" ? "undefined" : (0, $3KZcf._)(v)) === 'object';
            });
        }
    }
}), (0, $88ed151c68066729$export$1e13429dc53b9634)({
    clearable: true
})), 'VFileInput');
var $c17c949d6e62dfea$export$1492afa4b6f123c9 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VFileInput',
    inheritAttrs: false,
    props: $c17c949d6e62dfea$export$252244107ea9668e(),
    emits: {
        'click:control': function(e) {
            return true;
        },
        'mousedown:control': function(e) {
            return true;
        },
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(files) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, function(val) {
            return (0, $31779689cfd5da50$export$76411cac38121ecb)(val);
        }, function(val) {
            return !props.multiple && Array.isArray(val) ? val[0] : val;
        });
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var base = (0, $hXmfK.computed)(function() {
            return typeof props.showSize !== 'boolean' ? props.showSize : undefined;
        });
        var totalBytes = (0, $hXmfK.computed)(function() {
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : []).reduce(function(bytes, _ref2) {
                var _ref2_size = _ref2.size, size = _ref2_size === void 0 ? 0 : _ref2_size;
                return bytes + size;
            }, 0);
        });
        var totalBytesReadable = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$dfc82bc1332b0cba)(totalBytes.value, base.value);
        });
        var fileNames = (0, $hXmfK.computed)(function() {
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : []).map(function(file) {
                var _file_name = file.name, name = _file_name === void 0 ? '' : _file_name, _file_size = file.size, size = _file_size === void 0 ? 0 : _file_size;
                return !props.showSize ? name : "".concat(name, " (").concat((0, $31779689cfd5da50$export$dfc82bc1332b0cba)(size, base.value), ")");
            });
        });
        var counterValue = (0, $hXmfK.computed)(function() {
            var _model_value;
            var _model_value_length;
            var fileCount = (_model_value_length = (_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length) !== null && _model_value_length !== void 0 ? _model_value_length : 0;
            if (props.showSize) return t(props.counterSizeString, fileCount, totalBytesReadable.value);
            else return t(props.counterString, fileCount);
        });
        var vInputRef = (0, $hXmfK.ref)();
        var vFieldRef = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)();
        var isActive = (0, $hXmfK.toRef)(function() {
            return isFocused.value || props.active;
        });
        var isPlainOrUnderlined = (0, $hXmfK.computed)(function() {
            return [
                'plain',
                'underlined'
            ].includes(props.variant);
        });
        var isDragging = (0, $hXmfK.shallowRef)(false);
        var _useFileDrop = (0, $d40bf54237b08aa5$export$fffcc0a7404f3668)(), handleDrop = _useFileDrop.handleDrop, hasFilesOrFolders = _useFileDrop.hasFilesOrFolders;
        function onFocus() {
            var _inputRef_value;
            if (inputRef.value !== document.activeElement) (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.focus();
            if (!isFocused.value) focus();
        }
        function onClickPrepend(e) {
            var _inputRef_value;
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.click();
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onControlClick(e) {
            var _inputRef_value;
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.click();
            emit('click:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $bu8yf.nextTick)(function() {
                model.value = [];
                (0, $31779689cfd5da50$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onDragover(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging.value = true;
        }
        function onDragleave(e) {
            e.preventDefault();
            isDragging.value = false;
        }
        function onDrop(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var dataTransfer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, err;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            isDragging.value = false;
                            if (!inputRef.value || !hasFilesOrFolders(e)) return [
                                2
                            ];
                            dataTransfer = new DataTransfer();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            return [
                                4,
                                handleDrop(e)
                            ];
                        case 2:
                            _iterator = _state.sent()[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            file = _step.value;
                            dataTransfer.items.add(file);
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            inputRef.value.files = dataTransfer.files;
                            inputRef.value.dispatchEvent(new Event('change', {
                                bubbles: true
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        (0, $hXmfK.watch)(model, function(newValue) {
            var hasModelReset = !Array.isArray(newValue) || !newValue.length;
            if (hasModelReset && inputRef.value) inputRef.value.value = '';
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasCounter = !!(slots.counter || props.counter);
            var hasDetails = !!(hasCounter || slots.details);
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], inputAttrs = _filterInputAttrs[1];
            var _VInput_filterProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props), _ = _VInput_filterProps.modelValue, inputProps = (0, $g79Gh._)(_VInput_filterProps, [
                "modelValue"
            ]);
            var fieldProps = (0, $88ed151c68066729$export$3180fb4997e9f72d).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: vInputRef,
                modelValue: props.multiple ? model.value : model.value[0],
                "class": [
                    'v-file-input',
                    {
                        'v-file-input--chips': !!props.chips,
                        'v-file-input--dragging': isDragging.value,
                        'v-file-input--hide': props.hideInput,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props["class"]
                ],
                style: props.style,
                "onClick:prepend": onClickPrepend
            }, rootAttrs, inputProps, {
                centerAffix: !isPlainOrUnderlined.value,
                focused: isFocused.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref3) {
                    var id = _ref3.id, isDisabled = _ref3.isDisabled, isDirty = _ref3.isDirty, isReadonly = _ref3.isReadonly, isValid = _ref3.isValid, hasDetails = _ref3.hasDetails;
                    return (0, $bu8yf.createVNode)((0, $88ed151c68066729$export$3180fb4997e9f72d), (0, $bu8yf.mergeProps)({
                        ref: vFieldRef,
                        prependIcon: props.prependIcon,
                        onMousedown: onControlMousedown,
                        onClick: onControlClick,
                        "onClick:clear": onClear,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        id: id.value,
                        active: isActive.value || isDirty.value,
                        dirty: isDirty.value || props.dirty,
                        disabled: isDisabled.value,
                        focused: isFocused.value,
                        details: hasDetails.value,
                        error: isValid.value === false,
                        onDragover: onDragover,
                        onDrop: onDrop
                    }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                        "default": function(_ref4) {
                            var _model_value;
                            var _ref4_props = _ref4.props, fieldClass = _ref4_props["class"], slotProps = (0, $g79Gh._)(_ref4.props, [
                                "class"
                            ]);
                            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                (0, $bu8yf.createElementVNode)("input", (0, $bu8yf.mergeProps)({
                                    ref: inputRef,
                                    type: "file",
                                    readonly: isReadonly.value,
                                    disabled: isDisabled.value,
                                    multiple: props.multiple,
                                    name: props.name,
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        if (isReadonly.value) e.preventDefault();
                                        onFocus();
                                    },
                                    onChange: function(e) {
                                        if (!e.target) return;
                                        var target = e.target;
                                        var _target_files;
                                        model.value = (0, $7WNf6._)((_target_files = target.files) !== null && _target_files !== void 0 ? _target_files : []);
                                    },
                                    onDragleave: onDragleave,
                                    onFocus: onFocus,
                                    onBlur: blur
                                }, slotProps, inputAttrs), null),
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": (0, $d8jBh.normalizeClass)(fieldClass)
                                }, [
                                    !!((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length) && !props.hideInput && (slots.selection ? slots.selection({
                                        fileNames: fileNames.value,
                                        totalBytes: totalBytes.value,
                                        totalBytesReadable: totalBytesReadable.value
                                    }) : props.chips ? fileNames.value.map(function(text) {
                                        return (0, $bu8yf.createVNode)((0, $2f12dac67cff7cbd$export$1b5fab12cd17b4fb), {
                                            key: text,
                                            size: "small",
                                            text: text
                                        }, null);
                                    }) : fileNames.value.join(', '))
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? function(slotProps) {
                    var _slots_details, _model_value;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            (0, $bu8yf.createElementVNode)("span", null, null),
                            (0, $bu8yf.createVNode)((0, $7ba1fb3b216974cf$export$45efeae449ff2094), {
                                active: !!((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length),
                                value: counterValue.value,
                                disabled: props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});




var $8cb46c34ab58368d$exports = {};

$parcel$export($8cb46c34ab58368d$exports, "VFooter", function () { return $5043e5b392c40c96$export$81b275eb93e8d5bb; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");












var $5043e5b392c40c96$export$6f12c637938afaa3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    app: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        "default": 'auto'
    }
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $39e98ff3447d557e$export$d42abac634ace931)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'footer'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VFooter');
var $5043e5b392c40c96$export$81b275eb93e8d5bb = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VFooter',
    props: $5043e5b392c40c96$export$6f12c637938afaa3(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var layoutItemStyles = (0, $hXmfK.ref)();
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var autoHeight = (0, $hXmfK.shallowRef)(32);
        var resizeRef = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(function(entries) {
            if (!entries.length) return;
            autoHeight.value = entries[0].target.clientHeight;
        }).resizeRef;
        var height = (0, $hXmfK.computed)(function() {
            return props.height === 'auto' ? autoHeight.value : parseInt(props.height, 10);
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.app;
        }, function() {
            var layout = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $hXmfK.computed)(function() {
                    return parseInt(props.order, 10);
                }),
                position: (0, $hXmfK.toRef)(function() {
                    return 'bottom';
                }),
                layoutSize: height,
                elementSize: (0, $hXmfK.computed)(function() {
                    return props.height === 'auto' ? undefined : height.value;
                }),
                active: (0, $hXmfK.toRef)(function() {
                    return props.app;
                }),
                absolute: (0, $hXmfK.toRef)(function() {
                    return props.absolute;
                })
            });
            (0, $bu8yf.watchEffect)(function() {
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                ref: resizeRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-footer',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.app ? layoutItemStyles.value : {
                        height: (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});




var $08b68dee11ca8414$exports = {};

$parcel$export($08b68dee11ca8414$exports, "VForm", function () { return $171f8d996feab502$export$6f5d3162e9efbcf3; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");




var $171f8d996feab502$export$af2296a8595b5d52 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $04771d0544148a45$export$be046af95b8d4645)()), 'VForm');
var $171f8d996feab502$export$6f5d3162e9efbcf3 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VForm',
    props: $171f8d996feab502$export$af2296a8595b5d52(),
    emits: {
        'update:modelValue': function(val) {
            return true;
        },
        submit: function(e) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var form = (0, $04771d0544148a45$export$f681a8129d2e9d28)(props);
        var formRef = (0, $hXmfK.ref)();
        function onReset(e) {
            e.preventDefault();
            form.reset();
        }
        function onSubmit(_e) {
            var e = _e;
            var ready = form.validate();
            e.then = ready.then.bind(ready);
            e["catch"] = ready["catch"].bind(ready);
            e["finally"] = ready["finally"].bind(ready);
            emit('submit', e);
            if (!e.defaultPrevented) ready.then(function(_ref2) {
                var _formRef_value;
                var valid = _ref2.valid;
                if (valid) (_formRef_value = formRef.value) === null || _formRef_value === void 0 ? void 0 : _formRef_value.submit();
            });
            e.preventDefault();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("form", {
                ref: formRef,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-form',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                novalidate: true,
                onReset: onReset,
                onSubmit: onSubmit
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, form)
            ]);
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)(form, formRef);
    }
});




var $c47abed99c7fd2f4$exports = {};

$parcel$export($c47abed99c7fd2f4$exports, "VContainer", function () { return $2fa13c442b4afa7b$export$e6680f8f89b2ee43; });
$parcel$export($c47abed99c7fd2f4$exports, "VCol", function () { return $0ea12380033f3807$export$f063fe9fd55e6980; });
$parcel$export($c47abed99c7fd2f4$exports, "VRow", function () { return $9da90027f67dc74f$export$978f7f00e11cd63; });
$parcel$export($c47abed99c7fd2f4$exports, "VSpacer", function () { return $fcf55e69a53a0d0e$export$78e533170324578f; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






var $2fa13c442b4afa7b$export$a3b8e03bf0677e95 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    fluid: {
        type: Boolean,
        "default": false
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VContainer');
var $2fa13c442b4afa7b$export$e6680f8f89b2ee43 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VContainer',
    props: $2fa13c442b4afa7b$export$a3b8e03bf0677e95(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-container',
                    {
                        'v-container--fluid': props.fluid
                    },
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});


// Styles

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");




parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $0ea12380033f3807$var$breakpointProps = function() {
    return (0, $a7414385605a88b0$export$d07517a676ce386f).reduce(function(props, val) {
        props[val] = {
            type: [
                Boolean,
                String,
                Number
            ],
            "default": false
        };
        return props;
    }, {});
}();
var $0ea12380033f3807$var$offsetProps = function() {
    return (0, $a7414385605a88b0$export$d07517a676ce386f).reduce(function(props, val) {
        var offsetKey = 'offset' + (0, $d8jBh.capitalize)(val);
        props[offsetKey] = {
            type: [
                String,
                Number
            ],
            "default": null
        };
        return props;
    }, {});
}();
var $0ea12380033f3807$var$orderProps = function() {
    return (0, $a7414385605a88b0$export$d07517a676ce386f).reduce(function(props, val) {
        var orderKey = 'order' + (0, $d8jBh.capitalize)(val);
        props[orderKey] = {
            type: [
                String,
                Number
            ],
            "default": null
        };
        return props;
    }, {});
}();
var $0ea12380033f3807$var$propMap = {
    col: Object.keys($0ea12380033f3807$var$breakpointProps),
    offset: Object.keys($0ea12380033f3807$var$offsetProps),
    order: Object.keys($0ea12380033f3807$var$orderProps)
};
function $0ea12380033f3807$var$breakpointClass(type, prop, val) {
    var className = type;
    if (val == null || val === false) return undefined;
    if (prop) {
        var breakpoint = prop.replace(type, '');
        className += "-".concat(breakpoint);
    }
    if (type === 'col') className = 'v-' + className;
    // Handling the boolean style prop when accepting [Boolean, String, Number]
    // means Vue will not convert <v-col sm></v-col> to sm: true for us.
    // Since the default is false, an empty string indicates the prop's presence.
    if (type === 'col' && (val === '' || val === true)) // .v-col-md
    return className.toLowerCase();
    // .order-md-6
    className += "-".concat(val);
    return className.toLowerCase();
}
var $0ea12380033f3807$var$ALIGN_SELF_VALUES = [
    'auto',
    'start',
    'end',
    'center',
    'baseline',
    'stretch'
];
var $0ea12380033f3807$export$8170474963c9327d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)({
    cols: {
        type: [
            Boolean,
            String,
            Number
        ],
        "default": false
    }
}, $0ea12380033f3807$var$breakpointProps), {
    offset: {
        type: [
            String,
            Number
        ],
        "default": null
    }
}), $0ea12380033f3807$var$offsetProps), {
    order: {
        type: [
            String,
            Number
        ],
        "default": null
    }
}), $0ea12380033f3807$var$orderProps), {
    alignSelf: {
        type: String,
        "default": null,
        validator: function(str) {
            return $0ea12380033f3807$var$ALIGN_SELF_VALUES.includes(str);
        }
    }
}), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VCol');
var $0ea12380033f3807$export$f063fe9fd55e6980 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VCol',
    props: $0ea12380033f3807$export$8170474963c9327d(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var classes = (0, $hXmfK.computed)(function() {
            var classList = [];
            // Loop through `col`, `offset`, `order` breakpoint props
            var type;
            for(type in $0ea12380033f3807$var$propMap)$0ea12380033f3807$var$propMap[type].forEach(function(prop) {
                var value = props[prop];
                var className = $0ea12380033f3807$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            var hasColClasses = classList.some(function(className) {
                return className.startsWith('v-col-');
            });
            var _obj;
            classList.push((_obj = {
                // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
                'v-col': !hasColClasses || !props.cols
            }, (0, $cqEAj._)(_obj, "v-col-".concat(props.cols), props.cols), (0, $cqEAj._)(_obj, "offset-".concat(props.offset), props.offset), (0, $cqEAj._)(_obj, "order-".concat(props.order), props.order), (0, $cqEAj._)(_obj, "align-self-".concat(props.alignSelf), props.alignSelf), _obj));
            return classList;
        });
        return function() {
            var _slots_default;
            return (0, $bu8yf.h)(props.tag, {
                "class": [
                    classes.value,
                    props["class"]
                ],
                style: props.style
            }, (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});


// Styles

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");




parcelRequire("4D2TE");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $9da90027f67dc74f$var$ALIGNMENT = [
    'start',
    'end',
    'center'
];
var $9da90027f67dc74f$var$SPACE = [
    'space-between',
    'space-around',
    'space-evenly'
];
function $9da90027f67dc74f$var$makeRowProps(prefix, def) {
    return (0, $a7414385605a88b0$export$d07517a676ce386f).reduce(function(props, val) {
        var prefixKey = prefix + (0, $d8jBh.capitalize)(val);
        props[prefixKey] = def();
        return props;
    }, {});
}
var $9da90027f67dc74f$var$ALIGN_VALUES = (0, $7WNf6._)($9da90027f67dc74f$var$ALIGNMENT).concat([
    'baseline',
    'stretch'
]);
var $9da90027f67dc74f$var$alignValidator = function(str) {
    return $9da90027f67dc74f$var$ALIGN_VALUES.includes(str);
};
var $9da90027f67dc74f$var$alignProps = $9da90027f67dc74f$var$makeRowProps('align', function() {
    return {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$alignValidator
    };
});
var $9da90027f67dc74f$var$JUSTIFY_VALUES = (0, $7WNf6._)($9da90027f67dc74f$var$ALIGNMENT).concat((0, $7WNf6._)($9da90027f67dc74f$var$SPACE));
var $9da90027f67dc74f$var$justifyValidator = function(str) {
    return $9da90027f67dc74f$var$JUSTIFY_VALUES.includes(str);
};
var $9da90027f67dc74f$var$justifyProps = $9da90027f67dc74f$var$makeRowProps('justify', function() {
    return {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$justifyValidator
    };
});
var $9da90027f67dc74f$var$ALIGN_CONTENT_VALUES = (0, $7WNf6._)($9da90027f67dc74f$var$ALIGNMENT).concat((0, $7WNf6._)($9da90027f67dc74f$var$SPACE), [
    'stretch'
]);
var $9da90027f67dc74f$var$alignContentValidator = function(str) {
    return $9da90027f67dc74f$var$ALIGN_CONTENT_VALUES.includes(str);
};
var $9da90027f67dc74f$var$alignContentProps = $9da90027f67dc74f$var$makeRowProps('alignContent', function() {
    return {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$alignContentValidator
    };
});
var $9da90027f67dc74f$var$propMap = {
    align: Object.keys($9da90027f67dc74f$var$alignProps),
    justify: Object.keys($9da90027f67dc74f$var$justifyProps),
    alignContent: Object.keys($9da90027f67dc74f$var$alignContentProps)
};
var $9da90027f67dc74f$var$classMap = {
    align: 'align',
    justify: 'justify',
    alignContent: 'align-content'
};
function $9da90027f67dc74f$var$breakpointClass(type, prop, val) {
    var className = $9da90027f67dc74f$var$classMap[type];
    if (val == null) return undefined;
    if (prop) {
        // alignSm -> Sm
        var breakpoint = prop.replace(type, '');
        className += "-".concat(breakpoint);
    }
    // .align-items-sm-center
    className += "-".concat(val);
    return className.toLowerCase();
}
var $9da90027f67dc74f$export$aa6139b66bca50c0 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)((0, $emQHU._)((0, $iT0je._)({
    dense: Boolean,
    noGutters: Boolean,
    align: {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$alignValidator
    }
}, $9da90027f67dc74f$var$alignProps), {
    justify: {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$justifyValidator
    }
}), $9da90027f67dc74f$var$justifyProps), {
    alignContent: {
        type: String,
        "default": null,
        validator: $9da90027f67dc74f$var$alignContentValidator
    }
}), $9da90027f67dc74f$var$alignContentProps, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VRow');
var $9da90027f67dc74f$export$978f7f00e11cd63 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VRow',
    props: $9da90027f67dc74f$export$aa6139b66bca50c0(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var classes = (0, $hXmfK.computed)(function() {
            var classList = [];
            // Loop through `align`, `justify`, `alignContent` breakpoint props
            var type;
            for(type in $9da90027f67dc74f$var$propMap)$9da90027f67dc74f$var$propMap[type].forEach(function(prop) {
                var value = props[prop];
                var className = $9da90027f67dc74f$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            var _obj;
            classList.push((_obj = {
                'v-row--no-gutters': props.noGutters,
                'v-row--dense': props.dense
            }, (0, $cqEAj._)(_obj, "align-".concat(props.align), props.align), (0, $cqEAj._)(_obj, "justify-".concat(props.justify), props.justify), (0, $cqEAj._)(_obj, "align-content-".concat(props.alignContent), props.alignContent), _obj));
            return classList;
        });
        return function() {
            var _slots_default;
            return (0, $bu8yf.h)(props.tag, {
                "class": [
                    'v-row',
                    classes.value,
                    props["class"]
                ],
                style: props.style
            }, (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});





var $a7e87b08ee67b648$exports = {};

$parcel$export($a7e87b08ee67b648$exports, "VHover", function () { return $e2529a9ba20e0e32$export$18164602f71a6fd2; });
// Composables

var $iT0je = parcelRequire("iT0je");



var $e2529a9ba20e0e32$export$7189cef85a59ecb5 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    disabled: Boolean,
    modelValue: {
        type: Boolean,
        "default": null
    }
}, (0, $993255c150474af1$export$1fd3611e92a5a94)()), 'VHover');
var $e2529a9ba20e0e32$export$18164602f71a6fd2 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VHover',
    props: $e2529a9ba20e0e32$export$7189cef85a59ecb5(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isHovering = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useDelay = (0, $993255c150474af1$export$69f38700ea0cb3b9)(props, function(value) {
            return !props.disabled && (isHovering.value = value);
        }), runOpenDelay = _useDelay.runOpenDelay, runCloseDelay = _useDelay.runCloseDelay;
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isHovering: isHovering.value,
                props: {
                    onMouseenter: runOpenDelay,
                    onMouseleave: runCloseDelay
                }
            });
        };
    }
});




var $2b3e62a8aaaabcd4$exports = {};

$parcel$export($2b3e62a8aaaabcd4$exports, "VIcon", function () { return $f7a1be8330d12953$export$a7d30c6ec4d2d61e; });
$parcel$export($2b3e62a8aaaabcd4$exports, "VComponentIcon", function () { return $0192db7efcc99bb9$export$151a4e51f3246587; });
$parcel$export($2b3e62a8aaaabcd4$exports, "VSvgIcon", function () { return $0192db7efcc99bb9$export$4cc49047f32a5a44; });
$parcel$export($2b3e62a8aaaabcd4$exports, "VLigatureIcon", function () { return $0192db7efcc99bb9$export$d478d4439906e556; });
$parcel$export($2b3e62a8aaaabcd4$exports, "VClassIcon", function () { return $0192db7efcc99bb9$export$87ef10dabc6ea763; });




var $ac5e441f605ada63$exports = {};

$parcel$export($ac5e441f605ada63$exports, "VImg", function () { return $3fbd965354b26cae$export$126ec614c536f27c; });



var $637ef65ffa7ad03e$exports = {};

$parcel$export($637ef65ffa7ad03e$exports, "VInfiniteScroll", function () { return $21a4c1da60f6af9c$export$ba012ad002651a77; });

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");








var $21a4c1da60f6af9c$export$18c07fd75b3c9bd8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    direction: {
        type: String,
        "default": 'vertical',
        validator: function(v) {
            return [
                'vertical',
                'horizontal'
            ].includes(v);
        }
    },
    side: {
        type: String,
        "default": 'end',
        validator: function(v) {
            return [
                'start',
                'end',
                'both'
            ].includes(v);
        }
    },
    mode: {
        type: String,
        "default": 'intersect',
        validator: function(v) {
            return [
                'intersect',
                'manual'
            ].includes(v);
        }
    },
    margin: [
        Number,
        String
    ],
    loadMoreText: {
        type: String,
        "default": '$vuetify.infiniteScroll.loadMore'
    },
    emptyText: {
        type: String,
        "default": '$vuetify.infiniteScroll.empty'
    }
}, (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VInfiniteScroll');
var $21a4c1da60f6af9c$export$84669c010978ac95 = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VInfiniteScrollIntersect',
    props: {
        side: {
            type: String,
            required: true
        },
        rootMargin: String
    },
    emits: {
        intersect: function(side, isIntersecting) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        var _useIntersectionObserver = (0, $017d27f86fb94b2b$export$a7395f9832c00176)(), intersectionRef = _useIntersectionObserver.intersectionRef, isIntersecting = _useIntersectionObserver.isIntersecting;
        (0, $hXmfK.watch)(isIntersecting, function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    emit('intersect', props.side, val);
                    return [
                        2
                    ];
                });
            })();
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-infinite-scroll-intersect",
                style: {
                    '--v-infinite-margin-size': props.rootMargin
                },
                ref: intersectionRef
            }, [
                (0, $bu8yf.createTextVNode)("\xA0")
            ]);
        });
        return {};
    }
});
var $21a4c1da60f6af9c$export$ba012ad002651a77 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VInfiniteScroll',
    props: $21a4c1da60f6af9c$export$18c07fd75b3c9bd8(),
    emits: {
        load: function(options) {
            return true;
        }
    },
    setup: function(props, _ref2) {
        var slots = _ref2.slots, emit = _ref2.emit;
        var rootEl = (0, $hXmfK.ref)();
        var startStatus = (0, $hXmfK.shallowRef)('ok');
        var endStatus = (0, $hXmfK.shallowRef)('ok');
        var margin = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$286ad215293a0860)(props.margin);
        });
        var isIntersecting = (0, $hXmfK.shallowRef)(false);
        function setScrollAmount(amount) {
            if (!rootEl.value) return;
            var property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            rootEl.value[property] = amount;
        }
        function getScrollAmount() {
            if (!rootEl.value) return 0;
            var property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            return rootEl.value[property];
        }
        function getScrollSize() {
            if (!rootEl.value) return 0;
            var property = props.direction === 'vertical' ? 'scrollHeight' : 'scrollWidth';
            return rootEl.value[property];
        }
        function getContainerSize() {
            if (!rootEl.value) return 0;
            var property = props.direction === 'vertical' ? 'clientHeight' : 'clientWidth';
            return rootEl.value[property];
        }
        (0, $bu8yf.onMounted)(function() {
            if (!rootEl.value) return;
            if (props.side === 'start') setScrollAmount(getScrollSize());
            else if (props.side === 'both') setScrollAmount(getScrollSize() / 2 - getContainerSize() / 2);
        });
        function setStatus(side, status) {
            if (side === 'start') startStatus.value = status;
            else if (side === 'end') endStatus.value = status;
            else if (side === 'both') {
                startStatus.value = status;
                endStatus.value = status;
            }
        }
        function getStatus(side) {
            return side === 'start' ? startStatus.value : endStatus.value;
        }
        var previousScrollSize = 0;
        function handleIntersect(side, _isIntersecting) {
            isIntersecting.value = _isIntersecting;
            if (isIntersecting.value) intersecting(side);
        }
        function intersecting(side) {
            if (props.mode !== 'manual' && !isIntersecting.value) return;
            var status = getStatus(side);
            if (!rootEl.value || [
                'empty',
                'loading'
            ].includes(status)) return;
            previousScrollSize = getScrollSize();
            setStatus(side, 'loading');
            function done(status) {
                setStatus(side, status);
                (0, $bu8yf.nextTick)(function() {
                    if (status === 'empty' || status === 'error') return;
                    if (status === 'ok' && side === 'start') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                    if (props.mode !== 'manual') (0, $bu8yf.nextTick)(function() {
                        // Browser takes 2 - 3 animation frames to trigger IntersectionObserver after
                        // VInfiniteScrollIntersect leaves the viewpoint. So far I couldn't come up
                        // with a better solution than using 3 nested window.requestAnimationFrame. (#17475)
                        window.requestAnimationFrame(function() {
                            window.requestAnimationFrame(function() {
                                window.requestAnimationFrame(function() {
                                    intersecting(side);
                                });
                            });
                        });
                    });
                });
            }
            emit('load', {
                side: side,
                done: done
            });
        }
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        function renderSide(side, status) {
            var _slots_error, _slots_empty, _slots_loading;
            if (props.side !== side && props.side !== 'both') return;
            var onClick = function() {
                return intersecting(side);
            };
            var slotProps = {
                side: side,
                props: {
                    onClick: onClick,
                    color: props.color
                }
            };
            if (status === 'error') return (_slots_error = slots.error) === null || _slots_error === void 0 ? void 0 : _slots_error.call(slots, slotProps);
            var _slots_empty1;
            if (status === 'empty') return (_slots_empty1 = (_slots_empty = slots.empty) === null || _slots_empty === void 0 ? void 0 : _slots_empty.call(slots, slotProps)) !== null && _slots_empty1 !== void 0 ? _slots_empty1 : (0, $bu8yf.createElementVNode)("div", null, [
                t(props.emptyText)
            ]);
            if (props.mode === 'manual') {
                var _slots_loading1, _slots_loadmore;
                var _slots_loading2;
                if (status === 'loading') return (_slots_loading2 = (_slots_loading1 = slots.loading) === null || _slots_loading1 === void 0 ? void 0 : _slots_loading1.call(slots, slotProps)) !== null && _slots_loading2 !== void 0 ? _slots_loading2 : (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                    indeterminate: true,
                    color: props.color
                }, null);
                var _slots_loadmore1;
                return (_slots_loadmore1 = (_slots_loadmore = slots['load-more']) === null || _slots_loadmore === void 0 ? void 0 : _slots_loadmore.call(slots, slotProps)) !== null && _slots_loadmore1 !== void 0 ? _slots_loadmore1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    variant: "outlined",
                    color: props.color,
                    onClick: onClick
                }, {
                    "default": function() {
                        return [
                            t(props.loadMoreText)
                        ];
                    }
                });
            }
            var _slots_loading3;
            return (_slots_loading3 = (_slots_loading = slots.loading) === null || _slots_loading === void 0 ? void 0 : _slots_loading.call(slots, slotProps)) !== null && _slots_loading3 !== void 0 ? _slots_loading3 : (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                indeterminate: true,
                color: props.color
            }, null);
        }
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var Tag = props.tag;
            var hasStartIntersect = props.side === 'start' || props.side === 'both';
            var hasEndIntersect = props.side === 'end' || props.side === 'both';
            var intersectMode = props.mode === 'intersect';
            return (0, $bu8yf.createVNode)(Tag, {
                ref: rootEl,
                "class": (0, $d8jBh.normalizeClass)([
                    'v-infinite-scroll',
                    "v-infinite-scroll--".concat(props.direction),
                    {
                        'v-infinite-scroll--start': hasStartIntersect,
                        'v-infinite-scroll--end': hasEndIntersect
                    }
                ]),
                style: (0, $d8jBh.normalizeStyle)(dimensionStyles.value)
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('start', startStatus.value)
                        ]),
                        hasStartIntersect && intersectMode && (0, $bu8yf.createVNode)($21a4c1da60f6af9c$export$84669c010978ac95, {
                            key: "start",
                            side: "start",
                            onIntersect: handleIntersect,
                            rootMargin: margin.value
                        }, null),
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                        hasEndIntersect && intersectMode && (0, $bu8yf.createVNode)($21a4c1da60f6af9c$export$84669c010978ac95, {
                            key: "end",
                            side: "end",
                            onIntersect: handleIntersect,
                            rootMargin: margin.value
                        }, null),
                        (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('end', endStatus.value)
                        ])
                    ];
                }
            });
        });
        function reset(side) {
            var effectiveSide = side !== null && side !== void 0 ? side : props.side;
            setStatus(effectiveSide, 'ok');
            (0, $bu8yf.nextTick)(function() {
                setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                if (props.mode !== 'manual') (0, $bu8yf.nextTick)(function() {
                    // See #17475
                    window.requestAnimationFrame(function() {
                        window.requestAnimationFrame(function() {
                            window.requestAnimationFrame(function() {
                                if (effectiveSide === 'both') {
                                    intersecting('start');
                                    intersecting('end');
                                } else intersecting(effectiveSide);
                            });
                        });
                    });
                });
            });
        }
        return {
            reset: reset
        };
    }
});




var $5106b18c26887834$exports = {};

$parcel$export($5106b18c26887834$exports, "VInput", function () { return $b8b1b307f20fc3d6$export$2aca538d9f87f6ac; });



var $b971736ba8a9c96f$exports = {};

$parcel$export($b971736ba8a9c96f$exports, "VItemGroup", function () { return $03b4487f284ddeac$export$a0421bb7deea7bc9; });
$parcel$export($b971736ba8a9c96f$exports, "VItem", function () { return $257601ac7eaa07ab$export$89f8e1ba496bee4f; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");






var $03b4487f284ddeac$export$d47f675dc7233c18 = Symbol["for"]('vuetify:v-item-group');
var $03b4487f284ddeac$export$f9dfa1bfb55856d9 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $073309bf395585eb$export$fa4c05b3520340e6)({
    selectedClass: 'v-item--selected'
}), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VItemGroup');
var $03b4487f284ddeac$export$a0421bb7deea7bc9 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VItemGroup',
    props: $03b4487f284ddeac$export$f9dfa1bfb55856d9(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useGroup = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, $03b4487f284ddeac$export$d47f675dc7233c18), isSelected = _useGroup.isSelected, select = _useGroup.select, next = _useGroup.next, prev = _useGroup.prev, selected = _useGroup.selected;
        return function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-item-group',
                    themeClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ];
                }
            });
        };
    }
});


// Composables



var $257601ac7eaa07ab$export$89f8e1ba496bee4f = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VItem',
    props: (0, $073309bf395585eb$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useGroupItem = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $03b4487f284ddeac$export$d47f675dc7233c18)), isSelected = _useGroupItem.isSelected, select = _useGroupItem.select, toggle = _useGroupItem.toggle, selectedClass = _useGroupItem.selectedClass, value = _useGroupItem.value, disabled = _useGroupItem.disabled;
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isSelected: isSelected.value,
                selectedClass: selectedClass.value,
                select: select,
                toggle: toggle,
                value: value.value,
                disabled: disabled.value
            });
        };
    }
});




var $478135536c184ba6$exports = {};

$parcel$export($478135536c184ba6$exports, "VKbd", function () { return $05b5534382cdc455$export$ebd5060d8fa1579; });
// Styles


var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");









var $05b5534382cdc455$export$db48029448d91dd8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'kbd'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $753fdc0f0b894251$export$858059d20a48304b)()), 'VKbd');
var $05b5534382cdc455$export$ebd5060d8fa1579 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VKbd',
    props: $05b5534382cdc455$export$db48029448d91dd8(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-kbd',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});




var $9aebf6f2c8aaaf21$exports = {};

$parcel$export($9aebf6f2c8aaaf21$exports, "VLabel", function () { return $6c6f579f4011d0f0$export$90281af35207eb21; });



var $a0ee75f2450db1e6$exports = {};

$parcel$export($a0ee75f2450db1e6$exports, "VLayout", function () { return $4c1fef9d5eb2ae86$export$fd7ac754308b2698; });
$parcel$export($a0ee75f2450db1e6$exports, "VLayoutItem", function () { return $71035e1643b445ea$export$81da49e5190cd2c4; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");





var $4c1fef9d5eb2ae86$export$eb6bcdcfbf5fa46c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $39e98ff3447d557e$export$f0037fcffb4e2081)()), 'VLayout');
var $4c1fef9d5eb2ae86$export$fd7ac754308b2698 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VLayout',
    props: $4c1fef9d5eb2ae86$export$eb6bcdcfbf5fa46c(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _createLayout = (0, $39e98ff3447d557e$export$3dd437ade36ede40)(props), layoutClasses = _createLayout.layoutClasses, layoutStyles = _createLayout.layoutStyles, getLayoutItem = _createLayout.getLayoutItem, items = _createLayout.items, layoutRef = _createLayout.layoutRef;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                ref: layoutRef,
                "class": (0, $d8jBh.normalizeClass)([
                    layoutClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    layoutStyles.value,
                    props.style
                ])
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {
            getLayoutItem: getLayoutItem,
            items: items
        };
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $71035e1643b445ea$export$9e2dea49392136f7 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    position: {
        type: String,
        required: true
    },
    size: {
        type: [
            Number,
            String
        ],
        "default": 300
    },
    modelValue: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $39e98ff3447d557e$export$d42abac634ace931)()), 'VLayoutItem');
var $71035e1643b445ea$export$81da49e5190cd2c4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VLayoutItem',
    props: $71035e1643b445ea$export$9e2dea49392136f7(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var layoutItemStyles = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $hXmfK.computed)(function() {
                return parseInt(props.order, 10);
            }),
            position: (0, $hXmfK.toRef)(function() {
                return props.position;
            }),
            elementSize: (0, $hXmfK.toRef)(function() {
                return props.size;
            }),
            layoutSize: (0, $hXmfK.toRef)(function() {
                return props.size;
            }),
            active: (0, $hXmfK.toRef)(function() {
                return props.modelValue;
            }),
            absolute: (0, $hXmfK.toRef)(function() {
                return props.absolute;
            })
        }).layoutItemStyles;
        return function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-layout-item',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    layoutItemStyles.value,
                    props.style
                ])
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        };
    }
});




var $932d297d8c7d7f97$exports = {};

$parcel$export($932d297d8c7d7f97$exports, "VLazy", function () { return $9e3b32ad4cbb2203$export$c840683367f2f7cc; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







var $9e3b32ad4cbb2203$export$7e0bfdc21d0e5c9a = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    modelValue: Boolean,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        "default": function() {
            return {
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            };
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $7a70676d07761412$export$e5b7ff1a0fbdc00e)({
    transition: 'fade-transition'
})), 'VLazy');
var $9e3b32ad4cbb2203$export$c840683367f2f7cc = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VLazy',
    directives: {
        vIntersect: (0, $f77d117b08c9abf5$export$2e2bcd8739ae039)
    },
    props: $9e3b32ad4cbb2203$export$7e0bfdc21d0e5c9a(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        function onIntersect(isIntersecting) {
            if (isActive.value) return;
            isActive.value = isIntersecting;
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-lazy',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    return [
                        isActive.value && (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                            transition: props.transition,
                            appear: true
                        }, {
                            "default": function() {
                                var _slots_default;
                                return [
                                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                ];
                            }
                        })
                    ];
                }
            }), [
                [
                    (0, $f77d117b08c9abf5$export$2e2bcd8739ae039),
                    {
                        handler: onIntersect,
                        options: props.options
                    },
                    null
                ]
            ]);
        });
        return {};
    }
});




var $df4efdafa4371dc4$exports = {};

$parcel$export($df4efdafa4371dc4$exports, "VList", function () { return $c46d6e9c2ddd50d5$export$3b010b0401837103; });
$parcel$export($df4efdafa4371dc4$exports, "VListGroup", function () { return $0891b6ffb0402c20$export$22fc03a43764dcc7; });
$parcel$export($df4efdafa4371dc4$exports, "VListImg", function () { return $e8f86e0e69a22eca$export$dad6c498e719f15b; });
$parcel$export($df4efdafa4371dc4$exports, "VListItem", function () { return $d199497309ad1f0e$export$a6ee5a73ee56a146; });
$parcel$export($df4efdafa4371dc4$exports, "VListItemAction", function () { return $316db8322d57c65f$export$104c1ead9d891c55; });
$parcel$export($df4efdafa4371dc4$exports, "VListItemMedia", function () { return $46ef298028a8f627$export$18c32693f6eb8fdd; });
$parcel$export($df4efdafa4371dc4$exports, "VListItemSubtitle", function () { return $2f4a1b6bf70174ce$export$822b84d77d050116; });
$parcel$export($df4efdafa4371dc4$exports, "VListItemTitle", function () { return $9189b661f3080a91$export$d3fcc52550436b5b; });
$parcel$export($df4efdafa4371dc4$exports, "VListSubheader", function () { return $c18be527f2406595$export$70c4aba7bf48e22a; });


// Utilities

var $e8f86e0e69a22eca$export$dad6c498e719f15b = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-list-img');




var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $316db8322d57c65f$export$fb2699a134c6af57 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    start: Boolean,
    end: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VListItemAction');
var $316db8322d57c65f$export$104c1ead9d891c55 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListItemAction',
    props: $316db8322d57c65f$export$fb2699a134c6af57(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list-item-action',
                    {
                        'v-list-item-action--start': props.start,
                        'v-list-item-action--end': props.end
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, slots);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $46ef298028a8f627$export$bc8dec2df83055e0 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    start: Boolean,
    end: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VListItemMedia');
var $46ef298028a8f627$export$18c32693f6eb8fdd = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VListItemMedia',
    props: $46ef298028a8f627$export$bc8dec2df83055e0(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-list-item-media',
                    {
                        'v-list-item-media--start': props.start,
                        'v-list-item-media--end': props.end
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, slots);
        });
        return {};
    }
});







var $0c44c2b48b010bad$exports = {};

$parcel$export($0c44c2b48b010bad$exports, "VLocaleProvider", function () { return $e41a51c46d4fcde0$export$31df19007ea703da; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




var $e41a51c46d4fcde0$export$d5c1865211b2711 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    locale: String,
    fallbackLocale: String,
    messages: Object,
    rtl: {
        type: Boolean,
        "default": undefined
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VLocaleProvider');
var $e41a51c46d4fcde0$export$31df19007ea703da = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VLocaleProvider',
    props: $e41a51c46d4fcde0$export$d5c1865211b2711(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$4e518c250eba4aac)(props).rtlClasses;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-locale-provider',
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $a96bc83444910006$exports = {};

$parcel$export($a96bc83444910006$exports, "VMain", function () { return $c186dca825d8c26e$export$2ad79366571a8389; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







var $c186dca825d8c26e$export$604b06cdafed258f = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    scrollable: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'main'
})), 'VMain');
var $c186dca825d8c26e$export$2ad79366571a8389 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VMain',
    props: $c186dca825d8c26e$export$604b06cdafed258f(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var mainStyles = (0, $39e98ff3447d557e$export$f47430f7ffdcc134)().mainStyles;
        var ssrBootStyles = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().ssrBootStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-main',
                    {
                        'v-main--scrollable': props.scrollable
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    mainStyles.value,
                    ssrBootStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                "default": function() {
                    var _slots_default, _slots_default1;
                    return [
                        props.scrollable ? (0, $bu8yf.createElementVNode)("div", {
                            "class": "v-main__scroller"
                        }, [
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]) : (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)
                    ];
                }
            });
        });
        return {};
    }
});




var $c27b5636a9887bef$exports = {};

$parcel$export($c27b5636a9887bef$exports, "VMenu", function () { return $7cf2e5a7271d5533$export$a347888d6b8f252a; });



var $cfa90ba7b3395c79$exports = {};

$parcel$export($cfa90ba7b3395c79$exports, "VMessages", function () { return $536da37de9ff2b8b$export$31afdc787fe64f1d; });



var $8e4bb1cc17526ac1$exports = {};

$parcel$export($8e4bb1cc17526ac1$exports, "VNavigationDrawer", function () { return $6199936b3230d33c$export$2092f85d546b77d5; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");



// Utilities

var $cqEAj = parcelRequire("cqEAj");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

function $9b25cbde5fa1dc0a$export$5b8a2f2a5151b421(_ref) {
    var rootEl = _ref.rootEl, isSticky = _ref.isSticky, layoutItemStyles = _ref.layoutItemStyles;
    var isStuck = (0, $hXmfK.shallowRef)(false);
    var stuckPosition = (0, $hXmfK.shallowRef)(0);
    var stickyStyles = (0, $hXmfK.computed)(function() {
        var side = typeof isStuck.value === 'boolean' ? 'top' : isStuck.value;
        return [
            isSticky.value ? {
                top: 'auto',
                bottom: 'auto',
                height: undefined
            } : undefined,
            isStuck.value ? (0, $cqEAj._)({}, side, (0, $31779689cfd5da50$export$286ad215293a0860)(stuckPosition.value)) : {
                top: layoutItemStyles.value.top
            }
        ];
    });
    (0, $bu8yf.onMounted)(function() {
        (0, $hXmfK.watch)(isSticky, function(val) {
            if (val) window.addEventListener('scroll', onScroll, {
                passive: true
            });
            else window.removeEventListener('scroll', onScroll);
        }, {
            immediate: true
        });
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        window.removeEventListener('scroll', onScroll);
    });
    var lastScrollTop = 0;
    function onScroll() {
        var direction = lastScrollTop > window.scrollY ? 'up' : 'down';
        var rect = rootEl.value.getBoundingClientRect();
        var _layoutItemStyles_value_top;
        var layoutTop = parseFloat((_layoutItemStyles_value_top = layoutItemStyles.value.top) !== null && _layoutItemStyles_value_top !== void 0 ? _layoutItemStyles_value_top : 0);
        var top = window.scrollY - Math.max(0, stuckPosition.value - layoutTop);
        var bottom = rect.height + Math.max(stuckPosition.value, layoutTop) - window.scrollY - window.innerHeight;
        var bodyScroll = parseFloat(getComputedStyle(rootEl.value).getPropertyValue('--v-body-scroll-y')) || 0;
        if (rect.height < window.innerHeight - layoutTop) {
            isStuck.value = 'top';
            stuckPosition.value = layoutTop;
        } else if (direction === 'up' && isStuck.value === 'bottom' || direction === 'down' && isStuck.value === 'top') {
            stuckPosition.value = window.scrollY + rect.top - bodyScroll;
            isStuck.value = true;
        } else if (direction === 'down' && bottom <= 0) {
            stuckPosition.value = 0;
            isStuck.value = 'bottom';
        } else if (direction === 'up' && top <= 0) {
            if (!bodyScroll) {
                stuckPosition.value = rect.top + top;
                isStuck.value = 'top';
            } else if (isStuck.value !== 'top') {
                stuckPosition.value = -top + bodyScroll + layoutTop;
                isStuck.value = 'top';
            }
        }
        lastScrollTop = window.scrollY;
    }
    return {
        isStuck: isStuck,
        stickyStyles: stickyStyles
    };
}


// Composables

// Utilities

var $1608adfe0776f663$var$HORIZON = 100; // ms
var $1608adfe0776f663$var$HISTORY = 20; // number of samples to keep
/** @see https://android.googlesource.com/platform/frameworks/native/+/master/libs/input/VelocityTracker.cpp */ function $1608adfe0776f663$var$kineticEnergyToVelocity(work) {
    var sqrt2 = 1.41421356237;
    return (work < 0 ? -1 : 1.0) * Math.sqrt(Math.abs(work)) * sqrt2;
}
function $1608adfe0776f663$export$f51fa41ccb9b7df0(samples) {
    // The input should be in reversed time order (most recent sample at index i=0)
    if (samples.length < 2) // if 0 or 1 points, velocity is zero
    return 0;
    // if (samples[1].t > samples[0].t) {
    //   // Algorithm will still work, but not perfectly
    //   consoleWarn('Samples provided to calculateImpulseVelocity in the wrong order')
    // }
    if (samples.length === 2) {
        // if 2 points, basic linear calculation
        if (samples[1].t === samples[0].t) // consoleWarn(`Events have identical time stamps t=${samples[0].t}, setting velocity = 0`)
        return 0;
        return (samples[1].d - samples[0].d) / (samples[1].t - samples[0].t);
    }
    // Guaranteed to have at least 3 points here
    // start with the oldest sample and go forward in time
    var work = 0;
    for(var i = samples.length - 1; i > 0; i--){
        if (samples[i].t === samples[i - 1].t) continue;
        var vprev = $1608adfe0776f663$var$kineticEnergyToVelocity(work); // v[i-1]
        var vcurr = (samples[i].d - samples[i - 1].d) / (samples[i].t - samples[i - 1].t); // v[i]
        work += (vcurr - vprev) * Math.abs(vcurr);
        if (i === samples.length - 1) work *= 0.5;
    }
    return $1608adfe0776f663$var$kineticEnergyToVelocity(work) * 1000;
}
function $1608adfe0776f663$export$9753f5326cc4952a() {
    var touches = {};
    function addMovement(e) {
        Array.from(e.changedTouches).forEach(function(touch) {
            var _touches_touch_identifier;
            var samples = (_touches_touch_identifier = touches[touch.identifier]) !== null && _touches_touch_identifier !== void 0 ? _touches_touch_identifier : touches[touch.identifier] = new (0, $31779689cfd5da50$export$5900cd5f89b9a13a)($1608adfe0776f663$var$HISTORY);
            samples.push([
                e.timeStamp,
                touch
            ]);
        });
    }
    function endTouch(e) {
        Array.from(e.changedTouches).forEach(function(touch) {
            delete touches[touch.identifier];
        });
    }
    function getVelocity(id) {
        var _touches_id;
        var samples = (_touches_id = touches[id]) === null || _touches_id === void 0 ? void 0 : _touches_id.values().reverse();
        if (!samples) throw new Error("No samples for touch id ".concat(id));
        var newest = samples[0];
        var x = [];
        var y = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var val = _step.value;
                if (newest[0] - val[0] > $1608adfe0776f663$var$HORIZON) break;
                x.push({
                    t: val[0],
                    d: val[1].clientX
                });
                y.push({
                    t: val[0],
                    d: val[1].clientY
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            x: $1608adfe0776f663$export$f51fa41ccb9b7df0(x),
            y: $1608adfe0776f663$export$f51fa41ccb9b7df0(y),
            get direction () {
                var _this = this, x1 = _this.x, y1 = _this.y;
                var _ref = [
                    Math.abs(x1),
                    Math.abs(y1)
                ], absX = _ref[0], absY = _ref[1];
                return absX > absY && x1 >= 0 ? 'right' : absX > absY && x1 <= 0 ? 'left' : absY > absX && y1 >= 0 ? 'down' : absY > absX && y1 <= 0 ? 'up' : $1608adfe0776f663$var$oops();
            }
        };
    }
    return {
        addMovement: addMovement,
        endTouch: endTouch,
        getVelocity: getVelocity
    };
}
function $1608adfe0776f663$var$oops() {
    throw new Error();
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

function $d1835ca540ae834e$export$72022e98e0a26546(_ref) {
    var el = _ref.el, isActive = _ref.isActive, isTemporary = _ref.isTemporary, width = _ref.width, touchless = _ref.touchless, position = _ref.position;
    (0, $bu8yf.onMounted)(function() {
        window.addEventListener('touchstart', onTouchstart, {
            passive: true
        });
        window.addEventListener('touchmove', onTouchmove, {
            passive: false
        });
        window.addEventListener('touchend', onTouchend, {
            passive: true
        });
    });
    (0, $bu8yf.onBeforeUnmount)(function() {
        window.removeEventListener('touchstart', onTouchstart);
        window.removeEventListener('touchmove', onTouchmove);
        window.removeEventListener('touchend', onTouchend);
    });
    var isHorizontal = (0, $hXmfK.computed)(function() {
        return [
            'left',
            'right'
        ].includes(position.value);
    });
    var _useVelocity = (0, $1608adfe0776f663$export$9753f5326cc4952a)(), addMovement = _useVelocity.addMovement, endTouch = _useVelocity.endTouch, getVelocity = _useVelocity.getVelocity;
    var maybeDragging = false;
    var isDragging = (0, $hXmfK.shallowRef)(false);
    var dragProgress = (0, $hXmfK.shallowRef)(0);
    var offset = (0, $hXmfK.shallowRef)(0);
    var start;
    function getOffset(pos, active) {
        return (position.value === 'left' ? pos : position.value === 'right' ? document.documentElement.clientWidth - pos : position.value === 'top' ? pos : position.value === 'bottom' ? document.documentElement.clientHeight - pos : $d1835ca540ae834e$var$oops()) - (active ? width.value : 0);
    }
    function getProgress(pos) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var progress = position.value === 'left' ? (pos - offset.value) / width.value : position.value === 'right' ? (document.documentElement.clientWidth - pos - offset.value) / width.value : position.value === 'top' ? (pos - offset.value) / width.value : position.value === 'bottom' ? (document.documentElement.clientHeight - pos - offset.value) / width.value : $d1835ca540ae834e$var$oops();
        return limit ? (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(progress) : progress;
    }
    function onTouchstart(e) {
        if (touchless.value) return;
        var touchX = e.changedTouches[0].clientX;
        var touchY = e.changedTouches[0].clientY;
        var touchZone = 25;
        var inTouchZone = position.value === 'left' ? touchX < touchZone : position.value === 'right' ? touchX > document.documentElement.clientWidth - touchZone : position.value === 'top' ? touchY < touchZone : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - touchZone : $d1835ca540ae834e$var$oops();
        var inElement = isActive.value && (position.value === 'left' ? touchX < width.value : position.value === 'right' ? touchX > document.documentElement.clientWidth - width.value : position.value === 'top' ? touchY < width.value : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - width.value : $d1835ca540ae834e$var$oops());
        if (inTouchZone || inElement || isActive.value && isTemporary.value) {
            start = [
                touchX,
                touchY
            ];
            offset.value = getOffset(isHorizontal.value ? touchX : touchY, isActive.value);
            dragProgress.value = getProgress(isHorizontal.value ? touchX : touchY);
            maybeDragging = offset.value > -20 && offset.value < 80;
            endTouch(e);
            addMovement(e);
        }
    }
    function onTouchmove(e) {
        var touchX = e.changedTouches[0].clientX;
        var touchY = e.changedTouches[0].clientY;
        if (maybeDragging) {
            if (!e.cancelable) {
                maybeDragging = false;
                return;
            }
            var dx = Math.abs(touchX - start[0]);
            var dy = Math.abs(touchY - start[1]);
            var thresholdMet = isHorizontal.value ? dx > dy && dx > 3 : dy > dx && dy > 3;
            if (thresholdMet) {
                isDragging.value = true;
                maybeDragging = false;
            } else if ((isHorizontal.value ? dy : dx) > 3) maybeDragging = false;
        }
        if (!isDragging.value) return;
        e.preventDefault();
        addMovement(e);
        var progress = getProgress(isHorizontal.value ? touchX : touchY, false);
        dragProgress.value = Math.max(0, Math.min(1, progress));
        if (progress > 1) offset.value = getOffset(isHorizontal.value ? touchX : touchY, true);
        else if (progress < 0) offset.value = getOffset(isHorizontal.value ? touchX : touchY, false);
    }
    function onTouchend(e) {
        maybeDragging = false;
        if (!isDragging.value) return;
        addMovement(e);
        isDragging.value = false;
        var velocity = getVelocity(e.changedTouches[0].identifier);
        var vx = Math.abs(velocity.x);
        var vy = Math.abs(velocity.y);
        var thresholdMet = isHorizontal.value ? vx > vy && vx > 400 : vy > vx && vy > 3;
        if (thresholdMet) isActive.value = velocity.direction === (({
            left: 'right',
            right: 'left',
            top: 'down',
            bottom: 'up'
        })[position.value] || $d1835ca540ae834e$var$oops());
        else isActive.value = dragProgress.value > 0.5;
    }
    var dragStyles = (0, $hXmfK.computed)(function() {
        return isDragging.value ? {
            transform: position.value === 'left' ? "translateX(calc(-100% + ".concat(dragProgress.value * width.value, "px))") : position.value === 'right' ? "translateX(calc(100% - ".concat(dragProgress.value * width.value, "px))") : position.value === 'top' ? "translateY(calc(-100% + ".concat(dragProgress.value * width.value, "px))") : position.value === 'bottom' ? "translateY(calc(100% - ".concat(dragProgress.value * width.value, "px))") : $d1835ca540ae834e$var$oops(),
            transition: 'none'
        } : undefined;
    });
    (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(isDragging, function() {
        var _el_value, _el_value1;
        var _el_value_style_transform;
        var transform = (_el_value_style_transform = (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.transform) !== null && _el_value_style_transform !== void 0 ? _el_value_style_transform : null;
        var _el_value_style_transition;
        var transition = (_el_value_style_transition = (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.transition) !== null && _el_value_style_transition !== void 0 ? _el_value_style_transition : null;
        (0, $bu8yf.watchEffect)(function() {
            var _dragStyles_value, _el_value, _dragStyles_value1, _el_value1;
            (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.setProperty('transform', ((_dragStyles_value = dragStyles.value) === null || _dragStyles_value === void 0 ? void 0 : _dragStyles_value.transform) || 'none');
            (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.setProperty('transition', ((_dragStyles_value1 = dragStyles.value) === null || _dragStyles_value1 === void 0 ? void 0 : _dragStyles_value1.transition) || null);
        });
        (0, $hXmfK.onScopeDispose)(function() {
            var _el_value, _el_value1;
            (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.setProperty('transform', transform);
            (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.setProperty('transition', transition);
        });
    });
    return {
        isDragging: isDragging,
        dragProgress: dragProgress,
        dragStyles: dragStyles
    };
}
function $d1835ca540ae834e$var$oops() {
    throw new Error();
}




















var $6199936b3230d33c$var$locations = [
    'start',
    'end',
    'left',
    'right',
    'top',
    'bottom'
];
var $6199936b3230d33c$export$b9cc4b5bdef87275 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    disableResizeWatcher: Boolean,
    disableRouteWatcher: Boolean,
    expandOnHover: Boolean,
    floating: Boolean,
    modelValue: {
        type: Boolean,
        "default": null
    },
    permanent: Boolean,
    rail: {
        type: Boolean,
        "default": null
    },
    railWidth: {
        type: [
            Number,
            String
        ],
        "default": 56
    },
    scrim: {
        type: [
            Boolean,
            String
        ],
        "default": true
    },
    image: String,
    temporary: Boolean,
    persistent: Boolean,
    touchless: Boolean,
    width: {
        type: [
            Number,
            String
        ],
        "default": 256
    },
    location: {
        type: String,
        "default": 'start',
        validator: function(value) {
            return $6199936b3230d33c$var$locations.includes(value);
        }
    },
    sticky: Boolean
}, (0, $e0e369362aaf75e2$export$70b8b174e7d601ce)(), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $993255c150474af1$export$1fd3611e92a5a94)(), (0, $a7414385605a88b0$export$d0badecb383b472a)({
    mobile: null
}), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $39e98ff3447d557e$export$d42abac634ace931)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)({
    tag: 'nav'
}), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VNavigationDrawer');
var $6199936b3230d33c$export$2092f85d546b77d5 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VNavigationDrawer',
    props: $6199936b3230d33c$export$b9cc4b5bdef87275(),
    emits: {
        'update:modelValue': function(val) {
            return true;
        },
        'update:rail': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var isRtl = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().isRtl;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var borderClasses = (0, $e0e369362aaf75e2$export$6185a16c7b2926fb)(props).borderClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var router = (0, $f0fd6b0b61967e91$export$9a302a45f65d0572)();
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', null, function(v) {
            return !!v;
        });
        var ssrBootStyles = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().ssrBootStyles;
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        var rootEl = (0, $hXmfK.ref)();
        var isHovering = (0, $hXmfK.shallowRef)(false);
        var _useDelay = (0, $993255c150474af1$export$69f38700ea0cb3b9)(props, function(value) {
            isHovering.value = value;
        }), runOpenDelay = _useDelay.runOpenDelay, runCloseDelay = _useDelay.runCloseDelay;
        var width = (0, $hXmfK.computed)(function() {
            return props.rail && props.expandOnHover && isHovering.value ? Number(props.width) : Number(props.rail ? props.railWidth : props.width);
        });
        var location = (0, $hXmfK.computed)(function() {
            return (0, $a9eac1600b361ada$export$b56cedd93dedafd4)(props.location, isRtl.value);
        });
        var isPersistent = (0, $hXmfK.toRef)(function() {
            return props.persistent;
        });
        var isTemporary = (0, $hXmfK.computed)(function() {
            return !props.permanent && (mobile.value || props.temporary);
        });
        var isSticky = (0, $hXmfK.computed)(function() {
            return props.sticky && !isTemporary.value && location.value !== 'bottom';
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.expandOnHover && props.rail != null;
        }, function() {
            (0, $hXmfK.watch)(isHovering, function(val) {
                return emit('update:rail', !val);
            });
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return !props.disableResizeWatcher;
        }, function() {
            (0, $hXmfK.watch)(isTemporary, function(val) {
                return !props.permanent && (0, $bu8yf.nextTick)(function() {
                    return isActive.value = !val;
                });
            });
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return !props.disableRouteWatcher && !!router;
        }, function() {
            (0, $hXmfK.watch)(router.currentRoute, function() {
                return isTemporary.value && (isActive.value = false);
            });
        });
        (0, $hXmfK.watch)(function() {
            return props.permanent;
        }, function(val) {
            if (val) isActive.value = true;
        });
        if (props.modelValue == null && !isTemporary.value) isActive.value = props.permanent || !mobile.value;
        var _useTouch = (0, $d1835ca540ae834e$export$72022e98e0a26546)({
            el: rootEl,
            isActive: isActive,
            isTemporary: isTemporary,
            width: width,
            touchless: (0, $hXmfK.toRef)(function() {
                return props.touchless;
            }),
            position: location
        }), isDragging = _useTouch.isDragging, dragProgress = _useTouch.dragProgress;
        var layoutSize = (0, $hXmfK.computed)(function() {
            var size = isTemporary.value ? 0 : props.rail && props.expandOnHover ? Number(props.railWidth) : width.value;
            return isDragging.value ? size * dragProgress.value : size;
        });
        var _useLayoutItem = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $hXmfK.computed)(function() {
                return parseInt(props.order, 10);
            }),
            position: location,
            layoutSize: layoutSize,
            elementSize: width,
            active: (0, $hXmfK.readonly)(isActive),
            disableTransitions: (0, $hXmfK.toRef)(function() {
                return isDragging.value;
            }),
            absolute: (0, $hXmfK.computed)(function() {
                return(// eslint-disable-next-line @typescript-eslint/no-use-before-define
                props.absolute || isSticky.value && typeof isStuck.value !== 'string');
            })
        }), layoutItemStyles = _useLayoutItem.layoutItemStyles, layoutItemScrimStyles = _useLayoutItem.layoutItemScrimStyles;
        var _useSticky = (0, $9b25cbde5fa1dc0a$export$5b8a2f2a5151b421)({
            rootEl: rootEl,
            isSticky: isSticky,
            layoutItemStyles: layoutItemStyles
        }), isStuck = _useSticky.isStuck, stickyStyles = _useSticky.stickyStyles;
        var scrimColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        var scrimStyles = (0, $hXmfK.computed)(function() {
            return (0, $iT0je._)({}, isDragging.value ? {
                opacity: dragProgress.value * 0.2,
                transition: 'none'
            } : undefined, layoutItemScrimStyles.value);
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VList: {
                bgColor: 'transparent'
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasImage = slots.image || props.image;
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (0, $bu8yf.createVNode)(props.tag, (0, $bu8yf.mergeProps)({
                    ref: rootEl,
                    onMouseenter: runOpenDelay,
                    onMouseleave: runCloseDelay,
                    "class": [
                        'v-navigation-drawer',
                        "v-navigation-drawer--".concat(location.value),
                        {
                            'v-navigation-drawer--expand-on-hover': props.expandOnHover,
                            'v-navigation-drawer--floating': props.floating,
                            'v-navigation-drawer--is-hovering': isHovering.value,
                            'v-navigation-drawer--rail': props.rail,
                            'v-navigation-drawer--temporary': isTemporary.value,
                            'v-navigation-drawer--persistent': isPersistent.value,
                            'v-navigation-drawer--active': isActive.value,
                            'v-navigation-drawer--sticky': isSticky.value
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        displayClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props["class"]
                    ],
                    style: [
                        backgroundColorStyles.value,
                        layoutItemStyles.value,
                        ssrBootStyles.value,
                        stickyStyles.value,
                        props.style
                    ]
                }, scopeId, attrs), {
                    "default": function() {
                        var _slots_prepend, _slots_default, _slots_append;
                        return [
                            hasImage && (0, $bu8yf.createElementVNode)("div", {
                                key: "image",
                                "class": "v-navigation-drawer__img"
                            }, [
                                !slots.image ? (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                                    key: "image-img",
                                    alt: "",
                                    cover: true,
                                    height: "inherit",
                                    src: props.image
                                }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                    key: "image-defaults",
                                    disabled: !props.image,
                                    defaults: {
                                        VImg: {
                                            alt: '',
                                            cover: true,
                                            height: 'inherit',
                                            src: props.image
                                        }
                                    }
                                }, slots.image)
                            ]),
                            slots.prepend && (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-navigation-drawer__prepend"
                            }, [
                                (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots)
                            ]),
                            (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-navigation-drawer__content"
                            }, [
                                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                            ]),
                            slots.append && (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-navigation-drawer__append"
                            }, [
                                (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                            ])
                        ];
                    }
                }),
                (0, $bu8yf.createVNode)((0, $kiZwI.Transition), {
                    name: "fade-transition"
                }, {
                    "default": function() {
                        return [
                            isTemporary.value && (isDragging.value || isActive.value) && !!props.scrim && (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                                "class": [
                                    'v-navigation-drawer__scrim',
                                    scrimColor.backgroundColorClasses.value
                                ],
                                style: [
                                    scrimStyles.value,
                                    scrimColor.backgroundColorStyles.value
                                ],
                                onClick: function() {
                                    if (isPersistent.value) return;
                                    isActive.value = false;
                                }
                            }, scopeId), null)
                        ];
                    }
                })
            ]);
        });
        return {
            isStuck: isStuck
        };
    }
});




var $9cd63ced416bf39a$exports = {};

$parcel$export($9cd63ced416bf39a$exports, "VNoSsr", function () { return $a7a04635ae041404$export$3be0fc655d27bb1a; });
// Composables


var $a7a04635ae041404$export$3be0fc655d27bb1a = (0, $87e73a4a4b645892$export$afa64b67e5a01c3b)({
    name: 'VNoSsr',
    setup: function(_, _ref) {
        var slots = _ref.slots;
        var show = (0, $5e2188d9568ff520$export$5b8689c380bcb3d5)();
        return function() {
            var _slots_default;
            return show.value && ((_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});




var $a43186ffeb8da401$exports = {};

$parcel$export($a43186ffeb8da401$exports, "VNumberInput", function () { return $81786a8daf027119$export$ecd5b157968c4270; });

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");





// Utilities
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $005004535cc1ff13$var$HOLD_REPEAT = 50;
var $005004535cc1ff13$var$HOLD_DELAY = 500;
function $005004535cc1ff13$export$9b6ebe8ffd9dc981(_ref) {
    var toggleUpDown = _ref.toggleUpDown;
    var timeout = -1;
    var interval = -1;
    (0, $hXmfK.onScopeDispose)(holdStop);
    function holdStart(value) {
        holdStop();
        tick(value);
        window.addEventListener('pointerup', holdStop);
        document.addEventListener('blur', holdStop);
        timeout = window.setTimeout(function() {
            interval = window.setInterval(function() {
                return tick(value);
            }, $005004535cc1ff13$var$HOLD_REPEAT);
        }, $005004535cc1ff13$var$HOLD_DELAY);
    }
    function holdStop() {
        window.clearTimeout(timeout);
        window.clearInterval(interval);
        window.removeEventListener('pointerup', holdStop);
        document.removeEventListener('blur', holdStop);
    }
    function tick(value) {
        toggleUpDown(value === 'up');
    }
    return {
        holdStart: holdStart,
        holdStop: holdStop
    };
}







var $81786a8daf027119$var$makeVNumberInputProps = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    controlVariant: {
        type: String,
        "default": 'default'
    },
    inset: Boolean,
    hideInput: Boolean,
    modelValue: {
        type: Number,
        "default": null
    },
    min: {
        type: Number,
        "default": Number.MIN_SAFE_INTEGER
    },
    max: {
        type: Number,
        "default": Number.MAX_SAFE_INTEGER
    },
    step: {
        type: Number,
        "default": 1
    },
    precision: {
        type: Number,
        "default": 0
    },
    minFractionDigits: {
        type: Number,
        "default": null
    },
    decimalSeparator: {
        type: String,
        validator: function(v) {
            return !v || v.length === 1;
        }
    }
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9193e20196e963bf$export$c9f7484641b0b190)(), [
    'modelValue',
    'validationValue'
])), 'VNumberInput');
var $81786a8daf027119$export$ecd5b157968c4270 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VNumberInput',
    props: (0, $iT0je._)({}, $81786a8daf027119$var$makeVNumberInputProps()),
    emits: {
        'update:focused': function(val) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var vTextFieldRef = (0, $hXmfK.ref)();
        var _useHold = (0, $005004535cc1ff13$export$9b6ebe8ffd9dc981)({
            toggleUpDown: toggleUpDown
        }), holdStart = _useHold.holdStart, holdStop = _useHold.holdStop;
        var form = (0, $04771d0544148a45$export$87c0cf8eb5a167e0)(props);
        var controlsDisabled = (0, $hXmfK.computed)(function() {
            return form.isDisabled.value || form.isReadonly.value;
        });
        var isFocused = (0, $hXmfK.shallowRef)(props.focused);
        var _useLocale = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)(), decimalSeparatorFromLocale = _useLocale.decimalSeparator;
        var decimalSeparator = (0, $hXmfK.computed)(function() {
            var _props_decimalSeparator;
            return ((_props_decimalSeparator = props.decimalSeparator) === null || _props_decimalSeparator === void 0 ? void 0 : _props_decimalSeparator[0]) || decimalSeparatorFromLocale.value;
        });
        function correctPrecision(val) {
            var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.precision;
            var trim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var fixed = precision == null ? String(val) : val.toFixed(precision);
            if (isFocused.value && trim) return Number(fixed).toString() // trim zeros
            .replace('.', decimalSeparator.value);
            if (props.minFractionDigits === null || precision !== null && precision < props.minFractionDigits) return fixed.replace('.', decimalSeparator.value);
            var _fixed_split = (0, $32TW8._)(fixed.split('.'), 2), baseDigits = _fixed_split[0], fractionDigits = _fixed_split[1];
            fractionDigits = (fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : '').padEnd(props.minFractionDigits, '0').replace(new RegExp("(?<=\\d{".concat(props.minFractionDigits, "})0"), 'g'), '');
            return [
                baseDigits,
                fractionDigits
            ].filter(Boolean).join(decimalSeparator.value);
        }
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', null, function(val) {
            return val !== null && val !== void 0 ? val : null;
        }, function(val) {
            return val == null ? val !== null && val !== void 0 ? val : null : (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(Number(val), props.min, props.max);
        });
        var _inputText = (0, $hXmfK.shallowRef)(null);
        (0, $bu8yf.watchEffect)(function() {
            if (isFocused.value && !controlsDisabled.value) ;
            else if (model.value == null) _inputText.value = null;
            else if (!isNaN(model.value)) _inputText.value = correctPrecision(model.value);
        });
        var inputText = (0, $hXmfK.computed)({
            get: function() {
                return _inputText.value;
            },
            set: function(val) {
                if (val === null || val === '') {
                    model.value = null;
                    _inputText.value = null;
                    return;
                }
                var parsedValue = Number(val.replace(decimalSeparator.value, '.'));
                if (!isNaN(parsedValue) && parsedValue <= props.max && parsedValue >= props.min) {
                    model.value = parsedValue;
                    _inputText.value = val;
                }
            }
        });
        var canIncrease = (0, $hXmfK.computed)(function() {
            if (controlsDisabled.value) return false;
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : 0) + props.step <= props.max;
        });
        var canDecrease = (0, $hXmfK.computed)(function() {
            if (controlsDisabled.value) return false;
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : 0) - props.step >= props.min;
        });
        var controlVariant = (0, $hXmfK.computed)(function() {
            return props.hideInput ? 'stacked' : props.controlVariant;
        });
        var incrementIcon = (0, $hXmfK.toRef)(function() {
            return controlVariant.value === 'split' ? '$plus' : '$collapse';
        });
        var decrementIcon = (0, $hXmfK.toRef)(function() {
            return controlVariant.value === 'split' ? '$minus' : '$expand';
        });
        var controlNodeSize = (0, $hXmfK.toRef)(function() {
            return controlVariant.value === 'split' ? 'default' : 'small';
        });
        var controlNodeDefaultHeight = (0, $hXmfK.toRef)(function() {
            return controlVariant.value === 'stacked' ? 'auto' : '100%';
        });
        var incrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onUpControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        var decrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onDownControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        (0, $hXmfK.watch)(function() {
            return props.precision;
        }, function() {
            return formatInputValue();
        });
        (0, $hXmfK.watch)(function() {
            return props.minFractionDigits;
        }, function() {
            return formatInputValue();
        });
        (0, $bu8yf.onMounted)(function() {
            clampModel();
        });
        function inferPrecision(value) {
            if (value == null) return 0;
            var str = value.toString();
            var idx = str.indexOf('.');
            return ~idx ? str.length - idx : 0;
        }
        function toggleUpDown() {
            var increment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (controlsDisabled.value) return;
            if (model.value == null) {
                inputText.value = correctPrecision((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(0, props.min, props.max));
                return;
            }
            var inferredPrecision = Math.max(inferPrecision(model.value), inferPrecision(props.step));
            if (props.precision != null) inferredPrecision = Math.max(inferredPrecision, props.precision);
            if (increment) {
                if (canIncrease.value) inputText.value = correctPrecision(model.value + props.step, inferredPrecision);
            } else if (canDecrease.value) inputText.value = correctPrecision(model.value - props.step, inferredPrecision);
        }
        function onBeforeinput(e) {
            var _potentialNewInputVal_split_;
            if (!e.data) return;
            var inputElement = e.target;
            var _$_ref = inputElement !== null && inputElement !== void 0 ? inputElement : {}, existingTxt = _$_ref.value, selectionStart = _$_ref.selectionStart, selectionEnd = _$_ref.selectionEnd;
            var potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
            var potentialNewNumber = (0, $31779689cfd5da50$export$ee2b54e92bdbaa0c)(potentialNewInputVal, props.precision, decimalSeparator.value);
            // Allow only numbers, "-" and {decimal separator}
            // Allow "-" and {decimal separator} only once
            // Allow "-" only at the start
            if (!new RegExp("^-?\\d*".concat((0, $31779689cfd5da50$export$211de94a4ac98986)(decimalSeparator.value), "?\\d*$")).test(potentialNewInputVal)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
            if (props.precision == null) return;
            // Ignore decimal digits above precision limit
            if (((_potentialNewInputVal_split_ = potentialNewInputVal.split(decimalSeparator.value)[1]) === null || _potentialNewInputVal_split_ === void 0 ? void 0 : _potentialNewInputVal_split_.length) > props.precision) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
            // Ignore decimal separator when precision = 0
            if (props.precision === 0 && potentialNewInputVal.includes(decimalSeparator.value)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
        }
        function onKeydown(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ([
                                'Enter',
                                'ArrowLeft',
                                'ArrowRight',
                                'Backspace',
                                'Delete',
                                'Tab'
                            ].includes(e.key) || e.ctrlKey) return [
                                2
                            ];
                            if (![
                                'ArrowDown',
                                'ArrowUp'
                            ].includes(e.key)) return [
                                3,
                                2
                            ];
                            e.preventDefault();
                            clampModel();
                            // _model is controlled, so need to wait until props['modelValue'] is updated
                            return [
                                4,
                                (0, $bu8yf.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            if (e.key === 'ArrowDown') toggleUpDown(false);
                            else toggleUpDown();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function onControlClick(e) {
            e.stopPropagation();
        }
        function onControlMouseup(e) {
            var el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.releasePointerCapture(e.pointerId);
            e.preventDefault();
            holdStop();
        }
        function onUpControlMousedown(e) {
            var el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('up');
        }
        function onDownControlMousedown(e) {
            var el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('down');
        }
        function clampModel() {
            if (controlsDisabled.value) return;
            if (!vTextFieldRef.value) return;
            var actualText = vTextFieldRef.value.value;
            var parsedValue = Number(actualText.replace(decimalSeparator.value, '.'));
            if (actualText && !isNaN(parsedValue)) inputText.value = correctPrecision((0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(parsedValue, props.min, props.max));
            else inputText.value = null;
        }
        function formatInputValue() {
            if (controlsDisabled.value) return;
            inputText.value = model.value !== null && !isNaN(model.value) ? correctPrecision(model.value, props.precision, false) : null;
        }
        function trimDecimalZeros() {
            if (controlsDisabled.value) return;
            if (model.value === null || isNaN(model.value)) {
                inputText.value = null;
                return;
            }
            inputText.value = model.value.toString().replace('.', decimalSeparator.value);
        }
        function onFocus() {
            trimDecimalZeros();
        }
        function onBlur() {
            clampModel();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var incrementControlNode = function incrementControlNode() {
                return !slots.increment ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "increment",
                    disabled: !canIncrease.value,
                    flat: true,
                    height: controlNodeDefaultHeight.value,
                    icon: incrementIcon.value,
                    key: "increment-btn",
                    onClick: onControlClick,
                    onPointerdown: onUpControlMousedown,
                    onPointerup: onControlMouseup,
                    onPointercancel: onControlMouseup,
                    size: controlNodeSize.value,
                    tabindex: "-1"
                }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    key: "increment-defaults",
                    defaults: {
                        VBtn: {
                            disabled: !canIncrease.value,
                            flat: true,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: incrementIcon.value
                        }
                    }
                }, {
                    "default": function() {
                        return [
                            slots.increment(incrementSlotProps)
                        ];
                    }
                });
            };
            var decrementControlNode = function decrementControlNode() {
                return !slots.decrement ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "decrement",
                    disabled: !canDecrease.value,
                    flat: true,
                    height: controlNodeDefaultHeight.value,
                    icon: decrementIcon.value,
                    key: "decrement-btn",
                    onClick: onControlClick,
                    onPointerdown: onDownControlMousedown,
                    onPointerup: onControlMouseup,
                    onPointercancel: onControlMouseup,
                    size: controlNodeSize.value,
                    tabindex: "-1"
                }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    key: "decrement-defaults",
                    defaults: {
                        VBtn: {
                            disabled: !canDecrease.value,
                            flat: true,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: decrementIcon.value
                        }
                    }
                }, {
                    "default": function() {
                        return [
                            slots.decrement(decrementSlotProps)
                        ];
                    }
                });
            };
            var controlNode = function controlNode() {
                return (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-number-input__control"
                }, [
                    decrementControlNode(),
                    (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), {
                        vertical: controlVariant.value !== 'stacked'
                    }, null),
                    incrementControlNode()
                ]);
            };
            var dividerNode = function dividerNode() {
                return !props.hideInput && !props.inset ? (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), {
                    vertical: true
                }, null) : undefined;
            };
            var _VTextField_filterProps = (0, $9193e20196e963bf$export$d591c92dea965c28).filterProps(props), _ = _VTextField_filterProps.modelValue, textFieldProps = (0, $g79Gh._)(_VTextField_filterProps, [
                "modelValue"
            ]);
            var appendInnerControl = controlVariant.value === 'split' ? (0, $bu8yf.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), {
                    vertical: true
                }, null),
                incrementControlNode()
            ]) : props.reverse || controlVariant.value === 'hidden' ? undefined : (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                dividerNode(),
                controlNode()
            ]);
            var hasAppendInner = slots['append-inner'] || appendInnerControl;
            var prependInnerControl = controlVariant.value === 'split' ? (0, $bu8yf.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                decrementControlNode(),
                (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), {
                    vertical: true
                }, null)
            ]) : props.reverse && controlVariant.value !== 'hidden' ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                controlNode(),
                dividerNode()
            ]) : undefined;
            var hasPrependInner = slots['prepend-inner'] || prependInnerControl;
            return (0, $bu8yf.createVNode)((0, $9193e20196e963bf$export$d591c92dea965c28), (0, $bu8yf.mergeProps)({
                ref: vTextFieldRef
            }, textFieldProps, {
                modelValue: inputText.value,
                "onUpdate:modelValue": function($event) {
                    return inputText.value = $event;
                },
                focused: isFocused.value,
                "onUpdate:focused": function($event) {
                    return isFocused.value = $event;
                },
                validationValue: model.value,
                onBeforeinput: onBeforeinput,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeydown: onKeydown,
                "class": [
                    'v-number-input',
                    {
                        'v-number-input--default': controlVariant.value === 'default',
                        'v-number-input--hide-input': props.hideInput,
                        'v-number-input--inset': props.inset,
                        'v-number-input--reverse': props.reverse,
                        'v-number-input--split': controlVariant.value === 'split',
                        'v-number-input--stacked': controlVariant.value === 'stacked'
                    },
                    props["class"]
                ],
                style: props.style,
                inputmode: "decimal"
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                'append-inner': hasAppendInner ? function() {
                    var _slots_appendinner;
                    var _slots_appendinner1;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_appendinner1 = slots['append-inner']) === null || _slots_appendinner1 === void 0 ? void 0 : (_slots_appendinner = _slots_appendinner1).call.apply(_slots_appendinner, [
                            slots
                        ].concat((0, $7WNf6._)(args))),
                        appendInnerControl
                    ]);
                } : undefined,
                'prepend-inner': hasPrependInner ? function() {
                    var _slots_prependinner;
                    var _slots_prependinner1;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        prependInnerControl,
                        (_slots_prependinner1 = slots['prepend-inner']) === null || _slots_prependinner1 === void 0 ? void 0 : (_slots_prependinner = _slots_prependinner1).call.apply(_slots_prependinner, [
                            slots
                        ].concat((0, $7WNf6._)(args)))
                    ]);
                } : undefined
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, vTextFieldRef);
    }
});




var $efcda17f911672f2$exports = {};

$parcel$export($efcda17f911672f2$exports, "VOtpInput", function () { return $f0351670e3836c67$export$a3674b497e85ad8; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");












var $f0351670e3836c67$export$ad920badd2504e58 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autofocus: Boolean,
    divider: String,
    focusAll: Boolean,
    label: {
        type: String,
        "default": '$vuetify.input.otp'
    },
    length: {
        type: [
            Number,
            String
        ],
        "default": 6
    },
    modelValue: {
        type: [
            Number,
            String
        ],
        "default": undefined
    },
    placeholder: String,
    type: {
        type: String,
        "default": 'number'
    }
}, (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $6f0e0973cbf83779$export$676d4e684e4b0e1e)(), (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $88ed151c68066729$export$1e13429dc53b9634)({
    variant: 'outlined'
}), [
    'baseColor',
    'bgColor',
    'class',
    'color',
    'disabled',
    'error',
    'loading',
    'rounded',
    'style',
    'theme',
    'variant'
])), 'VOtpInput');
var $f0351670e3836c67$export$a3674b497e85ad8 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VOtpInput',
    props: $f0351670e3836c67$export$ad920badd2504e58(),
    emits: {
        finish: function(val) {
            return true;
        },
        'update:focused': function(val) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', '', function(val) {
            return val == null ? [] : String(val).split('');
        }, function(val) {
            return val.join('');
        });
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var length = (0, $hXmfK.computed)(function() {
            return Number(props.length);
        });
        var fields = (0, $hXmfK.computed)(function() {
            return Array(length.value).fill(0);
        });
        var focusIndex = (0, $hXmfK.ref)(-1);
        var contentRef = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)([]);
        var current = (0, $hXmfK.computed)(function() {
            return inputRef.value[focusIndex.value];
        });
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return props.autofocus;
        }, function() {
            var intersectScope = (0, $hXmfK.effectScope)();
            intersectScope.run(function() {
                var _useIntersectionObserver = (0, $017d27f86fb94b2b$export$a7395f9832c00176)(), intersectionRef = _useIntersectionObserver.intersectionRef, isIntersecting = _useIntersectionObserver.isIntersecting;
                (0, $bu8yf.watchEffect)(function() {
                    intersectionRef.value = inputRef.value[0];
                });
                (0, $hXmfK.watch)(isIntersecting, function(v) {
                    var _intersectionRef_value;
                    if (!v) return;
                    (_intersectionRef_value = intersectionRef.value) === null || _intersectionRef_value === void 0 ? void 0 : _intersectionRef_value.focus();
                    intersectScope.stop();
                });
            });
        });
        function onInput() {
            // The maxlength attribute doesn't work for the number type input, so the text type is used.
            // The following logic simulates the behavior of a number input.
            if (isValidNumber(current.value.value)) {
                current.value.value = '';
                return;
            }
            var array = model.value.slice();
            var value = current.value.value;
            array[focusIndex.value] = value;
            var target = null;
            if (focusIndex.value > model.value.length) target = model.value.length + 1;
            else if (focusIndex.value + 1 !== length.value) target = 'next';
            model.value = array;
            if (target) (0, $31779689cfd5da50$export$da2eafa20d5ebba)(contentRef.value, target);
        }
        function onKeydown(e) {
            var array = model.value.slice();
            var index = focusIndex.value;
            var target = null;
            if (![
                'ArrowLeft',
                'ArrowRight',
                'Backspace',
                'Delete'
            ].includes(e.key)) return;
            e.preventDefault();
            if (e.key === 'ArrowLeft') target = 'prev';
            else if (e.key === 'ArrowRight') target = 'next';
            else if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                array[focusIndex.value] = '';
                model.value = array;
                if (focusIndex.value > 0 && e.key === 'Backspace') target = 'prev';
                else requestAnimationFrame(function() {
                    var _inputRef_value_index;
                    (_inputRef_value_index = inputRef.value[index]) === null || _inputRef_value_index === void 0 ? void 0 : _inputRef_value_index.select();
                });
            }
            requestAnimationFrame(function() {
                if (target != null) (0, $31779689cfd5da50$export$da2eafa20d5ebba)(contentRef.value, target);
            });
        }
        function onPaste(index, e) {
            var _e_clipboardData, _inputRef_value;
            e.preventDefault();
            e.stopPropagation();
            var _e_clipboardData_getData_trim_slice;
            var clipboardText = (_e_clipboardData_getData_trim_slice = e === null || e === void 0 ? void 0 : (_e_clipboardData = e.clipboardData) === null || _e_clipboardData === void 0 ? void 0 : _e_clipboardData.getData('Text').trim().slice(0, length.value)) !== null && _e_clipboardData_getData_trim_slice !== void 0 ? _e_clipboardData_getData_trim_slice : '';
            var finalIndex = clipboardText.length - 1 === -1 ? index : clipboardText.length - 1;
            if (isValidNumber(clipboardText)) return;
            model.value = clipboardText.split('');
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value[finalIndex].focus();
        }
        function reset() {
            model.value = [];
        }
        function onFocus(e, index) {
            focus();
            focusIndex.value = index;
        }
        function onBlur() {
            blur();
            focusIndex.value = -1;
        }
        function isValidNumber(value) {
            return props.type === 'number' && /[^0-9]/g.test(value);
        }
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VField: {
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                bgColor: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                baseColor: (0, $hXmfK.toRef)(function() {
                    return props.baseColor;
                }),
                disabled: (0, $hXmfK.toRef)(function() {
                    return props.disabled;
                }),
                error: (0, $hXmfK.toRef)(function() {
                    return props.error;
                }),
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        }, {
            scoped: true
        });
        (0, $hXmfK.watch)(model, function(val) {
            if (val.length === length.value) {
                focusIndex.value = length.value - 1;
                emit('finish', val.join(''));
            }
        }, {
            deep: true
        });
        (0, $hXmfK.watch)(focusIndex, function(val) {
            if (val < 0) return;
            (0, $bu8yf.nextTick)(function() {
                var _inputRef_value_val;
                (_inputRef_value_val = inputRef.value[val]) === null || _inputRef_value_val === void 0 ? void 0 : _inputRef_value_val.select();
            });
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], inputAttrs = _filterInputAttrs[1];
            return (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                "class": [
                    'v-otp-input',
                    {
                        'v-otp-input--divided': !!props.divider
                    },
                    props["class"]
                ],
                style: [
                    props.style
                ]
            }, rootAttrs), [
                (0, $bu8yf.createElementVNode)("div", {
                    ref: contentRef,
                    "class": "v-otp-input__content",
                    style: (0, $d8jBh.normalizeStyle)([
                        dimensionStyles.value
                    ])
                }, [
                    fields.value.map(function(_, i) {
                        return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            props.divider && i !== 0 && (0, $bu8yf.createElementVNode)("span", {
                                "class": "v-otp-input__divider"
                            }, [
                                props.divider
                            ]),
                            (0, $bu8yf.createVNode)((0, $88ed151c68066729$export$3180fb4997e9f72d), {
                                focused: isFocused.value && props.focusAll || focusIndex.value === i,
                                key: i
                            }, (0, $emQHU._)((0, $iT0je._)({}, slots), {
                                loader: undefined,
                                "default": function() {
                                    return (0, $bu8yf.createElementVNode)("input", {
                                        ref: function(val) {
                                            return inputRef.value[i] = val;
                                        },
                                        "aria-label": t(props.label, i + 1),
                                        autofocus: i === 0 && props.autofocus,
                                        autocomplete: "one-time-code",
                                        "class": (0, $d8jBh.normalizeClass)([
                                            'v-otp-input__field'
                                        ]),
                                        disabled: props.disabled,
                                        inputmode: props.type === 'number' ? 'numeric' : 'text',
                                        min: props.type === 'number' ? 0 : undefined,
                                        maxlength: i === 0 ? length.value : '1',
                                        placeholder: props.placeholder,
                                        type: props.type === 'number' ? 'text' : props.type,
                                        value: model.value[i],
                                        onInput: onInput,
                                        onFocus: function(e) {
                                            return onFocus(e, i);
                                        },
                                        onBlur: onBlur,
                                        onKeydown: onKeydown,
                                        onPaste: function(event) {
                                            return onPaste(i, event);
                                        }
                                    }, null);
                                }
                            }))
                        ]);
                    }),
                    (0, $bu8yf.createElementVNode)("input", (0, $bu8yf.mergeProps)({
                        "class": "v-otp-input-input",
                        type: "hidden"
                    }, inputAttrs, {
                        value: model.value.join('')
                    }), null),
                    (0, $bu8yf.createVNode)((0, $7f198793a6132466$export$32caf7e8170352aa), {
                        contained: true,
                        contentClass: "v-otp-input__loader",
                        modelValue: !!props.loading,
                        persistent: true
                    }, {
                        "default": function() {
                            var _slots_loader;
                            var _slots_loader1;
                            return [
                                (_slots_loader1 = (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots)) !== null && _slots_loader1 !== void 0 ? _slots_loader1 : (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                                    color: typeof props.loading === 'boolean' ? undefined : props.loading,
                                    indeterminate: true,
                                    size: "24",
                                    width: "2"
                                }, null)
                            ];
                        }
                    }),
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ])
            ]);
        });
        return {
            blur: function() {
                var _inputRef_value;
                (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.some(function(input) {
                    return input.blur();
                });
            },
            focus: function() {
                var _inputRef_value;
                (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value[0].focus();
            },
            reset: reset,
            isFocused: isFocused
        };
    }
});




var $966e66413e6dddde$exports = {};

$parcel$export($966e66413e6dddde$exports, "VOverlay", function () { return $7f198793a6132466$export$32caf7e8170352aa; });



var $86d48e80f73def8a$exports = {};

$parcel$export($86d48e80f73def8a$exports, "VPagination", function () { return $5711626ff2a195b7$export$6353b480ae89e024; });



var $f7a2cbcc46ca1358$exports = {};

$parcel$export($f7a2cbcc46ca1358$exports, "VParallax", function () { return $ad8f256eddcc5359$export$7f342706af78ee7a; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







function $ad8f256eddcc5359$var$floor(val) {
    return Math.floor(Math.abs(val)) * Math.sign(val);
}
var $ad8f256eddcc5359$export$615da25b371a0c45 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    scale: {
        type: [
            Number,
            String
        ],
        "default": 0.5
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)()), 'VParallax');
var $ad8f256eddcc5359$export$7f342706af78ee7a = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VParallax',
    props: $ad8f256eddcc5359$export$615da25b371a0c45(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useIntersectionObserver = (0, $017d27f86fb94b2b$export$a7395f9832c00176)(), intersectionRef = _useIntersectionObserver.intersectionRef, isIntersecting = _useIntersectionObserver.isIntersecting;
        var _useResizeObserver = (0, $0a5bdd4f835cefd8$export$683480f191c0e3ea)(), resizeRef = _useResizeObserver.resizeRef, contentRect = _useResizeObserver.contentRect;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(), displayHeight = _useDisplay.height;
        var root = (0, $hXmfK.ref)();
        (0, $bu8yf.watchEffect)(function() {
            var _root_value;
            intersectionRef.value = resizeRef.value = (_root_value = root.value) === null || _root_value === void 0 ? void 0 : _root_value.$el;
        });
        var scrollParent;
        (0, $hXmfK.watch)(isIntersecting, function(val) {
            if (val) {
                scrollParent = (0, $84c2348fe514d5ac$export$cfa2225e87938781)(intersectionRef.value);
                scrollParent = scrollParent === document.scrollingElement ? document : scrollParent;
                scrollParent.addEventListener('scroll', onScroll, {
                    passive: true
                });
                onScroll();
            } else scrollParent.removeEventListener('scroll', onScroll);
        });
        (0, $bu8yf.onBeforeUnmount)(function() {
            scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.removeEventListener('scroll', onScroll);
        });
        (0, $hXmfK.watch)(displayHeight, onScroll);
        (0, $hXmfK.watch)(function() {
            var _contentRect_value;
            return (_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height;
        }, onScroll);
        var scale = (0, $hXmfK.computed)(function() {
            return 1 - (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(Number(props.scale));
        });
        var frame = -1;
        function onScroll() {
            if (!isIntersecting.value) return;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(function() {
                var _root_value;
                var el = ((_root_value = root.value) === null || _root_value === void 0 ? void 0 : _root_value.$el).querySelector('.v-img__img');
                if (!el) return;
                var scrollHeight = scrollParent instanceof Document ? document.documentElement.clientHeight : scrollParent.clientHeight;
                var scrollPos = scrollParent instanceof Document ? window.scrollY : scrollParent.scrollTop;
                var top = intersectionRef.value.getBoundingClientRect().top + scrollPos;
                var height = contentRect.value.height;
                var center = top + (height - scrollHeight) / 2;
                var translate = $ad8f256eddcc5359$var$floor((scrollPos - center) * scale.value);
                var sizeScale = Math.max(1, (scale.value * (scrollHeight - height) + height) / height);
                el.style.setProperty('transform', "translateY(".concat(translate, "px) scale(").concat(sizeScale, ")"));
            });
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)((0, $3fbd965354b26cae$export$126ec614c536f27c), {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-parallax',
                    {
                        'v-parallax--active': isIntersecting.value
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style),
                ref: root,
                cover: true,
                onLoadstart: onScroll,
                onLoad: onScroll
            }, slots);
        });
        return {};
    }
});




var $55efc23bda63e278$exports = {};

$parcel$export($55efc23bda63e278$exports, "VProgressCircular", function () { return $14d6ceaaee1fb579$export$2b4afd8de42c0c21; });



var $8537d5d8462e89b3$exports = {};

$parcel$export($8537d5d8462e89b3$exports, "VProgressLinear", function () { return $b435191c768336fc$export$86b13ad59f1a1627; });



var $7d2143e48a2d2067$exports = {};

$parcel$export($7d2143e48a2d2067$exports, "VRadio", function () { return $bb756d912004e6d2$export$3864b5d27f75e85c; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $bb756d912004e6d2$export$428023e8da5ad529 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $1fb46ce89e6b4a77$export$a15300eeb449da9c)({
    falseIcon: '$radioOff',
    trueIcon: '$radioOn'
})), 'VRadio');
var $bb756d912004e6d2$export$3864b5d27f75e85c = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VRadio',
    props: $bb756d912004e6d2$export$428023e8da5ad529(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var controlProps = (0, $1fb46ce89e6b4a77$export$ada18d63da74fb09).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $1fb46ce89e6b4a77$export$ada18d63da74fb09), (0, $bu8yf.mergeProps)(controlProps, {
                "class": [
                    'v-radio',
                    props["class"]
                ],
                style: props.style,
                type: "radio"
            }), slots);
        });
        return {};
    }
});




var $c4ab3333c88f7ee8$exports = {};

$parcel$export($c4ab3333c88f7ee8$exports, "VRadioGroup", function () { return $95f28269e0287fa8$export$ec19d6ef76fe208d; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");









var $95f28269e0287fa8$export$70413854d01ca5a3 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    height: {
        type: [
            Number,
            String
        ],
        "default": 'auto'
    }
}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $12549b94af1799f2$export$f6307c62fd1b0ce3)(), [
    'multiple'
])), {
    trueIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$radioOn'
    },
    falseIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$radioOff'
    },
    type: {
        type: String,
        "default": 'radio'
    }
}), 'VRadioGroup');
var $95f28269e0287fa8$export$ec19d6ef76fe208d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VRadioGroup',
    inheritAttrs: false,
    props: $95f28269e0287fa8$export$70413854d01ca5a3(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.computed)(function() {
            return props.id || "radio-group-".concat(uid);
        });
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var inputRef = (0, $hXmfK.ref)();
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], controlAttrs = _filterInputAttrs[1];
            var inputProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props);
            var controlProps = (0, $1fb46ce89e6b4a77$export$ada18d63da74fb09).filterProps(props);
            var label = slots.label ? slots.label({
                label: props.label,
                props: {
                    "for": id.value
                }
            }) : props.label;
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: inputRef,
                "class": [
                    'v-radio-group',
                    props["class"]
                ],
                style: props.style
            }, rootAttrs, inputProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                id: id.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref2) {
                    var id = _ref2.id, messagesId = _ref2.messagesId, isDisabled = _ref2.isDisabled, isReadonly = _ref2.isReadonly;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        label && (0, $bu8yf.createVNode)((0, $6c6f579f4011d0f0$export$90281af35207eb21), {
                            id: id.value
                        }, {
                            "default": function() {
                                return [
                                    label
                                ];
                            }
                        }),
                        (0, $bu8yf.createVNode)((0, $12549b94af1799f2$export$fbaa479cb0704980), (0, $bu8yf.mergeProps)(controlProps, {
                            id: id.value,
                            "aria-describedby": messagesId.value,
                            defaultsTarget: "VRadio",
                            trueIcon: props.trueIcon,
                            falseIcon: props.falseIcon,
                            type: props.type,
                            disabled: isDisabled.value,
                            readonly: isReadonly.value,
                            "aria-labelledby": label ? id.value : undefined,
                            multiple: false
                        }, controlAttrs, {
                            modelValue: model.value,
                            "onUpdate:modelValue": function($event) {
                                return model.value = $event;
                            }
                        }), slots)
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $53da77218b5094f6$exports = {};

$parcel$export($53da77218b5094f6$exports, "VRangeSlider", function () { return $f18941ccf4b46840$export$3106df8cc5c6e9b3; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");











var $f18941ccf4b46840$export$973ca10e7fdef000 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({}, (0, $6f0e0973cbf83779$export$676d4e684e4b0e1e)(), (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $3437cd49f8163c66$export$f4533040d074ed75)()), {
    strict: Boolean,
    modelValue: {
        type: Array,
        "default": function() {
            return [
                0,
                0
            ];
        }
    }
}), 'VRangeSlider');
var $f18941ccf4b46840$export$3106df8cc5c6e9b3 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VRangeSlider',
    props: $f18941ccf4b46840$export$973ca10e7fdef000(),
    emits: {
        'update:focused': function(value) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        end: function(value) {
            return true;
        },
        start: function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var startThumbRef = (0, $hXmfK.ref)();
        var stopThumbRef = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)();
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        function getActiveThumb(e) {
            if (!startThumbRef.value || !stopThumbRef.value) return;
            var startOffset = (0, $3437cd49f8163c66$export$622cea445a1c5b7d)(e, startThumbRef.value.$el, props.direction);
            var stopOffset = (0, $3437cd49f8163c66$export$622cea445a1c5b7d)(e, stopThumbRef.value.$el, props.direction);
            var a = Math.abs(startOffset);
            var b = Math.abs(stopOffset);
            return a < b || a === b && startOffset < 0 ? startThumbRef.value.$el : stopThumbRef.value.$el;
        }
        var steps = (0, $3437cd49f8163c66$export$302911c449e17ea4)(props);
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue', undefined, function(arr) {
            if (!(arr === null || arr === void 0 ? void 0 : arr.length)) return [
                0,
                0
            ];
            return arr.map(function(value) {
                return steps.roundValue(value);
            });
        });
        var _useSlider = (0, $3437cd49f8163c66$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: function() {
                emit('start', model.value);
            },
            onSliderEnd: function(_ref2) {
                var _startThumbRef_value;
                var value = _ref2.value;
                var newValue = activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el) ? [
                    value,
                    model.value[1]
                ] : [
                    model.value[0],
                    value
                ];
                if (!props.strict && newValue[0] < newValue[1]) model.value = newValue;
                emit('end', model.value);
            },
            onSliderMove: function(_ref3) {
                var _startThumbRef_value;
                var value = _ref3.value;
                var _model_value = (0, $32TW8._)(model.value, 2), start = _model_value[0], stop = _model_value[1];
                if (!props.strict && start === stop && start !== min.value) {
                    var _stopThumbRef_value, _startThumbRef_value1, _activeThumbRef_value;
                    activeThumbRef.value = value > start ? (_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el : (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el;
                    (_activeThumbRef_value = activeThumbRef.value) === null || _activeThumbRef_value === void 0 ? void 0 : _activeThumbRef_value.focus();
                }
                if (activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el)) model.value = [
                    Math.min(value, stop),
                    stop
                ];
                else model.value = [
                    start,
                    Math.max(start, value)
                ];
            },
            getActiveThumb: getActiveThumb
        }), activeThumbRef = _useSlider.activeThumbRef, hasLabels = _useSlider.hasLabels, max = _useSlider.max, min = _useSlider.min, mousePressed = _useSlider.mousePressed, onSliderMousedown = _useSlider.onSliderMousedown, onSliderTouchstart = _useSlider.onSliderTouchstart, position = _useSlider.position, trackContainerRef = _useSlider.trackContainerRef, readonly = _useSlider.readonly;
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var trackStart = (0, $hXmfK.computed)(function() {
            return position(model.value[0]);
        });
        var trackStop = (0, $hXmfK.computed)(function() {
            return position(model.value[1]);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var inputProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props);
            var hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                "class": [
                    'v-slider',
                    'v-range-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': props.disabled
                    },
                    rtlClasses.value,
                    props["class"]
                ],
                style: props.style,
                ref: inputRef
            }, inputProps, {
                focused: isFocused.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                prepend: hasPrepend ? function(slotProps) {
                    var _slots_label, _slots_prepend;
                    var _slots_label1;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, slotProps)) !== null && _slots_label1 !== void 0 ? _slots_label1 : props.label ? (0, $bu8yf.createVNode)((0, $6c6f579f4011d0f0$export$90281af35207eb21), {
                            "class": "v-slider__label",
                            text: props.label
                        }, null) : undefined,
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined,
                "default": function(_ref4) {
                    var _startThumbRef_value, _stopThumbRef_value;
                    var id = _ref4.id, messagesId = _ref4.messagesId;
                    return (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-slider__container",
                        onMousedown: !readonly.value ? onSliderMousedown : undefined,
                        onTouchstartPassive: !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $bu8yf.createElementVNode)("input", {
                            id: "".concat(id.value, "_start"),
                            name: props.name || id.value,
                            disabled: !!props.disabled,
                            readonly: !!props.readonly,
                            tabindex: "-1",
                            value: model.value[0]
                        }, null),
                        (0, $bu8yf.createElementVNode)("input", {
                            id: "".concat(id.value, "_stop"),
                            name: props.name || id.value,
                            disabled: !!props.disabled,
                            readonly: !!props.readonly,
                            tabindex: "-1",
                            value: model.value[1]
                        }, null),
                        (0, $bu8yf.createVNode)((0, $351f7fdcc1227baa$export$bf1154fbd075ef2), {
                            ref: trackContainerRef,
                            start: trackStart.value,
                            stop: trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $bu8yf.createVNode)((0, $337a930674f2b454$export$64ccdeab5f3618a7), {
                            ref: startThumbRef,
                            "aria-describedby": messagesId.value,
                            focused: isFocused && activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el),
                            modelValue: model.value[0],
                            "onUpdate:modelValue": function(v) {
                                return model.value = [
                                    v,
                                    model.value[1]
                                ];
                            },
                            onFocus: function(e) {
                                var _startThumbRef_value, _stopThumbRef_value;
                                focus();
                                activeThumbRef.value = (_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el;
                                // Make sure second thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at minimum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[1] === min.value && e.relatedTarget !== ((_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el)) {
                                    var _startThumbRef_value1, _stopThumbRef_value1;
                                    (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el.blur();
                                    (_stopThumbRef_value1 = stopThumbRef.value) === null || _stopThumbRef_value1 === void 0 ? void 0 : _stopThumbRef_value1.$el.focus();
                                }
                            },
                            onBlur: function() {
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            min: min.value,
                            max: model.value[1],
                            position: trackStart.value,
                            ripple: props.ripple
                        }, {
                            'thumb-label': slots['thumb-label']
                        }),
                        (0, $bu8yf.createVNode)((0, $337a930674f2b454$export$64ccdeab5f3618a7), {
                            ref: stopThumbRef,
                            "aria-describedby": messagesId.value,
                            focused: isFocused && activeThumbRef.value === ((_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el),
                            modelValue: model.value[1],
                            "onUpdate:modelValue": function(v) {
                                return model.value = [
                                    model.value[0],
                                    v
                                ];
                            },
                            onFocus: function(e) {
                                var _stopThumbRef_value, _startThumbRef_value;
                                focus();
                                activeThumbRef.value = (_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el;
                                // Make sure first thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at maximum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[0] === max.value && e.relatedTarget !== ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el)) {
                                    var _stopThumbRef_value1, _startThumbRef_value1;
                                    (_stopThumbRef_value1 = stopThumbRef.value) === null || _stopThumbRef_value1 === void 0 ? void 0 : _stopThumbRef_value1.$el.blur();
                                    (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el.focus();
                                }
                            },
                            onBlur: function() {
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            min: model.value[0],
                            max: max.value,
                            position: trackStop.value,
                            ripple: props.ripple
                        }, {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({
            focus: function() {
                var _startThumbRef_value;
                return (_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el.focus();
            }
        }, inputRef);
    }
});




var $a79832ef456375cf$exports = {};

$parcel$export($a79832ef456375cf$exports, "VRating", function () { return $8bd4061e64b1e770$export$f735a1378bec432; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");











var $8bd4061e64b1e770$export$6bdd7db3248ebef1 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    name: String,
    itemAriaLabel: {
        type: String,
        "default": '$vuetify.rating.ariaLabel.item'
    },
    activeColor: String,
    color: String,
    clearable: Boolean,
    disabled: Boolean,
    emptyIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$ratingEmpty'
    },
    fullIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$ratingFull'
    },
    halfIncrements: Boolean,
    hover: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        "default": 5
    },
    readonly: Boolean,
    modelValue: {
        type: [
            Number,
            String
        ],
        "default": 0
    },
    itemLabels: Array,
    itemLabelPosition: {
        type: String,
        "default": 'top',
        validator: function(v) {
            return [
                'top',
                'bottom'
            ].includes(v);
        }
    },
    ripple: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VRating');
var $8bd4061e64b1e770$export$f735a1378bec432 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VRating',
    props: $8bd4061e64b1e770$export$6bdd7db3248ebef1(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var rating = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var normalizedValue = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(parseFloat(rating.value), 0, Number(props.length));
        });
        var range = (0, $hXmfK.computed)(function() {
            return (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(Number(props.length), 1);
        });
        var increments = (0, $hXmfK.computed)(function() {
            return range.value.flatMap(function(v) {
                return props.halfIncrements ? [
                    v - 0.5,
                    v
                ] : [
                    v
                ];
            });
        });
        var hoverIndex = (0, $hXmfK.shallowRef)(-1);
        var itemState = (0, $hXmfK.computed)(function() {
            return increments.value.map(function(value) {
                var isHovering = props.hover && hoverIndex.value > -1;
                var isFilled = normalizedValue.value >= value;
                var isHovered = hoverIndex.value >= value;
                var isFullIcon = isHovering ? isHovered : isFilled;
                var icon = isFullIcon ? props.fullIcon : props.emptyIcon;
                var _props_activeColor;
                var activeColor = (_props_activeColor = props.activeColor) !== null && _props_activeColor !== void 0 ? _props_activeColor : props.color;
                var color = isFilled || isHovered ? activeColor : props.color;
                return {
                    isFilled: isFilled,
                    isHovered: isHovered,
                    icon: icon,
                    color: color
                };
            });
        });
        var eventState = (0, $hXmfK.computed)(function() {
            return [
                0
            ].concat((0, $7WNf6._)(increments.value)).map(function(value) {
                var onMouseenter = function onMouseenter() {
                    hoverIndex.value = value;
                };
                var onMouseleave = function onMouseleave() {
                    hoverIndex.value = -1;
                };
                var onClick = function onClick() {
                    if (props.disabled || props.readonly) return;
                    rating.value = normalizedValue.value === value && props.clearable ? 0 : value;
                };
                return {
                    onMouseenter: props.hover ? onMouseenter : undefined,
                    onMouseleave: props.hover ? onMouseleave : undefined,
                    onClick: onClick
                };
            });
        });
        var uid = (0, $bu8yf.useId)();
        var name = (0, $hXmfK.computed)(function() {
            var _props_name;
            return (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : "v-rating-".concat(uid);
        });
        function VRatingItem(_ref2) {
            var _itemState_value_index, _itemState_value_index1;
            var value = _ref2.value, index = _ref2.index, _ref2_showStar = _ref2.showStar, showStar = _ref2_showStar === void 0 ? true : _ref2_showStar;
            var _eventState_value_ = eventState.value[index + 1], onMouseenter = _eventState_value_.onMouseenter, onMouseleave = _eventState_value_.onMouseleave, onClick = _eventState_value_.onClick;
            var id = "".concat(name.value, "-").concat(String(value).replace('.', '-'));
            var btnProps = {
                color: (_itemState_value_index = itemState.value[index]) === null || _itemState_value_index === void 0 ? void 0 : _itemState_value_index.color,
                density: props.density,
                disabled: props.disabled,
                icon: (_itemState_value_index1 = itemState.value[index]) === null || _itemState_value_index1 === void 0 ? void 0 : _itemState_value_index1.icon,
                ripple: props.ripple,
                size: props.size,
                variant: 'plain'
            };
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (0, $bu8yf.createElementVNode)("label", {
                    "for": id,
                    "class": (0, $d8jBh.normalizeClass)({
                        'v-rating__item--half': props.halfIncrements && value % 1 > 0,
                        'v-rating__item--full': props.halfIncrements && value % 1 === 0
                    }),
                    onMouseenter: onMouseenter,
                    onMouseleave: onMouseleave,
                    onClick: onClick
                }, [
                    (0, $bu8yf.createElementVNode)("span", {
                        "class": "v-rating__hidden"
                    }, [
                        t(props.itemAriaLabel, value, props.length)
                    ]),
                    !showStar ? undefined : slots.item ? slots.item((0, $emQHU._)((0, $iT0je._)({}, itemState.value[index]), {
                        props: btnProps,
                        value: value,
                        index: index,
                        rating: normalizedValue.value
                    })) : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                        "aria-label": t(props.itemAriaLabel, value, props.length)
                    }, btnProps), null)
                ]),
                (0, $bu8yf.createElementVNode)("input", {
                    "class": "v-rating__hidden",
                    name: name.value,
                    id: id,
                    type: "radio",
                    value: value,
                    checked: normalizedValue.value === value,
                    tabindex: -1,
                    readonly: props.readonly,
                    disabled: props.disabled
                }, null)
            ]);
        }
        function createLabel(labelProps) {
            if (slots['item-label']) return slots['item-label'](labelProps);
            if (labelProps.label) return (0, $bu8yf.createElementVNode)("span", null, [
                labelProps.label
            ]);
            return (0, $bu8yf.createElementVNode)("span", null, [
                (0, $bu8yf.createTextVNode)("\xA0")
            ]);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _props_itemLabels;
            var hasLabels = !!((_props_itemLabels = props.itemLabels) === null || _props_itemLabels === void 0 ? void 0 : _props_itemLabels.length) || slots['item-label'];
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-rating',
                    {
                        'v-rating--hover': props.hover,
                        'v-rating--readonly': props.readonly
                    },
                    themeClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    return [
                        (0, $bu8yf.createVNode)(VRatingItem, {
                            value: 0,
                            index: -1,
                            showStar: false
                        }, null),
                        range.value.map(function(value, i) {
                            var _props_itemLabels, _props_itemLabels1;
                            return (0, $bu8yf.createElementVNode)("div", {
                                "class": "v-rating__wrapper"
                            }, [
                                hasLabels && props.itemLabelPosition === 'top' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: (_props_itemLabels = props.itemLabels) === null || _props_itemLabels === void 0 ? void 0 : _props_itemLabels[i]
                                }) : undefined,
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": "v-rating__item"
                                }, [
                                    props.halfIncrements ? (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                        (0, $bu8yf.createVNode)(VRatingItem, {
                                            value: value - 0.5,
                                            index: i * 2
                                        }, null),
                                        (0, $bu8yf.createVNode)(VRatingItem, {
                                            value: value,
                                            index: i * 2 + 1
                                        }, null)
                                    ]) : (0, $bu8yf.createVNode)(VRatingItem, {
                                        value: value,
                                        index: i
                                    }, null)
                                ]),
                                hasLabels && props.itemLabelPosition === 'bottom' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: (_props_itemLabels1 = props.itemLabels) === null || _props_itemLabels1 === void 0 ? void 0 : _props_itemLabels1[i]
                                }) : undefined
                            ]);
                        })
                    ];
                }
            });
        });
        return {};
    }
});




var $aa91406c052632b6$exports = {};

$parcel$export($aa91406c052632b6$exports, "VResponsive", function () { return $67b06dceb60f0bed$export$fede2db8a3499569; });



var $81d3c870af63624e$exports = {};

$parcel$export($81d3c870af63624e$exports, "VSelect", function () { return $416a51876874f600$export$1d8182ee812485f5; });



var $c3f4092ae6f61bf8$exports = {};

$parcel$export($c3f4092ae6f61bf8$exports, "VSelectionControl", function () { return $1fb46ce89e6b4a77$export$ada18d63da74fb09; });



var $5bf7b41bf443cd0c$exports = {};

$parcel$export($5bf7b41bf443cd0c$exports, "VSelectionControlGroup", function () { return $12549b94af1799f2$export$fbaa479cb0704980; });



var $6b5815f6a7e73c77$exports = {};

$parcel$export($6b5815f6a7e73c77$exports, "VSheet", function () { return $f9317188edfebf2e$export$d41b26ce18186ef0; });



var $cd0be4296b275334$exports = {};

$parcel$export($cd0be4296b275334$exports, "VSkeletonLoader", function () { return $67303d3d3636b257$export$d99330cd6b57c650; });

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");







var $67303d3d3636b257$export$6d4dc21e305d5383 = {
    actions: 'button@2',
    article: 'heading, paragraph',
    avatar: 'avatar',
    button: 'button',
    card: 'image, heading',
    'card-avatar': 'image, list-item-avatar',
    chip: 'chip',
    'date-picker': 'list-item, heading, divider, date-picker-options, date-picker-days, actions',
    'date-picker-options': 'text, avatar@2',
    'date-picker-days': 'avatar@28',
    divider: 'divider',
    heading: 'heading',
    image: 'image',
    'list-item': 'text',
    'list-item-avatar': 'avatar, text',
    'list-item-two-line': 'sentences',
    'list-item-avatar-two-line': 'avatar, sentences',
    'list-item-three-line': 'paragraph',
    'list-item-avatar-three-line': 'avatar, paragraph',
    ossein: 'ossein',
    paragraph: 'text@3',
    sentences: 'text@2',
    subtitle: 'text',
    table: 'table-heading, table-thead, table-tbody, table-tfoot',
    'table-heading': 'chip, text',
    'table-thead': 'heading@6',
    'table-tbody': 'table-row-divider@6',
    'table-row-divider': 'table-row, divider',
    'table-row': 'text@6',
    'table-tfoot': 'text@2, avatar@2',
    text: 'text'
};
function $67303d3d3636b257$var$genBone(type) {
    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return (0, $bu8yf.createElementVNode)("div", {
        "class": (0, $d8jBh.normalizeClass)([
            'v-skeleton-loader__bone',
            "v-skeleton-loader__".concat(type)
        ])
    }, [
        children
    ]);
}
function $67303d3d3636b257$var$genBones(bone) {
    // e.g. 'text@3'
    var _bone_split = (0, $32TW8._)(bone.split('@'), 2), type = _bone_split[0], length = _bone_split[1];
    // Generate a length array based upon
    // value after @ in the bone string
    return Array.from({
        length: length
    }).map(function() {
        return $67303d3d3636b257$var$genStructure(type);
    });
}
function $67303d3d3636b257$var$genStructure(type) {
    var children = [];
    if (!type) return children;
    // TODO: figure out a better way to type this
    var bone = $67303d3d3636b257$export$6d4dc21e305d5383[type];
    // End of recursion, do nothing
    /* eslint-disable-next-line no-empty, brace-style */ if (type === bone) ;
    else if (type.includes(',')) return $67303d3d3636b257$var$mapBones(type);
    else if (type.includes('@')) return $67303d3d3636b257$var$genBones(type);
    else if (bone.includes(',')) children = $67303d3d3636b257$var$mapBones(bone);
    else if (bone.includes('@')) children = $67303d3d3636b257$var$genBones(bone);
    else if (bone) children.push($67303d3d3636b257$var$genStructure(bone));
    return [
        $67303d3d3636b257$var$genBone(type, children)
    ];
}
function $67303d3d3636b257$var$mapBones(bones) {
    // Remove spaces and return array of structures
    return bones.replace(/\s/g, '').split(',').map($67303d3d3636b257$var$genStructure);
}
var $67303d3d3636b257$export$f40f79ca0a20b129 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    boilerplate: Boolean,
    color: String,
    loading: Boolean,
    loadingText: {
        type: String,
        "default": '$vuetify.loading'
    },
    type: {
        type: [
            String,
            Array
        ],
        "default": 'ossein'
    }
}, (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VSkeletonLoader');
var $67303d3d3636b257$export$d99330cd6b57c650 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSkeletonLoader',
    props: $67303d3d3636b257$export$f40f79ca0a20b129(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var items = (0, $hXmfK.computed)(function() {
            return $67303d3d3636b257$var$genStructure((0, $31779689cfd5da50$export$76411cac38121ecb)(props.type).join(','));
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            var isLoading = !slots["default"] || props.loading;
            var loadingProps = props.boilerplate || !isLoading ? {} : {
                ariaLive: 'polite',
                ariaLabel: t(props.loadingText),
                role: 'alert'
            };
            return (0, $bu8yf.createElementVNode)("div", (0, $bu8yf.mergeProps)({
                "class": [
                    'v-skeleton-loader',
                    {
                        'v-skeleton-loader--boilerplate': props.boilerplate
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value
                ],
                style: [
                    backgroundColorStyles.value,
                    isLoading ? dimensionStyles.value : {}
                ]
            }, loadingProps), [
                isLoading ? items.value : (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $9335df2622b8d1c6$exports = {};

$parcel$export($9335df2622b8d1c6$exports, "VSlideGroup", function () { return $a8d82cf1ac6b41e1$export$f3e025e558a486a4; });
$parcel$export($9335df2622b8d1c6$exports, "VSlideGroupItem", function () { return $532167d23f29bcc8$export$69c32988b229b652; });

// Composables



var $532167d23f29bcc8$export$69c32988b229b652 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSlideGroupItem',
    props: (0, $073309bf395585eb$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var slideGroupItem = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $a8d82cf1ac6b41e1$export$f8d4255bddd9d04c));
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isSelected: slideGroupItem.isSelected.value,
                select: slideGroupItem.select,
                toggle: slideGroupItem.toggle,
                selectedClass: slideGroupItem.selectedClass.value
            });
        };
    }
});




var $6c2d64bbf702b912$exports = {};

$parcel$export($6c2d64bbf702b912$exports, "VSlider", function () { return $4520edbc8ae6fc58$export$e0368715924ca04f; });



var $a0372d73f892851a$exports = {};

$parcel$export($a0372d73f892851a$exports, "VSnackbar", function () { return $a83d174aee5cae39$export$39df4d33ea6db485; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

















function $a83d174aee5cae39$var$useCountdown(milliseconds) {
    var time = (0, $hXmfK.shallowRef)(milliseconds());
    var timer = -1;
    function clear() {
        clearInterval(timer);
    }
    function reset() {
        clear();
        (0, $bu8yf.nextTick)(function() {
            return time.value = milliseconds();
        });
    }
    function start(el) {
        var style = el ? getComputedStyle(el) : {
            transitionDuration: 0.2
        };
        var interval = parseFloat(style.transitionDuration) * 1000 || 200;
        clear();
        if (time.value <= 0) return;
        var startTime = performance.now();
        timer = window.setInterval(function() {
            var elapsed = performance.now() - startTime + interval;
            time.value = Math.max(milliseconds() - elapsed, 0);
            if (time.value <= 0) clear();
        }, interval);
    }
    (0, $hXmfK.onScopeDispose)(clear);
    return {
        clear: clear,
        time: time,
        start: start,
        reset: reset
    };
}
var $a83d174aee5cae39$export$43333b6e787817d8 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    multiLine: Boolean,
    text: String,
    timer: [
        Boolean,
        String
    ],
    timeout: {
        type: [
            Number,
            String
        ],
        "default": 5000
    },
    vertical: Boolean
}, (0, $1f28bc3af840aa00$export$2831add577f947cb)({
    location: 'bottom'
}), (0, $e95b1c16d66c4c43$export$f84374c9369ae887)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $7f198793a6132466$export$357b25d59a7fb3fa)({
    transition: 'v-snackbar-transition'
}), [
    'persistent',
    'noClickAnimation',
    'scrim',
    'scrollStrategy'
])), 'VSnackbar');
var $a83d174aee5cae39$export$39df4d33ea6db485 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSnackbar',
    props: $a83d174aee5cae39$export$43333b6e787817d8(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var positionClasses = (0, $e95b1c16d66c4c43$export$8169801eda3f797f)(props).positionClasses;
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useVariant = (0, $b8cfc08eef1ed28f$export$36ef81613f8f20fc)(props), colorClasses = _useVariant.colorClasses, colorStyles = _useVariant.colorStyles, variantClasses = _useVariant.variantClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var countdown = $a83d174aee5cae39$var$useCountdown(function() {
            return Number(props.timeout);
        });
        var overlay = (0, $hXmfK.ref)();
        var timerRef = (0, $hXmfK.ref)();
        var isHovering = (0, $hXmfK.shallowRef)(false);
        var startY = (0, $hXmfK.shallowRef)(0);
        var mainStyles = (0, $hXmfK.ref)();
        var hasLayout = (0, $bu8yf.inject)((0, $39e98ff3447d557e$export$6c0af7fe4dd9b19b), undefined);
        (0, $f1963cd898950c2d$export$fa3cd679bf7c4ed)(function() {
            return !!hasLayout;
        }, function() {
            var layout = (0, $39e98ff3447d557e$export$f47430f7ffdcc134)();
            (0, $bu8yf.watchEffect)(function() {
                mainStyles.value = layout.mainStyles.value;
            });
        });
        (0, $hXmfK.watch)(isActive, startTimeout);
        (0, $hXmfK.watch)(function() {
            return props.timeout;
        }, startTimeout);
        (0, $bu8yf.onMounted)(function() {
            if (isActive.value) startTimeout();
        });
        var activeTimeout = -1;
        function startTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
            var timeout = Number(props.timeout);
            if (!isActive.value || timeout === -1) return;
            var element = (0, $31779689cfd5da50$export$2bffc57ac06742e2)(timerRef.value);
            countdown.start(element);
            activeTimeout = window.setTimeout(function() {
                isActive.value = false;
            }, timeout);
        }
        function clearTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
        }
        function onPointerenter() {
            isHovering.value = true;
            clearTimeout();
        }
        function onPointerleave() {
            isHovering.value = false;
            startTimeout();
        }
        function onTouchstart(event) {
            startY.value = event.touches[0].clientY;
        }
        function onTouchend(event) {
            if (Math.abs(startY.value - event.changedTouches[0].clientY) > 50) isActive.value = false;
        }
        function onAfterLeave() {
            if (isHovering.value) onPointerleave();
        }
        var locationClasses = (0, $hXmfK.computed)(function() {
            return props.location.split(' ').reduce(function(acc, loc) {
                acc["v-snackbar--".concat(loc)] = true;
                return acc;
            }, {});
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var overlayProps = (0, $7f198793a6132466$export$32caf7e8170352aa).filterProps(props);
            var hasContent = !!(slots["default"] || slots.text || props.text);
            return (0, $bu8yf.createVNode)((0, $7f198793a6132466$export$32caf7e8170352aa), (0, $bu8yf.mergeProps)({
                ref: overlay,
                "class": [
                    'v-snackbar',
                    {
                        'v-snackbar--active': isActive.value,
                        'v-snackbar--multi-line': props.multiLine && !props.vertical,
                        'v-snackbar--timer': !!props.timer,
                        'v-snackbar--vertical': props.vertical
                    },
                    locationClasses.value,
                    positionClasses.value,
                    props["class"]
                ],
                style: [
                    mainStyles.value,
                    props.style
                ]
            }, overlayProps, {
                modelValue: isActive.value,
                "onUpdate:modelValue": function($event) {
                    return isActive.value = $event;
                },
                contentProps: (0, $bu8yf.mergeProps)({
                    "class": [
                        'v-snackbar__wrapper',
                        themeClasses.value,
                        colorClasses.value,
                        roundedClasses.value,
                        variantClasses.value
                    ],
                    style: [
                        colorStyles.value
                    ],
                    onPointerenter: onPointerenter,
                    onPointerleave: onPointerleave
                }, overlayProps.contentProps),
                persistent: true,
                noClickAnimation: true,
                scrim: false,
                scrollStrategy: "none",
                _disableGlobalStack: true,
                onTouchstartPassive: onTouchstart,
                onTouchend: onTouchend,
                onAfterLeave: onAfterLeave
            }, scopeId), {
                "default": function() {
                    var _slots_text, _slots_default;
                    var _slots_text1;
                    return [
                        (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(false, 'v-snackbar'),
                        props.timer && !isHovering.value && (0, $bu8yf.createElementVNode)("div", {
                            key: "timer",
                            "class": "v-snackbar__timer"
                        }, [
                            (0, $bu8yf.createVNode)((0, $b435191c768336fc$export$86b13ad59f1a1627), {
                                ref: timerRef,
                                color: typeof props.timer === 'string' ? props.timer : 'info',
                                max: props.timeout,
                                modelValue: countdown.time.value
                            }, null)
                        ]),
                        hasContent && (0, $bu8yf.createElementVNode)("div", {
                            key: "content",
                            "class": "v-snackbar__content",
                            role: "status",
                            "aria-live": "polite"
                        }, [
                            (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text,
                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: {
                                VBtn: {
                                    variant: 'text',
                                    ripple: false,
                                    slim: true
                                }
                            }
                        }, {
                            "default": function() {
                                return [
                                    (0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-snackbar__actions"
                                    }, [
                                        slots.actions({
                                            isActive: isActive
                                        })
                                    ])
                                ];
                            }
                        })
                    ];
                },
                activator: slots.activator
            });
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $de6346e06ec65e85$exports = {};

$parcel$export($de6346e06ec65e85$exports, "VSnackbarQueue", function () { return $918f63f5afea8153$export$17675221b95f643d; });

var $iT0je = parcelRequire("iT0je");

var $g79Gh = parcelRequire("g79Gh");

var $1UYmo = parcelRequire("1UYmo");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");





var $918f63f5afea8153$export$4ff8615b6e07e6c0 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    // TODO: Port this to Snackbar on dev
    closable: [
        Boolean,
        String
    ],
    closeText: {
        type: String,
        "default": '$vuetify.dismiss'
    },
    modelValue: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $a83d174aee5cae39$export$43333b6e787817d8)(), [
    'modelValue'
])), 'VSnackbarQueue');
var $918f63f5afea8153$export$17675221b95f643d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSnackbarQueue',
    props: $918f63f5afea8153$export$4ff8615b6e07e6c0(),
    emits: {
        'update:modelValue': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var isActive = (0, $hXmfK.shallowRef)(false);
        var isVisible = (0, $hXmfK.shallowRef)(false);
        var current = (0, $hXmfK.shallowRef)();
        (0, $hXmfK.watch)(function() {
            return props.modelValue.length;
        }, function(val, oldVal) {
            if (!isVisible.value && val > oldVal) showNext();
        });
        (0, $hXmfK.watch)(isActive, function(val) {
            if (val) isVisible.value = true;
        });
        function onAfterLeave() {
            if (props.modelValue.length) showNext();
            else {
                current.value = undefined;
                isVisible.value = false;
            }
        }
        function showNext() {
            var _props_modelValue = (0, $1UYmo._)(props.modelValue), next = _props_modelValue[0], rest = _props_modelValue.slice(1);
            emit('update:modelValue', rest);
            current.value = typeof next === 'string' ? {
                text: next
            } : next;
            (0, $bu8yf.nextTick)(function() {
                isActive.value = true;
            });
        }
        function onClickClose() {
            isActive.value = false;
        }
        var btnProps = (0, $hXmfK.computed)(function() {
            return {
                color: typeof props.closable === 'string' ? props.closable : undefined,
                text: t(props.closeText)
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasActions = !!(props.closable || slots.actions);
            var _VSnackbar_filterProps = (0, $a83d174aee5cae39$export$39df4d33ea6db485).filterProps(props), _ = _VSnackbar_filterProps.modelValue, snackbarProps = (0, $g79Gh._)(_VSnackbar_filterProps, [
                "modelValue"
            ]);
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                isVisible.value && !!current.value && (slots["default"] ? (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    defaults: {
                        VSnackbar: current.value
                    }
                }, {
                    "default": function() {
                        return [
                            slots["default"]({
                                item: current.value
                            })
                        ];
                    }
                }) : (0, $bu8yf.createVNode)((0, $a83d174aee5cae39$export$39df4d33ea6db485), (0, $bu8yf.mergeProps)(snackbarProps, current.value, {
                    modelValue: isActive.value,
                    "onUpdate:modelValue": function($event) {
                        return isActive.value = $event;
                    },
                    onAfterLeave: onAfterLeave
                }), {
                    text: slots.text ? function() {
                        var _slots_text;
                        return (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots, {
                            item: current.value
                        });
                    } : undefined,
                    actions: hasActions ? function() {
                        return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            !slots.actions ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)(btnProps.value, {
                                onClick: onClickClose
                            }), null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                defaults: {
                                    VBtn: btnProps.value
                                }
                            }, {
                                "default": function() {
                                    return [
                                        slots.actions({
                                            item: current.value,
                                            props: {
                                                onClick: onClickClose
                                            }
                                        })
                                    ];
                                }
                            })
                        ]);
                    } : undefined
                }))
            ]);
        });
    }
});




var $2efe7c044a99683b$exports = {};

$parcel$export($2efe7c044a99683b$exports, "VSparkline", function () { return $44218db0e8d003ea$export$e0136f5b9f4808f4; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Utilities

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
// Utilities

var $f373fe3709f6d637$export$5c73e4f965147599 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    autoDraw: Boolean,
    autoDrawDuration: [
        Number,
        String
    ],
    autoDrawEasing: {
        type: String,
        "default": 'ease'
    },
    color: String,
    gradient: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    gradientDirection: {
        type: String,
        validator: function(val) {
            return [
                'top',
                'bottom',
                'left',
                'right'
            ].includes(val);
        },
        "default": 'top'
    },
    height: {
        type: [
            String,
            Number
        ],
        "default": 75
    },
    labels: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    labelSize: {
        type: [
            Number,
            String
        ],
        "default": 7
    },
    lineWidth: {
        type: [
            String,
            Number
        ],
        "default": 4
    },
    id: String,
    itemValue: {
        type: String,
        "default": 'value'
    },
    modelValue: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    min: [
        String,
        Number
    ],
    max: [
        String,
        Number
    ],
    padding: {
        type: [
            String,
            Number
        ],
        "default": 8
    },
    showLabels: Boolean,
    smooth: [
        Boolean,
        String,
        Number
    ],
    width: {
        type: [
            Number,
            String
        ],
        "default": 300
    }
}, 'Line');



var $c9800e87e05b8bd4$export$222ad48f0a9cf741 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autoLineWidth: Boolean
}, (0, $f373fe3709f6d637$export$5c73e4f965147599)()), 'VBarline');
var $c9800e87e05b8bd4$export$6c8d6ade92fb3940 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VBarline',
    props: $c9800e87e05b8bd4$export$222ad48f0a9cf741(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.computed)(function() {
            return props.id || "barline-".concat(uid);
        });
        var autoDrawDuration = (0, $hXmfK.computed)(function() {
            return Number(props.autoDrawDuration) || 500;
        });
        var hasLabels = (0, $hXmfK.computed)(function() {
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        var lineWidth = (0, $hXmfK.computed)(function() {
            return parseFloat(props.lineWidth) || 4;
        });
        var totalWidth = (0, $hXmfK.computed)(function() {
            return Math.max(props.modelValue.length * lineWidth.value, Number(props.width));
        });
        var boundary = (0, $hXmfK.computed)(function() {
            return {
                minX: 0,
                maxX: totalWidth.value,
                minY: 0,
                maxY: parseInt(props.height, 10)
            };
        });
        var items = (0, $hXmfK.computed)(function() {
            return props.modelValue.map(function(item) {
                return (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue, item);
            });
        });
        function genBars(values, boundary) {
            var _Math, _Math1;
            var minX = boundary.minX, maxX = boundary.maxX, minY = boundary.minY, maxY = boundary.maxY;
            var totalValues = values.length;
            var maxValue = props.max != null ? Number(props.max) : (_Math = Math).max.apply(_Math, (0, $7WNf6._)(values));
            var minValue = props.min != null ? Number(props.min) : (_Math1 = Math).min.apply(_Math1, (0, $7WNf6._)(values));
            if (minValue > 0 && props.min == null) minValue = 0;
            if (maxValue < 0 && props.max == null) maxValue = 0;
            var gridX = maxX / totalValues;
            var gridY = (maxY - minY) / (maxValue - minValue || 1);
            var horizonY = maxY - Math.abs(minValue * gridY);
            return values.map(function(value, index) {
                var height = Math.abs(gridY * value);
                return {
                    x: minX + index * gridX,
                    y: horizonY - height + Number(value < 0) * height,
                    height: height,
                    value: value
                };
            });
        }
        var parsedLabels = (0, $hXmfK.computed)(function() {
            var labels = [];
            var points = genBars(items.value, boundary.value);
            var len = points.length;
            for(var i = 0; labels.length < len; i++){
                var item = points[i];
                var value = props.labels[i];
                if (!value) value = (typeof item === "undefined" ? "undefined" : (0, $3KZcf._)(item)) === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        var bars = (0, $hXmfK.computed)(function() {
            return genBars(items.value, boundary.value);
        });
        var offsetX = (0, $hXmfK.computed)(function() {
            return (Math.abs(bars.value[0].x - bars.value[1].x) - lineWidth.value) / 2;
        });
        var smooth = (0, $hXmfK.computed)(function() {
            return typeof props.smooth === 'boolean' ? props.smooth ? 2 : 0 : Number(props.smooth);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            return (0, $bu8yf.createElementVNode)("svg", {
                display: "block"
            }, [
                (0, $bu8yf.createElementVNode)("defs", null, [
                    (0, $bu8yf.createElementVNode)("linearGradient", {
                        id: id.value,
                        gradientUnits: "userSpaceOnUse",
                        x1: props.gradientDirection === 'left' ? '100%' : '0',
                        y1: props.gradientDirection === 'top' ? '100%' : '0',
                        x2: props.gradientDirection === 'right' ? '100%' : '0',
                        y2: props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map(function(color, index) {
                            return (0, $bu8yf.createElementVNode)("stop", {
                                offset: index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null);
                        })
                    ])
                ]),
                (0, $bu8yf.createElementVNode)("clipPath", {
                    id: "".concat(id.value, "-clip")
                }, [
                    bars.value.map(function(item) {
                        return (0, $bu8yf.createElementVNode)("rect", {
                            x: item.x + offsetX.value,
                            y: item.y,
                            width: lineWidth.value,
                            height: item.height,
                            rx: smooth.value,
                            ry: smooth.value
                        }, [
                            props.autoDraw && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                (0, $bu8yf.createElementVNode)("animate", {
                                    attributeName: "y",
                                    from: item.y + item.height,
                                    to: item.y,
                                    dur: "".concat(autoDrawDuration.value, "ms"),
                                    fill: "freeze"
                                }, null),
                                (0, $bu8yf.createElementVNode)("animate", {
                                    attributeName: "height",
                                    from: "0",
                                    to: item.height,
                                    dur: "".concat(autoDrawDuration.value, "ms"),
                                    fill: "freeze"
                                }, null)
                            ])
                        ]);
                    })
                ]),
                hasLabels.value && (0, $bu8yf.createElementVNode)("g", {
                    key: "labels",
                    style: {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map(function(item, i) {
                        var _slots_label;
                        var _slots_label1;
                        return (0, $bu8yf.createElementVNode)("text", {
                            x: item.x + offsetX.value + lineWidth.value / 2,
                            y: parseInt(props.height, 10) - 2 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, {
                                index: i,
                                value: item.value
                            })) !== null && _slots_label1 !== void 0 ? _slots_label1 : item.value
                        ]);
                    })
                ]),
                (0, $bu8yf.createElementVNode)("g", {
                    "clip-path": "url(#".concat(id.value, "-clip)"),
                    fill: "url(#".concat(id.value, ")")
                }, [
                    (0, $bu8yf.createElementVNode)("rect", {
                        x: 0,
                        y: 0,
                        width: Math.max(props.modelValue.length * lineWidth.value, Number(props.width)),
                        height: props.height
                    }, null)
                ])
            ]);
        });
    }
});


// Utilities

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");

var $3KZcf = parcelRequire("3KZcf");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

// @ts-nocheck
/* eslint-disable */ // import { checkCollinear, getDistance, moveTo } from './math'
/**
 * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
 */ function $bb15814975860728$export$70465fece77953a5(points, radius) {
    var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 75;
    if (points.length === 0) return '';
    var start = points.shift();
    var end = points[points.length - 1];
    return (fill ? "M".concat(start.x, " ").concat(height - start.x + 2, " L").concat(start.x, " ").concat(start.y) : "M".concat(start.x, " ").concat(start.y)) + points.map(function(point, index) {
        var next = points[index + 1];
        var prev = points[index - 1] || start;
        var isCollinear = next && $bb15814975860728$export$188f7419cae70733(next, point, prev);
        if (!next || isCollinear) return "L".concat(point.x, " ").concat(point.y);
        var threshold = Math.min($bb15814975860728$export$79376507b09a66f(prev, point), $bb15814975860728$export$79376507b09a66f(next, point));
        var isTooCloseForRadius = threshold / 2 < radius;
        var radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
        var before = $bb15814975860728$export$75f1ccd6dc32e80a(prev, point, radiusForPoint);
        var after = $bb15814975860728$export$75f1ccd6dc32e80a(next, point, radiusForPoint);
        return "L".concat(before.x, " ").concat(before.y, "S").concat(point.x, " ").concat(point.y, " ").concat(after.x, " ").concat(after.y);
    }).join('') + (fill ? "L".concat(end.x, " ").concat(height - start.x + 2, " Z") : '');
}
function $bb15814975860728$var$_int(value) {
    return parseInt(value, 10);
}
function $bb15814975860728$export$188f7419cae70733(p0, p1, p2) {
    return int(p0.x + p2.x) === int(2 * p1.x) && int(p0.y + p2.y) === int(2 * p1.y);
}
function $bb15814975860728$export$79376507b09a66f(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $bb15814975860728$export$75f1ccd6dc32e80a(to, from, radius) {
    var vector = {
        x: to.x - from.x,
        y: to.y - from.y
    };
    var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
    var unitVector = {
        x: vector.x / length,
        y: vector.y / length
    };
    return {
        x: from.x + unitVector.x * radius,
        y: from.y + unitVector.y * radius
    };
}



var $666b21a3e207aa41$export$90c370e213d9a9b4 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    fill: Boolean
}, (0, $f373fe3709f6d637$export$5c73e4f965147599)()), 'VTrendline');
var $666b21a3e207aa41$export$82fedc3e5dab96c5 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTrendline',
    props: $666b21a3e207aa41$export$90c370e213d9a9b4(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.computed)(function() {
            return props.id || "trendline-".concat(uid);
        });
        var autoDrawDuration = (0, $hXmfK.computed)(function() {
            return Number(props.autoDrawDuration) || (props.fill ? 500 : 2000);
        });
        var lastLength = (0, $hXmfK.ref)(0);
        var path = (0, $hXmfK.ref)(null);
        function genPoints(values, boundary) {
            var _Math, _Math1;
            var minX = boundary.minX, maxX = boundary.maxX, minY = boundary.minY, maxY = boundary.maxY;
            var totalValues = values.length;
            var maxValue = props.max != null ? Number(props.max) : (_Math = Math).max.apply(_Math, (0, $7WNf6._)(values));
            var minValue = props.min != null ? Number(props.min) : (_Math1 = Math).min.apply(_Math1, (0, $7WNf6._)(values));
            var gridX = (maxX - minX) / (totalValues - 1);
            var gridY = (maxY - minY) / (maxValue - minValue || 1);
            return values.map(function(value, index) {
                return {
                    x: minX + index * gridX,
                    y: maxY - (value - minValue) * gridY,
                    value: value
                };
            });
        }
        var hasLabels = (0, $hXmfK.computed)(function() {
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        var lineWidth = (0, $hXmfK.computed)(function() {
            return parseFloat(props.lineWidth) || 4;
        });
        var totalWidth = (0, $hXmfK.computed)(function() {
            return Number(props.width);
        });
        var boundary = (0, $hXmfK.computed)(function() {
            var padding = Number(props.padding);
            return {
                minX: padding,
                maxX: totalWidth.value - padding,
                minY: padding,
                maxY: parseInt(props.height, 10) - padding
            };
        });
        var items = (0, $hXmfK.computed)(function() {
            return props.modelValue.map(function(item) {
                return (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue, item);
            });
        });
        var parsedLabels = (0, $hXmfK.computed)(function() {
            var labels = [];
            var points = genPoints(items.value, boundary.value);
            var len = points.length;
            for(var i = 0; labels.length < len; i++){
                var item = points[i];
                var value = props.labels[i];
                if (!value) value = (typeof item === "undefined" ? "undefined" : (0, $3KZcf._)(item)) === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        (0, $hXmfK.watch)(function() {
            return props.modelValue;
        }, function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var pathRef, length;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $bu8yf.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            if (!props.autoDraw || !path.value) return [
                                2
                            ];
                            pathRef = path.value;
                            length = pathRef.getTotalLength();
                            if (!props.fill) {
                                // Initial setup to "hide" the line by using the stroke dash array
                                pathRef.style.strokeDasharray = "".concat(length);
                                pathRef.style.strokeDashoffset = "".concat(length);
                                // Force reflow to ensure the transition starts from this state
                                pathRef.getBoundingClientRect();
                                // Animate the stroke dash offset to "draw" the line
                                pathRef.style.transition = "stroke-dashoffset ".concat(autoDrawDuration.value, "ms ").concat(props.autoDrawEasing);
                                pathRef.style.strokeDashoffset = '0';
                            } else {
                                // Your existing logic for filled paths remains the same
                                pathRef.style.transformOrigin = 'bottom center';
                                pathRef.style.transition = 'none';
                                pathRef.style.transform = "scaleY(0)";
                                pathRef.getBoundingClientRect();
                                pathRef.style.transition = "transform ".concat(autoDrawDuration.value, "ms ").concat(props.autoDrawEasing);
                                pathRef.style.transform = "scaleY(1)";
                            }
                            lastLength.value = length;
                            return [
                                2
                            ];
                    }
                });
            })();
        }, {
            immediate: true
        });
        function genPath(fill) {
            var smoothValue = typeof props.smooth === 'boolean' ? props.smooth ? 8 : 0 : Number(props.smooth);
            return (0, $bb15814975860728$export$70465fece77953a5)(genPoints(items.value, boundary.value), smoothValue, fill, parseInt(props.height, 10));
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _props_gradient;
            var gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            var _parseFloat, _props_color;
            return (0, $bu8yf.createElementVNode)("svg", {
                display: "block",
                "stroke-width": (_parseFloat = parseFloat(props.lineWidth)) !== null && _parseFloat !== void 0 ? _parseFloat : 4
            }, [
                (0, $bu8yf.createElementVNode)("defs", null, [
                    (0, $bu8yf.createElementVNode)("linearGradient", {
                        id: id.value,
                        gradientUnits: "userSpaceOnUse",
                        x1: props.gradientDirection === 'left' ? '100%' : '0',
                        y1: props.gradientDirection === 'top' ? '100%' : '0',
                        x2: props.gradientDirection === 'right' ? '100%' : '0',
                        y2: props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map(function(color, index) {
                            return (0, $bu8yf.createElementVNode)("stop", {
                                offset: index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null);
                        })
                    ])
                ]),
                hasLabels.value && (0, $bu8yf.createElementVNode)("g", {
                    key: "labels",
                    style: {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map(function(item, i) {
                        var _slots_label;
                        var _slots_label1;
                        return (0, $bu8yf.createElementVNode)("text", {
                            x: item.x + lineWidth.value / 2 + lineWidth.value / 2,
                            y: parseInt(props.height, 10) - 4 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, {
                                index: i,
                                value: item.value
                            })) !== null && _slots_label1 !== void 0 ? _slots_label1 : item.value
                        ]);
                    })
                ]),
                (0, $bu8yf.createElementVNode)("path", {
                    ref: path,
                    d: genPath(props.fill),
                    fill: props.fill ? "url(#".concat(id.value, ")") : 'none',
                    stroke: props.fill ? 'none' : "url(#".concat(id.value, ")")
                }, null),
                props.fill && (0, $bu8yf.createElementVNode)("path", {
                    d: genPath(false),
                    fill: "none",
                    stroke: (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (_props_gradient = props.gradient) === null || _props_gradient === void 0 ? void 0 : _props_gradient[0]
                }, null)
            ]);
        });
    }
});




var $44218db0e8d003ea$export$5c280328198e1bda = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    type: {
        type: String,
        "default": 'trend'
    }
}, (0, $c9800e87e05b8bd4$export$222ad48f0a9cf741)(), (0, $666b21a3e207aa41$export$90c370e213d9a9b4)()), 'VSparkline');
var $44218db0e8d003ea$export$e0136f5b9f4808f4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSparkline',
    props: $44218db0e8d003ea$export$5c280328198e1bda(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var hasLabels = (0, $hXmfK.computed)(function() {
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        var totalHeight = (0, $hXmfK.computed)(function() {
            var height = parseInt(props.height, 10);
            if (hasLabels.value) height += parseInt(props.labelSize, 10) * 1.5;
            return height;
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var Tag = props.type === 'trend' ? (0, $666b21a3e207aa41$export$82fedc3e5dab96c5) : (0, $c9800e87e05b8bd4$export$6c8d6ade92fb3940);
            var lineProps = props.type === 'trend' ? (0, $666b21a3e207aa41$export$82fedc3e5dab96c5).filterProps(props) : (0, $c9800e87e05b8bd4$export$6c8d6ade92fb3940).filterProps(props);
            return (0, $bu8yf.createVNode)(Tag, (0, $bu8yf.mergeProps)({
                key: props.type,
                "class": textColorClasses.value,
                style: textColorStyles.value,
                viewBox: "0 0 ".concat(props.width, " ").concat(parseInt(totalHeight.value, 10))
            }, lineProps), slots);
        });
    }
});




var $4ec93c151280d61d$exports = {};

$parcel$export($4ec93c151280d61d$exports, "VSpeedDial", function () { return $4d2ffc8e166aaec9$export$e8356b230e0f21e3; });

var $cqEAj = parcelRequire("cqEAj");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");







var $4d2ffc8e166aaec9$export$7aa2339d00109abe = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $7cf2e5a7271d5533$export$d914c5b32001cb2e)({
    offset: 8,
    minWidth: 0,
    openDelay: 0,
    closeDelay: 100,
    location: 'top center',
    transition: 'scale-transition'
})), 'VSpeedDial');
var $4d2ffc8e166aaec9$export$e8356b230e0f21e3 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSpeedDial',
    props: $4d2ffc8e166aaec9$export$7aa2339d00109abe(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var menuRef = (0, $hXmfK.ref)();
        var location = (0, $hXmfK.computed)(function() {
            var _props_location;
            var _props_location_split;
            var _$_ref = (0, $32TW8._)((_props_location_split = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ')) !== null && _props_location_split !== void 0 ? _props_location_split : [], 2), y = _$_ref[0], tmp = _$_ref[1], x = tmp === void 0 ? 'center' : tmp;
            return "".concat(y, " ").concat(x);
        });
        var locationClasses = (0, $hXmfK.computed)(function() {
            return (0, $cqEAj._)({}, "v-speed-dial__content--".concat(location.value.replace(' ', '-')), true);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var menuProps = (0, $7cf2e5a7271d5533$export$a347888d6b8f252a).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $7cf2e5a7271d5533$export$a347888d6b8f252a), (0, $bu8yf.mergeProps)(menuProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": props["class"],
                style: props.style,
                contentClass: [
                    'v-speed-dial__content',
                    locationClasses.value,
                    props.contentClass
                ],
                location: location.value,
                ref: menuRef,
                transition: "fade-transition"
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(slotProps) {
                    return (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                        defaults: {
                            VBtn: {
                                size: 'small'
                            }
                        }
                    }, {
                        "default": function() {
                            return [
                                (0, $bu8yf.createVNode)((0, $7a70676d07761412$export$dee7d6ab6955c95e), {
                                    appear: true,
                                    group: true,
                                    transition: props.transition
                                }, {
                                    "default": function() {
                                        var _slots_default;
                                        return [
                                            (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps)
                                        ];
                                    }
                                })
                            ];
                        }
                    });
                }
            }));
        });
        return {};
    }
});




var $b659131c729c525e$exports = {};

$parcel$export($b659131c729c525e$exports, "VStepper", function () { return $e4f192a3f252a225$export$d71b89a1c76eeba4; });
$parcel$export($b659131c729c525e$exports, "VStepperActions", function () { return $4a82d20a315b610d$export$8f37e166a106cb48; });
$parcel$export($b659131c729c525e$exports, "VStepperHeader", function () { return $fed99976d29f3b54$export$5080a7d7bfd22d69; });
$parcel$export($b659131c729c525e$exports, "VStepperItem", function () { return $83b54f2d90cc4151$export$e96da59f2149afb6; });
$parcel$export($b659131c729c525e$exports, "VStepperWindow", function () { return $4fd07ca898ec8525$export$238a44a6cb5ecb45; });
$parcel$export($b659131c729c525e$exports, "VStepperWindowItem", function () { return $88d5214daf387c8d$export$cb78a3090dfe8671; });

var $iT0je = parcelRequire("iT0je");

var $g79Gh = parcelRequire("g79Gh");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

// Types
var $e2991e478db56cb0$export$d8ee4ff2bc0a6403 = Symbol["for"]('vuetify:v-stepper');


parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");




var $4a82d20a315b610d$export$3aef26cced4a737 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    color: String,
    disabled: {
        type: [
            Boolean,
            String
        ],
        "default": false
    },
    prevText: {
        type: String,
        "default": '$vuetify.stepper.prev'
    },
    nextText: {
        type: String,
        "default": '$vuetify.stepper.next'
    }
}, 'VStepperActions');
var $4a82d20a315b610d$export$8f37e166a106cb48 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VStepperActions',
    props: $4a82d20a315b610d$export$3aef26cced4a737(),
    emits: {
        'click:prev': function() {
            return true;
        },
        'click:next': function() {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        function onClickPrev() {
            emit('click:prev');
        }
        function onClickNext() {
            emit('click:next');
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var prevSlotProps = {
                onClick: onClickPrev
            };
            var nextSlotProps = {
                onClick: onClickNext
            };
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-stepper-actions"
            }, [
                (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    defaults: {
                        VBtn: {
                            disabled: [
                                'prev',
                                true
                            ].includes(props.disabled),
                            text: t(props.prevText),
                            variant: 'text'
                        }
                    }
                }, {
                    "default": function() {
                        var _slots_prev;
                        var _slots_prev1;
                        return [
                            (_slots_prev1 = (_slots_prev = slots.prev) === null || _slots_prev === void 0 ? void 0 : _slots_prev.call(slots, {
                                props: prevSlotProps
                            })) !== null && _slots_prev1 !== void 0 ? _slots_prev1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), prevSlotProps, null)
                        ];
                    }
                }),
                (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                    defaults: {
                        VBtn: {
                            color: props.color,
                            disabled: [
                                'next',
                                true
                            ].includes(props.disabled),
                            text: t(props.nextText),
                            variant: 'tonal'
                        }
                    }
                }, {
                    "default": function() {
                        var _slots_next;
                        var _slots_next1;
                        return [
                            (_slots_next1 = (_slots_next = slots.next) === null || _slots_next === void 0 ? void 0 : _slots_next.call(slots, {
                                props: nextSlotProps
                            })) !== null && _slots_next1 !== void 0 ? _slots_next1 : (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), nextSlotProps, null)
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});


// Utilities

var $fed99976d29f3b54$export$5080a7d7bfd22d69 = (0, $f99f72eb23daee55$export$b3680ae2c271b9f3)('v-stepper-header');



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");









var $83b54f2d90cc4151$export$6f6f2035c111ae02 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    color: String,
    title: String,
    subtitle: String,
    complete: Boolean,
    completeIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$complete'
    },
    editable: Boolean,
    editIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$edit'
    },
    error: Boolean,
    errorIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$error'
    },
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        "default": true
    },
    rules: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, 'StepperItem');
var $83b54f2d90cc4151$export$716df0446fc4d770 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, $83b54f2d90cc4151$export$6f6f2035c111ae02(), (0, $073309bf395585eb$export$e9e3b570044587e8)()), 'VStepperItem');
var $83b54f2d90cc4151$export$e96da59f2149afb6 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VStepperItem',
    directives: {
        vRipple: (0, $df056000f2fe99f7$export$2e2bcd8739ae039)
    },
    props: $83b54f2d90cc4151$export$716df0446fc4d770(),
    emits: {
        'group:selected': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var group = (0, $073309bf395585eb$export$eebde8160f061c26)(props, (0, $e2991e478db56cb0$export$d8ee4ff2bc0a6403), true);
        var step = (0, $hXmfK.computed)(function() {
            var _group_value_value;
            return (_group_value_value = group === null || group === void 0 ? void 0 : group.value.value) !== null && _group_value_value !== void 0 ? _group_value_value : props.value;
        });
        var isValid = (0, $hXmfK.computed)(function() {
            return props.rules.every(function(handler) {
                return handler() === true;
            });
        });
        var isClickable = (0, $hXmfK.computed)(function() {
            return !props.disabled && props.editable;
        });
        var canEdit = (0, $hXmfK.computed)(function() {
            return !props.disabled && props.editable;
        });
        var hasError = (0, $hXmfK.computed)(function() {
            return props.error || !isValid.value;
        });
        var hasCompleted = (0, $hXmfK.computed)(function() {
            return props.complete || props.rules.length > 0 && isValid.value;
        });
        var icon = (0, $hXmfK.computed)(function() {
            if (hasError.value) return props.errorIcon;
            if (hasCompleted.value) return props.completeIcon;
            if (group.isSelected.value && props.editable) return props.editIcon;
            return props.icon;
        });
        var slotProps = (0, $hXmfK.computed)(function() {
            return {
                canEdit: canEdit.value,
                hasError: hasError.value,
                hasCompleted: hasCompleted.value,
                title: props.title,
                subtitle: props.subtitle,
                step: step.value,
                value: props.value
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var onClick = function onClick() {
                group === null || group === void 0 ? void 0 : group.toggle();
            };
            var _slots_title, _slots_subtitle, _slots_default;
            var hasColor = (!group || group.isSelected.value || hasCompleted.value || canEdit.value) && !hasError.value && !props.disabled;
            var hasTitle = !!(props.title != null || slots.title);
            var hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            var _slots_title1, _slots_subtitle1;
            return (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("button", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-stepper-item',
                    {
                        'v-stepper-item--complete': hasCompleted.value,
                        'v-stepper-item--disabled': props.disabled,
                        'v-stepper-item--error': hasError.value
                    },
                    group === null || group === void 0 ? void 0 : group.selectedClass.value
                ]),
                disabled: !props.editable,
                type: "button",
                onClick: onClick
            }, [
                isClickable.value && (0, $b8cfc08eef1ed28f$export$e27cd265ed232373)(true, 'v-stepper-item'),
                (0, $bu8yf.createVNode)((0, $1991d2d9d165718c$export$dbee61bc703cd5ff), {
                    key: "stepper-avatar",
                    "class": "v-stepper-item__avatar",
                    color: hasColor ? props.color : undefined,
                    size: 24
                }, {
                    "default": function() {
                        var _slots_icon;
                        var _slots_icon1;
                        return [
                            (_slots_icon1 = (_slots_icon = slots.icon) === null || _slots_icon === void 0 ? void 0 : _slots_icon.call(slots, slotProps.value)) !== null && _slots_icon1 !== void 0 ? _slots_icon1 : icon.value ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                icon: icon.value
                            }, null) : step.value
                        ];
                    }
                }),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-stepper-item__content"
                }, [
                    hasTitle && (0, $bu8yf.createElementVNode)("div", {
                        key: "title",
                        "class": "v-stepper-item__title"
                    }, [
                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, slotProps.value)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                    ]),
                    hasSubtitle && (0, $bu8yf.createElementVNode)("div", {
                        key: "subtitle",
                        "class": "v-stepper-item__subtitle"
                    }, [
                        (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, slotProps.value)) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : props.subtitle
                    ]),
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                ])
            ]), [
                [
                    (0, $df056000f2fe99f7$export$2e2bcd8739ae039),
                    props.editable && props.ripple,
                    null
                ]
            ]);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");




var $4fd07ca898ec8525$export$d1585806c2c3e337 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $ca166420585d5fdc$export$25b8cee22976996f)(), [
    'continuous',
    'nextIcon',
    'prevIcon',
    'showArrows',
    'touch',
    'mandatory'
])), 'VStepperWindow');
var $4fd07ca898ec8525$export$238a44a6cb5ecb45 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VStepperWindow',
    props: $4fd07ca898ec8525$export$d1585806c2c3e337(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var group = (0, $bu8yf.inject)((0, $e2991e478db56cb0$export$d8ee4ff2bc0a6403), null);
        var _model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var model = (0, $hXmfK.computed)({
            get: function() {
                var _group_items_value_find;
                // Always return modelValue if defined
                // or if not within a VStepper group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VStepper, find the currently selected
                // item by id. Item value may be assigned by its index
                return (_group_items_value_find = group.items.value.find(function(item) {
                    return group.selected.value.includes(item.id);
                })) === null || _group_items_value_find === void 0 ? void 0 : _group_items_value_find.value;
            },
            set: function(val) {
                _model.value = val;
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var windowProps = (0, $ca166420585d5fdc$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $ca166420585d5fdc$export$7e91eb8d1b90c043), (0, $bu8yf.mergeProps)({
                _as: "VStepperWindow"
            }, windowProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": [
                    'v-stepper-window',
                    props["class"]
                ],
                style: props.style,
                mandatory: false,
                touch: false
            }), slots);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $88d5214daf387c8d$export$aa1ae043363d1030 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $a77d8a325be2a9b0$export$7fb6acff7c00736c)()), 'VStepperWindowItem');
var $88d5214daf387c8d$export$cb78a3090dfe8671 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VStepperWindowItem',
    props: $88d5214daf387c8d$export$aa1ae043363d1030(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var windowItemProps = (0, $a77d8a325be2a9b0$export$5dd5457a16e4a360).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $a77d8a325be2a9b0$export$5dd5457a16e4a360), (0, $bu8yf.mergeProps)({
                _as: "VStepperWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-stepper-window-item',
                    props["class"]
                ],
                style: props.style
            }), slots);
        });
        return {};
    }
});









var $e4f192a3f252a225$export$ba77a79bea1d4366 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    altLabels: Boolean,
    bgColor: String,
    completeIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    editIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    editable: Boolean,
    errorIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    hideActions: Boolean,
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    itemTitle: {
        type: String,
        "default": 'title'
    },
    itemValue: {
        type: String,
        "default": 'value'
    },
    nonLinear: Boolean,
    flat: Boolean
}, (0, $a7414385605a88b0$export$d0badecb383b472a)()), 'Stepper');
var $e4f192a3f252a225$export$e15706ca8fb34f8d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, $e4f192a3f252a225$export$ba77a79bea1d4366(), (0, $073309bf395585eb$export$fa4c05b3520340e6)({
    mandatory: 'force',
    selectedClass: 'v-stepper-item--selected'
}), (0, $f9317188edfebf2e$export$a0ee5621cbdcc362)(), (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $4a82d20a315b610d$export$3aef26cced4a737)(), [
    'prevText',
    'nextText'
])), 'VStepper');
var $e4f192a3f252a225$export$d71b89a1c76eeba4 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VStepper',
    props: $e4f192a3f252a225$export$e15706ca8fb34f8d(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useGroup = (0, $073309bf395585eb$export$bfb6a372146ddc96)(props, (0, $e2991e478db56cb0$export$d8ee4ff2bc0a6403)), _items = _useGroup.items, next = _useGroup.next, prev = _useGroup.prev, selected = _useGroup.selected;
        var _useDisplay = (0, $a7414385605a88b0$export$8406b7efc286d284)(props), displayClasses = _useDisplay.displayClasses, mobile = _useDisplay.mobile;
        var _toRefs = (0, $hXmfK.toRefs)(props), completeIcon = _toRefs.completeIcon, editIcon = _toRefs.editIcon, errorIcon = _toRefs.errorIcon, color = _toRefs.color, editable = _toRefs.editable, prevText = _toRefs.prevText, nextText = _toRefs.nextText;
        var items = (0, $hXmfK.computed)(function() {
            return props.items.map(function(item, index) {
                var title = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemTitle, item);
                var value = (0, $31779689cfd5da50$export$655f0e681f1365dc)(item, props.itemValue, index + 1);
                return {
                    title: title,
                    value: value,
                    raw: item
                };
            });
        });
        var activeIndex = (0, $hXmfK.computed)(function() {
            return _items.value.findIndex(function(item) {
                return selected.value.includes(item.id);
            });
        });
        var disabled = (0, $hXmfK.computed)(function() {
            if (props.disabled) return props.disabled;
            if (activeIndex.value === 0) return 'prev';
            if (activeIndex.value === _items.value.length - 1) return 'next';
            return false;
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VStepperItem: {
                editable: editable,
                errorIcon: errorIcon,
                completeIcon: completeIcon,
                editIcon: editIcon,
                prevText: prevText,
                nextText: nextText
            },
            VStepperActions: {
                color: color,
                disabled: disabled,
                prevText: prevText,
                nextText: nextText
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var sheetProps = (0, $f9317188edfebf2e$export$d41b26ce18186ef0).filterProps(props);
            var hasHeader = !!(slots.header || props.items.length);
            var hasWindow = props.items.length > 0;
            var hasActions = !props.hideActions && !!(hasWindow || slots.actions);
            return (0, $bu8yf.createVNode)((0, $f9317188edfebf2e$export$d41b26ce18186ef0), (0, $bu8yf.mergeProps)(sheetProps, {
                color: props.bgColor,
                "class": [
                    'v-stepper',
                    {
                        'v-stepper--alt-labels': props.altLabels,
                        'v-stepper--flat': props.flat,
                        'v-stepper--non-linear': props.nonLinear,
                        'v-stepper--mobile': mobile.value
                    },
                    displayClasses.value,
                    props["class"]
                ],
                style: props.style
            }), {
                "default": function() {
                    var _slots_default, _slots_actions;
                    var _slots_actions1;
                    return [
                        hasHeader && (0, $bu8yf.createVNode)((0, $fed99976d29f3b54$export$5080a7d7bfd22d69), {
                            key: "stepper-header"
                        }, {
                            "default": function() {
                                return [
                                    items.value.map(function(_ref2, index) {
                                        var raw = _ref2.raw, item = (0, $g79Gh._)(_ref2, [
                                            "raw"
                                        ]);
                                        var _slots_;
                                        return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                            !!index && (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), null, null),
                                            (0, $bu8yf.createVNode)((0, $83b54f2d90cc4151$export$e96da59f2149afb6), item, {
                                                "default": (_slots_ = slots["header-item.".concat(item.value)]) !== null && _slots_ !== void 0 ? _slots_ : slots.header,
                                                icon: slots.icon,
                                                title: slots.title,
                                                subtitle: slots.subtitle
                                            })
                                        ]);
                                    })
                                ];
                            }
                        }),
                        hasWindow && (0, $bu8yf.createVNode)((0, $4fd07ca898ec8525$export$238a44a6cb5ecb45), {
                            key: "stepper-window"
                        }, {
                            "default": function() {
                                return [
                                    items.value.map(function(item) {
                                        return (0, $bu8yf.createVNode)((0, $88d5214daf387c8d$export$cb78a3090dfe8671), {
                                            value: item.value
                                        }, {
                                            "default": function() {
                                                var _slots_, _slots_item;
                                                var _slots_1;
                                                return (_slots_1 = (_slots_ = slots["item.".concat(item.value)]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, item)) !== null && _slots_1 !== void 0 ? _slots_1 : (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, item);
                                            }
                                        });
                                    })
                                ];
                            }
                        }),
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            prev: prev,
                            next: next
                        }),
                        hasActions && ((_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, {
                            next: next,
                            prev: prev
                        })) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $bu8yf.createVNode)((0, $4a82d20a315b610d$export$8f37e166a106cb48), {
                            key: "stepper-actions",
                            "onClick:prev": prev,
                            "onClick:next": next
                        }, slots))
                    ];
                }
            });
        });
        return {
            prev: prev,
            next: next
        };
    }
});









var $170adca7bd0cd074$exports = {};

$parcel$export($170adca7bd0cd074$exports, "VSwitch", function () { return $7c92999616089c35$export$f4b527597b639fa9; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");












var $7c92999616089c35$export$7dc4819afbfc762a = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    indeterminate: Boolean,
    inset: Boolean,
    flat: Boolean,
    loading: {
        type: [
            Boolean,
            String
        ],
        "default": false
    }
}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $1fb46ce89e6b4a77$export$a15300eeb449da9c)()), 'VSwitch');
var $7c92999616089c35$export$f4b527597b639fa9 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSwitch',
    inheritAttrs: false,
    props: $7c92999616089c35$export$7dc4819afbfc762a(),
    emits: {
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(value) {
            return true;
        },
        'update:indeterminate': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var indeterminate = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'indeterminate');
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var loaderClasses = (0, $de59c43ac78c3e7a$export$14095de704efe3f9)(props).loaderClasses;
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var control = (0, $hXmfK.ref)();
        var inputRef = (0, $hXmfK.ref)();
        var isForcedColorsModeActive = (0, $10db88b646d64b14$export$13a6ee1b6d6a0cfd) && window.matchMedia('(forced-colors: active)').matches;
        var loaderColor = (0, $hXmfK.toRef)(function() {
            return typeof props.loading === 'string' && props.loading !== '' ? props.loading : props.color;
        });
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.toRef)(function() {
            return props.id || "switch-".concat(uid);
        });
        function onChange() {
            if (indeterminate.value) indeterminate.value = false;
        }
        function onTrackClick(e) {
            var _control_value_input, _control_value;
            e.stopPropagation();
            e.preventDefault();
            (_control_value = control.value) === null || _control_value === void 0 ? void 0 : (_control_value_input = _control_value.input) === null || _control_value_input === void 0 ? void 0 : _control_value_input.click();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], controlAttrs = _filterInputAttrs[1];
            var inputProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props);
            var controlProps = (0, $1fb46ce89e6b4a77$export$ada18d63da74fb09).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: inputRef,
                "class": [
                    'v-switch',
                    {
                        'v-switch--flat': props.flat
                    },
                    {
                        'v-switch--inset': props.inset
                    },
                    {
                        'v-switch--indeterminate': indeterminate.value
                    },
                    loaderClasses.value,
                    props["class"]
                ]
            }, rootAttrs, inputProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                id: id.value,
                focused: isFocused.value,
                style: props.style
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref2) {
                    var id = _ref2.id, messagesId = _ref2.messagesId, isDisabled = _ref2.isDisabled, isReadonly = _ref2.isReadonly, isValid = _ref2.isValid;
                    var slotProps = {
                        model: model,
                        isValid: isValid
                    };
                    return (0, $bu8yf.createVNode)((0, $1fb46ce89e6b4a77$export$ada18d63da74fb09), (0, $bu8yf.mergeProps)({
                        ref: control
                    }, controlProps, {
                        modelValue: model.value,
                        "onUpdate:modelValue": [
                            function($event) {
                                return model.value = $event;
                            },
                            onChange
                        ],
                        id: id.value,
                        "aria-describedby": messagesId.value,
                        type: "checkbox",
                        "aria-checked": indeterminate.value ? 'mixed' : undefined,
                        disabled: isDisabled.value,
                        readonly: isReadonly.value,
                        onFocus: focus,
                        onBlur: blur
                    }, controlAttrs), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                        "default": function(_ref3) {
                            var backgroundColorClasses = _ref3.backgroundColorClasses, backgroundColorStyles = _ref3.backgroundColorStyles;
                            return (0, $bu8yf.createElementVNode)("div", {
                                "class": (0, $d8jBh.normalizeClass)([
                                    'v-switch__track',
                                    !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                                ]),
                                style: (0, $d8jBh.normalizeStyle)(backgroundColorStyles.value),
                                onClick: onTrackClick
                            }, [
                                slots['track-true'] && (0, $bu8yf.createElementVNode)("div", {
                                    key: "prepend",
                                    "class": "v-switch__track-true"
                                }, [
                                    slots['track-true'](slotProps)
                                ]),
                                slots['track-false'] && (0, $bu8yf.createElementVNode)("div", {
                                    key: "append",
                                    "class": "v-switch__track-false"
                                }, [
                                    slots['track-false'](slotProps)
                                ])
                            ]);
                        },
                        input: function(_ref4) {
                            var inputNode = _ref4.inputNode, icon = _ref4.icon, backgroundColorClasses = _ref4.backgroundColorClasses, backgroundColorStyles = _ref4.backgroundColorStyles;
                            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                inputNode,
                                (0, $bu8yf.createElementVNode)("div", {
                                    "class": (0, $d8jBh.normalizeClass)([
                                        'v-switch__thumb',
                                        {
                                            'v-switch__thumb--filled': icon || props.loading
                                        },
                                        props.inset || isForcedColorsModeActive ? undefined : backgroundColorClasses.value
                                    ]),
                                    style: (0, $d8jBh.normalizeStyle)(props.inset ? undefined : backgroundColorStyles.value)
                                }, [
                                    slots.thumb ? (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                                        defaults: {
                                            VIcon: {
                                                icon: icon,
                                                size: 'x-small'
                                            }
                                        }
                                    }, {
                                        "default": function() {
                                            return [
                                                slots.thumb((0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                                                    icon: icon
                                                }))
                                            ];
                                        }
                                    }) : (0, $bu8yf.createVNode)((0, $01a421c271ad0485$export$5d9397de61546474), null, {
                                        "default": function() {
                                            return [
                                                !props.loading ? icon && (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                                                    key: String(icon),
                                                    icon: icon,
                                                    size: "x-small"
                                                }, null) : (0, $bu8yf.createVNode)((0, $de59c43ac78c3e7a$export$9a5d46a3538da529), {
                                                    name: "v-switch",
                                                    active: true,
                                                    color: isValid.value === false ? undefined : loaderColor.value
                                                }, {
                                                    "default": function(slotProps) {
                                                        return slots.loader ? slots.loader(slotProps) : (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                                                            active: slotProps.isActive,
                                                            color: slotProps.color,
                                                            indeterminate: true,
                                                            size: "16",
                                                            width: "2"
                                                        }, null);
                                                    }
                                                })
                                            ];
                                        }
                                    })
                                ])
                            ]);
                        }
                    }));
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $1b0b677fdef4c52e$exports = {};

$parcel$export($1b0b677fdef4c52e$exports, "VSystemBar", function () { return $cb0b5b2b7b57d7ee$export$a4eb9b0d64886c6d; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");










var $cb0b5b2b7b57d7ee$export$e88cde833a0a933b = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    color: String,
    height: [
        Number,
        String
    ],
    window: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $39e98ff3447d557e$export$d42abac634ace931)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VSystemBar');
var $cb0b5b2b7b57d7ee$export$a4eb9b0d64886c6d = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VSystemBar',
    props: $cb0b5b2b7b57d7ee$export$e88cde833a0a933b(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props).roundedClasses;
        var ssrBootStyles = (0, $1ffa1d7831d0ed24$export$f385cca8ac2b2f35)().ssrBootStyles;
        var height = (0, $hXmfK.computed)(function() {
            var _props_height;
            return (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : props.window ? 32 : 24;
        });
        var layoutItemStyles = (0, $39e98ff3447d557e$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $hXmfK.computed)(function() {
                return parseInt(props.order, 10);
            }),
            position: (0, $hXmfK.shallowRef)('top'),
            layoutSize: height,
            elementSize: height,
            active: (0, $hXmfK.computed)(function() {
                return true;
            }),
            absolute: (0, $hXmfK.toRef)(function() {
                return props.absolute;
            })
        }).layoutItemStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-system-bar',
                    {
                        'v-system-bar--window': props.window
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    ssrBootStyles.value,
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});




var $a961a9be53247ab4$exports = {};

$parcel$export($a961a9be53247ab4$exports, "VTab", function () { return $e39ade78f6a044fc$export$f329ceb9f204f847; });
$parcel$export($a961a9be53247ab4$exports, "VTabs", function () { return $e7ac2545dc8af232$export$4317eb4b5dc6835; });
$parcel$export($a961a9be53247ab4$exports, "VTabsWindow", function () { return $80c6d1c41afa6997$export$9f9d2055cc6c09b8; });
$parcel$export($a961a9be53247ab4$exports, "VTabsWindowItem", function () { return $38d5ebbcbc1c284a$export$94f5ea3c1db246aa; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");




// Types
var $b6fbaf2f0ea02911$export$df452bc869d6b823 = Symbol["for"]('vuetify:v-tabs');



var $e39ade78f6a044fc$export$8b67f631a6cfcf80 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    fixed: Boolean,
    sliderColor: String,
    hideSlider: Boolean,
    direction: {
        type: String,
        "default": 'horizontal'
    }
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $9603829334ed7471$export$64daea74540bd34d)({
    selectedClass: 'v-tab--selected',
    variant: 'text'
}), [
    'active',
    'block',
    'flat',
    'location',
    'position',
    'symbol'
])), 'VTab');
var $e39ade78f6a044fc$export$f329ceb9f204f847 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTab',
    props: $e39ade78f6a044fc$export$8b67f631a6cfcf80(),
    setup: function(props, _ref) {
        var slots = _ref.slots, attrs = _ref.attrs;
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.sliderColor;
        }), sliderColorClasses = _useTextColor.textColorClasses, sliderColorStyles = _useTextColor.textColorStyles;
        var rootEl = (0, $hXmfK.ref)();
        var sliderEl = (0, $hXmfK.ref)();
        var isHorizontal = (0, $hXmfK.computed)(function() {
            return props.direction === 'horizontal';
        });
        var isSelected = (0, $hXmfK.computed)(function() {
            var _rootEl_value_group, _rootEl_value;
            var _rootEl_value_group_isSelected_value;
            return (_rootEl_value_group_isSelected_value = (_rootEl_value = rootEl.value) === null || _rootEl_value === void 0 ? void 0 : (_rootEl_value_group = _rootEl_value.group) === null || _rootEl_value_group === void 0 ? void 0 : _rootEl_value_group.isSelected.value) !== null && _rootEl_value_group_isSelected_value !== void 0 ? _rootEl_value_group_isSelected_value : false;
        });
        function updateSlider(_ref2) {
            var value = _ref2.value;
            if (value) {
                var _rootEl_value_$el_parentElement, _rootEl_value;
                var prevEl = (_rootEl_value = rootEl.value) === null || _rootEl_value === void 0 ? void 0 : (_rootEl_value_$el_parentElement = _rootEl_value.$el.parentElement) === null || _rootEl_value_$el_parentElement === void 0 ? void 0 : _rootEl_value_$el_parentElement.querySelector('.v-tab--selected .v-tab__slider');
                var nextEl = sliderEl.value;
                if (!prevEl || !nextEl) return;
                var color = getComputedStyle(prevEl).color;
                var prevBox = prevEl.getBoundingClientRect();
                var nextBox = nextEl.getBoundingClientRect();
                var xy = isHorizontal.value ? 'x' : 'y';
                var XY = isHorizontal.value ? 'X' : 'Y';
                var rightBottom = isHorizontal.value ? 'right' : 'bottom';
                var widthHeight = isHorizontal.value ? 'width' : 'height';
                var prevPos = prevBox[xy];
                var nextPos = nextBox[xy];
                var delta = prevPos > nextPos ? prevBox[rightBottom] - nextBox[rightBottom] : prevBox[xy] - nextBox[xy];
                var origin = Math.sign(delta) > 0 ? isHorizontal.value ? 'right' : 'bottom' : Math.sign(delta) < 0 ? isHorizontal.value ? 'left' : 'top' : 'center';
                var size = Math.abs(delta) + (Math.sign(delta) < 0 ? prevBox[widthHeight] : nextBox[widthHeight]);
                var scale = size / Math.max(prevBox[widthHeight], nextBox[widthHeight]) || 0;
                var initialScale = prevBox[widthHeight] / nextBox[widthHeight] || 0;
                var sigma = 1.5;
                (0, $4256e79b4dc20ac3$export$e3607ec2d7a891c4)(nextEl, {
                    backgroundColor: [
                        color,
                        'currentcolor'
                    ],
                    transform: [
                        "translate".concat(XY, "(").concat(delta, "px) scale").concat(XY, "(").concat(initialScale, ")"),
                        "translate".concat(XY, "(").concat(delta / sigma, "px) scale").concat(XY, "(").concat((scale - 1) / sigma + 1, ")"),
                        'none'
                    ],
                    transformOrigin: Array(3).fill(origin)
                }, {
                    duration: 225,
                    easing: (0, $7c499b58bf668c0e$export$bf86e2ccec972a06)
                });
            }
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var btnProps = (0, $9603829334ed7471$export$657f28cf887b91a6).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), (0, $bu8yf.mergeProps)({
                symbol: (0, $b6fbaf2f0ea02911$export$df452bc869d6b823),
                ref: rootEl,
                "class": [
                    'v-tab',
                    props["class"]
                ],
                style: props.style,
                tabindex: isSelected.value ? 0 : -1,
                role: "tab",
                "aria-selected": String(isSelected.value),
                active: false
            }, btnProps, attrs, {
                block: props.fixed,
                maxWidth: props.fixed ? 300 : undefined,
                "onGroup:selected": updateSlider
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function() {
                    var _slots_default;
                    var _slots_default1;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.text,
                        !props.hideSlider && (0, $bu8yf.createElementVNode)("div", {
                            ref: sliderEl,
                            "class": (0, $d8jBh.normalizeClass)([
                                'v-tab__slider',
                                sliderColorClasses.value
                            ]),
                            style: (0, $d8jBh.normalizeStyle)(sliderColorStyles.value)
                        }, null)
                    ]);
                }
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, rootEl);
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");




var $80c6d1c41afa6997$export$4090f644ec641abd = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $ca166420585d5fdc$export$25b8cee22976996f)(), [
    'continuous',
    'nextIcon',
    'prevIcon',
    'showArrows',
    'touch',
    'mandatory'
])), 'VTabsWindow');
var $80c6d1c41afa6997$export$9f9d2055cc6c09b8 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTabsWindow',
    props: $80c6d1c41afa6997$export$4090f644ec641abd(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var group = (0, $bu8yf.inject)((0, $b6fbaf2f0ea02911$export$df452bc869d6b823), null);
        var _model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var model = (0, $hXmfK.computed)({
            get: function() {
                var _group_items_value_find;
                // Always return modelValue if defined
                // or if not within a VTabs group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VTabs, find the currently selected
                // item by id. Item value may be assigned by its index
                return (_group_items_value_find = group.items.value.find(function(item) {
                    return group.selected.value.includes(item.id);
                })) === null || _group_items_value_find === void 0 ? void 0 : _group_items_value_find.value;
            },
            set: function(val) {
                _model.value = val;
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var windowProps = (0, $ca166420585d5fdc$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $ca166420585d5fdc$export$7e91eb8d1b90c043), (0, $bu8yf.mergeProps)({
                _as: "VTabsWindow"
            }, windowProps, {
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": [
                    'v-tabs-window',
                    props["class"]
                ],
                style: props.style,
                mandatory: false,
                touch: false
            }), slots);
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");


var $38d5ebbcbc1c284a$export$840fb8132a6799ab = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $a77d8a325be2a9b0$export$7fb6acff7c00736c)()), 'VTabsWindowItem');
var $38d5ebbcbc1c284a$export$94f5ea3c1db246aa = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTabsWindowItem',
    props: $38d5ebbcbc1c284a$export$840fb8132a6799ab(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var windowItemProps = (0, $a77d8a325be2a9b0$export$5dd5457a16e4a360).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $a77d8a325be2a9b0$export$5dd5457a16e4a360), (0, $bu8yf.mergeProps)({
                _as: "VTabsWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-tabs-window-item',
                    props["class"]
                ],
                style: props.style
            }), slots);
        });
        return {};
    }
});











function $e7ac2545dc8af232$var$parseItems(items) {
    if (!items) return [];
    return items.map(function(item) {
        if (!(0, $31779689cfd5da50$export$a6cdc56e425d0d0a)(item)) return {
            text: item,
            value: item
        };
        return item;
    });
}
var $e7ac2545dc8af232$export$419b64ceeafc723d = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    alignTabs: {
        type: String,
        "default": 'start'
    },
    color: String,
    fixedTabs: Boolean,
    items: {
        type: Array,
        "default": function() {
            return [];
        }
    },
    stacked: Boolean,
    bgColor: String,
    grow: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        "default": undefined
    },
    hideSlider: Boolean,
    sliderColor: String
}, (0, $a8d82cf1ac6b41e1$export$8d9f6ad26ccf07ca)({
    mandatory: 'force',
    selectedClass: 'v-tab-item--selected'
}), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VTabs');
var $e7ac2545dc8af232$export$4317eb4b5dc6835 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTabs',
    props: $e7ac2545dc8af232$export$419b64ceeafc723d(),
    emits: {
        'update:modelValue': function(v) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var items = (0, $hXmfK.computed)(function() {
            return $e7ac2545dc8af232$var$parseItems(props.items);
        });
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.bgColor;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VTab: {
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                direction: (0, $hXmfK.toRef)(function() {
                    return props.direction;
                }),
                stacked: (0, $hXmfK.toRef)(function() {
                    return props.stacked;
                }),
                fixed: (0, $hXmfK.toRef)(function() {
                    return props.fixedTabs;
                }),
                sliderColor: (0, $hXmfK.toRef)(function() {
                    return props.sliderColor;
                }),
                hideSlider: (0, $hXmfK.toRef)(function() {
                    return props.hideSlider;
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var slideGroupProps = (0, $a8d82cf1ac6b41e1$export$f3e025e558a486a4).filterProps(props);
            var hasWindow = !!(slots.window || props.items.length > 0);
            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                (0, $bu8yf.createVNode)((0, $a8d82cf1ac6b41e1$export$f3e025e558a486a4), (0, $bu8yf.mergeProps)(slideGroupProps, {
                    modelValue: model.value,
                    "onUpdate:modelValue": function($event) {
                        return model.value = $event;
                    },
                    "class": [
                        'v-tabs',
                        "v-tabs--".concat(props.direction),
                        "v-tabs--align-tabs-".concat(props.alignTabs),
                        {
                            'v-tabs--fixed-tabs': props.fixedTabs,
                            'v-tabs--grow': props.grow,
                            'v-tabs--stacked': props.stacked
                        },
                        densityClasses.value,
                        backgroundColorClasses.value,
                        props["class"]
                    ],
                    style: [
                        {
                            '--v-tabs-height': (0, $31779689cfd5da50$export$286ad215293a0860)(props.height)
                        },
                        backgroundColorStyles.value,
                        props.style
                    ],
                    role: "tablist",
                    symbol: (0, $b6fbaf2f0ea02911$export$df452bc869d6b823)
                }, scopeId, attrs), {
                    "default": function() {
                        var _slots_default;
                        var _slots_default1;
                        return [
                            (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : items.value.map(function(item) {
                                var _slots_tab;
                                var _slots_tab1;
                                return (_slots_tab1 = (_slots_tab = slots.tab) === null || _slots_tab === void 0 ? void 0 : _slots_tab.call(slots, {
                                    item: item
                                })) !== null && _slots_tab1 !== void 0 ? _slots_tab1 : (0, $bu8yf.createVNode)((0, $e39ade78f6a044fc$export$f329ceb9f204f847), (0, $bu8yf.mergeProps)(item, {
                                    key: item.text,
                                    value: item.value
                                }), {
                                    "default": slots["tab.".concat(item.value)] ? function() {
                                        var _slots_;
                                        return (_slots_ = slots["tab.".concat(item.value)]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, {
                                            item: item
                                        });
                                    } : undefined
                                });
                            })
                        ];
                    }
                }),
                hasWindow && (0, $bu8yf.createVNode)((0, $80c6d1c41afa6997$export$9f9d2055cc6c09b8), (0, $bu8yf.mergeProps)({
                    modelValue: model.value,
                    "onUpdate:modelValue": function($event) {
                        return model.value = $event;
                    },
                    key: "tabs-window"
                }, scopeId), {
                    "default": function() {
                        var _slots_window;
                        return [
                            items.value.map(function(item) {
                                var _slots_item;
                                var _slots_item1;
                                return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                    item: item
                                })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $bu8yf.createVNode)((0, $38d5ebbcbc1c284a$export$94f5ea3c1db246aa), {
                                    value: item.value
                                }, {
                                    "default": function() {
                                        var _slots_;
                                        return (_slots_ = slots["item.".concat(item.value)]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, {
                                            item: item
                                        });
                                    }
                                });
                            }),
                            (_slots_window = slots.window) === null || _slots_window === void 0 ? void 0 : _slots_window.call(slots)
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});






var $00ce4277fa188058$exports = {};

$parcel$export($00ce4277fa188058$exports, "VTable", function () { return $1abdccdd2ed5d604$export$95f18d4f6bf10502; });



var $5e91b3922d898731$exports = {};

$parcel$export($5e91b3922d898731$exports, "VTextarea", function () { return $2f8433af34d84f09$export$9bdfdce9e7a0e519; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $g79Gh = parcelRequire("g79Gh");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $kiZwI = parcelRequire("kiZwI");












var $2f8433af34d84f09$export$3bffc1deba3cd16e = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    autoGrow: Boolean,
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: Function,
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    noResize: Boolean,
    rows: {
        type: [
            Number,
            String
        ],
        "default": 5,
        validator: function(v) {
            return !isNaN(parseFloat(v));
        }
    },
    maxRows: {
        type: [
            Number,
            String
        ],
        validator: function(v) {
            return !isNaN(parseFloat(v));
        }
    },
    suffix: String,
    modelModifiers: Object
}, (0, $b8b1b307f20fc3d6$export$525655a73981d616)(), (0, $88ed151c68066729$export$1e13429dc53b9634)()), 'VTextarea');
var $2f8433af34d84f09$export$9bdfdce9e7a0e519 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTextarea',
    directives: {
        vIntersect: (0, $f77d117b08c9abf5$export$2e2bcd8739ae039)
    },
    inheritAttrs: false,
    props: $2f8433af34d84f09$export$3bffc1deba3cd16e(),
    emits: {
        'click:control': function(e) {
            return true;
        },
        'mousedown:control': function(e) {
            return true;
        },
        'update:focused': function(focused) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        },
        'update:rows': function(rows) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
        var model = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var _useFocus = (0, $6f0e0973cbf83779$export$f8168d8dd8fd66e6)(props), isFocused = _useFocus.isFocused, focus = _useFocus.focus, blur = _useFocus.blur;
        var onIntersect = (0, $c8dd3d88903cb8c3$export$a9c05560d717b4fe)(props).onIntersect;
        var counterValue = (0, $hXmfK.computed)(function() {
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : (model.value || '').toString().length;
        });
        var max = (0, $hXmfK.computed)(function() {
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        var vInputRef = (0, $hXmfK.ref)();
        var vFieldRef = (0, $hXmfK.ref)();
        var controlHeight = (0, $hXmfK.shallowRef)('');
        var textareaRef = (0, $hXmfK.ref)();
        var isActive = (0, $hXmfK.computed)(function() {
            return props.persistentPlaceholder || isFocused.value || props.active;
        });
        function onFocus() {
            var _textareaRef_value;
            if (textareaRef.value !== document.activeElement) (_textareaRef_value = textareaRef.value) === null || _textareaRef_value === void 0 ? void 0 : _textareaRef_value.focus();
            if (!isFocused.value) focus();
        }
        function onControlClick(e) {
            onFocus();
            emit('click:control', e);
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $bu8yf.nextTick)(function() {
                model.value = '';
                (0, $31779689cfd5da50$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            var _props_modelModifiers;
            var el = e.target;
            model.value = el.value;
            if ((_props_modelModifiers = props.modelModifiers) === null || _props_modelModifiers === void 0 ? void 0 : _props_modelModifiers.trim) {
                var caretPosition = [
                    el.selectionStart,
                    el.selectionEnd
                ];
                (0, $bu8yf.nextTick)(function() {
                    el.selectionStart = caretPosition[0];
                    el.selectionEnd = caretPosition[1];
                });
            }
        }
        var sizerRef = (0, $hXmfK.ref)();
        var rows = (0, $hXmfK.ref)(Number(props.rows));
        var isPlainOrUnderlined = (0, $hXmfK.computed)(function() {
            return [
                'plain',
                'underlined'
            ].includes(props.variant);
        });
        (0, $bu8yf.watchEffect)(function() {
            if (!props.autoGrow) rows.value = Number(props.rows);
        });
        function calculateInputHeight() {
            if (!props.autoGrow) return;
            (0, $bu8yf.nextTick)(function() {
                if (!sizerRef.value || !vFieldRef.value) return;
                var style = getComputedStyle(sizerRef.value);
                var fieldStyle = getComputedStyle(vFieldRef.value.$el);
                var padding = parseFloat(style.getPropertyValue('--v-field-padding-top')) + parseFloat(style.getPropertyValue('--v-input-padding-top')) + parseFloat(style.getPropertyValue('--v-field-padding-bottom'));
                var height = sizerRef.value.scrollHeight;
                var lineHeight = parseFloat(style.lineHeight);
                var minHeight = Math.max(parseFloat(props.rows) * lineHeight + padding, parseFloat(fieldStyle.getPropertyValue('--v-input-control-height')));
                var maxHeight = parseFloat(props.maxRows) * lineHeight + padding || Infinity;
                var newHeight = (0, $31779689cfd5da50$export$7d15b64cf5a3a4c4)(height !== null && height !== void 0 ? height : 0, minHeight, maxHeight);
                rows.value = Math.floor((newHeight - padding) / lineHeight);
                controlHeight.value = (0, $31779689cfd5da50$export$286ad215293a0860)(newHeight);
            });
        }
        (0, $bu8yf.onMounted)(calculateInputHeight);
        (0, $hXmfK.watch)(model, calculateInputHeight);
        (0, $hXmfK.watch)(function() {
            return props.rows;
        }, calculateInputHeight);
        (0, $hXmfK.watch)(function() {
            return props.maxRows;
        }, calculateInputHeight);
        (0, $hXmfK.watch)(function() {
            return props.density;
        }, calculateInputHeight);
        (0, $hXmfK.watch)(rows, function(val) {
            emit('update:rows', val);
        });
        var observer;
        (0, $hXmfK.watch)(sizerRef, function(val) {
            if (val) {
                observer = new ResizeObserver(calculateInputHeight);
                observer.observe(sizerRef.value);
            } else observer === null || observer === void 0 ? void 0 : observer.disconnect();
        });
        (0, $bu8yf.onBeforeUnmount)(function() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hasCounter = !!(slots.counter || props.counter || props.counterValue);
            var hasDetails = !!(hasCounter || slots.details);
            var _filterInputAttrs = (0, $32TW8._)((0, $31779689cfd5da50$export$c46dde8a23cbfcf2)(attrs), 2), rootAttrs = _filterInputAttrs[0], inputAttrs = _filterInputAttrs[1];
            var _VInput_filterProps = (0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac).filterProps(props), _ = _VInput_filterProps.modelValue, inputProps = (0, $g79Gh._)(_VInput_filterProps, [
                "modelValue"
            ]);
            var fieldProps = (0, $88ed151c68066729$export$3180fb4997e9f72d).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $b8b1b307f20fc3d6$export$2aca538d9f87f6ac), (0, $bu8yf.mergeProps)({
                ref: vInputRef,
                modelValue: model.value,
                "onUpdate:modelValue": function($event) {
                    return model.value = $event;
                },
                "class": [
                    'v-textarea v-text-field',
                    {
                        'v-textarea--prefixed': props.prefix,
                        'v-textarea--suffixed': props.suffix,
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-textarea--auto-grow': props.autoGrow,
                        'v-textarea--no-resize': props.noResize || props.autoGrow,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props["class"]
                ],
                style: props.style
            }, rootAttrs, inputProps, {
                centerAffix: rows.value === 1 && !isPlainOrUnderlined.value,
                focused: isFocused.value
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                "default": function(_ref2) {
                    var id = _ref2.id, isDisabled = _ref2.isDisabled, isDirty = _ref2.isDirty, isReadonly = _ref2.isReadonly, isValid = _ref2.isValid, hasDetails = _ref2.hasDetails;
                    return (0, $bu8yf.createVNode)((0, $88ed151c68066729$export$3180fb4997e9f72d), (0, $bu8yf.mergeProps)({
                        ref: vFieldRef,
                        style: {
                            '--v-textarea-control-height': controlHeight.value
                        },
                        onClick: onControlClick,
                        onMousedown: onControlMousedown,
                        "onClick:clear": onClear,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        id: id.value,
                        active: isActive.value || isDirty.value,
                        centerAffix: rows.value === 1 && !isPlainOrUnderlined.value,
                        dirty: isDirty.value || props.dirty,
                        disabled: isDisabled.value,
                        focused: isFocused.value,
                        details: hasDetails.value,
                        error: isValid.value === false
                    }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                        "default": function(_ref3) {
                            var _ref3_props = _ref3.props, fieldClass = _ref3_props["class"], slotProps = (0, $g79Gh._)(_ref3.props, [
                                "class"
                            ]);
                            return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                                props.prefix && (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    props.prefix
                                ]),
                                (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("textarea", (0, $bu8yf.mergeProps)({
                                    ref: textareaRef,
                                    "class": fieldClass,
                                    value: model.value,
                                    onInput: onInput,
                                    autofocus: props.autofocus,
                                    readonly: isReadonly.value,
                                    disabled: isDisabled.value,
                                    placeholder: props.placeholder,
                                    rows: props.rows,
                                    name: props.name,
                                    onFocus: onFocus,
                                    onBlur: blur
                                }, slotProps, inputAttrs), null), [
                                    [
                                        (0, $f77d117b08c9abf5$export$2e2bcd8739ae039),
                                        {
                                            handler: onIntersect
                                        },
                                        null,
                                        {
                                            once: true
                                        }
                                    ]
                                ]),
                                props.autoGrow && (0, $bu8yf.withDirectives)((0, $bu8yf.createElementVNode)("textarea", {
                                    "class": (0, $d8jBh.normalizeClass)([
                                        fieldClass,
                                        'v-textarea__sizer'
                                    ]),
                                    id: "".concat(slotProps.id, "-sizer"),
                                    "onUpdate:modelValue": function($event) {
                                        return model.value = $event;
                                    },
                                    ref: sizerRef,
                                    readonly: true,
                                    "aria-hidden": "true"
                                }, null), [
                                    [
                                        (0, $kiZwI.vModelText),
                                        model.value
                                    ]
                                ]),
                                props.suffix && (0, $bu8yf.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    props.suffix
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? function(slotProps) {
                    var _slots_details;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            (0, $bu8yf.createElementVNode)("span", null, null),
                            (0, $bu8yf.createVNode)((0, $7ba1fb3b216974cf$export$45efeae449ff2094), {
                                active: props.persistentCounter || isFocused.value,
                                value: counterValue.value,
                                max: max.value,
                                disabled: props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, textareaRef);
    }
});




var $ef4aea61c38f9c82$exports = {};

$parcel$export($ef4aea61c38f9c82$exports, "VTextField", function () { return $9193e20196e963bf$export$d591c92dea965c28; });



var $4d1f0a55c2134152$exports = {};

$parcel$export($4d1f0a55c2134152$exports, "VThemeProvider", function () { return $22dc1169c603ec69$export$dc0f7eaa56e7be3e; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");





var $22dc1169c603ec69$export$a2d976d5fd234984 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    withBackground: Boolean
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VThemeProvider');
var $22dc1169c603ec69$export$dc0f7eaa56e7be3e = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VThemeProvider',
    props: $22dc1169c603ec69$export$a2d976d5fd234984(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        return function() {
            var _slots_default;
            if (!props.withBackground) return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-theme-provider',
                    themeClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, {
                "default": function() {
                    var _slots_default;
                    return [
                        (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        };
    }
});




var $f130f0376ac60da4$exports = {};

$parcel$export($f130f0376ac60da4$exports, "VTimeline", function () { return $5459c5be85611ad1$export$8ba89235f21b4a00; });
$parcel$export($f130f0376ac60da4$exports, "VTimelineItem", function () { return $101e1e63ce8b00f8$export$dad0709e56abc8b2; });

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");









var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");

var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");









var $88115f2cd6cac2ed$export$30ea0189fb602543 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    iconColor: String,
    lineColor: String
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $753fdc0f0b894251$export$858059d20a48304b)()), 'VTimelineDivider');
var $88115f2cd6cac2ed$export$efdada82bea82bd = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimelineDivider',
    props: $88115f2cd6cac2ed$export$30ea0189fb602543(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var _useSize = (0, $4d4c8d49e200475b$export$1ab7ae714698c4b8)(props, 'v-timeline-divider__dot'), sizeClasses = _useSize.sizeClasses, sizeStyles = _useSize.sizeStyles;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.dotColor;
        }), backgroundColorStyles = _useBackgroundColor.backgroundColorStyles, backgroundColorClasses = _useBackgroundColor.backgroundColorClasses;
        var roundedClasses = (0, $96532e4c9abc507c$export$36c3a2ea94409e5e)(props, 'v-timeline-divider__dot').roundedClasses;
        var elevationClasses = (0, $753fdc0f0b894251$export$617be03f9f20f78c)(props).elevationClasses;
        var _useBackgroundColor1 = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.lineColor;
        }), lineColorClasses = _useBackgroundColor1.backgroundColorClasses, lineColorStyles = _useBackgroundColor1.backgroundColorStyles;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-timeline-divider',
                    {
                        'v-timeline-divider--fill-dot': props.fillDot
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-timeline-divider__before',
                        lineColorClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(lineColorStyles.value)
                }, null),
                !props.hideDot && (0, $bu8yf.createElementVNode)("div", {
                    key: "dot",
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-timeline-divider__dot',
                        elevationClasses.value,
                        roundedClasses.value,
                        sizeClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(sizeStyles.value)
                }, [
                    (0, $bu8yf.createElementVNode)("div", {
                        "class": (0, $d8jBh.normalizeClass)([
                            'v-timeline-divider__inner-dot',
                            backgroundColorClasses.value,
                            roundedClasses.value
                        ]),
                        style: (0, $d8jBh.normalizeStyle)(backgroundColorStyles.value)
                    }, [
                        !slots["default"] ? (0, $bu8yf.createVNode)((0, $f7a1be8330d12953$export$a7d30c6ec4d2d61e), {
                            key: "icon",
                            color: props.iconColor,
                            icon: props.icon,
                            size: props.size
                        }, null) : (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            key: "icon-defaults",
                            disabled: !props.icon,
                            defaults: {
                                VIcon: {
                                    color: props.iconColor,
                                    icon: props.icon,
                                    size: props.size
                                }
                            }
                        }, slots["default"])
                    ])
                ]),
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)([
                        'v-timeline-divider__after',
                        lineColorClasses.value
                    ]),
                    style: (0, $d8jBh.normalizeStyle)(lineColorStyles.value)
                }, null)
            ]);
        });
        return {};
    }
});










var $101e1e63ce8b00f8$export$ead07d56a29717a5 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    density: String,
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    hideOpposite: {
        type: Boolean,
        "default": undefined
    },
    icon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    iconColor: String,
    lineInset: [
        Number,
        String
    ],
    side: {
        type: String,
        validator: function(v) {
            return v == null || [
                'start',
                'end'
            ].includes(v);
        }
    }
}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ff2612ddfc292b98$export$f37f46640cc8dd75)(), (0, $753fdc0f0b894251$export$858059d20a48304b)(), (0, $96532e4c9abc507c$export$7bbc36c81a352d50)(), (0, $4d4c8d49e200475b$export$c7a32fb00df3ff20)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)()), 'VTimelineItem');
var $101e1e63ce8b00f8$export$dad0709e56abc8b2 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimelineItem',
    props: $101e1e63ce8b00f8$export$ead07d56a29717a5(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var dimensionStyles = (0, $ff2612ddfc292b98$export$2b21de4fc4968be5)(props).dimensionStyles;
        var dotSize = (0, $hXmfK.shallowRef)(0);
        var dotRef = (0, $hXmfK.ref)();
        (0, $hXmfK.watch)(dotRef, function(newValue) {
            var _newValue_$el_querySelector;
            if (!newValue) return;
            var _newValue_$el_querySelector_getBoundingClientRect_width;
            dotSize.value = (_newValue_$el_querySelector_getBoundingClientRect_width = (_newValue_$el_querySelector = newValue.$el.querySelector('.v-timeline-divider__dot')) === null || _newValue_$el_querySelector === void 0 ? void 0 : _newValue_$el_querySelector.getBoundingClientRect().width) !== null && _newValue_$el_querySelector_getBoundingClientRect_width !== void 0 ? _newValue_$el_querySelector_getBoundingClientRect_width : 0;
        }, {
            flush: 'post'
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default, _slots_opposite;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-timeline-item',
                    {
                        'v-timeline-item--fill-dot': props.fillDot,
                        'v-timeline-item--side-start': props.side === 'start',
                        'v-timeline-item--side-end': props.side === 'end'
                    },
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-timeline-dot-size': (0, $31779689cfd5da50$export$286ad215293a0860)(dotSize.value),
                        '--v-timeline-line-inset': props.lineInset ? "calc(var(--v-timeline-dot-size) / 2 + ".concat((0, $31779689cfd5da50$export$286ad215293a0860)(props.lineInset), ")") : (0, $31779689cfd5da50$export$286ad215293a0860)(0)
                    },
                    props.style
                ])
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-timeline-item__body",
                    style: (0, $d8jBh.normalizeStyle)(dimensionStyles.value)
                }, [
                    (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ]),
                (0, $bu8yf.createVNode)((0, $88115f2cd6cac2ed$export$efdada82bea82bd), {
                    ref: dotRef,
                    hideDot: props.hideDot,
                    icon: props.icon,
                    iconColor: props.iconColor,
                    size: props.size,
                    elevation: props.elevation,
                    dotColor: props.dotColor,
                    fillDot: props.fillDot,
                    rounded: props.rounded
                }, {
                    "default": slots.icon
                }),
                props.density !== 'compact' && (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-timeline-item__opposite"
                }, [
                    !props.hideOpposite && ((_slots_opposite = slots.opposite) === null || _slots_opposite === void 0 ? void 0 : _slots_opposite.call(slots))
                ])
            ]);
        });
        return {};
    }
});


var $5459c5be85611ad1$export$4b8690f62a5e29fc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    align: {
        type: String,
        "default": 'center',
        validator: function(v) {
            return [
                'center',
                'start'
            ].includes(v);
        }
    },
    direction: {
        type: String,
        "default": 'vertical',
        validator: function(v) {
            return [
                'vertical',
                'horizontal'
            ].includes(v);
        }
    },
    justify: {
        type: String,
        "default": 'auto',
        validator: function(v) {
            return [
                'auto',
                'center'
            ].includes(v);
        }
    },
    side: {
        type: String,
        validator: function(v) {
            return v == null || [
                'start',
                'end'
            ].includes(v);
        }
    },
    lineThickness: {
        type: [
            String,
            Number
        ],
        "default": 2
    },
    lineColor: String,
    truncateLine: {
        type: String,
        validator: function(v) {
            return [
                'start',
                'end',
                'both'
            ].includes(v);
        }
    }
}, (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $101e1e63ce8b00f8$export$ead07d56a29717a5)({
    lineInset: 0
}), [
    'dotColor',
    'fillDot',
    'hideOpposite',
    'iconColor',
    'lineInset',
    'size'
]), (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $ee636d54b7237d8b$export$aac8956235d563cb)(), (0, $ff78e1b0ace7b26a$export$1e45edda911c93db)(), (0, $d8647489982f8a06$export$d0fc5ddd543b4149)()), 'VTimeline');
var $5459c5be85611ad1$export$8ba89235f21b4a00 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimeline',
    props: $5459c5be85611ad1$export$4b8690f62a5e29fc(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var themeClasses = (0, $d8647489982f8a06$export$307b27329074e447)(props).themeClasses;
        var densityClasses = (0, $ee636d54b7237d8b$export$29e89a97ff256b5f)(props).densityClasses;
        var rtlClasses = (0, $b4c1f4104dc86d4b$export$b2dd014b6c321cb)().rtlClasses;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VTimelineDivider: {
                lineColor: (0, $hXmfK.toRef)(function() {
                    return props.lineColor;
                })
            },
            VTimelineItem: {
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                dotColor: (0, $hXmfK.toRef)(function() {
                    return props.dotColor;
                }),
                fillDot: (0, $hXmfK.toRef)(function() {
                    return props.fillDot;
                }),
                hideOpposite: (0, $hXmfK.toRef)(function() {
                    return props.hideOpposite;
                }),
                iconColor: (0, $hXmfK.toRef)(function() {
                    return props.iconColor;
                }),
                lineColor: (0, $hXmfK.toRef)(function() {
                    return props.lineColor;
                }),
                lineInset: (0, $hXmfK.toRef)(function() {
                    return props.lineInset;
                }),
                size: (0, $hXmfK.toRef)(function() {
                    return props.size;
                })
            }
        });
        var sideClasses = (0, $hXmfK.computed)(function() {
            var side = props.side ? props.side : props.density !== 'default' ? 'end' : null;
            return side && "v-timeline--side-".concat(side);
        });
        var truncateClasses = (0, $hXmfK.computed)(function() {
            var classes = [
                'v-timeline--truncate-line-start',
                'v-timeline--truncate-line-end'
            ];
            switch(props.truncateLine){
                case 'both':
                    return classes;
                case 'start':
                    return classes[0];
                case 'end':
                    return classes[1];
                default:
                    return null;
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createVNode)(props.tag, {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-timeline',
                    "v-timeline--".concat(props.direction),
                    "v-timeline--align-".concat(props.align),
                    "v-timeline--justify-".concat(props.justify),
                    truncateClasses.value,
                    {
                        'v-timeline--inset-line': !!props.lineInset
                    },
                    themeClasses.value,
                    densityClasses.value,
                    sideClasses.value,
                    rtlClasses.value,
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)([
                    {
                        '--v-timeline-line-thickness': (0, $31779689cfd5da50$export$286ad215293a0860)(props.lineThickness)
                    },
                    props.style
                ])
            }, slots);
        });
        return {};
    }
});





var $49bcfb59db4eba0d$exports = {};

$parcel$export($49bcfb59db4eba0d$exports, "VTimePicker", function () { return $6798944a705a2f57$export$71890c8f1f4c0e46; });
$parcel$export($49bcfb59db4eba0d$exports, "VTimePickerClock", function () { return $0d9cdfa80043d000$export$c447be6017502228; });
$parcel$export($49bcfb59db4eba0d$exports, "VTimePickerControls", function () { return $c78fb2d667266b3c$export$bc5bd0b10348afb9; });

var $iT0je = parcelRequire("iT0je");

var $32TW8 = parcelRequire("32TW8");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

function $5c839c419f21c425$export$5d04458e2a6c373e(n) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return String(n).padStart(length, '0');
}


parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");



var $0d9cdfa80043d000$export$61f3751d6bc7b864 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    allowedValues: Function,
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    displayedValue: null,
    double: Boolean,
    format: {
        type: Function,
        "default": function(val) {
            return val;
        }
    },
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    scrollable: Boolean,
    readonly: Boolean,
    rotate: {
        type: Number,
        "default": 0
    },
    step: {
        type: Number,
        "default": 1
    },
    modelValue: {
        type: Number
    }
}, 'VTimePickerClock');
var $0d9cdfa80043d000$export$c447be6017502228 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimePickerClock',
    props: $0d9cdfa80043d000$export$61f3751d6bc7b864(),
    emits: {
        change: function(val) {
            return true;
        },
        input: function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit;
        var clockRef = (0, $hXmfK.ref)(null);
        var innerClockRef = (0, $hXmfK.ref)(null);
        var inputValue = (0, $hXmfK.ref)(undefined);
        var isDragging = (0, $hXmfK.ref)(false);
        var valueOnMouseDown = (0, $hXmfK.ref)(null);
        var valueOnMouseUp = (0, $hXmfK.ref)(null);
        var emitChangeDebounced = (0, $31779689cfd5da50$export$61fc7d43ac8f84b0)(function(value) {
            return emit('change', value);
        }, 750);
        var _useTextColor = (0, $1f80711f67f81e35$export$2eb7f8f6c72160ec)(function() {
            return props.color;
        }), textColorClasses = _useTextColor.textColorClasses, textColorStyles = _useTextColor.textColorStyles;
        var _useBackgroundColor = (0, $1f80711f67f81e35$export$de4733d8105ed3f2)(function() {
            return props.color;
        }), backgroundColorClasses = _useBackgroundColor.backgroundColorClasses, backgroundColorStyles = _useBackgroundColor.backgroundColorStyles;
        var count = (0, $hXmfK.computed)(function() {
            return props.max - props.min + 1;
        });
        var roundCount = (0, $hXmfK.computed)(function() {
            return props["double"] ? count.value / 2 : count.value;
        });
        var degreesPerUnit = (0, $hXmfK.computed)(function() {
            return 360 / roundCount.value;
        });
        var degrees = (0, $hXmfK.computed)(function() {
            return degreesPerUnit.value * Math.PI / 180;
        });
        var displayedValue = (0, $hXmfK.computed)(function() {
            return props.modelValue == null ? props.min : props.modelValue;
        });
        var innerRadiusScale = (0, $hXmfK.computed)(function() {
            return 0.62;
        });
        var genChildren = (0, $hXmfK.computed)(function() {
            var children = [];
            for(var value = props.min; value <= props.max; value = value + props.step)children.push(value);
            return children;
        });
        (0, $hXmfK.watch)(function() {
            return props.modelValue;
        }, function(val) {
            inputValue.value = val;
        });
        function update(value) {
            if (inputValue.value !== value) inputValue.value = value;
            emit('input', value);
        }
        function isAllowed(value) {
            return !props.allowedValues || props.allowedValues(value);
        }
        function wheel(e) {
            if (!props.scrollable || props.disabled) return;
            e.preventDefault();
            var delta = Math.sign(-e.deltaY || 1);
            var value = displayedValue.value;
            do {
                value = value + delta;
                value = (value - props.min + count.value) % count.value + props.min;
            }while (!isAllowed(value) && value !== displayedValue.value);
            if (value !== props.displayedValue) update(value);
            emitChangeDebounced(value);
        }
        function isInner(value) {
            return props["double"] && value - props.min >= roundCount.value;
        }
        function handScale(value) {
            return isInner(value) ? innerRadiusScale.value : 1;
        }
        function getPosition(value) {
            var rotateRadians = props.rotate * Math.PI / 180;
            return {
                x: Math.sin((value - props.min) * degrees.value + rotateRadians) * handScale(value),
                y: -Math.cos((value - props.min) * degrees.value + rotateRadians) * handScale(value)
            };
        }
        function angleToValue(angle, insideClick) {
            var value = (Math.round(angle / degreesPerUnit.value) + (insideClick ? roundCount.value : 0)) % count.value + props.min;
            // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
            if (angle < 360 - degreesPerUnit.value / 2) return value;
            return insideClick ? props.max - roundCount.value + 1 : props.min;
        }
        function getTransform(i) {
            var _getPosition = getPosition(i), x = _getPosition.x, y = _getPosition.y;
            return {
                left: "".concat(Math.round(50 + x * 50), "%"),
                top: "".concat(Math.round(50 + y * 50), "%")
            };
        }
        function euclidean(p0, p1) {
            var dx = p1.x - p0.x;
            var dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function angle(center, p1) {
            var value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
            return Math.abs(value * 180 / Math.PI);
        }
        function setMouseDownValue(value) {
            if (valueOnMouseDown.value === null) valueOnMouseDown.value = value;
            valueOnMouseUp.value = value;
            update(value);
        }
        function onDragMove(e) {
            var _clockRef_value, _innerClockRef_value;
            e.preventDefault();
            if (!isDragging.value && e.type !== 'click' || !clockRef.value) return;
            var _$_ref = (_clockRef_value = clockRef.value) === null || _clockRef_value === void 0 ? void 0 : _clockRef_value.getBoundingClientRect(), width = _$_ref.width, top = _$_ref.top, left = _$_ref.left;
            var _innerClockRef_value_getBoundingClientRect;
            var _$_ref1 = (_innerClockRef_value_getBoundingClientRect = (_innerClockRef_value = innerClockRef.value) === null || _innerClockRef_value === void 0 ? void 0 : _innerClockRef_value.getBoundingClientRect()) !== null && _innerClockRef_value_getBoundingClientRect !== void 0 ? _innerClockRef_value_getBoundingClientRect : {
                width: 0
            }, innerWidth = _$_ref1.width;
            var _$_ref2 = 'touches' in e ? e.touches[0] : e, clientX = _$_ref2.clientX, clientY = _$_ref2.clientY;
            var center = {
                x: width / 2,
                y: -width / 2
            };
            var coords = {
                x: clientX - left,
                y: top - clientY
            };
            var handAngle = Math.round(angle(center, coords) - props.rotate + 360) % 360;
            var insideClick = props["double"] && euclidean(center, coords) < (innerWidth + innerWidth * innerRadiusScale.value) / 4;
            var checksCount = Math.ceil(15 / degreesPerUnit.value);
            var value;
            for(var i = 0; i < checksCount; i++){
                value = angleToValue(handAngle + i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
                value = angleToValue(handAngle - i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
            }
        }
        function onMouseDown(e) {
            if (props.disabled) return;
            e.preventDefault();
            window.addEventListener('mousemove', onDragMove);
            window.addEventListener('touchmove', onDragMove);
            window.addEventListener('mouseup', onMouseUp);
            window.addEventListener('touchend', onMouseUp);
            valueOnMouseDown.value = null;
            valueOnMouseUp.value = null;
            isDragging.value = true;
            onDragMove(e);
        }
        function onMouseUp(e) {
            e.stopPropagation();
            window.removeEventListener('mousemove', onDragMove);
            window.removeEventListener('touchmove', onDragMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('touchend', onMouseUp);
            isDragging.value = false;
            if (valueOnMouseUp.value !== null && isAllowed(valueOnMouseUp.value)) emit('change', valueOnMouseUp.value);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    {
                        'v-time-picker-clock': true,
                        'v-time-picker-clock--indeterminate': props.modelValue == null,
                        'v-time-picker-clock--readonly': props.readonly
                    }
                ]),
                onMousedown: onMouseDown,
                onTouchstart: onMouseDown,
                onWheel: wheel,
                ref: clockRef
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": "v-time-picker-clock__inner",
                    ref: innerClockRef
                }, [
                    (0, $bu8yf.createElementVNode)("div", {
                        "class": (0, $d8jBh.normalizeClass)([
                            {
                                'v-time-picker-clock__hand': true,
                                'v-time-picker-clock__hand--inner': isInner(props.modelValue)
                            },
                            textColorClasses.value
                        ]),
                        style: (0, $d8jBh.normalizeStyle)([
                            {
                                transform: "rotate(".concat(props.rotate + degreesPerUnit.value * (displayedValue.value - props.min), "deg) scaleY(").concat(handScale(displayedValue.value), ")")
                            },
                            textColorStyles.value
                        ])
                    }, null),
                    genChildren.value.map(function(value) {
                        var isActive = value === displayedValue.value;
                        return (0, $bu8yf.createElementVNode)("div", {
                            "class": (0, $d8jBh.normalizeClass)([
                                {
                                    'v-time-picker-clock__item': true,
                                    'v-time-picker-clock__item--active': isActive,
                                    'v-time-picker-clock__item--disabled': props.disabled || !isAllowed(value)
                                },
                                isActive && backgroundColorClasses.value
                            ]),
                            style: (0, $d8jBh.normalizeStyle)([
                                getTransform(value),
                                isActive && backgroundColorStyles.value
                            ])
                        }, [
                            (0, $bu8yf.createElementVNode)("span", null, [
                                props.format(value)
                            ])
                        ]);
                    })
                ])
            ]);
        });
    }
});


parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");





var $c78fb2d667266b3c$export$97d9b52d5b38b271 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)({
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    hour: Number,
    minute: Number,
    second: Number,
    period: String,
    readonly: Boolean,
    useSeconds: Boolean,
    value: Number,
    viewMode: String
}, 'VTimePickerControls');
var $c78fb2d667266b3c$export$bc5bd0b10348afb9 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimePickerControls',
    props: $c78fb2d667266b3c$export$97d9b52d5b38b271(),
    emits: {
        'update:period': function(data) {
            return true;
        },
        'update:viewMode': function(data) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var hour = props.hour;
            if (props.ampm) hour = hour ? (hour - 1) % 12 + 1 : 12;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": "v-time-picker-controls"
            }, [
                (0, $bu8yf.createElementVNode)("div", {
                    "class": (0, $d8jBh.normalizeClass)({
                        'v-time-picker-controls__time': true,
                        'v-time-picker-controls__time--with-seconds': props.useSeconds
                    })
                }, [
                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        active: props.viewMode === 'hour',
                        color: props.viewMode === 'hour' ? props.color : undefined,
                        disabled: props.disabled,
                        variant: "tonal",
                        "class": (0, $d8jBh.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time--with-ampm__btn': props.ampm,
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        text: props.hour == null ? '--' : (0, $5c839c419f21c425$export$5d04458e2a6c373e)("".concat(hour)),
                        onClick: function() {
                            return emit('update:viewMode', 'hour');
                        }
                    }, null),
                    (0, $bu8yf.createElementVNode)("span", {
                        "class": (0, $d8jBh.normalizeClass)([
                            'v-time-picker-controls__time__separator',
                            {
                                'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
                            }
                        ])
                    }, [
                        (0, $bu8yf.createTextVNode)(":")
                    ]),
                    (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        active: props.viewMode === 'minute',
                        color: props.viewMode === 'minute' ? props.color : undefined,
                        "class": (0, $d8jBh.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time__btn__active': props.viewMode === 'minute',
                            'v-time-picker-controls__time--with-ampm__btn': props.ampm,
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        disabled: props.disabled,
                        variant: "tonal",
                        text: props.minute == null ? '--' : (0, $5c839c419f21c425$export$5d04458e2a6c373e)(props.minute),
                        onClick: function() {
                            return emit('update:viewMode', 'minute');
                        }
                    }, null),
                    props.useSeconds && (0, $bu8yf.createElementVNode)("span", {
                        "class": (0, $d8jBh.normalizeClass)([
                            'v-time-picker-controls__time__separator',
                            {
                                'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
                            }
                        ]),
                        key: "secondsDivider"
                    }, [
                        (0, $bu8yf.createTextVNode)(":")
                    ]),
                    props.useSeconds && (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                        key: "secondsVal",
                        active: props.viewMode === 'second',
                        color: props.viewMode === 'second' ? props.color : undefined,
                        variant: "tonal",
                        onClick: function() {
                            return emit('update:viewMode', 'second');
                        },
                        "class": (0, $d8jBh.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time__btn__active': props.viewMode === 'second',
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        disabled: props.disabled,
                        text: props.second == null ? '--' : (0, $5c839c419f21c425$export$5d04458e2a6c373e)(props.second)
                    }, null),
                    props.ampm && (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-time-picker-controls__ampm"
                    }, [
                        (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                            active: props.period === 'am',
                            color: props.period === 'am' ? props.color : undefined,
                            "class": (0, $d8jBh.normalizeClass)({
                                'v-time-picker-controls__ampm__am': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'am'
                            }),
                            disabled: props.disabled,
                            text: t('$vuetify.timePicker.am'),
                            variant: props.disabled && props.period === 'am' ? 'elevated' : 'tonal',
                            onClick: function() {
                                return props.period !== 'am' ? emit('update:period', 'am') : null;
                            }
                        }, null),
                        (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                            active: props.period === 'pm',
                            color: props.period === 'pm' ? props.color : undefined,
                            "class": (0, $d8jBh.normalizeClass)({
                                'v-time-picker-controls__ampm__pm': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'pm'
                            }),
                            disabled: props.disabled,
                            text: t('$vuetify.timePicker.pm'),
                            variant: props.disabled && props.period === 'pm' ? 'elevated' : 'tonal',
                            onClick: function() {
                                return props.period !== 'pm' ? emit('update:period', 'pm') : null;
                            }
                        }, null)
                    ])
                ])
            ]);
        });
        return {};
    }
});






var $6798944a705a2f57$var$rangeHours24 = (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(24);
var $6798944a705a2f57$var$rangeHours12am = (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(12);
var $6798944a705a2f57$var$rangeHours12pm = $6798944a705a2f57$var$rangeHours12am.map(function(v) {
    return v + 12;
});
var $6798944a705a2f57$var$range60 = (0, $31779689cfd5da50$export$d372f2f3c4d1b8e5)(60);
var $6798944a705a2f57$export$8af4c77d07a6a5d7 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    allowedHours: [
        Function,
        Array
    ],
    allowedMinutes: [
        Function,
        Array
    ],
    allowedSeconds: [
        Function,
        Array
    ],
    disabled: Boolean,
    format: {
        type: String,
        "default": 'ampm'
    },
    max: String,
    min: String,
    viewMode: {
        type: String,
        "default": 'hour'
    },
    modelValue: null,
    readonly: Boolean,
    scrollable: Boolean,
    useSeconds: Boolean
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $3a810783e3364626$export$78d2911f7e2f59e2)({
    title: '$vuetify.timePicker.title'
}), [
    'landscape'
])), 'VTimePicker');
var $6798944a705a2f57$export$71890c8f1f4c0e46 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTimePicker',
    props: $6798944a705a2f57$export$8af4c77d07a6a5d7(),
    emits: {
        'update:hour': function(val) {
            return true;
        },
        'update:minute': function(val) {
            return true;
        },
        'update:period': function(val) {
            return true;
        },
        'update:second': function(val) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        },
        'update:viewMode': function(val) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var emit = _ref.emit, slots = _ref.slots;
        var t = (0, $b4c1f4104dc86d4b$export$43bb16f9c6d9e3f7)().t;
        var inputHour = (0, $hXmfK.ref)(null);
        var inputMinute = (0, $hXmfK.ref)(null);
        var inputSecond = (0, $hXmfK.ref)(null);
        var lazyInputHour = (0, $hXmfK.ref)(null);
        var lazyInputMinute = (0, $hXmfK.ref)(null);
        var lazyInputSecond = (0, $hXmfK.ref)(null);
        var period = (0, $hXmfK.ref)('am');
        var viewMode = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'viewMode', 'hour');
        var controlsRef = (0, $hXmfK.ref)(null);
        var clockRef = (0, $hXmfK.ref)(null);
        var isAllowedHourCb = (0, $hXmfK.computed)(function() {
            var cb;
            if (props.allowedHours instanceof Array) cb = function(val) {
                return props.allowedHours.includes(val);
            };
            else cb = props.allowedHours;
            if (!props.min && !props.max) return cb;
            var minHour = props.min ? Number(props.min.split(':')[0]) : 0;
            var maxHour = props.max ? Number(props.max.split(':')[0]) : 23;
            return function(val) {
                return val >= Number(minHour) && val <= Number(maxHour) && (!cb || cb(val));
            };
        });
        var isAllowedMinuteCb = (0, $hXmfK.computed)(function() {
            var cb;
            var isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
            if (props.allowedMinutes instanceof Array) cb = function(val) {
                return props.allowedMinutes.includes(val);
            };
            else cb = props.allowedMinutes;
            if (!props.min && !props.max) return isHourAllowed ? cb : function() {
                return false;
            };
            var _$_ref = (0, $32TW8._)(props.min ? props.min.split(':').map(Number) : [
                0,
                0
            ], 2), minHour = _$_ref[0], minMinute = _$_ref[1];
            var _$_ref1 = (0, $32TW8._)(props.max ? props.max.split(':').map(Number) : [
                23,
                59
            ], 2), maxHour = _$_ref1[0], maxMinute = _$_ref1[1];
            var minTime = minHour * 60 + Number(minMinute);
            var maxTime = maxHour * 60 + Number(maxMinute);
            return function(val) {
                var time = 60 * inputHour.value + val;
                return time >= minTime && time <= maxTime && isHourAllowed && (!cb || cb(val));
            };
        });
        var isAllowedSecondCb = (0, $hXmfK.computed)(function() {
            var cb;
            var isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
            var isMinuteAllowed = isHourAllowed && (!isAllowedMinuteCb.value || inputMinute.value === null || isAllowedMinuteCb.value(inputMinute.value));
            if (props.allowedSeconds instanceof Array) cb = function(val) {
                return props.allowedSeconds.includes(val);
            };
            else cb = props.allowedSeconds;
            if (!props.min && !props.max) return isMinuteAllowed ? cb : function() {
                return false;
            };
            var _$_ref = (0, $32TW8._)(props.min ? props.min.split(':').map(Number) : [
                0,
                0,
                0
            ], 3), minHour = _$_ref[0], minMinute = _$_ref[1], minSecond = _$_ref[2];
            var _$_ref1 = (0, $32TW8._)(props.max ? props.max.split(':').map(Number) : [
                23,
                59,
                59
            ], 3), maxHour = _$_ref1[0], maxMinute = _$_ref1[1], maxSecond = _$_ref1[2];
            var minTime = minHour * 3600 + minMinute * 60 + Number(minSecond || 0);
            var maxTime = maxHour * 3600 + maxMinute * 60 + Number(maxSecond || 0);
            return function(val) {
                var time = 3600 * inputHour.value + 60 * inputMinute.value + val;
                return time >= minTime && time <= maxTime && isMinuteAllowed && (!cb || cb(val));
            };
        });
        var isAmPm = (0, $hXmfK.computed)(function() {
            return props.format === 'ampm';
        });
        (0, $hXmfK.watch)(function() {
            return props.modelValue;
        }, function(val) {
            return setInputData(val);
        });
        (0, $bu8yf.onMounted)(function() {
            setInputData(props.modelValue);
        });
        function genValue() {
            if (inputHour.value != null && inputMinute.value != null && (!props.useSeconds || inputSecond.value != null)) return "".concat((0, $5c839c419f21c425$export$5d04458e2a6c373e)(inputHour.value), ":").concat((0, $5c839c419f21c425$export$5d04458e2a6c373e)(inputMinute.value)) + (props.useSeconds ? ":".concat((0, $5c839c419f21c425$export$5d04458e2a6c373e)(inputSecond.value)) : '');
            return null;
        }
        function emitValue() {
            var value = genValue();
            if (value !== null) emit('update:modelValue', value);
        }
        function convert24to12(hour) {
            return hour ? (hour - 1) % 12 + 1 : 12;
        }
        function convert12to24(hour, period) {
            return hour % 12 + (period === 'pm' ? 12 : 0);
        }
        function setInputData(value) {
            if (value == null || value === '') {
                inputHour.value = null;
                inputMinute.value = null;
                inputSecond.value = null;
            } else if (value instanceof Date) {
                inputHour.value = value.getHours();
                inputMinute.value = value.getMinutes();
                inputSecond.value = value.getSeconds();
            } else {
                var _$_ref = (0, $32TW8._)(value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6), 6), hour = _$_ref[0], minute = _$_ref[2], second = _$_ref[4], period1 = _$_ref[5];
                inputHour.value = period1 ? convert12to24(parseInt(hour, 10), period1) : parseInt(hour, 10);
                inputMinute.value = parseInt(minute, 10);
                inputSecond.value = parseInt(second || 0, 10);
            }
            period.value = inputHour.value == null || inputHour.value < 12 ? 'am' : 'pm';
        }
        function firstAllowed(type, value) {
            var allowedFn = type === 'hour' ? isAllowedHourCb.value : type === 'minute' ? isAllowedMinuteCb.value : isAllowedSecondCb.value;
            if (!allowedFn) return value;
            // TODO: clean up (Note from V2 code)
            var range = type === 'minute' ? $6798944a705a2f57$var$range60 : type === 'second' ? $6798944a705a2f57$var$range60 : isAmPm.value ? value < 12 ? $6798944a705a2f57$var$rangeHours12am : $6798944a705a2f57$var$rangeHours12pm : $6798944a705a2f57$var$rangeHours24;
            var first = range.find(function(v) {
                return allowedFn((v + value) % range.length + range[0]);
            });
            return ((first || 0) + value) % range.length + range[0];
        }
        function setPeriod(val) {
            period.value = val;
            if (inputHour.value != null) {
                var newHour = inputHour.value + (period.value === 'am' ? -12 : 12);
                inputHour.value = firstAllowed('hour', newHour);
            }
            emit('update:period', val);
            emitValue();
            return true;
        }
        function onInput(value) {
            if (viewMode.value === 'hour') inputHour.value = isAmPm.value ? convert12to24(value, period.value) : value;
            else if (viewMode.value === 'minute') inputMinute.value = value;
            else inputSecond.value = value;
        }
        function onChange(value) {
            switch(viewMode.value || 'hour'){
                case 'hour':
                    emit('update:hour', value);
                    break;
                case 'minute':
                    emit('update:minute', value);
                    break;
                case 'second':
                    emit('update:second', value);
                    break;
                default:
                    break;
            }
            var emitChange = inputHour.value !== null && inputMinute.value !== null && (props.useSeconds ? inputSecond.value !== null : true);
            if (viewMode.value === 'hour') viewMode.value = 'minute';
            else if (props.useSeconds && viewMode.value === 'minute') viewMode.value = 'second';
            if (inputHour.value === lazyInputHour.value && inputMinute.value === lazyInputMinute.value && (!props.useSeconds || inputSecond.value === lazyInputSecond.value)) return;
            var time = genValue();
            if (time === null) return;
            lazyInputHour.value = inputHour.value;
            lazyInputMinute.value = inputMinute.value;
            props.useSeconds && (lazyInputSecond.value = inputSecond.value);
            emitChange && emitValue();
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var pickerProps = (0, $3a810783e3364626$export$37f35d9b6bd5d714).filterProps(props);
            var timePickerControlsProps = (0, $c78fb2d667266b3c$export$bc5bd0b10348afb9).filterProps(props);
            var timePickerClockProps = (0, $0d9cdfa80043d000$export$c447be6017502228).filterProps((0, $31779689cfd5da50$export$30a06c8d3562193f)(props, [
                'format',
                'modelValue',
                'min',
                'max'
            ]));
            return (0, $bu8yf.createVNode)((0, $3a810783e3364626$export$37f35d9b6bd5d714), (0, $bu8yf.mergeProps)(pickerProps, {
                color: undefined,
                "class": [
                    'v-time-picker',
                    props["class"]
                ],
                style: props.style
            }), {
                title: function() {
                    var _slots_title;
                    var _slots_title1;
                    return (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $bu8yf.createElementVNode)("div", {
                        "class": "v-time-picker__title"
                    }, [
                        t(props.title)
                    ]);
                },
                header: function() {
                    return (0, $bu8yf.createVNode)((0, $c78fb2d667266b3c$export$bc5bd0b10348afb9), (0, $bu8yf.mergeProps)(timePickerControlsProps, {
                        ampm: isAmPm.value,
                        hour: inputHour.value,
                        minute: inputMinute.value,
                        period: period.value,
                        second: inputSecond.value,
                        viewMode: viewMode.value,
                        "onUpdate:period": function(val) {
                            return setPeriod(val);
                        },
                        "onUpdate:viewMode": function(value) {
                            return viewMode.value = value;
                        },
                        ref: controlsRef
                    }), null);
                },
                "default": function() {
                    return (0, $bu8yf.createVNode)((0, $0d9cdfa80043d000$export$c447be6017502228), (0, $bu8yf.mergeProps)(timePickerClockProps, {
                        allowedValues: viewMode.value === 'hour' ? isAllowedHourCb.value : viewMode.value === 'minute' ? isAllowedMinuteCb.value : isAllowedSecondCb.value,
                        double: viewMode.value === 'hour' && !isAmPm.value,
                        format: viewMode.value === 'hour' ? isAmPm.value ? convert24to12 : function(val) {
                            return val;
                        } : function(val) {
                            return (0, $5c839c419f21c425$export$5d04458e2a6c373e)(val, 2);
                        },
                        max: viewMode.value === 'hour' ? isAmPm.value && period.value === 'am' ? 11 : 23 : 59,
                        min: viewMode.value === 'hour' && isAmPm.value && period.value === 'pm' ? 12 : 0,
                        size: 20,
                        step: viewMode.value === 'hour' ? 1 : 5,
                        modelValue: viewMode.value === 'hour' ? inputHour.value : viewMode.value === 'minute' ? inputMinute.value : inputSecond.value,
                        onChange: onChange,
                        onInput: onInput,
                        ref: clockRef
                    }), null);
                },
                actions: slots.actions
            });
        });
    }
});






var $44bf76f7cb11abd4$exports = {};

$parcel$export($44bf76f7cb11abd4$exports, "VToolbar", function () { return $43b5cfb0203dfbd6$export$42c906c84e26a6d1; });
$parcel$export($44bf76f7cb11abd4$exports, "VToolbarTitle", function () { return $f849e9bc71871807$export$deaeca9428bfc9a4; });
$parcel$export($44bf76f7cb11abd4$exports, "VToolbarItems", function () { return $e3c6d030b4e0fb1c$export$b32291480cbbcf57; });



var $iT0je = parcelRequire("iT0je");
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");
var $hXmfK = parcelRequire("hXmfK");




var $e3c6d030b4e0fb1c$export$81931f5498198616 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $2b50544a76f0a26e$export$d271552babda0448)(), (0, $b8cfc08eef1ed28f$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VToolbarItems');
var $e3c6d030b4e0fb1c$export$b32291480cbbcf57 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VToolbarItems',
    props: $e3c6d030b4e0fb1c$export$81931f5498198616(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: (0, $hXmfK.toRef)(function() {
                    return props.color;
                }),
                height: 'inherit',
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _slots_default;
            return (0, $bu8yf.createElementVNode)("div", {
                "class": (0, $d8jBh.normalizeClass)([
                    'v-toolbar-items',
                    props["class"]
                ]),
                style: (0, $d8jBh.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $01ff8448a15d2520$exports = {};

$parcel$export($01ff8448a15d2520$exports, "VTooltip", function () { return $c9f649d49bf3ec7e$export$b742615555a86f54; });

var $iT0je = parcelRequire("iT0je");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");







var $c9f649d49bf3ec7e$export$9d9be12bfa458eb = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    id: String,
    interactive: Boolean,
    text: String
}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $7f198793a6132466$export$357b25d59a7fb3fa)({
    closeOnBack: false,
    location: 'end',
    locationStrategy: 'connected',
    eager: true,
    minWidth: 0,
    offset: 10,
    openOnClick: false,
    openOnHover: true,
    origin: 'auto',
    scrim: false,
    scrollStrategy: 'reposition',
    transition: null
}), [
    'absolute',
    'persistent'
])), 'VTooltip');
var $c9f649d49bf3ec7e$export$b742615555a86f54 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTooltip',
    props: $c9f649d49bf3ec7e$export$9d9be12bfa458eb(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isActive = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'modelValue');
        var scopeId = (0, $11b601c8e67368ec$export$eeabe5cda932100d)().scopeId;
        var uid = (0, $bu8yf.useId)();
        var id = (0, $hXmfK.toRef)(function() {
            return props.id || "v-tooltip-".concat(uid);
        });
        var overlay = (0, $hXmfK.ref)();
        var location = (0, $hXmfK.computed)(function() {
            return props.location.split(' ').length > 1 ? props.location : props.location + ' center';
        });
        var origin = (0, $hXmfK.computed)(function() {
            return props.origin === 'auto' || props.origin === 'overlap' || props.origin.split(' ').length > 1 || props.location.split(' ').length > 1 ? props.origin : props.origin + ' center';
        });
        var transition = (0, $hXmfK.toRef)(function() {
            if (props.transition != null) return props.transition;
            return isActive.value ? 'scale-transition' : 'fade-transition';
        });
        var activatorProps = (0, $hXmfK.computed)(function() {
            return (0, $bu8yf.mergeProps)({
                'aria-describedby': id.value
            }, props.activatorProps);
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var overlayProps = (0, $7f198793a6132466$export$32caf7e8170352aa).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $7f198793a6132466$export$32caf7e8170352aa), (0, $bu8yf.mergeProps)({
                ref: overlay,
                "class": [
                    'v-tooltip',
                    {
                        'v-tooltip--interactive': props.interactive
                    },
                    props["class"]
                ],
                style: props.style,
                id: id.value
            }, overlayProps, {
                modelValue: isActive.value,
                "onUpdate:modelValue": function($event) {
                    return isActive.value = $event;
                },
                transition: transition.value,
                absolute: true,
                location: location.value,
                origin: origin.value,
                persistent: true,
                role: "tooltip",
                activatorProps: activatorProps.value,
                _disableGlobalStack: true
            }, scopeId), {
                activator: slots.activator,
                "default": function _default() {
                    var _slots_default;
                    var _slots_default1;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _slots_default2;
                    return (_slots_default2 = (_slots_default1 = slots["default"]) === null || _slots_default1 === void 0 ? void 0 : (_slots_default = _slots_default1).call.apply(_slots_default, [
                        slots
                    ].concat((0, $7WNf6._)(args)))) !== null && _slots_default2 !== void 0 ? _slots_default2 : props.text;
                }
            });
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $395be6444c4b039d$exports = {};

$parcel$export($395be6444c4b039d$exports, "VTreeview", function () { return $3f87584c16bd9a7f$export$73d6d5b920b7a2b0; });
$parcel$export($395be6444c4b039d$exports, "VTreeviewItem", function () { return $4dbc13a163f21b04$export$bf6462de57644853; });
$parcel$export($395be6444c4b039d$exports, "VTreeviewGroup", function () { return $196c1acf0dcf8514$export$3a3ffd4c206e0c0c; });

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $b8tVf = parcelRequire("b8tVf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");

var $7WNf6 = parcelRequire("7WNf6");

var $9N5UN = parcelRequire("9N5UN");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");

var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");



var $196c1acf0dcf8514$export$b959bdd312d83ac6 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({}, (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $0891b6ffb0402c20$export$4ba1284b16a5c704)({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand'
}), [
    'subgroup'
])), 'VTreeviewGroup');
var $196c1acf0dcf8514$export$3a3ffd4c206e0c0c = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTreeviewGroup',
    props: $196c1acf0dcf8514$export$b959bdd312d83ac6(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var vListGroupRef = (0, $hXmfK.ref)();
        var toggleIcon = (0, $hXmfK.computed)(function() {
            var _vListGroupRef_value;
            return ((_vListGroupRef_value = vListGroupRef.value) === null || _vListGroupRef_value === void 0 ? void 0 : _vListGroupRef_value.isOpen) ? props.collapseIcon : props.expandIcon;
        });
        var activatorDefaults = (0, $hXmfK.computed)(function() {
            return {
                VTreeviewItem: {
                    prependIcon: undefined,
                    appendIcon: undefined,
                    toggleIcon: toggleIcon.value
                }
            };
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var listGroupProps = (0, $0891b6ffb0402c20$export$22fc03a43764dcc7).filterProps(props);
            return (0, $bu8yf.createVNode)((0, $0891b6ffb0402c20$export$22fc03a43764dcc7), (0, $bu8yf.mergeProps)(listGroupProps, {
                ref: vListGroupRef,
                "class": [
                    'v-treeview-group',
                    props["class"]
                ],
                subgroup: true
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                activator: slots.activator ? function(slotProps) {
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        (0, $bu8yf.createVNode)((0, $35431446b86815ea$export$ee4fab30a254e5ee), {
                            defaults: activatorDefaults.value
                        }, {
                            "default": function() {
                                var _slots_activator;
                                return [
                                    (_slots_activator = slots.activator) === null || _slots_activator === void 0 ? void 0 : _slots_activator.call(slots, slotProps)
                                ];
                            }
                        })
                    ]);
                } : undefined
            }));
        });
        return {};
    }
});



var $iT0je = parcelRequire("iT0je");

var $emQHU = parcelRequire("emQHU");
parcelRequire("4D2TE");
var $hXmfK = parcelRequire("hXmfK");
var $bu8yf = parcelRequire("bu8yf");
var $d8jBh = parcelRequire("d8jBh");








// Types
var $74fef754f043ceed$export$27ddf0c1fca754de = Symbol["for"]('vuetify:v-treeview');


var $4dbc13a163f21b04$export$9bf10ae5b7b202c = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    loading: Boolean,
    hideActions: Boolean,
    indentLines: Array,
    toggleIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f)
}, (0, $d199497309ad1f0e$export$b1024b817bbb948b)({
    slim: true
})), 'VTreeviewItem');
var $4dbc13a163f21b04$export$bf6462de57644853 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTreeviewItem',
    props: $4dbc13a163f21b04$export$9bf10ae5b7b202c(),
    emits: {
        toggleExpand: function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var visibleIds = (0, $bu8yf.inject)((0, $74fef754f043ceed$export$27ddf0c1fca754de), {
            visibleIds: (0, $hXmfK.ref)()
        }).visibleIds;
        var vListItemRef = (0, $hXmfK.ref)();
        var isActivatableGroupActivator = (0, $hXmfK.computed)(function() {
            var _vListItemRef_value, _vListItemRef_value1;
            return ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.root.activatable.value) && ((_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.isGroupActivator);
        });
        var vListItemRefIsClickable = (0, $hXmfK.computed)(function() {
            var _vListItemRef_value, _vListItemRef_value1;
            return ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.link.isClickable.value) || props.value != null && !!((_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.list);
        });
        var isClickable = (0, $hXmfK.computed)(function() {
            return !props.disabled && props.link !== false && (props.link || vListItemRefIsClickable.value || isActivatableGroupActivator.value);
        });
        var isFiltered = (0, $hXmfK.computed)(function() {
            var _vListItemRef_value;
            return visibleIds.value && !visibleIds.value.has((0, $hXmfK.toRaw)((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.id));
        });
        function activateGroupActivator(e) {
            var _vListItemRef_value, _vListItemRef_value1;
            if (isClickable.value && isActivatableGroupActivator.value) (_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.activate(!((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.isActivated), e);
        }
        function onClickAction(e) {
            e.preventDefault();
            e.stopPropagation();
            emit('toggleExpand', e);
        }
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var _vListItemRef_value;
            var listItemProps = (0, $d199497309ad1f0e$export$a6ee5a73ee56a146).filterProps(props);
            var hasPrepend = slots.prepend || props.toggleIcon || props.indentLines;
            return (0, $bu8yf.createVNode)((0, $d199497309ad1f0e$export$a6ee5a73ee56a146), (0, $bu8yf.mergeProps)({
                ref: vListItemRef
            }, listItemProps, {
                active: ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.isActivated) || undefined,
                "class": [
                    'v-treeview-item',
                    {
                        'v-treeview-item--activatable-group-activator': isActivatableGroupActivator.value,
                        'v-treeview-item--filtered': isFiltered.value
                    },
                    props["class"]
                ],
                ripple: false,
                onClick: activateGroupActivator
            }), (0, $emQHU._)((0, $iT0je._)({}, slots), {
                prepend: hasPrepend ? function(slotProps) {
                    var _slots_prepend;
                    return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                        props.indentLines && props.indentLines.length > 0 ? (0, $bu8yf.createElementVNode)("div", {
                            key: "indent-lines",
                            "class": "v-treeview-indent-lines",
                            style: {
                                '--v-indent-parts': props.indentLines.length
                            }
                        }, [
                            props.indentLines.map(function(type) {
                                return (0, $bu8yf.createElementVNode)("div", {
                                    "class": (0, $d8jBh.normalizeClass)("v-treeview-indent-line v-treeview-indent-line--".concat(type))
                                }, null);
                            })
                        ]) : '',
                        !props.hideActions && (0, $bu8yf.createVNode)((0, $316db8322d57c65f$export$104c1ead9d891c55), {
                            start: true
                        }, {
                            "default": function() {
                                return [
                                    props.toggleIcon ? (0, $bu8yf.createVNode)((0, $9603829334ed7471$export$657f28cf887b91a6), {
                                        density: "compact",
                                        icon: props.toggleIcon,
                                        loading: props.loading,
                                        variant: "text",
                                        onClick: onClickAction
                                    }, {
                                        loader: function() {
                                            return (0, $bu8yf.createVNode)((0, $14d6ceaaee1fb579$export$2b4afd8de42c0c21), {
                                                indeterminate: "disable-shrink",
                                                size: "20",
                                                width: "2"
                                            }, null);
                                        }
                                    }) : (0, $bu8yf.createElementVNode)("div", {
                                        "class": "v-treeview-item__level"
                                    }, null)
                                ];
                            }
                        }),
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined
            }));
        });
        return (0, $8a23d01bbdbffa09$export$e091cd9ead0744b3)({}, vListItemRef);
    }
});







// Types

var $7WNf6 = parcelRequire("7WNf6");
function $45b814843f4d27a1$export$af5f0b00e3736160(_ref) {
    var depth = _ref.depth, isLast = _ref.isLast, isLastGroup = _ref.isLastGroup, leafLinks = _ref.leafLinks, separateRoots = _ref.separateRoots, parentIndentLines = _ref.parentIndentLines, variant = _ref.variant;
    if (!parentIndentLines || !depth) return {
        leaf: undefined,
        node: undefined,
        children: parentIndentLines
    };
    if (variant === 'simple') return {
        leaf: (0, $7WNf6._)(parentIndentLines).concat([
            'line'
        ]),
        node: (0, $7WNf6._)(parentIndentLines).concat([
            'line'
        ]),
        children: (0, $7WNf6._)(parentIndentLines).concat([
            'line'
        ])
    };
    var isLastLeaf = isLast && (!isLastGroup || separateRoots || depth > 1);
    return {
        leaf: (0, $7WNf6._)(parentIndentLines).concat([
            isLastLeaf ? 'last-leaf' : 'leaf'
        ], (0, $7WNf6._)(leafLinks ? [
            'leaf-link'
        ] : [])),
        node: (0, $7WNf6._)(parentIndentLines).concat([
            isLastLeaf ? 'last-leaf' : 'leaf'
        ]),
        children: (0, $7WNf6._)(parentIndentLines).concat([
            isLastLeaf ? 'none' : 'line'
        ])
    };
}


var $b6ef8f08925dc10b$export$18e1f77dc95ddbb0 = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $iT0je._)({
    disabled: Boolean,
    loadChildren: Function,
    loadingIcon: {
        type: String,
        "default": '$loading'
    },
    items: Array,
    openOnClick: {
        type: Boolean,
        "default": undefined
    },
    indeterminateIcon: {
        type: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
        "default": '$checkboxIndeterminate'
    },
    falseIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    trueIcon: (0, $0192db7efcc99bb9$export$84527c6e3556c23f),
    returnObject: Boolean,
    activatable: Boolean,
    selectable: Boolean,
    selectedColor: String,
    selectStrategy: [
        String,
        Function,
        Object
    ],
    index: Number,
    isLastGroup: Boolean,
    separateRoots: Boolean,
    parentIndentLines: Array,
    indentLinesVariant: String,
    path: {
        type: Array,
        "default": function() {
            return [];
        }
    }
}, (0, $31779689cfd5da50$export$357523c63a2253b9)((0, $4dbc13a163f21b04$export$9bf10ae5b7b202c)(), [
    'hideActions'
]), (0, $ee636d54b7237d8b$export$aac8956235d563cb)()), 'VTreeviewChildren');
var $b6ef8f08925dc10b$export$be24f8dd9eaa5474 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTreeviewChildren',
    props: $b6ef8f08925dc10b$export$18e1f77dc95ddbb0(),
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var isLoading = (0, $hXmfK.reactive)(new Set());
        var activatorItems = (0, $hXmfK.ref)([]);
        var isClickOnOpen = (0, $hXmfK.computed)(function() {
            return !props.disabled && (props.openOnClick != null ? props.openOnClick : props.selectable && !props.activatable);
        });
        function checkChildren(item) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $b8tVf._)(function() {
                var _props_items, _item_children;
                return (0, $9N5UN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                ,
                                3,
                                4
                            ]);
                            if (!((_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.length) || !props.loadChildren) return [
                                2
                            ];
                            if (!((item === null || item === void 0 ? void 0 : (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.length) === 0)) return [
                                3,
                                2
                            ];
                            isLoading.add(item.value);
                            return [
                                4,
                                props.loadChildren(item.raw)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                3,
                                4
                            ];
                        case 3:
                            isLoading["delete"](item.value);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function selectItem(select, isSelected) {
            if (props.selectable) select(isSelected);
        }
        return function() {
            var _slots_default, _props_items;
            var _slots_default1;
            return (_slots_default1 = (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.map(function(item, index, items) {
                var _items_at, _props_path;
                var children = item.children, itemProps = item.props;
                var loading = isLoading.has(item.value);
                var nextItemHasChildren = !!((_items_at = items.at(index + 1)) === null || _items_at === void 0 ? void 0 : _items_at.children);
                var _props_path_length;
                var depth = (_props_path_length = (_props_path = props.path) === null || _props_path === void 0 ? void 0 : _props_path.length) !== null && _props_path_length !== void 0 ? _props_path_length : 0;
                var isLast = items.length - 1 === index;
                var treeItemProps = {
                    index: index,
                    depth: depth,
                    isFirst: index === 0,
                    isLast: isLast,
                    path: (0, $7WNf6._)(props.path).concat([
                        index
                    ]),
                    hideAction: props.hideActions
                };
                var indentLines = (0, $45b814843f4d27a1$export$af5f0b00e3736160)({
                    depth: depth,
                    isLast: isLast,
                    isLastGroup: props.isLastGroup,
                    leafLinks: !props.hideActions,
                    separateRoots: props.separateRoots,
                    parentIndentLines: props.parentIndentLines,
                    variant: props.indentLinesVariant
                });
                var slotsWithItem = {
                    prepend: function(slotProps) {
                        var _slots_prepend;
                        return (0, $bu8yf.createElementVNode)((0, $bu8yf.Fragment), null, [
                            props.selectable && (!children || children && ![
                                'leaf',
                                'single-leaf'
                            ].includes(props.selectStrategy)) && (0, $bu8yf.createElementVNode)("div", null, [
                                (0, $bu8yf.createVNode)((0, $941cc86b1aae9176$export$2c5503cb3c38fdb6), {
                                    key: item.value,
                                    modelValue: slotProps.isSelected,
                                    disabled: props.disabled,
                                    loading: loading,
                                    color: props.selectedColor,
                                    density: props.density,
                                    indeterminate: slotProps.isIndeterminate,
                                    indeterminateIcon: props.indeterminateIcon,
                                    falseIcon: props.falseIcon,
                                    trueIcon: props.trueIcon,
                                    "onUpdate:modelValue": function(v) {
                                        return selectItem(slotProps.select, v);
                                    },
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    onKeydown: function(e) {
                                        if (![
                                            'Enter',
                                            'Space'
                                        ].includes(e.key)) return;
                                        e.stopPropagation();
                                        selectItem(slotProps.select, slotProps.isSelected);
                                    }
                                }, null)
                            ]),
                            (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps, treeItemProps), {
                                item: item.raw,
                                internalItem: item
                            }))
                        ]);
                    },
                    append: slots.append ? function(slotProps) {
                        var _slots_append;
                        return (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps, treeItemProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined,
                    title: slots.title ? function(slotProps) {
                        var _slots_title;
                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined,
                    subtitle: slots.subtitle ? function(slotProps) {
                        var _slots_subtitle;
                        return (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, (0, $emQHU._)((0, $iT0je._)({}, slotProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined
                };
                var treeviewGroupProps = (0, $196c1acf0dcf8514$export$3a3ffd4c206e0c0c).filterProps(itemProps);
                var treeviewChildrenProps = $b6ef8f08925dc10b$export$be24f8dd9eaa5474.filterProps((0, $iT0je._)({}, props, treeItemProps));
                return children ? (0, $bu8yf.createVNode)((0, $196c1acf0dcf8514$export$3a3ffd4c206e0c0c), (0, $bu8yf.mergeProps)(treeviewGroupProps, {
                    value: props.returnObject ? item.raw : treeviewGroupProps === null || treeviewGroupProps === void 0 ? void 0 : treeviewGroupProps.value,
                    rawId: treeviewGroupProps === null || treeviewGroupProps === void 0 ? void 0 : treeviewGroupProps.value
                }), {
                    activator: function(_ref2) {
                        var activatorProps = _ref2.props;
                        var listItemProps = (0, $emQHU._)((0, $iT0je._)({}, itemProps, activatorProps), {
                            value: itemProps === null || itemProps === void 0 ? void 0 : itemProps.value,
                            onToggleExpand: [
                                function() {
                                    return checkChildren(item);
                                },
                                activatorProps.onClick
                            ],
                            onClick: isClickOnOpen.value ? [
                                function() {
                                    return checkChildren(item);
                                },
                                activatorProps.onClick
                            ] : function() {
                                var _activatorItems_value_index, _activatorItems_value_index1;
                                return selectItem((_activatorItems_value_index = activatorItems.value[index]) === null || _activatorItems_value_index === void 0 ? void 0 : _activatorItems_value_index.select, !((_activatorItems_value_index1 = activatorItems.value[index]) === null || _activatorItems_value_index1 === void 0 ? void 0 : _activatorItems_value_index1.isSelected));
                            }
                        });
                        return (0, $bu8yf.createVNode)((0, $4dbc13a163f21b04$export$bf6462de57644853), (0, $bu8yf.mergeProps)({
                            ref: function(el) {
                                return activatorItems.value[index] = el;
                            }
                        }, listItemProps, {
                            hideActions: props.hideActions,
                            indentLines: indentLines.node,
                            value: props.returnObject ? item.raw : itemProps.value,
                            loading: loading
                        }), slotsWithItem);
                    },
                    "default": function() {
                        return (0, $bu8yf.createVNode)($b6ef8f08925dc10b$export$be24f8dd9eaa5474, (0, $bu8yf.mergeProps)(treeviewChildrenProps, {
                            items: children,
                            indentLinesVariant: props.indentLinesVariant,
                            parentIndentLines: indentLines.children,
                            isLastGroup: nextItemHasChildren,
                            returnObject: props.returnObject
                        }), slots);
                    }
                }) : (0, $31779689cfd5da50$export$4abee4c34694ada1)(slots.item, {
                    props: itemProps,
                    item: item.raw,
                    internalItem: item
                }, function() {
                    if (item.type === 'divider') return (0, $31779689cfd5da50$export$4abee4c34694ada1)(slots.divider, {
                        props: item.raw
                    }, function() {
                        return (0, $bu8yf.createVNode)((0, $d0feee08e552461a$export$a2636a5d9a866ca1), item.props, null);
                    });
                    if (item.type === 'subheader') return (0, $31779689cfd5da50$export$4abee4c34694ada1)(slots.subheader, {
                        props: item.raw
                    }, function() {
                        return (0, $bu8yf.createVNode)((0, $c18be527f2406595$export$70c4aba7bf48e22a), item.props, null);
                    });
                    return (0, $bu8yf.createVNode)((0, $4dbc13a163f21b04$export$bf6462de57644853), (0, $bu8yf.mergeProps)(itemProps, {
                        hideActions: props.hideActions,
                        indentLines: indentLines.leaf,
                        value: props.returnObject ? (0, $hXmfK.toRaw)(item.raw) : itemProps.value
                    }), slotsWithItem);
                });
            });
        };
    }
});








function $3f87584c16bd9a7f$var$flatten(items) {
    var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            flat.push(item);
            if (item.children) $3f87584c16bd9a7f$var$flatten(item.children, flat);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return flat;
}
var $3f87584c16bd9a7f$export$ab81edf05d8984fc = (0, $0085e3529ef855a2$export$d5c63d7e6e58d2df)((0, $emQHU._)((0, $iT0je._)({
    fluid: Boolean,
    openAll: Boolean,
    indentLines: [
        Boolean,
        String
    ],
    search: String
}, (0, $d8173a2b878f034f$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $b6ef8f08925dc10b$export$18e1f77dc95ddbb0)(), [
    'index',
    'path',
    'indentLinesVariant',
    'parentIndentLines',
    'isLastGroup'
]), (0, $31779689cfd5da50$export$30a06c8d3562193f)((0, $c46d6e9c2ddd50d5$export$b385b2bc1ebed11d)({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand',
    slim: true
}), [
    'nav',
    'openStrategy'
])), {
    modelValue: Array
}), 'VTreeview');
var $3f87584c16bd9a7f$export$73d6d5b920b7a2b0 = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VTreeview',
    props: $3f87584c16bd9a7f$export$ab81edf05d8984fc(),
    emits: {
        'update:opened': function(val) {
            return true;
        },
        'update:activated': function(val) {
            return true;
        },
        'update:selected': function(val) {
            return true;
        },
        'update:modelValue': function(val) {
            return true;
        },
        'click:open': function(value) {
            return true;
        },
        'click:select': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots, emit = _ref.emit;
        var items = (0, $c46d6e9c2ddd50d5$export$d0ca4790a6d27133)(props).items;
        var activeColor = (0, $hXmfK.toRef)(function() {
            return props.activeColor;
        });
        var baseColor = (0, $hXmfK.toRef)(function() {
            return props.baseColor;
        });
        var color = (0, $hXmfK.toRef)(function() {
            return props.color;
        });
        var activated = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'activated');
        var _selected = (0, $26380e0ff495e5a4$export$6f3ae48335514a2)(props, 'selected');
        var selected = (0, $hXmfK.computed)({
            get: function() {
                var _props_modelValue;
                return (_props_modelValue = props.modelValue) !== null && _props_modelValue !== void 0 ? _props_modelValue : _selected.value;
            },
            set: function(val) {
                _selected.value = val;
                emit('update:modelValue', val);
            }
        });
        var vListRef = (0, $hXmfK.ref)();
        var opened = (0, $hXmfK.computed)(function() {
            return props.openAll ? openAll(items.value) : props.opened;
        });
        var flatItems = (0, $hXmfK.computed)(function() {
            return $3f87584c16bd9a7f$var$flatten(items.value);
        });
        var search = (0, $hXmfK.toRef)(function() {
            return props.search;
        });
        var filteredItems = (0, $d8173a2b878f034f$export$3274cf84b703fff)(props, flatItems, search).filteredItems;
        var visibleIds = (0, $hXmfK.computed)(function() {
            var _vListRef_value;
            if (!search.value) return null;
            var getPath = (_vListRef_value = vListRef.value) === null || _vListRef_value === void 0 ? void 0 : _vListRef_value.getPath;
            if (!getPath) return null;
            return new Set(filteredItems.value.flatMap(function(item) {
                var itemVal = props.returnObject ? item.raw : item.props.value;
                return (0, $7WNf6._)(getPath(itemVal)).concat((0, $7WNf6._)(getChildren(itemVal))).map((0, $hXmfK.toRaw));
            }));
        });
        function getChildren(id) {
            var _vListRef_value;
            var arr = [];
            var _vListRef_value_children_get;
            var queue = ((_vListRef_value_children_get = (_vListRef_value = vListRef.value) === null || _vListRef_value === void 0 ? void 0 : _vListRef_value.children.get(id)) !== null && _vListRef_value_children_get !== void 0 ? _vListRef_value_children_get : []).slice();
            while(queue.length){
                var _queue;
                var _vListRef_value1;
                var child = queue.shift();
                if (!child) continue;
                arr.push(child);
                var _vListRef_value_children_get1;
                (_queue = queue).push.apply(_queue, (0, $7WNf6._)(((_vListRef_value_children_get1 = (_vListRef_value1 = vListRef.value) === null || _vListRef_value1 === void 0 ? void 0 : _vListRef_value1.children.get(child)) !== null && _vListRef_value_children_get1 !== void 0 ? _vListRef_value_children_get1 : []).slice()));
            }
            return arr;
        }
        function openAll(items) {
            var ids = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (!i.children) continue;
                    ids.push(props.returnObject ? (0, $hXmfK.toRaw)(i.raw) : i.value);
                    if (i.children) ids = ids.concat(openAll(i.children));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return ids;
        }
        (0, $bu8yf.provide)((0, $74fef754f043ceed$export$27ddf0c1fca754de), {
            visibleIds: visibleIds
        });
        (0, $90060d7a7e173b81$export$31ed9bd1c7c3a7ee)({
            VTreeviewGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                collapseIcon: (0, $hXmfK.toRef)(function() {
                    return props.collapseIcon;
                }),
                expandIcon: (0, $hXmfK.toRef)(function() {
                    return props.expandIcon;
                })
            },
            VTreeviewItem: {
                activeClass: (0, $hXmfK.toRef)(function() {
                    return props.activeClass;
                }),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $hXmfK.toRef)(function() {
                    return props.density;
                }),
                disabled: (0, $hXmfK.toRef)(function() {
                    return props.disabled;
                }),
                lines: (0, $hXmfK.toRef)(function() {
                    return props.lines;
                }),
                variant: (0, $hXmfK.toRef)(function() {
                    return props.variant;
                })
            }
        });
        (0, $f6b888dae9ed8adc$export$e25bb1e5b53cbdff)(function() {
            var listProps = (0, $c46d6e9c2ddd50d5$export$3b010b0401837103).filterProps(props);
            var treeviewChildrenProps = (0, $b6ef8f08925dc10b$export$be24f8dd9eaa5474).filterProps(props);
            var indentLinesVariant = typeof props.indentLines === 'boolean' ? 'default' : props.indentLines;
            return (0, $bu8yf.createVNode)((0, $c46d6e9c2ddd50d5$export$3b010b0401837103), (0, $bu8yf.mergeProps)({
                ref: vListRef
            }, listProps, {
                "class": [
                    'v-treeview',
                    {
                        'v-treeview--fluid': props.fluid
                    },
                    props["class"]
                ],
                openStrategy: "multiple",
                style: props.style,
                opened: opened.value,
                activated: activated.value,
                "onUpdate:activated": function($event) {
                    return activated.value = $event;
                },
                selected: selected.value,
                "onUpdate:selected": function($event) {
                    return selected.value = $event;
                }
            }), {
                "default": function() {
                    return [
                        (0, $bu8yf.createVNode)((0, $b6ef8f08925dc10b$export$be24f8dd9eaa5474), (0, $bu8yf.mergeProps)(treeviewChildrenProps, {
                            density: props.density,
                            returnObject: props.returnObject,
                            items: items.value,
                            parentIndentLines: props.indentLines ? [] : undefined,
                            indentLinesVariant: indentLinesVariant
                        }), slots)
                    ];
                }
            });
        });
        return {};
    }
});






var $cff157edd079ca39$exports = {};

$parcel$export($cff157edd079ca39$exports, "VValidation", function () { return $9ab943bceb0b9cbc$export$5c8bcd85283afcdb; });
// Composables


var $9ab943bceb0b9cbc$export$5c8bcd85283afcdb = (0, $87e73a4a4b645892$export$6925fd0bc332cf90)()({
    name: 'VValidation',
    props: (0, $dfc9eccea4b997fa$export$42513dbc731a0133)(),
    emits: {
        'update:modelValue': function(value) {
            return true;
        }
    },
    setup: function(props, _ref) {
        var slots = _ref.slots;
        var validation = (0, $dfc9eccea4b997fa$export$87fe492f99f25a20)(props, 'validation');
        return function() {
            var _slots_default;
            return (_slots_default = slots["default"]) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, validation);
        };
    }
});




var $13fca4e5a91e4403$exports = {};

$parcel$export($13fca4e5a91e4403$exports, "VVirtualScroll", function () { return $af9026073940257e$export$bdb136bf2d9028a4; });



var $526f4caab75d212b$exports = {};

$parcel$export($526f4caab75d212b$exports, "VWindow", function () { return $ca166420585d5fdc$export$7e91eb8d1b90c043; });
$parcel$export($526f4caab75d212b$exports, "VWindowItem", function () { return $a77d8a325be2a9b0$export$5dd5457a16e4a360; });





$parcel$exportWildcard($fca2e0606619333d$exports, $5ab959b8b067cf4d$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5633c39a49672970$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $2397b8a0edf5de7c$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $15eb18a00c80d90b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $4979eba49805c59b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $52328ff2d011bc50$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $897a5bcd8d4e6bbb$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $65d444ec53767f82$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $24af973892f628d7$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $bf238f83c5b6cf03$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $aab197eaf2a6c67b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5539fa895c9b1aa3$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $e52980d23d8008dd$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $e9af1a32ff162c08$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $74bbacfd6d54dd3f$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $070025c56dc7037c$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $880223cb91e739eb$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $615c69d94f608698$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $68fe56eaeb99581b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5846c2b0b14fb289$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $2b9dfb6933d988f2$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $1abf0f082d2e9484$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $b28fb13f89d3a894$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5ad6a7c2a950f11b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $3c66f34f873743e2$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $bf27d80d3edc10c5$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $6559b8d559736b2f$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $d94b64461538f47b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5cd0b1f7302d0bce$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $bc75dea749d815a9$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $0f31d19c1eb87c95$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $1a2325ac52b4d6de$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $f1d25c1d218def35$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $95bb0bb2e9e14fb7$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $8cb46c34ab58368d$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $08b68dee11ca8414$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $c47abed99c7fd2f4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a7e87b08ee67b648$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $2b3e62a8aaaabcd4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $ac5e441f605ada63$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $637ef65ffa7ad03e$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5106b18c26887834$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $b971736ba8a9c96f$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $478135536c184ba6$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $9aebf6f2c8aaaf21$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a0ee75f2450db1e6$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $932d297d8c7d7f97$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $df4efdafa4371dc4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $0c44c2b48b010bad$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a96bc83444910006$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $c27b5636a9887bef$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $cfa90ba7b3395c79$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $8e4bb1cc17526ac1$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $9cd63ced416bf39a$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a43186ffeb8da401$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $efcda17f911672f2$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $966e66413e6dddde$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $86d48e80f73def8a$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $f7a2cbcc46ca1358$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $55efc23bda63e278$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $8537d5d8462e89b3$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $7d2143e48a2d2067$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $c4ab3333c88f7ee8$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $53da77218b5094f6$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a79832ef456375cf$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $aa91406c052632b6$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $81d3c870af63624e$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $c3f4092ae6f61bf8$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5bf7b41bf443cd0c$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $6b5815f6a7e73c77$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $cd0be4296b275334$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $9335df2622b8d1c6$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $6c2d64bbf702b912$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a0372d73f892851a$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $de6346e06ec65e85$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $2efe7c044a99683b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $4ec93c151280d61d$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $b659131c729c525e$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $170adca7bd0cd074$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $1b0b677fdef4c52e$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $a961a9be53247ab4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $00ce4277fa188058$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $5e91b3922d898731$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $ef4aea61c38f9c82$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $4d1f0a55c2134152$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $f130f0376ac60da4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $49bcfb59db4eba0d$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $44bf76f7cb11abd4$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $01ff8448a15d2520$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $395be6444c4b039d$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $cff157edd079ca39$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $13fca4e5a91e4403$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $526f4caab75d212b$exports);
$parcel$exportWildcard($fca2e0606619333d$exports, $01a421c271ad0485$exports);


var $2f535a67e607f556$exports = {};

$parcel$export($2f535a67e607f556$exports, "ClickOutside", function () { return $022086ec11d4df23$export$c16e4f034c84cb3f; });
$parcel$export($2f535a67e607f556$exports, "Intersect", function () { return $f77d117b08c9abf5$export$56a6b724e0c8deeb; });
$parcel$export($2f535a67e607f556$exports, "Mutate", function () { return $c93e106a544117a4$export$4a51a50f9614fc39; });
$parcel$export($2f535a67e607f556$exports, "Resize", function () { return $e281fbe189631d7a$export$76856258f71db1ea; });
$parcel$export($2f535a67e607f556$exports, "Ripple", function () { return $df056000f2fe99f7$export$9e9146f7e027fdaa; });
$parcel$export($2f535a67e607f556$exports, "Scroll", function () { return $ad16d3aaf582ffe4$export$6ed4a4084f55ee7c; });
$parcel$export($2f535a67e607f556$exports, "Touch", function () { return $8a7faef3eb477187$export$746b04bbf92762fd; });
$parcel$export($2f535a67e607f556$exports, "Tooltip", function () { return $7a321bfb5dc7bd08$export$28c660c63b792dea; });


// Types

var $g79Gh = parcelRequire("g79Gh");

var $3KZcf = parcelRequire("3KZcf");
function $c93e106a544117a4$var$mounted(el, binding) {
    var modifiers = binding.modifiers || {};
    var value = binding.value;
    var once = modifiers.once, immediate = modifiers.immediate, modifierKeys = (0, $g79Gh._)(modifiers, [
        "once",
        "immediate"
    ]);
    var defaultValue = !Object.keys(modifierKeys).length;
    var _modifierKeys_attr, _modifierKeys_char, _modifierKeys_child, _modifierKeys_sub;
    var _ref = (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' ? value : {
        handler: value,
        options: {
            attributes: (_modifierKeys_attr = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.attr) !== null && _modifierKeys_attr !== void 0 ? _modifierKeys_attr : defaultValue,
            characterData: (_modifierKeys_char = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys["char"]) !== null && _modifierKeys_char !== void 0 ? _modifierKeys_char : defaultValue,
            childList: (_modifierKeys_child = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.child) !== null && _modifierKeys_child !== void 0 ? _modifierKeys_child : defaultValue,
            subtree: (_modifierKeys_sub = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.sub) !== null && _modifierKeys_sub !== void 0 ? _modifierKeys_sub : defaultValue
        }
    }, handler = _ref.handler, options = _ref.options;
    var observer = new MutationObserver(function() {
        var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var observer = arguments.length > 1 ? arguments[1] : undefined;
        handler === null || handler === void 0 ? void 0 : handler(mutations, observer);
        if (once) $c93e106a544117a4$var$unmounted(el, binding);
    });
    if (immediate) handler === null || handler === void 0 ? void 0 : handler([], observer);
    el._mutate = Object(el._mutate);
    el._mutate[binding.instance.$.uid] = {
        observer: observer
    };
    observer.observe(el, options);
}
function $c93e106a544117a4$var$unmounted(el, binding) {
    var _el__mutate;
    if (!((_el__mutate = el._mutate) === null || _el__mutate === void 0 ? void 0 : _el__mutate[binding.instance.$.uid])) return;
    el._mutate[binding.instance.$.uid].observer.disconnect();
    delete el._mutate[binding.instance.$.uid];
}
var $c93e106a544117a4$export$4a51a50f9614fc39 = {
    mounted: $c93e106a544117a4$var$mounted,
    unmounted: $c93e106a544117a4$var$unmounted
};
var $c93e106a544117a4$export$2e2bcd8739ae039 = $c93e106a544117a4$export$4a51a50f9614fc39;


// Types
function $e281fbe189631d7a$var$mounted(el, binding) {
    var _binding_modifiers, _binding_modifiers1;
    var handler = binding.value;
    var options = {
        passive: !((_binding_modifiers = binding.modifiers) === null || _binding_modifiers === void 0 ? void 0 : _binding_modifiers.active)
    };
    window.addEventListener('resize', handler, options);
    el._onResize = Object(el._onResize);
    el._onResize[binding.instance.$.uid] = {
        handler: handler,
        options: options
    };
    if (!((_binding_modifiers1 = binding.modifiers) === null || _binding_modifiers1 === void 0 ? void 0 : _binding_modifiers1.quiet)) handler();
}
function $e281fbe189631d7a$var$unmounted(el, binding) {
    var _el__onResize;
    if (!((_el__onResize = el._onResize) === null || _el__onResize === void 0 ? void 0 : _el__onResize[binding.instance.$.uid])) return;
    var _el__onResize_binding_instance_$_uid = el._onResize[binding.instance.$.uid], handler = _el__onResize_binding_instance_$_uid.handler, options = _el__onResize_binding_instance_$_uid.options;
    window.removeEventListener('resize', handler, options);
    delete el._onResize[binding.instance.$.uid];
}
var $e281fbe189631d7a$export$76856258f71db1ea = {
    mounted: $e281fbe189631d7a$var$mounted,
    unmounted: $e281fbe189631d7a$var$unmounted
};
var $e281fbe189631d7a$export$2e2bcd8739ae039 = $e281fbe189631d7a$export$76856258f71db1ea;



// Types

var $3KZcf = parcelRequire("3KZcf");
function $ad16d3aaf582ffe4$var$mounted(el, binding) {
    var _binding_modifiers;
    var _ref = (_binding_modifiers = binding.modifiers) !== null && _binding_modifiers !== void 0 ? _binding_modifiers : {}, _ref_self = _ref.self, self = _ref_self === void 0 ? false : _ref_self;
    var value = binding.value;
    var options = (typeof value === "undefined" ? "undefined" : (0, $3KZcf._)(value)) === 'object' && value.options || {
        passive: true
    };
    var handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
    var target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
    if (!target) return;
    target.addEventListener('scroll', handler, options);
    el._onScroll = Object(el._onScroll);
    el._onScroll[binding.instance.$.uid] = {
        handler: handler,
        options: options,
        // Don't reference self
        target: self ? undefined : target
    };
}
function $ad16d3aaf582ffe4$var$unmounted(el, binding) {
    var _el__onScroll;
    if (!((_el__onScroll = el._onScroll) === null || _el__onScroll === void 0 ? void 0 : _el__onScroll[binding.instance.$.uid])) return;
    var _el__onScroll_binding_instance_$_uid = el._onScroll[binding.instance.$.uid], handler = _el__onScroll_binding_instance_$_uid.handler, options = _el__onScroll_binding_instance_$_uid.options, _el__onScroll_binding_instance_$_uid_target = _el__onScroll_binding_instance_$_uid.target, target = _el__onScroll_binding_instance_$_uid_target === void 0 ? el : _el__onScroll_binding_instance_$_uid_target;
    target.removeEventListener('scroll', handler, options);
    delete el._onScroll[binding.instance.$.uid];
}
function $ad16d3aaf582ffe4$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    $ad16d3aaf582ffe4$var$unmounted(el, binding);
    $ad16d3aaf582ffe4$var$mounted(el, binding);
}
var $ad16d3aaf582ffe4$export$6ed4a4084f55ee7c = {
    mounted: $ad16d3aaf582ffe4$var$mounted,
    unmounted: $ad16d3aaf582ffe4$var$unmounted,
    updated: $ad16d3aaf582ffe4$var$updated
};
var $ad16d3aaf582ffe4$export$2e2bcd8739ae039 = $ad16d3aaf582ffe4$export$6ed4a4084f55ee7c;



// Components

// Utilities
parcelRequire("4D2TE");
var $bu8yf = parcelRequire("bu8yf");
var $kiZwI = parcelRequire("kiZwI");

function $9f380e4820541dd8$export$90e2dd3d6933cb6c(component, props) {
    var concreteComponent = typeof component === 'string' ? (0, $bu8yf.resolveComponent)(component) : component;
    var hook = $9f380e4820541dd8$var$mountComponent(concreteComponent, props);
    return {
        mounted: hook,
        updated: hook,
        unmounted: function(el) {
            (0, $kiZwI.render)(null, el);
        }
    };
}
function $9f380e4820541dd8$var$mountComponent(component, props) {
    return function(el, binding, vnode) {
        var _binding_value, _findComponentParent, _vnode_ctx;
        var _props = typeof props === 'function' ? props(binding) : props;
        var _binding_value_text, _ref;
        var text = (_ref = (_binding_value_text = (_binding_value = binding.value) === null || _binding_value === void 0 ? void 0 : _binding_value.text) !== null && _binding_value_text !== void 0 ? _binding_value_text : binding.value) !== null && _ref !== void 0 ? _ref : _props === null || _props === void 0 ? void 0 : _props.text;
        var value = (0, $31779689cfd5da50$export$a6cdc56e425d0d0a)(binding.value) ? binding.value : {};
        // Get the children from the props or directive value, or the element's children
        var children = function() {
            return text !== null && text !== void 0 ? text : el.textContent;
        };
        var _ref1;
        // If vnode.ctx is the same as the instance, then we're bound to a plain element
        // and need to find the nearest parent component instance to inherit provides from
        var provides = (_ref1 = vnode.ctx === binding.instance.$ ? (_findComponentParent = $9f380e4820541dd8$var$findComponentParent(vnode, binding.instance.$)) === null || _findComponentParent === void 0 ? void 0 : _findComponentParent.provides : (_vnode_ctx = vnode.ctx) === null || _vnode_ctx === void 0 ? void 0 : _vnode_ctx.provides) !== null && _ref1 !== void 0 ? _ref1 : binding.instance.$.provides;
        var node = (0, $bu8yf.h)(component, (0, $bu8yf.mergeProps)(_props, value), children);
        node.appContext = Object.assign(Object.create(null), binding.instance.$.appContext, {
            provides: provides
        });
        (0, $kiZwI.render)(node, el);
    };
}
function $9f380e4820541dd8$var$findComponentParent(vnode, root) {
    // Walk the tree from root until we find the child vnode
    var stack = new Set();
    var walk = function(children) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                var _child_component, _child_component1;
                if (!child) continue;
                if (child === vnode || child.el && vnode.el && child.el === vnode.el) return true;
                stack.add(child);
                var result = void 0;
                if (child.suspense) result = walk([
                    child.ssContent
                ]);
                else if (Array.isArray(child.children)) result = walk(child.children);
                else if ((_child_component = child.component) === null || _child_component === void 0 ? void 0 : _child_component.vnode) result = walk([
                    (_child_component1 = child.component) === null || _child_component1 === void 0 ? void 0 : _child_component1.subTree
                ]);
                if (result) return result;
                stack["delete"](child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    if (!walk([
        root.subTree
    ])) {
        (0, $b0e141e3fccca32c$export$bf36f23bad3e1069)('Could not find original vnode, component will not inherit provides');
        return root;
    }
    // Return the first component parent
    var result = Array.from(stack).reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = result[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if (child.component) return child.component;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return root;
}


var $7a321bfb5dc7bd08$export$28c660c63b792dea = (0, $9f380e4820541dd8$export$90e2dd3d6933cb6c)((0, $c9f649d49bf3ec7e$export$b742615555a86f54), function(binding) {
    var _binding_arg;
    return {
        activator: 'parent',
        location: (_binding_arg = binding.arg) === null || _binding_arg === void 0 ? void 0 : _binding_arg.replace('-', ' '),
        text: typeof binding.value === 'boolean' ? undefined : binding.value
    };
});
var $7a321bfb5dc7bd08$export$2e2bcd8739ae039 = $7a321bfb5dc7bd08$export$28c660c63b792dea;




var $2a797541eeb9b767$var$script;




var $2a797541eeb9b767$var$initialize = function() {
    $2a797541eeb9b767$var$script = (parcelRequire("5Op9f"));
    if ($2a797541eeb9b767$var$script.__esModule) $2a797541eeb9b767$var$script = $2a797541eeb9b767$var$script["default"];
    $2a797541eeb9b767$var$script.render = (parcelRequire("g1RiW")).render;
    $2a797541eeb9b767$var$script.__cssModules = {};
    (parcelRequire("20gUI")).default($2a797541eeb9b767$var$script);
    $2a797541eeb9b767$var$script.__scopeId = 'data-v-61d198';
    $2a797541eeb9b767$var$script.__file = "App.vue";
};
$2a797541eeb9b767$var$initialize();
var $2a797541eeb9b767$export$2e2bcd8739ae039 = $2a797541eeb9b767$var$script;


var $da9f7df3429c1e74$var$vuetify = (0, $26ea8d1be9e46d91$export$ef34132de12b844b)({
    components: (0, $iT0je._)({}, $fca2e0606619333d$exports),
    directives: (0, $iT0je._)({}, $2f535a67e607f556$exports),
    theme: {
        defaultTheme: 'dark',
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#1976D2',
                    secondary: '#424242',
                    accent: '#82B1FF',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            },
            dark: {
                dark: true,
                colors: {
                    primary: '#2196F3',
                    secondary: '#424242',
                    accent: '#FF4081',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            }
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases: (0, $298432464b906a1d$export$9af93bb9e9126a2),
        sets: {
            mdi: (0, $298432464b906a1d$export$179238ba74376e8c)
        }
    }
});
var $da9f7df3429c1e74$var$app = (0, $kiZwI.createApp)((0, $2a797541eeb9b767$export$2e2bcd8739ae039));
$da9f7df3429c1e74$var$app.use($da9f7df3429c1e74$var$vuetify);
$da9f7df3429c1e74$var$app.mount(document.body);

})();
//# sourceMappingURL=Data.319945a9.js.map
